(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || dest.hasOwnProperty(key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree24f"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree24f"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("b4Ec1", function(module, exports) {

$parcel$export(module.exports, "isNodeEnv", function () { return isNodeEnv; });

var $9QYoO = parcelRequire("9QYoO");

var $3uujh = parcelRequire("3uujh");
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ /**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */ function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, $9QYoO.isBrowserBundle)() && Object.prototype.toString.call(typeof $3uujh !== "undefined" ? $3uujh : 0) === "[object process]";
}
/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
/**
 * Helper for dynamically loading module that should work with linked dependencies.
 * The problem is that we _should_ be using `require(require.resolve(moduleName, { paths: [cwd()] }))`
 * However it's _not possible_ to do that with Webpack, as it has to know all the dependencies during
 * build time. `require.resolve` is also not available in any other way, so we cannot create,
 * a fake helper like we do with `dynamicRequire`.
 *
 * We always prefer to use local package, thus the value is not returned early from each `try/catch` block.
 * That is to mimic the behavior of `require.resolve` exactly.
 *
 * @param moduleName module name to require
 * @param existingModule module to use for requiring
 * @returns possibly required module
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function loadModule(moduleName, existingModule = module) {
    let mod;
    try {
        mod = dynamicRequire(existingModule, moduleName);
    } catch (e) {
    // no-empty
    }
    if (!mod) try {
        const { cwd } = dynamicRequire(existingModule, "process");
        mod = dynamicRequire(existingModule, `${cwd()}/node_modules/${moduleName}`);
    } catch (e) {
    // no-empty
    }
    return mod;
}

});
parcelRegister("9QYoO", function(module, exports) {

$parcel$export(module.exports, "isBrowserBundle", function () { return $72c7d267c96801bc$export$2928c40372e623c0; });
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $72c7d267c96801bc$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== "undefined" && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function $72c7d267c96801bc$export$8ad33f488b1ab046() {
    // This comment is used to identify this line in the CDN bundle build step and replace this with "return 'cdn';"
    /* __SENTRY_SDK_SOURCE__ */ return "npm";
}

});

parcelRegister("3uujh", function(module, exports) {
// shim for using process in browser
var $28abaf5bfc067bf4$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $28abaf5bfc067bf4$var$cachedSetTimeout;
var $28abaf5bfc067bf4$var$cachedClearTimeout;
function $28abaf5bfc067bf4$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $28abaf5bfc067bf4$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $28abaf5bfc067bf4$var$cachedSetTimeout = setTimeout;
        else $28abaf5bfc067bf4$var$cachedSetTimeout = $28abaf5bfc067bf4$var$defaultSetTimout;
    } catch (e) {
        $28abaf5bfc067bf4$var$cachedSetTimeout = $28abaf5bfc067bf4$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $28abaf5bfc067bf4$var$cachedClearTimeout = clearTimeout;
        else $28abaf5bfc067bf4$var$cachedClearTimeout = $28abaf5bfc067bf4$var$defaultClearTimeout;
    } catch (e) {
        $28abaf5bfc067bf4$var$cachedClearTimeout = $28abaf5bfc067bf4$var$defaultClearTimeout;
    }
})();
function $28abaf5bfc067bf4$var$runTimeout(fun) {
    if ($28abaf5bfc067bf4$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($28abaf5bfc067bf4$var$cachedSetTimeout === $28abaf5bfc067bf4$var$defaultSetTimout || !$28abaf5bfc067bf4$var$cachedSetTimeout) && setTimeout) {
        $28abaf5bfc067bf4$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $28abaf5bfc067bf4$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $28abaf5bfc067bf4$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $28abaf5bfc067bf4$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $28abaf5bfc067bf4$var$runClearTimeout(marker) {
    if ($28abaf5bfc067bf4$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($28abaf5bfc067bf4$var$cachedClearTimeout === $28abaf5bfc067bf4$var$defaultClearTimeout || !$28abaf5bfc067bf4$var$cachedClearTimeout) && clearTimeout) {
        $28abaf5bfc067bf4$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $28abaf5bfc067bf4$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $28abaf5bfc067bf4$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $28abaf5bfc067bf4$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $28abaf5bfc067bf4$var$queue = [];
var $28abaf5bfc067bf4$var$draining = false;
var $28abaf5bfc067bf4$var$currentQueue;
var $28abaf5bfc067bf4$var$queueIndex = -1;
function $28abaf5bfc067bf4$var$cleanUpNextTick() {
    if (!$28abaf5bfc067bf4$var$draining || !$28abaf5bfc067bf4$var$currentQueue) return;
    $28abaf5bfc067bf4$var$draining = false;
    if ($28abaf5bfc067bf4$var$currentQueue.length) $28abaf5bfc067bf4$var$queue = $28abaf5bfc067bf4$var$currentQueue.concat($28abaf5bfc067bf4$var$queue);
    else $28abaf5bfc067bf4$var$queueIndex = -1;
    if ($28abaf5bfc067bf4$var$queue.length) $28abaf5bfc067bf4$var$drainQueue();
}
function $28abaf5bfc067bf4$var$drainQueue() {
    if ($28abaf5bfc067bf4$var$draining) return;
    var timeout = $28abaf5bfc067bf4$var$runTimeout($28abaf5bfc067bf4$var$cleanUpNextTick);
    $28abaf5bfc067bf4$var$draining = true;
    var len = $28abaf5bfc067bf4$var$queue.length;
    while(len){
        $28abaf5bfc067bf4$var$currentQueue = $28abaf5bfc067bf4$var$queue;
        $28abaf5bfc067bf4$var$queue = [];
        while(++$28abaf5bfc067bf4$var$queueIndex < len)if ($28abaf5bfc067bf4$var$currentQueue) $28abaf5bfc067bf4$var$currentQueue[$28abaf5bfc067bf4$var$queueIndex].run();
        $28abaf5bfc067bf4$var$queueIndex = -1;
        len = $28abaf5bfc067bf4$var$queue.length;
    }
    $28abaf5bfc067bf4$var$currentQueue = null;
    $28abaf5bfc067bf4$var$draining = false;
    $28abaf5bfc067bf4$var$runClearTimeout(timeout);
}
$28abaf5bfc067bf4$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $28abaf5bfc067bf4$var$queue.push(new $28abaf5bfc067bf4$var$Item(fun, args));
    if ($28abaf5bfc067bf4$var$queue.length === 1 && !$28abaf5bfc067bf4$var$draining) $28abaf5bfc067bf4$var$runTimeout($28abaf5bfc067bf4$var$drainQueue);
};
// v8 likes predictible objects
function $28abaf5bfc067bf4$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$28abaf5bfc067bf4$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$28abaf5bfc067bf4$var$process.title = "browser";
$28abaf5bfc067bf4$var$process.browser = true;
$28abaf5bfc067bf4$var$process.env = {};
$28abaf5bfc067bf4$var$process.argv = [];
$28abaf5bfc067bf4$var$process.version = ""; // empty string to avoid regexp issues
$28abaf5bfc067bf4$var$process.versions = {};
function $28abaf5bfc067bf4$var$noop() {}
$28abaf5bfc067bf4$var$process.on = $28abaf5bfc067bf4$var$noop;
$28abaf5bfc067bf4$var$process.addListener = $28abaf5bfc067bf4$var$noop;
$28abaf5bfc067bf4$var$process.once = $28abaf5bfc067bf4$var$noop;
$28abaf5bfc067bf4$var$process.off = $28abaf5bfc067bf4$var$noop;
$28abaf5bfc067bf4$var$process.removeListener = $28abaf5bfc067bf4$var$noop;
$28abaf5bfc067bf4$var$process.removeAllListeners = $28abaf5bfc067bf4$var$noop;
$28abaf5bfc067bf4$var$process.emit = $28abaf5bfc067bf4$var$noop;
$28abaf5bfc067bf4$var$process.prependListener = $28abaf5bfc067bf4$var$noop;
$28abaf5bfc067bf4$var$process.prependOnceListener = $28abaf5bfc067bf4$var$noop;
$28abaf5bfc067bf4$var$process.listeners = function(name) {
    return [];
};
$28abaf5bfc067bf4$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$28abaf5bfc067bf4$var$process.cwd = function() {
    return "/";
};
$28abaf5bfc067bf4$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$28abaf5bfc067bf4$var$process.umask = function() {
    return 0;
};

});


parcelRegister("kxQjj", function(module, exports) {

$parcel$export(module.exports, "isNodeEnv", function () { return isNodeEnv; });

var $jEQuq = parcelRequire("jEQuq");

var $3uujh = parcelRequire("3uujh");
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ /**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */ function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, $jEQuq.isBrowserBundle)() && Object.prototype.toString.call(typeof $3uujh !== "undefined" ? $3uujh : 0) === "[object process]";
}
/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
/**
 * Helper for dynamically loading module that should work with linked dependencies.
 * The problem is that we _should_ be using `require(require.resolve(moduleName, { paths: [cwd()] }))`
 * However it's _not possible_ to do that with Webpack, as it has to know all the dependencies during
 * build time. `require.resolve` is also not available in any other way, so we cannot create,
 * a fake helper like we do with `dynamicRequire`.
 *
 * We always prefer to use local package, thus the value is not returned early from each `try/catch` block.
 * That is to mimic the behavior of `require.resolve` exactly.
 *
 * @param moduleName module name to require
 * @param existingModule module to use for requiring
 * @returns possibly required module
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function loadModule(moduleName, existingModule = module) {
    let mod;
    try {
        mod = dynamicRequire(existingModule, moduleName);
    } catch (e) {
    // no-empty
    }
    if (!mod) try {
        const { cwd } = dynamicRequire(existingModule, "process");
        mod = dynamicRequire(existingModule, `${cwd()}/node_modules/${moduleName}`);
    } catch (e) {
    // no-empty
    }
    return mod;
}

});
parcelRegister("jEQuq", function(module, exports) {

$parcel$export(module.exports, "isBrowserBundle", function () { return $e4fa7819a6b78f8f$export$2928c40372e623c0; });
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $e4fa7819a6b78f8f$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== "undefined" && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function $e4fa7819a6b78f8f$export$8ad33f488b1ab046() {
    // This comment is used to identify this line in the CDN bundle build step and replace this with "return 'cdn';"
    /* __SENTRY_SDK_SOURCE__ */ return "npm";
}

});


parcelRegister("czKc9", function(module, exports) {

$parcel$export(module.exports, "addExtensionMethods", function () { return addExtensionMethods; });

var $fBYWi = parcelRequire("fBYWi");
var $l4UCE = parcelRequire("l4UCE");

var $4C0Qe = parcelRequire("4C0Qe");
/**
 * @private
 */ function _autoloadDatabaseIntegrations() {
    const carrier = (0, $l4UCE.getMainCarrier)();
    if (!carrier.__SENTRY__) return;
    const packageToIntegrationMapping = {
        mongodb () {
            const integration = (0, $4C0Qe.dynamicRequire)(module, "./node/integrations/mongo");
            return new integration.Mongo();
        },
        mongoose () {
            const integration = (0, $4C0Qe.dynamicRequire)(module, "./node/integrations/mongo");
            return new integration.Mongo();
        },
        mysql () {
            const integration = (0, $4C0Qe.dynamicRequire)(module, "./node/integrations/mysql");
            return new integration.Mysql();
        },
        pg () {
            const integration = (0, $4C0Qe.dynamicRequire)(module, "./node/integrations/postgres");
            return new integration.Postgres();
        }
    };
    const mappedPackages = Object.keys(packageToIntegrationMapping).filter((moduleName)=>!!(0, $4C0Qe.loadModule)(moduleName)).map((pkg)=>{
        try {
            return packageToIntegrationMapping[pkg]();
        } catch (e) {
            return undefined;
        }
    }).filter((p)=>p);
    if (mappedPackages.length > 0) carrier.__SENTRY__.integrations = [
        ...carrier.__SENTRY__.integrations || [],
        ...mappedPackages
    ];
}
/**
 * This patches the global object and injects the Tracing extensions methods
 */ function addExtensionMethods() {
    (0, $fBYWi.addTracingExtensions)();
    // Detect and automatically load specified integrations.
    if ((0, $4C0Qe.isNodeEnv)()) _autoloadDatabaseIntegrations();
}

});
parcelRegister("fBYWi", function(module, exports) {

$parcel$export(module.exports, "startIdleTransaction", function () { return $b5d994f5ea07196d$export$479dbd817e392a4f; });
$parcel$export(module.exports, "addTracingExtensions", function () { return $b5d994f5ea07196d$export$653d0ef2bad9cdf9; });

var $iyYYs = parcelRequire("iyYYs");

var $7dwLN = parcelRequire("7dwLN");

var $l4UCE = parcelRequire("l4UCE");

var $ceyhT = parcelRequire("ceyhT");

var $2zeDR = parcelRequire("2zeDR");

var $1COtc = parcelRequire("1COtc");

var $bbUDW = parcelRequire("bbUDW");

var $4R5py = parcelRequire("4R5py");
/** Returns all trace headers that are currently on the top scope. */ // eslint-disable-next-line deprecation/deprecation
function $b5d994f5ea07196d$var$traceHeaders() {
    // eslint-disable-next-line deprecation/deprecation
    const scope = this.getScope();
    // eslint-disable-next-line deprecation/deprecation
    const span = scope.getSpan();
    return span ? {
        "sentry-trace": (0, $ceyhT.spanToTraceHeader)(span)
    } : {};
}
/**
 * Creates a new transaction and adds a sampling decision if it doesn't yet have one.
 *
 * The Hub.startTransaction method delegates to this method to do its work, passing the Hub instance in as `this`, as if
 * it had been called on the hub directly. Exists as a separate function so that it can be injected into the class as an
 * "extension method."
 *
 * @param this: The Hub starting the transaction
 * @param transactionContext: Data used to configure the transaction
 * @param CustomSamplingContext: Optional data to be provided to the `tracesSampler` function (if any)
 *
 * @returns The new transaction
 *
 * @see {@link Hub.startTransaction}
 */ function $b5d994f5ea07196d$var$_startTransaction(// eslint-disable-next-line deprecation/deprecation
transactionContext, customSamplingContext) {
    // eslint-disable-next-line deprecation/deprecation
    const client = this.getClient();
    const options = client && client.getOptions() || {};
    const configInstrumenter = options.instrumenter || "sentry";
    const transactionInstrumenter = transactionContext.instrumenter || "sentry";
    if (configInstrumenter !== transactionInstrumenter) {
        (0, $7dwLN.DEBUG_BUILD) && (0, $iyYYs.logger).error(`A transaction was started with instrumenter=\`${transactionInstrumenter}\`, but the SDK is configured with the \`${configInstrumenter}\` instrumenter.
The transaction will not be sampled. Please use the ${configInstrumenter} instrumentation to start transactions.`);
        // eslint-disable-next-line deprecation/deprecation
        transactionContext.sampled = false;
    }
    // eslint-disable-next-line deprecation/deprecation
    let transaction = new (0, $4R5py.Transaction)(transactionContext, this);
    transaction = (0, $bbUDW.sampleTransaction)(transaction, options, {
        name: transactionContext.name,
        parentSampled: transactionContext.parentSampled,
        transactionContext: transactionContext,
        attributes: {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.data,
            ...transactionContext.attributes
        },
        ...customSamplingContext
    });
    if (transaction.isRecording()) transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    if (client && client.emit) client.emit("startTransaction", transaction);
    return transaction;
}
/**
 * Create new idle transaction.
 */ function $b5d994f5ea07196d$export$479dbd817e392a4f(// eslint-disable-next-line deprecation/deprecation
hub, transactionContext, idleTimeout, finalTimeout, onScope, customSamplingContext, heartbeatInterval, delayAutoFinishUntilSignal = false) {
    // eslint-disable-next-line deprecation/deprecation
    const client = hub.getClient();
    const options = client && client.getOptions() || {};
    // eslint-disable-next-line deprecation/deprecation
    let transaction = new (0, $1COtc.IdleTransaction)(transactionContext, hub, idleTimeout, finalTimeout, heartbeatInterval, onScope, delayAutoFinishUntilSignal);
    transaction = (0, $bbUDW.sampleTransaction)(transaction, options, {
        name: transactionContext.name,
        parentSampled: transactionContext.parentSampled,
        transactionContext: transactionContext,
        attributes: {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.data,
            ...transactionContext.attributes
        },
        ...customSamplingContext
    });
    if (transaction.isRecording()) transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    if (client && client.emit) client.emit("startTransaction", transaction);
    return transaction;
}
/**
 * Adds tracing extensions to the global hub.
 */ function $b5d994f5ea07196d$export$653d0ef2bad9cdf9() {
    const carrier = (0, $l4UCE.getMainCarrier)();
    if (!carrier.__SENTRY__) return;
    carrier.__SENTRY__.extensions = carrier.__SENTRY__.extensions || {};
    if (!carrier.__SENTRY__.extensions.startTransaction) carrier.__SENTRY__.extensions.startTransaction = $b5d994f5ea07196d$var$_startTransaction;
    if (!carrier.__SENTRY__.extensions.traceHeaders) carrier.__SENTRY__.extensions.traceHeaders = $b5d994f5ea07196d$var$traceHeaders;
    (0, $2zeDR.registerErrorInstrumentation)();
}

});
parcelRegister("iyYYs", function(module, exports) {

$parcel$export(module.exports, "consoleSandbox", function () { return $d83ab32b0c21d70e$export$cda52e2a8927a2ca; });
$parcel$export(module.exports, "logger", function () { return $d83ab32b0c21d70e$export$af88d00dbe7f521; });

var $5rgwG = parcelRequire("5rgwG");

var $8a8aJ = parcelRequire("8a8aJ");
/** Prefix for logging strings */ const $d83ab32b0c21d70e$var$PREFIX = "Sentry Logger ";
const $d83ab32b0c21d70e$export$2a2b1d2252a69ecb = [
    "debug",
    "info",
    "warn",
    "error",
    "log",
    "assert",
    "trace"
];
/** This may be mutated by the console instrumentation. */ const $d83ab32b0c21d70e$export$77c4ce905194557b = {};
/** JSDoc */ /**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $d83ab32b0c21d70e$export$cda52e2a8927a2ca(callback) {
    if (!("console" in (0, $8a8aJ.GLOBAL_OBJ))) return callback();
    const console = (0, $8a8aJ.GLOBAL_OBJ).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($d83ab32b0c21d70e$export$77c4ce905194557b);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $d83ab32b0c21d70e$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $d83ab32b0c21d70e$var$makeLogger() {
    let enabled = false;
    const logger = {
        enable: ()=>{
            enabled = true;
        },
        disable: ()=>{
            enabled = false;
        },
        isEnabled: ()=>enabled
    };
    if (0, $5rgwG.DEBUG_BUILD) $d83ab32b0c21d70e$export$2a2b1d2252a69ecb.forEach((name)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = (...args)=>{
            if (enabled) $d83ab32b0c21d70e$export$cda52e2a8927a2ca(()=>{
                (0, $8a8aJ.GLOBAL_OBJ).console[name](`${$d83ab32b0c21d70e$var$PREFIX}[${name}]:`, ...args);
            });
        };
    });
    else $d83ab32b0c21d70e$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = ()=>undefined;
    });
    return logger;
}
const $d83ab32b0c21d70e$export$af88d00dbe7f521 = $d83ab32b0c21d70e$var$makeLogger();

});
parcelRegister("5rgwG", function(module, exports) {

$parcel$export(module.exports, "DEBUG_BUILD", function () { return $3f5c4b1b5709b422$export$16a28057038b10ef; });
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $3f5c4b1b5709b422$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;

});

parcelRegister("8a8aJ", function(module, exports) {

$parcel$export(module.exports, "GLOBAL_OBJ", function () { return $01889b3cce19d138$export$f1a6cdb1459e81d1; });
$parcel$export(module.exports, "getGlobalObject", function () { return $01889b3cce19d138$export$256479dc0cea61c4; });
$parcel$export(module.exports, "getGlobalSingleton", function () { return $01889b3cce19d138$export$7e223ec222791509; });
/** Internal global with common properties and Sentry extensions  */ // The code below for 'isGlobalObj' and 'GLOBAL_OBJ' was copied from core-js before modification
// https://github.com/zloirock/core-js/blob/1b944df55282cdc99c90db5f49eb0b6eda2cc0a3/packages/core-js/internals/global.js
// core-js has the following licence:
//
// Copyright (c) 2014-2022 Denis Pushkarev
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
/** Returns 'obj' if it's the global object, otherwise returns undefined */ function $01889b3cce19d138$var$isGlobalObj(obj) {
    return obj && obj.Math == Math ? obj : undefined;
}
/** Get's the global object for the current JavaScript runtime */ const $01889b3cce19d138$export$f1a6cdb1459e81d1 = typeof globalThis == "object" && $01889b3cce19d138$var$isGlobalObj(globalThis) || // eslint-disable-next-line no-restricted-globals
typeof window == "object" && $01889b3cce19d138$var$isGlobalObj(window) || typeof self == "object" && $01889b3cce19d138$var$isGlobalObj(self) || typeof $parcel$global == "object" && $01889b3cce19d138$var$isGlobalObj($parcel$global) || function() {
    return this;
}() || {};
/**
 * @deprecated Use GLOBAL_OBJ instead or WINDOW from @sentry/browser. This will be removed in v8
 */ function $01889b3cce19d138$export$256479dc0cea61c4() {
    return $01889b3cce19d138$export$f1a6cdb1459e81d1;
}
/**
 * Returns a global singleton contained in the global `__SENTRY__` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $01889b3cce19d138$export$7e223ec222791509(name, creator, obj) {
    const gbl = obj || $01889b3cce19d138$export$f1a6cdb1459e81d1;
    const __SENTRY__ = gbl.__SENTRY__ = gbl.__SENTRY__ || {};
    const singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}

});


parcelRegister("7dwLN", function(module, exports) {

$parcel$export(module.exports, "DEBUG_BUILD", function () { return $54132ab6057f4c39$export$16a28057038b10ef; });
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $54132ab6057f4c39$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;

});

parcelRegister("l4UCE", function(module, exports) {

$parcel$export(module.exports, "getMainCarrier", function () { return $f585e4b7bf6b880e$export$19eade501500c6c1; });
$parcel$export(module.exports, "getCurrentHub", function () { return $f585e4b7bf6b880e$export$a07cdf6544bbd7c; });
$parcel$export(module.exports, "getIsolationScope", function () { return $f585e4b7bf6b880e$export$68f3af03034c9e90; });
$parcel$export(module.exports, "runWithAsyncContext", function () { return $f585e4b7bf6b880e$export$70d775fb1f267027; });

var $iyYYs = parcelRequire("iyYYs");
var $ggG8j = parcelRequire("ggG8j");
var $8a8aJ = parcelRequire("8a8aJ");
var $dR6t7 = parcelRequire("dR6t7");
var $dmJ8B = parcelRequire("dmJ8B");

var $aoBPq = parcelRequire("aoBPq");

var $7dwLN = parcelRequire("7dwLN");

var $hsIUf = parcelRequire("hsIUf");

var $eZJc1 = parcelRequire("eZJc1");

var $3uCDJ = parcelRequire("3uCDJ");
/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */ const $f585e4b7bf6b880e$export$24a86ef7798177e4 = parseFloat((0, $3uCDJ.SDK_VERSION));
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ const $f585e4b7bf6b880e$var$DEFAULT_BREADCRUMBS = 100;
/**
 * @deprecated The `Hub` class will be removed in version 8 of the SDK in favour of `Scope` and `Client` objects.
 *
 * If you previously used the `Hub` class directly, replace it with `Scope` and `Client` objects. More information:
 * - [Multiple Sentry Instances](https://docs.sentry.io/platforms/javascript/best-practices/multiple-sentry-instances/)
 * - [Browser Extensions](https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/)
 *
 * Some of our APIs are typed with the Hub class instead of the interface (e.g. `getCurrentHub`). Most of them are deprecated
 * themselves and will also be removed in version 8. More information:
 * - [Migration Guide](https://github.com/getsentry/sentry-javascript/blob/develop/MIGRATION.md#deprecate-hub)
 */ // eslint-disable-next-line deprecation/deprecation
class $f585e4b7bf6b880e$export$8c41bb232f1008b1 {
    /** Is a {@link Layer}[] containing the client and scope */ /** Contains the last event id of a captured event.  */ /**
   * Creates a new instance of the hub, will push one {@link Layer} into the
   * internal stack on creation.
   *
   * @param client bound to the hub.
   * @param scope bound to the hub.
   * @param version number, higher number means higher priority.
   *
   * @deprecated Instantiation of Hub objects is deprecated and the constructor will be removed in version 8 of the SDK.
   *
   * If you are currently using the Hub for multi-client use like so:
   *
   * ```
   * // OLD
   * const hub = new Hub();
   * hub.bindClient(client);
   * makeMain(hub)
   * ```
   *
   * instead initialize the client as follows:
   *
   * ```
   * // NEW
   * Sentry.withIsolationScope(() => {
   *    Sentry.setCurrentClient(client);
   *    client.init();
   * });
   * ```
   *
   * If you are using the Hub to capture events like so:
   *
   * ```
   * // OLD
   * const client = new Client();
   * const hub = new Hub(client);
   * hub.captureException()
   * ```
   *
   * instead capture isolated events as follows:
   *
   * ```
   * // NEW
   * const client = new Client();
   * const scope = new Scope();
   * scope.setClient(client);
   * scope.captureException();
   * ```
   */ constructor(client, scope, isolationScope, _version = $f585e4b7bf6b880e$export$24a86ef7798177e4){
        this._version = _version;
        let assignedScope;
        if (!scope) {
            assignedScope = new (0, $hsIUf.Scope)();
            assignedScope.setClient(client);
        } else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) {
            assignedIsolationScope = new (0, $hsIUf.Scope)();
            assignedIsolationScope.setClient(client);
        } else assignedIsolationScope = isolationScope;
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        if (client) // eslint-disable-next-line deprecation/deprecation
        this.bindClient(client);
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Checks if this hub's version is older than the given version.
   *
   * @param version A version number to compare to.
   * @return True if the given version is newer; otherwise false.
   *
   * @deprecated This will be removed in v8.
   */ isOlderThan(version) {
        return this._version < version;
    }
    /**
   * This binds the given client to the current scope.
   * @param client An SDK client (client) instance.
   *
   * @deprecated Use `initAndBind()` directly, or `setCurrentClient()` and/or `client.init()` instead.
   */ bindClient(client) {
        // eslint-disable-next-line deprecation/deprecation
        const top = this.getStackTop();
        top.client = client;
        top.scope.setClient(client);
        // eslint-disable-next-line deprecation/deprecation
        if (client && client.setupIntegrations) // eslint-disable-next-line deprecation/deprecation
        client.setupIntegrations();
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */ pushScope() {
        // We want to clone the content of prev scope
        // eslint-disable-next-line deprecation/deprecation
        const scope = this.getScope().clone();
        // eslint-disable-next-line deprecation/deprecation
        this.getStack().push({
            // eslint-disable-next-line deprecation/deprecation
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */ popScope() {
        // eslint-disable-next-line deprecation/deprecation
        if (this.getStack().length <= 1) return false;
        // eslint-disable-next-line deprecation/deprecation
        return !!this.getStack().pop();
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.withScope()` instead.
   */ withScope(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const scope = this.pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            throw e;
        }
        if ((0, $dR6t7.isThenable)(maybePromiseResult)) // @ts-expect-error - isThenable returns the wrong type
        return maybePromiseResult.then((res)=>{
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            return res;
        }, (e)=>{
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            throw e;
        });
        // eslint-disable-next-line deprecation/deprecation
        this.popScope();
        return maybePromiseResult;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.getClient()` instead.
   */ getClient() {
        // eslint-disable-next-line deprecation/deprecation
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   *
   * @deprecated Use `Sentry.getCurrentScope()` instead.
   */ getScope() {
        // eslint-disable-next-line deprecation/deprecation
        return this.getStackTop().scope;
    }
    /**
   * @deprecated Use `Sentry.getIsolationScope()` instead.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the scope stack for domains or the process.
   * @deprecated This will be removed in v8.
   */ getStack() {
        return this._stack;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   * @deprecated This will be removed in v8.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureException()` instead.
   */ captureException(exception, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $dmJ8B.uuid4)();
        const syntheticException = new Error("Sentry syntheticException");
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use  `Sentry.captureMessage()` instead.
   */ captureMessage(message, // eslint-disable-next-line deprecation/deprecation
    level, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $dmJ8B.uuid4)();
        const syntheticException = new Error(message);
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureEvent()` instead.
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $dmJ8B.uuid4)();
        if (!event.type) this._lastEventId = eventId;
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureEvent(event, {
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated This will be removed in v8.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.addBreadcrumb()` instead.
   */ addBreadcrumb(breadcrumb, hint) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        if (!client) return;
        const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $f585e4b7bf6b880e$var$DEFAULT_BREADCRUMBS } = client.getOptions && client.getOptions() || {};
        if (maxBreadcrumbs <= 0) return;
        const timestamp = (0, $ggG8j.dateTimestampInSeconds)();
        const mergedBreadcrumb = {
            timestamp: timestamp,
            ...breadcrumb
        };
        const finalBreadcrumb = beforeBreadcrumb ? (0, $iyYYs.consoleSandbox)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
        if (finalBreadcrumb === null) return;
        if (client.emit) client.emit("beforeAddBreadcrumb", finalBreadcrumb, hint);
        // TODO(v8): I know this comment doesn't make much sense because the hub will be deprecated but I still wanted to
        // write it down. In theory, we would have to add the breadcrumbs to the isolation scope here, however, that would
        // duplicate all of the breadcrumbs. There was the possibility of adding breadcrumbs to both, the isolation scope
        // and the normal scope, and deduplicating it down the line in the event processing pipeline. However, that would
        // have been very fragile, because the breadcrumb objects would have needed to keep their identity all throughout
        // the event processing pipeline.
        // In the new implementation, the top level `Sentry.addBreadcrumb()` should ONLY write to the isolation scope.
        scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setUser()` instead.
   */ setUser(user) {
        // TODO(v8): The top level `Sentry.setUser()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setUser(user);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setUser(user);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTags()` instead.
   */ setTags(tags) {
        // TODO(v8): The top level `Sentry.setTags()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setTags(tags);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setTags(tags);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtras()` instead.
   */ setExtras(extras) {
        // TODO(v8): The top level `Sentry.setExtras()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setExtras(extras);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setExtras(extras);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTag()` instead.
   */ setTag(key, value) {
        // TODO(v8): The top level `Sentry.setTag()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setTag(key, value);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setTag(key, value);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtra()` instead.
   */ setExtra(key, extra) {
        // TODO(v8): The top level `Sentry.setExtra()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setExtra(key, extra);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setExtra(key, extra);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setContext()` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setContext(name, context) {
        // TODO(v8): The top level `Sentry.setContext()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setContext(name, context);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setContext(name, context);
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `getScope()` directly.
   */ configureScope(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        if (client) callback(scope);
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    run(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const oldHub = $f585e4b7bf6b880e$export$4188a14ad302d1bc(this);
        try {
            callback(this);
        } finally{
            // eslint-disable-next-line deprecation/deprecation
            $f585e4b7bf6b880e$export$4188a14ad302d1bc(oldHub);
        }
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.getClient().getIntegrationByName()` instead.
   */ getIntegration(integration) {
        // eslint-disable-next-line deprecation/deprecation
        const client = this.getClient();
        if (!client) return null;
        try {
            // eslint-disable-next-line deprecation/deprecation
            return client.getIntegration(integration);
        } catch (_oO) {
            (0, $7dwLN.DEBUG_BUILD) && (0, $iyYYs.logger).warn(`Cannot retrieve integration ${integration.id} from the current Hub`);
            return null;
        }
    }
    /**
   * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
   *
   * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
   * new child span within the transaction or any span, call the respective `.startChild()` method.
   *
   * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
   *
   * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
   * finished child spans will be sent to Sentry.
   *
   * @param context Properties of the new `Transaction`.
   * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
   * default values). See {@link Options.tracesSampler}.
   *
   * @returns The transaction which was just started
   *
   * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
   */ startTransaction(context, customSamplingContext) {
        const result = this._callExtensionMethod("startTransaction", context, customSamplingContext);
        if ((0, $7dwLN.DEBUG_BUILD) && !result) {
            // eslint-disable-next-line deprecation/deprecation
            const client = this.getClient();
            if (!client) (0, $iyYYs.logger).warn("Tracing extension 'startTransaction' is missing. You should 'init' the SDK before calling 'startTransaction'");
            else (0, $iyYYs.logger).warn(`Tracing extension 'startTransaction' has not been added. Call 'addTracingExtensions' before calling 'init':
Sentry.addTracingExtensions();
Sentry.init({...});
`);
        }
        return result;
    }
    /**
   * @inheritDoc
   * @deprecated Use `spanToTraceHeader()` instead.
   */ traceHeaders() {
        return this._callExtensionMethod("traceHeaders");
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use top level `captureSession` instead.
   */ captureSession(endSession = false) {
        // both send the update and pull the session from the scope
        if (endSession) // eslint-disable-next-line deprecation/deprecation
        return this.endSession();
        // only send the update
        this._sendSessionUpdate();
    }
    /**
   * @inheritDoc
   * @deprecated Use top level `endSession` instead.
   */ endSession() {
        // eslint-disable-next-line deprecation/deprecation
        const layer = this.getStackTop();
        const scope = layer.scope;
        const session = scope.getSession();
        if (session) (0, $eZJc1.closeSession)(session);
        this._sendSessionUpdate();
        // the session is over; take it off of the scope
        scope.setSession();
    }
    /**
   * @inheritDoc
   * @deprecated Use top level `startSession` instead.
   */ startSession(context) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        const { release: release, environment: environment = (0, $aoBPq.DEFAULT_ENVIRONMENT) } = client && client.getOptions() || {};
        // Will fetch userAgent if called from browser sdk
        const { userAgent: userAgent } = (0, $8a8aJ.GLOBAL_OBJ).navigator || {};
        const session = (0, $eZJc1.makeSession)({
            release: release,
            environment: environment,
            user: scope.getUser(),
            ...userAgent && {
                userAgent: userAgent
            },
            ...context
        });
        // End existing session if there's one
        const currentSession = scope.getSession && scope.getSession();
        if (currentSession && currentSession.status === "ok") (0, $eZJc1.updateSession)(currentSession, {
            status: "exited"
        });
        // eslint-disable-next-line deprecation/deprecation
        this.endSession();
        // Afterwards we set the new session on the scope
        scope.setSession(session);
        return session;
    }
    /**
   * Returns if default PII should be sent to Sentry and propagated in ourgoing requests
   * when Tracing is used.
   *
   * @deprecated Use top-level `getClient().getOptions().sendDefaultPii` instead. This function
   * only unnecessarily increased API surface but only wrapped accessing the option.
   */ shouldSendDefaultPii() {
        // eslint-disable-next-line deprecation/deprecation
        const client = this.getClient();
        const options = client && client.getOptions();
        return Boolean(options && options.sendDefaultPii);
    }
    /**
   * Sends the current Session on the scope
   */ _sendSessionUpdate() {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        const session = scope.getSession();
        if (session && client && client.captureSession) client.captureSession(session);
    }
    /**
   * Calls global extension method and binding current instance to the function call
   */ // @ts-expect-error Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _callExtensionMethod(method, ...args) {
        const carrier = $f585e4b7bf6b880e$export$19eade501500c6c1();
        const sentry = carrier.__SENTRY__;
        if (sentry && sentry.extensions && typeof sentry.extensions[method] === "function") return sentry.extensions[method].apply(this, args);
        (0, $7dwLN.DEBUG_BUILD) && (0, $iyYYs.logger).warn(`Extension method ${method} couldn't be found, doing nothing.`);
    }
}
/**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $f585e4b7bf6b880e$export$19eade501500c6c1() {
    (0, $8a8aJ.GLOBAL_OBJ).__SENTRY__ = (0, $8a8aJ.GLOBAL_OBJ).__SENTRY__ || {
        extensions: {},
        hub: undefined
    };
    return 0, $8a8aJ.GLOBAL_OBJ;
}
/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 *
 * @deprecated Use `setCurrentClient()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
function $f585e4b7bf6b880e$export$4188a14ad302d1bc(hub) {
    const registry = $f585e4b7bf6b880e$export$19eade501500c6c1();
    const oldHub = $f585e4b7bf6b880e$export$bfa8a924a84a76b7(registry);
    $f585e4b7bf6b880e$export$849f05434e95d2f2(registry, hub);
    return oldHub;
}
/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 *
 * @deprecated Use the respective replacement method directly instead.
 */ // eslint-disable-next-line deprecation/deprecation
function $f585e4b7bf6b880e$export$a07cdf6544bbd7c() {
    // Get main carrier (global for every environment)
    const registry = $f585e4b7bf6b880e$export$19eade501500c6c1();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) {
        const hub = registry.__SENTRY__.acs.getCurrentHub();
        if (hub) return hub;
    }
    // Return hub that lives on a global object
    return $f585e4b7bf6b880e$var$getGlobalHub(registry);
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current exection context,
 * meaning that it will remain stable for the same Hub.
 */ function $f585e4b7bf6b880e$export$68f3af03034c9e90() {
    // eslint-disable-next-line deprecation/deprecation
    return $f585e4b7bf6b880e$export$a07cdf6544bbd7c().getIsolationScope();
}
// eslint-disable-next-line deprecation/deprecation
function $f585e4b7bf6b880e$var$getGlobalHub(registry = $f585e4b7bf6b880e$export$19eade501500c6c1()) {
    // If there's no hub, or its an old API, assign a new one
    if (!$f585e4b7bf6b880e$var$hasHubOnCarrier(registry) || // eslint-disable-next-line deprecation/deprecation
    $f585e4b7bf6b880e$export$bfa8a924a84a76b7(registry).isOlderThan($f585e4b7bf6b880e$export$24a86ef7798177e4)) // eslint-disable-next-line deprecation/deprecation
    $f585e4b7bf6b880e$export$849f05434e95d2f2(registry, new $f585e4b7bf6b880e$export$8c41bb232f1008b1());
    // Return hub that lives on a global object
    return $f585e4b7bf6b880e$export$bfa8a924a84a76b7(registry);
}
/**
 * @private Private API with no semver guarantees!
 *
 * If the carrier does not contain a hub, a new hub is created with the global hub client and scope.
 */ // eslint-disable-next-line deprecation/deprecation
function $f585e4b7bf6b880e$export$236689a79f5aa020(carrier, parent = $f585e4b7bf6b880e$var$getGlobalHub()) {
    // If there's no hub on current domain, or it's an old API, assign a new one
    if (!$f585e4b7bf6b880e$var$hasHubOnCarrier(carrier) || // eslint-disable-next-line deprecation/deprecation
    $f585e4b7bf6b880e$export$bfa8a924a84a76b7(carrier).isOlderThan($f585e4b7bf6b880e$export$24a86ef7798177e4)) {
        // eslint-disable-next-line deprecation/deprecation
        const client = parent.getClient();
        // eslint-disable-next-line deprecation/deprecation
        const scope = parent.getScope();
        // eslint-disable-next-line deprecation/deprecation
        const isolationScope = parent.getIsolationScope();
        // eslint-disable-next-line deprecation/deprecation
        $f585e4b7bf6b880e$export$849f05434e95d2f2(carrier, new $f585e4b7bf6b880e$export$8c41bb232f1008b1(client, scope.clone(), isolationScope.clone()));
    }
}
/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $f585e4b7bf6b880e$export$774ae0e6b6e444ca(strategy) {
    // Get main carrier (global for every environment)
    const registry = $f585e4b7bf6b880e$export$19eade501500c6c1();
    registry.__SENTRY__ = registry.__SENTRY__ || {};
    registry.__SENTRY__.acs = strategy;
}
/**
 * Runs the supplied callback in its own async context. Async Context strategies are defined per SDK.
 *
 * @param callback The callback to run in its own async context
 * @param options Options to pass to the async context strategy
 * @returns The result of the callback
 */ function $f585e4b7bf6b880e$export$70d775fb1f267027(callback, options = {}) {
    const registry = $f585e4b7bf6b880e$export$19eade501500c6c1();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) return registry.__SENTRY__.acs.runWithAsyncContext(callback, options);
    // if there was no strategy, fallback to just calling the callback
    return callback();
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */ function $f585e4b7bf6b880e$var$hasHubOnCarrier(carrier) {
    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */ // eslint-disable-next-line deprecation/deprecation
function $f585e4b7bf6b880e$export$bfa8a924a84a76b7(carrier) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $8a8aJ.getGlobalSingleton)("hub", ()=>new $f585e4b7bf6b880e$export$8c41bb232f1008b1(), carrier);
}
/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 * @returns A boolean indicating success or failure
 */ // eslint-disable-next-line deprecation/deprecation
function $f585e4b7bf6b880e$export$849f05434e95d2f2(carrier, hub) {
    if (!carrier) return false;
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.hub = hub;
    return true;
}

});
parcelRegister("ggG8j", function(module, exports) {

$parcel$export(module.exports, "dateTimestampInSeconds", function () { return $bd7ed2b8bb3838d4$export$7740643b9eeaf0c4; });
$parcel$export(module.exports, "timestampInSeconds", function () { return $bd7ed2b8bb3838d4$export$ee52dced521e3e18; });
$parcel$export(module.exports, "browserPerformanceTimeOrigin", function () { return $bd7ed2b8bb3838d4$export$baf075a948ffc0bf; });

var $8a8aJ = parcelRequire("8a8aJ");
const $bd7ed2b8bb3838d4$var$ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 *
 * TODO(v8): Return type should be rounded.
 */ function $bd7ed2b8bb3838d4$export$7740643b9eeaf0c4() {
    return Date.now() / $bd7ed2b8bb3838d4$var$ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function $bd7ed2b8bb3838d4$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $8a8aJ.GLOBAL_OBJ);
    if (!performance || !performance.now) return $bd7ed2b8bb3838d4$export$7740643b9eeaf0c4;
    // Some browser and environments don't have a timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    const approxStartingTimeOrigin = Date.now() - performance.now();
    const timeOrigin = performance.timeOrigin == undefined ? approxStartingTimeOrigin : performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return ()=>{
        return (timeOrigin + performance.now()) / $bd7ed2b8bb3838d4$var$ONE_SECOND_IN_MS;
    };
}
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ const $bd7ed2b8bb3838d4$export$ee52dced521e3e18 = $bd7ed2b8bb3838d4$var$createUnixTimestampInSecondsFunc();
/**
 * Re-exported with an old name for backwards-compatibility.
 * TODO (v8): Remove this
 *
 * @deprecated Use `timestampInSeconds` instead.
 */ const $bd7ed2b8bb3838d4$export$c5907b5a8838db13 = $bd7ed2b8bb3838d4$export$ee52dced521e3e18;
/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */ let $bd7ed2b8bb3838d4$export$f9f8cce55af5194c;
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ const $bd7ed2b8bb3838d4$export$baf075a948ffc0bf = (()=>{
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    const { performance: performance } = (0, $8a8aJ.GLOBAL_OBJ);
    if (!performance || !performance.now) {
        $bd7ed2b8bb3838d4$export$f9f8cce55af5194c = "none";
        return undefined;
    }
    const threshold = 3600000;
    const performanceNow = performance.now();
    const dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    const timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing && performance.timing.navigationStart;
    const hasNavigationStart = typeof navigationStart === "number";
    // if navigationStart isn't available set delta to threshold so it isn't used
    const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    const navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            $bd7ed2b8bb3838d4$export$f9f8cce55af5194c = "timeOrigin";
            return performance.timeOrigin;
        } else {
            $bd7ed2b8bb3838d4$export$f9f8cce55af5194c = "navigationStart";
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    $bd7ed2b8bb3838d4$export$f9f8cce55af5194c = "dateNow";
    return dateNow;
})();

});

parcelRegister("dR6t7", function(module, exports) {

$parcel$export(module.exports, "isError", function () { return $a1653e2a0740112e$export$e6127cc7fe7395c3; });
$parcel$export(module.exports, "isInstanceOf", function () { return $a1653e2a0740112e$export$49034edbe6b62415; });
$parcel$export(module.exports, "isString", function () { return $a1653e2a0740112e$export$844ec244b1367d54; });
$parcel$export(module.exports, "isPrimitive", function () { return $a1653e2a0740112e$export$c3825b437cbdea5c; });
$parcel$export(module.exports, "isPlainObject", function () { return $a1653e2a0740112e$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "isEvent", function () { return $a1653e2a0740112e$export$9671ea99bd126ace; });
$parcel$export(module.exports, "isElement", function () { return $a1653e2a0740112e$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isRegExp", function () { return $a1653e2a0740112e$export$49841c62b9eff15; });
$parcel$export(module.exports, "isThenable", function () { return $a1653e2a0740112e$export$f5b060c2914b97c8; });
$parcel$export(module.exports, "isSyntheticEvent", function () { return $a1653e2a0740112e$export$bc2894c7158efbac; });
$parcel$export(module.exports, "isNaN", function () { return $a1653e2a0740112e$export$c9f5652083b8129d; });
$parcel$export(module.exports, "isVueViewModel", function () { return $a1653e2a0740112e$export$7916fad0ebc23f48; });
// eslint-disable-next-line @typescript-eslint/unbound-method
const $a1653e2a0740112e$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $a1653e2a0740112e$export$e6127cc7fe7395c3(wat) {
    switch($a1653e2a0740112e$var$objectToString.call(wat)){
        case "[object Error]":
        case "[object Exception]":
        case "[object DOMException]":
            return true;
        default:
            return $a1653e2a0740112e$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $a1653e2a0740112e$var$isBuiltin(wat, className) {
    return $a1653e2a0740112e$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $a1653e2a0740112e$export$9f9636d330b71954(wat) {
    return $a1653e2a0740112e$var$isBuiltin(wat, "ErrorEvent");
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $a1653e2a0740112e$export$ef9e2056653f0c8e(wat) {
    return $a1653e2a0740112e$var$isBuiltin(wat, "DOMError");
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $a1653e2a0740112e$export$12e869b2a583f783(wat) {
    return $a1653e2a0740112e$var$isBuiltin(wat, "DOMException");
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $a1653e2a0740112e$export$844ec244b1367d54(wat) {
    return $a1653e2a0740112e$var$isBuiltin(wat, "String");
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $a1653e2a0740112e$export$dbcbffa59149b824(wat) {
    return typeof wat === "object" && wat !== null && "__sentry_template_string__" in wat && "__sentry_template_values__" in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $a1653e2a0740112e$export$c3825b437cbdea5c(wat) {
    return wat === null || $a1653e2a0740112e$export$dbcbffa59149b824(wat) || typeof wat !== "object" && typeof wat !== "function";
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $a1653e2a0740112e$export$53b83ca8eaab0383(wat) {
    return $a1653e2a0740112e$var$isBuiltin(wat, "Object");
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $a1653e2a0740112e$export$9671ea99bd126ace(wat) {
    return typeof Event !== "undefined" && $a1653e2a0740112e$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $a1653e2a0740112e$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== "undefined" && $a1653e2a0740112e$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $a1653e2a0740112e$export$49841c62b9eff15(wat) {
    return $a1653e2a0740112e$var$isBuiltin(wat, "RegExp");
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $a1653e2a0740112e$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === "function");
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $a1653e2a0740112e$export$bc2894c7158efbac(wat) {
    return $a1653e2a0740112e$export$53b83ca8eaab0383(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}
/**
 * Checks whether given value is NaN
 * {@link isNaN}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $a1653e2a0740112e$export$c9f5652083b8129d(wat) {
    return typeof wat === "number" && wat !== wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $a1653e2a0740112e$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $a1653e2a0740112e$export$7916fad0ebc23f48(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    return !!(typeof wat === "object" && wat !== null && (wat.__isVue || wat._isVue));
}

});

parcelRegister("dmJ8B", function(module, exports) {

$parcel$export(module.exports, "uuid4", function () { return $9bb057d8a3a1beef$export$19f53698e68b2496; });
$parcel$export(module.exports, "addExceptionMechanism", function () { return $9bb057d8a3a1beef$export$c69a9a0313b03bb1; });
$parcel$export(module.exports, "arrayify", function () { return $9bb057d8a3a1beef$export$3131421a7d01b4fb; });

var $9fGKl = parcelRequire("9fGKl");

var $hR2Jv = parcelRequire("hR2Jv");

var $8a8aJ = parcelRequire("8a8aJ");
/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */ function $9bb057d8a3a1beef$export$19f53698e68b2496() {
    const gbl = (0, $8a8aJ.GLOBAL_OBJ);
    const crypto = gbl.crypto || gbl.msCrypto;
    let getRandomByte = ()=>Math.random() * 16;
    try {
        if (crypto && crypto.randomUUID) return crypto.randomUUID().replace(/-/g, "");
        if (crypto && crypto.getRandomValues) getRandomByte = ()=>{
            // crypto.getRandomValues might return undefined instead of the typed array
            // in old Chromium versions (e.g. 23.0.1235.0 (151422))
            // However, `typedArray` is still filled in-place.
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues#typedarray
            const typedArray = new Uint8Array(1);
            crypto.getRandomValues(typedArray);
            return typedArray[0];
        };
    } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function $9bb057d8a3a1beef$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $9bb057d8a3a1beef$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $9bb057d8a3a1beef$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || "<unknown>";
    }
    return eventId || "<unknown>";
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $9bb057d8a3a1beef$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || "";
    if (!firstException.type) firstException.type = type || "Error";
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $9bb057d8a3a1beef$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $9bb057d8a3a1beef$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: "generic",
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && "data" in newMechanism) {
        const mergedData = {
            ...currentMechanism && currentMechanism.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $9bb057d8a3a1beef$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ /**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $9bb057d8a3a1beef$export$d364f2020ab30578(input) {
    const match = input.match($9bb057d8a3a1beef$var$SEMVER_REGEXP) || [];
    const major = parseInt(match[1], 10);
    const minor = parseInt(match[2], 10);
    const patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $9bb057d8a3a1beef$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $hR2Jv.snipLine)(line, 0));
    frame.context_line = (0, $hR2Jv.snipLine)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $hR2Jv.snipLine)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $9bb057d8a3a1beef$export$6de4ffac6a2f1098(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $9fGKl.addNonEnumerableProperty)(exception, "__sentry_captured__", true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 */ function $9bb057d8a3a1beef$export$3131421a7d01b4fb(maybeArray) {
    return Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];
}

});
parcelRegister("9fGKl", function(module, exports) {

$parcel$export(module.exports, "fill", function () { return $6bc6ac507bcf69ad$export$9563e054e6f787fb; });
$parcel$export(module.exports, "addNonEnumerableProperty", function () { return $6bc6ac507bcf69ad$export$e73679ffaf56810e; });
$parcel$export(module.exports, "convertToPlainObject", function () { return $6bc6ac507bcf69ad$export$62ff257738bf57f5; });
$parcel$export(module.exports, "dropUndefinedKeys", function () { return $6bc6ac507bcf69ad$export$d25f2688db1bb433; });

var $6DrO1 = parcelRequire("6DrO1");

var $5rgwG = parcelRequire("5rgwG");

var $dR6t7 = parcelRequire("dR6t7");

var $iyYYs = parcelRequire("iyYYs");

var $hR2Jv = parcelRequire("hR2Jv");
/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $6bc6ac507bcf69ad$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === "function") $6bc6ac507bcf69ad$export$5c1499e2e5d010ae(wrapped, original);
    source[name] = wrapped;
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $6bc6ac507bcf69ad$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch (o_O) {
        (0, $5rgwG.DEBUG_BUILD) && (0, $iyYYs.logger).log(`Failed to add non-enumerable property "${name}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $6bc6ac507bcf69ad$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $6bc6ac507bcf69ad$export$e73679ffaf56810e(wrapped, "__sentry_original__", original);
    } catch (o_O) {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ function $6bc6ac507bcf69ad$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */ function $6bc6ac507bcf69ad$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map((key)=>`${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`).join("&");
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argurment itself, when value is neither an Event nor
 *  an Error.
 */ function $6bc6ac507bcf69ad$export$62ff257738bf57f5(value) {
    if ((0, $dR6t7.isError)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$6bc6ac507bcf69ad$var$getOwnProperties(value)
    };
    else if ((0, $dR6t7.isEvent)(value)) {
        const newObj = {
            type: value.type,
            target: $6bc6ac507bcf69ad$var$serializeEventTarget(value.target),
            currentTarget: $6bc6ac507bcf69ad$var$serializeEventTarget(value.currentTarget),
            ...$6bc6ac507bcf69ad$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== "undefined" && (0, $dR6t7.isInstanceOf)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $6bc6ac507bcf69ad$var$serializeEventTarget(target) {
    try {
        return (0, $dR6t7.isElement)(target) ? (0, $6DrO1.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return "<unknown>";
    }
}
/** Filters out all but an object's own properties */ function $6bc6ac507bcf69ad$var$getOwnProperties(obj) {
    if (typeof obj === "object" && obj !== null) {
        const extractedProps = {};
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $6bc6ac507bcf69ad$export$b0244d5063c0b61b(exception, maxLength = 40) {
    const keys = Object.keys($6bc6ac507bcf69ad$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return "[object has no keys]";
    if (keys[0].length >= maxLength) return (0, $hR2Jv.truncate)(keys[0], maxLength);
    for(let includedKeys = keys.length; includedKeys > 0; includedKeys--){
        const serialized = keys.slice(0, includedKeys).join(", ");
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $hR2Jv.truncate)(serialized, maxLength);
    }
    return "";
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */ function $6bc6ac507bcf69ad$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $6bc6ac507bcf69ad$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $6bc6ac507bcf69ad$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if ($6bc6ac507bcf69ad$var$isPojo(inputValue)) {
        // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = {};
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        for (const key of Object.keys(inputValue))if (typeof inputValue[key] !== "undefined") returnValue[key] = $6bc6ac507bcf69ad$var$_dropUndefinedKeys(inputValue[key], memoizationMap);
        return returnValue;
    }
    if (Array.isArray(inputValue)) {
        // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = [];
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((item)=>{
            returnValue.push($6bc6ac507bcf69ad$var$_dropUndefinedKeys(item, memoizationMap));
        });
        return returnValue;
    }
    return inputValue;
}
function $6bc6ac507bcf69ad$var$isPojo(input) {
    if (!(0, $dR6t7.isPlainObject)(input)) return false;
    try {
        const name = Object.getPrototypeOf(input).constructor.name;
        return !name || name === "Object";
    } catch (e) {
        return true;
    }
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $6bc6ac507bcf69ad$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === "symbol" || typeof wat === "bigint":
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $dR6t7.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}

});
parcelRegister("6DrO1", function(module, exports) {

$parcel$export(module.exports, "htmlTreeAsString", function () { return $4d4bf43a6156331a$export$5647df6b7814ac86; });
$parcel$export(module.exports, "getDomElement", function () { return $4d4bf43a6156331a$export$c660c1f3ab49225c; });
$parcel$export(module.exports, "getComponentName", function () { return $4d4bf43a6156331a$export$26727cfcc4d7e0fc; });

var $dR6t7 = parcelRequire("dR6t7");

var $8a8aJ = parcelRequire("8a8aJ");
// eslint-disable-next-line deprecation/deprecation
const $4d4bf43a6156331a$var$WINDOW = (0, $8a8aJ.getGlobalObject)();
const $4d4bf43a6156331a$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $4d4bf43a6156331a$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return "<unknown>";
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = " > ";
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $4d4bf43a6156331a$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $4d4bf43a6156331a$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return "<unknown>";
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $4d4bf43a6156331a$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    let className;
    let classes;
    let key;
    let attr;
    let i;
    if (!elem || !elem.tagName) return "";
    // @ts-expect-error WINDOW has HTMLElement
    if ($4d4bf43a6156331a$var$WINDOW.HTMLElement) {
        // If using the component name annotation plugin, this value may be available on the DOM node
        if (elem instanceof HTMLElement && elem.dataset && elem.dataset["sentryComponent"]) return elem.dataset["sentryComponent"];
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $dR6t7.isString)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push(`.${classes[i]}`);
        }
    }
    const allowedAttrs = [
        "aria-label",
        "type",
        "name",
        "title",
        "alt"
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push(`[${key}="${attr}"]`);
    }
    return out.join("");
}
/**
 * A safe form of location.href
 */ function $4d4bf43a6156331a$export$1cfafeee2987818b() {
    try {
        return $4d4bf43a6156331a$var$WINDOW.document.location.href;
    } catch (oO) {
        return "";
    }
}
/**
 * Gets a DOM element by using document.querySelector.
 *
 * This wrapper will first check for the existance of the function before
 * actually calling it so that we don't have to take care of this check,
 * every time we want to access the DOM.
 *
 * Reason: DOM/querySelector is not available in all environments.
 *
 * We have to cast to any because utils can be consumed by a variety of environments,
 * and we don't want to break TS users. If you know what element will be selected by
 * `document.querySelector`, specify it as part of the generic call. For example,
 * `const element = getDomElement<Element>('selector');`
 *
 * @param selector the selector string passed on to document.querySelector
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $4d4bf43a6156331a$export$c660c1f3ab49225c(selector) {
    if ($4d4bf43a6156331a$var$WINDOW.document && $4d4bf43a6156331a$var$WINDOW.document.querySelector) return $4d4bf43a6156331a$var$WINDOW.document.querySelector(selector);
    return null;
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` attribute. This attribute is added at build-time
 * by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function $4d4bf43a6156331a$export$26727cfcc4d7e0fc(elem) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!$4d4bf43a6156331a$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    const MAX_TRAVERSE_HEIGHT = 5;
    for(let i = 0; i < MAX_TRAVERSE_HEIGHT; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement && currentElem.dataset["sentryComponent"]) return currentElem.dataset["sentryComponent"];
        currentElem = currentElem.parentNode;
    }
    return null;
}

});

parcelRegister("hR2Jv", function(module, exports) {

$parcel$export(module.exports, "truncate", function () { return $cff9819eec32cac6$export$6a506b36fdea397d; });
$parcel$export(module.exports, "snipLine", function () { return $cff9819eec32cac6$export$4215662d762d6f9d; });
$parcel$export(module.exports, "stringMatchesSomePattern", function () { return $cff9819eec32cac6$export$a7a5ec66062ea5d; });

var $dR6t7 = parcelRequire("dR6t7");
/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $cff9819eec32cac6$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== "string" || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $cff9819eec32cac6$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += " {snip}";
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $cff9819eec32cac6$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return "";
    const output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, $dR6t7.isVueViewModel)(value)) output.push("[VueViewModel]");
            else output.push(String(value));
        } catch (e) {
            output.push("[value cannot be serialized]");
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $cff9819eec32cac6$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $dR6t7.isString)(value)) return false;
    if ((0, $dR6t7.isRegExp)(pattern)) return pattern.test(value);
    if ((0, $dR6t7.isString)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $cff9819eec32cac6$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$cff9819eec32cac6$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}

});



parcelRegister("aoBPq", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_ENVIRONMENT", function () { return $79197d3c94d9525b$export$849dbeeeda01ae98; });
const $79197d3c94d9525b$export$849dbeeeda01ae98 = "production";

});

parcelRegister("hsIUf", function(module, exports) {

$parcel$export(module.exports, "Scope", function () { return $cb67e2a65a2980b8$export$775b6bb06e53a214; });
$parcel$export(module.exports, "getGlobalScope", function () { return $cb67e2a65a2980b8$export$aa55d5ab8e05984f; });

var $ggG8j = parcelRequire("ggG8j");
var $dR6t7 = parcelRequire("dR6t7");
var $iyYYs = parcelRequire("iyYYs");
var $dmJ8B = parcelRequire("dmJ8B");

var $8PyS2 = parcelRequire("8PyS2");

var $eZJc1 = parcelRequire("eZJc1");

var $5NPFC = parcelRequire("5NPFC");
/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $cb67e2a65a2980b8$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * The global scope is kept in this module.
 * When accessing this via `getGlobalScope()` we'll make sure to set one if none is currently present.
 */ let $cb67e2a65a2980b8$var$globalScope;
/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */ class $cb67e2a65a2980b8$export$775b6bb06e53a214 {
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called after {@link applyToEvent}. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Extra */ /** Contexts */ /** Attachments */ /** Propagation Context for distributed tracing */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ // eslint-disable-next-line deprecation/deprecation
    /**
   * Transaction Name
   */ /** Span */ /** Session */ /** Request Mode Session Status */ /** The client on this scope */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = $cb67e2a65a2980b8$var$generatePropagationContext();
    }
    /**
   * Inherit values from the parent scope.
   * @deprecated Use `scope.clone()` and `new Scope()` instead.
   */ static clone(scope) {
        return scope ? scope.clone() : new $cb67e2a65a2980b8$export$775b6bb06e53a214();
    }
    /**
   * Clone this scope instance.
   */ clone() {
        const newScope = new $cb67e2a65a2980b8$export$775b6bb06e53a214();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._span = this._span;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._requestSession = this._requestSession;
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        return newScope;
    }
    /** Update the client on the scope. */ setClient(client) {
        this._client = client;
    }
    /**
   * Get the client assigned to this scope.
   *
   * It is generally recommended to use the global function `Sentry.getClient()` instead, unless you know what you are doing.
   */ getClient() {
        return this._client;
    }
    /**
   * Add internal on change listener. Used for sub SDKs that need to store the scope.
   * @hidden
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * @inheritDoc
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * @inheritDoc
   */ setUser(user) {
        // If null is passed we want to unset everything, but still define keys,
        // so that later down in the pipeline any existing values are cleared.
        this._user = user || {
            email: undefined,
            id: undefined,
            ip_address: undefined,
            segment: undefined,
            username: undefined
        };
        if (this._session) (0, $eZJc1.updateSession)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getUser() {
        return this._user;
    }
    /**
   * @inheritDoc
   */ getRequestSession() {
        return this._requestSession;
    }
    /**
   * @inheritDoc
   */ setRequestSession(requestSession) {
        this._requestSession = requestSession;
        return this;
    }
    /**
   * @inheritDoc
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setTag(key, value) {
        this._tags = {
            ...this._tags,
            [key]: value
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setLevel(// eslint-disable-next-line deprecation/deprecation
    level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope for future events.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the Span on the scope.
   * @param span Span
   * @deprecated Instead of setting a span on a scope, use `startSpan()`/`startSpanManual()` instead.
   */ setSpan(span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Returns the `Span` if there is one.
   * @deprecated Use `getActiveSpan()` instead.
   */ getSpan() {
        return this._span;
    }
    /**
   * Returns the `Transaction` attached to the scope (if there is one).
   * @deprecated You should not rely on the transaction, but just use `startSpan()` APIs instead.
   */ getTransaction() {
        // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
        // have a pointer to the currently-active transaction.
        const span = this._span;
        // Cannot replace with getRootSpan because getRootSpan returns a span, not a transaction
        // Also, this method will be removed anyway.
        // eslint-disable-next-line deprecation/deprecation
        return span && span.transaction;
    }
    /**
   * @inheritDoc
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getSession() {
        return this._session;
    }
    /**
   * @inheritDoc
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === "function" ? captureContext(this) : captureContext;
        if (scopeToMerge instanceof $cb67e2a65a2980b8$export$775b6bb06e53a214) {
            const scopeData = scopeToMerge.getScopeData();
            this._tags = {
                ...this._tags,
                ...scopeData.tags
            };
            this._extra = {
                ...this._extra,
                ...scopeData.extra
            };
            this._contexts = {
                ...this._contexts,
                ...scopeData.contexts
            };
            if (scopeData.user && Object.keys(scopeData.user).length) this._user = scopeData.user;
            if (scopeData.level) this._level = scopeData.level;
            if (scopeData.fingerprint.length) this._fingerprint = scopeData.fingerprint;
            if (scopeToMerge.getRequestSession()) this._requestSession = scopeToMerge.getRequestSession();
            if (scopeData.propagationContext) this._propagationContext = scopeData.propagationContext;
        } else if ((0, $dR6t7.isPlainObject)(scopeToMerge)) {
            const scopeContext = captureContext;
            this._tags = {
                ...this._tags,
                ...scopeContext.tags
            };
            this._extra = {
                ...this._extra,
                ...scopeContext.extra
            };
            this._contexts = {
                ...this._contexts,
                ...scopeContext.contexts
            };
            if (scopeContext.user) this._user = scopeContext.user;
            if (scopeContext.level) this._level = scopeContext.level;
            if (scopeContext.fingerprint) this._fingerprint = scopeContext.fingerprint;
            if (scopeContext.requestSession) this._requestSession = scopeContext.requestSession;
            if (scopeContext.propagationContext) this._propagationContext = scopeContext.propagationContext;
        }
        return this;
    }
    /**
   * @inheritDoc
   */ clear() {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._span = undefined;
        this._session = undefined;
        this._notifyScopeListeners();
        this._attachments = [];
        this._propagationContext = $cb67e2a65a2980b8$var$generatePropagationContext();
        return this;
    }
    /**
   * @inheritDoc
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === "number" ? maxBreadcrumbs : $cb67e2a65a2980b8$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $ggG8j.dateTimestampInSeconds)(),
            ...breadcrumb
        };
        const breadcrumbs = this._breadcrumbs;
        breadcrumbs.push(mergedBreadcrumb);
        this._breadcrumbs = breadcrumbs.length > maxCrumbs ? breadcrumbs.slice(-maxCrumbs) : breadcrumbs;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * @inheritDoc
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * @inheritDoc
   * @deprecated Use `getScopeData()` instead.
   */ getAttachments() {
        const data = this.getScopeData();
        return data.attachments;
    }
    /**
   * @inheritDoc
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /** @inheritDoc */ getScopeData() {
        const { _breadcrumbs: _breadcrumbs, _attachments: _attachments, _contexts: _contexts, _tags: _tags, _extra: _extra, _user: _user, _level: _level, _fingerprint: _fingerprint, _eventProcessors: _eventProcessors, _propagationContext: _propagationContext, _sdkProcessingMetadata: _sdkProcessingMetadata, _transactionName: _transactionName, _span: _span } = this;
        return {
            breadcrumbs: _breadcrumbs,
            attachments: _attachments,
            contexts: _contexts,
            tags: _tags,
            extra: _extra,
            user: _user,
            level: _level,
            fingerprint: _fingerprint || [],
            eventProcessors: _eventProcessors,
            propagationContext: _propagationContext,
            sdkProcessingMetadata: _sdkProcessingMetadata,
            transactionName: _transactionName,
            span: _span
        };
    }
    /**
   * Applies data from the scope to the event and runs all event processors on it.
   *
   * @param event Event
   * @param hint Object containing additional information about the original exception, for use by the event processors.
   * @hidden
   * @deprecated Use `applyScopeDataToEvent()` directly
   */ applyToEvent(event, hint = {}, additionalEventProcessors = []) {
        (0, $5NPFC.applyScopeDataToEvent)(event, this.getScopeData());
        // TODO (v8): Update this order to be: Global > Client > Scope
        const eventProcessors = [
            ...additionalEventProcessors,
            // eslint-disable-next-line deprecation/deprecation
            ...(0, $8PyS2.getGlobalEventProcessors)(),
            ...this._eventProcessors
        ];
        return (0, $8PyS2.notifyEventProcessors)(eventProcessors, event, hint);
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata,
            ...newData
        };
        return this;
    }
    /**
   * @inheritDoc
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * @inheritDoc
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @param exception The exception to capture.
   * @param hint Optinal additional data to attach to the Sentry event.
   * @returns the id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $dmJ8B.uuid4)();
        if (!this._client) {
            (0, $iyYYs.logger).warn("No client configured on scope - will not capture exception!");
            return eventId;
        }
        const syntheticException = new Error("Sentry syntheticException");
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @param message The message to capture.
   * @param level An optional severity level to report the message with.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $dmJ8B.uuid4)();
        if (!this._client) {
            (0, $iyYYs.logger).warn("No client configured on scope - will not capture message!");
            return eventId;
        }
        const syntheticException = new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Captures a manually created event for this scope and sends it to Sentry.
   *
   * @param exception The event to capture.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $dmJ8B.uuid4)();
        if (!this._client) {
            (0, $iyYYs.logger).warn("No client configured on scope - will not capture event!");
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function $cb67e2a65a2980b8$export$aa55d5ab8e05984f() {
    if (!$cb67e2a65a2980b8$var$globalScope) $cb67e2a65a2980b8$var$globalScope = new $cb67e2a65a2980b8$export$775b6bb06e53a214();
    return $cb67e2a65a2980b8$var$globalScope;
}
/**
 * This is mainly needed for tests.
 * DO NOT USE this, as this is an internal API and subject to change.
 * @hidden
 */ function $cb67e2a65a2980b8$export$c83048efd17527d6(scope) {
    $cb67e2a65a2980b8$var$globalScope = scope;
}
function $cb67e2a65a2980b8$var$generatePropagationContext() {
    return {
        traceId: (0, $dmJ8B.uuid4)(),
        spanId: (0, $dmJ8B.uuid4)().substring(16)
    };
}

});
parcelRegister("8PyS2", function(module, exports) {

$parcel$export(module.exports, "getGlobalEventProcessors", function () { return $66de22bbb50cea03$export$3c4238858b85e8ac; });
$parcel$export(module.exports, "notifyEventProcessors", function () { return $66de22bbb50cea03$export$bf2a096c3e883e79; });

var $8a8aJ = parcelRequire("8a8aJ");
var $dR6t7 = parcelRequire("dR6t7");
var $iyYYs = parcelRequire("iyYYs");
var $2q9Kw = parcelRequire("2q9Kw");

var $7dwLN = parcelRequire("7dwLN");
/**
 * Returns the global event processors.
 * @deprecated Global event processors will be removed in v8.
 */ function $66de22bbb50cea03$export$3c4238858b85e8ac() {
    return (0, $8a8aJ.getGlobalSingleton)("globalEventProcessors", ()=>[]);
}
/**
 * Add a EventProcessor to be kept globally.
 * @deprecated Use `addEventProcessor` instead. Global event processors will be removed in v8.
 */ function $66de22bbb50cea03$export$8e4e25f54d456511(callback) {
    // eslint-disable-next-line deprecation/deprecation
    $66de22bbb50cea03$export$3c4238858b85e8ac().push(callback);
}
/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */ function $66de22bbb50cea03$export$bf2a096c3e883e79(processors, event, hint, index = 0) {
    return new (0, $2q9Kw.SyncPromise)((resolve, reject)=>{
        const processor = processors[index];
        if (event === null || typeof processor !== "function") resolve(event);
        else {
            const result = processor({
                ...event
            }, hint);
            (0, $7dwLN.DEBUG_BUILD) && processor.id && result === null && (0, $iyYYs.logger).log(`Event processor "${processor.id}" dropped event`);
            if ((0, $dR6t7.isThenable)(result)) result.then((final)=>$66de22bbb50cea03$export$bf2a096c3e883e79(processors, final, hint, index + 1).then(resolve)).then(null, reject);
            else $66de22bbb50cea03$export$bf2a096c3e883e79(processors, result, hint, index + 1).then(resolve).then(null, reject);
        }
    });
}

});
parcelRegister("2q9Kw", function(module, exports) {

$parcel$export(module.exports, "SyncPromise", function () { return $1c35927ad8221cdf$export$6f292d4960313241; });

var $dR6t7 = parcelRequire("dR6t7");
/* eslint-disable @typescript-eslint/explicit-function-return-type */ /** SyncPromise internal states */ var $1c35927ad8221cdf$var$States;
(function(States) {
    /** Pending */ const PENDING = 0;
    States[States["PENDING"] = PENDING] = "PENDING";
    /** Resolved / OK */ const RESOLVED = 1;
    States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
    /** Rejected / Error */ const REJECTED = 2;
    States[States["REJECTED"] = REJECTED] = "REJECTED";
})($1c35927ad8221cdf$var$States || ($1c35927ad8221cdf$var$States = {}));
// Overloads so we can call resolvedSyncPromise without arguments and generic argument
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $1c35927ad8221cdf$export$1fda8aa4d135f8aa(value) {
    return new $1c35927ad8221cdf$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $1c35927ad8221cdf$export$78e43115b553f358(reason) {
    return new $1c35927ad8221cdf$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class $1c35927ad8221cdf$export$6f292d4960313241 {
    constructor(executor){
        $1c35927ad8221cdf$export$6f292d4960313241.prototype.__init.call(this);
        $1c35927ad8221cdf$export$6f292d4960313241.prototype.__init2.call(this);
        $1c35927ad8221cdf$export$6f292d4960313241.prototype.__init3.call(this);
        $1c35927ad8221cdf$export$6f292d4960313241.prototype.__init4.call(this);
        this._state = $1c35927ad8221cdf$var$States.PENDING;
        this._handlers = [];
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ then(onfulfilled, onrejected) {
        return new $1c35927ad8221cdf$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** JSDoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** JSDoc */ finally(onfinally) {
        return new $1c35927ad8221cdf$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** JSDoc */ __init() {
        this._resolve = (value)=>{
            this._setResult($1c35927ad8221cdf$var$States.RESOLVED, value);
        };
    }
    /** JSDoc */ __init2() {
        this._reject = (reason)=>{
            this._setResult($1c35927ad8221cdf$var$States.REJECTED, reason);
        };
    }
    /** JSDoc */ __init3() {
        this._setResult = (state, value)=>{
            if (this._state !== $1c35927ad8221cdf$var$States.PENDING) return;
            if ((0, $dR6t7.isThenable)(value)) {
                value.then(this._resolve, this._reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
    }
    /** JSDoc */ __init4() {
        this._executeHandlers = ()=>{
            if (this._state === $1c35927ad8221cdf$var$States.PENDING) return;
            const cachedHandlers = this._handlers.slice();
            this._handlers = [];
            cachedHandlers.forEach((handler)=>{
                if (handler[0]) return;
                if (this._state === $1c35927ad8221cdf$var$States.RESOLVED) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                handler[1](this._value);
                if (this._state === $1c35927ad8221cdf$var$States.REJECTED) handler[2](this._value);
                handler[0] = true;
            });
        };
    }
}

});


parcelRegister("eZJc1", function(module, exports) {

$parcel$export(module.exports, "makeSession", function () { return $aea9d18a7fca5152$export$14a186326edbb264; });
$parcel$export(module.exports, "updateSession", function () { return $aea9d18a7fca5152$export$531818e825e774db; });
$parcel$export(module.exports, "closeSession", function () { return $aea9d18a7fca5152$export$56521d9ba90f62ee; });

var $9fGKl = parcelRequire("9fGKl");
var $ggG8j = parcelRequire("ggG8j");
var $dmJ8B = parcelRequire("dmJ8B");
/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $aea9d18a7fca5152$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $ggG8j.timestampInSeconds)();
    const session = {
        sid: (0, $dmJ8B.uuid4)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: "ok",
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$aea9d18a7fca5152$var$sessionToJSON(session)
    };
    if (context) $aea9d18a7fca5152$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $aea9d18a7fca5152$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $ggG8j.timestampInSeconds)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $dmJ8B.uuid4)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === "number") session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === "number") session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === "number") session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $aea9d18a7fca5152$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === "ok") context = {
        status: "exited"
    };
    $aea9d18a7fca5152$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $aea9d18a7fca5152$var$sessionToJSON(session) {
    return (0, $9fGKl.dropUndefinedKeys)({
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === "number" || typeof session.did === "string" ? `${session.did}` : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    });
}

});

parcelRegister("5NPFC", function(module, exports) {

$parcel$export(module.exports, "applyScopeDataToEvent", function () { return $01171f6b633de846$export$43988bc651a80216; });
$parcel$export(module.exports, "mergeScopeData", function () { return $01171f6b633de846$export$25ac7e259a513db4; });

var $dmJ8B = parcelRequire("dmJ8B");
var $9fGKl = parcelRequire("9fGKl");

var $kVnKi = parcelRequire("kVnKi");

var $gkl6g = parcelRequire("gkl6g");

var $ceyhT = parcelRequire("ceyhT");
/**
 * Applies data from the scope to the event and runs all event processors on it.
 */ function $01171f6b633de846$export$43988bc651a80216(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    // Apply general data
    $01171f6b633de846$var$applyDataToEvent(event, data);
    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (span) $01171f6b633de846$var$applySpanToEvent(event, span);
    $01171f6b633de846$var$applyFingerprintToEvent(event, fingerprint);
    $01171f6b633de846$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $01171f6b633de846$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
/** Merge data of two scopes together. */ function $01171f6b633de846$export$25ac7e259a513db4(data, mergeData) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: // eslint-disable-next-line deprecation/deprecation
    transactionName, span: span } = mergeData;
    $01171f6b633de846$export$b1a120a2871faa46(data, "extra", extra);
    $01171f6b633de846$export$b1a120a2871faa46(data, "tags", tags);
    $01171f6b633de846$export$b1a120a2871faa46(data, "user", user);
    $01171f6b633de846$export$b1a120a2871faa46(data, "contexts", contexts);
    $01171f6b633de846$export$b1a120a2871faa46(data, "sdkProcessingMetadata", sdkProcessingMetadata);
    if (level) data.level = level;
    if (transactionName) // eslint-disable-next-line deprecation/deprecation
    data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = {
        ...data.propagationContext,
        ...propagationContext
    };
}
/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */ function $01171f6b633de846$export$b1a120a2871faa46(data, prop, mergeVal) {
    if (mergeVal && Object.keys(mergeVal).length) {
        // Clone object
        data[prop] = {
            ...data[prop]
        };
        for(const key in mergeVal)if (Object.prototype.hasOwnProperty.call(mergeVal, key)) data[prop][key] = mergeVal[key];
    }
}
function $01171f6b633de846$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: // eslint-disable-next-line deprecation/deprecation
    transactionName } = data;
    const cleanedExtra = (0, $9fGKl.dropUndefinedKeys)(extra);
    if (cleanedExtra && Object.keys(cleanedExtra).length) event.extra = {
        ...cleanedExtra,
        ...event.extra
    };
    const cleanedTags = (0, $9fGKl.dropUndefinedKeys)(tags);
    if (cleanedTags && Object.keys(cleanedTags).length) event.tags = {
        ...cleanedTags,
        ...event.tags
    };
    const cleanedUser = (0, $9fGKl.dropUndefinedKeys)(user);
    if (cleanedUser && Object.keys(cleanedUser).length) event.user = {
        ...cleanedUser,
        ...event.user
    };
    const cleanedContexts = (0, $9fGKl.dropUndefinedKeys)(contexts);
    if (cleanedContexts && Object.keys(cleanedContexts).length) event.contexts = {
        ...cleanedContexts,
        ...event.contexts
    };
    if (level) event.level = level;
    if (transactionName) event.transaction = transactionName;
}
function $01171f6b633de846$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}
function $01171f6b633de846$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        ...sdkProcessingMetadata
    };
}
function $01171f6b633de846$var$applySpanToEvent(event, span) {
    event.contexts = {
        trace: (0, $ceyhT.spanToTraceContext)(span),
        ...event.contexts
    };
    const rootSpan = (0, $gkl6g.getRootSpan)(span);
    if (rootSpan) {
        event.sdkProcessingMetadata = {
            dynamicSamplingContext: (0, $kVnKi.getDynamicSamplingContextFromSpan)(span),
            ...event.sdkProcessingMetadata
        };
        const transactionName = (0, $ceyhT.spanToJSON)(rootSpan).description;
        if (transactionName) event.tags = {
            transaction: transactionName,
            ...event.tags
        };
    }
}
/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */ function $01171f6b633de846$var$applyFingerprintToEvent(event, fingerprint) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? (0, $dmJ8B.arrayify)(event.fingerprint) : [];
    // If we have something on the scope, then merge it with event
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    // If we have no data at all, remove empty array default
    if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
}

});
parcelRegister("kVnKi", function(module, exports) {

$parcel$export(module.exports, "getDynamicSamplingContextFromClient", function () { return $f3bb8ce7f9bb9772$export$366bad00d6815eed; });
$parcel$export(module.exports, "getDynamicSamplingContextFromSpan", function () { return $f3bb8ce7f9bb9772$export$a117f995597e25df; });

var $9fGKl = parcelRequire("9fGKl");

var $aoBPq = parcelRequire("aoBPq");

var $ejob9 = parcelRequire("ejob9");

var $gkl6g = parcelRequire("gkl6g");

var $ceyhT = parcelRequire("ceyhT");
/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function $f3bb8ce7f9bb9772$export$366bad00d6815eed(trace_id, client, scope) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    // TODO(v8): Remove segment from User
    // eslint-disable-next-line deprecation/deprecation
    const { segment: user_segment } = scope && scope.getUser() || {};
    const dsc = (0, $9fGKl.dropUndefinedKeys)({
        environment: options.environment || (0, $aoBPq.DEFAULT_ENVIRONMENT),
        release: options.release,
        user_segment: user_segment,
        public_key: public_key,
        trace_id: trace_id
    });
    client.emit && client.emit("createDsc", dsc);
    return dsc;
}
/**
 * A Span with a frozen dynamic sampling context.
 */ /**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function $f3bb8ce7f9bb9772$export$a117f995597e25df(span) {
    const client = (0, $ejob9.getClient)();
    if (!client) return {};
    // passing emit=false here to only emit later once the DSC is actually populated
    const dsc = $f3bb8ce7f9bb9772$export$366bad00d6815eed((0, $ceyhT.spanToJSON)(span).trace_id || "", client, (0, $ejob9.getCurrentScope)());
    // TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
    const txn = (0, $gkl6g.getRootSpan)(span);
    if (!txn) return dsc;
    // TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
    // For now we need to avoid breaking users who directly created a txn with a DSC, where this field is still set.
    // @see Transaction class constructor
    const v7FrozenDsc = txn && txn._frozenDynamicSamplingContext;
    if (v7FrozenDsc) return v7FrozenDsc;
    // TODO (v8): Replace txn.metadata with txn.attributes[]
    // We can't do this yet because attributes aren't always set yet.
    // eslint-disable-next-line deprecation/deprecation
    const { sampleRate: maybeSampleRate, source: source } = txn.metadata;
    if (maybeSampleRate != null) dsc.sample_rate = `${maybeSampleRate}`;
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    const jsonSpan = (0, $ceyhT.spanToJSON)(txn);
    // after JSON conversion, txn.name becomes jsonSpan.description
    if (source && source !== "url") dsc.transaction = jsonSpan.description;
    dsc.sampled = String((0, $ceyhT.spanIsSampled)(txn));
    client.emit && client.emit("createDsc", dsc);
    return dsc;
}

});
parcelRegister("ejob9", function(module, exports) {

$parcel$export(module.exports, "withScope", function () { return $a6b5987277dd6140$export$ec58d9285c204497; });
$parcel$export(module.exports, "getCurrentScope", function () { return $a6b5987277dd6140$export$c7be4b0125a10cba; });
$parcel$export(module.exports, "getClient", function () { return $a6b5987277dd6140$export$6bb76d6eba7e258c; });

var $8a8aJ = parcelRequire("8a8aJ");
var $dR6t7 = parcelRequire("dR6t7");
var $iyYYs = parcelRequire("iyYYs");
var $ggG8j = parcelRequire("ggG8j");
var $dmJ8B = parcelRequire("dmJ8B");

var $aoBPq = parcelRequire("aoBPq");

var $7dwLN = parcelRequire("7dwLN");

var $l4UCE = parcelRequire("l4UCE");

var $eZJc1 = parcelRequire("eZJc1");

var $iZeVT = parcelRequire("iZeVT");
/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $a6b5987277dd6140$export$f5282963edea4a68(// eslint-disable-next-line @typescript-eslint/no-explicit-any
exception, hint) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $l4UCE.getCurrentHub)().captureException(exception, (0, $iZeVT.parseEventHintOrCaptureContext)(hint));
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */ function $a6b5987277dd6140$export$45654777c133ae80(message, // eslint-disable-next-line deprecation/deprecation
captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    const level = typeof captureContext === "string" ? captureContext : undefined;
    const context = typeof captureContext !== "string" ? {
        captureContext: captureContext
    } : undefined;
    // eslint-disable-next-line deprecation/deprecation
    return (0, $l4UCE.getCurrentHub)().captureMessage(message, level, context);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param exception The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */ function $a6b5987277dd6140$export$1462b974fdcf6ba2(event, hint) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $l4UCE.getCurrentHub)().captureEvent(event, hint);
}
/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 *
 * @deprecated Use getCurrentScope() directly.
 */ // eslint-disable-next-line deprecation/deprecation
function $a6b5987277dd6140$export$99d44f04437e9cb8(callback) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $l4UCE.getCurrentHub)().configureScope(callback);
}
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */ // eslint-disable-next-line deprecation/deprecation
function $a6b5987277dd6140$export$efda9a273d7a036d(breadcrumb, hint) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $l4UCE.getCurrentHub)().addBreadcrumb(breadcrumb, hint);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, deprecation/deprecation
function $a6b5987277dd6140$export$2f04de43fe27971a(name, context) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $l4UCE.getCurrentHub)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ // eslint-disable-next-line deprecation/deprecation
function $a6b5987277dd6140$export$bb4922da0dd51b92(extras) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $l4UCE.getCurrentHub)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line deprecation/deprecation
function $a6b5987277dd6140$export$8e8e7789d42ed61d(key, extra) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $l4UCE.getCurrentHub)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ // eslint-disable-next-line deprecation/deprecation
function $a6b5987277dd6140$export$74a8fb34822092e6(tags) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $l4UCE.getCurrentHub)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ // eslint-disable-next-line deprecation/deprecation
function $a6b5987277dd6140$export$a37d07ee78eb4569(key, value) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $l4UCE.getCurrentHub)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ // eslint-disable-next-line deprecation/deprecation
function $a6b5987277dd6140$export$8b6bb3dd62a01be2(user) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $l4UCE.getCurrentHub)().setUser(user);
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function $a6b5987277dd6140$export$ec58d9285c204497(...rest) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $l4UCE.getCurrentHub)();
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) // eslint-disable-next-line deprecation/deprecation
        return hub.withScope(callback);
        // eslint-disable-next-line deprecation/deprecation
        return hub.withScope(()=>{
            // eslint-disable-next-line deprecation/deprecation
            hub.getStackTop().scope = scope;
            return callback(scope);
        });
    }
    // eslint-disable-next-line deprecation/deprecation
    return hub.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 *
 * @param callback The callback in which the passed isolation scope is active. (Note: In environments without async
 * context strategy, the currently active isolation scope may change within execution of the callback.)
 * @returns The same value that `callback` returns.
 */ function $a6b5987277dd6140$export$9a4fed82c350c2bd(callback) {
    return (0, $l4UCE.runWithAsyncContext)(()=>{
        return callback((0, $l4UCE.getIsolationScope)());
    });
}
/**
 * Forks the current scope and sets the provided span as active span in the context of the provided callback.
 *
 * @param span Spans started in the context of the provided callback will be children of this span.
 * @param callback Execution context in which the provided span will be active. Is passed the newly forked scope.
 * @returns the value returned from the provided callback function.
 */ function $a6b5987277dd6140$export$e57ac09b143d92a2(span, callback) {
    return $a6b5987277dd6140$export$ec58d9285c204497((scope)=>{
        // eslint-disable-next-line deprecation/deprecation
        scope.setSpan(span);
        return callback(scope);
    });
}
/**
 * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
 *
 * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
 * new child span within the transaction or any span, call the respective `.startChild()` method.
 *
 * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
 *
 * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
 * finished child spans will be sent to Sentry.
 *
 * NOTE: This function should only be used for *manual* instrumentation. Auto-instrumentation should call
 * `startTransaction` directly on the hub.
 *
 * @param context Properties of the new `Transaction`.
 * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
 * default values). See {@link Options.tracesSampler}.
 *
 * @returns The transaction which was just started
 *
 * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
 */ function $a6b5987277dd6140$export$e262da7ae6480481(context, customSamplingContext) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $l4UCE.getCurrentHub)().startTransaction({
        ...context
    }, customSamplingContext);
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $a6b5987277dd6140$export$413528111fbc67c(checkIn, upsertMonitorConfig) {
    const scope = $a6b5987277dd6140$export$c7be4b0125a10cba();
    const client = $a6b5987277dd6140$export$6bb76d6eba7e258c();
    if (!client) (0, $7dwLN.DEBUG_BUILD) && (0, $iyYYs.logger).warn("Cannot capture check-in. No client defined.");
    else if (!client.captureCheckIn) (0, $7dwLN.DEBUG_BUILD) && (0, $iyYYs.logger).warn("Cannot capture check-in. Client does not support sending check-ins.");
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, $dmJ8B.uuid4)();
}
/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $a6b5987277dd6140$export$553526fc5f03c0b1(monitorSlug, callback, upsertMonitorConfig) {
    const checkInId = $a6b5987277dd6140$export$413528111fbc67c({
        monitorSlug: monitorSlug,
        status: "in_progress"
    }, upsertMonitorConfig);
    const now = (0, $ggG8j.timestampInSeconds)();
    function finishCheckIn(status) {
        $a6b5987277dd6140$export$413528111fbc67c({
            monitorSlug: monitorSlug,
            status: status,
            checkInId: checkInId,
            duration: (0, $ggG8j.timestampInSeconds)() - now
        });
    }
    let maybePromiseResult;
    try {
        maybePromiseResult = callback();
    } catch (e) {
        finishCheckIn("error");
        throw e;
    }
    if ((0, $dR6t7.isThenable)(maybePromiseResult)) Promise.resolve(maybePromiseResult).then(()=>{
        finishCheckIn("ok");
    }, ()=>{
        finishCheckIn("error");
    });
    else finishCheckIn("ok");
    return maybePromiseResult;
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $a6b5987277dd6140$export$4909b86c8034bf73(timeout) {
    const client = $a6b5987277dd6140$export$6bb76d6eba7e258c();
    if (client) return client.flush(timeout);
    (0, $7dwLN.DEBUG_BUILD) && (0, $iyYYs.logger).warn("Cannot flush events. No client defined.");
    return Promise.resolve(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $a6b5987277dd6140$export$8360e631d277ea4d(timeout) {
    const client = $a6b5987277dd6140$export$6bb76d6eba7e258c();
    if (client) return client.close(timeout);
    (0, $7dwLN.DEBUG_BUILD) && (0, $iyYYs.logger).warn("Cannot flush events and disable SDK. No client defined.");
    return Promise.resolve(false);
}
/**
 * This is the getter for lastEventId.
 *
 * @returns The last event id of a captured event.
 */ function $a6b5987277dd6140$export$5d4e9fd7fac8e617() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $l4UCE.getCurrentHub)().lastEventId();
}
/**
 * Get the currently active client.
 */ function $a6b5987277dd6140$export$6bb76d6eba7e258c() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $l4UCE.getCurrentHub)().getClient();
}
/**
 * Returns true if Sentry has been properly initialized.
 */ function $a6b5987277dd6140$export$3f95c6f800b78024() {
    return !!$a6b5987277dd6140$export$6bb76d6eba7e258c();
}
/**
 * Get the currently active scope.
 */ function $a6b5987277dd6140$export$c7be4b0125a10cba() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $l4UCE.getCurrentHub)().getScope();
}
/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */ function $a6b5987277dd6140$export$c0d84948cecf78d8(context) {
    const client = $a6b5987277dd6140$export$6bb76d6eba7e258c();
    const isolationScope = (0, $l4UCE.getIsolationScope)();
    const currentScope = $a6b5987277dd6140$export$c7be4b0125a10cba();
    const { release: release, environment: environment = (0, $aoBPq.DEFAULT_ENVIRONMENT) } = client && client.getOptions() || {};
    // Will fetch userAgent if called from browser sdk
    const { userAgent: userAgent } = (0, $8a8aJ.GLOBAL_OBJ).navigator || {};
    const session = (0, $eZJc1.makeSession)({
        release: release,
        environment: environment,
        user: currentScope.getUser() || isolationScope.getUser(),
        ...userAgent && {
            userAgent: userAgent
        },
        ...context
    });
    // End existing session if there's one
    const currentSession = isolationScope.getSession();
    if (currentSession && currentSession.status === "ok") (0, $eZJc1.updateSession)(currentSession, {
        status: "exited"
    });
    $a6b5987277dd6140$export$17a5be43989a0bc1();
    // Afterwards we set the new session on the scope
    isolationScope.setSession(session);
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession(session);
    return session;
}
/**
 * End the session on the current isolation scope.
 */ function $a6b5987277dd6140$export$17a5be43989a0bc1() {
    const isolationScope = (0, $l4UCE.getIsolationScope)();
    const currentScope = $a6b5987277dd6140$export$c7be4b0125a10cba();
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session) (0, $eZJc1.closeSession)(session);
    $a6b5987277dd6140$var$_sendSessionUpdate();
    // the session is over; take it off of the scope
    isolationScope.setSession();
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession();
}
/**
 * Sends the current Session on the scope
 */ function $a6b5987277dd6140$var$_sendSessionUpdate() {
    const isolationScope = (0, $l4UCE.getIsolationScope)();
    const currentScope = $a6b5987277dd6140$export$c7be4b0125a10cba();
    const client = $a6b5987277dd6140$export$6bb76d6eba7e258c();
    // TODO (v8): Remove currentScope and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session && client && client.captureSession) client.captureSession(session);
}
/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */ function $a6b5987277dd6140$export$667e7b4d445d566b(end = false) {
    // both send the update and pull the session from the scope
    if (end) {
        $a6b5987277dd6140$export$17a5be43989a0bc1();
        return;
    }
    // only send the update
    $a6b5987277dd6140$var$_sendSessionUpdate();
}

});
parcelRegister("iZeVT", function(module, exports) {

$parcel$export(module.exports, "parseEventHintOrCaptureContext", function () { return $dd2981d9a7ce67ae$export$76b5f966996d1653; });

var $dmJ8B = parcelRequire("dmJ8B");
var $ggG8j = parcelRequire("ggG8j");
var $8a8aJ = parcelRequire("8a8aJ");
var $l7pai = parcelRequire("l7pai");
var $hR2Jv = parcelRequire("hR2Jv");

var $aoBPq = parcelRequire("aoBPq");

var $8PyS2 = parcelRequire("8PyS2");

var $hsIUf = parcelRequire("hsIUf");

var $5NPFC = parcelRequire("5NPFC");

var $ceyhT = parcelRequire("ceyhT");
/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */ /**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * Note: This also triggers callbacks for `addGlobalEventProcessor`, but not `beforeSend`.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function $dd2981d9a7ce67ae$export$2d67fb380bd11267(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || (0, $dmJ8B.uuid4)(),
        timestamp: event.timestamp || (0, $ggG8j.dateTimestampInSeconds)()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $dd2981d9a7ce67ae$var$applyClientOptions(prepared, options);
    $dd2981d9a7ce67ae$var$applyIntegrationsMetadata(prepared, integrations);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) $dd2981d9a7ce67ae$export$63042efc86f043e7(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    const finalScope = $dd2981d9a7ce67ae$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) (0, $dmJ8B.addExceptionMechanism)(prepared, hint.mechanism);
    const clientEventProcessors = client && client.getEventProcessors ? client.getEventProcessors() : [];
    // This should be the last thing called, since we want that
    // {@link Hub.addEventProcessor} gets the finished prepared event.
    // Merge scope data together
    const data = (0, $hsIUf.getGlobalScope)().getScopeData();
    if (isolationScope) {
        const isolationData = isolationScope.getScopeData();
        (0, $5NPFC.mergeScopeData)(data, isolationData);
    }
    if (finalScope) {
        const finalScopeData = finalScope.getScopeData();
        (0, $5NPFC.mergeScopeData)(data, finalScopeData);
    }
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    (0, $5NPFC.applyScopeDataToEvent)(prepared, data);
    // TODO (v8): Update this order to be: Global > Client > Scope
    const eventProcessors = [
        ...clientEventProcessors,
        // eslint-disable-next-line deprecation/deprecation
        ...(0, $8PyS2.getGlobalEventProcessors)(),
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    const result = (0, $8PyS2.notifyEventProcessors)(eventProcessors, prepared, hint);
    return result.then((evt)=>{
        if (evt) // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
        // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
        // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
        // any new data
        $dd2981d9a7ce67ae$export$1be657ba8ef44ff0(evt);
        if (typeof normalizeDepth === "number" && normalizeDepth > 0) return $dd2981d9a7ce67ae$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 *  Enhances event using the client configuration.
 *  It takes care of all "static" values like environment, release and `dist`,
 *  as well as truncating overly long values.
 * @param event event instance to be enhanced
 */ function $dd2981d9a7ce67ae$var$applyClientOptions(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength = 250 } = options;
    if (!("environment" in event)) event.environment = "environment" in options ? environment : (0, $aoBPq.DEFAULT_ENVIRONMENT);
    if (event.release === undefined && release !== undefined) event.release = release;
    if (event.dist === undefined && dist !== undefined) event.dist = dist;
    if (event.message) event.message = (0, $hR2Jv.truncate)(event.message, maxValueLength);
    const exception = event.exception && event.exception.values && event.exception.values[0];
    if (exception && exception.value) exception.value = (0, $hR2Jv.truncate)(exception.value, maxValueLength);
    const request = event.request;
    if (request && request.url) request.url = (0, $hR2Jv.truncate)(request.url, maxValueLength);
}
const $dd2981d9a7ce67ae$var$debugIdStackParserCache = new WeakMap();
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function $dd2981d9a7ce67ae$export$63042efc86f043e7(event, stackParser) {
    const debugIdMap = (0, $8a8aJ.GLOBAL_OBJ)._sentryDebugIds;
    if (!debugIdMap) return;
    let debugIdStackFramesCache;
    const cachedDebugIdStackFrameCache = $dd2981d9a7ce67ae$var$debugIdStackParserCache.get(stackParser);
    if (cachedDebugIdStackFrameCache) debugIdStackFramesCache = cachedDebugIdStackFrameCache;
    else {
        debugIdStackFramesCache = new Map();
        $dd2981d9a7ce67ae$var$debugIdStackParserCache.set(stackParser, debugIdStackFramesCache);
    }
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = Object.keys(debugIdMap).reduce((acc, debugIdStackTrace)=>{
        let parsedStack;
        const cachedParsedStack = debugIdStackFramesCache.get(debugIdStackTrace);
        if (cachedParsedStack) parsedStack = cachedParsedStack;
        else {
            parsedStack = stackParser(debugIdStackTrace);
            debugIdStackFramesCache.set(debugIdStackTrace, parsedStack);
        }
        for(let i = parsedStack.length - 1; i >= 0; i--){
            const stackFrame = parsedStack[i];
            if (stackFrame.filename) {
                acc[stackFrame.filename] = debugIdMap[debugIdStackTrace];
                break;
            }
        }
        return acc;
    }, {});
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function $dd2981d9a7ce67ae$export$1be657ba8ef44ff0(event) {
    // Extract debug IDs and filenames from the stack frames on the event.
    const filenameDebugIdMap = {};
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.debug_id) {
                    if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                    else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                    delete frame.debug_id;
                }
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.keys(filenameDebugIdMap).forEach((filename)=>{
        images.push({
            type: "sourcemap",
            code_file: filename,
            debug_id: filenameDebugIdMap[filename]
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function $dd2981d9a7ce67ae$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function $dd2981d9a7ce67ae$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: (0, $l7pai.normalize)(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: (0, $l7pai.normalize)(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: (0, $l7pai.normalize)(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: (0, $l7pai.normalize)(event.extra, depth, maxBreadth)
        }
    };
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts && event.contexts.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $l7pai.normalize)(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        const data = (0, $ceyhT.spanToJSON)(span).data;
        if (data) // This is a bit weird, as we generally have `Span` instances here, but to be safe we do not assume so
        // eslint-disable-next-line deprecation/deprecation
        span.data = (0, $l7pai.normalize)(data, depth, maxBreadth);
        return span;
    });
    return normalized;
}
function $dd2981d9a7ce67ae$var$getFinalScope(scope, captureContext) {
    if (!captureContext) return scope;
    const finalScope = scope ? scope.clone() : new (0, $hsIUf.Scope)();
    finalScope.update(captureContext);
    return finalScope;
}
/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */ function $dd2981d9a7ce67ae$export$76b5f966996d1653(hint) {
    if (!hint) return undefined;
    // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
    if ($dd2981d9a7ce67ae$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($dd2981d9a7ce67ae$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $dd2981d9a7ce67ae$var$hintIsScopeOrFunction(hint) {
    return hint instanceof (0, $hsIUf.Scope) || typeof hint === "function";
}
const $dd2981d9a7ce67ae$var$captureContextKeys = [
    "user",
    "level",
    "extra",
    "contexts",
    "tags",
    "fingerprint",
    "requestSession",
    "propagationContext"
];
function $dd2981d9a7ce67ae$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$dd2981d9a7ce67ae$var$captureContextKeys.includes(key));
}

});
parcelRegister("l7pai", function(module, exports) {

$parcel$export(module.exports, "normalize", function () { return $f5fdc5aa015559b3$export$a3295358bff77e; });

var $dR6t7 = parcelRequire("dR6t7");

var $4KTSL = parcelRequire("4KTSL");

var $9fGKl = parcelRequire("9fGKl");

var $hu8ps = parcelRequire("hu8ps");
/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normallized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $f5fdc5aa015559b3$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $f5fdc5aa015559b3$export$588732934346abbf("", input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $f5fdc5aa015559b3$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $f5fdc5aa015559b3$export$a3295358bff77e(object, depth);
    if ($f5fdc5aa015559b3$var$jsonSize(normalized) > maxSize) return $f5fdc5aa015559b3$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $f5fdc5aa015559b3$export$588732934346abbf(key, value, depth = Infinity, maxProperties = Infinity, memo = (0, $4KTSL.memoBuilder)()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        "number",
        "boolean",
        "string"
    ].includes(typeof value) && !(0, $dR6t7.isNaN)(value)) return value;
    const stringified = $f5fdc5aa015559b3$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith("[object ")) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value["__sentry_skip_normalization__"]) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    const remainingDepth = typeof value["__sentry_override_normalization_depth__"] === "number" ? value["__sentry_override_normalization_depth__"] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace("object ", "");
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return "[Circular ~]";
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === "function") try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $f5fdc5aa015559b3$export$588732934346abbf("", jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, $9fGKl.convertToPlainObject)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = "[MaxProperties ~]";
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $f5fdc5aa015559b3$export$588732934346abbf(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $f5fdc5aa015559b3$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === "domain" && value && typeof value === "object" && value._events) return "[Domain]";
        if (key === "domainEmitter") return "[DomainEmitter]";
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== "undefined" && value === $parcel$global) return "[Global]";
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== "undefined" && value === window) return "[Window]";
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== "undefined" && value === document) return "[Document]";
        if ((0, $dR6t7.isVueViewModel)(value)) return "[VueViewModel]";
        // React's SyntheticEvent thingy
        if ((0, $dR6t7.isSyntheticEvent)(value)) return "[SyntheticEvent]";
        if (typeof value === "number" && value !== value) return "[NaN]";
        if (typeof value === "function") return `[Function: ${(0, $hu8ps.getFunctionName)(value)}]`;
        if (typeof value === "symbol") return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === "bigint") return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        const objName = $f5fdc5aa015559b3$var$getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function $f5fdc5aa015559b3$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype ? prototype.constructor.name : "null prototype";
}
/** Calculates bytes size of input string */ function $f5fdc5aa015559b3$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $f5fdc5aa015559b3$var$jsonSize(value) {
    return $f5fdc5aa015559b3$var$utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function $f5fdc5aa015559b3$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath// Backslash to forward
    .replace(/\\/g, "/")// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, "\\$&");
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch (_Oo) {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, "/").replace(/webpack:\/?/g, "") // Remove intermediate base path
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor
    .replace(new RegExp(`(file://)?/*${escapedBase}/*`, "ig"), "app:///");
}

});
parcelRegister("4KTSL", function(module, exports) {

$parcel$export(module.exports, "memoBuilder", function () { return $3766ce5d2eb5eaa3$export$8115b0b78e956ab3; });
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ function $3766ce5d2eb5eaa3$export$8115b0b78e956ab3() {
    const hasWeakSet = typeof WeakSet === "function";
    const inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(let i = 0; i < inner.length; i++){
            const value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(let i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}

});

parcelRegister("hu8ps", function(module, exports) {

$parcel$export(module.exports, "getFunctionName", function () { return $cbabc2fb42648373$export$aad197c7121a6651; });

var $1YfH5 = parcelRequire("1YfH5");
const $cbabc2fb42648373$var$STACKTRACE_FRAME_LIMIT = 50;
// Used to sanitize webpack (error: *) wrapped stack errors
const $cbabc2fb42648373$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $cbabc2fb42648373$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $cbabc2fb42648373$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirst = 0)=>{
        const frames = [];
        const lines = stack.split("\n");
        for(let i = skipFirst; i < lines.length; i++){
            const line = lines[i];
            // Ignore lines over 1kb as they are unlikely to be stack frames.
            // Many of the regular expressions use backtracking which results in run time that increases exponentially with
            // input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) continue;
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $cbabc2fb42648373$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($cbabc2fb42648373$var$WEBPACK_ERROR_REGEXP, "$1") : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $cbabc2fb42648373$var$STACKTRACE_FRAME_LIMIT) break;
        }
        return $cbabc2fb42648373$export$c55c24c0eeba0205(frames);
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $cbabc2fb42648373$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $cbabc2fb42648373$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $cbabc2fb42648373$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test(localStack[localStack.length - 1].function || "")) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($cbabc2fb42648373$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || "")) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the hub itself, making it:
        //
        //   Sentry.captureException()
        //   getCurrentHub().captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($cbabc2fb42648373$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || "")) localStack.pop();
    }
    return localStack.slice(0, $cbabc2fb42648373$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || localStack[localStack.length - 1].filename,
            function: frame.function || "?"
        }));
}
const $cbabc2fb42648373$var$defaultFunctionName = "<anonymous>";
/**
 * Safely extract function name from itself
 */ function $cbabc2fb42648373$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== "function") return $cbabc2fb42648373$var$defaultFunctionName;
        return fn.name || $cbabc2fb42648373$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $cbabc2fb42648373$var$defaultFunctionName;
    }
}
/**
 * Node.js stack line parser
 *
 * This is in @sentry/utils so it can be used from the Electron SDK in the browser for when `nodeIntegration == true`.
 * This allows it to be used without referencing or importing any node specific code which causes bundlers to complain
 */ function $cbabc2fb42648373$export$673345a0da635a78(getModule) {
    return [
        90,
        (0, $1YfH5.node)(getModule)
    ];
}

});
parcelRegister("1YfH5", function(module, exports) {

$parcel$export(module.exports, "node", function () { return $16f79187b4ab4cf6$export$35059013cd4a06db; });
/**
 * Does this filename look like it's part of the app code?
 */ function $16f79187b4ab4cf6$export$1de92f38f4de99a8(filename, isNative = false) {
    const isInternal = isNative || filename && // It's not internal if it's an absolute linux path
    !filename.startsWith("/") && // It's not internal if it's an absolute windows path
    !filename.match(/^[A-Z]:/) && // It's not internal if the path is starting with a dot
    !filename.startsWith(".") && // It's not internal if the frame has a protocol. In node, this is usually the case if the file got pre-processed with a bundler like webpack
    !filename.match(/^[a-zA-Z]([a-zA-Z0-9.\-+])*:\/\//); // Schema from: https://stackoverflow.com/a/3641782
    // in_app is all that's not an internal Node function or a module within node_modules
    // note that isNative appears to return true even for node core libraries
    // see https://github.com/getsentry/raven-node/issues/176
    return !isInternal && filename !== undefined && !filename.includes("node_modules/");
}
/** Node Stack line parser */ // eslint-disable-next-line complexity
function $16f79187b4ab4cf6$export$35059013cd4a06db(getModule) {
    const FILENAME_MATCH = /^\s*[-]{4,}$/;
    const FULL_MATCH = /at (?:async )?(?:(.+?)\s+\()?(?:(.+):(\d+):(\d+)?|([^)]+))\)?/;
    // eslint-disable-next-line complexity
    return (line)=>{
        const lineMatch = line.match(FULL_MATCH);
        if (lineMatch) {
            let object;
            let method;
            let functionName;
            let typeName;
            let methodName;
            if (lineMatch[1]) {
                functionName = lineMatch[1];
                let methodStart = functionName.lastIndexOf(".");
                if (functionName[methodStart - 1] === ".") methodStart--;
                if (methodStart > 0) {
                    object = functionName.slice(0, methodStart);
                    method = functionName.slice(methodStart + 1);
                    const objectEnd = object.indexOf(".Module");
                    if (objectEnd > 0) {
                        functionName = functionName.slice(objectEnd + 1);
                        object = object.slice(0, objectEnd);
                    }
                }
                typeName = undefined;
            }
            if (method) {
                typeName = object;
                methodName = method;
            }
            if (method === "<anonymous>") {
                methodName = undefined;
                functionName = undefined;
            }
            if (functionName === undefined) {
                methodName = methodName || "<anonymous>";
                functionName = typeName ? `${typeName}.${methodName}` : methodName;
            }
            let filename = lineMatch[2] && lineMatch[2].startsWith("file://") ? lineMatch[2].slice(7) : lineMatch[2];
            const isNative = lineMatch[5] === "native";
            // If it's a Windows path, trim the leading slash so that `/C:/foo` becomes `C:/foo`
            if (filename && filename.match(/\/[A-Z]:/)) filename = filename.slice(1);
            if (!filename && lineMatch[5] && !isNative) filename = lineMatch[5];
            return {
                filename: filename,
                module: getModule ? getModule(filename) : undefined,
                function: functionName,
                lineno: parseInt(lineMatch[3], 10) || undefined,
                colno: parseInt(lineMatch[4], 10) || undefined,
                in_app: $16f79187b4ab4cf6$export$1de92f38f4de99a8(filename, isNative)
            };
        }
        if (line.match(FILENAME_MATCH)) return {
            filename: line
        };
        return undefined;
    };
}

});



parcelRegister("ceyhT", function(module, exports) {

$parcel$export(module.exports, "TRACE_FLAG_NONE", function () { return $8e81639f7548410f$export$208d5b368507fb8b; });
$parcel$export(module.exports, "TRACE_FLAG_SAMPLED", function () { return $8e81639f7548410f$export$eb571cd9b5d98de8; });
$parcel$export(module.exports, "spanToTraceContext", function () { return $8e81639f7548410f$export$46c6fbd1d265ebf0; });
$parcel$export(module.exports, "spanToJSON", function () { return $8e81639f7548410f$export$92d8c23565496537; });
$parcel$export(module.exports, "spanToTraceHeader", function () { return $8e81639f7548410f$export$7e9f8ae9e4a328ab; });
$parcel$export(module.exports, "spanIsSampled", function () { return $8e81639f7548410f$export$5caecac1caaf3a71; });
$parcel$export(module.exports, "spanTimeInputToSeconds", function () { return $8e81639f7548410f$export$3f7581298f56c6d7; });

var $9fGKl = parcelRequire("9fGKl");
var $dGzPN = parcelRequire("dGzPN");
var $ggG8j = parcelRequire("ggG8j");
// These are aligned with OpenTelemetry trace flags
const $8e81639f7548410f$export$208d5b368507fb8b = 0x0;
const $8e81639f7548410f$export$eb571cd9b5d98de8 = 0x1;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 */ function $8e81639f7548410f$export$46c6fbd1d265ebf0(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, tags: tags, origin: origin } = $8e81639f7548410f$export$92d8c23565496537(span);
    return (0, $9fGKl.dropUndefinedKeys)({
        data: data,
        op: op,
        parent_span_id: parent_span_id,
        span_id: span_id,
        status: status,
        tags: tags,
        trace_id: trace_id,
        origin: origin
    });
}
/**
 * Convert a Span to a Sentry trace header.
 */ function $8e81639f7548410f$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $8e81639f7548410f$export$5caecac1caaf3a71(span);
    return (0, $dGzPN.generateSentryTraceHeader)(traceId, spanId, sampled);
}
/**
 * Convert a span time input intp a timestamp in seconds.
 */ function $8e81639f7548410f$export$3f7581298f56c6d7(input) {
    if (typeof input === "number") return $8e81639f7548410f$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $8e81639f7548410f$var$ensureTimestampInSeconds(input.getTime());
    return (0, $ggG8j.timestampInSeconds)();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function $8e81639f7548410f$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 * Note that all fields returned here are optional and need to be guarded against.
 *
 * Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
 * This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
 * And `spanToJSON` needs the Span class from `span.ts` to check here.
 * TODO v8: When we remove the deprecated stuff from `span.ts`, we can remove the circular dependency again.
 */ function $8e81639f7548410f$export$92d8c23565496537(span) {
    if ($8e81639f7548410f$var$spanIsSpanClass(span)) return span.getSpanJSON();
    // Fallback: We also check for `.toJSON()` here...
    // eslint-disable-next-line deprecation/deprecation
    if (typeof span.toJSON === "function") // eslint-disable-next-line deprecation/deprecation
    return span.toJSON();
    return {};
}
/**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function $8e81639f7548410f$var$spanIsSpanClass(span) {
    return typeof span.getSpanJSON === "function";
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function $8e81639f7548410f$export$5caecac1caaf3a71(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    const { traceFlags: traceFlags } = span.spanContext();
    // eslint-disable-next-line no-bitwise
    return Boolean(traceFlags & $8e81639f7548410f$export$eb571cd9b5d98de8);
}

});
parcelRegister("dGzPN", function(module, exports) {

$parcel$export(module.exports, "TRACEPARENT_REGEXP", function () { return $02923de99dd6e1ed$export$394a210812ba3012; });
$parcel$export(module.exports, "extractTraceparentData", function () { return $02923de99dd6e1ed$export$8e9a29865c0a1226; });
$parcel$export(module.exports, "tracingContextFromHeaders", function () { return $02923de99dd6e1ed$export$ca5c066532785b6e; });
$parcel$export(module.exports, "propagationContextFromHeaders", function () { return $02923de99dd6e1ed$export$261f383d16a93e39; });
$parcel$export(module.exports, "generateSentryTraceHeader", function () { return $02923de99dd6e1ed$export$f35d907436da45cf; });

var $9evQX = parcelRequire("9evQX");

var $dmJ8B = parcelRequire("dmJ8B");
// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- RegExp is used for readability here
const $02923de99dd6e1ed$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $02923de99dd6e1ed$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return undefined;
    const matches = traceparent.match($02923de99dd6e1ed$export$394a210812ba3012);
    if (!matches) return undefined;
    let parentSampled;
    if (matches[3] === "1") parentSampled = true;
    else if (matches[3] === "0") parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create tracing context from incoming headers.
 *
 * @deprecated Use `propagationContextFromHeaders` instead.
 */ // TODO(v8): Remove this function
function $02923de99dd6e1ed$export$ca5c066532785b6e(sentryTrace, baggage) {
    const traceparentData = $02923de99dd6e1ed$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $9evQX.baggageHeaderToDynamicSamplingContext)(baggage);
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData || {};
    if (!traceparentData) return {
        traceparentData: traceparentData,
        dynamicSamplingContext: undefined,
        propagationContext: {
            traceId: traceId || (0, $dmJ8B.uuid4)(),
            spanId: (0, $dmJ8B.uuid4)().substring(16)
        }
    };
    else return {
        traceparentData: traceparentData,
        dynamicSamplingContext: dynamicSamplingContext || {},
        propagationContext: {
            traceId: traceId || (0, $dmJ8B.uuid4)(),
            parentSpanId: parentSpanId || (0, $dmJ8B.uuid4)().substring(16),
            spanId: (0, $dmJ8B.uuid4)().substring(16),
            sampled: parentSampled,
            dsc: dynamicSamplingContext || {}
        }
    };
}
/**
 * Create a propagation context from incoming headers.
 */ function $02923de99dd6e1ed$export$261f383d16a93e39(sentryTrace, baggage) {
    const traceparentData = $02923de99dd6e1ed$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $9evQX.baggageHeaderToDynamicSamplingContext)(baggage);
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData || {};
    if (!traceparentData) return {
        traceId: traceId || (0, $dmJ8B.uuid4)(),
        spanId: (0, $dmJ8B.uuid4)().substring(16)
    };
    else return {
        traceId: traceId || (0, $dmJ8B.uuid4)(),
        parentSpanId: parentSpanId || (0, $dmJ8B.uuid4)().substring(16),
        spanId: (0, $dmJ8B.uuid4)().substring(16),
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {}
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function $02923de99dd6e1ed$export$f35d907436da45cf(traceId = (0, $dmJ8B.uuid4)(), spanId = (0, $dmJ8B.uuid4)().substring(16), sampled) {
    let sampledString = "";
    if (sampled !== undefined) sampledString = sampled ? "-1" : "-0";
    return `${traceId}-${spanId}${sampledString}`;
}

});
parcelRegister("9evQX", function(module, exports) {

$parcel$export(module.exports, "BAGGAGE_HEADER_NAME", function () { return $6b8e213e909ebfcc$export$9ca9946bd449ac06; });
$parcel$export(module.exports, "baggageHeaderToDynamicSamplingContext", function () { return $6b8e213e909ebfcc$export$5b96ee2c8421f107; });
$parcel$export(module.exports, "dynamicSamplingContextToSentryBaggageHeader", function () { return $6b8e213e909ebfcc$export$56766feef403f365; });

var $5rgwG = parcelRequire("5rgwG");

var $dR6t7 = parcelRequire("dR6t7");

var $iyYYs = parcelRequire("iyYYs");
const $6b8e213e909ebfcc$export$9ca9946bd449ac06 = "baggage";
const $6b8e213e909ebfcc$export$6e69537d67fa20f = "sentry-";
const $6b8e213e909ebfcc$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const $6b8e213e909ebfcc$export$bdd844ddb2def819 = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $6b8e213e909ebfcc$export$5b96ee2c8421f107(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    if (!(0, $dR6t7.isString)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    // Intermediary object to store baggage key value pairs of incoming baggage headers on.
    // It is later used to read Sentry-DSC-values from.
    let baggageObject = {};
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    baggageObject = baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $6b8e213e909ebfcc$var$baggageHeaderToObject(curr);
        for (const key of Object.keys(currBaggageObject))acc[key] = currBaggageObject[key];
        return acc;
    }, {});
    else {
        // Return undefined if baggage header is an empty string (technically an empty baggage header is not spec conform but
        // this is how we choose to handle it)
        if (!baggageHeader) return undefined;
        baggageObject = $6b8e213e909ebfcc$var$baggageHeaderToObject(baggageHeader);
    }
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.match($6b8e213e909ebfcc$export$eb0401070c617ea5)) {
            const nonPrefixedKey = key.slice($6b8e213e909ebfcc$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $6b8e213e909ebfcc$export$56766feef403f365(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$6b8e213e909ebfcc$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $6b8e213e909ebfcc$var$objectToBaggageHeader(sentryPrefixedDSC);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $6b8e213e909ebfcc$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(",").map((baggageEntry)=>baggageEntry.split("=").map((keyOrValue)=>decodeURIComponent(keyOrValue.trim()))).reduce((acc, [key, value])=>{
        acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $6b8e213e909ebfcc$var$objectToBaggageHeader(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $6b8e213e909ebfcc$export$bdd844ddb2def819) {
            (0, $5rgwG.DEBUG_BUILD) && (0, $iyYYs.logger).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, "");
}

});





parcelRegister("gkl6g", function(module, exports) {

$parcel$export(module.exports, "getRootSpan", function () { return $031145b43b23fe38$export$c4c6a79b1260ca1b; });
/**
 * Returns the root span of a given span.
 *
 * As long as we use `Transaction`s internally, the returned root span
 * will be a `Transaction` but be aware that this might change in the future.
 *
 * If the given span has no root span or transaction, `undefined` is returned.
 */ function $031145b43b23fe38$export$c4c6a79b1260ca1b(span) {
    // TODO (v8): Remove this check and just return span
    // eslint-disable-next-line deprecation/deprecation
    return span.transaction;
}

});




parcelRegister("3uCDJ", function(module, exports) {

$parcel$export(module.exports, "SDK_VERSION", function () { return $28b22582ae7de11b$export$31499a9cd224b78c; });
const $28b22582ae7de11b$export$31499a9cd224b78c = "7.120.3";

});


parcelRegister("2zeDR", function(module, exports) {

$parcel$export(module.exports, "registerErrorInstrumentation", function () { return $1dea353d1cb9306c$export$637857c1d87b640c; });

var $jNmGS = parcelRequire("jNmGS");
var $b8GNw = parcelRequire("b8GNw");
var $iyYYs = parcelRequire("iyYYs");

var $7dwLN = parcelRequire("7dwLN");

var $4kgMm = parcelRequire("4kgMm");
let $1dea353d1cb9306c$var$errorsInstrumented = false;
/**
 * Configures global error listeners
 */ function $1dea353d1cb9306c$export$637857c1d87b640c() {
    if ($1dea353d1cb9306c$var$errorsInstrumented) return;
    $1dea353d1cb9306c$var$errorsInstrumented = true;
    (0, $jNmGS.addGlobalErrorInstrumentationHandler)($1dea353d1cb9306c$var$errorCallback);
    (0, $b8GNw.addGlobalUnhandledRejectionInstrumentationHandler)($1dea353d1cb9306c$var$errorCallback);
}
/**
 * If an error or unhandled promise occurs, we mark the active transaction as failed
 */ function $1dea353d1cb9306c$var$errorCallback() {
    // eslint-disable-next-line deprecation/deprecation
    const activeTransaction = (0, $4kgMm.getActiveTransaction)();
    if (activeTransaction) {
        const status = "internal_error";
        (0, $7dwLN.DEBUG_BUILD) && (0, $iyYYs.logger).log(`[Tracing] Transaction: ${status} -> Global error occured`);
        activeTransaction.setStatus(status);
    }
}
// The function name will be lost when bundling but we need to be able to identify this listener later to maintain the
// node.js default exit behaviour
$1dea353d1cb9306c$var$errorCallback.tag = "sentry_tracingErrorCallback";

});
parcelRegister("jNmGS", function(module, exports) {

$parcel$export(module.exports, "addGlobalErrorInstrumentationHandler", function () { return $e69431cf32219a06$export$55b5c3ba2194f0c6; });

var $8a8aJ = parcelRequire("8a8aJ");

var $hw7uQ = parcelRequire("hw7uQ");
let $e69431cf32219a06$var$_oldOnErrorHandler = null;
/**
 * Add an instrumentation handler for when an error is captured by the global error handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $e69431cf32219a06$export$55b5c3ba2194f0c6(handler) {
    const type = "error";
    (0, $hw7uQ.addHandler)(type, handler);
    (0, $hw7uQ.maybeInstrument)(type, $e69431cf32219a06$var$instrumentError);
}
function $e69431cf32219a06$var$instrumentError() {
    $e69431cf32219a06$var$_oldOnErrorHandler = (0, $8a8aJ.GLOBAL_OBJ).onerror;
    (0, $8a8aJ.GLOBAL_OBJ).onerror = function(msg, url, line, column, error) {
        const handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        (0, $hw7uQ.triggerHandlers)("error", handlerData);
        if ($e69431cf32219a06$var$_oldOnErrorHandler && !$e69431cf32219a06$var$_oldOnErrorHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $e69431cf32219a06$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    (0, $8a8aJ.GLOBAL_OBJ).onerror.__SENTRY_INSTRUMENTED__ = true;
}

});
parcelRegister("hw7uQ", function(module, exports) {

$parcel$export(module.exports, "addHandler", function () { return $cc0b3d7f80d805df$export$a4e09611e30da72e; });
$parcel$export(module.exports, "maybeInstrument", function () { return $cc0b3d7f80d805df$export$e18d6c5462c01368; });
$parcel$export(module.exports, "triggerHandlers", function () { return $cc0b3d7f80d805df$export$b18c893e424d3127; });

var $5rgwG = parcelRequire("5rgwG");

var $iyYYs = parcelRequire("iyYYs");

var $hu8ps = parcelRequire("hu8ps");
// We keep the handlers globally
const $cc0b3d7f80d805df$var$handlers = {};
const $cc0b3d7f80d805df$var$instrumented = {};
/** Add a handler function. */ function $cc0b3d7f80d805df$export$a4e09611e30da72e(type, handler) {
    $cc0b3d7f80d805df$var$handlers[type] = $cc0b3d7f80d805df$var$handlers[type] || [];
    $cc0b3d7f80d805df$var$handlers[type].push(handler);
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function $cc0b3d7f80d805df$export$b17eab759a1cb5fe() {
    Object.keys($cc0b3d7f80d805df$var$handlers).forEach((key)=>{
        $cc0b3d7f80d805df$var$handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function $cc0b3d7f80d805df$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$cc0b3d7f80d805df$var$instrumented[type]) {
        instrumentFn();
        $cc0b3d7f80d805df$var$instrumented[type] = true;
    }
}
/** Trigger handlers for a given instrumentation type. */ function $cc0b3d7f80d805df$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $cc0b3d7f80d805df$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $5rgwG.DEBUG_BUILD) && (0, $iyYYs.logger).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $hu8ps.getFunctionName)(handler)}\nError:`, e);
    }
}

});


parcelRegister("b8GNw", function(module, exports) {

$parcel$export(module.exports, "addGlobalUnhandledRejectionInstrumentationHandler", function () { return $81c1a3d41f75b90a$export$8bf4fc6858821a4e; });

var $8a8aJ = parcelRequire("8a8aJ");

var $hw7uQ = parcelRequire("hw7uQ");
let $81c1a3d41f75b90a$var$_oldOnUnhandledRejectionHandler = null;
/**
 * Add an instrumentation handler for when an unhandled promise rejection is captured.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $81c1a3d41f75b90a$export$8bf4fc6858821a4e(handler) {
    const type = "unhandledrejection";
    (0, $hw7uQ.addHandler)(type, handler);
    (0, $hw7uQ.maybeInstrument)(type, $81c1a3d41f75b90a$var$instrumentUnhandledRejection);
}
function $81c1a3d41f75b90a$var$instrumentUnhandledRejection() {
    $81c1a3d41f75b90a$var$_oldOnUnhandledRejectionHandler = (0, $8a8aJ.GLOBAL_OBJ).onunhandledrejection;
    (0, $8a8aJ.GLOBAL_OBJ).onunhandledrejection = function(e) {
        const handlerData = e;
        (0, $hw7uQ.triggerHandlers)("unhandledrejection", handlerData);
        if ($81c1a3d41f75b90a$var$_oldOnUnhandledRejectionHandler && !$81c1a3d41f75b90a$var$_oldOnUnhandledRejectionHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $81c1a3d41f75b90a$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    (0, $8a8aJ.GLOBAL_OBJ).onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}

});

parcelRegister("4kgMm", function(module, exports) {

$parcel$export(module.exports, "getActiveTransaction", function () { return $32660ba860961e05$export$a7feb32fdd923295; });
$parcel$export(module.exports, "extractTraceparentData", function () { return $32660ba860961e05$export$8e9a29865c0a1226; });

var $dGzPN = parcelRequire("dGzPN");

var $l4UCE = parcelRequire("l4UCE");
/**
 * Grabs active transaction off scope.
 *
 * @deprecated You should not rely on the transaction, but just use `startSpan()` APIs instead.
 */ // eslint-disable-next-line deprecation/deprecation
function $32660ba860961e05$export$a7feb32fdd923295(maybeHub) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = maybeHub || (0, $l4UCE.getCurrentHub)();
    // eslint-disable-next-line deprecation/deprecation
    const scope = hub.getScope();
    // eslint-disable-next-line deprecation/deprecation
    return scope.getTransaction();
}
/**
 * The `extractTraceparentData` function and `TRACEPARENT_REGEXP` constant used
 * to be declared in this file. It was later moved into `@sentry/utils` as part of a
 * move to remove `@sentry/tracing` dependencies from `@sentry/node` (`extractTraceparentData`
 * is the only tracing function used by `@sentry/node`).
 *
 * These exports are kept here for backwards compatability's sake.
 *
 * See https://github.com/getsentry/sentry-javascript/issues/4642 for more details.
 *
 * @deprecated Import this function from `@sentry/utils` instead
 */ const $32660ba860961e05$export$8e9a29865c0a1226 = (0, $dGzPN.extractTraceparentData);

});


parcelRegister("1COtc", function(module, exports) {

$parcel$export(module.exports, "TRACING_DEFAULTS", function () { return $12f07d5b149b8807$export$809a2b7987fd5306; });
$parcel$export(module.exports, "IdleTransaction", function () { return $12f07d5b149b8807$export$b279e6bd7040371f; });

var $iyYYs = parcelRequire("iyYYs");
var $ggG8j = parcelRequire("ggG8j");

var $7dwLN = parcelRequire("7dwLN");

var $ceyhT = parcelRequire("ceyhT");

var $lBUtp = parcelRequire("lBUtp");

var $4R5py = parcelRequire("4R5py");
const $12f07d5b149b8807$export$809a2b7987fd5306 = {
    idleTimeout: 1000,
    finalTimeout: 30000,
    heartbeatInterval: 5000
};
const $12f07d5b149b8807$var$FINISH_REASON_TAG = "finishReason";
const $12f07d5b149b8807$var$IDLE_TRANSACTION_FINISH_REASONS = [
    "heartbeatFailed",
    "idleTimeout",
    "documentHidden",
    "finalTimeout",
    "externalFinish",
    "cancelled"
];
/**
 * @inheritDoc
 */ class $12f07d5b149b8807$export$370d6113c18ba86c extends (0, $lBUtp.SpanRecorder) {
    constructor(_pushActivity, _popActivity, transactionSpanId, maxlen){
        super(maxlen);
        this._pushActivity = _pushActivity;
        this._popActivity = _popActivity;
        this.transactionSpanId = transactionSpanId;
    }
    /**
   * @inheritDoc
   */ add(span) {
        // We should make sure we do not push and pop activities for
        // the transaction that this span recorder belongs to.
        if (span.spanContext().spanId !== this.transactionSpanId) {
            // We patch span.end() to pop an activity after setting an endTimestamp.
            // eslint-disable-next-line @typescript-eslint/unbound-method
            const originalEnd = span.end;
            span.end = (...rest)=>{
                this._popActivity(span.spanContext().spanId);
                return originalEnd.apply(span, rest);
            };
            // We should only push new activities if the span does not have an end timestamp.
            if ((0, $ceyhT.spanToJSON)(span).timestamp === undefined) this._pushActivity(span.spanContext().spanId);
        }
        super.add(span);
    }
}
/**
 * An IdleTransaction is a transaction that automatically finishes. It does this by tracking child spans as activities.
 * You can have multiple IdleTransactions active, but if the `onScope` option is specified, the idle transaction will
 * put itself on the scope on creation.
 */ class $12f07d5b149b8807$export$b279e6bd7040371f extends (0, $4R5py.Transaction) {
    // Activities store a list of active spans
    // Track state of activities in previous heartbeat
    // Amount of times heartbeat has counted. Will cause transaction to finish after 3 beats.
    // We should not use heartbeat if we finished a transaction
    // Idle timeout was canceled and we should finish the transaction with the last span end.
    /**
   * Timer that tracks Transaction idleTimeout
   */ /**
   * @deprecated Transactions will be removed in v8. Use spans instead.
   */ constructor(transactionContext, // eslint-disable-next-line deprecation/deprecation
    _idleHub, /**
     * The time to wait in ms until the idle transaction will be finished. This timer is started each time
     * there are no active spans on this transaction.
     */ _idleTimeout = $12f07d5b149b8807$export$809a2b7987fd5306.idleTimeout, /**
     * The final value in ms that a transaction cannot exceed
     */ _finalTimeout = $12f07d5b149b8807$export$809a2b7987fd5306.finalTimeout, _heartbeatInterval = $12f07d5b149b8807$export$809a2b7987fd5306.heartbeatInterval, // Whether or not the transaction should put itself on the scope when it starts and pop itself off when it ends
    _onScope = false, /**
     * When set to `true`, will disable the idle timeout (`_idleTimeout` option) and heartbeat mechanisms (`_heartbeatInterval`
     * option) until the `sendAutoFinishSignal()` method is called. The final timeout mechanism (`_finalTimeout` option)
     * will not be affected by this option, meaning the transaction will definitely be finished when the final timeout is
     * reached, no matter what this option is configured to.
     *
     * Defaults to `false`.
     */ delayAutoFinishUntilSignal = false){
        super(transactionContext, _idleHub);
        this._idleHub = _idleHub;
        this._idleTimeout = _idleTimeout;
        this._finalTimeout = _finalTimeout;
        this._heartbeatInterval = _heartbeatInterval;
        this._onScope = _onScope;
        this.activities = {};
        this._heartbeatCounter = 0;
        this._finished = false;
        this._idleTimeoutCanceledPermanently = false;
        this._beforeFinishCallbacks = [];
        this._finishReason = $12f07d5b149b8807$var$IDLE_TRANSACTION_FINISH_REASONS[4];
        this._autoFinishAllowed = !delayAutoFinishUntilSignal;
        if (_onScope) {
            // We set the transaction here on the scope so error events pick up the trace
            // context and attach it to the error.
            (0, $7dwLN.DEBUG_BUILD) && (0, $iyYYs.logger).log(`Setting idle transaction on scope. Span ID: ${this.spanContext().spanId}`);
            // eslint-disable-next-line deprecation/deprecation
            _idleHub.getScope().setSpan(this);
        }
        if (!delayAutoFinishUntilSignal) this._restartIdleTimeout();
        setTimeout(()=>{
            if (!this._finished) {
                this.setStatus("deadline_exceeded");
                this._finishReason = $12f07d5b149b8807$var$IDLE_TRANSACTION_FINISH_REASONS[3];
                this.end();
            }
        }, this._finalTimeout);
    }
    /** {@inheritDoc} */ end(endTimestamp) {
        const endTimestampInS = (0, $ceyhT.spanTimeInputToSeconds)(endTimestamp);
        this._finished = true;
        this.activities = {};
        // eslint-disable-next-line deprecation/deprecation
        if (this.op === "ui.action.click") this.setAttribute($12f07d5b149b8807$var$FINISH_REASON_TAG, this._finishReason);
        // eslint-disable-next-line deprecation/deprecation
        if (this.spanRecorder) {
            (0, $7dwLN.DEBUG_BUILD) && // eslint-disable-next-line deprecation/deprecation
            (0, $iyYYs.logger).log("[Tracing] finishing IdleTransaction", new Date(endTimestampInS * 1000).toISOString(), this.op);
            for (const callback of this._beforeFinishCallbacks)callback(this, endTimestampInS);
            // eslint-disable-next-line deprecation/deprecation
            this.spanRecorder.spans = this.spanRecorder.spans.filter((span)=>{
                // If we are dealing with the transaction itself, we just return it
                if (span.spanContext().spanId === this.spanContext().spanId) return true;
                // We cancel all pending spans with status "cancelled" to indicate the idle transaction was finished early
                if (!(0, $ceyhT.spanToJSON)(span).timestamp) {
                    span.setStatus("cancelled");
                    span.end(endTimestampInS);
                    (0, $7dwLN.DEBUG_BUILD) && (0, $iyYYs.logger).log("[Tracing] cancelling span since transaction ended early", JSON.stringify(span, undefined, 2));
                }
                const { start_timestamp: startTime, timestamp: endTime } = (0, $ceyhT.spanToJSON)(span);
                const spanStartedBeforeTransactionFinish = startTime && startTime < endTimestampInS;
                // Add a delta with idle timeout so that we prevent false positives
                const timeoutWithMarginOfError = (this._finalTimeout + this._idleTimeout) / 1000;
                const spanEndedBeforeFinalTimeout = endTime && startTime && endTime - startTime < timeoutWithMarginOfError;
                if (0, $7dwLN.DEBUG_BUILD) {
                    const stringifiedSpan = JSON.stringify(span, undefined, 2);
                    if (!spanStartedBeforeTransactionFinish) (0, $iyYYs.logger).log("[Tracing] discarding Span since it happened after Transaction was finished", stringifiedSpan);
                    else if (!spanEndedBeforeFinalTimeout) (0, $iyYYs.logger).log("[Tracing] discarding Span since it finished after Transaction final timeout", stringifiedSpan);
                }
                return spanStartedBeforeTransactionFinish && spanEndedBeforeFinalTimeout;
            });
            (0, $7dwLN.DEBUG_BUILD) && (0, $iyYYs.logger).log("[Tracing] flushing IdleTransaction");
        } else (0, $7dwLN.DEBUG_BUILD) && (0, $iyYYs.logger).log("[Tracing] No active IdleTransaction");
        // if `this._onScope` is `true`, the transaction put itself on the scope when it started
        if (this._onScope) {
            // eslint-disable-next-line deprecation/deprecation
            const scope = this._idleHub.getScope();
            // eslint-disable-next-line deprecation/deprecation
            if (scope.getTransaction() === this) // eslint-disable-next-line deprecation/deprecation
            scope.setSpan(undefined);
        }
        return super.end(endTimestamp);
    }
    /**
   * Register a callback function that gets executed before the transaction finishes.
   * Useful for cleanup or if you want to add any additional spans based on current context.
   *
   * This is exposed because users have no other way of running something before an idle transaction
   * finishes.
   */ registerBeforeFinishCallback(callback) {
        this._beforeFinishCallbacks.push(callback);
    }
    /**
   * @inheritDoc
   */ initSpanRecorder(maxlen) {
        // eslint-disable-next-line deprecation/deprecation
        if (!this.spanRecorder) {
            const pushActivity = (id)=>{
                if (this._finished) return;
                this._pushActivity(id);
            };
            const popActivity = (id)=>{
                if (this._finished) return;
                this._popActivity(id);
            };
            // eslint-disable-next-line deprecation/deprecation
            this.spanRecorder = new $12f07d5b149b8807$export$370d6113c18ba86c(pushActivity, popActivity, this.spanContext().spanId, maxlen);
            // Start heartbeat so that transactions do not run forever.
            (0, $7dwLN.DEBUG_BUILD) && (0, $iyYYs.logger).log("Starting heartbeat");
            this._pingHeartbeat();
        }
        // eslint-disable-next-line deprecation/deprecation
        this.spanRecorder.add(this);
    }
    /**
   * Cancels the existing idle timeout, if there is one.
   * @param restartOnChildSpanChange Default is `true`.
   *                                 If set to false the transaction will end
   *                                 with the last child span.
   */ cancelIdleTimeout(endTimestamp, { restartOnChildSpanChange: restartOnChildSpanChange } = {
        restartOnChildSpanChange: true
    }) {
        this._idleTimeoutCanceledPermanently = restartOnChildSpanChange === false;
        if (this._idleTimeoutID) {
            clearTimeout(this._idleTimeoutID);
            this._idleTimeoutID = undefined;
            if (Object.keys(this.activities).length === 0 && this._idleTimeoutCanceledPermanently) {
                this._finishReason = $12f07d5b149b8807$var$IDLE_TRANSACTION_FINISH_REASONS[5];
                this.end(endTimestamp);
            }
        }
    }
    /**
   * Temporary method used to externally set the transaction's `finishReason`
   *
   * ** WARNING**
   * This is for the purpose of experimentation only and will be removed in the near future, do not use!
   *
   * @internal
   *
   */ setFinishReason(reason) {
        this._finishReason = reason;
    }
    /**
   * Permits the IdleTransaction to automatically end itself via the idle timeout and heartbeat mechanisms when the `delayAutoFinishUntilSignal` option was set to `true`.
   */ sendAutoFinishSignal() {
        if (!this._autoFinishAllowed) {
            (0, $7dwLN.DEBUG_BUILD) && (0, $iyYYs.logger).log("[Tracing] Received finish signal for idle transaction.");
            this._restartIdleTimeout();
            this._autoFinishAllowed = true;
        }
    }
    /**
   * Restarts idle timeout, if there is no running idle timeout it will start one.
   */ _restartIdleTimeout(endTimestamp) {
        this.cancelIdleTimeout();
        this._idleTimeoutID = setTimeout(()=>{
            if (!this._finished && Object.keys(this.activities).length === 0) {
                this._finishReason = $12f07d5b149b8807$var$IDLE_TRANSACTION_FINISH_REASONS[1];
                this.end(endTimestamp);
            }
        }, this._idleTimeout);
    }
    /**
   * Start tracking a specific activity.
   * @param spanId The span id that represents the activity
   */ _pushActivity(spanId) {
        this.cancelIdleTimeout(undefined, {
            restartOnChildSpanChange: !this._idleTimeoutCanceledPermanently
        });
        (0, $7dwLN.DEBUG_BUILD) && (0, $iyYYs.logger).log(`[Tracing] pushActivity: ${spanId}`);
        this.activities[spanId] = true;
        (0, $7dwLN.DEBUG_BUILD) && (0, $iyYYs.logger).log("[Tracing] new activities count", Object.keys(this.activities).length);
    }
    /**
   * Remove an activity from usage
   * @param spanId The span id that represents the activity
   */ _popActivity(spanId) {
        if (this.activities[spanId]) {
            (0, $7dwLN.DEBUG_BUILD) && (0, $iyYYs.logger).log(`[Tracing] popActivity ${spanId}`);
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete this.activities[spanId];
            (0, $7dwLN.DEBUG_BUILD) && (0, $iyYYs.logger).log("[Tracing] new activities count", Object.keys(this.activities).length);
        }
        if (Object.keys(this.activities).length === 0) {
            const endTimestamp = (0, $ggG8j.timestampInSeconds)();
            if (this._idleTimeoutCanceledPermanently) {
                if (this._autoFinishAllowed) {
                    this._finishReason = $12f07d5b149b8807$var$IDLE_TRANSACTION_FINISH_REASONS[5];
                    this.end(endTimestamp);
                }
            } else // We need to add the timeout here to have the real endtimestamp of the transaction
            // Remember timestampInSeconds is in seconds, timeout is in ms
            this._restartIdleTimeout(endTimestamp + this._idleTimeout / 1000);
        }
    }
    /**
   * Checks when entries of this.activities are not changing for 3 beats.
   * If this occurs we finish the transaction.
   */ _beat() {
        // We should not be running heartbeat if the idle transaction is finished.
        if (this._finished) return;
        const heartbeatString = Object.keys(this.activities).join("");
        if (heartbeatString === this._prevHeartbeatString) this._heartbeatCounter++;
        else this._heartbeatCounter = 1;
        this._prevHeartbeatString = heartbeatString;
        if (this._heartbeatCounter >= 3) {
            if (this._autoFinishAllowed) {
                (0, $7dwLN.DEBUG_BUILD) && (0, $iyYYs.logger).log("[Tracing] Transaction finished because of no change for 3 heart beats");
                this.setStatus("deadline_exceeded");
                this._finishReason = $12f07d5b149b8807$var$IDLE_TRANSACTION_FINISH_REASONS[0];
                this.end();
            }
        } else this._pingHeartbeat();
    }
    /**
   * Pings the heartbeat
   */ _pingHeartbeat() {
        (0, $7dwLN.DEBUG_BUILD) && (0, $iyYYs.logger).log(`pinging Heartbeat -> current counter: ${this._heartbeatCounter}`);
        setTimeout(()=>{
            this._beat();
        }, this._heartbeatInterval);
    }
}

});
parcelRegister("lBUtp", function(module, exports) {

$parcel$export(module.exports, "SpanRecorder", function () { return $fbb8dc15ba1d7dd7$export$10c95c129cd0d4fe; });
$parcel$export(module.exports, "Span", function () { return $fbb8dc15ba1d7dd7$export$5f1714a13ed34c01; });

var $9fGKl = parcelRequire("9fGKl");
var $iyYYs = parcelRequire("iyYYs");
var $ggG8j = parcelRequire("ggG8j");
var $dmJ8B = parcelRequire("dmJ8B");

var $7dwLN = parcelRequire("7dwLN");

var $dO7r5 = parcelRequire("dO7r5");

var $ePKuD = parcelRequire("ePKuD");

var $gkl6g = parcelRequire("gkl6g");

var $ceyhT = parcelRequire("ceyhT");

var $h795Y = parcelRequire("h795Y");
/**
 * Keeps track of finished spans for a given transaction
 * @internal
 * @hideconstructor
 * @hidden
 */ class $fbb8dc15ba1d7dd7$export$10c95c129cd0d4fe {
    constructor(maxlen = 1000){
        this._maxlen = maxlen;
        this.spans = [];
    }
    /**
   * This is just so that we don't run out of memory while recording a lot
   * of spans. At some point we just stop and flush out the start of the
   * trace tree (i.e.the first n spans with the smallest
   * start_timestamp).
   */ add(span) {
        if (this.spans.length > this._maxlen) // eslint-disable-next-line deprecation/deprecation
        span.spanRecorder = undefined;
        else this.spans.push(span);
    }
}
/**
 * Span contains all data about a span
 */ class $fbb8dc15ba1d7dd7$export$5f1714a13ed34c01 {
    /**
   * Tags for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */ /**
   * Data for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    /**
   * List of spans that were finalized
   *
   * @deprecated This property will no longer be public. Span recording will be handled internally.
   */ /**
   * @inheritDoc
   * @deprecated Use top level `Sentry.getRootSpan()` instead
   */ /**
   * The instrumenter that created this span.
   *
   * TODO (v8): This can probably be replaced by an `instanceOf` check of the span class.
   *            the instrumenter can only be sentry or otel so we can check the span instance
   *            to verify which one it is and remove this field entirely.
   *
   * @deprecated This field will be removed.
   */ /** Epoch timestamp in seconds when the span started. */ /** Epoch timestamp in seconds when the span ended. */ /** Internal keeper of the status */ /**
   * You should never call the constructor manually, always use `Sentry.startTransaction()`
   * or call `startChild()` on an existing span.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $dmJ8B.uuid4)();
        this._spanId = spanContext.spanId || (0, $dmJ8B.uuid4)().substring(16);
        this._startTime = spanContext.startTimestamp || (0, $ggG8j.timestampInSeconds)();
        // eslint-disable-next-line deprecation/deprecation
        this.tags = spanContext.tags ? {
            ...spanContext.tags
        } : {};
        // eslint-disable-next-line deprecation/deprecation
        this.data = spanContext.data ? {
            ...spanContext.data
        } : {};
        // eslint-disable-next-line deprecation/deprecation
        this.instrumenter = spanContext.instrumenter || "sentry";
        this._attributes = {};
        this.setAttributes({
            [(0, $ePKuD.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: spanContext.origin || "manual",
            [(0, $ePKuD.SEMANTIC_ATTRIBUTE_SENTRY_OP)]: spanContext.op,
            ...spanContext.attributes
        });
        // eslint-disable-next-line deprecation/deprecation
        this._name = spanContext.name || spanContext.description;
        if (spanContext.parentSpanId) this._parentSpanId = spanContext.parentSpanId;
        // We want to include booleans as well here
        if ("sampled" in spanContext) this._sampled = spanContext.sampled;
        if (spanContext.status) this._status = spanContext.status;
        if (spanContext.endTimestamp) this._endTime = spanContext.endTimestamp;
        if (spanContext.exclusiveTime !== undefined) this._exclusiveTime = spanContext.exclusiveTime;
        this._measurements = spanContext.measurements ? {
            ...spanContext.measurements
        } : {};
    }
    // This rule conflicts with another eslint rule :(
    /* eslint-disable @typescript-eslint/member-ordering */ /**
   * An alias for `description` of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ get name() {
        return this._name || "";
    }
    /**
   * Update the name of the span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ set name(name) {
        this.updateName(name);
    }
    /**
   * Get the description of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ get description() {
        return this._name;
    }
    /**
   * Get the description of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ set description(description) {
        this._name = description;
    }
    /**
   * The ID of the trace.
   * @deprecated Use `spanContext().traceId` instead.
   */ get traceId() {
        return this._traceId;
    }
    /**
   * The ID of the trace.
   * @deprecated You cannot update the traceId of a span after span creation.
   */ set traceId(traceId) {
        this._traceId = traceId;
    }
    /**
   * The ID of the span.
   * @deprecated Use `spanContext().spanId` instead.
   */ get spanId() {
        return this._spanId;
    }
    /**
   * The ID of the span.
   * @deprecated You cannot update the spanId of a span after span creation.
   */ set spanId(spanId) {
        this._spanId = spanId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `startSpan` functions instead.
   */ set parentSpanId(string) {
        this._parentSpanId = string;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON(span).parent_span_id` instead.
   */ get parentSpanId() {
        return this._parentSpanId;
    }
    /**
   * Was this span chosen to be sent as part of the sample?
   * @deprecated Use `isRecording()` instead.
   */ get sampled() {
        return this._sampled;
    }
    /**
   * Was this span chosen to be sent as part of the sample?
   * @deprecated You cannot update the sampling decision of a span after span creation.
   */ set sampled(sampled) {
        this._sampled = sampled;
    }
    /**
   * Attributes for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */ get attributes() {
        return this._attributes;
    }
    /**
   * Attributes for the span.
   * @deprecated Use `setAttributes()` instead.
   */ set attributes(attributes) {
        this._attributes = attributes;
    }
    /**
   * Timestamp in seconds (epoch time) indicating when the span started.
   * @deprecated Use `spanToJSON()` instead.
   */ get startTimestamp() {
        return this._startTime;
    }
    /**
   * Timestamp in seconds (epoch time) indicating when the span started.
   * @deprecated In v8, you will not be able to update the span start time after creation.
   */ set startTimestamp(startTime) {
        this._startTime = startTime;
    }
    /**
   * Timestamp in seconds when the span ended.
   * @deprecated Use `spanToJSON()` instead.
   */ get endTimestamp() {
        return this._endTime;
    }
    /**
   * Timestamp in seconds when the span ended.
   * @deprecated Set the end time via `span.end()` instead.
   */ set endTimestamp(endTime) {
        this._endTime = endTime;
    }
    /**
   * The status of the span.
   *
   * @deprecated Use `spanToJSON().status` instead to get the status.
   */ get status() {
        return this._status;
    }
    /**
   * The status of the span.
   *
   * @deprecated Use `.setStatus()` instead to set or update the status.
   */ set status(status) {
        this._status = status;
    }
    /**
   * Operation of the span
   *
   * @deprecated Use `spanToJSON().op` to read the op instead.
   */ get op() {
        return this._attributes[0, $ePKuD.SEMANTIC_ATTRIBUTE_SENTRY_OP];
    }
    /**
   * Operation of the span
   *
   * @deprecated Use `startSpan()` functions to set or `span.setAttribute(SEMANTIC_ATTRIBUTE_SENTRY_OP, 'op')
   *             to update the span instead.
   */ set op(op) {
        this.setAttribute((0, $ePKuD.SEMANTIC_ATTRIBUTE_SENTRY_OP), op);
    }
    /**
   * The origin of the span, giving context about what created the span.
   *
   * @deprecated Use `spanToJSON().origin` to read the origin instead.
   */ get origin() {
        return this._attributes[0, $ePKuD.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN];
    }
    /**
   * The origin of the span, giving context about what created the span.
   *
   * @deprecated Use `startSpan()` functions to set the origin instead.
   */ set origin(origin) {
        this.setAttribute((0, $ePKuD.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN), origin);
    }
    /* eslint-enable @typescript-eslint/member-ordering */ /** @inheritdoc */ spanContext() {
        const { _spanId: spanId, _traceId: traceId, _sampled: sampled } = this;
        return {
            spanId: spanId,
            traceId: traceId,
            traceFlags: sampled ? (0, $ceyhT.TRACE_FLAG_SAMPLED) : (0, $ceyhT.TRACE_FLAG_NONE)
        };
    }
    /**
   * Creates a new `Span` while setting the current `Span.id` as `parentSpanId`.
   * Also the `sampled` decision will be inherited.
   *
   * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
   */ startChild(spanContext) {
        const childSpan = new $fbb8dc15ba1d7dd7$export$5f1714a13ed34c01({
            ...spanContext,
            parentSpanId: this._spanId,
            sampled: this._sampled,
            traceId: this._traceId
        });
        // eslint-disable-next-line deprecation/deprecation
        childSpan.spanRecorder = this.spanRecorder;
        // eslint-disable-next-line deprecation/deprecation
        if (childSpan.spanRecorder) // eslint-disable-next-line deprecation/deprecation
        childSpan.spanRecorder.add(childSpan);
        const rootSpan = (0, $gkl6g.getRootSpan)(this);
        // TODO: still set span.transaction here until we have a more permanent solution
        // Probably similarly to the weakmap we hold in node-experimental
        // eslint-disable-next-line deprecation/deprecation
        childSpan.transaction = rootSpan;
        if ((0, $7dwLN.DEBUG_BUILD) && rootSpan) {
            const opStr = spanContext && spanContext.op || "< unknown op >";
            const nameStr = (0, $ceyhT.spanToJSON)(childSpan).description || "< unknown name >";
            const idStr = rootSpan.spanContext().spanId;
            const logMessage = `[Tracing] Starting '${opStr}' span on transaction '${nameStr}' (${idStr}).`;
            (0, $iyYYs.logger).log(logMessage);
            this._logMessage = logMessage;
        }
        return childSpan;
    }
    /**
   * Sets the tag attribute on the current span.
   *
   * Can also be used to unset a tag, by passing `undefined`.
   *
   * @param key Tag key
   * @param value Tag value
   * @deprecated Use `setAttribute()` instead.
   */ setTag(key, value) {
        // eslint-disable-next-line deprecation/deprecation
        this.tags = {
            ...this.tags,
            [key]: value
        };
        return this;
    }
    /**
   * Sets the data attribute on the current span
   * @param key Data key
   * @param value Data value
   * @deprecated Use `setAttribute()` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setData(key, value) {
        // eslint-disable-next-line deprecation/deprecation
        this.data = {
            ...this.data,
            [key]: value
        };
        return this;
    }
    /** @inheritdoc */ setAttribute(key, value) {
        if (value === undefined) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._attributes[key];
        else this._attributes[key] = value;
    }
    /** @inheritdoc */ setAttributes(attributes) {
        Object.keys(attributes).forEach((key)=>this.setAttribute(key, attributes[key]));
    }
    /**
   * @inheritDoc
   */ setStatus(value) {
        this._status = value;
        return this;
    }
    /**
   * @inheritDoc
   * @deprecated Use top-level `setHttpStatus()` instead.
   */ setHttpStatus(httpStatus) {
        (0, $h795Y.setHttpStatus)(this, httpStatus);
        return this;
    }
    /**
   * @inheritdoc
   *
   * @deprecated Use `.updateName()` instead.
   */ setName(name) {
        this.updateName(name);
    }
    /**
   * @inheritDoc
   */ updateName(name) {
        this._name = name;
        return this;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON(span).status === 'ok'` instead.
   */ isSuccess() {
        return this._status === "ok";
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `.end()` instead.
   */ finish(endTimestamp) {
        return this.end(endTimestamp);
    }
    /** @inheritdoc */ end(endTimestamp) {
        // If already ended, skip
        if (this._endTime) return;
        const rootSpan = (0, $gkl6g.getRootSpan)(this);
        if ((0, $7dwLN.DEBUG_BUILD) && // Don't call this for transactions
        rootSpan && rootSpan.spanContext().spanId !== this._spanId) {
            const logMessage = this._logMessage;
            if (logMessage) (0, $iyYYs.logger).log(logMessage.replace("Starting", "Finishing"));
        }
        this._endTime = (0, $ceyhT.spanTimeInputToSeconds)(endTimestamp);
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToTraceHeader()` instead.
   */ toTraceparent() {
        return (0, $ceyhT.spanToTraceHeader)(this);
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON()` or access the fields directly instead.
   */ toContext() {
        return (0, $9fGKl.dropUndefinedKeys)({
            data: this._getData(),
            description: this._name,
            endTimestamp: this._endTime,
            // eslint-disable-next-line deprecation/deprecation
            op: this.op,
            parentSpanId: this._parentSpanId,
            sampled: this._sampled,
            spanId: this._spanId,
            startTimestamp: this._startTime,
            status: this._status,
            // eslint-disable-next-line deprecation/deprecation
            tags: this.tags,
            traceId: this._traceId
        });
    }
    /**
   * @inheritDoc
   *
   * @deprecated Update the fields directly instead.
   */ updateWithContext(spanContext) {
        // eslint-disable-next-line deprecation/deprecation
        this.data = spanContext.data || {};
        // eslint-disable-next-line deprecation/deprecation
        this._name = spanContext.name || spanContext.description;
        this._endTime = spanContext.endTimestamp;
        // eslint-disable-next-line deprecation/deprecation
        this.op = spanContext.op;
        this._parentSpanId = spanContext.parentSpanId;
        this._sampled = spanContext.sampled;
        this._spanId = spanContext.spanId || this._spanId;
        this._startTime = spanContext.startTimestamp || this._startTime;
        this._status = spanContext.status;
        // eslint-disable-next-line deprecation/deprecation
        this.tags = spanContext.tags || {};
        this._traceId = spanContext.traceId || this._traceId;
        return this;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToTraceContext()` util function instead.
   */ getTraceContext() {
        return (0, $ceyhT.spanToTraceContext)(this);
    }
    /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */ getSpanJSON() {
        return (0, $9fGKl.dropUndefinedKeys)({
            data: this._getData(),
            description: this._name,
            op: this._attributes[0, $ePKuD.SEMANTIC_ATTRIBUTE_SENTRY_OP],
            parent_span_id: this._parentSpanId,
            span_id: this._spanId,
            start_timestamp: this._startTime,
            status: this._status,
            // eslint-disable-next-line deprecation/deprecation
            tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
            timestamp: this._endTime,
            trace_id: this._traceId,
            origin: this._attributes[0, $ePKuD.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN],
            _metrics_summary: (0, $dO7r5.getMetricSummaryJsonForSpan)(this),
            profile_id: this._attributes[0, $ePKuD.SEMANTIC_ATTRIBUTE_PROFILE_ID],
            exclusive_time: this._exclusiveTime,
            measurements: Object.keys(this._measurements).length > 0 ? this._measurements : undefined
        });
    }
    /** @inheritdoc */ isRecording() {
        return !this._endTime && !!this._sampled;
    }
    /**
   * Convert the object to JSON.
   * @deprecated Use `spanToJSON(span)` instead.
   */ toJSON() {
        return this.getSpanJSON();
    }
    /**
   * Get the merged data for this span.
   * For now, this combines `data` and `attributes` together,
   * until eventually we can ingest `attributes` directly.
   */ _getData() {
        // eslint-disable-next-line deprecation/deprecation
        const { data: data, _attributes: attributes } = this;
        const hasData = Object.keys(data).length > 0;
        const hasAttributes = Object.keys(attributes).length > 0;
        if (!hasData && !hasAttributes) return undefined;
        if (hasData && hasAttributes) return {
            ...data,
            ...attributes
        };
        return hasData ? data : attributes;
    }
}

});
parcelRegister("dO7r5", function(module, exports) {

$parcel$export(module.exports, "getMetricSummaryJsonForSpan", function () { return $a0d5b67fb856d7bb$export$2e7205e45c58797d; });

var $9fGKl = parcelRequire("9fGKl");




var $aJUSo = parcelRequire("aJUSo");
/**
 * key: bucketKey
 * value: [exportKey, MetricSummary]
 */ let $a0d5b67fb856d7bb$var$SPAN_METRIC_SUMMARY;
function $a0d5b67fb856d7bb$var$getMetricStorageForSpan(span) {
    return $a0d5b67fb856d7bb$var$SPAN_METRIC_SUMMARY ? $a0d5b67fb856d7bb$var$SPAN_METRIC_SUMMARY.get(span) : undefined;
}
/**
 * Fetches the metric summary if it exists for the passed span
 */ function $a0d5b67fb856d7bb$export$2e7205e45c58797d(span) {
    const storage = $a0d5b67fb856d7bb$var$getMetricStorageForSpan(span);
    if (!storage) return undefined;
    const output = {};
    for (const [, [exportKey, summary]] of storage){
        if (!output[exportKey]) output[exportKey] = [];
        output[exportKey].push((0, $9fGKl.dropUndefinedKeys)(summary));
    }
    return output;
}
/**
 * Updates the metric summary on the currently active span
 */ function $a0d5b67fb856d7bb$export$aefd1a302602f922(metricType, sanitizedName, value, unit, tags, bucketKey) {
    const span = (0, $aJUSo.getActiveSpan)();
    if (span) {
        const storage = $a0d5b67fb856d7bb$var$getMetricStorageForSpan(span) || new Map();
        const exportKey = `${metricType}:${sanitizedName}@${unit}`;
        const bucketItem = storage.get(bucketKey);
        if (bucketItem) {
            const [, summary] = bucketItem;
            storage.set(bucketKey, [
                exportKey,
                {
                    min: Math.min(summary.min, value),
                    max: Math.max(summary.max, value),
                    count: summary.count += 1,
                    sum: summary.sum += value,
                    tags: summary.tags
                }
            ]);
        } else storage.set(bucketKey, [
            exportKey,
            {
                min: value,
                max: value,
                count: 1,
                sum: value,
                tags: tags
            }
        ]);
        if (!$a0d5b67fb856d7bb$var$SPAN_METRIC_SUMMARY) $a0d5b67fb856d7bb$var$SPAN_METRIC_SUMMARY = new WeakMap();
        $a0d5b67fb856d7bb$var$SPAN_METRIC_SUMMARY.set(span, storage);
    }
}

});
parcelRegister("aJUSo", function(module, exports) {

$parcel$export(module.exports, "startSpan", function () { return $7d1a39d2b44db1ff$export$a1bd95187356f372; });
$parcel$export(module.exports, "startInactiveSpan", function () { return $7d1a39d2b44db1ff$export$63dbba021a6b4047; });
$parcel$export(module.exports, "getActiveSpan", function () { return $7d1a39d2b44db1ff$export$1be426a8e585c83e; });
$parcel$export(module.exports, "getCapturedScopesOnSpan", function () { return $7d1a39d2b44db1ff$export$c08fbc656a245d03; });

var $9fGKl = parcelRequire("9fGKl");
var $iyYYs = parcelRequire("iyYYs");
var $dGzPN = parcelRequire("dGzPN");

var $7dwLN = parcelRequire("7dwLN");

var $l4UCE = parcelRequire("l4UCE");

var $ceyhT = parcelRequire("ceyhT");



var $kVnKi = parcelRequire("kVnKi");

var $ejob9 = parcelRequire("ejob9");

var $7p7Aw = parcelRequire("7p7Aw");

var $bRL0a = parcelRequire("bRL0a");
/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 *
 * This function is meant to be used internally and may break at any time. Use at your own risk.
 *
 * @internal
 * @private
 *
 * @deprecated Use `startSpan` instead.
 */ function $7d1a39d2b44db1ff$export$357889f174732d38(context, callback, // eslint-disable-next-line @typescript-eslint/no-empty-function
onError = ()=>{}, // eslint-disable-next-line @typescript-eslint/no-empty-function
afterFinish = ()=>{}) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $l4UCE.getCurrentHub)();
    const scope = (0, $ejob9.getCurrentScope)();
    // eslint-disable-next-line deprecation/deprecation
    const parentSpan = scope.getSpan();
    const spanContext = $7d1a39d2b44db1ff$var$normalizeContext(context);
    const activeSpan = $7d1a39d2b44db1ff$var$createChildSpanOrTransaction(hub, {
        parentSpan: parentSpan,
        spanContext: spanContext,
        forceTransaction: false,
        scope: scope
    });
    // eslint-disable-next-line deprecation/deprecation
    scope.setSpan(activeSpan);
    return (0, $7p7Aw.handleCallbackErrors)(()=>callback(activeSpan), (error)=>{
        activeSpan && activeSpan.setStatus("internal_error");
        onError(error, activeSpan);
    }, ()=>{
        activeSpan && activeSpan.end();
        // eslint-disable-next-line deprecation/deprecation
        scope.setSpan(parentSpan);
        afterFinish();
    });
}
/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getSpan()`, as long as the function is executed while the scope is active.
 *
 * If you want to create a span that is not set as active, use {@link startInactiveSpan}.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function $7d1a39d2b44db1ff$export$a1bd95187356f372(context, callback) {
    const spanContext = $7d1a39d2b44db1ff$var$normalizeContext(context);
    return (0, $l4UCE.runWithAsyncContext)(()=>{
        return (0, $ejob9.withScope)(context.scope, (scope)=>{
            // eslint-disable-next-line deprecation/deprecation
            const hub = (0, $l4UCE.getCurrentHub)();
            // eslint-disable-next-line deprecation/deprecation
            const parentSpan = scope.getSpan();
            const shouldSkipSpan = context.onlyIfParent && !parentSpan;
            const activeSpan = shouldSkipSpan ? undefined : $7d1a39d2b44db1ff$var$createChildSpanOrTransaction(hub, {
                parentSpan: parentSpan,
                spanContext: spanContext,
                forceTransaction: context.forceTransaction,
                scope: scope
            });
            return (0, $7p7Aw.handleCallbackErrors)(()=>callback(activeSpan), ()=>{
                // Only update the span status if it hasn't been changed yet
                if (activeSpan) {
                    const { status: status } = (0, $ceyhT.spanToJSON)(activeSpan);
                    if (!status || status === "ok") activeSpan.setStatus("internal_error");
                }
            }, ()=>activeSpan && activeSpan.end());
        });
    });
}
/**
 * @deprecated Use {@link startSpan} instead.
 */ const $7d1a39d2b44db1ff$export$cb9e396e6b90b703 = $7d1a39d2b44db1ff$export$a1bd95187356f372;
/**
 * Similar to `Sentry.startSpan`. Wraps a function with a transaction/span, but does not finish the span
 * after the function is done automatically. You'll have to call `span.end()` manually.
 *
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function $7d1a39d2b44db1ff$export$c10292ad04b92aea(context, callback) {
    const spanContext = $7d1a39d2b44db1ff$var$normalizeContext(context);
    return (0, $l4UCE.runWithAsyncContext)(()=>{
        return (0, $ejob9.withScope)(context.scope, (scope)=>{
            // eslint-disable-next-line deprecation/deprecation
            const hub = (0, $l4UCE.getCurrentHub)();
            // eslint-disable-next-line deprecation/deprecation
            const parentSpan = scope.getSpan();
            const shouldSkipSpan = context.onlyIfParent && !parentSpan;
            const activeSpan = shouldSkipSpan ? undefined : $7d1a39d2b44db1ff$var$createChildSpanOrTransaction(hub, {
                parentSpan: parentSpan,
                spanContext: spanContext,
                forceTransaction: context.forceTransaction,
                scope: scope
            });
            function finishAndSetSpan() {
                activeSpan && activeSpan.end();
            }
            return (0, $7p7Aw.handleCallbackErrors)(()=>callback(activeSpan, finishAndSetSpan), ()=>{
                // Only update the span status if it hasn't been changed yet, and the span is not yet finished
                if (activeSpan && activeSpan.isRecording()) {
                    const { status: status } = (0, $ceyhT.spanToJSON)(activeSpan);
                    if (!status || status === "ok") activeSpan.setStatus("internal_error");
                }
            });
        });
    });
}
/**
 * Creates a span. This span is not set as active, so will not get automatic instrumentation spans
 * as children or be able to be accessed via `Sentry.getSpan()`.
 *
 * If you want to create a span that is set as active, use {@link startSpan}.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate` or `tracesSampler`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function $7d1a39d2b44db1ff$export$63dbba021a6b4047(context) {
    if (!(0, $bRL0a.hasTracingEnabled)()) return undefined;
    const spanContext = $7d1a39d2b44db1ff$var$normalizeContext(context);
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $l4UCE.getCurrentHub)();
    const parentSpan = context.scope ? context.scope.getSpan() : $7d1a39d2b44db1ff$export$1be426a8e585c83e();
    const shouldSkipSpan = context.onlyIfParent && !parentSpan;
    if (shouldSkipSpan) return undefined;
    const scope = context.scope || (0, $ejob9.getCurrentScope)();
    // Even though we don't actually want to make this span active on the current scope,
    // we need to make it active on a temporary scope that we use for event processing
    // as otherwise, it won't pick the correct span for the event when processing it
    const temporaryScope = scope.clone();
    return $7d1a39d2b44db1ff$var$createChildSpanOrTransaction(hub, {
        parentSpan: parentSpan,
        spanContext: spanContext,
        forceTransaction: context.forceTransaction,
        scope: temporaryScope
    });
}
/**
 * Returns the currently active span.
 */ function $7d1a39d2b44db1ff$export$1be426a8e585c83e() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $ejob9.getCurrentScope)().getSpan();
}
const $7d1a39d2b44db1ff$export$d2ee9b39b25437b3 = ({ sentryTrace: sentryTrace, baggage: baggage }, callback)=>{
    // TODO(v8): Change this function so it doesn't do anything besides setting the propagation context on the current scope:
    /*
    return withScope((scope) => {
      const propagationContext = propagationContextFromHeaders(sentryTrace, baggage);
      scope.setPropagationContext(propagationContext);
      return callback();
    })
  */ const currentScope = (0, $ejob9.getCurrentScope)();
    // eslint-disable-next-line deprecation/deprecation
    const { traceparentData: traceparentData, dynamicSamplingContext: dynamicSamplingContext, propagationContext: propagationContext } = (0, $dGzPN.tracingContextFromHeaders)(sentryTrace, baggage);
    currentScope.setPropagationContext(propagationContext);
    if ((0, $7dwLN.DEBUG_BUILD) && traceparentData) (0, $iyYYs.logger).log(`[Tracing] Continuing trace ${traceparentData.traceId}.`);
    const transactionContext = {
        ...traceparentData,
        metadata: (0, $9fGKl.dropUndefinedKeys)({
            dynamicSamplingContext: dynamicSamplingContext
        })
    };
    if (!callback) return transactionContext;
    return (0, $l4UCE.runWithAsyncContext)(()=>{
        return callback(transactionContext);
    });
};
function $7d1a39d2b44db1ff$var$createChildSpanOrTransaction(// eslint-disable-next-line deprecation/deprecation
hub, { parentSpan: parentSpan, spanContext: spanContext, forceTransaction: forceTransaction, scope: scope }) {
    if (!(0, $bRL0a.hasTracingEnabled)()) return undefined;
    const isolationScope = (0, $l4UCE.getIsolationScope)();
    let span;
    if (parentSpan && !forceTransaction) // eslint-disable-next-line deprecation/deprecation
    span = parentSpan.startChild(spanContext);
    else if (parentSpan) {
        // If we forced a transaction but have a parent span, make sure to continue from the parent span, not the scope
        const dsc = (0, $kVnKi.getDynamicSamplingContextFromSpan)(parentSpan);
        const { traceId: traceId, spanId: parentSpanId } = parentSpan.spanContext();
        const sampled = (0, $ceyhT.spanIsSampled)(parentSpan);
        // eslint-disable-next-line deprecation/deprecation
        span = hub.startTransaction({
            traceId: traceId,
            parentSpanId: parentSpanId,
            parentSampled: sampled,
            ...spanContext,
            metadata: {
                dynamicSamplingContext: dsc,
                // eslint-disable-next-line deprecation/deprecation
                ...spanContext.metadata
            }
        });
    } else {
        const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: sampled } = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        // eslint-disable-next-line deprecation/deprecation
        span = hub.startTransaction({
            traceId: traceId,
            parentSpanId: parentSpanId,
            parentSampled: sampled,
            ...spanContext,
            metadata: {
                dynamicSamplingContext: dsc,
                // eslint-disable-next-line deprecation/deprecation
                ...spanContext.metadata
            }
        });
    }
    // We always set this as active span on the scope
    // In the case of this being an inactive span, we ensure to pass a detached scope in here in the first place
    // But by having this here, we can ensure that the lookup through `getCapturedScopesOnSpan` results in the correct scope & span combo
    // eslint-disable-next-line deprecation/deprecation
    scope.setSpan(span);
    $7d1a39d2b44db1ff$var$setCapturedScopesOnSpan(span, scope, isolationScope);
    return span;
}
/**
 * This converts StartSpanOptions to TransactionContext.
 * For the most part (for now) we accept the same options,
 * but some of them need to be transformed.
 *
 * Eventually the StartSpanOptions will be more aligned with OpenTelemetry.
 */ function $7d1a39d2b44db1ff$var$normalizeContext(context) {
    if (context.startTime) {
        const ctx = {
            ...context
        };
        ctx.startTimestamp = (0, $ceyhT.spanTimeInputToSeconds)(context.startTime);
        delete ctx.startTime;
        return ctx;
    }
    return context;
}
const $7d1a39d2b44db1ff$var$SCOPE_ON_START_SPAN_FIELD = "_sentryScope";
const $7d1a39d2b44db1ff$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD = "_sentryIsolationScope";
function $7d1a39d2b44db1ff$var$setCapturedScopesOnSpan(span, scope, isolationScope) {
    if (span) {
        (0, $9fGKl.addNonEnumerableProperty)(span, $7d1a39d2b44db1ff$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD, isolationScope);
        (0, $9fGKl.addNonEnumerableProperty)(span, $7d1a39d2b44db1ff$var$SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
/**
 * Grabs the scope and isolation scope off a span that were active when the span was started.
 */ function $7d1a39d2b44db1ff$export$c08fbc656a245d03(span) {
    return {
        scope: span[$7d1a39d2b44db1ff$var$SCOPE_ON_START_SPAN_FIELD],
        isolationScope: span[$7d1a39d2b44db1ff$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD]
    };
}

});
parcelRegister("7p7Aw", function(module, exports) {

$parcel$export(module.exports, "handleCallbackErrors", function () { return $5640c10f2d5cca44$export$18ce21a8b7efd7e9; });

var $dR6t7 = parcelRequire("dR6t7");
/**
 * Wrap a callback function with error handling.
 * If an error is thrown, it will be passed to the `onError` callback and re-thrown.
 *
 * If the return value of the function is a promise, it will be handled with `maybeHandlePromiseRejection`.
 *
 * If an `onFinally` callback is provided, this will be called when the callback has finished
 * - so if it returns a promise, once the promise resolved/rejected,
 * else once the callback has finished executing.
 * The `onFinally` callback will _always_ be called, no matter if an error was thrown or not.
 */ function $5640c10f2d5cca44$export$18ce21a8b7efd7e9(fn, onError, // eslint-disable-next-line @typescript-eslint/no-empty-function
onFinally = ()=>{}) {
    let maybePromiseResult;
    try {
        maybePromiseResult = fn();
    } catch (e) {
        onError(e);
        onFinally();
        throw e;
    }
    return $5640c10f2d5cca44$var$maybeHandlePromiseRejection(maybePromiseResult, onError, onFinally);
}
/**
 * Maybe handle a promise rejection.
 * This expects to be given a value that _may_ be a promise, or any other value.
 * If it is a promise, and it rejects, it will call the `onError` callback.
 * Other than this, it will generally return the given value as-is.
 */ function $5640c10f2d5cca44$var$maybeHandlePromiseRejection(value, onError, onFinally) {
    if ((0, $dR6t7.isThenable)(value)) // @ts-expect-error - the isThenable check returns the "wrong" type here
    return value.then((res)=>{
        onFinally();
        return res;
    }, (e)=>{
        onError(e);
        onFinally();
        throw e;
    });
    onFinally();
    return value;
}

});

parcelRegister("bRL0a", function(module, exports) {

$parcel$export(module.exports, "hasTracingEnabled", function () { return $8a391a815e028bfc$export$5008da00b1b6dee6; });

var $ejob9 = parcelRequire("ejob9");
// Treeshakable guard to remove all code related to tracing
/**
 * Determines if tracing is currently enabled.
 *
 * Tracing is enabled when at least one of `tracesSampleRate` and `tracesSampler` is defined in the SDK config.
 */ function $8a391a815e028bfc$export$5008da00b1b6dee6(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === "boolean" && !__SENTRY_TRACING__) return false;
    const client = (0, $ejob9.getClient)();
    const options = maybeOptions || client && client.getOptions();
    return !!options && (options.enableTracing || "tracesSampleRate" in options || "tracesSampler" in options);
}

});



parcelRegister("ePKuD", function(module, exports) {

$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_SOURCE", function () { return $acc9e4aed738f2ef$export$d7a7d984b0791405; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE", function () { return $acc9e4aed738f2ef$export$ccfe0a40627cc34b; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_OP", function () { return $acc9e4aed738f2ef$export$1a413bd9a88fdb09; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN", function () { return $acc9e4aed738f2ef$export$cca8dd30f57f805e; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_PROFILE_ID", function () { return $acc9e4aed738f2ef$export$1efec95406bbe327; });
/**
 * Use this attribute to represent the source of a span.
 * Should be one of: custom, url, route, view, component, task, unknown
 *
 */ const $acc9e4aed738f2ef$export$d7a7d984b0791405 = "sentry.source";
/**
 * Use this attribute to represent the sample rate used for a span.
 */ const $acc9e4aed738f2ef$export$ccfe0a40627cc34b = "sentry.sample_rate";
/**
 * Use this attribute to represent the operation of a span.
 */ const $acc9e4aed738f2ef$export$1a413bd9a88fdb09 = "sentry.op";
/**
 * Use this attribute to represent the origin of a span.
 */ const $acc9e4aed738f2ef$export$cca8dd30f57f805e = "sentry.origin";
/**
 * The id of the profile that this span occured in.
 */ const $acc9e4aed738f2ef$export$1efec95406bbe327 = "profile_id";

});

parcelRegister("h795Y", function(module, exports) {

$parcel$export(module.exports, "SpanStatus", function () { return $c75a254546767d85$export$beb8e6a823e89c5d; });
$parcel$export(module.exports, "spanStatusfromHttpCode", function () { return $c75a254546767d85$export$ac65c70d78fcdb55; });
$parcel$export(module.exports, "setHttpStatus", function () { return $c75a254546767d85$export$2ad6630ec8164254; });
/** The status of an Span.
 *
 * @deprecated Use string literals - if you require type casting, cast to SpanStatusType type
 */ var $c75a254546767d85$export$beb8e6a823e89c5d;
(function(SpanStatus) {
    /** The operation completed successfully. */ const Ok = "ok";
    SpanStatus["Ok"] = Ok;
    /** Deadline expired before operation could complete. */ const DeadlineExceeded = "deadline_exceeded";
    SpanStatus["DeadlineExceeded"] = DeadlineExceeded;
    /** 401 Unauthorized (actually does mean unauthenticated according to RFC 7235) */ const Unauthenticated = "unauthenticated";
    SpanStatus["Unauthenticated"] = Unauthenticated;
    /** 403 Forbidden */ const PermissionDenied = "permission_denied";
    SpanStatus["PermissionDenied"] = PermissionDenied;
    /** 404 Not Found. Some requested entity (file or directory) was not found. */ const NotFound = "not_found";
    SpanStatus["NotFound"] = NotFound;
    /** 429 Too Many Requests */ const ResourceExhausted = "resource_exhausted";
    SpanStatus["ResourceExhausted"] = ResourceExhausted;
    /** Client specified an invalid argument. 4xx. */ const InvalidArgument = "invalid_argument";
    SpanStatus["InvalidArgument"] = InvalidArgument;
    /** 501 Not Implemented */ const Unimplemented = "unimplemented";
    SpanStatus["Unimplemented"] = Unimplemented;
    /** 503 Service Unavailable */ const Unavailable = "unavailable";
    SpanStatus["Unavailable"] = Unavailable;
    /** Other/generic 5xx. */ const InternalError = "internal_error";
    SpanStatus["InternalError"] = InternalError;
    /** Unknown. Any non-standard HTTP status code. */ const UnknownError = "unknown_error";
    SpanStatus["UnknownError"] = UnknownError;
    /** The operation was cancelled (typically by the user). */ const Cancelled = "cancelled";
    SpanStatus["Cancelled"] = Cancelled;
    /** Already exists (409) */ const AlreadyExists = "already_exists";
    SpanStatus["AlreadyExists"] = AlreadyExists;
    /** Operation was rejected because the system is not in a state required for the operation's */ const FailedPrecondition = "failed_precondition";
    SpanStatus["FailedPrecondition"] = FailedPrecondition;
    /** The operation was aborted, typically due to a concurrency issue. */ const Aborted = "aborted";
    SpanStatus["Aborted"] = Aborted;
    /** Operation was attempted past the valid range. */ const OutOfRange = "out_of_range";
    SpanStatus["OutOfRange"] = OutOfRange;
    /** Unrecoverable data loss or corruption */ const DataLoss = "data_loss";
    SpanStatus["DataLoss"] = DataLoss;
})($c75a254546767d85$export$beb8e6a823e89c5d || ($c75a254546767d85$export$beb8e6a823e89c5d = {}));
/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ function $c75a254546767d85$export$5fd4dc48a2131589(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return "ok";
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return "unauthenticated";
        case 403:
            return "permission_denied";
        case 404:
            return "not_found";
        case 409:
            return "already_exists";
        case 413:
            return "failed_precondition";
        case 429:
            return "resource_exhausted";
        default:
            return "invalid_argument";
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return "unimplemented";
        case 503:
            return "unavailable";
        case 504:
            return "deadline_exceeded";
        default:
            return "internal_error";
    }
    return "unknown_error";
}
/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @deprecated Use {@link spanStatusFromHttpCode} instead.
 * This export will be removed in v8 as the signature contains a typo.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ const $c75a254546767d85$export$ac65c70d78fcdb55 = $c75a254546767d85$export$5fd4dc48a2131589;
/**
 * Sets the Http status attributes on the current span based on the http code.
 * Additionally, the span's status is updated, depending on the http code.
 */ function $c75a254546767d85$export$2ad6630ec8164254(span, httpStatus) {
    // TODO (v8): Remove these calls
    // Relay does not require us to send the status code as a tag
    // For now, just because users might expect it to land as a tag we keep sending it.
    // Same with data.
    // In v8, we replace both, simply with
    // span.setAttribute('http.response.status_code', httpStatus);
    // eslint-disable-next-line deprecation/deprecation
    span.setTag("http.status_code", String(httpStatus));
    // eslint-disable-next-line deprecation/deprecation
    span.setData("http.response.status_code", httpStatus);
    const spanStatus = $c75a254546767d85$export$5fd4dc48a2131589(httpStatus);
    if (spanStatus !== "unknown_error") span.setStatus(spanStatus);
}

});


parcelRegister("4R5py", function(module, exports) {

$parcel$export(module.exports, "Transaction", function () { return $38904f38b1685bcb$export$febc5573c75cefb0; });

var $9fGKl = parcelRequire("9fGKl");
var $iyYYs = parcelRequire("iyYYs");

var $7dwLN = parcelRequire("7dwLN");

var $l4UCE = parcelRequire("l4UCE");

var $dO7r5 = parcelRequire("dO7r5");

var $ePKuD = parcelRequire("ePKuD");

var $ceyhT = parcelRequire("ceyhT");

var $kVnKi = parcelRequire("kVnKi");

var $lBUtp = parcelRequire("lBUtp");

var $aJUSo = parcelRequire("aJUSo");
/** JSDoc */ class $38904f38b1685bcb$export$febc5573c75cefb0 extends (0, $lBUtp.Span) {
    /**
   * The reference to the current hub.
   */ // eslint-disable-next-line deprecation/deprecation
    // DO NOT yet remove this property, it is used in a hack for v7 backwards compatibility.
    /**
   * This constructor should never be called manually. Those instrumenting tracing should use
   * `Sentry.startTransaction()`, and internal methods should use `hub.startTransaction()`.
   * @internal
   * @hideconstructor
   * @hidden
   *
   * @deprecated Transactions will be removed in v8. Use spans instead.
   */ // eslint-disable-next-line deprecation/deprecation
    constructor(transactionContext, hub){
        super(transactionContext);
        this._contexts = {};
        // eslint-disable-next-line deprecation/deprecation
        this._hub = hub || (0, $l4UCE.getCurrentHub)();
        this._name = transactionContext.name || "";
        this._metadata = {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.metadata
        };
        this._trimEnd = transactionContext.trimEnd;
        // this is because transactions are also spans, and spans have a transaction pointer
        // TODO (v8): Replace this with another way to set the root span
        // eslint-disable-next-line deprecation/deprecation
        this.transaction = this;
        // If Dynamic Sampling Context is provided during the creation of the transaction, we freeze it as it usually means
        // there is incoming Dynamic Sampling Context. (Either through an incoming request, a baggage meta-tag, or other means)
        const incomingDynamicSamplingContext = this._metadata.dynamicSamplingContext;
        if (incomingDynamicSamplingContext) // We shallow copy this in case anything writes to the original reference of the passed in `dynamicSamplingContext`
        this._frozenDynamicSamplingContext = {
            ...incomingDynamicSamplingContext
        };
    }
    // This sadly conflicts with the getter/setter ordering :(
    /* eslint-disable @typescript-eslint/member-ordering */ /**
   * Getter for `name` property.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ get name() {
        return this._name;
    }
    /**
   * Setter for `name` property, which also sets `source` as custom.
   * @deprecated Use `updateName()` and `setMetadata()` instead.
   */ set name(newName) {
        // eslint-disable-next-line deprecation/deprecation
        this.setName(newName);
    }
    /**
   * Get the metadata for this transaction.
   * @deprecated Use `spanGetMetadata(transaction)` instead.
   */ get metadata() {
        // We merge attributes in for backwards compatibility
        return {
            // Defaults
            // eslint-disable-next-line deprecation/deprecation
            source: "custom",
            spanMetadata: {},
            // Legacy metadata
            ...this._metadata,
            // From attributes
            ...this._attributes[0, $ePKuD.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] && {
                source: this._attributes[0, $ePKuD.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]
            },
            ...this._attributes[0, $ePKuD.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE] && {
                sampleRate: this._attributes[0, $ePKuD.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE]
            }
        };
    }
    /**
   * Update the metadata for this transaction.
   * @deprecated Use `spanGetMetadata(transaction)` instead.
   */ set metadata(metadata) {
        this._metadata = metadata;
    }
    /* eslint-enable @typescript-eslint/member-ordering */ /**
   * Setter for `name` property, which also sets `source` on the metadata.
   *
   * @deprecated Use `.updateName()` and `.setAttribute()` instead.
   */ setName(name, source = "custom") {
        this._name = name;
        this.setAttribute((0, $ePKuD.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE), source);
    }
    /** @inheritdoc */ updateName(name) {
        this._name = name;
        return this;
    }
    /**
   * Attaches SpanRecorder to the span itself
   * @param maxlen maximum number of spans that can be recorded
   */ initSpanRecorder(maxlen = 1000) {
        // eslint-disable-next-line deprecation/deprecation
        if (!this.spanRecorder) // eslint-disable-next-line deprecation/deprecation
        this.spanRecorder = new (0, $lBUtp.SpanRecorder)(maxlen);
        // eslint-disable-next-line deprecation/deprecation
        this.spanRecorder.add(this);
    }
    /**
   * Set the context of a transaction event.
   * @deprecated Use either `.setAttribute()`, or set the context on the scope before creating the transaction.
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use top-level `setMeasurement()` instead.
   */ setMeasurement(name, value, unit = "") {
        this._measurements[name] = {
            value: value,
            unit: unit
        };
    }
    /**
   * Store metadata on this transaction.
   * @deprecated Use attributes or store data on the scope instead.
   */ setMetadata(newMetadata) {
        this._metadata = {
            ...this._metadata,
            ...newMetadata
        };
    }
    /**
   * @inheritDoc
   */ end(endTimestamp) {
        const timestampInS = (0, $ceyhT.spanTimeInputToSeconds)(endTimestamp);
        const transaction = this._finishTransaction(timestampInS);
        if (!transaction) return undefined;
        // eslint-disable-next-line deprecation/deprecation
        return this._hub.captureEvent(transaction);
    }
    /**
   * @inheritDoc
   */ toContext() {
        // eslint-disable-next-line deprecation/deprecation
        const spanContext = super.toContext();
        return (0, $9fGKl.dropUndefinedKeys)({
            ...spanContext,
            name: this._name,
            trimEnd: this._trimEnd
        });
    }
    /**
   * @inheritDoc
   */ updateWithContext(transactionContext) {
        // eslint-disable-next-line deprecation/deprecation
        super.updateWithContext(transactionContext);
        this._name = transactionContext.name || "";
        this._trimEnd = transactionContext.trimEnd;
        return this;
    }
    /**
   * @inheritdoc
   *
   * @experimental
   *
   * @deprecated Use top-level `getDynamicSamplingContextFromSpan` instead.
   */ getDynamicSamplingContext() {
        return (0, $kVnKi.getDynamicSamplingContextFromSpan)(this);
    }
    /**
   * Override the current hub with a new one.
   * Used if you want another hub to finish the transaction.
   *
   * @internal
   */ // eslint-disable-next-line deprecation/deprecation
    setHub(hub) {
        this._hub = hub;
    }
    /**
   * Get the profile id of the transaction.
   */ getProfileId() {
        if (this._contexts !== undefined && this._contexts["profile"] !== undefined) return this._contexts["profile"].profile_id;
        return undefined;
    }
    /**
   * Finish the transaction & prepare the event to send to Sentry.
   */ _finishTransaction(endTimestamp) {
        // This transaction is already finished, so we should not flush it again.
        if (this._endTime !== undefined) return undefined;
        if (!this._name) {
            (0, $7dwLN.DEBUG_BUILD) && (0, $iyYYs.logger).warn("Transaction has no name, falling back to `<unlabeled transaction>`.");
            this._name = "<unlabeled transaction>";
        }
        // just sets the end timestamp
        super.end(endTimestamp);
        // eslint-disable-next-line deprecation/deprecation
        const client = this._hub.getClient();
        if (client && client.emit) client.emit("finishTransaction", this);
        if (this._sampled !== true) {
            // At this point if `sampled !== true` we want to discard the transaction.
            (0, $7dwLN.DEBUG_BUILD) && (0, $iyYYs.logger).log("[Tracing] Discarding transaction because its trace was not chosen to be sampled.");
            if (client) client.recordDroppedEvent("sample_rate", "transaction");
            return undefined;
        }
        // eslint-disable-next-line deprecation/deprecation
        const finishedSpans = this.spanRecorder ? this.spanRecorder.spans.filter((span)=>span !== this && (0, $ceyhT.spanToJSON)(span).timestamp) : [];
        if (this._trimEnd && finishedSpans.length > 0) {
            const endTimes = finishedSpans.map((span)=>(0, $ceyhT.spanToJSON)(span).timestamp).filter(Boolean);
            this._endTime = endTimes.reduce((prev, current)=>{
                return prev > current ? prev : current;
            });
        }
        const { scope: capturedSpanScope, isolationScope: capturedSpanIsolationScope } = (0, $aJUSo.getCapturedScopesOnSpan)(this);
        // eslint-disable-next-line deprecation/deprecation
        const { metadata: metadata } = this;
        // eslint-disable-next-line deprecation/deprecation
        const { source: source } = metadata;
        const transaction = {
            contexts: {
                ...this._contexts,
                // We don't want to override trace context
                trace: (0, $ceyhT.spanToTraceContext)(this)
            },
            // TODO: Pass spans serialized via `spanToJSON()` here instead in v8.
            spans: finishedSpans,
            start_timestamp: this._startTime,
            // eslint-disable-next-line deprecation/deprecation
            tags: this.tags,
            timestamp: this._endTime,
            transaction: this._name,
            type: "transaction",
            sdkProcessingMetadata: {
                ...metadata,
                capturedSpanScope: capturedSpanScope,
                capturedSpanIsolationScope: capturedSpanIsolationScope,
                ...(0, $9fGKl.dropUndefinedKeys)({
                    dynamicSamplingContext: (0, $kVnKi.getDynamicSamplingContextFromSpan)(this)
                })
            },
            _metrics_summary: (0, $dO7r5.getMetricSummaryJsonForSpan)(this),
            ...source && {
                transaction_info: {
                    source: source
                }
            }
        };
        const hasMeasurements = Object.keys(this._measurements).length > 0;
        if (hasMeasurements) {
            (0, $7dwLN.DEBUG_BUILD) && (0, $iyYYs.logger).log("[Measurements] Adding measurements to transaction", JSON.stringify(this._measurements, undefined, 2));
            transaction.measurements = this._measurements;
        }
        // eslint-disable-next-line deprecation/deprecation
        (0, $7dwLN.DEBUG_BUILD) && (0, $iyYYs.logger).log(`[Tracing] Finishing ${this.op} transaction: ${this._name}.`);
        return transaction;
    }
}

});


parcelRegister("bbUDW", function(module, exports) {

$parcel$export(module.exports, "sampleTransaction", function () { return $825ca8f57aa7d1bd$export$b3258c3993bc9b71; });
$parcel$export(module.exports, "isValidSampleRate", function () { return $825ca8f57aa7d1bd$export$2603c8d332a51c42; });

var $dR6t7 = parcelRequire("dR6t7");
var $iyYYs = parcelRequire("iyYYs");

var $7dwLN = parcelRequire("7dwLN");

var $ePKuD = parcelRequire("ePKuD");

var $bRL0a = parcelRequire("bRL0a");

var $ceyhT = parcelRequire("ceyhT");
/**
 * Makes a sampling decision for the given transaction and stores it on the transaction.
 *
 * Called every time a transaction is created. Only transactions which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 *
 * This method muttes the given `transaction` and will set the `sampled` value on it.
 * It returns the same transaction, for convenience.
 */ function $825ca8f57aa7d1bd$export$b3258c3993bc9b71(transaction, options, samplingContext) {
    // nothing to do if tracing is not enabled
    if (!(0, $bRL0a.hasTracingEnabled)(options)) {
        // eslint-disable-next-line deprecation/deprecation
        transaction.sampled = false;
        return transaction;
    }
    // if the user has forced a sampling decision by passing a `sampled` value in their transaction context, go with that
    // eslint-disable-next-line deprecation/deprecation
    if (transaction.sampled !== undefined) {
        // eslint-disable-next-line deprecation/deprecation
        transaction.setAttribute((0, $ePKuD.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE), Number(transaction.sampled));
        return transaction;
    }
    // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` nor `enableTracing` were defined, so one of these should
    // work; prefer the hook if so
    let sampleRate;
    if (typeof options.tracesSampler === "function") {
        sampleRate = options.tracesSampler(samplingContext);
        transaction.setAttribute((0, $ePKuD.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE), Number(sampleRate));
    } else if (samplingContext.parentSampled !== undefined) sampleRate = samplingContext.parentSampled;
    else if (typeof options.tracesSampleRate !== "undefined") {
        sampleRate = options.tracesSampleRate;
        transaction.setAttribute((0, $ePKuD.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE), Number(sampleRate));
    } else {
        // When `enableTracing === true`, we use a sample rate of 100%
        sampleRate = 1;
        transaction.setAttribute((0, $ePKuD.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE), sampleRate);
    }
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get. (The
    // only valid values are booleans or numbers between 0 and 1.)
    if (!$825ca8f57aa7d1bd$export$2603c8d332a51c42(sampleRate)) {
        (0, $7dwLN.DEBUG_BUILD) && (0, $iyYYs.logger).warn("[Tracing] Discarding transaction because of invalid sample rate.");
        // eslint-disable-next-line deprecation/deprecation
        transaction.sampled = false;
        return transaction;
    }
    // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
    if (!sampleRate) {
        (0, $7dwLN.DEBUG_BUILD) && (0, $iyYYs.logger).log(`[Tracing] Discarding transaction because ${typeof options.tracesSampler === "function" ? "tracesSampler returned 0 or false" : "a negative sampling decision was inherited or tracesSampleRate is set to 0"}`);
        // eslint-disable-next-line deprecation/deprecation
        transaction.sampled = false;
        return transaction;
    }
    // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
    // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
    // eslint-disable-next-line deprecation/deprecation
    transaction.sampled = Math.random() < sampleRate;
    // if we're not going to keep it, we're done
    // eslint-disable-next-line deprecation/deprecation
    if (!transaction.sampled) {
        (0, $7dwLN.DEBUG_BUILD) && (0, $iyYYs.logger).log(`[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(sampleRate)})`);
        return transaction;
    }
    (0, $7dwLN.DEBUG_BUILD) && // eslint-disable-next-line deprecation/deprecation
    (0, $iyYYs.logger).log(`[Tracing] starting ${transaction.op} transaction - ${(0, $ceyhT.spanToJSON)(transaction).description}`);
    return transaction;
}
/**
 * Checks the given sample rate to make sure it is valid type and value (a boolean, or a number between 0 and 1).
 */ function $825ca8f57aa7d1bd$export$2603c8d332a51c42(rate) {
    // we need to check NaN explicitly because it's of type 'number' and therefore wouldn't get caught by this typecheck
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if ((0, $dR6t7.isNaN)(rate) || !(typeof rate === "number" || typeof rate === "boolean")) {
        (0, $7dwLN.DEBUG_BUILD) && (0, $iyYYs.logger).warn(`[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(rate)} of type ${JSON.stringify(typeof rate)}.`);
        return false;
    }
    // in case sampleRate is a boolean, it will get automatically cast to 1 if it's true and 0 if it's false
    if (rate < 0 || rate > 1) {
        (0, $7dwLN.DEBUG_BUILD) && (0, $iyYYs.logger).warn(`[Tracing] Given sample rate is invalid. Sample rate must be between 0 and 1. Got ${rate}.`);
        return false;
    }
    return true;
}

});


parcelRegister("4C0Qe", function(module, exports) {

$parcel$export(module.exports, "isNodeEnv", function () { return isNodeEnv; });
$parcel$export(module.exports, "dynamicRequire", function () { return dynamicRequire; });
$parcel$export(module.exports, "loadModule", function () { return loadModule; });

var $553EP = parcelRequire("553EP");

var $3uujh = parcelRequire("3uujh");
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ /**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */ function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, $553EP.isBrowserBundle)() && Object.prototype.toString.call(typeof $3uujh !== "undefined" ? $3uujh : 0) === "[object process]";
}
/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
/**
 * Helper for dynamically loading module that should work with linked dependencies.
 * The problem is that we _should_ be using `require(require.resolve(moduleName, { paths: [cwd()] }))`
 * However it's _not possible_ to do that with Webpack, as it has to know all the dependencies during
 * build time. `require.resolve` is also not available in any other way, so we cannot create,
 * a fake helper like we do with `dynamicRequire`.
 *
 * We always prefer to use local package, thus the value is not returned early from each `try/catch` block.
 * That is to mimic the behavior of `require.resolve` exactly.
 *
 * @param moduleName module name to require
 * @returns possibly required module
 */ function loadModule(moduleName) {
    let mod;
    try {
        mod = dynamicRequire(module, moduleName);
    } catch (e) {
    // no-empty
    }
    try {
        const { cwd } = dynamicRequire(module, "process");
        mod = dynamicRequire(module, `${cwd()}/node_modules/${moduleName}`);
    } catch (e) {
    // no-empty
    }
    return mod;
}

});
parcelRegister("553EP", function(module, exports) {

$parcel$export(module.exports, "isBrowserBundle", function () { return $3b3041b262b62f22$export$2928c40372e623c0; });
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $3b3041b262b62f22$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== "undefined" && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function $3b3041b262b62f22$export$8ad33f488b1ab046() {
    // @ts-expect-error "npm" is injected by rollup during build process
    return "npm";
}

});



/*! DSFR v1.13.2 | SPDX-License-Identifier: MIT | License-Filename: LICENSE.md | restricted use (see terms and conditions) */ const $0e66457a70c08667$var$e = new class {
    constructor(){
        this.modules = {};
    }
    create(e) {
        const t1 = new e;
        this.modules[t1.type] = t1;
    }
    getModule(e) {
        return this.modules[e];
    }
    add(e, t1) {
        this.modules[e].add(t1);
    }
    remove(e, t1) {
        this.modules[e].remove(t1);
    }
    get isActive() {
        return this._isActive;
    }
    set isActive(e) {
        if (e === this._isActive) return;
        this._isActive = e;
        const t1 = Object.keys(this.modules).map((e)=>this.modules[e]);
        if (e) for (const e of t1)e.activate();
        else for (const e of t1)e.deactivate();
    }
    get isLegacy() {
        return this._isLegacy;
    }
    set isLegacy(e) {
        e !== this._isLegacy && (this._isLegacy = e);
    }
}, $0e66457a70c08667$var$t1 = "fr", $0e66457a70c08667$var$s = "dsfr", $0e66457a70c08667$var$i = "@gouvfr", $0e66457a70c08667$var$n = "1.13.2";
class $0e66457a70c08667$var$r {
    constructor(e, t1, s, i){
        switch(this.level = e, this.light = t1, this.dark = s, i){
            case "warn":
                this.logger = console.warn;
                break;
            case "error":
                this.logger = console.error;
                break;
            default:
                this.logger = console.log;
        }
    }
    log(...e) {
        const t1 = new $0e66457a70c08667$var$a($0e66457a70c08667$var$s);
        for (const s of e)t1.add(s);
        this.print(t1);
    }
    print(e) {
        e.setColor(this.color), this.logger.apply(console, e.getMessage());
    }
    get color() {
        return window.matchMedia("(prefers-color-scheme: dark)").matches ? this.dark : this.light;
    }
}
class $0e66457a70c08667$var$a {
    constructor(e){
        this.inputs = [
            "%c"
        ], this.styles = [
            "font-family:Marianne",
            "line-height: 1.5"
        ], this.objects = [], e && this.add(`${e} :`);
    }
    add(e) {
        switch(typeof e){
            case "object":
            case "function":
                this.inputs.push("%o "), this.objects.push(e);
                break;
            default:
                this.inputs.push(`${e} `);
        }
    }
    setColor(e) {
        this.styles.push(`color:${e}`);
    }
    getMessage() {
        return [
            this.inputs.join(""),
            this.styles.join(";"),
            ...this.objects
        ];
    }
}
const $0e66457a70c08667$var$o = {
    log: new $0e66457a70c08667$var$r(0, "#616161", "#989898"),
    debug: new $0e66457a70c08667$var$r(1, "#000091", "#8B8BFF"),
    info: new $0e66457a70c08667$var$r(2, "#007c3b", "#00ed70"),
    warn: new $0e66457a70c08667$var$r(3, "#ba4500", "#fa5c00", "warn"),
    error: new $0e66457a70c08667$var$r(4, "#D80600", "#FF4641", "error")
};
const $0e66457a70c08667$var$h = new class {
    constructor(){
        this.level = 2;
        for(const e in $0e66457a70c08667$var$o){
            const t1 = $0e66457a70c08667$var$o[e];
            this[e] = (...e)=>{
                this.level <= t1.level && t1.log.apply(t1, e);
            }, this[e].print = t1.print.bind(t1);
        }
    }
    state() {
        const t1 = new $0e66457a70c08667$var$a;
        t1.add($0e66457a70c08667$var$e), this.log.print(t1);
    }
    tree() {
        const t1 = $0e66457a70c08667$var$e.getModule("stage");
        if (!t1) return;
        const s = new $0e66457a70c08667$var$a;
        this._branch(t1.root, 0, s), this.log.print(s);
    }
    _branch(e, t1, s) {
        let i = "";
        if (t1 > 0) {
            let e = "";
            for(let s = 0; s < t1; s++)e += "    ";
            i += e + "\u2514\u2500 ";
        }
        i += `[${e.id}] ${e.html}`, s.add(i), s.add({
            "@": e
        }), s.add("\n");
        for (const n of e.children)i += this._branch(n, t1 + 1, s);
    }
}, $0e66457a70c08667$var$c = (e)=>{
    "loading" !== document.readyState ? window.requestAnimationFrame(e) : document.addEventListener("DOMContentLoaded", e);
}, $0e66457a70c08667$var$l = {
    AUTO: "auto",
    MANUAL: "manual",
    RUNTIME: "runtime",
    LOADED: "loaded",
    VUE: "vue",
    ANGULAR: "angular",
    REACT: "react"
}, $0e66457a70c08667$var$d = (e, t1, s = null, i = !0, n = !1)=>{
    const r = {
        bubbles: !0 === i,
        cancelable: !0 === n
    };
    s && (r.detail = s);
    const a = new CustomEvent(t1, r);
    e.dispatchEvent(a);
}, $0e66457a70c08667$var$u = (e, t1 = null, s = !1, i = !1)=>$0e66457a70c08667$var$d(document.documentElement, e, t1, s, i), $0e66457a70c08667$var$g = (e)=>`${$0e66457a70c08667$var$t1}-${e}`;
$0e66457a70c08667$var$g.selector = (e, t1)=>(void 0 === t1 && (t1 = "."), `${t1}${$0e66457a70c08667$var$g(e)}`), ($0e66457a70c08667$var$g.attr = (e)=>`data-${$0e66457a70c08667$var$g(e)}`).selector = (e, t1)=>{
    let s = $0e66457a70c08667$var$g.attr(e);
    return void 0 !== t1 && (s += `="${t1}"`), `[${s}]`;
}, $0e66457a70c08667$var$g.event = (e)=>`${$0e66457a70c08667$var$s}.${e}`, $0e66457a70c08667$var$g.emission = (e, t1)=>`emission:${e}.${t1}`;
const $0e66457a70c08667$var$p = {
    READY: $0e66457a70c08667$var$g.event("ready"),
    START: $0e66457a70c08667$var$g.event("start"),
    STOP: $0e66457a70c08667$var$g.event("stop"),
    RENDER: $0e66457a70c08667$var$g.event("render"),
    RESIZE: $0e66457a70c08667$var$g.event("resize"),
    BREAKPOINT: $0e66457a70c08667$var$g.event("breakpoint"),
    SCROLL_LOCK: $0e66457a70c08667$var$g.event("scroll-lock"),
    SCROLL_UNLOCK: $0e66457a70c08667$var$g.event("scroll-unlock")
};
const $0e66457a70c08667$var$m = new class {
    constructor(){
        this._mode = $0e66457a70c08667$var$l.AUTO, this.isStarted = !1, this.starting = this.start.bind(this), this.preventManipulation = !1;
    }
    configure(e = {}, t1, s) {
        this.startCallback = t1;
        const i = e.production && (!s || "false" !== s.production);
        switch(!0){
            case s && !isNaN(s.level):
                $0e66457a70c08667$var$h.level = Number(s.level);
                break;
            case s && s.verbose && ("true" === s.verbose || 1 === s.verbose):
                $0e66457a70c08667$var$h.level = 0;
                break;
            case i:
                $0e66457a70c08667$var$h.level = 999;
                break;
            case e.verbose:
                $0e66457a70c08667$var$h.level = 0;
        }
        $0e66457a70c08667$var$h.info(`version ${$0e66457a70c08667$var$n}`), $0e66457a70c08667$var$u($0e66457a70c08667$var$p.READY), this.mode = e.mode || $0e66457a70c08667$var$l.AUTO;
    }
    set mode(e) {
        switch(e){
            case $0e66457a70c08667$var$l.AUTO:
                this.preventManipulation = !1, t1 = this.starting, $0e66457a70c08667$var$c(t1);
                break;
            case $0e66457a70c08667$var$l.LOADED:
                this.preventManipulation = !1, $0e66457a70c08667$var$c(this.starting);
                break;
            case $0e66457a70c08667$var$l.RUNTIME:
                this.preventManipulation = !1, this.start();
                break;
            case $0e66457a70c08667$var$l.MANUAL:
                this.preventManipulation = !1;
                break;
            case $0e66457a70c08667$var$l.VUE:
            case $0e66457a70c08667$var$l.ANGULAR:
            case $0e66457a70c08667$var$l.REACT:
                this.preventManipulation = !0;
                break;
            default:
                return void $0e66457a70c08667$var$h.error("Illegal mode");
        }
        var t1;
        this._mode = e, $0e66457a70c08667$var$h.info(`mode set to ${e}`);
    }
    get mode() {
        return this._mode;
    }
    start() {
        $0e66457a70c08667$var$h.info("start"), this.startCallback();
    }
};
class $0e66457a70c08667$var$_ {
    constructor(){
        this._collection = [];
    }
    forEach(e) {
        this._collection.forEach(e);
    }
    map(e) {
        return this._collection.map(e);
    }
    get length() {
        return this._collection.length;
    }
    add(e) {
        return !(this._collection.indexOf(e) > -1) && (this._collection.push(e), this.onAdd && this.onAdd(), this.onPopulate && 1 === this._collection.length && this.onPopulate(), !0);
    }
    remove(e) {
        const t1 = this._collection.indexOf(e);
        if (-1 === t1) return !1;
        this._collection.splice(t1, 1), this.onRemove && this.onRemove(), this.onEmpty && 0 === this._collection.length && this.onEmpty();
    }
    execute(...e) {
        for (const t1 of this._collection)t1 && t1.apply(null, e);
    }
    clear() {
        this._collection.length = 0;
    }
    clone() {
        const e = new $0e66457a70c08667$var$_;
        return e._collection = this._collection.slice(), e;
    }
    get collection() {
        return this._collection;
    }
}
class $0e66457a70c08667$var$b extends $0e66457a70c08667$var$_ {
    constructor(e){
        super(), this.type = e, this.isActive = !1;
    }
    activate() {}
    deactivate() {}
}
const $0e66457a70c08667$var$E = (e, t1)=>Array.prototype.slice.call(e.querySelectorAll(t1)), $0e66457a70c08667$var$f = (e, t1)=>{
    const s = e.parentElement;
    return s.matches(t1) ? s : s === document.documentElement ? null : $0e66457a70c08667$var$f(s, t1);
};
class $0e66457a70c08667$var$A {
    constructor(e, t1, s){
        this.selector = e, this.InstanceClass = t1, this.creator = s, this.instances = new $0e66457a70c08667$var$_, this.isIntroduced = !1, this._instanceClassName = this.InstanceClass.instanceClassName, this._instanceClassNames = this.getInstanceClassNames(this.InstanceClass), this._property = this._instanceClassName.substring(0, 1).toLowerCase() + this._instanceClassName.substring(1);
        const i = this._instanceClassName.replace(/[^a-zA-Z0-9]+/g, "-").replace(/([A-Z]+)([A-Z][a-z])/g, "$1-$2").replace(/([a-z])([A-Z])/g, "$1-$2").replace(/([0-9])([^0-9])/g, "$1-$2").replace(/([^0-9])([0-9])/g, "$1-$2").toLowerCase();
        this._attribute = $0e66457a70c08667$var$g.attr(`js-${i}`);
    }
    getInstanceClassNames(e) {
        const t1 = Object.getPrototypeOf(e);
        return t1 && "Instance" !== t1.instanceClassName ? [
            ...this.getInstanceClassNames(t1),
            e.instanceClassName
        ] : [
            e.instanceClassName
        ];
    }
    hasInstanceClassName(e) {
        return this._instanceClassNames.indexOf(e) > -1;
    }
    introduce() {
        this.isIntroduced || (this.isIntroduced = !0, $0e66457a70c08667$var$e.getModule("stage").parse(document.documentElement, this));
    }
    parse(e, t1) {
        const s = [];
        return e.matches && e.matches(this.selector) && s.push(e), !t1 && e.querySelectorAll && e.querySelector(this.selector) && s.push.apply(s, $0e66457a70c08667$var$E(e, this.selector)), s;
    }
    create(e) {
        if (!e.node.matches(this.selector)) return;
        const t1 = new this.InstanceClass;
        return this.instances.add(t1), t1;
    }
    remove(e) {
        this.instances.remove(e);
    }
    dispose() {
        const e = this.instances.collection;
        for(let t1 = e.length - 1; t1 > -1; t1--)e[t1]._dispose();
        this.creator = null;
    }
    get instanceClassName() {
        return this._instanceClassName;
    }
    get instanceClassNames() {
        return this._instanceClassNames;
    }
    get property() {
        return this._property;
    }
    get attribute() {
        return this._attribute;
    }
}
class $0e66457a70c08667$var$T extends $0e66457a70c08667$var$b {
    constructor(){
        super("register");
    }
    register(t1, s, i) {
        const n = new $0e66457a70c08667$var$A(t1, s, i);
        return this.add(n), $0e66457a70c08667$var$e.isActive && n.introduce(), n;
    }
    activate() {
        for (const e of this.collection)e.introduce();
    }
    remove(e) {
        e.dispose(), super.remove(e);
    }
}
let $0e66457a70c08667$var$v = 0;
class $0e66457a70c08667$var$S {
    constructor(e, t1){
        t1 ? this.id = t1 : ($0e66457a70c08667$var$v++, this.id = $0e66457a70c08667$var$v), this.node = e, this.attributeNames = [], this.instances = [], this._children = [], this._parent = null, this._projects = [];
    }
    get proxy() {
        const e = this;
        if (!this._proxy) {
            this._proxy = {
                id: this.id,
                get parent () {
                    return e.parent ? e.parent.proxy : null;
                },
                get children () {
                    return e.children.map((e)=>e.proxy);
                }
            };
            for (const e of this.instances)this._proxy[e.registration.property] = e.proxy;
        }
        return this._proxy;
    }
    get html() {
        if (!this.node || !this.node.outerHTML) return "";
        const e = this.node.outerHTML.indexOf(">");
        return this.node.outerHTML.substring(0, e + 1);
    }
    project(e) {
        -1 === this._projects.indexOf(e) && this._projects.push(e);
    }
    populate() {
        const e = this._projects.slice();
        this._projects.length = 0;
        for (const t1 of e)this.create(t1);
    }
    create(e) {
        if (this.hasInstance(e.instanceClassName)) return;
        $0e66457a70c08667$var$h.debug(`create instance of ${e.instanceClassName} on element [${this.id}]`);
        const t1 = e.create(this);
        this.instances.push(t1), t1._config(this, e), this._proxy && (this._proxy[e.property] = t1.proxy);
    }
    remove(e) {
        const t1 = this.instances.indexOf(e);
        t1 > -1 && this.instances.splice(t1, 1), this._proxy && delete this._proxy[e.registration.property];
    }
    get parent() {
        return this._parent;
    }
    get ascendants() {
        return [
            this.parent,
            ...this.parent.ascendants
        ];
    }
    get children() {
        return this._children;
    }
    get descendants() {
        const e = [
            ...this._children
        ];
        return this._children.forEach((t1)=>e.push(...t1.descendants)), e;
    }
    addChild(e, t1) {
        return this._children.indexOf(e) > -1 ? null : (e._parent = this, !isNaN(t1) && t1 > -1 && t1 < this._children.length ? this._children.splice(t1, 0, e) : this._children.push(e), e);
    }
    removeChild(e) {
        const t1 = this._children.indexOf(e);
        if (-1 === t1) return null;
        e._parent = null, this._children.splice(t1, 1);
    }
    emit(t1, s) {
        const i = $0e66457a70c08667$var$e.getModule("stage").collection, n = [];
        for (const e of i)n.push(...e._emit(t1, s));
        return n;
    }
    _emit(e, t1) {
        const s = [];
        for (const i of this.instances)s.push(...i._emitter.emit(e, t1));
        return s;
    }
    ascend(e, t1) {
        return this._parent ? this._parent._ascend(e, t1) : [];
    }
    _ascend(e, t1) {
        const s = [];
        for (const i of this.instances)s.push(...i._ascent.emit(e, t1));
        return this._parent && s.push(...this._parent._ascend(e, t1)), s;
    }
    descend(e, t1) {
        const s = [];
        for (const i of this._children)s.push(...i._descend(e, t1));
        return s;
    }
    _descend(e, t1) {
        const s = [];
        for (const i of this.instances)s.push(...i._descent.emit(e, t1));
        for (const i of this._children)s.push(...i._descend(e, t1));
        return s;
    }
    getInstance(e) {
        for (const t1 of this.instances)if (t1.registration.hasInstanceClassName(e)) return t1;
        return null;
    }
    hasInstance(e) {
        return null !== this.getInstance(e);
    }
    getDescendantInstances(e, t1, s) {
        if (!e) return [];
        const i = [];
        for (const n of this._children){
            const r = n.getInstance(e);
            r && (i.push(r), s) || t1 && n.hasInstance(t1) || !n.children.length || i.push.apply(i, n.getDescendantInstances(e, t1, s));
        }
        return i;
    }
    getAscendantInstance(e, t1) {
        if (!e || !this._parent) return null;
        const s = this._parent.getInstance(e);
        return s || (t1 && this._parent.hasInstance(t1) ? null : this._parent.getAscendantInstance(e, t1));
    }
    dispose() {
        for(let e = this.instances.length - 1; e >= 0; e--){
            const t1 = this.instances[e];
            t1 && t1._dispose();
        }
        this.instances.length = 0, $0e66457a70c08667$var$e.remove("stage", this), this.parent.removeChild(this), this._children.length = 0, $0e66457a70c08667$var$h.debug(`remove element [${this.id}] ${this.html}`);
    }
    prepare(e) {
        -1 === this.attributeNames.indexOf(e) && this.attributeNames.push(e);
    }
    examine() {
        const e = this.attributeNames.slice();
        this.attributeNames.length = 0;
        for(let t1 = this.instances.length - 1; t1 > -1; t1--)this.instances[t1].examine(e);
    }
}
const $0e66457a70c08667$var$y = {
    CLICK: $0e66457a70c08667$var$g.emission("root", "click"),
    KEYDOWN: $0e66457a70c08667$var$g.emission("root", "keydown"),
    KEYUP: $0e66457a70c08667$var$g.emission("root", "keyup")
}, $0e66457a70c08667$var$C = {
    TAB: {
        id: "tab",
        value: 9
    },
    ESCAPE: {
        id: "escape",
        value: 27
    },
    END: {
        id: "end",
        value: 35
    },
    HOME: {
        id: "home",
        value: 36
    },
    LEFT: {
        id: "left",
        value: 37
    },
    UP: {
        id: "up",
        value: 38
    },
    RIGHT: {
        id: "right",
        value: 39
    },
    DOWN: {
        id: "down",
        value: 40
    }
}, $0e66457a70c08667$var$N = (e)=>Object.values($0e66457a70c08667$var$C).filter((t1)=>t1.value === e)[0];
class $0e66457a70c08667$var$D extends $0e66457a70c08667$var$S {
    constructor(){
        super(document.documentElement, "root"), this.node.setAttribute($0e66457a70c08667$var$g.attr("js"), !0), this.listen();
    }
    listen() {
        document.documentElement.addEventListener("click", this.click.bind(this), {
            capture: !0
        }), document.documentElement.addEventListener("keydown", this.keydown.bind(this), {
            capture: !0
        }), document.documentElement.addEventListener("keyup", this.keyup.bind(this), {
            capture: !0
        });
    }
    click(e) {
        this.emit($0e66457a70c08667$var$y.CLICK, e.target);
    }
    keydown(e) {
        this.emit($0e66457a70c08667$var$y.KEYDOWN, $0e66457a70c08667$var$N(e.keyCode));
    }
    keyup(e) {
        this.emit($0e66457a70c08667$var$y.KEYUP, $0e66457a70c08667$var$N(e.keyCode));
    }
}
class $0e66457a70c08667$var$R extends $0e66457a70c08667$var$b {
    constructor(){
        super("stage"), this.root = new $0e66457a70c08667$var$D, super.add(this.root), this.observer = new MutationObserver(this.mutate.bind(this)), this.modifications = [], this.willModify = !1, this.modifying = this.modify.bind(this);
    }
    hasElement(e) {
        for (const t1 of this.collection)if (t1.node === e) return !0;
        return !1;
    }
    getElement(e) {
        for (const t1 of this.collection)if (t1.node === e) return t1;
        const t1 = new $0e66457a70c08667$var$S(e);
        return this.add(t1), $0e66457a70c08667$var$h.debug(`add element [${t1.id}] ${t1.html}`), t1;
    }
    getProxy(e) {
        if (!this.hasElement(e)) return null;
        return this.getElement(e).proxy;
    }
    add(e) {
        super.add(e), this.put(e, this.root);
    }
    put(e, t1) {
        let s = 0;
        for(let i = t1.children.length - 1; i > -1; i--){
            const n = t1.children[i], r = e.node.compareDocumentPosition(n.node);
            if (r & Node.DOCUMENT_POSITION_CONTAINS) return void this.put(e, n);
            if (r & Node.DOCUMENT_POSITION_CONTAINED_BY) t1.removeChild(n), e.addChild(n, 0);
            else if (r & Node.DOCUMENT_POSITION_PRECEDING) {
                s = i + 1;
                break;
            }
        }
        t1.addChild(e, s);
    }
    activate() {
        this.observer.observe(document.documentElement, {
            childList: !0,
            subtree: !0,
            attributes: !0
        });
    }
    deactivate() {
        this.observer.disconnect();
    }
    mutate(e) {
        const t1 = [];
        e.forEach((e)=>{
            switch(e.type){
                case "childList":
                    e.removedNodes.forEach((e)=>this.dispose(e)), e.addedNodes.forEach((e)=>this.parse(e));
                    break;
                case "attributes":
                    if (this.hasElement(e.target)) {
                        const s = this.getElement(e.target);
                        s.prepare(e.attributeName), -1 === t1.indexOf(s) && t1.push(s);
                        for (const e of s.descendants)-1 === t1.indexOf(e) && t1.push(e);
                    }
                    -1 === this.modifications.indexOf(e.target) && this.modifications.push(e.target);
            }
        }), t1.forEach((e)=>e.examine()), this.modifications.length && !this.willModify && (this.willModify = !0, window.requestAnimationFrame(this.modifying));
    }
    modify() {
        this.willModify = !1;
        const e = this.modifications.slice();
        this.modifications.length = 0;
        for (const t1 of e)document.documentElement.contains(t1) && this.parse(t1);
    }
    dispose(e) {
        const t1 = [];
        this.forEach((s)=>{
            e.contains(s.node) && t1.push(s);
        });
        for (const e of t1)e.dispose(), this.remove(e);
    }
    parse(t1, s, i) {
        const n = s ? [
            s
        ] : $0e66457a70c08667$var$e.getModule("register").collection, r = [];
        for (const e of n){
            const s = e.parse(t1, i);
            for (const t1 of s){
                const s = this.getElement(t1);
                s.project(e), -1 === r.indexOf(s) && r.push(s);
            }
        }
        for (const e of r)e.populate();
    }
}
class $0e66457a70c08667$var$w extends $0e66457a70c08667$var$b {
    constructor(){
        super("render"), this.rendering = this.render.bind(this), this.nexts = new $0e66457a70c08667$var$_;
    }
    activate() {
        window.requestAnimationFrame(this.rendering);
    }
    request(e) {
        this.nexts.add(e);
    }
    render() {
        if (!$0e66457a70c08667$var$e.isActive) return;
        if (window.requestAnimationFrame(this.rendering), this.forEach((e)=>e.render()), !this.nexts.length) return;
        const t1 = this.nexts.clone();
        this.nexts.clear(), t1.forEach((e)=>e.next()), $0e66457a70c08667$var$u($0e66457a70c08667$var$p.RENDER);
    }
}
class $0e66457a70c08667$var$L extends $0e66457a70c08667$var$b {
    constructor(){
        super("resize"), this.requireResize = !1, this.resizing = this.resize.bind(this);
        const e = this.request.bind(this);
        document.fonts && document.fonts.ready.then(e), window.addEventListener("resize", e), window.addEventListener("orientationchange", e);
    }
    activate() {
        this.request();
    }
    request() {
        this.requireResize || (this.requireResize = !0, window.requestAnimationFrame(this.resizing));
    }
    resize() {
        this.requireResize && (this.forEach((e)=>e.resize()), this.requireResize = !1, $0e66457a70c08667$var$u($0e66457a70c08667$var$p.RESIZE));
    }
}
class $0e66457a70c08667$var$I extends $0e66457a70c08667$var$b {
    constructor(){
        super("lock"), this._isLocked = !1, this._scrollY = 0, this.onPopulate = this.lock.bind(this), this.onEmpty = this.unlock.bind(this);
    }
    get isLocked() {
        return this._isLocked;
    }
    lock() {
        if (!this._isLocked) {
            this._isLocked = !0, this._scrollY = window.scrollY;
            const e = window.innerWidth - document.documentElement.clientWidth;
            document.documentElement.setAttribute($0e66457a70c08667$var$g.attr("scrolling"), "false"), document.body.style.top = -this._scrollY + "px", this.behavior = getComputedStyle(document.documentElement).getPropertyValue("scroll-behavior"), "smooth" === this.behavior && (document.documentElement.style.scrollBehavior = "auto"), e > 0 && document.documentElement.style.setProperty("--scrollbar-width", `${e}px`), $0e66457a70c08667$var$u($0e66457a70c08667$var$p.SCROLL_LOCK);
        }
    }
    unlock() {
        this._isLocked && (this._isLocked = !1, document.documentElement.removeAttribute($0e66457a70c08667$var$g.attr("scrolling")), document.body.style.top = "", window.scrollTo(0, this._scrollY), "smooth" === this.behavior && document.documentElement.style.removeProperty("scroll-behavior"), document.documentElement.style.removeProperty("--scrollbar-width"), $0e66457a70c08667$var$u($0e66457a70c08667$var$p.SCROLL_UNLOCK));
    }
    move(e) {
        this._isLocked ? (this._scrollY += e, document.body.style.top = -this._scrollY + "px") : window.scrollTo(0, window.scrollY + e);
    }
}
class $0e66457a70c08667$var$x extends $0e66457a70c08667$var$b {
    constructor(){
        super("load"), this.loading = this.load.bind(this);
    }
    activate() {
        window.addEventListener("load", this.loading);
    }
    load() {
        this.forEach((e)=>e.load());
    }
}
const $0e66457a70c08667$var$O = [
    "Marianne",
    "Spectral"
];
class $0e66457a70c08667$var$P extends $0e66457a70c08667$var$b {
    constructor(){
        super("font-swap"), this.swapping = this.swap.bind(this);
    }
    activate() {
        document.fonts && document.fonts.addEventListener("loadingdone", this.swapping);
    }
    swap() {
        const e = $0e66457a70c08667$var$O.filter((e)=>document.fonts.check(`16px ${e}`));
        this.forEach((t1)=>t1.swapFont(e));
    }
}
class $0e66457a70c08667$var$k extends $0e66457a70c08667$var$b {
    constructor(){
        super("mouse-move"), this.requireMove = !1, this._isMoving = !1, this.moving = this.move.bind(this), this.requesting = this.request.bind(this), this.onPopulate = this.listen.bind(this), this.onEmpty = this.unlisten.bind(this);
    }
    listen() {
        this._isMoving || (this._isMoving = !0, this.requireMove = !1, document.documentElement.addEventListener("mousemove", this.requesting));
    }
    unlisten() {
        this._isMoving && (this._isMoving = !1, this.requireMove = !1, document.documentElement.removeEventListener("mousemove", this.requesting));
    }
    request(e) {
        this._isMoving && (this.point = {
            x: e.clientX,
            y: e.clientY
        }, this.requireMove || (this.requireMove = !0, window.requestAnimationFrame(this.moving)));
    }
    move() {
        this.requireMove && (this.forEach((e)=>e.mouseMove(this.point)), this.requireMove = !1);
    }
}
class $0e66457a70c08667$var$M extends $0e66457a70c08667$var$b {
    constructor(){
        super("hash"), this.handling = this.handle.bind(this), this.getLocationHash();
    }
    activate() {
        window.addEventListener("hashchange", this.handling);
    }
    deactivate() {
        window.removeEventListener("hashchange", this.handling);
    }
    _sanitize(e) {
        return "#" === e.charAt(0) ? e.substring(1) : e;
    }
    set hash(e) {
        const t1 = this._sanitize(e);
        this._hash !== t1 && (window.location.hash = t1);
    }
    get hash() {
        return this._hash;
    }
    getLocationHash() {
        const e = window.location.hash;
        this._hash = this._sanitize(e);
    }
    handle(e) {
        this.getLocationHash(), this.forEach((t1)=>t1.handleHash(this._hash, e));
    }
}
const $0e66457a70c08667$var$G = new class {
    constructor(){
        $0e66457a70c08667$var$e.create($0e66457a70c08667$var$T), $0e66457a70c08667$var$e.create($0e66457a70c08667$var$R), $0e66457a70c08667$var$e.create($0e66457a70c08667$var$w), $0e66457a70c08667$var$e.create($0e66457a70c08667$var$L), $0e66457a70c08667$var$e.create($0e66457a70c08667$var$I), $0e66457a70c08667$var$e.create($0e66457a70c08667$var$x), $0e66457a70c08667$var$e.create($0e66457a70c08667$var$P), $0e66457a70c08667$var$e.create($0e66457a70c08667$var$k), $0e66457a70c08667$var$e.create($0e66457a70c08667$var$M);
        const t1 = $0e66457a70c08667$var$e.getModule("register");
        this.register = t1.register.bind(t1);
    }
    get isActive() {
        return $0e66457a70c08667$var$e.isActive;
    }
    start() {
        $0e66457a70c08667$var$h.debug("START"), $0e66457a70c08667$var$e.isActive = !0, $0e66457a70c08667$var$u($0e66457a70c08667$var$p.START);
    }
    stop() {
        $0e66457a70c08667$var$h.debug("STOP"), $0e66457a70c08667$var$e.isActive = !1, $0e66457a70c08667$var$u($0e66457a70c08667$var$p.STOP);
    }
};
const $0e66457a70c08667$var$$ = (e)=>{
    switch(!0){
        case e.hover:
            return "-hover";
        case e.active:
            return "-active";
        default:
            return "";
    }
}, $0e66457a70c08667$var$H = new class {
    getColor(e, t1, s, i = {}) {
        const n = `--${e}-${t1}-${s}${$0e66457a70c08667$var$$(i)}`;
        return getComputedStyle(document.documentElement).getPropertyValue(n).trim() || null;
    }
}, $0e66457a70c08667$var$U = (e)=>"." === e.charAt(0) ? e.substr(1) : e, $0e66457a70c08667$var$B = (e)=>{
    switch(!0){
        case !e.className:
            return [];
        case "string" == typeof e.className:
            return e.className.split(" ");
        case "string" == typeof e.className.baseVal:
            return e.className.baseVal.split(" ");
    }
    return [];
}, $0e66457a70c08667$var$F = (e, t1, s)=>{
    t1 = $0e66457a70c08667$var$U(t1);
    const i = $0e66457a70c08667$var$B(e), n = i.indexOf(t1);
    !0 === s ? n > -1 && i.splice(n, 1) : -1 === n && i.push(t1), e.className = i.join(" ");
}, $0e66457a70c08667$var$W = (e, t1)=>$0e66457a70c08667$var$F(e, t1), $0e66457a70c08667$var$q = (e, t1)=>$0e66457a70c08667$var$F(e, t1, !0), $0e66457a70c08667$var$z = (e, t1)=>$0e66457a70c08667$var$B(e).indexOf($0e66457a70c08667$var$U(t1)) > -1, $0e66457a70c08667$var$K = [
    '[tabindex]:not([tabindex="-1"])',
    "a[href]",
    "button:not([disabled])",
    "input:not([disabled])",
    "select:not([disabled])",
    "textarea:not([disabled])",
    "audio[controls]",
    "video[controls]",
    '[contenteditable]:not([contenteditable="false"])',
    "details>summary:first-of-type",
    "details",
    "iframe"
].join(), $0e66457a70c08667$var$j = (e)=>e.querySelectorAll($0e66457a70c08667$var$K);
let $0e66457a70c08667$var$V = 0;
const $0e66457a70c08667$var$Y = (e)=>{
    if (!document.getElementById(e)) return e;
    let t1 = !0;
    const s = e;
    for(; t1;)$0e66457a70c08667$var$V++, e = `${s}-${$0e66457a70c08667$var$V}`, t1 = document.getElementById(e);
    return e;
}, $0e66457a70c08667$var$X = {
    addClass: $0e66457a70c08667$var$W,
    hasClass: $0e66457a70c08667$var$z,
    removeClass: $0e66457a70c08667$var$q,
    queryParentSelector: $0e66457a70c08667$var$f,
    querySelectorAllArray: $0e66457a70c08667$var$E,
    queryActions: $0e66457a70c08667$var$j,
    uniqueId: $0e66457a70c08667$var$Y,
    dispatch: $0e66457a70c08667$var$d
};
const $0e66457a70c08667$var$Q = {
    DataURISVG: class {
        constructor(e = 0, t1 = 0){
            this._width = e, this._height = t1, this._content = "";
        }
        get width() {
            return this._width;
        }
        set width(e) {
            this._width = e;
        }
        get height() {
            return this._height;
        }
        set height(e) {
            this._height = e;
        }
        get content() {
            return this._content;
        }
        set content(e) {
            this._content = e;
        }
        getDataURI(e = !1) {
            let t1 = `<svg xmlns='http://www.w3.org/2000/svg' viewbox='0 0 ${this._width} ${this._height}' width='${this._width}px' height='${this._height}px'>${this._content}</svg>`;
            return t1 = t1.replace(/#/gi, "%23"), e && (t1 = t1.replace(/</gi, "%3C"), t1 = t1.replace(/>/gi, "%3E"), t1 = t1.replace(/"/gi, "'"), t1 = t1.replace(/{/gi, "%7B"), t1 = t1.replace(/}/gi, "%7D")), `data:image/svg+xml;charset=utf8,${t1}`;
        }
    }
}, $0e66457a70c08667$var$Z = {
    supportLocalStorage: ()=>{
        try {
            return "localStorage" in window && null !== window.localStorage;
        } catch (e) {
            return !1;
        }
    },
    supportAspectRatio: ()=>!!window.CSS && CSS.supports("aspect-ratio: 16 / 9")
}, $0e66457a70c08667$var$J = {
    TransitionSelector: {
        NONE: $0e66457a70c08667$var$g.selector("transition-none")
    }
}, $0e66457a70c08667$var$ee = (e, ...t1)=>(t1.forEach((t1)=>{
        const s = Object.keys(t1).reduce((e, s)=>(e[s] = Object.getOwnPropertyDescriptor(t1, s), e), {});
        Object.getOwnPropertySymbols(t1).forEach((e)=>{
            const i = Object.getOwnPropertyDescriptor(t1, e);
            i.enumerable && (s[e] = i);
        }), Object.defineProperties(e, s);
    }), e), $0e66457a70c08667$var$te = {
    completeAssign: $0e66457a70c08667$var$ee
}, $0e66457a70c08667$var$se = {}, $0e66457a70c08667$var$ie = {};
Object.defineProperty($0e66457a70c08667$var$ie, "isLegacy", {
    get: ()=>$0e66457a70c08667$var$e.isLegacy
}), $0e66457a70c08667$var$ie.setLegacy = ()=>{
    $0e66457a70c08667$var$e.isLegacy = !0;
}, $0e66457a70c08667$var$se.legacy = $0e66457a70c08667$var$ie, $0e66457a70c08667$var$se.dom = $0e66457a70c08667$var$X, $0e66457a70c08667$var$se.image = $0e66457a70c08667$var$Q, $0e66457a70c08667$var$se.support = $0e66457a70c08667$var$Z, $0e66457a70c08667$var$se.motion = $0e66457a70c08667$var$J, $0e66457a70c08667$var$se.property = $0e66457a70c08667$var$te, $0e66457a70c08667$var$se.ns = $0e66457a70c08667$var$g, $0e66457a70c08667$var$se.register = $0e66457a70c08667$var$G.register, $0e66457a70c08667$var$se.state = $0e66457a70c08667$var$e, $0e66457a70c08667$var$se.query = ((e)=>{
    if (e && e.search) {
        const e = new URLSearchParams(window.location.search).entries();
        return Object.fromEntries(e);
    }
    return null;
})(window.location), Object.defineProperty($0e66457a70c08667$var$se, "preventManipulation", {
    get: ()=>$0e66457a70c08667$var$m.preventManipulation
}), Object.defineProperty($0e66457a70c08667$var$se, "stage", {
    get: ()=>$0e66457a70c08667$var$e.getModule("stage")
});
const $0e66457a70c08667$var$ne = (t1)=>$0e66457a70c08667$var$e.getModule("stage").getProxy(t1);
$0e66457a70c08667$var$ne.version = $0e66457a70c08667$var$n, $0e66457a70c08667$var$ne.prefix = $0e66457a70c08667$var$t1, $0e66457a70c08667$var$ne.organisation = $0e66457a70c08667$var$i, $0e66457a70c08667$var$ne.Modes = $0e66457a70c08667$var$l, Object.defineProperty($0e66457a70c08667$var$ne, "mode", {
    set: (e)=>{
        $0e66457a70c08667$var$m.mode = e;
    },
    get: ()=>$0e66457a70c08667$var$m.mode
}), $0e66457a70c08667$var$ne.internals = $0e66457a70c08667$var$se, $0e66457a70c08667$var$ne.version = $0e66457a70c08667$var$n, $0e66457a70c08667$var$ne.start = $0e66457a70c08667$var$G.start, $0e66457a70c08667$var$ne.stop = $0e66457a70c08667$var$G.stop, $0e66457a70c08667$var$ne.inspector = $0e66457a70c08667$var$h, $0e66457a70c08667$var$ne.colors = $0e66457a70c08667$var$H;
const $0e66457a70c08667$var$re = window[$0e66457a70c08667$var$s];
$0e66457a70c08667$var$ne.internals.configuration = $0e66457a70c08667$var$re, $0e66457a70c08667$var$m.configure($0e66457a70c08667$var$re, $0e66457a70c08667$var$ne.start, $0e66457a70c08667$var$ne.internals.query), window[$0e66457a70c08667$var$s] = $0e66457a70c08667$var$ne;
class $0e66457a70c08667$var$ae {
    constructor(){
        this.emissions = {};
    }
    add(e, t1) {
        if ("function" != typeof t1) throw new Error("closure must be a function");
        this.emissions[e] || (this.emissions[e] = []), this.emissions[e].push(t1);
    }
    remove(e, t1) {
        if (this.emissions[e]) {
            if (t1) {
                const s = this.emissions[e].indexOf(t1);
                s > -1 && this.emissions[e].splice(s);
            } else delete this.emissions[e];
        }
    }
    emit(e, t1) {
        if (!this.emissions[e]) return [];
        const s = [];
        for (const i of this.emissions[e])i && s.push(i(t1));
        return s;
    }
    dispose() {
        this.emissions = null;
    }
}
const $0e66457a70c08667$var$oe = new class {
    constructor(){
        this._activeElements = [], window.document.addEventListener("focusin", this._onFocusIn.bind(this));
    }
    _onFocusIn(e) {
        this._activeElements.push(e.target);
    }
    get index() {
        return this._activeElements.length - 1;
    }
    focus(e) {
        const t1 = this._activeElements[e];
        switch(!0){
            case e < 0:
            case 0 === this._activeElements.length:
                return void this.focusOnLogo();
            case !t1:
            case !document.documentElement.contains(t1):
            case !this._isDisplayed(t1):
                return void this.focus(e - 1);
        }
        t1.focus();
    }
    focusOnLogo() {
        const e = document.querySelector($0e66457a70c08667$var$ne.header.HeaderSelector.BRAND_LINK);
        e && e.focus();
    }
    _isDisplayed(e) {
        for(; e && e !== document.documentElement;){
            if (e === document.body) return !0;
            const t1 = window.getComputedStyle(e);
            if ("none" === t1.display || "hidden" === t1.visibility) return !1;
            e = e.parentElement;
        }
        return !0;
    }
};
class $0e66457a70c08667$var$he {
    constructor(e, t1){
        this.id = e, this.minWidth = t1;
    }
    test() {
        return window.matchMedia(`(min-width: ${this.minWidth}em)`).matches;
    }
}
const $0e66457a70c08667$var$ce = {
    XS: new $0e66457a70c08667$var$he("xs", 0),
    SM: new $0e66457a70c08667$var$he("sm", 36),
    MD: new $0e66457a70c08667$var$he("md", 48),
    LG: new $0e66457a70c08667$var$he("lg", 62),
    XL: new $0e66457a70c08667$var$he("xl", 78)
}, $0e66457a70c08667$var$le = {
    CLICK: $0e66457a70c08667$var$g.event("click")
};
class $0e66457a70c08667$var$de {
    constructor(e = !0){
        this.jsAttribute = e, this._isRendering = !1, this._isResizing = !1, this._isScrollLocked = !1, this._isLoading = !1, this._isSwappingFont = !1, this._isEnabled = !0, this._isDisposed = !1, this._listeners = {}, this._handlingClick = this._handleClick.bind(this), this._hashes = [], this._hash = "", this._keyListenerTypes = [], this._keys = [], this.handlingKey = this.handleKey.bind(this), this._emitter = new $0e66457a70c08667$var$ae, this._ascent = new $0e66457a70c08667$var$ae, this._descent = new $0e66457a70c08667$var$ae, this._registrations = [], this._nexts = [];
    }
    static get instanceClassName() {
        return "Instance";
    }
    _config(e, t1) {
        this.element = e, this.registration = t1, this.node = e.node, this.id = e.node.id, this.jsAttribute && this.setAttribute(t1.attribute, !0), this.init();
    }
    init() {}
    get proxy() {
        const e = this;
        return $0e66457a70c08667$var$ee({
            render: ()=>e.render(),
            resize: ()=>e.resize()
        }, {
            get node () {
                return e.node;
            },
            get isEnabled () {
                return e.isEnabled;
            },
            set isEnabled (t){
                e.isEnabled = t;
            }
        });
    }
    log(...e) {
        e.unshift(`${this.registration.instanceClassName} #${this.id} - `), $0e66457a70c08667$var$h.log.apply($0e66457a70c08667$var$h, e);
    }
    debug(...e) {
        e.unshift(`${this.registration.instanceClassName} #${this.id} - `), $0e66457a70c08667$var$h.debug.apply($0e66457a70c08667$var$h, e);
    }
    info(...e) {
        e.unshift(`${this.registration.instanceClassName} #${this.id} - `), $0e66457a70c08667$var$h.info.apply($0e66457a70c08667$var$h, e);
    }
    warn(...e) {
        e.unshift(`${this.registration.instanceClassName} #${this.id} - `), $0e66457a70c08667$var$h.warn.apply($0e66457a70c08667$var$h, e);
    }
    error(...e) {
        e.unshift(`${this.registration.instanceClassName} #${this.id} - `), $0e66457a70c08667$var$h.error.apply($0e66457a70c08667$var$h, e);
    }
    register(t1, s) {
        const i = $0e66457a70c08667$var$e.getModule("register").register(t1, s, this);
        this._registrations.push(i);
    }
    getRegisteredInstances(e) {
        for (const t1 of this._registrations)if (t1.hasInstanceClassName(e)) return t1.instances.collection;
        return [];
    }
    dispatch(e, t1 = null, s = !0, i = !1) {
        $0e66457a70c08667$var$d(this.node, e, t1, s, i);
    }
    listen(e, t1, s) {
        this._listeners[e] || (this._listeners[e] = []);
        const i = this._listeners[e], n = new $0e66457a70c08667$var$ge(this.node, e, t1, s);
        i.push(n), n.listen();
    }
    unlisten(e, t1, s) {
        if (!e) {
            for(const e in this._listeners)this.unlisten(e);
            return;
        }
        const i = this._listeners[e];
        if (!i) return;
        if (!t1) return void i.forEach((t1)=>this.unlisten(e, t1.closure));
        const n = i.filter((e)=>e.closure === t1 && e.matchOptions(s));
        n.forEach((e)=>e.unlisten()), this._listeners[e] = i.filter((e)=>-1 === n.indexOf(e));
    }
    listenClick(e) {
        this.listen("click", this._handlingClick, e);
    }
    unlistenClick(e) {
        this.unlisten("click", this._handlingClick, e);
    }
    _handleClick(e) {
        this.handleClick(e), this.dispatch($0e66457a70c08667$var$le.CLICK, this);
    }
    handleClick(e) {}
    set hash(t1) {
        $0e66457a70c08667$var$e.getModule("hash").hash = t1;
    }
    get hash() {
        return $0e66457a70c08667$var$e.getModule("hash").hash;
    }
    listenHash(t1, s) {
        if (!this._hashes) return;
        0 === this._hashes.length && $0e66457a70c08667$var$e.add("hash", this);
        const i = new $0e66457a70c08667$var$pe(t1, s);
        this._hashes = this._hashes.filter((e)=>e.hash !== t1), this._hashes.push(i);
    }
    unlistenHash(t1) {
        this._hashes && (this._hashes = this._hashes.filter((e)=>e.hash !== t1), 0 === this._hashes.length && $0e66457a70c08667$var$e.remove("hash", this));
    }
    handleHash(e, t1) {
        if (this._hashes) for (const s of this._hashes)s.handle(e, t1);
    }
    listenKey(e, t1, s = !1, i = !1, n = "down") {
        -1 === this._keyListenerTypes.indexOf(n) && (this.listen(`key${n}`, this.handlingKey), this._keyListenerTypes.push(n)), this._keys.push(new $0e66457a70c08667$var$ue(n, e, t1, s, i));
    }
    unlistenKey(e, t1) {
        this._keys = this._keys.filter((s)=>s.code !== e || s.closure !== t1), this._keyListenerTypes.forEach((e)=>{
            this._keys.some((t1)=>t1.type === e) || this.unlisten(`key${e}`, this.handlingKey);
        });
    }
    handleKey(e) {
        for (const t1 of this._keys)t1.handle(e);
    }
    get isEnabled() {
        return this._isEnabled;
    }
    set isEnabled(e) {
        this._isEnabled = e;
    }
    get isRendering() {
        return this._isRendering;
    }
    set isRendering(t1) {
        this._isRendering !== t1 && (t1 ? $0e66457a70c08667$var$e.add("render", this) : $0e66457a70c08667$var$e.remove("render", this), this._isRendering = t1);
    }
    render() {}
    request(t1) {
        this._nexts.push(t1), $0e66457a70c08667$var$e.getModule("render").request(this);
    }
    next() {
        const e = this._nexts.slice();
        this._nexts.length = 0;
        for (const t1 of e)t1 && t1();
    }
    get isResizing() {
        return this._isResizing;
    }
    set isResizing(t1) {
        this._isResizing !== t1 && (t1 ? ($0e66457a70c08667$var$e.add("resize", this), this.resize()) : $0e66457a70c08667$var$e.remove("resize", this), this._isResizing = t1);
    }
    resize() {}
    isBreakpoint(e) {
        return !0 == ("string" == typeof e) ? $0e66457a70c08667$var$ce[e.toUpperCase()].test() : e.test();
    }
    get isScrollLocked() {
        return this._isScrollLocked;
    }
    set isScrollLocked(t1) {
        this._isScrollLocked !== t1 && (t1 ? $0e66457a70c08667$var$e.add("lock", this) : $0e66457a70c08667$var$e.remove("lock", this), this._isScrollLocked = t1);
    }
    get isLoading() {
        return this._isLoading;
    }
    set isLoading(t1) {
        this._isLoading !== t1 && (t1 ? $0e66457a70c08667$var$e.add("load", this) : $0e66457a70c08667$var$e.remove("load", this), this._isLoading = t1);
    }
    load() {}
    get isSwappingFont() {
        return this._isSwappingFont;
    }
    set isSwappingFont(t1) {
        this._isSwappingFont !== t1 && (t1 ? $0e66457a70c08667$var$e.add("font-swap", this) : $0e66457a70c08667$var$e.remove("font-swap", this), this._isSwappingFont = t1);
    }
    swapFont() {}
    get isMouseMoving() {
        return this._isMouseMoving;
    }
    set isMouseMoving(t1) {
        this._isMouseMoving !== t1 && (t1 ? $0e66457a70c08667$var$e.add("mouse-move", this) : $0e66457a70c08667$var$e.remove("mouse-move", this), this._isMouseMoving = t1);
    }
    mouseMove(e) {}
    examine(e) {
        this.node.matches(this.registration.selector) ? this.mutate(e) : this._dispose();
    }
    mutate(e) {}
    retrieveNodeId(e, t1) {
        if (e.id) return e.id;
        const s = $0e66457a70c08667$var$Y(`${this.id}-${t1}`);
        return this.warn(`add id '${s}' to ${t1}`), e.setAttribute("id", s), s;
    }
    get isDisposed() {
        return this._isDisposed;
    }
    _dispose() {
        this.debug(`dispose instance of ${this.registration.instanceClassName} on element [${this.element.id}]`), this.removeAttribute(this.registration.attribute), this.unlisten(), $0e66457a70c08667$var$e.remove("hash", this), this._hashes = null, this._keys = null, this.isRendering = !1, this.isResizing = !1, this._nexts = null, $0e66457a70c08667$var$e.getModule("render").nexts.remove(this), this.isScrollLocked = !1, this.isLoading = !1, this.isSwappingFont = !1, this.isMouseMoving = !1, this._emitter.dispose(), this._emitter = null, this._ascent.dispose(), this._ascent = null, this._descent.dispose(), this._descent = null, this.element.remove(this);
        for (const t1 of this._registrations)$0e66457a70c08667$var$e.remove("register", t1);
        this._registrations = null, this.registration.remove(this), this._isDisposed = !0, this.dispose();
    }
    dispose() {}
    emit(e, t1) {
        return this.element.emit(e, t1);
    }
    addEmission(e, t1) {
        this._emitter.add(e, t1);
    }
    removeEmission(e, t1) {
        this._emitter.remove(e, t1);
    }
    ascend(e, t1) {
        return this.element.ascend(e, t1);
    }
    addAscent(e, t1) {
        this._ascent.add(e, t1);
    }
    removeAscent(e, t1) {
        this._ascent.remove(e, t1);
    }
    descend(e, t1) {
        return this.element.descend(e, t1);
    }
    addDescent(e, t1) {
        this._descent.add(e, t1);
    }
    removeDescent(e, t1) {
        this._descent.remove(e, t1);
    }
    get style() {
        return this.node.style;
    }
    addClass(e) {
        $0e66457a70c08667$var$W(this.node, e);
    }
    removeClass(e) {
        $0e66457a70c08667$var$q(this.node, e);
    }
    hasClass(e) {
        return $0e66457a70c08667$var$z(this.node, e);
    }
    get classNames() {
        return $0e66457a70c08667$var$B(this.node);
    }
    remove() {
        this.node.parentNode.removeChild(this.node);
    }
    setAttribute(e, t1) {
        this.node.setAttribute(e, t1);
    }
    getAttribute(e) {
        return this.node.getAttribute(e);
    }
    hasAttribute(e) {
        return this.node.hasAttribute(e);
    }
    removeAttribute(e) {
        this.node.removeAttribute(e);
    }
    setProperty(e, t1) {
        this.node.style.setProperty(e, t1);
    }
    removeProperty(e) {
        this.node.style.removeProperty(e);
    }
    focus() {
        this.node.focus();
    }
    blur() {
        this.node.blur();
    }
    retainFocus() {
        this._focusIndex = $0e66457a70c08667$var$oe.index;
    }
    focusBack() {
        $0e66457a70c08667$var$oe.focus(this._focusIndex);
    }
    focusClosest() {
        const e = this._focusClosest(this.node.parentNode);
        e && e.focus();
    }
    _focusClosest(e) {
        if (!e) return null;
        const t1 = [
            ...$0e66457a70c08667$var$j(e)
        ];
        if (t1.length <= 1) return this._focusClosest(e.parentNode);
        {
            const e = t1.indexOf(this.node);
            return t1[e + (e < t1.length - 1 ? 1 : -1)];
        }
    }
    get hasFocus() {
        return this.node === document.activeElement;
    }
    scrollIntoView() {
        const t1 = this.getRect(), s = $0e66457a70c08667$var$e.getModule("lock");
        t1.top < 0 && s.move(t1.top - 50), t1.bottom > window.innerHeight && s.move(t1.bottom - window.innerHeight + 50);
    }
    matches(e) {
        return this.node.matches(e);
    }
    querySelector(e) {
        return this.node.querySelector(e);
    }
    querySelectorAll(e) {
        return $0e66457a70c08667$var$E(this.node, e);
    }
    queryParentSelector(e) {
        return $0e66457a70c08667$var$f(this.node, e);
    }
    getRect() {
        const e = this.node.getBoundingClientRect();
        return e.center = e.left + .5 * e.width, e.middle = e.top + .5 * e.height, e;
    }
    get isLegacy() {
        return $0e66457a70c08667$var$e.isLegacy;
    }
}
class $0e66457a70c08667$var$ue {
    constructor(e, t1, s, i, n){
        this.type = e, this.eventType = `key${e}`, this.keyCode = t1, this.closure = s, this.preventDefault = !0 === i, this.stopPropagation = !0 === n;
    }
    handle(e) {
        e.type === this.eventType && e.keyCode === this.keyCode.value && (this.closure(e), this.preventDefault && e.preventDefault(), this.stopPropagation && e.stopPropagation());
    }
}
class $0e66457a70c08667$var$ge {
    constructor(e, t1, s, i){
        this._node = e, this._type = t1, this._closure = s, this._options = i;
    }
    get closure() {
        return this._closure;
    }
    listen() {
        this._node.addEventListener(this._type, this._closure, this._options);
    }
    matchOptions(e = null) {
        switch(!0){
            case null === e:
            case "boolean" == typeof this._options && "boolean" == typeof e && this._options === e:
                return !0;
            case Object.keys(this._options).length !== Object.keys(e).length:
                return !1;
            case Object.keys(e).every((t1)=>this._options[t1] === e[t1]):
                return !0;
        }
        return !1;
    }
    unlisten() {
        this._node.removeEventListener(this._type, this._closure, this._options);
    }
}
class $0e66457a70c08667$var$pe {
    constructor(e, t1){
        this.hash = e, this.add = t1;
    }
    handle(e, t1) {
        this.hash === e && this.add(t1);
    }
}
const $0e66457a70c08667$var$me = {
    DISCLOSE: $0e66457a70c08667$var$g.event("disclose"),
    CONCEAL: $0e66457a70c08667$var$g.event("conceal"),
    CURRENT: $0e66457a70c08667$var$g.event("current")
}, $0e66457a70c08667$var$_e = {
    RESET: $0e66457a70c08667$var$g.emission("disclosure", "reset"),
    ADDED: $0e66457a70c08667$var$g.emission("disclosure", "added"),
    RETRIEVE: $0e66457a70c08667$var$g.emission("disclosure", "retrieve"),
    REMOVED: $0e66457a70c08667$var$g.emission("disclosure", "removed"),
    GROUP: $0e66457a70c08667$var$g.emission("disclosure", "group"),
    UNGROUP: $0e66457a70c08667$var$g.emission("disclosure", "ungroup"),
    SPOTLIGHT: $0e66457a70c08667$var$g.emission("disclosure", "spotlight")
};
class $0e66457a70c08667$var$be extends $0e66457a70c08667$var$de {
    constructor(e, t1, s, i){
        super(), this.type = e, this._selector = t1, this.DisclosureButtonInstanceClass = s, this.disclosuresGroupInstanceClassName = i, this.modifier = this._selector + "--" + this.type.id, this._isPristine = !0, this._isActive = !0, this._isRetrievingPrimaries = !1, this._hasRetrieved = !1, this._primaryButtons = [];
    }
    static get instanceClassName() {
        return "Disclosure";
    }
    init() {
        this.addDescent($0e66457a70c08667$var$_e.RESET, this.reset.bind(this)), this.addDescent($0e66457a70c08667$var$_e.GROUP, this.update.bind(this)), this.addDescent($0e66457a70c08667$var$_e.UNGROUP, this.update.bind(this)), this.addAscent($0e66457a70c08667$var$_e.SPOTLIGHT, this.disclose.bind(this)), this.register(`[aria-controls="${this.id}"]`, this.DisclosureButtonInstanceClass), this.ascend($0e66457a70c08667$var$_e.ADDED), this.listenHash(this.id, this._spotlight.bind(this)), this.update();
    }
    get isEnabled() {
        return super.isEnabled;
    }
    set isEnabled(e) {
        this.isEnabled !== e && (super.isEnabled = e, e ? this.ascend($0e66457a70c08667$var$_e.ADDED) : this.ascend($0e66457a70c08667$var$_e.REMOVED));
    }
    get isActive() {
        return this._isActive;
    }
    set isActive(e) {
        this._isActive !== e && (this._isActive = e, e ? this.ascend($0e66457a70c08667$var$_e.ADDED) : (this.ascend($0e66457a70c08667$var$_e.REMOVED), this.isDisclosed && this.conceal()));
    }
    get isPristine() {
        return this._isPristine;
    }
    get proxy() {
        const e = this, t1 = Object.assign(super.proxy, {
            disclose: e.disclose.bind(e),
            focus: e.focus.bind(e)
        });
        this.type.canConceal && (t1.conceal = e.conceal.bind(e));
        return $0e66457a70c08667$var$ee(t1, {
            get buttons () {
                return e.buttons.map((e)=>e.proxy);
            },
            get group () {
                const t1 = e.group;
                return t1 ? t1.proxy : null;
            },
            get isDisclosed () {
                return e.isDisclosed;
            },
            get isEnabled () {
                return e.isEnabled;
            },
            get isActive () {
                return e.isActive;
            }
        });
    }
    get buttons() {
        return this.getRegisteredInstances(this.DisclosureButtonInstanceClass.instanceClassName);
    }
    update() {
        this.getGroup(), this.retrievePrimaries();
    }
    getGroup() {
        if (!this.disclosuresGroupInstanceClassName) return void (this._group = null);
        const e = this.element.getAscendantInstance(this.disclosuresGroupInstanceClassName, this.constructor.instanceClassName);
        e && e.validate(this) ? this._group = e : this._group = null;
    }
    get group() {
        return this._group;
    }
    disclose(e) {
        return !(!0 === this.isDisclosed || !this.isEnabled || !this._isActive) && (this.retainFocus(), this._isPristine = !1, this.isDisclosed = !0, !e && this.group && (this.group.current = this), !0);
    }
    conceal(e, t1 = !0) {
        return !1 !== this.isDisclosed && !(!this.type.canConceal && this.group && this.group.current === this) && (this.isDisclosed = !1, !e && this.group && this.group.current === this && (this.group.current = null), t1 || this.focus(), this._isPristine || this.descend($0e66457a70c08667$var$_e.RESET), !0);
    }
    get isDisclosed() {
        return this._isDisclosed;
    }
    set isDisclosed(e) {
        if (this._isDisclosed !== e && (this.isEnabled || !0 !== e)) {
            this._isPristine || this.dispatch(e ? $0e66457a70c08667$var$me.DISCLOSE : $0e66457a70c08667$var$me.CONCEAL, this), this._isDisclosed = e, e ? this.addClass(this.modifier) : this.removeClass(this.modifier);
            for(let t1 = 0; t1 < this.buttons.length; t1++)this.buttons[t1].apply(e);
        }
    }
    get isInitiallyDisclosed() {
        return this.primaryButtons.some((e)=>e.isInitiallyDisclosed);
    }
    hasRetrieved() {
        return this._hasRetrieved;
    }
    reset() {}
    toggle(e) {
        if (this.type.canConceal) switch(!0){
            case !e:
            case this.isDisclosed:
                this.conceal(!1, !1);
                break;
            default:
                this.disclose();
        }
        else this.disclose();
    }
    get buttonHasFocus() {
        return this.buttons.some((e)=>e.hasFocus);
    }
    get hasFocus() {
        return !!super.hasFocus || !!this.buttonHasFocus || this.querySelectorAll(":focus").length > 0;
    }
    focus() {
        this._primaryButtons.length > 0 ? this._primaryButtons[0].focus() : this.focusBack();
    }
    get primaryButtons() {
        return this._primaryButtons;
    }
    retrievePrimaries() {
        this._isRetrievingPrimaries || (this._isRetrievingPrimaries = !0, this.request(this._retrievePrimaries.bind(this)));
    }
    _retrievePrimaries() {
        if (this._isRetrievingPrimaries = !1, this._primaryButtons = this._electPrimaries(this.buttons), !(this._hasRetrieved || 0 === this._primaryButtons.length && this.type.requirePrimary)) {
            if (this.retrieved(), this._hasRetrieved = !0, this.applyAbility(!0), this.group) this.group.retrieve();
            else if (this._isPristine && this.isEnabled && this.isActive && !this.group) switch(!0){
                case this.hash === this.id:
                    this._spotlight();
                    break;
                case this.isInitiallyDisclosed:
                    this.disclose();
            }
        }
    }
    retrieved() {}
    _spotlight() {
        this.disclose(), this.request(()=>{
            this.ascend($0e66457a70c08667$var$_e.SPOTLIGHT);
        });
    }
    _electPrimaries(e) {
        return e.filter((e)=>e.canDisclose && !this.node.contains(e.node));
    }
    applyAbility(e = !1) {
        const t1 = !this.type.requirePrimary || this._primaryButtons.some((e)=>!e.isDisabled);
        this.isEnabled !== t1 && (this.isEnabled = t1, e || (!this.isEnabled && this.isDisclosed && (this.group ? this.ascend($0e66457a70c08667$var$_e.REMOVED) : this.type.canConceal && this.conceal()), this.isEnabled && (this.group && this.ascend($0e66457a70c08667$var$_e.ADDED), this.hash === this.id && this._spotlight())));
    }
    dispose() {
        this._group = null, this._primaryButtons = null, super.dispose(), this.ascend($0e66457a70c08667$var$_e.REMOVED);
    }
}
class $0e66457a70c08667$var$Ee extends $0e66457a70c08667$var$de {
    constructor(e){
        super(), this.type = e, this.attributeName = e.ariaState ? "aria-" + e.id : $0e66457a70c08667$var$g.attr(e.id), this._canDisclose = !1;
    }
    static get instanceClassName() {
        return "DisclosureButton";
    }
    get isPrimary() {
        return this.registration.creator.primaryButtons.includes(this);
    }
    get canDisclose() {
        return this._canDisclose;
    }
    get isDisabled() {
        return this.type.canDisable && this.hasAttribute("disabled");
    }
    init() {
        this._canDisclose = this.hasAttribute(this.attributeName), this._isInitiallyDisclosed = this.isDisclosed, this._isContained = this.registration.creator.node.contains(this.node), this.controlsId = this.getAttribute("aria-controls"), this.registration.creator.retrievePrimaries(), this.listenClick();
    }
    get proxy() {
        return Object.assign(super.proxy, {
            focus: this.focus.bind(this)
        });
    }
    handleClick(e) {
        this.registration.creator && this.registration.creator.toggle(this.canDisclose);
    }
    mutate(e) {
        this._canDisclose = this.hasAttribute(this.attributeName), this.registration.creator.applyAbility(), !this._isApplying && this.isPrimary && e.indexOf(this.attributeName) > -1 && this.registration.creator && (this.isDisclosed ? this.registration.creator.disclose() : this.type.canConceal && this.registration.creator.conceal());
    }
    apply(e) {
        this.canDisclose && (this._isApplying = !0, this.setAttribute(this.attributeName, e), this.request(()=>{
            this._isApplying = !1;
        }));
    }
    get isDisclosed() {
        return "true" === this.getAttribute(this.attributeName);
    }
    get isInitiallyDisclosed() {
        return this._isInitiallyDisclosed;
    }
    focus() {
        super.focus(), this.scrollIntoView();
    }
    measure(e) {
        const t1 = this.rect;
        this._dx = e.x - t1.x, this._dy = e.y - t1.y;
    }
    get dx() {
        return this._dx;
    }
    get dy() {
        return this._dy;
    }
}
const $0e66457a70c08667$var$fe = {
    PREVENT_CONCEAL: $0e66457a70c08667$var$g.attr.selector("prevent-conceal"),
    GROUP: $0e66457a70c08667$var$g.attr("group")
};
class $0e66457a70c08667$var$Ae extends $0e66457a70c08667$var$de {
    constructor(e, t1){
        super(t1), this.disclosureInstanceClassName = e, this._members = [], this._index = -1, this._isRetrieving = !1, this._hasRetrieved = !1, this._isGrouped = !0;
    }
    static get instanceClassName() {
        return "DisclosuresGroup";
    }
    init() {
        this.addAscent($0e66457a70c08667$var$_e.ADDED, this.update.bind(this)), this.addAscent($0e66457a70c08667$var$_e.RETRIEVE, this.retrieve.bind(this)), this.addAscent($0e66457a70c08667$var$_e.REMOVED, this.update.bind(this)), this.descend($0e66457a70c08667$var$_e.GROUP), this._isGrouped = "false" !== this.getAttribute($0e66457a70c08667$var$fe.GROUP), this.update();
    }
    get proxy() {
        const e = this, t1 = {
            set index (t){
                e.index = t;
            },
            get index () {
                return e.index;
            },
            get length () {
                return e.length;
            },
            get current () {
                const t1 = e.current;
                return t1 ? t1.proxy : null;
            },
            get members () {
                return e.members.map((e)=>e.proxy);
            },
            get hasFocus () {
                return e.hasFocus;
            },
            set isGrouped (t){
                e.isGrouped = t;
            },
            get isGrouped () {
                return e.isGrouped;
            }
        };
        return $0e66457a70c08667$var$ee(super.proxy, t1);
    }
    validate(e) {
        return !0;
    }
    getMembers() {
        const e = this.element.getDescendantInstances(this.disclosureInstanceClassName, this.constructor.instanceClassName, !0);
        this._members = e.filter(this.validate.bind(this)).filter((e)=>e.isEnabled && e.isActive);
        e.filter((e)=>!this._members.includes(e)).forEach((e)=>e.conceal());
    }
    retrieve(e = !1) {
        this._isRetrieving || this._hasRetrieved && !e || (this._isRetrieving = !0, this.request(this._retrieve.bind(this)));
    }
    _retrieve() {
        if (this.getMembers(), this._isRetrieving = !1, this._hasRetrieved = !0, this.isGrouped) {
            if (this.hash) for(let e = 0; e < this.length; e++){
                const t1 = this.members[e];
                if (this.hash === t1.id) return this.index = e, this.request(()=>{
                    this.ascend($0e66457a70c08667$var$_e.SPOTLIGHT);
                }), e;
            }
            for(let e = 0; e < this.length; e++){
                if (this.members[e].isInitiallyDisclosed) return this.index = e, e;
            }
            return this.getIndex();
        }
        for(let e = 0; e < this.length; e++){
            const t1 = this.members[e];
            t1.isInitiallyDisclosed && t1.disclose(!0);
        }
    }
    update() {
        this.getMembers(), this._hasRetrieved && this.isGrouped && this.getIndex();
    }
    get members() {
        return this._members;
    }
    get length() {
        return this.members ? this.members.length : 0;
    }
    getIndex(e = -1) {
        this._index = void 0;
        let t1 = e;
        for(let e = 0; e < this.length; e++)if (this.members[e].isDisclosed) {
            t1 = e;
            break;
        }
        return this.index = t1, t1;
    }
    get index() {
        return this._index;
    }
    set index(e) {
        if (!(e < -1 || e >= this.length || e === this._index)) {
            this._index = e;
            for(let t1 = 0; t1 < this.length; t1++){
                const s = this.members[t1];
                e === t1 ? s.isDisclosed || s.disclose(!0) : !this.isGrouped && this.canUngroup || !1 === s.isDisclosed || s.conceal(!0);
            }
            this.apply(), this.dispatch($0e66457a70c08667$var$me.CURRENT, this.current);
        }
    }
    get current() {
        return -1 === this._index || isNaN(this._index) ? null : this._members[this._index] || null;
    }
    set current(e) {
        this.index = this.members.indexOf(e);
    }
    get hasFocus() {
        const e = this.current;
        return !!e && e.hasFocus;
    }
    set isGrouped(e) {
        const t1 = !!e;
        this._isGrouped !== t1 && (this._isGrouped = t1, this.setAttribute($0e66457a70c08667$var$fe.GROUP, !!e), this.update());
    }
    get isGrouped() {
        return this._isGrouped;
    }
    get canUngroup() {
        return !1;
    }
    mutate(e) {
        e.includes($0e66457a70c08667$var$fe.GROUP) && (this.isGrouped = "false" !== this.getAttribute($0e66457a70c08667$var$fe.GROUP));
    }
    apply() {}
    dispose() {
        super.dispose(), this.descend($0e66457a70c08667$var$_e.UNGROUP), this._members = null;
    }
}
const $0e66457a70c08667$var$Te = {
    EXPAND: {
        id: "expanded",
        ariaState: !0,
        ariaControls: !0,
        canConceal: !0,
        canDisable: !0,
        requirePrimary: !0
    },
    SELECT: {
        id: "selected",
        ariaState: !0,
        ariaControls: !0,
        canConceal: !1,
        canDisable: !0,
        requirePrimary: !0
    },
    OPENED: {
        id: "opened",
        ariaState: !1,
        ariaControls: !0,
        canConceal: !0,
        canDisable: !1,
        requirePrimary: !1
    }
};
class $0e66457a70c08667$var$ve extends $0e66457a70c08667$var$Ee {
    constructor(){
        super($0e66457a70c08667$var$Te.EXPAND);
    }
    static get instanceClassName() {
        return "CollapseButton";
    }
}
const $0e66457a70c08667$var$Se = {
    COLLAPSE: $0e66457a70c08667$var$g.selector("collapse"),
    COLLAPSING: $0e66457a70c08667$var$g.selector("collapsing")
};
const $0e66457a70c08667$var$ye = {
    CHANGE: $0e66457a70c08667$var$g("equisized")
};
const $0e66457a70c08667$var$Ce = {
    INJECT_SVG: `[${$0e66457a70c08667$var$g.attr("inject-svg")}]`
};
const $0e66457a70c08667$var$Ne = {
    ARTWORK_USE: `${$0e66457a70c08667$var$g.selector("artwork")} use`
}, $0e66457a70c08667$var$De = {
    ASSESS_FILE: `${$0e66457a70c08667$var$g.attr.selector("assess-file")}`,
    DETAIL: `${$0e66457a70c08667$var$g.attr.selector("assess-file")} [class$="__detail"], ${$0e66457a70c08667$var$g.attr.selector("assess-file")} [class*="__detail "]`
}, $0e66457a70c08667$var$Re = {
    UPDATE: $0e66457a70c08667$var$g.emission("assess", "update"),
    ADDED: $0e66457a70c08667$var$g.emission("assess", "added")
};
const $0e66457a70c08667$var$we = [
    "32x9",
    "16x9",
    "3x2",
    "4x3",
    "1x1",
    "3x4",
    "2x3"
], $0e66457a70c08667$var$Le = (e, t1)=>t1.map((t1)=>$0e66457a70c08667$var$g.selector(`${e}--${t1}`)).join(","), $0e66457a70c08667$var$Ie = `${$0e66457a70c08667$var$g.selector("responsive-img")}, ${$0e66457a70c08667$var$Le("responsive-img", $0e66457a70c08667$var$we)}, ${$0e66457a70c08667$var$g.selector("responsive-vid")}, ${$0e66457a70c08667$var$Le("responsive-vid", [
    "16x9",
    "4x3",
    "1x1"
])}`, $0e66457a70c08667$var$xe = {
    RATIO: `${$0e66457a70c08667$var$g.selector("ratio")}, ${$0e66457a70c08667$var$Le("ratio", $0e66457a70c08667$var$we)}, ${$0e66457a70c08667$var$Ie}`
}, $0e66457a70c08667$var$Oe = window[$0e66457a70c08667$var$s];
const $0e66457a70c08667$var$Pe = {
    TOP: $0e66457a70c08667$var$g.selector("placement--top"),
    RIGHT: $0e66457a70c08667$var$g.selector("placement--right"),
    BOTTOM: $0e66457a70c08667$var$g.selector("placement--bottom"),
    LEFT: $0e66457a70c08667$var$g.selector("placement--left")
}, $0e66457a70c08667$var$ke = {
    START: $0e66457a70c08667$var$g.selector("placement--start"),
    CENTER: $0e66457a70c08667$var$g.selector("placement--center"),
    END: $0e66457a70c08667$var$g.selector("placement--end")
}, $0e66457a70c08667$var$Me = {
    TOP: "place_top",
    RIGHT: "place_right",
    BOTTOM: "place_bottom",
    LEFT: "place_left"
}, $0e66457a70c08667$var$Ge = {
    START: "align_start",
    CENTER: "align_center",
    END: "align_end"
}, $0e66457a70c08667$var$$e = {
    AUTO: "placement_auto",
    MANUAL: "placement_manual"
};
$0e66457a70c08667$var$ne.core = {
    Instance: $0e66457a70c08667$var$de,
    Breakpoints: $0e66457a70c08667$var$ce,
    KeyCodes: $0e66457a70c08667$var$C,
    Disclosure: $0e66457a70c08667$var$be,
    DisclosureButton: $0e66457a70c08667$var$Ee,
    DisclosuresGroup: $0e66457a70c08667$var$Ae,
    DisclosureType: $0e66457a70c08667$var$Te,
    DisclosureEvent: $0e66457a70c08667$var$me,
    DisclosureSelector: $0e66457a70c08667$var$fe,
    DisclosureEmission: $0e66457a70c08667$var$_e,
    Collapse: class extends $0e66457a70c08667$var$be {
        constructor(){
            super($0e66457a70c08667$var$Te.EXPAND, $0e66457a70c08667$var$Se.COLLAPSE, $0e66457a70c08667$var$ve, "CollapsesGroup");
        }
        static get instanceClassName() {
            return "Collapse";
        }
        init() {
            super.init(), this.listen("transitionend", this.endCollapsing.bind(this));
        }
        endCollapsing(e) {
            this._isCollpasing && (this._timeout && clearTimeout(this._timeout), this._timeout = null, this._isCollpasing = !1, this.removeClass($0e66457a70c08667$var$Se.COLLAPSING), this.isDisclosed || this.isLegacy && (this.style.maxHeight = ""));
        }
        unbound() {
            this.isLegacy && (this.style.maxHeight = "none");
        }
        disclose(e) {
            if (!0 === this.isDisclosed || !this.isEnabled) return !1;
            this.unbound(), this.collapsing(()=>super.disclose(e));
        }
        conceal(e, t1) {
            if (!1 === this.isDisclosed) return !1;
            this.collapsing(()=>super.conceal(e, t1));
        }
        collapsing(e) {
            this._isCollpasing = !0, this._timeout && clearTimeout(this._timeout), this.addClass($0e66457a70c08667$var$Se.COLLAPSING), this.adjust(), this.request(()=>{
                e(), this._timeout = setTimeout(this.endCollapsing.bind(this), 500);
            });
        }
        adjust() {
            this.setProperty("--collapser", "none");
            const e = this.node.offsetHeight;
            this.setProperty("--collapse", -e + "px"), this.setProperty("--collapser", "");
        }
        reset() {
            this.isPristine || (this.isDisclosed = !1);
        }
        _electPrimaries(e) {
            const t1 = this.element.parent.instances.map((e)=>e.collapsePrimary).filter((t1)=>void 0 !== t1 && e.indexOf(t1) > -1);
            if (1 === t1.length) return t1;
            if (1 === (e = super._electPrimaries(e)).length) return e;
            const s = e.filter((e)=>e.dy >= 0);
            if (s.length > 0 && (e = s), 1 === e.length) return e;
            const i = Math.min(...e.map((e)=>e.dy)), n = e.filter((e)=>e.dy === i);
            return n.length > 0 && (e = n), 1 === e.length || e.sort((e, t1)=>Math.abs(t1.dx) - Math.abs(e.dx)), e;
        }
    },
    CollapseButton: $0e66457a70c08667$var$ve,
    CollapsesGroup: class extends $0e66457a70c08667$var$Ae {
        constructor(){
            super("Collapse");
        }
        static get instanceClassName() {
            return "CollapsesGroup";
        }
        get canUngroup() {
            return !0;
        }
    },
    CollapseSelector: $0e66457a70c08667$var$Se,
    RootSelector: {
        ROOT: ":root"
    },
    RootEmission: $0e66457a70c08667$var$y,
    Equisized: class extends $0e66457a70c08667$var$de {
        static get instanceClassName() {
            return "Equisized";
        }
        init() {
            this.ascend($0e66457a70c08667$var$ye.CHANGE);
        }
        measure() {
            return this.isLegacy && (this.style.width = "auto"), this.getRect().width;
        }
        adjust(e) {
            this.isLegacy && (this.style.width = `${e}px`);
        }
        dispose() {
            this.ascend($0e66457a70c08667$var$ye.CHANGE);
        }
    },
    EquisizedEmission: $0e66457a70c08667$var$ye,
    Toggle: class extends $0e66457a70c08667$var$de {
        static get instanceClassName() {
            return "Toggle";
        }
        init() {
            this.pressed = "true" === this.pressed, this.listenClick();
        }
        handleClick() {
            this.toggle();
        }
        toggle() {
            this.pressed = "true" !== this.pressed;
        }
        get pressed() {
            return this.getAttribute("aria-pressed");
        }
        set pressed(e) {
            this.setAttribute("aria-pressed", e ? "true" : "false");
        }
        get proxy() {
            const e = this, t1 = Object.assign(super.proxy, {
                toggle: e.toggle.bind(e)
            });
            return $0e66457a70c08667$var$ee(t1, {
                get pressed () {
                    return e.pressed;
                },
                set pressed (t){
                    e.pressed = t;
                }
            });
        }
    },
    EquisizedsGroup: class extends $0e66457a70c08667$var$de {
        static get instanceClassName() {
            return "EquisizedsGroup";
        }
        init() {
            this.isResizing = !0, this.isLoading = !0, this.addAscent($0e66457a70c08667$var$ye.CHANGE, this.resize.bind(this));
        }
        load() {
            this.resize();
        }
        resize() {
            const e = this.element.getDescendantInstances("Equisized");
            this.isLegacy || this.style.setProperty("--equisized-width", "auto");
            const t1 = Math.max(...e.map((e)=>e.measure()));
            this.isLegacy ? e.forEach((e)=>e.adjust(t1)) : this.style.setProperty("--equisized-width", `${t1}px`);
        }
    },
    InjectSvg: class extends $0e66457a70c08667$var$de {
        static get instanceClassName() {
            return "InjectSvg";
        }
        init() {
            this.node && (this.img = this.node.querySelector("img")), this.isLegacy || this.replace();
        }
        get proxy() {
            const e = this;
            return Object.assign(super.proxy, {
                replace: e.replace.bind(e),
                restore: e.restore.bind(e)
            });
        }
        fetch() {
            this.img && (this.imgID = this.img.getAttribute("id"), this.imgClass = this.img.getAttribute("class"), this.imgURL = this.img.getAttribute("src"), fetch(this.imgURL).then((e)=>e.text()).then((e)=>{
                const t1 = (new DOMParser).parseFromString(e, "text/html");
                this.svg = t1.querySelector("svg"), this.svg && this.replace();
            }));
        }
        replace() {
            if (!this.svg) return void this.fetch();
            this.imgID && void 0 !== this.imgID && this.svg.setAttribute("id", this.imgID);
            let e = this.imgURL.match(/[ \w-]+\./)[0];
            e && (e = e.slice(0, -1), [
                "dark",
                "light",
                "system"
            ].includes(e) && (this.svg.innerHTML = this.svg.innerHTML.replaceAll('id="artwork-', `id="${e}-artwork-`), this.svg.innerHTML = this.svg.innerHTML.replaceAll('"#artwork-', `"#${e}-artwork-`))), this.imgClass && void 0 !== this.imgClass && this.svg.setAttribute("class", this.imgClass), this.svg.hasAttribute("xmlns:a") && this.svg.removeAttribute("xmlns:a"), this.node.setAttribute("data-fr-inject-svg", !0);
            var t1, s;
            t1 = this.svg, s = {
                "aria-hidden": !0,
                focusable: !1
            }, Object.keys(s).forEach((e)=>t1.setAttribute(e, s[e])), this.node.replaceChild(this.svg, this.img);
        }
        restore() {
            this.img && this.svg && (this.node.setAttribute("data-fr-inject-svg", !1), this.node.replaceChild(this.img, this.svg));
        }
    },
    InjectSvgSelector: $0e66457a70c08667$var$Ce,
    Artwork: class extends $0e66457a70c08667$var$de {
        static get instanceClassName() {
            return "Artwork";
        }
        init() {
            this.isLegacy && this.replace();
        }
        get proxy() {
            return Object.assign(super.proxy, {
                replace: this.replace.bind(this)
            });
        }
        fetch() {
            this.xlink = this.node.getAttribute("href");
            const e = this.xlink.split("#");
            this.svgUrl = e[0], this.svgName = e[1];
            const t1 = new XMLHttpRequest;
            t1.onload = ()=>{
                const e = (new DOMParser).parseFromString(t1.responseText, "text/html");
                this.realSvgContent = e.getElementById(this.svgName), this.realSvgContent && ("symbol" === this.realSvgContent.tagName ? (this.use = e.querySelector('use[href="#' + this.svgName + '"]'), this.use && this.node.parentNode.insertBefore(this.use, this.node)) : this.realSvgContent.classList.add(this.node.classList), this.replace());
            }, t1.open("GET", this.svgUrl), t1.send();
        }
        replace() {
            this.realSvgContent ? this.node.parentNode.replaceChild(this.realSvgContent, this.node) : this.fetch();
        }
    },
    ArtworkSelector: $0e66457a70c08667$var$Ne,
    AssessFile: class extends $0e66457a70c08667$var$de {
        static get instanceClassName() {
            return "AssessFile";
        }
        init() {
            this.lang = this.getLang(this.node), this.href = this.getAttribute("href"), this.hreflang = this.getAttribute("hreflang"), this.file = {}, this.gather(), this.addAscent($0e66457a70c08667$var$Re.ADDED, this.update.bind(this)), this.addDescent($0e66457a70c08667$var$Re.ADDED, this.update.bind(this));
        }
        getFileLength() {
            void 0 !== this.href ? fetch(this.href, {
                method: "HEAD",
                mode: "cors"
            }).then((e)=>{
                if (!e.ok) throw new Error("Unable to access the resource : Status " + e.status);
                if (this.length = e.headers.get("content-length") || -1, this.length && -1 === this.length) throw new Error('File size unknown\n Unable to get HTTP header: "content-length"');
                this.gather();
            }).catch((e)=>{
                this.length = -1, this.gather(), $0e66457a70c08667$var$h.warn("Fetch error on assess file : " + this.href + "\n " + e);
            }) : this.length = -1;
        }
        mutate(e) {
            -1 !== e.indexOf("href") && (this.href = this.getAttribute("href"), this.getFileLength()), -1 !== e.indexOf("hreflang") && (this.hreflang = this.getAttribute("hreflang"), this.gather());
        }
        gather() {
            if (this.isLegacy && (this.length = -1), this.length || this.getFileLength(), this.details = [], this.href) {
                const e = this.parseExtension(this.href);
                e && this.details.push(e.toUpperCase());
            }
            this.length && -1 !== this.length && this.details.push(this.bytesToSize(this.length)), this.hreflang && this.details.push(this.getLangDisplayName(this.hreflang)), this.update();
        }
        update() {
            this.details && (this.descend($0e66457a70c08667$var$Re.UPDATE, this.details), this.ascend($0e66457a70c08667$var$Re.UPDATE, this.details));
        }
        getLang(e) {
            return e.lang ? e.lang : document.documentElement === e ? window.navigator.language : this.getLang(e.parentElement);
        }
        parseExtension(e) {
            return e.match(/\.(\w{1,9})(?:$|[?#])/)[0].replace(".", "");
        }
        getLangDisplayName(e) {
            if (this.isLegacy) return e;
            const t1 = new Intl.DisplayNames([
                this.lang
            ], {
                type: "language"
            }).of(e);
            return t1.charAt(0).toUpperCase() + t1.slice(1);
        }
        bytesToSize(e) {
            if (-1 === e) return null;
            let t1 = [
                "octets",
                "ko",
                "Mo",
                "Go",
                "To"
            ];
            "bytes" === this.getAttribute($0e66457a70c08667$var$g.attr("assess-file")) && (t1 = [
                "bytes",
                "KB",
                "MB",
                "GB",
                "TB"
            ]);
            const s = parseInt(Math.floor(Math.log(e) / Math.log(1e3)), 10);
            if (0 === s) return `${e} ${t1[s]}`;
            const i = e / 1e3 ** s, n = Math.round(100 * (i + Number.EPSILON)) / 100;
            return `${String(n).replace(".", ",")} ${t1[s]}`;
        }
    },
    AssessDetail: class extends $0e66457a70c08667$var$de {
        static get instanceClassName() {
            return "AssessDetail";
        }
        init() {
            this.addDescent($0e66457a70c08667$var$Re.UPDATE, this.update.bind(this)), this.ascend($0e66457a70c08667$var$Re.ADDED);
        }
        update(e) {
            this.node.innerHTML = e.join(" - ");
        }
    },
    AssessEmission: $0e66457a70c08667$var$Re,
    AssessSelector: $0e66457a70c08667$var$De,
    Ratio: class extends $0e66457a70c08667$var$de {
        static get instanceClassName() {
            return "Ratio";
        }
        init() {
            if (!$0e66457a70c08667$var$Oe.internals.support.supportAspectRatio()) {
                this.ratio = 16 / 9;
                for(const e in this.classNames)if (this.registration.selector.indexOf(this.classNames[e]) > 0) {
                    const t1 = this.classNames[e].split("ratio-");
                    t1[1] && (this.ratio = t1[1].split("x")[0] / t1[1].split("x")[1]);
                }
                this.isRendering = !0, this.update();
            }
        }
        render() {
            this.getRect().width !== this.currentWidth && this.update();
        }
        update() {
            this.currentWidth = this.getRect().width, this.style.height = this.currentWidth / this.ratio + "px";
        }
    },
    RatioSelector: $0e66457a70c08667$var$xe,
    Placement: class extends $0e66457a70c08667$var$de {
        constructor(e = $0e66457a70c08667$var$$e.AUTO, t1 = [
            $0e66457a70c08667$var$Me.BOTTOM,
            $0e66457a70c08667$var$Me.TOP,
            $0e66457a70c08667$var$Me.LEFT,
            $0e66457a70c08667$var$Me.RIGHT
        ], s = [
            $0e66457a70c08667$var$Ge.CENTER,
            $0e66457a70c08667$var$Ge.START,
            $0e66457a70c08667$var$Ge.END
        ], i = 16){
            super(), this._mode = e, this._places = t1, this._aligns = s, this._safeAreaMargin = i, this._isShown = !1, this._x = this._y = 0;
        }
        static get instanceClassName() {
            return "Placement";
        }
        init() {
            this.isResizing = !0;
        }
        get proxy() {
            const e = this, t1 = Object.assign(super.proxy, {
                show: e.show.bind(e),
                hide: e.hide.bind(e)
            });
            return $0e66457a70c08667$var$ee(t1, {
                get mode () {
                    return e.mode;
                },
                set mode (t){
                    e.mode = t;
                },
                get place () {
                    return e.place;
                },
                set place (t){
                    e.place = t;
                },
                get align () {
                    return e.align;
                },
                set align (t){
                    e.align = t;
                },
                get isShown () {
                    return e.isShown;
                },
                set isShown (t){
                    e.isShown = t;
                }
            });
        }
        get mode() {
            return this._mode;
        }
        set mode(e) {
            this._mode = e;
        }
        get place() {
            return this._place;
        }
        set place(e) {
            if (this._place !== e) {
                switch(this._place){
                    case $0e66457a70c08667$var$Me.TOP:
                        this.removeClass($0e66457a70c08667$var$Pe.TOP);
                        break;
                    case $0e66457a70c08667$var$Me.RIGHT:
                        this.removeClass($0e66457a70c08667$var$Pe.RIGHT);
                        break;
                    case $0e66457a70c08667$var$Me.BOTTOM:
                        this.removeClass($0e66457a70c08667$var$Pe.BOTTOM);
                        break;
                    case $0e66457a70c08667$var$Me.LEFT:
                        this.removeClass($0e66457a70c08667$var$Pe.LEFT);
                }
                switch(this._place = e, this._place){
                    case $0e66457a70c08667$var$Me.TOP:
                        this.addClass($0e66457a70c08667$var$Pe.TOP);
                        break;
                    case $0e66457a70c08667$var$Me.RIGHT:
                        this.addClass($0e66457a70c08667$var$Pe.RIGHT);
                        break;
                    case $0e66457a70c08667$var$Me.BOTTOM:
                        this.addClass($0e66457a70c08667$var$Pe.BOTTOM);
                        break;
                    case $0e66457a70c08667$var$Me.LEFT:
                        this.addClass($0e66457a70c08667$var$Pe.LEFT);
                }
            }
        }
        get align() {
            return this._align;
        }
        set align(e) {
            if (this._align !== e) {
                switch(this._align){
                    case $0e66457a70c08667$var$Ge.START:
                        this.removeClass($0e66457a70c08667$var$ke.START);
                        break;
                    case $0e66457a70c08667$var$Ge.CENTER:
                        this.removeClass($0e66457a70c08667$var$ke.CENTER);
                        break;
                    case $0e66457a70c08667$var$Ge.END:
                        this.removeClass($0e66457a70c08667$var$ke.END);
                }
                switch(this._align = e, this._align){
                    case $0e66457a70c08667$var$Ge.START:
                        this.addClass($0e66457a70c08667$var$ke.START);
                        break;
                    case $0e66457a70c08667$var$Ge.CENTER:
                        this.addClass($0e66457a70c08667$var$ke.CENTER);
                        break;
                    case $0e66457a70c08667$var$Ge.END:
                        this.addClass($0e66457a70c08667$var$ke.END);
                }
            }
        }
        show() {
            this.isShown = !0;
        }
        hide() {
            this.isShown = !1;
        }
        get isShown() {
            return this._isShown;
        }
        set isShown(e) {
            this._isShown !== e && this.isEnabled && (this.isRendering = e, this._isShown = e);
        }
        setReferent(e) {
            this._referent = e;
        }
        render() {
            if (!this._referent) return;
            if (this.referentRect = this._referent.getRect(), this.rect = this.getRect(), this.safeArea = this.getSafeArea(), this.mode === $0e66457a70c08667$var$$e.AUTO) switch(this.place = this.getPlace(), this.place){
                case $0e66457a70c08667$var$Me.TOP:
                case $0e66457a70c08667$var$Me.BOTTOM:
                    this.align = this.getHorizontalAlign();
                    break;
                case $0e66457a70c08667$var$Me.LEFT:
                case $0e66457a70c08667$var$Me.RIGHT:
                    this.align = this.getVerticalAlign();
            }
            let e, t1;
            switch(this.place){
                case $0e66457a70c08667$var$Me.TOP:
                    t1 = this.referentRect.top - this.rect.top - this.rect.height;
                    break;
                case $0e66457a70c08667$var$Me.RIGHT:
                    e = this.referentRect.left - this.rect.left + this.referentRect.width;
                    break;
                case $0e66457a70c08667$var$Me.BOTTOM:
                    t1 = this.referentRect.top - this.rect.top + this.referentRect.height;
                    break;
                case $0e66457a70c08667$var$Me.LEFT:
                    e = this.referentRect.left - this.rect.left - this.rect.width;
            }
            switch(this.place){
                case $0e66457a70c08667$var$Me.TOP:
                case $0e66457a70c08667$var$Me.BOTTOM:
                    switch(this.align){
                        case $0e66457a70c08667$var$Ge.CENTER:
                            e = this.referentRect.left - this.rect.left + .5 * this.referentRect.width - .5 * this.rect.width;
                            break;
                        case $0e66457a70c08667$var$Ge.START:
                            e = this.referentRect.left - this.rect.left;
                            break;
                        case $0e66457a70c08667$var$Ge.END:
                            e = this.referentRect.left - this.rect.left + this.referentRect.width - this.rect.width;
                    }
                    break;
                case $0e66457a70c08667$var$Me.RIGHT:
                case $0e66457a70c08667$var$Me.LEFT:
                    switch(this.align){
                        case $0e66457a70c08667$var$Ge.CENTER:
                            t1 = this.referentRect.top - this.rect.top + .5 * this.referentRect.height - .5 * this.rect.height;
                            break;
                        case $0e66457a70c08667$var$Ge.START:
                            t1 = this.referentRect.top - this.rect.top;
                            break;
                        case $0e66457a70c08667$var$Ge.END:
                            t1 = this.referentRect.top - this.rect.top - this.rect.height;
                    }
            }
            this._x += e + .5 | 0, this._y += t1 + .5 | 0, this.node.style.transform = `translate(${this._x}px,${this._y}px)`;
        }
        getPlace() {
            for (const e of this._places)switch(e){
                case $0e66457a70c08667$var$Me.TOP:
                    if (this.referentRect.top - this.rect.height > this.safeArea.top) return $0e66457a70c08667$var$Me.TOP;
                    break;
                case $0e66457a70c08667$var$Me.RIGHT:
                    if (this.referentRect.right + this.rect.width < this.safeArea.right) return $0e66457a70c08667$var$Me.RIGHT;
                    break;
                case $0e66457a70c08667$var$Me.BOTTOM:
                    if (this.referentRect.bottom + this.rect.height < this.safeArea.bottom) return $0e66457a70c08667$var$Me.BOTTOM;
                    break;
                case $0e66457a70c08667$var$Me.LEFT:
                    if (this.referentRect.left - this.rect.width > this.safeArea.left) return $0e66457a70c08667$var$Me.LEFT;
            }
            return this._places[0];
        }
        getHorizontalAlign() {
            for (const e of this._aligns)switch(e){
                case $0e66457a70c08667$var$Ge.CENTER:
                    if (this.referentRect.center - .5 * this.rect.width > this.safeArea.left && this.referentRect.center + .5 * this.rect.width < this.safeArea.right) return $0e66457a70c08667$var$Ge.CENTER;
                    break;
                case $0e66457a70c08667$var$Ge.START:
                    if (this.referentRect.left + this.rect.width < this.safeArea.right) return $0e66457a70c08667$var$Ge.START;
                    break;
                case $0e66457a70c08667$var$Ge.END:
                    if (this.referentRect.right - this.rect.width > this.safeArea.left) return $0e66457a70c08667$var$Ge.END;
            }
            return this._aligns[0];
        }
        getVerticalAlign() {
            for (const e of this._aligns)switch(e){
                case $0e66457a70c08667$var$Ge.CENTER:
                    if (this.referentRect.middle - .5 * this.rect.height > this.safeArea.top && this.referentRect.middle + .5 * this.rect.height < this.safeArea.bottom) return $0e66457a70c08667$var$Ge.CENTER;
                    break;
                case $0e66457a70c08667$var$Ge.START:
                    if (this.referentRect.top + this.rect.height < this.safeArea.bottom) return $0e66457a70c08667$var$Ge.START;
                    break;
                case $0e66457a70c08667$var$Ge.END:
                    if (this.referentRect.bottom - this.rect.height > this.safeArea.top) return $0e66457a70c08667$var$Ge.END;
            }
            return this._aligns[0];
        }
        getSafeArea() {
            let e, t1, s = this.node, i = this._safeAreaMargin, n = window.innerWidth - this._safeAreaMargin, r = window.innerHeight - this._safeAreaMargin, a = this._safeAreaMargin;
            for(; s && s !== document.body;){
                s = s.parentElement;
                const o = window.getComputedStyle(s), h = /(visible|(\w+))(\s(visible|(\w+)))?/.exec(o.overflow);
                if (e = void 0 !== h[2], t1 = void 0 !== h[3] ? void 0 !== h[5] : void 0 !== h[2], !e && !t1) continue;
                const c = s.getBoundingClientRect();
                e && (c.left > a && (a = c.left), c.right < n && (n = c.right)), t1 && (c.top > i && (i = c.top), c.bottom < r && (r = c.bottom));
            }
            return {
                top: i,
                right: n,
                bottom: r,
                left: a,
                center: a + .5 * (n - a),
                middle: i + .5 * (r - i)
            };
        }
        dispose() {
            this._referent = null, super.dispose();
        }
    },
    PlacementReferent: class extends $0e66457a70c08667$var$de {
        constructor(){
            super(), this._isShown = !1;
        }
        static get instanceClassName() {
            return "PlacementReferent";
        }
        init() {
            this.registration.creator.setReferent(this), this._placement = this.registration.creator;
        }
        get placement() {
            return this._placement;
        }
        get isShown() {
            return this._isShown;
        }
        set isShown(e) {
            this._isShown !== e && this.isEnabled && (this._isShown = e, e ? this.registration.creator.show() : this.registration.creator.hide());
        }
        show() {
            this.isShown = !0;
        }
        hide() {
            this.isShown = !1;
        }
    },
    PlacementAlign: $0e66457a70c08667$var$Ge,
    PlacementPosition: $0e66457a70c08667$var$Me,
    PlacementMode: $0e66457a70c08667$var$$e
}, $0e66457a70c08667$var$ne.internals.register($0e66457a70c08667$var$ne.core.CollapseSelector.COLLAPSE, $0e66457a70c08667$var$ne.core.Collapse), $0e66457a70c08667$var$ne.internals.register($0e66457a70c08667$var$ne.core.InjectSvgSelector.INJECT_SVG, $0e66457a70c08667$var$ne.core.InjectSvg), $0e66457a70c08667$var$ne.internals.register($0e66457a70c08667$var$ne.core.RatioSelector.RATIO, $0e66457a70c08667$var$ne.core.Ratio), $0e66457a70c08667$var$ne.internals.register($0e66457a70c08667$var$ne.core.AssessSelector.ASSESS_FILE, $0e66457a70c08667$var$ne.core.AssessFile), $0e66457a70c08667$var$ne.internals.register($0e66457a70c08667$var$ne.core.AssessSelector.DETAIL, $0e66457a70c08667$var$ne.core.AssessDetail);
const $0e66457a70c08667$var$He = {
    SYSTEM: "system",
    LIGHT: "light",
    DARK: "dark"
}, $0e66457a70c08667$var$Ue = {
    THEME: $0e66457a70c08667$var$Oe.internals.ns.attr("theme"),
    SCHEME: $0e66457a70c08667$var$Oe.internals.ns.attr("scheme"),
    TRANSITION: $0e66457a70c08667$var$Oe.internals.ns.attr("transition")
}, $0e66457a70c08667$var$Be = {
    LIGHT: "light",
    DARK: "dark"
}, $0e66457a70c08667$var$Fe = {
    SCHEME: $0e66457a70c08667$var$Oe.internals.ns.emission("scheme", "scheme"),
    THEME: $0e66457a70c08667$var$Oe.internals.ns.emission("scheme", "theme"),
    ASK: $0e66457a70c08667$var$Oe.internals.ns.emission("scheme", "ask")
}, $0e66457a70c08667$var$We = {
    SCHEME: $0e66457a70c08667$var$Oe.internals.ns.event("scheme"),
    THEME: $0e66457a70c08667$var$Oe.internals.ns.event("theme")
};
class $0e66457a70c08667$var$qe extends $0e66457a70c08667$var$Oe.core.Instance {
    constructor(){
        super(!1);
    }
    static get instanceClassName() {
        return "Scheme";
    }
    init() {
        this.changing = this.change.bind(this), this.hasAttribute($0e66457a70c08667$var$Ue.TRANSITION) && (this.removeAttribute($0e66457a70c08667$var$Ue.TRANSITION), this.request(this.restoreTransition.bind(this)));
        const e = $0e66457a70c08667$var$Oe.internals.support.supportLocalStorage() ? localStorage.getItem("scheme") : "", t1 = this.getAttribute($0e66457a70c08667$var$Ue.SCHEME);
        switch(e){
            case $0e66457a70c08667$var$He.DARK:
            case $0e66457a70c08667$var$He.LIGHT:
            case $0e66457a70c08667$var$He.SYSTEM:
                this.scheme = e;
                break;
            default:
                switch(t1){
                    case $0e66457a70c08667$var$He.DARK:
                        this.scheme = $0e66457a70c08667$var$He.DARK;
                        break;
                    case $0e66457a70c08667$var$He.LIGHT:
                        this.scheme = $0e66457a70c08667$var$He.LIGHT;
                        break;
                    default:
                        this.scheme = $0e66457a70c08667$var$He.SYSTEM;
                }
        }
        this.addAscent($0e66457a70c08667$var$Fe.ASK, this.ask.bind(this)), this.addAscent($0e66457a70c08667$var$Fe.SCHEME, this.apply.bind(this));
    }
    get proxy() {
        const e = this, t1 = {
            get scheme () {
                return e.scheme;
            },
            set scheme (t){
                e.scheme = t;
            }
        };
        return $0e66457a70c08667$var$Oe.internals.property.completeAssign(super.proxy, t1);
    }
    restoreTransition() {
        this.setAttribute($0e66457a70c08667$var$Ue.TRANSITION, "");
    }
    ask() {
        this.descend($0e66457a70c08667$var$Fe.SCHEME, this.scheme);
    }
    apply(e) {
        this.scheme = e;
    }
    get scheme() {
        return this._scheme;
    }
    set scheme(e) {
        if (this._scheme !== e) {
            switch(this._scheme = e, e){
                case $0e66457a70c08667$var$He.SYSTEM:
                    this.listenPreferences();
                    break;
                case $0e66457a70c08667$var$He.DARK:
                    this.unlistenPreferences(), this.theme = $0e66457a70c08667$var$Be.DARK;
                    break;
                case $0e66457a70c08667$var$He.LIGHT:
                    this.unlistenPreferences(), this.theme = $0e66457a70c08667$var$Be.LIGHT;
                    break;
                default:
                    return void (this.scheme = $0e66457a70c08667$var$He.SYSTEM);
            }
            this.descend($0e66457a70c08667$var$Fe.SCHEME, e), $0e66457a70c08667$var$Oe.internals.support.supportLocalStorage() && localStorage.setItem("scheme", e), this.setAttribute($0e66457a70c08667$var$Ue.SCHEME, e), this.dispatch($0e66457a70c08667$var$We.SCHEME, {
                scheme: this._scheme
            }, !1);
        }
    }
    get theme() {
        return this._theme;
    }
    set theme(e) {
        if (this._theme !== e) switch(e){
            case $0e66457a70c08667$var$Be.LIGHT:
            case $0e66457a70c08667$var$Be.DARK:
                this._theme = e, this.setAttribute($0e66457a70c08667$var$Ue.THEME, e), this.descend($0e66457a70c08667$var$Fe.THEME, e), this.dispatch($0e66457a70c08667$var$We.THEME, {
                    theme: this._theme
                }, !1), document.documentElement.style.colorScheme = e === $0e66457a70c08667$var$Be.DARK ? "dark" : "";
        }
    }
    listenPreferences() {
        this.isListening || (this.isListening = !0, this.mediaQuery = window.matchMedia("(prefers-color-scheme: dark)"), this.mediaQuery.addEventListener && this.mediaQuery.addEventListener("change", this.changing), this.change());
    }
    unlistenPreferences() {
        this.isListening && (this.isListening = !1, this.mediaQuery.removeEventListener("change", this.changing), this.mediaQuery = null);
    }
    change() {
        this.isListening && (this.theme = this.mediaQuery.matches ? $0e66457a70c08667$var$Be.DARK : $0e66457a70c08667$var$Be.LIGHT);
    }
    mutate(e) {
        e.indexOf($0e66457a70c08667$var$Ue.SCHEME) > -1 && (this.scheme = this.getAttribute($0e66457a70c08667$var$Ue.SCHEME)), e.indexOf($0e66457a70c08667$var$Ue.THEME) > -1 && (this.theme = this.getAttribute($0e66457a70c08667$var$Ue.THEME));
    }
    dispose() {
        this.unlistenPreferences();
    }
}
const $0e66457a70c08667$var$ze = {
    SCHEME: `:root${$0e66457a70c08667$var$Oe.internals.ns.attr.selector("theme")}, :root${$0e66457a70c08667$var$Oe.internals.ns.attr.selector("scheme")}`,
    SWITCH_THEME: $0e66457a70c08667$var$Oe.internals.ns.selector("switch-theme"),
    RADIO_BUTTONS: `input[name="${$0e66457a70c08667$var$Oe.internals.ns("radios-theme")}"]`
};
$0e66457a70c08667$var$Oe.scheme = {
    Scheme: $0e66457a70c08667$var$qe,
    SchemeValue: $0e66457a70c08667$var$He,
    SchemeSelector: $0e66457a70c08667$var$ze,
    SchemeEmission: $0e66457a70c08667$var$Fe,
    SchemeTheme: $0e66457a70c08667$var$Be,
    SchemeEvent: $0e66457a70c08667$var$We
}, $0e66457a70c08667$var$Oe.internals.register($0e66457a70c08667$var$Oe.scheme.SchemeSelector.SCHEME, $0e66457a70c08667$var$Oe.scheme.Scheme);
const $0e66457a70c08667$var$Ke = $0e66457a70c08667$var$Oe.internals.ns.selector("accordion"), $0e66457a70c08667$var$je = $0e66457a70c08667$var$Oe.internals.ns.selector("collapse"), $0e66457a70c08667$var$Ve = {
    GROUP: $0e66457a70c08667$var$Oe.internals.ns.selector("accordions-group"),
    ACCORDION: $0e66457a70c08667$var$Ke,
    COLLAPSE: `${$0e66457a70c08667$var$Ke} > ${$0e66457a70c08667$var$je}, ${$0e66457a70c08667$var$Ke} > *:not(${$0e66457a70c08667$var$Ke}):not(${$0e66457a70c08667$var$je}) > ${$0e66457a70c08667$var$je}, ${$0e66457a70c08667$var$Ke} > *:not(${$0e66457a70c08667$var$Ke}):not(${$0e66457a70c08667$var$je}) > *:not(${$0e66457a70c08667$var$Ke}):not(${$0e66457a70c08667$var$je}) > ${$0e66457a70c08667$var$je}`,
    COLLAPSE_LEGACY: `${$0e66457a70c08667$var$Ke} ${$0e66457a70c08667$var$je}`,
    BUTTON: `${$0e66457a70c08667$var$Ke}__btn`
};
class $0e66457a70c08667$var$Ye extends $0e66457a70c08667$var$Oe.core.Instance {
    static get instanceClassName() {
        return "Accordion";
    }
    get collapsePrimary() {
        return this.element.children.map((e)=>e.getInstance("CollapseButton")).filter((e)=>null !== e && e.hasClass($0e66457a70c08667$var$Ve.BUTTON))[0];
    }
}
class $0e66457a70c08667$var$Xe extends $0e66457a70c08667$var$Oe.core.CollapsesGroup {
    static get instanceClassName() {
        return "AccordionsGroup";
    }
    validate(e) {
        const t1 = e.node.matches($0e66457a70c08667$var$Oe.internals.legacy.isLegacy ? $0e66457a70c08667$var$Ve.COLLAPSE_LEGACY : $0e66457a70c08667$var$Ve.COLLAPSE);
        return super.validate(e) && t1;
    }
}
$0e66457a70c08667$var$Oe.accordion = {
    Accordion: $0e66457a70c08667$var$Ye,
    AccordionSelector: $0e66457a70c08667$var$Ve,
    AccordionsGroup: $0e66457a70c08667$var$Xe
}, $0e66457a70c08667$var$Oe.internals.register($0e66457a70c08667$var$Oe.accordion.AccordionSelector.GROUP, $0e66457a70c08667$var$Oe.accordion.AccordionsGroup), $0e66457a70c08667$var$Oe.internals.register($0e66457a70c08667$var$Oe.accordion.AccordionSelector.ACCORDION, $0e66457a70c08667$var$Oe.accordion.Accordion);
const $0e66457a70c08667$var$Qe = {
    EQUISIZED_BUTTON: `${$0e66457a70c08667$var$Oe.internals.ns.selector("btns-group--equisized")} ${$0e66457a70c08667$var$Oe.internals.ns.selector("btn")}`,
    EQUISIZED_GROUP: $0e66457a70c08667$var$Oe.internals.ns.selector("btns-group--equisized")
};
$0e66457a70c08667$var$Oe.button = {
    ButtonSelector: $0e66457a70c08667$var$Qe
}, $0e66457a70c08667$var$Oe.internals.register($0e66457a70c08667$var$Oe.button.ButtonSelector.EQUISIZED_BUTTON, $0e66457a70c08667$var$Oe.core.Equisized), $0e66457a70c08667$var$Oe.internals.register($0e66457a70c08667$var$Oe.button.ButtonSelector.EQUISIZED_GROUP, $0e66457a70c08667$var$Oe.core.EquisizedsGroup);
class $0e66457a70c08667$var$Ze extends $0e66457a70c08667$var$Oe.core.Instance {
    static get instanceClassName() {
        return "CardDownload";
    }
    init() {
        this.addAscent($0e66457a70c08667$var$Oe.core.AssessEmission.UPDATE, (e)=>{
            this.descend($0e66457a70c08667$var$Oe.core.AssessEmission.UPDATE, e);
        }), this.addAscent($0e66457a70c08667$var$Oe.core.AssessEmission.ADDED, ()=>{
            this.descend($0e66457a70c08667$var$Oe.core.AssessEmission.ADDED);
        });
    }
}
const $0e66457a70c08667$var$Je = {
    DOWNLOAD: $0e66457a70c08667$var$Oe.internals.ns.selector("card--download"),
    DOWNLOAD_DETAIL: `${$0e66457a70c08667$var$Oe.internals.ns.selector("card--download")} ${$0e66457a70c08667$var$Oe.internals.ns.selector("card__end")} ${$0e66457a70c08667$var$Oe.internals.ns.selector("card__detail")}`
};
$0e66457a70c08667$var$Oe.card = {
    CardSelector: $0e66457a70c08667$var$Je,
    CardDownload: $0e66457a70c08667$var$Ze
}, $0e66457a70c08667$var$Oe.internals.register($0e66457a70c08667$var$Oe.card.CardSelector.DOWNLOAD, $0e66457a70c08667$var$Oe.card.CardDownload), $0e66457a70c08667$var$Oe.internals.register($0e66457a70c08667$var$Oe.card.CardSelector.DOWNLOAD_DETAIL, $0e66457a70c08667$var$Oe.core.AssessDetail);
const $0e66457a70c08667$var$et = {
    INPUT: `${$0e66457a70c08667$var$Oe.internals.ns.selector("checkbox-group")} input[type="checkbox"]`
}, $0e66457a70c08667$var$tt = {
    CHANGE: $0e66457a70c08667$var$Oe.internals.ns.emission("checkbox", "change"),
    RETRIEVE: $0e66457a70c08667$var$Oe.internals.ns.emission("checkbox", "retrieve")
};
class $0e66457a70c08667$var$st extends $0e66457a70c08667$var$Oe.core.Instance {
    static get instanceClassName() {
        return "CheckboxInput";
    }
    constructor(){
        super(), this._handlingChange = this.handleChange.bind(this);
    }
    init() {
        this.node.addEventListener("change", this._handlingChange), this.addDescent($0e66457a70c08667$var$tt.RETRIEVE, this._handlingChange), this.handleChange();
    }
    get isChecked() {
        return this.node.checked;
    }
    handleChange() {
        this.ascend($0e66457a70c08667$var$tt.CHANGE, this.node);
    }
}
$0e66457a70c08667$var$Oe.checkbox = {
    CheckboxSelector: $0e66457a70c08667$var$et,
    CheckboxEmission: $0e66457a70c08667$var$tt,
    CheckboxInput: $0e66457a70c08667$var$st
}, $0e66457a70c08667$var$Oe.internals.register($0e66457a70c08667$var$Oe.checkbox.CheckboxSelector.INPUT, $0e66457a70c08667$var$Oe.checkbox.CheckboxInput);
const $0e66457a70c08667$var$it = {
    SEGMENTED: $0e66457a70c08667$var$Oe.internals.ns.selector("segmented"),
    SEGMENTED_ELEMENTS: $0e66457a70c08667$var$Oe.internals.ns.selector("segmented__elements"),
    SEGMENTED_ELEMENT: $0e66457a70c08667$var$Oe.internals.ns.selector("segmented__element input"),
    SEGMENTED_LEGEND: $0e66457a70c08667$var$Oe.internals.ns.selector("segmented__legend")
}, $0e66457a70c08667$var$nt = {
    ADDED: $0e66457a70c08667$var$Oe.internals.ns.emission("segmented", "added"),
    REMOVED: $0e66457a70c08667$var$Oe.internals.ns.emission("segmented", "removed")
};
class $0e66457a70c08667$var$rt extends $0e66457a70c08667$var$Oe.core.Instance {
    static get instanceClassName() {
        return "Segmented";
    }
    init() {
        this.elements = this.node.querySelector($0e66457a70c08667$var$it.SEGMENTED_ELEMENTS), this.legend = this.node.querySelector($0e66457a70c08667$var$it.SEGMENTED_LEGEND), this.addAscent($0e66457a70c08667$var$nt.ADDED, this.resize.bind(this)), this.addAscent($0e66457a70c08667$var$nt.REMOVED, this.resize.bind(this)), this._isLegendInline = this.legend && this.legend.classList.contains(`${$0e66457a70c08667$var$Oe.prefix}-segmented__legend--inline`), this.isResizing = !0;
    }
    resize() {
        const e = `${$0e66457a70c08667$var$Oe.prefix}-segmented--vertical`, t1 = `${$0e66457a70c08667$var$Oe.prefix}-segmented__legend--inline`;
        this.removeClass(e), this._isLegendInline && (this.legend.classList.add(t1), (this.node.offsetWidth > this.node.parentNode.offsetWidth || this.elements.scrollWidth + this.legend.offsetWidth + 16 > this.node.parentNode.offsetWidth) && this.legend.classList.remove(t1)), this.elements.offsetWidth > this.node.parentNode.offsetWidth || this.elements.scrollWidth > this.node.parentNode.offsetWidth ? this.addClass(e) : this.removeClass(e);
    }
}
class $0e66457a70c08667$var$at extends $0e66457a70c08667$var$Oe.core.Instance {
    static get instanceClassName() {
        return "SegmentedElement";
    }
    init() {
        this.ascend($0e66457a70c08667$var$nt.ADDED);
    }
    dispose() {
        this.ascend($0e66457a70c08667$var$nt.REMOVED);
    }
}
$0e66457a70c08667$var$Oe.segmented = {
    SegmentedSelector: $0e66457a70c08667$var$it,
    SegmentedEmission: $0e66457a70c08667$var$nt,
    SegmentedElement: $0e66457a70c08667$var$at,
    Segmented: $0e66457a70c08667$var$rt
}, $0e66457a70c08667$var$Oe.internals.register($0e66457a70c08667$var$Oe.segmented.SegmentedSelector.SEGMENTED, $0e66457a70c08667$var$Oe.segmented.Segmented), $0e66457a70c08667$var$Oe.internals.register($0e66457a70c08667$var$Oe.segmented.SegmentedSelector.SEGMENTED_ELEMENT, $0e66457a70c08667$var$Oe.segmented.SegmentedElement);
const $0e66457a70c08667$var$ot = {
    BREADCRUMB: $0e66457a70c08667$var$Oe.internals.ns.selector("breadcrumb"),
    BUTTON: $0e66457a70c08667$var$Oe.internals.ns.selector("breadcrumb__button")
};
class $0e66457a70c08667$var$ht extends $0e66457a70c08667$var$Oe.core.Instance {
    constructor(){
        super(), this.count = 0, this.focusing = this.focus.bind(this);
    }
    static get instanceClassName() {
        return "Breadcrumb";
    }
    init() {
        this.getCollapse(), this.isResizing = !0;
    }
    get proxy() {
        const e = this;
        return Object.assign(super.proxy, {
            focus: e.focus.bind(e),
            disclose: e.collapse.disclose.bind(e.collapse)
        });
    }
    getCollapse() {
        const e = this.collapse;
        e ? e.listen($0e66457a70c08667$var$Oe.core.DisclosureEvent.DISCLOSE, this.focusing) : this.addAscent($0e66457a70c08667$var$Oe.core.DisclosureEmission.ADDED, this.getCollapse.bind(this));
    }
    resize() {
        const e = this.collapse, t1 = this.links;
        e && t1.length && (this.isBreakpoint($0e66457a70c08667$var$Oe.core.Breakpoints.MD) ? e.buttonHasFocus && t1[0].focus() : t1.indexOf(document.activeElement) > -1 && e.focus());
    }
    get links() {
        return [
            ...this.querySelectorAll("a[href]")
        ];
    }
    get collapse() {
        return this.element.getDescendantInstances($0e66457a70c08667$var$Oe.core.Collapse.instanceClassName, null, !0)[0];
    }
    focus() {
        this.count = 0, this._focus();
    }
    _focus() {
        const e = this.links[0];
        e && (e.focus(), this.request(this.verify.bind(this)));
    }
    verify() {
        if (this.count++, this.count > 100) return;
        const e = this.links[0];
        e && document.activeElement !== e && this._focus();
    }
    get collapsePrimary() {
        return this.element.children.map((e)=>e.getInstance("CollapseButton")).filter((e)=>null !== e && e.hasClass($0e66457a70c08667$var$ot.BUTTON))[0];
    }
}
$0e66457a70c08667$var$Oe.breadcrumb = {
    BreadcrumbSelector: $0e66457a70c08667$var$ot,
    Breadcrumb: $0e66457a70c08667$var$ht
}, $0e66457a70c08667$var$Oe.internals.register($0e66457a70c08667$var$Oe.breadcrumb.BreadcrumbSelector.BREADCRUMB, $0e66457a70c08667$var$Oe.breadcrumb.Breadcrumb);
const $0e66457a70c08667$var$ct = {
    TOOLTIP: $0e66457a70c08667$var$Oe.internals.ns.selector("tooltip"),
    SHOWN: $0e66457a70c08667$var$Oe.internals.ns.selector("tooltip--shown"),
    HIDDING: $0e66457a70c08667$var$Oe.internals.ns.selector("tooltip--hidding"),
    BUTTON: $0e66457a70c08667$var$Oe.internals.ns.selector("btn--tooltip")
}, $0e66457a70c08667$var$lt = 1, $0e66457a70c08667$var$dt = 2;
class $0e66457a70c08667$var$ut extends $0e66457a70c08667$var$Oe.core.PlacementReferent {
    constructor(){
        super(), this._state = 0;
    }
    static get instanceClassName() {
        return "TooltipReferent";
    }
    init() {
        if (super.init(), this.listen("focusin", this.focusIn.bind(this)), this.listen("focusout", this.focusOut.bind(this)), !this.matches($0e66457a70c08667$var$ct.BUTTON)) {
            const e = this.mouseover.bind(this);
            this.listen("mouseover", e), this.placement.listen("mouseover", e);
            const t1 = this.mouseout.bind(this);
            this.listen("mouseout", t1), this.placement.listen("mouseout", t1);
        }
        this.addEmission($0e66457a70c08667$var$Oe.core.RootEmission.KEYDOWN, this._keydown.bind(this)), this.listen("click", this._click.bind(this)), this.addEmission($0e66457a70c08667$var$Oe.core.RootEmission.CLICK, this._clickOut.bind(this));
    }
    _click() {
        this.focus();
    }
    _clickOut(e) {
        this.node.contains(e) || this.blur();
    }
    _keydown(e) {
        if (e === $0e66457a70c08667$var$Oe.core.KeyCodes.ESCAPE) this.blur(), this.close();
    }
    close() {
        this.state = 0;
    }
    get state() {
        return this._state;
    }
    set state(e) {
        this._state !== e && (this.isShown = e > 0, this._state = e);
    }
    focusIn() {
        this.state |= $0e66457a70c08667$var$lt;
    }
    focusOut() {
        this.state &= ~$0e66457a70c08667$var$lt;
    }
    mouseover() {
        this.state |= $0e66457a70c08667$var$dt;
    }
    mouseout() {
        this.state &= ~$0e66457a70c08667$var$dt;
    }
}
const $0e66457a70c08667$var$gt = {
    SHOW: $0e66457a70c08667$var$g.event("show"),
    HIDE: $0e66457a70c08667$var$g.event("hide")
}, $0e66457a70c08667$var$pt = "hidden", $0e66457a70c08667$var$mt = "shown", $0e66457a70c08667$var$_t = "hiding";
class $0e66457a70c08667$var$bt extends $0e66457a70c08667$var$Oe.core.Placement {
    constructor(){
        super($0e66457a70c08667$var$Oe.core.PlacementMode.AUTO, [
            $0e66457a70c08667$var$Oe.core.PlacementPosition.TOP,
            $0e66457a70c08667$var$Oe.core.PlacementPosition.BOTTOM
        ], [
            $0e66457a70c08667$var$Oe.core.PlacementAlign.CENTER,
            $0e66457a70c08667$var$Oe.core.PlacementAlign.START,
            $0e66457a70c08667$var$Oe.core.PlacementAlign.END
        ]), this.modifier = "", this._state = $0e66457a70c08667$var$pt;
    }
    static get instanceClassName() {
        return "Tooltip";
    }
    init() {
        super.init(), this.register(`[aria-describedby="${this.id}"]`, $0e66457a70c08667$var$ut), this.listen("transitionend", this.transitionEnd.bind(this));
    }
    transitionEnd() {
        this._state === $0e66457a70c08667$var$_t && (this.removeClass($0e66457a70c08667$var$ct.SHOWN), this.removeClass($0e66457a70c08667$var$ct.HIDDING), this._state = $0e66457a70c08667$var$pt, this.isShown = !1);
    }
    get isShown() {
        return super.isShown;
    }
    set isShown(e) {
        if (this.isEnabled) switch(!0){
            case e:
                this._state = $0e66457a70c08667$var$mt, this.addClass($0e66457a70c08667$var$ct.SHOWN), this.removeClass($0e66457a70c08667$var$ct.HIDDING), this.dispatch($0e66457a70c08667$var$gt.SHOW), super.isShown = !0;
                break;
            case this.isShown && !e && this._state === $0e66457a70c08667$var$mt:
                this._state = $0e66457a70c08667$var$_t, this.addClass($0e66457a70c08667$var$ct.HIDDING);
                break;
            case this.isShown && !e && this._state === $0e66457a70c08667$var$pt:
                this.dispatch($0e66457a70c08667$var$gt.HIDE), this.removeClass($0e66457a70c08667$var$ct.HIDDING), super.isShown = !1;
        }
    }
    render() {
        super.render(), this.rect = this.getRect();
        let e = this.referentRect.center - this.rect.center;
        const t1 = .5 * this.rect.width - 8;
        e < -t1 && (e = -t1), e > t1 && (e = t1), this.setProperty("--arrow-x", `${e.toFixed(2)}px`);
    }
}
$0e66457a70c08667$var$Oe.tooltip = {
    Tooltip: $0e66457a70c08667$var$bt,
    TooltipSelector: $0e66457a70c08667$var$ct,
    TooltipEvent: $0e66457a70c08667$var$gt
}, $0e66457a70c08667$var$Oe.internals.register($0e66457a70c08667$var$Oe.tooltip.TooltipSelector.TOOLTIP, $0e66457a70c08667$var$Oe.tooltip.Tooltip);
class $0e66457a70c08667$var$Et extends $0e66457a70c08667$var$Oe.core.Instance {
    static get instanceClassName() {
        return "ToggleInput";
    }
    get isChecked() {
        return this.node.checked;
    }
}
class $0e66457a70c08667$var$ft extends $0e66457a70c08667$var$Oe.core.Instance {
    static get instanceClassName() {
        return "ToggleStatusLabel";
    }
    init() {
        this.register(`input[id="${this.getAttribute("for")}"]`, $0e66457a70c08667$var$Et), this.update(), this.isSwappingFont = !0;
    }
    get proxy() {
        return Object.assign(super.proxy, {
            update: this.update.bind(this)
        });
    }
    get input() {
        return this.getRegisteredInstances("ToggleInput")[0];
    }
    update() {
        this.node.style.removeProperty("--toggle-status-width");
        const e = this.input.isChecked, t1 = getComputedStyle(this.node, ":before");
        let s = parseFloat(t1.width);
        this.input.node.checked = !e;
        const i = getComputedStyle(this.node, ":before"), n = parseFloat(i.width);
        n > s && (s = n), this.input.node.checked = e, this.node.style.setProperty("--toggle-status-width", s / 16 + "rem");
    }
    swapFont(e) {
        this.update();
    }
}
const $0e66457a70c08667$var$At = {
    STATUS_LABEL: `${$0e66457a70c08667$var$Oe.internals.ns.selector("toggle__label")}${$0e66457a70c08667$var$Oe.internals.ns.attr.selector("checked-label")}${$0e66457a70c08667$var$Oe.internals.ns.attr.selector("unchecked-label")}`
};
$0e66457a70c08667$var$Oe.toggle = {
    ToggleStatusLabel: $0e66457a70c08667$var$ft,
    ToggleSelector: $0e66457a70c08667$var$At
}, $0e66457a70c08667$var$Oe.internals.register($0e66457a70c08667$var$Oe.toggle.ToggleSelector.STATUS_LABEL, $0e66457a70c08667$var$Oe.toggle.ToggleStatusLabel);
const $0e66457a70c08667$var$Tt = $0e66457a70c08667$var$Oe.internals.ns.selector("sidemenu__item"), $0e66457a70c08667$var$vt = $0e66457a70c08667$var$Oe.internals.ns.selector("collapse"), $0e66457a70c08667$var$St = {
    LIST: $0e66457a70c08667$var$Oe.internals.ns.selector("sidemenu__list"),
    COLLAPSE: `${$0e66457a70c08667$var$Tt} > ${$0e66457a70c08667$var$vt}, ${$0e66457a70c08667$var$Tt} > *:not(${$0e66457a70c08667$var$Tt}):not(${$0e66457a70c08667$var$vt}) > ${$0e66457a70c08667$var$vt}, ${$0e66457a70c08667$var$Tt} > *:not(${$0e66457a70c08667$var$Tt}):not(${$0e66457a70c08667$var$vt}) > *:not(${$0e66457a70c08667$var$Tt}):not(${$0e66457a70c08667$var$vt}) > ${$0e66457a70c08667$var$vt}`,
    COLLAPSE_LEGACY: `${$0e66457a70c08667$var$Tt} ${$0e66457a70c08667$var$vt}`,
    ITEM: $0e66457a70c08667$var$Oe.internals.ns.selector("sidemenu__item"),
    BUTTON: $0e66457a70c08667$var$Oe.internals.ns.selector("sidemenu__btn")
};
class $0e66457a70c08667$var$yt extends $0e66457a70c08667$var$Oe.core.CollapsesGroup {
    static get instanceClassName() {
        return "SidemenuList";
    }
    validate(e) {
        return super.validate(e) && e.node.matches($0e66457a70c08667$var$Oe.internals.legacy.isLegacy ? $0e66457a70c08667$var$St.COLLAPSE_LEGACY : $0e66457a70c08667$var$St.COLLAPSE);
    }
}
class $0e66457a70c08667$var$Ct extends $0e66457a70c08667$var$Oe.core.Instance {
    static get instanceClassName() {
        return "SidemenuItem";
    }
    get collapsePrimary() {
        return this.element.children.map((e)=>e.getInstance("CollapseButton")).filter((e)=>null !== e && e.hasClass($0e66457a70c08667$var$St.BUTTON))[0];
    }
}
$0e66457a70c08667$var$Oe.sidemenu = {
    SidemenuList: $0e66457a70c08667$var$yt,
    SidemenuItem: $0e66457a70c08667$var$Ct,
    SidemenuSelector: $0e66457a70c08667$var$St
}, $0e66457a70c08667$var$Oe.internals.register($0e66457a70c08667$var$Oe.sidemenu.SidemenuSelector.LIST, $0e66457a70c08667$var$Oe.sidemenu.SidemenuList), $0e66457a70c08667$var$Oe.internals.register($0e66457a70c08667$var$Oe.sidemenu.SidemenuSelector.ITEM, $0e66457a70c08667$var$Oe.sidemenu.SidemenuItem);
const $0e66457a70c08667$var$Nt = {
    MODAL: $0e66457a70c08667$var$Oe.internals.ns.selector("modal"),
    SCROLL_DIVIDER: $0e66457a70c08667$var$Oe.internals.ns.selector("scroll-divider"),
    BODY: $0e66457a70c08667$var$Oe.internals.ns.selector("modal__body"),
    TITLE: $0e66457a70c08667$var$Oe.internals.ns.selector("modal__title")
};
class $0e66457a70c08667$var$Dt extends $0e66457a70c08667$var$Oe.core.DisclosureButton {
    constructor(){
        super($0e66457a70c08667$var$Oe.core.DisclosureType.OPENED);
    }
    static get instanceClassName() {
        return "ModalButton";
    }
}
const $0e66457a70c08667$var$Rt = {
    CONCEALING_BACKDROP: $0e66457a70c08667$var$Oe.internals.ns.attr("concealing-backdrop")
};
class $0e66457a70c08667$var$wt extends $0e66457a70c08667$var$Oe.core.Disclosure {
    constructor(){
        super($0e66457a70c08667$var$Oe.core.DisclosureType.OPENED, $0e66457a70c08667$var$Nt.MODAL, $0e66457a70c08667$var$Dt, "ModalsGroup"), this._isDecorated = !1, this.scrolling = this.resize.bind(this, !1), this.resizing = this.resize.bind(this, !0);
    }
    static get instanceClassName() {
        return "Modal";
    }
    init() {
        super.init(), this._isDialog = "DIALOG" === this.node.tagName, this.listenClick(), this.addEmission($0e66457a70c08667$var$Oe.core.RootEmission.KEYDOWN, this._keydown.bind(this));
    }
    _keydown(e) {
        if (e === $0e66457a70c08667$var$Oe.core.KeyCodes.ESCAPE) this._escape();
    }
    _escape() {
        switch(document.activeElement ? document.activeElement.tagName : void 0){
            case "INPUT":
            case "LABEL":
            case "TEXTAREA":
            case "SELECT":
            case "AUDIO":
            case "VIDEO":
                break;
            default:
                this.isDisclosed && (this.conceal(), this.focus());
        }
    }
    retrieved() {
        this._ensureAccessibleName();
    }
    get body() {
        return this.element.getDescendantInstances("ModalBody", "Modal")[0];
    }
    handleClick(e) {
        e.target === this.node && "false" !== this.getAttribute($0e66457a70c08667$var$Rt.CONCEALING_BACKDROP) && this.conceal();
    }
    disclose(e) {
        return !!super.disclose(e) && (this.body && (this.body.isResizing = !0, this.body.resize()), this.isScrollLocked = !0, this.setAttribute("aria-modal", "true"), this.setAttribute("open", "true"), this._isDialog || this.decorateDialog(), !0);
    }
    conceal(e, t1) {
        return !!super.conceal(e, t1) && (this.isScrollLocked = !1, this.removeAttribute("aria-modal"), this.removeAttribute("open"), this.body && (this.body.isResizing = !1), this._isDialog || this.stripDialog(), !0);
    }
    get isDialog() {
        return this._isDialog;
    }
    set isDialog(e) {
        this._isDialog = e;
    }
    get isActive() {
        return super.isActive;
    }
    set isActive(e) {
        super.isActive = e, e && this._ensureAccessibleName();
    }
    decorateDialog() {
        this._isDecorated || (this._isDecorated = !0, this._hasDialogRole = "dialog" === this.getAttribute("role"), this._hasDialogRole || this.setAttribute("role", "dialog"));
    }
    stripDialog() {
        this._isDecorated && (this._isDecorated = !1, this._hasDialogRole || this.removeAttribute("role"));
    }
    _setAccessibleName(e, t1) {
        const s = this.retrieveNodeId(e, t1);
        this.warn(`add reference to ${t1} for accessible name (aria-labelledby)`), this.setAttribute("aria-labelledby", s);
    }
    _ensureAccessibleName() {
        if (!this.isActive || !this.isEnabled || this.isEnabled && (this.hasAttribute("aria-labelledby") || this.hasAttribute("aria-label"))) return;
        this.warn("missing accessible name");
        const e = this.node.querySelector($0e66457a70c08667$var$Nt.TITLE), t1 = this.primaryButtons[0];
        switch(!0){
            case null !== e:
                this._setAccessibleName(e, "title");
                break;
            case void 0 !== t1:
                this.warn("missing required title, fallback to primary button"), this._setAccessibleName(t1, "primary");
        }
    }
}
const $0e66457a70c08667$var$Lt = [
    '[tabindex="0"]',
    "a[href]",
    "button:not([disabled])",
    "input:not([disabled])",
    "select:not([disabled])",
    "textarea:not([disabled])",
    "audio[controls]",
    "video[controls]",
    '[contenteditable]:not([contenteditable="false"])',
    "details>summary:first-of-type",
    "details",
    "iframe"
].join(), $0e66457a70c08667$var$It = [
    '[tabindex]:not([tabindex="-1"]):not([tabindex="0"])'
].join(), $0e66457a70c08667$var$xt = (e, t1)=>{
    if (!(e instanceof Element)) return !1;
    const s = window.getComputedStyle(e);
    if (!s) return !1;
    if ("hidden" === s.visibility) return !1;
    for(void 0 === t1 && (t1 = e); t1.contains(e);){
        if ("none" === s.display) return !1;
        e = e.parentElement;
    }
    return !0;
};
class $0e66457a70c08667$var$Ot {
    constructor(e, t1){
        this.element = null, this.activeElement = null, this.onTrap = e, this.onUntrap = t1, this.waiting = this.wait.bind(this), this.handling = this.handle.bind(this), this.focusing = this.maintainFocus.bind(this), this.current = null;
    }
    get trapped() {
        return null !== this.element;
    }
    trap(e) {
        this.trapped && this.untrap(), this.element = e, this.isTrapping = !0, this.wait(), this.onTrap && this.onTrap();
    }
    wait() {
        $0e66457a70c08667$var$xt(this.element) ? this.trapping() : window.requestAnimationFrame(this.waiting);
    }
    trapping() {
        if (!this.isTrapping) return;
        this.isTrapping = !1;
        const e = this.focusables;
        e.length && -1 === e.indexOf(document.activeElement) && e[0].focus(), this.element.setAttribute("aria-modal", !0), window.addEventListener("keydown", this.handling), document.body.addEventListener("focus", this.focusing, !0);
    }
    stun(e) {
        for (const t1 of e.children)t1 !== this.element && (t1.contains(this.element) ? this.stun(t1) : this.stunneds.push(new $0e66457a70c08667$var$Pt(t1)));
    }
    maintainFocus(e) {
        if (!this.element.contains(e.target)) {
            const t1 = this.focusables;
            if (0 === t1.length) return;
            const s = t1[0];
            e.preventDefault(), s.focus();
        }
    }
    handle(e) {
        if (9 !== e.keyCode) return;
        const t1 = this.focusables;
        if (0 === t1.length) return;
        const s = t1[0], i = t1[t1.length - 1], n = t1.indexOf(document.activeElement);
        e.shiftKey ? !this.element.contains(document.activeElement) || n < 1 ? (e.preventDefault(), i.focus()) : (document.activeElement.tabIndex > 0 || t1[n - 1].tabIndex > 0) && (e.preventDefault(), t1[n - 1].focus()) : this.element.contains(document.activeElement) && n !== t1.length - 1 && -1 !== n ? document.activeElement.tabIndex > 0 && (e.preventDefault(), t1[n + 1].focus()) : (e.preventDefault(), s.focus());
    }
    get focusables() {
        let e = $0e66457a70c08667$var$Oe.internals.dom.querySelectorAllArray(this.element, $0e66457a70c08667$var$Lt);
        const t1 = $0e66457a70c08667$var$Oe.internals.dom.querySelectorAllArray(document.documentElement, 'input[type="radio"]');
        if (t1.length) {
            const s = {};
            for (const e of t1){
                const t1 = e.getAttribute("name");
                void 0 === s[t1] && (s[t1] = new $0e66457a70c08667$var$kt(t1)), s[t1].push(e);
            }
            e = e.filter((e)=>{
                if ("input" !== e.tagName.toLowerCase() || e.getAttribute("type") && "radio" !== e.getAttribute("type").toLowerCase()) return !0;
                const t1 = e.getAttribute("name");
                return s[t1].keep(e);
            });
        }
        const s = $0e66457a70c08667$var$Oe.internals.dom.querySelectorAllArray(this.element, $0e66457a70c08667$var$It);
        s.sort((e, t1)=>e.tabIndex - t1.tabIndex);
        const i = e.filter((e)=>-1 === s.indexOf(e));
        return s.concat(i).filter((e)=>"-1" !== e.tabIndex && $0e66457a70c08667$var$xt(e, this.element));
    }
    untrap() {
        this.trapped && (this.isTrapping = !1, this.element.removeAttribute("aria-modal"), window.removeEventListener("keydown", this.handling), document.body.removeEventListener("focus", this.focusing, !0), this.element = null, this.onUntrap && this.onUntrap());
    }
    dispose() {
        this.untrap();
    }
}
class $0e66457a70c08667$var$Pt {
    constructor(e){
        this.element = e, this.inert = e.getAttribute("inert"), this.element.setAttribute("inert", "");
    }
    unstun() {
        null === this.inert ? this.element.removeAttribute("inert") : this.element.setAttribute("inert", this.inert);
    }
}
class $0e66457a70c08667$var$kt {
    constructor(e){
        this.name = e, this.buttons = [];
    }
    push(e) {
        this.buttons.push(e), (e === document.activeElement || e.checked || void 0 === this.selected) && (this.selected = e);
    }
    keep(e) {
        return this.selected === e;
    }
}
class $0e66457a70c08667$var$Mt extends $0e66457a70c08667$var$Oe.core.DisclosuresGroup {
    constructor(){
        super("Modal", !1), this.focusTrap = new $0e66457a70c08667$var$Ot;
    }
    static get instanceClassName() {
        return "ModalsGroup";
    }
    apply(e, t1) {
        super.apply(e, t1), null === this.current ? this.focusTrap.untrap() : this.focusTrap.trap(this.current.node);
    }
}
class $0e66457a70c08667$var$Gt extends $0e66457a70c08667$var$Oe.core.Instance {
    static get instanceClassName() {
        return "ModalBody";
    }
    init() {
        this.listen("scroll", this.divide.bind(this));
    }
    divide() {
        this.node.scrollHeight > this.node.clientHeight ? this.node.offsetHeight + this.node.scrollTop >= this.node.scrollHeight ? this.removeClass($0e66457a70c08667$var$Nt.SCROLL_DIVIDER) : this.addClass($0e66457a70c08667$var$Nt.SCROLL_DIVIDER) : this.removeClass($0e66457a70c08667$var$Nt.SCROLL_DIVIDER);
    }
    resize() {
        this.adjust(), this.request(this.adjust.bind(this));
    }
    adjust() {
        const e = 32 * (this.isBreakpoint($0e66457a70c08667$var$Oe.core.Breakpoints.MD) ? 2 : 1);
        this.isLegacy ? this.style.maxHeight = window.innerHeight - e + "px" : this.style.setProperty("--modal-max-height", window.innerHeight - e + "px"), this.divide();
    }
}
$0e66457a70c08667$var$Oe.modal = {
    Modal: $0e66457a70c08667$var$wt,
    ModalButton: $0e66457a70c08667$var$Dt,
    ModalBody: $0e66457a70c08667$var$Gt,
    ModalsGroup: $0e66457a70c08667$var$Mt,
    ModalSelector: $0e66457a70c08667$var$Nt
}, $0e66457a70c08667$var$Oe.internals.register($0e66457a70c08667$var$Oe.modal.ModalSelector.MODAL, $0e66457a70c08667$var$Oe.modal.Modal), $0e66457a70c08667$var$Oe.internals.register($0e66457a70c08667$var$Oe.modal.ModalSelector.BODY, $0e66457a70c08667$var$Oe.modal.ModalBody), $0e66457a70c08667$var$Oe.internals.register($0e66457a70c08667$var$Oe.core.RootSelector.ROOT, $0e66457a70c08667$var$Oe.modal.ModalsGroup);
const $0e66457a70c08667$var$$t = {
    TOGGLE: $0e66457a70c08667$var$Oe.internals.ns.emission("password", "toggle"),
    ADJUST: $0e66457a70c08667$var$Oe.internals.ns.emission("password", "adjust")
};
class $0e66457a70c08667$var$Ht extends $0e66457a70c08667$var$Oe.core.Instance {
    static get instanceClassName() {
        return "PasswordToggle";
    }
    init() {
        this.listenClick(), this.ascend($0e66457a70c08667$var$$t.ADJUST, this.width), this.isSwappingFont = !0, this._isChecked = this.isChecked;
    }
    get width() {
        const e = getComputedStyle(this.node.parentNode);
        return parseInt(e.width);
    }
    get isChecked() {
        return this.node.checked;
    }
    set isChecked(e) {
        this._isChecked = e, this.ascend($0e66457a70c08667$var$$t.TOGGLE, e);
    }
    handleClick() {
        this.isChecked = !this._isChecked;
    }
    swapFont(e) {
        this.ascend($0e66457a70c08667$var$$t.ADJUST, this.width);
    }
}
class $0e66457a70c08667$var$Ut extends $0e66457a70c08667$var$Oe.core.Instance {
    static get instanceClassName() {
        return "Password";
    }
    init() {
        this.addAscent($0e66457a70c08667$var$$t.TOGGLE, this.toggle.bind(this)), this.addAscent($0e66457a70c08667$var$$t.ADJUST, this.adjust.bind(this));
    }
    toggle(e) {
        this.descend($0e66457a70c08667$var$$t.TOGGLE, e);
    }
    adjust(e) {
        this.descend($0e66457a70c08667$var$$t.ADJUST, e);
    }
}
const $0e66457a70c08667$var$Bt = {
    PASSWORD: $0e66457a70c08667$var$Oe.internals.ns.selector("password"),
    INPUT: $0e66457a70c08667$var$Oe.internals.ns.selector("password__input"),
    LABEL: $0e66457a70c08667$var$Oe.internals.ns.selector("password__label"),
    TOOGLE: `${$0e66457a70c08667$var$Oe.internals.ns.selector("password__checkbox")} input[type="checkbox"]`
};
class $0e66457a70c08667$var$Ft extends $0e66457a70c08667$var$Oe.core.Instance {
    static get instanceClassName() {
        return "PasswordInput";
    }
    init() {
        this.addDescent($0e66457a70c08667$var$$t.TOGGLE, this.toggle.bind(this)), this._isRevealed = "password" === this.hasAttribute("type"), this.listen("keydown", this.capslock.bind(this)), this.listen("keyup", this.capslock.bind(this));
    }
    toggle(e) {
        this.isRevealed = e, this.setAttribute("type", e ? "text" : "password");
    }
    get isRevealed() {
        return this._isRevealed;
    }
    capslock(e) {
        e && "function" != typeof e.getModifierState || (e.getModifierState("CapsLock") ? this.node.parentNode.setAttribute($0e66457a70c08667$var$Oe.internals.ns.attr("capslock"), "") : this.node.parentNode.removeAttribute($0e66457a70c08667$var$Oe.internals.ns.attr("capslock")));
    }
    set isRevealed(e) {
        this._isRevealed = e, this.setAttribute("type", e ? "text" : "password");
    }
}
class $0e66457a70c08667$var$Wt extends $0e66457a70c08667$var$Oe.core.Instance {
    static get instanceClassName() {
        return "PasswordLabel";
    }
    init() {
        this.addDescent($0e66457a70c08667$var$$t.ADJUST, this.adjust.bind(this));
    }
    adjust(e) {
        const t1 = Math.ceil(e / 16);
        this.node.style.paddingRight = t1 + "rem";
    }
}
$0e66457a70c08667$var$Oe.password = {
    Password: $0e66457a70c08667$var$Ut,
    PasswordToggle: $0e66457a70c08667$var$Ht,
    PasswordSelector: $0e66457a70c08667$var$Bt,
    PasswordInput: $0e66457a70c08667$var$Ft,
    PasswordLabel: $0e66457a70c08667$var$Wt
}, $0e66457a70c08667$var$Oe.internals.register($0e66457a70c08667$var$Oe.password.PasswordSelector.INPUT, $0e66457a70c08667$var$Oe.password.PasswordInput), $0e66457a70c08667$var$Oe.internals.register($0e66457a70c08667$var$Oe.password.PasswordSelector.PASSWORD, $0e66457a70c08667$var$Oe.password.Password), $0e66457a70c08667$var$Oe.internals.register($0e66457a70c08667$var$Oe.password.PasswordSelector.TOOGLE, $0e66457a70c08667$var$Oe.password.PasswordToggle), $0e66457a70c08667$var$Oe.internals.register($0e66457a70c08667$var$Oe.password.PasswordSelector.LABEL, $0e66457a70c08667$var$Oe.password.PasswordLabel);
const $0e66457a70c08667$var$qt = $0e66457a70c08667$var$Oe.internals.ns.selector("nav__item"), $0e66457a70c08667$var$zt = $0e66457a70c08667$var$Oe.internals.ns.selector("collapse"), $0e66457a70c08667$var$Kt = {
    NAVIGATION: $0e66457a70c08667$var$Oe.internals.ns.selector("nav"),
    COLLAPSE: `${$0e66457a70c08667$var$qt} > ${$0e66457a70c08667$var$zt}, ${$0e66457a70c08667$var$qt} > *:not(${$0e66457a70c08667$var$qt}):not(${$0e66457a70c08667$var$zt}) > ${$0e66457a70c08667$var$zt}, ${$0e66457a70c08667$var$qt} > *:not(${$0e66457a70c08667$var$qt}):not(${$0e66457a70c08667$var$zt}) > *:not(${$0e66457a70c08667$var$qt}):not(${$0e66457a70c08667$var$zt}) > ${$0e66457a70c08667$var$zt}`,
    COLLAPSE_LEGACY: `${$0e66457a70c08667$var$qt} ${$0e66457a70c08667$var$zt}`,
    ITEM: $0e66457a70c08667$var$qt,
    ITEM_RIGHT: `${$0e66457a70c08667$var$qt}--align-right`,
    MENU: $0e66457a70c08667$var$Oe.internals.ns.selector("menu"),
    BUTTON: $0e66457a70c08667$var$Oe.internals.ns.selector("nav__btn"),
    TRANSLATE_BUTTON: $0e66457a70c08667$var$Oe.internals.ns.selector("translate__btn")
};
class $0e66457a70c08667$var$jt extends $0e66457a70c08667$var$Oe.core.Instance {
    constructor(){
        super(), this._isRightAligned = !1;
    }
    static get instanceClassName() {
        return "NavigationItem";
    }
    init() {
        this.addAscent($0e66457a70c08667$var$Oe.core.DisclosureEmission.ADDED, this.calculate.bind(this)), this.addAscent($0e66457a70c08667$var$Oe.core.DisclosureEmission.REMOVED, this.calculate.bind(this)), this.isResizing = !0, this.calculate();
    }
    resize() {
        this.calculate();
    }
    calculate() {
        const e = this.element.getDescendantInstances($0e66457a70c08667$var$Oe.core.Collapse.instanceClassName, null, !0)[0];
        if (e && this.isBreakpoint($0e66457a70c08667$var$Oe.core.Breakpoints.LG) && e.element.node.matches($0e66457a70c08667$var$Kt.MENU)) {
            const t1 = this.element.node.parentElement.getBoundingClientRect().right, s = e.element.node.getBoundingClientRect().width, i = this.element.node.getBoundingClientRect().left;
            this.isRightAligned = i + s > t1;
        } else this.isRightAligned = !1;
    }
    get isRightAligned() {
        return this._isRightAligned;
    }
    set isRightAligned(e) {
        this._isRightAligned !== e && (this._isRightAligned = e, e ? $0e66457a70c08667$var$Oe.internals.dom.addClass(this.element.node, $0e66457a70c08667$var$Kt.ITEM_RIGHT) : $0e66457a70c08667$var$Oe.internals.dom.removeClass(this.element.node, $0e66457a70c08667$var$Kt.ITEM_RIGHT));
    }
    get collapsePrimary() {
        return this.element.children.map((e)=>e.getInstance("CollapseButton")).filter((e)=>null !== e && (e.hasClass($0e66457a70c08667$var$Kt.BUTTON) || e.hasClass($0e66457a70c08667$var$Kt.TRANSLATE_BUTTON)))[0];
    }
}
const $0e66457a70c08667$var$Vt = {
    NONE: -1,
    INSIDE: 0,
    OUTSIDE: 1
};
class $0e66457a70c08667$var$Yt extends $0e66457a70c08667$var$Oe.core.CollapsesGroup {
    static get instanceClassName() {
        return "Navigation";
    }
    init() {
        super.init(), this.clicked = !1, this.out = !1, this.addEmission($0e66457a70c08667$var$Oe.core.RootEmission.CLICK, this._handleRootClick.bind(this)), this.listen("mousedown", this.handleMouseDown.bind(this)), this.addEmission($0e66457a70c08667$var$Oe.core.RootEmission.KEYDOWN, this._keydown.bind(this)), this.listenClick({
            capture: !0
        }), this.isResizing = !0;
    }
    validate(e) {
        return super.validate(e) && e.element.node.matches($0e66457a70c08667$var$Oe.internals.legacy.isLegacy ? $0e66457a70c08667$var$Kt.COLLAPSE_LEGACY : $0e66457a70c08667$var$Kt.COLLAPSE);
    }
    get hasOpenedMenu() {
        return this.isBreakpoint($0e66457a70c08667$var$Oe.core.Breakpoints.LG) && this.index > -1;
    }
    _keydown(e) {
        switch(e){
            case $0e66457a70c08667$var$Oe.core.KeyCodes.ESCAPE:
                if (!this.hasOpenedMenu) return;
                this.index = -1;
                break;
            case $0e66457a70c08667$var$Oe.core.KeyCodes.TAB:
                if (!this.hasOpenedMenu) return;
                this.request(()=>{
                    this.current.node.contains(document.activeElement) || (this.index = -1);
                });
        }
    }
    handleMouseDown(e) {
        this.hasOpenedMenu && (this.position = this.current.node.contains(e.target) ? $0e66457a70c08667$var$Vt.INSIDE : $0e66457a70c08667$var$Vt.OUTSIDE, this.requestPosition());
    }
    handleClick(e) {
        !e.target.matches("a, button") || e.target.matches("[aria-controls]") || e.target.matches($0e66457a70c08667$var$Oe.core.DisclosureSelector.PREVENT_CONCEAL) || (this.index = -1);
    }
    _handleRootClick(e) {
        this.isBreakpoint($0e66457a70c08667$var$Oe.core.Breakpoints.LG) && (this.node.contains(e) || (this.out = !0, this.requestPosition()));
    }
    requestPosition() {
        this.isRequesting || (this.isRequesting = !0, this.request(this.getPosition.bind(this)));
    }
    getPosition() {
        if (this.out) switch(this.position){
            case $0e66457a70c08667$var$Vt.OUTSIDE:
                this.index = -1;
                break;
            case $0e66457a70c08667$var$Vt.INSIDE:
                this.current && !this.current.node.contains(document.activeElement) && this.current.focus();
                break;
            default:
                this.index > -1 && !this.current.hasFocus && (this.index = -1);
        }
        this.request(this.requested.bind(this));
    }
    requested() {
        this.position = $0e66457a70c08667$var$Vt.NONE, this.out = !1, this.isRequesting = !1;
    }
    get index() {
        return super.index;
    }
    set index(e) {
        -1 === e && this.current && this.current.hasFocus && this.current.focus(), super.index = e;
    }
    get canUngroup() {
        return !this.isBreakpoint($0e66457a70c08667$var$Oe.core.Breakpoints.LG);
    }
    resize() {
        this.update();
    }
}
$0e66457a70c08667$var$Oe.navigation = {
    Navigation: $0e66457a70c08667$var$Yt,
    NavigationItem: $0e66457a70c08667$var$jt,
    NavigationMousePosition: $0e66457a70c08667$var$Vt,
    NavigationSelector: $0e66457a70c08667$var$Kt
}, $0e66457a70c08667$var$Oe.internals.register($0e66457a70c08667$var$Oe.navigation.NavigationSelector.NAVIGATION, $0e66457a70c08667$var$Oe.navigation.Navigation), $0e66457a70c08667$var$Oe.internals.register($0e66457a70c08667$var$Oe.navigation.NavigationSelector.ITEM, $0e66457a70c08667$var$Oe.navigation.NavigationItem);
class $0e66457a70c08667$var$Xt extends $0e66457a70c08667$var$Oe.core.DisclosureButton {
    constructor(){
        super($0e66457a70c08667$var$Oe.core.DisclosureType.SELECT);
    }
    static get instanceClassName() {
        return "TabButton";
    }
    handleClick(e) {
        super.handleClick(e), this.focus();
    }
    apply(e) {
        super.apply(e), this.isPrimary && (this.setAttribute("tabindex", e ? "0" : "-1"), e && this.list && this.list.focalize(this));
    }
    get list() {
        return this.element.getAscendantInstance("TabsList", "TabsGroup");
    }
}
const $0e66457a70c08667$var$Qt = {
    TAB: $0e66457a70c08667$var$Oe.internals.ns.selector("tabs__tab"),
    GROUP: $0e66457a70c08667$var$Oe.internals.ns.selector("tabs"),
    PANEL: $0e66457a70c08667$var$Oe.internals.ns.selector("tabs__panel"),
    LIST: $0e66457a70c08667$var$Oe.internals.ns.selector("tabs__list"),
    SHADOW: $0e66457a70c08667$var$Oe.internals.ns.selector("tabs__shadow"),
    SHADOW_LEFT: $0e66457a70c08667$var$Oe.internals.ns.selector("tabs__shadow--left"),
    SHADOW_RIGHT: $0e66457a70c08667$var$Oe.internals.ns.selector("tabs__shadow--right"),
    PANEL_START: $0e66457a70c08667$var$Oe.internals.ns.selector("tabs__panel--direction-start"),
    PANEL_END: $0e66457a70c08667$var$Oe.internals.ns.selector("tabs__panel--direction-end")
}, $0e66457a70c08667$var$Zt = "direction-start", $0e66457a70c08667$var$Jt = "direction-end", $0e66457a70c08667$var$es = "none";
class $0e66457a70c08667$var$ts extends $0e66457a70c08667$var$Oe.core.Disclosure {
    constructor(){
        super($0e66457a70c08667$var$Oe.core.DisclosureType.SELECT, $0e66457a70c08667$var$Qt.PANEL, $0e66457a70c08667$var$Xt, "TabsGroup"), this._direction = $0e66457a70c08667$var$es, this._isPreventingTransition = !1;
    }
    static get instanceClassName() {
        return "TabPanel";
    }
    get direction() {
        return this._direction;
    }
    set direction(e) {
        if (e !== this._direction) {
            switch(this._direction){
                case $0e66457a70c08667$var$Zt:
                    this.removeClass($0e66457a70c08667$var$Qt.PANEL_START);
                    break;
                case $0e66457a70c08667$var$Jt:
                    this.removeClass($0e66457a70c08667$var$Qt.PANEL_END);
                    break;
                case $0e66457a70c08667$var$es:
                    break;
                default:
                    return;
            }
            switch(this._direction = e, this._direction){
                case $0e66457a70c08667$var$Zt:
                    this.addClass($0e66457a70c08667$var$Qt.PANEL_START);
                    break;
                case $0e66457a70c08667$var$Jt:
                    this.addClass($0e66457a70c08667$var$Qt.PANEL_END);
            }
        }
    }
    get isPreventingTransition() {
        return this._isPreventingTransition;
    }
    set isPreventingTransition(e) {
        this._isPreventingTransition !== e && (e ? this.addClass($0e66457a70c08667$var$Oe.internals.motion.TransitionSelector.NONE) : this.removeClass($0e66457a70c08667$var$Oe.internals.motion.TransitionSelector.NONE), this._isPreventingTransition = !0 === e);
    }
    translate(e, t1) {
        this.isPreventingTransition = t1, this.direction = e;
    }
    reset() {
        this.group && this.group.retrieve(!0);
    }
    _electPrimaries(e) {
        return this.group && this.group.list ? super._electPrimaries(e).filter((e)=>this.group.list.node.contains(e.node)) : [];
    }
}
const $0e66457a70c08667$var$ss = "tab_keys_left", $0e66457a70c08667$var$is = "tab_keys_right", $0e66457a70c08667$var$ns = "tab_keys_home", $0e66457a70c08667$var$rs = "tab_keys_end", $0e66457a70c08667$var$as = {
    PRESS_KEY: $0e66457a70c08667$var$Oe.internals.ns.emission("tab", "press_key"),
    LIST_HEIGHT: $0e66457a70c08667$var$Oe.internals.ns.emission("tab", "list_height")
};
class $0e66457a70c08667$var$os extends $0e66457a70c08667$var$Oe.core.DisclosuresGroup {
    constructor(){
        super("TabPanel");
    }
    static get instanceClassName() {
        return "TabsGroup";
    }
    init() {
        super.init(), this.listen("transitionend", this.transitionend.bind(this)), this.addAscent($0e66457a70c08667$var$as.PRESS_KEY, this.pressKey.bind(this)), this.addAscent($0e66457a70c08667$var$as.LIST_HEIGHT, this.setListHeight.bind(this)), this.isRendering = !0;
    }
    getIndex(e = 0) {
        super.getIndex(e);
    }
    get list() {
        return this.element.getDescendantInstances("TabsList", "TabsGroup", !0)[0];
    }
    setListHeight(e) {
        this.listHeight = e;
    }
    transitionend(e) {
        this.isPreventingTransition = !0;
    }
    get buttonHasFocus() {
        return this.members.some((e)=>e.buttonHasFocus);
    }
    pressKey(e) {
        switch(e){
            case $0e66457a70c08667$var$ss:
                this.pressLeft();
                break;
            case $0e66457a70c08667$var$is:
                this.pressRight();
                break;
            case $0e66457a70c08667$var$ns:
                this.pressHome();
                break;
            case $0e66457a70c08667$var$rs:
                this.pressEnd();
        }
    }
    pressRight() {
        this.buttonHasFocus && (this.index < this.length - 1 ? this.index++ : this.index = 0, this.focus());
    }
    pressLeft() {
        this.buttonHasFocus && (this.index > 0 ? this.index-- : this.index = this.length - 1, this.focus());
    }
    pressHome() {
        this.buttonHasFocus && (this.index = 0, this.focus());
    }
    pressEnd() {
        this.buttonHasFocus && (this.index = this.length - 1, this.focus());
    }
    focus() {
        this.current && this.current.focus();
    }
    apply() {
        for(let e = 0; e < this._index; e++)this.members[e].translate($0e66457a70c08667$var$Zt);
        this.current && this.current.translate($0e66457a70c08667$var$es);
        for(let e = this._index + 1; e < this.length; e++)this.members[e].translate($0e66457a70c08667$var$Jt);
        this.isPreventingTransition = !1;
    }
    get isPreventingTransition() {
        return this._isPreventingTransition;
    }
    set isPreventingTransition(e) {
        this._isPreventingTransition !== e && (e ? this.addClass($0e66457a70c08667$var$Oe.internals.motion.TransitionSelector.NONE) : this.removeClass($0e66457a70c08667$var$Oe.internals.motion.TransitionSelector.NONE), this._isPreventingTransition = !0 === e);
    }
    render() {
        if (null === this.current) return;
        this.node.scrollTop = 0, this.node.scrollLeft = 0;
        const e = Math.round(this.current.node.offsetHeight);
        this.panelHeight !== e && (this.panelHeight = e, this.style.setProperty("--tabs-height", this.panelHeight + this.listHeight + "px"));
    }
}
class $0e66457a70c08667$var$hs extends $0e66457a70c08667$var$Oe.core.Instance {
    static get instanceClassName() {
        return "TabsList";
    }
    init() {
        this.listen("scroll", this.scroll.bind(this)), this.listenKey($0e66457a70c08667$var$Oe.core.KeyCodes.RIGHT, this.ascend.bind(this, $0e66457a70c08667$var$as.PRESS_KEY, $0e66457a70c08667$var$is), !0, !0), this.listenKey($0e66457a70c08667$var$Oe.core.KeyCodes.LEFT, this.ascend.bind(this, $0e66457a70c08667$var$as.PRESS_KEY, $0e66457a70c08667$var$ss), !0, !0), this.listenKey($0e66457a70c08667$var$Oe.core.KeyCodes.HOME, this.ascend.bind(this, $0e66457a70c08667$var$as.PRESS_KEY, $0e66457a70c08667$var$ns), !0, !0), this.listenKey($0e66457a70c08667$var$Oe.core.KeyCodes.END, this.ascend.bind(this, $0e66457a70c08667$var$as.PRESS_KEY, $0e66457a70c08667$var$rs), !0, !0), this.isResizing = !0;
    }
    focalize(e) {
        const t1 = e.getRect(), s = this.getRect(), i = this.node.scrollLeft;
        t1.left < s.left ? this.node.scrollTo(i - s.left + t1.left - 16, 0) : t1.right > s.right && this.node.scrollTo(i - s.right + t1.right + 16, 0);
    }
    get isScrolling() {
        return this._isScrolling;
    }
    set isScrolling(e) {
        this._isScrolling !== e && (this._isScrolling = e, this.apply());
    }
    apply() {
        this._isScrolling ? (this.addClass($0e66457a70c08667$var$Qt.SHADOW), this.scroll()) : (this.removeClass($0e66457a70c08667$var$Qt.SHADOW_RIGHT), this.removeClass($0e66457a70c08667$var$Qt.SHADOW_LEFT), this.removeClass($0e66457a70c08667$var$Qt.SHADOW));
    }
    scroll() {
        const e = Math.abs(this.node.scrollLeft), t1 = e <= 16, s = this.node.scrollWidth - this.node.clientWidth - 16, i = Math.abs(e) >= s, n = "rtl" === getComputedStyle(this.node).direction, r = n ? $0e66457a70c08667$var$Qt.SHADOW_RIGHT : $0e66457a70c08667$var$Qt.SHADOW_LEFT, a = n ? $0e66457a70c08667$var$Qt.SHADOW_LEFT : $0e66457a70c08667$var$Qt.SHADOW_RIGHT;
        t1 ? this.removeClass(r) : this.addClass(r), i ? this.removeClass(a) : this.addClass(a);
    }
    resize() {
        this.isScrolling = this.node.scrollWidth > this.node.clientWidth + 16;
        const e = this.getRect().height;
        this.setProperty("--tabs-list-height", `${e}px`), this.ascend($0e66457a70c08667$var$as.LIST_HEIGHT, e);
    }
    dispose() {
        this.isScrolling = !1;
    }
}
$0e66457a70c08667$var$Oe.tab = {
    TabPanel: $0e66457a70c08667$var$ts,
    TabButton: $0e66457a70c08667$var$Xt,
    TabsGroup: $0e66457a70c08667$var$os,
    TabsList: $0e66457a70c08667$var$hs,
    TabSelector: $0e66457a70c08667$var$Qt,
    TabEmission: $0e66457a70c08667$var$as
}, $0e66457a70c08667$var$Oe.internals.register($0e66457a70c08667$var$Oe.tab.TabSelector.PANEL, $0e66457a70c08667$var$Oe.tab.TabPanel), $0e66457a70c08667$var$Oe.internals.register($0e66457a70c08667$var$Oe.tab.TabSelector.GROUP, $0e66457a70c08667$var$Oe.tab.TabsGroup), $0e66457a70c08667$var$Oe.internals.register($0e66457a70c08667$var$Oe.tab.TabSelector.LIST, $0e66457a70c08667$var$Oe.tab.TabsList);
const $0e66457a70c08667$var$cs = {
    DISMISS: $0e66457a70c08667$var$Oe.internals.ns.event("dismiss")
};
class $0e66457a70c08667$var$ls extends $0e66457a70c08667$var$Oe.core.Instance {
    static get instanceClassName() {
        return "TagDismissible";
    }
    init() {
        this.listenClick();
    }
    handleClick() {
        switch(this.focusClosest(), $0e66457a70c08667$var$Oe.mode){
            case $0e66457a70c08667$var$Oe.Modes.ANGULAR:
            case $0e66457a70c08667$var$Oe.Modes.REACT:
            case $0e66457a70c08667$var$Oe.Modes.VUE:
                this.request(this.verify.bind(this));
                break;
            default:
                this.remove();
        }
        this.dispatch($0e66457a70c08667$var$cs.DISMISS);
    }
    verify() {
        document.body.contains(this.node) && this.warn(`a TagDismissible has just been dismissed and should be removed from the dom. In ${$0e66457a70c08667$var$Oe.mode} mode, the api doesn't handle dom modification. An event ${$0e66457a70c08667$var$cs.DISMISS} is dispatched by the element to trigger the removal`);
    }
}
const $0e66457a70c08667$var$ds = {
    PRESSABLE: `${$0e66457a70c08667$var$Oe.internals.ns.selector("tag")}[aria-pressed]`,
    DISMISSIBLE: `${$0e66457a70c08667$var$Oe.internals.ns.selector("tag--dismiss")}`
};
$0e66457a70c08667$var$Oe.tag = {
    TagDismissible: $0e66457a70c08667$var$ls,
    TagSelector: $0e66457a70c08667$var$ds,
    TagEvent: $0e66457a70c08667$var$cs
}, $0e66457a70c08667$var$Oe.internals.register($0e66457a70c08667$var$Oe.tag.TagSelector.PRESSABLE, $0e66457a70c08667$var$Oe.core.Toggle), $0e66457a70c08667$var$Oe.internals.register($0e66457a70c08667$var$Oe.tag.TagSelector.DISMISSIBLE, $0e66457a70c08667$var$Oe.tag.TagDismissible);
const $0e66457a70c08667$var$us = $0e66457a70c08667$var$Oe.internals.ns.selector("transcription"), $0e66457a70c08667$var$gs = {
    TRANSCRIPTION: $0e66457a70c08667$var$us,
    BUTTON: `${$0e66457a70c08667$var$us}__btn`
};
class $0e66457a70c08667$var$ps extends $0e66457a70c08667$var$Oe.core.Instance {
    static get instanceClassName() {
        return "Transcription";
    }
    get collapsePrimary() {
        return this.element.children.map((e)=>e.getInstance("CollapseButton")).filter((e)=>null !== e && e.hasClass($0e66457a70c08667$var$gs.BUTTON))[0];
    }
}
$0e66457a70c08667$var$Oe.transcription = {
    Transcription: $0e66457a70c08667$var$ps,
    TranscriptionSelector: $0e66457a70c08667$var$gs
}, $0e66457a70c08667$var$Oe.internals.register($0e66457a70c08667$var$Oe.transcription.TranscriptionSelector.TRANSCRIPTION, $0e66457a70c08667$var$Oe.transcription.Transcription);
class $0e66457a70c08667$var$ms extends $0e66457a70c08667$var$Oe.core.Instance {
    static get instanceClassName() {
        return "TileDownload";
    }
    init() {
        this.addAscent($0e66457a70c08667$var$Oe.core.AssessEmission.UPDATE, (e)=>{
            this.descend($0e66457a70c08667$var$Oe.core.AssessEmission.UPDATE, e);
        }), this.addAscent($0e66457a70c08667$var$Oe.core.AssessEmission.ADDED, ()=>{
            this.descend($0e66457a70c08667$var$Oe.core.AssessEmission.ADDED);
        });
    }
}
const $0e66457a70c08667$var$_s = {
    DOWNLOAD: $0e66457a70c08667$var$Oe.internals.ns.selector("tile--download"),
    DOWNLOAD_DETAIL: `${$0e66457a70c08667$var$Oe.internals.ns.selector("tile--download")} ${$0e66457a70c08667$var$Oe.internals.ns.selector("tile__detail")}`
};
$0e66457a70c08667$var$Oe.tile = {
    TileSelector: $0e66457a70c08667$var$_s,
    TileDownload: $0e66457a70c08667$var$ms
}, $0e66457a70c08667$var$Oe.internals.register($0e66457a70c08667$var$Oe.tile.TileSelector.DOWNLOAD, $0e66457a70c08667$var$Oe.tile.TileDownload), $0e66457a70c08667$var$Oe.internals.register($0e66457a70c08667$var$Oe.tile.TileSelector.DOWNLOAD_DETAIL, $0e66457a70c08667$var$Oe.core.AssessDetail);
const $0e66457a70c08667$var$bs = {
    RANGE: $0e66457a70c08667$var$Oe.internals.ns.selector("range"),
    RANGE_SM: $0e66457a70c08667$var$Oe.internals.ns.selector("range--sm"),
    RANGE_STEP: $0e66457a70c08667$var$Oe.internals.ns.selector("range--step"),
    RANGE_DOUBLE: $0e66457a70c08667$var$Oe.internals.ns.selector("range--double"),
    RANGE_DOUBLE_STEP: $0e66457a70c08667$var$Oe.internals.ns.selector("range--double") + $0e66457a70c08667$var$Oe.internals.ns.selector("range--step"),
    RANGE_INPUT: $0e66457a70c08667$var$Oe.internals.ns.selector("range input[type=range]:nth-of-type(1)"),
    RANGE_INPUT2: `${$0e66457a70c08667$var$Oe.internals.ns.selector("range--double")} input[type=range]:nth-of-type(2)`,
    RANGE_OUTPUT: $0e66457a70c08667$var$Oe.internals.ns.selector("range__output"),
    RANGE_MIN: $0e66457a70c08667$var$Oe.internals.ns.selector("range__min"),
    RANGE_MAX: $0e66457a70c08667$var$Oe.internals.ns.selector("range__max"),
    RANGE_PREFIX: $0e66457a70c08667$var$Oe.internals.ns.attr("prefix"),
    RANGE_SUFFIX: $0e66457a70c08667$var$Oe.internals.ns.attr("suffix")
}, $0e66457a70c08667$var$Es = {
    VALUE: $0e66457a70c08667$var$Oe.internals.ns.emission("range", "value"),
    VALUE2: $0e66457a70c08667$var$Oe.internals.ns.emission("range", "value2"),
    OUTPUT: $0e66457a70c08667$var$Oe.internals.ns.emission("range", "output"),
    CONSTRAINTS: $0e66457a70c08667$var$Oe.internals.ns.emission("range", "constraints"),
    MIN: $0e66457a70c08667$var$Oe.internals.ns.emission("range", "min"),
    MAX: $0e66457a70c08667$var$Oe.internals.ns.emission("range", "max"),
    STEP: $0e66457a70c08667$var$Oe.internals.ns.emission("range", "step"),
    PREFIX: $0e66457a70c08667$var$Oe.internals.ns.emission("range", "prefix"),
    SUFFIX: $0e66457a70c08667$var$Oe.internals.ns.emission("range", "suffix"),
    DISABLED: $0e66457a70c08667$var$Oe.internals.ns.emission("range", "disabled"),
    ENABLE_POINTER: $0e66457a70c08667$var$Oe.internals.ns.emission("range", "enable_pointer")
};
class $0e66457a70c08667$var$fs {
    constructor(){
        this._width = 0, this._min = 0, this._max = 0, this._value = 0, this._thumbSize = 24, this._innerWidth = 0, this._prefix = "", this._suffix = "", this._background = {};
    }
    configure(e) {
        e && (this._prefix = e._prefix, this._suffix = e._suffix, this._width = e.width, this.setConstraints(e._constraints), this.value = e.value, this.update());
    }
    setPrefix(e) {
        this._prefix = null !== e ? e : "";
    }
    setSuffix(e) {
        this._suffix = null !== e ? e : "";
    }
    _decorate(e) {
        return `${this._prefix}${e}${this._suffix}`;
    }
    get width() {
        return this._width;
    }
    set width(e) {
        this._width = e;
    }
    get isSm() {
        return this._isSm;
    }
    set isSm(e) {
        this._isSm !== e && (this._isSm = e, this.setThumbSize(e ? 16 : 24), this.update());
    }
    setThumbSize(e, t1 = 1) {
        this._thumbSize = e, this._innerPadding = e * t1;
    }
    get textValue() {
        return this._decorate(this._value);
    }
    get value() {
        return this._value;
    }
    set value(e) {
        this._value = e;
    }
    get outputX() {
        return this._outputX;
    }
    setConstraints(e) {
        this._constraints = e, this._min = e.min, this._max = e.max, this._step = e.step, this._rangeWidth = e.rangeWidth;
    }
    get min() {
        return this._min;
    }
    get textMin() {
        return this._decorate(this._min);
    }
    get max() {
        return this._max;
    }
    get textMax() {
        return this._decorate(this._max);
    }
    get step() {
        return this._step;
    }
    get output() {
        return {
            text: this.textValue,
            transform: `translateX(${this._translateX}px) translateX(-${this._centerPercent}%)`
        };
    }
    _getRatio(e) {
        return (e - this._min) / this._rangeWidth;
    }
    get progress() {
        return this._progress;
    }
    update() {
        this._update();
    }
    _update() {
        this._innerWidth = this._width - this._innerPadding;
        const e = this._getRatio(this._value);
        this._translateX = e * this._width, this._centerPercent = 100 * e, this._progress = {
            right: `${(this._innerWidth * e + .5 * this._innerPadding).toFixed(2)}px`
        };
    }
}
class $0e66457a70c08667$var$As extends $0e66457a70c08667$var$fs {
    get stepWidth() {
        return `${this._stepWidth.toFixed(3)}px`;
    }
    _update() {
        super._update();
        const e = this._rangeWidth / this._step;
        for(this._stepWidth = this._innerWidth / e, (this._stepWidth < 1 || !isFinite(this._stepWidth)) && (this._stepWidth = 4); this._stepWidth < 4;)this._stepWidth *= 2;
    }
}
class $0e66457a70c08667$var$Ts extends $0e66457a70c08667$var$fs {
    get value2() {
        return this._value;
    }
    set value2(e) {
        this._value2 !== e && (this._value2 = e, this.update());
    }
    get textValue() {
        return `${this._decorate(this._value)} - ${this._decorate(this._value2)}`;
    }
    setThumbSize(e) {
        super.setThumbSize(e, 2);
    }
    _update() {
        super._update();
        const e = this._getRatio(.5 * (this._value + this._value2));
        this._translateX = e * this._width, this._centerPercent = 100 * e;
        const t1 = this._getRatio(this._value), s = this._getRatio(this._value2);
        this._progress = {
            left: `${(this._innerWidth * t1 + .25 * this._innerPadding).toFixed(2)}px`,
            right: `${(this._innerWidth * s + .75 * this._innerPadding).toFixed(2)}px`
        };
    }
}
class $0e66457a70c08667$var$vs extends $0e66457a70c08667$var$Ts {
    get stepWidth() {
        return `${this._stepWidth.toFixed(3)}px`;
    }
    _update() {
        super._update();
        const e = this._rangeWidth / this._step;
        this._stepWidth = this._innerWidth / e, this._stepWidth < 4 && (this._stepWidth *= Math.ceil(4 / this._stepWidth));
    }
}
const $0e66457a70c08667$var$Ss = "step", $0e66457a70c08667$var$ys = "double", $0e66457a70c08667$var$Cs = "double-step", $0e66457a70c08667$var$Ns = "default";
class $0e66457a70c08667$var$Ds extends $0e66457a70c08667$var$Oe.core.Instance {
    static get instanceClassName() {
        return "Range";
    }
    init() {
        this._retrieveType(), this._retrieveSize(), this.isLegacy ? (this.isResizing = !0, this.isMouseMoving = !0) : (this._observer = new ResizeObserver(this.resize.bind(this)), this._observer.observe(this.node)), this.addAscent($0e66457a70c08667$var$Es.CONSTRAINTS, this.setConstraints.bind(this)), this.addAscent($0e66457a70c08667$var$Es.VALUE, this.setValue.bind(this)), this.addAscent($0e66457a70c08667$var$Es.VALUE2, this.setValue2.bind(this)), this.getAttribute($0e66457a70c08667$var$bs.RANGE_PREFIX) && this.setPrefix(this.getAttribute($0e66457a70c08667$var$bs.RANGE_PREFIX)), this.getAttribute($0e66457a70c08667$var$bs.RANGE_SUFFIX) && this.setSuffix(this.getAttribute($0e66457a70c08667$var$bs.RANGE_SUFFIX)), this.update();
    }
    _retrieveType() {
        switch(!0){
            case this.matches($0e66457a70c08667$var$bs.RANGE_DOUBLE_STEP):
            case this.matches($0e66457a70c08667$var$bs.RANGE_DOUBLE):
                this.type = $0e66457a70c08667$var$ys;
                break;
            case this.matches($0e66457a70c08667$var$bs.RANGE_STEP):
                this.type = $0e66457a70c08667$var$Ss;
                break;
            default:
                this.type = $0e66457a70c08667$var$Ns;
        }
    }
    set type(e) {
        if (this._type === e) return;
        this._type = e;
        const t1 = this._model;
        switch(this._type){
            case $0e66457a70c08667$var$Cs:
                this._model = new $0e66457a70c08667$var$vs;
                break;
            case $0e66457a70c08667$var$ys:
                this._model = new $0e66457a70c08667$var$Ts;
                break;
            case $0e66457a70c08667$var$Ss:
                this._model = new $0e66457a70c08667$var$As;
                break;
            default:
                this._model = new $0e66457a70c08667$var$fs;
        }
        this._model.configure(t1);
    }
    get type() {
        return this._type;
    }
    _retrieveSize() {
        this._model.isSm = this.matches($0e66457a70c08667$var$bs.RANGE_SM);
    }
    resize() {
        this._retrieveWidth(), this.update();
    }
    _retrieveWidth() {
        this._model.width = this.getRect().width;
    }
    setValue(e) {
        switch(this._model.value = e, this._type){
            case $0e66457a70c08667$var$Cs:
            case $0e66457a70c08667$var$ys:
                this.descend($0e66457a70c08667$var$Es.VALUE, e);
        }
        this.update();
    }
    setValue2(e) {
        this._model.value2 = e, this.descend($0e66457a70c08667$var$Es.VALUE2, e), this.update();
    }
    setConstraints(e) {
        this._model.setConstraints(e), this.update(), this.descend($0e66457a70c08667$var$Es.CONSTRAINTS, e);
    }
    setPrefix(e) {
        this._model.setPrefix(e), this.update();
    }
    setSuffix(e) {
        this._model.setSuffix(e), this.update();
    }
    mutate(e) {
        switch(!0){
            case e.includes("class"):
                this._retrieveType(), this._retrieveSize();
                break;
            case e.includes($0e66457a70c08667$var$bs.RANGE_PREFIX):
            case e.includes($0e66457a70c08667$var$bs.RANGE_SUFFIX):
                this._model.setPrefix(this.getAttribute($0e66457a70c08667$var$bs.RANGE_PREFIX)), this._model.setSuffix(this.getAttribute($0e66457a70c08667$var$bs.RANGE_SUFFIX)), this.update();
        }
    }
    update() {
        this._model.update(), this.descend($0e66457a70c08667$var$Es.OUTPUT, this._model.output), this.descend($0e66457a70c08667$var$Es.MIN, this._model.textMin), this.descend($0e66457a70c08667$var$Es.MAX, this._model.textMax);
        const e = this._model.progress;
        e.left ? this.style.setProperty("--progress-left", e.left) : this.style.removeProperty("--progress-left"), e.right ? (this.style.setProperty("--progress-right", e.right), this.isLegacy && e.left && (this.style.setProperty("background-position-x", e.left), this.style.setProperty("background-size", `${parseFloat(e.right) - parseFloat(e.left)}px ${this._model.isSm ? "8px" : "12px"}`))) : (this.style.removeProperty("--progress-right"), this.isLegacy && (this.style.removeProperty("background-size"), this.style.removeProperty("background-position-x"))), this._model.stepWidth ? this.style.setProperty("--step-width", this._model.stepWidth) : this.style.removeProperty("--step-width");
    }
    mouseMove(e) {
        if (this._type !== $0e66457a70c08667$var$ys && this._type !== $0e66457a70c08667$var$Cs) return;
        const t1 = e.x - this.getRect().left;
        this.descend($0e66457a70c08667$var$Es.ENABLE_POINTER, (parseFloat(this._model.progress.right) - parseFloat(this._model.progress.left)) / 2 + parseFloat(this._model.progress.left) < t1 ? 2 : 1);
    }
    dispose() {
        this._observer.disconnect();
    }
}
class $0e66457a70c08667$var$Rs {
    constructor(e){
        this._min = isNaN(e.min) ? 0 : e.min, this._max = isNaN(e.max) ? 100 : e.max, this._step = isNaN(e.step) ? 1 : e.step, this._rangeWidth = this._max - this._min;
    }
    get min() {
        return this._min;
    }
    get max() {
        return this._max;
    }
    get step() {
        return this._step;
    }
    get rangeWidth() {
        return this._rangeWidth;
    }
    test(e, t1, s) {
        return this._min === e && this._max === t1 && this._step === s;
    }
}
class $0e66457a70c08667$var$ws extends $0e66457a70c08667$var$Oe.core.Instance {
    static get instanceClassName() {
        return "RangeInput";
    }
    init() {
        this._init(), this._value = parseFloat(this.node.getAttribute("value")), this.isLegacy && this.addDescent($0e66457a70c08667$var$Es.ENABLE_POINTER, this._enablePointer.bind(this)), this.isRendering = !0, this.change();
    }
    _init() {
        this._pointerId = 1, this.request(()=>{
            this.hasAttribute("min") || this.setAttribute("min", 0), this.ascend($0e66457a70c08667$var$Es.CONSTRAINTS, new $0e66457a70c08667$var$Rs(this.node)), this.ascend($0e66457a70c08667$var$Es.DISABLED, this.node.disabled);
        }), this.addDescent($0e66457a70c08667$var$Es.VALUE2, this.setValue.bind(this));
    }
    get proxy() {
        const e = this, t1 = {
            get value () {
                return e.value;
            },
            set value (t){
                e.value = t;
            }
        };
        return $0e66457a70c08667$var$Oe.internals.property.completeAssign(super.proxy, t1);
    }
    _enablePointer(e) {
        const t1 = e === this._pointerId;
        this._isPointerEnabled !== t1 && (this._isPointerEnabled = t1, t1 ? this.style.removeProperty("pointer-events") : this.style.setProperty("pointer-events", "none"));
    }
    get value() {
        return parseFloat(this.node.value);
    }
    set value(e) {
        const t1 = parseFloat(e);
        t1 !== this._value && (this._value = t1, this.node.value = t1, this.dispatch("change"), this.change());
    }
    setValue(e) {
        parseFloat(this.node.value) > e && (this.value = e);
    }
    change() {
        this.ascend($0e66457a70c08667$var$Es.VALUE, this._value);
    }
    render() {
        const e = parseFloat(this.node.value);
        e !== this._value && (this.value = e);
    }
    mutate(e) {
        e.includes("disabled") && this.ascend($0e66457a70c08667$var$Es.DISABLED, this.node.disabled), (e.includes("min") || e.includes("max") || e.includes("step")) && (this.ascend($0e66457a70c08667$var$Es.CONSTRAINTS, new $0e66457a70c08667$var$Rs(this.node)), this.change());
    }
    dispose() {
        this._listenerType && this.unlisten(this._listenerType, this._changing);
    }
}
class $0e66457a70c08667$var$Ls extends $0e66457a70c08667$var$Oe.core.Instance {
    static get instanceClassName() {
        return "RangeOutput";
    }
    init() {
        this.addDescent($0e66457a70c08667$var$Es.OUTPUT, this.change.bind(this));
    }
    change(e) {
        this.node.innerText = e.text, this.node.style.transform = e.transform;
    }
}
class $0e66457a70c08667$var$Is extends $0e66457a70c08667$var$Oe.core.Instance {
    static get instanceClassName() {
        return "RangeLimit";
    }
    init() {
        switch(!0){
            case this.matches($0e66457a70c08667$var$bs.RANGE_MIN):
                this.addDescent($0e66457a70c08667$var$Es.MIN, this.change.bind(this));
                break;
            case this.matches($0e66457a70c08667$var$bs.RANGE_MAX):
                this.addDescent($0e66457a70c08667$var$Es.MAX, this.change.bind(this));
        }
    }
    change(e) {
        this.node.innerText = e;
    }
}
$0e66457a70c08667$var$Oe.range = {
    Range: $0e66457a70c08667$var$Ds,
    RangeInput: $0e66457a70c08667$var$ws,
    RangeInput2: class extends $0e66457a70c08667$var$ws {
        static get instanceClassName() {
            return "RangeInput2";
        }
        _init() {
            this._pointerId = 2, this.addDescent($0e66457a70c08667$var$Es.CONSTRAINTS, this.setConstraints.bind(this)), this.addDescent($0e66457a70c08667$var$Es.VALUE, this.setValue.bind(this));
        }
        setValue(e) {
            parseFloat(this.node.value) < e && (this.value = e);
        }
        change() {
            this.ascend($0e66457a70c08667$var$Es.VALUE2, parseFloat(this.node.value));
        }
        setConstraints(e) {
            this.node.min = e.min, this.node.max = e.max, this.node.step = e.step, this.change();
        }
        mutate(e) {}
    },
    RangeOutput: $0e66457a70c08667$var$Ls,
    RangeLimit: $0e66457a70c08667$var$Is,
    RangeEmission: $0e66457a70c08667$var$Es,
    RangeSelector: $0e66457a70c08667$var$bs
}, $0e66457a70c08667$var$Oe.internals.register($0e66457a70c08667$var$Oe.range.RangeSelector.RANGE, $0e66457a70c08667$var$Oe.range.Range), $0e66457a70c08667$var$Oe.internals.register($0e66457a70c08667$var$Oe.range.RangeSelector.RANGE_INPUT, $0e66457a70c08667$var$Oe.range.RangeInput), $0e66457a70c08667$var$Oe.internals.register($0e66457a70c08667$var$Oe.range.RangeSelector.RANGE_INPUT2, $0e66457a70c08667$var$Oe.range.RangeInput2), $0e66457a70c08667$var$Oe.internals.register($0e66457a70c08667$var$Oe.range.RangeSelector.RANGE_OUTPUT, $0e66457a70c08667$var$Oe.range.RangeOutput), $0e66457a70c08667$var$Oe.internals.register($0e66457a70c08667$var$Oe.range.RangeSelector.RANGE_MIN, $0e66457a70c08667$var$Oe.range.RangeLimit), $0e66457a70c08667$var$Oe.internals.register($0e66457a70c08667$var$Oe.range.RangeSelector.RANGE_MAX, $0e66457a70c08667$var$Oe.range.RangeLimit);
const $0e66457a70c08667$var$xs = {
    HEADER: $0e66457a70c08667$var$Oe.internals.ns.selector("header"),
    BRAND_LINK: $0e66457a70c08667$var$Oe.internals.ns.selector("header__brand a"),
    TOOLS_LINKS: $0e66457a70c08667$var$Oe.internals.ns.selector("header__tools-links"),
    MENU_LINKS: $0e66457a70c08667$var$Oe.internals.ns.selector("header__menu-links"),
    BUTTONS: `${$0e66457a70c08667$var$Oe.internals.ns.selector("header__tools-links")} ${$0e66457a70c08667$var$Oe.internals.ns.selector("btns-group")}, ${$0e66457a70c08667$var$Oe.internals.ns.selector("header__tools-links")} ${$0e66457a70c08667$var$Oe.internals.ns.selector("links-group")}`,
    MODALS: `${$0e66457a70c08667$var$Oe.internals.ns.selector("header__search")}${$0e66457a70c08667$var$Oe.internals.ns.selector("modal")}, ${$0e66457a70c08667$var$Oe.internals.ns.selector("header__menu")}${$0e66457a70c08667$var$Oe.internals.ns.selector("modal")}`
};
class $0e66457a70c08667$var$Os extends $0e66457a70c08667$var$Oe.core.Instance {
    static get instanceClassName() {
        return "HeaderLinks";
    }
    init() {
        const e = this.queryParentSelector($0e66457a70c08667$var$xs.HEADER);
        this.toolsLinks = e.querySelector($0e66457a70c08667$var$xs.TOOLS_LINKS), this.menuLinks = e.querySelector($0e66457a70c08667$var$xs.MENU_LINKS);
        const t1 = "-mobile", s = this.toolsLinks.innerHTML.replace(/  +/g, " "), i = this.menuLinks.innerHTML.replace(/  +/g, " ");
        let n = s.match(/id="(.*?)"/gm) || [];
        n = n.map((e)=>e.replace('id="', "").replace('"', ""));
        const r = [
            "aria-controls",
            "aria-describedby",
            "aria-labelledby"
        ];
        let a = s.replace(/id="(.*?)"/gm, `id="$1${t1}"`);
        for (const e of r){
            const i = s.match(new RegExp(`${e}="(.*?)"`, "gm"));
            if (i) for (const s of i){
                const i = s.replace(`${e}="`, "").replace('"', "");
                n.includes(i) && (a = a.replace(`${e}="${i}"`, `${e}="${i + t1}"`));
            }
        }
        if (a !== i) switch($0e66457a70c08667$var$Oe.mode){
            case $0e66457a70c08667$var$Oe.Modes.ANGULAR:
            case $0e66457a70c08667$var$Oe.Modes.REACT:
            case $0e66457a70c08667$var$Oe.Modes.VUE:
                this.warn(`header__tools-links content is different from header__menu-links content.\nAs you're using a dynamic framework, you should handle duplication of this content yourself, please refer to documentation:\n${$0e66457a70c08667$var$Oe.header.doc}`);
                break;
            default:
                this.menuLinks.innerHTML = a;
        }
    }
}
class $0e66457a70c08667$var$Ps extends $0e66457a70c08667$var$Oe.core.Instance {
    static get instanceClassName() {
        return "HeaderModal";
    }
    init() {
        this.storeAria(), this.isResizing = !0;
    }
    resize() {
        this.isBreakpoint($0e66457a70c08667$var$Oe.core.Breakpoints.LG) ? this.deactivateModal() : this.activateModal();
    }
    activateModal() {
        const e = this.element.getInstance("Modal");
        e ? (this.restoreAria(), e.isActive = !0, this.listenClick({
            capture: !0
        })) : this.request(this.activateModal.bind(this));
    }
    deactivateModal() {
        const e = this.element.getInstance("Modal");
        e ? (e.conceal(), e.isActive = !1, this.storeAria(), this.unlistenClick({
            capture: !0
        })) : this.request(this.deactivateModal.bind(this));
    }
    storeAria() {
        this.hasAttribute("aria-labelledby") && (this._ariaLabelledby = this.getAttribute("aria-labelledby")), this.hasAttribute("aria-label") && (this._ariaLabel = this.getAttribute("aria-label")), this.removeAttribute("aria-labelledby"), this.removeAttribute("aria-label");
    }
    restoreAria() {
        this._ariaLabelledby && this.setAttribute("aria-labelledby", this._ariaLabelledby), this._ariaLabel && this.setAttribute("aria-label", this._ariaLabel);
    }
    handleClick(e) {
        if (e.target.matches("a, button") && !e.target.matches("[aria-controls]") && !e.target.matches($0e66457a70c08667$var$Oe.core.DisclosureSelector.PREVENT_CONCEAL)) this.element.getInstance("Modal").conceal();
    }
}
$0e66457a70c08667$var$Oe.header = {
    HeaderLinks: $0e66457a70c08667$var$Os,
    HeaderModal: $0e66457a70c08667$var$Ps,
    HeaderSelector: $0e66457a70c08667$var$xs,
    doc: "https://www.systeme-de-design.gouv.fr/elements-d-interface/composants/en-tete"
}, $0e66457a70c08667$var$Oe.internals.register($0e66457a70c08667$var$Oe.header.HeaderSelector.TOOLS_LINKS, $0e66457a70c08667$var$Oe.header.HeaderLinks), $0e66457a70c08667$var$Oe.internals.register($0e66457a70c08667$var$Oe.header.HeaderSelector.MODALS, $0e66457a70c08667$var$Oe.header.HeaderModal);
const $0e66457a70c08667$var$ks = {
    DISPLAY: $0e66457a70c08667$var$Oe.internals.ns.selector("display"),
    RADIO_BUTTONS: `input[name="${$0e66457a70c08667$var$Oe.internals.ns("radios-theme")}"]`,
    FIELDSET: $0e66457a70c08667$var$Oe.internals.ns.selector("fieldset")
};
class $0e66457a70c08667$var$Ms extends $0e66457a70c08667$var$Oe.core.Instance {
    static get instanceClassName() {
        return "Display";
    }
    init() {
        if (this.radios = this.querySelectorAll($0e66457a70c08667$var$ks.RADIO_BUTTONS), $0e66457a70c08667$var$Oe.scheme) {
            this.changing = this.change.bind(this);
            for (const e of this.radios)e.addEventListener("change", this.changing);
            this.addDescent($0e66457a70c08667$var$Oe.scheme.SchemeEmission.SCHEME, this.apply.bind(this)), this.ascend($0e66457a70c08667$var$Oe.scheme.SchemeEmission.ASK);
        } else this.querySelector($0e66457a70c08667$var$ks.FIELDSET).setAttribute("disabled", "");
    }
    get scheme() {
        return this._scheme;
    }
    set scheme(e) {
        if (this._scheme !== e && $0e66457a70c08667$var$Oe.scheme) switch(e){
            case $0e66457a70c08667$var$Oe.scheme.SchemeValue.SYSTEM:
            case $0e66457a70c08667$var$Oe.scheme.SchemeValue.LIGHT:
            case $0e66457a70c08667$var$Oe.scheme.SchemeValue.DARK:
                this._scheme = e;
                for (const t1 of this.radios)t1.checked = t1.value === e;
                this.ascend($0e66457a70c08667$var$Oe.scheme.SchemeEmission.SCHEME, e);
        }
    }
    change() {
        for (const e of this.radios)if (e.checked) return void (this.scheme = e.value);
    }
    apply(e) {
        this.scheme = e;
    }
    dispose() {
        for (const e of this.radios)e.removeEventListener("change", this.changing);
    }
}
$0e66457a70c08667$var$Oe.display = {
    Display: $0e66457a70c08667$var$Ms,
    DisplaySelector: $0e66457a70c08667$var$ks
}, $0e66457a70c08667$var$Oe.internals.register($0e66457a70c08667$var$Oe.display.DisplaySelector.DISPLAY, $0e66457a70c08667$var$Oe.display.Display);
const $0e66457a70c08667$var$Gs = {
    SCROLLABLE: $0e66457a70c08667$var$Oe.internals.ns.emission("table", "scrollable"),
    CHANGE: $0e66457a70c08667$var$Oe.internals.ns.emission("table", "change"),
    CAPTION_HEIGHT: $0e66457a70c08667$var$Oe.internals.ns.emission("table", "captionheight"),
    CAPTION_WIDTH: $0e66457a70c08667$var$Oe.internals.ns.emission("table", "captionwidth")
};
class $0e66457a70c08667$var$$s extends $0e66457a70c08667$var$Oe.core.Instance {
    static get instanceClassName() {
        return "Table";
    }
    init() {
        this.addAscent($0e66457a70c08667$var$Gs.CAPTION_HEIGHT, this.setCaptionHeight.bind(this));
    }
    setCaptionHeight(e) {
        this.setProperty("--table-offset", e);
    }
}
class $0e66457a70c08667$var$Hs extends $0e66457a70c08667$var$Oe.core.Instance {
    static get instanceClassName() {
        return "TableWrapper";
    }
    init() {
        this.addAscent($0e66457a70c08667$var$Gs.CAPTION_HEIGHT, this.setCaptionHeight.bind(this));
    }
    setCaptionHeight(e) {
        requestAnimationFrame(()=>this.ascend($0e66457a70c08667$var$Gs.CAPTION_HEIGHT, 0)), this.setProperty("--table-offset", e);
    }
}
const $0e66457a70c08667$var$Us = {
    TABLE: $0e66457a70c08667$var$Oe.internals.ns.selector("table"),
    TABLE_WRAPPER: [
        `${$0e66457a70c08667$var$Oe.internals.ns.selector("table")} ${$0e66457a70c08667$var$Oe.internals.ns.selector("table__wrapper")}`
    ],
    SHADOW: $0e66457a70c08667$var$Oe.internals.ns.selector("table__shadow"),
    SHADOW_LEFT: $0e66457a70c08667$var$Oe.internals.ns.selector("table__shadow--left"),
    SHADOW_RIGHT: $0e66457a70c08667$var$Oe.internals.ns.selector("table__shadow--right"),
    ELEMENT: [
        `${$0e66457a70c08667$var$Oe.internals.ns.selector("table")}:not(${$0e66457a70c08667$var$Oe.internals.ns.selector("table--no-scroll")}) table`
    ],
    CAPTION: `${$0e66457a70c08667$var$Oe.internals.ns.selector("table")} table caption`,
    ROW: `${$0e66457a70c08667$var$Oe.internals.ns.selector("table")} tbody tr`,
    COL: `${$0e66457a70c08667$var$Oe.internals.ns.selector("table")} thead th`
};
class $0e66457a70c08667$var$Bs extends $0e66457a70c08667$var$Oe.core.Instance {
    static get instanceClassName() {
        return "TableElement";
    }
    init() {
        this.listen("scroll", this.scroll.bind(this)), this.content = this.querySelector("tbody"), this.tableOffsetHeight = 0, this.isResizing = !0;
    }
    get isScrolling() {
        return this._isScrolling;
    }
    set isScrolling(e) {
        this._isScrolling !== e && (this._isScrolling = e, e ? (this.addClass($0e66457a70c08667$var$Us.SHADOW), this.scroll()) : (this.removeClass($0e66457a70c08667$var$Us.SHADOW), this.removeClass($0e66457a70c08667$var$Us.SHADOW_LEFT), this.removeClass($0e66457a70c08667$var$Us.SHADOW_RIGHT)));
    }
    scroll() {
        const e = this.node.scrollLeft <= 0, t1 = this.content.offsetWidth - this.node.offsetWidth - 0, s = Math.abs(this.node.scrollLeft) >= t1, i = "rtl" === document.documentElement.getAttribute("dir"), n = i ? $0e66457a70c08667$var$Us.SHADOW_RIGHT : $0e66457a70c08667$var$Us.SHADOW_LEFT, r = i ? $0e66457a70c08667$var$Us.SHADOW_LEFT : $0e66457a70c08667$var$Us.SHADOW_RIGHT;
        e ? this.removeClass(n) : this.addClass(n), s ? this.removeClass(r) : this.addClass(r);
    }
    resize() {
        this.isScrolling = this.content.offsetWidth > this.node.offsetWidth;
    }
    dispose() {
        this.isScrolling = !1;
    }
}
class $0e66457a70c08667$var$Fs extends $0e66457a70c08667$var$Oe.core.Instance {
    static get instanceClassName() {
        return "TableCaption";
    }
    init() {
        this.height = 0, this.isResizing = !0;
    }
    resize() {
        const e = this.getRect().height;
        this.height !== e && (this.height = e, this.ascend($0e66457a70c08667$var$Gs.CAPTION_HEIGHT, `calc(${e}px + 1rem)`));
    }
}
class $0e66457a70c08667$var$Ws extends $0e66457a70c08667$var$Oe.core.Instance {
    static get instanceClassName() {
        return "TableRow";
    }
    init() {
        $0e66457a70c08667$var$Oe.checkbox && (this.addAscent($0e66457a70c08667$var$tt.CHANGE, this._handleCheckboxChange.bind(this)), this.descend($0e66457a70c08667$var$tt.RETRIEVE));
    }
    _handleCheckboxChange(e) {
        "row-select" !== e.name && "true" !== e.getAttribute($0e66457a70c08667$var$Oe.internals.ns.attr("row-select")) || (this.isSelected = !0 === e.checked);
    }
    render() {
        const e = this.getRect().height + 2;
        this._height !== e && (this._height = e, this.setProperty("--row-height", `${this._height}px`));
    }
    get isSelected() {
        return this._isSelected;
    }
    set isSelected(e) {
        this._isSelected !== e && (this.isRendering = e, this._isSelected = e, this.setAttribute("aria-selected", e));
    }
}
$0e66457a70c08667$var$Oe.table = {
    Table: $0e66457a70c08667$var$$s,
    TableWrapper: $0e66457a70c08667$var$Hs,
    TableElement: $0e66457a70c08667$var$Bs,
    TableCaption: $0e66457a70c08667$var$Fs,
    TableSelector: $0e66457a70c08667$var$Us,
    TableRow: $0e66457a70c08667$var$Ws
}, $0e66457a70c08667$var$Oe.internals.register($0e66457a70c08667$var$Oe.table.TableSelector.TABLE, $0e66457a70c08667$var$Oe.table.Table), $0e66457a70c08667$var$Oe.internals.register($0e66457a70c08667$var$Oe.table.TableSelector.TABLE_WRAPPER, $0e66457a70c08667$var$Oe.table.TableWrapper), $0e66457a70c08667$var$Oe.internals.register($0e66457a70c08667$var$Oe.table.TableSelector.ELEMENT, $0e66457a70c08667$var$Oe.table.TableElement), $0e66457a70c08667$var$Oe.internals.register($0e66457a70c08667$var$Oe.table.TableSelector.CAPTION, $0e66457a70c08667$var$Oe.table.TableCaption), $0e66457a70c08667$var$Oe.internals.register($0e66457a70c08667$var$Oe.table.TableSelector.ROW, $0e66457a70c08667$var$Oe.table.TableRow);


var $b20f9367718bba3f$exports = {};
/* @preserve
 * Leaflet 1.9.4, a JS library for interactive maps. https://leafletjs.com
 * (c) 2010-2023 Vladimir Agafonkin, (c) 2010-2011 CloudMade
 */ (function(global, factory) {
    factory($b20f9367718bba3f$exports);
})($b20f9367718bba3f$exports, function(exports1) {
    "use strict";
    var version = "1.9.4";
    /*
   * @namespace Util
   *
   * Various utility functions, used by Leaflet internally.
   */ // @function extend(dest: Object, src?: Object): Object
    // Merges the properties of the `src` object (or multiple objects) into `dest` object and returns the latter. Has an `L.extend` shortcut.
    function extend(dest) {
        var i, j, len, src;
        for(j = 1, len = arguments.length; j < len; j++){
            src = arguments[j];
            for(i in src)dest[i] = src[i];
        }
        return dest;
    }
    // @function create(proto: Object, properties?: Object): Object
    // Compatibility polyfill for [Object.create](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/create)
    var create$2 = Object.create || function() {
        function F() {}
        return function(proto) {
            F.prototype = proto;
            return new F();
        };
    }();
    // @function bind(fn: Function, …): Function
    // Returns a new function bound to the arguments passed, like [Function.prototype.bind](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
    // Has a `L.bind()` shortcut.
    function bind(fn, obj) {
        var slice = Array.prototype.slice;
        if (fn.bind) return fn.bind.apply(fn, slice.call(arguments, 1));
        var args = slice.call(arguments, 2);
        return function() {
            return fn.apply(obj, args.length ? args.concat(slice.call(arguments)) : arguments);
        };
    }
    // @property lastId: Number
    // Last unique ID used by [`stamp()`](#util-stamp)
    var lastId = 0;
    // @function stamp(obj: Object): Number
    // Returns the unique ID of an object, assigning it one if it doesn't have it.
    function stamp(obj) {
        if (!("_leaflet_id" in obj)) obj["_leaflet_id"] = ++lastId;
        return obj._leaflet_id;
    }
    // @function throttle(fn: Function, time: Number, context: Object): Function
    // Returns a function which executes function `fn` with the given scope `context`
    // (so that the `this` keyword refers to `context` inside `fn`'s code). The function
    // `fn` will be called no more than one time per given amount of `time`. The arguments
    // received by the bound function will be any arguments passed when binding the
    // function, followed by any arguments passed when invoking the bound function.
    // Has an `L.throttle` shortcut.
    function throttle(fn, time, context) {
        var lock, args, wrapperFn, later;
        later = function() {
            // reset lock and call if queued
            lock = false;
            if (args) {
                wrapperFn.apply(context, args);
                args = false;
            }
        };
        wrapperFn = function() {
            if (lock) // called too soon, queue to call later
            args = arguments;
            else {
                // call and lock until later
                fn.apply(context, arguments);
                setTimeout(later, time);
                lock = true;
            }
        };
        return wrapperFn;
    }
    // @function wrapNum(num: Number, range: Number[], includeMax?: Boolean): Number
    // Returns the number `num` modulo `range` in such a way so it lies within
    // `range[0]` and `range[1]`. The returned value will be always smaller than
    // `range[1]` unless `includeMax` is set to `true`.
    function wrapNum(x, range, includeMax) {
        var max = range[1], min = range[0], d = max - min;
        return x === max && includeMax ? x : ((x - min) % d + d) % d + min;
    }
    // @function falseFn(): Function
    // Returns a function which always returns `false`.
    function falseFn() {
        return false;
    }
    // @function formatNum(num: Number, precision?: Number|false): Number
    // Returns the number `num` rounded with specified `precision`.
    // The default `precision` value is 6 decimal places.
    // `false` can be passed to skip any processing (can be useful to avoid round-off errors).
    function formatNum(num, precision) {
        if (precision === false) return num;
        var pow = Math.pow(10, precision === undefined ? 6 : precision);
        return Math.round(num * pow) / pow;
    }
    // @function trim(str: String): String
    // Compatibility polyfill for [String.prototype.trim](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim)
    function trim(str) {
        return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
    }
    // @function splitWords(str: String): String[]
    // Trims and splits the string on whitespace and returns the array of parts.
    function splitWords(str) {
        return trim(str).split(/\s+/);
    }
    // @function setOptions(obj: Object, options: Object): Object
    // Merges the given properties to the `options` of the `obj` object, returning the resulting options. See `Class options`. Has an `L.setOptions` shortcut.
    function setOptions(obj, options) {
        if (!Object.prototype.hasOwnProperty.call(obj, "options")) obj.options = obj.options ? create$2(obj.options) : {};
        for(var i in options)obj.options[i] = options[i];
        return obj.options;
    }
    // @function getParamString(obj: Object, existingUrl?: String, uppercase?: Boolean): String
    // Converts an object into a parameter URL string, e.g. `{a: "foo", b: "bar"}`
    // translates to `'?a=foo&b=bar'`. If `existingUrl` is set, the parameters will
    // be appended at the end. If `uppercase` is `true`, the parameter names will
    // be uppercased (e.g. `'?A=foo&B=bar'`)
    function getParamString(obj, existingUrl, uppercase) {
        var params = [];
        for(var i in obj)params.push(encodeURIComponent(uppercase ? i.toUpperCase() : i) + "=" + encodeURIComponent(obj[i]));
        return (!existingUrl || existingUrl.indexOf("?") === -1 ? "?" : "&") + params.join("&");
    }
    var templateRe = /\{ *([\w_ -]+) *\}/g;
    // @function template(str: String, data: Object): String
    // Simple templating facility, accepts a template string of the form `'Hello {a}, {b}'`
    // and a data object like `{a: 'foo', b: 'bar'}`, returns evaluated string
    // `('Hello foo, bar')`. You can also specify functions instead of strings for
    // data values — they will be evaluated passing `data` as an argument.
    function template(str, data) {
        return str.replace(templateRe, function(str, key) {
            var value = data[key];
            if (value === undefined) throw new Error("No value provided for variable " + str);
            else if (typeof value === "function") value = value(data);
            return value;
        });
    }
    // @function isArray(obj): Boolean
    // Compatibility polyfill for [Array.isArray](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/isArray)
    var isArray = Array.isArray || function(obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
    };
    // @function indexOf(array: Array, el: Object): Number
    // Compatibility polyfill for [Array.prototype.indexOf](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/indexOf)
    function indexOf(array, el) {
        for(var i = 0; i < array.length; i++){
            if (array[i] === el) return i;
        }
        return -1;
    }
    // @property emptyImageUrl: String
    // Data URI string containing a base64-encoded empty GIF image.
    // Used as a hack to free memory from unused images on WebKit-powered
    // mobile devices (by setting image `src` to this string).
    var emptyImageUrl = "data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=";
    // inspired by https://paulirish.com/2011/requestanimationframe-for-smart-animating/
    function getPrefixed(name) {
        return window["webkit" + name] || window["moz" + name] || window["ms" + name];
    }
    var lastTime = 0;
    // fallback for IE 7-8
    function timeoutDefer(fn) {
        var time = +new Date(), timeToCall = Math.max(0, 16 - (time - lastTime));
        lastTime = time + timeToCall;
        return window.setTimeout(fn, timeToCall);
    }
    var requestFn = window.requestAnimationFrame || getPrefixed("RequestAnimationFrame") || timeoutDefer;
    var cancelFn = window.cancelAnimationFrame || getPrefixed("CancelAnimationFrame") || getPrefixed("CancelRequestAnimationFrame") || function(id) {
        window.clearTimeout(id);
    };
    // @function requestAnimFrame(fn: Function, context?: Object, immediate?: Boolean): Number
    // Schedules `fn` to be executed when the browser repaints. `fn` is bound to
    // `context` if given. When `immediate` is set, `fn` is called immediately if
    // the browser doesn't have native support for
    // [`window.requestAnimationFrame`](https://developer.mozilla.org/docs/Web/API/window/requestAnimationFrame),
    // otherwise it's delayed. Returns a request ID that can be used to cancel the request.
    function requestAnimFrame(fn, context, immediate) {
        if (immediate && requestFn === timeoutDefer) fn.call(context);
        else return requestFn.call(window, bind(fn, context));
    }
    // @function cancelAnimFrame(id: Number): undefined
    // Cancels a previous `requestAnimFrame`. See also [window.cancelAnimationFrame](https://developer.mozilla.org/docs/Web/API/window/cancelAnimationFrame).
    function cancelAnimFrame(id) {
        if (id) cancelFn.call(window, id);
    }
    var Util = {
        __proto__: null,
        extend: extend,
        create: create$2,
        bind: bind,
        get lastId () {
            return lastId;
        },
        stamp: stamp,
        throttle: throttle,
        wrapNum: wrapNum,
        falseFn: falseFn,
        formatNum: formatNum,
        trim: trim,
        splitWords: splitWords,
        setOptions: setOptions,
        getParamString: getParamString,
        template: template,
        isArray: isArray,
        indexOf: indexOf,
        emptyImageUrl: emptyImageUrl,
        requestFn: requestFn,
        cancelFn: cancelFn,
        requestAnimFrame: requestAnimFrame,
        cancelAnimFrame: cancelAnimFrame
    };
    // @class Class
    // @aka L.Class
    // @section
    // @uninheritable
    // Thanks to John Resig and Dean Edwards for inspiration!
    function Class() {}
    Class.extend = function(props) {
        // @function extend(props: Object): Function
        // [Extends the current class](#class-inheritance) given the properties to be included.
        // Returns a Javascript function that is a class constructor (to be called with `new`).
        var NewClass = function() {
            setOptions(this);
            // call the constructor
            if (this.initialize) this.initialize.apply(this, arguments);
            // call all constructor hooks
            this.callInitHooks();
        };
        var parentProto = NewClass.__super__ = this.prototype;
        var proto = create$2(parentProto);
        proto.constructor = NewClass;
        NewClass.prototype = proto;
        // inherit parent's statics
        for(var i in this)if (Object.prototype.hasOwnProperty.call(this, i) && i !== "prototype" && i !== "__super__") NewClass[i] = this[i];
        // mix static properties into the class
        if (props.statics) extend(NewClass, props.statics);
        // mix includes into the prototype
        if (props.includes) {
            checkDeprecatedMixinEvents(props.includes);
            extend.apply(null, [
                proto
            ].concat(props.includes));
        }
        // mix given properties into the prototype
        extend(proto, props);
        delete proto.statics;
        delete proto.includes;
        // merge options
        if (proto.options) {
            proto.options = parentProto.options ? create$2(parentProto.options) : {};
            extend(proto.options, props.options);
        }
        proto._initHooks = [];
        // add method for calling all hooks
        proto.callInitHooks = function() {
            if (this._initHooksCalled) return;
            if (parentProto.callInitHooks) parentProto.callInitHooks.call(this);
            this._initHooksCalled = true;
            for(var i = 0, len = proto._initHooks.length; i < len; i++)proto._initHooks[i].call(this);
        };
        return NewClass;
    };
    // @function include(properties: Object): this
    // [Includes a mixin](#class-includes) into the current class.
    Class.include = function(props) {
        var parentOptions = this.prototype.options;
        extend(this.prototype, props);
        if (props.options) {
            this.prototype.options = parentOptions;
            this.mergeOptions(props.options);
        }
        return this;
    };
    // @function mergeOptions(options: Object): this
    // [Merges `options`](#class-options) into the defaults of the class.
    Class.mergeOptions = function(options) {
        extend(this.prototype.options, options);
        return this;
    };
    // @function addInitHook(fn: Function): this
    // Adds a [constructor hook](#class-constructor-hooks) to the class.
    Class.addInitHook = function(fn) {
        var args = Array.prototype.slice.call(arguments, 1);
        var init = typeof fn === "function" ? fn : function() {
            this[fn].apply(this, args);
        };
        this.prototype._initHooks = this.prototype._initHooks || [];
        this.prototype._initHooks.push(init);
        return this;
    };
    function checkDeprecatedMixinEvents(includes) {
        /* global L: true */ if (typeof L === "undefined" || !L || !L.Mixin) return;
        includes = isArray(includes) ? includes : [
            includes
        ];
        for(var i = 0; i < includes.length; i++)if (includes[i] === L.Mixin.Events) console.warn("Deprecated include of L.Mixin.Events: this property will be removed in future releases, please inherit from L.Evented instead.", new Error().stack);
    }
    /*
   * @class Evented
   * @aka L.Evented
   * @inherits Class
   *
   * A set of methods shared between event-powered classes (like `Map` and `Marker`). Generally, events allow you to execute some function when something happens with an object (e.g. the user clicks on the map, causing the map to fire `'click'` event).
   *
   * @example
   *
   * ```js
   * map.on('click', function(e) {
   * 	alert(e.latlng);
   * } );
   * ```
   *
   * Leaflet deals with event listeners by reference, so if you want to add a listener and then remove it, define it as a function:
   *
   * ```js
   * function onClick(e) { ... }
   *
   * map.on('click', onClick);
   * map.off('click', onClick);
   * ```
   */ var Events = {
        /* @method on(type: String, fn: Function, context?: Object): this
  	 * Adds a listener function (`fn`) to a particular event type of the object. You can optionally specify the context of the listener (object the this keyword will point to). You can also pass several space-separated types (e.g. `'click dblclick'`).
  	 *
  	 * @alternative
  	 * @method on(eventMap: Object): this
  	 * Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
  	 */ on: function(types, fn, context) {
            // types can be a map of types/handlers
            if (typeof types === "object") for(var type in types)// we don't process space-separated events here for performance;
            // it's a hot path since Layer uses the on(obj) syntax
            this._on(type, types[type], fn);
            else {
                // types can be a string of space-separated words
                types = splitWords(types);
                for(var i = 0, len = types.length; i < len; i++)this._on(types[i], fn, context);
            }
            return this;
        },
        /* @method off(type: String, fn?: Function, context?: Object): this
  	 * Removes a previously added listener function. If no function is specified, it will remove all the listeners of that particular event from the object. Note that if you passed a custom context to `on`, you must pass the same context to `off` in order to remove the listener.
  	 *
  	 * @alternative
  	 * @method off(eventMap: Object): this
  	 * Removes a set of type/listener pairs.
  	 *
  	 * @alternative
  	 * @method off: this
  	 * Removes all listeners to all events on the object. This includes implicitly attached events.
  	 */ off: function(types, fn, context) {
            if (!arguments.length) // clear all listeners if called without arguments
            delete this._events;
            else if (typeof types === "object") for(var type in types)this._off(type, types[type], fn);
            else {
                types = splitWords(types);
                var removeAll = arguments.length === 1;
                for(var i = 0, len = types.length; i < len; i++)if (removeAll) this._off(types[i]);
                else this._off(types[i], fn, context);
            }
            return this;
        },
        // attach listener (without syntactic sugar now)
        _on: function(type, fn, context, _once) {
            if (typeof fn !== "function") {
                console.warn("wrong listener type: " + typeof fn);
                return;
            }
            // check if fn already there
            if (this._listens(type, fn, context) !== false) return;
            if (context === this) // Less memory footprint.
            context = undefined;
            var newListener = {
                fn: fn,
                ctx: context
            };
            if (_once) newListener.once = true;
            this._events = this._events || {};
            this._events[type] = this._events[type] || [];
            this._events[type].push(newListener);
        },
        _off: function(type, fn, context) {
            var listeners, i, len;
            if (!this._events) return;
            listeners = this._events[type];
            if (!listeners) return;
            if (arguments.length === 1) {
                if (this._firingCount) // Set all removed listeners to noop
                // so they are not called if remove happens in fire
                for(i = 0, len = listeners.length; i < len; i++)listeners[i].fn = falseFn;
                // clear all listeners for a type if function isn't specified
                delete this._events[type];
                return;
            }
            if (typeof fn !== "function") {
                console.warn("wrong listener type: " + typeof fn);
                return;
            }
            // find fn and remove it
            var index = this._listens(type, fn, context);
            if (index !== false) {
                var listener = listeners[index];
                if (this._firingCount) {
                    // set the removed listener to noop so that's not called if remove happens in fire
                    listener.fn = falseFn;
                    /* copy array in case events are being fired */ this._events[type] = listeners = listeners.slice();
                }
                listeners.splice(index, 1);
            }
        },
        // @method fire(type: String, data?: Object, propagate?: Boolean): this
        // Fires an event of the specified type. You can optionally provide a data
        // object — the first argument of the listener function will contain its
        // properties. The event can optionally be propagated to event parents.
        fire: function(type, data, propagate) {
            if (!this.listens(type, propagate)) return this;
            var event = extend({}, data, {
                type: type,
                target: this,
                sourceTarget: data && data.sourceTarget || this
            });
            if (this._events) {
                var listeners = this._events[type];
                if (listeners) {
                    this._firingCount = this._firingCount + 1 || 1;
                    for(var i = 0, len = listeners.length; i < len; i++){
                        var l = listeners[i];
                        // off overwrites l.fn, so we need to copy fn to a var
                        var fn = l.fn;
                        if (l.once) this.off(type, fn, l.ctx);
                        fn.call(l.ctx || this, event);
                    }
                    this._firingCount--;
                }
            }
            if (propagate) // propagate the event to parents (set with addEventParent)
            this._propagateEvent(event);
            return this;
        },
        // @method listens(type: String, propagate?: Boolean): Boolean
        // @method listens(type: String, fn: Function, context?: Object, propagate?: Boolean): Boolean
        // Returns `true` if a particular event type has any listeners attached to it.
        // The verification can optionally be propagated, it will return `true` if parents have the listener attached to it.
        listens: function(type, fn, context, propagate) {
            if (typeof type !== "string") console.warn('"string" type argument expected');
            // we don't overwrite the input `fn` value, because we need to use it for propagation
            var _fn = fn;
            if (typeof fn !== "function") {
                propagate = !!fn;
                _fn = undefined;
                context = undefined;
            }
            var listeners = this._events && this._events[type];
            if (listeners && listeners.length) {
                if (this._listens(type, _fn, context) !== false) return true;
            }
            if (propagate) // also check parents for listeners if event propagates
            for(var id in this._eventParents){
                if (this._eventParents[id].listens(type, fn, context, propagate)) return true;
            }
            return false;
        },
        // returns the index (number) or false
        _listens: function(type, fn, context) {
            if (!this._events) return false;
            var listeners = this._events[type] || [];
            if (!fn) return !!listeners.length;
            if (context === this) // Less memory footprint.
            context = undefined;
            for(var i = 0, len = listeners.length; i < len; i++){
                if (listeners[i].fn === fn && listeners[i].ctx === context) return i;
            }
            return false;
        },
        // @method once(…): this
        // Behaves as [`on(…)`](#evented-on), except the listener will only get fired once and then removed.
        once: function(types, fn, context) {
            // types can be a map of types/handlers
            if (typeof types === "object") for(var type in types)// we don't process space-separated events here for performance;
            // it's a hot path since Layer uses the on(obj) syntax
            this._on(type, types[type], fn, true);
            else {
                // types can be a string of space-separated words
                types = splitWords(types);
                for(var i = 0, len = types.length; i < len; i++)this._on(types[i], fn, context, true);
            }
            return this;
        },
        // @method addEventParent(obj: Evented): this
        // Adds an event parent - an `Evented` that will receive propagated events
        addEventParent: function(obj) {
            this._eventParents = this._eventParents || {};
            this._eventParents[stamp(obj)] = obj;
            return this;
        },
        // @method removeEventParent(obj: Evented): this
        // Removes an event parent, so it will stop receiving propagated events
        removeEventParent: function(obj) {
            if (this._eventParents) delete this._eventParents[stamp(obj)];
            return this;
        },
        _propagateEvent: function(e) {
            for(var id in this._eventParents)this._eventParents[id].fire(e.type, extend({
                layer: e.target,
                propagatedFrom: e.target
            }, e), true);
        }
    };
    // aliases; we should ditch those eventually
    // @method addEventListener(…): this
    // Alias to [`on(…)`](#evented-on)
    Events.addEventListener = Events.on;
    // @method removeEventListener(…): this
    // Alias to [`off(…)`](#evented-off)
    // @method clearAllEventListeners(…): this
    // Alias to [`off()`](#evented-off)
    Events.removeEventListener = Events.clearAllEventListeners = Events.off;
    // @method addOneTimeEventListener(…): this
    // Alias to [`once(…)`](#evented-once)
    Events.addOneTimeEventListener = Events.once;
    // @method fireEvent(…): this
    // Alias to [`fire(…)`](#evented-fire)
    Events.fireEvent = Events.fire;
    // @method hasEventListeners(…): Boolean
    // Alias to [`listens(…)`](#evented-listens)
    Events.hasEventListeners = Events.listens;
    var Evented = Class.extend(Events);
    /*
   * @class Point
   * @aka L.Point
   *
   * Represents a point with `x` and `y` coordinates in pixels.
   *
   * @example
   *
   * ```js
   * var point = L.point(200, 300);
   * ```
   *
   * All Leaflet methods and options that accept `Point` objects also accept them in a simple Array form (unless noted otherwise), so these lines are equivalent:
   *
   * ```js
   * map.panBy([200, 300]);
   * map.panBy(L.point(200, 300));
   * ```
   *
   * Note that `Point` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function Point(x, y, round) {
        // @property x: Number; The `x` coordinate of the point
        this.x = round ? Math.round(x) : x;
        // @property y: Number; The `y` coordinate of the point
        this.y = round ? Math.round(y) : y;
    }
    var trunc = Math.trunc || function(v) {
        return v > 0 ? Math.floor(v) : Math.ceil(v);
    };
    Point.prototype = {
        // @method clone(): Point
        // Returns a copy of the current point.
        clone: function() {
            return new Point(this.x, this.y);
        },
        // @method add(otherPoint: Point): Point
        // Returns the result of addition of the current and the given points.
        add: function(point) {
            // non-destructive, returns a new point
            return this.clone()._add(toPoint(point));
        },
        _add: function(point) {
            // destructive, used directly for performance in situations where it's safe to modify existing point
            this.x += point.x;
            this.y += point.y;
            return this;
        },
        // @method subtract(otherPoint: Point): Point
        // Returns the result of subtraction of the given point from the current.
        subtract: function(point) {
            return this.clone()._subtract(toPoint(point));
        },
        _subtract: function(point) {
            this.x -= point.x;
            this.y -= point.y;
            return this;
        },
        // @method divideBy(num: Number): Point
        // Returns the result of division of the current point by the given number.
        divideBy: function(num) {
            return this.clone()._divideBy(num);
        },
        _divideBy: function(num) {
            this.x /= num;
            this.y /= num;
            return this;
        },
        // @method multiplyBy(num: Number): Point
        // Returns the result of multiplication of the current point by the given number.
        multiplyBy: function(num) {
            return this.clone()._multiplyBy(num);
        },
        _multiplyBy: function(num) {
            this.x *= num;
            this.y *= num;
            return this;
        },
        // @method scaleBy(scale: Point): Point
        // Multiply each coordinate of the current point by each coordinate of
        // `scale`. In linear algebra terms, multiply the point by the
        // [scaling matrix](https://en.wikipedia.org/wiki/Scaling_%28geometry%29#Matrix_representation)
        // defined by `scale`.
        scaleBy: function(point) {
            return new Point(this.x * point.x, this.y * point.y);
        },
        // @method unscaleBy(scale: Point): Point
        // Inverse of `scaleBy`. Divide each coordinate of the current point by
        // each coordinate of `scale`.
        unscaleBy: function(point) {
            return new Point(this.x / point.x, this.y / point.y);
        },
        // @method round(): Point
        // Returns a copy of the current point with rounded coordinates.
        round: function() {
            return this.clone()._round();
        },
        _round: function() {
            this.x = Math.round(this.x);
            this.y = Math.round(this.y);
            return this;
        },
        // @method floor(): Point
        // Returns a copy of the current point with floored coordinates (rounded down).
        floor: function() {
            return this.clone()._floor();
        },
        _floor: function() {
            this.x = Math.floor(this.x);
            this.y = Math.floor(this.y);
            return this;
        },
        // @method ceil(): Point
        // Returns a copy of the current point with ceiled coordinates (rounded up).
        ceil: function() {
            return this.clone()._ceil();
        },
        _ceil: function() {
            this.x = Math.ceil(this.x);
            this.y = Math.ceil(this.y);
            return this;
        },
        // @method trunc(): Point
        // Returns a copy of the current point with truncated coordinates (rounded towards zero).
        trunc: function() {
            return this.clone()._trunc();
        },
        _trunc: function() {
            this.x = trunc(this.x);
            this.y = trunc(this.y);
            return this;
        },
        // @method distanceTo(otherPoint: Point): Number
        // Returns the cartesian distance between the current and the given points.
        distanceTo: function(point) {
            point = toPoint(point);
            var x = point.x - this.x, y = point.y - this.y;
            return Math.sqrt(x * x + y * y);
        },
        // @method equals(otherPoint: Point): Boolean
        // Returns `true` if the given point has the same coordinates.
        equals: function(point) {
            point = toPoint(point);
            return point.x === this.x && point.y === this.y;
        },
        // @method contains(otherPoint: Point): Boolean
        // Returns `true` if both coordinates of the given point are less than the corresponding current point coordinates (in absolute values).
        contains: function(point) {
            point = toPoint(point);
            return Math.abs(point.x) <= Math.abs(this.x) && Math.abs(point.y) <= Math.abs(this.y);
        },
        // @method toString(): String
        // Returns a string representation of the point for debugging purposes.
        toString: function() {
            return "Point(" + formatNum(this.x) + ", " + formatNum(this.y) + ")";
        }
    };
    // @factory L.point(x: Number, y: Number, round?: Boolean)
    // Creates a Point object with the given `x` and `y` coordinates. If optional `round` is set to true, rounds the `x` and `y` values.
    // @alternative
    // @factory L.point(coords: Number[])
    // Expects an array of the form `[x, y]` instead.
    // @alternative
    // @factory L.point(coords: Object)
    // Expects a plain object of the form `{x: Number, y: Number}` instead.
    function toPoint(x, y, round) {
        if (x instanceof Point) return x;
        if (isArray(x)) return new Point(x[0], x[1]);
        if (x === undefined || x === null) return x;
        if (typeof x === "object" && "x" in x && "y" in x) return new Point(x.x, x.y);
        return new Point(x, y, round);
    }
    /*
   * @class Bounds
   * @aka L.Bounds
   *
   * Represents a rectangular area in pixel coordinates.
   *
   * @example
   *
   * ```js
   * var p1 = L.point(10, 10),
   * p2 = L.point(40, 60),
   * bounds = L.bounds(p1, p2);
   * ```
   *
   * All Leaflet methods that accept `Bounds` objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
   *
   * ```js
   * otherBounds.intersects([[10, 10], [40, 60]]);
   * ```
   *
   * Note that `Bounds` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function Bounds(a, b) {
        if (!a) return;
        var points = b ? [
            a,
            b
        ] : a;
        for(var i = 0, len = points.length; i < len; i++)this.extend(points[i]);
    }
    Bounds.prototype = {
        // @method extend(point: Point): this
        // Extends the bounds to contain the given point.
        // @alternative
        // @method extend(otherBounds: Bounds): this
        // Extend the bounds to contain the given bounds
        extend: function(obj) {
            var min2, max2;
            if (!obj) return this;
            if (obj instanceof Point || typeof obj[0] === "number" || "x" in obj) min2 = max2 = toPoint(obj);
            else {
                obj = toBounds(obj);
                min2 = obj.min;
                max2 = obj.max;
                if (!min2 || !max2) return this;
            }
            // @property min: Point
            // The top left corner of the rectangle.
            // @property max: Point
            // The bottom right corner of the rectangle.
            if (!this.min && !this.max) {
                this.min = min2.clone();
                this.max = max2.clone();
            } else {
                this.min.x = Math.min(min2.x, this.min.x);
                this.max.x = Math.max(max2.x, this.max.x);
                this.min.y = Math.min(min2.y, this.min.y);
                this.max.y = Math.max(max2.y, this.max.y);
            }
            return this;
        },
        // @method getCenter(round?: Boolean): Point
        // Returns the center point of the bounds.
        getCenter: function(round) {
            return toPoint((this.min.x + this.max.x) / 2, (this.min.y + this.max.y) / 2, round);
        },
        // @method getBottomLeft(): Point
        // Returns the bottom-left point of the bounds.
        getBottomLeft: function() {
            return toPoint(this.min.x, this.max.y);
        },
        // @method getTopRight(): Point
        // Returns the top-right point of the bounds.
        getTopRight: function() {
            return toPoint(this.max.x, this.min.y);
        },
        // @method getTopLeft(): Point
        // Returns the top-left point of the bounds (i.e. [`this.min`](#bounds-min)).
        getTopLeft: function() {
            return this.min; // left, top
        },
        // @method getBottomRight(): Point
        // Returns the bottom-right point of the bounds (i.e. [`this.max`](#bounds-max)).
        getBottomRight: function() {
            return this.max; // right, bottom
        },
        // @method getSize(): Point
        // Returns the size of the given bounds
        getSize: function() {
            return this.max.subtract(this.min);
        },
        // @method contains(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle contains the given one.
        // @alternative
        // @method contains(point: Point): Boolean
        // Returns `true` if the rectangle contains the given point.
        contains: function(obj) {
            var min, max;
            if (typeof obj[0] === "number" || obj instanceof Point) obj = toPoint(obj);
            else obj = toBounds(obj);
            if (obj instanceof Bounds) {
                min = obj.min;
                max = obj.max;
            } else min = max = obj;
            return min.x >= this.min.x && max.x <= this.max.x && min.y >= this.min.y && max.y <= this.max.y;
        },
        // @method intersects(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle intersects the given bounds. Two bounds
        // intersect if they have at least one point in common.
        intersects: function(bounds) {
            bounds = toBounds(bounds);
            var min = this.min, max = this.max, min2 = bounds.min, max2 = bounds.max, xIntersects = max2.x >= min.x && min2.x <= max.x, yIntersects = max2.y >= min.y && min2.y <= max.y;
            return xIntersects && yIntersects;
        },
        // @method overlaps(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle overlaps the given bounds. Two bounds
        // overlap if their intersection is an area.
        overlaps: function(bounds) {
            bounds = toBounds(bounds);
            var min = this.min, max = this.max, min2 = bounds.min, max2 = bounds.max, xOverlaps = max2.x > min.x && min2.x < max.x, yOverlaps = max2.y > min.y && min2.y < max.y;
            return xOverlaps && yOverlaps;
        },
        // @method isValid(): Boolean
        // Returns `true` if the bounds are properly initialized.
        isValid: function() {
            return !!(this.min && this.max);
        },
        // @method pad(bufferRatio: Number): Bounds
        // Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
        // For example, a ratio of 0.5 extends the bounds by 50% in each direction.
        // Negative values will retract the bounds.
        pad: function(bufferRatio) {
            var min = this.min, max = this.max, heightBuffer = Math.abs(min.x - max.x) * bufferRatio, widthBuffer = Math.abs(min.y - max.y) * bufferRatio;
            return toBounds(toPoint(min.x - heightBuffer, min.y - widthBuffer), toPoint(max.x + heightBuffer, max.y + widthBuffer));
        },
        // @method equals(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle is equivalent to the given bounds.
        equals: function(bounds) {
            if (!bounds) return false;
            bounds = toBounds(bounds);
            return this.min.equals(bounds.getTopLeft()) && this.max.equals(bounds.getBottomRight());
        }
    };
    // @factory L.bounds(corner1: Point, corner2: Point)
    // Creates a Bounds object from two corners coordinate pairs.
    // @alternative
    // @factory L.bounds(points: Point[])
    // Creates a Bounds object from the given array of points.
    function toBounds(a, b) {
        if (!a || a instanceof Bounds) return a;
        return new Bounds(a, b);
    }
    /*
   * @class LatLngBounds
   * @aka L.LatLngBounds
   *
   * Represents a rectangular geographical area on a map.
   *
   * @example
   *
   * ```js
   * var corner1 = L.latLng(40.712, -74.227),
   * corner2 = L.latLng(40.774, -74.125),
   * bounds = L.latLngBounds(corner1, corner2);
   * ```
   *
   * All Leaflet methods that accept LatLngBounds objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
   *
   * ```js
   * map.fitBounds([
   * 	[40.712, -74.227],
   * 	[40.774, -74.125]
   * ]);
   * ```
   *
   * Caution: if the area crosses the antimeridian (often confused with the International Date Line), you must specify corners _outside_ the [-180, 180] degrees longitude range.
   *
   * Note that `LatLngBounds` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function LatLngBounds(corner1, corner2) {
        if (!corner1) return;
        var latlngs = corner2 ? [
            corner1,
            corner2
        ] : corner1;
        for(var i = 0, len = latlngs.length; i < len; i++)this.extend(latlngs[i]);
    }
    LatLngBounds.prototype = {
        // @method extend(latlng: LatLng): this
        // Extend the bounds to contain the given point
        // @alternative
        // @method extend(otherBounds: LatLngBounds): this
        // Extend the bounds to contain the given bounds
        extend: function(obj) {
            var sw = this._southWest, ne = this._northEast, sw2, ne2;
            if (obj instanceof LatLng) {
                sw2 = obj;
                ne2 = obj;
            } else if (obj instanceof LatLngBounds) {
                sw2 = obj._southWest;
                ne2 = obj._northEast;
                if (!sw2 || !ne2) return this;
            } else return obj ? this.extend(toLatLng(obj) || toLatLngBounds(obj)) : this;
            if (!sw && !ne) {
                this._southWest = new LatLng(sw2.lat, sw2.lng);
                this._northEast = new LatLng(ne2.lat, ne2.lng);
            } else {
                sw.lat = Math.min(sw2.lat, sw.lat);
                sw.lng = Math.min(sw2.lng, sw.lng);
                ne.lat = Math.max(ne2.lat, ne.lat);
                ne.lng = Math.max(ne2.lng, ne.lng);
            }
            return this;
        },
        // @method pad(bufferRatio: Number): LatLngBounds
        // Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
        // For example, a ratio of 0.5 extends the bounds by 50% in each direction.
        // Negative values will retract the bounds.
        pad: function(bufferRatio) {
            var sw = this._southWest, ne = this._northEast, heightBuffer = Math.abs(sw.lat - ne.lat) * bufferRatio, widthBuffer = Math.abs(sw.lng - ne.lng) * bufferRatio;
            return new LatLngBounds(new LatLng(sw.lat - heightBuffer, sw.lng - widthBuffer), new LatLng(ne.lat + heightBuffer, ne.lng + widthBuffer));
        },
        // @method getCenter(): LatLng
        // Returns the center point of the bounds.
        getCenter: function() {
            return new LatLng((this._southWest.lat + this._northEast.lat) / 2, (this._southWest.lng + this._northEast.lng) / 2);
        },
        // @method getSouthWest(): LatLng
        // Returns the south-west point of the bounds.
        getSouthWest: function() {
            return this._southWest;
        },
        // @method getNorthEast(): LatLng
        // Returns the north-east point of the bounds.
        getNorthEast: function() {
            return this._northEast;
        },
        // @method getNorthWest(): LatLng
        // Returns the north-west point of the bounds.
        getNorthWest: function() {
            return new LatLng(this.getNorth(), this.getWest());
        },
        // @method getSouthEast(): LatLng
        // Returns the south-east point of the bounds.
        getSouthEast: function() {
            return new LatLng(this.getSouth(), this.getEast());
        },
        // @method getWest(): Number
        // Returns the west longitude of the bounds
        getWest: function() {
            return this._southWest.lng;
        },
        // @method getSouth(): Number
        // Returns the south latitude of the bounds
        getSouth: function() {
            return this._southWest.lat;
        },
        // @method getEast(): Number
        // Returns the east longitude of the bounds
        getEast: function() {
            return this._northEast.lng;
        },
        // @method getNorth(): Number
        // Returns the north latitude of the bounds
        getNorth: function() {
            return this._northEast.lat;
        },
        // @method contains(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle contains the given one.
        // @alternative
        // @method contains (latlng: LatLng): Boolean
        // Returns `true` if the rectangle contains the given point.
        contains: function(obj) {
            if (typeof obj[0] === "number" || obj instanceof LatLng || "lat" in obj) obj = toLatLng(obj);
            else obj = toLatLngBounds(obj);
            var sw = this._southWest, ne = this._northEast, sw2, ne2;
            if (obj instanceof LatLngBounds) {
                sw2 = obj.getSouthWest();
                ne2 = obj.getNorthEast();
            } else sw2 = ne2 = obj;
            return sw2.lat >= sw.lat && ne2.lat <= ne.lat && sw2.lng >= sw.lng && ne2.lng <= ne.lng;
        },
        // @method intersects(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle intersects the given bounds. Two bounds intersect if they have at least one point in common.
        intersects: function(bounds) {
            bounds = toLatLngBounds(bounds);
            var sw = this._southWest, ne = this._northEast, sw2 = bounds.getSouthWest(), ne2 = bounds.getNorthEast(), latIntersects = ne2.lat >= sw.lat && sw2.lat <= ne.lat, lngIntersects = ne2.lng >= sw.lng && sw2.lng <= ne.lng;
            return latIntersects && lngIntersects;
        },
        // @method overlaps(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle overlaps the given bounds. Two bounds overlap if their intersection is an area.
        overlaps: function(bounds) {
            bounds = toLatLngBounds(bounds);
            var sw = this._southWest, ne = this._northEast, sw2 = bounds.getSouthWest(), ne2 = bounds.getNorthEast(), latOverlaps = ne2.lat > sw.lat && sw2.lat < ne.lat, lngOverlaps = ne2.lng > sw.lng && sw2.lng < ne.lng;
            return latOverlaps && lngOverlaps;
        },
        // @method toBBoxString(): String
        // Returns a string with bounding box coordinates in a 'southwest_lng,southwest_lat,northeast_lng,northeast_lat' format. Useful for sending requests to web services that return geo data.
        toBBoxString: function() {
            return [
                this.getWest(),
                this.getSouth(),
                this.getEast(),
                this.getNorth()
            ].join(",");
        },
        // @method equals(otherBounds: LatLngBounds, maxMargin?: Number): Boolean
        // Returns `true` if the rectangle is equivalent (within a small margin of error) to the given bounds. The margin of error can be overridden by setting `maxMargin` to a small number.
        equals: function(bounds, maxMargin) {
            if (!bounds) return false;
            bounds = toLatLngBounds(bounds);
            return this._southWest.equals(bounds.getSouthWest(), maxMargin) && this._northEast.equals(bounds.getNorthEast(), maxMargin);
        },
        // @method isValid(): Boolean
        // Returns `true` if the bounds are properly initialized.
        isValid: function() {
            return !!(this._southWest && this._northEast);
        }
    };
    // TODO International date line?
    // @factory L.latLngBounds(corner1: LatLng, corner2: LatLng)
    // Creates a `LatLngBounds` object by defining two diagonally opposite corners of the rectangle.
    // @alternative
    // @factory L.latLngBounds(latlngs: LatLng[])
    // Creates a `LatLngBounds` object defined by the geographical points it contains. Very useful for zooming the map to fit a particular set of locations with [`fitBounds`](#map-fitbounds).
    function toLatLngBounds(a, b) {
        if (a instanceof LatLngBounds) return a;
        return new LatLngBounds(a, b);
    }
    /* @class LatLng
   * @aka L.LatLng
   *
   * Represents a geographical point with a certain latitude and longitude.
   *
   * @example
   *
   * ```
   * var latlng = L.latLng(50.5, 30.5);
   * ```
   *
   * All Leaflet methods that accept LatLng objects also accept them in a simple Array form and simple object form (unless noted otherwise), so these lines are equivalent:
   *
   * ```
   * map.panTo([50, 30]);
   * map.panTo({lon: 30, lat: 50});
   * map.panTo({lat: 50, lng: 30});
   * map.panTo(L.latLng(50, 30));
   * ```
   *
   * Note that `LatLng` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function LatLng(lat, lng, alt) {
        if (isNaN(lat) || isNaN(lng)) throw new Error("Invalid LatLng object: (" + lat + ", " + lng + ")");
        // @property lat: Number
        // Latitude in degrees
        this.lat = +lat;
        // @property lng: Number
        // Longitude in degrees
        this.lng = +lng;
        // @property alt: Number
        // Altitude in meters (optional)
        if (alt !== undefined) this.alt = +alt;
    }
    LatLng.prototype = {
        // @method equals(otherLatLng: LatLng, maxMargin?: Number): Boolean
        // Returns `true` if the given `LatLng` point is at the same position (within a small margin of error). The margin of error can be overridden by setting `maxMargin` to a small number.
        equals: function(obj, maxMargin) {
            if (!obj) return false;
            obj = toLatLng(obj);
            var margin = Math.max(Math.abs(this.lat - obj.lat), Math.abs(this.lng - obj.lng));
            return margin <= (maxMargin === undefined ? 1.0E-9 : maxMargin);
        },
        // @method toString(): String
        // Returns a string representation of the point (for debugging purposes).
        toString: function(precision) {
            return "LatLng(" + formatNum(this.lat, precision) + ", " + formatNum(this.lng, precision) + ")";
        },
        // @method distanceTo(otherLatLng: LatLng): Number
        // Returns the distance (in meters) to the given `LatLng` calculated using the [Spherical Law of Cosines](https://en.wikipedia.org/wiki/Spherical_law_of_cosines).
        distanceTo: function(other) {
            return Earth.distance(this, toLatLng(other));
        },
        // @method wrap(): LatLng
        // Returns a new `LatLng` object with the longitude wrapped so it's always between -180 and +180 degrees.
        wrap: function() {
            return Earth.wrapLatLng(this);
        },
        // @method toBounds(sizeInMeters: Number): LatLngBounds
        // Returns a new `LatLngBounds` object in which each boundary is `sizeInMeters/2` meters apart from the `LatLng`.
        toBounds: function(sizeInMeters) {
            var latAccuracy = 180 * sizeInMeters / 40075017, lngAccuracy = latAccuracy / Math.cos(Math.PI / 180 * this.lat);
            return toLatLngBounds([
                this.lat - latAccuracy,
                this.lng - lngAccuracy
            ], [
                this.lat + latAccuracy,
                this.lng + lngAccuracy
            ]);
        },
        clone: function() {
            return new LatLng(this.lat, this.lng, this.alt);
        }
    };
    // @factory L.latLng(latitude: Number, longitude: Number, altitude?: Number): LatLng
    // Creates an object representing a geographical point with the given latitude and longitude (and optionally altitude).
    // @alternative
    // @factory L.latLng(coords: Array): LatLng
    // Expects an array of the form `[Number, Number]` or `[Number, Number, Number]` instead.
    // @alternative
    // @factory L.latLng(coords: Object): LatLng
    // Expects an plain object of the form `{lat: Number, lng: Number}` or `{lat: Number, lng: Number, alt: Number}` instead.
    function toLatLng(a, b, c) {
        if (a instanceof LatLng) return a;
        if (isArray(a) && typeof a[0] !== "object") {
            if (a.length === 3) return new LatLng(a[0], a[1], a[2]);
            if (a.length === 2) return new LatLng(a[0], a[1]);
            return null;
        }
        if (a === undefined || a === null) return a;
        if (typeof a === "object" && "lat" in a) return new LatLng(a.lat, "lng" in a ? a.lng : a.lon, a.alt);
        if (b === undefined) return null;
        return new LatLng(a, b, c);
    }
    /*
   * @namespace CRS
   * @crs L.CRS.Base
   * Object that defines coordinate reference systems for projecting
   * geographical points into pixel (screen) coordinates and back (and to
   * coordinates in other units for [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services). See
   * [spatial reference system](https://en.wikipedia.org/wiki/Spatial_reference_system).
   *
   * Leaflet defines the most usual CRSs by default. If you want to use a
   * CRS not defined by default, take a look at the
   * [Proj4Leaflet](https://github.com/kartena/Proj4Leaflet) plugin.
   *
   * Note that the CRS instances do not inherit from Leaflet's `Class` object,
   * and can't be instantiated. Also, new classes can't inherit from them,
   * and methods can't be added to them with the `include` function.
   */ var CRS = {
        // @method latLngToPoint(latlng: LatLng, zoom: Number): Point
        // Projects geographical coordinates into pixel coordinates for a given zoom.
        latLngToPoint: function(latlng, zoom) {
            var projectedPoint = this.projection.project(latlng), scale = this.scale(zoom);
            return this.transformation._transform(projectedPoint, scale);
        },
        // @method pointToLatLng(point: Point, zoom: Number): LatLng
        // The inverse of `latLngToPoint`. Projects pixel coordinates on a given
        // zoom into geographical coordinates.
        pointToLatLng: function(point, zoom) {
            var scale = this.scale(zoom), untransformedPoint = this.transformation.untransform(point, scale);
            return this.projection.unproject(untransformedPoint);
        },
        // @method project(latlng: LatLng): Point
        // Projects geographical coordinates into coordinates in units accepted for
        // this CRS (e.g. meters for EPSG:3857, for passing it to WMS services).
        project: function(latlng) {
            return this.projection.project(latlng);
        },
        // @method unproject(point: Point): LatLng
        // Given a projected coordinate returns the corresponding LatLng.
        // The inverse of `project`.
        unproject: function(point) {
            return this.projection.unproject(point);
        },
        // @method scale(zoom: Number): Number
        // Returns the scale used when transforming projected coordinates into
        // pixel coordinates for a particular zoom. For example, it returns
        // `256 * 2^zoom` for Mercator-based CRS.
        scale: function(zoom) {
            return 256 * Math.pow(2, zoom);
        },
        // @method zoom(scale: Number): Number
        // Inverse of `scale()`, returns the zoom level corresponding to a scale
        // factor of `scale`.
        zoom: function(scale) {
            return Math.log(scale / 256) / Math.LN2;
        },
        // @method getProjectedBounds(zoom: Number): Bounds
        // Returns the projection's bounds scaled and transformed for the provided `zoom`.
        getProjectedBounds: function(zoom) {
            if (this.infinite) return null;
            var b = this.projection.bounds, s = this.scale(zoom), min = this.transformation.transform(b.min, s), max = this.transformation.transform(b.max, s);
            return new Bounds(min, max);
        },
        // @method distance(latlng1: LatLng, latlng2: LatLng): Number
        // Returns the distance between two geographical coordinates.
        // @property code: String
        // Standard code name of the CRS passed into WMS services (e.g. `'EPSG:3857'`)
        //
        // @property wrapLng: Number[]
        // An array of two numbers defining whether the longitude (horizontal) coordinate
        // axis wraps around a given range and how. Defaults to `[-180, 180]` in most
        // geographical CRSs. If `undefined`, the longitude axis does not wrap around.
        //
        // @property wrapLat: Number[]
        // Like `wrapLng`, but for the latitude (vertical) axis.
        // wrapLng: [min, max],
        // wrapLat: [min, max],
        // @property infinite: Boolean
        // If true, the coordinate space will be unbounded (infinite in both axes)
        infinite: false,
        // @method wrapLatLng(latlng: LatLng): LatLng
        // Returns a `LatLng` where lat and lng has been wrapped according to the
        // CRS's `wrapLat` and `wrapLng` properties, if they are outside the CRS's bounds.
        wrapLatLng: function(latlng) {
            var lng = this.wrapLng ? wrapNum(latlng.lng, this.wrapLng, true) : latlng.lng, lat = this.wrapLat ? wrapNum(latlng.lat, this.wrapLat, true) : latlng.lat, alt = latlng.alt;
            return new LatLng(lat, lng, alt);
        },
        // @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
        // Returns a `LatLngBounds` with the same size as the given one, ensuring
        // that its center is within the CRS's bounds.
        // Only accepts actual `L.LatLngBounds` instances, not arrays.
        wrapLatLngBounds: function(bounds) {
            var center = bounds.getCenter(), newCenter = this.wrapLatLng(center), latShift = center.lat - newCenter.lat, lngShift = center.lng - newCenter.lng;
            if (latShift === 0 && lngShift === 0) return bounds;
            var sw = bounds.getSouthWest(), ne = bounds.getNorthEast(), newSw = new LatLng(sw.lat - latShift, sw.lng - lngShift), newNe = new LatLng(ne.lat - latShift, ne.lng - lngShift);
            return new LatLngBounds(newSw, newNe);
        }
    };
    /*
   * @namespace CRS
   * @crs L.CRS.Earth
   *
   * Serves as the base for CRS that are global such that they cover the earth.
   * Can only be used as the base for other CRS and cannot be used directly,
   * since it does not have a `code`, `projection` or `transformation`. `distance()` returns
   * meters.
   */ var Earth = extend({}, CRS, {
        wrapLng: [
            -180,
            180
        ],
        // Mean Earth Radius, as recommended for use by
        // the International Union of Geodesy and Geophysics,
        // see https://rosettacode.org/wiki/Haversine_formula
        R: 6371000,
        // distance between two geographical points using spherical law of cosines approximation
        distance: function(latlng1, latlng2) {
            var rad = Math.PI / 180, lat1 = latlng1.lat * rad, lat2 = latlng2.lat * rad, sinDLat = Math.sin((latlng2.lat - latlng1.lat) * rad / 2), sinDLon = Math.sin((latlng2.lng - latlng1.lng) * rad / 2), a = sinDLat * sinDLat + Math.cos(lat1) * Math.cos(lat2) * sinDLon * sinDLon, c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            return this.R * c;
        }
    });
    /*
   * @namespace Projection
   * @projection L.Projection.SphericalMercator
   *
   * Spherical Mercator projection — the most common projection for online maps,
   * used by almost all free and commercial tile providers. Assumes that Earth is
   * a sphere. Used by the `EPSG:3857` CRS.
   */ var earthRadius = 6378137;
    var SphericalMercator = {
        R: earthRadius,
        MAX_LATITUDE: 85.0511287798,
        project: function(latlng) {
            var d = Math.PI / 180, max = this.MAX_LATITUDE, lat = Math.max(Math.min(max, latlng.lat), -max), sin = Math.sin(lat * d);
            return new Point(this.R * latlng.lng * d, this.R * Math.log((1 + sin) / (1 - sin)) / 2);
        },
        unproject: function(point) {
            var d = 180 / Math.PI;
            return new LatLng((2 * Math.atan(Math.exp(point.y / this.R)) - Math.PI / 2) * d, point.x * d / this.R);
        },
        bounds: function() {
            var d = earthRadius * Math.PI;
            return new Bounds([
                -d,
                -d
            ], [
                d,
                d
            ]);
        }()
    };
    /*
   * @class Transformation
   * @aka L.Transformation
   *
   * Represents an affine transformation: a set of coefficients `a`, `b`, `c`, `d`
   * for transforming a point of a form `(x, y)` into `(a*x + b, c*y + d)` and doing
   * the reverse. Used by Leaflet in its projections code.
   *
   * @example
   *
   * ```js
   * var transformation = L.transformation(2, 5, -1, 10),
   * 	p = L.point(1, 2),
   * 	p2 = transformation.transform(p), //  L.point(7, 8)
   * 	p3 = transformation.untransform(p2); //  L.point(1, 2)
   * ```
   */ // factory new L.Transformation(a: Number, b: Number, c: Number, d: Number)
    // Creates a `Transformation` object with the given coefficients.
    function Transformation(a, b, c, d) {
        if (isArray(a)) {
            // use array properties
            this._a = a[0];
            this._b = a[1];
            this._c = a[2];
            this._d = a[3];
            return;
        }
        this._a = a;
        this._b = b;
        this._c = c;
        this._d = d;
    }
    Transformation.prototype = {
        // @method transform(point: Point, scale?: Number): Point
        // Returns a transformed point, optionally multiplied by the given scale.
        // Only accepts actual `L.Point` instances, not arrays.
        transform: function(point, scale) {
            return this._transform(point.clone(), scale);
        },
        // destructive transform (faster)
        _transform: function(point, scale) {
            scale = scale || 1;
            point.x = scale * (this._a * point.x + this._b);
            point.y = scale * (this._c * point.y + this._d);
            return point;
        },
        // @method untransform(point: Point, scale?: Number): Point
        // Returns the reverse transformation of the given point, optionally divided
        // by the given scale. Only accepts actual `L.Point` instances, not arrays.
        untransform: function(point, scale) {
            scale = scale || 1;
            return new Point((point.x / scale - this._b) / this._a, (point.y / scale - this._d) / this._c);
        }
    };
    // factory L.transformation(a: Number, b: Number, c: Number, d: Number)
    // @factory L.transformation(a: Number, b: Number, c: Number, d: Number)
    // Instantiates a Transformation object with the given coefficients.
    // @alternative
    // @factory L.transformation(coefficients: Array): Transformation
    // Expects an coefficients array of the form
    // `[a: Number, b: Number, c: Number, d: Number]`.
    function toTransformation(a, b, c, d) {
        return new Transformation(a, b, c, d);
    }
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG3857
   *
   * The most common CRS for online maps, used by almost all free and commercial
   * tile providers. Uses Spherical Mercator projection. Set in by default in
   * Map's `crs` option.
   */ var EPSG3857 = extend({}, Earth, {
        code: "EPSG:3857",
        projection: SphericalMercator,
        transformation: function() {
            var scale = 0.5 / (Math.PI * SphericalMercator.R);
            return toTransformation(scale, 0.5, -scale, 0.5);
        }()
    });
    var EPSG900913 = extend({}, EPSG3857, {
        code: "EPSG:900913"
    });
    // @namespace SVG; @section
    // There are several static functions which can be called without instantiating L.SVG:
    // @function create(name: String): SVGElement
    // Returns a instance of [SVGElement](https://developer.mozilla.org/docs/Web/API/SVGElement),
    // corresponding to the class name passed. For example, using 'line' will return
    // an instance of [SVGLineElement](https://developer.mozilla.org/docs/Web/API/SVGLineElement).
    function svgCreate(name) {
        return document.createElementNS("http://www.w3.org/2000/svg", name);
    }
    // @function pointsToPath(rings: Point[], closed: Boolean): String
    // Generates a SVG path string for multiple rings, with each ring turning
    // into "M..L..L.." instructions
    function pointsToPath(rings, closed) {
        var str = "", i, j, len, len2, points, p;
        for(i = 0, len = rings.length; i < len; i++){
            points = rings[i];
            for(j = 0, len2 = points.length; j < len2; j++){
                p = points[j];
                str += (j ? "L" : "M") + p.x + " " + p.y;
            }
            // closes the ring for polygons; "x" is VML syntax
            str += closed ? Browser.svg ? "z" : "x" : "";
        }
        // SVG complains about empty path strings
        return str || "M0 0";
    }
    /*
   * @namespace Browser
   * @aka L.Browser
   *
   * A namespace with static properties for browser/feature detection used by Leaflet internally.
   *
   * @example
   *
   * ```js
   * if (L.Browser.ielt9) {
   *   alert('Upgrade your browser, dude!');
   * }
   * ```
   */ var style = document.documentElement.style;
    // @property ie: Boolean; `true` for all Internet Explorer versions (not Edge).
    var ie = "ActiveXObject" in window;
    // @property ielt9: Boolean; `true` for Internet Explorer versions less than 9.
    var ielt9 = ie && !document.addEventListener;
    // @property edge: Boolean; `true` for the Edge web browser.
    var edge = "msLaunchUri" in navigator && !("documentMode" in document);
    // @property webkit: Boolean;
    // `true` for webkit-based browsers like Chrome and Safari (including mobile versions).
    var webkit = userAgentContains("webkit");
    // @property android: Boolean
    // **Deprecated.** `true` for any browser running on an Android platform.
    var android = userAgentContains("android");
    // @property android23: Boolean; **Deprecated.** `true` for browsers running on Android 2 or Android 3.
    var android23 = userAgentContains("android 2") || userAgentContains("android 3");
    /* See https://stackoverflow.com/a/17961266 for details on detecting stock Android */ var webkitVer = parseInt(/WebKit\/([0-9]+)|$/.exec(navigator.userAgent)[1], 10); // also matches AppleWebKit
    // @property androidStock: Boolean; **Deprecated.** `true` for the Android stock browser (i.e. not Chrome)
    var androidStock = android && userAgentContains("Google") && webkitVer < 537 && !("AudioNode" in window);
    // @property opera: Boolean; `true` for the Opera browser
    var opera = !!window.opera;
    // @property chrome: Boolean; `true` for the Chrome browser.
    var chrome = !edge && userAgentContains("chrome");
    // @property gecko: Boolean; `true` for gecko-based browsers like Firefox.
    var gecko = userAgentContains("gecko") && !webkit && !opera && !ie;
    // @property safari: Boolean; `true` for the Safari browser.
    var safari = !chrome && userAgentContains("safari");
    var phantom = userAgentContains("phantom");
    // @property opera12: Boolean
    // `true` for the Opera browser supporting CSS transforms (version 12 or later).
    var opera12 = "OTransition" in style;
    // @property win: Boolean; `true` when the browser is running in a Windows platform
    var win = navigator.platform.indexOf("Win") === 0;
    // @property ie3d: Boolean; `true` for all Internet Explorer versions supporting CSS transforms.
    var ie3d = ie && "transition" in style;
    // @property webkit3d: Boolean; `true` for webkit-based browsers supporting CSS transforms.
    var webkit3d = "WebKitCSSMatrix" in window && "m11" in new window.WebKitCSSMatrix() && !android23;
    // @property gecko3d: Boolean; `true` for gecko-based browsers supporting CSS transforms.
    var gecko3d = "MozPerspective" in style;
    // @property any3d: Boolean
    // `true` for all browsers supporting CSS transforms.
    var any3d = !window.L_DISABLE_3D && (ie3d || webkit3d || gecko3d) && !opera12 && !phantom;
    // @property mobile: Boolean; `true` for all browsers running in a mobile device.
    var mobile = typeof orientation !== "undefined" || userAgentContains("mobile");
    // @property mobileWebkit: Boolean; `true` for all webkit-based browsers in a mobile device.
    var mobileWebkit = mobile && webkit;
    // @property mobileWebkit3d: Boolean
    // `true` for all webkit-based browsers in a mobile device supporting CSS transforms.
    var mobileWebkit3d = mobile && webkit3d;
    // @property msPointer: Boolean
    // `true` for browsers implementing the Microsoft touch events model (notably IE10).
    var msPointer = !window.PointerEvent && window.MSPointerEvent;
    // @property pointer: Boolean
    // `true` for all browsers supporting [pointer events](https://msdn.microsoft.com/en-us/library/dn433244%28v=vs.85%29.aspx).
    var pointer = !!(window.PointerEvent || msPointer);
    // @property touchNative: Boolean
    // `true` for all browsers supporting [touch events](https://developer.mozilla.org/docs/Web/API/Touch_events).
    // **This does not necessarily mean** that the browser is running in a computer with
    // a touchscreen, it only means that the browser is capable of understanding
    // touch events.
    var touchNative = "ontouchstart" in window || !!window.TouchEvent;
    // @property touch: Boolean
    // `true` for all browsers supporting either [touch](#browser-touch) or [pointer](#browser-pointer) events.
    // Note: pointer events will be preferred (if available), and processed for all `touch*` listeners.
    var touch = !window.L_NO_TOUCH && (touchNative || pointer);
    // @property mobileOpera: Boolean; `true` for the Opera browser in a mobile device.
    var mobileOpera = mobile && opera;
    // @property mobileGecko: Boolean
    // `true` for gecko-based browsers running in a mobile device.
    var mobileGecko = mobile && gecko;
    // @property retina: Boolean
    // `true` for browsers on a high-resolution "retina" screen or on any screen when browser's display zoom is more than 100%.
    var retina = (window.devicePixelRatio || window.screen.deviceXDPI / window.screen.logicalXDPI) > 1;
    // @property passiveEvents: Boolean
    // `true` for browsers that support passive events.
    var passiveEvents = function() {
        var supportsPassiveOption = false;
        try {
            var opts = Object.defineProperty({}, "passive", {
                get: function() {
                    supportsPassiveOption = true;
                }
            });
            window.addEventListener("testPassiveEventSupport", falseFn, opts);
            window.removeEventListener("testPassiveEventSupport", falseFn, opts);
        } catch (e) {
        // Errors can safely be ignored since this is only a browser support test.
        }
        return supportsPassiveOption;
    }();
    // @property canvas: Boolean
    // `true` when the browser supports [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
    var canvas$1 = function() {
        return !!document.createElement("canvas").getContext;
    }();
    // @property svg: Boolean
    // `true` when the browser supports [SVG](https://developer.mozilla.org/docs/Web/SVG).
    var svg$1 = !!(document.createElementNS && svgCreate("svg").createSVGRect);
    var inlineSvg = !!svg$1 && function() {
        var div = document.createElement("div");
        div.innerHTML = "<svg/>";
        return (div.firstChild && div.firstChild.namespaceURI) === "http://www.w3.org/2000/svg";
    }();
    // @property vml: Boolean
    // `true` if the browser supports [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language).
    var vml = !svg$1 && function() {
        try {
            var div = document.createElement("div");
            div.innerHTML = '<v:shape adj="1"/>';
            var shape = div.firstChild;
            shape.style.behavior = "url(#default#VML)";
            return shape && typeof shape.adj === "object";
        } catch (e) {
            return false;
        }
    }();
    // @property mac: Boolean; `true` when the browser is running in a Mac platform
    var mac = navigator.platform.indexOf("Mac") === 0;
    // @property mac: Boolean; `true` when the browser is running in a Linux platform
    var linux = navigator.platform.indexOf("Linux") === 0;
    function userAgentContains(str) {
        return navigator.userAgent.toLowerCase().indexOf(str) >= 0;
    }
    var Browser = {
        ie: ie,
        ielt9: ielt9,
        edge: edge,
        webkit: webkit,
        android: android,
        android23: android23,
        androidStock: androidStock,
        opera: opera,
        chrome: chrome,
        gecko: gecko,
        safari: safari,
        phantom: phantom,
        opera12: opera12,
        win: win,
        ie3d: ie3d,
        webkit3d: webkit3d,
        gecko3d: gecko3d,
        any3d: any3d,
        mobile: mobile,
        mobileWebkit: mobileWebkit,
        mobileWebkit3d: mobileWebkit3d,
        msPointer: msPointer,
        pointer: pointer,
        touch: touch,
        touchNative: touchNative,
        mobileOpera: mobileOpera,
        mobileGecko: mobileGecko,
        retina: retina,
        passiveEvents: passiveEvents,
        canvas: canvas$1,
        svg: svg$1,
        vml: vml,
        inlineSvg: inlineSvg,
        mac: mac,
        linux: linux
    };
    /*
   * Extends L.DomEvent to provide touch support for Internet Explorer and Windows-based devices.
   */ var POINTER_DOWN = Browser.msPointer ? "MSPointerDown" : "pointerdown";
    var POINTER_MOVE = Browser.msPointer ? "MSPointerMove" : "pointermove";
    var POINTER_UP = Browser.msPointer ? "MSPointerUp" : "pointerup";
    var POINTER_CANCEL = Browser.msPointer ? "MSPointerCancel" : "pointercancel";
    var pEvent = {
        touchstart: POINTER_DOWN,
        touchmove: POINTER_MOVE,
        touchend: POINTER_UP,
        touchcancel: POINTER_CANCEL
    };
    var handle = {
        touchstart: _onPointerStart,
        touchmove: _handlePointer,
        touchend: _handlePointer,
        touchcancel: _handlePointer
    };
    var _pointers = {};
    var _pointerDocListener = false;
    // Provides a touch events wrapper for (ms)pointer events.
    // ref https://www.w3.org/TR/pointerevents/ https://www.w3.org/Bugs/Public/show_bug.cgi?id=22890
    function addPointerListener(obj, type, handler) {
        if (type === "touchstart") _addPointerDocListener();
        if (!handle[type]) {
            console.warn("wrong event specified:", type);
            return falseFn;
        }
        handler = handle[type].bind(this, handler);
        obj.addEventListener(pEvent[type], handler, false);
        return handler;
    }
    function removePointerListener(obj, type, handler) {
        if (!pEvent[type]) {
            console.warn("wrong event specified:", type);
            return;
        }
        obj.removeEventListener(pEvent[type], handler, false);
    }
    function _globalPointerDown(e) {
        _pointers[e.pointerId] = e;
    }
    function _globalPointerMove(e) {
        if (_pointers[e.pointerId]) _pointers[e.pointerId] = e;
    }
    function _globalPointerUp(e) {
        delete _pointers[e.pointerId];
    }
    function _addPointerDocListener() {
        // need to keep track of what pointers and how many are active to provide e.touches emulation
        if (!_pointerDocListener) {
            // we listen document as any drags that end by moving the touch off the screen get fired there
            document.addEventListener(POINTER_DOWN, _globalPointerDown, true);
            document.addEventListener(POINTER_MOVE, _globalPointerMove, true);
            document.addEventListener(POINTER_UP, _globalPointerUp, true);
            document.addEventListener(POINTER_CANCEL, _globalPointerUp, true);
            _pointerDocListener = true;
        }
    }
    function _handlePointer(handler, e) {
        if (e.pointerType === (e.MSPOINTER_TYPE_MOUSE || "mouse")) return;
        e.touches = [];
        for(var i in _pointers)e.touches.push(_pointers[i]);
        e.changedTouches = [
            e
        ];
        handler(e);
    }
    function _onPointerStart(handler, e) {
        // IE10 specific: MsTouch needs preventDefault. See #2000
        if (e.MSPOINTER_TYPE_TOUCH && e.pointerType === e.MSPOINTER_TYPE_TOUCH) preventDefault(e);
        _handlePointer(handler, e);
    }
    /*
   * Extends the event handling code with double tap support for mobile browsers.
   *
   * Note: currently most browsers fire native dblclick, with only a few exceptions
   * (see https://github.com/Leaflet/Leaflet/issues/7012#issuecomment-595087386)
   */ function makeDblclick(event) {
        // in modern browsers `type` cannot be just overridden:
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Getter_only
        var newEvent = {}, prop, i;
        for(i in event){
            prop = event[i];
            newEvent[i] = prop && prop.bind ? prop.bind(event) : prop;
        }
        event = newEvent;
        newEvent.type = "dblclick";
        newEvent.detail = 2;
        newEvent.isTrusted = false;
        newEvent._simulated = true; // for debug purposes
        return newEvent;
    }
    var delay = 200;
    function addDoubleTapListener(obj, handler) {
        // Most browsers handle double tap natively
        obj.addEventListener("dblclick", handler);
        // On some platforms the browser doesn't fire native dblclicks for touch events.
        // It seems that in all such cases `detail` property of `click` event is always `1`.
        // So here we rely on that fact to avoid excessive 'dblclick' simulation when not needed.
        var last = 0, detail;
        function simDblclick(e) {
            if (e.detail !== 1) {
                detail = e.detail; // keep in sync to avoid false dblclick in some cases
                return;
            }
            if (e.pointerType === "mouse" || e.sourceCapabilities && !e.sourceCapabilities.firesTouchEvents) return;
            // When clicking on an <input>, the browser generates a click on its
            // <label> (and vice versa) triggering two clicks in quick succession.
            // This ignores clicks on elements which are a label with a 'for'
            // attribute (or children of such a label), but not children of
            // a <input>.
            var path = getPropagationPath(e);
            if (path.some(function(el) {
                return el instanceof HTMLLabelElement && el.attributes.for;
            }) && !path.some(function(el) {
                return el instanceof HTMLInputElement || el instanceof HTMLSelectElement;
            })) return;
            var now = Date.now();
            if (now - last <= delay) {
                detail++;
                if (detail === 2) handler(makeDblclick(e));
            } else detail = 1;
            last = now;
        }
        obj.addEventListener("click", simDblclick);
        return {
            dblclick: handler,
            simDblclick: simDblclick
        };
    }
    function removeDoubleTapListener(obj, handlers) {
        obj.removeEventListener("dblclick", handlers.dblclick);
        obj.removeEventListener("click", handlers.simDblclick);
    }
    /*
   * @namespace DomUtil
   *
   * Utility functions to work with the [DOM](https://developer.mozilla.org/docs/Web/API/Document_Object_Model)
   * tree, used by Leaflet internally.
   *
   * Most functions expecting or returning a `HTMLElement` also work for
   * SVG elements. The only difference is that classes refer to CSS classes
   * in HTML and SVG classes in SVG.
   */ // @property TRANSFORM: String
    // Vendor-prefixed transform style name (e.g. `'webkitTransform'` for WebKit).
    var TRANSFORM = testProp([
        "transform",
        "webkitTransform",
        "OTransform",
        "MozTransform",
        "msTransform"
    ]);
    // webkitTransition comes first because some browser versions that drop vendor prefix don't do
    // the same for the transitionend event, in particular the Android 4.1 stock browser
    // @property TRANSITION: String
    // Vendor-prefixed transition style name.
    var TRANSITION = testProp([
        "webkitTransition",
        "transition",
        "OTransition",
        "MozTransition",
        "msTransition"
    ]);
    // @property TRANSITION_END: String
    // Vendor-prefixed transitionend event name.
    var TRANSITION_END = TRANSITION === "webkitTransition" || TRANSITION === "OTransition" ? TRANSITION + "End" : "transitionend";
    // @function get(id: String|HTMLElement): HTMLElement
    // Returns an element given its DOM id, or returns the element itself
    // if it was passed directly.
    function get(id) {
        return typeof id === "string" ? document.getElementById(id) : id;
    }
    // @function getStyle(el: HTMLElement, styleAttrib: String): String
    // Returns the value for a certain style attribute on an element,
    // including computed values or values set through CSS.
    function getStyle(el, style) {
        var value = el.style[style] || el.currentStyle && el.currentStyle[style];
        if ((!value || value === "auto") && document.defaultView) {
            var css = document.defaultView.getComputedStyle(el, null);
            value = css ? css[style] : null;
        }
        return value === "auto" ? null : value;
    }
    // @function create(tagName: String, className?: String, container?: HTMLElement): HTMLElement
    // Creates an HTML element with `tagName`, sets its class to `className`, and optionally appends it to `container` element.
    function create$1(tagName, className, container) {
        var el = document.createElement(tagName);
        el.className = className || "";
        if (container) container.appendChild(el);
        return el;
    }
    // @function remove(el: HTMLElement)
    // Removes `el` from its parent element
    function remove(el) {
        var parent = el.parentNode;
        if (parent) parent.removeChild(el);
    }
    // @function empty(el: HTMLElement)
    // Removes all of `el`'s children elements from `el`
    function empty(el) {
        while(el.firstChild)el.removeChild(el.firstChild);
    }
    // @function toFront(el: HTMLElement)
    // Makes `el` the last child of its parent, so it renders in front of the other children.
    function toFront(el) {
        var parent = el.parentNode;
        if (parent && parent.lastChild !== el) parent.appendChild(el);
    }
    // @function toBack(el: HTMLElement)
    // Makes `el` the first child of its parent, so it renders behind the other children.
    function toBack(el) {
        var parent = el.parentNode;
        if (parent && parent.firstChild !== el) parent.insertBefore(el, parent.firstChild);
    }
    // @function hasClass(el: HTMLElement, name: String): Boolean
    // Returns `true` if the element's class attribute contains `name`.
    function hasClass(el, name) {
        if (el.classList !== undefined) return el.classList.contains(name);
        var className = getClass(el);
        return className.length > 0 && new RegExp("(^|\\s)" + name + "(\\s|$)").test(className);
    }
    // @function addClass(el: HTMLElement, name: String)
    // Adds `name` to the element's class attribute.
    function addClass(el, name) {
        if (el.classList !== undefined) {
            var classes = splitWords(name);
            for(var i = 0, len = classes.length; i < len; i++)el.classList.add(classes[i]);
        } else if (!hasClass(el, name)) {
            var className = getClass(el);
            setClass(el, (className ? className + " " : "") + name);
        }
    }
    // @function removeClass(el: HTMLElement, name: String)
    // Removes `name` from the element's class attribute.
    function removeClass(el, name) {
        if (el.classList !== undefined) el.classList.remove(name);
        else setClass(el, trim((" " + getClass(el) + " ").replace(" " + name + " ", " ")));
    }
    // @function setClass(el: HTMLElement, name: String)
    // Sets the element's class.
    function setClass(el, name) {
        if (el.className.baseVal === undefined) el.className = name;
        else // in case of SVG element
        el.className.baseVal = name;
    }
    // @function getClass(el: HTMLElement): String
    // Returns the element's class.
    function getClass(el) {
        // Check if the element is an SVGElementInstance and use the correspondingElement instead
        // (Required for linked SVG elements in IE11.)
        if (el.correspondingElement) el = el.correspondingElement;
        return el.className.baseVal === undefined ? el.className : el.className.baseVal;
    }
    // @function setOpacity(el: HTMLElement, opacity: Number)
    // Set the opacity of an element (including old IE support).
    // `opacity` must be a number from `0` to `1`.
    function setOpacity(el, value) {
        if ("opacity" in el.style) el.style.opacity = value;
        else if ("filter" in el.style) _setOpacityIE(el, value);
    }
    function _setOpacityIE(el, value) {
        var filter = false, filterName = "DXImageTransform.Microsoft.Alpha";
        // filters collection throws an error if we try to retrieve a filter that doesn't exist
        try {
            filter = el.filters.item(filterName);
        } catch (e) {
            // don't set opacity to 1 if we haven't already set an opacity,
            // it isn't needed and breaks transparent pngs.
            if (value === 1) return;
        }
        value = Math.round(value * 100);
        if (filter) {
            filter.Enabled = value !== 100;
            filter.Opacity = value;
        } else el.style.filter += " progid:" + filterName + "(opacity=" + value + ")";
    }
    // @function testProp(props: String[]): String|false
    // Goes through the array of style names and returns the first name
    // that is a valid style name for an element. If no such name is found,
    // it returns false. Useful for vendor-prefixed styles like `transform`.
    function testProp(props) {
        var style = document.documentElement.style;
        for(var i = 0; i < props.length; i++){
            if (props[i] in style) return props[i];
        }
        return false;
    }
    // @function setTransform(el: HTMLElement, offset: Point, scale?: Number)
    // Resets the 3D CSS transform of `el` so it is translated by `offset` pixels
    // and optionally scaled by `scale`. Does not have an effect if the
    // browser doesn't support 3D CSS transforms.
    function setTransform(el, offset, scale) {
        var pos = offset || new Point(0, 0);
        el.style[TRANSFORM] = (Browser.ie3d ? "translate(" + pos.x + "px," + pos.y + "px)" : "translate3d(" + pos.x + "px," + pos.y + "px,0)") + (scale ? " scale(" + scale + ")" : "");
    }
    // @function setPosition(el: HTMLElement, position: Point)
    // Sets the position of `el` to coordinates specified by `position`,
    // using CSS translate or top/left positioning depending on the browser
    // (used by Leaflet internally to position its layers).
    function setPosition(el, point) {
        /*eslint-disable */ el._leaflet_pos = point;
        /* eslint-enable */ if (Browser.any3d) setTransform(el, point);
        else {
            el.style.left = point.x + "px";
            el.style.top = point.y + "px";
        }
    }
    // @function getPosition(el: HTMLElement): Point
    // Returns the coordinates of an element previously positioned with setPosition.
    function getPosition(el) {
        // this method is only used for elements previously positioned using setPosition,
        // so it's safe to cache the position for performance
        return el._leaflet_pos || new Point(0, 0);
    }
    // @function disableTextSelection()
    // Prevents the user from generating `selectstart` DOM events, usually generated
    // when the user drags the mouse through a page with text. Used internally
    // by Leaflet to override the behaviour of any click-and-drag interaction on
    // the map. Affects drag interactions on the whole document.
    // @function enableTextSelection()
    // Cancels the effects of a previous [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection).
    var disableTextSelection;
    var enableTextSelection;
    var _userSelect;
    if ("onselectstart" in document) {
        disableTextSelection = function() {
            on(window, "selectstart", preventDefault);
        };
        enableTextSelection = function() {
            off(window, "selectstart", preventDefault);
        };
    } else {
        var userSelectProperty = testProp([
            "userSelect",
            "WebkitUserSelect",
            "OUserSelect",
            "MozUserSelect",
            "msUserSelect"
        ]);
        disableTextSelection = function() {
            if (userSelectProperty) {
                var style = document.documentElement.style;
                _userSelect = style[userSelectProperty];
                style[userSelectProperty] = "none";
            }
        };
        enableTextSelection = function() {
            if (userSelectProperty) {
                document.documentElement.style[userSelectProperty] = _userSelect;
                _userSelect = undefined;
            }
        };
    }
    // @function disableImageDrag()
    // As [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection), but
    // for `dragstart` DOM events, usually generated when the user drags an image.
    function disableImageDrag() {
        on(window, "dragstart", preventDefault);
    }
    // @function enableImageDrag()
    // Cancels the effects of a previous [`L.DomUtil.disableImageDrag`](#domutil-disabletextselection).
    function enableImageDrag() {
        off(window, "dragstart", preventDefault);
    }
    var _outlineElement, _outlineStyle;
    // @function preventOutline(el: HTMLElement)
    // Makes the [outline](https://developer.mozilla.org/docs/Web/CSS/outline)
    // of the element `el` invisible. Used internally by Leaflet to prevent
    // focusable elements from displaying an outline when the user performs a
    // drag interaction on them.
    function preventOutline(element) {
        while(element.tabIndex === -1)element = element.parentNode;
        if (!element.style) return;
        restoreOutline();
        _outlineElement = element;
        _outlineStyle = element.style.outlineStyle;
        element.style.outlineStyle = "none";
        on(window, "keydown", restoreOutline);
    }
    // @function restoreOutline()
    // Cancels the effects of a previous [`L.DomUtil.preventOutline`]().
    function restoreOutline() {
        if (!_outlineElement) return;
        _outlineElement.style.outlineStyle = _outlineStyle;
        _outlineElement = undefined;
        _outlineStyle = undefined;
        off(window, "keydown", restoreOutline);
    }
    // @function getSizedParentNode(el: HTMLElement): HTMLElement
    // Finds the closest parent node which size (width and height) is not null.
    function getSizedParentNode(element) {
        do element = element.parentNode;
        while ((!element.offsetWidth || !element.offsetHeight) && element !== document.body);
        return element;
    }
    // @function getScale(el: HTMLElement): Object
    // Computes the CSS scale currently applied on the element.
    // Returns an object with `x` and `y` members as horizontal and vertical scales respectively,
    // and `boundingClientRect` as the result of [`getBoundingClientRect()`](https://developer.mozilla.org/en-US/docs/Web/API/Element/getBoundingClientRect).
    function getScale(element) {
        var rect = element.getBoundingClientRect(); // Read-only in old browsers.
        return {
            x: rect.width / element.offsetWidth || 1,
            y: rect.height / element.offsetHeight || 1,
            boundingClientRect: rect
        };
    }
    var DomUtil = {
        __proto__: null,
        TRANSFORM: TRANSFORM,
        TRANSITION: TRANSITION,
        TRANSITION_END: TRANSITION_END,
        get: get,
        getStyle: getStyle,
        create: create$1,
        remove: remove,
        empty: empty,
        toFront: toFront,
        toBack: toBack,
        hasClass: hasClass,
        addClass: addClass,
        removeClass: removeClass,
        setClass: setClass,
        getClass: getClass,
        setOpacity: setOpacity,
        testProp: testProp,
        setTransform: setTransform,
        setPosition: setPosition,
        getPosition: getPosition,
        get disableTextSelection () {
            return disableTextSelection;
        },
        get enableTextSelection () {
            return enableTextSelection;
        },
        disableImageDrag: disableImageDrag,
        enableImageDrag: enableImageDrag,
        preventOutline: preventOutline,
        restoreOutline: restoreOutline,
        getSizedParentNode: getSizedParentNode,
        getScale: getScale
    };
    /*
   * @namespace DomEvent
   * Utility functions to work with the [DOM events](https://developer.mozilla.org/docs/Web/API/Event), used by Leaflet internally.
   */ // Inspired by John Resig, Dean Edwards and YUI addEvent implementations.
    // @function on(el: HTMLElement, types: String, fn: Function, context?: Object): this
    // Adds a listener function (`fn`) to a particular DOM event type of the
    // element `el`. You can optionally specify the context of the listener
    // (object the `this` keyword will point to). You can also pass several
    // space-separated types (e.g. `'click dblclick'`).
    // @alternative
    // @function on(el: HTMLElement, eventMap: Object, context?: Object): this
    // Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
    function on(obj, types, fn, context) {
        if (types && typeof types === "object") for(var type in types)addOne(obj, type, types[type], fn);
        else {
            types = splitWords(types);
            for(var i = 0, len = types.length; i < len; i++)addOne(obj, types[i], fn, context);
        }
        return this;
    }
    var eventsKey = "_leaflet_events";
    // @function off(el: HTMLElement, types: String, fn: Function, context?: Object): this
    // Removes a previously added listener function.
    // Note that if you passed a custom context to on, you must pass the same
    // context to `off` in order to remove the listener.
    // @alternative
    // @function off(el: HTMLElement, eventMap: Object, context?: Object): this
    // Removes a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
    // @alternative
    // @function off(el: HTMLElement, types: String): this
    // Removes all previously added listeners of given types.
    // @alternative
    // @function off(el: HTMLElement): this
    // Removes all previously added listeners from given HTMLElement
    function off(obj, types, fn, context) {
        if (arguments.length === 1) {
            batchRemove(obj);
            delete obj[eventsKey];
        } else if (types && typeof types === "object") for(var type in types)removeOne(obj, type, types[type], fn);
        else {
            types = splitWords(types);
            if (arguments.length === 2) batchRemove(obj, function(type) {
                return indexOf(types, type) !== -1;
            });
            else for(var i = 0, len = types.length; i < len; i++)removeOne(obj, types[i], fn, context);
        }
        return this;
    }
    function batchRemove(obj, filterFn) {
        for(var id in obj[eventsKey]){
            var type = id.split(/\d/)[0];
            if (!filterFn || filterFn(type)) removeOne(obj, type, null, null, id);
        }
    }
    var mouseSubst = {
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        wheel: !("onwheel" in window) && "mousewheel"
    };
    function addOne(obj, type, fn, context) {
        var id = type + stamp(fn) + (context ? "_" + stamp(context) : "");
        if (obj[eventsKey] && obj[eventsKey][id]) return this;
        var handler = function(e) {
            return fn.call(context || obj, e || window.event);
        };
        var originalHandler = handler;
        if (!Browser.touchNative && Browser.pointer && type.indexOf("touch") === 0) // Needs DomEvent.Pointer.js
        handler = addPointerListener(obj, type, handler);
        else if (Browser.touch && type === "dblclick") handler = addDoubleTapListener(obj, handler);
        else if ("addEventListener" in obj) {
            if (type === "touchstart" || type === "touchmove" || type === "wheel" || type === "mousewheel") obj.addEventListener(mouseSubst[type] || type, handler, Browser.passiveEvents ? {
                passive: false
            } : false);
            else if (type === "mouseenter" || type === "mouseleave") {
                handler = function(e) {
                    e = e || window.event;
                    if (isExternalTarget(obj, e)) originalHandler(e);
                };
                obj.addEventListener(mouseSubst[type], handler, false);
            } else obj.addEventListener(type, originalHandler, false);
        } else obj.attachEvent("on" + type, handler);
        obj[eventsKey] = obj[eventsKey] || {};
        obj[eventsKey][id] = handler;
    }
    function removeOne(obj, type, fn, context, id) {
        id = id || type + stamp(fn) + (context ? "_" + stamp(context) : "");
        var handler = obj[eventsKey] && obj[eventsKey][id];
        if (!handler) return this;
        if (!Browser.touchNative && Browser.pointer && type.indexOf("touch") === 0) removePointerListener(obj, type, handler);
        else if (Browser.touch && type === "dblclick") removeDoubleTapListener(obj, handler);
        else if ("removeEventListener" in obj) obj.removeEventListener(mouseSubst[type] || type, handler, false);
        else obj.detachEvent("on" + type, handler);
        obj[eventsKey][id] = null;
    }
    // @function stopPropagation(ev: DOMEvent): this
    // Stop the given event from propagation to parent elements. Used inside the listener functions:
    // ```js
    // L.DomEvent.on(div, 'click', function (ev) {
    // 	L.DomEvent.stopPropagation(ev);
    // });
    // ```
    function stopPropagation(e) {
        if (e.stopPropagation) e.stopPropagation();
        else if (e.originalEvent) e.originalEvent._stopped = true;
        else e.cancelBubble = true;
        return this;
    }
    // @function disableScrollPropagation(el: HTMLElement): this
    // Adds `stopPropagation` to the element's `'wheel'` events (plus browser variants).
    function disableScrollPropagation(el) {
        addOne(el, "wheel", stopPropagation);
        return this;
    }
    // @function disableClickPropagation(el: HTMLElement): this
    // Adds `stopPropagation` to the element's `'click'`, `'dblclick'`, `'contextmenu'`,
    // `'mousedown'` and `'touchstart'` events (plus browser variants).
    function disableClickPropagation(el) {
        on(el, "mousedown touchstart dblclick contextmenu", stopPropagation);
        el["_leaflet_disable_click"] = true;
        return this;
    }
    // @function preventDefault(ev: DOMEvent): this
    // Prevents the default action of the DOM Event `ev` from happening (such as
    // following a link in the href of the a element, or doing a POST request
    // with page reload when a `<form>` is submitted).
    // Use it inside listener functions.
    function preventDefault(e) {
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        return this;
    }
    // @function stop(ev: DOMEvent): this
    // Does `stopPropagation` and `preventDefault` at the same time.
    function stop(e) {
        preventDefault(e);
        stopPropagation(e);
        return this;
    }
    // @function getPropagationPath(ev: DOMEvent): Array
    // Compatibility polyfill for [`Event.composedPath()`](https://developer.mozilla.org/en-US/docs/Web/API/Event/composedPath).
    // Returns an array containing the `HTMLElement`s that the given DOM event
    // should propagate to (if not stopped).
    function getPropagationPath(ev) {
        if (ev.composedPath) return ev.composedPath();
        var path = [];
        var el = ev.target;
        while(el){
            path.push(el);
            el = el.parentNode;
        }
        return path;
    }
    // @function getMousePosition(ev: DOMEvent, container?: HTMLElement): Point
    // Gets normalized mouse position from a DOM event relative to the
    // `container` (border excluded) or to the whole page if not specified.
    function getMousePosition(e, container) {
        if (!container) return new Point(e.clientX, e.clientY);
        var scale = getScale(container), offset = scale.boundingClientRect; // left and top  values are in page scale (like the event clientX/Y)
        return new Point(// offset.left/top values are in page scale (like clientX/Y),
        // whereas clientLeft/Top (border width) values are the original values (before CSS scale applies).
        (e.clientX - offset.left) / scale.x - container.clientLeft, (e.clientY - offset.top) / scale.y - container.clientTop);
    }
    //  except , Safari and
    // We need double the scroll pixels (see #7403 and #4538) for all Browsers
    // except OSX (Mac) -> 3x, Chrome running on Linux 1x
    var wheelPxFactor = Browser.linux && Browser.chrome ? window.devicePixelRatio : Browser.mac ? window.devicePixelRatio * 3 : window.devicePixelRatio > 0 ? 2 * window.devicePixelRatio : 1;
    // @function getWheelDelta(ev: DOMEvent): Number
    // Gets normalized wheel delta from a wheel DOM event, in vertical
    // pixels scrolled (negative if scrolling down).
    // Events from pointing devices without precise scrolling are mapped to
    // a best guess of 60 pixels.
    function getWheelDelta(e) {
        return Browser.edge ? e.wheelDeltaY / 2 : e.deltaY && e.deltaMode === 0 ? -e.deltaY / wheelPxFactor : e.deltaY && e.deltaMode === 1 ? -e.deltaY * 20 : e.deltaY && e.deltaMode === 2 ? -e.deltaY * 60 : e.deltaX || e.deltaZ ? 0 : e.wheelDelta ? (e.wheelDeltaY || e.wheelDelta) / 2 : e.detail && Math.abs(e.detail) < 32765 ? -e.detail * 20 : e.detail ? e.detail / -32765 * 60 : 0;
    }
    // check if element really left/entered the event target (for mouseenter/mouseleave)
    function isExternalTarget(el, e) {
        var related = e.relatedTarget;
        if (!related) return true;
        try {
            while(related && related !== el)related = related.parentNode;
        } catch (err) {
            return false;
        }
        return related !== el;
    }
    var DomEvent = {
        __proto__: null,
        on: on,
        off: off,
        stopPropagation: stopPropagation,
        disableScrollPropagation: disableScrollPropagation,
        disableClickPropagation: disableClickPropagation,
        preventDefault: preventDefault,
        stop: stop,
        getPropagationPath: getPropagationPath,
        getMousePosition: getMousePosition,
        getWheelDelta: getWheelDelta,
        isExternalTarget: isExternalTarget,
        addListener: on,
        removeListener: off
    };
    /*
   * @class PosAnimation
   * @aka L.PosAnimation
   * @inherits Evented
   * Used internally for panning animations, utilizing CSS3 Transitions for modern browsers and a timer fallback for IE6-9.
   *
   * @example
   * ```js
   * var myPositionMarker = L.marker([48.864716, 2.294694]).addTo(map);
   *
   * myPositionMarker.on("click", function() {
   * 	var pos = map.latLngToLayerPoint(myPositionMarker.getLatLng());
   * 	pos.y -= 25;
   * 	var fx = new L.PosAnimation();
   *
   * 	fx.once('end',function() {
   * 		pos.y += 25;
   * 		fx.run(myPositionMarker._icon, pos, 0.8);
   * 	});
   *
   * 	fx.run(myPositionMarker._icon, pos, 0.3);
   * });
   *
   * ```
   *
   * @constructor L.PosAnimation()
   * Creates a `PosAnimation` object.
   *
   */ var PosAnimation = Evented.extend({
        // @method run(el: HTMLElement, newPos: Point, duration?: Number, easeLinearity?: Number)
        // Run an animation of a given element to a new position, optionally setting
        // duration in seconds (`0.25` by default) and easing linearity factor (3rd
        // argument of the [cubic bezier curve](https://cubic-bezier.com/#0,0,.5,1),
        // `0.5` by default).
        run: function(el, newPos, duration, easeLinearity) {
            this.stop();
            this._el = el;
            this._inProgress = true;
            this._duration = duration || 0.25;
            this._easeOutPower = 1 / Math.max(easeLinearity || 0.5, 0.2);
            this._startPos = getPosition(el);
            this._offset = newPos.subtract(this._startPos);
            this._startTime = +new Date();
            // @event start: Event
            // Fired when the animation starts
            this.fire("start");
            this._animate();
        },
        // @method stop()
        // Stops the animation (if currently running).
        stop: function() {
            if (!this._inProgress) return;
            this._step(true);
            this._complete();
        },
        _animate: function() {
            // animation loop
            this._animId = requestAnimFrame(this._animate, this);
            this._step();
        },
        _step: function(round) {
            var elapsed = +new Date() - this._startTime, duration = this._duration * 1000;
            if (elapsed < duration) this._runFrame(this._easeOut(elapsed / duration), round);
            else {
                this._runFrame(1);
                this._complete();
            }
        },
        _runFrame: function(progress, round) {
            var pos = this._startPos.add(this._offset.multiplyBy(progress));
            if (round) pos._round();
            setPosition(this._el, pos);
            // @event step: Event
            // Fired continuously during the animation.
            this.fire("step");
        },
        _complete: function() {
            cancelAnimFrame(this._animId);
            this._inProgress = false;
            // @event end: Event
            // Fired when the animation ends.
            this.fire("end");
        },
        _easeOut: function(t) {
            return 1 - Math.pow(1 - t, this._easeOutPower);
        }
    });
    /*
   * @class Map
   * @aka L.Map
   * @inherits Evented
   *
   * The central class of the API — it is used to create a map on a page and manipulate it.
   *
   * @example
   *
   * ```js
   * // initialize the map on the "map" div with a given center and zoom
   * var map = L.map('map', {
   * 	center: [51.505, -0.09],
   * 	zoom: 13
   * });
   * ```
   *
   */ var Map = Evented.extend({
        options: {
            // @section Map State Options
            // @option crs: CRS = L.CRS.EPSG3857
            // The [Coordinate Reference System](#crs) to use. Don't change this if you're not
            // sure what it means.
            crs: EPSG3857,
            // @option center: LatLng = undefined
            // Initial geographic center of the map
            center: undefined,
            // @option zoom: Number = undefined
            // Initial map zoom level
            zoom: undefined,
            // @option minZoom: Number = *
            // Minimum zoom level of the map.
            // If not specified and at least one `GridLayer` or `TileLayer` is in the map,
            // the lowest of their `minZoom` options will be used instead.
            minZoom: undefined,
            // @option maxZoom: Number = *
            // Maximum zoom level of the map.
            // If not specified and at least one `GridLayer` or `TileLayer` is in the map,
            // the highest of their `maxZoom` options will be used instead.
            maxZoom: undefined,
            // @option layers: Layer[] = []
            // Array of layers that will be added to the map initially
            layers: [],
            // @option maxBounds: LatLngBounds = null
            // When this option is set, the map restricts the view to the given
            // geographical bounds, bouncing the user back if the user tries to pan
            // outside the view. To set the restriction dynamically, use
            // [`setMaxBounds`](#map-setmaxbounds) method.
            maxBounds: undefined,
            // @option renderer: Renderer = *
            // The default method for drawing vector layers on the map. `L.SVG`
            // or `L.Canvas` by default depending on browser support.
            renderer: undefined,
            // @section Animation Options
            // @option zoomAnimation: Boolean = true
            // Whether the map zoom animation is enabled. By default it's enabled
            // in all browsers that support CSS3 Transitions except Android.
            zoomAnimation: true,
            // @option zoomAnimationThreshold: Number = 4
            // Won't animate zoom if the zoom difference exceeds this value.
            zoomAnimationThreshold: 4,
            // @option fadeAnimation: Boolean = true
            // Whether the tile fade animation is enabled. By default it's enabled
            // in all browsers that support CSS3 Transitions except Android.
            fadeAnimation: true,
            // @option markerZoomAnimation: Boolean = true
            // Whether markers animate their zoom with the zoom animation, if disabled
            // they will disappear for the length of the animation. By default it's
            // enabled in all browsers that support CSS3 Transitions except Android.
            markerZoomAnimation: true,
            // @option transform3DLimit: Number = 2^23
            // Defines the maximum size of a CSS translation transform. The default
            // value should not be changed unless a web browser positions layers in
            // the wrong place after doing a large `panBy`.
            transform3DLimit: 8388608,
            // @section Interaction Options
            // @option zoomSnap: Number = 1
            // Forces the map's zoom level to always be a multiple of this, particularly
            // right after a [`fitBounds()`](#map-fitbounds) or a pinch-zoom.
            // By default, the zoom level snaps to the nearest integer; lower values
            // (e.g. `0.5` or `0.1`) allow for greater granularity. A value of `0`
            // means the zoom level will not be snapped after `fitBounds` or a pinch-zoom.
            zoomSnap: 1,
            // @option zoomDelta: Number = 1
            // Controls how much the map's zoom level will change after a
            // [`zoomIn()`](#map-zoomin), [`zoomOut()`](#map-zoomout), pressing `+`
            // or `-` on the keyboard, or using the [zoom controls](#control-zoom).
            // Values smaller than `1` (e.g. `0.5`) allow for greater granularity.
            zoomDelta: 1,
            // @option trackResize: Boolean = true
            // Whether the map automatically handles browser window resize to update itself.
            trackResize: true
        },
        initialize: function(id, options) {
            options = setOptions(this, options);
            // Make sure to assign internal flags at the beginning,
            // to avoid inconsistent state in some edge cases.
            this._handlers = [];
            this._layers = {};
            this._zoomBoundLayers = {};
            this._sizeChanged = true;
            this._initContainer(id);
            this._initLayout();
            // hack for https://github.com/Leaflet/Leaflet/issues/1980
            this._onResize = bind(this._onResize, this);
            this._initEvents();
            if (options.maxBounds) this.setMaxBounds(options.maxBounds);
            if (options.zoom !== undefined) this._zoom = this._limitZoom(options.zoom);
            if (options.center && options.zoom !== undefined) this.setView(toLatLng(options.center), options.zoom, {
                reset: true
            });
            this.callInitHooks();
            // don't animate on browsers without hardware-accelerated transitions or old Android/Opera
            this._zoomAnimated = TRANSITION && Browser.any3d && !Browser.mobileOpera && this.options.zoomAnimation;
            // zoom transitions run with the same duration for all layers, so if one of transitionend events
            // happens after starting zoom animation (propagating to the map pane), we know that it ended globally
            if (this._zoomAnimated) {
                this._createAnimProxy();
                on(this._proxy, TRANSITION_END, this._catchTransitionEnd, this);
            }
            this._addLayers(this.options.layers);
        },
        // @section Methods for modifying map state
        // @method setView(center: LatLng, zoom: Number, options?: Zoom/pan options): this
        // Sets the view of the map (geographical center and zoom) with the given
        // animation options.
        setView: function(center, zoom, options) {
            zoom = zoom === undefined ? this._zoom : this._limitZoom(zoom);
            center = this._limitCenter(toLatLng(center), zoom, this.options.maxBounds);
            options = options || {};
            this._stop();
            if (this._loaded && !options.reset && options !== true) {
                if (options.animate !== undefined) {
                    options.zoom = extend({
                        animate: options.animate
                    }, options.zoom);
                    options.pan = extend({
                        animate: options.animate,
                        duration: options.duration
                    }, options.pan);
                }
                // try animating pan or zoom
                var moved = this._zoom !== zoom ? this._tryAnimatedZoom && this._tryAnimatedZoom(center, zoom, options.zoom) : this._tryAnimatedPan(center, options.pan);
                if (moved) {
                    // prevent resize handler call, the view will refresh after animation anyway
                    clearTimeout(this._sizeTimer);
                    return this;
                }
            }
            // animation didn't start, just reset the map view
            this._resetView(center, zoom, options.pan && options.pan.noMoveStart);
            return this;
        },
        // @method setZoom(zoom: Number, options?: Zoom/pan options): this
        // Sets the zoom of the map.
        setZoom: function(zoom, options) {
            if (!this._loaded) {
                this._zoom = zoom;
                return this;
            }
            return this.setView(this.getCenter(), zoom, {
                zoom: options
            });
        },
        // @method zoomIn(delta?: Number, options?: Zoom options): this
        // Increases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
        zoomIn: function(delta, options) {
            delta = delta || (Browser.any3d ? this.options.zoomDelta : 1);
            return this.setZoom(this._zoom + delta, options);
        },
        // @method zoomOut(delta?: Number, options?: Zoom options): this
        // Decreases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
        zoomOut: function(delta, options) {
            delta = delta || (Browser.any3d ? this.options.zoomDelta : 1);
            return this.setZoom(this._zoom - delta, options);
        },
        // @method setZoomAround(latlng: LatLng, zoom: Number, options: Zoom options): this
        // Zooms the map while keeping a specified geographical point on the map
        // stationary (e.g. used internally for scroll zoom and double-click zoom).
        // @alternative
        // @method setZoomAround(offset: Point, zoom: Number, options: Zoom options): this
        // Zooms the map while keeping a specified pixel on the map (relative to the top-left corner) stationary.
        setZoomAround: function(latlng, zoom, options) {
            var scale = this.getZoomScale(zoom), viewHalf = this.getSize().divideBy(2), containerPoint = latlng instanceof Point ? latlng : this.latLngToContainerPoint(latlng), centerOffset = containerPoint.subtract(viewHalf).multiplyBy(1 - 1 / scale), newCenter = this.containerPointToLatLng(viewHalf.add(centerOffset));
            return this.setView(newCenter, zoom, {
                zoom: options
            });
        },
        _getBoundsCenterZoom: function(bounds, options) {
            options = options || {};
            bounds = bounds.getBounds ? bounds.getBounds() : toLatLngBounds(bounds);
            var paddingTL = toPoint(options.paddingTopLeft || options.padding || [
                0,
                0
            ]), paddingBR = toPoint(options.paddingBottomRight || options.padding || [
                0,
                0
            ]), zoom = this.getBoundsZoom(bounds, false, paddingTL.add(paddingBR));
            zoom = typeof options.maxZoom === "number" ? Math.min(options.maxZoom, zoom) : zoom;
            if (zoom === Infinity) return {
                center: bounds.getCenter(),
                zoom: zoom
            };
            var paddingOffset = paddingBR.subtract(paddingTL).divideBy(2), swPoint = this.project(bounds.getSouthWest(), zoom), nePoint = this.project(bounds.getNorthEast(), zoom), center = this.unproject(swPoint.add(nePoint).divideBy(2).add(paddingOffset), zoom);
            return {
                center: center,
                zoom: zoom
            };
        },
        // @method fitBounds(bounds: LatLngBounds, options?: fitBounds options): this
        // Sets a map view that contains the given geographical bounds with the
        // maximum zoom level possible.
        fitBounds: function(bounds, options) {
            bounds = toLatLngBounds(bounds);
            if (!bounds.isValid()) throw new Error("Bounds are not valid.");
            var target = this._getBoundsCenterZoom(bounds, options);
            return this.setView(target.center, target.zoom, options);
        },
        // @method fitWorld(options?: fitBounds options): this
        // Sets a map view that mostly contains the whole world with the maximum
        // zoom level possible.
        fitWorld: function(options) {
            return this.fitBounds([
                [
                    -90,
                    -180
                ],
                [
                    90,
                    180
                ]
            ], options);
        },
        // @method panTo(latlng: LatLng, options?: Pan options): this
        // Pans the map to a given center.
        panTo: function(center, options) {
            return this.setView(center, this._zoom, {
                pan: options
            });
        },
        // @method panBy(offset: Point, options?: Pan options): this
        // Pans the map by a given number of pixels (animated).
        panBy: function(offset, options) {
            offset = toPoint(offset).round();
            options = options || {};
            if (!offset.x && !offset.y) return this.fire("moveend");
            // If we pan too far, Chrome gets issues with tiles
            // and makes them disappear or appear in the wrong place (slightly offset) #2602
            if (options.animate !== true && !this.getSize().contains(offset)) {
                this._resetView(this.unproject(this.project(this.getCenter()).add(offset)), this.getZoom());
                return this;
            }
            if (!this._panAnim) {
                this._panAnim = new PosAnimation();
                this._panAnim.on({
                    "step": this._onPanTransitionStep,
                    "end": this._onPanTransitionEnd
                }, this);
            }
            // don't fire movestart if animating inertia
            if (!options.noMoveStart) this.fire("movestart");
            // animate pan unless animate: false specified
            if (options.animate !== false) {
                addClass(this._mapPane, "leaflet-pan-anim");
                var newPos = this._getMapPanePos().subtract(offset).round();
                this._panAnim.run(this._mapPane, newPos, options.duration || 0.25, options.easeLinearity);
            } else {
                this._rawPanBy(offset);
                this.fire("move").fire("moveend");
            }
            return this;
        },
        // @method flyTo(latlng: LatLng, zoom?: Number, options?: Zoom/pan options): this
        // Sets the view of the map (geographical center and zoom) performing a smooth
        // pan-zoom animation.
        flyTo: function(targetCenter, targetZoom, options) {
            options = options || {};
            if (options.animate === false || !Browser.any3d) return this.setView(targetCenter, targetZoom, options);
            this._stop();
            var from = this.project(this.getCenter()), to = this.project(targetCenter), size = this.getSize(), startZoom = this._zoom;
            targetCenter = toLatLng(targetCenter);
            targetZoom = targetZoom === undefined ? startZoom : targetZoom;
            var w0 = Math.max(size.x, size.y), w1 = w0 * this.getZoomScale(startZoom, targetZoom), u1 = to.distanceTo(from) || 1, rho = 1.42, rho2 = rho * rho;
            function r(i) {
                var s1 = i ? -1 : 1, s2 = i ? w1 : w0, t1 = w1 * w1 - w0 * w0 + s1 * rho2 * rho2 * u1 * u1, b1 = 2 * s2 * rho2 * u1, b = t1 / b1, sq = Math.sqrt(b * b + 1) - b;
                // workaround for floating point precision bug when sq = 0, log = -Infinite,
                // thus triggering an infinite loop in flyTo
                var log = sq < 0.000000001 ? -18 : Math.log(sq);
                return log;
            }
            function sinh(n) {
                return (Math.exp(n) - Math.exp(-n)) / 2;
            }
            function cosh(n) {
                return (Math.exp(n) + Math.exp(-n)) / 2;
            }
            function tanh(n) {
                return sinh(n) / cosh(n);
            }
            var r0 = r(0);
            function w(s) {
                return w0 * (cosh(r0) / cosh(r0 + rho * s));
            }
            function u(s) {
                return w0 * (cosh(r0) * tanh(r0 + rho * s) - sinh(r0)) / rho2;
            }
            function easeOut(t) {
                return 1 - Math.pow(1 - t, 1.5);
            }
            var start = Date.now(), S = (r(1) - r0) / rho, duration = options.duration ? 1000 * options.duration : 1000 * S * 0.8;
            function frame() {
                var t = (Date.now() - start) / duration, s = easeOut(t) * S;
                if (t <= 1) {
                    this._flyToFrame = requestAnimFrame(frame, this);
                    this._move(this.unproject(from.add(to.subtract(from).multiplyBy(u(s) / u1)), startZoom), this.getScaleZoom(w0 / w(s), startZoom), {
                        flyTo: true
                    });
                } else this._move(targetCenter, targetZoom)._moveEnd(true);
            }
            this._moveStart(true, options.noMoveStart);
            frame.call(this);
            return this;
        },
        // @method flyToBounds(bounds: LatLngBounds, options?: fitBounds options): this
        // Sets the view of the map with a smooth animation like [`flyTo`](#map-flyto),
        // but takes a bounds parameter like [`fitBounds`](#map-fitbounds).
        flyToBounds: function(bounds, options) {
            var target = this._getBoundsCenterZoom(bounds, options);
            return this.flyTo(target.center, target.zoom, options);
        },
        // @method setMaxBounds(bounds: LatLngBounds): this
        // Restricts the map view to the given bounds (see the [maxBounds](#map-maxbounds) option).
        setMaxBounds: function(bounds) {
            bounds = toLatLngBounds(bounds);
            if (this.listens("moveend", this._panInsideMaxBounds)) this.off("moveend", this._panInsideMaxBounds);
            if (!bounds.isValid()) {
                this.options.maxBounds = null;
                return this;
            }
            this.options.maxBounds = bounds;
            if (this._loaded) this._panInsideMaxBounds();
            return this.on("moveend", this._panInsideMaxBounds);
        },
        // @method setMinZoom(zoom: Number): this
        // Sets the lower limit for the available zoom levels (see the [minZoom](#map-minzoom) option).
        setMinZoom: function(zoom) {
            var oldZoom = this.options.minZoom;
            this.options.minZoom = zoom;
            if (this._loaded && oldZoom !== zoom) {
                this.fire("zoomlevelschange");
                if (this.getZoom() < this.options.minZoom) return this.setZoom(zoom);
            }
            return this;
        },
        // @method setMaxZoom(zoom: Number): this
        // Sets the upper limit for the available zoom levels (see the [maxZoom](#map-maxzoom) option).
        setMaxZoom: function(zoom) {
            var oldZoom = this.options.maxZoom;
            this.options.maxZoom = zoom;
            if (this._loaded && oldZoom !== zoom) {
                this.fire("zoomlevelschange");
                if (this.getZoom() > this.options.maxZoom) return this.setZoom(zoom);
            }
            return this;
        },
        // @method panInsideBounds(bounds: LatLngBounds, options?: Pan options): this
        // Pans the map to the closest view that would lie inside the given bounds (if it's not already), controlling the animation using the options specific, if any.
        panInsideBounds: function(bounds, options) {
            this._enforcingBounds = true;
            var center = this.getCenter(), newCenter = this._limitCenter(center, this._zoom, toLatLngBounds(bounds));
            if (!center.equals(newCenter)) this.panTo(newCenter, options);
            this._enforcingBounds = false;
            return this;
        },
        // @method panInside(latlng: LatLng, options?: padding options): this
        // Pans the map the minimum amount to make the `latlng` visible. Use
        // padding options to fit the display to more restricted bounds.
        // If `latlng` is already within the (optionally padded) display bounds,
        // the map will not be panned.
        panInside: function(latlng, options) {
            options = options || {};
            var paddingTL = toPoint(options.paddingTopLeft || options.padding || [
                0,
                0
            ]), paddingBR = toPoint(options.paddingBottomRight || options.padding || [
                0,
                0
            ]), pixelCenter = this.project(this.getCenter()), pixelPoint = this.project(latlng), pixelBounds = this.getPixelBounds(), paddedBounds = toBounds([
                pixelBounds.min.add(paddingTL),
                pixelBounds.max.subtract(paddingBR)
            ]), paddedSize = paddedBounds.getSize();
            if (!paddedBounds.contains(pixelPoint)) {
                this._enforcingBounds = true;
                var centerOffset = pixelPoint.subtract(paddedBounds.getCenter());
                var offset = paddedBounds.extend(pixelPoint).getSize().subtract(paddedSize);
                pixelCenter.x += centerOffset.x < 0 ? -offset.x : offset.x;
                pixelCenter.y += centerOffset.y < 0 ? -offset.y : offset.y;
                this.panTo(this.unproject(pixelCenter), options);
                this._enforcingBounds = false;
            }
            return this;
        },
        // @method invalidateSize(options: Zoom/pan options): this
        // Checks if the map container size changed and updates the map if so —
        // call it after you've changed the map size dynamically, also animating
        // pan by default. If `options.pan` is `false`, panning will not occur.
        // If `options.debounceMoveend` is `true`, it will delay `moveend` event so
        // that it doesn't happen often even if the method is called many
        // times in a row.
        // @alternative
        // @method invalidateSize(animate: Boolean): this
        // Checks if the map container size changed and updates the map if so —
        // call it after you've changed the map size dynamically, also animating
        // pan by default.
        invalidateSize: function(options) {
            if (!this._loaded) return this;
            options = extend({
                animate: false,
                pan: true
            }, options === true ? {
                animate: true
            } : options);
            var oldSize = this.getSize();
            this._sizeChanged = true;
            this._lastCenter = null;
            var newSize = this.getSize(), oldCenter = oldSize.divideBy(2).round(), newCenter = newSize.divideBy(2).round(), offset = oldCenter.subtract(newCenter);
            if (!offset.x && !offset.y) return this;
            if (options.animate && options.pan) this.panBy(offset);
            else {
                if (options.pan) this._rawPanBy(offset);
                this.fire("move");
                if (options.debounceMoveend) {
                    clearTimeout(this._sizeTimer);
                    this._sizeTimer = setTimeout(bind(this.fire, this, "moveend"), 200);
                } else this.fire("moveend");
            }
            // @section Map state change events
            // @event resize: ResizeEvent
            // Fired when the map is resized.
            return this.fire("resize", {
                oldSize: oldSize,
                newSize: newSize
            });
        },
        // @section Methods for modifying map state
        // @method stop(): this
        // Stops the currently running `panTo` or `flyTo` animation, if any.
        stop: function() {
            this.setZoom(this._limitZoom(this._zoom));
            if (!this.options.zoomSnap) this.fire("viewreset");
            return this._stop();
        },
        // @section Geolocation methods
        // @method locate(options?: Locate options): this
        // Tries to locate the user using the Geolocation API, firing a [`locationfound`](#map-locationfound)
        // event with location data on success or a [`locationerror`](#map-locationerror) event on failure,
        // and optionally sets the map view to the user's location with respect to
        // detection accuracy (or to the world view if geolocation failed).
        // Note that, if your page doesn't use HTTPS, this method will fail in
        // modern browsers ([Chrome 50 and newer](https://sites.google.com/a/chromium.org/dev/Home/chromium-security/deprecating-powerful-features-on-insecure-origins))
        // See `Locate options` for more details.
        locate: function(options) {
            options = this._locateOptions = extend({
                timeout: 10000,
                watch: false
            }, options);
            if (!("geolocation" in navigator)) {
                this._handleGeolocationError({
                    code: 0,
                    message: "Geolocation not supported."
                });
                return this;
            }
            var onResponse = bind(this._handleGeolocationResponse, this), onError = bind(this._handleGeolocationError, this);
            if (options.watch) this._locationWatchId = navigator.geolocation.watchPosition(onResponse, onError, options);
            else navigator.geolocation.getCurrentPosition(onResponse, onError, options);
            return this;
        },
        // @method stopLocate(): this
        // Stops watching location previously initiated by `map.locate({watch: true})`
        // and aborts resetting the map view if map.locate was called with
        // `{setView: true}`.
        stopLocate: function() {
            if (navigator.geolocation && navigator.geolocation.clearWatch) navigator.geolocation.clearWatch(this._locationWatchId);
            if (this._locateOptions) this._locateOptions.setView = false;
            return this;
        },
        _handleGeolocationError: function(error) {
            if (!this._container._leaflet_id) return;
            var c = error.code, message = error.message || (c === 1 ? "permission denied" : c === 2 ? "position unavailable" : "timeout");
            if (this._locateOptions.setView && !this._loaded) this.fitWorld();
            // @section Location events
            // @event locationerror: ErrorEvent
            // Fired when geolocation (using the [`locate`](#map-locate) method) failed.
            this.fire("locationerror", {
                code: c,
                message: "Geolocation error: " + message + "."
            });
        },
        _handleGeolocationResponse: function(pos) {
            if (!this._container._leaflet_id) return;
            var lat = pos.coords.latitude, lng = pos.coords.longitude, latlng = new LatLng(lat, lng), bounds = latlng.toBounds(pos.coords.accuracy * 2), options = this._locateOptions;
            if (options.setView) {
                var zoom = this.getBoundsZoom(bounds);
                this.setView(latlng, options.maxZoom ? Math.min(zoom, options.maxZoom) : zoom);
            }
            var data = {
                latlng: latlng,
                bounds: bounds,
                timestamp: pos.timestamp
            };
            for(var i in pos.coords)if (typeof pos.coords[i] === "number") data[i] = pos.coords[i];
            // @event locationfound: LocationEvent
            // Fired when geolocation (using the [`locate`](#map-locate) method)
            // went successfully.
            this.fire("locationfound", data);
        },
        // TODO Appropriate docs section?
        // @section Other Methods
        // @method addHandler(name: String, HandlerClass: Function): this
        // Adds a new `Handler` to the map, given its name and constructor function.
        addHandler: function(name, HandlerClass) {
            if (!HandlerClass) return this;
            var handler = this[name] = new HandlerClass(this);
            this._handlers.push(handler);
            if (this.options[name]) handler.enable();
            return this;
        },
        // @method remove(): this
        // Destroys the map and clears all related event listeners.
        remove: function() {
            this._initEvents(true);
            if (this.options.maxBounds) this.off("moveend", this._panInsideMaxBounds);
            if (this._containerId !== this._container._leaflet_id) throw new Error("Map container is being reused by another instance");
            try {
                // throws error in IE6-8
                delete this._container._leaflet_id;
                delete this._containerId;
            } catch (e) {
                /*eslint-disable */ this._container._leaflet_id = undefined;
                /* eslint-enable */ this._containerId = undefined;
            }
            if (this._locationWatchId !== undefined) this.stopLocate();
            this._stop();
            remove(this._mapPane);
            if (this._clearControlPos) this._clearControlPos();
            if (this._resizeRequest) {
                cancelAnimFrame(this._resizeRequest);
                this._resizeRequest = null;
            }
            this._clearHandlers();
            if (this._loaded) // @section Map state change events
            // @event unload: Event
            // Fired when the map is destroyed with [remove](#map-remove) method.
            this.fire("unload");
            var i;
            for(i in this._layers)this._layers[i].remove();
            for(i in this._panes)remove(this._panes[i]);
            this._layers = [];
            this._panes = [];
            delete this._mapPane;
            delete this._renderer;
            return this;
        },
        // @section Other Methods
        // @method createPane(name: String, container?: HTMLElement): HTMLElement
        // Creates a new [map pane](#map-pane) with the given name if it doesn't exist already,
        // then returns it. The pane is created as a child of `container`, or
        // as a child of the main map pane if not set.
        createPane: function(name, container) {
            var className = "leaflet-pane" + (name ? " leaflet-" + name.replace("Pane", "") + "-pane" : ""), pane = create$1("div", className, container || this._mapPane);
            if (name) this._panes[name] = pane;
            return pane;
        },
        // @section Methods for Getting Map State
        // @method getCenter(): LatLng
        // Returns the geographical center of the map view
        getCenter: function() {
            this._checkIfLoaded();
            if (this._lastCenter && !this._moved()) return this._lastCenter.clone();
            return this.layerPointToLatLng(this._getCenterLayerPoint());
        },
        // @method getZoom(): Number
        // Returns the current zoom level of the map view
        getZoom: function() {
            return this._zoom;
        },
        // @method getBounds(): LatLngBounds
        // Returns the geographical bounds visible in the current map view
        getBounds: function() {
            var bounds = this.getPixelBounds(), sw = this.unproject(bounds.getBottomLeft()), ne = this.unproject(bounds.getTopRight());
            return new LatLngBounds(sw, ne);
        },
        // @method getMinZoom(): Number
        // Returns the minimum zoom level of the map (if set in the `minZoom` option of the map or of any layers), or `0` by default.
        getMinZoom: function() {
            return this.options.minZoom === undefined ? this._layersMinZoom || 0 : this.options.minZoom;
        },
        // @method getMaxZoom(): Number
        // Returns the maximum zoom level of the map (if set in the `maxZoom` option of the map or of any layers).
        getMaxZoom: function() {
            return this.options.maxZoom === undefined ? this._layersMaxZoom === undefined ? Infinity : this._layersMaxZoom : this.options.maxZoom;
        },
        // @method getBoundsZoom(bounds: LatLngBounds, inside?: Boolean, padding?: Point): Number
        // Returns the maximum zoom level on which the given bounds fit to the map
        // view in its entirety. If `inside` (optional) is set to `true`, the method
        // instead returns the minimum zoom level on which the map view fits into
        // the given bounds in its entirety.
        getBoundsZoom: function(bounds, inside, padding) {
            bounds = toLatLngBounds(bounds);
            padding = toPoint(padding || [
                0,
                0
            ]);
            var zoom = this.getZoom() || 0, min = this.getMinZoom(), max = this.getMaxZoom(), nw = bounds.getNorthWest(), se = bounds.getSouthEast(), size = this.getSize().subtract(padding), boundsSize = toBounds(this.project(se, zoom), this.project(nw, zoom)).getSize(), snap = Browser.any3d ? this.options.zoomSnap : 1, scalex = size.x / boundsSize.x, scaley = size.y / boundsSize.y, scale = inside ? Math.max(scalex, scaley) : Math.min(scalex, scaley);
            zoom = this.getScaleZoom(scale, zoom);
            if (snap) {
                zoom = Math.round(zoom / (snap / 100)) * (snap / 100); // don't jump if within 1% of a snap level
                zoom = inside ? Math.ceil(zoom / snap) * snap : Math.floor(zoom / snap) * snap;
            }
            return Math.max(min, Math.min(max, zoom));
        },
        // @method getSize(): Point
        // Returns the current size of the map container (in pixels).
        getSize: function() {
            if (!this._size || this._sizeChanged) {
                this._size = new Point(this._container.clientWidth || 0, this._container.clientHeight || 0);
                this._sizeChanged = false;
            }
            return this._size.clone();
        },
        // @method getPixelBounds(): Bounds
        // Returns the bounds of the current map view in projected pixel
        // coordinates (sometimes useful in layer and overlay implementations).
        getPixelBounds: function(center, zoom) {
            var topLeftPoint = this._getTopLeftPoint(center, zoom);
            return new Bounds(topLeftPoint, topLeftPoint.add(this.getSize()));
        },
        // TODO: Check semantics - isn't the pixel origin the 0,0 coord relative to
        // the map pane? "left point of the map layer" can be confusing, specially
        // since there can be negative offsets.
        // @method getPixelOrigin(): Point
        // Returns the projected pixel coordinates of the top left point of
        // the map layer (useful in custom layer and overlay implementations).
        getPixelOrigin: function() {
            this._checkIfLoaded();
            return this._pixelOrigin;
        },
        // @method getPixelWorldBounds(zoom?: Number): Bounds
        // Returns the world's bounds in pixel coordinates for zoom level `zoom`.
        // If `zoom` is omitted, the map's current zoom level is used.
        getPixelWorldBounds: function(zoom) {
            return this.options.crs.getProjectedBounds(zoom === undefined ? this.getZoom() : zoom);
        },
        // @section Other Methods
        // @method getPane(pane: String|HTMLElement): HTMLElement
        // Returns a [map pane](#map-pane), given its name or its HTML element (its identity).
        getPane: function(pane) {
            return typeof pane === "string" ? this._panes[pane] : pane;
        },
        // @method getPanes(): Object
        // Returns a plain object containing the names of all [panes](#map-pane) as keys and
        // the panes as values.
        getPanes: function() {
            return this._panes;
        },
        // @method getContainer: HTMLElement
        // Returns the HTML element that contains the map.
        getContainer: function() {
            return this._container;
        },
        // @section Conversion Methods
        // @method getZoomScale(toZoom: Number, fromZoom: Number): Number
        // Returns the scale factor to be applied to a map transition from zoom level
        // `fromZoom` to `toZoom`. Used internally to help with zoom animations.
        getZoomScale: function(toZoom, fromZoom) {
            // TODO replace with universal implementation after refactoring projections
            var crs = this.options.crs;
            fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
            return crs.scale(toZoom) / crs.scale(fromZoom);
        },
        // @method getScaleZoom(scale: Number, fromZoom: Number): Number
        // Returns the zoom level that the map would end up at, if it is at `fromZoom`
        // level and everything is scaled by a factor of `scale`. Inverse of
        // [`getZoomScale`](#map-getZoomScale).
        getScaleZoom: function(scale, fromZoom) {
            var crs = this.options.crs;
            fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
            var zoom = crs.zoom(scale * crs.scale(fromZoom));
            return isNaN(zoom) ? Infinity : zoom;
        },
        // @method project(latlng: LatLng, zoom: Number): Point
        // Projects a geographical coordinate `LatLng` according to the projection
        // of the map's CRS, then scales it according to `zoom` and the CRS's
        // `Transformation`. The result is pixel coordinate relative to
        // the CRS origin.
        project: function(latlng, zoom) {
            zoom = zoom === undefined ? this._zoom : zoom;
            return this.options.crs.latLngToPoint(toLatLng(latlng), zoom);
        },
        // @method unproject(point: Point, zoom: Number): LatLng
        // Inverse of [`project`](#map-project).
        unproject: function(point, zoom) {
            zoom = zoom === undefined ? this._zoom : zoom;
            return this.options.crs.pointToLatLng(toPoint(point), zoom);
        },
        // @method layerPointToLatLng(point: Point): LatLng
        // Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
        // returns the corresponding geographical coordinate (for the current zoom level).
        layerPointToLatLng: function(point) {
            var projectedPoint = toPoint(point).add(this.getPixelOrigin());
            return this.unproject(projectedPoint);
        },
        // @method latLngToLayerPoint(latlng: LatLng): Point
        // Given a geographical coordinate, returns the corresponding pixel coordinate
        // relative to the [origin pixel](#map-getpixelorigin).
        latLngToLayerPoint: function(latlng) {
            var projectedPoint = this.project(toLatLng(latlng))._round();
            return projectedPoint._subtract(this.getPixelOrigin());
        },
        // @method wrapLatLng(latlng: LatLng): LatLng
        // Returns a `LatLng` where `lat` and `lng` has been wrapped according to the
        // map's CRS's `wrapLat` and `wrapLng` properties, if they are outside the
        // CRS's bounds.
        // By default this means longitude is wrapped around the dateline so its
        // value is between -180 and +180 degrees.
        wrapLatLng: function(latlng) {
            return this.options.crs.wrapLatLng(toLatLng(latlng));
        },
        // @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
        // Returns a `LatLngBounds` with the same size as the given one, ensuring that
        // its center is within the CRS's bounds.
        // By default this means the center longitude is wrapped around the dateline so its
        // value is between -180 and +180 degrees, and the majority of the bounds
        // overlaps the CRS's bounds.
        wrapLatLngBounds: function(latlng) {
            return this.options.crs.wrapLatLngBounds(toLatLngBounds(latlng));
        },
        // @method distance(latlng1: LatLng, latlng2: LatLng): Number
        // Returns the distance between two geographical coordinates according to
        // the map's CRS. By default this measures distance in meters.
        distance: function(latlng1, latlng2) {
            return this.options.crs.distance(toLatLng(latlng1), toLatLng(latlng2));
        },
        // @method containerPointToLayerPoint(point: Point): Point
        // Given a pixel coordinate relative to the map container, returns the corresponding
        // pixel coordinate relative to the [origin pixel](#map-getpixelorigin).
        containerPointToLayerPoint: function(point) {
            return toPoint(point).subtract(this._getMapPanePos());
        },
        // @method layerPointToContainerPoint(point: Point): Point
        // Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
        // returns the corresponding pixel coordinate relative to the map container.
        layerPointToContainerPoint: function(point) {
            return toPoint(point).add(this._getMapPanePos());
        },
        // @method containerPointToLatLng(point: Point): LatLng
        // Given a pixel coordinate relative to the map container, returns
        // the corresponding geographical coordinate (for the current zoom level).
        containerPointToLatLng: function(point) {
            var layerPoint = this.containerPointToLayerPoint(toPoint(point));
            return this.layerPointToLatLng(layerPoint);
        },
        // @method latLngToContainerPoint(latlng: LatLng): Point
        // Given a geographical coordinate, returns the corresponding pixel coordinate
        // relative to the map container.
        latLngToContainerPoint: function(latlng) {
            return this.layerPointToContainerPoint(this.latLngToLayerPoint(toLatLng(latlng)));
        },
        // @method mouseEventToContainerPoint(ev: MouseEvent): Point
        // Given a MouseEvent object, returns the pixel coordinate relative to the
        // map container where the event took place.
        mouseEventToContainerPoint: function(e) {
            return getMousePosition(e, this._container);
        },
        // @method mouseEventToLayerPoint(ev: MouseEvent): Point
        // Given a MouseEvent object, returns the pixel coordinate relative to
        // the [origin pixel](#map-getpixelorigin) where the event took place.
        mouseEventToLayerPoint: function(e) {
            return this.containerPointToLayerPoint(this.mouseEventToContainerPoint(e));
        },
        // @method mouseEventToLatLng(ev: MouseEvent): LatLng
        // Given a MouseEvent object, returns geographical coordinate where the
        // event took place.
        mouseEventToLatLng: function(e) {
            return this.layerPointToLatLng(this.mouseEventToLayerPoint(e));
        },
        // map initialization methods
        _initContainer: function(id) {
            var container = this._container = get(id);
            if (!container) throw new Error("Map container not found.");
            else if (container._leaflet_id) throw new Error("Map container is already initialized.");
            on(container, "scroll", this._onScroll, this);
            this._containerId = stamp(container);
        },
        _initLayout: function() {
            var container = this._container;
            this._fadeAnimated = this.options.fadeAnimation && Browser.any3d;
            addClass(container, "leaflet-container" + (Browser.touch ? " leaflet-touch" : "") + (Browser.retina ? " leaflet-retina" : "") + (Browser.ielt9 ? " leaflet-oldie" : "") + (Browser.safari ? " leaflet-safari" : "") + (this._fadeAnimated ? " leaflet-fade-anim" : ""));
            var position = getStyle(container, "position");
            if (position !== "absolute" && position !== "relative" && position !== "fixed" && position !== "sticky") container.style.position = "relative";
            this._initPanes();
            if (this._initControlPos) this._initControlPos();
        },
        _initPanes: function() {
            var panes = this._panes = {};
            this._paneRenderers = {};
            // @section
            //
            // Panes are DOM elements used to control the ordering of layers on the map. You
            // can access panes with [`map.getPane`](#map-getpane) or
            // [`map.getPanes`](#map-getpanes) methods. New panes can be created with the
            // [`map.createPane`](#map-createpane) method.
            //
            // Every map has the following default panes that differ only in zIndex.
            //
            // @pane mapPane: HTMLElement = 'auto'
            // Pane that contains all other map panes
            this._mapPane = this.createPane("mapPane", this._container);
            setPosition(this._mapPane, new Point(0, 0));
            // @pane tilePane: HTMLElement = 200
            // Pane for `GridLayer`s and `TileLayer`s
            this.createPane("tilePane");
            // @pane overlayPane: HTMLElement = 400
            // Pane for vectors (`Path`s, like `Polyline`s and `Polygon`s), `ImageOverlay`s and `VideoOverlay`s
            this.createPane("overlayPane");
            // @pane shadowPane: HTMLElement = 500
            // Pane for overlay shadows (e.g. `Marker` shadows)
            this.createPane("shadowPane");
            // @pane markerPane: HTMLElement = 600
            // Pane for `Icon`s of `Marker`s
            this.createPane("markerPane");
            // @pane tooltipPane: HTMLElement = 650
            // Pane for `Tooltip`s.
            this.createPane("tooltipPane");
            // @pane popupPane: HTMLElement = 700
            // Pane for `Popup`s.
            this.createPane("popupPane");
            if (!this.options.markerZoomAnimation) {
                addClass(panes.markerPane, "leaflet-zoom-hide");
                addClass(panes.shadowPane, "leaflet-zoom-hide");
            }
        },
        // private methods that modify map state
        // @section Map state change events
        _resetView: function(center, zoom, noMoveStart) {
            setPosition(this._mapPane, new Point(0, 0));
            var loading = !this._loaded;
            this._loaded = true;
            zoom = this._limitZoom(zoom);
            this.fire("viewprereset");
            var zoomChanged = this._zoom !== zoom;
            this._moveStart(zoomChanged, noMoveStart)._move(center, zoom)._moveEnd(zoomChanged);
            // @event viewreset: Event
            // Fired when the map needs to redraw its content (this usually happens
            // on map zoom or load). Very useful for creating custom overlays.
            this.fire("viewreset");
            // @event load: Event
            // Fired when the map is initialized (when its center and zoom are set
            // for the first time).
            if (loading) this.fire("load");
        },
        _moveStart: function(zoomChanged, noMoveStart) {
            // @event zoomstart: Event
            // Fired when the map zoom is about to change (e.g. before zoom animation).
            // @event movestart: Event
            // Fired when the view of the map starts changing (e.g. user starts dragging the map).
            if (zoomChanged) this.fire("zoomstart");
            if (!noMoveStart) this.fire("movestart");
            return this;
        },
        _move: function(center, zoom, data, supressEvent) {
            if (zoom === undefined) zoom = this._zoom;
            var zoomChanged = this._zoom !== zoom;
            this._zoom = zoom;
            this._lastCenter = center;
            this._pixelOrigin = this._getNewPixelOrigin(center);
            if (!supressEvent) {
                // @event zoom: Event
                // Fired repeatedly during any change in zoom level,
                // including zoom and fly animations.
                if (zoomChanged || data && data.pinch) this.fire("zoom", data);
                // @event move: Event
                // Fired repeatedly during any movement of the map,
                // including pan and fly animations.
                this.fire("move", data);
            } else if (data && data.pinch) this.fire("zoom", data);
            return this;
        },
        _moveEnd: function(zoomChanged) {
            // @event zoomend: Event
            // Fired when the map zoom changed, after any animations.
            if (zoomChanged) this.fire("zoomend");
            // @event moveend: Event
            // Fired when the center of the map stops changing
            // (e.g. user stopped dragging the map or after non-centered zoom).
            return this.fire("moveend");
        },
        _stop: function() {
            cancelAnimFrame(this._flyToFrame);
            if (this._panAnim) this._panAnim.stop();
            return this;
        },
        _rawPanBy: function(offset) {
            setPosition(this._mapPane, this._getMapPanePos().subtract(offset));
        },
        _getZoomSpan: function() {
            return this.getMaxZoom() - this.getMinZoom();
        },
        _panInsideMaxBounds: function() {
            if (!this._enforcingBounds) this.panInsideBounds(this.options.maxBounds);
        },
        _checkIfLoaded: function() {
            if (!this._loaded) throw new Error("Set map center and zoom first.");
        },
        // DOM event handling
        // @section Interaction events
        _initEvents: function(remove) {
            this._targets = {};
            this._targets[stamp(this._container)] = this;
            var onOff = remove ? off : on;
            // @event click: MouseEvent
            // Fired when the user clicks (or taps) the map.
            // @event dblclick: MouseEvent
            // Fired when the user double-clicks (or double-taps) the map.
            // @event mousedown: MouseEvent
            // Fired when the user pushes the mouse button on the map.
            // @event mouseup: MouseEvent
            // Fired when the user releases the mouse button on the map.
            // @event mouseover: MouseEvent
            // Fired when the mouse enters the map.
            // @event mouseout: MouseEvent
            // Fired when the mouse leaves the map.
            // @event mousemove: MouseEvent
            // Fired while the mouse moves over the map.
            // @event contextmenu: MouseEvent
            // Fired when the user pushes the right mouse button on the map, prevents
            // default browser context menu from showing if there are listeners on
            // this event. Also fired on mobile when the user holds a single touch
            // for a second (also called long press).
            // @event keypress: KeyboardEvent
            // Fired when the user presses a key from the keyboard that produces a character value while the map is focused.
            // @event keydown: KeyboardEvent
            // Fired when the user presses a key from the keyboard while the map is focused. Unlike the `keypress` event,
            // the `keydown` event is fired for keys that produce a character value and for keys
            // that do not produce a character value.
            // @event keyup: KeyboardEvent
            // Fired when the user releases a key from the keyboard while the map is focused.
            onOff(this._container, "click dblclick mousedown mouseup mouseover mouseout mousemove contextmenu keypress keydown keyup", this._handleDOMEvent, this);
            if (this.options.trackResize) onOff(window, "resize", this._onResize, this);
            if (Browser.any3d && this.options.transform3DLimit) (remove ? this.off : this.on).call(this, "moveend", this._onMoveEnd);
        },
        _onResize: function() {
            cancelAnimFrame(this._resizeRequest);
            this._resizeRequest = requestAnimFrame(function() {
                this.invalidateSize({
                    debounceMoveend: true
                });
            }, this);
        },
        _onScroll: function() {
            this._container.scrollTop = 0;
            this._container.scrollLeft = 0;
        },
        _onMoveEnd: function() {
            var pos = this._getMapPanePos();
            if (Math.max(Math.abs(pos.x), Math.abs(pos.y)) >= this.options.transform3DLimit) // https://bugzilla.mozilla.org/show_bug.cgi?id=1203873 but Webkit also have
            // a pixel offset on very high values, see: https://jsfiddle.net/dg6r5hhb/
            this._resetView(this.getCenter(), this.getZoom());
        },
        _findEventTargets: function(e, type) {
            var targets = [], target, isHover = type === "mouseout" || type === "mouseover", src = e.target || e.srcElement, dragging = false;
            while(src){
                target = this._targets[stamp(src)];
                if (target && (type === "click" || type === "preclick") && this._draggableMoved(target)) {
                    // Prevent firing click after you just dragged an object.
                    dragging = true;
                    break;
                }
                if (target && target.listens(type, true)) {
                    if (isHover && !isExternalTarget(src, e)) break;
                    targets.push(target);
                    if (isHover) break;
                }
                if (src === this._container) break;
                src = src.parentNode;
            }
            if (!targets.length && !dragging && !isHover && this.listens(type, true)) targets = [
                this
            ];
            return targets;
        },
        _isClickDisabled: function(el) {
            while(el && el !== this._container){
                if (el["_leaflet_disable_click"]) return true;
                el = el.parentNode;
            }
        },
        _handleDOMEvent: function(e) {
            var el = e.target || e.srcElement;
            if (!this._loaded || el["_leaflet_disable_events"] || e.type === "click" && this._isClickDisabled(el)) return;
            var type = e.type;
            if (type === "mousedown") // prevents outline when clicking on keyboard-focusable element
            preventOutline(el);
            this._fireDOMEvent(e, type);
        },
        _mouseEvents: [
            "click",
            "dblclick",
            "mouseover",
            "mouseout",
            "contextmenu"
        ],
        _fireDOMEvent: function(e, type, canvasTargets) {
            if (e.type === "click") {
                // Fire a synthetic 'preclick' event which propagates up (mainly for closing popups).
                // @event preclick: MouseEvent
                // Fired before mouse click on the map (sometimes useful when you
                // want something to happen on click before any existing click
                // handlers start running).
                var synth = extend({}, e);
                synth.type = "preclick";
                this._fireDOMEvent(synth, synth.type, canvasTargets);
            }
            // Find the layer the event is propagating from and its parents.
            var targets = this._findEventTargets(e, type);
            if (canvasTargets) {
                var filtered = []; // pick only targets with listeners
                for(var i = 0; i < canvasTargets.length; i++)if (canvasTargets[i].listens(type, true)) filtered.push(canvasTargets[i]);
                targets = filtered.concat(targets);
            }
            if (!targets.length) return;
            if (type === "contextmenu") preventDefault(e);
            var target = targets[0];
            var data = {
                originalEvent: e
            };
            if (e.type !== "keypress" && e.type !== "keydown" && e.type !== "keyup") {
                var isMarker = target.getLatLng && (!target._radius || target._radius <= 10);
                data.containerPoint = isMarker ? this.latLngToContainerPoint(target.getLatLng()) : this.mouseEventToContainerPoint(e);
                data.layerPoint = this.containerPointToLayerPoint(data.containerPoint);
                data.latlng = isMarker ? target.getLatLng() : this.layerPointToLatLng(data.layerPoint);
            }
            for(i = 0; i < targets.length; i++){
                targets[i].fire(type, data, true);
                if (data.originalEvent._stopped || targets[i].options.bubblingMouseEvents === false && indexOf(this._mouseEvents, type) !== -1) return;
            }
        },
        _draggableMoved: function(obj) {
            obj = obj.dragging && obj.dragging.enabled() ? obj : this;
            return obj.dragging && obj.dragging.moved() || this.boxZoom && this.boxZoom.moved();
        },
        _clearHandlers: function() {
            for(var i = 0, len = this._handlers.length; i < len; i++)this._handlers[i].disable();
        },
        // @section Other Methods
        // @method whenReady(fn: Function, context?: Object): this
        // Runs the given function `fn` when the map gets initialized with
        // a view (center and zoom) and at least one layer, or immediately
        // if it's already initialized, optionally passing a function context.
        whenReady: function(callback, context) {
            if (this._loaded) callback.call(context || this, {
                target: this
            });
            else this.on("load", callback, context);
            return this;
        },
        // private methods for getting map state
        _getMapPanePos: function() {
            return getPosition(this._mapPane) || new Point(0, 0);
        },
        _moved: function() {
            var pos = this._getMapPanePos();
            return pos && !pos.equals([
                0,
                0
            ]);
        },
        _getTopLeftPoint: function(center, zoom) {
            var pixelOrigin = center && zoom !== undefined ? this._getNewPixelOrigin(center, zoom) : this.getPixelOrigin();
            return pixelOrigin.subtract(this._getMapPanePos());
        },
        _getNewPixelOrigin: function(center, zoom) {
            var viewHalf = this.getSize()._divideBy(2);
            return this.project(center, zoom)._subtract(viewHalf)._add(this._getMapPanePos())._round();
        },
        _latLngToNewLayerPoint: function(latlng, zoom, center) {
            var topLeft = this._getNewPixelOrigin(center, zoom);
            return this.project(latlng, zoom)._subtract(topLeft);
        },
        _latLngBoundsToNewLayerBounds: function(latLngBounds, zoom, center) {
            var topLeft = this._getNewPixelOrigin(center, zoom);
            return toBounds([
                this.project(latLngBounds.getSouthWest(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getNorthWest(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getSouthEast(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getNorthEast(), zoom)._subtract(topLeft)
            ]);
        },
        // layer point of the current center
        _getCenterLayerPoint: function() {
            return this.containerPointToLayerPoint(this.getSize()._divideBy(2));
        },
        // offset of the specified place to the current center in pixels
        _getCenterOffset: function(latlng) {
            return this.latLngToLayerPoint(latlng).subtract(this._getCenterLayerPoint());
        },
        // adjust center for view to get inside bounds
        _limitCenter: function(center, zoom, bounds) {
            if (!bounds) return center;
            var centerPoint = this.project(center, zoom), viewHalf = this.getSize().divideBy(2), viewBounds = new Bounds(centerPoint.subtract(viewHalf), centerPoint.add(viewHalf)), offset = this._getBoundsOffset(viewBounds, bounds, zoom);
            // If offset is less than a pixel, ignore.
            // This prevents unstable projections from getting into
            // an infinite loop of tiny offsets.
            if (Math.abs(offset.x) <= 1 && Math.abs(offset.y) <= 1) return center;
            return this.unproject(centerPoint.add(offset), zoom);
        },
        // adjust offset for view to get inside bounds
        _limitOffset: function(offset, bounds) {
            if (!bounds) return offset;
            var viewBounds = this.getPixelBounds(), newBounds = new Bounds(viewBounds.min.add(offset), viewBounds.max.add(offset));
            return offset.add(this._getBoundsOffset(newBounds, bounds));
        },
        // returns offset needed for pxBounds to get inside maxBounds at a specified zoom
        _getBoundsOffset: function(pxBounds, maxBounds, zoom) {
            var projectedMaxBounds = toBounds(this.project(maxBounds.getNorthEast(), zoom), this.project(maxBounds.getSouthWest(), zoom)), minOffset = projectedMaxBounds.min.subtract(pxBounds.min), maxOffset = projectedMaxBounds.max.subtract(pxBounds.max), dx = this._rebound(minOffset.x, -maxOffset.x), dy = this._rebound(minOffset.y, -maxOffset.y);
            return new Point(dx, dy);
        },
        _rebound: function(left, right) {
            return left + right > 0 ? Math.round(left - right) / 2 : Math.max(0, Math.ceil(left)) - Math.max(0, Math.floor(right));
        },
        _limitZoom: function(zoom) {
            var min = this.getMinZoom(), max = this.getMaxZoom(), snap = Browser.any3d ? this.options.zoomSnap : 1;
            if (snap) zoom = Math.round(zoom / snap) * snap;
            return Math.max(min, Math.min(max, zoom));
        },
        _onPanTransitionStep: function() {
            this.fire("move");
        },
        _onPanTransitionEnd: function() {
            removeClass(this._mapPane, "leaflet-pan-anim");
            this.fire("moveend");
        },
        _tryAnimatedPan: function(center, options) {
            // difference between the new and current centers in pixels
            var offset = this._getCenterOffset(center)._trunc();
            // don't animate too far unless animate: true specified in options
            if ((options && options.animate) !== true && !this.getSize().contains(offset)) return false;
            this.panBy(offset, options);
            return true;
        },
        _createAnimProxy: function() {
            var proxy = this._proxy = create$1("div", "leaflet-proxy leaflet-zoom-animated");
            this._panes.mapPane.appendChild(proxy);
            this.on("zoomanim", function(e) {
                var prop = TRANSFORM, transform = this._proxy.style[prop];
                setTransform(this._proxy, this.project(e.center, e.zoom), this.getZoomScale(e.zoom, 1));
                // workaround for case when transform is the same and so transitionend event is not fired
                if (transform === this._proxy.style[prop] && this._animatingZoom) this._onZoomTransitionEnd();
            }, this);
            this.on("load moveend", this._animMoveEnd, this);
            this._on("unload", this._destroyAnimProxy, this);
        },
        _destroyAnimProxy: function() {
            remove(this._proxy);
            this.off("load moveend", this._animMoveEnd, this);
            delete this._proxy;
        },
        _animMoveEnd: function() {
            var c = this.getCenter(), z = this.getZoom();
            setTransform(this._proxy, this.project(c, z), this.getZoomScale(z, 1));
        },
        _catchTransitionEnd: function(e) {
            if (this._animatingZoom && e.propertyName.indexOf("transform") >= 0) this._onZoomTransitionEnd();
        },
        _nothingToAnimate: function() {
            return !this._container.getElementsByClassName("leaflet-zoom-animated").length;
        },
        _tryAnimatedZoom: function(center, zoom, options) {
            if (this._animatingZoom) return true;
            options = options || {};
            // don't animate if disabled, not supported or zoom difference is too large
            if (!this._zoomAnimated || options.animate === false || this._nothingToAnimate() || Math.abs(zoom - this._zoom) > this.options.zoomAnimationThreshold) return false;
            // offset is the pixel coords of the zoom origin relative to the current center
            var scale = this.getZoomScale(zoom), offset = this._getCenterOffset(center)._divideBy(1 - 1 / scale);
            // don't animate if the zoom origin isn't within one screen from the current center, unless forced
            if (options.animate !== true && !this.getSize().contains(offset)) return false;
            requestAnimFrame(function() {
                this._moveStart(true, options.noMoveStart || false)._animateZoom(center, zoom, true);
            }, this);
            return true;
        },
        _animateZoom: function(center, zoom, startAnim, noUpdate) {
            if (!this._mapPane) return;
            if (startAnim) {
                this._animatingZoom = true;
                // remember what center/zoom to set after animation
                this._animateToCenter = center;
                this._animateToZoom = zoom;
                addClass(this._mapPane, "leaflet-zoom-anim");
            }
            // @section Other Events
            // @event zoomanim: ZoomAnimEvent
            // Fired at least once per zoom animation. For continuous zoom, like pinch zooming, fired once per frame during zoom.
            this.fire("zoomanim", {
                center: center,
                zoom: zoom,
                noUpdate: noUpdate
            });
            if (!this._tempFireZoomEvent) this._tempFireZoomEvent = this._zoom !== this._animateToZoom;
            this._move(this._animateToCenter, this._animateToZoom, undefined, true);
            // Work around webkit not firing 'transitionend', see https://github.com/Leaflet/Leaflet/issues/3689, 2693
            setTimeout(bind(this._onZoomTransitionEnd, this), 250);
        },
        _onZoomTransitionEnd: function() {
            if (!this._animatingZoom) return;
            if (this._mapPane) removeClass(this._mapPane, "leaflet-zoom-anim");
            this._animatingZoom = false;
            this._move(this._animateToCenter, this._animateToZoom, undefined, true);
            if (this._tempFireZoomEvent) this.fire("zoom");
            delete this._tempFireZoomEvent;
            this.fire("move");
            this._moveEnd(true);
        }
    });
    // @section
    // @factory L.map(id: String, options?: Map options)
    // Instantiates a map object given the DOM ID of a `<div>` element
    // and optionally an object literal with `Map options`.
    //
    // @alternative
    // @factory L.map(el: HTMLElement, options?: Map options)
    // Instantiates a map object given an instance of a `<div>` HTML element
    // and optionally an object literal with `Map options`.
    function createMap(id, options) {
        return new Map(id, options);
    }
    /*
   * @class Control
   * @aka L.Control
   * @inherits Class
   *
   * L.Control is a base class for implementing map controls. Handles positioning.
   * All other controls extend from this class.
   */ var Control = Class.extend({
        // @section
        // @aka Control Options
        options: {
            // @option position: String = 'topright'
            // The position of the control (one of the map corners). Possible values are `'topleft'`,
            // `'topright'`, `'bottomleft'` or `'bottomright'`
            position: "topright"
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        /* @section
  	 * Classes extending L.Control will inherit the following methods:
  	 *
  	 * @method getPosition: string
  	 * Returns the position of the control.
  	 */ getPosition: function() {
            return this.options.position;
        },
        // @method setPosition(position: string): this
        // Sets the position of the control.
        setPosition: function(position) {
            var map = this._map;
            if (map) map.removeControl(this);
            this.options.position = position;
            if (map) map.addControl(this);
            return this;
        },
        // @method getContainer: HTMLElement
        // Returns the HTMLElement that contains the control.
        getContainer: function() {
            return this._container;
        },
        // @method addTo(map: Map): this
        // Adds the control to the given map.
        addTo: function(map) {
            this.remove();
            this._map = map;
            var container = this._container = this.onAdd(map), pos = this.getPosition(), corner = map._controlCorners[pos];
            addClass(container, "leaflet-control");
            if (pos.indexOf("bottom") !== -1) corner.insertBefore(container, corner.firstChild);
            else corner.appendChild(container);
            this._map.on("unload", this.remove, this);
            return this;
        },
        // @method remove: this
        // Removes the control from the map it is currently active on.
        remove: function() {
            if (!this._map) return this;
            remove(this._container);
            if (this.onRemove) this.onRemove(this._map);
            this._map.off("unload", this.remove, this);
            this._map = null;
            return this;
        },
        _refocusOnMap: function(e) {
            // if map exists and event is not a keyboard event
            if (this._map && e && e.screenX > 0 && e.screenY > 0) this._map.getContainer().focus();
        }
    });
    var control = function(options) {
        return new Control(options);
    };
    /* @section Extension methods
   * @uninheritable
   *
   * Every control should extend from `L.Control` and (re-)implement the following methods.
   *
   * @method onAdd(map: Map): HTMLElement
   * Should return the container DOM element for the control and add listeners on relevant map events. Called on [`control.addTo(map)`](#control-addTo).
   *
   * @method onRemove(map: Map)
   * Optional method. Should contain all clean up code that removes the listeners previously added in [`onAdd`](#control-onadd). Called on [`control.remove()`](#control-remove).
   */ /* @namespace Map
   * @section Methods for Layers and Controls
   */ Map.include({
        // @method addControl(control: Control): this
        // Adds the given control to the map
        addControl: function(control) {
            control.addTo(this);
            return this;
        },
        // @method removeControl(control: Control): this
        // Removes the given control from the map
        removeControl: function(control) {
            control.remove();
            return this;
        },
        _initControlPos: function() {
            var corners = this._controlCorners = {}, l = "leaflet-", container = this._controlContainer = create$1("div", l + "control-container", this._container);
            function createCorner(vSide, hSide) {
                var className = l + vSide + " " + l + hSide;
                corners[vSide + hSide] = create$1("div", className, container);
            }
            createCorner("top", "left");
            createCorner("top", "right");
            createCorner("bottom", "left");
            createCorner("bottom", "right");
        },
        _clearControlPos: function() {
            for(var i in this._controlCorners)remove(this._controlCorners[i]);
            remove(this._controlContainer);
            delete this._controlCorners;
            delete this._controlContainer;
        }
    });
    /*
   * @class Control.Layers
   * @aka L.Control.Layers
   * @inherits Control
   *
   * The layers control gives users the ability to switch between different base layers and switch overlays on/off (check out the [detailed example](https://leafletjs.com/examples/layers-control/)). Extends `Control`.
   *
   * @example
   *
   * ```js
   * var baseLayers = {
   * 	"Mapbox": mapbox,
   * 	"OpenStreetMap": osm
   * };
   *
   * var overlays = {
   * 	"Marker": marker,
   * 	"Roads": roadsLayer
   * };
   *
   * L.control.layers(baseLayers, overlays).addTo(map);
   * ```
   *
   * The `baseLayers` and `overlays` parameters are object literals with layer names as keys and `Layer` objects as values:
   *
   * ```js
   * {
   *     "<someName1>": layer1,
   *     "<someName2>": layer2
   * }
   * ```
   *
   * The layer names can contain HTML, which allows you to add additional styling to the items:
   *
   * ```js
   * {"<img src='my-layer-icon' /> <span class='my-layer-item'>My Layer</span>": myLayer}
   * ```
   */ var Layers = Control.extend({
        // @section
        // @aka Control.Layers options
        options: {
            // @option collapsed: Boolean = true
            // If `true`, the control will be collapsed into an icon and expanded on mouse hover, touch, or keyboard activation.
            collapsed: true,
            position: "topright",
            // @option autoZIndex: Boolean = true
            // If `true`, the control will assign zIndexes in increasing order to all of its layers so that the order is preserved when switching them on/off.
            autoZIndex: true,
            // @option hideSingleBase: Boolean = false
            // If `true`, the base layers in the control will be hidden when there is only one.
            hideSingleBase: false,
            // @option sortLayers: Boolean = false
            // Whether to sort the layers. When `false`, layers will keep the order
            // in which they were added to the control.
            sortLayers: false,
            // @option sortFunction: Function = *
            // A [compare function](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/sort)
            // that will be used for sorting the layers, when `sortLayers` is `true`.
            // The function receives both the `L.Layer` instances and their names, as in
            // `sortFunction(layerA, layerB, nameA, nameB)`.
            // By default, it sorts layers alphabetically by their name.
            sortFunction: function(layerA, layerB, nameA, nameB) {
                return nameA < nameB ? -1 : nameB < nameA ? 1 : 0;
            }
        },
        initialize: function(baseLayers, overlays, options) {
            setOptions(this, options);
            this._layerControlInputs = [];
            this._layers = [];
            this._lastZIndex = 0;
            this._handlingClick = false;
            this._preventClick = false;
            for(var i in baseLayers)this._addLayer(baseLayers[i], i);
            for(i in overlays)this._addLayer(overlays[i], i, true);
        },
        onAdd: function(map) {
            this._initLayout();
            this._update();
            this._map = map;
            map.on("zoomend", this._checkDisabledLayers, this);
            for(var i = 0; i < this._layers.length; i++)this._layers[i].layer.on("add remove", this._onLayerChange, this);
            return this._container;
        },
        addTo: function(map) {
            Control.prototype.addTo.call(this, map);
            // Trigger expand after Layers Control has been inserted into DOM so that is now has an actual height.
            return this._expandIfNotCollapsed();
        },
        onRemove: function() {
            this._map.off("zoomend", this._checkDisabledLayers, this);
            for(var i = 0; i < this._layers.length; i++)this._layers[i].layer.off("add remove", this._onLayerChange, this);
        },
        // @method addBaseLayer(layer: Layer, name: String): this
        // Adds a base layer (radio button entry) with the given name to the control.
        addBaseLayer: function(layer, name) {
            this._addLayer(layer, name);
            return this._map ? this._update() : this;
        },
        // @method addOverlay(layer: Layer, name: String): this
        // Adds an overlay (checkbox entry) with the given name to the control.
        addOverlay: function(layer, name) {
            this._addLayer(layer, name, true);
            return this._map ? this._update() : this;
        },
        // @method removeLayer(layer: Layer): this
        // Remove the given layer from the control.
        removeLayer: function(layer) {
            layer.off("add remove", this._onLayerChange, this);
            var obj = this._getLayer(stamp(layer));
            if (obj) this._layers.splice(this._layers.indexOf(obj), 1);
            return this._map ? this._update() : this;
        },
        // @method expand(): this
        // Expand the control container if collapsed.
        expand: function() {
            addClass(this._container, "leaflet-control-layers-expanded");
            this._section.style.height = null;
            var acceptableHeight = this._map.getSize().y - (this._container.offsetTop + 50);
            if (acceptableHeight < this._section.clientHeight) {
                addClass(this._section, "leaflet-control-layers-scrollbar");
                this._section.style.height = acceptableHeight + "px";
            } else removeClass(this._section, "leaflet-control-layers-scrollbar");
            this._checkDisabledLayers();
            return this;
        },
        // @method collapse(): this
        // Collapse the control container if expanded.
        collapse: function() {
            removeClass(this._container, "leaflet-control-layers-expanded");
            return this;
        },
        _initLayout: function() {
            var className = "leaflet-control-layers", container = this._container = create$1("div", className), collapsed = this.options.collapsed;
            // makes this work on IE touch devices by stopping it from firing a mouseout event when the touch is released
            container.setAttribute("aria-haspopup", true);
            disableClickPropagation(container);
            disableScrollPropagation(container);
            var section = this._section = create$1("section", className + "-list");
            if (collapsed) {
                this._map.on("click", this.collapse, this);
                on(container, {
                    mouseenter: this._expandSafely,
                    mouseleave: this.collapse
                }, this);
            }
            var link = this._layersLink = create$1("a", className + "-toggle", container);
            link.href = "#";
            link.title = "Layers";
            link.setAttribute("role", "button");
            on(link, {
                keydown: function(e) {
                    if (e.keyCode === 13) this._expandSafely();
                },
                // Certain screen readers intercept the key event and instead send a click event
                click: function(e) {
                    preventDefault(e);
                    this._expandSafely();
                }
            }, this);
            if (!collapsed) this.expand();
            this._baseLayersList = create$1("div", className + "-base", section);
            this._separator = create$1("div", className + "-separator", section);
            this._overlaysList = create$1("div", className + "-overlays", section);
            container.appendChild(section);
        },
        _getLayer: function(id) {
            for(var i = 0; i < this._layers.length; i++){
                if (this._layers[i] && stamp(this._layers[i].layer) === id) return this._layers[i];
            }
        },
        _addLayer: function(layer, name, overlay) {
            if (this._map) layer.on("add remove", this._onLayerChange, this);
            this._layers.push({
                layer: layer,
                name: name,
                overlay: overlay
            });
            if (this.options.sortLayers) this._layers.sort(bind(function(a, b) {
                return this.options.sortFunction(a.layer, b.layer, a.name, b.name);
            }, this));
            if (this.options.autoZIndex && layer.setZIndex) {
                this._lastZIndex++;
                layer.setZIndex(this._lastZIndex);
            }
            this._expandIfNotCollapsed();
        },
        _update: function() {
            if (!this._container) return this;
            empty(this._baseLayersList);
            empty(this._overlaysList);
            this._layerControlInputs = [];
            var baseLayersPresent, overlaysPresent, i, obj, baseLayersCount = 0;
            for(i = 0; i < this._layers.length; i++){
                obj = this._layers[i];
                this._addItem(obj);
                overlaysPresent = overlaysPresent || obj.overlay;
                baseLayersPresent = baseLayersPresent || !obj.overlay;
                baseLayersCount += !obj.overlay ? 1 : 0;
            }
            // Hide base layers section if there's only one layer.
            if (this.options.hideSingleBase) {
                baseLayersPresent = baseLayersPresent && baseLayersCount > 1;
                this._baseLayersList.style.display = baseLayersPresent ? "" : "none";
            }
            this._separator.style.display = overlaysPresent && baseLayersPresent ? "" : "none";
            return this;
        },
        _onLayerChange: function(e) {
            if (!this._handlingClick) this._update();
            var obj = this._getLayer(stamp(e.target));
            // @namespace Map
            // @section Layer events
            // @event baselayerchange: LayersControlEvent
            // Fired when the base layer is changed through the [layers control](#control-layers).
            // @event overlayadd: LayersControlEvent
            // Fired when an overlay is selected through the [layers control](#control-layers).
            // @event overlayremove: LayersControlEvent
            // Fired when an overlay is deselected through the [layers control](#control-layers).
            // @namespace Control.Layers
            var type = obj.overlay ? e.type === "add" ? "overlayadd" : "overlayremove" : e.type === "add" ? "baselayerchange" : null;
            if (type) this._map.fire(type, obj);
        },
        // IE7 bugs out if you create a radio dynamically, so you have to do it this hacky way (see https://stackoverflow.com/a/119079)
        _createRadioElement: function(name, checked) {
            var radioHtml = '<input type="radio" class="leaflet-control-layers-selector" name="' + name + '"' + (checked ? ' checked="checked"' : "") + "/>";
            var radioFragment = document.createElement("div");
            radioFragment.innerHTML = radioHtml;
            return radioFragment.firstChild;
        },
        _addItem: function(obj) {
            var label = document.createElement("label"), checked = this._map.hasLayer(obj.layer), input;
            if (obj.overlay) {
                input = document.createElement("input");
                input.type = "checkbox";
                input.className = "leaflet-control-layers-selector";
                input.defaultChecked = checked;
            } else input = this._createRadioElement("leaflet-base-layers_" + stamp(this), checked);
            this._layerControlInputs.push(input);
            input.layerId = stamp(obj.layer);
            on(input, "click", this._onInputClick, this);
            var name = document.createElement("span");
            name.innerHTML = " " + obj.name;
            // Helps from preventing layer control flicker when checkboxes are disabled
            // https://github.com/Leaflet/Leaflet/issues/2771
            var holder = document.createElement("span");
            label.appendChild(holder);
            holder.appendChild(input);
            holder.appendChild(name);
            var container = obj.overlay ? this._overlaysList : this._baseLayersList;
            container.appendChild(label);
            this._checkDisabledLayers();
            return label;
        },
        _onInputClick: function() {
            // expanding the control on mobile with a click can cause adding a layer - we don't want this
            if (this._preventClick) return;
            var inputs = this._layerControlInputs, input, layer;
            var addedLayers = [], removedLayers = [];
            this._handlingClick = true;
            for(var i = inputs.length - 1; i >= 0; i--){
                input = inputs[i];
                layer = this._getLayer(input.layerId).layer;
                if (input.checked) addedLayers.push(layer);
                else if (!input.checked) removedLayers.push(layer);
            }
            // Bugfix issue 2318: Should remove all old layers before readding new ones
            for(i = 0; i < removedLayers.length; i++)if (this._map.hasLayer(removedLayers[i])) this._map.removeLayer(removedLayers[i]);
            for(i = 0; i < addedLayers.length; i++)if (!this._map.hasLayer(addedLayers[i])) this._map.addLayer(addedLayers[i]);
            this._handlingClick = false;
            this._refocusOnMap();
        },
        _checkDisabledLayers: function() {
            var inputs = this._layerControlInputs, input, layer, zoom = this._map.getZoom();
            for(var i = inputs.length - 1; i >= 0; i--){
                input = inputs[i];
                layer = this._getLayer(input.layerId).layer;
                input.disabled = layer.options.minZoom !== undefined && zoom < layer.options.minZoom || layer.options.maxZoom !== undefined && zoom > layer.options.maxZoom;
            }
        },
        _expandIfNotCollapsed: function() {
            if (this._map && !this.options.collapsed) this.expand();
            return this;
        },
        _expandSafely: function() {
            var section = this._section;
            this._preventClick = true;
            on(section, "click", preventDefault);
            this.expand();
            var that = this;
            setTimeout(function() {
                off(section, "click", preventDefault);
                that._preventClick = false;
            });
        }
    });
    // @factory L.control.layers(baselayers?: Object, overlays?: Object, options?: Control.Layers options)
    // Creates a layers control with the given layers. Base layers will be switched with radio buttons, while overlays will be switched with checkboxes. Note that all base layers should be passed in the base layers object, but only one should be added to the map during map instantiation.
    var layers = function(baseLayers, overlays, options) {
        return new Layers(baseLayers, overlays, options);
    };
    /*
   * @class Control.Zoom
   * @aka L.Control.Zoom
   * @inherits Control
   *
   * A basic zoom control with two buttons (zoom in and zoom out). It is put on the map by default unless you set its [`zoomControl` option](#map-zoomcontrol) to `false`. Extends `Control`.
   */ var Zoom = Control.extend({
        // @section
        // @aka Control.Zoom options
        options: {
            position: "topleft",
            // @option zoomInText: String = '<span aria-hidden="true">+</span>'
            // The text set on the 'zoom in' button.
            zoomInText: '<span aria-hidden="true">+</span>',
            // @option zoomInTitle: String = 'Zoom in'
            // The title set on the 'zoom in' button.
            zoomInTitle: "Zoom in",
            // @option zoomOutText: String = '<span aria-hidden="true">&#x2212;</span>'
            // The text set on the 'zoom out' button.
            zoomOutText: '<span aria-hidden="true">&#x2212;</span>',
            // @option zoomOutTitle: String = 'Zoom out'
            // The title set on the 'zoom out' button.
            zoomOutTitle: "Zoom out"
        },
        onAdd: function(map) {
            var zoomName = "leaflet-control-zoom", container = create$1("div", zoomName + " leaflet-bar"), options = this.options;
            this._zoomInButton = this._createButton(options.zoomInText, options.zoomInTitle, zoomName + "-in", container, this._zoomIn);
            this._zoomOutButton = this._createButton(options.zoomOutText, options.zoomOutTitle, zoomName + "-out", container, this._zoomOut);
            this._updateDisabled();
            map.on("zoomend zoomlevelschange", this._updateDisabled, this);
            return container;
        },
        onRemove: function(map) {
            map.off("zoomend zoomlevelschange", this._updateDisabled, this);
        },
        disable: function() {
            this._disabled = true;
            this._updateDisabled();
            return this;
        },
        enable: function() {
            this._disabled = false;
            this._updateDisabled();
            return this;
        },
        _zoomIn: function(e) {
            if (!this._disabled && this._map._zoom < this._map.getMaxZoom()) this._map.zoomIn(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
        },
        _zoomOut: function(e) {
            if (!this._disabled && this._map._zoom > this._map.getMinZoom()) this._map.zoomOut(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
        },
        _createButton: function(html, title, className, container, fn) {
            var link = create$1("a", className, container);
            link.innerHTML = html;
            link.href = "#";
            link.title = title;
            /*
  		 * Will force screen readers like VoiceOver to read this as "Zoom in - button"
  		 */ link.setAttribute("role", "button");
            link.setAttribute("aria-label", title);
            disableClickPropagation(link);
            on(link, "click", stop);
            on(link, "click", fn, this);
            on(link, "click", this._refocusOnMap, this);
            return link;
        },
        _updateDisabled: function() {
            var map = this._map, className = "leaflet-disabled";
            removeClass(this._zoomInButton, className);
            removeClass(this._zoomOutButton, className);
            this._zoomInButton.setAttribute("aria-disabled", "false");
            this._zoomOutButton.setAttribute("aria-disabled", "false");
            if (this._disabled || map._zoom === map.getMinZoom()) {
                addClass(this._zoomOutButton, className);
                this._zoomOutButton.setAttribute("aria-disabled", "true");
            }
            if (this._disabled || map._zoom === map.getMaxZoom()) {
                addClass(this._zoomInButton, className);
                this._zoomInButton.setAttribute("aria-disabled", "true");
            }
        }
    });
    // @namespace Map
    // @section Control options
    // @option zoomControl: Boolean = true
    // Whether a [zoom control](#control-zoom) is added to the map by default.
    Map.mergeOptions({
        zoomControl: true
    });
    Map.addInitHook(function() {
        if (this.options.zoomControl) {
            // @section Controls
            // @property zoomControl: Control.Zoom
            // The default zoom control (only available if the
            // [`zoomControl` option](#map-zoomcontrol) was `true` when creating the map).
            this.zoomControl = new Zoom();
            this.addControl(this.zoomControl);
        }
    });
    // @namespace Control.Zoom
    // @factory L.control.zoom(options: Control.Zoom options)
    // Creates a zoom control
    var zoom = function(options) {
        return new Zoom(options);
    };
    /*
   * @class Control.Scale
   * @aka L.Control.Scale
   * @inherits Control
   *
   * A simple scale control that shows the scale of the current center of screen in metric (m/km) and imperial (mi/ft) systems. Extends `Control`.
   *
   * @example
   *
   * ```js
   * L.control.scale().addTo(map);
   * ```
   */ var Scale = Control.extend({
        // @section
        // @aka Control.Scale options
        options: {
            position: "bottomleft",
            // @option maxWidth: Number = 100
            // Maximum width of the control in pixels. The width is set dynamically to show round values (e.g. 100, 200, 500).
            maxWidth: 100,
            // @option metric: Boolean = True
            // Whether to show the metric scale line (m/km).
            metric: true,
            // @option imperial: Boolean = True
            // Whether to show the imperial scale line (mi/ft).
            imperial: true
        },
        onAdd: function(map) {
            var className = "leaflet-control-scale", container = create$1("div", className), options = this.options;
            this._addScales(options, className + "-line", container);
            map.on(options.updateWhenIdle ? "moveend" : "move", this._update, this);
            map.whenReady(this._update, this);
            return container;
        },
        onRemove: function(map) {
            map.off(this.options.updateWhenIdle ? "moveend" : "move", this._update, this);
        },
        _addScales: function(options, className, container) {
            if (options.metric) this._mScale = create$1("div", className, container);
            if (options.imperial) this._iScale = create$1("div", className, container);
        },
        _update: function() {
            var map = this._map, y = map.getSize().y / 2;
            var maxMeters = map.distance(map.containerPointToLatLng([
                0,
                y
            ]), map.containerPointToLatLng([
                this.options.maxWidth,
                y
            ]));
            this._updateScales(maxMeters);
        },
        _updateScales: function(maxMeters) {
            if (this.options.metric && maxMeters) this._updateMetric(maxMeters);
            if (this.options.imperial && maxMeters) this._updateImperial(maxMeters);
        },
        _updateMetric: function(maxMeters) {
            var meters = this._getRoundNum(maxMeters), label = meters < 1000 ? meters + " m" : meters / 1000 + " km";
            this._updateScale(this._mScale, label, meters / maxMeters);
        },
        _updateImperial: function(maxMeters) {
            var maxFeet = maxMeters * 3.2808399, maxMiles, miles, feet;
            if (maxFeet > 5280) {
                maxMiles = maxFeet / 5280;
                miles = this._getRoundNum(maxMiles);
                this._updateScale(this._iScale, miles + " mi", miles / maxMiles);
            } else {
                feet = this._getRoundNum(maxFeet);
                this._updateScale(this._iScale, feet + " ft", feet / maxFeet);
            }
        },
        _updateScale: function(scale, text, ratio) {
            scale.style.width = Math.round(this.options.maxWidth * ratio) + "px";
            scale.innerHTML = text;
        },
        _getRoundNum: function(num) {
            var pow10 = Math.pow(10, (Math.floor(num) + "").length - 1), d = num / pow10;
            d = d >= 10 ? 10 : d >= 5 ? 5 : d >= 3 ? 3 : d >= 2 ? 2 : 1;
            return pow10 * d;
        }
    });
    // @factory L.control.scale(options?: Control.Scale options)
    // Creates an scale control with the given options.
    var scale = function(options) {
        return new Scale(options);
    };
    var ukrainianFlag = '<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" class="leaflet-attribution-flag"><path fill="#4C7BE1" d="M0 0h12v4H0z"/><path fill="#FFD500" d="M0 4h12v3H0z"/><path fill="#E0BC00" d="M0 7h12v1H0z"/></svg>';
    /*
   * @class Control.Attribution
   * @aka L.Control.Attribution
   * @inherits Control
   *
   * The attribution control allows you to display attribution data in a small text box on a map. It is put on the map by default unless you set its [`attributionControl` option](#map-attributioncontrol) to `false`, and it fetches attribution texts from layers with the [`getAttribution` method](#layer-getattribution) automatically. Extends Control.
   */ var Attribution = Control.extend({
        // @section
        // @aka Control.Attribution options
        options: {
            position: "bottomright",
            // @option prefix: String|false = 'Leaflet'
            // The HTML text shown before the attributions. Pass `false` to disable.
            prefix: '<a href="https://leafletjs.com" title="A JavaScript library for interactive maps">' + (Browser.inlineSvg ? ukrainianFlag + " " : "") + "Leaflet</a>"
        },
        initialize: function(options) {
            setOptions(this, options);
            this._attributions = {};
        },
        onAdd: function(map) {
            map.attributionControl = this;
            this._container = create$1("div", "leaflet-control-attribution");
            disableClickPropagation(this._container);
            // TODO ugly, refactor
            for(var i in map._layers)if (map._layers[i].getAttribution) this.addAttribution(map._layers[i].getAttribution());
            this._update();
            map.on("layeradd", this._addAttribution, this);
            return this._container;
        },
        onRemove: function(map) {
            map.off("layeradd", this._addAttribution, this);
        },
        _addAttribution: function(ev) {
            if (ev.layer.getAttribution) {
                this.addAttribution(ev.layer.getAttribution());
                ev.layer.once("remove", function() {
                    this.removeAttribution(ev.layer.getAttribution());
                }, this);
            }
        },
        // @method setPrefix(prefix: String|false): this
        // The HTML text shown before the attributions. Pass `false` to disable.
        setPrefix: function(prefix) {
            this.options.prefix = prefix;
            this._update();
            return this;
        },
        // @method addAttribution(text: String): this
        // Adds an attribution text (e.g. `'&copy; OpenStreetMap contributors'`).
        addAttribution: function(text) {
            if (!text) return this;
            if (!this._attributions[text]) this._attributions[text] = 0;
            this._attributions[text]++;
            this._update();
            return this;
        },
        // @method removeAttribution(text: String): this
        // Removes an attribution text.
        removeAttribution: function(text) {
            if (!text) return this;
            if (this._attributions[text]) {
                this._attributions[text]--;
                this._update();
            }
            return this;
        },
        _update: function() {
            if (!this._map) return;
            var attribs = [];
            for(var i in this._attributions)if (this._attributions[i]) attribs.push(i);
            var prefixAndAttribs = [];
            if (this.options.prefix) prefixAndAttribs.push(this.options.prefix);
            if (attribs.length) prefixAndAttribs.push(attribs.join(", "));
            this._container.innerHTML = prefixAndAttribs.join(' <span aria-hidden="true">|</span> ');
        }
    });
    // @namespace Map
    // @section Control options
    // @option attributionControl: Boolean = true
    // Whether a [attribution control](#control-attribution) is added to the map by default.
    Map.mergeOptions({
        attributionControl: true
    });
    Map.addInitHook(function() {
        if (this.options.attributionControl) new Attribution().addTo(this);
    });
    // @namespace Control.Attribution
    // @factory L.control.attribution(options: Control.Attribution options)
    // Creates an attribution control.
    var attribution = function(options) {
        return new Attribution(options);
    };
    Control.Layers = Layers;
    Control.Zoom = Zoom;
    Control.Scale = Scale;
    Control.Attribution = Attribution;
    control.layers = layers;
    control.zoom = zoom;
    control.scale = scale;
    control.attribution = attribution;
    /*
  	L.Handler is a base class for handler classes that are used internally to inject
  	interaction features like dragging to classes like Map and Marker.
  */ // @class Handler
    // @aka L.Handler
    // Abstract class for map interaction handlers
    var Handler = Class.extend({
        initialize: function(map) {
            this._map = map;
        },
        // @method enable(): this
        // Enables the handler
        enable: function() {
            if (this._enabled) return this;
            this._enabled = true;
            this.addHooks();
            return this;
        },
        // @method disable(): this
        // Disables the handler
        disable: function() {
            if (!this._enabled) return this;
            this._enabled = false;
            this.removeHooks();
            return this;
        },
        // @method enabled(): Boolean
        // Returns `true` if the handler is enabled
        enabled: function() {
            return !!this._enabled;
        }
    });
    // @section There is static function which can be called without instantiating L.Handler:
    // @function addTo(map: Map, name: String): this
    // Adds a new Handler to the given map with the given name.
    Handler.addTo = function(map, name) {
        map.addHandler(name, this);
        return this;
    };
    var Mixin = {
        Events: Events
    };
    /*
   * @class Draggable
   * @aka L.Draggable
   * @inherits Evented
   *
   * A class for making DOM elements draggable (including touch support).
   * Used internally for map and marker dragging. Only works for elements
   * that were positioned with [`L.DomUtil.setPosition`](#domutil-setposition).
   *
   * @example
   * ```js
   * var draggable = new L.Draggable(elementToDrag);
   * draggable.enable();
   * ```
   */ var START = Browser.touch ? "touchstart mousedown" : "mousedown";
    var Draggable = Evented.extend({
        options: {
            // @section
            // @aka Draggable options
            // @option clickTolerance: Number = 3
            // The max number of pixels a user can shift the mouse pointer during a click
            // for it to be considered a valid click (as opposed to a mouse drag).
            clickTolerance: 3
        },
        // @constructor L.Draggable(el: HTMLElement, dragHandle?: HTMLElement, preventOutline?: Boolean, options?: Draggable options)
        // Creates a `Draggable` object for moving `el` when you start dragging the `dragHandle` element (equals `el` itself by default).
        initialize: function(element, dragStartTarget, preventOutline, options) {
            setOptions(this, options);
            this._element = element;
            this._dragStartTarget = dragStartTarget || element;
            this._preventOutline = preventOutline;
        },
        // @method enable()
        // Enables the dragging ability
        enable: function() {
            if (this._enabled) return;
            on(this._dragStartTarget, START, this._onDown, this);
            this._enabled = true;
        },
        // @method disable()
        // Disables the dragging ability
        disable: function() {
            if (!this._enabled) return;
            // If we're currently dragging this draggable,
            // disabling it counts as first ending the drag.
            if (Draggable._dragging === this) this.finishDrag(true);
            off(this._dragStartTarget, START, this._onDown, this);
            this._enabled = false;
            this._moved = false;
        },
        _onDown: function(e) {
            // Ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (!this._enabled) return;
            this._moved = false;
            if (hasClass(this._element, "leaflet-zoom-anim")) return;
            if (e.touches && e.touches.length !== 1) {
                // Finish dragging to avoid conflict with touchZoom
                if (Draggable._dragging === this) this.finishDrag();
                return;
            }
            if (Draggable._dragging || e.shiftKey || e.which !== 1 && e.button !== 1 && !e.touches) return;
            Draggable._dragging = this; // Prevent dragging multiple objects at once.
            if (this._preventOutline) preventOutline(this._element);
            disableImageDrag();
            disableTextSelection();
            if (this._moving) return;
            // @event down: Event
            // Fired when a drag is about to start.
            this.fire("down");
            var first = e.touches ? e.touches[0] : e, sizedParent = getSizedParentNode(this._element);
            this._startPoint = new Point(first.clientX, first.clientY);
            this._startPos = getPosition(this._element);
            // Cache the scale, so that we can continuously compensate for it during drag (_onMove).
            this._parentScale = getScale(sizedParent);
            var mouseevent = e.type === "mousedown";
            on(document, mouseevent ? "mousemove" : "touchmove", this._onMove, this);
            on(document, mouseevent ? "mouseup" : "touchend touchcancel", this._onUp, this);
        },
        _onMove: function(e) {
            // Ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (!this._enabled) return;
            if (e.touches && e.touches.length > 1) {
                this._moved = true;
                return;
            }
            var first = e.touches && e.touches.length === 1 ? e.touches[0] : e, offset = new Point(first.clientX, first.clientY)._subtract(this._startPoint);
            if (!offset.x && !offset.y) return;
            if (Math.abs(offset.x) + Math.abs(offset.y) < this.options.clickTolerance) return;
            // We assume that the parent container's position, border and scale do not change for the duration of the drag.
            // Therefore there is no need to account for the position and border (they are eliminated by the subtraction)
            // and we can use the cached value for the scale.
            offset.x /= this._parentScale.x;
            offset.y /= this._parentScale.y;
            preventDefault(e);
            if (!this._moved) {
                // @event dragstart: Event
                // Fired when a drag starts
                this.fire("dragstart");
                this._moved = true;
                addClass(document.body, "leaflet-dragging");
                this._lastTarget = e.target || e.srcElement;
                // IE and Edge do not give the <use> element, so fetch it
                // if necessary
                if (window.SVGElementInstance && this._lastTarget instanceof window.SVGElementInstance) this._lastTarget = this._lastTarget.correspondingUseElement;
                addClass(this._lastTarget, "leaflet-drag-target");
            }
            this._newPos = this._startPos.add(offset);
            this._moving = true;
            this._lastEvent = e;
            this._updatePosition();
        },
        _updatePosition: function() {
            var e = {
                originalEvent: this._lastEvent
            };
            // @event predrag: Event
            // Fired continuously during dragging *before* each corresponding
            // update of the element's position.
            this.fire("predrag", e);
            setPosition(this._element, this._newPos);
            // @event drag: Event
            // Fired continuously during dragging.
            this.fire("drag", e);
        },
        _onUp: function() {
            // Ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (!this._enabled) return;
            this.finishDrag();
        },
        finishDrag: function(noInertia) {
            removeClass(document.body, "leaflet-dragging");
            if (this._lastTarget) {
                removeClass(this._lastTarget, "leaflet-drag-target");
                this._lastTarget = null;
            }
            off(document, "mousemove touchmove", this._onMove, this);
            off(document, "mouseup touchend touchcancel", this._onUp, this);
            enableImageDrag();
            enableTextSelection();
            var fireDragend = this._moved && this._moving;
            this._moving = false;
            Draggable._dragging = false;
            if (fireDragend) // @event dragend: DragEndEvent
            // Fired when the drag ends.
            this.fire("dragend", {
                noInertia: noInertia,
                distance: this._newPos.distanceTo(this._startPos)
            });
        }
    });
    /*
   * @namespace PolyUtil
   * Various utility functions for polygon geometries.
   */ /* @function clipPolygon(points: Point[], bounds: Bounds, round?: Boolean): Point[]
   * Clips the polygon geometry defined by the given `points` by the given bounds (using the [Sutherland-Hodgman algorithm](https://en.wikipedia.org/wiki/Sutherland%E2%80%93Hodgman_algorithm)).
   * Used by Leaflet to only show polygon points that are on the screen or near, increasing
   * performance. Note that polygon points needs different algorithm for clipping
   * than polyline, so there's a separate method for it.
   */ function clipPolygon(points, bounds, round) {
        var clippedPoints, edges = [
            1,
            4,
            2,
            8
        ], i, j, k, a, b, len, edge, p;
        for(i = 0, len = points.length; i < len; i++)points[i]._code = _getBitCode(points[i], bounds);
        // for each edge (left, bottom, right, top)
        for(k = 0; k < 4; k++){
            edge = edges[k];
            clippedPoints = [];
            for(i = 0, len = points.length, j = len - 1; i < len; j = i++){
                a = points[i];
                b = points[j];
                // if a is inside the clip window
                if (!(a._code & edge)) {
                    // if b is outside the clip window (a->b goes out of screen)
                    if (b._code & edge) {
                        p = _getEdgeIntersection(b, a, edge, bounds, round);
                        p._code = _getBitCode(p, bounds);
                        clippedPoints.push(p);
                    }
                    clippedPoints.push(a);
                // else if b is inside the clip window (a->b enters the screen)
                } else if (!(b._code & edge)) {
                    p = _getEdgeIntersection(b, a, edge, bounds, round);
                    p._code = _getBitCode(p, bounds);
                    clippedPoints.push(p);
                }
            }
            points = clippedPoints;
        }
        return points;
    }
    /* @function polygonCenter(latlngs: LatLng[], crs: CRS): LatLng
   * Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the passed LatLngs (first ring) from a polygon.
   */ function polygonCenter(latlngs, crs) {
        var i, j, p1, p2, f, area, x, y, center;
        if (!latlngs || latlngs.length === 0) throw new Error("latlngs not passed");
        if (!isFlat(latlngs)) {
            console.warn("latlngs are not flat! Only the first ring will be used");
            latlngs = latlngs[0];
        }
        var centroidLatLng = toLatLng([
            0,
            0
        ]);
        var bounds = toLatLngBounds(latlngs);
        var areaBounds = bounds.getNorthWest().distanceTo(bounds.getSouthWest()) * bounds.getNorthEast().distanceTo(bounds.getNorthWest());
        // tests showed that below 1700 rounding errors are happening
        if (areaBounds < 1700) // getting a inexact center, to move the latlngs near to [0, 0] to prevent rounding errors
        centroidLatLng = centroid(latlngs);
        var len = latlngs.length;
        var points = [];
        for(i = 0; i < len; i++){
            var latlng = toLatLng(latlngs[i]);
            points.push(crs.project(toLatLng([
                latlng.lat - centroidLatLng.lat,
                latlng.lng - centroidLatLng.lng
            ])));
        }
        area = x = y = 0;
        // polygon centroid algorithm;
        for(i = 0, j = len - 1; i < len; j = i++){
            p1 = points[i];
            p2 = points[j];
            f = p1.y * p2.x - p2.y * p1.x;
            x += (p1.x + p2.x) * f;
            y += (p1.y + p2.y) * f;
            area += f * 3;
        }
        if (area === 0) // Polygon is so small that all points are on same pixel.
        center = points[0];
        else center = [
            x / area,
            y / area
        ];
        var latlngCenter = crs.unproject(toPoint(center));
        return toLatLng([
            latlngCenter.lat + centroidLatLng.lat,
            latlngCenter.lng + centroidLatLng.lng
        ]);
    }
    /* @function centroid(latlngs: LatLng[]): LatLng
   * Returns the 'center of mass' of the passed LatLngs.
   */ function centroid(coords) {
        var latSum = 0;
        var lngSum = 0;
        var len = 0;
        for(var i = 0; i < coords.length; i++){
            var latlng = toLatLng(coords[i]);
            latSum += latlng.lat;
            lngSum += latlng.lng;
            len++;
        }
        return toLatLng([
            latSum / len,
            lngSum / len
        ]);
    }
    var PolyUtil = {
        __proto__: null,
        clipPolygon: clipPolygon,
        polygonCenter: polygonCenter,
        centroid: centroid
    };
    /*
   * @namespace LineUtil
   *
   * Various utility functions for polyline points processing, used by Leaflet internally to make polylines lightning-fast.
   */ // Simplify polyline with vertex reduction and Douglas-Peucker simplification.
    // Improves rendering performance dramatically by lessening the number of points to draw.
    // @function simplify(points: Point[], tolerance: Number): Point[]
    // Dramatically reduces the number of points in a polyline while retaining
    // its shape and returns a new array of simplified points, using the
    // [Ramer-Douglas-Peucker algorithm](https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm).
    // Used for a huge performance boost when processing/displaying Leaflet polylines for
    // each zoom level and also reducing visual noise. tolerance affects the amount of
    // simplification (lesser value means higher quality but slower and with more points).
    // Also released as a separated micro-library [Simplify.js](https://mourner.github.io/simplify-js/).
    function simplify(points, tolerance) {
        if (!tolerance || !points.length) return points.slice();
        var sqTolerance = tolerance * tolerance;
        // stage 1: vertex reduction
        points = _reducePoints(points, sqTolerance);
        // stage 2: Douglas-Peucker simplification
        points = _simplifyDP(points, sqTolerance);
        return points;
    }
    // @function pointToSegmentDistance(p: Point, p1: Point, p2: Point): Number
    // Returns the distance between point `p` and segment `p1` to `p2`.
    function pointToSegmentDistance(p, p1, p2) {
        return Math.sqrt(_sqClosestPointOnSegment(p, p1, p2, true));
    }
    // @function closestPointOnSegment(p: Point, p1: Point, p2: Point): Number
    // Returns the closest point from a point `p` on a segment `p1` to `p2`.
    function closestPointOnSegment(p, p1, p2) {
        return _sqClosestPointOnSegment(p, p1, p2);
    }
    // Ramer-Douglas-Peucker simplification, see https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm
    function _simplifyDP(points, sqTolerance) {
        var len = points.length, ArrayConstructor = typeof Uint8Array !== "undefined" ? Uint8Array : Array, markers = new ArrayConstructor(len);
        markers[0] = markers[len - 1] = 1;
        _simplifyDPStep(points, markers, sqTolerance, 0, len - 1);
        var i, newPoints = [];
        for(i = 0; i < len; i++)if (markers[i]) newPoints.push(points[i]);
        return newPoints;
    }
    function _simplifyDPStep(points, markers, sqTolerance, first, last) {
        var maxSqDist = 0, index, i, sqDist;
        for(i = first + 1; i <= last - 1; i++){
            sqDist = _sqClosestPointOnSegment(points[i], points[first], points[last], true);
            if (sqDist > maxSqDist) {
                index = i;
                maxSqDist = sqDist;
            }
        }
        if (maxSqDist > sqTolerance) {
            markers[index] = 1;
            _simplifyDPStep(points, markers, sqTolerance, first, index);
            _simplifyDPStep(points, markers, sqTolerance, index, last);
        }
    }
    // reduce points that are too close to each other to a single point
    function _reducePoints(points, sqTolerance) {
        var reducedPoints = [
            points[0]
        ];
        for(var i = 1, prev = 0, len = points.length; i < len; i++)if (_sqDist(points[i], points[prev]) > sqTolerance) {
            reducedPoints.push(points[i]);
            prev = i;
        }
        if (prev < len - 1) reducedPoints.push(points[len - 1]);
        return reducedPoints;
    }
    var _lastCode;
    // @function clipSegment(a: Point, b: Point, bounds: Bounds, useLastCode?: Boolean, round?: Boolean): Point[]|Boolean
    // Clips the segment a to b by rectangular bounds with the
    // [Cohen-Sutherland algorithm](https://en.wikipedia.org/wiki/Cohen%E2%80%93Sutherland_algorithm)
    // (modifying the segment points directly!). Used by Leaflet to only show polyline
    // points that are on the screen or near, increasing performance.
    function clipSegment(a, b, bounds, useLastCode, round) {
        var codeA = useLastCode ? _lastCode : _getBitCode(a, bounds), codeB = _getBitCode(b, bounds), codeOut, p, newCode;
        // save 2nd code to avoid calculating it on the next segment
        _lastCode = codeB;
        while(true){
            // if a,b is inside the clip window (trivial accept)
            if (!(codeA | codeB)) return [
                a,
                b
            ];
            // if a,b is outside the clip window (trivial reject)
            if (codeA & codeB) return false;
            // other cases
            codeOut = codeA || codeB;
            p = _getEdgeIntersection(a, b, codeOut, bounds, round);
            newCode = _getBitCode(p, bounds);
            if (codeOut === codeA) {
                a = p;
                codeA = newCode;
            } else {
                b = p;
                codeB = newCode;
            }
        }
    }
    function _getEdgeIntersection(a, b, code, bounds, round) {
        var dx = b.x - a.x, dy = b.y - a.y, min = bounds.min, max = bounds.max, x, y;
        if (code & 8) {
            x = a.x + dx * (max.y - a.y) / dy;
            y = max.y;
        } else if (code & 4) {
            x = a.x + dx * (min.y - a.y) / dy;
            y = min.y;
        } else if (code & 2) {
            x = max.x;
            y = a.y + dy * (max.x - a.x) / dx;
        } else if (code & 1) {
            x = min.x;
            y = a.y + dy * (min.x - a.x) / dx;
        }
        return new Point(x, y, round);
    }
    function _getBitCode(p, bounds) {
        var code = 0;
        if (p.x < bounds.min.x) code |= 1;
        else if (p.x > bounds.max.x) code |= 2;
        if (p.y < bounds.min.y) code |= 4;
        else if (p.y > bounds.max.y) code |= 8;
        return code;
    }
    // square distance (to avoid unnecessary Math.sqrt calls)
    function _sqDist(p1, p2) {
        var dx = p2.x - p1.x, dy = p2.y - p1.y;
        return dx * dx + dy * dy;
    }
    // return closest point on segment or distance to that point
    function _sqClosestPointOnSegment(p, p1, p2, sqDist) {
        var x = p1.x, y = p1.y, dx = p2.x - x, dy = p2.y - y, dot = dx * dx + dy * dy, t;
        if (dot > 0) {
            t = ((p.x - x) * dx + (p.y - y) * dy) / dot;
            if (t > 1) {
                x = p2.x;
                y = p2.y;
            } else if (t > 0) {
                x += dx * t;
                y += dy * t;
            }
        }
        dx = p.x - x;
        dy = p.y - y;
        return sqDist ? dx * dx + dy * dy : new Point(x, y);
    }
    // @function isFlat(latlngs: LatLng[]): Boolean
    // Returns true if `latlngs` is a flat array, false is nested.
    function isFlat(latlngs) {
        return !isArray(latlngs[0]) || typeof latlngs[0][0] !== "object" && typeof latlngs[0][0] !== "undefined";
    }
    function _flat(latlngs) {
        console.warn("Deprecated use of _flat, please use L.LineUtil.isFlat instead.");
        return isFlat(latlngs);
    }
    /* @function polylineCenter(latlngs: LatLng[], crs: CRS): LatLng
   * Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the passed LatLngs (first ring) from a polyline.
   */ function polylineCenter(latlngs, crs) {
        var i, halfDist, segDist, dist, p1, p2, ratio, center;
        if (!latlngs || latlngs.length === 0) throw new Error("latlngs not passed");
        if (!isFlat(latlngs)) {
            console.warn("latlngs are not flat! Only the first ring will be used");
            latlngs = latlngs[0];
        }
        var centroidLatLng = toLatLng([
            0,
            0
        ]);
        var bounds = toLatLngBounds(latlngs);
        var areaBounds = bounds.getNorthWest().distanceTo(bounds.getSouthWest()) * bounds.getNorthEast().distanceTo(bounds.getNorthWest());
        // tests showed that below 1700 rounding errors are happening
        if (areaBounds < 1700) // getting a inexact center, to move the latlngs near to [0, 0] to prevent rounding errors
        centroidLatLng = centroid(latlngs);
        var len = latlngs.length;
        var points = [];
        for(i = 0; i < len; i++){
            var latlng = toLatLng(latlngs[i]);
            points.push(crs.project(toLatLng([
                latlng.lat - centroidLatLng.lat,
                latlng.lng - centroidLatLng.lng
            ])));
        }
        for(i = 0, halfDist = 0; i < len - 1; i++)halfDist += points[i].distanceTo(points[i + 1]) / 2;
        // The line is so small in the current view that all points are on the same pixel.
        if (halfDist === 0) center = points[0];
        else for(i = 0, dist = 0; i < len - 1; i++){
            p1 = points[i];
            p2 = points[i + 1];
            segDist = p1.distanceTo(p2);
            dist += segDist;
            if (dist > halfDist) {
                ratio = (dist - halfDist) / segDist;
                center = [
                    p2.x - ratio * (p2.x - p1.x),
                    p2.y - ratio * (p2.y - p1.y)
                ];
                break;
            }
        }
        var latlngCenter = crs.unproject(toPoint(center));
        return toLatLng([
            latlngCenter.lat + centroidLatLng.lat,
            latlngCenter.lng + centroidLatLng.lng
        ]);
    }
    var LineUtil = {
        __proto__: null,
        simplify: simplify,
        pointToSegmentDistance: pointToSegmentDistance,
        closestPointOnSegment: closestPointOnSegment,
        clipSegment: clipSegment,
        _getEdgeIntersection: _getEdgeIntersection,
        _getBitCode: _getBitCode,
        _sqClosestPointOnSegment: _sqClosestPointOnSegment,
        isFlat: isFlat,
        _flat: _flat,
        polylineCenter: polylineCenter
    };
    /*
   * @namespace Projection
   * @section
   * Leaflet comes with a set of already defined Projections out of the box:
   *
   * @projection L.Projection.LonLat
   *
   * Equirectangular, or Plate Carree projection — the most simple projection,
   * mostly used by GIS enthusiasts. Directly maps `x` as longitude, and `y` as
   * latitude. Also suitable for flat worlds, e.g. game maps. Used by the
   * `EPSG:4326` and `Simple` CRS.
   */ var LonLat = {
        project: function(latlng) {
            return new Point(latlng.lng, latlng.lat);
        },
        unproject: function(point) {
            return new LatLng(point.y, point.x);
        },
        bounds: new Bounds([
            -180,
            -90
        ], [
            180,
            90
        ])
    };
    /*
   * @namespace Projection
   * @projection L.Projection.Mercator
   *
   * Elliptical Mercator projection — more complex than Spherical Mercator. Assumes that Earth is an ellipsoid. Used by the EPSG:3395 CRS.
   */ var Mercator = {
        R: 6378137,
        R_MINOR: 6356752.314245179,
        bounds: new Bounds([
            -20037508.34279,
            -15496570.73972
        ], [
            20037508.34279,
            18764656.23138
        ]),
        project: function(latlng) {
            var d = Math.PI / 180, r = this.R, y = latlng.lat * d, tmp = this.R_MINOR / r, e = Math.sqrt(1 - tmp * tmp), con = e * Math.sin(y);
            var ts = Math.tan(Math.PI / 4 - y / 2) / Math.pow((1 - con) / (1 + con), e / 2);
            y = -r * Math.log(Math.max(ts, 1E-10));
            return new Point(latlng.lng * d * r, y);
        },
        unproject: function(point) {
            var d = 180 / Math.PI, r = this.R, tmp = this.R_MINOR / r, e = Math.sqrt(1 - tmp * tmp), ts = Math.exp(-point.y / r), phi = Math.PI / 2 - 2 * Math.atan(ts);
            for(var i = 0, dphi = 0.1, con; i < 15 && Math.abs(dphi) > 1e-7; i++){
                con = e * Math.sin(phi);
                con = Math.pow((1 - con) / (1 + con), e / 2);
                dphi = Math.PI / 2 - 2 * Math.atan(ts * con) - phi;
                phi += dphi;
            }
            return new LatLng(phi * d, point.x * d / r);
        }
    };
    /*
   * @class Projection

   * An object with methods for projecting geographical coordinates of the world onto
   * a flat surface (and back). See [Map projection](https://en.wikipedia.org/wiki/Map_projection).

   * @property bounds: Bounds
   * The bounds (specified in CRS units) where the projection is valid

   * @method project(latlng: LatLng): Point
   * Projects geographical coordinates into a 2D point.
   * Only accepts actual `L.LatLng` instances, not arrays.

   * @method unproject(point: Point): LatLng
   * The inverse of `project`. Projects a 2D point into a geographical location.
   * Only accepts actual `L.Point` instances, not arrays.

   * Note that the projection instances do not inherit from Leaflet's `Class` object,
   * and can't be instantiated. Also, new classes can't inherit from them,
   * and methods can't be added to them with the `include` function.

   */ var index = {
        __proto__: null,
        LonLat: LonLat,
        Mercator: Mercator,
        SphericalMercator: SphericalMercator
    };
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG3395
   *
   * Rarely used by some commercial tile providers. Uses Elliptical Mercator projection.
   */ var EPSG3395 = extend({}, Earth, {
        code: "EPSG:3395",
        projection: Mercator,
        transformation: function() {
            var scale = 0.5 / (Math.PI * Mercator.R);
            return toTransformation(scale, 0.5, -scale, 0.5);
        }()
    });
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG4326
   *
   * A common CRS among GIS enthusiasts. Uses simple Equirectangular projection.
   *
   * Leaflet 1.0.x complies with the [TMS coordinate scheme for EPSG:4326](https://wiki.osgeo.org/wiki/Tile_Map_Service_Specification#global-geodetic),
   * which is a breaking change from 0.7.x behaviour.  If you are using a `TileLayer`
   * with this CRS, ensure that there are two 256x256 pixel tiles covering the
   * whole earth at zoom level zero, and that the tile coordinate origin is (-180,+90),
   * or (-180,-90) for `TileLayer`s with [the `tms` option](#tilelayer-tms) set.
   */ var EPSG4326 = extend({}, Earth, {
        code: "EPSG:4326",
        projection: LonLat,
        transformation: toTransformation(1 / 180, 1, -1 / 180, 0.5)
    });
    /*
   * @namespace CRS
   * @crs L.CRS.Simple
   *
   * A simple CRS that maps longitude and latitude into `x` and `y` directly.
   * May be used for maps of flat surfaces (e.g. game maps). Note that the `y`
   * axis should still be inverted (going from bottom to top). `distance()` returns
   * simple euclidean distance.
   */ var Simple = extend({}, CRS, {
        projection: LonLat,
        transformation: toTransformation(1, 0, -1, 0),
        scale: function(zoom) {
            return Math.pow(2, zoom);
        },
        zoom: function(scale) {
            return Math.log(scale) / Math.LN2;
        },
        distance: function(latlng1, latlng2) {
            var dx = latlng2.lng - latlng1.lng, dy = latlng2.lat - latlng1.lat;
            return Math.sqrt(dx * dx + dy * dy);
        },
        infinite: true
    });
    CRS.Earth = Earth;
    CRS.EPSG3395 = EPSG3395;
    CRS.EPSG3857 = EPSG3857;
    CRS.EPSG900913 = EPSG900913;
    CRS.EPSG4326 = EPSG4326;
    CRS.Simple = Simple;
    /*
   * @class Layer
   * @inherits Evented
   * @aka L.Layer
   * @aka ILayer
   *
   * A set of methods from the Layer base class that all Leaflet layers use.
   * Inherits all methods, options and events from `L.Evented`.
   *
   * @example
   *
   * ```js
   * var layer = L.marker(latlng).addTo(map);
   * layer.addTo(map);
   * layer.remove();
   * ```
   *
   * @event add: Event
   * Fired after the layer is added to a map
   *
   * @event remove: Event
   * Fired after the layer is removed from a map
   */ var Layer = Evented.extend({
        // Classes extending `L.Layer` will inherit the following options:
        options: {
            // @option pane: String = 'overlayPane'
            // By default the layer will be added to the map's [overlay pane](#map-overlaypane). Overriding this option will cause the layer to be placed on another pane by default.
            pane: "overlayPane",
            // @option attribution: String = null
            // String to be shown in the attribution control, e.g. "© OpenStreetMap contributors". It describes the layer data and is often a legal obligation towards copyright holders and tile providers.
            attribution: null,
            bubblingMouseEvents: true
        },
        /* @section
  	 * Classes extending `L.Layer` will inherit the following methods:
  	 *
  	 * @method addTo(map: Map|LayerGroup): this
  	 * Adds the layer to the given map or layer group.
  	 */ addTo: function(map) {
            map.addLayer(this);
            return this;
        },
        // @method remove: this
        // Removes the layer from the map it is currently active on.
        remove: function() {
            return this.removeFrom(this._map || this._mapToAdd);
        },
        // @method removeFrom(map: Map): this
        // Removes the layer from the given map
        //
        // @alternative
        // @method removeFrom(group: LayerGroup): this
        // Removes the layer from the given `LayerGroup`
        removeFrom: function(obj) {
            if (obj) obj.removeLayer(this);
            return this;
        },
        // @method getPane(name? : String): HTMLElement
        // Returns the `HTMLElement` representing the named pane on the map. If `name` is omitted, returns the pane for this layer.
        getPane: function(name) {
            return this._map.getPane(name ? this.options[name] || name : this.options.pane);
        },
        addInteractiveTarget: function(targetEl) {
            this._map._targets[stamp(targetEl)] = this;
            return this;
        },
        removeInteractiveTarget: function(targetEl) {
            delete this._map._targets[stamp(targetEl)];
            return this;
        },
        // @method getAttribution: String
        // Used by the `attribution control`, returns the [attribution option](#gridlayer-attribution).
        getAttribution: function() {
            return this.options.attribution;
        },
        _layerAdd: function(e) {
            var map = e.target;
            // check in case layer gets added and then removed before the map is ready
            if (!map.hasLayer(this)) return;
            this._map = map;
            this._zoomAnimated = map._zoomAnimated;
            if (this.getEvents) {
                var events = this.getEvents();
                map.on(events, this);
                this.once("remove", function() {
                    map.off(events, this);
                }, this);
            }
            this.onAdd(map);
            this.fire("add");
            map.fire("layeradd", {
                layer: this
            });
        }
    });
    /* @section Extension methods
   * @uninheritable
   *
   * Every layer should extend from `L.Layer` and (re-)implement the following methods.
   *
   * @method onAdd(map: Map): this
   * Should contain code that creates DOM elements for the layer, adds them to `map panes` where they should belong and puts listeners on relevant map events. Called on [`map.addLayer(layer)`](#map-addlayer).
   *
   * @method onRemove(map: Map): this
   * Should contain all clean up code that removes the layer's elements from the DOM and removes listeners previously added in [`onAdd`](#layer-onadd). Called on [`map.removeLayer(layer)`](#map-removelayer).
   *
   * @method getEvents(): Object
   * This optional method should return an object like `{ viewreset: this._reset }` for [`addEventListener`](#evented-addeventlistener). The event handlers in this object will be automatically added and removed from the map with your layer.
   *
   * @method getAttribution(): String
   * This optional method should return a string containing HTML to be shown on the `Attribution control` whenever the layer is visible.
   *
   * @method beforeAdd(map: Map): this
   * Optional method. Called on [`map.addLayer(layer)`](#map-addlayer), before the layer is added to the map, before events are initialized, without waiting until the map is in a usable state. Use for early initialization only.
   */ /* @namespace Map
   * @section Layer events
   *
   * @event layeradd: LayerEvent
   * Fired when a new layer is added to the map.
   *
   * @event layerremove: LayerEvent
   * Fired when some layer is removed from the map
   *
   * @section Methods for Layers and Controls
   */ Map.include({
        // @method addLayer(layer: Layer): this
        // Adds the given layer to the map
        addLayer: function(layer) {
            if (!layer._layerAdd) throw new Error("The provided object is not a Layer.");
            var id = stamp(layer);
            if (this._layers[id]) return this;
            this._layers[id] = layer;
            layer._mapToAdd = this;
            if (layer.beforeAdd) layer.beforeAdd(this);
            this.whenReady(layer._layerAdd, layer);
            return this;
        },
        // @method removeLayer(layer: Layer): this
        // Removes the given layer from the map.
        removeLayer: function(layer) {
            var id = stamp(layer);
            if (!this._layers[id]) return this;
            if (this._loaded) layer.onRemove(this);
            delete this._layers[id];
            if (this._loaded) {
                this.fire("layerremove", {
                    layer: layer
                });
                layer.fire("remove");
            }
            layer._map = layer._mapToAdd = null;
            return this;
        },
        // @method hasLayer(layer: Layer): Boolean
        // Returns `true` if the given layer is currently added to the map
        hasLayer: function(layer) {
            return stamp(layer) in this._layers;
        },
        /* @method eachLayer(fn: Function, context?: Object): this
  	 * Iterates over the layers of the map, optionally specifying context of the iterator function.
  	 * ```
  	 * map.eachLayer(function(layer){
  	 *     layer.bindPopup('Hello');
  	 * });
  	 * ```
  	 */ eachLayer: function(method, context) {
            for(var i in this._layers)method.call(context, this._layers[i]);
            return this;
        },
        _addLayers: function(layers) {
            layers = layers ? isArray(layers) ? layers : [
                layers
            ] : [];
            for(var i = 0, len = layers.length; i < len; i++)this.addLayer(layers[i]);
        },
        _addZoomLimit: function(layer) {
            if (!isNaN(layer.options.maxZoom) || !isNaN(layer.options.minZoom)) {
                this._zoomBoundLayers[stamp(layer)] = layer;
                this._updateZoomLevels();
            }
        },
        _removeZoomLimit: function(layer) {
            var id = stamp(layer);
            if (this._zoomBoundLayers[id]) {
                delete this._zoomBoundLayers[id];
                this._updateZoomLevels();
            }
        },
        _updateZoomLevels: function() {
            var minZoom = Infinity, maxZoom = -Infinity, oldZoomSpan = this._getZoomSpan();
            for(var i in this._zoomBoundLayers){
                var options = this._zoomBoundLayers[i].options;
                minZoom = options.minZoom === undefined ? minZoom : Math.min(minZoom, options.minZoom);
                maxZoom = options.maxZoom === undefined ? maxZoom : Math.max(maxZoom, options.maxZoom);
            }
            this._layersMaxZoom = maxZoom === -Infinity ? undefined : maxZoom;
            this._layersMinZoom = minZoom === Infinity ? undefined : minZoom;
            // @section Map state change events
            // @event zoomlevelschange: Event
            // Fired when the number of zoomlevels on the map is changed due
            // to adding or removing a layer.
            if (oldZoomSpan !== this._getZoomSpan()) this.fire("zoomlevelschange");
            if (this.options.maxZoom === undefined && this._layersMaxZoom && this.getZoom() > this._layersMaxZoom) this.setZoom(this._layersMaxZoom);
            if (this.options.minZoom === undefined && this._layersMinZoom && this.getZoom() < this._layersMinZoom) this.setZoom(this._layersMinZoom);
        }
    });
    /*
   * @class LayerGroup
   * @aka L.LayerGroup
   * @inherits Interactive layer
   *
   * Used to group several layers and handle them as one. If you add it to the map,
   * any layers added or removed from the group will be added/removed on the map as
   * well. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * L.layerGroup([marker1, marker2])
   * 	.addLayer(polyline)
   * 	.addTo(map);
   * ```
   */ var LayerGroup = Layer.extend({
        initialize: function(layers, options) {
            setOptions(this, options);
            this._layers = {};
            var i, len;
            if (layers) for(i = 0, len = layers.length; i < len; i++)this.addLayer(layers[i]);
        },
        // @method addLayer(layer: Layer): this
        // Adds the given layer to the group.
        addLayer: function(layer) {
            var id = this.getLayerId(layer);
            this._layers[id] = layer;
            if (this._map) this._map.addLayer(layer);
            return this;
        },
        // @method removeLayer(layer: Layer): this
        // Removes the given layer from the group.
        // @alternative
        // @method removeLayer(id: Number): this
        // Removes the layer with the given internal ID from the group.
        removeLayer: function(layer) {
            var id = layer in this._layers ? layer : this.getLayerId(layer);
            if (this._map && this._layers[id]) this._map.removeLayer(this._layers[id]);
            delete this._layers[id];
            return this;
        },
        // @method hasLayer(layer: Layer): Boolean
        // Returns `true` if the given layer is currently added to the group.
        // @alternative
        // @method hasLayer(id: Number): Boolean
        // Returns `true` if the given internal ID is currently added to the group.
        hasLayer: function(layer) {
            var layerId = typeof layer === "number" ? layer : this.getLayerId(layer);
            return layerId in this._layers;
        },
        // @method clearLayers(): this
        // Removes all the layers from the group.
        clearLayers: function() {
            return this.eachLayer(this.removeLayer, this);
        },
        // @method invoke(methodName: String, …): this
        // Calls `methodName` on every layer contained in this group, passing any
        // additional parameters. Has no effect if the layers contained do not
        // implement `methodName`.
        invoke: function(methodName) {
            var args = Array.prototype.slice.call(arguments, 1), i, layer;
            for(i in this._layers){
                layer = this._layers[i];
                if (layer[methodName]) layer[methodName].apply(layer, args);
            }
            return this;
        },
        onAdd: function(map) {
            this.eachLayer(map.addLayer, map);
        },
        onRemove: function(map) {
            this.eachLayer(map.removeLayer, map);
        },
        // @method eachLayer(fn: Function, context?: Object): this
        // Iterates over the layers of the group, optionally specifying context of the iterator function.
        // ```js
        // group.eachLayer(function (layer) {
        // 	layer.bindPopup('Hello');
        // });
        // ```
        eachLayer: function(method, context) {
            for(var i in this._layers)method.call(context, this._layers[i]);
            return this;
        },
        // @method getLayer(id: Number): Layer
        // Returns the layer with the given internal ID.
        getLayer: function(id) {
            return this._layers[id];
        },
        // @method getLayers(): Layer[]
        // Returns an array of all the layers added to the group.
        getLayers: function() {
            var layers = [];
            this.eachLayer(layers.push, layers);
            return layers;
        },
        // @method setZIndex(zIndex: Number): this
        // Calls `setZIndex` on every layer contained in this group, passing the z-index.
        setZIndex: function(zIndex) {
            return this.invoke("setZIndex", zIndex);
        },
        // @method getLayerId(layer: Layer): Number
        // Returns the internal ID for a layer
        getLayerId: function(layer) {
            return stamp(layer);
        }
    });
    // @factory L.layerGroup(layers?: Layer[], options?: Object)
    // Create a layer group, optionally given an initial set of layers and an `options` object.
    var layerGroup = function(layers, options) {
        return new LayerGroup(layers, options);
    };
    /*
   * @class FeatureGroup
   * @aka L.FeatureGroup
   * @inherits LayerGroup
   *
   * Extended `LayerGroup` that makes it easier to do the same thing to all its member layers:
   *  * [`bindPopup`](#layer-bindpopup) binds a popup to all of the layers at once (likewise with [`bindTooltip`](#layer-bindtooltip))
   *  * Events are propagated to the `FeatureGroup`, so if the group has an event
   * handler, it will handle events from any of the layers. This includes mouse events
   * and custom events.
   *  * Has `layeradd` and `layerremove` events
   *
   * @example
   *
   * ```js
   * L.featureGroup([marker1, marker2, polyline])
   * 	.bindPopup('Hello world!')
   * 	.on('click', function() { alert('Clicked on a member of the group!'); })
   * 	.addTo(map);
   * ```
   */ var FeatureGroup = LayerGroup.extend({
        addLayer: function(layer) {
            if (this.hasLayer(layer)) return this;
            layer.addEventParent(this);
            LayerGroup.prototype.addLayer.call(this, layer);
            // @event layeradd: LayerEvent
            // Fired when a layer is added to this `FeatureGroup`
            return this.fire("layeradd", {
                layer: layer
            });
        },
        removeLayer: function(layer) {
            if (!this.hasLayer(layer)) return this;
            if (layer in this._layers) layer = this._layers[layer];
            layer.removeEventParent(this);
            LayerGroup.prototype.removeLayer.call(this, layer);
            // @event layerremove: LayerEvent
            // Fired when a layer is removed from this `FeatureGroup`
            return this.fire("layerremove", {
                layer: layer
            });
        },
        // @method setStyle(style: Path options): this
        // Sets the given path options to each layer of the group that has a `setStyle` method.
        setStyle: function(style) {
            return this.invoke("setStyle", style);
        },
        // @method bringToFront(): this
        // Brings the layer group to the top of all other layers
        bringToFront: function() {
            return this.invoke("bringToFront");
        },
        // @method bringToBack(): this
        // Brings the layer group to the back of all other layers
        bringToBack: function() {
            return this.invoke("bringToBack");
        },
        // @method getBounds(): LatLngBounds
        // Returns the LatLngBounds of the Feature Group (created from bounds and coordinates of its children).
        getBounds: function() {
            var bounds = new LatLngBounds();
            for(var id in this._layers){
                var layer = this._layers[id];
                bounds.extend(layer.getBounds ? layer.getBounds() : layer.getLatLng());
            }
            return bounds;
        }
    });
    // @factory L.featureGroup(layers?: Layer[], options?: Object)
    // Create a feature group, optionally given an initial set of layers and an `options` object.
    var featureGroup = function(layers, options) {
        return new FeatureGroup(layers, options);
    };
    /*
   * @class Icon
   * @aka L.Icon
   *
   * Represents an icon to provide when creating a marker.
   *
   * @example
   *
   * ```js
   * var myIcon = L.icon({
   *     iconUrl: 'my-icon.png',
   *     iconRetinaUrl: 'my-icon@2x.png',
   *     iconSize: [38, 95],
   *     iconAnchor: [22, 94],
   *     popupAnchor: [-3, -76],
   *     shadowUrl: 'my-icon-shadow.png',
   *     shadowRetinaUrl: 'my-icon-shadow@2x.png',
   *     shadowSize: [68, 95],
   *     shadowAnchor: [22, 94]
   * });
   *
   * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
   * ```
   *
   * `L.Icon.Default` extends `L.Icon` and is the blue icon Leaflet uses for markers by default.
   *
   */ var Icon = Class.extend({
        /* @section
  	 * @aka Icon options
  	 *
  	 * @option iconUrl: String = null
  	 * **(required)** The URL to the icon image (absolute or relative to your script path).
  	 *
  	 * @option iconRetinaUrl: String = null
  	 * The URL to a retina sized version of the icon image (absolute or relative to your
  	 * script path). Used for Retina screen devices.
  	 *
  	 * @option iconSize: Point = null
  	 * Size of the icon image in pixels.
  	 *
  	 * @option iconAnchor: Point = null
  	 * The coordinates of the "tip" of the icon (relative to its top left corner). The icon
  	 * will be aligned so that this point is at the marker's geographical location. Centered
  	 * by default if size is specified, also can be set in CSS with negative margins.
  	 *
  	 * @option popupAnchor: Point = [0, 0]
  	 * The coordinates of the point from which popups will "open", relative to the icon anchor.
  	 *
  	 * @option tooltipAnchor: Point = [0, 0]
  	 * The coordinates of the point from which tooltips will "open", relative to the icon anchor.
  	 *
  	 * @option shadowUrl: String = null
  	 * The URL to the icon shadow image. If not specified, no shadow image will be created.
  	 *
  	 * @option shadowRetinaUrl: String = null
  	 *
  	 * @option shadowSize: Point = null
  	 * Size of the shadow image in pixels.
  	 *
  	 * @option shadowAnchor: Point = null
  	 * The coordinates of the "tip" of the shadow (relative to its top left corner) (the same
  	 * as iconAnchor if not specified).
  	 *
  	 * @option className: String = ''
  	 * A custom class name to assign to both icon and shadow images. Empty by default.
  	 */ options: {
            popupAnchor: [
                0,
                0
            ],
            tooltipAnchor: [
                0,
                0
            ],
            // @option crossOrigin: Boolean|String = false
            // Whether the crossOrigin attribute will be added to the tiles.
            // If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
            // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
            crossOrigin: false
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        // @method createIcon(oldIcon?: HTMLElement): HTMLElement
        // Called internally when the icon has to be shown, returns a `<img>` HTML element
        // styled according to the options.
        createIcon: function(oldIcon) {
            return this._createIcon("icon", oldIcon);
        },
        // @method createShadow(oldIcon?: HTMLElement): HTMLElement
        // As `createIcon`, but for the shadow beneath it.
        createShadow: function(oldIcon) {
            return this._createIcon("shadow", oldIcon);
        },
        _createIcon: function(name, oldIcon) {
            var src = this._getIconUrl(name);
            if (!src) {
                if (name === "icon") throw new Error("iconUrl not set in Icon options (see the docs).");
                return null;
            }
            var img = this._createImg(src, oldIcon && oldIcon.tagName === "IMG" ? oldIcon : null);
            this._setIconStyles(img, name);
            if (this.options.crossOrigin || this.options.crossOrigin === "") img.crossOrigin = this.options.crossOrigin === true ? "" : this.options.crossOrigin;
            return img;
        },
        _setIconStyles: function(img, name) {
            var options = this.options;
            var sizeOption = options[name + "Size"];
            if (typeof sizeOption === "number") sizeOption = [
                sizeOption,
                sizeOption
            ];
            var size = toPoint(sizeOption), anchor = toPoint(name === "shadow" && options.shadowAnchor || options.iconAnchor || size && size.divideBy(2, true));
            img.className = "leaflet-marker-" + name + " " + (options.className || "");
            if (anchor) {
                img.style.marginLeft = -anchor.x + "px";
                img.style.marginTop = -anchor.y + "px";
            }
            if (size) {
                img.style.width = size.x + "px";
                img.style.height = size.y + "px";
            }
        },
        _createImg: function(src, el) {
            el = el || document.createElement("img");
            el.src = src;
            return el;
        },
        _getIconUrl: function(name) {
            return Browser.retina && this.options[name + "RetinaUrl"] || this.options[name + "Url"];
        }
    });
    // @factory L.icon(options: Icon options)
    // Creates an icon instance with the given options.
    function icon(options) {
        return new Icon(options);
    }
    /*
   * @miniclass Icon.Default (Icon)
   * @aka L.Icon.Default
   * @section
   *
   * A trivial subclass of `Icon`, represents the icon to use in `Marker`s when
   * no icon is specified. Points to the blue marker image distributed with Leaflet
   * releases.
   *
   * In order to customize the default icon, just change the properties of `L.Icon.Default.prototype.options`
   * (which is a set of `Icon options`).
   *
   * If you want to _completely_ replace the default icon, override the
   * `L.Marker.prototype.options.icon` with your own icon instead.
   */ var IconDefault = Icon.extend({
        options: {
            iconUrl: "marker-icon.png",
            iconRetinaUrl: "marker-icon-2x.png",
            shadowUrl: "marker-shadow.png",
            iconSize: [
                25,
                41
            ],
            iconAnchor: [
                12,
                41
            ],
            popupAnchor: [
                1,
                -34
            ],
            tooltipAnchor: [
                16,
                -28
            ],
            shadowSize: [
                41,
                41
            ]
        },
        _getIconUrl: function(name) {
            if (typeof IconDefault.imagePath !== "string") IconDefault.imagePath = this._detectIconPath();
            // @option imagePath: String
            // `Icon.Default` will try to auto-detect the location of the
            // blue icon images. If you are placing these images in a non-standard
            // way, set this option to point to the right path.
            return (this.options.imagePath || IconDefault.imagePath) + Icon.prototype._getIconUrl.call(this, name);
        },
        _stripUrl: function(path) {
            var strip = function(str, re, idx) {
                var match = re.exec(str);
                return match && match[idx];
            };
            path = strip(path, /^url\((['"])?(.+)\1\)$/, 2);
            return path && strip(path, /^(.*)marker-icon\.png$/, 1);
        },
        _detectIconPath: function() {
            var el = create$1("div", "leaflet-default-icon-path", document.body);
            var path = getStyle(el, "background-image") || getStyle(el, "backgroundImage"); // IE8
            document.body.removeChild(el);
            path = this._stripUrl(path);
            if (path) return path;
            var link = document.querySelector('link[href$="leaflet.css"]');
            if (!link) return "";
            return link.href.substring(0, link.href.length - 11 - 1);
        }
    });
    /*
   * L.Handler.MarkerDrag is used internally by L.Marker to make the markers draggable.
   */ /* @namespace Marker
   * @section Interaction handlers
   *
   * Interaction handlers are properties of a marker instance that allow you to control interaction behavior in runtime, enabling or disabling certain features such as dragging (see `Handler` methods). Example:
   *
   * ```js
   * marker.dragging.disable();
   * ```
   *
   * @property dragging: Handler
   * Marker dragging handler (by both mouse and touch). Only valid when the marker is on the map (Otherwise set [`marker.options.draggable`](#marker-draggable)).
   */ var MarkerDrag = Handler.extend({
        initialize: function(marker) {
            this._marker = marker;
        },
        addHooks: function() {
            var icon = this._marker._icon;
            if (!this._draggable) this._draggable = new Draggable(icon, icon, true);
            this._draggable.on({
                dragstart: this._onDragStart,
                predrag: this._onPreDrag,
                drag: this._onDrag,
                dragend: this._onDragEnd
            }, this).enable();
            addClass(icon, "leaflet-marker-draggable");
        },
        removeHooks: function() {
            this._draggable.off({
                dragstart: this._onDragStart,
                predrag: this._onPreDrag,
                drag: this._onDrag,
                dragend: this._onDragEnd
            }, this).disable();
            if (this._marker._icon) removeClass(this._marker._icon, "leaflet-marker-draggable");
        },
        moved: function() {
            return this._draggable && this._draggable._moved;
        },
        _adjustPan: function(e) {
            var marker = this._marker, map = marker._map, speed = this._marker.options.autoPanSpeed, padding = this._marker.options.autoPanPadding, iconPos = getPosition(marker._icon), bounds = map.getPixelBounds(), origin = map.getPixelOrigin();
            var panBounds = toBounds(bounds.min._subtract(origin).add(padding), bounds.max._subtract(origin).subtract(padding));
            if (!panBounds.contains(iconPos)) {
                // Compute incremental movement
                var movement = toPoint((Math.max(panBounds.max.x, iconPos.x) - panBounds.max.x) / (bounds.max.x - panBounds.max.x) - (Math.min(panBounds.min.x, iconPos.x) - panBounds.min.x) / (bounds.min.x - panBounds.min.x), (Math.max(panBounds.max.y, iconPos.y) - panBounds.max.y) / (bounds.max.y - panBounds.max.y) - (Math.min(panBounds.min.y, iconPos.y) - panBounds.min.y) / (bounds.min.y - panBounds.min.y)).multiplyBy(speed);
                map.panBy(movement, {
                    animate: false
                });
                this._draggable._newPos._add(movement);
                this._draggable._startPos._add(movement);
                setPosition(marker._icon, this._draggable._newPos);
                this._onDrag(e);
                this._panRequest = requestAnimFrame(this._adjustPan.bind(this, e));
            }
        },
        _onDragStart: function() {
            // @section Dragging events
            // @event dragstart: Event
            // Fired when the user starts dragging the marker.
            // @event movestart: Event
            // Fired when the marker starts moving (because of dragging).
            this._oldLatLng = this._marker.getLatLng();
            // When using ES6 imports it could not be set when `Popup` was not imported as well
            this._marker.closePopup && this._marker.closePopup();
            this._marker.fire("movestart").fire("dragstart");
        },
        _onPreDrag: function(e) {
            if (this._marker.options.autoPan) {
                cancelAnimFrame(this._panRequest);
                this._panRequest = requestAnimFrame(this._adjustPan.bind(this, e));
            }
        },
        _onDrag: function(e) {
            var marker = this._marker, shadow = marker._shadow, iconPos = getPosition(marker._icon), latlng = marker._map.layerPointToLatLng(iconPos);
            // update shadow position
            if (shadow) setPosition(shadow, iconPos);
            marker._latlng = latlng;
            e.latlng = latlng;
            e.oldLatLng = this._oldLatLng;
            // @event drag: Event
            // Fired repeatedly while the user drags the marker.
            marker.fire("move", e).fire("drag", e);
        },
        _onDragEnd: function(e) {
            // @event dragend: DragEndEvent
            // Fired when the user stops dragging the marker.
            cancelAnimFrame(this._panRequest);
            // @event moveend: Event
            // Fired when the marker stops moving (because of dragging).
            delete this._oldLatLng;
            this._marker.fire("moveend").fire("dragend", e);
        }
    });
    /*
   * @class Marker
   * @inherits Interactive layer
   * @aka L.Marker
   * L.Marker is used to display clickable/draggable icons on the map. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * L.marker([50.5, 30.5]).addTo(map);
   * ```
   */ var Marker = Layer.extend({
        // @section
        // @aka Marker options
        options: {
            // @option icon: Icon = *
            // Icon instance to use for rendering the marker.
            // See [Icon documentation](#L.Icon) for details on how to customize the marker icon.
            // If not specified, a common instance of `L.Icon.Default` is used.
            icon: new IconDefault(),
            // Option inherited from "Interactive layer" abstract class
            interactive: true,
            // @option keyboard: Boolean = true
            // Whether the marker can be tabbed to with a keyboard and clicked by pressing enter.
            keyboard: true,
            // @option title: String = ''
            // Text for the browser tooltip that appear on marker hover (no tooltip by default).
            // [Useful for accessibility](https://leafletjs.com/examples/accessibility/#markers-must-be-labelled).
            title: "",
            // @option alt: String = 'Marker'
            // Text for the `alt` attribute of the icon image.
            // [Useful for accessibility](https://leafletjs.com/examples/accessibility/#markers-must-be-labelled).
            alt: "Marker",
            // @option zIndexOffset: Number = 0
            // By default, marker images zIndex is set automatically based on its latitude. Use this option if you want to put the marker on top of all others (or below), specifying a high value like `1000` (or high negative value, respectively).
            zIndexOffset: 0,
            // @option opacity: Number = 1.0
            // The opacity of the marker.
            opacity: 1,
            // @option riseOnHover: Boolean = false
            // If `true`, the marker will get on top of others when you hover the mouse over it.
            riseOnHover: false,
            // @option riseOffset: Number = 250
            // The z-index offset used for the `riseOnHover` feature.
            riseOffset: 250,
            // @option pane: String = 'markerPane'
            // `Map pane` where the markers icon will be added.
            pane: "markerPane",
            // @option shadowPane: String = 'shadowPane'
            // `Map pane` where the markers shadow will be added.
            shadowPane: "shadowPane",
            // @option bubblingMouseEvents: Boolean = false
            // When `true`, a mouse event on this marker will trigger the same event on the map
            // (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
            bubblingMouseEvents: false,
            // @option autoPanOnFocus: Boolean = true
            // When `true`, the map will pan whenever the marker is focused (via
            // e.g. pressing `tab` on the keyboard) to ensure the marker is
            // visible within the map's bounds
            autoPanOnFocus: true,
            // @section Draggable marker options
            // @option draggable: Boolean = false
            // Whether the marker is draggable with mouse/touch or not.
            draggable: false,
            // @option autoPan: Boolean = false
            // Whether to pan the map when dragging this marker near its edge or not.
            autoPan: false,
            // @option autoPanPadding: Point = Point(50, 50)
            // Distance (in pixels to the left/right and to the top/bottom) of the
            // map edge to start panning the map.
            autoPanPadding: [
                50,
                50
            ],
            // @option autoPanSpeed: Number = 10
            // Number of pixels the map should pan by.
            autoPanSpeed: 10
        },
        /* @section
  	 *
  	 * In addition to [shared layer methods](#Layer) like `addTo()` and `remove()` and [popup methods](#Popup) like bindPopup() you can also use the following methods:
  	 */ initialize: function(latlng, options) {
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
        },
        onAdd: function(map) {
            this._zoomAnimated = this._zoomAnimated && map.options.markerZoomAnimation;
            if (this._zoomAnimated) map.on("zoomanim", this._animateZoom, this);
            this._initIcon();
            this.update();
        },
        onRemove: function(map) {
            if (this.dragging && this.dragging.enabled()) {
                this.options.draggable = true;
                this.dragging.removeHooks();
            }
            delete this.dragging;
            if (this._zoomAnimated) map.off("zoomanim", this._animateZoom, this);
            this._removeIcon();
            this._removeShadow();
        },
        getEvents: function() {
            return {
                zoom: this.update,
                viewreset: this.update
            };
        },
        // @method getLatLng: LatLng
        // Returns the current geographical position of the marker.
        getLatLng: function() {
            return this._latlng;
        },
        // @method setLatLng(latlng: LatLng): this
        // Changes the marker position to the given point.
        setLatLng: function(latlng) {
            var oldLatLng = this._latlng;
            this._latlng = toLatLng(latlng);
            this.update();
            // @event move: Event
            // Fired when the marker is moved via [`setLatLng`](#marker-setlatlng) or by [dragging](#marker-dragging). Old and new coordinates are included in event arguments as `oldLatLng`, `latlng`.
            return this.fire("move", {
                oldLatLng: oldLatLng,
                latlng: this._latlng
            });
        },
        // @method setZIndexOffset(offset: Number): this
        // Changes the [zIndex offset](#marker-zindexoffset) of the marker.
        setZIndexOffset: function(offset) {
            this.options.zIndexOffset = offset;
            return this.update();
        },
        // @method getIcon: Icon
        // Returns the current icon used by the marker
        getIcon: function() {
            return this.options.icon;
        },
        // @method setIcon(icon: Icon): this
        // Changes the marker icon.
        setIcon: function(icon) {
            this.options.icon = icon;
            if (this._map) {
                this._initIcon();
                this.update();
            }
            if (this._popup) this.bindPopup(this._popup, this._popup.options);
            return this;
        },
        getElement: function() {
            return this._icon;
        },
        update: function() {
            if (this._icon && this._map) {
                var pos = this._map.latLngToLayerPoint(this._latlng).round();
                this._setPos(pos);
            }
            return this;
        },
        _initIcon: function() {
            var options = this.options, classToAdd = "leaflet-zoom-" + (this._zoomAnimated ? "animated" : "hide");
            var icon = options.icon.createIcon(this._icon), addIcon = false;
            // if we're not reusing the icon, remove the old one and init new one
            if (icon !== this._icon) {
                if (this._icon) this._removeIcon();
                addIcon = true;
                if (options.title) icon.title = options.title;
                if (icon.tagName === "IMG") icon.alt = options.alt || "";
            }
            addClass(icon, classToAdd);
            if (options.keyboard) {
                icon.tabIndex = "0";
                icon.setAttribute("role", "button");
            }
            this._icon = icon;
            if (options.riseOnHover) this.on({
                mouseover: this._bringToFront,
                mouseout: this._resetZIndex
            });
            if (this.options.autoPanOnFocus) on(icon, "focus", this._panOnFocus, this);
            var newShadow = options.icon.createShadow(this._shadow), addShadow = false;
            if (newShadow !== this._shadow) {
                this._removeShadow();
                addShadow = true;
            }
            if (newShadow) {
                addClass(newShadow, classToAdd);
                newShadow.alt = "";
            }
            this._shadow = newShadow;
            if (options.opacity < 1) this._updateOpacity();
            if (addIcon) this.getPane().appendChild(this._icon);
            this._initInteraction();
            if (newShadow && addShadow) this.getPane(options.shadowPane).appendChild(this._shadow);
        },
        _removeIcon: function() {
            if (this.options.riseOnHover) this.off({
                mouseover: this._bringToFront,
                mouseout: this._resetZIndex
            });
            if (this.options.autoPanOnFocus) off(this._icon, "focus", this._panOnFocus, this);
            remove(this._icon);
            this.removeInteractiveTarget(this._icon);
            this._icon = null;
        },
        _removeShadow: function() {
            if (this._shadow) remove(this._shadow);
            this._shadow = null;
        },
        _setPos: function(pos) {
            if (this._icon) setPosition(this._icon, pos);
            if (this._shadow) setPosition(this._shadow, pos);
            this._zIndex = pos.y + this.options.zIndexOffset;
            this._resetZIndex();
        },
        _updateZIndex: function(offset) {
            if (this._icon) this._icon.style.zIndex = this._zIndex + offset;
        },
        _animateZoom: function(opt) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, opt.zoom, opt.center).round();
            this._setPos(pos);
        },
        _initInteraction: function() {
            if (!this.options.interactive) return;
            addClass(this._icon, "leaflet-interactive");
            this.addInteractiveTarget(this._icon);
            if (MarkerDrag) {
                var draggable = this.options.draggable;
                if (this.dragging) {
                    draggable = this.dragging.enabled();
                    this.dragging.disable();
                }
                this.dragging = new MarkerDrag(this);
                if (draggable) this.dragging.enable();
            }
        },
        // @method setOpacity(opacity: Number): this
        // Changes the opacity of the marker.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._map) this._updateOpacity();
            return this;
        },
        _updateOpacity: function() {
            var opacity = this.options.opacity;
            if (this._icon) setOpacity(this._icon, opacity);
            if (this._shadow) setOpacity(this._shadow, opacity);
        },
        _bringToFront: function() {
            this._updateZIndex(this.options.riseOffset);
        },
        _resetZIndex: function() {
            this._updateZIndex(0);
        },
        _panOnFocus: function() {
            var map = this._map;
            if (!map) return;
            var iconOpts = this.options.icon.options;
            var size = iconOpts.iconSize ? toPoint(iconOpts.iconSize) : toPoint(0, 0);
            var anchor = iconOpts.iconAnchor ? toPoint(iconOpts.iconAnchor) : toPoint(0, 0);
            map.panInside(this._latlng, {
                paddingTopLeft: anchor,
                paddingBottomRight: size.subtract(anchor)
            });
        },
        _getPopupAnchor: function() {
            return this.options.icon.options.popupAnchor;
        },
        _getTooltipAnchor: function() {
            return this.options.icon.options.tooltipAnchor;
        }
    });
    // factory L.marker(latlng: LatLng, options? : Marker options)
    // @factory L.marker(latlng: LatLng, options? : Marker options)
    // Instantiates a Marker object given a geographical point and optionally an options object.
    function marker(latlng, options) {
        return new Marker(latlng, options);
    }
    /*
   * @class Path
   * @aka L.Path
   * @inherits Interactive layer
   *
   * An abstract class that contains options and constants shared between vector
   * overlays (Polygon, Polyline, Circle). Do not use it directly. Extends `Layer`.
   */ var Path = Layer.extend({
        // @section
        // @aka Path options
        options: {
            // @option stroke: Boolean = true
            // Whether to draw stroke along the path. Set it to `false` to disable borders on polygons or circles.
            stroke: true,
            // @option color: String = '#3388ff'
            // Stroke color
            color: "#3388ff",
            // @option weight: Number = 3
            // Stroke width in pixels
            weight: 3,
            // @option opacity: Number = 1.0
            // Stroke opacity
            opacity: 1,
            // @option lineCap: String= 'round'
            // A string that defines [shape to be used at the end](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linecap) of the stroke.
            lineCap: "round",
            // @option lineJoin: String = 'round'
            // A string that defines [shape to be used at the corners](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linejoin) of the stroke.
            lineJoin: "round",
            // @option dashArray: String = null
            // A string that defines the stroke [dash pattern](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dasharray). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
            dashArray: null,
            // @option dashOffset: String = null
            // A string that defines the [distance into the dash pattern to start the dash](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dashoffset). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
            dashOffset: null,
            // @option fill: Boolean = depends
            // Whether to fill the path with color. Set it to `false` to disable filling on polygons or circles.
            fill: false,
            // @option fillColor: String = *
            // Fill color. Defaults to the value of the [`color`](#path-color) option
            fillColor: null,
            // @option fillOpacity: Number = 0.2
            // Fill opacity.
            fillOpacity: 0.2,
            // @option fillRule: String = 'evenodd'
            // A string that defines [how the inside of a shape](https://developer.mozilla.org/docs/Web/SVG/Attribute/fill-rule) is determined.
            fillRule: "evenodd",
            // className: '',
            // Option inherited from "Interactive layer" abstract class
            interactive: true,
            // @option bubblingMouseEvents: Boolean = true
            // When `true`, a mouse event on this path will trigger the same event on the map
            // (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
            bubblingMouseEvents: true
        },
        beforeAdd: function(map) {
            // Renderer is set here because we need to call renderer.getEvents
            // before this.getEvents.
            this._renderer = map.getRenderer(this);
        },
        onAdd: function() {
            this._renderer._initPath(this);
            this._reset();
            this._renderer._addPath(this);
        },
        onRemove: function() {
            this._renderer._removePath(this);
        },
        // @method redraw(): this
        // Redraws the layer. Sometimes useful after you changed the coordinates that the path uses.
        redraw: function() {
            if (this._map) this._renderer._updatePath(this);
            return this;
        },
        // @method setStyle(style: Path options): this
        // Changes the appearance of a Path based on the options in the `Path options` object.
        setStyle: function(style) {
            setOptions(this, style);
            if (this._renderer) {
                this._renderer._updateStyle(this);
                if (this.options.stroke && style && Object.prototype.hasOwnProperty.call(style, "weight")) this._updateBounds();
            }
            return this;
        },
        // @method bringToFront(): this
        // Brings the layer to the top of all path layers.
        bringToFront: function() {
            if (this._renderer) this._renderer._bringToFront(this);
            return this;
        },
        // @method bringToBack(): this
        // Brings the layer to the bottom of all path layers.
        bringToBack: function() {
            if (this._renderer) this._renderer._bringToBack(this);
            return this;
        },
        getElement: function() {
            return this._path;
        },
        _reset: function() {
            // defined in child classes
            this._project();
            this._update();
        },
        _clickTolerance: function() {
            // used when doing hit detection for Canvas layers
            return (this.options.stroke ? this.options.weight / 2 : 0) + (this._renderer.options.tolerance || 0);
        }
    });
    /*
   * @class CircleMarker
   * @aka L.CircleMarker
   * @inherits Path
   *
   * A circle of a fixed size with radius specified in pixels. Extends `Path`.
   */ var CircleMarker = Path.extend({
        // @section
        // @aka CircleMarker options
        options: {
            fill: true,
            // @option radius: Number = 10
            // Radius of the circle marker, in pixels
            radius: 10
        },
        initialize: function(latlng, options) {
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
            this._radius = this.options.radius;
        },
        // @method setLatLng(latLng: LatLng): this
        // Sets the position of a circle marker to a new location.
        setLatLng: function(latlng) {
            var oldLatLng = this._latlng;
            this._latlng = toLatLng(latlng);
            this.redraw();
            // @event move: Event
            // Fired when the marker is moved via [`setLatLng`](#circlemarker-setlatlng). Old and new coordinates are included in event arguments as `oldLatLng`, `latlng`.
            return this.fire("move", {
                oldLatLng: oldLatLng,
                latlng: this._latlng
            });
        },
        // @method getLatLng(): LatLng
        // Returns the current geographical position of the circle marker
        getLatLng: function() {
            return this._latlng;
        },
        // @method setRadius(radius: Number): this
        // Sets the radius of a circle marker. Units are in pixels.
        setRadius: function(radius) {
            this.options.radius = this._radius = radius;
            return this.redraw();
        },
        // @method getRadius(): Number
        // Returns the current radius of the circle
        getRadius: function() {
            return this._radius;
        },
        setStyle: function(options) {
            var radius = options && options.radius || this._radius;
            Path.prototype.setStyle.call(this, options);
            this.setRadius(radius);
            return this;
        },
        _project: function() {
            this._point = this._map.latLngToLayerPoint(this._latlng);
            this._updateBounds();
        },
        _updateBounds: function() {
            var r = this._radius, r2 = this._radiusY || r, w = this._clickTolerance(), p = [
                r + w,
                r2 + w
            ];
            this._pxBounds = new Bounds(this._point.subtract(p), this._point.add(p));
        },
        _update: function() {
            if (this._map) this._updatePath();
        },
        _updatePath: function() {
            this._renderer._updateCircle(this);
        },
        _empty: function() {
            return this._radius && !this._renderer._bounds.intersects(this._pxBounds);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p) {
            return p.distanceTo(this._point) <= this._radius + this._clickTolerance();
        }
    });
    // @factory L.circleMarker(latlng: LatLng, options?: CircleMarker options)
    // Instantiates a circle marker object given a geographical point, and an optional options object.
    function circleMarker(latlng, options) {
        return new CircleMarker(latlng, options);
    }
    /*
   * @class Circle
   * @aka L.Circle
   * @inherits CircleMarker
   *
   * A class for drawing circle overlays on a map. Extends `CircleMarker`.
   *
   * It's an approximation and starts to diverge from a real circle closer to poles (due to projection distortion).
   *
   * @example
   *
   * ```js
   * L.circle([50.5, 30.5], {radius: 200}).addTo(map);
   * ```
   */ var Circle = CircleMarker.extend({
        initialize: function(latlng, options, legacyOptions) {
            if (typeof options === "number") // Backwards compatibility with 0.7.x factory (latlng, radius, options?)
            options = extend({}, legacyOptions, {
                radius: options
            });
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
            if (isNaN(this.options.radius)) throw new Error("Circle radius cannot be NaN");
            // @section
            // @aka Circle options
            // @option radius: Number; Radius of the circle, in meters.
            this._mRadius = this.options.radius;
        },
        // @method setRadius(radius: Number): this
        // Sets the radius of a circle. Units are in meters.
        setRadius: function(radius) {
            this._mRadius = radius;
            return this.redraw();
        },
        // @method getRadius(): Number
        // Returns the current radius of a circle. Units are in meters.
        getRadius: function() {
            return this._mRadius;
        },
        // @method getBounds(): LatLngBounds
        // Returns the `LatLngBounds` of the path.
        getBounds: function() {
            var half = [
                this._radius,
                this._radiusY || this._radius
            ];
            return new LatLngBounds(this._map.layerPointToLatLng(this._point.subtract(half)), this._map.layerPointToLatLng(this._point.add(half)));
        },
        setStyle: Path.prototype.setStyle,
        _project: function() {
            var lng = this._latlng.lng, lat = this._latlng.lat, map = this._map, crs = map.options.crs;
            if (crs.distance === Earth.distance) {
                var d = Math.PI / 180, latR = this._mRadius / Earth.R / d, top = map.project([
                    lat + latR,
                    lng
                ]), bottom = map.project([
                    lat - latR,
                    lng
                ]), p = top.add(bottom).divideBy(2), lat2 = map.unproject(p).lat, lngR = Math.acos((Math.cos(latR * d) - Math.sin(lat * d) * Math.sin(lat2 * d)) / (Math.cos(lat * d) * Math.cos(lat2 * d))) / d;
                if (isNaN(lngR) || lngR === 0) lngR = latR / Math.cos(Math.PI / 180 * lat); // Fallback for edge case, #2425
                this._point = p.subtract(map.getPixelOrigin());
                this._radius = isNaN(lngR) ? 0 : p.x - map.project([
                    lat2,
                    lng - lngR
                ]).x;
                this._radiusY = p.y - top.y;
            } else {
                var latlng2 = crs.unproject(crs.project(this._latlng).subtract([
                    this._mRadius,
                    0
                ]));
                this._point = map.latLngToLayerPoint(this._latlng);
                this._radius = this._point.x - map.latLngToLayerPoint(latlng2).x;
            }
            this._updateBounds();
        }
    });
    // @factory L.circle(latlng: LatLng, options?: Circle options)
    // Instantiates a circle object given a geographical point, and an options object
    // which contains the circle radius.
    // @alternative
    // @factory L.circle(latlng: LatLng, radius: Number, options?: Circle options)
    // Obsolete way of instantiating a circle, for compatibility with 0.7.x code.
    // Do not use in new applications or plugins.
    function circle(latlng, options, legacyOptions) {
        return new Circle(latlng, options, legacyOptions);
    }
    /*
   * @class Polyline
   * @aka L.Polyline
   * @inherits Path
   *
   * A class for drawing polyline overlays on a map. Extends `Path`.
   *
   * @example
   *
   * ```js
   * // create a red polyline from an array of LatLng points
   * var latlngs = [
   * 	[45.51, -122.68],
   * 	[37.77, -122.43],
   * 	[34.04, -118.2]
   * ];
   *
   * var polyline = L.polyline(latlngs, {color: 'red'}).addTo(map);
   *
   * // zoom the map to the polyline
   * map.fitBounds(polyline.getBounds());
   * ```
   *
   * You can also pass a multi-dimensional array to represent a `MultiPolyline` shape:
   *
   * ```js
   * // create a red polyline from an array of arrays of LatLng points
   * var latlngs = [
   * 	[[45.51, -122.68],
   * 	 [37.77, -122.43],
   * 	 [34.04, -118.2]],
   * 	[[40.78, -73.91],
   * 	 [41.83, -87.62],
   * 	 [32.76, -96.72]]
   * ];
   * ```
   */ var Polyline = Path.extend({
        // @section
        // @aka Polyline options
        options: {
            // @option smoothFactor: Number = 1.0
            // How much to simplify the polyline on each zoom level. More means
            // better performance and smoother look, and less means more accurate representation.
            smoothFactor: 1.0,
            // @option noClip: Boolean = false
            // Disable polyline clipping.
            noClip: false
        },
        initialize: function(latlngs, options) {
            setOptions(this, options);
            this._setLatLngs(latlngs);
        },
        // @method getLatLngs(): LatLng[]
        // Returns an array of the points in the path, or nested arrays of points in case of multi-polyline.
        getLatLngs: function() {
            return this._latlngs;
        },
        // @method setLatLngs(latlngs: LatLng[]): this
        // Replaces all the points in the polyline with the given array of geographical points.
        setLatLngs: function(latlngs) {
            this._setLatLngs(latlngs);
            return this.redraw();
        },
        // @method isEmpty(): Boolean
        // Returns `true` if the Polyline has no LatLngs.
        isEmpty: function() {
            return !this._latlngs.length;
        },
        // @method closestLayerPoint(p: Point): Point
        // Returns the point closest to `p` on the Polyline.
        closestLayerPoint: function(p) {
            var minDistance = Infinity, minPoint = null, closest = _sqClosestPointOnSegment, p1, p2;
            for(var j = 0, jLen = this._parts.length; j < jLen; j++){
                var points = this._parts[j];
                for(var i = 1, len = points.length; i < len; i++){
                    p1 = points[i - 1];
                    p2 = points[i];
                    var sqDist = closest(p, p1, p2, true);
                    if (sqDist < minDistance) {
                        minDistance = sqDist;
                        minPoint = closest(p, p1, p2);
                    }
                }
            }
            if (minPoint) minPoint.distance = Math.sqrt(minDistance);
            return minPoint;
        },
        // @method getCenter(): LatLng
        // Returns the center ([centroid](https://en.wikipedia.org/wiki/Centroid)) of the polyline.
        getCenter: function() {
            // throws error when not yet added to map as this center calculation requires projected coordinates
            if (!this._map) throw new Error("Must add layer to map before using getCenter()");
            return polylineCenter(this._defaultShape(), this._map.options.crs);
        },
        // @method getBounds(): LatLngBounds
        // Returns the `LatLngBounds` of the path.
        getBounds: function() {
            return this._bounds;
        },
        // @method addLatLng(latlng: LatLng, latlngs?: LatLng[]): this
        // Adds a given point to the polyline. By default, adds to the first ring of
        // the polyline in case of a multi-polyline, but can be overridden by passing
        // a specific ring as a LatLng array (that you can earlier access with [`getLatLngs`](#polyline-getlatlngs)).
        addLatLng: function(latlng, latlngs) {
            latlngs = latlngs || this._defaultShape();
            latlng = toLatLng(latlng);
            latlngs.push(latlng);
            this._bounds.extend(latlng);
            return this.redraw();
        },
        _setLatLngs: function(latlngs) {
            this._bounds = new LatLngBounds();
            this._latlngs = this._convertLatLngs(latlngs);
        },
        _defaultShape: function() {
            return isFlat(this._latlngs) ? this._latlngs : this._latlngs[0];
        },
        // recursively convert latlngs input into actual LatLng instances; calculate bounds along the way
        _convertLatLngs: function(latlngs) {
            var result = [], flat = isFlat(latlngs);
            for(var i = 0, len = latlngs.length; i < len; i++)if (flat) {
                result[i] = toLatLng(latlngs[i]);
                this._bounds.extend(result[i]);
            } else result[i] = this._convertLatLngs(latlngs[i]);
            return result;
        },
        _project: function() {
            var pxBounds = new Bounds();
            this._rings = [];
            this._projectLatlngs(this._latlngs, this._rings, pxBounds);
            if (this._bounds.isValid() && pxBounds.isValid()) {
                this._rawPxBounds = pxBounds;
                this._updateBounds();
            }
        },
        _updateBounds: function() {
            var w = this._clickTolerance(), p = new Point(w, w);
            if (!this._rawPxBounds) return;
            this._pxBounds = new Bounds([
                this._rawPxBounds.min.subtract(p),
                this._rawPxBounds.max.add(p)
            ]);
        },
        // recursively turns latlngs into a set of rings with projected coordinates
        _projectLatlngs: function(latlngs, result, projectedBounds) {
            var flat = latlngs[0] instanceof LatLng, len = latlngs.length, i, ring;
            if (flat) {
                ring = [];
                for(i = 0; i < len; i++){
                    ring[i] = this._map.latLngToLayerPoint(latlngs[i]);
                    projectedBounds.extend(ring[i]);
                }
                result.push(ring);
            } else for(i = 0; i < len; i++)this._projectLatlngs(latlngs[i], result, projectedBounds);
        },
        // clip polyline by renderer bounds so that we have less to render for performance
        _clipPoints: function() {
            var bounds = this._renderer._bounds;
            this._parts = [];
            if (!this._pxBounds || !this._pxBounds.intersects(bounds)) return;
            if (this.options.noClip) {
                this._parts = this._rings;
                return;
            }
            var parts = this._parts, i, j, k, len, len2, segment, points;
            for(i = 0, k = 0, len = this._rings.length; i < len; i++){
                points = this._rings[i];
                for(j = 0, len2 = points.length; j < len2 - 1; j++){
                    segment = clipSegment(points[j], points[j + 1], bounds, j, true);
                    if (!segment) continue;
                    parts[k] = parts[k] || [];
                    parts[k].push(segment[0]);
                    // if segment goes out of screen, or it's the last one, it's the end of the line part
                    if (segment[1] !== points[j + 1] || j === len2 - 2) {
                        parts[k].push(segment[1]);
                        k++;
                    }
                }
            }
        },
        // simplify each clipped part of the polyline for performance
        _simplifyPoints: function() {
            var parts = this._parts, tolerance = this.options.smoothFactor;
            for(var i = 0, len = parts.length; i < len; i++)parts[i] = simplify(parts[i], tolerance);
        },
        _update: function() {
            if (!this._map) return;
            this._clipPoints();
            this._simplifyPoints();
            this._updatePath();
        },
        _updatePath: function() {
            this._renderer._updatePoly(this);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p, closed) {
            var i, j, k, len, len2, part, w = this._clickTolerance();
            if (!this._pxBounds || !this._pxBounds.contains(p)) return false;
            // hit detection for polylines
            for(i = 0, len = this._parts.length; i < len; i++){
                part = this._parts[i];
                for(j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++){
                    if (!closed && j === 0) continue;
                    if (pointToSegmentDistance(p, part[k], part[j]) <= w) return true;
                }
            }
            return false;
        }
    });
    // @factory L.polyline(latlngs: LatLng[], options?: Polyline options)
    // Instantiates a polyline object given an array of geographical points and
    // optionally an options object. You can create a `Polyline` object with
    // multiple separate lines (`MultiPolyline`) by passing an array of arrays
    // of geographic points.
    function polyline(latlngs, options) {
        return new Polyline(latlngs, options);
    }
    // Retrocompat. Allow plugins to support Leaflet versions before and after 1.1.
    Polyline._flat = _flat;
    /*
   * @class Polygon
   * @aka L.Polygon
   * @inherits Polyline
   *
   * A class for drawing polygon overlays on a map. Extends `Polyline`.
   *
   * Note that points you pass when creating a polygon shouldn't have an additional last point equal to the first one — it's better to filter out such points.
   *
   *
   * @example
   *
   * ```js
   * // create a red polygon from an array of LatLng points
   * var latlngs = [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]];
   *
   * var polygon = L.polygon(latlngs, {color: 'red'}).addTo(map);
   *
   * // zoom the map to the polygon
   * map.fitBounds(polygon.getBounds());
   * ```
   *
   * You can also pass an array of arrays of latlngs, with the first array representing the outer shape and the other arrays representing holes in the outer shape:
   *
   * ```js
   * var latlngs = [
   *   [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
   *   [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
   * ];
   * ```
   *
   * Additionally, you can pass a multi-dimensional array to represent a MultiPolygon shape.
   *
   * ```js
   * var latlngs = [
   *   [ // first polygon
   *     [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
   *     [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
   *   ],
   *   [ // second polygon
   *     [[41, -111.03],[45, -111.04],[45, -104.05],[41, -104.05]]
   *   ]
   * ];
   * ```
   */ var Polygon = Polyline.extend({
        options: {
            fill: true
        },
        isEmpty: function() {
            return !this._latlngs.length || !this._latlngs[0].length;
        },
        // @method getCenter(): LatLng
        // Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the Polygon.
        getCenter: function() {
            // throws error when not yet added to map as this center calculation requires projected coordinates
            if (!this._map) throw new Error("Must add layer to map before using getCenter()");
            return polygonCenter(this._defaultShape(), this._map.options.crs);
        },
        _convertLatLngs: function(latlngs) {
            var result = Polyline.prototype._convertLatLngs.call(this, latlngs), len = result.length;
            // remove last point if it equals first one
            if (len >= 2 && result[0] instanceof LatLng && result[0].equals(result[len - 1])) result.pop();
            return result;
        },
        _setLatLngs: function(latlngs) {
            Polyline.prototype._setLatLngs.call(this, latlngs);
            if (isFlat(this._latlngs)) this._latlngs = [
                this._latlngs
            ];
        },
        _defaultShape: function() {
            return isFlat(this._latlngs[0]) ? this._latlngs[0] : this._latlngs[0][0];
        },
        _clipPoints: function() {
            // polygons need a different clipping algorithm so we redefine that
            var bounds = this._renderer._bounds, w = this.options.weight, p = new Point(w, w);
            // increase clip padding by stroke width to avoid stroke on clip edges
            bounds = new Bounds(bounds.min.subtract(p), bounds.max.add(p));
            this._parts = [];
            if (!this._pxBounds || !this._pxBounds.intersects(bounds)) return;
            if (this.options.noClip) {
                this._parts = this._rings;
                return;
            }
            for(var i = 0, len = this._rings.length, clipped; i < len; i++){
                clipped = clipPolygon(this._rings[i], bounds, true);
                if (clipped.length) this._parts.push(clipped);
            }
        },
        _updatePath: function() {
            this._renderer._updatePoly(this, true);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p) {
            var inside = false, part, p1, p2, i, j, k, len, len2;
            if (!this._pxBounds || !this._pxBounds.contains(p)) return false;
            // ray casting algorithm for detecting if point is in polygon
            for(i = 0, len = this._parts.length; i < len; i++){
                part = this._parts[i];
                for(j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++){
                    p1 = part[j];
                    p2 = part[k];
                    if (p1.y > p.y !== p2.y > p.y && p.x < (p2.x - p1.x) * (p.y - p1.y) / (p2.y - p1.y) + p1.x) inside = !inside;
                }
            }
            // also check if it's on polygon stroke
            return inside || Polyline.prototype._containsPoint.call(this, p, true);
        }
    });
    // @factory L.polygon(latlngs: LatLng[], options?: Polyline options)
    function polygon(latlngs, options) {
        return new Polygon(latlngs, options);
    }
    /*
   * @class GeoJSON
   * @aka L.GeoJSON
   * @inherits FeatureGroup
   *
   * Represents a GeoJSON object or an array of GeoJSON objects. Allows you to parse
   * GeoJSON data and display it on the map. Extends `FeatureGroup`.
   *
   * @example
   *
   * ```js
   * L.geoJSON(data, {
   * 	style: function (feature) {
   * 		return {color: feature.properties.color};
   * 	}
   * }).bindPopup(function (layer) {
   * 	return layer.feature.properties.description;
   * }).addTo(map);
   * ```
   */ var GeoJSON = FeatureGroup.extend({
        /* @section
  	 * @aka GeoJSON options
  	 *
  	 * @option pointToLayer: Function = *
  	 * A `Function` defining how GeoJSON points spawn Leaflet layers. It is internally
  	 * called when data is added, passing the GeoJSON point feature and its `LatLng`.
  	 * The default is to spawn a default `Marker`:
  	 * ```js
  	 * function(geoJsonPoint, latlng) {
  	 * 	return L.marker(latlng);
  	 * }
  	 * ```
  	 *
  	 * @option style: Function = *
  	 * A `Function` defining the `Path options` for styling GeoJSON lines and polygons,
  	 * called internally when data is added.
  	 * The default value is to not override any defaults:
  	 * ```js
  	 * function (geoJsonFeature) {
  	 * 	return {}
  	 * }
  	 * ```
  	 *
  	 * @option onEachFeature: Function = *
  	 * A `Function` that will be called once for each created `Feature`, after it has
  	 * been created and styled. Useful for attaching events and popups to features.
  	 * The default is to do nothing with the newly created layers:
  	 * ```js
  	 * function (feature, layer) {}
  	 * ```
  	 *
  	 * @option filter: Function = *
  	 * A `Function` that will be used to decide whether to include a feature or not.
  	 * The default is to include all features:
  	 * ```js
  	 * function (geoJsonFeature) {
  	 * 	return true;
  	 * }
  	 * ```
  	 * Note: dynamically changing the `filter` option will have effect only on newly
  	 * added data. It will _not_ re-evaluate already included features.
  	 *
  	 * @option coordsToLatLng: Function = *
  	 * A `Function` that will be used for converting GeoJSON coordinates to `LatLng`s.
  	 * The default is the `coordsToLatLng` static method.
  	 *
  	 * @option markersInheritOptions: Boolean = false
  	 * Whether default Markers for "Point" type Features inherit from group options.
  	 */ initialize: function(geojson, options) {
            setOptions(this, options);
            this._layers = {};
            if (geojson) this.addData(geojson);
        },
        // @method addData( <GeoJSON> data ): this
        // Adds a GeoJSON object to the layer.
        addData: function(geojson) {
            var features = isArray(geojson) ? geojson : geojson.features, i, len, feature;
            if (features) {
                for(i = 0, len = features.length; i < len; i++){
                    // only add this if geometry or geometries are set and not null
                    feature = features[i];
                    if (feature.geometries || feature.geometry || feature.features || feature.coordinates) this.addData(feature);
                }
                return this;
            }
            var options = this.options;
            if (options.filter && !options.filter(geojson)) return this;
            var layer = geometryToLayer(geojson, options);
            if (!layer) return this;
            layer.feature = asFeature(geojson);
            layer.defaultOptions = layer.options;
            this.resetStyle(layer);
            if (options.onEachFeature) options.onEachFeature(geojson, layer);
            return this.addLayer(layer);
        },
        // @method resetStyle( <Path> layer? ): this
        // Resets the given vector layer's style to the original GeoJSON style, useful for resetting style after hover events.
        // If `layer` is omitted, the style of all features in the current layer is reset.
        resetStyle: function(layer) {
            if (layer === undefined) return this.eachLayer(this.resetStyle, this);
            // reset any custom styles
            layer.options = extend({}, layer.defaultOptions);
            this._setLayerStyle(layer, this.options.style);
            return this;
        },
        // @method setStyle( <Function> style ): this
        // Changes styles of GeoJSON vector layers with the given style function.
        setStyle: function(style) {
            return this.eachLayer(function(layer) {
                this._setLayerStyle(layer, style);
            }, this);
        },
        _setLayerStyle: function(layer, style) {
            if (layer.setStyle) {
                if (typeof style === "function") style = style(layer.feature);
                layer.setStyle(style);
            }
        }
    });
    // @section
    // There are several static functions which can be called without instantiating L.GeoJSON:
    // @function geometryToLayer(featureData: Object, options?: GeoJSON options): Layer
    // Creates a `Layer` from a given GeoJSON feature. Can use a custom
    // [`pointToLayer`](#geojson-pointtolayer) and/or [`coordsToLatLng`](#geojson-coordstolatlng)
    // functions if provided as options.
    function geometryToLayer(geojson, options) {
        var geometry = geojson.type === "Feature" ? geojson.geometry : geojson, coords = geometry ? geometry.coordinates : null, layers = [], pointToLayer = options && options.pointToLayer, _coordsToLatLng = options && options.coordsToLatLng || coordsToLatLng, latlng, latlngs, i, len;
        if (!coords && !geometry) return null;
        switch(geometry.type){
            case "Point":
                latlng = _coordsToLatLng(coords);
                return _pointToLayer(pointToLayer, geojson, latlng, options);
            case "MultiPoint":
                for(i = 0, len = coords.length; i < len; i++){
                    latlng = _coordsToLatLng(coords[i]);
                    layers.push(_pointToLayer(pointToLayer, geojson, latlng, options));
                }
                return new FeatureGroup(layers);
            case "LineString":
            case "MultiLineString":
                latlngs = coordsToLatLngs(coords, geometry.type === "LineString" ? 0 : 1, _coordsToLatLng);
                return new Polyline(latlngs, options);
            case "Polygon":
            case "MultiPolygon":
                latlngs = coordsToLatLngs(coords, geometry.type === "Polygon" ? 1 : 2, _coordsToLatLng);
                return new Polygon(latlngs, options);
            case "GeometryCollection":
                for(i = 0, len = geometry.geometries.length; i < len; i++){
                    var geoLayer = geometryToLayer({
                        geometry: geometry.geometries[i],
                        type: "Feature",
                        properties: geojson.properties
                    }, options);
                    if (geoLayer) layers.push(geoLayer);
                }
                return new FeatureGroup(layers);
            case "FeatureCollection":
                for(i = 0, len = geometry.features.length; i < len; i++){
                    var featureLayer = geometryToLayer(geometry.features[i], options);
                    if (featureLayer) layers.push(featureLayer);
                }
                return new FeatureGroup(layers);
            default:
                throw new Error("Invalid GeoJSON object.");
        }
    }
    function _pointToLayer(pointToLayerFn, geojson, latlng, options) {
        return pointToLayerFn ? pointToLayerFn(geojson, latlng) : new Marker(latlng, options && options.markersInheritOptions && options);
    }
    // @function coordsToLatLng(coords: Array): LatLng
    // Creates a `LatLng` object from an array of 2 numbers (longitude, latitude)
    // or 3 numbers (longitude, latitude, altitude) used in GeoJSON for points.
    function coordsToLatLng(coords) {
        return new LatLng(coords[1], coords[0], coords[2]);
    }
    // @function coordsToLatLngs(coords: Array, levelsDeep?: Number, coordsToLatLng?: Function): Array
    // Creates a multidimensional array of `LatLng`s from a GeoJSON coordinates array.
    // `levelsDeep` specifies the nesting level (0 is for an array of points, 1 for an array of arrays of points, etc., 0 by default).
    // Can use a custom [`coordsToLatLng`](#geojson-coordstolatlng) function.
    function coordsToLatLngs(coords, levelsDeep, _coordsToLatLng) {
        var latlngs = [];
        for(var i = 0, len = coords.length, latlng; i < len; i++){
            latlng = levelsDeep ? coordsToLatLngs(coords[i], levelsDeep - 1, _coordsToLatLng) : (_coordsToLatLng || coordsToLatLng)(coords[i]);
            latlngs.push(latlng);
        }
        return latlngs;
    }
    // @function latLngToCoords(latlng: LatLng, precision?: Number|false): Array
    // Reverse of [`coordsToLatLng`](#geojson-coordstolatlng)
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function.
    function latLngToCoords(latlng, precision) {
        latlng = toLatLng(latlng);
        return latlng.alt !== undefined ? [
            formatNum(latlng.lng, precision),
            formatNum(latlng.lat, precision),
            formatNum(latlng.alt, precision)
        ] : [
            formatNum(latlng.lng, precision),
            formatNum(latlng.lat, precision)
        ];
    }
    // @function latLngsToCoords(latlngs: Array, levelsDeep?: Number, closed?: Boolean, precision?: Number|false): Array
    // Reverse of [`coordsToLatLngs`](#geojson-coordstolatlngs)
    // `closed` determines whether the first point should be appended to the end of the array to close the feature, only used when `levelsDeep` is 0. False by default.
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function.
    function latLngsToCoords(latlngs, levelsDeep, closed, precision) {
        var coords = [];
        for(var i = 0, len = latlngs.length; i < len; i++)// Check for flat arrays required to ensure unbalanced arrays are correctly converted in recursion
        coords.push(levelsDeep ? latLngsToCoords(latlngs[i], isFlat(latlngs[i]) ? 0 : levelsDeep - 1, closed, precision) : latLngToCoords(latlngs[i], precision));
        if (!levelsDeep && closed && coords.length > 0) coords.push(coords[0].slice());
        return coords;
    }
    function getFeature(layer, newGeometry) {
        return layer.feature ? extend({}, layer.feature, {
            geometry: newGeometry
        }) : asFeature(newGeometry);
    }
    // @function asFeature(geojson: Object): Object
    // Normalize GeoJSON geometries/features into GeoJSON features.
    function asFeature(geojson) {
        if (geojson.type === "Feature" || geojson.type === "FeatureCollection") return geojson;
        return {
            type: "Feature",
            properties: {},
            geometry: geojson
        };
    }
    var PointToGeoJSON = {
        toGeoJSON: function(precision) {
            return getFeature(this, {
                type: "Point",
                coordinates: latLngToCoords(this.getLatLng(), precision)
            });
        }
    };
    // @namespace Marker
    // @section Other methods
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the marker (as a GeoJSON `Point` Feature).
    Marker.include(PointToGeoJSON);
    // @namespace CircleMarker
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the circle marker (as a GeoJSON `Point` Feature).
    Circle.include(PointToGeoJSON);
    CircleMarker.include(PointToGeoJSON);
    // @namespace Polyline
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the polyline (as a GeoJSON `LineString` or `MultiLineString` Feature).
    Polyline.include({
        toGeoJSON: function(precision) {
            var multi = !isFlat(this._latlngs);
            var coords = latLngsToCoords(this._latlngs, multi ? 1 : 0, false, precision);
            return getFeature(this, {
                type: (multi ? "Multi" : "") + "LineString",
                coordinates: coords
            });
        }
    });
    // @namespace Polygon
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the polygon (as a GeoJSON `Polygon` or `MultiPolygon` Feature).
    Polygon.include({
        toGeoJSON: function(precision) {
            var holes = !isFlat(this._latlngs), multi = holes && !isFlat(this._latlngs[0]);
            var coords = latLngsToCoords(this._latlngs, multi ? 2 : holes ? 1 : 0, true, precision);
            if (!holes) coords = [
                coords
            ];
            return getFeature(this, {
                type: (multi ? "Multi" : "") + "Polygon",
                coordinates: coords
            });
        }
    });
    // @namespace LayerGroup
    LayerGroup.include({
        toMultiPoint: function(precision) {
            var coords = [];
            this.eachLayer(function(layer) {
                coords.push(layer.toGeoJSON(precision).geometry.coordinates);
            });
            return getFeature(this, {
                type: "MultiPoint",
                coordinates: coords
            });
        },
        // @method toGeoJSON(precision?: Number|false): Object
        // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
        // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the layer group (as a GeoJSON `FeatureCollection`, `GeometryCollection`, or `MultiPoint`).
        toGeoJSON: function(precision) {
            var type = this.feature && this.feature.geometry && this.feature.geometry.type;
            if (type === "MultiPoint") return this.toMultiPoint(precision);
            var isGeometryCollection = type === "GeometryCollection", jsons = [];
            this.eachLayer(function(layer) {
                if (layer.toGeoJSON) {
                    var json = layer.toGeoJSON(precision);
                    if (isGeometryCollection) jsons.push(json.geometry);
                    else {
                        var feature = asFeature(json);
                        // Squash nested feature collections
                        if (feature.type === "FeatureCollection") jsons.push.apply(jsons, feature.features);
                        else jsons.push(feature);
                    }
                }
            });
            if (isGeometryCollection) return getFeature(this, {
                geometries: jsons,
                type: "GeometryCollection"
            });
            return {
                type: "FeatureCollection",
                features: jsons
            };
        }
    });
    // @namespace GeoJSON
    // @factory L.geoJSON(geojson?: Object, options?: GeoJSON options)
    // Creates a GeoJSON layer. Optionally accepts an object in
    // [GeoJSON format](https://tools.ietf.org/html/rfc7946) to display on the map
    // (you can alternatively add it later with `addData` method) and an `options` object.
    function geoJSON(geojson, options) {
        return new GeoJSON(geojson, options);
    }
    // Backward compatibility.
    var geoJson = geoJSON;
    /*
   * @class ImageOverlay
   * @aka L.ImageOverlay
   * @inherits Interactive layer
   *
   * Used to load and display a single image over specific bounds of the map. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * var imageUrl = 'https://maps.lib.utexas.edu/maps/historical/newark_nj_1922.jpg',
   * 	imageBounds = [[40.712216, -74.22655], [40.773941, -74.12544]];
   * L.imageOverlay(imageUrl, imageBounds).addTo(map);
   * ```
   */ var ImageOverlay = Layer.extend({
        // @section
        // @aka ImageOverlay options
        options: {
            // @option opacity: Number = 1.0
            // The opacity of the image overlay.
            opacity: 1,
            // @option alt: String = ''
            // Text for the `alt` attribute of the image (useful for accessibility).
            alt: "",
            // @option interactive: Boolean = false
            // If `true`, the image overlay will emit [mouse events](#interactive-layer) when clicked or hovered.
            interactive: false,
            // @option crossOrigin: Boolean|String = false
            // Whether the crossOrigin attribute will be added to the image.
            // If a String is provided, the image will have its crossOrigin attribute set to the String provided. This is needed if you want to access image pixel data.
            // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
            crossOrigin: false,
            // @option errorOverlayUrl: String = ''
            // URL to the overlay image to show in place of the overlay that failed to load.
            errorOverlayUrl: "",
            // @option zIndex: Number = 1
            // The explicit [zIndex](https://developer.mozilla.org/docs/Web/CSS/CSS_Positioning/Understanding_z_index) of the overlay layer.
            zIndex: 1,
            // @option className: String = ''
            // A custom class name to assign to the image. Empty by default.
            className: ""
        },
        initialize: function(url, bounds, options) {
            this._url = url;
            this._bounds = toLatLngBounds(bounds);
            setOptions(this, options);
        },
        onAdd: function() {
            if (!this._image) {
                this._initImage();
                if (this.options.opacity < 1) this._updateOpacity();
            }
            if (this.options.interactive) {
                addClass(this._image, "leaflet-interactive");
                this.addInteractiveTarget(this._image);
            }
            this.getPane().appendChild(this._image);
            this._reset();
        },
        onRemove: function() {
            remove(this._image);
            if (this.options.interactive) this.removeInteractiveTarget(this._image);
        },
        // @method setOpacity(opacity: Number): this
        // Sets the opacity of the overlay.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._image) this._updateOpacity();
            return this;
        },
        setStyle: function(styleOpts) {
            if (styleOpts.opacity) this.setOpacity(styleOpts.opacity);
            return this;
        },
        // @method bringToFront(): this
        // Brings the layer to the top of all overlays.
        bringToFront: function() {
            if (this._map) toFront(this._image);
            return this;
        },
        // @method bringToBack(): this
        // Brings the layer to the bottom of all overlays.
        bringToBack: function() {
            if (this._map) toBack(this._image);
            return this;
        },
        // @method setUrl(url: String): this
        // Changes the URL of the image.
        setUrl: function(url) {
            this._url = url;
            if (this._image) this._image.src = url;
            return this;
        },
        // @method setBounds(bounds: LatLngBounds): this
        // Update the bounds that this ImageOverlay covers
        setBounds: function(bounds) {
            this._bounds = toLatLngBounds(bounds);
            if (this._map) this._reset();
            return this;
        },
        getEvents: function() {
            var events = {
                zoom: this._reset,
                viewreset: this._reset
            };
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @method setZIndex(value: Number): this
        // Changes the [zIndex](#imageoverlay-zindex) of the image overlay.
        setZIndex: function(value) {
            this.options.zIndex = value;
            this._updateZIndex();
            return this;
        },
        // @method getBounds(): LatLngBounds
        // Get the bounds that this ImageOverlay covers
        getBounds: function() {
            return this._bounds;
        },
        // @method getElement(): HTMLElement
        // Returns the instance of [`HTMLImageElement`](https://developer.mozilla.org/docs/Web/API/HTMLImageElement)
        // used by this overlay.
        getElement: function() {
            return this._image;
        },
        _initImage: function() {
            var wasElementSupplied = this._url.tagName === "IMG";
            var img = this._image = wasElementSupplied ? this._url : create$1("img");
            addClass(img, "leaflet-image-layer");
            if (this._zoomAnimated) addClass(img, "leaflet-zoom-animated");
            if (this.options.className) addClass(img, this.options.className);
            img.onselectstart = falseFn;
            img.onmousemove = falseFn;
            // @event load: Event
            // Fired when the ImageOverlay layer has loaded its image
            img.onload = bind(this.fire, this, "load");
            img.onerror = bind(this._overlayOnError, this, "error");
            if (this.options.crossOrigin || this.options.crossOrigin === "") img.crossOrigin = this.options.crossOrigin === true ? "" : this.options.crossOrigin;
            if (this.options.zIndex) this._updateZIndex();
            if (wasElementSupplied) {
                this._url = img.src;
                return;
            }
            img.src = this._url;
            img.alt = this.options.alt;
        },
        _animateZoom: function(e) {
            var scale = this._map.getZoomScale(e.zoom), offset = this._map._latLngBoundsToNewLayerBounds(this._bounds, e.zoom, e.center).min;
            setTransform(this._image, offset, scale);
        },
        _reset: function() {
            var image = this._image, bounds = new Bounds(this._map.latLngToLayerPoint(this._bounds.getNorthWest()), this._map.latLngToLayerPoint(this._bounds.getSouthEast())), size = bounds.getSize();
            setPosition(image, bounds.min);
            image.style.width = size.x + "px";
            image.style.height = size.y + "px";
        },
        _updateOpacity: function() {
            setOpacity(this._image, this.options.opacity);
        },
        _updateZIndex: function() {
            if (this._image && this.options.zIndex !== undefined && this.options.zIndex !== null) this._image.style.zIndex = this.options.zIndex;
        },
        _overlayOnError: function() {
            // @event error: Event
            // Fired when the ImageOverlay layer fails to load its image
            this.fire("error");
            var errorUrl = this.options.errorOverlayUrl;
            if (errorUrl && this._url !== errorUrl) {
                this._url = errorUrl;
                this._image.src = errorUrl;
            }
        },
        // @method getCenter(): LatLng
        // Returns the center of the ImageOverlay.
        getCenter: function() {
            return this._bounds.getCenter();
        }
    });
    // @factory L.imageOverlay(imageUrl: String, bounds: LatLngBounds, options?: ImageOverlay options)
    // Instantiates an image overlay object given the URL of the image and the
    // geographical bounds it is tied to.
    var imageOverlay = function(url, bounds, options) {
        return new ImageOverlay(url, bounds, options);
    };
    /*
   * @class VideoOverlay
   * @aka L.VideoOverlay
   * @inherits ImageOverlay
   *
   * Used to load and display a video player over specific bounds of the map. Extends `ImageOverlay`.
   *
   * A video overlay uses the [`<video>`](https://developer.mozilla.org/docs/Web/HTML/Element/video)
   * HTML5 element.
   *
   * @example
   *
   * ```js
   * var videoUrl = 'https://www.mapbox.com/bites/00188/patricia_nasa.webm',
   * 	videoBounds = [[ 32, -130], [ 13, -100]];
   * L.videoOverlay(videoUrl, videoBounds ).addTo(map);
   * ```
   */ var VideoOverlay = ImageOverlay.extend({
        // @section
        // @aka VideoOverlay options
        options: {
            // @option autoplay: Boolean = true
            // Whether the video starts playing automatically when loaded.
            // On some browsers autoplay will only work with `muted: true`
            autoplay: true,
            // @option loop: Boolean = true
            // Whether the video will loop back to the beginning when played.
            loop: true,
            // @option keepAspectRatio: Boolean = true
            // Whether the video will save aspect ratio after the projection.
            // Relevant for supported browsers. See [browser compatibility](https://developer.mozilla.org/en-US/docs/Web/CSS/object-fit)
            keepAspectRatio: true,
            // @option muted: Boolean = false
            // Whether the video starts on mute when loaded.
            muted: false,
            // @option playsInline: Boolean = true
            // Mobile browsers will play the video right where it is instead of open it up in fullscreen mode.
            playsInline: true
        },
        _initImage: function() {
            var wasElementSupplied = this._url.tagName === "VIDEO";
            var vid = this._image = wasElementSupplied ? this._url : create$1("video");
            addClass(vid, "leaflet-image-layer");
            if (this._zoomAnimated) addClass(vid, "leaflet-zoom-animated");
            if (this.options.className) addClass(vid, this.options.className);
            vid.onselectstart = falseFn;
            vid.onmousemove = falseFn;
            // @event load: Event
            // Fired when the video has finished loading the first frame
            vid.onloadeddata = bind(this.fire, this, "load");
            if (wasElementSupplied) {
                var sourceElements = vid.getElementsByTagName("source");
                var sources = [];
                for(var j = 0; j < sourceElements.length; j++)sources.push(sourceElements[j].src);
                this._url = sourceElements.length > 0 ? sources : [
                    vid.src
                ];
                return;
            }
            if (!isArray(this._url)) this._url = [
                this._url
            ];
            if (!this.options.keepAspectRatio && Object.prototype.hasOwnProperty.call(vid.style, "objectFit")) vid.style["objectFit"] = "fill";
            vid.autoplay = !!this.options.autoplay;
            vid.loop = !!this.options.loop;
            vid.muted = !!this.options.muted;
            vid.playsInline = !!this.options.playsInline;
            for(var i = 0; i < this._url.length; i++){
                var source = create$1("source");
                source.src = this._url[i];
                vid.appendChild(source);
            }
        }
    });
    // @factory L.videoOverlay(video: String|Array|HTMLVideoElement, bounds: LatLngBounds, options?: VideoOverlay options)
    // Instantiates an image overlay object given the URL of the video (or array of URLs, or even a video element) and the
    // geographical bounds it is tied to.
    function videoOverlay(video, bounds, options) {
        return new VideoOverlay(video, bounds, options);
    }
    /*
   * @class SVGOverlay
   * @aka L.SVGOverlay
   * @inherits ImageOverlay
   *
   * Used to load, display and provide DOM access to an SVG file over specific bounds of the map. Extends `ImageOverlay`.
   *
   * An SVG overlay uses the [`<svg>`](https://developer.mozilla.org/docs/Web/SVG/Element/svg) element.
   *
   * @example
   *
   * ```js
   * var svgElement = document.createElementNS("http://www.w3.org/2000/svg", "svg");
   * svgElement.setAttribute('xmlns', "http://www.w3.org/2000/svg");
   * svgElement.setAttribute('viewBox', "0 0 200 200");
   * svgElement.innerHTML = '<rect width="200" height="200"/><rect x="75" y="23" width="50" height="50" style="fill:red"/><rect x="75" y="123" width="50" height="50" style="fill:#0013ff"/>';
   * var svgElementBounds = [ [ 32, -130 ], [ 13, -100 ] ];
   * L.svgOverlay(svgElement, svgElementBounds).addTo(map);
   * ```
   */ var SVGOverlay = ImageOverlay.extend({
        _initImage: function() {
            var el = this._image = this._url;
            addClass(el, "leaflet-image-layer");
            if (this._zoomAnimated) addClass(el, "leaflet-zoom-animated");
            if (this.options.className) addClass(el, this.options.className);
            el.onselectstart = falseFn;
            el.onmousemove = falseFn;
        }
    });
    // @factory L.svgOverlay(svg: String|SVGElement, bounds: LatLngBounds, options?: SVGOverlay options)
    // Instantiates an image overlay object given an SVG element and the geographical bounds it is tied to.
    // A viewBox attribute is required on the SVG element to zoom in and out properly.
    function svgOverlay(el, bounds, options) {
        return new SVGOverlay(el, bounds, options);
    }
    /*
   * @class DivOverlay
   * @inherits Interactive layer
   * @aka L.DivOverlay
   * Base model for L.Popup and L.Tooltip. Inherit from it for custom overlays like plugins.
   */ // @namespace DivOverlay
    var DivOverlay = Layer.extend({
        // @section
        // @aka DivOverlay options
        options: {
            // @option interactive: Boolean = false
            // If true, the popup/tooltip will listen to the mouse events.
            interactive: false,
            // @option offset: Point = Point(0, 0)
            // The offset of the overlay position.
            offset: [
                0,
                0
            ],
            // @option className: String = ''
            // A custom CSS class name to assign to the overlay.
            className: "",
            // @option pane: String = undefined
            // `Map pane` where the overlay will be added.
            pane: undefined,
            // @option content: String|HTMLElement|Function = ''
            // Sets the HTML content of the overlay while initializing. If a function is passed the source layer will be
            // passed to the function. The function should return a `String` or `HTMLElement` to be used in the overlay.
            content: ""
        },
        initialize: function(options, source) {
            if (options && (options instanceof LatLng || isArray(options))) {
                this._latlng = toLatLng(options);
                setOptions(this, source);
            } else {
                setOptions(this, options);
                this._source = source;
            }
            if (this.options.content) this._content = this.options.content;
        },
        // @method openOn(map: Map): this
        // Adds the overlay to the map.
        // Alternative to `map.openPopup(popup)`/`.openTooltip(tooltip)`.
        openOn: function(map) {
            map = arguments.length ? map : this._source._map; // experimental, not the part of public api
            if (!map.hasLayer(this)) map.addLayer(this);
            return this;
        },
        // @method close(): this
        // Closes the overlay.
        // Alternative to `map.closePopup(popup)`/`.closeTooltip(tooltip)`
        // and `layer.closePopup()`/`.closeTooltip()`.
        close: function() {
            if (this._map) this._map.removeLayer(this);
            return this;
        },
        // @method toggle(layer?: Layer): this
        // Opens or closes the overlay bound to layer depending on its current state.
        // Argument may be omitted only for overlay bound to layer.
        // Alternative to `layer.togglePopup()`/`.toggleTooltip()`.
        toggle: function(layer) {
            if (this._map) this.close();
            else {
                if (arguments.length) this._source = layer;
                else layer = this._source;
                this._prepareOpen();
                // open the overlay on the map
                this.openOn(layer._map);
            }
            return this;
        },
        onAdd: function(map) {
            this._zoomAnimated = map._zoomAnimated;
            if (!this._container) this._initLayout();
            if (map._fadeAnimated) setOpacity(this._container, 0);
            clearTimeout(this._removeTimeout);
            this.getPane().appendChild(this._container);
            this.update();
            if (map._fadeAnimated) setOpacity(this._container, 1);
            this.bringToFront();
            if (this.options.interactive) {
                addClass(this._container, "leaflet-interactive");
                this.addInteractiveTarget(this._container);
            }
        },
        onRemove: function(map) {
            if (map._fadeAnimated) {
                setOpacity(this._container, 0);
                this._removeTimeout = setTimeout(bind(remove, undefined, this._container), 200);
            } else remove(this._container);
            if (this.options.interactive) {
                removeClass(this._container, "leaflet-interactive");
                this.removeInteractiveTarget(this._container);
            }
        },
        // @namespace DivOverlay
        // @method getLatLng: LatLng
        // Returns the geographical point of the overlay.
        getLatLng: function() {
            return this._latlng;
        },
        // @method setLatLng(latlng: LatLng): this
        // Sets the geographical point where the overlay will open.
        setLatLng: function(latlng) {
            this._latlng = toLatLng(latlng);
            if (this._map) {
                this._updatePosition();
                this._adjustPan();
            }
            return this;
        },
        // @method getContent: String|HTMLElement
        // Returns the content of the overlay.
        getContent: function() {
            return this._content;
        },
        // @method setContent(htmlContent: String|HTMLElement|Function): this
        // Sets the HTML content of the overlay. If a function is passed the source layer will be passed to the function.
        // The function should return a `String` or `HTMLElement` to be used in the overlay.
        setContent: function(content) {
            this._content = content;
            this.update();
            return this;
        },
        // @method getElement: String|HTMLElement
        // Returns the HTML container of the overlay.
        getElement: function() {
            return this._container;
        },
        // @method update: null
        // Updates the overlay content, layout and position. Useful for updating the overlay after something inside changed, e.g. image loaded.
        update: function() {
            if (!this._map) return;
            this._container.style.visibility = "hidden";
            this._updateContent();
            this._updateLayout();
            this._updatePosition();
            this._container.style.visibility = "";
            this._adjustPan();
        },
        getEvents: function() {
            var events = {
                zoom: this._updatePosition,
                viewreset: this._updatePosition
            };
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @method isOpen: Boolean
        // Returns `true` when the overlay is visible on the map.
        isOpen: function() {
            return !!this._map && this._map.hasLayer(this);
        },
        // @method bringToFront: this
        // Brings this overlay in front of other overlays (in the same map pane).
        bringToFront: function() {
            if (this._map) toFront(this._container);
            return this;
        },
        // @method bringToBack: this
        // Brings this overlay to the back of other overlays (in the same map pane).
        bringToBack: function() {
            if (this._map) toBack(this._container);
            return this;
        },
        // prepare bound overlay to open: update latlng pos / content source (for FeatureGroup)
        _prepareOpen: function(latlng) {
            var source = this._source;
            if (!source._map) return false;
            if (source instanceof FeatureGroup) {
                source = null;
                var layers = this._source._layers;
                for(var id in layers)if (layers[id]._map) {
                    source = layers[id];
                    break;
                }
                if (!source) return false;
                 // Unable to get source layer.
                // set overlay source to this layer
                this._source = source;
            }
            if (!latlng) {
                if (source.getCenter) latlng = source.getCenter();
                else if (source.getLatLng) latlng = source.getLatLng();
                else if (source.getBounds) latlng = source.getBounds().getCenter();
                else throw new Error("Unable to get source layer LatLng.");
            }
            this.setLatLng(latlng);
            if (this._map) // update the overlay (content, layout, etc...)
            this.update();
            return true;
        },
        _updateContent: function() {
            if (!this._content) return;
            var node = this._contentNode;
            var content = typeof this._content === "function" ? this._content(this._source || this) : this._content;
            if (typeof content === "string") node.innerHTML = content;
            else {
                while(node.hasChildNodes())node.removeChild(node.firstChild);
                node.appendChild(content);
            }
            // @namespace DivOverlay
            // @section DivOverlay events
            // @event contentupdate: Event
            // Fired when the content of the overlay is updated
            this.fire("contentupdate");
        },
        _updatePosition: function() {
            if (!this._map) return;
            var pos = this._map.latLngToLayerPoint(this._latlng), offset = toPoint(this.options.offset), anchor = this._getAnchor();
            if (this._zoomAnimated) setPosition(this._container, pos.add(anchor));
            else offset = offset.add(pos).add(anchor);
            var bottom = this._containerBottom = -offset.y, left = this._containerLeft = -Math.round(this._containerWidth / 2) + offset.x;
            // bottom position the overlay in case the height of the overlay changes (images loading etc)
            this._container.style.bottom = bottom + "px";
            this._container.style.left = left + "px";
        },
        _getAnchor: function() {
            return [
                0,
                0
            ];
        }
    });
    Map.include({
        _initOverlay: function(OverlayClass, content, latlng, options) {
            var overlay = content;
            if (!(overlay instanceof OverlayClass)) overlay = new OverlayClass(options).setContent(content);
            if (latlng) overlay.setLatLng(latlng);
            return overlay;
        }
    });
    Layer.include({
        _initOverlay: function(OverlayClass, old, content, options) {
            var overlay = content;
            if (overlay instanceof OverlayClass) {
                setOptions(overlay, options);
                overlay._source = this;
            } else {
                overlay = old && !options ? old : new OverlayClass(options, this);
                overlay.setContent(content);
            }
            return overlay;
        }
    });
    /*
   * @class Popup
   * @inherits DivOverlay
   * @aka L.Popup
   * Used to open popups in certain places of the map. Use [Map.openPopup](#map-openpopup) to
   * open popups while making sure that only one popup is open at one time
   * (recommended for usability), or use [Map.addLayer](#map-addlayer) to open as many as you want.
   *
   * @example
   *
   * If you want to just bind a popup to marker click and then open it, it's really easy:
   *
   * ```js
   * marker.bindPopup(popupContent).openPopup();
   * ```
   * Path overlays like polylines also have a `bindPopup` method.
   *
   * A popup can be also standalone:
   *
   * ```js
   * var popup = L.popup()
   * 	.setLatLng(latlng)
   * 	.setContent('<p>Hello world!<br />This is a nice popup.</p>')
   * 	.openOn(map);
   * ```
   * or
   * ```js
   * var popup = L.popup(latlng, {content: '<p>Hello world!<br />This is a nice popup.</p>')
   * 	.openOn(map);
   * ```
   */ // @namespace Popup
    var Popup = DivOverlay.extend({
        // @section
        // @aka Popup options
        options: {
            // @option pane: String = 'popupPane'
            // `Map pane` where the popup will be added.
            pane: "popupPane",
            // @option offset: Point = Point(0, 7)
            // The offset of the popup position.
            offset: [
                0,
                7
            ],
            // @option maxWidth: Number = 300
            // Max width of the popup, in pixels.
            maxWidth: 300,
            // @option minWidth: Number = 50
            // Min width of the popup, in pixels.
            minWidth: 50,
            // @option maxHeight: Number = null
            // If set, creates a scrollable container of the given height
            // inside a popup if its content exceeds it.
            // The scrollable container can be styled using the
            // `leaflet-popup-scrolled` CSS class selector.
            maxHeight: null,
            // @option autoPan: Boolean = true
            // Set it to `false` if you don't want the map to do panning animation
            // to fit the opened popup.
            autoPan: true,
            // @option autoPanPaddingTopLeft: Point = null
            // The margin between the popup and the top left corner of the map
            // view after autopanning was performed.
            autoPanPaddingTopLeft: null,
            // @option autoPanPaddingBottomRight: Point = null
            // The margin between the popup and the bottom right corner of the map
            // view after autopanning was performed.
            autoPanPaddingBottomRight: null,
            // @option autoPanPadding: Point = Point(5, 5)
            // Equivalent of setting both top left and bottom right autopan padding to the same value.
            autoPanPadding: [
                5,
                5
            ],
            // @option keepInView: Boolean = false
            // Set it to `true` if you want to prevent users from panning the popup
            // off of the screen while it is open.
            keepInView: false,
            // @option closeButton: Boolean = true
            // Controls the presence of a close button in the popup.
            closeButton: true,
            // @option autoClose: Boolean = true
            // Set it to `false` if you want to override the default behavior of
            // the popup closing when another popup is opened.
            autoClose: true,
            // @option closeOnEscapeKey: Boolean = true
            // Set it to `false` if you want to override the default behavior of
            // the ESC key for closing of the popup.
            closeOnEscapeKey: true,
            // @option closeOnClick: Boolean = *
            // Set it if you want to override the default behavior of the popup closing when user clicks
            // on the map. Defaults to the map's [`closePopupOnClick`](#map-closepopuponclick) option.
            // @option className: String = ''
            // A custom CSS class name to assign to the popup.
            className: ""
        },
        // @namespace Popup
        // @method openOn(map: Map): this
        // Alternative to `map.openPopup(popup)`.
        // Adds the popup to the map and closes the previous one.
        openOn: function(map) {
            map = arguments.length ? map : this._source._map; // experimental, not the part of public api
            if (!map.hasLayer(this) && map._popup && map._popup.options.autoClose) map.removeLayer(map._popup);
            map._popup = this;
            return DivOverlay.prototype.openOn.call(this, map);
        },
        onAdd: function(map) {
            DivOverlay.prototype.onAdd.call(this, map);
            // @namespace Map
            // @section Popup events
            // @event popupopen: PopupEvent
            // Fired when a popup is opened in the map
            map.fire("popupopen", {
                popup: this
            });
            if (this._source) {
                // @namespace Layer
                // @section Popup events
                // @event popupopen: PopupEvent
                // Fired when a popup bound to this layer is opened
                this._source.fire("popupopen", {
                    popup: this
                }, true);
                // For non-path layers, we toggle the popup when clicking
                // again the layer, so prevent the map to reopen it.
                if (!(this._source instanceof Path)) this._source.on("preclick", stopPropagation);
            }
        },
        onRemove: function(map) {
            DivOverlay.prototype.onRemove.call(this, map);
            // @namespace Map
            // @section Popup events
            // @event popupclose: PopupEvent
            // Fired when a popup in the map is closed
            map.fire("popupclose", {
                popup: this
            });
            if (this._source) {
                // @namespace Layer
                // @section Popup events
                // @event popupclose: PopupEvent
                // Fired when a popup bound to this layer is closed
                this._source.fire("popupclose", {
                    popup: this
                }, true);
                if (!(this._source instanceof Path)) this._source.off("preclick", stopPropagation);
            }
        },
        getEvents: function() {
            var events = DivOverlay.prototype.getEvents.call(this);
            if (this.options.closeOnClick !== undefined ? this.options.closeOnClick : this._map.options.closePopupOnClick) events.preclick = this.close;
            if (this.options.keepInView) events.moveend = this._adjustPan;
            return events;
        },
        _initLayout: function() {
            var prefix = "leaflet-popup", container = this._container = create$1("div", prefix + " " + (this.options.className || "") + " leaflet-zoom-animated");
            var wrapper = this._wrapper = create$1("div", prefix + "-content-wrapper", container);
            this._contentNode = create$1("div", prefix + "-content", wrapper);
            disableClickPropagation(container);
            disableScrollPropagation(this._contentNode);
            on(container, "contextmenu", stopPropagation);
            this._tipContainer = create$1("div", prefix + "-tip-container", container);
            this._tip = create$1("div", prefix + "-tip", this._tipContainer);
            if (this.options.closeButton) {
                var closeButton = this._closeButton = create$1("a", prefix + "-close-button", container);
                closeButton.setAttribute("role", "button"); // overrides the implicit role=link of <a> elements #7399
                closeButton.setAttribute("aria-label", "Close popup");
                closeButton.href = "#close";
                closeButton.innerHTML = '<span aria-hidden="true">&#215;</span>';
                on(closeButton, "click", function(ev) {
                    preventDefault(ev);
                    this.close();
                }, this);
            }
        },
        _updateLayout: function() {
            var container = this._contentNode, style = container.style;
            style.width = "";
            style.whiteSpace = "nowrap";
            var width = container.offsetWidth;
            width = Math.min(width, this.options.maxWidth);
            width = Math.max(width, this.options.minWidth);
            style.width = width + 1 + "px";
            style.whiteSpace = "";
            style.height = "";
            var height = container.offsetHeight, maxHeight = this.options.maxHeight, scrolledClass = "leaflet-popup-scrolled";
            if (maxHeight && height > maxHeight) {
                style.height = maxHeight + "px";
                addClass(container, scrolledClass);
            } else removeClass(container, scrolledClass);
            this._containerWidth = this._container.offsetWidth;
        },
        _animateZoom: function(e) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center), anchor = this._getAnchor();
            setPosition(this._container, pos.add(anchor));
        },
        _adjustPan: function() {
            if (!this.options.autoPan) return;
            if (this._map._panAnim) this._map._panAnim.stop();
            // We can endlessly recurse if keepInView is set and the view resets.
            // Let's guard against that by exiting early if we're responding to our own autopan.
            if (this._autopanning) {
                this._autopanning = false;
                return;
            }
            var map = this._map, marginBottom = parseInt(getStyle(this._container, "marginBottom"), 10) || 0, containerHeight = this._container.offsetHeight + marginBottom, containerWidth = this._containerWidth, layerPos = new Point(this._containerLeft, -containerHeight - this._containerBottom);
            layerPos._add(getPosition(this._container));
            var containerPos = map.layerPointToContainerPoint(layerPos), padding = toPoint(this.options.autoPanPadding), paddingTL = toPoint(this.options.autoPanPaddingTopLeft || padding), paddingBR = toPoint(this.options.autoPanPaddingBottomRight || padding), size = map.getSize(), dx = 0, dy = 0;
            if (containerPos.x + containerWidth + paddingBR.x > size.x) dx = containerPos.x + containerWidth - size.x + paddingBR.x;
            if (containerPos.x - dx - paddingTL.x < 0) dx = containerPos.x - paddingTL.x;
            if (containerPos.y + containerHeight + paddingBR.y > size.y) dy = containerPos.y + containerHeight - size.y + paddingBR.y;
            if (containerPos.y - dy - paddingTL.y < 0) dy = containerPos.y - paddingTL.y;
            // @namespace Map
            // @section Popup events
            // @event autopanstart: Event
            // Fired when the map starts autopanning when opening a popup.
            if (dx || dy) {
                // Track that we're autopanning, as this function will be re-ran on moveend
                if (this.options.keepInView) this._autopanning = true;
                map.fire("autopanstart").panBy([
                    dx,
                    dy
                ]);
            }
        },
        _getAnchor: function() {
            // Where should we anchor the popup on the source layer?
            return toPoint(this._source && this._source._getPopupAnchor ? this._source._getPopupAnchor() : [
                0,
                0
            ]);
        }
    });
    // @namespace Popup
    // @factory L.popup(options?: Popup options, source?: Layer)
    // Instantiates a `Popup` object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the popup with a reference to the Layer to which it refers.
    // @alternative
    // @factory L.popup(latlng: LatLng, options?: Popup options)
    // Instantiates a `Popup` object given `latlng` where the popup will open and an optional `options` object that describes its appearance and location.
    var popup = function(options, source) {
        return new Popup(options, source);
    };
    /* @namespace Map
   * @section Interaction Options
   * @option closePopupOnClick: Boolean = true
   * Set it to `false` if you don't want popups to close when user clicks the map.
   */ Map.mergeOptions({
        closePopupOnClick: true
    });
    // @namespace Map
    // @section Methods for Layers and Controls
    Map.include({
        // @method openPopup(popup: Popup): this
        // Opens the specified popup while closing the previously opened (to make sure only one is opened at one time for usability).
        // @alternative
        // @method openPopup(content: String|HTMLElement, latlng: LatLng, options?: Popup options): this
        // Creates a popup with the specified content and options and opens it in the given point on a map.
        openPopup: function(popup, latlng, options) {
            this._initOverlay(Popup, popup, latlng, options).openOn(this);
            return this;
        },
        // @method closePopup(popup?: Popup): this
        // Closes the popup previously opened with [openPopup](#map-openpopup) (or the given one).
        closePopup: function(popup) {
            popup = arguments.length ? popup : this._popup;
            if (popup) popup.close();
            return this;
        }
    });
    /*
   * @namespace Layer
   * @section Popup methods example
   *
   * All layers share a set of methods convenient for binding popups to it.
   *
   * ```js
   * var layer = L.Polygon(latlngs).bindPopup('Hi There!').addTo(map);
   * layer.openPopup();
   * layer.closePopup();
   * ```
   *
   * Popups will also be automatically opened when the layer is clicked on and closed when the layer is removed from the map or another popup is opened.
   */ // @section Popup methods
    Layer.include({
        // @method bindPopup(content: String|HTMLElement|Function|Popup, options?: Popup options): this
        // Binds a popup to the layer with the passed `content` and sets up the
        // necessary event listeners. If a `Function` is passed it will receive
        // the layer as the first argument and should return a `String` or `HTMLElement`.
        bindPopup: function(content, options) {
            this._popup = this._initOverlay(Popup, this._popup, content, options);
            if (!this._popupHandlersAdded) {
                this.on({
                    click: this._openPopup,
                    keypress: this._onKeyPress,
                    remove: this.closePopup,
                    move: this._movePopup
                });
                this._popupHandlersAdded = true;
            }
            return this;
        },
        // @method unbindPopup(): this
        // Removes the popup previously bound with `bindPopup`.
        unbindPopup: function() {
            if (this._popup) {
                this.off({
                    click: this._openPopup,
                    keypress: this._onKeyPress,
                    remove: this.closePopup,
                    move: this._movePopup
                });
                this._popupHandlersAdded = false;
                this._popup = null;
            }
            return this;
        },
        // @method openPopup(latlng?: LatLng): this
        // Opens the bound popup at the specified `latlng` or at the default popup anchor if no `latlng` is passed.
        openPopup: function(latlng) {
            if (this._popup) {
                if (!(this instanceof FeatureGroup)) this._popup._source = this;
                if (this._popup._prepareOpen(latlng || this._latlng)) // open the popup on the map
                this._popup.openOn(this._map);
            }
            return this;
        },
        // @method closePopup(): this
        // Closes the popup bound to this layer if it is open.
        closePopup: function() {
            if (this._popup) this._popup.close();
            return this;
        },
        // @method togglePopup(): this
        // Opens or closes the popup bound to this layer depending on its current state.
        togglePopup: function() {
            if (this._popup) this._popup.toggle(this);
            return this;
        },
        // @method isPopupOpen(): boolean
        // Returns `true` if the popup bound to this layer is currently open.
        isPopupOpen: function() {
            return this._popup ? this._popup.isOpen() : false;
        },
        // @method setPopupContent(content: String|HTMLElement|Popup): this
        // Sets the content of the popup bound to this layer.
        setPopupContent: function(content) {
            if (this._popup) this._popup.setContent(content);
            return this;
        },
        // @method getPopup(): Popup
        // Returns the popup bound to this layer.
        getPopup: function() {
            return this._popup;
        },
        _openPopup: function(e) {
            if (!this._popup || !this._map) return;
            // prevent map click
            stop(e);
            var target = e.layer || e.target;
            if (this._popup._source === target && !(target instanceof Path)) {
                // treat it like a marker and figure out
                // if we should toggle it open/closed
                if (this._map.hasLayer(this._popup)) this.closePopup();
                else this.openPopup(e.latlng);
                return;
            }
            this._popup._source = target;
            this.openPopup(e.latlng);
        },
        _movePopup: function(e) {
            this._popup.setLatLng(e.latlng);
        },
        _onKeyPress: function(e) {
            if (e.originalEvent.keyCode === 13) this._openPopup(e);
        }
    });
    /*
   * @class Tooltip
   * @inherits DivOverlay
   * @aka L.Tooltip
   * Used to display small texts on top of map layers.
   *
   * @example
   * If you want to just bind a tooltip to marker:
   *
   * ```js
   * marker.bindTooltip("my tooltip text").openTooltip();
   * ```
   * Path overlays like polylines also have a `bindTooltip` method.
   *
   * A tooltip can be also standalone:
   *
   * ```js
   * var tooltip = L.tooltip()
   * 	.setLatLng(latlng)
   * 	.setContent('Hello world!<br />This is a nice tooltip.')
   * 	.addTo(map);
   * ```
   * or
   * ```js
   * var tooltip = L.tooltip(latlng, {content: 'Hello world!<br />This is a nice tooltip.'})
   * 	.addTo(map);
   * ```
   *
   *
   * Note about tooltip offset. Leaflet takes two options in consideration
   * for computing tooltip offsetting:
   * - the `offset` Tooltip option: it defaults to [0, 0], and it's specific to one tooltip.
   *   Add a positive x offset to move the tooltip to the right, and a positive y offset to
   *   move it to the bottom. Negatives will move to the left and top.
   * - the `tooltipAnchor` Icon option: this will only be considered for Marker. You
   *   should adapt this value if you use a custom icon.
   */ // @namespace Tooltip
    var Tooltip = DivOverlay.extend({
        // @section
        // @aka Tooltip options
        options: {
            // @option pane: String = 'tooltipPane'
            // `Map pane` where the tooltip will be added.
            pane: "tooltipPane",
            // @option offset: Point = Point(0, 0)
            // Optional offset of the tooltip position.
            offset: [
                0,
                0
            ],
            // @option direction: String = 'auto'
            // Direction where to open the tooltip. Possible values are: `right`, `left`,
            // `top`, `bottom`, `center`, `auto`.
            // `auto` will dynamically switch between `right` and `left` according to the tooltip
            // position on the map.
            direction: "auto",
            // @option permanent: Boolean = false
            // Whether to open the tooltip permanently or only on mouseover.
            permanent: false,
            // @option sticky: Boolean = false
            // If true, the tooltip will follow the mouse instead of being fixed at the feature center.
            sticky: false,
            // @option opacity: Number = 0.9
            // Tooltip container opacity.
            opacity: 0.9
        },
        onAdd: function(map) {
            DivOverlay.prototype.onAdd.call(this, map);
            this.setOpacity(this.options.opacity);
            // @namespace Map
            // @section Tooltip events
            // @event tooltipopen: TooltipEvent
            // Fired when a tooltip is opened in the map.
            map.fire("tooltipopen", {
                tooltip: this
            });
            if (this._source) {
                this.addEventParent(this._source);
                // @namespace Layer
                // @section Tooltip events
                // @event tooltipopen: TooltipEvent
                // Fired when a tooltip bound to this layer is opened.
                this._source.fire("tooltipopen", {
                    tooltip: this
                }, true);
            }
        },
        onRemove: function(map) {
            DivOverlay.prototype.onRemove.call(this, map);
            // @namespace Map
            // @section Tooltip events
            // @event tooltipclose: TooltipEvent
            // Fired when a tooltip in the map is closed.
            map.fire("tooltipclose", {
                tooltip: this
            });
            if (this._source) {
                this.removeEventParent(this._source);
                // @namespace Layer
                // @section Tooltip events
                // @event tooltipclose: TooltipEvent
                // Fired when a tooltip bound to this layer is closed.
                this._source.fire("tooltipclose", {
                    tooltip: this
                }, true);
            }
        },
        getEvents: function() {
            var events = DivOverlay.prototype.getEvents.call(this);
            if (!this.options.permanent) events.preclick = this.close;
            return events;
        },
        _initLayout: function() {
            var prefix = "leaflet-tooltip", className = prefix + " " + (this.options.className || "") + " leaflet-zoom-" + (this._zoomAnimated ? "animated" : "hide");
            this._contentNode = this._container = create$1("div", className);
            this._container.setAttribute("role", "tooltip");
            this._container.setAttribute("id", "leaflet-tooltip-" + stamp(this));
        },
        _updateLayout: function() {},
        _adjustPan: function() {},
        _setPosition: function(pos) {
            var subX, subY, map = this._map, container = this._container, centerPoint = map.latLngToContainerPoint(map.getCenter()), tooltipPoint = map.layerPointToContainerPoint(pos), direction = this.options.direction, tooltipWidth = container.offsetWidth, tooltipHeight = container.offsetHeight, offset = toPoint(this.options.offset), anchor = this._getAnchor();
            if (direction === "top") {
                subX = tooltipWidth / 2;
                subY = tooltipHeight;
            } else if (direction === "bottom") {
                subX = tooltipWidth / 2;
                subY = 0;
            } else if (direction === "center") {
                subX = tooltipWidth / 2;
                subY = tooltipHeight / 2;
            } else if (direction === "right") {
                subX = 0;
                subY = tooltipHeight / 2;
            } else if (direction === "left") {
                subX = tooltipWidth;
                subY = tooltipHeight / 2;
            } else if (tooltipPoint.x < centerPoint.x) {
                direction = "right";
                subX = 0;
                subY = tooltipHeight / 2;
            } else {
                direction = "left";
                subX = tooltipWidth + (offset.x + anchor.x) * 2;
                subY = tooltipHeight / 2;
            }
            pos = pos.subtract(toPoint(subX, subY, true)).add(offset).add(anchor);
            removeClass(container, "leaflet-tooltip-right");
            removeClass(container, "leaflet-tooltip-left");
            removeClass(container, "leaflet-tooltip-top");
            removeClass(container, "leaflet-tooltip-bottom");
            addClass(container, "leaflet-tooltip-" + direction);
            setPosition(container, pos);
        },
        _updatePosition: function() {
            var pos = this._map.latLngToLayerPoint(this._latlng);
            this._setPosition(pos);
        },
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._container) setOpacity(this._container, opacity);
        },
        _animateZoom: function(e) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center);
            this._setPosition(pos);
        },
        _getAnchor: function() {
            // Where should we anchor the tooltip on the source layer?
            return toPoint(this._source && this._source._getTooltipAnchor && !this.options.sticky ? this._source._getTooltipAnchor() : [
                0,
                0
            ]);
        }
    });
    // @namespace Tooltip
    // @factory L.tooltip(options?: Tooltip options, source?: Layer)
    // Instantiates a `Tooltip` object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the tooltip with a reference to the Layer to which it refers.
    // @alternative
    // @factory L.tooltip(latlng: LatLng, options?: Tooltip options)
    // Instantiates a `Tooltip` object given `latlng` where the tooltip will open and an optional `options` object that describes its appearance and location.
    var tooltip = function(options, source) {
        return new Tooltip(options, source);
    };
    // @namespace Map
    // @section Methods for Layers and Controls
    Map.include({
        // @method openTooltip(tooltip: Tooltip): this
        // Opens the specified tooltip.
        // @alternative
        // @method openTooltip(content: String|HTMLElement, latlng: LatLng, options?: Tooltip options): this
        // Creates a tooltip with the specified content and options and open it.
        openTooltip: function(tooltip, latlng, options) {
            this._initOverlay(Tooltip, tooltip, latlng, options).openOn(this);
            return this;
        },
        // @method closeTooltip(tooltip: Tooltip): this
        // Closes the tooltip given as parameter.
        closeTooltip: function(tooltip) {
            tooltip.close();
            return this;
        }
    });
    /*
   * @namespace Layer
   * @section Tooltip methods example
   *
   * All layers share a set of methods convenient for binding tooltips to it.
   *
   * ```js
   * var layer = L.Polygon(latlngs).bindTooltip('Hi There!').addTo(map);
   * layer.openTooltip();
   * layer.closeTooltip();
   * ```
   */ // @section Tooltip methods
    Layer.include({
        // @method bindTooltip(content: String|HTMLElement|Function|Tooltip, options?: Tooltip options): this
        // Binds a tooltip to the layer with the passed `content` and sets up the
        // necessary event listeners. If a `Function` is passed it will receive
        // the layer as the first argument and should return a `String` or `HTMLElement`.
        bindTooltip: function(content, options) {
            if (this._tooltip && this.isTooltipOpen()) this.unbindTooltip();
            this._tooltip = this._initOverlay(Tooltip, this._tooltip, content, options);
            this._initTooltipInteractions();
            if (this._tooltip.options.permanent && this._map && this._map.hasLayer(this)) this.openTooltip();
            return this;
        },
        // @method unbindTooltip(): this
        // Removes the tooltip previously bound with `bindTooltip`.
        unbindTooltip: function() {
            if (this._tooltip) {
                this._initTooltipInteractions(true);
                this.closeTooltip();
                this._tooltip = null;
            }
            return this;
        },
        _initTooltipInteractions: function(remove) {
            if (!remove && this._tooltipHandlersAdded) return;
            var onOff = remove ? "off" : "on", events = {
                remove: this.closeTooltip,
                move: this._moveTooltip
            };
            if (!this._tooltip.options.permanent) {
                events.mouseover = this._openTooltip;
                events.mouseout = this.closeTooltip;
                events.click = this._openTooltip;
                if (this._map) this._addFocusListeners();
                else events.add = this._addFocusListeners;
            } else events.add = this._openTooltip;
            if (this._tooltip.options.sticky) events.mousemove = this._moveTooltip;
            this[onOff](events);
            this._tooltipHandlersAdded = !remove;
        },
        // @method openTooltip(latlng?: LatLng): this
        // Opens the bound tooltip at the specified `latlng` or at the default tooltip anchor if no `latlng` is passed.
        openTooltip: function(latlng) {
            if (this._tooltip) {
                if (!(this instanceof FeatureGroup)) this._tooltip._source = this;
                if (this._tooltip._prepareOpen(latlng)) {
                    // open the tooltip on the map
                    this._tooltip.openOn(this._map);
                    if (this.getElement) this._setAriaDescribedByOnLayer(this);
                    else if (this.eachLayer) this.eachLayer(this._setAriaDescribedByOnLayer, this);
                }
            }
            return this;
        },
        // @method closeTooltip(): this
        // Closes the tooltip bound to this layer if it is open.
        closeTooltip: function() {
            if (this._tooltip) return this._tooltip.close();
        },
        // @method toggleTooltip(): this
        // Opens or closes the tooltip bound to this layer depending on its current state.
        toggleTooltip: function() {
            if (this._tooltip) this._tooltip.toggle(this);
            return this;
        },
        // @method isTooltipOpen(): boolean
        // Returns `true` if the tooltip bound to this layer is currently open.
        isTooltipOpen: function() {
            return this._tooltip.isOpen();
        },
        // @method setTooltipContent(content: String|HTMLElement|Tooltip): this
        // Sets the content of the tooltip bound to this layer.
        setTooltipContent: function(content) {
            if (this._tooltip) this._tooltip.setContent(content);
            return this;
        },
        // @method getTooltip(): Tooltip
        // Returns the tooltip bound to this layer.
        getTooltip: function() {
            return this._tooltip;
        },
        _addFocusListeners: function() {
            if (this.getElement) this._addFocusListenersOnLayer(this);
            else if (this.eachLayer) this.eachLayer(this._addFocusListenersOnLayer, this);
        },
        _addFocusListenersOnLayer: function(layer) {
            var el = typeof layer.getElement === "function" && layer.getElement();
            if (el) {
                on(el, "focus", function() {
                    this._tooltip._source = layer;
                    this.openTooltip();
                }, this);
                on(el, "blur", this.closeTooltip, this);
            }
        },
        _setAriaDescribedByOnLayer: function(layer) {
            var el = typeof layer.getElement === "function" && layer.getElement();
            if (el) el.setAttribute("aria-describedby", this._tooltip._container.id);
        },
        _openTooltip: function(e) {
            if (!this._tooltip || !this._map) return;
            // If the map is moving, we will show the tooltip after it's done.
            if (this._map.dragging && this._map.dragging.moving() && !this._openOnceFlag) {
                this._openOnceFlag = true;
                var that = this;
                this._map.once("moveend", function() {
                    that._openOnceFlag = false;
                    that._openTooltip(e);
                });
                return;
            }
            this._tooltip._source = e.layer || e.target;
            this.openTooltip(this._tooltip.options.sticky ? e.latlng : undefined);
        },
        _moveTooltip: function(e) {
            var latlng = e.latlng, containerPoint, layerPoint;
            if (this._tooltip.options.sticky && e.originalEvent) {
                containerPoint = this._map.mouseEventToContainerPoint(e.originalEvent);
                layerPoint = this._map.containerPointToLayerPoint(containerPoint);
                latlng = this._map.layerPointToLatLng(layerPoint);
            }
            this._tooltip.setLatLng(latlng);
        }
    });
    /*
   * @class DivIcon
   * @aka L.DivIcon
   * @inherits Icon
   *
   * Represents a lightweight icon for markers that uses a simple `<div>`
   * element instead of an image. Inherits from `Icon` but ignores the `iconUrl` and shadow options.
   *
   * @example
   * ```js
   * var myIcon = L.divIcon({className: 'my-div-icon'});
   * // you can set .my-div-icon styles in CSS
   *
   * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
   * ```
   *
   * By default, it has a 'leaflet-div-icon' CSS class and is styled as a little white square with a shadow.
   */ var DivIcon = Icon.extend({
        options: {
            // @section
            // @aka DivIcon options
            iconSize: [
                12,
                12
            ],
            // iconAnchor: (Point),
            // popupAnchor: (Point),
            // @option html: String|HTMLElement = ''
            // Custom HTML code to put inside the div element, empty by default. Alternatively,
            // an instance of `HTMLElement`.
            html: false,
            // @option bgPos: Point = [0, 0]
            // Optional relative position of the background, in pixels
            bgPos: null,
            className: "leaflet-div-icon"
        },
        createIcon: function(oldIcon) {
            var div = oldIcon && oldIcon.tagName === "DIV" ? oldIcon : document.createElement("div"), options = this.options;
            if (options.html instanceof Element) {
                empty(div);
                div.appendChild(options.html);
            } else div.innerHTML = options.html !== false ? options.html : "";
            if (options.bgPos) {
                var bgPos = toPoint(options.bgPos);
                div.style.backgroundPosition = -bgPos.x + "px " + -bgPos.y + "px";
            }
            this._setIconStyles(div, "icon");
            return div;
        },
        createShadow: function() {
            return null;
        }
    });
    // @factory L.divIcon(options: DivIcon options)
    // Creates a `DivIcon` instance with the given options.
    function divIcon(options) {
        return new DivIcon(options);
    }
    Icon.Default = IconDefault;
    /*
   * @class GridLayer
   * @inherits Layer
   * @aka L.GridLayer
   *
   * Generic class for handling a tiled grid of HTML elements. This is the base class for all tile layers and replaces `TileLayer.Canvas`.
   * GridLayer can be extended to create a tiled grid of HTML elements like `<canvas>`, `<img>` or `<div>`. GridLayer will handle creating and animating these DOM elements for you.
   *
   *
   * @section Synchronous usage
   * @example
   *
   * To create a custom layer, extend GridLayer and implement the `createTile()` method, which will be passed a `Point` object with the `x`, `y`, and `z` (zoom level) coordinates to draw your tile.
   *
   * ```js
   * var CanvasLayer = L.GridLayer.extend({
   *     createTile: function(coords){
   *         // create a <canvas> element for drawing
   *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
   *
   *         // setup tile width and height according to the options
   *         var size = this.getTileSize();
   *         tile.width = size.x;
   *         tile.height = size.y;
   *
   *         // get a canvas context and draw something on it using coords.x, coords.y and coords.z
   *         var ctx = tile.getContext('2d');
   *
   *         // return the tile so it can be rendered on screen
   *         return tile;
   *     }
   * });
   * ```
   *
   * @section Asynchronous usage
   * @example
   *
   * Tile creation can also be asynchronous, this is useful when using a third-party drawing library. Once the tile is finished drawing it can be passed to the `done()` callback.
   *
   * ```js
   * var CanvasLayer = L.GridLayer.extend({
   *     createTile: function(coords, done){
   *         var error;
   *
   *         // create a <canvas> element for drawing
   *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
   *
   *         // setup tile width and height according to the options
   *         var size = this.getTileSize();
   *         tile.width = size.x;
   *         tile.height = size.y;
   *
   *         // draw something asynchronously and pass the tile to the done() callback
   *         setTimeout(function() {
   *             done(error, tile);
   *         }, 1000);
   *
   *         return tile;
   *     }
   * });
   * ```
   *
   * @section
   */ var GridLayer = Layer.extend({
        // @section
        // @aka GridLayer options
        options: {
            // @option tileSize: Number|Point = 256
            // Width and height of tiles in the grid. Use a number if width and height are equal, or `L.point(width, height)` otherwise.
            tileSize: 256,
            // @option opacity: Number = 1.0
            // Opacity of the tiles. Can be used in the `createTile()` function.
            opacity: 1,
            // @option updateWhenIdle: Boolean = (depends)
            // Load new tiles only when panning ends.
            // `true` by default on mobile browsers, in order to avoid too many requests and keep smooth navigation.
            // `false` otherwise in order to display new tiles _during_ panning, since it is easy to pan outside the
            // [`keepBuffer`](#gridlayer-keepbuffer) option in desktop browsers.
            updateWhenIdle: Browser.mobile,
            // @option updateWhenZooming: Boolean = true
            // By default, a smooth zoom animation (during a [touch zoom](#map-touchzoom) or a [`flyTo()`](#map-flyto)) will update grid layers every integer zoom level. Setting this option to `false` will update the grid layer only when the smooth animation ends.
            updateWhenZooming: true,
            // @option updateInterval: Number = 200
            // Tiles will not update more than once every `updateInterval` milliseconds when panning.
            updateInterval: 200,
            // @option zIndex: Number = 1
            // The explicit zIndex of the tile layer.
            zIndex: 1,
            // @option bounds: LatLngBounds = undefined
            // If set, tiles will only be loaded inside the set `LatLngBounds`.
            bounds: null,
            // @option minZoom: Number = 0
            // The minimum zoom level down to which this layer will be displayed (inclusive).
            minZoom: 0,
            // @option maxZoom: Number = undefined
            // The maximum zoom level up to which this layer will be displayed (inclusive).
            maxZoom: undefined,
            // @option maxNativeZoom: Number = undefined
            // Maximum zoom number the tile source has available. If it is specified,
            // the tiles on all zoom levels higher than `maxNativeZoom` will be loaded
            // from `maxNativeZoom` level and auto-scaled.
            maxNativeZoom: undefined,
            // @option minNativeZoom: Number = undefined
            // Minimum zoom number the tile source has available. If it is specified,
            // the tiles on all zoom levels lower than `minNativeZoom` will be loaded
            // from `minNativeZoom` level and auto-scaled.
            minNativeZoom: undefined,
            // @option noWrap: Boolean = false
            // Whether the layer is wrapped around the antimeridian. If `true`, the
            // GridLayer will only be displayed once at low zoom levels. Has no
            // effect when the [map CRS](#map-crs) doesn't wrap around. Can be used
            // in combination with [`bounds`](#gridlayer-bounds) to prevent requesting
            // tiles outside the CRS limits.
            noWrap: false,
            // @option pane: String = 'tilePane'
            // `Map pane` where the grid layer will be added.
            pane: "tilePane",
            // @option className: String = ''
            // A custom class name to assign to the tile layer. Empty by default.
            className: "",
            // @option keepBuffer: Number = 2
            // When panning the map, keep this many rows and columns of tiles before unloading them.
            keepBuffer: 2
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        onAdd: function() {
            this._initContainer();
            this._levels = {};
            this._tiles = {};
            this._resetView(); // implicit _update() call
        },
        beforeAdd: function(map) {
            map._addZoomLimit(this);
        },
        onRemove: function(map) {
            this._removeAllTiles();
            remove(this._container);
            map._removeZoomLimit(this);
            this._container = null;
            this._tileZoom = undefined;
        },
        // @method bringToFront: this
        // Brings the tile layer to the top of all tile layers.
        bringToFront: function() {
            if (this._map) {
                toFront(this._container);
                this._setAutoZIndex(Math.max);
            }
            return this;
        },
        // @method bringToBack: this
        // Brings the tile layer to the bottom of all tile layers.
        bringToBack: function() {
            if (this._map) {
                toBack(this._container);
                this._setAutoZIndex(Math.min);
            }
            return this;
        },
        // @method getContainer: HTMLElement
        // Returns the HTML element that contains the tiles for this layer.
        getContainer: function() {
            return this._container;
        },
        // @method setOpacity(opacity: Number): this
        // Changes the [opacity](#gridlayer-opacity) of the grid layer.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            this._updateOpacity();
            return this;
        },
        // @method setZIndex(zIndex: Number): this
        // Changes the [zIndex](#gridlayer-zindex) of the grid layer.
        setZIndex: function(zIndex) {
            this.options.zIndex = zIndex;
            this._updateZIndex();
            return this;
        },
        // @method isLoading: Boolean
        // Returns `true` if any tile in the grid layer has not finished loading.
        isLoading: function() {
            return this._loading;
        },
        // @method redraw: this
        // Causes the layer to clear all the tiles and request them again.
        redraw: function() {
            if (this._map) {
                this._removeAllTiles();
                var tileZoom = this._clampZoom(this._map.getZoom());
                if (tileZoom !== this._tileZoom) {
                    this._tileZoom = tileZoom;
                    this._updateLevels();
                }
                this._update();
            }
            return this;
        },
        getEvents: function() {
            var events = {
                viewprereset: this._invalidateAll,
                viewreset: this._resetView,
                zoom: this._resetView,
                moveend: this._onMoveEnd
            };
            if (!this.options.updateWhenIdle) {
                // update tiles on move, but not more often than once per given interval
                if (!this._onMove) this._onMove = throttle(this._onMoveEnd, this.options.updateInterval, this);
                events.move = this._onMove;
            }
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @section Extension methods
        // Layers extending `GridLayer` shall reimplement the following method.
        // @method createTile(coords: Object, done?: Function): HTMLElement
        // Called only internally, must be overridden by classes extending `GridLayer`.
        // Returns the `HTMLElement` corresponding to the given `coords`. If the `done` callback
        // is specified, it must be called when the tile has finished loading and drawing.
        createTile: function() {
            return document.createElement("div");
        },
        // @section
        // @method getTileSize: Point
        // Normalizes the [tileSize option](#gridlayer-tilesize) into a point. Used by the `createTile()` method.
        getTileSize: function() {
            var s = this.options.tileSize;
            return s instanceof Point ? s : new Point(s, s);
        },
        _updateZIndex: function() {
            if (this._container && this.options.zIndex !== undefined && this.options.zIndex !== null) this._container.style.zIndex = this.options.zIndex;
        },
        _setAutoZIndex: function(compare) {
            // go through all other layers of the same pane, set zIndex to max + 1 (front) or min - 1 (back)
            var layers = this.getPane().children, edgeZIndex = -compare(-Infinity, Infinity); // -Infinity for max, Infinity for min
            for(var i = 0, len = layers.length, zIndex; i < len; i++){
                zIndex = layers[i].style.zIndex;
                if (layers[i] !== this._container && zIndex) edgeZIndex = compare(edgeZIndex, +zIndex);
            }
            if (isFinite(edgeZIndex)) {
                this.options.zIndex = edgeZIndex + compare(-1, 1);
                this._updateZIndex();
            }
        },
        _updateOpacity: function() {
            if (!this._map) return;
            // IE doesn't inherit filter opacity properly, so we're forced to set it on tiles
            if (Browser.ielt9) return;
            setOpacity(this._container, this.options.opacity);
            var now = +new Date(), nextFrame = false, willPrune = false;
            for(var key in this._tiles){
                var tile = this._tiles[key];
                if (!tile.current || !tile.loaded) continue;
                var fade = Math.min(1, (now - tile.loaded) / 200);
                setOpacity(tile.el, fade);
                if (fade < 1) nextFrame = true;
                else {
                    if (tile.active) willPrune = true;
                    else this._onOpaqueTile(tile);
                    tile.active = true;
                }
            }
            if (willPrune && !this._noPrune) this._pruneTiles();
            if (nextFrame) {
                cancelAnimFrame(this._fadeFrame);
                this._fadeFrame = requestAnimFrame(this._updateOpacity, this);
            }
        },
        _onOpaqueTile: falseFn,
        _initContainer: function() {
            if (this._container) return;
            this._container = create$1("div", "leaflet-layer " + (this.options.className || ""));
            this._updateZIndex();
            if (this.options.opacity < 1) this._updateOpacity();
            this.getPane().appendChild(this._container);
        },
        _updateLevels: function() {
            var zoom = this._tileZoom, maxZoom = this.options.maxZoom;
            if (zoom === undefined) return undefined;
            for(var z in this._levels){
                z = Number(z);
                if (this._levels[z].el.children.length || z === zoom) {
                    this._levels[z].el.style.zIndex = maxZoom - Math.abs(zoom - z);
                    this._onUpdateLevel(z);
                } else {
                    remove(this._levels[z].el);
                    this._removeTilesAtZoom(z);
                    this._onRemoveLevel(z);
                    delete this._levels[z];
                }
            }
            var level = this._levels[zoom], map = this._map;
            if (!level) {
                level = this._levels[zoom] = {};
                level.el = create$1("div", "leaflet-tile-container leaflet-zoom-animated", this._container);
                level.el.style.zIndex = maxZoom;
                level.origin = map.project(map.unproject(map.getPixelOrigin()), zoom).round();
                level.zoom = zoom;
                this._setZoomTransform(level, map.getCenter(), map.getZoom());
                // force the browser to consider the newly added element for transition
                falseFn(level.el.offsetWidth);
                this._onCreateLevel(level);
            }
            this._level = level;
            return level;
        },
        _onUpdateLevel: falseFn,
        _onRemoveLevel: falseFn,
        _onCreateLevel: falseFn,
        _pruneTiles: function() {
            if (!this._map) return;
            var key, tile;
            var zoom = this._map.getZoom();
            if (zoom > this.options.maxZoom || zoom < this.options.minZoom) {
                this._removeAllTiles();
                return;
            }
            for(key in this._tiles){
                tile = this._tiles[key];
                tile.retain = tile.current;
            }
            for(key in this._tiles){
                tile = this._tiles[key];
                if (tile.current && !tile.active) {
                    var coords = tile.coords;
                    if (!this._retainParent(coords.x, coords.y, coords.z, coords.z - 5)) this._retainChildren(coords.x, coords.y, coords.z, coords.z + 2);
                }
            }
            for(key in this._tiles)if (!this._tiles[key].retain) this._removeTile(key);
        },
        _removeTilesAtZoom: function(zoom) {
            for(var key in this._tiles){
                if (this._tiles[key].coords.z !== zoom) continue;
                this._removeTile(key);
            }
        },
        _removeAllTiles: function() {
            for(var key in this._tiles)this._removeTile(key);
        },
        _invalidateAll: function() {
            for(var z in this._levels){
                remove(this._levels[z].el);
                this._onRemoveLevel(Number(z));
                delete this._levels[z];
            }
            this._removeAllTiles();
            this._tileZoom = undefined;
        },
        _retainParent: function(x, y, z, minZoom) {
            var x2 = Math.floor(x / 2), y2 = Math.floor(y / 2), z2 = z - 1, coords2 = new Point(+x2, +y2);
            coords2.z = +z2;
            var key = this._tileCoordsToKey(coords2), tile = this._tiles[key];
            if (tile && tile.active) {
                tile.retain = true;
                return true;
            } else if (tile && tile.loaded) tile.retain = true;
            if (z2 > minZoom) return this._retainParent(x2, y2, z2, minZoom);
            return false;
        },
        _retainChildren: function(x, y, z, maxZoom) {
            for(var i = 2 * x; i < 2 * x + 2; i++)for(var j = 2 * y; j < 2 * y + 2; j++){
                var coords = new Point(i, j);
                coords.z = z + 1;
                var key = this._tileCoordsToKey(coords), tile = this._tiles[key];
                if (tile && tile.active) {
                    tile.retain = true;
                    continue;
                } else if (tile && tile.loaded) tile.retain = true;
                if (z + 1 < maxZoom) this._retainChildren(i, j, z + 1, maxZoom);
            }
        },
        _resetView: function(e) {
            var animating = e && (e.pinch || e.flyTo);
            this._setView(this._map.getCenter(), this._map.getZoom(), animating, animating);
        },
        _animateZoom: function(e) {
            this._setView(e.center, e.zoom, true, e.noUpdate);
        },
        _clampZoom: function(zoom) {
            var options = this.options;
            if (undefined !== options.minNativeZoom && zoom < options.minNativeZoom) return options.minNativeZoom;
            if (undefined !== options.maxNativeZoom && options.maxNativeZoom < zoom) return options.maxNativeZoom;
            return zoom;
        },
        _setView: function(center, zoom, noPrune, noUpdate) {
            var tileZoom = Math.round(zoom);
            if (this.options.maxZoom !== undefined && tileZoom > this.options.maxZoom || this.options.minZoom !== undefined && tileZoom < this.options.minZoom) tileZoom = undefined;
            else tileZoom = this._clampZoom(tileZoom);
            var tileZoomChanged = this.options.updateWhenZooming && tileZoom !== this._tileZoom;
            if (!noUpdate || tileZoomChanged) {
                this._tileZoom = tileZoom;
                if (this._abortLoading) this._abortLoading();
                this._updateLevels();
                this._resetGrid();
                if (tileZoom !== undefined) this._update(center);
                if (!noPrune) this._pruneTiles();
                // Flag to prevent _updateOpacity from pruning tiles during
                // a zoom anim or a pinch gesture
                this._noPrune = !!noPrune;
            }
            this._setZoomTransforms(center, zoom);
        },
        _setZoomTransforms: function(center, zoom) {
            for(var i in this._levels)this._setZoomTransform(this._levels[i], center, zoom);
        },
        _setZoomTransform: function(level, center, zoom) {
            var scale = this._map.getZoomScale(zoom, level.zoom), translate = level.origin.multiplyBy(scale).subtract(this._map._getNewPixelOrigin(center, zoom)).round();
            if (Browser.any3d) setTransform(level.el, translate, scale);
            else setPosition(level.el, translate);
        },
        _resetGrid: function() {
            var map = this._map, crs = map.options.crs, tileSize = this._tileSize = this.getTileSize(), tileZoom = this._tileZoom;
            var bounds = this._map.getPixelWorldBounds(this._tileZoom);
            if (bounds) this._globalTileRange = this._pxBoundsToTileRange(bounds);
            this._wrapX = crs.wrapLng && !this.options.noWrap && [
                Math.floor(map.project([
                    0,
                    crs.wrapLng[0]
                ], tileZoom).x / tileSize.x),
                Math.ceil(map.project([
                    0,
                    crs.wrapLng[1]
                ], tileZoom).x / tileSize.y)
            ];
            this._wrapY = crs.wrapLat && !this.options.noWrap && [
                Math.floor(map.project([
                    crs.wrapLat[0],
                    0
                ], tileZoom).y / tileSize.x),
                Math.ceil(map.project([
                    crs.wrapLat[1],
                    0
                ], tileZoom).y / tileSize.y)
            ];
        },
        _onMoveEnd: function() {
            if (!this._map || this._map._animatingZoom) return;
            this._update();
        },
        _getTiledPixelBounds: function(center) {
            var map = this._map, mapZoom = map._animatingZoom ? Math.max(map._animateToZoom, map.getZoom()) : map.getZoom(), scale = map.getZoomScale(mapZoom, this._tileZoom), pixelCenter = map.project(center, this._tileZoom).floor(), halfSize = map.getSize().divideBy(scale * 2);
            return new Bounds(pixelCenter.subtract(halfSize), pixelCenter.add(halfSize));
        },
        // Private method to load tiles in the grid's active zoom level according to map bounds
        _update: function(center) {
            var map = this._map;
            if (!map) return;
            var zoom = this._clampZoom(map.getZoom());
            if (center === undefined) center = map.getCenter();
            if (this._tileZoom === undefined) return;
             // if out of minzoom/maxzoom
            var pixelBounds = this._getTiledPixelBounds(center), tileRange = this._pxBoundsToTileRange(pixelBounds), tileCenter = tileRange.getCenter(), queue = [], margin = this.options.keepBuffer, noPruneRange = new Bounds(tileRange.getBottomLeft().subtract([
                margin,
                -margin
            ]), tileRange.getTopRight().add([
                margin,
                -margin
            ]));
            // Sanity check: panic if the tile range contains Infinity somewhere.
            if (!(isFinite(tileRange.min.x) && isFinite(tileRange.min.y) && isFinite(tileRange.max.x) && isFinite(tileRange.max.y))) throw new Error("Attempted to load an infinite number of tiles");
            for(var key in this._tiles){
                var c = this._tiles[key].coords;
                if (c.z !== this._tileZoom || !noPruneRange.contains(new Point(c.x, c.y))) this._tiles[key].current = false;
            }
            // _update just loads more tiles. If the tile zoom level differs too much
            // from the map's, let _setView reset levels and prune old tiles.
            if (Math.abs(zoom - this._tileZoom) > 1) {
                this._setView(center, zoom);
                return;
            }
            // create a queue of coordinates to load tiles from
            for(var j = tileRange.min.y; j <= tileRange.max.y; j++)for(var i = tileRange.min.x; i <= tileRange.max.x; i++){
                var coords = new Point(i, j);
                coords.z = this._tileZoom;
                if (!this._isValidTile(coords)) continue;
                var tile = this._tiles[this._tileCoordsToKey(coords)];
                if (tile) tile.current = true;
                else queue.push(coords);
            }
            // sort tile queue to load tiles in order of their distance to center
            queue.sort(function(a, b) {
                return a.distanceTo(tileCenter) - b.distanceTo(tileCenter);
            });
            if (queue.length !== 0) {
                // if it's the first batch of tiles to load
                if (!this._loading) {
                    this._loading = true;
                    // @event loading: Event
                    // Fired when the grid layer starts loading tiles.
                    this.fire("loading");
                }
                // create DOM fragment to append tiles in one batch
                var fragment = document.createDocumentFragment();
                for(i = 0; i < queue.length; i++)this._addTile(queue[i], fragment);
                this._level.el.appendChild(fragment);
            }
        },
        _isValidTile: function(coords) {
            var crs = this._map.options.crs;
            if (!crs.infinite) {
                // don't load tile if it's out of bounds and not wrapped
                var bounds = this._globalTileRange;
                if (!crs.wrapLng && (coords.x < bounds.min.x || coords.x > bounds.max.x) || !crs.wrapLat && (coords.y < bounds.min.y || coords.y > bounds.max.y)) return false;
            }
            if (!this.options.bounds) return true;
            // don't load tile if it doesn't intersect the bounds in options
            var tileBounds = this._tileCoordsToBounds(coords);
            return toLatLngBounds(this.options.bounds).overlaps(tileBounds);
        },
        _keyToBounds: function(key) {
            return this._tileCoordsToBounds(this._keyToTileCoords(key));
        },
        _tileCoordsToNwSe: function(coords) {
            var map = this._map, tileSize = this.getTileSize(), nwPoint = coords.scaleBy(tileSize), sePoint = nwPoint.add(tileSize), nw = map.unproject(nwPoint, coords.z), se = map.unproject(sePoint, coords.z);
            return [
                nw,
                se
            ];
        },
        // converts tile coordinates to its geographical bounds
        _tileCoordsToBounds: function(coords) {
            var bp = this._tileCoordsToNwSe(coords), bounds = new LatLngBounds(bp[0], bp[1]);
            if (!this.options.noWrap) bounds = this._map.wrapLatLngBounds(bounds);
            return bounds;
        },
        // converts tile coordinates to key for the tile cache
        _tileCoordsToKey: function(coords) {
            return coords.x + ":" + coords.y + ":" + coords.z;
        },
        // converts tile cache key to coordinates
        _keyToTileCoords: function(key) {
            var k = key.split(":"), coords = new Point(+k[0], +k[1]);
            coords.z = +k[2];
            return coords;
        },
        _removeTile: function(key) {
            var tile = this._tiles[key];
            if (!tile) return;
            remove(tile.el);
            delete this._tiles[key];
            // @event tileunload: TileEvent
            // Fired when a tile is removed (e.g. when a tile goes off the screen).
            this.fire("tileunload", {
                tile: tile.el,
                coords: this._keyToTileCoords(key)
            });
        },
        _initTile: function(tile) {
            addClass(tile, "leaflet-tile");
            var tileSize = this.getTileSize();
            tile.style.width = tileSize.x + "px";
            tile.style.height = tileSize.y + "px";
            tile.onselectstart = falseFn;
            tile.onmousemove = falseFn;
            // update opacity on tiles in IE7-8 because of filter inheritance problems
            if (Browser.ielt9 && this.options.opacity < 1) setOpacity(tile, this.options.opacity);
        },
        _addTile: function(coords, container) {
            var tilePos = this._getTilePos(coords), key = this._tileCoordsToKey(coords);
            var tile = this.createTile(this._wrapCoords(coords), bind(this._tileReady, this, coords));
            this._initTile(tile);
            // if createTile is defined with a second argument ("done" callback),
            // we know that tile is async and will be ready later; otherwise
            if (this.createTile.length < 2) // mark tile as ready, but delay one frame for opacity animation to happen
            requestAnimFrame(bind(this._tileReady, this, coords, null, tile));
            setPosition(tile, tilePos);
            // save tile in cache
            this._tiles[key] = {
                el: tile,
                coords: coords,
                current: true
            };
            container.appendChild(tile);
            // @event tileloadstart: TileEvent
            // Fired when a tile is requested and starts loading.
            this.fire("tileloadstart", {
                tile: tile,
                coords: coords
            });
        },
        _tileReady: function(coords, err, tile) {
            if (err) // @event tileerror: TileErrorEvent
            // Fired when there is an error loading a tile.
            this.fire("tileerror", {
                error: err,
                tile: tile,
                coords: coords
            });
            var key = this._tileCoordsToKey(coords);
            tile = this._tiles[key];
            if (!tile) return;
            tile.loaded = +new Date();
            if (this._map._fadeAnimated) {
                setOpacity(tile.el, 0);
                cancelAnimFrame(this._fadeFrame);
                this._fadeFrame = requestAnimFrame(this._updateOpacity, this);
            } else {
                tile.active = true;
                this._pruneTiles();
            }
            if (!err) {
                addClass(tile.el, "leaflet-tile-loaded");
                // @event tileload: TileEvent
                // Fired when a tile loads.
                this.fire("tileload", {
                    tile: tile.el,
                    coords: coords
                });
            }
            if (this._noTilesToLoad()) {
                this._loading = false;
                // @event load: Event
                // Fired when the grid layer loaded all visible tiles.
                this.fire("load");
                if (Browser.ielt9 || !this._map._fadeAnimated) requestAnimFrame(this._pruneTiles, this);
                else // Wait a bit more than 0.2 secs (the duration of the tile fade-in)
                // to trigger a pruning.
                setTimeout(bind(this._pruneTiles, this), 250);
            }
        },
        _getTilePos: function(coords) {
            return coords.scaleBy(this.getTileSize()).subtract(this._level.origin);
        },
        _wrapCoords: function(coords) {
            var newCoords = new Point(this._wrapX ? wrapNum(coords.x, this._wrapX) : coords.x, this._wrapY ? wrapNum(coords.y, this._wrapY) : coords.y);
            newCoords.z = coords.z;
            return newCoords;
        },
        _pxBoundsToTileRange: function(bounds) {
            var tileSize = this.getTileSize();
            return new Bounds(bounds.min.unscaleBy(tileSize).floor(), bounds.max.unscaleBy(tileSize).ceil().subtract([
                1,
                1
            ]));
        },
        _noTilesToLoad: function() {
            for(var key in this._tiles){
                if (!this._tiles[key].loaded) return false;
            }
            return true;
        }
    });
    // @factory L.gridLayer(options?: GridLayer options)
    // Creates a new instance of GridLayer with the supplied options.
    function gridLayer(options) {
        return new GridLayer(options);
    }
    /*
   * @class TileLayer
   * @inherits GridLayer
   * @aka L.TileLayer
   * Used to load and display tile layers on the map. Note that most tile servers require attribution, which you can set under `Layer`. Extends `GridLayer`.
   *
   * @example
   *
   * ```js
   * L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png?{foo}', {foo: 'bar', attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'}).addTo(map);
   * ```
   *
   * @section URL template
   * @example
   *
   * A string of the following form:
   *
   * ```
   * 'https://{s}.somedomain.com/blabla/{z}/{x}/{y}{r}.png'
   * ```
   *
   * `{s}` means one of the available subdomains (used sequentially to help with browser parallel requests per domain limitation; subdomain values are specified in options; `a`, `b` or `c` by default, can be omitted), `{z}` — zoom level, `{x}` and `{y}` — tile coordinates. `{r}` can be used to add "&commat;2x" to the URL to load retina tiles.
   *
   * You can use custom keys in the template, which will be [evaluated](#util-template) from TileLayer options, like this:
   *
   * ```
   * L.tileLayer('https://{s}.somedomain.com/{foo}/{z}/{x}/{y}.png', {foo: 'bar'});
   * ```
   */ var TileLayer = GridLayer.extend({
        // @section
        // @aka TileLayer options
        options: {
            // @option minZoom: Number = 0
            // The minimum zoom level down to which this layer will be displayed (inclusive).
            minZoom: 0,
            // @option maxZoom: Number = 18
            // The maximum zoom level up to which this layer will be displayed (inclusive).
            maxZoom: 18,
            // @option subdomains: String|String[] = 'abc'
            // Subdomains of the tile service. Can be passed in the form of one string (where each letter is a subdomain name) or an array of strings.
            subdomains: "abc",
            // @option errorTileUrl: String = ''
            // URL to the tile image to show in place of the tile that failed to load.
            errorTileUrl: "",
            // @option zoomOffset: Number = 0
            // The zoom number used in tile URLs will be offset with this value.
            zoomOffset: 0,
            // @option tms: Boolean = false
            // If `true`, inverses Y axis numbering for tiles (turn this on for [TMS](https://en.wikipedia.org/wiki/Tile_Map_Service) services).
            tms: false,
            // @option zoomReverse: Boolean = false
            // If set to true, the zoom number used in tile URLs will be reversed (`maxZoom - zoom` instead of `zoom`)
            zoomReverse: false,
            // @option detectRetina: Boolean = false
            // If `true` and user is on a retina display, it will request four tiles of half the specified size and a bigger zoom level in place of one to utilize the high resolution.
            detectRetina: false,
            // @option crossOrigin: Boolean|String = false
            // Whether the crossOrigin attribute will be added to the tiles.
            // If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
            // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
            crossOrigin: false,
            // @option referrerPolicy: Boolean|String = false
            // Whether the referrerPolicy attribute will be added to the tiles.
            // If a String is provided, all tiles will have their referrerPolicy attribute set to the String provided.
            // This may be needed if your map's rendering context has a strict default but your tile provider expects a valid referrer
            // (e.g. to validate an API token).
            // Refer to [HTMLImageElement.referrerPolicy](https://developer.mozilla.org/en-US/docs/Web/API/HTMLImageElement/referrerPolicy) for valid String values.
            referrerPolicy: false
        },
        initialize: function(url, options) {
            this._url = url;
            options = setOptions(this, options);
            // detecting retina displays, adjusting tileSize and zoom levels
            if (options.detectRetina && Browser.retina && options.maxZoom > 0) {
                options.tileSize = Math.floor(options.tileSize / 2);
                if (!options.zoomReverse) {
                    options.zoomOffset++;
                    options.maxZoom = Math.max(options.minZoom, options.maxZoom - 1);
                } else {
                    options.zoomOffset--;
                    options.minZoom = Math.min(options.maxZoom, options.minZoom + 1);
                }
                options.minZoom = Math.max(0, options.minZoom);
            } else if (!options.zoomReverse) // make sure maxZoom is gte minZoom
            options.maxZoom = Math.max(options.minZoom, options.maxZoom);
            else // make sure minZoom is lte maxZoom
            options.minZoom = Math.min(options.maxZoom, options.minZoom);
            if (typeof options.subdomains === "string") options.subdomains = options.subdomains.split("");
            this.on("tileunload", this._onTileRemove);
        },
        // @method setUrl(url: String, noRedraw?: Boolean): this
        // Updates the layer's URL template and redraws it (unless `noRedraw` is set to `true`).
        // If the URL does not change, the layer will not be redrawn unless
        // the noRedraw parameter is set to false.
        setUrl: function(url, noRedraw) {
            if (this._url === url && noRedraw === undefined) noRedraw = true;
            this._url = url;
            if (!noRedraw) this.redraw();
            return this;
        },
        // @method createTile(coords: Object, done?: Function): HTMLElement
        // Called only internally, overrides GridLayer's [`createTile()`](#gridlayer-createtile)
        // to return an `<img>` HTML element with the appropriate image URL given `coords`. The `done`
        // callback is called when the tile has been loaded.
        createTile: function(coords, done) {
            var tile = document.createElement("img");
            on(tile, "load", bind(this._tileOnLoad, this, done, tile));
            on(tile, "error", bind(this._tileOnError, this, done, tile));
            if (this.options.crossOrigin || this.options.crossOrigin === "") tile.crossOrigin = this.options.crossOrigin === true ? "" : this.options.crossOrigin;
            // for this new option we follow the documented behavior
            // more closely by only setting the property when string
            if (typeof this.options.referrerPolicy === "string") tile.referrerPolicy = this.options.referrerPolicy;
            // The alt attribute is set to the empty string,
            // allowing screen readers to ignore the decorative image tiles.
            // https://www.w3.org/WAI/tutorials/images/decorative/
            // https://www.w3.org/TR/html-aria/#el-img-empty-alt
            tile.alt = "";
            tile.src = this.getTileUrl(coords);
            return tile;
        },
        // @section Extension methods
        // @uninheritable
        // Layers extending `TileLayer` might reimplement the following method.
        // @method getTileUrl(coords: Object): String
        // Called only internally, returns the URL for a tile given its coordinates.
        // Classes extending `TileLayer` can override this function to provide custom tile URL naming schemes.
        getTileUrl: function(coords) {
            var data = {
                r: Browser.retina ? "@2x" : "",
                s: this._getSubdomain(coords),
                x: coords.x,
                y: coords.y,
                z: this._getZoomForUrl()
            };
            if (this._map && !this._map.options.crs.infinite) {
                var invertedY = this._globalTileRange.max.y - coords.y;
                if (this.options.tms) data["y"] = invertedY;
                data["-y"] = invertedY;
            }
            return template(this._url, extend(data, this.options));
        },
        _tileOnLoad: function(done, tile) {
            // For https://github.com/Leaflet/Leaflet/issues/3332
            if (Browser.ielt9) setTimeout(bind(done, this, null, tile), 0);
            else done(null, tile);
        },
        _tileOnError: function(done, tile, e) {
            var errorUrl = this.options.errorTileUrl;
            if (errorUrl && tile.getAttribute("src") !== errorUrl) tile.src = errorUrl;
            done(e, tile);
        },
        _onTileRemove: function(e) {
            e.tile.onload = null;
        },
        _getZoomForUrl: function() {
            var zoom = this._tileZoom, maxZoom = this.options.maxZoom, zoomReverse = this.options.zoomReverse, zoomOffset = this.options.zoomOffset;
            if (zoomReverse) zoom = maxZoom - zoom;
            return zoom + zoomOffset;
        },
        _getSubdomain: function(tilePoint) {
            var index = Math.abs(tilePoint.x + tilePoint.y) % this.options.subdomains.length;
            return this.options.subdomains[index];
        },
        // stops loading all tiles in the background layer
        _abortLoading: function() {
            var i, tile;
            for(i in this._tiles)if (this._tiles[i].coords.z !== this._tileZoom) {
                tile = this._tiles[i].el;
                tile.onload = falseFn;
                tile.onerror = falseFn;
                if (!tile.complete) {
                    tile.src = emptyImageUrl;
                    var coords = this._tiles[i].coords;
                    remove(tile);
                    delete this._tiles[i];
                    // @event tileabort: TileEvent
                    // Fired when a tile was loading but is now not wanted.
                    this.fire("tileabort", {
                        tile: tile,
                        coords: coords
                    });
                }
            }
        },
        _removeTile: function(key) {
            var tile = this._tiles[key];
            if (!tile) return;
            // Cancels any pending http requests associated with the tile
            tile.el.setAttribute("src", emptyImageUrl);
            return GridLayer.prototype._removeTile.call(this, key);
        },
        _tileReady: function(coords, err, tile) {
            if (!this._map || tile && tile.getAttribute("src") === emptyImageUrl) return;
            return GridLayer.prototype._tileReady.call(this, coords, err, tile);
        }
    });
    // @factory L.tilelayer(urlTemplate: String, options?: TileLayer options)
    // Instantiates a tile layer object given a `URL template` and optionally an options object.
    function tileLayer(url, options) {
        return new TileLayer(url, options);
    }
    /*
   * @class TileLayer.WMS
   * @inherits TileLayer
   * @aka L.TileLayer.WMS
   * Used to display [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services as tile layers on the map. Extends `TileLayer`.
   *
   * @example
   *
   * ```js
   * var nexrad = L.tileLayer.wms("http://mesonet.agron.iastate.edu/cgi-bin/wms/nexrad/n0r.cgi", {
   * 	layers: 'nexrad-n0r-900913',
   * 	format: 'image/png',
   * 	transparent: true,
   * 	attribution: "Weather data © 2012 IEM Nexrad"
   * });
   * ```
   */ var TileLayerWMS = TileLayer.extend({
        // @section
        // @aka TileLayer.WMS options
        // If any custom options not documented here are used, they will be sent to the
        // WMS server as extra parameters in each request URL. This can be useful for
        // [non-standard vendor WMS parameters](https://docs.geoserver.org/stable/en/user/services/wms/vendor.html).
        defaultWmsParams: {
            service: "WMS",
            request: "GetMap",
            // @option layers: String = ''
            // **(required)** Comma-separated list of WMS layers to show.
            layers: "",
            // @option styles: String = ''
            // Comma-separated list of WMS styles.
            styles: "",
            // @option format: String = 'image/jpeg'
            // WMS image format (use `'image/png'` for layers with transparency).
            format: "image/jpeg",
            // @option transparent: Boolean = false
            // If `true`, the WMS service will return images with transparency.
            transparent: false,
            // @option version: String = '1.1.1'
            // Version of the WMS service to use
            version: "1.1.1"
        },
        options: {
            // @option crs: CRS = null
            // Coordinate Reference System to use for the WMS requests, defaults to
            // map CRS. Don't change this if you're not sure what it means.
            crs: null,
            // @option uppercase: Boolean = false
            // If `true`, WMS request parameter keys will be uppercase.
            uppercase: false
        },
        initialize: function(url, options) {
            this._url = url;
            var wmsParams = extend({}, this.defaultWmsParams);
            // all keys that are not TileLayer options go to WMS params
            for(var i in options)if (!(i in this.options)) wmsParams[i] = options[i];
            options = setOptions(this, options);
            var realRetina = options.detectRetina && Browser.retina ? 2 : 1;
            var tileSize = this.getTileSize();
            wmsParams.width = tileSize.x * realRetina;
            wmsParams.height = tileSize.y * realRetina;
            this.wmsParams = wmsParams;
        },
        onAdd: function(map) {
            this._crs = this.options.crs || map.options.crs;
            this._wmsVersion = parseFloat(this.wmsParams.version);
            var projectionKey = this._wmsVersion >= 1.3 ? "crs" : "srs";
            this.wmsParams[projectionKey] = this._crs.code;
            TileLayer.prototype.onAdd.call(this, map);
        },
        getTileUrl: function(coords) {
            var tileBounds = this._tileCoordsToNwSe(coords), crs = this._crs, bounds = toBounds(crs.project(tileBounds[0]), crs.project(tileBounds[1])), min = bounds.min, max = bounds.max, bbox = (this._wmsVersion >= 1.3 && this._crs === EPSG4326 ? [
                min.y,
                min.x,
                max.y,
                max.x
            ] : [
                min.x,
                min.y,
                max.x,
                max.y
            ]).join(","), url = TileLayer.prototype.getTileUrl.call(this, coords);
            return url + getParamString(this.wmsParams, url, this.options.uppercase) + (this.options.uppercase ? "&BBOX=" : "&bbox=") + bbox;
        },
        // @method setParams(params: Object, noRedraw?: Boolean): this
        // Merges an object with the new parameters and re-requests tiles on the current screen (unless `noRedraw` was set to true).
        setParams: function(params, noRedraw) {
            extend(this.wmsParams, params);
            if (!noRedraw) this.redraw();
            return this;
        }
    });
    // @factory L.tileLayer.wms(baseUrl: String, options: TileLayer.WMS options)
    // Instantiates a WMS tile layer object given a base URL of the WMS service and a WMS parameters/options object.
    function tileLayerWMS(url, options) {
        return new TileLayerWMS(url, options);
    }
    TileLayer.WMS = TileLayerWMS;
    tileLayer.wms = tileLayerWMS;
    /*
   * @class Renderer
   * @inherits Layer
   * @aka L.Renderer
   *
   * Base class for vector renderer implementations (`SVG`, `Canvas`). Handles the
   * DOM container of the renderer, its bounds, and its zoom animation.
   *
   * A `Renderer` works as an implicit layer group for all `Path`s - the renderer
   * itself can be added or removed to the map. All paths use a renderer, which can
   * be implicit (the map will decide the type of renderer and use it automatically)
   * or explicit (using the [`renderer`](#path-renderer) option of the path).
   *
   * Do not use this class directly, use `SVG` and `Canvas` instead.
   *
   * @event update: Event
   * Fired when the renderer updates its bounds, center and zoom, for example when
   * its map has moved
   */ var Renderer = Layer.extend({
        // @section
        // @aka Renderer options
        options: {
            // @option padding: Number = 0.1
            // How much to extend the clip area around the map view (relative to its size)
            // e.g. 0.1 would be 10% of map view in each direction
            padding: 0.1
        },
        initialize: function(options) {
            setOptions(this, options);
            stamp(this);
            this._layers = this._layers || {};
        },
        onAdd: function() {
            if (!this._container) {
                this._initContainer(); // defined by renderer implementations
                // always keep transform-origin as 0 0
                addClass(this._container, "leaflet-zoom-animated");
            }
            this.getPane().appendChild(this._container);
            this._update();
            this.on("update", this._updatePaths, this);
        },
        onRemove: function() {
            this.off("update", this._updatePaths, this);
            this._destroyContainer();
        },
        getEvents: function() {
            var events = {
                viewreset: this._reset,
                zoom: this._onZoom,
                moveend: this._update,
                zoomend: this._onZoomEnd
            };
            if (this._zoomAnimated) events.zoomanim = this._onAnimZoom;
            return events;
        },
        _onAnimZoom: function(ev) {
            this._updateTransform(ev.center, ev.zoom);
        },
        _onZoom: function() {
            this._updateTransform(this._map.getCenter(), this._map.getZoom());
        },
        _updateTransform: function(center, zoom) {
            var scale = this._map.getZoomScale(zoom, this._zoom), viewHalf = this._map.getSize().multiplyBy(0.5 + this.options.padding), currentCenterPoint = this._map.project(this._center, zoom), topLeftOffset = viewHalf.multiplyBy(-scale).add(currentCenterPoint).subtract(this._map._getNewPixelOrigin(center, zoom));
            if (Browser.any3d) setTransform(this._container, topLeftOffset, scale);
            else setPosition(this._container, topLeftOffset);
        },
        _reset: function() {
            this._update();
            this._updateTransform(this._center, this._zoom);
            for(var id in this._layers)this._layers[id]._reset();
        },
        _onZoomEnd: function() {
            for(var id in this._layers)this._layers[id]._project();
        },
        _updatePaths: function() {
            for(var id in this._layers)this._layers[id]._update();
        },
        _update: function() {
            // Update pixel bounds of renderer container (for positioning/sizing/clipping later)
            // Subclasses are responsible of firing the 'update' event.
            var p = this.options.padding, size = this._map.getSize(), min = this._map.containerPointToLayerPoint(size.multiplyBy(-p)).round();
            this._bounds = new Bounds(min, min.add(size.multiplyBy(1 + p * 2)).round());
            this._center = this._map.getCenter();
            this._zoom = this._map.getZoom();
        }
    });
    /*
   * @class Canvas
   * @inherits Renderer
   * @aka L.Canvas
   *
   * Allows vector layers to be displayed with [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
   * Inherits `Renderer`.
   *
   * Due to [technical limitations](https://caniuse.com/canvas), Canvas is not
   * available in all web browsers, notably IE8, and overlapping geometries might
   * not display properly in some edge cases.
   *
   * @example
   *
   * Use Canvas by default for all paths in the map:
   *
   * ```js
   * var map = L.map('map', {
   * 	renderer: L.canvas()
   * });
   * ```
   *
   * Use a Canvas renderer with extra padding for specific vector geometries:
   *
   * ```js
   * var map = L.map('map');
   * var myRenderer = L.canvas({ padding: 0.5 });
   * var line = L.polyline( coordinates, { renderer: myRenderer } );
   * var circle = L.circle( center, { renderer: myRenderer } );
   * ```
   */ var Canvas = Renderer.extend({
        // @section
        // @aka Canvas options
        options: {
            // @option tolerance: Number = 0
            // How much to extend the click tolerance around a path/object on the map.
            tolerance: 0
        },
        getEvents: function() {
            var events = Renderer.prototype.getEvents.call(this);
            events.viewprereset = this._onViewPreReset;
            return events;
        },
        _onViewPreReset: function() {
            // Set a flag so that a viewprereset+moveend+viewreset only updates&redraws once
            this._postponeUpdatePaths = true;
        },
        onAdd: function() {
            Renderer.prototype.onAdd.call(this);
            // Redraw vectors since canvas is cleared upon removal,
            // in case of removing the renderer itself from the map.
            this._draw();
        },
        _initContainer: function() {
            var container = this._container = document.createElement("canvas");
            on(container, "mousemove", this._onMouseMove, this);
            on(container, "click dblclick mousedown mouseup contextmenu", this._onClick, this);
            on(container, "mouseout", this._handleMouseOut, this);
            container["_leaflet_disable_events"] = true;
            this._ctx = container.getContext("2d");
        },
        _destroyContainer: function() {
            cancelAnimFrame(this._redrawRequest);
            delete this._ctx;
            remove(this._container);
            off(this._container);
            delete this._container;
        },
        _updatePaths: function() {
            if (this._postponeUpdatePaths) return;
            var layer;
            this._redrawBounds = null;
            for(var id in this._layers){
                layer = this._layers[id];
                layer._update();
            }
            this._redraw();
        },
        _update: function() {
            if (this._map._animatingZoom && this._bounds) return;
            Renderer.prototype._update.call(this);
            var b = this._bounds, container = this._container, size = b.getSize(), m = Browser.retina ? 2 : 1;
            setPosition(container, b.min);
            // set canvas size (also clearing it); use double size on retina
            container.width = m * size.x;
            container.height = m * size.y;
            container.style.width = size.x + "px";
            container.style.height = size.y + "px";
            if (Browser.retina) this._ctx.scale(2, 2);
            // translate so we use the same path coordinates after canvas element moves
            this._ctx.translate(-b.min.x, -b.min.y);
            // Tell paths to redraw themselves
            this.fire("update");
        },
        _reset: function() {
            Renderer.prototype._reset.call(this);
            if (this._postponeUpdatePaths) {
                this._postponeUpdatePaths = false;
                this._updatePaths();
            }
        },
        _initPath: function(layer) {
            this._updateDashArray(layer);
            this._layers[stamp(layer)] = layer;
            var order = layer._order = {
                layer: layer,
                prev: this._drawLast,
                next: null
            };
            if (this._drawLast) this._drawLast.next = order;
            this._drawLast = order;
            this._drawFirst = this._drawFirst || this._drawLast;
        },
        _addPath: function(layer) {
            this._requestRedraw(layer);
        },
        _removePath: function(layer) {
            var order = layer._order;
            var next = order.next;
            var prev = order.prev;
            if (next) next.prev = prev;
            else this._drawLast = prev;
            if (prev) prev.next = next;
            else this._drawFirst = next;
            delete layer._order;
            delete this._layers[stamp(layer)];
            this._requestRedraw(layer);
        },
        _updatePath: function(layer) {
            // Redraw the union of the layer's old pixel
            // bounds and the new pixel bounds.
            this._extendRedrawBounds(layer);
            layer._project();
            layer._update();
            // The redraw will extend the redraw bounds
            // with the new pixel bounds.
            this._requestRedraw(layer);
        },
        _updateStyle: function(layer) {
            this._updateDashArray(layer);
            this._requestRedraw(layer);
        },
        _updateDashArray: function(layer) {
            if (typeof layer.options.dashArray === "string") {
                var parts = layer.options.dashArray.split(/[, ]+/), dashArray = [], dashValue, i;
                for(i = 0; i < parts.length; i++){
                    dashValue = Number(parts[i]);
                    // Ignore dash array containing invalid lengths
                    if (isNaN(dashValue)) return;
                    dashArray.push(dashValue);
                }
                layer.options._dashArray = dashArray;
            } else layer.options._dashArray = layer.options.dashArray;
        },
        _requestRedraw: function(layer) {
            if (!this._map) return;
            this._extendRedrawBounds(layer);
            this._redrawRequest = this._redrawRequest || requestAnimFrame(this._redraw, this);
        },
        _extendRedrawBounds: function(layer) {
            if (layer._pxBounds) {
                var padding = (layer.options.weight || 0) + 1;
                this._redrawBounds = this._redrawBounds || new Bounds();
                this._redrawBounds.extend(layer._pxBounds.min.subtract([
                    padding,
                    padding
                ]));
                this._redrawBounds.extend(layer._pxBounds.max.add([
                    padding,
                    padding
                ]));
            }
        },
        _redraw: function() {
            this._redrawRequest = null;
            if (this._redrawBounds) {
                this._redrawBounds.min._floor();
                this._redrawBounds.max._ceil();
            }
            this._clear(); // clear layers in redraw bounds
            this._draw(); // draw layers
            this._redrawBounds = null;
        },
        _clear: function() {
            var bounds = this._redrawBounds;
            if (bounds) {
                var size = bounds.getSize();
                this._ctx.clearRect(bounds.min.x, bounds.min.y, size.x, size.y);
            } else {
                this._ctx.save();
                this._ctx.setTransform(1, 0, 0, 1, 0, 0);
                this._ctx.clearRect(0, 0, this._container.width, this._container.height);
                this._ctx.restore();
            }
        },
        _draw: function() {
            var layer, bounds = this._redrawBounds;
            this._ctx.save();
            if (bounds) {
                var size = bounds.getSize();
                this._ctx.beginPath();
                this._ctx.rect(bounds.min.x, bounds.min.y, size.x, size.y);
                this._ctx.clip();
            }
            this._drawing = true;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (!bounds || layer._pxBounds && layer._pxBounds.intersects(bounds)) layer._updatePath();
            }
            this._drawing = false;
            this._ctx.restore(); // Restore state before clipping.
        },
        _updatePoly: function(layer, closed) {
            if (!this._drawing) return;
            var i, j, len2, p, parts = layer._parts, len = parts.length, ctx = this._ctx;
            if (!len) return;
            ctx.beginPath();
            for(i = 0; i < len; i++){
                for(j = 0, len2 = parts[i].length; j < len2; j++){
                    p = parts[i][j];
                    ctx[j ? "lineTo" : "moveTo"](p.x, p.y);
                }
                if (closed) ctx.closePath();
            }
            this._fillStroke(ctx, layer);
        // TODO optimization: 1 fill/stroke for all features with equal style instead of 1 for each feature
        },
        _updateCircle: function(layer) {
            if (!this._drawing || layer._empty()) return;
            var p = layer._point, ctx = this._ctx, r = Math.max(Math.round(layer._radius), 1), s = (Math.max(Math.round(layer._radiusY), 1) || r) / r;
            if (s !== 1) {
                ctx.save();
                ctx.scale(1, s);
            }
            ctx.beginPath();
            ctx.arc(p.x, p.y / s, r, 0, Math.PI * 2, false);
            if (s !== 1) ctx.restore();
            this._fillStroke(ctx, layer);
        },
        _fillStroke: function(ctx, layer) {
            var options = layer.options;
            if (options.fill) {
                ctx.globalAlpha = options.fillOpacity;
                ctx.fillStyle = options.fillColor || options.color;
                ctx.fill(options.fillRule || "evenodd");
            }
            if (options.stroke && options.weight !== 0) {
                if (ctx.setLineDash) ctx.setLineDash(layer.options && layer.options._dashArray || []);
                ctx.globalAlpha = options.opacity;
                ctx.lineWidth = options.weight;
                ctx.strokeStyle = options.color;
                ctx.lineCap = options.lineCap;
                ctx.lineJoin = options.lineJoin;
                ctx.stroke();
            }
        },
        // Canvas obviously doesn't have mouse events for individual drawn objects,
        // so we emulate that by calculating what's under the mouse on mousemove/click manually
        _onClick: function(e) {
            var point = this._map.mouseEventToLayerPoint(e), layer, clickedLayer;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (layer.options.interactive && layer._containsPoint(point)) {
                    if (!(e.type === "click" || e.type === "preclick") || !this._map._draggableMoved(layer)) clickedLayer = layer;
                }
            }
            this._fireEvent(clickedLayer ? [
                clickedLayer
            ] : false, e);
        },
        _onMouseMove: function(e) {
            if (!this._map || this._map.dragging.moving() || this._map._animatingZoom) return;
            var point = this._map.mouseEventToLayerPoint(e);
            this._handleMouseHover(e, point);
        },
        _handleMouseOut: function(e) {
            var layer = this._hoveredLayer;
            if (layer) {
                // if we're leaving the layer, fire mouseout
                removeClass(this._container, "leaflet-interactive");
                this._fireEvent([
                    layer
                ], e, "mouseout");
                this._hoveredLayer = null;
                this._mouseHoverThrottled = false;
            }
        },
        _handleMouseHover: function(e, point) {
            if (this._mouseHoverThrottled) return;
            var layer, candidateHoveredLayer;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (layer.options.interactive && layer._containsPoint(point)) candidateHoveredLayer = layer;
            }
            if (candidateHoveredLayer !== this._hoveredLayer) {
                this._handleMouseOut(e);
                if (candidateHoveredLayer) {
                    addClass(this._container, "leaflet-interactive"); // change cursor
                    this._fireEvent([
                        candidateHoveredLayer
                    ], e, "mouseover");
                    this._hoveredLayer = candidateHoveredLayer;
                }
            }
            this._fireEvent(this._hoveredLayer ? [
                this._hoveredLayer
            ] : false, e);
            this._mouseHoverThrottled = true;
            setTimeout(bind(function() {
                this._mouseHoverThrottled = false;
            }, this), 32);
        },
        _fireEvent: function(layers, e, type) {
            this._map._fireDOMEvent(e, type || e.type, layers);
        },
        _bringToFront: function(layer) {
            var order = layer._order;
            if (!order) return;
            var next = order.next;
            var prev = order.prev;
            if (next) next.prev = prev;
            else // Already last
            return;
            if (prev) prev.next = next;
            else if (next) // Update first entry unless this is the
            // single entry
            this._drawFirst = next;
            order.prev = this._drawLast;
            this._drawLast.next = order;
            order.next = null;
            this._drawLast = order;
            this._requestRedraw(layer);
        },
        _bringToBack: function(layer) {
            var order = layer._order;
            if (!order) return;
            var next = order.next;
            var prev = order.prev;
            if (prev) prev.next = next;
            else // Already first
            return;
            if (next) next.prev = prev;
            else if (prev) // Update last entry unless this is the
            // single entry
            this._drawLast = prev;
            order.prev = null;
            order.next = this._drawFirst;
            this._drawFirst.prev = order;
            this._drawFirst = order;
            this._requestRedraw(layer);
        }
    });
    // @factory L.canvas(options?: Renderer options)
    // Creates a Canvas renderer with the given options.
    function canvas(options) {
        return Browser.canvas ? new Canvas(options) : null;
    }
    /*
   * Thanks to Dmitry Baranovsky and his Raphael library for inspiration!
   */ var vmlCreate = function() {
        try {
            document.namespaces.add("lvml", "urn:schemas-microsoft-com:vml");
            return function(name) {
                return document.createElement("<lvml:" + name + ' class="lvml">');
            };
        } catch (e) {
        // Do not return fn from catch block so `e` can be garbage collected
        // See https://github.com/Leaflet/Leaflet/pull/7279
        }
        return function(name) {
            return document.createElement("<" + name + ' xmlns="urn:schemas-microsoft.com:vml" class="lvml">');
        };
    }();
    /*
   * @class SVG
   *
   *
   * VML was deprecated in 2012, which means VML functionality exists only for backwards compatibility
   * with old versions of Internet Explorer.
   */ // mixin to redefine some SVG methods to handle VML syntax which is similar but with some differences
    var vmlMixin = {
        _initContainer: function() {
            this._container = create$1("div", "leaflet-vml-container");
        },
        _update: function() {
            if (this._map._animatingZoom) return;
            Renderer.prototype._update.call(this);
            this.fire("update");
        },
        _initPath: function(layer) {
            var container = layer._container = vmlCreate("shape");
            addClass(container, "leaflet-vml-shape " + (this.options.className || ""));
            container.coordsize = "1 1";
            layer._path = vmlCreate("path");
            container.appendChild(layer._path);
            this._updateStyle(layer);
            this._layers[stamp(layer)] = layer;
        },
        _addPath: function(layer) {
            var container = layer._container;
            this._container.appendChild(container);
            if (layer.options.interactive) layer.addInteractiveTarget(container);
        },
        _removePath: function(layer) {
            var container = layer._container;
            remove(container);
            layer.removeInteractiveTarget(container);
            delete this._layers[stamp(layer)];
        },
        _updateStyle: function(layer) {
            var stroke = layer._stroke, fill = layer._fill, options = layer.options, container = layer._container;
            container.stroked = !!options.stroke;
            container.filled = !!options.fill;
            if (options.stroke) {
                if (!stroke) stroke = layer._stroke = vmlCreate("stroke");
                container.appendChild(stroke);
                stroke.weight = options.weight + "px";
                stroke.color = options.color;
                stroke.opacity = options.opacity;
                if (options.dashArray) stroke.dashStyle = isArray(options.dashArray) ? options.dashArray.join(" ") : options.dashArray.replace(/( *, *)/g, " ");
                else stroke.dashStyle = "";
                stroke.endcap = options.lineCap.replace("butt", "flat");
                stroke.joinstyle = options.lineJoin;
            } else if (stroke) {
                container.removeChild(stroke);
                layer._stroke = null;
            }
            if (options.fill) {
                if (!fill) fill = layer._fill = vmlCreate("fill");
                container.appendChild(fill);
                fill.color = options.fillColor || options.color;
                fill.opacity = options.fillOpacity;
            } else if (fill) {
                container.removeChild(fill);
                layer._fill = null;
            }
        },
        _updateCircle: function(layer) {
            var p = layer._point.round(), r = Math.round(layer._radius), r2 = Math.round(layer._radiusY || r);
            this._setPath(layer, layer._empty() ? "M0 0" : "AL " + p.x + "," + p.y + " " + r + "," + r2 + " 0," + 23592600);
        },
        _setPath: function(layer, path) {
            layer._path.v = path;
        },
        _bringToFront: function(layer) {
            toFront(layer._container);
        },
        _bringToBack: function(layer) {
            toBack(layer._container);
        }
    };
    var create = Browser.vml ? vmlCreate : svgCreate;
    /*
   * @class SVG
   * @inherits Renderer
   * @aka L.SVG
   *
   * Allows vector layers to be displayed with [SVG](https://developer.mozilla.org/docs/Web/SVG).
   * Inherits `Renderer`.
   *
   * Due to [technical limitations](https://caniuse.com/svg), SVG is not
   * available in all web browsers, notably Android 2.x and 3.x.
   *
   * Although SVG is not available on IE7 and IE8, these browsers support
   * [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language)
   * (a now deprecated technology), and the SVG renderer will fall back to VML in
   * this case.
   *
   * @example
   *
   * Use SVG by default for all paths in the map:
   *
   * ```js
   * var map = L.map('map', {
   * 	renderer: L.svg()
   * });
   * ```
   *
   * Use a SVG renderer with extra padding for specific vector geometries:
   *
   * ```js
   * var map = L.map('map');
   * var myRenderer = L.svg({ padding: 0.5 });
   * var line = L.polyline( coordinates, { renderer: myRenderer } );
   * var circle = L.circle( center, { renderer: myRenderer } );
   * ```
   */ var SVG = Renderer.extend({
        _initContainer: function() {
            this._container = create("svg");
            // makes it possible to click through svg root; we'll reset it back in individual paths
            this._container.setAttribute("pointer-events", "none");
            this._rootGroup = create("g");
            this._container.appendChild(this._rootGroup);
        },
        _destroyContainer: function() {
            remove(this._container);
            off(this._container);
            delete this._container;
            delete this._rootGroup;
            delete this._svgSize;
        },
        _update: function() {
            if (this._map._animatingZoom && this._bounds) return;
            Renderer.prototype._update.call(this);
            var b = this._bounds, size = b.getSize(), container = this._container;
            // set size of svg-container if changed
            if (!this._svgSize || !this._svgSize.equals(size)) {
                this._svgSize = size;
                container.setAttribute("width", size.x);
                container.setAttribute("height", size.y);
            }
            // movement: update container viewBox so that we don't have to change coordinates of individual layers
            setPosition(container, b.min);
            container.setAttribute("viewBox", [
                b.min.x,
                b.min.y,
                size.x,
                size.y
            ].join(" "));
            this.fire("update");
        },
        // methods below are called by vector layers implementations
        _initPath: function(layer) {
            var path = layer._path = create("path");
            // @namespace Path
            // @option className: String = null
            // Custom class name set on an element. Only for SVG renderer.
            if (layer.options.className) addClass(path, layer.options.className);
            if (layer.options.interactive) addClass(path, "leaflet-interactive");
            this._updateStyle(layer);
            this._layers[stamp(layer)] = layer;
        },
        _addPath: function(layer) {
            if (!this._rootGroup) this._initContainer();
            this._rootGroup.appendChild(layer._path);
            layer.addInteractiveTarget(layer._path);
        },
        _removePath: function(layer) {
            remove(layer._path);
            layer.removeInteractiveTarget(layer._path);
            delete this._layers[stamp(layer)];
        },
        _updatePath: function(layer) {
            layer._project();
            layer._update();
        },
        _updateStyle: function(layer) {
            var path = layer._path, options = layer.options;
            if (!path) return;
            if (options.stroke) {
                path.setAttribute("stroke", options.color);
                path.setAttribute("stroke-opacity", options.opacity);
                path.setAttribute("stroke-width", options.weight);
                path.setAttribute("stroke-linecap", options.lineCap);
                path.setAttribute("stroke-linejoin", options.lineJoin);
                if (options.dashArray) path.setAttribute("stroke-dasharray", options.dashArray);
                else path.removeAttribute("stroke-dasharray");
                if (options.dashOffset) path.setAttribute("stroke-dashoffset", options.dashOffset);
                else path.removeAttribute("stroke-dashoffset");
            } else path.setAttribute("stroke", "none");
            if (options.fill) {
                path.setAttribute("fill", options.fillColor || options.color);
                path.setAttribute("fill-opacity", options.fillOpacity);
                path.setAttribute("fill-rule", options.fillRule || "evenodd");
            } else path.setAttribute("fill", "none");
        },
        _updatePoly: function(layer, closed) {
            this._setPath(layer, pointsToPath(layer._parts, closed));
        },
        _updateCircle: function(layer) {
            var p = layer._point, r = Math.max(Math.round(layer._radius), 1), r2 = Math.max(Math.round(layer._radiusY), 1) || r, arc = "a" + r + "," + r2 + " 0 1,0 ";
            // drawing a circle with two half-arcs
            var d = layer._empty() ? "M0 0" : "M" + (p.x - r) + "," + p.y + arc + r * 2 + ",0 " + arc + -r * 2 + ",0 ";
            this._setPath(layer, d);
        },
        _setPath: function(layer, path) {
            layer._path.setAttribute("d", path);
        },
        // SVG does not have the concept of zIndex so we resort to changing the DOM order of elements
        _bringToFront: function(layer) {
            toFront(layer._path);
        },
        _bringToBack: function(layer) {
            toBack(layer._path);
        }
    });
    if (Browser.vml) SVG.include(vmlMixin);
    // @namespace SVG
    // @factory L.svg(options?: Renderer options)
    // Creates a SVG renderer with the given options.
    function svg(options) {
        return Browser.svg || Browser.vml ? new SVG(options) : null;
    }
    Map.include({
        // @namespace Map; @method getRenderer(layer: Path): Renderer
        // Returns the instance of `Renderer` that should be used to render the given
        // `Path`. It will ensure that the `renderer` options of the map and paths
        // are respected, and that the renderers do exist on the map.
        getRenderer: function(layer) {
            // @namespace Path; @option renderer: Renderer
            // Use this specific instance of `Renderer` for this path. Takes
            // precedence over the map's [default renderer](#map-renderer).
            var renderer = layer.options.renderer || this._getPaneRenderer(layer.options.pane) || this.options.renderer || this._renderer;
            if (!renderer) renderer = this._renderer = this._createRenderer();
            if (!this.hasLayer(renderer)) this.addLayer(renderer);
            return renderer;
        },
        _getPaneRenderer: function(name) {
            if (name === "overlayPane" || name === undefined) return false;
            var renderer = this._paneRenderers[name];
            if (renderer === undefined) {
                renderer = this._createRenderer({
                    pane: name
                });
                this._paneRenderers[name] = renderer;
            }
            return renderer;
        },
        _createRenderer: function(options) {
            // @namespace Map; @option preferCanvas: Boolean = false
            // Whether `Path`s should be rendered on a `Canvas` renderer.
            // By default, all `Path`s are rendered in a `SVG` renderer.
            return this.options.preferCanvas && canvas(options) || svg(options);
        }
    });
    /*
   * L.Rectangle extends Polygon and creates a rectangle when passed a LatLngBounds object.
   */ /*
   * @class Rectangle
   * @aka L.Rectangle
   * @inherits Polygon
   *
   * A class for drawing rectangle overlays on a map. Extends `Polygon`.
   *
   * @example
   *
   * ```js
   * // define rectangle geographical bounds
   * var bounds = [[54.559322, -5.767822], [56.1210604, -3.021240]];
   *
   * // create an orange rectangle
   * L.rectangle(bounds, {color: "#ff7800", weight: 1}).addTo(map);
   *
   * // zoom the map to the rectangle bounds
   * map.fitBounds(bounds);
   * ```
   *
   */ var Rectangle = Polygon.extend({
        initialize: function(latLngBounds, options) {
            Polygon.prototype.initialize.call(this, this._boundsToLatLngs(latLngBounds), options);
        },
        // @method setBounds(latLngBounds: LatLngBounds): this
        // Redraws the rectangle with the passed bounds.
        setBounds: function(latLngBounds) {
            return this.setLatLngs(this._boundsToLatLngs(latLngBounds));
        },
        _boundsToLatLngs: function(latLngBounds) {
            latLngBounds = toLatLngBounds(latLngBounds);
            return [
                latLngBounds.getSouthWest(),
                latLngBounds.getNorthWest(),
                latLngBounds.getNorthEast(),
                latLngBounds.getSouthEast()
            ];
        }
    });
    // @factory L.rectangle(latLngBounds: LatLngBounds, options?: Polyline options)
    function rectangle(latLngBounds, options) {
        return new Rectangle(latLngBounds, options);
    }
    SVG.create = create;
    SVG.pointsToPath = pointsToPath;
    GeoJSON.geometryToLayer = geometryToLayer;
    GeoJSON.coordsToLatLng = coordsToLatLng;
    GeoJSON.coordsToLatLngs = coordsToLatLngs;
    GeoJSON.latLngToCoords = latLngToCoords;
    GeoJSON.latLngsToCoords = latLngsToCoords;
    GeoJSON.getFeature = getFeature;
    GeoJSON.asFeature = asFeature;
    /*
   * L.Handler.BoxZoom is used to add shift-drag zoom interaction to the map
   * (zoom to a selected bounding box), enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option boxZoom: Boolean = true
        // Whether the map can be zoomed to a rectangular area specified by
        // dragging the mouse while pressing the shift key.
        boxZoom: true
    });
    var BoxZoom = Handler.extend({
        initialize: function(map) {
            this._map = map;
            this._container = map._container;
            this._pane = map._panes.overlayPane;
            this._resetStateTimeout = 0;
            map.on("unload", this._destroy, this);
        },
        addHooks: function() {
            on(this._container, "mousedown", this._onMouseDown, this);
        },
        removeHooks: function() {
            off(this._container, "mousedown", this._onMouseDown, this);
        },
        moved: function() {
            return this._moved;
        },
        _destroy: function() {
            remove(this._pane);
            delete this._pane;
        },
        _resetState: function() {
            this._resetStateTimeout = 0;
            this._moved = false;
        },
        _clearDeferredResetState: function() {
            if (this._resetStateTimeout !== 0) {
                clearTimeout(this._resetStateTimeout);
                this._resetStateTimeout = 0;
            }
        },
        _onMouseDown: function(e) {
            if (!e.shiftKey || e.which !== 1 && e.button !== 1) return false;
            // Clear the deferred resetState if it hasn't executed yet, otherwise it
            // will interrupt the interaction and orphan a box element in the container.
            this._clearDeferredResetState();
            this._resetState();
            disableTextSelection();
            disableImageDrag();
            this._startPoint = this._map.mouseEventToContainerPoint(e);
            on(document, {
                contextmenu: stop,
                mousemove: this._onMouseMove,
                mouseup: this._onMouseUp,
                keydown: this._onKeyDown
            }, this);
        },
        _onMouseMove: function(e) {
            if (!this._moved) {
                this._moved = true;
                this._box = create$1("div", "leaflet-zoom-box", this._container);
                addClass(this._container, "leaflet-crosshair");
                this._map.fire("boxzoomstart");
            }
            this._point = this._map.mouseEventToContainerPoint(e);
            var bounds = new Bounds(this._point, this._startPoint), size = bounds.getSize();
            setPosition(this._box, bounds.min);
            this._box.style.width = size.x + "px";
            this._box.style.height = size.y + "px";
        },
        _finish: function() {
            if (this._moved) {
                remove(this._box);
                removeClass(this._container, "leaflet-crosshair");
            }
            enableTextSelection();
            enableImageDrag();
            off(document, {
                contextmenu: stop,
                mousemove: this._onMouseMove,
                mouseup: this._onMouseUp,
                keydown: this._onKeyDown
            }, this);
        },
        _onMouseUp: function(e) {
            if (e.which !== 1 && e.button !== 1) return;
            this._finish();
            if (!this._moved) return;
            // Postpone to next JS tick so internal click event handling
            // still see it as "moved".
            this._clearDeferredResetState();
            this._resetStateTimeout = setTimeout(bind(this._resetState, this), 0);
            var bounds = new LatLngBounds(this._map.containerPointToLatLng(this._startPoint), this._map.containerPointToLatLng(this._point));
            this._map.fitBounds(bounds).fire("boxzoomend", {
                boxZoomBounds: bounds
            });
        },
        _onKeyDown: function(e) {
            if (e.keyCode === 27) {
                this._finish();
                this._clearDeferredResetState();
                this._resetState();
            }
        }
    });
    // @section Handlers
    // @property boxZoom: Handler
    // Box (shift-drag with mouse) zoom handler.
    Map.addInitHook("addHandler", "boxZoom", BoxZoom);
    /*
   * L.Handler.DoubleClickZoom is used to handle double-click zoom on the map, enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option doubleClickZoom: Boolean|String = true
        // Whether the map can be zoomed in by double clicking on it and
        // zoomed out by double clicking while holding shift. If passed
        // `'center'`, double-click zoom will zoom to the center of the
        //  view regardless of where the mouse was.
        doubleClickZoom: true
    });
    var DoubleClickZoom = Handler.extend({
        addHooks: function() {
            this._map.on("dblclick", this._onDoubleClick, this);
        },
        removeHooks: function() {
            this._map.off("dblclick", this._onDoubleClick, this);
        },
        _onDoubleClick: function(e) {
            var map = this._map, oldZoom = map.getZoom(), delta = map.options.zoomDelta, zoom = e.originalEvent.shiftKey ? oldZoom - delta : oldZoom + delta;
            if (map.options.doubleClickZoom === "center") map.setZoom(zoom);
            else map.setZoomAround(e.containerPoint, zoom);
        }
    });
    // @section Handlers
    //
    // Map properties include interaction handlers that allow you to control
    // interaction behavior in runtime, enabling or disabling certain features such
    // as dragging or touch zoom (see `Handler` methods). For example:
    //
    // ```js
    // map.doubleClickZoom.disable();
    // ```
    //
    // @property doubleClickZoom: Handler
    // Double click zoom handler.
    Map.addInitHook("addHandler", "doubleClickZoom", DoubleClickZoom);
    /*
   * L.Handler.MapDrag is used to make the map draggable (with panning inertia), enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option dragging: Boolean = true
        // Whether the map is draggable with mouse/touch or not.
        dragging: true,
        // @section Panning Inertia Options
        // @option inertia: Boolean = *
        // If enabled, panning of the map will have an inertia effect where
        // the map builds momentum while dragging and continues moving in
        // the same direction for some time. Feels especially nice on touch
        // devices. Enabled by default.
        inertia: true,
        // @option inertiaDeceleration: Number = 3000
        // The rate with which the inertial movement slows down, in pixels/second².
        inertiaDeceleration: 3400,
        // @option inertiaMaxSpeed: Number = Infinity
        // Max speed of the inertial movement, in pixels/second.
        inertiaMaxSpeed: Infinity,
        // @option easeLinearity: Number = 0.2
        easeLinearity: 0.2,
        // TODO refactor, move to CRS
        // @option worldCopyJump: Boolean = false
        // With this option enabled, the map tracks when you pan to another "copy"
        // of the world and seamlessly jumps to the original one so that all overlays
        // like markers and vector layers are still visible.
        worldCopyJump: false,
        // @option maxBoundsViscosity: Number = 0.0
        // If `maxBounds` is set, this option will control how solid the bounds
        // are when dragging the map around. The default value of `0.0` allows the
        // user to drag outside the bounds at normal speed, higher values will
        // slow down map dragging outside bounds, and `1.0` makes the bounds fully
        // solid, preventing the user from dragging outside the bounds.
        maxBoundsViscosity: 0.0
    });
    var Drag = Handler.extend({
        addHooks: function() {
            if (!this._draggable) {
                var map = this._map;
                this._draggable = new Draggable(map._mapPane, map._container);
                this._draggable.on({
                    dragstart: this._onDragStart,
                    drag: this._onDrag,
                    dragend: this._onDragEnd
                }, this);
                this._draggable.on("predrag", this._onPreDragLimit, this);
                if (map.options.worldCopyJump) {
                    this._draggable.on("predrag", this._onPreDragWrap, this);
                    map.on("zoomend", this._onZoomEnd, this);
                    map.whenReady(this._onZoomEnd, this);
                }
            }
            addClass(this._map._container, "leaflet-grab leaflet-touch-drag");
            this._draggable.enable();
            this._positions = [];
            this._times = [];
        },
        removeHooks: function() {
            removeClass(this._map._container, "leaflet-grab");
            removeClass(this._map._container, "leaflet-touch-drag");
            this._draggable.disable();
        },
        moved: function() {
            return this._draggable && this._draggable._moved;
        },
        moving: function() {
            return this._draggable && this._draggable._moving;
        },
        _onDragStart: function() {
            var map = this._map;
            map._stop();
            if (this._map.options.maxBounds && this._map.options.maxBoundsViscosity) {
                var bounds = toLatLngBounds(this._map.options.maxBounds);
                this._offsetLimit = toBounds(this._map.latLngToContainerPoint(bounds.getNorthWest()).multiplyBy(-1), this._map.latLngToContainerPoint(bounds.getSouthEast()).multiplyBy(-1).add(this._map.getSize()));
                this._viscosity = Math.min(1.0, Math.max(0.0, this._map.options.maxBoundsViscosity));
            } else this._offsetLimit = null;
            map.fire("movestart").fire("dragstart");
            if (map.options.inertia) {
                this._positions = [];
                this._times = [];
            }
        },
        _onDrag: function(e) {
            if (this._map.options.inertia) {
                var time = this._lastTime = +new Date(), pos = this._lastPos = this._draggable._absPos || this._draggable._newPos;
                this._positions.push(pos);
                this._times.push(time);
                this._prunePositions(time);
            }
            this._map.fire("move", e).fire("drag", e);
        },
        _prunePositions: function(time) {
            while(this._positions.length > 1 && time - this._times[0] > 50){
                this._positions.shift();
                this._times.shift();
            }
        },
        _onZoomEnd: function() {
            var pxCenter = this._map.getSize().divideBy(2), pxWorldCenter = this._map.latLngToLayerPoint([
                0,
                0
            ]);
            this._initialWorldOffset = pxWorldCenter.subtract(pxCenter).x;
            this._worldWidth = this._map.getPixelWorldBounds().getSize().x;
        },
        _viscousLimit: function(value, threshold) {
            return value - (value - threshold) * this._viscosity;
        },
        _onPreDragLimit: function() {
            if (!this._viscosity || !this._offsetLimit) return;
            var offset = this._draggable._newPos.subtract(this._draggable._startPos);
            var limit = this._offsetLimit;
            if (offset.x < limit.min.x) offset.x = this._viscousLimit(offset.x, limit.min.x);
            if (offset.y < limit.min.y) offset.y = this._viscousLimit(offset.y, limit.min.y);
            if (offset.x > limit.max.x) offset.x = this._viscousLimit(offset.x, limit.max.x);
            if (offset.y > limit.max.y) offset.y = this._viscousLimit(offset.y, limit.max.y);
            this._draggable._newPos = this._draggable._startPos.add(offset);
        },
        _onPreDragWrap: function() {
            // TODO refactor to be able to adjust map pane position after zoom
            var worldWidth = this._worldWidth, halfWidth = Math.round(worldWidth / 2), dx = this._initialWorldOffset, x = this._draggable._newPos.x, newX1 = (x - halfWidth + dx) % worldWidth + halfWidth - dx, newX2 = (x + halfWidth + dx) % worldWidth - halfWidth - dx, newX = Math.abs(newX1 + dx) < Math.abs(newX2 + dx) ? newX1 : newX2;
            this._draggable._absPos = this._draggable._newPos.clone();
            this._draggable._newPos.x = newX;
        },
        _onDragEnd: function(e) {
            var map = this._map, options = map.options, noInertia = !options.inertia || e.noInertia || this._times.length < 2;
            map.fire("dragend", e);
            if (noInertia) map.fire("moveend");
            else {
                this._prunePositions(+new Date());
                var direction = this._lastPos.subtract(this._positions[0]), duration = (this._lastTime - this._times[0]) / 1000, ease = options.easeLinearity, speedVector = direction.multiplyBy(ease / duration), speed = speedVector.distanceTo([
                    0,
                    0
                ]), limitedSpeed = Math.min(options.inertiaMaxSpeed, speed), limitedSpeedVector = speedVector.multiplyBy(limitedSpeed / speed), decelerationDuration = limitedSpeed / (options.inertiaDeceleration * ease), offset = limitedSpeedVector.multiplyBy(-decelerationDuration / 2).round();
                if (!offset.x && !offset.y) map.fire("moveend");
                else {
                    offset = map._limitOffset(offset, map.options.maxBounds);
                    requestAnimFrame(function() {
                        map.panBy(offset, {
                            duration: decelerationDuration,
                            easeLinearity: ease,
                            noMoveStart: true,
                            animate: true
                        });
                    });
                }
            }
        }
    });
    // @section Handlers
    // @property dragging: Handler
    // Map dragging handler (by both mouse and touch).
    Map.addInitHook("addHandler", "dragging", Drag);
    /*
   * L.Map.Keyboard is handling keyboard interaction with the map, enabled by default.
   */ // @namespace Map
    // @section Keyboard Navigation Options
    Map.mergeOptions({
        // @option keyboard: Boolean = true
        // Makes the map focusable and allows users to navigate the map with keyboard
        // arrows and `+`/`-` keys.
        keyboard: true,
        // @option keyboardPanDelta: Number = 80
        // Amount of pixels to pan when pressing an arrow key.
        keyboardPanDelta: 80
    });
    var Keyboard = Handler.extend({
        keyCodes: {
            left: [
                37
            ],
            right: [
                39
            ],
            down: [
                40
            ],
            up: [
                38
            ],
            zoomIn: [
                187,
                107,
                61,
                171
            ],
            zoomOut: [
                189,
                109,
                54,
                173
            ]
        },
        initialize: function(map) {
            this._map = map;
            this._setPanDelta(map.options.keyboardPanDelta);
            this._setZoomDelta(map.options.zoomDelta);
        },
        addHooks: function() {
            var container = this._map._container;
            // make the container focusable by tabbing
            if (container.tabIndex <= 0) container.tabIndex = "0";
            on(container, {
                focus: this._onFocus,
                blur: this._onBlur,
                mousedown: this._onMouseDown
            }, this);
            this._map.on({
                focus: this._addHooks,
                blur: this._removeHooks
            }, this);
        },
        removeHooks: function() {
            this._removeHooks();
            off(this._map._container, {
                focus: this._onFocus,
                blur: this._onBlur,
                mousedown: this._onMouseDown
            }, this);
            this._map.off({
                focus: this._addHooks,
                blur: this._removeHooks
            }, this);
        },
        _onMouseDown: function() {
            if (this._focused) return;
            var body = document.body, docEl = document.documentElement, top = body.scrollTop || docEl.scrollTop, left = body.scrollLeft || docEl.scrollLeft;
            this._map._container.focus();
            window.scrollTo(left, top);
        },
        _onFocus: function() {
            this._focused = true;
            this._map.fire("focus");
        },
        _onBlur: function() {
            this._focused = false;
            this._map.fire("blur");
        },
        _setPanDelta: function(panDelta) {
            var keys = this._panKeys = {}, codes = this.keyCodes, i, len;
            for(i = 0, len = codes.left.length; i < len; i++)keys[codes.left[i]] = [
                -1 * panDelta,
                0
            ];
            for(i = 0, len = codes.right.length; i < len; i++)keys[codes.right[i]] = [
                panDelta,
                0
            ];
            for(i = 0, len = codes.down.length; i < len; i++)keys[codes.down[i]] = [
                0,
                panDelta
            ];
            for(i = 0, len = codes.up.length; i < len; i++)keys[codes.up[i]] = [
                0,
                -1 * panDelta
            ];
        },
        _setZoomDelta: function(zoomDelta) {
            var keys = this._zoomKeys = {}, codes = this.keyCodes, i, len;
            for(i = 0, len = codes.zoomIn.length; i < len; i++)keys[codes.zoomIn[i]] = zoomDelta;
            for(i = 0, len = codes.zoomOut.length; i < len; i++)keys[codes.zoomOut[i]] = -zoomDelta;
        },
        _addHooks: function() {
            on(document, "keydown", this._onKeyDown, this);
        },
        _removeHooks: function() {
            off(document, "keydown", this._onKeyDown, this);
        },
        _onKeyDown: function(e) {
            if (e.altKey || e.ctrlKey || e.metaKey) return;
            var key = e.keyCode, map = this._map, offset;
            if (key in this._panKeys) {
                if (!map._panAnim || !map._panAnim._inProgress) {
                    offset = this._panKeys[key];
                    if (e.shiftKey) offset = toPoint(offset).multiplyBy(3);
                    if (map.options.maxBounds) offset = map._limitOffset(toPoint(offset), map.options.maxBounds);
                    if (map.options.worldCopyJump) {
                        var newLatLng = map.wrapLatLng(map.unproject(map.project(map.getCenter()).add(offset)));
                        map.panTo(newLatLng);
                    } else map.panBy(offset);
                }
            } else if (key in this._zoomKeys) map.setZoom(map.getZoom() + (e.shiftKey ? 3 : 1) * this._zoomKeys[key]);
            else if (key === 27 && map._popup && map._popup.options.closeOnEscapeKey) map.closePopup();
            else return;
            stop(e);
        }
    });
    // @section Handlers
    // @section Handlers
    // @property keyboard: Handler
    // Keyboard navigation handler.
    Map.addInitHook("addHandler", "keyboard", Keyboard);
    /*
   * L.Handler.ScrollWheelZoom is used by L.Map to enable mouse scroll wheel zoom on the map.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Mouse wheel options
        // @option scrollWheelZoom: Boolean|String = true
        // Whether the map can be zoomed by using the mouse wheel. If passed `'center'`,
        // it will zoom to the center of the view regardless of where the mouse was.
        scrollWheelZoom: true,
        // @option wheelDebounceTime: Number = 40
        // Limits the rate at which a wheel can fire (in milliseconds). By default
        // user can't zoom via wheel more often than once per 40 ms.
        wheelDebounceTime: 40,
        // @option wheelPxPerZoomLevel: Number = 60
        // How many scroll pixels (as reported by [L.DomEvent.getWheelDelta](#domevent-getwheeldelta))
        // mean a change of one full zoom level. Smaller values will make wheel-zooming
        // faster (and vice versa).
        wheelPxPerZoomLevel: 60
    });
    var ScrollWheelZoom = Handler.extend({
        addHooks: function() {
            on(this._map._container, "wheel", this._onWheelScroll, this);
            this._delta = 0;
        },
        removeHooks: function() {
            off(this._map._container, "wheel", this._onWheelScroll, this);
        },
        _onWheelScroll: function(e) {
            var delta = getWheelDelta(e);
            var debounce = this._map.options.wheelDebounceTime;
            this._delta += delta;
            this._lastMousePos = this._map.mouseEventToContainerPoint(e);
            if (!this._startTime) this._startTime = +new Date();
            var left = Math.max(debounce - (+new Date() - this._startTime), 0);
            clearTimeout(this._timer);
            this._timer = setTimeout(bind(this._performZoom, this), left);
            stop(e);
        },
        _performZoom: function() {
            var map = this._map, zoom = map.getZoom(), snap = this._map.options.zoomSnap || 0;
            map._stop(); // stop panning and fly animations if any
            // map the delta with a sigmoid function to -4..4 range leaning on -1..1
            var d2 = this._delta / (this._map.options.wheelPxPerZoomLevel * 4), d3 = 4 * Math.log(2 / (1 + Math.exp(-Math.abs(d2)))) / Math.LN2, d4 = snap ? Math.ceil(d3 / snap) * snap : d3, delta = map._limitZoom(zoom + (this._delta > 0 ? d4 : -d4)) - zoom;
            this._delta = 0;
            this._startTime = null;
            if (!delta) return;
            if (map.options.scrollWheelZoom === "center") map.setZoom(zoom + delta);
            else map.setZoomAround(this._lastMousePos, zoom + delta);
        }
    });
    // @section Handlers
    // @property scrollWheelZoom: Handler
    // Scroll wheel zoom handler.
    Map.addInitHook("addHandler", "scrollWheelZoom", ScrollWheelZoom);
    /*
   * L.Map.TapHold is used to simulate `contextmenu` event on long hold,
   * which otherwise is not fired by mobile Safari.
   */ var tapHoldDelay = 600;
    // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Touch interaction options
        // @option tapHold: Boolean
        // Enables simulation of `contextmenu` event, default is `true` for mobile Safari.
        tapHold: Browser.touchNative && Browser.safari && Browser.mobile,
        // @option tapTolerance: Number = 15
        // The max number of pixels a user can shift his finger during touch
        // for it to be considered a valid tap.
        tapTolerance: 15
    });
    var TapHold = Handler.extend({
        addHooks: function() {
            on(this._map._container, "touchstart", this._onDown, this);
        },
        removeHooks: function() {
            off(this._map._container, "touchstart", this._onDown, this);
        },
        _onDown: function(e) {
            clearTimeout(this._holdTimeout);
            if (e.touches.length !== 1) return;
            var first = e.touches[0];
            this._startPos = this._newPos = new Point(first.clientX, first.clientY);
            this._holdTimeout = setTimeout(bind(function() {
                this._cancel();
                if (!this._isTapValid()) return;
                // prevent simulated mouse events https://w3c.github.io/touch-events/#mouse-events
                on(document, "touchend", preventDefault);
                on(document, "touchend touchcancel", this._cancelClickPrevent);
                this._simulateEvent("contextmenu", first);
            }, this), tapHoldDelay);
            on(document, "touchend touchcancel contextmenu", this._cancel, this);
            on(document, "touchmove", this._onMove, this);
        },
        _cancelClickPrevent: function cancelClickPrevent() {
            off(document, "touchend", preventDefault);
            off(document, "touchend touchcancel", cancelClickPrevent);
        },
        _cancel: function() {
            clearTimeout(this._holdTimeout);
            off(document, "touchend touchcancel contextmenu", this._cancel, this);
            off(document, "touchmove", this._onMove, this);
        },
        _onMove: function(e) {
            var first = e.touches[0];
            this._newPos = new Point(first.clientX, first.clientY);
        },
        _isTapValid: function() {
            return this._newPos.distanceTo(this._startPos) <= this._map.options.tapTolerance;
        },
        _simulateEvent: function(type, e) {
            var simulatedEvent = new MouseEvent(type, {
                bubbles: true,
                cancelable: true,
                view: window,
                // detail: 1,
                screenX: e.screenX,
                screenY: e.screenY,
                clientX: e.clientX,
                clientY: e.clientY
            });
            simulatedEvent._simulated = true;
            e.target.dispatchEvent(simulatedEvent);
        }
    });
    // @section Handlers
    // @property tapHold: Handler
    // Long tap handler to simulate `contextmenu` event (useful in mobile Safari).
    Map.addInitHook("addHandler", "tapHold", TapHold);
    /*
   * L.Handler.TouchZoom is used by L.Map to add pinch zoom on supported mobile browsers.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Touch interaction options
        // @option touchZoom: Boolean|String = *
        // Whether the map can be zoomed by touch-dragging with two fingers. If
        // passed `'center'`, it will zoom to the center of the view regardless of
        // where the touch events (fingers) were. Enabled for touch-capable web
        // browsers.
        touchZoom: Browser.touch,
        // @option bounceAtZoomLimits: Boolean = true
        // Set it to false if you don't want the map to zoom beyond min/max zoom
        // and then bounce back when pinch-zooming.
        bounceAtZoomLimits: true
    });
    var TouchZoom = Handler.extend({
        addHooks: function() {
            addClass(this._map._container, "leaflet-touch-zoom");
            on(this._map._container, "touchstart", this._onTouchStart, this);
        },
        removeHooks: function() {
            removeClass(this._map._container, "leaflet-touch-zoom");
            off(this._map._container, "touchstart", this._onTouchStart, this);
        },
        _onTouchStart: function(e) {
            var map = this._map;
            if (!e.touches || e.touches.length !== 2 || map._animatingZoom || this._zooming) return;
            var p1 = map.mouseEventToContainerPoint(e.touches[0]), p2 = map.mouseEventToContainerPoint(e.touches[1]);
            this._centerPoint = map.getSize()._divideBy(2);
            this._startLatLng = map.containerPointToLatLng(this._centerPoint);
            if (map.options.touchZoom !== "center") this._pinchStartLatLng = map.containerPointToLatLng(p1.add(p2)._divideBy(2));
            this._startDist = p1.distanceTo(p2);
            this._startZoom = map.getZoom();
            this._moved = false;
            this._zooming = true;
            map._stop();
            on(document, "touchmove", this._onTouchMove, this);
            on(document, "touchend touchcancel", this._onTouchEnd, this);
            preventDefault(e);
        },
        _onTouchMove: function(e) {
            if (!e.touches || e.touches.length !== 2 || !this._zooming) return;
            var map = this._map, p1 = map.mouseEventToContainerPoint(e.touches[0]), p2 = map.mouseEventToContainerPoint(e.touches[1]), scale = p1.distanceTo(p2) / this._startDist;
            this._zoom = map.getScaleZoom(scale, this._startZoom);
            if (!map.options.bounceAtZoomLimits && (this._zoom < map.getMinZoom() && scale < 1 || this._zoom > map.getMaxZoom() && scale > 1)) this._zoom = map._limitZoom(this._zoom);
            if (map.options.touchZoom === "center") {
                this._center = this._startLatLng;
                if (scale === 1) return;
            } else {
                // Get delta from pinch to center, so centerLatLng is delta applied to initial pinchLatLng
                var delta = p1._add(p2)._divideBy(2)._subtract(this._centerPoint);
                if (scale === 1 && delta.x === 0 && delta.y === 0) return;
                this._center = map.unproject(map.project(this._pinchStartLatLng, this._zoom).subtract(delta), this._zoom);
            }
            if (!this._moved) {
                map._moveStart(true, false);
                this._moved = true;
            }
            cancelAnimFrame(this._animRequest);
            var moveFn = bind(map._move, map, this._center, this._zoom, {
                pinch: true,
                round: false
            }, undefined);
            this._animRequest = requestAnimFrame(moveFn, this, true);
            preventDefault(e);
        },
        _onTouchEnd: function() {
            if (!this._moved || !this._zooming) {
                this._zooming = false;
                return;
            }
            this._zooming = false;
            cancelAnimFrame(this._animRequest);
            off(document, "touchmove", this._onTouchMove, this);
            off(document, "touchend touchcancel", this._onTouchEnd, this);
            // Pinch updates GridLayers' levels only when zoomSnap is off, so zoomSnap becomes noUpdate.
            if (this._map.options.zoomAnimation) this._map._animateZoom(this._center, this._map._limitZoom(this._zoom), true, this._map.options.zoomSnap);
            else this._map._resetView(this._center, this._map._limitZoom(this._zoom));
        }
    });
    // @section Handlers
    // @property touchZoom: Handler
    // Touch zoom handler.
    Map.addInitHook("addHandler", "touchZoom", TouchZoom);
    Map.BoxZoom = BoxZoom;
    Map.DoubleClickZoom = DoubleClickZoom;
    Map.Drag = Drag;
    Map.Keyboard = Keyboard;
    Map.ScrollWheelZoom = ScrollWheelZoom;
    Map.TapHold = TapHold;
    Map.TouchZoom = TouchZoom;
    exports1.Bounds = Bounds;
    exports1.Browser = Browser;
    exports1.CRS = CRS;
    exports1.Canvas = Canvas;
    exports1.Circle = Circle;
    exports1.CircleMarker = CircleMarker;
    exports1.Class = Class;
    exports1.Control = Control;
    exports1.DivIcon = DivIcon;
    exports1.DivOverlay = DivOverlay;
    exports1.DomEvent = DomEvent;
    exports1.DomUtil = DomUtil;
    exports1.Draggable = Draggable;
    exports1.Evented = Evented;
    exports1.FeatureGroup = FeatureGroup;
    exports1.GeoJSON = GeoJSON;
    exports1.GridLayer = GridLayer;
    exports1.Handler = Handler;
    exports1.Icon = Icon;
    exports1.ImageOverlay = ImageOverlay;
    exports1.LatLng = LatLng;
    exports1.LatLngBounds = LatLngBounds;
    exports1.Layer = Layer;
    exports1.LayerGroup = LayerGroup;
    exports1.LineUtil = LineUtil;
    exports1.Map = Map;
    exports1.Marker = Marker;
    exports1.Mixin = Mixin;
    exports1.Path = Path;
    exports1.Point = Point;
    exports1.PolyUtil = PolyUtil;
    exports1.Polygon = Polygon;
    exports1.Polyline = Polyline;
    exports1.Popup = Popup;
    exports1.PosAnimation = PosAnimation;
    exports1.Projection = index;
    exports1.Rectangle = Rectangle;
    exports1.Renderer = Renderer;
    exports1.SVG = SVG;
    exports1.SVGOverlay = SVGOverlay;
    exports1.TileLayer = TileLayer;
    exports1.Tooltip = Tooltip;
    exports1.Transformation = Transformation;
    exports1.Util = Util;
    exports1.VideoOverlay = VideoOverlay;
    exports1.bind = bind;
    exports1.bounds = toBounds;
    exports1.canvas = canvas;
    exports1.circle = circle;
    exports1.circleMarker = circleMarker;
    exports1.control = control;
    exports1.divIcon = divIcon;
    exports1.extend = extend;
    exports1.featureGroup = featureGroup;
    exports1.geoJSON = geoJSON;
    exports1.geoJson = geoJson;
    exports1.gridLayer = gridLayer;
    exports1.icon = icon;
    exports1.imageOverlay = imageOverlay;
    exports1.latLng = toLatLng;
    exports1.latLngBounds = toLatLngBounds;
    exports1.layerGroup = layerGroup;
    exports1.map = createMap;
    exports1.marker = marker;
    exports1.point = toPoint;
    exports1.polygon = polygon;
    exports1.polyline = polyline;
    exports1.popup = popup;
    exports1.rectangle = rectangle;
    exports1.setOptions = setOptions;
    exports1.stamp = stamp;
    exports1.svg = svg;
    exports1.svgOverlay = svgOverlay;
    exports1.tileLayer = tileLayer;
    exports1.tooltip = tooltip;
    exports1.transformation = toTransformation;
    exports1.version = version;
    exports1.videoOverlay = videoOverlay;
    var oldL = window.L;
    exports1.noConflict = function() {
        window.L = oldL;
        return this;
    };
    // Always export us to window global (see #2364)
    window.L = exports1;
});


var $27bb4197cb03d819$exports = {};
/*
 * Leaflet.markercluster 1.5.3+master.e5124b2,
 * Provides Beautiful Animated Marker Clustering functionality for Leaflet, a JS library for interactive maps.
 * https://github.com/Leaflet/Leaflet.markercluster
 * (c) 2012-2017, Dave Leaver, smartrak
 */ (function(global, factory) {
    factory($27bb4197cb03d819$exports);
})($27bb4197cb03d819$exports, function(exports1) {
    "use strict";
    /*
	 * L.MarkerClusterGroup extends L.FeatureGroup by clustering the markers contained within
	 */ var MarkerClusterGroup = L.MarkerClusterGroup = L.FeatureGroup.extend({
        options: {
            maxClusterRadius: 80,
            iconCreateFunction: null,
            clusterPane: L.Marker.prototype.options.pane,
            spiderfyOnEveryZoom: false,
            spiderfyOnMaxZoom: true,
            showCoverageOnHover: true,
            zoomToBoundsOnClick: true,
            singleMarkerMode: false,
            disableClusteringAtZoom: null,
            // Setting this to false prevents the removal of any clusters outside of the viewpoint, which
            // is the default behaviour for performance reasons.
            removeOutsideVisibleBounds: true,
            // Set to false to disable all animations (zoom and spiderfy).
            // If false, option animateAddingMarkers below has no effect.
            // If L.DomUtil.TRANSITION is falsy, this option has no effect.
            animate: true,
            //Whether to animate adding markers after adding the MarkerClusterGroup to the map
            // If you are adding individual markers set to true, if adding bulk markers leave false for massive performance gains.
            animateAddingMarkers: false,
            // Make it possible to provide custom function to calculate spiderfy shape positions
            spiderfyShapePositions: null,
            //Increase to increase the distance away that spiderfied markers appear from the center
            spiderfyDistanceMultiplier: 1,
            // Make it possible to specify a polyline options on a spider leg
            spiderLegPolylineOptions: {
                weight: 1.5,
                color: "#222",
                opacity: 0.5
            },
            // When bulk adding layers, adds markers in chunks. Means addLayers may not add all the layers in the call, others will be loaded during setTimeouts
            chunkedLoading: false,
            chunkInterval: 200,
            chunkDelay: 50,
            chunkProgress: null,
            //Options to pass to the L.Polygon constructor
            polygonOptions: {}
        },
        initialize: function(options) {
            L.Util.setOptions(this, options);
            if (!this.options.iconCreateFunction) this.options.iconCreateFunction = this._defaultIconCreateFunction;
            this._featureGroup = L.featureGroup();
            this._featureGroup.addEventParent(this);
            this._nonPointGroup = L.featureGroup();
            this._nonPointGroup.addEventParent(this);
            this._inZoomAnimation = 0;
            this._needsClustering = [];
            this._needsRemoving = []; //Markers removed while we aren't on the map need to be kept track of
            //The bounds of the currently shown area (from _getExpandedVisibleBounds) Updated on zoom/move
            this._currentShownBounds = null;
            this._queue = [];
            this._childMarkerEventHandlers = {
                "dragstart": this._childMarkerDragStart,
                "move": this._childMarkerMoved,
                "dragend": this._childMarkerDragEnd
            };
            // Hook the appropriate animation methods.
            var animate = L.DomUtil.TRANSITION && this.options.animate;
            L.extend(this, animate ? this._withAnimation : this._noAnimation);
            // Remember which MarkerCluster class to instantiate (animated or not).
            this._markerCluster = animate ? L.MarkerCluster : L.MarkerClusterNonAnimated;
        },
        addLayer: function(layer) {
            if (layer instanceof L.LayerGroup) return this.addLayers([
                layer
            ]);
            //Don't cluster non point data
            if (!layer.getLatLng) {
                this._nonPointGroup.addLayer(layer);
                this.fire("layeradd", {
                    layer: layer
                });
                return this;
            }
            if (!this._map) {
                this._needsClustering.push(layer);
                this.fire("layeradd", {
                    layer: layer
                });
                return this;
            }
            if (this.hasLayer(layer)) return this;
            //If we have already clustered we'll need to add this one to a cluster
            if (this._unspiderfy) this._unspiderfy();
            this._addLayer(layer, this._maxZoom);
            this.fire("layeradd", {
                layer: layer
            });
            // Refresh bounds and weighted positions.
            this._topClusterLevel._recalculateBounds();
            this._refreshClustersIcons();
            //Work out what is visible
            var visibleLayer = layer, currentZoom = this._zoom;
            if (layer.__parent) while(visibleLayer.__parent._zoom >= currentZoom)visibleLayer = visibleLayer.__parent;
            if (this._currentShownBounds.contains(visibleLayer.getLatLng())) {
                if (this.options.animateAddingMarkers) this._animationAddLayer(layer, visibleLayer);
                else this._animationAddLayerNonAnimated(layer, visibleLayer);
            }
            return this;
        },
        removeLayer: function(layer) {
            if (layer instanceof L.LayerGroup) return this.removeLayers([
                layer
            ]);
            //Non point layers
            if (!layer.getLatLng) {
                this._nonPointGroup.removeLayer(layer);
                this.fire("layerremove", {
                    layer: layer
                });
                return this;
            }
            if (!this._map) {
                if (!this._arraySplice(this._needsClustering, layer) && this.hasLayer(layer)) this._needsRemoving.push({
                    layer: layer,
                    latlng: layer._latlng
                });
                this.fire("layerremove", {
                    layer: layer
                });
                return this;
            }
            if (!layer.__parent) return this;
            if (this._unspiderfy) {
                this._unspiderfy();
                this._unspiderfyLayer(layer);
            }
            //Remove the marker from clusters
            this._removeLayer(layer, true);
            this.fire("layerremove", {
                layer: layer
            });
            // Refresh bounds and weighted positions.
            this._topClusterLevel._recalculateBounds();
            this._refreshClustersIcons();
            layer.off(this._childMarkerEventHandlers, this);
            if (this._featureGroup.hasLayer(layer)) {
                this._featureGroup.removeLayer(layer);
                if (layer.clusterShow) layer.clusterShow();
            }
            return this;
        },
        //Takes an array of markers and adds them in bulk
        addLayers: function(layersArray, skipLayerAddEvent) {
            if (!L.Util.isArray(layersArray)) return this.addLayer(layersArray);
            var fg = this._featureGroup, npg = this._nonPointGroup, chunked = this.options.chunkedLoading, chunkInterval = this.options.chunkInterval, chunkProgress = this.options.chunkProgress, l = layersArray.length, offset = 0, originalArray = true, m;
            if (this._map) {
                var started = new Date().getTime();
                var process = L.bind(function() {
                    var start = new Date().getTime();
                    // Make sure to unspiderfy before starting to add some layers
                    if (this._map && this._unspiderfy) this._unspiderfy();
                    for(; offset < l; offset++){
                        if (chunked && offset % 200 === 0) {
                            // every couple hundred markers, instrument the time elapsed since processing started:
                            var elapsed = new Date().getTime() - start;
                            if (elapsed > chunkInterval) break; // been working too hard, time to take a break :-)
                        }
                        m = layersArray[offset];
                        // Group of layers, append children to layersArray and skip.
                        // Side effects:
                        // - Total increases, so chunkProgress ratio jumps backward.
                        // - Groups are not included in this group, only their non-group child layers (hasLayer).
                        // Changing array length while looping does not affect performance in current browsers:
                        // http://jsperf.com/for-loop-changing-length/6
                        if (m instanceof L.LayerGroup) {
                            if (originalArray) {
                                layersArray = layersArray.slice();
                                originalArray = false;
                            }
                            this._extractNonGroupLayers(m, layersArray);
                            l = layersArray.length;
                            continue;
                        }
                        //Not point data, can't be clustered
                        if (!m.getLatLng) {
                            npg.addLayer(m);
                            if (!skipLayerAddEvent) this.fire("layeradd", {
                                layer: m
                            });
                            continue;
                        }
                        if (this.hasLayer(m)) continue;
                        this._addLayer(m, this._maxZoom);
                        if (!skipLayerAddEvent) this.fire("layeradd", {
                            layer: m
                        });
                        //If we just made a cluster of size 2 then we need to remove the other marker from the map (if it is) or we never will
                        if (m.__parent) {
                            if (m.__parent.getChildCount() === 2) {
                                var markers = m.__parent.getAllChildMarkers(), otherMarker = markers[0] === m ? markers[1] : markers[0];
                                fg.removeLayer(otherMarker);
                            }
                        }
                    }
                    if (chunkProgress) // report progress and time elapsed:
                    chunkProgress(offset, l, new Date().getTime() - started);
                    // Completed processing all markers.
                    if (offset === l) {
                        // Refresh bounds and weighted positions.
                        this._topClusterLevel._recalculateBounds();
                        this._refreshClustersIcons();
                        this._topClusterLevel._recursivelyAddChildrenToMap(null, this._zoom, this._currentShownBounds);
                    } else setTimeout(process, this.options.chunkDelay);
                }, this);
                process();
            } else {
                var needsClustering = this._needsClustering;
                for(; offset < l; offset++){
                    m = layersArray[offset];
                    // Group of layers, append children to layersArray and skip.
                    if (m instanceof L.LayerGroup) {
                        if (originalArray) {
                            layersArray = layersArray.slice();
                            originalArray = false;
                        }
                        this._extractNonGroupLayers(m, layersArray);
                        l = layersArray.length;
                        continue;
                    }
                    //Not point data, can't be clustered
                    if (!m.getLatLng) {
                        npg.addLayer(m);
                        continue;
                    }
                    if (this.hasLayer(m)) continue;
                    needsClustering.push(m);
                }
            }
            return this;
        },
        //Takes an array of markers and removes them in bulk
        removeLayers: function(layersArray) {
            var i, m, l = layersArray.length, fg = this._featureGroup, npg = this._nonPointGroup, originalArray = true;
            if (!this._map) {
                for(i = 0; i < l; i++){
                    m = layersArray[i];
                    // Group of layers, append children to layersArray and skip.
                    if (m instanceof L.LayerGroup) {
                        if (originalArray) {
                            layersArray = layersArray.slice();
                            originalArray = false;
                        }
                        this._extractNonGroupLayers(m, layersArray);
                        l = layersArray.length;
                        continue;
                    }
                    this._arraySplice(this._needsClustering, m);
                    npg.removeLayer(m);
                    if (this.hasLayer(m)) this._needsRemoving.push({
                        layer: m,
                        latlng: m._latlng
                    });
                    this.fire("layerremove", {
                        layer: m
                    });
                }
                return this;
            }
            if (this._unspiderfy) {
                this._unspiderfy();
                // Work on a copy of the array, so that next loop is not affected.
                var layersArray2 = layersArray.slice(), l2 = l;
                for(i = 0; i < l2; i++){
                    m = layersArray2[i];
                    // Group of layers, append children to layersArray and skip.
                    if (m instanceof L.LayerGroup) {
                        this._extractNonGroupLayers(m, layersArray2);
                        l2 = layersArray2.length;
                        continue;
                    }
                    this._unspiderfyLayer(m);
                }
            }
            for(i = 0; i < l; i++){
                m = layersArray[i];
                // Group of layers, append children to layersArray and skip.
                if (m instanceof L.LayerGroup) {
                    if (originalArray) {
                        layersArray = layersArray.slice();
                        originalArray = false;
                    }
                    this._extractNonGroupLayers(m, layersArray);
                    l = layersArray.length;
                    continue;
                }
                if (!m.__parent) {
                    npg.removeLayer(m);
                    this.fire("layerremove", {
                        layer: m
                    });
                    continue;
                }
                this._removeLayer(m, true, true);
                this.fire("layerremove", {
                    layer: m
                });
                if (fg.hasLayer(m)) {
                    fg.removeLayer(m);
                    if (m.clusterShow) m.clusterShow();
                }
            }
            // Refresh bounds and weighted positions.
            this._topClusterLevel._recalculateBounds();
            this._refreshClustersIcons();
            //Fix up the clusters and markers on the map
            this._topClusterLevel._recursivelyAddChildrenToMap(null, this._zoom, this._currentShownBounds);
            return this;
        },
        //Removes all layers from the MarkerClusterGroup
        clearLayers: function() {
            //Need our own special implementation as the LayerGroup one doesn't work for us
            //If we aren't on the map (yet), blow away the markers we know of
            if (!this._map) {
                this._needsClustering = [];
                this._needsRemoving = [];
                delete this._gridClusters;
                delete this._gridUnclustered;
            }
            if (this._noanimationUnspiderfy) this._noanimationUnspiderfy();
            //Remove all the visible layers
            this._featureGroup.clearLayers();
            this._nonPointGroup.clearLayers();
            this.eachLayer(function(marker) {
                marker.off(this._childMarkerEventHandlers, this);
                delete marker.__parent;
            }, this);
            if (this._map) //Reset _topClusterLevel and the DistanceGrids
            this._generateInitialClusters();
            return this;
        },
        //Override FeatureGroup.getBounds as it doesn't work
        getBounds: function() {
            var bounds = new L.LatLngBounds();
            if (this._topClusterLevel) bounds.extend(this._topClusterLevel._bounds);
            for(var i = this._needsClustering.length - 1; i >= 0; i--)bounds.extend(this._needsClustering[i].getLatLng());
            bounds.extend(this._nonPointGroup.getBounds());
            return bounds;
        },
        //Overrides LayerGroup.eachLayer
        eachLayer: function(method, context) {
            var markers = this._needsClustering.slice(), needsRemoving = this._needsRemoving, thisNeedsRemoving, i, j;
            if (this._topClusterLevel) this._topClusterLevel.getAllChildMarkers(markers);
            for(i = markers.length - 1; i >= 0; i--){
                thisNeedsRemoving = true;
                for(j = needsRemoving.length - 1; j >= 0; j--)if (needsRemoving[j].layer === markers[i]) {
                    thisNeedsRemoving = false;
                    break;
                }
                if (thisNeedsRemoving) method.call(context, markers[i]);
            }
            this._nonPointGroup.eachLayer(method, context);
        },
        //Overrides LayerGroup.getLayers
        getLayers: function() {
            var layers = [];
            this.eachLayer(function(l) {
                layers.push(l);
            });
            return layers;
        },
        //Overrides LayerGroup.getLayer, WARNING: Really bad performance
        getLayer: function(id) {
            var result = null;
            id = parseInt(id, 10);
            this.eachLayer(function(l) {
                if (L.stamp(l) === id) result = l;
            });
            return result;
        },
        //Returns true if the given layer is in this MarkerClusterGroup
        hasLayer: function(layer) {
            if (!layer) return false;
            var i, anArray = this._needsClustering;
            for(i = anArray.length - 1; i >= 0; i--){
                if (anArray[i] === layer) return true;
            }
            anArray = this._needsRemoving;
            for(i = anArray.length - 1; i >= 0; i--){
                if (anArray[i].layer === layer) return false;
            }
            return !!(layer.__parent && layer.__parent._group === this) || this._nonPointGroup.hasLayer(layer);
        },
        //Zoom down to show the given layer (spiderfying if necessary) then calls the callback
        zoomToShowLayer: function(layer, callback) {
            var map = this._map;
            if (typeof callback !== "function") callback = function() {};
            var showMarker = function() {
                // Assumes that map.hasLayer checks for direct appearance on map, not recursively calling
                // hasLayer on Layer Groups that are on map (typically not calling this MarkerClusterGroup.hasLayer, which would always return true)
                if ((map.hasLayer(layer) || map.hasLayer(layer.__parent)) && !this._inZoomAnimation) {
                    this._map.off("moveend", showMarker, this);
                    this.off("animationend", showMarker, this);
                    if (map.hasLayer(layer)) callback();
                    else if (layer.__parent._icon) {
                        this.once("spiderfied", callback, this);
                        layer.__parent.spiderfy();
                    }
                }
            };
            if (layer._icon && this._map.getBounds().contains(layer.getLatLng())) //Layer is visible ond on screen, immediate return
            callback();
            else if (layer.__parent._zoom < Math.round(this._map._zoom)) {
                //Layer should be visible at this zoom level. It must not be on screen so just pan over to it
                this._map.on("moveend", showMarker, this);
                this._map.panTo(layer.getLatLng());
            } else {
                this._map.on("moveend", showMarker, this);
                this.on("animationend", showMarker, this);
                layer.__parent.zoomToBounds();
            }
        },
        //Overrides FeatureGroup.onAdd
        onAdd: function(map) {
            this._map = map;
            var i, l, layer;
            if (!isFinite(this._map.getMaxZoom())) throw "Map has no maxZoom specified";
            this._featureGroup.addTo(map);
            this._nonPointGroup.addTo(map);
            if (!this._gridClusters) this._generateInitialClusters();
            this._maxLat = map.options.crs.projection.MAX_LATITUDE;
            //Restore all the positions as they are in the MCG before removing them
            for(i = 0, l = this._needsRemoving.length; i < l; i++){
                layer = this._needsRemoving[i];
                layer.newlatlng = layer.layer._latlng;
                layer.layer._latlng = layer.latlng;
            }
            //Remove them, then restore their new positions
            for(i = 0, l = this._needsRemoving.length; i < l; i++){
                layer = this._needsRemoving[i];
                this._removeLayer(layer.layer, true);
                layer.layer._latlng = layer.newlatlng;
            }
            this._needsRemoving = [];
            //Remember the current zoom level and bounds
            this._zoom = Math.round(this._map._zoom);
            this._currentShownBounds = this._getExpandedVisibleBounds();
            this._map.on("zoomend", this._zoomEnd, this);
            this._map.on("moveend", this._moveEnd, this);
            if (this._spiderfierOnAdd) this._spiderfierOnAdd();
            this._bindEvents();
            //Actually add our markers to the map:
            l = this._needsClustering;
            this._needsClustering = [];
            this.addLayers(l, true);
        },
        //Overrides FeatureGroup.onRemove
        onRemove: function(map) {
            map.off("zoomend", this._zoomEnd, this);
            map.off("moveend", this._moveEnd, this);
            this._unbindEvents();
            //In case we are in a cluster animation
            this._map._mapPane.className = this._map._mapPane.className.replace(" leaflet-cluster-anim", "");
            if (this._spiderfierOnRemove) this._spiderfierOnRemove();
            delete this._maxLat;
            //Clean up all the layers we added to the map
            this._hideCoverage();
            this._featureGroup.remove();
            this._nonPointGroup.remove();
            this._featureGroup.clearLayers();
            this._map = null;
        },
        getVisibleParent: function(marker) {
            var vMarker = marker;
            while(vMarker && !vMarker._icon)vMarker = vMarker.__parent;
            return vMarker || null;
        },
        //Remove the given object from the given array
        _arraySplice: function(anArray, obj) {
            for(var i = anArray.length - 1; i >= 0; i--)if (anArray[i] === obj) {
                anArray.splice(i, 1);
                return true;
            }
        },
        /**
		 * Removes a marker from all _gridUnclustered zoom levels, starting at the supplied zoom.
		 * @param marker to be removed from _gridUnclustered.
		 * @param z integer bottom start zoom level (included)
		 * @private
		 */ _removeFromGridUnclustered: function(marker, z) {
            var map = this._map, gridUnclustered = this._gridUnclustered, minZoom = Math.floor(this._map.getMinZoom());
            for(; z >= minZoom; z--){
                if (!gridUnclustered[z].removeObject(marker, map.project(marker.getLatLng(), z))) break;
            }
        },
        _childMarkerDragStart: function(e) {
            e.target.__dragStart = e.target._latlng;
        },
        _childMarkerMoved: function(e) {
            if (!this._ignoreMove && !e.target.__dragStart) {
                var isPopupOpen = e.target._popup && e.target._popup.isOpen();
                this._moveChild(e.target, e.oldLatLng, e.latlng);
                if (isPopupOpen) e.target.openPopup();
            }
        },
        _moveChild: function(layer, from, to) {
            layer._latlng = from;
            this.removeLayer(layer);
            layer._latlng = to;
            this.addLayer(layer);
        },
        _childMarkerDragEnd: function(e) {
            var dragStart = e.target.__dragStart;
            delete e.target.__dragStart;
            if (dragStart) this._moveChild(e.target, dragStart, e.target._latlng);
        },
        //Internal function for removing a marker from everything.
        //dontUpdateMap: set to true if you will handle updating the map manually (for bulk functions)
        _removeLayer: function(marker, removeFromDistanceGrid, dontUpdateMap) {
            var gridClusters = this._gridClusters, gridUnclustered = this._gridUnclustered, fg = this._featureGroup, map = this._map, minZoom = Math.floor(this._map.getMinZoom());
            //Remove the marker from distance clusters it might be in
            if (removeFromDistanceGrid) this._removeFromGridUnclustered(marker, this._maxZoom);
            //Work our way up the clusters removing them as we go if required
            var cluster = marker.__parent, markers = cluster._markers, otherMarker;
            //Remove the marker from the immediate parents marker list
            this._arraySplice(markers, marker);
            while(cluster){
                cluster._childCount--;
                cluster._boundsNeedUpdate = true;
                if (cluster._zoom < minZoom) break;
                else if (removeFromDistanceGrid && cluster._childCount <= 1) {
                    //We need to push the other marker up to the parent
                    otherMarker = cluster._markers[0] === marker ? cluster._markers[1] : cluster._markers[0];
                    //Update distance grid
                    gridClusters[cluster._zoom].removeObject(cluster, map.project(cluster._cLatLng, cluster._zoom));
                    gridUnclustered[cluster._zoom].addObject(otherMarker, map.project(otherMarker.getLatLng(), cluster._zoom));
                    //Move otherMarker up to parent
                    this._arraySplice(cluster.__parent._childClusters, cluster);
                    cluster.__parent._markers.push(otherMarker);
                    otherMarker.__parent = cluster.__parent;
                    if (cluster._icon) {
                        //Cluster is currently on the map, need to put the marker on the map instead
                        fg.removeLayer(cluster);
                        if (!dontUpdateMap) fg.addLayer(otherMarker);
                    }
                } else cluster._iconNeedsUpdate = true;
                cluster = cluster.__parent;
            }
            delete marker.__parent;
        },
        _isOrIsParent: function(el, oel) {
            while(oel){
                if (el === oel) return true;
                oel = oel.parentNode;
            }
            return false;
        },
        //Override L.Evented.fire
        fire: function(type, data, propagate) {
            if (data && data.layer instanceof L.MarkerCluster) {
                //Prevent multiple clustermouseover/off events if the icon is made up of stacked divs (Doesn't work in ie <= 8, no relatedTarget)
                if (data.originalEvent && this._isOrIsParent(data.layer._icon, data.originalEvent.relatedTarget)) return;
                type = "cluster" + type;
            }
            L.FeatureGroup.prototype.fire.call(this, type, data, propagate);
        },
        //Override L.Evented.listens
        listens: function(type, propagate) {
            return L.FeatureGroup.prototype.listens.call(this, type, propagate) || L.FeatureGroup.prototype.listens.call(this, "cluster" + type, propagate);
        },
        //Default functionality
        _defaultIconCreateFunction: function(cluster) {
            var childCount = cluster.getChildCount();
            var c = " marker-cluster-";
            if (childCount < 10) c += "small";
            else if (childCount < 100) c += "medium";
            else c += "large";
            return new L.DivIcon({
                html: "<div><span>" + childCount + "</span></div>",
                className: "marker-cluster" + c,
                iconSize: new L.Point(40, 40)
            });
        },
        _bindEvents: function() {
            var map = this._map, spiderfyOnMaxZoom = this.options.spiderfyOnMaxZoom, showCoverageOnHover = this.options.showCoverageOnHover, zoomToBoundsOnClick = this.options.zoomToBoundsOnClick, spiderfyOnEveryZoom = this.options.spiderfyOnEveryZoom;
            //Zoom on cluster click or spiderfy if we are at the lowest level
            if (spiderfyOnMaxZoom || zoomToBoundsOnClick || spiderfyOnEveryZoom) this.on("clusterclick clusterkeypress", this._zoomOrSpiderfy, this);
            //Show convex hull (boundary) polygon on mouse over
            if (showCoverageOnHover) {
                this.on("clustermouseover", this._showCoverage, this);
                this.on("clustermouseout", this._hideCoverage, this);
                map.on("zoomend", this._hideCoverage, this);
            }
        },
        _zoomOrSpiderfy: function(e) {
            var cluster = e.layer, bottomCluster = cluster;
            if (e.type === "clusterkeypress" && e.originalEvent && e.originalEvent.keyCode !== 13) return;
            while(bottomCluster._childClusters.length === 1)bottomCluster = bottomCluster._childClusters[0];
            if (bottomCluster._zoom === this._maxZoom && bottomCluster._childCount === cluster._childCount && this.options.spiderfyOnMaxZoom) // All child markers are contained in a single cluster from this._maxZoom to this cluster.
            cluster.spiderfy();
            else if (this.options.zoomToBoundsOnClick) cluster.zoomToBounds();
            if (this.options.spiderfyOnEveryZoom) cluster.spiderfy();
            // Focus the map again for keyboard users.
            if (e.originalEvent && e.originalEvent.keyCode === 13) this._map._container.focus();
        },
        _showCoverage: function(e) {
            var map = this._map;
            if (this._inZoomAnimation) return;
            if (this._shownPolygon) map.removeLayer(this._shownPolygon);
            if (e.layer.getChildCount() > 2 && e.layer !== this._spiderfied) {
                this._shownPolygon = new L.Polygon(e.layer.getConvexHull(), this.options.polygonOptions);
                map.addLayer(this._shownPolygon);
            }
        },
        _hideCoverage: function() {
            if (this._shownPolygon) {
                this._map.removeLayer(this._shownPolygon);
                this._shownPolygon = null;
            }
        },
        _unbindEvents: function() {
            var spiderfyOnMaxZoom = this.options.spiderfyOnMaxZoom, showCoverageOnHover = this.options.showCoverageOnHover, zoomToBoundsOnClick = this.options.zoomToBoundsOnClick, spiderfyOnEveryZoom = this.options.spiderfyOnEveryZoom, map = this._map;
            if (spiderfyOnMaxZoom || zoomToBoundsOnClick || spiderfyOnEveryZoom) this.off("clusterclick clusterkeypress", this._zoomOrSpiderfy, this);
            if (showCoverageOnHover) {
                this.off("clustermouseover", this._showCoverage, this);
                this.off("clustermouseout", this._hideCoverage, this);
                map.off("zoomend", this._hideCoverage, this);
            }
        },
        _zoomEnd: function() {
            if (!this._map) return;
            this._mergeSplitClusters();
            this._zoom = Math.round(this._map._zoom);
            this._currentShownBounds = this._getExpandedVisibleBounds();
        },
        _moveEnd: function() {
            if (this._inZoomAnimation) return;
            var newBounds = this._getExpandedVisibleBounds();
            this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds, Math.floor(this._map.getMinZoom()), this._zoom, newBounds);
            this._topClusterLevel._recursivelyAddChildrenToMap(null, Math.round(this._map._zoom), newBounds);
            this._currentShownBounds = newBounds;
            return;
        },
        _generateInitialClusters: function() {
            var maxZoom = Math.ceil(this._map.getMaxZoom()), minZoom = Math.floor(this._map.getMinZoom()), radius = this.options.maxClusterRadius, radiusFn = radius;
            //If we just set maxClusterRadius to a single number, we need to create
            //a simple function to return that number. Otherwise, we just have to
            //use the function we've passed in.
            if (typeof radius !== "function") radiusFn = function() {
                return radius;
            };
            if (this.options.disableClusteringAtZoom !== null) maxZoom = this.options.disableClusteringAtZoom - 1;
            this._maxZoom = maxZoom;
            this._gridClusters = {};
            this._gridUnclustered = {};
            //Set up DistanceGrids for each zoom
            for(var zoom = maxZoom; zoom >= minZoom; zoom--){
                this._gridClusters[zoom] = new L.DistanceGrid(radiusFn(zoom));
                this._gridUnclustered[zoom] = new L.DistanceGrid(radiusFn(zoom));
            }
            // Instantiate the appropriate L.MarkerCluster class (animated or not).
            this._topClusterLevel = new this._markerCluster(this, minZoom - 1);
        },
        //Zoom: Zoom to start adding at (Pass this._maxZoom to start at the bottom)
        _addLayer: function(layer, zoom) {
            var gridClusters = this._gridClusters, gridUnclustered = this._gridUnclustered, minZoom = Math.floor(this._map.getMinZoom()), markerPoint, z;
            if (this.options.singleMarkerMode) this._overrideMarkerIcon(layer);
            layer.on(this._childMarkerEventHandlers, this);
            //Find the lowest zoom level to slot this one in
            for(; zoom >= minZoom; zoom--){
                markerPoint = this._map.project(layer.getLatLng(), zoom); // calculate pixel position
                //Try find a cluster close by
                var closest = gridClusters[zoom].getNearObject(markerPoint);
                if (closest) {
                    closest._addChild(layer);
                    layer.__parent = closest;
                    return;
                }
                //Try find a marker close by to form a new cluster with
                closest = gridUnclustered[zoom].getNearObject(markerPoint);
                if (closest) {
                    var parent = closest.__parent;
                    if (parent) this._removeLayer(closest, false);
                    //Create new cluster with these 2 in it
                    var newCluster = new this._markerCluster(this, zoom, closest, layer);
                    gridClusters[zoom].addObject(newCluster, this._map.project(newCluster._cLatLng, zoom));
                    closest.__parent = newCluster;
                    layer.__parent = newCluster;
                    //First create any new intermediate parent clusters that don't exist
                    var lastParent = newCluster;
                    for(z = zoom - 1; z > parent._zoom; z--){
                        lastParent = new this._markerCluster(this, z, lastParent);
                        gridClusters[z].addObject(lastParent, this._map.project(closest.getLatLng(), z));
                    }
                    parent._addChild(lastParent);
                    //Remove closest from this zoom level and any above that it is in, replace with newCluster
                    this._removeFromGridUnclustered(closest, zoom);
                    return;
                }
                //Didn't manage to cluster in at this zoom, record us as a marker here and continue upwards
                gridUnclustered[zoom].addObject(layer, markerPoint);
            }
            //Didn't get in anything, add us to the top
            this._topClusterLevel._addChild(layer);
            layer.__parent = this._topClusterLevel;
            return;
        },
        /**
		 * Refreshes the icon of all "dirty" visible clusters.
		 * Non-visible "dirty" clusters will be updated when they are added to the map.
		 * @private
		 */ _refreshClustersIcons: function() {
            this._featureGroup.eachLayer(function(c) {
                if (c instanceof L.MarkerCluster && c._iconNeedsUpdate) c._updateIcon();
            });
        },
        //Enqueue code to fire after the marker expand/contract has happened
        _enqueue: function(fn) {
            this._queue.push(fn);
            if (!this._queueTimeout) this._queueTimeout = setTimeout(L.bind(this._processQueue, this), 300);
        },
        _processQueue: function() {
            for(var i = 0; i < this._queue.length; i++)this._queue[i].call(this);
            this._queue.length = 0;
            clearTimeout(this._queueTimeout);
            this._queueTimeout = null;
        },
        //Merge and split any existing clusters that are too big or small
        _mergeSplitClusters: function() {
            var mapZoom = Math.round(this._map._zoom);
            //In case we are starting to split before the animation finished
            this._processQueue();
            if (this._zoom < mapZoom && this._currentShownBounds.intersects(this._getExpandedVisibleBounds())) {
                this._animationStart();
                //Remove clusters now off screen
                this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds, Math.floor(this._map.getMinZoom()), this._zoom, this._getExpandedVisibleBounds());
                this._animationZoomIn(this._zoom, mapZoom);
            } else if (this._zoom > mapZoom) {
                this._animationStart();
                this._animationZoomOut(this._zoom, mapZoom);
            } else this._moveEnd();
        },
        //Gets the maps visible bounds expanded in each direction by the size of the screen (so the user cannot see an area we do not cover in one pan)
        _getExpandedVisibleBounds: function() {
            if (!this.options.removeOutsideVisibleBounds) return this._mapBoundsInfinite;
            else if (L.Browser.mobile) return this._checkBoundsMaxLat(this._map.getBounds());
            return this._checkBoundsMaxLat(this._map.getBounds().pad(1)); // Padding expands the bounds by its own dimensions but scaled with the given factor.
        },
        /**
		 * Expands the latitude to Infinity (or -Infinity) if the input bounds reach the map projection maximum defined latitude
		 * (in the case of Web/Spherical Mercator, it is 85.0511287798 / see https://en.wikipedia.org/wiki/Web_Mercator#Formulas).
		 * Otherwise, the removeOutsideVisibleBounds option will remove markers beyond that limit, whereas the same markers without
		 * this option (or outside MCG) will have their position floored (ceiled) by the projection and rendered at that limit,
		 * making the user think that MCG "eats" them and never displays them again.
		 * @param bounds L.LatLngBounds
		 * @returns {L.LatLngBounds}
		 * @private
		 */ _checkBoundsMaxLat: function(bounds) {
            var maxLat = this._maxLat;
            if (maxLat !== undefined) {
                if (bounds.getNorth() >= maxLat) bounds._northEast.lat = Infinity;
                if (bounds.getSouth() <= -maxLat) bounds._southWest.lat = -Infinity;
            }
            return bounds;
        },
        //Shared animation code
        _animationAddLayerNonAnimated: function(layer, newCluster) {
            if (newCluster === layer) this._featureGroup.addLayer(layer);
            else if (newCluster._childCount === 2) {
                newCluster._addToMap();
                var markers = newCluster.getAllChildMarkers();
                this._featureGroup.removeLayer(markers[0]);
                this._featureGroup.removeLayer(markers[1]);
            } else newCluster._updateIcon();
        },
        /**
		 * Extracts individual (i.e. non-group) layers from a Layer Group.
		 * @param group to extract layers from.
		 * @param output {Array} in which to store the extracted layers.
		 * @returns {*|Array}
		 * @private
		 */ _extractNonGroupLayers: function(group, output) {
            var layers = group.getLayers(), i = 0, layer;
            output = output || [];
            for(; i < layers.length; i++){
                layer = layers[i];
                if (layer instanceof L.LayerGroup) {
                    this._extractNonGroupLayers(layer, output);
                    continue;
                }
                output.push(layer);
            }
            return output;
        },
        /**
		 * Implements the singleMarkerMode option.
		 * @param layer Marker to re-style using the Clusters iconCreateFunction.
		 * @returns {L.Icon} The newly created icon.
		 * @private
		 */ _overrideMarkerIcon: function(layer) {
            var icon = layer.options.icon = this.options.iconCreateFunction({
                getChildCount: function() {
                    return 1;
                },
                getAllChildMarkers: function() {
                    return [
                        layer
                    ];
                }
            });
            return icon;
        }
    });
    // Constant bounds used in case option "removeOutsideVisibleBounds" is set to false.
    L.MarkerClusterGroup.include({
        _mapBoundsInfinite: new L.LatLngBounds(new L.LatLng(-Infinity, -Infinity), new L.LatLng(Infinity, Infinity))
    });
    L.MarkerClusterGroup.include({
        _noAnimation: {
            //Non Animated versions of everything
            _animationStart: function() {
            //Do nothing...
            },
            _animationZoomIn: function(previousZoomLevel, newZoomLevel) {
                this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds, Math.floor(this._map.getMinZoom()), previousZoomLevel);
                this._topClusterLevel._recursivelyAddChildrenToMap(null, newZoomLevel, this._getExpandedVisibleBounds());
                //We didn't actually animate, but we use this event to mean "clustering animations have finished"
                this.fire("animationend");
            },
            _animationZoomOut: function(previousZoomLevel, newZoomLevel) {
                this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds, Math.floor(this._map.getMinZoom()), previousZoomLevel);
                this._topClusterLevel._recursivelyAddChildrenToMap(null, newZoomLevel, this._getExpandedVisibleBounds());
                //We didn't actually animate, but we use this event to mean "clustering animations have finished"
                this.fire("animationend");
            },
            _animationAddLayer: function(layer, newCluster) {
                this._animationAddLayerNonAnimated(layer, newCluster);
            }
        },
        _withAnimation: {
            //Animated versions here
            _animationStart: function() {
                this._map._mapPane.className += " leaflet-cluster-anim";
                this._inZoomAnimation++;
            },
            _animationZoomIn: function(previousZoomLevel, newZoomLevel) {
                var bounds = this._getExpandedVisibleBounds(), fg = this._featureGroup, minZoom = Math.floor(this._map.getMinZoom()), i;
                this._ignoreMove = true;
                //Add all children of current clusters to map and remove those clusters from map
                this._topClusterLevel._recursively(bounds, previousZoomLevel, minZoom, function(c) {
                    var startPos = c._latlng, markers = c._markers, m;
                    if (!bounds.contains(startPos)) startPos = null;
                    if (c._isSingleParent() && previousZoomLevel + 1 === newZoomLevel) {
                        fg.removeLayer(c);
                        c._recursivelyAddChildrenToMap(null, newZoomLevel, bounds);
                    } else {
                        //Fade out old cluster
                        c.clusterHide();
                        c._recursivelyAddChildrenToMap(startPos, newZoomLevel, bounds);
                    }
                    //Remove all markers that aren't visible any more
                    //TODO: Do we actually need to do this on the higher levels too?
                    for(i = markers.length - 1; i >= 0; i--){
                        m = markers[i];
                        if (!bounds.contains(m._latlng)) fg.removeLayer(m);
                    }
                });
                this._forceLayout();
                //Update opacities
                this._topClusterLevel._recursivelyBecomeVisible(bounds, newZoomLevel);
                //TODO Maybe? Update markers in _recursivelyBecomeVisible
                fg.eachLayer(function(n) {
                    if (!(n instanceof L.MarkerCluster) && n._icon) n.clusterShow();
                });
                //update the positions of the just added clusters/markers
                this._topClusterLevel._recursively(bounds, previousZoomLevel, newZoomLevel, function(c) {
                    c._recursivelyRestoreChildPositions(newZoomLevel);
                });
                this._ignoreMove = false;
                //Remove the old clusters and close the zoom animation
                this._enqueue(function() {
                    //update the positions of the just added clusters/markers
                    this._topClusterLevel._recursively(bounds, previousZoomLevel, minZoom, function(c) {
                        fg.removeLayer(c);
                        c.clusterShow();
                    });
                    this._animationEnd();
                });
            },
            _animationZoomOut: function(previousZoomLevel, newZoomLevel) {
                this._animationZoomOutSingle(this._topClusterLevel, previousZoomLevel - 1, newZoomLevel);
                //Need to add markers for those that weren't on the map before but are now
                this._topClusterLevel._recursivelyAddChildrenToMap(null, newZoomLevel, this._getExpandedVisibleBounds());
                //Remove markers that were on the map before but won't be now
                this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds, Math.floor(this._map.getMinZoom()), previousZoomLevel, this._getExpandedVisibleBounds());
            },
            _animationAddLayer: function(layer, newCluster) {
                var me = this, fg = this._featureGroup;
                fg.addLayer(layer);
                if (newCluster !== layer) {
                    if (newCluster._childCount > 2) {
                        newCluster._updateIcon();
                        this._forceLayout();
                        this._animationStart();
                        layer._setPos(this._map.latLngToLayerPoint(newCluster.getLatLng()));
                        layer.clusterHide();
                        this._enqueue(function() {
                            fg.removeLayer(layer);
                            layer.clusterShow();
                            me._animationEnd();
                        });
                    } else {
                        this._forceLayout();
                        me._animationStart();
                        me._animationZoomOutSingle(newCluster, this._map.getMaxZoom(), this._zoom);
                    }
                }
            }
        },
        // Private methods for animated versions.
        _animationZoomOutSingle: function(cluster, previousZoomLevel, newZoomLevel) {
            var bounds = this._getExpandedVisibleBounds(), minZoom = Math.floor(this._map.getMinZoom());
            //Animate all of the markers in the clusters to move to their cluster center point
            cluster._recursivelyAnimateChildrenInAndAddSelfToMap(bounds, minZoom, previousZoomLevel + 1, newZoomLevel);
            var me = this;
            //Update the opacity (If we immediately set it they won't animate)
            this._forceLayout();
            cluster._recursivelyBecomeVisible(bounds, newZoomLevel);
            //TODO: Maybe use the transition timing stuff to make this more reliable
            //When the animations are done, tidy up
            this._enqueue(function() {
                //This cluster stopped being a cluster before the timeout fired
                if (cluster._childCount === 1) {
                    var m = cluster._markers[0];
                    //If we were in a cluster animation at the time then the opacity and position of our child could be wrong now, so fix it
                    this._ignoreMove = true;
                    m.setLatLng(m.getLatLng());
                    this._ignoreMove = false;
                    if (m.clusterShow) m.clusterShow();
                } else cluster._recursively(bounds, newZoomLevel, minZoom, function(c) {
                    c._recursivelyRemoveChildrenFromMap(bounds, minZoom, previousZoomLevel + 1);
                });
                me._animationEnd();
            });
        },
        _animationEnd: function() {
            if (this._map) this._map._mapPane.className = this._map._mapPane.className.replace(" leaflet-cluster-anim", "");
            this._inZoomAnimation--;
            this.fire("animationend");
        },
        //Force a browser layout of stuff in the map
        // Should apply the current opacity and location to all elements so we can update them again for an animation
        _forceLayout: function() {
            //In my testing this works, infact offsetWidth of any element seems to work.
            //Could loop all this._layers and do this for each _icon if it stops working
            L.Util.falseFn(document.body.offsetWidth);
        }
    });
    L.markerClusterGroup = function(options) {
        return new L.MarkerClusterGroup(options);
    };
    var MarkerCluster = L.MarkerCluster = L.Marker.extend({
        options: L.Icon.prototype.options,
        initialize: function(group, zoom, a, b) {
            L.Marker.prototype.initialize.call(this, a ? a._cLatLng || a.getLatLng() : new L.LatLng(0, 0), {
                icon: this,
                pane: group.options.clusterPane
            });
            this._group = group;
            this._zoom = zoom;
            this._markers = [];
            this._childClusters = [];
            this._childCount = 0;
            this._iconNeedsUpdate = true;
            this._boundsNeedUpdate = true;
            this._bounds = new L.LatLngBounds();
            if (a) this._addChild(a);
            if (b) this._addChild(b);
        },
        //Recursively retrieve all child markers of this cluster
        getAllChildMarkers: function(storageArray, ignoreDraggedMarker) {
            storageArray = storageArray || [];
            for(var i = this._childClusters.length - 1; i >= 0; i--)this._childClusters[i].getAllChildMarkers(storageArray, ignoreDraggedMarker);
            for(var j = this._markers.length - 1; j >= 0; j--){
                if (ignoreDraggedMarker && this._markers[j].__dragStart) continue;
                storageArray.push(this._markers[j]);
            }
            return storageArray;
        },
        //Returns the count of how many child markers we have
        getChildCount: function() {
            return this._childCount;
        },
        //Zoom to the minimum of showing all of the child markers, or the extents of this cluster
        zoomToBounds: function(fitBoundsOptions) {
            var childClusters = this._childClusters.slice(), map = this._group._map, boundsZoom = map.getBoundsZoom(this._bounds), zoom = this._zoom + 1, mapZoom = map.getZoom(), i;
            //calculate how far we need to zoom down to see all of the markers
            while(childClusters.length > 0 && boundsZoom > zoom){
                zoom++;
                var newClusters = [];
                for(i = 0; i < childClusters.length; i++)newClusters = newClusters.concat(childClusters[i]._childClusters);
                childClusters = newClusters;
            }
            if (boundsZoom > zoom) this._group._map.setView(this._latlng, zoom);
            else if (boundsZoom <= mapZoom) this._group._map.setView(this._latlng, mapZoom + 1);
            else this._group._map.fitBounds(this._bounds, fitBoundsOptions);
        },
        getBounds: function() {
            var bounds = new L.LatLngBounds();
            bounds.extend(this._bounds);
            return bounds;
        },
        _updateIcon: function() {
            this._iconNeedsUpdate = true;
            if (this._icon) this.setIcon(this);
        },
        //Cludge for Icon, we pretend to be an icon for performance
        createIcon: function() {
            if (this._iconNeedsUpdate) {
                this._iconObj = this._group.options.iconCreateFunction(this);
                this._iconNeedsUpdate = false;
            }
            return this._iconObj.createIcon();
        },
        createShadow: function() {
            return this._iconObj.createShadow();
        },
        _addChild: function(new1, isNotificationFromChild) {
            this._iconNeedsUpdate = true;
            this._boundsNeedUpdate = true;
            this._setClusterCenter(new1);
            if (new1 instanceof L.MarkerCluster) {
                if (!isNotificationFromChild) {
                    this._childClusters.push(new1);
                    new1.__parent = this;
                }
                this._childCount += new1._childCount;
            } else {
                if (!isNotificationFromChild) this._markers.push(new1);
                this._childCount++;
            }
            if (this.__parent) this.__parent._addChild(new1, true);
        },
        /**
		 * Makes sure the cluster center is set. If not, uses the child center if it is a cluster, or the marker position.
		 * @param child L.MarkerCluster|L.Marker that will be used as cluster center if not defined yet.
		 * @private
		 */ _setClusterCenter: function(child) {
            if (!this._cLatLng) // when clustering, take position of the first point as the cluster center
            this._cLatLng = child._cLatLng || child._latlng;
        },
        /**
		 * Assigns impossible bounding values so that the next extend entirely determines the new bounds.
		 * This method avoids having to trash the previous L.LatLngBounds object and to create a new one, which is much slower for this class.
		 * As long as the bounds are not extended, most other methods would probably fail, as they would with bounds initialized but not extended.
		 * @private
		 */ _resetBounds: function() {
            var bounds = this._bounds;
            if (bounds._southWest) {
                bounds._southWest.lat = Infinity;
                bounds._southWest.lng = Infinity;
            }
            if (bounds._northEast) {
                bounds._northEast.lat = -Infinity;
                bounds._northEast.lng = -Infinity;
            }
        },
        _recalculateBounds: function() {
            var markers = this._markers, childClusters = this._childClusters, latSum = 0, lngSum = 0, totalCount = this._childCount, i, child, childLatLng, childCount;
            // Case where all markers are removed from the map and we are left with just an empty _topClusterLevel.
            if (totalCount === 0) return;
            // Reset rather than creating a new object, for performance.
            this._resetBounds();
            // Child markers.
            for(i = 0; i < markers.length; i++){
                childLatLng = markers[i]._latlng;
                this._bounds.extend(childLatLng);
                latSum += childLatLng.lat;
                lngSum += childLatLng.lng;
            }
            // Child clusters.
            for(i = 0; i < childClusters.length; i++){
                child = childClusters[i];
                // Re-compute child bounds and weighted position first if necessary.
                if (child._boundsNeedUpdate) child._recalculateBounds();
                this._bounds.extend(child._bounds);
                childLatLng = child._wLatLng;
                childCount = child._childCount;
                latSum += childLatLng.lat * childCount;
                lngSum += childLatLng.lng * childCount;
            }
            this._latlng = this._wLatLng = new L.LatLng(latSum / totalCount, lngSum / totalCount);
            // Reset dirty flag.
            this._boundsNeedUpdate = false;
        },
        //Set our markers position as given and add it to the map
        _addToMap: function(startPos) {
            if (startPos) {
                this._backupLatlng = this._latlng;
                this.setLatLng(startPos);
            }
            this._group._featureGroup.addLayer(this);
        },
        _recursivelyAnimateChildrenIn: function(bounds, center, maxZoom) {
            this._recursively(bounds, this._group._map.getMinZoom(), maxZoom - 1, function(c) {
                var markers = c._markers, i, m;
                for(i = markers.length - 1; i >= 0; i--){
                    m = markers[i];
                    //Only do it if the icon is still on the map
                    if (m._icon) {
                        m._setPos(center);
                        m.clusterHide();
                    }
                }
            }, function(c) {
                var childClusters = c._childClusters, j, cm;
                for(j = childClusters.length - 1; j >= 0; j--){
                    cm = childClusters[j];
                    if (cm._icon) {
                        cm._setPos(center);
                        cm.clusterHide();
                    }
                }
            });
        },
        _recursivelyAnimateChildrenInAndAddSelfToMap: function(bounds, mapMinZoom, previousZoomLevel, newZoomLevel) {
            this._recursively(bounds, newZoomLevel, mapMinZoom, function(c) {
                c._recursivelyAnimateChildrenIn(bounds, c._group._map.latLngToLayerPoint(c.getLatLng()).round(), previousZoomLevel);
                //TODO: depthToAnimateIn affects _isSingleParent, if there is a multizoom we may/may not be.
                //As a hack we only do a animation free zoom on a single level zoom, if someone does multiple levels then we always animate
                if (c._isSingleParent() && previousZoomLevel - 1 === newZoomLevel) {
                    c.clusterShow();
                    c._recursivelyRemoveChildrenFromMap(bounds, mapMinZoom, previousZoomLevel); //Immediately remove our children as we are replacing them. TODO previousBounds not bounds
                } else c.clusterHide();
                c._addToMap();
            });
        },
        _recursivelyBecomeVisible: function(bounds, zoomLevel) {
            this._recursively(bounds, this._group._map.getMinZoom(), zoomLevel, null, function(c) {
                c.clusterShow();
            });
        },
        _recursivelyAddChildrenToMap: function(startPos, zoomLevel, bounds) {
            this._recursively(bounds, this._group._map.getMinZoom() - 1, zoomLevel, function(c) {
                if (zoomLevel === c._zoom) return;
                //Add our child markers at startPos (so they can be animated out)
                for(var i = c._markers.length - 1; i >= 0; i--){
                    var nm = c._markers[i];
                    if (!bounds.contains(nm._latlng)) continue;
                    if (startPos) {
                        nm._backupLatlng = nm.getLatLng();
                        nm.setLatLng(startPos);
                        if (nm.clusterHide) nm.clusterHide();
                    }
                    c._group._featureGroup.addLayer(nm);
                }
            }, function(c) {
                c._addToMap(startPos);
            });
        },
        _recursivelyRestoreChildPositions: function(zoomLevel) {
            //Fix positions of child markers
            for(var i = this._markers.length - 1; i >= 0; i--){
                var nm = this._markers[i];
                if (nm._backupLatlng) {
                    nm.setLatLng(nm._backupLatlng);
                    delete nm._backupLatlng;
                }
            }
            if (zoomLevel - 1 === this._zoom) //Reposition child clusters
            for(var j = this._childClusters.length - 1; j >= 0; j--)this._childClusters[j]._restorePosition();
            else for(var k = this._childClusters.length - 1; k >= 0; k--)this._childClusters[k]._recursivelyRestoreChildPositions(zoomLevel);
        },
        _restorePosition: function() {
            if (this._backupLatlng) {
                this.setLatLng(this._backupLatlng);
                delete this._backupLatlng;
            }
        },
        //exceptBounds: If set, don't remove any markers/clusters in it
        _recursivelyRemoveChildrenFromMap: function(previousBounds, mapMinZoom, zoomLevel, exceptBounds) {
            var m, i;
            this._recursively(previousBounds, mapMinZoom - 1, zoomLevel - 1, function(c) {
                //Remove markers at every level
                for(i = c._markers.length - 1; i >= 0; i--){
                    m = c._markers[i];
                    if (!exceptBounds || !exceptBounds.contains(m._latlng)) {
                        c._group._featureGroup.removeLayer(m);
                        if (m.clusterShow) m.clusterShow();
                    }
                }
            }, function(c) {
                //Remove child clusters at just the bottom level
                for(i = c._childClusters.length - 1; i >= 0; i--){
                    m = c._childClusters[i];
                    if (!exceptBounds || !exceptBounds.contains(m._latlng)) {
                        c._group._featureGroup.removeLayer(m);
                        if (m.clusterShow) m.clusterShow();
                    }
                }
            });
        },
        //Run the given functions recursively to this and child clusters
        // boundsToApplyTo: a L.LatLngBounds representing the bounds of what clusters to recurse in to
        // zoomLevelToStart: zoom level to start running functions (inclusive)
        // zoomLevelToStop: zoom level to stop running functions (inclusive)
        // runAtEveryLevel: function that takes an L.MarkerCluster as an argument that should be applied on every level
        // runAtBottomLevel: function that takes an L.MarkerCluster as an argument that should be applied at only the bottom level
        _recursively: function(boundsToApplyTo, zoomLevelToStart, zoomLevelToStop, runAtEveryLevel, runAtBottomLevel) {
            var childClusters = this._childClusters, zoom = this._zoom, i, c;
            if (zoomLevelToStart <= zoom) {
                if (runAtEveryLevel) runAtEveryLevel(this);
                if (runAtBottomLevel && zoom === zoomLevelToStop) runAtBottomLevel(this);
            }
            if (zoom < zoomLevelToStart || zoom < zoomLevelToStop) for(i = childClusters.length - 1; i >= 0; i--){
                c = childClusters[i];
                if (c._boundsNeedUpdate) c._recalculateBounds();
                if (boundsToApplyTo.intersects(c._bounds)) c._recursively(boundsToApplyTo, zoomLevelToStart, zoomLevelToStop, runAtEveryLevel, runAtBottomLevel);
            }
        },
        //Returns true if we are the parent of only one cluster and that cluster is the same as us
        _isSingleParent: function() {
            //Don't need to check this._markers as the rest won't work if there are any
            return this._childClusters.length > 0 && this._childClusters[0]._childCount === this._childCount;
        }
    });
    /*
	* Extends L.Marker to include two extra methods: clusterHide and clusterShow.
	* 
	* They work as setOpacity(0) and setOpacity(1) respectively, but
	* don't overwrite the options.opacity
	* 
	*/ L.Marker.include({
        clusterHide: function() {
            var backup = this.options.opacity;
            this.setOpacity(0);
            this.options.opacity = backup;
            return this;
        },
        clusterShow: function() {
            return this.setOpacity(this.options.opacity);
        }
    });
    L.DistanceGrid = function(cellSize) {
        this._cellSize = cellSize;
        this._sqCellSize = cellSize * cellSize;
        this._grid = {};
        this._objectPoint = {};
    };
    L.DistanceGrid.prototype = {
        addObject: function(obj, point) {
            var x = this._getCoord(point.x), y = this._getCoord(point.y), grid = this._grid, row = grid[y] = grid[y] || {}, cell = row[x] = row[x] || [], stamp = L.Util.stamp(obj);
            this._objectPoint[stamp] = point;
            cell.push(obj);
        },
        updateObject: function(obj, point) {
            this.removeObject(obj);
            this.addObject(obj, point);
        },
        //Returns true if the object was found
        removeObject: function(obj, point) {
            var x = this._getCoord(point.x), y = this._getCoord(point.y), grid = this._grid, row = grid[y] = grid[y] || {}, cell = row[x] = row[x] || [], i, len;
            delete this._objectPoint[L.Util.stamp(obj)];
            for(i = 0, len = cell.length; i < len; i++)if (cell[i] === obj) {
                cell.splice(i, 1);
                if (len === 1) delete row[x];
                return true;
            }
        },
        eachObject: function(fn, context) {
            var i, j, k, len, row, cell, removed, grid = this._grid;
            for(i in grid){
                row = grid[i];
                for(j in row){
                    cell = row[j];
                    for(k = 0, len = cell.length; k < len; k++){
                        removed = fn.call(context, cell[k]);
                        if (removed) {
                            k--;
                            len--;
                        }
                    }
                }
            }
        },
        getNearObject: function(point) {
            var x = this._getCoord(point.x), y = this._getCoord(point.y), i, j, k, row, cell, len, obj, dist, objectPoint = this._objectPoint, closestDistSq = this._sqCellSize, closest = null;
            for(i = y - 1; i <= y + 1; i++){
                row = this._grid[i];
                if (row) for(j = x - 1; j <= x + 1; j++){
                    cell = row[j];
                    if (cell) for(k = 0, len = cell.length; k < len; k++){
                        obj = cell[k];
                        dist = this._sqDist(objectPoint[L.Util.stamp(obj)], point);
                        if (dist < closestDistSq || dist <= closestDistSq && closest === null) {
                            closestDistSq = dist;
                            closest = obj;
                        }
                    }
                }
            }
            return closest;
        },
        _getCoord: function(x) {
            var coord = Math.floor(x / this._cellSize);
            return isFinite(coord) ? coord : x;
        },
        _sqDist: function(p, p2) {
            var dx = p2.x - p.x, dy = p2.y - p.y;
            return dx * dx + dy * dy;
        }
    };
    /* Copyright (c) 2012 the authors listed at the following URL, and/or
	the authors of referenced articles or incorporated external code:
	http://en.literateprograms.org/Quickhull_(Javascript)?action=history&offset=20120410175256

	Permission is hereby granted, free of charge, to any person obtaining
	a copy of this software and associated documentation files (the
	"Software"), to deal in the Software without restriction, including
	without limitation the rights to use, copy, modify, merge, publish,
	distribute, sublicense, and/or sell copies of the Software, and to
	permit persons to whom the Software is furnished to do so, subject to
	the following conditions:

	The above copyright notice and this permission notice shall be
	included in all copies or substantial portions of the Software.

	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

	Retrieved from: http://en.literateprograms.org/Quickhull_(Javascript)?oldid=18434
	*/ (function() {
        L.QuickHull = {
            /*
			 * @param {Object} cpt a point to be measured from the baseline
			 * @param {Array} bl the baseline, as represented by a two-element
			 *   array of latlng objects.
			 * @returns {Number} an approximate distance measure
			 */ getDistant: function(cpt, bl) {
                var vY = bl[1].lat - bl[0].lat, vX = bl[0].lng - bl[1].lng;
                return vX * (cpt.lat - bl[0].lat) + vY * (cpt.lng - bl[0].lng);
            },
            /*
			 * @param {Array} baseLine a two-element array of latlng objects
			 *   representing the baseline to project from
			 * @param {Array} latLngs an array of latlng objects
			 * @returns {Object} the maximum point and all new points to stay
			 *   in consideration for the hull.
			 */ findMostDistantPointFromBaseLine: function(baseLine, latLngs) {
                var maxD = 0, maxPt = null, newPoints = [], i, pt, d;
                for(i = latLngs.length - 1; i >= 0; i--){
                    pt = latLngs[i];
                    d = this.getDistant(pt, baseLine);
                    if (d > 0) newPoints.push(pt);
                    else continue;
                    if (d > maxD) {
                        maxD = d;
                        maxPt = pt;
                    }
                }
                return {
                    maxPoint: maxPt,
                    newPoints: newPoints
                };
            },
            /*
			 * Given a baseline, compute the convex hull of latLngs as an array
			 * of latLngs.
			 *
			 * @param {Array} latLngs
			 * @returns {Array}
			 */ buildConvexHull: function(baseLine, latLngs) {
                var convexHullBaseLines = [], t = this.findMostDistantPointFromBaseLine(baseLine, latLngs);
                if (t.maxPoint) {
                    convexHullBaseLines = convexHullBaseLines.concat(this.buildConvexHull([
                        baseLine[0],
                        t.maxPoint
                    ], t.newPoints));
                    convexHullBaseLines = convexHullBaseLines.concat(this.buildConvexHull([
                        t.maxPoint,
                        baseLine[1]
                    ], t.newPoints));
                    return convexHullBaseLines;
                } else return [
                    baseLine[0]
                ];
            },
            /*
			 * Given an array of latlngs, compute a convex hull as an array
			 * of latlngs
			 *
			 * @param {Array} latLngs
			 * @returns {Array}
			 */ getConvexHull: function(latLngs) {
                // find first baseline
                var maxLat = false, minLat = false, maxLng = false, minLng = false, maxLatPt = null, minLatPt = null, maxLngPt = null, minLngPt = null, maxPt = null, minPt = null, i;
                for(i = latLngs.length - 1; i >= 0; i--){
                    var pt = latLngs[i];
                    if (maxLat === false || pt.lat > maxLat) {
                        maxLatPt = pt;
                        maxLat = pt.lat;
                    }
                    if (minLat === false || pt.lat < minLat) {
                        minLatPt = pt;
                        minLat = pt.lat;
                    }
                    if (maxLng === false || pt.lng > maxLng) {
                        maxLngPt = pt;
                        maxLng = pt.lng;
                    }
                    if (minLng === false || pt.lng < minLng) {
                        minLngPt = pt;
                        minLng = pt.lng;
                    }
                }
                if (minLat !== maxLat) {
                    minPt = minLatPt;
                    maxPt = maxLatPt;
                } else {
                    minPt = minLngPt;
                    maxPt = maxLngPt;
                }
                var ch = [].concat(this.buildConvexHull([
                    minPt,
                    maxPt
                ], latLngs), this.buildConvexHull([
                    maxPt,
                    minPt
                ], latLngs));
                return ch;
            }
        };
    })();
    L.MarkerCluster.include({
        getConvexHull: function() {
            var childMarkers = this.getAllChildMarkers(), points = [], p, i;
            for(i = childMarkers.length - 1; i >= 0; i--){
                p = childMarkers[i].getLatLng();
                points.push(p);
            }
            return L.QuickHull.getConvexHull(points);
        }
    });
    //This code is 100% based on https://github.com/jawj/OverlappingMarkerSpiderfier-Leaflet
    //Huge thanks to jawj for implementing it first to make my job easy :-)
    L.MarkerCluster.include({
        _2PI: Math.PI * 2,
        _circleFootSeparation: 25,
        _circleStartAngle: 0,
        _spiralFootSeparation: 28,
        _spiralLengthStart: 11,
        _spiralLengthFactor: 5,
        _circleSpiralSwitchover: 9,
        // 0 -> always spiral; Infinity -> always circle
        spiderfy: function() {
            if (this._group._spiderfied === this || this._group._inZoomAnimation) return;
            var childMarkers = this.getAllChildMarkers(null, true), group = this._group, map = group._map, center = map.latLngToLayerPoint(this._latlng), positions;
            this._group._unspiderfy();
            this._group._spiderfied = this;
            //TODO Maybe: childMarkers order by distance to center
            if (this._group.options.spiderfyShapePositions) positions = this._group.options.spiderfyShapePositions(childMarkers.length, center);
            else if (childMarkers.length >= this._circleSpiralSwitchover) positions = this._generatePointsSpiral(childMarkers.length, center);
            else {
                center.y += 10; // Otherwise circles look wrong => hack for standard blue icon, renders differently for other icons.
                positions = this._generatePointsCircle(childMarkers.length, center);
            }
            this._animationSpiderfy(childMarkers, positions);
        },
        unspiderfy: function(zoomDetails) {
            /// <param Name="zoomDetails">Argument from zoomanim if being called in a zoom animation or null otherwise</param>
            if (this._group._inZoomAnimation) return;
            this._animationUnspiderfy(zoomDetails);
            this._group._spiderfied = null;
        },
        _generatePointsCircle: function(count, centerPt) {
            var circumference = this._group.options.spiderfyDistanceMultiplier * this._circleFootSeparation * (2 + count), legLength = circumference / this._2PI, angleStep = this._2PI / count, res = [], i, angle;
            legLength = Math.max(legLength, 35); // Minimum distance to get outside the cluster icon.
            res.length = count;
            for(i = 0; i < count; i++){
                angle = this._circleStartAngle + i * angleStep;
                res[i] = new L.Point(centerPt.x + legLength * Math.cos(angle), centerPt.y + legLength * Math.sin(angle))._round();
            }
            return res;
        },
        _generatePointsSpiral: function(count, centerPt) {
            var spiderfyDistanceMultiplier = this._group.options.spiderfyDistanceMultiplier, legLength = spiderfyDistanceMultiplier * this._spiralLengthStart, separation = spiderfyDistanceMultiplier * this._spiralFootSeparation, lengthFactor = spiderfyDistanceMultiplier * this._spiralLengthFactor * this._2PI, angle = 0, res = [], i;
            res.length = count;
            // Higher index, closer position to cluster center.
            for(i = count; i >= 0; i--){
                // Skip the first position, so that we are already farther from center and we avoid
                // being under the default cluster icon (especially important for Circle Markers).
                if (i < count) res[i] = new L.Point(centerPt.x + legLength * Math.cos(angle), centerPt.y + legLength * Math.sin(angle))._round();
                angle += separation / legLength + i * 0.0005;
                legLength += lengthFactor / angle;
            }
            return res;
        },
        _noanimationUnspiderfy: function() {
            var group = this._group, map = group._map, fg = group._featureGroup, childMarkers = this.getAllChildMarkers(null, true), m, i;
            group._ignoreMove = true;
            this.setOpacity(1);
            for(i = childMarkers.length - 1; i >= 0; i--){
                m = childMarkers[i];
                fg.removeLayer(m);
                if (m._preSpiderfyLatlng) {
                    m.setLatLng(m._preSpiderfyLatlng);
                    delete m._preSpiderfyLatlng;
                }
                if (m.setZIndexOffset) m.setZIndexOffset(0);
                if (m._spiderLeg) {
                    map.removeLayer(m._spiderLeg);
                    delete m._spiderLeg;
                }
            }
            group.fire("unspiderfied", {
                cluster: this,
                markers: childMarkers
            });
            group._ignoreMove = false;
            group._spiderfied = null;
        }
    });
    //Non Animated versions of everything
    L.MarkerClusterNonAnimated = L.MarkerCluster.extend({
        _animationSpiderfy: function(childMarkers, positions) {
            var group = this._group, map = group._map, fg = group._featureGroup, legOptions = this._group.options.spiderLegPolylineOptions, i, m, leg, newPos;
            group._ignoreMove = true;
            // Traverse in ascending order to make sure that inner circleMarkers are on top of further legs. Normal markers are re-ordered by newPosition.
            // The reverse order trick no longer improves performance on modern browsers.
            for(i = 0; i < childMarkers.length; i++){
                newPos = map.layerPointToLatLng(positions[i]);
                m = childMarkers[i];
                // Add the leg before the marker, so that in case the latter is a circleMarker, the leg is behind it.
                leg = new L.Polyline([
                    this._latlng,
                    newPos
                ], legOptions);
                map.addLayer(leg);
                m._spiderLeg = leg;
                // Now add the marker.
                m._preSpiderfyLatlng = m._latlng;
                m.setLatLng(newPos);
                if (m.setZIndexOffset) m.setZIndexOffset(1000000); //Make these appear on top of EVERYTHING
                fg.addLayer(m);
            }
            this.setOpacity(0.3);
            group._ignoreMove = false;
            group.fire("spiderfied", {
                cluster: this,
                markers: childMarkers
            });
        },
        _animationUnspiderfy: function() {
            this._noanimationUnspiderfy();
        }
    });
    //Animated versions here
    L.MarkerCluster.include({
        _animationSpiderfy: function(childMarkers, positions) {
            var me = this, group = this._group, map = group._map, fg = group._featureGroup, thisLayerLatLng = this._latlng, thisLayerPos = map.latLngToLayerPoint(thisLayerLatLng), svg = L.Path.SVG, legOptions = L.extend({}, this._group.options.spiderLegPolylineOptions), finalLegOpacity = legOptions.opacity, i, m, leg, legPath, legLength, newPos;
            if (finalLegOpacity === undefined) finalLegOpacity = L.MarkerClusterGroup.prototype.options.spiderLegPolylineOptions.opacity;
            if (svg) {
                // If the initial opacity of the spider leg is not 0 then it appears before the animation starts.
                legOptions.opacity = 0;
                // Add the class for CSS transitions.
                legOptions.className = (legOptions.className || "") + " leaflet-cluster-spider-leg";
            } else // Make sure we have a defined opacity.
            legOptions.opacity = finalLegOpacity;
            group._ignoreMove = true;
            // Add markers and spider legs to map, hidden at our center point.
            // Traverse in ascending order to make sure that inner circleMarkers are on top of further legs. Normal markers are re-ordered by newPosition.
            // The reverse order trick no longer improves performance on modern browsers.
            for(i = 0; i < childMarkers.length; i++){
                m = childMarkers[i];
                newPos = map.layerPointToLatLng(positions[i]);
                // Add the leg before the marker, so that in case the latter is a circleMarker, the leg is behind it.
                leg = new L.Polyline([
                    thisLayerLatLng,
                    newPos
                ], legOptions);
                map.addLayer(leg);
                m._spiderLeg = leg;
                // Explanations: https://jakearchibald.com/2013/animated-line-drawing-svg/
                // In our case the transition property is declared in the CSS file.
                if (svg) {
                    legPath = leg._path;
                    legLength = legPath.getTotalLength() + 0.1; // Need a small extra length to avoid remaining dot in Firefox.
                    legPath.style.strokeDasharray = legLength; // Just 1 length is enough, it will be duplicated.
                    legPath.style.strokeDashoffset = legLength;
                }
                // If it is a marker, add it now and we'll animate it out
                if (m.setZIndexOffset) m.setZIndexOffset(1000000); // Make normal markers appear on top of EVERYTHING
                if (m.clusterHide) m.clusterHide();
                // Vectors just get immediately added
                fg.addLayer(m);
                if (m._setPos) m._setPos(thisLayerPos);
            }
            group._forceLayout();
            group._animationStart();
            // Reveal markers and spider legs.
            for(i = childMarkers.length - 1; i >= 0; i--){
                newPos = map.layerPointToLatLng(positions[i]);
                m = childMarkers[i];
                //Move marker to new position
                m._preSpiderfyLatlng = m._latlng;
                m.setLatLng(newPos);
                if (m.clusterShow) m.clusterShow();
                // Animate leg (animation is actually delegated to CSS transition).
                if (svg) {
                    leg = m._spiderLeg;
                    legPath = leg._path;
                    legPath.style.strokeDashoffset = 0;
                    //legPath.style.strokeOpacity = finalLegOpacity;
                    leg.setStyle({
                        opacity: finalLegOpacity
                    });
                }
            }
            this.setOpacity(0.3);
            group._ignoreMove = false;
            setTimeout(function() {
                group._animationEnd();
                group.fire("spiderfied", {
                    cluster: me,
                    markers: childMarkers
                });
            }, 200);
        },
        _animationUnspiderfy: function(zoomDetails) {
            var me = this, group = this._group, map = group._map, fg = group._featureGroup, thisLayerPos = zoomDetails ? map._latLngToNewLayerPoint(this._latlng, zoomDetails.zoom, zoomDetails.center) : map.latLngToLayerPoint(this._latlng), childMarkers = this.getAllChildMarkers(null, true), svg = L.Path.SVG, m, i, leg, legPath, legLength, nonAnimatable;
            group._ignoreMove = true;
            group._animationStart();
            //Make us visible and bring the child markers back in
            this.setOpacity(1);
            for(i = childMarkers.length - 1; i >= 0; i--){
                m = childMarkers[i];
                //Marker was added to us after we were spiderfied
                if (!m._preSpiderfyLatlng) continue;
                //Close any popup on the marker first, otherwise setting the location of the marker will make the map scroll
                m.closePopup();
                //Fix up the location to the real one
                m.setLatLng(m._preSpiderfyLatlng);
                delete m._preSpiderfyLatlng;
                //Hack override the location to be our center
                nonAnimatable = true;
                if (m._setPos) {
                    m._setPos(thisLayerPos);
                    nonAnimatable = false;
                }
                if (m.clusterHide) {
                    m.clusterHide();
                    nonAnimatable = false;
                }
                if (nonAnimatable) fg.removeLayer(m);
                // Animate the spider leg back in (animation is actually delegated to CSS transition).
                if (svg) {
                    leg = m._spiderLeg;
                    legPath = leg._path;
                    legLength = legPath.getTotalLength() + 0.1;
                    legPath.style.strokeDashoffset = legLength;
                    leg.setStyle({
                        opacity: 0
                    });
                }
            }
            group._ignoreMove = false;
            setTimeout(function() {
                //If we have only <= one child left then that marker will be shown on the map so don't remove it!
                var stillThereChildCount = 0;
                for(i = childMarkers.length - 1; i >= 0; i--){
                    m = childMarkers[i];
                    if (m._spiderLeg) stillThereChildCount++;
                }
                for(i = childMarkers.length - 1; i >= 0; i--){
                    m = childMarkers[i];
                    if (!m._spiderLeg) continue;
                    if (m.clusterShow) m.clusterShow();
                    if (m.setZIndexOffset) m.setZIndexOffset(0);
                    if (stillThereChildCount > 1) fg.removeLayer(m);
                    map.removeLayer(m._spiderLeg);
                    delete m._spiderLeg;
                }
                group._animationEnd();
                group.fire("unspiderfied", {
                    cluster: me,
                    markers: childMarkers
                });
            }, 200);
        }
    });
    L.MarkerClusterGroup.include({
        //The MarkerCluster currently spiderfied (if any)
        _spiderfied: null,
        unspiderfy: function() {
            this._unspiderfy.apply(this, arguments);
        },
        _spiderfierOnAdd: function() {
            this._map.on("click", this._unspiderfyWrapper, this);
            if (this._map.options.zoomAnimation) this._map.on("zoomstart", this._unspiderfyZoomStart, this);
            //Browsers without zoomAnimation or a big zoom don't fire zoomstart
            this._map.on("zoomend", this._noanimationUnspiderfy, this);
            if (!L.Browser.touch) this._map.getRenderer(this);
        },
        _spiderfierOnRemove: function() {
            this._map.off("click", this._unspiderfyWrapper, this);
            this._map.off("zoomstart", this._unspiderfyZoomStart, this);
            this._map.off("zoomanim", this._unspiderfyZoomAnim, this);
            this._map.off("zoomend", this._noanimationUnspiderfy, this);
            //Ensure that markers are back where they should be
            // Use no animation to avoid a sticky leaflet-cluster-anim class on mapPane
            this._noanimationUnspiderfy();
        },
        //On zoom start we add a zoomanim handler so that we are guaranteed to be last (after markers are animated)
        //This means we can define the animation they do rather than Markers doing an animation to their actual location
        _unspiderfyZoomStart: function() {
            if (!this._map) return;
            this._map.on("zoomanim", this._unspiderfyZoomAnim, this);
        },
        _unspiderfyZoomAnim: function(zoomDetails) {
            //Wait until the first zoomanim after the user has finished touch-zooming before running the animation
            if (L.DomUtil.hasClass(this._map._mapPane, "leaflet-touching")) return;
            this._map.off("zoomanim", this._unspiderfyZoomAnim, this);
            this._unspiderfy(zoomDetails);
        },
        _unspiderfyWrapper: function() {
            /// <summary>_unspiderfy but passes no arguments</summary>
            this._unspiderfy();
        },
        _unspiderfy: function(zoomDetails) {
            if (this._spiderfied) this._spiderfied.unspiderfy(zoomDetails);
        },
        _noanimationUnspiderfy: function() {
            if (this._spiderfied) this._spiderfied._noanimationUnspiderfy();
        },
        //If the given layer is currently being spiderfied then we unspiderfy it so it isn't on the map anymore etc
        _unspiderfyLayer: function(layer) {
            if (layer._spiderLeg) {
                this._featureGroup.removeLayer(layer);
                if (layer.clusterShow) layer.clusterShow();
                //Position will be fixed up immediately in _animationUnspiderfy
                if (layer.setZIndexOffset) layer.setZIndexOffset(0);
                this._map.removeLayer(layer._spiderLeg);
                delete layer._spiderLeg;
            }
        }
    });
    /**
	 * Adds 1 public method to MCG and 1 to L.Marker to facilitate changing
	 * markers' icon options and refreshing their icon and their parent clusters
	 * accordingly (case where their iconCreateFunction uses data of childMarkers
	 * to make up the cluster icon).
	 */ L.MarkerClusterGroup.include({
        /**
		 * Updates the icon of all clusters which are parents of the given marker(s).
		 * In singleMarkerMode, also updates the given marker(s) icon.
		 * @param layers L.MarkerClusterGroup|L.LayerGroup|Array(L.Marker)|Map(L.Marker)|
		 * L.MarkerCluster|L.Marker (optional) list of markers (or single marker) whose parent
		 * clusters need to be updated. If not provided, retrieves all child markers of this.
		 * @returns {L.MarkerClusterGroup}
		 */ refreshClusters: function(layers) {
            if (!layers) layers = this._topClusterLevel.getAllChildMarkers();
            else if (layers instanceof L.MarkerClusterGroup) layers = layers._topClusterLevel.getAllChildMarkers();
            else if (layers instanceof L.LayerGroup) layers = layers._layers;
            else if (layers instanceof L.MarkerCluster) layers = layers.getAllChildMarkers();
            else if (layers instanceof L.Marker) layers = [
                layers
            ];
             // else: must be an Array(L.Marker)|Map(L.Marker)
            this._flagParentsIconsNeedUpdate(layers);
            this._refreshClustersIcons();
            // In case of singleMarkerMode, also re-draw the markers.
            if (this.options.singleMarkerMode) this._refreshSingleMarkerModeMarkers(layers);
            return this;
        },
        /**
		 * Simply flags all parent clusters of the given markers as having a "dirty" icon.
		 * @param layers Array(L.Marker)|Map(L.Marker) list of markers.
		 * @private
		 */ _flagParentsIconsNeedUpdate: function(layers) {
            var id, parent;
            // Assumes layers is an Array or an Object whose prototype is non-enumerable.
            for(id in layers){
                // Flag parent clusters' icon as "dirty", all the way up.
                // Dumb process that flags multiple times upper parents, but still
                // much more efficient than trying to be smart and make short lists,
                // at least in the case of a hierarchy following a power law:
                // http://jsperf.com/flag-nodes-in-power-hierarchy/2
                parent = layers[id].__parent;
                while(parent){
                    parent._iconNeedsUpdate = true;
                    parent = parent.__parent;
                }
            }
        },
        /**
		 * Re-draws the icon of the supplied markers.
		 * To be used in singleMarkerMode only.
		 * @param layers Array(L.Marker)|Map(L.Marker) list of markers.
		 * @private
		 */ _refreshSingleMarkerModeMarkers: function(layers) {
            var id, layer;
            for(id in layers){
                layer = layers[id];
                // Make sure we do not override markers that do not belong to THIS group.
                if (this.hasLayer(layer)) // Need to re-create the icon first, then re-draw the marker.
                layer.setIcon(this._overrideMarkerIcon(layer));
            }
        }
    });
    L.Marker.include({
        /**
		 * Updates the given options in the marker's icon and refreshes the marker.
		 * @param options map object of icon options.
		 * @param directlyRefreshClusters boolean (optional) true to trigger
		 * MCG.refreshClustersOf() right away with this single marker.
		 * @returns {L.Marker}
		 */ refreshIconOptions: function(options, directlyRefreshClusters) {
            var icon = this.options.icon;
            L.setOptions(icon, options);
            this.setIcon(icon);
            // Shortcut to refresh the associated MCG clusters right away.
            // To be used when refreshing a single marker.
            // Otherwise, better use MCG.refreshClusters() once at the end with
            // the list of modified markers.
            if (directlyRefreshClusters && this.__parent) this.__parent._group.refreshClusters(this);
            return this;
        }
    });
    exports1.MarkerClusterGroup = MarkerClusterGroup;
    exports1.MarkerCluster = MarkerCluster;
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
});



/*!
Copyright (c) 2016 Dominik Moritz

This file is part of the leaflet locate control. It is licensed under the MIT license.
You can find the project at: https://github.com/domoritz/leaflet-locatecontrol
*/ const $873e4daea7377db1$var$addClasses = (el, names)=>{
    names.split(" ").forEach((className)=>{
        el.classList.add(className);
    });
};
const $873e4daea7377db1$var$removeClasses = (el, names)=>{
    names.split(" ").forEach((className)=>{
        el.classList.remove(className);
    });
};
/**
 * Compatible with Circle but a true marker instead of a path
 */ const $873e4daea7377db1$export$b42842b40b0e9990 = (0, $b20f9367718bba3f$exports.Marker).extend({
    initialize (latlng, options) {
        (0, $b20f9367718bba3f$exports.setOptions)(this, options);
        this._latlng = latlng;
        this.createIcon();
    },
    /**
   * Create a styled circle location marker
   */ createIcon () {
        const opt = this.options;
        const style = [
            [
                "stroke",
                opt.color
            ],
            [
                "stroke-width",
                opt.weight
            ],
            [
                "fill",
                opt.fillColor
            ],
            [
                "fill-opacity",
                opt.fillOpacity
            ],
            [
                "opacity",
                opt.opacity
            ]
        ].filter(([k, v])=>v !== undefined).map(([k, v])=>`${k}="${v}"`).join(" ");
        const icon = this._getIconSVG(opt, style);
        this._locationIcon = (0, $b20f9367718bba3f$exports.divIcon)({
            className: icon.className,
            html: icon.svg,
            iconSize: [
                icon.w,
                icon.h
            ]
        });
        this.setIcon(this._locationIcon);
    },
    /**
   * Return the raw svg for the shape
   *
   * Split so can be easily overridden
   */ _getIconSVG (options, style) {
        const r = options.radius;
        const w = options.weight;
        const s = r + w;
        const s2 = s * 2;
        const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${s2}" height="${s2}" version="1.1" viewBox="-${s} -${s} ${s2} ${s2}">` + `<circle r="${r}" ${style} /></svg>`;
        return {
            className: "leaflet-control-locate-location",
            svg: svg,
            w: s2,
            h: s2
        };
    },
    setStyle (style) {
        (0, $b20f9367718bba3f$exports.setOptions)(this, style);
        this.createIcon();
    }
});
const $873e4daea7377db1$export$c05b54df9e1e8513 = $873e4daea7377db1$export$b42842b40b0e9990.extend({
    initialize (latlng, heading, options) {
        (0, $b20f9367718bba3f$exports.setOptions)(this, options);
        this._latlng = latlng;
        this._heading = heading;
        this.createIcon();
    },
    setHeading (heading) {
        this._heading = heading;
    },
    /**
   * Create a styled arrow compass marker
   */ _getIconSVG (options, style) {
        const r = options.radius;
        const w = options.width + options.weight;
        const h = (r + options.depth + options.weight) * 2;
        const path = `M0,0 l${options.width / 2},${options.depth} l-${w},0 z`;
        const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${w}" height="${h}" version="1.1" viewBox="-${w / 2} 0 ${w} ${h}" transform="rotate(${this._heading})">` + `<path d="${path}" ${style} /></svg>`;
        return {
            className: "leaflet-control-locate-heading",
            svg: svg,
            w: w,
            h: h
        };
    }
});
const $873e4daea7377db1$export$acde3ad4f992a4ae = (0, $b20f9367718bba3f$exports.Control).extend({
    options: {
        /** Position of the control */ position: "topleft",
        /** The layer that the user's location should be drawn on. By default creates a new layer. */ layer: undefined,
        /**
     * Automatically sets the map view (zoom and pan) to the user's location as it updates.
     * While the map is following the user's location, the control is in the `following` state,
     * which changes the style of the control and the circle marker.
     *
     * Possible values:
     *  - false: never updates the map view when location changes.
     *  - 'once': set the view when the location is first determined
     *  - 'always': always updates the map view when location changes.
     *              The map view follows the user's location.
     *  - 'untilPan': like 'always', except stops updating the
     *                view if the user has manually panned the map.
     *                The map view follows the user's location until she pans.
     *  - 'untilPanOrZoom': (default) like 'always', except stops updating the
     *                view if the user has manually panned the map.
     *                The map view follows the user's location until she pans.
     */ setView: "untilPanOrZoom",
        /** Keep the current map zoom level when setting the view and only pan. */ keepCurrentZoomLevel: false,
        /** After activating the plugin by clicking on the icon, zoom to the selected zoom level, even when keepCurrentZoomLevel is true. Set to 'false' to disable this feature. */ initialZoomLevel: false,
        /**
     * This callback can be used to override the viewport tracking
     * This function should return a LatLngBounds object.
     *
     * For example to extend the viewport to ensure that a particular LatLng is visible:
     *
     * getLocationBounds: function(locationEvent) {
     *    return locationEvent.bounds.extend([-33.873085, 151.219273]);
     * },
     */ getLocationBounds (locationEvent) {
            return locationEvent.bounds;
        },
        /** Smooth pan and zoom to the location of the marker. Only works in Leaflet 1.0+. */ flyTo: false,
        /**
     * The user location can be inside and outside the current view when the user clicks on the
     * control that is already active. Both cases can be configures separately.
     * Possible values are:
     *  - 'setView': zoom and pan to the current location
     *  - 'stop': stop locating and remove the location marker
     */ clickBehavior: {
            /** What should happen if the user clicks on the control while the location is within the current view. */ inView: "stop",
            /** What should happen if the user clicks on the control while the location is outside the current view. */ outOfView: "setView",
            /**
       * What should happen if the user clicks on the control while the location is within the current view
       * and we could be following but are not. Defaults to a special value which inherits from 'inView';
       */ inViewNotFollowing: "inView"
        },
        /**
     * If set, save the map bounds just before centering to the user's
     * location. When control is disabled, set the view back to the
     * bounds that were saved.
     */ returnToPrevBounds: false,
        /**
     * Keep a cache of the location after the user deactivates the control. If set to false, the user has to wait
     * until the locate API returns a new location before they see where they are again.
     */ cacheLocation: true,
        /** If set, a circle that shows the location accuracy is drawn. */ drawCircle: true,
        /** If set, the marker at the users' location is drawn. */ drawMarker: true,
        /** If set and supported then show the compass heading */ showCompass: true,
        /** The class to be used to create the marker. For example L.CircleMarker or L.Marker */ markerClass: $873e4daea7377db1$export$b42842b40b0e9990,
        /** The class us be used to create the compass bearing arrow */ compassClass: $873e4daea7377db1$export$c05b54df9e1e8513,
        /** Accuracy circle style properties. NOTE these styles should match the css animations styles */ circleStyle: {
            className: "leaflet-control-locate-circle",
            color: "#136AEC",
            fillColor: "#136AEC",
            fillOpacity: 0.15,
            weight: 0
        },
        /** Inner marker style properties. Only works if your marker class supports `setStyle`. */ markerStyle: {
            className: "leaflet-control-locate-marker",
            color: "#fff",
            fillColor: "#2A93EE",
            fillOpacity: 1,
            weight: 3,
            opacity: 1,
            radius: 9
        },
        /** Compass */ compassStyle: {
            fillColor: "#2A93EE",
            fillOpacity: 1,
            weight: 0,
            color: "#fff",
            opacity: 1,
            radius: 9,
            width: 9,
            depth: 6 // Length of the arrow
        },
        /**
     * Changes to accuracy circle and inner marker while following.
     * It is only necessary to provide the properties that should change.
     */ followCircleStyle: {},
        followMarkerStyle: {
        },
        followCompassStyle: {},
        /** The CSS class for the icon. For example fa-location-arrow or fa-map-marker */ icon: "leaflet-control-locate-location-arrow",
        iconLoading: "leaflet-control-locate-spinner",
        /** The element to be created for icons. For example span or i */ iconElementTag: "span",
        /** The element to be created for the text. For example small or span */ textElementTag: "small",
        /** Padding around the accuracy circle. */ circlePadding: [
            0,
            0
        ],
        /** Use metric units. */ metric: true,
        /**
     * This callback can be used in case you would like to override button creation behavior.
     * This is useful for DOM manipulation frameworks such as angular etc.
     * This function should return an object with HtmlElement for the button (link property) and the icon (icon property).
     */ createButtonCallback (container, options) {
            const link = (0, $b20f9367718bba3f$exports.DomUtil).create("a", "leaflet-bar-part leaflet-bar-part-single", container);
            link.title = options.strings.title;
            link.href = "#";
            link.setAttribute("role", "button");
            const icon = (0, $b20f9367718bba3f$exports.DomUtil).create(options.iconElementTag, options.icon, link);
            if (options.strings.text !== undefined) {
                const text = (0, $b20f9367718bba3f$exports.DomUtil).create(options.textElementTag, "leaflet-locate-text", link);
                text.textContent = options.strings.text;
                link.classList.add("leaflet-locate-text-active");
                link.parentNode.style.display = "flex";
                if (options.icon.length > 0) icon.classList.add("leaflet-locate-icon");
            }
            return {
                link: link,
                icon: icon
            };
        },
        /** This event is called in case of any location error that is not a time out error. */ onLocationError (err, control) {
            alert(err.message);
        },
        /**
     * This event is called when the user's location is outside the bounds set on the map.
     * The event is called repeatedly when the location changes.
     */ onLocationOutsideMapBounds (control) {
            control.stop();
            alert(control.options.strings.outsideMapBoundsMsg);
        },
        /** Display a pop-up when the user click on the inner marker. */ showPopup: true,
        strings: {
            title: "Show me where I am",
            metersUnit: "meters",
            feetUnit: "feet",
            popup: "You are within {distance} {unit} from this point",
            outsideMapBoundsMsg: "You seem located outside the boundaries of the map"
        },
        /** The default options passed to leaflets locate method. */ locateOptions: {
            maxZoom: Infinity,
            watch: true,
            setView: false // have to set this to false because we have to
        }
    },
    initialize (options) {
        // set default options if nothing is set (merge one step deep)
        for(const i in options)if (typeof this.options[i] === "object") (0, $b20f9367718bba3f$exports.extend)(this.options[i], options[i]);
        else this.options[i] = options[i];
        // extend the follow marker style and circle from the normal style
        this.options.followMarkerStyle = (0, $b20f9367718bba3f$exports.extend)({}, this.options.markerStyle, this.options.followMarkerStyle);
        this.options.followCircleStyle = (0, $b20f9367718bba3f$exports.extend)({}, this.options.circleStyle, this.options.followCircleStyle);
        this.options.followCompassStyle = (0, $b20f9367718bba3f$exports.extend)({}, this.options.compassStyle, this.options.followCompassStyle);
    },
    /**
   * Add control to map. Returns the container for the control.
   */ onAdd (map) {
        const container = (0, $b20f9367718bba3f$exports.DomUtil).create("div", "leaflet-control-locate leaflet-bar leaflet-control");
        this._container = container;
        this._map = map;
        this._layer = this.options.layer || new (0, $b20f9367718bba3f$exports.LayerGroup)();
        this._layer.addTo(map);
        this._event = undefined;
        this._compassHeading = null;
        this._prevBounds = null;
        const linkAndIcon = this.options.createButtonCallback(container, this.options);
        this._link = linkAndIcon.link;
        this._icon = linkAndIcon.icon;
        (0, $b20f9367718bba3f$exports.DomEvent).on(this._link, "click", function(ev) {
            (0, $b20f9367718bba3f$exports.DomEvent).stopPropagation(ev);
            (0, $b20f9367718bba3f$exports.DomEvent).preventDefault(ev);
            this._onClick();
        }, this).on(this._link, "dblclick", (0, $b20f9367718bba3f$exports.DomEvent).stopPropagation);
        this._resetVariables();
        this._map.on("unload", this._unload, this);
        return container;
    },
    /**
   * This method is called when the user clicks on the control.
   */ _onClick () {
        this._justClicked = true;
        const wasFollowing = this._isFollowing();
        this._userPanned = false;
        this._userZoomed = false;
        if (this._active && !this._event) // click while requesting
        this.stop();
        else if (this._active) {
            const behaviors = this.options.clickBehavior;
            let behavior = behaviors.outOfView;
            if (this._map.getBounds().contains(this._event.latlng)) behavior = wasFollowing ? behaviors.inView : behaviors.inViewNotFollowing;
            // Allow inheriting from another behavior
            if (behaviors[behavior]) behavior = behaviors[behavior];
            switch(behavior){
                case "setView":
                    this.setView();
                    break;
                case "stop":
                    this.stop();
                    if (this.options.returnToPrevBounds) {
                        const f = this.options.flyTo ? this._map.flyToBounds : this._map.fitBounds;
                        f.bind(this._map)(this._prevBounds);
                    }
                    break;
            }
        } else {
            if (this.options.returnToPrevBounds) this._prevBounds = this._map.getBounds();
            this.start();
        }
        this._updateContainerStyle();
    },
    /**
   * Starts the plugin:
   * - activates the engine
   * - draws the marker (if coordinates available)
   */ start () {
        this._activate();
        if (this._event) {
            this._drawMarker(this._map);
            // if we already have a location but the user clicked on the control
            if (this.options.setView) this.setView();
        }
        this._updateContainerStyle();
    },
    /**
   * Stops the plugin:
   * - deactivates the engine
   * - reinitializes the button
   * - removes the marker
   */ stop () {
        this._deactivate();
        this._cleanClasses();
        this._resetVariables();
        this._removeMarker();
    },
    /**
   * Keep the control active but stop following the location
   */ stopFollowing () {
        this._userPanned = true;
        this._updateContainerStyle();
        this._drawMarker();
    },
    /**
   * This method launches the location engine.
   * It is called before the marker is updated,
   * event if it does not mean that the event will be ready.
   *
   * Override it if you want to add more functionalities.
   * It should set the this._active to true and do nothing if
   * this._active is true.
   */ _activate () {
        if (this._active || !this._map) return;
        this._map.locate(this.options.locateOptions);
        this._map.fire("locateactivate", this);
        this._active = true;
        // bind event listeners
        this._map.on("locationfound", this._onLocationFound, this);
        this._map.on("locationerror", this._onLocationError, this);
        this._map.on("dragstart", this._onDrag, this);
        this._map.on("zoomstart", this._onZoom, this);
        this._map.on("zoomend", this._onZoomEnd, this);
        if (this.options.showCompass) {
            const oriAbs = "ondeviceorientationabsolute" in window;
            if (oriAbs || "ondeviceorientation" in window) {
                const _this = this;
                const deviceorientation = function() {
                    (0, $b20f9367718bba3f$exports.DomEvent).on(window, oriAbs ? "deviceorientationabsolute" : "deviceorientation", _this._onDeviceOrientation, _this);
                };
                if (DeviceOrientationEvent && typeof DeviceOrientationEvent.requestPermission === "function") DeviceOrientationEvent.requestPermission().then(function(permissionState) {
                    if (permissionState === "granted") deviceorientation();
                });
                else deviceorientation();
            }
        }
    },
    /**
   * Called to stop the location engine.
   *
   * Override it to shutdown any functionalities you added on start.
   */ _deactivate () {
        if (!this._active || !this._map) return;
        this._map.stopLocate();
        this._map.fire("locatedeactivate", this);
        this._active = false;
        if (!this.options.cacheLocation) this._event = undefined;
        // unbind event listeners
        this._map.off("locationfound", this._onLocationFound, this);
        this._map.off("locationerror", this._onLocationError, this);
        this._map.off("dragstart", this._onDrag, this);
        this._map.off("zoomstart", this._onZoom, this);
        this._map.off("zoomend", this._onZoomEnd, this);
        if (this.options.showCompass) {
            this._compassHeading = null;
            if ("ondeviceorientationabsolute" in window) (0, $b20f9367718bba3f$exports.DomEvent).off(window, "deviceorientationabsolute", this._onDeviceOrientation, this);
            else if ("ondeviceorientation" in window) (0, $b20f9367718bba3f$exports.DomEvent).off(window, "deviceorientation", this._onDeviceOrientation, this);
        }
    },
    /**
   * Zoom (unless we should keep the zoom level) and an to the current view.
   */ setView () {
        this._drawMarker();
        if (this._isOutsideMapBounds()) {
            this._event = undefined; // clear the current location so we can get back into the bounds
            this.options.onLocationOutsideMapBounds(this);
        } else {
            if (this._justClicked && this.options.initialZoomLevel !== false) {
                let f = this.options.flyTo ? this._map.flyTo : this._map.setView;
                f.bind(this._map)([
                    this._event.latitude,
                    this._event.longitude
                ], this.options.initialZoomLevel);
            } else if (this.options.keepCurrentZoomLevel) {
                let f = this.options.flyTo ? this._map.flyTo : this._map.panTo;
                f.bind(this._map)([
                    this._event.latitude,
                    this._event.longitude
                ]);
            } else {
                let f = this.options.flyTo ? this._map.flyToBounds : this._map.fitBounds;
                // Ignore zoom events while setting the viewport as these would stop following
                this._ignoreEvent = true;
                f.bind(this._map)(this.options.getLocationBounds(this._event), {
                    padding: this.options.circlePadding,
                    maxZoom: this.options.initialZoomLevel || this.options.locateOptions.maxZoom
                });
                (0, $b20f9367718bba3f$exports.Util).requestAnimFrame(function() {
                    // Wait until after the next animFrame because the flyTo can be async
                    this._ignoreEvent = false;
                }, this);
            }
        }
    },
    /**
   *
   */ _drawCompass () {
        if (!this._event) return;
        const latlng = this._event.latlng;
        if (this.options.showCompass && latlng && this._compassHeading !== null) {
            const cStyle = this._isFollowing() ? this.options.followCompassStyle : this.options.compassStyle;
            if (!this._compass) this._compass = new this.options.compassClass(latlng, this._compassHeading, cStyle).addTo(this._layer);
            else {
                this._compass.setLatLng(latlng);
                this._compass.setHeading(this._compassHeading);
                // If the compassClass can be updated with setStyle, update it.
                if (this._compass.setStyle) this._compass.setStyle(cStyle);
            }
        //
        }
        if (this._compass && (!this.options.showCompass || this._compassHeading === null)) {
            this._compass.removeFrom(this._layer);
            this._compass = null;
        }
    },
    /**
   * Draw the marker and accuracy circle on the map.
   *
   * Uses the event retrieved from onLocationFound from the map.
   */ _drawMarker () {
        if (this._event.accuracy === undefined) this._event.accuracy = 0;
        const radius = this._event.accuracy;
        const latlng = this._event.latlng;
        // circle with the radius of the location's accuracy
        if (this.options.drawCircle) {
            const style = this._isFollowing() ? this.options.followCircleStyle : this.options.circleStyle;
            if (!this._circle) this._circle = (0, $b20f9367718bba3f$exports.circle)(latlng, radius, style).addTo(this._layer);
            else this._circle.setLatLng(latlng).setRadius(radius).setStyle(style);
        }
        let distance;
        let unit;
        if (this.options.metric) {
            distance = radius.toFixed(0);
            unit = this.options.strings.metersUnit;
        } else {
            distance = (radius * 3.2808399).toFixed(0);
            unit = this.options.strings.feetUnit;
        }
        // small inner marker
        if (this.options.drawMarker) {
            const mStyle = this._isFollowing() ? this.options.followMarkerStyle : this.options.markerStyle;
            if (!this._marker) this._marker = new this.options.markerClass(latlng, mStyle).addTo(this._layer);
            else {
                this._marker.setLatLng(latlng);
                // If the markerClass can be updated with setStyle, update it.
                if (this._marker.setStyle) this._marker.setStyle(mStyle);
            }
        }
        this._drawCompass();
        const t = this.options.strings.popup;
        function getPopupText() {
            if (typeof t === "string") return (0, $b20f9367718bba3f$exports.Util).template(t, {
                distance: distance,
                unit: unit
            });
            else if (typeof t === "function") return t({
                distance: distance,
                unit: unit
            });
            else return t;
        }
        if (this.options.showPopup && t && this._marker) this._marker.bindPopup(getPopupText())._popup.setLatLng(latlng);
        if (this.options.showPopup && t && this._compass) this._compass.bindPopup(getPopupText())._popup.setLatLng(latlng);
    },
    /**
   * Remove the marker from map.
   */ _removeMarker () {
        this._layer.clearLayers();
        this._marker = undefined;
        this._circle = undefined;
    },
    /**
   * Unload the plugin and all event listeners.
   * Kind of the opposite of onAdd.
   */ _unload () {
        this.stop();
        // May become undefined during HMR
        if (this._map) this._map.off("unload", this._unload, this);
    },
    /**
   * Sets the compass heading
   */ _setCompassHeading (angle) {
        if (!isNaN(parseFloat(angle)) && isFinite(angle)) {
            angle = Math.round(angle);
            this._compassHeading = angle;
            (0, $b20f9367718bba3f$exports.Util).requestAnimFrame(this._drawCompass, this);
        } else this._compassHeading = null;
    },
    /**
   * If the compass fails calibration just fail safely and remove the compass
   */ _onCompassNeedsCalibration () {
        this._setCompassHeading();
    },
    /**
   * Process and normalise compass events
   */ _onDeviceOrientation (e) {
        if (!this._active) return;
        if (e.webkitCompassHeading) // iOS
        this._setCompassHeading(e.webkitCompassHeading);
        else if (e.absolute && e.alpha) // Android
        this._setCompassHeading(360 - e.alpha);
    },
    /**
   * Calls deactivate and dispatches an error.
   */ _onLocationError (err) {
        // ignore time out error if the location is watched
        if (err.code == 3 && this.options.locateOptions.watch) return;
        this.stop();
        this.options.onLocationError(err, this);
    },
    /**
   * Stores the received event and updates the marker.
   */ _onLocationFound (e) {
        // no need to do anything if the location has not changed
        if (this._event && this._event.latlng.lat === e.latlng.lat && this._event.latlng.lng === e.latlng.lng && this._event.accuracy === e.accuracy) return;
        if (!this._active) // we may have a stray event
        return;
        this._event = e;
        this._drawMarker();
        this._updateContainerStyle();
        switch(this.options.setView){
            case "once":
                if (this._justClicked) this.setView();
                break;
            case "untilPan":
                if (!this._userPanned) this.setView();
                break;
            case "untilPanOrZoom":
                if (!this._userPanned && !this._userZoomed) this.setView();
                break;
            case "always":
                this.setView();
                break;
        }
        this._justClicked = false;
    },
    /**
   * When the user drags. Need a separate event so we can bind and unbind event listeners.
   */ _onDrag () {
        // only react to drags once we have a location
        if (this._event && !this._ignoreEvent) {
            this._userPanned = true;
            this._updateContainerStyle();
            this._drawMarker();
        }
    },
    /**
   * When the user zooms. Need a separate event so we can bind and unbind event listeners.
   */ _onZoom () {
        // only react to drags once we have a location
        if (this._event && !this._ignoreEvent) {
            this._userZoomed = true;
            this._updateContainerStyle();
            this._drawMarker();
        }
    },
    /**
   * After a zoom ends update the compass and handle sideways zooms
   */ _onZoomEnd () {
        if (this._event) this._drawCompass();
        if (this._event && !this._ignoreEvent) // If we have zoomed in and out and ended up sideways treat it as a pan
        {
            if (this._marker && !this._map.getBounds().pad(-0.3).contains(this._marker.getLatLng())) {
                this._userPanned = true;
                this._updateContainerStyle();
                this._drawMarker();
            }
        }
    },
    /**
   * Compute whether the map is following the user location with pan and zoom.
   */ _isFollowing () {
        if (!this._active) return false;
        if (this.options.setView === "always") return true;
        else if (this.options.setView === "untilPan") return !this._userPanned;
        else if (this.options.setView === "untilPanOrZoom") return !this._userPanned && !this._userZoomed;
    },
    /**
   * Check if location is in map bounds
   */ _isOutsideMapBounds () {
        if (this._event === undefined) return false;
        return this._map.options.maxBounds && !this._map.options.maxBounds.contains(this._event.latlng);
    },
    /**
   * Toggles button class between following and active.
   */ _updateContainerStyle () {
        if (!this._container) return;
        if (this._active && !this._event) // active but don't have a location yet
        this._setClasses("requesting");
        else if (this._isFollowing()) this._setClasses("following");
        else if (this._active) this._setClasses("active");
        else this._cleanClasses();
    },
    /**
   * Sets the CSS classes for the state.
   */ _setClasses (state) {
        if (state == "requesting") {
            $873e4daea7377db1$var$removeClasses(this._container, "active following");
            $873e4daea7377db1$var$addClasses(this._container, "requesting");
            $873e4daea7377db1$var$removeClasses(this._icon, this.options.icon);
            $873e4daea7377db1$var$addClasses(this._icon, this.options.iconLoading);
        } else if (state == "active") {
            $873e4daea7377db1$var$removeClasses(this._container, "requesting following");
            $873e4daea7377db1$var$addClasses(this._container, "active");
            $873e4daea7377db1$var$removeClasses(this._icon, this.options.iconLoading);
            $873e4daea7377db1$var$addClasses(this._icon, this.options.icon);
        } else if (state == "following") {
            $873e4daea7377db1$var$removeClasses(this._container, "requesting");
            $873e4daea7377db1$var$addClasses(this._container, "active following");
            $873e4daea7377db1$var$removeClasses(this._icon, this.options.iconLoading);
            $873e4daea7377db1$var$addClasses(this._icon, this.options.icon);
        }
    },
    /**
   * Removes all classes from button.
   */ _cleanClasses () {
        (0, $b20f9367718bba3f$exports.DomUtil).removeClass(this._container, "requesting");
        (0, $b20f9367718bba3f$exports.DomUtil).removeClass(this._container, "active");
        (0, $b20f9367718bba3f$exports.DomUtil).removeClass(this._container, "following");
        $873e4daea7377db1$var$removeClasses(this._icon, this.options.iconLoading);
        $873e4daea7377db1$var$addClasses(this._icon, this.options.icon);
    },
    /**
   * Reinitializes state variables.
   */ _resetVariables () {
        // whether locate is active or not
        this._active = false;
        // true if the control was clicked for the first time
        // we need this so we can pan and zoom once we have the location
        this._justClicked = false;
        // true if the user has panned the map after clicking the control
        this._userPanned = false;
        // true if the user has zoomed the map after clicking the control
        this._userZoomed = false;
    }
});
function $873e4daea7377db1$export$5200e0c7549d7bff(options) {
    return new $873e4daea7377db1$export$acde3ad4f992a4ae(options);
}


/*
	Leaflet.CenterCross, a plugin that adds cross image on center to Leaflet powered maps.
	Original program is developed by Geospatial Information Authority of Japan.
	(c) 2015, Taro Matsuzawa and Geospatial Information Authority of Japan

	https://github.com/smellman/Leaflet.CenterCross
	http://leafletjs.com
	Original: https://github.com/gsi-cyberjapan/gsimaps
*/ window, document, L.centerCrossVersion = "0.0.8", L.CenterCross = L.Layer.extend({
    marker: null,
    options: {
        visible: !0
    },
    initialize: function(t) {
        t = L.setOptions(this, t);
    },
    addTo: function(t) {
        return this.onAdd(t), this;
    },
    onAdd: function(t) {
        this._map = t, this.setVisible(this.options.visible);
    },
    onRemove: function(t) {
        t.off("move", this.refresh, this), this.marker && (t.removeLayer(this.marker), this.marker = null);
    },
    refresh: function() {
        if (this.options.visible) {
            var t = this._map.getCenter();
            if (this.marker) this.marker.setLatLng(t);
            else {
                var e = L.icon({
                    iconUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAjCAYAAAAe2bNZAAAAAXNSR0IArs4c6QAAAAZiS0dEAP8A/wD/oL2nkwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAHVJREFUWMPt1rENgDAMRNEPi3gERmA0RmAERgmjsAEjhMY0dOBIWHCWTulOL5UN8VmACpRoUdcAU1v19SQaYYQRRhhhhMmIMV//9WGuG/xudmA6C+YApGUGgNF1b0KKjithhBFGGGGE+Rtm9XfL8CHzS8340hzaXWaR1yQVAAAAAABJRU5ErkJggg==",
                    iconSize: [
                        32,
                        32
                    ],
                    iconAnchor: [
                        16,
                        16
                    ]
                });
                this.marker = L.marker(t, {
                    icon: e,
                    clickable: !1,
                    draggable: !1,
                    keyboard: !1,
                    opacity: .8,
                    zIndexOffset: 0
                }), this.marker.addTo(this._map);
            }
        } else this.marker && (this._map.removeLayer(this.marker), this.marker = null);
    },
    setVisible: function(t) {
        return this.options.visible = t, this.options.visible ? this._map.on("move", this.refresh, this) : this._map.off("move", this.refresh, this), this.refresh(), this;
    },
    getVisible: function() {
        return this.options.visible;
    }
}), L.centerCross = function(t) {
    return new L.CenterCross(t);
}, L.Control.CenterCross = L.Control.extend({
    options: {
        position: "topleft",
        toggleText: "C",
        toggleTitle: "Toggle Center Cross",
        show: !1
    },
    initialize: function(t) {
        L.Control.prototype.initialize.call(this, t);
    },
    onAdd: function(t) {
        var e = L.DomUtil.create("div", "leaflet-center-cross leaflet-bar");
        return this._map = t, this._toggleButton = this._createButton(e, this), this._centerCross = L.centerCross({
            visible: this.options.show
        }).addTo(this._map), this._updateButton(), e;
    },
    _createButton: function(t, e) {
        var i = L.DomUtil.create("a", "leaflet-center-cross-toggle", t);
        i.innerHTML = this.options.toggleText, i.href = "#", i.title = this.options.toggleTitle;
        var o = L.DomEvent.stopPropagation;
        return L.DomEvent.on(i, "click", o).on(i, "mousedown", o).on(i, "dblclick", o).on(i, "click", L.DomEvent.preventDefault).on(i, "click", this._toggle, e), i;
    },
    _toggle: function() {
        var t = !this._centerCross.getVisible();
        this._centerCross.setVisible(t), this._updateButton();
    },
    _updateButton: function() {
        var t = this._centerCross.getVisible(), e = "leaflet-disabled";
        L.DomUtil.removeClass(this._toggleButton, e), t && L.DomUtil.addClass(this._toggleButton, e);
    }
}), L.control.centerCross = function(t) {
    return new L.Control.CenterCross(t);
};


var $41743c7b81409b9b$exports = {};
!function(a, t) {
    t($41743c7b81409b9b$exports);
}($41743c7b81409b9b$exports, function(a) {
    "use strict";
    var o = {
        ar: {
            touch: "\u0627\u0633\u062A\u062E\u062F\u0645 \u0625\u0635\u0628\u0639\u064A\u0646 \u0644\u062A\u062D\u0631\u064A\u0643 \u0627\u0644\u062E\u0631\u064A\u0637\u0629",
            scroll: "\u200F\u0627\u0633\u062A\u062E\u062F\u0645 ctrl + scroll \u0644\u062A\u0635\u063A\u064A\u0631/\u062A\u0643\u0628\u064A\u0631 \u0627\u0644\u062E\u0631\u064A\u0637\u0629",
            scrollMac: "\u064A\u0645\u0643\u0646\u0643 \u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u2318 + \u0627\u0644\u062A\u0645\u0631\u064A\u0631 \u0644\u062A\u0643\u0628\u064A\u0631/\u062A\u0635\u063A\u064A\u0631 \u0627\u0644\u062E\u0631\u064A\u0637\u0629"
        },
        bg: {
            touch: "\u0418\u0437\u043F\u043E\u043B\u0437\u0432\u0430\u0439\u0442\u0435 \u0434\u0432\u0430 \u043F\u0440\u044A\u0441\u0442\u0430, \u0437\u0430 \u0434\u0430 \u043F\u0440\u0435\u043C\u0435\u0441\u0442\u0438\u0442\u0435 \u043A\u0430\u0440\u0442\u0430\u0442\u0430",
            scroll: "\u0417\u0430\u0434\u0440\u044A\u0436\u0442\u0435 \u0431\u0443\u0442\u043E\u043D\u0430 Ctrl \u043D\u0430\u0442\u0438\u0441\u043D\u0430\u0442, \u0434\u043E\u043A\u0430\u0442\u043E \u043F\u0440\u0435\u0432\u044A\u0440\u0442\u0430\u0442\u0435, \u0437\u0430 \u0434\u0430 \u043F\u0440\u043E\u043C\u0435\u043D\u0438\u0442\u0435 \u043C\u0430\u0449\u0430\u0431\u0430 \u043D\u0430 \u043A\u0430\u0440\u0442\u0430\u0442\u0430",
            scrollMac: "\u0417\u0430\u0434\u0440\u044A\u0436\u0442\u0435 \u0431\u0443\u0442\u043E\u043D\u0430 \u2318 \u043D\u0430\u0442\u0438\u0441\u043D\u0430\u0442, \u0434\u043E\u043A\u0430\u0442\u043E \u043F\u0440\u0435\u0432\u044A\u0440\u0442\u0430\u0442\u0435, \u0437\u0430 \u0434\u0430 \u043F\u0440\u043E\u043C\u0435\u043D\u0438\u0442\u0435 \u043C\u0430\u0449\u0430\u0431\u0430 \u043D\u0430 \u043A\u0430\u0440\u0442\u0430\u0442\u0430"
        },
        bn: {
            touch: "\u09AE\u09BE\u09A8\u099A\u09BF\u09A4\u09CD\u09B0\u099F\u09BF\u0995\u09C7 \u09B8\u09B0\u09BE\u09A4\u09C7 \u09A6\u09C1\u099F\u09BF \u0986\u0999\u09CD\u0997\u09C1\u09B2 \u09AC\u09CD\u09AF\u09AC\u09B9\u09BE\u09B0 \u0995\u09B0\u09C1\u09A8",
            scroll: "\u09AE\u09CD\u09AF\u09BE\u09AA \u099C\u09C1\u09AE \u0995\u09B0\u09A4\u09C7 ctrl + scroll \u09AC\u09CD\u09AF\u09AC\u09B9\u09BE\u09B0 \u0995\u09B0\u09C1\u09A8",
            scrollMac: "\u09AE\u09CD\u09AF\u09BE\u09AA\u09C7 \u099C\u09C1\u09AE \u0995\u09B0\u09A4\u09C7 \u2318 \u09AC\u09CB\u09A4\u09BE\u09AE \u099F\u09BF\u09AA\u09C7 \u09B8\u09CD\u0995\u09CD\u09B0\u09B2 \u0995\u09B0\u09C1\u09A8"
        },
        ca: {
            touch: "Fes servir dos dits per moure el mapa",
            scroll: "Prem la tecla Control mentre et desplaces per apropar i allunyar el mapa",
            scrollMac: "Prem la tecla \u2318 mentre et desplaces per apropar i allunyar el mapa"
        },
        cs: {
            touch: "K\xa0posunut\xed mapy pou\u017Eijte dva prsty",
            scroll: "Velikost zobrazen\xed mapy zm\u011B\u0148te podr\u017Een\xedm kl\xe1vesy Ctrl a\xa0posouv\xe1n\xedm kole\u010Dka my\u0161i",
            scrollMac: "Velikost zobrazen\xed mapy zm\u011Bn\xedte podr\u017Een\xedm kl\xe1vesy \u2318 a\xa0posunut\xedm kole\u010Dka my\u0161i / touchpadu"
        },
        da: {
            touch: "Brug to fingre til at flytte kortet",
            scroll: "Brug ctrl + rullefunktionen til at zoome ind og ud p\xe5 kortet",
            scrollMac: "Brug \u2318 + rullefunktionen til at zoome ind og ud p\xe5 kortet"
        },
        de: {
            touch: "Verschieben der Karte mit zwei Fingern",
            scroll: "Verwende Strg+Scrollen zum Zoomen der Karte",
            scrollMac: "\u2318"
        },
        el: {
            touch: "\u03A7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03C4\u03B5 \u03B4\u03CD\u03BF \u03B4\u03AC\u03C7\u03C4\u03C5\u03BB\u03B1 \u03B3\u03B9\u03B1 \u03BC\u03B5\u03C4\u03B1\u03BA\u03AF\u03BD\u03B7\u03C3\u03B7 \u03C3\u03C4\u03BF\u03BD \u03C7\u03AC\u03C1\u03C4\u03B7",
            scroll: "\u03A7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03C4\u03B5 \u03C4\u03BF \u03C0\u03BB\u03AE\u03BA\u03C4\u03C1\u03BF Ctrl \u03BA\u03B1\u03B9 \u03BA\u03CD\u03BB\u03B9\u03C3\u03B7, \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03BC\u03B5\u03B3\u03B5\u03B8\u03CD\u03BD\u03B5\u03C4\u03B5 \u03C4\u03BF\u03BD \u03C7\u03AC\u03C1\u03C4\u03B7",
            scrollMac: "\u03A7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03C4\u03B5 \u03C4\u03BF \u03C0\u03BB\u03AE\u03BA\u03C4\u03C1\u03BF \u2318 + \u03BA\u03CD\u03BB\u03B9\u03C3\u03B7 \u03B3\u03B9\u03B1 \u03B5\u03C3\u03C4\u03AF\u03B1\u03C3\u03B7 \u03C3\u03C4\u03BF\u03BD \u03C7\u03AC\u03C1\u03C4\u03B7"
        },
        en: {
            touch: "Use two fingers to move the map",
            scroll: "Use ctrl + scroll to zoom the map",
            scrollMac: "Use \u2318 + scroll to zoom the map"
        },
        "en-AU": {
            touch: "Use two fingers to move the map",
            scroll: "Use ctrl + scroll to zoom the map",
            scrollMac: "Use \u2318 + scroll to zoom the map"
        },
        "en-GB": {
            touch: "Use two fingers to move the map",
            scroll: "Use ctrl + scroll to zoom the map",
            scrollMac: "Use \u2318 + scroll to zoom the map"
        },
        es: {
            touch: "Para mover el mapa, utiliza dos dedos",
            scroll: "Mant\xe9n pulsada la tecla Ctrl mientras te desplazas para acercar o alejar el mapa",
            scrollMac: "Mant\xe9n pulsada la tecla \u2318 mientras te desplazas para acercar o alejar el mapa"
        },
        eu: {
            touch: "Erabili bi hatz mapa mugitzeko",
            scroll: "Mapan zooma aplikatzeko, sakatu Ktrl eta egin gora edo behera",
            scrollMac: "Eduki sakatuta \u2318 eta egin gora eta behera mapa handitu eta txikitzeko"
        },
        fa: {
            touch: "\u0628\u0631\u0627\u06CC \u062D\u0631\u06A9\u062A \u062F\u0627\u062F\u0646 \u0646\u0642\u0634\u0647 \u0627\u0632 \u062F\u0648 \u0627\u0646\u06AF\u0634\u062A \u0627\u0633\u062A\u0641\u0627\u062F\u0647 \u06A9\u0646\u06CC\u062F.",
            scroll: "\u200F\u0628\u0631\u0627\u06CC \u0628\u0632\u0631\u06AF\u200C\u0646\u0645\u0627\u06CC\u06CC \u0646\u0642\u0634\u0647 \u0627\u0632 ctrl + scroll \u0627\u0633\u062A\u0641\u0627\u062F\u0647 \u06A9\u0646\u06CC\u062F",
            scrollMac: "\u0628\u0631\u0627\u06CC \u0628\u0632\u0631\u06AF\u200C\u0646\u0645\u0627\u06CC\u06CC \u0646\u0642\u0634\u0647\u060C \u0627\u0632 \u2318 + \u067E\u06CC\u0645\u0627\u06CC\u0634 \u0627\u0633\u062A\u0641\u0627\u062F\u0647 \u06A9\u0646\u06CC\u062F."
        },
        fi: {
            touch: "Siirr\xe4 karttaa kahdella sormella.",
            scroll: "Zoomaa karttaa painamalla Ctrl-painiketta ja vieritt\xe4m\xe4ll\xe4.",
            scrollMac: "Zoomaa karttaa pit\xe4m\xe4ll\xe4 painike \u2318 painettuna ja vieritt\xe4m\xe4ll\xe4."
        },
        fil: {
            touch: "Gumamit ng dalawang daliri upang iusog ang mapa",
            scroll: "Gamitin ang ctrl + scroll upang i-zoom ang mapa",
            scrollMac: "Gamitin ang \u2318 + scroll upang i-zoom ang mapa"
        },
        fr: {
            touch: "Utilisez deux\xa0doigts pour d\xe9placer la carte",
            scroll: "Vous pouvez zoomer sur la carte \xe0 l'aide de CTRL+Molette de d\xe9filement",
            scrollMac: "Vous pouvez zoomer sur la carte \xe0 l'aide de \u2318+Molette de d\xe9filement"
        },
        gl: {
            touch: "Utiliza dous dedos para mover o mapa",
            scroll: "Preme Ctrl mentres te desprazas para ampliar o mapa",
            scrollMac: "Preme \u2318 e despr\xe1zate para ampliar o mapa"
        },
        gu: {
            touch: "\u0AA8\u0A95\u0AB6\u0ACB \u0A96\u0AB8\u0AC7\u0AA1\u0AB5\u0ABE \u0AAC\u0AC7 \u0A86\u0A82\u0A97\u0AB3\u0AC0\u0A93\u0AA8\u0ACB \u0A89\u0AAA\u0AAF\u0ACB\u0A97 \u0A95\u0AB0\u0ACB",
            scroll: "\u0AA8\u0A95\u0AB6\u0ABE\u0AA8\u0AC7 \u0A9D\u0AC2\u0AAE \u0A95\u0AB0\u0AB5\u0ABE \u0AAE\u0ABE\u0A9F\u0AC7 ctrl + \u0AB8\u0ACD\u0A95\u0ACD\u0AB0\u0ACB\u0AB2\u0AA8\u0ACB \u0A89\u0AAA\u0AAF\u0ACB\u0A97 \u0A95\u0AB0\u0ACB",
            scrollMac: "\u0AA8\u0A95\u0AB6\u0ABE\u0AA8\u0AC7 \u0A9D\u0AC2\u0AAE \u0A95\u0AB0\u0AB5\u0ABE \u2318 + \u0AB8\u0ACD\u0A95\u0ACD\u0AB0\u0ACB\u0AB2\u0AA8\u0ACB \u0A89\u0AAA\u0AAF\u0ACB\u0A97 \u0A95\u0AB0\u0ACB"
        },
        hi: {
            touch: "\u092E\u0948\u092A \u090F\u0915 \u091C\u0917\u0939 \u0938\u0947 \u0926\u0942\u0938\u0930\u0940 \u091C\u0917\u0939 \u0932\u0947 \u091C\u093E\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u0926\u094B \u0909\u0902\u0917\u0932\u093F\u092F\u094B\u0902 \u0915\u093E \u0907\u0938\u094D\u0924\u0947\u092E\u093E\u0932 \u0915\u0930\u0947\u0902",
            scroll: "\u092E\u0948\u092A \u0915\u094B \u091C\u093C\u0942\u092E \u0915\u0930\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F ctrl + \u0938\u094D\u0915\u094D\u0930\u094B\u0932 \u0915\u093E \u0909\u092A\u092F\u094B\u0917 \u0915\u0930\u0947\u0902",
            scrollMac: "\u092E\u0948\u092A \u0915\u094B \u091C\u093C\u0942\u092E \u0915\u0930\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u2318 + \u0938\u094D\u0915\u094D\u0930\u094B\u0932 \u0915\u093E \u0909\u092A\u092F\u094B\u0917 \u0915\u0930\u0947\u0902"
        },
        hr: {
            touch: "Pomi\u010Dite kartu pomo\u0107u dva prsta",
            scroll: "Upotrijebite Ctrl i kliza\u010D mi\u0161a da biste zumirali kartu",
            scrollMac: "Upotrijebite gumb \u2318 dok se pomi\u010Dete za zumiranje karte"
        },
        hu: {
            touch: "K\xe9t ujjal mozgassa a t\xe9rk\xe9pet",
            scroll: "A t\xe9rk\xe9p a ctrl + g\xf6rget\xe9s haszn\xe1lat\xe1val nagy\xedthat\xf3",
            scrollMac: "A t\xe9rk\xe9p a \u2318 + g\xf6rget\xe9s haszn\xe1lat\xe1val nagy\xedthat\xf3"
        },
        id: {
            touch: "Gunakan dua jari untuk menggerakkan peta",
            scroll: "Gunakan ctrl + scroll untuk memperbesar atau memperkecil peta",
            scrollMac: "Gunakan \u2318 + scroll untuk memperbesar atau memperkecil peta"
        },
        it: {
            touch: "Utilizza due dita per spostare la mappa",
            scroll: "Utilizza CTRL + scorrimento per eseguire lo zoom della mappa",
            scrollMac: "Utilizza \u2318 + scorrimento per eseguire lo zoom della mappa"
        },
        iw: {
            touch: "\u05D4\u05D6\u05D6 \u05D0\u05EA \u05D4\u05DE\u05E4\u05D4 \u05D1\u05D0\u05DE\u05E6\u05E2\u05D5\u05EA \u05E9\u05EA\u05D9 \u05D0\u05E6\u05D1\u05E2\u05D5\u05EA",
            scroll: "\u200F\u05D0\u05E4\u05E9\u05E8 \u05DC\u05E9\u05E0\u05D5\u05EA \u05D0\u05EA \u05DE\u05E8\u05D7\u05E7 \u05D4\u05EA\u05E6\u05D5\u05D2\u05D4 \u05D1\u05DE\u05E4\u05D4 \u05D1\u05D0\u05DE\u05E6\u05E2\u05D5\u05EA \u05DE\u05E7\u05E9 ctrl \u05D5\u05D2\u05DC\u05D9\u05DC\u05D4",
            scrollMac: "\u05D0\u05E4\u05E9\u05E8 \u05DC\u05E9\u05E0\u05D5\u05EA \u05D0\u05EA \u05DE\u05E8\u05D7\u05E7 \u05D4\u05EA\u05E6\u05D5\u05D2\u05D4 \u05D1\u05DE\u05E4\u05D4 \u05D1\u05D0\u05DE\u05E6\u05E2\u05D5\u05EA \u05DE\u05E7\u05E9 \u2318 \u05D5\u05D2\u05DC\u05D9\u05DC\u05D4"
        },
        ja: {
            touch: "\u5730\u56F3\u3092\u79FB\u52D5\u3055\u305B\u308B\u306B\u306F\u6307 2 \u672C\u3067\u64CD\u4F5C\u3057\u307E\u3059",
            scroll: "\u5730\u56F3\u3092\u30BA\u30FC\u30E0\u3059\u308B\u306B\u306F\u3001Ctrl \u30AD\u30FC\u3092\u62BC\u3057\u306A\u304C\u3089\u30B9\u30AF\u30ED\u30FC\u30EB\u3057\u3066\u304F\u3060\u3055\u3044",
            scrollMac: "\u5730\u56F3\u3092\u30BA\u30FC\u30E0\u3059\u308B\u306B\u306F\u3001\u2318 \u30AD\u30FC\u3092\u62BC\u3057\u306A\u304C\u3089\u30B9\u30AF\u30ED\u30FC\u30EB\u3057\u3066\u304F\u3060\u3055\u3044"
        },
        kn: {
            touch: "Use two fingers to move the map",
            scroll: "Use Ctrl + scroll to zoom the map",
            scrollMac: "Use \u2318 + scroll to zoom the map"
        },
        ko: {
            touch: "\uC9C0\uB3C4\uB97C \uC6C0\uC9C1\uC774\uB824\uBA74 \uB450 \uC190\uAC00\uB77D\uC744 \uC0AC\uC6A9\uD558\uC138\uC694.",
            scroll: "\uC9C0\uB3C4\uB97C \uD655\uB300/\uCD95\uC18C\uD558\uB824\uBA74 Ctrl\uC744 \uB204\uB978 \uCC44 \uC2A4\uD06C\uB864\uD558\uC138\uC694.",
            scrollMac: "\uC9C0\uB3C4\uB97C \uD655\uB300\uD558\uB824\uBA74 \u2318 + \uC2A4\uD06C\uB864 \uC0AC\uC6A9"
        },
        lt: {
            touch: "Perkelkite \u017Eem\u0117lap\u012F dviem pir\u0161tais",
            scroll: "Slinkite nuspaud\u0119 klavi\u0161\u0105 \u201ECtrl\u201C, kad pakeistum\u0117te \u017Eem\u0117lapio mastel\u012F",
            scrollMac: "Paspauskite klavi\u0161\u0105 \u2318 ir slinkite, kad priartintum\u0117te \u017Eem\u0117lap\u012F"
        },
        lv: {
            touch: "Lai p\u0101rvietotu karti, b\u012Bdiet to ar diviem pirkstiem",
            scroll: "Kartes t\u0101lummai\u0146ai izmantojiet ctrl + ritin\u0101\u0161anu",
            scrollMac: "Lai veiktu kartes t\u0101lummai\u0146u, izmantojiet \u2318 + ritin\u0101\u0161anu"
        },
        ml: {
            touch: "\u0D2E\u0D3E\u0D2A\u0D4D\u0D2A\u0D4D \u0D28\u0D40\u0D15\u0D4D\u0D15\u0D3E\u0D7B \u0D30\u0D23\u0D4D\u0D1F\u0D4D \u0D35\u0D3F\u0D30\u0D32\u0D41\u0D15\u0D7E \u0D09\u0D2A\u0D2F\u0D4B\u0D17\u0D3F\u0D15\u0D4D\u0D15\u0D41\u0D15",
            scroll: "\u0D15\u0D7A\u0D1F\u0D4D\u0D30\u0D4B\u0D7E + \u0D38\u0D4D\u200C\u0D15\u0D4D\u0D30\u0D4B\u0D7E \u0D09\u0D2A\u0D2F\u0D4B\u0D17\u0D3F\u0D1A\u0D4D\u0D1A\u0D4D \u200C\u0D2E\u0D3E\u0D2A\u0D4D\u0D2A\u0D4D \u200C\u0D38\u0D42\u0D02 \u0D1A\u0D46\u0D2F\u0D4D\u0D2F\u0D41\u0D15",
            scrollMac: "\u2318 + \u0D38\u0D4D\u200C\u0D15\u0D4D\u0D30\u0D4B\u0D7E \u0D09\u0D2A\u0D2F\u0D4B\u0D17\u0D3F\u0D1A\u0D4D\u0D1A\u0D4D \u200C\u0D2E\u0D3E\u0D2A\u0D4D\u0D2A\u0D4D \u200C\u0D38\u0D42\u0D02 \u0D1A\u0D46\u0D2F\u0D4D\u0D2F\u0D41\u0D15"
        },
        mr: {
            touch: "\u0928\u0915\u093E\u0936\u093E \u0939\u0932\u0935\u093F\u0923\u094D\u092F\u093E\u0938\u093E\u0920\u0940 \u0926\u094B\u0928 \u092C\u094B\u091F\u0947 \u0935\u093E\u092A\u0930\u093E",
            scroll: "\u0928\u0915\u093E\u0936\u093E \u091D\u0942\u092E \u0915\u0930\u0923\u094D\u092F\u093E\u0938\u093E\u0920\u0940 ctrl + scroll \u0935\u093E\u092A\u0930\u093E",
            scrollMac: "\u0928\u0915\u093E\u0936\u093E\u0935\u0930 \u091D\u0942\u092E \u0915\u0930\u0923\u094D\u092F\u093E\u0938\u093E\u0920\u0940 \u2318 + \u0938\u094D\u0915\u094D\u0930\u094B\u0932 \u0935\u093E\u092A\u0930\u093E"
        },
        nl: {
            touch: "Gebruik twee vingers om de kaart te verplaatsen",
            scroll: "Gebruik Ctrl + scrollen om in- en uit te zoomen op de kaart",
            scrollMac: "Gebruik \u2318 + scrollen om in en uit te zoomen op de kaart"
        },
        no: {
            touch: "Bruk to fingre for \xe5 flytte kartet",
            scroll: "Hold ctrl-tasten inne og rull for \xe5 zoome p\xe5 kartet",
            scrollMac: "Hold inne \u2318-tasten og rull for \xe5 zoome p\xe5 kartet"
        },
        pl: {
            touch: "Przesu\u0144 map\u0119 dwoma palcami",
            scroll: "Naci\u015Bnij CTRL i przewi\u0144, by przybli\u017Cy\u0107 map\u0119",
            scrollMac: "Naci\u015Bnij\xa0\u2318 i przewi\u0144, by przybli\u017Cy\u0107 map\u0119"
        },
        pt: {
            touch: "Use dois dedos para mover o mapa",
            scroll: "Pressione Ctrl e role a tela simultaneamente para aplicar zoom no mapa",
            scrollMac: "Use \u2318 e role a tela simultaneamente para aplicar zoom no mapa"
        },
        "pt-BR": {
            touch: "Use dois dedos para mover o mapa",
            scroll: "Pressione Ctrl e role a tela simultaneamente para aplicar zoom no mapa",
            scrollMac: "Use \u2318 e role a tela simultaneamente para aplicar zoom no mapa"
        },
        "pt-PT": {
            touch: "Utilize dois dedos para mover o mapa",
            scroll: "Utilizar ctrl + deslocar para aumentar/diminuir zoom do mapa",
            scrollMac: "Utilize \u2318 + deslocar para aumentar/diminuir o zoom do mapa"
        },
        ro: {
            touch: "Folosi\u021Bi dou\u0103 degete pentru a deplasa harta",
            scroll: "Ap\u0103sa\u021Bi tasta ctrl \u0219i derula\u021Bi simultan pentru a m\u0103ri harta",
            scrollMac: "Folosi\u021Bi \u2318 \u0219i derula\u021Bi pentru a m\u0103ri/mic\u0219ora harta"
        },
        ru: {
            touch: "\u0427\u0442\u043E\u0431\u044B \u043F\u0435\u0440\u0435\u043C\u0435\u0441\u0442\u0438\u0442\u044C \u043A\u0430\u0440\u0442\u0443, \u043F\u0440\u043E\u0432\u0435\u0434\u0438\u0442\u0435 \u043F\u043E \u043D\u0435\u0439 \u0434\u0432\u0443\u043C\u044F \u043F\u0430\u043B\u044C\u0446\u0430\u043C\u0438",
            scroll: "\u0427\u0442\u043E\u0431\u044B \u0438\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u043C\u0430\u0441\u0448\u0442\u0430\u0431, \u043F\u0440\u043E\u043A\u0440\u0443\u0447\u0438\u0432\u0430\u0439\u0442\u0435 \u043A\u0430\u0440\u0442\u0443, \u0443\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u044F \u043A\u043B\u0430\u0432\u0438\u0448\u0443 Ctrl.",
            scrollMac: "\u0427\u0442\u043E\u0431\u044B \u0438\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u043C\u0430\u0441\u0448\u0442\u0430\u0431, \u043D\u0430\u0436\u043C\u0438\u0442\u0435 \u2318\xa0+ \u043F\u0440\u043E\u043A\u0440\u0443\u0442\u043A\u0430"
        },
        sk: {
            touch: "Mapu m\xf4\u017Eete posun\xfa\u0165 dvoma prstami",
            scroll: "Ak chcete pribl\xed\u017Ei\u0165 mapu, stla\u010Dte kl\xe1ves ctrl a\xa0pos\xfavajte",
            scrollMac: "Ak chcete pribl\xed\u017Ei\u0165 mapu, stla\u010Dte kl\xe1ves \u2318 a\xa0pos\xfavajte kolieskom my\u0161i"
        },
        sl: {
            touch: "Premaknite zemljevid z dvema prstoma",
            scroll: "Zemljevid pove\u010Date tako, da dr\u017Eite tipko Ctrl in vrtite kolesce na mi\u0161ki",
            scrollMac: "Uporabite \u2318 + funkcijo pomika, da pove\u010Date ali pomanj\u0161ate zemljevid"
        },
        sr: {
            touch: "\u041C\u0430\u043F\u0443 \u043F\u043E\u043C\u0435\u0440\u0430\u0458\u0442\u0435 \u043F\u043E\u043C\u043E\u045B\u0443 \u0434\u0432\u0430 \u043F\u0440\u0441\u0442\u0430",
            scroll: "\u041F\u0440\u0438\u0442\u0438\u0441\u043D\u0438\u0442\u0435 ctrl \u0442\u0430\u0441\u0442\u0435\u0440 \u0434\u043E\u043A \u043F\u043E\u043C\u0435\u0440\u0430\u0442\u0435 \u0434\u0430 \u0431\u0438\u0441\u0442\u0435 \u0437\u0443\u043C\u0438\u0440\u0430\u043B\u0438 \u043C\u0430\u043F\u0443",
            scrollMac: "\u041F\u0440\u0438\u0442\u0438\u0441\u043D\u0438\u0442\u0435 \u0442\u0430\u0441\u0442\u0435\u0440 \u2318 \u0434\u043E\u043A \u043F\u043E\u043C\u0435\u0440\u0430\u0442\u0435 \u0434\u0430 \u0431\u0438\u0441\u0442\u0435 \u0437\u0443\u043C\u0438\u0440\u0430\u043B\u0438 \u043C\u0430\u043F\u0443"
        },
        sv: {
            touch: "Anv\xe4nd tv\xe5 fingrar f\xf6r att flytta kartan",
            scroll: "Anv\xe4nd ctrl + rulla f\xf6r att zooma kartan",
            scrollMac: "Anv\xe4nd \u2318 + rulla f\xf6r att zooma p\xe5 kartan"
        },
        ta: {
            touch: "\u0BAE\u0BC7\u0BAA\u0BCD\u0BAA\u0BC8 \u0BA8\u0B95\u0BB0\u0BCD\u0BA4\u0BCD\u0BA4 \u0B87\u0BB0\u0BA3\u0BCD\u0B9F\u0BC1 \u0BB5\u0BBF\u0BB0\u0BB2\u0BCD\u0B95\u0BB3\u0BC8\u0BAA\u0BCD \u0BAA\u0BAF\u0BA9\u0BCD\u0BAA\u0B9F\u0BC1\u0BA4\u0BCD\u0BA4\u0BB5\u0BC1\u0BAE\u0BCD",
            scroll: "\u0BAE\u0BC7\u0BAA\u0BCD\u0BAA\u0BC8 \u0BAA\u0BC6\u0BB0\u0BBF\u0BA4\u0BBE\u0B95\u0BCD\u0B95\u0BBF/\u0B9A\u0BBF\u0BB1\u0BBF\u0BA4\u0BBE\u0B95\u0BCD\u0B95\u0BBF\u0BAA\u0BCD \u0BAA\u0BBE\u0BB0\u0BCD\u0B95\u0BCD\u0B95, ctrl \u0BAA\u0B9F\u0BCD\u0B9F\u0BA9\u0BC8\u0BAA\u0BCD \u0BAA\u0BBF\u0B9F\u0BBF\u0BA4\u0BCD\u0BA4\u0BAA\u0B9F\u0BBF, \u0BAE\u0BC7\u0BB2\u0BC7/\u0B95\u0BC0\u0BB4\u0BC7 \u0BB8\u0BCD\u0B95\u0BCD\u0BB0\u0BBE\u0BB2\u0BCD \u0B9A\u0BC6\u0BAF\u0BCD\u0BAF\u0BB5\u0BC1\u0BAE\u0BCD",
            scrollMac: "\u0BAE\u0BC7\u0BAA\u0BCD\u0BAA\u0BC8 \u0BAA\u0BC6\u0BB0\u0BBF\u0BA4\u0BBE\u0B95\u0BCD\u0B95\u0BBF/\u0B9A\u0BBF\u0BB1\u0BBF\u0BA4\u0BBE\u0B95\u0BCD\u0B95\u0BBF\u0BAA\u0BCD \u0BAA\u0BBE\u0BB0\u0BCD\u0B95\u0BCD\u0B95, \u2318 \u0BAA\u0B9F\u0BCD\u0B9F\u0BA9\u0BC8\u0BAA\u0BCD \u0BAA\u0BBF\u0B9F\u0BBF\u0BA4\u0BCD\u0BA4\u0BAA\u0B9F\u0BBF, \u0BAE\u0BC7\u0BB2\u0BC7/\u0B95\u0BC0\u0BB4\u0BC7 \u0BB8\u0BCD\u0B95\u0BCD\u0BB0\u0BBE\u0BB2\u0BCD \u0B9A\u0BC6\u0BAF\u0BCD\u0BAF\u0BB5\u0BC1\u0BAE\u0BCD"
        },
        te: {
            touch: "\u0C2E\u0C4D\u0C2F\u0C3E\u0C2A\u0C4D\u200C\u0C28\u0C3F \u0C24\u0C30\u0C32\u0C3F\u0C02\u0C1A\u0C21\u0C02 \u0C15\u0C4B\u0C38\u0C02 \u0C30\u0C46\u0C02\u0C21\u0C41 \u0C35\u0C47\u0C33\u0C4D\u0C32\u0C28\u0C41 \u0C09\u0C2A\u0C2F\u0C4B\u0C17\u0C3F\u0C02\u0C1A\u0C02\u0C21\u0C3F",
            scroll: "\u0C2E\u0C4D\u0C2F\u0C3E\u0C2A\u0C4D\u200C\u0C28\u0C3F \u0C1C\u0C42\u0C2E\u0C4D \u0C1A\u0C47\u0C2F\u0C21\u0C3E\u0C28\u0C3F\u0C15\u0C3F ctrl \u0C2C\u0C1F\u0C28\u0C4D\u200C\u0C28\u0C41 \u0C28\u0C4A\u0C15\u0C4D\u0C15\u0C3F \u0C09\u0C02\u0C1A\u0C3F, \u0C38\u0C4D\u0C15\u0C4D\u0C30\u0C4B\u0C32\u0C4D \u0C1A\u0C47\u0C2F\u0C02\u0C21\u0C3F",
            scrollMac: "\u0C2E\u0C4D\u0C2F\u0C3E\u0C2A\u0C4D \u0C1C\u0C42\u0C2E\u0C4D \u0C1A\u0C47\u0C2F\u0C3E\u0C32\u0C02\u0C1F\u0C47 \u2318 + \u0C38\u0C4D\u0C15\u0C4D\u0C30\u0C4B\u0C32\u0C4D \u0C09\u0C2A\u0C2F\u0C4B\u0C17\u0C3F\u0C02\u0C1A\u0C02\u0C21\u0C3F"
        },
        th: {
            touch: "\u0E43\u0E0A\u0E49 2 \u0E19\u0E34\u0E49\u0E27\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E25\u0E37\u0E48\u0E2D\u0E19\u0E41\u0E1C\u0E19\u0E17\u0E35\u0E48",
            scroll: "\u0E01\u0E14 Ctrl \u0E04\u0E49\u0E32\u0E07\u0E44\u0E27\u0E49 \u0E41\u0E25\u0E49\u0E27\u0E40\u0E25\u0E37\u0E48\u0E2D\u0E19\u0E2B\u0E19\u0E49\u0E32\u0E08\u0E2D\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E0B\u0E39\u0E21\u0E41\u0E1C\u0E19\u0E17\u0E35\u0E48",
            scrollMac: "\u0E01\u0E14 \u2318 \u0E41\u0E25\u0E49\u0E27\u0E40\u0E25\u0E37\u0E48\u0E2D\u0E19\u0E2B\u0E19\u0E49\u0E32\u0E08\u0E2D\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E0B\u0E39\u0E21\u0E41\u0E1C\u0E19\u0E17\u0E35\u0E48"
        },
        tl: {
            touch: "Gumamit ng dalawang daliri upang iusog ang mapa",
            scroll: "Gamitin ang ctrl + scroll upang i-zoom ang mapa",
            scrollMac: "Gamitin ang \u2318 + scroll upang i-zoom ang mapa"
        },
        tr: {
            touch: "Haritada gezinmek i\xe7in iki parma\u011F\u0131n\u0131z\u0131 kullan\u0131n",
            scroll: "Haritay\u0131 yak\u0131nla\u015Ft\u0131rmak i\xe7in ctrl + kayd\u0131rma kombinasyonunu kullan\u0131n",
            scrollMac: "Haritay\u0131 yak\u0131nla\u015Ft\u0131rmak i\xe7in \u2318 tu\u015Funa bas\u0131p ekran\u0131 kayd\u0131r\u0131n"
        },
        uk: {
            touch: "\u041F\u0435\u0440\u0435\u043C\u0456\u0449\u0443\u0439\u0442\u0435 \u043A\u0430\u0440\u0442\u0443 \u0434\u0432\u043E\u043C\u0430 \u043F\u0430\u043B\u044C\u0446\u044F\u043C\u0438",
            scroll: "\u0429\u043E\u0431 \u0437\u043C\u0456\u043D\u044E\u0432\u0430\u0442\u0438 \u043C\u0430\u0441\u0448\u0442\u0430\u0431 \u043A\u0430\u0440\u0442\u0438, \u043F\u0440\u043E\u043A\u0440\u0443\u0447\u0443\u0439\u0442\u0435 \u043A\u043E\u043B\u0456\u0449\u0430\u0442\u043A\u043E \u043C\u0438\u0448\u0456, \u0443\u0442\u0440\u0438\u043C\u0443\u044E\u0447\u0438 \u043A\u043B\u0430\u0432\u0456\u0448\u0443 Ctrl",
            scrollMac: "\u0429\u043E\u0431 \u0437\u043C\u0456\u043D\u0438\u0442\u0438 \u043C\u0430\u0441\u0448\u0442\u0430\u0431 \u043A\u0430\u0440\u0442\u0438, \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0439\u0442\u0435 \u2318 + \u043F\u0440\u043E\u043A\u0440\u0443\u0447\u0443\u0432\u0430\u043D\u043D\u044F"
        },
        vi: {
            touch: "S\u1EED d\u1EE5ng hai ng\xf3n tay \u0111\u1EC3 di chuy\u1EC3n b\u1EA3n \u0111\u1ED3",
            scroll: "S\u1EED d\u1EE5ng ctrl + cu\u1ED9n \u0111\u1EC3 thu ph\xf3ng b\u1EA3n \u0111\u1ED3",
            scrollMac: "S\u1EED d\u1EE5ng \u2318 + cu\u1ED9n \u0111\u1EC3 thu ph\xf3ng b\u1EA3n \u0111\u1ED3"
        },
        "zh-CN": {
            touch: "\u4F7F\u7528\u53CC\u6307\u79FB\u52A8\u5730\u56FE",
            scroll: "\u6309\u4F4F Ctrl \u5E76\u6EDA\u52A8\u9F20\u6807\u6EDA\u8F6E\u624D\u53EF\u7F29\u653E\u5730\u56FE",
            scrollMac: "\u6309\u4F4F \u2318 \u5E76\u6EDA\u52A8\u9F20\u6807\u6EDA\u8F6E\u624D\u53EF\u7F29\u653E\u5730\u56FE"
        },
        "zh-TW": {
            touch: "\u540C\u6642\u4EE5\u5169\u6307\u79FB\u52D5\u5730\u5716",
            scroll: "\u6309\u4F4F ctrl \u9375\u52A0\u4E0A\u6372\u52D5\u6ED1\u9F20\u53EF\u4EE5\u7E2E\u653E\u5730\u5716",
            scrollMac: "\u6309 \u2318 \u52A0\u4E0A\u6EFE\u52D5\u6372\u8EF8\u53EF\u4EE5\u7E2E\u653E\u5730\u5716"
        }
    };
    L.Map.mergeOptions({
        gestureHandlingOptions: {
            text: {},
            duration: 1e3
        }
    });
    var t = !1, e = L.Handler.extend({
        addHooks: function() {
            this._handleTouch = this._handleTouch.bind(this), this._setupPluginOptions(), this._setLanguageContent(), this._disableInteractions(), this._map._container.addEventListener("touchstart", this._handleTouch), this._map._container.addEventListener("touchmove", this._handleTouch), this._map._container.addEventListener("touchend", this._handleTouch), this._map._container.addEventListener("touchcancel", this._handleTouch), this._map._container.addEventListener("click", this._handleTouch), L.DomEvent.on(this._map._container, "wheel", this._handleScroll, this), L.DomEvent.on(this._map, "mouseover", this._handleMouseOver, this), L.DomEvent.on(this._map, "mouseout", this._handleMouseOut, this), L.DomEvent.on(this._map, "movestart", this._handleDragging, this), L.DomEvent.on(this._map, "move", this._handleDragging, this), L.DomEvent.on(this._map, "moveend", this._handleDragging, this);
        },
        removeHooks: function() {
            this._enableInteractions(), this._map._container.removeEventListener("touchstart", this._handleTouch), this._map._container.removeEventListener("touchmove", this._handleTouch), this._map._container.removeEventListener("touchend", this._handleTouch), this._map._container.removeEventListener("touchcancel", this._handleTouch), this._map._container.removeEventListener("click", this._handleTouch), L.DomEvent.off(this._map._container, "wheel", this._handleScroll, this), L.DomEvent.off(this._map, "mouseover", this._handleMouseOver, this), L.DomEvent.off(this._map, "mouseout", this._handleMouseOut, this), L.DomEvent.off(this._map, "movestart", this._handleDragging, this), L.DomEvent.off(this._map, "move", this._handleDragging, this), L.DomEvent.off(this._map, "moveend", this._handleDragging, this);
        },
        _handleDragging: function(a) {
            "movestart" == a.type || "move" == a.type ? t = !0 : "moveend" == a.type && (t = !1);
        },
        _disableInteractions: function() {
            this._map.dragging.disable(), this._map.scrollWheelZoom.disable(), this._map.tap && this._map.tap.disable();
        },
        _enableInteractions: function() {
            this._map.dragging.enable(), this._map.scrollWheelZoom.enable(), this._map.tap && this._map.tap.enable();
        },
        _setupPluginOptions: function() {
            this._map.options.gestureHandlingText && (this._map.options.gestureHandlingOptions.text = this._map.options.gestureHandlingText);
        },
        _setLanguageContent: function() {
            var a;
            if (this._map.options.gestureHandlingOptions && this._map.options.gestureHandlingOptions.text && this._map.options.gestureHandlingOptions.text.touch && this._map.options.gestureHandlingOptions.text.scroll && this._map.options.gestureHandlingOptions.text.scrollMac) a = this._map.options.gestureHandlingOptions.text;
            else {
                var t = this._getUserLanguage();
                t || (t = "en"), o[t] && (a = o[t]), a || -1 === t.indexOf("-") || (t = t.split("-")[0], a = o[t]), a || (a = o[t = "en"]);
            }
            var e = !1;
            0 <= navigator.platform.toUpperCase().indexOf("MAC") && (e = !0);
            var l = a.scroll;
            e && (l = a.scrollMac), this._map._container.setAttribute("data-gesture-handling-touch-content", a.touch), this._map._container.setAttribute("data-gesture-handling-scroll-content", l);
        },
        _getUserLanguage: function() {
            return navigator.languages ? navigator.languages[0] : navigator.language || navigator.userLanguage;
        },
        _handleTouch: function(a) {
            for(var t = [
                "leaflet-control-minimap",
                "leaflet-interactive",
                "leaflet-popup-content",
                "leaflet-popup-content-wrapper",
                "leaflet-popup-close-button",
                "leaflet-control-zoom-in",
                "leaflet-control-zoom-out"
            ], e = !1, l = 0; l < t.length; l++)L.DomUtil.hasClass(a.target, t[l]) && (e = !0);
            e ? L.DomUtil.hasClass(a.target, "leaflet-interactive") && "touchmove" === a.type && 1 === a.touches.length ? (L.DomUtil.addClass(this._map._container, "leaflet-gesture-handling-touch-warning"), this._disableInteractions()) : L.DomUtil.removeClass(this._map._container, "leaflet-gesture-handling-touch-warning") : "touchmove" === a.type || "touchstart" === a.type ? 1 === a.touches.length ? (L.DomUtil.addClass(this._map._container, "leaflet-gesture-handling-touch-warning"), this._disableInteractions()) : (a.preventDefault(), this._enableInteractions(), L.DomUtil.removeClass(this._map._container, "leaflet-gesture-handling-touch-warning")) : L.DomUtil.removeClass(this._map._container, "leaflet-gesture-handling-touch-warning");
        },
        _isScrolling: !1,
        _handleScroll: function(a) {
            a.metaKey || a.ctrlKey ? (a.preventDefault(), L.DomUtil.removeClass(this._map._container, "leaflet-gesture-handling-scroll-warning"), this._map.scrollWheelZoom.enable()) : (L.DomUtil.addClass(this._map._container, "leaflet-gesture-handling-scroll-warning"), this._map.scrollWheelZoom.disable(), clearTimeout(this._isScrolling), this._isScrolling = setTimeout(function() {
                for(var a = document.getElementsByClassName("leaflet-gesture-handling-scroll-warning"), t = 0; t < a.length; t++)L.DomUtil.removeClass(a[t], "leaflet-gesture-handling-scroll-warning");
            }, this._map.options.gestureHandlingOptions.duration));
        },
        _handleMouseOver: function(a) {
            this._enableInteractions();
        },
        _handleMouseOut: function(a) {
            t || this._disableInteractions();
        }
    });
    L.Map.addInitHook("addHandler", "gestureHandling", e), a.GestureHandling = e, a.default = e, Object.defineProperty(a, "__esModule", {
        value: !0
    });
});


/*!
  * Bootstrap v5.3.3 (https://getbootstrap.com/)
  * Copyright 2011-2024 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ var $adf6c43f8c27fe04$exports = {};

$parcel$export($adf6c43f8c27fe04$exports, "popperGenerator", function () { return $274bc1182b81f938$export$ed5e13716264f202; });
$parcel$export($adf6c43f8c27fe04$exports, "detectOverflow", function () { return $d41178d4bf911711$export$2e2bcd8739ae039; });
$parcel$export($adf6c43f8c27fe04$exports, "createPopperBase", function () { return $274bc1182b81f938$export$8f7491d57c8f97a9; });
$parcel$export($adf6c43f8c27fe04$exports, "createPopper", function () { return $4778e0b6040e2f98$export$8f7491d57c8f97a9; });
$parcel$export($adf6c43f8c27fe04$exports, "createPopperLite", function () { return $f689e912e865fa89$export$8f7491d57c8f97a9; });
var $2f59803f89522976$exports = {};

$parcel$export($2f59803f89522976$exports, "top", function () { return $2f59803f89522976$export$1e95b668f3b82d; });
$parcel$export($2f59803f89522976$exports, "bottom", function () { return $2f59803f89522976$export$40e543e69a8b3fbb; });
$parcel$export($2f59803f89522976$exports, "right", function () { return $2f59803f89522976$export$79ffe56a765070d2; });
$parcel$export($2f59803f89522976$exports, "left", function () { return $2f59803f89522976$export$eabcd2c8791e7bf4; });
$parcel$export($2f59803f89522976$exports, "auto", function () { return $2f59803f89522976$export$dfb5619354ba860; });
$parcel$export($2f59803f89522976$exports, "basePlacements", function () { return $2f59803f89522976$export$aec2ce47c367b8c3; });
$parcel$export($2f59803f89522976$exports, "start", function () { return $2f59803f89522976$export$b3571188c770cc5a; });
$parcel$export($2f59803f89522976$exports, "end", function () { return $2f59803f89522976$export$bd5df0f255a350f8; });
$parcel$export($2f59803f89522976$exports, "clippingParents", function () { return $2f59803f89522976$export$390fd549c5303b4d; });
$parcel$export($2f59803f89522976$exports, "viewport", function () { return $2f59803f89522976$export$d7b7311ec04a3e8f; });
$parcel$export($2f59803f89522976$exports, "popper", function () { return $2f59803f89522976$export$ae5ab1c730825774; });
$parcel$export($2f59803f89522976$exports, "reference", function () { return $2f59803f89522976$export$ca50aac9f3ba507f; });
$parcel$export($2f59803f89522976$exports, "variationPlacements", function () { return $2f59803f89522976$export$368f9a87e87fa4e1; });
$parcel$export($2f59803f89522976$exports, "placements", function () { return $2f59803f89522976$export$803cd8101b6c182b; });
$parcel$export($2f59803f89522976$exports, "beforeRead", function () { return $2f59803f89522976$export$421679a7c3d56e; });
$parcel$export($2f59803f89522976$exports, "read", function () { return $2f59803f89522976$export$aafa59e2e03f2942; });
$parcel$export($2f59803f89522976$exports, "afterRead", function () { return $2f59803f89522976$export$6964f6c886723980; });
$parcel$export($2f59803f89522976$exports, "beforeMain", function () { return $2f59803f89522976$export$c65e99957a05207c; });
$parcel$export($2f59803f89522976$exports, "main", function () { return $2f59803f89522976$export$f22da7240b7add18; });
$parcel$export($2f59803f89522976$exports, "afterMain", function () { return $2f59803f89522976$export$bab79516f2d662fe; });
$parcel$export($2f59803f89522976$exports, "beforeWrite", function () { return $2f59803f89522976$export$8d4d2d70e7d46032; });
$parcel$export($2f59803f89522976$exports, "write", function () { return $2f59803f89522976$export$68d8715fc104d294; });
$parcel$export($2f59803f89522976$exports, "afterWrite", function () { return $2f59803f89522976$export$70a6e5159acce2e6; });
$parcel$export($2f59803f89522976$exports, "modifierPhases", function () { return $2f59803f89522976$export$d087d3878fdf71d5; });
var $2f59803f89522976$export$1e95b668f3b82d = "top";
var $2f59803f89522976$export$40e543e69a8b3fbb = "bottom";
var $2f59803f89522976$export$79ffe56a765070d2 = "right";
var $2f59803f89522976$export$eabcd2c8791e7bf4 = "left";
var $2f59803f89522976$export$dfb5619354ba860 = "auto";
var $2f59803f89522976$export$aec2ce47c367b8c3 = [
    $2f59803f89522976$export$1e95b668f3b82d,
    $2f59803f89522976$export$40e543e69a8b3fbb,
    $2f59803f89522976$export$79ffe56a765070d2,
    $2f59803f89522976$export$eabcd2c8791e7bf4
];
var $2f59803f89522976$export$b3571188c770cc5a = "start";
var $2f59803f89522976$export$bd5df0f255a350f8 = "end";
var $2f59803f89522976$export$390fd549c5303b4d = "clippingParents";
var $2f59803f89522976$export$d7b7311ec04a3e8f = "viewport";
var $2f59803f89522976$export$ae5ab1c730825774 = "popper";
var $2f59803f89522976$export$ca50aac9f3ba507f = "reference";
var $2f59803f89522976$export$368f9a87e87fa4e1 = /*#__PURE__*/ $2f59803f89522976$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $2f59803f89522976$export$b3571188c770cc5a,
        placement + "-" + $2f59803f89522976$export$bd5df0f255a350f8
    ]);
}, []);
var $2f59803f89522976$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($2f59803f89522976$export$aec2ce47c367b8c3, [
    $2f59803f89522976$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $2f59803f89522976$export$b3571188c770cc5a,
        placement + "-" + $2f59803f89522976$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $2f59803f89522976$export$421679a7c3d56e = "beforeRead";
var $2f59803f89522976$export$aafa59e2e03f2942 = "read";
var $2f59803f89522976$export$6964f6c886723980 = "afterRead"; // pure-logic modifiers
var $2f59803f89522976$export$c65e99957a05207c = "beforeMain";
var $2f59803f89522976$export$f22da7240b7add18 = "main";
var $2f59803f89522976$export$bab79516f2d662fe = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var $2f59803f89522976$export$8d4d2d70e7d46032 = "beforeWrite";
var $2f59803f89522976$export$68d8715fc104d294 = "write";
var $2f59803f89522976$export$70a6e5159acce2e6 = "afterWrite";
var $2f59803f89522976$export$d087d3878fdf71d5 = [
    $2f59803f89522976$export$421679a7c3d56e,
    $2f59803f89522976$export$aafa59e2e03f2942,
    $2f59803f89522976$export$6964f6c886723980,
    $2f59803f89522976$export$c65e99957a05207c,
    $2f59803f89522976$export$f22da7240b7add18,
    $2f59803f89522976$export$bab79516f2d662fe,
    $2f59803f89522976$export$8d4d2d70e7d46032,
    $2f59803f89522976$export$68d8715fc104d294,
    $2f59803f89522976$export$70a6e5159acce2e6
];


var $4de021c4d26d7927$exports = {};

$parcel$export($4de021c4d26d7927$exports, "applyStyles", function () { return $b73519959eb6f577$export$2e2bcd8739ae039; });
$parcel$export($4de021c4d26d7927$exports, "arrow", function () { return $ae88eef85e3ee67c$export$2e2bcd8739ae039; });
$parcel$export($4de021c4d26d7927$exports, "computeStyles", function () { return $8b6fa2975dd1dd2b$export$2e2bcd8739ae039; });
$parcel$export($4de021c4d26d7927$exports, "eventListeners", function () { return $20665ae4d959ecd9$export$2e2bcd8739ae039; });
$parcel$export($4de021c4d26d7927$exports, "flip", function () { return $42bca5ede95de35f$export$2e2bcd8739ae039; });
$parcel$export($4de021c4d26d7927$exports, "hide", function () { return $ebe5ac00848ee6c4$export$2e2bcd8739ae039; });
$parcel$export($4de021c4d26d7927$exports, "offset", function () { return $49d6ab7fc3ac4e58$export$2e2bcd8739ae039; });
$parcel$export($4de021c4d26d7927$exports, "popperOffsets", function () { return $f7fbca4d6ede30c1$export$2e2bcd8739ae039; });
$parcel$export($4de021c4d26d7927$exports, "preventOverflow", function () { return $6da8693f631c6665$export$2e2bcd8739ae039; });
function $f320ee6316f9873f$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}


function $e9739ce302fe3e63$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $efe52269b1e87572$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $e9739ce302fe3e63$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $efe52269b1e87572$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $e9739ce302fe3e63$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $efe52269b1e87572$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, $e9739ce302fe3e63$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


// and applies them to the HTMLElements such as popper and arrow
function $b73519959eb6f577$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $efe52269b1e87572$export$1b3bfaa9684536aa)(element) || !(0, $f320ee6316f9873f$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? "" : value);
        });
    });
}
function $b73519959eb6f577$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
        },
        arrow: {
            position: "absolute"
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = "";
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $efe52269b1e87572$export$1b3bfaa9684536aa)(element) || !(0, $f320ee6316f9873f$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $b73519959eb6f577$export$2e2bcd8739ae039 = {
    name: "applyStyles",
    enabled: true,
    phase: "write",
    fn: $b73519959eb6f577$var$applyStyles,
    effect: $b73519959eb6f577$var$effect,
    requires: [
        "computeStyles"
    ]
};



function $3be2cafb7aeabb69$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[0];
}



var $d970f1420390d5ed$export$8960430cfd85939f = Math.max;
var $d970f1420390d5ed$export$96ec731ed4dcb222 = Math.min;
var $d970f1420390d5ed$export$2077e0241d6afd3c = Math.round;



function $5fcaccd3c36dc1eb$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}


function $e0553216fd185806$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $5fcaccd3c36dc1eb$export$2e2bcd8739ae039)());
}


function $66156c3b080bccf4$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $efe52269b1e87572$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $d970f1420390d5ed$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $d970f1420390d5ed$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $efe52269b1e87572$export$45a5e7f76e0caa8d)(element) ? (0, $e9739ce302fe3e63$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $e0553216fd185806$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}


function $961bfa09123cc0c3$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $66156c3b080bccf4$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}



function $60a8c5b725f322f9$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $efe52269b1e87572$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}





function $78dd59933addbcc0$export$2e2bcd8739ae039(element) {
    return (0, $e9739ce302fe3e63$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}




function $cbb1014511778323$export$2e2bcd8739ae039(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, $f320ee6316f9873f$export$2e2bcd8739ae039)(element)) >= 0;
}




function $d59d162ed38ceeb0$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $efe52269b1e87572$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $7897def57db13767$export$2e2bcd8739ae039(element) {
    if ((0, $f320ee6316f9873f$export$2e2bcd8739ae039)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $efe52269b1e87572$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $d59d162ed38ceeb0$export$2e2bcd8739ae039)(element) // fallback
    );
}



function $de89146f198bb093$var$getTrueOffsetParent(element) {
    if (!(0, $efe52269b1e87572$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $78dd59933addbcc0$export$2e2bcd8739ae039)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $de89146f198bb093$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $5fcaccd3c36dc1eb$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $5fcaccd3c36dc1eb$export$2e2bcd8739ae039)());
    if (isIE && (0, $efe52269b1e87572$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $78dd59933addbcc0$export$2e2bcd8739ae039)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, $7897def57db13767$export$2e2bcd8739ae039)(element);
    if ((0, $efe52269b1e87572$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $efe52269b1e87572$export$1b3bfaa9684536aa)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, $f320ee6316f9873f$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $78dd59933addbcc0$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $de89146f198bb093$export$2e2bcd8739ae039(element) {
    var window = (0, $e9739ce302fe3e63$export$2e2bcd8739ae039)(element);
    var offsetParent = $de89146f198bb093$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $cbb1014511778323$export$2e2bcd8739ae039)(offsetParent) && (0, $78dd59933addbcc0$export$2e2bcd8739ae039)(offsetParent).position === "static")offsetParent = $de89146f198bb093$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $f320ee6316f9873f$export$2e2bcd8739ae039)(offsetParent) === "html" || (0, $f320ee6316f9873f$export$2e2bcd8739ae039)(offsetParent) === "body" && (0, $78dd59933addbcc0$export$2e2bcd8739ae039)(offsetParent).position === "static")) return window;
    return offsetParent || $de89146f198bb093$var$getContainingBlock(element) || window;
}


function $9ed2f87291fd3f71$export$2e2bcd8739ae039(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}



function $48fe11e390a7ae46$export$f28d906d67a997f3(min, value, max) {
    return (0, $d970f1420390d5ed$export$8960430cfd85939f)(min, (0, $d970f1420390d5ed$export$96ec731ed4dcb222)(value, max));
}
function $48fe11e390a7ae46$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $48fe11e390a7ae46$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}


function $f3e24be1f4c121fd$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $c59e528685f0af1a$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $f3e24be1f4c121fd$export$2e2bcd8739ae039)(), paddingObject);
}


function $7cb803e0a6e6306b$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}



var $ae88eef85e3ee67c$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $c59e528685f0af1a$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $7cb803e0a6e6306b$export$2e2bcd8739ae039)(padding, (0, $2f59803f89522976$export$aec2ce47c367b8c3)));
};
function $ae88eef85e3ee67c$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $3be2cafb7aeabb69$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $9ed2f87291fd3f71$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $2f59803f89522976$export$eabcd2c8791e7bf4),
        (0, $2f59803f89522976$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $ae88eef85e3ee67c$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $961bfa09123cc0c3$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === "y" ? (0, $2f59803f89522976$export$1e95b668f3b82d) : (0, $2f59803f89522976$export$eabcd2c8791e7bf4);
    var maxProp = axis === "y" ? (0, $2f59803f89522976$export$40e543e69a8b3fbb) : (0, $2f59803f89522976$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $de89146f198bb093$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $48fe11e390a7ae46$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $ae88eef85e3ee67c$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $60a8c5b725f322f9$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $ae88eef85e3ee67c$export$2e2bcd8739ae039 = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: $ae88eef85e3ee67c$var$arrow,
    effect: $ae88eef85e3ee67c$var$effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};








function $a384a6c8d9f4d558$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[1];
}



var $8b6fa2975dd1dd2b$var$unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $8b6fa2975dd1dd2b$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $d970f1420390d5ed$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $d970f1420390d5ed$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $8b6fa2975dd1dd2b$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, $2f59803f89522976$export$eabcd2c8791e7bf4);
    var sideY = (0, $2f59803f89522976$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $de89146f198bb093$export$2e2bcd8739ae039)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, $e9739ce302fe3e63$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $d59d162ed38ceeb0$export$2e2bcd8739ae039)(popper);
            if ((0, $78dd59933addbcc0$export$2e2bcd8739ae039)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $2f59803f89522976$export$1e95b668f3b82d) || (placement === (0, $2f59803f89522976$export$eabcd2c8791e7bf4) || placement === (0, $2f59803f89522976$export$79ffe56a765070d2)) && variation === (0, $2f59803f89522976$export$bd5df0f255a350f8)) {
            sideY = (0, $2f59803f89522976$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $2f59803f89522976$export$eabcd2c8791e7bf4) || (placement === (0, $2f59803f89522976$export$1e95b668f3b82d) || placement === (0, $2f59803f89522976$export$40e543e69a8b3fbb)) && variation === (0, $2f59803f89522976$export$bd5df0f255a350f8)) {
            sideX = (0, $2f59803f89522976$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $8b6fa2975dd1dd2b$var$unsetSides);
    var _ref4 = roundOffsets === true ? $8b6fa2975dd1dd2b$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $e9739ce302fe3e63$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function $8b6fa2975dd1dd2b$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $3be2cafb7aeabb69$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $a384a6c8d9f4d558$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $8b6fa2975dd1dd2b$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $8b6fa2975dd1dd2b$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $8b6fa2975dd1dd2b$export$2e2bcd8739ae039 = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: $8b6fa2975dd1dd2b$var$computeStyles,
    data: {}
};



var $20665ae4d959ecd9$var$passive = {
    passive: true
};
function $20665ae4d959ecd9$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $e9739ce302fe3e63$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, $20665ae4d959ecd9$var$passive);
    });
    if (resize) window.addEventListener("resize", instance.update, $20665ae4d959ecd9$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, $20665ae4d959ecd9$var$passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, $20665ae4d959ecd9$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $20665ae4d959ecd9$export$2e2bcd8739ae039 = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: $20665ae4d959ecd9$var$effect,
    data: {}
};


var $052793b5c0639162$var$hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $052793b5c0639162$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $052793b5c0639162$var$hash[matched];
    });
}



var $c8765a8ac75b4201$var$hash = {
    start: "end",
    end: "start"
};
function $c8765a8ac75b4201$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $c8765a8ac75b4201$var$hash[matched];
    });
}








function $35dddb2950392a89$export$2e2bcd8739ae039(node) {
    var win = (0, $e9739ce302fe3e63$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}


function $d5facbef27268915$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $66156c3b080bccf4$export$2e2bcd8739ae039)((0, $d59d162ed38ceeb0$export$2e2bcd8739ae039)(element)).left + (0, $35dddb2950392a89$export$2e2bcd8739ae039)(element).scrollLeft;
}



function $ae647867d2b99080$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $e9739ce302fe3e63$export$2e2bcd8739ae039)(element);
    var html = (0, $d59d162ed38ceeb0$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $e0553216fd185806$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $d5facbef27268915$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $40908a89358ca070$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $d59d162ed38ceeb0$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $35dddb2950392a89$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $d970f1420390d5ed$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $d970f1420390d5ed$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $d5facbef27268915$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $78dd59933addbcc0$export$2e2bcd8739ae039)(body || html).direction === "rtl") x += (0, $d970f1420390d5ed$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}




function $c346468fde803bb7$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $78dd59933addbcc0$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}




function $076456ef5b74dfbd$export$2e2bcd8739ae039(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, $f320ee6316f9873f$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $efe52269b1e87572$export$1b3bfaa9684536aa)(node) && (0, $c346468fde803bb7$export$2e2bcd8739ae039)(node)) return node;
    return $076456ef5b74dfbd$export$2e2bcd8739ae039((0, $7897def57db13767$export$2e2bcd8739ae039)(node));
}





function $32e0bc370e575f94$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $076456ef5b74dfbd$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $e9739ce302fe3e63$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $c346468fde803bb7$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($32e0bc370e575f94$export$2e2bcd8739ae039((0, $7897def57db13767$export$2e2bcd8739ae039)(target)));
}










function $6db50f33ca8a272f$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $c67a2db688d0a63c$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $66156c3b080bccf4$export$2e2bcd8739ae039)(element, false, strategy === "fixed");
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $c67a2db688d0a63c$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $2f59803f89522976$export$d7b7311ec04a3e8f) ? (0, $6db50f33ca8a272f$export$2e2bcd8739ae039)((0, $ae647867d2b99080$export$2e2bcd8739ae039)(element, strategy)) : (0, $efe52269b1e87572$export$45a5e7f76e0caa8d)(clippingParent) ? $c67a2db688d0a63c$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $6db50f33ca8a272f$export$2e2bcd8739ae039)((0, $40908a89358ca070$export$2e2bcd8739ae039)((0, $d59d162ed38ceeb0$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $c67a2db688d0a63c$var$getClippingParents(element) {
    var clippingParents = (0, $32e0bc370e575f94$export$2e2bcd8739ae039)((0, $7897def57db13767$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, $78dd59933addbcc0$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $efe52269b1e87572$export$1b3bfaa9684536aa)(element) ? (0, $de89146f198bb093$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $efe52269b1e87572$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $efe52269b1e87572$export$45a5e7f76e0caa8d)(clippingParent) && (0, $60a8c5b725f322f9$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $f320ee6316f9873f$export$2e2bcd8739ae039)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function $c67a2db688d0a63c$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? $c67a2db688d0a63c$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $c67a2db688d0a63c$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $d970f1420390d5ed$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $d970f1420390d5ed$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $d970f1420390d5ed$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $d970f1420390d5ed$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $c67a2db688d0a63c$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $3985db0bfe4e7e4a$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $3be2cafb7aeabb69$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $a384a6c8d9f4d558$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $2f59803f89522976$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $2f59803f89522976$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $2f59803f89522976$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $2f59803f89522976$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $9ed2f87291fd3f71$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, $2f59803f89522976$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $2f59803f89522976$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}







function $d41178d4bf911711$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $2f59803f89522976$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $2f59803f89522976$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $2f59803f89522976$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $c59e528685f0af1a$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $7cb803e0a6e6306b$export$2e2bcd8739ae039)(padding, (0, $2f59803f89522976$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $2f59803f89522976$export$ae5ab1c730825774) ? (0, $2f59803f89522976$export$ca50aac9f3ba507f) : (0, $2f59803f89522976$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $c67a2db688d0a63c$export$2e2bcd8739ae039)((0, $efe52269b1e87572$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $d59d162ed38ceeb0$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $66156c3b080bccf4$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $3985db0bfe4e7e4a$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, $6db50f33ca8a272f$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $2f59803f89522976$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $2f59803f89522976$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $2f59803f89522976$export$79ffe56a765070d2),
                (0, $2f59803f89522976$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $2f59803f89522976$export$1e95b668f3b82d),
                (0, $2f59803f89522976$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $227221ef39e80585$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $2f59803f89522976$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $a384a6c8d9f4d558$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $2f59803f89522976$export$368f9a87e87fa4e1) : (0, $2f59803f89522976$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $a384a6c8d9f4d558$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $2f59803f89522976$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $d41178d4bf911711$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $3be2cafb7aeabb69$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $42bca5ede95de35f$var$getExpandedFallbackPlacements(placement) {
    if ((0, $3be2cafb7aeabb69$export$2e2bcd8739ae039)(placement) === (0, $2f59803f89522976$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $052793b5c0639162$export$2e2bcd8739ae039)(placement);
    return [
        (0, $c8765a8ac75b4201$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $c8765a8ac75b4201$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $42bca5ede95de35f$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $3be2cafb7aeabb69$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $052793b5c0639162$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $42bca5ede95de35f$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $3be2cafb7aeabb69$export$2e2bcd8739ae039)(placement) === (0, $2f59803f89522976$export$dfb5619354ba860) ? (0, $227221ef39e80585$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $3be2cafb7aeabb69$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $a384a6c8d9f4d558$export$2e2bcd8739ae039)(placement) === (0, $2f59803f89522976$export$b3571188c770cc5a);
        var isVertical = [
            (0, $2f59803f89522976$export$1e95b668f3b82d),
            (0, $2f59803f89522976$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, $d41178d4bf911711$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $2f59803f89522976$export$79ffe56a765070d2) : (0, $2f59803f89522976$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $2f59803f89522976$export$40e543e69a8b3fbb) : (0, $2f59803f89522976$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $052793b5c0639162$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $052793b5c0639162$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $42bca5ede95de35f$export$2e2bcd8739ae039 = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: $42bca5ede95de35f$var$flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};




function $ebe5ac00848ee6c4$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $ebe5ac00848ee6c4$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $2f59803f89522976$export$1e95b668f3b82d),
        (0, $2f59803f89522976$export$79ffe56a765070d2),
        (0, $2f59803f89522976$export$40e543e69a8b3fbb),
        (0, $2f59803f89522976$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $ebe5ac00848ee6c4$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $d41178d4bf911711$export$2e2bcd8739ae039)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, $d41178d4bf911711$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $ebe5ac00848ee6c4$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $ebe5ac00848ee6c4$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $ebe5ac00848ee6c4$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $ebe5ac00848ee6c4$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $ebe5ac00848ee6c4$export$2e2bcd8739ae039 = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: $ebe5ac00848ee6c4$var$hide
};




function $49d6ab7fc3ac4e58$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $3be2cafb7aeabb69$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $2f59803f89522976$export$eabcd2c8791e7bf4),
        (0, $2f59803f89522976$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $2f59803f89522976$export$eabcd2c8791e7bf4),
        (0, $2f59803f89522976$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $49d6ab7fc3ac4e58$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $2f59803f89522976$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $49d6ab7fc3ac4e58$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $49d6ab7fc3ac4e58$export$2e2bcd8739ae039 = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: $49d6ab7fc3ac4e58$var$offset
};



function $f7fbca4d6ede30c1$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $3985db0bfe4e7e4a$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $f7fbca4d6ede30c1$export$2e2bcd8739ae039 = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: $f7fbca4d6ede30c1$var$popperOffsets,
    data: {}
};





function $ae09d9783e643576$export$2e2bcd8739ae039(axis) {
    return axis === "x" ? "y" : "x";
}









function $6da8693f631c6665$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $d41178d4bf911711$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $3be2cafb7aeabb69$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $a384a6c8d9f4d558$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $9ed2f87291fd3f71$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $ae09d9783e643576$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, $2f59803f89522976$export$1e95b668f3b82d) : (0, $2f59803f89522976$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === "y" ? (0, $2f59803f89522976$export$40e543e69a8b3fbb) : (0, $2f59803f89522976$export$79ffe56a765070d2);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $2f59803f89522976$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $2f59803f89522976$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $961bfa09123cc0c3$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, $f3e24be1f4c121fd$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $48fe11e390a7ae46$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $de89146f198bb093$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $48fe11e390a7ae46$export$f28d906d67a997f3)(tether ? (0, $d970f1420390d5ed$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $d970f1420390d5ed$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, $2f59803f89522976$export$1e95b668f3b82d) : (0, $2f59803f89522976$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === "x" ? (0, $2f59803f89522976$export$40e543e69a8b3fbb) : (0, $2f59803f89522976$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $2f59803f89522976$export$1e95b668f3b82d),
            (0, $2f59803f89522976$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $48fe11e390a7ae46$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $48fe11e390a7ae46$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $6da8693f631c6665$export$2e2bcd8739ae039 = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: $6da8693f631c6665$var$preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};








function $f41ae6ef763bc42b$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $7e4c51f73247d573$export$2e2bcd8739ae039(node) {
    if (node === (0, $e9739ce302fe3e63$export$2e2bcd8739ae039)(node) || !(0, $efe52269b1e87572$export$1b3bfaa9684536aa)(node)) return (0, $35dddb2950392a89$export$2e2bcd8739ae039)(node);
    else return (0, $f41ae6ef763bc42b$export$2e2bcd8739ae039)(node);
}








function $121edbfac9b4f9aa$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $d970f1420390d5ed$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $d970f1420390d5ed$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $121edbfac9b4f9aa$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $efe52269b1e87572$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $efe52269b1e87572$export$1b3bfaa9684536aa)(offsetParent) && $121edbfac9b4f9aa$var$isElementScaled(offsetParent);
    var documentElement = (0, $d59d162ed38ceeb0$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $66156c3b080bccf4$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $f320ee6316f9873f$export$2e2bcd8739ae039)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, $c346468fde803bb7$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $7e4c51f73247d573$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $efe52269b1e87572$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $66156c3b080bccf4$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $d5facbef27268915$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}






function $799a189392c45cd3$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $799a189392c45cd3$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $799a189392c45cd3$var$order(modifiers); // order based on phase
    return (0, $2f59803f89522976$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $d2a1a2cf898c761e$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $eb7ed5be8ed6bee8$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $274bc1182b81f938$var$DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function $274bc1182b81f938$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function $274bc1182b81f938$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $274bc1182b81f938$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, $274bc1182b81f938$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $efe52269b1e87572$export$45a5e7f76e0caa8d)(reference) ? (0, $32e0bc370e575f94$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $32e0bc370e575f94$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $32e0bc370e575f94$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $799a189392c45cd3$export$2e2bcd8739ae039)((0, $eb7ed5be8ed6bee8$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$274bc1182b81f938$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $121edbfac9b4f9aa$export$2e2bcd8739ae039)(reference, (0, $de89146f198bb093$export$2e2bcd8739ae039)(popper), state.options.strategy === "fixed"),
                    popper: (0, $961bfa09123cc0c3$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $d2a1a2cf898c761e$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$274bc1182b81f938$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $274bc1182b81f938$export$8f7491d57c8f97a9 = /*#__PURE__*/ $274bc1182b81f938$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules














var $4778e0b6040e2f98$export$d34966752335dd47 = [
    (0, $20665ae4d959ecd9$export$2e2bcd8739ae039),
    (0, $f7fbca4d6ede30c1$export$2e2bcd8739ae039),
    (0, $8b6fa2975dd1dd2b$export$2e2bcd8739ae039),
    (0, $b73519959eb6f577$export$2e2bcd8739ae039),
    (0, $49d6ab7fc3ac4e58$export$2e2bcd8739ae039),
    (0, $42bca5ede95de35f$export$2e2bcd8739ae039),
    (0, $6da8693f631c6665$export$2e2bcd8739ae039),
    (0, $ae88eef85e3ee67c$export$2e2bcd8739ae039),
    (0, $ebe5ac00848ee6c4$export$2e2bcd8739ae039)
];
var $4778e0b6040e2f98$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $274bc1182b81f938$export$ed5e13716264f202)({
    defaultModifiers: $4778e0b6040e2f98$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules







var $f689e912e865fa89$export$d34966752335dd47 = [
    (0, $20665ae4d959ecd9$export$2e2bcd8739ae039),
    (0, $f7fbca4d6ede30c1$export$2e2bcd8739ae039),
    (0, $8b6fa2975dd1dd2b$export$2e2bcd8739ae039),
    (0, $b73519959eb6f577$export$2e2bcd8739ae039)
];
var $f689e912e865fa89$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $274bc1182b81f938$export$ed5e13716264f202)({
    defaultModifiers: $f689e912e865fa89$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules


$parcel$exportWildcard($adf6c43f8c27fe04$exports, $2f59803f89522976$exports);
$parcel$exportWildcard($adf6c43f8c27fe04$exports, $4de021c4d26d7927$exports);


/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/data.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $8560031dd706a122$var$elementMap = new Map();
const $8560031dd706a122$var$Data = {
    set (element, key, instance) {
        if (!$8560031dd706a122$var$elementMap.has(element)) $8560031dd706a122$var$elementMap.set(element, new Map());
        const instanceMap = $8560031dd706a122$var$elementMap.get(element);
        // make it clear we only want one instance per element
        // can be removed later when multiple key/instances are fine to be used
        if (!instanceMap.has(key) && instanceMap.size !== 0) {
            // eslint-disable-next-line no-console
            console.error(`Bootstrap doesn't allow more than one instance per element. Bound instance: ${Array.from(instanceMap.keys())[0]}.`);
            return;
        }
        instanceMap.set(key, instance);
    },
    get (element, key) {
        if ($8560031dd706a122$var$elementMap.has(element)) return $8560031dd706a122$var$elementMap.get(element).get(key) || null;
        return null;
    },
    remove (element, key) {
        if (!$8560031dd706a122$var$elementMap.has(element)) return;
        const instanceMap = $8560031dd706a122$var$elementMap.get(element);
        instanceMap.delete(key);
        // free up element references if there are no instances left for an element
        if (instanceMap.size === 0) $8560031dd706a122$var$elementMap.delete(element);
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/index.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $8560031dd706a122$var$MAX_UID = 1000000;
const $8560031dd706a122$var$MILLISECONDS_MULTIPLIER = 1000;
const $8560031dd706a122$var$TRANSITION_END = "transitionend";
/**
 * Properly escape IDs selectors to handle weird IDs
 * @param {string} selector
 * @returns {string}
 */ const $8560031dd706a122$var$parseSelector = (selector)=>{
    if (selector && window.CSS && window.CSS.escape) // document.querySelector needs escaping to handle IDs (html5+) containing for instance /
    selector = selector.replace(/#([^\s"#']+)/g, (match, id)=>`#${CSS.escape(id)}`);
    return selector;
};
// Shout-out Angus Croll (https://goo.gl/pxwQGp)
const $8560031dd706a122$var$toType = (object)=>{
    if (object === null || object === undefined) return `${object}`;
    return Object.prototype.toString.call(object).match(/\s([a-z]+)/i)[1].toLowerCase();
};
/**
 * Public Util API
 */ const $8560031dd706a122$var$getUID = (prefix)=>{
    do prefix += Math.floor(Math.random() * $8560031dd706a122$var$MAX_UID);
    while (document.getElementById(prefix));
    return prefix;
};
const $8560031dd706a122$var$getTransitionDurationFromElement = (element)=>{
    if (!element) return 0;
    // Get transition-duration of the element
    let { transitionDuration: transitionDuration, transitionDelay: transitionDelay } = window.getComputedStyle(element);
    const floatTransitionDuration = Number.parseFloat(transitionDuration);
    const floatTransitionDelay = Number.parseFloat(transitionDelay);
    // Return 0 if element or transition duration is not found
    if (!floatTransitionDuration && !floatTransitionDelay) return 0;
    // If multiple durations are defined, take the first
    transitionDuration = transitionDuration.split(",")[0];
    transitionDelay = transitionDelay.split(",")[0];
    return (Number.parseFloat(transitionDuration) + Number.parseFloat(transitionDelay)) * $8560031dd706a122$var$MILLISECONDS_MULTIPLIER;
};
const $8560031dd706a122$var$triggerTransitionEnd = (element)=>{
    element.dispatchEvent(new Event($8560031dd706a122$var$TRANSITION_END));
};
const $8560031dd706a122$var$isElement = (object)=>{
    if (!object || typeof object !== "object") return false;
    if (typeof object.jquery !== "undefined") object = object[0];
    return typeof object.nodeType !== "undefined";
};
const $8560031dd706a122$var$getElement = (object)=>{
    // it's a jQuery object or a node element
    if ($8560031dd706a122$var$isElement(object)) return object.jquery ? object[0] : object;
    if (typeof object === "string" && object.length > 0) return document.querySelector($8560031dd706a122$var$parseSelector(object));
    return null;
};
const $8560031dd706a122$var$isVisible = (element)=>{
    if (!$8560031dd706a122$var$isElement(element) || element.getClientRects().length === 0) return false;
    const elementIsVisible = getComputedStyle(element).getPropertyValue("visibility") === "visible";
    // Handle `details` element as its content may falsie appear visible when it is closed
    const closedDetails = element.closest("details:not([open])");
    if (!closedDetails) return elementIsVisible;
    if (closedDetails !== element) {
        const summary = element.closest("summary");
        if (summary && summary.parentNode !== closedDetails) return false;
        if (summary === null) return false;
    }
    return elementIsVisible;
};
const $8560031dd706a122$var$isDisabled = (element)=>{
    if (!element || element.nodeType !== Node.ELEMENT_NODE) return true;
    if (element.classList.contains("disabled")) return true;
    if (typeof element.disabled !== "undefined") return element.disabled;
    return element.hasAttribute("disabled") && element.getAttribute("disabled") !== "false";
};
const $8560031dd706a122$var$findShadowRoot = (element)=>{
    if (!document.documentElement.attachShadow) return null;
    // Can find the shadow root otherwise it'll return the document
    if (typeof element.getRootNode === "function") {
        const root = element.getRootNode();
        return root instanceof ShadowRoot ? root : null;
    }
    if (element instanceof ShadowRoot) return element;
    // when we don't find a shadow root
    if (!element.parentNode) return null;
    return $8560031dd706a122$var$findShadowRoot(element.parentNode);
};
const $8560031dd706a122$var$noop = ()=>{};
/**
 * Trick to restart an element's animation
 *
 * @param {HTMLElement} element
 * @return void
 *
 * @see https://www.charistheo.io/blog/2021/02/restart-a-css-animation-with-javascript/#restarting-a-css-animation
 */ const $8560031dd706a122$var$reflow = (element)=>{
    element.offsetHeight; // eslint-disable-line no-unused-expressions
};
const $8560031dd706a122$var$getjQuery = ()=>{
    if (window.jQuery && !document.body.hasAttribute("data-bs-no-jquery")) return window.jQuery;
    return null;
};
const $8560031dd706a122$var$DOMContentLoadedCallbacks = [];
const $8560031dd706a122$var$onDOMContentLoaded = (callback)=>{
    if (document.readyState === "loading") {
        // add listener on the first call when the document is in loading state
        if (!$8560031dd706a122$var$DOMContentLoadedCallbacks.length) document.addEventListener("DOMContentLoaded", ()=>{
            for (const callback of $8560031dd706a122$var$DOMContentLoadedCallbacks)callback();
        });
        $8560031dd706a122$var$DOMContentLoadedCallbacks.push(callback);
    } else callback();
};
const $8560031dd706a122$var$isRTL = ()=>document.documentElement.dir === "rtl";
const $8560031dd706a122$var$defineJQueryPlugin = (plugin)=>{
    $8560031dd706a122$var$onDOMContentLoaded(()=>{
        const $ = $8560031dd706a122$var$getjQuery();
        /* istanbul ignore if */ if ($) {
            const name = plugin.NAME;
            const JQUERY_NO_CONFLICT = $.fn[name];
            $.fn[name] = plugin.jQueryInterface;
            $.fn[name].Constructor = plugin;
            $.fn[name].noConflict = ()=>{
                $.fn[name] = JQUERY_NO_CONFLICT;
                return plugin.jQueryInterface;
            };
        }
    });
};
const $8560031dd706a122$var$execute = (possibleCallback, args = [], defaultValue = possibleCallback)=>{
    return typeof possibleCallback === "function" ? possibleCallback(...args) : defaultValue;
};
const $8560031dd706a122$var$executeAfterTransition = (callback, transitionElement, waitForTransition = true)=>{
    if (!waitForTransition) {
        $8560031dd706a122$var$execute(callback);
        return;
    }
    const durationPadding = 5;
    const emulatedDuration = $8560031dd706a122$var$getTransitionDurationFromElement(transitionElement) + durationPadding;
    let called = false;
    const handler = ({ target: target })=>{
        if (target !== transitionElement) return;
        called = true;
        transitionElement.removeEventListener($8560031dd706a122$var$TRANSITION_END, handler);
        $8560031dd706a122$var$execute(callback);
    };
    transitionElement.addEventListener($8560031dd706a122$var$TRANSITION_END, handler);
    setTimeout(()=>{
        if (!called) $8560031dd706a122$var$triggerTransitionEnd(transitionElement);
    }, emulatedDuration);
};
/**
 * Return the previous/next element of a list.
 *
 * @param {array} list    The list of elements
 * @param activeElement   The active element
 * @param shouldGetNext   Choose to get next or previous element
 * @param isCycleAllowed
 * @return {Element|elem} The proper element
 */ const $8560031dd706a122$var$getNextActiveElement = (list, activeElement, shouldGetNext, isCycleAllowed)=>{
    const listLength = list.length;
    let index = list.indexOf(activeElement);
    // if the element does not exist in the list return an element
    // depending on the direction and if cycle is allowed
    if (index === -1) return !shouldGetNext && isCycleAllowed ? list[listLength - 1] : list[0];
    index += shouldGetNext ? 1 : -1;
    if (isCycleAllowed) index = (index + listLength) % listLength;
    return list[Math.max(0, Math.min(index, listLength - 1))];
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/event-handler.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $8560031dd706a122$var$namespaceRegex = /[^.]*(?=\..*)\.|.*/;
const $8560031dd706a122$var$stripNameRegex = /\..*/;
const $8560031dd706a122$var$stripUidRegex = /::\d+$/;
const $8560031dd706a122$var$eventRegistry = {}; // Events storage
let $8560031dd706a122$var$uidEvent = 1;
const $8560031dd706a122$var$customEvents = {
    mouseenter: "mouseover",
    mouseleave: "mouseout"
};
const $8560031dd706a122$var$nativeEvents = new Set([
    "click",
    "dblclick",
    "mouseup",
    "mousedown",
    "contextmenu",
    "mousewheel",
    "DOMMouseScroll",
    "mouseover",
    "mouseout",
    "mousemove",
    "selectstart",
    "selectend",
    "keydown",
    "keypress",
    "keyup",
    "orientationchange",
    "touchstart",
    "touchmove",
    "touchend",
    "touchcancel",
    "pointerdown",
    "pointermove",
    "pointerup",
    "pointerleave",
    "pointercancel",
    "gesturestart",
    "gesturechange",
    "gestureend",
    "focus",
    "blur",
    "change",
    "reset",
    "select",
    "submit",
    "focusin",
    "focusout",
    "load",
    "unload",
    "beforeunload",
    "resize",
    "move",
    "DOMContentLoaded",
    "readystatechange",
    "error",
    "abort",
    "scroll"
]);
/**
 * Private methods
 */ function $8560031dd706a122$var$makeEventUid(element, uid) {
    return uid && `${uid}::${$8560031dd706a122$var$uidEvent++}` || element.uidEvent || $8560031dd706a122$var$uidEvent++;
}
function $8560031dd706a122$var$getElementEvents(element) {
    const uid = $8560031dd706a122$var$makeEventUid(element);
    element.uidEvent = uid;
    $8560031dd706a122$var$eventRegistry[uid] = $8560031dd706a122$var$eventRegistry[uid] || {};
    return $8560031dd706a122$var$eventRegistry[uid];
}
function $8560031dd706a122$var$bootstrapHandler(element, fn) {
    return function handler(event) {
        $8560031dd706a122$var$hydrateObj(event, {
            delegateTarget: element
        });
        if (handler.oneOff) $8560031dd706a122$var$EventHandler.off(element, event.type, fn);
        return fn.apply(element, [
            event
        ]);
    };
}
function $8560031dd706a122$var$bootstrapDelegationHandler(element, selector, fn) {
    return function handler(event) {
        const domElements = element.querySelectorAll(selector);
        for(let { target: target } = event; target && target !== this; target = target.parentNode)for (const domElement of domElements){
            if (domElement !== target) continue;
            $8560031dd706a122$var$hydrateObj(event, {
                delegateTarget: target
            });
            if (handler.oneOff) $8560031dd706a122$var$EventHandler.off(element, event.type, selector, fn);
            return fn.apply(target, [
                event
            ]);
        }
    };
}
function $8560031dd706a122$var$findHandler(events, callable, delegationSelector = null) {
    return Object.values(events).find((event)=>event.callable === callable && event.delegationSelector === delegationSelector);
}
function $8560031dd706a122$var$normalizeParameters(originalTypeEvent, handler, delegationFunction) {
    const isDelegated = typeof handler === "string";
    // TODO: tooltip passes `false` instead of selector, so we need to check
    const callable = isDelegated ? delegationFunction : handler || delegationFunction;
    let typeEvent = $8560031dd706a122$var$getTypeEvent(originalTypeEvent);
    if (!$8560031dd706a122$var$nativeEvents.has(typeEvent)) typeEvent = originalTypeEvent;
    return [
        isDelegated,
        callable,
        typeEvent
    ];
}
function $8560031dd706a122$var$addHandler(element, originalTypeEvent, handler, delegationFunction, oneOff) {
    if (typeof originalTypeEvent !== "string" || !element) return;
    let [isDelegated, callable, typeEvent] = $8560031dd706a122$var$normalizeParameters(originalTypeEvent, handler, delegationFunction);
    // in case of mouseenter or mouseleave wrap the handler within a function that checks for its DOM position
    // this prevents the handler from being dispatched the same way as mouseover or mouseout does
    if (originalTypeEvent in $8560031dd706a122$var$customEvents) {
        const wrapFunction = (fn)=>{
            return function(event) {
                if (!event.relatedTarget || event.relatedTarget !== event.delegateTarget && !event.delegateTarget.contains(event.relatedTarget)) return fn.call(this, event);
            };
        };
        callable = wrapFunction(callable);
    }
    const events = $8560031dd706a122$var$getElementEvents(element);
    const handlers = events[typeEvent] || (events[typeEvent] = {});
    const previousFunction = $8560031dd706a122$var$findHandler(handlers, callable, isDelegated ? handler : null);
    if (previousFunction) {
        previousFunction.oneOff = previousFunction.oneOff && oneOff;
        return;
    }
    const uid = $8560031dd706a122$var$makeEventUid(callable, originalTypeEvent.replace($8560031dd706a122$var$namespaceRegex, ""));
    const fn = isDelegated ? $8560031dd706a122$var$bootstrapDelegationHandler(element, handler, callable) : $8560031dd706a122$var$bootstrapHandler(element, callable);
    fn.delegationSelector = isDelegated ? handler : null;
    fn.callable = callable;
    fn.oneOff = oneOff;
    fn.uidEvent = uid;
    handlers[uid] = fn;
    element.addEventListener(typeEvent, fn, isDelegated);
}
function $8560031dd706a122$var$removeHandler(element, events, typeEvent, handler, delegationSelector) {
    const fn = $8560031dd706a122$var$findHandler(events[typeEvent], handler, delegationSelector);
    if (!fn) return;
    element.removeEventListener(typeEvent, fn, Boolean(delegationSelector));
    delete events[typeEvent][fn.uidEvent];
}
function $8560031dd706a122$var$removeNamespacedHandlers(element, events, typeEvent, namespace) {
    const storeElementEvent = events[typeEvent] || {};
    for (const [handlerKey, event] of Object.entries(storeElementEvent))if (handlerKey.includes(namespace)) $8560031dd706a122$var$removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
}
function $8560031dd706a122$var$getTypeEvent(event) {
    // allow to get the native events from namespaced events ('click.bs.button' --> 'click')
    event = event.replace($8560031dd706a122$var$stripNameRegex, "");
    return $8560031dd706a122$var$customEvents[event] || event;
}
const $8560031dd706a122$var$EventHandler = {
    on (element, event, handler, delegationFunction) {
        $8560031dd706a122$var$addHandler(element, event, handler, delegationFunction, false);
    },
    one (element, event, handler, delegationFunction) {
        $8560031dd706a122$var$addHandler(element, event, handler, delegationFunction, true);
    },
    off (element, originalTypeEvent, handler, delegationFunction) {
        if (typeof originalTypeEvent !== "string" || !element) return;
        const [isDelegated, callable, typeEvent] = $8560031dd706a122$var$normalizeParameters(originalTypeEvent, handler, delegationFunction);
        const inNamespace = typeEvent !== originalTypeEvent;
        const events = $8560031dd706a122$var$getElementEvents(element);
        const storeElementEvent = events[typeEvent] || {};
        const isNamespace = originalTypeEvent.startsWith(".");
        if (typeof callable !== "undefined") {
            // Simplest case: handler is passed, remove that listener ONLY.
            if (!Object.keys(storeElementEvent).length) return;
            $8560031dd706a122$var$removeHandler(element, events, typeEvent, callable, isDelegated ? handler : null);
            return;
        }
        if (isNamespace) for (const elementEvent of Object.keys(events))$8560031dd706a122$var$removeNamespacedHandlers(element, events, elementEvent, originalTypeEvent.slice(1));
        for (const [keyHandlers, event] of Object.entries(storeElementEvent)){
            const handlerKey = keyHandlers.replace($8560031dd706a122$var$stripUidRegex, "");
            if (!inNamespace || originalTypeEvent.includes(handlerKey)) $8560031dd706a122$var$removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
        }
    },
    trigger (element, event, args) {
        if (typeof event !== "string" || !element) return null;
        const $ = $8560031dd706a122$var$getjQuery();
        const typeEvent = $8560031dd706a122$var$getTypeEvent(event);
        const inNamespace = event !== typeEvent;
        let jQueryEvent = null;
        let bubbles = true;
        let nativeDispatch = true;
        let defaultPrevented = false;
        if (inNamespace && $) {
            jQueryEvent = $.Event(event, args);
            $(element).trigger(jQueryEvent);
            bubbles = !jQueryEvent.isPropagationStopped();
            nativeDispatch = !jQueryEvent.isImmediatePropagationStopped();
            defaultPrevented = jQueryEvent.isDefaultPrevented();
        }
        const evt = $8560031dd706a122$var$hydrateObj(new Event(event, {
            bubbles: bubbles,
            cancelable: true
        }), args);
        if (defaultPrevented) evt.preventDefault();
        if (nativeDispatch) element.dispatchEvent(evt);
        if (evt.defaultPrevented && jQueryEvent) jQueryEvent.preventDefault();
        return evt;
    }
};
function $8560031dd706a122$var$hydrateObj(obj, meta = {}) {
    for (const [key, value] of Object.entries(meta))try {
        obj[key] = value;
    } catch (_unused) {
        Object.defineProperty(obj, key, {
            configurable: true,
            get () {
                return value;
            }
        });
    }
    return obj;
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/manipulator.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ function $8560031dd706a122$var$normalizeData(value) {
    if (value === "true") return true;
    if (value === "false") return false;
    if (value === Number(value).toString()) return Number(value);
    if (value === "" || value === "null") return null;
    if (typeof value !== "string") return value;
    try {
        return JSON.parse(decodeURIComponent(value));
    } catch (_unused) {
        return value;
    }
}
function $8560031dd706a122$var$normalizeDataKey(key) {
    return key.replace(/[A-Z]/g, (chr)=>`-${chr.toLowerCase()}`);
}
const $8560031dd706a122$var$Manipulator = {
    setDataAttribute (element, key, value) {
        element.setAttribute(`data-bs-${$8560031dd706a122$var$normalizeDataKey(key)}`, value);
    },
    removeDataAttribute (element, key) {
        element.removeAttribute(`data-bs-${$8560031dd706a122$var$normalizeDataKey(key)}`);
    },
    getDataAttributes (element) {
        if (!element) return {};
        const attributes = {};
        const bsKeys = Object.keys(element.dataset).filter((key)=>key.startsWith("bs") && !key.startsWith("bsConfig"));
        for (const key of bsKeys){
            let pureKey = key.replace(/^bs/, "");
            pureKey = pureKey.charAt(0).toLowerCase() + pureKey.slice(1, pureKey.length);
            attributes[pureKey] = $8560031dd706a122$var$normalizeData(element.dataset[key]);
        }
        return attributes;
    },
    getDataAttribute (element, key) {
        return $8560031dd706a122$var$normalizeData(element.getAttribute(`data-bs-${$8560031dd706a122$var$normalizeDataKey(key)}`));
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/config.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Class definition
 */ class $8560031dd706a122$var$Config {
    // Getters
    static get Default() {
        return {};
    }
    static get DefaultType() {
        return {};
    }
    static get NAME() {
        throw new Error('You have to implement the static method "NAME", for each component!');
    }
    _getConfig(config) {
        config = this._mergeConfigObj(config);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    _configAfterMerge(config) {
        return config;
    }
    _mergeConfigObj(config, element) {
        const jsonConfig = $8560031dd706a122$var$isElement(element) ? $8560031dd706a122$var$Manipulator.getDataAttribute(element, "config") : {}; // try to parse
        return {
            ...this.constructor.Default,
            ...typeof jsonConfig === "object" ? jsonConfig : {},
            ...$8560031dd706a122$var$isElement(element) ? $8560031dd706a122$var$Manipulator.getDataAttributes(element) : {},
            ...typeof config === "object" ? config : {}
        };
    }
    _typeCheckConfig(config, configTypes = this.constructor.DefaultType) {
        for (const [property, expectedTypes] of Object.entries(configTypes)){
            const value = config[property];
            const valueType = $8560031dd706a122$var$isElement(value) ? "element" : $8560031dd706a122$var$toType(value);
            if (!new RegExp(expectedTypes).test(valueType)) throw new TypeError(`${this.constructor.NAME.toUpperCase()}: Option "${property}" provided type "${valueType}" but expected type "${expectedTypes}".`);
        }
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap base-component.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $8560031dd706a122$var$VERSION = "5.3.3";
/**
 * Class definition
 */ class $8560031dd706a122$var$BaseComponent extends $8560031dd706a122$var$Config {
    constructor(element, config){
        super();
        element = $8560031dd706a122$var$getElement(element);
        if (!element) return;
        this._element = element;
        this._config = this._getConfig(config);
        $8560031dd706a122$var$Data.set(this._element, this.constructor.DATA_KEY, this);
    }
    // Public
    dispose() {
        $8560031dd706a122$var$Data.remove(this._element, this.constructor.DATA_KEY);
        $8560031dd706a122$var$EventHandler.off(this._element, this.constructor.EVENT_KEY);
        for (const propertyName of Object.getOwnPropertyNames(this))this[propertyName] = null;
    }
    _queueCallback(callback, element, isAnimated = true) {
        $8560031dd706a122$var$executeAfterTransition(callback, element, isAnimated);
    }
    _getConfig(config) {
        config = this._mergeConfigObj(config, this._element);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    // Static
    static getInstance(element) {
        return $8560031dd706a122$var$Data.get($8560031dd706a122$var$getElement(element), this.DATA_KEY);
    }
    static getOrCreateInstance(element, config = {}) {
        return this.getInstance(element) || new this(element, typeof config === "object" ? config : null);
    }
    static get VERSION() {
        return $8560031dd706a122$var$VERSION;
    }
    static get DATA_KEY() {
        return `bs.${this.NAME}`;
    }
    static get EVENT_KEY() {
        return `.${this.DATA_KEY}`;
    }
    static eventName(name) {
        return `${name}${this.EVENT_KEY}`;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/selector-engine.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $8560031dd706a122$var$getSelector = (element)=>{
    let selector = element.getAttribute("data-bs-target");
    if (!selector || selector === "#") {
        let hrefAttribute = element.getAttribute("href");
        // The only valid content that could double as a selector are IDs or classes,
        // so everything starting with `#` or `.`. If a "real" URL is used as the selector,
        // `document.querySelector` will rightfully complain it is invalid.
        // See https://github.com/twbs/bootstrap/issues/32273
        if (!hrefAttribute || !hrefAttribute.includes("#") && !hrefAttribute.startsWith(".")) return null;
        // Just in case some CMS puts out a full URL with the anchor appended
        if (hrefAttribute.includes("#") && !hrefAttribute.startsWith("#")) hrefAttribute = `#${hrefAttribute.split("#")[1]}`;
        selector = hrefAttribute && hrefAttribute !== "#" ? hrefAttribute.trim() : null;
    }
    return selector ? selector.split(",").map((sel)=>$8560031dd706a122$var$parseSelector(sel)).join(",") : null;
};
const $8560031dd706a122$var$SelectorEngine = {
    find (selector, element = document.documentElement) {
        return [].concat(...Element.prototype.querySelectorAll.call(element, selector));
    },
    findOne (selector, element = document.documentElement) {
        return Element.prototype.querySelector.call(element, selector);
    },
    children (element, selector) {
        return [].concat(...element.children).filter((child)=>child.matches(selector));
    },
    parents (element, selector) {
        const parents = [];
        let ancestor = element.parentNode.closest(selector);
        while(ancestor){
            parents.push(ancestor);
            ancestor = ancestor.parentNode.closest(selector);
        }
        return parents;
    },
    prev (element, selector) {
        let previous = element.previousElementSibling;
        while(previous){
            if (previous.matches(selector)) return [
                previous
            ];
            previous = previous.previousElementSibling;
        }
        return [];
    },
    // TODO: this is now unused; remove later along with prev()
    next (element, selector) {
        let next = element.nextElementSibling;
        while(next){
            if (next.matches(selector)) return [
                next
            ];
            next = next.nextElementSibling;
        }
        return [];
    },
    focusableChildren (element) {
        const focusables = [
            "a",
            "button",
            "input",
            "textarea",
            "select",
            "details",
            "[tabindex]",
            '[contenteditable="true"]'
        ].map((selector)=>`${selector}:not([tabindex^="-"])`).join(",");
        return this.find(focusables, element).filter((el)=>!$8560031dd706a122$var$isDisabled(el) && $8560031dd706a122$var$isVisible(el));
    },
    getSelectorFromElement (element) {
        const selector = $8560031dd706a122$var$getSelector(element);
        if (selector) return $8560031dd706a122$var$SelectorEngine.findOne(selector) ? selector : null;
        return null;
    },
    getElementFromSelector (element) {
        const selector = $8560031dd706a122$var$getSelector(element);
        return selector ? $8560031dd706a122$var$SelectorEngine.findOne(selector) : null;
    },
    getMultipleElementsFromSelector (element) {
        const selector = $8560031dd706a122$var$getSelector(element);
        return selector ? $8560031dd706a122$var$SelectorEngine.find(selector) : [];
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/component-functions.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $8560031dd706a122$var$enableDismissTrigger = (component, method = "hide")=>{
    const clickEvent = `click.dismiss${component.EVENT_KEY}`;
    const name = component.NAME;
    $8560031dd706a122$var$EventHandler.on(document, clickEvent, `[data-bs-dismiss="${name}"]`, function(event) {
        if ([
            "A",
            "AREA"
        ].includes(this.tagName)) event.preventDefault();
        if ($8560031dd706a122$var$isDisabled(this)) return;
        const target = $8560031dd706a122$var$SelectorEngine.getElementFromSelector(this) || this.closest(`.${name}`);
        const instance = component.getOrCreateInstance(target);
        // Method argument is left, for Alert and only, as it doesn't implement the 'hide' method
        instance[method]();
    });
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap alert.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $8560031dd706a122$var$NAME$f = "alert";
const $8560031dd706a122$var$DATA_KEY$a = "bs.alert";
const $8560031dd706a122$var$EVENT_KEY$b = `.${$8560031dd706a122$var$DATA_KEY$a}`;
const $8560031dd706a122$var$EVENT_CLOSE = `close${$8560031dd706a122$var$EVENT_KEY$b}`;
const $8560031dd706a122$var$EVENT_CLOSED = `closed${$8560031dd706a122$var$EVENT_KEY$b}`;
const $8560031dd706a122$var$CLASS_NAME_FADE$5 = "fade";
const $8560031dd706a122$var$CLASS_NAME_SHOW$8 = "show";
/**
 * Class definition
 */ class $8560031dd706a122$export$caec2af78bcc877f extends $8560031dd706a122$var$BaseComponent {
    // Getters
    static get NAME() {
        return $8560031dd706a122$var$NAME$f;
    }
    // Public
    close() {
        const closeEvent = $8560031dd706a122$var$EventHandler.trigger(this._element, $8560031dd706a122$var$EVENT_CLOSE);
        if (closeEvent.defaultPrevented) return;
        this._element.classList.remove($8560031dd706a122$var$CLASS_NAME_SHOW$8);
        const isAnimated = this._element.classList.contains($8560031dd706a122$var$CLASS_NAME_FADE$5);
        this._queueCallback(()=>this._destroyElement(), this._element, isAnimated);
    }
    // Private
    _destroyElement() {
        this._element.remove();
        $8560031dd706a122$var$EventHandler.trigger(this._element, $8560031dd706a122$var$EVENT_CLOSED);
        this.dispose();
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $8560031dd706a122$export$caec2af78bcc877f.getOrCreateInstance(this);
            if (typeof config !== "string") return;
            if (data[config] === undefined || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
            data[config](this);
        });
    }
}
/**
 * Data API implementation
 */ $8560031dd706a122$var$enableDismissTrigger($8560031dd706a122$export$caec2af78bcc877f, "close");
/**
 * jQuery
 */ $8560031dd706a122$var$defineJQueryPlugin($8560031dd706a122$export$caec2af78bcc877f);
/**
 * --------------------------------------------------------------------------
 * Bootstrap button.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $8560031dd706a122$var$NAME$e = "button";
const $8560031dd706a122$var$DATA_KEY$9 = "bs.button";
const $8560031dd706a122$var$EVENT_KEY$a = `.${$8560031dd706a122$var$DATA_KEY$9}`;
const $8560031dd706a122$var$DATA_API_KEY$6 = ".data-api";
const $8560031dd706a122$var$CLASS_NAME_ACTIVE$3 = "active";
const $8560031dd706a122$var$SELECTOR_DATA_TOGGLE$5 = '[data-bs-toggle="button"]';
const $8560031dd706a122$var$EVENT_CLICK_DATA_API$6 = `click${$8560031dd706a122$var$EVENT_KEY$a}${$8560031dd706a122$var$DATA_API_KEY$6}`;
/**
 * Class definition
 */ class $8560031dd706a122$export$353f5b6fc5456de1 extends $8560031dd706a122$var$BaseComponent {
    // Getters
    static get NAME() {
        return $8560031dd706a122$var$NAME$e;
    }
    // Public
    toggle() {
        // Toggle class and sync the `aria-pressed` attribute with the return value of the `.toggle()` method
        this._element.setAttribute("aria-pressed", this._element.classList.toggle($8560031dd706a122$var$CLASS_NAME_ACTIVE$3));
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $8560031dd706a122$export$353f5b6fc5456de1.getOrCreateInstance(this);
            if (config === "toggle") data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $8560031dd706a122$var$EventHandler.on(document, $8560031dd706a122$var$EVENT_CLICK_DATA_API$6, $8560031dd706a122$var$SELECTOR_DATA_TOGGLE$5, (event)=>{
    event.preventDefault();
    const button = event.target.closest($8560031dd706a122$var$SELECTOR_DATA_TOGGLE$5);
    const data = $8560031dd706a122$export$353f5b6fc5456de1.getOrCreateInstance(button);
    data.toggle();
});
/**
 * jQuery
 */ $8560031dd706a122$var$defineJQueryPlugin($8560031dd706a122$export$353f5b6fc5456de1);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/swipe.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $8560031dd706a122$var$NAME$d = "swipe";
const $8560031dd706a122$var$EVENT_KEY$9 = ".bs.swipe";
const $8560031dd706a122$var$EVENT_TOUCHSTART = `touchstart${$8560031dd706a122$var$EVENT_KEY$9}`;
const $8560031dd706a122$var$EVENT_TOUCHMOVE = `touchmove${$8560031dd706a122$var$EVENT_KEY$9}`;
const $8560031dd706a122$var$EVENT_TOUCHEND = `touchend${$8560031dd706a122$var$EVENT_KEY$9}`;
const $8560031dd706a122$var$EVENT_POINTERDOWN = `pointerdown${$8560031dd706a122$var$EVENT_KEY$9}`;
const $8560031dd706a122$var$EVENT_POINTERUP = `pointerup${$8560031dd706a122$var$EVENT_KEY$9}`;
const $8560031dd706a122$var$POINTER_TYPE_TOUCH = "touch";
const $8560031dd706a122$var$POINTER_TYPE_PEN = "pen";
const $8560031dd706a122$var$CLASS_NAME_POINTER_EVENT = "pointer-event";
const $8560031dd706a122$var$SWIPE_THRESHOLD = 40;
const $8560031dd706a122$var$Default$c = {
    endCallback: null,
    leftCallback: null,
    rightCallback: null
};
const $8560031dd706a122$var$DefaultType$c = {
    endCallback: "(function|null)",
    leftCallback: "(function|null)",
    rightCallback: "(function|null)"
};
/**
 * Class definition
 */ class $8560031dd706a122$var$Swipe extends $8560031dd706a122$var$Config {
    constructor(element, config){
        super();
        this._element = element;
        if (!element || !$8560031dd706a122$var$Swipe.isSupported()) return;
        this._config = this._getConfig(config);
        this._deltaX = 0;
        this._supportPointerEvents = Boolean(window.PointerEvent);
        this._initEvents();
    }
    // Getters
    static get Default() {
        return $8560031dd706a122$var$Default$c;
    }
    static get DefaultType() {
        return $8560031dd706a122$var$DefaultType$c;
    }
    static get NAME() {
        return $8560031dd706a122$var$NAME$d;
    }
    // Public
    dispose() {
        $8560031dd706a122$var$EventHandler.off(this._element, $8560031dd706a122$var$EVENT_KEY$9);
    }
    // Private
    _start(event) {
        if (!this._supportPointerEvents) {
            this._deltaX = event.touches[0].clientX;
            return;
        }
        if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX;
    }
    _end(event) {
        if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX - this._deltaX;
        this._handleSwipe();
        $8560031dd706a122$var$execute(this._config.endCallback);
    }
    _move(event) {
        this._deltaX = event.touches && event.touches.length > 1 ? 0 : event.touches[0].clientX - this._deltaX;
    }
    _handleSwipe() {
        const absDeltaX = Math.abs(this._deltaX);
        if (absDeltaX <= $8560031dd706a122$var$SWIPE_THRESHOLD) return;
        const direction = absDeltaX / this._deltaX;
        this._deltaX = 0;
        if (!direction) return;
        $8560031dd706a122$var$execute(direction > 0 ? this._config.rightCallback : this._config.leftCallback);
    }
    _initEvents() {
        if (this._supportPointerEvents) {
            $8560031dd706a122$var$EventHandler.on(this._element, $8560031dd706a122$var$EVENT_POINTERDOWN, (event)=>this._start(event));
            $8560031dd706a122$var$EventHandler.on(this._element, $8560031dd706a122$var$EVENT_POINTERUP, (event)=>this._end(event));
            this._element.classList.add($8560031dd706a122$var$CLASS_NAME_POINTER_EVENT);
        } else {
            $8560031dd706a122$var$EventHandler.on(this._element, $8560031dd706a122$var$EVENT_TOUCHSTART, (event)=>this._start(event));
            $8560031dd706a122$var$EventHandler.on(this._element, $8560031dd706a122$var$EVENT_TOUCHMOVE, (event)=>this._move(event));
            $8560031dd706a122$var$EventHandler.on(this._element, $8560031dd706a122$var$EVENT_TOUCHEND, (event)=>this._end(event));
        }
    }
    _eventIsPointerPenTouch(event) {
        return this._supportPointerEvents && (event.pointerType === $8560031dd706a122$var$POINTER_TYPE_PEN || event.pointerType === $8560031dd706a122$var$POINTER_TYPE_TOUCH);
    }
    // Static
    static isSupported() {
        return "ontouchstart" in document.documentElement || navigator.maxTouchPoints > 0;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap carousel.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $8560031dd706a122$var$NAME$c = "carousel";
const $8560031dd706a122$var$DATA_KEY$8 = "bs.carousel";
const $8560031dd706a122$var$EVENT_KEY$8 = `.${$8560031dd706a122$var$DATA_KEY$8}`;
const $8560031dd706a122$var$DATA_API_KEY$5 = ".data-api";
const $8560031dd706a122$var$ARROW_LEFT_KEY$1 = "ArrowLeft";
const $8560031dd706a122$var$ARROW_RIGHT_KEY$1 = "ArrowRight";
const $8560031dd706a122$var$TOUCHEVENT_COMPAT_WAIT = 500; // Time for mouse compat events to fire after touch
const $8560031dd706a122$var$ORDER_NEXT = "next";
const $8560031dd706a122$var$ORDER_PREV = "prev";
const $8560031dd706a122$var$DIRECTION_LEFT = "left";
const $8560031dd706a122$var$DIRECTION_RIGHT = "right";
const $8560031dd706a122$var$EVENT_SLIDE = `slide${$8560031dd706a122$var$EVENT_KEY$8}`;
const $8560031dd706a122$var$EVENT_SLID = `slid${$8560031dd706a122$var$EVENT_KEY$8}`;
const $8560031dd706a122$var$EVENT_KEYDOWN$1 = `keydown${$8560031dd706a122$var$EVENT_KEY$8}`;
const $8560031dd706a122$var$EVENT_MOUSEENTER$1 = `mouseenter${$8560031dd706a122$var$EVENT_KEY$8}`;
const $8560031dd706a122$var$EVENT_MOUSELEAVE$1 = `mouseleave${$8560031dd706a122$var$EVENT_KEY$8}`;
const $8560031dd706a122$var$EVENT_DRAG_START = `dragstart${$8560031dd706a122$var$EVENT_KEY$8}`;
const $8560031dd706a122$var$EVENT_LOAD_DATA_API$3 = `load${$8560031dd706a122$var$EVENT_KEY$8}${$8560031dd706a122$var$DATA_API_KEY$5}`;
const $8560031dd706a122$var$EVENT_CLICK_DATA_API$5 = `click${$8560031dd706a122$var$EVENT_KEY$8}${$8560031dd706a122$var$DATA_API_KEY$5}`;
const $8560031dd706a122$var$CLASS_NAME_CAROUSEL = "carousel";
const $8560031dd706a122$var$CLASS_NAME_ACTIVE$2 = "active";
const $8560031dd706a122$var$CLASS_NAME_SLIDE = "slide";
const $8560031dd706a122$var$CLASS_NAME_END = "carousel-item-end";
const $8560031dd706a122$var$CLASS_NAME_START = "carousel-item-start";
const $8560031dd706a122$var$CLASS_NAME_NEXT = "carousel-item-next";
const $8560031dd706a122$var$CLASS_NAME_PREV = "carousel-item-prev";
const $8560031dd706a122$var$SELECTOR_ACTIVE = ".active";
const $8560031dd706a122$var$SELECTOR_ITEM = ".carousel-item";
const $8560031dd706a122$var$SELECTOR_ACTIVE_ITEM = $8560031dd706a122$var$SELECTOR_ACTIVE + $8560031dd706a122$var$SELECTOR_ITEM;
const $8560031dd706a122$var$SELECTOR_ITEM_IMG = ".carousel-item img";
const $8560031dd706a122$var$SELECTOR_INDICATORS = ".carousel-indicators";
const $8560031dd706a122$var$SELECTOR_DATA_SLIDE = "[data-bs-slide], [data-bs-slide-to]";
const $8560031dd706a122$var$SELECTOR_DATA_RIDE = '[data-bs-ride="carousel"]';
const $8560031dd706a122$var$KEY_TO_DIRECTION = {
    [$8560031dd706a122$var$ARROW_LEFT_KEY$1]: $8560031dd706a122$var$DIRECTION_RIGHT,
    [$8560031dd706a122$var$ARROW_RIGHT_KEY$1]: $8560031dd706a122$var$DIRECTION_LEFT
};
const $8560031dd706a122$var$Default$b = {
    interval: 5000,
    keyboard: true,
    pause: "hover",
    ride: false,
    touch: true,
    wrap: true
};
const $8560031dd706a122$var$DefaultType$b = {
    interval: "(number|boolean)",
    // TODO:v6 remove boolean support
    keyboard: "boolean",
    pause: "(string|boolean)",
    ride: "(boolean|string)",
    touch: "boolean",
    wrap: "boolean"
};
/**
 * Class definition
 */ class $8560031dd706a122$export$144901db2ea8e967 extends $8560031dd706a122$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._interval = null;
        this._activeElement = null;
        this._isSliding = false;
        this.touchTimeout = null;
        this._swipeHelper = null;
        this._indicatorsElement = $8560031dd706a122$var$SelectorEngine.findOne($8560031dd706a122$var$SELECTOR_INDICATORS, this._element);
        this._addEventListeners();
        if (this._config.ride === $8560031dd706a122$var$CLASS_NAME_CAROUSEL) this.cycle();
    }
    // Getters
    static get Default() {
        return $8560031dd706a122$var$Default$b;
    }
    static get DefaultType() {
        return $8560031dd706a122$var$DefaultType$b;
    }
    static get NAME() {
        return $8560031dd706a122$var$NAME$c;
    }
    // Public
    next() {
        this._slide($8560031dd706a122$var$ORDER_NEXT);
    }
    nextWhenVisible() {
        // FIXME TODO use `document.visibilityState`
        // Don't call next when the page isn't visible
        // or the carousel or its parent isn't visible
        if (!document.hidden && $8560031dd706a122$var$isVisible(this._element)) this.next();
    }
    prev() {
        this._slide($8560031dd706a122$var$ORDER_PREV);
    }
    pause() {
        if (this._isSliding) $8560031dd706a122$var$triggerTransitionEnd(this._element);
        this._clearInterval();
    }
    cycle() {
        this._clearInterval();
        this._updateInterval();
        this._interval = setInterval(()=>this.nextWhenVisible(), this._config.interval);
    }
    _maybeEnableCycle() {
        if (!this._config.ride) return;
        if (this._isSliding) {
            $8560031dd706a122$var$EventHandler.one(this._element, $8560031dd706a122$var$EVENT_SLID, ()=>this.cycle());
            return;
        }
        this.cycle();
    }
    to(index) {
        const items = this._getItems();
        if (index > items.length - 1 || index < 0) return;
        if (this._isSliding) {
            $8560031dd706a122$var$EventHandler.one(this._element, $8560031dd706a122$var$EVENT_SLID, ()=>this.to(index));
            return;
        }
        const activeIndex = this._getItemIndex(this._getActive());
        if (activeIndex === index) return;
        const order = index > activeIndex ? $8560031dd706a122$var$ORDER_NEXT : $8560031dd706a122$var$ORDER_PREV;
        this._slide(order, items[index]);
    }
    dispose() {
        if (this._swipeHelper) this._swipeHelper.dispose();
        super.dispose();
    }
    // Private
    _configAfterMerge(config) {
        config.defaultInterval = config.interval;
        return config;
    }
    _addEventListeners() {
        if (this._config.keyboard) $8560031dd706a122$var$EventHandler.on(this._element, $8560031dd706a122$var$EVENT_KEYDOWN$1, (event)=>this._keydown(event));
        if (this._config.pause === "hover") {
            $8560031dd706a122$var$EventHandler.on(this._element, $8560031dd706a122$var$EVENT_MOUSEENTER$1, ()=>this.pause());
            $8560031dd706a122$var$EventHandler.on(this._element, $8560031dd706a122$var$EVENT_MOUSELEAVE$1, ()=>this._maybeEnableCycle());
        }
        if (this._config.touch && $8560031dd706a122$var$Swipe.isSupported()) this._addTouchEventListeners();
    }
    _addTouchEventListeners() {
        for (const img of $8560031dd706a122$var$SelectorEngine.find($8560031dd706a122$var$SELECTOR_ITEM_IMG, this._element))$8560031dd706a122$var$EventHandler.on(img, $8560031dd706a122$var$EVENT_DRAG_START, (event)=>event.preventDefault());
        const endCallBack = ()=>{
            if (this._config.pause !== "hover") return;
            // If it's a touch-enabled device, mouseenter/leave are fired as
            // part of the mouse compatibility events on first tap - the carousel
            // would stop cycling until user tapped out of it;
            // here, we listen for touchend, explicitly pause the carousel
            // (as if it's the second time we tap on it, mouseenter compat event
            // is NOT fired) and after a timeout (to allow for mouse compatibility
            // events to fire) we explicitly restart cycling
            this.pause();
            if (this.touchTimeout) clearTimeout(this.touchTimeout);
            this.touchTimeout = setTimeout(()=>this._maybeEnableCycle(), $8560031dd706a122$var$TOUCHEVENT_COMPAT_WAIT + this._config.interval);
        };
        const swipeConfig = {
            leftCallback: ()=>this._slide(this._directionToOrder($8560031dd706a122$var$DIRECTION_LEFT)),
            rightCallback: ()=>this._slide(this._directionToOrder($8560031dd706a122$var$DIRECTION_RIGHT)),
            endCallback: endCallBack
        };
        this._swipeHelper = new $8560031dd706a122$var$Swipe(this._element, swipeConfig);
    }
    _keydown(event) {
        if (/input|textarea/i.test(event.target.tagName)) return;
        const direction = $8560031dd706a122$var$KEY_TO_DIRECTION[event.key];
        if (direction) {
            event.preventDefault();
            this._slide(this._directionToOrder(direction));
        }
    }
    _getItemIndex(element) {
        return this._getItems().indexOf(element);
    }
    _setActiveIndicatorElement(index) {
        if (!this._indicatorsElement) return;
        const activeIndicator = $8560031dd706a122$var$SelectorEngine.findOne($8560031dd706a122$var$SELECTOR_ACTIVE, this._indicatorsElement);
        activeIndicator.classList.remove($8560031dd706a122$var$CLASS_NAME_ACTIVE$2);
        activeIndicator.removeAttribute("aria-current");
        const newActiveIndicator = $8560031dd706a122$var$SelectorEngine.findOne(`[data-bs-slide-to="${index}"]`, this._indicatorsElement);
        if (newActiveIndicator) {
            newActiveIndicator.classList.add($8560031dd706a122$var$CLASS_NAME_ACTIVE$2);
            newActiveIndicator.setAttribute("aria-current", "true");
        }
    }
    _updateInterval() {
        const element = this._activeElement || this._getActive();
        if (!element) return;
        const elementInterval = Number.parseInt(element.getAttribute("data-bs-interval"), 10);
        this._config.interval = elementInterval || this._config.defaultInterval;
    }
    _slide(order, element = null) {
        if (this._isSliding) return;
        const activeElement = this._getActive();
        const isNext = order === $8560031dd706a122$var$ORDER_NEXT;
        const nextElement = element || $8560031dd706a122$var$getNextActiveElement(this._getItems(), activeElement, isNext, this._config.wrap);
        if (nextElement === activeElement) return;
        const nextElementIndex = this._getItemIndex(nextElement);
        const triggerEvent = (eventName)=>{
            return $8560031dd706a122$var$EventHandler.trigger(this._element, eventName, {
                relatedTarget: nextElement,
                direction: this._orderToDirection(order),
                from: this._getItemIndex(activeElement),
                to: nextElementIndex
            });
        };
        const slideEvent = triggerEvent($8560031dd706a122$var$EVENT_SLIDE);
        if (slideEvent.defaultPrevented) return;
        if (!activeElement || !nextElement) // Some weirdness is happening, so we bail
        // TODO: change tests that use empty divs to avoid this check
        return;
        const isCycling = Boolean(this._interval);
        this.pause();
        this._isSliding = true;
        this._setActiveIndicatorElement(nextElementIndex);
        this._activeElement = nextElement;
        const directionalClassName = isNext ? $8560031dd706a122$var$CLASS_NAME_START : $8560031dd706a122$var$CLASS_NAME_END;
        const orderClassName = isNext ? $8560031dd706a122$var$CLASS_NAME_NEXT : $8560031dd706a122$var$CLASS_NAME_PREV;
        nextElement.classList.add(orderClassName);
        $8560031dd706a122$var$reflow(nextElement);
        activeElement.classList.add(directionalClassName);
        nextElement.classList.add(directionalClassName);
        const completeCallBack = ()=>{
            nextElement.classList.remove(directionalClassName, orderClassName);
            nextElement.classList.add($8560031dd706a122$var$CLASS_NAME_ACTIVE$2);
            activeElement.classList.remove($8560031dd706a122$var$CLASS_NAME_ACTIVE$2, orderClassName, directionalClassName);
            this._isSliding = false;
            triggerEvent($8560031dd706a122$var$EVENT_SLID);
        };
        this._queueCallback(completeCallBack, activeElement, this._isAnimated());
        if (isCycling) this.cycle();
    }
    _isAnimated() {
        return this._element.classList.contains($8560031dd706a122$var$CLASS_NAME_SLIDE);
    }
    _getActive() {
        return $8560031dd706a122$var$SelectorEngine.findOne($8560031dd706a122$var$SELECTOR_ACTIVE_ITEM, this._element);
    }
    _getItems() {
        return $8560031dd706a122$var$SelectorEngine.find($8560031dd706a122$var$SELECTOR_ITEM, this._element);
    }
    _clearInterval() {
        if (this._interval) {
            clearInterval(this._interval);
            this._interval = null;
        }
    }
    _directionToOrder(direction) {
        if ($8560031dd706a122$var$isRTL()) return direction === $8560031dd706a122$var$DIRECTION_LEFT ? $8560031dd706a122$var$ORDER_PREV : $8560031dd706a122$var$ORDER_NEXT;
        return direction === $8560031dd706a122$var$DIRECTION_LEFT ? $8560031dd706a122$var$ORDER_NEXT : $8560031dd706a122$var$ORDER_PREV;
    }
    _orderToDirection(order) {
        if ($8560031dd706a122$var$isRTL()) return order === $8560031dd706a122$var$ORDER_PREV ? $8560031dd706a122$var$DIRECTION_LEFT : $8560031dd706a122$var$DIRECTION_RIGHT;
        return order === $8560031dd706a122$var$ORDER_PREV ? $8560031dd706a122$var$DIRECTION_RIGHT : $8560031dd706a122$var$DIRECTION_LEFT;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $8560031dd706a122$export$144901db2ea8e967.getOrCreateInstance(this, config);
            if (typeof config === "number") {
                data.to(config);
                return;
            }
            if (typeof config === "string") {
                if (data[config] === undefined || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
                data[config]();
            }
        });
    }
}
/**
 * Data API implementation
 */ $8560031dd706a122$var$EventHandler.on(document, $8560031dd706a122$var$EVENT_CLICK_DATA_API$5, $8560031dd706a122$var$SELECTOR_DATA_SLIDE, function(event) {
    const target = $8560031dd706a122$var$SelectorEngine.getElementFromSelector(this);
    if (!target || !target.classList.contains($8560031dd706a122$var$CLASS_NAME_CAROUSEL)) return;
    event.preventDefault();
    const carousel = $8560031dd706a122$export$144901db2ea8e967.getOrCreateInstance(target);
    const slideIndex = this.getAttribute("data-bs-slide-to");
    if (slideIndex) {
        carousel.to(slideIndex);
        carousel._maybeEnableCycle();
        return;
    }
    if ($8560031dd706a122$var$Manipulator.getDataAttribute(this, "slide") === "next") {
        carousel.next();
        carousel._maybeEnableCycle();
        return;
    }
    carousel.prev();
    carousel._maybeEnableCycle();
});
$8560031dd706a122$var$EventHandler.on(window, $8560031dd706a122$var$EVENT_LOAD_DATA_API$3, ()=>{
    const carousels = $8560031dd706a122$var$SelectorEngine.find($8560031dd706a122$var$SELECTOR_DATA_RIDE);
    for (const carousel of carousels)$8560031dd706a122$export$144901db2ea8e967.getOrCreateInstance(carousel);
});
/**
 * jQuery
 */ $8560031dd706a122$var$defineJQueryPlugin($8560031dd706a122$export$144901db2ea8e967);
/**
 * --------------------------------------------------------------------------
 * Bootstrap collapse.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $8560031dd706a122$var$NAME$b = "collapse";
const $8560031dd706a122$var$DATA_KEY$7 = "bs.collapse";
const $8560031dd706a122$var$EVENT_KEY$7 = `.${$8560031dd706a122$var$DATA_KEY$7}`;
const $8560031dd706a122$var$DATA_API_KEY$4 = ".data-api";
const $8560031dd706a122$var$EVENT_SHOW$6 = `show${$8560031dd706a122$var$EVENT_KEY$7}`;
const $8560031dd706a122$var$EVENT_SHOWN$6 = `shown${$8560031dd706a122$var$EVENT_KEY$7}`;
const $8560031dd706a122$var$EVENT_HIDE$6 = `hide${$8560031dd706a122$var$EVENT_KEY$7}`;
const $8560031dd706a122$var$EVENT_HIDDEN$6 = `hidden${$8560031dd706a122$var$EVENT_KEY$7}`;
const $8560031dd706a122$var$EVENT_CLICK_DATA_API$4 = `click${$8560031dd706a122$var$EVENT_KEY$7}${$8560031dd706a122$var$DATA_API_KEY$4}`;
const $8560031dd706a122$var$CLASS_NAME_SHOW$7 = "show";
const $8560031dd706a122$var$CLASS_NAME_COLLAPSE = "collapse";
const $8560031dd706a122$var$CLASS_NAME_COLLAPSING = "collapsing";
const $8560031dd706a122$var$CLASS_NAME_COLLAPSED = "collapsed";
const $8560031dd706a122$var$CLASS_NAME_DEEPER_CHILDREN = `:scope .${$8560031dd706a122$var$CLASS_NAME_COLLAPSE} .${$8560031dd706a122$var$CLASS_NAME_COLLAPSE}`;
const $8560031dd706a122$var$CLASS_NAME_HORIZONTAL = "collapse-horizontal";
const $8560031dd706a122$var$WIDTH = "width";
const $8560031dd706a122$var$HEIGHT = "height";
const $8560031dd706a122$var$SELECTOR_ACTIVES = ".collapse.show, .collapse.collapsing";
const $8560031dd706a122$var$SELECTOR_DATA_TOGGLE$4 = '[data-bs-toggle="collapse"]';
const $8560031dd706a122$var$Default$a = {
    parent: null,
    toggle: true
};
const $8560031dd706a122$var$DefaultType$a = {
    parent: "(null|element)",
    toggle: "boolean"
};
/**
 * Class definition
 */ class $8560031dd706a122$export$78768a9af065a7b extends $8560031dd706a122$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._isTransitioning = false;
        this._triggerArray = [];
        const toggleList = $8560031dd706a122$var$SelectorEngine.find($8560031dd706a122$var$SELECTOR_DATA_TOGGLE$4);
        for (const elem of toggleList){
            const selector = $8560031dd706a122$var$SelectorEngine.getSelectorFromElement(elem);
            const filterElement = $8560031dd706a122$var$SelectorEngine.find(selector).filter((foundElement)=>foundElement === this._element);
            if (selector !== null && filterElement.length) this._triggerArray.push(elem);
        }
        this._initializeChildren();
        if (!this._config.parent) this._addAriaAndCollapsedClass(this._triggerArray, this._isShown());
        if (this._config.toggle) this.toggle();
    }
    // Getters
    static get Default() {
        return $8560031dd706a122$var$Default$a;
    }
    static get DefaultType() {
        return $8560031dd706a122$var$DefaultType$a;
    }
    static get NAME() {
        return $8560031dd706a122$var$NAME$b;
    }
    // Public
    toggle() {
        if (this._isShown()) this.hide();
        else this.show();
    }
    show() {
        if (this._isTransitioning || this._isShown()) return;
        let activeChildren = [];
        // find active children
        if (this._config.parent) activeChildren = this._getFirstLevelChildren($8560031dd706a122$var$SELECTOR_ACTIVES).filter((element)=>element !== this._element).map((element)=>$8560031dd706a122$export$78768a9af065a7b.getOrCreateInstance(element, {
                toggle: false
            }));
        if (activeChildren.length && activeChildren[0]._isTransitioning) return;
        const startEvent = $8560031dd706a122$var$EventHandler.trigger(this._element, $8560031dd706a122$var$EVENT_SHOW$6);
        if (startEvent.defaultPrevented) return;
        for (const activeInstance of activeChildren)activeInstance.hide();
        const dimension = this._getDimension();
        this._element.classList.remove($8560031dd706a122$var$CLASS_NAME_COLLAPSE);
        this._element.classList.add($8560031dd706a122$var$CLASS_NAME_COLLAPSING);
        this._element.style[dimension] = 0;
        this._addAriaAndCollapsedClass(this._triggerArray, true);
        this._isTransitioning = true;
        const complete = ()=>{
            this._isTransitioning = false;
            this._element.classList.remove($8560031dd706a122$var$CLASS_NAME_COLLAPSING);
            this._element.classList.add($8560031dd706a122$var$CLASS_NAME_COLLAPSE, $8560031dd706a122$var$CLASS_NAME_SHOW$7);
            this._element.style[dimension] = "";
            $8560031dd706a122$var$EventHandler.trigger(this._element, $8560031dd706a122$var$EVENT_SHOWN$6);
        };
        const capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
        const scrollSize = `scroll${capitalizedDimension}`;
        this._queueCallback(complete, this._element, true);
        this._element.style[dimension] = `${this._element[scrollSize]}px`;
    }
    hide() {
        if (this._isTransitioning || !this._isShown()) return;
        const startEvent = $8560031dd706a122$var$EventHandler.trigger(this._element, $8560031dd706a122$var$EVENT_HIDE$6);
        if (startEvent.defaultPrevented) return;
        const dimension = this._getDimension();
        this._element.style[dimension] = `${this._element.getBoundingClientRect()[dimension]}px`;
        $8560031dd706a122$var$reflow(this._element);
        this._element.classList.add($8560031dd706a122$var$CLASS_NAME_COLLAPSING);
        this._element.classList.remove($8560031dd706a122$var$CLASS_NAME_COLLAPSE, $8560031dd706a122$var$CLASS_NAME_SHOW$7);
        for (const trigger of this._triggerArray){
            const element = $8560031dd706a122$var$SelectorEngine.getElementFromSelector(trigger);
            if (element && !this._isShown(element)) this._addAriaAndCollapsedClass([
                trigger
            ], false);
        }
        this._isTransitioning = true;
        const complete = ()=>{
            this._isTransitioning = false;
            this._element.classList.remove($8560031dd706a122$var$CLASS_NAME_COLLAPSING);
            this._element.classList.add($8560031dd706a122$var$CLASS_NAME_COLLAPSE);
            $8560031dd706a122$var$EventHandler.trigger(this._element, $8560031dd706a122$var$EVENT_HIDDEN$6);
        };
        this._element.style[dimension] = "";
        this._queueCallback(complete, this._element, true);
    }
    _isShown(element = this._element) {
        return element.classList.contains($8560031dd706a122$var$CLASS_NAME_SHOW$7);
    }
    // Private
    _configAfterMerge(config) {
        config.toggle = Boolean(config.toggle); // Coerce string values
        config.parent = $8560031dd706a122$var$getElement(config.parent);
        return config;
    }
    _getDimension() {
        return this._element.classList.contains($8560031dd706a122$var$CLASS_NAME_HORIZONTAL) ? $8560031dd706a122$var$WIDTH : $8560031dd706a122$var$HEIGHT;
    }
    _initializeChildren() {
        if (!this._config.parent) return;
        const children = this._getFirstLevelChildren($8560031dd706a122$var$SELECTOR_DATA_TOGGLE$4);
        for (const element of children){
            const selected = $8560031dd706a122$var$SelectorEngine.getElementFromSelector(element);
            if (selected) this._addAriaAndCollapsedClass([
                element
            ], this._isShown(selected));
        }
    }
    _getFirstLevelChildren(selector) {
        const children = $8560031dd706a122$var$SelectorEngine.find($8560031dd706a122$var$CLASS_NAME_DEEPER_CHILDREN, this._config.parent);
        // remove children if greater depth
        return $8560031dd706a122$var$SelectorEngine.find(selector, this._config.parent).filter((element)=>!children.includes(element));
    }
    _addAriaAndCollapsedClass(triggerArray, isOpen) {
        if (!triggerArray.length) return;
        for (const element of triggerArray){
            element.classList.toggle($8560031dd706a122$var$CLASS_NAME_COLLAPSED, !isOpen);
            element.setAttribute("aria-expanded", isOpen);
        }
    }
    // Static
    static jQueryInterface(config) {
        const _config = {};
        if (typeof config === "string" && /show|hide/.test(config)) _config.toggle = false;
        return this.each(function() {
            const data = $8560031dd706a122$export$78768a9af065a7b.getOrCreateInstance(this, _config);
            if (typeof config === "string") {
                if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
                data[config]();
            }
        });
    }
}
/**
 * Data API implementation
 */ $8560031dd706a122$var$EventHandler.on(document, $8560031dd706a122$var$EVENT_CLICK_DATA_API$4, $8560031dd706a122$var$SELECTOR_DATA_TOGGLE$4, function(event) {
    // preventDefault only for <a> elements (which change the URL) not inside the collapsible element
    if (event.target.tagName === "A" || event.delegateTarget && event.delegateTarget.tagName === "A") event.preventDefault();
    for (const element of $8560031dd706a122$var$SelectorEngine.getMultipleElementsFromSelector(this))$8560031dd706a122$export$78768a9af065a7b.getOrCreateInstance(element, {
        toggle: false
    }).toggle();
});
/**
 * jQuery
 */ $8560031dd706a122$var$defineJQueryPlugin($8560031dd706a122$export$78768a9af065a7b);
/**
 * --------------------------------------------------------------------------
 * Bootstrap dropdown.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $8560031dd706a122$var$NAME$a = "dropdown";
const $8560031dd706a122$var$DATA_KEY$6 = "bs.dropdown";
const $8560031dd706a122$var$EVENT_KEY$6 = `.${$8560031dd706a122$var$DATA_KEY$6}`;
const $8560031dd706a122$var$DATA_API_KEY$3 = ".data-api";
const $8560031dd706a122$var$ESCAPE_KEY$2 = "Escape";
const $8560031dd706a122$var$TAB_KEY$1 = "Tab";
const $8560031dd706a122$var$ARROW_UP_KEY$1 = "ArrowUp";
const $8560031dd706a122$var$ARROW_DOWN_KEY$1 = "ArrowDown";
const $8560031dd706a122$var$RIGHT_MOUSE_BUTTON = 2; // MouseEvent.button value for the secondary button, usually the right button
const $8560031dd706a122$var$EVENT_HIDE$5 = `hide${$8560031dd706a122$var$EVENT_KEY$6}`;
const $8560031dd706a122$var$EVENT_HIDDEN$5 = `hidden${$8560031dd706a122$var$EVENT_KEY$6}`;
const $8560031dd706a122$var$EVENT_SHOW$5 = `show${$8560031dd706a122$var$EVENT_KEY$6}`;
const $8560031dd706a122$var$EVENT_SHOWN$5 = `shown${$8560031dd706a122$var$EVENT_KEY$6}`;
const $8560031dd706a122$var$EVENT_CLICK_DATA_API$3 = `click${$8560031dd706a122$var$EVENT_KEY$6}${$8560031dd706a122$var$DATA_API_KEY$3}`;
const $8560031dd706a122$var$EVENT_KEYDOWN_DATA_API = `keydown${$8560031dd706a122$var$EVENT_KEY$6}${$8560031dd706a122$var$DATA_API_KEY$3}`;
const $8560031dd706a122$var$EVENT_KEYUP_DATA_API = `keyup${$8560031dd706a122$var$EVENT_KEY$6}${$8560031dd706a122$var$DATA_API_KEY$3}`;
const $8560031dd706a122$var$CLASS_NAME_SHOW$6 = "show";
const $8560031dd706a122$var$CLASS_NAME_DROPUP = "dropup";
const $8560031dd706a122$var$CLASS_NAME_DROPEND = "dropend";
const $8560031dd706a122$var$CLASS_NAME_DROPSTART = "dropstart";
const $8560031dd706a122$var$CLASS_NAME_DROPUP_CENTER = "dropup-center";
const $8560031dd706a122$var$CLASS_NAME_DROPDOWN_CENTER = "dropdown-center";
const $8560031dd706a122$var$SELECTOR_DATA_TOGGLE$3 = '[data-bs-toggle="dropdown"]:not(.disabled):not(:disabled)';
const $8560031dd706a122$var$SELECTOR_DATA_TOGGLE_SHOWN = `${$8560031dd706a122$var$SELECTOR_DATA_TOGGLE$3}.${$8560031dd706a122$var$CLASS_NAME_SHOW$6}`;
const $8560031dd706a122$var$SELECTOR_MENU = ".dropdown-menu";
const $8560031dd706a122$var$SELECTOR_NAVBAR = ".navbar";
const $8560031dd706a122$var$SELECTOR_NAVBAR_NAV = ".navbar-nav";
const $8560031dd706a122$var$SELECTOR_VISIBLE_ITEMS = ".dropdown-menu .dropdown-item:not(.disabled):not(:disabled)";
const $8560031dd706a122$var$PLACEMENT_TOP = $8560031dd706a122$var$isRTL() ? "top-end" : "top-start";
const $8560031dd706a122$var$PLACEMENT_TOPEND = $8560031dd706a122$var$isRTL() ? "top-start" : "top-end";
const $8560031dd706a122$var$PLACEMENT_BOTTOM = $8560031dd706a122$var$isRTL() ? "bottom-end" : "bottom-start";
const $8560031dd706a122$var$PLACEMENT_BOTTOMEND = $8560031dd706a122$var$isRTL() ? "bottom-start" : "bottom-end";
const $8560031dd706a122$var$PLACEMENT_RIGHT = $8560031dd706a122$var$isRTL() ? "left-start" : "right-start";
const $8560031dd706a122$var$PLACEMENT_LEFT = $8560031dd706a122$var$isRTL() ? "right-start" : "left-start";
const $8560031dd706a122$var$PLACEMENT_TOPCENTER = "top";
const $8560031dd706a122$var$PLACEMENT_BOTTOMCENTER = "bottom";
const $8560031dd706a122$var$Default$9 = {
    autoClose: true,
    boundary: "clippingParents",
    display: "dynamic",
    offset: [
        0,
        2
    ],
    popperConfig: null,
    reference: "toggle"
};
const $8560031dd706a122$var$DefaultType$9 = {
    autoClose: "(boolean|string)",
    boundary: "(string|element)",
    display: "string",
    offset: "(array|string|function)",
    popperConfig: "(null|object|function)",
    reference: "(string|element|object)"
};
/**
 * Class definition
 */ class $8560031dd706a122$export$931cbfb6bfb85fc extends $8560031dd706a122$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._popper = null;
        this._parent = this._element.parentNode; // dropdown wrapper
        // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
        this._menu = $8560031dd706a122$var$SelectorEngine.next(this._element, $8560031dd706a122$var$SELECTOR_MENU)[0] || $8560031dd706a122$var$SelectorEngine.prev(this._element, $8560031dd706a122$var$SELECTOR_MENU)[0] || $8560031dd706a122$var$SelectorEngine.findOne($8560031dd706a122$var$SELECTOR_MENU, this._parent);
        this._inNavbar = this._detectNavbar();
    }
    // Getters
    static get Default() {
        return $8560031dd706a122$var$Default$9;
    }
    static get DefaultType() {
        return $8560031dd706a122$var$DefaultType$9;
    }
    static get NAME() {
        return $8560031dd706a122$var$NAME$a;
    }
    // Public
    toggle() {
        return this._isShown() ? this.hide() : this.show();
    }
    show() {
        if ($8560031dd706a122$var$isDisabled(this._element) || this._isShown()) return;
        const relatedTarget = {
            relatedTarget: this._element
        };
        const showEvent = $8560031dd706a122$var$EventHandler.trigger(this._element, $8560031dd706a122$var$EVENT_SHOW$5, relatedTarget);
        if (showEvent.defaultPrevented) return;
        this._createPopper();
        // If this is a touch-enabled device we add extra
        // empty mouseover listeners to the body's immediate children;
        // only needed because of broken event delegation on iOS
        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
        if ("ontouchstart" in document.documentElement && !this._parent.closest($8560031dd706a122$var$SELECTOR_NAVBAR_NAV)) for (const element of [].concat(...document.body.children))$8560031dd706a122$var$EventHandler.on(element, "mouseover", $8560031dd706a122$var$noop);
        this._element.focus();
        this._element.setAttribute("aria-expanded", true);
        this._menu.classList.add($8560031dd706a122$var$CLASS_NAME_SHOW$6);
        this._element.classList.add($8560031dd706a122$var$CLASS_NAME_SHOW$6);
        $8560031dd706a122$var$EventHandler.trigger(this._element, $8560031dd706a122$var$EVENT_SHOWN$5, relatedTarget);
    }
    hide() {
        if ($8560031dd706a122$var$isDisabled(this._element) || !this._isShown()) return;
        const relatedTarget = {
            relatedTarget: this._element
        };
        this._completeHide(relatedTarget);
    }
    dispose() {
        if (this._popper) this._popper.destroy();
        super.dispose();
    }
    update() {
        this._inNavbar = this._detectNavbar();
        if (this._popper) this._popper.update();
    }
    // Private
    _completeHide(relatedTarget) {
        const hideEvent = $8560031dd706a122$var$EventHandler.trigger(this._element, $8560031dd706a122$var$EVENT_HIDE$5, relatedTarget);
        if (hideEvent.defaultPrevented) return;
        // If this is a touch-enabled device we remove the extra
        // empty mouseover listeners we added for iOS support
        if ("ontouchstart" in document.documentElement) for (const element of [].concat(...document.body.children))$8560031dd706a122$var$EventHandler.off(element, "mouseover", $8560031dd706a122$var$noop);
        if (this._popper) this._popper.destroy();
        this._menu.classList.remove($8560031dd706a122$var$CLASS_NAME_SHOW$6);
        this._element.classList.remove($8560031dd706a122$var$CLASS_NAME_SHOW$6);
        this._element.setAttribute("aria-expanded", "false");
        $8560031dd706a122$var$Manipulator.removeDataAttribute(this._menu, "popper");
        $8560031dd706a122$var$EventHandler.trigger(this._element, $8560031dd706a122$var$EVENT_HIDDEN$5, relatedTarget);
    }
    _getConfig(config) {
        config = super._getConfig(config);
        if (typeof config.reference === "object" && !$8560031dd706a122$var$isElement(config.reference) && typeof config.reference.getBoundingClientRect !== "function") // Popper virtual elements require a getBoundingClientRect method
        throw new TypeError(`${$8560031dd706a122$var$NAME$a.toUpperCase()}: Option "reference" provided type "object" without a required "getBoundingClientRect" method.`);
        return config;
    }
    _createPopper() {
        if (typeof $adf6c43f8c27fe04$exports === "undefined") throw new TypeError("Bootstrap's dropdowns require Popper (https://popper.js.org)");
        let referenceElement = this._element;
        if (this._config.reference === "parent") referenceElement = this._parent;
        else if ($8560031dd706a122$var$isElement(this._config.reference)) referenceElement = $8560031dd706a122$var$getElement(this._config.reference);
        else if (typeof this._config.reference === "object") referenceElement = this._config.reference;
        const popperConfig = this._getPopperConfig();
        this._popper = $adf6c43f8c27fe04$exports.createPopper(referenceElement, this._menu, popperConfig);
    }
    _isShown() {
        return this._menu.classList.contains($8560031dd706a122$var$CLASS_NAME_SHOW$6);
    }
    _getPlacement() {
        const parentDropdown = this._parent;
        if (parentDropdown.classList.contains($8560031dd706a122$var$CLASS_NAME_DROPEND)) return $8560031dd706a122$var$PLACEMENT_RIGHT;
        if (parentDropdown.classList.contains($8560031dd706a122$var$CLASS_NAME_DROPSTART)) return $8560031dd706a122$var$PLACEMENT_LEFT;
        if (parentDropdown.classList.contains($8560031dd706a122$var$CLASS_NAME_DROPUP_CENTER)) return $8560031dd706a122$var$PLACEMENT_TOPCENTER;
        if (parentDropdown.classList.contains($8560031dd706a122$var$CLASS_NAME_DROPDOWN_CENTER)) return $8560031dd706a122$var$PLACEMENT_BOTTOMCENTER;
        // We need to trim the value because custom properties can also include spaces
        const isEnd = getComputedStyle(this._menu).getPropertyValue("--bs-position").trim() === "end";
        if (parentDropdown.classList.contains($8560031dd706a122$var$CLASS_NAME_DROPUP)) return isEnd ? $8560031dd706a122$var$PLACEMENT_TOPEND : $8560031dd706a122$var$PLACEMENT_TOP;
        return isEnd ? $8560031dd706a122$var$PLACEMENT_BOTTOMEND : $8560031dd706a122$var$PLACEMENT_BOTTOM;
    }
    _detectNavbar() {
        return this._element.closest($8560031dd706a122$var$SELECTOR_NAVBAR) !== null;
    }
    _getOffset() {
        const { offset: offset } = this._config;
        if (typeof offset === "string") return offset.split(",").map((value)=>Number.parseInt(value, 10));
        if (typeof offset === "function") return (popperData)=>offset(popperData, this._element);
        return offset;
    }
    _getPopperConfig() {
        const defaultBsPopperConfig = {
            placement: this._getPlacement(),
            modifiers: [
                {
                    name: "preventOverflow",
                    options: {
                        boundary: this._config.boundary
                    }
                },
                {
                    name: "offset",
                    options: {
                        offset: this._getOffset()
                    }
                }
            ]
        };
        // Disable Popper if we have a static display or Dropdown is in Navbar
        if (this._inNavbar || this._config.display === "static") {
            $8560031dd706a122$var$Manipulator.setDataAttribute(this._menu, "popper", "static"); // TODO: v6 remove
            defaultBsPopperConfig.modifiers = [
                {
                    name: "applyStyles",
                    enabled: false
                }
            ];
        }
        return {
            ...defaultBsPopperConfig,
            ...$8560031dd706a122$var$execute(this._config.popperConfig, [
                defaultBsPopperConfig
            ])
        };
    }
    _selectMenuItem({ key: key, target: target }) {
        const items = $8560031dd706a122$var$SelectorEngine.find($8560031dd706a122$var$SELECTOR_VISIBLE_ITEMS, this._menu).filter((element)=>$8560031dd706a122$var$isVisible(element));
        if (!items.length) return;
        // if target isn't included in items (e.g. when expanding the dropdown)
        // allow cycling to get the last item in case key equals ARROW_UP_KEY
        $8560031dd706a122$var$getNextActiveElement(items, target, key === $8560031dd706a122$var$ARROW_DOWN_KEY$1, !items.includes(target)).focus();
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $8560031dd706a122$export$931cbfb6bfb85fc.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
    static clearMenus(event) {
        if (event.button === $8560031dd706a122$var$RIGHT_MOUSE_BUTTON || event.type === "keyup" && event.key !== $8560031dd706a122$var$TAB_KEY$1) return;
        const openToggles = $8560031dd706a122$var$SelectorEngine.find($8560031dd706a122$var$SELECTOR_DATA_TOGGLE_SHOWN);
        for (const toggle of openToggles){
            const context = $8560031dd706a122$export$931cbfb6bfb85fc.getInstance(toggle);
            if (!context || context._config.autoClose === false) continue;
            const composedPath = event.composedPath();
            const isMenuTarget = composedPath.includes(context._menu);
            if (composedPath.includes(context._element) || context._config.autoClose === "inside" && !isMenuTarget || context._config.autoClose === "outside" && isMenuTarget) continue;
            // Tab navigation through the dropdown menu or events from contained inputs shouldn't close the menu
            if (context._menu.contains(event.target) && (event.type === "keyup" && event.key === $8560031dd706a122$var$TAB_KEY$1 || /input|select|option|textarea|form/i.test(event.target.tagName))) continue;
            const relatedTarget = {
                relatedTarget: context._element
            };
            if (event.type === "click") relatedTarget.clickEvent = event;
            context._completeHide(relatedTarget);
        }
    }
    static dataApiKeydownHandler(event) {
        // If not an UP | DOWN | ESCAPE key => not a dropdown command
        // If input/textarea && if key is other than ESCAPE => not a dropdown command
        const isInput = /input|textarea/i.test(event.target.tagName);
        const isEscapeEvent = event.key === $8560031dd706a122$var$ESCAPE_KEY$2;
        const isUpOrDownEvent = [
            $8560031dd706a122$var$ARROW_UP_KEY$1,
            $8560031dd706a122$var$ARROW_DOWN_KEY$1
        ].includes(event.key);
        if (!isUpOrDownEvent && !isEscapeEvent) return;
        if (isInput && !isEscapeEvent) return;
        event.preventDefault();
        // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
        const getToggleButton = this.matches($8560031dd706a122$var$SELECTOR_DATA_TOGGLE$3) ? this : $8560031dd706a122$var$SelectorEngine.prev(this, $8560031dd706a122$var$SELECTOR_DATA_TOGGLE$3)[0] || $8560031dd706a122$var$SelectorEngine.next(this, $8560031dd706a122$var$SELECTOR_DATA_TOGGLE$3)[0] || $8560031dd706a122$var$SelectorEngine.findOne($8560031dd706a122$var$SELECTOR_DATA_TOGGLE$3, event.delegateTarget.parentNode);
        const instance = $8560031dd706a122$export$931cbfb6bfb85fc.getOrCreateInstance(getToggleButton);
        if (isUpOrDownEvent) {
            event.stopPropagation();
            instance.show();
            instance._selectMenuItem(event);
            return;
        }
        if (instance._isShown()) {
            // else is escape and we check if it is shown
            event.stopPropagation();
            instance.hide();
            getToggleButton.focus();
        }
    }
}
/**
 * Data API implementation
 */ $8560031dd706a122$var$EventHandler.on(document, $8560031dd706a122$var$EVENT_KEYDOWN_DATA_API, $8560031dd706a122$var$SELECTOR_DATA_TOGGLE$3, $8560031dd706a122$export$931cbfb6bfb85fc.dataApiKeydownHandler);
$8560031dd706a122$var$EventHandler.on(document, $8560031dd706a122$var$EVENT_KEYDOWN_DATA_API, $8560031dd706a122$var$SELECTOR_MENU, $8560031dd706a122$export$931cbfb6bfb85fc.dataApiKeydownHandler);
$8560031dd706a122$var$EventHandler.on(document, $8560031dd706a122$var$EVENT_CLICK_DATA_API$3, $8560031dd706a122$export$931cbfb6bfb85fc.clearMenus);
$8560031dd706a122$var$EventHandler.on(document, $8560031dd706a122$var$EVENT_KEYUP_DATA_API, $8560031dd706a122$export$931cbfb6bfb85fc.clearMenus);
$8560031dd706a122$var$EventHandler.on(document, $8560031dd706a122$var$EVENT_CLICK_DATA_API$3, $8560031dd706a122$var$SELECTOR_DATA_TOGGLE$3, function(event) {
    event.preventDefault();
    $8560031dd706a122$export$931cbfb6bfb85fc.getOrCreateInstance(this).toggle();
});
/**
 * jQuery
 */ $8560031dd706a122$var$defineJQueryPlugin($8560031dd706a122$export$931cbfb6bfb85fc);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/backdrop.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $8560031dd706a122$var$NAME$9 = "backdrop";
const $8560031dd706a122$var$CLASS_NAME_FADE$4 = "fade";
const $8560031dd706a122$var$CLASS_NAME_SHOW$5 = "show";
const $8560031dd706a122$var$EVENT_MOUSEDOWN = `mousedown.bs.${$8560031dd706a122$var$NAME$9}`;
const $8560031dd706a122$var$Default$8 = {
    className: "modal-backdrop",
    clickCallback: null,
    isAnimated: false,
    isVisible: true,
    // if false, we use the backdrop helper without adding any element to the dom
    rootElement: "body" // give the choice to place backdrop under different elements
};
const $8560031dd706a122$var$DefaultType$8 = {
    className: "string",
    clickCallback: "(function|null)",
    isAnimated: "boolean",
    isVisible: "boolean",
    rootElement: "(element|string)"
};
/**
 * Class definition
 */ class $8560031dd706a122$var$Backdrop extends $8560031dd706a122$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
        this._isAppended = false;
        this._element = null;
    }
    // Getters
    static get Default() {
        return $8560031dd706a122$var$Default$8;
    }
    static get DefaultType() {
        return $8560031dd706a122$var$DefaultType$8;
    }
    static get NAME() {
        return $8560031dd706a122$var$NAME$9;
    }
    // Public
    show(callback) {
        if (!this._config.isVisible) {
            $8560031dd706a122$var$execute(callback);
            return;
        }
        this._append();
        const element = this._getElement();
        if (this._config.isAnimated) $8560031dd706a122$var$reflow(element);
        element.classList.add($8560031dd706a122$var$CLASS_NAME_SHOW$5);
        this._emulateAnimation(()=>{
            $8560031dd706a122$var$execute(callback);
        });
    }
    hide(callback) {
        if (!this._config.isVisible) {
            $8560031dd706a122$var$execute(callback);
            return;
        }
        this._getElement().classList.remove($8560031dd706a122$var$CLASS_NAME_SHOW$5);
        this._emulateAnimation(()=>{
            this.dispose();
            $8560031dd706a122$var$execute(callback);
        });
    }
    dispose() {
        if (!this._isAppended) return;
        $8560031dd706a122$var$EventHandler.off(this._element, $8560031dd706a122$var$EVENT_MOUSEDOWN);
        this._element.remove();
        this._isAppended = false;
    }
    // Private
    _getElement() {
        if (!this._element) {
            const backdrop = document.createElement("div");
            backdrop.className = this._config.className;
            if (this._config.isAnimated) backdrop.classList.add($8560031dd706a122$var$CLASS_NAME_FADE$4);
            this._element = backdrop;
        }
        return this._element;
    }
    _configAfterMerge(config) {
        // use getElement() with the default "body" to get a fresh Element on each instantiation
        config.rootElement = $8560031dd706a122$var$getElement(config.rootElement);
        return config;
    }
    _append() {
        if (this._isAppended) return;
        const element = this._getElement();
        this._config.rootElement.append(element);
        $8560031dd706a122$var$EventHandler.on(element, $8560031dd706a122$var$EVENT_MOUSEDOWN, ()=>{
            $8560031dd706a122$var$execute(this._config.clickCallback);
        });
        this._isAppended = true;
    }
    _emulateAnimation(callback) {
        $8560031dd706a122$var$executeAfterTransition(callback, this._getElement(), this._config.isAnimated);
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/focustrap.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $8560031dd706a122$var$NAME$8 = "focustrap";
const $8560031dd706a122$var$DATA_KEY$5 = "bs.focustrap";
const $8560031dd706a122$var$EVENT_KEY$5 = `.${$8560031dd706a122$var$DATA_KEY$5}`;
const $8560031dd706a122$var$EVENT_FOCUSIN$2 = `focusin${$8560031dd706a122$var$EVENT_KEY$5}`;
const $8560031dd706a122$var$EVENT_KEYDOWN_TAB = `keydown.tab${$8560031dd706a122$var$EVENT_KEY$5}`;
const $8560031dd706a122$var$TAB_KEY = "Tab";
const $8560031dd706a122$var$TAB_NAV_FORWARD = "forward";
const $8560031dd706a122$var$TAB_NAV_BACKWARD = "backward";
const $8560031dd706a122$var$Default$7 = {
    autofocus: true,
    trapElement: null // The element to trap focus inside of
};
const $8560031dd706a122$var$DefaultType$7 = {
    autofocus: "boolean",
    trapElement: "element"
};
/**
 * Class definition
 */ class $8560031dd706a122$var$FocusTrap extends $8560031dd706a122$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
        this._isActive = false;
        this._lastTabNavDirection = null;
    }
    // Getters
    static get Default() {
        return $8560031dd706a122$var$Default$7;
    }
    static get DefaultType() {
        return $8560031dd706a122$var$DefaultType$7;
    }
    static get NAME() {
        return $8560031dd706a122$var$NAME$8;
    }
    // Public
    activate() {
        if (this._isActive) return;
        if (this._config.autofocus) this._config.trapElement.focus();
        $8560031dd706a122$var$EventHandler.off(document, $8560031dd706a122$var$EVENT_KEY$5); // guard against infinite focus loop
        $8560031dd706a122$var$EventHandler.on(document, $8560031dd706a122$var$EVENT_FOCUSIN$2, (event)=>this._handleFocusin(event));
        $8560031dd706a122$var$EventHandler.on(document, $8560031dd706a122$var$EVENT_KEYDOWN_TAB, (event)=>this._handleKeydown(event));
        this._isActive = true;
    }
    deactivate() {
        if (!this._isActive) return;
        this._isActive = false;
        $8560031dd706a122$var$EventHandler.off(document, $8560031dd706a122$var$EVENT_KEY$5);
    }
    // Private
    _handleFocusin(event) {
        const { trapElement: trapElement } = this._config;
        if (event.target === document || event.target === trapElement || trapElement.contains(event.target)) return;
        const elements = $8560031dd706a122$var$SelectorEngine.focusableChildren(trapElement);
        if (elements.length === 0) trapElement.focus();
        else if (this._lastTabNavDirection === $8560031dd706a122$var$TAB_NAV_BACKWARD) elements[elements.length - 1].focus();
        else elements[0].focus();
    }
    _handleKeydown(event) {
        if (event.key !== $8560031dd706a122$var$TAB_KEY) return;
        this._lastTabNavDirection = event.shiftKey ? $8560031dd706a122$var$TAB_NAV_BACKWARD : $8560031dd706a122$var$TAB_NAV_FORWARD;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/scrollBar.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $8560031dd706a122$var$SELECTOR_FIXED_CONTENT = ".fixed-top, .fixed-bottom, .is-fixed, .sticky-top";
const $8560031dd706a122$var$SELECTOR_STICKY_CONTENT = ".sticky-top";
const $8560031dd706a122$var$PROPERTY_PADDING = "padding-right";
const $8560031dd706a122$var$PROPERTY_MARGIN = "margin-right";
/**
 * Class definition
 */ class $8560031dd706a122$var$ScrollBarHelper {
    constructor(){
        this._element = document.body;
    }
    // Public
    getWidth() {
        // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
        const documentWidth = document.documentElement.clientWidth;
        return Math.abs(window.innerWidth - documentWidth);
    }
    hide() {
        const width = this.getWidth();
        this._disableOverFlow();
        // give padding to element to balance the hidden scrollbar width
        this._setElementAttributes(this._element, $8560031dd706a122$var$PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
        // trick: We adjust positive paddingRight and negative marginRight to sticky-top elements to keep showing fullwidth
        this._setElementAttributes($8560031dd706a122$var$SELECTOR_FIXED_CONTENT, $8560031dd706a122$var$PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
        this._setElementAttributes($8560031dd706a122$var$SELECTOR_STICKY_CONTENT, $8560031dd706a122$var$PROPERTY_MARGIN, (calculatedValue)=>calculatedValue - width);
    }
    reset() {
        this._resetElementAttributes(this._element, "overflow");
        this._resetElementAttributes(this._element, $8560031dd706a122$var$PROPERTY_PADDING);
        this._resetElementAttributes($8560031dd706a122$var$SELECTOR_FIXED_CONTENT, $8560031dd706a122$var$PROPERTY_PADDING);
        this._resetElementAttributes($8560031dd706a122$var$SELECTOR_STICKY_CONTENT, $8560031dd706a122$var$PROPERTY_MARGIN);
    }
    isOverflowing() {
        return this.getWidth() > 0;
    }
    // Private
    _disableOverFlow() {
        this._saveInitialAttribute(this._element, "overflow");
        this._element.style.overflow = "hidden";
    }
    _setElementAttributes(selector, styleProperty, callback) {
        const scrollbarWidth = this.getWidth();
        const manipulationCallBack = (element)=>{
            if (element !== this._element && window.innerWidth > element.clientWidth + scrollbarWidth) return;
            this._saveInitialAttribute(element, styleProperty);
            const calculatedValue = window.getComputedStyle(element).getPropertyValue(styleProperty);
            element.style.setProperty(styleProperty, `${callback(Number.parseFloat(calculatedValue))}px`);
        };
        this._applyManipulationCallback(selector, manipulationCallBack);
    }
    _saveInitialAttribute(element, styleProperty) {
        const actualValue = element.style.getPropertyValue(styleProperty);
        if (actualValue) $8560031dd706a122$var$Manipulator.setDataAttribute(element, styleProperty, actualValue);
    }
    _resetElementAttributes(selector, styleProperty) {
        const manipulationCallBack = (element)=>{
            const value = $8560031dd706a122$var$Manipulator.getDataAttribute(element, styleProperty);
            // We only want to remove the property if the value is `null`; the value can also be zero
            if (value === null) {
                element.style.removeProperty(styleProperty);
                return;
            }
            $8560031dd706a122$var$Manipulator.removeDataAttribute(element, styleProperty);
            element.style.setProperty(styleProperty, value);
        };
        this._applyManipulationCallback(selector, manipulationCallBack);
    }
    _applyManipulationCallback(selector, callBack) {
        if ($8560031dd706a122$var$isElement(selector)) {
            callBack(selector);
            return;
        }
        for (const sel of $8560031dd706a122$var$SelectorEngine.find(selector, this._element))callBack(sel);
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap modal.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $8560031dd706a122$var$NAME$7 = "modal";
const $8560031dd706a122$var$DATA_KEY$4 = "bs.modal";
const $8560031dd706a122$var$EVENT_KEY$4 = `.${$8560031dd706a122$var$DATA_KEY$4}`;
const $8560031dd706a122$var$DATA_API_KEY$2 = ".data-api";
const $8560031dd706a122$var$ESCAPE_KEY$1 = "Escape";
const $8560031dd706a122$var$EVENT_HIDE$4 = `hide${$8560031dd706a122$var$EVENT_KEY$4}`;
const $8560031dd706a122$var$EVENT_HIDE_PREVENTED$1 = `hidePrevented${$8560031dd706a122$var$EVENT_KEY$4}`;
const $8560031dd706a122$var$EVENT_HIDDEN$4 = `hidden${$8560031dd706a122$var$EVENT_KEY$4}`;
const $8560031dd706a122$var$EVENT_SHOW$4 = `show${$8560031dd706a122$var$EVENT_KEY$4}`;
const $8560031dd706a122$var$EVENT_SHOWN$4 = `shown${$8560031dd706a122$var$EVENT_KEY$4}`;
const $8560031dd706a122$var$EVENT_RESIZE$1 = `resize${$8560031dd706a122$var$EVENT_KEY$4}`;
const $8560031dd706a122$var$EVENT_CLICK_DISMISS = `click.dismiss${$8560031dd706a122$var$EVENT_KEY$4}`;
const $8560031dd706a122$var$EVENT_MOUSEDOWN_DISMISS = `mousedown.dismiss${$8560031dd706a122$var$EVENT_KEY$4}`;
const $8560031dd706a122$var$EVENT_KEYDOWN_DISMISS$1 = `keydown.dismiss${$8560031dd706a122$var$EVENT_KEY$4}`;
const $8560031dd706a122$var$EVENT_CLICK_DATA_API$2 = `click${$8560031dd706a122$var$EVENT_KEY$4}${$8560031dd706a122$var$DATA_API_KEY$2}`;
const $8560031dd706a122$var$CLASS_NAME_OPEN = "modal-open";
const $8560031dd706a122$var$CLASS_NAME_FADE$3 = "fade";
const $8560031dd706a122$var$CLASS_NAME_SHOW$4 = "show";
const $8560031dd706a122$var$CLASS_NAME_STATIC = "modal-static";
const $8560031dd706a122$var$OPEN_SELECTOR$1 = ".modal.show";
const $8560031dd706a122$var$SELECTOR_DIALOG = ".modal-dialog";
const $8560031dd706a122$var$SELECTOR_MODAL_BODY = ".modal-body";
const $8560031dd706a122$var$SELECTOR_DATA_TOGGLE$2 = '[data-bs-toggle="modal"]';
const $8560031dd706a122$var$Default$6 = {
    backdrop: true,
    focus: true,
    keyboard: true
};
const $8560031dd706a122$var$DefaultType$6 = {
    backdrop: "(boolean|string)",
    focus: "boolean",
    keyboard: "boolean"
};
/**
 * Class definition
 */ class $8560031dd706a122$export$2b77a92f1a5ad772 extends $8560031dd706a122$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._dialog = $8560031dd706a122$var$SelectorEngine.findOne($8560031dd706a122$var$SELECTOR_DIALOG, this._element);
        this._backdrop = this._initializeBackDrop();
        this._focustrap = this._initializeFocusTrap();
        this._isShown = false;
        this._isTransitioning = false;
        this._scrollBar = new $8560031dd706a122$var$ScrollBarHelper();
        this._addEventListeners();
    }
    // Getters
    static get Default() {
        return $8560031dd706a122$var$Default$6;
    }
    static get DefaultType() {
        return $8560031dd706a122$var$DefaultType$6;
    }
    static get NAME() {
        return $8560031dd706a122$var$NAME$7;
    }
    // Public
    toggle(relatedTarget) {
        return this._isShown ? this.hide() : this.show(relatedTarget);
    }
    show(relatedTarget) {
        if (this._isShown || this._isTransitioning) return;
        const showEvent = $8560031dd706a122$var$EventHandler.trigger(this._element, $8560031dd706a122$var$EVENT_SHOW$4, {
            relatedTarget: relatedTarget
        });
        if (showEvent.defaultPrevented) return;
        this._isShown = true;
        this._isTransitioning = true;
        this._scrollBar.hide();
        document.body.classList.add($8560031dd706a122$var$CLASS_NAME_OPEN);
        this._adjustDialog();
        this._backdrop.show(()=>this._showElement(relatedTarget));
    }
    hide() {
        if (!this._isShown || this._isTransitioning) return;
        const hideEvent = $8560031dd706a122$var$EventHandler.trigger(this._element, $8560031dd706a122$var$EVENT_HIDE$4);
        if (hideEvent.defaultPrevented) return;
        this._isShown = false;
        this._isTransitioning = true;
        this._focustrap.deactivate();
        this._element.classList.remove($8560031dd706a122$var$CLASS_NAME_SHOW$4);
        this._queueCallback(()=>this._hideModal(), this._element, this._isAnimated());
    }
    dispose() {
        $8560031dd706a122$var$EventHandler.off(window, $8560031dd706a122$var$EVENT_KEY$4);
        $8560031dd706a122$var$EventHandler.off(this._dialog, $8560031dd706a122$var$EVENT_KEY$4);
        this._backdrop.dispose();
        this._focustrap.deactivate();
        super.dispose();
    }
    handleUpdate() {
        this._adjustDialog();
    }
    // Private
    _initializeBackDrop() {
        return new $8560031dd706a122$var$Backdrop({
            isVisible: Boolean(this._config.backdrop),
            // 'static' option will be translated to true, and booleans will keep their value,
            isAnimated: this._isAnimated()
        });
    }
    _initializeFocusTrap() {
        return new $8560031dd706a122$var$FocusTrap({
            trapElement: this._element
        });
    }
    _showElement(relatedTarget) {
        // try to append dynamic modal
        if (!document.body.contains(this._element)) document.body.append(this._element);
        this._element.style.display = "block";
        this._element.removeAttribute("aria-hidden");
        this._element.setAttribute("aria-modal", true);
        this._element.setAttribute("role", "dialog");
        this._element.scrollTop = 0;
        const modalBody = $8560031dd706a122$var$SelectorEngine.findOne($8560031dd706a122$var$SELECTOR_MODAL_BODY, this._dialog);
        if (modalBody) modalBody.scrollTop = 0;
        $8560031dd706a122$var$reflow(this._element);
        this._element.classList.add($8560031dd706a122$var$CLASS_NAME_SHOW$4);
        const transitionComplete = ()=>{
            if (this._config.focus) this._focustrap.activate();
            this._isTransitioning = false;
            $8560031dd706a122$var$EventHandler.trigger(this._element, $8560031dd706a122$var$EVENT_SHOWN$4, {
                relatedTarget: relatedTarget
            });
        };
        this._queueCallback(transitionComplete, this._dialog, this._isAnimated());
    }
    _addEventListeners() {
        $8560031dd706a122$var$EventHandler.on(this._element, $8560031dd706a122$var$EVENT_KEYDOWN_DISMISS$1, (event)=>{
            if (event.key !== $8560031dd706a122$var$ESCAPE_KEY$1) return;
            if (this._config.keyboard) {
                this.hide();
                return;
            }
            this._triggerBackdropTransition();
        });
        $8560031dd706a122$var$EventHandler.on(window, $8560031dd706a122$var$EVENT_RESIZE$1, ()=>{
            if (this._isShown && !this._isTransitioning) this._adjustDialog();
        });
        $8560031dd706a122$var$EventHandler.on(this._element, $8560031dd706a122$var$EVENT_MOUSEDOWN_DISMISS, (event)=>{
            // a bad trick to segregate clicks that may start inside dialog but end outside, and avoid listen to scrollbar clicks
            $8560031dd706a122$var$EventHandler.one(this._element, $8560031dd706a122$var$EVENT_CLICK_DISMISS, (event2)=>{
                if (this._element !== event.target || this._element !== event2.target) return;
                if (this._config.backdrop === "static") {
                    this._triggerBackdropTransition();
                    return;
                }
                if (this._config.backdrop) this.hide();
            });
        });
    }
    _hideModal() {
        this._element.style.display = "none";
        this._element.setAttribute("aria-hidden", true);
        this._element.removeAttribute("aria-modal");
        this._element.removeAttribute("role");
        this._isTransitioning = false;
        this._backdrop.hide(()=>{
            document.body.classList.remove($8560031dd706a122$var$CLASS_NAME_OPEN);
            this._resetAdjustments();
            this._scrollBar.reset();
            $8560031dd706a122$var$EventHandler.trigger(this._element, $8560031dd706a122$var$EVENT_HIDDEN$4);
        });
    }
    _isAnimated() {
        return this._element.classList.contains($8560031dd706a122$var$CLASS_NAME_FADE$3);
    }
    _triggerBackdropTransition() {
        const hideEvent = $8560031dd706a122$var$EventHandler.trigger(this._element, $8560031dd706a122$var$EVENT_HIDE_PREVENTED$1);
        if (hideEvent.defaultPrevented) return;
        const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
        const initialOverflowY = this._element.style.overflowY;
        // return if the following background transition hasn't yet completed
        if (initialOverflowY === "hidden" || this._element.classList.contains($8560031dd706a122$var$CLASS_NAME_STATIC)) return;
        if (!isModalOverflowing) this._element.style.overflowY = "hidden";
        this._element.classList.add($8560031dd706a122$var$CLASS_NAME_STATIC);
        this._queueCallback(()=>{
            this._element.classList.remove($8560031dd706a122$var$CLASS_NAME_STATIC);
            this._queueCallback(()=>{
                this._element.style.overflowY = initialOverflowY;
            }, this._dialog);
        }, this._dialog);
        this._element.focus();
    }
    /**
   * The following methods are used to handle overflowing modals
   */ _adjustDialog() {
        const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
        const scrollbarWidth = this._scrollBar.getWidth();
        const isBodyOverflowing = scrollbarWidth > 0;
        if (isBodyOverflowing && !isModalOverflowing) {
            const property = $8560031dd706a122$var$isRTL() ? "paddingLeft" : "paddingRight";
            this._element.style[property] = `${scrollbarWidth}px`;
        }
        if (!isBodyOverflowing && isModalOverflowing) {
            const property = $8560031dd706a122$var$isRTL() ? "paddingRight" : "paddingLeft";
            this._element.style[property] = `${scrollbarWidth}px`;
        }
    }
    _resetAdjustments() {
        this._element.style.paddingLeft = "";
        this._element.style.paddingRight = "";
    }
    // Static
    static jQueryInterface(config, relatedTarget) {
        return this.each(function() {
            const data = $8560031dd706a122$export$2b77a92f1a5ad772.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
            data[config](relatedTarget);
        });
    }
}
/**
 * Data API implementation
 */ $8560031dd706a122$var$EventHandler.on(document, $8560031dd706a122$var$EVENT_CLICK_DATA_API$2, $8560031dd706a122$var$SELECTOR_DATA_TOGGLE$2, function(event) {
    const target = $8560031dd706a122$var$SelectorEngine.getElementFromSelector(this);
    if ([
        "A",
        "AREA"
    ].includes(this.tagName)) event.preventDefault();
    $8560031dd706a122$var$EventHandler.one(target, $8560031dd706a122$var$EVENT_SHOW$4, (showEvent)=>{
        if (showEvent.defaultPrevented) // only register focus restorer if modal will actually get shown
        return;
        $8560031dd706a122$var$EventHandler.one(target, $8560031dd706a122$var$EVENT_HIDDEN$4, ()=>{
            if ($8560031dd706a122$var$isVisible(this)) this.focus();
        });
    });
    // avoid conflict when clicking modal toggler while another one is open
    const alreadyOpen = $8560031dd706a122$var$SelectorEngine.findOne($8560031dd706a122$var$OPEN_SELECTOR$1);
    if (alreadyOpen) $8560031dd706a122$export$2b77a92f1a5ad772.getInstance(alreadyOpen).hide();
    const data = $8560031dd706a122$export$2b77a92f1a5ad772.getOrCreateInstance(target);
    data.toggle(this);
});
$8560031dd706a122$var$enableDismissTrigger($8560031dd706a122$export$2b77a92f1a5ad772);
/**
 * jQuery
 */ $8560031dd706a122$var$defineJQueryPlugin($8560031dd706a122$export$2b77a92f1a5ad772);
/**
 * --------------------------------------------------------------------------
 * Bootstrap offcanvas.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $8560031dd706a122$var$NAME$6 = "offcanvas";
const $8560031dd706a122$var$DATA_KEY$3 = "bs.offcanvas";
const $8560031dd706a122$var$EVENT_KEY$3 = `.${$8560031dd706a122$var$DATA_KEY$3}`;
const $8560031dd706a122$var$DATA_API_KEY$1 = ".data-api";
const $8560031dd706a122$var$EVENT_LOAD_DATA_API$2 = `load${$8560031dd706a122$var$EVENT_KEY$3}${$8560031dd706a122$var$DATA_API_KEY$1}`;
const $8560031dd706a122$var$ESCAPE_KEY = "Escape";
const $8560031dd706a122$var$CLASS_NAME_SHOW$3 = "show";
const $8560031dd706a122$var$CLASS_NAME_SHOWING$1 = "showing";
const $8560031dd706a122$var$CLASS_NAME_HIDING = "hiding";
const $8560031dd706a122$var$CLASS_NAME_BACKDROP = "offcanvas-backdrop";
const $8560031dd706a122$var$OPEN_SELECTOR = ".offcanvas.show";
const $8560031dd706a122$var$EVENT_SHOW$3 = `show${$8560031dd706a122$var$EVENT_KEY$3}`;
const $8560031dd706a122$var$EVENT_SHOWN$3 = `shown${$8560031dd706a122$var$EVENT_KEY$3}`;
const $8560031dd706a122$var$EVENT_HIDE$3 = `hide${$8560031dd706a122$var$EVENT_KEY$3}`;
const $8560031dd706a122$var$EVENT_HIDE_PREVENTED = `hidePrevented${$8560031dd706a122$var$EVENT_KEY$3}`;
const $8560031dd706a122$var$EVENT_HIDDEN$3 = `hidden${$8560031dd706a122$var$EVENT_KEY$3}`;
const $8560031dd706a122$var$EVENT_RESIZE = `resize${$8560031dd706a122$var$EVENT_KEY$3}`;
const $8560031dd706a122$var$EVENT_CLICK_DATA_API$1 = `click${$8560031dd706a122$var$EVENT_KEY$3}${$8560031dd706a122$var$DATA_API_KEY$1}`;
const $8560031dd706a122$var$EVENT_KEYDOWN_DISMISS = `keydown.dismiss${$8560031dd706a122$var$EVENT_KEY$3}`;
const $8560031dd706a122$var$SELECTOR_DATA_TOGGLE$1 = '[data-bs-toggle="offcanvas"]';
const $8560031dd706a122$var$Default$5 = {
    backdrop: true,
    keyboard: true,
    scroll: false
};
const $8560031dd706a122$var$DefaultType$5 = {
    backdrop: "(boolean|string)",
    keyboard: "boolean",
    scroll: "boolean"
};
/**
 * Class definition
 */ class $8560031dd706a122$export$591ca0244c9dfcd4 extends $8560031dd706a122$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._isShown = false;
        this._backdrop = this._initializeBackDrop();
        this._focustrap = this._initializeFocusTrap();
        this._addEventListeners();
    }
    // Getters
    static get Default() {
        return $8560031dd706a122$var$Default$5;
    }
    static get DefaultType() {
        return $8560031dd706a122$var$DefaultType$5;
    }
    static get NAME() {
        return $8560031dd706a122$var$NAME$6;
    }
    // Public
    toggle(relatedTarget) {
        return this._isShown ? this.hide() : this.show(relatedTarget);
    }
    show(relatedTarget) {
        if (this._isShown) return;
        const showEvent = $8560031dd706a122$var$EventHandler.trigger(this._element, $8560031dd706a122$var$EVENT_SHOW$3, {
            relatedTarget: relatedTarget
        });
        if (showEvent.defaultPrevented) return;
        this._isShown = true;
        this._backdrop.show();
        if (!this._config.scroll) new $8560031dd706a122$var$ScrollBarHelper().hide();
        this._element.setAttribute("aria-modal", true);
        this._element.setAttribute("role", "dialog");
        this._element.classList.add($8560031dd706a122$var$CLASS_NAME_SHOWING$1);
        const completeCallBack = ()=>{
            if (!this._config.scroll || this._config.backdrop) this._focustrap.activate();
            this._element.classList.add($8560031dd706a122$var$CLASS_NAME_SHOW$3);
            this._element.classList.remove($8560031dd706a122$var$CLASS_NAME_SHOWING$1);
            $8560031dd706a122$var$EventHandler.trigger(this._element, $8560031dd706a122$var$EVENT_SHOWN$3, {
                relatedTarget: relatedTarget
            });
        };
        this._queueCallback(completeCallBack, this._element, true);
    }
    hide() {
        if (!this._isShown) return;
        const hideEvent = $8560031dd706a122$var$EventHandler.trigger(this._element, $8560031dd706a122$var$EVENT_HIDE$3);
        if (hideEvent.defaultPrevented) return;
        this._focustrap.deactivate();
        this._element.blur();
        this._isShown = false;
        this._element.classList.add($8560031dd706a122$var$CLASS_NAME_HIDING);
        this._backdrop.hide();
        const completeCallback = ()=>{
            this._element.classList.remove($8560031dd706a122$var$CLASS_NAME_SHOW$3, $8560031dd706a122$var$CLASS_NAME_HIDING);
            this._element.removeAttribute("aria-modal");
            this._element.removeAttribute("role");
            if (!this._config.scroll) new $8560031dd706a122$var$ScrollBarHelper().reset();
            $8560031dd706a122$var$EventHandler.trigger(this._element, $8560031dd706a122$var$EVENT_HIDDEN$3);
        };
        this._queueCallback(completeCallback, this._element, true);
    }
    dispose() {
        this._backdrop.dispose();
        this._focustrap.deactivate();
        super.dispose();
    }
    // Private
    _initializeBackDrop() {
        const clickCallback = ()=>{
            if (this._config.backdrop === "static") {
                $8560031dd706a122$var$EventHandler.trigger(this._element, $8560031dd706a122$var$EVENT_HIDE_PREVENTED);
                return;
            }
            this.hide();
        };
        // 'static' option will be translated to true, and booleans will keep their value
        const isVisible = Boolean(this._config.backdrop);
        return new $8560031dd706a122$var$Backdrop({
            className: $8560031dd706a122$var$CLASS_NAME_BACKDROP,
            isVisible: isVisible,
            isAnimated: true,
            rootElement: this._element.parentNode,
            clickCallback: isVisible ? clickCallback : null
        });
    }
    _initializeFocusTrap() {
        return new $8560031dd706a122$var$FocusTrap({
            trapElement: this._element
        });
    }
    _addEventListeners() {
        $8560031dd706a122$var$EventHandler.on(this._element, $8560031dd706a122$var$EVENT_KEYDOWN_DISMISS, (event)=>{
            if (event.key !== $8560031dd706a122$var$ESCAPE_KEY) return;
            if (this._config.keyboard) {
                this.hide();
                return;
            }
            $8560031dd706a122$var$EventHandler.trigger(this._element, $8560031dd706a122$var$EVENT_HIDE_PREVENTED);
        });
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $8560031dd706a122$export$591ca0244c9dfcd4.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (data[config] === undefined || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
            data[config](this);
        });
    }
}
/**
 * Data API implementation
 */ $8560031dd706a122$var$EventHandler.on(document, $8560031dd706a122$var$EVENT_CLICK_DATA_API$1, $8560031dd706a122$var$SELECTOR_DATA_TOGGLE$1, function(event) {
    const target = $8560031dd706a122$var$SelectorEngine.getElementFromSelector(this);
    if ([
        "A",
        "AREA"
    ].includes(this.tagName)) event.preventDefault();
    if ($8560031dd706a122$var$isDisabled(this)) return;
    $8560031dd706a122$var$EventHandler.one(target, $8560031dd706a122$var$EVENT_HIDDEN$3, ()=>{
        // focus on trigger when it is closed
        if ($8560031dd706a122$var$isVisible(this)) this.focus();
    });
    // avoid conflict when clicking a toggler of an offcanvas, while another is open
    const alreadyOpen = $8560031dd706a122$var$SelectorEngine.findOne($8560031dd706a122$var$OPEN_SELECTOR);
    if (alreadyOpen && alreadyOpen !== target) $8560031dd706a122$export$591ca0244c9dfcd4.getInstance(alreadyOpen).hide();
    const data = $8560031dd706a122$export$591ca0244c9dfcd4.getOrCreateInstance(target);
    data.toggle(this);
});
$8560031dd706a122$var$EventHandler.on(window, $8560031dd706a122$var$EVENT_LOAD_DATA_API$2, ()=>{
    for (const selector of $8560031dd706a122$var$SelectorEngine.find($8560031dd706a122$var$OPEN_SELECTOR))$8560031dd706a122$export$591ca0244c9dfcd4.getOrCreateInstance(selector).show();
});
$8560031dd706a122$var$EventHandler.on(window, $8560031dd706a122$var$EVENT_RESIZE, ()=>{
    for (const element of $8560031dd706a122$var$SelectorEngine.find("[aria-modal][class*=show][class*=offcanvas-]"))if (getComputedStyle(element).position !== "fixed") $8560031dd706a122$export$591ca0244c9dfcd4.getOrCreateInstance(element).hide();
});
$8560031dd706a122$var$enableDismissTrigger($8560031dd706a122$export$591ca0244c9dfcd4);
/**
 * jQuery
 */ $8560031dd706a122$var$defineJQueryPlugin($8560031dd706a122$export$591ca0244c9dfcd4);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/sanitizer.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ // js-docs-start allow-list
const $8560031dd706a122$var$ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i;
const $8560031dd706a122$var$DefaultAllowlist = {
    // Global attributes allowed on any supplied element below.
    "*": [
        "class",
        "dir",
        "id",
        "lang",
        "role",
        $8560031dd706a122$var$ARIA_ATTRIBUTE_PATTERN
    ],
    a: [
        "target",
        "href",
        "title",
        "rel"
    ],
    area: [],
    b: [],
    br: [],
    col: [],
    code: [],
    dd: [],
    div: [],
    dl: [],
    dt: [],
    em: [],
    hr: [],
    h1: [],
    h2: [],
    h3: [],
    h4: [],
    h5: [],
    h6: [],
    i: [],
    img: [
        "src",
        "srcset",
        "alt",
        "title",
        "width",
        "height"
    ],
    li: [],
    ol: [],
    p: [],
    pre: [],
    s: [],
    small: [],
    span: [],
    sub: [],
    sup: [],
    strong: [],
    u: [],
    ul: []
};
// js-docs-end allow-list
const $8560031dd706a122$var$uriAttributes = new Set([
    "background",
    "cite",
    "href",
    "itemtype",
    "longdesc",
    "poster",
    "src",
    "xlink:href"
]);
/**
 * A pattern that recognizes URLs that are safe wrt. XSS in URL navigation
 * contexts.
 *
 * Shout-out to Angular https://github.com/angular/angular/blob/15.2.8/packages/core/src/sanitization/url_sanitizer.ts#L38
 */ // eslint-disable-next-line unicorn/better-regex
const $8560031dd706a122$var$SAFE_URL_PATTERN = /^(?!javascript:)(?:[a-z0-9+.-]+:|[^&:/?#]*(?:[/?#]|$))/i;
const $8560031dd706a122$var$allowedAttribute = (attribute, allowedAttributeList)=>{
    const attributeName = attribute.nodeName.toLowerCase();
    if (allowedAttributeList.includes(attributeName)) {
        if ($8560031dd706a122$var$uriAttributes.has(attributeName)) return Boolean($8560031dd706a122$var$SAFE_URL_PATTERN.test(attribute.nodeValue));
        return true;
    }
    // Check if a regular expression validates the attribute.
    return allowedAttributeList.filter((attributeRegex)=>attributeRegex instanceof RegExp).some((regex)=>regex.test(attributeName));
};
function $8560031dd706a122$var$sanitizeHtml(unsafeHtml, allowList, sanitizeFunction) {
    if (!unsafeHtml.length) return unsafeHtml;
    if (sanitizeFunction && typeof sanitizeFunction === "function") return sanitizeFunction(unsafeHtml);
    const domParser = new window.DOMParser();
    const createdDocument = domParser.parseFromString(unsafeHtml, "text/html");
    const elements = [].concat(...createdDocument.body.querySelectorAll("*"));
    for (const element of elements){
        const elementName = element.nodeName.toLowerCase();
        if (!Object.keys(allowList).includes(elementName)) {
            element.remove();
            continue;
        }
        const attributeList = [].concat(...element.attributes);
        const allowedAttributes = [].concat(allowList["*"] || [], allowList[elementName] || []);
        for (const attribute of attributeList)if (!$8560031dd706a122$var$allowedAttribute(attribute, allowedAttributes)) element.removeAttribute(attribute.nodeName);
    }
    return createdDocument.body.innerHTML;
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/template-factory.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $8560031dd706a122$var$NAME$5 = "TemplateFactory";
const $8560031dd706a122$var$Default$4 = {
    allowList: $8560031dd706a122$var$DefaultAllowlist,
    content: {},
    // { selector : text ,  selector2 : text2 , }
    extraClass: "",
    html: false,
    sanitize: true,
    sanitizeFn: null,
    template: "<div></div>"
};
const $8560031dd706a122$var$DefaultType$4 = {
    allowList: "object",
    content: "object",
    extraClass: "(string|function)",
    html: "boolean",
    sanitize: "boolean",
    sanitizeFn: "(null|function)",
    template: "string"
};
const $8560031dd706a122$var$DefaultContentType = {
    entry: "(string|element|function|null)",
    selector: "(string|element)"
};
/**
 * Class definition
 */ class $8560031dd706a122$var$TemplateFactory extends $8560031dd706a122$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
    }
    // Getters
    static get Default() {
        return $8560031dd706a122$var$Default$4;
    }
    static get DefaultType() {
        return $8560031dd706a122$var$DefaultType$4;
    }
    static get NAME() {
        return $8560031dd706a122$var$NAME$5;
    }
    // Public
    getContent() {
        return Object.values(this._config.content).map((config)=>this._resolvePossibleFunction(config)).filter(Boolean);
    }
    hasContent() {
        return this.getContent().length > 0;
    }
    changeContent(content) {
        this._checkContent(content);
        this._config.content = {
            ...this._config.content,
            ...content
        };
        return this;
    }
    toHtml() {
        const templateWrapper = document.createElement("div");
        templateWrapper.innerHTML = this._maybeSanitize(this._config.template);
        for (const [selector, text] of Object.entries(this._config.content))this._setContent(templateWrapper, text, selector);
        const template = templateWrapper.children[0];
        const extraClass = this._resolvePossibleFunction(this._config.extraClass);
        if (extraClass) template.classList.add(...extraClass.split(" "));
        return template;
    }
    // Private
    _typeCheckConfig(config) {
        super._typeCheckConfig(config);
        this._checkContent(config.content);
    }
    _checkContent(arg) {
        for (const [selector, content] of Object.entries(arg))super._typeCheckConfig({
            selector: selector,
            entry: content
        }, $8560031dd706a122$var$DefaultContentType);
    }
    _setContent(template, content, selector) {
        const templateElement = $8560031dd706a122$var$SelectorEngine.findOne(selector, template);
        if (!templateElement) return;
        content = this._resolvePossibleFunction(content);
        if (!content) {
            templateElement.remove();
            return;
        }
        if ($8560031dd706a122$var$isElement(content)) {
            this._putElementInTemplate($8560031dd706a122$var$getElement(content), templateElement);
            return;
        }
        if (this._config.html) {
            templateElement.innerHTML = this._maybeSanitize(content);
            return;
        }
        templateElement.textContent = content;
    }
    _maybeSanitize(arg) {
        return this._config.sanitize ? $8560031dd706a122$var$sanitizeHtml(arg, this._config.allowList, this._config.sanitizeFn) : arg;
    }
    _resolvePossibleFunction(arg) {
        return $8560031dd706a122$var$execute(arg, [
            this
        ]);
    }
    _putElementInTemplate(element, templateElement) {
        if (this._config.html) {
            templateElement.innerHTML = "";
            templateElement.append(element);
            return;
        }
        templateElement.textContent = element.textContent;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap tooltip.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $8560031dd706a122$var$NAME$4 = "tooltip";
const $8560031dd706a122$var$DISALLOWED_ATTRIBUTES = new Set([
    "sanitize",
    "allowList",
    "sanitizeFn"
]);
const $8560031dd706a122$var$CLASS_NAME_FADE$2 = "fade";
const $8560031dd706a122$var$CLASS_NAME_MODAL = "modal";
const $8560031dd706a122$var$CLASS_NAME_SHOW$2 = "show";
const $8560031dd706a122$var$SELECTOR_TOOLTIP_INNER = ".tooltip-inner";
const $8560031dd706a122$var$SELECTOR_MODAL = `.${$8560031dd706a122$var$CLASS_NAME_MODAL}`;
const $8560031dd706a122$var$EVENT_MODAL_HIDE = "hide.bs.modal";
const $8560031dd706a122$var$TRIGGER_HOVER = "hover";
const $8560031dd706a122$var$TRIGGER_FOCUS = "focus";
const $8560031dd706a122$var$TRIGGER_CLICK = "click";
const $8560031dd706a122$var$TRIGGER_MANUAL = "manual";
const $8560031dd706a122$var$EVENT_HIDE$2 = "hide";
const $8560031dd706a122$var$EVENT_HIDDEN$2 = "hidden";
const $8560031dd706a122$var$EVENT_SHOW$2 = "show";
const $8560031dd706a122$var$EVENT_SHOWN$2 = "shown";
const $8560031dd706a122$var$EVENT_INSERTED = "inserted";
const $8560031dd706a122$var$EVENT_CLICK$1 = "click";
const $8560031dd706a122$var$EVENT_FOCUSIN$1 = "focusin";
const $8560031dd706a122$var$EVENT_FOCUSOUT$1 = "focusout";
const $8560031dd706a122$var$EVENT_MOUSEENTER = "mouseenter";
const $8560031dd706a122$var$EVENT_MOUSELEAVE = "mouseleave";
const $8560031dd706a122$var$AttachmentMap = {
    AUTO: "auto",
    TOP: "top",
    RIGHT: $8560031dd706a122$var$isRTL() ? "left" : "right",
    BOTTOM: "bottom",
    LEFT: $8560031dd706a122$var$isRTL() ? "right" : "left"
};
const $8560031dd706a122$var$Default$3 = {
    allowList: $8560031dd706a122$var$DefaultAllowlist,
    animation: true,
    boundary: "clippingParents",
    container: false,
    customClass: "",
    delay: 0,
    fallbackPlacements: [
        "top",
        "right",
        "bottom",
        "left"
    ],
    html: false,
    offset: [
        0,
        6
    ],
    placement: "top",
    popperConfig: null,
    sanitize: true,
    sanitizeFn: null,
    selector: false,
    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
    title: "",
    trigger: "hover focus"
};
const $8560031dd706a122$var$DefaultType$3 = {
    allowList: "object",
    animation: "boolean",
    boundary: "(string|element)",
    container: "(string|element|boolean)",
    customClass: "(string|function)",
    delay: "(number|object)",
    fallbackPlacements: "array",
    html: "boolean",
    offset: "(array|string|function)",
    placement: "(string|function)",
    popperConfig: "(null|object|function)",
    sanitize: "boolean",
    sanitizeFn: "(null|function)",
    selector: "(string|boolean)",
    template: "string",
    title: "(string|element|function)",
    trigger: "string"
};
/**
 * Class definition
 */ class $8560031dd706a122$export$28c660c63b792dea extends $8560031dd706a122$var$BaseComponent {
    constructor(element, config){
        if (typeof $adf6c43f8c27fe04$exports === "undefined") throw new TypeError("Bootstrap's tooltips require Popper (https://popper.js.org)");
        super(element, config);
        // Private
        this._isEnabled = true;
        this._timeout = 0;
        this._isHovered = null;
        this._activeTrigger = {};
        this._popper = null;
        this._templateFactory = null;
        this._newContent = null;
        // Protected
        this.tip = null;
        this._setListeners();
        if (!this._config.selector) this._fixTitle();
    }
    // Getters
    static get Default() {
        return $8560031dd706a122$var$Default$3;
    }
    static get DefaultType() {
        return $8560031dd706a122$var$DefaultType$3;
    }
    static get NAME() {
        return $8560031dd706a122$var$NAME$4;
    }
    // Public
    enable() {
        this._isEnabled = true;
    }
    disable() {
        this._isEnabled = false;
    }
    toggleEnabled() {
        this._isEnabled = !this._isEnabled;
    }
    toggle() {
        if (!this._isEnabled) return;
        this._activeTrigger.click = !this._activeTrigger.click;
        if (this._isShown()) {
            this._leave();
            return;
        }
        this._enter();
    }
    dispose() {
        clearTimeout(this._timeout);
        $8560031dd706a122$var$EventHandler.off(this._element.closest($8560031dd706a122$var$SELECTOR_MODAL), $8560031dd706a122$var$EVENT_MODAL_HIDE, this._hideModalHandler);
        if (this._element.getAttribute("data-bs-original-title")) this._element.setAttribute("title", this._element.getAttribute("data-bs-original-title"));
        this._disposePopper();
        super.dispose();
    }
    show() {
        if (this._element.style.display === "none") throw new Error("Please use show on visible elements");
        if (!(this._isWithContent() && this._isEnabled)) return;
        const showEvent = $8560031dd706a122$var$EventHandler.trigger(this._element, this.constructor.eventName($8560031dd706a122$var$EVENT_SHOW$2));
        const shadowRoot = $8560031dd706a122$var$findShadowRoot(this._element);
        const isInTheDom = (shadowRoot || this._element.ownerDocument.documentElement).contains(this._element);
        if (showEvent.defaultPrevented || !isInTheDom) return;
        // TODO: v6 remove this or make it optional
        this._disposePopper();
        const tip = this._getTipElement();
        this._element.setAttribute("aria-describedby", tip.getAttribute("id"));
        const { container: container } = this._config;
        if (!this._element.ownerDocument.documentElement.contains(this.tip)) {
            container.append(tip);
            $8560031dd706a122$var$EventHandler.trigger(this._element, this.constructor.eventName($8560031dd706a122$var$EVENT_INSERTED));
        }
        this._popper = this._createPopper(tip);
        tip.classList.add($8560031dd706a122$var$CLASS_NAME_SHOW$2);
        // If this is a touch-enabled device we add extra
        // empty mouseover listeners to the body's immediate children;
        // only needed because of broken event delegation on iOS
        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
        if ("ontouchstart" in document.documentElement) for (const element of [].concat(...document.body.children))$8560031dd706a122$var$EventHandler.on(element, "mouseover", $8560031dd706a122$var$noop);
        const complete = ()=>{
            $8560031dd706a122$var$EventHandler.trigger(this._element, this.constructor.eventName($8560031dd706a122$var$EVENT_SHOWN$2));
            if (this._isHovered === false) this._leave();
            this._isHovered = false;
        };
        this._queueCallback(complete, this.tip, this._isAnimated());
    }
    hide() {
        if (!this._isShown()) return;
        const hideEvent = $8560031dd706a122$var$EventHandler.trigger(this._element, this.constructor.eventName($8560031dd706a122$var$EVENT_HIDE$2));
        if (hideEvent.defaultPrevented) return;
        const tip = this._getTipElement();
        tip.classList.remove($8560031dd706a122$var$CLASS_NAME_SHOW$2);
        // If this is a touch-enabled device we remove the extra
        // empty mouseover listeners we added for iOS support
        if ("ontouchstart" in document.documentElement) for (const element of [].concat(...document.body.children))$8560031dd706a122$var$EventHandler.off(element, "mouseover", $8560031dd706a122$var$noop);
        this._activeTrigger[$8560031dd706a122$var$TRIGGER_CLICK] = false;
        this._activeTrigger[$8560031dd706a122$var$TRIGGER_FOCUS] = false;
        this._activeTrigger[$8560031dd706a122$var$TRIGGER_HOVER] = false;
        this._isHovered = null; // it is a trick to support manual triggering
        const complete = ()=>{
            if (this._isWithActiveTrigger()) return;
            if (!this._isHovered) this._disposePopper();
            this._element.removeAttribute("aria-describedby");
            $8560031dd706a122$var$EventHandler.trigger(this._element, this.constructor.eventName($8560031dd706a122$var$EVENT_HIDDEN$2));
        };
        this._queueCallback(complete, this.tip, this._isAnimated());
    }
    update() {
        if (this._popper) this._popper.update();
    }
    // Protected
    _isWithContent() {
        return Boolean(this._getTitle());
    }
    _getTipElement() {
        if (!this.tip) this.tip = this._createTipElement(this._newContent || this._getContentForTemplate());
        return this.tip;
    }
    _createTipElement(content) {
        const tip = this._getTemplateFactory(content).toHtml();
        // TODO: remove this check in v6
        if (!tip) return null;
        tip.classList.remove($8560031dd706a122$var$CLASS_NAME_FADE$2, $8560031dd706a122$var$CLASS_NAME_SHOW$2);
        // TODO: v6 the following can be achieved with CSS only
        tip.classList.add(`bs-${this.constructor.NAME}-auto`);
        const tipId = $8560031dd706a122$var$getUID(this.constructor.NAME).toString();
        tip.setAttribute("id", tipId);
        if (this._isAnimated()) tip.classList.add($8560031dd706a122$var$CLASS_NAME_FADE$2);
        return tip;
    }
    setContent(content) {
        this._newContent = content;
        if (this._isShown()) {
            this._disposePopper();
            this.show();
        }
    }
    _getTemplateFactory(content) {
        if (this._templateFactory) this._templateFactory.changeContent(content);
        else this._templateFactory = new $8560031dd706a122$var$TemplateFactory({
            ...this._config,
            content: // the `content` var has to be after `this._config`
            // to override config.content in case of popover
            content,
            extraClass: this._resolvePossibleFunction(this._config.customClass)
        });
        return this._templateFactory;
    }
    _getContentForTemplate() {
        return {
            [$8560031dd706a122$var$SELECTOR_TOOLTIP_INNER]: this._getTitle()
        };
    }
    _getTitle() {
        return this._resolvePossibleFunction(this._config.title) || this._element.getAttribute("data-bs-original-title");
    }
    // Private
    _initializeOnDelegatedTarget(event) {
        return this.constructor.getOrCreateInstance(event.delegateTarget, this._getDelegateConfig());
    }
    _isAnimated() {
        return this._config.animation || this.tip && this.tip.classList.contains($8560031dd706a122$var$CLASS_NAME_FADE$2);
    }
    _isShown() {
        return this.tip && this.tip.classList.contains($8560031dd706a122$var$CLASS_NAME_SHOW$2);
    }
    _createPopper(tip) {
        const placement = $8560031dd706a122$var$execute(this._config.placement, [
            this,
            tip,
            this._element
        ]);
        const attachment = $8560031dd706a122$var$AttachmentMap[placement.toUpperCase()];
        return $adf6c43f8c27fe04$exports.createPopper(this._element, tip, this._getPopperConfig(attachment));
    }
    _getOffset() {
        const { offset: offset } = this._config;
        if (typeof offset === "string") return offset.split(",").map((value)=>Number.parseInt(value, 10));
        if (typeof offset === "function") return (popperData)=>offset(popperData, this._element);
        return offset;
    }
    _resolvePossibleFunction(arg) {
        return $8560031dd706a122$var$execute(arg, [
            this._element
        ]);
    }
    _getPopperConfig(attachment) {
        const defaultBsPopperConfig = {
            placement: attachment,
            modifiers: [
                {
                    name: "flip",
                    options: {
                        fallbackPlacements: this._config.fallbackPlacements
                    }
                },
                {
                    name: "offset",
                    options: {
                        offset: this._getOffset()
                    }
                },
                {
                    name: "preventOverflow",
                    options: {
                        boundary: this._config.boundary
                    }
                },
                {
                    name: "arrow",
                    options: {
                        element: `.${this.constructor.NAME}-arrow`
                    }
                },
                {
                    name: "preSetPlacement",
                    enabled: true,
                    phase: "beforeMain",
                    fn: (data)=>{
                        // Pre-set Popper's placement attribute in order to read the arrow sizes properly.
                        // Otherwise, Popper mixes up the width and height dimensions since the initial arrow style is for top placement
                        this._getTipElement().setAttribute("data-popper-placement", data.state.placement);
                    }
                }
            ]
        };
        return {
            ...defaultBsPopperConfig,
            ...$8560031dd706a122$var$execute(this._config.popperConfig, [
                defaultBsPopperConfig
            ])
        };
    }
    _setListeners() {
        const triggers = this._config.trigger.split(" ");
        for (const trigger of triggers){
            if (trigger === "click") $8560031dd706a122$var$EventHandler.on(this._element, this.constructor.eventName($8560031dd706a122$var$EVENT_CLICK$1), this._config.selector, (event)=>{
                const context = this._initializeOnDelegatedTarget(event);
                context.toggle();
            });
            else if (trigger !== $8560031dd706a122$var$TRIGGER_MANUAL) {
                const eventIn = trigger === $8560031dd706a122$var$TRIGGER_HOVER ? this.constructor.eventName($8560031dd706a122$var$EVENT_MOUSEENTER) : this.constructor.eventName($8560031dd706a122$var$EVENT_FOCUSIN$1);
                const eventOut = trigger === $8560031dd706a122$var$TRIGGER_HOVER ? this.constructor.eventName($8560031dd706a122$var$EVENT_MOUSELEAVE) : this.constructor.eventName($8560031dd706a122$var$EVENT_FOCUSOUT$1);
                $8560031dd706a122$var$EventHandler.on(this._element, eventIn, this._config.selector, (event)=>{
                    const context = this._initializeOnDelegatedTarget(event);
                    context._activeTrigger[event.type === "focusin" ? $8560031dd706a122$var$TRIGGER_FOCUS : $8560031dd706a122$var$TRIGGER_HOVER] = true;
                    context._enter();
                });
                $8560031dd706a122$var$EventHandler.on(this._element, eventOut, this._config.selector, (event)=>{
                    const context = this._initializeOnDelegatedTarget(event);
                    context._activeTrigger[event.type === "focusout" ? $8560031dd706a122$var$TRIGGER_FOCUS : $8560031dd706a122$var$TRIGGER_HOVER] = context._element.contains(event.relatedTarget);
                    context._leave();
                });
            }
        }
        this._hideModalHandler = ()=>{
            if (this._element) this.hide();
        };
        $8560031dd706a122$var$EventHandler.on(this._element.closest($8560031dd706a122$var$SELECTOR_MODAL), $8560031dd706a122$var$EVENT_MODAL_HIDE, this._hideModalHandler);
    }
    _fixTitle() {
        const title = this._element.getAttribute("title");
        if (!title) return;
        if (!this._element.getAttribute("aria-label") && !this._element.textContent.trim()) this._element.setAttribute("aria-label", title);
        this._element.setAttribute("data-bs-original-title", title); // DO NOT USE IT. Is only for backwards compatibility
        this._element.removeAttribute("title");
    }
    _enter() {
        if (this._isShown() || this._isHovered) {
            this._isHovered = true;
            return;
        }
        this._isHovered = true;
        this._setTimeout(()=>{
            if (this._isHovered) this.show();
        }, this._config.delay.show);
    }
    _leave() {
        if (this._isWithActiveTrigger()) return;
        this._isHovered = false;
        this._setTimeout(()=>{
            if (!this._isHovered) this.hide();
        }, this._config.delay.hide);
    }
    _setTimeout(handler, timeout) {
        clearTimeout(this._timeout);
        this._timeout = setTimeout(handler, timeout);
    }
    _isWithActiveTrigger() {
        return Object.values(this._activeTrigger).includes(true);
    }
    _getConfig(config) {
        const dataAttributes = $8560031dd706a122$var$Manipulator.getDataAttributes(this._element);
        for (const dataAttribute of Object.keys(dataAttributes))if ($8560031dd706a122$var$DISALLOWED_ATTRIBUTES.has(dataAttribute)) delete dataAttributes[dataAttribute];
        config = {
            ...dataAttributes,
            ...typeof config === "object" && config ? config : {}
        };
        config = this._mergeConfigObj(config);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    _configAfterMerge(config) {
        config.container = config.container === false ? document.body : $8560031dd706a122$var$getElement(config.container);
        if (typeof config.delay === "number") config.delay = {
            show: config.delay,
            hide: config.delay
        };
        if (typeof config.title === "number") config.title = config.title.toString();
        if (typeof config.content === "number") config.content = config.content.toString();
        return config;
    }
    _getDelegateConfig() {
        const config = {};
        for (const [key, value] of Object.entries(this._config))if (this.constructor.Default[key] !== value) config[key] = value;
        config.selector = false;
        config.trigger = "manual";
        // In the future can be replaced with:
        // const keysWithDifferentValues = Object.entries(this._config).filter(entry => this.constructor.Default[entry[0]] !== this._config[entry[0]])
        // `Object.fromEntries(keysWithDifferentValues)`
        return config;
    }
    _disposePopper() {
        if (this._popper) {
            this._popper.destroy();
            this._popper = null;
        }
        if (this.tip) {
            this.tip.remove();
            this.tip = null;
        }
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $8560031dd706a122$export$28c660c63b792dea.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * jQuery
 */ $8560031dd706a122$var$defineJQueryPlugin($8560031dd706a122$export$28c660c63b792dea);
/**
 * --------------------------------------------------------------------------
 * Bootstrap popover.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $8560031dd706a122$var$NAME$3 = "popover";
const $8560031dd706a122$var$SELECTOR_TITLE = ".popover-header";
const $8560031dd706a122$var$SELECTOR_CONTENT = ".popover-body";
const $8560031dd706a122$var$Default$2 = {
    ...$8560031dd706a122$export$28c660c63b792dea.Default,
    content: "",
    offset: [
        0,
        8
    ],
    placement: "right",
    template: '<div class="popover" role="tooltip"><div class="popover-arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>',
    trigger: "click"
};
const $8560031dd706a122$var$DefaultType$2 = {
    ...$8560031dd706a122$export$28c660c63b792dea.DefaultType,
    content: "(null|string|element|function)"
};
/**
 * Class definition
 */ class $8560031dd706a122$export$5b6b19405a83ff9d extends $8560031dd706a122$export$28c660c63b792dea {
    // Getters
    static get Default() {
        return $8560031dd706a122$var$Default$2;
    }
    static get DefaultType() {
        return $8560031dd706a122$var$DefaultType$2;
    }
    static get NAME() {
        return $8560031dd706a122$var$NAME$3;
    }
    // Overrides
    _isWithContent() {
        return this._getTitle() || this._getContent();
    }
    // Private
    _getContentForTemplate() {
        return {
            [$8560031dd706a122$var$SELECTOR_TITLE]: this._getTitle(),
            [$8560031dd706a122$var$SELECTOR_CONTENT]: this._getContent()
        };
    }
    _getContent() {
        return this._resolvePossibleFunction(this._config.content);
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $8560031dd706a122$export$5b6b19405a83ff9d.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * jQuery
 */ $8560031dd706a122$var$defineJQueryPlugin($8560031dd706a122$export$5b6b19405a83ff9d);
/**
 * --------------------------------------------------------------------------
 * Bootstrap scrollspy.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $8560031dd706a122$var$NAME$2 = "scrollspy";
const $8560031dd706a122$var$DATA_KEY$2 = "bs.scrollspy";
const $8560031dd706a122$var$EVENT_KEY$2 = `.${$8560031dd706a122$var$DATA_KEY$2}`;
const $8560031dd706a122$var$DATA_API_KEY = ".data-api";
const $8560031dd706a122$var$EVENT_ACTIVATE = `activate${$8560031dd706a122$var$EVENT_KEY$2}`;
const $8560031dd706a122$var$EVENT_CLICK = `click${$8560031dd706a122$var$EVENT_KEY$2}`;
const $8560031dd706a122$var$EVENT_LOAD_DATA_API$1 = `load${$8560031dd706a122$var$EVENT_KEY$2}${$8560031dd706a122$var$DATA_API_KEY}`;
const $8560031dd706a122$var$CLASS_NAME_DROPDOWN_ITEM = "dropdown-item";
const $8560031dd706a122$var$CLASS_NAME_ACTIVE$1 = "active";
const $8560031dd706a122$var$SELECTOR_DATA_SPY = '[data-bs-spy="scroll"]';
const $8560031dd706a122$var$SELECTOR_TARGET_LINKS = "[href]";
const $8560031dd706a122$var$SELECTOR_NAV_LIST_GROUP = ".nav, .list-group";
const $8560031dd706a122$var$SELECTOR_NAV_LINKS = ".nav-link";
const $8560031dd706a122$var$SELECTOR_NAV_ITEMS = ".nav-item";
const $8560031dd706a122$var$SELECTOR_LIST_ITEMS = ".list-group-item";
const $8560031dd706a122$var$SELECTOR_LINK_ITEMS = `${$8560031dd706a122$var$SELECTOR_NAV_LINKS}, ${$8560031dd706a122$var$SELECTOR_NAV_ITEMS} > ${$8560031dd706a122$var$SELECTOR_NAV_LINKS}, ${$8560031dd706a122$var$SELECTOR_LIST_ITEMS}`;
const $8560031dd706a122$var$SELECTOR_DROPDOWN = ".dropdown";
const $8560031dd706a122$var$SELECTOR_DROPDOWN_TOGGLE$1 = ".dropdown-toggle";
const $8560031dd706a122$var$Default$1 = {
    offset: null,
    // TODO: v6 @deprecated, keep it for backwards compatibility reasons
    rootMargin: "0px 0px -25%",
    smoothScroll: false,
    target: null,
    threshold: [
        0.1,
        0.5,
        1
    ]
};
const $8560031dd706a122$var$DefaultType$1 = {
    offset: "(number|null)",
    // TODO v6 @deprecated, keep it for backwards compatibility reasons
    rootMargin: "string",
    smoothScroll: "boolean",
    target: "element",
    threshold: "array"
};
/**
 * Class definition
 */ class $8560031dd706a122$export$a6472a5298a374be extends $8560031dd706a122$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        // this._element is the observablesContainer and config.target the menu links wrapper
        this._targetLinks = new Map();
        this._observableSections = new Map();
        this._rootElement = getComputedStyle(this._element).overflowY === "visible" ? null : this._element;
        this._activeTarget = null;
        this._observer = null;
        this._previousScrollData = {
            visibleEntryTop: 0,
            parentScrollTop: 0
        };
        this.refresh(); // initialize
    }
    // Getters
    static get Default() {
        return $8560031dd706a122$var$Default$1;
    }
    static get DefaultType() {
        return $8560031dd706a122$var$DefaultType$1;
    }
    static get NAME() {
        return $8560031dd706a122$var$NAME$2;
    }
    // Public
    refresh() {
        this._initializeTargetsAndObservables();
        this._maybeEnableSmoothScroll();
        if (this._observer) this._observer.disconnect();
        else this._observer = this._getNewObserver();
        for (const section of this._observableSections.values())this._observer.observe(section);
    }
    dispose() {
        this._observer.disconnect();
        super.dispose();
    }
    // Private
    _configAfterMerge(config) {
        // TODO: on v6 target should be given explicitly & remove the {target: 'ss-target'} case
        config.target = $8560031dd706a122$var$getElement(config.target) || document.body;
        // TODO: v6 Only for backwards compatibility reasons. Use rootMargin only
        config.rootMargin = config.offset ? `${config.offset}px 0px -30%` : config.rootMargin;
        if (typeof config.threshold === "string") config.threshold = config.threshold.split(",").map((value)=>Number.parseFloat(value));
        return config;
    }
    _maybeEnableSmoothScroll() {
        if (!this._config.smoothScroll) return;
        // unregister any previous listeners
        $8560031dd706a122$var$EventHandler.off(this._config.target, $8560031dd706a122$var$EVENT_CLICK);
        $8560031dd706a122$var$EventHandler.on(this._config.target, $8560031dd706a122$var$EVENT_CLICK, $8560031dd706a122$var$SELECTOR_TARGET_LINKS, (event)=>{
            const observableSection = this._observableSections.get(event.target.hash);
            if (observableSection) {
                event.preventDefault();
                const root = this._rootElement || window;
                const height = observableSection.offsetTop - this._element.offsetTop;
                if (root.scrollTo) {
                    root.scrollTo({
                        top: height,
                        behavior: "smooth"
                    });
                    return;
                }
                // Chrome 60 doesn't support `scrollTo`
                root.scrollTop = height;
            }
        });
    }
    _getNewObserver() {
        const options = {
            root: this._rootElement,
            threshold: this._config.threshold,
            rootMargin: this._config.rootMargin
        };
        return new IntersectionObserver((entries)=>this._observerCallback(entries), options);
    }
    // The logic of selection
    _observerCallback(entries) {
        const targetElement = (entry)=>this._targetLinks.get(`#${entry.target.id}`);
        const activate = (entry)=>{
            this._previousScrollData.visibleEntryTop = entry.target.offsetTop;
            this._process(targetElement(entry));
        };
        const parentScrollTop = (this._rootElement || document.documentElement).scrollTop;
        const userScrollsDown = parentScrollTop >= this._previousScrollData.parentScrollTop;
        this._previousScrollData.parentScrollTop = parentScrollTop;
        for (const entry of entries){
            if (!entry.isIntersecting) {
                this._activeTarget = null;
                this._clearActiveClass(targetElement(entry));
                continue;
            }
            const entryIsLowerThanPrevious = entry.target.offsetTop >= this._previousScrollData.visibleEntryTop;
            // if we are scrolling down, pick the bigger offsetTop
            if (userScrollsDown && entryIsLowerThanPrevious) {
                activate(entry);
                // if parent isn't scrolled, let's keep the first visible item, breaking the iteration
                if (!parentScrollTop) return;
                continue;
            }
            // if we are scrolling up, pick the smallest offsetTop
            if (!userScrollsDown && !entryIsLowerThanPrevious) activate(entry);
        }
    }
    _initializeTargetsAndObservables() {
        this._targetLinks = new Map();
        this._observableSections = new Map();
        const targetLinks = $8560031dd706a122$var$SelectorEngine.find($8560031dd706a122$var$SELECTOR_TARGET_LINKS, this._config.target);
        for (const anchor of targetLinks){
            // ensure that the anchor has an id and is not disabled
            if (!anchor.hash || $8560031dd706a122$var$isDisabled(anchor)) continue;
            const observableSection = $8560031dd706a122$var$SelectorEngine.findOne(decodeURI(anchor.hash), this._element);
            // ensure that the observableSection exists & is visible
            if ($8560031dd706a122$var$isVisible(observableSection)) {
                this._targetLinks.set(decodeURI(anchor.hash), anchor);
                this._observableSections.set(anchor.hash, observableSection);
            }
        }
    }
    _process(target) {
        if (this._activeTarget === target) return;
        this._clearActiveClass(this._config.target);
        this._activeTarget = target;
        target.classList.add($8560031dd706a122$var$CLASS_NAME_ACTIVE$1);
        this._activateParents(target);
        $8560031dd706a122$var$EventHandler.trigger(this._element, $8560031dd706a122$var$EVENT_ACTIVATE, {
            relatedTarget: target
        });
    }
    _activateParents(target) {
        // Activate dropdown parents
        if (target.classList.contains($8560031dd706a122$var$CLASS_NAME_DROPDOWN_ITEM)) {
            $8560031dd706a122$var$SelectorEngine.findOne($8560031dd706a122$var$SELECTOR_DROPDOWN_TOGGLE$1, target.closest($8560031dd706a122$var$SELECTOR_DROPDOWN)).classList.add($8560031dd706a122$var$CLASS_NAME_ACTIVE$1);
            return;
        }
        for (const listGroup of $8560031dd706a122$var$SelectorEngine.parents(target, $8560031dd706a122$var$SELECTOR_NAV_LIST_GROUP))// Set triggered links parents as active
        // With both <ul> and <nav> markup a parent is the previous sibling of any nav ancestor
        for (const item of $8560031dd706a122$var$SelectorEngine.prev(listGroup, $8560031dd706a122$var$SELECTOR_LINK_ITEMS))item.classList.add($8560031dd706a122$var$CLASS_NAME_ACTIVE$1);
    }
    _clearActiveClass(parent) {
        parent.classList.remove($8560031dd706a122$var$CLASS_NAME_ACTIVE$1);
        const activeNodes = $8560031dd706a122$var$SelectorEngine.find(`${$8560031dd706a122$var$SELECTOR_TARGET_LINKS}.${$8560031dd706a122$var$CLASS_NAME_ACTIVE$1}`, parent);
        for (const node of activeNodes)node.classList.remove($8560031dd706a122$var$CLASS_NAME_ACTIVE$1);
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $8560031dd706a122$export$a6472a5298a374be.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (data[config] === undefined || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $8560031dd706a122$var$EventHandler.on(window, $8560031dd706a122$var$EVENT_LOAD_DATA_API$1, ()=>{
    for (const spy of $8560031dd706a122$var$SelectorEngine.find($8560031dd706a122$var$SELECTOR_DATA_SPY))$8560031dd706a122$export$a6472a5298a374be.getOrCreateInstance(spy);
});
/**
 * jQuery
 */ $8560031dd706a122$var$defineJQueryPlugin($8560031dd706a122$export$a6472a5298a374be);
/**
 * --------------------------------------------------------------------------
 * Bootstrap tab.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $8560031dd706a122$var$NAME$1 = "tab";
const $8560031dd706a122$var$DATA_KEY$1 = "bs.tab";
const $8560031dd706a122$var$EVENT_KEY$1 = `.${$8560031dd706a122$var$DATA_KEY$1}`;
const $8560031dd706a122$var$EVENT_HIDE$1 = `hide${$8560031dd706a122$var$EVENT_KEY$1}`;
const $8560031dd706a122$var$EVENT_HIDDEN$1 = `hidden${$8560031dd706a122$var$EVENT_KEY$1}`;
const $8560031dd706a122$var$EVENT_SHOW$1 = `show${$8560031dd706a122$var$EVENT_KEY$1}`;
const $8560031dd706a122$var$EVENT_SHOWN$1 = `shown${$8560031dd706a122$var$EVENT_KEY$1}`;
const $8560031dd706a122$var$EVENT_CLICK_DATA_API = `click${$8560031dd706a122$var$EVENT_KEY$1}`;
const $8560031dd706a122$var$EVENT_KEYDOWN = `keydown${$8560031dd706a122$var$EVENT_KEY$1}`;
const $8560031dd706a122$var$EVENT_LOAD_DATA_API = `load${$8560031dd706a122$var$EVENT_KEY$1}`;
const $8560031dd706a122$var$ARROW_LEFT_KEY = "ArrowLeft";
const $8560031dd706a122$var$ARROW_RIGHT_KEY = "ArrowRight";
const $8560031dd706a122$var$ARROW_UP_KEY = "ArrowUp";
const $8560031dd706a122$var$ARROW_DOWN_KEY = "ArrowDown";
const $8560031dd706a122$var$HOME_KEY = "Home";
const $8560031dd706a122$var$END_KEY = "End";
const $8560031dd706a122$var$CLASS_NAME_ACTIVE = "active";
const $8560031dd706a122$var$CLASS_NAME_FADE$1 = "fade";
const $8560031dd706a122$var$CLASS_NAME_SHOW$1 = "show";
const $8560031dd706a122$var$CLASS_DROPDOWN = "dropdown";
const $8560031dd706a122$var$SELECTOR_DROPDOWN_TOGGLE = ".dropdown-toggle";
const $8560031dd706a122$var$SELECTOR_DROPDOWN_MENU = ".dropdown-menu";
const $8560031dd706a122$var$NOT_SELECTOR_DROPDOWN_TOGGLE = `:not(${$8560031dd706a122$var$SELECTOR_DROPDOWN_TOGGLE})`;
const $8560031dd706a122$var$SELECTOR_TAB_PANEL = '.list-group, .nav, [role="tablist"]';
const $8560031dd706a122$var$SELECTOR_OUTER = ".nav-item, .list-group-item";
const $8560031dd706a122$var$SELECTOR_INNER = `.nav-link${$8560031dd706a122$var$NOT_SELECTOR_DROPDOWN_TOGGLE}, .list-group-item${$8560031dd706a122$var$NOT_SELECTOR_DROPDOWN_TOGGLE}, [role="tab"]${$8560031dd706a122$var$NOT_SELECTOR_DROPDOWN_TOGGLE}`;
const $8560031dd706a122$var$SELECTOR_DATA_TOGGLE = '[data-bs-toggle="tab"], [data-bs-toggle="pill"], [data-bs-toggle="list"]'; // TODO: could only be `tab` in v6
const $8560031dd706a122$var$SELECTOR_INNER_ELEM = `${$8560031dd706a122$var$SELECTOR_INNER}, ${$8560031dd706a122$var$SELECTOR_DATA_TOGGLE}`;
const $8560031dd706a122$var$SELECTOR_DATA_TOGGLE_ACTIVE = `.${$8560031dd706a122$var$CLASS_NAME_ACTIVE}[data-bs-toggle="tab"], .${$8560031dd706a122$var$CLASS_NAME_ACTIVE}[data-bs-toggle="pill"], .${$8560031dd706a122$var$CLASS_NAME_ACTIVE}[data-bs-toggle="list"]`;
/**
 * Class definition
 */ class $8560031dd706a122$export$3e41faf802a29e71 extends $8560031dd706a122$var$BaseComponent {
    constructor(element){
        super(element);
        this._parent = this._element.closest($8560031dd706a122$var$SELECTOR_TAB_PANEL);
        if (!this._parent) return;
        // Set up initial aria attributes
        this._setInitialAttributes(this._parent, this._getChildren());
        $8560031dd706a122$var$EventHandler.on(this._element, $8560031dd706a122$var$EVENT_KEYDOWN, (event)=>this._keydown(event));
    }
    // Getters
    static get NAME() {
        return $8560031dd706a122$var$NAME$1;
    }
    // Public
    show() {
        // Shows this elem and deactivate the active sibling if exists
        const innerElem = this._element;
        if (this._elemIsActive(innerElem)) return;
        // Search for active tab on same parent to deactivate it
        const active = this._getActiveElem();
        const hideEvent = active ? $8560031dd706a122$var$EventHandler.trigger(active, $8560031dd706a122$var$EVENT_HIDE$1, {
            relatedTarget: innerElem
        }) : null;
        const showEvent = $8560031dd706a122$var$EventHandler.trigger(innerElem, $8560031dd706a122$var$EVENT_SHOW$1, {
            relatedTarget: active
        });
        if (showEvent.defaultPrevented || hideEvent && hideEvent.defaultPrevented) return;
        this._deactivate(active, innerElem);
        this._activate(innerElem, active);
    }
    // Private
    _activate(element, relatedElem) {
        if (!element) return;
        element.classList.add($8560031dd706a122$var$CLASS_NAME_ACTIVE);
        this._activate($8560031dd706a122$var$SelectorEngine.getElementFromSelector(element)); // Search and activate/show the proper section
        const complete = ()=>{
            if (element.getAttribute("role") !== "tab") {
                element.classList.add($8560031dd706a122$var$CLASS_NAME_SHOW$1);
                return;
            }
            element.removeAttribute("tabindex");
            element.setAttribute("aria-selected", true);
            this._toggleDropDown(element, true);
            $8560031dd706a122$var$EventHandler.trigger(element, $8560031dd706a122$var$EVENT_SHOWN$1, {
                relatedTarget: relatedElem
            });
        };
        this._queueCallback(complete, element, element.classList.contains($8560031dd706a122$var$CLASS_NAME_FADE$1));
    }
    _deactivate(element, relatedElem) {
        if (!element) return;
        element.classList.remove($8560031dd706a122$var$CLASS_NAME_ACTIVE);
        element.blur();
        this._deactivate($8560031dd706a122$var$SelectorEngine.getElementFromSelector(element)); // Search and deactivate the shown section too
        const complete = ()=>{
            if (element.getAttribute("role") !== "tab") {
                element.classList.remove($8560031dd706a122$var$CLASS_NAME_SHOW$1);
                return;
            }
            element.setAttribute("aria-selected", false);
            element.setAttribute("tabindex", "-1");
            this._toggleDropDown(element, false);
            $8560031dd706a122$var$EventHandler.trigger(element, $8560031dd706a122$var$EVENT_HIDDEN$1, {
                relatedTarget: relatedElem
            });
        };
        this._queueCallback(complete, element, element.classList.contains($8560031dd706a122$var$CLASS_NAME_FADE$1));
    }
    _keydown(event) {
        if (![
            $8560031dd706a122$var$ARROW_LEFT_KEY,
            $8560031dd706a122$var$ARROW_RIGHT_KEY,
            $8560031dd706a122$var$ARROW_UP_KEY,
            $8560031dd706a122$var$ARROW_DOWN_KEY,
            $8560031dd706a122$var$HOME_KEY,
            $8560031dd706a122$var$END_KEY
        ].includes(event.key)) return;
        event.stopPropagation(); // stopPropagation/preventDefault both added to support up/down keys without scrolling the page
        event.preventDefault();
        const children = this._getChildren().filter((element)=>!$8560031dd706a122$var$isDisabled(element));
        let nextActiveElement;
        if ([
            $8560031dd706a122$var$HOME_KEY,
            $8560031dd706a122$var$END_KEY
        ].includes(event.key)) nextActiveElement = children[event.key === $8560031dd706a122$var$HOME_KEY ? 0 : children.length - 1];
        else {
            const isNext = [
                $8560031dd706a122$var$ARROW_RIGHT_KEY,
                $8560031dd706a122$var$ARROW_DOWN_KEY
            ].includes(event.key);
            nextActiveElement = $8560031dd706a122$var$getNextActiveElement(children, event.target, isNext, true);
        }
        if (nextActiveElement) {
            nextActiveElement.focus({
                preventScroll: true
            });
            $8560031dd706a122$export$3e41faf802a29e71.getOrCreateInstance(nextActiveElement).show();
        }
    }
    _getChildren() {
        // collection of inner elements
        return $8560031dd706a122$var$SelectorEngine.find($8560031dd706a122$var$SELECTOR_INNER_ELEM, this._parent);
    }
    _getActiveElem() {
        return this._getChildren().find((child)=>this._elemIsActive(child)) || null;
    }
    _setInitialAttributes(parent, children) {
        this._setAttributeIfNotExists(parent, "role", "tablist");
        for (const child of children)this._setInitialAttributesOnChild(child);
    }
    _setInitialAttributesOnChild(child) {
        child = this._getInnerElement(child);
        const isActive = this._elemIsActive(child);
        const outerElem = this._getOuterElement(child);
        child.setAttribute("aria-selected", isActive);
        if (outerElem !== child) this._setAttributeIfNotExists(outerElem, "role", "presentation");
        if (!isActive) child.setAttribute("tabindex", "-1");
        this._setAttributeIfNotExists(child, "role", "tab");
        // set attributes to the related panel too
        this._setInitialAttributesOnTargetPanel(child);
    }
    _setInitialAttributesOnTargetPanel(child) {
        const target = $8560031dd706a122$var$SelectorEngine.getElementFromSelector(child);
        if (!target) return;
        this._setAttributeIfNotExists(target, "role", "tabpanel");
        if (child.id) this._setAttributeIfNotExists(target, "aria-labelledby", `${child.id}`);
    }
    _toggleDropDown(element, open) {
        const outerElem = this._getOuterElement(element);
        if (!outerElem.classList.contains($8560031dd706a122$var$CLASS_DROPDOWN)) return;
        const toggle = (selector, className)=>{
            const element = $8560031dd706a122$var$SelectorEngine.findOne(selector, outerElem);
            if (element) element.classList.toggle(className, open);
        };
        toggle($8560031dd706a122$var$SELECTOR_DROPDOWN_TOGGLE, $8560031dd706a122$var$CLASS_NAME_ACTIVE);
        toggle($8560031dd706a122$var$SELECTOR_DROPDOWN_MENU, $8560031dd706a122$var$CLASS_NAME_SHOW$1);
        outerElem.setAttribute("aria-expanded", open);
    }
    _setAttributeIfNotExists(element, attribute, value) {
        if (!element.hasAttribute(attribute)) element.setAttribute(attribute, value);
    }
    _elemIsActive(elem) {
        return elem.classList.contains($8560031dd706a122$var$CLASS_NAME_ACTIVE);
    }
    // Try to get the inner element (usually the .nav-link)
    _getInnerElement(elem) {
        return elem.matches($8560031dd706a122$var$SELECTOR_INNER_ELEM) ? elem : $8560031dd706a122$var$SelectorEngine.findOne($8560031dd706a122$var$SELECTOR_INNER_ELEM, elem);
    }
    // Try to get the outer element (usually the .nav-item)
    _getOuterElement(elem) {
        return elem.closest($8560031dd706a122$var$SELECTOR_OUTER) || elem;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $8560031dd706a122$export$3e41faf802a29e71.getOrCreateInstance(this);
            if (typeof config !== "string") return;
            if (data[config] === undefined || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $8560031dd706a122$var$EventHandler.on(document, $8560031dd706a122$var$EVENT_CLICK_DATA_API, $8560031dd706a122$var$SELECTOR_DATA_TOGGLE, function(event) {
    if ([
        "A",
        "AREA"
    ].includes(this.tagName)) event.preventDefault();
    if ($8560031dd706a122$var$isDisabled(this)) return;
    $8560031dd706a122$export$3e41faf802a29e71.getOrCreateInstance(this).show();
});
/**
 * Initialize on focus
 */ $8560031dd706a122$var$EventHandler.on(window, $8560031dd706a122$var$EVENT_LOAD_DATA_API, ()=>{
    for (const element of $8560031dd706a122$var$SelectorEngine.find($8560031dd706a122$var$SELECTOR_DATA_TOGGLE_ACTIVE))$8560031dd706a122$export$3e41faf802a29e71.getOrCreateInstance(element);
});
/**
 * jQuery
 */ $8560031dd706a122$var$defineJQueryPlugin($8560031dd706a122$export$3e41faf802a29e71);
/**
 * --------------------------------------------------------------------------
 * Bootstrap toast.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $8560031dd706a122$var$NAME = "toast";
const $8560031dd706a122$var$DATA_KEY = "bs.toast";
const $8560031dd706a122$var$EVENT_KEY = `.${$8560031dd706a122$var$DATA_KEY}`;
const $8560031dd706a122$var$EVENT_MOUSEOVER = `mouseover${$8560031dd706a122$var$EVENT_KEY}`;
const $8560031dd706a122$var$EVENT_MOUSEOUT = `mouseout${$8560031dd706a122$var$EVENT_KEY}`;
const $8560031dd706a122$var$EVENT_FOCUSIN = `focusin${$8560031dd706a122$var$EVENT_KEY}`;
const $8560031dd706a122$var$EVENT_FOCUSOUT = `focusout${$8560031dd706a122$var$EVENT_KEY}`;
const $8560031dd706a122$var$EVENT_HIDE = `hide${$8560031dd706a122$var$EVENT_KEY}`;
const $8560031dd706a122$var$EVENT_HIDDEN = `hidden${$8560031dd706a122$var$EVENT_KEY}`;
const $8560031dd706a122$var$EVENT_SHOW = `show${$8560031dd706a122$var$EVENT_KEY}`;
const $8560031dd706a122$var$EVENT_SHOWN = `shown${$8560031dd706a122$var$EVENT_KEY}`;
const $8560031dd706a122$var$CLASS_NAME_FADE = "fade";
const $8560031dd706a122$var$CLASS_NAME_HIDE = "hide"; // @deprecated - kept here only for backwards compatibility
const $8560031dd706a122$var$CLASS_NAME_SHOW = "show";
const $8560031dd706a122$var$CLASS_NAME_SHOWING = "showing";
const $8560031dd706a122$var$DefaultType = {
    animation: "boolean",
    autohide: "boolean",
    delay: "number"
};
const $8560031dd706a122$var$Default = {
    animation: true,
    autohide: true,
    delay: 5000
};
/**
 * Class definition
 */ class $8560031dd706a122$export$8d8dc7d5f743331b extends $8560031dd706a122$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._timeout = null;
        this._hasMouseInteraction = false;
        this._hasKeyboardInteraction = false;
        this._setListeners();
    }
    // Getters
    static get Default() {
        return $8560031dd706a122$var$Default;
    }
    static get DefaultType() {
        return $8560031dd706a122$var$DefaultType;
    }
    static get NAME() {
        return $8560031dd706a122$var$NAME;
    }
    // Public
    show() {
        const showEvent = $8560031dd706a122$var$EventHandler.trigger(this._element, $8560031dd706a122$var$EVENT_SHOW);
        if (showEvent.defaultPrevented) return;
        this._clearTimeout();
        if (this._config.animation) this._element.classList.add($8560031dd706a122$var$CLASS_NAME_FADE);
        const complete = ()=>{
            this._element.classList.remove($8560031dd706a122$var$CLASS_NAME_SHOWING);
            $8560031dd706a122$var$EventHandler.trigger(this._element, $8560031dd706a122$var$EVENT_SHOWN);
            this._maybeScheduleHide();
        };
        this._element.classList.remove($8560031dd706a122$var$CLASS_NAME_HIDE); // @deprecated
        $8560031dd706a122$var$reflow(this._element);
        this._element.classList.add($8560031dd706a122$var$CLASS_NAME_SHOW, $8560031dd706a122$var$CLASS_NAME_SHOWING);
        this._queueCallback(complete, this._element, this._config.animation);
    }
    hide() {
        if (!this.isShown()) return;
        const hideEvent = $8560031dd706a122$var$EventHandler.trigger(this._element, $8560031dd706a122$var$EVENT_HIDE);
        if (hideEvent.defaultPrevented) return;
        const complete = ()=>{
            this._element.classList.add($8560031dd706a122$var$CLASS_NAME_HIDE); // @deprecated
            this._element.classList.remove($8560031dd706a122$var$CLASS_NAME_SHOWING, $8560031dd706a122$var$CLASS_NAME_SHOW);
            $8560031dd706a122$var$EventHandler.trigger(this._element, $8560031dd706a122$var$EVENT_HIDDEN);
        };
        this._element.classList.add($8560031dd706a122$var$CLASS_NAME_SHOWING);
        this._queueCallback(complete, this._element, this._config.animation);
    }
    dispose() {
        this._clearTimeout();
        if (this.isShown()) this._element.classList.remove($8560031dd706a122$var$CLASS_NAME_SHOW);
        super.dispose();
    }
    isShown() {
        return this._element.classList.contains($8560031dd706a122$var$CLASS_NAME_SHOW);
    }
    // Private
    _maybeScheduleHide() {
        if (!this._config.autohide) return;
        if (this._hasMouseInteraction || this._hasKeyboardInteraction) return;
        this._timeout = setTimeout(()=>{
            this.hide();
        }, this._config.delay);
    }
    _onInteraction(event, isInteracting) {
        switch(event.type){
            case "mouseover":
            case "mouseout":
                this._hasMouseInteraction = isInteracting;
                break;
            case "focusin":
            case "focusout":
                this._hasKeyboardInteraction = isInteracting;
                break;
        }
        if (isInteracting) {
            this._clearTimeout();
            return;
        }
        const nextElement = event.relatedTarget;
        if (this._element === nextElement || this._element.contains(nextElement)) return;
        this._maybeScheduleHide();
    }
    _setListeners() {
        $8560031dd706a122$var$EventHandler.on(this._element, $8560031dd706a122$var$EVENT_MOUSEOVER, (event)=>this._onInteraction(event, true));
        $8560031dd706a122$var$EventHandler.on(this._element, $8560031dd706a122$var$EVENT_MOUSEOUT, (event)=>this._onInteraction(event, false));
        $8560031dd706a122$var$EventHandler.on(this._element, $8560031dd706a122$var$EVENT_FOCUSIN, (event)=>this._onInteraction(event, true));
        $8560031dd706a122$var$EventHandler.on(this._element, $8560031dd706a122$var$EVENT_FOCUSOUT, (event)=>this._onInteraction(event, false));
    }
    _clearTimeout() {
        clearTimeout(this._timeout);
        this._timeout = null;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $8560031dd706a122$export$8d8dc7d5f743331b.getOrCreateInstance(this, config);
            if (typeof config === "string") {
                if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
                data[config](this);
            }
        });
    }
}
/**
 * Data API implementation
 */ $8560031dd706a122$var$enableDismissTrigger($8560031dd706a122$export$8d8dc7d5f743331b);
/**
 * jQuery
 */ $8560031dd706a122$var$defineJQueryPlugin($8560031dd706a122$export$8d8dc7d5f743331b);


var $5c1cc6e36f06e493$exports = {};

$parcel$export($5c1cc6e36f06e493$exports, "feedbackAsyncIntegration", function () { return $3d59335a691d3e76$export$21eeae83e17be6ea; });
$parcel$export($5c1cc6e36f06e493$exports, "feedbackIntegration", function () { return $0d3894867527e3f1$export$4bf8b7bb0f0086df; });
$parcel$export($5c1cc6e36f06e493$exports, "feedbackSyncIntegration", function () { return $0d3894867527e3f1$export$4bf8b7bb0f0086df; });
$parcel$export($5c1cc6e36f06e493$exports, "logger", function () { return $af54c954d97593f2$exports; });
$parcel$export($5c1cc6e36f06e493$exports, "SDK_VERSION", function () { return $c62c944ea7134a72$export$31499a9cd224b78c; });
$parcel$export($5c1cc6e36f06e493$exports, "SEMANTIC_ATTRIBUTE_SENTRY_OP", function () { return $34e3132ced11beec$export$1a413bd9a88fdb09; });
$parcel$export($5c1cc6e36f06e493$exports, "SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN", function () { return $34e3132ced11beec$export$cca8dd30f57f805e; });
$parcel$export($5c1cc6e36f06e493$exports, "SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE", function () { return $34e3132ced11beec$export$ccfe0a40627cc34b; });
$parcel$export($5c1cc6e36f06e493$exports, "SEMANTIC_ATTRIBUTE_SENTRY_SOURCE", function () { return $34e3132ced11beec$export$d7a7d984b0791405; });
$parcel$export($5c1cc6e36f06e493$exports, "Scope", function () { return $74a314e82a93236a$export$775b6bb06e53a214; });
$parcel$export($5c1cc6e36f06e493$exports, "addBreadcrumb", function () { return $ee7505b2004f4941$export$efda9a273d7a036d; });
$parcel$export($5c1cc6e36f06e493$exports, "addEventProcessor", function () { return $584cdb98c6222991$export$9aac0b9f77928fbf; });
$parcel$export($5c1cc6e36f06e493$exports, "addIntegration", function () { return $5cfb41e3e92106c4$export$2d8f5188773bcddd; });
$parcel$export($5c1cc6e36f06e493$exports, "captureConsoleIntegration", function () { return $2508206409ecec22$export$caa9b6c4a4144db4; });
$parcel$export($5c1cc6e36f06e493$exports, "captureEvent", function () { return $584cdb98c6222991$export$1462b974fdcf6ba2; });
$parcel$export($5c1cc6e36f06e493$exports, "captureException", function () { return $584cdb98c6222991$export$f5282963edea4a68; });
$parcel$export($5c1cc6e36f06e493$exports, "captureFeedback", function () { return $354cf52c79b8d220$export$3b07f81befe2dd0a; });
$parcel$export($5c1cc6e36f06e493$exports, "captureMessage", function () { return $584cdb98c6222991$export$45654777c133ae80; });
$parcel$export($5c1cc6e36f06e493$exports, "captureSession", function () { return $584cdb98c6222991$export$667e7b4d445d566b; });
$parcel$export($5c1cc6e36f06e493$exports, "close", function () { return $584cdb98c6222991$export$8360e631d277ea4d; });
$parcel$export($5c1cc6e36f06e493$exports, "consoleLoggingIntegration", function () { return $2e4f1938d54cb3a4$export$63e034b6c5b5b12a; });
$parcel$export($5c1cc6e36f06e493$exports, "continueTrace", function () { return $3bfe6b778935764d$export$d2ee9b39b25437b3; });
$parcel$export($5c1cc6e36f06e493$exports, "createTransport", function () { return $f8ec919a2acc7c86$export$d09f50d9ab7f7b69; });
$parcel$export($5c1cc6e36f06e493$exports, "dedupeIntegration", function () { return $537c946bd548a1d5$export$6d39aa44cd0c7567; });
$parcel$export($5c1cc6e36f06e493$exports, "endSession", function () { return $584cdb98c6222991$export$17a5be43989a0bc1; });
$parcel$export($5c1cc6e36f06e493$exports, "eventFiltersIntegration", function () { return $59875e18f45a8371$export$9a84f518c163c552; });
$parcel$export($5c1cc6e36f06e493$exports, "extraErrorDataIntegration", function () { return $e9166acabf7288f6$export$6e0872131894301d; });
$parcel$export($5c1cc6e36f06e493$exports, "featureFlagsIntegration", function () { return $a41fe4fd4129052f$export$82a435367bc83944; });
$parcel$export($5c1cc6e36f06e493$exports, "flush", function () { return $584cdb98c6222991$export$4909b86c8034bf73; });
$parcel$export($5c1cc6e36f06e493$exports, "functionToStringIntegration", function () { return $4292595dc8172ea7$export$7918117e9202e4fb; });
$parcel$export($5c1cc6e36f06e493$exports, "getActiveSpan", function () { return $e89a3331adf677ac$export$1be426a8e585c83e; });
$parcel$export($5c1cc6e36f06e493$exports, "getClient", function () { return $0b98faa1b87c8168$export$6bb76d6eba7e258c; });
$parcel$export($5c1cc6e36f06e493$exports, "getCurrentScope", function () { return $0b98faa1b87c8168$export$c7be4b0125a10cba; });
$parcel$export($5c1cc6e36f06e493$exports, "getGlobalScope", function () { return $0b98faa1b87c8168$export$aa55d5ab8e05984f; });
$parcel$export($5c1cc6e36f06e493$exports, "getIsolationScope", function () { return $0b98faa1b87c8168$export$68f3af03034c9e90; });
$parcel$export($5c1cc6e36f06e493$exports, "getRootSpan", function () { return $e89a3331adf677ac$export$c4c6a79b1260ca1b; });
$parcel$export($5c1cc6e36f06e493$exports, "getSpanDescendants", function () { return $e89a3331adf677ac$export$340c5c8a13ffc680; });
$parcel$export($5c1cc6e36f06e493$exports, "getSpanStatusFromHttpCode", function () { return $1c91772cf9c3fc39$export$5fd4dc48a2131589; });
$parcel$export($5c1cc6e36f06e493$exports, "getTraceData", function () { return $9602e691d7587103$export$dec8f001b9d982cb; });
$parcel$export($5c1cc6e36f06e493$exports, "inboundFiltersIntegration", function () { return $59875e18f45a8371$export$cb3c5c2ceb9818ba; });
$parcel$export($5c1cc6e36f06e493$exports, "instrumentSupabaseClient", function () { return $d8a08a8532df871d$export$a286d61fd33c7083; });
$parcel$export($5c1cc6e36f06e493$exports, "isEnabled", function () { return $584cdb98c6222991$export$3b029eb57ac4d562; });
$parcel$export($5c1cc6e36f06e493$exports, "isInitialized", function () { return $584cdb98c6222991$export$3f95c6f800b78024; });
$parcel$export($5c1cc6e36f06e493$exports, "lastEventId", function () { return $584cdb98c6222991$export$5d4e9fd7fac8e617; });
$parcel$export($5c1cc6e36f06e493$exports, "makeMultiplexedTransport", function () { return $aa34e56af930583d$export$53bbcd410607e756; });
$parcel$export($5c1cc6e36f06e493$exports, "moduleMetadataIntegration", function () { return $23b219268b226c74$export$b3b128c3ae01ded0; });
$parcel$export($5c1cc6e36f06e493$exports, "parameterize", function () { return $48f7b345b59f4894$export$4cb5eb704d6ec224; });
$parcel$export($5c1cc6e36f06e493$exports, "registerSpanErrorInstrumentation", function () { return $7e41a6e2f43eb615$export$b0914730ee1f6c80; });
$parcel$export($5c1cc6e36f06e493$exports, "rewriteFramesIntegration", function () { return $bc14ade2d1e07927$export$5ed0db6416cb6ea2; });
$parcel$export($5c1cc6e36f06e493$exports, "setContext", function () { return $584cdb98c6222991$export$2f04de43fe27971a; });
$parcel$export($5c1cc6e36f06e493$exports, "setCurrentClient", function () { return $d57539a789385421$export$ecb76f41d43c0e43; });
$parcel$export($5c1cc6e36f06e493$exports, "setExtra", function () { return $584cdb98c6222991$export$8e8e7789d42ed61d; });
$parcel$export($5c1cc6e36f06e493$exports, "setExtras", function () { return $584cdb98c6222991$export$bb4922da0dd51b92; });
$parcel$export($5c1cc6e36f06e493$exports, "setHttpStatus", function () { return $1c91772cf9c3fc39$export$2ad6630ec8164254; });
$parcel$export($5c1cc6e36f06e493$exports, "setMeasurement", function () { return $a6c71f13db00a683$export$7cc31b475d33a706; });
$parcel$export($5c1cc6e36f06e493$exports, "setTag", function () { return $584cdb98c6222991$export$a37d07ee78eb4569; });
$parcel$export($5c1cc6e36f06e493$exports, "setTags", function () { return $584cdb98c6222991$export$74a8fb34822092e6; });
$parcel$export($5c1cc6e36f06e493$exports, "setUser", function () { return $584cdb98c6222991$export$8b6bb3dd62a01be2; });
$parcel$export($5c1cc6e36f06e493$exports, "spanToBaggageHeader", function () { return $d001bfa1cb8b2131$export$95cf936fdacaff7b; });
$parcel$export($5c1cc6e36f06e493$exports, "spanToJSON", function () { return $e89a3331adf677ac$export$92d8c23565496537; });
$parcel$export($5c1cc6e36f06e493$exports, "spanToTraceHeader", function () { return $e89a3331adf677ac$export$7e9f8ae9e4a328ab; });
$parcel$export($5c1cc6e36f06e493$exports, "startInactiveSpan", function () { return $3bfe6b778935764d$export$63dbba021a6b4047; });
$parcel$export($5c1cc6e36f06e493$exports, "startNewTrace", function () { return $3bfe6b778935764d$export$f90b03291402f553; });
$parcel$export($5c1cc6e36f06e493$exports, "startSession", function () { return $584cdb98c6222991$export$c0d84948cecf78d8; });
$parcel$export($5c1cc6e36f06e493$exports, "startSpan", function () { return $3bfe6b778935764d$export$a1bd95187356f372; });
$parcel$export($5c1cc6e36f06e493$exports, "startSpanManual", function () { return $3bfe6b778935764d$export$c10292ad04b92aea; });
$parcel$export($5c1cc6e36f06e493$exports, "supabaseIntegration", function () { return $d8a08a8532df871d$export$856ced54ce86f97e; });
$parcel$export($5c1cc6e36f06e493$exports, "suppressTracing", function () { return $3bfe6b778935764d$export$869298f9835abc68; });
$parcel$export($5c1cc6e36f06e493$exports, "thirdPartyErrorFilterIntegration", function () { return $f4f22675634e3fbf$export$be5f345197c66e53; });
$parcel$export($5c1cc6e36f06e493$exports, "updateSpanName", function () { return $e89a3331adf677ac$export$5b72d3169c1be715; });
$parcel$export($5c1cc6e36f06e493$exports, "withActiveSpan", function () { return $3bfe6b778935764d$export$e57ac09b143d92a2; });
$parcel$export($5c1cc6e36f06e493$exports, "withIsolationScope", function () { return $0b98faa1b87c8168$export$9a4fed82c350c2bd; });
$parcel$export($5c1cc6e36f06e493$exports, "withScope", function () { return $0b98faa1b87c8168$export$ec58d9285c204497; });
$parcel$export($5c1cc6e36f06e493$exports, "zodErrorsIntegration", function () { return $4481da8d37c90371$export$a9e1d9bd14830dfb; });
$parcel$export($5c1cc6e36f06e493$exports, "WINDOW", function () { return $9c98becc1d3a3995$export$56d8a8a25bd48b81; });
$parcel$export($5c1cc6e36f06e493$exports, "BrowserClient", function () { return $b91089b3308fbb6b$export$1df9218a526d318d; });
$parcel$export($5c1cc6e36f06e493$exports, "makeFetchTransport", function () { return $846ede25dfa44954$export$b2311068c46d7cc8; });
$parcel$export($5c1cc6e36f06e493$exports, "chromeStackLineParser", function () { return $06eae0b9980e6601$export$263a749fff749872; });
$parcel$export($5c1cc6e36f06e493$exports, "defaultStackLineParsers", function () { return $06eae0b9980e6601$export$7197c0fe6554c079; });
$parcel$export($5c1cc6e36f06e493$exports, "defaultStackParser", function () { return $06eae0b9980e6601$export$2b2b997d81bf3907; });
$parcel$export($5c1cc6e36f06e493$exports, "geckoStackLineParser", function () { return $06eae0b9980e6601$export$cdba47a5dd2804d; });
$parcel$export($5c1cc6e36f06e493$exports, "opera10StackLineParser", function () { return $06eae0b9980e6601$export$f892b52c880ffc7a; });
$parcel$export($5c1cc6e36f06e493$exports, "opera11StackLineParser", function () { return $06eae0b9980e6601$export$af11af13f09fb0dc; });
$parcel$export($5c1cc6e36f06e493$exports, "winjsStackLineParser", function () { return $06eae0b9980e6601$export$179460296da408e8; });
$parcel$export($5c1cc6e36f06e493$exports, "eventFromException", function () { return $a499dd93ae694349$export$ea3ec7e569b823fc; });
$parcel$export($5c1cc6e36f06e493$exports, "eventFromMessage", function () { return $a499dd93ae694349$export$5425b53185d13d6c; });
$parcel$export($5c1cc6e36f06e493$exports, "exceptionFromError", function () { return $a499dd93ae694349$export$a6c2d27607295951; });
$parcel$export($5c1cc6e36f06e493$exports, "createUserFeedbackEnvelope", function () { return $ed3cec9f08115078$export$24a4dfcb686ee5bf; });
$parcel$export($5c1cc6e36f06e493$exports, "forceLoad", function () { return $04bfbe110e873c9a$export$a3f323d81eede727; });
$parcel$export($5c1cc6e36f06e493$exports, "getDefaultIntegrations", function () { return $04bfbe110e873c9a$export$5783b2920b1d62b9; });
$parcel$export($5c1cc6e36f06e493$exports, "init", function () { return $04bfbe110e873c9a$export$2cd8252107eb640b; });
$parcel$export($5c1cc6e36f06e493$exports, "onLoad", function () { return $04bfbe110e873c9a$export$4e4d8b287d028b6b; });
$parcel$export($5c1cc6e36f06e493$exports, "showReportDialog", function () { return $150636d007eb8ee1$export$3a8fd680da42627b; });
$parcel$export($5c1cc6e36f06e493$exports, "breadcrumbsIntegration", function () { return $72e965827831ee54$export$c079d904b326663a; });
$parcel$export($5c1cc6e36f06e493$exports, "globalHandlersIntegration", function () { return $1b2080bc7187f32c$export$66acc70e8cf2b71a; });
$parcel$export($5c1cc6e36f06e493$exports, "httpContextIntegration", function () { return $cc5de4f2add7e163$export$1378794447170364; });
$parcel$export($5c1cc6e36f06e493$exports, "linkedErrorsIntegration", function () { return $960d78d16da62d4a$export$ebabb00eb7f3a395; });
$parcel$export($5c1cc6e36f06e493$exports, "browserApiErrorsIntegration", function () { return $cbc8cb5a8604edeb$export$59bfe9f1c76150e; });
$parcel$export($5c1cc6e36f06e493$exports, "lazyLoadIntegration", function () { return $a067d4a78b80c1aa$export$6da56f3ddf2bd0c1; });
$parcel$export($5c1cc6e36f06e493$exports, "reportingObserverIntegration", function () { return $628d5e129a23f25e$export$609cccfa9f328cc5; });
$parcel$export($5c1cc6e36f06e493$exports, "httpClientIntegration", function () { return $5b9fa18608a480f3$export$8a3b7aeb379b3907; });
$parcel$export($5c1cc6e36f06e493$exports, "contextLinesIntegration", function () { return $afde9de8f0629aeb$export$74173d114ed4f354; });
$parcel$export($5c1cc6e36f06e493$exports, "graphqlClientIntegration", function () { return $e25e4109b458438c$export$a934e57cd817247a; });
$parcel$export($5c1cc6e36f06e493$exports, "getReplay", function () { return $2814b83f7132876d$export$b28310b2f161456b; });
$parcel$export($5c1cc6e36f06e493$exports, "replayIntegration", function () { return $2814b83f7132876d$export$d7706faf7ab354bf; });
$parcel$export($5c1cc6e36f06e493$exports, "replayCanvasIntegration", function () { return $66dbdc40622762c6$export$71ba62165d5c834d; });
$parcel$export($5c1cc6e36f06e493$exports, "getFeedback", function () { return $de7c19ef16e9e5a3$export$ed85ee0b85ce96e1; });
$parcel$export($5c1cc6e36f06e493$exports, "sendFeedback", function () { return $de7c19ef16e9e5a3$export$a65d69dd22caceda; });
$parcel$export($5c1cc6e36f06e493$exports, "defaultRequestInstrumentationOptions", function () { return $07fac35b67406f25$export$cc17fb3c0bc95cd7; });
$parcel$export($5c1cc6e36f06e493$exports, "instrumentOutgoingRequests", function () { return $07fac35b67406f25$export$864489cb3478db3e; });
$parcel$export($5c1cc6e36f06e493$exports, "browserTracingIntegration", function () { return $37e7ec92b70e280f$export$b4109253475213e9; });
$parcel$export($5c1cc6e36f06e493$exports, "startBrowserTracingNavigationSpan", function () { return $37e7ec92b70e280f$export$7d159749bd9969ad; });
$parcel$export($5c1cc6e36f06e493$exports, "startBrowserTracingPageLoadSpan", function () { return $37e7ec92b70e280f$export$aa44a07f82af519f; });
$parcel$export($5c1cc6e36f06e493$exports, "makeBrowserOfflineTransport", function () { return $6a0982bb5a2a41ea$export$79c8882827636cf2; });
$parcel$export($5c1cc6e36f06e493$exports, "browserProfilingIntegration", function () { return $bc6a1c7deaf32184$export$2c7b5d6dd5622f23; });
$parcel$export($5c1cc6e36f06e493$exports, "spotlightBrowserIntegration", function () { return $51378b91d2e1775c$export$a05c07c0f32f730a; });
$parcel$export($5c1cc6e36f06e493$exports, "browserSessionIntegration", function () { return $8b736359c68920d8$export$1baa7880e357371c; });
$parcel$export($5c1cc6e36f06e493$exports, "buildLaunchDarklyFlagUsedHandler", function () { return $f051f6a2f783abf3$export$f97714c0986edb0; });
$parcel$export($5c1cc6e36f06e493$exports, "launchDarklyIntegration", function () { return $f051f6a2f783abf3$export$7cd9c18538ed792e; });
$parcel$export($5c1cc6e36f06e493$exports, "OpenFeatureIntegrationHook", function () { return $0847159cb5419a92$export$f399add65bfd388e; });
$parcel$export($5c1cc6e36f06e493$exports, "openFeatureIntegration", function () { return $0847159cb5419a92$export$a41102cd52abbd1b; });
$parcel$export($5c1cc6e36f06e493$exports, "unleashIntegration", function () { return $bc0447b1d783ed24$export$e753ab651e68430d; });
$parcel$export($5c1cc6e36f06e493$exports, "statsigIntegration", function () { return $bec224dbfaee6b5b$export$473918ef9c3b2ab7; });
$parcel$export($5c1cc6e36f06e493$exports, "diagnoseSdkConnectivity", function () { return $2565d0a939fc6789$export$fecc80c9f0e9c1b2; });
// This is a magic string replaced by rollup
const $7e3bed7186ec1b77$export$31499a9cd224b78c = "9.33.0";


/** Internal global with common properties and Sentry extensions  */ /** Get's the global object for the current JavaScript runtime */ const $3042afa3ea37a05a$export$f1a6cdb1459e81d1 = globalThis;


/**
 * An object that contains globally accessible properties and maintains a scope stack.
 * @hidden
 */ /**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $911e5c703825d4fd$export$19eade501500c6c1() {
    // This ensures a Sentry carrier exists
    $911e5c703825d4fd$export$c8bfa33e4e8ae492((0, $3042afa3ea37a05a$export$f1a6cdb1459e81d1));
    return 0, $3042afa3ea37a05a$export$f1a6cdb1459e81d1;
}
/** Will either get the existing sentry carrier, or create a new one. */ function $911e5c703825d4fd$export$c8bfa33e4e8ae492(carrier) {
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    // For now: First SDK that sets the .version property wins
    __SENTRY__.version = __SENTRY__.version || (0, $7e3bed7186ec1b77$export$31499a9cd224b78c);
    // Intentionally populating and returning the version of "this" SDK instance
    // rather than what's set in .version so that "this" SDK always gets its carrier
    return __SENTRY__[0, $7e3bed7186ec1b77$export$31499a9cd224b78c] = __SENTRY__[0, $7e3bed7186ec1b77$export$31499a9cd224b78c] || {};
}
/**
 * Returns a global singleton contained in the global `__SENTRY__[]` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $911e5c703825d4fd$export$7e223ec222791509(name, creator, obj = (0, $3042afa3ea37a05a$export$f1a6cdb1459e81d1)) {
    const __SENTRY__ = obj.__SENTRY__ = obj.__SENTRY__ || {};
    const carrier = __SENTRY__[0, $7e3bed7186ec1b77$export$31499a9cd224b78c] = __SENTRY__[0, $7e3bed7186ec1b77$export$31499a9cd224b78c] || {};
    // Note: We do not want to set `carrier.version` here, as this may be called before any `init` is called, e.g. for the default scopes
    return carrier[name] || (carrier[name] = creator());
}



/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $20f7ec4490ac47c4$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;


// eslint-disable-next-line @typescript-eslint/unbound-method
const $ae60f34c3d590aaa$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $ae60f34c3d590aaa$export$e6127cc7fe7395c3(wat) {
    switch($ae60f34c3d590aaa$var$objectToString.call(wat)){
        case "[object Error]":
        case "[object Exception]":
        case "[object DOMException]":
        case "[object WebAssembly.Exception]":
            return true;
        default:
            return $ae60f34c3d590aaa$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $ae60f34c3d590aaa$var$isBuiltin(wat, className) {
    return $ae60f34c3d590aaa$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $ae60f34c3d590aaa$export$9f9636d330b71954(wat) {
    return $ae60f34c3d590aaa$var$isBuiltin(wat, "ErrorEvent");
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $ae60f34c3d590aaa$export$ef9e2056653f0c8e(wat) {
    return $ae60f34c3d590aaa$var$isBuiltin(wat, "DOMError");
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $ae60f34c3d590aaa$export$12e869b2a583f783(wat) {
    return $ae60f34c3d590aaa$var$isBuiltin(wat, "DOMException");
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $ae60f34c3d590aaa$export$844ec244b1367d54(wat) {
    return $ae60f34c3d590aaa$var$isBuiltin(wat, "String");
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $ae60f34c3d590aaa$export$dbcbffa59149b824(wat) {
    return typeof wat === "object" && wat !== null && "__sentry_template_string__" in wat && "__sentry_template_values__" in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $ae60f34c3d590aaa$export$c3825b437cbdea5c(wat) {
    return wat === null || $ae60f34c3d590aaa$export$dbcbffa59149b824(wat) || typeof wat !== "object" && typeof wat !== "function";
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $ae60f34c3d590aaa$export$53b83ca8eaab0383(wat) {
    return $ae60f34c3d590aaa$var$isBuiltin(wat, "Object");
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $ae60f34c3d590aaa$export$9671ea99bd126ace(wat) {
    return typeof Event !== "undefined" && $ae60f34c3d590aaa$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $ae60f34c3d590aaa$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== "undefined" && $ae60f34c3d590aaa$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $ae60f34c3d590aaa$export$49841c62b9eff15(wat) {
    return $ae60f34c3d590aaa$var$isBuiltin(wat, "RegExp");
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $ae60f34c3d590aaa$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat?.then && typeof wat.then === "function");
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $ae60f34c3d590aaa$export$bc2894c7158efbac(wat) {
    return $ae60f34c3d590aaa$export$53b83ca8eaab0383(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $ae60f34c3d590aaa$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $ae60f34c3d590aaa$export$7916fad0ebc23f48(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    return !!(typeof wat === "object" && wat !== null && (wat.__isVue || wat._isVue));
}
/**
 * Checks whether the given parameter is a Standard Web API Request instance.
 *
 * Returns false if Request is not available in the current runtime.
 */ function $ae60f34c3d590aaa$export$6d3d1f317d7cda57(request) {
    return typeof Request !== "undefined" && $ae60f34c3d590aaa$export$49034edbe6b62415(request, Request);
}



const $1a28f4370f93c31b$var$WINDOW = (0, $3042afa3ea37a05a$export$f1a6cdb1459e81d1);
const $1a28f4370f93c31b$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $1a28f4370f93c31b$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return "<unknown>";
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = " > ";
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $1a28f4370f93c31b$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $1a28f4370f93c31b$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return "<unknown>";
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $1a28f4370f93c31b$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    if (!elem?.tagName) return "";
    // @ts-expect-error WINDOW has HTMLElement
    if ($1a28f4370f93c31b$var$WINDOW.HTMLElement) // If using the component name annotation plugin, this value may be available on the DOM node
    {
        if (elem instanceof HTMLElement && elem.dataset) {
            if (elem.dataset["sentryComponent"]) return elem.dataset["sentryComponent"];
            if (elem.dataset["sentryElement"]) return elem.dataset["sentryElement"];
        }
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs?.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs?.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        const className = elem.className;
        if (className && (0, $ae60f34c3d590aaa$export$844ec244b1367d54)(className)) {
            const classes = className.split(/\s+/);
            for (const c of classes)out.push(`.${c}`);
        }
    }
    const allowedAttrs = [
        "aria-label",
        "type",
        "name",
        "title",
        "alt"
    ];
    for (const k of allowedAttrs){
        const attr = elem.getAttribute(k);
        if (attr) out.push(`[${k}="${attr}"]`);
    }
    return out.join("");
}
/**
 * A safe form of location.href
 */ function $1a28f4370f93c31b$export$1cfafeee2987818b() {
    try {
        return $1a28f4370f93c31b$var$WINDOW.document.location.href;
    } catch (oO) {
        return "";
    }
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` or `data-sentry-element` attribute with `data-sentry-component` taking
 * precedence. This attribute is added at build-time by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function $1a28f4370f93c31b$export$26727cfcc4d7e0fc(elem) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!$1a28f4370f93c31b$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    const MAX_TRAVERSE_HEIGHT = 5;
    for(let i = 0; i < MAX_TRAVERSE_HEIGHT; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement) {
            if (currentElem.dataset["sentryComponent"]) return currentElem.dataset["sentryComponent"];
            if (currentElem.dataset["sentryElement"]) return currentElem.dataset["sentryElement"];
        }
        currentElem = currentElem.parentNode;
    }
    return null;
}






/** Prefix for logging strings */ const $90b8a6ace9b755b8$var$PREFIX = "Sentry Logger ";
const $90b8a6ace9b755b8$export$2a2b1d2252a69ecb = [
    "debug",
    "info",
    "warn",
    "error",
    "log",
    "assert",
    "trace"
];
/** This may be mutated by the console instrumentation. */ const $90b8a6ace9b755b8$export$77c4ce905194557b = {};
/** A Sentry Logger instance. */ /**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $90b8a6ace9b755b8$export$cda52e2a8927a2ca(callback) {
    if (!("console" in (0, $3042afa3ea37a05a$export$f1a6cdb1459e81d1))) return callback();
    const console = (0, $3042afa3ea37a05a$export$f1a6cdb1459e81d1).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($90b8a6ace9b755b8$export$77c4ce905194557b);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $90b8a6ace9b755b8$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $90b8a6ace9b755b8$var$makeLogger() {
    let enabled = false;
    const logger = {
        enable: ()=>{
            enabled = true;
        },
        disable: ()=>{
            enabled = false;
        },
        isEnabled: ()=>enabled
    };
    if (0, $20f7ec4490ac47c4$export$16a28057038b10ef) $90b8a6ace9b755b8$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = (...args)=>{
            if (enabled) $90b8a6ace9b755b8$export$cda52e2a8927a2ca(()=>{
                (0, $3042afa3ea37a05a$export$f1a6cdb1459e81d1).console[name](`${$90b8a6ace9b755b8$var$PREFIX}[${name}]:`, ...args);
            });
        };
    });
    else $90b8a6ace9b755b8$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = ()=>undefined;
    });
    return logger;
}
/**
 * This is a logger singleton which either logs things or no-ops if logging is not enabled.
 * The logger is a singleton on the carrier, to ensure that a consistent logger is used throughout the SDK.
 */ const $90b8a6ace9b755b8$export$af88d00dbe7f521 = (0, $911e5c703825d4fd$export$7e223ec222791509)("logger", $90b8a6ace9b755b8$var$makeLogger);



/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $4d727efeabbf7e81$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== "string" || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $4d727efeabbf7e81$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += " {snip}";
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ function $4d727efeabbf7e81$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return "";
    const output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, $ae60f34c3d590aaa$export$7916fad0ebc23f48)(value)) output.push("[VueViewModel]");
            else output.push(String(value));
        } catch (e) {
            output.push("[value cannot be serialized]");
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $4d727efeabbf7e81$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $ae60f34c3d590aaa$export$844ec244b1367d54)(value)) return false;
    if ((0, $ae60f34c3d590aaa$export$49841c62b9eff15)(pattern)) return pattern.test(value);
    if ((0, $ae60f34c3d590aaa$export$844ec244b1367d54)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $4d727efeabbf7e81$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$4d727efeabbf7e81$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}


/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Replace a method in an object with a wrapped version of itself.
 *
 * If the method on the passed object is not a function, the wrapper will not be applied.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $b3797a03f782dc14$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    // explicitly casting to unknown because we don't know the type of the method initially at all
    const original = source[name];
    if (typeof original !== "function") return;
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === "function") $b3797a03f782dc14$export$5c1499e2e5d010ae(wrapped, original);
    try {
        source[name] = wrapped;
    } catch  {
        (0, $20f7ec4490ac47c4$export$16a28057038b10ef) && (0, $90b8a6ace9b755b8$export$af88d00dbe7f521).log(`Failed to replace method "${name}" in object`, source);
    }
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $b3797a03f782dc14$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch (o_O) {
        (0, $20f7ec4490ac47c4$export$16a28057038b10ef) && (0, $90b8a6ace9b755b8$export$af88d00dbe7f521).log(`Failed to add non-enumerable property "${name}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $b3797a03f782dc14$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $b3797a03f782dc14$export$e73679ffaf56810e(wrapped, "__sentry_original__", original);
    } catch (o_O) {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $b3797a03f782dc14$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argument itself, when value is neither an Event nor
 *  an Error.
 */ function $b3797a03f782dc14$export$62ff257738bf57f5(value) {
    if ((0, $ae60f34c3d590aaa$export$e6127cc7fe7395c3)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$b3797a03f782dc14$var$getOwnProperties(value)
    };
    else if ((0, $ae60f34c3d590aaa$export$9671ea99bd126ace)(value)) {
        const newObj = {
            type: value.type,
            target: $b3797a03f782dc14$var$serializeEventTarget(value.target),
            currentTarget: $b3797a03f782dc14$var$serializeEventTarget(value.currentTarget),
            ...$b3797a03f782dc14$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== "undefined" && (0, $ae60f34c3d590aaa$export$49034edbe6b62415)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $b3797a03f782dc14$var$serializeEventTarget(target) {
    try {
        return (0, $ae60f34c3d590aaa$export$45a5e7f76e0caa8d)(target) ? (0, $1a28f4370f93c31b$export$5647df6b7814ac86)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return "<unknown>";
    }
}
/** Filters out all but an object's own properties */ function $b3797a03f782dc14$var$getOwnProperties(obj) {
    if (typeof obj === "object" && obj !== null) {
        const extractedProps = {};
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $b3797a03f782dc14$export$b0244d5063c0b61b(exception, maxLength = 40) {
    const keys = Object.keys($b3797a03f782dc14$export$62ff257738bf57f5(exception));
    keys.sort();
    const firstKey = keys[0];
    if (!firstKey) return "[object has no keys]";
    if (firstKey.length >= maxLength) return (0, $4d727efeabbf7e81$export$6a506b36fdea397d)(firstKey, maxLength);
    for(let includedKeys = keys.length; includedKeys > 0; includedKeys--){
        const serialized = keys.slice(0, includedKeys).join(", ");
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $4d727efeabbf7e81$export$6a506b36fdea397d)(serialized, maxLength);
    }
    return "";
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 *
 * @deprecated This function is no longer used by the SDK and will be removed in a future major version.
 */ function $b3797a03f782dc14$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $b3797a03f782dc14$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $b3797a03f782dc14$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    // Early return for primitive values
    if (inputValue === null || typeof inputValue !== "object") return inputValue;
    // Check memo map first for all object types
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== undefined) return memoVal;
    // handle arrays
    if (Array.isArray(inputValue)) {
        const returnValue = [];
        // Store mapping to handle circular references
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((value)=>{
            returnValue.push($b3797a03f782dc14$var$_dropUndefinedKeys(value, memoizationMap));
        });
        return returnValue;
    }
    if ($b3797a03f782dc14$var$isPojo(inputValue)) {
        const returnValue = {};
        // Store mapping to handle circular references
        memoizationMap.set(inputValue, returnValue);
        const keys = Object.keys(inputValue);
        keys.forEach((key)=>{
            const val = inputValue[key];
            if (val !== undefined) returnValue[key] = $b3797a03f782dc14$var$_dropUndefinedKeys(val, memoizationMap);
        });
        return returnValue;
    }
    // For other object types, return as is
    return inputValue;
}
function $b3797a03f782dc14$var$isPojo(input) {
    // Plain objects have Object as constructor or no constructor
    const constructor = input.constructor;
    return constructor === Object || constructor === undefined;
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $b3797a03f782dc14$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        // this will catch both undefined and null
        case wat == undefined:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === "symbol" || typeof wat === "bigint":
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $ae60f34c3d590aaa$export$c3825b437cbdea5c)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}




function $f05e01169d6895ab$var$getCrypto() {
    const gbl = (0, $3042afa3ea37a05a$export$f1a6cdb1459e81d1);
    return gbl.crypto || gbl.msCrypto;
}
/**
 * UUID4 generator
 * @param crypto Object that provides the crypto API.
 * @returns string Generated UUID4.
 */ function $f05e01169d6895ab$export$19f53698e68b2496(crypto = $f05e01169d6895ab$var$getCrypto()) {
    let getRandomByte = ()=>Math.random() * 16;
    try {
        if (crypto?.randomUUID) return crypto.randomUUID().replace(/-/g, "");
        if (crypto?.getRandomValues) getRandomByte = ()=>{
            // crypto.getRandomValues might return undefined instead of the typed array
            // in old Chromium versions (e.g. 23.0.1235.0 (151422))
            // However, `typedArray` is still filled in-place.
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues#typedarray
            const typedArray = new Uint8Array(1);
            crypto.getRandomValues(typedArray);
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            return typedArray[0];
        };
    } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function $f05e01169d6895ab$var$getFirstException(event) {
    return event.exception?.values?.[0];
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $f05e01169d6895ab$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $f05e01169d6895ab$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || "<unknown>";
    }
    return eventId || "<unknown>";
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $f05e01169d6895ab$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || "";
    if (!firstException.type) firstException.type = type || "Error";
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $f05e01169d6895ab$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $f05e01169d6895ab$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: "generic",
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && "data" in newMechanism) {
        const mergedData = {
            ...currentMechanism?.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $f05e01169d6895ab$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ function $f05e01169d6895ab$var$_parseInt(input) {
    return parseInt(input || "", 10);
}
/**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $f05e01169d6895ab$export$d364f2020ab30578(input) {
    const match = input.match($f05e01169d6895ab$var$SEMVER_REGEXP) || [];
    const major = $f05e01169d6895ab$var$_parseInt(match[1]);
    const minor = $f05e01169d6895ab$var$_parseInt(match[2]);
    const patch = $f05e01169d6895ab$var$_parseInt(match[3]);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $f05e01169d6895ab$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $4d727efeabbf7e81$export$4215662d762d6f9d)(line, 0));
    // We guard here to ensure this is not larger than the existing number of lines
    const lineIndex = Math.min(maxLines - 1, sourceLine);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    frame.context_line = (0, $4d727efeabbf7e81$export$4215662d762d6f9d)(lines[lineIndex], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $4d727efeabbf7e81$export$4215662d762d6f9d)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $f05e01169d6895ab$export$6de4ffac6a2f1098(exception) {
    if ($f05e01169d6895ab$var$isAlreadyCaptured(exception)) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $b3797a03f782dc14$export$e73679ffaf56810e)(exception, "__sentry_captured__", true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
function $f05e01169d6895ab$var$isAlreadyCaptured(exception) {
    try {
        return exception.__sentry_captured__;
    } catch  {} // eslint-disable-line no-empty
}



const $3324fa1d26f7f04d$var$ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 */ function $3324fa1d26f7f04d$export$7740643b9eeaf0c4() {
    return Date.now() / $3324fa1d26f7f04d$var$ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function $3324fa1d26f7f04d$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $3042afa3ea37a05a$export$f1a6cdb1459e81d1);
    if (!performance?.now) return $3324fa1d26f7f04d$export$7740643b9eeaf0c4;
    // Some browser and environments don't have a timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    const approxStartingTimeOrigin = Date.now() - performance.now();
    const timeOrigin = performance.timeOrigin == undefined ? approxStartingTimeOrigin : performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return ()=>{
        return (timeOrigin + performance.now()) / $3324fa1d26f7f04d$var$ONE_SECOND_IN_MS;
    };
}
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ const $3324fa1d26f7f04d$export$ee52dced521e3e18 = $3324fa1d26f7f04d$var$createUnixTimestampInSecondsFunc();
/**
 * Cached result of getBrowserTimeOrigin.
 */ let $3324fa1d26f7f04d$var$cachedTimeOrigin;
/**
 * Gets the time origin and the mode used to determine it.
 */ function $3324fa1d26f7f04d$var$getBrowserTimeOrigin() {
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    const { performance: performance } = (0, $3042afa3ea37a05a$export$f1a6cdb1459e81d1);
    if (!performance?.now) return [
        undefined,
        "none"
    ];
    const threshold = 3600000;
    const performanceNow = performance.now();
    const dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    const timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing?.navigationStart;
    const hasNavigationStart = typeof navigationStart === "number";
    // if navigationStart isn't available set delta to threshold so it isn't used
    const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    const navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) return [
            performance.timeOrigin,
            "timeOrigin"
        ];
        else return [
            navigationStart,
            "navigationStart"
        ];
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    return [
        dateNow,
        "dateNow"
    ];
}
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ function $3324fa1d26f7f04d$export$baf075a948ffc0bf() {
    if (!$3324fa1d26f7f04d$var$cachedTimeOrigin) $3324fa1d26f7f04d$var$cachedTimeOrigin = $3324fa1d26f7f04d$var$getBrowserTimeOrigin();
    return $3324fa1d26f7f04d$var$cachedTimeOrigin[0];
}


/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $4462a0f97f968a41$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $3324fa1d26f7f04d$export$ee52dced521e3e18)();
    const session = {
        sid: (0, $f05e01169d6895ab$export$19f53698e68b2496)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: "ok",
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$4462a0f97f968a41$var$sessionToJSON(session)
    };
    if (context) $4462a0f97f968a41$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see Client.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $4462a0f97f968a41$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $3324fa1d26f7f04d$export$ee52dced521e3e18)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $f05e01169d6895ab$export$19f53698e68b2496)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === "number") session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === "number") session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === "number") session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $4462a0f97f968a41$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === "ok") context = {
        status: "exited"
    };
    $4462a0f97f968a41$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $4462a0f97f968a41$var$sessionToJSON(session) {
    return {
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === "number" || typeof session.did === "string" ? `${session.did}` : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    };
}




/**
 * Shallow merge two objects.
 * Does not mutate the passed in objects.
 * Undefined/empty values in the merge object will overwrite existing values.
 *
 * By default, this merges 2 levels deep.
 */ function $fb7c38700212e097$export$4950aa0f605343fb(initialObj, mergeObj, levels = 2) {
    // If the merge value is not an object, or we have no merge levels left,
    // we just set the value to the merge value
    if (!mergeObj || typeof mergeObj !== "object" || levels <= 0) return mergeObj;
    // If the merge object is an empty object, and the initial object is not undefined, we return the initial object
    if (initialObj && Object.keys(mergeObj).length === 0) return initialObj;
    // Clone object
    const output = {
        ...initialObj
    };
    // Merge values into output, resursively
    for(const key in mergeObj)if (Object.prototype.hasOwnProperty.call(mergeObj, key)) output[key] = $fb7c38700212e097$export$4950aa0f605343fb(output[key], mergeObj[key], levels - 1);
    return output;
}




/**
 * Generate a random, valid trace ID.
 */ function $956629e5843a7517$export$dc6d7ea554bcce10() {
    return (0, $f05e01169d6895ab$export$19f53698e68b2496)();
}
/**
 * Generate a random, valid span ID.
 */ function $956629e5843a7517$export$295213bc4d0c54ad() {
    return (0, $f05e01169d6895ab$export$19f53698e68b2496)().substring(16);
}



const $db1a0cde7b6e2c8a$var$SCOPE_SPAN_FIELD = "_sentrySpan";
/**
 * Set the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $db1a0cde7b6e2c8a$export$3f25fa50c18e20ca(scope, span) {
    if (span) (0, $b3797a03f782dc14$export$e73679ffaf56810e)(scope, $db1a0cde7b6e2c8a$var$SCOPE_SPAN_FIELD, span);
    else // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
    delete scope[$db1a0cde7b6e2c8a$var$SCOPE_SPAN_FIELD];
}
/**
 * Get the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $db1a0cde7b6e2c8a$export$91f063ebb8eff307(scope) {
    return scope[$db1a0cde7b6e2c8a$var$SCOPE_SPAN_FIELD];
}




/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $e0ce129be50721dc$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * A context to be used for capturing an event.
 * This can either be a Scope, or a partial ScopeContext,
 * or a callback that receives the current scope and returns a new scope to use.
 */ /**
 * Holds additional event information.
 */ class $e0ce129be50721dc$export$775b6bb06e53a214 {
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called during event processing. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Extra */ /** Contexts */ /** Attachments */ /** Propagation Context for distributed tracing */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */ /** Session */ /** The client on this scope */ /** Contains the last event id of a captured event.  */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = {
            traceId: (0, $956629e5843a7517$export$dc6d7ea554bcce10)(),
            sampleRand: Math.random()
        };
    }
    /**
   * Clone all data from this scope into a new scope.
   */ clone() {
        const newScope = new $e0ce129be50721dc$export$775b6bb06e53a214();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        if (this._contexts.flags) // We need to copy the `values` array so insertions on a cloned scope
        // won't affect the original array.
        newScope._contexts.flags = {
            values: [
                ...this._contexts.flags.values
            ]
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        newScope._lastEventId = this._lastEventId;
        (0, $db1a0cde7b6e2c8a$export$3f25fa50c18e20ca)(newScope, (0, $db1a0cde7b6e2c8a$export$91f063ebb8eff307)(this));
        return newScope;
    }
    /**
   * Update the client assigned to this scope.
   * Note that not every scope will have a client assigned - isolation scopes & the global scope will generally not have a client,
   * as well as manually created scopes.
   */ setClient(client) {
        this._client = client;
    }
    /**
   * Set the ID of the last captured error event.
   * This is generally only captured on the isolation scope.
   */ setLastEventId(lastEventId) {
        this._lastEventId = lastEventId;
    }
    /**
   * Get the client assigned to this scope.
   */ getClient() {
        return this._client;
    }
    /**
   * Get the ID of the last captured error event.
   * This is generally only available on the isolation scope.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * Add an event processor that will be called before an event is sent.
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * Set the user for this scope.
   * Set to `null` to unset the user.
   */ setUser(user) {
        // If null is passed we want to unset everything, but still define keys,
        // so that later down in the pipeline any existing values are cleared.
        this._user = user || {
            email: undefined,
            id: undefined,
            ip_address: undefined,
            username: undefined
        };
        if (this._session) (0, $4462a0f97f968a41$export$531818e825e774db)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the user from this scope.
   */ getUser() {
        return this._user;
    }
    /**
   * Set an object that will be merged into existing tags on the scope,
   * and will be sent as tags data with the event.
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single tag that will be sent as tags data with the event.
   */ setTag(key, value) {
        this._tags = {
            ...this._tags,
            [key]: value
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set an object that will be merged into existing extra on the scope,
   * and will be sent as extra data with the event.
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single key:value extra entry that will be sent as extra data with the event.
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the fingerprint on the scope to send with the events.
   * @param {string[]} fingerprint Fingerprint to group events in Sentry.
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the level on the scope for future events.
   */ setLevel(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope so that the name of e.g. taken server route or
   * the page location is attached to future events.
   *
   * IMPORTANT: Calling this function does NOT change the name of the currently active
   * root span. If you want to change the name of the active root span, use
   * `Sentry.updateSpanName(rootSpan, 'new name')` instead.
   *
   * By default, the SDK updates the scope's transaction name automatically on sensible
   * occasions, such as a page navigation or when handling a new request on the server.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets context data with the given name.
   * Data passed as context will be normalized. You can also pass `null` to unset the context.
   * Note that context data will not be merged - calling `setContext` will overwrite an existing context with the same key.
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set the session for the scope.
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the session from the scope.
   */ getSession() {
        return this._session;
    }
    /**
   * Updates the scope with provided data. Can work in three variations:
   * - plain object containing updatable attributes
   * - Scope instance that'll extract the attributes from
   * - callback function that'll receive the current scope as an argument and allow for modifications
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === "function" ? captureContext(this) : captureContext;
        const scopeInstance = scopeToMerge instanceof $e0ce129be50721dc$export$775b6bb06e53a214 ? scopeToMerge.getScopeData() : (0, $ae60f34c3d590aaa$export$53b83ca8eaab0383)(scopeToMerge) ? captureContext : undefined;
        const { tags: tags, extra: extra, user: user, contexts: contexts, level: level, fingerprint: fingerprint = [], propagationContext: propagationContext } = scopeInstance || {};
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._extra = {
            ...this._extra,
            ...extra
        };
        this._contexts = {
            ...this._contexts,
            ...contexts
        };
        if (user && Object.keys(user).length) this._user = user;
        if (level) this._level = level;
        if (fingerprint.length) this._fingerprint = fingerprint;
        if (propagationContext) this._propagationContext = propagationContext;
        return this;
    }
    /**
   * Clears the current scope and resets its properties.
   * Note: The client will not be cleared.
   */ clear() {
        // client is not cleared here on purpose!
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._session = undefined;
        (0, $db1a0cde7b6e2c8a$export$3f25fa50c18e20ca)(this, undefined);
        this._attachments = [];
        this.setPropagationContext({
            traceId: (0, $956629e5843a7517$export$dc6d7ea554bcce10)(),
            sampleRand: Math.random()
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Adds a breadcrumb to the scope.
   * By default, the last 100 breadcrumbs are kept.
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === "number" ? maxBreadcrumbs : $e0ce129be50721dc$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $3324fa1d26f7f04d$export$7740643b9eeaf0c4)(),
            ...breadcrumb,
            // Breadcrumb messages can theoretically be infinitely large and they're held in memory so we truncate them not to leak (too much) memory
            message: breadcrumb.message ? (0, $4d727efeabbf7e81$export$6a506b36fdea397d)(breadcrumb.message, 2048) : breadcrumb.message
        };
        this._breadcrumbs.push(mergedBreadcrumb);
        if (this._breadcrumbs.length > maxCrumbs) {
            this._breadcrumbs = this._breadcrumbs.slice(-maxCrumbs);
            this._client?.recordDroppedEvent("buffer_overflow", "log_item");
        }
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the last breadcrumb of the scope.
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * Clear all breadcrumbs from the scope.
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Add an attachment to the scope.
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * Clear all attachments from the scope.
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /**
   * Get the data of this scope, which should be applied to an event during processing.
   */ getScopeData() {
        return {
            breadcrumbs: this._breadcrumbs,
            attachments: this._attachments,
            contexts: this._contexts,
            tags: this._tags,
            extra: this._extra,
            user: this._user,
            level: this._level,
            fingerprint: this._fingerprint || [],
            eventProcessors: this._eventProcessors,
            propagationContext: this._propagationContext,
            sdkProcessingMetadata: this._sdkProcessingMetadata,
            transactionName: this._transactionName,
            span: (0, $db1a0cde7b6e2c8a$export$91f063ebb8eff307)(this)
        };
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry.
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = (0, $fb7c38700212e097$export$4950aa0f605343fb)(this._sdkProcessingMetadata, newData, 2);
        return this;
    }
    /**
   * Add propagation context to the scope, used for distributed tracing
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * Get propagation context from the scope, used for distributed tracing
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @returns {string} The id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = hint?.event_id || (0, $f05e01169d6895ab$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $90b8a6ace9b755b8$export$af88d00dbe7f521).warn("No client configured on scope - will not capture exception!");
            return eventId;
        }
        const syntheticException = new Error("Sentry syntheticException");
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @returns {string} The id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = hint?.event_id || (0, $f05e01169d6895ab$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $90b8a6ace9b755b8$export$af88d00dbe7f521).warn("No client configured on scope - will not capture message!");
            return eventId;
        }
        const syntheticException = new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a Sentry event for this scope.
   *
   * @returns {string} The id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = hint?.event_id || (0, $f05e01169d6895ab$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $90b8a6ace9b755b8$export$af88d00dbe7f521).warn("No client configured on scope - will not capture event!");
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}


/** Get the default current scope. */ function $d582f70bc143c925$export$6f1b9191db9c4d5() {
    return (0, $911e5c703825d4fd$export$7e223ec222791509)("defaultCurrentScope", ()=>new (0, $e0ce129be50721dc$export$775b6bb06e53a214)());
}
/** Get the default isolation scope. */ function $d582f70bc143c925$export$de9862929b76bf57() {
    return (0, $911e5c703825d4fd$export$7e223ec222791509)("defaultIsolationScope", ()=>new (0, $e0ce129be50721dc$export$775b6bb06e53a214)());
}





/**
 * This is an object that holds a stack of scopes.
 */ class $924e7295504cb58d$export$d36ec451f120cfba {
    constructor(scope, isolationScope){
        let assignedScope;
        if (!scope) assignedScope = new (0, $e0ce129be50721dc$export$775b6bb06e53a214)();
        else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) assignedIsolationScope = new (0, $e0ce129be50721dc$export$775b6bb06e53a214)();
        else assignedIsolationScope = isolationScope;
        // scope stack for domains or the process
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Fork a scope for the stack.
   */ withScope(callback) {
        const scope = this._pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            this._popScope();
            throw e;
        }
        if ((0, $ae60f34c3d590aaa$export$f5b060c2914b97c8)(maybePromiseResult)) // @ts-expect-error - isThenable returns the wrong type
        return maybePromiseResult.then((res)=>{
            this._popScope();
            return res;
        }, (e)=>{
            this._popScope();
            throw e;
        });
        this._popScope();
        return maybePromiseResult;
    }
    /**
   * Get the client of the stack.
   */ getClient() {
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   */ getScope() {
        return this.getStackTop().scope;
    }
    /**
   * Get the isolation scope for the stack.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * Push a scope to the stack.
   */ _pushScope() {
        // We want to clone the content of prev scope
        const scope = this.getScope().clone();
        this._stack.push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * Pop a scope from the stack.
   */ _popScope() {
        if (this._stack.length <= 1) return false;
        return !!this._stack.pop();
    }
}
/**
 * Get the global async context stack.
 * This will be removed during the v8 cycle and is only here to make migration easier.
 */ function $924e7295504cb58d$var$getAsyncContextStack() {
    const registry = (0, $911e5c703825d4fd$export$19eade501500c6c1)();
    const sentry = (0, $911e5c703825d4fd$export$c8bfa33e4e8ae492)(registry);
    return sentry.stack = sentry.stack || new $924e7295504cb58d$export$d36ec451f120cfba((0, $d582f70bc143c925$export$6f1b9191db9c4d5)(), (0, $d582f70bc143c925$export$de9862929b76bf57)());
}
function $924e7295504cb58d$var$withScope(callback) {
    return $924e7295504cb58d$var$getAsyncContextStack().withScope(callback);
}
function $924e7295504cb58d$var$withSetScope(scope, callback) {
    const stack = $924e7295504cb58d$var$getAsyncContextStack();
    return stack.withScope(()=>{
        stack.getStackTop().scope = scope;
        return callback(scope);
    });
}
function $924e7295504cb58d$var$withIsolationScope(callback) {
    return $924e7295504cb58d$var$getAsyncContextStack().withScope(()=>{
        return callback($924e7295504cb58d$var$getAsyncContextStack().getIsolationScope());
    });
}
/**
 * Get the stack-based async context strategy.
 */ function $924e7295504cb58d$export$329d4d4d54e42710() {
    return {
        withIsolationScope: $924e7295504cb58d$var$withIsolationScope,
        withScope: $924e7295504cb58d$var$withScope,
        withSetScope: $924e7295504cb58d$var$withSetScope,
        withSetIsolationScope: (_isolationScope, callback)=>{
            return $924e7295504cb58d$var$withIsolationScope(callback);
        },
        getCurrentScope: ()=>$924e7295504cb58d$var$getAsyncContextStack().getScope(),
        getIsolationScope: ()=>$924e7295504cb58d$var$getAsyncContextStack().getIsolationScope()
    };
}


/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $dbc4f026218a21f4$export$774ae0e6b6e444ca(strategy) {
    // Get main carrier (global for every environment)
    const registry = (0, $911e5c703825d4fd$export$19eade501500c6c1)();
    const sentry = (0, $911e5c703825d4fd$export$c8bfa33e4e8ae492)(registry);
    sentry.acs = strategy;
}
/**
 * Get the current async context strategy.
 * If none has been setup, the default will be used.
 */ function $dbc4f026218a21f4$export$f639b0c2752203be(carrier) {
    const sentry = (0, $911e5c703825d4fd$export$c8bfa33e4e8ae492)(carrier);
    if (sentry.acs) return sentry.acs;
    // Otherwise, use the default one (stack)
    return (0, $924e7295504cb58d$export$329d4d4d54e42710)();
}





/**
 * Get the currently active scope.
 */ function $5d0bc397896c048e$export$c7be4b0125a10cba() {
    const carrier = (0, $911e5c703825d4fd$export$19eade501500c6c1)();
    const acs = (0, $dbc4f026218a21f4$export$f639b0c2752203be)(carrier);
    return acs.getCurrentScope();
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current execution context.
 */ function $5d0bc397896c048e$export$68f3af03034c9e90() {
    const carrier = (0, $911e5c703825d4fd$export$19eade501500c6c1)();
    const acs = (0, $dbc4f026218a21f4$export$f639b0c2752203be)(carrier);
    return acs.getIsolationScope();
}
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function $5d0bc397896c048e$export$aa55d5ab8e05984f() {
    return (0, $911e5c703825d4fd$export$7e223ec222791509)("globalScope", ()=>new (0, $e0ce129be50721dc$export$775b6bb06e53a214)());
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function $5d0bc397896c048e$export$ec58d9285c204497(...rest) {
    const carrier = (0, $911e5c703825d4fd$export$19eade501500c6c1)();
    const acs = (0, $dbc4f026218a21f4$export$f639b0c2752203be)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) return acs.withScope(callback);
        return acs.withSetScope(scope, callback);
    }
    return acs.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 */ /**
 * Either creates a new active isolation scope, or sets the given isolation scope as active scope in the given callback.
 */ function $5d0bc397896c048e$export$9a4fed82c350c2bd(...rest) {
    const carrier = (0, $911e5c703825d4fd$export$19eade501500c6c1)();
    const acs = (0, $dbc4f026218a21f4$export$f639b0c2752203be)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [isolationScope, callback] = rest;
        if (!isolationScope) return acs.withIsolationScope(callback);
        return acs.withSetIsolationScope(isolationScope, callback);
    }
    return acs.withIsolationScope(rest[0]);
}
/**
 * Get the currently active client.
 */ function $5d0bc397896c048e$export$6bb76d6eba7e258c() {
    return $5d0bc397896c048e$export$c7be4b0125a10cba().getClient();
}
/**
 * Get a trace context for the given scope.
 */ function $5d0bc397896c048e$export$1e83db7ee4876dc4(scope) {
    const propagationContext = scope.getPropagationContext();
    const { traceId: traceId, parentSpanId: parentSpanId, propagationSpanId: propagationSpanId } = propagationContext;
    const traceContext = {
        trace_id: traceId,
        span_id: propagationSpanId || (0, $956629e5843a7517$export$295213bc4d0c54ad)()
    };
    if (parentSpanId) traceContext.parent_span_id = parentSpanId;
    return traceContext;
}




const $ef5328dba375a694$export$b14a8888f80a0b3e = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preserve the order of integrations in the array.
 *
 * @private
 */ function $ef5328dba375a694$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.values(integrationsByName);
}
/** Gets integrations to install */ function $ef5328dba375a694$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === "function") {
        const resolvedUserIntegrations = userIntegrations(defaultIntegrations);
        integrations = Array.isArray(resolvedUserIntegrations) ? resolvedUserIntegrations : [
            resolvedUserIntegrations
        ];
    } else integrations = defaultIntegrations;
    return $ef5328dba375a694$var$filterDuplicates(integrations);
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function $ef5328dba375a694$export$51abed9797baa598(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        // guard against empty provided integrations
        if (integration) $ef5328dba375a694$export$e7390a03b70a6f2f(client, integration, integrationIndex);
    });
    return integrationIndex;
}
/**
 * Execute the `afterAllSetup` hooks of the given integrations.
 */ function $ef5328dba375a694$export$35abcfd71227c6ca(client, integrations) {
    for (const integration of integrations)// guard against empty provided integrations
    if (integration?.afterAllSetup) integration.afterAllSetup(client);
}
/** Setup a single integration.  */ function $ef5328dba375a694$export$e7390a03b70a6f2f(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        (0, $20f7ec4490ac47c4$export$16a28057038b10ef) && (0, $90b8a6ace9b755b8$export$af88d00dbe7f521).log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    // `setupOnce` is only called the first time
    if ($ef5328dba375a694$export$b14a8888f80a0b3e.indexOf(integration.name) === -1 && typeof integration.setupOnce === "function") {
        integration.setupOnce();
        $ef5328dba375a694$export$b14a8888f80a0b3e.push(integration.name);
    }
    // `setup` is run for each client
    if (integration.setup && typeof integration.setup === "function") integration.setup(client);
    if (typeof integration.preprocessEvent === "function") {
        const callback = integration.preprocessEvent.bind(integration);
        client.on("preprocessEvent", (event, hint)=>callback(event, hint, client));
    }
    if (typeof integration.processEvent === "function") {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    (0, $20f7ec4490ac47c4$export$16a28057038b10ef) && (0, $90b8a6ace9b755b8$export$af88d00dbe7f521).log(`Integration installed: ${integration.name}`);
}
/** Add an integration to the current scope's client. */ function $ef5328dba375a694$export$2d8f5188773bcddd(integration) {
    const client = (0, $5d0bc397896c048e$export$6bb76d6eba7e258c)();
    if (!client) {
        (0, $20f7ec4490ac47c4$export$16a28057038b10ef) && (0, $90b8a6ace9b755b8$export$af88d00dbe7f521).warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
/**
 * Define an integration function that can be used to create an integration instance.
 * Note that this by design hides the implementation details of the integration, as they are considered internal.
 */ function $ef5328dba375a694$export$2323046b9414659f(fn) {
    return fn;
}


/**
 * Send user feedback to Sentry.
 */ function $0a8ed3f8a4d12824$export$3b07f81befe2dd0a(params, hint = {}, scope = (0, $5d0bc397896c048e$export$c7be4b0125a10cba)()) {
    const { message: message, name: name, email: email, url: url, source: source, associatedEventId: associatedEventId, tags: tags } = params;
    const feedbackEvent = {
        contexts: {
            feedback: {
                contact_email: email,
                name: name,
                message: message,
                url: url,
                source: source,
                associated_event_id: associatedEventId
            }
        },
        type: "feedback",
        level: "info",
        tags: tags
    };
    const client = scope?.getClient() || (0, $5d0bc397896c048e$export$6bb76d6eba7e258c)();
    if (client) client.emit("beforeSendFeedback", feedbackEvent, hint);
    const eventId = scope.captureEvent(feedbackEvent, hint);
    return eventId;
}


var $b4Ec1 = parcelRequire("b4Ec1");

/**
 * Returns true if we are in the browser.
 */ function $ef854fce0a2f15d6$export$4e09c449d6c407f7() {
    // eslint-disable-next-line no-restricted-globals
    return typeof window !== "undefined" && (!(0, $b4Ec1.isNodeEnv)() || $ef854fce0a2f15d6$var$isElectronNodeRenderer());
}
// Electron renderers with nodeIntegration enabled are detected as Node.js so we specifically test for them
function $ef854fce0a2f15d6$var$isElectronNodeRenderer() {
    const process = (0, $3042afa3ea37a05a$export$f1a6cdb1459e81d1).process;
    return process?.type === "renderer";
}


// exporting a separate copy of `WINDOW` rather than exporting the one from `@sentry/browser`
// prevents the browser package from being bundled in the CDN bundle, and avoids a
// circular dependency between the browser and feedback packages
const $de7c19ef16e9e5a3$var$WINDOW = (0, $3042afa3ea37a05a$export$f1a6cdb1459e81d1);
const $de7c19ef16e9e5a3$var$DOCUMENT = $de7c19ef16e9e5a3$var$WINDOW.document;
const $de7c19ef16e9e5a3$var$NAVIGATOR = $de7c19ef16e9e5a3$var$WINDOW.navigator;
const $de7c19ef16e9e5a3$var$TRIGGER_LABEL = "Report a Bug";
const $de7c19ef16e9e5a3$var$CANCEL_BUTTON_LABEL = "Cancel";
const $de7c19ef16e9e5a3$var$SUBMIT_BUTTON_LABEL = "Send Bug Report";
const $de7c19ef16e9e5a3$var$CONFIRM_BUTTON_LABEL = "Confirm";
const $de7c19ef16e9e5a3$var$FORM_TITLE = "Report a Bug";
const $de7c19ef16e9e5a3$var$EMAIL_PLACEHOLDER = "your.email@example.org";
const $de7c19ef16e9e5a3$var$EMAIL_LABEL = "Email";
const $de7c19ef16e9e5a3$var$MESSAGE_PLACEHOLDER = "What's the bug? What did you expect?";
const $de7c19ef16e9e5a3$var$MESSAGE_LABEL = "Description";
const $de7c19ef16e9e5a3$var$NAME_PLACEHOLDER = "Your Name";
const $de7c19ef16e9e5a3$var$NAME_LABEL = "Name";
const $de7c19ef16e9e5a3$var$SUCCESS_MESSAGE_TEXT = "Thank you for your report!";
const $de7c19ef16e9e5a3$var$IS_REQUIRED_LABEL = "(required)";
const $de7c19ef16e9e5a3$var$ADD_SCREENSHOT_LABEL = "Add a screenshot";
const $de7c19ef16e9e5a3$var$REMOVE_SCREENSHOT_LABEL = "Remove screenshot";
const $de7c19ef16e9e5a3$var$FEEDBACK_WIDGET_SOURCE = "widget";
const $de7c19ef16e9e5a3$var$FEEDBACK_API_SOURCE = "api";
const $de7c19ef16e9e5a3$var$SUCCESS_MESSAGE_TIMEOUT = 5000;
/**
 * Public API to send a Feedback item to Sentry
 */ const $de7c19ef16e9e5a3$export$a65d69dd22caceda = (params, hint = {
    includeReplay: true
})=>{
    if (!params.message) throw new Error("Unable to submit feedback with empty message");
    // We want to wait for the feedback to be sent (or not)
    const client = (0, $5d0bc397896c048e$export$6bb76d6eba7e258c)();
    if (!client) throw new Error("No client setup, cannot send feedback.");
    if (params.tags && Object.keys(params.tags).length) (0, $5d0bc397896c048e$export$c7be4b0125a10cba)().setTags(params.tags);
    const eventId = (0, $0a8ed3f8a4d12824$export$3b07f81befe2dd0a)({
        source: $de7c19ef16e9e5a3$var$FEEDBACK_API_SOURCE,
        url: (0, $1a28f4370f93c31b$export$1cfafeee2987818b)(),
        ...params
    }, hint);
    // We want to wait for the feedback to be sent (or not)
    return new Promise((resolve, reject)=>{
        // After 5s, we want to clear anyhow
        const timeout = setTimeout(()=>reject("Unable to determine if Feedback was correctly sent."), 5000);
        const cleanup = client.on("afterSendEvent", (event, response)=>{
            if (event.event_id !== eventId) return;
            clearTimeout(timeout);
            cleanup();
            // Require valid status codes, otherwise can assume feedback was not sent successfully
            if (response && typeof response.statusCode === "number" && response.statusCode >= 200 && response.statusCode < 300) return resolve(eventId);
            if (response && typeof response.statusCode === "number" && response.statusCode === 0) return reject("Unable to send Feedback. This is because of network issues, or because you are using an ad-blocker.");
            if (response && typeof response.statusCode === "number" && response.statusCode === 403) return reject("Unable to send Feedback. This could be because this domain is not in your list of allowed domains.");
            return reject("Unable to send Feedback. This could be because of network issues, or because you are using an ad-blocker");
        });
    });
};
/*
 * For reference, the fully built event looks something like this:
 * {
 *     "type": "feedback",
 *     "event_id": "d2132d31b39445f1938d7e21b6bf0ec4",
 *     "timestamp": 1597977777.6189718,
 *     "dist": "1.12",
 *     "platform": "javascript",
 *     "environment": "production",
 *     "release": 42,
 *     "tags": {"transaction": "/organizations/:orgId/performance/:eventSlug/"},
 *     "sdk": {"name": "name", "version": "version"},
 *     "user": {
 *         "id": "123",
 *         "username": "user",
 *         "email": "user@site.com",
 *         "ip_address": "192.168.11.12",
 *     },
 *     "request": {
 *         "url": None,
 *         "headers": {
 *             "user-Agent": "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/15.5 Safari/605.1.15"
 *         },
 *     },
 *     "contexts": {
 *         "feedback": {
 *             "message": "test message",
 *             "contact_email": "test@example.com",
 *             "type": "feedback",
 *         },
 *         "trace": {
 *             "trace_id": "4C79F60C11214EB38604F4AE0781BFB2",
 *             "span_id": "FA90FDEAD5F74052",
 *             "type": "trace",
 *         },
 *         "replay": {
 *             "replay_id": "e2d42047b1c5431c8cba85ee2a8ab25d",
 *         },
 *     },
 *   }
 */ /**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $de7c19ef16e9e5a3$var$DEBUG_BUILD = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;
/**
 * Mobile browsers do not support `mediaDevices.getDisplayMedia` even though they have the api implemented
 * Instead they return things like `NotAllowedError` when called.
 *
 * It's simpler for us to browser sniff first, and avoid loading the integration if we can.
 *
 * https://stackoverflow.com/a/58879212
 * https://stackoverflow.com/a/3540295
 *
 * `mediaDevices.getDisplayMedia` is also only supported in secure contexts, and return a `mediaDevices is not supported` error, so we should also avoid loading the integration if we can.
 *
 * https://developer.mozilla.org/en-US/docs/Web/API/MediaDevices/getDisplayMedia
 */ function $de7c19ef16e9e5a3$var$isScreenshotSupported() {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test($de7c19ef16e9e5a3$var$NAVIGATOR.userAgent)) return false;
    /**
   * User agent on iPads show as Macintosh, so we need extra checks
   *
   * https://forums.developer.apple.com/forums/thread/119186
   * https://stackoverflow.com/questions/60482650/how-to-detect-ipad-useragent-on-safari-browser
   */ if (/Macintosh/i.test($de7c19ef16e9e5a3$var$NAVIGATOR.userAgent) && $de7c19ef16e9e5a3$var$NAVIGATOR.maxTouchPoints && $de7c19ef16e9e5a3$var$NAVIGATOR.maxTouchPoints > 1) return false;
    if (!isSecureContext) return false;
    return true;
}
/**
 * Quick and dirty deep merge for the Feedback integration options
 */ function $de7c19ef16e9e5a3$var$mergeOptions(defaultOptions, optionOverrides) {
    return {
        ...defaultOptions,
        ...optionOverrides,
        tags: {
            ...defaultOptions.tags,
            ...optionOverrides.tags
        },
        onFormOpen: ()=>{
            optionOverrides.onFormOpen?.();
            defaultOptions.onFormOpen?.();
        },
        onFormClose: ()=>{
            optionOverrides.onFormClose?.();
            defaultOptions.onFormClose?.();
        },
        onSubmitSuccess: (data)=>{
            optionOverrides.onSubmitSuccess?.(data);
            defaultOptions.onSubmitSuccess?.(data);
        },
        onSubmitError: (error)=>{
            optionOverrides.onSubmitError?.(error);
            defaultOptions.onSubmitError?.(error);
        },
        onFormSubmitted: ()=>{
            optionOverrides.onFormSubmitted?.();
            defaultOptions.onFormSubmitted?.();
        },
        themeDark: {
            ...defaultOptions.themeDark,
            ...optionOverrides.themeDark
        },
        themeLight: {
            ...defaultOptions.themeLight,
            ...optionOverrides.themeLight
        }
    };
}
/**
 * Creates <style> element for widget actor (button that opens the dialog)
 */ function $de7c19ef16e9e5a3$var$createActorStyles(styleNonce) {
    const style = $de7c19ef16e9e5a3$var$DOCUMENT.createElement("style");
    style.textContent = `
.widget__actor {
  position: fixed;
  z-index: var(--z-index);
  margin: var(--page-margin);
  inset: var(--actor-inset);

  display: flex;
  align-items: center;
  gap: 8px;
  padding: 16px;

  font-family: inherit;
  font-size: var(--font-size);
  font-weight: 600;
  line-height: 1.14em;
  text-decoration: none;

  background: var(--actor-background, var(--background));
  border-radius: var(--actor-border-radius, 1.7em/50%);
  border: var(--actor-border, var(--border));
  box-shadow: var(--actor-box-shadow, var(--box-shadow));
  color: var(--actor-color, var(--foreground));
  fill: var(--actor-color, var(--foreground));
  cursor: pointer;
  opacity: 1;
  transition: transform 0.2s ease-in-out;
  transform: translate(0, 0) scale(1);
}
.widget__actor[aria-hidden="true"] {
  opacity: 0;
  pointer-events: none;
  visibility: hidden;
  transform: translate(0, 16px) scale(0.98);
}

.widget__actor:hover {
  background: var(--actor-hover-background, var(--background));
  filter: var(--interactive-filter);
}

.widget__actor svg {
  width: 1.14em;
  height: 1.14em;
}

@media (max-width: 600px) {
  .widget__actor span {
    display: none;
  }
}
`;
    if (styleNonce) style.setAttribute("nonce", styleNonce);
    return style;
}
/**
 * Helper function to set a dict of attributes on element (w/ specified namespace)
 */ function $de7c19ef16e9e5a3$var$setAttributesNS(el, attributes) {
    Object.entries(attributes).forEach(([key, val])=>{
        el.setAttributeNS(null, key, val);
    });
    return el;
}
const $de7c19ef16e9e5a3$var$SIZE = 20;
const $de7c19ef16e9e5a3$var$XMLNS$2 = "http://www.w3.org/2000/svg";
/**
 * Feedback Icon
 */ function $de7c19ef16e9e5a3$var$FeedbackIcon() {
    const createElementNS = (tagName)=>$de7c19ef16e9e5a3$var$WINDOW.document.createElementNS($de7c19ef16e9e5a3$var$XMLNS$2, tagName);
    const svg = $de7c19ef16e9e5a3$var$setAttributesNS(createElementNS("svg"), {
        width: `${$de7c19ef16e9e5a3$var$SIZE}`,
        height: `${$de7c19ef16e9e5a3$var$SIZE}`,
        viewBox: `0 0 ${$de7c19ef16e9e5a3$var$SIZE} ${$de7c19ef16e9e5a3$var$SIZE}`,
        fill: "var(--actor-color, var(--foreground))"
    });
    const g = $de7c19ef16e9e5a3$var$setAttributesNS(createElementNS("g"), {
        clipPath: "url(#clip0_57_80)"
    });
    const path = $de7c19ef16e9e5a3$var$setAttributesNS(createElementNS("path"), {
        ["fill-rule"]: "evenodd",
        ["clip-rule"]: "evenodd",
        d: "M15.6622 15H12.3997C12.2129 14.9959 12.031 14.9396 11.8747 14.8375L8.04965 12.2H7.49956V19.1C7.4875 19.3348 7.3888 19.5568 7.22256 19.723C7.05632 19.8892 6.83435 19.9879 6.59956 20H2.04956C1.80193 19.9968 1.56535 19.8969 1.39023 19.7218C1.21511 19.5467 1.1153 19.3101 1.11206 19.0625V12.2H0.949652C0.824431 12.2017 0.700142 12.1783 0.584123 12.1311C0.468104 12.084 0.362708 12.014 0.274155 11.9255C0.185602 11.8369 0.115689 11.7315 0.0685419 11.6155C0.0213952 11.4995 -0.00202913 11.3752 -0.00034808 11.25V3.75C-0.00900498 3.62067 0.0092504 3.49095 0.0532651 3.36904C0.0972798 3.24712 0.166097 3.13566 0.255372 3.04168C0.344646 2.94771 0.452437 2.87327 0.571937 2.82307C0.691437 2.77286 0.82005 2.74798 0.949652 2.75H8.04965L11.8747 0.1625C12.031 0.0603649 12.2129 0.00407221 12.3997 0H15.6622C15.9098 0.00323746 16.1464 0.103049 16.3215 0.278167C16.4966 0.453286 16.5964 0.689866 16.5997 0.9375V3.25269C17.3969 3.42959 18.1345 3.83026 18.7211 4.41679C19.5322 5.22788 19.9878 6.32796 19.9878 7.47502C19.9878 8.62209 19.5322 9.72217 18.7211 10.5333C18.1345 11.1198 17.3969 11.5205 16.5997 11.6974V14.0125C16.6047 14.1393 16.5842 14.2659 16.5395 14.3847C16.4948 14.5035 16.4268 14.6121 16.3394 14.7042C16.252 14.7962 16.147 14.8698 16.0307 14.9206C15.9144 14.9714 15.7891 14.9984 15.6622 15ZM1.89695 10.325H1.88715V4.625H8.33715C8.52423 4.62301 8.70666 4.56654 8.86215 4.4625L12.6872 1.875H14.7247V13.125H12.6872L8.86215 10.4875C8.70666 10.3835 8.52423 10.327 8.33715 10.325H2.20217C2.15205 10.3167 2.10102 10.3125 2.04956 10.3125C1.9981 10.3125 1.94708 10.3167 1.89695 10.325ZM2.98706 12.2V18.1625H5.66206V12.2H2.98706ZM16.5997 9.93612V5.01393C16.6536 5.02355 16.7072 5.03495 16.7605 5.04814C17.1202 5.13709 17.4556 5.30487 17.7425 5.53934C18.0293 5.77381 18.2605 6.06912 18.4192 6.40389C18.578 6.73866 18.6603 7.10452 18.6603 7.47502C18.6603 7.84552 18.578 8.21139 18.4192 8.54616C18.2605 8.88093 18.0293 9.17624 17.7425 9.41071C17.4556 9.64518 17.1202 9.81296 16.7605 9.90191C16.7072 9.91509 16.6536 9.9265 16.5997 9.93612Z"
    });
    svg.appendChild(g).appendChild(path);
    const speakerDefs = createElementNS("defs");
    const speakerClipPathDef = $de7c19ef16e9e5a3$var$setAttributesNS(createElementNS("clipPath"), {
        id: "clip0_57_80"
    });
    const speakerRect = $de7c19ef16e9e5a3$var$setAttributesNS(createElementNS("rect"), {
        width: `${$de7c19ef16e9e5a3$var$SIZE}`,
        height: `${$de7c19ef16e9e5a3$var$SIZE}`,
        fill: "white"
    });
    speakerClipPathDef.appendChild(speakerRect);
    speakerDefs.appendChild(speakerClipPathDef);
    svg.appendChild(speakerDefs).appendChild(speakerClipPathDef).appendChild(speakerRect);
    return svg;
}
/**
 * The sentry-provided button to open the feedback modal
 */ function $de7c19ef16e9e5a3$var$Actor({ triggerLabel: triggerLabel, triggerAriaLabel: triggerAriaLabel, shadow: shadow, styleNonce: styleNonce }) {
    const el = $de7c19ef16e9e5a3$var$DOCUMENT.createElement("button");
    el.type = "button";
    el.className = "widget__actor";
    el.ariaHidden = "false";
    el.ariaLabel = triggerAriaLabel || triggerLabel || $de7c19ef16e9e5a3$var$TRIGGER_LABEL;
    el.appendChild($de7c19ef16e9e5a3$var$FeedbackIcon());
    if (triggerLabel) {
        const label = $de7c19ef16e9e5a3$var$DOCUMENT.createElement("span");
        label.appendChild($de7c19ef16e9e5a3$var$DOCUMENT.createTextNode(triggerLabel));
        el.appendChild(label);
    }
    const style = $de7c19ef16e9e5a3$var$createActorStyles(styleNonce);
    return {
        el: el,
        appendToDom () {
            shadow.appendChild(style);
            shadow.appendChild(el);
        },
        removeFromDom () {
            el.remove();
            style.remove();
        },
        show () {
            el.ariaHidden = "false";
        },
        hide () {
            el.ariaHidden = "true";
        }
    };
}
const $de7c19ef16e9e5a3$var$PURPLE = "rgba(88, 74, 192, 1)";
const $de7c19ef16e9e5a3$var$DEFAULT_LIGHT = {
    foreground: "#2b2233",
    background: "#ffffff",
    accentForeground: "white",
    accentBackground: $de7c19ef16e9e5a3$var$PURPLE,
    successColor: "#268d75",
    errorColor: "#df3338",
    border: "1.5px solid rgba(41, 35, 47, 0.13)",
    boxShadow: "0px 4px 24px 0px rgba(43, 34, 51, 0.12)",
    outline: "1px auto var(--accent-background)",
    interactiveFilter: "brightness(95%)"
};
const $de7c19ef16e9e5a3$var$DEFAULT_DARK = {
    foreground: "#ebe6ef",
    background: "#29232f",
    accentForeground: "white",
    accentBackground: $de7c19ef16e9e5a3$var$PURPLE,
    successColor: "#2da98c",
    errorColor: "#f55459",
    border: "1.5px solid rgba(235, 230, 239, 0.15)",
    boxShadow: "0px 4px 24px 0px rgba(43, 34, 51, 0.12)",
    outline: "1px auto var(--accent-background)",
    interactiveFilter: "brightness(150%)"
};
function $de7c19ef16e9e5a3$var$getThemedCssVariables(theme) {
    return `
  --foreground: ${theme.foreground};
  --background: ${theme.background};
  --accent-foreground: ${theme.accentForeground};
  --accent-background: ${theme.accentBackground};
  --success-color: ${theme.successColor};
  --error-color: ${theme.errorColor};
  --border: ${theme.border};
  --box-shadow: ${theme.boxShadow};
  --outline: ${theme.outline};
  --interactive-filter: ${theme.interactiveFilter};
  `;
}
/**
 * Creates <style> element for widget actor (button that opens the dialog)
 */ function $de7c19ef16e9e5a3$var$createMainStyles({ colorScheme: colorScheme, themeDark: themeDark, themeLight: themeLight, styleNonce: styleNonce }) {
    const style = $de7c19ef16e9e5a3$var$DOCUMENT.createElement("style");
    style.textContent = `
:host {
  --font-family: system-ui, 'Helvetica Neue', Arial, sans-serif;
  --font-size: 14px;
  --z-index: 100000;

  --page-margin: 16px;
  --inset: auto 0 0 auto;
  --actor-inset: var(--inset);

  font-family: var(--font-family);
  font-size: var(--font-size);

  ${colorScheme !== "system" ? "color-scheme: only light;" : ""}

  ${$de7c19ef16e9e5a3$var$getThemedCssVariables(colorScheme === "dark" ? {
        ...$de7c19ef16e9e5a3$var$DEFAULT_DARK,
        ...themeDark
    } : {
        ...$de7c19ef16e9e5a3$var$DEFAULT_LIGHT,
        ...themeLight
    })}
}

${colorScheme === "system" ? `
@media (prefers-color-scheme: dark) {
  :host {
    ${$de7c19ef16e9e5a3$var$getThemedCssVariables({
        ...$de7c19ef16e9e5a3$var$DEFAULT_DARK,
        ...themeDark
    })}
  }
}` : ""}
}
`;
    if (styleNonce) style.setAttribute("nonce", styleNonce);
    return style;
}
const $de7c19ef16e9e5a3$export$13a9e5a543258f97 = ({ lazyLoadIntegration: lazyLoadIntegration, getModalIntegration: getModalIntegration, getScreenshotIntegration: getScreenshotIntegration })=>{
    const feedbackIntegration = ({ id: // FeedbackGeneralConfiguration
    id = "sentry-feedback", autoInject: autoInject = true, showBranding: showBranding = true, isEmailRequired: isEmailRequired = false, isNameRequired: isNameRequired = false, showEmail: showEmail = true, showName: showName = true, enableScreenshot: enableScreenshot = true, useSentryUser: useSentryUser = {
        email: "email",
        name: "username"
    }, tags: tags, styleNonce: styleNonce, scriptNonce: scriptNonce, colorScheme: // FeedbackThemeConfiguration
    colorScheme = "system", themeLight: themeLight = {}, themeDark: themeDark = {}, addScreenshotButtonLabel: // FeedbackTextConfiguration
    addScreenshotButtonLabel = $de7c19ef16e9e5a3$var$ADD_SCREENSHOT_LABEL, cancelButtonLabel: cancelButtonLabel = $de7c19ef16e9e5a3$var$CANCEL_BUTTON_LABEL, confirmButtonLabel: confirmButtonLabel = $de7c19ef16e9e5a3$var$CONFIRM_BUTTON_LABEL, emailLabel: emailLabel = $de7c19ef16e9e5a3$var$EMAIL_LABEL, emailPlaceholder: emailPlaceholder = $de7c19ef16e9e5a3$var$EMAIL_PLACEHOLDER, formTitle: formTitle = $de7c19ef16e9e5a3$var$FORM_TITLE, isRequiredLabel: isRequiredLabel = $de7c19ef16e9e5a3$var$IS_REQUIRED_LABEL, messageLabel: messageLabel = $de7c19ef16e9e5a3$var$MESSAGE_LABEL, messagePlaceholder: messagePlaceholder = $de7c19ef16e9e5a3$var$MESSAGE_PLACEHOLDER, nameLabel: nameLabel = $de7c19ef16e9e5a3$var$NAME_LABEL, namePlaceholder: namePlaceholder = $de7c19ef16e9e5a3$var$NAME_PLACEHOLDER, removeScreenshotButtonLabel: removeScreenshotButtonLabel = $de7c19ef16e9e5a3$var$REMOVE_SCREENSHOT_LABEL, submitButtonLabel: submitButtonLabel = $de7c19ef16e9e5a3$var$SUBMIT_BUTTON_LABEL, successMessageText: successMessageText = $de7c19ef16e9e5a3$var$SUCCESS_MESSAGE_TEXT, triggerLabel: triggerLabel = $de7c19ef16e9e5a3$var$TRIGGER_LABEL, triggerAriaLabel: triggerAriaLabel = "", onFormOpen: // FeedbackCallbacks
    onFormOpen, onFormClose: onFormClose, onSubmitSuccess: onSubmitSuccess, onSubmitError: onSubmitError, onFormSubmitted: onFormSubmitted } = {})=>{
        const _options = {
            id: id,
            autoInject: autoInject,
            showBranding: showBranding,
            isEmailRequired: isEmailRequired,
            isNameRequired: isNameRequired,
            showEmail: showEmail,
            showName: showName,
            enableScreenshot: enableScreenshot,
            useSentryUser: useSentryUser,
            tags: tags,
            styleNonce: styleNonce,
            scriptNonce: scriptNonce,
            colorScheme: colorScheme,
            themeDark: themeDark,
            themeLight: themeLight,
            triggerLabel: triggerLabel,
            triggerAriaLabel: triggerAriaLabel,
            cancelButtonLabel: cancelButtonLabel,
            submitButtonLabel: submitButtonLabel,
            confirmButtonLabel: confirmButtonLabel,
            formTitle: formTitle,
            emailLabel: emailLabel,
            emailPlaceholder: emailPlaceholder,
            messageLabel: messageLabel,
            messagePlaceholder: messagePlaceholder,
            nameLabel: nameLabel,
            namePlaceholder: namePlaceholder,
            successMessageText: successMessageText,
            isRequiredLabel: isRequiredLabel,
            addScreenshotButtonLabel: addScreenshotButtonLabel,
            removeScreenshotButtonLabel: removeScreenshotButtonLabel,
            onFormClose: onFormClose,
            onFormOpen: onFormOpen,
            onSubmitError: onSubmitError,
            onSubmitSuccess: onSubmitSuccess,
            onFormSubmitted: onFormSubmitted
        };
        let _shadow = null;
        let _subscriptions = [];
        /**
     * Get the shadow root where we will append css
     */ const _createShadow = (options)=>{
            if (!_shadow) {
                const host = $de7c19ef16e9e5a3$var$DOCUMENT.createElement("div");
                host.id = String(options.id);
                $de7c19ef16e9e5a3$var$DOCUMENT.body.appendChild(host);
                _shadow = host.attachShadow({
                    mode: "open"
                });
                _shadow.appendChild($de7c19ef16e9e5a3$var$createMainStyles(options));
            }
            return _shadow;
        };
        const _loadAndRenderDialog = async (options)=>{
            const screenshotRequired = options.enableScreenshot && $de7c19ef16e9e5a3$var$isScreenshotSupported();
            let modalIntegration;
            let screenshotIntegration;
            try {
                const modalIntegrationFn = getModalIntegration ? getModalIntegration() : await lazyLoadIntegration("feedbackModalIntegration", scriptNonce);
                modalIntegration = modalIntegrationFn();
                (0, $ef5328dba375a694$export$2d8f5188773bcddd)(modalIntegration);
            } catch  {
                $de7c19ef16e9e5a3$var$DEBUG_BUILD && (0, $90b8a6ace9b755b8$export$af88d00dbe7f521).error("[Feedback] Error when trying to load feedback integrations. Try using `feedbackSyncIntegration` in your `Sentry.init`.");
                throw new Error("[Feedback] Missing feedback modal integration!");
            }
            try {
                const screenshotIntegrationFn = screenshotRequired ? getScreenshotIntegration ? getScreenshotIntegration() : await lazyLoadIntegration("feedbackScreenshotIntegration", scriptNonce) : undefined;
                if (screenshotIntegrationFn) {
                    screenshotIntegration = screenshotIntegrationFn();
                    (0, $ef5328dba375a694$export$2d8f5188773bcddd)(screenshotIntegration);
                }
            } catch  {
                $de7c19ef16e9e5a3$var$DEBUG_BUILD && (0, $90b8a6ace9b755b8$export$af88d00dbe7f521).error("[Feedback] Missing feedback screenshot integration. Proceeding without screenshots.");
            }
            const dialog = modalIntegration.createDialog({
                options: {
                    ...options,
                    onFormClose: ()=>{
                        dialog?.close();
                        options.onFormClose?.();
                    },
                    onFormSubmitted: ()=>{
                        dialog?.close();
                        options.onFormSubmitted?.();
                    }
                },
                screenshotIntegration: screenshotIntegration,
                sendFeedback: $de7c19ef16e9e5a3$export$a65d69dd22caceda,
                shadow: _createShadow(options)
            });
            return dialog;
        };
        const _attachTo = (el, optionOverrides = {})=>{
            const mergedOptions = $de7c19ef16e9e5a3$var$mergeOptions(_options, optionOverrides);
            const targetEl = typeof el === "string" ? $de7c19ef16e9e5a3$var$DOCUMENT.querySelector(el) : typeof el.addEventListener === "function" ? el : null;
            if (!targetEl) {
                $de7c19ef16e9e5a3$var$DEBUG_BUILD && (0, $90b8a6ace9b755b8$export$af88d00dbe7f521).error("[Feedback] Unable to attach to target element");
                throw new Error("Unable to attach to target element");
            }
            let dialog = null;
            const handleClick = async ()=>{
                if (!dialog) dialog = await _loadAndRenderDialog({
                    ...mergedOptions,
                    onFormSubmitted: ()=>{
                        dialog?.removeFromDom();
                        mergedOptions.onFormSubmitted?.();
                    }
                });
                dialog.appendToDom();
                dialog.open();
            };
            targetEl.addEventListener("click", handleClick);
            const unsubscribe = ()=>{
                _subscriptions = _subscriptions.filter((sub)=>sub !== unsubscribe);
                dialog?.removeFromDom();
                dialog = null;
                targetEl.removeEventListener("click", handleClick);
            };
            _subscriptions.push(unsubscribe);
            return unsubscribe;
        };
        const _createActor = (optionOverrides = {})=>{
            const mergedOptions = $de7c19ef16e9e5a3$var$mergeOptions(_options, optionOverrides);
            const shadow = _createShadow(mergedOptions);
            const actor = $de7c19ef16e9e5a3$var$Actor({
                triggerLabel: mergedOptions.triggerLabel,
                triggerAriaLabel: mergedOptions.triggerAriaLabel,
                shadow: shadow,
                styleNonce: styleNonce
            });
            _attachTo(actor.el, {
                ...mergedOptions,
                onFormOpen () {
                    actor.hide();
                },
                onFormClose () {
                    actor.show();
                },
                onFormSubmitted () {
                    actor.show();
                }
            });
            return actor;
        };
        return {
            name: "Feedback",
            setupOnce () {
                if (!(0, $ef854fce0a2f15d6$export$4e09c449d6c407f7)() || !_options.autoInject) return;
                if ($de7c19ef16e9e5a3$var$DOCUMENT.readyState === "loading") $de7c19ef16e9e5a3$var$DOCUMENT.addEventListener("DOMContentLoaded", ()=>_createActor().appendToDom());
                else _createActor().appendToDom();
            },
            /**
       * Adds click listener to the element to open a feedback dialog
       *
       * The returned function can be used to remove the click listener
       */ attachTo: _attachTo,
            /**
       * Creates a new widget which is composed of a Button which triggers a Dialog.
       * Accepts partial options to override any options passed to constructor.
       */ createWidget (optionOverrides = {}) {
                const actor = _createActor($de7c19ef16e9e5a3$var$mergeOptions(_options, optionOverrides));
                actor.appendToDom();
                return actor;
            },
            /**
       * Creates a new Form which you can
       * Accepts partial options to override any options passed to constructor.
       */ async createForm (optionOverrides = {}) {
                return _loadAndRenderDialog($de7c19ef16e9e5a3$var$mergeOptions(_options, optionOverrides));
            },
            /**
       * Removes the Feedback integration (including host, shadow DOM, and all widgets)
       */ remove () {
                if (_shadow) {
                    _shadow.parentElement?.remove();
                    _shadow = null;
                }
                // Remove any lingering subscriptions
                _subscriptions.forEach((sub)=>sub());
                _subscriptions = [];
            }
        };
    };
    return feedbackIntegration;
};
/**
 * This is a small utility to get a type-safe instance of the Feedback integration.
 */ function $de7c19ef16e9e5a3$export$ed85ee0b85ce96e1() {
    const client = (0, $5d0bc397896c048e$export$6bb76d6eba7e258c)();
    return client?.getIntegrationByName("Feedback");
}
var $de7c19ef16e9e5a3$var$n, $de7c19ef16e9e5a3$var$l$1, $de7c19ef16e9e5a3$var$u$1, $de7c19ef16e9e5a3$var$i$1, $de7c19ef16e9e5a3$var$o$1, $de7c19ef16e9e5a3$var$r$1, $de7c19ef16e9e5a3$var$f$1, $de7c19ef16e9e5a3$var$c$1 = {}, $de7c19ef16e9e5a3$var$s$1 = [], $de7c19ef16e9e5a3$var$a$1 = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, $de7c19ef16e9e5a3$var$h$1 = Array.isArray;
function $de7c19ef16e9e5a3$var$v$1(n, l) {
    for(var u in l)n[u] = l[u];
    return n;
}
function $de7c19ef16e9e5a3$var$p$1(n) {
    var l = n.parentNode;
    l && l.removeChild(n);
}
function $de7c19ef16e9e5a3$var$y$1(l, u, t) {
    var i, o, r, f = {};
    for(r in u)"key" == r ? i = u[r] : "ref" == r ? o = u[r] : f[r] = u[r];
    if (arguments.length > 2 && (f.children = arguments.length > 3 ? $de7c19ef16e9e5a3$var$n.call(arguments, 2) : t), "function" == typeof l && null != l.defaultProps) for(r in l.defaultProps)void 0 === f[r] && (f[r] = l.defaultProps[r]);
    return $de7c19ef16e9e5a3$var$d$1(l, f, i, o, null);
}
function $de7c19ef16e9e5a3$var$d$1(n, t, i, o, r) {
    var f = {
        type: n,
        props: t,
        key: i,
        ref: o,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __d: void 0,
        __c: null,
        constructor: void 0,
        __v: null == r ? ++$de7c19ef16e9e5a3$var$u$1 : r,
        __i: -1,
        __u: 0
    };
    return null == r && null != $de7c19ef16e9e5a3$var$l$1.vnode && $de7c19ef16e9e5a3$var$l$1.vnode(f), f;
}
function $de7c19ef16e9e5a3$var$g$1(n) {
    return n.children;
}
function $de7c19ef16e9e5a3$var$b$1(n, l) {
    this.props = n, this.context = l;
}
function $de7c19ef16e9e5a3$var$m$1(n, l) {
    if (null == l) return n.__ ? $de7c19ef16e9e5a3$var$m$1(n.__, n.__i + 1) : null;
    for(var u; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
    return "function" == typeof n.type ? $de7c19ef16e9e5a3$var$m$1(n) : null;
}
function $de7c19ef16e9e5a3$var$w$1(n, u, t) {
    var i, o = n.__v, r = o.__e, f = n.__P;
    if (f) return (i = $de7c19ef16e9e5a3$var$v$1({}, o)).__v = o.__v + 1, $de7c19ef16e9e5a3$var$l$1.vnode && $de7c19ef16e9e5a3$var$l$1.vnode(i), $de7c19ef16e9e5a3$var$M(f, i, o, n.__n, void 0 !== f.ownerSVGElement, 32 & o.__u ? [
        r
    ] : null, u, null == r ? $de7c19ef16e9e5a3$var$m$1(o) : r, !!(32 & o.__u), t), i.__.__k[i.__i] = i, i.__d = void 0, i.__e != r && $de7c19ef16e9e5a3$var$k$1(i), i;
}
function $de7c19ef16e9e5a3$var$k$1(n) {
    var l, u;
    if (null != (n = n.__) && null != n.__c) {
        for(n.__e = n.__c.base = null, l = 0; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) {
            n.__e = n.__c.base = u.__e;
            break;
        }
        return $de7c19ef16e9e5a3$var$k$1(n);
    }
}
function $de7c19ef16e9e5a3$var$x$1(n) {
    (!n.__d && (n.__d = true) && $de7c19ef16e9e5a3$var$i$1.push(n) && !$de7c19ef16e9e5a3$var$C$1.__r++ || $de7c19ef16e9e5a3$var$o$1 !== $de7c19ef16e9e5a3$var$l$1.debounceRendering) && (($de7c19ef16e9e5a3$var$o$1 = $de7c19ef16e9e5a3$var$l$1.debounceRendering) || $de7c19ef16e9e5a3$var$r$1)($de7c19ef16e9e5a3$var$C$1);
}
function $de7c19ef16e9e5a3$var$C$1() {
    var n, u, t, o = [], r = [];
    for($de7c19ef16e9e5a3$var$i$1.sort($de7c19ef16e9e5a3$var$f$1); n = $de7c19ef16e9e5a3$var$i$1.shift();)n.__d && (t = $de7c19ef16e9e5a3$var$i$1.length, u = $de7c19ef16e9e5a3$var$w$1(n, o, r) || u, 0 === t || $de7c19ef16e9e5a3$var$i$1.length > t ? ($de7c19ef16e9e5a3$var$j$1(o, u, r), r.length = o.length = 0, u = void 0, $de7c19ef16e9e5a3$var$i$1.sort($de7c19ef16e9e5a3$var$f$1)) : u && $de7c19ef16e9e5a3$var$l$1.__c && $de7c19ef16e9e5a3$var$l$1.__c(u, $de7c19ef16e9e5a3$var$s$1));
    u && $de7c19ef16e9e5a3$var$j$1(o, u, r), $de7c19ef16e9e5a3$var$C$1.__r = 0;
}
function $de7c19ef16e9e5a3$var$P$1(n, l, u, t, i, o, r, f, e, a, h) {
    var v, p, y, d, _, g = t && t.__k || $de7c19ef16e9e5a3$var$s$1, b = l.length;
    for(u.__d = e, $de7c19ef16e9e5a3$var$S(u, l, g), e = u.__d, v = 0; v < b; v++)null != (y = u.__k[v]) && "boolean" != typeof y && "function" != typeof y && (p = -1 === y.__i ? $de7c19ef16e9e5a3$var$c$1 : g[y.__i] || $de7c19ef16e9e5a3$var$c$1, y.__i = v, $de7c19ef16e9e5a3$var$M(n, y, p, i, o, r, f, e, a, h), d = y.__e, y.ref && p.ref != y.ref && (p.ref && $de7c19ef16e9e5a3$var$N(p.ref, null, y), h.push(y.ref, y.__c || d, y)), null == _ && null != d && (_ = d), 65536 & y.__u || p.__k === y.__k ? e = $de7c19ef16e9e5a3$var$$(y, e, n) : "function" == typeof y.type && void 0 !== y.__d ? e = y.__d : d && (e = d.nextSibling), y.__d = void 0, y.__u &= -196609);
    u.__d = e, u.__e = _;
}
function $de7c19ef16e9e5a3$var$S(n, l, u) {
    var t, i, o, r, f, e = l.length, c = u.length, s = c, a = 0;
    for(n.__k = [], t = 0; t < e; t++)null != (i = n.__k[t] = null == (i = l[t]) || "boolean" == typeof i || "function" == typeof i ? null : "string" == typeof i || "number" == typeof i || "bigint" == typeof i || i.constructor == String ? $de7c19ef16e9e5a3$var$d$1(null, i, null, null, i) : $de7c19ef16e9e5a3$var$h$1(i) ? $de7c19ef16e9e5a3$var$d$1($de7c19ef16e9e5a3$var$g$1, {
        children: i
    }, null, null, null) : void 0 === i.constructor && i.__b > 0 ? $de7c19ef16e9e5a3$var$d$1(i.type, i.props, i.key, i.ref ? i.ref : null, i.__v) : i) ? (i.__ = n, i.__b = n.__b + 1, f = $de7c19ef16e9e5a3$var$I(i, u, r = t + a, s), i.__i = f, o = null, -1 !== f && (s--, (o = u[f]) && (o.__u |= 131072)), null == o || null === o.__v ? (-1 == f && a--, "function" != typeof i.type && (i.__u |= 65536)) : f !== r && (f === r + 1 ? a++ : f > r ? s > e - r ? a += f - r : a-- : a = f < r && f == r - 1 ? f - r : 0, f !== t + a && (i.__u |= 65536))) : (o = u[t]) && null == o.key && o.__e && (o.__e == n.__d && (n.__d = $de7c19ef16e9e5a3$var$m$1(o)), $de7c19ef16e9e5a3$var$O(o, o, false), u[t] = null, s--);
    if (s) for(t = 0; t < c; t++)null != (o = u[t]) && 0 == (131072 & o.__u) && (o.__e == n.__d && (n.__d = $de7c19ef16e9e5a3$var$m$1(o)), $de7c19ef16e9e5a3$var$O(o, o));
}
function $de7c19ef16e9e5a3$var$$(n, l, u) {
    var t, i;
    if ("function" == typeof n.type) {
        for(t = n.__k, i = 0; t && i < t.length; i++)t[i] && (t[i].__ = n, l = $de7c19ef16e9e5a3$var$$(t[i], l, u));
        return l;
    }
    n.__e != l && (u.insertBefore(n.__e, l || null), l = n.__e);
    do l = l && l.nextSibling;
    while (null != l && 8 === l.nodeType);
    return l;
}
function $de7c19ef16e9e5a3$var$I(n, l, u, t) {
    var i = n.key, o = n.type, r = u - 1, f = u + 1, e = l[u];
    if (null === e || e && i == e.key && o === e.type) return u;
    if (t > (null != e && 0 == (131072 & e.__u) ? 1 : 0)) for(; r >= 0 || f < l.length;){
        if (r >= 0) {
            if ((e = l[r]) && 0 == (131072 & e.__u) && i == e.key && o === e.type) return r;
            r--;
        }
        if (f < l.length) {
            if ((e = l[f]) && 0 == (131072 & e.__u) && i == e.key && o === e.type) return f;
            f++;
        }
    }
    return -1;
}
function $de7c19ef16e9e5a3$var$T$1(n, l, u) {
    "-" === l[0] ? n.setProperty(l, null == u ? "" : u) : n[l] = null == u ? "" : "number" != typeof u || $de7c19ef16e9e5a3$var$a$1.test(l) ? u : u + "px";
}
function $de7c19ef16e9e5a3$var$A$1(n, l, u, t, i) {
    var o;
    n: if ("style" === l) {
        if ("string" == typeof u) n.style.cssText = u;
        else {
            if ("string" == typeof t && (n.style.cssText = t = ""), t) for(l in t)u && l in u || $de7c19ef16e9e5a3$var$T$1(n.style, l, "");
            if (u) for(l in u)t && u[l] === t[l] || $de7c19ef16e9e5a3$var$T$1(n.style, l, u[l]);
        }
    } else if ("o" === l[0] && "n" === l[1]) o = l !== (l = l.replace(/(PointerCapture)$|Capture$/i, "$1")), l = l.toLowerCase() in n ? l.toLowerCase().slice(2) : l.slice(2), n.l || (n.l = {}), n.l[l + o] = u, u ? t ? u.u = t.u : (u.u = Date.now(), n.addEventListener(l, o ? $de7c19ef16e9e5a3$var$L : $de7c19ef16e9e5a3$var$D$1, o)) : n.removeEventListener(l, o ? $de7c19ef16e9e5a3$var$L : $de7c19ef16e9e5a3$var$D$1, o);
    else {
        if (i) l = l.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
        else if ("width" !== l && "height" !== l && "href" !== l && "list" !== l && "form" !== l && "tabIndex" !== l && "download" !== l && "rowSpan" !== l && "colSpan" !== l && "role" !== l && l in n) try {
            n[l] = null == u ? "" : u;
            break n;
        } catch (n) {}
        "function" == typeof u || (null == u || false === u && "-" !== l[4] ? n.removeAttribute(l) : n.setAttribute(l, u));
    }
}
function $de7c19ef16e9e5a3$var$D$1(n) {
    if (this.l) {
        var u = this.l[n.type + false];
        if (n.t) {
            if (n.t <= u.u) return;
        } else n.t = Date.now();
        return u($de7c19ef16e9e5a3$var$l$1.event ? $de7c19ef16e9e5a3$var$l$1.event(n) : n);
    }
}
function $de7c19ef16e9e5a3$var$L(n) {
    if (this.l) return this.l[n.type + true]($de7c19ef16e9e5a3$var$l$1.event ? $de7c19ef16e9e5a3$var$l$1.event(n) : n);
}
function $de7c19ef16e9e5a3$var$M(n, u, t, i, o, r, f, e, c, s) {
    var a, p, y, d, _, m, w, k, x, C, S, $, H, I, T, A = u.type;
    if (void 0 !== u.constructor) return null;
    128 & t.__u && (c = !!(32 & t.__u), r = [
        e = u.__e = t.__e
    ]), (a = $de7c19ef16e9e5a3$var$l$1.__b) && a(u);
    n: if ("function" == typeof A) try {
        if (k = u.props, x = (a = A.contextType) && i[a.__c], C = a ? x ? x.props.value : a.__ : i, t.__c ? w = (p = u.__c = t.__c).__ = p.__E : ("prototype" in A && A.prototype.render ? u.__c = p = new A(k, C) : (u.__c = p = new $de7c19ef16e9e5a3$var$b$1(k, C), p.constructor = A, p.render = $de7c19ef16e9e5a3$var$q$1), x && x.sub(p), p.props = k, p.state || (p.state = {}), p.context = C, p.__n = i, y = p.__d = !0, p.__h = [], p._sb = []), null == p.__s && (p.__s = p.state), null != A.getDerivedStateFromProps && (p.__s == p.state && (p.__s = $de7c19ef16e9e5a3$var$v$1({}, p.__s)), $de7c19ef16e9e5a3$var$v$1(p.__s, A.getDerivedStateFromProps(k, p.__s))), d = p.props, _ = p.state, p.__v = u, y) null == A.getDerivedStateFromProps && null != p.componentWillMount && p.componentWillMount(), null != p.componentDidMount && p.__h.push(p.componentDidMount);
        else {
            if (null == A.getDerivedStateFromProps && k !== d && null != p.componentWillReceiveProps && p.componentWillReceiveProps(k, C), !p.__e && (null != p.shouldComponentUpdate && !1 === p.shouldComponentUpdate(k, p.__s, C) || u.__v === t.__v)) {
                for(u.__v !== t.__v && (p.props = k, p.state = p.__s, p.__d = !1), u.__e = t.__e, u.__k = t.__k, u.__k.forEach(function(n) {
                    n && (n.__ = u);
                }), S = 0; S < p._sb.length; S++)p.__h.push(p._sb[S]);
                p._sb = [], p.__h.length && f.push(p);
                break n;
            }
            null != p.componentWillUpdate && p.componentWillUpdate(k, p.__s, C), null != p.componentDidUpdate && p.__h.push(function() {
                p.componentDidUpdate(d, _, m);
            });
        }
        if (p.context = C, p.props = k, p.__P = n, p.__e = !1, $ = $de7c19ef16e9e5a3$var$l$1.__r, H = 0, "prototype" in A && A.prototype.render) {
            for(p.state = p.__s, p.__d = !1, $ && $(u), a = p.render(p.props, p.state, p.context), I = 0; I < p._sb.length; I++)p.__h.push(p._sb[I]);
            p._sb = [];
        } else do p.__d = !1, $ && $(u), a = p.render(p.props, p.state, p.context), p.state = p.__s;
        while (p.__d && ++H < 25);
        p.state = p.__s, null != p.getChildContext && (i = $de7c19ef16e9e5a3$var$v$1($de7c19ef16e9e5a3$var$v$1({}, i), p.getChildContext())), y || null == p.getSnapshotBeforeUpdate || (m = p.getSnapshotBeforeUpdate(d, _)), $de7c19ef16e9e5a3$var$P$1(n, $de7c19ef16e9e5a3$var$h$1(T = null != a && a.type === $de7c19ef16e9e5a3$var$g$1 && null == a.key ? a.props.children : a) ? T : [
            T
        ], u, t, i, o, r, f, e, c, s), p.base = u.__e, u.__u &= -161, p.__h.length && f.push(p), w && (p.__E = p.__ = null);
    } catch (n) {
        u.__v = null, c || null != r ? (u.__e = e, u.__u |= c ? 160 : 32, r[r.indexOf(e)] = null) : (u.__e = t.__e, u.__k = t.__k), $de7c19ef16e9e5a3$var$l$1.__e(n, u, t);
    }
    else null == r && u.__v === t.__v ? (u.__k = t.__k, u.__e = t.__e) : u.__e = $de7c19ef16e9e5a3$var$z$1(t.__e, u, t, i, o, r, f, c, s);
    (a = $de7c19ef16e9e5a3$var$l$1.diffed) && a(u);
}
function $de7c19ef16e9e5a3$var$j$1(n, u, t) {
    for(var i = 0; i < t.length; i++)$de7c19ef16e9e5a3$var$N(t[i], t[++i], t[++i]);
    $de7c19ef16e9e5a3$var$l$1.__c && $de7c19ef16e9e5a3$var$l$1.__c(u, n), n.some(function(u) {
        try {
            n = u.__h, u.__h = [], n.some(function(n) {
                n.call(u);
            });
        } catch (n) {
            $de7c19ef16e9e5a3$var$l$1.__e(n, u.__v);
        }
    });
}
function $de7c19ef16e9e5a3$var$z$1(l, u, t, i, o, r, f, e, s) {
    var a, v, y, d, _, g, b, w = t.props, k = u.props, x = u.type;
    if ("svg" === x && (o = true), null != r) {
        for(a = 0; a < r.length; a++)if ((_ = r[a]) && "setAttribute" in _ == !!x && (x ? _.localName === x : 3 === _.nodeType)) {
            l = _, r[a] = null;
            break;
        }
    }
    if (null == l) {
        if (null === x) return document.createTextNode(k);
        l = o ? document.createElementNS("http://www.w3.org/2000/svg", x) : document.createElement(x, k.is && k), r = null, e = false;
    }
    if (null === x) w === k || e && l.data === k || (l.data = k);
    else {
        if (r = r && $de7c19ef16e9e5a3$var$n.call(l.childNodes), w = t.props || $de7c19ef16e9e5a3$var$c$1, !e && null != r) for(w = {}, a = 0; a < l.attributes.length; a++)w[(_ = l.attributes[a]).name] = _.value;
        for(a in w)_ = w[a], "children" == a || ("dangerouslySetInnerHTML" == a ? y = _ : "key" === a || a in k || $de7c19ef16e9e5a3$var$A$1(l, a, null, _, o));
        for(a in k)_ = k[a], "children" == a ? d = _ : "dangerouslySetInnerHTML" == a ? v = _ : "value" == a ? g = _ : "checked" == a ? b = _ : "key" === a || e && "function" != typeof _ || w[a] === _ || $de7c19ef16e9e5a3$var$A$1(l, a, _, w[a], o);
        if (v) e || y && (v.__html === y.__html || v.__html === l.innerHTML) || (l.innerHTML = v.__html), u.__k = [];
        else if (y && (l.innerHTML = ""), $de7c19ef16e9e5a3$var$P$1(l, $de7c19ef16e9e5a3$var$h$1(d) ? d : [
            d
        ], u, t, i, o && "foreignObject" !== x, r, f, r ? r[0] : t.__k && $de7c19ef16e9e5a3$var$m$1(t, 0), e, s), null != r) for(a = r.length; a--;)null != r[a] && $de7c19ef16e9e5a3$var$p$1(r[a]);
        e || (a = "value", void 0 !== g && (g !== l[a] || "progress" === x && !g || "option" === x && g !== w[a]) && $de7c19ef16e9e5a3$var$A$1(l, a, g, w[a], false), a = "checked", void 0 !== b && b !== l[a] && $de7c19ef16e9e5a3$var$A$1(l, a, b, w[a], false));
    }
    return l;
}
function $de7c19ef16e9e5a3$var$N(n, u, t) {
    try {
        "function" == typeof n ? n(u) : n.current = u;
    } catch (n) {
        $de7c19ef16e9e5a3$var$l$1.__e(n, t);
    }
}
function $de7c19ef16e9e5a3$var$O(n, u, t) {
    var i, o;
    if ($de7c19ef16e9e5a3$var$l$1.unmount && $de7c19ef16e9e5a3$var$l$1.unmount(n), (i = n.ref) && (i.current && i.current !== n.__e || $de7c19ef16e9e5a3$var$N(i, null, u)), null != (i = n.__c)) {
        if (i.componentWillUnmount) try {
            i.componentWillUnmount();
        } catch (n) {
            $de7c19ef16e9e5a3$var$l$1.__e(n, u);
        }
        i.base = i.__P = null, n.__c = void 0;
    }
    if (i = n.__k) for(o = 0; o < i.length; o++)i[o] && $de7c19ef16e9e5a3$var$O(i[o], u, t || "function" != typeof n.type);
    t || null == n.__e || $de7c19ef16e9e5a3$var$p$1(n.__e), n.__ = n.__e = n.__d = void 0;
}
function $de7c19ef16e9e5a3$var$q$1(n, l, u) {
    return this.constructor(n, u);
}
function $de7c19ef16e9e5a3$var$B$1(u, t, i) {
    var o, r, f, e;
    $de7c19ef16e9e5a3$var$l$1.__ && $de7c19ef16e9e5a3$var$l$1.__(u, t), r = (o = false, t.__k), f = [], e = [], $de7c19ef16e9e5a3$var$M(t, u = t.__k = $de7c19ef16e9e5a3$var$y$1($de7c19ef16e9e5a3$var$g$1, null, [
        u
    ]), r || $de7c19ef16e9e5a3$var$c$1, $de7c19ef16e9e5a3$var$c$1, void 0 !== t.ownerSVGElement, r ? null : t.firstChild ? $de7c19ef16e9e5a3$var$n.call(t.childNodes) : null, f, r ? r.__e : t.firstChild, o, e), u.__d = void 0, $de7c19ef16e9e5a3$var$j$1(f, u, e);
}
$de7c19ef16e9e5a3$var$n = $de7c19ef16e9e5a3$var$s$1.slice, $de7c19ef16e9e5a3$var$l$1 = {
    __e: function(n, l, u, t) {
        for(var i, o, r; l = l.__;)if ((i = l.__c) && !i.__) try {
            if ((o = i.constructor) && null != o.getDerivedStateFromError && (i.setState(o.getDerivedStateFromError(n)), r = i.__d), null != i.componentDidCatch && (i.componentDidCatch(n, t || {}), r = i.__d), r) return i.__E = i;
        } catch (l) {
            n = l;
        }
        throw n;
    }
}, $de7c19ef16e9e5a3$var$u$1 = 0, $de7c19ef16e9e5a3$var$b$1.prototype.setState = function(n, l) {
    var u;
    u = null != this.__s && this.__s !== this.state ? this.__s : this.__s = $de7c19ef16e9e5a3$var$v$1({}, this.state), "function" == typeof n && (n = n($de7c19ef16e9e5a3$var$v$1({}, u), this.props)), n && $de7c19ef16e9e5a3$var$v$1(u, n), null != n && this.__v && (l && this._sb.push(l), $de7c19ef16e9e5a3$var$x$1(this));
}, $de7c19ef16e9e5a3$var$b$1.prototype.forceUpdate = function(n) {
    this.__v && (this.__e = true, n && this.__h.push(n), $de7c19ef16e9e5a3$var$x$1(this));
}, $de7c19ef16e9e5a3$var$b$1.prototype.render = $de7c19ef16e9e5a3$var$g$1, $de7c19ef16e9e5a3$var$i$1 = [], $de7c19ef16e9e5a3$var$r$1 = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, $de7c19ef16e9e5a3$var$f$1 = function(n, l) {
    return n.__v.__b - l.__v.__b;
}, $de7c19ef16e9e5a3$var$C$1.__r = 0;
var $de7c19ef16e9e5a3$var$t, $de7c19ef16e9e5a3$var$r, $de7c19ef16e9e5a3$var$u, $de7c19ef16e9e5a3$var$i, $de7c19ef16e9e5a3$var$o = 0, $de7c19ef16e9e5a3$var$f = [], $de7c19ef16e9e5a3$var$c = [], $de7c19ef16e9e5a3$var$e = $de7c19ef16e9e5a3$var$l$1, $de7c19ef16e9e5a3$var$a = $de7c19ef16e9e5a3$var$e.__b, $de7c19ef16e9e5a3$var$v = $de7c19ef16e9e5a3$var$e.__r, $de7c19ef16e9e5a3$var$l = $de7c19ef16e9e5a3$var$e.diffed, $de7c19ef16e9e5a3$var$m = $de7c19ef16e9e5a3$var$e.__c, $de7c19ef16e9e5a3$var$s = $de7c19ef16e9e5a3$var$e.unmount, $de7c19ef16e9e5a3$var$d = $de7c19ef16e9e5a3$var$e.__;
function $de7c19ef16e9e5a3$var$h(n, t) {
    $de7c19ef16e9e5a3$var$e.__h && $de7c19ef16e9e5a3$var$e.__h($de7c19ef16e9e5a3$var$r, n, $de7c19ef16e9e5a3$var$o || t), $de7c19ef16e9e5a3$var$o = 0;
    var u = $de7c19ef16e9e5a3$var$r.__H || ($de7c19ef16e9e5a3$var$r.__H = {
        __: [],
        __h: []
    });
    return n >= u.__.length && u.__.push({
        __V: $de7c19ef16e9e5a3$var$c
    }), u.__[n];
}
function $de7c19ef16e9e5a3$var$p(n) {
    return $de7c19ef16e9e5a3$var$o = 1, $de7c19ef16e9e5a3$var$y($de7c19ef16e9e5a3$var$D, n);
}
function $de7c19ef16e9e5a3$var$y(n, u, i) {
    var o = $de7c19ef16e9e5a3$var$h($de7c19ef16e9e5a3$var$t++, 2);
    if (o.t = n, !o.__c && (o.__ = [
        i ? i(u) : $de7c19ef16e9e5a3$var$D(void 0, u),
        function(n) {
            var t = o.__N ? o.__N[0] : o.__[0], r = o.t(t, n);
            t !== r && (o.__N = [
                r,
                o.__[1]
            ], o.__c.setState({}));
        }
    ], o.__c = $de7c19ef16e9e5a3$var$r, !$de7c19ef16e9e5a3$var$r.u)) {
        var f = function(n, t, r) {
            if (!o.__c.__H) return true;
            var u = o.__c.__H.__.filter(function(n) {
                return !!n.__c;
            });
            if (u.every(function(n) {
                return !n.__N;
            })) return !c || c.call(this, n, t, r);
            var i = false;
            return u.forEach(function(n) {
                if (n.__N) {
                    var t = n.__[0];
                    n.__ = n.__N, n.__N = void 0, t !== n.__[0] && (i = true);
                }
            }), !(!i && o.__c.props === n) && (!c || c.call(this, n, t, r));
        };
        $de7c19ef16e9e5a3$var$r.u = true;
        var c = $de7c19ef16e9e5a3$var$r.shouldComponentUpdate, e = $de7c19ef16e9e5a3$var$r.componentWillUpdate;
        $de7c19ef16e9e5a3$var$r.componentWillUpdate = function(n, t, r) {
            if (this.__e) {
                var u = c;
                c = void 0, f(n, t, r), c = u;
            }
            e && e.call(this, n, t, r);
        }, $de7c19ef16e9e5a3$var$r.shouldComponentUpdate = f;
    }
    return o.__N || o.__;
}
function $de7c19ef16e9e5a3$var$_(n, u) {
    var i = $de7c19ef16e9e5a3$var$h($de7c19ef16e9e5a3$var$t++, 3);
    !$de7c19ef16e9e5a3$var$e.__s && $de7c19ef16e9e5a3$var$C(i.__H, u) && (i.__ = n, i.i = u, $de7c19ef16e9e5a3$var$r.__H.__h.push(i));
}
function $de7c19ef16e9e5a3$var$A(n, u) {
    var i = $de7c19ef16e9e5a3$var$h($de7c19ef16e9e5a3$var$t++, 4);
    !$de7c19ef16e9e5a3$var$e.__s && $de7c19ef16e9e5a3$var$C(i.__H, u) && (i.__ = n, i.i = u, $de7c19ef16e9e5a3$var$r.__h.push(i));
}
function $de7c19ef16e9e5a3$var$F(n) {
    return $de7c19ef16e9e5a3$var$o = 5, $de7c19ef16e9e5a3$var$q(function() {
        return {
            current: n
        };
    }, []);
}
function $de7c19ef16e9e5a3$var$T(n, t, r) {
    $de7c19ef16e9e5a3$var$o = 6, $de7c19ef16e9e5a3$var$A(function() {
        return "function" == typeof n ? (n(t()), function() {
            return n(null);
        }) : n ? (n.current = t(), function() {
            return n.current = null;
        }) : void 0;
    }, null == r ? r : r.concat(n));
}
function $de7c19ef16e9e5a3$var$q(n, r) {
    var u = $de7c19ef16e9e5a3$var$h($de7c19ef16e9e5a3$var$t++, 7);
    return $de7c19ef16e9e5a3$var$C(u.__H, r) ? (u.__V = n(), u.i = r, u.__h = n, u.__V) : u.__;
}
function $de7c19ef16e9e5a3$var$x(n, t) {
    return $de7c19ef16e9e5a3$var$o = 8, $de7c19ef16e9e5a3$var$q(function() {
        return n;
    }, t);
}
function $de7c19ef16e9e5a3$var$P(n) {
    var u = $de7c19ef16e9e5a3$var$r.context[n.__c], i = $de7c19ef16e9e5a3$var$h($de7c19ef16e9e5a3$var$t++, 9);
    return i.c = n, u ? (null == i.__ && (i.__ = true, u.sub($de7c19ef16e9e5a3$var$r)), u.props.value) : n.__;
}
function $de7c19ef16e9e5a3$var$V(n, t) {
    $de7c19ef16e9e5a3$var$e.useDebugValue && $de7c19ef16e9e5a3$var$e.useDebugValue(t ? t(n) : n);
}
function $de7c19ef16e9e5a3$var$b(n) {
    var u = $de7c19ef16e9e5a3$var$h($de7c19ef16e9e5a3$var$t++, 10), i = $de7c19ef16e9e5a3$var$p();
    return u.__ = n, $de7c19ef16e9e5a3$var$r.componentDidCatch || ($de7c19ef16e9e5a3$var$r.componentDidCatch = function(n, t) {
        u.__ && u.__(n, t), i[1](n);
    }), [
        i[0],
        function() {
            i[1](void 0);
        }
    ];
}
function $de7c19ef16e9e5a3$var$g() {
    var n = $de7c19ef16e9e5a3$var$h($de7c19ef16e9e5a3$var$t++, 11);
    if (!n.__) {
        for(var u = $de7c19ef16e9e5a3$var$r.__v; null !== u && !u.__m && null !== u.__;)u = u.__;
        var i = u.__m || (u.__m = [
            0,
            0
        ]);
        n.__ = "P" + i[0] + "-" + i[1]++;
    }
    return n.__;
}
function $de7c19ef16e9e5a3$var$j() {
    for(var n; n = $de7c19ef16e9e5a3$var$f.shift();)if (n.__P && n.__H) try {
        n.__H.__h.forEach($de7c19ef16e9e5a3$var$z), n.__H.__h.forEach($de7c19ef16e9e5a3$var$B), n.__H.__h = [];
    } catch (t) {
        n.__H.__h = [], $de7c19ef16e9e5a3$var$e.__e(t, n.__v);
    }
}
$de7c19ef16e9e5a3$var$e.__b = function(n) {
    $de7c19ef16e9e5a3$var$r = null, $de7c19ef16e9e5a3$var$a && $de7c19ef16e9e5a3$var$a(n);
}, $de7c19ef16e9e5a3$var$e.__ = function(n, t) {
    t.__k && t.__k.__m && (n.__m = t.__k.__m), $de7c19ef16e9e5a3$var$d && $de7c19ef16e9e5a3$var$d(n, t);
}, $de7c19ef16e9e5a3$var$e.__r = function(n) {
    $de7c19ef16e9e5a3$var$v && $de7c19ef16e9e5a3$var$v(n), $de7c19ef16e9e5a3$var$t = 0;
    var i = ($de7c19ef16e9e5a3$var$r = n.__c).__H;
    i && ($de7c19ef16e9e5a3$var$u === $de7c19ef16e9e5a3$var$r ? (i.__h = [], $de7c19ef16e9e5a3$var$r.__h = [], i.__.forEach(function(n) {
        n.__N && (n.__ = n.__N), n.__V = $de7c19ef16e9e5a3$var$c, n.__N = n.i = void 0;
    })) : (i.__h.forEach($de7c19ef16e9e5a3$var$z), i.__h.forEach($de7c19ef16e9e5a3$var$B), i.__h = [], $de7c19ef16e9e5a3$var$t = 0)), $de7c19ef16e9e5a3$var$u = $de7c19ef16e9e5a3$var$r;
}, $de7c19ef16e9e5a3$var$e.diffed = function(n) {
    $de7c19ef16e9e5a3$var$l && $de7c19ef16e9e5a3$var$l(n);
    var t = n.__c;
    t && t.__H && (t.__H.__h.length && (1 !== $de7c19ef16e9e5a3$var$f.push(t) && $de7c19ef16e9e5a3$var$i === $de7c19ef16e9e5a3$var$e.requestAnimationFrame || (($de7c19ef16e9e5a3$var$i = $de7c19ef16e9e5a3$var$e.requestAnimationFrame) || $de7c19ef16e9e5a3$var$w)($de7c19ef16e9e5a3$var$j)), t.__H.__.forEach(function(n) {
        n.i && (n.__H = n.i), n.__V !== $de7c19ef16e9e5a3$var$c && (n.__ = n.__V), n.i = void 0, n.__V = $de7c19ef16e9e5a3$var$c;
    })), $de7c19ef16e9e5a3$var$u = $de7c19ef16e9e5a3$var$r = null;
}, $de7c19ef16e9e5a3$var$e.__c = function(n, t) {
    t.some(function(n) {
        try {
            n.__h.forEach($de7c19ef16e9e5a3$var$z), n.__h = n.__h.filter(function(n) {
                return !n.__ || $de7c19ef16e9e5a3$var$B(n);
            });
        } catch (r) {
            t.some(function(n) {
                n.__h && (n.__h = []);
            }), t = [], $de7c19ef16e9e5a3$var$e.__e(r, n.__v);
        }
    }), $de7c19ef16e9e5a3$var$m && $de7c19ef16e9e5a3$var$m(n, t);
}, $de7c19ef16e9e5a3$var$e.unmount = function(n) {
    $de7c19ef16e9e5a3$var$s && $de7c19ef16e9e5a3$var$s(n);
    var t, r = n.__c;
    r && r.__H && (r.__H.__.forEach(function(n) {
        try {
            $de7c19ef16e9e5a3$var$z(n);
        } catch (n) {
            t = n;
        }
    }), r.__H = void 0, t && $de7c19ef16e9e5a3$var$e.__e(t, r.__v));
};
var $de7c19ef16e9e5a3$var$k = "function" == typeof requestAnimationFrame;
function $de7c19ef16e9e5a3$var$w(n) {
    var t, r = function() {
        clearTimeout(u), $de7c19ef16e9e5a3$var$k && cancelAnimationFrame(t), setTimeout(n);
    }, u = setTimeout(r, 100);
    $de7c19ef16e9e5a3$var$k && (t = requestAnimationFrame(r));
}
function $de7c19ef16e9e5a3$var$z(n) {
    var t = $de7c19ef16e9e5a3$var$r, u = n.__c;
    "function" == typeof u && (n.__c = void 0, u()), $de7c19ef16e9e5a3$var$r = t;
}
function $de7c19ef16e9e5a3$var$B(n) {
    var t = $de7c19ef16e9e5a3$var$r;
    n.__c = n.__(), $de7c19ef16e9e5a3$var$r = t;
}
function $de7c19ef16e9e5a3$var$C(n, t) {
    return !n || n.length !== t.length || t.some(function(t, r) {
        return t !== n[r];
    });
}
function $de7c19ef16e9e5a3$var$D(n, t) {
    return "function" == typeof t ? t(n) : t;
}
const $de7c19ef16e9e5a3$var$hooks = /*#__PURE__*/ Object.defineProperty({
    __proto__: null,
    useCallback: $de7c19ef16e9e5a3$var$x,
    useContext: $de7c19ef16e9e5a3$var$P,
    useDebugValue: $de7c19ef16e9e5a3$var$V,
    useEffect: $de7c19ef16e9e5a3$var$_,
    useErrorBoundary: $de7c19ef16e9e5a3$var$b,
    useId: $de7c19ef16e9e5a3$var$g,
    useImperativeHandle: $de7c19ef16e9e5a3$var$T,
    useLayoutEffect: $de7c19ef16e9e5a3$var$A,
    useMemo: $de7c19ef16e9e5a3$var$q,
    useReducer: $de7c19ef16e9e5a3$var$y,
    useRef: $de7c19ef16e9e5a3$var$F,
    useState: $de7c19ef16e9e5a3$var$p
}, Symbol.toStringTag, {
    value: "Module"
});
const $de7c19ef16e9e5a3$var$XMLNS$1 = "http://www.w3.org/2000/svg";
/**
 * Sentry Logo
 */ function $de7c19ef16e9e5a3$var$SentryLogo() {
    const createElementNS = (tagName)=>$de7c19ef16e9e5a3$var$DOCUMENT.createElementNS($de7c19ef16e9e5a3$var$XMLNS$1, tagName);
    const svg = $de7c19ef16e9e5a3$var$setAttributesNS(createElementNS("svg"), {
        width: "32",
        height: "30",
        viewBox: "0 0 72 66",
        fill: "inherit"
    });
    const path = $de7c19ef16e9e5a3$var$setAttributesNS(createElementNS("path"), {
        transform: "translate(11, 11)",
        d: "M29,2.26a4.67,4.67,0,0,0-8,0L14.42,13.53A32.21,32.21,0,0,1,32.17,40.19H27.55A27.68,27.68,0,0,0,12.09,17.47L6,28a15.92,15.92,0,0,1,9.23,12.17H4.62A.76.76,0,0,1,4,39.06l2.94-5a10.74,10.74,0,0,0-3.36-1.9l-2.91,5a4.54,4.54,0,0,0,1.69,6.24A4.66,4.66,0,0,0,4.62,44H19.15a19.4,19.4,0,0,0-8-17.31l2.31-4A23.87,23.87,0,0,1,23.76,44H36.07a35.88,35.88,0,0,0-16.41-31.8l4.67-8a.77.77,0,0,1,1.05-.27c.53.29,20.29,34.77,20.66,35.17a.76.76,0,0,1-.68,1.13H40.6q.09,1.91,0,3.81h4.78A4.59,4.59,0,0,0,50,39.43a4.49,4.49,0,0,0-.62-2.28Z"
    });
    svg.appendChild(path);
    return svg;
}
function $de7c19ef16e9e5a3$var$DialogHeader({ options: options }) {
    const logoHtml = $de7c19ef16e9e5a3$var$q(()=>({
            __html: $de7c19ef16e9e5a3$var$SentryLogo().outerHTML
        }), []);
    return $de7c19ef16e9e5a3$var$y$1("h2", {
        class: "dialog__header"
    }, $de7c19ef16e9e5a3$var$y$1("span", {
        class: "dialog__title"
    }, options.formTitle), options.showBranding ? $de7c19ef16e9e5a3$var$y$1("a", {
        class: "brand-link",
        target: "_blank",
        href: "https://sentry.io/welcome/",
        title: "Powered by Sentry",
        rel: "noopener noreferrer",
        dangerouslySetInnerHTML: logoHtml
    }) : null);
}
/**
 * Validate that a given feedback submission has the required fields
 */ function $de7c19ef16e9e5a3$var$getMissingFields(feedback, props) {
    const emptyFields = [];
    if (props.isNameRequired && !feedback.name) emptyFields.push(props.nameLabel);
    if (props.isEmailRequired && !feedback.email) emptyFields.push(props.emailLabel);
    if (!feedback.message) emptyFields.push(props.messageLabel);
    return emptyFields;
}
function $de7c19ef16e9e5a3$var$retrieveStringValue(formData, key) {
    const value = formData.get(key);
    if (typeof value === "string") return value.trim();
    return "";
}
function $de7c19ef16e9e5a3$var$Form({ options: options, defaultEmail: defaultEmail, defaultName: defaultName, onFormClose: onFormClose, onSubmit: onSubmit, onSubmitSuccess: onSubmitSuccess, onSubmitError: onSubmitError, showEmail: showEmail, showName: showName, screenshotInput: screenshotInput }) {
    const { tags: tags, addScreenshotButtonLabel: addScreenshotButtonLabel, removeScreenshotButtonLabel: removeScreenshotButtonLabel, cancelButtonLabel: cancelButtonLabel, emailLabel: emailLabel, emailPlaceholder: emailPlaceholder, isEmailRequired: isEmailRequired, isNameRequired: isNameRequired, messageLabel: messageLabel, messagePlaceholder: messagePlaceholder, nameLabel: nameLabel, namePlaceholder: namePlaceholder, submitButtonLabel: submitButtonLabel, isRequiredLabel: isRequiredLabel } = options;
    const [isSubmitting, setIsSubmitting] = $de7c19ef16e9e5a3$var$p(false);
    // TODO: set a ref on the form, and whenever an input changes call processForm() and setError()
    const [error, setError] = $de7c19ef16e9e5a3$var$p(null);
    const [showScreenshotInput, setShowScreenshotInput] = $de7c19ef16e9e5a3$var$p(false);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const ScreenshotInputComponent = screenshotInput?.input;
    const [screenshotError, setScreenshotError] = $de7c19ef16e9e5a3$var$p(null);
    const onScreenshotError = $de7c19ef16e9e5a3$var$x((error)=>{
        setScreenshotError(error);
        setShowScreenshotInput(false);
    }, []);
    const hasAllRequiredFields = $de7c19ef16e9e5a3$var$x((data)=>{
        const missingFields = $de7c19ef16e9e5a3$var$getMissingFields(data, {
            emailLabel: emailLabel,
            isEmailRequired: isEmailRequired,
            isNameRequired: isNameRequired,
            messageLabel: messageLabel,
            nameLabel: nameLabel
        });
        if (missingFields.length > 0) setError(`Please enter in the following required fields: ${missingFields.join(", ")}`);
        else setError(null);
        return missingFields.length === 0;
    }, [
        emailLabel,
        isEmailRequired,
        isNameRequired,
        messageLabel,
        nameLabel
    ]);
    const handleSubmit = $de7c19ef16e9e5a3$var$x(async (e)=>{
        setIsSubmitting(true);
        try {
            e.preventDefault();
            if (!(e.target instanceof HTMLFormElement)) return;
            const formData = new FormData(e.target);
            const attachment = await (screenshotInput && showScreenshotInput ? screenshotInput.value() : undefined);
            const data = {
                name: $de7c19ef16e9e5a3$var$retrieveStringValue(formData, "name"),
                email: $de7c19ef16e9e5a3$var$retrieveStringValue(formData, "email"),
                message: $de7c19ef16e9e5a3$var$retrieveStringValue(formData, "message"),
                attachments: attachment ? [
                    attachment
                ] : undefined
            };
            if (!hasAllRequiredFields(data)) return;
            try {
                await onSubmit({
                    name: data.name,
                    email: data.email,
                    message: data.message,
                    source: $de7c19ef16e9e5a3$var$FEEDBACK_WIDGET_SOURCE,
                    tags: tags
                }, {
                    attachments: data.attachments
                });
                onSubmitSuccess(data);
            } catch (error) {
                $de7c19ef16e9e5a3$var$DEBUG_BUILD && (0, $90b8a6ace9b755b8$export$af88d00dbe7f521).error(error);
                setError(error);
                onSubmitError(error);
            }
        } finally{
            setIsSubmitting(false);
        }
    }, [
        screenshotInput && showScreenshotInput,
        onSubmitSuccess,
        onSubmitError
    ]);
    return $de7c19ef16e9e5a3$var$y$1("form", {
        class: "form",
        onSubmit: handleSubmit
    }, ScreenshotInputComponent && showScreenshotInput ? $de7c19ef16e9e5a3$var$y$1(ScreenshotInputComponent, {
        onError: onScreenshotError
    }) : null, $de7c19ef16e9e5a3$var$y$1("fieldset", {
        class: "form__right",
        "data-sentry-feedback": true,
        disabled: isSubmitting
    }, $de7c19ef16e9e5a3$var$y$1("div", {
        class: "form__top"
    }, error ? $de7c19ef16e9e5a3$var$y$1("div", {
        class: "form__error-container"
    }, error) : null, showName ? $de7c19ef16e9e5a3$var$y$1("label", {
        for: "name",
        class: "form__label"
    }, $de7c19ef16e9e5a3$var$y$1($de7c19ef16e9e5a3$var$LabelText, {
        label: nameLabel,
        isRequiredLabel: isRequiredLabel,
        isRequired: isNameRequired
    }), $de7c19ef16e9e5a3$var$y$1("input", {
        class: "form__input",
        defaultValue: defaultName,
        id: "name",
        name: "name",
        placeholder: namePlaceholder,
        required: isNameRequired,
        type: "text"
    })) : $de7c19ef16e9e5a3$var$y$1("input", {
        "aria-hidden": true,
        value: defaultName,
        name: "name",
        type: "hidden"
    }), showEmail ? $de7c19ef16e9e5a3$var$y$1("label", {
        for: "email",
        class: "form__label"
    }, $de7c19ef16e9e5a3$var$y$1($de7c19ef16e9e5a3$var$LabelText, {
        label: emailLabel,
        isRequiredLabel: isRequiredLabel,
        isRequired: isEmailRequired
    }), $de7c19ef16e9e5a3$var$y$1("input", {
        class: "form__input",
        defaultValue: defaultEmail,
        id: "email",
        name: "email",
        placeholder: emailPlaceholder,
        required: isEmailRequired,
        type: "email"
    })) : $de7c19ef16e9e5a3$var$y$1("input", {
        "aria-hidden": true,
        value: defaultEmail,
        name: "email",
        type: "hidden"
    }), $de7c19ef16e9e5a3$var$y$1("label", {
        for: "message",
        class: "form__label"
    }, $de7c19ef16e9e5a3$var$y$1($de7c19ef16e9e5a3$var$LabelText, {
        label: messageLabel,
        isRequiredLabel: isRequiredLabel,
        isRequired: true
    }), $de7c19ef16e9e5a3$var$y$1("textarea", {
        autoFocus: true,
        class: "form__input form__input--textarea",
        id: "message",
        name: "message",
        placeholder: messagePlaceholder,
        required: true,
        rows: 5
    })), ScreenshotInputComponent ? $de7c19ef16e9e5a3$var$y$1("label", {
        for: "screenshot",
        class: "form__label"
    }, $de7c19ef16e9e5a3$var$y$1("button", {
        class: "btn btn--default",
        disabled: isSubmitting,
        type: "button",
        onClick: ()=>{
            setScreenshotError(null);
            setShowScreenshotInput((prev)=>!prev);
        }
    }, showScreenshotInput ? removeScreenshotButtonLabel : addScreenshotButtonLabel), screenshotError ? $de7c19ef16e9e5a3$var$y$1("div", {
        class: "form__error-container"
    }, screenshotError.message) : null) : null), $de7c19ef16e9e5a3$var$y$1("div", {
        class: "btn-group"
    }, $de7c19ef16e9e5a3$var$y$1("button", {
        class: "btn btn--primary",
        disabled: isSubmitting,
        type: "submit"
    }, submitButtonLabel), $de7c19ef16e9e5a3$var$y$1("button", {
        class: "btn btn--default",
        disabled: isSubmitting,
        type: "button",
        onClick: onFormClose
    }, cancelButtonLabel))));
}
function $de7c19ef16e9e5a3$var$LabelText({ label: label, isRequired: isRequired, isRequiredLabel: isRequiredLabel }) {
    return $de7c19ef16e9e5a3$var$y$1("span", {
        class: "form__label__text"
    }, label, isRequired && $de7c19ef16e9e5a3$var$y$1("span", {
        class: "form__label__text--required"
    }, isRequiredLabel));
}
const $de7c19ef16e9e5a3$var$WIDTH = 16;
const $de7c19ef16e9e5a3$var$HEIGHT = 17;
const $de7c19ef16e9e5a3$var$XMLNS = "http://www.w3.org/2000/svg";
/**
 * Success Icon (checkmark)
 */ function $de7c19ef16e9e5a3$var$SuccessIcon() {
    const createElementNS = (tagName)=>$de7c19ef16e9e5a3$var$WINDOW.document.createElementNS($de7c19ef16e9e5a3$var$XMLNS, tagName);
    const svg = $de7c19ef16e9e5a3$var$setAttributesNS(createElementNS("svg"), {
        width: `${$de7c19ef16e9e5a3$var$WIDTH}`,
        height: `${$de7c19ef16e9e5a3$var$HEIGHT}`,
        viewBox: `0 0 ${$de7c19ef16e9e5a3$var$WIDTH} ${$de7c19ef16e9e5a3$var$HEIGHT}`,
        fill: "inherit"
    });
    const g = $de7c19ef16e9e5a3$var$setAttributesNS(createElementNS("g"), {
        clipPath: "url(#clip0_57_156)"
    });
    const path2 = $de7c19ef16e9e5a3$var$setAttributesNS(createElementNS("path"), {
        ["fill-rule"]: "evenodd",
        ["clip-rule"]: "evenodd",
        d: "M3.55544 15.1518C4.87103 16.0308 6.41775 16.5 8 16.5C10.1217 16.5 12.1566 15.6571 13.6569 14.1569C15.1571 12.6566 16 10.6217 16 8.5C16 6.91775 15.5308 5.37103 14.6518 4.05544C13.7727 2.73985 12.5233 1.71447 11.0615 1.10897C9.59966 0.503466 7.99113 0.34504 6.43928 0.653721C4.88743 0.962403 3.46197 1.72433 2.34315 2.84315C1.22433 3.96197 0.462403 5.38743 0.153721 6.93928C-0.15496 8.49113 0.00346625 10.0997 0.608967 11.5615C1.21447 13.0233 2.23985 14.2727 3.55544 15.1518ZM4.40546 3.1204C5.46945 2.40946 6.72036 2.03 8 2.03C9.71595 2.03 11.3616 2.71166 12.575 3.92502C13.7883 5.13838 14.47 6.78405 14.47 8.5C14.47 9.77965 14.0905 11.0306 13.3796 12.0945C12.6687 13.1585 11.6582 13.9878 10.476 14.4775C9.29373 14.9672 7.99283 15.0953 6.73777 14.8457C5.48271 14.596 4.32987 13.9798 3.42502 13.075C2.52018 12.1701 1.90397 11.0173 1.65432 9.76224C1.40468 8.50718 1.5328 7.20628 2.0225 6.02404C2.5122 4.8418 3.34148 3.83133 4.40546 3.1204Z"
    });
    const path = $de7c19ef16e9e5a3$var$setAttributesNS(createElementNS("path"), {
        d: "M6.68775 12.4297C6.78586 12.4745 6.89218 12.4984 7 12.5C7.11275 12.4955 7.22315 12.4664 7.32337 12.4145C7.4236 12.3627 7.51121 12.2894 7.58 12.2L12 5.63999C12.0848 5.47724 12.1071 5.28902 12.0625 5.11098C12.0178 4.93294 11.9095 4.77744 11.7579 4.67392C11.6064 4.57041 11.4221 4.52608 11.24 4.54931C11.0579 4.57254 10.8907 4.66173 10.77 4.79999L6.88 10.57L5.13 8.56999C5.06508 8.49566 4.98613 8.43488 4.89768 8.39111C4.80922 8.34735 4.713 8.32148 4.61453 8.31498C4.51605 8.30847 4.41727 8.32147 4.32382 8.35322C4.23038 8.38497 4.14413 8.43484 4.07 8.49999C3.92511 8.63217 3.83692 8.81523 3.82387 9.01092C3.81083 9.2066 3.87393 9.39976 4 9.54999L6.43 12.24C6.50187 12.3204 6.58964 12.385 6.68775 12.4297Z"
    });
    svg.appendChild(g).append(path, path2);
    const speakerDefs = createElementNS("defs");
    const speakerClipPathDef = $de7c19ef16e9e5a3$var$setAttributesNS(createElementNS("clipPath"), {
        id: "clip0_57_156"
    });
    const speakerRect = $de7c19ef16e9e5a3$var$setAttributesNS(createElementNS("rect"), {
        width: `${$de7c19ef16e9e5a3$var$WIDTH}`,
        height: `${$de7c19ef16e9e5a3$var$WIDTH}`,
        fill: "white",
        transform: "translate(0 0.5)"
    });
    speakerClipPathDef.appendChild(speakerRect);
    speakerDefs.appendChild(speakerClipPathDef);
    svg.appendChild(speakerDefs).appendChild(speakerClipPathDef).appendChild(speakerRect);
    return svg;
}
function $de7c19ef16e9e5a3$var$Dialog({ open: open, onFormSubmitted: onFormSubmitted, ...props }) {
    const options = props.options;
    const successIconHtml = $de7c19ef16e9e5a3$var$q(()=>({
            __html: $de7c19ef16e9e5a3$var$SuccessIcon().outerHTML
        }), []);
    const [timeoutId, setTimeoutId] = $de7c19ef16e9e5a3$var$p(null);
    const handleOnSuccessClick = $de7c19ef16e9e5a3$var$x(()=>{
        if (timeoutId) {
            clearTimeout(timeoutId);
            setTimeoutId(null);
        }
        onFormSubmitted();
    }, [
        timeoutId
    ]);
    const onSubmitSuccess = $de7c19ef16e9e5a3$var$x((data)=>{
        props.onSubmitSuccess(data);
        setTimeoutId(setTimeout(()=>{
            onFormSubmitted();
            setTimeoutId(null);
        }, $de7c19ef16e9e5a3$var$SUCCESS_MESSAGE_TIMEOUT));
    }, [
        onFormSubmitted
    ]);
    return $de7c19ef16e9e5a3$var$y$1($de7c19ef16e9e5a3$var$g$1, null, timeoutId ? $de7c19ef16e9e5a3$var$y$1("div", {
        class: "success__position",
        onClick: handleOnSuccessClick
    }, $de7c19ef16e9e5a3$var$y$1("div", {
        class: "success__content"
    }, options.successMessageText, $de7c19ef16e9e5a3$var$y$1("span", {
        class: "success__icon",
        dangerouslySetInnerHTML: successIconHtml
    }))) : $de7c19ef16e9e5a3$var$y$1("dialog", {
        class: "dialog",
        onClick: options.onFormClose,
        open: open
    }, $de7c19ef16e9e5a3$var$y$1("div", {
        class: "dialog__position"
    }, $de7c19ef16e9e5a3$var$y$1("div", {
        class: "dialog__content",
        onClick: (e)=>{
            // Stop event propagation so clicks on content modal do not propagate to dialog (which will close dialog)
            e.stopPropagation();
        }
    }, $de7c19ef16e9e5a3$var$y$1($de7c19ef16e9e5a3$var$DialogHeader, {
        options: options
    }), $de7c19ef16e9e5a3$var$y$1($de7c19ef16e9e5a3$var$Form, {
        ...props,
        onSubmitSuccess: onSubmitSuccess
    })))));
}
const $de7c19ef16e9e5a3$var$DIALOG = `
.dialog {
  position: fixed;
  z-index: var(--z-index);
  margin: 0;
  inset: 0;

  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  height: 100vh;
  width: 100vw;

  color: var(--dialog-color, var(--foreground));
  fill: var(--dialog-color, var(--foreground));
  line-height: 1.75em;

  background-color: rgba(0, 0, 0, 0.05);
  border: none;
  inset: 0;
  opacity: 1;
  transition: opacity 0.2s ease-in-out;
}

.dialog__position {
  position: fixed;
  z-index: var(--z-index);
  inset: var(--dialog-inset);
  padding: var(--page-margin);
  display: flex;
  max-height: calc(100vh - (2 * var(--page-margin)));
}
@media (max-width: 600px) {
  .dialog__position {
    inset: var(--page-margin);
    padding: 0;
  }
}

.dialog__position:has(.editor) {
  inset: var(--page-margin);
  padding: 0;
}

.dialog:not([open]) {
  opacity: 0;
  pointer-events: none;
  visibility: hidden;
}
.dialog:not([open]) .dialog__content {
  transform: translate(0, -16px) scale(0.98);
}

.dialog__content {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: var(--dialog-padding, 24px);
  max-width: 100%;
  width: 100%;
  max-height: 100%;
  overflow: auto;

  background: var(--dialog-background, var(--background));
  border-radius: var(--dialog-border-radius, 20px);
  border: var(--dialog-border, var(--border));
  box-shadow: var(--dialog-box-shadow, var(--box-shadow));
  transform: translate(0, 0) scale(1);
  transition: transform 0.2s ease-in-out;
}

`;
const $de7c19ef16e9e5a3$var$DIALOG_HEADER = `
.dialog__header {
  display: flex;
  gap: 4px;
  justify-content: space-between;
  font-weight: var(--dialog-header-weight, 600);
  margin: 0;
}
.dialog__title {
  align-self: center;
  width: var(--form-width, 272px);
}

@media (max-width: 600px) {
  .dialog__title {
    width: auto;
  }
}

.dialog__position:has(.editor) .dialog__title {
  width: auto;
}


.brand-link {
  display: inline-flex;
}
.brand-link:focus-visible {
  outline: var(--outline);
}
`;
const $de7c19ef16e9e5a3$var$FORM = `
.form {
  display: flex;
  overflow: auto;
  flex-direction: row;
  gap: 16px;
  flex: 1 0;
}

.form fieldset {
  border: none;
  margin: 0;
  padding: 0;
}

.form__right {
  flex: 0 0 auto;
  display: flex;
  overflow: auto;
  flex-direction: column;
  justify-content: space-between;
  gap: 20px;
  width: var(--form-width, 100%);
}

.dialog__position:has(.editor) .form__right {
  width: var(--form-width, 272px);
}

.form__top {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form__error-container {
  color: var(--error-color);
  fill: var(--error-color);
}

.form__label {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin: 0px;
}

.form__label__text {
  display: flex;
  gap: 4px;
  align-items: center;
}

.form__label__text--required {
  font-size: 0.85em;
}

.form__input {
  font-family: inherit;
  line-height: inherit;
  background: transparent;
  box-sizing: border-box;
  border: var(--input-border, var(--border));
  border-radius: var(--input-border-radius, 6px);
  color: var(--input-color, inherit);
  fill: var(--input-color, inherit);
  font-size: var(--input-font-size, inherit);
  font-weight: var(--input-font-weight, 500);
  padding: 6px 12px;
}

.form__input::placeholder {
  opacity: 0.65;
  color: var(--input-placeholder-color, inherit);
  filter: var(--interactive-filter);
}

.form__input:focus-visible {
  outline: var(--input-focus-outline, var(--outline));
}

.form__input--textarea {
  font-family: inherit;
  resize: vertical;
}

.error {
  color: var(--error-color);
  fill: var(--error-color);
}
`;
const $de7c19ef16e9e5a3$var$BUTTON = `
.btn-group {
  display: grid;
  gap: 8px;
}

.btn {
  line-height: inherit;
  border: var(--button-border, var(--border));
  border-radius: var(--button-border-radius, 6px);
  cursor: pointer;
  font-family: inherit;
  font-size: var(--button-font-size, inherit);
  font-weight: var(--button-font-weight, 600);
  padding: var(--button-padding, 6px 16px);
}
.btn[disabled] {
  opacity: 0.6;
  pointer-events: none;
}

.btn--primary {
  color: var(--button-primary-color, var(--accent-foreground));
  fill: var(--button-primary-color, var(--accent-foreground));
  background: var(--button-primary-background, var(--accent-background));
  border: var(--button-primary-border, var(--border));
  border-radius: var(--button-primary-border-radius, 6px);
  font-weight: var(--button-primary-font-weight, 500);
}
.btn--primary:hover {
  color: var(--button-primary-hover-color, var(--accent-foreground));
  fill: var(--button-primary-hover-color, var(--accent-foreground));
  background: var(--button-primary-hover-background, var(--accent-background));
  filter: var(--interactive-filter);
}
.btn--primary:focus-visible {
  background: var(--button-primary-hover-background, var(--accent-background));
  filter: var(--interactive-filter);
  outline: var(--button-primary-focus-outline, var(--outline));
}

.btn--default {
  color: var(--button-color, var(--foreground));
  fill: var(--button-color, var(--foreground));
  background: var(--button-background, var(--background));
  border: var(--button-border, var(--border));
  border-radius: var(--button-border-radius, 6px);
  font-weight: var(--button-font-weight, 500);
}
.btn--default:hover {
  color: var(--button-color, var(--foreground));
  fill: var(--button-color, var(--foreground));
  background: var(--button-hover-background, var(--background));
  filter: var(--interactive-filter);
}
.btn--default:focus-visible {
  background: var(--button-hover-background, var(--background));
  filter: var(--interactive-filter);
  outline: var(--button-focus-outline, var(--outline));
}
`;
const $de7c19ef16e9e5a3$var$SUCCESS = `
.success__position {
  position: fixed;
  inset: var(--dialog-inset);
  padding: var(--page-margin);
  z-index: var(--z-index);
}
.success__content {
  background: var(--success-background, var(--background));
  border: var(--success-border, var(--border));
  border-radius: var(--success-border-radius, 1.7em/50%);
  box-shadow: var(--success-box-shadow, var(--box-shadow));
  font-weight: var(--success-font-weight, 600);
  color: var(--success-color);
  fill: var(--success-color);
  padding: 12px 24px;
  line-height: 1.75em;

  display: grid;
  align-items: center;
  grid-auto-flow: column;
  gap: 6px;
  cursor: default;
}

.success__icon {
  display: flex;
}
`;
/**
 * Creates <style> element for widget dialog
 */ function $de7c19ef16e9e5a3$var$createDialogStyles(styleNonce) {
    const style = $de7c19ef16e9e5a3$var$DOCUMENT.createElement("style");
    style.textContent = `
:host {
  --dialog-inset: var(--inset);
}

${$de7c19ef16e9e5a3$var$DIALOG}
${$de7c19ef16e9e5a3$var$DIALOG_HEADER}
${$de7c19ef16e9e5a3$var$FORM}
${$de7c19ef16e9e5a3$var$BUTTON}
${$de7c19ef16e9e5a3$var$SUCCESS}
`;
    if (styleNonce) style.setAttribute("nonce", styleNonce);
    return style;
}
function $de7c19ef16e9e5a3$var$getUser() {
    const currentUser = (0, $5d0bc397896c048e$export$c7be4b0125a10cba)().getUser();
    const isolationUser = (0, $5d0bc397896c048e$export$68f3af03034c9e90)().getUser();
    const globalUser = (0, $5d0bc397896c048e$export$aa55d5ab8e05984f)().getUser();
    if (currentUser && Object.keys(currentUser).length) return currentUser;
    if (isolationUser && Object.keys(isolationUser).length) return isolationUser;
    return globalUser;
}
const $de7c19ef16e9e5a3$export$2ed486683e133d58 = ()=>{
    return {
        name: "FeedbackModal",
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        setupOnce () {},
        createDialog: ({ options: options, screenshotIntegration: screenshotIntegration, sendFeedback: sendFeedback, shadow: shadow })=>{
            const shadowRoot = shadow;
            const userKey = options.useSentryUser;
            const user = $de7c19ef16e9e5a3$var$getUser();
            const el = $de7c19ef16e9e5a3$var$DOCUMENT.createElement("div");
            const style = $de7c19ef16e9e5a3$var$createDialogStyles(options.styleNonce);
            let originalOverflow = "";
            const dialog = {
                get el () {
                    return el;
                },
                appendToDom () {
                    if (!shadowRoot.contains(style) && !shadowRoot.contains(el)) {
                        shadowRoot.appendChild(style);
                        shadowRoot.appendChild(el);
                    }
                },
                removeFromDom () {
                    el.remove();
                    style.remove();
                    $de7c19ef16e9e5a3$var$DOCUMENT.body.style.overflow = originalOverflow;
                },
                open () {
                    renderContent(true);
                    options.onFormOpen?.();
                    (0, $5d0bc397896c048e$export$6bb76d6eba7e258c)()?.emit("openFeedbackWidget");
                    originalOverflow = $de7c19ef16e9e5a3$var$DOCUMENT.body.style.overflow;
                    $de7c19ef16e9e5a3$var$DOCUMENT.body.style.overflow = "hidden";
                },
                close () {
                    renderContent(false);
                    $de7c19ef16e9e5a3$var$DOCUMENT.body.style.overflow = originalOverflow;
                }
            };
            const screenshotInput = screenshotIntegration?.createInput({
                h: $de7c19ef16e9e5a3$var$y$1,
                hooks: $de7c19ef16e9e5a3$var$hooks,
                dialog: dialog,
                options: options
            });
            const renderContent = (open)=>{
                $de7c19ef16e9e5a3$var$B$1($de7c19ef16e9e5a3$var$y$1($de7c19ef16e9e5a3$var$Dialog, {
                    options: options,
                    screenshotInput: screenshotInput,
                    showName: options.showName || options.isNameRequired,
                    showEmail: options.showEmail || options.isEmailRequired,
                    defaultName: userKey && user && user[userKey.name] || "",
                    defaultEmail: userKey && user && user[userKey.email] || "",
                    onFormClose: ()=>{
                        renderContent(false);
                        options.onFormClose?.();
                    },
                    onSubmit: sendFeedback,
                    onSubmitSuccess: (data)=>{
                        renderContent(false);
                        options.onSubmitSuccess?.(data);
                    },
                    onSubmitError: (error)=>{
                        options.onSubmitError?.(error);
                    },
                    onFormSubmitted: ()=>{
                        options.onFormSubmitted?.();
                    },
                    open: open
                }), el);
            };
            return dialog;
        }
    };
};
function $de7c19ef16e9e5a3$var$IconCloseFactory({ h: h }) {
    return function IconClose() {
        return h("svg", {
            "data-test-id": "icon-close",
            viewBox: "0 0 16 16",
            fill: "#2B2233",
            height: "25px",
            width: "25px"
        }, h("circle", {
            r: "7",
            cx: "8",
            cy: "8",
            fill: "white"
        }), h("path", {
            strokeWidth: "1.5",
            d: "M8,16a8,8,0,1,1,8-8A8,8,0,0,1,8,16ZM8,1.53A6.47,6.47,0,1,0,14.47,8,6.47,6.47,0,0,0,8,1.53Z"
        }), h("path", {
            strokeWidth: "1.5",
            d: "M5.34,11.41a.71.71,0,0,1-.53-.22.74.74,0,0,1,0-1.06l5.32-5.32a.75.75,0,0,1,1.06,1.06L5.87,11.19A.74.74,0,0,1,5.34,11.41Z"
        }), h("path", {
            strokeWidth: "1.5",
            d: "M10.66,11.41a.74.74,0,0,1-.53-.22L4.81,5.87A.75.75,0,0,1,5.87,4.81l5.32,5.32a.74.74,0,0,1,0,1.06A.71.71,0,0,1,10.66,11.41Z"
        }));
    };
}
/**
 * Creates <style> element for widget dialog
 */ function $de7c19ef16e9e5a3$var$createScreenshotInputStyles(styleNonce) {
    const style = $de7c19ef16e9e5a3$var$DOCUMENT.createElement("style");
    const surface200 = "#1A141F";
    const gray100 = "#302735";
    style.textContent = `
.editor {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
}

.editor__image-container {
  justify-items: center;
  padding: 15px;
  position: relative;
  height: 100%;
  border-radius: var(--menu-border-radius, 6px);

  background-color: ${surface200};
  background-image: repeating-linear-gradient(
      -145deg,
      transparent,
      transparent 8px,
      ${surface200} 8px,
      ${surface200} 11px
    ),
    repeating-linear-gradient(
      -45deg,
      transparent,
      transparent 15px,
      ${gray100} 15px,
      ${gray100} 16px
    );
}

.editor__canvas-container {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.editor__canvas-container > * {
  object-fit: contain;
  position: absolute;
}

.editor__tool-container {
  padding-top: 8px;
  display: flex;
  justify-content: center;
}

.editor__tool-bar {
  display: flex;
  gap: 8px;
}

.editor__tool {
  display: flex;
  padding: 8px 12px;
  justify-content: center;
  align-items: center;
  border: var(--button-border, var(--border));
  border-radius: var(--button-border-radius, 6px);
  background: var(--button-background, var(--background));
  color: var(--button-color, var(--foreground));
}

.editor__tool--active {
  background: var(--button-primary-background, var(--accent-background));
  color: var(--button-primary-color, var(--accent-foreground));
}

.editor__rect {
  position: absolute;
  z-index: 2;
}

.editor__rect button {
  opacity: 0;
  position: absolute;
  top: -12px;
  right: -12px;
  cursor: pointer;
  padding: 0;
  z-index: 3;
  border: none;
  background: none;
}

.editor__rect:hover button {
  opacity: 1;
}
`;
    if (styleNonce) style.setAttribute("nonce", styleNonce);
    return style;
}
function $de7c19ef16e9e5a3$var$ToolbarFactory({ h: h }) {
    return function Toolbar({ action: action, setAction: setAction }) {
        return h("div", {
            class: "editor__tool-container"
        }, h("div", {
            class: "editor__tool-bar"
        }, h("button", {
            type: "button",
            class: `editor__tool ${action === "highlight" ? "editor__tool--active" : ""}`,
            onClick: ()=>{
                setAction(action === "highlight" ? "" : "highlight");
            }
        }, "Highlight"), h("button", {
            type: "button",
            class: `editor__tool ${action === "hide" ? "editor__tool--active" : ""}`,
            onClick: ()=>{
                setAction(action === "hide" ? "" : "hide");
            }
        }, "Hide")));
    };
}
function $de7c19ef16e9e5a3$var$useTakeScreenshotFactory({ hooks: hooks }) {
    function useDpi() {
        const [dpi, setDpi] = hooks.useState($de7c19ef16e9e5a3$var$WINDOW.devicePixelRatio ?? 1);
        hooks.useEffect(()=>{
            const onChange = ()=>{
                setDpi($de7c19ef16e9e5a3$var$WINDOW.devicePixelRatio);
            };
            const media = matchMedia(`(resolution: ${$de7c19ef16e9e5a3$var$WINDOW.devicePixelRatio}dppx)`);
            media.addEventListener("change", onChange);
            return ()=>{
                media.removeEventListener("change", onChange);
            };
        }, []);
        return dpi;
    }
    return function useTakeScreenshot({ onBeforeScreenshot: onBeforeScreenshot, onScreenshot: onScreenshot, onAfterScreenshot: onAfterScreenshot, onError: onError }) {
        const dpi = useDpi();
        hooks.useEffect(()=>{
            const takeScreenshot = async ()=>{
                onBeforeScreenshot();
                // Chrome will animate a top-bar which can shrink the window height by a
                // few pixels. The exact amount depends on how fast it takes to exec
                // the onloadedmetadata callback.
                // https://stackoverflow.com/q/75833049
                const stream = await $de7c19ef16e9e5a3$var$NAVIGATOR.mediaDevices.getDisplayMedia({
                    video: {
                        width: $de7c19ef16e9e5a3$var$WINDOW.innerWidth * dpi,
                        height: $de7c19ef16e9e5a3$var$WINDOW.innerHeight * dpi
                    },
                    audio: false,
                    // @ts-expect-error experimental flags: https://developer.mozilla.org/en-US/docs/Web/API/MediaDevices/getDisplayMedia#prefercurrenttab
                    monitorTypeSurfaces: "exclude",
                    preferCurrentTab: true,
                    selfBrowserSurface: "include",
                    surfaceSwitching: "exclude"
                });
                const video = $de7c19ef16e9e5a3$var$DOCUMENT.createElement("video");
                await new Promise((resolve, reject)=>{
                    video.srcObject = stream;
                    video.onloadedmetadata = ()=>{
                        onScreenshot(video, dpi);
                        stream.getTracks().forEach((track)=>track.stop());
                        resolve();
                    };
                    video.play().catch(reject);
                });
                onAfterScreenshot();
            };
            takeScreenshot().catch(onError);
        }, []);
    };
}
function $de7c19ef16e9e5a3$var$drawRect(command, ctx, color) {
    switch(command.type){
        case "highlight":
            // creates a shadow around
            ctx.shadowColor = "rgba(0, 0, 0, 0.7)";
            ctx.shadowBlur = 50;
            // draws a rectangle first with a shadow
            ctx.fillStyle = color;
            ctx.fillRect(command.x - 1, command.y - 1, command.w + 2, command.h + 2);
            // cut out the inside of the rectangle
            ctx.clearRect(command.x, command.y, command.w, command.h);
            break;
        case "hide":
            ctx.fillStyle = "rgb(0, 0, 0)";
            ctx.fillRect(command.x, command.y, command.w, command.h);
            break;
    }
}
function $de7c19ef16e9e5a3$var$with2dContext(canvas, options, callback) {
    if (!canvas) return;
    const ctx = canvas.getContext("2d", options);
    if (!ctx) return;
    callback(canvas, ctx);
}
function $de7c19ef16e9e5a3$var$paintImage(maybeDest, source) {
    $de7c19ef16e9e5a3$var$with2dContext(maybeDest, {
        alpha: true
    }, (destCanvas, destCtx)=>{
        destCtx.drawImage(source, 0, 0, source.width, source.height, 0, 0, destCanvas.width, destCanvas.height);
    });
}
// Paint the array of drawCommands into a canvas.
// Assuming this is the canvas foreground, and the background is cleaned.
function $de7c19ef16e9e5a3$var$paintForeground(maybeCanvas, strokeColor, drawCommands) {
    $de7c19ef16e9e5a3$var$with2dContext(maybeCanvas, {
        alpha: true
    }, (canvas, ctx)=>{
        // If there's anything to draw, then we'll first clear the canvas with
        // a transparent grey background
        if (drawCommands.length) {
            ctx.fillStyle = "rgba(0, 0, 0, 0.25)";
            ctx.fillRect(0, 0, canvas.width, canvas.height);
        }
        drawCommands.forEach((command)=>{
            $de7c19ef16e9e5a3$var$drawRect(command, ctx, strokeColor);
        });
    });
}
function $de7c19ef16e9e5a3$var$ScreenshotEditorFactory({ h: h, hooks: hooks, outputBuffer: outputBuffer, dialog: dialog, options: options }) {
    const useTakeScreenshot = $de7c19ef16e9e5a3$var$useTakeScreenshotFactory({
        hooks: hooks
    });
    const Toolbar = $de7c19ef16e9e5a3$var$ToolbarFactory({
        h: h
    });
    const IconClose = $de7c19ef16e9e5a3$var$IconCloseFactory({
        h: h
    });
    const editorStyleInnerText = {
        __html: $de7c19ef16e9e5a3$var$createScreenshotInputStyles(options.styleNonce).innerText
    };
    const dialogStyle = dialog.el.style;
    const ScreenshotEditor = ({ screenshot: screenshot })=>{
        // Data for rendering:
        const [action, setAction] = hooks.useState("highlight");
        const [drawCommands, setDrawCommands] = hooks.useState([]);
        // Refs to our html components:
        const measurementRef = hooks.useRef(null);
        const backgroundRef = hooks.useRef(null);
        const foregroundRef = hooks.useRef(null);
        const mouseRef = hooks.useRef(null);
        // The size of our window, relative to the imageSource
        const [scaleFactor, setScaleFactor] = hooks.useState(1);
        const strokeColor = hooks.useMemo(()=>{
            const sentryFeedback = $de7c19ef16e9e5a3$var$DOCUMENT.getElementById(options.id);
            if (!sentryFeedback) return "white";
            const computedStyle = getComputedStyle(sentryFeedback);
            return computedStyle.getPropertyValue("--button-primary-background") || computedStyle.getPropertyValue("--accent-background");
        }, [
            options.id
        ]);
        // The initial resize, to measure the area and set the children to the correct size
        hooks.useLayoutEffect(()=>{
            const handleResize = ()=>{
                const measurementDiv = measurementRef.current;
                if (!measurementDiv) return;
                $de7c19ef16e9e5a3$var$with2dContext(screenshot.canvas, {
                    alpha: false
                }, (canvas)=>{
                    const scale = Math.min(measurementDiv.clientWidth / canvas.width, measurementDiv.clientHeight / canvas.height);
                    setScaleFactor(scale);
                });
                // For Firefox, the canvas is not yet measured, so we need to wait for it to get the correct size
                if (measurementDiv.clientHeight === 0 || measurementDiv.clientWidth === 0) setTimeout(handleResize, 0);
            };
            handleResize();
            $de7c19ef16e9e5a3$var$WINDOW.addEventListener("resize", handleResize);
            return ()=>{
                $de7c19ef16e9e5a3$var$WINDOW.removeEventListener("resize", handleResize);
            };
        }, [
            screenshot
        ]);
        // Set the size of the canvas element to match our screenshot
        const setCanvasSize = hooks.useCallback((maybeCanvas, scale)=>{
            $de7c19ef16e9e5a3$var$with2dContext(maybeCanvas, {
                alpha: true
            }, (canvas, ctx)=>{
                // Must call `scale()` before setting `width` & `height`
                ctx.scale(scale, scale);
                canvas.width = screenshot.canvas.width;
                canvas.height = screenshot.canvas.height;
            });
        }, [
            screenshot
        ]);
        // Draw the screenshot into the background
        hooks.useEffect(()=>{
            setCanvasSize(backgroundRef.current, screenshot.dpi);
            $de7c19ef16e9e5a3$var$paintImage(backgroundRef.current, screenshot.canvas);
        }, [
            screenshot
        ]);
        // Draw the commands into the foreground
        hooks.useEffect(()=>{
            setCanvasSize(foregroundRef.current, screenshot.dpi);
            $de7c19ef16e9e5a3$var$with2dContext(foregroundRef.current, {
                alpha: true
            }, (canvas, ctx)=>{
                ctx.clearRect(0, 0, canvas.width, canvas.height);
            });
            $de7c19ef16e9e5a3$var$paintForeground(foregroundRef.current, strokeColor, drawCommands);
        }, [
            drawCommands,
            strokeColor
        ]);
        // Draw into the output outputBuffer
        hooks.useEffect(()=>{
            setCanvasSize(outputBuffer, screenshot.dpi);
            $de7c19ef16e9e5a3$var$paintImage(outputBuffer, screenshot.canvas);
            $de7c19ef16e9e5a3$var$with2dContext($de7c19ef16e9e5a3$var$DOCUMENT.createElement("canvas"), {
                alpha: true
            }, (foreground, ctx)=>{
                ctx.scale(screenshot.dpi, screenshot.dpi); // The scale needs to be set before we set the width/height and paint
                foreground.width = screenshot.canvas.width;
                foreground.height = screenshot.canvas.height;
                $de7c19ef16e9e5a3$var$paintForeground(foreground, strokeColor, drawCommands);
                $de7c19ef16e9e5a3$var$paintImage(outputBuffer, foreground);
            });
        }, [
            drawCommands,
            screenshot,
            strokeColor
        ]);
        const handleMouseDown = (e)=>{
            if (!action || !mouseRef.current) return;
            const boundingRect = mouseRef.current.getBoundingClientRect();
            const startingPoint = {
                type: action,
                x: e.offsetX / scaleFactor,
                y: e.offsetY / scaleFactor
            };
            const getDrawCommand = (startingPoint, e)=>{
                const x = (e.clientX - boundingRect.x) / scaleFactor;
                const y = (e.clientY - boundingRect.y) / scaleFactor;
                return {
                    type: startingPoint.type,
                    x: Math.min(startingPoint.x, x),
                    y: Math.min(startingPoint.y, y),
                    w: Math.abs(x - startingPoint.x),
                    h: Math.abs(y - startingPoint.y)
                };
            };
            const handleMouseMove = (e)=>{
                $de7c19ef16e9e5a3$var$with2dContext(foregroundRef.current, {
                    alpha: true
                }, (canvas, ctx)=>{
                    ctx.clearRect(0, 0, canvas.width, canvas.height);
                });
                $de7c19ef16e9e5a3$var$paintForeground(foregroundRef.current, strokeColor, [
                    ...drawCommands,
                    getDrawCommand(startingPoint, e)
                ]);
            };
            const handleMouseUp = (e)=>{
                const drawCommand = getDrawCommand(startingPoint, e);
                // Prevent just clicking onto the canvas, mouse has to move at least 1 pixel
                if (drawCommand.w * scaleFactor >= 1 && drawCommand.h * scaleFactor >= 1) setDrawCommands((prev)=>[
                        ...prev,
                        drawCommand
                    ]);
                $de7c19ef16e9e5a3$var$DOCUMENT.removeEventListener("mousemove", handleMouseMove);
                $de7c19ef16e9e5a3$var$DOCUMENT.removeEventListener("mouseup", handleMouseUp);
            };
            $de7c19ef16e9e5a3$var$DOCUMENT.addEventListener("mousemove", handleMouseMove);
            $de7c19ef16e9e5a3$var$DOCUMENT.addEventListener("mouseup", handleMouseUp);
        };
        const deleteRect = hooks.useCallback((index)=>{
            return (e)=>{
                e.preventDefault();
                e.stopPropagation();
                setDrawCommands((prev)=>{
                    const updatedRects = [
                        ...prev
                    ];
                    updatedRects.splice(index, 1);
                    return updatedRects;
                });
            };
        }, []);
        const dimensions = {
            width: `${screenshot.canvas.width * scaleFactor}px`,
            height: `${screenshot.canvas.height * scaleFactor}px`
        };
        const handleStopPropagation = (e)=>{
            e.stopPropagation();
        };
        return h("div", {
            class: "editor"
        }, h("style", {
            nonce: options.styleNonce,
            dangerouslySetInnerHTML: editorStyleInnerText
        }), h("div", {
            class: "editor__image-container"
        }, h("div", {
            class: "editor__canvas-container",
            ref: measurementRef
        }, h("canvas", {
            ref: backgroundRef,
            id: "background",
            style: dimensions
        }), h("canvas", {
            ref: foregroundRef,
            id: "foreground",
            style: dimensions
        }), h("div", {
            ref: mouseRef,
            onMouseDown: handleMouseDown,
            style: dimensions
        }, drawCommands.map((rect, index)=>h("div", {
                key: index,
                class: "editor__rect",
                style: {
                    top: `${rect.y * scaleFactor}px`,
                    left: `${rect.x * scaleFactor}px`,
                    width: `${rect.w * scaleFactor}px`,
                    height: `${rect.h * scaleFactor}px`
                }
            }, h("button", {
                "aria-label": "Remove",
                onClick: deleteRect(index),
                onMouseDown: handleStopPropagation,
                onMouseUp: handleStopPropagation,
                type: "button"
            }, h(IconClose, null))))))), h(Toolbar, {
            action: action,
            setAction: setAction
        }));
    };
    return function Wrapper({ onError: onError }) {
        const [screenshot, setScreenshot] = hooks.useState();
        useTakeScreenshot({
            onBeforeScreenshot: hooks.useCallback(()=>{
                dialogStyle.display = "none";
            }, []),
            onScreenshot: hooks.useCallback((screenshotVideo, dpi)=>{
                // Stash the original screenshot image so we can (re)draw it multiple times
                $de7c19ef16e9e5a3$var$with2dContext($de7c19ef16e9e5a3$var$DOCUMENT.createElement("canvas"), {
                    alpha: false
                }, (canvas, ctx)=>{
                    ctx.scale(dpi, dpi); // The scale needs to be set before we set the width/height and paint
                    canvas.width = screenshotVideo.videoWidth;
                    canvas.height = screenshotVideo.videoHeight;
                    ctx.drawImage(screenshotVideo, 0, 0, canvas.width, canvas.height);
                    setScreenshot({
                        canvas: canvas,
                        dpi: dpi
                    });
                });
                // The output buffer, we only need to set the width/height on this once, it stays the same forever
                outputBuffer.width = screenshotVideo.videoWidth;
                outputBuffer.height = screenshotVideo.videoHeight;
            }, []),
            onAfterScreenshot: hooks.useCallback(()=>{
                dialogStyle.display = "block";
            }, []),
            onError: hooks.useCallback((error)=>{
                dialogStyle.display = "block";
                onError(error);
            }, [])
        });
        if (screenshot) return h(ScreenshotEditor, {
            screenshot: screenshot
        });
        return h("div", null);
    };
}
const $de7c19ef16e9e5a3$export$fd00458861e48ab4 = ()=>{
    return {
        name: "FeedbackScreenshot",
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        setupOnce () {},
        createInput: ({ h: h, hooks: hooks, dialog: dialog, options: options })=>{
            const outputBuffer = $de7c19ef16e9e5a3$var$DOCUMENT.createElement("canvas");
            return {
                input: $de7c19ef16e9e5a3$var$ScreenshotEditorFactory({
                    h: h,
                    hooks: hooks,
                    outputBuffer: outputBuffer,
                    dialog: dialog,
                    options: options
                }),
                value: async ()=>{
                    const blob = await new Promise((resolve)=>{
                        outputBuffer.toBlob(resolve, "image/png");
                    });
                    if (blob) {
                        const data = new Uint8Array(await blob.arrayBuffer());
                        const attachment = {
                            data: data,
                            filename: "screenshot.png",
                            contentType: "application/png"
                        };
                        return attachment;
                    }
                    return undefined;
                }
            };
        }
    };
};


// This is a magic string replaced by rollup
const $c62c944ea7134a72$export$31499a9cd224b78c = "9.33.0";


/** Internal global with common properties and Sentry extensions  */ /** Get's the global object for the current JavaScript runtime */ const $88208d9e04627397$export$f1a6cdb1459e81d1 = globalThis;


/**
 * An object that contains globally accessible properties and maintains a scope stack.
 * @hidden
 */ /**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $abd13f64e43ff217$export$19eade501500c6c1() {
    // This ensures a Sentry carrier exists
    $abd13f64e43ff217$export$c8bfa33e4e8ae492((0, $88208d9e04627397$export$f1a6cdb1459e81d1));
    return 0, $88208d9e04627397$export$f1a6cdb1459e81d1;
}
/** Will either get the existing sentry carrier, or create a new one. */ function $abd13f64e43ff217$export$c8bfa33e4e8ae492(carrier) {
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    // For now: First SDK that sets the .version property wins
    __SENTRY__.version = __SENTRY__.version || (0, $c62c944ea7134a72$export$31499a9cd224b78c);
    // Intentionally populating and returning the version of "this" SDK instance
    // rather than what's set in .version so that "this" SDK always gets its carrier
    return __SENTRY__[0, $c62c944ea7134a72$export$31499a9cd224b78c] = __SENTRY__[0, $c62c944ea7134a72$export$31499a9cd224b78c] || {};
}
/**
 * Returns a global singleton contained in the global `__SENTRY__[]` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $abd13f64e43ff217$export$7e223ec222791509(name, creator, obj = (0, $88208d9e04627397$export$f1a6cdb1459e81d1)) {
    const __SENTRY__ = obj.__SENTRY__ = obj.__SENTRY__ || {};
    const carrier = __SENTRY__[0, $c62c944ea7134a72$export$31499a9cd224b78c] = __SENTRY__[0, $c62c944ea7134a72$export$31499a9cd224b78c] || {};
    // Note: We do not want to set `carrier.version` here, as this may be called before any `init` is called, e.g. for the default scopes
    return carrier[name] || (carrier[name] = creator());
}



/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $b5c0571e433473d8$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;


// eslint-disable-next-line @typescript-eslint/unbound-method
const $ed5cb73b8752546d$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $ed5cb73b8752546d$export$e6127cc7fe7395c3(wat) {
    switch($ed5cb73b8752546d$var$objectToString.call(wat)){
        case "[object Error]":
        case "[object Exception]":
        case "[object DOMException]":
        case "[object WebAssembly.Exception]":
            return true;
        default:
            return $ed5cb73b8752546d$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $ed5cb73b8752546d$var$isBuiltin(wat, className) {
    return $ed5cb73b8752546d$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $ed5cb73b8752546d$export$9f9636d330b71954(wat) {
    return $ed5cb73b8752546d$var$isBuiltin(wat, "ErrorEvent");
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $ed5cb73b8752546d$export$ef9e2056653f0c8e(wat) {
    return $ed5cb73b8752546d$var$isBuiltin(wat, "DOMError");
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $ed5cb73b8752546d$export$12e869b2a583f783(wat) {
    return $ed5cb73b8752546d$var$isBuiltin(wat, "DOMException");
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $ed5cb73b8752546d$export$844ec244b1367d54(wat) {
    return $ed5cb73b8752546d$var$isBuiltin(wat, "String");
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $ed5cb73b8752546d$export$dbcbffa59149b824(wat) {
    return typeof wat === "object" && wat !== null && "__sentry_template_string__" in wat && "__sentry_template_values__" in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $ed5cb73b8752546d$export$c3825b437cbdea5c(wat) {
    return wat === null || $ed5cb73b8752546d$export$dbcbffa59149b824(wat) || typeof wat !== "object" && typeof wat !== "function";
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $ed5cb73b8752546d$export$53b83ca8eaab0383(wat) {
    return $ed5cb73b8752546d$var$isBuiltin(wat, "Object");
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $ed5cb73b8752546d$export$9671ea99bd126ace(wat) {
    return typeof Event !== "undefined" && $ed5cb73b8752546d$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $ed5cb73b8752546d$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== "undefined" && $ed5cb73b8752546d$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $ed5cb73b8752546d$export$49841c62b9eff15(wat) {
    return $ed5cb73b8752546d$var$isBuiltin(wat, "RegExp");
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $ed5cb73b8752546d$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat?.then && typeof wat.then === "function");
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $ed5cb73b8752546d$export$bc2894c7158efbac(wat) {
    return $ed5cb73b8752546d$export$53b83ca8eaab0383(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $ed5cb73b8752546d$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $ed5cb73b8752546d$export$7916fad0ebc23f48(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    return !!(typeof wat === "object" && wat !== null && (wat.__isVue || wat._isVue));
}
/**
 * Checks whether the given parameter is a Standard Web API Request instance.
 *
 * Returns false if Request is not available in the current runtime.
 */ function $ed5cb73b8752546d$export$6d3d1f317d7cda57(request) {
    return typeof Request !== "undefined" && $ed5cb73b8752546d$export$49034edbe6b62415(request, Request);
}



const $8afcf0d9e9f8c38b$var$WINDOW = (0, $88208d9e04627397$export$f1a6cdb1459e81d1);
const $8afcf0d9e9f8c38b$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $8afcf0d9e9f8c38b$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return "<unknown>";
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = " > ";
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $8afcf0d9e9f8c38b$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $8afcf0d9e9f8c38b$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return "<unknown>";
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $8afcf0d9e9f8c38b$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    if (!elem?.tagName) return "";
    // @ts-expect-error WINDOW has HTMLElement
    if ($8afcf0d9e9f8c38b$var$WINDOW.HTMLElement) // If using the component name annotation plugin, this value may be available on the DOM node
    {
        if (elem instanceof HTMLElement && elem.dataset) {
            if (elem.dataset["sentryComponent"]) return elem.dataset["sentryComponent"];
            if (elem.dataset["sentryElement"]) return elem.dataset["sentryElement"];
        }
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs?.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs?.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        const className = elem.className;
        if (className && (0, $ed5cb73b8752546d$export$844ec244b1367d54)(className)) {
            const classes = className.split(/\s+/);
            for (const c of classes)out.push(`.${c}`);
        }
    }
    const allowedAttrs = [
        "aria-label",
        "type",
        "name",
        "title",
        "alt"
    ];
    for (const k of allowedAttrs){
        const attr = elem.getAttribute(k);
        if (attr) out.push(`[${k}="${attr}"]`);
    }
    return out.join("");
}
/**
 * A safe form of location.href
 */ function $8afcf0d9e9f8c38b$export$1cfafeee2987818b() {
    try {
        return $8afcf0d9e9f8c38b$var$WINDOW.document.location.href;
    } catch (oO) {
        return "";
    }
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` or `data-sentry-element` attribute with `data-sentry-component` taking
 * precedence. This attribute is added at build-time by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function $8afcf0d9e9f8c38b$export$26727cfcc4d7e0fc(elem) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!$8afcf0d9e9f8c38b$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    const MAX_TRAVERSE_HEIGHT = 5;
    for(let i = 0; i < MAX_TRAVERSE_HEIGHT; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement) {
            if (currentElem.dataset["sentryComponent"]) return currentElem.dataset["sentryComponent"];
            if (currentElem.dataset["sentryElement"]) return currentElem.dataset["sentryElement"];
        }
        currentElem = currentElem.parentNode;
    }
    return null;
}






/** Prefix for logging strings */ const $dfad86e498c52aee$var$PREFIX = "Sentry Logger ";
const $dfad86e498c52aee$export$2a2b1d2252a69ecb = [
    "debug",
    "info",
    "warn",
    "error",
    "log",
    "assert",
    "trace"
];
/** This may be mutated by the console instrumentation. */ const $dfad86e498c52aee$export$77c4ce905194557b = {};
/** A Sentry Logger instance. */ /**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $dfad86e498c52aee$export$cda52e2a8927a2ca(callback) {
    if (!("console" in (0, $88208d9e04627397$export$f1a6cdb1459e81d1))) return callback();
    const console = (0, $88208d9e04627397$export$f1a6cdb1459e81d1).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($dfad86e498c52aee$export$77c4ce905194557b);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $dfad86e498c52aee$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $dfad86e498c52aee$var$makeLogger() {
    let enabled = false;
    const logger = {
        enable: ()=>{
            enabled = true;
        },
        disable: ()=>{
            enabled = false;
        },
        isEnabled: ()=>enabled
    };
    if (0, $b5c0571e433473d8$export$16a28057038b10ef) $dfad86e498c52aee$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = (...args)=>{
            if (enabled) $dfad86e498c52aee$export$cda52e2a8927a2ca(()=>{
                (0, $88208d9e04627397$export$f1a6cdb1459e81d1).console[name](`${$dfad86e498c52aee$var$PREFIX}[${name}]:`, ...args);
            });
        };
    });
    else $dfad86e498c52aee$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = ()=>undefined;
    });
    return logger;
}
/**
 * This is a logger singleton which either logs things or no-ops if logging is not enabled.
 * The logger is a singleton on the carrier, to ensure that a consistent logger is used throughout the SDK.
 */ const $dfad86e498c52aee$export$af88d00dbe7f521 = (0, $abd13f64e43ff217$export$7e223ec222791509)("logger", $dfad86e498c52aee$var$makeLogger);



/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $79b6b3761a352021$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== "string" || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $79b6b3761a352021$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += " {snip}";
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ function $79b6b3761a352021$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return "";
    const output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, $ed5cb73b8752546d$export$7916fad0ebc23f48)(value)) output.push("[VueViewModel]");
            else output.push(String(value));
        } catch (e) {
            output.push("[value cannot be serialized]");
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $79b6b3761a352021$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $ed5cb73b8752546d$export$844ec244b1367d54)(value)) return false;
    if ((0, $ed5cb73b8752546d$export$49841c62b9eff15)(pattern)) return pattern.test(value);
    if ((0, $ed5cb73b8752546d$export$844ec244b1367d54)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $79b6b3761a352021$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$79b6b3761a352021$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}


/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Replace a method in an object with a wrapped version of itself.
 *
 * If the method on the passed object is not a function, the wrapper will not be applied.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $90379bc90653c4b6$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    // explicitly casting to unknown because we don't know the type of the method initially at all
    const original = source[name];
    if (typeof original !== "function") return;
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === "function") $90379bc90653c4b6$export$5c1499e2e5d010ae(wrapped, original);
    try {
        source[name] = wrapped;
    } catch  {
        (0, $b5c0571e433473d8$export$16a28057038b10ef) && (0, $dfad86e498c52aee$export$af88d00dbe7f521).log(`Failed to replace method "${name}" in object`, source);
    }
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $90379bc90653c4b6$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch (o_O) {
        (0, $b5c0571e433473d8$export$16a28057038b10ef) && (0, $dfad86e498c52aee$export$af88d00dbe7f521).log(`Failed to add non-enumerable property "${name}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $90379bc90653c4b6$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $90379bc90653c4b6$export$e73679ffaf56810e(wrapped, "__sentry_original__", original);
    } catch (o_O) {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $90379bc90653c4b6$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argument itself, when value is neither an Event nor
 *  an Error.
 */ function $90379bc90653c4b6$export$62ff257738bf57f5(value) {
    if ((0, $ed5cb73b8752546d$export$e6127cc7fe7395c3)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$90379bc90653c4b6$var$getOwnProperties(value)
    };
    else if ((0, $ed5cb73b8752546d$export$9671ea99bd126ace)(value)) {
        const newObj = {
            type: value.type,
            target: $90379bc90653c4b6$var$serializeEventTarget(value.target),
            currentTarget: $90379bc90653c4b6$var$serializeEventTarget(value.currentTarget),
            ...$90379bc90653c4b6$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== "undefined" && (0, $ed5cb73b8752546d$export$49034edbe6b62415)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $90379bc90653c4b6$var$serializeEventTarget(target) {
    try {
        return (0, $ed5cb73b8752546d$export$45a5e7f76e0caa8d)(target) ? (0, $8afcf0d9e9f8c38b$export$5647df6b7814ac86)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return "<unknown>";
    }
}
/** Filters out all but an object's own properties */ function $90379bc90653c4b6$var$getOwnProperties(obj) {
    if (typeof obj === "object" && obj !== null) {
        const extractedProps = {};
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $90379bc90653c4b6$export$b0244d5063c0b61b(exception, maxLength = 40) {
    const keys = Object.keys($90379bc90653c4b6$export$62ff257738bf57f5(exception));
    keys.sort();
    const firstKey = keys[0];
    if (!firstKey) return "[object has no keys]";
    if (firstKey.length >= maxLength) return (0, $79b6b3761a352021$export$6a506b36fdea397d)(firstKey, maxLength);
    for(let includedKeys = keys.length; includedKeys > 0; includedKeys--){
        const serialized = keys.slice(0, includedKeys).join(", ");
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $79b6b3761a352021$export$6a506b36fdea397d)(serialized, maxLength);
    }
    return "";
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 *
 * @deprecated This function is no longer used by the SDK and will be removed in a future major version.
 */ function $90379bc90653c4b6$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $90379bc90653c4b6$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $90379bc90653c4b6$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    // Early return for primitive values
    if (inputValue === null || typeof inputValue !== "object") return inputValue;
    // Check memo map first for all object types
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== undefined) return memoVal;
    // handle arrays
    if (Array.isArray(inputValue)) {
        const returnValue = [];
        // Store mapping to handle circular references
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((value)=>{
            returnValue.push($90379bc90653c4b6$var$_dropUndefinedKeys(value, memoizationMap));
        });
        return returnValue;
    }
    if ($90379bc90653c4b6$var$isPojo(inputValue)) {
        const returnValue = {};
        // Store mapping to handle circular references
        memoizationMap.set(inputValue, returnValue);
        const keys = Object.keys(inputValue);
        keys.forEach((key)=>{
            const val = inputValue[key];
            if (val !== undefined) returnValue[key] = $90379bc90653c4b6$var$_dropUndefinedKeys(val, memoizationMap);
        });
        return returnValue;
    }
    // For other object types, return as is
    return inputValue;
}
function $90379bc90653c4b6$var$isPojo(input) {
    // Plain objects have Object as constructor or no constructor
    const constructor = input.constructor;
    return constructor === Object || constructor === undefined;
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $90379bc90653c4b6$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        // this will catch both undefined and null
        case wat == undefined:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === "symbol" || typeof wat === "bigint":
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $ed5cb73b8752546d$export$c3825b437cbdea5c)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}




function $c65fa882a3254127$var$getCrypto() {
    const gbl = (0, $88208d9e04627397$export$f1a6cdb1459e81d1);
    return gbl.crypto || gbl.msCrypto;
}
/**
 * UUID4 generator
 * @param crypto Object that provides the crypto API.
 * @returns string Generated UUID4.
 */ function $c65fa882a3254127$export$19f53698e68b2496(crypto = $c65fa882a3254127$var$getCrypto()) {
    let getRandomByte = ()=>Math.random() * 16;
    try {
        if (crypto?.randomUUID) return crypto.randomUUID().replace(/-/g, "");
        if (crypto?.getRandomValues) getRandomByte = ()=>{
            // crypto.getRandomValues might return undefined instead of the typed array
            // in old Chromium versions (e.g. 23.0.1235.0 (151422))
            // However, `typedArray` is still filled in-place.
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues#typedarray
            const typedArray = new Uint8Array(1);
            crypto.getRandomValues(typedArray);
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            return typedArray[0];
        };
    } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function $c65fa882a3254127$var$getFirstException(event) {
    return event.exception?.values?.[0];
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $c65fa882a3254127$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $c65fa882a3254127$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || "<unknown>";
    }
    return eventId || "<unknown>";
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $c65fa882a3254127$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || "";
    if (!firstException.type) firstException.type = type || "Error";
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $c65fa882a3254127$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $c65fa882a3254127$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: "generic",
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && "data" in newMechanism) {
        const mergedData = {
            ...currentMechanism?.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $c65fa882a3254127$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ function $c65fa882a3254127$var$_parseInt(input) {
    return parseInt(input || "", 10);
}
/**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $c65fa882a3254127$export$d364f2020ab30578(input) {
    const match = input.match($c65fa882a3254127$var$SEMVER_REGEXP) || [];
    const major = $c65fa882a3254127$var$_parseInt(match[1]);
    const minor = $c65fa882a3254127$var$_parseInt(match[2]);
    const patch = $c65fa882a3254127$var$_parseInt(match[3]);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $c65fa882a3254127$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $79b6b3761a352021$export$4215662d762d6f9d)(line, 0));
    // We guard here to ensure this is not larger than the existing number of lines
    const lineIndex = Math.min(maxLines - 1, sourceLine);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    frame.context_line = (0, $79b6b3761a352021$export$4215662d762d6f9d)(lines[lineIndex], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $79b6b3761a352021$export$4215662d762d6f9d)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $c65fa882a3254127$export$6de4ffac6a2f1098(exception) {
    if ($c65fa882a3254127$var$isAlreadyCaptured(exception)) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $90379bc90653c4b6$export$e73679ffaf56810e)(exception, "__sentry_captured__", true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
function $c65fa882a3254127$var$isAlreadyCaptured(exception) {
    try {
        return exception.__sentry_captured__;
    } catch  {} // eslint-disable-line no-empty
}



const $14ccb306f78f15b4$var$ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 */ function $14ccb306f78f15b4$export$7740643b9eeaf0c4() {
    return Date.now() / $14ccb306f78f15b4$var$ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function $14ccb306f78f15b4$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $88208d9e04627397$export$f1a6cdb1459e81d1);
    if (!performance?.now) return $14ccb306f78f15b4$export$7740643b9eeaf0c4;
    // Some browser and environments don't have a timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    const approxStartingTimeOrigin = Date.now() - performance.now();
    const timeOrigin = performance.timeOrigin == undefined ? approxStartingTimeOrigin : performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return ()=>{
        return (timeOrigin + performance.now()) / $14ccb306f78f15b4$var$ONE_SECOND_IN_MS;
    };
}
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ const $14ccb306f78f15b4$export$ee52dced521e3e18 = $14ccb306f78f15b4$var$createUnixTimestampInSecondsFunc();
/**
 * Cached result of getBrowserTimeOrigin.
 */ let $14ccb306f78f15b4$var$cachedTimeOrigin;
/**
 * Gets the time origin and the mode used to determine it.
 */ function $14ccb306f78f15b4$var$getBrowserTimeOrigin() {
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    const { performance: performance } = (0, $88208d9e04627397$export$f1a6cdb1459e81d1);
    if (!performance?.now) return [
        undefined,
        "none"
    ];
    const threshold = 3600000;
    const performanceNow = performance.now();
    const dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    const timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing?.navigationStart;
    const hasNavigationStart = typeof navigationStart === "number";
    // if navigationStart isn't available set delta to threshold so it isn't used
    const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    const navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) return [
            performance.timeOrigin,
            "timeOrigin"
        ];
        else return [
            navigationStart,
            "navigationStart"
        ];
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    return [
        dateNow,
        "dateNow"
    ];
}
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ function $14ccb306f78f15b4$export$baf075a948ffc0bf() {
    if (!$14ccb306f78f15b4$var$cachedTimeOrigin) $14ccb306f78f15b4$var$cachedTimeOrigin = $14ccb306f78f15b4$var$getBrowserTimeOrigin();
    return $14ccb306f78f15b4$var$cachedTimeOrigin[0];
}


/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $1336536f7ff10af9$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $14ccb306f78f15b4$export$ee52dced521e3e18)();
    const session = {
        sid: (0, $c65fa882a3254127$export$19f53698e68b2496)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: "ok",
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$1336536f7ff10af9$var$sessionToJSON(session)
    };
    if (context) $1336536f7ff10af9$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see Client.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $1336536f7ff10af9$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $14ccb306f78f15b4$export$ee52dced521e3e18)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $c65fa882a3254127$export$19f53698e68b2496)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === "number") session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === "number") session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === "number") session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $1336536f7ff10af9$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === "ok") context = {
        status: "exited"
    };
    $1336536f7ff10af9$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $1336536f7ff10af9$var$sessionToJSON(session) {
    return {
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === "number" || typeof session.did === "string" ? `${session.did}` : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    };
}




/**
 * Shallow merge two objects.
 * Does not mutate the passed in objects.
 * Undefined/empty values in the merge object will overwrite existing values.
 *
 * By default, this merges 2 levels deep.
 */ function $b431b21a01204225$export$4950aa0f605343fb(initialObj, mergeObj, levels = 2) {
    // If the merge value is not an object, or we have no merge levels left,
    // we just set the value to the merge value
    if (!mergeObj || typeof mergeObj !== "object" || levels <= 0) return mergeObj;
    // If the merge object is an empty object, and the initial object is not undefined, we return the initial object
    if (initialObj && Object.keys(mergeObj).length === 0) return initialObj;
    // Clone object
    const output = {
        ...initialObj
    };
    // Merge values into output, resursively
    for(const key in mergeObj)if (Object.prototype.hasOwnProperty.call(mergeObj, key)) output[key] = $b431b21a01204225$export$4950aa0f605343fb(output[key], mergeObj[key], levels - 1);
    return output;
}




/**
 * Generate a random, valid trace ID.
 */ function $482848166ffdb9e6$export$dc6d7ea554bcce10() {
    return (0, $c65fa882a3254127$export$19f53698e68b2496)();
}
/**
 * Generate a random, valid span ID.
 */ function $482848166ffdb9e6$export$295213bc4d0c54ad() {
    return (0, $c65fa882a3254127$export$19f53698e68b2496)().substring(16);
}



const $946deb57ecfb47b9$var$SCOPE_SPAN_FIELD = "_sentrySpan";
/**
 * Set the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $946deb57ecfb47b9$export$3f25fa50c18e20ca(scope, span) {
    if (span) (0, $90379bc90653c4b6$export$e73679ffaf56810e)(scope, $946deb57ecfb47b9$var$SCOPE_SPAN_FIELD, span);
    else // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
    delete scope[$946deb57ecfb47b9$var$SCOPE_SPAN_FIELD];
}
/**
 * Get the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $946deb57ecfb47b9$export$91f063ebb8eff307(scope) {
    return scope[$946deb57ecfb47b9$var$SCOPE_SPAN_FIELD];
}




/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $74a314e82a93236a$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * A context to be used for capturing an event.
 * This can either be a Scope, or a partial ScopeContext,
 * or a callback that receives the current scope and returns a new scope to use.
 */ /**
 * Holds additional event information.
 */ class $74a314e82a93236a$export$775b6bb06e53a214 {
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called during event processing. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Extra */ /** Contexts */ /** Attachments */ /** Propagation Context for distributed tracing */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */ /** Session */ /** The client on this scope */ /** Contains the last event id of a captured event.  */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = {
            traceId: (0, $482848166ffdb9e6$export$dc6d7ea554bcce10)(),
            sampleRand: Math.random()
        };
    }
    /**
   * Clone all data from this scope into a new scope.
   */ clone() {
        const newScope = new $74a314e82a93236a$export$775b6bb06e53a214();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        if (this._contexts.flags) // We need to copy the `values` array so insertions on a cloned scope
        // won't affect the original array.
        newScope._contexts.flags = {
            values: [
                ...this._contexts.flags.values
            ]
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        newScope._lastEventId = this._lastEventId;
        (0, $946deb57ecfb47b9$export$3f25fa50c18e20ca)(newScope, (0, $946deb57ecfb47b9$export$91f063ebb8eff307)(this));
        return newScope;
    }
    /**
   * Update the client assigned to this scope.
   * Note that not every scope will have a client assigned - isolation scopes & the global scope will generally not have a client,
   * as well as manually created scopes.
   */ setClient(client) {
        this._client = client;
    }
    /**
   * Set the ID of the last captured error event.
   * This is generally only captured on the isolation scope.
   */ setLastEventId(lastEventId) {
        this._lastEventId = lastEventId;
    }
    /**
   * Get the client assigned to this scope.
   */ getClient() {
        return this._client;
    }
    /**
   * Get the ID of the last captured error event.
   * This is generally only available on the isolation scope.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * Add an event processor that will be called before an event is sent.
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * Set the user for this scope.
   * Set to `null` to unset the user.
   */ setUser(user) {
        // If null is passed we want to unset everything, but still define keys,
        // so that later down in the pipeline any existing values are cleared.
        this._user = user || {
            email: undefined,
            id: undefined,
            ip_address: undefined,
            username: undefined
        };
        if (this._session) (0, $1336536f7ff10af9$export$531818e825e774db)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the user from this scope.
   */ getUser() {
        return this._user;
    }
    /**
   * Set an object that will be merged into existing tags on the scope,
   * and will be sent as tags data with the event.
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single tag that will be sent as tags data with the event.
   */ setTag(key, value) {
        this._tags = {
            ...this._tags,
            [key]: value
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set an object that will be merged into existing extra on the scope,
   * and will be sent as extra data with the event.
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single key:value extra entry that will be sent as extra data with the event.
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the fingerprint on the scope to send with the events.
   * @param {string[]} fingerprint Fingerprint to group events in Sentry.
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the level on the scope for future events.
   */ setLevel(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope so that the name of e.g. taken server route or
   * the page location is attached to future events.
   *
   * IMPORTANT: Calling this function does NOT change the name of the currently active
   * root span. If you want to change the name of the active root span, use
   * `Sentry.updateSpanName(rootSpan, 'new name')` instead.
   *
   * By default, the SDK updates the scope's transaction name automatically on sensible
   * occasions, such as a page navigation or when handling a new request on the server.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets context data with the given name.
   * Data passed as context will be normalized. You can also pass `null` to unset the context.
   * Note that context data will not be merged - calling `setContext` will overwrite an existing context with the same key.
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set the session for the scope.
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the session from the scope.
   */ getSession() {
        return this._session;
    }
    /**
   * Updates the scope with provided data. Can work in three variations:
   * - plain object containing updatable attributes
   * - Scope instance that'll extract the attributes from
   * - callback function that'll receive the current scope as an argument and allow for modifications
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === "function" ? captureContext(this) : captureContext;
        const scopeInstance = scopeToMerge instanceof $74a314e82a93236a$export$775b6bb06e53a214 ? scopeToMerge.getScopeData() : (0, $ed5cb73b8752546d$export$53b83ca8eaab0383)(scopeToMerge) ? captureContext : undefined;
        const { tags: tags, extra: extra, user: user, contexts: contexts, level: level, fingerprint: fingerprint = [], propagationContext: propagationContext } = scopeInstance || {};
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._extra = {
            ...this._extra,
            ...extra
        };
        this._contexts = {
            ...this._contexts,
            ...contexts
        };
        if (user && Object.keys(user).length) this._user = user;
        if (level) this._level = level;
        if (fingerprint.length) this._fingerprint = fingerprint;
        if (propagationContext) this._propagationContext = propagationContext;
        return this;
    }
    /**
   * Clears the current scope and resets its properties.
   * Note: The client will not be cleared.
   */ clear() {
        // client is not cleared here on purpose!
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._session = undefined;
        (0, $946deb57ecfb47b9$export$3f25fa50c18e20ca)(this, undefined);
        this._attachments = [];
        this.setPropagationContext({
            traceId: (0, $482848166ffdb9e6$export$dc6d7ea554bcce10)(),
            sampleRand: Math.random()
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Adds a breadcrumb to the scope.
   * By default, the last 100 breadcrumbs are kept.
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === "number" ? maxBreadcrumbs : $74a314e82a93236a$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $14ccb306f78f15b4$export$7740643b9eeaf0c4)(),
            ...breadcrumb,
            // Breadcrumb messages can theoretically be infinitely large and they're held in memory so we truncate them not to leak (too much) memory
            message: breadcrumb.message ? (0, $79b6b3761a352021$export$6a506b36fdea397d)(breadcrumb.message, 2048) : breadcrumb.message
        };
        this._breadcrumbs.push(mergedBreadcrumb);
        if (this._breadcrumbs.length > maxCrumbs) {
            this._breadcrumbs = this._breadcrumbs.slice(-maxCrumbs);
            this._client?.recordDroppedEvent("buffer_overflow", "log_item");
        }
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the last breadcrumb of the scope.
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * Clear all breadcrumbs from the scope.
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Add an attachment to the scope.
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * Clear all attachments from the scope.
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /**
   * Get the data of this scope, which should be applied to an event during processing.
   */ getScopeData() {
        return {
            breadcrumbs: this._breadcrumbs,
            attachments: this._attachments,
            contexts: this._contexts,
            tags: this._tags,
            extra: this._extra,
            user: this._user,
            level: this._level,
            fingerprint: this._fingerprint || [],
            eventProcessors: this._eventProcessors,
            propagationContext: this._propagationContext,
            sdkProcessingMetadata: this._sdkProcessingMetadata,
            transactionName: this._transactionName,
            span: (0, $946deb57ecfb47b9$export$91f063ebb8eff307)(this)
        };
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry.
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = (0, $b431b21a01204225$export$4950aa0f605343fb)(this._sdkProcessingMetadata, newData, 2);
        return this;
    }
    /**
   * Add propagation context to the scope, used for distributed tracing
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * Get propagation context from the scope, used for distributed tracing
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @returns {string} The id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = hint?.event_id || (0, $c65fa882a3254127$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $dfad86e498c52aee$export$af88d00dbe7f521).warn("No client configured on scope - will not capture exception!");
            return eventId;
        }
        const syntheticException = new Error("Sentry syntheticException");
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @returns {string} The id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = hint?.event_id || (0, $c65fa882a3254127$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $dfad86e498c52aee$export$af88d00dbe7f521).warn("No client configured on scope - will not capture message!");
            return eventId;
        }
        const syntheticException = new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a Sentry event for this scope.
   *
   * @returns {string} The id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = hint?.event_id || (0, $c65fa882a3254127$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $dfad86e498c52aee$export$af88d00dbe7f521).warn("No client configured on scope - will not capture event!");
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}


/** Get the default current scope. */ function $a8747bbd714535a9$export$6f1b9191db9c4d5() {
    return (0, $abd13f64e43ff217$export$7e223ec222791509)("defaultCurrentScope", ()=>new (0, $74a314e82a93236a$export$775b6bb06e53a214)());
}
/** Get the default isolation scope. */ function $a8747bbd714535a9$export$de9862929b76bf57() {
    return (0, $abd13f64e43ff217$export$7e223ec222791509)("defaultIsolationScope", ()=>new (0, $74a314e82a93236a$export$775b6bb06e53a214)());
}





/**
 * This is an object that holds a stack of scopes.
 */ class $957f84573f72472d$export$d36ec451f120cfba {
    constructor(scope, isolationScope){
        let assignedScope;
        if (!scope) assignedScope = new (0, $74a314e82a93236a$export$775b6bb06e53a214)();
        else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) assignedIsolationScope = new (0, $74a314e82a93236a$export$775b6bb06e53a214)();
        else assignedIsolationScope = isolationScope;
        // scope stack for domains or the process
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Fork a scope for the stack.
   */ withScope(callback) {
        const scope = this._pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            this._popScope();
            throw e;
        }
        if ((0, $ed5cb73b8752546d$export$f5b060c2914b97c8)(maybePromiseResult)) // @ts-expect-error - isThenable returns the wrong type
        return maybePromiseResult.then((res)=>{
            this._popScope();
            return res;
        }, (e)=>{
            this._popScope();
            throw e;
        });
        this._popScope();
        return maybePromiseResult;
    }
    /**
   * Get the client of the stack.
   */ getClient() {
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   */ getScope() {
        return this.getStackTop().scope;
    }
    /**
   * Get the isolation scope for the stack.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * Push a scope to the stack.
   */ _pushScope() {
        // We want to clone the content of prev scope
        const scope = this.getScope().clone();
        this._stack.push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * Pop a scope from the stack.
   */ _popScope() {
        if (this._stack.length <= 1) return false;
        return !!this._stack.pop();
    }
}
/**
 * Get the global async context stack.
 * This will be removed during the v8 cycle and is only here to make migration easier.
 */ function $957f84573f72472d$var$getAsyncContextStack() {
    const registry = (0, $abd13f64e43ff217$export$19eade501500c6c1)();
    const sentry = (0, $abd13f64e43ff217$export$c8bfa33e4e8ae492)(registry);
    return sentry.stack = sentry.stack || new $957f84573f72472d$export$d36ec451f120cfba((0, $a8747bbd714535a9$export$6f1b9191db9c4d5)(), (0, $a8747bbd714535a9$export$de9862929b76bf57)());
}
function $957f84573f72472d$var$withScope(callback) {
    return $957f84573f72472d$var$getAsyncContextStack().withScope(callback);
}
function $957f84573f72472d$var$withSetScope(scope, callback) {
    const stack = $957f84573f72472d$var$getAsyncContextStack();
    return stack.withScope(()=>{
        stack.getStackTop().scope = scope;
        return callback(scope);
    });
}
function $957f84573f72472d$var$withIsolationScope(callback) {
    return $957f84573f72472d$var$getAsyncContextStack().withScope(()=>{
        return callback($957f84573f72472d$var$getAsyncContextStack().getIsolationScope());
    });
}
/**
 * Get the stack-based async context strategy.
 */ function $957f84573f72472d$export$329d4d4d54e42710() {
    return {
        withIsolationScope: $957f84573f72472d$var$withIsolationScope,
        withScope: $957f84573f72472d$var$withScope,
        withSetScope: $957f84573f72472d$var$withSetScope,
        withSetIsolationScope: (_isolationScope, callback)=>{
            return $957f84573f72472d$var$withIsolationScope(callback);
        },
        getCurrentScope: ()=>$957f84573f72472d$var$getAsyncContextStack().getScope(),
        getIsolationScope: ()=>$957f84573f72472d$var$getAsyncContextStack().getIsolationScope()
    };
}


/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $eb2688584caaa46c$export$774ae0e6b6e444ca(strategy) {
    // Get main carrier (global for every environment)
    const registry = (0, $abd13f64e43ff217$export$19eade501500c6c1)();
    const sentry = (0, $abd13f64e43ff217$export$c8bfa33e4e8ae492)(registry);
    sentry.acs = strategy;
}
/**
 * Get the current async context strategy.
 * If none has been setup, the default will be used.
 */ function $eb2688584caaa46c$export$f639b0c2752203be(carrier) {
    const sentry = (0, $abd13f64e43ff217$export$c8bfa33e4e8ae492)(carrier);
    if (sentry.acs) return sentry.acs;
    // Otherwise, use the default one (stack)
    return (0, $957f84573f72472d$export$329d4d4d54e42710)();
}





/**
 * Get the currently active scope.
 */ function $0b98faa1b87c8168$export$c7be4b0125a10cba() {
    const carrier = (0, $abd13f64e43ff217$export$19eade501500c6c1)();
    const acs = (0, $eb2688584caaa46c$export$f639b0c2752203be)(carrier);
    return acs.getCurrentScope();
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current execution context.
 */ function $0b98faa1b87c8168$export$68f3af03034c9e90() {
    const carrier = (0, $abd13f64e43ff217$export$19eade501500c6c1)();
    const acs = (0, $eb2688584caaa46c$export$f639b0c2752203be)(carrier);
    return acs.getIsolationScope();
}
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function $0b98faa1b87c8168$export$aa55d5ab8e05984f() {
    return (0, $abd13f64e43ff217$export$7e223ec222791509)("globalScope", ()=>new (0, $74a314e82a93236a$export$775b6bb06e53a214)());
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function $0b98faa1b87c8168$export$ec58d9285c204497(...rest) {
    const carrier = (0, $abd13f64e43ff217$export$19eade501500c6c1)();
    const acs = (0, $eb2688584caaa46c$export$f639b0c2752203be)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) return acs.withScope(callback);
        return acs.withSetScope(scope, callback);
    }
    return acs.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 */ /**
 * Either creates a new active isolation scope, or sets the given isolation scope as active scope in the given callback.
 */ function $0b98faa1b87c8168$export$9a4fed82c350c2bd(...rest) {
    const carrier = (0, $abd13f64e43ff217$export$19eade501500c6c1)();
    const acs = (0, $eb2688584caaa46c$export$f639b0c2752203be)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [isolationScope, callback] = rest;
        if (!isolationScope) return acs.withIsolationScope(callback);
        return acs.withSetIsolationScope(isolationScope, callback);
    }
    return acs.withIsolationScope(rest[0]);
}
/**
 * Get the currently active client.
 */ function $0b98faa1b87c8168$export$6bb76d6eba7e258c() {
    return $0b98faa1b87c8168$export$c7be4b0125a10cba().getClient();
}
/**
 * Get a trace context for the given scope.
 */ function $0b98faa1b87c8168$export$1e83db7ee4876dc4(scope) {
    const propagationContext = scope.getPropagationContext();
    const { traceId: traceId, parentSpanId: parentSpanId, propagationSpanId: propagationSpanId } = propagationContext;
    const traceContext = {
        trace_id: traceId,
        span_id: propagationSpanId || (0, $482848166ffdb9e6$export$295213bc4d0c54ad)()
    };
    if (parentSpanId) traceContext.parent_span_id = parentSpanId;
    return traceContext;
}








const $4d1ecfae9e70d95f$export$849dbeeeda01ae98 = "production";







/* eslint-disable @typescript-eslint/no-explicit-any */ /** SyncPromise internal states */ var $3de734ff6b883b7d$var$States;
(function(States) {
    /** Pending */ const PENDING = 0;
    States[States["PENDING"] = PENDING] = "PENDING";
    /** Resolved / OK */ const RESOLVED = 1;
    States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
    /** Rejected / Error */ const REJECTED = 2;
    States[States["REJECTED"] = REJECTED] = "REJECTED";
})($3de734ff6b883b7d$var$States || ($3de734ff6b883b7d$var$States = {}));
// Overloads so we can call resolvedSyncPromise without arguments and generic argument
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $3de734ff6b883b7d$export$1fda8aa4d135f8aa(value) {
    return new $3de734ff6b883b7d$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $3de734ff6b883b7d$export$78e43115b553f358(reason) {
    return new $3de734ff6b883b7d$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class $3de734ff6b883b7d$export$6f292d4960313241 {
    constructor(executor){
        this._state = $3de734ff6b883b7d$var$States.PENDING;
        this._handlers = [];
        this._runExecutor(executor);
    }
    /** @inheritdoc */ then(onfulfilled, onrejected) {
        return new $3de734ff6b883b7d$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** @inheritdoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** @inheritdoc */ finally(onfinally) {
        return new $3de734ff6b883b7d$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** Excute the resolve/reject handlers. */ _executeHandlers() {
        if (this._state === $3de734ff6b883b7d$var$States.PENDING) return;
        const cachedHandlers = this._handlers.slice();
        this._handlers = [];
        cachedHandlers.forEach((handler)=>{
            if (handler[0]) return;
            if (this._state === $3de734ff6b883b7d$var$States.RESOLVED) handler[1](this._value);
            if (this._state === $3de734ff6b883b7d$var$States.REJECTED) handler[2](this._value);
            handler[0] = true;
        });
    }
    /** Run the executor for the SyncPromise. */ _runExecutor(executor) {
        const setResult = (state, value)=>{
            if (this._state !== $3de734ff6b883b7d$var$States.PENDING) return;
            if ((0, $ed5cb73b8752546d$export$f5b060c2914b97c8)(value)) {
                value.then(resolve, reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
        const resolve = (value)=>{
            setResult($3de734ff6b883b7d$var$States.RESOLVED, value);
        };
        const reject = (reason)=>{
            setResult($3de734ff6b883b7d$var$States.REJECTED, reason);
        };
        try {
            executor(resolve, reject);
        } catch (e) {
            reject(e);
        }
    }
}


/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */ function $0f691e97ff786670$export$bf2a096c3e883e79(processors, event, hint, index = 0) {
    return new (0, $3de734ff6b883b7d$export$6f292d4960313241)((resolve, reject)=>{
        const processor = processors[index];
        if (event === null || typeof processor !== "function") resolve(event);
        else {
            const result = processor({
                ...event
            }, hint);
            (0, $b5c0571e433473d8$export$16a28057038b10ef) && processor.id && result === null && (0, $dfad86e498c52aee$export$af88d00dbe7f521).log(`Event processor "${processor.id}" dropped event`);
            if ((0, $ed5cb73b8752546d$export$f5b060c2914b97c8)(result)) result.then((final)=>$0f691e97ff786670$export$bf2a096c3e883e79(processors, final, hint, index + 1).then(resolve)).then(null, reject);
            else $0f691e97ff786670$export$bf2a096c3e883e79(processors, result, hint, index + 1).then(resolve).then(null, reject);
        }
    });
}





/**
 * Use this attribute to represent the source of a span.
 * Should be one of: custom, url, route, view, component, task, unknown
 *
 */ const $34e3132ced11beec$export$d7a7d984b0791405 = "sentry.source";
/**
 * Attributes that holds the sample rate that was locally applied to a span.
 * If this attribute is not defined, it means that the span inherited a sampling decision.
 *
 * NOTE: Is only defined on root spans.
 */ const $34e3132ced11beec$export$ccfe0a40627cc34b = "sentry.sample_rate";
/**
 * Attribute holding the sample rate of the previous trace.
 * This is used to sample consistently across subsequent traces in the browser SDK.
 *
 * Note: Only defined on root spans, if opted into consistent sampling
 */ const $34e3132ced11beec$export$889fb736668e1ecc = "sentry.previous_trace_sample_rate";
/**
 * Use this attribute to represent the operation of a span.
 */ const $34e3132ced11beec$export$1a413bd9a88fdb09 = "sentry.op";
/**
 * Use this attribute to represent the origin of a span.
 */ const $34e3132ced11beec$export$cca8dd30f57f805e = "sentry.origin";
/** The reason why an idle span finished. */ const $34e3132ced11beec$export$ba73f34502b7a3b3 = "sentry.idle_span_finish_reason";
/** The unit of a measurement, which may be stored as a TimedEvent. */ const $34e3132ced11beec$export$f5f95cff026507b5 = "sentry.measurement_unit";
/** The value of a measurement, which may be stored as a TimedEvent. */ const $34e3132ced11beec$export$69cd5c610c7bb96a = "sentry.measurement_value";
/**
 * A custom span name set by users guaranteed to be taken over any automatically
 * inferred name. This attribute is removed before the span is sent.
 *
 * @internal only meant for internal SDK usage
 * @hidden
 */ const $34e3132ced11beec$export$165ce9a229f6f050 = "sentry.custom_span_name";
/**
 * The id of the profile that this span occurred in.
 */ const $34e3132ced11beec$export$1efec95406bbe327 = "sentry.profile_id";
const $34e3132ced11beec$export$fea48ba9f4550879 = "sentry.exclusive_time";
const $34e3132ced11beec$export$b016f89ac1066ec = "cache.hit";
const $34e3132ced11beec$export$3110e4c3f4386399 = "cache.key";
const $34e3132ced11beec$export$86be76deee227ff2 = "cache.item_size";
/** TODO: Remove these once we update to latest semantic conventions */ const $34e3132ced11beec$export$be7a251980e7e946 = "http.request.method";
const $34e3132ced11beec$export$25dfd73e0e32c6e1 = "url.full";
/**
 * A span link attribute to mark the link as a special span link.
 *
 * Known values:
 * - `previous_trace`: The span links to the frontend root span of the previous trace.
 * - `next_trace`: The span links to the frontend root span of the next trace. (Not set by the SDK)
 *
 * Other values may be set as appropriate.
 * @see https://develop.sentry.dev/sdk/telemetry/traces/span-links/#link-types
 */ const $34e3132ced11beec$export$ff77b5fd5b2d627b = "sentry.link.type";





const $fb4f2d687c5ee56d$export$6e69537d67fa20f = "sentry-";
const $fb4f2d687c5ee56d$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const $fb4f2d687c5ee56d$export$bdd844ddb2def819 = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $fb4f2d687c5ee56d$export$5b96ee2c8421f107(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    const baggageObject = $fb4f2d687c5ee56d$export$397de414d189db00(baggageHeader);
    if (!baggageObject) return undefined;
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.match($fb4f2d687c5ee56d$export$eb0401070c617ea5)) {
            const nonPrefixedKey = key.slice($fb4f2d687c5ee56d$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $fb4f2d687c5ee56d$export$56766feef403f365(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$fb4f2d687c5ee56d$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $fb4f2d687c5ee56d$export$12a7349a29a6e3c2(sentryPrefixedDSC);
}
/**
 * Take a baggage header and parse it into an object.
 */ function $fb4f2d687c5ee56d$export$397de414d189db00(baggageHeader) {
    if (!baggageHeader || !(0, $ed5cb73b8752546d$export$844ec244b1367d54)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    return baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $fb4f2d687c5ee56d$var$baggageHeaderToObject(curr);
        Object.entries(currBaggageObject).forEach(([key, value])=>{
            acc[key] = value;
        });
        return acc;
    }, {});
    return $fb4f2d687c5ee56d$var$baggageHeaderToObject(baggageHeader);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $fb4f2d687c5ee56d$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(",").map((baggageEntry)=>baggageEntry.split("=").map((keyOrValue)=>{
            try {
                return decodeURIComponent(keyOrValue.trim());
            } catch  {
                // We ignore errors here, e.g. if the value cannot be URL decoded.
                // This will then be skipped in the next step
                return;
            }
        })).reduce((acc, [key, value])=>{
        if (key && value) acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $fb4f2d687c5ee56d$export$12a7349a29a6e3c2(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $fb4f2d687c5ee56d$export$bdd844ddb2def819) {
            (0, $b5c0571e433473d8$export$16a28057038b10ef) && (0, $dfad86e498c52aee$export$af88d00dbe7f521).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, "");
}




/** Regular expression used to extract org ID from a DSN host. */ const $0ce64b897229c6e0$var$ORG_ID_REGEX = /^o(\d+)\./;
/** Regular expression used to parse a Dsn. */ const $0ce64b897229c6e0$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $0ce64b897229c6e0$var$isValidProtocol(protocol) {
    return protocol === "http" || protocol === "https";
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function $0ce64b897229c6e0$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ""}` + `@${host}${port ? `:${port}` : ""}/${path ? `${path}/` : path}${projectId}`;
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function $0ce64b897229c6e0$export$b892860177f70a30(str) {
    const match = $0ce64b897229c6e0$var$DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        (0, $dfad86e498c52aee$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return undefined;
    }
    const [protocol, publicKey, pass = "", host = "", port = "", lastPath = ""] = match.slice(1);
    let path = "";
    let projectId = lastPath;
    const split = projectId.split("/");
    if (split.length > 1) {
        path = split.slice(0, -1).join("/");
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $0ce64b897229c6e0$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $0ce64b897229c6e0$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || "",
        pass: components.pass || "",
        host: components.host,
        port: components.port || "",
        path: components.path || "",
        projectId: components.projectId
    };
}
function $0ce64b897229c6e0$var$validateDsn(dsn) {
    if (!(0, $b5c0571e433473d8$export$16a28057038b10ef)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        "protocol",
        "publicKey",
        "host",
        "projectId"
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $dfad86e498c52aee$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $dfad86e498c52aee$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$0ce64b897229c6e0$var$isValidProtocol(protocol)) {
        (0, $dfad86e498c52aee$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $dfad86e498c52aee$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
/**
 * Extract the org ID from a DSN host.
 *
 * @param host The host from a DSN
 * @returns The org ID if found, undefined otherwise
 */ function $0ce64b897229c6e0$export$5914f4e7748c29c9(host) {
    const match = host.match($0ce64b897229c6e0$var$ORG_ID_REGEX);
    return match?.[1];
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function $0ce64b897229c6e0$export$128827c3562ec0cb(from) {
    const components = typeof from === "string" ? $0ce64b897229c6e0$export$b892860177f70a30(from) : $0ce64b897229c6e0$var$dsnFromComponents(from);
    if (!components || !$0ce64b897229c6e0$var$validateDsn(components)) return undefined;
    return components;
}



// Treeshakable guard to remove all code related to tracing
/**
 * Determines if span recording is currently enabled.
 *
 * Spans are recorded when at least one of `tracesSampleRate` and `tracesSampler`
 * is defined in the SDK config. This function does not make any assumption about
 * sampling decisions, it only checks if the SDK is configured to record spans.
 *
 * Important: This function only determines if span recording is enabled. Trace
 * continuation and propagation is separately controlled and not covered by this function.
 * If this function returns `false`, traces can still be propagated (which is what
 * we refer to by "Tracing without Performance")
 * @see https://develop.sentry.dev/sdk/telemetry/traces/tracing-without-performance/
 *
 * @param maybeOptions An SDK options object to be passed to this function.
 * If this option is not provided, the function will use the current client's options.
 */ function $715af054d7b34c54$export$1f70765132c3c225(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === "boolean" && !__SENTRY_TRACING__) return false;
    const options = maybeOptions || (0, $0b98faa1b87c8168$export$6bb76d6eba7e258c)()?.getOptions();
    return !!options && // Note: This check is `!= null`, meaning "nullish". `0` is not "nullish", `undefined` and `null` are. (This comment was brought to you by 15 minutes of questioning life)
    (options.tracesSampleRate != null || !!options.tracesSampler);
}
/**
 * @see JSDoc of `hasSpansEnabled`
 * @deprecated Use `hasSpansEnabled` instead, which is a more accurately named version of this function.
 * This function will be removed in the next major version of the SDK.
 */ // TODO(v10): Remove this export
const $715af054d7b34c54$export$5008da00b1b6dee6 = $715af054d7b34c54$export$1f70765132c3c225;







const $1c91772cf9c3fc39$export$136e25984ba4a383 = 0;
const $1c91772cf9c3fc39$export$58f7963109c806fc = 1;
const $1c91772cf9c3fc39$export$f966a0446ece71e = 2;
/**
 * Converts a HTTP status code into a sentry status with a message.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ // https://develop.sentry.dev/sdk/event-payloads/span/
function $1c91772cf9c3fc39$export$5fd4dc48a2131589(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return {
        code: $1c91772cf9c3fc39$export$58f7963109c806fc
    };
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return {
                code: $1c91772cf9c3fc39$export$f966a0446ece71e,
                message: "unauthenticated"
            };
        case 403:
            return {
                code: $1c91772cf9c3fc39$export$f966a0446ece71e,
                message: "permission_denied"
            };
        case 404:
            return {
                code: $1c91772cf9c3fc39$export$f966a0446ece71e,
                message: "not_found"
            };
        case 409:
            return {
                code: $1c91772cf9c3fc39$export$f966a0446ece71e,
                message: "already_exists"
            };
        case 413:
            return {
                code: $1c91772cf9c3fc39$export$f966a0446ece71e,
                message: "failed_precondition"
            };
        case 429:
            return {
                code: $1c91772cf9c3fc39$export$f966a0446ece71e,
                message: "resource_exhausted"
            };
        case 499:
            return {
                code: $1c91772cf9c3fc39$export$f966a0446ece71e,
                message: "cancelled"
            };
        default:
            return {
                code: $1c91772cf9c3fc39$export$f966a0446ece71e,
                message: "invalid_argument"
            };
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return {
                code: $1c91772cf9c3fc39$export$f966a0446ece71e,
                message: "unimplemented"
            };
        case 503:
            return {
                code: $1c91772cf9c3fc39$export$f966a0446ece71e,
                message: "unavailable"
            };
        case 504:
            return {
                code: $1c91772cf9c3fc39$export$f966a0446ece71e,
                message: "deadline_exceeded"
            };
        default:
            return {
                code: $1c91772cf9c3fc39$export$f966a0446ece71e,
                message: "internal_error"
            };
    }
    return {
        code: $1c91772cf9c3fc39$export$f966a0446ece71e,
        message: "unknown_error"
    };
}
/**
 * Sets the Http status attributes on the current span based on the http code.
 * Additionally, the span's status is updated, depending on the http code.
 */ function $1c91772cf9c3fc39$export$2ad6630ec8164254(span, httpStatus) {
    span.setAttribute("http.response.status_code", httpStatus);
    const spanStatus = $1c91772cf9c3fc39$export$5fd4dc48a2131589(httpStatus);
    if (spanStatus.message !== "unknown_error") span.setStatus(spanStatus);
}



const $7248b389a5580386$var$SCOPE_ON_START_SPAN_FIELD = "_sentryScope";
const $7248b389a5580386$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD = "_sentryIsolationScope";
/** Store the scope & isolation scope for a span, which can the be used when it is finished. */ function $7248b389a5580386$export$cddb4027e3b0dd66(span, scope, isolationScope) {
    if (span) {
        (0, $90379bc90653c4b6$export$e73679ffaf56810e)(span, $7248b389a5580386$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD, isolationScope);
        (0, $90379bc90653c4b6$export$e73679ffaf56810e)(span, $7248b389a5580386$var$SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
/**
 * Grabs the scope and isolation scope off a span that were active when the span was started.
 */ function $7248b389a5580386$export$c08fbc656a245d03(span) {
    return {
        scope: span[$7248b389a5580386$var$SCOPE_ON_START_SPAN_FIELD],
        isolationScope: span[$7248b389a5580386$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD]
    };
}







/**
 * Parse a sample rate from a given value.
 * This will either return a boolean or number sample rate, if the sample rate is valid (between 0 and 1).
 * If a string is passed, we try to convert it to a number.
 *
 * Any invalid sample rate will return `undefined`.
 */ function $7c4c9604e7e6042d$export$a5bd2d81656d9546(sampleRate) {
    if (typeof sampleRate === "boolean") return Number(sampleRate);
    const rate = typeof sampleRate === "string" ? parseFloat(sampleRate) : sampleRate;
    if (typeof rate !== "number" || isNaN(rate) || rate < 0 || rate > 1) return undefined;
    return rate;
}



// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- RegExp is used for readability here
const $e70413ee8cf08e05$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $e70413ee8cf08e05$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return undefined;
    const matches = traceparent.match($e70413ee8cf08e05$export$394a210812ba3012);
    if (!matches) return undefined;
    let parentSampled;
    if (matches[3] === "1") parentSampled = true;
    else if (matches[3] === "0") parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create a propagation context from incoming headers or
 * creates a minimal new one if the headers are undefined.
 */ function $e70413ee8cf08e05$export$261f383d16a93e39(sentryTrace, baggage) {
    const traceparentData = $e70413ee8cf08e05$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $fb4f2d687c5ee56d$export$5b96ee2c8421f107)(baggage);
    if (!traceparentData?.traceId) return {
        traceId: (0, $482848166ffdb9e6$export$dc6d7ea554bcce10)(),
        sampleRand: Math.random()
    };
    const sampleRand = $e70413ee8cf08e05$var$getSampleRandFromTraceparentAndDsc(traceparentData, dynamicSamplingContext);
    // The sample_rand on the DSC needs to be generated based on traceparent + baggage.
    if (dynamicSamplingContext) dynamicSamplingContext.sample_rand = sampleRand.toString();
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData;
    return {
        traceId: traceId,
        parentSpanId: parentSpanId,
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {},
        sampleRand: sampleRand
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function $e70413ee8cf08e05$export$f35d907436da45cf(traceId = (0, $482848166ffdb9e6$export$dc6d7ea554bcce10)(), spanId = (0, $482848166ffdb9e6$export$295213bc4d0c54ad)(), sampled) {
    let sampledString = "";
    if (sampled !== undefined) sampledString = sampled ? "-1" : "-0";
    return `${traceId}-${spanId}${sampledString}`;
}
/**
 * Given any combination of an incoming trace, generate a sample rand based on its defined semantics.
 *
 * Read more: https://develop.sentry.dev/sdk/telemetry/traces/#propagated-random-value
 */ function $e70413ee8cf08e05$var$getSampleRandFromTraceparentAndDsc(traceparentData, dsc) {
    // When there is an incoming sample rand use it.
    const parsedSampleRand = (0, $7c4c9604e7e6042d$export$a5bd2d81656d9546)(dsc?.sample_rand);
    if (parsedSampleRand !== undefined) return parsedSampleRand;
    // Otherwise, if there is an incoming sampling decision + sample rate, generate a sample rand that would lead to the same sampling decision.
    const parsedSampleRate = (0, $7c4c9604e7e6042d$export$a5bd2d81656d9546)(dsc?.sample_rate);
    if (parsedSampleRate && traceparentData?.parentSampled !== undefined) return traceparentData.parentSampled ? Math.random() * parsedSampleRate : parsedSampleRate + Math.random() * (1 - parsedSampleRate);
    else // If nothing applies, return a random sample rand.
    return Math.random();
}



// These are aligned with OpenTelemetry trace flags
const $e89a3331adf677ac$export$208d5b368507fb8b = 0x0;
const $e89a3331adf677ac$export$eb571cd9b5d98de8 = 0x1;
let $e89a3331adf677ac$var$hasShownSpanDropWarning = false;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 * By default, this will only include trace_id, span_id & parent_span_id.
 * If `includeAllData` is true, it will also include data, op, status & origin.
 */ function $e89a3331adf677ac$export$4c3967a8a2f6bbd6(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, origin: origin, links: links } = $e89a3331adf677ac$export$92d8c23565496537(span);
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id,
        data: data,
        op: op,
        status: status,
        origin: origin,
        links: links
    };
}
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in a non-transaction event.
 */ function $e89a3331adf677ac$export$46c6fbd1d265ebf0(span) {
    const { spanId: spanId, traceId: trace_id, isRemote: isRemote } = span.spanContext();
    // If the span is remote, we use a random/virtual span as span_id to the trace context,
    // and the remote span as parent_span_id
    const parent_span_id = isRemote ? spanId : $e89a3331adf677ac$export$92d8c23565496537(span).parent_span_id;
    const scope = (0, $7248b389a5580386$export$c08fbc656a245d03)(span).scope;
    const span_id = isRemote ? scope?.getPropagationContext().propagationSpanId || (0, $482848166ffdb9e6$export$295213bc4d0c54ad)() : spanId;
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id
    };
}
/**
 * Convert a Span to a Sentry trace header.
 */ function $e89a3331adf677ac$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $e89a3331adf677ac$export$5caecac1caaf3a71(span);
    return (0, $e70413ee8cf08e05$export$f35d907436da45cf)(traceId, spanId, sampled);
}
/**
 *  Converts the span links array to a flattened version to be sent within an envelope.
 *
 *  If the links array is empty, it returns `undefined` so the empty value can be dropped before it's sent.
 */ function $e89a3331adf677ac$export$cb3e3a12e0eec16c(links) {
    if (links && links.length > 0) return links.map(({ context: { spanId: spanId, traceId: traceId, traceFlags: traceFlags, ...restContext }, attributes: attributes })=>({
            span_id: spanId,
            trace_id: traceId,
            sampled: traceFlags === $e89a3331adf677ac$export$eb571cd9b5d98de8,
            attributes: attributes,
            ...restContext
        }));
    else return undefined;
}
/**
 * Convert a span time input into a timestamp in seconds.
 */ function $e89a3331adf677ac$export$3f7581298f56c6d7(input) {
    if (typeof input === "number") return $e89a3331adf677ac$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $e89a3331adf677ac$var$ensureTimestampInSeconds(input.getTime());
    return (0, $14ccb306f78f15b4$export$ee52dced521e3e18)();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function $e89a3331adf677ac$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 */ // Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
// This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
// And `spanToJSON` needs the Span class from `span.ts` to check here.
function $e89a3331adf677ac$export$92d8c23565496537(span) {
    if ($e89a3331adf677ac$var$spanIsSentrySpan(span)) return span.getSpanJSON();
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    // Handle a span from @opentelemetry/sdk-base-trace's `Span` class
    if ($e89a3331adf677ac$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
        const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, status: status, links: links } = span;
        // In preparation for the next major of OpenTelemetry, we want to support
        // looking up the parent span id according to the new API
        // In OTel v1, the parent span id is accessed as `parentSpanId`
        // In OTel v2, the parent span id is accessed as `spanId` on the `parentSpanContext`
        const parentSpanId = "parentSpanId" in span ? span.parentSpanId : "parentSpanContext" in span ? span.parentSpanContext?.spanId : undefined;
        return {
            span_id: span_id,
            trace_id: trace_id,
            data: attributes,
            description: name,
            parent_span_id: parentSpanId,
            start_timestamp: $e89a3331adf677ac$export$3f7581298f56c6d7(startTime),
            // This is [0,0] by default in OTEL, in which case we want to interpret this as no end time
            timestamp: $e89a3331adf677ac$export$3f7581298f56c6d7(endTime) || undefined,
            status: $e89a3331adf677ac$export$e238a77ea3a8cd66(status),
            op: attributes[0, $34e3132ced11beec$export$1a413bd9a88fdb09],
            origin: attributes[0, $34e3132ced11beec$export$cca8dd30f57f805e],
            links: $e89a3331adf677ac$export$cb3e3a12e0eec16c(links)
        };
    }
    // Finally, at least we have `spanContext()`....
    // This should not actually happen in reality, but we need to handle it for type safety.
    return {
        span_id: span_id,
        trace_id: trace_id,
        start_timestamp: 0,
        data: {}
    };
}
function $e89a3331adf677ac$var$spanIsOpenTelemetrySdkTraceBaseSpan(span) {
    const castSpan = span;
    return !!castSpan.attributes && !!castSpan.startTime && !!castSpan.name && !!castSpan.endTime && !!castSpan.status;
}
/** Exported only for tests. */ /**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function $e89a3331adf677ac$var$spanIsSentrySpan(span) {
    return typeof span.getSpanJSON === "function";
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function $e89a3331adf677ac$export$5caecac1caaf3a71(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    const { traceFlags: traceFlags } = span.spanContext();
    return traceFlags === $e89a3331adf677ac$export$eb571cd9b5d98de8;
}
/** Get the status message to use for a JSON representation of a span. */ function $e89a3331adf677ac$export$e238a77ea3a8cd66(status) {
    if (!status || status.code === (0, $1c91772cf9c3fc39$export$136e25984ba4a383)) return undefined;
    if (status.code === (0, $1c91772cf9c3fc39$export$58f7963109c806fc)) return "ok";
    return status.message || "unknown_error";
}
const $e89a3331adf677ac$var$CHILD_SPANS_FIELD = "_sentryChildSpans";
const $e89a3331adf677ac$var$ROOT_SPAN_FIELD = "_sentryRootSpan";
/**
 * Adds an opaque child span reference to a span.
 */ function $e89a3331adf677ac$export$81397d924722cc65(span, childSpan) {
    // We store the root span reference on the child span
    // We need this for `getRootSpan()` to work
    const rootSpan = span[$e89a3331adf677ac$var$ROOT_SPAN_FIELD] || span;
    (0, $90379bc90653c4b6$export$e73679ffaf56810e)(childSpan, $e89a3331adf677ac$var$ROOT_SPAN_FIELD, rootSpan);
    // We store a list of child spans on the parent span
    // We need this for `getSpanDescendants()` to work
    if (span[$e89a3331adf677ac$var$CHILD_SPANS_FIELD]) span[$e89a3331adf677ac$var$CHILD_SPANS_FIELD].add(childSpan);
    else (0, $90379bc90653c4b6$export$e73679ffaf56810e)(span, $e89a3331adf677ac$var$CHILD_SPANS_FIELD, new Set([
        childSpan
    ]));
}
/** This is only used internally by Idle Spans. */ function $e89a3331adf677ac$export$c2a0c9438bb89d91(span, childSpan) {
    if (span[$e89a3331adf677ac$var$CHILD_SPANS_FIELD]) span[$e89a3331adf677ac$var$CHILD_SPANS_FIELD].delete(childSpan);
}
/**
 * Returns an array of the given span and all of its descendants.
 */ function $e89a3331adf677ac$export$340c5c8a13ffc680(span) {
    const resultSet = new Set();
    function addSpanChildren(span) {
        // This exit condition is required to not infinitely loop in case of a circular dependency.
        if (resultSet.has(span)) return;
        else if ($e89a3331adf677ac$export$5caecac1caaf3a71(span)) {
            resultSet.add(span);
            const childSpans = span[$e89a3331adf677ac$var$CHILD_SPANS_FIELD] ? Array.from(span[$e89a3331adf677ac$var$CHILD_SPANS_FIELD]) : [];
            for (const childSpan of childSpans)addSpanChildren(childSpan);
        }
    }
    addSpanChildren(span);
    return Array.from(resultSet);
}
/**
 * Returns the root span of a given span.
 */ function $e89a3331adf677ac$export$c4c6a79b1260ca1b(span) {
    return span[$e89a3331adf677ac$var$ROOT_SPAN_FIELD] || span;
}
/**
 * Returns the currently active span.
 */ function $e89a3331adf677ac$export$1be426a8e585c83e() {
    const carrier = (0, $abd13f64e43ff217$export$19eade501500c6c1)();
    const acs = (0, $eb2688584caaa46c$export$f639b0c2752203be)(carrier);
    if (acs.getActiveSpan) return acs.getActiveSpan();
    return (0, $946deb57ecfb47b9$export$91f063ebb8eff307)((0, $0b98faa1b87c8168$export$c7be4b0125a10cba)());
}
/**
 * Logs a warning once if `beforeSendSpan` is used to drop spans.
 */ function $e89a3331adf677ac$export$d11691ff45a3e535() {
    if (!$e89a3331adf677ac$var$hasShownSpanDropWarning) {
        (0, $dfad86e498c52aee$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.warn("[Sentry] Returning null from `beforeSendSpan` is disallowed. To drop certain spans, configure the respective integrations directly.");
        });
        $e89a3331adf677ac$var$hasShownSpanDropWarning = true;
    }
}
/**
 * Updates the name of the given span and ensures that the span name is not
 * overwritten by the Sentry SDK.
 *
 * Use this function instead of `span.updateName()` if you want to make sure that
 * your name is kept. For some spans, for example root `http.server` spans the
 * Sentry SDK would otherwise overwrite the span name with a high-quality name
 * it infers when the span ends.
 *
 * Use this function in server code or when your span is started on the server
 * and on the client (browser). If you only update a span name on the client,
 * you can also use `span.updateName()` the SDK does not overwrite the name.
 *
 * @param span - The span to update the name of.
 * @param name - The name to set on the span.
 */ function $e89a3331adf677ac$export$5b72d3169c1be715(span, name) {
    span.updateName(name);
    span.setAttributes({
        [(0, $34e3132ced11beec$export$d7a7d984b0791405)]: "custom",
        [(0, $34e3132ced11beec$export$165ce9a229f6f050)]: name
    });
}



/**
 * If you change this value, also update the terser plugin config to
 * avoid minification of the object property!
 */ const $d001bfa1cb8b2131$var$FROZEN_DSC_FIELD = "_frozenDsc";
/**
 * Freeze the given DSC on the given span.
 */ function $d001bfa1cb8b2131$export$7398c93e763ca9fd(span, dsc) {
    const spanWithMaybeDsc = span;
    (0, $90379bc90653c4b6$export$e73679ffaf56810e)(spanWithMaybeDsc, $d001bfa1cb8b2131$var$FROZEN_DSC_FIELD, dsc);
}
/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function $d001bfa1cb8b2131$export$366bad00d6815eed(trace_id, client) {
    const options = client.getOptions();
    const { publicKey: public_key, host: host } = client.getDsn() || {};
    let org_id;
    if (options.orgId) org_id = String(options.orgId);
    else if (host) org_id = (0, $0ce64b897229c6e0$export$5914f4e7748c29c9)(host);
    // Instead of conditionally adding non-undefined values, we add them and then remove them if needed
    // otherwise, the order of baggage entries changes, which "breaks" a bunch of tests etc.
    const dsc = {
        environment: options.environment || (0, $4d1ecfae9e70d95f$export$849dbeeeda01ae98),
        release: options.release,
        public_key: public_key,
        trace_id: trace_id,
        org_id: org_id
    };
    client.emit("createDsc", dsc);
    return dsc;
}
/**
 * Get the dynamic sampling context for the currently active scopes.
 */ function $d001bfa1cb8b2131$export$89ef1736f08c6b2b(client, scope) {
    const propagationContext = scope.getPropagationContext();
    return propagationContext.dsc || $d001bfa1cb8b2131$export$366bad00d6815eed(propagationContext.traceId, client);
}
/**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function $d001bfa1cb8b2131$export$a117f995597e25df(span) {
    const client = (0, $0b98faa1b87c8168$export$6bb76d6eba7e258c)();
    if (!client) return {};
    const rootSpan = (0, $e89a3331adf677ac$export$c4c6a79b1260ca1b)(span);
    const rootSpanJson = (0, $e89a3331adf677ac$export$92d8c23565496537)(rootSpan);
    const rootSpanAttributes = rootSpanJson.data;
    const traceState = rootSpan.spanContext().traceState;
    // The span sample rate that was locally applied to the root span should also always be applied to the DSC, even if the DSC is frozen.
    // This is so that the downstream traces/services can use parentSampleRate in their `tracesSampler` to make consistent sampling decisions across the entire trace.
    const rootSpanSampleRate = traceState?.get("sentry.sample_rate") ?? rootSpanAttributes[0, $34e3132ced11beec$export$ccfe0a40627cc34b] ?? rootSpanAttributes[0, $34e3132ced11beec$export$889fb736668e1ecc];
    function applyLocalSampleRateToDsc(dsc) {
        if (typeof rootSpanSampleRate === "number" || typeof rootSpanSampleRate === "string") dsc.sample_rate = `${rootSpanSampleRate}`;
        return dsc;
    }
    // For core implementation, we freeze the DSC onto the span as a non-enumerable property
    const frozenDsc = rootSpan[$d001bfa1cb8b2131$var$FROZEN_DSC_FIELD];
    if (frozenDsc) return applyLocalSampleRateToDsc(frozenDsc);
    // For OpenTelemetry, we freeze the DSC on the trace state
    const traceStateDsc = traceState?.get("sentry.dsc");
    // If the span has a DSC, we want it to take precedence
    const dscOnTraceState = traceStateDsc && (0, $fb4f2d687c5ee56d$export$5b96ee2c8421f107)(traceStateDsc);
    if (dscOnTraceState) return applyLocalSampleRateToDsc(dscOnTraceState);
    // Else, we generate it from the span
    const dsc = $d001bfa1cb8b2131$export$366bad00d6815eed(span.spanContext().traceId, client);
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    const source = rootSpanAttributes[0, $34e3132ced11beec$export$d7a7d984b0791405];
    // after JSON conversion, txn.name becomes jsonSpan.description
    const name = rootSpanJson.description;
    if (source !== "url" && name) dsc.transaction = name;
    // How can we even land here with hasSpansEnabled() returning false?
    // Otel creates a Non-recording span in Tracing Without Performance mode when handling incoming requests
    // So we end up with an active span that is not sampled (neither positively nor negatively)
    if ((0, $715af054d7b34c54$export$1f70765132c3c225)()) {
        dsc.sampled = String((0, $e89a3331adf677ac$export$5caecac1caaf3a71)(rootSpan));
        dsc.sample_rand = // In OTEL we store the sample rand on the trace state because we cannot access scopes for NonRecordingSpans
        // The Sentry OTEL SpanSampler takes care of writing the sample rand on the root span
        traceState?.get("sentry.sample_rand") ?? // On all other platforms we can actually get the scopes from a root span (we use this as a fallback)
        (0, $7248b389a5580386$export$c08fbc656a245d03)(rootSpan).scope?.getPropagationContext().sampleRand.toString();
    }
    applyLocalSampleRateToDsc(dsc);
    client.emit("createDsc", dsc, rootSpan);
    return dsc;
}
/**
 * Convert a Span to a baggage header.
 */ function $d001bfa1cb8b2131$export$95cf936fdacaff7b(span) {
    const dsc = $d001bfa1cb8b2131$export$a117f995597e25df(span);
    return (0, $fb4f2d687c5ee56d$export$56766feef403f365)(dsc);
}




/**
 * Applies data from the scope to the event and runs all event processors on it.
 */ function $6374289555580b98$export$43988bc651a80216(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    // Apply general data
    $6374289555580b98$var$applyDataToEvent(event, data);
    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (span) $6374289555580b98$var$applySpanToEvent(event, span);
    $6374289555580b98$var$applyFingerprintToEvent(event, fingerprint);
    $6374289555580b98$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $6374289555580b98$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
/** Merge data of two scopes together. */ function $6374289555580b98$export$25ac7e259a513db4(data, mergeData) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: transactionName, span: span } = mergeData;
    $6374289555580b98$export$b1a120a2871faa46(data, "extra", extra);
    $6374289555580b98$export$b1a120a2871faa46(data, "tags", tags);
    $6374289555580b98$export$b1a120a2871faa46(data, "user", user);
    $6374289555580b98$export$b1a120a2871faa46(data, "contexts", contexts);
    data.sdkProcessingMetadata = (0, $b431b21a01204225$export$4950aa0f605343fb)(data.sdkProcessingMetadata, sdkProcessingMetadata, 2);
    if (level) data.level = level;
    if (transactionName) data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = {
        ...data.propagationContext,
        ...propagationContext
    };
}
/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */ function $6374289555580b98$export$b1a120a2871faa46(data, prop, mergeVal) {
    data[prop] = (0, $b431b21a01204225$export$4950aa0f605343fb)(data[prop], mergeVal, 1);
}
function $6374289555580b98$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: transactionName } = data;
    if (Object.keys(extra).length) event.extra = {
        ...extra,
        ...event.extra
    };
    if (Object.keys(tags).length) event.tags = {
        ...tags,
        ...event.tags
    };
    if (Object.keys(user).length) event.user = {
        ...user,
        ...event.user
    };
    if (Object.keys(contexts).length) event.contexts = {
        ...contexts,
        ...event.contexts
    };
    if (level) event.level = level;
    // transaction events get their `transaction` from the root span name
    if (transactionName && event.type !== "transaction") event.transaction = transactionName;
}
function $6374289555580b98$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}
function $6374289555580b98$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        ...sdkProcessingMetadata
    };
}
function $6374289555580b98$var$applySpanToEvent(event, span) {
    event.contexts = {
        trace: (0, $e89a3331adf677ac$export$46c6fbd1d265ebf0)(span),
        ...event.contexts
    };
    event.sdkProcessingMetadata = {
        dynamicSamplingContext: (0, $d001bfa1cb8b2131$export$a117f995597e25df)(span),
        ...event.sdkProcessingMetadata
    };
    const rootSpan = (0, $e89a3331adf677ac$export$c4c6a79b1260ca1b)(span);
    const transactionName = (0, $e89a3331adf677ac$export$92d8c23565496537)(rootSpan).description;
    if (transactionName && !event.transaction && event.type === "transaction") event.transaction = transactionName;
}
/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */ function $6374289555580b98$var$applyFingerprintToEvent(event, fingerprint) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? Array.isArray(event.fingerprint) ? event.fingerprint : [
        event.fingerprint
    ] : [];
    // If we have something on the scope, then merge it with event
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    // If we have no data at all, remove empty array default
    if (!event.fingerprint.length) delete event.fingerprint;
}



let $22e79d0b6f95266a$var$parsedStackResults;
let $22e79d0b6f95266a$var$lastKeysCount;
let $22e79d0b6f95266a$var$cachedFilenameDebugIds;
/**
 * Returns a map of filenames to debug identifiers.
 */ function $22e79d0b6f95266a$export$e069fee9c632ed00(stackParser) {
    const debugIdMap = (0, $88208d9e04627397$export$f1a6cdb1459e81d1)._sentryDebugIds;
    if (!debugIdMap) return {};
    const debugIdKeys = Object.keys(debugIdMap);
    // If the count of registered globals hasn't changed since the last call, we
    // can just return the cached result.
    if ($22e79d0b6f95266a$var$cachedFilenameDebugIds && debugIdKeys.length === $22e79d0b6f95266a$var$lastKeysCount) return $22e79d0b6f95266a$var$cachedFilenameDebugIds;
    $22e79d0b6f95266a$var$lastKeysCount = debugIdKeys.length;
    // Build a map of filename -> debug_id.
    $22e79d0b6f95266a$var$cachedFilenameDebugIds = debugIdKeys.reduce((acc, stackKey)=>{
        if (!$22e79d0b6f95266a$var$parsedStackResults) $22e79d0b6f95266a$var$parsedStackResults = {};
        const result = $22e79d0b6f95266a$var$parsedStackResults[stackKey];
        if (result) acc[result[0]] = result[1];
        else {
            const parsedStack = stackParser(stackKey);
            for(let i = parsedStack.length - 1; i >= 0; i--){
                const stackFrame = parsedStack[i];
                const filename = stackFrame?.filename;
                const debugId = debugIdMap[stackKey];
                if (filename && debugId) {
                    acc[filename] = debugId;
                    $22e79d0b6f95266a$var$parsedStackResults[stackKey] = [
                        filename,
                        debugId
                    ];
                    break;
                }
            }
        }
        return acc;
    }, {});
    return $22e79d0b6f95266a$var$cachedFilenameDebugIds;
}
/**
 * Returns a list of debug images for the given resources.
 */ function $22e79d0b6f95266a$export$5a7368330d9ee6e3(stackParser, resource_paths) {
    const filenameDebugIdMap = $22e79d0b6f95266a$export$e069fee9c632ed00(stackParser);
    if (!filenameDebugIdMap) return [];
    const images = [];
    for (const path of resource_paths)if (path && filenameDebugIdMap[path]) images.push({
        type: "sourcemap",
        code_file: path,
        debug_id: filenameDebugIdMap[path]
    });
    return images;
}





const $ed9a0f1a0a69d190$var$STACKTRACE_FRAME_LIMIT = 50;
const $ed9a0f1a0a69d190$export$27c7e15d453fc0ac = "?";
// Used to sanitize webpack (error: *) wrapped stack errors
const $ed9a0f1a0a69d190$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $ed9a0f1a0a69d190$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $ed9a0f1a0a69d190$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirstLines = 0, framesToPop = 0)=>{
        const frames = [];
        const lines = stack.split("\n");
        for(let i = skipFirstLines; i < lines.length; i++){
            const line = lines[i];
            // Ignore lines over 1kb as they are unlikely to be stack frames.
            // Many of the regular expressions use backtracking which results in run time that increases exponentially with
            // input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) continue;
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $ed9a0f1a0a69d190$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($ed9a0f1a0a69d190$var$WEBPACK_ERROR_REGEXP, "$1") : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $ed9a0f1a0a69d190$var$STACKTRACE_FRAME_LIMIT + framesToPop) break;
        }
        return $ed9a0f1a0a69d190$export$c55c24c0eeba0205(frames.slice(framesToPop));
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $ed9a0f1a0a69d190$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $ed9a0f1a0a69d190$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $ed9a0f1a0a69d190$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test($ed9a0f1a0a69d190$var$getLastStackFrame(localStack).function || "")) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($ed9a0f1a0a69d190$var$STRIP_FRAME_REGEXP.test($ed9a0f1a0a69d190$var$getLastStackFrame(localStack).function || "")) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the scope itself, making it:
        //
        //   Sentry.captureException()
        //   scope.captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($ed9a0f1a0a69d190$var$STRIP_FRAME_REGEXP.test($ed9a0f1a0a69d190$var$getLastStackFrame(localStack).function || "")) localStack.pop();
    }
    return localStack.slice(0, $ed9a0f1a0a69d190$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || $ed9a0f1a0a69d190$var$getLastStackFrame(localStack).filename,
            function: frame.function || $ed9a0f1a0a69d190$export$27c7e15d453fc0ac
        }));
}
function $ed9a0f1a0a69d190$var$getLastStackFrame(arr) {
    return arr[arr.length - 1] || {};
}
const $ed9a0f1a0a69d190$var$defaultFunctionName = "<anonymous>";
/**
 * Safely extract function name from itself
 */ function $ed9a0f1a0a69d190$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== "function") return $ed9a0f1a0a69d190$var$defaultFunctionName;
        return fn.name || $ed9a0f1a0a69d190$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $ed9a0f1a0a69d190$var$defaultFunctionName;
    }
}
/**
 * Get's stack frames from an event without needing to check for undefined properties.
 */ function $ed9a0f1a0a69d190$export$91d8ca51bd9f6a47(event) {
    const exception = event.exception;
    if (exception) {
        const frames = [];
        try {
            // @ts-expect-error Object could be undefined
            exception.values.forEach((value)=>{
                // @ts-expect-error Value could be undefined
                if (value.stacktrace.frames) // @ts-expect-error Value could be undefined
                frames.push(...value.stacktrace.frames);
            });
            return frames;
        } catch (_oO) {
            return undefined;
        }
    }
    return undefined;
}


/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normalized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $3878df912d4376ee$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $3878df912d4376ee$var$visit("", input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $3878df912d4376ee$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $3878df912d4376ee$export$a3295358bff77e(object, depth);
    if ($3878df912d4376ee$var$jsonSize(normalized) > maxSize) return $3878df912d4376ee$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $3878df912d4376ee$var$visit(key, value, depth = Infinity, maxProperties = Infinity, memo = $3878df912d4376ee$var$memoBuilder()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        "boolean",
        "string"
    ].includes(typeof value) || typeof value === "number" && Number.isFinite(value)) return value;
    const stringified = $3878df912d4376ee$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith("[object ")) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value["__sentry_skip_normalization__"]) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    const remainingDepth = typeof value["__sentry_override_normalization_depth__"] === "number" ? value["__sentry_override_normalization_depth__"] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace("object ", "");
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return "[Circular ~]";
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === "function") try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $3878df912d4376ee$var$visit("", jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, $90379bc90653c4b6$export$62ff257738bf57f5)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = "[MaxProperties ~]";
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $3878df912d4376ee$var$visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $3878df912d4376ee$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === "domain" && value && typeof value === "object" && value._events) return "[Domain]";
        if (key === "domainEmitter") return "[DomainEmitter]";
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== "undefined" && value === $parcel$global) return "[Global]";
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== "undefined" && value === window) return "[Window]";
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== "undefined" && value === document) return "[Document]";
        if ((0, $ed5cb73b8752546d$export$7916fad0ebc23f48)(value)) return "[VueViewModel]";
        // React's SyntheticEvent thingy
        if ((0, $ed5cb73b8752546d$export$bc2894c7158efbac)(value)) return "[SyntheticEvent]";
        if (typeof value === "number" && !Number.isFinite(value)) return `[${value}]`;
        if (typeof value === "function") return `[Function: ${(0, $ed9a0f1a0a69d190$export$aad197c7121a6651)(value)}]`;
        if (typeof value === "symbol") return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === "bigint") return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        const objName = $3878df912d4376ee$var$getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function $3878df912d4376ee$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype?.constructor ? prototype.constructor.name : "null prototype";
}
/** Calculates bytes size of input string */ function $3878df912d4376ee$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $3878df912d4376ee$var$jsonSize(value) {
    return $3878df912d4376ee$var$utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function $3878df912d4376ee$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath// Backslash to forward
    .replace(/\\/g, "/")// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, "\\$&");
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch (_Oo) {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, "/").replace(/webpack:\/?/g, "") // Remove intermediate base path
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor
    .replace(new RegExp(`(file://)?/*${escapedBase}/*`, "ig"), "app:///");
}
/**
 * Helper to decycle json objects
 */ function $3878df912d4376ee$var$memoBuilder() {
    const inner = new WeakSet();
    function memoize(obj) {
        if (inner.has(obj)) return true;
        inner.add(obj);
        return false;
    }
    function unmemoize(obj) {
        inner.delete(obj);
    }
    return [
        memoize,
        unmemoize
    ];
}




/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */ /**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function $f9704539615075ff$export$2d67fb380bd11267(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || (0, $c65fa882a3254127$export$19f53698e68b2496)(),
        timestamp: event.timestamp || (0, $14ccb306f78f15b4$export$7740643b9eeaf0c4)()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $f9704539615075ff$export$d7e04067a6fbc882(prepared, options);
    $f9704539615075ff$var$applyIntegrationsMetadata(prepared, integrations);
    if (client) client.emit("applyFrameMetadata", event);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) $f9704539615075ff$export$63042efc86f043e7(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    const finalScope = $f9704539615075ff$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) (0, $c65fa882a3254127$export$c69a9a0313b03bb1)(prepared, hint.mechanism);
    const clientEventProcessors = client ? client.getEventProcessors() : [];
    // This should be the last thing called, since we want that
    // {@link Scope.addEventProcessor} gets the finished prepared event.
    // Merge scope data together
    const data = (0, $0b98faa1b87c8168$export$aa55d5ab8e05984f)().getScopeData();
    if (isolationScope) {
        const isolationData = isolationScope.getScopeData();
        (0, $6374289555580b98$export$25ac7e259a513db4)(data, isolationData);
    }
    if (finalScope) {
        const finalScopeData = finalScope.getScopeData();
        (0, $6374289555580b98$export$25ac7e259a513db4)(data, finalScopeData);
    }
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    (0, $6374289555580b98$export$43988bc651a80216)(prepared, data);
    const eventProcessors = [
        ...clientEventProcessors,
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    const result = (0, $0f691e97ff786670$export$bf2a096c3e883e79)(eventProcessors, prepared, hint);
    return result.then((evt)=>{
        if (evt) // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
        // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
        // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
        // any new data
        $f9704539615075ff$export$1be657ba8ef44ff0(evt);
        if (typeof normalizeDepth === "number" && normalizeDepth > 0) return $f9704539615075ff$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 * Enhances event using the client configuration.
 * It takes care of all "static" values like environment, release and `dist`,
 * as well as truncating overly long values.
 *
 * Only exported for tests.
 *
 * @param event event instance to be enhanced
 */ function $f9704539615075ff$export$d7e04067a6fbc882(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength = 250 } = options;
    // empty strings do not make sense for environment, release, and dist
    // so we handle them the same as if they were not provided
    event.environment = event.environment || environment || (0, $4d1ecfae9e70d95f$export$849dbeeeda01ae98);
    if (!event.release && release) event.release = release;
    if (!event.dist && dist) event.dist = dist;
    const request = event.request;
    if (request?.url) request.url = (0, $79b6b3761a352021$export$6a506b36fdea397d)(request.url, maxValueLength);
}
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function $f9704539615075ff$export$63042efc86f043e7(event, stackParser) {
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = (0, $22e79d0b6f95266a$export$e069fee9c632ed00)(stackParser);
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
        });
    });
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function $f9704539615075ff$export$1be657ba8ef44ff0(event) {
    // Extract debug IDs and filenames from the stack frames on the event.
    const filenameDebugIdMap = {};
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            if (frame.debug_id) {
                if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                delete frame.debug_id;
            }
        });
    });
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.entries(filenameDebugIdMap).forEach(([filename, debug_id])=>{
        images.push({
            type: "sourcemap",
            code_file: filename,
            debug_id: debug_id
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function $f9704539615075ff$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function $f9704539615075ff$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: (0, $3878df912d4376ee$export$a3295358bff77e)(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: (0, $3878df912d4376ee$export$a3295358bff77e)(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: (0, $3878df912d4376ee$export$a3295358bff77e)(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: (0, $3878df912d4376ee$export$a3295358bff77e)(event.extra, depth, maxBreadth)
        }
    };
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts?.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $3878df912d4376ee$export$a3295358bff77e)(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        return {
            ...span,
            ...span.data && {
                data: (0, $3878df912d4376ee$export$a3295358bff77e)(span.data, depth, maxBreadth)
            }
        };
    });
    // event.contexts.flags (FeatureFlagContext) stores context for our feature
    // flag integrations. It has a greater nesting depth than our other typed
    // Contexts, so we re-normalize with a fixed depth of 3 here. We do not want
    // to skip this in case of conflicting, user-provided context.
    if (event.contexts?.flags && normalized.contexts) normalized.contexts.flags = (0, $3878df912d4376ee$export$a3295358bff77e)(event.contexts.flags, 3, maxBreadth);
    return normalized;
}
function $f9704539615075ff$var$getFinalScope(scope, captureContext) {
    if (!captureContext) return scope;
    const finalScope = scope ? scope.clone() : new (0, $74a314e82a93236a$export$775b6bb06e53a214)();
    finalScope.update(captureContext);
    return finalScope;
}
/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */ function $f9704539615075ff$export$76b5f966996d1653(hint) {
    if (!hint) return undefined;
    // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
    if ($f9704539615075ff$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($f9704539615075ff$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $f9704539615075ff$var$hintIsScopeOrFunction(hint) {
    return hint instanceof (0, $74a314e82a93236a$export$775b6bb06e53a214) || typeof hint === "function";
}
const $f9704539615075ff$var$captureContextKeys = [
    "user",
    "level",
    "extra",
    "contexts",
    "tags",
    "fingerprint",
    "propagationContext"
];
function $f9704539615075ff$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$f9704539615075ff$var$captureContextKeys.includes(key));
}




/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $584cdb98c6222991$export$f5282963edea4a68(exception, hint) {
    return (0, $0b98faa1b87c8168$export$c7be4b0125a10cba)().captureException(exception, (0, $f9704539615075ff$export$76b5f966996d1653)(hint));
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param message The message to send to Sentry.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */ function $584cdb98c6222991$export$45654777c133ae80(message, captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    const level = typeof captureContext === "string" ? captureContext : undefined;
    const context = typeof captureContext !== "string" ? {
        captureContext: captureContext
    } : undefined;
    return (0, $0b98faa1b87c8168$export$c7be4b0125a10cba)().captureMessage(message, level, context);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param event The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */ function $584cdb98c6222991$export$1462b974fdcf6ba2(event, hint) {
    return (0, $0b98faa1b87c8168$export$c7be4b0125a10cba)().captureEvent(event, hint);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ function $584cdb98c6222991$export$2f04de43fe27971a(name, context) {
    (0, $0b98faa1b87c8168$export$68f3af03034c9e90)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ function $584cdb98c6222991$export$bb4922da0dd51b92(extras) {
    (0, $0b98faa1b87c8168$export$68f3af03034c9e90)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ function $584cdb98c6222991$export$8e8e7789d42ed61d(key, extra) {
    (0, $0b98faa1b87c8168$export$68f3af03034c9e90)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ function $584cdb98c6222991$export$74a8fb34822092e6(tags) {
    (0, $0b98faa1b87c8168$export$68f3af03034c9e90)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ function $584cdb98c6222991$export$a37d07ee78eb4569(key, value) {
    (0, $0b98faa1b87c8168$export$68f3af03034c9e90)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ function $584cdb98c6222991$export$8b6bb3dd62a01be2(user) {
    (0, $0b98faa1b87c8168$export$68f3af03034c9e90)().setUser(user);
}
/**
 * The last error event id of the isolation scope.
 *
 * Warning: This function really returns the last recorded error event id on the current
 * isolation scope. If you call this function after handling a certain error and another error
 * is captured in between, the last one is returned instead of the one you might expect.
 * Also, ids of events that were never sent to Sentry (for example because
 * they were dropped in `beforeSend`) could be returned.
 *
 * @returns The last event id of the isolation scope.
 */ function $584cdb98c6222991$export$5d4e9fd7fac8e617() {
    return (0, $0b98faa1b87c8168$export$68f3af03034c9e90)().lastEventId();
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $584cdb98c6222991$export$413528111fbc67c(checkIn, upsertMonitorConfig) {
    const scope = (0, $0b98faa1b87c8168$export$c7be4b0125a10cba)();
    const client = (0, $0b98faa1b87c8168$export$6bb76d6eba7e258c)();
    if (!client) (0, $b5c0571e433473d8$export$16a28057038b10ef) && (0, $dfad86e498c52aee$export$af88d00dbe7f521).warn("Cannot capture check-in. No client defined.");
    else if (!client.captureCheckIn) (0, $b5c0571e433473d8$export$16a28057038b10ef) && (0, $dfad86e498c52aee$export$af88d00dbe7f521).warn("Cannot capture check-in. Client does not support sending check-ins.");
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, $c65fa882a3254127$export$19f53698e68b2496)();
}
/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $584cdb98c6222991$export$553526fc5f03c0b1(monitorSlug, callback, upsertMonitorConfig) {
    const checkInId = $584cdb98c6222991$export$413528111fbc67c({
        monitorSlug: monitorSlug,
        status: "in_progress"
    }, upsertMonitorConfig);
    const now = (0, $14ccb306f78f15b4$export$ee52dced521e3e18)();
    function finishCheckIn(status) {
        $584cdb98c6222991$export$413528111fbc67c({
            monitorSlug: monitorSlug,
            status: status,
            checkInId: checkInId,
            duration: (0, $14ccb306f78f15b4$export$ee52dced521e3e18)() - now
        });
    }
    return (0, $0b98faa1b87c8168$export$9a4fed82c350c2bd)(()=>{
        let maybePromiseResult;
        try {
            maybePromiseResult = callback();
        } catch (e) {
            finishCheckIn("error");
            throw e;
        }
        if ((0, $ed5cb73b8752546d$export$f5b060c2914b97c8)(maybePromiseResult)) Promise.resolve(maybePromiseResult).then(()=>{
            finishCheckIn("ok");
        }, (e)=>{
            finishCheckIn("error");
            throw e;
        });
        else finishCheckIn("ok");
        return maybePromiseResult;
    });
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $584cdb98c6222991$export$4909b86c8034bf73(timeout) {
    const client = (0, $0b98faa1b87c8168$export$6bb76d6eba7e258c)();
    if (client) return client.flush(timeout);
    (0, $b5c0571e433473d8$export$16a28057038b10ef) && (0, $dfad86e498c52aee$export$af88d00dbe7f521).warn("Cannot flush events. No client defined.");
    return Promise.resolve(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $584cdb98c6222991$export$8360e631d277ea4d(timeout) {
    const client = (0, $0b98faa1b87c8168$export$6bb76d6eba7e258c)();
    if (client) return client.close(timeout);
    (0, $b5c0571e433473d8$export$16a28057038b10ef) && (0, $dfad86e498c52aee$export$af88d00dbe7f521).warn("Cannot flush events and disable SDK. No client defined.");
    return Promise.resolve(false);
}
/**
 * Returns true if Sentry has been properly initialized.
 */ function $584cdb98c6222991$export$3f95c6f800b78024() {
    return !!(0, $0b98faa1b87c8168$export$6bb76d6eba7e258c)();
}
/** If the SDK is initialized & enabled. */ function $584cdb98c6222991$export$3b029eb57ac4d562() {
    const client = (0, $0b98faa1b87c8168$export$6bb76d6eba7e258c)();
    return client?.getOptions().enabled !== false && !!client?.getTransport();
}
/**
 * Add an event processor.
 * This will be added to the current isolation scope, ensuring any event that is processed in the current execution
 * context will have the processor applied.
 */ function $584cdb98c6222991$export$9aac0b9f77928fbf(callback) {
    (0, $0b98faa1b87c8168$export$68f3af03034c9e90)().addEventProcessor(callback);
}
/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */ function $584cdb98c6222991$export$c0d84948cecf78d8(context) {
    const isolationScope = (0, $0b98faa1b87c8168$export$68f3af03034c9e90)();
    const currentScope = (0, $0b98faa1b87c8168$export$c7be4b0125a10cba)();
    // Will fetch userAgent if called from browser sdk
    const { userAgent: userAgent } = (0, $88208d9e04627397$export$f1a6cdb1459e81d1).navigator || {};
    const session = (0, $1336536f7ff10af9$export$14a186326edbb264)({
        user: currentScope.getUser() || isolationScope.getUser(),
        ...userAgent && {
            userAgent: userAgent
        },
        ...context
    });
    // End existing session if there's one
    const currentSession = isolationScope.getSession();
    if (currentSession?.status === "ok") (0, $1336536f7ff10af9$export$531818e825e774db)(currentSession, {
        status: "exited"
    });
    $584cdb98c6222991$export$17a5be43989a0bc1();
    // Afterwards we set the new session on the scope
    isolationScope.setSession(session);
    return session;
}
/**
 * End the session on the current isolation scope.
 */ function $584cdb98c6222991$export$17a5be43989a0bc1() {
    const isolationScope = (0, $0b98faa1b87c8168$export$68f3af03034c9e90)();
    const currentScope = (0, $0b98faa1b87c8168$export$c7be4b0125a10cba)();
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session) (0, $1336536f7ff10af9$export$56521d9ba90f62ee)(session);
    $584cdb98c6222991$var$_sendSessionUpdate();
    // the session is over; take it off of the scope
    isolationScope.setSession();
}
/**
 * Sends the current Session on the scope
 */ function $584cdb98c6222991$var$_sendSessionUpdate() {
    const isolationScope = (0, $0b98faa1b87c8168$export$68f3af03034c9e90)();
    const client = (0, $0b98faa1b87c8168$export$6bb76d6eba7e258c)();
    const session = isolationScope.getSession();
    if (session && client) client.captureSession(session);
}
/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */ function $584cdb98c6222991$export$667e7b4d445d566b(end = false) {
    // both send the update and pull the session from the scope
    if (end) {
        $584cdb98c6222991$export$17a5be43989a0bc1();
        return;
    }
    // only send the update
    $584cdb98c6222991$var$_sendSessionUpdate();
}


const $9c98becc1d3a3995$export$56d8a8a25bd48b81 = (0, $88208d9e04627397$export$f1a6cdb1459e81d1);
let $9c98becc1d3a3995$var$ignoreOnError = 0;
/**
 * @hidden
 */ function $9c98becc1d3a3995$export$b79738ab10c590b2() {
    return $9c98becc1d3a3995$var$ignoreOnError > 0;
}
/**
 * @hidden
 */ function $9c98becc1d3a3995$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $9c98becc1d3a3995$var$ignoreOnError++;
    setTimeout(()=>{
        $9c98becc1d3a3995$var$ignoreOnError--;
    });
}
// eslint-disable-next-line @typescript-eslint/ban-types
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */ function $9c98becc1d3a3995$export$4997ffc0176396a6(fn, options = {}) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    function isFunction(fn) {
        return typeof fn === "function";
    }
    if (!isFunction(fn)) return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        const wrapper = fn.__sentry_wrapped__;
        if (wrapper) {
            if (typeof wrapper === "function") return wrapper;
            else // If we find that the `__sentry_wrapped__` function is not a function at the time of accessing it, it means
            // that something messed with it. In that case we want to return the originally passed function.
            return fn;
        }
        // We don't wanna wrap it twice
        if ((0, $90379bc90653c4b6$export$e6cc1e135e2092e5)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    // Wrap the function itself
    // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
    const sentryWrapped = function(...args) {
        try {
            // Also wrap arguments that are themselves functions
            const wrappedArguments = args.map((arg)=>$9c98becc1d3a3995$export$4997ffc0176396a6(arg, options));
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $9c98becc1d3a3995$export$1265a142ff5ba165();
            (0, $0b98faa1b87c8168$export$ec58d9285c204497)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $c65fa882a3254127$export$f26508487bf83ee7)(event, undefined, undefined);
                        (0, $c65fa882a3254127$export$c69a9a0313b03bb1)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                (0, $584cdb98c6222991$export$f5282963edea4a68)(ex);
            });
            throw ex;
        }
    };
    // Wrap the wrapped function in a proxy, to ensure any other properties of the original function remain available
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch  {
    // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    }
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $90379bc90653c4b6$export$5c1499e2e5d010ae)(sentryWrapped, fn);
    (0, $90379bc90653c4b6$export$e73679ffaf56810e)(fn, "__sentry_wrapped__", sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, "name");
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, "name", {
            get () {
                return fn.name;
            }
        });
    } catch  {
    // This may throw if e.g. the descriptor does not exist, or a browser does not allow redefining `name`.
    // to save some bytes we simply try-catch this
    }
    return sentryWrapped;
}
/**
 * Get HTTP request data from the current page.
 */ function $9c98becc1d3a3995$export$a3c4a8453e8936f0() {
    // grab as much info as exists and add it to the event
    const url = (0, $8afcf0d9e9f8c38b$export$1cfafeee2987818b)();
    const { referrer: referrer } = $9c98becc1d3a3995$export$56d8a8a25bd48b81.document || {};
    const { userAgent: userAgent } = $9c98becc1d3a3995$export$56d8a8a25bd48b81.navigator || {};
    const headers = {
        ...referrer && {
            Referer: referrer
        },
        ...userAgent && {
            "User-Agent": userAgent
        }
    };
    const request = {
        url: url,
        headers: headers
    };
    return request;
}


// This is a map of integration function method to bundle file name.
const $a067d4a78b80c1aa$var$LazyLoadableIntegrations = {
    replayIntegration: "replay",
    replayCanvasIntegration: "replay-canvas",
    feedbackIntegration: "feedback",
    feedbackModalIntegration: "feedback-modal",
    feedbackScreenshotIntegration: "feedback-screenshot",
    captureConsoleIntegration: "captureconsole",
    contextLinesIntegration: "contextlines",
    linkedErrorsIntegration: "linkederrors",
    dedupeIntegration: "dedupe",
    extraErrorDataIntegration: "extraerrordata",
    graphqlClientIntegration: "graphqlclient",
    httpClientIntegration: "httpclient",
    reportingObserverIntegration: "reportingobserver",
    rewriteFramesIntegration: "rewriteframes",
    browserProfilingIntegration: "browserprofiling",
    moduleMetadataIntegration: "modulemetadata"
};
const $a067d4a78b80c1aa$var$WindowWithMaybeIntegration = (0, $9c98becc1d3a3995$export$56d8a8a25bd48b81);
/**
 * Lazy load an integration from the CDN.
 * Rejects if the integration cannot be loaded.
 */ async function $a067d4a78b80c1aa$export$6da56f3ddf2bd0c1(name, scriptNonce) {
    const bundle = $a067d4a78b80c1aa$var$LazyLoadableIntegrations[name];
    // `window.Sentry` is only set when using a CDN bundle, but this method can also be used via the NPM package
    const sentryOnWindow = $a067d4a78b80c1aa$var$WindowWithMaybeIntegration.Sentry = $a067d4a78b80c1aa$var$WindowWithMaybeIntegration.Sentry || {};
    if (!bundle) throw new Error(`Cannot lazy load integration: ${name}`);
    // Bail if the integration already exists
    const existing = sentryOnWindow[name];
    // The `feedbackIntegration` is loaded by default in the CDN bundles,
    // so we need to differentiate between the real integration and the shim.
    // if only the shim exists, we still want to lazy load the real integration.
    if (typeof existing === "function" && !("_isShim" in existing)) return existing;
    const url = $a067d4a78b80c1aa$var$getScriptURL(bundle);
    const script = (0, $9c98becc1d3a3995$export$56d8a8a25bd48b81).document.createElement("script");
    script.src = url;
    script.crossOrigin = "anonymous";
    script.referrerPolicy = "strict-origin";
    if (scriptNonce) script.setAttribute("nonce", scriptNonce);
    const waitForLoad = new Promise((resolve, reject)=>{
        script.addEventListener("load", ()=>resolve());
        script.addEventListener("error", reject);
    });
    const currentScript = (0, $9c98becc1d3a3995$export$56d8a8a25bd48b81).document.currentScript;
    const parent = (0, $9c98becc1d3a3995$export$56d8a8a25bd48b81).document.body || (0, $9c98becc1d3a3995$export$56d8a8a25bd48b81).document.head || currentScript?.parentElement;
    if (parent) parent.appendChild(script);
    else throw new Error(`Could not find parent element to insert lazy-loaded ${name} script`);
    try {
        await waitForLoad;
    } catch  {
        throw new Error(`Error when loading integration: ${name}`);
    }
    const integrationFn = sentryOnWindow[name];
    if (typeof integrationFn !== "function") throw new Error(`Could not load integration: ${name}`);
    return integrationFn;
}
function $a067d4a78b80c1aa$var$getScriptURL(bundle) {
    const client = (0, $0b98faa1b87c8168$export$6bb76d6eba7e258c)();
    const baseURL = client?.getOptions()?.cdnBaseUrl || "https://browser.sentry-cdn.com";
    return new URL(`/${(0, $c62c944ea7134a72$export$31499a9cd224b78c)}/${bundle}.min.js`, baseURL).toString();
}


/**
 * An integration to add user feedback to your application,
 * while loading most of the code lazily only when it's needed.
 */ const $3d59335a691d3e76$export$21eeae83e17be6ea = (0, $de7c19ef16e9e5a3$export$13a9e5a543258f97)({
    lazyLoadIntegration: $a067d4a78b80c1aa$export$6da56f3ddf2bd0c1
});



/** Add a widget to capture user feedback to your application. */ const $0d3894867527e3f1$export$4bf8b7bb0f0086df = (0, $de7c19ef16e9e5a3$export$13a9e5a543258f97)({
    getModalIntegration: ()=>(0, $de7c19ef16e9e5a3$export$2ed486683e133d58),
    getScreenshotIntegration: ()=>(0, $de7c19ef16e9e5a3$export$fd00458861e48ab4)
});


var $af54c954d97593f2$exports = {};

$parcel$export($af54c954d97593f2$exports, "trace", function () { return $af54c954d97593f2$export$357889f174732d38; });
$parcel$export($af54c954d97593f2$exports, "debug", function () { return $af54c954d97593f2$export$1c9f709888824e05; });
$parcel$export($af54c954d97593f2$exports, "info", function () { return $af54c954d97593f2$export$a80b3bd66acc52ff; });
$parcel$export($af54c954d97593f2$exports, "warn", function () { return $af54c954d97593f2$export$c106dd0671a0fc2d; });
$parcel$export($af54c954d97593f2$exports, "error", function () { return $af54c954d97593f2$export$a3bc9b8ed74fc; });
$parcel$export($af54c954d97593f2$exports, "fatal", function () { return $af54c954d97593f2$export$570101a5202fba29; });
$parcel$export($af54c954d97593f2$exports, "fmt", function () { return $48f7b345b59f4894$export$bc71a178fd8db0f; });

const $e3f8c961f1c27003$var$SENTRY_API_VERSION = "7";
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $e3f8c961f1c27003$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : "";
    const port = dsn.port ? `:${dsn.port}` : "";
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ""}/api/`;
}
/** Returns the ingest API endpoint for target. */ function $e3f8c961f1c27003$var$_getIngestEndpoint(dsn) {
    return `${$e3f8c961f1c27003$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $e3f8c961f1c27003$var$_encodedAuth(dsn, sdkInfo) {
    const params = {
        sentry_version: $e3f8c961f1c27003$var$SENTRY_API_VERSION
    };
    if (dsn.publicKey) // We send only the minimum set of required information. See
    // https://github.com/getsentry/sentry-javascript/issues/2572.
    params.sentry_key = dsn.publicKey;
    if (sdkInfo) params.sentry_client = `${sdkInfo.name}/${sdkInfo.version}`;
    return new URLSearchParams(params).toString();
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */ function $e3f8c961f1c27003$export$9964600bfe84e6a3(dsn, tunnel, sdkInfo) {
    return tunnel ? tunnel : `${$e3f8c961f1c27003$var$_getIngestEndpoint(dsn)}?${$e3f8c961f1c27003$var$_encodedAuth(dsn, sdkInfo)}`;
}
/** Returns the url to the report dialog endpoint. */ function $e3f8c961f1c27003$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    const dsn = (0, $0ce64b897229c6e0$export$128827c3562ec0cb)(dsnLike);
    if (!dsn) return "";
    const endpoint = `${$e3f8c961f1c27003$var$getBaseApiEndpoint(dsn)}embed/error-page/`;
    let encodedOptions = `dsn=${(0, $0ce64b897229c6e0$export$44d472fbb931a776)(dsn)}`;
    for(const key in dialogOptions){
        if (key === "dsn") continue;
        if (key === "onClose") continue;
        if (key === "user") {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}











/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $a293d580860d0106$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $a293d580860d0106$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function $a293d580860d0106$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function $a293d580860d0106$export$604a45d95a155e2b(envelope, types) {
    return $a293d580860d0106$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
/**
 * Encode a string to UTF8 array.
 */ function $a293d580860d0106$var$encodeUTF8(input) {
    const carrier = (0, $abd13f64e43ff217$export$c8bfa33e4e8ae492)((0, $88208d9e04627397$export$f1a6cdb1459e81d1));
    return carrier.encodePolyfill ? carrier.encodePolyfill(input) : new TextEncoder().encode(input);
}
/**
 * Decode a UTF8 array to string.
 */ function $a293d580860d0106$var$decodeUTF8(input) {
    const carrier = (0, $abd13f64e43ff217$export$c8bfa33e4e8ae492)((0, $88208d9e04627397$export$f1a6cdb1459e81d1));
    return carrier.decodePolyfill ? carrier.decodePolyfill(input) : new TextDecoder().decode(input);
}
/**
 * Serializes an envelope.
 */ function $a293d580860d0106$export$32f9b428425aac85(envelope) {
    const [envHeaders, items] = envelope;
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === "string") parts = typeof next === "string" ? parts + next : [
            $a293d580860d0106$var$encodeUTF8(parts),
            next
        ];
        else parts.push(typeof next === "string" ? $a293d580860d0106$var$encodeUTF8(next) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`\n${JSON.stringify(itemHeaders)}\n`);
        if (typeof payload === "string" || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch (e) {
                // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.stringify()` still
                // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                // performance impact but in this case a performance hit is better than throwing.
                stringifiedPayload = JSON.stringify((0, $3878df912d4376ee$export$a3295358bff77e)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === "string" ? parts : $a293d580860d0106$var$concatBuffers(parts);
}
function $a293d580860d0106$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
/**
 * Parses an envelope
 */ function $a293d580860d0106$export$3338d0c7b6e17a2b(env) {
    let buffer = typeof env === "string" ? $a293d580860d0106$var$encodeUTF8(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse($a293d580860d0106$var$decodeUTF8(readBinary(i)));
    }
    const envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === "number" ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates envelope item for a single span
 */ function $a293d580860d0106$export$655cf139bc8b8afd(spanJson) {
    const spanHeaders = {
        type: "span"
    };
    return [
        spanHeaders,
        spanJson
    ];
}
/**
 * Creates attachment envelope items
 */ function $a293d580860d0106$export$d8fc80952cc31fa4(attachment) {
    const buffer = typeof attachment.data === "string" ? $a293d580860d0106$var$encodeUTF8(attachment.data) : attachment.data;
    return [
        {
            type: "attachment",
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        },
        buffer
    ];
}
const $a293d580860d0106$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
    session: "session",
    sessions: "session",
    attachment: "attachment",
    transaction: "transaction",
    event: "error",
    client_report: "internal",
    user_report: "default",
    profile: "profile",
    profile_chunk: "profile",
    replay_event: "replay",
    replay_recording: "replay",
    check_in: "monitor",
    feedback: "feedback",
    span: "span",
    raw_security: "security",
    log: "log_item"
};
/**
 * Maps the type of an envelope item to a data category.
 */ function $a293d580860d0106$export$b11169581eeaf237(type) {
    return $a293d580860d0106$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}
/** Extracts the minimal SDK info from the metadata or an events */ function $a293d580860d0106$export$d369f3b2758f6743(metadataOrEvent) {
    if (!metadataOrEvent?.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function $a293d580860d0106$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    const dynamicSamplingContext = event.sdkProcessingMetadata?.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $0ce64b897229c6e0$export$44d472fbb931a776)(dsn)
        },
        ...dynamicSamplingContext && {
            trace: dynamicSamplingContext
        }
    };
}





/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $52dc1c4d127660c2$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = [
        ...event.sdk.integrations || [],
        ...sdkInfo.integrations || []
    ];
    event.sdk.packages = [
        ...event.sdk.packages || [],
        ...sdkInfo.packages || []
    ];
    return event;
}
/** Creates an envelope from a Session */ function $52dc1c4d127660c2$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $a293d580860d0106$export$d369f3b2758f6743)(metadata);
    const envelopeHeaders = {
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $0ce64b897229c6e0$export$44d472fbb931a776)(dsn)
        }
    };
    const envelopeItem = "aggregates" in session ? [
        {
            type: "sessions"
        },
        session
    ] : [
        {
            type: "session"
        },
        session.toJSON()
    ];
    return (0, $a293d580860d0106$export$f93f7f385160c44e)(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function $52dc1c4d127660c2$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $a293d580860d0106$export$d369f3b2758f6743)(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjust a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ const eventType = event.type && event.type !== "replay_event" ? event.type : "event";
    $52dc1c4d127660c2$var$enhanceEventWithSdkInfo(event, metadata?.sdk);
    const envelopeHeaders = (0, $a293d580860d0106$export$92b6093782fe661b)(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $a293d580860d0106$export$f93f7f385160c44e)(envelopeHeaders, [
        eventItem
    ]);
}
/**
 * Create envelope from Span item.
 *
 * Takes an optional client and runs spans through `beforeSendSpan` if available.
 */ function $52dc1c4d127660c2$export$19a0081d4b39d77(spans, client) {
    function dscHasRequiredProps(dsc) {
        return !!dsc.trace_id && !!dsc.public_key;
    }
    // For the moment we'll obtain the DSC from the first span in the array
    // This might need to be changed if we permit sending multiple spans from
    // different segments in one envelope
    const dsc = (0, $d001bfa1cb8b2131$export$a117f995597e25df)(spans[0]);
    const dsn = client?.getDsn();
    const tunnel = client?.getOptions().tunnel;
    const headers = {
        sent_at: new Date().toISOString(),
        ...dscHasRequiredProps(dsc) && {
            trace: dsc
        },
        ...!!tunnel && dsn && {
            dsn: (0, $0ce64b897229c6e0$export$44d472fbb931a776)(dsn)
        }
    };
    const beforeSendSpan = client?.getOptions().beforeSendSpan;
    const convertToSpanJSON = beforeSendSpan ? (span)=>{
        const spanJson = (0, $e89a3331adf677ac$export$92d8c23565496537)(span);
        const processedSpan = beforeSendSpan(spanJson);
        if (!processedSpan) {
            (0, $e89a3331adf677ac$export$d11691ff45a3e535)();
            return spanJson;
        }
        return processedSpan;
    } : (0, $e89a3331adf677ac$export$92d8c23565496537);
    const items = [];
    for (const span of spans){
        const spanJson = convertToSpanJSON(span);
        if (spanJson) items.push((0, $a293d580860d0106$export$655cf139bc8b8afd)(spanJson));
    }
    return (0, $a293d580860d0106$export$f93f7f385160c44e)(headers, items);
}





const $5cfb41e3e92106c4$export$b14a8888f80a0b3e = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preserve the order of integrations in the array.
 *
 * @private
 */ function $5cfb41e3e92106c4$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.values(integrationsByName);
}
/** Gets integrations to install */ function $5cfb41e3e92106c4$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === "function") {
        const resolvedUserIntegrations = userIntegrations(defaultIntegrations);
        integrations = Array.isArray(resolvedUserIntegrations) ? resolvedUserIntegrations : [
            resolvedUserIntegrations
        ];
    } else integrations = defaultIntegrations;
    return $5cfb41e3e92106c4$var$filterDuplicates(integrations);
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function $5cfb41e3e92106c4$export$51abed9797baa598(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        // guard against empty provided integrations
        if (integration) $5cfb41e3e92106c4$export$e7390a03b70a6f2f(client, integration, integrationIndex);
    });
    return integrationIndex;
}
/**
 * Execute the `afterAllSetup` hooks of the given integrations.
 */ function $5cfb41e3e92106c4$export$35abcfd71227c6ca(client, integrations) {
    for (const integration of integrations)// guard against empty provided integrations
    if (integration?.afterAllSetup) integration.afterAllSetup(client);
}
/** Setup a single integration.  */ function $5cfb41e3e92106c4$export$e7390a03b70a6f2f(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        (0, $b5c0571e433473d8$export$16a28057038b10ef) && (0, $dfad86e498c52aee$export$af88d00dbe7f521).log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    // `setupOnce` is only called the first time
    if ($5cfb41e3e92106c4$export$b14a8888f80a0b3e.indexOf(integration.name) === -1 && typeof integration.setupOnce === "function") {
        integration.setupOnce();
        $5cfb41e3e92106c4$export$b14a8888f80a0b3e.push(integration.name);
    }
    // `setup` is run for each client
    if (integration.setup && typeof integration.setup === "function") integration.setup(client);
    if (typeof integration.preprocessEvent === "function") {
        const callback = integration.preprocessEvent.bind(integration);
        client.on("preprocessEvent", (event, hint)=>callback(event, hint, client));
    }
    if (typeof integration.processEvent === "function") {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    (0, $b5c0571e433473d8$export$16a28057038b10ef) && (0, $dfad86e498c52aee$export$af88d00dbe7f521).log(`Integration installed: ${integration.name}`);
}
/** Add an integration to the current scope's client. */ function $5cfb41e3e92106c4$export$2d8f5188773bcddd(integration) {
    const client = (0, $0b98faa1b87c8168$export$6bb76d6eba7e258c)();
    if (!client) {
        (0, $b5c0571e433473d8$export$16a28057038b10ef) && (0, $dfad86e498c52aee$export$af88d00dbe7f521).warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
/**
 * Define an integration function that can be used to create an integration instance.
 * Note that this by design hides the implementation details of the integration, as they are considered internal.
 */ function $5cfb41e3e92106c4$export$2323046b9414659f(fn) {
    return fn;
}






/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */ function $e0069c1770c8ad8f$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: "client_report"
        },
        {
            timestamp: timestamp || (0, $14ccb306f78f15b4$export$7740643b9eeaf0c4)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $a293d580860d0106$export$f93f7f385160c44e)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}




/**
 * Get a list of possible event messages from a Sentry event.
 */ function $85d228d1bd1d06f6$export$d55a97c329cacfcc(event) {
    const possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    try {
        // @ts-expect-error Try catching to save bundle size
        const lastException = event.exception.values[event.exception.values.length - 1];
        if (lastException?.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    } catch (e) {
    // ignore errors here
    }
    return possibleMessages;
}











/**
 * Converts a transaction event to a span JSON object.
 */ function $becd4c7739c82027$export$d9c6b2464b0a687e(event) {
    const { trace_id: trace_id, parent_span_id: parent_span_id, span_id: span_id, status: status, origin: origin, data: data, op: op } = event.contexts?.trace ?? {};
    return {
        data: data ?? {},
        description: event.transaction,
        op: op,
        parent_span_id: parent_span_id,
        span_id: span_id ?? "",
        start_timestamp: event.start_timestamp ?? 0,
        status: status,
        timestamp: event.timestamp,
        trace_id: trace_id ?? "",
        origin: origin,
        profile_id: data?.[0, $34e3132ced11beec$export$1efec95406bbe327],
        exclusive_time: data?.[0, $34e3132ced11beec$export$fea48ba9f4550879],
        measurements: event.measurements,
        is_segment: true
    };
}
/**
 * Converts a span JSON object to a transaction event.
 */ function $becd4c7739c82027$export$f2d8fce5ae150e92(span) {
    return {
        type: "transaction",
        timestamp: span.timestamp,
        start_timestamp: span.start_timestamp,
        transaction: span.description,
        contexts: {
            trace: {
                trace_id: span.trace_id,
                span_id: span.span_id,
                parent_span_id: span.parent_span_id,
                op: span.op,
                status: span.status,
                origin: span.origin,
                data: {
                    ...span.data,
                    ...span.profile_id && {
                        [(0, $34e3132ced11beec$export$1efec95406bbe327)]: span.profile_id
                    },
                    ...span.exclusive_time && {
                        [(0, $34e3132ced11beec$export$fea48ba9f4550879)]: span.exclusive_time
                    }
                }
            }
        },
        measurements: span.measurements
    };
}


/* eslint-disable max-lines */ const $1f108170a70c53f4$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
const $1f108170a70c53f4$var$MISSING_RELEASE_FOR_SESSION_ERROR = "Discarded session because of missing or non-string release";
const $1f108170a70c53f4$var$INTERNAL_ERROR_SYMBOL = Symbol.for("SentryInternalError");
const $1f108170a70c53f4$var$DO_NOT_SEND_EVENT_SYMBOL = Symbol.for("SentryDoNotSendEventError");
function $1f108170a70c53f4$var$_makeInternalError(message) {
    return {
        message: message,
        [$1f108170a70c53f4$var$INTERNAL_ERROR_SYMBOL]: true
    };
}
function $1f108170a70c53f4$var$_makeDoNotSendEventError(message) {
    return {
        message: message,
        [$1f108170a70c53f4$var$DO_NOT_SEND_EVENT_SYMBOL]: true
    };
}
function $1f108170a70c53f4$var$_isInternalError(error) {
    return !!error && typeof error === "object" && $1f108170a70c53f4$var$INTERNAL_ERROR_SYMBOL in error;
}
function $1f108170a70c53f4$var$_isDoNotSendEventError(error) {
    return !!error && typeof error === "object" && $1f108170a70c53f4$var$DO_NOT_SEND_EVENT_SYMBOL in error;
}
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link Client._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends Client<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */ class $1f108170a70c53f4$export$1f2bb630327ac4b6 {
    /** Options passed to the SDK. */ /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */ /** Array of set up integrations. */ /** Number of calls being processed */ /** Holds flushable  */ // eslint-disable-next-line @typescript-eslint/ban-types
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        this._options = options;
        this._integrations = {};
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        if (options.dsn) this._dsn = (0, $0ce64b897229c6e0$export$128827c3562ec0cb)(options.dsn);
        else (0, $b5c0571e433473d8$export$16a28057038b10ef) && (0, $dfad86e498c52aee$export$af88d00dbe7f521).warn("No DSN provided, client will not send events.");
        if (this._dsn) {
            const url = (0, $e3f8c961f1c27003$export$9964600bfe84e6a3)(this._dsn, options.tunnel, options._metadata ? options._metadata.sdk : undefined);
            this._transport = options.transport({
                tunnel: this._options.tunnel,
                recordDroppedEvent: this.recordDroppedEvent.bind(this),
                ...options.transportOptions,
                url: url
            });
        }
    }
    /**
   * Captures an exception event and sends it to Sentry.
   *
   * Unlike `captureException` exported from every SDK, this method requires that you pass it the current scope.
   */ captureException(exception, hint, scope) {
        const eventId = (0, $c65fa882a3254127$export$19f53698e68b2496)();
        // ensure we haven't captured this very object before
        if ((0, $c65fa882a3254127$export$6de4ffac6a2f1098)(exception)) {
            (0, $b5c0571e433473d8$export$16a28057038b10ef) && (0, $dfad86e498c52aee$export$af88d00dbe7f521).log($1f108170a70c53f4$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        this._process(this.eventFromException(exception, hintWithEventId).then((event)=>this._captureEvent(event, hintWithEventId, scope)));
        return hintWithEventId.event_id;
    }
    /**
   * Captures a message event and sends it to Sentry.
   *
   * Unlike `captureMessage` exported from every SDK, this method requires that you pass it the current scope.
   */ captureMessage(message, level, hint, currentScope) {
        const hintWithEventId = {
            event_id: (0, $c65fa882a3254127$export$19f53698e68b2496)(),
            ...hint
        };
        const eventMessage = (0, $ed5cb73b8752546d$export$dbcbffa59149b824)(message) ? message : String(message);
        const promisedEvent = (0, $ed5cb73b8752546d$export$c3825b437cbdea5c)(message) ? this.eventFromMessage(eventMessage, level, hintWithEventId) : this.eventFromException(message, hintWithEventId);
        this._process(promisedEvent.then((event)=>this._captureEvent(event, hintWithEventId, currentScope)));
        return hintWithEventId.event_id;
    }
    /**
   * Captures a manually created event and sends it to Sentry.
   *
   * Unlike `captureEvent` exported from every SDK, this method requires that you pass it the current scope.
   */ captureEvent(event, hint, currentScope) {
        const eventId = (0, $c65fa882a3254127$export$19f53698e68b2496)();
        // ensure we haven't captured this very object before
        if (hint?.originalException && (0, $c65fa882a3254127$export$6de4ffac6a2f1098)(hint.originalException)) {
            (0, $b5c0571e433473d8$export$16a28057038b10ef) && (0, $dfad86e498c52aee$export$af88d00dbe7f521).log($1f108170a70c53f4$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
        const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
        this._process(this._captureEvent(event, hintWithEventId, capturedSpanScope || currentScope, capturedSpanIsolationScope));
        return hintWithEventId.event_id;
    }
    /**
   * Captures a session.
   */ captureSession(session) {
        this.sendSession(session);
        // After sending, we set init false to indicate it's not the first occurrence
        (0, $1336536f7ff10af9$export$531818e825e774db)(session, {
            init: false
        });
    }
    /**
   * Create a cron monitor check in and send it to Sentry. This method is not available on all clients.
   *
   * @param checkIn An object that describes a check in.
   * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
   * to create a monitor automatically when sending a check in.
   * @param scope An optional scope containing event metadata.
   * @returns A string representing the id of the check in.
   */ /**
   * Get the current Dsn.
   */ getDsn() {
        return this._dsn;
    }
    /**
   * Get the current options.
   */ getOptions() {
        return this._options;
    }
    /**
   * Get the SDK metadata.
   * @see SdkMetadata
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * Returns the transport that is used by the client.
   * Please note that the transport gets lazy initialized so it will only be there once the first event has been sent.
   */ getTransport() {
        return this._transport;
    }
    /**
   * Wait for all events to be sent or the timeout to expire, whichever comes first.
   *
   * @param timeout Maximum time in ms the client should wait for events to be flushed. Omitting this parameter will
   *   cause the client to wait until all events are sent before resolving the promise.
   * @returns A promise that will resolve with `true` if all events are sent before the timeout, or `false` if there are
   * still events in the queue when the timeout is reached.
   */ flush(timeout) {
        const transport = this._transport;
        if (transport) {
            this.emit("flush");
            return this._isClientDoneProcessing(timeout).then((clientFinished)=>{
                return transport.flush(timeout).then((transportFlushed)=>clientFinished && transportFlushed);
            });
        } else return (0, $3de734ff6b883b7d$export$1fda8aa4d135f8aa)(true);
    }
    /**
   * Flush the event queue and set the client to `enabled = false`. See {@link Client.flush}.
   *
   * @param {number} timeout Maximum time in ms the client should wait before shutting down. Omitting this parameter will cause
   *   the client to wait until all events are sent before disabling itself.
   * @returns {Promise<boolean>} A promise which resolves to `true` if the flush completes successfully before the timeout, or `false` if
   * it doesn't.
   */ close(timeout) {
        return this.flush(timeout).then((result)=>{
            this.getOptions().enabled = false;
            this.emit("close");
            return result;
        });
    }
    /**
   * Get all installed event processors.
   */ getEventProcessors() {
        return this._eventProcessors;
    }
    /**
   * Adds an event processor that applies to any event processed by this client.
   */ addEventProcessor(eventProcessor) {
        this._eventProcessors.push(eventProcessor);
    }
    /**
   * Initialize this client.
   * Call this after the client was set on a scope.
   */ init() {
        if (this._isEnabled() || // Force integrations to be setup even if no DSN was set when we have
        // Spotlight enabled. This is particularly important for browser as we
        // don't support the `spotlight` option there and rely on the users
        // adding the `spotlightBrowserIntegration()` to their integrations which
        // wouldn't get initialized with the check below when there's no DSN set.
        this._options.integrations.some(({ name: name })=>name.startsWith("Spotlight"))) this._setupIntegrations();
    }
    /**
   * Gets an installed integration by its name.
   *
   * @returns {Integration|undefined} The installed integration or `undefined` if no integration with that `name` was installed.
   */ getIntegrationByName(integrationName) {
        return this._integrations[integrationName];
    }
    /**
   * Add an integration to the client.
   * This can be used to e.g. lazy load integrations.
   * In most cases, this should not be necessary,
   * and you're better off just passing the integrations via `integrations: []` at initialization time.
   * However, if you find the need to conditionally load & add an integration, you can use `addIntegration` to do so.
   */ addIntegration(integration) {
        const isAlreadyInstalled = this._integrations[integration.name];
        // This hook takes care of only installing if not already installed
        (0, $5cfb41e3e92106c4$export$e7390a03b70a6f2f)(this, integration, this._integrations);
        // Here we need to check manually to make sure to not run this multiple times
        if (!isAlreadyInstalled) (0, $5cfb41e3e92106c4$export$35abcfd71227c6ca)(this, [
            integration
        ]);
    }
    /**
   * Send a fully prepared event to Sentry.
   */ sendEvent(event, hint = {}) {
        this.emit("beforeSendEvent", event, hint);
        let env = (0, $52dc1c4d127660c2$export$c31057337a18010f)(event, this._dsn, this._options._metadata, this._options.tunnel);
        for (const attachment of hint.attachments || [])env = (0, $a293d580860d0106$export$d650323442802f6f)(env, (0, $a293d580860d0106$export$d8fc80952cc31fa4)(attachment));
        const promise = this.sendEnvelope(env);
        if (promise) promise.then((sendResponse)=>this.emit("afterSendEvent", event, sendResponse), null);
    }
    /**
   * Send a session or session aggregrates to Sentry.
   */ sendSession(session) {
        // Backfill release and environment on session
        const { release: clientReleaseOption, environment: clientEnvironmentOption = (0, $4d1ecfae9e70d95f$export$849dbeeeda01ae98) } = this._options;
        if ("aggregates" in session) {
            const sessionAttrs = session.attrs || {};
            if (!sessionAttrs.release && !clientReleaseOption) {
                (0, $b5c0571e433473d8$export$16a28057038b10ef) && (0, $dfad86e498c52aee$export$af88d00dbe7f521).warn($1f108170a70c53f4$var$MISSING_RELEASE_FOR_SESSION_ERROR);
                return;
            }
            sessionAttrs.release = sessionAttrs.release || clientReleaseOption;
            sessionAttrs.environment = sessionAttrs.environment || clientEnvironmentOption;
            session.attrs = sessionAttrs;
        } else {
            if (!session.release && !clientReleaseOption) {
                (0, $b5c0571e433473d8$export$16a28057038b10ef) && (0, $dfad86e498c52aee$export$af88d00dbe7f521).warn($1f108170a70c53f4$var$MISSING_RELEASE_FOR_SESSION_ERROR);
                return;
            }
            session.release = session.release || clientReleaseOption;
            session.environment = session.environment || clientEnvironmentOption;
        }
        this.emit("beforeSendSession", session);
        const env = (0, $52dc1c4d127660c2$export$124b03c077baa2f3)(session, this._dsn, this._options._metadata, this._options.tunnel);
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(env);
    }
    /**
   * Record on the client that an event got dropped (ie, an event that will not be sent to Sentry).
   */ recordDroppedEvent(reason, category, count = 1) {
        if (this._options.sendClientReports) {
            // We want to track each category (error, transaction, session, replay_event) separately
            // but still keep the distinction between different type of outcomes.
            // We could use nested maps, but it's much easier to read and type this way.
            // A correct type for map-based implementation if we want to go that route
            // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
            // With typescript 4.1 we could even use template literal types
            const key = `${reason}:${category}`;
            (0, $b5c0571e433473d8$export$16a28057038b10ef) && (0, $dfad86e498c52aee$export$af88d00dbe7f521).log(`Recording outcome: "${key}"${count > 1 ? ` (${count} times)` : ""}`);
            this._outcomes[key] = (this._outcomes[key] || 0) + count;
        }
    }
    /* eslint-disable @typescript-eslint/unified-signatures */ /**
   * Register a callback for whenever a span is started.
   * Receives the span as argument.
   * @returns {() => void} A function that, when executed, removes the registered callback.
   */ /**
   * Register a hook on this client.
   */ on(hook, callback) {
        const hooks = this._hooks[hook] = this._hooks[hook] || [];
        // @ts-expect-error We assume the types are correct
        hooks.push(callback);
        // This function returns a callback execution handler that, when invoked,
        // deregisters a callback. This is crucial for managing instances where callbacks
        // need to be unregistered to prevent self-referencing in callback closures,
        // ensuring proper garbage collection.
        return ()=>{
            // @ts-expect-error We assume the types are correct
            const cbIndex = hooks.indexOf(callback);
            if (cbIndex > -1) hooks.splice(cbIndex, 1);
        };
    }
    /** Fire a hook whenever a span starts. */ /**
   * Emit a hook that was previously registered via `on()`.
   */ emit(hook, ...rest) {
        const callbacks = this._hooks[hook];
        if (callbacks) callbacks.forEach((callback)=>callback(...rest));
    }
    /**
   * Send an envelope to Sentry.
   */ sendEnvelope(envelope) {
        this.emit("beforeEnvelope", envelope);
        if (this._isEnabled() && this._transport) return this._transport.send(envelope).then(null, (reason)=>{
            (0, $b5c0571e433473d8$export$16a28057038b10ef) && (0, $dfad86e498c52aee$export$af88d00dbe7f521).error("Error while sending envelope:", reason);
            return reason;
        });
        (0, $b5c0571e433473d8$export$16a28057038b10ef) && (0, $dfad86e498c52aee$export$af88d00dbe7f521).error("Transport disabled");
        return (0, $3de734ff6b883b7d$export$1fda8aa4d135f8aa)({});
    }
    /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ _setupIntegrations() {
        const { integrations: integrations } = this._options;
        this._integrations = (0, $5cfb41e3e92106c4$export$51abed9797baa598)(this, integrations);
        (0, $5cfb41e3e92106c4$export$35abcfd71227c6ca)(this, integrations);
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session, event) {
        let crashed = event.level === "fatal";
        let errored = false;
        const exceptions = event.exception?.values;
        if (exceptions) {
            errored = true;
            for (const ex of exceptions){
                const mechanism = ex.mechanism;
                if (mechanism?.handled === false) {
                    crashed = true;
                    break;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        const sessionNonTerminal = session.status === "ok";
        const shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            (0, $1336536f7ff10af9$export$531818e825e774db)(session, {
                ...crashed && {
                    status: "crashed"
                },
                errors: session.errors || Number(errored || crashed)
            });
            this.captureSession(session);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ _isClientDoneProcessing(timeout) {
        return new (0, $3de734ff6b883b7d$export$6f292d4960313241)((resolve)=>{
            let ticked = 0;
            const tick = 1;
            const interval = setInterval(()=>{
                if (this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    }
    /** Determines whether this SDK is enabled and a transport is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._transport !== undefined;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, currentScope, isolationScope) {
        const options = this.getOptions();
        const integrations = Object.keys(this._integrations);
        if (!hint.integrations && integrations?.length) hint.integrations = integrations;
        this.emit("preprocessEvent", event, hint);
        if (!event.type) isolationScope.setLastEventId(event.event_id || hint.event_id);
        return (0, $f9704539615075ff$export$2d67fb380bd11267)(options, event, hint, currentScope, this, isolationScope).then((evt)=>{
            if (evt === null) return evt;
            this.emit("postprocessEvent", evt, hint);
            evt.contexts = {
                trace: (0, $0b98faa1b87c8168$export$1e83db7ee4876dc4)(currentScope),
                ...evt.contexts
            };
            const dynamicSamplingContext = (0, $d001bfa1cb8b2131$export$89ef1736f08c6b2b)(this, currentScope);
            evt.sdkProcessingMetadata = {
                dynamicSamplingContext: dynamicSamplingContext,
                ...evt.sdkProcessingMetadata
            };
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, currentScope = (0, $0b98faa1b87c8168$export$c7be4b0125a10cba)(), isolationScope = (0, $0b98faa1b87c8168$export$68f3af03034c9e90)()) {
        if ((0, $b5c0571e433473d8$export$16a28057038b10ef) && $1f108170a70c53f4$var$isErrorEvent(event)) (0, $dfad86e498c52aee$export$af88d00dbe7f521).log(`Captured error event \`${(0, $85d228d1bd1d06f6$export$d55a97c329cacfcc)(event)[0] || "<unknown>"}\``);
        return this._processEvent(event, hint, currentScope, isolationScope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if (0, $b5c0571e433473d8$export$16a28057038b10ef) {
                if ($1f108170a70c53f4$var$_isDoNotSendEventError(reason)) (0, $dfad86e498c52aee$export$af88d00dbe7f521).log(reason.message);
                else if ($1f108170a70c53f4$var$_isInternalError(reason)) (0, $dfad86e498c52aee$export$af88d00dbe7f521).warn(reason.message);
                else (0, $dfad86e498c52aee$export$af88d00dbe7f521).warn(reason);
            }
            return undefined;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, currentScope, isolationScope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        const isTransaction = $1f108170a70c53f4$var$isTransactionEvent(event);
        const isError = $1f108170a70c53f4$var$isErrorEvent(event);
        const eventType = event.type || "error";
        const beforeSendLabel = `before send for type \`${eventType}\``;
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        const parsedSampleRate = typeof sampleRate === "undefined" ? undefined : (0, $7c4c9604e7e6042d$export$a5bd2d81656d9546)(sampleRate);
        if (isError && typeof parsedSampleRate === "number" && Math.random() > parsedSampleRate) {
            this.recordDroppedEvent("sample_rate", "error");
            return (0, $3de734ff6b883b7d$export$78e43115b553f358)($1f108170a70c53f4$var$_makeDoNotSendEventError(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`));
        }
        const dataCategory = eventType === "replay_event" ? "replay" : eventType;
        return this._prepareEvent(event, hint, currentScope, isolationScope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent("event_processor", dataCategory);
                throw $1f108170a70c53f4$var$_makeDoNotSendEventError("An event processor returned `null`, will not send event.");
            }
            const isInternalException = hint.data && hint.data.__sentry__ === true;
            if (isInternalException) return prepared;
            const result = $1f108170a70c53f4$var$processBeforeSend(this, options, prepared, hint);
            return $1f108170a70c53f4$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent("before_send", dataCategory);
                if (isTransaction) {
                    const spans = event.spans || [];
                    // the transaction itself counts as one span, plus all the child spans that are added
                    const spanCount = 1 + spans.length;
                    this.recordDroppedEvent("before_send", "span", spanCount);
                }
                throw $1f108170a70c53f4$var$_makeDoNotSendEventError(`${beforeSendLabel} returned \`null\`, will not send event.`);
            }
            const session = currentScope.getSession() || isolationScope.getSession();
            if (isError && session) this._updateSessionFromEvent(session, processedEvent);
            if (isTransaction) {
                const spanCountBefore = processedEvent.sdkProcessingMetadata?.spanCountBeforeProcessing || 0;
                const spanCountAfter = processedEvent.spans ? processedEvent.spans.length : 0;
                const droppedSpanCount = spanCountBefore - spanCountAfter;
                if (droppedSpanCount > 0) this.recordDroppedEvent("before_send", "span", droppedSpanCount);
            }
            // None of the Sentry built event processor will update transaction name,
            // so if the transaction name has been changed by an event processor, we know
            // it has to come from custom event processor added by a user
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = "custom";
                processedEvent.transaction_info = {
                    ...transactionInfo,
                    source: source
                };
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if ($1f108170a70c53f4$var$_isDoNotSendEventError(reason) || $1f108170a70c53f4$var$_isInternalError(reason)) throw reason;
            this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw $1f108170a70c53f4$var$_makeInternalError(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(promise) {
        this._numProcessing++;
        promise.then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            return reason;
        });
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.entries(outcomes).map(([key, quantity])=>{
            const [reason, category] = key.split(":");
            return {
                reason: reason,
                category: category,
                quantity: quantity
            };
        });
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        (0, $b5c0571e433473d8$export$16a28057038b10ef) && (0, $dfad86e498c52aee$export$af88d00dbe7f521).log("Flushing outcomes...");
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            (0, $b5c0571e433473d8$export$16a28057038b10ef) && (0, $dfad86e498c52aee$export$af88d00dbe7f521).log("No outcomes to send");
            return;
        }
        // This is really the only place where we want to check for a DSN and only send outcomes then
        if (!this._dsn) {
            (0, $b5c0571e433473d8$export$16a28057038b10ef) && (0, $dfad86e498c52aee$export$af88d00dbe7f521).log("No dsn provided, will not send outcomes");
            return;
        }
        (0, $b5c0571e433473d8$export$16a28057038b10ef) && (0, $dfad86e498c52aee$export$af88d00dbe7f521).log("Sending outcomes:", outcomes);
        const envelope = (0, $e0069c1770c8ad8f$export$f3b9ed77c03eeb00)(outcomes, this._options.tunnel && (0, $0ce64b897229c6e0$export$44d472fbb931a776)(this._dsn));
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(envelope);
    }
}
/**
 * @deprecated Use `Client` instead. This alias may be removed in a future major version.
 */ // TODO(v10): Remove
/**
 * @deprecated Use `Client` instead. This alias may be removed in a future major version.
 */ // TODO(v10): Remove
const $1f108170a70c53f4$export$4f22f74eddb7716a = $1f108170a70c53f4$export$1f2bb630327ac4b6;
/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */ function $1f108170a70c53f4$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ((0, $ed5cb73b8752546d$export$f5b060c2914b97c8)(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!(0, $ed5cb73b8752546d$export$53b83ca8eaab0383)(event) && event !== null) throw $1f108170a70c53f4$var$_makeInternalError(invalidValueError);
        return event;
    }, (e)=>{
        throw $1f108170a70c53f4$var$_makeInternalError(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!(0, $ed5cb73b8752546d$export$53b83ca8eaab0383)(beforeSendResult) && beforeSendResult !== null) throw $1f108170a70c53f4$var$_makeInternalError(invalidValueError);
    return beforeSendResult;
}
/**
 * Process the matching `beforeSendXXX` callback.
 */ function $1f108170a70c53f4$var$processBeforeSend(client, options, event, hint) {
    const { beforeSend: beforeSend, beforeSendTransaction: beforeSendTransaction, beforeSendSpan: beforeSendSpan } = options;
    let processedEvent = event;
    if ($1f108170a70c53f4$var$isErrorEvent(processedEvent) && beforeSend) return beforeSend(processedEvent, hint);
    if ($1f108170a70c53f4$var$isTransactionEvent(processedEvent)) {
        if (beforeSendSpan) {
            // process root span
            const processedRootSpanJson = beforeSendSpan((0, $becd4c7739c82027$export$d9c6b2464b0a687e)(processedEvent));
            if (!processedRootSpanJson) (0, $e89a3331adf677ac$export$d11691ff45a3e535)();
            else // update event with processed root span values
            processedEvent = (0, $b431b21a01204225$export$4950aa0f605343fb)(event, (0, $becd4c7739c82027$export$f2d8fce5ae150e92)(processedRootSpanJson));
            // process child spans
            if (processedEvent.spans) {
                const processedSpans = [];
                for (const span of processedEvent.spans){
                    const processedSpan = beforeSendSpan(span);
                    if (!processedSpan) {
                        (0, $e89a3331adf677ac$export$d11691ff45a3e535)();
                        processedSpans.push(span);
                    } else processedSpans.push(processedSpan);
                }
                processedEvent.spans = processedSpans;
            }
        }
        if (beforeSendTransaction) {
            if (processedEvent.spans) {
                // We store the # of spans before processing in SDK metadata,
                // so we can compare it afterwards to determine how many spans were dropped
                const spanCountBefore = processedEvent.spans.length;
                processedEvent.sdkProcessingMetadata = {
                    ...event.sdkProcessingMetadata,
                    spanCountBeforeProcessing: spanCountBefore
                };
            }
            return beforeSendTransaction(processedEvent, hint);
        }
    }
    return processedEvent;
}
function $1f108170a70c53f4$var$isErrorEvent(event) {
    return event.type === undefined;
}
function $1f108170a70c53f4$var$isTransactionEvent(event) {
    return event.type === "transaction";
}
/** Extract trace information from scope */ function $1f108170a70c53f4$export$fb7d833b3fdedf5f(client, scope) {
    if (!scope) return [
        undefined,
        undefined
    ];
    return (0, $0b98faa1b87c8168$export$ec58d9285c204497)(scope, ()=>{
        const span = (0, $e89a3331adf677ac$export$1be426a8e585c83e)();
        const traceContext = span ? (0, $e89a3331adf677ac$export$46c6fbd1d265ebf0)(span) : (0, $0b98faa1b87c8168$export$1e83db7ee4876dc4)(scope);
        const dynamicSamplingContext = span ? (0, $d001bfa1cb8b2131$export$a117f995597e25df)(span) : (0, $d001bfa1cb8b2131$export$89ef1736f08c6b2b)(client, scope);
        return [
            dynamicSamplingContext,
            traceContext
        ];
    });
}










/**
 * Maps a log severity level to a log severity number.
 *
 * @see LogSeverityLevel
 */ const $3b2138dd9b421ea9$export$4fb50c0840d636d1 = {
    trace: 1,
    debug: 5,
    info: 9,
    warn: 13,
    error: 17,
    fatal: 21
};




/**
 * Creates a log container envelope item for a list of logs.
 *
 * @param items - The logs to include in the envelope.
 * @returns The created log container envelope item.
 */ function $ec808d4f4634d33e$export$efdf3b13edb1118e(items) {
    return [
        {
            type: "log",
            item_count: items.length,
            content_type: "application/vnd.sentry.items.log+json"
        },
        {
            items: items
        }
    ];
}
/**
 * Creates an envelope for a list of logs.
 *
 * Logs from multiple traces can be included in the same envelope.
 *
 * @param logs - The logs to include in the envelope.
 * @param metadata - The metadata to include in the envelope.
 * @param tunnel - The tunnel to include in the envelope.
 * @param dsn - The DSN to include in the envelope.
 * @returns The created envelope.
 */ function $ec808d4f4634d33e$export$cdcd668e6516443f(logs, metadata, tunnel, dsn) {
    const headers = {};
    if (metadata?.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && !!dsn) headers.dsn = (0, $0ce64b897229c6e0$export$44d472fbb931a776)(dsn);
    return (0, $a293d580860d0106$export$f93f7f385160c44e)(headers, [
        $ec808d4f4634d33e$export$efdf3b13edb1118e(logs)
    ]);
}


const $20d4cb9d0d7789a3$var$MAX_LOG_BUFFER_SIZE = 100;
// The reference to the Client <> LogBuffer map is stored to ensure it's always the same
(0, $88208d9e04627397$export$f1a6cdb1459e81d1)._sentryClientToLogBufferMap = new WeakMap();
/**
 * Converts a log attribute to a serialized log attribute.
 *
 * @param key - The key of the log attribute.
 * @param value - The value of the log attribute.
 * @returns The serialized log attribute.
 */ function $20d4cb9d0d7789a3$export$84cb46f4adfc5d14(value) {
    switch(typeof value){
        case "number":
            if (Number.isInteger(value)) return {
                value: value,
                type: "integer"
            };
            return {
                value: value,
                type: "double"
            };
        case "boolean":
            return {
                value: value,
                type: "boolean"
            };
        case "string":
            return {
                value: value,
                type: "string"
            };
        default:
            {
                let stringValue = "";
                try {
                    stringValue = JSON.stringify(value) ?? "";
                } catch  {
                // Do nothing
                }
                return {
                    value: stringValue,
                    type: "string"
                };
            }
    }
}
/**
 * Sets a log attribute if the value exists and the attribute key is not already present.
 *
 * @param logAttributes - The log attributes object to modify.
 * @param key - The attribute key to set.
 * @param value - The value to set (only sets if truthy and key not present).
 * @param setEvenIfPresent - Whether to set the attribute if it is present. Defaults to true.
 */ function $20d4cb9d0d7789a3$var$setLogAttribute(logAttributes, key, value, setEvenIfPresent = true) {
    if (value && (!logAttributes[key] || setEvenIfPresent)) logAttributes[key] = value;
}
/**
 * Captures a serialized log event and adds it to the log buffer for the given client.
 *
 * @param client - A client. Uses the current client if not provided.
 * @param serializedLog - The serialized log event to capture.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function $20d4cb9d0d7789a3$export$743ba6f7ec19225f(client, serializedLog) {
    const logBuffer = $20d4cb9d0d7789a3$export$5365c9902fb9e770(client);
    if (logBuffer === undefined) (0, $88208d9e04627397$export$f1a6cdb1459e81d1)._sentryClientToLogBufferMap?.set(client, [
        serializedLog
    ]);
    else {
        (0, $88208d9e04627397$export$f1a6cdb1459e81d1)._sentryClientToLogBufferMap?.set(client, [
            ...logBuffer,
            serializedLog
        ]);
        if (logBuffer.length >= $20d4cb9d0d7789a3$var$MAX_LOG_BUFFER_SIZE) $20d4cb9d0d7789a3$export$f8ed83d3b6a0b504(client, logBuffer);
    }
}
/**
 * Captures a log event and sends it to Sentry.
 *
 * @param log - The log event to capture.
 * @param scope - A scope. Uses the current scope if not provided.
 * @param client - A client. Uses the current client if not provided.
 * @param captureSerializedLog - A function to capture the serialized log.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function $20d4cb9d0d7789a3$export$3ab3d16b9eebd986(beforeLog, client = (0, $0b98faa1b87c8168$export$6bb76d6eba7e258c)(), currentScope = (0, $0b98faa1b87c8168$export$c7be4b0125a10cba)(), captureSerializedLog = $20d4cb9d0d7789a3$export$743ba6f7ec19225f) {
    if (!client) {
        (0, $b5c0571e433473d8$export$16a28057038b10ef) && (0, $dfad86e498c52aee$export$af88d00dbe7f521).warn("No client available to capture log.");
        return;
    }
    const { _experiments: _experiments, release: release, environment: environment } = client.getOptions();
    const { enableLogs: enableLogs = false, beforeSendLog: beforeSendLog } = _experiments ?? {};
    if (!enableLogs) {
        (0, $b5c0571e433473d8$export$16a28057038b10ef) && (0, $dfad86e498c52aee$export$af88d00dbe7f521).warn("logging option not enabled, log will not be captured.");
        return;
    }
    const [, traceContext] = (0, $1f108170a70c53f4$export$fb7d833b3fdedf5f)(client, currentScope);
    const processedLogAttributes = {
        ...beforeLog.attributes
    };
    const { user: { id: id, email: email, username: username } } = $20d4cb9d0d7789a3$var$getMergedScopeData(currentScope);
    $20d4cb9d0d7789a3$var$setLogAttribute(processedLogAttributes, "user.id", id, false);
    $20d4cb9d0d7789a3$var$setLogAttribute(processedLogAttributes, "user.email", email, false);
    $20d4cb9d0d7789a3$var$setLogAttribute(processedLogAttributes, "user.name", username, false);
    $20d4cb9d0d7789a3$var$setLogAttribute(processedLogAttributes, "sentry.release", release);
    $20d4cb9d0d7789a3$var$setLogAttribute(processedLogAttributes, "sentry.environment", environment);
    const { name: name, version: version } = client.getSdkMetadata()?.sdk ?? {};
    $20d4cb9d0d7789a3$var$setLogAttribute(processedLogAttributes, "sentry.sdk.name", name);
    $20d4cb9d0d7789a3$var$setLogAttribute(processedLogAttributes, "sentry.sdk.version", version);
    const beforeLogMessage = beforeLog.message;
    if ((0, $ed5cb73b8752546d$export$dbcbffa59149b824)(beforeLogMessage)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ = [] } = beforeLogMessage;
        processedLogAttributes["sentry.message.template"] = __sentry_template_string__;
        __sentry_template_values__.forEach((param, index)=>{
            processedLogAttributes[`sentry.message.parameter.${index}`] = param;
        });
    }
    const span = (0, $946deb57ecfb47b9$export$91f063ebb8eff307)(currentScope);
    // Add the parent span ID to the log attributes for trace context
    $20d4cb9d0d7789a3$var$setLogAttribute(processedLogAttributes, "sentry.trace.parent_span_id", span?.spanContext().spanId);
    const processedLog = {
        ...beforeLog,
        attributes: processedLogAttributes
    };
    client.emit("beforeCaptureLog", processedLog);
    const log = beforeSendLog ? beforeSendLog(processedLog) : processedLog;
    if (!log) {
        client.recordDroppedEvent("before_send", "log_item", 1);
        (0, $b5c0571e433473d8$export$16a28057038b10ef) && (0, $dfad86e498c52aee$export$af88d00dbe7f521).warn("beforeSendLog returned null, log will not be captured.");
        return;
    }
    const { level: level, message: message, attributes: attributes = {}, severityNumber: severityNumber } = log;
    const serializedLog = {
        timestamp: (0, $14ccb306f78f15b4$export$ee52dced521e3e18)(),
        level: level,
        body: message,
        trace_id: traceContext?.trace_id,
        severity_number: severityNumber ?? (0, $3b2138dd9b421ea9$export$4fb50c0840d636d1)[level],
        attributes: Object.keys(attributes).reduce((acc, key)=>{
            acc[key] = $20d4cb9d0d7789a3$export$84cb46f4adfc5d14(attributes[key]);
            return acc;
        }, {})
    };
    captureSerializedLog(client, serializedLog);
    client.emit("afterCaptureLog", log);
}
/**
 * Flushes the logs buffer to Sentry.
 *
 * @param client - A client.
 * @param maybeLogBuffer - A log buffer. Uses the log buffer for the given client if not provided.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function $20d4cb9d0d7789a3$export$f8ed83d3b6a0b504(client, maybeLogBuffer) {
    const logBuffer = maybeLogBuffer ?? $20d4cb9d0d7789a3$export$5365c9902fb9e770(client) ?? [];
    if (logBuffer.length === 0) return;
    const clientOptions = client.getOptions();
    const envelope = (0, $ec808d4f4634d33e$export$cdcd668e6516443f)(logBuffer, clientOptions._metadata, clientOptions.tunnel, client.getDsn());
    // Clear the log buffer after envelopes have been constructed.
    (0, $88208d9e04627397$export$f1a6cdb1459e81d1)._sentryClientToLogBufferMap?.set(client, []);
    client.emit("flushLogs");
    // sendEnvelope should not throw
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    client.sendEnvelope(envelope);
}
/**
 * Returns the log buffer for a given client.
 *
 * Exported for testing purposes.
 *
 * @param client - The client to get the log buffer for.
 * @returns The log buffer for the given client.
 */ function $20d4cb9d0d7789a3$export$5365c9902fb9e770(client) {
    return (0, $88208d9e04627397$export$f1a6cdb1459e81d1)._sentryClientToLogBufferMap?.get(client);
}
/**
 * Get the scope data for the current scope after merging with the
 * global scope and isolation scope.
 *
 * @param currentScope - The current scope.
 * @returns The scope data.
 */ function $20d4cb9d0d7789a3$var$getMergedScopeData(currentScope) {
    const scopeData = (0, $0b98faa1b87c8168$export$aa55d5ab8e05984f)().getScopeData();
    (0, $6374289555580b98$export$25ac7e259a513db4)(scopeData, (0, $0b98faa1b87c8168$export$68f3af03034c9e90)().getScopeData());
    (0, $6374289555580b98$export$25ac7e259a513db4)(scopeData, currentScope.getScopeData());
    return scopeData;
}

/**
 * Tagged template function which returns parameterized representation of the message
 * For example: parameterize`This is a log statement with ${x} and ${y} params`, would return:
 * "__sentry_template_string__": 'This is a log statement with %s and %s params',
 * "__sentry_template_values__": ['first', 'second']
 *
 * @param strings An array of string values splitted between expressions
 * @param values Expressions extracted from template string
 *
 * @returns A `ParameterizedString` object that can be passed into `captureMessage` or Sentry.logger.X methods.
 */ function $48f7b345b59f4894$export$4cb5eb704d6ec224(strings, ...values) {
    const formatted = new String(String.raw(strings, ...values));
    formatted.__sentry_template_string__ = strings.join("\x00").replace(/%/g, "%%").replace(/\0/g, "%s");
    formatted.__sentry_template_values__ = values;
    return formatted;
}
/**
 * Tagged template function which returns parameterized representation of the message.
 *
 * @param strings An array of string values splitted between expressions
 * @param values Expressions extracted from template string
 * @returns A `ParameterizedString` object that can be passed into `captureMessage` or Sentry.logger.X methods.
 */ const $48f7b345b59f4894$export$bc71a178fd8db0f = $48f7b345b59f4894$export$4cb5eb704d6ec224;


/**
 * Capture a log with the given level.
 *
 * @param level - The level of the log.
 * @param message - The message to log.
 * @param attributes - Arbitrary structured data that stores information about the log - e.g., userId: 100.
 * @param severityNumber - The severity number of the log.
 */ function $af54c954d97593f2$var$captureLog(level, message, attributes, severityNumber) {
    (0, $20d4cb9d0d7789a3$export$3ab3d16b9eebd986)({
        level: level,
        message: message,
        attributes: attributes,
        severityNumber: severityNumber
    });
}
/**
 * @summary Capture a log with the `trace` level. Requires `_experiments.enableLogs` to be enabled.
 *
 * @param message - The message to log.
 * @param attributes - Arbitrary structured data that stores information about the log - e.g., { userId: 100, route: '/dashboard' }.
 *
 * @example
 *
 * ```
 * Sentry.logger.trace('User clicked submit button', {
 *   buttonId: 'submit-form',
 *   formId: 'user-profile',
 *   timestamp: Date.now()
 * });
 * ```
 *
 * @example With template strings
 *
 * ```
 * Sentry.logger.trace(Sentry.logger.fmt`User ${user} navigated to ${page}`, {
 *   userId: '123',
 *   sessionId: 'abc-xyz'
 * });
 * ```
 */ function $af54c954d97593f2$export$357889f174732d38(message, attributes) {
    $af54c954d97593f2$var$captureLog("trace", message, attributes);
}
/**
 * @summary Capture a log with the `debug` level. Requires `_experiments.enableLogs` to be enabled.
 *
 * @param message - The message to log.
 * @param attributes - Arbitrary structured data that stores information about the log - e.g., { component: 'Header', state: 'loading' }.
 *
 * @example
 *
 * ```
 * Sentry.logger.debug('Component mounted', {
 *   component: 'UserProfile',
 *   props: { userId: 123 },
 *   renderTime: 150
 * });
 * ```
 *
 * @example With template strings
 *
 * ```
 * Sentry.logger.debug(Sentry.logger.fmt`API request to ${endpoint} failed`, {
 *   statusCode: 404,
 *   requestId: 'req-123',
 *   duration: 250
 * });
 * ```
 */ function $af54c954d97593f2$export$1c9f709888824e05(message, attributes) {
    $af54c954d97593f2$var$captureLog("debug", message, attributes);
}
/**
 * @summary Capture a log with the `info` level. Requires `_experiments.enableLogs` to be enabled.
 *
 * @param message - The message to log.
 * @param attributes - Arbitrary structured data that stores information about the log - e.g., { feature: 'checkout', status: 'completed' }.
 *
 * @example
 *
 * ```
 * Sentry.logger.info('User completed checkout', {
 *   orderId: 'order-123',
 *   amount: 99.99,
 *   paymentMethod: 'credit_card'
 * });
 * ```
 *
 * @example With template strings
 *
 * ```
 * Sentry.logger.info(Sentry.logger.fmt`User ${user} updated profile picture`, {
 *   userId: 'user-123',
 *   imageSize: '2.5MB',
 *   timestamp: Date.now()
 * });
 * ```
 */ function $af54c954d97593f2$export$a80b3bd66acc52ff(message, attributes) {
    $af54c954d97593f2$var$captureLog("info", message, attributes);
}
/**
 * @summary Capture a log with the `warn` level. Requires `_experiments.enableLogs` to be enabled.
 *
 * @param message - The message to log.
 * @param attributes - Arbitrary structured data that stores information about the log - e.g., { browser: 'Chrome', version: '91.0' }.
 *
 * @example
 *
 * ```
 * Sentry.logger.warn('Browser compatibility issue detected', {
 *   browser: 'Safari',
 *   version: '14.0',
 *   feature: 'WebRTC',
 *   fallback: 'enabled'
 * });
 * ```
 *
 * @example With template strings
 *
 * ```
 * Sentry.logger.warn(Sentry.logger.fmt`API endpoint ${endpoint} is deprecated`, {
 *   recommendedEndpoint: '/api/v2/users',
 *   sunsetDate: '2024-12-31',
 *   clientVersion: '1.2.3'
 * });
 * ```
 */ function $af54c954d97593f2$export$c106dd0671a0fc2d(message, attributes) {
    $af54c954d97593f2$var$captureLog("warn", message, attributes);
}
/**
 * @summary Capture a log with the `error` level. Requires `_experiments.enableLogs` to be enabled.
 *
 * @param message - The message to log.
 * @param attributes - Arbitrary structured data that stores information about the log - e.g., { error: 'NetworkError', url: '/api/data' }.
 *
 * @example
 *
 * ```
 * Sentry.logger.error('Failed to load user data', {
 *   error: 'NetworkError',
 *   url: '/api/users/123',
 *   statusCode: 500,
 *   retryCount: 3
 * });
 * ```
 *
 * @example With template strings
 *
 * ```
 * Sentry.logger.error(Sentry.logger.fmt`Payment processing failed for order ${orderId}`, {
 *   error: 'InsufficientFunds',
 *   amount: 100.00,
 *   currency: 'USD',
 *   userId: 'user-456'
 * });
 * ```
 */ function $af54c954d97593f2$export$a3bc9b8ed74fc(message, attributes) {
    $af54c954d97593f2$var$captureLog("error", message, attributes);
}
/**
 * @summary Capture a log with the `fatal` level. Requires `_experiments.enableLogs` to be enabled.
 *
 * @param message - The message to log.
 * @param attributes - Arbitrary structured data that stores information about the log - e.g., { appState: 'corrupted', sessionId: 'abc-123' }.
 *
 * @example
 *
 * ```
 * Sentry.logger.fatal('Application state corrupted', {
 *   lastKnownState: 'authenticated',
 *   sessionId: 'session-123',
 *   timestamp: Date.now(),
 *   recoveryAttempted: true
 * });
 * ```
 *
 * @example With template strings
 *
 * ```
 * Sentry.logger.fatal(Sentry.logger.fmt`Critical system failure in ${service}`, {
 *   service: 'payment-processor',
 *   errorCode: 'CRITICAL_FAILURE',
 *   affectedUsers: 150,
 *   timestamp: Date.now()
 * });
 * ```
 */ function $af54c954d97593f2$export$570101a5202fba29(message, attributes) {
    $af54c954d97593f2$var$captureLog("fatal", message, attributes);
}





/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ const $ee7505b2004f4941$var$DEFAULT_BREADCRUMBS = 100;
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 */ function $ee7505b2004f4941$export$efda9a273d7a036d(breadcrumb, hint) {
    const client = (0, $0b98faa1b87c8168$export$6bb76d6eba7e258c)();
    const isolationScope = (0, $0b98faa1b87c8168$export$68f3af03034c9e90)();
    if (!client) return;
    const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $ee7505b2004f4941$var$DEFAULT_BREADCRUMBS } = client.getOptions();
    if (maxBreadcrumbs <= 0) return;
    const timestamp = (0, $14ccb306f78f15b4$export$7740643b9eeaf0c4)();
    const mergedBreadcrumb = {
        timestamp: timestamp,
        ...breadcrumb
    };
    const finalBreadcrumb = beforeBreadcrumb ? (0, $dfad86e498c52aee$export$cda52e2a8927a2ca)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
    if (finalBreadcrumb === null) return;
    if (client.emit) client.emit("beforeAddBreadcrumb", finalBreadcrumb, hint);
    isolationScope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
}









// We keep the handlers globally
const $ffa875045a09c5c1$var$handlers = {};
const $ffa875045a09c5c1$var$instrumented = {};
/** Add a handler function. */ function $ffa875045a09c5c1$export$a4e09611e30da72e(type, handler) {
    $ffa875045a09c5c1$var$handlers[type] = $ffa875045a09c5c1$var$handlers[type] || [];
    $ffa875045a09c5c1$var$handlers[type].push(handler);
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function $ffa875045a09c5c1$export$b17eab759a1cb5fe() {
    Object.keys($ffa875045a09c5c1$var$handlers).forEach((key)=>{
        $ffa875045a09c5c1$var$handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function $ffa875045a09c5c1$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$ffa875045a09c5c1$var$instrumented[type]) {
        $ffa875045a09c5c1$var$instrumented[type] = true;
        try {
            instrumentFn();
        } catch (e) {
            (0, $b5c0571e433473d8$export$16a28057038b10ef) && (0, $dfad86e498c52aee$export$af88d00dbe7f521).error(`Error while instrumenting ${type}`, e);
        }
    }
}
/** Trigger handlers for a given instrumentation type. */ function $ffa875045a09c5c1$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $ffa875045a09c5c1$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $b5c0571e433473d8$export$16a28057038b10ef) && (0, $dfad86e498c52aee$export$af88d00dbe7f521).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $ed9a0f1a0a69d190$export$aad197c7121a6651)(handler)}\nError:`, e);
    }
}


/**
 * Add an instrumentation handler for when a console.xxx method is called.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $08122a69e42135dc$export$1d6e0d073f9e6723(handler) {
    const type = "console";
    (0, $ffa875045a09c5c1$export$a4e09611e30da72e)(type, handler);
    (0, $ffa875045a09c5c1$export$e18d6c5462c01368)(type, $08122a69e42135dc$var$instrumentConsole);
}
function $08122a69e42135dc$var$instrumentConsole() {
    if (!("console" in (0, $88208d9e04627397$export$f1a6cdb1459e81d1))) return;
    (0, $dfad86e498c52aee$export$2a2b1d2252a69ecb).forEach(function(level) {
        if (!(level in (0, $88208d9e04627397$export$f1a6cdb1459e81d1).console)) return;
        (0, $90379bc90653c4b6$export$9563e054e6f787fb)((0, $88208d9e04627397$export$f1a6cdb1459e81d1).console, level, function(originalConsoleMethod) {
            (0, $dfad86e498c52aee$export$77c4ce905194557b)[level] = originalConsoleMethod;
            return function(...args) {
                const handlerData = {
                    args: args,
                    level: level
                };
                (0, $ffa875045a09c5c1$export$b18c893e424d3127)("console", handlerData);
                const log = (0, $dfad86e498c52aee$export$77c4ce905194557b)[level];
                log?.apply((0, $88208d9e04627397$export$f1a6cdb1459e81d1).console, args);
            };
        });
    });
}





/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ function $ef87419235eb9f8c$export$d771ef054122c30a(level) {
    return level === "warn" ? "warning" : [
        "fatal",
        "error",
        "warning",
        "log",
        "info",
        "debug"
    ].includes(level) ? level : "log";
}




const $2508206409ecec22$var$INTEGRATION_NAME = "CaptureConsole";
const $2508206409ecec22$var$_captureConsoleIntegration = (options = {})=>{
    const levels = options.levels || (0, $dfad86e498c52aee$export$2a2b1d2252a69ecb);
    const handled = options.handled ?? true;
    return {
        name: $2508206409ecec22$var$INTEGRATION_NAME,
        setup (client) {
            if (!("console" in (0, $88208d9e04627397$export$f1a6cdb1459e81d1))) return;
            (0, $08122a69e42135dc$export$1d6e0d073f9e6723)(({ args: args, level: level })=>{
                if ((0, $0b98faa1b87c8168$export$6bb76d6eba7e258c)() !== client || !levels.includes(level)) return;
                $2508206409ecec22$var$consoleHandler(args, level, handled);
            });
        }
    };
};
/**
 * Send Console API calls as Sentry Events.
 */ const $2508206409ecec22$export$caa9b6c4a4144db4 = (0, $5cfb41e3e92106c4$export$2323046b9414659f)($2508206409ecec22$var$_captureConsoleIntegration);
function $2508206409ecec22$var$consoleHandler(args, level, handled) {
    const captureContext = {
        level: (0, $ef87419235eb9f8c$export$d771ef054122c30a)(level),
        extra: {
            arguments: args
        }
    };
    (0, $0b98faa1b87c8168$export$ec58d9285c204497)((scope)=>{
        scope.addEventProcessor((event)=>{
            event.logger = "console";
            (0, $c65fa882a3254127$export$c69a9a0313b03bb1)(event, {
                handled: handled,
                type: "console"
            });
            return event;
        });
        if (level === "assert") {
            if (!args[0]) {
                const message = `Assertion failed: ${(0, $79b6b3761a352021$export$465e9d514283d4fd)(args.slice(1), " ") || "console.assert"}`;
                scope.setExtra("arguments", args.slice(1));
                (0, $584cdb98c6222991$export$45654777c133ae80)(message, captureContext);
            }
            return;
        }
        const error = args.find((arg)=>arg instanceof Error);
        if (error) {
            (0, $584cdb98c6222991$export$f5282963edea4a68)(error, captureContext);
            return;
        }
        const message = (0, $79b6b3761a352021$export$465e9d514283d4fd)(args, " ");
        (0, $584cdb98c6222991$export$45654777c133ae80)(message, captureContext);
    });
}


/**
 * Send user feedback to Sentry.
 */ function $354cf52c79b8d220$export$3b07f81befe2dd0a(params, hint = {}, scope = (0, $0b98faa1b87c8168$export$c7be4b0125a10cba)()) {
    const { message: message, name: name, email: email, url: url, source: source, associatedEventId: associatedEventId, tags: tags } = params;
    const feedbackEvent = {
        contexts: {
            feedback: {
                contact_email: email,
                name: name,
                message: message,
                url: url,
                source: source,
                associated_event_id: associatedEventId
            }
        },
        type: "feedback",
        level: "info",
        tags: tags
    };
    const client = scope?.getClient() || (0, $0b98faa1b87c8168$export$6bb76d6eba7e258c)();
    if (client) client.emit("beforeSendFeedback", feedbackEvent, hint);
    const eventId = scope.captureEvent(feedbackEvent, hint);
    return eventId;
}











const $2e4f1938d54cb3a4$var$INTEGRATION_NAME = "ConsoleLogs";
const $2e4f1938d54cb3a4$var$DEFAULT_ATTRIBUTES = {
    [(0, $34e3132ced11beec$export$cca8dd30f57f805e)]: "auto.console.logging"
};
const $2e4f1938d54cb3a4$var$_consoleLoggingIntegration = (options = {})=>{
    const levels = options.levels || (0, $dfad86e498c52aee$export$2a2b1d2252a69ecb);
    return {
        name: $2e4f1938d54cb3a4$var$INTEGRATION_NAME,
        setup (client) {
            const { _experiments: _experiments, normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = client.getOptions();
            if (!_experiments?.enableLogs) {
                (0, $b5c0571e433473d8$export$16a28057038b10ef) && (0, $dfad86e498c52aee$export$af88d00dbe7f521).warn("`_experiments.enableLogs` is not enabled, ConsoleLogs integration disabled");
                return;
            }
            (0, $08122a69e42135dc$export$1d6e0d073f9e6723)(({ args: args, level: level })=>{
                if ((0, $0b98faa1b87c8168$export$6bb76d6eba7e258c)() !== client || !levels.includes(level)) return;
                if (level === "assert") {
                    if (!args[0]) {
                        const followingArgs = args.slice(1);
                        const assertionMessage = followingArgs.length > 0 ? `Assertion failed: ${$2e4f1938d54cb3a4$var$formatConsoleArgs(followingArgs, normalizeDepth, normalizeMaxBreadth)}` : "Assertion failed";
                        (0, $20d4cb9d0d7789a3$export$3ab3d16b9eebd986)({
                            level: "error",
                            message: assertionMessage,
                            attributes: $2e4f1938d54cb3a4$var$DEFAULT_ATTRIBUTES
                        });
                    }
                    return;
                }
                const isLevelLog = level === "log";
                (0, $20d4cb9d0d7789a3$export$3ab3d16b9eebd986)({
                    level: isLevelLog ? "info" : level,
                    message: $2e4f1938d54cb3a4$var$formatConsoleArgs(args, normalizeDepth, normalizeMaxBreadth),
                    severityNumber: isLevelLog ? 10 : undefined,
                    attributes: $2e4f1938d54cb3a4$var$DEFAULT_ATTRIBUTES
                });
            });
        }
    };
};
/**
 * Captures calls to the `console` API as logs in Sentry. Requires `_experiments.enableLogs` to be enabled.
 *
 * @experimental This feature is experimental and may be changed or removed in future versions.
 *
 * By default the integration instruments `console.debug`, `console.info`, `console.warn`, `console.error`,
 * `console.log`, `console.trace`, and `console.assert`. You can use the `levels` option to customize which
 * levels are captured.
 *
 * @example
 *
 * ```ts
 * import * as Sentry from '@sentry/browser';
 *
 * Sentry.init({
 *   integrations: [Sentry.consoleLoggingIntegration({ levels: ['error', 'warn'] })],
 * });
 * ```
 */ const $2e4f1938d54cb3a4$export$63e034b6c5b5b12a = (0, $5cfb41e3e92106c4$export$2323046b9414659f)($2e4f1938d54cb3a4$var$_consoleLoggingIntegration);
function $2e4f1938d54cb3a4$var$formatConsoleArgs(values, normalizeDepth, normalizeMaxBreadth) {
    return "util" in (0, $88208d9e04627397$export$f1a6cdb1459e81d1) && typeof (0, $88208d9e04627397$export$f1a6cdb1459e81d1).util.format === "function" ? (0, $88208d9e04627397$export$f1a6cdb1459e81d1).util.format(...values) : $2e4f1938d54cb3a4$var$safeJoinConsoleArgs(values, normalizeDepth, normalizeMaxBreadth);
}
function $2e4f1938d54cb3a4$var$safeJoinConsoleArgs(values, normalizeDepth, normalizeMaxBreadth) {
    return values.map((value)=>(0, $ed5cb73b8752546d$export$c3825b437cbdea5c)(value) ? String(value) : JSON.stringify((0, $3878df912d4376ee$export$a3295358bff77e)(value, normalizeDepth, normalizeMaxBreadth))).join(" ");
}







/**
 * Wrap a callback function with error handling.
 * If an error is thrown, it will be passed to the `onError` callback and re-thrown.
 *
 * If the return value of the function is a promise, it will be handled with `maybeHandlePromiseRejection`.
 *
 * If an `onFinally` callback is provided, this will be called when the callback has finished
 * - so if it returns a promise, once the promise resolved/rejected,
 * else once the callback has finished executing.
 * The `onFinally` callback will _always_ be called, no matter if an error was thrown or not.
 */ function $da5c976124199021$export$18ce21a8b7efd7e9(fn, onError, // eslint-disable-next-line @typescript-eslint/no-empty-function
onFinally = ()=>{}) {
    let maybePromiseResult;
    try {
        maybePromiseResult = fn();
    } catch (e) {
        onError(e);
        onFinally();
        throw e;
    }
    return $da5c976124199021$var$maybeHandlePromiseRejection(maybePromiseResult, onError, onFinally);
}
/**
 * Maybe handle a promise rejection.
 * This expects to be given a value that _may_ be a promise, or any other value.
 * If it is a promise, and it rejects, it will call the `onError` callback.
 * Other than this, it will generally return the given value as-is.
 */ function $da5c976124199021$var$maybeHandlePromiseRejection(value, onError, onFinally) {
    if ((0, $ed5cb73b8752546d$export$f5b060c2914b97c8)(value)) // @ts-expect-error - the isThenable check returns the "wrong" type here
    return value.then((res)=>{
        onFinally();
        return res;
    }, (e)=>{
        onError(e);
        onFinally();
        throw e;
    });
    onFinally();
    return value;
}













/**
 * Print a log message for a started span.
 */ function $d6af7818e0c9fb81$export$2f3d84e767c9592b(span) {
    if (!(0, $b5c0571e433473d8$export$16a28057038b10ef)) return;
    const { description: description = "< unknown name >", op: op = "< unknown op >", parent_span_id: parentSpanId } = (0, $e89a3331adf677ac$export$92d8c23565496537)(span);
    const { spanId: spanId } = span.spanContext();
    const sampled = (0, $e89a3331adf677ac$export$5caecac1caaf3a71)(span);
    const rootSpan = (0, $e89a3331adf677ac$export$c4c6a79b1260ca1b)(span);
    const isRootSpan = rootSpan === span;
    const header = `[Tracing] Starting ${sampled ? "sampled" : "unsampled"} ${isRootSpan ? "root " : ""}span`;
    const infoParts = [
        `op: ${op}`,
        `name: ${description}`,
        `ID: ${spanId}`
    ];
    if (parentSpanId) infoParts.push(`parent ID: ${parentSpanId}`);
    if (!isRootSpan) {
        const { op: op, description: description } = (0, $e89a3331adf677ac$export$92d8c23565496537)(rootSpan);
        infoParts.push(`root ID: ${rootSpan.spanContext().spanId}`);
        if (op) infoParts.push(`root op: ${op}`);
        if (description) infoParts.push(`root description: ${description}`);
    }
    (0, $dfad86e498c52aee$export$af88d00dbe7f521).log(`${header}
  ${infoParts.join("\n  ")}`);
}
/**
 * Print a log message for an ended span.
 */ function $d6af7818e0c9fb81$export$b77c830667a4d630(span) {
    if (!(0, $b5c0571e433473d8$export$16a28057038b10ef)) return;
    const { description: description = "< unknown name >", op: op = "< unknown op >" } = (0, $e89a3331adf677ac$export$92d8c23565496537)(span);
    const { spanId: spanId } = span.spanContext();
    const rootSpan = (0, $e89a3331adf677ac$export$c4c6a79b1260ca1b)(span);
    const isRootSpan = rootSpan === span;
    const msg = `[Tracing] Finishing "${op}" ${isRootSpan ? "root " : ""}span "${description}" with ID ${spanId}`;
    (0, $dfad86e498c52aee$export$af88d00dbe7f521).log(msg);
}






/**
 * Makes a sampling decision for the given options.
 *
 * Called every time a root span is created. Only root spans which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 */ function $c58d92155f64fbb6$export$5f833db634b217bb(options, samplingContext, sampleRand) {
    // nothing to do if span recording is not enabled
    if (!(0, $715af054d7b34c54$export$1f70765132c3c225)(options)) return [
        false
    ];
    let localSampleRateWasApplied = undefined;
    // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` were defined, so one of these should
    // work; prefer the hook if so
    let sampleRate;
    if (typeof options.tracesSampler === "function") {
        sampleRate = options.tracesSampler({
            ...samplingContext,
            inheritOrSampleWith: (fallbackSampleRate)=>{
                // If we have an incoming parent sample rate, we'll just use that one.
                // The sampling decision will be inherited because of the sample_rand that was generated when the trace reached the incoming boundaries of the SDK.
                if (typeof samplingContext.parentSampleRate === "number") return samplingContext.parentSampleRate;
                // Fallback if parent sample rate is not on the incoming trace (e.g. if there is no baggage)
                // This is to provide backwards compatibility if there are incoming traces from older SDKs that don't send a parent sample rate or a sample rand. In these cases we just want to force either a sampling decision on the downstream traces via the sample rate.
                if (typeof samplingContext.parentSampled === "boolean") return Number(samplingContext.parentSampled);
                return fallbackSampleRate;
            }
        });
        localSampleRateWasApplied = true;
    } else if (samplingContext.parentSampled !== undefined) sampleRate = samplingContext.parentSampled;
    else if (typeof options.tracesSampleRate !== "undefined") {
        sampleRate = options.tracesSampleRate;
        localSampleRateWasApplied = true;
    }
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get.
    // (The only valid values are booleans or numbers between 0 and 1.)
    const parsedSampleRate = (0, $7c4c9604e7e6042d$export$a5bd2d81656d9546)(sampleRate);
    if (parsedSampleRate === undefined) {
        (0, $b5c0571e433473d8$export$16a28057038b10ef) && (0, $dfad86e498c52aee$export$af88d00dbe7f521).warn(`[Tracing] Discarding root span because of invalid sample rate. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(sampleRate)} of type ${JSON.stringify(typeof sampleRate)}.`);
        return [
            false
        ];
    }
    // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
    if (!parsedSampleRate) {
        (0, $b5c0571e433473d8$export$16a28057038b10ef) && (0, $dfad86e498c52aee$export$af88d00dbe7f521).log(`[Tracing] Discarding transaction because ${typeof options.tracesSampler === "function" ? "tracesSampler returned 0 or false" : "a negative sampling decision was inherited or tracesSampleRate is set to 0"}`);
        return [
            false,
            parsedSampleRate,
            localSampleRateWasApplied
        ];
    }
    // We always compare the sample rand for the current execution context against the chosen sample rate.
    // Read more: https://develop.sentry.dev/sdk/telemetry/traces/#propagated-random-value
    const shouldSample = sampleRand < parsedSampleRate;
    // if we're not going to keep it, we're done
    if (!shouldSample) (0, $b5c0571e433473d8$export$16a28057038b10ef) && (0, $dfad86e498c52aee$export$af88d00dbe7f521).log(`[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(sampleRate)})`);
    return [
        shouldSample,
        parsedSampleRate,
        localSampleRateWasApplied
    ];
}




/**
 * A Sentry Span that is non-recording, meaning it will not be sent to Sentry.
 */ class $08d90c1dc724b4e2$export$d6636b700b76c516 {
    constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $482848166ffdb9e6$export$dc6d7ea554bcce10)();
        this._spanId = spanContext.spanId || (0, $482848166ffdb9e6$export$295213bc4d0c54ad)();
    }
    /** @inheritdoc */ spanContext() {
        return {
            spanId: this._spanId,
            traceId: this._traceId,
            traceFlags: (0, $e89a3331adf677ac$export$208d5b368507fb8b)
        };
    }
    /** @inheritdoc */ // eslint-disable-next-line @typescript-eslint/no-empty-function
    end(_timestamp) {}
    /** @inheritdoc */ setAttribute(_key, _value) {
        return this;
    }
    /** @inheritdoc */ setAttributes(_values) {
        return this;
    }
    /** @inheritdoc */ setStatus(_status) {
        return this;
    }
    /** @inheritdoc */ updateName(_name) {
        return this;
    }
    /** @inheritdoc */ isRecording() {
        return false;
    }
    /** @inheritdoc */ addEvent(_name, _attributesOrStartTime, _startTime) {
        return this;
    }
    /** @inheritDoc */ addLink(_link) {
        return this;
    }
    /** @inheritDoc */ addLinks(_links) {
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {
    // noop
    }
}
















/**
 * Adds a measurement to the active transaction on the current global scope. You can optionally pass in a different span
 * as the 4th parameter.
 */ function $a6c71f13db00a683$export$7cc31b475d33a706(name, value, unit, activeSpan = (0, $e89a3331adf677ac$export$1be426a8e585c83e)()) {
    const rootSpan = activeSpan && (0, $e89a3331adf677ac$export$c4c6a79b1260ca1b)(activeSpan);
    if (rootSpan) {
        (0, $b5c0571e433473d8$export$16a28057038b10ef) && (0, $dfad86e498c52aee$export$af88d00dbe7f521).log(`[Measurement] Setting measurement on root span: ${name} = ${value} ${unit}`);
        rootSpan.addEvent(name, {
            [(0, $34e3132ced11beec$export$69cd5c610c7bb96a)]: value,
            [(0, $34e3132ced11beec$export$f5f95cff026507b5)]: unit
        });
    }
}
/**
 * Convert timed events to measurements.
 */ function $a6c71f13db00a683$export$487db6fcdf36893e(events) {
    if (!events || events.length === 0) return undefined;
    const measurements = {};
    events.forEach((event)=>{
        const attributes = event.attributes || {};
        const unit = attributes[0, $34e3132ced11beec$export$f5f95cff026507b5];
        const value = attributes[0, $34e3132ced11beec$export$69cd5c610c7bb96a];
        if (typeof unit === "string" && typeof value === "number") measurements[event.name] = {
            value: value,
            unit: unit
        };
    });
    return measurements;
}



const $fbafb03a1f6858ee$var$MAX_SPAN_COUNT = 1000;
/**
 * Span contains all data about a span
 */ class $fbafb03a1f6858ee$export$a92149b045260d9f {
    /** Epoch timestamp in seconds when the span started. */ /** Epoch timestamp in seconds when the span ended. */ /** Internal keeper of the status */ /** The timed events added to this span. */ /** if true, treat span as a standalone span (not part of a transaction) */ /**
   * You should never call the constructor manually, always use `Sentry.startSpan()`
   * or other span methods.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $482848166ffdb9e6$export$dc6d7ea554bcce10)();
        this._spanId = spanContext.spanId || (0, $482848166ffdb9e6$export$295213bc4d0c54ad)();
        this._startTime = spanContext.startTimestamp || (0, $14ccb306f78f15b4$export$ee52dced521e3e18)();
        this._links = spanContext.links;
        this._attributes = {};
        this.setAttributes({
            [(0, $34e3132ced11beec$export$cca8dd30f57f805e)]: "manual",
            [(0, $34e3132ced11beec$export$1a413bd9a88fdb09)]: spanContext.op,
            ...spanContext.attributes
        });
        this._name = spanContext.name;
        if (spanContext.parentSpanId) this._parentSpanId = spanContext.parentSpanId;
        // We want to include booleans as well here
        if ("sampled" in spanContext) this._sampled = spanContext.sampled;
        if (spanContext.endTimestamp) this._endTime = spanContext.endTimestamp;
        this._events = [];
        this._isStandaloneSpan = spanContext.isStandalone;
        // If the span is already ended, ensure we finalize the span immediately
        if (this._endTime) this._onSpanEnded();
    }
    /** @inheritDoc */ addLink(link) {
        if (this._links) this._links.push(link);
        else this._links = [
            link
        ];
        return this;
    }
    /** @inheritDoc */ addLinks(links) {
        if (this._links) this._links.push(...links);
        else this._links = links;
        return this;
    }
    /**
   * This should generally not be used,
   * but it is needed for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {
    // noop
    }
    /** @inheritdoc */ spanContext() {
        const { _spanId: spanId, _traceId: traceId, _sampled: sampled } = this;
        return {
            spanId: spanId,
            traceId: traceId,
            traceFlags: sampled ? (0, $e89a3331adf677ac$export$eb571cd9b5d98de8) : (0, $e89a3331adf677ac$export$208d5b368507fb8b)
        };
    }
    /** @inheritdoc */ setAttribute(key, value) {
        if (value === undefined) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._attributes[key];
        else this._attributes[key] = value;
        return this;
    }
    /** @inheritdoc */ setAttributes(attributes) {
        Object.keys(attributes).forEach((key)=>this.setAttribute(key, attributes[key]));
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for browser tracing where we want to adjust the start time afterwards.
   * USE THIS WITH CAUTION!
   *
   * @hidden
   * @internal
   */ updateStartTime(timeInput) {
        this._startTime = (0, $e89a3331adf677ac$export$3f7581298f56c6d7)(timeInput);
    }
    /**
   * @inheritDoc
   */ setStatus(value) {
        this._status = value;
        return this;
    }
    /**
   * @inheritDoc
   */ updateName(name) {
        this._name = name;
        this.setAttribute((0, $34e3132ced11beec$export$d7a7d984b0791405), "custom");
        return this;
    }
    /** @inheritdoc */ end(endTimestamp) {
        // If already ended, skip
        if (this._endTime) return;
        this._endTime = (0, $e89a3331adf677ac$export$3f7581298f56c6d7)(endTimestamp);
        (0, $d6af7818e0c9fb81$export$b77c830667a4d630)(this);
        this._onSpanEnded();
    }
    /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */ getSpanJSON() {
        return {
            data: this._attributes,
            description: this._name,
            op: this._attributes[0, $34e3132ced11beec$export$1a413bd9a88fdb09],
            parent_span_id: this._parentSpanId,
            span_id: this._spanId,
            start_timestamp: this._startTime,
            status: (0, $e89a3331adf677ac$export$e238a77ea3a8cd66)(this._status),
            timestamp: this._endTime,
            trace_id: this._traceId,
            origin: this._attributes[0, $34e3132ced11beec$export$cca8dd30f57f805e],
            profile_id: this._attributes[0, $34e3132ced11beec$export$1efec95406bbe327],
            exclusive_time: this._attributes[0, $34e3132ced11beec$export$fea48ba9f4550879],
            measurements: (0, $a6c71f13db00a683$export$487db6fcdf36893e)(this._events),
            is_segment: this._isStandaloneSpan && (0, $e89a3331adf677ac$export$c4c6a79b1260ca1b)(this) === this || undefined,
            segment_id: this._isStandaloneSpan ? (0, $e89a3331adf677ac$export$c4c6a79b1260ca1b)(this).spanContext().spanId : undefined,
            links: (0, $e89a3331adf677ac$export$cb3e3a12e0eec16c)(this._links)
        };
    }
    /** @inheritdoc */ isRecording() {
        return !this._endTime && !!this._sampled;
    }
    /**
   * @inheritdoc
   */ addEvent(name, attributesOrStartTime, startTime) {
        (0, $b5c0571e433473d8$export$16a28057038b10ef) && (0, $dfad86e498c52aee$export$af88d00dbe7f521).log("[Tracing] Adding an event to span:", name);
        const time = $fbafb03a1f6858ee$var$isSpanTimeInput(attributesOrStartTime) ? attributesOrStartTime : startTime || (0, $14ccb306f78f15b4$export$ee52dced521e3e18)();
        const attributes = $fbafb03a1f6858ee$var$isSpanTimeInput(attributesOrStartTime) ? {} : attributesOrStartTime || {};
        const event = {
            name: name,
            time: (0, $e89a3331adf677ac$export$3f7581298f56c6d7)(time),
            attributes: attributes
        };
        this._events.push(event);
        return this;
    }
    /**
   * This method should generally not be used,
   * but for now we need a way to publicly check if the `_isStandaloneSpan` flag is set.
   * USE THIS WITH CAUTION!
   * @internal
   * @hidden
   * @experimental
   */ isStandaloneSpan() {
        return !!this._isStandaloneSpan;
    }
    /** Emit `spanEnd` when the span is ended. */ _onSpanEnded() {
        const client = (0, $0b98faa1b87c8168$export$6bb76d6eba7e258c)();
        if (client) client.emit("spanEnd", this);
        // A segment span is basically the root span of a local span tree.
        // So for now, this is either what we previously refer to as the root span,
        // or a standalone span.
        const isSegmentSpan = this._isStandaloneSpan || this === (0, $e89a3331adf677ac$export$c4c6a79b1260ca1b)(this);
        if (!isSegmentSpan) return;
        // if this is a standalone span, we send it immediately
        if (this._isStandaloneSpan) {
            if (this._sampled) $fbafb03a1f6858ee$var$sendSpanEnvelope((0, $52dc1c4d127660c2$export$19a0081d4b39d77)([
                this
            ], client));
            else {
                (0, $b5c0571e433473d8$export$16a28057038b10ef) && (0, $dfad86e498c52aee$export$af88d00dbe7f521).log("[Tracing] Discarding standalone span because its trace was not chosen to be sampled.");
                if (client) client.recordDroppedEvent("sample_rate", "span");
            }
            return;
        }
        const transactionEvent = this._convertSpanToTransaction();
        if (transactionEvent) {
            const scope = (0, $7248b389a5580386$export$c08fbc656a245d03)(this).scope || (0, $0b98faa1b87c8168$export$c7be4b0125a10cba)();
            scope.captureEvent(transactionEvent);
        }
    }
    /**
   * Finish the transaction & prepare the event to send to Sentry.
   */ _convertSpanToTransaction() {
        // We can only convert finished spans
        if (!$fbafb03a1f6858ee$var$isFullFinishedSpan((0, $e89a3331adf677ac$export$92d8c23565496537)(this))) return undefined;
        if (!this._name) {
            (0, $b5c0571e433473d8$export$16a28057038b10ef) && (0, $dfad86e498c52aee$export$af88d00dbe7f521).warn("Transaction has no name, falling back to `<unlabeled transaction>`.");
            this._name = "<unlabeled transaction>";
        }
        const { scope: capturedSpanScope, isolationScope: capturedSpanIsolationScope } = (0, $7248b389a5580386$export$c08fbc656a245d03)(this);
        const normalizedRequest = capturedSpanScope?.getScopeData().sdkProcessingMetadata?.normalizedRequest;
        if (this._sampled !== true) return undefined;
        // The transaction span itself as well as any potential standalone spans should be filtered out
        const finishedSpans = (0, $e89a3331adf677ac$export$340c5c8a13ffc680)(this).filter((span)=>span !== this && !$fbafb03a1f6858ee$var$isStandaloneSpan(span));
        const spans = finishedSpans.map((span)=>(0, $e89a3331adf677ac$export$92d8c23565496537)(span)).filter($fbafb03a1f6858ee$var$isFullFinishedSpan);
        const source = this._attributes[0, $34e3132ced11beec$export$d7a7d984b0791405];
        // remove internal root span attributes we don't need to send.
        /* eslint-disable @typescript-eslint/no-dynamic-delete */ delete this._attributes[0, $34e3132ced11beec$export$165ce9a229f6f050];
        spans.forEach((span)=>{
            delete span.data[0, $34e3132ced11beec$export$165ce9a229f6f050];
        });
        // eslint-enabled-next-line @typescript-eslint/no-dynamic-delete
        const transaction = {
            contexts: {
                trace: (0, $e89a3331adf677ac$export$4c3967a8a2f6bbd6)(this)
            },
            spans: // spans.sort() mutates the array, but `spans` is already a copy so we can safely do this here
            // we do not use spans anymore after this point
            spans.length > $fbafb03a1f6858ee$var$MAX_SPAN_COUNT ? spans.sort((a, b)=>a.start_timestamp - b.start_timestamp).slice(0, $fbafb03a1f6858ee$var$MAX_SPAN_COUNT) : spans,
            start_timestamp: this._startTime,
            timestamp: this._endTime,
            transaction: this._name,
            type: "transaction",
            sdkProcessingMetadata: {
                capturedSpanScope: capturedSpanScope,
                capturedSpanIsolationScope: capturedSpanIsolationScope,
                dynamicSamplingContext: (0, $d001bfa1cb8b2131$export$a117f995597e25df)(this)
            },
            request: normalizedRequest,
            ...source && {
                transaction_info: {
                    source: source
                }
            }
        };
        const measurements = (0, $a6c71f13db00a683$export$487db6fcdf36893e)(this._events);
        const hasMeasurements = measurements && Object.keys(measurements).length;
        if (hasMeasurements) {
            (0, $b5c0571e433473d8$export$16a28057038b10ef) && (0, $dfad86e498c52aee$export$af88d00dbe7f521).log("[Measurements] Adding measurements to transaction event", JSON.stringify(measurements, undefined, 2));
            transaction.measurements = measurements;
        }
        return transaction;
    }
}
function $fbafb03a1f6858ee$var$isSpanTimeInput(value) {
    return value && typeof value === "number" || value instanceof Date || Array.isArray(value);
}
// We want to filter out any incomplete SpanJSON objects
function $fbafb03a1f6858ee$var$isFullFinishedSpan(input) {
    return !!input.start_timestamp && !!input.timestamp && !!input.span_id && !!input.trace_id;
}
/** `SentrySpan`s can be sent as a standalone span rather than belonging to a transaction */ function $fbafb03a1f6858ee$var$isStandaloneSpan(span) {
    return span instanceof $fbafb03a1f6858ee$export$a92149b045260d9f && span.isStandaloneSpan();
}
/**
 * Sends a `SpanEnvelope`.
 *
 * Note: If the envelope's spans are dropped, e.g. via `beforeSendSpan`,
 * the envelope will not be sent either.
 */ function $fbafb03a1f6858ee$var$sendSpanEnvelope(envelope) {
    const client = (0, $0b98faa1b87c8168$export$6bb76d6eba7e258c)();
    if (!client) return;
    const spanItems = envelope[1];
    if (!spanItems || spanItems.length === 0) {
        client.recordDroppedEvent("before_send", "span");
        return;
    }
    // sendEnvelope should not throw
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    client.sendEnvelope(envelope);
}




/* eslint-disable max-lines */ const $3bfe6b778935764d$var$SUPPRESS_TRACING_KEY = "__SENTRY_SUPPRESS_TRACING__";
/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * If you want to create a span that is not set as active, use {@link startInactiveSpan}.
 *
 * You'll always get a span passed to the callback,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function $3bfe6b778935764d$export$a1bd95187356f372(options, callback) {
    const acs = $3bfe6b778935764d$var$getAcs();
    if (acs.startSpan) return acs.startSpan(options, callback);
    const spanArguments = $3bfe6b778935764d$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan, scope: customScope } = options;
    // We still need to fork a potentially passed scope, as we set the active span on it
    // and we need to ensure that it is cleaned up properly once the span ends.
    const customForkedScope = customScope?.clone();
    return (0, $0b98faa1b87c8168$export$ec58d9285c204497)(customForkedScope, ()=>{
        // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
        const wrapper = $3bfe6b778935764d$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = (0, $0b98faa1b87c8168$export$c7be4b0125a10cba)();
            const parentSpan = $3bfe6b778935764d$var$getParentSpan(scope);
            const shouldSkipSpan = options.onlyIfParent && !parentSpan;
            const activeSpan = shouldSkipSpan ? new (0, $08d90c1dc724b4e2$export$d6636b700b76c516)() : $3bfe6b778935764d$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            (0, $946deb57ecfb47b9$export$3f25fa50c18e20ca)(scope, activeSpan);
            return (0, $da5c976124199021$export$18ce21a8b7efd7e9)(()=>callback(activeSpan), ()=>{
                // Only update the span status if it hasn't been changed yet, and the span is not yet finished
                const { status: status } = (0, $e89a3331adf677ac$export$92d8c23565496537)(activeSpan);
                if (activeSpan.isRecording() && (!status || status === "ok")) activeSpan.setStatus({
                    code: (0, $1c91772cf9c3fc39$export$f966a0446ece71e),
                    message: "internal_error"
                });
            }, ()=>{
                activeSpan.end();
            });
        });
    });
}
/**
 * Similar to `Sentry.startSpan`. Wraps a function with a transaction/span, but does not finish the span
 * after the function is done automatically. Use `span.end()` to end the span.
 *
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * You'll always get a span passed to the callback,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function $3bfe6b778935764d$export$c10292ad04b92aea(options, callback) {
    const acs = $3bfe6b778935764d$var$getAcs();
    if (acs.startSpanManual) return acs.startSpanManual(options, callback);
    const spanArguments = $3bfe6b778935764d$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan, scope: customScope } = options;
    const customForkedScope = customScope?.clone();
    return (0, $0b98faa1b87c8168$export$ec58d9285c204497)(customForkedScope, ()=>{
        // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
        const wrapper = $3bfe6b778935764d$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = (0, $0b98faa1b87c8168$export$c7be4b0125a10cba)();
            const parentSpan = $3bfe6b778935764d$var$getParentSpan(scope);
            const shouldSkipSpan = options.onlyIfParent && !parentSpan;
            const activeSpan = shouldSkipSpan ? new (0, $08d90c1dc724b4e2$export$d6636b700b76c516)() : $3bfe6b778935764d$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            (0, $946deb57ecfb47b9$export$3f25fa50c18e20ca)(scope, activeSpan);
            return (0, $da5c976124199021$export$18ce21a8b7efd7e9)(// We pass the `finish` function to the callback, so the user can finish the span manually
            // this is mainly here for historic purposes because previously, we instructed users to call
            // `finish` instead of `span.end()` to also clean up the scope. Nowadays, calling `span.end()`
            // or `finish` has the same effect and we simply leave it here to avoid breaking user code.
            ()=>callback(activeSpan, ()=>activeSpan.end()), ()=>{
                // Only update the span status if it hasn't been changed yet, and the span is not yet finished
                const { status: status } = (0, $e89a3331adf677ac$export$92d8c23565496537)(activeSpan);
                if (activeSpan.isRecording() && (!status || status === "ok")) activeSpan.setStatus({
                    code: (0, $1c91772cf9c3fc39$export$f966a0446ece71e),
                    message: "internal_error"
                });
            });
        });
    });
}
/**
 * Creates a span. This span is not set as active, so will not get automatic instrumentation spans
 * as children or be able to be accessed via `Sentry.getActiveSpan()`.
 *
 * If you want to create a span that is set as active, use {@link startSpan}.
 *
 * This function will always return a span,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function $3bfe6b778935764d$export$63dbba021a6b4047(options) {
    const acs = $3bfe6b778935764d$var$getAcs();
    if (acs.startInactiveSpan) return acs.startInactiveSpan(options);
    const spanArguments = $3bfe6b778935764d$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan } = options;
    // If `options.scope` is defined, we use this as as a wrapper,
    // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
    const wrapper = options.scope ? (callback)=>(0, $0b98faa1b87c8168$export$ec58d9285c204497)(options.scope, callback) : customParentSpan !== undefined ? (callback)=>$3bfe6b778935764d$export$e57ac09b143d92a2(customParentSpan, callback) : (callback)=>callback();
    return wrapper(()=>{
        const scope = (0, $0b98faa1b87c8168$export$c7be4b0125a10cba)();
        const parentSpan = $3bfe6b778935764d$var$getParentSpan(scope);
        const shouldSkipSpan = options.onlyIfParent && !parentSpan;
        if (shouldSkipSpan) return new (0, $08d90c1dc724b4e2$export$d6636b700b76c516)();
        return $3bfe6b778935764d$var$createChildOrRootSpan({
            parentSpan: parentSpan,
            spanArguments: spanArguments,
            forceTransaction: forceTransaction,
            scope: scope
        });
    });
}
/**
 * Continue a trace from `sentry-trace` and `baggage` values.
 * These values can be obtained from incoming request headers, or in the browser from `<meta name="sentry-trace">`
 * and `<meta name="baggage">` HTML tags.
 *
 * Spans started with `startSpan`, `startSpanManual` and `startInactiveSpan`, within the callback will automatically
 * be attached to the incoming trace.
 */ const $3bfe6b778935764d$export$d2ee9b39b25437b3 = (options, callback)=>{
    const carrier = (0, $abd13f64e43ff217$export$19eade501500c6c1)();
    const acs = (0, $eb2688584caaa46c$export$f639b0c2752203be)(carrier);
    if (acs.continueTrace) return acs.continueTrace(options, callback);
    const { sentryTrace: sentryTrace, baggage: baggage } = options;
    return (0, $0b98faa1b87c8168$export$ec58d9285c204497)((scope)=>{
        const propagationContext = (0, $e70413ee8cf08e05$export$261f383d16a93e39)(sentryTrace, baggage);
        scope.setPropagationContext(propagationContext);
        return callback();
    });
};
/**
 * Forks the current scope and sets the provided span as active span in the context of the provided callback. Can be
 * passed `null` to start an entirely new span tree.
 *
 * @param span Spans started in the context of the provided callback will be children of this span. If `null` is passed,
 * spans started within the callback will not be attached to a parent span.
 * @param callback Execution context in which the provided span will be active. Is passed the newly forked scope.
 * @returns the value returned from the provided callback function.
 */ function $3bfe6b778935764d$export$e57ac09b143d92a2(span, callback) {
    const acs = $3bfe6b778935764d$var$getAcs();
    if (acs.withActiveSpan) return acs.withActiveSpan(span, callback);
    return (0, $0b98faa1b87c8168$export$ec58d9285c204497)((scope)=>{
        (0, $946deb57ecfb47b9$export$3f25fa50c18e20ca)(scope, span || undefined);
        return callback(scope);
    });
}
/** Suppress tracing in the given callback, ensuring no spans are generated inside of it. */ function $3bfe6b778935764d$export$869298f9835abc68(callback) {
    const acs = $3bfe6b778935764d$var$getAcs();
    if (acs.suppressTracing) return acs.suppressTracing(callback);
    return (0, $0b98faa1b87c8168$export$ec58d9285c204497)((scope)=>{
        // Note: We do not wait for the callback to finish before we reset the metadata
        // the reason for this is that otherwise, in the browser this can lead to very weird behavior
        // as there is only a single top scope, if the callback takes longer to finish,
        // other, unrelated spans may also be suppressed, which we do not want
        // so instead, we only suppress tracing synchronoysly in the browser
        scope.setSDKProcessingMetadata({
            [$3bfe6b778935764d$var$SUPPRESS_TRACING_KEY]: true
        });
        const res = callback();
        scope.setSDKProcessingMetadata({
            [$3bfe6b778935764d$var$SUPPRESS_TRACING_KEY]: undefined
        });
        return res;
    });
}
/**
 * Starts a new trace for the duration of the provided callback. Spans started within the
 * callback will be part of the new trace instead of a potentially previously started trace.
 *
 * Important: Only use this function if you want to override the default trace lifetime and
 * propagation mechanism of the SDK for the duration and scope of the provided callback.
 * The newly created trace will also be the root of a new distributed trace, for example if
 * you make http requests within the callback.
 * This function might be useful if the operation you want to instrument should not be part
 * of a potentially ongoing trace.
 *
 * Default behavior:
 * - Server-side: A new trace is started for each incoming request.
 * - Browser: A new trace is started for each page our route. Navigating to a new route
 *            or page will automatically create a new trace.
 */ function $3bfe6b778935764d$export$f90b03291402f553(callback) {
    return (0, $0b98faa1b87c8168$export$ec58d9285c204497)((scope)=>{
        scope.setPropagationContext({
            traceId: (0, $482848166ffdb9e6$export$dc6d7ea554bcce10)(),
            sampleRand: Math.random()
        });
        (0, $b5c0571e433473d8$export$16a28057038b10ef) && (0, $dfad86e498c52aee$export$af88d00dbe7f521).info(`Starting a new trace with id ${scope.getPropagationContext().traceId}`);
        return $3bfe6b778935764d$export$e57ac09b143d92a2(null, callback);
    });
}
function $3bfe6b778935764d$var$createChildOrRootSpan({ parentSpan: parentSpan, spanArguments: spanArguments, forceTransaction: forceTransaction, scope: scope }) {
    if (!(0, $715af054d7b34c54$export$1f70765132c3c225)()) {
        const span = new (0, $08d90c1dc724b4e2$export$d6636b700b76c516)();
        // If this is a root span, we ensure to freeze a DSC
        // So we can have at least partial data here
        if (forceTransaction || !parentSpan) {
            const dsc = {
                sampled: "false",
                sample_rate: "0",
                transaction: spanArguments.name,
                ...(0, $d001bfa1cb8b2131$export$a117f995597e25df)(span)
            };
            (0, $d001bfa1cb8b2131$export$7398c93e763ca9fd)(span, dsc);
        }
        return span;
    }
    const isolationScope = (0, $0b98faa1b87c8168$export$68f3af03034c9e90)();
    let span;
    if (parentSpan && !forceTransaction) {
        span = $3bfe6b778935764d$var$_startChildSpan(parentSpan, scope, spanArguments);
        (0, $e89a3331adf677ac$export$81397d924722cc65)(parentSpan, span);
    } else if (parentSpan) {
        // If we forced a transaction but have a parent span, make sure to continue from the parent span, not the scope
        const dsc = (0, $d001bfa1cb8b2131$export$a117f995597e25df)(parentSpan);
        const { traceId: traceId, spanId: parentSpanId } = parentSpan.spanContext();
        const parentSampled = (0, $e89a3331adf677ac$export$5caecac1caaf3a71)(parentSpan);
        span = $3bfe6b778935764d$var$_startRootSpan({
            traceId: traceId,
            parentSpanId: parentSpanId,
            ...spanArguments
        }, scope, parentSampled);
        (0, $d001bfa1cb8b2131$export$7398c93e763ca9fd)(span, dsc);
    } else {
        const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: parentSampled } = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        span = $3bfe6b778935764d$var$_startRootSpan({
            traceId: traceId,
            parentSpanId: parentSpanId,
            ...spanArguments
        }, scope, parentSampled);
        if (dsc) (0, $d001bfa1cb8b2131$export$7398c93e763ca9fd)(span, dsc);
    }
    (0, $d6af7818e0c9fb81$export$2f3d84e767c9592b)(span);
    (0, $7248b389a5580386$export$cddb4027e3b0dd66)(span, scope, isolationScope);
    return span;
}
/**
 * This converts StartSpanOptions to SentrySpanArguments.
 * For the most part (for now) we accept the same options,
 * but some of them need to be transformed.
 */ function $3bfe6b778935764d$var$parseSentrySpanArguments(options) {
    const exp = options.experimental || {};
    const initialCtx = {
        isStandalone: exp.standalone,
        ...options
    };
    if (options.startTime) {
        const ctx = {
            ...initialCtx
        };
        ctx.startTimestamp = (0, $e89a3331adf677ac$export$3f7581298f56c6d7)(options.startTime);
        delete ctx.startTime;
        return ctx;
    }
    return initialCtx;
}
function $3bfe6b778935764d$var$getAcs() {
    const carrier = (0, $abd13f64e43ff217$export$19eade501500c6c1)();
    return (0, $eb2688584caaa46c$export$f639b0c2752203be)(carrier);
}
function $3bfe6b778935764d$var$_startRootSpan(spanArguments, scope, parentSampled) {
    const client = (0, $0b98faa1b87c8168$export$6bb76d6eba7e258c)();
    const options = client?.getOptions() || {};
    const { name: name = "" } = spanArguments;
    const mutableSpanSamplingData = {
        spanAttributes: {
            ...spanArguments.attributes
        },
        spanName: name,
        parentSampled: parentSampled
    };
    // we don't care about the decision for the moment; this is just a placeholder
    client?.emit("beforeSampling", mutableSpanSamplingData, {
        decision: false
    });
    // If hook consumers override the parentSampled flag, we will use that value instead of the actual one
    const finalParentSampled = mutableSpanSamplingData.parentSampled ?? parentSampled;
    const finalAttributes = mutableSpanSamplingData.spanAttributes;
    const currentPropagationContext = scope.getPropagationContext();
    const [sampled, sampleRate, localSampleRateWasApplied] = scope.getScopeData().sdkProcessingMetadata[$3bfe6b778935764d$var$SUPPRESS_TRACING_KEY] ? [
        false
    ] : (0, $c58d92155f64fbb6$export$5f833db634b217bb)(options, {
        name: name,
        parentSampled: finalParentSampled,
        attributes: finalAttributes,
        parentSampleRate: (0, $7c4c9604e7e6042d$export$a5bd2d81656d9546)(currentPropagationContext.dsc?.sample_rate)
    }, currentPropagationContext.sampleRand);
    const rootSpan = new (0, $fbafb03a1f6858ee$export$a92149b045260d9f)({
        ...spanArguments,
        attributes: {
            [(0, $34e3132ced11beec$export$d7a7d984b0791405)]: "custom",
            [(0, $34e3132ced11beec$export$ccfe0a40627cc34b)]: sampleRate !== undefined && localSampleRateWasApplied ? sampleRate : undefined,
            ...finalAttributes
        },
        sampled: sampled
    });
    if (!sampled && client) {
        (0, $b5c0571e433473d8$export$16a28057038b10ef) && (0, $dfad86e498c52aee$export$af88d00dbe7f521).log("[Tracing] Discarding root span because its trace was not chosen to be sampled.");
        client.recordDroppedEvent("sample_rate", "transaction");
    }
    if (client) client.emit("spanStart", rootSpan);
    return rootSpan;
}
/**
 * Creates a new `Span` while setting the current `Span.id` as `parentSpanId`.
 * This inherits the sampling decision from the parent span.
 */ function $3bfe6b778935764d$var$_startChildSpan(parentSpan, scope, spanArguments) {
    const { spanId: spanId, traceId: traceId } = parentSpan.spanContext();
    const sampled = scope.getScopeData().sdkProcessingMetadata[$3bfe6b778935764d$var$SUPPRESS_TRACING_KEY] ? false : (0, $e89a3331adf677ac$export$5caecac1caaf3a71)(parentSpan);
    const childSpan = sampled ? new (0, $fbafb03a1f6858ee$export$a92149b045260d9f)({
        ...spanArguments,
        parentSpanId: spanId,
        traceId: traceId,
        sampled: sampled
    }) : new (0, $08d90c1dc724b4e2$export$d6636b700b76c516)({
        traceId: traceId
    });
    (0, $e89a3331adf677ac$export$81397d924722cc65)(parentSpan, childSpan);
    const client = (0, $0b98faa1b87c8168$export$6bb76d6eba7e258c)();
    if (client) {
        client.emit("spanStart", childSpan);
        // If it has an endTimestamp, it's already ended
        if (spanArguments.endTimestamp) client.emit("spanEnd", childSpan);
    }
    return childSpan;
}
function $3bfe6b778935764d$var$getParentSpan(scope) {
    const span = (0, $946deb57ecfb47b9$export$91f063ebb8eff307)(scope);
    if (!span) return undefined;
    const client = (0, $0b98faa1b87c8168$export$6bb76d6eba7e258c)();
    const options = client ? client.getOptions() : {};
    if (options.parentSpanIsAlwaysRootSpan) return (0, $e89a3331adf677ac$export$c4c6a79b1260ca1b)(span);
    return span;
}
function $3bfe6b778935764d$var$getActiveSpanWrapper(parentSpan) {
    return parentSpan !== undefined ? (callback)=>{
        return $3bfe6b778935764d$export$e57ac09b143d92a2(parentSpan, callback);
    } : (callback)=>callback();
}





const $927281de959214ba$export$c8667f1887a128dc = Symbol.for("SentryBufferFullError");
/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */ function $927281de959214ba$export$85a4f67f852183e6(limit) {
    const buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0] || Promise.resolve(undefined);
    }
    /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */ function add(taskProducer) {
        if (!isReady()) return (0, $3de734ff6b883b7d$export$78e43115b553f358)($927281de959214ba$export$c8667f1887a128dc);
        // start the task and add its promise to the queue
        const task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(()=>remove(task))// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, ()=>remove(task).then(null, ()=>{
            // We have to add another catch here because `remove()` starts a new promise chain.
            }));
        return task;
    }
    /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */ function drain(timeout) {
        return new (0, $3de734ff6b883b7d$export$6f292d4960313241)((resolve, reject)=>{
            let counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            const capturedSetTimeout = setTimeout(()=>{
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach((item)=>{
                (0, $3de734ff6b883b7d$export$1fda8aa4d135f8aa)(item).then(()=>{
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}


// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend
const $47cdf2bf61f4d0ed$export$b09ce39faaeb1e7c = 60000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */ function $47cdf2bf61f4d0ed$export$615352e17ed7741(header, now = Date.now()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $47cdf2bf61f4d0ed$export$b09ce39faaeb1e7c;
}
/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */ function $47cdf2bf61f4d0ed$export$b89fc7b2e4c799e7(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */ function $47cdf2bf61f4d0ed$export$6c91fec22056810a(limits, dataCategory, now = Date.now()) {
    return $47cdf2bf61f4d0ed$export$b89fc7b2e4c799e7(limits, dataCategory) > now;
}
/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */ function $47cdf2bf61f4d0ed$export$699aff705e0d49d4(limits, { statusCode: statusCode, headers: headers }, now = Date.now()) {
    const updatedRateLimits = {
        ...limits
    };
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    const rateLimitHeader = headers?.["x-sentry-rate-limits"];
    const retryAfterHeader = headers?.["retry-after"];
    if (rateLimitHeader) /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>: <namespaces>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     *     <namespaces> Semicolon-separated list of metric namespace identifiers. Defines which namespace(s) will be affected.
     *         Only present if rate limit applies to the metric_bucket data category.
     */ for (const limit of rateLimitHeader.trim().split(",")){
        const [retryAfter, categories, , , namespaces] = limit.split(":", 5);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(";")){
            if (category === "metric_bucket") // namespaces will be present when category === 'metric_bucket'
            {
                if (!namespaces || namespaces.split(";").includes("custom")) updatedRateLimits[category] = now + delay;
            } else updatedRateLimits[category] = now + delay;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $47cdf2bf61f4d0ed$export$615352e17ed7741(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}



const $f8ec919a2acc7c86$export$e515cf6dfd2f98b8 = 64;
/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */ function $f8ec919a2acc7c86$export$d09f50d9ab7f7b69(options, makeRequest, buffer = (0, $927281de959214ba$export$85a4f67f852183e6)(options.bufferSize || $f8ec919a2acc7c86$export$e515cf6dfd2f98b8)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope) {
        const filteredEnvelopeItems = [];
        // Drop rate limited items from envelope
        (0, $a293d580860d0106$export$c56c55acf0136fd3)(envelope, (item, type)=>{
            const dataCategory = (0, $a293d580860d0106$export$b11169581eeaf237)(type);
            if ((0, $47cdf2bf61f4d0ed$export$6c91fec22056810a)(rateLimits, dataCategory)) options.recordDroppedEvent("ratelimit_backoff", dataCategory);
            else filteredEnvelopeItems.push(item);
        });
        // Skip sending if envelope is empty after filtering out rate limited events
        if (filteredEnvelopeItems.length === 0) return (0, $3de734ff6b883b7d$export$1fda8aa4d135f8aa)({});
        const filteredEnvelope = (0, $a293d580860d0106$export$f93f7f385160c44e)(envelope[0], filteredEnvelopeItems);
        // Creates client report for each item in an envelope
        const recordEnvelopeLoss = (reason)=>{
            (0, $a293d580860d0106$export$c56c55acf0136fd3)(filteredEnvelope, (item, type)=>{
                options.recordDroppedEvent(reason, (0, $a293d580860d0106$export$b11169581eeaf237)(type));
            });
        };
        const requestTask = ()=>makeRequest({
                body: (0, $a293d580860d0106$export$32f9b428425aac85)(filteredEnvelope)
            }).then((response)=>{
                // We don't want to throw on NOK responses, but we want to at least log them
                if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) (0, $b5c0571e433473d8$export$16a28057038b10ef) && (0, $dfad86e498c52aee$export$af88d00dbe7f521).warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = (0, $47cdf2bf61f4d0ed$export$699aff705e0d49d4)(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss("network_error");
                (0, $b5c0571e433473d8$export$16a28057038b10ef) && (0, $dfad86e498c52aee$export$af88d00dbe7f521).error("Encountered error running transport request:", error);
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error === (0, $927281de959214ba$export$c8667f1887a128dc)) {
                (0, $b5c0571e433473d8$export$16a28057038b10ef) && (0, $dfad86e498c52aee$export$af88d00dbe7f521).error("Skipped sending event because buffer is full.");
                recordEnvelopeLoss("queue_overflow");
                return (0, $3de734ff6b883b7d$export$1fda8aa4d135f8aa)({});
            } else throw error;
        });
    }
    return {
        send: send,
        flush: flush
    };
}





const $537c946bd548a1d5$var$INTEGRATION_NAME = "Dedupe";
const $537c946bd548a1d5$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $537c946bd548a1d5$var$INTEGRATION_NAME,
        processEvent (currentEvent) {
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            // Juuust in case something goes wrong
            try {
                if ($537c946bd548a1d5$export$3c6361fddf6cd929(currentEvent, previousEvent)) {
                    (0, $b5c0571e433473d8$export$16a28057038b10ef) && (0, $dfad86e498c52aee$export$af88d00dbe7f521).warn("Event dropped due to being a duplicate of previously captured event.");
                    return null;
                }
            } catch (_oO) {} // eslint-disable-line no-empty
            return previousEvent = currentEvent;
        }
    };
};
/**
 * Deduplication filter.
 */ const $537c946bd548a1d5$export$6d39aa44cd0c7567 = (0, $5cfb41e3e92106c4$export$2323046b9414659f)($537c946bd548a1d5$var$_dedupeIntegration);
/** only exported for tests. */ function $537c946bd548a1d5$export$3c6361fddf6cd929(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($537c946bd548a1d5$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($537c946bd548a1d5$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $537c946bd548a1d5$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$537c946bd548a1d5$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$537c946bd548a1d5$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $537c946bd548a1d5$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $537c946bd548a1d5$var$_getExceptionFromEvent(previousEvent);
    const currentException = $537c946bd548a1d5$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$537c946bd548a1d5$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$537c946bd548a1d5$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $537c946bd548a1d5$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = (0, $ed9a0f1a0a69d190$export$91d8ca51bd9f6a47)(currentEvent);
    let previousFrames = (0, $ed9a0f1a0a69d190$export$91d8ca51bd9f6a47)(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(let i = 0; i < previousFrames.length; i++){
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const frameA = previousFrames[i];
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $537c946bd548a1d5$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join("") === previousFingerprint.join(""));
    } catch (_oO) {
        return false;
    }
}
function $537c946bd548a1d5$var$_getExceptionFromEvent(event) {
    return event.exception?.values && event.exception.values[0];
}







// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const $59875e18f45a8371$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    /^Cannot redefine property: googletag$/,
    /^Can't find variable: gmo$/,
    /^undefined is not an object \(evaluating 'a\.[A-Z]'\)$/,
    'can\'t redefine non-configurable property "solana"',
    "vv().getRestrictions is not a function. (In 'vv().getRestrictions(1,a)', 'vv().getRestrictions' is undefined)",
    "Can't find variable: _AutofillCallbackHandler",
    /^Non-Error promise rejection captured with value: Object Not Found Matching Id:\d+, MethodName:simulateEvent, ParamCount:\d+$/,
    /^Java exception was raised during method invocation$/
];
/** Options for the EventFilters integration */ const $59875e18f45a8371$var$INTEGRATION_NAME = "EventFilters";
/**
 * An integration that filters out events (errors and transactions) based on:
 *
 * - (Errors) A curated list of known low-value or irrelevant errors (see {@link DEFAULT_IGNORE_ERRORS})
 * - (Errors) A list of error messages or urls/filenames passed in via
 *   - Top level Sentry.init options (`ignoreErrors`, `denyUrls`, `allowUrls`)
 *   - The same options passed to the integration directly via @param options
 * - (Transactions/Spans) A list of root span (transaction) names passed in via
 *   - Top level Sentry.init option (`ignoreTransactions`)
 *   - The same option passed to the integration directly via @param options
 *
 * Events filtered by this integration will not be sent to Sentry.
 */ const $59875e18f45a8371$export$9a84f518c163c552 = (0, $5cfb41e3e92106c4$export$2323046b9414659f)((options = {})=>{
    let mergedOptions;
    return {
        name: $59875e18f45a8371$var$INTEGRATION_NAME,
        setup (client) {
            const clientOptions = client.getOptions();
            mergedOptions = $59875e18f45a8371$var$_mergeOptions(options, clientOptions);
        },
        processEvent (event, _hint, client) {
            if (!mergedOptions) {
                const clientOptions = client.getOptions();
                mergedOptions = $59875e18f45a8371$var$_mergeOptions(options, clientOptions);
            }
            return $59875e18f45a8371$var$_shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
});
/**
 * An integration that filters out events (errors and transactions) based on:
 *
 * - (Errors) A curated list of known low-value or irrelevant errors (see {@link DEFAULT_IGNORE_ERRORS})
 * - (Errors) A list of error messages or urls/filenames passed in via
 *   - Top level Sentry.init options (`ignoreErrors`, `denyUrls`, `allowUrls`)
 *   - The same options passed to the integration directly via @param options
 * - (Transactions/Spans) A list of root span (transaction) names passed in via
 *   - Top level Sentry.init option (`ignoreTransactions`)
 *   - The same option passed to the integration directly via @param options
 *
 * Events filtered by this integration will not be sent to Sentry.
 *
 * @deprecated this integration was renamed and will be removed in a future major version.
 * Use `eventFiltersIntegration` instead.
 */ const $59875e18f45a8371$export$cb3c5c2ceb9818ba = (0, $5cfb41e3e92106c4$export$2323046b9414659f)((options = {})=>{
    return {
        ...$59875e18f45a8371$export$9a84f518c163c552(options),
        name: "InboundFilters"
    };
});
function $59875e18f45a8371$var$_mergeOptions(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : $59875e18f45a8371$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || []
        ]
    };
}
function $59875e18f45a8371$var$_shouldDropEvent(event, options) {
    if (!event.type) {
        // Filter errors
        if ($59875e18f45a8371$var$_isIgnoredError(event, options.ignoreErrors)) {
            (0, $b5c0571e433473d8$export$16a28057038b10ef) && (0, $dfad86e498c52aee$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0, $c65fa882a3254127$export$4157119e2b157127)(event)}`);
            return true;
        }
        if ($59875e18f45a8371$var$_isUselessError(event)) {
            (0, $b5c0571e433473d8$export$16a28057038b10ef) && (0, $dfad86e498c52aee$export$af88d00dbe7f521).warn(`Event dropped due to not having an error message, error type or stacktrace.\nEvent: ${(0, $c65fa882a3254127$export$4157119e2b157127)(event)}`);
            return true;
        }
        if ($59875e18f45a8371$var$_isDeniedUrl(event, options.denyUrls)) {
            (0, $b5c0571e433473d8$export$16a28057038b10ef) && (0, $dfad86e498c52aee$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0, $c65fa882a3254127$export$4157119e2b157127)(event)}.\nUrl: ${$59875e18f45a8371$var$_getEventFilterUrl(event)}`);
            return true;
        }
        if (!$59875e18f45a8371$var$_isAllowedUrl(event, options.allowUrls)) {
            (0, $b5c0571e433473d8$export$16a28057038b10ef) && (0, $dfad86e498c52aee$export$af88d00dbe7f521).warn(`Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0, $c65fa882a3254127$export$4157119e2b157127)(event)}.\nUrl: ${$59875e18f45a8371$var$_getEventFilterUrl(event)}`);
            return true;
        }
    } else if (event.type === "transaction") // Filter transactions
    {
        if ($59875e18f45a8371$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
            (0, $b5c0571e433473d8$export$16a28057038b10ef) && (0, $dfad86e498c52aee$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`ignoreTransactions\` option.\nEvent: ${(0, $c65fa882a3254127$export$4157119e2b157127)(event)}`);
            return true;
        }
    }
    return false;
}
function $59875e18f45a8371$var$_isIgnoredError(event, ignoreErrors) {
    if (!ignoreErrors?.length) return false;
    return (0, $85d228d1bd1d06f6$export$d55a97c329cacfcc)(event).some((message)=>(0, $79b6b3761a352021$export$a7a5ec66062ea5d)(message, ignoreErrors));
}
function $59875e18f45a8371$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (!ignoreTransactions?.length) return false;
    const name = event.transaction;
    return name ? (0, $79b6b3761a352021$export$a7a5ec66062ea5d)(name, ignoreTransactions) : false;
}
function $59875e18f45a8371$var$_isDeniedUrl(event, denyUrls) {
    if (!denyUrls?.length) return false;
    const url = $59875e18f45a8371$var$_getEventFilterUrl(event);
    return !url ? false : (0, $79b6b3761a352021$export$a7a5ec66062ea5d)(url, denyUrls);
}
function $59875e18f45a8371$var$_isAllowedUrl(event, allowUrls) {
    if (!allowUrls?.length) return true;
    const url = $59875e18f45a8371$var$_getEventFilterUrl(event);
    return !url ? true : (0, $79b6b3761a352021$export$a7a5ec66062ea5d)(url, allowUrls);
}
function $59875e18f45a8371$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== "<anonymous>" && frame.filename !== "[native code]") return frame.filename || null;
    }
    return null;
}
function $59875e18f45a8371$var$_getEventFilterUrl(event) {
    try {
        // If there are linked exceptions or exception aggregates we only want to match against the top frame of the "root" (the main exception)
        // The root always comes last in linked exceptions
        const rootException = [
            ...event.exception?.values ?? []
        ].reverse().find((value)=>value.mechanism?.parent_id === undefined && value.stacktrace?.frames?.length);
        const frames = rootException?.stacktrace?.frames;
        return frames ? $59875e18f45a8371$var$_getLastValidUrl(frames) : null;
    } catch (oO) {
        (0, $b5c0571e433473d8$export$16a28057038b10ef) && (0, $dfad86e498c52aee$export$af88d00dbe7f521).error(`Cannot extract url for event ${(0, $c65fa882a3254127$export$4157119e2b157127)(event)}`);
        return null;
    }
}
function $59875e18f45a8371$var$_isUselessError(event) {
    // We only want to consider events for dropping that actually have recorded exception values.
    if (!event.exception?.values?.length) return false;
    return(// No top-level message
    !event.message && // There are no exception values that have a stacktrace, a non-generic-Error type or value
    !event.exception.values.some((value)=>value.stacktrace || value.type && value.type !== "Error" || value.value));
}








const $e9166acabf7288f6$var$INTEGRATION_NAME = "ExtraErrorData";
/**
 * Extract additional data for from original exceptions.
 */ const $e9166acabf7288f6$var$_extraErrorDataIntegration = (options = {})=>{
    const { depth: depth = 3, captureErrorCause: captureErrorCause = true } = options;
    return {
        name: $e9166acabf7288f6$var$INTEGRATION_NAME,
        processEvent (event, hint, client) {
            const { maxValueLength: maxValueLength = 250 } = client.getOptions();
            return $e9166acabf7288f6$var$_enhanceEventWithErrorData(event, hint, depth, captureErrorCause, maxValueLength);
        }
    };
};
const $e9166acabf7288f6$export$6e0872131894301d = (0, $5cfb41e3e92106c4$export$2323046b9414659f)($e9166acabf7288f6$var$_extraErrorDataIntegration);
function $e9166acabf7288f6$var$_enhanceEventWithErrorData(event, hint = {}, depth, captureErrorCause, maxValueLength) {
    if (!hint.originalException || !(0, $ed5cb73b8752546d$export$e6127cc7fe7395c3)(hint.originalException)) return event;
    const exceptionName = hint.originalException.name || hint.originalException.constructor.name;
    const errorData = $e9166acabf7288f6$var$_extractErrorData(hint.originalException, captureErrorCause, maxValueLength);
    if (errorData) {
        const contexts = {
            ...event.contexts
        };
        const normalizedErrorData = (0, $3878df912d4376ee$export$a3295358bff77e)(errorData, depth);
        if ((0, $ed5cb73b8752546d$export$53b83ca8eaab0383)(normalizedErrorData)) {
            // We mark the error data as "already normalized" here, because we don't want other normalization procedures to
            // potentially truncate the data we just already normalized, with a certain depth setting.
            (0, $90379bc90653c4b6$export$e73679ffaf56810e)(normalizedErrorData, "__sentry_skip_normalization__", true);
            contexts[exceptionName] = normalizedErrorData;
        }
        return {
            ...event,
            contexts: contexts
        };
    }
    return event;
}
/**
 * Extract extra information from the Error object
 */ function $e9166acabf7288f6$var$_extractErrorData(error, captureErrorCause, maxValueLength) {
    // We are trying to enhance already existing event, so no harm done if it won't succeed
    try {
        const nativeKeys = [
            "name",
            "message",
            "stack",
            "line",
            "column",
            "fileName",
            "lineNumber",
            "columnNumber",
            "toJSON"
        ];
        const extraErrorInfo = {};
        // We want only enumerable properties, thus `getOwnPropertyNames` is redundant here, as we filter keys anyway.
        for (const key of Object.keys(error)){
            if (nativeKeys.indexOf(key) !== -1) continue;
            const value = error[key];
            extraErrorInfo[key] = (0, $ed5cb73b8752546d$export$e6127cc7fe7395c3)(value) || typeof value === "string" ? (0, $79b6b3761a352021$export$6a506b36fdea397d)(`${value}`, maxValueLength) : value;
        }
        // Error.cause is a standard property that is non enumerable, we therefore need to access it separately.
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/cause
        if (captureErrorCause && error.cause !== undefined) extraErrorInfo.cause = (0, $ed5cb73b8752546d$export$e6127cc7fe7395c3)(error.cause) ? error.cause.toString() : error.cause;
        // Check if someone attached `toJSON` method to grab even more properties (eg. axios is doing that)
        if (typeof error.toJSON === "function") {
            const serializedError = error.toJSON();
            for (const key of Object.keys(serializedError)){
                const value = serializedError[key];
                extraErrorInfo[key] = (0, $ed5cb73b8752546d$export$e6127cc7fe7395c3)(value) ? value.toString() : value;
            }
        }
        return extraErrorInfo;
    } catch (oO) {
        (0, $b5c0571e433473d8$export$16a28057038b10ef) && (0, $dfad86e498c52aee$export$af88d00dbe7f521).error("Unable to extract extra data from the Error object:", oO);
    }
    return null;
}







/**
 * Ordered LRU cache for storing feature flags in the scope context. The name
 * of each flag in the buffer is unique, and the output of getAll() is ordered
 * from oldest to newest.
 */ /**
 * Max size of the LRU flag buffer stored in Sentry scope and event contexts.
 */ const $a286eb10ef04a60d$export$55ae3ce75ec4a8a5 = 100;
/**
 * Max number of flag evaluations to record per span.
 */ const $a286eb10ef04a60d$export$d742b64c913238d0 = 10;
// Global map of spans to feature flag buffers. Populated by feature flag integrations.
(0, $88208d9e04627397$export$f1a6cdb1459e81d1)._spanToFlagBufferMap = new WeakMap();
const $a286eb10ef04a60d$var$SPAN_FLAG_ATTRIBUTE_PREFIX = "flag.evaluation.";
/**
 * Copies feature flags that are in current scope context to the event context
 */ function $a286eb10ef04a60d$export$bbaa51f7b5642e0f(event) {
    const scope = (0, $0b98faa1b87c8168$export$c7be4b0125a10cba)();
    const flagContext = scope.getScopeData().contexts.flags;
    const flagBuffer = flagContext ? flagContext.values : [];
    if (!flagBuffer.length) return event;
    if (event.contexts === undefined) event.contexts = {};
    event.contexts.flags = {
        values: [
            ...flagBuffer
        ]
    };
    return event;
}
/**
 * Inserts a flag into the current scope's context while maintaining ordered LRU properties.
 * Not thread-safe. After inserting:
 * - The flag buffer is sorted in order of recency, with the newest evaluation at the end.
 * - The names in the buffer are always unique.
 * - The length of the buffer never exceeds `maxSize`.
 *
 * @param name     Name of the feature flag to insert.
 * @param value    Value of the feature flag.
 * @param maxSize  Max number of flags the buffer should store. Default value should always be used in production.
 */ function $a286eb10ef04a60d$export$8eeb712c9ea5b068(name, value, maxSize = $a286eb10ef04a60d$export$55ae3ce75ec4a8a5) {
    const scopeContexts = (0, $0b98faa1b87c8168$export$c7be4b0125a10cba)().getScopeData().contexts;
    if (!scopeContexts.flags) scopeContexts.flags = {
        values: []
    };
    const flags = scopeContexts.flags.values;
    $a286eb10ef04a60d$export$4d53a5a3dfb988d2(flags, name, value, maxSize);
}
/**
 * Exported for tests only. Currently only accepts boolean values (otherwise no-op).
 * Inserts a flag into a FeatureFlag array while maintaining the following properties:
 * - Flags are sorted in order of recency, with the newest evaluation at the end.
 * - The flag names are always unique.
 * - The length of the array never exceeds `maxSize`.
 *
 * @param flags      The buffer to insert the flag into.
 * @param name       Name of the feature flag to insert.
 * @param value      Value of the feature flag.
 * @param maxSize    Max number of flags the buffer should store. Default value should always be used in production.
 */ function $a286eb10ef04a60d$export$4d53a5a3dfb988d2(flags, name, value, maxSize) {
    if (typeof value !== "boolean") return;
    if (flags.length > maxSize) {
        (0, $b5c0571e433473d8$export$16a28057038b10ef) && (0, $dfad86e498c52aee$export$af88d00dbe7f521).error(`[Feature Flags] insertToFlagBuffer called on a buffer larger than maxSize=${maxSize}`);
        return;
    }
    // Check if the flag is already in the buffer - O(n)
    const index = flags.findIndex((f)=>f.flag === name);
    if (index !== -1) // The flag was found, remove it from its current position - O(n)
    flags.splice(index, 1);
    if (flags.length === maxSize) // If at capacity, pop the earliest flag - O(n)
    flags.shift();
    // Push the flag to the end - O(1)
    flags.push({
        flag: name,
        result: value
    });
}
/**
 * Records a feature flag evaluation for the active span. This is a no-op for non-boolean values.
 * The flag and its value is stored in span attributes with the `flag.evaluation` prefix. Once the
 * unique flags for a span reaches maxFlagsPerSpan, subsequent flags are dropped.
 *
 * @param name             Name of the feature flag.
 * @param value            Value of the feature flag. Non-boolean values are ignored.
 * @param maxFlagsPerSpan  Max number of flags a buffer should store. Default value should always be used in production.
 */ function $a286eb10ef04a60d$export$4de324656d9a2858(name, value, maxFlagsPerSpan = $a286eb10ef04a60d$export$d742b64c913238d0) {
    const spanFlagMap = (0, $88208d9e04627397$export$f1a6cdb1459e81d1)._spanToFlagBufferMap;
    if (!spanFlagMap || typeof value !== "boolean") return;
    const span = (0, $e89a3331adf677ac$export$1be426a8e585c83e)();
    if (span) {
        const flags = spanFlagMap.get(span) || new Set();
        if (flags.has(name)) span.setAttribute(`${$a286eb10ef04a60d$var$SPAN_FLAG_ATTRIBUTE_PREFIX}${name}`, value);
        else if (flags.size < maxFlagsPerSpan) {
            flags.add(name);
            span.setAttribute(`${$a286eb10ef04a60d$var$SPAN_FLAG_ATTRIBUTE_PREFIX}${name}`, value);
        }
        spanFlagMap.set(span, flags);
    }
}


/**
 * Sentry integration for buffering feature flag evaluations manually with an API, and
 * capturing them on error events and spans.
 *
 * See the [feature flag documentation](https://develop.sentry.dev/sdk/expected-features/#feature-flags) for more information.
 *
 * @example
 * ```
 * import * as Sentry from '@sentry/browser';
 * import { type FeatureFlagsIntegration } from '@sentry/browser';
 *
 * // Setup
 * Sentry.init(..., integrations: [Sentry.featureFlagsIntegration()])
 *
 * // Verify
 * const flagsIntegration = Sentry.getClient()?.getIntegrationByName<FeatureFlagsIntegration>('FeatureFlags');
 * if (flagsIntegration) {
 *   flagsIntegration.addFeatureFlag('my-flag', true);
 * } else {
 *   // check your setup
 * }
 * Sentry.captureException(Exception('broke')); // 'my-flag' should be captured to this Sentry event.
 * ```
 */ const $a41fe4fd4129052f$export$82a435367bc83944 = (0, $5cfb41e3e92106c4$export$2323046b9414659f)(()=>{
    return {
        name: "FeatureFlags",
        processEvent (event, _hint, _client) {
            return (0, $a286eb10ef04a60d$export$bbaa51f7b5642e0f)(event);
        },
        addFeatureFlag (name, value) {
            (0, $a286eb10ef04a60d$export$8eeb712c9ea5b068)(name, value);
            (0, $a286eb10ef04a60d$export$4de324656d9a2858)(name, value);
        }
    };
});




let $4292595dc8172ea7$var$originalFunctionToString;
const $4292595dc8172ea7$var$INTEGRATION_NAME = "FunctionToString";
const $4292595dc8172ea7$var$SETUP_CLIENTS = new WeakMap();
const $4292595dc8172ea7$var$_functionToStringIntegration = ()=>{
    return {
        name: $4292595dc8172ea7$var$INTEGRATION_NAME,
        setupOnce () {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            $4292595dc8172ea7$var$originalFunctionToString = Function.prototype.toString;
            // intrinsics (like Function.prototype) might be immutable in some environments
            // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
            try {
                Function.prototype.toString = function(...args) {
                    const originalFunction = (0, $90379bc90653c4b6$export$e6cc1e135e2092e5)(this);
                    const context = $4292595dc8172ea7$var$SETUP_CLIENTS.has((0, $0b98faa1b87c8168$export$6bb76d6eba7e258c)()) && originalFunction !== undefined ? originalFunction : this;
                    return $4292595dc8172ea7$var$originalFunctionToString.apply(context, args);
                };
            } catch  {
            // ignore errors here, just don't patch this
            }
        },
        setup (client) {
            $4292595dc8172ea7$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * ```js
 * Sentry.init({
 *   integrations: [
 *     functionToStringIntegration(),
 *   ],
 * });
 * ```
 */ const $4292595dc8172ea7$export$7918117e9202e4fb = (0, $5cfb41e3e92106c4$export$2323046b9414659f)($4292595dc8172ea7$var$_functionToStringIntegration);













/**
 * Extracts trace propagation data from the current span or from the client's scope (via transaction or propagation
 * context) and serializes it to `sentry-trace` and `baggage` values to strings. These values can be used to propagate
 * a trace via our tracing Http headers or Html `<meta>` tags.
 *
 * This function also applies some validation to the generated sentry-trace and baggage values to ensure that
 * only valid strings are returned.
 *
 * @returns an object with the tracing data values. The object keys are the name of the tracing key to be used as header
 * or meta tag name.
 */ function $9602e691d7587103$export$dec8f001b9d982cb(options = {}) {
    const client = options.client || (0, $0b98faa1b87c8168$export$6bb76d6eba7e258c)();
    if (!(0, $584cdb98c6222991$export$3b029eb57ac4d562)() || !client) return {};
    const carrier = (0, $abd13f64e43ff217$export$19eade501500c6c1)();
    const acs = (0, $eb2688584caaa46c$export$f639b0c2752203be)(carrier);
    if (acs.getTraceData) return acs.getTraceData(options);
    const scope = options.scope || (0, $0b98faa1b87c8168$export$c7be4b0125a10cba)();
    const span = options.span || (0, $e89a3331adf677ac$export$1be426a8e585c83e)();
    const sentryTrace = span ? (0, $e89a3331adf677ac$export$7e9f8ae9e4a328ab)(span) : $9602e691d7587103$var$scopeToTraceHeader(scope);
    const dsc = span ? (0, $d001bfa1cb8b2131$export$a117f995597e25df)(span) : (0, $d001bfa1cb8b2131$export$89ef1736f08c6b2b)(client, scope);
    const baggage = (0, $fb4f2d687c5ee56d$export$56766feef403f365)(dsc);
    const isValidSentryTraceHeader = (0, $e70413ee8cf08e05$export$394a210812ba3012).test(sentryTrace);
    if (!isValidSentryTraceHeader) {
        (0, $dfad86e498c52aee$export$af88d00dbe7f521).warn("Invalid sentry-trace data. Cannot generate trace data");
        return {};
    }
    return {
        "sentry-trace": sentryTrace,
        baggage: baggage
    };
}
/**
 * Get a sentry-trace header value for the given scope.
 */ function $9602e691d7587103$var$scopeToTraceHeader(scope) {
    const { traceId: traceId, sampled: sampled, propagationSpanId: propagationSpanId } = scope.getPropagationContext();
    return (0, $e70413ee8cf08e05$export$f35d907436da45cf)(traceId, propagationSpanId, sampled);
}












// Based on Kamil Ogórek's work on:
// https://github.com/supabase-community/sentry-integration-js
const $d8a08a8532df871d$var$AUTH_OPERATIONS_TO_INSTRUMENT = [
    "reauthenticate",
    "signInAnonymously",
    "signInWithOAuth",
    "signInWithIdToken",
    "signInWithOtp",
    "signInWithPassword",
    "signInWithSSO",
    "signOut",
    "signUp",
    "verifyOtp"
];
const $d8a08a8532df871d$var$AUTH_ADMIN_OPERATIONS_TO_INSTRUMENT = [
    "createUser",
    "deleteUser",
    "listUsers",
    "getUserById",
    "updateUserById",
    "inviteUserByEmail"
];
const $d8a08a8532df871d$export$d0904ca37147fb52 = {
    eq: "eq",
    neq: "neq",
    gt: "gt",
    gte: "gte",
    lt: "lt",
    lte: "lte",
    like: "like",
    "like(all)": "likeAllOf",
    "like(any)": "likeAnyOf",
    ilike: "ilike",
    "ilike(all)": "ilikeAllOf",
    "ilike(any)": "ilikeAnyOf",
    is: "is",
    in: "in",
    cs: "contains",
    cd: "containedBy",
    sr: "rangeGt",
    nxl: "rangeGte",
    sl: "rangeLt",
    nxr: "rangeLte",
    adj: "rangeAdjacent",
    ov: "overlaps",
    fts: "",
    plfts: "plain",
    phfts: "phrase",
    wfts: "websearch",
    not: "not"
};
const $d8a08a8532df871d$export$31e06e7dfa7807a2 = [
    "select",
    "insert",
    "upsert",
    "update",
    "delete"
];
function $d8a08a8532df871d$var$markAsInstrumented(fn) {
    try {
        fn.__SENTRY_INSTRUMENTED__ = true;
    } catch  {
    // ignore errors here
    }
}
function $d8a08a8532df871d$var$isInstrumented(fn) {
    try {
        return fn.__SENTRY_INSTRUMENTED__;
    } catch  {
        return false;
    }
}
/**
 * Extracts the database operation type from the HTTP method and headers
 * @param method - The HTTP method of the request
 * @param headers - The request headers
 * @returns The database operation type ('select', 'insert', 'upsert', 'update', or 'delete')
 */ function $d8a08a8532df871d$export$f22380eda758c19d(method, headers = {}) {
    switch(method){
        case "GET":
            return "select";
        case "POST":
            if (headers["Prefer"]?.includes("resolution=")) return "upsert";
            else return "insert";
        case "PATCH":
            return "update";
        case "DELETE":
            return "delete";
        default:
            return "<unknown-op>";
    }
}
/**
 * Translates Supabase filter parameters into readable method names for tracing
 * @param key - The filter key from the URL search parameters
 * @param query - The filter value from the URL search parameters
 * @returns A string representation of the filter as a method call
 */ function $d8a08a8532df871d$export$d75b19044f24c22b(key, query) {
    if (query === "" || query === "*") return "select(*)";
    if (key === "select") return `select(${query})`;
    if (key === "or" || key.endsWith(".or")) return `${key}${query}`;
    const [filter, ...value] = query.split(".");
    let method;
    // Handle optional `configPart` of the filter
    if (filter?.startsWith("fts")) method = "textSearch";
    else if (filter?.startsWith("plfts")) method = "textSearch[plain]";
    else if (filter?.startsWith("phfts")) method = "textSearch[phrase]";
    else if (filter?.startsWith("wfts")) method = "textSearch[websearch]";
    else method = filter && $d8a08a8532df871d$export$d0904ca37147fb52[filter] || "filter";
    return `${method}(${key}, ${value.join(".")})`;
}
function $d8a08a8532df871d$var$instrumentAuthOperation(operation, isAdmin = false) {
    return new Proxy(operation, {
        apply (target, thisArg, argumentsList) {
            return (0, $3bfe6b778935764d$export$a1bd95187356f372)({
                name: `auth ${isAdmin ? "(admin) " : ""}${operation.name}`,
                attributes: {
                    [(0, $34e3132ced11beec$export$cca8dd30f57f805e)]: "auto.db.supabase",
                    [(0, $34e3132ced11beec$export$1a413bd9a88fdb09)]: "db",
                    "db.system": "postgresql",
                    "db.operation": `auth.${isAdmin ? "admin." : ""}${operation.name}`
                }
            }, (span)=>{
                return Reflect.apply(target, thisArg, argumentsList).then((res)=>{
                    if (res && typeof res === "object" && "error" in res && res.error) {
                        span.setStatus({
                            code: (0, $1c91772cf9c3fc39$export$f966a0446ece71e)
                        });
                        (0, $584cdb98c6222991$export$f5282963edea4a68)(res.error, {
                            mechanism: {
                                handled: false
                            }
                        });
                    } else span.setStatus({
                        code: (0, $1c91772cf9c3fc39$export$58f7963109c806fc)
                    });
                    span.end();
                    return res;
                }).catch((err)=>{
                    span.setStatus({
                        code: (0, $1c91772cf9c3fc39$export$f966a0446ece71e)
                    });
                    span.end();
                    (0, $584cdb98c6222991$export$f5282963edea4a68)(err, {
                        mechanism: {
                            handled: false
                        }
                    });
                    throw err;
                }).then(...argumentsList);
            });
        }
    });
}
function $d8a08a8532df871d$var$instrumentSupabaseAuthClient(supabaseClientInstance) {
    const auth = supabaseClientInstance.auth;
    if (!auth || $d8a08a8532df871d$var$isInstrumented(supabaseClientInstance.auth)) return;
    for (const operation of $d8a08a8532df871d$var$AUTH_OPERATIONS_TO_INSTRUMENT){
        const authOperation = auth[operation];
        if (!authOperation) continue;
        if (typeof supabaseClientInstance.auth[operation] === "function") supabaseClientInstance.auth[operation] = $d8a08a8532df871d$var$instrumentAuthOperation(authOperation);
    }
    for (const operation of $d8a08a8532df871d$var$AUTH_ADMIN_OPERATIONS_TO_INSTRUMENT){
        const authOperation = auth.admin[operation];
        if (!authOperation) continue;
        if (typeof supabaseClientInstance.auth.admin[operation] === "function") supabaseClientInstance.auth.admin[operation] = $d8a08a8532df871d$var$instrumentAuthOperation(authOperation, true);
    }
    $d8a08a8532df871d$var$markAsInstrumented(supabaseClientInstance.auth);
}
function $d8a08a8532df871d$var$instrumentSupabaseClientConstructor(SupabaseClient) {
    if ($d8a08a8532df871d$var$isInstrumented(SupabaseClient.prototype.from)) return;
    SupabaseClient.prototype.from = new Proxy(SupabaseClient.prototype.from, {
        apply (target, thisArg, argumentsList) {
            const rv = Reflect.apply(target, thisArg, argumentsList);
            const PostgRESTQueryBuilder = rv.constructor;
            $d8a08a8532df871d$var$instrumentPostgRESTQueryBuilder(PostgRESTQueryBuilder);
            return rv;
        }
    });
    $d8a08a8532df871d$var$markAsInstrumented(SupabaseClient.prototype.from);
}
function $d8a08a8532df871d$var$instrumentPostgRESTFilterBuilder(PostgRESTFilterBuilder) {
    if ($d8a08a8532df871d$var$isInstrumented(PostgRESTFilterBuilder.prototype.then)) return;
    PostgRESTFilterBuilder.prototype.then = new Proxy(PostgRESTFilterBuilder.prototype.then, {
        apply (target, thisArg, argumentsList) {
            const operations = $d8a08a8532df871d$export$31e06e7dfa7807a2;
            const typedThis = thisArg;
            const operation = $d8a08a8532df871d$export$f22380eda758c19d(typedThis.method, typedThis.headers);
            if (!operations.includes(operation)) return Reflect.apply(target, thisArg, argumentsList);
            if (!typedThis?.url?.pathname || typeof typedThis.url.pathname !== "string") return Reflect.apply(target, thisArg, argumentsList);
            const pathParts = typedThis.url.pathname.split("/");
            const table = pathParts.length > 0 ? pathParts[pathParts.length - 1] : "";
            const queryItems = [];
            for (const [key, value] of typedThis.url.searchParams.entries())// It's possible to have multiple entries for the same key, eg. `id=eq.7&id=eq.3`,
            // so we need to use array instead of object to collect them.
            queryItems.push($d8a08a8532df871d$export$d75b19044f24c22b(key, value));
            const body = Object.create(null);
            if ((0, $ed5cb73b8752546d$export$53b83ca8eaab0383)(typedThis.body)) for (const [key, value] of Object.entries(typedThis.body))body[key] = value;
            // Adding operation to the beginning of the description if it's not a `select` operation
            // For example, it can be an `insert` or `update` operation but the query can be `select(...)`
            // For `select` operations, we don't need repeat it in the description
            const description = `${operation === "select" ? "" : `${operation}${body ? "(...) " : ""}`}${queryItems.join(" ")} from(${table})`;
            const attributes = {
                "db.table": table,
                "db.schema": typedThis.schema,
                "db.url": typedThis.url.origin,
                "db.sdk": typedThis.headers["X-Client-Info"],
                "db.system": "postgresql",
                "db.operation": operation,
                [(0, $34e3132ced11beec$export$cca8dd30f57f805e)]: "auto.db.supabase",
                [(0, $34e3132ced11beec$export$1a413bd9a88fdb09)]: "db"
            };
            if (queryItems.length) attributes["db.query"] = queryItems;
            if (Object.keys(body).length) attributes["db.body"] = body;
            return (0, $3bfe6b778935764d$export$a1bd95187356f372)({
                name: description,
                attributes: attributes
            }, (span)=>{
                return Reflect.apply(target, thisArg, []).then((res)=>{
                    if (span) {
                        if (res && typeof res === "object" && "status" in res) (0, $1c91772cf9c3fc39$export$2ad6630ec8164254)(span, res.status || 500);
                        span.end();
                    }
                    if (res.error) {
                        const err = new Error(res.error.message);
                        if (res.error.code) err.code = res.error.code;
                        if (res.error.details) err.details = res.error.details;
                        const supabaseContext = {};
                        if (queryItems.length) supabaseContext.query = queryItems;
                        if (Object.keys(body).length) supabaseContext.body = body;
                        (0, $584cdb98c6222991$export$f5282963edea4a68)(err, {
                            contexts: {
                                supabase: supabaseContext
                            }
                        });
                    }
                    const breadcrumb = {
                        type: "supabase",
                        category: `db.${operation}`,
                        message: description
                    };
                    const data = {};
                    if (queryItems.length) data.query = queryItems;
                    if (Object.keys(body).length) data.body = body;
                    if (Object.keys(data).length) breadcrumb.data = data;
                    (0, $ee7505b2004f4941$export$efda9a273d7a036d)(breadcrumb);
                    return res;
                }, (err)=>{
                    if (span) {
                        (0, $1c91772cf9c3fc39$export$2ad6630ec8164254)(span, 500);
                        span.end();
                    }
                    throw err;
                }).then(...argumentsList);
            });
        }
    });
    $d8a08a8532df871d$var$markAsInstrumented(PostgRESTFilterBuilder.prototype.then);
}
function $d8a08a8532df871d$var$instrumentPostgRESTQueryBuilder(PostgRESTQueryBuilder) {
    // We need to wrap _all_ operations despite them sharing the same `PostgRESTFilterBuilder`
    // constructor, as we don't know which method will be called first, and we don't want to miss any calls.
    for (const operation of $d8a08a8532df871d$export$31e06e7dfa7807a2){
        if ($d8a08a8532df871d$var$isInstrumented(PostgRESTQueryBuilder.prototype[operation])) continue;
        PostgRESTQueryBuilder.prototype[operation] = new Proxy(PostgRESTQueryBuilder.prototype[operation], {
            apply (target, thisArg, argumentsList) {
                const rv = Reflect.apply(target, thisArg, argumentsList);
                const PostgRESTFilterBuilder = rv.constructor;
                (0, $b5c0571e433473d8$export$16a28057038b10ef) && (0, $dfad86e498c52aee$export$af88d00dbe7f521).log(`Instrumenting ${operation} operation's PostgRESTFilterBuilder`);
                $d8a08a8532df871d$var$instrumentPostgRESTFilterBuilder(PostgRESTFilterBuilder);
                return rv;
            }
        });
        $d8a08a8532df871d$var$markAsInstrumented(PostgRESTQueryBuilder.prototype[operation]);
    }
}
const $d8a08a8532df871d$export$a286d61fd33c7083 = (supabaseClient)=>{
    if (!supabaseClient) {
        (0, $b5c0571e433473d8$export$16a28057038b10ef) && (0, $dfad86e498c52aee$export$af88d00dbe7f521).warn("Supabase integration was not installed because no Supabase client was provided.");
        return;
    }
    const SupabaseClientConstructor = supabaseClient.constructor === Function ? supabaseClient : supabaseClient.constructor;
    $d8a08a8532df871d$var$instrumentSupabaseClientConstructor(SupabaseClientConstructor);
    $d8a08a8532df871d$var$instrumentSupabaseAuthClient(supabaseClient);
};
const $d8a08a8532df871d$var$INTEGRATION_NAME = "Supabase";
const $d8a08a8532df871d$var$_supabaseIntegration = (supabaseClient)=>{
    return {
        setupOnce () {
            $d8a08a8532df871d$export$a286d61fd33c7083(supabaseClient);
        },
        name: $d8a08a8532df871d$var$INTEGRATION_NAME
    };
};
const $d8a08a8532df871d$export$856ced54ce86f97e = (0, $5cfb41e3e92106c4$export$2323046b9414659f)((options)=>{
    return $d8a08a8532df871d$var$_supabaseIntegration(options.supabaseClient);
});




/**
 * Gets an event from an envelope.
 *
 * This is only exported for use in the tests
 */ function $aa34e56af930583d$export$b92f55f7516d9100(env, types) {
    let event;
    (0, $a293d580860d0106$export$c56c55acf0136fd3)(env, (item, type)=>{
        if (types.includes(type)) event = Array.isArray(item) ? item[1] : undefined;
        // bail out if we found an event
        return !!event;
    });
    return event;
}
/**
 * Creates a transport that overrides the release on all events.
 */ function $aa34e56af930583d$var$makeOverrideReleaseTransport(createTransport, release) {
    return (options)=>{
        const transport = createTransport(options);
        return {
            ...transport,
            send: async (envelope)=>{
                const event = $aa34e56af930583d$export$b92f55f7516d9100(envelope, [
                    "event",
                    "transaction",
                    "profile",
                    "replay_event"
                ]);
                if (event) event.release = release;
                return transport.send(envelope);
            }
        };
    };
}
/** Overrides the DSN in the envelope header  */ function $aa34e56af930583d$var$overrideDsn(envelope, dsn) {
    return (0, $a293d580860d0106$export$f93f7f385160c44e)(dsn ? {
        ...envelope[0],
        dsn: dsn
    } : envelope[0], envelope[1]);
}
/**
 * Creates a transport that can send events to different DSNs depending on the envelope contents.
 */ function $aa34e56af930583d$export$53bbcd410607e756(createTransport, matcher) {
    return (options)=>{
        const fallbackTransport = createTransport(options);
        const otherTransports = new Map();
        function getTransport(dsn, release) {
            // We create a transport for every unique dsn/release combination as there may be code from multiple releases in
            // use at the same time
            const key = release ? `${dsn}:${release}` : dsn;
            let transport = otherTransports.get(key);
            if (!transport) {
                const validatedDsn = (0, $0ce64b897229c6e0$export$b892860177f70a30)(dsn);
                if (!validatedDsn) return undefined;
                const url = (0, $e3f8c961f1c27003$export$9964600bfe84e6a3)(validatedDsn, options.tunnel);
                transport = release ? $aa34e56af930583d$var$makeOverrideReleaseTransport(createTransport, release)({
                    ...options,
                    url: url
                }) : createTransport({
                    ...options,
                    url: url
                });
                otherTransports.set(key, transport);
            }
            return [
                dsn,
                transport
            ];
        }
        async function send(envelope) {
            function getEvent(types) {
                const eventTypes = types?.length ? types : [
                    "event"
                ];
                return $aa34e56af930583d$export$b92f55f7516d9100(envelope, eventTypes);
            }
            const transports = matcher({
                envelope: envelope,
                getEvent: getEvent
            }).map((result)=>{
                if (typeof result === "string") return getTransport(result, undefined);
                else return getTransport(result.dsn, result.release);
            }).filter((t)=>!!t);
            // If we have no transports to send to, use the fallback transport
            // Don't override the DSN in the header for the fallback transport. '' is falsy
            const transportsWithFallback = transports.length ? transports : [
                [
                    "",
                    fallbackTransport
                ]
            ];
            const results = await Promise.all(transportsWithFallback.map(([dsn, transport])=>transport.send($aa34e56af930583d$var$overrideDsn(envelope, dsn))));
            return results[0];
        }
        async function flush(timeout) {
            const allTransports = [
                ...otherTransports.values(),
                fallbackTransport
            ];
            const results = await Promise.all(allTransports.map((transport)=>transport.flush(timeout)));
            return results.every((r)=>r);
        }
        return {
            send: send,
            flush: flush
        };
    };
}



/** Keys are source filename/url, values are metadata objects. */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $00fa8f22e96b92c2$var$filenameMetadataMap = new Map();
/** Set of stack strings that have already been parsed. */ const $00fa8f22e96b92c2$var$parsedStacks = new Set();
function $00fa8f22e96b92c2$var$ensureMetadataStacksAreParsed(parser) {
    if (!(0, $88208d9e04627397$export$f1a6cdb1459e81d1)._sentryModuleMetadata) return;
    for (const stack of Object.keys((0, $88208d9e04627397$export$f1a6cdb1459e81d1)._sentryModuleMetadata)){
        const metadata = (0, $88208d9e04627397$export$f1a6cdb1459e81d1)._sentryModuleMetadata[stack];
        if ($00fa8f22e96b92c2$var$parsedStacks.has(stack)) continue;
        // Ensure this stack doesn't get parsed again
        $00fa8f22e96b92c2$var$parsedStacks.add(stack);
        const frames = parser(stack);
        // Go through the frames starting from the top of the stack and find the first one with a filename
        for (const frame of frames.reverse())if (frame.filename) {
            // Save the metadata for this filename
            $00fa8f22e96b92c2$var$filenameMetadataMap.set(frame.filename, metadata);
            break;
        }
    }
}
/**
 * Retrieve metadata for a specific JavaScript file URL.
 *
 * Metadata is injected by the Sentry bundler plugins using the `_experiments.moduleMetadata` config option.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $00fa8f22e96b92c2$export$fb4062399a51f94a(parser, filename) {
    $00fa8f22e96b92c2$var$ensureMetadataStacksAreParsed(parser);
    return $00fa8f22e96b92c2$var$filenameMetadataMap.get(filename);
}
/**
 * Adds metadata to stack frames.
 *
 * Metadata is injected by the Sentry bundler plugins using the `_experiments.moduleMetadata` config option.
 */ function $00fa8f22e96b92c2$export$94b52ecabddf6844(parser, event) {
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            if (!exception.stacktrace) return;
            for (const frame of exception.stacktrace.frames || []){
                if (!frame.filename || frame.module_metadata) continue;
                const metadata = $00fa8f22e96b92c2$export$fb4062399a51f94a(parser, frame.filename);
                if (metadata) frame.module_metadata = metadata;
            }
        });
    } catch (_) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
}
/**
 * Strips metadata from stack frames.
 */ function $00fa8f22e96b92c2$export$5d4932fac9735eed(event) {
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            if (!exception.stacktrace) return;
            for (const frame of exception.stacktrace.frames || [])delete frame.module_metadata;
        });
    } catch (_) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
}



/**
 * Adds module metadata to stack frames.
 *
 * Metadata can be injected by the Sentry bundler plugins using the `moduleMetadata` config option.
 *
 * When this integration is added, the metadata passed to the bundler plugin is added to the stack frames of all events
 * under the `module_metadata` property. This can be used to help in tagging or routing of events from different teams
 * our sources
 */ const $23b219268b226c74$export$b3b128c3ae01ded0 = (0, $5cfb41e3e92106c4$export$2323046b9414659f)(()=>{
    return {
        name: "ModuleMetadata",
        setup (client) {
            // We need to strip metadata from stack frames before sending them to Sentry since these are client side only.
            client.on("beforeEnvelope", (envelope)=>{
                (0, $a293d580860d0106$export$c56c55acf0136fd3)(envelope, (item, type)=>{
                    if (type === "event") {
                        const event = Array.isArray(item) ? item[1] : undefined;
                        if (event) {
                            (0, $00fa8f22e96b92c2$export$5d4932fac9735eed)(event);
                            item[1] = event;
                        }
                    }
                });
            });
            client.on("applyFrameMetadata", (event)=>{
                // Only apply stack frame metadata to error events
                if (event.type) return;
                const stackParser = client.getOptions().stackParser;
                (0, $00fa8f22e96b92c2$export$94b52ecabddf6844)(stackParser, event);
            });
        }
    };
});




let $c8c70ae4e52a41c7$var$_oldOnErrorHandler = null;
/**
 * Add an instrumentation handler for when an error is captured by the global error handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $c8c70ae4e52a41c7$export$55b5c3ba2194f0c6(handler) {
    const type = "error";
    (0, $ffa875045a09c5c1$export$a4e09611e30da72e)(type, handler);
    (0, $ffa875045a09c5c1$export$e18d6c5462c01368)(type, $c8c70ae4e52a41c7$var$instrumentError);
}
function $c8c70ae4e52a41c7$var$instrumentError() {
    $c8c70ae4e52a41c7$var$_oldOnErrorHandler = (0, $88208d9e04627397$export$f1a6cdb1459e81d1).onerror;
    // Note: The reason we are doing window.onerror instead of window.addEventListener('error')
    // is that we are using this handler in the Loader Script, to handle buffered errors consistently
    (0, $88208d9e04627397$export$f1a6cdb1459e81d1).onerror = function(msg, url, line, column, error) {
        const handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        (0, $ffa875045a09c5c1$export$b18c893e424d3127)("error", handlerData);
        if ($c8c70ae4e52a41c7$var$_oldOnErrorHandler) // eslint-disable-next-line prefer-rest-params
        return $c8c70ae4e52a41c7$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    (0, $88208d9e04627397$export$f1a6cdb1459e81d1).onerror.__SENTRY_INSTRUMENTED__ = true;
}




let $54dc1fc04528211a$var$_oldOnUnhandledRejectionHandler = null;
/**
 * Add an instrumentation handler for when an unhandled promise rejection is captured.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $54dc1fc04528211a$export$8bf4fc6858821a4e(handler) {
    const type = "unhandledrejection";
    (0, $ffa875045a09c5c1$export$a4e09611e30da72e)(type, handler);
    (0, $ffa875045a09c5c1$export$e18d6c5462c01368)(type, $54dc1fc04528211a$var$instrumentUnhandledRejection);
}
function $54dc1fc04528211a$var$instrumentUnhandledRejection() {
    $54dc1fc04528211a$var$_oldOnUnhandledRejectionHandler = (0, $88208d9e04627397$export$f1a6cdb1459e81d1).onunhandledrejection;
    // Note: The reason we are doing window.onunhandledrejection instead of window.addEventListener('unhandledrejection')
    // is that we are using this handler in the Loader Script, to handle buffered rejections consistently
    (0, $88208d9e04627397$export$f1a6cdb1459e81d1).onunhandledrejection = function(e) {
        const handlerData = e;
        (0, $ffa875045a09c5c1$export$b18c893e424d3127)("unhandledrejection", handlerData);
        if ($54dc1fc04528211a$var$_oldOnUnhandledRejectionHandler) // eslint-disable-next-line prefer-rest-params
        return $54dc1fc04528211a$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    (0, $88208d9e04627397$export$f1a6cdb1459e81d1).onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}





let $7e41a6e2f43eb615$var$errorsInstrumented = false;
/**
 * Ensure that global errors automatically set the active span status.
 */ function $7e41a6e2f43eb615$export$b0914730ee1f6c80() {
    if ($7e41a6e2f43eb615$var$errorsInstrumented) return;
    $7e41a6e2f43eb615$var$errorsInstrumented = true;
    (0, $c8c70ae4e52a41c7$export$55b5c3ba2194f0c6)($7e41a6e2f43eb615$var$errorCallback);
    (0, $54dc1fc04528211a$export$8bf4fc6858821a4e)($7e41a6e2f43eb615$var$errorCallback);
}
/**
 * If an error or unhandled promise occurs, we mark the active root span as failed
 */ function $7e41a6e2f43eb615$var$errorCallback() {
    const activeSpan = (0, $e89a3331adf677ac$export$1be426a8e585c83e)();
    const rootSpan = activeSpan && (0, $e89a3331adf677ac$export$c4c6a79b1260ca1b)(activeSpan);
    if (rootSpan) {
        const message = "internal_error";
        (0, $b5c0571e433473d8$export$16a28057038b10ef) && (0, $dfad86e498c52aee$export$af88d00dbe7f521).log(`[Tracing] Root span: ${message} -> Global error occurred`);
        rootSpan.setStatus({
            code: (0, $1c91772cf9c3fc39$export$f966a0446ece71e),
            message: message
        });
    }
}
// The function name will be lost when bundling but we need to be able to identify this listener later to maintain the
// node.js default exit behaviour
$7e41a6e2f43eb615$var$errorCallback.tag = "sentry_tracingErrorCallback";


// Slightly modified (no IE8 support, ES6) and transcribed to TypeScript
// https://github.com/calvinmetcalf/rollup-plugin-node-builtins/blob/63ab8aacd013767445ca299e468d9a60a95328d7/src/es6/path.js
//
// Copyright Joyent, Inc.and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
/** JSDoc */ function $cc8ad38b0486bea1$var$normalizeArray(parts, allowAboveRoot) {
    // if the path tries to go above the root, `up` ends up > 0
    let up = 0;
    for(let i = parts.length - 1; i >= 0; i--){
        const last = parts[i];
        if (last === ".") parts.splice(i, 1);
        else if (last === "..") {
            parts.splice(i, 1);
            up++;
        } else if (up) {
            parts.splice(i, 1);
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (allowAboveRoot) for(; up--; up)parts.unshift("..");
    return parts;
}
// Split a filename into [root, dir, basename, ext], unix version
// 'root' is just a slash, or nothing.
const $cc8ad38b0486bea1$var$splitPathRe = /^(\S+:\\|\/?)([\s\S]*?)((?:\.{1,2}|[^/\\]+?|)(\.[^./\\]*|))(?:[/\\]*)$/;
/** JSDoc */ function $cc8ad38b0486bea1$var$splitPath(filename) {
    // Truncate files names greater than 1024 characters to avoid regex dos
    // https://github.com/getsentry/sentry-javascript/pull/8737#discussion_r1285719172
    const truncated = filename.length > 1024 ? `<truncated>${filename.slice(-1024)}` : filename;
    const parts = $cc8ad38b0486bea1$var$splitPathRe.exec(truncated);
    return parts ? parts.slice(1) : [];
}
// path.resolve([from ...], to)
// posix version
/** JSDoc */ function $cc8ad38b0486bea1$export$f7ad0328861e2f03(...args) {
    let resolvedPath = "";
    let resolvedAbsolute = false;
    for(let i = args.length - 1; i >= -1 && !resolvedAbsolute; i--){
        const path = i >= 0 ? args[i] : "/";
        // Skip empty entries
        if (!path) continue;
        resolvedPath = `${path}/${resolvedPath}`;
        resolvedAbsolute = path.charAt(0) === "/";
    }
    // At this point the path should be resolved to a full absolute path, but
    // handle relative paths to be safe (might happen when process.cwd() fails)
    // Normalize the path
    resolvedPath = $cc8ad38b0486bea1$var$normalizeArray(resolvedPath.split("/").filter((p)=>!!p), !resolvedAbsolute).join("/");
    return (resolvedAbsolute ? "/" : "") + resolvedPath || ".";
}
/** JSDoc */ function $cc8ad38b0486bea1$var$trim(arr) {
    let start = 0;
    for(; start < arr.length; start++){
        if (arr[start] !== "") break;
    }
    let end = arr.length - 1;
    for(; end >= 0; end--){
        if (arr[end] !== "") break;
    }
    if (start > end) return [];
    return arr.slice(start, end - start + 1);
}
// path.relative(from, to)
// posix version
/** JSDoc */ function $cc8ad38b0486bea1$export$f0e7d1106eeabbe6(from, to) {
    /* eslint-disable no-param-reassign */ from = $cc8ad38b0486bea1$export$f7ad0328861e2f03(from).slice(1);
    to = $cc8ad38b0486bea1$export$f7ad0328861e2f03(to).slice(1);
    /* eslint-enable no-param-reassign */ const fromParts = $cc8ad38b0486bea1$var$trim(from.split("/"));
    const toParts = $cc8ad38b0486bea1$var$trim(to.split("/"));
    const length = Math.min(fromParts.length, toParts.length);
    let samePartsLength = length;
    for(let i = 0; i < length; i++)if (fromParts[i] !== toParts[i]) {
        samePartsLength = i;
        break;
    }
    let outputParts = [];
    for(let i = samePartsLength; i < fromParts.length; i++)outputParts.push("..");
    outputParts = outputParts.concat(toParts.slice(samePartsLength));
    return outputParts.join("/");
}
// path.normalize(path)
// posix version
/** JSDoc */ function $cc8ad38b0486bea1$export$6af368f973c74c5(path) {
    const isPathAbsolute = $cc8ad38b0486bea1$export$e434c7255acda994(path);
    const trailingSlash = path.slice(-1) === "/";
    // Normalize the path
    let normalizedPath = $cc8ad38b0486bea1$var$normalizeArray(path.split("/").filter((p)=>!!p), !isPathAbsolute).join("/");
    if (!normalizedPath && !isPathAbsolute) normalizedPath = ".";
    if (normalizedPath && trailingSlash) normalizedPath += "/";
    return (isPathAbsolute ? "/" : "") + normalizedPath;
}
// posix version
/** JSDoc */ function $cc8ad38b0486bea1$export$e434c7255acda994(path) {
    return path.charAt(0) === "/";
}
// posix version
/** JSDoc */ function $cc8ad38b0486bea1$export$f7e2c8231c57a8bd(...args) {
    return $cc8ad38b0486bea1$export$6af368f973c74c5(args.join("/"));
}
/** JSDoc */ function $cc8ad38b0486bea1$export$7f7b8152cc673abe(path) {
    const result = $cc8ad38b0486bea1$var$splitPath(path);
    const root = result[0] || "";
    let dir = result[1];
    if (!root && !dir) // No dirname whatsoever
    return ".";
    if (dir) // It has a dirname, strip trailing slash
    dir = dir.slice(0, dir.length - 1);
    return root + dir;
}
/** JSDoc */ function $cc8ad38b0486bea1$export$9bf319d8f74f51d1(path, ext) {
    let f = $cc8ad38b0486bea1$var$splitPath(path)[2] || "";
    if (ext && f.slice(ext.length * -1) === ext) f = f.slice(0, f.length - ext.length);
    return f;
}



const $bc14ade2d1e07927$var$INTEGRATION_NAME = "RewriteFrames";
/**
 * Rewrite event frames paths.
 */ const $bc14ade2d1e07927$export$5ed0db6416cb6ea2 = (0, $5cfb41e3e92106c4$export$2323046b9414659f)((options = {})=>{
    const root = options.root;
    const prefix = options.prefix || "app:///";
    const isBrowser = "window" in (0, $88208d9e04627397$export$f1a6cdb1459e81d1) && !!(0, $88208d9e04627397$export$f1a6cdb1459e81d1).window;
    const iteratee = options.iteratee || $bc14ade2d1e07927$export$96f9867e17282d04({
        isBrowser: isBrowser,
        root: root,
        prefix: prefix
    });
    /** Process an exception event. */ function _processExceptionsEvent(event) {
        try {
            return {
                ...event,
                exception: {
                    ...event.exception,
                    // The check for this is performed inside `process` call itself, safe to skip here
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    values: event.exception.values.map((value)=>({
                            ...value,
                            ...value.stacktrace && {
                                stacktrace: _processStacktrace(value.stacktrace)
                            }
                        }))
                }
            };
        } catch (_oO) {
            return event;
        }
    }
    /** Process a stack trace. */ function _processStacktrace(stacktrace) {
        return {
            ...stacktrace,
            frames: stacktrace?.frames && stacktrace.frames.map((f)=>iteratee(f))
        };
    }
    return {
        name: $bc14ade2d1e07927$var$INTEGRATION_NAME,
        processEvent (originalEvent) {
            let processedEvent = originalEvent;
            if (originalEvent.exception && Array.isArray(originalEvent.exception.values)) processedEvent = _processExceptionsEvent(processedEvent);
            return processedEvent;
        }
    };
});
/**
 * Exported only for tests.
 */ function $bc14ade2d1e07927$export$96f9867e17282d04({ isBrowser: isBrowser, root: root, prefix: prefix }) {
    return (frame)=>{
        if (!frame.filename) return frame;
        // Determine if this is a Windows frame by checking for a Windows-style prefix such as `C:\`
        const isWindowsFrame = /^[a-zA-Z]:\\/.test(frame.filename) || // or the presence of a backslash without a forward slash (which are not allowed on Windows)
        frame.filename.includes("\\") && !frame.filename.includes("/");
        // Check if the frame filename begins with `/`
        const startsWithSlash = /^\//.test(frame.filename);
        if (isBrowser) {
            if (root) {
                const oldFilename = frame.filename;
                if (oldFilename.indexOf(root) === 0) frame.filename = oldFilename.replace(root, prefix);
            }
        } else if (isWindowsFrame || startsWithSlash) {
            const filename = isWindowsFrame ? frame.filename.replace(/^[a-zA-Z]:/, "") // remove Windows-style prefix
            .replace(/\\/g, "/") // replace all `\\` instances with `/`
             : frame.filename;
            const base = root ? (0, $cc8ad38b0486bea1$export$f0e7d1106eeabbe6)(root, filename) : (0, $cc8ad38b0486bea1$export$9bf319d8f74f51d1)(filename);
            frame.filename = `${prefix}${base}`;
        }
        return frame;
    };
}




/** A class object that can instantiate Client objects. */ /**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */ function $d57539a789385421$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $b5c0571e433473d8$export$16a28057038b10ef) (0, $dfad86e498c52aee$export$af88d00dbe7f521).enable();
        else // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
        (0, $dfad86e498c52aee$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.warn("[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.");
        });
    }
    const scope = (0, $0b98faa1b87c8168$export$c7be4b0125a10cba)();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    $d57539a789385421$export$ecb76f41d43c0e43(client);
    client.init();
    return client;
}
/**
 * Make the given client the current client.
 */ function $d57539a789385421$export$ecb76f41d43c0e43(client) {
    (0, $0b98faa1b87c8168$export$c7be4b0125a10cba)().setClient(client);
}





/**
 * This integration allows you to filter out, or tag error events that do not come from user code marked with a bundle key via the Sentry bundler plugins.
 */ const $f4f22675634e3fbf$export$be5f345197c66e53 = (0, $5cfb41e3e92106c4$export$2323046b9414659f)((options)=>{
    return {
        name: "ThirdPartyErrorsFilter",
        setup (client) {
            // We need to strip metadata from stack frames before sending them to Sentry since these are client side only.
            // TODO(lforst): Move this cleanup logic into a more central place in the SDK.
            client.on("beforeEnvelope", (envelope)=>{
                (0, $a293d580860d0106$export$c56c55acf0136fd3)(envelope, (item, type)=>{
                    if (type === "event") {
                        const event = Array.isArray(item) ? item[1] : undefined;
                        if (event) {
                            (0, $00fa8f22e96b92c2$export$5d4932fac9735eed)(event);
                            item[1] = event;
                        }
                    }
                });
            });
            client.on("applyFrameMetadata", (event)=>{
                // Only apply stack frame metadata to error events
                if (event.type) return;
                const stackParser = client.getOptions().stackParser;
                (0, $00fa8f22e96b92c2$export$94b52ecabddf6844)(stackParser, event);
            });
        },
        processEvent (event) {
            const frameKeys = $f4f22675634e3fbf$var$getBundleKeysForAllFramesWithFilenames(event);
            if (frameKeys) {
                const arrayMethod = options.behaviour === "drop-error-if-contains-third-party-frames" || options.behaviour === "apply-tag-if-contains-third-party-frames" ? "some" : "every";
                const behaviourApplies = frameKeys[arrayMethod]((keys)=>!keys.some((key)=>options.filterKeys.includes(key)));
                if (behaviourApplies) {
                    const shouldDrop = options.behaviour === "drop-error-if-contains-third-party-frames" || options.behaviour === "drop-error-if-exclusively-contains-third-party-frames";
                    if (shouldDrop) return null;
                    else event.tags = {
                        ...event.tags,
                        third_party_code: true
                    };
                }
            }
            return event;
        }
    };
});
function $f4f22675634e3fbf$var$getBundleKeysForAllFramesWithFilenames(event) {
    const frames = (0, $ed9a0f1a0a69d190$export$91d8ca51bd9f6a47)(event);
    if (!frames) return undefined;
    return frames// Exclude frames without a filename since these are likely native code or built-ins
    .filter((frame)=>!!frame.filename).map((frame)=>{
        if (frame.module_metadata) return Object.keys(frame.module_metadata).filter((key)=>key.startsWith($f4f22675634e3fbf$var$BUNDLER_PLUGIN_APP_KEY_PREFIX)).map((key)=>key.slice($f4f22675634e3fbf$var$BUNDLER_PLUGIN_APP_KEY_PREFIX.length));
        return [];
    });
}
const $f4f22675634e3fbf$var$BUNDLER_PLUGIN_APP_KEY_PREFIX = "_sentryBundlerPluginAppKey:";




const $4481da8d37c90371$var$DEFAULT_LIMIT = 10;
const $4481da8d37c90371$var$INTEGRATION_NAME = "ZodErrors";
/**
 * Simplified ZodIssue type definition
 */ function $4481da8d37c90371$var$originalExceptionIsZodError(originalException) {
    return (0, $ed5cb73b8752546d$export$e6127cc7fe7395c3)(originalException) && originalException.name === "ZodError" && Array.isArray(originalException.issues);
}
/**
 * Formats child objects or arrays to a string
 * that is preserved when sent to Sentry.
 *
 * Without this, we end up with something like this in Sentry:
 *
 * [
 *  [Object],
 *  [Object],
 *  [Object],
 *  [Object]
 * ]
 */ function $4481da8d37c90371$export$aca8f6f436c2ad07(issue) {
    return {
        ...issue,
        path: "path" in issue && Array.isArray(issue.path) ? issue.path.join(".") : undefined,
        keys: "keys" in issue ? JSON.stringify(issue.keys) : undefined,
        unionErrors: "unionErrors" in issue ? JSON.stringify(issue.unionErrors) : undefined
    };
}
/**
 * Takes ZodError issue path array and returns a flattened version as a string.
 * This makes it easier to display paths within a Sentry error message.
 *
 * Array indexes are normalized to reduce duplicate entries
 *
 * @param path ZodError issue path
 * @returns flattened path
 *
 * @example
 * flattenIssuePath([0, 'foo', 1, 'bar']) // -> '<array>.foo.<array>.bar'
 */ function $4481da8d37c90371$export$64ff46cc0375df3e(path) {
    return path.map((p)=>{
        if (typeof p === "number") return "<array>";
        else return p;
    }).join(".");
}
/**
 * Zod error message is a stringified version of ZodError.issues
 * This doesn't display well in the Sentry UI. Replace it with something shorter.
 */ function $4481da8d37c90371$export$c1fdbb35d2a2db0e(zodError) {
    const errorKeyMap = new Set();
    for (const iss of zodError.issues){
        const issuePath = $4481da8d37c90371$export$64ff46cc0375df3e(iss.path);
        if (issuePath.length > 0) errorKeyMap.add(issuePath);
    }
    const errorKeys = Array.from(errorKeyMap);
    if (errorKeys.length === 0) {
        // If there are no keys, then we're likely validating the root
        // variable rather than a key within an object. This attempts
        // to extract what type it was that failed to validate.
        // For example, z.string().parse(123) would return "string" here.
        let rootExpectedType = "variable";
        if (zodError.issues.length > 0) {
            const iss = zodError.issues[0];
            if (iss !== undefined && "expected" in iss && typeof iss.expected === "string") rootExpectedType = iss.expected;
        }
        return `Failed to validate ${rootExpectedType}`;
    }
    return `Failed to validate keys: ${(0, $79b6b3761a352021$export$6a506b36fdea397d)(errorKeys.join(", "), 100)}`;
}
/**
 * Applies ZodError issues to an event extra and replaces the error message
 */ function $4481da8d37c90371$export$a392eb5ca0ee57d9(limit, saveZodIssuesAsAttachment = false, event, hint) {
    if (!event.exception?.values || !hint.originalException || !$4481da8d37c90371$var$originalExceptionIsZodError(hint.originalException) || hint.originalException.issues.length === 0) return event;
    try {
        const issuesToFlatten = saveZodIssuesAsAttachment ? hint.originalException.issues : hint.originalException.issues.slice(0, limit);
        const flattenedIssues = issuesToFlatten.map($4481da8d37c90371$export$aca8f6f436c2ad07);
        if (saveZodIssuesAsAttachment) {
            // Sometimes having the full error details can be helpful.
            // Attachments have much higher limits, so we can include the full list of issues.
            if (!Array.isArray(hint.attachments)) hint.attachments = [];
            hint.attachments.push({
                filename: "zod_issues.json",
                data: JSON.stringify({
                    issues: flattenedIssues
                })
            });
        }
        return {
            ...event,
            exception: {
                ...event.exception,
                values: [
                    {
                        ...event.exception.values[0],
                        value: $4481da8d37c90371$export$c1fdbb35d2a2db0e(hint.originalException)
                    },
                    ...event.exception.values.slice(1)
                ]
            },
            extra: {
                ...event.extra,
                "zoderror.issues": flattenedIssues.slice(0, limit)
            }
        };
    } catch (e) {
        // Hopefully we never throw errors here, but record it
        // with the event just in case.
        return {
            ...event,
            extra: {
                ...event.extra,
                "zoderrors sentry integration parse error": {
                    message: "an exception was thrown while processing ZodError within applyZodErrorsToEvent()",
                    error: e instanceof Error ? `${e.name}: ${e.message}\n${e.stack}` : "unknown"
                }
            }
        };
    }
}
const $4481da8d37c90371$var$_zodErrorsIntegration = (options = {})=>{
    const limit = options.limit ?? $4481da8d37c90371$var$DEFAULT_LIMIT;
    return {
        name: $4481da8d37c90371$var$INTEGRATION_NAME,
        processEvent (originalEvent, hint) {
            const processedEvent = $4481da8d37c90371$export$a392eb5ca0ee57d9(limit, options.saveZodIssuesAsAttachment, originalEvent, hint);
            return processedEvent;
        }
    };
};
/**
 * Sentry integration to process Zod errors, making them easier to work with in Sentry.
 */ const $4481da8d37c90371$export$a9e1d9bd14830dfb = (0, $5cfb41e3e92106c4$export$2323046b9414659f)($4481da8d37c90371$var$_zodErrorsIntegration);



// By default, we want to infer the IP address, unless this is explicitly set to `null`
// We do this after all other processing is done
// If `ip_address` is explicitly set to `null` or a value, we leave it as is
/**
 * @internal
 */ function $fd1d3ee30d3b97fe$export$3e12ad68afa434ac(objWithMaybeUser) {
    if (objWithMaybeUser.user?.ip_address === undefined) objWithMaybeUser.user = {
        ...objWithMaybeUser.user,
        ip_address: "{{auto}}"
    };
}
/**
 * @internal
 */ function $fd1d3ee30d3b97fe$export$e8e2d07ba63e2b6c(session) {
    if ("aggregates" in session) {
        if (session.attrs?.["ip_address"] === undefined) session.attrs = {
            ...session.attrs,
            ip_address: "{{auto}}"
        };
    } else if (session.ipAddress === undefined) session.ipAddress = "{{auto}}";
}


/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 *
 * Note: This function is identical to `buildMetadata` in Remix and NextJS and SvelteKit.
 * We don't extract it for bundle size reasons.
 * @see https://github.com/getsentry/sentry-javascript/pull/7404
 * @see https://github.com/getsentry/sentry-javascript/pull/4196
 *
 * If you make changes to this function consider updating the others as well.
 *
 * @param options SDK options object that gets mutated
 * @param names list of package names
 */ function $8f798f83283d3526$export$b9f95b027256052c(options, name, names = [
    name
], source = "npm") {
    const metadata = options._metadata || {};
    if (!metadata.sdk) metadata.sdk = {
        name: `sentry.javascript.${name}`,
        packages: names.map((name)=>({
                name: `${source}:@sentry/${name}`,
                version: (0, $c62c944ea7134a72$export$31499a9cd224b78c)
            })),
        version: (0, $c62c944ea7134a72$export$31499a9cd224b78c)
    };
    options._metadata = metadata;
}

/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $0002844f30807564$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== "undefined" && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function $0002844f30807564$export$8ad33f488b1ab046() {
    // This comment is used to identify this line in the CDN bundle build step and replace this with "return 'cdn';"
    /* __SENTRY_SDK_SOURCE__ */ return "npm";
}



/**
 * This function creates an exception from a JavaScript Error
 */ function $a499dd93ae694349$export$a6c2d27607295951(stackParser, ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    const frames = $a499dd93ae694349$var$parseStackFrames(stackParser, ex);
    const exception = {
        type: $a499dd93ae694349$export$2e9ae379995d99e3(ex),
        value: $a499dd93ae694349$export$86005d1b62804363(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === "") exception.value = "Unrecoverable error caught";
    return exception;
}
function $a499dd93ae694349$var$eventFromPlainObject(stackParser, exception, syntheticException, isUnhandledRejection) {
    const client = (0, $0b98faa1b87c8168$export$6bb76d6eba7e258c)();
    const normalizeDepth = client?.getOptions().normalizeDepth;
    // If we can, we extract an exception from the object properties
    const errorFromProp = $a499dd93ae694349$var$getErrorPropertyFromObject(exception);
    const extra = {
        __serialized__: (0, $3878df912d4376ee$export$23fbbb20bed71033)(exception, normalizeDepth)
    };
    if (errorFromProp) return {
        exception: {
            values: [
                $a499dd93ae694349$export$a6c2d27607295951(stackParser, errorFromProp)
            ]
        },
        extra: extra
    };
    const event = {
        exception: {
            values: [
                {
                    type: (0, $ed5cb73b8752546d$export$9671ea99bd126ace)(exception) ? exception.constructor.name : isUnhandledRejection ? "UnhandledRejection" : "Error",
                    value: $a499dd93ae694349$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: extra
    };
    if (syntheticException) {
        const frames = $a499dd93ae694349$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) // event.exception.values[0] has been set above
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
function $a499dd93ae694349$var$eventFromError(stackParser, ex) {
    return {
        exception: {
            values: [
                $a499dd93ae694349$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
/** Parses stack frames from an error */ function $a499dd93ae694349$var$parseStackFrames(stackParser, ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    const stacktrace = ex.stacktrace || ex.stack || "";
    const skipLines = $a499dd93ae694349$var$getSkipFirstStackStringLines(ex);
    const framesToPop = $a499dd93ae694349$var$getPopFirstTopFrames(ex);
    try {
        return stackParser(stacktrace, skipLines, framesToPop);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const $a499dd93ae694349$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
/**
 * Certain known React errors contain links that would be falsely
 * parsed as frames. This function check for these errors and
 * returns number of the stack string lines to skip.
 */ function $a499dd93ae694349$var$getSkipFirstStackStringLines(ex) {
    if (ex && $a499dd93ae694349$var$reactMinifiedRegexp.test(ex.message)) return 1;
    return 0;
}
/**
 * If error has `framesToPop` property, it means that the
 * creator tells us the first x frames will be useless
 * and should be discarded. Typically error from wrapper function
 * which don't point to the actual location in the developer's code.
 *
 * Example: https://github.com/zertosh/invariant/blob/master/invariant.js#L46
 */ function $a499dd93ae694349$var$getPopFirstTopFrames(ex) {
    if (typeof ex.framesToPop === "number") return ex.framesToPop;
    return 0;
}
// https://developer.mozilla.org/en-US/docs/WebAssembly/JavaScript_interface/Exception
// @ts-expect-error - WebAssembly.Exception is a valid class
function $a499dd93ae694349$var$isWebAssemblyException(exception) {
    // Check for support
    // @ts-expect-error - WebAssembly.Exception is a valid class
    if (typeof WebAssembly !== "undefined" && typeof WebAssembly.Exception !== "undefined") // @ts-expect-error - WebAssembly.Exception is a valid class
    return exception instanceof WebAssembly.Exception;
    else return false;
}
/**
 * Extracts from errors what we use as the exception `type` in error events.
 *
 * Usually, this is the `name` property on Error objects but WASM errors need to be treated differently.
 */ function $a499dd93ae694349$export$2e9ae379995d99e3(ex) {
    const name = ex?.name;
    // The name for WebAssembly.Exception Errors needs to be extracted differently.
    // Context: https://github.com/getsentry/sentry-javascript/issues/13787
    if (!name && $a499dd93ae694349$var$isWebAssemblyException(ex)) {
        // Emscripten sets array[type, message] to the "message" property on the WebAssembly.Exception object
        const hasTypeInMessage = ex.message && Array.isArray(ex.message) && ex.message.length == 2;
        return hasTypeInMessage ? ex.message[0] : "WebAssembly.Exception";
    }
    return name;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $a499dd93ae694349$export$86005d1b62804363(ex) {
    const message = ex?.message;
    if ($a499dd93ae694349$var$isWebAssemblyException(ex)) {
        // For Node 18, Emscripten sets array[type, message] to the "message" property on the WebAssembly.Exception object
        if (Array.isArray(ex.message) && ex.message.length == 2) return ex.message[1];
        return "wasm exception";
    }
    if (!message) return "No error message";
    if (message.error && typeof message.error.message === "string") return message.error.message;
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function $a499dd93ae694349$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint?.syntheticException || undefined;
    const event = $a499dd93ae694349$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $c65fa882a3254127$export$c69a9a0313b03bb1)(event); // defaults to { type: 'generic', handled: true }
    event.level = "error";
    if (hint?.event_id) event.event_id = hint.event_id;
    return (0, $3de734ff6b883b7d$export$1fda8aa4d135f8aa)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $a499dd93ae694349$export$5425b53185d13d6c(stackParser, message, level = "info", hint, attachStacktrace) {
    const syntheticException = hint?.syntheticException || undefined;
    const event = $a499dd93ae694349$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint?.event_id) event.event_id = hint.event_id;
    return (0, $3de734ff6b883b7d$export$1fda8aa4d135f8aa)(event);
}
/**
 * @hidden
 */ function $a499dd93ae694349$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $ed5cb73b8752546d$export$9f9636d330b71954)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        const errorEvent = exception;
        return $a499dd93ae694349$var$eventFromError(stackParser, errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $ed5cb73b8752546d$export$ef9e2056653f0c8e)(exception) || (0, $ed5cb73b8752546d$export$12e869b2a583f783)(exception)) {
        const domException = exception;
        if ("stack" in exception) event = $a499dd93ae694349$var$eventFromError(stackParser, exception);
        else {
            const name = domException.name || ((0, $ed5cb73b8752546d$export$ef9e2056653f0c8e)(domException) ? "DOMError" : "DOMException");
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $a499dd93ae694349$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
            (0, $c65fa882a3254127$export$f26508487bf83ee7)(event, message);
        }
        if ("code" in domException) // eslint-disable-next-line deprecation/deprecation
        event.tags = {
            ...event.tags,
            "DOMException.code": `${domException.code}`
        };
        return event;
    }
    if ((0, $ed5cb73b8752546d$export$e6127cc7fe7395c3)(exception)) // we have a real Error object, do nothing
    return $a499dd93ae694349$var$eventFromError(stackParser, exception);
    if ((0, $ed5cb73b8752546d$export$53b83ca8eaab0383)(exception) || (0, $ed5cb73b8752546d$export$9671ea99bd126ace)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        const objectException = exception;
        event = $a499dd93ae694349$var$eventFromPlainObject(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $c65fa882a3254127$export$c69a9a0313b03bb1)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $a499dd93ae694349$var$eventFromString(stackParser, exception, syntheticException, attachStacktrace);
    (0, $c65fa882a3254127$export$f26508487bf83ee7)(event, `${exception}`, undefined);
    (0, $c65fa882a3254127$export$c69a9a0313b03bb1)(event, {
        synthetic: true
    });
    return event;
}
function $a499dd93ae694349$var$eventFromString(stackParser, message, syntheticException, attachStacktrace) {
    const event = {};
    if (attachStacktrace && syntheticException) {
        const frames = $a499dd93ae694349$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
        (0, $c65fa882a3254127$export$c69a9a0313b03bb1)(event, {
            synthetic: true
        });
    }
    if ((0, $ed5cb73b8752546d$export$dbcbffa59149b824)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function $a499dd93ae694349$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $90379bc90653c4b6$export$b0244d5063c0b61b)(exception);
    const captureType = isUnhandledRejection ? "promise rejection" : "exception";
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0, $ed5cb73b8752546d$export$9f9636d330b71954)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $ed5cb73b8752546d$export$9671ea99bd126ace)(exception)) {
        const className = $a499dd93ae694349$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $a499dd93ae694349$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch (e) {
    // ignore errors here
    }
}
/** If a plain object has a property that is an `Error`, return this error. */ function $a499dd93ae694349$var$getErrorPropertyFromObject(obj) {
    for(const prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        const value = obj[prop];
        if (value instanceof Error) return value;
    }
    return undefined;
}



/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */ const $b91089b3308fbb6b$var$DEFAULT_FLUSH_INTERVAL = 5000;
/**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ class $b91089b3308fbb6b$export$1df9218a526d318d extends (0, $1f108170a70c53f4$export$1f2bb630327ac4b6) {
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const opts = $b91089b3308fbb6b$export$4e107b20a7f977(options);
        const sdkSource = (0, $9c98becc1d3a3995$export$56d8a8a25bd48b81).SENTRY_SDK_SOURCE || (0, $0002844f30807564$export$8ad33f488b1ab046)();
        (0, $8f798f83283d3526$export$b9f95b027256052c)(opts, "browser", [
            "browser"
        ], sdkSource);
        super(opts);
        const { sendDefaultPii: sendDefaultPii, sendClientReports: sendClientReports, _experiments: _experiments } = this._options;
        const enableLogs = _experiments?.enableLogs;
        if ((0, $9c98becc1d3a3995$export$56d8a8a25bd48b81).document && (sendClientReports || enableLogs)) (0, $9c98becc1d3a3995$export$56d8a8a25bd48b81).document.addEventListener("visibilitychange", ()=>{
            if ((0, $9c98becc1d3a3995$export$56d8a8a25bd48b81).document.visibilityState === "hidden") {
                if (sendClientReports) this._flushOutcomes();
                if (enableLogs) (0, $20d4cb9d0d7789a3$export$f8ed83d3b6a0b504)(this);
            }
        });
        if (enableLogs) {
            this.on("flush", ()=>{
                (0, $20d4cb9d0d7789a3$export$f8ed83d3b6a0b504)(this);
            });
            this.on("afterCaptureLog", ()=>{
                if (this._logFlushIdleTimeout) clearTimeout(this._logFlushIdleTimeout);
                this._logFlushIdleTimeout = setTimeout(()=>{
                    (0, $20d4cb9d0d7789a3$export$f8ed83d3b6a0b504)(this);
                }, $b91089b3308fbb6b$var$DEFAULT_FLUSH_INTERVAL);
            });
        }
        if (sendDefaultPii) {
            this.on("postprocessEvent", (0, $fd1d3ee30d3b97fe$export$3e12ad68afa434ac));
            this.on("beforeSendSession", (0, $fd1d3ee30d3b97fe$export$e8e2d07ba63e2b6c));
        }
    }
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $a499dd93ae694349$export$ea3ec7e569b823fc)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, level = "info", hint) {
        return (0, $a499dd93ae694349$export$5425b53185d13d6c)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, currentScope, isolationScope) {
        event.platform = event.platform || "javascript";
        return super._prepareEvent(event, hint, currentScope, isolationScope);
    }
}
/** Exported only for tests. */ function $b91089b3308fbb6b$export$4e107b20a7f977(optionsArg) {
    return {
        release: typeof __SENTRY_RELEASE__ === "string" // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
         ? __SENTRY_RELEASE__ : (0, $9c98becc1d3a3995$export$56d8a8a25bd48b81).SENTRY_RELEASE?.id,
        sendClientReports: true,
        // We default this to true, as it is the safer scenario
        parentSpanIsAlwaysRootSpan: true,
        ...optionsArg
    };
}



/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $b2977c3b93d1398b$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;


// This is a magic string replaced by rollup
const $f63dfc0cbb49c2f1$export$31499a9cd224b78c = "9.33.0";


/** Internal global with common properties and Sentry extensions  */ /** Get's the global object for the current JavaScript runtime */ const $20ae43346f76bdfd$export$f1a6cdb1459e81d1 = globalThis;


/**
 * An object that contains globally accessible properties and maintains a scope stack.
 * @hidden
 */ /**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $b8e8a2c978e98d94$export$19eade501500c6c1() {
    // This ensures a Sentry carrier exists
    $b8e8a2c978e98d94$export$c8bfa33e4e8ae492((0, $20ae43346f76bdfd$export$f1a6cdb1459e81d1));
    return 0, $20ae43346f76bdfd$export$f1a6cdb1459e81d1;
}
/** Will either get the existing sentry carrier, or create a new one. */ function $b8e8a2c978e98d94$export$c8bfa33e4e8ae492(carrier) {
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    // For now: First SDK that sets the .version property wins
    __SENTRY__.version = __SENTRY__.version || (0, $f63dfc0cbb49c2f1$export$31499a9cd224b78c);
    // Intentionally populating and returning the version of "this" SDK instance
    // rather than what's set in .version so that "this" SDK always gets its carrier
    return __SENTRY__[0, $f63dfc0cbb49c2f1$export$31499a9cd224b78c] = __SENTRY__[0, $f63dfc0cbb49c2f1$export$31499a9cd224b78c] || {};
}
/**
 * Returns a global singleton contained in the global `__SENTRY__[]` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $b8e8a2c978e98d94$export$7e223ec222791509(name, creator, obj = (0, $20ae43346f76bdfd$export$f1a6cdb1459e81d1)) {
    const __SENTRY__ = obj.__SENTRY__ = obj.__SENTRY__ || {};
    const carrier = __SENTRY__[0, $f63dfc0cbb49c2f1$export$31499a9cd224b78c] = __SENTRY__[0, $f63dfc0cbb49c2f1$export$31499a9cd224b78c] || {};
    // Note: We do not want to set `carrier.version` here, as this may be called before any `init` is called, e.g. for the default scopes
    return carrier[name] || (carrier[name] = creator());
}




/** Prefix for logging strings */ const $70cc7a497c940a25$var$PREFIX = "Sentry Logger ";
const $70cc7a497c940a25$export$2a2b1d2252a69ecb = [
    "debug",
    "info",
    "warn",
    "error",
    "log",
    "assert",
    "trace"
];
/** This may be mutated by the console instrumentation. */ const $70cc7a497c940a25$export$77c4ce905194557b = {};
/** A Sentry Logger instance. */ /**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $70cc7a497c940a25$export$cda52e2a8927a2ca(callback) {
    if (!("console" in (0, $20ae43346f76bdfd$export$f1a6cdb1459e81d1))) return callback();
    const console = (0, $20ae43346f76bdfd$export$f1a6cdb1459e81d1).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($70cc7a497c940a25$export$77c4ce905194557b);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $70cc7a497c940a25$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $70cc7a497c940a25$var$makeLogger() {
    let enabled = false;
    const logger = {
        enable: ()=>{
            enabled = true;
        },
        disable: ()=>{
            enabled = false;
        },
        isEnabled: ()=>enabled
    };
    if (0, $b2977c3b93d1398b$export$16a28057038b10ef) $70cc7a497c940a25$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = (...args)=>{
            if (enabled) $70cc7a497c940a25$export$cda52e2a8927a2ca(()=>{
                (0, $20ae43346f76bdfd$export$f1a6cdb1459e81d1).console[name](`${$70cc7a497c940a25$var$PREFIX}[${name}]:`, ...args);
            });
        };
    });
    else $70cc7a497c940a25$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = ()=>undefined;
    });
    return logger;
}
/**
 * This is a logger singleton which either logs things or no-ops if logging is not enabled.
 * The logger is a singleton on the carrier, to ensure that a consistent logger is used throughout the SDK.
 */ const $70cc7a497c940a25$export$af88d00dbe7f521 = (0, $b8e8a2c978e98d94$export$7e223ec222791509)("logger", $70cc7a497c940a25$var$makeLogger);



const $cf78825dfe129821$var$WINDOW = (0, $20ae43346f76bdfd$export$f1a6cdb1459e81d1);
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $cf78825dfe129821$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $cf78825dfe129821$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $cf78825dfe129821$export$ab12a5d056f1d3a() {
    try {
        new DOMException("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function $cf78825dfe129821$export$67fc34576016d6ec() {
    return "history" in $cf78825dfe129821$var$WINDOW && !!$cf78825dfe129821$var$WINDOW.history;
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 * @deprecated This is no longer used and will be removed in a future major version.
 */ const $cf78825dfe129821$export$edf3cb81fd7d2a3e = $cf78825dfe129821$var$_isFetchSupported;
function $cf78825dfe129821$var$_isFetchSupported() {
    if (!("fetch" in $cf78825dfe129821$var$WINDOW)) return false;
    try {
        new Headers();
        new Request("http://www.example.com");
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNative checks if the given function is a native implementation
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $cf78825dfe129821$export$d5f608b368e73f38(func) {
    return func && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $cf78825dfe129821$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === "string") return true;
    if (!$cf78825dfe129821$var$_isFetchSupported()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($cf78825dfe129821$export$d5f608b368e73f38($cf78825dfe129821$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = $cf78825dfe129821$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === "function") try {
        const sandbox = doc.createElement("iframe");
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow?.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $cf78825dfe129821$export$d5f608b368e73f38(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $b2977c3b93d1398b$export$16a28057038b10ef) && (0, $70cc7a497c940a25$export$af88d00dbe7f521).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $cf78825dfe129821$export$531055a6c684a70a() {
    return "ReportingObserver" in $cf78825dfe129821$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 * @deprecated This is no longer used and will be removed in a future major version.
 */ function $cf78825dfe129821$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$cf78825dfe129821$var$_isFetchSupported()) return false;
    try {
        new Request("_", {
            referrerPolicy: "origin"
        });
        return true;
    } catch (e) {
        return false;
    }
}


/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $40b62dc164a5f4e4$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;



const $40dc3e9cd8295a99$export$56d8a8a25bd48b81 = (0, $20ae43346f76bdfd$export$f1a6cdb1459e81d1);


/**
 * We generally want to use window.fetch / window.setTimeout.
 * However, in some cases this may be wrapped (e.g. by Zone.js for Angular),
 * so we try to get an unpatched version of this from a sandboxed iframe.
 */ const $31c1fb7be891462e$var$cachedImplementations = {};
/**
 * Get the native implementation of a browser function.
 *
 * This can be used to ensure we get an unwrapped version of a function, in cases where a wrapped function can lead to problems.
 *
 * The following methods can be retrieved:
 * - `setTimeout`: This can be wrapped by e.g. Angular, causing change detection to be triggered.
 * - `fetch`: This can be wrapped by e.g. ad-blockers, causing an infinite loop when a request is blocked.
 */ function $31c1fb7be891462e$export$e464f4a514ac28a8(name) {
    const cached = $31c1fb7be891462e$var$cachedImplementations[name];
    if (cached) return cached;
    let impl = (0, $40dc3e9cd8295a99$export$56d8a8a25bd48b81)[name];
    // Fast path to avoid DOM I/O
    if ((0, $cf78825dfe129821$export$d5f608b368e73f38)(impl)) return $31c1fb7be891462e$var$cachedImplementations[name] = impl.bind((0, $40dc3e9cd8295a99$export$56d8a8a25bd48b81));
    const document = (0, $40dc3e9cd8295a99$export$56d8a8a25bd48b81).document;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === "function") try {
        const sandbox = document.createElement("iframe");
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow?.[name]) impl = contentWindow[name];
        document.head.removeChild(sandbox);
    } catch (e) {
        // Could not create sandbox iframe, just use window.xxx
        (0, $40b62dc164a5f4e4$export$16a28057038b10ef) && (0, $70cc7a497c940a25$export$af88d00dbe7f521).warn(`Could not create sandbox iframe for ${name} check, bailing to window.${name}: `, e);
    }
    // Sanity check: This _should_ not happen, but if it does, we just skip caching...
    // This can happen e.g. in tests where fetch may not be available in the env, or similar.
    if (!impl) return impl;
    return $31c1fb7be891462e$var$cachedImplementations[name] = impl.bind((0, $40dc3e9cd8295a99$export$56d8a8a25bd48b81));
}
/** Clear a cached implementation. */ function $31c1fb7be891462e$export$8aa36702e8c8978(name) {
    $31c1fb7be891462e$var$cachedImplementations[name] = undefined;
}
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */ function $31c1fb7be891462e$export$e7aa7bc5c1b3cfb3(...rest) {
    return $31c1fb7be891462e$export$e464f4a514ac28a8("fetch")(...rest);
}
/**
 * Get an unwrapped `setTimeout` method.
 * This ensures that even if e.g. Angular wraps `setTimeout`, we get the native implementation,
 * avoiding triggering change detection.
 */ function $31c1fb7be891462e$export$831dc9f2ab0a617b(...rest) {
    return $31c1fb7be891462e$export$e464f4a514ac28a8("setTimeout")(...rest);
}


/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */ function $846ede25dfa44954$export$b2311068c46d7cc8(options, nativeFetch = (0, $31c1fb7be891462e$export$e464f4a514ac28a8)("fetch")) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = {
            body: request.body,
            method: "POST",
            referrerPolicy: "strict-origin",
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. when finishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 60000 && pendingCount < 15,
            ...options.fetchOptions
        };
        if (!nativeFetch) {
            (0, $31c1fb7be891462e$export$8aa36702e8c8978)("fetch");
            return (0, $3de734ff6b883b7d$export$78e43115b553f358)("No fetch implementation available");
        }
        try {
            // Note: We do not need to suppress tracing here, becasue we are using the native fetch, instead of our wrapped one.
            return nativeFetch(options.url, requestOptions).then((response)=>{
                pendingBodySize -= requestSize;
                pendingCount--;
                return {
                    statusCode: response.status,
                    headers: {
                        "x-sentry-rate-limits": response.headers.get("X-Sentry-Rate-Limits"),
                        "retry-after": response.headers.get("Retry-After")
                    }
                };
            });
        } catch (e) {
            (0, $31c1fb7be891462e$export$8aa36702e8c8978)("fetch");
            pendingBodySize -= requestSize;
            pendingCount--;
            return (0, $3de734ff6b883b7d$export$78e43115b553f358)(e);
        }
    }
    return (0, $f8ec919a2acc7c86$export$d09f50d9ab7f7b69)(options, makeRequest);
}



const $06eae0b9980e6601$var$OPERA10_PRIORITY = 10;
const $06eae0b9980e6601$var$OPERA11_PRIORITY = 20;
const $06eae0b9980e6601$var$CHROME_PRIORITY = 30;
const $06eae0b9980e6601$var$WINJS_PRIORITY = 40;
const $06eae0b9980e6601$var$GECKO_PRIORITY = 50;
function $06eae0b9980e6601$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func === "<anonymous>" ? (0, $ed9a0f1a0a69d190$export$27c7e15d453fc0ac) : func,
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// This regex matches frames that have no function name (ie. are at the top level of a module).
// For example "at http://localhost:5000//script.js:1:126"
// Frames _with_ function names usually look as follows: "at commitLayoutEffects (react-dom.development.js:23426:1)"
const $06eae0b9980e6601$var$chromeRegexNoFnName = /^\s*at (\S+?)(?::(\d+))(?::(\d+))\s*$/i;
// This regex matches all the frames that have a function name.
const $06eae0b9980e6601$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $06eae0b9980e6601$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
// We cannot call this variable `chrome` because it can conflict with global `chrome` variable in certain environments
// See: https://github.com/getsentry/sentry-javascript/issues/6880
const $06eae0b9980e6601$var$chromeStackParserFn = (line)=>{
    // If the stack line has no function name, we need to parse it differently
    const noFnParts = $06eae0b9980e6601$var$chromeRegexNoFnName.exec(line);
    if (noFnParts) {
        const [, filename, line, col] = noFnParts;
        return $06eae0b9980e6601$var$createFrame(filename, (0, $ed9a0f1a0a69d190$export$27c7e15d453fc0ac), +line, +col);
    }
    const parts = $06eae0b9980e6601$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2] && parts[2].indexOf("eval") === 0; // start of line
        if (isEval) {
            const subMatch = $06eae0b9980e6601$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        const [func, filename] = $06eae0b9980e6601$var$extractSafariExtensionDetails(parts[1] || (0, $ed9a0f1a0a69d190$export$27c7e15d453fc0ac), parts[2]);
        return $06eae0b9980e6601$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
const $06eae0b9980e6601$export$263a749fff749872 = [
    $06eae0b9980e6601$var$CHROME_PRIORITY,
    $06eae0b9980e6601$var$chromeStackParserFn
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const $06eae0b9980e6601$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $06eae0b9980e6601$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $06eae0b9980e6601$var$gecko = (line)=>{
    const parts = $06eae0b9980e6601$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(" > eval") > -1;
        if (isEval) {
            const subMatch = $06eae0b9980e6601$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || "eval";
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ""; // no column when eval
            }
        }
        let filename = parts[3];
        let func = parts[1] || (0, $ed9a0f1a0a69d190$export$27c7e15d453fc0ac);
        [func, filename] = $06eae0b9980e6601$var$extractSafariExtensionDetails(func, filename);
        return $06eae0b9980e6601$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
const $06eae0b9980e6601$export$cdba47a5dd2804d = [
    $06eae0b9980e6601$var$GECKO_PRIORITY,
    $06eae0b9980e6601$var$gecko
];
const $06eae0b9980e6601$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $06eae0b9980e6601$var$winjs = (line)=>{
    const parts = $06eae0b9980e6601$var$winjsRegex.exec(line);
    return parts ? $06eae0b9980e6601$var$createFrame(parts[2], parts[1] || (0, $ed9a0f1a0a69d190$export$27c7e15d453fc0ac), +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
const $06eae0b9980e6601$export$179460296da408e8 = [
    $06eae0b9980e6601$var$WINJS_PRIORITY,
    $06eae0b9980e6601$var$winjs
];
const $06eae0b9980e6601$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $06eae0b9980e6601$var$opera10 = (line)=>{
    const parts = $06eae0b9980e6601$var$opera10Regex.exec(line);
    return parts ? $06eae0b9980e6601$var$createFrame(parts[2], parts[3] || (0, $ed9a0f1a0a69d190$export$27c7e15d453fc0ac), +parts[1]) : undefined;
};
const $06eae0b9980e6601$export$f892b52c880ffc7a = [
    $06eae0b9980e6601$var$OPERA10_PRIORITY,
    $06eae0b9980e6601$var$opera10
];
const $06eae0b9980e6601$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $06eae0b9980e6601$var$opera11 = (line)=>{
    const parts = $06eae0b9980e6601$var$opera11Regex.exec(line);
    return parts ? $06eae0b9980e6601$var$createFrame(parts[5], parts[3] || parts[4] || (0, $ed9a0f1a0a69d190$export$27c7e15d453fc0ac), +parts[1], +parts[2]) : undefined;
};
const $06eae0b9980e6601$export$af11af13f09fb0dc = [
    $06eae0b9980e6601$var$OPERA11_PRIORITY,
    $06eae0b9980e6601$var$opera11
];
const $06eae0b9980e6601$export$7197c0fe6554c079 = [
    $06eae0b9980e6601$export$263a749fff749872,
    $06eae0b9980e6601$export$cdba47a5dd2804d
];
const $06eae0b9980e6601$export$2b2b997d81bf3907 = (0, $ed9a0f1a0a69d190$export$a5739666fb2d03d4)(...$06eae0b9980e6601$export$7197c0fe6554c079);
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ const $06eae0b9980e6601$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf("safari-extension") !== -1;
    const isSafariWebExtension = func.indexOf("safari-web-extension") !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf("@") !== -1 ? func.split("@")[0] : (0, $ed9a0f1a0a69d190$export$27c7e15d453fc0ac),
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};




/**
 * Creates an envelope from a user feedback.
 */ function $ed3cec9f08115078$export$24a4dfcb686ee5bf(feedback, { metadata: metadata, tunnel: tunnel, dsn: dsn }) {
    const headers = {
        event_id: feedback.event_id,
        sent_at: new Date().toISOString(),
        ...metadata?.sdk && {
            sdk: {
                name: metadata.sdk.name,
                version: metadata.sdk.version
            }
        },
        ...!!tunnel && !!dsn && {
            dsn: (0, $0ce64b897229c6e0$export$44d472fbb931a776)(dsn)
        }
    };
    const item = $ed3cec9f08115078$var$createUserFeedbackEnvelopeItem(feedback);
    return (0, $a293d580860d0106$export$f93f7f385160c44e)(headers, [
        item
    ]);
}
function $ed3cec9f08115078$var$createUserFeedbackEnvelopeItem(feedback) {
    const feedbackHeaders = {
        type: "user_report"
    };
    return [
        feedbackHeaders,
        feedback
    ];
}









const $20b8c37b7dc32b0d$var$WINDOW = (0, $88208d9e04627397$export$f1a6cdb1459e81d1);
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $20b8c37b7dc32b0d$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $20b8c37b7dc32b0d$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $20b8c37b7dc32b0d$export$ab12a5d056f1d3a() {
    try {
        new DOMException("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function $20b8c37b7dc32b0d$export$67fc34576016d6ec() {
    return "history" in $20b8c37b7dc32b0d$var$WINDOW && !!$20b8c37b7dc32b0d$var$WINDOW.history;
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 * @deprecated This is no longer used and will be removed in a future major version.
 */ const $20b8c37b7dc32b0d$export$edf3cb81fd7d2a3e = $20b8c37b7dc32b0d$var$_isFetchSupported;
function $20b8c37b7dc32b0d$var$_isFetchSupported() {
    if (!("fetch" in $20b8c37b7dc32b0d$var$WINDOW)) return false;
    try {
        new Headers();
        new Request("http://www.example.com");
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNative checks if the given function is a native implementation
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $20b8c37b7dc32b0d$export$d5f608b368e73f38(func) {
    return func && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $20b8c37b7dc32b0d$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === "string") return true;
    if (!$20b8c37b7dc32b0d$var$_isFetchSupported()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($20b8c37b7dc32b0d$export$d5f608b368e73f38($20b8c37b7dc32b0d$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = $20b8c37b7dc32b0d$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === "function") try {
        const sandbox = doc.createElement("iframe");
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow?.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $20b8c37b7dc32b0d$export$d5f608b368e73f38(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $b5c0571e433473d8$export$16a28057038b10ef) && (0, $dfad86e498c52aee$export$af88d00dbe7f521).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $20b8c37b7dc32b0d$export$531055a6c684a70a() {
    return "ReportingObserver" in $20b8c37b7dc32b0d$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 * @deprecated This is no longer used and will be removed in a future major version.
 */ function $20b8c37b7dc32b0d$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$20b8c37b7dc32b0d$var$_isFetchSupported()) return false;
    try {
        new Request("_", {
            referrerPolicy: "origin"
        });
        return true;
    } catch (e) {
        return false;
    }
}





/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $1f5839cb68df003d$export$f75d3c772c923df0(handler, skipNativeFetchCheck) {
    const type = "fetch";
    (0, $ffa875045a09c5c1$export$a4e09611e30da72e)(type, handler);
    (0, $ffa875045a09c5c1$export$e18d6c5462c01368)(type, ()=>$1f5839cb68df003d$var$instrumentFetch(undefined, skipNativeFetchCheck));
}
/**
 * Add an instrumentation handler for long-lived fetch requests, like consuming server-sent events (SSE) via fetch.
 * The handler will resolve the request body and emit the actual `endTimestamp`, so that the
 * span can be updated accordingly.
 *
 * Only used internally
 * @hidden
 */ function $1f5839cb68df003d$export$1a79663eb318fe6a(handler) {
    const type = "fetch-body-resolved";
    (0, $ffa875045a09c5c1$export$a4e09611e30da72e)(type, handler);
    (0, $ffa875045a09c5c1$export$e18d6c5462c01368)(type, ()=>$1f5839cb68df003d$var$instrumentFetch($1f5839cb68df003d$var$streamHandler));
}
function $1f5839cb68df003d$var$instrumentFetch(onFetchResolved, skipNativeFetchCheck = false) {
    if (skipNativeFetchCheck && !(0, $20b8c37b7dc32b0d$export$c82d238e23c40b21)()) return;
    (0, $90379bc90653c4b6$export$9563e054e6f787fb)((0, $88208d9e04627397$export$f1a6cdb1459e81d1), "fetch", function(originalFetch) {
        return function(...args) {
            // We capture the error right here and not in the Promise error callback because Safari (and probably other
            // browsers too) will wipe the stack trace up to this point, only leaving us with this file which is useless.
            // NOTE: If you are a Sentry user, and you are seeing this stack frame,
            //       it means the error, that was caused by your fetch call did not
            //       have a stack trace, so the SDK backfilled the stack trace so
            //       you can see which fetch call failed.
            const virtualError = new Error();
            const { method: method, url: url } = $1f5839cb68df003d$export$f7a71163cc309d9a(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: (0, $14ccb306f78f15b4$export$ee52dced521e3e18)() * 1000,
                virtualError: // // Adding the error to be able to fingerprint the failed fetch event in HttpClient instrumentation
                virtualError,
                headers: $1f5839cb68df003d$var$getHeadersFromFetchArgs(args)
            };
            // if there is no callback, fetch is instrumented directly
            if (!onFetchResolved) (0, $ffa875045a09c5c1$export$b18c893e424d3127)("fetch", {
                ...handlerData
            });
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply((0, $88208d9e04627397$export$f1a6cdb1459e81d1), args).then(async (response)=>{
                if (onFetchResolved) onFetchResolved(response);
                else (0, $ffa875045a09c5c1$export$b18c893e424d3127)("fetch", {
                    ...handlerData,
                    endTimestamp: (0, $14ccb306f78f15b4$export$ee52dced521e3e18)() * 1000,
                    response: response
                });
                return response;
            }, (error)=>{
                (0, $ffa875045a09c5c1$export$b18c893e424d3127)("fetch", {
                    ...handlerData,
                    endTimestamp: (0, $14ccb306f78f15b4$export$ee52dced521e3e18)() * 1000,
                    error: error
                });
                if ((0, $ed5cb73b8752546d$export$e6127cc7fe7395c3)(error) && error.stack === undefined) {
                    // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                    //       it means the error, that was caused by your fetch call did not
                    //       have a stack trace, so the SDK backfilled the stack trace so
                    //       you can see which fetch call failed.
                    error.stack = virtualError.stack;
                    (0, $90379bc90653c4b6$export$e73679ffaf56810e)(error, "framesToPop", 1);
                }
                // We enhance the not-so-helpful "Failed to fetch" error messages with the host
                // Possible messages we handle here:
                // * "Failed to fetch" (chromium)
                // * "Load failed" (webkit)
                // * "NetworkError when attempting to fetch resource." (firefox)
                if (error instanceof TypeError && (error.message === "Failed to fetch" || error.message === "Load failed" || error.message === "NetworkError when attempting to fetch resource.")) try {
                    const url = new URL(handlerData.fetchData.url);
                    error.message = `${error.message} (${url.host})`;
                } catch  {
                // ignore it if errors happen here
                }
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
async function $1f5839cb68df003d$var$resolveResponse(res, onFinishedResolving) {
    if (res?.body) {
        const body = res.body;
        const responseReader = body.getReader();
        // Define a maximum duration after which we just cancel
        const maxFetchDurationTimeout = setTimeout(()=>{
            body.cancel().then(null, ()=>{
            // noop
            });
        }, 90000);
        let readingActive = true;
        while(readingActive){
            let chunkTimeout;
            try {
                // abort reading if read op takes more than 5s
                chunkTimeout = setTimeout(()=>{
                    body.cancel().then(null, ()=>{
                    // noop on error
                    });
                }, 5000);
                // This .read() call will reject/throw when we abort due to timeouts through `body.cancel()`
                const { done: done } = await responseReader.read();
                clearTimeout(chunkTimeout);
                if (done) {
                    onFinishedResolving();
                    readingActive = false;
                }
            } catch (error) {
                readingActive = false;
            } finally{
                clearTimeout(chunkTimeout);
            }
        }
        clearTimeout(maxFetchDurationTimeout);
        responseReader.releaseLock();
        body.cancel().then(null, ()=>{
        // noop on error
        });
    }
}
function $1f5839cb68df003d$var$streamHandler(response) {
    // clone response for awaiting stream
    let clonedResponseForResolving;
    try {
        clonedResponseForResolving = response.clone();
    } catch  {
        return;
    }
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    $1f5839cb68df003d$var$resolveResponse(clonedResponseForResolving, ()=>{
        (0, $ffa875045a09c5c1$export$b18c893e424d3127)("fetch-body-resolved", {
            endTimestamp: (0, $14ccb306f78f15b4$export$ee52dced521e3e18)() * 1000,
            response: response
        });
    });
}
function $1f5839cb68df003d$var$hasProp(obj, prop) {
    return !!obj && typeof obj === "object" && !!obj[prop];
}
function $1f5839cb68df003d$var$getUrlFromResource(resource) {
    if (typeof resource === "string") return resource;
    if (!resource) return "";
    if ($1f5839cb68df003d$var$hasProp(resource, "url")) return resource.url;
    if (resource.toString) return resource.toString();
    return "";
}
/**
 * Parses the fetch arguments to find the used Http method and the url of the request.
 * Exported for tests only.
 */ function $1f5839cb68df003d$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: "GET",
        url: ""
    };
    if (fetchArgs.length === 2) {
        const [url, options] = fetchArgs;
        return {
            url: $1f5839cb68df003d$var$getUrlFromResource(url),
            method: $1f5839cb68df003d$var$hasProp(options, "method") ? String(options.method).toUpperCase() : "GET"
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $1f5839cb68df003d$var$getUrlFromResource(arg),
        method: $1f5839cb68df003d$var$hasProp(arg, "method") ? String(arg.method).toUpperCase() : "GET"
    };
}
function $1f5839cb68df003d$var$getHeadersFromFetchArgs(fetchArgs) {
    const [requestArgument, optionsArgument] = fetchArgs;
    try {
        if (typeof optionsArgument === "object" && optionsArgument !== null && "headers" in optionsArgument && optionsArgument.headers) return new Headers(optionsArgument.headers);
        if ((0, $ed5cb73b8752546d$export$6d3d1f317d7cda57)(requestArgument)) return new Headers(requestArgument.headers);
    } catch  {
    // noop
    }
    return;
}

/**
 * Determine a breadcrumb's log level (only `warning` or `error`) based on an HTTP status code.
 */ function $c4ed481e2fed84d8$export$b8cfcc4175694bcc(statusCode) {
    // NOTE: undefined defaults to 'info' in Sentry
    if (statusCode === undefined) return undefined;
    else if (statusCode >= 400 && statusCode < 500) return "warning";
    else if (statusCode >= 500) return "error";
    else return undefined;
}


// Curious about `thismessage:/`? See: https://www.rfc-editor.org/rfc/rfc2557.html
//  > When the methods above do not yield an absolute URI, a base URL
//  > of "thismessage:/" MUST be employed. This base URL has been
//  > defined for the sole purpose of resolving relative references
//  > within a multipart/related structure when no other base URI is
//  > specified.
//
// We need to provide a base URL to `parseStringToURLObject` because the fetch API gives us a
// relative URL sometimes.
//
// This is the only case where we need to provide a base URL to `parseStringToURLObject`
// because the relative URL is not valid on its own.
const $34321b3a3ce9dbbd$var$DEFAULT_BASE_URL = "thismessage:/";
/**
 * Checks if the URL object is relative
 *
 * @param url - The URL object to check
 * @returns True if the URL object is relative, false otherwise
 */ function $34321b3a3ce9dbbd$export$e258e13805402ba7(url) {
    return "isRelative" in url;
}
/**
 * Parses string to a URL object
 *
 * @param url - The URL to parse
 * @returns The parsed URL object or undefined if the URL is invalid
 */ function $34321b3a3ce9dbbd$export$2004d912a9ead694(url, urlBase) {
    const isRelative = url.indexOf("://") <= 0 && url.indexOf("//") !== 0;
    const base = urlBase ?? (isRelative ? $34321b3a3ce9dbbd$var$DEFAULT_BASE_URL : undefined);
    try {
        // Use `canParse` to short-circuit the URL constructor if it's not a valid URL
        // This is faster than trying to construct the URL and catching the error
        // Node 20+, Chrome 120+, Firefox 115+, Safari 17+
        if ("canParse" in URL && !URL.canParse(url, base)) return undefined;
        const fullUrlObject = new URL(url, base);
        if (isRelative) // Because we used a fake base URL, we need to return a relative URL object.
        // We cannot return anything about the origin, host, etc. because it will refer to the fake base URL.
        return {
            isRelative: isRelative,
            pathname: fullUrlObject.pathname,
            search: fullUrlObject.search,
            hash: fullUrlObject.hash
        };
        return fullUrlObject;
    } catch  {
    // empty body
    }
    return undefined;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span name
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $34321b3a3ce9dbbd$export$5339fcdc8e2a427c(url) {
    if ($34321b3a3ce9dbbd$export$e258e13805402ba7(url)) return url.pathname;
    const newUrl = new URL(url);
    newUrl.search = "";
    newUrl.hash = "";
    if ([
        "80",
        "443"
    ].includes(newUrl.port)) newUrl.port = "";
    if (newUrl.password) newUrl.password = "%filtered%";
    if (newUrl.username) newUrl.username = "%filtered%";
    return newUrl.toString();
}
function $34321b3a3ce9dbbd$var$getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName) {
    const method = request?.method?.toUpperCase() ?? "GET";
    const route = routeName ? routeName : urlObject ? kind === "client" ? $34321b3a3ce9dbbd$export$5339fcdc8e2a427c(urlObject) : urlObject.pathname : "/";
    return `${method} ${route}`;
}
/**
 * Takes a parsed URL object and returns a set of attributes for the span
 * that represents the HTTP request for that url. This is used for both server
 * and client http spans.
 *
 * Follows https://opentelemetry.io/docs/specs/semconv/http/.
 *
 * @param urlObject - see {@link parseStringToURLObject}
 * @param kind - The type of HTTP operation (server or client)
 * @param spanOrigin - The origin of the span
 * @param request - The request object, see {@link PartialRequest}
 * @param routeName - The name of the route, must be low cardinality
 * @returns The span name and attributes for the HTTP operation
 */ function $34321b3a3ce9dbbd$export$c37a41544f3c180c(urlObject, kind, spanOrigin, request, routeName) {
    const attributes = {
        [(0, $34e3132ced11beec$export$cca8dd30f57f805e)]: spanOrigin,
        [(0, $34e3132ced11beec$export$d7a7d984b0791405)]: "url"
    };
    if (routeName) {
        // This is based on https://opentelemetry.io/docs/specs/semconv/http/http-spans/#name
        attributes[kind === "server" ? "http.route" : "url.template"] = routeName;
        attributes[0, $34e3132ced11beec$export$d7a7d984b0791405] = "route";
    }
    if (request?.method) attributes[0, $34e3132ced11beec$export$be7a251980e7e946] = request.method.toUpperCase();
    if (urlObject) {
        if (urlObject.search) attributes["url.query"] = urlObject.search;
        if (urlObject.hash) attributes["url.fragment"] = urlObject.hash;
        if (urlObject.pathname) {
            attributes["url.path"] = urlObject.pathname;
            if (urlObject.pathname === "/") attributes[0, $34e3132ced11beec$export$d7a7d984b0791405] = "route";
        }
        if (!$34321b3a3ce9dbbd$export$e258e13805402ba7(urlObject)) {
            attributes[0, $34e3132ced11beec$export$25dfd73e0e32c6e1] = urlObject.href;
            if (urlObject.port) attributes["url.port"] = urlObject.port;
            if (urlObject.protocol) attributes["url.scheme"] = urlObject.protocol;
            if (urlObject.hostname) attributes[kind === "server" ? "server.address" : "url.domain"] = urlObject.hostname;
        }
    }
    return [
        $34321b3a3ce9dbbd$var$getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName),
        attributes
    ];
}
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function $34321b3a3ce9dbbd$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    const query = match[6] || "";
    const fragment = match[8] || "";
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function $34321b3a3ce9dbbd$export$ce084c78234bd35(urlPath) {
    return urlPath.split(/[?#]/, 1)[0];
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span name
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $34321b3a3ce9dbbd$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host?.replace(/^.*@/, "[filtered]:[filtered]@").replace(/(:80)$/, "").replace(/(:443)$/, "") || "";
    return `${protocol ? `${protocol}://` : ""}${filteredHost}${path}`;
}




const $62980e96870c5f3e$var$STACKTRACE_FRAME_LIMIT = 50;
const $62980e96870c5f3e$export$27c7e15d453fc0ac = "?";
// Used to sanitize webpack (error: *) wrapped stack errors
const $62980e96870c5f3e$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $62980e96870c5f3e$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $62980e96870c5f3e$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirstLines = 0, framesToPop = 0)=>{
        const frames = [];
        const lines = stack.split("\n");
        for(let i = skipFirstLines; i < lines.length; i++){
            const line = lines[i];
            // Ignore lines over 1kb as they are unlikely to be stack frames.
            // Many of the regular expressions use backtracking which results in run time that increases exponentially with
            // input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) continue;
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $62980e96870c5f3e$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($62980e96870c5f3e$var$WEBPACK_ERROR_REGEXP, "$1") : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $62980e96870c5f3e$var$STACKTRACE_FRAME_LIMIT + framesToPop) break;
        }
        return $62980e96870c5f3e$export$c55c24c0eeba0205(frames.slice(framesToPop));
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $62980e96870c5f3e$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $62980e96870c5f3e$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $62980e96870c5f3e$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test($62980e96870c5f3e$var$getLastStackFrame(localStack).function || "")) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($62980e96870c5f3e$var$STRIP_FRAME_REGEXP.test($62980e96870c5f3e$var$getLastStackFrame(localStack).function || "")) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the scope itself, making it:
        //
        //   Sentry.captureException()
        //   scope.captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($62980e96870c5f3e$var$STRIP_FRAME_REGEXP.test($62980e96870c5f3e$var$getLastStackFrame(localStack).function || "")) localStack.pop();
    }
    return localStack.slice(0, $62980e96870c5f3e$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || $62980e96870c5f3e$var$getLastStackFrame(localStack).filename,
            function: frame.function || $62980e96870c5f3e$export$27c7e15d453fc0ac
        }));
}
function $62980e96870c5f3e$var$getLastStackFrame(arr) {
    return arr[arr.length - 1] || {};
}
const $62980e96870c5f3e$var$defaultFunctionName = "<anonymous>";
/**
 * Safely extract function name from itself
 */ function $62980e96870c5f3e$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== "function") return $62980e96870c5f3e$var$defaultFunctionName;
        return fn.name || $62980e96870c5f3e$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $62980e96870c5f3e$var$defaultFunctionName;
    }
}
/**
 * Get's stack frames from an event without needing to check for undefined properties.
 */ function $62980e96870c5f3e$export$91d8ca51bd9f6a47(event) {
    const exception = event.exception;
    if (exception) {
        const frames = [];
        try {
            // @ts-expect-error Object could be undefined
            exception.values.forEach((value)=>{
                // @ts-expect-error Value could be undefined
                if (value.stacktrace.frames) // @ts-expect-error Value could be undefined
                frames.push(...value.stacktrace.frames);
            });
            return frames;
        } catch (_oO) {
            return undefined;
        }
    }
    return undefined;
}


// We keep the handlers globally
const $1c39801aee9436e3$var$handlers = {};
const $1c39801aee9436e3$var$instrumented = {};
/** Add a handler function. */ function $1c39801aee9436e3$export$a4e09611e30da72e(type, handler) {
    $1c39801aee9436e3$var$handlers[type] = $1c39801aee9436e3$var$handlers[type] || [];
    $1c39801aee9436e3$var$handlers[type].push(handler);
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function $1c39801aee9436e3$export$b17eab759a1cb5fe() {
    Object.keys($1c39801aee9436e3$var$handlers).forEach((key)=>{
        $1c39801aee9436e3$var$handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function $1c39801aee9436e3$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$1c39801aee9436e3$var$instrumented[type]) {
        $1c39801aee9436e3$var$instrumented[type] = true;
        try {
            instrumentFn();
        } catch (e) {
            (0, $b2977c3b93d1398b$export$16a28057038b10ef) && (0, $70cc7a497c940a25$export$af88d00dbe7f521).error(`Error while instrumenting ${type}`, e);
        }
    }
}
/** Trigger handlers for a given instrumentation type. */ function $1c39801aee9436e3$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $1c39801aee9436e3$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $b2977c3b93d1398b$export$16a28057038b10ef) && (0, $70cc7a497c940a25$export$af88d00dbe7f521).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $62980e96870c5f3e$export$aad197c7121a6651)(handler)}\nError:`, e);
    }
}


// eslint-disable-next-line @typescript-eslint/unbound-method
const $4541e6bae1c3cae8$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4541e6bae1c3cae8$export$e6127cc7fe7395c3(wat) {
    switch($4541e6bae1c3cae8$var$objectToString.call(wat)){
        case "[object Error]":
        case "[object Exception]":
        case "[object DOMException]":
        case "[object WebAssembly.Exception]":
            return true;
        default:
            return $4541e6bae1c3cae8$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $4541e6bae1c3cae8$var$isBuiltin(wat, className) {
    return $4541e6bae1c3cae8$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4541e6bae1c3cae8$export$9f9636d330b71954(wat) {
    return $4541e6bae1c3cae8$var$isBuiltin(wat, "ErrorEvent");
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4541e6bae1c3cae8$export$ef9e2056653f0c8e(wat) {
    return $4541e6bae1c3cae8$var$isBuiltin(wat, "DOMError");
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4541e6bae1c3cae8$export$12e869b2a583f783(wat) {
    return $4541e6bae1c3cae8$var$isBuiltin(wat, "DOMException");
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4541e6bae1c3cae8$export$844ec244b1367d54(wat) {
    return $4541e6bae1c3cae8$var$isBuiltin(wat, "String");
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4541e6bae1c3cae8$export$dbcbffa59149b824(wat) {
    return typeof wat === "object" && wat !== null && "__sentry_template_string__" in wat && "__sentry_template_values__" in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4541e6bae1c3cae8$export$c3825b437cbdea5c(wat) {
    return wat === null || $4541e6bae1c3cae8$export$dbcbffa59149b824(wat) || typeof wat !== "object" && typeof wat !== "function";
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4541e6bae1c3cae8$export$53b83ca8eaab0383(wat) {
    return $4541e6bae1c3cae8$var$isBuiltin(wat, "Object");
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4541e6bae1c3cae8$export$9671ea99bd126ace(wat) {
    return typeof Event !== "undefined" && $4541e6bae1c3cae8$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4541e6bae1c3cae8$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== "undefined" && $4541e6bae1c3cae8$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4541e6bae1c3cae8$export$49841c62b9eff15(wat) {
    return $4541e6bae1c3cae8$var$isBuiltin(wat, "RegExp");
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $4541e6bae1c3cae8$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat?.then && typeof wat.then === "function");
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4541e6bae1c3cae8$export$bc2894c7158efbac(wat) {
    return $4541e6bae1c3cae8$export$53b83ca8eaab0383(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $4541e6bae1c3cae8$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4541e6bae1c3cae8$export$7916fad0ebc23f48(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    return !!(typeof wat === "object" && wat !== null && (wat.__isVue || wat._isVue));
}
/**
 * Checks whether the given parameter is a Standard Web API Request instance.
 *
 * Returns false if Request is not available in the current runtime.
 */ function $4541e6bae1c3cae8$export$6d3d1f317d7cda57(request) {
    return typeof Request !== "undefined" && $4541e6bae1c3cae8$export$49034edbe6b62415(request, Request);
}



const $1e36c764d0445908$var$WINDOW = (0, $20ae43346f76bdfd$export$f1a6cdb1459e81d1);
const $1e36c764d0445908$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $1e36c764d0445908$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return "<unknown>";
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = " > ";
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $1e36c764d0445908$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $1e36c764d0445908$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return "<unknown>";
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $1e36c764d0445908$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    if (!elem?.tagName) return "";
    // @ts-expect-error WINDOW has HTMLElement
    if ($1e36c764d0445908$var$WINDOW.HTMLElement) // If using the component name annotation plugin, this value may be available on the DOM node
    {
        if (elem instanceof HTMLElement && elem.dataset) {
            if (elem.dataset["sentryComponent"]) return elem.dataset["sentryComponent"];
            if (elem.dataset["sentryElement"]) return elem.dataset["sentryElement"];
        }
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs?.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs?.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        const className = elem.className;
        if (className && (0, $4541e6bae1c3cae8$export$844ec244b1367d54)(className)) {
            const classes = className.split(/\s+/);
            for (const c of classes)out.push(`.${c}`);
        }
    }
    const allowedAttrs = [
        "aria-label",
        "type",
        "name",
        "title",
        "alt"
    ];
    for (const k of allowedAttrs){
        const attr = elem.getAttribute(k);
        if (attr) out.push(`[${k}="${attr}"]`);
    }
    return out.join("");
}
/**
 * A safe form of location.href
 */ function $1e36c764d0445908$export$1cfafeee2987818b() {
    try {
        return $1e36c764d0445908$var$WINDOW.document.location.href;
    } catch (oO) {
        return "";
    }
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` or `data-sentry-element` attribute with `data-sentry-component` taking
 * precedence. This attribute is added at build-time by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function $1e36c764d0445908$export$26727cfcc4d7e0fc(elem) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!$1e36c764d0445908$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    const MAX_TRAVERSE_HEIGHT = 5;
    for(let i = 0; i < MAX_TRAVERSE_HEIGHT; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement) {
            if (currentElem.dataset["sentryComponent"]) return currentElem.dataset["sentryComponent"];
            if (currentElem.dataset["sentryElement"]) return currentElem.dataset["sentryElement"];
        }
        currentElem = currentElem.parentNode;
    }
    return null;
}





/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $ac71f3aed2307965$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== "string" || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $ac71f3aed2307965$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += " {snip}";
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ function $ac71f3aed2307965$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return "";
    const output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, $4541e6bae1c3cae8$export$7916fad0ebc23f48)(value)) output.push("[VueViewModel]");
            else output.push(String(value));
        } catch (e) {
            output.push("[value cannot be serialized]");
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $ac71f3aed2307965$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $4541e6bae1c3cae8$export$844ec244b1367d54)(value)) return false;
    if ((0, $4541e6bae1c3cae8$export$49841c62b9eff15)(pattern)) return pattern.test(value);
    if ((0, $4541e6bae1c3cae8$export$844ec244b1367d54)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $ac71f3aed2307965$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$ac71f3aed2307965$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}


/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Replace a method in an object with a wrapped version of itself.
 *
 * If the method on the passed object is not a function, the wrapper will not be applied.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $69901043324a0df8$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    // explicitly casting to unknown because we don't know the type of the method initially at all
    const original = source[name];
    if (typeof original !== "function") return;
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === "function") $69901043324a0df8$export$5c1499e2e5d010ae(wrapped, original);
    try {
        source[name] = wrapped;
    } catch  {
        (0, $b2977c3b93d1398b$export$16a28057038b10ef) && (0, $70cc7a497c940a25$export$af88d00dbe7f521).log(`Failed to replace method "${name}" in object`, source);
    }
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $69901043324a0df8$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch (o_O) {
        (0, $b2977c3b93d1398b$export$16a28057038b10ef) && (0, $70cc7a497c940a25$export$af88d00dbe7f521).log(`Failed to add non-enumerable property "${name}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $69901043324a0df8$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $69901043324a0df8$export$e73679ffaf56810e(wrapped, "__sentry_original__", original);
    } catch (o_O) {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $69901043324a0df8$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argument itself, when value is neither an Event nor
 *  an Error.
 */ function $69901043324a0df8$export$62ff257738bf57f5(value) {
    if ((0, $4541e6bae1c3cae8$export$e6127cc7fe7395c3)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$69901043324a0df8$var$getOwnProperties(value)
    };
    else if ((0, $4541e6bae1c3cae8$export$9671ea99bd126ace)(value)) {
        const newObj = {
            type: value.type,
            target: $69901043324a0df8$var$serializeEventTarget(value.target),
            currentTarget: $69901043324a0df8$var$serializeEventTarget(value.currentTarget),
            ...$69901043324a0df8$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== "undefined" && (0, $4541e6bae1c3cae8$export$49034edbe6b62415)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $69901043324a0df8$var$serializeEventTarget(target) {
    try {
        return (0, $4541e6bae1c3cae8$export$45a5e7f76e0caa8d)(target) ? (0, $1e36c764d0445908$export$5647df6b7814ac86)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return "<unknown>";
    }
}
/** Filters out all but an object's own properties */ function $69901043324a0df8$var$getOwnProperties(obj) {
    if (typeof obj === "object" && obj !== null) {
        const extractedProps = {};
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $69901043324a0df8$export$b0244d5063c0b61b(exception, maxLength = 40) {
    const keys = Object.keys($69901043324a0df8$export$62ff257738bf57f5(exception));
    keys.sort();
    const firstKey = keys[0];
    if (!firstKey) return "[object has no keys]";
    if (firstKey.length >= maxLength) return (0, $ac71f3aed2307965$export$6a506b36fdea397d)(firstKey, maxLength);
    for(let includedKeys = keys.length; includedKeys > 0; includedKeys--){
        const serialized = keys.slice(0, includedKeys).join(", ");
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $ac71f3aed2307965$export$6a506b36fdea397d)(serialized, maxLength);
    }
    return "";
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 *
 * @deprecated This function is no longer used by the SDK and will be removed in a future major version.
 */ function $69901043324a0df8$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $69901043324a0df8$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $69901043324a0df8$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    // Early return for primitive values
    if (inputValue === null || typeof inputValue !== "object") return inputValue;
    // Check memo map first for all object types
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== undefined) return memoVal;
    // handle arrays
    if (Array.isArray(inputValue)) {
        const returnValue = [];
        // Store mapping to handle circular references
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((value)=>{
            returnValue.push($69901043324a0df8$var$_dropUndefinedKeys(value, memoizationMap));
        });
        return returnValue;
    }
    if ($69901043324a0df8$var$isPojo(inputValue)) {
        const returnValue = {};
        // Store mapping to handle circular references
        memoizationMap.set(inputValue, returnValue);
        const keys = Object.keys(inputValue);
        keys.forEach((key)=>{
            const val = inputValue[key];
            if (val !== undefined) returnValue[key] = $69901043324a0df8$var$_dropUndefinedKeys(val, memoizationMap);
        });
        return returnValue;
    }
    // For other object types, return as is
    return inputValue;
}
function $69901043324a0df8$var$isPojo(input) {
    // Plain objects have Object as constructor or no constructor
    const constructor = input.constructor;
    return constructor === Object || constructor === undefined;
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $69901043324a0df8$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        // this will catch both undefined and null
        case wat == undefined:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === "symbol" || typeof wat === "bigint":
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $4541e6bae1c3cae8$export$c3825b437cbdea5c)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}




function $a15fd97f4e1b6d43$var$getCrypto() {
    const gbl = (0, $20ae43346f76bdfd$export$f1a6cdb1459e81d1);
    return gbl.crypto || gbl.msCrypto;
}
/**
 * UUID4 generator
 * @param crypto Object that provides the crypto API.
 * @returns string Generated UUID4.
 */ function $a15fd97f4e1b6d43$export$19f53698e68b2496(crypto = $a15fd97f4e1b6d43$var$getCrypto()) {
    let getRandomByte = ()=>Math.random() * 16;
    try {
        if (crypto?.randomUUID) return crypto.randomUUID().replace(/-/g, "");
        if (crypto?.getRandomValues) getRandomByte = ()=>{
            // crypto.getRandomValues might return undefined instead of the typed array
            // in old Chromium versions (e.g. 23.0.1235.0 (151422))
            // However, `typedArray` is still filled in-place.
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues#typedarray
            const typedArray = new Uint8Array(1);
            crypto.getRandomValues(typedArray);
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            return typedArray[0];
        };
    } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function $a15fd97f4e1b6d43$var$getFirstException(event) {
    return event.exception?.values?.[0];
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $a15fd97f4e1b6d43$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $a15fd97f4e1b6d43$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || "<unknown>";
    }
    return eventId || "<unknown>";
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $a15fd97f4e1b6d43$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || "";
    if (!firstException.type) firstException.type = type || "Error";
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $a15fd97f4e1b6d43$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $a15fd97f4e1b6d43$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: "generic",
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && "data" in newMechanism) {
        const mergedData = {
            ...currentMechanism?.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $a15fd97f4e1b6d43$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ function $a15fd97f4e1b6d43$var$_parseInt(input) {
    return parseInt(input || "", 10);
}
/**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $a15fd97f4e1b6d43$export$d364f2020ab30578(input) {
    const match = input.match($a15fd97f4e1b6d43$var$SEMVER_REGEXP) || [];
    const major = $a15fd97f4e1b6d43$var$_parseInt(match[1]);
    const minor = $a15fd97f4e1b6d43$var$_parseInt(match[2]);
    const patch = $a15fd97f4e1b6d43$var$_parseInt(match[3]);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $a15fd97f4e1b6d43$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $ac71f3aed2307965$export$4215662d762d6f9d)(line, 0));
    // We guard here to ensure this is not larger than the existing number of lines
    const lineIndex = Math.min(maxLines - 1, sourceLine);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    frame.context_line = (0, $ac71f3aed2307965$export$4215662d762d6f9d)(lines[lineIndex], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $ac71f3aed2307965$export$4215662d762d6f9d)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $a15fd97f4e1b6d43$export$6de4ffac6a2f1098(exception) {
    if ($a15fd97f4e1b6d43$var$isAlreadyCaptured(exception)) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $69901043324a0df8$export$e73679ffaf56810e)(exception, "__sentry_captured__", true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
function $a15fd97f4e1b6d43$var$isAlreadyCaptured(exception) {
    try {
        return exception.__sentry_captured__;
    } catch  {} // eslint-disable-line no-empty
}



const $3fb634bee7939c58$var$DEBOUNCE_DURATION = 1000;
let $3fb634bee7939c58$var$debounceTimerID;
let $3fb634bee7939c58$var$lastCapturedEventType;
let $3fb634bee7939c58$var$lastCapturedEventTargetId;
/**
 * Add an instrumentation handler for when a click or a keypress happens.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $3fb634bee7939c58$export$5aeffd3db2cf9df7(handler) {
    const type = "dom";
    (0, $1c39801aee9436e3$export$a4e09611e30da72e)(type, handler);
    (0, $1c39801aee9436e3$export$e18d6c5462c01368)(type, $3fb634bee7939c58$export$3014bbf0af0e1d4a);
}
/** Exported for tests only. */ function $3fb634bee7939c58$export$3014bbf0af0e1d4a() {
    if (!(0, $40dc3e9cd8295a99$export$56d8a8a25bd48b81).document) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    const triggerDOMHandler = (0, $1c39801aee9436e3$export$b18c893e424d3127).bind(null, "dom");
    const globalDOMEventHandler = $3fb634bee7939c58$var$makeDOMEventHandler(triggerDOMHandler, true);
    (0, $40dc3e9cd8295a99$export$56d8a8a25bd48b81).document.addEventListener("click", globalDOMEventHandler, false);
    (0, $40dc3e9cd8295a99$export$56d8a8a25bd48b81).document.addEventListener("keypress", globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        "EventTarget",
        "Node"
    ].forEach((target)=>{
        const globalObject = (0, $40dc3e9cd8295a99$export$56d8a8a25bd48b81);
        const proto = globalObject[target]?.prototype;
        // eslint-disable-next-line no-prototype-builtins
        if (!proto?.hasOwnProperty?.("addEventListener")) return;
        (0, $69901043324a0df8$export$9563e054e6f787fb)(proto, "addEventListener", function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const handlers = this.__sentry_instrumentation_handlers__ = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $3fb634bee7939c58$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListeners` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $69901043324a0df8$export$9563e054e6f787fb)(proto, "removeEventListener", function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const handlers = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers).length === 0) delete this.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListeners` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
/**
 * Check whether the event is similar to the last captured one. For example, two click events on the same button.
 */ function $3fb634bee7939c58$var$isSimilarToLastCapturedEvent(event) {
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (event.type !== $3fb634bee7939c58$var$lastCapturedEventType) return false;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (!event.target || event.target._sentryId !== $3fb634bee7939c58$var$lastCapturedEventTargetId) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return true;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $3fb634bee7939c58$var$shouldSkipDOMEvent(eventType, target) {
    // We are only interested in filtering `keypress` events for now.
    if (eventType !== "keypress") return false;
    if (!target?.tagName) return true;
    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable) return false;
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 */ function $3fb634bee7939c58$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || event["_sentryCaptured"]) return;
        const target = $3fb634bee7939c58$var$getEventTarget(event);
        // We always want to skip _some_ events.
        if ($3fb634bee7939c58$var$shouldSkipDOMEvent(event.type, target)) return;
        // Mark event as "seen"
        (0, $69901043324a0df8$export$e73679ffaf56810e)(event, "_sentryCaptured", true);
        if (target && !target._sentryId) // Add UUID to event target so we can identify if
        (0, $69901043324a0df8$export$e73679ffaf56810e)(target, "_sentryId", (0, $a15fd97f4e1b6d43$export$19f53698e68b2496)());
        const name = event.type === "keypress" ? "input" : event.type;
        // If there is no last captured event, it means that we can safely capture the new event and store it for future comparisons.
        // If there is a last captured event, see if the new event is different enough to treat it as a unique one.
        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
        if (!$3fb634bee7939c58$var$isSimilarToLastCapturedEvent(event)) {
            const handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            $3fb634bee7939c58$var$lastCapturedEventType = event.type;
            $3fb634bee7939c58$var$lastCapturedEventTargetId = target ? target._sentryId : undefined;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($3fb634bee7939c58$var$debounceTimerID);
        $3fb634bee7939c58$var$debounceTimerID = (0, $40dc3e9cd8295a99$export$56d8a8a25bd48b81).setTimeout(()=>{
            $3fb634bee7939c58$var$lastCapturedEventTargetId = undefined;
            $3fb634bee7939c58$var$lastCapturedEventType = undefined;
        }, $3fb634bee7939c58$var$DEBOUNCE_DURATION);
    };
}
function $3fb634bee7939c58$var$getEventTarget(event) {
    try {
        return event.target;
    } catch (e) {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
        return null;
    }
}



let $6bfcc9d7c86121e5$var$lastHref;
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $6bfcc9d7c86121e5$export$3f18c56c58114e75(handler) {
    const type = "history";
    (0, $1c39801aee9436e3$export$a4e09611e30da72e)(type, handler);
    (0, $1c39801aee9436e3$export$e18d6c5462c01368)(type, $6bfcc9d7c86121e5$export$d9b613a6254a184e);
}
/**
 * Exported just for testing
 */ function $6bfcc9d7c86121e5$export$d9b613a6254a184e() {
    // The `popstate` event may also be triggered on `pushState`, but it may not always reliably be emitted by the browser
    // Which is why we also monkey-patch methods below, in addition to this
    (0, $40dc3e9cd8295a99$export$56d8a8a25bd48b81).addEventListener("popstate", ()=>{
        const to = (0, $40dc3e9cd8295a99$export$56d8a8a25bd48b81).location.href;
        // keep track of the current URL state, as we always receive only the updated state
        const from = $6bfcc9d7c86121e5$var$lastHref;
        $6bfcc9d7c86121e5$var$lastHref = to;
        if (from === to) return;
        const handlerData = {
            from: from,
            to: to
        };
        (0, $1c39801aee9436e3$export$b18c893e424d3127)("history", handlerData);
    });
    // Just guard against this not being available, in weird environments
    if (!(0, $cf78825dfe129821$export$67fc34576016d6ec)()) return;
    function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : undefined;
            if (url) {
                const from = $6bfcc9d7c86121e5$var$lastHref;
                // Ensure the URL is absolute
                // this can be either a path, then it is relative to the current origin
                // or a full URL of the current origin - other origins are not allowed
                // See: https://developer.mozilla.org/en-US/docs/Web/API/History/pushState#url
                // coerce to string (this is what pushState does)
                const to = $6bfcc9d7c86121e5$var$getAbsoluteUrl(String(url));
                // keep track of the current URL state, as we always receive only the updated state
                $6bfcc9d7c86121e5$var$lastHref = to;
                if (from === to) return originalHistoryFunction.apply(this, args);
                const handlerData = {
                    from: from,
                    to: to
                };
                (0, $1c39801aee9436e3$export$b18c893e424d3127)("history", handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $69901043324a0df8$export$9563e054e6f787fb)((0, $40dc3e9cd8295a99$export$56d8a8a25bd48b81).history, "pushState", historyReplacementFunction);
    (0, $69901043324a0df8$export$9563e054e6f787fb)((0, $40dc3e9cd8295a99$export$56d8a8a25bd48b81).history, "replaceState", historyReplacementFunction);
}
function $6bfcc9d7c86121e5$var$getAbsoluteUrl(urlOrPath) {
    try {
        const url = new URL(urlOrPath, (0, $40dc3e9cd8295a99$export$56d8a8a25bd48b81).location.origin);
        return url.toString();
    } catch  {
        // fallback, just do nothing
        return urlOrPath;
    }
}


const $b83fbc460ca20326$var$ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 */ function $b83fbc460ca20326$export$7740643b9eeaf0c4() {
    return Date.now() / $b83fbc460ca20326$var$ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function $b83fbc460ca20326$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $20ae43346f76bdfd$export$f1a6cdb1459e81d1);
    if (!performance?.now) return $b83fbc460ca20326$export$7740643b9eeaf0c4;
    // Some browser and environments don't have a timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    const approxStartingTimeOrigin = Date.now() - performance.now();
    const timeOrigin = performance.timeOrigin == undefined ? approxStartingTimeOrigin : performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return ()=>{
        return (timeOrigin + performance.now()) / $b83fbc460ca20326$var$ONE_SECOND_IN_MS;
    };
}
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ const $b83fbc460ca20326$export$ee52dced521e3e18 = $b83fbc460ca20326$var$createUnixTimestampInSecondsFunc();
/**
 * Cached result of getBrowserTimeOrigin.
 */ let $b83fbc460ca20326$var$cachedTimeOrigin;
/**
 * Gets the time origin and the mode used to determine it.
 */ function $b83fbc460ca20326$var$getBrowserTimeOrigin() {
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    const { performance: performance } = (0, $20ae43346f76bdfd$export$f1a6cdb1459e81d1);
    if (!performance?.now) return [
        undefined,
        "none"
    ];
    const threshold = 3600000;
    const performanceNow = performance.now();
    const dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    const timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing?.navigationStart;
    const hasNavigationStart = typeof navigationStart === "number";
    // if navigationStart isn't available set delta to threshold so it isn't used
    const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    const navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) return [
            performance.timeOrigin,
            "timeOrigin"
        ];
        else return [
            navigationStart,
            "navigationStart"
        ];
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    return [
        dateNow,
        "dateNow"
    ];
}
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ function $b83fbc460ca20326$export$baf075a948ffc0bf() {
    if (!$b83fbc460ca20326$var$cachedTimeOrigin) $b83fbc460ca20326$var$cachedTimeOrigin = $b83fbc460ca20326$var$getBrowserTimeOrigin();
    return $b83fbc460ca20326$var$cachedTimeOrigin[0];
}



const $932d70c5552b8c29$export$55b6bb1e45c6cf59 = "__sentry_xhr_v3__";
/**
 * Add an instrumentation handler for when an XHR request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $932d70c5552b8c29$export$26ace48dd54c9aea(handler) {
    const type = "xhr";
    (0, $1c39801aee9436e3$export$a4e09611e30da72e)(type, handler);
    (0, $1c39801aee9436e3$export$e18d6c5462c01368)(type, $932d70c5552b8c29$export$c67d533bf77cbf54);
}
/** Exported only for tests. */ function $932d70c5552b8c29$export$c67d533bf77cbf54() {
    if (!(0, $40dc3e9cd8295a99$export$56d8a8a25bd48b81).XMLHttpRequest) return;
    const xhrproto = XMLHttpRequest.prototype;
    // eslint-disable-next-line @typescript-eslint/unbound-method
    xhrproto.open = new Proxy(xhrproto.open, {
        apply (originalOpen, xhrOpenThisArg, xhrOpenArgArray) {
            // NOTE: If you are a Sentry user, and you are seeing this stack frame,
            //       it means the error, that was caused by your XHR call did not
            //       have a stack trace. If you are using HttpClient integration,
            //       this is the expected behavior, as we are using this virtual error to capture
            //       the location of your XHR call, and group your HttpClient events accordingly.
            const virtualError = new Error();
            const startTimestamp = (0, $b83fbc460ca20326$export$ee52dced521e3e18)() * 1000;
            // open() should always be called with two or more arguments
            // But to be on the safe side, we actually validate this and bail out if we don't have a method & url
            const method = (0, $4541e6bae1c3cae8$export$844ec244b1367d54)(xhrOpenArgArray[0]) ? xhrOpenArgArray[0].toUpperCase() : undefined;
            const url = $932d70c5552b8c29$var$parseXhrUrlArg(xhrOpenArgArray[1]);
            if (!method || !url) return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
            xhrOpenThisArg[$932d70c5552b8c29$export$55b6bb1e45c6cf59] = {
                method: method,
                url: url,
                request_headers: {}
            };
            // if Sentry key appears in URL, don't capture it as a request
            if (method === "POST" && url.match(/sentry_key/)) xhrOpenThisArg.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                // For whatever reason, this is not the same instance here as from the outer method
                const xhrInfo = xhrOpenThisArg[$932d70c5552b8c29$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (xhrOpenThisArg.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = xhrOpenThisArg.status;
                    } catch (e) {
                    /* do nothing */ }
                    const handlerData = {
                        endTimestamp: (0, $b83fbc460ca20326$export$ee52dced521e3e18)() * 1000,
                        startTimestamp: startTimestamp,
                        xhr: xhrOpenThisArg,
                        virtualError: virtualError
                    };
                    (0, $1c39801aee9436e3$export$b18c893e424d3127)("xhr", handlerData);
                }
            };
            if ("onreadystatechange" in xhrOpenThisArg && typeof xhrOpenThisArg.onreadystatechange === "function") xhrOpenThisArg.onreadystatechange = new Proxy(xhrOpenThisArg.onreadystatechange, {
                apply (originalOnreadystatechange, onreadystatechangeThisArg, onreadystatechangeArgArray) {
                    onreadystatechangeHandler();
                    return originalOnreadystatechange.apply(onreadystatechangeThisArg, onreadystatechangeArgArray);
                }
            });
            else xhrOpenThisArg.addEventListener("readystatechange", onreadystatechangeHandler);
            // Intercepting `setRequestHeader` to access the request headers of XHR instance.
            // This will only work for user/library defined headers, not for the default/browser-assigned headers.
            // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
            xhrOpenThisArg.setRequestHeader = new Proxy(xhrOpenThisArg.setRequestHeader, {
                apply (originalSetRequestHeader, setRequestHeaderThisArg, setRequestHeaderArgArray) {
                    const [header, value] = setRequestHeaderArgArray;
                    const xhrInfo = setRequestHeaderThisArg[$932d70c5552b8c29$export$55b6bb1e45c6cf59];
                    if (xhrInfo && (0, $4541e6bae1c3cae8$export$844ec244b1367d54)(header) && (0, $4541e6bae1c3cae8$export$844ec244b1367d54)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return originalSetRequestHeader.apply(setRequestHeaderThisArg, setRequestHeaderArgArray);
                }
            });
            return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
        }
    });
    // eslint-disable-next-line @typescript-eslint/unbound-method
    xhrproto.send = new Proxy(xhrproto.send, {
        apply (originalSend, sendThisArg, sendArgArray) {
            const sentryXhrData = sendThisArg[$932d70c5552b8c29$export$55b6bb1e45c6cf59];
            if (!sentryXhrData) return originalSend.apply(sendThisArg, sendArgArray);
            if (sendArgArray[0] !== undefined) sentryXhrData.body = sendArgArray[0];
            const handlerData = {
                startTimestamp: (0, $b83fbc460ca20326$export$ee52dced521e3e18)() * 1000,
                xhr: sendThisArg
            };
            (0, $1c39801aee9436e3$export$b18c893e424d3127)("xhr", handlerData);
            return originalSend.apply(sendThisArg, sendArgArray);
        }
    });
}
/**
 * Parses the URL argument of a XHR method to a string.
 *
 * See: https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/open#url
 * url: A string or any other object with a stringifier — including a URL object — that provides the URL of the resource to send the request to.
 *
 * @param url - The URL argument of an XHR method
 * @returns The parsed URL string or undefined if the URL is invalid
 */ function $932d70c5552b8c29$var$parseXhrUrlArg(url) {
    if ((0, $4541e6bae1c3cae8$export$844ec244b1367d54)(url)) return url;
    try {
        // If the passed in argument is not a string, it should have a `toString` method as a stringifier.
        // If that fails, we just return undefined (like in IE11 where URL is not available)
        return url.toString();
    } catch  {} // eslint-disable-line no-empty
    return undefined;
}


/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $fe45e6d5f124fb0c$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;



/** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */ const $72e965827831ee54$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $72e965827831ee54$var$INTEGRATION_NAME = "Breadcrumbs";
const $72e965827831ee54$var$_breadcrumbsIntegration = (options = {})=>{
    const _options = {
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true,
        ...options
    };
    return {
        name: $72e965827831ee54$var$INTEGRATION_NAME,
        setup (client) {
            // TODO(v10): Remove this functionality and use `consoleIntegration` from @sentry/core instead.
            if (_options.console) (0, $08122a69e42135dc$export$1d6e0d073f9e6723)($72e965827831ee54$var$_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, $3fb634bee7939c58$export$5aeffd3db2cf9df7)($72e965827831ee54$var$_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, $932d70c5552b8c29$export$26ace48dd54c9aea)($72e965827831ee54$var$_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, $1f5839cb68df003d$export$f75d3c772c923df0)($72e965827831ee54$var$_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, $6bfcc9d7c86121e5$export$3f18c56c58114e75)($72e965827831ee54$var$_getHistoryBreadcrumbHandler(client));
            if (_options.sentry) client.on("beforeSendEvent", $72e965827831ee54$var$_getSentryBreadcrumbHandler(client));
        }
    };
};
const $72e965827831ee54$export$c079d904b326663a = (0, $5cfb41e3e92106c4$export$2323046b9414659f)($72e965827831ee54$var$_breadcrumbsIntegration);
/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */ function $72e965827831ee54$var$_getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, $0b98faa1b87c8168$export$6bb76d6eba7e258c)() !== client) return;
        (0, $ee7505b2004f4941$export$efda9a273d7a036d)({
            category: `sentry.${event.type === "transaction" ? "transaction" : "event"}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $c65fa882a3254127$export$4157119e2b157127)(event)
        }, {
            event: event
        });
    };
}
/**
 * A HOC that creates a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ function $72e965827831ee54$var$_getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, $0b98faa1b87c8168$export$6bb76d6eba7e258c)() !== client) return;
        let target;
        let componentName;
        let keyAttrs = typeof dom === "object" ? dom.serializeAttribute : undefined;
        let maxStringLength = typeof dom === "object" && typeof dom.maxStringLength === "number" ? dom.maxStringLength : undefined;
        if (maxStringLength && maxStringLength > $72e965827831ee54$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $fe45e6d5f124fb0c$export$16a28057038b10ef) && (0, $dfad86e498c52aee$export$af88d00dbe7f521).warn(`\`dom.maxStringLength\` cannot exceed ${$72e965827831ee54$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$72e965827831ee54$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $72e965827831ee54$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === "string") keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            const event = handlerData.event;
            const element = $72e965827831ee54$var$_isEvent(event) ? event.target : event;
            target = (0, $8afcf0d9e9f8c38b$export$5647df6b7814ac86)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, $8afcf0d9e9f8c38b$export$26727cfcc4d7e0fc)(element);
        } catch (e) {
            target = "<unknown>";
        }
        if (target.length === 0) return;
        const breadcrumb = {
            category: `ui.${handlerData.name}`,
            message: target
        };
        if (componentName) breadcrumb.data = {
            "ui.component_name": componentName
        };
        (0, $ee7505b2004f4941$export$efda9a273d7a036d)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
/**
 * Creates breadcrumbs from console API calls
 */ function $72e965827831ee54$var$_getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, $0b98faa1b87c8168$export$6bb76d6eba7e258c)() !== client) return;
        const breadcrumb = {
            category: "console",
            data: {
                arguments: handlerData.args,
                logger: "console"
            },
            level: (0, $ef87419235eb9f8c$export$d771ef054122c30a)(handlerData.level),
            message: (0, $79b6b3761a352021$export$465e9d514283d4fd)(handlerData.args, " ")
        };
        if (handlerData.level === "assert") {
            if (handlerData.args[0] === false) {
                breadcrumb.message = `Assertion failed: ${(0, $79b6b3761a352021$export$465e9d514283d4fd)(handlerData.args.slice(1), " ") || "console.assert"}`;
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else // Don't capture a breadcrumb for passed assertions
            return;
        }
        (0, $ee7505b2004f4941$export$efda9a273d7a036d)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
/**
 * Creates breadcrumbs from XHR API calls
 */ function $72e965827831ee54$var$_getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, $0b98faa1b87c8168$export$6bb76d6eba7e258c)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        const sentryXhrData = handlerData.xhr[0, $932d70c5552b8c29$export$55b6bb1e45c6cf59];
        // We only capture complete, non-sentry requests
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
        const data = {
            method: method,
            url: url,
            status_code: status_code
        };
        const hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        const breadcrumb = {
            category: "xhr",
            data: data,
            type: "http",
            level: (0, $c4ed481e2fed84d8$export$b8cfcc4175694bcc)(status_code)
        };
        client.emit("beforeOutgoingRequestBreadcrumb", breadcrumb, hint);
        (0, $ee7505b2004f4941$export$efda9a273d7a036d)(breadcrumb, hint);
    };
}
/**
 * Creates breadcrumbs from fetch API calls
 */ function $72e965827831ee54$var$_getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, $0b98faa1b87c8168$export$6bb76d6eba7e258c)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        // We only capture complete fetch requests
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === "POST") // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
        return;
        handlerData.fetchData.method, handlerData.fetchData.url;
        if (handlerData.error) {
            const data = handlerData.fetchData;
            const hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            const breadcrumb = {
                category: "fetch",
                data: data,
                level: "error",
                type: "http"
            };
            client.emit("beforeOutgoingRequestBreadcrumb", breadcrumb, hint);
            (0, $ee7505b2004f4941$export$efda9a273d7a036d)(breadcrumb, hint);
        } else {
            const response = handlerData.response;
            const data = {
                ...handlerData.fetchData,
                status_code: response?.status
            };
            handlerData.fetchData.request_body_size;
            handlerData.fetchData.response_body_size;
            response?.status;
            const hint = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            const breadcrumb = {
                category: "fetch",
                data: data,
                type: "http",
                level: (0, $c4ed481e2fed84d8$export$b8cfcc4175694bcc)(data.status_code)
            };
            client.emit("beforeOutgoingRequestBreadcrumb", breadcrumb, hint);
            (0, $ee7505b2004f4941$export$efda9a273d7a036d)(breadcrumb, hint);
        }
    };
}
/**
 * Creates breadcrumbs from history API calls
 */ function $72e965827831ee54$var$_getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, $0b98faa1b87c8168$export$6bb76d6eba7e258c)() !== client) return;
        let from = handlerData.from;
        let to = handlerData.to;
        const parsedLoc = (0, $34321b3a3ce9dbbd$export$7a5253c0f62e0150)((0, $9c98becc1d3a3995$export$56d8a8a25bd48b81).location.href);
        let parsedFrom = from ? (0, $34321b3a3ce9dbbd$export$7a5253c0f62e0150)(from) : undefined;
        const parsedTo = (0, $34321b3a3ce9dbbd$export$7a5253c0f62e0150)(to);
        // Initial pushState doesn't provide `from` information
        if (!parsedFrom?.path) parsedFrom = parsedLoc;
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $ee7505b2004f4941$export$efda9a273d7a036d)({
            category: "navigation",
            data: {
                from: from,
                to: to
            }
        });
    };
}
function $72e965827831ee54$var$_isEvent(event) {
    return !!event && !!event.target;
}




const $cbc8cb5a8604edeb$var$DEFAULT_EVENT_TARGET = [
    "EventTarget",
    "Window",
    "Node",
    "ApplicationCache",
    "AudioTrackList",
    "BroadcastChannel",
    "ChannelMergerNode",
    "CryptoOperation",
    "EventSource",
    "FileReader",
    "HTMLUnknownElement",
    "IDBDatabase",
    "IDBRequest",
    "IDBTransaction",
    "KeyOperation",
    "MediaController",
    "MessagePort",
    "ModalWindow",
    "Notification",
    "SVGElementInstance",
    "Screen",
    "SharedWorker",
    "TextTrack",
    "TextTrackCue",
    "TextTrackList",
    "WebSocket",
    "WebSocketWorker",
    "Worker",
    "XMLHttpRequest",
    "XMLHttpRequestEventTarget",
    "XMLHttpRequestUpload"
];
const $cbc8cb5a8604edeb$var$INTEGRATION_NAME = "BrowserApiErrors";
const $cbc8cb5a8604edeb$var$_browserApiErrorsIntegration = (options = {})=>{
    const _options = {
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true,
        unregisterOriginalCallbacks: false,
        ...options
    };
    return {
        name: $cbc8cb5a8604edeb$var$INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce () {
            if (_options.setTimeout) (0, $90379bc90653c4b6$export$9563e054e6f787fb)((0, $9c98becc1d3a3995$export$56d8a8a25bd48b81), "setTimeout", $cbc8cb5a8604edeb$var$_wrapTimeFunction);
            if (_options.setInterval) (0, $90379bc90653c4b6$export$9563e054e6f787fb)((0, $9c98becc1d3a3995$export$56d8a8a25bd48b81), "setInterval", $cbc8cb5a8604edeb$var$_wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, $90379bc90653c4b6$export$9563e054e6f787fb)((0, $9c98becc1d3a3995$export$56d8a8a25bd48b81), "requestAnimationFrame", $cbc8cb5a8604edeb$var$_wrapRAF);
            if (_options.XMLHttpRequest && "XMLHttpRequest" in (0, $9c98becc1d3a3995$export$56d8a8a25bd48b81)) (0, $90379bc90653c4b6$export$9563e054e6f787fb)(XMLHttpRequest.prototype, "send", $cbc8cb5a8604edeb$var$_wrapXHR);
            const eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $cbc8cb5a8604edeb$var$DEFAULT_EVENT_TARGET;
                eventTarget.forEach((target)=>$cbc8cb5a8604edeb$var$_wrapEventTarget(target, _options));
            }
        }
    };
};
/**
 * Wrap timer functions and event targets to catch errors and provide better meta data.
 */ const $cbc8cb5a8604edeb$export$59bfe9f1c76150e = (0, $5cfb41e3e92106c4$export$2323046b9414659f)($cbc8cb5a8604edeb$var$_browserApiErrorsIntegration);
function $cbc8cb5a8604edeb$var$_wrapTimeFunction(original) {
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $9c98becc1d3a3995$export$4997ffc0176396a6)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, $ed9a0f1a0a69d190$export$aad197c7121a6651)(original)
                },
                handled: false,
                type: "instrument"
            }
        });
        return original.apply(this, args);
    };
}
function $cbc8cb5a8604edeb$var$_wrapRAF(original) {
    return function(callback) {
        return original.apply(this, [
            (0, $9c98becc1d3a3995$export$4997ffc0176396a6)(callback, {
                mechanism: {
                    data: {
                        function: "requestAnimationFrame",
                        handler: (0, $ed9a0f1a0a69d190$export$aad197c7121a6651)(original)
                    },
                    handled: false,
                    type: "instrument"
                }
            })
        ]);
    };
}
function $cbc8cb5a8604edeb$var$_wrapXHR(originalSend) {
    return function(...args) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const xhr = this;
        const xmlHttpRequestProps = [
            "onload",
            "onerror",
            "onprogress",
            "onreadystatechange"
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === "function") (0, $90379bc90653c4b6$export$9563e054e6f787fb)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, $ed9a0f1a0a69d190$export$aad197c7121a6651)(original)
                        },
                        handled: false,
                        type: "instrument"
                    }
                };
                // If Instrument integration has been called before BrowserApiErrors, get the name of original function
                const originalFunction = (0, $90379bc90653c4b6$export$e6cc1e135e2092e5)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $ed9a0f1a0a69d190$export$aad197c7121a6651)(originalFunction);
                // Otherwise wrap directly
                return (0, $9c98becc1d3a3995$export$4997ffc0176396a6)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function $cbc8cb5a8604edeb$var$_wrapEventTarget(target, integrationOptions) {
    const globalObject = (0, $9c98becc1d3a3995$export$56d8a8a25bd48b81);
    const proto = globalObject[target]?.prototype;
    // eslint-disable-next-line no-prototype-builtins
    if (!proto?.hasOwnProperty?.("addEventListener")) return;
    (0, $90379bc90653c4b6$export$9563e054e6f787fb)(proto, "addEventListener", function(original) {
        return function(eventName, fn, options) {
            try {
                if ($cbc8cb5a8604edeb$var$isEventListenerObject(fn)) // ESlint disable explanation:
                //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
                //  introduce a bug here, because bind returns a new function that doesn't have our
                //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
                //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                // eslint-disable-next-line @typescript-eslint/unbound-method
                fn.handleEvent = (0, $9c98becc1d3a3995$export$4997ffc0176396a6)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            function: "handleEvent",
                            handler: (0, $ed9a0f1a0a69d190$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: false,
                        type: "instrument"
                    }
                });
            } catch  {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            if (integrationOptions.unregisterOriginalCallbacks) $cbc8cb5a8604edeb$var$unregisterOriginalCallback(this, eventName, fn);
            return original.apply(this, [
                eventName,
                (0, $9c98becc1d3a3995$export$4997ffc0176396a6)(fn, {
                    mechanism: {
                        data: {
                            function: "addEventListener",
                            handler: (0, $ed9a0f1a0a69d190$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: false,
                        type: "instrument"
                    }
                }),
                options
            ]);
        };
    });
    (0, $90379bc90653c4b6$export$9563e054e6f787fb)(proto, "removeEventListener", function(originalRemoveEventListener) {
        return function(eventName, fn, options) {
            /**
       * There are 2 possible scenarios here:
       *
       * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
       * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
       * as a pass-through, and call original `removeEventListener` with it.
       *
       * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
       * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
       * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
       * in order for us to make a distinction between wrapped/non-wrapped functions possible.
       * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
       *
       * When someone adds a handler prior to initialization, and then do it again, but after,
       * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
       * to get rid of the initial handler and it'd stick there forever.
       */ try {
                const originalEventHandler = fn.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, fn, options);
        };
    });
}
function $cbc8cb5a8604edeb$var$isEventListenerObject(obj) {
    return typeof obj.handleEvent === "function";
}
function $cbc8cb5a8604edeb$var$unregisterOriginalCallback(target, eventName, fn) {
    if (target && typeof target === "object" && "removeEventListener" in target && typeof target.removeEventListener === "function") target.removeEventListener(eventName, fn);
}






/**
 * When added, automatically creates sessions which allow you to track adoption and crashes (crash free rate) in your Releases in Sentry.
 * More information: https://docs.sentry.io/product/releases/health/
 *
 * Note: In order for session tracking to work, you need to set up Releases: https://docs.sentry.io/product/releases/
 */ const $8b736359c68920d8$export$1baa7880e357371c = (0, $5cfb41e3e92106c4$export$2323046b9414659f)(()=>{
    return {
        name: "BrowserSession",
        setupOnce () {
            if (typeof (0, $9c98becc1d3a3995$export$56d8a8a25bd48b81).document === "undefined") {
                (0, $fe45e6d5f124fb0c$export$16a28057038b10ef) && (0, $dfad86e498c52aee$export$af88d00dbe7f521).warn("Using the `browserSessionIntegration` in non-browser environments is not supported.");
                return;
            }
            // The session duration for browser sessions does not track a meaningful
            // concept that can be used as a metric.
            // Automatically captured sessions are akin to page views, and thus we
            // discard their duration.
            (0, $584cdb98c6222991$export$c0d84948cecf78d8)({
                ignoreDuration: true
            });
            (0, $584cdb98c6222991$export$667e7b4d445d566b)();
            // We want to create a session for every navigation as well
            (0, $6bfcc9d7c86121e5$export$3f18c56c58114e75)(({ from: from, to: to })=>{
                // Don't create an additional session for the initial route or if the location did not change
                if (from !== undefined && from !== to) {
                    (0, $584cdb98c6222991$export$c0d84948cecf78d8)({
                        ignoreDuration: true
                    });
                    (0, $584cdb98c6222991$export$667e7b4d445d566b)();
                }
            });
        }
    };
});






const $1b2080bc7187f32c$var$INTEGRATION_NAME = "GlobalHandlers";
const $1b2080bc7187f32c$var$_globalHandlersIntegration = (options = {})=>{
    const _options = {
        onerror: true,
        onunhandledrejection: true,
        ...options
    };
    return {
        name: $1b2080bc7187f32c$var$INTEGRATION_NAME,
        setupOnce () {
            Error.stackTraceLimit = 50;
        },
        setup (client) {
            if (_options.onerror) {
                $1b2080bc7187f32c$var$_installGlobalOnErrorHandler(client);
                $1b2080bc7187f32c$var$globalHandlerLog("onerror");
            }
            if (_options.onunhandledrejection) {
                $1b2080bc7187f32c$var$_installGlobalOnUnhandledRejectionHandler(client);
                $1b2080bc7187f32c$var$globalHandlerLog("onunhandledrejection");
            }
        }
    };
};
const $1b2080bc7187f32c$export$66acc70e8cf2b71a = (0, $5cfb41e3e92106c4$export$2323046b9414659f)($1b2080bc7187f32c$var$_globalHandlersIntegration);
function $1b2080bc7187f32c$var$_installGlobalOnErrorHandler(client) {
    (0, $c8c70ae4e52a41c7$export$55b5c3ba2194f0c6)((data)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $1b2080bc7187f32c$var$getOptions();
        if ((0, $0b98faa1b87c8168$export$6bb76d6eba7e258c)() !== client || (0, $9c98becc1d3a3995$export$b79738ab10c590b2)()) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        const event = $1b2080bc7187f32c$var$_enhanceEventWithInitialFrame((0, $a499dd93ae694349$export$9dd56ed1ef0c3420)(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = "error";
        (0, $584cdb98c6222991$export$1462b974fdcf6ba2)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "onerror"
            }
        });
    });
}
function $1b2080bc7187f32c$var$_installGlobalOnUnhandledRejectionHandler(client) {
    (0, $54dc1fc04528211a$export$8bf4fc6858821a4e)((e)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $1b2080bc7187f32c$var$getOptions();
        if ((0, $0b98faa1b87c8168$export$6bb76d6eba7e258c)() !== client || (0, $9c98becc1d3a3995$export$b79738ab10c590b2)()) return;
        const error = $1b2080bc7187f32c$var$_getUnhandledRejectionError(e);
        const event = (0, $ed5cb73b8752546d$export$c3825b437cbdea5c)(error) ? $1b2080bc7187f32c$var$_eventFromRejectionWithPrimitive(error) : (0, $a499dd93ae694349$export$9dd56ed1ef0c3420)(stackParser, error, undefined, attachStacktrace, true);
        event.level = "error";
        (0, $584cdb98c6222991$export$1462b974fdcf6ba2)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "onunhandledrejection"
            }
        });
    });
}
function $1b2080bc7187f32c$var$_getUnhandledRejectionError(error) {
    if ((0, $ed5cb73b8752546d$export$c3825b437cbdea5c)(error)) return error;
    // dig the object of the rejection out of known event types
    try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ("reason" in error) return error.reason;
        // something, somewhere, (likely a browser extension) effectively casts PromiseRejectionEvents
        // to CustomEvents, moving the `promise` and `reason` attributes of the PRE into
        // the CustomEvent's `detail` attribute, since they're not part of CustomEvent's spec
        // see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent and
        // https://github.com/getsentry/sentry-javascript/issues/2380
        if ("detail" in error && "reason" in error.detail) return error.detail.reason;
    } catch  {} // eslint-disable-line no-empty
    return error;
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $1b2080bc7187f32c$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: "UnhandledRejection",
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
function $1b2080bc7187f32c$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    const e = event.exception = event.exception || {};
    // event.exception.values
    const ev = e.values = e.values || [];
    // event.exception.values[0]
    const ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    const ev0sf = ev0s.frames = ev0s.frames || [];
    const colno = column;
    const lineno = line;
    const filename = (0, $ed5cb73b8752546d$export$844ec244b1367d54)(url) && url.length > 0 ? url : (0, $8afcf0d9e9f8c38b$export$1cfafeee2987818b)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: (0, $ed9a0f1a0a69d190$export$27c7e15d453fc0ac),
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $1b2080bc7187f32c$var$globalHandlerLog(type) {
    (0, $fe45e6d5f124fb0c$export$16a28057038b10ef) && (0, $dfad86e498c52aee$export$af88d00dbe7f521).log(`Global Handler attached: ${type}`);
}
function $1b2080bc7187f32c$var$getOptions() {
    const client = (0, $0b98faa1b87c8168$export$6bb76d6eba7e258c)();
    const options = client?.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return options;
}




/**
 * Collects information about HTTP request headers and
 * attaches them to the event.
 */ const $cc5de4f2add7e163$export$1378794447170364 = (0, $5cfb41e3e92106c4$export$2323046b9414659f)(()=>{
    return {
        name: "HttpContext",
        preprocessEvent (event) {
            // if none of the information we want exists, don't bother
            if (!(0, $9c98becc1d3a3995$export$56d8a8a25bd48b81).navigator && !(0, $9c98becc1d3a3995$export$56d8a8a25bd48b81).location && !(0, $9c98becc1d3a3995$export$56d8a8a25bd48b81).document) return;
            const reqData = (0, $9c98becc1d3a3995$export$a3c4a8453e8936f0)();
            const headers = {
                ...reqData.headers,
                ...event.request?.headers
            };
            event.request = {
                ...reqData,
                ...event.request,
                headers: headers
            };
        }
    };
});



/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */ function $2af91dc578faa5e0$export$b91c38ed7d8ae9b2(exceptionFromErrorImplementation, parser, key, limit, event, hint) {
    if (!event.exception?.values || !hint || !(0, $ed5cb73b8752546d$export$49034edbe6b62415)(hint.originalException, Error)) return;
    // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined;
    // We only create exception grouping if there is an exception in the event.
    if (originalException) event.exception.values = $2af91dc578faa5e0$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0);
}
function $2af91dc578faa5e0$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    // Recursively call this function in order to walk down a chain of errors
    if ((0, $ed5cb73b8752546d$export$49034edbe6b62415)(error[key], Error)) {
        $2af91dc578faa5e0$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        $2af91dc578faa5e0$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $2af91dc578faa5e0$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    // This will create exception grouping for AggregateErrors
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
    if (Array.isArray(error.errors)) error.errors.forEach((childError, i)=>{
        if ((0, $ed5cb73b8752546d$export$49034edbe6b62415)(childError, Error)) {
            $2af91dc578faa5e0$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            $2af91dc578faa5e0$var$applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = $2af91dc578faa5e0$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $2af91dc578faa5e0$var$applyExceptionGroupFieldsForParentException(exception, exceptionId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: "generic",
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        ...exception.type === "AggregateError" && {
            is_exception_group: true
        },
        exception_id: exceptionId
    };
}
function $2af91dc578faa5e0$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: "generic",
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        type: "chained",
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    };
}



const $960d78d16da62d4a$var$DEFAULT_KEY = "cause";
const $960d78d16da62d4a$var$DEFAULT_LIMIT = 5;
const $960d78d16da62d4a$var$INTEGRATION_NAME = "LinkedErrors";
const $960d78d16da62d4a$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $960d78d16da62d4a$var$DEFAULT_LIMIT;
    const key = options.key || $960d78d16da62d4a$var$DEFAULT_KEY;
    return {
        name: $960d78d16da62d4a$var$INTEGRATION_NAME,
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            (0, $2af91dc578faa5e0$export$b91c38ed7d8ae9b2)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, $a499dd93ae694349$export$a6c2d27607295951), options.stackParser, key, limit, event, hint);
        }
    };
};
/**
 * Aggregrate linked errors in an event.
 */ const $960d78d16da62d4a$export$ebabb00eb7f3a395 = (0, $5cfb41e3e92106c4$export$2323046b9414659f)($960d78d16da62d4a$var$_linkedErrorsIntegration);







/**
 * Returns true if the SDK is running in an embedded browser extension.
 * Stand-alone browser extensions (which do not share the same data as the main browser page) are fine.
 */ function $67fe0649224a3670$export$dc236a86065879fc() {
    if ($67fe0649224a3670$var$_isEmbeddedBrowserExtension()) {
        if (0, $fe45e6d5f124fb0c$export$16a28057038b10ef) (0, $dfad86e498c52aee$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.error("[Sentry] You cannot use Sentry.init() in a browser extension, see: https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/");
        });
        return true;
    }
    return false;
}
function $67fe0649224a3670$var$_isEmbeddedBrowserExtension() {
    if (typeof (0, $9c98becc1d3a3995$export$56d8a8a25bd48b81).window === "undefined") // No need to show the error if we're not in a browser window environment (e.g. service workers)
    return false;
    const _window = (0, $9c98becc1d3a3995$export$56d8a8a25bd48b81);
    // Running the SDK in NW.js, which appears like a browser extension but isn't, is also fine
    // see: https://github.com/getsentry/sentry-javascript/issues/12668
    if (_window.nw) return false;
    const extensionObject = _window["chrome"] || _window["browser"];
    if (!extensionObject?.runtime?.id) return false;
    const href = (0, $8afcf0d9e9f8c38b$export$1cfafeee2987818b)();
    const extensionProtocols = [
        "chrome-extension",
        "moz-extension",
        "ms-browser-extension",
        "safari-web-extension"
    ];
    // Running the SDK in a dedicated extension page and calling Sentry.init is fine; no risk of data leakage
    const isDedicatedExtensionPage = (0, $9c98becc1d3a3995$export$56d8a8a25bd48b81) === (0, $9c98becc1d3a3995$export$56d8a8a25bd48b81).top && extensionProtocols.some((protocol)=>href.startsWith(`${protocol}://`));
    return !isDedicatedExtensionPage;
}


/** Get the default integrations for the browser SDK. */ function $04bfbe110e873c9a$export$5783b2920b1d62b9(_options) {
    /**
   * Note: Please make sure this stays in sync with Angular SDK, which re-exports
   * `getDefaultIntegrations` but with an adjusted set of integrations.
   */ return [
        // TODO(v10): Replace with `eventFiltersIntegration` once we remove the deprecated `inboundFiltersIntegration`
        // eslint-disable-next-line deprecation/deprecation
        (0, $59875e18f45a8371$export$cb3c5c2ceb9818ba)(),
        (0, $4292595dc8172ea7$export$7918117e9202e4fb)(),
        (0, $cbc8cb5a8604edeb$export$59bfe9f1c76150e)(),
        (0, $72e965827831ee54$export$c079d904b326663a)(),
        (0, $1b2080bc7187f32c$export$66acc70e8cf2b71a)(),
        (0, $960d78d16da62d4a$export$ebabb00eb7f3a395)(),
        (0, $537c946bd548a1d5$export$6d39aa44cd0c7567)(),
        (0, $cc5de4f2add7e163$export$1378794447170364)(),
        (0, $8b736359c68920d8$export$1baa7880e357371c)()
    ];
}
/**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */ function $04bfbe110e873c9a$export$2cd8252107eb640b(options = {}) {
    const shouldDisableBecauseIsBrowserExtenstion = !options.skipBrowserExtensionCheck && (0, $67fe0649224a3670$export$dc236a86065879fc)();
    const clientOptions = {
        ...options,
        enabled: shouldDisableBecauseIsBrowserExtenstion ? false : options.enabled,
        stackParser: (0, $ed9a0f1a0a69d190$export$1d5cf88b347146d4)(options.stackParser || (0, $06eae0b9980e6601$export$2b2b997d81bf3907)),
        integrations: (0, $5cfb41e3e92106c4$export$68bc4c01ab8ae766)({
            integrations: options.integrations,
            defaultIntegrations: options.defaultIntegrations == null ? $04bfbe110e873c9a$export$5783b2920b1d62b9() : options.defaultIntegrations
        }),
        transport: options.transport || (0, $846ede25dfa44954$export$b2311068c46d7cc8)
    };
    return (0, $d57539a789385421$export$5333c3f1c58d9bc1)((0, $b91089b3308fbb6b$export$1df9218a526d318d), clientOptions);
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $04bfbe110e873c9a$export$a3f323d81eede727() {
// Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $04bfbe110e873c9a$export$4e4d8b287d028b6b(callback) {
    callback();
}





/**
 * Present the user with a report dialog.
 *
 * @param options Everything is optional, we try to fetch all info need from the current scope.
 */ function $150636d007eb8ee1$export$3a8fd680da42627b(options = {}) {
    const optionalDocument = (0, $9c98becc1d3a3995$export$56d8a8a25bd48b81).document;
    const injectionPoint = optionalDocument?.head || optionalDocument?.body;
    // doesn't work without a document (React Native)
    if (!injectionPoint) {
        (0, $fe45e6d5f124fb0c$export$16a28057038b10ef) && (0, $dfad86e498c52aee$export$af88d00dbe7f521).error("[showReportDialog] Global document not defined");
        return;
    }
    const scope = (0, $0b98faa1b87c8168$export$c7be4b0125a10cba)();
    const client = (0, $0b98faa1b87c8168$export$6bb76d6eba7e258c)();
    const dsn = client?.getDsn();
    if (!dsn) {
        (0, $fe45e6d5f124fb0c$export$16a28057038b10ef) && (0, $dfad86e498c52aee$export$af88d00dbe7f521).error("[showReportDialog] DSN not configured");
        return;
    }
    const mergedOptions = {
        ...options,
        user: {
            ...scope.getUser(),
            ...options.user
        },
        eventId: options.eventId || (0, $584cdb98c6222991$export$5d4e9fd7fac8e617)()
    };
    const script = (0, $9c98becc1d3a3995$export$56d8a8a25bd48b81).document.createElement("script");
    script.async = true;
    script.crossOrigin = "anonymous";
    script.src = (0, $e3f8c961f1c27003$export$671c7ed8e40a7a57)(dsn, mergedOptions);
    const { onLoad: onLoad, onClose: onClose } = mergedOptions;
    if (onLoad) script.onload = onLoad;
    if (onClose) {
        const reportDialogClosedMessageHandler = (event)=>{
            if (event.data === "__sentry_reportdialog_closed__") try {
                onClose();
            } finally{
                (0, $9c98becc1d3a3995$export$56d8a8a25bd48b81).removeEventListener("message", reportDialogClosedMessageHandler);
            }
        };
        (0, $9c98becc1d3a3995$export$56d8a8a25bd48b81).addEventListener("message", reportDialogClosedMessageHandler);
    }
    injectionPoint.appendChild(script);
}









const $628d5e129a23f25e$var$WINDOW = (0, $88208d9e04627397$export$f1a6cdb1459e81d1);
const $628d5e129a23f25e$var$INTEGRATION_NAME = "ReportingObserver";
const $628d5e129a23f25e$var$SETUP_CLIENTS = new WeakMap();
const $628d5e129a23f25e$var$_reportingObserverIntegration = (options = {})=>{
    const types = options.types || [
        "crash",
        "deprecation",
        "intervention"
    ];
    /** Handler for the reporting observer. */ function handler(reports) {
        if (!$628d5e129a23f25e$var$SETUP_CLIENTS.has((0, $0b98faa1b87c8168$export$6bb76d6eba7e258c)())) return;
        for (const report of reports)(0, $0b98faa1b87c8168$export$ec58d9285c204497)((scope)=>{
            scope.setExtra("url", report.url);
            const label = `ReportingObserver [${report.type}]`;
            let details = "No details available";
            if (report.body) {
                // Object.keys doesn't work on ReportBody, as all properties are inherited
                const plainBody = {};
                // eslint-disable-next-line guard-for-in
                for(const prop in report.body)plainBody[prop] = report.body[prop];
                scope.setExtra("body", plainBody);
                if (report.type === "crash") {
                    const body = report.body;
                    // A fancy way to create a message out of crashId OR reason OR both OR fallback
                    details = [
                        body.crashId || "",
                        body.reason || ""
                    ].join(" ").trim() || details;
                } else {
                    const body = report.body;
                    details = body.message || details;
                }
            }
            (0, $584cdb98c6222991$export$45654777c133ae80)(`${label}: ${details}`);
        });
    }
    return {
        name: $628d5e129a23f25e$var$INTEGRATION_NAME,
        setupOnce () {
            if (!(0, $20b8c37b7dc32b0d$export$531055a6c684a70a)()) return;
            const observer = new $628d5e129a23f25e$var$WINDOW.ReportingObserver(handler, {
                buffered: true,
                types: types
            });
            observer.observe();
        },
        setup (client) {
            $628d5e129a23f25e$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
/**
 * Reporting API integration - https://w3c.github.io/reporting/
 */ const $628d5e129a23f25e$export$609cccfa9f328cc5 = (0, $5cfb41e3e92106c4$export$2323046b9414659f)($628d5e129a23f25e$var$_reportingObserverIntegration);


/**
 * Checks whether given url points to Sentry server
 *
 * @param url url to verify
 */ function $67d81651c8938ed0$export$d92e61f5600202af(url, client) {
    const dsn = client?.getDsn();
    const tunnel = client?.getOptions().tunnel;
    return $67d81651c8938ed0$var$checkDsn(url, dsn) || $67d81651c8938ed0$var$checkTunnel(url, tunnel);
}
function $67d81651c8938ed0$var$checkTunnel(url, tunnel) {
    if (!tunnel) return false;
    return $67d81651c8938ed0$var$removeTrailingSlash(url) === $67d81651c8938ed0$var$removeTrailingSlash(tunnel);
}
function $67d81651c8938ed0$var$checkDsn(url, dsn) {
    return dsn ? url.includes(dsn.host) : false;
}
function $67d81651c8938ed0$var$removeTrailingSlash(str) {
    return str[str.length - 1] === "/" ? str.slice(0, -1) : str;
}




const $5b9fa18608a480f3$var$INTEGRATION_NAME = "HttpClient";
const $5b9fa18608a480f3$var$_httpClientIntegration = (options = {})=>{
    const _options = {
        failedRequestStatusCodes: [
            [
                500,
                599
            ]
        ],
        failedRequestTargets: [
            /.*/
        ],
        ...options
    };
    return {
        name: $5b9fa18608a480f3$var$INTEGRATION_NAME,
        setup (client) {
            $5b9fa18608a480f3$var$_wrapFetch(client, _options);
            $5b9fa18608a480f3$var$_wrapXHR(client, _options);
        }
    };
};
/**
 * Create events for failed client side HTTP requests.
 */ const $5b9fa18608a480f3$export$8a3b7aeb379b3907 = (0, $5cfb41e3e92106c4$export$2323046b9414659f)($5b9fa18608a480f3$var$_httpClientIntegration);
/**
 * Interceptor function for fetch requests
 *
 * @param requestInfo The Fetch API request info
 * @param response The Fetch API response
 * @param requestInit The request init object
 */ function $5b9fa18608a480f3$var$_fetchResponseHandler(options, requestInfo, response, requestInit, error) {
    if ($5b9fa18608a480f3$var$_shouldCaptureResponse(options, response.status, response.url)) {
        const request = $5b9fa18608a480f3$var$_getRequest(requestInfo, requestInit);
        let requestHeaders, responseHeaders, requestCookies, responseCookies;
        if ($5b9fa18608a480f3$var$_shouldSendDefaultPii()) {
            [requestHeaders, requestCookies] = $5b9fa18608a480f3$var$_parseCookieHeaders("Cookie", request);
            [responseHeaders, responseCookies] = $5b9fa18608a480f3$var$_parseCookieHeaders("Set-Cookie", response);
        }
        const event = $5b9fa18608a480f3$var$_createEvent({
            url: request.url,
            method: request.method,
            status: response.status,
            requestHeaders: requestHeaders,
            responseHeaders: responseHeaders,
            requestCookies: requestCookies,
            responseCookies: responseCookies,
            error: error
        });
        (0, $584cdb98c6222991$export$1462b974fdcf6ba2)(event);
    }
}
function $5b9fa18608a480f3$var$_parseCookieHeaders(cookieHeader, obj) {
    const headers = $5b9fa18608a480f3$var$_extractFetchHeaders(obj.headers);
    let cookies;
    try {
        const cookieString = headers[cookieHeader] || headers[cookieHeader.toLowerCase()] || undefined;
        if (cookieString) cookies = $5b9fa18608a480f3$var$_parseCookieString(cookieString);
    } catch  {
    // ignore it if parsing fails
    }
    return [
        headers,
        cookies
    ];
}
/**
 * Interceptor function for XHR requests
 *
 * @param xhr The XHR request
 * @param method The HTTP method
 * @param headers The HTTP headers
 */ function $5b9fa18608a480f3$var$_xhrResponseHandler(options, xhr, method, headers, error) {
    if ($5b9fa18608a480f3$var$_shouldCaptureResponse(options, xhr.status, xhr.responseURL)) {
        let requestHeaders, responseCookies, responseHeaders;
        if ($5b9fa18608a480f3$var$_shouldSendDefaultPii()) {
            try {
                const cookieString = xhr.getResponseHeader("Set-Cookie") || xhr.getResponseHeader("set-cookie") || undefined;
                if (cookieString) responseCookies = $5b9fa18608a480f3$var$_parseCookieString(cookieString);
            } catch  {
            // ignore it if parsing fails
            }
            try {
                responseHeaders = $5b9fa18608a480f3$var$_getXHRResponseHeaders(xhr);
            } catch  {
            // ignore it if parsing fails
            }
            requestHeaders = headers;
        }
        const event = $5b9fa18608a480f3$var$_createEvent({
            url: xhr.responseURL,
            method: method,
            status: xhr.status,
            requestHeaders: requestHeaders,
            responseHeaders: // Can't access request cookies from XHR
            responseHeaders,
            responseCookies: responseCookies,
            error: error
        });
        (0, $584cdb98c6222991$export$1462b974fdcf6ba2)(event);
    }
}
/**
 * Extracts response size from `Content-Length` header when possible
 *
 * @param headers
 * @returns The response size in bytes or undefined
 */ function $5b9fa18608a480f3$var$_getResponseSizeFromHeaders(headers) {
    if (headers) {
        const contentLength = headers["Content-Length"] || headers["content-length"];
        if (contentLength) return parseInt(contentLength, 10);
    }
    return undefined;
}
/**
 * Creates an object containing cookies from the given cookie string
 *
 * @param cookieString The cookie string to parse
 * @returns The parsed cookies
 */ function $5b9fa18608a480f3$var$_parseCookieString(cookieString) {
    return cookieString.split("; ").reduce((acc, cookie)=>{
        const [key, value] = cookie.split("=");
        if (key && value) acc[key] = value;
        return acc;
    }, {});
}
/**
 * Extracts the headers as an object from the given Fetch API request or response object
 *
 * @param headers The headers to extract
 * @returns The extracted headers as an object
 */ function $5b9fa18608a480f3$var$_extractFetchHeaders(headers) {
    const result = {};
    headers.forEach((value, key)=>{
        result[key] = value;
    });
    return result;
}
/**
 * Extracts the response headers as an object from the given XHR object
 *
 * @param xhr The XHR object to extract the response headers from
 * @returns The response headers as an object
 */ function $5b9fa18608a480f3$var$_getXHRResponseHeaders(xhr) {
    const headers = xhr.getAllResponseHeaders();
    if (!headers) return {};
    return headers.split("\r\n").reduce((acc, line)=>{
        const [key, value] = line.split(": ");
        if (key && value) acc[key] = value;
        return acc;
    }, {});
}
/**
 * Checks if the given target url is in the given list of targets
 *
 * @param target The target url to check
 * @returns true if the target url is in the given list of targets, false otherwise
 */ function $5b9fa18608a480f3$var$_isInGivenRequestTargets(failedRequestTargets, target) {
    return failedRequestTargets.some((givenRequestTarget)=>{
        if (typeof givenRequestTarget === "string") return target.includes(givenRequestTarget);
        return givenRequestTarget.test(target);
    });
}
/**
 * Checks if the given status code is in the given range
 *
 * @param status The status code to check
 * @returns true if the status code is in the given range, false otherwise
 */ function $5b9fa18608a480f3$var$_isInGivenStatusRanges(failedRequestStatusCodes, status) {
    return failedRequestStatusCodes.some((range)=>{
        if (typeof range === "number") return range === status;
        return status >= range[0] && status <= range[1];
    });
}
/**
 * Wraps `fetch` function to capture request and response data
 */ function $5b9fa18608a480f3$var$_wrapFetch(client, options) {
    if (!(0, $20b8c37b7dc32b0d$export$c82d238e23c40b21)()) return;
    (0, $1f5839cb68df003d$export$f75d3c772c923df0)((handlerData)=>{
        if ((0, $0b98faa1b87c8168$export$6bb76d6eba7e258c)() !== client) return;
        const { response: response, args: args, error: error, virtualError: virtualError } = handlerData;
        const [requestInfo, requestInit] = args;
        if (!response) return;
        $5b9fa18608a480f3$var$_fetchResponseHandler(options, requestInfo, response, requestInit, error || virtualError);
    }, false);
}
/**
 * Wraps XMLHttpRequest to capture request and response data
 */ function $5b9fa18608a480f3$var$_wrapXHR(client, options) {
    if (!("XMLHttpRequest" in (0, $88208d9e04627397$export$f1a6cdb1459e81d1))) return;
    (0, $932d70c5552b8c29$export$26ace48dd54c9aea)((handlerData)=>{
        if ((0, $0b98faa1b87c8168$export$6bb76d6eba7e258c)() !== client) return;
        const { error: error, virtualError: virtualError } = handlerData;
        const xhr = handlerData.xhr;
        const sentryXhrData = xhr[0, $932d70c5552b8c29$export$55b6bb1e45c6cf59];
        if (!sentryXhrData) return;
        const { method: method, request_headers: headers } = sentryXhrData;
        try {
            $5b9fa18608a480f3$var$_xhrResponseHandler(options, xhr, method, headers, error || virtualError);
        } catch (e) {
            (0, $fe45e6d5f124fb0c$export$16a28057038b10ef) && (0, $dfad86e498c52aee$export$af88d00dbe7f521).warn("Error while extracting response event form XHR response", e);
        }
    });
}
/**
 * Checks whether to capture given response as an event
 *
 * @param status response status code
 * @param url response url
 */ function $5b9fa18608a480f3$var$_shouldCaptureResponse(options, status, url) {
    return $5b9fa18608a480f3$var$_isInGivenStatusRanges(options.failedRequestStatusCodes, status) && $5b9fa18608a480f3$var$_isInGivenRequestTargets(options.failedRequestTargets, url) && !(0, $67d81651c8938ed0$export$d92e61f5600202af)(url, (0, $0b98faa1b87c8168$export$6bb76d6eba7e258c)());
}
/**
 * Creates a synthetic Sentry event from given response data
 *
 * @param data response data
 * @returns event
 */ function $5b9fa18608a480f3$var$_createEvent(data) {
    const client = (0, $0b98faa1b87c8168$export$6bb76d6eba7e258c)();
    const virtualStackTrace = client && data.error && data.error instanceof Error ? data.error.stack : undefined;
    // Remove the first frame from the stack as it's the HttpClient call
    const stack = virtualStackTrace && client ? client.getOptions().stackParser(virtualStackTrace, 0, 1) : undefined;
    const message = `HTTP Client Error with status code: ${data.status}`;
    const event = {
        message: message,
        exception: {
            values: [
                {
                    type: "Error",
                    value: message,
                    stacktrace: stack ? {
                        frames: stack
                    } : undefined
                }
            ]
        },
        request: {
            url: data.url,
            method: data.method,
            headers: data.requestHeaders,
            cookies: data.requestCookies
        },
        contexts: {
            response: {
                status_code: data.status,
                headers: data.responseHeaders,
                cookies: data.responseCookies,
                body_size: $5b9fa18608a480f3$var$_getResponseSizeFromHeaders(data.responseHeaders)
            }
        }
    };
    (0, $c65fa882a3254127$export$c69a9a0313b03bb1)(event, {
        type: "http.client",
        handled: false
    });
    return event;
}
function $5b9fa18608a480f3$var$_getRequest(requestInfo, requestInit) {
    if (!requestInit && requestInfo instanceof Request) return requestInfo;
    // If both are set, we try to construct a new Request with the given arguments
    // However, if e.g. the original request has a `body`, this will throw an error because it was already accessed
    // In this case, as a fallback, we just use the original request - using both is rather an edge case
    if (requestInfo instanceof Request && requestInfo.bodyUsed) return requestInfo;
    return new Request(requestInfo, requestInit);
}
function $5b9fa18608a480f3$var$_shouldSendDefaultPii() {
    const client = (0, $0b98faa1b87c8168$export$6bb76d6eba7e258c)();
    return client ? Boolean(client.getOptions().sendDefaultPii) : false;
}



const $afde9de8f0629aeb$var$WINDOW = (0, $88208d9e04627397$export$f1a6cdb1459e81d1);
const $afde9de8f0629aeb$var$DEFAULT_LINES_OF_CONTEXT = 7;
const $afde9de8f0629aeb$var$INTEGRATION_NAME = "ContextLines";
const $afde9de8f0629aeb$var$_contextLinesIntegration = (options = {})=>{
    const contextLines = options.frameContextLines != null ? options.frameContextLines : $afde9de8f0629aeb$var$DEFAULT_LINES_OF_CONTEXT;
    return {
        name: $afde9de8f0629aeb$var$INTEGRATION_NAME,
        processEvent (event) {
            return $afde9de8f0629aeb$var$addSourceContext(event, contextLines);
        }
    };
};
/**
 * Collects source context lines around the lines of stackframes pointing to JS embedded in
 * the current page's HTML.
 *
 * This integration DOES NOT work for stack frames pointing to JS files that are loaded by the browser.
 * For frames pointing to files, context lines are added during ingestion and symbolication
 * by attempting to download the JS files to the Sentry backend.
 *
 * Use this integration if you have inline JS code in HTML pages that can't be accessed
 * by our backend (e.g. due to a login-protected page).
 */ const $afde9de8f0629aeb$export$74173d114ed4f354 = (0, $5cfb41e3e92106c4$export$2323046b9414659f)($afde9de8f0629aeb$var$_contextLinesIntegration);
/**
 * Processes an event and adds context lines.
 */ function $afde9de8f0629aeb$var$addSourceContext(event, contextLines) {
    const doc = $afde9de8f0629aeb$var$WINDOW.document;
    const htmlFilename = $afde9de8f0629aeb$var$WINDOW.location && (0, $34321b3a3ce9dbbd$export$ce084c78234bd35)($afde9de8f0629aeb$var$WINDOW.location.href);
    if (!doc || !htmlFilename) return event;
    const exceptions = event.exception?.values;
    if (!exceptions?.length) return event;
    const html = doc.documentElement.innerHTML;
    if (!html) return event;
    const htmlLines = [
        "<!DOCTYPE html>",
        "<html>",
        ...html.split("\n"),
        "</html>"
    ];
    exceptions.forEach((exception)=>{
        const stacktrace = exception.stacktrace;
        if (stacktrace?.frames) stacktrace.frames = stacktrace.frames.map((frame)=>$afde9de8f0629aeb$export$cf59ef3dc46bd2e1(frame, htmlLines, htmlFilename, contextLines));
    });
    return event;
}
/**
 * Only exported for testing
 */ function $afde9de8f0629aeb$export$cf59ef3dc46bd2e1(frame, htmlLines, htmlFilename, linesOfContext) {
    if (frame.filename !== htmlFilename || !frame.lineno || !htmlLines.length) return frame;
    (0, $c65fa882a3254127$export$ec2291bfc64632f0)(htmlLines, frame, linesOfContext);
    return frame;
}





/**
 * Serializes FormData.
 *
 * This is a bit simplified, but gives us a decent estimate.
 * This converts e.g. { name: 'Anne Smith', age: 13 } to 'name=Anne+Smith&age=13'.
 *
 */ function $3f1b9c08521fa255$export$2f1b0f57f243f270(formData) {
    // @ts-expect-error passing FormData to URLSearchParams actually works
    return new URLSearchParams(formData).toString();
}
/** Get the string representation of a body. */ function $3f1b9c08521fa255$export$945a2d5364608d5(body, _logger = (0, $70cc7a497c940a25$export$af88d00dbe7f521)) {
    try {
        if (typeof body === "string") return [
            body
        ];
        if (body instanceof URLSearchParams) return [
            body.toString()
        ];
        if (body instanceof FormData) return [
            $3f1b9c08521fa255$export$2f1b0f57f243f270(body)
        ];
        if (!body) return [
            undefined
        ];
    } catch (error) {
        (0, $40b62dc164a5f4e4$export$16a28057038b10ef) && _logger.error(error, "Failed to serialize body", body);
        return [
            undefined,
            "BODY_PARSE_ERROR"
        ];
    }
    (0, $40b62dc164a5f4e4$export$16a28057038b10ef) && _logger.info("Skipping network body because of body type", body);
    return [
        undefined,
        "UNPARSEABLE_BODY_TYPE"
    ];
}
/**
 * Parses the fetch arguments to extract the request payload.
 *
 * We only support getting the body from the fetch options.
 */ function $3f1b9c08521fa255$export$ad44edf8012ec314(fetchArgs = []) {
    if (fetchArgs.length !== 2 || typeof fetchArgs[1] !== "object") return undefined;
    return fetchArgs[1].body;
}


const $e25e4109b458438c$var$INTEGRATION_NAME = "GraphQLClient";
const $e25e4109b458438c$var$_graphqlClientIntegration = (options)=>{
    return {
        name: $e25e4109b458438c$var$INTEGRATION_NAME,
        setup (client) {
            $e25e4109b458438c$var$_updateSpanWithGraphQLData(client, options);
            $e25e4109b458438c$var$_updateBreadcrumbWithGraphQLData(client, options);
        }
    };
};
function $e25e4109b458438c$var$_updateSpanWithGraphQLData(client, options) {
    client.on("beforeOutgoingRequestSpan", (span, hint)=>{
        const spanJSON = (0, $e89a3331adf677ac$export$92d8c23565496537)(span);
        const spanAttributes = spanJSON.data || {};
        const spanOp = spanAttributes[0, $34e3132ced11beec$export$1a413bd9a88fdb09];
        const isHttpClientSpan = spanOp === "http.client";
        if (!isHttpClientSpan) return;
        const httpUrl = spanAttributes[0, $34e3132ced11beec$export$25dfd73e0e32c6e1] || spanAttributes["http.url"];
        const httpMethod = spanAttributes[0, $34e3132ced11beec$export$be7a251980e7e946] || spanAttributes["http.method"];
        if (!(0, $ed5cb73b8752546d$export$844ec244b1367d54)(httpUrl) || !(0, $ed5cb73b8752546d$export$844ec244b1367d54)(httpMethod)) return;
        const { endpoints: endpoints } = options;
        const isTracedGraphqlEndpoint = (0, $79b6b3761a352021$export$a7a5ec66062ea5d)(httpUrl, endpoints);
        const payload = $e25e4109b458438c$export$ab01d0edbd10f3e8(hint);
        if (isTracedGraphqlEndpoint && payload) {
            const graphqlBody = $e25e4109b458438c$export$8a91006ab73e3ea(payload);
            if (graphqlBody) {
                const operationInfo = $e25e4109b458438c$var$_getGraphQLOperation(graphqlBody);
                span.updateName(`${httpMethod} ${httpUrl} (${operationInfo})`);
                span.setAttribute("graphql.document", payload);
            }
        }
    });
}
function $e25e4109b458438c$var$_updateBreadcrumbWithGraphQLData(client, options) {
    client.on("beforeOutgoingRequestBreadcrumb", (breadcrumb, handlerData)=>{
        const { category: category, type: type, data: data } = breadcrumb;
        const isFetch = category === "fetch";
        const isXhr = category === "xhr";
        const isHttpBreadcrumb = type === "http";
        if (isHttpBreadcrumb && (isFetch || isXhr)) {
            const httpUrl = data?.url;
            const { endpoints: endpoints } = options;
            const isTracedGraphqlEndpoint = (0, $79b6b3761a352021$export$a7a5ec66062ea5d)(httpUrl, endpoints);
            const payload = $e25e4109b458438c$export$ab01d0edbd10f3e8(handlerData);
            if (isTracedGraphqlEndpoint && data && payload) {
                const graphqlBody = $e25e4109b458438c$export$8a91006ab73e3ea(payload);
                if (!data.graphql && graphqlBody) {
                    const operationInfo = $e25e4109b458438c$var$_getGraphQLOperation(graphqlBody);
                    data["graphql.document"] = graphqlBody.query;
                    data["graphql.operation"] = operationInfo;
                }
            }
        }
    });
}
/**
 * @param requestBody - GraphQL request
 * @returns A formatted version of the request: 'TYPE NAME' or 'TYPE'
 */ function $e25e4109b458438c$var$_getGraphQLOperation(requestBody) {
    const { query: graphqlQuery, operationName: graphqlOperationName } = requestBody;
    const { operationName: operationName = graphqlOperationName, operationType: operationType } = $e25e4109b458438c$export$cf7a144a1fa44ed4(graphqlQuery);
    const operationInfo = operationName ? `${operationType} ${operationName}` : `${operationType}`;
    return operationInfo;
}
/**
 * Get the request body/payload based on the shape of the hint.
 *
 * Exported for tests only.
 */ function $e25e4109b458438c$export$ab01d0edbd10f3e8(hint) {
    const isXhr = "xhr" in hint;
    let body;
    if (isXhr) {
        const sentryXhrData = hint.xhr[0, $932d70c5552b8c29$export$55b6bb1e45c6cf59];
        body = sentryXhrData && (0, $3f1b9c08521fa255$export$945a2d5364608d5)(sentryXhrData.body)[0];
    } else {
        const sentryFetchData = (0, $3f1b9c08521fa255$export$ad44edf8012ec314)(hint.input);
        body = (0, $3f1b9c08521fa255$export$945a2d5364608d5)(sentryFetchData)[0];
    }
    return body;
}
/**
 * Extract the name and type of the operation from the GraphQL query.
 *
 * Exported for tests only.
 */ function $e25e4109b458438c$export$cf7a144a1fa44ed4(query) {
    const namedQueryRe = /^(?:\s*)(query|mutation|subscription)(?:\s*)(\w+)(?:\s*)[{(]/;
    const unnamedQueryRe = /^(?:\s*)(query|mutation|subscription)(?:\s*)[{(]/;
    const namedMatch = query.match(namedQueryRe);
    if (namedMatch) return {
        operationType: namedMatch[1],
        operationName: namedMatch[2]
    };
    const unnamedMatch = query.match(unnamedQueryRe);
    if (unnamedMatch) return {
        operationType: unnamedMatch[1],
        operationName: undefined
    };
    return {
        operationType: undefined,
        operationName: undefined
    };
}
/**
 * Extract the payload of a request if it's GraphQL.
 * Exported for tests only.
 * @param payload - A valid JSON string
 * @returns A POJO or undefined
 */ function $e25e4109b458438c$export$8a91006ab73e3ea(payload) {
    let graphqlBody = undefined;
    try {
        const requestBody = JSON.parse(payload);
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        const isGraphQLRequest = !!requestBody["query"];
        if (isGraphQLRequest) graphqlBody = requestBody;
    } finally{
        // Fallback to undefined if payload is an invalid JSON (SyntaxError)
        /* eslint-disable no-unsafe-finally */ return graphqlBody;
    }
}
/**
 * This integration ensures that GraphQL requests made in the browser
 * have their GraphQL-specific data captured and attached to spans and breadcrumbs.
 */ const $e25e4109b458438c$export$a934e57cd817247a = (0, $5cfb41e3e92106c4$export$2323046b9414659f)($e25e4109b458438c$var$_graphqlClientIntegration);


// This is a magic string replaced by rollup
const $006c42a7bac22f4c$export$31499a9cd224b78c = "9.33.0";


/** Internal global with common properties and Sentry extensions  */ /** Get's the global object for the current JavaScript runtime */ const $bf3d8fd3d1ce8fc4$export$f1a6cdb1459e81d1 = globalThis;


/**
 * An object that contains globally accessible properties and maintains a scope stack.
 * @hidden
 */ /**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $92999225fa2a9a7f$export$19eade501500c6c1() {
    // This ensures a Sentry carrier exists
    $92999225fa2a9a7f$export$c8bfa33e4e8ae492((0, $bf3d8fd3d1ce8fc4$export$f1a6cdb1459e81d1));
    return 0, $bf3d8fd3d1ce8fc4$export$f1a6cdb1459e81d1;
}
/** Will either get the existing sentry carrier, or create a new one. */ function $92999225fa2a9a7f$export$c8bfa33e4e8ae492(carrier) {
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    // For now: First SDK that sets the .version property wins
    __SENTRY__.version = __SENTRY__.version || (0, $006c42a7bac22f4c$export$31499a9cd224b78c);
    // Intentionally populating and returning the version of "this" SDK instance
    // rather than what's set in .version so that "this" SDK always gets its carrier
    return __SENTRY__[0, $006c42a7bac22f4c$export$31499a9cd224b78c] = __SENTRY__[0, $006c42a7bac22f4c$export$31499a9cd224b78c] || {};
}
/**
 * Returns a global singleton contained in the global `__SENTRY__[]` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $92999225fa2a9a7f$export$7e223ec222791509(name, creator, obj = (0, $bf3d8fd3d1ce8fc4$export$f1a6cdb1459e81d1)) {
    const __SENTRY__ = obj.__SENTRY__ = obj.__SENTRY__ || {};
    const carrier = __SENTRY__[0, $006c42a7bac22f4c$export$31499a9cd224b78c] = __SENTRY__[0, $006c42a7bac22f4c$export$31499a9cd224b78c] || {};
    // Note: We do not want to set `carrier.version` here, as this may be called before any `init` is called, e.g. for the default scopes
    return carrier[name] || (carrier[name] = creator());
}



/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $a19fca88fc2be424$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;


// eslint-disable-next-line @typescript-eslint/unbound-method
const $5caf4cf2c479782f$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $5caf4cf2c479782f$export$e6127cc7fe7395c3(wat) {
    switch($5caf4cf2c479782f$var$objectToString.call(wat)){
        case "[object Error]":
        case "[object Exception]":
        case "[object DOMException]":
        case "[object WebAssembly.Exception]":
            return true;
        default:
            return $5caf4cf2c479782f$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $5caf4cf2c479782f$var$isBuiltin(wat, className) {
    return $5caf4cf2c479782f$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $5caf4cf2c479782f$export$9f9636d330b71954(wat) {
    return $5caf4cf2c479782f$var$isBuiltin(wat, "ErrorEvent");
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $5caf4cf2c479782f$export$ef9e2056653f0c8e(wat) {
    return $5caf4cf2c479782f$var$isBuiltin(wat, "DOMError");
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $5caf4cf2c479782f$export$12e869b2a583f783(wat) {
    return $5caf4cf2c479782f$var$isBuiltin(wat, "DOMException");
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $5caf4cf2c479782f$export$844ec244b1367d54(wat) {
    return $5caf4cf2c479782f$var$isBuiltin(wat, "String");
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $5caf4cf2c479782f$export$dbcbffa59149b824(wat) {
    return typeof wat === "object" && wat !== null && "__sentry_template_string__" in wat && "__sentry_template_values__" in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $5caf4cf2c479782f$export$c3825b437cbdea5c(wat) {
    return wat === null || $5caf4cf2c479782f$export$dbcbffa59149b824(wat) || typeof wat !== "object" && typeof wat !== "function";
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $5caf4cf2c479782f$export$53b83ca8eaab0383(wat) {
    return $5caf4cf2c479782f$var$isBuiltin(wat, "Object");
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $5caf4cf2c479782f$export$9671ea99bd126ace(wat) {
    return typeof Event !== "undefined" && $5caf4cf2c479782f$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $5caf4cf2c479782f$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== "undefined" && $5caf4cf2c479782f$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $5caf4cf2c479782f$export$49841c62b9eff15(wat) {
    return $5caf4cf2c479782f$var$isBuiltin(wat, "RegExp");
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $5caf4cf2c479782f$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat?.then && typeof wat.then === "function");
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $5caf4cf2c479782f$export$bc2894c7158efbac(wat) {
    return $5caf4cf2c479782f$export$53b83ca8eaab0383(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $5caf4cf2c479782f$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $5caf4cf2c479782f$export$7916fad0ebc23f48(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    return !!(typeof wat === "object" && wat !== null && (wat.__isVue || wat._isVue));
}
/**
 * Checks whether the given parameter is a Standard Web API Request instance.
 *
 * Returns false if Request is not available in the current runtime.
 */ function $5caf4cf2c479782f$export$6d3d1f317d7cda57(request) {
    return typeof Request !== "undefined" && $5caf4cf2c479782f$export$49034edbe6b62415(request, Request);
}



const $0a4b219981573bc1$var$WINDOW = (0, $bf3d8fd3d1ce8fc4$export$f1a6cdb1459e81d1);
const $0a4b219981573bc1$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $0a4b219981573bc1$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return "<unknown>";
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = " > ";
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $0a4b219981573bc1$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $0a4b219981573bc1$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return "<unknown>";
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $0a4b219981573bc1$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    if (!elem?.tagName) return "";
    // @ts-expect-error WINDOW has HTMLElement
    if ($0a4b219981573bc1$var$WINDOW.HTMLElement) // If using the component name annotation plugin, this value may be available on the DOM node
    {
        if (elem instanceof HTMLElement && elem.dataset) {
            if (elem.dataset["sentryComponent"]) return elem.dataset["sentryComponent"];
            if (elem.dataset["sentryElement"]) return elem.dataset["sentryElement"];
        }
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs?.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs?.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        const className = elem.className;
        if (className && (0, $5caf4cf2c479782f$export$844ec244b1367d54)(className)) {
            const classes = className.split(/\s+/);
            for (const c of classes)out.push(`.${c}`);
        }
    }
    const allowedAttrs = [
        "aria-label",
        "type",
        "name",
        "title",
        "alt"
    ];
    for (const k of allowedAttrs){
        const attr = elem.getAttribute(k);
        if (attr) out.push(`[${k}="${attr}"]`);
    }
    return out.join("");
}
/**
 * A safe form of location.href
 */ function $0a4b219981573bc1$export$1cfafeee2987818b() {
    try {
        return $0a4b219981573bc1$var$WINDOW.document.location.href;
    } catch (oO) {
        return "";
    }
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` or `data-sentry-element` attribute with `data-sentry-component` taking
 * precedence. This attribute is added at build-time by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function $0a4b219981573bc1$export$26727cfcc4d7e0fc(elem) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!$0a4b219981573bc1$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    const MAX_TRAVERSE_HEIGHT = 5;
    for(let i = 0; i < MAX_TRAVERSE_HEIGHT; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement) {
            if (currentElem.dataset["sentryComponent"]) return currentElem.dataset["sentryComponent"];
            if (currentElem.dataset["sentryElement"]) return currentElem.dataset["sentryElement"];
        }
        currentElem = currentElem.parentNode;
    }
    return null;
}






/** Prefix for logging strings */ const $f1cb9ab3cf87365c$var$PREFIX = "Sentry Logger ";
const $f1cb9ab3cf87365c$export$2a2b1d2252a69ecb = [
    "debug",
    "info",
    "warn",
    "error",
    "log",
    "assert",
    "trace"
];
/** This may be mutated by the console instrumentation. */ const $f1cb9ab3cf87365c$export$77c4ce905194557b = {};
/** A Sentry Logger instance. */ /**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $f1cb9ab3cf87365c$export$cda52e2a8927a2ca(callback) {
    if (!("console" in (0, $bf3d8fd3d1ce8fc4$export$f1a6cdb1459e81d1))) return callback();
    const console = (0, $bf3d8fd3d1ce8fc4$export$f1a6cdb1459e81d1).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($f1cb9ab3cf87365c$export$77c4ce905194557b);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $f1cb9ab3cf87365c$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $f1cb9ab3cf87365c$var$makeLogger() {
    let enabled = false;
    const logger = {
        enable: ()=>{
            enabled = true;
        },
        disable: ()=>{
            enabled = false;
        },
        isEnabled: ()=>enabled
    };
    if (0, $a19fca88fc2be424$export$16a28057038b10ef) $f1cb9ab3cf87365c$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = (...args)=>{
            if (enabled) $f1cb9ab3cf87365c$export$cda52e2a8927a2ca(()=>{
                (0, $bf3d8fd3d1ce8fc4$export$f1a6cdb1459e81d1).console[name](`${$f1cb9ab3cf87365c$var$PREFIX}[${name}]:`, ...args);
            });
        };
    });
    else $f1cb9ab3cf87365c$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = ()=>undefined;
    });
    return logger;
}
/**
 * This is a logger singleton which either logs things or no-ops if logging is not enabled.
 * The logger is a singleton on the carrier, to ensure that a consistent logger is used throughout the SDK.
 */ const $f1cb9ab3cf87365c$export$af88d00dbe7f521 = (0, $92999225fa2a9a7f$export$7e223ec222791509)("logger", $f1cb9ab3cf87365c$var$makeLogger);



/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $e9fb89f9f6b2a439$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== "string" || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $e9fb89f9f6b2a439$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += " {snip}";
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ function $e9fb89f9f6b2a439$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return "";
    const output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, $5caf4cf2c479782f$export$7916fad0ebc23f48)(value)) output.push("[VueViewModel]");
            else output.push(String(value));
        } catch (e) {
            output.push("[value cannot be serialized]");
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $e9fb89f9f6b2a439$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $5caf4cf2c479782f$export$844ec244b1367d54)(value)) return false;
    if ((0, $5caf4cf2c479782f$export$49841c62b9eff15)(pattern)) return pattern.test(value);
    if ((0, $5caf4cf2c479782f$export$844ec244b1367d54)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $e9fb89f9f6b2a439$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$e9fb89f9f6b2a439$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}


/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Replace a method in an object with a wrapped version of itself.
 *
 * If the method on the passed object is not a function, the wrapper will not be applied.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $088bc5d23a73ee42$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    // explicitly casting to unknown because we don't know the type of the method initially at all
    const original = source[name];
    if (typeof original !== "function") return;
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === "function") $088bc5d23a73ee42$export$5c1499e2e5d010ae(wrapped, original);
    try {
        source[name] = wrapped;
    } catch  {
        (0, $a19fca88fc2be424$export$16a28057038b10ef) && (0, $f1cb9ab3cf87365c$export$af88d00dbe7f521).log(`Failed to replace method "${name}" in object`, source);
    }
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $088bc5d23a73ee42$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch (o_O) {
        (0, $a19fca88fc2be424$export$16a28057038b10ef) && (0, $f1cb9ab3cf87365c$export$af88d00dbe7f521).log(`Failed to add non-enumerable property "${name}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $088bc5d23a73ee42$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $088bc5d23a73ee42$export$e73679ffaf56810e(wrapped, "__sentry_original__", original);
    } catch (o_O) {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $088bc5d23a73ee42$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argument itself, when value is neither an Event nor
 *  an Error.
 */ function $088bc5d23a73ee42$export$62ff257738bf57f5(value) {
    if ((0, $5caf4cf2c479782f$export$e6127cc7fe7395c3)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$088bc5d23a73ee42$var$getOwnProperties(value)
    };
    else if ((0, $5caf4cf2c479782f$export$9671ea99bd126ace)(value)) {
        const newObj = {
            type: value.type,
            target: $088bc5d23a73ee42$var$serializeEventTarget(value.target),
            currentTarget: $088bc5d23a73ee42$var$serializeEventTarget(value.currentTarget),
            ...$088bc5d23a73ee42$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== "undefined" && (0, $5caf4cf2c479782f$export$49034edbe6b62415)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $088bc5d23a73ee42$var$serializeEventTarget(target) {
    try {
        return (0, $5caf4cf2c479782f$export$45a5e7f76e0caa8d)(target) ? (0, $0a4b219981573bc1$export$5647df6b7814ac86)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return "<unknown>";
    }
}
/** Filters out all but an object's own properties */ function $088bc5d23a73ee42$var$getOwnProperties(obj) {
    if (typeof obj === "object" && obj !== null) {
        const extractedProps = {};
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $088bc5d23a73ee42$export$b0244d5063c0b61b(exception, maxLength = 40) {
    const keys = Object.keys($088bc5d23a73ee42$export$62ff257738bf57f5(exception));
    keys.sort();
    const firstKey = keys[0];
    if (!firstKey) return "[object has no keys]";
    if (firstKey.length >= maxLength) return (0, $e9fb89f9f6b2a439$export$6a506b36fdea397d)(firstKey, maxLength);
    for(let includedKeys = keys.length; includedKeys > 0; includedKeys--){
        const serialized = keys.slice(0, includedKeys).join(", ");
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $e9fb89f9f6b2a439$export$6a506b36fdea397d)(serialized, maxLength);
    }
    return "";
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 *
 * @deprecated This function is no longer used by the SDK and will be removed in a future major version.
 */ function $088bc5d23a73ee42$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $088bc5d23a73ee42$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $088bc5d23a73ee42$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    // Early return for primitive values
    if (inputValue === null || typeof inputValue !== "object") return inputValue;
    // Check memo map first for all object types
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== undefined) return memoVal;
    // handle arrays
    if (Array.isArray(inputValue)) {
        const returnValue = [];
        // Store mapping to handle circular references
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((value)=>{
            returnValue.push($088bc5d23a73ee42$var$_dropUndefinedKeys(value, memoizationMap));
        });
        return returnValue;
    }
    if ($088bc5d23a73ee42$var$isPojo(inputValue)) {
        const returnValue = {};
        // Store mapping to handle circular references
        memoizationMap.set(inputValue, returnValue);
        const keys = Object.keys(inputValue);
        keys.forEach((key)=>{
            const val = inputValue[key];
            if (val !== undefined) returnValue[key] = $088bc5d23a73ee42$var$_dropUndefinedKeys(val, memoizationMap);
        });
        return returnValue;
    }
    // For other object types, return as is
    return inputValue;
}
function $088bc5d23a73ee42$var$isPojo(input) {
    // Plain objects have Object as constructor or no constructor
    const constructor = input.constructor;
    return constructor === Object || constructor === undefined;
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $088bc5d23a73ee42$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        // this will catch both undefined and null
        case wat == undefined:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === "symbol" || typeof wat === "bigint":
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $5caf4cf2c479782f$export$c3825b437cbdea5c)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}




function $adba9e1e8cd7ee8e$var$getCrypto() {
    const gbl = (0, $bf3d8fd3d1ce8fc4$export$f1a6cdb1459e81d1);
    return gbl.crypto || gbl.msCrypto;
}
/**
 * UUID4 generator
 * @param crypto Object that provides the crypto API.
 * @returns string Generated UUID4.
 */ function $adba9e1e8cd7ee8e$export$19f53698e68b2496(crypto = $adba9e1e8cd7ee8e$var$getCrypto()) {
    let getRandomByte = ()=>Math.random() * 16;
    try {
        if (crypto?.randomUUID) return crypto.randomUUID().replace(/-/g, "");
        if (crypto?.getRandomValues) getRandomByte = ()=>{
            // crypto.getRandomValues might return undefined instead of the typed array
            // in old Chromium versions (e.g. 23.0.1235.0 (151422))
            // However, `typedArray` is still filled in-place.
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues#typedarray
            const typedArray = new Uint8Array(1);
            crypto.getRandomValues(typedArray);
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            return typedArray[0];
        };
    } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function $adba9e1e8cd7ee8e$var$getFirstException(event) {
    return event.exception?.values?.[0];
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $adba9e1e8cd7ee8e$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $adba9e1e8cd7ee8e$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || "<unknown>";
    }
    return eventId || "<unknown>";
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $adba9e1e8cd7ee8e$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || "";
    if (!firstException.type) firstException.type = type || "Error";
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $adba9e1e8cd7ee8e$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $adba9e1e8cd7ee8e$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: "generic",
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && "data" in newMechanism) {
        const mergedData = {
            ...currentMechanism?.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $adba9e1e8cd7ee8e$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ function $adba9e1e8cd7ee8e$var$_parseInt(input) {
    return parseInt(input || "", 10);
}
/**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $adba9e1e8cd7ee8e$export$d364f2020ab30578(input) {
    const match = input.match($adba9e1e8cd7ee8e$var$SEMVER_REGEXP) || [];
    const major = $adba9e1e8cd7ee8e$var$_parseInt(match[1]);
    const minor = $adba9e1e8cd7ee8e$var$_parseInt(match[2]);
    const patch = $adba9e1e8cd7ee8e$var$_parseInt(match[3]);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $adba9e1e8cd7ee8e$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $e9fb89f9f6b2a439$export$4215662d762d6f9d)(line, 0));
    // We guard here to ensure this is not larger than the existing number of lines
    const lineIndex = Math.min(maxLines - 1, sourceLine);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    frame.context_line = (0, $e9fb89f9f6b2a439$export$4215662d762d6f9d)(lines[lineIndex], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $e9fb89f9f6b2a439$export$4215662d762d6f9d)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $adba9e1e8cd7ee8e$export$6de4ffac6a2f1098(exception) {
    if ($adba9e1e8cd7ee8e$var$isAlreadyCaptured(exception)) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $088bc5d23a73ee42$export$e73679ffaf56810e)(exception, "__sentry_captured__", true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
function $adba9e1e8cd7ee8e$var$isAlreadyCaptured(exception) {
    try {
        return exception.__sentry_captured__;
    } catch  {} // eslint-disable-line no-empty
}



const $a49793e7936ef572$var$ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 */ function $a49793e7936ef572$export$7740643b9eeaf0c4() {
    return Date.now() / $a49793e7936ef572$var$ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function $a49793e7936ef572$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $bf3d8fd3d1ce8fc4$export$f1a6cdb1459e81d1);
    if (!performance?.now) return $a49793e7936ef572$export$7740643b9eeaf0c4;
    // Some browser and environments don't have a timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    const approxStartingTimeOrigin = Date.now() - performance.now();
    const timeOrigin = performance.timeOrigin == undefined ? approxStartingTimeOrigin : performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return ()=>{
        return (timeOrigin + performance.now()) / $a49793e7936ef572$var$ONE_SECOND_IN_MS;
    };
}
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ const $a49793e7936ef572$export$ee52dced521e3e18 = $a49793e7936ef572$var$createUnixTimestampInSecondsFunc();
/**
 * Cached result of getBrowserTimeOrigin.
 */ let $a49793e7936ef572$var$cachedTimeOrigin;
/**
 * Gets the time origin and the mode used to determine it.
 */ function $a49793e7936ef572$var$getBrowserTimeOrigin() {
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    const { performance: performance } = (0, $bf3d8fd3d1ce8fc4$export$f1a6cdb1459e81d1);
    if (!performance?.now) return [
        undefined,
        "none"
    ];
    const threshold = 3600000;
    const performanceNow = performance.now();
    const dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    const timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing?.navigationStart;
    const hasNavigationStart = typeof navigationStart === "number";
    // if navigationStart isn't available set delta to threshold so it isn't used
    const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    const navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) return [
            performance.timeOrigin,
            "timeOrigin"
        ];
        else return [
            navigationStart,
            "navigationStart"
        ];
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    return [
        dateNow,
        "dateNow"
    ];
}
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ function $a49793e7936ef572$export$baf075a948ffc0bf() {
    if (!$a49793e7936ef572$var$cachedTimeOrigin) $a49793e7936ef572$var$cachedTimeOrigin = $a49793e7936ef572$var$getBrowserTimeOrigin();
    return $a49793e7936ef572$var$cachedTimeOrigin[0];
}


/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $cd8c952cb2d34a33$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $a49793e7936ef572$export$ee52dced521e3e18)();
    const session = {
        sid: (0, $adba9e1e8cd7ee8e$export$19f53698e68b2496)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: "ok",
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$cd8c952cb2d34a33$var$sessionToJSON(session)
    };
    if (context) $cd8c952cb2d34a33$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see Client.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $cd8c952cb2d34a33$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $a49793e7936ef572$export$ee52dced521e3e18)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $adba9e1e8cd7ee8e$export$19f53698e68b2496)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === "number") session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === "number") session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === "number") session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $cd8c952cb2d34a33$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === "ok") context = {
        status: "exited"
    };
    $cd8c952cb2d34a33$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $cd8c952cb2d34a33$var$sessionToJSON(session) {
    return {
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === "number" || typeof session.did === "string" ? `${session.did}` : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    };
}




/**
 * Shallow merge two objects.
 * Does not mutate the passed in objects.
 * Undefined/empty values in the merge object will overwrite existing values.
 *
 * By default, this merges 2 levels deep.
 */ function $efd5e6f793cedc55$export$4950aa0f605343fb(initialObj, mergeObj, levels = 2) {
    // If the merge value is not an object, or we have no merge levels left,
    // we just set the value to the merge value
    if (!mergeObj || typeof mergeObj !== "object" || levels <= 0) return mergeObj;
    // If the merge object is an empty object, and the initial object is not undefined, we return the initial object
    if (initialObj && Object.keys(mergeObj).length === 0) return initialObj;
    // Clone object
    const output = {
        ...initialObj
    };
    // Merge values into output, resursively
    for(const key in mergeObj)if (Object.prototype.hasOwnProperty.call(mergeObj, key)) output[key] = $efd5e6f793cedc55$export$4950aa0f605343fb(output[key], mergeObj[key], levels - 1);
    return output;
}




/**
 * Generate a random, valid trace ID.
 */ function $5a01a011ec80712b$export$dc6d7ea554bcce10() {
    return (0, $adba9e1e8cd7ee8e$export$19f53698e68b2496)();
}
/**
 * Generate a random, valid span ID.
 */ function $5a01a011ec80712b$export$295213bc4d0c54ad() {
    return (0, $adba9e1e8cd7ee8e$export$19f53698e68b2496)().substring(16);
}



const $a50179f3b396b1d8$var$SCOPE_SPAN_FIELD = "_sentrySpan";
/**
 * Set the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $a50179f3b396b1d8$export$3f25fa50c18e20ca(scope, span) {
    if (span) (0, $088bc5d23a73ee42$export$e73679ffaf56810e)(scope, $a50179f3b396b1d8$var$SCOPE_SPAN_FIELD, span);
    else // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
    delete scope[$a50179f3b396b1d8$var$SCOPE_SPAN_FIELD];
}
/**
 * Get the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $a50179f3b396b1d8$export$91f063ebb8eff307(scope) {
    return scope[$a50179f3b396b1d8$var$SCOPE_SPAN_FIELD];
}




/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $bac4dfa4b40ca381$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * A context to be used for capturing an event.
 * This can either be a Scope, or a partial ScopeContext,
 * or a callback that receives the current scope and returns a new scope to use.
 */ /**
 * Holds additional event information.
 */ class $bac4dfa4b40ca381$export$775b6bb06e53a214 {
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called during event processing. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Extra */ /** Contexts */ /** Attachments */ /** Propagation Context for distributed tracing */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */ /** Session */ /** The client on this scope */ /** Contains the last event id of a captured event.  */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = {
            traceId: (0, $5a01a011ec80712b$export$dc6d7ea554bcce10)(),
            sampleRand: Math.random()
        };
    }
    /**
   * Clone all data from this scope into a new scope.
   */ clone() {
        const newScope = new $bac4dfa4b40ca381$export$775b6bb06e53a214();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        if (this._contexts.flags) // We need to copy the `values` array so insertions on a cloned scope
        // won't affect the original array.
        newScope._contexts.flags = {
            values: [
                ...this._contexts.flags.values
            ]
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        newScope._lastEventId = this._lastEventId;
        (0, $a50179f3b396b1d8$export$3f25fa50c18e20ca)(newScope, (0, $a50179f3b396b1d8$export$91f063ebb8eff307)(this));
        return newScope;
    }
    /**
   * Update the client assigned to this scope.
   * Note that not every scope will have a client assigned - isolation scopes & the global scope will generally not have a client,
   * as well as manually created scopes.
   */ setClient(client) {
        this._client = client;
    }
    /**
   * Set the ID of the last captured error event.
   * This is generally only captured on the isolation scope.
   */ setLastEventId(lastEventId) {
        this._lastEventId = lastEventId;
    }
    /**
   * Get the client assigned to this scope.
   */ getClient() {
        return this._client;
    }
    /**
   * Get the ID of the last captured error event.
   * This is generally only available on the isolation scope.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * Add an event processor that will be called before an event is sent.
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * Set the user for this scope.
   * Set to `null` to unset the user.
   */ setUser(user) {
        // If null is passed we want to unset everything, but still define keys,
        // so that later down in the pipeline any existing values are cleared.
        this._user = user || {
            email: undefined,
            id: undefined,
            ip_address: undefined,
            username: undefined
        };
        if (this._session) (0, $cd8c952cb2d34a33$export$531818e825e774db)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the user from this scope.
   */ getUser() {
        return this._user;
    }
    /**
   * Set an object that will be merged into existing tags on the scope,
   * and will be sent as tags data with the event.
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single tag that will be sent as tags data with the event.
   */ setTag(key, value) {
        this._tags = {
            ...this._tags,
            [key]: value
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set an object that will be merged into existing extra on the scope,
   * and will be sent as extra data with the event.
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single key:value extra entry that will be sent as extra data with the event.
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the fingerprint on the scope to send with the events.
   * @param {string[]} fingerprint Fingerprint to group events in Sentry.
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the level on the scope for future events.
   */ setLevel(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope so that the name of e.g. taken server route or
   * the page location is attached to future events.
   *
   * IMPORTANT: Calling this function does NOT change the name of the currently active
   * root span. If you want to change the name of the active root span, use
   * `Sentry.updateSpanName(rootSpan, 'new name')` instead.
   *
   * By default, the SDK updates the scope's transaction name automatically on sensible
   * occasions, such as a page navigation or when handling a new request on the server.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets context data with the given name.
   * Data passed as context will be normalized. You can also pass `null` to unset the context.
   * Note that context data will not be merged - calling `setContext` will overwrite an existing context with the same key.
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set the session for the scope.
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the session from the scope.
   */ getSession() {
        return this._session;
    }
    /**
   * Updates the scope with provided data. Can work in three variations:
   * - plain object containing updatable attributes
   * - Scope instance that'll extract the attributes from
   * - callback function that'll receive the current scope as an argument and allow for modifications
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === "function" ? captureContext(this) : captureContext;
        const scopeInstance = scopeToMerge instanceof $bac4dfa4b40ca381$export$775b6bb06e53a214 ? scopeToMerge.getScopeData() : (0, $5caf4cf2c479782f$export$53b83ca8eaab0383)(scopeToMerge) ? captureContext : undefined;
        const { tags: tags, extra: extra, user: user, contexts: contexts, level: level, fingerprint: fingerprint = [], propagationContext: propagationContext } = scopeInstance || {};
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._extra = {
            ...this._extra,
            ...extra
        };
        this._contexts = {
            ...this._contexts,
            ...contexts
        };
        if (user && Object.keys(user).length) this._user = user;
        if (level) this._level = level;
        if (fingerprint.length) this._fingerprint = fingerprint;
        if (propagationContext) this._propagationContext = propagationContext;
        return this;
    }
    /**
   * Clears the current scope and resets its properties.
   * Note: The client will not be cleared.
   */ clear() {
        // client is not cleared here on purpose!
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._session = undefined;
        (0, $a50179f3b396b1d8$export$3f25fa50c18e20ca)(this, undefined);
        this._attachments = [];
        this.setPropagationContext({
            traceId: (0, $5a01a011ec80712b$export$dc6d7ea554bcce10)(),
            sampleRand: Math.random()
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Adds a breadcrumb to the scope.
   * By default, the last 100 breadcrumbs are kept.
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === "number" ? maxBreadcrumbs : $bac4dfa4b40ca381$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $a49793e7936ef572$export$7740643b9eeaf0c4)(),
            ...breadcrumb,
            // Breadcrumb messages can theoretically be infinitely large and they're held in memory so we truncate them not to leak (too much) memory
            message: breadcrumb.message ? (0, $e9fb89f9f6b2a439$export$6a506b36fdea397d)(breadcrumb.message, 2048) : breadcrumb.message
        };
        this._breadcrumbs.push(mergedBreadcrumb);
        if (this._breadcrumbs.length > maxCrumbs) {
            this._breadcrumbs = this._breadcrumbs.slice(-maxCrumbs);
            this._client?.recordDroppedEvent("buffer_overflow", "log_item");
        }
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the last breadcrumb of the scope.
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * Clear all breadcrumbs from the scope.
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Add an attachment to the scope.
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * Clear all attachments from the scope.
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /**
   * Get the data of this scope, which should be applied to an event during processing.
   */ getScopeData() {
        return {
            breadcrumbs: this._breadcrumbs,
            attachments: this._attachments,
            contexts: this._contexts,
            tags: this._tags,
            extra: this._extra,
            user: this._user,
            level: this._level,
            fingerprint: this._fingerprint || [],
            eventProcessors: this._eventProcessors,
            propagationContext: this._propagationContext,
            sdkProcessingMetadata: this._sdkProcessingMetadata,
            transactionName: this._transactionName,
            span: (0, $a50179f3b396b1d8$export$91f063ebb8eff307)(this)
        };
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry.
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = (0, $efd5e6f793cedc55$export$4950aa0f605343fb)(this._sdkProcessingMetadata, newData, 2);
        return this;
    }
    /**
   * Add propagation context to the scope, used for distributed tracing
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * Get propagation context from the scope, used for distributed tracing
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @returns {string} The id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = hint?.event_id || (0, $adba9e1e8cd7ee8e$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $f1cb9ab3cf87365c$export$af88d00dbe7f521).warn("No client configured on scope - will not capture exception!");
            return eventId;
        }
        const syntheticException = new Error("Sentry syntheticException");
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @returns {string} The id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = hint?.event_id || (0, $adba9e1e8cd7ee8e$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $f1cb9ab3cf87365c$export$af88d00dbe7f521).warn("No client configured on scope - will not capture message!");
            return eventId;
        }
        const syntheticException = new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a Sentry event for this scope.
   *
   * @returns {string} The id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = hint?.event_id || (0, $adba9e1e8cd7ee8e$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $f1cb9ab3cf87365c$export$af88d00dbe7f521).warn("No client configured on scope - will not capture event!");
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}


/** Get the default current scope. */ function $26dd46cb46da6e8a$export$6f1b9191db9c4d5() {
    return (0, $92999225fa2a9a7f$export$7e223ec222791509)("defaultCurrentScope", ()=>new (0, $bac4dfa4b40ca381$export$775b6bb06e53a214)());
}
/** Get the default isolation scope. */ function $26dd46cb46da6e8a$export$de9862929b76bf57() {
    return (0, $92999225fa2a9a7f$export$7e223ec222791509)("defaultIsolationScope", ()=>new (0, $bac4dfa4b40ca381$export$775b6bb06e53a214)());
}





/**
 * This is an object that holds a stack of scopes.
 */ class $6345c72af7d2cc0e$export$d36ec451f120cfba {
    constructor(scope, isolationScope){
        let assignedScope;
        if (!scope) assignedScope = new (0, $bac4dfa4b40ca381$export$775b6bb06e53a214)();
        else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) assignedIsolationScope = new (0, $bac4dfa4b40ca381$export$775b6bb06e53a214)();
        else assignedIsolationScope = isolationScope;
        // scope stack for domains or the process
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Fork a scope for the stack.
   */ withScope(callback) {
        const scope = this._pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            this._popScope();
            throw e;
        }
        if ((0, $5caf4cf2c479782f$export$f5b060c2914b97c8)(maybePromiseResult)) // @ts-expect-error - isThenable returns the wrong type
        return maybePromiseResult.then((res)=>{
            this._popScope();
            return res;
        }, (e)=>{
            this._popScope();
            throw e;
        });
        this._popScope();
        return maybePromiseResult;
    }
    /**
   * Get the client of the stack.
   */ getClient() {
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   */ getScope() {
        return this.getStackTop().scope;
    }
    /**
   * Get the isolation scope for the stack.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * Push a scope to the stack.
   */ _pushScope() {
        // We want to clone the content of prev scope
        const scope = this.getScope().clone();
        this._stack.push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * Pop a scope from the stack.
   */ _popScope() {
        if (this._stack.length <= 1) return false;
        return !!this._stack.pop();
    }
}
/**
 * Get the global async context stack.
 * This will be removed during the v8 cycle and is only here to make migration easier.
 */ function $6345c72af7d2cc0e$var$getAsyncContextStack() {
    const registry = (0, $92999225fa2a9a7f$export$19eade501500c6c1)();
    const sentry = (0, $92999225fa2a9a7f$export$c8bfa33e4e8ae492)(registry);
    return sentry.stack = sentry.stack || new $6345c72af7d2cc0e$export$d36ec451f120cfba((0, $26dd46cb46da6e8a$export$6f1b9191db9c4d5)(), (0, $26dd46cb46da6e8a$export$de9862929b76bf57)());
}
function $6345c72af7d2cc0e$var$withScope(callback) {
    return $6345c72af7d2cc0e$var$getAsyncContextStack().withScope(callback);
}
function $6345c72af7d2cc0e$var$withSetScope(scope, callback) {
    const stack = $6345c72af7d2cc0e$var$getAsyncContextStack();
    return stack.withScope(()=>{
        stack.getStackTop().scope = scope;
        return callback(scope);
    });
}
function $6345c72af7d2cc0e$var$withIsolationScope(callback) {
    return $6345c72af7d2cc0e$var$getAsyncContextStack().withScope(()=>{
        return callback($6345c72af7d2cc0e$var$getAsyncContextStack().getIsolationScope());
    });
}
/**
 * Get the stack-based async context strategy.
 */ function $6345c72af7d2cc0e$export$329d4d4d54e42710() {
    return {
        withIsolationScope: $6345c72af7d2cc0e$var$withIsolationScope,
        withScope: $6345c72af7d2cc0e$var$withScope,
        withSetScope: $6345c72af7d2cc0e$var$withSetScope,
        withSetIsolationScope: (_isolationScope, callback)=>{
            return $6345c72af7d2cc0e$var$withIsolationScope(callback);
        },
        getCurrentScope: ()=>$6345c72af7d2cc0e$var$getAsyncContextStack().getScope(),
        getIsolationScope: ()=>$6345c72af7d2cc0e$var$getAsyncContextStack().getIsolationScope()
    };
}


/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $09969a149715ffe3$export$774ae0e6b6e444ca(strategy) {
    // Get main carrier (global for every environment)
    const registry = (0, $92999225fa2a9a7f$export$19eade501500c6c1)();
    const sentry = (0, $92999225fa2a9a7f$export$c8bfa33e4e8ae492)(registry);
    sentry.acs = strategy;
}
/**
 * Get the current async context strategy.
 * If none has been setup, the default will be used.
 */ function $09969a149715ffe3$export$f639b0c2752203be(carrier) {
    const sentry = (0, $92999225fa2a9a7f$export$c8bfa33e4e8ae492)(carrier);
    if (sentry.acs) return sentry.acs;
    // Otherwise, use the default one (stack)
    return (0, $6345c72af7d2cc0e$export$329d4d4d54e42710)();
}





/**
 * Get the currently active scope.
 */ function $b03165fa5825574e$export$c7be4b0125a10cba() {
    const carrier = (0, $92999225fa2a9a7f$export$19eade501500c6c1)();
    const acs = (0, $09969a149715ffe3$export$f639b0c2752203be)(carrier);
    return acs.getCurrentScope();
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current execution context.
 */ function $b03165fa5825574e$export$68f3af03034c9e90() {
    const carrier = (0, $92999225fa2a9a7f$export$19eade501500c6c1)();
    const acs = (0, $09969a149715ffe3$export$f639b0c2752203be)(carrier);
    return acs.getIsolationScope();
}
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function $b03165fa5825574e$export$aa55d5ab8e05984f() {
    return (0, $92999225fa2a9a7f$export$7e223ec222791509)("globalScope", ()=>new (0, $bac4dfa4b40ca381$export$775b6bb06e53a214)());
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function $b03165fa5825574e$export$ec58d9285c204497(...rest) {
    const carrier = (0, $92999225fa2a9a7f$export$19eade501500c6c1)();
    const acs = (0, $09969a149715ffe3$export$f639b0c2752203be)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) return acs.withScope(callback);
        return acs.withSetScope(scope, callback);
    }
    return acs.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 */ /**
 * Either creates a new active isolation scope, or sets the given isolation scope as active scope in the given callback.
 */ function $b03165fa5825574e$export$9a4fed82c350c2bd(...rest) {
    const carrier = (0, $92999225fa2a9a7f$export$19eade501500c6c1)();
    const acs = (0, $09969a149715ffe3$export$f639b0c2752203be)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [isolationScope, callback] = rest;
        if (!isolationScope) return acs.withIsolationScope(callback);
        return acs.withSetIsolationScope(isolationScope, callback);
    }
    return acs.withIsolationScope(rest[0]);
}
/**
 * Get the currently active client.
 */ function $b03165fa5825574e$export$6bb76d6eba7e258c() {
    return $b03165fa5825574e$export$c7be4b0125a10cba().getClient();
}
/**
 * Get a trace context for the given scope.
 */ function $b03165fa5825574e$export$1e83db7ee4876dc4(scope) {
    const propagationContext = scope.getPropagationContext();
    const { traceId: traceId, parentSpanId: parentSpanId, propagationSpanId: propagationSpanId } = propagationContext;
    const traceContext = {
        trace_id: traceId,
        span_id: propagationSpanId || (0, $5a01a011ec80712b$export$295213bc4d0c54ad)()
    };
    if (parentSpanId) traceContext.parent_span_id = parentSpanId;
    return traceContext;
}




/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ const $4391fcdc8a459c29$var$DEFAULT_BREADCRUMBS = 100;
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 */ function $4391fcdc8a459c29$export$efda9a273d7a036d(breadcrumb, hint) {
    const client = (0, $b03165fa5825574e$export$6bb76d6eba7e258c)();
    const isolationScope = (0, $b03165fa5825574e$export$68f3af03034c9e90)();
    if (!client) return;
    const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $4391fcdc8a459c29$var$DEFAULT_BREADCRUMBS } = client.getOptions();
    if (maxBreadcrumbs <= 0) return;
    const timestamp = (0, $a49793e7936ef572$export$7740643b9eeaf0c4)();
    const mergedBreadcrumb = {
        timestamp: timestamp,
        ...breadcrumb
    };
    const finalBreadcrumb = beforeBreadcrumb ? (0, $f1cb9ab3cf87365c$export$cda52e2a8927a2ca)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
    if (finalBreadcrumb === null) return;
    if (client.emit) client.emit("beforeAddBreadcrumb", finalBreadcrumb, hint);
    isolationScope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
}







const $4cef6351145f1d86$export$849dbeeeda01ae98 = "production";







/* eslint-disable @typescript-eslint/no-explicit-any */ /** SyncPromise internal states */ var $e24febe2e5fbb9f7$var$States;
(function(States) {
    /** Pending */ const PENDING = 0;
    States[States["PENDING"] = PENDING] = "PENDING";
    /** Resolved / OK */ const RESOLVED = 1;
    States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
    /** Rejected / Error */ const REJECTED = 2;
    States[States["REJECTED"] = REJECTED] = "REJECTED";
})($e24febe2e5fbb9f7$var$States || ($e24febe2e5fbb9f7$var$States = {}));
// Overloads so we can call resolvedSyncPromise without arguments and generic argument
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $e24febe2e5fbb9f7$export$1fda8aa4d135f8aa(value) {
    return new $e24febe2e5fbb9f7$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $e24febe2e5fbb9f7$export$78e43115b553f358(reason) {
    return new $e24febe2e5fbb9f7$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class $e24febe2e5fbb9f7$export$6f292d4960313241 {
    constructor(executor){
        this._state = $e24febe2e5fbb9f7$var$States.PENDING;
        this._handlers = [];
        this._runExecutor(executor);
    }
    /** @inheritdoc */ then(onfulfilled, onrejected) {
        return new $e24febe2e5fbb9f7$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** @inheritdoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** @inheritdoc */ finally(onfinally) {
        return new $e24febe2e5fbb9f7$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** Excute the resolve/reject handlers. */ _executeHandlers() {
        if (this._state === $e24febe2e5fbb9f7$var$States.PENDING) return;
        const cachedHandlers = this._handlers.slice();
        this._handlers = [];
        cachedHandlers.forEach((handler)=>{
            if (handler[0]) return;
            if (this._state === $e24febe2e5fbb9f7$var$States.RESOLVED) handler[1](this._value);
            if (this._state === $e24febe2e5fbb9f7$var$States.REJECTED) handler[2](this._value);
            handler[0] = true;
        });
    }
    /** Run the executor for the SyncPromise. */ _runExecutor(executor) {
        const setResult = (state, value)=>{
            if (this._state !== $e24febe2e5fbb9f7$var$States.PENDING) return;
            if ((0, $5caf4cf2c479782f$export$f5b060c2914b97c8)(value)) {
                value.then(resolve, reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
        const resolve = (value)=>{
            setResult($e24febe2e5fbb9f7$var$States.RESOLVED, value);
        };
        const reject = (reason)=>{
            setResult($e24febe2e5fbb9f7$var$States.REJECTED, reason);
        };
        try {
            executor(resolve, reject);
        } catch (e) {
            reject(e);
        }
    }
}


/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */ function $dc1c072626d5b007$export$bf2a096c3e883e79(processors, event, hint, index = 0) {
    return new (0, $e24febe2e5fbb9f7$export$6f292d4960313241)((resolve, reject)=>{
        const processor = processors[index];
        if (event === null || typeof processor !== "function") resolve(event);
        else {
            const result = processor({
                ...event
            }, hint);
            (0, $a19fca88fc2be424$export$16a28057038b10ef) && processor.id && result === null && (0, $f1cb9ab3cf87365c$export$af88d00dbe7f521).log(`Event processor "${processor.id}" dropped event`);
            if ((0, $5caf4cf2c479782f$export$f5b060c2914b97c8)(result)) result.then((final)=>$dc1c072626d5b007$export$bf2a096c3e883e79(processors, final, hint, index + 1).then(resolve)).then(null, reject);
            else $dc1c072626d5b007$export$bf2a096c3e883e79(processors, result, hint, index + 1).then(resolve).then(null, reject);
        }
    });
}





/**
 * Use this attribute to represent the source of a span.
 * Should be one of: custom, url, route, view, component, task, unknown
 *
 */ const $800ba4cf60399ed2$export$d7a7d984b0791405 = "sentry.source";
/**
 * Attributes that holds the sample rate that was locally applied to a span.
 * If this attribute is not defined, it means that the span inherited a sampling decision.
 *
 * NOTE: Is only defined on root spans.
 */ const $800ba4cf60399ed2$export$ccfe0a40627cc34b = "sentry.sample_rate";
/**
 * Attribute holding the sample rate of the previous trace.
 * This is used to sample consistently across subsequent traces in the browser SDK.
 *
 * Note: Only defined on root spans, if opted into consistent sampling
 */ const $800ba4cf60399ed2$export$889fb736668e1ecc = "sentry.previous_trace_sample_rate";
/**
 * Use this attribute to represent the operation of a span.
 */ const $800ba4cf60399ed2$export$1a413bd9a88fdb09 = "sentry.op";
/**
 * Use this attribute to represent the origin of a span.
 */ const $800ba4cf60399ed2$export$cca8dd30f57f805e = "sentry.origin";
/** The reason why an idle span finished. */ const $800ba4cf60399ed2$export$ba73f34502b7a3b3 = "sentry.idle_span_finish_reason";
/** The unit of a measurement, which may be stored as a TimedEvent. */ const $800ba4cf60399ed2$export$f5f95cff026507b5 = "sentry.measurement_unit";
/** The value of a measurement, which may be stored as a TimedEvent. */ const $800ba4cf60399ed2$export$69cd5c610c7bb96a = "sentry.measurement_value";
/**
 * A custom span name set by users guaranteed to be taken over any automatically
 * inferred name. This attribute is removed before the span is sent.
 *
 * @internal only meant for internal SDK usage
 * @hidden
 */ const $800ba4cf60399ed2$export$165ce9a229f6f050 = "sentry.custom_span_name";
/**
 * The id of the profile that this span occurred in.
 */ const $800ba4cf60399ed2$export$1efec95406bbe327 = "sentry.profile_id";
const $800ba4cf60399ed2$export$fea48ba9f4550879 = "sentry.exclusive_time";
const $800ba4cf60399ed2$export$b016f89ac1066ec = "cache.hit";
const $800ba4cf60399ed2$export$3110e4c3f4386399 = "cache.key";
const $800ba4cf60399ed2$export$86be76deee227ff2 = "cache.item_size";
/** TODO: Remove these once we update to latest semantic conventions */ const $800ba4cf60399ed2$export$be7a251980e7e946 = "http.request.method";
const $800ba4cf60399ed2$export$25dfd73e0e32c6e1 = "url.full";
/**
 * A span link attribute to mark the link as a special span link.
 *
 * Known values:
 * - `previous_trace`: The span links to the frontend root span of the previous trace.
 * - `next_trace`: The span links to the frontend root span of the next trace. (Not set by the SDK)
 *
 * Other values may be set as appropriate.
 * @see https://develop.sentry.dev/sdk/telemetry/traces/span-links/#link-types
 */ const $800ba4cf60399ed2$export$ff77b5fd5b2d627b = "sentry.link.type";





const $6e5d8187374d2325$export$6e69537d67fa20f = "sentry-";
const $6e5d8187374d2325$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const $6e5d8187374d2325$export$bdd844ddb2def819 = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $6e5d8187374d2325$export$5b96ee2c8421f107(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    const baggageObject = $6e5d8187374d2325$export$397de414d189db00(baggageHeader);
    if (!baggageObject) return undefined;
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.match($6e5d8187374d2325$export$eb0401070c617ea5)) {
            const nonPrefixedKey = key.slice($6e5d8187374d2325$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $6e5d8187374d2325$export$56766feef403f365(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$6e5d8187374d2325$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $6e5d8187374d2325$export$12a7349a29a6e3c2(sentryPrefixedDSC);
}
/**
 * Take a baggage header and parse it into an object.
 */ function $6e5d8187374d2325$export$397de414d189db00(baggageHeader) {
    if (!baggageHeader || !(0, $5caf4cf2c479782f$export$844ec244b1367d54)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    return baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $6e5d8187374d2325$var$baggageHeaderToObject(curr);
        Object.entries(currBaggageObject).forEach(([key, value])=>{
            acc[key] = value;
        });
        return acc;
    }, {});
    return $6e5d8187374d2325$var$baggageHeaderToObject(baggageHeader);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $6e5d8187374d2325$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(",").map((baggageEntry)=>baggageEntry.split("=").map((keyOrValue)=>{
            try {
                return decodeURIComponent(keyOrValue.trim());
            } catch  {
                // We ignore errors here, e.g. if the value cannot be URL decoded.
                // This will then be skipped in the next step
                return;
            }
        })).reduce((acc, [key, value])=>{
        if (key && value) acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $6e5d8187374d2325$export$12a7349a29a6e3c2(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $6e5d8187374d2325$export$bdd844ddb2def819) {
            (0, $a19fca88fc2be424$export$16a28057038b10ef) && (0, $f1cb9ab3cf87365c$export$af88d00dbe7f521).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, "");
}




/** Regular expression used to extract org ID from a DSN host. */ const $1051dd8b7d8de41f$var$ORG_ID_REGEX = /^o(\d+)\./;
/** Regular expression used to parse a Dsn. */ const $1051dd8b7d8de41f$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $1051dd8b7d8de41f$var$isValidProtocol(protocol) {
    return protocol === "http" || protocol === "https";
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function $1051dd8b7d8de41f$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ""}` + `@${host}${port ? `:${port}` : ""}/${path ? `${path}/` : path}${projectId}`;
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function $1051dd8b7d8de41f$export$b892860177f70a30(str) {
    const match = $1051dd8b7d8de41f$var$DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        (0, $f1cb9ab3cf87365c$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return undefined;
    }
    const [protocol, publicKey, pass = "", host = "", port = "", lastPath = ""] = match.slice(1);
    let path = "";
    let projectId = lastPath;
    const split = projectId.split("/");
    if (split.length > 1) {
        path = split.slice(0, -1).join("/");
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $1051dd8b7d8de41f$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $1051dd8b7d8de41f$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || "",
        pass: components.pass || "",
        host: components.host,
        port: components.port || "",
        path: components.path || "",
        projectId: components.projectId
    };
}
function $1051dd8b7d8de41f$var$validateDsn(dsn) {
    if (!(0, $a19fca88fc2be424$export$16a28057038b10ef)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        "protocol",
        "publicKey",
        "host",
        "projectId"
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $f1cb9ab3cf87365c$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $f1cb9ab3cf87365c$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$1051dd8b7d8de41f$var$isValidProtocol(protocol)) {
        (0, $f1cb9ab3cf87365c$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $f1cb9ab3cf87365c$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
/**
 * Extract the org ID from a DSN host.
 *
 * @param host The host from a DSN
 * @returns The org ID if found, undefined otherwise
 */ function $1051dd8b7d8de41f$export$5914f4e7748c29c9(host) {
    const match = host.match($1051dd8b7d8de41f$var$ORG_ID_REGEX);
    return match?.[1];
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function $1051dd8b7d8de41f$export$128827c3562ec0cb(from) {
    const components = typeof from === "string" ? $1051dd8b7d8de41f$export$b892860177f70a30(from) : $1051dd8b7d8de41f$var$dsnFromComponents(from);
    if (!components || !$1051dd8b7d8de41f$var$validateDsn(components)) return undefined;
    return components;
}



// Treeshakable guard to remove all code related to tracing
/**
 * Determines if span recording is currently enabled.
 *
 * Spans are recorded when at least one of `tracesSampleRate` and `tracesSampler`
 * is defined in the SDK config. This function does not make any assumption about
 * sampling decisions, it only checks if the SDK is configured to record spans.
 *
 * Important: This function only determines if span recording is enabled. Trace
 * continuation and propagation is separately controlled and not covered by this function.
 * If this function returns `false`, traces can still be propagated (which is what
 * we refer to by "Tracing without Performance")
 * @see https://develop.sentry.dev/sdk/telemetry/traces/tracing-without-performance/
 *
 * @param maybeOptions An SDK options object to be passed to this function.
 * If this option is not provided, the function will use the current client's options.
 */ function $a1afdbbd1e661b97$export$1f70765132c3c225(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === "boolean" && !__SENTRY_TRACING__) return false;
    const options = maybeOptions || (0, $b03165fa5825574e$export$6bb76d6eba7e258c)()?.getOptions();
    return !!options && // Note: This check is `!= null`, meaning "nullish". `0` is not "nullish", `undefined` and `null` are. (This comment was brought to you by 15 minutes of questioning life)
    (options.tracesSampleRate != null || !!options.tracesSampler);
}
/**
 * @see JSDoc of `hasSpansEnabled`
 * @deprecated Use `hasSpansEnabled` instead, which is a more accurately named version of this function.
 * This function will be removed in the next major version of the SDK.
 */ // TODO(v10): Remove this export
const $a1afdbbd1e661b97$export$5008da00b1b6dee6 = $a1afdbbd1e661b97$export$1f70765132c3c225;







const $c641f6e9a3e6fcff$export$136e25984ba4a383 = 0;
const $c641f6e9a3e6fcff$export$58f7963109c806fc = 1;
const $c641f6e9a3e6fcff$export$f966a0446ece71e = 2;
/**
 * Converts a HTTP status code into a sentry status with a message.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ // https://develop.sentry.dev/sdk/event-payloads/span/
function $c641f6e9a3e6fcff$export$5fd4dc48a2131589(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return {
        code: $c641f6e9a3e6fcff$export$58f7963109c806fc
    };
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return {
                code: $c641f6e9a3e6fcff$export$f966a0446ece71e,
                message: "unauthenticated"
            };
        case 403:
            return {
                code: $c641f6e9a3e6fcff$export$f966a0446ece71e,
                message: "permission_denied"
            };
        case 404:
            return {
                code: $c641f6e9a3e6fcff$export$f966a0446ece71e,
                message: "not_found"
            };
        case 409:
            return {
                code: $c641f6e9a3e6fcff$export$f966a0446ece71e,
                message: "already_exists"
            };
        case 413:
            return {
                code: $c641f6e9a3e6fcff$export$f966a0446ece71e,
                message: "failed_precondition"
            };
        case 429:
            return {
                code: $c641f6e9a3e6fcff$export$f966a0446ece71e,
                message: "resource_exhausted"
            };
        case 499:
            return {
                code: $c641f6e9a3e6fcff$export$f966a0446ece71e,
                message: "cancelled"
            };
        default:
            return {
                code: $c641f6e9a3e6fcff$export$f966a0446ece71e,
                message: "invalid_argument"
            };
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return {
                code: $c641f6e9a3e6fcff$export$f966a0446ece71e,
                message: "unimplemented"
            };
        case 503:
            return {
                code: $c641f6e9a3e6fcff$export$f966a0446ece71e,
                message: "unavailable"
            };
        case 504:
            return {
                code: $c641f6e9a3e6fcff$export$f966a0446ece71e,
                message: "deadline_exceeded"
            };
        default:
            return {
                code: $c641f6e9a3e6fcff$export$f966a0446ece71e,
                message: "internal_error"
            };
    }
    return {
        code: $c641f6e9a3e6fcff$export$f966a0446ece71e,
        message: "unknown_error"
    };
}
/**
 * Sets the Http status attributes on the current span based on the http code.
 * Additionally, the span's status is updated, depending on the http code.
 */ function $c641f6e9a3e6fcff$export$2ad6630ec8164254(span, httpStatus) {
    span.setAttribute("http.response.status_code", httpStatus);
    const spanStatus = $c641f6e9a3e6fcff$export$5fd4dc48a2131589(httpStatus);
    if (spanStatus.message !== "unknown_error") span.setStatus(spanStatus);
}



const $efe19f6028f47f0c$var$SCOPE_ON_START_SPAN_FIELD = "_sentryScope";
const $efe19f6028f47f0c$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD = "_sentryIsolationScope";
/** Store the scope & isolation scope for a span, which can the be used when it is finished. */ function $efe19f6028f47f0c$export$cddb4027e3b0dd66(span, scope, isolationScope) {
    if (span) {
        (0, $088bc5d23a73ee42$export$e73679ffaf56810e)(span, $efe19f6028f47f0c$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD, isolationScope);
        (0, $088bc5d23a73ee42$export$e73679ffaf56810e)(span, $efe19f6028f47f0c$var$SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
/**
 * Grabs the scope and isolation scope off a span that were active when the span was started.
 */ function $efe19f6028f47f0c$export$c08fbc656a245d03(span) {
    return {
        scope: span[$efe19f6028f47f0c$var$SCOPE_ON_START_SPAN_FIELD],
        isolationScope: span[$efe19f6028f47f0c$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD]
    };
}







/**
 * Parse a sample rate from a given value.
 * This will either return a boolean or number sample rate, if the sample rate is valid (between 0 and 1).
 * If a string is passed, we try to convert it to a number.
 *
 * Any invalid sample rate will return `undefined`.
 */ function $2ef248cc9221d52a$export$a5bd2d81656d9546(sampleRate) {
    if (typeof sampleRate === "boolean") return Number(sampleRate);
    const rate = typeof sampleRate === "string" ? parseFloat(sampleRate) : sampleRate;
    if (typeof rate !== "number" || isNaN(rate) || rate < 0 || rate > 1) return undefined;
    return rate;
}



// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- RegExp is used for readability here
const $7acd8f1d8d8f63c0$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $7acd8f1d8d8f63c0$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return undefined;
    const matches = traceparent.match($7acd8f1d8d8f63c0$export$394a210812ba3012);
    if (!matches) return undefined;
    let parentSampled;
    if (matches[3] === "1") parentSampled = true;
    else if (matches[3] === "0") parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create a propagation context from incoming headers or
 * creates a minimal new one if the headers are undefined.
 */ function $7acd8f1d8d8f63c0$export$261f383d16a93e39(sentryTrace, baggage) {
    const traceparentData = $7acd8f1d8d8f63c0$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $6e5d8187374d2325$export$5b96ee2c8421f107)(baggage);
    if (!traceparentData?.traceId) return {
        traceId: (0, $5a01a011ec80712b$export$dc6d7ea554bcce10)(),
        sampleRand: Math.random()
    };
    const sampleRand = $7acd8f1d8d8f63c0$var$getSampleRandFromTraceparentAndDsc(traceparentData, dynamicSamplingContext);
    // The sample_rand on the DSC needs to be generated based on traceparent + baggage.
    if (dynamicSamplingContext) dynamicSamplingContext.sample_rand = sampleRand.toString();
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData;
    return {
        traceId: traceId,
        parentSpanId: parentSpanId,
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {},
        sampleRand: sampleRand
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function $7acd8f1d8d8f63c0$export$f35d907436da45cf(traceId = (0, $5a01a011ec80712b$export$dc6d7ea554bcce10)(), spanId = (0, $5a01a011ec80712b$export$295213bc4d0c54ad)(), sampled) {
    let sampledString = "";
    if (sampled !== undefined) sampledString = sampled ? "-1" : "-0";
    return `${traceId}-${spanId}${sampledString}`;
}
/**
 * Given any combination of an incoming trace, generate a sample rand based on its defined semantics.
 *
 * Read more: https://develop.sentry.dev/sdk/telemetry/traces/#propagated-random-value
 */ function $7acd8f1d8d8f63c0$var$getSampleRandFromTraceparentAndDsc(traceparentData, dsc) {
    // When there is an incoming sample rand use it.
    const parsedSampleRand = (0, $2ef248cc9221d52a$export$a5bd2d81656d9546)(dsc?.sample_rand);
    if (parsedSampleRand !== undefined) return parsedSampleRand;
    // Otherwise, if there is an incoming sampling decision + sample rate, generate a sample rand that would lead to the same sampling decision.
    const parsedSampleRate = (0, $2ef248cc9221d52a$export$a5bd2d81656d9546)(dsc?.sample_rate);
    if (parsedSampleRate && traceparentData?.parentSampled !== undefined) return traceparentData.parentSampled ? Math.random() * parsedSampleRate : parsedSampleRate + Math.random() * (1 - parsedSampleRate);
    else // If nothing applies, return a random sample rand.
    return Math.random();
}



// These are aligned with OpenTelemetry trace flags
const $d955067cf7638cfb$export$208d5b368507fb8b = 0x0;
const $d955067cf7638cfb$export$eb571cd9b5d98de8 = 0x1;
let $d955067cf7638cfb$var$hasShownSpanDropWarning = false;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 * By default, this will only include trace_id, span_id & parent_span_id.
 * If `includeAllData` is true, it will also include data, op, status & origin.
 */ function $d955067cf7638cfb$export$4c3967a8a2f6bbd6(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, origin: origin, links: links } = $d955067cf7638cfb$export$92d8c23565496537(span);
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id,
        data: data,
        op: op,
        status: status,
        origin: origin,
        links: links
    };
}
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in a non-transaction event.
 */ function $d955067cf7638cfb$export$46c6fbd1d265ebf0(span) {
    const { spanId: spanId, traceId: trace_id, isRemote: isRemote } = span.spanContext();
    // If the span is remote, we use a random/virtual span as span_id to the trace context,
    // and the remote span as parent_span_id
    const parent_span_id = isRemote ? spanId : $d955067cf7638cfb$export$92d8c23565496537(span).parent_span_id;
    const scope = (0, $efe19f6028f47f0c$export$c08fbc656a245d03)(span).scope;
    const span_id = isRemote ? scope?.getPropagationContext().propagationSpanId || (0, $5a01a011ec80712b$export$295213bc4d0c54ad)() : spanId;
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id
    };
}
/**
 * Convert a Span to a Sentry trace header.
 */ function $d955067cf7638cfb$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $d955067cf7638cfb$export$5caecac1caaf3a71(span);
    return (0, $7acd8f1d8d8f63c0$export$f35d907436da45cf)(traceId, spanId, sampled);
}
/**
 *  Converts the span links array to a flattened version to be sent within an envelope.
 *
 *  If the links array is empty, it returns `undefined` so the empty value can be dropped before it's sent.
 */ function $d955067cf7638cfb$export$cb3e3a12e0eec16c(links) {
    if (links && links.length > 0) return links.map(({ context: { spanId: spanId, traceId: traceId, traceFlags: traceFlags, ...restContext }, attributes: attributes })=>({
            span_id: spanId,
            trace_id: traceId,
            sampled: traceFlags === $d955067cf7638cfb$export$eb571cd9b5d98de8,
            attributes: attributes,
            ...restContext
        }));
    else return undefined;
}
/**
 * Convert a span time input into a timestamp in seconds.
 */ function $d955067cf7638cfb$export$3f7581298f56c6d7(input) {
    if (typeof input === "number") return $d955067cf7638cfb$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $d955067cf7638cfb$var$ensureTimestampInSeconds(input.getTime());
    return (0, $a49793e7936ef572$export$ee52dced521e3e18)();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function $d955067cf7638cfb$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 */ // Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
// This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
// And `spanToJSON` needs the Span class from `span.ts` to check here.
function $d955067cf7638cfb$export$92d8c23565496537(span) {
    if ($d955067cf7638cfb$var$spanIsSentrySpan(span)) return span.getSpanJSON();
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    // Handle a span from @opentelemetry/sdk-base-trace's `Span` class
    if ($d955067cf7638cfb$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
        const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, status: status, links: links } = span;
        // In preparation for the next major of OpenTelemetry, we want to support
        // looking up the parent span id according to the new API
        // In OTel v1, the parent span id is accessed as `parentSpanId`
        // In OTel v2, the parent span id is accessed as `spanId` on the `parentSpanContext`
        const parentSpanId = "parentSpanId" in span ? span.parentSpanId : "parentSpanContext" in span ? span.parentSpanContext?.spanId : undefined;
        return {
            span_id: span_id,
            trace_id: trace_id,
            data: attributes,
            description: name,
            parent_span_id: parentSpanId,
            start_timestamp: $d955067cf7638cfb$export$3f7581298f56c6d7(startTime),
            // This is [0,0] by default in OTEL, in which case we want to interpret this as no end time
            timestamp: $d955067cf7638cfb$export$3f7581298f56c6d7(endTime) || undefined,
            status: $d955067cf7638cfb$export$e238a77ea3a8cd66(status),
            op: attributes[0, $800ba4cf60399ed2$export$1a413bd9a88fdb09],
            origin: attributes[0, $800ba4cf60399ed2$export$cca8dd30f57f805e],
            links: $d955067cf7638cfb$export$cb3e3a12e0eec16c(links)
        };
    }
    // Finally, at least we have `spanContext()`....
    // This should not actually happen in reality, but we need to handle it for type safety.
    return {
        span_id: span_id,
        trace_id: trace_id,
        start_timestamp: 0,
        data: {}
    };
}
function $d955067cf7638cfb$var$spanIsOpenTelemetrySdkTraceBaseSpan(span) {
    const castSpan = span;
    return !!castSpan.attributes && !!castSpan.startTime && !!castSpan.name && !!castSpan.endTime && !!castSpan.status;
}
/** Exported only for tests. */ /**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function $d955067cf7638cfb$var$spanIsSentrySpan(span) {
    return typeof span.getSpanJSON === "function";
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function $d955067cf7638cfb$export$5caecac1caaf3a71(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    const { traceFlags: traceFlags } = span.spanContext();
    return traceFlags === $d955067cf7638cfb$export$eb571cd9b5d98de8;
}
/** Get the status message to use for a JSON representation of a span. */ function $d955067cf7638cfb$export$e238a77ea3a8cd66(status) {
    if (!status || status.code === (0, $c641f6e9a3e6fcff$export$136e25984ba4a383)) return undefined;
    if (status.code === (0, $c641f6e9a3e6fcff$export$58f7963109c806fc)) return "ok";
    return status.message || "unknown_error";
}
const $d955067cf7638cfb$var$CHILD_SPANS_FIELD = "_sentryChildSpans";
const $d955067cf7638cfb$var$ROOT_SPAN_FIELD = "_sentryRootSpan";
/**
 * Adds an opaque child span reference to a span.
 */ function $d955067cf7638cfb$export$81397d924722cc65(span, childSpan) {
    // We store the root span reference on the child span
    // We need this for `getRootSpan()` to work
    const rootSpan = span[$d955067cf7638cfb$var$ROOT_SPAN_FIELD] || span;
    (0, $088bc5d23a73ee42$export$e73679ffaf56810e)(childSpan, $d955067cf7638cfb$var$ROOT_SPAN_FIELD, rootSpan);
    // We store a list of child spans on the parent span
    // We need this for `getSpanDescendants()` to work
    if (span[$d955067cf7638cfb$var$CHILD_SPANS_FIELD]) span[$d955067cf7638cfb$var$CHILD_SPANS_FIELD].add(childSpan);
    else (0, $088bc5d23a73ee42$export$e73679ffaf56810e)(span, $d955067cf7638cfb$var$CHILD_SPANS_FIELD, new Set([
        childSpan
    ]));
}
/** This is only used internally by Idle Spans. */ function $d955067cf7638cfb$export$c2a0c9438bb89d91(span, childSpan) {
    if (span[$d955067cf7638cfb$var$CHILD_SPANS_FIELD]) span[$d955067cf7638cfb$var$CHILD_SPANS_FIELD].delete(childSpan);
}
/**
 * Returns an array of the given span and all of its descendants.
 */ function $d955067cf7638cfb$export$340c5c8a13ffc680(span) {
    const resultSet = new Set();
    function addSpanChildren(span) {
        // This exit condition is required to not infinitely loop in case of a circular dependency.
        if (resultSet.has(span)) return;
        else if ($d955067cf7638cfb$export$5caecac1caaf3a71(span)) {
            resultSet.add(span);
            const childSpans = span[$d955067cf7638cfb$var$CHILD_SPANS_FIELD] ? Array.from(span[$d955067cf7638cfb$var$CHILD_SPANS_FIELD]) : [];
            for (const childSpan of childSpans)addSpanChildren(childSpan);
        }
    }
    addSpanChildren(span);
    return Array.from(resultSet);
}
/**
 * Returns the root span of a given span.
 */ function $d955067cf7638cfb$export$c4c6a79b1260ca1b(span) {
    return span[$d955067cf7638cfb$var$ROOT_SPAN_FIELD] || span;
}
/**
 * Returns the currently active span.
 */ function $d955067cf7638cfb$export$1be426a8e585c83e() {
    const carrier = (0, $92999225fa2a9a7f$export$19eade501500c6c1)();
    const acs = (0, $09969a149715ffe3$export$f639b0c2752203be)(carrier);
    if (acs.getActiveSpan) return acs.getActiveSpan();
    return (0, $a50179f3b396b1d8$export$91f063ebb8eff307)((0, $b03165fa5825574e$export$c7be4b0125a10cba)());
}
/**
 * Logs a warning once if `beforeSendSpan` is used to drop spans.
 */ function $d955067cf7638cfb$export$d11691ff45a3e535() {
    if (!$d955067cf7638cfb$var$hasShownSpanDropWarning) {
        (0, $f1cb9ab3cf87365c$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.warn("[Sentry] Returning null from `beforeSendSpan` is disallowed. To drop certain spans, configure the respective integrations directly.");
        });
        $d955067cf7638cfb$var$hasShownSpanDropWarning = true;
    }
}
/**
 * Updates the name of the given span and ensures that the span name is not
 * overwritten by the Sentry SDK.
 *
 * Use this function instead of `span.updateName()` if you want to make sure that
 * your name is kept. For some spans, for example root `http.server` spans the
 * Sentry SDK would otherwise overwrite the span name with a high-quality name
 * it infers when the span ends.
 *
 * Use this function in server code or when your span is started on the server
 * and on the client (browser). If you only update a span name on the client,
 * you can also use `span.updateName()` the SDK does not overwrite the name.
 *
 * @param span - The span to update the name of.
 * @param name - The name to set on the span.
 */ function $d955067cf7638cfb$export$5b72d3169c1be715(span, name) {
    span.updateName(name);
    span.setAttributes({
        [(0, $800ba4cf60399ed2$export$d7a7d984b0791405)]: "custom",
        [(0, $800ba4cf60399ed2$export$165ce9a229f6f050)]: name
    });
}



/**
 * If you change this value, also update the terser plugin config to
 * avoid minification of the object property!
 */ const $d3b57429db417f76$var$FROZEN_DSC_FIELD = "_frozenDsc";
/**
 * Freeze the given DSC on the given span.
 */ function $d3b57429db417f76$export$7398c93e763ca9fd(span, dsc) {
    const spanWithMaybeDsc = span;
    (0, $088bc5d23a73ee42$export$e73679ffaf56810e)(spanWithMaybeDsc, $d3b57429db417f76$var$FROZEN_DSC_FIELD, dsc);
}
/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function $d3b57429db417f76$export$366bad00d6815eed(trace_id, client) {
    const options = client.getOptions();
    const { publicKey: public_key, host: host } = client.getDsn() || {};
    let org_id;
    if (options.orgId) org_id = String(options.orgId);
    else if (host) org_id = (0, $1051dd8b7d8de41f$export$5914f4e7748c29c9)(host);
    // Instead of conditionally adding non-undefined values, we add them and then remove them if needed
    // otherwise, the order of baggage entries changes, which "breaks" a bunch of tests etc.
    const dsc = {
        environment: options.environment || (0, $4cef6351145f1d86$export$849dbeeeda01ae98),
        release: options.release,
        public_key: public_key,
        trace_id: trace_id,
        org_id: org_id
    };
    client.emit("createDsc", dsc);
    return dsc;
}
/**
 * Get the dynamic sampling context for the currently active scopes.
 */ function $d3b57429db417f76$export$89ef1736f08c6b2b(client, scope) {
    const propagationContext = scope.getPropagationContext();
    return propagationContext.dsc || $d3b57429db417f76$export$366bad00d6815eed(propagationContext.traceId, client);
}
/**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function $d3b57429db417f76$export$a117f995597e25df(span) {
    const client = (0, $b03165fa5825574e$export$6bb76d6eba7e258c)();
    if (!client) return {};
    const rootSpan = (0, $d955067cf7638cfb$export$c4c6a79b1260ca1b)(span);
    const rootSpanJson = (0, $d955067cf7638cfb$export$92d8c23565496537)(rootSpan);
    const rootSpanAttributes = rootSpanJson.data;
    const traceState = rootSpan.spanContext().traceState;
    // The span sample rate that was locally applied to the root span should also always be applied to the DSC, even if the DSC is frozen.
    // This is so that the downstream traces/services can use parentSampleRate in their `tracesSampler` to make consistent sampling decisions across the entire trace.
    const rootSpanSampleRate = traceState?.get("sentry.sample_rate") ?? rootSpanAttributes[0, $800ba4cf60399ed2$export$ccfe0a40627cc34b] ?? rootSpanAttributes[0, $800ba4cf60399ed2$export$889fb736668e1ecc];
    function applyLocalSampleRateToDsc(dsc) {
        if (typeof rootSpanSampleRate === "number" || typeof rootSpanSampleRate === "string") dsc.sample_rate = `${rootSpanSampleRate}`;
        return dsc;
    }
    // For core implementation, we freeze the DSC onto the span as a non-enumerable property
    const frozenDsc = rootSpan[$d3b57429db417f76$var$FROZEN_DSC_FIELD];
    if (frozenDsc) return applyLocalSampleRateToDsc(frozenDsc);
    // For OpenTelemetry, we freeze the DSC on the trace state
    const traceStateDsc = traceState?.get("sentry.dsc");
    // If the span has a DSC, we want it to take precedence
    const dscOnTraceState = traceStateDsc && (0, $6e5d8187374d2325$export$5b96ee2c8421f107)(traceStateDsc);
    if (dscOnTraceState) return applyLocalSampleRateToDsc(dscOnTraceState);
    // Else, we generate it from the span
    const dsc = $d3b57429db417f76$export$366bad00d6815eed(span.spanContext().traceId, client);
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    const source = rootSpanAttributes[0, $800ba4cf60399ed2$export$d7a7d984b0791405];
    // after JSON conversion, txn.name becomes jsonSpan.description
    const name = rootSpanJson.description;
    if (source !== "url" && name) dsc.transaction = name;
    // How can we even land here with hasSpansEnabled() returning false?
    // Otel creates a Non-recording span in Tracing Without Performance mode when handling incoming requests
    // So we end up with an active span that is not sampled (neither positively nor negatively)
    if ((0, $a1afdbbd1e661b97$export$1f70765132c3c225)()) {
        dsc.sampled = String((0, $d955067cf7638cfb$export$5caecac1caaf3a71)(rootSpan));
        dsc.sample_rand = // In OTEL we store the sample rand on the trace state because we cannot access scopes for NonRecordingSpans
        // The Sentry OTEL SpanSampler takes care of writing the sample rand on the root span
        traceState?.get("sentry.sample_rand") ?? // On all other platforms we can actually get the scopes from a root span (we use this as a fallback)
        (0, $efe19f6028f47f0c$export$c08fbc656a245d03)(rootSpan).scope?.getPropagationContext().sampleRand.toString();
    }
    applyLocalSampleRateToDsc(dsc);
    client.emit("createDsc", dsc, rootSpan);
    return dsc;
}
/**
 * Convert a Span to a baggage header.
 */ function $d3b57429db417f76$export$95cf936fdacaff7b(span) {
    const dsc = $d3b57429db417f76$export$a117f995597e25df(span);
    return (0, $6e5d8187374d2325$export$56766feef403f365)(dsc);
}




/**
 * Applies data from the scope to the event and runs all event processors on it.
 */ function $0ebf6b3897e41d02$export$43988bc651a80216(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    // Apply general data
    $0ebf6b3897e41d02$var$applyDataToEvent(event, data);
    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (span) $0ebf6b3897e41d02$var$applySpanToEvent(event, span);
    $0ebf6b3897e41d02$var$applyFingerprintToEvent(event, fingerprint);
    $0ebf6b3897e41d02$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $0ebf6b3897e41d02$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
/** Merge data of two scopes together. */ function $0ebf6b3897e41d02$export$25ac7e259a513db4(data, mergeData) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: transactionName, span: span } = mergeData;
    $0ebf6b3897e41d02$export$b1a120a2871faa46(data, "extra", extra);
    $0ebf6b3897e41d02$export$b1a120a2871faa46(data, "tags", tags);
    $0ebf6b3897e41d02$export$b1a120a2871faa46(data, "user", user);
    $0ebf6b3897e41d02$export$b1a120a2871faa46(data, "contexts", contexts);
    data.sdkProcessingMetadata = (0, $efd5e6f793cedc55$export$4950aa0f605343fb)(data.sdkProcessingMetadata, sdkProcessingMetadata, 2);
    if (level) data.level = level;
    if (transactionName) data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = {
        ...data.propagationContext,
        ...propagationContext
    };
}
/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */ function $0ebf6b3897e41d02$export$b1a120a2871faa46(data, prop, mergeVal) {
    data[prop] = (0, $efd5e6f793cedc55$export$4950aa0f605343fb)(data[prop], mergeVal, 1);
}
function $0ebf6b3897e41d02$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: transactionName } = data;
    if (Object.keys(extra).length) event.extra = {
        ...extra,
        ...event.extra
    };
    if (Object.keys(tags).length) event.tags = {
        ...tags,
        ...event.tags
    };
    if (Object.keys(user).length) event.user = {
        ...user,
        ...event.user
    };
    if (Object.keys(contexts).length) event.contexts = {
        ...contexts,
        ...event.contexts
    };
    if (level) event.level = level;
    // transaction events get their `transaction` from the root span name
    if (transactionName && event.type !== "transaction") event.transaction = transactionName;
}
function $0ebf6b3897e41d02$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}
function $0ebf6b3897e41d02$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        ...sdkProcessingMetadata
    };
}
function $0ebf6b3897e41d02$var$applySpanToEvent(event, span) {
    event.contexts = {
        trace: (0, $d955067cf7638cfb$export$46c6fbd1d265ebf0)(span),
        ...event.contexts
    };
    event.sdkProcessingMetadata = {
        dynamicSamplingContext: (0, $d3b57429db417f76$export$a117f995597e25df)(span),
        ...event.sdkProcessingMetadata
    };
    const rootSpan = (0, $d955067cf7638cfb$export$c4c6a79b1260ca1b)(span);
    const transactionName = (0, $d955067cf7638cfb$export$92d8c23565496537)(rootSpan).description;
    if (transactionName && !event.transaction && event.type === "transaction") event.transaction = transactionName;
}
/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */ function $0ebf6b3897e41d02$var$applyFingerprintToEvent(event, fingerprint) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? Array.isArray(event.fingerprint) ? event.fingerprint : [
        event.fingerprint
    ] : [];
    // If we have something on the scope, then merge it with event
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    // If we have no data at all, remove empty array default
    if (!event.fingerprint.length) delete event.fingerprint;
}



let $9316c63bd301f487$var$parsedStackResults;
let $9316c63bd301f487$var$lastKeysCount;
let $9316c63bd301f487$var$cachedFilenameDebugIds;
/**
 * Returns a map of filenames to debug identifiers.
 */ function $9316c63bd301f487$export$e069fee9c632ed00(stackParser) {
    const debugIdMap = (0, $bf3d8fd3d1ce8fc4$export$f1a6cdb1459e81d1)._sentryDebugIds;
    if (!debugIdMap) return {};
    const debugIdKeys = Object.keys(debugIdMap);
    // If the count of registered globals hasn't changed since the last call, we
    // can just return the cached result.
    if ($9316c63bd301f487$var$cachedFilenameDebugIds && debugIdKeys.length === $9316c63bd301f487$var$lastKeysCount) return $9316c63bd301f487$var$cachedFilenameDebugIds;
    $9316c63bd301f487$var$lastKeysCount = debugIdKeys.length;
    // Build a map of filename -> debug_id.
    $9316c63bd301f487$var$cachedFilenameDebugIds = debugIdKeys.reduce((acc, stackKey)=>{
        if (!$9316c63bd301f487$var$parsedStackResults) $9316c63bd301f487$var$parsedStackResults = {};
        const result = $9316c63bd301f487$var$parsedStackResults[stackKey];
        if (result) acc[result[0]] = result[1];
        else {
            const parsedStack = stackParser(stackKey);
            for(let i = parsedStack.length - 1; i >= 0; i--){
                const stackFrame = parsedStack[i];
                const filename = stackFrame?.filename;
                const debugId = debugIdMap[stackKey];
                if (filename && debugId) {
                    acc[filename] = debugId;
                    $9316c63bd301f487$var$parsedStackResults[stackKey] = [
                        filename,
                        debugId
                    ];
                    break;
                }
            }
        }
        return acc;
    }, {});
    return $9316c63bd301f487$var$cachedFilenameDebugIds;
}
/**
 * Returns a list of debug images for the given resources.
 */ function $9316c63bd301f487$export$5a7368330d9ee6e3(stackParser, resource_paths) {
    const filenameDebugIdMap = $9316c63bd301f487$export$e069fee9c632ed00(stackParser);
    if (!filenameDebugIdMap) return [];
    const images = [];
    for (const path of resource_paths)if (path && filenameDebugIdMap[path]) images.push({
        type: "sourcemap",
        code_file: path,
        debug_id: filenameDebugIdMap[path]
    });
    return images;
}





const $ea5a61a83f2b5ce5$var$STACKTRACE_FRAME_LIMIT = 50;
const $ea5a61a83f2b5ce5$export$27c7e15d453fc0ac = "?";
// Used to sanitize webpack (error: *) wrapped stack errors
const $ea5a61a83f2b5ce5$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $ea5a61a83f2b5ce5$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $ea5a61a83f2b5ce5$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirstLines = 0, framesToPop = 0)=>{
        const frames = [];
        const lines = stack.split("\n");
        for(let i = skipFirstLines; i < lines.length; i++){
            const line = lines[i];
            // Ignore lines over 1kb as they are unlikely to be stack frames.
            // Many of the regular expressions use backtracking which results in run time that increases exponentially with
            // input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) continue;
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $ea5a61a83f2b5ce5$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($ea5a61a83f2b5ce5$var$WEBPACK_ERROR_REGEXP, "$1") : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $ea5a61a83f2b5ce5$var$STACKTRACE_FRAME_LIMIT + framesToPop) break;
        }
        return $ea5a61a83f2b5ce5$export$c55c24c0eeba0205(frames.slice(framesToPop));
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $ea5a61a83f2b5ce5$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $ea5a61a83f2b5ce5$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $ea5a61a83f2b5ce5$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test($ea5a61a83f2b5ce5$var$getLastStackFrame(localStack).function || "")) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($ea5a61a83f2b5ce5$var$STRIP_FRAME_REGEXP.test($ea5a61a83f2b5ce5$var$getLastStackFrame(localStack).function || "")) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the scope itself, making it:
        //
        //   Sentry.captureException()
        //   scope.captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($ea5a61a83f2b5ce5$var$STRIP_FRAME_REGEXP.test($ea5a61a83f2b5ce5$var$getLastStackFrame(localStack).function || "")) localStack.pop();
    }
    return localStack.slice(0, $ea5a61a83f2b5ce5$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || $ea5a61a83f2b5ce5$var$getLastStackFrame(localStack).filename,
            function: frame.function || $ea5a61a83f2b5ce5$export$27c7e15d453fc0ac
        }));
}
function $ea5a61a83f2b5ce5$var$getLastStackFrame(arr) {
    return arr[arr.length - 1] || {};
}
const $ea5a61a83f2b5ce5$var$defaultFunctionName = "<anonymous>";
/**
 * Safely extract function name from itself
 */ function $ea5a61a83f2b5ce5$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== "function") return $ea5a61a83f2b5ce5$var$defaultFunctionName;
        return fn.name || $ea5a61a83f2b5ce5$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $ea5a61a83f2b5ce5$var$defaultFunctionName;
    }
}
/**
 * Get's stack frames from an event without needing to check for undefined properties.
 */ function $ea5a61a83f2b5ce5$export$91d8ca51bd9f6a47(event) {
    const exception = event.exception;
    if (exception) {
        const frames = [];
        try {
            // @ts-expect-error Object could be undefined
            exception.values.forEach((value)=>{
                // @ts-expect-error Value could be undefined
                if (value.stacktrace.frames) // @ts-expect-error Value could be undefined
                frames.push(...value.stacktrace.frames);
            });
            return frames;
        } catch (_oO) {
            return undefined;
        }
    }
    return undefined;
}


/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normalized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $b661d102b0d864f7$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $b661d102b0d864f7$var$visit("", input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $b661d102b0d864f7$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $b661d102b0d864f7$export$a3295358bff77e(object, depth);
    if ($b661d102b0d864f7$var$jsonSize(normalized) > maxSize) return $b661d102b0d864f7$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $b661d102b0d864f7$var$visit(key, value, depth = Infinity, maxProperties = Infinity, memo = $b661d102b0d864f7$var$memoBuilder()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        "boolean",
        "string"
    ].includes(typeof value) || typeof value === "number" && Number.isFinite(value)) return value;
    const stringified = $b661d102b0d864f7$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith("[object ")) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value["__sentry_skip_normalization__"]) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    const remainingDepth = typeof value["__sentry_override_normalization_depth__"] === "number" ? value["__sentry_override_normalization_depth__"] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace("object ", "");
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return "[Circular ~]";
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === "function") try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $b661d102b0d864f7$var$visit("", jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, $088bc5d23a73ee42$export$62ff257738bf57f5)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = "[MaxProperties ~]";
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $b661d102b0d864f7$var$visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $b661d102b0d864f7$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === "domain" && value && typeof value === "object" && value._events) return "[Domain]";
        if (key === "domainEmitter") return "[DomainEmitter]";
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== "undefined" && value === $parcel$global) return "[Global]";
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== "undefined" && value === window) return "[Window]";
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== "undefined" && value === document) return "[Document]";
        if ((0, $5caf4cf2c479782f$export$7916fad0ebc23f48)(value)) return "[VueViewModel]";
        // React's SyntheticEvent thingy
        if ((0, $5caf4cf2c479782f$export$bc2894c7158efbac)(value)) return "[SyntheticEvent]";
        if (typeof value === "number" && !Number.isFinite(value)) return `[${value}]`;
        if (typeof value === "function") return `[Function: ${(0, $ea5a61a83f2b5ce5$export$aad197c7121a6651)(value)}]`;
        if (typeof value === "symbol") return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === "bigint") return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        const objName = $b661d102b0d864f7$var$getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function $b661d102b0d864f7$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype?.constructor ? prototype.constructor.name : "null prototype";
}
/** Calculates bytes size of input string */ function $b661d102b0d864f7$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $b661d102b0d864f7$var$jsonSize(value) {
    return $b661d102b0d864f7$var$utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function $b661d102b0d864f7$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath// Backslash to forward
    .replace(/\\/g, "/")// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, "\\$&");
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch (_Oo) {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, "/").replace(/webpack:\/?/g, "") // Remove intermediate base path
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor
    .replace(new RegExp(`(file://)?/*${escapedBase}/*`, "ig"), "app:///");
}
/**
 * Helper to decycle json objects
 */ function $b661d102b0d864f7$var$memoBuilder() {
    const inner = new WeakSet();
    function memoize(obj) {
        if (inner.has(obj)) return true;
        inner.add(obj);
        return false;
    }
    function unmemoize(obj) {
        inner.delete(obj);
    }
    return [
        memoize,
        unmemoize
    ];
}




/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */ /**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function $6785e865a7974434$export$2d67fb380bd11267(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || (0, $adba9e1e8cd7ee8e$export$19f53698e68b2496)(),
        timestamp: event.timestamp || (0, $a49793e7936ef572$export$7740643b9eeaf0c4)()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $6785e865a7974434$export$d7e04067a6fbc882(prepared, options);
    $6785e865a7974434$var$applyIntegrationsMetadata(prepared, integrations);
    if (client) client.emit("applyFrameMetadata", event);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) $6785e865a7974434$export$63042efc86f043e7(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    const finalScope = $6785e865a7974434$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) (0, $adba9e1e8cd7ee8e$export$c69a9a0313b03bb1)(prepared, hint.mechanism);
    const clientEventProcessors = client ? client.getEventProcessors() : [];
    // This should be the last thing called, since we want that
    // {@link Scope.addEventProcessor} gets the finished prepared event.
    // Merge scope data together
    const data = (0, $b03165fa5825574e$export$aa55d5ab8e05984f)().getScopeData();
    if (isolationScope) {
        const isolationData = isolationScope.getScopeData();
        (0, $0ebf6b3897e41d02$export$25ac7e259a513db4)(data, isolationData);
    }
    if (finalScope) {
        const finalScopeData = finalScope.getScopeData();
        (0, $0ebf6b3897e41d02$export$25ac7e259a513db4)(data, finalScopeData);
    }
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    (0, $0ebf6b3897e41d02$export$43988bc651a80216)(prepared, data);
    const eventProcessors = [
        ...clientEventProcessors,
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    const result = (0, $dc1c072626d5b007$export$bf2a096c3e883e79)(eventProcessors, prepared, hint);
    return result.then((evt)=>{
        if (evt) // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
        // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
        // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
        // any new data
        $6785e865a7974434$export$1be657ba8ef44ff0(evt);
        if (typeof normalizeDepth === "number" && normalizeDepth > 0) return $6785e865a7974434$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 * Enhances event using the client configuration.
 * It takes care of all "static" values like environment, release and `dist`,
 * as well as truncating overly long values.
 *
 * Only exported for tests.
 *
 * @param event event instance to be enhanced
 */ function $6785e865a7974434$export$d7e04067a6fbc882(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength = 250 } = options;
    // empty strings do not make sense for environment, release, and dist
    // so we handle them the same as if they were not provided
    event.environment = event.environment || environment || (0, $4cef6351145f1d86$export$849dbeeeda01ae98);
    if (!event.release && release) event.release = release;
    if (!event.dist && dist) event.dist = dist;
    const request = event.request;
    if (request?.url) request.url = (0, $e9fb89f9f6b2a439$export$6a506b36fdea397d)(request.url, maxValueLength);
}
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function $6785e865a7974434$export$63042efc86f043e7(event, stackParser) {
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = (0, $9316c63bd301f487$export$e069fee9c632ed00)(stackParser);
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
        });
    });
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function $6785e865a7974434$export$1be657ba8ef44ff0(event) {
    // Extract debug IDs and filenames from the stack frames on the event.
    const filenameDebugIdMap = {};
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            if (frame.debug_id) {
                if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                delete frame.debug_id;
            }
        });
    });
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.entries(filenameDebugIdMap).forEach(([filename, debug_id])=>{
        images.push({
            type: "sourcemap",
            code_file: filename,
            debug_id: debug_id
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function $6785e865a7974434$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function $6785e865a7974434$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: (0, $b661d102b0d864f7$export$a3295358bff77e)(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: (0, $b661d102b0d864f7$export$a3295358bff77e)(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: (0, $b661d102b0d864f7$export$a3295358bff77e)(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: (0, $b661d102b0d864f7$export$a3295358bff77e)(event.extra, depth, maxBreadth)
        }
    };
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts?.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $b661d102b0d864f7$export$a3295358bff77e)(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        return {
            ...span,
            ...span.data && {
                data: (0, $b661d102b0d864f7$export$a3295358bff77e)(span.data, depth, maxBreadth)
            }
        };
    });
    // event.contexts.flags (FeatureFlagContext) stores context for our feature
    // flag integrations. It has a greater nesting depth than our other typed
    // Contexts, so we re-normalize with a fixed depth of 3 here. We do not want
    // to skip this in case of conflicting, user-provided context.
    if (event.contexts?.flags && normalized.contexts) normalized.contexts.flags = (0, $b661d102b0d864f7$export$a3295358bff77e)(event.contexts.flags, 3, maxBreadth);
    return normalized;
}
function $6785e865a7974434$var$getFinalScope(scope, captureContext) {
    if (!captureContext) return scope;
    const finalScope = scope ? scope.clone() : new (0, $bac4dfa4b40ca381$export$775b6bb06e53a214)();
    finalScope.update(captureContext);
    return finalScope;
}
/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */ function $6785e865a7974434$export$76b5f966996d1653(hint) {
    if (!hint) return undefined;
    // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
    if ($6785e865a7974434$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($6785e865a7974434$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $6785e865a7974434$var$hintIsScopeOrFunction(hint) {
    return hint instanceof (0, $bac4dfa4b40ca381$export$775b6bb06e53a214) || typeof hint === "function";
}
const $6785e865a7974434$var$captureContextKeys = [
    "user",
    "level",
    "extra",
    "contexts",
    "tags",
    "fingerprint",
    "propagationContext"
];
function $6785e865a7974434$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$6785e865a7974434$var$captureContextKeys.includes(key));
}




/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $45011cfcd1a50cfc$export$f5282963edea4a68(exception, hint) {
    return (0, $b03165fa5825574e$export$c7be4b0125a10cba)().captureException(exception, (0, $6785e865a7974434$export$76b5f966996d1653)(hint));
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param message The message to send to Sentry.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */ function $45011cfcd1a50cfc$export$45654777c133ae80(message, captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    const level = typeof captureContext === "string" ? captureContext : undefined;
    const context = typeof captureContext !== "string" ? {
        captureContext: captureContext
    } : undefined;
    return (0, $b03165fa5825574e$export$c7be4b0125a10cba)().captureMessage(message, level, context);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param event The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */ function $45011cfcd1a50cfc$export$1462b974fdcf6ba2(event, hint) {
    return (0, $b03165fa5825574e$export$c7be4b0125a10cba)().captureEvent(event, hint);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ function $45011cfcd1a50cfc$export$2f04de43fe27971a(name, context) {
    (0, $b03165fa5825574e$export$68f3af03034c9e90)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ function $45011cfcd1a50cfc$export$bb4922da0dd51b92(extras) {
    (0, $b03165fa5825574e$export$68f3af03034c9e90)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ function $45011cfcd1a50cfc$export$8e8e7789d42ed61d(key, extra) {
    (0, $b03165fa5825574e$export$68f3af03034c9e90)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ function $45011cfcd1a50cfc$export$74a8fb34822092e6(tags) {
    (0, $b03165fa5825574e$export$68f3af03034c9e90)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ function $45011cfcd1a50cfc$export$a37d07ee78eb4569(key, value) {
    (0, $b03165fa5825574e$export$68f3af03034c9e90)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ function $45011cfcd1a50cfc$export$8b6bb3dd62a01be2(user) {
    (0, $b03165fa5825574e$export$68f3af03034c9e90)().setUser(user);
}
/**
 * The last error event id of the isolation scope.
 *
 * Warning: This function really returns the last recorded error event id on the current
 * isolation scope. If you call this function after handling a certain error and another error
 * is captured in between, the last one is returned instead of the one you might expect.
 * Also, ids of events that were never sent to Sentry (for example because
 * they were dropped in `beforeSend`) could be returned.
 *
 * @returns The last event id of the isolation scope.
 */ function $45011cfcd1a50cfc$export$5d4e9fd7fac8e617() {
    return (0, $b03165fa5825574e$export$68f3af03034c9e90)().lastEventId();
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $45011cfcd1a50cfc$export$413528111fbc67c(checkIn, upsertMonitorConfig) {
    const scope = (0, $b03165fa5825574e$export$c7be4b0125a10cba)();
    const client = (0, $b03165fa5825574e$export$6bb76d6eba7e258c)();
    if (!client) (0, $a19fca88fc2be424$export$16a28057038b10ef) && (0, $f1cb9ab3cf87365c$export$af88d00dbe7f521).warn("Cannot capture check-in. No client defined.");
    else if (!client.captureCheckIn) (0, $a19fca88fc2be424$export$16a28057038b10ef) && (0, $f1cb9ab3cf87365c$export$af88d00dbe7f521).warn("Cannot capture check-in. Client does not support sending check-ins.");
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, $adba9e1e8cd7ee8e$export$19f53698e68b2496)();
}
/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $45011cfcd1a50cfc$export$553526fc5f03c0b1(monitorSlug, callback, upsertMonitorConfig) {
    const checkInId = $45011cfcd1a50cfc$export$413528111fbc67c({
        monitorSlug: monitorSlug,
        status: "in_progress"
    }, upsertMonitorConfig);
    const now = (0, $a49793e7936ef572$export$ee52dced521e3e18)();
    function finishCheckIn(status) {
        $45011cfcd1a50cfc$export$413528111fbc67c({
            monitorSlug: monitorSlug,
            status: status,
            checkInId: checkInId,
            duration: (0, $a49793e7936ef572$export$ee52dced521e3e18)() - now
        });
    }
    return (0, $b03165fa5825574e$export$9a4fed82c350c2bd)(()=>{
        let maybePromiseResult;
        try {
            maybePromiseResult = callback();
        } catch (e) {
            finishCheckIn("error");
            throw e;
        }
        if ((0, $5caf4cf2c479782f$export$f5b060c2914b97c8)(maybePromiseResult)) Promise.resolve(maybePromiseResult).then(()=>{
            finishCheckIn("ok");
        }, (e)=>{
            finishCheckIn("error");
            throw e;
        });
        else finishCheckIn("ok");
        return maybePromiseResult;
    });
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $45011cfcd1a50cfc$export$4909b86c8034bf73(timeout) {
    const client = (0, $b03165fa5825574e$export$6bb76d6eba7e258c)();
    if (client) return client.flush(timeout);
    (0, $a19fca88fc2be424$export$16a28057038b10ef) && (0, $f1cb9ab3cf87365c$export$af88d00dbe7f521).warn("Cannot flush events. No client defined.");
    return Promise.resolve(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $45011cfcd1a50cfc$export$8360e631d277ea4d(timeout) {
    const client = (0, $b03165fa5825574e$export$6bb76d6eba7e258c)();
    if (client) return client.close(timeout);
    (0, $a19fca88fc2be424$export$16a28057038b10ef) && (0, $f1cb9ab3cf87365c$export$af88d00dbe7f521).warn("Cannot flush events and disable SDK. No client defined.");
    return Promise.resolve(false);
}
/**
 * Returns true if Sentry has been properly initialized.
 */ function $45011cfcd1a50cfc$export$3f95c6f800b78024() {
    return !!(0, $b03165fa5825574e$export$6bb76d6eba7e258c)();
}
/** If the SDK is initialized & enabled. */ function $45011cfcd1a50cfc$export$3b029eb57ac4d562() {
    const client = (0, $b03165fa5825574e$export$6bb76d6eba7e258c)();
    return client?.getOptions().enabled !== false && !!client?.getTransport();
}
/**
 * Add an event processor.
 * This will be added to the current isolation scope, ensuring any event that is processed in the current execution
 * context will have the processor applied.
 */ function $45011cfcd1a50cfc$export$9aac0b9f77928fbf(callback) {
    (0, $b03165fa5825574e$export$68f3af03034c9e90)().addEventProcessor(callback);
}
/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */ function $45011cfcd1a50cfc$export$c0d84948cecf78d8(context) {
    const isolationScope = (0, $b03165fa5825574e$export$68f3af03034c9e90)();
    const currentScope = (0, $b03165fa5825574e$export$c7be4b0125a10cba)();
    // Will fetch userAgent if called from browser sdk
    const { userAgent: userAgent } = (0, $bf3d8fd3d1ce8fc4$export$f1a6cdb1459e81d1).navigator || {};
    const session = (0, $cd8c952cb2d34a33$export$14a186326edbb264)({
        user: currentScope.getUser() || isolationScope.getUser(),
        ...userAgent && {
            userAgent: userAgent
        },
        ...context
    });
    // End existing session if there's one
    const currentSession = isolationScope.getSession();
    if (currentSession?.status === "ok") (0, $cd8c952cb2d34a33$export$531818e825e774db)(currentSession, {
        status: "exited"
    });
    $45011cfcd1a50cfc$export$17a5be43989a0bc1();
    // Afterwards we set the new session on the scope
    isolationScope.setSession(session);
    return session;
}
/**
 * End the session on the current isolation scope.
 */ function $45011cfcd1a50cfc$export$17a5be43989a0bc1() {
    const isolationScope = (0, $b03165fa5825574e$export$68f3af03034c9e90)();
    const currentScope = (0, $b03165fa5825574e$export$c7be4b0125a10cba)();
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session) (0, $cd8c952cb2d34a33$export$56521d9ba90f62ee)(session);
    $45011cfcd1a50cfc$var$_sendSessionUpdate();
    // the session is over; take it off of the scope
    isolationScope.setSession();
}
/**
 * Sends the current Session on the scope
 */ function $45011cfcd1a50cfc$var$_sendSessionUpdate() {
    const isolationScope = (0, $b03165fa5825574e$export$68f3af03034c9e90)();
    const client = (0, $b03165fa5825574e$export$6bb76d6eba7e258c)();
    const session = isolationScope.getSession();
    if (session && client) client.captureSession(session);
}
/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */ function $45011cfcd1a50cfc$export$667e7b4d445d566b(end = false) {
    // both send the update and pull the session from the scope
    if (end) {
        $45011cfcd1a50cfc$export$17a5be43989a0bc1();
        return;
    }
    // only send the update
    $45011cfcd1a50cfc$var$_sendSessionUpdate();
}





/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $ee4fb08d97605578$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $ee4fb08d97605578$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function $ee4fb08d97605578$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function $ee4fb08d97605578$export$604a45d95a155e2b(envelope, types) {
    return $ee4fb08d97605578$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
/**
 * Encode a string to UTF8 array.
 */ function $ee4fb08d97605578$var$encodeUTF8(input) {
    const carrier = (0, $92999225fa2a9a7f$export$c8bfa33e4e8ae492)((0, $bf3d8fd3d1ce8fc4$export$f1a6cdb1459e81d1));
    return carrier.encodePolyfill ? carrier.encodePolyfill(input) : new TextEncoder().encode(input);
}
/**
 * Decode a UTF8 array to string.
 */ function $ee4fb08d97605578$var$decodeUTF8(input) {
    const carrier = (0, $92999225fa2a9a7f$export$c8bfa33e4e8ae492)((0, $bf3d8fd3d1ce8fc4$export$f1a6cdb1459e81d1));
    return carrier.decodePolyfill ? carrier.decodePolyfill(input) : new TextDecoder().decode(input);
}
/**
 * Serializes an envelope.
 */ function $ee4fb08d97605578$export$32f9b428425aac85(envelope) {
    const [envHeaders, items] = envelope;
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === "string") parts = typeof next === "string" ? parts + next : [
            $ee4fb08d97605578$var$encodeUTF8(parts),
            next
        ];
        else parts.push(typeof next === "string" ? $ee4fb08d97605578$var$encodeUTF8(next) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`\n${JSON.stringify(itemHeaders)}\n`);
        if (typeof payload === "string" || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch (e) {
                // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.stringify()` still
                // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                // performance impact but in this case a performance hit is better than throwing.
                stringifiedPayload = JSON.stringify((0, $b661d102b0d864f7$export$a3295358bff77e)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === "string" ? parts : $ee4fb08d97605578$var$concatBuffers(parts);
}
function $ee4fb08d97605578$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
/**
 * Parses an envelope
 */ function $ee4fb08d97605578$export$3338d0c7b6e17a2b(env) {
    let buffer = typeof env === "string" ? $ee4fb08d97605578$var$encodeUTF8(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse($ee4fb08d97605578$var$decodeUTF8(readBinary(i)));
    }
    const envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === "number" ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates envelope item for a single span
 */ function $ee4fb08d97605578$export$655cf139bc8b8afd(spanJson) {
    const spanHeaders = {
        type: "span"
    };
    return [
        spanHeaders,
        spanJson
    ];
}
/**
 * Creates attachment envelope items
 */ function $ee4fb08d97605578$export$d8fc80952cc31fa4(attachment) {
    const buffer = typeof attachment.data === "string" ? $ee4fb08d97605578$var$encodeUTF8(attachment.data) : attachment.data;
    return [
        {
            type: "attachment",
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        },
        buffer
    ];
}
const $ee4fb08d97605578$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
    session: "session",
    sessions: "session",
    attachment: "attachment",
    transaction: "transaction",
    event: "error",
    client_report: "internal",
    user_report: "default",
    profile: "profile",
    profile_chunk: "profile",
    replay_event: "replay",
    replay_recording: "replay",
    check_in: "monitor",
    feedback: "feedback",
    span: "span",
    raw_security: "security",
    log: "log_item"
};
/**
 * Maps the type of an envelope item to a data category.
 */ function $ee4fb08d97605578$export$b11169581eeaf237(type) {
    return $ee4fb08d97605578$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}
/** Extracts the minimal SDK info from the metadata or an events */ function $ee4fb08d97605578$export$d369f3b2758f6743(metadataOrEvent) {
    if (!metadataOrEvent?.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function $ee4fb08d97605578$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    const dynamicSamplingContext = event.sdkProcessingMetadata?.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $1051dd8b7d8de41f$export$44d472fbb931a776)(dsn)
        },
        ...dynamicSamplingContext && {
            trace: dynamicSamplingContext
        }
    };
}

/**
 * Heavily simplified debounce function based on lodash.debounce.
 *
 * This function takes a callback function (@param fun) and delays its invocation
 * by @param wait milliseconds. Optionally, a maxWait can be specified in @param options,
 * which ensures that the callback is invoked at least once after the specified max. wait time.
 *
 * @param func the function whose invocation is to be debounced
 * @param wait the minimum time until the function is invoked after it was called once
 * @param options the options object, which can contain the `maxWait` property
 *
 * @returns the debounced version of the function, which needs to be called at least once to start the
 *          debouncing process. Subsequent calls will reset the debouncing timer and, in case @paramfunc
 *          was already invoked in the meantime, return @param func's return value.
 *          The debounced function has two additional properties:
 *          - `flush`: Invokes the debounced function immediately and returns its return value
 *          - `cancel`: Cancels the debouncing process and resets the debouncing timer
 */ function $265204be4a2cf165$export$61fc7d43ac8f84b0(func, wait, options) {
    let callbackReturnValue;
    let timerId;
    let maxTimerId;
    const maxWait = options?.maxWait ? Math.max(options.maxWait, wait) : 0;
    const setTimeoutImpl = options?.setTimeoutImpl || setTimeout;
    function invokeFunc() {
        cancelTimers();
        callbackReturnValue = func();
        return callbackReturnValue;
    }
    function cancelTimers() {
        timerId !== undefined && clearTimeout(timerId);
        maxTimerId !== undefined && clearTimeout(maxTimerId);
        timerId = maxTimerId = undefined;
    }
    function flush() {
        if (timerId !== undefined || maxTimerId !== undefined) return invokeFunc();
        return callbackReturnValue;
    }
    function debounced() {
        if (timerId) clearTimeout(timerId);
        timerId = setTimeoutImpl(invokeFunc, wait);
        if (maxWait && maxTimerId === undefined) maxTimerId = setTimeoutImpl(invokeFunc, maxWait);
        return callbackReturnValue;
    }
    debounced.cancel = cancelTimers;
    debounced.flush = flush;
    return debounced;
}


var $kxQjj = parcelRequire("kxQjj");

/**
 * Returns true if we are in the browser.
 */ function $4b7f9433b4245a20$export$4e09c449d6c407f7() {
    // eslint-disable-next-line no-restricted-globals
    return typeof window !== "undefined" && (!(0, $kxQjj.isNodeEnv)() || $4b7f9433b4245a20$var$isElectronNodeRenderer());
}
// Electron renderers with nodeIntegration enabled are detected as Node.js so we specifically test for them
function $4b7f9433b4245a20$var$isElectronNodeRenderer() {
    const process = (0, $bf3d8fd3d1ce8fc4$export$f1a6cdb1459e81d1).process;
    return process?.type === "renderer";
}

// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend
const $3d4033f4c6918770$export$b09ce39faaeb1e7c = 60000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */ function $3d4033f4c6918770$export$615352e17ed7741(header, now = Date.now()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $3d4033f4c6918770$export$b09ce39faaeb1e7c;
}
/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */ function $3d4033f4c6918770$export$b89fc7b2e4c799e7(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */ function $3d4033f4c6918770$export$6c91fec22056810a(limits, dataCategory, now = Date.now()) {
    return $3d4033f4c6918770$export$b89fc7b2e4c799e7(limits, dataCategory) > now;
}
/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */ function $3d4033f4c6918770$export$699aff705e0d49d4(limits, { statusCode: statusCode, headers: headers }, now = Date.now()) {
    const updatedRateLimits = {
        ...limits
    };
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    const rateLimitHeader = headers?.["x-sentry-rate-limits"];
    const retryAfterHeader = headers?.["retry-after"];
    if (rateLimitHeader) /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>: <namespaces>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     *     <namespaces> Semicolon-separated list of metric namespace identifiers. Defines which namespace(s) will be affected.
     *         Only present if rate limit applies to the metric_bucket data category.
     */ for (const limit of rateLimitHeader.trim().split(",")){
        const [retryAfter, categories, , , namespaces] = limit.split(":", 5);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(";")){
            if (category === "metric_bucket") // namespaces will be present when category === 'metric_bucket'
            {
                if (!namespaces || namespaces.split(";").includes("custom")) updatedRateLimits[category] = now + delay;
            } else updatedRateLimits[category] = now + delay;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $3d4033f4c6918770$export$615352e17ed7741(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}

/**
 * Checks whether given url points to Sentry server
 *
 * @param url url to verify
 */ function $58c2736742858a43$export$d92e61f5600202af(url, client) {
    const dsn = client?.getDsn();
    const tunnel = client?.getOptions().tunnel;
    return $58c2736742858a43$var$checkDsn(url, dsn) || $58c2736742858a43$var$checkTunnel(url, tunnel);
}
function $58c2736742858a43$var$checkTunnel(url, tunnel) {
    if (!tunnel) return false;
    return $58c2736742858a43$var$removeTrailingSlash(url) === $58c2736742858a43$var$removeTrailingSlash(tunnel);
}
function $58c2736742858a43$var$checkDsn(url, dsn) {
    return dsn ? url.includes(dsn.host) : false;
}
function $58c2736742858a43$var$removeTrailingSlash(str) {
    return str[str.length - 1] === "/" ? str.slice(0, -1) : str;
}

/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ function $3f81f76ce20091af$export$d771ef054122c30a(level) {
    return level === "warn" ? "warning" : [
        "fatal",
        "error",
        "warning",
        "log",
        "info",
        "debug"
    ].includes(level) ? level : "log";
}





const $be771ae5ccf70d8d$var$getRating = (value, thresholds)=>{
    if (value > thresholds[1]) return "poor";
    if (value > thresholds[0]) return "needs-improvement";
    return "good";
};
const $be771ae5ccf70d8d$export$17679dccdd551979 = (callback, metric, thresholds, reportAllChanges)=>{
    let prevValue;
    let delta;
    return (forceReport)=>{
        if (metric.value >= 0) {
            if (forceReport || reportAllChanges) {
                delta = metric.value - (prevValue ?? 0);
                // Report the metric if there's a non-zero delta or if no previous
                // value exists (which can happen in the case of the document becoming
                // hidden when the metric value is 0).
                // See: https://github.com/GoogleChrome/web-vitals/issues/14
                if (delta || prevValue === undefined) {
                    prevValue = metric.value;
                    metric.delta = delta;
                    metric.rating = $be771ae5ccf70d8d$var$getRating(metric.value, thresholds);
                    callback(metric);
                }
            }
        }
    };
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Performantly generate a unique, 30-char string by combining a version
 * number, the current timestamp with a 13-digit number integer.
 * @return {string}
 */ const $54f077e0576ea0c1$export$407ea409d1f3b539 = ()=>{
    return `v5-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`;
};



/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // sentry-specific change:
// add optional param to not check for responseStart (see comment below)
const $093b1175f041d1f7$export$6431553786c94949 = (checkResponseStart = true)=>{
    const navigationEntry = (0, $40dc3e9cd8295a99$export$56d8a8a25bd48b81).performance?.getEntriesByType?.("navigation")[0];
    // Check to ensure the `responseStart` property is present and valid.
    // In some cases a zero value is reported by the browser (for
    // privacy/security reasons), and in other cases (bugs) the value is
    // negative or is larger than the current page time. Ignore these cases:
    // - https://github.com/GoogleChrome/web-vitals/issues/137
    // - https://github.com/GoogleChrome/web-vitals/issues/162
    // - https://github.com/GoogleChrome/web-vitals/issues/275
    if (// sentry-specific change:
    // We don't want to check for responseStart for our own use of `getNavigationEntry`
    !checkResponseStart || navigationEntry && navigationEntry.responseStart > 0 && navigationEntry.responseStart < performance.now()) return navigationEntry;
};


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $37e15f2d09cb930e$export$d3e828b3c7b5b845 = ()=>{
    const navEntry = (0, $093b1175f041d1f7$export$6431553786c94949)();
    return navEntry?.activationStart ?? 0;
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $ff6be072a62a54dc$export$3c29b44508a0612b = (name, value = -1)=>{
    const navEntry = (0, $093b1175f041d1f7$export$6431553786c94949)();
    let navigationType = "navigate";
    if (navEntry) {
        if ((0, $40dc3e9cd8295a99$export$56d8a8a25bd48b81).document?.prerendering || (0, $37e15f2d09cb930e$export$d3e828b3c7b5b845)() > 0) navigationType = "prerender";
        else if ((0, $40dc3e9cd8295a99$export$56d8a8a25bd48b81).document?.wasDiscarded) navigationType = "restore";
        else if (navEntry.type) navigationType = navEntry.type.replace(/_/g, "-");
    }
    // Use `entries` type specific for the metric.
    const entries = [];
    return {
        name: name,
        value: value,
        rating: "good",
        delta: 0,
        entries: entries,
        id: (0, $54f077e0576ea0c1$export$407ea409d1f3b539)(),
        navigationType: navigationType
    };
};


/*
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $2e0ac973457cd28a$var$instanceMap = new WeakMap();
/**
 * A function that accepts and identity object and a class object and returns
 * either a new instance of that class or an existing instance, if the
 * identity object was previously used.
 */ function $2e0ac973457cd28a$export$7c74c9b2462ddb3c(identityObj, ClassObj) {
    if (!$2e0ac973457cd28a$var$instanceMap.get(identityObj)) $2e0ac973457cd28a$var$instanceMap.set(identityObj, new ClassObj());
    return $2e0ac973457cd28a$var$instanceMap.get(identityObj);
}


/* eslint-disable jsdoc/require-jsdoc */ /*
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $33351f1a899f0d68$export$4050f7f955e19aa0 {
    constructor(){
        $33351f1a899f0d68$export$4050f7f955e19aa0.prototype.__init.call(this);
        $33351f1a899f0d68$export$4050f7f955e19aa0.prototype.__init2.call(this);
    }
    // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
    // eslint-disable-next-line @sentry-internal/sdk/no-class-field-initializers, @typescript-eslint/explicit-member-accessibility
    __init() {
        this._sessionValue = 0;
    }
    // eslint-disable-next-line @sentry-internal/sdk/no-class-field-initializers, @typescript-eslint/explicit-member-accessibility
    __init2() {
        this._sessionEntries = [];
    }
    // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
    _processEntry(entry) {
        // Only count layout shifts without recent user input.
        if (entry.hadRecentInput) return;
        const firstSessionEntry = this._sessionEntries[0];
        // This previously used `this._sessionEntries.at(-1)` but that is ES2022. We support ES2021 and earlier.
        const lastSessionEntry = this._sessionEntries[this._sessionEntries.length - 1];
        // If the entry occurred less than 1 second after the previous entry
        // and less than 5 seconds after the first entry in the session,
        // include the entry in the current session. Otherwise, start a new
        // session.
        if (this._sessionValue && firstSessionEntry && lastSessionEntry && entry.startTime - lastSessionEntry.startTime < 1000 && entry.startTime - firstSessionEntry.startTime < 5000) {
            this._sessionValue += entry.value;
            this._sessionEntries.push(entry);
        } else {
            this._sessionValue = entry.value;
            this._sessionEntries = [
                entry
            ];
        }
        this._onAfterProcessingUnexpectedShift?.(entry);
    }
}


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Takes a performance entry type and a callback function, and creates a
 * `PerformanceObserver` instance that will observe the specified entry type
 * with buffering enabled and call the callback _for each entry_.
 *
 * This function also feature-detects entry support and wraps the logic in a
 * try/catch to avoid errors in unsupporting browsers.
 */ const $942c690a126f7cd9$export$d1203567a167490e = (type, callback, opts = {})=>{
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(type)) {
            const po = new PerformanceObserver((list)=>{
                // Delay by a microtask to workaround a bug in Safari where the
                // callback is invoked immediately, rather than in a separate task.
                // See: https://github.com/GoogleChrome/web-vitals/issues/277
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                Promise.resolve().then(()=>{
                    callback(list.getEntries());
                });
            });
            po.observe({
                type: type,
                buffered: true,
                ...opts
            });
            return po;
        }
    } catch  {
    // Do nothing.
    }
    return;
};


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $2c7756a82aeee7b0$export$b841d51e31c12bab = (cb)=>{
    let called = false;
    return ()=>{
        if (!called) {
            cb();
            called = true;
        }
    };
};






/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $113b85067c2fe4f7$var$firstHiddenTime = -1;
const $113b85067c2fe4f7$var$initHiddenTime = ()=>{
    // If the document is hidden when this code runs, assume it was always
    // hidden and the page was loaded in the background, with the one exception
    // that visibility state is always 'hidden' during prerendering, so we have
    // to ignore that case until prerendering finishes (see: `prerenderingchange`
    // event logic below).
    return (0, $40dc3e9cd8295a99$export$56d8a8a25bd48b81).document?.visibilityState === "hidden" && !(0, $40dc3e9cd8295a99$export$56d8a8a25bd48b81).document?.prerendering ? 0 : Infinity;
};
const $113b85067c2fe4f7$var$onVisibilityUpdate = (event)=>{
    // If the document is 'hidden' and no previous hidden timestamp has been
    // set, update it based on the current event data.
    if ((0, $40dc3e9cd8295a99$export$56d8a8a25bd48b81).document.visibilityState === "hidden" && $113b85067c2fe4f7$var$firstHiddenTime > -1) {
        // If the event is a 'visibilitychange' event, it means the page was
        // visible prior to this change, so the event timestamp is the first
        // hidden time.
        // However, if the event is not a 'visibilitychange' event, then it must
        // be a 'prerenderingchange' event, and the fact that the document is
        // still 'hidden' from the above check means the tab was activated
        // in a background state and so has always been hidden.
        $113b85067c2fe4f7$var$firstHiddenTime = event.type === "visibilitychange" ? event.timeStamp : 0;
        // Remove all listeners now that a `firstHiddenTime` value has been set.
        $113b85067c2fe4f7$var$removeChangeListeners();
    }
};
const $113b85067c2fe4f7$var$addChangeListeners = ()=>{
    addEventListener("visibilitychange", $113b85067c2fe4f7$var$onVisibilityUpdate, true);
    // IMPORTANT: when a page is prerendering, its `visibilityState` is
    // 'hidden', so in order to account for cases where this module checks for
    // visibility during prerendering, an additional check after prerendering
    // completes is also required.
    addEventListener("prerenderingchange", $113b85067c2fe4f7$var$onVisibilityUpdate, true);
};
const $113b85067c2fe4f7$var$removeChangeListeners = ()=>{
    removeEventListener("visibilitychange", $113b85067c2fe4f7$var$onVisibilityUpdate, true);
    removeEventListener("prerenderingchange", $113b85067c2fe4f7$var$onVisibilityUpdate, true);
};
const $113b85067c2fe4f7$export$443f86b2c77012c4 = ()=>{
    if ((0, $40dc3e9cd8295a99$export$56d8a8a25bd48b81).document && $113b85067c2fe4f7$var$firstHiddenTime < 0) {
        // Check if we have a previous hidden `visibility-state` performance entry.
        const activationStart = (0, $37e15f2d09cb930e$export$d3e828b3c7b5b845)();
        const firstVisibilityStateHiddenTime = !(0, $40dc3e9cd8295a99$export$56d8a8a25bd48b81).document.prerendering ? globalThis.performance.getEntriesByType("visibility-state").filter((e)=>e.name === "hidden" && e.startTime > activationStart)[0]?.startTime : undefined;
        // Prefer that, but if it's not available and the document is hidden when
        // this code runs, assume it was hidden since navigation start. This isn't
        // a perfect heuristic, but it's the best we can do until the
        // `visibility-state` performance entry becomes available in all browsers.
        $113b85067c2fe4f7$var$firstHiddenTime = firstVisibilityStateHiddenTime ?? $113b85067c2fe4f7$var$initHiddenTime();
        // We're still going to listen to for changes so we can handle things like
        // bfcache restores and/or prerender without having to examine individual
        // timestamps in detail.
        $113b85067c2fe4f7$var$addChangeListeners();
    }
    return {
        get firstHiddenTime () {
            return $113b85067c2fe4f7$var$firstHiddenTime;
        }
    };
};





/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $d7512ade3669dd6e$export$8bdb38a5671b594e = (callback)=>{
    if ((0, $40dc3e9cd8295a99$export$56d8a8a25bd48b81).document?.prerendering) addEventListener("prerenderingchange", ()=>callback(), true);
    else callback();
};


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for FCP. See https://web.dev/articles/fcp#what_is_a_good_fcp_score */ const $10e8ba14ad9c6454$export$e610c735b5510cec = [
    1800,
    3000
];
/**
 * Calculates the [FCP](https://web.dev/articles/fcp) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `paint` performance entry used to determine the value. The reported
 * value is a `DOMHighResTimeStamp`.
 */ const $10e8ba14ad9c6454$export$fe3c86b74e15d5de = (onReport, opts = {})=>{
    (0, $d7512ade3669dd6e$export$8bdb38a5671b594e)(()=>{
        const visibilityWatcher = (0, $113b85067c2fe4f7$export$443f86b2c77012c4)();
        const metric = (0, $ff6be072a62a54dc$export$3c29b44508a0612b)("FCP");
        let report;
        const handleEntries = (entries)=>{
            for (const entry of entries)if (entry.name === "first-contentful-paint") {
                po.disconnect();
                // Only report if the page wasn't hidden prior to the first paint.
                if (entry.startTime < visibilityWatcher.firstHiddenTime) {
                    // The activationStart reference is used because FCP should be
                    // relative to page activation rather than navigation start if the
                    // page was prerendered. But in cases where `activationStart` occurs
                    // after the FCP, this time should be clamped at 0.
                    metric.value = Math.max(entry.startTime - (0, $37e15f2d09cb930e$export$d3e828b3c7b5b845)(), 0);
                    metric.entries.push(entry);
                    report(true);
                }
            }
        };
        const po = (0, $942c690a126f7cd9$export$d1203567a167490e)("paint", handleEntries);
        if (po) report = (0, $be771ae5ccf70d8d$export$17679dccdd551979)(onReport, metric, $10e8ba14ad9c6454$export$e610c735b5510cec, opts.reportAllChanges);
    });
};


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for CLS. See https://web.dev/articles/cls#what_is_a_good_cls_score */ const $2922e20f372bb8fe$export$3f20d8e089ac35b2 = [
    0.1,
    0.25
];
/**
 * Calculates the [CLS](https://web.dev/articles/cls) value for the current page and
 * calls the `callback` function once the value is ready to be reported, along
 * with all `layout-shift` performance entries that were used in the metric
 * value calculation. The reported value is a `double` (corresponding to a
 * [layout shift score](https://web.dev/articles/cls#layout_shift_score)).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** CLS should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $2922e20f372bb8fe$export$a7873055838e5ad8 = (onReport, opts = {})=>{
    // Start monitoring FCP so we can only report CLS if FCP is also reported.
    // Note: this is done to match the current behavior of CrUX.
    (0, $10e8ba14ad9c6454$export$fe3c86b74e15d5de)((0, $2c7756a82aeee7b0$export$b841d51e31c12bab)(()=>{
        const metric = (0, $ff6be072a62a54dc$export$3c29b44508a0612b)("CLS", 0);
        let report;
        const layoutShiftManager = (0, $2e0ac973457cd28a$export$7c74c9b2462ddb3c)(opts, (0, $33351f1a899f0d68$export$4050f7f955e19aa0));
        const handleEntries = (entries)=>{
            for (const entry of entries)layoutShiftManager._processEntry(entry);
            // If the current session value is larger than the current CLS value,
            // update CLS and the entries contributing to it.
            if (layoutShiftManager._sessionValue > metric.value) {
                metric.value = layoutShiftManager._sessionValue;
                metric.entries = layoutShiftManager._sessionEntries;
                report();
            }
        };
        const po = (0, $942c690a126f7cd9$export$d1203567a167490e)("layout-shift", handleEntries);
        if (po) {
            report = (0, $be771ae5ccf70d8d$export$17679dccdd551979)(onReport, metric, $2922e20f372bb8fe$export$3f20d8e089ac35b2, opts.reportAllChanges);
            (0, $40dc3e9cd8295a99$export$56d8a8a25bd48b81).document?.addEventListener("visibilitychange", ()=>{
                if ((0, $40dc3e9cd8295a99$export$56d8a8a25bd48b81).document?.visibilityState === "hidden") {
                    handleEntries(po.takeRecords());
                    report(true);
                }
            });
            // Queue a task to report (if nothing else triggers a report first).
            // This allows CLS to be reported as soon as FCP fires when
            // `reportAllChanges` is true.
            (0, $40dc3e9cd8295a99$export$56d8a8a25bd48b81)?.setTimeout?.(report);
        }
    }));
};







/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Sentry-specific change:
// This function's logic was NOT updated to web-vitals 4.2.4 or 5.x but we continue
// to use the web-vitals 3.5.2 versiondue to us having stricter browser support.
// PR with context that made the changes: https://github.com/GoogleChrome/web-vitals/pull/442/files#r1530492402
// The PR removed listening to the `pagehide` event, in favour of only listening to `visibilitychange` event.
// This is "more correct" but some browsers we still support (Safari <14.4) don't fully support `visibilitychange`
// or have known bugs w.r.t the `visibilitychange` event.
// TODO (v10): If we decide to drop support for Safari 14.4, we can use the logic from web-vitals 4.2.4
// In this case, we also need to update the integration tests that currently trigger the `pagehide` event to
// simulate the page being hidden.
const $5e78ab7c1ebb2703$export$91ec2be6fdd8f1b4 = (cb)=>{
    const onHiddenOrPageHide = (event)=>{
        if (event.type === "pagehide" || (0, $40dc3e9cd8295a99$export$56d8a8a25bd48b81).document?.visibilityState === "hidden") cb(event);
    };
    if ((0, $40dc3e9cd8295a99$export$56d8a8a25bd48b81).document) {
        addEventListener("visibilitychange", onHiddenOrPageHide, true);
        // Some browsers have buggy implementations of visibilitychange,
        // so we use pagehide in addition, just to be safe.
        addEventListener("pagehide", onHiddenOrPageHide, true);
    }
};




/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * // Sentry: web-vitals removed FID reporting from v5. We're keeping it around
 * for the time being.
 * // TODO(v10): Remove FID reporting!
 */ /** Thresholds for FID. See https://web.dev/articles/fid#what_is_a_good_fid_score */ const $6c5eac632aa926b7$export$8f7f3c48ca6fbe34 = [
    100,
    300
];
/**
 * Calculates the [FID](https://web.dev/articles/fid) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `first-input` performance entry used to determine the value. The
 * reported value is a `DOMHighResTimeStamp`.
 *
 * _**Important:** since FID is only reported after the user interacts with the
 * page, it's possible that it will not be reported for some page loads._
 */ const $6c5eac632aa926b7$export$39705a25c49af873 = (onReport, opts = {})=>{
    (0, $d7512ade3669dd6e$export$8bdb38a5671b594e)(()=>{
        const visibilityWatcher = (0, $113b85067c2fe4f7$export$443f86b2c77012c4)();
        const metric = (0, $ff6be072a62a54dc$export$3c29b44508a0612b)("FID");
        // eslint-disable-next-line prefer-const
        let report;
        const handleEntry = (entry)=>{
            // Only report if the page wasn't hidden prior to the first input.
            if (entry.startTime < visibilityWatcher.firstHiddenTime) {
                metric.value = entry.processingStart - entry.startTime;
                metric.entries.push(entry);
                report(true);
            }
        };
        const handleEntries = (entries)=>{
            entries.forEach(handleEntry);
        };
        const po = (0, $942c690a126f7cd9$export$d1203567a167490e)("first-input", handleEntries);
        report = (0, $be771ae5ccf70d8d$export$17679dccdd551979)(onReport, metric, $6c5eac632aa926b7$export$8f7f3c48ca6fbe34, opts.reportAllChanges);
        if (po) // sentry: TODO: Figure out if we can use new whinIdleOrHidden insteard of onHidden
        (0, $5e78ab7c1ebb2703$export$91ec2be6fdd8f1b4)((0, $2c7756a82aeee7b0$export$b841d51e31c12bab)(()=>{
            handleEntries(po.takeRecords());
            po.disconnect();
        }));
    });
};






/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $3482050d138c7077$var$interactionCountEstimate = 0;
let $3482050d138c7077$var$minKnownInteractionId = Infinity;
let $3482050d138c7077$var$maxKnownInteractionId = 0;
const $3482050d138c7077$var$updateEstimate = (entries)=>{
    entries.forEach((e)=>{
        if (e.interactionId) {
            $3482050d138c7077$var$minKnownInteractionId = Math.min($3482050d138c7077$var$minKnownInteractionId, e.interactionId);
            $3482050d138c7077$var$maxKnownInteractionId = Math.max($3482050d138c7077$var$maxKnownInteractionId, e.interactionId);
            $3482050d138c7077$var$interactionCountEstimate = $3482050d138c7077$var$maxKnownInteractionId ? ($3482050d138c7077$var$maxKnownInteractionId - $3482050d138c7077$var$minKnownInteractionId) / 7 + 1 : 0;
        }
    });
};
let $3482050d138c7077$var$po;
/**
 * Returns the `interactionCount` value using the native API (if available)
 * or the polyfill estimate in this module.
 */ const $3482050d138c7077$export$8a962f2683a476d1 = ()=>{
    return $3482050d138c7077$var$po ? $3482050d138c7077$var$interactionCountEstimate : performance.interactionCount || 0;
};
/**
 * Feature detects native support or initializes the polyfill if needed.
 */ const $3482050d138c7077$export$67d90cda6b78a2eb = ()=>{
    if ("interactionCount" in performance || $3482050d138c7077$var$po) return;
    $3482050d138c7077$var$po = (0, $942c690a126f7cd9$export$d1203567a167490e)("event", $3482050d138c7077$var$updateEstimate, {
        type: "event",
        buffered: true,
        durationThreshold: 0
    });
};


/*
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // To prevent unnecessary memory usage on pages with lots of interactions,
// store at most 10 of the longest interactions to consider as INP candidates.
const $632ce28a879a25db$var$MAX_INTERACTIONS_TO_CONSIDER = 10;
// Used to store the interaction count after a bfcache restore, since p98
// interaction latencies should only consider the current navigation.
let $632ce28a879a25db$var$prevInteractionCount = 0;
/**
 * Returns the interaction count since the last bfcache restore (or for the
 * full page lifecycle if there were no bfcache restores).
 */ const $632ce28a879a25db$var$getInteractionCountForNavigation = ()=>{
    return (0, $3482050d138c7077$export$8a962f2683a476d1)() - $632ce28a879a25db$var$prevInteractionCount;
};
/**
 *
 */ class $632ce28a879a25db$export$aaa80641d584351c {
    constructor(){
        $632ce28a879a25db$export$aaa80641d584351c.prototype.__init.call(this);
        $632ce28a879a25db$export$aaa80641d584351c.prototype.__init2.call(this);
    }
    /**
   * A list of longest interactions on the page (by latency) sorted so the
   * longest one is first. The list is at most MAX_INTERACTIONS_TO_CONSIDER
   * long.
   */ // eslint-disable-next-line @sentry-internal/sdk/no-class-field-initializers, @typescript-eslint/explicit-member-accessibility
    __init() {
        this._longestInteractionList = [];
    }
    /**
   * A mapping of longest interactions by their interaction ID.
   * This is used for faster lookup.
   */ // eslint-disable-next-line @sentry-internal/sdk/no-class-field-initializers, @typescript-eslint/explicit-member-accessibility
    __init2() {
        this._longestInteractionMap = new Map();
    }
    // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
    // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
    // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility, jsdoc/require-jsdoc
    _resetInteractions() {
        $632ce28a879a25db$var$prevInteractionCount = (0, $3482050d138c7077$export$8a962f2683a476d1)();
        this._longestInteractionList.length = 0;
        this._longestInteractionMap.clear();
    }
    /**
   * Returns the estimated p98 longest interaction based on the stored
   * interaction candidates and the interaction count for the current page.
   */ // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
    _estimateP98LongestInteraction() {
        const candidateInteractionIndex = Math.min(this._longestInteractionList.length - 1, Math.floor($632ce28a879a25db$var$getInteractionCountForNavigation() / 50));
        return this._longestInteractionList[candidateInteractionIndex];
    }
    /**
   * Takes a performance entry and adds it to the list of worst interactions
   * if its duration is long enough to make it among the worst. If the
   * entry is part of an existing interaction, it is merged and the latency
   * and entries list is updated as needed.
   */ // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
    _processEntry(entry) {
        this._onBeforeProcessingEntry?.(entry);
        // Skip further processing for entries that cannot be INP candidates.
        if (!(entry.interactionId || entry.entryType === "first-input")) return;
        // The least-long of the 10 longest interactions.
        const minLongestInteraction = this._longestInteractionList.at(-1);
        let interaction = this._longestInteractionMap.get(entry.interactionId);
        // Only process the entry if it's possibly one of the ten longest,
        // or if it's part of an existing interaction.
        if (interaction || this._longestInteractionList.length < $632ce28a879a25db$var$MAX_INTERACTIONS_TO_CONSIDER || // If the above conditions are false, `minLongestInteraction` will be set.
        entry.duration > minLongestInteraction._latency) {
            // If the interaction already exists, update it. Otherwise create one.
            if (interaction) {
                // If the new entry has a longer duration, replace the old entries,
                // otherwise add to the array.
                if (entry.duration > interaction._latency) {
                    interaction.entries = [
                        entry
                    ];
                    interaction._latency = entry.duration;
                } else if (entry.duration === interaction._latency && entry.startTime === interaction.entries[0].startTime) interaction.entries.push(entry);
            } else {
                interaction = {
                    id: entry.interactionId,
                    entries: [
                        entry
                    ],
                    _latency: entry.duration
                };
                this._longestInteractionMap.set(interaction.id, interaction);
                this._longestInteractionList.push(interaction);
            }
            // Sort the entries by latency (descending) and keep only the top ten.
            this._longestInteractionList.sort((a, b)=>b._latency - a._latency);
            if (this._longestInteractionList.length > $632ce28a879a25db$var$MAX_INTERACTIONS_TO_CONSIDER) {
                const removedInteractions = this._longestInteractionList.splice($632ce28a879a25db$var$MAX_INTERACTIONS_TO_CONSIDER);
                for (const interaction of removedInteractions)this._longestInteractionMap.delete(interaction.id);
            }
            // Call any post-processing on the interaction
            this._onAfterProcessingINPCandidate?.(interaction);
        }
    }
}









/*
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Runs the passed callback during the next idle period, or immediately
 * if the browser's visibility state is (or becomes) hidden.
 */ const $72e5373f34ae2e46$export$d3314d5863fc1fef = (cb)=>{
    const rIC = (0, $40dc3e9cd8295a99$export$56d8a8a25bd48b81).requestIdleCallback || (0, $40dc3e9cd8295a99$export$56d8a8a25bd48b81).setTimeout;
    // If the document is hidden, run the callback immediately, otherwise
    // race an idle callback with the next `visibilitychange` event.
    if ((0, $40dc3e9cd8295a99$export$56d8a8a25bd48b81).document?.visibilityState === "hidden") cb();
    else {
        // eslint-disable-next-line no-param-reassign
        cb = (0, $2c7756a82aeee7b0$export$b841d51e31c12bab)(cb);
        rIC(cb);
        // sentry: we use onHidden instead of directly listening to visibilitychange
        // because some browsers we still support (Safari <14.4) don't fully support
        // `visibilitychange` or have known bugs w.r.t the `visibilitychange` event.
        (0, $5e78ab7c1ebb2703$export$91ec2be6fdd8f1b4)(cb);
    }
};


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for INP. See https://web.dev/articles/inp#what_is_a_good_inp_score */ const $d0cfb99b0d71b47d$export$7f4cb060ded9173c = [
    200,
    500
];
// The default `durationThreshold` used across this library for observing
// `event` entries via PerformanceObserver.
const $d0cfb99b0d71b47d$var$DEFAULT_DURATION_THRESHOLD = 40;
/**
 * Calculates the [INP](https://web.dev/articles/inp) value for the current
 * page and calls the `callback` function once the value is ready, along with
 * the `event` performance entries reported for that interaction. The reported
 * value is a `DOMHighResTimeStamp`.
 *
 * A custom `durationThreshold` configuration option can optionally be passed
 * to control what `event-timing` entries are considered for INP reporting. The
 * default threshold is `40`, which means INP scores of less than 40 will not
 * be reported. To avoid reporting no interactions in these cases, the library
 * will fall back to the input delay of the first interaction. Note that this
 * will not affect your 75th percentile INP value unless that value is also
 * less than 40 (well below the recommended
 * [good](https://web.dev/articles/inp#what_is_a_good_inp_score) threshold).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** INP should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $d0cfb99b0d71b47d$export$7df4b36ecaed99e1 = (onReport, opts = {})=>{
    // Return if the browser doesn't support all APIs needed to measure INP.
    if (!(globalThis.PerformanceEventTiming && "interactionId" in PerformanceEventTiming.prototype)) return;
    (0, $d7512ade3669dd6e$export$8bdb38a5671b594e)(()=>{
        // TODO(philipwalton): remove once the polyfill is no longer needed.
        (0, $3482050d138c7077$export$67d90cda6b78a2eb)();
        const metric = (0, $ff6be072a62a54dc$export$3c29b44508a0612b)("INP");
        // eslint-disable-next-line prefer-const
        let report;
        const interactionManager = (0, $2e0ac973457cd28a$export$7c74c9b2462ddb3c)(opts, (0, $632ce28a879a25db$export$aaa80641d584351c));
        const handleEntries = (entries)=>{
            // Queue the `handleEntries()` callback in the next idle task.
            // This is needed to increase the chances that all event entries that
            // occurred between the user interaction and the next paint
            // have been dispatched. Note: there is currently an experiment
            // running in Chrome (EventTimingKeypressAndCompositionInteractionId)
            // 123+ that if rolled out fully may make this no longer necessary.
            (0, $72e5373f34ae2e46$export$d3314d5863fc1fef)(()=>{
                for (const entry of entries)interactionManager._processEntry(entry);
                const inp = interactionManager._estimateP98LongestInteraction();
                if (inp && inp._latency !== metric.value) {
                    metric.value = inp._latency;
                    metric.entries = inp.entries;
                    report();
                }
            });
        };
        const po = (0, $942c690a126f7cd9$export$d1203567a167490e)("event", handleEntries, {
            // Event Timing entries have their durations rounded to the nearest 8ms,
            // so a duration of 40ms would be any event that spans 2.5 or more frames
            // at 60Hz. This threshold is chosen to strike a balance between usefulness
            // and performance. Running this callback for any interaction that spans
            // just one or two frames is likely not worth the insight that could be
            // gained.
            durationThreshold: opts.durationThreshold ?? $d0cfb99b0d71b47d$var$DEFAULT_DURATION_THRESHOLD
        });
        report = (0, $be771ae5ccf70d8d$export$17679dccdd551979)(onReport, metric, $d0cfb99b0d71b47d$export$7f4cb060ded9173c, opts.reportAllChanges);
        if (po) {
            // Also observe entries of type `first-input`. This is useful in cases
            // where the first interaction is less than the `durationThreshold`.
            po.observe({
                type: "first-input",
                buffered: true
            });
            // sentry: we use onHidden instead of directly listening to visibilitychange
            // because some browsers we still support (Safari <14.4) don't fully support
            // `visibilitychange` or have known bugs w.r.t the `visibilitychange` event.
            (0, $5e78ab7c1ebb2703$export$91ec2be6fdd8f1b4)(()=>{
                handleEntries(po.takeRecords());
                report(true);
            });
        }
    });
};








/*
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // eslint-disable-next-line jsdoc/require-jsdoc
class $3d07ac6571d2bd99$export$6a641ef2a067ec62 {
    // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
    // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility, jsdoc/require-jsdoc
    _processEntry(entry) {
        this._onBeforeProcessingEntry?.(entry);
    }
}






/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for LCP. See https://web.dev/articles/lcp#what_is_a_good_lcp_score */ const $b260eb4ca11dbdc1$export$948521ca5b0e1b17 = [
    2500,
    4000
];
/**
 * Calculates the [LCP](https://web.dev/articles/lcp) value for the current page and
 * calls the `callback` function once the value is ready (along with the
 * relevant `largest-contentful-paint` performance entry used to determine the
 * value). The reported value is a `DOMHighResTimeStamp`.
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called any time a new `largest-contentful-paint`
 * performance entry is dispatched, or once the final value of the metric has
 * been determined.
 */ const $b260eb4ca11dbdc1$export$947b1626ab8d5632 = (onReport, opts = {})=>{
    (0, $d7512ade3669dd6e$export$8bdb38a5671b594e)(()=>{
        const visibilityWatcher = (0, $113b85067c2fe4f7$export$443f86b2c77012c4)();
        const metric = (0, $ff6be072a62a54dc$export$3c29b44508a0612b)("LCP");
        let report;
        const lcpEntryManager = (0, $2e0ac973457cd28a$export$7c74c9b2462ddb3c)(opts, (0, $3d07ac6571d2bd99$export$6a641ef2a067ec62));
        const handleEntries = (entries)=>{
            // If reportAllChanges is set then call this function for each entry,
            // otherwise only consider the last one.
            if (!opts.reportAllChanges) // eslint-disable-next-line no-param-reassign
            entries = entries.slice(-1);
            for (const entry of entries){
                lcpEntryManager._processEntry(entry);
                // Only report if the page wasn't hidden prior to LCP.
                if (entry.startTime < visibilityWatcher.firstHiddenTime) {
                    // The startTime attribute returns the value of the renderTime if it is
                    // not 0, and the value of the loadTime otherwise. The activationStart
                    // reference is used because LCP should be relative to page activation
                    // rather than navigation start if the page was prerendered. But in cases
                    // where `activationStart` occurs after the LCP, this time should be
                    // clamped at 0.
                    metric.value = Math.max(entry.startTime - (0, $37e15f2d09cb930e$export$d3e828b3c7b5b845)(), 0);
                    metric.entries = [
                        entry
                    ];
                    report();
                }
            }
        };
        const po = (0, $942c690a126f7cd9$export$d1203567a167490e)("largest-contentful-paint", handleEntries);
        if (po) {
            report = (0, $be771ae5ccf70d8d$export$17679dccdd551979)(onReport, metric, $b260eb4ca11dbdc1$export$948521ca5b0e1b17, opts.reportAllChanges);
            // Ensure this logic only runs once, since it can be triggered from
            // any of three different event listeners below.
            const stopListening = (0, $2c7756a82aeee7b0$export$b841d51e31c12bab)(()=>{
                handleEntries(po.takeRecords());
                po.disconnect();
                report(true);
            });
            // Stop listening after input or visibilitychange.
            // Note: while scrolling is an input that stops LCP observation, it's
            // unreliable since it can be programmatically generated.
            // See: https://github.com/GoogleChrome/web-vitals/issues/75
            for (const type of [
                "keydown",
                "click",
                "visibilitychange"
            ])// Wrap the listener in an idle callback so it's run in a separate
            // task to reduce potential INP impact.
            // https://github.com/GoogleChrome/web-vitals/issues/383
            if ((0, $40dc3e9cd8295a99$export$56d8a8a25bd48b81).document) addEventListener(type, ()=>(0, $72e5373f34ae2e46$export$d3314d5863fc1fef)(stopListening), {
                capture: true,
                once: true
            });
        }
    });
};









/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for TTFB. See https://web.dev/articles/ttfb#what_is_a_good_ttfb_score */ const $a826234bf83ce921$export$65c59ea8064668fc = [
    800,
    1800
];
/**
 * Runs in the next task after the page is done loading and/or prerendering.
 * @param callback
 */ const $a826234bf83ce921$var$whenReady = (callback)=>{
    if ((0, $40dc3e9cd8295a99$export$56d8a8a25bd48b81).document?.prerendering) (0, $d7512ade3669dd6e$export$8bdb38a5671b594e)(()=>$a826234bf83ce921$var$whenReady(callback));
    else if ((0, $40dc3e9cd8295a99$export$56d8a8a25bd48b81).document?.readyState !== "complete") addEventListener("load", ()=>$a826234bf83ce921$var$whenReady(callback), true);
    else // Queue a task so the callback runs after `loadEventEnd`.
    setTimeout(callback);
};
/**
 * Calculates the [TTFB](https://web.dev/articles/ttfb) value for the
 * current page and calls the `callback` function once the page has loaded,
 * along with the relevant `navigation` performance entry used to determine the
 * value. The reported value is a `DOMHighResTimeStamp`.
 *
 * Note, this function waits until after the page is loaded to call `callback`
 * in order to ensure all properties of the `navigation` entry are populated.
 * This is useful if you want to report on other metrics exposed by the
 * [Navigation Timing API](https://w3c.github.io/navigation-timing/). For
 * example, the TTFB metric starts from the page's [time
 * origin](https://www.w3.org/TR/hr-time-2/#sec-time-origin), which means it
 * includes time spent on DNS lookup, connection negotiation, network latency,
 * and server processing time.
 */ const $a826234bf83ce921$export$33a01e6c5f2c7e33 = (onReport, opts = {})=>{
    const metric = (0, $ff6be072a62a54dc$export$3c29b44508a0612b)("TTFB");
    const report = (0, $be771ae5ccf70d8d$export$17679dccdd551979)(onReport, metric, $a826234bf83ce921$export$65c59ea8064668fc, opts.reportAllChanges);
    $a826234bf83ce921$var$whenReady(()=>{
        const navigationEntry = (0, $093b1175f041d1f7$export$6431553786c94949)();
        if (navigationEntry) {
            // The activationStart reference is used because TTFB should be
            // relative to page activation rather than navigation start if the
            // page was prerendered. But in cases where `activationStart` occurs
            // after the first byte is received, this time should be clamped at 0.
            metric.value = Math.max(navigationEntry.responseStart - (0, $37e15f2d09cb930e$export$d3e828b3c7b5b845)(), 0);
            metric.entries = [
                navigationEntry
            ];
            report(true);
        }
    });
};


const $52f106d2c2e0344c$var$handlers = {};
const $52f106d2c2e0344c$var$instrumented = {};
let $52f106d2c2e0344c$var$_previousCls;
let $52f106d2c2e0344c$var$_previousFid;
let $52f106d2c2e0344c$var$_previousLcp;
let $52f106d2c2e0344c$var$_previousTtfb;
let $52f106d2c2e0344c$var$_previousInp;
/**
 * Add a callback that will be triggered when a CLS metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for CLS when the cleanup callback is called.
 * This will lead to the CLS being finalized and frozen.
 */ function $52f106d2c2e0344c$export$861b82818b37ba5b(callback, stopOnCallback = false) {
    return $52f106d2c2e0344c$var$addMetricObserver("cls", callback, $52f106d2c2e0344c$var$instrumentCls, $52f106d2c2e0344c$var$_previousCls, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a LCP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for LCP when the cleanup callback is called.
 * This will lead to the LCP being finalized and frozen.
 */ function $52f106d2c2e0344c$export$3fd4b53331200102(callback, stopOnCallback = false) {
    return $52f106d2c2e0344c$var$addMetricObserver("lcp", callback, $52f106d2c2e0344c$var$instrumentLcp, $52f106d2c2e0344c$var$_previousLcp, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a FID metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $52f106d2c2e0344c$export$2707d7471c0b918f(callback) {
    return $52f106d2c2e0344c$var$addMetricObserver("fid", callback, $52f106d2c2e0344c$var$instrumentFid, $52f106d2c2e0344c$var$_previousFid);
}
/**
 * Add a callback that will be triggered when a FID metric is available.
 */ function $52f106d2c2e0344c$export$699d9529c099a797(callback) {
    return $52f106d2c2e0344c$var$addMetricObserver("ttfb", callback, $52f106d2c2e0344c$var$instrumentTtfb, $52f106d2c2e0344c$var$_previousTtfb);
}
/**
 * Add a callback that will be triggered when a INP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $52f106d2c2e0344c$export$da3b76aa2022cbd7(callback) {
    return $52f106d2c2e0344c$var$addMetricObserver("inp", callback, $52f106d2c2e0344c$var$instrumentInp, $52f106d2c2e0344c$var$_previousInp);
}
/**
 * Add a callback that will be triggered when a performance observer is triggered,
 * and receives the entries of the observer.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $52f106d2c2e0344c$export$69816c1a049f8db6(type, callback) {
    $52f106d2c2e0344c$var$addHandler(type, callback);
    if (!$52f106d2c2e0344c$var$instrumented[type]) {
        $52f106d2c2e0344c$var$instrumentPerformanceObserver(type);
        $52f106d2c2e0344c$var$instrumented[type] = true;
    }
    return $52f106d2c2e0344c$var$getCleanupCallback(type, callback);
}
/** Trigger all handlers of a given type. */ function $52f106d2c2e0344c$var$triggerHandlers(type, data) {
    const typeHandlers = $52f106d2c2e0344c$var$handlers[type];
    if (!typeHandlers?.length) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $40b62dc164a5f4e4$export$16a28057038b10ef) && (0, $70cc7a497c940a25$export$af88d00dbe7f521).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $62980e96870c5f3e$export$aad197c7121a6651)(handler)}\nError:`, e);
    }
}
function $52f106d2c2e0344c$var$instrumentCls() {
    return (0, $2922e20f372bb8fe$export$a7873055838e5ad8)((metric)=>{
        $52f106d2c2e0344c$var$triggerHandlers("cls", {
            metric: metric
        });
        $52f106d2c2e0344c$var$_previousCls = metric;
    }, // We want the callback to be called whenever the CLS value updates.
    // By default, the callback is only called when the tab goes to the background.
    {
        reportAllChanges: true
    });
}
function $52f106d2c2e0344c$var$instrumentFid() {
    return (0, $6c5eac632aa926b7$export$39705a25c49af873)((metric)=>{
        $52f106d2c2e0344c$var$triggerHandlers("fid", {
            metric: metric
        });
        $52f106d2c2e0344c$var$_previousFid = metric;
    });
}
function $52f106d2c2e0344c$var$instrumentLcp() {
    return (0, $b260eb4ca11dbdc1$export$947b1626ab8d5632)((metric)=>{
        $52f106d2c2e0344c$var$triggerHandlers("lcp", {
            metric: metric
        });
        $52f106d2c2e0344c$var$_previousLcp = metric;
    }, // We want the callback to be called whenever the LCP value updates.
    // By default, the callback is only called when the tab goes to the background.
    {
        reportAllChanges: true
    });
}
function $52f106d2c2e0344c$var$instrumentTtfb() {
    return (0, $a826234bf83ce921$export$33a01e6c5f2c7e33)((metric)=>{
        $52f106d2c2e0344c$var$triggerHandlers("ttfb", {
            metric: metric
        });
        $52f106d2c2e0344c$var$_previousTtfb = metric;
    });
}
function $52f106d2c2e0344c$var$instrumentInp() {
    return (0, $d0cfb99b0d71b47d$export$7df4b36ecaed99e1)((metric)=>{
        $52f106d2c2e0344c$var$triggerHandlers("inp", {
            metric: metric
        });
        $52f106d2c2e0344c$var$_previousInp = metric;
    });
}
function $52f106d2c2e0344c$var$addMetricObserver(type, callback, instrumentFn, previousValue, stopOnCallback = false) {
    $52f106d2c2e0344c$var$addHandler(type, callback);
    let stopListening;
    if (!$52f106d2c2e0344c$var$instrumented[type]) {
        stopListening = instrumentFn();
        $52f106d2c2e0344c$var$instrumented[type] = true;
    }
    if (previousValue) callback({
        metric: previousValue
    });
    return $52f106d2c2e0344c$var$getCleanupCallback(type, callback, stopOnCallback ? stopListening : undefined);
}
function $52f106d2c2e0344c$var$instrumentPerformanceObserver(type) {
    const options = {};
    // Special per-type options we want to use
    if (type === "event") options.durationThreshold = 0;
    (0, $942c690a126f7cd9$export$d1203567a167490e)(type, (entries)=>{
        $52f106d2c2e0344c$var$triggerHandlers(type, {
            entries: entries
        });
    }, options);
}
function $52f106d2c2e0344c$var$addHandler(type, handler) {
    $52f106d2c2e0344c$var$handlers[type] = $52f106d2c2e0344c$var$handlers[type] || [];
    $52f106d2c2e0344c$var$handlers[type].push(handler);
}
// Get a callback which can be called to remove the instrumentation handler
function $52f106d2c2e0344c$var$getCleanupCallback(type, callback, stopListening) {
    return ()=>{
        if (stopListening) stopListening();
        const typeHandlers = $52f106d2c2e0344c$var$handlers[type];
        if (!typeHandlers) return;
        const index = typeHandlers.indexOf(callback);
        if (index !== -1) typeHandlers.splice(index, 1);
    };
}
/**
 * Check if a PerformanceEntry is a PerformanceEventTiming by checking for the `duration` property.
 */ function $52f106d2c2e0344c$export$7affb50b622d8714(entry) {
    return "duration" in entry;
}


// exporting a separate copy of `WINDOW` rather than exporting the one from `@sentry/browser`
// prevents the browser package from being bundled in the CDN bundle, and avoids a
// circular dependency between the browser and replay packages should `@sentry/browser` import
// from `@sentry/replay` in the future
const $2814b83f7132876d$var$WINDOW = (0, $bf3d8fd3d1ce8fc4$export$f1a6cdb1459e81d1);
const $2814b83f7132876d$var$REPLAY_SESSION_KEY = "sentryReplaySession";
const $2814b83f7132876d$var$REPLAY_EVENT_NAME = "replay_event";
const $2814b83f7132876d$var$UNABLE_TO_SEND_REPLAY = "Unable to send Replay";
// The idle limit for a session after which recording is paused.
const $2814b83f7132876d$var$SESSION_IDLE_PAUSE_DURATION = 300000; // 5 minutes in ms
// The idle limit for a session after which the session expires.
const $2814b83f7132876d$var$SESSION_IDLE_EXPIRE_DURATION = 900000; // 15 minutes in ms
/** Default flush delays */ const $2814b83f7132876d$var$DEFAULT_FLUSH_MIN_DELAY = 5000;
// XXX: Temp fix for our debounce logic where `maxWait` would never occur if it
// was the same as `wait`
const $2814b83f7132876d$var$DEFAULT_FLUSH_MAX_DELAY = 5500;
/* How long to wait for error checkouts */ const $2814b83f7132876d$var$BUFFER_CHECKOUT_TIME = 60000;
const $2814b83f7132876d$var$RETRY_BASE_INTERVAL = 5000;
const $2814b83f7132876d$var$RETRY_MAX_COUNT = 3;
/* The max (uncompressed) size in bytes of a network body. Any body larger than this will be truncated. */ const $2814b83f7132876d$var$NETWORK_BODY_MAX_SIZE = 150000;
/* The max size of a single console arg that is captured. Any arg larger than this will be truncated. */ const $2814b83f7132876d$var$CONSOLE_ARG_MAX_SIZE = 5000;
/* Min. time to wait before we consider something a slow click. */ const $2814b83f7132876d$var$SLOW_CLICK_THRESHOLD = 3000;
/* For scroll actions after a click, we only look for a very short time period to detect programmatic scrolling. */ const $2814b83f7132876d$var$SLOW_CLICK_SCROLL_TIMEOUT = 300;
/** When encountering a total segment size exceeding this size, stop the replay (as we cannot properly ingest it). */ const $2814b83f7132876d$var$REPLAY_MAX_EVENT_BUFFER_SIZE = 20000000; // ~20MB
/** Replays must be min. 5s long before we send them. */ const $2814b83f7132876d$var$MIN_REPLAY_DURATION = 4999;
/* The max. allowed value that the minReplayDuration can be set to. */ const $2814b83f7132876d$var$MIN_REPLAY_DURATION_LIMIT = 15000;
/** The max. length of a replay. */ const $2814b83f7132876d$var$MAX_REPLAY_DURATION = 3600000; // 60 minutes in ms;
var $2814b83f7132876d$var$__defProp$1 = Object.defineProperty;
var $2814b83f7132876d$var$__defNormalProp$1 = (obj, key, value)=>key in obj ? $2814b83f7132876d$var$__defProp$1(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $2814b83f7132876d$var$__publicField$1 = (obj, key, value)=>$2814b83f7132876d$var$__defNormalProp$1(obj, typeof key !== "symbol" ? key + "" : key, value);
var $2814b83f7132876d$var$NodeType$2 = /* @__PURE__ */ ((NodeType2)=>{
    NodeType2[NodeType2["Document"] = 0] = "Document";
    NodeType2[NodeType2["DocumentType"] = 1] = "DocumentType";
    NodeType2[NodeType2["Element"] = 2] = "Element";
    NodeType2[NodeType2["Text"] = 3] = "Text";
    NodeType2[NodeType2["CDATA"] = 4] = "CDATA";
    NodeType2[NodeType2["Comment"] = 5] = "Comment";
    return NodeType2;
})($2814b83f7132876d$var$NodeType$2 || {});
function $2814b83f7132876d$var$isElement$1(n2) {
    return n2.nodeType === n2.ELEMENT_NODE;
}
function $2814b83f7132876d$var$isShadowRoot(n2) {
    const host = n2?.host;
    return Boolean(host?.shadowRoot === n2);
}
function $2814b83f7132876d$var$isNativeShadowDom(shadowRoot) {
    return Object.prototype.toString.call(shadowRoot) === "[object ShadowRoot]";
}
function $2814b83f7132876d$var$fixBrowserCompatibilityIssuesInCSS(cssText) {
    if (cssText.includes(" background-clip: text;") && !cssText.includes(" -webkit-background-clip: text;")) cssText = cssText.replace(/\sbackground-clip:\s*text;/g, " -webkit-background-clip: text; background-clip: text;");
    return cssText;
}
function $2814b83f7132876d$var$escapeImportStatement(rule) {
    const { cssText: cssText } = rule;
    if (cssText.split('"').length < 3) return cssText;
    const statement = [
        "@import",
        `url(${JSON.stringify(rule.href)})`
    ];
    if (rule.layerName === "") statement.push(`layer`);
    else if (rule.layerName) statement.push(`layer(${rule.layerName})`);
    if (rule.supportsText) statement.push(`supports(${rule.supportsText})`);
    if (rule.media.length) statement.push(rule.media.mediaText);
    return statement.join(" ") + ";";
}
function $2814b83f7132876d$var$stringifyStylesheet(s2) {
    try {
        const rules2 = s2.rules || s2.cssRules;
        return rules2 ? $2814b83f7132876d$var$fixBrowserCompatibilityIssuesInCSS(Array.from(rules2, $2814b83f7132876d$var$stringifyRule).join("")) : null;
    } catch (error) {
        return null;
    }
}
function $2814b83f7132876d$var$fixAllCssProperty(rule) {
    let styles = "";
    for(let i2 = 0; i2 < rule.style.length; i2++){
        const styleDeclaration = rule.style;
        const attribute = styleDeclaration[i2];
        const isImportant = styleDeclaration.getPropertyPriority(attribute);
        styles += `${attribute}:${styleDeclaration.getPropertyValue(attribute)}${isImportant ? ` !important` : ""};`;
    }
    return `${rule.selectorText} { ${styles} }`;
}
function $2814b83f7132876d$var$stringifyRule(rule) {
    let importStringified;
    if ($2814b83f7132876d$var$isCSSImportRule(rule)) try {
        importStringified = // we can access the imported stylesheet rules directly
        $2814b83f7132876d$var$stringifyStylesheet(rule.styleSheet) || // work around browser issues with the raw string `@import url(...)` statement
        $2814b83f7132876d$var$escapeImportStatement(rule);
    } catch (error) {}
    else if ($2814b83f7132876d$var$isCSSStyleRule(rule)) {
        let cssText = rule.cssText;
        const needsSafariColonFix = rule.selectorText.includes(":");
        const needsAllFix = typeof rule.style["all"] === "string" && rule.style["all"];
        if (needsAllFix) cssText = $2814b83f7132876d$var$fixAllCssProperty(rule);
        if (needsSafariColonFix) cssText = $2814b83f7132876d$var$fixSafariColons(cssText);
        if (needsSafariColonFix || needsAllFix) return cssText;
    }
    return importStringified || rule.cssText;
}
function $2814b83f7132876d$var$fixSafariColons(cssStringified) {
    const regex = /(\[(?:[\w-]+)[^\\])(:(?:[\w-]+)\])/gm;
    return cssStringified.replace(regex, "$1\\$2");
}
function $2814b83f7132876d$var$isCSSImportRule(rule) {
    return "styleSheet" in rule;
}
function $2814b83f7132876d$var$isCSSStyleRule(rule) {
    return "selectorText" in rule;
}
class $2814b83f7132876d$var$Mirror {
    constructor(){
        $2814b83f7132876d$var$__publicField$1(this, "idNodeMap", /* @__PURE__ */ new Map());
        $2814b83f7132876d$var$__publicField$1(this, "nodeMetaMap", /* @__PURE__ */ new WeakMap());
    }
    getId(n2) {
        if (!n2) return -1;
        const id = this.getMeta(n2)?.id;
        return id ?? -1;
    }
    getNode(id) {
        return this.idNodeMap.get(id) || null;
    }
    getIds() {
        return Array.from(this.idNodeMap.keys());
    }
    getMeta(n2) {
        return this.nodeMetaMap.get(n2) || null;
    }
    // removes the node from idNodeMap
    // doesn't remove the node from nodeMetaMap
    removeNodeFromMap(n2) {
        const id = this.getId(n2);
        this.idNodeMap.delete(id);
        if (n2.childNodes) n2.childNodes.forEach((childNode)=>this.removeNodeFromMap(childNode));
    }
    has(id) {
        return this.idNodeMap.has(id);
    }
    hasNode(node) {
        return this.nodeMetaMap.has(node);
    }
    add(n2, meta) {
        const id = meta.id;
        this.idNodeMap.set(id, n2);
        this.nodeMetaMap.set(n2, meta);
    }
    replace(id, n2) {
        const oldNode = this.getNode(id);
        if (oldNode) {
            const meta = this.nodeMetaMap.get(oldNode);
            if (meta) this.nodeMetaMap.set(n2, meta);
        }
        this.idNodeMap.set(id, n2);
    }
    reset() {
        this.idNodeMap = /* @__PURE__ */ new Map();
        this.nodeMetaMap = /* @__PURE__ */ new WeakMap();
    }
}
function $2814b83f7132876d$var$createMirror$2() {
    return new $2814b83f7132876d$var$Mirror();
}
function $2814b83f7132876d$var$shouldMaskInput({ maskInputOptions: maskInputOptions, tagName: tagName, type: type }) {
    if (tagName === "OPTION") tagName = "SELECT";
    return Boolean(maskInputOptions[tagName.toLowerCase()] || type && maskInputOptions[type] || type === "password" || // Default to "text" option for inputs without a "type" attribute defined
    tagName === "INPUT" && !type && maskInputOptions["text"]);
}
function $2814b83f7132876d$var$maskInputValue({ isMasked: isMasked, element: element, value: value, maskInputFn: maskInputFn }) {
    let text = value || "";
    if (!isMasked) return text;
    if (maskInputFn) text = maskInputFn(text, element);
    return "*".repeat(text.length);
}
function $2814b83f7132876d$var$toLowerCase(str) {
    return str.toLowerCase();
}
function $2814b83f7132876d$var$toUpperCase(str) {
    return str.toUpperCase();
}
const $2814b83f7132876d$var$ORIGINAL_ATTRIBUTE_NAME = "__rrweb_original__";
function $2814b83f7132876d$var$is2DCanvasBlank(canvas) {
    const ctx = canvas.getContext("2d");
    if (!ctx) return true;
    const chunkSize = 50;
    for(let x = 0; x < canvas.width; x += chunkSize)for(let y = 0; y < canvas.height; y += chunkSize){
        const getImageData = ctx.getImageData;
        const originalGetImageData = $2814b83f7132876d$var$ORIGINAL_ATTRIBUTE_NAME in getImageData ? getImageData[$2814b83f7132876d$var$ORIGINAL_ATTRIBUTE_NAME] : getImageData;
        const pixelBuffer = new Uint32Array(// eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
        originalGetImageData.call(ctx, x, y, Math.min(chunkSize, canvas.width - x), Math.min(chunkSize, canvas.height - y)).data.buffer);
        if (pixelBuffer.some((pixel)=>pixel !== 0)) return false;
    }
    return true;
}
function $2814b83f7132876d$var$getInputType(element) {
    const type = element.type;
    return element.hasAttribute("data-rr-is-password") ? "password" : type ? // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
    $2814b83f7132876d$var$toLowerCase(type) : null;
}
function $2814b83f7132876d$var$getInputValue(el, tagName, type) {
    if (tagName === "INPUT" && (type === "radio" || type === "checkbox")) return el.getAttribute("value") || "";
    return el.value;
}
function $2814b83f7132876d$var$extractFileExtension(path, baseURL) {
    let url;
    try {
        url = new URL(path, baseURL ?? window.location.href);
    } catch (err) {
        return null;
    }
    const regex = /\.([0-9a-z]+)(?:$)/i;
    const match = url.pathname.match(regex);
    return match?.[1] ?? null;
}
const $2814b83f7132876d$var$cachedImplementations$1 = {};
function $2814b83f7132876d$var$getImplementation$1(name) {
    const cached = $2814b83f7132876d$var$cachedImplementations$1[name];
    if (cached) return cached;
    const document2 = window.document;
    let impl = window[name];
    if (document2 && typeof document2.createElement === "function") try {
        const sandbox = document2.createElement("iframe");
        sandbox.hidden = true;
        document2.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow[name]) impl = contentWindow[name];
        document2.head.removeChild(sandbox);
    } catch (e2) {}
    return $2814b83f7132876d$var$cachedImplementations$1[name] = impl.bind(window);
}
function $2814b83f7132876d$var$setTimeout$2(...rest) {
    return $2814b83f7132876d$var$getImplementation$1("setTimeout")(...rest);
}
function $2814b83f7132876d$var$clearTimeout$1(...rest) {
    return $2814b83f7132876d$var$getImplementation$1("clearTimeout")(...rest);
}
function $2814b83f7132876d$var$getIframeContentDocument(iframe) {
    try {
        return iframe.contentDocument;
    } catch (e2) {}
}
let $2814b83f7132876d$var$_id = 1;
const $2814b83f7132876d$var$tagNameRegex = new RegExp("[^a-z0-9-_:]");
const $2814b83f7132876d$var$IGNORED_NODE = -2;
function $2814b83f7132876d$var$genId() {
    return $2814b83f7132876d$var$_id++;
}
function $2814b83f7132876d$var$getValidTagName$1(element) {
    if (element instanceof HTMLFormElement) return "form";
    const processedTagName = $2814b83f7132876d$var$toLowerCase(element.tagName);
    if ($2814b83f7132876d$var$tagNameRegex.test(processedTagName)) return "div";
    return processedTagName;
}
function $2814b83f7132876d$var$extractOrigin(url) {
    let origin = "";
    if (url.indexOf("//") > -1) origin = url.split("/").slice(0, 3).join("/");
    else origin = url.split("/")[0];
    origin = origin.split("?")[0];
    return origin;
}
let $2814b83f7132876d$var$canvasService;
let $2814b83f7132876d$var$canvasCtx;
const $2814b83f7132876d$var$URL_IN_CSS_REF = /url\((?:(')([^']*)'|(")(.*?)"|([^)]*))\)/gm;
const $2814b83f7132876d$var$URL_PROTOCOL_MATCH = /^(?:[a-z+]+:)?\/\//i;
const $2814b83f7132876d$var$URL_WWW_MATCH = /^www\..*/i;
const $2814b83f7132876d$var$DATA_URI = /^(data:)([^,]*),(.*)/i;
function $2814b83f7132876d$var$absoluteToStylesheet(cssText, href) {
    return (cssText || "").replace($2814b83f7132876d$var$URL_IN_CSS_REF, (origin, quote1, path1, quote2, path2, path3)=>{
        const filePath = path1 || path2 || path3;
        const maybeQuote = quote1 || quote2 || "";
        if (!filePath) return origin;
        if ($2814b83f7132876d$var$URL_PROTOCOL_MATCH.test(filePath) || $2814b83f7132876d$var$URL_WWW_MATCH.test(filePath)) return `url(${maybeQuote}${filePath}${maybeQuote})`;
        if ($2814b83f7132876d$var$DATA_URI.test(filePath)) return `url(${maybeQuote}${filePath}${maybeQuote})`;
        if (filePath[0] === "/") return `url(${maybeQuote}${$2814b83f7132876d$var$extractOrigin(href) + filePath}${maybeQuote})`;
        const stack = href.split("/");
        const parts = filePath.split("/");
        stack.pop();
        for (const part of parts){
            if (part === ".") continue;
            else if (part === "..") stack.pop();
            else stack.push(part);
        }
        return `url(${maybeQuote}${stack.join("/")}${maybeQuote})`;
    });
}
const $2814b83f7132876d$var$SRCSET_NOT_SPACES = /^[^ \t\n\r\u000c]+/;
const $2814b83f7132876d$var$SRCSET_COMMAS_OR_SPACES = /^[, \t\n\r\u000c]+/;
function $2814b83f7132876d$var$getAbsoluteSrcsetString(doc, attributeValue) {
    if (attributeValue.trim() === "") return attributeValue;
    let pos = 0;
    function collectCharacters(regEx) {
        let chars2;
        const match = regEx.exec(attributeValue.substring(pos));
        if (match) {
            chars2 = match[0];
            pos += chars2.length;
            return chars2;
        }
        return "";
    }
    const output = [];
    while(true){
        collectCharacters($2814b83f7132876d$var$SRCSET_COMMAS_OR_SPACES);
        if (pos >= attributeValue.length) break;
        let url = collectCharacters($2814b83f7132876d$var$SRCSET_NOT_SPACES);
        if (url.slice(-1) === ",") {
            url = $2814b83f7132876d$var$absoluteToDoc(doc, url.substring(0, url.length - 1));
            output.push(url);
        } else {
            let descriptorsStr = "";
            url = $2814b83f7132876d$var$absoluteToDoc(doc, url);
            let inParens = false;
            while(true){
                const c2 = attributeValue.charAt(pos);
                if (c2 === "") {
                    output.push((url + descriptorsStr).trim());
                    break;
                } else if (!inParens) {
                    if (c2 === ",") {
                        pos += 1;
                        output.push((url + descriptorsStr).trim());
                        break;
                    } else if (c2 === "(") inParens = true;
                } else if (c2 === ")") inParens = false;
                descriptorsStr += c2;
                pos += 1;
            }
        }
    }
    return output.join(", ");
}
const $2814b83f7132876d$var$cachedDocument = /* @__PURE__ */ new WeakMap();
function $2814b83f7132876d$var$absoluteToDoc(doc, attributeValue) {
    if (!attributeValue || attributeValue.trim() === "") return attributeValue;
    return $2814b83f7132876d$var$getHref(doc, attributeValue);
}
function $2814b83f7132876d$var$isSVGElement(el) {
    return Boolean(el.tagName === "svg" || el.ownerSVGElement);
}
function $2814b83f7132876d$var$getHref(doc, customHref) {
    let a2 = $2814b83f7132876d$var$cachedDocument.get(doc);
    if (!a2) {
        a2 = doc.createElement("a");
        $2814b83f7132876d$var$cachedDocument.set(doc, a2);
    }
    if (!customHref) customHref = "";
    else if (customHref.startsWith("blob:") || customHref.startsWith("data:")) return customHref;
    a2.setAttribute("href", customHref);
    return a2.href;
}
function $2814b83f7132876d$var$transformAttribute(doc, tagName, name, value, element, maskAttributeFn) {
    if (!value) return value;
    if (name === "src" || name === "href" && !(tagName === "use" && value[0] === "#")) return $2814b83f7132876d$var$absoluteToDoc(doc, value);
    else if (name === "xlink:href" && value[0] !== "#") return $2814b83f7132876d$var$absoluteToDoc(doc, value);
    else if (name === "background" && (tagName === "table" || tagName === "td" || tagName === "th")) return $2814b83f7132876d$var$absoluteToDoc(doc, value);
    else if (name === "srcset") return $2814b83f7132876d$var$getAbsoluteSrcsetString(doc, value);
    else if (name === "style") return $2814b83f7132876d$var$absoluteToStylesheet(value, $2814b83f7132876d$var$getHref(doc));
    else if (tagName === "object" && name === "data") return $2814b83f7132876d$var$absoluteToDoc(doc, value);
    if (typeof maskAttributeFn === "function") return maskAttributeFn(name, value, element);
    return value;
}
function $2814b83f7132876d$var$ignoreAttribute(tagName, name, _value) {
    return (tagName === "video" || tagName === "audio") && name === "autoplay";
}
function $2814b83f7132876d$var$_isBlockedElement(element, blockClass, blockSelector, unblockSelector) {
    try {
        if (unblockSelector && element.matches(unblockSelector)) return false;
        if (typeof blockClass === "string") {
            if (element.classList.contains(blockClass)) return true;
        } else for(let eIndex = element.classList.length; eIndex--;){
            const className = element.classList[eIndex];
            if (blockClass.test(className)) return true;
        }
        if (blockSelector) return element.matches(blockSelector);
    } catch (e2) {}
    return false;
}
function $2814b83f7132876d$var$elementClassMatchesRegex(el, regex) {
    for(let eIndex = el.classList.length; eIndex--;){
        const className = el.classList[eIndex];
        if (regex.test(className)) return true;
    }
    return false;
}
function $2814b83f7132876d$var$distanceToMatch(node, matchPredicate, limit = Infinity, distance = 0) {
    if (!node) return -1;
    if (node.nodeType !== node.ELEMENT_NODE) return -1;
    if (distance > limit) return -1;
    if (matchPredicate(node)) return distance;
    return $2814b83f7132876d$var$distanceToMatch(node.parentNode, matchPredicate, limit, distance + 1);
}
function $2814b83f7132876d$var$createMatchPredicate(className, selector) {
    return (node)=>{
        const el = node;
        if (el === null) return false;
        try {
            if (className) {
                if (typeof className === "string") {
                    if (el.matches(`.${className}`)) return true;
                } else if ($2814b83f7132876d$var$elementClassMatchesRegex(el, className)) return true;
            }
            if (selector && el.matches(selector)) return true;
            return false;
        } catch  {
            return false;
        }
    };
}
function $2814b83f7132876d$var$needMaskingText(node, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, maskAllText) {
    try {
        const el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
        if (el === null) return false;
        if (el.tagName === "INPUT") {
            const autocomplete = el.getAttribute("autocomplete");
            const disallowedAutocompleteValues = [
                "current-password",
                "new-password",
                "cc-number",
                "cc-exp",
                "cc-exp-month",
                "cc-exp-year",
                "cc-csc"
            ];
            if (disallowedAutocompleteValues.includes(autocomplete)) return true;
        }
        let maskDistance = -1;
        let unmaskDistance = -1;
        if (maskAllText) {
            unmaskDistance = $2814b83f7132876d$var$distanceToMatch(el, $2814b83f7132876d$var$createMatchPredicate(unmaskTextClass, unmaskTextSelector));
            if (unmaskDistance < 0) return true;
            maskDistance = $2814b83f7132876d$var$distanceToMatch(el, $2814b83f7132876d$var$createMatchPredicate(maskTextClass, maskTextSelector), unmaskDistance >= 0 ? unmaskDistance : Infinity);
        } else {
            maskDistance = $2814b83f7132876d$var$distanceToMatch(el, $2814b83f7132876d$var$createMatchPredicate(maskTextClass, maskTextSelector));
            if (maskDistance < 0) return false;
            unmaskDistance = $2814b83f7132876d$var$distanceToMatch(el, $2814b83f7132876d$var$createMatchPredicate(unmaskTextClass, unmaskTextSelector), maskDistance >= 0 ? maskDistance : Infinity);
        }
        return maskDistance >= 0 ? unmaskDistance >= 0 ? maskDistance <= unmaskDistance : true : unmaskDistance >= 0 ? false : !!maskAllText;
    } catch (e2) {}
    return !!maskAllText;
}
function $2814b83f7132876d$var$onceIframeLoaded(iframeEl, listener, iframeLoadTimeout) {
    const win = iframeEl.contentWindow;
    if (!win) return;
    let fired = false;
    let readyState;
    try {
        readyState = win.document.readyState;
    } catch (error) {
        return;
    }
    if (readyState !== "complete") {
        const timer = $2814b83f7132876d$var$setTimeout$2(()=>{
            if (!fired) {
                listener();
                fired = true;
            }
        }, iframeLoadTimeout);
        iframeEl.addEventListener("load", ()=>{
            $2814b83f7132876d$var$clearTimeout$1(timer);
            fired = true;
            listener();
        });
        return;
    }
    const blankUrl = "about:blank";
    if (win.location.href !== blankUrl || iframeEl.src === blankUrl || iframeEl.src === "") {
        $2814b83f7132876d$var$setTimeout$2(listener, 0);
        return iframeEl.addEventListener("load", listener);
    }
    iframeEl.addEventListener("load", listener);
}
function $2814b83f7132876d$var$onceStylesheetLoaded(link, listener, styleSheetLoadTimeout) {
    let fired = false;
    let styleSheetLoaded;
    try {
        styleSheetLoaded = link.sheet;
    } catch (error) {
        return;
    }
    if (styleSheetLoaded) return;
    const timer = $2814b83f7132876d$var$setTimeout$2(()=>{
        if (!fired) {
            listener();
            fired = true;
        }
    }, styleSheetLoadTimeout);
    link.addEventListener("load", ()=>{
        $2814b83f7132876d$var$clearTimeout$1(timer);
        fired = true;
        listener();
    });
}
function $2814b83f7132876d$var$serializeNode(n2, options) {
    const { doc: doc, mirror: mirror2, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, maskAllText: maskAllText, maskAttributeFn: maskAttributeFn, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector, inlineStylesheet: inlineStylesheet, maskInputOptions: maskInputOptions = {}, maskTextFn: maskTextFn, maskInputFn: maskInputFn, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages, recordCanvas: recordCanvas, keepIframeSrcFn: keepIframeSrcFn, newlyAddedElement: newlyAddedElement = false } = options;
    const rootId = $2814b83f7132876d$var$getRootId(doc, mirror2);
    switch(n2.nodeType){
        case n2.DOCUMENT_NODE:
            if (n2.compatMode !== "CSS1Compat") return {
                type: $2814b83f7132876d$var$NodeType$2.Document,
                childNodes: [],
                compatMode: n2.compatMode
            };
            else return {
                type: $2814b83f7132876d$var$NodeType$2.Document,
                childNodes: []
            };
        case n2.DOCUMENT_TYPE_NODE:
            return {
                type: $2814b83f7132876d$var$NodeType$2.DocumentType,
                name: n2.name,
                publicId: n2.publicId,
                systemId: n2.systemId,
                rootId: rootId
            };
        case n2.ELEMENT_NODE:
            return $2814b83f7132876d$var$serializeElementNode(n2, {
                doc: doc,
                blockClass: blockClass,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                inlineStylesheet: inlineStylesheet,
                maskAttributeFn: maskAttributeFn,
                maskInputOptions: maskInputOptions,
                maskInputFn: maskInputFn,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                keepIframeSrcFn: keepIframeSrcFn,
                newlyAddedElement: newlyAddedElement,
                rootId: rootId,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector
            });
        case n2.TEXT_NODE:
            return $2814b83f7132876d$var$serializeTextNode(n2, {
                doc: doc,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                maskTextFn: maskTextFn,
                maskInputOptions: maskInputOptions,
                maskInputFn: maskInputFn,
                rootId: rootId
            });
        case n2.CDATA_SECTION_NODE:
            return {
                type: $2814b83f7132876d$var$NodeType$2.CDATA,
                textContent: "",
                rootId: rootId
            };
        case n2.COMMENT_NODE:
            return {
                type: $2814b83f7132876d$var$NodeType$2.Comment,
                textContent: n2.textContent || "",
                rootId: rootId
            };
        default:
            return false;
    }
}
function $2814b83f7132876d$var$getRootId(doc, mirror2) {
    if (!mirror2.hasNode(doc)) return void 0;
    const docId = mirror2.getId(doc);
    return docId === 1 ? void 0 : docId;
}
function $2814b83f7132876d$var$serializeTextNode(n2, options) {
    const { maskAllText: maskAllText, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector, maskTextFn: maskTextFn, maskInputOptions: maskInputOptions, maskInputFn: maskInputFn, rootId: rootId } = options;
    const parentTagName = n2.parentNode && n2.parentNode.tagName;
    let textContent = n2.textContent;
    const isStyle = parentTagName === "STYLE" ? true : void 0;
    const isScript = parentTagName === "SCRIPT" ? true : void 0;
    const isTextarea = parentTagName === "TEXTAREA" ? true : void 0;
    if (isStyle && textContent) {
        try {
            if (n2.nextSibling || n2.previousSibling) ;
            else if (n2.parentNode.sheet?.cssRules) textContent = $2814b83f7132876d$var$stringifyStylesheet(n2.parentNode.sheet);
        } catch (err) {
            console.warn(`Cannot get CSS styles from text's parentNode. Error: ${err}`, n2);
        }
        textContent = $2814b83f7132876d$var$absoluteToStylesheet(textContent, $2814b83f7132876d$var$getHref(options.doc));
    }
    if (isScript) textContent = "SCRIPT_PLACEHOLDER";
    const forceMask = $2814b83f7132876d$var$needMaskingText(n2, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, maskAllText);
    if (!isStyle && !isScript && !isTextarea && textContent && forceMask) textContent = maskTextFn ? maskTextFn(textContent, n2.parentElement) : textContent.replace(/[\S]/g, "*");
    if (isTextarea && textContent && (maskInputOptions.textarea || forceMask)) textContent = maskInputFn ? maskInputFn(textContent, n2.parentNode) : textContent.replace(/[\S]/g, "*");
    if (parentTagName === "OPTION" && textContent) {
        const isInputMasked = $2814b83f7132876d$var$shouldMaskInput({
            type: null,
            tagName: parentTagName,
            maskInputOptions: maskInputOptions
        });
        textContent = $2814b83f7132876d$var$maskInputValue({
            isMasked: $2814b83f7132876d$var$needMaskingText(n2, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, isInputMasked),
            element: n2,
            value: textContent,
            maskInputFn: maskInputFn
        });
    }
    return {
        type: $2814b83f7132876d$var$NodeType$2.Text,
        textContent: textContent || "",
        isStyle: isStyle,
        rootId: rootId
    };
}
function $2814b83f7132876d$var$serializeElementNode(n2, options) {
    const { doc: doc, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, inlineStylesheet: inlineStylesheet, maskInputOptions: maskInputOptions = {}, maskAttributeFn: maskAttributeFn, maskInputFn: maskInputFn, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages, recordCanvas: recordCanvas, keepIframeSrcFn: keepIframeSrcFn, newlyAddedElement: newlyAddedElement = false, rootId: rootId, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector } = options;
    const needBlock = $2814b83f7132876d$var$_isBlockedElement(n2, blockClass, blockSelector, unblockSelector);
    const tagName = $2814b83f7132876d$var$getValidTagName$1(n2);
    let attributes2 = {};
    const len = n2.attributes.length;
    for(let i2 = 0; i2 < len; i2++){
        const attr = n2.attributes[i2];
        if (attr.name && !$2814b83f7132876d$var$ignoreAttribute(tagName, attr.name, attr.value)) attributes2[attr.name] = $2814b83f7132876d$var$transformAttribute(doc, tagName, $2814b83f7132876d$var$toLowerCase(attr.name), attr.value, n2, maskAttributeFn);
    }
    if (tagName === "link" && inlineStylesheet) {
        const stylesheet = Array.from(doc.styleSheets).find((s2)=>{
            return s2.href === n2.href;
        });
        let cssText = null;
        if (stylesheet) cssText = $2814b83f7132876d$var$stringifyStylesheet(stylesheet);
        if (cssText) {
            attributes2.rel = null;
            attributes2.href = null;
            attributes2.crossorigin = null;
            attributes2._cssText = $2814b83f7132876d$var$absoluteToStylesheet(cssText, stylesheet.href);
        }
    }
    if (tagName === "style" && n2.sheet && // TODO: Currently we only try to get dynamic stylesheet when it is an empty style element
    !(n2.innerText || n2.textContent || "").trim().length) {
        const cssText = $2814b83f7132876d$var$stringifyStylesheet(n2.sheet);
        if (cssText) attributes2._cssText = $2814b83f7132876d$var$absoluteToStylesheet(cssText, $2814b83f7132876d$var$getHref(doc));
    }
    if (tagName === "input" || tagName === "textarea" || tagName === "select" || tagName === "option") {
        const el = n2;
        const type = $2814b83f7132876d$var$getInputType(el);
        const value = $2814b83f7132876d$var$getInputValue(el, $2814b83f7132876d$var$toUpperCase(tagName), type);
        const checked = el.checked;
        if (type !== "submit" && type !== "button" && value) {
            const forceMask = $2814b83f7132876d$var$needMaskingText(el, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, $2814b83f7132876d$var$shouldMaskInput({
                type: type,
                tagName: $2814b83f7132876d$var$toUpperCase(tagName),
                maskInputOptions: maskInputOptions
            }));
            attributes2.value = $2814b83f7132876d$var$maskInputValue({
                isMasked: forceMask,
                element: el,
                value: value,
                maskInputFn: maskInputFn
            });
        }
        if (checked) attributes2.checked = checked;
    }
    if (tagName === "option") {
        if (n2.selected && !maskInputOptions["select"]) attributes2.selected = true;
        else delete attributes2.selected;
    }
    if (tagName === "canvas" && recordCanvas) {
        if (n2.__context === "2d") {
            if (!$2814b83f7132876d$var$is2DCanvasBlank(n2)) attributes2.rr_dataURL = n2.toDataURL(dataURLOptions.type, dataURLOptions.quality);
        } else if (!("__context" in n2)) {
            const canvasDataURL = n2.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            const blankCanvas = doc.createElement("canvas");
            blankCanvas.width = n2.width;
            blankCanvas.height = n2.height;
            const blankCanvasDataURL = blankCanvas.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            if (canvasDataURL !== blankCanvasDataURL) attributes2.rr_dataURL = canvasDataURL;
        }
    }
    if (tagName === "img" && inlineImages) {
        if (!$2814b83f7132876d$var$canvasService) {
            $2814b83f7132876d$var$canvasService = doc.createElement("canvas");
            $2814b83f7132876d$var$canvasCtx = $2814b83f7132876d$var$canvasService.getContext("2d");
        }
        const image = n2;
        const imageSrc = image.currentSrc || image.getAttribute("src") || "<unknown-src>";
        const priorCrossOrigin = image.crossOrigin;
        const recordInlineImage = ()=>{
            image.removeEventListener("load", recordInlineImage);
            try {
                $2814b83f7132876d$var$canvasService.width = image.naturalWidth;
                $2814b83f7132876d$var$canvasService.height = image.naturalHeight;
                $2814b83f7132876d$var$canvasCtx.drawImage(image, 0, 0);
                attributes2.rr_dataURL = $2814b83f7132876d$var$canvasService.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            } catch (err) {
                if (image.crossOrigin !== "anonymous") {
                    image.crossOrigin = "anonymous";
                    if (image.complete && image.naturalWidth !== 0) recordInlineImage();
                    else image.addEventListener("load", recordInlineImage);
                    return;
                } else console.warn(`Cannot inline img src=${imageSrc}! Error: ${err}`);
            }
            if (image.crossOrigin === "anonymous") priorCrossOrigin ? attributes2.crossOrigin = priorCrossOrigin : image.removeAttribute("crossorigin");
        };
        if (image.complete && image.naturalWidth !== 0) recordInlineImage();
        else image.addEventListener("load", recordInlineImage);
    }
    if (tagName === "audio" || tagName === "video") {
        attributes2.rr_mediaState = n2.paused ? "paused" : "played";
        attributes2.rr_mediaCurrentTime = n2.currentTime;
    }
    if (!newlyAddedElement) {
        if (n2.scrollLeft) attributes2.rr_scrollLeft = n2.scrollLeft;
        if (n2.scrollTop) attributes2.rr_scrollTop = n2.scrollTop;
    }
    if (needBlock) {
        const { width: width, height: height } = n2.getBoundingClientRect();
        attributes2 = {
            class: attributes2.class,
            rr_width: `${width}px`,
            rr_height: `${height}px`
        };
    }
    if (tagName === "iframe" && !keepIframeSrcFn(attributes2.src)) {
        if (!needBlock && !$2814b83f7132876d$var$getIframeContentDocument(n2)) attributes2.rr_src = attributes2.src;
        delete attributes2.src;
    }
    let isCustomElement;
    try {
        if (customElements.get(tagName)) isCustomElement = true;
    } catch (e2) {}
    return {
        type: $2814b83f7132876d$var$NodeType$2.Element,
        tagName: tagName,
        attributes: attributes2,
        childNodes: [],
        isSVG: $2814b83f7132876d$var$isSVGElement(n2) || void 0,
        needBlock: needBlock,
        rootId: rootId,
        isCustom: isCustomElement
    };
}
function $2814b83f7132876d$var$lowerIfExists(maybeAttr) {
    if (maybeAttr === void 0 || maybeAttr === null) return "";
    else return maybeAttr.toLowerCase();
}
function $2814b83f7132876d$var$slimDOMExcluded(sn, slimDOMOptions) {
    if (slimDOMOptions.comment && sn.type === $2814b83f7132876d$var$NodeType$2.Comment) return true;
    else if (sn.type === $2814b83f7132876d$var$NodeType$2.Element) {
        if (slimDOMOptions.script && // script tag
        (sn.tagName === "script" || // (module)preload link
        sn.tagName === "link" && (sn.attributes.rel === "preload" || sn.attributes.rel === "modulepreload") || // prefetch link
        sn.tagName === "link" && sn.attributes.rel === "prefetch" && typeof sn.attributes.href === "string" && $2814b83f7132876d$var$extractFileExtension(sn.attributes.href) === "js")) return true;
        else if (slimDOMOptions.headFavicon && (sn.tagName === "link" && sn.attributes.rel === "shortcut icon" || sn.tagName === "meta" && ($2814b83f7132876d$var$lowerIfExists(sn.attributes.name).match(/^msapplication-tile(image|color)$/) || $2814b83f7132876d$var$lowerIfExists(sn.attributes.name) === "application-name" || $2814b83f7132876d$var$lowerIfExists(sn.attributes.rel) === "icon" || $2814b83f7132876d$var$lowerIfExists(sn.attributes.rel) === "apple-touch-icon" || $2814b83f7132876d$var$lowerIfExists(sn.attributes.rel) === "shortcut icon"))) return true;
        else if (sn.tagName === "meta") {
            if (slimDOMOptions.headMetaDescKeywords && $2814b83f7132876d$var$lowerIfExists(sn.attributes.name).match(/^description|keywords$/)) return true;
            else if (slimDOMOptions.headMetaSocial && ($2814b83f7132876d$var$lowerIfExists(sn.attributes.property).match(/^(og|twitter|fb):/) || // og = opengraph (facebook)
            $2814b83f7132876d$var$lowerIfExists(sn.attributes.name).match(/^(og|twitter):/) || $2814b83f7132876d$var$lowerIfExists(sn.attributes.name) === "pinterest")) return true;
            else if (slimDOMOptions.headMetaRobots && ($2814b83f7132876d$var$lowerIfExists(sn.attributes.name) === "robots" || $2814b83f7132876d$var$lowerIfExists(sn.attributes.name) === "googlebot" || $2814b83f7132876d$var$lowerIfExists(sn.attributes.name) === "bingbot")) return true;
            else if (slimDOMOptions.headMetaHttpEquiv && sn.attributes["http-equiv"] !== void 0) return true;
            else if (slimDOMOptions.headMetaAuthorship && ($2814b83f7132876d$var$lowerIfExists(sn.attributes.name) === "author" || $2814b83f7132876d$var$lowerIfExists(sn.attributes.name) === "generator" || $2814b83f7132876d$var$lowerIfExists(sn.attributes.name) === "framework" || $2814b83f7132876d$var$lowerIfExists(sn.attributes.name) === "publisher" || $2814b83f7132876d$var$lowerIfExists(sn.attributes.name) === "progid" || $2814b83f7132876d$var$lowerIfExists(sn.attributes.property).match(/^article:/) || $2814b83f7132876d$var$lowerIfExists(sn.attributes.property).match(/^product:/))) return true;
            else if (slimDOMOptions.headMetaVerification && ($2814b83f7132876d$var$lowerIfExists(sn.attributes.name) === "google-site-verification" || $2814b83f7132876d$var$lowerIfExists(sn.attributes.name) === "yandex-verification" || $2814b83f7132876d$var$lowerIfExists(sn.attributes.name) === "csrf-token" || $2814b83f7132876d$var$lowerIfExists(sn.attributes.name) === "p:domain_verify" || $2814b83f7132876d$var$lowerIfExists(sn.attributes.name) === "verify-v1" || $2814b83f7132876d$var$lowerIfExists(sn.attributes.name) === "verification" || $2814b83f7132876d$var$lowerIfExists(sn.attributes.name) === "shopify-checkout-api-token")) return true;
        }
    }
    return false;
}
function $2814b83f7132876d$var$serializeNodeWithId(n2, options) {
    const { doc: doc, mirror: mirror2, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, maskAllText: maskAllText, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector, skipChild: skipChild = false, inlineStylesheet: inlineStylesheet = true, maskInputOptions: maskInputOptions = {}, maskAttributeFn: maskAttributeFn, maskTextFn: maskTextFn, maskInputFn: maskInputFn, slimDOMOptions: slimDOMOptions, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages = false, recordCanvas: recordCanvas = false, onSerialize: onSerialize, onIframeLoad: onIframeLoad, iframeLoadTimeout: iframeLoadTimeout = 5e3, onStylesheetLoad: onStylesheetLoad, stylesheetLoadTimeout: stylesheetLoadTimeout = 5e3, keepIframeSrcFn: keepIframeSrcFn = ()=>false, newlyAddedElement: newlyAddedElement = false } = options;
    let { preserveWhiteSpace: preserveWhiteSpace = true } = options;
    const _serializedNode = $2814b83f7132876d$var$serializeNode(n2, {
        doc: doc,
        mirror: mirror2,
        blockClass: blockClass,
        blockSelector: blockSelector,
        maskAllText: maskAllText,
        unblockSelector: unblockSelector,
        maskTextClass: maskTextClass,
        unmaskTextClass: unmaskTextClass,
        maskTextSelector: maskTextSelector,
        unmaskTextSelector: unmaskTextSelector,
        inlineStylesheet: inlineStylesheet,
        maskInputOptions: maskInputOptions,
        maskAttributeFn: maskAttributeFn,
        maskTextFn: maskTextFn,
        maskInputFn: maskInputFn,
        dataURLOptions: dataURLOptions,
        inlineImages: inlineImages,
        recordCanvas: recordCanvas,
        keepIframeSrcFn: keepIframeSrcFn,
        newlyAddedElement: newlyAddedElement
    });
    if (!_serializedNode) {
        console.warn(n2, "not serialized");
        return null;
    }
    let id;
    if (mirror2.hasNode(n2)) id = mirror2.getId(n2);
    else if ($2814b83f7132876d$var$slimDOMExcluded(_serializedNode, slimDOMOptions) || !preserveWhiteSpace && _serializedNode.type === $2814b83f7132876d$var$NodeType$2.Text && !_serializedNode.isStyle && !_serializedNode.textContent.replace(/^\s+|\s+$/gm, "").length) id = $2814b83f7132876d$var$IGNORED_NODE;
    else id = $2814b83f7132876d$var$genId();
    const serializedNode2 = Object.assign(_serializedNode, {
        id: id
    });
    mirror2.add(n2, serializedNode2);
    if (id === $2814b83f7132876d$var$IGNORED_NODE) return null;
    if (onSerialize) onSerialize(n2);
    let recordChild = !skipChild;
    if (serializedNode2.type === $2814b83f7132876d$var$NodeType$2.Element) {
        recordChild = recordChild && !serializedNode2.needBlock;
        delete serializedNode2.needBlock;
        const shadowRoot = n2.shadowRoot;
        if (shadowRoot && $2814b83f7132876d$var$isNativeShadowDom(shadowRoot)) serializedNode2.isShadowHost = true;
    }
    if ((serializedNode2.type === $2814b83f7132876d$var$NodeType$2.Document || serializedNode2.type === $2814b83f7132876d$var$NodeType$2.Element) && recordChild) {
        if (slimDOMOptions.headWhitespace && serializedNode2.type === $2814b83f7132876d$var$NodeType$2.Element && serializedNode2.tagName === "head") preserveWhiteSpace = false;
        const bypassOptions = {
            doc: doc,
            mirror: mirror2,
            blockClass: blockClass,
            blockSelector: blockSelector,
            maskAllText: maskAllText,
            unblockSelector: unblockSelector,
            maskTextClass: maskTextClass,
            unmaskTextClass: unmaskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            skipChild: skipChild,
            inlineStylesheet: inlineStylesheet,
            maskInputOptions: maskInputOptions,
            maskAttributeFn: maskAttributeFn,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            slimDOMOptions: slimDOMOptions,
            dataURLOptions: dataURLOptions,
            inlineImages: inlineImages,
            recordCanvas: recordCanvas,
            preserveWhiteSpace: preserveWhiteSpace,
            onSerialize: onSerialize,
            onIframeLoad: onIframeLoad,
            iframeLoadTimeout: iframeLoadTimeout,
            onStylesheetLoad: onStylesheetLoad,
            stylesheetLoadTimeout: stylesheetLoadTimeout,
            keepIframeSrcFn: keepIframeSrcFn
        };
        for (const childN of Array.from(n2.childNodes)){
            const serializedChildNode = $2814b83f7132876d$var$serializeNodeWithId(childN, bypassOptions);
            if (serializedChildNode) serializedNode2.childNodes.push(serializedChildNode);
        }
        if ($2814b83f7132876d$var$isElement$1(n2) && n2.shadowRoot) for (const childN of Array.from(n2.shadowRoot.childNodes)){
            const serializedChildNode = $2814b83f7132876d$var$serializeNodeWithId(childN, bypassOptions);
            if (serializedChildNode) {
                $2814b83f7132876d$var$isNativeShadowDom(n2.shadowRoot) && (serializedChildNode.isShadow = true);
                serializedNode2.childNodes.push(serializedChildNode);
            }
        }
    }
    if (n2.parentNode && $2814b83f7132876d$var$isShadowRoot(n2.parentNode) && $2814b83f7132876d$var$isNativeShadowDom(n2.parentNode)) serializedNode2.isShadow = true;
    if (serializedNode2.type === $2814b83f7132876d$var$NodeType$2.Element && serializedNode2.tagName === "iframe" && !$2814b83f7132876d$var$_isBlockedElement(n2, blockClass, blockSelector, unblockSelector)) $2814b83f7132876d$var$onceIframeLoaded(n2, ()=>{
        const iframeDoc = $2814b83f7132876d$var$getIframeContentDocument(n2);
        if (iframeDoc && onIframeLoad) {
            const serializedIframeNode = $2814b83f7132876d$var$serializeNodeWithId(iframeDoc, {
                doc: iframeDoc,
                mirror: mirror2,
                blockClass: blockClass,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                skipChild: false,
                inlineStylesheet: inlineStylesheet,
                maskInputOptions: maskInputOptions,
                maskAttributeFn: maskAttributeFn,
                maskTextFn: maskTextFn,
                maskInputFn: maskInputFn,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                preserveWhiteSpace: preserveWhiteSpace,
                onSerialize: onSerialize,
                onIframeLoad: onIframeLoad,
                iframeLoadTimeout: iframeLoadTimeout,
                onStylesheetLoad: onStylesheetLoad,
                stylesheetLoadTimeout: stylesheetLoadTimeout,
                keepIframeSrcFn: keepIframeSrcFn
            });
            if (serializedIframeNode) onIframeLoad(n2, serializedIframeNode);
        }
    }, iframeLoadTimeout);
    if (serializedNode2.type === $2814b83f7132876d$var$NodeType$2.Element && serializedNode2.tagName === "link" && typeof serializedNode2.attributes.rel === "string" && (serializedNode2.attributes.rel === "stylesheet" || serializedNode2.attributes.rel === "preload" && typeof serializedNode2.attributes.href === "string" && $2814b83f7132876d$var$extractFileExtension(serializedNode2.attributes.href) === "css")) $2814b83f7132876d$var$onceStylesheetLoaded(n2, ()=>{
        if (onStylesheetLoad) {
            const serializedLinkNode = $2814b83f7132876d$var$serializeNodeWithId(n2, {
                doc: doc,
                mirror: mirror2,
                blockClass: blockClass,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                skipChild: false,
                inlineStylesheet: inlineStylesheet,
                maskInputOptions: maskInputOptions,
                maskAttributeFn: maskAttributeFn,
                maskTextFn: maskTextFn,
                maskInputFn: maskInputFn,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                preserveWhiteSpace: preserveWhiteSpace,
                onSerialize: onSerialize,
                onIframeLoad: onIframeLoad,
                iframeLoadTimeout: iframeLoadTimeout,
                onStylesheetLoad: onStylesheetLoad,
                stylesheetLoadTimeout: stylesheetLoadTimeout,
                keepIframeSrcFn: keepIframeSrcFn
            });
            if (serializedLinkNode) onStylesheetLoad(n2, serializedLinkNode);
        }
    }, stylesheetLoadTimeout);
    return serializedNode2;
}
function $2814b83f7132876d$var$snapshot(n2, options) {
    const { mirror: mirror2 = new $2814b83f7132876d$var$Mirror(), blockClass: blockClass = "rr-block", blockSelector: blockSelector = null, unblockSelector: unblockSelector = null, maskAllText: maskAllText = false, maskTextClass: maskTextClass = "rr-mask", unmaskTextClass: unmaskTextClass = null, maskTextSelector: maskTextSelector = null, unmaskTextSelector: unmaskTextSelector = null, inlineStylesheet: inlineStylesheet = true, inlineImages: inlineImages = false, recordCanvas: recordCanvas = false, maskAllInputs: maskAllInputs = false, maskAttributeFn: maskAttributeFn, maskTextFn: maskTextFn, maskInputFn: maskInputFn, slimDOM: slimDOM = false, dataURLOptions: dataURLOptions, preserveWhiteSpace: preserveWhiteSpace, onSerialize: onSerialize, onIframeLoad: onIframeLoad, iframeLoadTimeout: iframeLoadTimeout, onStylesheetLoad: onStylesheetLoad, stylesheetLoadTimeout: stylesheetLoadTimeout, keepIframeSrcFn: keepIframeSrcFn = ()=>false } = options || {};
    const maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        "datetime-local": true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true
    } : maskAllInputs === false ? {} : maskAllInputs;
    const slimDOMOptions = slimDOM === true || slimDOM === "all" ? // if true: set of sensible options that should not throw away any information
    {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaDescKeywords: slimDOM === "all",
        // destructive
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaAuthorship: true,
        headMetaVerification: true
    } : slimDOM === false ? {} : slimDOM;
    return $2814b83f7132876d$var$serializeNodeWithId(n2, {
        doc: n2,
        mirror: mirror2,
        blockClass: blockClass,
        blockSelector: blockSelector,
        unblockSelector: unblockSelector,
        maskAllText: maskAllText,
        maskTextClass: maskTextClass,
        unmaskTextClass: unmaskTextClass,
        maskTextSelector: maskTextSelector,
        unmaskTextSelector: unmaskTextSelector,
        skipChild: false,
        inlineStylesheet: inlineStylesheet,
        maskInputOptions: maskInputOptions,
        maskAttributeFn: maskAttributeFn,
        maskTextFn: maskTextFn,
        maskInputFn: maskInputFn,
        slimDOMOptions: slimDOMOptions,
        dataURLOptions: dataURLOptions,
        inlineImages: inlineImages,
        recordCanvas: recordCanvas,
        preserveWhiteSpace: preserveWhiteSpace,
        onSerialize: onSerialize,
        onIframeLoad: onIframeLoad,
        iframeLoadTimeout: iframeLoadTimeout,
        onStylesheetLoad: onStylesheetLoad,
        stylesheetLoadTimeout: stylesheetLoadTimeout,
        keepIframeSrcFn: keepIframeSrcFn,
        newlyAddedElement: false
    });
}
function $2814b83f7132876d$var$on(type, fn, target = document) {
    const options = {
        capture: true,
        passive: true
    };
    target.addEventListener(type, fn, options);
    return ()=>target.removeEventListener(type, fn, options);
}
const $2814b83f7132876d$var$DEPARTED_MIRROR_ACCESS_WARNING = "Please stop import mirror directly. Instead of that,\r\nnow you can use replayer.getMirror() to access the mirror instance of a replayer,\r\nor you can use record.mirror to access the mirror instance during recording.";
let $2814b83f7132876d$var$_mirror = {
    map: {},
    getId () {
        console.error($2814b83f7132876d$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return -1;
    },
    getNode () {
        console.error($2814b83f7132876d$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return null;
    },
    removeNodeFromMap () {
        console.error($2814b83f7132876d$var$DEPARTED_MIRROR_ACCESS_WARNING);
    },
    has () {
        console.error($2814b83f7132876d$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return false;
    },
    reset () {
        console.error($2814b83f7132876d$var$DEPARTED_MIRROR_ACCESS_WARNING);
    }
};
if (typeof window !== "undefined" && window.Proxy && window.Reflect) $2814b83f7132876d$var$_mirror = new Proxy($2814b83f7132876d$var$_mirror, {
    get (target, prop, receiver) {
        if (prop === "map") console.error($2814b83f7132876d$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return Reflect.get(target, prop, receiver);
    }
});
function $2814b83f7132876d$var$throttle$1(func, wait, options = {}) {
    let timeout = null;
    let previous = 0;
    return function(...args) {
        const now = Date.now();
        if (!previous && options.leading === false) previous = now;
        const remaining = wait - (now - previous);
        const context = this;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                $2814b83f7132876d$var$clearTimeout$2(timeout);
                timeout = null;
            }
            previous = now;
            func.apply(context, args);
        } else if (!timeout && options.trailing !== false) timeout = $2814b83f7132876d$var$setTimeout$1(()=>{
            previous = options.leading === false ? 0 : Date.now();
            timeout = null;
            func.apply(context, args);
        }, remaining);
    };
}
function $2814b83f7132876d$var$hookSetter(target, key, d, isRevoked, win = window) {
    const original = win.Object.getOwnPropertyDescriptor(target, key);
    win.Object.defineProperty(target, key, isRevoked ? d : {
        set (value) {
            $2814b83f7132876d$var$setTimeout$1(()=>{
                d.set.call(this, value);
            }, 0);
            if (original && original.set) original.set.call(this, value);
        }
    });
    return ()=>$2814b83f7132876d$var$hookSetter(target, key, original || {}, true);
}
function $2814b83f7132876d$var$patch(source, name, replacement) {
    try {
        if (!(name in source)) return ()=>{};
        const original = source[name];
        const wrapped = replacement(original);
        if (typeof wrapped === "function") {
            wrapped.prototype = wrapped.prototype || {};
            Object.defineProperties(wrapped, {
                __rrweb_original__: {
                    enumerable: false,
                    value: original
                }
            });
        }
        source[name] = wrapped;
        return ()=>{
            source[name] = original;
        };
    } catch  {
        return ()=>{};
    }
}
let $2814b83f7132876d$var$nowTimestamp = Date.now;
if (!/* @__PURE__ */ /[1-9][0-9]{12}/.test(Date.now().toString())) $2814b83f7132876d$var$nowTimestamp = ()=>/* @__PURE__ */ new Date().getTime();
function $2814b83f7132876d$var$getWindowScroll(win) {
    const doc = win.document;
    return {
        left: doc.scrollingElement ? doc.scrollingElement.scrollLeft : win.pageXOffset !== void 0 ? win.pageXOffset : doc?.documentElement.scrollLeft || doc?.body?.parentElement?.scrollLeft || doc?.body?.scrollLeft || 0,
        top: doc.scrollingElement ? doc.scrollingElement.scrollTop : win.pageYOffset !== void 0 ? win.pageYOffset : doc?.documentElement.scrollTop || doc?.body?.parentElement?.scrollTop || doc?.body?.scrollTop || 0
    };
}
function $2814b83f7132876d$var$getWindowHeight() {
    return window.innerHeight || document.documentElement && document.documentElement.clientHeight || document.body && document.body.clientHeight;
}
function $2814b83f7132876d$var$getWindowWidth() {
    return window.innerWidth || document.documentElement && document.documentElement.clientWidth || document.body && document.body.clientWidth;
}
function $2814b83f7132876d$var$closestElementOfNode(node) {
    if (!node) return null;
    try {
        const el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
        return el;
    } catch (error) {
        return null;
    }
}
function $2814b83f7132876d$var$isBlocked(node, blockClass, blockSelector, unblockSelector, checkAncestors) {
    if (!node) return false;
    const el = $2814b83f7132876d$var$closestElementOfNode(node);
    if (!el) return false;
    const blockedPredicate = $2814b83f7132876d$var$createMatchPredicate(blockClass, blockSelector);
    if (!checkAncestors) {
        const isUnblocked = unblockSelector && el.matches(unblockSelector);
        return blockedPredicate(el) && !isUnblocked;
    }
    const blockDistance = $2814b83f7132876d$var$distanceToMatch(el, blockedPredicate);
    let unblockDistance = -1;
    if (blockDistance < 0) return false;
    if (unblockSelector) unblockDistance = $2814b83f7132876d$var$distanceToMatch(el, $2814b83f7132876d$var$createMatchPredicate(null, unblockSelector));
    if (blockDistance > -1 && unblockDistance < 0) return true;
    return blockDistance < unblockDistance;
}
function $2814b83f7132876d$var$isSerialized(n2, mirror2) {
    return mirror2.getId(n2) !== -1;
}
function $2814b83f7132876d$var$isIgnored(n2, mirror2) {
    return mirror2.getId(n2) === $2814b83f7132876d$var$IGNORED_NODE;
}
function $2814b83f7132876d$var$isAncestorRemoved(target, mirror2) {
    if ($2814b83f7132876d$var$isShadowRoot(target)) return false;
    const id = mirror2.getId(target);
    if (!mirror2.has(id)) return true;
    if (target.parentNode && target.parentNode.nodeType === target.DOCUMENT_NODE) return false;
    if (!target.parentNode) return true;
    return $2814b83f7132876d$var$isAncestorRemoved(target.parentNode, mirror2);
}
function $2814b83f7132876d$var$legacy_isTouchEvent(event) {
    return Boolean(event.changedTouches);
}
function $2814b83f7132876d$var$polyfill$1(win = window) {
    if ("NodeList" in win && !win.NodeList.prototype.forEach) win.NodeList.prototype.forEach = Array.prototype.forEach;
    if ("DOMTokenList" in win && !win.DOMTokenList.prototype.forEach) win.DOMTokenList.prototype.forEach = Array.prototype.forEach;
    if (!Node.prototype.contains) Node.prototype.contains = (...args)=>{
        let node = args[0];
        if (!(0 in args)) throw new TypeError("1 argument is required");
        do {
            if (this === node) return true;
        }while (node = node && node.parentNode);
        return false;
    };
}
function $2814b83f7132876d$var$isSerializedIframe(n2, mirror2) {
    return Boolean(n2.nodeName === "IFRAME" && mirror2.getMeta(n2));
}
function $2814b83f7132876d$var$isSerializedStylesheet(n2, mirror2) {
    return Boolean(n2.nodeName === "LINK" && n2.nodeType === n2.ELEMENT_NODE && n2.getAttribute && n2.getAttribute("rel") === "stylesheet" && mirror2.getMeta(n2));
}
function $2814b83f7132876d$var$hasShadowRoot(n2) {
    return Boolean(n2?.shadowRoot);
}
class $2814b83f7132876d$var$StyleSheetMirror {
    constructor(){
        this.id = 1;
        this.styleIDMap = /* @__PURE__ */ new WeakMap();
        this.idStyleMap = /* @__PURE__ */ new Map();
    }
    getId(stylesheet) {
        return this.styleIDMap.get(stylesheet) ?? -1;
    }
    has(stylesheet) {
        return this.styleIDMap.has(stylesheet);
    }
    /**
   * @returns If the stylesheet is in the mirror, returns the id of the stylesheet. If not, return the new assigned id.
   */ add(stylesheet, id) {
        if (this.has(stylesheet)) return this.getId(stylesheet);
        let newId;
        if (id === void 0) newId = this.id++;
        else newId = id;
        this.styleIDMap.set(stylesheet, newId);
        this.idStyleMap.set(newId, stylesheet);
        return newId;
    }
    getStyle(id) {
        return this.idStyleMap.get(id) || null;
    }
    reset() {
        this.styleIDMap = /* @__PURE__ */ new WeakMap();
        this.idStyleMap = /* @__PURE__ */ new Map();
        this.id = 1;
    }
    generateId() {
        return this.id++;
    }
}
function $2814b83f7132876d$var$getShadowHost(n2) {
    let shadowHost = null;
    if (n2.getRootNode?.()?.nodeType === Node.DOCUMENT_FRAGMENT_NODE && n2.getRootNode().host) shadowHost = n2.getRootNode().host;
    return shadowHost;
}
function $2814b83f7132876d$var$getRootShadowHost(n2) {
    let rootShadowHost = n2;
    let shadowHost;
    while(shadowHost = $2814b83f7132876d$var$getShadowHost(rootShadowHost))rootShadowHost = shadowHost;
    return rootShadowHost;
}
function $2814b83f7132876d$var$shadowHostInDom(n2) {
    const doc = n2.ownerDocument;
    if (!doc) return false;
    const shadowHost = $2814b83f7132876d$var$getRootShadowHost(n2);
    return doc.contains(shadowHost);
}
function $2814b83f7132876d$var$inDom(n2) {
    const doc = n2.ownerDocument;
    if (!doc) return false;
    return doc.contains(n2) || $2814b83f7132876d$var$shadowHostInDom(n2);
}
const $2814b83f7132876d$var$cachedImplementations = {};
function $2814b83f7132876d$var$getImplementation(name) {
    const cached = $2814b83f7132876d$var$cachedImplementations[name];
    if (cached) return cached;
    const document2 = window.document;
    let impl = window[name];
    if (document2 && typeof document2.createElement === "function") try {
        const sandbox = document2.createElement("iframe");
        sandbox.hidden = true;
        document2.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow[name]) impl = contentWindow[name];
        document2.head.removeChild(sandbox);
    } catch (e2) {}
    return $2814b83f7132876d$var$cachedImplementations[name] = impl.bind(window);
}
function $2814b83f7132876d$var$onRequestAnimationFrame(...rest) {
    return $2814b83f7132876d$var$getImplementation("requestAnimationFrame")(...rest);
}
function $2814b83f7132876d$var$setTimeout$1(...rest) {
    return $2814b83f7132876d$var$getImplementation("setTimeout")(...rest);
}
function $2814b83f7132876d$var$clearTimeout$2(...rest) {
    return $2814b83f7132876d$var$getImplementation("clearTimeout")(...rest);
}
var $2814b83f7132876d$var$EventType = /* @__PURE__ */ ((EventType2)=>{
    EventType2[EventType2["DomContentLoaded"] = 0] = "DomContentLoaded";
    EventType2[EventType2["Load"] = 1] = "Load";
    EventType2[EventType2["FullSnapshot"] = 2] = "FullSnapshot";
    EventType2[EventType2["IncrementalSnapshot"] = 3] = "IncrementalSnapshot";
    EventType2[EventType2["Meta"] = 4] = "Meta";
    EventType2[EventType2["Custom"] = 5] = "Custom";
    EventType2[EventType2["Plugin"] = 6] = "Plugin";
    return EventType2;
})($2814b83f7132876d$var$EventType || {});
var $2814b83f7132876d$var$IncrementalSource = /* @__PURE__ */ ((IncrementalSource2)=>{
    IncrementalSource2[IncrementalSource2["Mutation"] = 0] = "Mutation";
    IncrementalSource2[IncrementalSource2["MouseMove"] = 1] = "MouseMove";
    IncrementalSource2[IncrementalSource2["MouseInteraction"] = 2] = "MouseInteraction";
    IncrementalSource2[IncrementalSource2["Scroll"] = 3] = "Scroll";
    IncrementalSource2[IncrementalSource2["ViewportResize"] = 4] = "ViewportResize";
    IncrementalSource2[IncrementalSource2["Input"] = 5] = "Input";
    IncrementalSource2[IncrementalSource2["TouchMove"] = 6] = "TouchMove";
    IncrementalSource2[IncrementalSource2["MediaInteraction"] = 7] = "MediaInteraction";
    IncrementalSource2[IncrementalSource2["StyleSheetRule"] = 8] = "StyleSheetRule";
    IncrementalSource2[IncrementalSource2["CanvasMutation"] = 9] = "CanvasMutation";
    IncrementalSource2[IncrementalSource2["Font"] = 10] = "Font";
    IncrementalSource2[IncrementalSource2["Log"] = 11] = "Log";
    IncrementalSource2[IncrementalSource2["Drag"] = 12] = "Drag";
    IncrementalSource2[IncrementalSource2["StyleDeclaration"] = 13] = "StyleDeclaration";
    IncrementalSource2[IncrementalSource2["Selection"] = 14] = "Selection";
    IncrementalSource2[IncrementalSource2["AdoptedStyleSheet"] = 15] = "AdoptedStyleSheet";
    IncrementalSource2[IncrementalSource2["CustomElement"] = 16] = "CustomElement";
    return IncrementalSource2;
})($2814b83f7132876d$var$IncrementalSource || {});
var $2814b83f7132876d$var$MouseInteractions = /* @__PURE__ */ ((MouseInteractions2)=>{
    MouseInteractions2[MouseInteractions2["MouseUp"] = 0] = "MouseUp";
    MouseInteractions2[MouseInteractions2["MouseDown"] = 1] = "MouseDown";
    MouseInteractions2[MouseInteractions2["Click"] = 2] = "Click";
    MouseInteractions2[MouseInteractions2["ContextMenu"] = 3] = "ContextMenu";
    MouseInteractions2[MouseInteractions2["DblClick"] = 4] = "DblClick";
    MouseInteractions2[MouseInteractions2["Focus"] = 5] = "Focus";
    MouseInteractions2[MouseInteractions2["Blur"] = 6] = "Blur";
    MouseInteractions2[MouseInteractions2["TouchStart"] = 7] = "TouchStart";
    MouseInteractions2[MouseInteractions2["TouchMove_Departed"] = 8] = "TouchMove_Departed";
    MouseInteractions2[MouseInteractions2["TouchEnd"] = 9] = "TouchEnd";
    MouseInteractions2[MouseInteractions2["TouchCancel"] = 10] = "TouchCancel";
    return MouseInteractions2;
})($2814b83f7132876d$var$MouseInteractions || {});
var $2814b83f7132876d$var$PointerTypes = /* @__PURE__ */ ((PointerTypes2)=>{
    PointerTypes2[PointerTypes2["Mouse"] = 0] = "Mouse";
    PointerTypes2[PointerTypes2["Pen"] = 1] = "Pen";
    PointerTypes2[PointerTypes2["Touch"] = 2] = "Touch";
    return PointerTypes2;
})($2814b83f7132876d$var$PointerTypes || {});
var $2814b83f7132876d$var$MediaInteractions = /* @__PURE__ */ ((MediaInteractions2)=>{
    MediaInteractions2[MediaInteractions2["Play"] = 0] = "Play";
    MediaInteractions2[MediaInteractions2["Pause"] = 1] = "Pause";
    MediaInteractions2[MediaInteractions2["Seeked"] = 2] = "Seeked";
    MediaInteractions2[MediaInteractions2["VolumeChange"] = 3] = "VolumeChange";
    MediaInteractions2[MediaInteractions2["RateChange"] = 4] = "RateChange";
    return MediaInteractions2;
})($2814b83f7132876d$var$MediaInteractions || {});
function $2814b83f7132876d$var$getIFrameContentDocument(iframe) {
    try {
        return iframe.contentDocument;
    } catch (e2) {}
}
function $2814b83f7132876d$var$getIFrameContentWindow(iframe) {
    try {
        return iframe.contentWindow;
    } catch (e2) {}
}
function $2814b83f7132876d$var$isNodeInLinkedList(n2) {
    return "__ln" in n2;
}
class $2814b83f7132876d$var$DoubleLinkedList {
    constructor(){
        this.length = 0;
        this.head = null;
        this.tail = null;
    }
    get(position) {
        if (position >= this.length) throw new Error("Position outside of list range");
        let current = this.head;
        for(let index = 0; index < position; index++)current = current?.next || null;
        return current;
    }
    addNode(n2) {
        const node = {
            value: n2,
            previous: null,
            next: null
        };
        n2.__ln = node;
        if (n2.previousSibling && $2814b83f7132876d$var$isNodeInLinkedList(n2.previousSibling)) {
            const current = n2.previousSibling.__ln.next;
            node.next = current;
            node.previous = n2.previousSibling.__ln;
            n2.previousSibling.__ln.next = node;
            if (current) current.previous = node;
        } else if (n2.nextSibling && $2814b83f7132876d$var$isNodeInLinkedList(n2.nextSibling) && n2.nextSibling.__ln.previous) {
            const current = n2.nextSibling.__ln.previous;
            node.previous = current;
            node.next = n2.nextSibling.__ln;
            n2.nextSibling.__ln.previous = node;
            if (current) current.next = node;
        } else {
            if (this.head) this.head.previous = node;
            node.next = this.head;
            this.head = node;
        }
        if (node.next === null) this.tail = node;
        this.length++;
    }
    removeNode(n2) {
        const current = n2.__ln;
        if (!this.head) return;
        if (!current.previous) {
            this.head = current.next;
            if (this.head) this.head.previous = null;
            else this.tail = null;
        } else {
            current.previous.next = current.next;
            if (current.next) current.next.previous = current.previous;
            else this.tail = current.previous;
        }
        if (n2.__ln) delete n2.__ln;
        this.length--;
    }
}
const $2814b83f7132876d$var$moveKey = (id, parentId)=>`${id}@${parentId}`;
class $2814b83f7132876d$var$MutationBuffer {
    constructor(){
        this.frozen = false;
        this.locked = false;
        this.texts = [];
        this.attributes = [];
        this.attributeMap = /* @__PURE__ */ new WeakMap();
        this.removes = [];
        this.mapRemoves = [];
        this.movedMap = {};
        this.addedSet = /* @__PURE__ */ new Set();
        this.movedSet = /* @__PURE__ */ new Set();
        this.droppedSet = /* @__PURE__ */ new Set();
        this.processMutations = (mutations)=>{
            mutations.forEach(this.processMutation);
            this.emit();
        };
        this.emit = ()=>{
            if (this.frozen || this.locked) return;
            const adds = [];
            const addedIds = /* @__PURE__ */ new Set();
            const addList = new $2814b83f7132876d$var$DoubleLinkedList();
            const getNextId = (n2)=>{
                let ns = n2;
                let nextId = $2814b83f7132876d$var$IGNORED_NODE;
                while(nextId === $2814b83f7132876d$var$IGNORED_NODE){
                    ns = ns && ns.nextSibling;
                    nextId = ns && this.mirror.getId(ns);
                }
                return nextId;
            };
            const pushAdd = (n2)=>{
                if (!n2.parentNode || !$2814b83f7132876d$var$inDom(n2)) return;
                const parentId = $2814b83f7132876d$var$isShadowRoot(n2.parentNode) ? this.mirror.getId($2814b83f7132876d$var$getShadowHost(n2)) : this.mirror.getId(n2.parentNode);
                const nextId = getNextId(n2);
                if (parentId === -1 || nextId === -1) return addList.addNode(n2);
                const sn = $2814b83f7132876d$var$serializeNodeWithId(n2, {
                    doc: this.doc,
                    mirror: this.mirror,
                    blockClass: this.blockClass,
                    blockSelector: this.blockSelector,
                    maskAllText: this.maskAllText,
                    unblockSelector: this.unblockSelector,
                    maskTextClass: this.maskTextClass,
                    unmaskTextClass: this.unmaskTextClass,
                    maskTextSelector: this.maskTextSelector,
                    unmaskTextSelector: this.unmaskTextSelector,
                    skipChild: true,
                    newlyAddedElement: true,
                    inlineStylesheet: this.inlineStylesheet,
                    maskInputOptions: this.maskInputOptions,
                    maskAttributeFn: this.maskAttributeFn,
                    maskTextFn: this.maskTextFn,
                    maskInputFn: this.maskInputFn,
                    slimDOMOptions: this.slimDOMOptions,
                    dataURLOptions: this.dataURLOptions,
                    recordCanvas: this.recordCanvas,
                    inlineImages: this.inlineImages,
                    onSerialize: (currentN)=>{
                        if ($2814b83f7132876d$var$isSerializedIframe(currentN, this.mirror) && !$2814b83f7132876d$var$isBlocked(currentN, this.blockClass, this.blockSelector, this.unblockSelector, false)) this.iframeManager.addIframe(currentN);
                        if ($2814b83f7132876d$var$isSerializedStylesheet(currentN, this.mirror)) this.stylesheetManager.trackLinkElement(currentN);
                        if ($2814b83f7132876d$var$hasShadowRoot(n2)) this.shadowDomManager.addShadowRoot(n2.shadowRoot, this.doc);
                    },
                    onIframeLoad: (iframe, childSn)=>{
                        if ($2814b83f7132876d$var$isBlocked(iframe, this.blockClass, this.blockSelector, this.unblockSelector, false)) return;
                        this.iframeManager.attachIframe(iframe, childSn);
                        if (iframe.contentWindow) this.canvasManager.addWindow(iframe.contentWindow);
                        this.shadowDomManager.observeAttachShadow(iframe);
                    },
                    onStylesheetLoad: (link, childSn)=>{
                        this.stylesheetManager.attachLinkElement(link, childSn);
                    }
                });
                if (sn) {
                    adds.push({
                        parentId: parentId,
                        nextId: nextId,
                        node: sn
                    });
                    addedIds.add(sn.id);
                }
            };
            while(this.mapRemoves.length)this.mirror.removeNodeFromMap(this.mapRemoves.shift());
            for (const n2 of this.movedSet){
                if ($2814b83f7132876d$var$isParentRemoved(this.removes, n2, this.mirror) && !this.movedSet.has(n2.parentNode)) continue;
                pushAdd(n2);
            }
            for (const n2 of this.addedSet){
                if (!$2814b83f7132876d$var$isAncestorInSet(this.droppedSet, n2) && !$2814b83f7132876d$var$isParentRemoved(this.removes, n2, this.mirror)) pushAdd(n2);
                else if ($2814b83f7132876d$var$isAncestorInSet(this.movedSet, n2)) pushAdd(n2);
                else this.droppedSet.add(n2);
            }
            let candidate = null;
            while(addList.length){
                let node = null;
                if (candidate) {
                    const parentId = this.mirror.getId(candidate.value.parentNode);
                    const nextId = getNextId(candidate.value);
                    if (parentId !== -1 && nextId !== -1) node = candidate;
                }
                if (!node) {
                    let tailNode = addList.tail;
                    while(tailNode){
                        const _node = tailNode;
                        tailNode = tailNode.previous;
                        if (_node) {
                            const parentId = this.mirror.getId(_node.value.parentNode);
                            const nextId = getNextId(_node.value);
                            if (nextId === -1) continue;
                            else if (parentId !== -1) {
                                node = _node;
                                break;
                            } else {
                                const unhandledNode = _node.value;
                                if (unhandledNode.parentNode && unhandledNode.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
                                    const shadowHost = unhandledNode.parentNode.host;
                                    const parentId2 = this.mirror.getId(shadowHost);
                                    if (parentId2 !== -1) {
                                        node = _node;
                                        break;
                                    }
                                }
                            }
                        }
                    }
                }
                if (!node) {
                    while(addList.head)addList.removeNode(addList.head.value);
                    break;
                }
                candidate = node.previous;
                addList.removeNode(node.value);
                pushAdd(node.value);
            }
            const payload = {
                texts: this.texts.map((text)=>({
                        id: this.mirror.getId(text.node),
                        value: text.value
                    })).filter((text)=>!addedIds.has(text.id)).filter((text)=>this.mirror.has(text.id)),
                attributes: this.attributes.map((attribute)=>{
                    const { attributes: attributes } = attribute;
                    if (typeof attributes.style === "string") {
                        const diffAsStr = JSON.stringify(attribute.styleDiff);
                        const unchangedAsStr = JSON.stringify(attribute._unchangedStyles);
                        if (diffAsStr.length < attributes.style.length) {
                            if ((diffAsStr + unchangedAsStr).split("var(").length === attributes.style.split("var(").length) attributes.style = attribute.styleDiff;
                        }
                    }
                    return {
                        id: this.mirror.getId(attribute.node),
                        attributes: attributes
                    };
                }).filter((attribute)=>!addedIds.has(attribute.id)).filter((attribute)=>this.mirror.has(attribute.id)),
                removes: this.removes,
                adds: adds
            };
            if (!payload.texts.length && !payload.attributes.length && !payload.removes.length && !payload.adds.length) return;
            this.texts = [];
            this.attributes = [];
            this.attributeMap = /* @__PURE__ */ new WeakMap();
            this.removes = [];
            this.addedSet = /* @__PURE__ */ new Set();
            this.movedSet = /* @__PURE__ */ new Set();
            this.droppedSet = /* @__PURE__ */ new Set();
            this.movedMap = {};
            this.mutationCb(payload);
        };
        this.processMutation = (m)=>{
            if ($2814b83f7132876d$var$isIgnored(m.target, this.mirror)) return;
            switch(m.type){
                case "characterData":
                    {
                        const value = m.target.textContent;
                        if (!$2814b83f7132876d$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, false) && value !== m.oldValue) this.texts.push({
                            value: $2814b83f7132876d$var$needMaskingText(m.target, this.maskTextClass, this.maskTextSelector, this.unmaskTextClass, this.unmaskTextSelector, this.maskAllText) && value ? this.maskTextFn ? this.maskTextFn(value, $2814b83f7132876d$var$closestElementOfNode(m.target)) : value.replace(/[\S]/g, "*") : value,
                            node: m.target
                        });
                        break;
                    }
                case "attributes":
                    {
                        const target = m.target;
                        let attributeName = m.attributeName;
                        let value = m.target.getAttribute(attributeName);
                        if (attributeName === "value") {
                            const type = $2814b83f7132876d$var$getInputType(target);
                            const tagName = target.tagName;
                            value = $2814b83f7132876d$var$getInputValue(target, tagName, type);
                            const isInputMasked = $2814b83f7132876d$var$shouldMaskInput({
                                maskInputOptions: this.maskInputOptions,
                                tagName: tagName,
                                type: type
                            });
                            const forceMask = $2814b83f7132876d$var$needMaskingText(m.target, this.maskTextClass, this.maskTextSelector, this.unmaskTextClass, this.unmaskTextSelector, isInputMasked);
                            value = $2814b83f7132876d$var$maskInputValue({
                                isMasked: forceMask,
                                element: target,
                                value: value,
                                maskInputFn: this.maskInputFn
                            });
                        }
                        if ($2814b83f7132876d$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, false) || value === m.oldValue) return;
                        let item = this.attributeMap.get(m.target);
                        if (target.tagName === "IFRAME" && attributeName === "src" && !this.keepIframeSrcFn(value)) {
                            const iframeDoc = $2814b83f7132876d$var$getIFrameContentDocument(target);
                            if (!iframeDoc) attributeName = "rr_src";
                            else return;
                        }
                        if (!item) {
                            item = {
                                node: m.target,
                                attributes: {},
                                styleDiff: {},
                                _unchangedStyles: {}
                            };
                            this.attributes.push(item);
                            this.attributeMap.set(m.target, item);
                        }
                        if (attributeName === "type" && target.tagName === "INPUT" && (m.oldValue || "").toLowerCase() === "password") target.setAttribute("data-rr-is-password", "true");
                        if (!$2814b83f7132876d$var$ignoreAttribute(target.tagName, attributeName)) {
                            item.attributes[attributeName] = $2814b83f7132876d$var$transformAttribute(this.doc, $2814b83f7132876d$var$toLowerCase(target.tagName), $2814b83f7132876d$var$toLowerCase(attributeName), value, target, this.maskAttributeFn);
                            if (attributeName === "style") {
                                if (!this.unattachedDoc) try {
                                    this.unattachedDoc = document.implementation.createHTMLDocument();
                                } catch (e2) {
                                    this.unattachedDoc = this.doc;
                                }
                                const old = this.unattachedDoc.createElement("span");
                                if (m.oldValue) old.setAttribute("style", m.oldValue);
                                for (const pname of Array.from(target.style)){
                                    const newValue = target.style.getPropertyValue(pname);
                                    const newPriority = target.style.getPropertyPriority(pname);
                                    if (newValue !== old.style.getPropertyValue(pname) || newPriority !== old.style.getPropertyPriority(pname)) {
                                        if (newPriority === "") item.styleDiff[pname] = newValue;
                                        else item.styleDiff[pname] = [
                                            newValue,
                                            newPriority
                                        ];
                                    } else item._unchangedStyles[pname] = [
                                        newValue,
                                        newPriority
                                    ];
                                }
                                for (const pname of Array.from(old.style))if (target.style.getPropertyValue(pname) === "") item.styleDiff[pname] = false;
                            }
                        }
                        break;
                    }
                case "childList":
                    if ($2814b83f7132876d$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, true)) return;
                    m.addedNodes.forEach((n2)=>this.genAdds(n2, m.target));
                    m.removedNodes.forEach((n2)=>{
                        const nodeId = this.mirror.getId(n2);
                        const parentId = $2814b83f7132876d$var$isShadowRoot(m.target) ? this.mirror.getId(m.target.host) : this.mirror.getId(m.target);
                        if ($2814b83f7132876d$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, false) || $2814b83f7132876d$var$isIgnored(n2, this.mirror) || !$2814b83f7132876d$var$isSerialized(n2, this.mirror)) return;
                        if (this.addedSet.has(n2)) {
                            $2814b83f7132876d$var$deepDelete(this.addedSet, n2);
                            this.droppedSet.add(n2);
                        } else if (this.addedSet.has(m.target) && nodeId === -1) ;
                        else if ($2814b83f7132876d$var$isAncestorRemoved(m.target, this.mirror)) ;
                        else if (this.movedSet.has(n2) && this.movedMap[$2814b83f7132876d$var$moveKey(nodeId, parentId)]) $2814b83f7132876d$var$deepDelete(this.movedSet, n2);
                        else this.removes.push({
                            parentId: parentId,
                            id: nodeId,
                            isShadow: $2814b83f7132876d$var$isShadowRoot(m.target) && $2814b83f7132876d$var$isNativeShadowDom(m.target) ? true : void 0
                        });
                        this.mapRemoves.push(n2);
                    });
                    break;
            }
        };
        this.genAdds = (n2, target)=>{
            if (this.processedNodeManager.inOtherBuffer(n2, this)) return;
            if (this.addedSet.has(n2) || this.movedSet.has(n2)) return;
            if (this.mirror.hasNode(n2)) {
                if ($2814b83f7132876d$var$isIgnored(n2, this.mirror)) return;
                this.movedSet.add(n2);
                let targetId = null;
                if (target && this.mirror.hasNode(target)) targetId = this.mirror.getId(target);
                if (targetId && targetId !== -1) this.movedMap[$2814b83f7132876d$var$moveKey(this.mirror.getId(n2), targetId)] = true;
            } else {
                this.addedSet.add(n2);
                this.droppedSet.delete(n2);
            }
            if (!$2814b83f7132876d$var$isBlocked(n2, this.blockClass, this.blockSelector, this.unblockSelector, false)) {
                n2.childNodes.forEach((childN)=>this.genAdds(childN));
                if ($2814b83f7132876d$var$hasShadowRoot(n2)) n2.shadowRoot.childNodes.forEach((childN)=>{
                    this.processedNodeManager.add(childN, this);
                    this.genAdds(childN, n2);
                });
            }
        };
    }
    init(options) {
        [
            "mutationCb",
            "blockClass",
            "blockSelector",
            "unblockSelector",
            "maskAllText",
            "maskTextClass",
            "unmaskTextClass",
            "maskTextSelector",
            "unmaskTextSelector",
            "inlineStylesheet",
            "maskInputOptions",
            "maskAttributeFn",
            "maskTextFn",
            "maskInputFn",
            "keepIframeSrcFn",
            "recordCanvas",
            "inlineImages",
            "slimDOMOptions",
            "dataURLOptions",
            "doc",
            "mirror",
            "iframeManager",
            "stylesheetManager",
            "shadowDomManager",
            "canvasManager",
            "processedNodeManager"
        ].forEach((key)=>{
            this[key] = options[key];
        });
    }
    freeze() {
        this.frozen = true;
        this.canvasManager.freeze();
    }
    unfreeze() {
        this.frozen = false;
        this.canvasManager.unfreeze();
        this.emit();
    }
    isFrozen() {
        return this.frozen;
    }
    lock() {
        this.locked = true;
        this.canvasManager.lock();
    }
    unlock() {
        this.locked = false;
        this.canvasManager.unlock();
        this.emit();
    }
    reset() {
        this.shadowDomManager.reset();
        this.canvasManager.reset();
    }
}
function $2814b83f7132876d$var$deepDelete(addsSet, n2) {
    addsSet.delete(n2);
    n2.childNodes.forEach((childN)=>$2814b83f7132876d$var$deepDelete(addsSet, childN));
}
function $2814b83f7132876d$var$isParentRemoved(removes, n2, mirror2) {
    if (removes.length === 0) return false;
    return $2814b83f7132876d$var$_isParentRemoved(removes, n2, mirror2);
}
function $2814b83f7132876d$var$_isParentRemoved(removes, n2, mirror2) {
    let node = n2.parentNode;
    while(node){
        const parentId = mirror2.getId(node);
        if (removes.some((r2)=>r2.id === parentId)) return true;
        node = node.parentNode;
    }
    return false;
}
function $2814b83f7132876d$var$isAncestorInSet(set, n2) {
    if (set.size === 0) return false;
    return $2814b83f7132876d$var$_isAncestorInSet(set, n2);
}
function $2814b83f7132876d$var$_isAncestorInSet(set, n2) {
    const { parentNode: parentNode } = n2;
    if (!parentNode) return false;
    if (set.has(parentNode)) return true;
    return $2814b83f7132876d$var$_isAncestorInSet(set, parentNode);
}
let $2814b83f7132876d$var$errorHandler;
function $2814b83f7132876d$var$registerErrorHandler(handler) {
    $2814b83f7132876d$var$errorHandler = handler;
}
function $2814b83f7132876d$var$unregisterErrorHandler() {
    $2814b83f7132876d$var$errorHandler = void 0;
}
const $2814b83f7132876d$var$callbackWrapper = (cb)=>{
    if (!$2814b83f7132876d$var$errorHandler) return cb;
    const rrwebWrapped = (...rest)=>{
        try {
            return cb(...rest);
        } catch (error) {
            if ($2814b83f7132876d$var$errorHandler && $2814b83f7132876d$var$errorHandler(error) === true) return ()=>{};
            throw error;
        }
    };
    return rrwebWrapped;
};
const $2814b83f7132876d$var$mutationBuffers = [];
function $2814b83f7132876d$var$getEventTarget(event) {
    try {
        if ("composedPath" in event) {
            const path = event.composedPath();
            if (path.length) return path[0];
        } else if ("path" in event && event.path.length) return event.path[0];
    } catch  {}
    return event && event.target;
}
function $2814b83f7132876d$var$initMutationObserver(options, rootEl) {
    const mutationBuffer = new $2814b83f7132876d$var$MutationBuffer();
    $2814b83f7132876d$var$mutationBuffers.push(mutationBuffer);
    mutationBuffer.init(options);
    let mutationObserverCtor = window.MutationObserver || /**
  * Some websites may disable MutationObserver by removing it from the window object.
  * If someone is using rrweb to build a browser extention or things like it, they
  * could not change the website's code but can have an opportunity to inject some
  * code before the website executing its JS logic.
  * Then they can do this to store the native MutationObserver:
  * window.__rrMutationObserver = MutationObserver
  */ window.__rrMutationObserver;
    const angularZoneSymbol = window?.Zone?.__symbol__?.("MutationObserver");
    if (angularZoneSymbol && window[angularZoneSymbol]) mutationObserverCtor = window[angularZoneSymbol];
    const observer = new mutationObserverCtor($2814b83f7132876d$var$callbackWrapper((mutations)=>{
        if (options.onMutation && options.onMutation(mutations) === false) return;
        mutationBuffer.processMutations.bind(mutationBuffer)(mutations);
    }));
    observer.observe(rootEl, {
        attributes: true,
        attributeOldValue: true,
        characterData: true,
        characterDataOldValue: true,
        childList: true,
        subtree: true
    });
    return observer;
}
function $2814b83f7132876d$var$initMoveObserver({ mousemoveCb: mousemoveCb, sampling: sampling, doc: doc, mirror: mirror2 }) {
    if (sampling.mousemove === false) return ()=>{};
    const threshold = typeof sampling.mousemove === "number" ? sampling.mousemove : 50;
    const callbackThreshold = typeof sampling.mousemoveCallback === "number" ? sampling.mousemoveCallback : 500;
    let positions = [];
    let timeBaseline;
    const wrappedCb = $2814b83f7132876d$var$throttle$1($2814b83f7132876d$var$callbackWrapper((source)=>{
        const totalOffset = Date.now() - timeBaseline;
        mousemoveCb(positions.map((p)=>{
            p.timeOffset -= totalOffset;
            return p;
        }), source);
        positions = [];
        timeBaseline = null;
    }), callbackThreshold);
    const updatePosition = $2814b83f7132876d$var$callbackWrapper($2814b83f7132876d$var$throttle$1($2814b83f7132876d$var$callbackWrapper((evt)=>{
        const target = $2814b83f7132876d$var$getEventTarget(evt);
        const { clientX: clientX, clientY: clientY } = $2814b83f7132876d$var$legacy_isTouchEvent(evt) ? evt.changedTouches[0] : evt;
        if (!timeBaseline) timeBaseline = $2814b83f7132876d$var$nowTimestamp();
        positions.push({
            x: clientX,
            y: clientY,
            id: mirror2.getId(target),
            timeOffset: $2814b83f7132876d$var$nowTimestamp() - timeBaseline
        });
        wrappedCb(typeof DragEvent !== "undefined" && evt instanceof DragEvent ? $2814b83f7132876d$var$IncrementalSource.Drag : evt instanceof MouseEvent ? $2814b83f7132876d$var$IncrementalSource.MouseMove : $2814b83f7132876d$var$IncrementalSource.TouchMove);
    }), threshold, {
        trailing: false
    }));
    const handlers = [
        $2814b83f7132876d$var$on("mousemove", updatePosition, doc),
        $2814b83f7132876d$var$on("touchmove", updatePosition, doc),
        $2814b83f7132876d$var$on("drag", updatePosition, doc)
    ];
    return $2814b83f7132876d$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $2814b83f7132876d$var$initMouseInteractionObserver({ mouseInteractionCb: mouseInteractionCb, doc: doc, mirror: mirror2, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, sampling: sampling }) {
    if (sampling.mouseInteraction === false) return ()=>{};
    const disableMap = sampling.mouseInteraction === true || sampling.mouseInteraction === void 0 ? {} : sampling.mouseInteraction;
    const handlers = [];
    let currentPointerType = null;
    const getHandler = (eventKey)=>{
        return (event)=>{
            const target = $2814b83f7132876d$var$getEventTarget(event);
            if ($2814b83f7132876d$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
            let pointerType = null;
            let thisEventKey = eventKey;
            if ("pointerType" in event) {
                switch(event.pointerType){
                    case "mouse":
                        pointerType = $2814b83f7132876d$var$PointerTypes.Mouse;
                        break;
                    case "touch":
                        pointerType = $2814b83f7132876d$var$PointerTypes.Touch;
                        break;
                    case "pen":
                        pointerType = $2814b83f7132876d$var$PointerTypes.Pen;
                        break;
                }
                if (pointerType === $2814b83f7132876d$var$PointerTypes.Touch) {
                    if ($2814b83f7132876d$var$MouseInteractions[eventKey] === $2814b83f7132876d$var$MouseInteractions.MouseDown) thisEventKey = "TouchStart";
                    else if ($2814b83f7132876d$var$MouseInteractions[eventKey] === $2814b83f7132876d$var$MouseInteractions.MouseUp) thisEventKey = "TouchEnd";
                } else $2814b83f7132876d$var$PointerTypes.Pen;
            } else if ($2814b83f7132876d$var$legacy_isTouchEvent(event)) pointerType = $2814b83f7132876d$var$PointerTypes.Touch;
            if (pointerType !== null) {
                currentPointerType = pointerType;
                if (thisEventKey.startsWith("Touch") && pointerType === $2814b83f7132876d$var$PointerTypes.Touch || thisEventKey.startsWith("Mouse") && pointerType === $2814b83f7132876d$var$PointerTypes.Mouse) pointerType = null;
            } else if ($2814b83f7132876d$var$MouseInteractions[eventKey] === $2814b83f7132876d$var$MouseInteractions.Click) {
                pointerType = currentPointerType;
                currentPointerType = null;
            }
            const e2 = $2814b83f7132876d$var$legacy_isTouchEvent(event) ? event.changedTouches[0] : event;
            if (!e2) return;
            const id = mirror2.getId(target);
            const { clientX: clientX, clientY: clientY } = e2;
            $2814b83f7132876d$var$callbackWrapper(mouseInteractionCb)({
                type: $2814b83f7132876d$var$MouseInteractions[thisEventKey],
                id: id,
                x: clientX,
                y: clientY,
                ...pointerType !== null && {
                    pointerType: pointerType
                }
            });
        };
    };
    Object.keys($2814b83f7132876d$var$MouseInteractions).filter((key)=>Number.isNaN(Number(key)) && !key.endsWith("_Departed") && disableMap[key] !== false).forEach((eventKey)=>{
        let eventName = $2814b83f7132876d$var$toLowerCase(eventKey);
        const handler = getHandler(eventKey);
        if (window.PointerEvent) switch($2814b83f7132876d$var$MouseInteractions[eventKey]){
            case $2814b83f7132876d$var$MouseInteractions.MouseDown:
            case $2814b83f7132876d$var$MouseInteractions.MouseUp:
                eventName = eventName.replace("mouse", "pointer");
                break;
            case $2814b83f7132876d$var$MouseInteractions.TouchStart:
            case $2814b83f7132876d$var$MouseInteractions.TouchEnd:
                return;
        }
        handlers.push($2814b83f7132876d$var$on(eventName, handler, doc));
    });
    return $2814b83f7132876d$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $2814b83f7132876d$var$initScrollObserver({ scrollCb: scrollCb, doc: doc, mirror: mirror2, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, sampling: sampling }) {
    const updatePosition = $2814b83f7132876d$var$callbackWrapper($2814b83f7132876d$var$throttle$1($2814b83f7132876d$var$callbackWrapper((evt)=>{
        const target = $2814b83f7132876d$var$getEventTarget(evt);
        if (!target || $2814b83f7132876d$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
        const id = mirror2.getId(target);
        if (target === doc && doc.defaultView) {
            const scrollLeftTop = $2814b83f7132876d$var$getWindowScroll(doc.defaultView);
            scrollCb({
                id: id,
                x: scrollLeftTop.left,
                y: scrollLeftTop.top
            });
        } else scrollCb({
            id: id,
            x: target.scrollLeft,
            y: target.scrollTop
        });
    }), sampling.scroll || 100));
    return $2814b83f7132876d$var$on("scroll", updatePosition, doc);
}
function $2814b83f7132876d$var$initViewportResizeObserver({ viewportResizeCb: viewportResizeCb }, { win: win }) {
    let lastH = -1;
    let lastW = -1;
    const updateDimension = $2814b83f7132876d$var$callbackWrapper($2814b83f7132876d$var$throttle$1($2814b83f7132876d$var$callbackWrapper(()=>{
        const height = $2814b83f7132876d$var$getWindowHeight();
        const width = $2814b83f7132876d$var$getWindowWidth();
        if (lastH !== height || lastW !== width) {
            viewportResizeCb({
                width: Number(width),
                height: Number(height)
            });
            lastH = height;
            lastW = width;
        }
    }), 200));
    return $2814b83f7132876d$var$on("resize", updateDimension, win);
}
const $2814b83f7132876d$var$INPUT_TAGS = [
    "INPUT",
    "TEXTAREA",
    "SELECT"
];
const $2814b83f7132876d$var$lastInputValueMap = /* @__PURE__ */ new WeakMap();
function $2814b83f7132876d$var$initInputObserver({ inputCb: inputCb, doc: doc, mirror: mirror2, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, ignoreClass: ignoreClass, ignoreSelector: ignoreSelector, maskInputOptions: maskInputOptions, maskInputFn: maskInputFn, sampling: sampling, userTriggeredOnInput: userTriggeredOnInput, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector }) {
    function eventHandler(event) {
        let target = $2814b83f7132876d$var$getEventTarget(event);
        const userTriggered = event.isTrusted;
        const tagName = target && $2814b83f7132876d$var$toUpperCase(target.tagName);
        if (tagName === "OPTION") target = target.parentElement;
        if (!target || !tagName || $2814b83f7132876d$var$INPUT_TAGS.indexOf(tagName) < 0 || $2814b83f7132876d$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
        const el = target;
        if (el.classList.contains(ignoreClass) || ignoreSelector && el.matches(ignoreSelector)) return;
        const type = $2814b83f7132876d$var$getInputType(target);
        let text = $2814b83f7132876d$var$getInputValue(el, tagName, type);
        let isChecked = false;
        const isInputMasked = $2814b83f7132876d$var$shouldMaskInput({
            maskInputOptions: maskInputOptions,
            tagName: tagName,
            type: type
        });
        const forceMask = $2814b83f7132876d$var$needMaskingText(target, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, isInputMasked);
        if (type === "radio" || type === "checkbox") isChecked = target.checked;
        text = $2814b83f7132876d$var$maskInputValue({
            isMasked: forceMask,
            element: target,
            value: text,
            maskInputFn: maskInputFn
        });
        cbWithDedup(target, userTriggeredOnInput ? {
            text: text,
            isChecked: isChecked,
            userTriggered: userTriggered
        } : {
            text: text,
            isChecked: isChecked
        });
        const name = target.name;
        if (type === "radio" && name && isChecked) doc.querySelectorAll(`input[type="radio"][name="${name}"]`).forEach((el2)=>{
            if (el2 !== target) {
                const text2 = $2814b83f7132876d$var$maskInputValue({
                    // share mask behavior of `target`
                    isMasked: forceMask,
                    element: el2,
                    value: $2814b83f7132876d$var$getInputValue(el2, tagName, type),
                    maskInputFn: maskInputFn
                });
                cbWithDedup(el2, userTriggeredOnInput ? {
                    text: text2,
                    isChecked: !isChecked,
                    userTriggered: false
                } : {
                    text: text2,
                    isChecked: !isChecked
                });
            }
        });
    }
    function cbWithDedup(target, v2) {
        const lastInputValue = $2814b83f7132876d$var$lastInputValueMap.get(target);
        if (!lastInputValue || lastInputValue.text !== v2.text || lastInputValue.isChecked !== v2.isChecked) {
            $2814b83f7132876d$var$lastInputValueMap.set(target, v2);
            const id = mirror2.getId(target);
            $2814b83f7132876d$var$callbackWrapper(inputCb)({
                ...v2,
                id: id
            });
        }
    }
    const events = sampling.input === "last" ? [
        "change"
    ] : [
        "input",
        "change"
    ];
    const handlers = events.map((eventName)=>$2814b83f7132876d$var$on(eventName, $2814b83f7132876d$var$callbackWrapper(eventHandler), doc));
    const currentWindow = doc.defaultView;
    if (!currentWindow) return ()=>{
        handlers.forEach((h)=>h());
    };
    const propertyDescriptor = currentWindow.Object.getOwnPropertyDescriptor(currentWindow.HTMLInputElement.prototype, "value");
    const hookProperties = [
        [
            currentWindow.HTMLInputElement.prototype,
            "value"
        ],
        [
            currentWindow.HTMLInputElement.prototype,
            "checked"
        ],
        [
            currentWindow.HTMLSelectElement.prototype,
            "value"
        ],
        [
            currentWindow.HTMLTextAreaElement.prototype,
            "value"
        ],
        // Some UI library use selectedIndex to set select value
        [
            currentWindow.HTMLSelectElement.prototype,
            "selectedIndex"
        ],
        [
            currentWindow.HTMLOptionElement.prototype,
            "selected"
        ]
    ];
    if (propertyDescriptor && propertyDescriptor.set) handlers.push(...hookProperties.map((p)=>$2814b83f7132876d$var$hookSetter(p[0], p[1], {
            set () {
                $2814b83f7132876d$var$callbackWrapper(eventHandler)({
                    target: this,
                    isTrusted: false
                });
            }
        }, false, currentWindow)));
    return $2814b83f7132876d$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $2814b83f7132876d$var$getNestedCSSRulePositions(rule) {
    const positions = [];
    function recurse(childRule, pos) {
        if ($2814b83f7132876d$var$hasNestedCSSRule("CSSGroupingRule") && childRule.parentRule instanceof CSSGroupingRule || $2814b83f7132876d$var$hasNestedCSSRule("CSSMediaRule") && childRule.parentRule instanceof CSSMediaRule || $2814b83f7132876d$var$hasNestedCSSRule("CSSSupportsRule") && childRule.parentRule instanceof CSSSupportsRule || $2814b83f7132876d$var$hasNestedCSSRule("CSSConditionRule") && childRule.parentRule instanceof CSSConditionRule) {
            const rules2 = Array.from(childRule.parentRule.cssRules);
            const index = rules2.indexOf(childRule);
            pos.unshift(index);
        } else if (childRule.parentStyleSheet) {
            const rules2 = Array.from(childRule.parentStyleSheet.cssRules);
            const index = rules2.indexOf(childRule);
            pos.unshift(index);
        }
        return pos;
    }
    return recurse(rule, positions);
}
function $2814b83f7132876d$var$getIdAndStyleId(sheet, mirror2, styleMirror) {
    let id, styleId;
    if (!sheet) return {};
    if (sheet.ownerNode) id = mirror2.getId(sheet.ownerNode);
    else styleId = styleMirror.getId(sheet);
    return {
        styleId: styleId,
        id: id
    };
}
function $2814b83f7132876d$var$initStyleSheetObserver({ styleSheetRuleCb: styleSheetRuleCb, mirror: mirror2, stylesheetManager: stylesheetManager }, { win: win }) {
    if (!win.CSSStyleSheet || !win.CSSStyleSheet.prototype) return ()=>{};
    const insertRule = win.CSSStyleSheet.prototype.insertRule;
    win.CSSStyleSheet.prototype.insertRule = new Proxy(insertRule, {
        apply: $2814b83f7132876d$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [rule, index] = argumentsList;
            const { id: id, styleId: styleId } = $2814b83f7132876d$var$getIdAndStyleId(thisArg, mirror2, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                id: id,
                styleId: styleId,
                adds: [
                    {
                        rule: rule,
                        index: index
                    }
                ]
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    const deleteRule = win.CSSStyleSheet.prototype.deleteRule;
    win.CSSStyleSheet.prototype.deleteRule = new Proxy(deleteRule, {
        apply: $2814b83f7132876d$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [index] = argumentsList;
            const { id: id, styleId: styleId } = $2814b83f7132876d$var$getIdAndStyleId(thisArg, mirror2, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                id: id,
                styleId: styleId,
                removes: [
                    {
                        index: index
                    }
                ]
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    let replace;
    if (win.CSSStyleSheet.prototype.replace) {
        replace = win.CSSStyleSheet.prototype.replace;
        win.CSSStyleSheet.prototype.replace = new Proxy(replace, {
            apply: $2814b83f7132876d$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [text] = argumentsList;
                const { id: id, styleId: styleId } = $2814b83f7132876d$var$getIdAndStyleId(thisArg, mirror2, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    replace: text
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    }
    let replaceSync;
    if (win.CSSStyleSheet.prototype.replaceSync) {
        replaceSync = win.CSSStyleSheet.prototype.replaceSync;
        win.CSSStyleSheet.prototype.replaceSync = new Proxy(replaceSync, {
            apply: $2814b83f7132876d$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [text] = argumentsList;
                const { id: id, styleId: styleId } = $2814b83f7132876d$var$getIdAndStyleId(thisArg, mirror2, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    replaceSync: text
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    }
    const supportedNestedCSSRuleTypes = {};
    if ($2814b83f7132876d$var$canMonkeyPatchNestedCSSRule("CSSGroupingRule")) supportedNestedCSSRuleTypes.CSSGroupingRule = win.CSSGroupingRule;
    else {
        if ($2814b83f7132876d$var$canMonkeyPatchNestedCSSRule("CSSMediaRule")) supportedNestedCSSRuleTypes.CSSMediaRule = win.CSSMediaRule;
        if ($2814b83f7132876d$var$canMonkeyPatchNestedCSSRule("CSSConditionRule")) supportedNestedCSSRuleTypes.CSSConditionRule = win.CSSConditionRule;
        if ($2814b83f7132876d$var$canMonkeyPatchNestedCSSRule("CSSSupportsRule")) supportedNestedCSSRuleTypes.CSSSupportsRule = win.CSSSupportsRule;
    }
    const unmodifiedFunctions = {};
    Object.entries(supportedNestedCSSRuleTypes).forEach(([typeKey, type])=>{
        unmodifiedFunctions[typeKey] = {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            insertRule: type.prototype.insertRule,
            // eslint-disable-next-line @typescript-eslint/unbound-method
            deleteRule: type.prototype.deleteRule
        };
        type.prototype.insertRule = new Proxy(unmodifiedFunctions[typeKey].insertRule, {
            apply: $2814b83f7132876d$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [rule, index] = argumentsList;
                const { id: id, styleId: styleId } = $2814b83f7132876d$var$getIdAndStyleId(thisArg.parentStyleSheet, mirror2, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    adds: [
                        {
                            rule: rule,
                            index: [
                                ...$2814b83f7132876d$var$getNestedCSSRulePositions(thisArg),
                                index || 0
                            ]
                        }
                    ]
                });
                return target.apply(thisArg, argumentsList);
            })
        });
        type.prototype.deleteRule = new Proxy(unmodifiedFunctions[typeKey].deleteRule, {
            apply: $2814b83f7132876d$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [index] = argumentsList;
                const { id: id, styleId: styleId } = $2814b83f7132876d$var$getIdAndStyleId(thisArg.parentStyleSheet, mirror2, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    removes: [
                        {
                            index: [
                                ...$2814b83f7132876d$var$getNestedCSSRulePositions(thisArg),
                                index
                            ]
                        }
                    ]
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    });
    return $2814b83f7132876d$var$callbackWrapper(()=>{
        win.CSSStyleSheet.prototype.insertRule = insertRule;
        win.CSSStyleSheet.prototype.deleteRule = deleteRule;
        replace && (win.CSSStyleSheet.prototype.replace = replace);
        replaceSync && (win.CSSStyleSheet.prototype.replaceSync = replaceSync);
        Object.entries(supportedNestedCSSRuleTypes).forEach(([typeKey, type])=>{
            type.prototype.insertRule = unmodifiedFunctions[typeKey].insertRule;
            type.prototype.deleteRule = unmodifiedFunctions[typeKey].deleteRule;
        });
    });
}
function $2814b83f7132876d$var$initAdoptedStyleSheetObserver({ mirror: mirror2, stylesheetManager: stylesheetManager }, host) {
    let hostId = null;
    if (host.nodeName === "#document") hostId = mirror2.getId(host);
    else hostId = mirror2.getId(host.host);
    const patchTarget = host.nodeName === "#document" ? host.defaultView?.Document : host.ownerDocument?.defaultView?.ShadowRoot;
    const originalPropertyDescriptor = patchTarget?.prototype ? Object.getOwnPropertyDescriptor(patchTarget?.prototype, "adoptedStyleSheets") : void 0;
    if (hostId === null || hostId === -1 || !patchTarget || !originalPropertyDescriptor) return ()=>{};
    Object.defineProperty(host, "adoptedStyleSheets", {
        configurable: originalPropertyDescriptor.configurable,
        enumerable: originalPropertyDescriptor.enumerable,
        get () {
            return originalPropertyDescriptor.get?.call(this);
        },
        set (sheets) {
            const result = originalPropertyDescriptor.set?.call(this, sheets);
            if (hostId !== null && hostId !== -1) try {
                stylesheetManager.adoptStyleSheets(sheets, hostId);
            } catch (e2) {}
            return result;
        }
    });
    return $2814b83f7132876d$var$callbackWrapper(()=>{
        Object.defineProperty(host, "adoptedStyleSheets", {
            configurable: originalPropertyDescriptor.configurable,
            enumerable: originalPropertyDescriptor.enumerable,
            // eslint-disable-next-line @typescript-eslint/unbound-method
            get: originalPropertyDescriptor.get,
            // eslint-disable-next-line @typescript-eslint/unbound-method
            set: originalPropertyDescriptor.set
        });
    });
}
function $2814b83f7132876d$var$initStyleDeclarationObserver({ styleDeclarationCb: styleDeclarationCb, mirror: mirror2, ignoreCSSAttributes: ignoreCSSAttributes, stylesheetManager: stylesheetManager }, { win: win }) {
    const setProperty = win.CSSStyleDeclaration.prototype.setProperty;
    win.CSSStyleDeclaration.prototype.setProperty = new Proxy(setProperty, {
        apply: $2814b83f7132876d$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [property, value, priority] = argumentsList;
            if (ignoreCSSAttributes.has(property)) return setProperty.apply(thisArg, [
                property,
                value,
                priority
            ]);
            const { id: id, styleId: styleId } = $2814b83f7132876d$var$getIdAndStyleId(thisArg.parentRule?.parentStyleSheet, mirror2, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleDeclarationCb({
                id: id,
                styleId: styleId,
                set: {
                    property: property,
                    value: value,
                    priority: priority
                },
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                index: $2814b83f7132876d$var$getNestedCSSRulePositions(thisArg.parentRule)
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    const removeProperty = win.CSSStyleDeclaration.prototype.removeProperty;
    win.CSSStyleDeclaration.prototype.removeProperty = new Proxy(removeProperty, {
        apply: $2814b83f7132876d$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [property] = argumentsList;
            if (ignoreCSSAttributes.has(property)) return removeProperty.apply(thisArg, [
                property
            ]);
            const { id: id, styleId: styleId } = $2814b83f7132876d$var$getIdAndStyleId(thisArg.parentRule?.parentStyleSheet, mirror2, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleDeclarationCb({
                id: id,
                styleId: styleId,
                remove: {
                    property: property
                },
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                index: $2814b83f7132876d$var$getNestedCSSRulePositions(thisArg.parentRule)
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    return $2814b83f7132876d$var$callbackWrapper(()=>{
        win.CSSStyleDeclaration.prototype.setProperty = setProperty;
        win.CSSStyleDeclaration.prototype.removeProperty = removeProperty;
    });
}
function $2814b83f7132876d$var$initMediaInteractionObserver({ mediaInteractionCb: mediaInteractionCb, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, mirror: mirror2, sampling: sampling, doc: doc }) {
    const handler = $2814b83f7132876d$var$callbackWrapper((type)=>$2814b83f7132876d$var$throttle$1($2814b83f7132876d$var$callbackWrapper((event)=>{
            const target = $2814b83f7132876d$var$getEventTarget(event);
            if (!target || $2814b83f7132876d$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
            const { currentTime: currentTime, volume: volume, muted: muted, playbackRate: playbackRate } = target;
            mediaInteractionCb({
                type: type,
                id: mirror2.getId(target),
                currentTime: currentTime,
                volume: volume,
                muted: muted,
                playbackRate: playbackRate
            });
        }), sampling.media || 500));
    const handlers = [
        $2814b83f7132876d$var$on("play", handler($2814b83f7132876d$var$MediaInteractions.Play), doc),
        $2814b83f7132876d$var$on("pause", handler($2814b83f7132876d$var$MediaInteractions.Pause), doc),
        $2814b83f7132876d$var$on("seeked", handler($2814b83f7132876d$var$MediaInteractions.Seeked), doc),
        $2814b83f7132876d$var$on("volumechange", handler($2814b83f7132876d$var$MediaInteractions.VolumeChange), doc),
        $2814b83f7132876d$var$on("ratechange", handler($2814b83f7132876d$var$MediaInteractions.RateChange), doc)
    ];
    return $2814b83f7132876d$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $2814b83f7132876d$var$initFontObserver({ fontCb: fontCb, doc: doc }) {
    const win = doc.defaultView;
    if (!win) return ()=>{};
    const handlers = [];
    const fontMap = /* @__PURE__ */ new WeakMap();
    const originalFontFace = win.FontFace;
    win.FontFace = function FontFace2(family, source, descriptors) {
        const fontFace = new originalFontFace(family, source, descriptors);
        fontMap.set(fontFace, {
            family: family,
            buffer: typeof source !== "string",
            descriptors: descriptors,
            fontSource: typeof source === "string" ? source : JSON.stringify(Array.from(new Uint8Array(source)))
        });
        return fontFace;
    };
    const restoreHandler = $2814b83f7132876d$var$patch(doc.fonts, "add", function(original) {
        return function(fontFace) {
            $2814b83f7132876d$var$setTimeout$1($2814b83f7132876d$var$callbackWrapper(()=>{
                const p = fontMap.get(fontFace);
                if (p) {
                    fontCb(p);
                    fontMap.delete(fontFace);
                }
            }), 0);
            return original.apply(this, [
                fontFace
            ]);
        };
    });
    handlers.push(()=>{
        win.FontFace = originalFontFace;
    });
    handlers.push(restoreHandler);
    return $2814b83f7132876d$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $2814b83f7132876d$var$initSelectionObserver(param) {
    const { doc: doc, mirror: mirror2, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, selectionCb: selectionCb } = param;
    let collapsed = true;
    const updateSelection = $2814b83f7132876d$var$callbackWrapper(()=>{
        const selection = doc.getSelection();
        if (!selection || collapsed && selection?.isCollapsed) return;
        collapsed = selection.isCollapsed || false;
        const ranges = [];
        const count = selection.rangeCount || 0;
        for(let i2 = 0; i2 < count; i2++){
            const range = selection.getRangeAt(i2);
            const { startContainer: startContainer, startOffset: startOffset, endContainer: endContainer, endOffset: endOffset } = range;
            const blocked = $2814b83f7132876d$var$isBlocked(startContainer, blockClass, blockSelector, unblockSelector, true) || $2814b83f7132876d$var$isBlocked(endContainer, blockClass, blockSelector, unblockSelector, true);
            if (blocked) continue;
            ranges.push({
                start: mirror2.getId(startContainer),
                startOffset: startOffset,
                end: mirror2.getId(endContainer),
                endOffset: endOffset
            });
        }
        selectionCb({
            ranges: ranges
        });
    });
    updateSelection();
    return $2814b83f7132876d$var$on("selectionchange", updateSelection);
}
function $2814b83f7132876d$var$initCustomElementObserver({ doc: doc, customElementCb: customElementCb }) {
    const win = doc.defaultView;
    if (!win || !win.customElements) return ()=>{};
    const restoreHandler = $2814b83f7132876d$var$patch(win.customElements, "define", function(original) {
        return function(name, constructor, options) {
            try {
                customElementCb({
                    define: {
                        name: name
                    }
                });
            } catch (e2) {}
            return original.apply(this, [
                name,
                constructor,
                options
            ]);
        };
    });
    return restoreHandler;
}
function $2814b83f7132876d$var$initObservers(o2, _hooks = {}) {
    const currentWindow = o2.doc.defaultView;
    if (!currentWindow) return ()=>{};
    let mutationObserver;
    if (o2.recordDOM) mutationObserver = $2814b83f7132876d$var$initMutationObserver(o2, o2.doc);
    const mousemoveHandler = $2814b83f7132876d$var$initMoveObserver(o2);
    const mouseInteractionHandler = $2814b83f7132876d$var$initMouseInteractionObserver(o2);
    const scrollHandler = $2814b83f7132876d$var$initScrollObserver(o2);
    const viewportResizeHandler = $2814b83f7132876d$var$initViewportResizeObserver(o2, {
        win: currentWindow
    });
    const inputHandler = $2814b83f7132876d$var$initInputObserver(o2);
    const mediaInteractionHandler = $2814b83f7132876d$var$initMediaInteractionObserver(o2);
    let styleSheetObserver = ()=>{};
    let adoptedStyleSheetObserver = ()=>{};
    let styleDeclarationObserver = ()=>{};
    let fontObserver = ()=>{};
    if (o2.recordDOM) {
        styleSheetObserver = $2814b83f7132876d$var$initStyleSheetObserver(o2, {
            win: currentWindow
        });
        adoptedStyleSheetObserver = $2814b83f7132876d$var$initAdoptedStyleSheetObserver(o2, o2.doc);
        styleDeclarationObserver = $2814b83f7132876d$var$initStyleDeclarationObserver(o2, {
            win: currentWindow
        });
        if (o2.collectFonts) fontObserver = $2814b83f7132876d$var$initFontObserver(o2);
    }
    const selectionObserver = $2814b83f7132876d$var$initSelectionObserver(o2);
    const customElementObserver = $2814b83f7132876d$var$initCustomElementObserver(o2);
    const pluginHandlers = [];
    for (const plugin of o2.plugins)pluginHandlers.push(plugin.observer(plugin.callback, currentWindow, plugin.options));
    return $2814b83f7132876d$var$callbackWrapper(()=>{
        $2814b83f7132876d$var$mutationBuffers.forEach((b)=>b.reset());
        mutationObserver?.disconnect();
        mousemoveHandler();
        mouseInteractionHandler();
        scrollHandler();
        viewportResizeHandler();
        inputHandler();
        mediaInteractionHandler();
        styleSheetObserver();
        adoptedStyleSheetObserver();
        styleDeclarationObserver();
        fontObserver();
        selectionObserver();
        customElementObserver();
        pluginHandlers.forEach((h)=>h());
    });
}
function $2814b83f7132876d$var$hasNestedCSSRule(prop) {
    return typeof window[prop] !== "undefined";
}
function $2814b83f7132876d$var$canMonkeyPatchNestedCSSRule(prop) {
    return Boolean(typeof window[prop] !== "undefined" && // Note: Generally, this check _shouldn't_ be necessary
    // However, in some scenarios (e.g. jsdom) this can sometimes fail, so we check for it here
    window[prop].prototype && "insertRule" in window[prop].prototype && "deleteRule" in window[prop].prototype);
}
class $2814b83f7132876d$var$CrossOriginIframeMirror {
    constructor(generateIdFn){
        this.generateIdFn = generateIdFn;
        this.iframeIdToRemoteIdMap = /* @__PURE__ */ new WeakMap();
        this.iframeRemoteIdToIdMap = /* @__PURE__ */ new WeakMap();
    }
    getId(iframe, remoteId, idToRemoteMap, remoteToIdMap) {
        const idToRemoteIdMap = idToRemoteMap || this.getIdToRemoteIdMap(iframe);
        const remoteIdToIdMap = remoteToIdMap || this.getRemoteIdToIdMap(iframe);
        let id = idToRemoteIdMap.get(remoteId);
        if (!id) {
            id = this.generateIdFn();
            idToRemoteIdMap.set(remoteId, id);
            remoteIdToIdMap.set(id, remoteId);
        }
        return id;
    }
    getIds(iframe, remoteId) {
        const idToRemoteIdMap = this.getIdToRemoteIdMap(iframe);
        const remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
        return remoteId.map((id)=>this.getId(iframe, id, idToRemoteIdMap, remoteIdToIdMap));
    }
    getRemoteId(iframe, id, map) {
        const remoteIdToIdMap = map || this.getRemoteIdToIdMap(iframe);
        if (typeof id !== "number") return id;
        const remoteId = remoteIdToIdMap.get(id);
        if (!remoteId) return -1;
        return remoteId;
    }
    getRemoteIds(iframe, ids) {
        const remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
        return ids.map((id)=>this.getRemoteId(iframe, id, remoteIdToIdMap));
    }
    reset(iframe) {
        if (!iframe) {
            this.iframeIdToRemoteIdMap = /* @__PURE__ */ new WeakMap();
            this.iframeRemoteIdToIdMap = /* @__PURE__ */ new WeakMap();
            return;
        }
        this.iframeIdToRemoteIdMap.delete(iframe);
        this.iframeRemoteIdToIdMap.delete(iframe);
    }
    getIdToRemoteIdMap(iframe) {
        let idToRemoteIdMap = this.iframeIdToRemoteIdMap.get(iframe);
        if (!idToRemoteIdMap) {
            idToRemoteIdMap = /* @__PURE__ */ new Map();
            this.iframeIdToRemoteIdMap.set(iframe, idToRemoteIdMap);
        }
        return idToRemoteIdMap;
    }
    getRemoteIdToIdMap(iframe) {
        let remoteIdToIdMap = this.iframeRemoteIdToIdMap.get(iframe);
        if (!remoteIdToIdMap) {
            remoteIdToIdMap = /* @__PURE__ */ new Map();
            this.iframeRemoteIdToIdMap.set(iframe, remoteIdToIdMap);
        }
        return remoteIdToIdMap;
    }
}
class $2814b83f7132876d$var$IframeManagerNoop {
    constructor(){
        this.crossOriginIframeMirror = new $2814b83f7132876d$var$CrossOriginIframeMirror($2814b83f7132876d$var$genId);
        this.crossOriginIframeRootIdMap = /* @__PURE__ */ new WeakMap();
    }
    addIframe() {}
    addLoadListener() {}
    attachIframe() {}
}
class $2814b83f7132876d$var$IframeManager {
    constructor(options){
        this.iframes = /* @__PURE__ */ new WeakMap();
        this.crossOriginIframeMap = /* @__PURE__ */ new WeakMap();
        this.crossOriginIframeMirror = new $2814b83f7132876d$var$CrossOriginIframeMirror($2814b83f7132876d$var$genId);
        this.crossOriginIframeRootIdMap = /* @__PURE__ */ new WeakMap();
        this.mutationCb = options.mutationCb;
        this.wrappedEmit = options.wrappedEmit;
        this.stylesheetManager = options.stylesheetManager;
        this.recordCrossOriginIframes = options.recordCrossOriginIframes;
        this.crossOriginIframeStyleMirror = new $2814b83f7132876d$var$CrossOriginIframeMirror(this.stylesheetManager.styleMirror.generateId.bind(this.stylesheetManager.styleMirror));
        this.mirror = options.mirror;
        if (this.recordCrossOriginIframes) window.addEventListener("message", this.handleMessage.bind(this));
    }
    addIframe(iframeEl) {
        this.iframes.set(iframeEl, true);
        if (iframeEl.contentWindow) this.crossOriginIframeMap.set(iframeEl.contentWindow, iframeEl);
    }
    addLoadListener(cb) {
        this.loadListener = cb;
    }
    attachIframe(iframeEl, childSn) {
        this.mutationCb({
            adds: [
                {
                    parentId: this.mirror.getId(iframeEl),
                    nextId: null,
                    node: childSn
                }
            ],
            removes: [],
            texts: [],
            attributes: [],
            isAttachIframe: true
        });
        if (this.recordCrossOriginIframes) iframeEl.contentWindow?.addEventListener("message", this.handleMessage.bind(this));
        this.loadListener?.(iframeEl);
        const iframeDoc = $2814b83f7132876d$var$getIFrameContentDocument(iframeEl);
        if (iframeDoc && iframeDoc.adoptedStyleSheets && iframeDoc.adoptedStyleSheets.length > 0) this.stylesheetManager.adoptStyleSheets(iframeDoc.adoptedStyleSheets, this.mirror.getId(iframeDoc));
    }
    handleMessage(message) {
        const crossOriginMessageEvent = message;
        if (crossOriginMessageEvent.data.type !== "rrweb" || // To filter out the rrweb messages which are forwarded by some sites.
        crossOriginMessageEvent.origin !== crossOriginMessageEvent.data.origin) return;
        const iframeSourceWindow = message.source;
        if (!iframeSourceWindow) return;
        const iframeEl = this.crossOriginIframeMap.get(message.source);
        if (!iframeEl) return;
        const transformedEvent = this.transformCrossOriginEvent(iframeEl, crossOriginMessageEvent.data.event);
        if (transformedEvent) this.wrappedEmit(transformedEvent, crossOriginMessageEvent.data.isCheckout);
    }
    transformCrossOriginEvent(iframeEl, e2) {
        switch(e2.type){
            case $2814b83f7132876d$var$EventType.FullSnapshot:
                {
                    this.crossOriginIframeMirror.reset(iframeEl);
                    this.crossOriginIframeStyleMirror.reset(iframeEl);
                    this.replaceIdOnNode(e2.data.node, iframeEl);
                    const rootId = e2.data.node.id;
                    this.crossOriginIframeRootIdMap.set(iframeEl, rootId);
                    this.patchRootIdOnNode(e2.data.node, rootId);
                    return {
                        timestamp: e2.timestamp,
                        type: $2814b83f7132876d$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $2814b83f7132876d$var$IncrementalSource.Mutation,
                            adds: [
                                {
                                    parentId: this.mirror.getId(iframeEl),
                                    nextId: null,
                                    node: e2.data.node
                                }
                            ],
                            removes: [],
                            texts: [],
                            attributes: [],
                            isAttachIframe: true
                        }
                    };
                }
            case $2814b83f7132876d$var$EventType.Meta:
            case $2814b83f7132876d$var$EventType.Load:
            case $2814b83f7132876d$var$EventType.DomContentLoaded:
                return false;
            case $2814b83f7132876d$var$EventType.Plugin:
                return e2;
            case $2814b83f7132876d$var$EventType.Custom:
                this.replaceIds(e2.data.payload, iframeEl, [
                    "id",
                    "parentId",
                    "previousId",
                    "nextId"
                ]);
                return e2;
            case $2814b83f7132876d$var$EventType.IncrementalSnapshot:
                switch(e2.data.source){
                    case $2814b83f7132876d$var$IncrementalSource.Mutation:
                        e2.data.adds.forEach((n2)=>{
                            this.replaceIds(n2, iframeEl, [
                                "parentId",
                                "nextId",
                                "previousId"
                            ]);
                            this.replaceIdOnNode(n2.node, iframeEl);
                            const rootId = this.crossOriginIframeRootIdMap.get(iframeEl);
                            rootId && this.patchRootIdOnNode(n2.node, rootId);
                        });
                        e2.data.removes.forEach((n2)=>{
                            this.replaceIds(n2, iframeEl, [
                                "parentId",
                                "id"
                            ]);
                        });
                        e2.data.attributes.forEach((n2)=>{
                            this.replaceIds(n2, iframeEl, [
                                "id"
                            ]);
                        });
                        e2.data.texts.forEach((n2)=>{
                            this.replaceIds(n2, iframeEl, [
                                "id"
                            ]);
                        });
                        return e2;
                    case $2814b83f7132876d$var$IncrementalSource.Drag:
                    case $2814b83f7132876d$var$IncrementalSource.TouchMove:
                    case $2814b83f7132876d$var$IncrementalSource.MouseMove:
                        e2.data.positions.forEach((p)=>{
                            this.replaceIds(p, iframeEl, [
                                "id"
                            ]);
                        });
                        return e2;
                    case $2814b83f7132876d$var$IncrementalSource.ViewportResize:
                        return false;
                    case $2814b83f7132876d$var$IncrementalSource.MediaInteraction:
                    case $2814b83f7132876d$var$IncrementalSource.MouseInteraction:
                    case $2814b83f7132876d$var$IncrementalSource.Scroll:
                    case $2814b83f7132876d$var$IncrementalSource.CanvasMutation:
                    case $2814b83f7132876d$var$IncrementalSource.Input:
                        this.replaceIds(e2.data, iframeEl, [
                            "id"
                        ]);
                        return e2;
                    case $2814b83f7132876d$var$IncrementalSource.StyleSheetRule:
                    case $2814b83f7132876d$var$IncrementalSource.StyleDeclaration:
                        this.replaceIds(e2.data, iframeEl, [
                            "id"
                        ]);
                        this.replaceStyleIds(e2.data, iframeEl, [
                            "styleId"
                        ]);
                        return e2;
                    case $2814b83f7132876d$var$IncrementalSource.Font:
                        return e2;
                    case $2814b83f7132876d$var$IncrementalSource.Selection:
                        e2.data.ranges.forEach((range)=>{
                            this.replaceIds(range, iframeEl, [
                                "start",
                                "end"
                            ]);
                        });
                        return e2;
                    case $2814b83f7132876d$var$IncrementalSource.AdoptedStyleSheet:
                        this.replaceIds(e2.data, iframeEl, [
                            "id"
                        ]);
                        this.replaceStyleIds(e2.data, iframeEl, [
                            "styleIds"
                        ]);
                        e2.data.styles?.forEach((style)=>{
                            this.replaceStyleIds(style, iframeEl, [
                                "styleId"
                            ]);
                        });
                        return e2;
                }
        }
        return false;
    }
    replace(iframeMirror, obj, iframeEl, keys) {
        for (const key of keys){
            if (!Array.isArray(obj[key]) && typeof obj[key] !== "number") continue;
            if (Array.isArray(obj[key])) obj[key] = iframeMirror.getIds(iframeEl, obj[key]);
            else obj[key] = iframeMirror.getId(iframeEl, obj[key]);
        }
        return obj;
    }
    replaceIds(obj, iframeEl, keys) {
        return this.replace(this.crossOriginIframeMirror, obj, iframeEl, keys);
    }
    replaceStyleIds(obj, iframeEl, keys) {
        return this.replace(this.crossOriginIframeStyleMirror, obj, iframeEl, keys);
    }
    replaceIdOnNode(node, iframeEl) {
        this.replaceIds(node, iframeEl, [
            "id",
            "rootId"
        ]);
        if ("childNodes" in node) node.childNodes.forEach((child)=>{
            this.replaceIdOnNode(child, iframeEl);
        });
    }
    patchRootIdOnNode(node, rootId) {
        if (node.type !== $2814b83f7132876d$var$NodeType$2.Document && !node.rootId) node.rootId = rootId;
        if ("childNodes" in node) node.childNodes.forEach((child)=>{
            this.patchRootIdOnNode(child, rootId);
        });
    }
}
class $2814b83f7132876d$var$ShadowDomManagerNoop {
    init() {}
    addShadowRoot() {}
    observeAttachShadow() {}
    reset() {}
}
class $2814b83f7132876d$var$ShadowDomManager {
    constructor(options){
        this.shadowDoms = /* @__PURE__ */ new WeakSet();
        this.restoreHandlers = [];
        this.mutationCb = options.mutationCb;
        this.scrollCb = options.scrollCb;
        this.bypassOptions = options.bypassOptions;
        this.mirror = options.mirror;
        this.init();
    }
    init() {
        this.reset();
        this.patchAttachShadow(Element, document);
    }
    addShadowRoot(shadowRoot, doc) {
        if (!$2814b83f7132876d$var$isNativeShadowDom(shadowRoot)) return;
        if (this.shadowDoms.has(shadowRoot)) return;
        this.shadowDoms.add(shadowRoot);
        this.bypassOptions.canvasManager.addShadowRoot(shadowRoot);
        const observer = $2814b83f7132876d$var$initMutationObserver({
            ...this.bypassOptions,
            doc: doc,
            mutationCb: this.mutationCb,
            mirror: this.mirror,
            shadowDomManager: this
        }, shadowRoot);
        this.restoreHandlers.push(()=>observer.disconnect());
        this.restoreHandlers.push($2814b83f7132876d$var$initScrollObserver({
            ...this.bypassOptions,
            scrollCb: this.scrollCb,
            // https://gist.github.com/praveenpuglia/0832da687ed5a5d7a0907046c9ef1813
            // scroll is not allowed to pass the boundary, so we need to listen the shadow document
            doc: shadowRoot,
            mirror: this.mirror
        }));
        $2814b83f7132876d$var$setTimeout$1(()=>{
            if (shadowRoot.adoptedStyleSheets && shadowRoot.adoptedStyleSheets.length > 0) this.bypassOptions.stylesheetManager.adoptStyleSheets(shadowRoot.adoptedStyleSheets, this.mirror.getId(shadowRoot.host));
            this.restoreHandlers.push($2814b83f7132876d$var$initAdoptedStyleSheetObserver({
                mirror: this.mirror,
                stylesheetManager: this.bypassOptions.stylesheetManager
            }, shadowRoot));
        }, 0);
    }
    /**
   * Monkey patch 'attachShadow' of an IFrameElement to observe newly added shadow doms.
   */ observeAttachShadow(iframeElement) {
        const iframeDoc = $2814b83f7132876d$var$getIFrameContentDocument(iframeElement);
        const iframeWindow = $2814b83f7132876d$var$getIFrameContentWindow(iframeElement);
        if (!iframeDoc || !iframeWindow) return;
        this.patchAttachShadow(iframeWindow.Element, iframeDoc);
    }
    /**
   * Patch 'attachShadow' to observe newly added shadow doms.
   */ patchAttachShadow(element, doc) {
        const manager = this;
        this.restoreHandlers.push($2814b83f7132876d$var$patch(element.prototype, "attachShadow", function(original) {
            return function(option) {
                const shadowRoot = original.call(this, option);
                if (this.shadowRoot && $2814b83f7132876d$var$inDom(this)) manager.addShadowRoot(this.shadowRoot, doc);
                return shadowRoot;
            };
        }));
    }
    reset() {
        this.restoreHandlers.forEach((handler)=>{
            try {
                handler();
            } catch (e2) {}
        });
        this.restoreHandlers = [];
        this.shadowDoms = /* @__PURE__ */ new WeakSet();
        this.bypassOptions.canvasManager.resetShadowRoots();
    }
}
var $2814b83f7132876d$var$chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
var $2814b83f7132876d$var$lookup = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
for(var $2814b83f7132876d$var$i$1 = 0; $2814b83f7132876d$var$i$1 < $2814b83f7132876d$var$chars.length; $2814b83f7132876d$var$i$1++)$2814b83f7132876d$var$lookup[$2814b83f7132876d$var$chars.charCodeAt($2814b83f7132876d$var$i$1)] = $2814b83f7132876d$var$i$1;
class $2814b83f7132876d$var$CanvasManagerNoop {
    reset() {}
    freeze() {}
    unfreeze() {}
    lock() {}
    unlock() {}
    snapshot() {}
    addWindow() {}
    addShadowRoot() {}
    resetShadowRoots() {}
}
class $2814b83f7132876d$var$StylesheetManager {
    constructor(options){
        this.trackedLinkElements = /* @__PURE__ */ new WeakSet();
        this.styleMirror = new $2814b83f7132876d$var$StyleSheetMirror();
        this.mutationCb = options.mutationCb;
        this.adoptedStyleSheetCb = options.adoptedStyleSheetCb;
    }
    attachLinkElement(linkEl, childSn) {
        if ("_cssText" in childSn.attributes) this.mutationCb({
            adds: [],
            removes: [],
            texts: [],
            attributes: [
                {
                    id: childSn.id,
                    attributes: childSn.attributes
                }
            ]
        });
        this.trackLinkElement(linkEl);
    }
    trackLinkElement(linkEl) {
        if (this.trackedLinkElements.has(linkEl)) return;
        this.trackedLinkElements.add(linkEl);
        this.trackStylesheetInLinkElement(linkEl);
    }
    adoptStyleSheets(sheets, hostId) {
        if (sheets.length === 0) return;
        const adoptedStyleSheetData = {
            id: hostId,
            styleIds: []
        };
        const styles = [];
        for (const sheet of sheets){
            let styleId;
            if (!this.styleMirror.has(sheet)) {
                styleId = this.styleMirror.add(sheet);
                styles.push({
                    styleId: styleId,
                    rules: Array.from(sheet.rules || CSSRule, (r2, index)=>({
                            rule: $2814b83f7132876d$var$stringifyRule(r2),
                            index: index
                        }))
                });
            } else styleId = this.styleMirror.getId(sheet);
            adoptedStyleSheetData.styleIds.push(styleId);
        }
        if (styles.length > 0) adoptedStyleSheetData.styles = styles;
        this.adoptedStyleSheetCb(adoptedStyleSheetData);
    }
    reset() {
        this.styleMirror.reset();
        this.trackedLinkElements = /* @__PURE__ */ new WeakSet();
    }
    // TODO: take snapshot on stylesheet reload by applying event listener
    trackStylesheetInLinkElement(_linkEl) {}
}
class $2814b83f7132876d$var$ProcessedNodeManager {
    constructor(){
        this.nodeMap = /* @__PURE__ */ new WeakMap();
        this.active = false;
    }
    inOtherBuffer(node, thisBuffer) {
        const buffers = this.nodeMap.get(node);
        return buffers && Array.from(buffers).some((buffer)=>buffer !== thisBuffer);
    }
    add(node, buffer) {
        if (!this.active) {
            this.active = true;
            $2814b83f7132876d$var$onRequestAnimationFrame(()=>{
                this.nodeMap = /* @__PURE__ */ new WeakMap();
                this.active = false;
            });
        }
        this.nodeMap.set(node, (this.nodeMap.get(node) || /* @__PURE__ */ new Set()).add(buffer));
    }
    destroy() {}
}
let $2814b83f7132876d$var$wrappedEmit;
let $2814b83f7132876d$var$_takeFullSnapshot;
try {
    if (Array.from([
        1
    ], (x)=>x * 2)[0] !== 2) {
        const cleanFrame = document.createElement("iframe");
        document.body.appendChild(cleanFrame);
        Array.from = cleanFrame.contentWindow?.Array.from || Array.from;
        document.body.removeChild(cleanFrame);
    }
} catch (err) {
    console.debug("Unable to override Array.from", err);
}
const $2814b83f7132876d$var$mirror = $2814b83f7132876d$var$createMirror$2();
function $2814b83f7132876d$var$record(options = {}) {
    const { emit: emit, checkoutEveryNms: checkoutEveryNms, checkoutEveryNth: checkoutEveryNth, blockClass: blockClass = "rr-block", blockSelector: blockSelector = null, unblockSelector: unblockSelector = null, ignoreClass: ignoreClass = "rr-ignore", ignoreSelector: ignoreSelector = null, maskAllText: maskAllText = false, maskTextClass: maskTextClass = "rr-mask", unmaskTextClass: unmaskTextClass = null, maskTextSelector: maskTextSelector = null, unmaskTextSelector: unmaskTextSelector = null, inlineStylesheet: inlineStylesheet = true, maskAllInputs: maskAllInputs, maskInputOptions: _maskInputOptions, slimDOMOptions: _slimDOMOptions, maskAttributeFn: maskAttributeFn, maskInputFn: maskInputFn, maskTextFn: maskTextFn, maxCanvasSize: maxCanvasSize = null, packFn: packFn, sampling: sampling = {}, dataURLOptions: dataURLOptions = {}, mousemoveWait: mousemoveWait, recordDOM: recordDOM = true, recordCanvas: recordCanvas = false, recordCrossOriginIframes: recordCrossOriginIframes = false, recordAfter: recordAfter = options.recordAfter === "DOMContentLoaded" ? options.recordAfter : "load", userTriggeredOnInput: userTriggeredOnInput = false, collectFonts: collectFonts = false, inlineImages: inlineImages = false, plugins: plugins, keepIframeSrcFn: keepIframeSrcFn = ()=>false, ignoreCSSAttributes: ignoreCSSAttributes = /* @__PURE__ */ new Set([]), errorHandler: errorHandler2, onMutation: onMutation, getCanvasManager: getCanvasManager } = options;
    $2814b83f7132876d$var$registerErrorHandler(errorHandler2);
    const inEmittingFrame = recordCrossOriginIframes ? window.parent === window : true;
    let passEmitsToParent = false;
    if (!inEmittingFrame) try {
        if (window.parent.document) passEmitsToParent = false;
    } catch (e2) {
        passEmitsToParent = true;
    }
    if (inEmittingFrame && !emit) throw new Error("emit function is required");
    if (!inEmittingFrame && !passEmitsToParent) return ()=>{};
    if (mousemoveWait !== void 0 && sampling.mousemove === void 0) sampling.mousemove = mousemoveWait;
    $2814b83f7132876d$var$mirror.reset();
    const maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        "datetime-local": true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true,
        radio: true,
        checkbox: true
    } : _maskInputOptions !== void 0 ? _maskInputOptions : {};
    const slimDOMOptions = _slimDOMOptions === true || _slimDOMOptions === "all" ? {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaVerification: true,
        // the following are off for slimDOMOptions === true,
        // as they destroy some (hidden) info:
        headMetaAuthorship: _slimDOMOptions === "all",
        headMetaDescKeywords: _slimDOMOptions === "all"
    } : _slimDOMOptions ? _slimDOMOptions : {};
    $2814b83f7132876d$var$polyfill$1();
    let lastFullSnapshotEvent;
    let incrementalSnapshotCount = 0;
    const eventProcessor = (e2)=>{
        for (const plugin of plugins || [])if (plugin.eventProcessor) e2 = plugin.eventProcessor(e2);
        if (packFn && // Disable packing events which will be emitted to parent frames.
        !passEmitsToParent) e2 = packFn(e2);
        return e2;
    };
    $2814b83f7132876d$var$wrappedEmit = (r2, isCheckout)=>{
        const e2 = r2;
        e2.timestamp = $2814b83f7132876d$var$nowTimestamp();
        if ($2814b83f7132876d$var$mutationBuffers[0]?.isFrozen() && e2.type !== $2814b83f7132876d$var$EventType.FullSnapshot && !(e2.type === $2814b83f7132876d$var$EventType.IncrementalSnapshot && e2.data.source === $2814b83f7132876d$var$IncrementalSource.Mutation)) $2814b83f7132876d$var$mutationBuffers.forEach((buf)=>buf.unfreeze());
        if (inEmittingFrame) emit?.(eventProcessor(e2), isCheckout);
        else if (passEmitsToParent) {
            const message = {
                type: "rrweb",
                event: eventProcessor(e2),
                origin: window.location.origin,
                isCheckout: isCheckout
            };
            window.parent.postMessage(message, "*");
        }
        if (e2.type === $2814b83f7132876d$var$EventType.FullSnapshot) {
            lastFullSnapshotEvent = e2;
            incrementalSnapshotCount = 0;
        } else if (e2.type === $2814b83f7132876d$var$EventType.IncrementalSnapshot) {
            if (e2.data.source === $2814b83f7132876d$var$IncrementalSource.Mutation && e2.data.isAttachIframe) return;
            incrementalSnapshotCount++;
            const exceedCount = checkoutEveryNth && incrementalSnapshotCount >= checkoutEveryNth;
            const exceedTime = checkoutEveryNms && lastFullSnapshotEvent && e2.timestamp - lastFullSnapshotEvent.timestamp > checkoutEveryNms;
            if (exceedCount || exceedTime) takeFullSnapshot2(true);
        }
    };
    const wrappedMutationEmit = (m)=>{
        $2814b83f7132876d$var$wrappedEmit({
            type: $2814b83f7132876d$var$EventType.IncrementalSnapshot,
            data: {
                source: $2814b83f7132876d$var$IncrementalSource.Mutation,
                ...m
            }
        });
    };
    const wrappedScrollEmit = (p)=>$2814b83f7132876d$var$wrappedEmit({
            type: $2814b83f7132876d$var$EventType.IncrementalSnapshot,
            data: {
                source: $2814b83f7132876d$var$IncrementalSource.Scroll,
                ...p
            }
        });
    const wrappedCanvasMutationEmit = (p)=>$2814b83f7132876d$var$wrappedEmit({
            type: $2814b83f7132876d$var$EventType.IncrementalSnapshot,
            data: {
                source: $2814b83f7132876d$var$IncrementalSource.CanvasMutation,
                ...p
            }
        });
    const wrappedAdoptedStyleSheetEmit = (a2)=>$2814b83f7132876d$var$wrappedEmit({
            type: $2814b83f7132876d$var$EventType.IncrementalSnapshot,
            data: {
                source: $2814b83f7132876d$var$IncrementalSource.AdoptedStyleSheet,
                ...a2
            }
        });
    const stylesheetManager = new $2814b83f7132876d$var$StylesheetManager({
        mutationCb: wrappedMutationEmit,
        adoptedStyleSheetCb: wrappedAdoptedStyleSheetEmit
    });
    const iframeManager = typeof __RRWEB_EXCLUDE_IFRAME__ === "boolean" && __RRWEB_EXCLUDE_IFRAME__ ? new $2814b83f7132876d$var$IframeManagerNoop() : new $2814b83f7132876d$var$IframeManager({
        mirror: $2814b83f7132876d$var$mirror,
        mutationCb: wrappedMutationEmit,
        stylesheetManager: stylesheetManager,
        recordCrossOriginIframes: recordCrossOriginIframes,
        wrappedEmit: $2814b83f7132876d$var$wrappedEmit
    });
    for (const plugin of plugins || [])if (plugin.getMirror) plugin.getMirror({
        nodeMirror: $2814b83f7132876d$var$mirror,
        crossOriginIframeMirror: iframeManager.crossOriginIframeMirror,
        crossOriginIframeStyleMirror: iframeManager.crossOriginIframeStyleMirror
    });
    const processedNodeManager = new $2814b83f7132876d$var$ProcessedNodeManager();
    const canvasManager = $2814b83f7132876d$var$_getCanvasManager(getCanvasManager, {
        mirror: $2814b83f7132876d$var$mirror,
        win: window,
        mutationCb: (p)=>$2814b83f7132876d$var$wrappedEmit({
                type: $2814b83f7132876d$var$EventType.IncrementalSnapshot,
                data: {
                    source: $2814b83f7132876d$var$IncrementalSource.CanvasMutation,
                    ...p
                }
            }),
        recordCanvas: recordCanvas,
        blockClass: blockClass,
        blockSelector: blockSelector,
        unblockSelector: unblockSelector,
        maxCanvasSize: maxCanvasSize,
        sampling: sampling["canvas"],
        dataURLOptions: dataURLOptions,
        errorHandler: errorHandler2
    });
    const shadowDomManager = typeof __RRWEB_EXCLUDE_SHADOW_DOM__ === "boolean" && __RRWEB_EXCLUDE_SHADOW_DOM__ ? new $2814b83f7132876d$var$ShadowDomManagerNoop() : new $2814b83f7132876d$var$ShadowDomManager({
        mutationCb: wrappedMutationEmit,
        scrollCb: wrappedScrollEmit,
        bypassOptions: {
            onMutation: onMutation,
            blockClass: blockClass,
            blockSelector: blockSelector,
            unblockSelector: unblockSelector,
            maskAllText: maskAllText,
            maskTextClass: maskTextClass,
            unmaskTextClass: unmaskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            inlineStylesheet: inlineStylesheet,
            maskInputOptions: maskInputOptions,
            dataURLOptions: dataURLOptions,
            maskAttributeFn: maskAttributeFn,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            recordCanvas: recordCanvas,
            inlineImages: inlineImages,
            sampling: sampling,
            slimDOMOptions: slimDOMOptions,
            iframeManager: iframeManager,
            stylesheetManager: stylesheetManager,
            canvasManager: canvasManager,
            keepIframeSrcFn: keepIframeSrcFn,
            processedNodeManager: processedNodeManager
        },
        mirror: $2814b83f7132876d$var$mirror
    });
    const takeFullSnapshot2 = (isCheckout = false)=>{
        if (!recordDOM) return;
        $2814b83f7132876d$var$wrappedEmit({
            type: $2814b83f7132876d$var$EventType.Meta,
            data: {
                href: window.location.href,
                width: $2814b83f7132876d$var$getWindowWidth(),
                height: $2814b83f7132876d$var$getWindowHeight()
            }
        }, isCheckout);
        stylesheetManager.reset();
        shadowDomManager.init();
        $2814b83f7132876d$var$mutationBuffers.forEach((buf)=>buf.lock());
        const node = $2814b83f7132876d$var$snapshot(document, {
            mirror: $2814b83f7132876d$var$mirror,
            blockClass: blockClass,
            blockSelector: blockSelector,
            unblockSelector: unblockSelector,
            maskAllText: maskAllText,
            maskTextClass: maskTextClass,
            unmaskTextClass: unmaskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            inlineStylesheet: inlineStylesheet,
            maskAllInputs: maskInputOptions,
            maskAttributeFn: maskAttributeFn,
            maskInputFn: maskInputFn,
            maskTextFn: maskTextFn,
            slimDOM: slimDOMOptions,
            dataURLOptions: dataURLOptions,
            recordCanvas: recordCanvas,
            inlineImages: inlineImages,
            onSerialize: (n2)=>{
                if ($2814b83f7132876d$var$isSerializedIframe(n2, $2814b83f7132876d$var$mirror)) iframeManager.addIframe(n2);
                if ($2814b83f7132876d$var$isSerializedStylesheet(n2, $2814b83f7132876d$var$mirror)) stylesheetManager.trackLinkElement(n2);
                if ($2814b83f7132876d$var$hasShadowRoot(n2)) shadowDomManager.addShadowRoot(n2.shadowRoot, document);
            },
            onIframeLoad: (iframe, childSn)=>{
                iframeManager.attachIframe(iframe, childSn);
                if (iframe.contentWindow) canvasManager.addWindow(iframe.contentWindow);
                shadowDomManager.observeAttachShadow(iframe);
            },
            onStylesheetLoad: (linkEl, childSn)=>{
                stylesheetManager.attachLinkElement(linkEl, childSn);
            },
            keepIframeSrcFn: keepIframeSrcFn
        });
        if (!node) return console.warn("Failed to snapshot the document");
        $2814b83f7132876d$var$wrappedEmit({
            type: $2814b83f7132876d$var$EventType.FullSnapshot,
            data: {
                node: node,
                initialOffset: $2814b83f7132876d$var$getWindowScroll(window)
            }
        });
        $2814b83f7132876d$var$mutationBuffers.forEach((buf)=>buf.unlock());
        if (document.adoptedStyleSheets && document.adoptedStyleSheets.length > 0) stylesheetManager.adoptStyleSheets(document.adoptedStyleSheets, $2814b83f7132876d$var$mirror.getId(document));
    };
    $2814b83f7132876d$var$_takeFullSnapshot = takeFullSnapshot2;
    try {
        const handlers = [];
        const observe = (doc)=>{
            return $2814b83f7132876d$var$callbackWrapper($2814b83f7132876d$var$initObservers)({
                onMutation: onMutation,
                mutationCb: wrappedMutationEmit,
                mousemoveCb: (positions, source)=>$2814b83f7132876d$var$wrappedEmit({
                        type: $2814b83f7132876d$var$EventType.IncrementalSnapshot,
                        data: {
                            source: source,
                            positions: positions
                        }
                    }),
                mouseInteractionCb: (d)=>$2814b83f7132876d$var$wrappedEmit({
                        type: $2814b83f7132876d$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $2814b83f7132876d$var$IncrementalSource.MouseInteraction,
                            ...d
                        }
                    }),
                scrollCb: wrappedScrollEmit,
                viewportResizeCb: (d)=>$2814b83f7132876d$var$wrappedEmit({
                        type: $2814b83f7132876d$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $2814b83f7132876d$var$IncrementalSource.ViewportResize,
                            ...d
                        }
                    }),
                inputCb: (v2)=>$2814b83f7132876d$var$wrappedEmit({
                        type: $2814b83f7132876d$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $2814b83f7132876d$var$IncrementalSource.Input,
                            ...v2
                        }
                    }),
                mediaInteractionCb: (p)=>$2814b83f7132876d$var$wrappedEmit({
                        type: $2814b83f7132876d$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $2814b83f7132876d$var$IncrementalSource.MediaInteraction,
                            ...p
                        }
                    }),
                styleSheetRuleCb: (r2)=>$2814b83f7132876d$var$wrappedEmit({
                        type: $2814b83f7132876d$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $2814b83f7132876d$var$IncrementalSource.StyleSheetRule,
                            ...r2
                        }
                    }),
                styleDeclarationCb: (r2)=>$2814b83f7132876d$var$wrappedEmit({
                        type: $2814b83f7132876d$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $2814b83f7132876d$var$IncrementalSource.StyleDeclaration,
                            ...r2
                        }
                    }),
                canvasMutationCb: wrappedCanvasMutationEmit,
                fontCb: (p)=>$2814b83f7132876d$var$wrappedEmit({
                        type: $2814b83f7132876d$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $2814b83f7132876d$var$IncrementalSource.Font,
                            ...p
                        }
                    }),
                selectionCb: (p)=>{
                    $2814b83f7132876d$var$wrappedEmit({
                        type: $2814b83f7132876d$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $2814b83f7132876d$var$IncrementalSource.Selection,
                            ...p
                        }
                    });
                },
                customElementCb: (c2)=>{
                    $2814b83f7132876d$var$wrappedEmit({
                        type: $2814b83f7132876d$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $2814b83f7132876d$var$IncrementalSource.CustomElement,
                            ...c2
                        }
                    });
                },
                blockClass: blockClass,
                ignoreClass: ignoreClass,
                ignoreSelector: ignoreSelector,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                maskInputOptions: maskInputOptions,
                inlineStylesheet: inlineStylesheet,
                sampling: sampling,
                recordDOM: recordDOM,
                recordCanvas: recordCanvas,
                inlineImages: inlineImages,
                userTriggeredOnInput: userTriggeredOnInput,
                collectFonts: collectFonts,
                doc: doc,
                maskAttributeFn: maskAttributeFn,
                maskInputFn: maskInputFn,
                maskTextFn: maskTextFn,
                keepIframeSrcFn: keepIframeSrcFn,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                mirror: $2814b83f7132876d$var$mirror,
                iframeManager: iframeManager,
                stylesheetManager: stylesheetManager,
                shadowDomManager: shadowDomManager,
                processedNodeManager: processedNodeManager,
                canvasManager: canvasManager,
                ignoreCSSAttributes: ignoreCSSAttributes,
                plugins: plugins?.filter((p)=>p.observer)?.map((p)=>({
                        observer: p.observer,
                        options: p.options,
                        callback: (payload)=>$2814b83f7132876d$var$wrappedEmit({
                                type: $2814b83f7132876d$var$EventType.Plugin,
                                data: {
                                    plugin: p.name,
                                    payload: payload
                                }
                            })
                    })) || []
            }, {});
        };
        iframeManager.addLoadListener((iframeEl)=>{
            try {
                handlers.push(observe(iframeEl.contentDocument));
            } catch (error) {
                console.warn(error);
            }
        });
        const init = ()=>{
            takeFullSnapshot2();
            handlers.push(observe(document));
        };
        if (document.readyState === "interactive" || document.readyState === "complete") init();
        else {
            handlers.push($2814b83f7132876d$var$on("DOMContentLoaded", ()=>{
                $2814b83f7132876d$var$wrappedEmit({
                    type: $2814b83f7132876d$var$EventType.DomContentLoaded,
                    data: {}
                });
                if (recordAfter === "DOMContentLoaded") init();
            }));
            handlers.push($2814b83f7132876d$var$on("load", ()=>{
                $2814b83f7132876d$var$wrappedEmit({
                    type: $2814b83f7132876d$var$EventType.Load,
                    data: {}
                });
                if (recordAfter === "load") init();
            }, window));
        }
        return ()=>{
            handlers.forEach((h)=>h());
            processedNodeManager.destroy();
            $2814b83f7132876d$var$_takeFullSnapshot = void 0;
            $2814b83f7132876d$var$unregisterErrorHandler();
        };
    } catch (error) {
        console.warn(error);
    }
}
function $2814b83f7132876d$var$takeFullSnapshot(isCheckout) {
    if (!$2814b83f7132876d$var$_takeFullSnapshot) throw new Error("please take full snapshot after start recording");
    $2814b83f7132876d$var$_takeFullSnapshot(isCheckout);
}
$2814b83f7132876d$var$record.mirror = $2814b83f7132876d$var$mirror;
$2814b83f7132876d$var$record.takeFullSnapshot = $2814b83f7132876d$var$takeFullSnapshot;
function $2814b83f7132876d$var$_getCanvasManager(getCanvasManagerFn, options) {
    try {
        return getCanvasManagerFn ? getCanvasManagerFn(options) : new $2814b83f7132876d$var$CanvasManagerNoop();
    } catch  {
        console.warn("Unable to initialize CanvasManager");
        return new $2814b83f7132876d$var$CanvasManagerNoop();
    }
}
var $2814b83f7132876d$var$n;
!function(t2) {
    t2[t2.NotStarted = 0] = "NotStarted", t2[t2.Running = 1] = "Running", t2[t2.Stopped = 2] = "Stopped";
}($2814b83f7132876d$var$n || ($2814b83f7132876d$var$n = {}));
const $2814b83f7132876d$var$ReplayEventTypeIncrementalSnapshot = 3;
const $2814b83f7132876d$var$ReplayEventTypeCustom = 5;
/**
 * Converts a timestamp to ms, if it was in s, or keeps it as ms.
 */ function $2814b83f7132876d$var$timestampToMs(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp : timestamp * 1000;
}
/**
 * Converts a timestamp to s, if it was in ms, or keeps it as s.
 */ function $2814b83f7132876d$var$timestampToS(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Add a breadcrumb event to replay.
 */ function $2814b83f7132876d$var$addBreadcrumbEvent(replay, breadcrumb) {
    if (breadcrumb.category === "sentry.transaction") return;
    if ([
        "ui.click",
        "ui.input"
    ].includes(breadcrumb.category)) replay.triggerUserActivity();
    else replay.checkAndHandleExpiredSession();
    replay.addUpdate(()=>{
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        replay.throttledAddEvent({
            type: $2814b83f7132876d$var$EventType.Custom,
            // TODO: We were converting from ms to seconds for breadcrumbs, spans,
            // but maybe we should just keep them as milliseconds
            timestamp: (breadcrumb.timestamp || 0) * 1000,
            data: {
                tag: "breadcrumb",
                // normalize to max. 10 depth and 1_000 properties per object
                payload: (0, $b661d102b0d864f7$export$a3295358bff77e)(breadcrumb, 10, 1000)
            }
        });
        // Do not flush after console log messages
        return breadcrumb.category === "console";
    });
}
const $2814b83f7132876d$var$INTERACTIVE_SELECTOR = "button,a";
/** Get the closest interactive parent element, or else return the given element. */ function $2814b83f7132876d$var$getClosestInteractive(element) {
    const closestInteractive = element.closest($2814b83f7132876d$var$INTERACTIVE_SELECTOR);
    return closestInteractive || element;
}
/**
 * For clicks, we check if the target is inside of a button or link
 * If so, we use this as the target instead
 * This is useful because if you click on the image in <button><img></button>,
 * The target will be the image, not the button, which we don't want here
 */ function $2814b83f7132876d$var$getClickTargetNode(event) {
    const target = $2814b83f7132876d$var$getTargetNode(event);
    if (!target || !(target instanceof Element)) return target;
    return $2814b83f7132876d$var$getClosestInteractive(target);
}
/** Get the event target node. */ function $2814b83f7132876d$var$getTargetNode(event) {
    if ($2814b83f7132876d$var$isEventWithTarget(event)) return event.target;
    return event;
}
function $2814b83f7132876d$var$isEventWithTarget(event) {
    return typeof event === "object" && !!event && "target" in event;
}
let $2814b83f7132876d$var$handlers;
/**
 * Register a handler to be called when `window.open()` is called.
 * Returns a cleanup function.
 */ function $2814b83f7132876d$var$onWindowOpen(cb) {
    // Ensure to only register this once
    if (!$2814b83f7132876d$var$handlers) {
        $2814b83f7132876d$var$handlers = [];
        $2814b83f7132876d$var$monkeyPatchWindowOpen();
    }
    $2814b83f7132876d$var$handlers.push(cb);
    return ()=>{
        const pos = $2814b83f7132876d$var$handlers ? $2814b83f7132876d$var$handlers.indexOf(cb) : -1;
        if (pos > -1) $2814b83f7132876d$var$handlers.splice(pos, 1);
    };
}
function $2814b83f7132876d$var$monkeyPatchWindowOpen() {
    (0, $088bc5d23a73ee42$export$9563e054e6f787fb)($2814b83f7132876d$var$WINDOW, "open", function(originalWindowOpen) {
        return function(...args) {
            if ($2814b83f7132876d$var$handlers) try {
                $2814b83f7132876d$var$handlers.forEach((handler)=>handler());
            } catch (e) {
            // ignore errors in here
            }
            return originalWindowOpen.apply($2814b83f7132876d$var$WINDOW, args);
        };
    });
}
/** Any IncrementalSource for rrweb that we interpret as a kind of mutation. */ const $2814b83f7132876d$var$IncrementalMutationSources = new Set([
    $2814b83f7132876d$var$IncrementalSource.Mutation,
    $2814b83f7132876d$var$IncrementalSource.StyleSheetRule,
    $2814b83f7132876d$var$IncrementalSource.StyleDeclaration,
    $2814b83f7132876d$var$IncrementalSource.AdoptedStyleSheet,
    $2814b83f7132876d$var$IncrementalSource.CanvasMutation,
    $2814b83f7132876d$var$IncrementalSource.Selection,
    $2814b83f7132876d$var$IncrementalSource.MediaInteraction
]);
/** Handle a click. */ function $2814b83f7132876d$var$handleClick(clickDetector, clickBreadcrumb, node) {
    clickDetector.handleClick(clickBreadcrumb, node);
}
/** A click detector class that can be used to detect slow or rage clicks on elements. */ class $2814b83f7132876d$var$ClickDetector {
    // protected for testing
    constructor(replay, slowClickConfig, // Just for easier testing
    _addBreadcrumbEvent = $2814b83f7132876d$var$addBreadcrumbEvent){
        this._lastMutation = 0;
        this._lastScroll = 0;
        this._clicks = [];
        // We want everything in s, but options are in ms
        this._timeout = slowClickConfig.timeout / 1000;
        this._threshold = slowClickConfig.threshold / 1000;
        this._scrollTimeout = slowClickConfig.scrollTimeout / 1000;
        this._replay = replay;
        this._ignoreSelector = slowClickConfig.ignoreSelector;
        this._addBreadcrumbEvent = _addBreadcrumbEvent;
    }
    /** Register click detection handlers on mutation or scroll. */ addListeners() {
        const cleanupWindowOpen = $2814b83f7132876d$var$onWindowOpen(()=>{
            // Treat window.open as mutation
            this._lastMutation = $2814b83f7132876d$var$nowInSeconds();
        });
        this._teardown = ()=>{
            cleanupWindowOpen();
            this._clicks = [];
            this._lastMutation = 0;
            this._lastScroll = 0;
        };
    }
    /** Clean up listeners. */ removeListeners() {
        if (this._teardown) this._teardown();
        if (this._checkClickTimeout) clearTimeout(this._checkClickTimeout);
    }
    /** @inheritDoc */ handleClick(breadcrumb, node) {
        if ($2814b83f7132876d$var$ignoreElement(node, this._ignoreSelector) || !$2814b83f7132876d$var$isClickBreadcrumb(breadcrumb)) return;
        const newClick = {
            timestamp: $2814b83f7132876d$var$timestampToS(breadcrumb.timestamp),
            clickBreadcrumb: breadcrumb,
            // Set this to 0 so we know it originates from the click breadcrumb
            clickCount: 0,
            node: node
        };
        // If there was a click in the last 1s on the same element, ignore it - only keep a single reference per second
        if (this._clicks.some((click)=>click.node === newClick.node && Math.abs(click.timestamp - newClick.timestamp) < 1)) return;
        this._clicks.push(newClick);
        // If this is the first new click, set a timeout to check for multi clicks
        if (this._clicks.length === 1) this._scheduleCheckClicks();
    }
    /** @inheritDoc */ registerMutation(timestamp = Date.now()) {
        this._lastMutation = $2814b83f7132876d$var$timestampToS(timestamp);
    }
    /** @inheritDoc */ registerScroll(timestamp = Date.now()) {
        this._lastScroll = $2814b83f7132876d$var$timestampToS(timestamp);
    }
    /** @inheritDoc */ registerClick(element) {
        const node = $2814b83f7132876d$var$getClosestInteractive(element);
        this._handleMultiClick(node);
    }
    /** Count multiple clicks on elements. */ _handleMultiClick(node) {
        this._getClicks(node).forEach((click)=>{
            click.clickCount++;
        });
    }
    /** Get all pending clicks for a given node. */ _getClicks(node) {
        return this._clicks.filter((click)=>click.node === node);
    }
    /** Check the clicks that happened. */ _checkClicks() {
        const timedOutClicks = [];
        const now = $2814b83f7132876d$var$nowInSeconds();
        this._clicks.forEach((click)=>{
            if (!click.mutationAfter && this._lastMutation) click.mutationAfter = click.timestamp <= this._lastMutation ? this._lastMutation - click.timestamp : undefined;
            if (!click.scrollAfter && this._lastScroll) click.scrollAfter = click.timestamp <= this._lastScroll ? this._lastScroll - click.timestamp : undefined;
            // All of these are in seconds!
            if (click.timestamp + this._timeout <= now) timedOutClicks.push(click);
        });
        // Remove "old" clicks
        for (const click of timedOutClicks){
            const pos = this._clicks.indexOf(click);
            if (pos > -1) {
                this._generateBreadcrumbs(click);
                this._clicks.splice(pos, 1);
            }
        }
        // Trigger new check, unless no clicks left
        if (this._clicks.length) this._scheduleCheckClicks();
    }
    /** Generate matching breadcrumb(s) for the click. */ _generateBreadcrumbs(click) {
        const replay = this._replay;
        const hadScroll = click.scrollAfter && click.scrollAfter <= this._scrollTimeout;
        const hadMutation = click.mutationAfter && click.mutationAfter <= this._threshold;
        const isSlowClick = !hadScroll && !hadMutation;
        const { clickCount: clickCount, clickBreadcrumb: clickBreadcrumb } = click;
        // Slow click
        if (isSlowClick) {
            // If `mutationAfter` is set, it means a mutation happened after the threshold, but before the timeout
            // If not, it means we just timed out without scroll & mutation
            const timeAfterClickMs = Math.min(click.mutationAfter || this._timeout, this._timeout) * 1000;
            const endReason = timeAfterClickMs < this._timeout * 1000 ? "mutation" : "timeout";
            const breadcrumb = {
                type: "default",
                message: clickBreadcrumb.message,
                timestamp: clickBreadcrumb.timestamp,
                category: "ui.slowClickDetected",
                data: {
                    ...clickBreadcrumb.data,
                    url: $2814b83f7132876d$var$WINDOW.location.href,
                    route: replay.getCurrentRoute(),
                    timeAfterClickMs: timeAfterClickMs,
                    endReason: endReason,
                    // If clickCount === 0, it means multiClick was not correctly captured here
                    // - we still want to send 1 in this case
                    clickCount: clickCount || 1
                }
            };
            this._addBreadcrumbEvent(replay, breadcrumb);
            return;
        }
        // Multi click
        if (clickCount > 1) {
            const breadcrumb = {
                type: "default",
                message: clickBreadcrumb.message,
                timestamp: clickBreadcrumb.timestamp,
                category: "ui.multiClick",
                data: {
                    ...clickBreadcrumb.data,
                    url: $2814b83f7132876d$var$WINDOW.location.href,
                    route: replay.getCurrentRoute(),
                    clickCount: clickCount,
                    metric: true
                }
            };
            this._addBreadcrumbEvent(replay, breadcrumb);
        }
    }
    /** Schedule to check current clicks. */ _scheduleCheckClicks() {
        if (this._checkClickTimeout) clearTimeout(this._checkClickTimeout);
        this._checkClickTimeout = (0, $31c1fb7be891462e$export$831dc9f2ab0a617b)(()=>this._checkClicks(), 1000);
    }
}
const $2814b83f7132876d$var$SLOW_CLICK_TAGS = [
    "A",
    "BUTTON",
    "INPUT"
];
/** exported for tests only */ function $2814b83f7132876d$var$ignoreElement(node, ignoreSelector) {
    if (!$2814b83f7132876d$var$SLOW_CLICK_TAGS.includes(node.tagName)) return true;
    // If <input> tag, we only want to consider input[type='submit'] & input[type='button']
    if (node.tagName === "INPUT" && ![
        "submit",
        "button"
    ].includes(node.getAttribute("type") || "")) return true;
    // If <a> tag, detect special variants that may not lead to an action
    // If target !== _self, we may open the link somewhere else, which would lead to no action
    // Also, when downloading a file, we may not leave the page, but still not trigger an action
    if (node.tagName === "A" && (node.hasAttribute("download") || node.hasAttribute("target") && node.getAttribute("target") !== "_self")) return true;
    if (ignoreSelector && node.matches(ignoreSelector)) return true;
    return false;
}
function $2814b83f7132876d$var$isClickBreadcrumb(breadcrumb) {
    return !!(breadcrumb.data && typeof breadcrumb.data.nodeId === "number" && breadcrumb.timestamp);
}
// This is good enough for us, and is easier to test/mock than `timestampInSeconds`
function $2814b83f7132876d$var$nowInSeconds() {
    return Date.now() / 1000;
}
/** Update the click detector based on a recording event of rrweb. */ function $2814b83f7132876d$var$updateClickDetectorForRecordingEvent(clickDetector, event) {
    try {
        // note: We only consider incremental snapshots here
        // This means that any full snapshot is ignored for mutation detection - the reason is that we simply cannot know if a mutation happened here.
        // E.g. think that we are buffering, an error happens and we take a full snapshot because we switched to session mode -
        // in this scenario, we would not know if a dead click happened because of the error, which is a key dead click scenario.
        // Instead, by ignoring full snapshots, we have the risk that we generate a false positive
        // (if a mutation _did_ happen but was "swallowed" by the full snapshot)
        // But this should be more unlikely as we'd generally capture the incremental snapshot right away
        if (!$2814b83f7132876d$var$isIncrementalEvent(event)) return;
        const { source: source } = event.data;
        if ($2814b83f7132876d$var$IncrementalMutationSources.has(source)) clickDetector.registerMutation(event.timestamp);
        if (source === $2814b83f7132876d$var$IncrementalSource.Scroll) clickDetector.registerScroll(event.timestamp);
        if ($2814b83f7132876d$var$isIncrementalMouseInteraction(event)) {
            const { type: type, id: id } = event.data;
            const node = $2814b83f7132876d$var$record.mirror.getNode(id);
            if (node instanceof HTMLElement && type === $2814b83f7132876d$var$MouseInteractions.Click) clickDetector.registerClick(node);
        }
    } catch  {
    // ignore errors here, e.g. if accessing something that does not exist
    }
}
function $2814b83f7132876d$var$isIncrementalEvent(event) {
    return event.type === $2814b83f7132876d$var$ReplayEventTypeIncrementalSnapshot;
}
function $2814b83f7132876d$var$isIncrementalMouseInteraction(event) {
    return event.data.source === $2814b83f7132876d$var$IncrementalSource.MouseInteraction;
}
/**
 * Create a breadcrumb for a replay.
 */ function $2814b83f7132876d$var$createBreadcrumb(breadcrumb) {
    return {
        timestamp: Date.now() / 1000,
        type: "default",
        ...breadcrumb
    };
}
var $2814b83f7132876d$var$NodeType = /* @__PURE__ */ ((NodeType2)=>{
    NodeType2[NodeType2["Document"] = 0] = "Document";
    NodeType2[NodeType2["DocumentType"] = 1] = "DocumentType";
    NodeType2[NodeType2["Element"] = 2] = "Element";
    NodeType2[NodeType2["Text"] = 3] = "Text";
    NodeType2[NodeType2["CDATA"] = 4] = "CDATA";
    NodeType2[NodeType2["Comment"] = 5] = "Comment";
    return NodeType2;
})($2814b83f7132876d$var$NodeType || {});
// Note that these are the serialized attributes and not attributes directly on
// the DOM Node. Attributes we are interested in:
const $2814b83f7132876d$var$ATTRIBUTES_TO_RECORD = new Set([
    "id",
    "class",
    "aria-label",
    "role",
    "name",
    "alt",
    "title",
    "data-test-id",
    "data-testid",
    "disabled",
    "aria-disabled",
    "data-sentry-component"
]);
/**
 * Inclusion list of attributes that we want to record from the DOM element
 */ function $2814b83f7132876d$var$getAttributesToRecord(attributes) {
    const obj = {};
    if (!attributes["data-sentry-component"] && attributes["data-sentry-element"]) attributes["data-sentry-component"] = attributes["data-sentry-element"];
    for(const key in attributes)if ($2814b83f7132876d$var$ATTRIBUTES_TO_RECORD.has(key)) {
        let normalizedKey = key;
        if (key === "data-testid" || key === "data-test-id") normalizedKey = "testId";
        obj[normalizedKey] = attributes[key];
    }
    return obj;
}
const $2814b83f7132876d$var$handleDomListener = (replay)=>{
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $2814b83f7132876d$var$handleDom(handlerData);
        if (!result) return;
        const isClick = handlerData.name === "click";
        const event = isClick ? handlerData.event : undefined;
        // Ignore clicks if ctrl/alt/meta/shift keys are held down as they alter behavior of clicks (e.g. open in new tab)
        if (isClick && replay.clickDetector && event && event.target && !event.altKey && !event.metaKey && !event.ctrlKey && !event.shiftKey) $2814b83f7132876d$var$handleClick(replay.clickDetector, result, $2814b83f7132876d$var$getClickTargetNode(handlerData.event));
        $2814b83f7132876d$var$addBreadcrumbEvent(replay, result);
    };
};
/** Get the base DOM breadcrumb. */ function $2814b83f7132876d$var$getBaseDomBreadcrumb(target, message) {
    const nodeId = $2814b83f7132876d$var$record.mirror.getId(target);
    const node = nodeId && $2814b83f7132876d$var$record.mirror.getNode(nodeId);
    const meta = node && $2814b83f7132876d$var$record.mirror.getMeta(node);
    const element = meta && $2814b83f7132876d$var$isElement(meta) ? meta : null;
    return {
        message: message,
        data: element ? {
            nodeId: nodeId,
            node: {
                id: nodeId,
                tagName: element.tagName,
                textContent: Array.from(element.childNodes).map((node)=>node.type === $2814b83f7132876d$var$NodeType.Text && node.textContent).filter(Boolean) // filter out empty values
                .map((text)=>text.trim()).join(""),
                attributes: $2814b83f7132876d$var$getAttributesToRecord(element.attributes)
            }
        } : {}
    };
}
/**
 * An event handler to react to DOM events.
 * Exported for tests.
 */ function $2814b83f7132876d$var$handleDom(handlerData) {
    const { target: target, message: message } = $2814b83f7132876d$var$getDomTarget(handlerData);
    return $2814b83f7132876d$var$createBreadcrumb({
        category: `ui.${handlerData.name}`,
        ...$2814b83f7132876d$var$getBaseDomBreadcrumb(target, message)
    });
}
function $2814b83f7132876d$var$getDomTarget(handlerData) {
    const isClick = handlerData.name === "click";
    let message;
    let target = null;
    // Accessing event.target can throw (see getsentry/raven-js#838, #768)
    try {
        target = isClick ? $2814b83f7132876d$var$getClickTargetNode(handlerData.event) : $2814b83f7132876d$var$getTargetNode(handlerData.event);
        message = (0, $0a4b219981573bc1$export$5647df6b7814ac86)(target, {
            maxStringLength: 200
        }) || "<unknown>";
    } catch (e) {
        message = "<unknown>";
    }
    return {
        target: target,
        message: message
    };
}
function $2814b83f7132876d$var$isElement(node) {
    return node.type === $2814b83f7132876d$var$NodeType.Element;
}
/** Handle keyboard events & create breadcrumbs. */ function $2814b83f7132876d$var$handleKeyboardEvent(replay, event) {
    if (!replay.isEnabled()) return;
    // Update user activity, but do not restart recording as it can create
    // noisy/low-value replays (e.g. user comes back from idle, hits alt-tab, new
    // session with a single "keydown" breadcrumb is created)
    replay.updateUserActivity();
    const breadcrumb = $2814b83f7132876d$var$getKeyboardBreadcrumb(event);
    if (!breadcrumb) return;
    $2814b83f7132876d$var$addBreadcrumbEvent(replay, breadcrumb);
}
/** exported only for tests */ function $2814b83f7132876d$var$getKeyboardBreadcrumb(event) {
    const { metaKey: metaKey, shiftKey: shiftKey, ctrlKey: ctrlKey, altKey: altKey, key: key, target: target } = event;
    // never capture for input fields
    if (!target || $2814b83f7132876d$var$isInputElement(target) || !key) return null;
    // Note: We do not consider shift here, as that means "uppercase"
    const hasModifierKey = metaKey || ctrlKey || altKey;
    const isCharacterKey = key.length === 1; // other keys like Escape, Tab, etc have a longer length
    // Do not capture breadcrumb if only a word key is pressed
    // This could leak e.g. user input
    if (!hasModifierKey && isCharacterKey) return null;
    const message = (0, $0a4b219981573bc1$export$5647df6b7814ac86)(target, {
        maxStringLength: 200
    }) || "<unknown>";
    const baseBreadcrumb = $2814b83f7132876d$var$getBaseDomBreadcrumb(target, message);
    return $2814b83f7132876d$var$createBreadcrumb({
        category: "ui.keyDown",
        message: message,
        data: {
            ...baseBreadcrumb.data,
            metaKey: metaKey,
            shiftKey: shiftKey,
            ctrlKey: ctrlKey,
            altKey: altKey,
            key: key
        }
    });
}
function $2814b83f7132876d$var$isInputElement(target) {
    return target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable;
}
// Map entryType -> function to normalize data for event
const $2814b83f7132876d$var$ENTRY_TYPES = {
    // @ts-expect-error TODO: entry type does not fit the create* functions entry type
    resource: $2814b83f7132876d$var$createResourceEntry,
    paint: $2814b83f7132876d$var$createPaintEntry,
    // @ts-expect-error TODO: entry type does not fit the create* functions entry type
    navigation: $2814b83f7132876d$var$createNavigationEntry
};
/**
 * Handler creater for web vitals
 */ function $2814b83f7132876d$var$webVitalHandler(getter, replay) {
    return ({ metric: metric })=>void replay.replayPerformanceEntries.push(getter(metric));
}
/**
 * Create replay performance entries from the browser performance entries.
 */ function $2814b83f7132876d$var$createPerformanceEntries(entries) {
    return entries.map($2814b83f7132876d$var$createPerformanceEntry).filter(Boolean);
}
function $2814b83f7132876d$var$createPerformanceEntry(entry) {
    const entryType = $2814b83f7132876d$var$ENTRY_TYPES[entry.entryType];
    if (!entryType) return null;
    return entryType(entry);
}
function $2814b83f7132876d$var$getAbsoluteTime(time) {
    // browserPerformanceTimeOrigin can be undefined if `performance` or
    // `performance.now` doesn't exist, but this is already checked by this integration
    return (((0, $a49793e7936ef572$export$baf075a948ffc0bf)() || $2814b83f7132876d$var$WINDOW.performance.timeOrigin) + time) / 1000;
}
function $2814b83f7132876d$var$createPaintEntry(entry) {
    const { duration: duration, entryType: entryType, name: name, startTime: startTime } = entry;
    const start = $2814b83f7132876d$var$getAbsoluteTime(startTime);
    return {
        type: entryType,
        name: name,
        start: start,
        end: start + duration,
        data: undefined
    };
}
function $2814b83f7132876d$var$createNavigationEntry(entry) {
    const { entryType: entryType, name: name, decodedBodySize: decodedBodySize, duration: duration, domComplete: domComplete, encodedBodySize: encodedBodySize, domContentLoadedEventStart: domContentLoadedEventStart, domContentLoadedEventEnd: domContentLoadedEventEnd, domInteractive: domInteractive, loadEventStart: loadEventStart, loadEventEnd: loadEventEnd, redirectCount: redirectCount, startTime: startTime, transferSize: transferSize, type: type } = entry;
    // Ignore entries with no duration, they do not seem to be useful and cause dupes
    if (duration === 0) return null;
    return {
        type: `${entryType}.${type}`,
        start: $2814b83f7132876d$var$getAbsoluteTime(startTime),
        end: $2814b83f7132876d$var$getAbsoluteTime(domComplete),
        name: name,
        data: {
            size: transferSize,
            decodedBodySize: decodedBodySize,
            encodedBodySize: encodedBodySize,
            duration: duration,
            domInteractive: domInteractive,
            domContentLoadedEventStart: domContentLoadedEventStart,
            domContentLoadedEventEnd: domContentLoadedEventEnd,
            loadEventStart: loadEventStart,
            loadEventEnd: loadEventEnd,
            domComplete: domComplete,
            redirectCount: redirectCount
        }
    };
}
function $2814b83f7132876d$var$createResourceEntry(entry) {
    const { entryType: entryType, initiatorType: initiatorType, name: name, responseEnd: responseEnd, startTime: startTime, decodedBodySize: decodedBodySize, encodedBodySize: encodedBodySize, responseStatus: responseStatus, transferSize: transferSize } = entry;
    // Core SDK handles these
    if ([
        "fetch",
        "xmlhttprequest"
    ].includes(initiatorType)) return null;
    return {
        type: `${entryType}.${initiatorType}`,
        start: $2814b83f7132876d$var$getAbsoluteTime(startTime),
        end: $2814b83f7132876d$var$getAbsoluteTime(responseEnd),
        name: name,
        data: {
            size: transferSize,
            statusCode: responseStatus,
            decodedBodySize: decodedBodySize,
            encodedBodySize: encodedBodySize
        }
    };
}
/**
 * Add a LCP event to the replay based on a LCP metric.
 */ function $2814b83f7132876d$var$getLargestContentfulPaint(metric) {
    const lastEntry = metric.entries[metric.entries.length - 1];
    const node = lastEntry?.element ? [
        lastEntry.element
    ] : undefined;
    return $2814b83f7132876d$var$getWebVital(metric, "largest-contentful-paint", node);
}
function $2814b83f7132876d$var$isLayoutShift(entry) {
    return entry.sources !== undefined;
}
/**
 * Add a CLS event to the replay based on a CLS metric.
 */ function $2814b83f7132876d$var$getCumulativeLayoutShift(metric) {
    const layoutShifts = [];
    const nodes = [];
    for (const entry of metric.entries)if ($2814b83f7132876d$var$isLayoutShift(entry)) {
        const nodeIds = [];
        for (const source of entry.sources)if (source.node) {
            nodes.push(source.node);
            const nodeId = $2814b83f7132876d$var$record.mirror.getId(source.node);
            if (nodeId) nodeIds.push(nodeId);
        }
        layoutShifts.push({
            value: entry.value,
            nodeIds: nodeIds.length ? nodeIds : undefined
        });
    }
    return $2814b83f7132876d$var$getWebVital(metric, "cumulative-layout-shift", nodes, layoutShifts);
}
/**
 * Add a FID event to the replay based on a FID metric.
 */ function $2814b83f7132876d$var$getFirstInputDelay(metric) {
    const lastEntry = metric.entries[metric.entries.length - 1];
    const node = lastEntry?.target ? [
        lastEntry.target
    ] : undefined;
    return $2814b83f7132876d$var$getWebVital(metric, "first-input-delay", node);
}
/**
 * Add an INP event to the replay based on an INP metric.
 */ function $2814b83f7132876d$var$getInteractionToNextPaint(metric) {
    const lastEntry = metric.entries[metric.entries.length - 1];
    const node = lastEntry?.target ? [
        lastEntry.target
    ] : undefined;
    return $2814b83f7132876d$var$getWebVital(metric, "interaction-to-next-paint", node);
}
/**
 * Add an web vital event to the replay based on the web vital metric.
 */ function $2814b83f7132876d$var$getWebVital(metric, name, nodes, attributions) {
    const value = metric.value;
    const rating = metric.rating;
    const end = $2814b83f7132876d$var$getAbsoluteTime(value);
    return {
        type: "web-vital",
        name: name,
        start: end,
        end: end,
        data: {
            value: value,
            size: value,
            rating: rating,
            nodeIds: nodes ? nodes.map((node)=>$2814b83f7132876d$var$record.mirror.getId(node)) : undefined,
            attributions: attributions
        }
    };
}
/**
 * Sets up a PerformanceObserver to listen to all performance entry types.
 * Returns a callback to stop observing.
 */ function $2814b83f7132876d$var$setupPerformanceObserver(replay) {
    function addPerformanceEntry(entry) {
        // It is possible for entries to come up multiple times
        if (!replay.performanceEntries.includes(entry)) replay.performanceEntries.push(entry);
    }
    function onEntries({ entries: entries }) {
        entries.forEach(addPerformanceEntry);
    }
    const clearCallbacks = [];
    [
        "navigation",
        "paint",
        "resource"
    ].forEach((type)=>{
        clearCallbacks.push((0, $52f106d2c2e0344c$export$69816c1a049f8db6)(type, onEntries));
    });
    clearCallbacks.push((0, $52f106d2c2e0344c$export$3fd4b53331200102)($2814b83f7132876d$var$webVitalHandler($2814b83f7132876d$var$getLargestContentfulPaint, replay)), (0, $52f106d2c2e0344c$export$861b82818b37ba5b)($2814b83f7132876d$var$webVitalHandler($2814b83f7132876d$var$getCumulativeLayoutShift, replay)), (0, $52f106d2c2e0344c$export$2707d7471c0b918f)($2814b83f7132876d$var$webVitalHandler($2814b83f7132876d$var$getFirstInputDelay, replay)), (0, $52f106d2c2e0344c$export$da3b76aa2022cbd7)($2814b83f7132876d$var$webVitalHandler($2814b83f7132876d$var$getInteractionToNextPaint, replay)));
    // A callback to cleanup all handlers
    return ()=>{
        clearCallbacks.forEach((clearCallback)=>clearCallback());
    };
}
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $2814b83f7132876d$var$DEBUG_BUILD = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;
const $2814b83f7132876d$var$r = `var t=Uint8Array,n=Uint16Array,r=Int32Array,e=new t([0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0,0,0,0]),i=new t([0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13,0,0]),s=new t([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),a=function(t,e){for(var i=new n(31),s=0;s<31;++s)i[s]=e+=1<<t[s-1];var a=new r(i[30]);for(s=1;s<30;++s)for(var o=i[s];o<i[s+1];++o)a[o]=o-i[s]<<5|s;return{b:i,r:a}},o=a(e,2),h=o.b,f=o.r;h[28]=258,f[258]=28;for(var l=a(i,0).r,u=new n(32768),c=0;c<32768;++c){var v=(43690&c)>>1|(21845&c)<<1;v=(61680&(v=(52428&v)>>2|(13107&v)<<2))>>4|(3855&v)<<4,u[c]=((65280&v)>>8|(255&v)<<8)>>1}var d=function(t,r,e){for(var i=t.length,s=0,a=new n(r);s<i;++s)t[s]&&++a[t[s]-1];var o,h=new n(r);for(s=1;s<r;++s)h[s]=h[s-1]+a[s-1]<<1;if(e){o=new n(1<<r);var f=15-r;for(s=0;s<i;++s)if(t[s])for(var l=s<<4|t[s],c=r-t[s],v=h[t[s]-1]++<<c,d=v|(1<<c)-1;v<=d;++v)o[u[v]>>f]=l}else for(o=new n(i),s=0;s<i;++s)t[s]&&(o[s]=u[h[t[s]-1]++]>>15-t[s]);return o},p=new t(288);for(c=0;c<144;++c)p[c]=8;for(c=144;c<256;++c)p[c]=9;for(c=256;c<280;++c)p[c]=7;for(c=280;c<288;++c)p[c]=8;var g=new t(32);for(c=0;c<32;++c)g[c]=5;var w=d(p,9,0),y=d(g,5,0),m=function(t){return(t+7)/8|0},b=function(n,r,e){return(null==e||e>n.length)&&(e=n.length),new t(n.subarray(r,e))},M=["unexpected EOF","invalid block type","invalid length/literal","invalid distance","stream finished","no stream handler",,"no callback","invalid UTF-8 data","extra field too long","date not in range 1980-2099","filename too long","stream finishing","invalid zip data"],E=function(t,n,r){var e=new Error(n||M[t]);if(e.code=t,Error.captureStackTrace&&Error.captureStackTrace(e,E),!r)throw e;return e},z=function(t,n,r){r<<=7&n;var e=n/8|0;t[e]|=r,t[e+1]|=r>>8},_=function(t,n,r){r<<=7&n;var e=n/8|0;t[e]|=r,t[e+1]|=r>>8,t[e+2]|=r>>16},x=function(r,e){for(var i=[],s=0;s<r.length;++s)r[s]&&i.push({s:s,f:r[s]});var a=i.length,o=i.slice();if(!a)return{t:F,l:0};if(1==a){var h=new t(i[0].s+1);return h[i[0].s]=1,{t:h,l:1}}i.sort((function(t,n){return t.f-n.f})),i.push({s:-1,f:25001});var f=i[0],l=i[1],u=0,c=1,v=2;for(i[0]={s:-1,f:f.f+l.f,l:f,r:l};c!=a-1;)f=i[i[u].f<i[v].f?u++:v++],l=i[u!=c&&i[u].f<i[v].f?u++:v++],i[c++]={s:-1,f:f.f+l.f,l:f,r:l};var d=o[0].s;for(s=1;s<a;++s)o[s].s>d&&(d=o[s].s);var p=new n(d+1),g=A(i[c-1],p,0);if(g>e){s=0;var w=0,y=g-e,m=1<<y;for(o.sort((function(t,n){return p[n.s]-p[t.s]||t.f-n.f}));s<a;++s){var b=o[s].s;if(!(p[b]>e))break;w+=m-(1<<g-p[b]),p[b]=e}for(w>>=y;w>0;){var M=o[s].s;p[M]<e?w-=1<<e-p[M]++-1:++s}for(;s>=0&&w;--s){var E=o[s].s;p[E]==e&&(--p[E],++w)}g=e}return{t:new t(p),l:g}},A=function(t,n,r){return-1==t.s?Math.max(A(t.l,n,r+1),A(t.r,n,r+1)):n[t.s]=r},D=function(t){for(var r=t.length;r&&!t[--r];);for(var e=new n(++r),i=0,s=t[0],a=1,o=function(t){e[i++]=t},h=1;h<=r;++h)if(t[h]==s&&h!=r)++a;else{if(!s&&a>2){for(;a>138;a-=138)o(32754);a>2&&(o(a>10?a-11<<5|28690:a-3<<5|12305),a=0)}else if(a>3){for(o(s),--a;a>6;a-=6)o(8304);a>2&&(o(a-3<<5|8208),a=0)}for(;a--;)o(s);a=1,s=t[h]}return{c:e.subarray(0,i),n:r}},T=function(t,n){for(var r=0,e=0;e<n.length;++e)r+=t[e]*n[e];return r},k=function(t,n,r){var e=r.length,i=m(n+2);t[i]=255&e,t[i+1]=e>>8,t[i+2]=255^t[i],t[i+3]=255^t[i+1];for(var s=0;s<e;++s)t[i+s+4]=r[s];return 8*(i+4+e)},U=function(t,r,a,o,h,f,l,u,c,v,m){z(r,m++,a),++h[256];for(var b=x(h,15),M=b.t,E=b.l,A=x(f,15),U=A.t,C=A.l,F=D(M),I=F.c,S=F.n,L=D(U),O=L.c,j=L.n,q=new n(19),B=0;B<I.length;++B)++q[31&I[B]];for(B=0;B<O.length;++B)++q[31&O[B]];for(var G=x(q,7),H=G.t,J=G.l,K=19;K>4&&!H[s[K-1]];--K);var N,P,Q,R,V=v+5<<3,W=T(h,p)+T(f,g)+l,X=T(h,M)+T(f,U)+l+14+3*K+T(q,H)+2*q[16]+3*q[17]+7*q[18];if(c>=0&&V<=W&&V<=X)return k(r,m,t.subarray(c,c+v));if(z(r,m,1+(X<W)),m+=2,X<W){N=d(M,E,0),P=M,Q=d(U,C,0),R=U;var Y=d(H,J,0);z(r,m,S-257),z(r,m+5,j-1),z(r,m+10,K-4),m+=14;for(B=0;B<K;++B)z(r,m+3*B,H[s[B]]);m+=3*K;for(var Z=[I,O],$=0;$<2;++$){var tt=Z[$];for(B=0;B<tt.length;++B){var nt=31&tt[B];z(r,m,Y[nt]),m+=H[nt],nt>15&&(z(r,m,tt[B]>>5&127),m+=tt[B]>>12)}}}else N=w,P=p,Q=y,R=g;for(B=0;B<u;++B){var rt=o[B];if(rt>255){_(r,m,N[(nt=rt>>18&31)+257]),m+=P[nt+257],nt>7&&(z(r,m,rt>>23&31),m+=e[nt]);var et=31&rt;_(r,m,Q[et]),m+=R[et],et>3&&(_(r,m,rt>>5&8191),m+=i[et])}else _(r,m,N[rt]),m+=P[rt]}return _(r,m,N[256]),m+P[256]},C=new r([65540,131080,131088,131104,262176,1048704,1048832,2114560,2117632]),F=new t(0),I=function(){for(var t=new Int32Array(256),n=0;n<256;++n){for(var r=n,e=9;--e;)r=(1&r&&-306674912)^r>>>1;t[n]=r}return t}(),S=function(){var t=-1;return{p:function(n){for(var r=t,e=0;e<n.length;++e)r=I[255&r^n[e]]^r>>>8;t=r},d:function(){return~t}}},L=function(){var t=1,n=0;return{p:function(r){for(var e=t,i=n,s=0|r.length,a=0;a!=s;){for(var o=Math.min(a+2655,s);a<o;++a)i+=e+=r[a];e=(65535&e)+15*(e>>16),i=(65535&i)+15*(i>>16)}t=e,n=i},d:function(){return(255&(t%=65521))<<24|(65280&t)<<8|(255&(n%=65521))<<8|n>>8}}},O=function(s,a,o,h,u){if(!u&&(u={l:1},a.dictionary)){var c=a.dictionary.subarray(-32768),v=new t(c.length+s.length);v.set(c),v.set(s,c.length),s=v,u.w=c.length}return function(s,a,o,h,u,c){var v=c.z||s.length,d=new t(h+v+5*(1+Math.ceil(v/7e3))+u),p=d.subarray(h,d.length-u),g=c.l,w=7&(c.r||0);if(a){w&&(p[0]=c.r>>3);for(var y=C[a-1],M=y>>13,E=8191&y,z=(1<<o)-1,_=c.p||new n(32768),x=c.h||new n(z+1),A=Math.ceil(o/3),D=2*A,T=function(t){return(s[t]^s[t+1]<<A^s[t+2]<<D)&z},F=new r(25e3),I=new n(288),S=new n(32),L=0,O=0,j=c.i||0,q=0,B=c.w||0,G=0;j+2<v;++j){var H=T(j),J=32767&j,K=x[H];if(_[J]=K,x[H]=J,B<=j){var N=v-j;if((L>7e3||q>24576)&&(N>423||!g)){w=U(s,p,0,F,I,S,O,q,G,j-G,w),q=L=O=0,G=j;for(var P=0;P<286;++P)I[P]=0;for(P=0;P<30;++P)S[P]=0}var Q=2,R=0,V=E,W=J-K&32767;if(N>2&&H==T(j-W))for(var X=Math.min(M,N)-1,Y=Math.min(32767,j),Z=Math.min(258,N);W<=Y&&--V&&J!=K;){if(s[j+Q]==s[j+Q-W]){for(var $=0;$<Z&&s[j+$]==s[j+$-W];++$);if($>Q){if(Q=$,R=W,$>X)break;var tt=Math.min(W,$-2),nt=0;for(P=0;P<tt;++P){var rt=j-W+P&32767,et=rt-_[rt]&32767;et>nt&&(nt=et,K=rt)}}}W+=(J=K)-(K=_[J])&32767}if(R){F[q++]=268435456|f[Q]<<18|l[R];var it=31&f[Q],st=31&l[R];O+=e[it]+i[st],++I[257+it],++S[st],B=j+Q,++L}else F[q++]=s[j],++I[s[j]]}}for(j=Math.max(j,B);j<v;++j)F[q++]=s[j],++I[s[j]];w=U(s,p,g,F,I,S,O,q,G,j-G,w),g||(c.r=7&w|p[w/8|0]<<3,w-=7,c.h=x,c.p=_,c.i=j,c.w=B)}else{for(j=c.w||0;j<v+g;j+=65535){var at=j+65535;at>=v&&(p[w/8|0]=g,at=v),w=k(p,w+1,s.subarray(j,at))}c.i=v}return b(d,0,h+m(w)+u)}(s,null==a.level?6:a.level,null==a.mem?u.l?Math.ceil(1.5*Math.max(8,Math.min(13,Math.log(s.length)))):20:12+a.mem,o,h,u)},j=function(t,n,r){for(;r;++n)t[n]=r,r>>>=8},q=function(t,n){var r=n.filename;if(t[0]=31,t[1]=139,t[2]=8,t[8]=n.level<2?4:9==n.level?2:0,t[9]=3,0!=n.mtime&&j(t,4,Math.floor(new Date(n.mtime||Date.now())/1e3)),r){t[3]=8;for(var e=0;e<=r.length;++e)t[e+10]=r.charCodeAt(e)}},B=function(t){return 10+(t.filename?t.filename.length+1:0)},G=function(){function n(n,r){if("function"==typeof n&&(r=n,n={}),this.ondata=r,this.o=n||{},this.s={l:0,i:32768,w:32768,z:32768},this.b=new t(98304),this.o.dictionary){var e=this.o.dictionary.subarray(-32768);this.b.set(e,32768-e.length),this.s.i=32768-e.length}}return n.prototype.p=function(t,n){this.ondata(O(t,this.o,0,0,this.s),n)},n.prototype.push=function(n,r){this.ondata||E(5),this.s.l&&E(4);var e=n.length+this.s.z;if(e>this.b.length){if(e>2*this.b.length-32768){var i=new t(-32768&e);i.set(this.b.subarray(0,this.s.z)),this.b=i}var s=this.b.length-this.s.z;this.b.set(n.subarray(0,s),this.s.z),this.s.z=this.b.length,this.p(this.b,!1),this.b.set(this.b.subarray(-32768)),this.b.set(n.subarray(s),32768),this.s.z=n.length-s+32768,this.s.i=32766,this.s.w=32768}else this.b.set(n,this.s.z),this.s.z+=n.length;this.s.l=1&r,(this.s.z>this.s.w+8191||r)&&(this.p(this.b,r||!1),this.s.w=this.s.i,this.s.i-=2)},n.prototype.flush=function(){this.ondata||E(5),this.s.l&&E(4),this.p(this.b,!1),this.s.w=this.s.i,this.s.i-=2},n}();var H=function(){function t(t,n){this.c=L(),this.v=1,G.call(this,t,n)}return t.prototype.push=function(t,n){this.c.p(t),G.prototype.push.call(this,t,n)},t.prototype.p=function(t,n){var r=O(t,this.o,this.v&&(this.o.dictionary?6:2),n&&4,this.s);this.v&&(function(t,n){var r=n.level,e=0==r?0:r<6?1:9==r?3:2;if(t[0]=120,t[1]=e<<6|(n.dictionary&&32),t[1]|=31-(t[0]<<8|t[1])%31,n.dictionary){var i=L();i.p(n.dictionary),j(t,2,i.d())}}(r,this.o),this.v=0),n&&j(r,r.length-4,this.c.d()),this.ondata(r,n)},t.prototype.flush=function(){G.prototype.flush.call(this)},t}(),J="undefined"!=typeof TextEncoder&&new TextEncoder,K="undefined"!=typeof TextDecoder&&new TextDecoder;try{K.decode(F,{stream:!0})}catch(t){}var N=function(){function t(t){this.ondata=t}return t.prototype.push=function(t,n){this.ondata||E(5),this.d&&E(4),this.ondata(P(t),this.d=n||!1)},t}();function P(n,r){if(J)return J.encode(n);for(var e=n.length,i=new t(n.length+(n.length>>1)),s=0,a=function(t){i[s++]=t},o=0;o<e;++o){if(s+5>i.length){var h=new t(s+8+(e-o<<1));h.set(i),i=h}var f=n.charCodeAt(o);f<128||r?a(f):f<2048?(a(192|f>>6),a(128|63&f)):f>55295&&f<57344?(a(240|(f=65536+(1047552&f)|1023&n.charCodeAt(++o))>>18),a(128|f>>12&63),a(128|f>>6&63),a(128|63&f)):(a(224|f>>12),a(128|f>>6&63),a(128|63&f))}return b(i,0,s)}function Q(t){return function(t,n){n||(n={});var r=S(),e=t.length;r.p(t);var i=O(t,n,B(n),8),s=i.length;return q(i,n),j(i,s-8,r.d()),j(i,s-4,e),i}(P(t))}const R=new class{constructor(){this._init()}clear(){this._init()}addEvent(t){if(!t)throw new Error("Adding invalid event");const n=this._hasEvents?",":"";this.stream.push(n+t),this._hasEvents=!0}finish(){this.stream.push("]",!0);const t=function(t){let n=0;for(const r of t)n+=r.length;const r=new Uint8Array(n);for(let n=0,e=0,i=t.length;n<i;n++){const i=t[n];r.set(i,e),e+=i.length}return r}(this._deflatedData);return this._init(),t}_init(){this._hasEvents=!1,this._deflatedData=[],this.deflate=new H,this.deflate.ondata=(t,n)=>{this._deflatedData.push(t)},this.stream=new N(((t,n)=>{this.deflate.push(t,n)})),this.stream.push("[")}},V={clear:()=>{R.clear()},addEvent:t=>R.addEvent(t),finish:()=>R.finish(),compress:t=>Q(t)};addEventListener("message",(function(t){const n=t.data.method,r=t.data.id,e=t.data.arg;if(n in V&&"function"==typeof V[n])try{const t=V[n](e);postMessage({id:r,method:n,success:!0,response:t})}catch(t){postMessage({id:r,method:n,success:!1,response:t.message}),console.error(t)}})),postMessage({id:void 0,method:"init",success:!0,response:void 0});`;
function $2814b83f7132876d$var$e() {
    const e = new Blob([
        $2814b83f7132876d$var$r
    ]);
    return URL.createObjectURL(e);
}
const $2814b83f7132876d$var$CONSOLE_LEVELS = [
    "info",
    "warn",
    "error",
    "log"
];
const $2814b83f7132876d$var$PREFIX = "[Replay] ";
function $2814b83f7132876d$var$_addBreadcrumb(message, level = "info") {
    (0, $4391fcdc8a459c29$export$efda9a273d7a036d)({
        category: "console",
        data: {
            logger: "replay"
        },
        level: level,
        message: `${$2814b83f7132876d$var$PREFIX}${message}`
    }, {
        level: level
    });
}
function $2814b83f7132876d$var$makeReplayLogger() {
    let _capture = false;
    let _trace = false;
    const _logger = {
        exception: ()=>undefined,
        infoTick: ()=>undefined,
        setConfig: (opts)=>{
            _capture = !!opts.captureExceptions;
            _trace = !!opts.traceInternals;
        }
    };
    if ($2814b83f7132876d$var$DEBUG_BUILD) {
        $2814b83f7132876d$var$CONSOLE_LEVELS.forEach((name)=>{
            _logger[name] = (...args)=>{
                (0, $f1cb9ab3cf87365c$export$af88d00dbe7f521)[name]($2814b83f7132876d$var$PREFIX, ...args);
                if (_trace) $2814b83f7132876d$var$_addBreadcrumb(args.join(""), (0, $3f81f76ce20091af$export$d771ef054122c30a)(name));
            };
        });
        _logger.exception = (error, ...message)=>{
            if (message.length && _logger.error) _logger.error(...message);
            (0, $f1cb9ab3cf87365c$export$af88d00dbe7f521).error($2814b83f7132876d$var$PREFIX, error);
            if (_capture) (0, $45011cfcd1a50cfc$export$f5282963edea4a68)(error);
            else if (_trace) // No need for a breadcrumb if `_capture` is enabled since it should be
            // captured as an exception
            $2814b83f7132876d$var$_addBreadcrumb(error, "error");
        };
        _logger.infoTick = (...args)=>{
            (0, $f1cb9ab3cf87365c$export$af88d00dbe7f521).info($2814b83f7132876d$var$PREFIX, ...args);
            if (_trace) // Wait a tick here to avoid race conditions for some initial logs
            // which may be added before replay is initialized
            setTimeout(()=>$2814b83f7132876d$var$_addBreadcrumb(args[0]), 0);
        };
    } else $2814b83f7132876d$var$CONSOLE_LEVELS.forEach((name)=>{
        _logger[name] = ()=>undefined;
    });
    return _logger;
}
const $2814b83f7132876d$var$logger = $2814b83f7132876d$var$makeReplayLogger();
/** This error indicates that the event buffer size exceeded the limit.. */ class $2814b83f7132876d$var$EventBufferSizeExceededError extends Error {
    constructor(){
        super(`Event buffer exceeded maximum size of ${$2814b83f7132876d$var$REPLAY_MAX_EVENT_BUFFER_SIZE}.`);
    }
}
/**
 * A basic event buffer that does not do any compression.
 * Used as fallback if the compression worker cannot be loaded or is disabled.
 */ class $2814b83f7132876d$var$EventBufferArray {
    /** All the events that are buffered to be sent. */ /** @inheritdoc */ /** @inheritdoc */ constructor(){
        this.events = [];
        this._totalSize = 0;
        this.hasCheckout = false;
        this.waitForCheckout = false;
    }
    /** @inheritdoc */ get hasEvents() {
        return this.events.length > 0;
    }
    /** @inheritdoc */ get type() {
        return "sync";
    }
    /** @inheritdoc */ destroy() {
        this.events = [];
    }
    /** @inheritdoc */ async addEvent(event) {
        const eventSize = JSON.stringify(event).length;
        this._totalSize += eventSize;
        if (this._totalSize > $2814b83f7132876d$var$REPLAY_MAX_EVENT_BUFFER_SIZE) throw new $2814b83f7132876d$var$EventBufferSizeExceededError();
        this.events.push(event);
    }
    /** @inheritdoc */ finish() {
        return new Promise((resolve)=>{
            // Make a copy of the events array reference and immediately clear the
            // events member so that we do not lose new events while uploading
            // attachment.
            const eventsRet = this.events;
            this.clear();
            resolve(JSON.stringify(eventsRet));
        });
    }
    /** @inheritdoc */ clear() {
        this.events = [];
        this._totalSize = 0;
        this.hasCheckout = false;
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        const timestamp = this.events.map((event)=>event.timestamp).sort()[0];
        if (!timestamp) return null;
        return $2814b83f7132876d$var$timestampToMs(timestamp);
    }
}
/**
 * Event buffer that uses a web worker to compress events.
 * Exported only for testing.
 */ class $2814b83f7132876d$var$WorkerHandler {
    constructor(worker){
        this._worker = worker;
        this._id = 0;
    }
    /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occurred.
   */ ensureReady() {
        // Ensure we only check once
        if (this._ensureReadyPromise) return this._ensureReadyPromise;
        this._ensureReadyPromise = new Promise((resolve, reject)=>{
            this._worker.addEventListener("message", ({ data: data })=>{
                if (data.success) resolve();
                else reject();
            }, {
                once: true
            });
            this._worker.addEventListener("error", (error)=>{
                reject(error);
            }, {
                once: true
            });
        });
        return this._ensureReadyPromise;
    }
    /**
   * Destroy the worker.
   */ destroy() {
        $2814b83f7132876d$var$DEBUG_BUILD && $2814b83f7132876d$var$logger.info("Destroying compression worker");
        this._worker.terminate();
    }
    /**
   * Post message to worker and wait for response before resolving promise.
   */ postMessage(method, arg) {
        const id = this._getAndIncrementId();
        return new Promise((resolve, reject)=>{
            const listener = ({ data: data })=>{
                const response = data;
                if (response.method !== method) return;
                // There can be multiple listeners for a single method, the id ensures
                // that the response matches the caller.
                if (response.id !== id) return;
                // At this point, we'll always want to remove listener regardless of result status
                this._worker.removeEventListener("message", listener);
                if (!response.success) {
                    // TODO: Do some error handling, not sure what
                    $2814b83f7132876d$var$DEBUG_BUILD && $2814b83f7132876d$var$logger.error("Error in compression worker: ", response.response);
                    reject(new Error("Error in compression worker"));
                    return;
                }
                resolve(response.response);
            };
            // Note: we can't use `once` option because it's possible it needs to
            // listen to multiple messages
            this._worker.addEventListener("message", listener);
            this._worker.postMessage({
                id: id,
                method: method,
                arg: arg
            });
        });
    }
    /** Get the current ID and increment it for the next call. */ _getAndIncrementId() {
        return this._id++;
    }
}
/**
 * Event buffer that uses a web worker to compress events.
 * Exported only for testing.
 */ class $2814b83f7132876d$var$EventBufferCompressionWorker {
    /** @inheritdoc */ /** @inheritdoc */ constructor(worker){
        this._worker = new $2814b83f7132876d$var$WorkerHandler(worker);
        this._earliestTimestamp = null;
        this._totalSize = 0;
        this.hasCheckout = false;
        this.waitForCheckout = false;
    }
    /** @inheritdoc */ get hasEvents() {
        return !!this._earliestTimestamp;
    }
    /** @inheritdoc */ get type() {
        return "worker";
    }
    /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occurred.
   */ ensureReady() {
        return this._worker.ensureReady();
    }
    /**
   * Destroy the event buffer.
   */ destroy() {
        this._worker.destroy();
    }
    /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfully received and processed by worker.
   */ addEvent(event) {
        const timestamp = $2814b83f7132876d$var$timestampToMs(event.timestamp);
        if (!this._earliestTimestamp || timestamp < this._earliestTimestamp) this._earliestTimestamp = timestamp;
        const data = JSON.stringify(event);
        this._totalSize += data.length;
        if (this._totalSize > $2814b83f7132876d$var$REPLAY_MAX_EVENT_BUFFER_SIZE) return Promise.reject(new $2814b83f7132876d$var$EventBufferSizeExceededError());
        return this._sendEventToWorker(data);
    }
    /**
   * Finish the event buffer and return the compressed data.
   */ finish() {
        return this._finishRequest();
    }
    /** @inheritdoc */ clear() {
        this._earliestTimestamp = null;
        this._totalSize = 0;
        this.hasCheckout = false;
        // We do not wait on this, as we assume the order of messages is consistent for the worker
        this._worker.postMessage("clear").then(null, (e)=>{
            $2814b83f7132876d$var$DEBUG_BUILD && $2814b83f7132876d$var$logger.exception(e, 'Sending "clear" message to worker failed', e);
        });
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        return this._earliestTimestamp;
    }
    /**
   * Send the event to the worker.
   */ _sendEventToWorker(data) {
        return this._worker.postMessage("addEvent", data);
    }
    /**
   * Finish the request and return the compressed data from the worker.
   */ async _finishRequest() {
        const response = await this._worker.postMessage("finish");
        this._earliestTimestamp = null;
        this._totalSize = 0;
        return response;
    }
}
/**
 * This proxy will try to use the compression worker, and fall back to use the simple buffer if an error occurs there.
 * This can happen e.g. if the worker cannot be loaded.
 * Exported only for testing.
 */ class $2814b83f7132876d$var$EventBufferProxy {
    constructor(worker){
        this._fallback = new $2814b83f7132876d$var$EventBufferArray();
        this._compression = new $2814b83f7132876d$var$EventBufferCompressionWorker(worker);
        this._used = this._fallback;
        this._ensureWorkerIsLoadedPromise = this._ensureWorkerIsLoaded();
    }
    /** @inheritdoc */ get waitForCheckout() {
        return this._used.waitForCheckout;
    }
    /** @inheritdoc */ get type() {
        return this._used.type;
    }
    /** @inheritDoc */ get hasEvents() {
        return this._used.hasEvents;
    }
    /** @inheritdoc */ get hasCheckout() {
        return this._used.hasCheckout;
    }
    /** @inheritdoc */ set hasCheckout(value) {
        this._used.hasCheckout = value;
    }
    /** @inheritdoc */ // eslint-disable-next-line @typescript-eslint/adjacent-overload-signatures
    set waitForCheckout(value) {
        this._used.waitForCheckout = value;
    }
    /** @inheritDoc */ destroy() {
        this._fallback.destroy();
        this._compression.destroy();
    }
    /** @inheritdoc */ clear() {
        return this._used.clear();
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        return this._used.getEarliestTimestamp();
    }
    /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfully added.
   */ addEvent(event) {
        return this._used.addEvent(event);
    }
    /** @inheritDoc */ async finish() {
        // Ensure the worker is loaded, so the sent event is compressed
        await this.ensureWorkerIsLoaded();
        return this._used.finish();
    }
    /** Ensure the worker has loaded. */ ensureWorkerIsLoaded() {
        return this._ensureWorkerIsLoadedPromise;
    }
    /** Actually check if the worker has been loaded. */ async _ensureWorkerIsLoaded() {
        try {
            await this._compression.ensureReady();
        } catch (error) {
            // If the worker fails to load, we fall back to the simple buffer.
            // Nothing more to do from our side here
            $2814b83f7132876d$var$DEBUG_BUILD && $2814b83f7132876d$var$logger.exception(error, "Failed to load the compression worker, falling back to simple buffer");
            return;
        }
        // Now we need to switch over the array buffer to the compression worker
        await this._switchToCompressionWorker();
    }
    /** Switch the used buffer to the compression worker. */ async _switchToCompressionWorker() {
        const { events: events, hasCheckout: hasCheckout, waitForCheckout: waitForCheckout } = this._fallback;
        const addEventPromises = [];
        for (const event of events)addEventPromises.push(this._compression.addEvent(event));
        this._compression.hasCheckout = hasCheckout;
        this._compression.waitForCheckout = waitForCheckout;
        // We switch over to the new buffer immediately - any further events will be added
        // after the previously buffered ones
        this._used = this._compression;
        // Wait for original events to be re-added before resolving
        try {
            await Promise.all(addEventPromises);
            // Can now clear fallback buffer as it's no longer necessary
            this._fallback.clear();
        } catch (error) {
            $2814b83f7132876d$var$DEBUG_BUILD && $2814b83f7132876d$var$logger.exception(error, "Failed to add events when switching buffers.");
        }
    }
}
/**
 * Create an event buffer for replays.
 */ function $2814b83f7132876d$var$createEventBuffer({ useCompression: useCompression, workerUrl: customWorkerUrl }) {
    if (useCompression && // eslint-disable-next-line no-restricted-globals
    window.Worker) {
        const worker = $2814b83f7132876d$var$_loadWorker(customWorkerUrl);
        if (worker) return worker;
    }
    $2814b83f7132876d$var$DEBUG_BUILD && $2814b83f7132876d$var$logger.info("Using simple buffer");
    return new $2814b83f7132876d$var$EventBufferArray();
}
function $2814b83f7132876d$var$_loadWorker(customWorkerUrl) {
    try {
        const workerUrl = customWorkerUrl || $2814b83f7132876d$var$_getWorkerUrl();
        if (!workerUrl) return;
        $2814b83f7132876d$var$DEBUG_BUILD && $2814b83f7132876d$var$logger.info(`Using compression worker${customWorkerUrl ? ` from ${customWorkerUrl}` : ""}`);
        const worker = new Worker(workerUrl);
        return new $2814b83f7132876d$var$EventBufferProxy(worker);
    } catch (error) {
        $2814b83f7132876d$var$DEBUG_BUILD && $2814b83f7132876d$var$logger.exception(error, "Failed to create compression worker");
    // Fall back to use simple event buffer array
    }
}
function $2814b83f7132876d$var$_getWorkerUrl() {
    if (typeof __SENTRY_EXCLUDE_REPLAY_WORKER__ === "undefined" || !__SENTRY_EXCLUDE_REPLAY_WORKER__) return $2814b83f7132876d$var$e();
    return "";
}
/** If sessionStorage is available. */ function $2814b83f7132876d$var$hasSessionStorage() {
    try {
        // This can throw, e.g. when being accessed in a sandboxed iframe
        return "sessionStorage" in $2814b83f7132876d$var$WINDOW && !!$2814b83f7132876d$var$WINDOW.sessionStorage;
    } catch  {
        return false;
    }
}
/**
 * Removes the session from Session Storage and unsets session in replay instance
 */ function $2814b83f7132876d$var$clearSession(replay) {
    $2814b83f7132876d$var$deleteSession();
    replay.session = undefined;
}
/**
 * Deletes a session from storage
 */ function $2814b83f7132876d$var$deleteSession() {
    if (!$2814b83f7132876d$var$hasSessionStorage()) return;
    try {
        $2814b83f7132876d$var$WINDOW.sessionStorage.removeItem($2814b83f7132876d$var$REPLAY_SESSION_KEY);
    } catch  {
    // Ignore potential SecurityError exceptions
    }
}
/**
 * Given a sample rate, returns true if replay should be sampled.
 *
 * 1.0 = 100% sampling
 * 0.0 = 0% sampling
 */ function $2814b83f7132876d$var$isSampled(sampleRate) {
    if (sampleRate === undefined) return false;
    // Math.random() returns a number in range of 0 to 1 (inclusive of 0, but not 1)
    return Math.random() < sampleRate;
}
/**
 * Save a session to session storage.
 */ function $2814b83f7132876d$var$saveSession(session) {
    if (!$2814b83f7132876d$var$hasSessionStorage()) return;
    try {
        $2814b83f7132876d$var$WINDOW.sessionStorage.setItem($2814b83f7132876d$var$REPLAY_SESSION_KEY, JSON.stringify(session));
    } catch  {
    // Ignore potential SecurityError exceptions
    }
}
/**
 * Get a session with defaults & applied sampling.
 */ function $2814b83f7132876d$var$makeSession(session) {
    const now = Date.now();
    const id = session.id || (0, $adba9e1e8cd7ee8e$export$19f53698e68b2496)();
    // Note that this means we cannot set a started/lastActivity of `0`, but this should not be relevant outside of tests.
    const started = session.started || now;
    const lastActivity = session.lastActivity || now;
    const segmentId = session.segmentId || 0;
    const sampled = session.sampled;
    const previousSessionId = session.previousSessionId;
    return {
        id: id,
        started: started,
        lastActivity: lastActivity,
        segmentId: segmentId,
        sampled: sampled,
        previousSessionId: previousSessionId
    };
}
/**
 * Get the sampled status for a session based on sample rates & current sampled status.
 */ function $2814b83f7132876d$var$getSessionSampleType(sessionSampleRate, allowBuffering) {
    return $2814b83f7132876d$var$isSampled(sessionSampleRate) ? "session" : allowBuffering ? "buffer" : false;
}
/**
 * Create a new session, which in its current implementation is a Sentry event
 * that all replays will be saved to as attachments. Currently, we only expect
 * one of these Sentry events per "replay session".
 */ function $2814b83f7132876d$var$createSession({ sessionSampleRate: sessionSampleRate, allowBuffering: allowBuffering, stickySession: stickySession = false }, { previousSessionId: previousSessionId } = {}) {
    const sampled = $2814b83f7132876d$var$getSessionSampleType(sessionSampleRate, allowBuffering);
    const session = $2814b83f7132876d$var$makeSession({
        sampled: sampled,
        previousSessionId: previousSessionId
    });
    if (stickySession) $2814b83f7132876d$var$saveSession(session);
    return session;
}
/**
 * Fetches a session from storage
 */ function $2814b83f7132876d$var$fetchSession() {
    if (!$2814b83f7132876d$var$hasSessionStorage()) return null;
    try {
        // This can throw if cookies are disabled
        const sessionStringFromStorage = $2814b83f7132876d$var$WINDOW.sessionStorage.getItem($2814b83f7132876d$var$REPLAY_SESSION_KEY);
        if (!sessionStringFromStorage) return null;
        const sessionObj = JSON.parse(sessionStringFromStorage);
        $2814b83f7132876d$var$DEBUG_BUILD && $2814b83f7132876d$var$logger.infoTick("Loading existing session");
        return $2814b83f7132876d$var$makeSession(sessionObj);
    } catch  {
        return null;
    }
}
/**
 * Given an initial timestamp and an expiry duration, checks to see if current
 * time should be considered as expired.
 */ function $2814b83f7132876d$var$isExpired(initialTime, expiry, targetTime = +new Date()) {
    // Always expired if < 0
    if (initialTime === null || expiry === undefined || expiry < 0) return true;
    // Never expires if == 0
    if (expiry === 0) return false;
    return initialTime + expiry <= targetTime;
}
/**
 * Checks to see if session is expired
 */ function $2814b83f7132876d$var$isSessionExpired(session, { maxReplayDuration: maxReplayDuration, sessionIdleExpire: sessionIdleExpire, targetTime: targetTime = Date.now() }) {
    return(// First, check that maximum session length has not been exceeded
    $2814b83f7132876d$var$isExpired(session.started, maxReplayDuration, targetTime) || // check that the idle timeout has not been exceeded (i.e. user has
    // performed an action within the last `sessionIdleExpire` ms)
    $2814b83f7132876d$var$isExpired(session.lastActivity, sessionIdleExpire, targetTime));
}
/** If the session should be refreshed or not. */ function $2814b83f7132876d$var$shouldRefreshSession(session, { sessionIdleExpire: sessionIdleExpire, maxReplayDuration: maxReplayDuration }) {
    // If not expired, all good, just keep the session
    if (!$2814b83f7132876d$var$isSessionExpired(session, {
        sessionIdleExpire: sessionIdleExpire,
        maxReplayDuration: maxReplayDuration
    })) return false;
    // If we are buffering & haven't ever flushed yet, always continue
    if (session.sampled === "buffer" && session.segmentId === 0) return false;
    return true;
}
/**
 * Get or create a session, when initializing the replay.
 * Returns a session that may be unsampled.
 */ function $2814b83f7132876d$var$loadOrCreateSession({ sessionIdleExpire: sessionIdleExpire, maxReplayDuration: maxReplayDuration, previousSessionId: previousSessionId }, sessionOptions) {
    const existingSession = sessionOptions.stickySession && $2814b83f7132876d$var$fetchSession();
    // No session exists yet, just create a new one
    if (!existingSession) {
        $2814b83f7132876d$var$DEBUG_BUILD && $2814b83f7132876d$var$logger.infoTick("Creating new session");
        return $2814b83f7132876d$var$createSession(sessionOptions, {
            previousSessionId: previousSessionId
        });
    }
    if (!$2814b83f7132876d$var$shouldRefreshSession(existingSession, {
        sessionIdleExpire: sessionIdleExpire,
        maxReplayDuration: maxReplayDuration
    })) return existingSession;
    $2814b83f7132876d$var$DEBUG_BUILD && $2814b83f7132876d$var$logger.infoTick("Session in sessionStorage is expired, creating new one...");
    return $2814b83f7132876d$var$createSession(sessionOptions, {
        previousSessionId: existingSession.id
    });
}
function $2814b83f7132876d$var$isCustomEvent(event) {
    return event.type === $2814b83f7132876d$var$EventType.Custom;
}
/**
 * Add an event to the event buffer.
 * In contrast to `addEvent`, this does not return a promise & does not wait for the adding of the event to succeed/fail.
 * Instead this returns `true` if we tried to add the event, else false.
 * It returns `false` e.g. if we are paused, disabled, or out of the max replay duration.
 *
 * `isCheckout` is true if this is either the very first event, or an event triggered by `checkoutEveryNms`.
 */ function $2814b83f7132876d$var$addEventSync(replay, event, isCheckout) {
    if (!$2814b83f7132876d$var$shouldAddEvent(replay, event)) return false;
    // This should never reject
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    $2814b83f7132876d$var$_addEvent(replay, event, isCheckout);
    return true;
}
/**
 * Add an event to the event buffer.
 * Resolves to `null` if no event was added, else to `void`.
 *
 * `isCheckout` is true if this is either the very first event, or an event triggered by `checkoutEveryNms`.
 */ function $2814b83f7132876d$var$addEvent(replay, event, isCheckout) {
    if (!$2814b83f7132876d$var$shouldAddEvent(replay, event)) return Promise.resolve(null);
    return $2814b83f7132876d$var$_addEvent(replay, event, isCheckout);
}
async function $2814b83f7132876d$var$_addEvent(replay, event, isCheckout) {
    const { eventBuffer: eventBuffer } = replay;
    if (!eventBuffer || eventBuffer.waitForCheckout && !isCheckout) return null;
    const isBufferMode = replay.recordingMode === "buffer";
    try {
        if (isCheckout && isBufferMode) eventBuffer.clear();
        if (isCheckout) {
            eventBuffer.hasCheckout = true;
            eventBuffer.waitForCheckout = false;
        }
        const replayOptions = replay.getOptions();
        const eventAfterPossibleCallback = $2814b83f7132876d$var$maybeApplyCallback(event, replayOptions.beforeAddRecordingEvent);
        if (!eventAfterPossibleCallback) return;
        return await eventBuffer.addEvent(eventAfterPossibleCallback);
    } catch (error) {
        const isExceeded = error && error instanceof $2814b83f7132876d$var$EventBufferSizeExceededError;
        const reason = isExceeded ? "addEventSizeExceeded" : "addEvent";
        if (isExceeded && isBufferMode) {
            // Clear buffer and wait for next checkout
            eventBuffer.clear();
            eventBuffer.waitForCheckout = true;
            return null;
        }
        replay.handleException(error);
        await replay.stop({
            reason: reason
        });
        const client = (0, $b03165fa5825574e$export$6bb76d6eba7e258c)();
        if (client) client.recordDroppedEvent("internal_sdk_error", "replay");
    }
}
/** Exported only for tests. */ function $2814b83f7132876d$var$shouldAddEvent(replay, event) {
    if (!replay.eventBuffer || replay.isPaused() || !replay.isEnabled()) return false;
    const timestampInMs = $2814b83f7132876d$var$timestampToMs(event.timestamp);
    // Throw out events that happen more than 5 minutes ago. This can happen if
    // page has been left open and idle for a long period of time and user
    // comes back to trigger a new session. The performance entries rely on
    // `performance.timeOrigin`, which is when the page first opened.
    if (timestampInMs + replay.timeouts.sessionIdlePause < Date.now()) return false;
    // Throw out events that are +60min from the initial timestamp
    if (timestampInMs > replay.getContext().initialTimestamp + replay.getOptions().maxReplayDuration) {
        $2814b83f7132876d$var$DEBUG_BUILD && $2814b83f7132876d$var$logger.infoTick(`Skipping event with timestamp ${timestampInMs} because it is after maxReplayDuration`);
        return false;
    }
    return true;
}
function $2814b83f7132876d$var$maybeApplyCallback(event, callback) {
    try {
        if (typeof callback === "function" && $2814b83f7132876d$var$isCustomEvent(event)) return callback(event);
    } catch (error) {
        $2814b83f7132876d$var$DEBUG_BUILD && $2814b83f7132876d$var$logger.exception(error, "An error occurred in the `beforeAddRecordingEvent` callback, skipping the event...");
        return null;
    }
    return event;
}
/** If the event is an error event */ function $2814b83f7132876d$var$isErrorEvent(event) {
    return !event.type;
}
/** If the event is a transaction event */ function $2814b83f7132876d$var$isTransactionEvent(event) {
    return event.type === "transaction";
}
/** If the event is an replay event */ function $2814b83f7132876d$var$isReplayEvent(event) {
    return event.type === "replay_event";
}
/** If the event is a feedback event */ function $2814b83f7132876d$var$isFeedbackEvent(event) {
    return event.type === "feedback";
}
/**
 * Returns a listener to be added to `client.on('afterSendErrorEvent, listener)`.
 */ function $2814b83f7132876d$var$handleAfterSendEvent(replay) {
    return (event, sendResponse)=>{
        if (!replay.isEnabled() || !$2814b83f7132876d$var$isErrorEvent(event) && !$2814b83f7132876d$var$isTransactionEvent(event)) return;
        const statusCode = sendResponse?.statusCode;
        // We only want to do stuff on successful error sending, otherwise you get error replays without errors attached
        // If not using the base transport, we allow `undefined` response (as a custom transport may not implement this correctly yet)
        // If we do use the base transport, we skip if we encountered an non-OK status code
        if (!statusCode || statusCode < 200 || statusCode >= 300) return;
        if ($2814b83f7132876d$var$isTransactionEvent(event)) {
            $2814b83f7132876d$var$handleTransactionEvent(replay, event);
            return;
        }
        $2814b83f7132876d$var$handleErrorEvent(replay, event);
    };
}
function $2814b83f7132876d$var$handleTransactionEvent(replay, event) {
    const replayContext = replay.getContext();
    // Collect traceIds in _context regardless of `recordingMode`
    // In error mode, _context gets cleared on every checkout
    // We limit to max. 100 transactions linked
    if (event.contexts?.trace?.trace_id && replayContext.traceIds.size < 100) replayContext.traceIds.add(event.contexts.trace.trace_id);
}
function $2814b83f7132876d$var$handleErrorEvent(replay, event) {
    const replayContext = replay.getContext();
    // Add error to list of errorIds of replay. This is ok to do even if not
    // sampled because context will get reset at next checkout.
    // XXX: There is also a race condition where it's possible to capture an
    // error to Sentry before Replay SDK has loaded, but response returns after
    // it was loaded, and this gets called.
    // We limit to max. 100 errors linked
    if (event.event_id && replayContext.errorIds.size < 100) replayContext.errorIds.add(event.event_id);
    // If error event is tagged with replay id it means it was sampled (when in buffer mode)
    // Need to be very careful that this does not cause an infinite loop
    if (replay.recordingMode !== "buffer" || !event.tags || !event.tags.replayId) return;
    const { beforeErrorSampling: beforeErrorSampling } = replay.getOptions();
    if (typeof beforeErrorSampling === "function" && !beforeErrorSampling(event)) return;
    (0, $31c1fb7be891462e$export$831dc9f2ab0a617b)(async ()=>{
        try {
            // Capture current event buffer as new replay
            await replay.sendBufferedReplayOrFlush();
        } catch (err) {
            replay.handleException(err);
        }
    });
}
/**
 * Returns a listener to be added to `client.on('afterSendErrorEvent, listener)`.
 */ function $2814b83f7132876d$var$handleBeforeSendEvent(replay) {
    return (event)=>{
        if (!replay.isEnabled() || !$2814b83f7132876d$var$isErrorEvent(event)) return;
        $2814b83f7132876d$var$handleHydrationError(replay, event);
    };
}
function $2814b83f7132876d$var$handleHydrationError(replay, event) {
    const exceptionValue = event.exception?.values?.[0]?.value;
    if (typeof exceptionValue !== "string") return;
    if (// Only matches errors in production builds of react-dom
    // Example https://reactjs.org/docs/error-decoder.html?invariant=423
    // With newer React versions, the messages changed to a different website https://react.dev/errors/418
    exceptionValue.match(/(reactjs\.org\/docs\/error-decoder\.html\?invariant=|react\.dev\/errors\/)(418|419|422|423|425)/) || // Development builds of react-dom
    // Error 1: Hydration failed because the initial UI does not match what was rendered on the server.
    // Error 2: Text content does not match server-rendered HTML. Warning: Text content did not match.
    exceptionValue.match(/(does not match server-rendered HTML|Hydration failed because)/i)) {
        const breadcrumb = $2814b83f7132876d$var$createBreadcrumb({
            category: "replay.hydrate-error",
            data: {
                url: (0, $0a4b219981573bc1$export$1cfafeee2987818b)()
            }
        });
        $2814b83f7132876d$var$addBreadcrumbEvent(replay, breadcrumb);
    }
}
/**
 * Handle breadcrumbs that Sentry captures, and make sure to capture relevant breadcrumbs to Replay as well.
 */ function $2814b83f7132876d$var$handleBreadcrumbs(replay) {
    const client = (0, $b03165fa5825574e$export$6bb76d6eba7e258c)();
    if (!client) return;
    client.on("beforeAddBreadcrumb", (breadcrumb)=>$2814b83f7132876d$var$beforeAddBreadcrumb(replay, breadcrumb));
}
function $2814b83f7132876d$var$beforeAddBreadcrumb(replay, breadcrumb) {
    if (!replay.isEnabled() || !$2814b83f7132876d$var$isBreadcrumbWithCategory(breadcrumb)) return;
    const result = $2814b83f7132876d$var$normalizeBreadcrumb(breadcrumb);
    if (result) $2814b83f7132876d$var$addBreadcrumbEvent(replay, result);
}
/** Exported only for tests. */ function $2814b83f7132876d$var$normalizeBreadcrumb(breadcrumb) {
    if (!$2814b83f7132876d$var$isBreadcrumbWithCategory(breadcrumb) || [
        // fetch & xhr are handled separately,in handleNetworkBreadcrumbs
        "fetch",
        "xhr",
        // These two are breadcrumbs for emitted sentry events, we don't care about them
        "sentry.event",
        "sentry.transaction"
    ].includes(breadcrumb.category) || // We capture UI breadcrumbs separately
    breadcrumb.category.startsWith("ui.")) return null;
    if (breadcrumb.category === "console") return $2814b83f7132876d$var$normalizeConsoleBreadcrumb(breadcrumb);
    return $2814b83f7132876d$var$createBreadcrumb(breadcrumb);
}
/** exported for tests only */ function $2814b83f7132876d$var$normalizeConsoleBreadcrumb(breadcrumb) {
    const args = breadcrumb.data?.arguments;
    if (!Array.isArray(args) || args.length === 0) return $2814b83f7132876d$var$createBreadcrumb(breadcrumb);
    let isTruncated = false;
    // Avoid giant args captures
    const normalizedArgs = args.map((arg)=>{
        if (!arg) return arg;
        if (typeof arg === "string") {
            if (arg.length > $2814b83f7132876d$var$CONSOLE_ARG_MAX_SIZE) {
                isTruncated = true;
                return `${arg.slice(0, $2814b83f7132876d$var$CONSOLE_ARG_MAX_SIZE)}\u{2026}`;
            }
            return arg;
        }
        if (typeof arg === "object") try {
            const normalizedArg = (0, $b661d102b0d864f7$export$a3295358bff77e)(arg, 7);
            const stringified = JSON.stringify(normalizedArg);
            if (stringified.length > $2814b83f7132876d$var$CONSOLE_ARG_MAX_SIZE) {
                isTruncated = true;
                // We use the pretty printed JSON string here as a base
                return `${JSON.stringify(normalizedArg, null, 2).slice(0, $2814b83f7132876d$var$CONSOLE_ARG_MAX_SIZE)}\u{2026}`;
            }
            return normalizedArg;
        } catch  {
        // fall back to default
        }
        return arg;
    });
    return $2814b83f7132876d$var$createBreadcrumb({
        ...breadcrumb,
        data: {
            ...breadcrumb.data,
            arguments: normalizedArgs,
            ...isTruncated ? {
                _meta: {
                    warnings: [
                        "CONSOLE_ARG_TRUNCATED"
                    ]
                }
            } : {}
        }
    });
}
function $2814b83f7132876d$var$isBreadcrumbWithCategory(breadcrumb) {
    return !!breadcrumb.category;
}
/**
 * Returns true if we think the given event is an error originating inside of rrweb.
 */ function $2814b83f7132876d$var$isRrwebError(event, hint) {
    if (event.type || !event.exception || !event.exception.values || !event.exception.values.length) return false;
    // @ts-expect-error this may be set by rrweb when it finds errors
    if (hint.originalException?.__rrweb__) return true;
    return false;
}
/**
 * Reset the `replay_id` field on the DSC.
 */ function $2814b83f7132876d$var$resetReplayIdOnDynamicSamplingContext() {
    // Reset DSC on the current scope, if there is one
    const dsc = (0, $b03165fa5825574e$export$c7be4b0125a10cba)().getPropagationContext().dsc;
    if (dsc) delete dsc.replay_id;
    // Clear it from frozen DSC on the active span
    const activeSpan = (0, $d955067cf7638cfb$export$1be426a8e585c83e)();
    if (activeSpan) {
        const dsc = (0, $d3b57429db417f76$export$a117f995597e25df)(activeSpan);
        delete dsc.replay_id;
    }
}
/**
 * Add a feedback breadcrumb event to replay.
 */ function $2814b83f7132876d$var$addFeedbackBreadcrumb(replay, event) {
    replay.triggerUserActivity();
    replay.addUpdate(()=>{
        if (!event.timestamp) // Ignore events that don't have timestamps (this shouldn't happen, more of a typing issue)
        // Return true here so that we don't flush
        return true;
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        replay.throttledAddEvent({
            type: $2814b83f7132876d$var$EventType.Custom,
            timestamp: event.timestamp * 1000,
            data: {
                tag: "breadcrumb",
                payload: {
                    timestamp: event.timestamp,
                    type: "default",
                    category: "sentry.feedback",
                    data: {
                        feedbackId: event.event_id
                    }
                }
            }
        });
        return false;
    });
}
/**
 * Determine if event should be sampled (only applies in buffer mode).
 * When an event is captured by `handleGlobalEvent`, when in buffer mode
 * we determine if we want to sample the error or not.
 */ function $2814b83f7132876d$var$shouldSampleForBufferEvent(replay, event) {
    if (replay.recordingMode !== "buffer") return false;
    // ignore this error because otherwise we could loop indefinitely with
    // trying to capture replay and failing
    if (event.message === $2814b83f7132876d$var$UNABLE_TO_SEND_REPLAY) return false;
    // Require the event to be an error event & to have an exception
    if (!event.exception || event.type) return false;
    return $2814b83f7132876d$var$isSampled(replay.getOptions().errorSampleRate);
}
/**
 * Returns a listener to be added to `addEventProcessor(listener)`.
 */ function $2814b83f7132876d$var$handleGlobalEventListener(replay) {
    return Object.assign((event, hint)=>{
        // Do nothing if replay has been disabled or paused
        if (!replay.isEnabled() || replay.isPaused()) return event;
        if ($2814b83f7132876d$var$isReplayEvent(event)) {
            // Replays have separate set of breadcrumbs, do not include breadcrumbs
            // from core SDK
            delete event.breadcrumbs;
            return event;
        }
        // We only want to handle errors, transactions, and feedbacks, nothing else
        if (!$2814b83f7132876d$var$isErrorEvent(event) && !$2814b83f7132876d$var$isTransactionEvent(event) && !$2814b83f7132876d$var$isFeedbackEvent(event)) return event;
        // Ensure we do not add replay_id if the session is expired
        const isSessionActive = replay.checkAndHandleExpiredSession();
        if (!isSessionActive) {
            // prevent exceeding replay durations by removing the expired replayId from the DSC
            $2814b83f7132876d$var$resetReplayIdOnDynamicSamplingContext();
            return event;
        }
        if ($2814b83f7132876d$var$isFeedbackEvent(event)) {
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            replay.flush();
            event.contexts.feedback.replay_id = replay.getSessionId();
            // Add a replay breadcrumb for this piece of feedback
            $2814b83f7132876d$var$addFeedbackBreadcrumb(replay, event);
            return event;
        }
        // Unless `captureExceptions` is enabled, we want to ignore errors coming from rrweb
        // As there can be a bunch of stuff going wrong in internals there, that we don't want to bubble up to users
        if ($2814b83f7132876d$var$isRrwebError(event, hint) && !replay.getOptions()._experiments.captureExceptions) {
            $2814b83f7132876d$var$DEBUG_BUILD && $2814b83f7132876d$var$logger.log("Ignoring error from rrweb internals", event);
            return null;
        }
        // When in buffer mode, we decide to sample here.
        // Later, in `handleAfterSendEvent`, if the replayId is set, we know that we sampled
        // And convert the buffer session to a full session
        const isErrorEventSampled = $2814b83f7132876d$var$shouldSampleForBufferEvent(replay, event);
        // Tag errors if it has been sampled in buffer mode, or if it is session mode
        // Only tag transactions if in session mode
        const shouldTagReplayId = isErrorEventSampled || replay.recordingMode === "session";
        if (shouldTagReplayId) event.tags = {
            ...event.tags,
            replayId: replay.getSessionId()
        };
        return event;
    }, {
        id: "Replay"
    });
}
/**
 * Create a "span" for each performance entry.
 */ function $2814b83f7132876d$var$createPerformanceSpans(replay, entries) {
    return entries.map(({ type: type, start: start, end: end, name: name, data: data })=>{
        const response = replay.throttledAddEvent({
            type: $2814b83f7132876d$var$EventType.Custom,
            timestamp: start,
            data: {
                tag: "performanceSpan",
                payload: {
                    op: type,
                    description: name,
                    startTimestamp: start,
                    endTimestamp: end,
                    data: data
                }
            }
        });
        // If response is a string, it means its either THROTTLED or SKIPPED
        return typeof response === "string" ? Promise.resolve(null) : response;
    });
}
function $2814b83f7132876d$var$handleHistory(handlerData) {
    const { from: from, to: to } = handlerData;
    const now = Date.now() / 1000;
    return {
        type: "navigation.push",
        start: now,
        end: now,
        name: to,
        data: {
            previous: from
        }
    };
}
/**
 * Returns a listener to be added to `addHistoryInstrumentationHandler(listener)`.
 */ function $2814b83f7132876d$var$handleHistorySpanListener(replay) {
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $2814b83f7132876d$var$handleHistory(handlerData);
        if (result === null) return;
        // Need to collect visited URLs
        replay.getContext().urls.push(result.name);
        replay.triggerUserActivity();
        replay.addUpdate(()=>{
            $2814b83f7132876d$var$createPerformanceSpans(replay, [
                result
            ]);
            // Returning false to flush
            return false;
        });
    };
}
/**
 * Check whether a given request URL should be filtered out. This is so we
 * don't log Sentry ingest requests.
 */ function $2814b83f7132876d$var$shouldFilterRequest(replay, url) {
    // If we enabled the `traceInternals` experiment, we want to trace everything
    if ($2814b83f7132876d$var$DEBUG_BUILD && replay.getOptions()._experiments.traceInternals) return false;
    return (0, $58c2736742858a43$export$d92e61f5600202af)(url, (0, $b03165fa5825574e$export$6bb76d6eba7e258c)());
}
/** Add a performance entry breadcrumb */ function $2814b83f7132876d$var$addNetworkBreadcrumb(replay, result) {
    if (!replay.isEnabled()) return;
    if (result === null) return;
    if ($2814b83f7132876d$var$shouldFilterRequest(replay, result.name)) return;
    replay.addUpdate(()=>{
        $2814b83f7132876d$var$createPerformanceSpans(replay, [
            result
        ]);
        // Returning true will cause `addUpdate` to not flush
        // We do not want network requests to cause a flush. This will prevent
        // recurring/polling requests from keeping the replay session alive.
        return true;
    });
}
/** Get the size of a body. */ function $2814b83f7132876d$var$getBodySize(body) {
    if (!body) return undefined;
    const textEncoder = new TextEncoder();
    try {
        if (typeof body === "string") return textEncoder.encode(body).length;
        if (body instanceof URLSearchParams) return textEncoder.encode(body.toString()).length;
        if (body instanceof FormData) {
            const formDataStr = (0, $3f1b9c08521fa255$export$2f1b0f57f243f270)(body);
            return textEncoder.encode(formDataStr).length;
        }
        if (body instanceof Blob) return body.size;
        if (body instanceof ArrayBuffer) return body.byteLength;
    // Currently unhandled types: ArrayBufferView, ReadableStream
    } catch  {
    // just return undefined
    }
    return undefined;
}
/** Convert a Content-Length header to number/undefined.  */ function $2814b83f7132876d$var$parseContentLengthHeader(header) {
    if (!header) return undefined;
    const size = parseInt(header, 10);
    return isNaN(size) ? undefined : size;
}
/** Merge a warning into an existing network request/response. */ function $2814b83f7132876d$var$mergeWarning(info, warning) {
    if (!info) return {
        headers: {},
        size: undefined,
        _meta: {
            warnings: [
                warning
            ]
        }
    };
    const newMeta = {
        ...info._meta
    };
    const existingWarnings = newMeta.warnings || [];
    newMeta.warnings = [
        ...existingWarnings,
        warning
    ];
    info._meta = newMeta;
    return info;
}
/** Convert ReplayNetworkRequestData to a PerformanceEntry. */ function $2814b83f7132876d$var$makeNetworkReplayBreadcrumb(type, data) {
    if (!data) return null;
    const { startTimestamp: startTimestamp, endTimestamp: endTimestamp, url: url, method: method, statusCode: statusCode, request: request, response: response } = data;
    const result = {
        type: type,
        start: startTimestamp / 1000,
        end: endTimestamp / 1000,
        name: url,
        data: {
            method: method,
            statusCode: statusCode,
            request: request,
            response: response
        }
    };
    return result;
}
/** Build the request or response part of a replay network breadcrumb that was skipped. */ function $2814b83f7132876d$var$buildSkippedNetworkRequestOrResponse(bodySize) {
    return {
        headers: {},
        size: bodySize,
        _meta: {
            warnings: [
                "URL_SKIPPED"
            ]
        }
    };
}
/** Build the request or response part of a replay network breadcrumb. */ function $2814b83f7132876d$var$buildNetworkRequestOrResponse(headers, bodySize, body) {
    if (!bodySize && Object.keys(headers).length === 0) return undefined;
    if (!bodySize) return {
        headers: headers
    };
    if (!body) return {
        headers: headers,
        size: bodySize
    };
    const info = {
        headers: headers,
        size: bodySize
    };
    const { body: normalizedBody, warnings: warnings } = $2814b83f7132876d$var$normalizeNetworkBody(body);
    info.body = normalizedBody;
    if (warnings?.length) info._meta = {
        warnings: warnings
    };
    return info;
}
/** Filter a set of headers */ function $2814b83f7132876d$var$getAllowedHeaders(headers, allowedHeaders) {
    return Object.entries(headers).reduce((filteredHeaders, [key, value])=>{
        const normalizedKey = key.toLowerCase();
        // Avoid putting empty strings into the headers
        if (allowedHeaders.includes(normalizedKey) && headers[key]) filteredHeaders[normalizedKey] = value;
        return filteredHeaders;
    }, {});
}
function $2814b83f7132876d$var$normalizeNetworkBody(body) {
    if (!body || typeof body !== "string") return {
        body: body
    };
    const exceedsSizeLimit = body.length > $2814b83f7132876d$var$NETWORK_BODY_MAX_SIZE;
    const isProbablyJson = $2814b83f7132876d$var$_strIsProbablyJson(body);
    if (exceedsSizeLimit) {
        const truncatedBody = body.slice(0, $2814b83f7132876d$var$NETWORK_BODY_MAX_SIZE);
        if (isProbablyJson) return {
            body: truncatedBody,
            warnings: [
                "MAYBE_JSON_TRUNCATED"
            ]
        };
        return {
            body: `${truncatedBody}\u{2026}`,
            warnings: [
                "TEXT_TRUNCATED"
            ]
        };
    }
    if (isProbablyJson) try {
        const jsonBody = JSON.parse(body);
        return {
            body: jsonBody
        };
    } catch  {
    // fall back to just send the body as string
    }
    return {
        body: body
    };
}
function $2814b83f7132876d$var$_strIsProbablyJson(str) {
    const first = str[0];
    const last = str[str.length - 1];
    // Simple check: If this does not start & end with {} or [], it's not JSON
    return first === "[" && last === "]" || first === "{" && last === "}";
}
/** Match an URL against a list of strings/Regex. */ function $2814b83f7132876d$var$urlMatches(url, urls) {
    const fullUrl = $2814b83f7132876d$var$getFullUrl(url);
    return (0, $e9fb89f9f6b2a439$export$a7a5ec66062ea5d)(fullUrl, urls);
}
/** exported for tests */ function $2814b83f7132876d$var$getFullUrl(url, baseURI = $2814b83f7132876d$var$WINDOW.document.baseURI) {
    // Short circuit for common cases:
    if (url.startsWith("http://") || url.startsWith("https://") || url.startsWith($2814b83f7132876d$var$WINDOW.location.origin)) return url;
    const fixedUrl = new URL(url, baseURI);
    // If these do not match, we are not dealing with a relative URL, so just return it
    if (fixedUrl.origin !== new URL(baseURI).origin) return url;
    const fullUrl = fixedUrl.href;
    // Remove trailing slashes, if they don't match the original URL
    if (!url.endsWith("/") && fullUrl.endsWith("/")) return fullUrl.slice(0, -1);
    return fullUrl;
}
/**
 * Capture a fetch breadcrumb to a replay.
 * This adds additional data (where appropriate).
 */ async function $2814b83f7132876d$var$captureFetchBreadcrumbToReplay(breadcrumb, hint, options) {
    try {
        const data = await $2814b83f7132876d$var$_prepareFetchData(breadcrumb, hint, options);
        // Create a replay performance entry from this breadcrumb
        const result = $2814b83f7132876d$var$makeNetworkReplayBreadcrumb("resource.fetch", data);
        $2814b83f7132876d$var$addNetworkBreadcrumb(options.replay, result);
    } catch (error) {
        $2814b83f7132876d$var$DEBUG_BUILD && $2814b83f7132876d$var$logger.exception(error, "Failed to capture fetch breadcrumb");
    }
}
/**
 * Enrich a breadcrumb with additional data.
 * This has to be sync & mutate the given breadcrumb,
 * as the breadcrumb is afterwards consumed by other handlers.
 */ function $2814b83f7132876d$var$enrichFetchBreadcrumb(breadcrumb, hint) {
    const { input: input, response: response } = hint;
    const body = input ? (0, $3f1b9c08521fa255$export$ad44edf8012ec314)(input) : undefined;
    const reqSize = $2814b83f7132876d$var$getBodySize(body);
    const resSize = response ? $2814b83f7132876d$var$parseContentLengthHeader(response.headers.get("content-length")) : undefined;
    if (reqSize !== undefined) breadcrumb.data.request_body_size = reqSize;
    if (resSize !== undefined) breadcrumb.data.response_body_size = resSize;
}
async function $2814b83f7132876d$var$_prepareFetchData(breadcrumb, hint, options) {
    const now = Date.now();
    const { startTimestamp: startTimestamp = now, endTimestamp: endTimestamp = now } = hint;
    const { url: url, method: method, status_code: statusCode = 0, request_body_size: requestBodySize, response_body_size: responseBodySize } = breadcrumb.data;
    const captureDetails = $2814b83f7132876d$var$urlMatches(url, options.networkDetailAllowUrls) && !$2814b83f7132876d$var$urlMatches(url, options.networkDetailDenyUrls);
    const request = captureDetails ? $2814b83f7132876d$var$_getRequestInfo(options, hint.input, requestBodySize) : $2814b83f7132876d$var$buildSkippedNetworkRequestOrResponse(requestBodySize);
    const response = await $2814b83f7132876d$var$_getResponseInfo(captureDetails, options, hint.response, responseBodySize);
    return {
        startTimestamp: startTimestamp,
        endTimestamp: endTimestamp,
        url: url,
        method: method,
        statusCode: statusCode,
        request: request,
        response: response
    };
}
function $2814b83f7132876d$var$_getRequestInfo({ networkCaptureBodies: networkCaptureBodies, networkRequestHeaders: networkRequestHeaders }, input, requestBodySize) {
    const headers = input ? $2814b83f7132876d$var$getRequestHeaders(input, networkRequestHeaders) : {};
    if (!networkCaptureBodies) return $2814b83f7132876d$var$buildNetworkRequestOrResponse(headers, requestBodySize, undefined);
    // We only want to transmit string or string-like bodies
    const requestBody = (0, $3f1b9c08521fa255$export$ad44edf8012ec314)(input);
    const [bodyStr, warning] = (0, $3f1b9c08521fa255$export$945a2d5364608d5)(requestBody, $2814b83f7132876d$var$logger);
    const data = $2814b83f7132876d$var$buildNetworkRequestOrResponse(headers, requestBodySize, bodyStr);
    if (warning) return $2814b83f7132876d$var$mergeWarning(data, warning);
    return data;
}
/** Exported only for tests. */ async function $2814b83f7132876d$var$_getResponseInfo(captureDetails, { networkCaptureBodies: networkCaptureBodies, networkResponseHeaders: networkResponseHeaders }, response, responseBodySize) {
    if (!captureDetails && responseBodySize !== undefined) return $2814b83f7132876d$var$buildSkippedNetworkRequestOrResponse(responseBodySize);
    const headers = response ? $2814b83f7132876d$var$getAllHeaders(response.headers, networkResponseHeaders) : {};
    if (!response || !networkCaptureBodies && responseBodySize !== undefined) return $2814b83f7132876d$var$buildNetworkRequestOrResponse(headers, responseBodySize, undefined);
    const [bodyText, warning] = await $2814b83f7132876d$var$_parseFetchResponseBody(response);
    const result = $2814b83f7132876d$var$getResponseData(bodyText, {
        networkCaptureBodies: networkCaptureBodies,
        responseBodySize: responseBodySize,
        captureDetails: captureDetails,
        headers: headers
    });
    if (warning) return $2814b83f7132876d$var$mergeWarning(result, warning);
    return result;
}
function $2814b83f7132876d$var$getResponseData(bodyText, { networkCaptureBodies: networkCaptureBodies, responseBodySize: responseBodySize, captureDetails: captureDetails, headers: headers }) {
    try {
        const size = bodyText?.length && responseBodySize === undefined ? $2814b83f7132876d$var$getBodySize(bodyText) : responseBodySize;
        if (!captureDetails) return $2814b83f7132876d$var$buildSkippedNetworkRequestOrResponse(size);
        if (networkCaptureBodies) return $2814b83f7132876d$var$buildNetworkRequestOrResponse(headers, size, bodyText);
        return $2814b83f7132876d$var$buildNetworkRequestOrResponse(headers, size, undefined);
    } catch (error) {
        $2814b83f7132876d$var$DEBUG_BUILD && $2814b83f7132876d$var$logger.exception(error, "Failed to serialize response body");
        // fallback
        return $2814b83f7132876d$var$buildNetworkRequestOrResponse(headers, responseBodySize, undefined);
    }
}
async function $2814b83f7132876d$var$_parseFetchResponseBody(response) {
    const res = $2814b83f7132876d$var$_tryCloneResponse(response);
    if (!res) return [
        undefined,
        "BODY_PARSE_ERROR"
    ];
    try {
        const text = await $2814b83f7132876d$var$_tryGetResponseText(res);
        return [
            text
        ];
    } catch (error) {
        if (error instanceof Error && error.message.indexOf("Timeout") > -1) {
            $2814b83f7132876d$var$DEBUG_BUILD && $2814b83f7132876d$var$logger.warn("Parsing text body from response timed out");
            return [
                undefined,
                "BODY_PARSE_TIMEOUT"
            ];
        }
        $2814b83f7132876d$var$DEBUG_BUILD && $2814b83f7132876d$var$logger.exception(error, "Failed to get text body from response");
        return [
            undefined,
            "BODY_PARSE_ERROR"
        ];
    }
}
function $2814b83f7132876d$var$getAllHeaders(headers, allowedHeaders) {
    const allHeaders = {};
    allowedHeaders.forEach((header)=>{
        if (headers.get(header)) allHeaders[header] = headers.get(header);
    });
    return allHeaders;
}
function $2814b83f7132876d$var$getRequestHeaders(fetchArgs, allowedHeaders) {
    if (fetchArgs.length === 1 && typeof fetchArgs[0] !== "string") return $2814b83f7132876d$var$getHeadersFromOptions(fetchArgs[0], allowedHeaders);
    if (fetchArgs.length === 2) return $2814b83f7132876d$var$getHeadersFromOptions(fetchArgs[1], allowedHeaders);
    return {};
}
function $2814b83f7132876d$var$getHeadersFromOptions(input, allowedHeaders) {
    if (!input) return {};
    const headers = input.headers;
    if (!headers) return {};
    if (headers instanceof Headers) return $2814b83f7132876d$var$getAllHeaders(headers, allowedHeaders);
    // We do not support this, as it is not really documented (anymore?)
    if (Array.isArray(headers)) return {};
    return $2814b83f7132876d$var$getAllowedHeaders(headers, allowedHeaders);
}
function $2814b83f7132876d$var$_tryCloneResponse(response) {
    try {
        // We have to clone this, as the body can only be read once
        return response.clone();
    } catch (error) {
        // this can throw if the response was already consumed before
        $2814b83f7132876d$var$DEBUG_BUILD && $2814b83f7132876d$var$logger.exception(error, "Failed to clone response body");
    }
}
/**
 * Get the response body of a fetch request, or timeout after 500ms.
 * Fetch can return a streaming body, that may not resolve (or not for a long time).
 * If that happens, we rather abort after a short time than keep waiting for this.
 */ function $2814b83f7132876d$var$_tryGetResponseText(response) {
    return new Promise((resolve, reject)=>{
        const timeout = (0, $31c1fb7be891462e$export$831dc9f2ab0a617b)(()=>reject(new Error("Timeout while trying to read response body")), 500);
        $2814b83f7132876d$var$_getResponseText(response).then((txt)=>resolve(txt), (reason)=>reject(reason)).finally(()=>clearTimeout(timeout));
    });
}
async function $2814b83f7132876d$var$_getResponseText(response) {
    // Force this to be a promise, just to be safe
    // eslint-disable-next-line no-return-await
    return await response.text();
}
/**
 * Capture an XHR breadcrumb to a replay.
 * This adds additional data (where appropriate).
 */ async function $2814b83f7132876d$var$captureXhrBreadcrumbToReplay(breadcrumb, hint, options) {
    try {
        const data = $2814b83f7132876d$var$_prepareXhrData(breadcrumb, hint, options);
        // Create a replay performance entry from this breadcrumb
        const result = $2814b83f7132876d$var$makeNetworkReplayBreadcrumb("resource.xhr", data);
        $2814b83f7132876d$var$addNetworkBreadcrumb(options.replay, result);
    } catch (error) {
        $2814b83f7132876d$var$DEBUG_BUILD && $2814b83f7132876d$var$logger.exception(error, "Failed to capture xhr breadcrumb");
    }
}
/**
 * Enrich a breadcrumb with additional data.
 * This has to be sync & mutate the given breadcrumb,
 * as the breadcrumb is afterwards consumed by other handlers.
 */ function $2814b83f7132876d$var$enrichXhrBreadcrumb(breadcrumb, hint) {
    const { xhr: xhr, input: input } = hint;
    if (!xhr) return;
    const reqSize = $2814b83f7132876d$var$getBodySize(input);
    const resSize = xhr.getResponseHeader("content-length") ? $2814b83f7132876d$var$parseContentLengthHeader(xhr.getResponseHeader("content-length")) : $2814b83f7132876d$var$_getBodySize(xhr.response, xhr.responseType);
    if (reqSize !== undefined) breadcrumb.data.request_body_size = reqSize;
    if (resSize !== undefined) breadcrumb.data.response_body_size = resSize;
}
function $2814b83f7132876d$var$_prepareXhrData(breadcrumb, hint, options) {
    const now = Date.now();
    const { startTimestamp: startTimestamp = now, endTimestamp: endTimestamp = now, input: input, xhr: xhr } = hint;
    const { url: url, method: method, status_code: statusCode = 0, request_body_size: requestBodySize, response_body_size: responseBodySize } = breadcrumb.data;
    if (!url) return null;
    if (!xhr || !$2814b83f7132876d$var$urlMatches(url, options.networkDetailAllowUrls) || $2814b83f7132876d$var$urlMatches(url, options.networkDetailDenyUrls)) {
        const request = $2814b83f7132876d$var$buildSkippedNetworkRequestOrResponse(requestBodySize);
        const response = $2814b83f7132876d$var$buildSkippedNetworkRequestOrResponse(responseBodySize);
        return {
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp,
            url: url,
            method: method,
            statusCode: statusCode,
            request: request,
            response: response
        };
    }
    // ---- This additional network data below is only captured for URLs defined in `networkDetailAllowUrls` ----
    const xhrInfo = xhr[0, $932d70c5552b8c29$export$55b6bb1e45c6cf59];
    const networkRequestHeaders = xhrInfo ? $2814b83f7132876d$var$getAllowedHeaders(xhrInfo.request_headers, options.networkRequestHeaders) : {};
    const networkResponseHeaders = $2814b83f7132876d$var$getAllowedHeaders($2814b83f7132876d$var$getResponseHeaders(xhr), options.networkResponseHeaders);
    const [requestBody, requestWarning] = options.networkCaptureBodies ? (0, $3f1b9c08521fa255$export$945a2d5364608d5)(input, $2814b83f7132876d$var$logger) : [
        undefined
    ];
    const [responseBody, responseWarning] = options.networkCaptureBodies ? $2814b83f7132876d$var$_getXhrResponseBody(xhr) : [
        undefined
    ];
    const request = $2814b83f7132876d$var$buildNetworkRequestOrResponse(networkRequestHeaders, requestBodySize, requestBody);
    const response = $2814b83f7132876d$var$buildNetworkRequestOrResponse(networkResponseHeaders, responseBodySize, responseBody);
    return {
        startTimestamp: startTimestamp,
        endTimestamp: endTimestamp,
        url: url,
        method: method,
        statusCode: statusCode,
        request: requestWarning ? $2814b83f7132876d$var$mergeWarning(request, requestWarning) : request,
        response: responseWarning ? $2814b83f7132876d$var$mergeWarning(response, responseWarning) : response
    };
}
function $2814b83f7132876d$var$getResponseHeaders(xhr) {
    const headers = xhr.getAllResponseHeaders();
    if (!headers) return {};
    return headers.split("\r\n").reduce((acc, line)=>{
        const [key, value] = line.split(": ");
        if (value) acc[key.toLowerCase()] = value;
        return acc;
    }, {});
}
function $2814b83f7132876d$var$_getXhrResponseBody(xhr) {
    // We collect errors that happen, but only log them if we can't get any response body
    const errors = [];
    try {
        return [
            xhr.responseText
        ];
    } catch (e) {
        errors.push(e);
    }
    // Try to manually parse the response body, if responseText fails
    try {
        return $2814b83f7132876d$var$_parseXhrResponse(xhr.response, xhr.responseType);
    } catch (e) {
        errors.push(e);
    }
    $2814b83f7132876d$var$DEBUG_BUILD && $2814b83f7132876d$var$logger.warn("Failed to get xhr response body", ...errors);
    return [
        undefined
    ];
}
/**
 * Get the string representation of the XHR response.
 * Based on MDN, these are the possible types of the response:
 * string
 * ArrayBuffer
 * Blob
 * Document
 * POJO
 *
 * Exported only for tests.
 */ function $2814b83f7132876d$var$_parseXhrResponse(body, responseType) {
    try {
        if (typeof body === "string") return [
            body
        ];
        if (body instanceof Document) return [
            body.body.outerHTML
        ];
        if (responseType === "json" && body && typeof body === "object") return [
            JSON.stringify(body)
        ];
        if (!body) return [
            undefined
        ];
    } catch (error) {
        $2814b83f7132876d$var$DEBUG_BUILD && $2814b83f7132876d$var$logger.exception(error, "Failed to serialize body", body);
        return [
            undefined,
            "BODY_PARSE_ERROR"
        ];
    }
    $2814b83f7132876d$var$DEBUG_BUILD && $2814b83f7132876d$var$logger.info("Skipping network body because of body type", body);
    return [
        undefined,
        "UNPARSEABLE_BODY_TYPE"
    ];
}
function $2814b83f7132876d$var$_getBodySize(body, responseType) {
    try {
        const bodyStr = responseType === "json" && body && typeof body === "object" ? JSON.stringify(body) : body;
        return $2814b83f7132876d$var$getBodySize(bodyStr);
    } catch  {
        return undefined;
    }
}
/**
 * This method does two things:
 * - It enriches the regular XHR/fetch breadcrumbs with request/response size data
 * - It captures the XHR/fetch breadcrumbs to the replay
 *   (enriching it with further data that is _not_ added to the regular breadcrumbs)
 */ function $2814b83f7132876d$var$handleNetworkBreadcrumbs(replay) {
    const client = (0, $b03165fa5825574e$export$6bb76d6eba7e258c)();
    try {
        const { networkDetailAllowUrls: networkDetailAllowUrls, networkDetailDenyUrls: networkDetailDenyUrls, networkCaptureBodies: networkCaptureBodies, networkRequestHeaders: networkRequestHeaders, networkResponseHeaders: networkResponseHeaders } = replay.getOptions();
        const options = {
            replay: replay,
            networkDetailAllowUrls: networkDetailAllowUrls,
            networkDetailDenyUrls: networkDetailDenyUrls,
            networkCaptureBodies: networkCaptureBodies,
            networkRequestHeaders: networkRequestHeaders,
            networkResponseHeaders: networkResponseHeaders
        };
        if (client) client.on("beforeAddBreadcrumb", (breadcrumb, hint)=>$2814b83f7132876d$var$beforeAddNetworkBreadcrumb(options, breadcrumb, hint));
    } catch  {
    // Do nothing
    }
}
/** just exported for tests */ function $2814b83f7132876d$var$beforeAddNetworkBreadcrumb(options, breadcrumb, hint) {
    if (!breadcrumb.data) return;
    try {
        if ($2814b83f7132876d$var$_isXhrBreadcrumb(breadcrumb) && $2814b83f7132876d$var$_isXhrHint(hint)) {
            // This has to be sync, as we need to ensure the breadcrumb is enriched in the same tick
            // Because the hook runs synchronously, and the breadcrumb is afterwards passed on
            // So any async mutations to it will not be reflected in the final breadcrumb
            $2814b83f7132876d$var$enrichXhrBreadcrumb(breadcrumb, hint);
            // This call should not reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            $2814b83f7132876d$var$captureXhrBreadcrumbToReplay(breadcrumb, hint, options);
        }
        if ($2814b83f7132876d$var$_isFetchBreadcrumb(breadcrumb) && $2814b83f7132876d$var$_isFetchHint(hint)) {
            // This has to be sync, as we need to ensure the breadcrumb is enriched in the same tick
            // Because the hook runs synchronously, and the breadcrumb is afterwards passed on
            // So any async mutations to it will not be reflected in the final breadcrumb
            $2814b83f7132876d$var$enrichFetchBreadcrumb(breadcrumb, hint);
            // This call should not reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            $2814b83f7132876d$var$captureFetchBreadcrumbToReplay(breadcrumb, hint, options);
        }
    } catch (e) {
        $2814b83f7132876d$var$DEBUG_BUILD && $2814b83f7132876d$var$logger.exception(e, "Error when enriching network breadcrumb");
    }
}
function $2814b83f7132876d$var$_isXhrBreadcrumb(breadcrumb) {
    return breadcrumb.category === "xhr";
}
function $2814b83f7132876d$var$_isFetchBreadcrumb(breadcrumb) {
    return breadcrumb.category === "fetch";
}
function $2814b83f7132876d$var$_isXhrHint(hint) {
    return hint?.xhr;
}
function $2814b83f7132876d$var$_isFetchHint(hint) {
    return hint?.response;
}
/**
 * Add global listeners that cannot be removed.
 */ function $2814b83f7132876d$var$addGlobalListeners(replay, { autoFlushOnFeedback: autoFlushOnFeedback }) {
    // Listeners from core SDK //
    const client = (0, $b03165fa5825574e$export$6bb76d6eba7e258c)();
    (0, $3fb634bee7939c58$export$5aeffd3db2cf9df7)($2814b83f7132876d$var$handleDomListener(replay));
    (0, $6bfcc9d7c86121e5$export$3f18c56c58114e75)($2814b83f7132876d$var$handleHistorySpanListener(replay));
    $2814b83f7132876d$var$handleBreadcrumbs(replay);
    $2814b83f7132876d$var$handleNetworkBreadcrumbs(replay);
    // Tag all (non replay) events that get sent to Sentry with the current
    // replay ID so that we can reference them later in the UI
    const eventProcessor = $2814b83f7132876d$var$handleGlobalEventListener(replay);
    (0, $45011cfcd1a50cfc$export$9aac0b9f77928fbf)(eventProcessor);
    // If a custom client has no hooks yet, we continue to use the "old" implementation
    if (client) {
        client.on("beforeSendEvent", $2814b83f7132876d$var$handleBeforeSendEvent(replay));
        client.on("afterSendEvent", $2814b83f7132876d$var$handleAfterSendEvent(replay));
        client.on("createDsc", (dsc)=>{
            const replayId = replay.getSessionId();
            // We do not want to set the DSC when in buffer mode, as that means the replay has not been sent (yet)
            if (replayId && replay.isEnabled() && replay.recordingMode === "session") {
                // Ensure to check that the session is still active - it could have expired in the meanwhile
                const isSessionActive = replay.checkAndHandleExpiredSession();
                if (isSessionActive) dsc.replay_id = replayId;
            }
        });
        client.on("spanStart", (span)=>{
            replay.lastActiveSpan = span;
        });
        // We may be missing the initial spanStart due to timing issues,
        // so we capture it on finish again.
        client.on("spanEnd", (span)=>{
            replay.lastActiveSpan = span;
        });
        // We want to attach the replay id to the feedback event
        client.on("beforeSendFeedback", async (feedbackEvent, options)=>{
            const replayId = replay.getSessionId();
            if (options?.includeReplay && replay.isEnabled() && replayId && feedbackEvent.contexts?.feedback) {
                // In case the feedback is sent via API and not through our widget, we want to flush replay
                if (feedbackEvent.contexts.feedback.source === "api" && autoFlushOnFeedback) await replay.flush();
                feedbackEvent.contexts.feedback.replay_id = replayId;
            }
        });
        if (autoFlushOnFeedback) client.on("openFeedbackWidget", async ()=>{
            await replay.flush();
        });
    }
}
/**
 * Create a "span" for the total amount of memory being used by JS objects
 * (including v8 internal objects).
 */ async function $2814b83f7132876d$var$addMemoryEntry(replay) {
    // window.performance.memory is a non-standard API and doesn't work on all browsers, so we try-catch this
    try {
        return Promise.all($2814b83f7132876d$var$createPerformanceSpans(replay, [
            // @ts-expect-error memory doesn't exist on type Performance as the API is non-standard (we check that it exists above)
            $2814b83f7132876d$var$createMemoryEntry($2814b83f7132876d$var$WINDOW.performance.memory)
        ]));
    } catch (error) {
        // Do nothing
        return [];
    }
}
function $2814b83f7132876d$var$createMemoryEntry(memoryEntry) {
    const { jsHeapSizeLimit: jsHeapSizeLimit, totalJSHeapSize: totalJSHeapSize, usedJSHeapSize: usedJSHeapSize } = memoryEntry;
    // we don't want to use `getAbsoluteTime` because it adds the event time to the
    // time origin, so we get the current timestamp instead
    const time = Date.now() / 1000;
    return {
        type: "memory",
        name: "memory",
        start: time,
        end: time,
        data: {
            memory: {
                jsHeapSizeLimit: jsHeapSizeLimit,
                totalJSHeapSize: totalJSHeapSize,
                usedJSHeapSize: usedJSHeapSize
            }
        }
    };
}
/**
 * Heavily simplified debounce function based on lodash.debounce.
 *
 * This function takes a callback function (@param fun) and delays its invocation
 * by @param wait milliseconds. Optionally, a maxWait can be specified in @param options,
 * which ensures that the callback is invoked at least once after the specified max. wait time.
 *
 * @param func the function whose invocation is to be debounced
 * @param wait the minimum time until the function is invoked after it was called once
 * @param options the options object, which can contain the `maxWait` property
 *
 * @returns the debounced version of the function, which needs to be called at least once to start the
 *          debouncing process. Subsequent calls will reset the debouncing timer and, in case @paramfunc
 *          was already invoked in the meantime, return @param func's return value.
 *          The debounced function has two additional properties:
 *          - `flush`: Invokes the debounced function immediately and returns its return value
 *          - `cancel`: Cancels the debouncing process and resets the debouncing timer
 */ function $2814b83f7132876d$var$debounce(func, wait, options) {
    return (0, $265204be4a2cf165$export$61fc7d43ac8f84b0)(func, wait, {
        ...options,
        // @ts-expect-error - Not quite sure why these types do not match, but this is fine
        setTimeoutImpl: (0, $31c1fb7be891462e$export$831dc9f2ab0a617b)
    });
}
const $2814b83f7132876d$var$NAVIGATOR = (0, $bf3d8fd3d1ce8fc4$export$f1a6cdb1459e81d1).navigator;
/**
 *  Disable sampling mousemove events on iOS browsers as this can cause blocking the main thread
 *  https://github.com/getsentry/sentry-javascript/issues/14534
 */ function $2814b83f7132876d$var$getRecordingSamplingOptions() {
    if (/iPhone|iPad|iPod/i.test($2814b83f7132876d$var$NAVIGATOR?.userAgent ?? "") || /Macintosh/i.test($2814b83f7132876d$var$NAVIGATOR?.userAgent ?? "") && $2814b83f7132876d$var$NAVIGATOR?.maxTouchPoints && $2814b83f7132876d$var$NAVIGATOR?.maxTouchPoints > 1) return {
        sampling: {
            mousemove: false
        }
    };
    return {};
}
/**
 * Handler for recording events.
 *
 * Adds to event buffer, and has varying flushing behaviors if the event was a checkout.
 */ function $2814b83f7132876d$var$getHandleRecordingEmit(replay) {
    let hadFirstEvent = false;
    return (event, _isCheckout)=>{
        // If this is false, it means session is expired, create and a new session and wait for checkout
        if (!replay.checkAndHandleExpiredSession()) {
            $2814b83f7132876d$var$DEBUG_BUILD && $2814b83f7132876d$var$logger.warn("Received replay event after session expired.");
            return;
        }
        // `_isCheckout` is only set when the checkout is due to `checkoutEveryNms`
        // We also want to treat the first event as a checkout, so we handle this specifically here
        const isCheckout = _isCheckout || !hadFirstEvent;
        hadFirstEvent = true;
        if (replay.clickDetector) $2814b83f7132876d$var$updateClickDetectorForRecordingEvent(replay.clickDetector, event);
        // The handler returns `true` if we do not want to trigger debounced flush, `false` if we want to debounce flush.
        replay.addUpdate(()=>{
            // The session is always started immediately on pageload/init, but for
            // error-only replays, it should reflect the most recent checkout
            // when an error occurs. Clear any state that happens before this current
            // checkout. This needs to happen before `addEvent()` which updates state
            // dependent on this reset.
            if (replay.recordingMode === "buffer" && isCheckout) replay.setInitialState();
            // If the event is not added (e.g. due to being paused, disabled, or out of the max replay duration),
            // Skip all further steps
            if (!$2814b83f7132876d$var$addEventSync(replay, event, isCheckout)) // Return true to skip scheduling a debounced flush
            return true;
            // Different behavior for full snapshots (type=2), ignore other event types
            // See https://github.com/rrweb-io/rrweb/blob/d8f9290ca496712aa1e7d472549480c4e7876594/packages/rrweb/src/types.ts#L16
            if (!isCheckout) return false;
            const session = replay.session;
            // Additionally, create a meta event that will capture certain SDK settings.
            // In order to handle buffer mode, this needs to either be done when we
            // receive checkout events or at flush time. We have an experimental mode
            // to perform multiple checkouts a session (the idea is to improve
            // seeking during playback), so also only include if segmentId is 0
            // (handled in `addSettingsEvent`).
            //
            // `isCheckout` is always true, but want to be explicit that it should
            // only be added for checkouts
            $2814b83f7132876d$var$addSettingsEvent(replay, isCheckout);
            // When in buffer mode, make sure we adjust the session started date to the current earliest event of the buffer
            // this should usually be the timestamp of the checkout event, but to be safe...
            if (replay.recordingMode === "buffer" && session && replay.eventBuffer) {
                const earliestEvent = replay.eventBuffer.getEarliestTimestamp();
                if (earliestEvent) {
                    $2814b83f7132876d$var$DEBUG_BUILD && $2814b83f7132876d$var$logger.info(`Updating session start time to earliest event in buffer to ${new Date(earliestEvent)}`);
                    session.started = earliestEvent;
                    if (replay.getOptions().stickySession) $2814b83f7132876d$var$saveSession(session);
                }
            }
            // If there is a previousSessionId after a full snapshot occurs, then
            // the replay session was started due to session expiration. The new session
            // is started before triggering a new checkout and contains the id
            // of the previous session. Do not immediately flush in this case
            // to avoid capturing only the checkout and instead the replay will
            // be captured if they perform any follow-up actions.
            if (session?.previousSessionId) return true;
            if (replay.recordingMode === "session") // If the full snapshot is due to an initial load, we will not have
            // a previous session ID. In this case, we want to buffer events
            // for a set amount of time before flushing. This can help avoid
            // capturing replays of users that immediately close the window.
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            replay.flush();
            return true;
        });
    };
}
/**
 * Exported for tests
 */ function $2814b83f7132876d$var$createOptionsEvent(replay) {
    const options = replay.getOptions();
    return {
        type: $2814b83f7132876d$var$EventType.Custom,
        timestamp: Date.now(),
        data: {
            tag: "options",
            payload: {
                shouldRecordCanvas: replay.isRecordingCanvas(),
                sessionSampleRate: options.sessionSampleRate,
                errorSampleRate: options.errorSampleRate,
                useCompressionOption: options.useCompression,
                blockAllMedia: options.blockAllMedia,
                maskAllText: options.maskAllText,
                maskAllInputs: options.maskAllInputs,
                useCompression: replay.eventBuffer ? replay.eventBuffer.type === "worker" : false,
                networkDetailHasUrls: options.networkDetailAllowUrls.length > 0,
                networkCaptureBodies: options.networkCaptureBodies,
                networkRequestHasHeaders: options.networkRequestHeaders.length > 0,
                networkResponseHasHeaders: options.networkResponseHeaders.length > 0
            }
        }
    };
}
/**
 * Add a "meta" event that contains a simplified view on current configuration
 * options. This should only be included on the first segment of a recording.
 */ function $2814b83f7132876d$var$addSettingsEvent(replay, isCheckout) {
    // Only need to add this event when sending the first segment
    if (!isCheckout || !replay.session || replay.session.segmentId !== 0) return;
    $2814b83f7132876d$var$addEventSync(replay, $2814b83f7132876d$var$createOptionsEvent(replay), false);
}
/**
 * Create a replay envelope ready to be sent.
 * This includes both the replay event, as well as the recording data.
 */ function $2814b83f7132876d$var$createReplayEnvelope(replayEvent, recordingData, dsn, tunnel) {
    return (0, $ee4fb08d97605578$export$f93f7f385160c44e)((0, $ee4fb08d97605578$export$92b6093782fe661b)(replayEvent, (0, $ee4fb08d97605578$export$d369f3b2758f6743)(replayEvent), tunnel, dsn), [
        [
            {
                type: "replay_event"
            },
            replayEvent
        ],
        [
            {
                type: "replay_recording",
                // If string then we need to encode to UTF8, otherwise will have
                // wrong size. TextEncoder has similar browser support to
                // MutationObserver, although it does not accept IE11.
                length: typeof recordingData === "string" ? new TextEncoder().encode(recordingData).length : recordingData.length
            },
            recordingData
        ]
    ]);
}
/**
 * Prepare the recording data ready to be sent.
 */ function $2814b83f7132876d$var$prepareRecordingData({ recordingData: recordingData, headers: headers }) {
    let payloadWithSequence;
    // XXX: newline is needed to separate sequence id from events
    const replayHeaders = `${JSON.stringify(headers)}
`;
    if (typeof recordingData === "string") payloadWithSequence = `${replayHeaders}${recordingData}`;
    else {
        const enc = new TextEncoder();
        // XXX: newline is needed to separate sequence id from events
        const sequence = enc.encode(replayHeaders);
        // Merge the two Uint8Arrays
        payloadWithSequence = new Uint8Array(sequence.length + recordingData.length);
        payloadWithSequence.set(sequence);
        payloadWithSequence.set(recordingData, sequence.length);
    }
    return payloadWithSequence;
}
/**
 * Prepare a replay event & enrich it with the SDK metadata.
 */ async function $2814b83f7132876d$var$prepareReplayEvent({ client: client, scope: scope, replayId: event_id, event: event }) {
    const integrations = typeof client["_integrations"] === "object" && client["_integrations"] !== null && !Array.isArray(client["_integrations"]) ? Object.keys(client["_integrations"]) : undefined;
    const eventHint = {
        event_id: event_id,
        integrations: integrations
    };
    client.emit("preprocessEvent", event, eventHint);
    const preparedEvent = await (0, $6785e865a7974434$export$2d67fb380bd11267)(client.getOptions(), event, eventHint, scope, client, (0, $b03165fa5825574e$export$68f3af03034c9e90)());
    // If e.g. a global event processor returned null
    if (!preparedEvent) return null;
    client.emit("postprocessEvent", preparedEvent, eventHint);
    // This normally happens in browser client "_prepareEvent"
    // but since we do not use this private method from the client, but rather the plain import
    // we need to do this manually.
    preparedEvent.platform = preparedEvent.platform || "javascript";
    // extract the SDK name because `client._prepareEvent` doesn't add it to the event
    const metadata = client.getSdkMetadata();
    const { name: name, version: version } = metadata?.sdk || {};
    preparedEvent.sdk = {
        ...preparedEvent.sdk,
        name: name || "sentry.javascript.unknown",
        version: version || "0.0.0"
    };
    return preparedEvent;
}
/**
 * Send replay attachment using `fetch()`
 */ async function $2814b83f7132876d$var$sendReplayRequest({ recordingData: recordingData, replayId: replayId, segmentId: segment_id, eventContext: eventContext, timestamp: timestamp, session: session }) {
    const preparedRecordingData = $2814b83f7132876d$var$prepareRecordingData({
        recordingData: recordingData,
        headers: {
            segment_id: segment_id
        }
    });
    const { urls: urls, errorIds: errorIds, traceIds: traceIds, initialTimestamp: initialTimestamp } = eventContext;
    const client = (0, $b03165fa5825574e$export$6bb76d6eba7e258c)();
    const scope = (0, $b03165fa5825574e$export$c7be4b0125a10cba)();
    const transport = client?.getTransport();
    const dsn = client?.getDsn();
    if (!client || !transport || !dsn || !session.sampled) return (0, $e24febe2e5fbb9f7$export$1fda8aa4d135f8aa)({});
    const baseEvent = {
        type: $2814b83f7132876d$var$REPLAY_EVENT_NAME,
        replay_start_timestamp: initialTimestamp / 1000,
        timestamp: timestamp / 1000,
        error_ids: errorIds,
        trace_ids: traceIds,
        urls: urls,
        replay_id: replayId,
        segment_id: segment_id,
        replay_type: session.sampled
    };
    const replayEvent = await $2814b83f7132876d$var$prepareReplayEvent({
        scope: scope,
        client: client,
        replayId: replayId,
        event: baseEvent
    });
    if (!replayEvent) {
        // Taken from baseclient's `_processEvent` method, where this is handled for errors/transactions
        client.recordDroppedEvent("event_processor", "replay");
        $2814b83f7132876d$var$DEBUG_BUILD && $2814b83f7132876d$var$logger.info("An event processor returned `null`, will not send event.");
        return (0, $e24febe2e5fbb9f7$export$1fda8aa4d135f8aa)({});
    }
    /*
  For reference, the fully built event looks something like this:
  {
      "type": "replay_event",
      "timestamp": 1670837008.634,
      "error_ids": [
          "errorId"
      ],
      "trace_ids": [
          "traceId"
      ],
      "urls": [
          "https://example.com"
      ],
      "replay_id": "eventId",
      "segment_id": 3,
      "replay_type": "error",
      "platform": "javascript",
      "event_id": "eventId",
      "environment": "production",
      "sdk": {
          "integrations": [
              "BrowserTracing",
              "Replay"
          ],
          "name": "sentry.javascript.browser",
          "version": "7.25.0"
      },
      "sdkProcessingMetadata": {},
      "contexts": {
      },
  }
  */ // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete replayEvent.sdkProcessingMetadata;
    const envelope = $2814b83f7132876d$var$createReplayEnvelope(replayEvent, preparedRecordingData, dsn, client.getOptions().tunnel);
    let response;
    try {
        response = await transport.send(envelope);
    } catch (err) {
        const error = new Error($2814b83f7132876d$var$UNABLE_TO_SEND_REPLAY);
        try {
            // In case browsers don't allow this property to be writable
            // @ts-expect-error This needs lib es2022 and newer
            error.cause = err;
        } catch  {
        // nothing to do
        }
        throw error;
    }
    // If the status code is invalid, we want to immediately stop & not retry
    if (typeof response.statusCode === "number" && (response.statusCode < 200 || response.statusCode >= 300)) throw new $2814b83f7132876d$var$TransportStatusCodeError(response.statusCode);
    const rateLimits = (0, $3d4033f4c6918770$export$699aff705e0d49d4)({}, response);
    if ((0, $3d4033f4c6918770$export$6c91fec22056810a)(rateLimits, "replay")) throw new $2814b83f7132876d$var$RateLimitError(rateLimits);
    return response;
}
/**
 * This error indicates that the transport returned an invalid status code.
 */ class $2814b83f7132876d$var$TransportStatusCodeError extends Error {
    constructor(statusCode){
        super(`Transport returned status code ${statusCode}`);
    }
}
/**
 * This error indicates that we hit a rate limit API error.
 */ class $2814b83f7132876d$var$RateLimitError extends Error {
    constructor(rateLimits){
        super("Rate limit hit");
        this.rateLimits = rateLimits;
    }
}
/**
 * Finalize and send the current replay event to Sentry
 */ async function $2814b83f7132876d$var$sendReplay(replayData, retryConfig = {
    count: 0,
    interval: $2814b83f7132876d$var$RETRY_BASE_INTERVAL
}) {
    const { recordingData: recordingData, onError: onError } = replayData;
    // short circuit if there's no events to upload (this shouldn't happen as _runFlush makes this check)
    if (!recordingData.length) return;
    try {
        await $2814b83f7132876d$var$sendReplayRequest(replayData);
        return true;
    } catch (err) {
        if (err instanceof $2814b83f7132876d$var$TransportStatusCodeError || err instanceof $2814b83f7132876d$var$RateLimitError) throw err;
        // Capture error for every failed replay
        (0, $45011cfcd1a50cfc$export$2f04de43fe27971a)("Replays", {
            _retryCount: retryConfig.count
        });
        if (onError) onError(err);
        // If an error happened here, it's likely that uploading the attachment
        // failed, we'll can retry with the same events payload
        if (retryConfig.count >= $2814b83f7132876d$var$RETRY_MAX_COUNT) {
            const error = new Error(`${$2814b83f7132876d$var$UNABLE_TO_SEND_REPLAY} - max retries exceeded`);
            try {
                // In case browsers don't allow this property to be writable
                // @ts-expect-error This needs lib es2022 and newer
                error.cause = err;
            } catch  {
            // nothing to do
            }
            throw error;
        }
        // will retry in intervals of 5, 10, 30
        retryConfig.interval *= ++retryConfig.count;
        return new Promise((resolve, reject)=>{
            (0, $31c1fb7be891462e$export$831dc9f2ab0a617b)(async ()=>{
                try {
                    await $2814b83f7132876d$var$sendReplay(replayData, retryConfig);
                    resolve(true);
                } catch (err) {
                    reject(err);
                }
            }, retryConfig.interval);
        });
    }
}
const $2814b83f7132876d$var$THROTTLED = "__THROTTLED";
const $2814b83f7132876d$var$SKIPPED = "__SKIPPED";
/**
 * Create a throttled function off a given function.
 * When calling the throttled function, it will call the original function only
 * if it hasn't been called more than `maxCount` times in the last `durationSeconds`.
 *
 * Returns `THROTTLED` if throttled for the first time, after that `SKIPPED`,
 * or else the return value of the original function.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $2814b83f7132876d$var$throttle(fn, maxCount, durationSeconds) {
    const counter = new Map();
    const _cleanup = (now)=>{
        const threshold = now - durationSeconds;
        counter.forEach((_value, key)=>{
            if (key < threshold) counter.delete(key);
        });
    };
    const _getTotalCount = ()=>{
        return [
            ...counter.values()
        ].reduce((a, b)=>a + b, 0);
    };
    let isThrottled = false;
    return (...rest)=>{
        // Date in second-precision, which we use as basis for the throttling
        const now = Math.floor(Date.now() / 1000);
        // First, make sure to delete any old entries
        _cleanup(now);
        // If already over limit, do nothing
        if (_getTotalCount() >= maxCount) {
            const wasThrottled = isThrottled;
            isThrottled = true;
            return wasThrottled ? $2814b83f7132876d$var$SKIPPED : $2814b83f7132876d$var$THROTTLED;
        }
        isThrottled = false;
        const count = counter.get(now) || 0;
        counter.set(now, count + 1);
        return fn(...rest);
    };
}
/**
 * The main replay container class, which holds all the state and methods for recording and sending replays.
 */ class $2814b83f7132876d$var$ReplayContainer {
    /**
   * Recording can happen in one of two modes:
   *   - session: Record the whole session, sending it continuously
   *   - buffer: Always keep the last 60s of recording, requires:
   *     - having replaysOnErrorSampleRate > 0 to capture replay when an error occurs
   *     - or calling `flush()` to send the replay
   */ /**
   * The current or last active span.
   * This is only available when performance is enabled.
   */ /**
   * These are here so we can overwrite them in tests etc.
   * @hidden
   */ /** The replay has to be manually started, because no sample rate (neither session or error) was provided. */ /**
   * Options to pass to `rrweb.record()`
   */ /**
   * Timestamp of the last user activity. This lives across sessions.
   */ /**
   * Is the integration currently active?
   */ /**
   * Paused is a state where:
   * - DOM Recording is not listening at all
   * - Nothing will be added to event buffer (e.g. core SDK events)
   */ /**
   * Have we attached listeners to the core SDK?
   * Note we have to track this as there is no way to remove instrumentation handlers.
   */ /**
   * Function to stop recording
   */ /**
   * Internal use for canvas recording options
   */ /**
   * Handle when visibility of the page content changes. Opening a new tab will
   * cause the state to change to hidden because of content of current page will
   * be hidden. Likewise, moving a different window to cover the contents of the
   * page will also trigger a change to a hidden state.
   */ /**
   * Handle when page is blurred
   */ /**
   * Handle when page is focused
   */ /** Ensure page remains active when a key is pressed. */ constructor({ options: options, recordingOptions: recordingOptions }){
        this.eventBuffer = null;
        this.performanceEntries = [];
        this.replayPerformanceEntries = [];
        this.recordingMode = "session";
        this.timeouts = {
            sessionIdlePause: $2814b83f7132876d$var$SESSION_IDLE_PAUSE_DURATION,
            sessionIdleExpire: $2814b83f7132876d$var$SESSION_IDLE_EXPIRE_DURATION
        };
        this._lastActivity = Date.now();
        this._isEnabled = false;
        this._isPaused = false;
        this._requiresManualStart = false;
        this._hasInitializedCoreListeners = false;
        this._context = {
            errorIds: new Set(),
            traceIds: new Set(),
            urls: [],
            initialTimestamp: Date.now(),
            initialUrl: ""
        };
        this._recordingOptions = recordingOptions;
        this._options = options;
        this._debouncedFlush = $2814b83f7132876d$var$debounce(()=>this._flush(), this._options.flushMinDelay, {
            maxWait: this._options.flushMaxDelay
        });
        this._throttledAddEvent = $2814b83f7132876d$var$throttle((event, isCheckout)=>$2814b83f7132876d$var$addEvent(this, event, isCheckout), // Max 300 events...
        300, // ... per 5s
        5);
        const { slowClickTimeout: slowClickTimeout, slowClickIgnoreSelectors: slowClickIgnoreSelectors } = this.getOptions();
        const slowClickConfig = slowClickTimeout ? {
            threshold: Math.min($2814b83f7132876d$var$SLOW_CLICK_THRESHOLD, slowClickTimeout),
            timeout: slowClickTimeout,
            scrollTimeout: $2814b83f7132876d$var$SLOW_CLICK_SCROLL_TIMEOUT,
            ignoreSelector: slowClickIgnoreSelectors ? slowClickIgnoreSelectors.join(",") : ""
        } : undefined;
        if (slowClickConfig) this.clickDetector = new $2814b83f7132876d$var$ClickDetector(this, slowClickConfig);
        // Configure replay logger w/ experimental options
        if ($2814b83f7132876d$var$DEBUG_BUILD) {
            const experiments = options._experiments;
            $2814b83f7132876d$var$logger.setConfig({
                captureExceptions: !!experiments.captureExceptions,
                traceInternals: !!experiments.traceInternals
            });
        }
        // We set these handler properties as class properties, to make binding/unbinding them easier
        this._handleVisibilityChange = ()=>{
            if ($2814b83f7132876d$var$WINDOW.document.visibilityState === "visible") this._doChangeToForegroundTasks();
            else this._doChangeToBackgroundTasks();
        };
        /**
     * Handle when page is blurred
     */ this._handleWindowBlur = ()=>{
            const breadcrumb = $2814b83f7132876d$var$createBreadcrumb({
                category: "ui.blur"
            });
            // Do not count blur as a user action -- it's part of the process of them
            // leaving the page
            this._doChangeToBackgroundTasks(breadcrumb);
        };
        this._handleWindowFocus = ()=>{
            const breadcrumb = $2814b83f7132876d$var$createBreadcrumb({
                category: "ui.focus"
            });
            // Do not count focus as a user action -- instead wait until they focus and
            // interactive with page
            this._doChangeToForegroundTasks(breadcrumb);
        };
        /** Ensure page remains active when a key is pressed. */ this._handleKeyboardEvent = (event)=>{
            $2814b83f7132876d$var$handleKeyboardEvent(this, event);
        };
    }
    /** Get the event context. */ getContext() {
        return this._context;
    }
    /** If recording is currently enabled. */ isEnabled() {
        return this._isEnabled;
    }
    /** If recording is currently paused. */ isPaused() {
        return this._isPaused;
    }
    /**
   * Determine if canvas recording is enabled
   */ isRecordingCanvas() {
        return Boolean(this._canvas);
    }
    /** Get the replay integration options. */ getOptions() {
        return this._options;
    }
    /** A wrapper to conditionally capture exceptions. */ handleException(error) {
        $2814b83f7132876d$var$DEBUG_BUILD && $2814b83f7132876d$var$logger.exception(error);
        if (this._options.onError) this._options.onError(error);
    }
    /**
   * Initializes the plugin based on sampling configuration. Should not be
   * called outside of constructor.
   */ initializeSampling(previousSessionId) {
        const { errorSampleRate: errorSampleRate, sessionSampleRate: sessionSampleRate } = this._options;
        // If neither sample rate is > 0, then do nothing - user will need to call one of
        // `start()` or `startBuffering` themselves.
        const requiresManualStart = errorSampleRate <= 0 && sessionSampleRate <= 0;
        this._requiresManualStart = requiresManualStart;
        if (requiresManualStart) return;
        // Otherwise if there is _any_ sample rate set, try to load an existing
        // session, or create a new one.
        this._initializeSessionForSampling(previousSessionId);
        if (!this.session) {
            // This should not happen, something wrong has occurred
            $2814b83f7132876d$var$DEBUG_BUILD && $2814b83f7132876d$var$logger.exception(new Error("Unable to initialize and create session"));
            return;
        }
        if (this.session.sampled === false) // This should only occur if `errorSampleRate` is 0 and was unsampled for
        // session-based replay. In this case there is nothing to do.
        return;
        // If segmentId > 0, it means we've previously already captured this session
        // In this case, we still want to continue in `session` recording mode
        this.recordingMode = this.session.sampled === "buffer" && this.session.segmentId === 0 ? "buffer" : "session";
        $2814b83f7132876d$var$DEBUG_BUILD && $2814b83f7132876d$var$logger.infoTick(`Starting replay in ${this.recordingMode} mode`);
        this._initializeRecording();
    }
    /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will log a message if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * _performanceObserver, Recording, Sentry SDK, etc)
   */ start() {
        if (this._isEnabled && this.recordingMode === "session") {
            $2814b83f7132876d$var$DEBUG_BUILD && $2814b83f7132876d$var$logger.info("Recording is already in progress");
            return;
        }
        if (this._isEnabled && this.recordingMode === "buffer") {
            $2814b83f7132876d$var$DEBUG_BUILD && $2814b83f7132876d$var$logger.info("Buffering is in progress, call `flush()` to save the replay");
            return;
        }
        $2814b83f7132876d$var$DEBUG_BUILD && $2814b83f7132876d$var$logger.infoTick("Starting replay in session mode");
        // Required as user activity is initially set in
        // constructor, so if `start()` is called after
        // session idle expiration, a replay will not be
        // created due to an idle timeout.
        this._updateUserActivity();
        const session = $2814b83f7132876d$var$loadOrCreateSession({
            maxReplayDuration: this._options.maxReplayDuration,
            sessionIdleExpire: this.timeouts.sessionIdleExpire
        }, {
            stickySession: this._options.stickySession,
            // This is intentional: create a new session-based replay when calling `start()`
            sessionSampleRate: 1,
            allowBuffering: false
        });
        this.session = session;
        this._initializeRecording();
    }
    /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, an error occurs.
   */ startBuffering() {
        if (this._isEnabled) {
            $2814b83f7132876d$var$DEBUG_BUILD && $2814b83f7132876d$var$logger.info("Buffering is in progress, call `flush()` to save the replay");
            return;
        }
        $2814b83f7132876d$var$DEBUG_BUILD && $2814b83f7132876d$var$logger.infoTick("Starting replay in buffer mode");
        const session = $2814b83f7132876d$var$loadOrCreateSession({
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            maxReplayDuration: this._options.maxReplayDuration
        }, {
            stickySession: this._options.stickySession,
            sessionSampleRate: 0,
            allowBuffering: true
        });
        this.session = session;
        this.recordingMode = "buffer";
        this._initializeRecording();
    }
    /**
   * Start recording.
   *
   * Note that this will cause a new DOM checkout
   */ startRecording() {
        try {
            const canvasOptions = this._canvas;
            this._stopRecording = $2814b83f7132876d$var$record({
                ...this._recordingOptions,
                // When running in error sampling mode, we need to overwrite `checkoutEveryNms`
                // Without this, it would record forever, until an error happens, which we don't want
                // instead, we'll always keep the last 60 seconds of replay before an error happened
                ...this.recordingMode === "buffer" ? {
                    checkoutEveryNms: $2814b83f7132876d$var$BUFFER_CHECKOUT_TIME
                } : // This is to improve playback seeking as there could potentially be
                // less mutations to process in the worse cases.
                //
                // checkout by "N" events is probably ideal, but means we have less
                // control about the number of checkouts we make (which generally
                // increases replay size)
                this._options._experiments.continuousCheckout && {
                    // Minimum checkout time is 6 minutes
                    checkoutEveryNms: Math.max(360000, this._options._experiments.continuousCheckout)
                },
                emit: $2814b83f7132876d$var$getHandleRecordingEmit(this),
                ...$2814b83f7132876d$var$getRecordingSamplingOptions(),
                onMutation: this._onMutationHandler.bind(this),
                ...canvasOptions ? {
                    recordCanvas: canvasOptions.recordCanvas,
                    getCanvasManager: canvasOptions.getCanvasManager,
                    sampling: canvasOptions.sampling,
                    dataURLOptions: canvasOptions.dataURLOptions
                } : {}
            });
        } catch (err) {
            this.handleException(err);
        }
    }
    /**
   * Stops the recording, if it was running.
   *
   * Returns true if it was previously stopped, or is now stopped,
   * otherwise false.
   */ stopRecording() {
        try {
            if (this._stopRecording) {
                this._stopRecording();
                this._stopRecording = undefined;
            }
            return true;
        } catch (err) {
            this.handleException(err);
            return false;
        }
    }
    /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */ async stop({ forceFlush: forceFlush = false, reason: reason } = {}) {
        if (!this._isEnabled) return;
        // We can't move `_isEnabled` after awaiting a flush, otherwise we can
        // enter into an infinite loop when `stop()` is called while flushing.
        this._isEnabled = false;
        try {
            $2814b83f7132876d$var$DEBUG_BUILD && $2814b83f7132876d$var$logger.info(`Stopping Replay${reason ? ` triggered by ${reason}` : ""}`);
            $2814b83f7132876d$var$resetReplayIdOnDynamicSamplingContext();
            this._removeListeners();
            this.stopRecording();
            this._debouncedFlush.cancel();
            // See comment above re: `_isEnabled`, we "force" a flush, ignoring the
            // `_isEnabled` state of the plugin since it was disabled above.
            if (forceFlush) await this._flush({
                force: true
            });
            // After flush, destroy event buffer
            this.eventBuffer?.destroy();
            this.eventBuffer = null;
            // Clear session from session storage, note this means if a new session
            // is started after, it will not have `previousSessionId`
            $2814b83f7132876d$var$clearSession(this);
        } catch (err) {
            this.handleException(err);
        }
    }
    /**
   * Pause some replay functionality. See comments for `_isPaused`.
   * This differs from stop as this only stops DOM recording, it is
   * not as thorough of a shutdown as `stop()`.
   */ pause() {
        if (this._isPaused) return;
        this._isPaused = true;
        this.stopRecording();
        $2814b83f7132876d$var$DEBUG_BUILD && $2814b83f7132876d$var$logger.info("Pausing replay");
    }
    /**
   * Resumes recording, see notes for `pause().
   *
   * Note that calling `startRecording()` here will cause a
   * new DOM checkout.`
   */ resume() {
        if (!this._isPaused || !this._checkSession()) return;
        this._isPaused = false;
        this.startRecording();
        $2814b83f7132876d$var$DEBUG_BUILD && $2814b83f7132876d$var$logger.info("Resuming replay");
    }
    /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */ async sendBufferedReplayOrFlush({ continueRecording: continueRecording = true } = {}) {
        if (this.recordingMode === "session") return this.flushImmediate();
        const activityTime = Date.now();
        $2814b83f7132876d$var$DEBUG_BUILD && $2814b83f7132876d$var$logger.info("Converting buffer to session");
        // Allow flush to complete before resuming as a session recording, otherwise
        // the checkout from `startRecording` may be included in the payload.
        // Prefer to keep the error replay as a separate (and smaller) segment
        // than the session replay.
        await this.flushImmediate();
        const hasStoppedRecording = this.stopRecording();
        if (!continueRecording || !hasStoppedRecording) return;
        // To avoid race conditions where this is called multiple times, we check here again that we are still buffering
        if (this.recordingMode === "session") return;
        // Re-start recording in session-mode
        this.recordingMode = "session";
        // Once this session ends, we do not want to refresh it
        if (this.session) {
            this._updateUserActivity(activityTime);
            this._updateSessionActivity(activityTime);
            this._maybeSaveSession();
        }
        this.startRecording();
    }
    /**
   * We want to batch uploads of replay events. Save events only if
   * `<flushMinDelay>` milliseconds have elapsed since the last event
   * *OR* if `<flushMaxDelay>` milliseconds have elapsed.
   *
   * Accepts a callback to perform side-effects and returns true to stop batch
   * processing and hand back control to caller.
   */ addUpdate(cb) {
        // We need to always run `cb` (e.g. in the case of `this.recordingMode == 'buffer'`)
        const cbResult = cb();
        // If this option is turned on then we will only want to call `flush`
        // explicitly
        if (this.recordingMode === "buffer") return;
        // If callback is true, we do not want to continue with flushing -- the
        // caller will need to handle it.
        if (cbResult === true) return;
        // addUpdate is called quite frequently - use _debouncedFlush so that it
        // respects the flush delays and does not flush immediately
        this._debouncedFlush();
    }
    /**
   * Updates the user activity timestamp and resumes recording. This should be
   * called in an event handler for a user action that we consider as the user
   * being "active" (e.g. a mouse click).
   */ triggerUserActivity() {
        this._updateUserActivity();
        // This case means that recording was once stopped due to inactivity.
        // Ensure that recording is resumed.
        if (!this._stopRecording) {
            // Create a new session, otherwise when the user action is flushed, it
            // will get rejected due to an expired session.
            if (!this._checkSession()) return;
            // Note: This will cause a new DOM checkout
            this.resume();
            return;
        }
        // Otherwise... recording was never suspended, continue as normalish
        this.checkAndHandleExpiredSession();
        this._updateSessionActivity();
    }
    /**
   * Updates the user activity timestamp *without* resuming
   * recording. Some user events (e.g. keydown) can be create
   * low-value replays that only contain the keypress as a
   * breadcrumb. Instead this would require other events to
   * create a new replay after a session has expired.
   */ updateUserActivity() {
        this._updateUserActivity();
        this._updateSessionActivity();
    }
    /**
   * Only flush if `this.recordingMode === 'session'`
   */ conditionalFlush() {
        if (this.recordingMode === "buffer") return Promise.resolve();
        return this.flushImmediate();
    }
    /**
   * Flush using debounce flush
   */ flush() {
        return this._debouncedFlush();
    }
    /**
   * Always flush via `_debouncedFlush` so that we do not have flushes triggered
   * from calling both `flush` and `_debouncedFlush`. Otherwise, there could be
   * cases of multiple flushes happening closely together.
   */ flushImmediate() {
        this._debouncedFlush();
        // `.flush` is provided by the debounced function, analogously to lodash.debounce
        return this._debouncedFlush.flush();
    }
    /**
   * Cancels queued up flushes.
   */ cancelFlush() {
        this._debouncedFlush.cancel();
    }
    /** Get the current session (=replay) ID */ getSessionId() {
        return this.session?.id;
    }
    /**
   * Checks if recording should be stopped due to user inactivity. Otherwise
   * check if session is expired and create a new session if so. Triggers a new
   * full snapshot on new session.
   *
   * Returns true if session is not expired, false otherwise.
   * @hidden
   */ checkAndHandleExpiredSession() {
        // Prevent starting a new session if the last user activity is older than
        // SESSION_IDLE_PAUSE_DURATION. Otherwise non-user activity can trigger a new
        // session+recording. This creates noisy replays that do not have much
        // content in them.
        if (this._lastActivity && $2814b83f7132876d$var$isExpired(this._lastActivity, this.timeouts.sessionIdlePause) && this.session && this.session.sampled === "session") {
            // Pause recording only for session-based replays. Otherwise, resuming
            // will create a new replay and will conflict with users who only choose
            // to record error-based replays only. (e.g. the resumed replay will not
            // contain a reference to an error)
            this.pause();
            return;
        }
        // --- There is recent user activity --- //
        // This will create a new session if expired, based on expiry length
        if (!this._checkSession()) // Check session handles the refreshing itself
        return false;
        return true;
    }
    /**
   * Capture some initial state that can change throughout the lifespan of the
   * replay. This is required because otherwise they would be captured at the
   * first flush.
   */ setInitialState() {
        const urlPath = `${$2814b83f7132876d$var$WINDOW.location.pathname}${$2814b83f7132876d$var$WINDOW.location.hash}${$2814b83f7132876d$var$WINDOW.location.search}`;
        const url = `${$2814b83f7132876d$var$WINDOW.location.origin}${urlPath}`;
        this.performanceEntries = [];
        this.replayPerformanceEntries = [];
        // Reset _context as well
        this._clearContext();
        this._context.initialUrl = url;
        this._context.initialTimestamp = Date.now();
        this._context.urls.push(url);
    }
    /**
   * Add a breadcrumb event, that may be throttled.
   * If it was throttled, we add a custom breadcrumb to indicate that.
   */ throttledAddEvent(event, isCheckout) {
        const res = this._throttledAddEvent(event, isCheckout);
        // If this is THROTTLED, it means we have throttled the event for the first time
        // In this case, we want to add a breadcrumb indicating that something was skipped
        if (res === $2814b83f7132876d$var$THROTTLED) {
            const breadcrumb = $2814b83f7132876d$var$createBreadcrumb({
                category: "replay.throttled"
            });
            this.addUpdate(()=>{
                // Return `false` if the event _was_ added, as that means we schedule a flush
                return !$2814b83f7132876d$var$addEventSync(this, {
                    type: $2814b83f7132876d$var$ReplayEventTypeCustom,
                    timestamp: breadcrumb.timestamp || 0,
                    data: {
                        tag: "breadcrumb",
                        payload: breadcrumb,
                        metric: true
                    }
                });
            });
        }
        return res;
    }
    /**
   * This will get the parametrized route name of the current page.
   * This is only available if performance is enabled, and if an instrumented router is used.
   */ getCurrentRoute() {
        const lastActiveSpan = this.lastActiveSpan || (0, $d955067cf7638cfb$export$1be426a8e585c83e)();
        const lastRootSpan = lastActiveSpan && (0, $d955067cf7638cfb$export$c4c6a79b1260ca1b)(lastActiveSpan);
        const attributes = lastRootSpan && (0, $d955067cf7638cfb$export$92d8c23565496537)(lastRootSpan).data || {};
        const source = attributes[0, $800ba4cf60399ed2$export$d7a7d984b0791405];
        if (!lastRootSpan || !source || ![
            "route",
            "custom"
        ].includes(source)) return undefined;
        return (0, $d955067cf7638cfb$export$92d8c23565496537)(lastRootSpan).description;
    }
    /**
   * Initialize and start all listeners to varying events (DOM,
   * Performance Observer, Recording, Sentry SDK, etc)
   */ _initializeRecording() {
        this.setInitialState();
        // this method is generally called on page load or manually - in both cases
        // we should treat it as an activity
        this._updateSessionActivity();
        this.eventBuffer = $2814b83f7132876d$var$createEventBuffer({
            useCompression: this._options.useCompression,
            workerUrl: this._options.workerUrl
        });
        this._removeListeners();
        this._addListeners();
        // Need to set as enabled before we start recording, as `record()` can trigger a flush with a new checkout
        this._isEnabled = true;
        this._isPaused = false;
        this.startRecording();
    }
    /**
   * Loads (or refreshes) the current session.
   */ _initializeSessionForSampling(previousSessionId) {
        // Whenever there is _any_ error sample rate, we always allow buffering
        // Because we decide on sampling when an error occurs, we need to buffer at all times if sampling for errors
        const allowBuffering = this._options.errorSampleRate > 0;
        const session = $2814b83f7132876d$var$loadOrCreateSession({
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            maxReplayDuration: this._options.maxReplayDuration,
            previousSessionId: previousSessionId
        }, {
            stickySession: this._options.stickySession,
            sessionSampleRate: this._options.sessionSampleRate,
            allowBuffering: allowBuffering
        });
        this.session = session;
    }
    /**
   * Checks and potentially refreshes the current session.
   * Returns false if session is not recorded.
   */ _checkSession() {
        // If there is no session yet, we do not want to refresh anything
        // This should generally not happen, but to be safe....
        if (!this.session) return false;
        const currentSession = this.session;
        if ($2814b83f7132876d$var$shouldRefreshSession(currentSession, {
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            maxReplayDuration: this._options.maxReplayDuration
        })) {
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this._refreshSession(currentSession);
            return false;
        }
        return true;
    }
    /**
   * Refresh a session with a new one.
   * This stops the current session (without forcing a flush, as that would never work since we are expired),
   * and then does a new sampling based on the refreshed session.
   */ async _refreshSession(session) {
        if (!this._isEnabled) return;
        await this.stop({
            reason: "refresh session"
        });
        this.initializeSampling(session.id);
    }
    /**
   * Adds listeners to record events for the replay
   */ _addListeners() {
        try {
            $2814b83f7132876d$var$WINDOW.document.addEventListener("visibilitychange", this._handleVisibilityChange);
            $2814b83f7132876d$var$WINDOW.addEventListener("blur", this._handleWindowBlur);
            $2814b83f7132876d$var$WINDOW.addEventListener("focus", this._handleWindowFocus);
            $2814b83f7132876d$var$WINDOW.addEventListener("keydown", this._handleKeyboardEvent);
            if (this.clickDetector) this.clickDetector.addListeners();
            // There is no way to remove these listeners, so ensure they are only added once
            if (!this._hasInitializedCoreListeners) {
                $2814b83f7132876d$var$addGlobalListeners(this, {
                    autoFlushOnFeedback: this._options._experiments.autoFlushOnFeedback
                });
                this._hasInitializedCoreListeners = true;
            }
        } catch (err) {
            this.handleException(err);
        }
        this._performanceCleanupCallback = $2814b83f7132876d$var$setupPerformanceObserver(this);
    }
    /**
   * Cleans up listeners that were created in `_addListeners`
   */ _removeListeners() {
        try {
            $2814b83f7132876d$var$WINDOW.document.removeEventListener("visibilitychange", this._handleVisibilityChange);
            $2814b83f7132876d$var$WINDOW.removeEventListener("blur", this._handleWindowBlur);
            $2814b83f7132876d$var$WINDOW.removeEventListener("focus", this._handleWindowFocus);
            $2814b83f7132876d$var$WINDOW.removeEventListener("keydown", this._handleKeyboardEvent);
            if (this.clickDetector) this.clickDetector.removeListeners();
            if (this._performanceCleanupCallback) this._performanceCleanupCallback();
        } catch (err) {
            this.handleException(err);
        }
    }
    /**
   * Tasks to run when we consider a page to be hidden (via blurring and/or visibility)
   */ _doChangeToBackgroundTasks(breadcrumb) {
        if (!this.session) return;
        const expired = $2814b83f7132876d$var$isSessionExpired(this.session, {
            maxReplayDuration: this._options.maxReplayDuration,
            sessionIdleExpire: this.timeouts.sessionIdleExpire
        });
        if (expired) return;
        if (breadcrumb) this._createCustomBreadcrumb(breadcrumb);
        // Send replay when the page/tab becomes hidden. There is no reason to send
        // replay if it becomes visible, since no actions we care about were done
        // while it was hidden
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.conditionalFlush();
    }
    /**
   * Tasks to run when we consider a page to be visible (via focus and/or visibility)
   */ _doChangeToForegroundTasks(breadcrumb) {
        if (!this.session) return;
        const isSessionActive = this.checkAndHandleExpiredSession();
        if (!isSessionActive) {
            // If the user has come back to the page within SESSION_IDLE_PAUSE_DURATION
            // ms, we will re-use the existing session, otherwise create a new
            // session
            $2814b83f7132876d$var$DEBUG_BUILD && $2814b83f7132876d$var$logger.info("Document has become active, but session has expired");
            return;
        }
        if (breadcrumb) this._createCustomBreadcrumb(breadcrumb);
    }
    /**
   * Update user activity (across session lifespans)
   */ _updateUserActivity(_lastActivity = Date.now()) {
        this._lastActivity = _lastActivity;
    }
    /**
   * Updates the session's last activity timestamp
   */ _updateSessionActivity(_lastActivity = Date.now()) {
        if (this.session) {
            this.session.lastActivity = _lastActivity;
            this._maybeSaveSession();
        }
    }
    /**
   * Helper to create (and buffer) a replay breadcrumb from a core SDK breadcrumb
   */ _createCustomBreadcrumb(breadcrumb) {
        this.addUpdate(()=>{
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.throttledAddEvent({
                type: $2814b83f7132876d$var$EventType.Custom,
                timestamp: breadcrumb.timestamp || 0,
                data: {
                    tag: "breadcrumb",
                    payload: breadcrumb
                }
            });
        });
    }
    /**
   * Observed performance events are added to `this.performanceEntries`. These
   * are included in the replay event before it is finished and sent to Sentry.
   */ _addPerformanceEntries() {
        let performanceEntries = $2814b83f7132876d$var$createPerformanceEntries(this.performanceEntries).concat(this.replayPerformanceEntries);
        this.performanceEntries = [];
        this.replayPerformanceEntries = [];
        // If we are manually starting, we want to ensure we only include performance entries
        // that are after the initial timestamp
        // The reason for this is that we may have performance entries from the page load, but may decide to start
        // the replay later on, in which case we do not want to include these entries.
        // without this, manually started replays can have events long before the actual replay recording starts,
        // which messes with the timeline etc.
        if (this._requiresManualStart) {
            const initialTimestampInSeconds = this._context.initialTimestamp / 1000;
            performanceEntries = performanceEntries.filter((entry)=>entry.start >= initialTimestampInSeconds);
        }
        return Promise.all($2814b83f7132876d$var$createPerformanceSpans(this, performanceEntries));
    }
    /**
   * Clear _context
   */ _clearContext() {
        // XXX: `initialTimestamp` and `initialUrl` do not get cleared
        this._context.errorIds.clear();
        this._context.traceIds.clear();
        this._context.urls = [];
    }
    /** Update the initial timestamp based on the buffer content. */ _updateInitialTimestampFromEventBuffer() {
        const { session: session, eventBuffer: eventBuffer } = this;
        // If replay was started manually (=no sample rate was given),
        // We do not want to back-port the initial timestamp
        if (!session || !eventBuffer || this._requiresManualStart) return;
        // we only ever update this on the initial segment
        if (session.segmentId) return;
        const earliestEvent = eventBuffer.getEarliestTimestamp();
        if (earliestEvent && earliestEvent < this._context.initialTimestamp) this._context.initialTimestamp = earliestEvent;
    }
    /**
   * Return and clear _context
   */ _popEventContext() {
        const _context = {
            initialTimestamp: this._context.initialTimestamp,
            initialUrl: this._context.initialUrl,
            errorIds: Array.from(this._context.errorIds),
            traceIds: Array.from(this._context.traceIds),
            urls: this._context.urls
        };
        this._clearContext();
        return _context;
    }
    /**
   * Flushes replay event buffer to Sentry.
   *
   * Performance events are only added right before flushing - this is
   * due to the buffered performance observer events.
   *
   * Should never be called directly, only by `flush`
   */ async _runFlush() {
        const replayId = this.getSessionId();
        if (!this.session || !this.eventBuffer || !replayId) {
            $2814b83f7132876d$var$DEBUG_BUILD && $2814b83f7132876d$var$logger.error("No session or eventBuffer found to flush.");
            return;
        }
        await this._addPerformanceEntries();
        // Check eventBuffer again, as it could have been stopped in the meanwhile
        if (!this.eventBuffer?.hasEvents) return;
        // Only attach memory event if eventBuffer is not empty
        await $2814b83f7132876d$var$addMemoryEntry(this);
        // Check eventBuffer again, as it could have been stopped in the meanwhile
        if (!this.eventBuffer) return;
        // if this changed in the meanwhile, e.g. because the session was refreshed or similar, we abort here
        if (replayId !== this.getSessionId()) return;
        try {
            // This uses the data from the eventBuffer, so we need to call this before `finish()
            this._updateInitialTimestampFromEventBuffer();
            const timestamp = Date.now();
            // Check total duration again, to avoid sending outdated stuff
            // We leave 30s wiggle room to accommodate late flushing etc.
            // This _could_ happen when the browser is suspended during flushing, in which case we just want to stop
            if (timestamp - this._context.initialTimestamp > this._options.maxReplayDuration + 30000) throw new Error("Session is too long, not sending replay");
            const eventContext = this._popEventContext();
            // Always increment segmentId regardless of outcome of sending replay
            const segmentId = this.session.segmentId++;
            this._maybeSaveSession();
            // Note this empties the event buffer regardless of outcome of sending replay
            const recordingData = await this.eventBuffer.finish();
            await $2814b83f7132876d$var$sendReplay({
                replayId: replayId,
                recordingData: recordingData,
                segmentId: segmentId,
                eventContext: eventContext,
                session: this.session,
                timestamp: timestamp,
                onError: (err)=>this.handleException(err)
            });
        } catch (err) {
            this.handleException(err);
            // This means we retried 3 times and all of them failed,
            // or we ran into a problem we don't want to retry, like rate limiting.
            // In this case, we want to completely stop the replay - otherwise, we may get inconsistent segments
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.stop({
                reason: "sendReplay"
            });
            const client = (0, $b03165fa5825574e$export$6bb76d6eba7e258c)();
            if (client) {
                const dropReason = err instanceof $2814b83f7132876d$var$RateLimitError ? "ratelimit_backoff" : "send_error";
                client.recordDroppedEvent(dropReason, "replay");
            }
        }
    }
    /**
   * Flush recording data to Sentry. Creates a lock so that only a single flush
   * can be active at a time. Do not call this directly.
   */ async _flush({ force: force = false } = {}) {
        if (!this._isEnabled && !force) // This can happen if e.g. the replay was stopped because of exceeding the retry limit
        return;
        if (!this.checkAndHandleExpiredSession()) {
            $2814b83f7132876d$var$DEBUG_BUILD && $2814b83f7132876d$var$logger.error("Attempting to finish replay event after session expired.");
            return;
        }
        if (!this.session) // should never happen, as we would have bailed out before
        return;
        const start = this.session.started;
        const now = Date.now();
        const duration = now - start;
        // A flush is about to happen, cancel any queued flushes
        this._debouncedFlush.cancel();
        // If session is too short, or too long (allow some wiggle room over maxReplayDuration), do not send it
        // This _should_ not happen, but it may happen if flush is triggered due to a page activity change or similar
        const tooShort = duration < this._options.minReplayDuration;
        const tooLong = duration > this._options.maxReplayDuration + 5000;
        if (tooShort || tooLong) {
            $2814b83f7132876d$var$DEBUG_BUILD && $2814b83f7132876d$var$logger.info(`Session duration (${Math.floor(duration / 1000)}s) is too ${tooShort ? "short" : "long"}, not sending replay.`);
            if (tooShort) this._debouncedFlush();
            return;
        }
        const eventBuffer = this.eventBuffer;
        if (eventBuffer && this.session.segmentId === 0 && !eventBuffer.hasCheckout) $2814b83f7132876d$var$DEBUG_BUILD && $2814b83f7132876d$var$logger.info("Flushing initial segment without checkout.");
        const _flushInProgress = !!this._flushLock;
        // this._flushLock acts as a lock so that future calls to `_flush()` will
        // be blocked until current flush is finished (i.e. this promise resolves)
        if (!this._flushLock) this._flushLock = this._runFlush();
        try {
            await this._flushLock;
        } catch (err) {
            this.handleException(err);
        } finally{
            this._flushLock = undefined;
            if (_flushInProgress) // Wait for previous flush to finish, then call the debounced
            // `_flush()`. It's possible there are other flush requests queued and
            // waiting for it to resolve. We want to reduce all outstanding
            // requests (as well as any new flush requests that occur within a
            // second of the locked flush completing) into a single flush.
            this._debouncedFlush();
        }
    }
    /** Save the session, if it is sticky */ _maybeSaveSession() {
        if (this.session && this._options.stickySession) $2814b83f7132876d$var$saveSession(this.session);
    }
    /** Handler for rrweb.record.onMutation */ _onMutationHandler(mutations) {
        const count = mutations.length;
        const mutationLimit = this._options.mutationLimit;
        const mutationBreadcrumbLimit = this._options.mutationBreadcrumbLimit;
        const overMutationLimit = mutationLimit && count > mutationLimit;
        // Create a breadcrumb if a lot of mutations happen at the same time
        // We can show this in the UI as an information with potential performance improvements
        if (count > mutationBreadcrumbLimit || overMutationLimit) {
            const breadcrumb = $2814b83f7132876d$var$createBreadcrumb({
                category: "replay.mutations",
                data: {
                    count: count,
                    limit: overMutationLimit
                }
            });
            this._createCustomBreadcrumb(breadcrumb);
        }
        // Stop replay if over the mutation limit
        if (overMutationLimit) {
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.stop({
                reason: "mutationLimit",
                forceFlush: this.recordingMode === "session"
            });
            return false;
        }
        // `true` means we use the regular mutation handling by rrweb
        return true;
    }
}
function $2814b83f7132876d$var$getOption(selectors, defaultSelectors) {
    return [
        ...selectors,
        // sentry defaults
        ...defaultSelectors
    ].join(",");
}
/**
 * Returns privacy related configuration for use in rrweb
 */ function $2814b83f7132876d$var$getPrivacyOptions({ mask: mask, unmask: unmask, block: block, unblock: unblock, ignore: ignore }) {
    const defaultBlockedElements = [
        "base",
        "iframe[srcdoc]:not([src])"
    ];
    const maskSelector = $2814b83f7132876d$var$getOption(mask, [
        ".sentry-mask",
        "[data-sentry-mask]"
    ]);
    const unmaskSelector = $2814b83f7132876d$var$getOption(unmask, []);
    const options = {
        // We are making the decision to make text and input selectors the same
        maskTextSelector: maskSelector,
        unmaskTextSelector: unmaskSelector,
        blockSelector: $2814b83f7132876d$var$getOption(block, [
            ".sentry-block",
            "[data-sentry-block]",
            ...defaultBlockedElements
        ]),
        unblockSelector: $2814b83f7132876d$var$getOption(unblock, []),
        ignoreSelector: $2814b83f7132876d$var$getOption(ignore, [
            ".sentry-ignore",
            "[data-sentry-ignore]",
            'input[type="file"]'
        ])
    };
    return options;
}
/**
 * Masks an attribute if necessary, otherwise return attribute value as-is.
 */ function $2814b83f7132876d$var$maskAttribute({ el: el, key: key, maskAttributes: maskAttributes, maskAllText: maskAllText, privacyOptions: privacyOptions, value: value }) {
    // We only mask attributes if `maskAllText` is true
    if (!maskAllText) return value;
    // unmaskTextSelector takes precedence
    if (privacyOptions.unmaskTextSelector && el.matches(privacyOptions.unmaskTextSelector)) return value;
    if (maskAttributes.includes(key) || // Need to mask `value` attribute for `<input>` if it's a button-like
    // type
    key === "value" && el.tagName === "INPUT" && [
        "submit",
        "button"
    ].includes(el.getAttribute("type") || "")) return value.replace(/[\S]/g, "*");
    return value;
}
const $2814b83f7132876d$var$MEDIA_SELECTORS = 'img,image,svg,video,object,picture,embed,map,audio,link[rel="icon"],link[rel="apple-touch-icon"]';
const $2814b83f7132876d$var$DEFAULT_NETWORK_HEADERS = [
    "content-length",
    "content-type",
    "accept"
];
let $2814b83f7132876d$var$_initialized = false;
/**
 * Sentry integration for [Session Replay](https://sentry.io/for/session-replay/).
 *
 * See the [Replay documentation](https://docs.sentry.io/platforms/javascript/guides/session-replay/) for more information.
 *
 * @example
 *
 * ```
 * Sentry.init({
 *   dsn: '__DSN__',
 *   integrations: [Sentry.replayIntegration()],
 * });
 * ```
 */ const $2814b83f7132876d$export$d7706faf7ab354bf = (options)=>{
    return new $2814b83f7132876d$var$Replay(options);
};
/**
 * Replay integration
 */ class $2814b83f7132876d$var$Replay {
    /**
   * @inheritDoc
   */ /**
   * Options to pass to `rrweb.record()`
   */ /**
   * Initial options passed to the replay integration, merged with default values.
   * Note: `sessionSampleRate` and `errorSampleRate` are not required here, as they
   * can only be finally set when setupOnce() is called.
   *
   * @private
   */ constructor({ flushMinDelay: flushMinDelay = $2814b83f7132876d$var$DEFAULT_FLUSH_MIN_DELAY, flushMaxDelay: flushMaxDelay = $2814b83f7132876d$var$DEFAULT_FLUSH_MAX_DELAY, minReplayDuration: minReplayDuration = $2814b83f7132876d$var$MIN_REPLAY_DURATION, maxReplayDuration: maxReplayDuration = $2814b83f7132876d$var$MAX_REPLAY_DURATION, stickySession: stickySession = true, useCompression: useCompression = true, workerUrl: workerUrl, _experiments: _experiments = {}, maskAllText: maskAllText = true, maskAllInputs: maskAllInputs = true, blockAllMedia: blockAllMedia = true, mutationBreadcrumbLimit: mutationBreadcrumbLimit = 750, mutationLimit: mutationLimit = 10000, slowClickTimeout: slowClickTimeout = 7000, slowClickIgnoreSelectors: slowClickIgnoreSelectors = [], networkDetailAllowUrls: networkDetailAllowUrls = [], networkDetailDenyUrls: networkDetailDenyUrls = [], networkCaptureBodies: networkCaptureBodies = true, networkRequestHeaders: networkRequestHeaders = [], networkResponseHeaders: networkResponseHeaders = [], mask: mask = [], maskAttributes: maskAttributes = [
        "title",
        "placeholder",
        "aria-label"
    ], unmask: unmask = [], block: block = [], unblock: unblock = [], ignore: ignore = [], maskFn: maskFn, beforeAddRecordingEvent: beforeAddRecordingEvent, beforeErrorSampling: beforeErrorSampling, onError: onError } = {}){
        this.name = "Replay";
        const privacyOptions = $2814b83f7132876d$var$getPrivacyOptions({
            mask: mask,
            unmask: unmask,
            block: block,
            unblock: unblock,
            ignore: ignore
        });
        this._recordingOptions = {
            maskAllInputs: maskAllInputs,
            maskAllText: maskAllText,
            maskInputOptions: {
                password: true
            },
            maskTextFn: maskFn,
            maskInputFn: maskFn,
            maskAttributeFn: (key, value, el)=>$2814b83f7132876d$var$maskAttribute({
                    maskAttributes: maskAttributes,
                    maskAllText: maskAllText,
                    privacyOptions: privacyOptions,
                    key: key,
                    value: value,
                    el: el
                }),
            ...privacyOptions,
            // Our defaults
            slimDOMOptions: "all",
            inlineStylesheet: true,
            // Disable inline images as it will increase segment/replay size
            inlineImages: false,
            // collect fonts, but be aware that `sentry.io` needs to be an allowed
            // origin for playback
            collectFonts: true,
            errorHandler: (err)=>{
                try {
                    err.__rrweb__ = true;
                } catch (error) {
                // ignore errors here
                // this can happen if the error is frozen or does not allow mutation for other reasons
                }
            },
            // experimental support for recording iframes from different origins
            recordCrossOriginIframes: Boolean(_experiments.recordCrossOriginIframes)
        };
        this._initialOptions = {
            flushMinDelay: flushMinDelay,
            flushMaxDelay: flushMaxDelay,
            minReplayDuration: Math.min(minReplayDuration, $2814b83f7132876d$var$MIN_REPLAY_DURATION_LIMIT),
            maxReplayDuration: Math.min(maxReplayDuration, $2814b83f7132876d$var$MAX_REPLAY_DURATION),
            stickySession: stickySession,
            useCompression: useCompression,
            workerUrl: workerUrl,
            blockAllMedia: blockAllMedia,
            maskAllInputs: maskAllInputs,
            maskAllText: maskAllText,
            mutationBreadcrumbLimit: mutationBreadcrumbLimit,
            mutationLimit: mutationLimit,
            slowClickTimeout: slowClickTimeout,
            slowClickIgnoreSelectors: slowClickIgnoreSelectors,
            networkDetailAllowUrls: networkDetailAllowUrls,
            networkDetailDenyUrls: networkDetailDenyUrls,
            networkCaptureBodies: networkCaptureBodies,
            networkRequestHeaders: $2814b83f7132876d$var$_getMergedNetworkHeaders(networkRequestHeaders),
            networkResponseHeaders: $2814b83f7132876d$var$_getMergedNetworkHeaders(networkResponseHeaders),
            beforeAddRecordingEvent: beforeAddRecordingEvent,
            beforeErrorSampling: beforeErrorSampling,
            onError: onError,
            _experiments: _experiments
        };
        if (this._initialOptions.blockAllMedia) // `blockAllMedia` is a more user friendly option to configure blocking
        // embedded media elements
        this._recordingOptions.blockSelector = !this._recordingOptions.blockSelector ? $2814b83f7132876d$var$MEDIA_SELECTORS : `${this._recordingOptions.blockSelector},${$2814b83f7132876d$var$MEDIA_SELECTORS}`;
        if (this._isInitialized && (0, $4b7f9433b4245a20$export$4e09c449d6c407f7)()) throw new Error("Multiple Sentry Session Replay instances are not supported");
        this._isInitialized = true;
    }
    /** If replay has already been initialized */ get _isInitialized() {
        return $2814b83f7132876d$var$_initialized;
    }
    /** Update _isInitialized */ set _isInitialized(value) {
        $2814b83f7132876d$var$_initialized = value;
    }
    /**
   * Setup and initialize replay container
   */ afterAllSetup(client) {
        if (!(0, $4b7f9433b4245a20$export$4e09c449d6c407f7)() || this._replay) return;
        this._setup(client);
        this._initialize(client);
    }
    /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will log a message if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * PerformanceObserver, Recording, Sentry SDK, etc)
   */ start() {
        if (!this._replay) return;
        this._replay.start();
    }
    /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, until an error occurs.
   */ startBuffering() {
        if (!this._replay) return;
        this._replay.startBuffering();
    }
    /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */ stop() {
        if (!this._replay) return Promise.resolve();
        return this._replay.stop({
            forceFlush: this._replay.recordingMode === "session"
        });
    }
    /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * If replay is not enabled, a new session replay is started.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */ flush(options) {
        if (!this._replay) return Promise.resolve();
        // assuming a session should be recorded in this case
        if (!this._replay.isEnabled()) {
            this._replay.start();
            return Promise.resolve();
        }
        return this._replay.sendBufferedReplayOrFlush(options);
    }
    /**
   * Get the current session ID.
   */ getReplayId() {
        if (!this._replay?.isEnabled()) return;
        return this._replay.getSessionId();
    }
    /**
   * Get the current recording mode. This can be either `session` or `buffer`.
   *
   * `session`: Recording the whole session, sending it continuously
   * `buffer`: Always keeping the last 60s of recording, requires:
   *   - having replaysOnErrorSampleRate > 0 to capture replay when an error occurs
   *   - or calling `flush()` to send the replay
   */ getRecordingMode() {
        if (!this._replay?.isEnabled()) return;
        return this._replay.recordingMode;
    }
    /**
   * Initializes replay.
   */ _initialize(client) {
        if (!this._replay) return;
        this._maybeLoadFromReplayCanvasIntegration(client);
        this._replay.initializeSampling();
    }
    /** Setup the integration. */ _setup(client) {
        // Client is not available in constructor, so we need to wait until setupOnce
        const finalOptions = $2814b83f7132876d$var$loadReplayOptionsFromClient(this._initialOptions, client);
        this._replay = new $2814b83f7132876d$var$ReplayContainer({
            options: finalOptions,
            recordingOptions: this._recordingOptions
        });
    }
    /** Get canvas options from ReplayCanvas integration, if it is also added. */ _maybeLoadFromReplayCanvasIntegration(client) {
        // To save bundle size, we skip checking for stuff here
        // and instead just try-catch everything - as generally this should all be defined
        /* eslint-disable @typescript-eslint/no-non-null-assertion */ try {
            const canvasIntegration = client.getIntegrationByName("ReplayCanvas");
            if (!canvasIntegration) return;
            this._replay["_canvas"] = canvasIntegration.getOptions();
        } catch  {
        // ignore errors here
        }
    /* eslint-enable @typescript-eslint/no-non-null-assertion */ }
}
/** Parse Replay-related options from SDK options */ function $2814b83f7132876d$var$loadReplayOptionsFromClient(initialOptions, client) {
    const opt = client.getOptions();
    const finalOptions = {
        sessionSampleRate: 0,
        errorSampleRate: 0,
        ...initialOptions
    };
    const replaysSessionSampleRate = (0, $2ef248cc9221d52a$export$a5bd2d81656d9546)(opt.replaysSessionSampleRate);
    const replaysOnErrorSampleRate = (0, $2ef248cc9221d52a$export$a5bd2d81656d9546)(opt.replaysOnErrorSampleRate);
    if (replaysSessionSampleRate == null && replaysOnErrorSampleRate == null) (0, $f1cb9ab3cf87365c$export$cda52e2a8927a2ca)(()=>{
        // eslint-disable-next-line no-console
        console.warn("Replay is disabled because neither `replaysSessionSampleRate` nor `replaysOnErrorSampleRate` are set.");
    });
    if (replaysSessionSampleRate != null) finalOptions.sessionSampleRate = replaysSessionSampleRate;
    if (replaysOnErrorSampleRate != null) finalOptions.errorSampleRate = replaysOnErrorSampleRate;
    return finalOptions;
}
function $2814b83f7132876d$var$_getMergedNetworkHeaders(headers) {
    return [
        ...$2814b83f7132876d$var$DEFAULT_NETWORK_HEADERS,
        ...headers.map((header)=>header.toLowerCase())
    ];
}
/**
 * This is a small utility to get a type-safe instance of the Replay integration.
 */ function $2814b83f7132876d$export$b28310b2f161456b() {
    const client = (0, $b03165fa5825574e$export$6bb76d6eba7e258c)();
    return client?.getIntegrationByName("Replay");
}


// This is a magic string replaced by rollup
const $d9c1a66e2fbc01fd$export$31499a9cd224b78c = "9.33.0";


/** Internal global with common properties and Sentry extensions  */ /** Get's the global object for the current JavaScript runtime */ const $cfd82114b95d3f62$export$f1a6cdb1459e81d1 = globalThis;


/**
 * An object that contains globally accessible properties and maintains a scope stack.
 * @hidden
 */ /**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $a3a94f0659c1ae52$export$19eade501500c6c1() {
    // This ensures a Sentry carrier exists
    $a3a94f0659c1ae52$export$c8bfa33e4e8ae492((0, $cfd82114b95d3f62$export$f1a6cdb1459e81d1));
    return 0, $cfd82114b95d3f62$export$f1a6cdb1459e81d1;
}
/** Will either get the existing sentry carrier, or create a new one. */ function $a3a94f0659c1ae52$export$c8bfa33e4e8ae492(carrier) {
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    // For now: First SDK that sets the .version property wins
    __SENTRY__.version = __SENTRY__.version || (0, $d9c1a66e2fbc01fd$export$31499a9cd224b78c);
    // Intentionally populating and returning the version of "this" SDK instance
    // rather than what's set in .version so that "this" SDK always gets its carrier
    return __SENTRY__[0, $d9c1a66e2fbc01fd$export$31499a9cd224b78c] = __SENTRY__[0, $d9c1a66e2fbc01fd$export$31499a9cd224b78c] || {};
}
/**
 * Returns a global singleton contained in the global `__SENTRY__[]` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $a3a94f0659c1ae52$export$7e223ec222791509(name, creator, obj = (0, $cfd82114b95d3f62$export$f1a6cdb1459e81d1)) {
    const __SENTRY__ = obj.__SENTRY__ = obj.__SENTRY__ || {};
    const carrier = __SENTRY__[0, $d9c1a66e2fbc01fd$export$31499a9cd224b78c] = __SENTRY__[0, $d9c1a66e2fbc01fd$export$31499a9cd224b78c] || {};
    // Note: We do not want to set `carrier.version` here, as this may be called before any `init` is called, e.g. for the default scopes
    return carrier[name] || (carrier[name] = creator());
}



/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $0ff2b032dfd8dfc4$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;


// eslint-disable-next-line @typescript-eslint/unbound-method
const $74a491f11c036384$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $74a491f11c036384$export$e6127cc7fe7395c3(wat) {
    switch($74a491f11c036384$var$objectToString.call(wat)){
        case "[object Error]":
        case "[object Exception]":
        case "[object DOMException]":
        case "[object WebAssembly.Exception]":
            return true;
        default:
            return $74a491f11c036384$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $74a491f11c036384$var$isBuiltin(wat, className) {
    return $74a491f11c036384$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $74a491f11c036384$export$9f9636d330b71954(wat) {
    return $74a491f11c036384$var$isBuiltin(wat, "ErrorEvent");
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $74a491f11c036384$export$ef9e2056653f0c8e(wat) {
    return $74a491f11c036384$var$isBuiltin(wat, "DOMError");
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $74a491f11c036384$export$12e869b2a583f783(wat) {
    return $74a491f11c036384$var$isBuiltin(wat, "DOMException");
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $74a491f11c036384$export$844ec244b1367d54(wat) {
    return $74a491f11c036384$var$isBuiltin(wat, "String");
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $74a491f11c036384$export$dbcbffa59149b824(wat) {
    return typeof wat === "object" && wat !== null && "__sentry_template_string__" in wat && "__sentry_template_values__" in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $74a491f11c036384$export$c3825b437cbdea5c(wat) {
    return wat === null || $74a491f11c036384$export$dbcbffa59149b824(wat) || typeof wat !== "object" && typeof wat !== "function";
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $74a491f11c036384$export$53b83ca8eaab0383(wat) {
    return $74a491f11c036384$var$isBuiltin(wat, "Object");
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $74a491f11c036384$export$9671ea99bd126ace(wat) {
    return typeof Event !== "undefined" && $74a491f11c036384$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $74a491f11c036384$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== "undefined" && $74a491f11c036384$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $74a491f11c036384$export$49841c62b9eff15(wat) {
    return $74a491f11c036384$var$isBuiltin(wat, "RegExp");
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $74a491f11c036384$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat?.then && typeof wat.then === "function");
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $74a491f11c036384$export$bc2894c7158efbac(wat) {
    return $74a491f11c036384$export$53b83ca8eaab0383(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $74a491f11c036384$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $74a491f11c036384$export$7916fad0ebc23f48(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    return !!(typeof wat === "object" && wat !== null && (wat.__isVue || wat._isVue));
}
/**
 * Checks whether the given parameter is a Standard Web API Request instance.
 *
 * Returns false if Request is not available in the current runtime.
 */ function $74a491f11c036384$export$6d3d1f317d7cda57(request) {
    return typeof Request !== "undefined" && $74a491f11c036384$export$49034edbe6b62415(request, Request);
}



const $627cb013759466b6$var$WINDOW = (0, $cfd82114b95d3f62$export$f1a6cdb1459e81d1);
const $627cb013759466b6$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $627cb013759466b6$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return "<unknown>";
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = " > ";
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $627cb013759466b6$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $627cb013759466b6$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return "<unknown>";
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $627cb013759466b6$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    if (!elem?.tagName) return "";
    // @ts-expect-error WINDOW has HTMLElement
    if ($627cb013759466b6$var$WINDOW.HTMLElement) // If using the component name annotation plugin, this value may be available on the DOM node
    {
        if (elem instanceof HTMLElement && elem.dataset) {
            if (elem.dataset["sentryComponent"]) return elem.dataset["sentryComponent"];
            if (elem.dataset["sentryElement"]) return elem.dataset["sentryElement"];
        }
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs?.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs?.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        const className = elem.className;
        if (className && (0, $74a491f11c036384$export$844ec244b1367d54)(className)) {
            const classes = className.split(/\s+/);
            for (const c of classes)out.push(`.${c}`);
        }
    }
    const allowedAttrs = [
        "aria-label",
        "type",
        "name",
        "title",
        "alt"
    ];
    for (const k of allowedAttrs){
        const attr = elem.getAttribute(k);
        if (attr) out.push(`[${k}="${attr}"]`);
    }
    return out.join("");
}
/**
 * A safe form of location.href
 */ function $627cb013759466b6$export$1cfafeee2987818b() {
    try {
        return $627cb013759466b6$var$WINDOW.document.location.href;
    } catch (oO) {
        return "";
    }
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` or `data-sentry-element` attribute with `data-sentry-component` taking
 * precedence. This attribute is added at build-time by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function $627cb013759466b6$export$26727cfcc4d7e0fc(elem) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!$627cb013759466b6$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    const MAX_TRAVERSE_HEIGHT = 5;
    for(let i = 0; i < MAX_TRAVERSE_HEIGHT; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement) {
            if (currentElem.dataset["sentryComponent"]) return currentElem.dataset["sentryComponent"];
            if (currentElem.dataset["sentryElement"]) return currentElem.dataset["sentryElement"];
        }
        currentElem = currentElem.parentNode;
    }
    return null;
}






/** Prefix for logging strings */ const $ba0a81389f3fecaf$var$PREFIX = "Sentry Logger ";
const $ba0a81389f3fecaf$export$2a2b1d2252a69ecb = [
    "debug",
    "info",
    "warn",
    "error",
    "log",
    "assert",
    "trace"
];
/** This may be mutated by the console instrumentation. */ const $ba0a81389f3fecaf$export$77c4ce905194557b = {};
/** A Sentry Logger instance. */ /**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $ba0a81389f3fecaf$export$cda52e2a8927a2ca(callback) {
    if (!("console" in (0, $cfd82114b95d3f62$export$f1a6cdb1459e81d1))) return callback();
    const console = (0, $cfd82114b95d3f62$export$f1a6cdb1459e81d1).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($ba0a81389f3fecaf$export$77c4ce905194557b);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $ba0a81389f3fecaf$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $ba0a81389f3fecaf$var$makeLogger() {
    let enabled = false;
    const logger = {
        enable: ()=>{
            enabled = true;
        },
        disable: ()=>{
            enabled = false;
        },
        isEnabled: ()=>enabled
    };
    if (0, $0ff2b032dfd8dfc4$export$16a28057038b10ef) $ba0a81389f3fecaf$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = (...args)=>{
            if (enabled) $ba0a81389f3fecaf$export$cda52e2a8927a2ca(()=>{
                (0, $cfd82114b95d3f62$export$f1a6cdb1459e81d1).console[name](`${$ba0a81389f3fecaf$var$PREFIX}[${name}]:`, ...args);
            });
        };
    });
    else $ba0a81389f3fecaf$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = ()=>undefined;
    });
    return logger;
}
/**
 * This is a logger singleton which either logs things or no-ops if logging is not enabled.
 * The logger is a singleton on the carrier, to ensure that a consistent logger is used throughout the SDK.
 */ const $ba0a81389f3fecaf$export$af88d00dbe7f521 = (0, $a3a94f0659c1ae52$export$7e223ec222791509)("logger", $ba0a81389f3fecaf$var$makeLogger);



/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $7f9b723c5d3beb16$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== "string" || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $7f9b723c5d3beb16$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += " {snip}";
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ function $7f9b723c5d3beb16$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return "";
    const output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, $74a491f11c036384$export$7916fad0ebc23f48)(value)) output.push("[VueViewModel]");
            else output.push(String(value));
        } catch (e) {
            output.push("[value cannot be serialized]");
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $7f9b723c5d3beb16$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $74a491f11c036384$export$844ec244b1367d54)(value)) return false;
    if ((0, $74a491f11c036384$export$49841c62b9eff15)(pattern)) return pattern.test(value);
    if ((0, $74a491f11c036384$export$844ec244b1367d54)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $7f9b723c5d3beb16$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$7f9b723c5d3beb16$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}


/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Replace a method in an object with a wrapped version of itself.
 *
 * If the method on the passed object is not a function, the wrapper will not be applied.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $d7ca46ba0a15e3a0$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    // explicitly casting to unknown because we don't know the type of the method initially at all
    const original = source[name];
    if (typeof original !== "function") return;
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === "function") $d7ca46ba0a15e3a0$export$5c1499e2e5d010ae(wrapped, original);
    try {
        source[name] = wrapped;
    } catch  {
        (0, $0ff2b032dfd8dfc4$export$16a28057038b10ef) && (0, $ba0a81389f3fecaf$export$af88d00dbe7f521).log(`Failed to replace method "${name}" in object`, source);
    }
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $d7ca46ba0a15e3a0$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch (o_O) {
        (0, $0ff2b032dfd8dfc4$export$16a28057038b10ef) && (0, $ba0a81389f3fecaf$export$af88d00dbe7f521).log(`Failed to add non-enumerable property "${name}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $d7ca46ba0a15e3a0$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $d7ca46ba0a15e3a0$export$e73679ffaf56810e(wrapped, "__sentry_original__", original);
    } catch (o_O) {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $d7ca46ba0a15e3a0$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argument itself, when value is neither an Event nor
 *  an Error.
 */ function $d7ca46ba0a15e3a0$export$62ff257738bf57f5(value) {
    if ((0, $74a491f11c036384$export$e6127cc7fe7395c3)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$d7ca46ba0a15e3a0$var$getOwnProperties(value)
    };
    else if ((0, $74a491f11c036384$export$9671ea99bd126ace)(value)) {
        const newObj = {
            type: value.type,
            target: $d7ca46ba0a15e3a0$var$serializeEventTarget(value.target),
            currentTarget: $d7ca46ba0a15e3a0$var$serializeEventTarget(value.currentTarget),
            ...$d7ca46ba0a15e3a0$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== "undefined" && (0, $74a491f11c036384$export$49034edbe6b62415)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $d7ca46ba0a15e3a0$var$serializeEventTarget(target) {
    try {
        return (0, $74a491f11c036384$export$45a5e7f76e0caa8d)(target) ? (0, $627cb013759466b6$export$5647df6b7814ac86)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return "<unknown>";
    }
}
/** Filters out all but an object's own properties */ function $d7ca46ba0a15e3a0$var$getOwnProperties(obj) {
    if (typeof obj === "object" && obj !== null) {
        const extractedProps = {};
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $d7ca46ba0a15e3a0$export$b0244d5063c0b61b(exception, maxLength = 40) {
    const keys = Object.keys($d7ca46ba0a15e3a0$export$62ff257738bf57f5(exception));
    keys.sort();
    const firstKey = keys[0];
    if (!firstKey) return "[object has no keys]";
    if (firstKey.length >= maxLength) return (0, $7f9b723c5d3beb16$export$6a506b36fdea397d)(firstKey, maxLength);
    for(let includedKeys = keys.length; includedKeys > 0; includedKeys--){
        const serialized = keys.slice(0, includedKeys).join(", ");
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $7f9b723c5d3beb16$export$6a506b36fdea397d)(serialized, maxLength);
    }
    return "";
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 *
 * @deprecated This function is no longer used by the SDK and will be removed in a future major version.
 */ function $d7ca46ba0a15e3a0$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $d7ca46ba0a15e3a0$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $d7ca46ba0a15e3a0$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    // Early return for primitive values
    if (inputValue === null || typeof inputValue !== "object") return inputValue;
    // Check memo map first for all object types
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== undefined) return memoVal;
    // handle arrays
    if (Array.isArray(inputValue)) {
        const returnValue = [];
        // Store mapping to handle circular references
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((value)=>{
            returnValue.push($d7ca46ba0a15e3a0$var$_dropUndefinedKeys(value, memoizationMap));
        });
        return returnValue;
    }
    if ($d7ca46ba0a15e3a0$var$isPojo(inputValue)) {
        const returnValue = {};
        // Store mapping to handle circular references
        memoizationMap.set(inputValue, returnValue);
        const keys = Object.keys(inputValue);
        keys.forEach((key)=>{
            const val = inputValue[key];
            if (val !== undefined) returnValue[key] = $d7ca46ba0a15e3a0$var$_dropUndefinedKeys(val, memoizationMap);
        });
        return returnValue;
    }
    // For other object types, return as is
    return inputValue;
}
function $d7ca46ba0a15e3a0$var$isPojo(input) {
    // Plain objects have Object as constructor or no constructor
    const constructor = input.constructor;
    return constructor === Object || constructor === undefined;
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $d7ca46ba0a15e3a0$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        // this will catch both undefined and null
        case wat == undefined:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === "symbol" || typeof wat === "bigint":
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $74a491f11c036384$export$c3825b437cbdea5c)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}




function $b02a41fd7bbcc8b3$var$getCrypto() {
    const gbl = (0, $cfd82114b95d3f62$export$f1a6cdb1459e81d1);
    return gbl.crypto || gbl.msCrypto;
}
/**
 * UUID4 generator
 * @param crypto Object that provides the crypto API.
 * @returns string Generated UUID4.
 */ function $b02a41fd7bbcc8b3$export$19f53698e68b2496(crypto = $b02a41fd7bbcc8b3$var$getCrypto()) {
    let getRandomByte = ()=>Math.random() * 16;
    try {
        if (crypto?.randomUUID) return crypto.randomUUID().replace(/-/g, "");
        if (crypto?.getRandomValues) getRandomByte = ()=>{
            // crypto.getRandomValues might return undefined instead of the typed array
            // in old Chromium versions (e.g. 23.0.1235.0 (151422))
            // However, `typedArray` is still filled in-place.
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues#typedarray
            const typedArray = new Uint8Array(1);
            crypto.getRandomValues(typedArray);
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            return typedArray[0];
        };
    } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function $b02a41fd7bbcc8b3$var$getFirstException(event) {
    return event.exception?.values?.[0];
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $b02a41fd7bbcc8b3$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $b02a41fd7bbcc8b3$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || "<unknown>";
    }
    return eventId || "<unknown>";
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $b02a41fd7bbcc8b3$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || "";
    if (!firstException.type) firstException.type = type || "Error";
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $b02a41fd7bbcc8b3$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $b02a41fd7bbcc8b3$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: "generic",
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && "data" in newMechanism) {
        const mergedData = {
            ...currentMechanism?.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $b02a41fd7bbcc8b3$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ function $b02a41fd7bbcc8b3$var$_parseInt(input) {
    return parseInt(input || "", 10);
}
/**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $b02a41fd7bbcc8b3$export$d364f2020ab30578(input) {
    const match = input.match($b02a41fd7bbcc8b3$var$SEMVER_REGEXP) || [];
    const major = $b02a41fd7bbcc8b3$var$_parseInt(match[1]);
    const minor = $b02a41fd7bbcc8b3$var$_parseInt(match[2]);
    const patch = $b02a41fd7bbcc8b3$var$_parseInt(match[3]);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $b02a41fd7bbcc8b3$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $7f9b723c5d3beb16$export$4215662d762d6f9d)(line, 0));
    // We guard here to ensure this is not larger than the existing number of lines
    const lineIndex = Math.min(maxLines - 1, sourceLine);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    frame.context_line = (0, $7f9b723c5d3beb16$export$4215662d762d6f9d)(lines[lineIndex], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $7f9b723c5d3beb16$export$4215662d762d6f9d)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $b02a41fd7bbcc8b3$export$6de4ffac6a2f1098(exception) {
    if ($b02a41fd7bbcc8b3$var$isAlreadyCaptured(exception)) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $d7ca46ba0a15e3a0$export$e73679ffaf56810e)(exception, "__sentry_captured__", true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
function $b02a41fd7bbcc8b3$var$isAlreadyCaptured(exception) {
    try {
        return exception.__sentry_captured__;
    } catch  {} // eslint-disable-line no-empty
}



const $e53342135f887ac2$var$ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 */ function $e53342135f887ac2$export$7740643b9eeaf0c4() {
    return Date.now() / $e53342135f887ac2$var$ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function $e53342135f887ac2$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $cfd82114b95d3f62$export$f1a6cdb1459e81d1);
    if (!performance?.now) return $e53342135f887ac2$export$7740643b9eeaf0c4;
    // Some browser and environments don't have a timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    const approxStartingTimeOrigin = Date.now() - performance.now();
    const timeOrigin = performance.timeOrigin == undefined ? approxStartingTimeOrigin : performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return ()=>{
        return (timeOrigin + performance.now()) / $e53342135f887ac2$var$ONE_SECOND_IN_MS;
    };
}
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ const $e53342135f887ac2$export$ee52dced521e3e18 = $e53342135f887ac2$var$createUnixTimestampInSecondsFunc();
/**
 * Cached result of getBrowserTimeOrigin.
 */ let $e53342135f887ac2$var$cachedTimeOrigin;
/**
 * Gets the time origin and the mode used to determine it.
 */ function $e53342135f887ac2$var$getBrowserTimeOrigin() {
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    const { performance: performance } = (0, $cfd82114b95d3f62$export$f1a6cdb1459e81d1);
    if (!performance?.now) return [
        undefined,
        "none"
    ];
    const threshold = 3600000;
    const performanceNow = performance.now();
    const dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    const timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing?.navigationStart;
    const hasNavigationStart = typeof navigationStart === "number";
    // if navigationStart isn't available set delta to threshold so it isn't used
    const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    const navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) return [
            performance.timeOrigin,
            "timeOrigin"
        ];
        else return [
            navigationStart,
            "navigationStart"
        ];
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    return [
        dateNow,
        "dateNow"
    ];
}
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ function $e53342135f887ac2$export$baf075a948ffc0bf() {
    if (!$e53342135f887ac2$var$cachedTimeOrigin) $e53342135f887ac2$var$cachedTimeOrigin = $e53342135f887ac2$var$getBrowserTimeOrigin();
    return $e53342135f887ac2$var$cachedTimeOrigin[0];
}


/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $64abcd80499b27c7$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $e53342135f887ac2$export$ee52dced521e3e18)();
    const session = {
        sid: (0, $b02a41fd7bbcc8b3$export$19f53698e68b2496)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: "ok",
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$64abcd80499b27c7$var$sessionToJSON(session)
    };
    if (context) $64abcd80499b27c7$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see Client.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $64abcd80499b27c7$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $e53342135f887ac2$export$ee52dced521e3e18)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $b02a41fd7bbcc8b3$export$19f53698e68b2496)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === "number") session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === "number") session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === "number") session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $64abcd80499b27c7$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === "ok") context = {
        status: "exited"
    };
    $64abcd80499b27c7$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $64abcd80499b27c7$var$sessionToJSON(session) {
    return {
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === "number" || typeof session.did === "string" ? `${session.did}` : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    };
}




/**
 * Shallow merge two objects.
 * Does not mutate the passed in objects.
 * Undefined/empty values in the merge object will overwrite existing values.
 *
 * By default, this merges 2 levels deep.
 */ function $137112c5577a2db1$export$4950aa0f605343fb(initialObj, mergeObj, levels = 2) {
    // If the merge value is not an object, or we have no merge levels left,
    // we just set the value to the merge value
    if (!mergeObj || typeof mergeObj !== "object" || levels <= 0) return mergeObj;
    // If the merge object is an empty object, and the initial object is not undefined, we return the initial object
    if (initialObj && Object.keys(mergeObj).length === 0) return initialObj;
    // Clone object
    const output = {
        ...initialObj
    };
    // Merge values into output, resursively
    for(const key in mergeObj)if (Object.prototype.hasOwnProperty.call(mergeObj, key)) output[key] = $137112c5577a2db1$export$4950aa0f605343fb(output[key], mergeObj[key], levels - 1);
    return output;
}




/**
 * Generate a random, valid trace ID.
 */ function $5f84b47bcde86f06$export$dc6d7ea554bcce10() {
    return (0, $b02a41fd7bbcc8b3$export$19f53698e68b2496)();
}
/**
 * Generate a random, valid span ID.
 */ function $5f84b47bcde86f06$export$295213bc4d0c54ad() {
    return (0, $b02a41fd7bbcc8b3$export$19f53698e68b2496)().substring(16);
}



const $449bd8f78d15bda4$var$SCOPE_SPAN_FIELD = "_sentrySpan";
/**
 * Set the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $449bd8f78d15bda4$export$3f25fa50c18e20ca(scope, span) {
    if (span) (0, $d7ca46ba0a15e3a0$export$e73679ffaf56810e)(scope, $449bd8f78d15bda4$var$SCOPE_SPAN_FIELD, span);
    else // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
    delete scope[$449bd8f78d15bda4$var$SCOPE_SPAN_FIELD];
}
/**
 * Get the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $449bd8f78d15bda4$export$91f063ebb8eff307(scope) {
    return scope[$449bd8f78d15bda4$var$SCOPE_SPAN_FIELD];
}




/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $49335ddafc3f2633$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * A context to be used for capturing an event.
 * This can either be a Scope, or a partial ScopeContext,
 * or a callback that receives the current scope and returns a new scope to use.
 */ /**
 * Holds additional event information.
 */ class $49335ddafc3f2633$export$775b6bb06e53a214 {
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called during event processing. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Extra */ /** Contexts */ /** Attachments */ /** Propagation Context for distributed tracing */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */ /** Session */ /** The client on this scope */ /** Contains the last event id of a captured event.  */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = {
            traceId: (0, $5f84b47bcde86f06$export$dc6d7ea554bcce10)(),
            sampleRand: Math.random()
        };
    }
    /**
   * Clone all data from this scope into a new scope.
   */ clone() {
        const newScope = new $49335ddafc3f2633$export$775b6bb06e53a214();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        if (this._contexts.flags) // We need to copy the `values` array so insertions on a cloned scope
        // won't affect the original array.
        newScope._contexts.flags = {
            values: [
                ...this._contexts.flags.values
            ]
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        newScope._lastEventId = this._lastEventId;
        (0, $449bd8f78d15bda4$export$3f25fa50c18e20ca)(newScope, (0, $449bd8f78d15bda4$export$91f063ebb8eff307)(this));
        return newScope;
    }
    /**
   * Update the client assigned to this scope.
   * Note that not every scope will have a client assigned - isolation scopes & the global scope will generally not have a client,
   * as well as manually created scopes.
   */ setClient(client) {
        this._client = client;
    }
    /**
   * Set the ID of the last captured error event.
   * This is generally only captured on the isolation scope.
   */ setLastEventId(lastEventId) {
        this._lastEventId = lastEventId;
    }
    /**
   * Get the client assigned to this scope.
   */ getClient() {
        return this._client;
    }
    /**
   * Get the ID of the last captured error event.
   * This is generally only available on the isolation scope.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * Add an event processor that will be called before an event is sent.
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * Set the user for this scope.
   * Set to `null` to unset the user.
   */ setUser(user) {
        // If null is passed we want to unset everything, but still define keys,
        // so that later down in the pipeline any existing values are cleared.
        this._user = user || {
            email: undefined,
            id: undefined,
            ip_address: undefined,
            username: undefined
        };
        if (this._session) (0, $64abcd80499b27c7$export$531818e825e774db)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the user from this scope.
   */ getUser() {
        return this._user;
    }
    /**
   * Set an object that will be merged into existing tags on the scope,
   * and will be sent as tags data with the event.
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single tag that will be sent as tags data with the event.
   */ setTag(key, value) {
        this._tags = {
            ...this._tags,
            [key]: value
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set an object that will be merged into existing extra on the scope,
   * and will be sent as extra data with the event.
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single key:value extra entry that will be sent as extra data with the event.
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the fingerprint on the scope to send with the events.
   * @param {string[]} fingerprint Fingerprint to group events in Sentry.
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the level on the scope for future events.
   */ setLevel(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope so that the name of e.g. taken server route or
   * the page location is attached to future events.
   *
   * IMPORTANT: Calling this function does NOT change the name of the currently active
   * root span. If you want to change the name of the active root span, use
   * `Sentry.updateSpanName(rootSpan, 'new name')` instead.
   *
   * By default, the SDK updates the scope's transaction name automatically on sensible
   * occasions, such as a page navigation or when handling a new request on the server.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets context data with the given name.
   * Data passed as context will be normalized. You can also pass `null` to unset the context.
   * Note that context data will not be merged - calling `setContext` will overwrite an existing context with the same key.
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set the session for the scope.
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the session from the scope.
   */ getSession() {
        return this._session;
    }
    /**
   * Updates the scope with provided data. Can work in three variations:
   * - plain object containing updatable attributes
   * - Scope instance that'll extract the attributes from
   * - callback function that'll receive the current scope as an argument and allow for modifications
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === "function" ? captureContext(this) : captureContext;
        const scopeInstance = scopeToMerge instanceof $49335ddafc3f2633$export$775b6bb06e53a214 ? scopeToMerge.getScopeData() : (0, $74a491f11c036384$export$53b83ca8eaab0383)(scopeToMerge) ? captureContext : undefined;
        const { tags: tags, extra: extra, user: user, contexts: contexts, level: level, fingerprint: fingerprint = [], propagationContext: propagationContext } = scopeInstance || {};
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._extra = {
            ...this._extra,
            ...extra
        };
        this._contexts = {
            ...this._contexts,
            ...contexts
        };
        if (user && Object.keys(user).length) this._user = user;
        if (level) this._level = level;
        if (fingerprint.length) this._fingerprint = fingerprint;
        if (propagationContext) this._propagationContext = propagationContext;
        return this;
    }
    /**
   * Clears the current scope and resets its properties.
   * Note: The client will not be cleared.
   */ clear() {
        // client is not cleared here on purpose!
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._session = undefined;
        (0, $449bd8f78d15bda4$export$3f25fa50c18e20ca)(this, undefined);
        this._attachments = [];
        this.setPropagationContext({
            traceId: (0, $5f84b47bcde86f06$export$dc6d7ea554bcce10)(),
            sampleRand: Math.random()
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Adds a breadcrumb to the scope.
   * By default, the last 100 breadcrumbs are kept.
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === "number" ? maxBreadcrumbs : $49335ddafc3f2633$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $e53342135f887ac2$export$7740643b9eeaf0c4)(),
            ...breadcrumb,
            // Breadcrumb messages can theoretically be infinitely large and they're held in memory so we truncate them not to leak (too much) memory
            message: breadcrumb.message ? (0, $7f9b723c5d3beb16$export$6a506b36fdea397d)(breadcrumb.message, 2048) : breadcrumb.message
        };
        this._breadcrumbs.push(mergedBreadcrumb);
        if (this._breadcrumbs.length > maxCrumbs) {
            this._breadcrumbs = this._breadcrumbs.slice(-maxCrumbs);
            this._client?.recordDroppedEvent("buffer_overflow", "log_item");
        }
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the last breadcrumb of the scope.
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * Clear all breadcrumbs from the scope.
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Add an attachment to the scope.
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * Clear all attachments from the scope.
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /**
   * Get the data of this scope, which should be applied to an event during processing.
   */ getScopeData() {
        return {
            breadcrumbs: this._breadcrumbs,
            attachments: this._attachments,
            contexts: this._contexts,
            tags: this._tags,
            extra: this._extra,
            user: this._user,
            level: this._level,
            fingerprint: this._fingerprint || [],
            eventProcessors: this._eventProcessors,
            propagationContext: this._propagationContext,
            sdkProcessingMetadata: this._sdkProcessingMetadata,
            transactionName: this._transactionName,
            span: (0, $449bd8f78d15bda4$export$91f063ebb8eff307)(this)
        };
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry.
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = (0, $137112c5577a2db1$export$4950aa0f605343fb)(this._sdkProcessingMetadata, newData, 2);
        return this;
    }
    /**
   * Add propagation context to the scope, used for distributed tracing
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * Get propagation context from the scope, used for distributed tracing
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @returns {string} The id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = hint?.event_id || (0, $b02a41fd7bbcc8b3$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $ba0a81389f3fecaf$export$af88d00dbe7f521).warn("No client configured on scope - will not capture exception!");
            return eventId;
        }
        const syntheticException = new Error("Sentry syntheticException");
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @returns {string} The id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = hint?.event_id || (0, $b02a41fd7bbcc8b3$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $ba0a81389f3fecaf$export$af88d00dbe7f521).warn("No client configured on scope - will not capture message!");
            return eventId;
        }
        const syntheticException = new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a Sentry event for this scope.
   *
   * @returns {string} The id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = hint?.event_id || (0, $b02a41fd7bbcc8b3$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $ba0a81389f3fecaf$export$af88d00dbe7f521).warn("No client configured on scope - will not capture event!");
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}


/** Get the default current scope. */ function $981f99b803c549e1$export$6f1b9191db9c4d5() {
    return (0, $a3a94f0659c1ae52$export$7e223ec222791509)("defaultCurrentScope", ()=>new (0, $49335ddafc3f2633$export$775b6bb06e53a214)());
}
/** Get the default isolation scope. */ function $981f99b803c549e1$export$de9862929b76bf57() {
    return (0, $a3a94f0659c1ae52$export$7e223ec222791509)("defaultIsolationScope", ()=>new (0, $49335ddafc3f2633$export$775b6bb06e53a214)());
}





/**
 * This is an object that holds a stack of scopes.
 */ class $b04d37e4b9a438dd$export$d36ec451f120cfba {
    constructor(scope, isolationScope){
        let assignedScope;
        if (!scope) assignedScope = new (0, $49335ddafc3f2633$export$775b6bb06e53a214)();
        else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) assignedIsolationScope = new (0, $49335ddafc3f2633$export$775b6bb06e53a214)();
        else assignedIsolationScope = isolationScope;
        // scope stack for domains or the process
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Fork a scope for the stack.
   */ withScope(callback) {
        const scope = this._pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            this._popScope();
            throw e;
        }
        if ((0, $74a491f11c036384$export$f5b060c2914b97c8)(maybePromiseResult)) // @ts-expect-error - isThenable returns the wrong type
        return maybePromiseResult.then((res)=>{
            this._popScope();
            return res;
        }, (e)=>{
            this._popScope();
            throw e;
        });
        this._popScope();
        return maybePromiseResult;
    }
    /**
   * Get the client of the stack.
   */ getClient() {
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   */ getScope() {
        return this.getStackTop().scope;
    }
    /**
   * Get the isolation scope for the stack.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * Push a scope to the stack.
   */ _pushScope() {
        // We want to clone the content of prev scope
        const scope = this.getScope().clone();
        this._stack.push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * Pop a scope from the stack.
   */ _popScope() {
        if (this._stack.length <= 1) return false;
        return !!this._stack.pop();
    }
}
/**
 * Get the global async context stack.
 * This will be removed during the v8 cycle and is only here to make migration easier.
 */ function $b04d37e4b9a438dd$var$getAsyncContextStack() {
    const registry = (0, $a3a94f0659c1ae52$export$19eade501500c6c1)();
    const sentry = (0, $a3a94f0659c1ae52$export$c8bfa33e4e8ae492)(registry);
    return sentry.stack = sentry.stack || new $b04d37e4b9a438dd$export$d36ec451f120cfba((0, $981f99b803c549e1$export$6f1b9191db9c4d5)(), (0, $981f99b803c549e1$export$de9862929b76bf57)());
}
function $b04d37e4b9a438dd$var$withScope(callback) {
    return $b04d37e4b9a438dd$var$getAsyncContextStack().withScope(callback);
}
function $b04d37e4b9a438dd$var$withSetScope(scope, callback) {
    const stack = $b04d37e4b9a438dd$var$getAsyncContextStack();
    return stack.withScope(()=>{
        stack.getStackTop().scope = scope;
        return callback(scope);
    });
}
function $b04d37e4b9a438dd$var$withIsolationScope(callback) {
    return $b04d37e4b9a438dd$var$getAsyncContextStack().withScope(()=>{
        return callback($b04d37e4b9a438dd$var$getAsyncContextStack().getIsolationScope());
    });
}
/**
 * Get the stack-based async context strategy.
 */ function $b04d37e4b9a438dd$export$329d4d4d54e42710() {
    return {
        withIsolationScope: $b04d37e4b9a438dd$var$withIsolationScope,
        withScope: $b04d37e4b9a438dd$var$withScope,
        withSetScope: $b04d37e4b9a438dd$var$withSetScope,
        withSetIsolationScope: (_isolationScope, callback)=>{
            return $b04d37e4b9a438dd$var$withIsolationScope(callback);
        },
        getCurrentScope: ()=>$b04d37e4b9a438dd$var$getAsyncContextStack().getScope(),
        getIsolationScope: ()=>$b04d37e4b9a438dd$var$getAsyncContextStack().getIsolationScope()
    };
}


/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $e4835075adcb570a$export$774ae0e6b6e444ca(strategy) {
    // Get main carrier (global for every environment)
    const registry = (0, $a3a94f0659c1ae52$export$19eade501500c6c1)();
    const sentry = (0, $a3a94f0659c1ae52$export$c8bfa33e4e8ae492)(registry);
    sentry.acs = strategy;
}
/**
 * Get the current async context strategy.
 * If none has been setup, the default will be used.
 */ function $e4835075adcb570a$export$f639b0c2752203be(carrier) {
    const sentry = (0, $a3a94f0659c1ae52$export$c8bfa33e4e8ae492)(carrier);
    if (sentry.acs) return sentry.acs;
    // Otherwise, use the default one (stack)
    return (0, $b04d37e4b9a438dd$export$329d4d4d54e42710)();
}





/**
 * Get the currently active scope.
 */ function $cd799dd3a43d7279$export$c7be4b0125a10cba() {
    const carrier = (0, $a3a94f0659c1ae52$export$19eade501500c6c1)();
    const acs = (0, $e4835075adcb570a$export$f639b0c2752203be)(carrier);
    return acs.getCurrentScope();
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current execution context.
 */ function $cd799dd3a43d7279$export$68f3af03034c9e90() {
    const carrier = (0, $a3a94f0659c1ae52$export$19eade501500c6c1)();
    const acs = (0, $e4835075adcb570a$export$f639b0c2752203be)(carrier);
    return acs.getIsolationScope();
}
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function $cd799dd3a43d7279$export$aa55d5ab8e05984f() {
    return (0, $a3a94f0659c1ae52$export$7e223ec222791509)("globalScope", ()=>new (0, $49335ddafc3f2633$export$775b6bb06e53a214)());
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function $cd799dd3a43d7279$export$ec58d9285c204497(...rest) {
    const carrier = (0, $a3a94f0659c1ae52$export$19eade501500c6c1)();
    const acs = (0, $e4835075adcb570a$export$f639b0c2752203be)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) return acs.withScope(callback);
        return acs.withSetScope(scope, callback);
    }
    return acs.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 */ /**
 * Either creates a new active isolation scope, or sets the given isolation scope as active scope in the given callback.
 */ function $cd799dd3a43d7279$export$9a4fed82c350c2bd(...rest) {
    const carrier = (0, $a3a94f0659c1ae52$export$19eade501500c6c1)();
    const acs = (0, $e4835075adcb570a$export$f639b0c2752203be)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [isolationScope, callback] = rest;
        if (!isolationScope) return acs.withIsolationScope(callback);
        return acs.withSetIsolationScope(isolationScope, callback);
    }
    return acs.withIsolationScope(rest[0]);
}
/**
 * Get the currently active client.
 */ function $cd799dd3a43d7279$export$6bb76d6eba7e258c() {
    return $cd799dd3a43d7279$export$c7be4b0125a10cba().getClient();
}
/**
 * Get a trace context for the given scope.
 */ function $cd799dd3a43d7279$export$1e83db7ee4876dc4(scope) {
    const propagationContext = scope.getPropagationContext();
    const { traceId: traceId, parentSpanId: parentSpanId, propagationSpanId: propagationSpanId } = propagationContext;
    const traceContext = {
        trace_id: traceId,
        span_id: propagationSpanId || (0, $5f84b47bcde86f06$export$295213bc4d0c54ad)()
    };
    if (parentSpanId) traceContext.parent_span_id = parentSpanId;
    return traceContext;
}




const $4f154973204f7721$export$b14a8888f80a0b3e = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preserve the order of integrations in the array.
 *
 * @private
 */ function $4f154973204f7721$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.values(integrationsByName);
}
/** Gets integrations to install */ function $4f154973204f7721$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === "function") {
        const resolvedUserIntegrations = userIntegrations(defaultIntegrations);
        integrations = Array.isArray(resolvedUserIntegrations) ? resolvedUserIntegrations : [
            resolvedUserIntegrations
        ];
    } else integrations = defaultIntegrations;
    return $4f154973204f7721$var$filterDuplicates(integrations);
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function $4f154973204f7721$export$51abed9797baa598(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        // guard against empty provided integrations
        if (integration) $4f154973204f7721$export$e7390a03b70a6f2f(client, integration, integrationIndex);
    });
    return integrationIndex;
}
/**
 * Execute the `afterAllSetup` hooks of the given integrations.
 */ function $4f154973204f7721$export$35abcfd71227c6ca(client, integrations) {
    for (const integration of integrations)// guard against empty provided integrations
    if (integration?.afterAllSetup) integration.afterAllSetup(client);
}
/** Setup a single integration.  */ function $4f154973204f7721$export$e7390a03b70a6f2f(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        (0, $0ff2b032dfd8dfc4$export$16a28057038b10ef) && (0, $ba0a81389f3fecaf$export$af88d00dbe7f521).log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    // `setupOnce` is only called the first time
    if ($4f154973204f7721$export$b14a8888f80a0b3e.indexOf(integration.name) === -1 && typeof integration.setupOnce === "function") {
        integration.setupOnce();
        $4f154973204f7721$export$b14a8888f80a0b3e.push(integration.name);
    }
    // `setup` is run for each client
    if (integration.setup && typeof integration.setup === "function") integration.setup(client);
    if (typeof integration.preprocessEvent === "function") {
        const callback = integration.preprocessEvent.bind(integration);
        client.on("preprocessEvent", (event, hint)=>callback(event, hint, client));
    }
    if (typeof integration.processEvent === "function") {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    (0, $0ff2b032dfd8dfc4$export$16a28057038b10ef) && (0, $ba0a81389f3fecaf$export$af88d00dbe7f521).log(`Integration installed: ${integration.name}`);
}
/** Add an integration to the current scope's client. */ function $4f154973204f7721$export$2d8f5188773bcddd(integration) {
    const client = (0, $cd799dd3a43d7279$export$6bb76d6eba7e258c)();
    if (!client) {
        (0, $0ff2b032dfd8dfc4$export$16a28057038b10ef) && (0, $ba0a81389f3fecaf$export$af88d00dbe7f521).warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
/**
 * Define an integration function that can be used to create an integration instance.
 * Note that this by design hides the implementation details of the integration, as they are considered internal.
 */ function $4f154973204f7721$export$2323046b9414659f(fn) {
    return fn;
}


var $66dbdc40622762c6$var$__defProp$1 = Object.defineProperty;
var $66dbdc40622762c6$var$__defNormalProp$1 = (obj, key, value)=>key in obj ? $66dbdc40622762c6$var$__defProp$1(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $66dbdc40622762c6$var$__publicField$1 = (obj, key, value)=>$66dbdc40622762c6$var$__defNormalProp$1(obj, typeof key !== "symbol" ? key + "" : key, value);
class $66dbdc40622762c6$var$Mirror {
    constructor(){
        $66dbdc40622762c6$var$__publicField$1(this, "idNodeMap", /* @__PURE__ */ new Map());
        $66dbdc40622762c6$var$__publicField$1(this, "nodeMetaMap", /* @__PURE__ */ new WeakMap());
    }
    getId(n2) {
        if (!n2) return -1;
        const id = this.getMeta(n2)?.id;
        return id ?? -1;
    }
    getNode(id) {
        return this.idNodeMap.get(id) || null;
    }
    getIds() {
        return Array.from(this.idNodeMap.keys());
    }
    getMeta(n2) {
        return this.nodeMetaMap.get(n2) || null;
    }
    // removes the node from idNodeMap
    // doesn't remove the node from nodeMetaMap
    removeNodeFromMap(n2) {
        const id = this.getId(n2);
        this.idNodeMap.delete(id);
        if (n2.childNodes) n2.childNodes.forEach((childNode)=>this.removeNodeFromMap(childNode));
    }
    has(id) {
        return this.idNodeMap.has(id);
    }
    hasNode(node) {
        return this.nodeMetaMap.has(node);
    }
    add(n2, meta) {
        const id = meta.id;
        this.idNodeMap.set(id, n2);
        this.nodeMetaMap.set(n2, meta);
    }
    replace(id, n2) {
        const oldNode = this.getNode(id);
        if (oldNode) {
            const meta = this.nodeMetaMap.get(oldNode);
            if (meta) this.nodeMetaMap.set(n2, meta);
        }
        this.idNodeMap.set(id, n2);
    }
    reset() {
        this.idNodeMap = /* @__PURE__ */ new Map();
        this.nodeMetaMap = /* @__PURE__ */ new WeakMap();
    }
}
function $66dbdc40622762c6$var$createMirror$2() {
    return new $66dbdc40622762c6$var$Mirror();
}
function $66dbdc40622762c6$var$elementClassMatchesRegex(el, regex) {
    for(let eIndex = el.classList.length; eIndex--;){
        const className = el.classList[eIndex];
        if (regex.test(className)) return true;
    }
    return false;
}
function $66dbdc40622762c6$var$distanceToMatch(node, matchPredicate, limit = Infinity, distance = 0) {
    if (!node) return -1;
    if (node.nodeType !== node.ELEMENT_NODE) return -1;
    if (distance > limit) return -1;
    if (matchPredicate(node)) return distance;
    return $66dbdc40622762c6$var$distanceToMatch(node.parentNode, matchPredicate, limit, distance + 1);
}
function $66dbdc40622762c6$var$createMatchPredicate(className, selector) {
    return (node)=>{
        const el = node;
        if (el === null) return false;
        try {
            if (className) {
                if (typeof className === "string") {
                    if (el.matches(`.${className}`)) return true;
                } else if ($66dbdc40622762c6$var$elementClassMatchesRegex(el, className)) return true;
            }
            if (selector && el.matches(selector)) return true;
            return false;
        } catch  {
            return false;
        }
    };
}
const $66dbdc40622762c6$var$DEPARTED_MIRROR_ACCESS_WARNING = "Please stop import mirror directly. Instead of that,\r\nnow you can use replayer.getMirror() to access the mirror instance of a replayer,\r\nor you can use record.mirror to access the mirror instance during recording.";
let $66dbdc40622762c6$var$_mirror = {
    map: {},
    getId () {
        console.error($66dbdc40622762c6$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return -1;
    },
    getNode () {
        console.error($66dbdc40622762c6$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return null;
    },
    removeNodeFromMap () {
        console.error($66dbdc40622762c6$var$DEPARTED_MIRROR_ACCESS_WARNING);
    },
    has () {
        console.error($66dbdc40622762c6$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return false;
    },
    reset () {
        console.error($66dbdc40622762c6$var$DEPARTED_MIRROR_ACCESS_WARNING);
    }
};
if (typeof window !== "undefined" && window.Proxy && window.Reflect) $66dbdc40622762c6$var$_mirror = new Proxy($66dbdc40622762c6$var$_mirror, {
    get (target, prop, receiver) {
        if (prop === "map") console.error($66dbdc40622762c6$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return Reflect.get(target, prop, receiver);
    }
});
function $66dbdc40622762c6$var$hookSetter(target, key, d, isRevoked, win = window) {
    const original = win.Object.getOwnPropertyDescriptor(target, key);
    win.Object.defineProperty(target, key, isRevoked ? d : {
        set (value) {
            $66dbdc40622762c6$var$setTimeout$1(()=>{
                d.set.call(this, value);
            }, 0);
            if (original && original.set) original.set.call(this, value);
        }
    });
    return ()=>$66dbdc40622762c6$var$hookSetter(target, key, original || {}, true);
}
function $66dbdc40622762c6$var$patch(source, name, replacement) {
    try {
        if (!(name in source)) return ()=>{};
        const original = source[name];
        const wrapped = replacement(original);
        if (typeof wrapped === "function") {
            wrapped.prototype = wrapped.prototype || {};
            Object.defineProperties(wrapped, {
                __rrweb_original__: {
                    enumerable: false,
                    value: original
                }
            });
        }
        source[name] = wrapped;
        return ()=>{
            source[name] = original;
        };
    } catch  {
        return ()=>{};
    }
}
/* @__PURE__ */ /[1-9][0-9]{12}/.test(Date.now().toString());
function $66dbdc40622762c6$var$closestElementOfNode(node) {
    if (!node) return null;
    try {
        const el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
        return el;
    } catch (error) {
        return null;
    }
}
function $66dbdc40622762c6$var$isBlocked(node, blockClass, blockSelector, unblockSelector, checkAncestors) {
    if (!node) return false;
    const el = $66dbdc40622762c6$var$closestElementOfNode(node);
    if (!el) return false;
    const blockedPredicate = $66dbdc40622762c6$var$createMatchPredicate(blockClass, blockSelector);
    if (!checkAncestors) {
        const isUnblocked = unblockSelector && el.matches(unblockSelector);
        return blockedPredicate(el) && !isUnblocked;
    }
    const blockDistance = $66dbdc40622762c6$var$distanceToMatch(el, blockedPredicate);
    let unblockDistance = -1;
    if (blockDistance < 0) return false;
    if (unblockSelector) unblockDistance = $66dbdc40622762c6$var$distanceToMatch(el, $66dbdc40622762c6$var$createMatchPredicate(null, unblockSelector));
    if (blockDistance > -1 && unblockDistance < 0) return true;
    return blockDistance < unblockDistance;
}
const $66dbdc40622762c6$var$cachedImplementations = {};
function $66dbdc40622762c6$var$getImplementation(name) {
    const cached = $66dbdc40622762c6$var$cachedImplementations[name];
    if (cached) return cached;
    const document2 = window.document;
    let impl = window[name];
    if (document2 && typeof document2.createElement === "function") try {
        const sandbox = document2.createElement("iframe");
        sandbox.hidden = true;
        document2.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow[name]) impl = contentWindow[name];
        document2.head.removeChild(sandbox);
    } catch (e2) {}
    return $66dbdc40622762c6$var$cachedImplementations[name] = impl.bind(window);
}
function $66dbdc40622762c6$var$onRequestAnimationFrame(...rest) {
    return $66dbdc40622762c6$var$getImplementation("requestAnimationFrame")(...rest);
}
function $66dbdc40622762c6$var$setTimeout$1(...rest) {
    return $66dbdc40622762c6$var$getImplementation("setTimeout")(...rest);
}
var $66dbdc40622762c6$var$CanvasContext = /* @__PURE__ */ ((CanvasContext2)=>{
    CanvasContext2[CanvasContext2["2D"] = 0] = "2D";
    CanvasContext2[CanvasContext2["WebGL"] = 1] = "WebGL";
    CanvasContext2[CanvasContext2["WebGL2"] = 2] = "WebGL2";
    return CanvasContext2;
})($66dbdc40622762c6$var$CanvasContext || {});
let $66dbdc40622762c6$var$errorHandler;
function $66dbdc40622762c6$var$registerErrorHandler(handler) {
    $66dbdc40622762c6$var$errorHandler = handler;
}
const $66dbdc40622762c6$var$callbackWrapper = (cb)=>{
    if (!$66dbdc40622762c6$var$errorHandler) return cb;
    const rrwebWrapped = (...rest)=>{
        try {
            return cb(...rest);
        } catch (error) {
            if ($66dbdc40622762c6$var$errorHandler && $66dbdc40622762c6$var$errorHandler(error) === true) return ()=>{};
            throw error;
        }
    };
    return rrwebWrapped;
};
var $66dbdc40622762c6$var$chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
var $66dbdc40622762c6$var$lookup = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
for(var $66dbdc40622762c6$var$i$1 = 0; $66dbdc40622762c6$var$i$1 < $66dbdc40622762c6$var$chars.length; $66dbdc40622762c6$var$i$1++)$66dbdc40622762c6$var$lookup[$66dbdc40622762c6$var$chars.charCodeAt($66dbdc40622762c6$var$i$1)] = $66dbdc40622762c6$var$i$1;
var $66dbdc40622762c6$var$encode = function(arraybuffer) {
    var bytes = new Uint8Array(arraybuffer), i2, len = bytes.length, base64 = "";
    for(i2 = 0; i2 < len; i2 += 3){
        base64 += $66dbdc40622762c6$var$chars[bytes[i2] >> 2];
        base64 += $66dbdc40622762c6$var$chars[(bytes[i2] & 3) << 4 | bytes[i2 + 1] >> 4];
        base64 += $66dbdc40622762c6$var$chars[(bytes[i2 + 1] & 15) << 2 | bytes[i2 + 2] >> 6];
        base64 += $66dbdc40622762c6$var$chars[bytes[i2 + 2] & 63];
    }
    if (len % 3 === 2) base64 = base64.substring(0, base64.length - 1) + "=";
    else if (len % 3 === 1) base64 = base64.substring(0, base64.length - 2) + "==";
    return base64;
};
const $66dbdc40622762c6$var$canvasVarMap = /* @__PURE__ */ new Map();
function $66dbdc40622762c6$var$variableListFor$1(ctx, ctor) {
    let contextMap = $66dbdc40622762c6$var$canvasVarMap.get(ctx);
    if (!contextMap) {
        contextMap = /* @__PURE__ */ new Map();
        $66dbdc40622762c6$var$canvasVarMap.set(ctx, contextMap);
    }
    if (!contextMap.has(ctor)) contextMap.set(ctor, []);
    return contextMap.get(ctor);
}
const $66dbdc40622762c6$var$saveWebGLVar = (value, win, ctx)=>{
    if (!value || !($66dbdc40622762c6$var$isInstanceOfWebGLObject(value, win) || typeof value === "object")) return;
    const name = value.constructor.name;
    const list = $66dbdc40622762c6$var$variableListFor$1(ctx, name);
    let index = list.indexOf(value);
    if (index === -1) {
        index = list.length;
        list.push(value);
    }
    return index;
};
function $66dbdc40622762c6$var$serializeArg(value, win, ctx) {
    if (value instanceof Array) return value.map((arg)=>$66dbdc40622762c6$var$serializeArg(arg, win, ctx));
    else if (value === null) return value;
    else if (value instanceof Float32Array || value instanceof Float64Array || value instanceof Int32Array || value instanceof Uint32Array || value instanceof Uint8Array || value instanceof Uint16Array || value instanceof Int16Array || value instanceof Int8Array || value instanceof Uint8ClampedArray) {
        const name = value.constructor.name;
        return {
            rr_type: name,
            args: [
                Object.values(value)
            ]
        };
    } else if (// SharedArrayBuffer disabled on most browsers due to spectre.
    // More info: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/SharedArrayBuffer/SharedArrayBuffer
    // value instanceof SharedArrayBuffer ||
    value instanceof ArrayBuffer) {
        const name = value.constructor.name;
        const base64 = $66dbdc40622762c6$var$encode(value);
        return {
            rr_type: name,
            base64: base64
        };
    } else if (value instanceof DataView) {
        const name = value.constructor.name;
        return {
            rr_type: name,
            args: [
                $66dbdc40622762c6$var$serializeArg(value.buffer, win, ctx),
                value.byteOffset,
                value.byteLength
            ]
        };
    } else if (value instanceof HTMLImageElement) {
        const name = value.constructor.name;
        const { src: src } = value;
        return {
            rr_type: name,
            src: src
        };
    } else if (value instanceof HTMLCanvasElement) {
        const name = "HTMLImageElement";
        const src = value.toDataURL();
        return {
            rr_type: name,
            src: src
        };
    } else if (value instanceof ImageData) {
        const name = value.constructor.name;
        return {
            rr_type: name,
            args: [
                $66dbdc40622762c6$var$serializeArg(value.data, win, ctx),
                value.width,
                value.height
            ]
        };
    } else if ($66dbdc40622762c6$var$isInstanceOfWebGLObject(value, win) || typeof value === "object") {
        const name = value.constructor.name;
        const index = $66dbdc40622762c6$var$saveWebGLVar(value, win, ctx);
        return {
            rr_type: name,
            index: index
        };
    }
    return value;
}
const $66dbdc40622762c6$var$serializeArgs = (args, win, ctx)=>{
    return args.map((arg)=>$66dbdc40622762c6$var$serializeArg(arg, win, ctx));
};
const $66dbdc40622762c6$var$isInstanceOfWebGLObject = (value, win)=>{
    const webGLConstructorNames = [
        "WebGLActiveInfo",
        "WebGLBuffer",
        "WebGLFramebuffer",
        "WebGLProgram",
        "WebGLRenderbuffer",
        "WebGLShader",
        "WebGLShaderPrecisionFormat",
        "WebGLTexture",
        "WebGLUniformLocation",
        "WebGLVertexArrayObject",
        // In old Chrome versions, value won't be an instanceof WebGLVertexArrayObject.
        "WebGLVertexArrayObjectOES"
    ];
    const supportedWebGLConstructorNames = webGLConstructorNames.filter((name)=>typeof win[name] === "function");
    return Boolean(supportedWebGLConstructorNames.find((name)=>value instanceof win[name]));
};
function $66dbdc40622762c6$var$initCanvas2DMutationObserver(cb, win, blockClass2, blockSelector, unblockSelector) {
    const handlers = [];
    const props2D = Object.getOwnPropertyNames(win.CanvasRenderingContext2D.prototype);
    for (const prop of props2D)try {
        if (typeof win.CanvasRenderingContext2D.prototype[prop] !== "function") continue;
        const restoreHandler = $66dbdc40622762c6$var$patch(win.CanvasRenderingContext2D.prototype, prop, function(original) {
            return function(...args) {
                if (!$66dbdc40622762c6$var$isBlocked(this.canvas, blockClass2, blockSelector, unblockSelector, true)) $66dbdc40622762c6$var$setTimeout$1(()=>{
                    const recordArgs = $66dbdc40622762c6$var$serializeArgs(args, win, this);
                    cb(this.canvas, {
                        type: $66dbdc40622762c6$var$CanvasContext["2D"],
                        property: prop,
                        args: recordArgs
                    });
                }, 0);
                return original.apply(this, args);
            };
        });
        handlers.push(restoreHandler);
    } catch  {
        const hookHandler = $66dbdc40622762c6$var$hookSetter(win.CanvasRenderingContext2D.prototype, prop, {
            set (v2) {
                cb(this.canvas, {
                    type: $66dbdc40622762c6$var$CanvasContext["2D"],
                    property: prop,
                    args: [
                        v2
                    ],
                    setter: true
                });
            }
        });
        handlers.push(hookHandler);
    }
    return ()=>{
        handlers.forEach((h)=>h());
    };
}
function $66dbdc40622762c6$var$getNormalizedContextName(contextType) {
    return contextType === "experimental-webgl" ? "webgl" : contextType;
}
function $66dbdc40622762c6$var$initCanvasContextObserver(win, blockClass, blockSelector, unblockSelector, setPreserveDrawingBufferToTrue) {
    const handlers = [];
    try {
        const restoreHandler = $66dbdc40622762c6$var$patch(win.HTMLCanvasElement.prototype, "getContext", function(original) {
            return function(contextType, ...args) {
                if (!$66dbdc40622762c6$var$isBlocked(this, blockClass, blockSelector, unblockSelector, true)) {
                    const ctxName = $66dbdc40622762c6$var$getNormalizedContextName(contextType);
                    if (!("__context" in this)) this.__context = ctxName;
                    if (setPreserveDrawingBufferToTrue && [
                        "webgl",
                        "webgl2"
                    ].includes(ctxName)) {
                        if (args[0] && typeof args[0] === "object") {
                            const contextAttributes = args[0];
                            if (!contextAttributes.preserveDrawingBuffer) contextAttributes.preserveDrawingBuffer = true;
                        } else args.splice(0, 1, {
                            preserveDrawingBuffer: true
                        });
                    }
                }
                return original.apply(this, [
                    contextType,
                    ...args
                ]);
            };
        });
        handlers.push(restoreHandler);
    } catch  {
        console.error("failed to patch HTMLCanvasElement.prototype.getContext");
    }
    return ()=>{
        handlers.forEach((h)=>h());
    };
}
function $66dbdc40622762c6$var$patchGLPrototype(prototype, type, cb, blockClass2, blockSelector, unblockSelector, _mirror2, win) {
    const handlers = [];
    const props = Object.getOwnPropertyNames(prototype);
    for (const prop of props){
        if (//prop.startsWith('get') ||  // e.g. getProgramParameter, but too risky
        [
            "isContextLost",
            "canvas",
            "drawingBufferWidth",
            "drawingBufferHeight"
        ].includes(prop)) continue;
        try {
            if (typeof prototype[prop] !== "function") continue;
            const restoreHandler = $66dbdc40622762c6$var$patch(prototype, prop, function(original) {
                return function(...args) {
                    const result = original.apply(this, args);
                    $66dbdc40622762c6$var$saveWebGLVar(result, win, this);
                    if ("tagName" in this.canvas && !$66dbdc40622762c6$var$isBlocked(this.canvas, blockClass2, blockSelector, unblockSelector, true)) {
                        const recordArgs = $66dbdc40622762c6$var$serializeArgs(args, win, this);
                        const mutation = {
                            type: type,
                            property: prop,
                            args: recordArgs
                        };
                        cb(this.canvas, mutation);
                    }
                    return result;
                };
            });
            handlers.push(restoreHandler);
        } catch  {
            const hookHandler = $66dbdc40622762c6$var$hookSetter(prototype, prop, {
                set (v2) {
                    cb(this.canvas, {
                        type: type,
                        property: prop,
                        args: [
                            v2
                        ],
                        setter: true
                    });
                }
            });
            handlers.push(hookHandler);
        }
    }
    return handlers;
}
function $66dbdc40622762c6$var$initCanvasWebGLMutationObserver(cb, win, blockClass2, blockSelector, unblockSelector, mirror2) {
    const handlers = [];
    handlers.push(...$66dbdc40622762c6$var$patchGLPrototype(win.WebGLRenderingContext.prototype, $66dbdc40622762c6$var$CanvasContext.WebGL, cb, blockClass2, blockSelector, unblockSelector, mirror2, win));
    if (typeof win.WebGL2RenderingContext !== "undefined") handlers.push(...$66dbdc40622762c6$var$patchGLPrototype(win.WebGL2RenderingContext.prototype, $66dbdc40622762c6$var$CanvasContext.WebGL2, cb, blockClass2, blockSelector, unblockSelector, mirror2, win));
    return ()=>{
        handlers.forEach((h)=>h());
    };
}
const $66dbdc40622762c6$var$r$1 = `for(var e="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",t="undefined"==typeof Uint8Array?[]:new Uint8Array(256),a=0;a<64;a++)t[e.charCodeAt(a)]=a;var n=function(t){var a,n=new Uint8Array(t),r=n.length,s="";for(a=0;a<r;a+=3)s+=e[n[a]>>2],s+=e[(3&n[a])<<4|n[a+1]>>4],s+=e[(15&n[a+1])<<2|n[a+2]>>6],s+=e[63&n[a+2]];return r%3==2?s=s.substring(0,s.length-1)+"=":r%3==1&&(s=s.substring(0,s.length-2)+"=="),s};const r=new Map,s=new Map;const i=self;i.onmessage=async function(e){if(!("OffscreenCanvas"in globalThis))return i.postMessage({id:e.data.id});{const{id:t,bitmap:a,width:o,height:f,maxCanvasSize:c,dataURLOptions:g}=e.data,u=async function(e,t,a){const r=e+"-"+t;if("OffscreenCanvas"in globalThis){if(s.has(r))return s.get(r);const i=new OffscreenCanvas(e,t);i.getContext("2d");const o=await i.convertToBlob(a),f=await o.arrayBuffer(),c=n(f);return s.set(r,c),c}return""}(o,f,g),[h,d]=function(e,t,a){if(!a)return[e,t];const[n,r]=a;if(e<=n&&t<=r)return[e,t];let s=e,i=t;return s>n&&(i=Math.floor(n*t/e),s=n),i>r&&(s=Math.floor(r*e/t),i=r),[s,i]}(o,f,c),l=new OffscreenCanvas(h,d),w=l.getContext("bitmaprenderer"),p=h===o&&d===f?a:await createImageBitmap(a,{resizeWidth:h,resizeHeight:d,resizeQuality:"low"});w.transferFromImageBitmap(p),a.close();const y=await l.convertToBlob(g),v=y.type,b=await y.arrayBuffer(),m=n(b);if(p.close(),!r.has(t)&&await u===m)return r.set(t,m),i.postMessage({id:t});if(r.get(t)===m)return i.postMessage({id:t});i.postMessage({id:t,type:v,base64:m,width:o,height:f}),r.set(t,m)}};`;
function $66dbdc40622762c6$var$t$1() {
    const t2 = new Blob([
        $66dbdc40622762c6$var$r$1
    ]);
    return URL.createObjectURL(t2);
}
class $66dbdc40622762c6$var$CanvasManager {
    constructor(options){
        this.pendingCanvasMutations = /* @__PURE__ */ new Map();
        this.rafStamps = {
            latestId: 0,
            invokeId: null
        };
        this.shadowDoms = /* @__PURE__ */ new Set();
        this.windowsSet = /* @__PURE__ */ new WeakSet();
        this.windows = [];
        this.restoreHandlers = [];
        this.frozen = false;
        this.locked = false;
        this.snapshotInProgressMap = /* @__PURE__ */ new Map();
        this.worker = null;
        this.lastSnapshotTime = 0;
        this.processMutation = (target, mutation)=>{
            const newFrame = this.rafStamps.invokeId && this.rafStamps.latestId !== this.rafStamps.invokeId;
            if (newFrame || !this.rafStamps.invokeId) this.rafStamps.invokeId = this.rafStamps.latestId;
            if (!this.pendingCanvasMutations.has(target)) this.pendingCanvasMutations.set(target, []);
            this.pendingCanvasMutations.get(target).push(mutation);
        };
        const { sampling: sampling = "all", win: win, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, maxCanvasSize: maxCanvasSize, recordCanvas: recordCanvas, dataURLOptions: dataURLOptions, errorHandler: errorHandler2 } = options;
        this.mutationCb = options.mutationCb;
        this.mirror = options.mirror;
        this.options = options;
        if (errorHandler2) $66dbdc40622762c6$var$registerErrorHandler(errorHandler2);
        if (recordCanvas && typeof sampling === "number" || options.enableManualSnapshot) this.worker = this.initFPSWorker();
        this.addWindow(win);
        if (options.enableManualSnapshot) return;
        $66dbdc40622762c6$var$callbackWrapper(()=>{
            if (recordCanvas && sampling === "all") {
                this.startRAFTimestamping();
                this.startPendingCanvasMutationFlusher();
            }
            if (recordCanvas && typeof sampling === "number") this.initCanvasFPSObserver(sampling, blockClass, blockSelector, unblockSelector, maxCanvasSize, {
                dataURLOptions: dataURLOptions
            });
        })();
    }
    reset() {
        this.pendingCanvasMutations.clear();
        this.restoreHandlers.forEach((handler)=>{
            try {
                handler();
            } catch (e2) {}
        });
        this.restoreHandlers = [];
        this.windowsSet = /* @__PURE__ */ new WeakSet();
        this.windows = [];
        this.shadowDoms = /* @__PURE__ */ new Set();
        this.worker?.terminate();
        this.worker = null;
        this.snapshotInProgressMap = /* @__PURE__ */ new Map();
    }
    freeze() {
        this.frozen = true;
    }
    unfreeze() {
        this.frozen = false;
    }
    lock() {
        this.locked = true;
    }
    unlock() {
        this.locked = false;
    }
    addWindow(win) {
        const { sampling: sampling = "all", blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, recordCanvas: recordCanvas, enableManualSnapshot: enableManualSnapshot } = this.options;
        if (this.windowsSet.has(win)) return;
        if (enableManualSnapshot) {
            this.windowsSet.add(win);
            this.windows.push(new WeakRef(win));
            return;
        }
        $66dbdc40622762c6$var$callbackWrapper(()=>{
            if (recordCanvas && sampling === "all") this.initCanvasMutationObserver(win, blockClass, blockSelector, unblockSelector);
            if (recordCanvas && typeof sampling === "number") {
                const canvasContextReset = $66dbdc40622762c6$var$initCanvasContextObserver(win, blockClass, blockSelector, unblockSelector, true);
                this.restoreHandlers.push(()=>{
                    canvasContextReset();
                });
            }
        })();
        this.windowsSet.add(win);
        this.windows.push(new WeakRef(win));
    }
    addShadowRoot(shadowRoot) {
        this.shadowDoms.add(new WeakRef(shadowRoot));
    }
    resetShadowRoots() {
        this.shadowDoms = /* @__PURE__ */ new Set();
    }
    initFPSWorker() {
        const worker = new Worker($66dbdc40622762c6$var$t$1());
        worker.onmessage = (e2)=>{
            const data = e2.data;
            const { id: id } = data;
            this.snapshotInProgressMap.set(id, false);
            if (!("base64" in data)) return;
            const { base64: base64, type: type, width: width, height: height } = data;
            this.mutationCb({
                id: id,
                type: $66dbdc40622762c6$var$CanvasContext["2D"],
                commands: [
                    {
                        property: "clearRect",
                        // wipe canvas
                        args: [
                            0,
                            0,
                            width,
                            height
                        ]
                    },
                    {
                        property: "drawImage",
                        // draws (semi-transparent) image
                        args: [
                            {
                                rr_type: "ImageBitmap",
                                args: [
                                    {
                                        rr_type: "Blob",
                                        data: [
                                            {
                                                rr_type: "ArrayBuffer",
                                                base64: base64
                                            }
                                        ],
                                        type: type
                                    }
                                ]
                            },
                            0,
                            0,
                            // The below args are needed if we enforce a max size, we want to
                            // retain the original size when drawing the image (which should be smaller)
                            width,
                            height
                        ]
                    }
                ]
            });
        };
        return worker;
    }
    initCanvasFPSObserver(fps, blockClass, blockSelector, unblockSelector, maxCanvasSize, options) {
        const rafId = this.takeSnapshot(false, fps, blockClass, blockSelector, unblockSelector, maxCanvasSize, options.dataURLOptions);
        this.restoreHandlers.push(()=>{
            cancelAnimationFrame(rafId);
        });
    }
    initCanvasMutationObserver(win, blockClass, blockSelector, unblockSelector) {
        const canvasContextReset = $66dbdc40622762c6$var$initCanvasContextObserver(win, blockClass, blockSelector, unblockSelector, false);
        const canvas2DReset = $66dbdc40622762c6$var$initCanvas2DMutationObserver(this.processMutation.bind(this), win, blockClass, blockSelector, unblockSelector);
        const canvasWebGL1and2Reset = $66dbdc40622762c6$var$initCanvasWebGLMutationObserver(this.processMutation.bind(this), win, blockClass, blockSelector, unblockSelector, this.mirror);
        this.restoreHandlers.push(()=>{
            canvasContextReset();
            canvas2DReset();
            canvasWebGL1and2Reset();
        });
    }
    snapshot(canvasElement) {
        const { options: options } = this;
        const rafId = this.takeSnapshot(true, options.sampling === "all" ? 2 : options.sampling || 2, options.blockClass, options.blockSelector, options.unblockSelector, options.maxCanvasSize, options.dataURLOptions, canvasElement);
        this.restoreHandlers.push(()=>{
            cancelAnimationFrame(rafId);
        });
    }
    takeSnapshot(isManualSnapshot, fps, blockClass, blockSelector, unblockSelector, maxCanvasSize, dataURLOptions, canvasElement) {
        const timeBetweenSnapshots = 1e3 / fps;
        let rafId;
        const getCanvas = (canvasElement2)=>{
            if (canvasElement2) return [
                canvasElement2
            ];
            const matchedCanvas = [];
            const searchCanvas = (root)=>{
                root.querySelectorAll("canvas").forEach((canvas)=>{
                    if (!$66dbdc40622762c6$var$isBlocked(canvas, blockClass, blockSelector, unblockSelector, true)) matchedCanvas.push(canvas);
                });
            };
            for (const item of this.windows){
                const window2 = item.deref();
                let _document;
                try {
                    _document = window2 && window2.document;
                } catch  {}
                if (_document) searchCanvas(_document);
            }
            for (const item of this.shadowDoms){
                const shadowRoot = item.deref();
                if (shadowRoot) searchCanvas(shadowRoot);
            }
            return matchedCanvas;
        };
        const takeCanvasSnapshots = (timestamp)=>{
            if (!this.windows.length) return;
            if (this.lastSnapshotTime && timestamp - this.lastSnapshotTime < timeBetweenSnapshots) {
                rafId = $66dbdc40622762c6$var$onRequestAnimationFrame(takeCanvasSnapshots);
                return;
            }
            this.lastSnapshotTime = timestamp;
            getCanvas(canvasElement).forEach((canvas)=>{
                if (!this.mirror.hasNode(canvas)) return;
                const id = this.mirror.getId(canvas);
                if (this.snapshotInProgressMap.get(id)) return;
                if (!canvas.width || !canvas.height) return;
                this.snapshotInProgressMap.set(id, true);
                if (!isManualSnapshot && [
                    "webgl",
                    "webgl2"
                ].includes(canvas.__context)) {
                    const context = canvas.getContext(canvas.__context);
                    if (context?.getContextAttributes()?.preserveDrawingBuffer === false) context.clear(context.COLOR_BUFFER_BIT);
                }
                createImageBitmap(canvas).then((bitmap)=>{
                    this.worker?.postMessage({
                        id: id,
                        bitmap: bitmap,
                        width: canvas.width,
                        height: canvas.height,
                        dataURLOptions: dataURLOptions,
                        maxCanvasSize: maxCanvasSize
                    }, [
                        bitmap
                    ]);
                }).catch((error)=>{
                    $66dbdc40622762c6$var$callbackWrapper(()=>{
                        throw error;
                    })();
                });
            });
            if (!isManualSnapshot) rafId = $66dbdc40622762c6$var$onRequestAnimationFrame(takeCanvasSnapshots);
        };
        rafId = $66dbdc40622762c6$var$onRequestAnimationFrame(takeCanvasSnapshots);
        return rafId;
    }
    startPendingCanvasMutationFlusher() {
        $66dbdc40622762c6$var$onRequestAnimationFrame(()=>this.flushPendingCanvasMutations());
    }
    startRAFTimestamping() {
        const setLatestRAFTimestamp = (timestamp)=>{
            this.rafStamps.latestId = timestamp;
            $66dbdc40622762c6$var$onRequestAnimationFrame(setLatestRAFTimestamp);
        };
        $66dbdc40622762c6$var$onRequestAnimationFrame(setLatestRAFTimestamp);
    }
    flushPendingCanvasMutations() {
        this.pendingCanvasMutations.forEach((_values, canvas)=>{
            const id = this.mirror.getId(canvas);
            this.flushPendingCanvasMutationFor(canvas, id);
        });
        $66dbdc40622762c6$var$onRequestAnimationFrame(()=>this.flushPendingCanvasMutations());
    }
    flushPendingCanvasMutationFor(canvas, id) {
        if (this.frozen || this.locked) return;
        const valuesWithType = this.pendingCanvasMutations.get(canvas);
        if (!valuesWithType || id === -1) return;
        const values = valuesWithType.map((value)=>{
            const { type: type2, ...rest } = value;
            return rest;
        });
        const { type: type } = valuesWithType[0];
        this.mutationCb({
            id: id,
            type: type,
            commands: values
        });
        this.pendingCanvasMutations.delete(canvas);
    }
}
try {
    if (Array.from([
        1
    ], (x)=>x * 2)[0] !== 2) {
        const cleanFrame = document.createElement("iframe");
        document.body.appendChild(cleanFrame);
        Array.from = cleanFrame.contentWindow?.Array.from || Array.from;
        document.body.removeChild(cleanFrame);
    }
} catch (err) {
    console.debug("Unable to override Array.from", err);
}
$66dbdc40622762c6$var$createMirror$2();
var $66dbdc40622762c6$var$n;
!function(t2) {
    t2[t2.NotStarted = 0] = "NotStarted", t2[t2.Running = 1] = "Running", t2[t2.Stopped = 2] = "Stopped";
}($66dbdc40622762c6$var$n || ($66dbdc40622762c6$var$n = {}));
const $66dbdc40622762c6$var$CANVAS_QUALITY = {
    low: {
        sampling: {
            canvas: 1
        },
        dataURLOptions: {
            type: "image/webp",
            quality: 0.25
        }
    },
    medium: {
        sampling: {
            canvas: 2
        },
        dataURLOptions: {
            type: "image/webp",
            quality: 0.4
        }
    },
    high: {
        sampling: {
            canvas: 4
        },
        dataURLOptions: {
            type: "image/webp",
            quality: 0.5
        }
    }
};
const $66dbdc40622762c6$var$INTEGRATION_NAME = "ReplayCanvas";
const $66dbdc40622762c6$var$DEFAULT_MAX_CANVAS_SIZE = 1280;
/** Exported only for type safe tests. */ const $66dbdc40622762c6$var$_replayCanvasIntegration = (options = {})=>{
    const [maxCanvasWidth, maxCanvasHeight] = options.maxCanvasSize || [];
    const _canvasOptions = {
        quality: options.quality || "medium",
        enableManualSnapshot: options.enableManualSnapshot,
        maxCanvasSize: [
            maxCanvasWidth ? Math.min(maxCanvasWidth, $66dbdc40622762c6$var$DEFAULT_MAX_CANVAS_SIZE) : $66dbdc40622762c6$var$DEFAULT_MAX_CANVAS_SIZE,
            maxCanvasHeight ? Math.min(maxCanvasHeight, $66dbdc40622762c6$var$DEFAULT_MAX_CANVAS_SIZE) : $66dbdc40622762c6$var$DEFAULT_MAX_CANVAS_SIZE
        ]
    };
    let canvasManagerResolve;
    const _canvasManager = new Promise((resolve)=>canvasManagerResolve = resolve);
    return {
        name: $66dbdc40622762c6$var$INTEGRATION_NAME,
        getOptions () {
            const { quality: quality, enableManualSnapshot: enableManualSnapshot, maxCanvasSize: maxCanvasSize } = _canvasOptions;
            return {
                enableManualSnapshot: enableManualSnapshot,
                recordCanvas: true,
                getCanvasManager: (getCanvasManagerOptions)=>{
                    const manager = new $66dbdc40622762c6$var$CanvasManager({
                        ...getCanvasManagerOptions,
                        enableManualSnapshot: enableManualSnapshot,
                        maxCanvasSize: maxCanvasSize,
                        errorHandler: (err)=>{
                            try {
                                if (typeof err === "object") err.__rrweb__ = true;
                            } catch (error) {
                            // ignore errors here
                            // this can happen if the error is frozen or does not allow mutation for other reasons
                            }
                        }
                    });
                    canvasManagerResolve(manager);
                    return manager;
                },
                ...$66dbdc40622762c6$var$CANVAS_QUALITY[quality] || $66dbdc40622762c6$var$CANVAS_QUALITY.medium
            };
        },
        async snapshot (canvasElement) {
            const canvasManager = await _canvasManager;
            canvasManager.snapshot(canvasElement);
        }
    };
};
/**
 * Add this in addition to `replayIntegration()` to enable canvas recording.
 */ const $66dbdc40622762c6$export$71ba62165d5c834d = (0, $4f154973204f7721$export$2323046b9414659f)($66dbdc40622762c6$var$_replayCanvasIntegration);


















/**
 * Create and track fetch request spans for usage in combination with `addFetchInstrumentationHandler`.
 *
 * @returns Span if a span was created, otherwise void.
 */ function $db739e1bf2511265$export$6d73c62358c655be(handlerData, shouldCreateSpan, shouldAttachHeaders, spans, spanOrigin = "auto.http.browser") {
    if (!handlerData.fetchData) return undefined;
    const { method: method, url: url } = handlerData.fetchData;
    const shouldCreateSpanResult = (0, $715af054d7b34c54$export$1f70765132c3c225)() && shouldCreateSpan(url);
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        const spanId = handlerData.fetchData.__span;
        if (!spanId) return;
        const span = spans[spanId];
        if (span) {
            $db739e1bf2511265$var$endSpan(span, handlerData);
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    const hasParent = !!(0, $e89a3331adf677ac$export$1be426a8e585c83e)();
    const span = shouldCreateSpanResult && hasParent ? (0, $3bfe6b778935764d$export$63dbba021a6b4047)($db739e1bf2511265$var$getSpanStartOptions(url, method, spanOrigin)) : new (0, $08d90c1dc724b4e2$export$d6636b700b76c516)();
    handlerData.fetchData.__span = span.spanContext().spanId;
    spans[span.spanContext().spanId] = span;
    if (shouldAttachHeaders(handlerData.fetchData.url)) {
        const request = handlerData.args[0];
        const options = handlerData.args[1] || {};
        const headers = $db739e1bf2511265$export$eab8901e1b084464(request, options, // If performance is disabled (TWP) or there's no active root span (pageload/navigation/interaction),
        // we do not want to use the span as base for the trace headers,
        // which means that the headers will be generated from the scope and the sampling decision is deferred
        (0, $715af054d7b34c54$export$1f70765132c3c225)() && hasParent ? span : undefined);
        if (headers) {
            // Ensure this is actually set, if no options have been passed previously
            handlerData.args[1] = options;
            options.headers = headers;
        }
    }
    const client = (0, $0b98faa1b87c8168$export$6bb76d6eba7e258c)();
    if (client) {
        const fetchHint = {
            input: handlerData.args,
            response: handlerData.response,
            startTimestamp: handlerData.startTimestamp,
            endTimestamp: handlerData.endTimestamp
        };
        client.emit("beforeOutgoingRequestSpan", span, fetchHint);
    }
    return span;
}
/**
 * Adds sentry-trace and baggage headers to the various forms of fetch headers.
 * exported only for testing purposes
 *
 * When we determine if we should add a baggage header, there are 3 cases:
 * 1. No previous baggage header -> add baggage
 * 2. Previous baggage header has no sentry baggage values -> add our baggage
 * 3. Previous baggage header has sentry baggage values -> do nothing (might have been added manually by users)
 */ // eslint-disable-next-line complexity -- yup it's this complicated :(
function $db739e1bf2511265$export$eab8901e1b084464(request, fetchOptionsObj, span) {
    const traceHeaders = (0, $9602e691d7587103$export$dec8f001b9d982cb)({
        span: span
    });
    const sentryTrace = traceHeaders["sentry-trace"];
    const baggage = traceHeaders.baggage;
    // Nothing to do, when we return undefined here, the original headers will be used
    if (!sentryTrace) return undefined;
    const originalHeaders = fetchOptionsObj.headers || ((0, $ed5cb73b8752546d$export$6d3d1f317d7cda57)(request) ? request.headers : undefined);
    if (!originalHeaders) return {
        ...traceHeaders
    };
    else if ($db739e1bf2511265$var$isHeaders(originalHeaders)) {
        const newHeaders = new Headers(originalHeaders);
        // We don't want to override manually added sentry headers
        if (!newHeaders.get("sentry-trace")) newHeaders.set("sentry-trace", sentryTrace);
        if (baggage) {
            const prevBaggageHeader = newHeaders.get("baggage");
            if (!prevBaggageHeader) newHeaders.set("baggage", baggage);
            else if (!$db739e1bf2511265$var$baggageHeaderHasSentryBaggageValues(prevBaggageHeader)) newHeaders.set("baggage", `${prevBaggageHeader},${baggage}`);
        }
        return newHeaders;
    } else if (Array.isArray(originalHeaders)) {
        const newHeaders = [
            ...originalHeaders
        ];
        if (!originalHeaders.find((header)=>header[0] === "sentry-trace")) newHeaders.push([
            "sentry-trace",
            sentryTrace
        ]);
        const prevBaggageHeaderWithSentryValues = originalHeaders.find((header)=>header[0] === "baggage" && $db739e1bf2511265$var$baggageHeaderHasSentryBaggageValues(header[1]));
        if (baggage && !prevBaggageHeaderWithSentryValues) // If there are multiple entries with the same key, the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.push([
            "baggage",
            baggage
        ]);
        return newHeaders;
    } else {
        const existingSentryTraceHeader = "sentry-trace" in originalHeaders ? originalHeaders["sentry-trace"] : undefined;
        const existingBaggageHeader = "baggage" in originalHeaders ? originalHeaders.baggage : undefined;
        const newBaggageHeaders = existingBaggageHeader ? Array.isArray(existingBaggageHeader) ? [
            ...existingBaggageHeader
        ] : [
            existingBaggageHeader
        ] : [];
        const prevBaggageHeaderWithSentryValues = existingBaggageHeader && (Array.isArray(existingBaggageHeader) ? existingBaggageHeader.find((headerItem)=>$db739e1bf2511265$var$baggageHeaderHasSentryBaggageValues(headerItem)) : $db739e1bf2511265$var$baggageHeaderHasSentryBaggageValues(existingBaggageHeader));
        if (baggage && !prevBaggageHeaderWithSentryValues) newBaggageHeaders.push(baggage);
        return {
            ...originalHeaders,
            "sentry-trace": existingSentryTraceHeader ?? sentryTrace,
            baggage: newBaggageHeaders.length > 0 ? newBaggageHeaders.join(",") : undefined
        };
    }
}
function $db739e1bf2511265$var$endSpan(span, handlerData) {
    if (handlerData.response) {
        (0, $1c91772cf9c3fc39$export$2ad6630ec8164254)(span, handlerData.response.status);
        const contentLength = handlerData.response?.headers && handlerData.response.headers.get("content-length");
        if (contentLength) {
            const contentLengthNum = parseInt(contentLength);
            if (contentLengthNum > 0) span.setAttribute("http.response_content_length", contentLengthNum);
        }
    } else if (handlerData.error) span.setStatus({
        code: (0, $1c91772cf9c3fc39$export$f966a0446ece71e),
        message: "internal_error"
    });
    span.end();
}
function $db739e1bf2511265$var$baggageHeaderHasSentryBaggageValues(baggageHeader) {
    return baggageHeader.split(",").some((baggageEntry)=>baggageEntry.trim().startsWith((0, $fb4f2d687c5ee56d$export$6e69537d67fa20f)));
}
function $db739e1bf2511265$var$isHeaders(headers) {
    return typeof Headers !== "undefined" && (0, $ed5cb73b8752546d$export$49034edbe6b62415)(headers, Headers);
}
function $db739e1bf2511265$var$getSpanStartOptions(url, method, spanOrigin) {
    const parsedUrl = (0, $34321b3a3ce9dbbd$export$2004d912a9ead694)(url);
    return {
        name: parsedUrl ? `${method} ${(0, $34321b3a3ce9dbbd$export$5339fcdc8e2a427c)(parsedUrl)}` : method,
        attributes: $db739e1bf2511265$var$getFetchSpanAttributes(url, parsedUrl, method, spanOrigin)
    };
}
function $db739e1bf2511265$var$getFetchSpanAttributes(url, parsedUrl, method, spanOrigin) {
    const attributes = {
        url: url,
        type: "fetch",
        "http.method": method,
        [(0, $34e3132ced11beec$export$cca8dd30f57f805e)]: spanOrigin,
        [(0, $34e3132ced11beec$export$1a413bd9a88fdb09)]: "http.client"
    };
    if (parsedUrl) {
        if (!(0, $34321b3a3ce9dbbd$export$e258e13805402ba7)(parsedUrl)) {
            attributes["http.url"] = parsedUrl.href;
            attributes["server.address"] = parsedUrl.host;
        }
        if (parsedUrl.search) attributes["http.query"] = parsedUrl.search;
        if (parsedUrl.hash) attributes["http.fragment"] = parsedUrl.hash;
    }
    return attributes;
}






/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $fd72da8f54d6c057$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $b83fbc460ca20326$export$ee52dced521e3e18)();
    const session = {
        sid: (0, $a15fd97f4e1b6d43$export$19f53698e68b2496)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: "ok",
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$fd72da8f54d6c057$var$sessionToJSON(session)
    };
    if (context) $fd72da8f54d6c057$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see Client.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $fd72da8f54d6c057$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $b83fbc460ca20326$export$ee52dced521e3e18)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $a15fd97f4e1b6d43$export$19f53698e68b2496)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === "number") session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === "number") session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === "number") session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $fd72da8f54d6c057$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === "ok") context = {
        status: "exited"
    };
    $fd72da8f54d6c057$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $fd72da8f54d6c057$var$sessionToJSON(session) {
    return {
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === "number" || typeof session.did === "string" ? `${session.did}` : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    };
}




/**
 * Shallow merge two objects.
 * Does not mutate the passed in objects.
 * Undefined/empty values in the merge object will overwrite existing values.
 *
 * By default, this merges 2 levels deep.
 */ function $c440b9679f500884$export$4950aa0f605343fb(initialObj, mergeObj, levels = 2) {
    // If the merge value is not an object, or we have no merge levels left,
    // we just set the value to the merge value
    if (!mergeObj || typeof mergeObj !== "object" || levels <= 0) return mergeObj;
    // If the merge object is an empty object, and the initial object is not undefined, we return the initial object
    if (initialObj && Object.keys(mergeObj).length === 0) return initialObj;
    // Clone object
    const output = {
        ...initialObj
    };
    // Merge values into output, resursively
    for(const key in mergeObj)if (Object.prototype.hasOwnProperty.call(mergeObj, key)) output[key] = $c440b9679f500884$export$4950aa0f605343fb(output[key], mergeObj[key], levels - 1);
    return output;
}




/**
 * Generate a random, valid trace ID.
 */ function $2b9195e12fc435e7$export$dc6d7ea554bcce10() {
    return (0, $a15fd97f4e1b6d43$export$19f53698e68b2496)();
}
/**
 * Generate a random, valid span ID.
 */ function $2b9195e12fc435e7$export$295213bc4d0c54ad() {
    return (0, $a15fd97f4e1b6d43$export$19f53698e68b2496)().substring(16);
}



const $4b940a7f4edc293b$var$SCOPE_SPAN_FIELD = "_sentrySpan";
/**
 * Set the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $4b940a7f4edc293b$export$3f25fa50c18e20ca(scope, span) {
    if (span) (0, $69901043324a0df8$export$e73679ffaf56810e)(scope, $4b940a7f4edc293b$var$SCOPE_SPAN_FIELD, span);
    else // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
    delete scope[$4b940a7f4edc293b$var$SCOPE_SPAN_FIELD];
}
/**
 * Get the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $4b940a7f4edc293b$export$91f063ebb8eff307(scope) {
    return scope[$4b940a7f4edc293b$var$SCOPE_SPAN_FIELD];
}




/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $7057e3acb253866f$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * A context to be used for capturing an event.
 * This can either be a Scope, or a partial ScopeContext,
 * or a callback that receives the current scope and returns a new scope to use.
 */ /**
 * Holds additional event information.
 */ class $7057e3acb253866f$export$775b6bb06e53a214 {
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called during event processing. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Extra */ /** Contexts */ /** Attachments */ /** Propagation Context for distributed tracing */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */ /** Session */ /** The client on this scope */ /** Contains the last event id of a captured event.  */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = {
            traceId: (0, $2b9195e12fc435e7$export$dc6d7ea554bcce10)(),
            sampleRand: Math.random()
        };
    }
    /**
   * Clone all data from this scope into a new scope.
   */ clone() {
        const newScope = new $7057e3acb253866f$export$775b6bb06e53a214();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        if (this._contexts.flags) // We need to copy the `values` array so insertions on a cloned scope
        // won't affect the original array.
        newScope._contexts.flags = {
            values: [
                ...this._contexts.flags.values
            ]
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        newScope._lastEventId = this._lastEventId;
        (0, $4b940a7f4edc293b$export$3f25fa50c18e20ca)(newScope, (0, $4b940a7f4edc293b$export$91f063ebb8eff307)(this));
        return newScope;
    }
    /**
   * Update the client assigned to this scope.
   * Note that not every scope will have a client assigned - isolation scopes & the global scope will generally not have a client,
   * as well as manually created scopes.
   */ setClient(client) {
        this._client = client;
    }
    /**
   * Set the ID of the last captured error event.
   * This is generally only captured on the isolation scope.
   */ setLastEventId(lastEventId) {
        this._lastEventId = lastEventId;
    }
    /**
   * Get the client assigned to this scope.
   */ getClient() {
        return this._client;
    }
    /**
   * Get the ID of the last captured error event.
   * This is generally only available on the isolation scope.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * Add an event processor that will be called before an event is sent.
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * Set the user for this scope.
   * Set to `null` to unset the user.
   */ setUser(user) {
        // If null is passed we want to unset everything, but still define keys,
        // so that later down in the pipeline any existing values are cleared.
        this._user = user || {
            email: undefined,
            id: undefined,
            ip_address: undefined,
            username: undefined
        };
        if (this._session) (0, $fd72da8f54d6c057$export$531818e825e774db)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the user from this scope.
   */ getUser() {
        return this._user;
    }
    /**
   * Set an object that will be merged into existing tags on the scope,
   * and will be sent as tags data with the event.
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single tag that will be sent as tags data with the event.
   */ setTag(key, value) {
        this._tags = {
            ...this._tags,
            [key]: value
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set an object that will be merged into existing extra on the scope,
   * and will be sent as extra data with the event.
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single key:value extra entry that will be sent as extra data with the event.
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the fingerprint on the scope to send with the events.
   * @param {string[]} fingerprint Fingerprint to group events in Sentry.
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the level on the scope for future events.
   */ setLevel(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope so that the name of e.g. taken server route or
   * the page location is attached to future events.
   *
   * IMPORTANT: Calling this function does NOT change the name of the currently active
   * root span. If you want to change the name of the active root span, use
   * `Sentry.updateSpanName(rootSpan, 'new name')` instead.
   *
   * By default, the SDK updates the scope's transaction name automatically on sensible
   * occasions, such as a page navigation or when handling a new request on the server.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets context data with the given name.
   * Data passed as context will be normalized. You can also pass `null` to unset the context.
   * Note that context data will not be merged - calling `setContext` will overwrite an existing context with the same key.
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set the session for the scope.
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the session from the scope.
   */ getSession() {
        return this._session;
    }
    /**
   * Updates the scope with provided data. Can work in three variations:
   * - plain object containing updatable attributes
   * - Scope instance that'll extract the attributes from
   * - callback function that'll receive the current scope as an argument and allow for modifications
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === "function" ? captureContext(this) : captureContext;
        const scopeInstance = scopeToMerge instanceof $7057e3acb253866f$export$775b6bb06e53a214 ? scopeToMerge.getScopeData() : (0, $4541e6bae1c3cae8$export$53b83ca8eaab0383)(scopeToMerge) ? captureContext : undefined;
        const { tags: tags, extra: extra, user: user, contexts: contexts, level: level, fingerprint: fingerprint = [], propagationContext: propagationContext } = scopeInstance || {};
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._extra = {
            ...this._extra,
            ...extra
        };
        this._contexts = {
            ...this._contexts,
            ...contexts
        };
        if (user && Object.keys(user).length) this._user = user;
        if (level) this._level = level;
        if (fingerprint.length) this._fingerprint = fingerprint;
        if (propagationContext) this._propagationContext = propagationContext;
        return this;
    }
    /**
   * Clears the current scope and resets its properties.
   * Note: The client will not be cleared.
   */ clear() {
        // client is not cleared here on purpose!
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._session = undefined;
        (0, $4b940a7f4edc293b$export$3f25fa50c18e20ca)(this, undefined);
        this._attachments = [];
        this.setPropagationContext({
            traceId: (0, $2b9195e12fc435e7$export$dc6d7ea554bcce10)(),
            sampleRand: Math.random()
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Adds a breadcrumb to the scope.
   * By default, the last 100 breadcrumbs are kept.
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === "number" ? maxBreadcrumbs : $7057e3acb253866f$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $b83fbc460ca20326$export$7740643b9eeaf0c4)(),
            ...breadcrumb,
            // Breadcrumb messages can theoretically be infinitely large and they're held in memory so we truncate them not to leak (too much) memory
            message: breadcrumb.message ? (0, $ac71f3aed2307965$export$6a506b36fdea397d)(breadcrumb.message, 2048) : breadcrumb.message
        };
        this._breadcrumbs.push(mergedBreadcrumb);
        if (this._breadcrumbs.length > maxCrumbs) {
            this._breadcrumbs = this._breadcrumbs.slice(-maxCrumbs);
            this._client?.recordDroppedEvent("buffer_overflow", "log_item");
        }
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the last breadcrumb of the scope.
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * Clear all breadcrumbs from the scope.
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Add an attachment to the scope.
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * Clear all attachments from the scope.
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /**
   * Get the data of this scope, which should be applied to an event during processing.
   */ getScopeData() {
        return {
            breadcrumbs: this._breadcrumbs,
            attachments: this._attachments,
            contexts: this._contexts,
            tags: this._tags,
            extra: this._extra,
            user: this._user,
            level: this._level,
            fingerprint: this._fingerprint || [],
            eventProcessors: this._eventProcessors,
            propagationContext: this._propagationContext,
            sdkProcessingMetadata: this._sdkProcessingMetadata,
            transactionName: this._transactionName,
            span: (0, $4b940a7f4edc293b$export$91f063ebb8eff307)(this)
        };
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry.
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = (0, $c440b9679f500884$export$4950aa0f605343fb)(this._sdkProcessingMetadata, newData, 2);
        return this;
    }
    /**
   * Add propagation context to the scope, used for distributed tracing
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * Get propagation context from the scope, used for distributed tracing
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @returns {string} The id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = hint?.event_id || (0, $a15fd97f4e1b6d43$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $70cc7a497c940a25$export$af88d00dbe7f521).warn("No client configured on scope - will not capture exception!");
            return eventId;
        }
        const syntheticException = new Error("Sentry syntheticException");
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @returns {string} The id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = hint?.event_id || (0, $a15fd97f4e1b6d43$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $70cc7a497c940a25$export$af88d00dbe7f521).warn("No client configured on scope - will not capture message!");
            return eventId;
        }
        const syntheticException = new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a Sentry event for this scope.
   *
   * @returns {string} The id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = hint?.event_id || (0, $a15fd97f4e1b6d43$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $70cc7a497c940a25$export$af88d00dbe7f521).warn("No client configured on scope - will not capture event!");
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}


/** Get the default current scope. */ function $b29c69f02b18c15a$export$6f1b9191db9c4d5() {
    return (0, $b8e8a2c978e98d94$export$7e223ec222791509)("defaultCurrentScope", ()=>new (0, $7057e3acb253866f$export$775b6bb06e53a214)());
}
/** Get the default isolation scope. */ function $b29c69f02b18c15a$export$de9862929b76bf57() {
    return (0, $b8e8a2c978e98d94$export$7e223ec222791509)("defaultIsolationScope", ()=>new (0, $7057e3acb253866f$export$775b6bb06e53a214)());
}





/**
 * This is an object that holds a stack of scopes.
 */ class $4ac1c0cf71ab5f6a$export$d36ec451f120cfba {
    constructor(scope, isolationScope){
        let assignedScope;
        if (!scope) assignedScope = new (0, $7057e3acb253866f$export$775b6bb06e53a214)();
        else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) assignedIsolationScope = new (0, $7057e3acb253866f$export$775b6bb06e53a214)();
        else assignedIsolationScope = isolationScope;
        // scope stack for domains or the process
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Fork a scope for the stack.
   */ withScope(callback) {
        const scope = this._pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            this._popScope();
            throw e;
        }
        if ((0, $4541e6bae1c3cae8$export$f5b060c2914b97c8)(maybePromiseResult)) // @ts-expect-error - isThenable returns the wrong type
        return maybePromiseResult.then((res)=>{
            this._popScope();
            return res;
        }, (e)=>{
            this._popScope();
            throw e;
        });
        this._popScope();
        return maybePromiseResult;
    }
    /**
   * Get the client of the stack.
   */ getClient() {
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   */ getScope() {
        return this.getStackTop().scope;
    }
    /**
   * Get the isolation scope for the stack.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * Push a scope to the stack.
   */ _pushScope() {
        // We want to clone the content of prev scope
        const scope = this.getScope().clone();
        this._stack.push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * Pop a scope from the stack.
   */ _popScope() {
        if (this._stack.length <= 1) return false;
        return !!this._stack.pop();
    }
}
/**
 * Get the global async context stack.
 * This will be removed during the v8 cycle and is only here to make migration easier.
 */ function $4ac1c0cf71ab5f6a$var$getAsyncContextStack() {
    const registry = (0, $b8e8a2c978e98d94$export$19eade501500c6c1)();
    const sentry = (0, $b8e8a2c978e98d94$export$c8bfa33e4e8ae492)(registry);
    return sentry.stack = sentry.stack || new $4ac1c0cf71ab5f6a$export$d36ec451f120cfba((0, $b29c69f02b18c15a$export$6f1b9191db9c4d5)(), (0, $b29c69f02b18c15a$export$de9862929b76bf57)());
}
function $4ac1c0cf71ab5f6a$var$withScope(callback) {
    return $4ac1c0cf71ab5f6a$var$getAsyncContextStack().withScope(callback);
}
function $4ac1c0cf71ab5f6a$var$withSetScope(scope, callback) {
    const stack = $4ac1c0cf71ab5f6a$var$getAsyncContextStack();
    return stack.withScope(()=>{
        stack.getStackTop().scope = scope;
        return callback(scope);
    });
}
function $4ac1c0cf71ab5f6a$var$withIsolationScope(callback) {
    return $4ac1c0cf71ab5f6a$var$getAsyncContextStack().withScope(()=>{
        return callback($4ac1c0cf71ab5f6a$var$getAsyncContextStack().getIsolationScope());
    });
}
/**
 * Get the stack-based async context strategy.
 */ function $4ac1c0cf71ab5f6a$export$329d4d4d54e42710() {
    return {
        withIsolationScope: $4ac1c0cf71ab5f6a$var$withIsolationScope,
        withScope: $4ac1c0cf71ab5f6a$var$withScope,
        withSetScope: $4ac1c0cf71ab5f6a$var$withSetScope,
        withSetIsolationScope: (_isolationScope, callback)=>{
            return $4ac1c0cf71ab5f6a$var$withIsolationScope(callback);
        },
        getCurrentScope: ()=>$4ac1c0cf71ab5f6a$var$getAsyncContextStack().getScope(),
        getIsolationScope: ()=>$4ac1c0cf71ab5f6a$var$getAsyncContextStack().getIsolationScope()
    };
}


/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $8e7eca78891ba6de$export$774ae0e6b6e444ca(strategy) {
    // Get main carrier (global for every environment)
    const registry = (0, $b8e8a2c978e98d94$export$19eade501500c6c1)();
    const sentry = (0, $b8e8a2c978e98d94$export$c8bfa33e4e8ae492)(registry);
    sentry.acs = strategy;
}
/**
 * Get the current async context strategy.
 * If none has been setup, the default will be used.
 */ function $8e7eca78891ba6de$export$f639b0c2752203be(carrier) {
    const sentry = (0, $b8e8a2c978e98d94$export$c8bfa33e4e8ae492)(carrier);
    if (sentry.acs) return sentry.acs;
    // Otherwise, use the default one (stack)
    return (0, $4ac1c0cf71ab5f6a$export$329d4d4d54e42710)();
}





/**
 * Get the currently active scope.
 */ function $ea3b8c0e772c7cc7$export$c7be4b0125a10cba() {
    const carrier = (0, $b8e8a2c978e98d94$export$19eade501500c6c1)();
    const acs = (0, $8e7eca78891ba6de$export$f639b0c2752203be)(carrier);
    return acs.getCurrentScope();
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current execution context.
 */ function $ea3b8c0e772c7cc7$export$68f3af03034c9e90() {
    const carrier = (0, $b8e8a2c978e98d94$export$19eade501500c6c1)();
    const acs = (0, $8e7eca78891ba6de$export$f639b0c2752203be)(carrier);
    return acs.getIsolationScope();
}
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function $ea3b8c0e772c7cc7$export$aa55d5ab8e05984f() {
    return (0, $b8e8a2c978e98d94$export$7e223ec222791509)("globalScope", ()=>new (0, $7057e3acb253866f$export$775b6bb06e53a214)());
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function $ea3b8c0e772c7cc7$export$ec58d9285c204497(...rest) {
    const carrier = (0, $b8e8a2c978e98d94$export$19eade501500c6c1)();
    const acs = (0, $8e7eca78891ba6de$export$f639b0c2752203be)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) return acs.withScope(callback);
        return acs.withSetScope(scope, callback);
    }
    return acs.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 */ /**
 * Either creates a new active isolation scope, or sets the given isolation scope as active scope in the given callback.
 */ function $ea3b8c0e772c7cc7$export$9a4fed82c350c2bd(...rest) {
    const carrier = (0, $b8e8a2c978e98d94$export$19eade501500c6c1)();
    const acs = (0, $8e7eca78891ba6de$export$f639b0c2752203be)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [isolationScope, callback] = rest;
        if (!isolationScope) return acs.withIsolationScope(callback);
        return acs.withSetIsolationScope(isolationScope, callback);
    }
    return acs.withIsolationScope(rest[0]);
}
/**
 * Get the currently active client.
 */ function $ea3b8c0e772c7cc7$export$6bb76d6eba7e258c() {
    return $ea3b8c0e772c7cc7$export$c7be4b0125a10cba().getClient();
}
/**
 * Get a trace context for the given scope.
 */ function $ea3b8c0e772c7cc7$export$1e83db7ee4876dc4(scope) {
    const propagationContext = scope.getPropagationContext();
    const { traceId: traceId, parentSpanId: parentSpanId, propagationSpanId: propagationSpanId } = propagationContext;
    const traceContext = {
        trace_id: traceId,
        span_id: propagationSpanId || (0, $2b9195e12fc435e7$export$295213bc4d0c54ad)()
    };
    if (parentSpanId) traceContext.parent_span_id = parentSpanId;
    return traceContext;
}




/**
 * Use this attribute to represent the source of a span.
 * Should be one of: custom, url, route, view, component, task, unknown
 *
 */ const $6889f80b19c28299$export$d7a7d984b0791405 = "sentry.source";
/**
 * Attributes that holds the sample rate that was locally applied to a span.
 * If this attribute is not defined, it means that the span inherited a sampling decision.
 *
 * NOTE: Is only defined on root spans.
 */ const $6889f80b19c28299$export$ccfe0a40627cc34b = "sentry.sample_rate";
/**
 * Attribute holding the sample rate of the previous trace.
 * This is used to sample consistently across subsequent traces in the browser SDK.
 *
 * Note: Only defined on root spans, if opted into consistent sampling
 */ const $6889f80b19c28299$export$889fb736668e1ecc = "sentry.previous_trace_sample_rate";
/**
 * Use this attribute to represent the operation of a span.
 */ const $6889f80b19c28299$export$1a413bd9a88fdb09 = "sentry.op";
/**
 * Use this attribute to represent the origin of a span.
 */ const $6889f80b19c28299$export$cca8dd30f57f805e = "sentry.origin";
/** The reason why an idle span finished. */ const $6889f80b19c28299$export$ba73f34502b7a3b3 = "sentry.idle_span_finish_reason";
/** The unit of a measurement, which may be stored as a TimedEvent. */ const $6889f80b19c28299$export$f5f95cff026507b5 = "sentry.measurement_unit";
/** The value of a measurement, which may be stored as a TimedEvent. */ const $6889f80b19c28299$export$69cd5c610c7bb96a = "sentry.measurement_value";
/**
 * A custom span name set by users guaranteed to be taken over any automatically
 * inferred name. This attribute is removed before the span is sent.
 *
 * @internal only meant for internal SDK usage
 * @hidden
 */ const $6889f80b19c28299$export$165ce9a229f6f050 = "sentry.custom_span_name";
/**
 * The id of the profile that this span occurred in.
 */ const $6889f80b19c28299$export$1efec95406bbe327 = "sentry.profile_id";
const $6889f80b19c28299$export$fea48ba9f4550879 = "sentry.exclusive_time";
const $6889f80b19c28299$export$b016f89ac1066ec = "cache.hit";
const $6889f80b19c28299$export$3110e4c3f4386399 = "cache.key";
const $6889f80b19c28299$export$86be76deee227ff2 = "cache.item_size";
/** TODO: Remove these once we update to latest semantic conventions */ const $6889f80b19c28299$export$be7a251980e7e946 = "http.request.method";
const $6889f80b19c28299$export$25dfd73e0e32c6e1 = "url.full";
/**
 * A span link attribute to mark the link as a special span link.
 *
 * Known values:
 * - `previous_trace`: The span links to the frontend root span of the previous trace.
 * - `next_trace`: The span links to the frontend root span of the next trace. (Not set by the SDK)
 *
 * Other values may be set as appropriate.
 * @see https://develop.sentry.dev/sdk/telemetry/traces/span-links/#link-types
 */ const $6889f80b19c28299$export$ff77b5fd5b2d627b = "sentry.link.type";


const $edd9cdaf250acb4e$export$136e25984ba4a383 = 0;
const $edd9cdaf250acb4e$export$58f7963109c806fc = 1;
const $edd9cdaf250acb4e$export$f966a0446ece71e = 2;
/**
 * Converts a HTTP status code into a sentry status with a message.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ // https://develop.sentry.dev/sdk/event-payloads/span/
function $edd9cdaf250acb4e$export$5fd4dc48a2131589(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return {
        code: $edd9cdaf250acb4e$export$58f7963109c806fc
    };
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return {
                code: $edd9cdaf250acb4e$export$f966a0446ece71e,
                message: "unauthenticated"
            };
        case 403:
            return {
                code: $edd9cdaf250acb4e$export$f966a0446ece71e,
                message: "permission_denied"
            };
        case 404:
            return {
                code: $edd9cdaf250acb4e$export$f966a0446ece71e,
                message: "not_found"
            };
        case 409:
            return {
                code: $edd9cdaf250acb4e$export$f966a0446ece71e,
                message: "already_exists"
            };
        case 413:
            return {
                code: $edd9cdaf250acb4e$export$f966a0446ece71e,
                message: "failed_precondition"
            };
        case 429:
            return {
                code: $edd9cdaf250acb4e$export$f966a0446ece71e,
                message: "resource_exhausted"
            };
        case 499:
            return {
                code: $edd9cdaf250acb4e$export$f966a0446ece71e,
                message: "cancelled"
            };
        default:
            return {
                code: $edd9cdaf250acb4e$export$f966a0446ece71e,
                message: "invalid_argument"
            };
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return {
                code: $edd9cdaf250acb4e$export$f966a0446ece71e,
                message: "unimplemented"
            };
        case 503:
            return {
                code: $edd9cdaf250acb4e$export$f966a0446ece71e,
                message: "unavailable"
            };
        case 504:
            return {
                code: $edd9cdaf250acb4e$export$f966a0446ece71e,
                message: "deadline_exceeded"
            };
        default:
            return {
                code: $edd9cdaf250acb4e$export$f966a0446ece71e,
                message: "internal_error"
            };
    }
    return {
        code: $edd9cdaf250acb4e$export$f966a0446ece71e,
        message: "unknown_error"
    };
}
/**
 * Sets the Http status attributes on the current span based on the http code.
 * Additionally, the span's status is updated, depending on the http code.
 */ function $edd9cdaf250acb4e$export$2ad6630ec8164254(span, httpStatus) {
    span.setAttribute("http.response.status_code", httpStatus);
    const spanStatus = $edd9cdaf250acb4e$export$5fd4dc48a2131589(httpStatus);
    if (spanStatus.message !== "unknown_error") span.setStatus(spanStatus);
}



const $29c340d100c49ff2$var$SCOPE_ON_START_SPAN_FIELD = "_sentryScope";
const $29c340d100c49ff2$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD = "_sentryIsolationScope";
/** Store the scope & isolation scope for a span, which can the be used when it is finished. */ function $29c340d100c49ff2$export$cddb4027e3b0dd66(span, scope, isolationScope) {
    if (span) {
        (0, $69901043324a0df8$export$e73679ffaf56810e)(span, $29c340d100c49ff2$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD, isolationScope);
        (0, $69901043324a0df8$export$e73679ffaf56810e)(span, $29c340d100c49ff2$var$SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
/**
 * Grabs the scope and isolation scope off a span that were active when the span was started.
 */ function $29c340d100c49ff2$export$c08fbc656a245d03(span) {
    return {
        scope: span[$29c340d100c49ff2$var$SCOPE_ON_START_SPAN_FIELD],
        isolationScope: span[$29c340d100c49ff2$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD]
    };
}









const $4441f262bcfe1ccb$export$6e69537d67fa20f = "sentry-";
const $4441f262bcfe1ccb$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const $4441f262bcfe1ccb$export$bdd844ddb2def819 = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $4441f262bcfe1ccb$export$5b96ee2c8421f107(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    const baggageObject = $4441f262bcfe1ccb$export$397de414d189db00(baggageHeader);
    if (!baggageObject) return undefined;
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.match($4441f262bcfe1ccb$export$eb0401070c617ea5)) {
            const nonPrefixedKey = key.slice($4441f262bcfe1ccb$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $4441f262bcfe1ccb$export$56766feef403f365(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$4441f262bcfe1ccb$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $4441f262bcfe1ccb$export$12a7349a29a6e3c2(sentryPrefixedDSC);
}
/**
 * Take a baggage header and parse it into an object.
 */ function $4441f262bcfe1ccb$export$397de414d189db00(baggageHeader) {
    if (!baggageHeader || !(0, $4541e6bae1c3cae8$export$844ec244b1367d54)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    return baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $4441f262bcfe1ccb$var$baggageHeaderToObject(curr);
        Object.entries(currBaggageObject).forEach(([key, value])=>{
            acc[key] = value;
        });
        return acc;
    }, {});
    return $4441f262bcfe1ccb$var$baggageHeaderToObject(baggageHeader);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $4441f262bcfe1ccb$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(",").map((baggageEntry)=>baggageEntry.split("=").map((keyOrValue)=>{
            try {
                return decodeURIComponent(keyOrValue.trim());
            } catch  {
                // We ignore errors here, e.g. if the value cannot be URL decoded.
                // This will then be skipped in the next step
                return;
            }
        })).reduce((acc, [key, value])=>{
        if (key && value) acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $4441f262bcfe1ccb$export$12a7349a29a6e3c2(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $4441f262bcfe1ccb$export$bdd844ddb2def819) {
            (0, $b2977c3b93d1398b$export$16a28057038b10ef) && (0, $70cc7a497c940a25$export$af88d00dbe7f521).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, "");
}


/**
 * Parse a sample rate from a given value.
 * This will either return a boolean or number sample rate, if the sample rate is valid (between 0 and 1).
 * If a string is passed, we try to convert it to a number.
 *
 * Any invalid sample rate will return `undefined`.
 */ function $d8d708bfa76dee9a$export$a5bd2d81656d9546(sampleRate) {
    if (typeof sampleRate === "boolean") return Number(sampleRate);
    const rate = typeof sampleRate === "string" ? parseFloat(sampleRate) : sampleRate;
    if (typeof rate !== "number" || isNaN(rate) || rate < 0 || rate > 1) return undefined;
    return rate;
}



// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- RegExp is used for readability here
const $cd34f4260dc55d51$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $cd34f4260dc55d51$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return undefined;
    const matches = traceparent.match($cd34f4260dc55d51$export$394a210812ba3012);
    if (!matches) return undefined;
    let parentSampled;
    if (matches[3] === "1") parentSampled = true;
    else if (matches[3] === "0") parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create a propagation context from incoming headers or
 * creates a minimal new one if the headers are undefined.
 */ function $cd34f4260dc55d51$export$261f383d16a93e39(sentryTrace, baggage) {
    const traceparentData = $cd34f4260dc55d51$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $4441f262bcfe1ccb$export$5b96ee2c8421f107)(baggage);
    if (!traceparentData?.traceId) return {
        traceId: (0, $2b9195e12fc435e7$export$dc6d7ea554bcce10)(),
        sampleRand: Math.random()
    };
    const sampleRand = $cd34f4260dc55d51$var$getSampleRandFromTraceparentAndDsc(traceparentData, dynamicSamplingContext);
    // The sample_rand on the DSC needs to be generated based on traceparent + baggage.
    if (dynamicSamplingContext) dynamicSamplingContext.sample_rand = sampleRand.toString();
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData;
    return {
        traceId: traceId,
        parentSpanId: parentSpanId,
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {},
        sampleRand: sampleRand
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function $cd34f4260dc55d51$export$f35d907436da45cf(traceId = (0, $2b9195e12fc435e7$export$dc6d7ea554bcce10)(), spanId = (0, $2b9195e12fc435e7$export$295213bc4d0c54ad)(), sampled) {
    let sampledString = "";
    if (sampled !== undefined) sampledString = sampled ? "-1" : "-0";
    return `${traceId}-${spanId}${sampledString}`;
}
/**
 * Given any combination of an incoming trace, generate a sample rand based on its defined semantics.
 *
 * Read more: https://develop.sentry.dev/sdk/telemetry/traces/#propagated-random-value
 */ function $cd34f4260dc55d51$var$getSampleRandFromTraceparentAndDsc(traceparentData, dsc) {
    // When there is an incoming sample rand use it.
    const parsedSampleRand = (0, $d8d708bfa76dee9a$export$a5bd2d81656d9546)(dsc?.sample_rand);
    if (parsedSampleRand !== undefined) return parsedSampleRand;
    // Otherwise, if there is an incoming sampling decision + sample rate, generate a sample rand that would lead to the same sampling decision.
    const parsedSampleRate = (0, $d8d708bfa76dee9a$export$a5bd2d81656d9546)(dsc?.sample_rate);
    if (parsedSampleRate && traceparentData?.parentSampled !== undefined) return traceparentData.parentSampled ? Math.random() * parsedSampleRate : parsedSampleRate + Math.random() * (1 - parsedSampleRate);
    else // If nothing applies, return a random sample rand.
    return Math.random();
}



// These are aligned with OpenTelemetry trace flags
const $eb63b022ee5d8903$export$208d5b368507fb8b = 0x0;
const $eb63b022ee5d8903$export$eb571cd9b5d98de8 = 0x1;
let $eb63b022ee5d8903$var$hasShownSpanDropWarning = false;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 * By default, this will only include trace_id, span_id & parent_span_id.
 * If `includeAllData` is true, it will also include data, op, status & origin.
 */ function $eb63b022ee5d8903$export$4c3967a8a2f6bbd6(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, origin: origin, links: links } = $eb63b022ee5d8903$export$92d8c23565496537(span);
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id,
        data: data,
        op: op,
        status: status,
        origin: origin,
        links: links
    };
}
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in a non-transaction event.
 */ function $eb63b022ee5d8903$export$46c6fbd1d265ebf0(span) {
    const { spanId: spanId, traceId: trace_id, isRemote: isRemote } = span.spanContext();
    // If the span is remote, we use a random/virtual span as span_id to the trace context,
    // and the remote span as parent_span_id
    const parent_span_id = isRemote ? spanId : $eb63b022ee5d8903$export$92d8c23565496537(span).parent_span_id;
    const scope = (0, $29c340d100c49ff2$export$c08fbc656a245d03)(span).scope;
    const span_id = isRemote ? scope?.getPropagationContext().propagationSpanId || (0, $2b9195e12fc435e7$export$295213bc4d0c54ad)() : spanId;
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id
    };
}
/**
 * Convert a Span to a Sentry trace header.
 */ function $eb63b022ee5d8903$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $eb63b022ee5d8903$export$5caecac1caaf3a71(span);
    return (0, $cd34f4260dc55d51$export$f35d907436da45cf)(traceId, spanId, sampled);
}
/**
 *  Converts the span links array to a flattened version to be sent within an envelope.
 *
 *  If the links array is empty, it returns `undefined` so the empty value can be dropped before it's sent.
 */ function $eb63b022ee5d8903$export$cb3e3a12e0eec16c(links) {
    if (links && links.length > 0) return links.map(({ context: { spanId: spanId, traceId: traceId, traceFlags: traceFlags, ...restContext }, attributes: attributes })=>({
            span_id: spanId,
            trace_id: traceId,
            sampled: traceFlags === $eb63b022ee5d8903$export$eb571cd9b5d98de8,
            attributes: attributes,
            ...restContext
        }));
    else return undefined;
}
/**
 * Convert a span time input into a timestamp in seconds.
 */ function $eb63b022ee5d8903$export$3f7581298f56c6d7(input) {
    if (typeof input === "number") return $eb63b022ee5d8903$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $eb63b022ee5d8903$var$ensureTimestampInSeconds(input.getTime());
    return (0, $b83fbc460ca20326$export$ee52dced521e3e18)();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function $eb63b022ee5d8903$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 */ // Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
// This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
// And `spanToJSON` needs the Span class from `span.ts` to check here.
function $eb63b022ee5d8903$export$92d8c23565496537(span) {
    if ($eb63b022ee5d8903$var$spanIsSentrySpan(span)) return span.getSpanJSON();
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    // Handle a span from @opentelemetry/sdk-base-trace's `Span` class
    if ($eb63b022ee5d8903$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
        const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, status: status, links: links } = span;
        // In preparation for the next major of OpenTelemetry, we want to support
        // looking up the parent span id according to the new API
        // In OTel v1, the parent span id is accessed as `parentSpanId`
        // In OTel v2, the parent span id is accessed as `spanId` on the `parentSpanContext`
        const parentSpanId = "parentSpanId" in span ? span.parentSpanId : "parentSpanContext" in span ? span.parentSpanContext?.spanId : undefined;
        return {
            span_id: span_id,
            trace_id: trace_id,
            data: attributes,
            description: name,
            parent_span_id: parentSpanId,
            start_timestamp: $eb63b022ee5d8903$export$3f7581298f56c6d7(startTime),
            // This is [0,0] by default in OTEL, in which case we want to interpret this as no end time
            timestamp: $eb63b022ee5d8903$export$3f7581298f56c6d7(endTime) || undefined,
            status: $eb63b022ee5d8903$export$e238a77ea3a8cd66(status),
            op: attributes[0, $6889f80b19c28299$export$1a413bd9a88fdb09],
            origin: attributes[0, $6889f80b19c28299$export$cca8dd30f57f805e],
            links: $eb63b022ee5d8903$export$cb3e3a12e0eec16c(links)
        };
    }
    // Finally, at least we have `spanContext()`....
    // This should not actually happen in reality, but we need to handle it for type safety.
    return {
        span_id: span_id,
        trace_id: trace_id,
        start_timestamp: 0,
        data: {}
    };
}
function $eb63b022ee5d8903$var$spanIsOpenTelemetrySdkTraceBaseSpan(span) {
    const castSpan = span;
    return !!castSpan.attributes && !!castSpan.startTime && !!castSpan.name && !!castSpan.endTime && !!castSpan.status;
}
/** Exported only for tests. */ /**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function $eb63b022ee5d8903$var$spanIsSentrySpan(span) {
    return typeof span.getSpanJSON === "function";
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function $eb63b022ee5d8903$export$5caecac1caaf3a71(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    const { traceFlags: traceFlags } = span.spanContext();
    return traceFlags === $eb63b022ee5d8903$export$eb571cd9b5d98de8;
}
/** Get the status message to use for a JSON representation of a span. */ function $eb63b022ee5d8903$export$e238a77ea3a8cd66(status) {
    if (!status || status.code === (0, $edd9cdaf250acb4e$export$136e25984ba4a383)) return undefined;
    if (status.code === (0, $edd9cdaf250acb4e$export$58f7963109c806fc)) return "ok";
    return status.message || "unknown_error";
}
const $eb63b022ee5d8903$var$CHILD_SPANS_FIELD = "_sentryChildSpans";
const $eb63b022ee5d8903$var$ROOT_SPAN_FIELD = "_sentryRootSpan";
/**
 * Adds an opaque child span reference to a span.
 */ function $eb63b022ee5d8903$export$81397d924722cc65(span, childSpan) {
    // We store the root span reference on the child span
    // We need this for `getRootSpan()` to work
    const rootSpan = span[$eb63b022ee5d8903$var$ROOT_SPAN_FIELD] || span;
    (0, $69901043324a0df8$export$e73679ffaf56810e)(childSpan, $eb63b022ee5d8903$var$ROOT_SPAN_FIELD, rootSpan);
    // We store a list of child spans on the parent span
    // We need this for `getSpanDescendants()` to work
    if (span[$eb63b022ee5d8903$var$CHILD_SPANS_FIELD]) span[$eb63b022ee5d8903$var$CHILD_SPANS_FIELD].add(childSpan);
    else (0, $69901043324a0df8$export$e73679ffaf56810e)(span, $eb63b022ee5d8903$var$CHILD_SPANS_FIELD, new Set([
        childSpan
    ]));
}
/** This is only used internally by Idle Spans. */ function $eb63b022ee5d8903$export$c2a0c9438bb89d91(span, childSpan) {
    if (span[$eb63b022ee5d8903$var$CHILD_SPANS_FIELD]) span[$eb63b022ee5d8903$var$CHILD_SPANS_FIELD].delete(childSpan);
}
/**
 * Returns an array of the given span and all of its descendants.
 */ function $eb63b022ee5d8903$export$340c5c8a13ffc680(span) {
    const resultSet = new Set();
    function addSpanChildren(span) {
        // This exit condition is required to not infinitely loop in case of a circular dependency.
        if (resultSet.has(span)) return;
        else if ($eb63b022ee5d8903$export$5caecac1caaf3a71(span)) {
            resultSet.add(span);
            const childSpans = span[$eb63b022ee5d8903$var$CHILD_SPANS_FIELD] ? Array.from(span[$eb63b022ee5d8903$var$CHILD_SPANS_FIELD]) : [];
            for (const childSpan of childSpans)addSpanChildren(childSpan);
        }
    }
    addSpanChildren(span);
    return Array.from(resultSet);
}
/**
 * Returns the root span of a given span.
 */ function $eb63b022ee5d8903$export$c4c6a79b1260ca1b(span) {
    return span[$eb63b022ee5d8903$var$ROOT_SPAN_FIELD] || span;
}
/**
 * Returns the currently active span.
 */ function $eb63b022ee5d8903$export$1be426a8e585c83e() {
    const carrier = (0, $b8e8a2c978e98d94$export$19eade501500c6c1)();
    const acs = (0, $8e7eca78891ba6de$export$f639b0c2752203be)(carrier);
    if (acs.getActiveSpan) return acs.getActiveSpan();
    return (0, $4b940a7f4edc293b$export$91f063ebb8eff307)((0, $ea3b8c0e772c7cc7$export$c7be4b0125a10cba)());
}
/**
 * Logs a warning once if `beforeSendSpan` is used to drop spans.
 */ function $eb63b022ee5d8903$export$d11691ff45a3e535() {
    if (!$eb63b022ee5d8903$var$hasShownSpanDropWarning) {
        (0, $70cc7a497c940a25$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.warn("[Sentry] Returning null from `beforeSendSpan` is disallowed. To drop certain spans, configure the respective integrations directly.");
        });
        $eb63b022ee5d8903$var$hasShownSpanDropWarning = true;
    }
}
/**
 * Updates the name of the given span and ensures that the span name is not
 * overwritten by the Sentry SDK.
 *
 * Use this function instead of `span.updateName()` if you want to make sure that
 * your name is kept. For some spans, for example root `http.server` spans the
 * Sentry SDK would otherwise overwrite the span name with a high-quality name
 * it infers when the span ends.
 *
 * Use this function in server code or when your span is started on the server
 * and on the client (browser). If you only update a span name on the client,
 * you can also use `span.updateName()` the SDK does not overwrite the name.
 *
 * @param span - The span to update the name of.
 * @param name - The name to set on the span.
 */ function $eb63b022ee5d8903$export$5b72d3169c1be715(span, name) {
    span.updateName(name);
    span.setAttributes({
        [(0, $6889f80b19c28299$export$d7a7d984b0791405)]: "custom",
        [(0, $6889f80b19c28299$export$165ce9a229f6f050)]: name
    });
}







/**
 * Wrap a callback function with error handling.
 * If an error is thrown, it will be passed to the `onError` callback and re-thrown.
 *
 * If the return value of the function is a promise, it will be handled with `maybeHandlePromiseRejection`.
 *
 * If an `onFinally` callback is provided, this will be called when the callback has finished
 * - so if it returns a promise, once the promise resolved/rejected,
 * else once the callback has finished executing.
 * The `onFinally` callback will _always_ be called, no matter if an error was thrown or not.
 */ function $8bf6ceaf67cc8cac$export$18ce21a8b7efd7e9(fn, onError, // eslint-disable-next-line @typescript-eslint/no-empty-function
onFinally = ()=>{}) {
    let maybePromiseResult;
    try {
        maybePromiseResult = fn();
    } catch (e) {
        onError(e);
        onFinally();
        throw e;
    }
    return $8bf6ceaf67cc8cac$var$maybeHandlePromiseRejection(maybePromiseResult, onError, onFinally);
}
/**
 * Maybe handle a promise rejection.
 * This expects to be given a value that _may_ be a promise, or any other value.
 * If it is a promise, and it rejects, it will call the `onError` callback.
 * Other than this, it will generally return the given value as-is.
 */ function $8bf6ceaf67cc8cac$var$maybeHandlePromiseRejection(value, onError, onFinally) {
    if ((0, $4541e6bae1c3cae8$export$f5b060c2914b97c8)(value)) // @ts-expect-error - the isThenable check returns the "wrong" type here
    return value.then((res)=>{
        onFinally();
        return res;
    }, (e)=>{
        onError(e);
        onFinally();
        throw e;
    });
    onFinally();
    return value;
}



// Treeshakable guard to remove all code related to tracing
/**
 * Determines if span recording is currently enabled.
 *
 * Spans are recorded when at least one of `tracesSampleRate` and `tracesSampler`
 * is defined in the SDK config. This function does not make any assumption about
 * sampling decisions, it only checks if the SDK is configured to record spans.
 *
 * Important: This function only determines if span recording is enabled. Trace
 * continuation and propagation is separately controlled and not covered by this function.
 * If this function returns `false`, traces can still be propagated (which is what
 * we refer to by "Tracing without Performance")
 * @see https://develop.sentry.dev/sdk/telemetry/traces/tracing-without-performance/
 *
 * @param maybeOptions An SDK options object to be passed to this function.
 * If this option is not provided, the function will use the current client's options.
 */ function $f5f4e8ed7952f893$export$1f70765132c3c225(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === "boolean" && !__SENTRY_TRACING__) return false;
    const options = maybeOptions || (0, $ea3b8c0e772c7cc7$export$6bb76d6eba7e258c)()?.getOptions();
    return !!options && // Note: This check is `!= null`, meaning "nullish". `0` is not "nullish", `undefined` and `null` are. (This comment was brought to you by 15 minutes of questioning life)
    (options.tracesSampleRate != null || !!options.tracesSampler);
}
/**
 * @see JSDoc of `hasSpansEnabled`
 * @deprecated Use `hasSpansEnabled` instead, which is a more accurately named version of this function.
 * This function will be removed in the next major version of the SDK.
 */ // TODO(v10): Remove this export
const $f5f4e8ed7952f893$export$5008da00b1b6dee6 = $f5f4e8ed7952f893$export$1f70765132c3c225;








const $18ab534e7d547973$export$849dbeeeda01ae98 = "production";







/** Regular expression used to extract org ID from a DSN host. */ const $d29a90850bb2632c$var$ORG_ID_REGEX = /^o(\d+)\./;
/** Regular expression used to parse a Dsn. */ const $d29a90850bb2632c$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $d29a90850bb2632c$var$isValidProtocol(protocol) {
    return protocol === "http" || protocol === "https";
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function $d29a90850bb2632c$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ""}` + `@${host}${port ? `:${port}` : ""}/${path ? `${path}/` : path}${projectId}`;
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function $d29a90850bb2632c$export$b892860177f70a30(str) {
    const match = $d29a90850bb2632c$var$DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        (0, $70cc7a497c940a25$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return undefined;
    }
    const [protocol, publicKey, pass = "", host = "", port = "", lastPath = ""] = match.slice(1);
    let path = "";
    let projectId = lastPath;
    const split = projectId.split("/");
    if (split.length > 1) {
        path = split.slice(0, -1).join("/");
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $d29a90850bb2632c$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $d29a90850bb2632c$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || "",
        pass: components.pass || "",
        host: components.host,
        port: components.port || "",
        path: components.path || "",
        projectId: components.projectId
    };
}
function $d29a90850bb2632c$var$validateDsn(dsn) {
    if (!(0, $b2977c3b93d1398b$export$16a28057038b10ef)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        "protocol",
        "publicKey",
        "host",
        "projectId"
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $70cc7a497c940a25$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $70cc7a497c940a25$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$d29a90850bb2632c$var$isValidProtocol(protocol)) {
        (0, $70cc7a497c940a25$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $70cc7a497c940a25$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
/**
 * Extract the org ID from a DSN host.
 *
 * @param host The host from a DSN
 * @returns The org ID if found, undefined otherwise
 */ function $d29a90850bb2632c$export$5914f4e7748c29c9(host) {
    const match = host.match($d29a90850bb2632c$var$ORG_ID_REGEX);
    return match?.[1];
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function $d29a90850bb2632c$export$128827c3562ec0cb(from) {
    const components = typeof from === "string" ? $d29a90850bb2632c$export$b892860177f70a30(from) : $d29a90850bb2632c$var$dsnFromComponents(from);
    if (!components || !$d29a90850bb2632c$var$validateDsn(components)) return undefined;
    return components;
}






/**
 * If you change this value, also update the terser plugin config to
 * avoid minification of the object property!
 */ const $a14190270949a626$var$FROZEN_DSC_FIELD = "_frozenDsc";
/**
 * Freeze the given DSC on the given span.
 */ function $a14190270949a626$export$7398c93e763ca9fd(span, dsc) {
    const spanWithMaybeDsc = span;
    (0, $69901043324a0df8$export$e73679ffaf56810e)(spanWithMaybeDsc, $a14190270949a626$var$FROZEN_DSC_FIELD, dsc);
}
/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function $a14190270949a626$export$366bad00d6815eed(trace_id, client) {
    const options = client.getOptions();
    const { publicKey: public_key, host: host } = client.getDsn() || {};
    let org_id;
    if (options.orgId) org_id = String(options.orgId);
    else if (host) org_id = (0, $d29a90850bb2632c$export$5914f4e7748c29c9)(host);
    // Instead of conditionally adding non-undefined values, we add them and then remove them if needed
    // otherwise, the order of baggage entries changes, which "breaks" a bunch of tests etc.
    const dsc = {
        environment: options.environment || (0, $18ab534e7d547973$export$849dbeeeda01ae98),
        release: options.release,
        public_key: public_key,
        trace_id: trace_id,
        org_id: org_id
    };
    client.emit("createDsc", dsc);
    return dsc;
}
/**
 * Get the dynamic sampling context for the currently active scopes.
 */ function $a14190270949a626$export$89ef1736f08c6b2b(client, scope) {
    const propagationContext = scope.getPropagationContext();
    return propagationContext.dsc || $a14190270949a626$export$366bad00d6815eed(propagationContext.traceId, client);
}
/**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function $a14190270949a626$export$a117f995597e25df(span) {
    const client = (0, $ea3b8c0e772c7cc7$export$6bb76d6eba7e258c)();
    if (!client) return {};
    const rootSpan = (0, $eb63b022ee5d8903$export$c4c6a79b1260ca1b)(span);
    const rootSpanJson = (0, $eb63b022ee5d8903$export$92d8c23565496537)(rootSpan);
    const rootSpanAttributes = rootSpanJson.data;
    const traceState = rootSpan.spanContext().traceState;
    // The span sample rate that was locally applied to the root span should also always be applied to the DSC, even if the DSC is frozen.
    // This is so that the downstream traces/services can use parentSampleRate in their `tracesSampler` to make consistent sampling decisions across the entire trace.
    const rootSpanSampleRate = traceState?.get("sentry.sample_rate") ?? rootSpanAttributes[0, $6889f80b19c28299$export$ccfe0a40627cc34b] ?? rootSpanAttributes[0, $6889f80b19c28299$export$889fb736668e1ecc];
    function applyLocalSampleRateToDsc(dsc) {
        if (typeof rootSpanSampleRate === "number" || typeof rootSpanSampleRate === "string") dsc.sample_rate = `${rootSpanSampleRate}`;
        return dsc;
    }
    // For core implementation, we freeze the DSC onto the span as a non-enumerable property
    const frozenDsc = rootSpan[$a14190270949a626$var$FROZEN_DSC_FIELD];
    if (frozenDsc) return applyLocalSampleRateToDsc(frozenDsc);
    // For OpenTelemetry, we freeze the DSC on the trace state
    const traceStateDsc = traceState?.get("sentry.dsc");
    // If the span has a DSC, we want it to take precedence
    const dscOnTraceState = traceStateDsc && (0, $4441f262bcfe1ccb$export$5b96ee2c8421f107)(traceStateDsc);
    if (dscOnTraceState) return applyLocalSampleRateToDsc(dscOnTraceState);
    // Else, we generate it from the span
    const dsc = $a14190270949a626$export$366bad00d6815eed(span.spanContext().traceId, client);
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    const source = rootSpanAttributes[0, $6889f80b19c28299$export$d7a7d984b0791405];
    // after JSON conversion, txn.name becomes jsonSpan.description
    const name = rootSpanJson.description;
    if (source !== "url" && name) dsc.transaction = name;
    // How can we even land here with hasSpansEnabled() returning false?
    // Otel creates a Non-recording span in Tracing Without Performance mode when handling incoming requests
    // So we end up with an active span that is not sampled (neither positively nor negatively)
    if ((0, $f5f4e8ed7952f893$export$1f70765132c3c225)()) {
        dsc.sampled = String((0, $eb63b022ee5d8903$export$5caecac1caaf3a71)(rootSpan));
        dsc.sample_rand = // In OTEL we store the sample rand on the trace state because we cannot access scopes for NonRecordingSpans
        // The Sentry OTEL SpanSampler takes care of writing the sample rand on the root span
        traceState?.get("sentry.sample_rand") ?? // On all other platforms we can actually get the scopes from a root span (we use this as a fallback)
        (0, $29c340d100c49ff2$export$c08fbc656a245d03)(rootSpan).scope?.getPropagationContext().sampleRand.toString();
    }
    applyLocalSampleRateToDsc(dsc);
    client.emit("createDsc", dsc, rootSpan);
    return dsc;
}
/**
 * Convert a Span to a baggage header.
 */ function $a14190270949a626$export$95cf936fdacaff7b(span) {
    const dsc = $a14190270949a626$export$a117f995597e25df(span);
    return (0, $4441f262bcfe1ccb$export$56766feef403f365)(dsc);
}





/**
 * Print a log message for a started span.
 */ function $1697b8f148de0a48$export$2f3d84e767c9592b(span) {
    if (!(0, $b2977c3b93d1398b$export$16a28057038b10ef)) return;
    const { description: description = "< unknown name >", op: op = "< unknown op >", parent_span_id: parentSpanId } = (0, $eb63b022ee5d8903$export$92d8c23565496537)(span);
    const { spanId: spanId } = span.spanContext();
    const sampled = (0, $eb63b022ee5d8903$export$5caecac1caaf3a71)(span);
    const rootSpan = (0, $eb63b022ee5d8903$export$c4c6a79b1260ca1b)(span);
    const isRootSpan = rootSpan === span;
    const header = `[Tracing] Starting ${sampled ? "sampled" : "unsampled"} ${isRootSpan ? "root " : ""}span`;
    const infoParts = [
        `op: ${op}`,
        `name: ${description}`,
        `ID: ${spanId}`
    ];
    if (parentSpanId) infoParts.push(`parent ID: ${parentSpanId}`);
    if (!isRootSpan) {
        const { op: op, description: description } = (0, $eb63b022ee5d8903$export$92d8c23565496537)(rootSpan);
        infoParts.push(`root ID: ${rootSpan.spanContext().spanId}`);
        if (op) infoParts.push(`root op: ${op}`);
        if (description) infoParts.push(`root description: ${description}`);
    }
    (0, $70cc7a497c940a25$export$af88d00dbe7f521).log(`${header}
  ${infoParts.join("\n  ")}`);
}
/**
 * Print a log message for an ended span.
 */ function $1697b8f148de0a48$export$b77c830667a4d630(span) {
    if (!(0, $b2977c3b93d1398b$export$16a28057038b10ef)) return;
    const { description: description = "< unknown name >", op: op = "< unknown op >" } = (0, $eb63b022ee5d8903$export$92d8c23565496537)(span);
    const { spanId: spanId } = span.spanContext();
    const rootSpan = (0, $eb63b022ee5d8903$export$c4c6a79b1260ca1b)(span);
    const isRootSpan = rootSpan === span;
    const msg = `[Tracing] Finishing "${op}" ${isRootSpan ? "root " : ""}span "${description}" with ID ${spanId}`;
    (0, $70cc7a497c940a25$export$af88d00dbe7f521).log(msg);
}






/**
 * Makes a sampling decision for the given options.
 *
 * Called every time a root span is created. Only root spans which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 */ function $f38d79859654667a$export$5f833db634b217bb(options, samplingContext, sampleRand) {
    // nothing to do if span recording is not enabled
    if (!(0, $f5f4e8ed7952f893$export$1f70765132c3c225)(options)) return [
        false
    ];
    let localSampleRateWasApplied = undefined;
    // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` were defined, so one of these should
    // work; prefer the hook if so
    let sampleRate;
    if (typeof options.tracesSampler === "function") {
        sampleRate = options.tracesSampler({
            ...samplingContext,
            inheritOrSampleWith: (fallbackSampleRate)=>{
                // If we have an incoming parent sample rate, we'll just use that one.
                // The sampling decision will be inherited because of the sample_rand that was generated when the trace reached the incoming boundaries of the SDK.
                if (typeof samplingContext.parentSampleRate === "number") return samplingContext.parentSampleRate;
                // Fallback if parent sample rate is not on the incoming trace (e.g. if there is no baggage)
                // This is to provide backwards compatibility if there are incoming traces from older SDKs that don't send a parent sample rate or a sample rand. In these cases we just want to force either a sampling decision on the downstream traces via the sample rate.
                if (typeof samplingContext.parentSampled === "boolean") return Number(samplingContext.parentSampled);
                return fallbackSampleRate;
            }
        });
        localSampleRateWasApplied = true;
    } else if (samplingContext.parentSampled !== undefined) sampleRate = samplingContext.parentSampled;
    else if (typeof options.tracesSampleRate !== "undefined") {
        sampleRate = options.tracesSampleRate;
        localSampleRateWasApplied = true;
    }
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get.
    // (The only valid values are booleans or numbers between 0 and 1.)
    const parsedSampleRate = (0, $d8d708bfa76dee9a$export$a5bd2d81656d9546)(sampleRate);
    if (parsedSampleRate === undefined) {
        (0, $b2977c3b93d1398b$export$16a28057038b10ef) && (0, $70cc7a497c940a25$export$af88d00dbe7f521).warn(`[Tracing] Discarding root span because of invalid sample rate. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(sampleRate)} of type ${JSON.stringify(typeof sampleRate)}.`);
        return [
            false
        ];
    }
    // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
    if (!parsedSampleRate) {
        (0, $b2977c3b93d1398b$export$16a28057038b10ef) && (0, $70cc7a497c940a25$export$af88d00dbe7f521).log(`[Tracing] Discarding transaction because ${typeof options.tracesSampler === "function" ? "tracesSampler returned 0 or false" : "a negative sampling decision was inherited or tracesSampleRate is set to 0"}`);
        return [
            false,
            parsedSampleRate,
            localSampleRateWasApplied
        ];
    }
    // We always compare the sample rand for the current execution context against the chosen sample rate.
    // Read more: https://develop.sentry.dev/sdk/telemetry/traces/#propagated-random-value
    const shouldSample = sampleRand < parsedSampleRate;
    // if we're not going to keep it, we're done
    if (!shouldSample) (0, $b2977c3b93d1398b$export$16a28057038b10ef) && (0, $70cc7a497c940a25$export$af88d00dbe7f521).log(`[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(sampleRate)})`);
    return [
        shouldSample,
        parsedSampleRate,
        localSampleRateWasApplied
    ];
}




/**
 * A Sentry Span that is non-recording, meaning it will not be sent to Sentry.
 */ class $f3522bc55eae07bc$export$d6636b700b76c516 {
    constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $2b9195e12fc435e7$export$dc6d7ea554bcce10)();
        this._spanId = spanContext.spanId || (0, $2b9195e12fc435e7$export$295213bc4d0c54ad)();
    }
    /** @inheritdoc */ spanContext() {
        return {
            spanId: this._spanId,
            traceId: this._traceId,
            traceFlags: (0, $eb63b022ee5d8903$export$208d5b368507fb8b)
        };
    }
    /** @inheritdoc */ // eslint-disable-next-line @typescript-eslint/no-empty-function
    end(_timestamp) {}
    /** @inheritdoc */ setAttribute(_key, _value) {
        return this;
    }
    /** @inheritdoc */ setAttributes(_values) {
        return this;
    }
    /** @inheritdoc */ setStatus(_status) {
        return this;
    }
    /** @inheritdoc */ updateName(_name) {
        return this;
    }
    /** @inheritdoc */ isRecording() {
        return false;
    }
    /** @inheritdoc */ addEvent(_name, _attributesOrStartTime, _startTime) {
        return this;
    }
    /** @inheritDoc */ addLink(_link) {
        return this;
    }
    /** @inheritDoc */ addLinks(_links) {
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {
    // noop
    }
}











/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normalized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $7c8e4381e2614efa$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $7c8e4381e2614efa$var$visit("", input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $7c8e4381e2614efa$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $7c8e4381e2614efa$export$a3295358bff77e(object, depth);
    if ($7c8e4381e2614efa$var$jsonSize(normalized) > maxSize) return $7c8e4381e2614efa$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $7c8e4381e2614efa$var$visit(key, value, depth = Infinity, maxProperties = Infinity, memo = $7c8e4381e2614efa$var$memoBuilder()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        "boolean",
        "string"
    ].includes(typeof value) || typeof value === "number" && Number.isFinite(value)) return value;
    const stringified = $7c8e4381e2614efa$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith("[object ")) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value["__sentry_skip_normalization__"]) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    const remainingDepth = typeof value["__sentry_override_normalization_depth__"] === "number" ? value["__sentry_override_normalization_depth__"] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace("object ", "");
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return "[Circular ~]";
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === "function") try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $7c8e4381e2614efa$var$visit("", jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, $69901043324a0df8$export$62ff257738bf57f5)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = "[MaxProperties ~]";
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $7c8e4381e2614efa$var$visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $7c8e4381e2614efa$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === "domain" && value && typeof value === "object" && value._events) return "[Domain]";
        if (key === "domainEmitter") return "[DomainEmitter]";
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== "undefined" && value === $parcel$global) return "[Global]";
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== "undefined" && value === window) return "[Window]";
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== "undefined" && value === document) return "[Document]";
        if ((0, $4541e6bae1c3cae8$export$7916fad0ebc23f48)(value)) return "[VueViewModel]";
        // React's SyntheticEvent thingy
        if ((0, $4541e6bae1c3cae8$export$bc2894c7158efbac)(value)) return "[SyntheticEvent]";
        if (typeof value === "number" && !Number.isFinite(value)) return `[${value}]`;
        if (typeof value === "function") return `[Function: ${(0, $62980e96870c5f3e$export$aad197c7121a6651)(value)}]`;
        if (typeof value === "symbol") return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === "bigint") return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        const objName = $7c8e4381e2614efa$var$getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function $7c8e4381e2614efa$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype?.constructor ? prototype.constructor.name : "null prototype";
}
/** Calculates bytes size of input string */ function $7c8e4381e2614efa$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $7c8e4381e2614efa$var$jsonSize(value) {
    return $7c8e4381e2614efa$var$utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function $7c8e4381e2614efa$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath// Backslash to forward
    .replace(/\\/g, "/")// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, "\\$&");
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch (_Oo) {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, "/").replace(/webpack:\/?/g, "") // Remove intermediate base path
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor
    .replace(new RegExp(`(file://)?/*${escapedBase}/*`, "ig"), "app:///");
}
/**
 * Helper to decycle json objects
 */ function $7c8e4381e2614efa$var$memoBuilder() {
    const inner = new WeakSet();
    function memoize(obj) {
        if (inner.has(obj)) return true;
        inner.add(obj);
        return false;
    }
    function unmemoize(obj) {
        inner.delete(obj);
    }
    return [
        memoize,
        unmemoize
    ];
}



/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $6c82efee51166966$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $6c82efee51166966$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function $6c82efee51166966$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function $6c82efee51166966$export$604a45d95a155e2b(envelope, types) {
    return $6c82efee51166966$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
/**
 * Encode a string to UTF8 array.
 */ function $6c82efee51166966$var$encodeUTF8(input) {
    const carrier = (0, $b8e8a2c978e98d94$export$c8bfa33e4e8ae492)((0, $20ae43346f76bdfd$export$f1a6cdb1459e81d1));
    return carrier.encodePolyfill ? carrier.encodePolyfill(input) : new TextEncoder().encode(input);
}
/**
 * Decode a UTF8 array to string.
 */ function $6c82efee51166966$var$decodeUTF8(input) {
    const carrier = (0, $b8e8a2c978e98d94$export$c8bfa33e4e8ae492)((0, $20ae43346f76bdfd$export$f1a6cdb1459e81d1));
    return carrier.decodePolyfill ? carrier.decodePolyfill(input) : new TextDecoder().decode(input);
}
/**
 * Serializes an envelope.
 */ function $6c82efee51166966$export$32f9b428425aac85(envelope) {
    const [envHeaders, items] = envelope;
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === "string") parts = typeof next === "string" ? parts + next : [
            $6c82efee51166966$var$encodeUTF8(parts),
            next
        ];
        else parts.push(typeof next === "string" ? $6c82efee51166966$var$encodeUTF8(next) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`\n${JSON.stringify(itemHeaders)}\n`);
        if (typeof payload === "string" || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch (e) {
                // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.stringify()` still
                // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                // performance impact but in this case a performance hit is better than throwing.
                stringifiedPayload = JSON.stringify((0, $7c8e4381e2614efa$export$a3295358bff77e)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === "string" ? parts : $6c82efee51166966$var$concatBuffers(parts);
}
function $6c82efee51166966$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
/**
 * Parses an envelope
 */ function $6c82efee51166966$export$3338d0c7b6e17a2b(env) {
    let buffer = typeof env === "string" ? $6c82efee51166966$var$encodeUTF8(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse($6c82efee51166966$var$decodeUTF8(readBinary(i)));
    }
    const envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === "number" ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates envelope item for a single span
 */ function $6c82efee51166966$export$655cf139bc8b8afd(spanJson) {
    const spanHeaders = {
        type: "span"
    };
    return [
        spanHeaders,
        spanJson
    ];
}
/**
 * Creates attachment envelope items
 */ function $6c82efee51166966$export$d8fc80952cc31fa4(attachment) {
    const buffer = typeof attachment.data === "string" ? $6c82efee51166966$var$encodeUTF8(attachment.data) : attachment.data;
    return [
        {
            type: "attachment",
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        },
        buffer
    ];
}
const $6c82efee51166966$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
    session: "session",
    sessions: "session",
    attachment: "attachment",
    transaction: "transaction",
    event: "error",
    client_report: "internal",
    user_report: "default",
    profile: "profile",
    profile_chunk: "profile",
    replay_event: "replay",
    replay_recording: "replay",
    check_in: "monitor",
    feedback: "feedback",
    span: "span",
    raw_security: "security",
    log: "log_item"
};
/**
 * Maps the type of an envelope item to a data category.
 */ function $6c82efee51166966$export$b11169581eeaf237(type) {
    return $6c82efee51166966$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}
/** Extracts the minimal SDK info from the metadata or an events */ function $6c82efee51166966$export$d369f3b2758f6743(metadataOrEvent) {
    if (!metadataOrEvent?.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function $6c82efee51166966$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    const dynamicSamplingContext = event.sdkProcessingMetadata?.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $d29a90850bb2632c$export$44d472fbb931a776)(dsn)
        },
        ...dynamicSamplingContext && {
            trace: dynamicSamplingContext
        }
    };
}





/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $3289e4eecb423ee5$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = [
        ...event.sdk.integrations || [],
        ...sdkInfo.integrations || []
    ];
    event.sdk.packages = [
        ...event.sdk.packages || [],
        ...sdkInfo.packages || []
    ];
    return event;
}
/** Creates an envelope from a Session */ function $3289e4eecb423ee5$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $6c82efee51166966$export$d369f3b2758f6743)(metadata);
    const envelopeHeaders = {
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $d29a90850bb2632c$export$44d472fbb931a776)(dsn)
        }
    };
    const envelopeItem = "aggregates" in session ? [
        {
            type: "sessions"
        },
        session
    ] : [
        {
            type: "session"
        },
        session.toJSON()
    ];
    return (0, $6c82efee51166966$export$f93f7f385160c44e)(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function $3289e4eecb423ee5$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $6c82efee51166966$export$d369f3b2758f6743)(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjust a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ const eventType = event.type && event.type !== "replay_event" ? event.type : "event";
    $3289e4eecb423ee5$var$enhanceEventWithSdkInfo(event, metadata?.sdk);
    const envelopeHeaders = (0, $6c82efee51166966$export$92b6093782fe661b)(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $6c82efee51166966$export$f93f7f385160c44e)(envelopeHeaders, [
        eventItem
    ]);
}
/**
 * Create envelope from Span item.
 *
 * Takes an optional client and runs spans through `beforeSendSpan` if available.
 */ function $3289e4eecb423ee5$export$19a0081d4b39d77(spans, client) {
    function dscHasRequiredProps(dsc) {
        return !!dsc.trace_id && !!dsc.public_key;
    }
    // For the moment we'll obtain the DSC from the first span in the array
    // This might need to be changed if we permit sending multiple spans from
    // different segments in one envelope
    const dsc = (0, $a14190270949a626$export$a117f995597e25df)(spans[0]);
    const dsn = client?.getDsn();
    const tunnel = client?.getOptions().tunnel;
    const headers = {
        sent_at: new Date().toISOString(),
        ...dscHasRequiredProps(dsc) && {
            trace: dsc
        },
        ...!!tunnel && dsn && {
            dsn: (0, $d29a90850bb2632c$export$44d472fbb931a776)(dsn)
        }
    };
    const beforeSendSpan = client?.getOptions().beforeSendSpan;
    const convertToSpanJSON = beforeSendSpan ? (span)=>{
        const spanJson = (0, $eb63b022ee5d8903$export$92d8c23565496537)(span);
        const processedSpan = beforeSendSpan(spanJson);
        if (!processedSpan) {
            (0, $eb63b022ee5d8903$export$d11691ff45a3e535)();
            return spanJson;
        }
        return processedSpan;
    } : (0, $eb63b022ee5d8903$export$92d8c23565496537);
    const items = [];
    for (const span of spans){
        const spanJson = convertToSpanJSON(span);
        if (spanJson) items.push((0, $6c82efee51166966$export$655cf139bc8b8afd)(spanJson));
    }
    return (0, $6c82efee51166966$export$f93f7f385160c44e)(headers, items);
}













/**
 * Adds a measurement to the active transaction on the current global scope. You can optionally pass in a different span
 * as the 4th parameter.
 */ function $d334757dba6e7de3$export$7cc31b475d33a706(name, value, unit, activeSpan = (0, $eb63b022ee5d8903$export$1be426a8e585c83e)()) {
    const rootSpan = activeSpan && (0, $eb63b022ee5d8903$export$c4c6a79b1260ca1b)(activeSpan);
    if (rootSpan) {
        (0, $b2977c3b93d1398b$export$16a28057038b10ef) && (0, $70cc7a497c940a25$export$af88d00dbe7f521).log(`[Measurement] Setting measurement on root span: ${name} = ${value} ${unit}`);
        rootSpan.addEvent(name, {
            [(0, $6889f80b19c28299$export$69cd5c610c7bb96a)]: value,
            [(0, $6889f80b19c28299$export$f5f95cff026507b5)]: unit
        });
    }
}
/**
 * Convert timed events to measurements.
 */ function $d334757dba6e7de3$export$487db6fcdf36893e(events) {
    if (!events || events.length === 0) return undefined;
    const measurements = {};
    events.forEach((event)=>{
        const attributes = event.attributes || {};
        const unit = attributes[0, $6889f80b19c28299$export$f5f95cff026507b5];
        const value = attributes[0, $6889f80b19c28299$export$69cd5c610c7bb96a];
        if (typeof unit === "string" && typeof value === "number") measurements[event.name] = {
            value: value,
            unit: unit
        };
    });
    return measurements;
}



const $3bb92b0f5a1ec42d$var$MAX_SPAN_COUNT = 1000;
/**
 * Span contains all data about a span
 */ class $3bb92b0f5a1ec42d$export$a92149b045260d9f {
    /** Epoch timestamp in seconds when the span started. */ /** Epoch timestamp in seconds when the span ended. */ /** Internal keeper of the status */ /** The timed events added to this span. */ /** if true, treat span as a standalone span (not part of a transaction) */ /**
   * You should never call the constructor manually, always use `Sentry.startSpan()`
   * or other span methods.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $2b9195e12fc435e7$export$dc6d7ea554bcce10)();
        this._spanId = spanContext.spanId || (0, $2b9195e12fc435e7$export$295213bc4d0c54ad)();
        this._startTime = spanContext.startTimestamp || (0, $b83fbc460ca20326$export$ee52dced521e3e18)();
        this._links = spanContext.links;
        this._attributes = {};
        this.setAttributes({
            [(0, $6889f80b19c28299$export$cca8dd30f57f805e)]: "manual",
            [(0, $6889f80b19c28299$export$1a413bd9a88fdb09)]: spanContext.op,
            ...spanContext.attributes
        });
        this._name = spanContext.name;
        if (spanContext.parentSpanId) this._parentSpanId = spanContext.parentSpanId;
        // We want to include booleans as well here
        if ("sampled" in spanContext) this._sampled = spanContext.sampled;
        if (spanContext.endTimestamp) this._endTime = spanContext.endTimestamp;
        this._events = [];
        this._isStandaloneSpan = spanContext.isStandalone;
        // If the span is already ended, ensure we finalize the span immediately
        if (this._endTime) this._onSpanEnded();
    }
    /** @inheritDoc */ addLink(link) {
        if (this._links) this._links.push(link);
        else this._links = [
            link
        ];
        return this;
    }
    /** @inheritDoc */ addLinks(links) {
        if (this._links) this._links.push(...links);
        else this._links = links;
        return this;
    }
    /**
   * This should generally not be used,
   * but it is needed for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {
    // noop
    }
    /** @inheritdoc */ spanContext() {
        const { _spanId: spanId, _traceId: traceId, _sampled: sampled } = this;
        return {
            spanId: spanId,
            traceId: traceId,
            traceFlags: sampled ? (0, $eb63b022ee5d8903$export$eb571cd9b5d98de8) : (0, $eb63b022ee5d8903$export$208d5b368507fb8b)
        };
    }
    /** @inheritdoc */ setAttribute(key, value) {
        if (value === undefined) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._attributes[key];
        else this._attributes[key] = value;
        return this;
    }
    /** @inheritdoc */ setAttributes(attributes) {
        Object.keys(attributes).forEach((key)=>this.setAttribute(key, attributes[key]));
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for browser tracing where we want to adjust the start time afterwards.
   * USE THIS WITH CAUTION!
   *
   * @hidden
   * @internal
   */ updateStartTime(timeInput) {
        this._startTime = (0, $eb63b022ee5d8903$export$3f7581298f56c6d7)(timeInput);
    }
    /**
   * @inheritDoc
   */ setStatus(value) {
        this._status = value;
        return this;
    }
    /**
   * @inheritDoc
   */ updateName(name) {
        this._name = name;
        this.setAttribute((0, $6889f80b19c28299$export$d7a7d984b0791405), "custom");
        return this;
    }
    /** @inheritdoc */ end(endTimestamp) {
        // If already ended, skip
        if (this._endTime) return;
        this._endTime = (0, $eb63b022ee5d8903$export$3f7581298f56c6d7)(endTimestamp);
        (0, $1697b8f148de0a48$export$b77c830667a4d630)(this);
        this._onSpanEnded();
    }
    /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */ getSpanJSON() {
        return {
            data: this._attributes,
            description: this._name,
            op: this._attributes[0, $6889f80b19c28299$export$1a413bd9a88fdb09],
            parent_span_id: this._parentSpanId,
            span_id: this._spanId,
            start_timestamp: this._startTime,
            status: (0, $eb63b022ee5d8903$export$e238a77ea3a8cd66)(this._status),
            timestamp: this._endTime,
            trace_id: this._traceId,
            origin: this._attributes[0, $6889f80b19c28299$export$cca8dd30f57f805e],
            profile_id: this._attributes[0, $6889f80b19c28299$export$1efec95406bbe327],
            exclusive_time: this._attributes[0, $6889f80b19c28299$export$fea48ba9f4550879],
            measurements: (0, $d334757dba6e7de3$export$487db6fcdf36893e)(this._events),
            is_segment: this._isStandaloneSpan && (0, $eb63b022ee5d8903$export$c4c6a79b1260ca1b)(this) === this || undefined,
            segment_id: this._isStandaloneSpan ? (0, $eb63b022ee5d8903$export$c4c6a79b1260ca1b)(this).spanContext().spanId : undefined,
            links: (0, $eb63b022ee5d8903$export$cb3e3a12e0eec16c)(this._links)
        };
    }
    /** @inheritdoc */ isRecording() {
        return !this._endTime && !!this._sampled;
    }
    /**
   * @inheritdoc
   */ addEvent(name, attributesOrStartTime, startTime) {
        (0, $b2977c3b93d1398b$export$16a28057038b10ef) && (0, $70cc7a497c940a25$export$af88d00dbe7f521).log("[Tracing] Adding an event to span:", name);
        const time = $3bb92b0f5a1ec42d$var$isSpanTimeInput(attributesOrStartTime) ? attributesOrStartTime : startTime || (0, $b83fbc460ca20326$export$ee52dced521e3e18)();
        const attributes = $3bb92b0f5a1ec42d$var$isSpanTimeInput(attributesOrStartTime) ? {} : attributesOrStartTime || {};
        const event = {
            name: name,
            time: (0, $eb63b022ee5d8903$export$3f7581298f56c6d7)(time),
            attributes: attributes
        };
        this._events.push(event);
        return this;
    }
    /**
   * This method should generally not be used,
   * but for now we need a way to publicly check if the `_isStandaloneSpan` flag is set.
   * USE THIS WITH CAUTION!
   * @internal
   * @hidden
   * @experimental
   */ isStandaloneSpan() {
        return !!this._isStandaloneSpan;
    }
    /** Emit `spanEnd` when the span is ended. */ _onSpanEnded() {
        const client = (0, $ea3b8c0e772c7cc7$export$6bb76d6eba7e258c)();
        if (client) client.emit("spanEnd", this);
        // A segment span is basically the root span of a local span tree.
        // So for now, this is either what we previously refer to as the root span,
        // or a standalone span.
        const isSegmentSpan = this._isStandaloneSpan || this === (0, $eb63b022ee5d8903$export$c4c6a79b1260ca1b)(this);
        if (!isSegmentSpan) return;
        // if this is a standalone span, we send it immediately
        if (this._isStandaloneSpan) {
            if (this._sampled) $3bb92b0f5a1ec42d$var$sendSpanEnvelope((0, $3289e4eecb423ee5$export$19a0081d4b39d77)([
                this
            ], client));
            else {
                (0, $b2977c3b93d1398b$export$16a28057038b10ef) && (0, $70cc7a497c940a25$export$af88d00dbe7f521).log("[Tracing] Discarding standalone span because its trace was not chosen to be sampled.");
                if (client) client.recordDroppedEvent("sample_rate", "span");
            }
            return;
        }
        const transactionEvent = this._convertSpanToTransaction();
        if (transactionEvent) {
            const scope = (0, $29c340d100c49ff2$export$c08fbc656a245d03)(this).scope || (0, $ea3b8c0e772c7cc7$export$c7be4b0125a10cba)();
            scope.captureEvent(transactionEvent);
        }
    }
    /**
   * Finish the transaction & prepare the event to send to Sentry.
   */ _convertSpanToTransaction() {
        // We can only convert finished spans
        if (!$3bb92b0f5a1ec42d$var$isFullFinishedSpan((0, $eb63b022ee5d8903$export$92d8c23565496537)(this))) return undefined;
        if (!this._name) {
            (0, $b2977c3b93d1398b$export$16a28057038b10ef) && (0, $70cc7a497c940a25$export$af88d00dbe7f521).warn("Transaction has no name, falling back to `<unlabeled transaction>`.");
            this._name = "<unlabeled transaction>";
        }
        const { scope: capturedSpanScope, isolationScope: capturedSpanIsolationScope } = (0, $29c340d100c49ff2$export$c08fbc656a245d03)(this);
        const normalizedRequest = capturedSpanScope?.getScopeData().sdkProcessingMetadata?.normalizedRequest;
        if (this._sampled !== true) return undefined;
        // The transaction span itself as well as any potential standalone spans should be filtered out
        const finishedSpans = (0, $eb63b022ee5d8903$export$340c5c8a13ffc680)(this).filter((span)=>span !== this && !$3bb92b0f5a1ec42d$var$isStandaloneSpan(span));
        const spans = finishedSpans.map((span)=>(0, $eb63b022ee5d8903$export$92d8c23565496537)(span)).filter($3bb92b0f5a1ec42d$var$isFullFinishedSpan);
        const source = this._attributes[0, $6889f80b19c28299$export$d7a7d984b0791405];
        // remove internal root span attributes we don't need to send.
        /* eslint-disable @typescript-eslint/no-dynamic-delete */ delete this._attributes[0, $6889f80b19c28299$export$165ce9a229f6f050];
        spans.forEach((span)=>{
            delete span.data[0, $6889f80b19c28299$export$165ce9a229f6f050];
        });
        // eslint-enabled-next-line @typescript-eslint/no-dynamic-delete
        const transaction = {
            contexts: {
                trace: (0, $eb63b022ee5d8903$export$4c3967a8a2f6bbd6)(this)
            },
            spans: // spans.sort() mutates the array, but `spans` is already a copy so we can safely do this here
            // we do not use spans anymore after this point
            spans.length > $3bb92b0f5a1ec42d$var$MAX_SPAN_COUNT ? spans.sort((a, b)=>a.start_timestamp - b.start_timestamp).slice(0, $3bb92b0f5a1ec42d$var$MAX_SPAN_COUNT) : spans,
            start_timestamp: this._startTime,
            timestamp: this._endTime,
            transaction: this._name,
            type: "transaction",
            sdkProcessingMetadata: {
                capturedSpanScope: capturedSpanScope,
                capturedSpanIsolationScope: capturedSpanIsolationScope,
                dynamicSamplingContext: (0, $a14190270949a626$export$a117f995597e25df)(this)
            },
            request: normalizedRequest,
            ...source && {
                transaction_info: {
                    source: source
                }
            }
        };
        const measurements = (0, $d334757dba6e7de3$export$487db6fcdf36893e)(this._events);
        const hasMeasurements = measurements && Object.keys(measurements).length;
        if (hasMeasurements) {
            (0, $b2977c3b93d1398b$export$16a28057038b10ef) && (0, $70cc7a497c940a25$export$af88d00dbe7f521).log("[Measurements] Adding measurements to transaction event", JSON.stringify(measurements, undefined, 2));
            transaction.measurements = measurements;
        }
        return transaction;
    }
}
function $3bb92b0f5a1ec42d$var$isSpanTimeInput(value) {
    return value && typeof value === "number" || value instanceof Date || Array.isArray(value);
}
// We want to filter out any incomplete SpanJSON objects
function $3bb92b0f5a1ec42d$var$isFullFinishedSpan(input) {
    return !!input.start_timestamp && !!input.timestamp && !!input.span_id && !!input.trace_id;
}
/** `SentrySpan`s can be sent as a standalone span rather than belonging to a transaction */ function $3bb92b0f5a1ec42d$var$isStandaloneSpan(span) {
    return span instanceof $3bb92b0f5a1ec42d$export$a92149b045260d9f && span.isStandaloneSpan();
}
/**
 * Sends a `SpanEnvelope`.
 *
 * Note: If the envelope's spans are dropped, e.g. via `beforeSendSpan`,
 * the envelope will not be sent either.
 */ function $3bb92b0f5a1ec42d$var$sendSpanEnvelope(envelope) {
    const client = (0, $ea3b8c0e772c7cc7$export$6bb76d6eba7e258c)();
    if (!client) return;
    const spanItems = envelope[1];
    if (!spanItems || spanItems.length === 0) {
        client.recordDroppedEvent("before_send", "span");
        return;
    }
    // sendEnvelope should not throw
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    client.sendEnvelope(envelope);
}




/* eslint-disable max-lines */ const $854994e9df64e411$var$SUPPRESS_TRACING_KEY = "__SENTRY_SUPPRESS_TRACING__";
/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * If you want to create a span that is not set as active, use {@link startInactiveSpan}.
 *
 * You'll always get a span passed to the callback,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function $854994e9df64e411$export$a1bd95187356f372(options, callback) {
    const acs = $854994e9df64e411$var$getAcs();
    if (acs.startSpan) return acs.startSpan(options, callback);
    const spanArguments = $854994e9df64e411$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan, scope: customScope } = options;
    // We still need to fork a potentially passed scope, as we set the active span on it
    // and we need to ensure that it is cleaned up properly once the span ends.
    const customForkedScope = customScope?.clone();
    return (0, $ea3b8c0e772c7cc7$export$ec58d9285c204497)(customForkedScope, ()=>{
        // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
        const wrapper = $854994e9df64e411$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = (0, $ea3b8c0e772c7cc7$export$c7be4b0125a10cba)();
            const parentSpan = $854994e9df64e411$var$getParentSpan(scope);
            const shouldSkipSpan = options.onlyIfParent && !parentSpan;
            const activeSpan = shouldSkipSpan ? new (0, $f3522bc55eae07bc$export$d6636b700b76c516)() : $854994e9df64e411$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            (0, $4b940a7f4edc293b$export$3f25fa50c18e20ca)(scope, activeSpan);
            return (0, $8bf6ceaf67cc8cac$export$18ce21a8b7efd7e9)(()=>callback(activeSpan), ()=>{
                // Only update the span status if it hasn't been changed yet, and the span is not yet finished
                const { status: status } = (0, $eb63b022ee5d8903$export$92d8c23565496537)(activeSpan);
                if (activeSpan.isRecording() && (!status || status === "ok")) activeSpan.setStatus({
                    code: (0, $edd9cdaf250acb4e$export$f966a0446ece71e),
                    message: "internal_error"
                });
            }, ()=>{
                activeSpan.end();
            });
        });
    });
}
/**
 * Similar to `Sentry.startSpan`. Wraps a function with a transaction/span, but does not finish the span
 * after the function is done automatically. Use `span.end()` to end the span.
 *
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * You'll always get a span passed to the callback,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function $854994e9df64e411$export$c10292ad04b92aea(options, callback) {
    const acs = $854994e9df64e411$var$getAcs();
    if (acs.startSpanManual) return acs.startSpanManual(options, callback);
    const spanArguments = $854994e9df64e411$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan, scope: customScope } = options;
    const customForkedScope = customScope?.clone();
    return (0, $ea3b8c0e772c7cc7$export$ec58d9285c204497)(customForkedScope, ()=>{
        // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
        const wrapper = $854994e9df64e411$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = (0, $ea3b8c0e772c7cc7$export$c7be4b0125a10cba)();
            const parentSpan = $854994e9df64e411$var$getParentSpan(scope);
            const shouldSkipSpan = options.onlyIfParent && !parentSpan;
            const activeSpan = shouldSkipSpan ? new (0, $f3522bc55eae07bc$export$d6636b700b76c516)() : $854994e9df64e411$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            (0, $4b940a7f4edc293b$export$3f25fa50c18e20ca)(scope, activeSpan);
            return (0, $8bf6ceaf67cc8cac$export$18ce21a8b7efd7e9)(// We pass the `finish` function to the callback, so the user can finish the span manually
            // this is mainly here for historic purposes because previously, we instructed users to call
            // `finish` instead of `span.end()` to also clean up the scope. Nowadays, calling `span.end()`
            // or `finish` has the same effect and we simply leave it here to avoid breaking user code.
            ()=>callback(activeSpan, ()=>activeSpan.end()), ()=>{
                // Only update the span status if it hasn't been changed yet, and the span is not yet finished
                const { status: status } = (0, $eb63b022ee5d8903$export$92d8c23565496537)(activeSpan);
                if (activeSpan.isRecording() && (!status || status === "ok")) activeSpan.setStatus({
                    code: (0, $edd9cdaf250acb4e$export$f966a0446ece71e),
                    message: "internal_error"
                });
            });
        });
    });
}
/**
 * Creates a span. This span is not set as active, so will not get automatic instrumentation spans
 * as children or be able to be accessed via `Sentry.getActiveSpan()`.
 *
 * If you want to create a span that is set as active, use {@link startSpan}.
 *
 * This function will always return a span,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function $854994e9df64e411$export$63dbba021a6b4047(options) {
    const acs = $854994e9df64e411$var$getAcs();
    if (acs.startInactiveSpan) return acs.startInactiveSpan(options);
    const spanArguments = $854994e9df64e411$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan } = options;
    // If `options.scope` is defined, we use this as as a wrapper,
    // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
    const wrapper = options.scope ? (callback)=>(0, $ea3b8c0e772c7cc7$export$ec58d9285c204497)(options.scope, callback) : customParentSpan !== undefined ? (callback)=>$854994e9df64e411$export$e57ac09b143d92a2(customParentSpan, callback) : (callback)=>callback();
    return wrapper(()=>{
        const scope = (0, $ea3b8c0e772c7cc7$export$c7be4b0125a10cba)();
        const parentSpan = $854994e9df64e411$var$getParentSpan(scope);
        const shouldSkipSpan = options.onlyIfParent && !parentSpan;
        if (shouldSkipSpan) return new (0, $f3522bc55eae07bc$export$d6636b700b76c516)();
        return $854994e9df64e411$var$createChildOrRootSpan({
            parentSpan: parentSpan,
            spanArguments: spanArguments,
            forceTransaction: forceTransaction,
            scope: scope
        });
    });
}
/**
 * Continue a trace from `sentry-trace` and `baggage` values.
 * These values can be obtained from incoming request headers, or in the browser from `<meta name="sentry-trace">`
 * and `<meta name="baggage">` HTML tags.
 *
 * Spans started with `startSpan`, `startSpanManual` and `startInactiveSpan`, within the callback will automatically
 * be attached to the incoming trace.
 */ const $854994e9df64e411$export$d2ee9b39b25437b3 = (options, callback)=>{
    const carrier = (0, $b8e8a2c978e98d94$export$19eade501500c6c1)();
    const acs = (0, $8e7eca78891ba6de$export$f639b0c2752203be)(carrier);
    if (acs.continueTrace) return acs.continueTrace(options, callback);
    const { sentryTrace: sentryTrace, baggage: baggage } = options;
    return (0, $ea3b8c0e772c7cc7$export$ec58d9285c204497)((scope)=>{
        const propagationContext = (0, $cd34f4260dc55d51$export$261f383d16a93e39)(sentryTrace, baggage);
        scope.setPropagationContext(propagationContext);
        return callback();
    });
};
/**
 * Forks the current scope and sets the provided span as active span in the context of the provided callback. Can be
 * passed `null` to start an entirely new span tree.
 *
 * @param span Spans started in the context of the provided callback will be children of this span. If `null` is passed,
 * spans started within the callback will not be attached to a parent span.
 * @param callback Execution context in which the provided span will be active. Is passed the newly forked scope.
 * @returns the value returned from the provided callback function.
 */ function $854994e9df64e411$export$e57ac09b143d92a2(span, callback) {
    const acs = $854994e9df64e411$var$getAcs();
    if (acs.withActiveSpan) return acs.withActiveSpan(span, callback);
    return (0, $ea3b8c0e772c7cc7$export$ec58d9285c204497)((scope)=>{
        (0, $4b940a7f4edc293b$export$3f25fa50c18e20ca)(scope, span || undefined);
        return callback(scope);
    });
}
/** Suppress tracing in the given callback, ensuring no spans are generated inside of it. */ function $854994e9df64e411$export$869298f9835abc68(callback) {
    const acs = $854994e9df64e411$var$getAcs();
    if (acs.suppressTracing) return acs.suppressTracing(callback);
    return (0, $ea3b8c0e772c7cc7$export$ec58d9285c204497)((scope)=>{
        // Note: We do not wait for the callback to finish before we reset the metadata
        // the reason for this is that otherwise, in the browser this can lead to very weird behavior
        // as there is only a single top scope, if the callback takes longer to finish,
        // other, unrelated spans may also be suppressed, which we do not want
        // so instead, we only suppress tracing synchronoysly in the browser
        scope.setSDKProcessingMetadata({
            [$854994e9df64e411$var$SUPPRESS_TRACING_KEY]: true
        });
        const res = callback();
        scope.setSDKProcessingMetadata({
            [$854994e9df64e411$var$SUPPRESS_TRACING_KEY]: undefined
        });
        return res;
    });
}
/**
 * Starts a new trace for the duration of the provided callback. Spans started within the
 * callback will be part of the new trace instead of a potentially previously started trace.
 *
 * Important: Only use this function if you want to override the default trace lifetime and
 * propagation mechanism of the SDK for the duration and scope of the provided callback.
 * The newly created trace will also be the root of a new distributed trace, for example if
 * you make http requests within the callback.
 * This function might be useful if the operation you want to instrument should not be part
 * of a potentially ongoing trace.
 *
 * Default behavior:
 * - Server-side: A new trace is started for each incoming request.
 * - Browser: A new trace is started for each page our route. Navigating to a new route
 *            or page will automatically create a new trace.
 */ function $854994e9df64e411$export$f90b03291402f553(callback) {
    return (0, $ea3b8c0e772c7cc7$export$ec58d9285c204497)((scope)=>{
        scope.setPropagationContext({
            traceId: (0, $2b9195e12fc435e7$export$dc6d7ea554bcce10)(),
            sampleRand: Math.random()
        });
        (0, $b2977c3b93d1398b$export$16a28057038b10ef) && (0, $70cc7a497c940a25$export$af88d00dbe7f521).info(`Starting a new trace with id ${scope.getPropagationContext().traceId}`);
        return $854994e9df64e411$export$e57ac09b143d92a2(null, callback);
    });
}
function $854994e9df64e411$var$createChildOrRootSpan({ parentSpan: parentSpan, spanArguments: spanArguments, forceTransaction: forceTransaction, scope: scope }) {
    if (!(0, $f5f4e8ed7952f893$export$1f70765132c3c225)()) {
        const span = new (0, $f3522bc55eae07bc$export$d6636b700b76c516)();
        // If this is a root span, we ensure to freeze a DSC
        // So we can have at least partial data here
        if (forceTransaction || !parentSpan) {
            const dsc = {
                sampled: "false",
                sample_rate: "0",
                transaction: spanArguments.name,
                ...(0, $a14190270949a626$export$a117f995597e25df)(span)
            };
            (0, $a14190270949a626$export$7398c93e763ca9fd)(span, dsc);
        }
        return span;
    }
    const isolationScope = (0, $ea3b8c0e772c7cc7$export$68f3af03034c9e90)();
    let span;
    if (parentSpan && !forceTransaction) {
        span = $854994e9df64e411$var$_startChildSpan(parentSpan, scope, spanArguments);
        (0, $eb63b022ee5d8903$export$81397d924722cc65)(parentSpan, span);
    } else if (parentSpan) {
        // If we forced a transaction but have a parent span, make sure to continue from the parent span, not the scope
        const dsc = (0, $a14190270949a626$export$a117f995597e25df)(parentSpan);
        const { traceId: traceId, spanId: parentSpanId } = parentSpan.spanContext();
        const parentSampled = (0, $eb63b022ee5d8903$export$5caecac1caaf3a71)(parentSpan);
        span = $854994e9df64e411$var$_startRootSpan({
            traceId: traceId,
            parentSpanId: parentSpanId,
            ...spanArguments
        }, scope, parentSampled);
        (0, $a14190270949a626$export$7398c93e763ca9fd)(span, dsc);
    } else {
        const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: parentSampled } = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        span = $854994e9df64e411$var$_startRootSpan({
            traceId: traceId,
            parentSpanId: parentSpanId,
            ...spanArguments
        }, scope, parentSampled);
        if (dsc) (0, $a14190270949a626$export$7398c93e763ca9fd)(span, dsc);
    }
    (0, $1697b8f148de0a48$export$2f3d84e767c9592b)(span);
    (0, $29c340d100c49ff2$export$cddb4027e3b0dd66)(span, scope, isolationScope);
    return span;
}
/**
 * This converts StartSpanOptions to SentrySpanArguments.
 * For the most part (for now) we accept the same options,
 * but some of them need to be transformed.
 */ function $854994e9df64e411$var$parseSentrySpanArguments(options) {
    const exp = options.experimental || {};
    const initialCtx = {
        isStandalone: exp.standalone,
        ...options
    };
    if (options.startTime) {
        const ctx = {
            ...initialCtx
        };
        ctx.startTimestamp = (0, $eb63b022ee5d8903$export$3f7581298f56c6d7)(options.startTime);
        delete ctx.startTime;
        return ctx;
    }
    return initialCtx;
}
function $854994e9df64e411$var$getAcs() {
    const carrier = (0, $b8e8a2c978e98d94$export$19eade501500c6c1)();
    return (0, $8e7eca78891ba6de$export$f639b0c2752203be)(carrier);
}
function $854994e9df64e411$var$_startRootSpan(spanArguments, scope, parentSampled) {
    const client = (0, $ea3b8c0e772c7cc7$export$6bb76d6eba7e258c)();
    const options = client?.getOptions() || {};
    const { name: name = "" } = spanArguments;
    const mutableSpanSamplingData = {
        spanAttributes: {
            ...spanArguments.attributes
        },
        spanName: name,
        parentSampled: parentSampled
    };
    // we don't care about the decision for the moment; this is just a placeholder
    client?.emit("beforeSampling", mutableSpanSamplingData, {
        decision: false
    });
    // If hook consumers override the parentSampled flag, we will use that value instead of the actual one
    const finalParentSampled = mutableSpanSamplingData.parentSampled ?? parentSampled;
    const finalAttributes = mutableSpanSamplingData.spanAttributes;
    const currentPropagationContext = scope.getPropagationContext();
    const [sampled, sampleRate, localSampleRateWasApplied] = scope.getScopeData().sdkProcessingMetadata[$854994e9df64e411$var$SUPPRESS_TRACING_KEY] ? [
        false
    ] : (0, $f38d79859654667a$export$5f833db634b217bb)(options, {
        name: name,
        parentSampled: finalParentSampled,
        attributes: finalAttributes,
        parentSampleRate: (0, $d8d708bfa76dee9a$export$a5bd2d81656d9546)(currentPropagationContext.dsc?.sample_rate)
    }, currentPropagationContext.sampleRand);
    const rootSpan = new (0, $3bb92b0f5a1ec42d$export$a92149b045260d9f)({
        ...spanArguments,
        attributes: {
            [(0, $6889f80b19c28299$export$d7a7d984b0791405)]: "custom",
            [(0, $6889f80b19c28299$export$ccfe0a40627cc34b)]: sampleRate !== undefined && localSampleRateWasApplied ? sampleRate : undefined,
            ...finalAttributes
        },
        sampled: sampled
    });
    if (!sampled && client) {
        (0, $b2977c3b93d1398b$export$16a28057038b10ef) && (0, $70cc7a497c940a25$export$af88d00dbe7f521).log("[Tracing] Discarding root span because its trace was not chosen to be sampled.");
        client.recordDroppedEvent("sample_rate", "transaction");
    }
    if (client) client.emit("spanStart", rootSpan);
    return rootSpan;
}
/**
 * Creates a new `Span` while setting the current `Span.id` as `parentSpanId`.
 * This inherits the sampling decision from the parent span.
 */ function $854994e9df64e411$var$_startChildSpan(parentSpan, scope, spanArguments) {
    const { spanId: spanId, traceId: traceId } = parentSpan.spanContext();
    const sampled = scope.getScopeData().sdkProcessingMetadata[$854994e9df64e411$var$SUPPRESS_TRACING_KEY] ? false : (0, $eb63b022ee5d8903$export$5caecac1caaf3a71)(parentSpan);
    const childSpan = sampled ? new (0, $3bb92b0f5a1ec42d$export$a92149b045260d9f)({
        ...spanArguments,
        parentSpanId: spanId,
        traceId: traceId,
        sampled: sampled
    }) : new (0, $f3522bc55eae07bc$export$d6636b700b76c516)({
        traceId: traceId
    });
    (0, $eb63b022ee5d8903$export$81397d924722cc65)(parentSpan, childSpan);
    const client = (0, $ea3b8c0e772c7cc7$export$6bb76d6eba7e258c)();
    if (client) {
        client.emit("spanStart", childSpan);
        // If it has an endTimestamp, it's already ended
        if (spanArguments.endTimestamp) client.emit("spanEnd", childSpan);
    }
    return childSpan;
}
function $854994e9df64e411$var$getParentSpan(scope) {
    const span = (0, $4b940a7f4edc293b$export$91f063ebb8eff307)(scope);
    if (!span) return undefined;
    const client = (0, $ea3b8c0e772c7cc7$export$6bb76d6eba7e258c)();
    const options = client ? client.getOptions() : {};
    if (options.parentSpanIsAlwaysRootSpan) return (0, $eb63b022ee5d8903$export$c4c6a79b1260ca1b)(span);
    return span;
}
function $854994e9df64e411$var$getActiveSpanWrapper(parentSpan) {
    return parentSpan !== undefined ? (callback)=>{
        return $854994e9df64e411$export$e57ac09b143d92a2(parentSpan, callback);
    } : (callback)=>callback();
}



/**
 * Checks if a given value is a valid measurement value.
 */ function $32ec15e1edc55b14$export$27169ccae1b439e3(value) {
    return typeof value === "number" && isFinite(value);
}
/**
 * Helper function to start child on transactions. This function will make sure that the transaction will
 * use the start timestamp of the created child span if it is earlier than the transactions actual
 * start timestamp.
 */ function $32ec15e1edc55b14$export$7567a67bdb69a23d(parentSpan, startTimeInSeconds, endTime, { ...ctx }) {
    const parentStartTime = (0, $eb63b022ee5d8903$export$92d8c23565496537)(parentSpan).start_timestamp;
    if (parentStartTime && parentStartTime > startTimeInSeconds) // We can only do this for SentrySpans...
    {
        if (typeof parentSpan.updateStartTime === "function") parentSpan.updateStartTime(startTimeInSeconds);
    }
    // The return value only exists for tests
    return (0, $854994e9df64e411$export$e57ac09b143d92a2)(parentSpan, ()=>{
        const span = (0, $854994e9df64e411$export$63dbba021a6b4047)({
            startTime: startTimeInSeconds,
            ...ctx
        });
        if (span) span.end(endTime);
        return span;
    });
}
/**
 * Starts an inactive, standalone span used to send web vital values to Sentry.
 * DO NOT use this for arbitrary spans, as these spans require special handling
 * during ingestion to extract metrics.
 *
 * This function adds a bunch of attributes and data to the span that's shared
 * by all web vital standalone spans. However, you need to take care of adding
 * the actual web vital value as an event to the span. Also, you need to assign
 * a transaction name and some other values that are specific to the web vital.
 *
 * Ultimately, you also need to take care of ending the span to send it off.
 *
 * @param options
 *
 * @returns an inactive, standalone and NOT YET ended span
 */ function $32ec15e1edc55b14$export$b71b9c7b60c5a4aa(options) {
    const client = (0, $ea3b8c0e772c7cc7$export$6bb76d6eba7e258c)();
    if (!client) return;
    const { name: name, transaction: transaction, attributes: passedAttributes, startTime: startTime } = options;
    const { release: release, environment: environment, sendDefaultPii: sendDefaultPii } = client.getOptions();
    // We need to get the replay, user, and activeTransaction from the current scope
    // so that we can associate replay id, profile id, and a user display to the span
    const replay = client.getIntegrationByName("Replay");
    const replayId = replay?.getReplayId();
    const scope = (0, $ea3b8c0e772c7cc7$export$c7be4b0125a10cba)();
    const user = scope.getUser();
    const userDisplay = user !== undefined ? user.email || user.id || user.ip_address : undefined;
    let profileId;
    try {
        // @ts-expect-error skip optional chaining to save bundle size with try catch
        profileId = scope.getScopeData().contexts.profile.profile_id;
    } catch  {
    // do nothing
    }
    const attributes = {
        release: release,
        environment: environment,
        user: userDisplay || undefined,
        profile_id: profileId || undefined,
        replay_id: replayId || undefined,
        transaction: transaction,
        // Web vital score calculation relies on the user agent to account for different
        // browsers setting different thresholds for what is considered a good/meh/bad value.
        // For example: Chrome vs. Chrome Mobile
        "user_agent.original": (0, $40dc3e9cd8295a99$export$56d8a8a25bd48b81).navigator?.userAgent,
        // This tells Sentry to infer the IP address from the request
        "client.address": sendDefaultPii ? "{{auto}}" : undefined,
        ...passedAttributes
    };
    return (0, $854994e9df64e411$export$63dbba021a6b4047)({
        name: name,
        attributes: attributes,
        startTime: startTime,
        experimental: {
            standalone: true
        }
    });
}
/** Get the browser performance API. */ function $32ec15e1edc55b14$export$f72a13c439a30cab() {
    // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
    return (0, $40dc3e9cd8295a99$export$56d8a8a25bd48b81).addEventListener && (0, $40dc3e9cd8295a99$export$56d8a8a25bd48b81).performance;
}
/**
 * Converts from milliseconds to seconds
 * @param time time in ms
 */ function $32ec15e1edc55b14$export$b4785dbd4a81b33f(time) {
    return time / 1000;
}
/**
 * Converts ALPN protocol ids to name and version.
 *
 * (https://www.iana.org/assignments/tls-extensiontype-values/tls-extensiontype-values.xhtml#alpn-protocol-ids)
 * @param nextHopProtocol PerformanceResourceTiming.nextHopProtocol
 */ function $32ec15e1edc55b14$export$57c6f824442f9fe1(nextHopProtocol) {
    let name = "unknown";
    let version = "unknown";
    let _name = "";
    for (const char of nextHopProtocol){
        // http/1.1 etc.
        if (char === "/") {
            [name, version] = nextHopProtocol.split("/");
            break;
        }
        // h2, h3 etc.
        if (!isNaN(Number(char))) {
            name = _name === "h" ? "http" : _name;
            version = nextHopProtocol.split(_name)[1];
            break;
        }
        _name += char;
    }
    if (_name === nextHopProtocol) // webrtc, ftp, etc.
    name = _name;
    return {
        name: name,
        version: version
    };
}



/** Options for Request Instrumentation */ const $07fac35b67406f25$var$responseToSpanId = new WeakMap();
const $07fac35b67406f25$var$spanIdToEndTimestamp = new Map();
const $07fac35b67406f25$export$cc17fb3c0bc95cd7 = {
    traceFetch: true,
    traceXHR: true,
    enableHTTPTimings: true,
    trackFetchStreamPerformance: false
};
/** Registers span creators for xhr and fetch requests  */ function $07fac35b67406f25$export$864489cb3478db3e(client, _options) {
    const { traceFetch: traceFetch, traceXHR: traceXHR, trackFetchStreamPerformance: trackFetchStreamPerformance, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings, tracePropagationTargets: tracePropagationTargets, onRequestSpanStart: onRequestSpanStart } = {
        ...$07fac35b67406f25$export$cc17fb3c0bc95cd7,
        ..._options
    };
    const shouldCreateSpan = typeof shouldCreateSpanForRequest === "function" ? shouldCreateSpanForRequest : (_)=>true;
    const shouldAttachHeadersWithTargets = (url)=>$07fac35b67406f25$export$c260386ab3f0b3dd(url, tracePropagationTargets);
    const spans = {};
    if (traceFetch) {
        // Keeping track of http requests, whose body payloads resolved later than the initial resolved request
        // e.g. streaming using server sent events (SSE)
        client.addEventProcessor((event)=>{
            if (event.type === "transaction" && event.spans) event.spans.forEach((span)=>{
                if (span.op === "http.client") {
                    const updatedTimestamp = $07fac35b67406f25$var$spanIdToEndTimestamp.get(span.span_id);
                    if (updatedTimestamp) {
                        span.timestamp = updatedTimestamp / 1000;
                        $07fac35b67406f25$var$spanIdToEndTimestamp.delete(span.span_id);
                    }
                }
            });
            return event;
        });
        if (trackFetchStreamPerformance) (0, $1f5839cb68df003d$export$1a79663eb318fe6a)((handlerData)=>{
            if (handlerData.response) {
                const span = $07fac35b67406f25$var$responseToSpanId.get(handlerData.response);
                if (span && handlerData.endTimestamp) $07fac35b67406f25$var$spanIdToEndTimestamp.set(span, handlerData.endTimestamp);
            }
        });
        (0, $1f5839cb68df003d$export$f75d3c772c923df0)((handlerData)=>{
            const createdSpan = (0, $db739e1bf2511265$export$6d73c62358c655be)(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
            if (handlerData.response && handlerData.fetchData.__span) $07fac35b67406f25$var$responseToSpanId.set(handlerData.response, handlerData.fetchData.__span);
            // We cannot use `window.location` in the generic fetch instrumentation,
            // but we need it for reliable `server.address` attribute.
            // so we extend this in here
            if (createdSpan) {
                const fullUrl = $07fac35b67406f25$var$getFullURL(handlerData.fetchData.url);
                const host = fullUrl ? (0, $34321b3a3ce9dbbd$export$7a5253c0f62e0150)(fullUrl).host : undefined;
                createdSpan.setAttributes({
                    "http.url": fullUrl,
                    "server.address": host
                });
                if (enableHTTPTimings) $07fac35b67406f25$var$addHTTPTimings(createdSpan);
                onRequestSpanStart?.(createdSpan, {
                    headers: handlerData.headers
                });
            }
        });
    }
    if (traceXHR) (0, $932d70c5552b8c29$export$26ace48dd54c9aea)((handlerData)=>{
        const createdSpan = $07fac35b67406f25$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
        if (createdSpan) {
            if (enableHTTPTimings) $07fac35b67406f25$var$addHTTPTimings(createdSpan);
            let headers;
            try {
                headers = new Headers(handlerData.xhr.__sentry_xhr_v3__?.request_headers);
            } catch  {
            // noop
            }
            onRequestSpanStart?.(createdSpan, {
                headers: headers
            });
        }
    });
}
function $07fac35b67406f25$var$isPerformanceResourceTiming(entry) {
    return entry.entryType === "resource" && "initiatorType" in entry && typeof entry.nextHopProtocol === "string" && (entry.initiatorType === "fetch" || entry.initiatorType === "xmlhttprequest");
}
/**
 * Creates a temporary observer to listen to the next fetch/xhr resourcing timings,
 * so that when timings hit their per-browser limit they don't need to be removed.
 *
 * @param span A span that has yet to be finished, must contain `url` on data.
 */ function $07fac35b67406f25$var$addHTTPTimings(span) {
    const { url: url } = (0, $e89a3331adf677ac$export$92d8c23565496537)(span).data;
    if (!url || typeof url !== "string") return;
    const cleanup = (0, $52f106d2c2e0344c$export$69816c1a049f8db6)("resource", ({ entries: entries })=>{
        entries.forEach((entry)=>{
            if ($07fac35b67406f25$var$isPerformanceResourceTiming(entry) && entry.name.endsWith(url)) {
                const spanData = $07fac35b67406f25$var$resourceTimingEntryToSpanData(entry);
                spanData.forEach((data)=>span.setAttribute(...data));
                // In the next tick, clean this handler up
                // We have to wait here because otherwise this cleans itself up before it is fully done
                setTimeout(cleanup);
            }
        });
    });
}
function $07fac35b67406f25$var$getAbsoluteTime(time = 0) {
    return (((0, $14ccb306f78f15b4$export$baf075a948ffc0bf)() || performance.timeOrigin) + time) / 1000;
}
function $07fac35b67406f25$var$resourceTimingEntryToSpanData(resourceTiming) {
    const { name: name, version: version } = (0, $32ec15e1edc55b14$export$57c6f824442f9fe1)(resourceTiming.nextHopProtocol);
    const timingSpanData = [];
    timingSpanData.push([
        "network.protocol.version",
        version
    ], [
        "network.protocol.name",
        name
    ]);
    if (!(0, $14ccb306f78f15b4$export$baf075a948ffc0bf)()) return timingSpanData;
    return [
        ...timingSpanData,
        [
            "http.request.redirect_start",
            $07fac35b67406f25$var$getAbsoluteTime(resourceTiming.redirectStart)
        ],
        [
            "http.request.fetch_start",
            $07fac35b67406f25$var$getAbsoluteTime(resourceTiming.fetchStart)
        ],
        [
            "http.request.domain_lookup_start",
            $07fac35b67406f25$var$getAbsoluteTime(resourceTiming.domainLookupStart)
        ],
        [
            "http.request.domain_lookup_end",
            $07fac35b67406f25$var$getAbsoluteTime(resourceTiming.domainLookupEnd)
        ],
        [
            "http.request.connect_start",
            $07fac35b67406f25$var$getAbsoluteTime(resourceTiming.connectStart)
        ],
        [
            "http.request.secure_connection_start",
            $07fac35b67406f25$var$getAbsoluteTime(resourceTiming.secureConnectionStart)
        ],
        [
            "http.request.connection_end",
            $07fac35b67406f25$var$getAbsoluteTime(resourceTiming.connectEnd)
        ],
        [
            "http.request.request_start",
            $07fac35b67406f25$var$getAbsoluteTime(resourceTiming.requestStart)
        ],
        [
            "http.request.response_start",
            $07fac35b67406f25$var$getAbsoluteTime(resourceTiming.responseStart)
        ],
        [
            "http.request.response_end",
            $07fac35b67406f25$var$getAbsoluteTime(resourceTiming.responseEnd)
        ]
    ];
}
/**
 * A function that determines whether to attach tracing headers to a request.
 * We only export this function for testing purposes.
 */ function $07fac35b67406f25$export$c260386ab3f0b3dd(targetUrl, tracePropagationTargets) {
    // window.location.href not being defined is an edge case in the browser but we need to handle it.
    // Potentially dangerous situations where it may not be defined: Browser Extensions, Web Workers, patching of the location obj
    const href = (0, $8afcf0d9e9f8c38b$export$1cfafeee2987818b)();
    if (!href) {
        // If there is no window.location.origin, we default to only attaching tracing headers to relative requests, i.e. ones that start with `/`
        // BIG DISCLAIMER: Users can call URLs with a double slash (fetch("//example.com/api")), this is a shorthand for "send to the same protocol",
        // so we need a to exclude those requests, because they might be cross origin.
        const isRelativeSameOriginRequest = !!targetUrl.match(/^\/(?!\/)/);
        if (!tracePropagationTargets) return isRelativeSameOriginRequest;
        else return (0, $79b6b3761a352021$export$a7a5ec66062ea5d)(targetUrl, tracePropagationTargets);
    } else {
        let resolvedUrl;
        let currentOrigin;
        // URL parsing may fail, we default to not attaching trace headers in that case.
        try {
            resolvedUrl = new URL(targetUrl, href);
            currentOrigin = new URL(href).origin;
        } catch (e) {
            return false;
        }
        const isSameOriginRequest = resolvedUrl.origin === currentOrigin;
        if (!tracePropagationTargets) return isSameOriginRequest;
        else return (0, $79b6b3761a352021$export$a7a5ec66062ea5d)(resolvedUrl.toString(), tracePropagationTargets) || isSameOriginRequest && (0, $79b6b3761a352021$export$a7a5ec66062ea5d)(resolvedUrl.pathname, tracePropagationTargets);
    }
}
/**
 * Create and track xhr request spans
 *
 * @returns Span if a span was created, otherwise void.
 */ function $07fac35b67406f25$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeaders, spans) {
    const xhr = handlerData.xhr;
    const sentryXhrData = xhr?.[0, $932d70c5552b8c29$export$55b6bb1e45c6cf59];
    if (!xhr || xhr.__sentry_own_request__ || !sentryXhrData) return undefined;
    const { url: url, method: method } = sentryXhrData;
    const shouldCreateSpanResult = (0, $715af054d7b34c54$export$1f70765132c3c225)() && shouldCreateSpan(url);
    // check first if the request has finished and is tracked by an existing span which should now end
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        const spanId = xhr.__sentry_xhr_span_id__;
        if (!spanId) return;
        const span = spans[spanId];
        if (span && sentryXhrData.status_code !== undefined) {
            (0, $1c91772cf9c3fc39$export$2ad6630ec8164254)(span, sentryXhrData.status_code);
            span.end();
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    const fullUrl = $07fac35b67406f25$var$getFullURL(url);
    const parsedUrl = fullUrl ? (0, $34321b3a3ce9dbbd$export$7a5253c0f62e0150)(fullUrl) : (0, $34321b3a3ce9dbbd$export$7a5253c0f62e0150)(url);
    const urlForSpanName = (0, $34321b3a3ce9dbbd$export$ce084c78234bd35)(url);
    const hasParent = !!(0, $e89a3331adf677ac$export$1be426a8e585c83e)();
    const span = shouldCreateSpanResult && hasParent ? (0, $3bfe6b778935764d$export$63dbba021a6b4047)({
        name: `${method} ${urlForSpanName}`,
        attributes: {
            url: url,
            type: "xhr",
            "http.method": method,
            "http.url": fullUrl,
            "server.address": parsedUrl?.host,
            [(0, $34e3132ced11beec$export$cca8dd30f57f805e)]: "auto.http.browser",
            [(0, $34e3132ced11beec$export$1a413bd9a88fdb09)]: "http.client",
            ...parsedUrl?.search && {
                "http.query": parsedUrl?.search
            },
            ...parsedUrl?.hash && {
                "http.fragment": parsedUrl?.hash
            }
        }
    }) : new (0, $08d90c1dc724b4e2$export$d6636b700b76c516)();
    xhr.__sentry_xhr_span_id__ = span.spanContext().spanId;
    spans[xhr.__sentry_xhr_span_id__] = span;
    if (shouldAttachHeaders(url)) $07fac35b67406f25$var$addTracingHeadersToXhrRequest(xhr, // If performance is disabled (TWP) or there's no active root span (pageload/navigation/interaction),
    // we do not want to use the span as base for the trace headers,
    // which means that the headers will be generated from the scope and the sampling decision is deferred
    (0, $715af054d7b34c54$export$1f70765132c3c225)() && hasParent ? span : undefined);
    const client = (0, $0b98faa1b87c8168$export$6bb76d6eba7e258c)();
    if (client) client.emit("beforeOutgoingRequestSpan", span, handlerData);
    return span;
}
function $07fac35b67406f25$var$addTracingHeadersToXhrRequest(xhr, span) {
    const { "sentry-trace": sentryTrace, baggage: baggage } = (0, $9602e691d7587103$export$dec8f001b9d982cb)({
        span: span
    });
    if (sentryTrace) $07fac35b67406f25$var$setHeaderOnXhr(xhr, sentryTrace, baggage);
}
function $07fac35b67406f25$var$setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader) {
    const originalHeaders = xhr.__sentry_xhr_v3__?.request_headers;
    if (originalHeaders?.["sentry-trace"]) // bail if a sentry-trace header is already set
    return;
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xhr.setRequestHeader("sentry-trace", sentryTraceHeader);
        if (sentryBaggageHeader) {
            // only add our headers if
            // - no pre-existing baggage header exists
            // - or it is set and doesn't yet contain sentry values
            const originalBaggageHeader = originalHeaders?.["baggage"];
            if (!originalBaggageHeader || !$07fac35b67406f25$var$baggageHeaderHasSentryValues(originalBaggageHeader)) // From MDN: "If this method is called several times with the same header, the values are merged into one single request header."
            // We can therefore simply set a baggage header without checking what was there before
            // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/setRequestHeader
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            xhr.setRequestHeader("baggage", sentryBaggageHeader);
        }
    } catch (_) {
    // Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
    }
}
function $07fac35b67406f25$var$baggageHeaderHasSentryValues(baggageHeader) {
    return baggageHeader.split(",").some((value)=>value.trim().startsWith("sentry-"));
}
function $07fac35b67406f25$var$getFullURL(url) {
    try {
        // By adding a base URL to new URL(), this will also work for relative urls
        // If `url` is a full URL, the base URL is ignored anyhow
        const parsed = new URL(url, (0, $9c98becc1d3a3995$export$56d8a8a25bd48b81).location.origin);
        return parsed.href;
    } catch  {
        return undefined;
    }
}














const $66867db55b849e12$export$809a2b7987fd5306 = {
    idleTimeout: 1000,
    finalTimeout: 30000,
    childSpanTimeout: 15000
};
const $66867db55b849e12$var$FINISH_REASON_HEARTBEAT_FAILED = "heartbeatFailed";
const $66867db55b849e12$var$FINISH_REASON_IDLE_TIMEOUT = "idleTimeout";
const $66867db55b849e12$var$FINISH_REASON_FINAL_TIMEOUT = "finalTimeout";
const $66867db55b849e12$var$FINISH_REASON_EXTERNAL_FINISH = "externalFinish";
/**
 * An idle span is a span that automatically finishes. It does this by tracking child spans as activities.
 * An idle span is always the active span.
 */ function $66867db55b849e12$export$901bffd97bd52797(startSpanOptions, options = {}) {
    // Activities store a list of active spans
    const activities = new Map();
    // We should not use heartbeat if we finished a span
    let _finished = false;
    // Timer that tracks idleTimeout
    let _idleTimeoutID;
    // The reason why the span was finished
    let _finishReason = $66867db55b849e12$var$FINISH_REASON_EXTERNAL_FINISH;
    let _autoFinishAllowed = !options.disableAutoFinish;
    const _cleanupHooks = [];
    const { idleTimeout: idleTimeout = $66867db55b849e12$export$809a2b7987fd5306.idleTimeout, finalTimeout: finalTimeout = $66867db55b849e12$export$809a2b7987fd5306.finalTimeout, childSpanTimeout: childSpanTimeout = $66867db55b849e12$export$809a2b7987fd5306.childSpanTimeout, beforeSpanEnd: beforeSpanEnd } = options;
    const client = (0, $0b98faa1b87c8168$export$6bb76d6eba7e258c)();
    if (!client || !(0, $715af054d7b34c54$export$1f70765132c3c225)()) {
        const span = new (0, $08d90c1dc724b4e2$export$d6636b700b76c516)();
        const dsc = {
            sample_rate: "0",
            sampled: "false",
            ...(0, $d001bfa1cb8b2131$export$a117f995597e25df)(span)
        };
        (0, $d001bfa1cb8b2131$export$7398c93e763ca9fd)(span, dsc);
        return span;
    }
    const scope = (0, $0b98faa1b87c8168$export$c7be4b0125a10cba)();
    const previousActiveSpan = (0, $e89a3331adf677ac$export$1be426a8e585c83e)();
    const span = $66867db55b849e12$var$_startIdleSpan(startSpanOptions);
    // We patch span.end to ensure we can run some things before the span is ended
    // eslint-disable-next-line @typescript-eslint/unbound-method
    span.end = new Proxy(span.end, {
        apply (target, thisArg, args) {
            if (beforeSpanEnd) beforeSpanEnd(span);
            // If the span is non-recording, nothing more to do here...
            // This is the case if tracing is enabled but this specific span was not sampled
            if (thisArg instanceof (0, $08d90c1dc724b4e2$export$d6636b700b76c516)) return;
            // Just ensuring that this keeps working, even if we ever have more arguments here
            const [definedEndTimestamp, ...rest] = args;
            const timestamp = definedEndTimestamp || (0, $14ccb306f78f15b4$export$ee52dced521e3e18)();
            const spanEndTimestamp = (0, $e89a3331adf677ac$export$3f7581298f56c6d7)(timestamp);
            // Ensure we end with the last span timestamp, if possible
            const spans = (0, $e89a3331adf677ac$export$340c5c8a13ffc680)(span).filter((child)=>child !== span);
            // If we have no spans, we just end, nothing else to do here
            if (!spans.length) {
                onIdleSpanEnded(spanEndTimestamp);
                return Reflect.apply(target, thisArg, [
                    spanEndTimestamp,
                    ...rest
                ]);
            }
            const childEndTimestamps = spans.map((span)=>(0, $e89a3331adf677ac$export$92d8c23565496537)(span).timestamp).filter((timestamp)=>!!timestamp);
            const latestSpanEndTimestamp = childEndTimestamps.length ? Math.max(...childEndTimestamps) : undefined;
            // In reality this should always exist here, but type-wise it may be undefined...
            const spanStartTimestamp = (0, $e89a3331adf677ac$export$92d8c23565496537)(span).start_timestamp;
            // The final endTimestamp should:
            // * Never be before the span start timestamp
            // * Be the latestSpanEndTimestamp, if there is one, and it is smaller than the passed span end timestamp
            // * Otherwise be the passed end timestamp
            // Final timestamp can never be after finalTimeout
            const endTimestamp = Math.min(spanStartTimestamp ? spanStartTimestamp + finalTimeout / 1000 : Infinity, Math.max(spanStartTimestamp || -Infinity, Math.min(spanEndTimestamp, latestSpanEndTimestamp || Infinity)));
            onIdleSpanEnded(endTimestamp);
            return Reflect.apply(target, thisArg, [
                endTimestamp,
                ...rest
            ]);
        }
    });
    /**
   * Cancels the existing idle timeout, if there is one.
   */ function _cancelIdleTimeout() {
        if (_idleTimeoutID) {
            clearTimeout(_idleTimeoutID);
            _idleTimeoutID = undefined;
        }
    }
    /**
   * Restarts idle timeout, if there is no running idle timeout it will start one.
   */ function _restartIdleTimeout(endTimestamp) {
        _cancelIdleTimeout();
        _idleTimeoutID = setTimeout(()=>{
            if (!_finished && activities.size === 0 && _autoFinishAllowed) {
                _finishReason = $66867db55b849e12$var$FINISH_REASON_IDLE_TIMEOUT;
                span.end(endTimestamp);
            }
        }, idleTimeout);
    }
    /**
   * Restarts child span timeout, if there is none running it will start one.
   */ function _restartChildSpanTimeout(endTimestamp) {
        _idleTimeoutID = setTimeout(()=>{
            if (!_finished && _autoFinishAllowed) {
                _finishReason = $66867db55b849e12$var$FINISH_REASON_HEARTBEAT_FAILED;
                span.end(endTimestamp);
            }
        }, childSpanTimeout);
    }
    /**
   * Start tracking a specific activity.
   * @param spanId The span id that represents the activity
   */ function _pushActivity(spanId) {
        _cancelIdleTimeout();
        activities.set(spanId, true);
        const endTimestamp = (0, $14ccb306f78f15b4$export$ee52dced521e3e18)();
        // We need to add the timeout here to have the real endtimestamp of the idle span
        // Remember timestampInSeconds is in seconds, timeout is in ms
        _restartChildSpanTimeout(endTimestamp + childSpanTimeout / 1000);
    }
    /**
   * Remove an activity from usage
   * @param spanId The span id that represents the activity
   */ function _popActivity(spanId) {
        if (activities.has(spanId)) activities.delete(spanId);
        if (activities.size === 0) {
            const endTimestamp = (0, $14ccb306f78f15b4$export$ee52dced521e3e18)();
            // We need to add the timeout here to have the real endtimestamp of the idle span
            // Remember timestampInSeconds is in seconds, timeout is in ms
            _restartIdleTimeout(endTimestamp + idleTimeout / 1000);
        }
    }
    function onIdleSpanEnded(endTimestamp) {
        _finished = true;
        activities.clear();
        _cleanupHooks.forEach((cleanup)=>cleanup());
        (0, $946deb57ecfb47b9$export$3f25fa50c18e20ca)(scope, previousActiveSpan);
        const spanJSON = (0, $e89a3331adf677ac$export$92d8c23565496537)(span);
        const { start_timestamp: startTimestamp } = spanJSON;
        // This should never happen, but to make TS happy...
        if (!startTimestamp) return;
        const attributes = spanJSON.data;
        if (!attributes[0, $34e3132ced11beec$export$ba73f34502b7a3b3]) span.setAttribute((0, $34e3132ced11beec$export$ba73f34502b7a3b3), _finishReason);
        (0, $dfad86e498c52aee$export$af88d00dbe7f521).log(`[Tracing] Idle span "${spanJSON.op}" finished`);
        const childSpans = (0, $e89a3331adf677ac$export$340c5c8a13ffc680)(span).filter((child)=>child !== span);
        let discardedSpans = 0;
        childSpans.forEach((childSpan)=>{
            // We cancel all pending spans with status "cancelled" to indicate the idle span was finished early
            if (childSpan.isRecording()) {
                childSpan.setStatus({
                    code: (0, $1c91772cf9c3fc39$export$f966a0446ece71e),
                    message: "cancelled"
                });
                childSpan.end(endTimestamp);
                (0, $b5c0571e433473d8$export$16a28057038b10ef) && (0, $dfad86e498c52aee$export$af88d00dbe7f521).log("[Tracing] Cancelling span since span ended early", JSON.stringify(childSpan, undefined, 2));
            }
            const childSpanJSON = (0, $e89a3331adf677ac$export$92d8c23565496537)(childSpan);
            const { timestamp: childEndTimestamp = 0, start_timestamp: childStartTimestamp = 0 } = childSpanJSON;
            const spanStartedBeforeIdleSpanEnd = childStartTimestamp <= endTimestamp;
            // Add a delta with idle timeout so that we prevent false positives
            const timeoutWithMarginOfError = (finalTimeout + idleTimeout) / 1000;
            const spanEndedBeforeFinalTimeout = childEndTimestamp - childStartTimestamp <= timeoutWithMarginOfError;
            if (0, $b5c0571e433473d8$export$16a28057038b10ef) {
                const stringifiedSpan = JSON.stringify(childSpan, undefined, 2);
                if (!spanStartedBeforeIdleSpanEnd) (0, $dfad86e498c52aee$export$af88d00dbe7f521).log("[Tracing] Discarding span since it happened after idle span was finished", stringifiedSpan);
                else if (!spanEndedBeforeFinalTimeout) (0, $dfad86e498c52aee$export$af88d00dbe7f521).log("[Tracing] Discarding span since it finished after idle span final timeout", stringifiedSpan);
            }
            if (!spanEndedBeforeFinalTimeout || !spanStartedBeforeIdleSpanEnd) {
                (0, $e89a3331adf677ac$export$c2a0c9438bb89d91)(span, childSpan);
                discardedSpans++;
            }
        });
        if (discardedSpans > 0) span.setAttribute("sentry.idle_span_discarded_spans", discardedSpans);
    }
    _cleanupHooks.push(client.on("spanStart", (startedSpan)=>{
        // If we already finished the idle span,
        // or if this is the idle span itself being started,
        // or if the started span has already been closed,
        // we don't care about it for activity
        if (_finished || startedSpan === span || !!(0, $e89a3331adf677ac$export$92d8c23565496537)(startedSpan).timestamp) return;
        const allSpans = (0, $e89a3331adf677ac$export$340c5c8a13ffc680)(span);
        // If the span that was just started is a child of the idle span, we should track it
        if (allSpans.includes(startedSpan)) _pushActivity(startedSpan.spanContext().spanId);
    }));
    _cleanupHooks.push(client.on("spanEnd", (endedSpan)=>{
        if (_finished) return;
        _popActivity(endedSpan.spanContext().spanId);
    }));
    _cleanupHooks.push(client.on("idleSpanEnableAutoFinish", (spanToAllowAutoFinish)=>{
        if (spanToAllowAutoFinish === span) {
            _autoFinishAllowed = true;
            _restartIdleTimeout();
            if (activities.size) _restartChildSpanTimeout();
        }
    }));
    // We only start the initial idle timeout if we are not delaying the auto finish
    if (!options.disableAutoFinish) _restartIdleTimeout();
    setTimeout(()=>{
        if (!_finished) {
            span.setStatus({
                code: (0, $1c91772cf9c3fc39$export$f966a0446ece71e),
                message: "deadline_exceeded"
            });
            _finishReason = $66867db55b849e12$var$FINISH_REASON_FINAL_TIMEOUT;
            span.end();
        }
    }, finalTimeout);
    return span;
}
function $66867db55b849e12$var$_startIdleSpan(options) {
    const span = (0, $3bfe6b778935764d$export$63dbba021a6b4047)(options);
    (0, $946deb57ecfb47b9$export$3f25fa50c18e20ca)((0, $0b98faa1b87c8168$export$c7be4b0125a10cba)(), span);
    (0, $b5c0571e433473d8$export$16a28057038b10ef) && (0, $dfad86e498c52aee$export$af88d00dbe7f521).log("[Tracing] Started span is an idle span");
    return span;
}



// Curious about `thismessage:/`? See: https://www.rfc-editor.org/rfc/rfc2557.html
//  > When the methods above do not yield an absolute URI, a base URL
//  > of "thismessage:/" MUST be employed. This base URL has been
//  > defined for the sole purpose of resolving relative references
//  > within a multipart/related structure when no other base URI is
//  > specified.
//
// We need to provide a base URL to `parseStringToURLObject` because the fetch API gives us a
// relative URL sometimes.
//
// This is the only case where we need to provide a base URL to `parseStringToURLObject`
// because the relative URL is not valid on its own.
const $15224e026ce50451$var$DEFAULT_BASE_URL = "thismessage:/";
/**
 * Checks if the URL object is relative
 *
 * @param url - The URL object to check
 * @returns True if the URL object is relative, false otherwise
 */ function $15224e026ce50451$export$e258e13805402ba7(url) {
    return "isRelative" in url;
}
/**
 * Parses string to a URL object
 *
 * @param url - The URL to parse
 * @returns The parsed URL object or undefined if the URL is invalid
 */ function $15224e026ce50451$export$2004d912a9ead694(url, urlBase) {
    const isRelative = url.indexOf("://") <= 0 && url.indexOf("//") !== 0;
    const base = urlBase ?? (isRelative ? $15224e026ce50451$var$DEFAULT_BASE_URL : undefined);
    try {
        // Use `canParse` to short-circuit the URL constructor if it's not a valid URL
        // This is faster than trying to construct the URL and catching the error
        // Node 20+, Chrome 120+, Firefox 115+, Safari 17+
        if ("canParse" in URL && !URL.canParse(url, base)) return undefined;
        const fullUrlObject = new URL(url, base);
        if (isRelative) // Because we used a fake base URL, we need to return a relative URL object.
        // We cannot return anything about the origin, host, etc. because it will refer to the fake base URL.
        return {
            isRelative: isRelative,
            pathname: fullUrlObject.pathname,
            search: fullUrlObject.search,
            hash: fullUrlObject.hash
        };
        return fullUrlObject;
    } catch  {
    // empty body
    }
    return undefined;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span name
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $15224e026ce50451$export$5339fcdc8e2a427c(url) {
    if ($15224e026ce50451$export$e258e13805402ba7(url)) return url.pathname;
    const newUrl = new URL(url);
    newUrl.search = "";
    newUrl.hash = "";
    if ([
        "80",
        "443"
    ].includes(newUrl.port)) newUrl.port = "";
    if (newUrl.password) newUrl.password = "%filtered%";
    if (newUrl.username) newUrl.username = "%filtered%";
    return newUrl.toString();
}
function $15224e026ce50451$var$getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName) {
    const method = request?.method?.toUpperCase() ?? "GET";
    const route = routeName ? routeName : urlObject ? kind === "client" ? $15224e026ce50451$export$5339fcdc8e2a427c(urlObject) : urlObject.pathname : "/";
    return `${method} ${route}`;
}
/**
 * Takes a parsed URL object and returns a set of attributes for the span
 * that represents the HTTP request for that url. This is used for both server
 * and client http spans.
 *
 * Follows https://opentelemetry.io/docs/specs/semconv/http/.
 *
 * @param urlObject - see {@link parseStringToURLObject}
 * @param kind - The type of HTTP operation (server or client)
 * @param spanOrigin - The origin of the span
 * @param request - The request object, see {@link PartialRequest}
 * @param routeName - The name of the route, must be low cardinality
 * @returns The span name and attributes for the HTTP operation
 */ function $15224e026ce50451$export$c37a41544f3c180c(urlObject, kind, spanOrigin, request, routeName) {
    const attributes = {
        [(0, $6889f80b19c28299$export$cca8dd30f57f805e)]: spanOrigin,
        [(0, $6889f80b19c28299$export$d7a7d984b0791405)]: "url"
    };
    if (routeName) {
        // This is based on https://opentelemetry.io/docs/specs/semconv/http/http-spans/#name
        attributes[kind === "server" ? "http.route" : "url.template"] = routeName;
        attributes[0, $6889f80b19c28299$export$d7a7d984b0791405] = "route";
    }
    if (request?.method) attributes[0, $6889f80b19c28299$export$be7a251980e7e946] = request.method.toUpperCase();
    if (urlObject) {
        if (urlObject.search) attributes["url.query"] = urlObject.search;
        if (urlObject.hash) attributes["url.fragment"] = urlObject.hash;
        if (urlObject.pathname) {
            attributes["url.path"] = urlObject.pathname;
            if (urlObject.pathname === "/") attributes[0, $6889f80b19c28299$export$d7a7d984b0791405] = "route";
        }
        if (!$15224e026ce50451$export$e258e13805402ba7(urlObject)) {
            attributes[0, $6889f80b19c28299$export$25dfd73e0e32c6e1] = urlObject.href;
            if (urlObject.port) attributes["url.port"] = urlObject.port;
            if (urlObject.protocol) attributes["url.scheme"] = urlObject.protocol;
            if (urlObject.hostname) attributes[kind === "server" ? "server.address" : "url.domain"] = urlObject.hostname;
        }
    }
    return [
        $15224e026ce50451$var$getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName),
        attributes
    ];
}
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function $15224e026ce50451$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    const query = match[6] || "";
    const fragment = match[8] || "";
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function $15224e026ce50451$export$ce084c78234bd35(urlPath) {
    return urlPath.split(/[?#]/, 1)[0];
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span name
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $15224e026ce50451$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host?.replace(/^.*@/, "[filtered]:[filtered]@").replace(/(:80)$/, "").replace(/(:443)$/, "") || "";
    return `${protocol ? `${protocol}://` : ""}${filteredHost}${path}`;
}








/**
 * Starts tracking the Cumulative Layout Shift on the current page and collects the value once
 *
 * - the page visibility is hidden
 * - a navigation span is started (to stop CLS measurement for SPA soft navigations)
 *
 * Once either of these events triggers, the CLS value is sent as a standalone span and we stop
 * measuring CLS.
 */ function $710dfbeb8e55db08$export$585bab03c6c18c45() {
    let standaloneCLsValue = 0;
    let standaloneClsEntry;
    let pageloadSpanId;
    if (!$710dfbeb8e55db08$var$supportsLayoutShift()) return;
    let sentSpan = false;
    function _collectClsOnce() {
        if (sentSpan) return;
        sentSpan = true;
        if (pageloadSpanId) $710dfbeb8e55db08$var$sendStandaloneClsSpan(standaloneCLsValue, standaloneClsEntry, pageloadSpanId);
        cleanupClsHandler();
    }
    const cleanupClsHandler = (0, $52f106d2c2e0344c$export$861b82818b37ba5b)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        standaloneCLsValue = metric.value;
        standaloneClsEntry = entry;
    }, true);
    // TODO: Figure out if we can switch to using whenIdleOrHidden instead of onHidden
    // use pagehide event from web-vitals
    (0, $5e78ab7c1ebb2703$export$91ec2be6fdd8f1b4)(()=>{
        _collectClsOnce();
    });
    // Since the call chain of this function is synchronous and evaluates before the SDK client is created,
    // we need to wait with subscribing to a client hook until the client is created. Therefore, we defer
    // to the next tick after the SDK setup.
    setTimeout(()=>{
        const client = (0, $ea3b8c0e772c7cc7$export$6bb76d6eba7e258c)();
        if (!client) return;
        const unsubscribeStartNavigation = client.on("startNavigationSpan", ()=>{
            _collectClsOnce();
            unsubscribeStartNavigation?.();
        });
        const activeSpan = (0, $eb63b022ee5d8903$export$1be426a8e585c83e)();
        if (activeSpan) {
            const rootSpan = (0, $eb63b022ee5d8903$export$c4c6a79b1260ca1b)(activeSpan);
            const spanJSON = (0, $eb63b022ee5d8903$export$92d8c23565496537)(rootSpan);
            if (spanJSON.op === "pageload") pageloadSpanId = rootSpan.spanContext().spanId;
        }
    }, 0);
}
function $710dfbeb8e55db08$var$sendStandaloneClsSpan(clsValue, entry, pageloadSpanId) {
    (0, $40b62dc164a5f4e4$export$16a28057038b10ef) && (0, $70cc7a497c940a25$export$af88d00dbe7f521).log(`Sending CLS span (${clsValue})`);
    const startTime = (0, $32ec15e1edc55b14$export$b4785dbd4a81b33f)(((0, $b83fbc460ca20326$export$baf075a948ffc0bf)() || 0) + (entry?.startTime || 0));
    const routeName = (0, $ea3b8c0e772c7cc7$export$c7be4b0125a10cba)().getScopeData().transactionName;
    const name = entry ? (0, $1e36c764d0445908$export$5647df6b7814ac86)(entry.sources[0]?.node) : "Layout shift";
    const attributes = {
        [(0, $6889f80b19c28299$export$cca8dd30f57f805e)]: "auto.http.browser.cls",
        [(0, $6889f80b19c28299$export$1a413bd9a88fdb09)]: "ui.webvital.cls",
        [(0, $6889f80b19c28299$export$fea48ba9f4550879)]: entry?.duration || 0,
        // attach the pageload span id to the CLS span so that we can link them in the UI
        "sentry.pageload.span_id": pageloadSpanId
    };
    // Add CLS sources as span attributes to help with debugging layout shifts
    // See: https://developer.mozilla.org/en-US/docs/Web/API/LayoutShift/sources
    if (entry?.sources) entry.sources.forEach((source, index)=>{
        attributes[`cls.source.${index + 1}`] = (0, $1e36c764d0445908$export$5647df6b7814ac86)(source.node);
    });
    const span = (0, $32ec15e1edc55b14$export$b71b9c7b60c5a4aa)({
        name: name,
        transaction: routeName,
        attributes: attributes,
        startTime: startTime
    });
    if (span) {
        span.addEvent("cls", {
            [(0, $6889f80b19c28299$export$f5f95cff026507b5)]: "",
            [(0, $6889f80b19c28299$export$69cd5c610c7bb96a)]: clsValue
        });
        // LayoutShift performance entries always have a duration of 0, so we don't need to add `entry.duration` here
        // see: https://developer.mozilla.org/en-US/docs/Web/API/PerformanceEntry/duration
        span.end(startTime);
    }
}
function $710dfbeb8e55db08$var$supportsLayoutShift() {
    try {
        return PerformanceObserver.supportedEntryTypes.includes("layout-shift");
    } catch  {
        return false;
    }
}







const $381fec96980d61a7$var$MAX_INT_AS_BYTES = 2147483647;
let $381fec96980d61a7$var$_performanceCursor = 0;
let $381fec96980d61a7$var$_measurements = {};
let $381fec96980d61a7$var$_lcpEntry;
let $381fec96980d61a7$var$_clsEntry;
/**
 * Start tracking web vitals.
 * The callback returned by this function can be used to stop tracking & ensure all measurements are final & captured.
 *
 * @returns A function that forces web vitals collection
 */ function $381fec96980d61a7$export$7c69f0412d101b88({ recordClsStandaloneSpans: recordClsStandaloneSpans }) {
    const performance = (0, $32ec15e1edc55b14$export$f72a13c439a30cab)();
    if (performance && (0, $b83fbc460ca20326$export$baf075a948ffc0bf)()) {
        // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
        if (performance.mark) (0, $40dc3e9cd8295a99$export$56d8a8a25bd48b81).performance.mark("sentry-tracing-init");
        const fidCleanupCallback = $381fec96980d61a7$var$_trackFID();
        const lcpCleanupCallback = $381fec96980d61a7$var$_trackLCP();
        const ttfbCleanupCallback = $381fec96980d61a7$var$_trackTtfb();
        const clsCleanupCallback = recordClsStandaloneSpans ? (0, $710dfbeb8e55db08$export$585bab03c6c18c45)() : $381fec96980d61a7$var$_trackCLS();
        return ()=>{
            fidCleanupCallback();
            lcpCleanupCallback();
            ttfbCleanupCallback();
            clsCleanupCallback?.();
        };
    }
    return ()=>undefined;
}
/**
 * Start tracking long tasks.
 */ function $381fec96980d61a7$export$f396d19077034ad2() {
    (0, $52f106d2c2e0344c$export$69816c1a049f8db6)("longtask", ({ entries: entries })=>{
        const parent = (0, $eb63b022ee5d8903$export$1be426a8e585c83e)();
        if (!parent) return;
        const { op: parentOp, start_timestamp: parentStartTimestamp } = (0, $eb63b022ee5d8903$export$92d8c23565496537)(parent);
        for (const entry of entries){
            const startTime = (0, $32ec15e1edc55b14$export$b4785dbd4a81b33f)((0, $b83fbc460ca20326$export$baf075a948ffc0bf)() + entry.startTime);
            const duration = (0, $32ec15e1edc55b14$export$b4785dbd4a81b33f)(entry.duration);
            if (parentOp === "navigation" && parentStartTimestamp && startTime < parentStartTimestamp) continue;
            (0, $32ec15e1edc55b14$export$7567a67bdb69a23d)(parent, startTime, startTime + duration, {
                name: "Main UI thread blocked",
                op: "ui.long-task",
                attributes: {
                    [(0, $6889f80b19c28299$export$cca8dd30f57f805e)]: "auto.ui.browser.metrics"
                }
            });
        }
    });
}
/**
 * Start tracking long animation frames.
 */ function $381fec96980d61a7$export$5b823ab2ccbc801d() {
    // NOTE: the current web-vitals version (3.5.2) does not support long-animation-frame, so
    // we directly observe `long-animation-frame` events instead of through the web-vitals
    // `observe` helper function.
    const observer = new PerformanceObserver((list)=>{
        const parent = (0, $eb63b022ee5d8903$export$1be426a8e585c83e)();
        if (!parent) return;
        for (const entry of list.getEntries()){
            if (!entry.scripts[0]) continue;
            const startTime = (0, $32ec15e1edc55b14$export$b4785dbd4a81b33f)((0, $b83fbc460ca20326$export$baf075a948ffc0bf)() + entry.startTime);
            const { start_timestamp: parentStartTimestamp, op: parentOp } = (0, $eb63b022ee5d8903$export$92d8c23565496537)(parent);
            if (parentOp === "navigation" && parentStartTimestamp && startTime < parentStartTimestamp) continue;
            const duration = (0, $32ec15e1edc55b14$export$b4785dbd4a81b33f)(entry.duration);
            const attributes = {
                [(0, $6889f80b19c28299$export$cca8dd30f57f805e)]: "auto.ui.browser.metrics"
            };
            const initialScript = entry.scripts[0];
            const { invoker: invoker, invokerType: invokerType, sourceURL: sourceURL, sourceFunctionName: sourceFunctionName, sourceCharPosition: sourceCharPosition } = initialScript;
            attributes["browser.script.invoker"] = invoker;
            attributes["browser.script.invoker_type"] = invokerType;
            if (sourceURL) attributes["code.filepath"] = sourceURL;
            if (sourceFunctionName) attributes["code.function"] = sourceFunctionName;
            if (sourceCharPosition !== -1) attributes["browser.script.source_char_position"] = sourceCharPosition;
            (0, $32ec15e1edc55b14$export$7567a67bdb69a23d)(parent, startTime, startTime + duration, {
                name: "Main UI thread blocked",
                op: "ui.long-animation-frame",
                attributes: attributes
            });
        }
    });
    observer.observe({
        type: "long-animation-frame",
        buffered: true
    });
}
/**
 * Start tracking interaction events.
 */ function $381fec96980d61a7$export$e27543e0976315e4() {
    (0, $52f106d2c2e0344c$export$69816c1a049f8db6)("event", ({ entries: entries })=>{
        const parent = (0, $eb63b022ee5d8903$export$1be426a8e585c83e)();
        if (!parent) return;
        for (const entry of entries)if (entry.name === "click") {
            const startTime = (0, $32ec15e1edc55b14$export$b4785dbd4a81b33f)((0, $b83fbc460ca20326$export$baf075a948ffc0bf)() + entry.startTime);
            const duration = (0, $32ec15e1edc55b14$export$b4785dbd4a81b33f)(entry.duration);
            const spanOptions = {
                name: (0, $1e36c764d0445908$export$5647df6b7814ac86)(entry.target),
                op: `ui.interaction.${entry.name}`,
                startTime: startTime,
                attributes: {
                    [(0, $6889f80b19c28299$export$cca8dd30f57f805e)]: "auto.ui.browser.metrics"
                }
            };
            const componentName = (0, $1e36c764d0445908$export$26727cfcc4d7e0fc)(entry.target);
            if (componentName) spanOptions.attributes["ui.component_name"] = componentName;
            (0, $32ec15e1edc55b14$export$7567a67bdb69a23d)(parent, startTime, startTime + duration, spanOptions);
        }
    });
}
/**
 * Starts tracking the Cumulative Layout Shift on the current page and collects the value and last entry
 * to the `_measurements` object which ultimately is applied to the pageload span's measurements.
 */ function $381fec96980d61a7$var$_trackCLS() {
    return (0, $52f106d2c2e0344c$export$861b82818b37ba5b)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        $381fec96980d61a7$var$_measurements["cls"] = {
            value: metric.value,
            unit: ""
        };
        $381fec96980d61a7$var$_clsEntry = entry;
    }, true);
}
/** Starts tracking the Largest Contentful Paint on the current page. */ function $381fec96980d61a7$var$_trackLCP() {
    return (0, $52f106d2c2e0344c$export$3fd4b53331200102)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        $381fec96980d61a7$var$_measurements["lcp"] = {
            value: metric.value,
            unit: "millisecond"
        };
        $381fec96980d61a7$var$_lcpEntry = entry;
    }, true);
}
/** Starts tracking the First Input Delay on the current page. */ function $381fec96980d61a7$var$_trackFID() {
    return (0, $52f106d2c2e0344c$export$2707d7471c0b918f)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        const timeOrigin = (0, $32ec15e1edc55b14$export$b4785dbd4a81b33f)((0, $b83fbc460ca20326$export$baf075a948ffc0bf)());
        const startTime = (0, $32ec15e1edc55b14$export$b4785dbd4a81b33f)(entry.startTime);
        $381fec96980d61a7$var$_measurements["fid"] = {
            value: metric.value,
            unit: "millisecond"
        };
        $381fec96980d61a7$var$_measurements["mark.fid"] = {
            value: timeOrigin + startTime,
            unit: "second"
        };
    });
}
function $381fec96980d61a7$var$_trackTtfb() {
    return (0, $52f106d2c2e0344c$export$699d9529c099a797)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        $381fec96980d61a7$var$_measurements["ttfb"] = {
            value: metric.value,
            unit: "millisecond"
        };
    });
}
/** Add performance related spans to a transaction */ function $381fec96980d61a7$export$5f8fa6b3467a7443(span, options) {
    const performance = (0, $32ec15e1edc55b14$export$f72a13c439a30cab)();
    const origin = (0, $b83fbc460ca20326$export$baf075a948ffc0bf)();
    if (!performance?.getEntries || !origin) // Gatekeeper if performance API not available
    return;
    const timeOrigin = (0, $32ec15e1edc55b14$export$b4785dbd4a81b33f)(origin);
    const performanceEntries = performance.getEntries();
    const { op: op, start_timestamp: transactionStartTime } = (0, $eb63b022ee5d8903$export$92d8c23565496537)(span);
    performanceEntries.slice($381fec96980d61a7$var$_performanceCursor).forEach((entry)=>{
        const startTime = (0, $32ec15e1edc55b14$export$b4785dbd4a81b33f)(entry.startTime);
        const duration = (0, $32ec15e1edc55b14$export$b4785dbd4a81b33f)(// Inexplicably, Chrome sometimes emits a negative duration. We need to work around this.
        // There is a SO post attempting to explain this, but it leaves one with open questions: https://stackoverflow.com/questions/23191918/peformance-getentries-and-negative-duration-display
        // The way we clamp the value is probably not accurate, since we have observed this happen for things that may take a while to load, like for example the replay worker.
        // TODO: Investigate why this happens and how to properly mitigate. For now, this is a workaround to prevent transactions being dropped due to negative duration spans.
        Math.max(0, entry.duration));
        if (op === "navigation" && transactionStartTime && timeOrigin + startTime < transactionStartTime) return;
        switch(entry.entryType){
            case "navigation":
                $381fec96980d61a7$export$90a8fd571ed9a1bc(span, entry, timeOrigin);
                break;
            case "mark":
            case "paint":
            case "measure":
                {
                    $381fec96980d61a7$export$bc93b84e4d45912d(span, entry, startTime, duration, timeOrigin, options.ignorePerformanceApiSpans);
                    // capture web vitals
                    const firstHidden = (0, $113b85067c2fe4f7$export$443f86b2c77012c4)();
                    // Only report if the page wasn't hidden prior to the web vital.
                    const shouldRecord = entry.startTime < firstHidden.firstHiddenTime;
                    if (entry.name === "first-paint" && shouldRecord) $381fec96980d61a7$var$_measurements["fp"] = {
                        value: entry.startTime,
                        unit: "millisecond"
                    };
                    if (entry.name === "first-contentful-paint" && shouldRecord) $381fec96980d61a7$var$_measurements["fcp"] = {
                        value: entry.startTime,
                        unit: "millisecond"
                    };
                    break;
                }
            case "resource":
                $381fec96980d61a7$export$c82fe1a70634f317(span, entry, entry.name, startTime, duration, timeOrigin, options.ignoreResourceSpans);
                break;
        }
    });
    $381fec96980d61a7$var$_performanceCursor = Math.max(performanceEntries.length - 1, 0);
    $381fec96980d61a7$var$_trackNavigator(span);
    // Measurements are only available for pageload transactions
    if (op === "pageload") {
        $381fec96980d61a7$var$_addTtfbRequestTimeToMeasurements($381fec96980d61a7$var$_measurements);
        const fidMark = $381fec96980d61a7$var$_measurements["mark.fid"];
        if (fidMark && $381fec96980d61a7$var$_measurements["fid"]) {
            // create span for FID
            (0, $32ec15e1edc55b14$export$7567a67bdb69a23d)(span, fidMark.value, fidMark.value + (0, $32ec15e1edc55b14$export$b4785dbd4a81b33f)($381fec96980d61a7$var$_measurements["fid"].value), {
                name: "first input delay",
                op: "ui.action",
                attributes: {
                    [(0, $6889f80b19c28299$export$cca8dd30f57f805e)]: "auto.ui.browser.metrics"
                }
            });
            // Delete mark.fid as we don't want it to be part of final payload
            delete $381fec96980d61a7$var$_measurements["mark.fid"];
        }
        // If FCP is not recorded we should not record the cls value
        // according to the new definition of CLS.
        // TODO: Check if the first condition is still necessary: `onCLS` already only fires once `onFCP` was called.
        if (!("fcp" in $381fec96980d61a7$var$_measurements) || !options.recordClsOnPageloadSpan) delete $381fec96980d61a7$var$_measurements.cls;
        Object.entries($381fec96980d61a7$var$_measurements).forEach(([measurementName, measurement])=>{
            (0, $d334757dba6e7de3$export$7cc31b475d33a706)(measurementName, measurement.value, measurement.unit);
        });
        // Set timeOrigin which denotes the timestamp which to base the LCP/FCP/FP/TTFB measurements on
        span.setAttribute("performance.timeOrigin", timeOrigin);
        // In prerendering scenarios, where a page might be prefetched and pre-rendered before the user clicks the link,
        // the navigation starts earlier than when the user clicks it. Web Vitals should always be based on the
        // user-perceived time, so they are not reported from the actual start of the navigation, but rather from the
        // time where the user actively started the navigation, for example by clicking a link.
        // This is user action is called "activation" and the time between navigation and activation is stored in
        // the `activationStart` attribute of the "navigation" PerformanceEntry.
        span.setAttribute("performance.activationStart", (0, $37e15f2d09cb930e$export$d3e828b3c7b5b845)());
        $381fec96980d61a7$var$_setWebVitalAttributes(span);
    }
    $381fec96980d61a7$var$_lcpEntry = undefined;
    $381fec96980d61a7$var$_clsEntry = undefined;
    $381fec96980d61a7$var$_measurements = {};
}
/**
 * Create measure related spans.
 * Exported only for tests.
 */ function $381fec96980d61a7$export$bc93b84e4d45912d(span, entry, startTime, duration, timeOrigin, ignorePerformanceApiSpans) {
    if ([
        "mark",
        "measure"
    ].includes(entry.entryType) && (0, $ac71f3aed2307965$export$a7a5ec66062ea5d)(entry.name, ignorePerformanceApiSpans)) return;
    const navEntry = (0, $093b1175f041d1f7$export$6431553786c94949)(false);
    const requestTime = (0, $32ec15e1edc55b14$export$b4785dbd4a81b33f)(navEntry ? navEntry.requestStart : 0);
    // Because performance.measure accepts arbitrary timestamps it can produce
    // spans that happen before the browser even makes a request for the page.
    //
    // An example of this is the automatically generated Next.js-before-hydration
    // spans created by the Next.js framework.
    //
    // To prevent this we will pin the start timestamp to the request start time
    // This does make duration inaccurate, so if this does happen, we will add
    // an attribute to the span
    const measureStartTimestamp = timeOrigin + Math.max(startTime, requestTime);
    const startTimeStamp = timeOrigin + startTime;
    const measureEndTimestamp = startTimeStamp + duration;
    const attributes = {
        [(0, $6889f80b19c28299$export$cca8dd30f57f805e)]: "auto.resource.browser.metrics"
    };
    if (measureStartTimestamp !== startTimeStamp) {
        attributes["sentry.browser.measure_happened_before_request"] = true;
        attributes["sentry.browser.measure_start_time"] = measureStartTimestamp;
    }
    $381fec96980d61a7$var$_addDetailToSpanAttributes(attributes, entry);
    // Measurements from third parties can be off, which would create invalid spans, dropping transactions in the process.
    if (measureStartTimestamp <= measureEndTimestamp) (0, $32ec15e1edc55b14$export$7567a67bdb69a23d)(span, measureStartTimestamp, measureEndTimestamp, {
        name: entry.name,
        op: entry.entryType,
        attributes: attributes
    });
}
function $381fec96980d61a7$var$_addDetailToSpanAttributes(attributes, performanceMeasure) {
    try {
        // Accessing detail might throw in some browsers (e.g., Firefox) due to security restrictions
        const detail = performanceMeasure.detail;
        if (!detail) return;
        // Process detail based on its type
        if (typeof detail === "object") {
            // Handle object details
            for (const [key, value] of Object.entries(detail)){
                if (value && (0, $4541e6bae1c3cae8$export$c3825b437cbdea5c)(value)) attributes[`sentry.browser.measure.detail.${key}`] = value;
                else if (value !== undefined) try {
                    // This is user defined so we can't guarantee it's serializable
                    attributes[`sentry.browser.measure.detail.${key}`] = JSON.stringify(value);
                } catch  {
                // Skip values that can't be stringified
                }
            }
            return;
        }
        if ((0, $4541e6bae1c3cae8$export$c3825b437cbdea5c)(detail)) {
            // Handle primitive details
            attributes["sentry.browser.measure.detail"] = detail;
            return;
        }
        try {
            attributes["sentry.browser.measure.detail"] = JSON.stringify(detail);
        } catch  {
        // Skip if stringification fails
        }
    } catch  {
    // Silently ignore any errors when accessing detail
    // This handles the Firefox "Permission denied to access object" error
    }
}
/**
 * Instrument navigation entries
 * exported only for tests
 */ function $381fec96980d61a7$export$90a8fd571ed9a1bc(span, entry, timeOrigin) {
    [
        "unloadEvent",
        "redirect",
        "domContentLoadedEvent",
        "loadEvent",
        "connect"
    ].forEach((event)=>{
        $381fec96980d61a7$var$_addPerformanceNavigationTiming(span, entry, event, timeOrigin);
    });
    $381fec96980d61a7$var$_addPerformanceNavigationTiming(span, entry, "secureConnection", timeOrigin, "TLS/SSL");
    $381fec96980d61a7$var$_addPerformanceNavigationTiming(span, entry, "fetch", timeOrigin, "cache");
    $381fec96980d61a7$var$_addPerformanceNavigationTiming(span, entry, "domainLookup", timeOrigin, "DNS");
    $381fec96980d61a7$var$_addRequest(span, entry, timeOrigin);
}
/** Create performance navigation related spans */ function $381fec96980d61a7$var$_addPerformanceNavigationTiming(span, entry, event, timeOrigin, name = event) {
    const eventEnd = $381fec96980d61a7$var$_getEndPropertyNameForNavigationTiming(event);
    const end = entry[eventEnd];
    const start = entry[`${event}Start`];
    if (!start || !end) return;
    (0, $32ec15e1edc55b14$export$7567a67bdb69a23d)(span, timeOrigin + (0, $32ec15e1edc55b14$export$b4785dbd4a81b33f)(start), timeOrigin + (0, $32ec15e1edc55b14$export$b4785dbd4a81b33f)(end), {
        op: `browser.${name}`,
        name: entry.name,
        attributes: {
            [(0, $6889f80b19c28299$export$cca8dd30f57f805e)]: "auto.ui.browser.metrics",
            ...event === "redirect" && entry.redirectCount != null ? {
                "http.redirect_count": entry.redirectCount
            } : {}
        }
    });
}
function $381fec96980d61a7$var$_getEndPropertyNameForNavigationTiming(event) {
    if (event === "secureConnection") return "connectEnd";
    if (event === "fetch") return "domainLookupStart";
    return `${event}End`;
}
/** Create request and response related spans */ function $381fec96980d61a7$var$_addRequest(span, entry, timeOrigin) {
    const requestStartTimestamp = timeOrigin + (0, $32ec15e1edc55b14$export$b4785dbd4a81b33f)(entry.requestStart);
    const responseEndTimestamp = timeOrigin + (0, $32ec15e1edc55b14$export$b4785dbd4a81b33f)(entry.responseEnd);
    const responseStartTimestamp = timeOrigin + (0, $32ec15e1edc55b14$export$b4785dbd4a81b33f)(entry.responseStart);
    if (entry.responseEnd) {
        // It is possible that we are collecting these metrics when the page hasn't finished loading yet, for example when the HTML slowly streams in.
        // In this case, ie. when the document request hasn't finished yet, `entry.responseEnd` will be 0.
        // In order not to produce faulty spans, where the end timestamp is before the start timestamp, we will only collect
        // these spans when the responseEnd value is available. The backend (Relay) would drop the entire span if it contained faulty spans.
        (0, $32ec15e1edc55b14$export$7567a67bdb69a23d)(span, requestStartTimestamp, responseEndTimestamp, {
            op: "browser.request",
            name: entry.name,
            attributes: {
                [(0, $6889f80b19c28299$export$cca8dd30f57f805e)]: "auto.ui.browser.metrics"
            }
        });
        (0, $32ec15e1edc55b14$export$7567a67bdb69a23d)(span, responseStartTimestamp, responseEndTimestamp, {
            op: "browser.response",
            name: entry.name,
            attributes: {
                [(0, $6889f80b19c28299$export$cca8dd30f57f805e)]: "auto.ui.browser.metrics"
            }
        });
    }
}
/**
 * Create resource-related spans.
 * Exported only for tests.
 */ function $381fec96980d61a7$export$c82fe1a70634f317(span, entry, resourceUrl, startTime, duration, timeOrigin, ignoreResourceSpans) {
    // we already instrument based on fetch and xhr, so we don't need to
    // duplicate spans here.
    if (entry.initiatorType === "xmlhttprequest" || entry.initiatorType === "fetch") return;
    const op = entry.initiatorType ? `resource.${entry.initiatorType}` : "resource.other";
    if (ignoreResourceSpans?.includes(op)) return;
    const parsedUrl = (0, $15224e026ce50451$export$7a5253c0f62e0150)(resourceUrl);
    const attributes = {
        [(0, $6889f80b19c28299$export$cca8dd30f57f805e)]: "auto.resource.browser.metrics"
    };
    $381fec96980d61a7$var$setResourceEntrySizeData(attributes, entry, "transferSize", "http.response_transfer_size");
    $381fec96980d61a7$var$setResourceEntrySizeData(attributes, entry, "encodedBodySize", "http.response_content_length");
    $381fec96980d61a7$var$setResourceEntrySizeData(attributes, entry, "decodedBodySize", "http.decoded_response_content_length");
    // `deliveryType` is experimental and does not exist everywhere
    const deliveryType = entry.deliveryType;
    if (deliveryType != null) attributes["http.response_delivery_type"] = deliveryType;
    // Types do not reflect this property yet
    const renderBlockingStatus = entry.renderBlockingStatus;
    if (renderBlockingStatus) attributes["resource.render_blocking_status"] = renderBlockingStatus;
    if (parsedUrl.protocol) attributes["url.scheme"] = parsedUrl.protocol.split(":").pop(); // the protocol returned by parseUrl includes a :, but OTEL spec does not, so we remove it.
    if (parsedUrl.host) attributes["server.address"] = parsedUrl.host;
    attributes["url.same_origin"] = resourceUrl.includes((0, $40dc3e9cd8295a99$export$56d8a8a25bd48b81).location.origin);
    const { name: name, version: version } = (0, $32ec15e1edc55b14$export$57c6f824442f9fe1)(entry.nextHopProtocol);
    attributes["network.protocol.name"] = name;
    attributes["network.protocol.version"] = version;
    const startTimestamp = timeOrigin + startTime;
    const endTimestamp = startTimestamp + duration;
    (0, $32ec15e1edc55b14$export$7567a67bdb69a23d)(span, startTimestamp, endTimestamp, {
        name: resourceUrl.replace((0, $40dc3e9cd8295a99$export$56d8a8a25bd48b81).location.origin, ""),
        op: op,
        attributes: attributes
    });
}
/**
 * Capture the information of the user agent.
 */ function $381fec96980d61a7$var$_trackNavigator(span) {
    const navigator = (0, $40dc3e9cd8295a99$export$56d8a8a25bd48b81).navigator;
    if (!navigator) return;
    // track network connectivity
    const connection = navigator.connection;
    if (connection) {
        if (connection.effectiveType) span.setAttribute("effectiveConnectionType", connection.effectiveType);
        if (connection.type) span.setAttribute("connectionType", connection.type);
        if ((0, $32ec15e1edc55b14$export$27169ccae1b439e3)(connection.rtt)) $381fec96980d61a7$var$_measurements["connection.rtt"] = {
            value: connection.rtt,
            unit: "millisecond"
        };
    }
    if ((0, $32ec15e1edc55b14$export$27169ccae1b439e3)(navigator.deviceMemory)) span.setAttribute("deviceMemory", `${navigator.deviceMemory} GB`);
    if ((0, $32ec15e1edc55b14$export$27169ccae1b439e3)(navigator.hardwareConcurrency)) span.setAttribute("hardwareConcurrency", String(navigator.hardwareConcurrency));
}
/** Add LCP / CLS data to span to allow debugging */ function $381fec96980d61a7$var$_setWebVitalAttributes(span) {
    if ($381fec96980d61a7$var$_lcpEntry) {
        // Capture Properties of the LCP element that contributes to the LCP.
        if ($381fec96980d61a7$var$_lcpEntry.element) span.setAttribute("lcp.element", (0, $1e36c764d0445908$export$5647df6b7814ac86)($381fec96980d61a7$var$_lcpEntry.element));
        if ($381fec96980d61a7$var$_lcpEntry.id) span.setAttribute("lcp.id", $381fec96980d61a7$var$_lcpEntry.id);
        if ($381fec96980d61a7$var$_lcpEntry.url) // Trim URL to the first 200 characters.
        span.setAttribute("lcp.url", $381fec96980d61a7$var$_lcpEntry.url.trim().slice(0, 200));
        if ($381fec96980d61a7$var$_lcpEntry.loadTime != null) // loadTime is the time of LCP that's related to receiving the LCP element response..
        span.setAttribute("lcp.loadTime", $381fec96980d61a7$var$_lcpEntry.loadTime);
        if ($381fec96980d61a7$var$_lcpEntry.renderTime != null) // renderTime is loadTime + rendering time
        // it's 0 if the LCP element is loaded from a 3rd party origin that doesn't send the
        // `Timing-Allow-Origin` header.
        span.setAttribute("lcp.renderTime", $381fec96980d61a7$var$_lcpEntry.renderTime);
        span.setAttribute("lcp.size", $381fec96980d61a7$var$_lcpEntry.size);
    }
    // See: https://developer.mozilla.org/en-US/docs/Web/API/LayoutShift
    if ($381fec96980d61a7$var$_clsEntry?.sources) $381fec96980d61a7$var$_clsEntry.sources.forEach((source, index)=>span.setAttribute(`cls.source.${index + 1}`, (0, $1e36c764d0445908$export$5647df6b7814ac86)(source.node)));
}
function $381fec96980d61a7$var$setResourceEntrySizeData(attributes, entry, key, dataKey) {
    const entryVal = entry[key];
    if (entryVal != null && entryVal < $381fec96980d61a7$var$MAX_INT_AS_BYTES) attributes[dataKey] = entryVal;
}
/**
 * Add ttfb request time information to measurements.
 *
 * ttfb information is added via vendored web vitals library.
 */ function $381fec96980d61a7$var$_addTtfbRequestTimeToMeasurements(_measurements) {
    const navEntry = (0, $093b1175f041d1f7$export$6431553786c94949)(false);
    if (!navEntry) return;
    const { responseStart: responseStart, requestStart: requestStart } = navEntry;
    if (requestStart <= responseStart) _measurements["ttfb.requestTime"] = {
        value: responseStart - requestStart,
        unit: "millisecond"
    };
}




const $0d8964ca1aa4ae00$var$LAST_INTERACTIONS = [];
const $0d8964ca1aa4ae00$var$INTERACTIONS_SPAN_MAP = new Map();
/**
 * 60 seconds is the maximum for a plausible INP value
 * (source: Me)
 */ const $0d8964ca1aa4ae00$var$MAX_PLAUSIBLE_INP_DURATION = 60;
/**
 * Start tracking INP webvital events.
 */ function $0d8964ca1aa4ae00$export$f17d06681a4744a3() {
    const performance = (0, $32ec15e1edc55b14$export$f72a13c439a30cab)();
    if (performance && (0, $b83fbc460ca20326$export$baf075a948ffc0bf)()) {
        const inpCallback = $0d8964ca1aa4ae00$export$eeab203db0ed99a9();
        return ()=>{
            inpCallback();
        };
    }
    return ()=>undefined;
}
const $0d8964ca1aa4ae00$var$INP_ENTRY_MAP = {
    click: "click",
    pointerdown: "click",
    pointerup: "click",
    mousedown: "click",
    mouseup: "click",
    touchstart: "click",
    touchend: "click",
    mouseover: "hover",
    mouseout: "hover",
    mouseenter: "hover",
    mouseleave: "hover",
    pointerover: "hover",
    pointerout: "hover",
    pointerenter: "hover",
    pointerleave: "hover",
    dragstart: "drag",
    dragend: "drag",
    drag: "drag",
    dragenter: "drag",
    dragleave: "drag",
    dragover: "drag",
    drop: "drag",
    keydown: "press",
    keyup: "press",
    keypress: "press",
    input: "press"
};
/** Starts tracking the Interaction to Next Paint on the current page. #
 * exported only for testing
 */ function $0d8964ca1aa4ae00$export$eeab203db0ed99a9() {
    return (0, $52f106d2c2e0344c$export$da3b76aa2022cbd7)($0d8964ca1aa4ae00$export$7bcb98fe01441521);
}
/**
 * exported only for testing
 */ const $0d8964ca1aa4ae00$export$7bcb98fe01441521 = ({ metric: metric })=>{
    if (metric.value == undefined) return;
    const duration = (0, $32ec15e1edc55b14$export$b4785dbd4a81b33f)(metric.value);
    // We received occasional reports of hour-long INP values.
    // Therefore, we add a sanity check to avoid creating spans for
    // unrealistically long INP durations.
    if (duration > $0d8964ca1aa4ae00$var$MAX_PLAUSIBLE_INP_DURATION) return;
    const entry = metric.entries.find((entry)=>entry.duration === metric.value && $0d8964ca1aa4ae00$var$INP_ENTRY_MAP[entry.name]);
    if (!entry) return;
    const { interactionId: interactionId } = entry;
    const interactionType = $0d8964ca1aa4ae00$var$INP_ENTRY_MAP[entry.name];
    /** Build the INP span, create an envelope from the span, and then send the envelope */ const startTime = (0, $32ec15e1edc55b14$export$b4785dbd4a81b33f)((0, $b83fbc460ca20326$export$baf075a948ffc0bf)() + entry.startTime);
    const activeSpan = (0, $eb63b022ee5d8903$export$1be426a8e585c83e)();
    const rootSpan = activeSpan ? (0, $eb63b022ee5d8903$export$c4c6a79b1260ca1b)(activeSpan) : undefined;
    // We first try to lookup the span from our INTERACTIONS_SPAN_MAP,
    // where we cache the route per interactionId
    const cachedSpan = interactionId != null ? $0d8964ca1aa4ae00$var$INTERACTIONS_SPAN_MAP.get(interactionId) : undefined;
    const spanToUse = cachedSpan || rootSpan;
    // Else, we try to use the active span.
    // Finally, we fall back to look at the transactionName on the scope
    const routeName = spanToUse ? (0, $eb63b022ee5d8903$export$92d8c23565496537)(spanToUse).description : (0, $ea3b8c0e772c7cc7$export$c7be4b0125a10cba)().getScopeData().transactionName;
    const name = (0, $1e36c764d0445908$export$5647df6b7814ac86)(entry.target);
    const attributes = {
        [(0, $6889f80b19c28299$export$cca8dd30f57f805e)]: "auto.http.browser.inp",
        [(0, $6889f80b19c28299$export$1a413bd9a88fdb09)]: `ui.interaction.${interactionType}`,
        [(0, $6889f80b19c28299$export$fea48ba9f4550879)]: entry.duration
    };
    const span = (0, $32ec15e1edc55b14$export$b71b9c7b60c5a4aa)({
        name: name,
        transaction: routeName,
        attributes: attributes,
        startTime: startTime
    });
    if (span) {
        span.addEvent("inp", {
            [(0, $6889f80b19c28299$export$f5f95cff026507b5)]: "millisecond",
            [(0, $6889f80b19c28299$export$69cd5c610c7bb96a)]: metric.value
        });
        span.end(startTime + duration);
    }
};
/**
 * Register a listener to cache route information for INP interactions.
 */ function $0d8964ca1aa4ae00$export$e4e04d43e223cce2() {
    const handleEntries = ({ entries: entries })=>{
        const activeSpan = (0, $eb63b022ee5d8903$export$1be426a8e585c83e)();
        const activeRootSpan = activeSpan && (0, $eb63b022ee5d8903$export$c4c6a79b1260ca1b)(activeSpan);
        entries.forEach((entry)=>{
            if (!(0, $52f106d2c2e0344c$export$7affb50b622d8714)(entry) || !activeRootSpan) return;
            const interactionId = entry.interactionId;
            if (interactionId == null) return;
            // If the interaction was already recorded before, nothing more to do
            if ($0d8964ca1aa4ae00$var$INTERACTIONS_SPAN_MAP.has(interactionId)) return;
            // We keep max. 10 interactions in the list, then remove the oldest one & clean up
            if ($0d8964ca1aa4ae00$var$LAST_INTERACTIONS.length > 10) {
                const last = $0d8964ca1aa4ae00$var$LAST_INTERACTIONS.shift();
                $0d8964ca1aa4ae00$var$INTERACTIONS_SPAN_MAP.delete(last);
            }
            // We add the interaction to the list of recorded interactions
            // and store the span for this interaction
            $0d8964ca1aa4ae00$var$LAST_INTERACTIONS.push(interactionId);
            $0d8964ca1aa4ae00$var$INTERACTIONS_SPAN_MAP.set(interactionId, activeRootSpan);
        });
    };
    (0, $52f106d2c2e0344c$export$69816c1a049f8db6)("event", handleEntries);
    (0, $52f106d2c2e0344c$export$69816c1a049f8db6)("first-input", handleEntries);
}







/**
 * Add a listener that cancels and finishes a transaction when the global
 * document is hidden.
 */ function $6cf7e450f29971b4$export$6f18f55521af71a1() {
    if ((0, $9c98becc1d3a3995$export$56d8a8a25bd48b81).document) (0, $9c98becc1d3a3995$export$56d8a8a25bd48b81).document.addEventListener("visibilitychange", ()=>{
        const activeSpan = (0, $e89a3331adf677ac$export$1be426a8e585c83e)();
        if (!activeSpan) return;
        const rootSpan = (0, $e89a3331adf677ac$export$c4c6a79b1260ca1b)(activeSpan);
        if ((0, $9c98becc1d3a3995$export$56d8a8a25bd48b81).document.hidden && rootSpan) {
            const cancelledStatus = "cancelled";
            const { op: op, status: status } = (0, $e89a3331adf677ac$export$92d8c23565496537)(rootSpan);
            if (0, $fe45e6d5f124fb0c$export$16a28057038b10ef) (0, $dfad86e498c52aee$export$af88d00dbe7f521).log(`[Tracing] Transaction: ${cancelledStatus} -> since tab moved to the background, op: ${op}`);
            // We should not set status if it is already set, this prevent important statuses like
            // error or data loss from being overwritten on transaction.
            if (!status) rootSpan.setStatus({
                code: (0, $1c91772cf9c3fc39$export$f966a0446ece71e),
                message: cancelledStatus
            });
            rootSpan.setAttribute("sentry.cancellation_reason", "document.hidden");
            rootSpan.end();
        }
    });
    else (0, $fe45e6d5f124fb0c$export$16a28057038b10ef) && (0, $dfad86e498c52aee$export$af88d00dbe7f521).warn("[Tracing] Could not set up background tab detection due to lack of global document");
}













// 1h in seconds
const $868a63ff6f7bd2c9$export$c8d616af96ac729f = 3600;
// session storage key
const $868a63ff6f7bd2c9$export$16b6aa13b3c0f075 = "sentry_previous_trace";
const $868a63ff6f7bd2c9$export$237518aee8726f02 = "sentry.previous_trace";
/**
 * Takes care of linking traces and applying the (consistent) sampling behavoiour based on the passed options
 * @param options - options for linking traces and consistent trace sampling (@see BrowserTracingOptions)
 * @param client - Sentry client
 */ function $868a63ff6f7bd2c9$export$830d9ee659c6e4c4(client, { linkPreviousTrace: linkPreviousTrace, consistentTraceSampling: consistentTraceSampling }) {
    const useSessionStorage = linkPreviousTrace === "session-storage";
    let inMemoryPreviousTraceInfo = useSessionStorage ? $868a63ff6f7bd2c9$export$ef546bba8a402d99() : undefined;
    client.on("spanStart", (span)=>{
        if ((0, $e89a3331adf677ac$export$c4c6a79b1260ca1b)(span) !== span) return;
        const oldPropagationContext = (0, $0b98faa1b87c8168$export$c7be4b0125a10cba)().getPropagationContext();
        inMemoryPreviousTraceInfo = $868a63ff6f7bd2c9$export$ae31cf84cbfc630e(inMemoryPreviousTraceInfo, span, oldPropagationContext);
        if (useSessionStorage) $868a63ff6f7bd2c9$export$e3dcc2666496dd96(inMemoryPreviousTraceInfo);
    });
    let isFirstTraceOnPageload = true;
    if (consistentTraceSampling) /*
    When users opt into `consistentTraceSampling`, we need to ensure that we propagate
    the previous trace's sample rate and rand to the current trace. This is necessary because otherwise, span
    metric extrapolation is inaccurate, as we'd propagate too high of a sample rate for the subsequent traces.

    So therefore, we pretend that the previous trace was the parent trace of the newly started trace. To do that,
    we mutate the propagation context of the current trace and set the sample rate and sample rand of the previous trace.
    Timing-wise, it is fine because it happens before we even sample the root span.

    @see https://github.com/getsentry/sentry-javascript/issues/15754
    */ client.on("beforeSampling", (mutableSamplingContextData)=>{
        if (!inMemoryPreviousTraceInfo) return;
        const scope = (0, $0b98faa1b87c8168$export$c7be4b0125a10cba)();
        const currentPropagationContext = scope.getPropagationContext();
        // We do not want to force-continue the sampling decision if we continue a trace
        // that was started on the backend. Most prominently, this will happen in MPAs where
        // users hard-navigate between pages. In this case, the sampling decision of a potentially
        // started trace on the server takes precedence.
        // Why? We want to prioritize inter-trace consistency over intra-trace consistency.
        if (isFirstTraceOnPageload && currentPropagationContext.parentSpanId) {
            isFirstTraceOnPageload = false;
            return;
        }
        scope.setPropagationContext({
            ...currentPropagationContext,
            dsc: {
                ...currentPropagationContext.dsc,
                sample_rate: String(inMemoryPreviousTraceInfo.sampleRate),
                sampled: String($868a63ff6f7bd2c9$export$f394c5f143a7b597(inMemoryPreviousTraceInfo.spanContext))
            },
            sampleRand: inMemoryPreviousTraceInfo.sampleRand
        });
        mutableSamplingContextData.parentSampled = $868a63ff6f7bd2c9$export$f394c5f143a7b597(inMemoryPreviousTraceInfo.spanContext);
        mutableSamplingContextData.parentSampleRate = inMemoryPreviousTraceInfo.sampleRate;
        mutableSamplingContextData.spanAttributes = {
            ...mutableSamplingContextData.spanAttributes,
            [(0, $34e3132ced11beec$export$889fb736668e1ecc)]: inMemoryPreviousTraceInfo.sampleRate
        };
    });
}
/**
 * Adds a previous_trace span link to the passed span if the passed
 * previousTraceInfo is still valid.
 *
 * @returns the updated previous trace info (based on the current span/trace) to
 * be used on the next call
 */ function $868a63ff6f7bd2c9$export$ae31cf84cbfc630e(previousTraceInfo, span, oldPropagationContext) {
    const spanJson = (0, $e89a3331adf677ac$export$92d8c23565496537)(span);
    function getSampleRate() {
        try {
            return Number(oldPropagationContext.dsc?.sample_rate) ?? Number(spanJson.data?.[0, $34e3132ced11beec$export$ccfe0a40627cc34b]);
        } catch  {
            return 0;
        }
    }
    const updatedPreviousTraceInfo = {
        spanContext: span.spanContext(),
        startTimestamp: spanJson.start_timestamp,
        sampleRate: getSampleRate(),
        sampleRand: oldPropagationContext.sampleRand
    };
    if (!previousTraceInfo) return updatedPreviousTraceInfo;
    const previousTraceSpanCtx = previousTraceInfo.spanContext;
    if (previousTraceSpanCtx.traceId === spanJson.trace_id) // This means, we're still in the same trace so let's not update the previous trace info
    // or add a link to the current span.
    // Once we move away from the long-lived, route-based trace model, we can remove this cases
    return previousTraceInfo;
    // Only add the link if the startTimeStamp of the previous trace's root span is within
    // PREVIOUS_TRACE_MAX_DURATION (1h) of the current root span's startTimestamp
    // This is done to
    // - avoid adding links to "stale" traces
    // - enable more efficient querying for previous/next traces in Sentry
    if (Date.now() / 1000 - previousTraceInfo.startTimestamp <= $868a63ff6f7bd2c9$export$c8d616af96ac729f) {
        if (0, $fe45e6d5f124fb0c$export$16a28057038b10ef) (0, $dfad86e498c52aee$export$af88d00dbe7f521).info(`Adding previous_trace ${previousTraceSpanCtx} link to span ${{
            op: spanJson.op,
            ...span.spanContext()
        }}`);
        span.addLink({
            context: previousTraceSpanCtx,
            attributes: {
                [(0, $34e3132ced11beec$export$ff77b5fd5b2d627b)]: "previous_trace"
            }
        });
        // TODO: Remove this once EAP can store span links. We currently only set this attribute so that we
        // can obtain the previous trace information from the EAP store. Long-term, EAP will handle
        // span links and then we should remove this again. Also throwing in a TODO(v10), to remind us
        // to check this at v10 time :)
        span.setAttribute($868a63ff6f7bd2c9$export$237518aee8726f02, `${previousTraceSpanCtx.traceId}-${previousTraceSpanCtx.spanId}-${$868a63ff6f7bd2c9$export$f394c5f143a7b597(previousTraceSpanCtx) ? 1 : 0}`);
    }
    return updatedPreviousTraceInfo;
}
/**
 * Stores @param previousTraceInfo in sessionStorage.
 */ function $868a63ff6f7bd2c9$export$e3dcc2666496dd96(previousTraceInfo) {
    try {
        (0, $9c98becc1d3a3995$export$56d8a8a25bd48b81).sessionStorage.setItem($868a63ff6f7bd2c9$export$16b6aa13b3c0f075, JSON.stringify(previousTraceInfo));
    } catch (e) {
        // Ignore potential errors (e.g. if sessionStorage is not available)
        (0, $fe45e6d5f124fb0c$export$16a28057038b10ef) && (0, $dfad86e498c52aee$export$af88d00dbe7f521).warn("Could not store previous trace in sessionStorage", e);
    }
}
/**
 * Retrieves the previous trace from sessionStorage if available.
 */ function $868a63ff6f7bd2c9$export$ef546bba8a402d99() {
    try {
        const previousTraceInfo = (0, $9c98becc1d3a3995$export$56d8a8a25bd48b81).sessionStorage?.getItem($868a63ff6f7bd2c9$export$16b6aa13b3c0f075);
        // @ts-expect-error - intentionally risking JSON.parse throwing when previousTraceInfo is null to save bundle size
        return JSON.parse(previousTraceInfo);
    } catch (e) {
        return undefined;
    }
}
/**
 * see {@link import('@sentry/core').spanIsSampled}
 */ function $868a63ff6f7bd2c9$export$f394c5f143a7b597(ctx) {
    return ctx.traceFlags === 0x1;
}



const $37e7ec92b70e280f$export$bbd2089f30bd3708 = "BrowserTracing";
const $37e7ec92b70e280f$var$DEFAULT_BROWSER_TRACING_OPTIONS = {
    ...(0, $66867db55b849e12$export$809a2b7987fd5306),
    instrumentNavigation: true,
    instrumentPageLoad: true,
    markBackgroundSpan: true,
    enableLongTask: true,
    enableLongAnimationFrame: true,
    enableInp: true,
    ignoreResourceSpans: [],
    ignorePerformanceApiSpans: [],
    linkPreviousTrace: "in-memory",
    consistentTraceSampling: false,
    _experiments: {},
    ...(0, $07fac35b67406f25$export$cc17fb3c0bc95cd7)
};
/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library.
 *
 * We explicitly export the proper type here, as this has to be extended in some cases.
 */ const $37e7ec92b70e280f$export$b4109253475213e9 = (_options = {})=>{
    const latestRoute = {
        name: undefined,
        source: undefined
    };
    /**
   * This is just a small wrapper that makes `document` optional.
   * We want to be extra-safe and always check that this exists, to ensure weird environments do not blow up.
   */ const optionalWindowDocument = (0, $9c98becc1d3a3995$export$56d8a8a25bd48b81).document;
    const { enableInp: enableInp, enableLongTask: enableLongTask, enableLongAnimationFrame: enableLongAnimationFrame, _experiments: { enableInteractions: enableInteractions, enableStandaloneClsSpans: enableStandaloneClsSpans }, beforeStartSpan: beforeStartSpan, idleTimeout: idleTimeout, finalTimeout: finalTimeout, childSpanTimeout: childSpanTimeout, markBackgroundSpan: markBackgroundSpan, traceFetch: traceFetch, traceXHR: traceXHR, trackFetchStreamPerformance: trackFetchStreamPerformance, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings, ignoreResourceSpans: ignoreResourceSpans, ignorePerformanceApiSpans: ignorePerformanceApiSpans, instrumentPageLoad: instrumentPageLoad, instrumentNavigation: instrumentNavigation, linkPreviousTrace: linkPreviousTrace, consistentTraceSampling: consistentTraceSampling, onRequestSpanStart: onRequestSpanStart } = {
        ...$37e7ec92b70e280f$var$DEFAULT_BROWSER_TRACING_OPTIONS,
        ..._options
    };
    let _collectWebVitals;
    /** Create routing idle transaction. */ function _createRouteSpan(client, startSpanOptions) {
        const isPageloadTransaction = startSpanOptions.op === "pageload";
        const finalStartSpanOptions = beforeStartSpan ? beforeStartSpan(startSpanOptions) : startSpanOptions;
        const attributes = finalStartSpanOptions.attributes || {};
        // If `finalStartSpanOptions.name` is different than `startSpanOptions.name`
        // it is because `beforeStartSpan` set a custom name. Therefore we set the source to 'custom'.
        if (startSpanOptions.name !== finalStartSpanOptions.name) {
            attributes[0, $34e3132ced11beec$export$d7a7d984b0791405] = "custom";
            finalStartSpanOptions.attributes = attributes;
        }
        latestRoute.name = finalStartSpanOptions.name;
        latestRoute.source = attributes[0, $34e3132ced11beec$export$d7a7d984b0791405];
        const idleSpan = (0, $66867db55b849e12$export$901bffd97bd52797)(finalStartSpanOptions, {
            idleTimeout: idleTimeout,
            finalTimeout: finalTimeout,
            childSpanTimeout: childSpanTimeout,
            // should wait for finish signal if it's a pageload transaction
            disableAutoFinish: isPageloadTransaction,
            beforeSpanEnd: (span)=>{
                // This will generally always be defined here, because it is set in `setup()` of the integration
                // but technically, it is optional, so we guard here to be extra safe
                _collectWebVitals?.();
                (0, $381fec96980d61a7$export$5f8fa6b3467a7443)(span, {
                    recordClsOnPageloadSpan: !enableStandaloneClsSpans,
                    ignoreResourceSpans: ignoreResourceSpans,
                    ignorePerformanceApiSpans: ignorePerformanceApiSpans
                });
                $37e7ec92b70e280f$var$setActiveIdleSpan(client, undefined);
                // A trace should stay consistent over the entire timespan of one route - even after the pageload/navigation ended.
                // Only when another navigation happens, we want to create a new trace.
                // This way, e.g. errors that occur after the pageload span ended are still associated to the pageload trace.
                const scope = (0, $0b98faa1b87c8168$export$c7be4b0125a10cba)();
                const oldPropagationContext = scope.getPropagationContext();
                scope.setPropagationContext({
                    ...oldPropagationContext,
                    traceId: idleSpan.spanContext().traceId,
                    sampled: (0, $e89a3331adf677ac$export$5caecac1caaf3a71)(idleSpan),
                    dsc: (0, $d001bfa1cb8b2131$export$a117f995597e25df)(span)
                });
            }
        });
        $37e7ec92b70e280f$var$setActiveIdleSpan(client, idleSpan);
        function emitFinish() {
            if (optionalWindowDocument && [
                "interactive",
                "complete"
            ].includes(optionalWindowDocument.readyState)) client.emit("idleSpanEnableAutoFinish", idleSpan);
        }
        if (isPageloadTransaction && optionalWindowDocument) {
            optionalWindowDocument.addEventListener("readystatechange", ()=>{
                emitFinish();
            });
            emitFinish();
        }
    }
    return {
        name: $37e7ec92b70e280f$export$bbd2089f30bd3708,
        setup (client) {
            (0, $7e41a6e2f43eb615$export$b0914730ee1f6c80)();
            _collectWebVitals = (0, $381fec96980d61a7$export$7c69f0412d101b88)({
                recordClsStandaloneSpans: enableStandaloneClsSpans || false
            });
            if (enableInp) (0, $0d8964ca1aa4ae00$export$f17d06681a4744a3)();
            if (enableLongAnimationFrame && (0, $88208d9e04627397$export$f1a6cdb1459e81d1).PerformanceObserver && PerformanceObserver.supportedEntryTypes && PerformanceObserver.supportedEntryTypes.includes("long-animation-frame")) (0, $381fec96980d61a7$export$5b823ab2ccbc801d)();
            else if (enableLongTask) (0, $381fec96980d61a7$export$f396d19077034ad2)();
            if (enableInteractions) (0, $381fec96980d61a7$export$e27543e0976315e4)();
            function maybeEndActiveSpan() {
                const activeSpan = $37e7ec92b70e280f$var$getActiveIdleSpan(client);
                if (activeSpan && !(0, $e89a3331adf677ac$export$92d8c23565496537)(activeSpan).timestamp) {
                    (0, $fe45e6d5f124fb0c$export$16a28057038b10ef) && (0, $dfad86e498c52aee$export$af88d00dbe7f521).log(`[Tracing] Finishing current active span with op: ${(0, $e89a3331adf677ac$export$92d8c23565496537)(activeSpan).op}`);
                    // If there's an open active span, we need to finish it before creating an new one.
                    activeSpan.setAttribute((0, $34e3132ced11beec$export$ba73f34502b7a3b3), "cancelled");
                    activeSpan.end();
                }
            }
            client.on("startNavigationSpan", (startSpanOptions)=>{
                if ((0, $0b98faa1b87c8168$export$6bb76d6eba7e258c)() !== client) return;
                maybeEndActiveSpan();
                (0, $0b98faa1b87c8168$export$68f3af03034c9e90)().setPropagationContext({
                    traceId: (0, $482848166ffdb9e6$export$dc6d7ea554bcce10)(),
                    sampleRand: Math.random()
                });
                const scope = (0, $0b98faa1b87c8168$export$c7be4b0125a10cba)();
                scope.setPropagationContext({
                    traceId: (0, $482848166ffdb9e6$export$dc6d7ea554bcce10)(),
                    sampleRand: Math.random()
                });
                // We reset this to ensure we do not have lingering incorrect data here
                // places that call this hook may set this where appropriate - else, the URL at span sending time is used
                scope.setSDKProcessingMetadata({
                    normalizedRequest: undefined
                });
                _createRouteSpan(client, {
                    op: "navigation",
                    ...startSpanOptions
                });
            });
            client.on("startPageLoadSpan", (startSpanOptions, traceOptions = {})=>{
                if ((0, $0b98faa1b87c8168$export$6bb76d6eba7e258c)() !== client) return;
                maybeEndActiveSpan();
                const sentryTrace = traceOptions.sentryTrace || $37e7ec92b70e280f$export$f147b32b03c9cf11("sentry-trace");
                const baggage = traceOptions.baggage || $37e7ec92b70e280f$export$f147b32b03c9cf11("baggage");
                const propagationContext = (0, $e70413ee8cf08e05$export$261f383d16a93e39)(sentryTrace, baggage);
                const scope = (0, $0b98faa1b87c8168$export$c7be4b0125a10cba)();
                scope.setPropagationContext(propagationContext);
                // We store the normalized request data on the scope, so we get the request data at time of span creation
                // otherwise, the URL etc. may already be of the following navigation, and we'd report the wrong URL
                scope.setSDKProcessingMetadata({
                    normalizedRequest: (0, $9c98becc1d3a3995$export$a3c4a8453e8936f0)()
                });
                _createRouteSpan(client, {
                    op: "pageload",
                    ...startSpanOptions
                });
            });
        },
        afterAllSetup (client) {
            let startingUrl = (0, $8afcf0d9e9f8c38b$export$1cfafeee2987818b)();
            if (linkPreviousTrace !== "off") (0, $868a63ff6f7bd2c9$export$830d9ee659c6e4c4)(client, {
                linkPreviousTrace: linkPreviousTrace,
                consistentTraceSampling: consistentTraceSampling
            });
            if ((0, $9c98becc1d3a3995$export$56d8a8a25bd48b81).location) {
                if (instrumentPageLoad) {
                    const origin = (0, $14ccb306f78f15b4$export$baf075a948ffc0bf)();
                    $37e7ec92b70e280f$export$aa44a07f82af519f(client, {
                        name: (0, $9c98becc1d3a3995$export$56d8a8a25bd48b81).location.pathname,
                        // pageload should always start at timeOrigin (and needs to be in s, not ms)
                        startTime: origin ? origin / 1000 : undefined,
                        attributes: {
                            [(0, $34e3132ced11beec$export$d7a7d984b0791405)]: "url",
                            [(0, $34e3132ced11beec$export$cca8dd30f57f805e)]: "auto.pageload.browser"
                        }
                    });
                }
                if (instrumentNavigation) (0, $6bfcc9d7c86121e5$export$3f18c56c58114e75)(({ to: to, from: from })=>{
                    /**
             * This early return is there to account for some cases where a navigation transaction starts right after
             * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
             * create an uneccessary navigation transaction.
             *
             * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
             * only be caused in certain development environments where the usage of a hot module reloader is causing
             * errors.
             */ if (from === undefined && startingUrl?.indexOf(to) !== -1) {
                        startingUrl = undefined;
                        return;
                    }
                    startingUrl = undefined;
                    const parsed = (0, $34321b3a3ce9dbbd$export$2004d912a9ead694)(to);
                    $37e7ec92b70e280f$export$7d159749bd9969ad(client, {
                        name: parsed?.pathname || (0, $9c98becc1d3a3995$export$56d8a8a25bd48b81).location.pathname,
                        attributes: {
                            [(0, $34e3132ced11beec$export$d7a7d984b0791405)]: "url",
                            [(0, $34e3132ced11beec$export$cca8dd30f57f805e)]: "auto.navigation.browser"
                        }
                    });
                    // We store the normalized request data on the scope, so we get the request data at time of span creation
                    // otherwise, the URL etc. may already be of the following navigation, and we'd report the wrong URL
                    (0, $0b98faa1b87c8168$export$c7be4b0125a10cba)().setSDKProcessingMetadata({
                        normalizedRequest: {
                            ...(0, $9c98becc1d3a3995$export$a3c4a8453e8936f0)(),
                            // Ensure to set this, so this matches the target route even if the URL has not yet been updated
                            url: to
                        }
                    });
                });
            }
            if (markBackgroundSpan) (0, $6cf7e450f29971b4$export$6f18f55521af71a1)();
            if (enableInteractions) $37e7ec92b70e280f$var$registerInteractionListener(client, idleTimeout, finalTimeout, childSpanTimeout, latestRoute);
            if (enableInp) (0, $0d8964ca1aa4ae00$export$e4e04d43e223cce2)();
            (0, $07fac35b67406f25$export$864489cb3478db3e)(client, {
                traceFetch: traceFetch,
                traceXHR: traceXHR,
                trackFetchStreamPerformance: trackFetchStreamPerformance,
                tracePropagationTargets: client.getOptions().tracePropagationTargets,
                shouldCreateSpanForRequest: shouldCreateSpanForRequest,
                enableHTTPTimings: enableHTTPTimings,
                onRequestSpanStart: onRequestSpanStart
            });
        }
    };
};
/**
 * Manually start a page load span.
 * This will only do something if a browser tracing integration integration has been setup.
 *
 * If you provide a custom `traceOptions` object, it will be used to continue the trace
 * instead of the default behavior, which is to look it up on the <meta> tags.
 */ function $37e7ec92b70e280f$export$aa44a07f82af519f(client, spanOptions, traceOptions) {
    client.emit("startPageLoadSpan", spanOptions, traceOptions);
    (0, $0b98faa1b87c8168$export$c7be4b0125a10cba)().setTransactionName(spanOptions.name);
    return $37e7ec92b70e280f$var$getActiveIdleSpan(client);
}
/**
 * Manually start a navigation span.
 * This will only do something if a browser tracing integration has been setup.
 */ function $37e7ec92b70e280f$export$7d159749bd9969ad(client, spanOptions) {
    client.emit("startNavigationSpan", spanOptions);
    (0, $0b98faa1b87c8168$export$c7be4b0125a10cba)().setTransactionName(spanOptions.name);
    return $37e7ec92b70e280f$var$getActiveIdleSpan(client);
}
/** Returns the value of a meta tag */ function $37e7ec92b70e280f$export$f147b32b03c9cf11(metaName) {
    /**
   * This is just a small wrapper that makes `document` optional.
   * We want to be extra-safe and always check that this exists, to ensure weird environments do not blow up.
   */ const optionalWindowDocument = (0, $9c98becc1d3a3995$export$56d8a8a25bd48b81).document;
    const metaTag = optionalWindowDocument?.querySelector(`meta[name=${metaName}]`);
    return metaTag?.getAttribute("content") || undefined;
}
/** Start listener for interaction transactions */ function $37e7ec92b70e280f$var$registerInteractionListener(client, idleTimeout, finalTimeout, childSpanTimeout, latestRoute) {
    /**
   * This is just a small wrapper that makes `document` optional.
   * We want to be extra-safe and always check that this exists, to ensure weird environments do not blow up.
   */ const optionalWindowDocument = (0, $9c98becc1d3a3995$export$56d8a8a25bd48b81).document;
    let inflightInteractionSpan;
    const registerInteractionTransaction = ()=>{
        const op = "ui.action.click";
        const activeIdleSpan = $37e7ec92b70e280f$var$getActiveIdleSpan(client);
        if (activeIdleSpan) {
            const currentRootSpanOp = (0, $e89a3331adf677ac$export$92d8c23565496537)(activeIdleSpan).op;
            if ([
                "navigation",
                "pageload"
            ].includes(currentRootSpanOp)) {
                (0, $fe45e6d5f124fb0c$export$16a28057038b10ef) && (0, $dfad86e498c52aee$export$af88d00dbe7f521).warn(`[Tracing] Did not create ${op} span because a pageload or navigation span is in progress.`);
                return undefined;
            }
        }
        if (inflightInteractionSpan) {
            inflightInteractionSpan.setAttribute((0, $34e3132ced11beec$export$ba73f34502b7a3b3), "interactionInterrupted");
            inflightInteractionSpan.end();
            inflightInteractionSpan = undefined;
        }
        if (!latestRoute.name) {
            (0, $fe45e6d5f124fb0c$export$16a28057038b10ef) && (0, $dfad86e498c52aee$export$af88d00dbe7f521).warn(`[Tracing] Did not create ${op} transaction because _latestRouteName is missing.`);
            return undefined;
        }
        inflightInteractionSpan = (0, $66867db55b849e12$export$901bffd97bd52797)({
            name: latestRoute.name,
            op: op,
            attributes: {
                [(0, $34e3132ced11beec$export$d7a7d984b0791405)]: latestRoute.source || "url"
            }
        }, {
            idleTimeout: idleTimeout,
            finalTimeout: finalTimeout,
            childSpanTimeout: childSpanTimeout
        });
    };
    if (optionalWindowDocument) addEventListener("click", registerInteractionTransaction, {
        once: false,
        capture: true
    });
}
// We store the active idle span on the client object, so we can access it from exported functions
const $37e7ec92b70e280f$var$ACTIVE_IDLE_SPAN_PROPERTY = "_sentry_idleSpan";
function $37e7ec92b70e280f$var$getActiveIdleSpan(client) {
    return client[$37e7ec92b70e280f$var$ACTIVE_IDLE_SPAN_PROPERTY];
}
function $37e7ec92b70e280f$var$setActiveIdleSpan(client, span) {
    (0, $90379bc90653c4b6$export$e73679ffaf56810e)(client, $37e7ec92b70e280f$var$ACTIVE_IDLE_SPAN_PROPERTY, span);
}






const $6996b4a912b50503$export$638fddefcf0452da = 100; // 100 ms
const $6996b4a912b50503$export$998db03eaf5cf3f3 = 5000; // 5 seconds
const $6996b4a912b50503$var$MAX_DELAY = 3.6e6; // 1 hour
/**
 * Wraps a transport and stores and retries events when they fail to send.
 *
 * @param createTransport The transport to wrap.
 */ function $6996b4a912b50503$export$405ec66a0e87547a(createTransport) {
    function log(...args) {
        (0, $b5c0571e433473d8$export$16a28057038b10ef) && (0, $dfad86e498c52aee$export$af88d00dbe7f521).info("[Offline]:", ...args);
    }
    return (options)=>{
        const transport = createTransport(options);
        if (!options.createStore) throw new Error("No `createStore` function was provided");
        const store = options.createStore(options);
        let retryDelay = $6996b4a912b50503$export$998db03eaf5cf3f3;
        let flushTimer;
        function shouldQueue(env, error, retryDelay) {
            // We want to drop client reports because they can be generated when we retry sending events while offline.
            if ((0, $a293d580860d0106$export$604a45d95a155e2b)(env, [
                "client_report"
            ])) return false;
            if (options.shouldStore) return options.shouldStore(env, error, retryDelay);
            return true;
        }
        function flushIn(delay) {
            if (flushTimer) clearTimeout(flushTimer);
            flushTimer = setTimeout(async ()=>{
                flushTimer = undefined;
                const found = await store.shift();
                if (found) {
                    log("Attempting to send previously queued event");
                    // We should to update the sent_at timestamp to the current time.
                    found[0].sent_at = new Date().toISOString();
                    send(found, true).catch((e)=>{
                        log("Failed to retry sending", e);
                    });
                }
            }, delay);
            // We need to unref the timer in node.js, otherwise the node process never exit.
            if (typeof flushTimer !== "number" && flushTimer.unref) flushTimer.unref();
        }
        function flushWithBackOff() {
            if (flushTimer) return;
            flushIn(retryDelay);
            retryDelay = Math.min(retryDelay * 2, $6996b4a912b50503$var$MAX_DELAY);
        }
        async function send(envelope, isRetry = false) {
            // We queue all replay envelopes to avoid multiple replay envelopes being sent at the same time. If one fails, we
            // need to retry them in order.
            if (!isRetry && (0, $a293d580860d0106$export$604a45d95a155e2b)(envelope, [
                "replay_event",
                "replay_recording"
            ])) {
                await store.push(envelope);
                flushIn($6996b4a912b50503$export$638fddefcf0452da);
                return {};
            }
            try {
                if (options.shouldSend && await options.shouldSend(envelope) === false) throw new Error("Envelope not sent because `shouldSend` callback returned false");
                const result = await transport.send(envelope);
                let delay = $6996b4a912b50503$export$638fddefcf0452da;
                if (result) {
                    // If there's a retry-after header, use that as the next delay.
                    if (result.headers?.["retry-after"]) delay = (0, $47cdf2bf61f4d0ed$export$615352e17ed7741)(result.headers["retry-after"]);
                    else if (result.headers?.["x-sentry-rate-limits"]) delay = 60000; // 60 seconds
                    else if ((result.statusCode || 0) >= 400) return result;
                }
                flushIn(delay);
                retryDelay = $6996b4a912b50503$export$998db03eaf5cf3f3;
                return result;
            } catch (e) {
                if (await shouldQueue(envelope, e, retryDelay)) {
                    // If this envelope was a retry, we want to add it to the front of the queue so it's retried again first.
                    if (isRetry) await store.unshift(envelope);
                    else await store.push(envelope);
                    flushWithBackOff();
                    log("Error sending. Event queued.", e);
                    return {};
                } else throw e;
            }
        }
        if (options.flushAtStartup) flushWithBackOff();
        return {
            send: send,
            flush: (timeout)=>{
                // If there's no timeout, we should attempt to flush the offline queue.
                if (timeout === undefined) {
                    retryDelay = $6996b4a912b50503$export$998db03eaf5cf3f3;
                    flushIn($6996b4a912b50503$export$638fddefcf0452da);
                }
                return transport.flush(timeout);
            }
        };
    };
}




// 'Store', 'promisifyRequest' and 'createStore' were originally copied from the 'idb-keyval' package before being
// modified and simplified: https://github.com/jakearchibald/idb-keyval
//
// At commit: 0420a704fd6cbb4225429c536b1f61112d012fca
// Original license:
// Copyright 2016, Jake Archibald
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
function $6a0982bb5a2a41ea$var$promisifyRequest(request) {
    return new Promise((resolve, reject)=>{
        // @ts-expect-error - file size hacks
        request.oncomplete = request.onsuccess = ()=>resolve(request.result);
        // @ts-expect-error - file size hacks
        request.onabort = request.onerror = ()=>reject(request.error);
    });
}
/** Create or open an IndexedDb store */ function $6a0982bb5a2a41ea$export$f51a9068ac82ea43(dbName, storeName) {
    const request = indexedDB.open(dbName);
    request.onupgradeneeded = ()=>request.result.createObjectStore(storeName);
    const dbp = $6a0982bb5a2a41ea$var$promisifyRequest(request);
    return (callback)=>dbp.then((db)=>callback(db.transaction(storeName, "readwrite").objectStore(storeName)));
}
function $6a0982bb5a2a41ea$var$keys(store) {
    return $6a0982bb5a2a41ea$var$promisifyRequest(store.getAllKeys());
}
/** Insert into the end of the store */ function $6a0982bb5a2a41ea$export$4cbf152802aa238(store, value, maxQueueSize) {
    return store((store)=>{
        return $6a0982bb5a2a41ea$var$keys(store).then((keys)=>{
            if (keys.length >= maxQueueSize) return;
            // We insert with an incremented key so that the entries are popped in order
            store.put(value, Math.max(...keys, 0) + 1);
            return $6a0982bb5a2a41ea$var$promisifyRequest(store.transaction);
        });
    });
}
/** Insert into the front of the store */ function $6a0982bb5a2a41ea$export$37cdb546b806ae87(store, value, maxQueueSize) {
    return store((store)=>{
        return $6a0982bb5a2a41ea$var$keys(store).then((keys)=>{
            if (keys.length >= maxQueueSize) return;
            // We insert with an decremented key so that the entries are popped in order
            store.put(value, Math.min(...keys, 0) - 1);
            return $6a0982bb5a2a41ea$var$promisifyRequest(store.transaction);
        });
    });
}
/** Pop the oldest value from the store */ function $6a0982bb5a2a41ea$export$fba63a578e423eb(store) {
    return store((store)=>{
        return $6a0982bb5a2a41ea$var$keys(store).then((keys)=>{
            const firstKey = keys[0];
            if (firstKey == null) return undefined;
            return $6a0982bb5a2a41ea$var$promisifyRequest(store.get(firstKey)).then((value)=>{
                store.delete(firstKey);
                return $6a0982bb5a2a41ea$var$promisifyRequest(store.transaction).then(()=>value);
            });
        });
    });
}
function $6a0982bb5a2a41ea$var$createIndexedDbStore(options) {
    let store;
    // Lazily create the store only when it's needed
    function getStore() {
        if (store == undefined) store = $6a0982bb5a2a41ea$export$f51a9068ac82ea43(options.dbName || "sentry-offline", options.storeName || "queue");
        return store;
    }
    return {
        push: async (env)=>{
            try {
                const serialized = await (0, $a293d580860d0106$export$32f9b428425aac85)(env);
                await $6a0982bb5a2a41ea$export$4cbf152802aa238(getStore(), serialized, options.maxQueueSize || 30);
            } catch (_) {
            //
            }
        },
        unshift: async (env)=>{
            try {
                const serialized = await (0, $a293d580860d0106$export$32f9b428425aac85)(env);
                await $6a0982bb5a2a41ea$export$37cdb546b806ae87(getStore(), serialized, options.maxQueueSize || 30);
            } catch (_) {
            //
            }
        },
        shift: async ()=>{
            try {
                const deserialized = await $6a0982bb5a2a41ea$export$fba63a578e423eb(getStore());
                if (deserialized) return (0, $a293d580860d0106$export$3338d0c7b6e17a2b)(deserialized);
            } catch (_) {
            //
            }
            return undefined;
        }
    };
}
function $6a0982bb5a2a41ea$var$makeIndexedDbOfflineTransport(createTransport) {
    return (options)=>{
        const transport = createTransport({
            ...options,
            createStore: $6a0982bb5a2a41ea$var$createIndexedDbStore
        });
        (0, $9c98becc1d3a3995$export$56d8a8a25bd48b81).addEventListener("online", async (_)=>{
            await transport.flush();
        });
        return transport;
    };
}
/**
 * Creates a transport that uses IndexedDb to store events when offline.
 */ function $6a0982bb5a2a41ea$export$79c8882827636cf2(createTransport = (0, $846ede25dfa44954$export$b2311068c46d7cc8)) {
    return $6a0982bb5a2a41ea$var$makeIndexedDbOfflineTransport((0, $6996b4a912b50503$export$405ec66a0e87547a)(createTransport));
}










const $d19c75133e07fa94$var$MS_TO_NS = 1e6;
// Use 0 as main thread id which is identical to threadId in node:worker_threads
// where main logs 0 and workers seem to log in increments of 1
const $d19c75133e07fa94$var$THREAD_ID_STRING = String(0);
const $d19c75133e07fa94$var$THREAD_NAME = "main";
// We force make this optional to be on the safe side...
const $d19c75133e07fa94$var$navigator = (0, $9c98becc1d3a3995$export$56d8a8a25bd48b81).navigator;
// Machine properties (eval only once)
let $d19c75133e07fa94$var$OS_PLATFORM = "";
let $d19c75133e07fa94$var$OS_PLATFORM_VERSION = "";
let $d19c75133e07fa94$var$OS_ARCH = "";
let $d19c75133e07fa94$var$OS_BROWSER = $d19c75133e07fa94$var$navigator?.userAgent || "";
let $d19c75133e07fa94$var$OS_MODEL = "";
const $d19c75133e07fa94$var$OS_LOCALE = $d19c75133e07fa94$var$navigator?.language || $d19c75133e07fa94$var$navigator?.languages?.[0] || "";
function $d19c75133e07fa94$var$isUserAgentData(data) {
    return typeof data === "object" && data !== null && "getHighEntropyValues" in data;
}
// @ts-expect-error userAgentData is not part of the navigator interface yet
const $d19c75133e07fa94$var$userAgentData = $d19c75133e07fa94$var$navigator?.userAgentData;
if ($d19c75133e07fa94$var$isUserAgentData($d19c75133e07fa94$var$userAgentData)) $d19c75133e07fa94$var$userAgentData.getHighEntropyValues([
    "architecture",
    "model",
    "platform",
    "platformVersion",
    "fullVersionList"
]).then((ua)=>{
    $d19c75133e07fa94$var$OS_PLATFORM = ua.platform || "";
    $d19c75133e07fa94$var$OS_ARCH = ua.architecture || "";
    $d19c75133e07fa94$var$OS_MODEL = ua.model || "";
    $d19c75133e07fa94$var$OS_PLATFORM_VERSION = ua.platformVersion || "";
    if (ua.fullVersionList?.length) {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const firstUa = ua.fullVersionList[ua.fullVersionList.length - 1];
        $d19c75133e07fa94$var$OS_BROWSER = `${firstUa.brand} ${firstUa.version}`;
    }
}).catch((e)=>void 0);
function $d19c75133e07fa94$var$isProcessedJSSelfProfile(profile) {
    return !("thread_metadata" in profile);
}
// Enriches the profile with threadId of the current thread.
// This is done in node as we seem to not be able to get the info from C native code.
/**
 *
 */ function $d19c75133e07fa94$export$7cbe6c4f12ea8325(profile) {
    if (!$d19c75133e07fa94$var$isProcessedJSSelfProfile(profile)) return profile;
    return $d19c75133e07fa94$export$f4122c775dfac1c2(profile);
}
// Profile is marked as optional because it is deleted from the metadata
// by the integration before the event is processed by other integrations.
function $d19c75133e07fa94$var$getTraceId(event) {
    const traceId = event.contexts?.trace?.["trace_id"];
    // Log a warning if the profile has an invalid traceId (should be uuidv4).
    // All profiles and transactions are rejected if this is the case and we want to
    // warn users that this is happening if they enable debug flag
    if (typeof traceId === "string" && traceId.length !== 32) {
        if (0, $fe45e6d5f124fb0c$export$16a28057038b10ef) (0, $dfad86e498c52aee$export$af88d00dbe7f521).log(`[Profiling] Invalid traceId: ${traceId} on profiled event`);
    }
    if (typeof traceId !== "string") return "";
    return traceId;
}
/**
 * Creates a profiling event envelope from a Sentry event. If profile does not pass
 * validation, returns null.
 * @param event
 * @param dsn
 * @param metadata
 * @param tunnel
 * @returns {EventEnvelope | null}
 */ /**
 * Creates a profiling event envelope from a Sentry event.
 */ function $d19c75133e07fa94$export$5c9f6e262288b7db(profile_id, start_timestamp, processed_profile, event) {
    if (event.type !== "transaction") // createProfilingEventEnvelope should only be called for transactions,
    // we type guard this behavior with isProfiledTransactionEvent.
    throw new TypeError("Profiling events may only be attached to transactions, this should never occur.");
    if (processed_profile === undefined || processed_profile === null) throw new TypeError(`Cannot construct profiling event envelope without a valid profile. Got ${processed_profile} instead.`);
    const traceId = $d19c75133e07fa94$var$getTraceId(event);
    const enrichedThreadProfile = $d19c75133e07fa94$export$7cbe6c4f12ea8325(processed_profile);
    const transactionStartMs = start_timestamp ? start_timestamp : typeof event.start_timestamp === "number" ? event.start_timestamp * 1000 : (0, $14ccb306f78f15b4$export$ee52dced521e3e18)() * 1000;
    const transactionEndMs = typeof event.timestamp === "number" ? event.timestamp * 1000 : (0, $14ccb306f78f15b4$export$ee52dced521e3e18)() * 1000;
    const profile = {
        event_id: profile_id,
        timestamp: new Date(transactionStartMs).toISOString(),
        platform: "javascript",
        version: "1",
        release: event.release || "",
        environment: event.environment || (0, $4d1ecfae9e70d95f$export$849dbeeeda01ae98),
        runtime: {
            name: "javascript",
            version: (0, $9c98becc1d3a3995$export$56d8a8a25bd48b81).navigator.userAgent
        },
        os: {
            name: $d19c75133e07fa94$var$OS_PLATFORM,
            version: $d19c75133e07fa94$var$OS_PLATFORM_VERSION,
            build_number: $d19c75133e07fa94$var$OS_BROWSER
        },
        device: {
            locale: $d19c75133e07fa94$var$OS_LOCALE,
            model: $d19c75133e07fa94$var$OS_MODEL,
            manufacturer: $d19c75133e07fa94$var$OS_BROWSER,
            architecture: $d19c75133e07fa94$var$OS_ARCH,
            is_emulator: false
        },
        debug_meta: {
            images: $d19c75133e07fa94$export$4c0b0d8ee0d018b5(processed_profile.resources)
        },
        profile: enrichedThreadProfile,
        transactions: [
            {
                name: event.transaction || "",
                id: event.event_id || (0, $c65fa882a3254127$export$19f53698e68b2496)(),
                trace_id: traceId,
                active_thread_id: $d19c75133e07fa94$var$THREAD_ID_STRING,
                relative_start_ns: "0",
                relative_end_ns: ((transactionEndMs - transactionStartMs) * 1e6).toFixed(0)
            }
        ]
    };
    return profile;
}
/*
  See packages/browser-utils/src/browser/router.ts
*/ /**
 *
 */ function $d19c75133e07fa94$export$563404c5f9ee31f6(span) {
    return (0, $e89a3331adf677ac$export$92d8c23565496537)(span).op === "pageload";
}
/**
 * Converts a JSSelfProfile to a our sampled format.
 * Does not currently perform stack indexing.
 */ function $d19c75133e07fa94$export$f4122c775dfac1c2(input) {
    let EMPTY_STACK_ID = undefined;
    let STACK_ID = 0;
    // Initialize the profile that we will fill with data
    const profile = {
        samples: [],
        stacks: [],
        frames: [],
        thread_metadata: {
            [$d19c75133e07fa94$var$THREAD_ID_STRING]: {
                name: $d19c75133e07fa94$var$THREAD_NAME
            }
        }
    };
    const firstSample = input.samples[0];
    if (!firstSample) return profile;
    // We assert samples.length > 0 above and timestamp should always be present
    const start = firstSample.timestamp;
    // The JS SDK might change it's time origin based on some heuristic (see See packages/utils/src/time.ts)
    // when that happens, we need to ensure we are correcting the profile timings so the two timelines stay in sync.
    // Since JS self profiling time origin is always initialized to performance.timeOrigin, we need to adjust for
    // the drift between the SDK selected value and our profile time origin.
    const perfOrigin = (0, $14ccb306f78f15b4$export$baf075a948ffc0bf)();
    const origin = typeof performance.timeOrigin === "number" ? performance.timeOrigin : perfOrigin || 0;
    const adjustForOriginChange = origin - (perfOrigin || origin);
    input.samples.forEach((jsSample, i)=>{
        // If sample has no stack, add an empty sample
        if (jsSample.stackId === undefined) {
            if (EMPTY_STACK_ID === undefined) {
                EMPTY_STACK_ID = STACK_ID;
                profile.stacks[EMPTY_STACK_ID] = [];
                STACK_ID++;
            }
            profile["samples"][i] = {
                // convert ms timestamp to ns
                elapsed_since_start_ns: ((jsSample.timestamp + adjustForOriginChange - start) * $d19c75133e07fa94$var$MS_TO_NS).toFixed(0),
                stack_id: EMPTY_STACK_ID,
                thread_id: $d19c75133e07fa94$var$THREAD_ID_STRING
            };
            return;
        }
        let stackTop = input.stacks[jsSample.stackId];
        // Functions in top->down order (root is last)
        // We follow the stackTop.parentId trail and collect each visited frameId
        const stack = [];
        while(stackTop){
            stack.push(stackTop.frameId);
            const frame = input.frames[stackTop.frameId];
            // If our frame has not been indexed yet, index it
            if (frame && profile.frames[stackTop.frameId] === undefined) profile.frames[stackTop.frameId] = {
                function: frame.name,
                abs_path: typeof frame.resourceId === "number" ? input.resources[frame.resourceId] : undefined,
                lineno: frame.line,
                colno: frame.column
            };
            stackTop = stackTop.parentId === undefined ? undefined : input.stacks[stackTop.parentId];
        }
        const sample = {
            // convert ms timestamp to ns
            elapsed_since_start_ns: ((jsSample.timestamp + adjustForOriginChange - start) * $d19c75133e07fa94$var$MS_TO_NS).toFixed(0),
            stack_id: STACK_ID,
            thread_id: $d19c75133e07fa94$var$THREAD_ID_STRING
        };
        profile["stacks"][STACK_ID] = stack;
        profile["samples"][i] = sample;
        STACK_ID++;
    });
    return profile;
}
/**
 * Adds items to envelope if they are not already present - mutates the envelope.
 * @param envelope
 */ function $d19c75133e07fa94$export$4df36760a75f76bc(envelope, profiles) {
    if (!profiles.length) return envelope;
    for (const profile of profiles)envelope[1].push([
        {
            type: "profile"
        },
        profile
    ]);
    return envelope;
}
/**
 * Finds transactions with profile_id context in the envelope
 * @param envelope
 * @returns
 */ function $d19c75133e07fa94$export$df9bb0fc214ff8cd(envelope) {
    const events = [];
    (0, $a293d580860d0106$export$c56c55acf0136fd3)(envelope, (item, type)=>{
        if (type !== "transaction") return;
        for(let j = 1; j < item.length; j++){
            const event = item[j];
            if (event?.contexts && event.contexts["profile"] && event.contexts["profile"]["profile_id"]) events.push(item[j]);
        }
    });
    return events;
}
/**
 * Applies debug meta data to an event from a list of paths to resources (sourcemaps)
 */ function $d19c75133e07fa94$export$4c0b0d8ee0d018b5(resource_paths) {
    const client = (0, $0b98faa1b87c8168$export$6bb76d6eba7e258c)();
    const options = client?.getOptions();
    const stackParser = options?.stackParser;
    if (!stackParser) return [];
    return (0, $22e79d0b6f95266a$export$5a7368330d9ee6e3)(stackParser, resource_paths);
}
/**
 * Checks the given sample rate to make sure it is valid type and value (a boolean, or a number between 0 and 1).
 */ function $d19c75133e07fa94$export$2603c8d332a51c42(rate) {
    // we need to check NaN explicitly because it's of type 'number' and therefore wouldn't get caught by this typecheck
    if (typeof rate !== "number" && typeof rate !== "boolean" || typeof rate === "number" && isNaN(rate)) {
        (0, $fe45e6d5f124fb0c$export$16a28057038b10ef) && (0, $dfad86e498c52aee$export$af88d00dbe7f521).warn(`[Profiling] Invalid sample rate. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(rate)} of type ${JSON.stringify(typeof rate)}.`);
        return false;
    }
    // Boolean sample rates are always valid
    if (rate === true || rate === false) return true;
    // in case sampleRate is a boolean, it will get automatically cast to 1 if it's true and 0 if it's false
    if (rate < 0 || rate > 1) {
        (0, $fe45e6d5f124fb0c$export$16a28057038b10ef) && (0, $dfad86e498c52aee$export$af88d00dbe7f521).warn(`[Profiling] Invalid sample rate. Sample rate must be between 0 and 1. Got ${rate}.`);
        return false;
    }
    return true;
}
function $d19c75133e07fa94$var$isValidProfile(profile) {
    if (profile.samples.length < 2) {
        if (0, $fe45e6d5f124fb0c$export$16a28057038b10ef) // Log a warning if the profile has less than 2 samples so users can know why
        // they are not seeing any profiling data and we cant avoid the back and forth
        // of asking them to provide us with a dump of the profile data.
        (0, $dfad86e498c52aee$export$af88d00dbe7f521).log("[Profiling] Discarding profile because it contains less than 2 samples");
        return false;
    }
    if (!profile.frames.length) {
        if (0, $fe45e6d5f124fb0c$export$16a28057038b10ef) (0, $dfad86e498c52aee$export$af88d00dbe7f521).log("[Profiling] Discarding profile because it contains no frames");
        return false;
    }
    return true;
}
// Keep a flag value to avoid re-initializing the profiler constructor. If it fails
// once, it will always fail and this allows us to early return.
let $d19c75133e07fa94$var$PROFILING_CONSTRUCTOR_FAILED = false;
const $d19c75133e07fa94$export$8640c0b5c7d98a81 = 30000;
/**
 * Check if profiler constructor is available.
 * @param maybeProfiler
 */ function $d19c75133e07fa94$var$isJSProfilerSupported(maybeProfiler) {
    return typeof maybeProfiler === "function";
}
/**
 * Starts the profiler and returns the profiler instance.
 */ function $d19c75133e07fa94$export$9f4f648547a4284f() {
    // Feature support check first
    const JSProfilerConstructor = (0, $9c98becc1d3a3995$export$56d8a8a25bd48b81).Profiler;
    if (!$d19c75133e07fa94$var$isJSProfilerSupported(JSProfilerConstructor)) {
        if (0, $fe45e6d5f124fb0c$export$16a28057038b10ef) (0, $dfad86e498c52aee$export$af88d00dbe7f521).log("[Profiling] Profiling is not supported by this browser, Profiler interface missing on window object.");
        return;
    }
    // From initial testing, it seems that the minimum value for sampleInterval is 10ms.
    const samplingIntervalMS = 10;
    // Start the profiler
    const maxSamples = Math.floor($d19c75133e07fa94$export$8640c0b5c7d98a81 / samplingIntervalMS);
    // Attempt to initialize the profiler constructor, if it fails, we disable profiling for the current user session.
    // This is likely due to a missing 'Document-Policy': 'js-profiling' header. We do not want to throw an error if this happens
    // as we risk breaking the user's application, so just disable profiling and log an error.
    try {
        return new JSProfilerConstructor({
            sampleInterval: samplingIntervalMS,
            maxBufferSize: maxSamples
        });
    } catch (e) {
        if (0, $fe45e6d5f124fb0c$export$16a28057038b10ef) {
            (0, $dfad86e498c52aee$export$af88d00dbe7f521).log("[Profiling] Failed to initialize the Profiling constructor, this is likely due to a missing 'Document-Policy': 'js-profiling' header.");
            (0, $dfad86e498c52aee$export$af88d00dbe7f521).log("[Profiling] Disabling profiling for current user session.");
        }
        $d19c75133e07fa94$var$PROFILING_CONSTRUCTOR_FAILED = true;
    }
    return;
}
/**
 * Determine if a profile should be profiled.
 */ function $d19c75133e07fa94$export$fa7ef36a2032fde9(span) {
    // If constructor failed once, it will always fail, so we can early return.
    if ($d19c75133e07fa94$var$PROFILING_CONSTRUCTOR_FAILED) {
        if (0, $fe45e6d5f124fb0c$export$16a28057038b10ef) (0, $dfad86e498c52aee$export$af88d00dbe7f521).log("[Profiling] Profiling has been disabled for the duration of the current user session.");
        return false;
    }
    if (!span.isRecording()) {
        if (0, $fe45e6d5f124fb0c$export$16a28057038b10ef) (0, $dfad86e498c52aee$export$af88d00dbe7f521).log("[Profiling] Discarding profile because transaction was not sampled.");
        return false;
    }
    const client = (0, $0b98faa1b87c8168$export$6bb76d6eba7e258c)();
    const options = client?.getOptions();
    if (!options) {
        (0, $fe45e6d5f124fb0c$export$16a28057038b10ef) && (0, $dfad86e498c52aee$export$af88d00dbe7f521).log("[Profiling] Profiling disabled, no options found.");
        return false;
    }
    // @ts-expect-error profilesSampleRate is not part of the browser options yet
    const profilesSampleRate = options.profilesSampleRate;
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get. (The
    // only valid values are booleans or numbers between 0 and 1.)
    if (!$d19c75133e07fa94$export$2603c8d332a51c42(profilesSampleRate)) {
        (0, $fe45e6d5f124fb0c$export$16a28057038b10ef) && (0, $dfad86e498c52aee$export$af88d00dbe7f521).warn("[Profiling] Discarding profile because of invalid sample rate.");
        return false;
    }
    // if the function returned 0 (or false), or if `profileSampleRate` is 0, it's a sign the profile should be dropped
    if (!profilesSampleRate) {
        (0, $fe45e6d5f124fb0c$export$16a28057038b10ef) && (0, $dfad86e498c52aee$export$af88d00dbe7f521).log("[Profiling] Discarding profile because a negative sampling decision was inherited or profileSampleRate is set to 0");
        return false;
    }
    // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
    // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
    const sampled = profilesSampleRate === true ? true : Math.random() < profilesSampleRate;
    // Check if we should sample this profile
    if (!sampled) {
        (0, $fe45e6d5f124fb0c$export$16a28057038b10ef) && (0, $dfad86e498c52aee$export$af88d00dbe7f521).log(`[Profiling] Discarding profile because it's not included in the random sample (sampling rate = ${Number(profilesSampleRate)})`);
        return false;
    }
    return true;
}
/**
 * Creates a profiling envelope item, if the profile does not pass validation, returns null.
 * @param event
 * @returns {Profile | null}
 */ function $d19c75133e07fa94$export$5c2c5e805edd874f(profile_id, start_timestamp, profile, event) {
    if (!$d19c75133e07fa94$var$isValidProfile(profile)) return null;
    return $d19c75133e07fa94$export$5c9f6e262288b7db(profile_id, start_timestamp, profile, event);
}
// TODO (v8): We need to obtain profile ids in @sentry-internal/tracing,
// but we don't have access to this map because importing this map would
// cause a circular dependency. We need to resolve this in v8.
const $d19c75133e07fa94$var$PROFILE_MAP = new Map();
/**
 *
 */ function $d19c75133e07fa94$export$9d723f414195854a() {
    return $d19c75133e07fa94$var$PROFILE_MAP.size;
}
/**
 * Retrieves profile from global cache and removes it.
 */ function $d19c75133e07fa94$export$6285310796363de1(profile_id) {
    const profile = $d19c75133e07fa94$var$PROFILE_MAP.get(profile_id);
    if (profile) $d19c75133e07fa94$var$PROFILE_MAP.delete(profile_id);
    return profile;
}
/**
 * Adds profile to global cache and evicts the oldest profile if the cache is full.
 */ function $d19c75133e07fa94$export$7ddae68097f7e530(profile_id, profile) {
    $d19c75133e07fa94$var$PROFILE_MAP.set(profile_id, profile);
    if ($d19c75133e07fa94$var$PROFILE_MAP.size > 30) {
        const last = $d19c75133e07fa94$var$PROFILE_MAP.keys().next().value;
        $d19c75133e07fa94$var$PROFILE_MAP.delete(last);
    }
}


/**
 * Wraps startTransaction and stopTransaction with profiling related logic.
 * startProfileForTransaction is called after the call to startTransaction in order to avoid our own code from
 * being profiled. Because of that same reason, stopProfiling is called before the call to stopTransaction.
 */ function $04b2908323f25469$export$83bcc43b6a2cf5e7(span) {
    // Start the profiler and get the profiler instance.
    let startTimestamp;
    if ((0, $d19c75133e07fa94$export$563404c5f9ee31f6)(span)) startTimestamp = (0, $14ccb306f78f15b4$export$ee52dced521e3e18)() * 1000;
    const profiler = (0, $d19c75133e07fa94$export$9f4f648547a4284f)();
    // We failed to construct the profiler, so we skip.
    // No need to log anything as this has already been logged in startProfile.
    if (!profiler) return;
    if (0, $fe45e6d5f124fb0c$export$16a28057038b10ef) (0, $dfad86e498c52aee$export$af88d00dbe7f521).log(`[Profiling] started profiling span: ${(0, $e89a3331adf677ac$export$92d8c23565496537)(span).description}`);
    // We create "unique" span names to avoid concurrent spans with same names
    // from being ignored by the profiler. From here on, only this span name should be used when
    // calling the profiler methods. Note: we log the original name to the user to avoid confusion.
    const profileId = (0, $c65fa882a3254127$export$19f53698e68b2496)();
    (0, $0b98faa1b87c8168$export$c7be4b0125a10cba)().setContext("profile", {
        profile_id: profileId,
        start_timestamp: startTimestamp
    });
    /**
   * Idempotent handler for profile stop
   */ async function onProfileHandler() {
        // Check if the profile exists and return it the behavior has to be idempotent as users may call span.finish multiple times.
        if (!span) return;
        // Satisfy the type checker, but profiler will always be defined here.
        if (!profiler) return;
        return profiler.stop().then((profile)=>{
            if (maxDurationTimeoutID) {
                (0, $9c98becc1d3a3995$export$56d8a8a25bd48b81).clearTimeout(maxDurationTimeoutID);
                maxDurationTimeoutID = undefined;
            }
            if (0, $fe45e6d5f124fb0c$export$16a28057038b10ef) (0, $dfad86e498c52aee$export$af88d00dbe7f521).log(`[Profiling] stopped profiling of span: ${(0, $e89a3331adf677ac$export$92d8c23565496537)(span).description}`);
            // In case of an overlapping span, stopProfiling may return null and silently ignore the overlapping profile.
            if (!profile) {
                if (0, $fe45e6d5f124fb0c$export$16a28057038b10ef) (0, $dfad86e498c52aee$export$af88d00dbe7f521).log(`[Profiling] profiler returned null profile for: ${(0, $e89a3331adf677ac$export$92d8c23565496537)(span).description}`, "this may indicate an overlapping span or a call to stopProfiling with a profile title that was never started");
                return;
            }
            (0, $d19c75133e07fa94$export$7ddae68097f7e530)(profileId, profile);
        }).catch((error)=>{
            if (0, $fe45e6d5f124fb0c$export$16a28057038b10ef) (0, $dfad86e498c52aee$export$af88d00dbe7f521).log("[Profiling] error while stopping profiler:", error);
        });
    }
    // Enqueue a timeout to prevent profiles from running over max duration.
    let maxDurationTimeoutID = (0, $9c98becc1d3a3995$export$56d8a8a25bd48b81).setTimeout(()=>{
        if (0, $fe45e6d5f124fb0c$export$16a28057038b10ef) (0, $dfad86e498c52aee$export$af88d00dbe7f521).log("[Profiling] max profile duration elapsed, stopping profiling for:", (0, $e89a3331adf677ac$export$92d8c23565496537)(span).description);
        // If the timeout exceeds, we want to stop profiling, but not finish the span
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        onProfileHandler();
    }, (0, $d19c75133e07fa94$export$8640c0b5c7d98a81));
    // We need to reference the original end call to avoid creating an infinite loop
    const originalEnd = span.end.bind(span);
    /**
   * Wraps span `end()` with profiling related logic.
   * startProfiling is called after the call to spanStart in order to avoid our own code from
   * being profiled. Because of that same reason, stopProfiling is called before the call to spanEnd.
   */ function profilingWrappedSpanEnd() {
        if (!span) return originalEnd();
        // onProfileHandler should always return the same profile even if this is called multiple times.
        // Always call onProfileHandler to ensure stopProfiling is called and the timeout is cleared.
        onProfileHandler().then(()=>{
            originalEnd();
        }, ()=>{
            // If onProfileHandler fails, we still want to call the original finish method.
            originalEnd();
        });
        return span;
    }
    span.end = profilingWrappedSpanEnd;
}



const $bc6a1c7deaf32184$var$INTEGRATION_NAME = "BrowserProfiling";
const $bc6a1c7deaf32184$var$_browserProfilingIntegration = ()=>{
    return {
        name: $bc6a1c7deaf32184$var$INTEGRATION_NAME,
        setup (client) {
            const activeSpan = (0, $e89a3331adf677ac$export$1be426a8e585c83e)();
            const rootSpan = activeSpan && (0, $e89a3331adf677ac$export$c4c6a79b1260ca1b)(activeSpan);
            if (rootSpan && (0, $d19c75133e07fa94$export$563404c5f9ee31f6)(rootSpan)) {
                if ((0, $d19c75133e07fa94$export$fa7ef36a2032fde9)(rootSpan)) (0, $04b2908323f25469$export$83bcc43b6a2cf5e7)(rootSpan);
            }
            client.on("spanStart", (span)=>{
                if (span === (0, $e89a3331adf677ac$export$c4c6a79b1260ca1b)(span) && (0, $d19c75133e07fa94$export$fa7ef36a2032fde9)(span)) (0, $04b2908323f25469$export$83bcc43b6a2cf5e7)(span);
            });
            client.on("beforeEnvelope", (envelope)=>{
                // if not profiles are in queue, there is nothing to add to the envelope.
                if (!(0, $d19c75133e07fa94$export$9d723f414195854a)()) return;
                const profiledTransactionEvents = (0, $d19c75133e07fa94$export$df9bb0fc214ff8cd)(envelope);
                if (!profiledTransactionEvents.length) return;
                const profilesToAddToEnvelope = [];
                for (const profiledTransaction of profiledTransactionEvents){
                    const context = profiledTransaction?.contexts;
                    const profile_id = context?.profile?.["profile_id"];
                    const start_timestamp = context?.profile?.["start_timestamp"];
                    if (typeof profile_id !== "string") {
                        (0, $fe45e6d5f124fb0c$export$16a28057038b10ef) && (0, $dfad86e498c52aee$export$af88d00dbe7f521).log("[Profiling] cannot find profile for a span without a profile context");
                        continue;
                    }
                    if (!profile_id) {
                        (0, $fe45e6d5f124fb0c$export$16a28057038b10ef) && (0, $dfad86e498c52aee$export$af88d00dbe7f521).log("[Profiling] cannot find profile for a span without a profile context");
                        continue;
                    }
                    // Remove the profile from the span context before sending, relay will take care of the rest.
                    if (context?.profile) delete context.profile;
                    const profile = (0, $d19c75133e07fa94$export$6285310796363de1)(profile_id);
                    if (!profile) {
                        (0, $fe45e6d5f124fb0c$export$16a28057038b10ef) && (0, $dfad86e498c52aee$export$af88d00dbe7f521).log(`[Profiling] Could not retrieve profile for span: ${profile_id}`);
                        continue;
                    }
                    const profileEvent = (0, $d19c75133e07fa94$export$5c2c5e805edd874f)(profile_id, start_timestamp, profile, profiledTransaction);
                    if (profileEvent) profilesToAddToEnvelope.push(profileEvent);
                }
                (0, $d19c75133e07fa94$export$4df36760a75f76bc)(envelope, profilesToAddToEnvelope);
            });
        }
    };
};
const $bc6a1c7deaf32184$export$2c7b5d6dd5622f23 = (0, $5cfb41e3e92106c4$export$2323046b9414659f)($bc6a1c7deaf32184$var$_browserProfilingIntegration);





const $51378b91d2e1775c$export$63196314a6cfeb0f = "SpotlightBrowser";
const $51378b91d2e1775c$var$_spotlightIntegration = (options = {})=>{
    const sidecarUrl = options.sidecarUrl || "http://localhost:8969/stream";
    return {
        name: $51378b91d2e1775c$export$63196314a6cfeb0f,
        setup: ()=>{
            (0, $fe45e6d5f124fb0c$export$16a28057038b10ef) && (0, $dfad86e498c52aee$export$af88d00dbe7f521).log("Using Sidecar URL", sidecarUrl);
        },
        // We don't want to send interaction transactions/root spans created from
        // clicks within Spotlight to Sentry. Neither do we want them to be sent to
        // spotlight.
        processEvent: (event)=>$51378b91d2e1775c$export$23b74ddf1b93645b(event) ? null : event,
        afterAllSetup: (client)=>{
            $51378b91d2e1775c$var$setupSidecarForwarding(client, sidecarUrl);
        }
    };
};
function $51378b91d2e1775c$var$setupSidecarForwarding(client, sidecarUrl) {
    const makeFetch = (0, $31c1fb7be891462e$export$e464f4a514ac28a8)("fetch");
    let failCount = 0;
    client.on("beforeEnvelope", (envelope)=>{
        if (failCount > 3) {
            (0, $dfad86e498c52aee$export$af88d00dbe7f521).warn("[Spotlight] Disabled Sentry -> Spotlight integration due to too many failed requests:", failCount);
            return;
        }
        makeFetch(sidecarUrl, {
            method: "POST",
            body: (0, $a293d580860d0106$export$32f9b428425aac85)(envelope),
            headers: {
                "Content-Type": "application/x-sentry-envelope"
            },
            mode: "cors"
        }).then((res)=>{
            if (res.status >= 200 && res.status < 400) // Reset failed requests counter on success
            failCount = 0;
        }, (err)=>{
            failCount++;
            (0, $dfad86e498c52aee$export$af88d00dbe7f521).error("Sentry SDK can't connect to Sidecar is it running? See: https://spotlightjs.com/sidecar/npx/", err);
        });
    });
}
/**
 * Use this integration to send errors and transactions to Spotlight.
 *
 * Learn more about spotlight at https://spotlightjs.com
 */ const $51378b91d2e1775c$export$a05c07c0f32f730a = (0, $5cfb41e3e92106c4$export$2323046b9414659f)($51378b91d2e1775c$var$_spotlightIntegration);
/**
 * Flags if the event is a transaction created from an interaction with the spotlight UI.
 */ function $51378b91d2e1775c$export$23b74ddf1b93645b(event) {
    return Boolean(event.type === "transaction" && event.spans && event.contexts && event.contexts.trace && event.contexts.trace.op === "ui.action.click" && event.spans.some(({ description: description })=>description?.includes("#sentry-spotlight")));
}




/**
 * Sentry integration for capturing feature flag evaluations from LaunchDarkly.
 *
 * See the [feature flag documentation](https://develop.sentry.dev/sdk/expected-features/#feature-flags) for more information.
 *
 * @example
 * ```
 * import * as Sentry from '@sentry/browser';
 * import {launchDarklyIntegration, buildLaunchDarklyFlagUsedInspector} from '@sentry/browser';
 * import * as LaunchDarkly from 'launchdarkly-js-client-sdk';
 *
 * Sentry.init(..., integrations: [launchDarklyIntegration()])
 * const ldClient = LaunchDarkly.initialize(..., {inspectors: [buildLaunchDarklyFlagUsedHandler()]});
 * ```
 */ const $f051f6a2f783abf3$export$7cd9c18538ed792e = (0, $5cfb41e3e92106c4$export$2323046b9414659f)(()=>{
    return {
        name: "LaunchDarkly",
        processEvent (event, _hint, _client) {
            return (0, $a286eb10ef04a60d$export$bbaa51f7b5642e0f)(event);
        }
    };
});
/**
 * LaunchDarkly hook to listen for and buffer flag evaluations. This needs to
 * be registered as an 'inspector' in LaunchDarkly initialize() options,
 * separately from `launchDarklyIntegration`. Both the hook and the integration
 * are needed to capture LaunchDarkly flags.
 */ function $f051f6a2f783abf3$export$f97714c0986edb0() {
    return {
        name: "sentry-flag-auditor",
        type: "flag-used",
        synchronous: true,
        /**
     * Handle a flag evaluation by storing its name and value on the current scope.
     */ method: (flagKey, flagDetail, _context)=>{
            (0, $a286eb10ef04a60d$export$8eeb712c9ea5b068)(flagKey, flagDetail.value);
            (0, $a286eb10ef04a60d$export$4de324656d9a2858)(flagKey, flagDetail.value);
        }
    };
}



const $0847159cb5419a92$export$a41102cd52abbd1b = (0, $5cfb41e3e92106c4$export$2323046b9414659f)(()=>{
    return {
        name: "OpenFeature",
        processEvent (event, _hint, _client) {
            return (0, $a286eb10ef04a60d$export$bbaa51f7b5642e0f)(event);
        }
    };
});
/**
 * OpenFeature Hook class implementation.
 */ class $0847159cb5419a92$export$f399add65bfd388e {
    /**
   * Successful evaluation result.
   */ after(_hookContext, evaluationDetails) {
        (0, $a286eb10ef04a60d$export$8eeb712c9ea5b068)(evaluationDetails.flagKey, evaluationDetails.value);
        (0, $a286eb10ef04a60d$export$4de324656d9a2858)(evaluationDetails.flagKey, evaluationDetails.value);
    }
    /**
   * On error evaluation result.
   */ error(hookContext, _error, _hookHints) {
        (0, $a286eb10ef04a60d$export$8eeb712c9ea5b068)(hookContext.flagKey, hookContext.defaultValue);
        (0, $a286eb10ef04a60d$export$4de324656d9a2858)(hookContext.flagKey, hookContext.defaultValue);
    }
}




/**
 * Sentry integration for capturing feature flag evaluations from the Unleash SDK.
 *
 * See the [feature flag documentation](https://develop.sentry.dev/sdk/expected-features/#feature-flags) for more information.
 *
 * @example
 * ```
 * import { UnleashClient } from 'unleash-proxy-client';
 * import * as Sentry from '@sentry/browser';
 *
 * Sentry.init({
 *   dsn: '___PUBLIC_DSN___',
 *   integrations: [Sentry.unleashIntegration({featureFlagClientClass: UnleashClient})],
 * });
 *
 * const unleash = new UnleashClient(...);
 * unleash.start();
 *
 * unleash.isEnabled('my-feature');
 * Sentry.captureException(new Error('something went wrong'));
 * ```
 */ const $bc0447b1d783ed24$export$e753ab651e68430d = (0, $5cfb41e3e92106c4$export$2323046b9414659f)(({ featureFlagClientClass: unleashClientClass })=>{
    return {
        name: "Unleash",
        setupOnce () {
            const unleashClientPrototype = unleashClientClass.prototype;
            (0, $90379bc90653c4b6$export$9563e054e6f787fb)(unleashClientPrototype, "isEnabled", $bc0447b1d783ed24$var$_wrappedIsEnabled);
        },
        processEvent (event, _hint, _client) {
            return (0, $a286eb10ef04a60d$export$bbaa51f7b5642e0f)(event);
        }
    };
});
/**
 * Wraps the UnleashClient.isEnabled method to capture feature flag evaluations. Its only side effect is writing to Sentry scope.
 *
 * This wrapper is safe for all isEnabled signatures. If the signature does not match (this: UnleashClient, toggleName: string, ...args: unknown[]) => boolean,
 * we log an error and return the original result.
 *
 * @param original - The original method.
 * @returns Wrapped method. Results should match the original.
 */ function $bc0447b1d783ed24$var$_wrappedIsEnabled(original) {
    return function(...args) {
        const toggleName = args[0];
        const result = original.apply(this, args);
        if (typeof toggleName === "string" && typeof result === "boolean") {
            (0, $a286eb10ef04a60d$export$8eeb712c9ea5b068)(toggleName, result);
            (0, $a286eb10ef04a60d$export$4de324656d9a2858)(toggleName, result);
        } else if (0, $fe45e6d5f124fb0c$export$16a28057038b10ef) (0, $dfad86e498c52aee$export$af88d00dbe7f521).error(`[Feature Flags] UnleashClient.isEnabled does not match expected signature. arg0: ${toggleName} (${typeof toggleName}), result: ${result} (${typeof result})`);
        return result;
    };
}



/**
 * Sentry integration for capturing feature flag evaluations from the Statsig js-client SDK.
 *
 * See the [feature flag documentation](https://develop.sentry.dev/sdk/expected-features/#feature-flags) for more information.
 *
 * @example
 * ```
 * import { StatsigClient } from '@statsig/js-client';
 * import * as Sentry from '@sentry/browser';
 *
 * const statsigClient = new StatsigClient();
 *
 * Sentry.init({
 *   dsn: '___PUBLIC_DSN___',
 *   integrations: [Sentry.statsigIntegration({featureFlagClient: statsigClient})],
 * });
 *
 * await statsigClient.initializeAsync();  // or statsigClient.initializeSync();
 *
 * const result = statsigClient.checkGate('my-feature-gate');
 * Sentry.captureException(new Error('something went wrong'));
 * ```
 */ const $bec224dbfaee6b5b$export$473918ef9c3b2ab7 = (0, $5cfb41e3e92106c4$export$2323046b9414659f)(({ featureFlagClient: statsigClient })=>{
    return {
        name: "Statsig",
        setup (_client) {
            statsigClient.on("gate_evaluation", (event)=>{
                (0, $a286eb10ef04a60d$export$8eeb712c9ea5b068)(event.gate.name, event.gate.value);
                (0, $a286eb10ef04a60d$export$4de324656d9a2858)(event.gate.name, event.gate.value);
            });
        },
        processEvent (event, _hint, _client) {
            return (0, $a286eb10ef04a60d$export$bbaa51f7b5642e0f)(event);
        }
    };
});



/**
 * A function to diagnose why the SDK might not be successfully sending data.
 *
 * Possible return values wrapped in a Promise:
 * - `"no-client-active"` - There was no active client when the function was called. This possibly means that the SDK was not initialized yet.
 * - `"sentry-unreachable"` - The Sentry SaaS servers were not reachable. This likely means that there is an ad blocker active on the page or that there are other connection issues.
 *
 * If the function doesn't detect an issue it resolves to `undefined`.
 */ async function $2565d0a939fc6789$export$fecc80c9f0e9c1b2() {
    const client = (0, $0b98faa1b87c8168$export$6bb76d6eba7e258c)();
    if (!client) return "no-client-active";
    if (!client.getDsn()) return "no-dsn-configured";
    try {
        // If fetch throws, there is likely an ad blocker active or there are other connective issues.
        await fetch(// We want this to be as close as possible to an actual ingest URL so that ad blockers will actually block the request
        // We are using the "sentry-sdks" org with id 447951 not to pollute any actual organizations.
        "https://o447951.ingest.sentry.io/api/1337/envelope/?sentry_version=7&sentry_key=1337&sentry_client=sentry.javascript.browser%2F1.33.7", {
            body: "{}",
            method: "POST",
            mode: "cors",
            credentials: "omit"
        });
    } catch  {
        return "sentry-unreachable";
    }
}





var $czKc9 = parcelRequire("czKc9");/**
 * Polyfill for the optional chain operator, `?.`, given previous conversion of the expression into an array of values,
 * descriptors, and functions.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 * See https://github.com/alangpierce/sucrase/blob/265887868966917f3b924ce38dfad01fbab1329f/src/transformers/OptionalChainingNullishTransformer.ts#L15
 *
 * @param ops Array result of expression conversion
 * @returns The value of the expression
 */ function $89603552ac3124a9$export$3cc482e6b02f32f7(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        // by checking for loose equality to `null`, we catch both `null` and `undefined`
        if ((op === "optionalAccess" || op === "optionalCall") && value == null) // really we're meaning to return `undefined` as an actual value here, but it saves bytes not to write it
        return;
        if (op === "access" || op === "optionalAccess") {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === "call" || op === "optionalCall") {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}


var $dmJ8B = parcelRequire("dmJ8B");
var $9fGKl = parcelRequire("9fGKl");
var $dR6t7 = parcelRequire("dR6t7");
var $4C0Qe = parcelRequire("4C0Qe");
var $iyYYs = parcelRequire("iyYYs");
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $8a1bc3da87759f5f$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;



/**
 * Check if Sentry auto-instrumentation should be disabled.
 *
 * @param getCurrentHub A method to fetch the current hub
 * @returns boolean
 */ // eslint-disable-next-line deprecation/deprecation
function $98cbc8e6b5922577$export$34db76d03eb96b7e(getCurrentHub) {
    // eslint-disable-next-line deprecation/deprecation
    const clientOptions = (0, $89603552ac3124a9$export$3cc482e6b02f32f7)([
        getCurrentHub,
        "call",
        (_)=>_(),
        "access",
        (_2)=>_2.getClient,
        "call",
        (_3)=>_3(),
        "optionalAccess",
        (_4)=>_4.getOptions,
        "call",
        (_5)=>_5()
    ]);
    const instrumenter = (0, $89603552ac3124a9$export$3cc482e6b02f32f7)([
        clientOptions,
        "optionalAccess",
        (_6)=>_6.instrumenter
    ]) || "sentry";
    return instrumenter !== "sentry";
}


/** Tracing integration for Apollo */ class $6e5dd3b1dd31093e$export$3db3e396472fda8d {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "Apollo";
    }
    /**
   * @inheritDoc
   */ /**
   * @inheritDoc
   */ constructor(options = {
        useNestjs: false
    }){
        this.name = $6e5dd3b1dd31093e$export$3db3e396472fda8d.id;
        this._useNest = !!options.useNestjs;
    }
    /** @inheritdoc */ loadDependency() {
        if (this._useNest) this._module = this._module || (0, $4C0Qe.loadModule)("@nestjs/graphql");
        else this._module = this._module || (0, $4C0Qe.loadModule)("apollo-server-core");
        return this._module;
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    setupOnce(_, getCurrentHub) {
        if ((0, $98cbc8e6b5922577$export$34db76d03eb96b7e)(getCurrentHub)) {
            (0, $8a1bc3da87759f5f$export$16a28057038b10ef) && (0, $iyYYs.logger).log("Apollo Integration is skipped because of instrumenter configuration.");
            return;
        }
        if (this._useNest) {
            const pkg = this.loadDependency();
            if (!pkg) {
                (0, $8a1bc3da87759f5f$export$16a28057038b10ef) && (0, $iyYYs.logger).error("Apollo-NestJS Integration was unable to require @nestjs/graphql package.");
                return;
            }
            /**
       * Iterate over resolvers of NestJS ResolversExplorerService before schemas are constructed.
       */ (0, $9fGKl.fill)(pkg.GraphQLFactory.prototype, "mergeWithSchema", function(orig) {
                return function(...args) {
                    (0, $9fGKl.fill)(this.resolversExplorerService, "explore", function(orig) {
                        return function() {
                            const resolvers = (0, $dmJ8B.arrayify)(orig.call(this));
                            const instrumentedResolvers = $6e5dd3b1dd31093e$var$instrumentResolvers(resolvers, getCurrentHub);
                            return instrumentedResolvers;
                        };
                    });
                    return orig.call(this, ...args);
                };
            });
        } else {
            const pkg = this.loadDependency();
            if (!pkg) {
                (0, $8a1bc3da87759f5f$export$16a28057038b10ef) && (0, $iyYYs.logger).error("Apollo Integration was unable to require apollo-server-core package.");
                return;
            }
            /**
       * Iterate over resolvers of the ApolloServer instance before schemas are constructed.
       */ (0, $9fGKl.fill)(pkg.ApolloServerBase.prototype, "constructSchema", function(orig) {
                return function() {
                    if (!this.config.resolvers) {
                        if (0, $8a1bc3da87759f5f$export$16a28057038b10ef) {
                            if (this.config.schema) {
                                (0, $iyYYs.logger).warn("Apollo integration is not able to trace `ApolloServer` instances constructed via `schema` property.If you are using NestJS with Apollo, please use `Sentry.Integrations.Apollo({ useNestjs: true })` instead.");
                                (0, $iyYYs.logger).warn();
                            } else if (this.config.modules) (0, $iyYYs.logger).warn("Apollo integration is not able to trace `ApolloServer` instances constructed via `modules` property.");
                            (0, $iyYYs.logger).error("Skipping tracing as no resolvers found on the `ApolloServer` instance.");
                        }
                        return orig.call(this);
                    }
                    const resolvers = (0, $dmJ8B.arrayify)(this.config.resolvers);
                    this.config.resolvers = $6e5dd3b1dd31093e$var$instrumentResolvers(resolvers, getCurrentHub);
                    return orig.call(this);
                };
            });
        }
    }
}
$6e5dd3b1dd31093e$export$3db3e396472fda8d.__initStatic();
// eslint-disable-next-line deprecation/deprecation
function $6e5dd3b1dd31093e$var$instrumentResolvers(resolvers, getCurrentHub) {
    return resolvers.map((model)=>{
        Object.keys(model).forEach((resolverGroupName)=>{
            Object.keys(model[resolverGroupName]).forEach((resolverName)=>{
                if (typeof model[resolverGroupName][resolverName] !== "function") return;
                $6e5dd3b1dd31093e$var$wrapResolver(model, resolverGroupName, resolverName, getCurrentHub);
            });
        });
        return model;
    });
}
/**
 * Wrap a single resolver which can be a parent of other resolvers and/or db operations.
 */ function $6e5dd3b1dd31093e$var$wrapResolver(model, resolverGroupName, resolverName, // eslint-disable-next-line deprecation/deprecation
getCurrentHub) {
    (0, $9fGKl.fill)(model[resolverGroupName], resolverName, function(orig) {
        return function(...args) {
            // eslint-disable-next-line deprecation/deprecation
            const scope = getCurrentHub().getScope();
            // eslint-disable-next-line deprecation/deprecation
            const parentSpan = scope.getSpan();
            // eslint-disable-next-line deprecation/deprecation
            const span = (0, $89603552ac3124a9$export$3cc482e6b02f32f7)([
                parentSpan,
                "optionalAccess",
                (_2)=>_2.startChild,
                "call",
                (_3)=>_3({
                        description: `${resolverGroupName}.${resolverName}`,
                        op: "graphql.resolve",
                        origin: "auto.graphql.apollo"
                    })
            ]);
            const rv = orig.call(this, ...args);
            if ((0, $dR6t7.isThenable)(rv)) return rv.then((res)=>{
                (0, $89603552ac3124a9$export$3cc482e6b02f32f7)([
                    span,
                    "optionalAccess",
                    (_4)=>_4.end,
                    "call",
                    (_5)=>_5()
                ]);
                return res;
            });
            (0, $89603552ac3124a9$export$3cc482e6b02f32f7)([
                span,
                "optionalAccess",
                (_6)=>_6.end,
                "call",
                (_7)=>_7()
            ]);
            return rv;
        };
    });
}


var $fBYWi = parcelRequire("fBYWi");
var $4kgMm = parcelRequire("4kgMm");
var $ejob9 = parcelRequire("ejob9");
var $ePKuD = parcelRequire("ePKuD");
var $1COtc = parcelRequire("1COtc");

var $6DrO1 = parcelRequire("6DrO1");
var $iyYYs = parcelRequire("iyYYs");
var $dGzPN = parcelRequire("dGzPN");


var $4kgMm = parcelRequire("4kgMm");
var $ceyhT = parcelRequire("ceyhT");

var $iyYYs = parcelRequire("iyYYs");


var $8a8aJ = parcelRequire("8a8aJ");
const $5e51d76f74d40e19$export$56d8a8a25bd48b81 = (0, $8a8aJ.GLOBAL_OBJ);


/**
 * Add a listener that cancels and finishes a transaction when the global
 * document is hidden.
 */ function $e5c6e0dc933aa8d6$export$6f18f55521af71a1() {
    if ((0, $5e51d76f74d40e19$export$56d8a8a25bd48b81).document) (0, $5e51d76f74d40e19$export$56d8a8a25bd48b81).document.addEventListener("visibilitychange", ()=>{
        // eslint-disable-next-line deprecation/deprecation
        const activeTransaction = (0, $4kgMm.getActiveTransaction)();
        if ((0, $5e51d76f74d40e19$export$56d8a8a25bd48b81).document.hidden && activeTransaction) {
            const statusType = "cancelled";
            const { op: op, status: status } = (0, $ceyhT.spanToJSON)(activeTransaction);
            (0, $8a1bc3da87759f5f$export$16a28057038b10ef) && (0, $iyYYs.logger).log(`[Tracing] Transaction: ${statusType} -> since tab moved to the background, op: ${op}`);
            // We should not set status if it is already set, this prevent important statuses like
            // error or data loss from being overwritten on transaction.
            if (!status) activeTransaction.setStatus(statusType);
            // TODO: Can we rewrite this to an attribute?
            // eslint-disable-next-line deprecation/deprecation
            activeTransaction.setTag("visibilitychange", "document.hidden");
            activeTransaction.end();
        }
    });
    else (0, $8a1bc3da87759f5f$export$16a28057038b10ef) && (0, $iyYYs.logger).warn("[Tracing] Could not set up background tab detection due to lack of global document");
}



var $hu8ps = parcelRequire("hu8ps");
var $iyYYs = parcelRequire("iyYYs");

const $729ab701af8c17c6$export$17679dccdd551979 = (callback, metric, reportAllChanges)=>{
    let prevValue;
    let delta;
    return (forceReport)=>{
        if (metric.value >= 0) {
            if (forceReport || reportAllChanges) {
                delta = metric.value - (prevValue || 0);
                // Report the metric if there's a non-zero delta or if no previous
                // value exists (which can happen in the case of the document becoming
                // hidden when the metric value is 0).
                // See: https://github.com/GoogleChrome/web-vitals/issues/14
                if (delta || prevValue === undefined) {
                    prevValue = metric.value;
                    metric.delta = delta;
                    callback(metric);
                }
            }
        }
    };
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Performantly generate a unique, 30-char string by combining a version
 * number, the current timestamp with a 13-digit number integer.
 * @return {string}
 */ const $58c93bd8ad346e55$export$407ea409d1f3b539 = ()=>{
    return `v3-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`;
};



/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $1eeea86275bf6bcc$var$getNavigationEntryFromPerformanceTiming = ()=>{
    // eslint-disable-next-line deprecation/deprecation
    const timing = (0, $5e51d76f74d40e19$export$56d8a8a25bd48b81).performance.timing;
    // eslint-disable-next-line deprecation/deprecation
    const type = (0, $5e51d76f74d40e19$export$56d8a8a25bd48b81).performance.navigation.type;
    const navigationEntry = {
        entryType: "navigation",
        startTime: 0,
        type: type == 2 ? "back_forward" : type === 1 ? "reload" : "navigate"
    };
    for(const key in timing)if (key !== "navigationStart" && key !== "toJSON") // eslint-disable-next-line deprecation/deprecation
    navigationEntry[key] = Math.max(timing[key] - timing.navigationStart, 0);
    return navigationEntry;
};
const $1eeea86275bf6bcc$export$6431553786c94949 = ()=>{
    if ((0, $5e51d76f74d40e19$export$56d8a8a25bd48b81).__WEB_VITALS_POLYFILL__) return (0, $5e51d76f74d40e19$export$56d8a8a25bd48b81).performance && (performance.getEntriesByType && performance.getEntriesByType("navigation")[0] || $1eeea86275bf6bcc$var$getNavigationEntryFromPerformanceTiming());
    else return (0, $5e51d76f74d40e19$export$56d8a8a25bd48b81).performance && performance.getEntriesByType && performance.getEntriesByType("navigation")[0];
};


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $50ace05518f32212$export$d3e828b3c7b5b845 = ()=>{
    const navEntry = (0, $1eeea86275bf6bcc$export$6431553786c94949)();
    return navEntry && navEntry.activationStart || 0;
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $bed15cf1f3860f35$export$3c29b44508a0612b = (name, value)=>{
    const navEntry = (0, $1eeea86275bf6bcc$export$6431553786c94949)();
    let navigationType = "navigate";
    if (navEntry) {
        if ((0, $5e51d76f74d40e19$export$56d8a8a25bd48b81).document && (0, $5e51d76f74d40e19$export$56d8a8a25bd48b81).document.prerendering || (0, $50ace05518f32212$export$d3e828b3c7b5b845)() > 0) navigationType = "prerender";
        else navigationType = navEntry.type.replace(/_/g, "-");
    }
    return {
        name: name,
        value: typeof value === "undefined" ? -1 : value,
        rating: "good",
        delta: 0,
        entries: [],
        id: (0, $58c93bd8ad346e55$export$407ea409d1f3b539)(),
        navigationType: navigationType
    };
};


/**
 * Takes a performance entry type and a callback function, and creates a
 * `PerformanceObserver` instance that will observe the specified entry type
 * with buffering enabled and call the callback _for each entry_.
 *
 * This function also feature-detects entry support and wraps the logic in a
 * try/catch to avoid errors in unsupporting browsers.
 */ const $d692688f8aa3df2b$export$d1203567a167490e = (type, callback, opts)=>{
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(type)) {
            const po = new PerformanceObserver((list)=>{
                callback(list.getEntries());
            });
            po.observe(Object.assign({
                type: type,
                buffered: true
            }, opts || {}));
            return po;
        }
    } catch (e) {
    // Do nothing.
    }
    return;
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $10a24f686f739cec$export$91ec2be6fdd8f1b4 = (cb, once)=>{
    const onHiddenOrPageHide = (event)=>{
        if (event.type === "pagehide" || (0, $5e51d76f74d40e19$export$56d8a8a25bd48b81).document.visibilityState === "hidden") {
            cb(event);
            if (once) {
                removeEventListener("visibilitychange", onHiddenOrPageHide, true);
                removeEventListener("pagehide", onHiddenOrPageHide, true);
            }
        }
    };
    if ((0, $5e51d76f74d40e19$export$56d8a8a25bd48b81).document) {
        addEventListener("visibilitychange", onHiddenOrPageHide, true);
        // Some browsers have buggy implementations of visibilitychange,
        // so we use pagehide in addition, just to be safe.
        addEventListener("pagehide", onHiddenOrPageHide, true);
    }
};


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the [CLS](https://web.dev/cls/) value for the current page and
 * calls the `callback` function once the value is ready to be reported, along
 * with all `layout-shift` performance entries that were used in the metric
 * value calculation. The reported value is a `double` (corresponding to a
 * [layout shift score](https://web.dev/cls/#layout-shift-score)).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** CLS should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $3d3901c53f504de5$export$a7873055838e5ad8 = (onReport, options = {})=>{
    const metric = (0, $bed15cf1f3860f35$export$3c29b44508a0612b)("CLS", 0);
    let report;
    let sessionValue = 0;
    let sessionEntries = [];
    // const handleEntries = (entries: Metric['entries']) => {
    const handleEntries = (entries)=>{
        entries.forEach((entry)=>{
            // Only count layout shifts without recent user input.
            if (!entry.hadRecentInput) {
                const firstSessionEntry = sessionEntries[0];
                const lastSessionEntry = sessionEntries[sessionEntries.length - 1];
                // If the entry occurred less than 1 second after the previous entry and
                // less than 5 seconds after the first entry in the session, include the
                // entry in the current session. Otherwise, start a new session.
                if (sessionValue && sessionEntries.length !== 0 && entry.startTime - lastSessionEntry.startTime < 1000 && entry.startTime - firstSessionEntry.startTime < 5000) {
                    sessionValue += entry.value;
                    sessionEntries.push(entry);
                } else {
                    sessionValue = entry.value;
                    sessionEntries = [
                        entry
                    ];
                }
                // If the current session value is larger than the current CLS value,
                // update CLS and the entries contributing to it.
                if (sessionValue > metric.value) {
                    metric.value = sessionValue;
                    metric.entries = sessionEntries;
                    if (report) report();
                }
            }
        });
    };
    const po = (0, $d692688f8aa3df2b$export$d1203567a167490e)("layout-shift", handleEntries);
    if (po) {
        report = (0, $729ab701af8c17c6$export$17679dccdd551979)(onReport, metric, options.reportAllChanges);
        const stopListening = ()=>{
            handleEntries(po.takeRecords());
            report(true);
        };
        (0, $10a24f686f739cec$export$91ec2be6fdd8f1b4)(stopListening);
        return stopListening;
    }
    return;
};





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $41a87e17ca9575f5$var$firstHiddenTime = -1;
const $41a87e17ca9575f5$var$initHiddenTime = ()=>{
    // If the document is hidden and not prerendering, assume it was always
    // hidden and the page was loaded in the background.
    if ((0, $5e51d76f74d40e19$export$56d8a8a25bd48b81).document && (0, $5e51d76f74d40e19$export$56d8a8a25bd48b81).document.visibilityState) $41a87e17ca9575f5$var$firstHiddenTime = (0, $5e51d76f74d40e19$export$56d8a8a25bd48b81).document.visibilityState === "hidden" && !(0, $5e51d76f74d40e19$export$56d8a8a25bd48b81).document.prerendering ? 0 : Infinity;
};
const $41a87e17ca9575f5$var$trackChanges = ()=>{
    // Update the time if/when the document becomes hidden.
    (0, $10a24f686f739cec$export$91ec2be6fdd8f1b4)(({ timeStamp: timeStamp })=>{
        $41a87e17ca9575f5$var$firstHiddenTime = timeStamp;
    }, true);
};
const $41a87e17ca9575f5$export$443f86b2c77012c4 = ()=>{
    if ($41a87e17ca9575f5$var$firstHiddenTime < 0) {
        // If the document is hidden when this code runs, assume it was hidden
        // since navigation start. This isn't a perfect heuristic, but it's the
        // best we can do until an API is available to support querying past
        // visibilityState.
        $41a87e17ca9575f5$var$initHiddenTime();
        $41a87e17ca9575f5$var$trackChanges();
    }
    return {
        get firstHiddenTime () {
            return $41a87e17ca9575f5$var$firstHiddenTime;
        }
    };
};





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the [FID](https://web.dev/fid/) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `first-input` performance entry used to determine the value. The
 * reported value is a `DOMHighResTimeStamp`.
 *
 * _**Important:** since FID is only reported after the user interacts with the
 * page, it's possible that it will not be reported for some page loads._
 */ const $9925c747c226df35$export$39705a25c49af873 = (onReport)=>{
    const visibilityWatcher = (0, $41a87e17ca9575f5$export$443f86b2c77012c4)();
    const metric = (0, $bed15cf1f3860f35$export$3c29b44508a0612b)("FID");
    // eslint-disable-next-line prefer-const
    let report;
    const handleEntry = (entry)=>{
        // Only report if the page wasn't hidden prior to the first input.
        if (entry.startTime < visibilityWatcher.firstHiddenTime) {
            metric.value = entry.processingStart - entry.startTime;
            metric.entries.push(entry);
            report(true);
        }
    };
    const handleEntries = (entries)=>{
        entries.forEach(handleEntry);
    };
    const po = (0, $d692688f8aa3df2b$export$d1203567a167490e)("first-input", handleEntries);
    report = (0, $729ab701af8c17c6$export$17679dccdd551979)(onReport, metric);
    if (po) (0, $10a24f686f739cec$export$91ec2be6fdd8f1b4)(()=>{
        handleEntries(po.takeRecords());
        po.disconnect();
    }, true);
};







let $bd0988c238cf611b$var$interactionCountEstimate = 0;
let $bd0988c238cf611b$var$minKnownInteractionId = Infinity;
let $bd0988c238cf611b$var$maxKnownInteractionId = 0;
const $bd0988c238cf611b$var$updateEstimate = (entries)=>{
    entries.forEach((e)=>{
        if (e.interactionId) {
            $bd0988c238cf611b$var$minKnownInteractionId = Math.min($bd0988c238cf611b$var$minKnownInteractionId, e.interactionId);
            $bd0988c238cf611b$var$maxKnownInteractionId = Math.max($bd0988c238cf611b$var$maxKnownInteractionId, e.interactionId);
            $bd0988c238cf611b$var$interactionCountEstimate = $bd0988c238cf611b$var$maxKnownInteractionId ? ($bd0988c238cf611b$var$maxKnownInteractionId - $bd0988c238cf611b$var$minKnownInteractionId) / 7 + 1 : 0;
        }
    });
};
let $bd0988c238cf611b$var$po;
/**
 * Returns the `interactionCount` value using the native API (if available)
 * or the polyfill estimate in this module.
 */ const $bd0988c238cf611b$export$8a962f2683a476d1 = ()=>{
    return $bd0988c238cf611b$var$po ? $bd0988c238cf611b$var$interactionCountEstimate : performance.interactionCount || 0;
};
/**
 * Feature detects native support or initializes the polyfill if needed.
 */ const $bd0988c238cf611b$export$67d90cda6b78a2eb = ()=>{
    if ("interactionCount" in performance || $bd0988c238cf611b$var$po) return;
    $bd0988c238cf611b$var$po = (0, $d692688f8aa3df2b$export$d1203567a167490e)("event", $bd0988c238cf611b$var$updateEstimate, {
        type: "event",
        buffered: true,
        durationThreshold: 0
    });
};


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns the interaction count since the last bfcache restore (or for the
 * full page lifecycle if there were no bfcache restores).
 */ const $257d3851642c72d6$var$getInteractionCountForNavigation = ()=>{
    return (0, $bd0988c238cf611b$export$8a962f2683a476d1)();
};
// To prevent unnecessary memory usage on pages with lots of interactions,
// store at most 10 of the longest interactions to consider as INP candidates.
const $257d3851642c72d6$var$MAX_INTERACTIONS_TO_CONSIDER = 10;
// A list of longest interactions on the page (by latency) sorted so the
// longest one is first. The list is as most MAX_INTERACTIONS_TO_CONSIDER long.
const $257d3851642c72d6$var$longestInteractionList = [];
// A mapping of longest interactions by their interaction ID.
// This is used for faster lookup.
const $257d3851642c72d6$var$longestInteractionMap = {};
/**
 * Takes a performance entry and adds it to the list of worst interactions
 * if its duration is long enough to make it among the worst. If the
 * entry is part of an existing interaction, it is merged and the latency
 * and entries list is updated as needed.
 */ const $257d3851642c72d6$var$processEntry = (entry)=>{
    // The least-long of the 10 longest interactions.
    const minLongestInteraction = $257d3851642c72d6$var$longestInteractionList[$257d3851642c72d6$var$longestInteractionList.length - 1];
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const existingInteraction = $257d3851642c72d6$var$longestInteractionMap[entry.interactionId];
    // Only process the entry if it's possibly one of the ten longest,
    // or if it's part of an existing interaction.
    if (existingInteraction || $257d3851642c72d6$var$longestInteractionList.length < $257d3851642c72d6$var$MAX_INTERACTIONS_TO_CONSIDER || entry.duration > minLongestInteraction.latency) {
        // If the interaction already exists, update it. Otherwise create one.
        if (existingInteraction) {
            existingInteraction.entries.push(entry);
            existingInteraction.latency = Math.max(existingInteraction.latency, entry.duration);
        } else {
            const interaction = {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                id: entry.interactionId,
                latency: entry.duration,
                entries: [
                    entry
                ]
            };
            $257d3851642c72d6$var$longestInteractionMap[interaction.id] = interaction;
            $257d3851642c72d6$var$longestInteractionList.push(interaction);
        }
        // Sort the entries by latency (descending) and keep only the top ten.
        $257d3851642c72d6$var$longestInteractionList.sort((a, b)=>b.latency - a.latency);
        $257d3851642c72d6$var$longestInteractionList.splice($257d3851642c72d6$var$MAX_INTERACTIONS_TO_CONSIDER).forEach((i)=>{
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete $257d3851642c72d6$var$longestInteractionMap[i.id];
        });
    }
};
/**
 * Returns the estimated p98 longest interaction based on the stored
 * interaction candidates and the interaction count for the current page.
 */ const $257d3851642c72d6$var$estimateP98LongestInteraction = ()=>{
    const candidateInteractionIndex = Math.min($257d3851642c72d6$var$longestInteractionList.length - 1, Math.floor($257d3851642c72d6$var$getInteractionCountForNavigation() / 50));
    return $257d3851642c72d6$var$longestInteractionList[candidateInteractionIndex];
};
/**
 * Calculates the [INP](https://web.dev/responsiveness/) value for the current
 * page and calls the `callback` function once the value is ready, along with
 * the `event` performance entries reported for that interaction. The reported
 * value is a `DOMHighResTimeStamp`.
 *
 * A custom `durationThreshold` configuration option can optionally be passed to
 * control what `event-timing` entries are considered for INP reporting. The
 * default threshold is `40`, which means INP scores of less than 40 are
 * reported as 0. Note that this will not affect your 75th percentile INP value
 * unless that value is also less than 40 (well below the recommended
 * [good](https://web.dev/inp/#what-is-a-good-inp-score) threshold).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** INP should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $257d3851642c72d6$export$7df4b36ecaed99e1 = (onReport, opts)=>{
    // Set defaults
    // eslint-disable-next-line no-param-reassign
    opts = opts || {};
    // https://web.dev/inp/#what's-a-%22good%22-inp-value
    // const thresholds = [200, 500];
    // TODO(philipwalton): remove once the polyfill is no longer needed.
    (0, $bd0988c238cf611b$export$67d90cda6b78a2eb)();
    const metric = (0, $bed15cf1f3860f35$export$3c29b44508a0612b)("INP");
    // eslint-disable-next-line prefer-const
    let report;
    const handleEntries = (entries)=>{
        entries.forEach((entry)=>{
            if (entry.interactionId) $257d3851642c72d6$var$processEntry(entry);
            // Entries of type `first-input` don't currently have an `interactionId`,
            // so to consider them in INP we have to first check that an existing
            // entry doesn't match the `duration` and `startTime`.
            // Note that this logic assumes that `event` entries are dispatched
            // before `first-input` entries. This is true in Chrome but it is not
            // true in Firefox; however, Firefox doesn't support interactionId, so
            // it's not an issue at the moment.
            // TODO(philipwalton): remove once crbug.com/1325826 is fixed.
            if (entry.entryType === "first-input") {
                const noMatchingEntry = !$257d3851642c72d6$var$longestInteractionList.some((interaction)=>{
                    return interaction.entries.some((prevEntry)=>{
                        return entry.duration === prevEntry.duration && entry.startTime === prevEntry.startTime;
                    });
                });
                if (noMatchingEntry) $257d3851642c72d6$var$processEntry(entry);
            }
        });
        const inp = $257d3851642c72d6$var$estimateP98LongestInteraction();
        if (inp && inp.latency !== metric.value) {
            metric.value = inp.latency;
            metric.entries = inp.entries;
            report();
        }
    };
    const po = (0, $d692688f8aa3df2b$export$d1203567a167490e)("event", handleEntries, {
        // Event Timing entries have their durations rounded to the nearest 8ms,
        // so a duration of 40ms would be any event that spans 2.5 or more frames
        // at 60Hz. This threshold is chosen to strike a balance between usefulness
        // and performance. Running this callback for any interaction that spans
        // just one or two frames is likely not worth the insight that could be
        // gained.
        durationThreshold: opts.durationThreshold || 40
    });
    report = (0, $729ab701af8c17c6$export$17679dccdd551979)(onReport, metric, opts.reportAllChanges);
    if (po) {
        // Also observe entries of type `first-input`. This is useful in cases
        // where the first interaction is less than the `durationThreshold`.
        po.observe({
            type: "first-input",
            buffered: true
        });
        (0, $10a24f686f739cec$export$91ec2be6fdd8f1b4)(()=>{
            handleEntries(po.takeRecords());
            // If the interaction count shows that there were interactions but
            // none were captured by the PerformanceObserver, report a latency of 0.
            if (metric.value < 0 && $257d3851642c72d6$var$getInteractionCountForNavigation() > 0) {
                metric.value = 0;
                metric.entries = [];
            }
            report(true);
        });
    }
};









/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $99738a96073f41aa$var$reportedMetricIDs = {};
/**
 * Calculates the [LCP](https://web.dev/lcp/) value for the current page and
 * calls the `callback` function once the value is ready (along with the
 * relevant `largest-contentful-paint` performance entry used to determine the
 * value). The reported value is a `DOMHighResTimeStamp`.
 */ const $99738a96073f41aa$export$947b1626ab8d5632 = (onReport)=>{
    const visibilityWatcher = (0, $41a87e17ca9575f5$export$443f86b2c77012c4)();
    const metric = (0, $bed15cf1f3860f35$export$3c29b44508a0612b)("LCP");
    let report;
    const handleEntries = (entries)=>{
        const lastEntry = entries[entries.length - 1];
        if (lastEntry) {
            // The startTime attribute returns the value of the renderTime if it is
            // not 0, and the value of the loadTime otherwise. The activationStart
            // reference is used because LCP should be relative to page activation
            // rather than navigation start if the page was prerendered.
            const value = Math.max(lastEntry.startTime - (0, $50ace05518f32212$export$d3e828b3c7b5b845)(), 0);
            // Only report if the page wasn't hidden prior to LCP.
            if (value < visibilityWatcher.firstHiddenTime) {
                metric.value = value;
                metric.entries = [
                    lastEntry
                ];
                report();
            }
        }
    };
    const po = (0, $d692688f8aa3df2b$export$d1203567a167490e)("largest-contentful-paint", handleEntries);
    if (po) {
        report = (0, $729ab701af8c17c6$export$17679dccdd551979)(onReport, metric);
        const stopListening = ()=>{
            if (!$99738a96073f41aa$var$reportedMetricIDs[metric.id]) {
                handleEntries(po.takeRecords());
                po.disconnect();
                $99738a96073f41aa$var$reportedMetricIDs[metric.id] = true;
                report(true);
            }
        };
        // Stop listening after input. Note: while scrolling is an input that
        // stop LCP observation, it's unreliable since it can be programmatically
        // generated. See: https://github.com/GoogleChrome/web-vitals/issues/75
        [
            "keydown",
            "click"
        ].forEach((type)=>{
            if ((0, $5e51d76f74d40e19$export$56d8a8a25bd48b81).document) addEventListener(type, stopListening, {
                once: true,
                capture: true
            });
        });
        (0, $10a24f686f739cec$export$91ec2be6fdd8f1b4)(stopListening, true);
        return stopListening;
    }
    return;
};








/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Runs in the next task after the page is done loading and/or prerendering.
 * @param callback
 */ const $b5261f452d2bdafe$var$whenReady = (callback)=>{
    if (!(0, $5e51d76f74d40e19$export$56d8a8a25bd48b81).document) return;
    if ((0, $5e51d76f74d40e19$export$56d8a8a25bd48b81).document.prerendering) addEventListener("prerenderingchange", ()=>$b5261f452d2bdafe$var$whenReady(callback), true);
    else if ((0, $5e51d76f74d40e19$export$56d8a8a25bd48b81).document.readyState !== "complete") addEventListener("load", ()=>$b5261f452d2bdafe$var$whenReady(callback), true);
    else // Queue a task so the callback runs after `loadEventEnd`.
    setTimeout(callback, 0);
};
/**
 * Calculates the [TTFB](https://web.dev/time-to-first-byte/) value for the
 * current page and calls the `callback` function once the page has loaded,
 * along with the relevant `navigation` performance entry used to determine the
 * value. The reported value is a `DOMHighResTimeStamp`.
 *
 * Note, this function waits until after the page is loaded to call `callback`
 * in order to ensure all properties of the `navigation` entry are populated.
 * This is useful if you want to report on other metrics exposed by the
 * [Navigation Timing API](https://w3c.github.io/navigation-timing/). For
 * example, the TTFB metric starts from the page's [time
 * origin](https://www.w3.org/TR/hr-time-2/#sec-time-origin), which means it
 * includes time spent on DNS lookup, connection negotiation, network latency,
 * and server processing time.
 */ const $b5261f452d2bdafe$export$33a01e6c5f2c7e33 = (onReport, opts)=>{
    // Set defaults
    // eslint-disable-next-line no-param-reassign
    opts = opts || {};
    // https://web.dev/ttfb/#what-is-a-good-ttfb-score
    // const thresholds = [800, 1800];
    const metric = (0, $bed15cf1f3860f35$export$3c29b44508a0612b)("TTFB");
    const report = (0, $729ab701af8c17c6$export$17679dccdd551979)(onReport, metric, opts.reportAllChanges);
    $b5261f452d2bdafe$var$whenReady(()=>{
        const navEntry = (0, $1eeea86275bf6bcc$export$6431553786c94949)();
        if (navEntry) {
            // The activationStart reference is used because TTFB should be
            // relative to page activation rather than navigation start if the
            // page was prerendered. But in cases where `activationStart` occurs
            // after the first byte is received, this time should be clamped at 0.
            metric.value = Math.max(navEntry.responseStart - (0, $50ace05518f32212$export$d3e828b3c7b5b845)(), 0);
            // In some cases the value reported is negative or is larger
            // than the current page time. Ignore these cases:
            // https://github.com/GoogleChrome/web-vitals/issues/137
            // https://github.com/GoogleChrome/web-vitals/issues/162
            if (metric.value < 0 || metric.value > performance.now()) return;
            metric.entries = [
                navEntry
            ];
            report(true);
        }
    });
};


const $6b49d60e25dc0568$var$handlers = {};
const $6b49d60e25dc0568$var$instrumented = {};
let $6b49d60e25dc0568$var$_previousCls;
let $6b49d60e25dc0568$var$_previousFid;
let $6b49d60e25dc0568$var$_previousLcp;
let $6b49d60e25dc0568$var$_previousTtfb;
let $6b49d60e25dc0568$var$_previousInp;
/**
 * Add a callback that will be triggered when a CLS metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for CLS when the cleanup callback is called.
 * This will lead to the CLS being finalized and frozen.
 */ function $6b49d60e25dc0568$export$861b82818b37ba5b(callback, stopOnCallback = false) {
    return $6b49d60e25dc0568$var$addMetricObserver("cls", callback, $6b49d60e25dc0568$var$instrumentCls, $6b49d60e25dc0568$var$_previousCls, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a LCP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for LCP when the cleanup callback is called.
 * This will lead to the LCP being finalized and frozen.
 */ function $6b49d60e25dc0568$export$3fd4b53331200102(callback, stopOnCallback = false) {
    return $6b49d60e25dc0568$var$addMetricObserver("lcp", callback, $6b49d60e25dc0568$var$instrumentLcp, $6b49d60e25dc0568$var$_previousLcp, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a FID metric is available.
 */ function $6b49d60e25dc0568$export$699d9529c099a797(callback) {
    return $6b49d60e25dc0568$var$addMetricObserver("ttfb", callback, $6b49d60e25dc0568$var$instrumentTtfb, $6b49d60e25dc0568$var$_previousTtfb);
}
/**
 * Add a callback that will be triggered when a FID metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $6b49d60e25dc0568$export$2707d7471c0b918f(callback) {
    return $6b49d60e25dc0568$var$addMetricObserver("fid", callback, $6b49d60e25dc0568$var$instrumentFid, $6b49d60e25dc0568$var$_previousFid);
}
/**
 * Add a callback that will be triggered when a INP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $6b49d60e25dc0568$export$da3b76aa2022cbd7(callback) {
    return $6b49d60e25dc0568$var$addMetricObserver("inp", callback, $6b49d60e25dc0568$var$instrumentInp, $6b49d60e25dc0568$var$_previousInp);
}
/**
 * Add a callback that will be triggered when a performance observer is triggered,
 * and receives the entries of the observer.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $6b49d60e25dc0568$export$69816c1a049f8db6(type, callback) {
    $6b49d60e25dc0568$var$addHandler(type, callback);
    if (!$6b49d60e25dc0568$var$instrumented[type]) {
        $6b49d60e25dc0568$var$instrumentPerformanceObserver(type);
        $6b49d60e25dc0568$var$instrumented[type] = true;
    }
    return $6b49d60e25dc0568$var$getCleanupCallback(type, callback);
}
/** Trigger all handlers of a given type. */ function $6b49d60e25dc0568$var$triggerHandlers(type, data) {
    const typeHandlers = $6b49d60e25dc0568$var$handlers[type];
    if (!typeHandlers || !typeHandlers.length) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $8a1bc3da87759f5f$export$16a28057038b10ef) && (0, $iyYYs.logger).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $hu8ps.getFunctionName)(handler)}\nError:`, e);
    }
}
function $6b49d60e25dc0568$var$instrumentCls() {
    return (0, $3d3901c53f504de5$export$a7873055838e5ad8)((metric)=>{
        $6b49d60e25dc0568$var$triggerHandlers("cls", {
            metric: metric
        });
        $6b49d60e25dc0568$var$_previousCls = metric;
    }, {
        reportAllChanges: true
    });
}
function $6b49d60e25dc0568$var$instrumentFid() {
    return (0, $9925c747c226df35$export$39705a25c49af873)((metric)=>{
        $6b49d60e25dc0568$var$triggerHandlers("fid", {
            metric: metric
        });
        $6b49d60e25dc0568$var$_previousFid = metric;
    });
}
function $6b49d60e25dc0568$var$instrumentLcp() {
    return (0, $99738a96073f41aa$export$947b1626ab8d5632)((metric)=>{
        $6b49d60e25dc0568$var$triggerHandlers("lcp", {
            metric: metric
        });
        $6b49d60e25dc0568$var$_previousLcp = metric;
    });
}
function $6b49d60e25dc0568$var$instrumentTtfb() {
    return (0, $b5261f452d2bdafe$export$33a01e6c5f2c7e33)((metric)=>{
        $6b49d60e25dc0568$var$triggerHandlers("ttfb", {
            metric: metric
        });
        $6b49d60e25dc0568$var$_previousTtfb = metric;
    });
}
function $6b49d60e25dc0568$var$instrumentInp() {
    return (0, $257d3851642c72d6$export$7df4b36ecaed99e1)((metric)=>{
        $6b49d60e25dc0568$var$triggerHandlers("inp", {
            metric: metric
        });
        $6b49d60e25dc0568$var$_previousInp = metric;
    });
}
function $6b49d60e25dc0568$var$addMetricObserver(type, callback, instrumentFn, previousValue, stopOnCallback = false) {
    $6b49d60e25dc0568$var$addHandler(type, callback);
    let stopListening;
    if (!$6b49d60e25dc0568$var$instrumented[type]) {
        stopListening = instrumentFn();
        $6b49d60e25dc0568$var$instrumented[type] = true;
    }
    if (previousValue) callback({
        metric: previousValue
    });
    return $6b49d60e25dc0568$var$getCleanupCallback(type, callback, stopOnCallback ? stopListening : undefined);
}
function $6b49d60e25dc0568$var$instrumentPerformanceObserver(type) {
    const options = {};
    // Special per-type options we want to use
    if (type === "event") options.durationThreshold = 0;
    (0, $d692688f8aa3df2b$export$d1203567a167490e)(type, (entries)=>{
        $6b49d60e25dc0568$var$triggerHandlers(type, {
            entries: entries
        });
    }, options);
}
function $6b49d60e25dc0568$var$addHandler(type, handler) {
    $6b49d60e25dc0568$var$handlers[type] = $6b49d60e25dc0568$var$handlers[type] || [];
    $6b49d60e25dc0568$var$handlers[type].push(handler);
}
// Get a callback which can be called to remove the instrumentation handler
function $6b49d60e25dc0568$var$getCleanupCallback(type, callback, stopListening) {
    return ()=>{
        if (stopListening) stopListening();
        const typeHandlers = $6b49d60e25dc0568$var$handlers[type];
        if (!typeHandlers) return;
        const index = typeHandlers.indexOf(callback);
        if (index !== -1) typeHandlers.splice(index, 1);
    };
}



var $5rgwG = parcelRequire("5rgwG");

var $iyYYs = parcelRequire("iyYYs");
/** Regular expression used to parse a Dsn. */ const $0e35fb3a56a38ccc$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $0e35fb3a56a38ccc$var$isValidProtocol(protocol) {
    return protocol === "http" || protocol === "https";
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function $0e35fb3a56a38ccc$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ""}` + `@${host}${port ? `:${port}` : ""}/${path ? `${path}/` : path}${projectId}`;
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function $0e35fb3a56a38ccc$export$b892860177f70a30(str) {
    const match = $0e35fb3a56a38ccc$var$DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        (0, $iyYYs.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return undefined;
    }
    const [protocol, publicKey, pass = "", host, port = "", lastPath] = match.slice(1);
    let path = "";
    let projectId = lastPath;
    const split = projectId.split("/");
    if (split.length > 1) {
        path = split.slice(0, -1).join("/");
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $0e35fb3a56a38ccc$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $0e35fb3a56a38ccc$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || "",
        pass: components.pass || "",
        host: components.host,
        port: components.port || "",
        path: components.path || "",
        projectId: components.projectId
    };
}
function $0e35fb3a56a38ccc$var$validateDsn(dsn) {
    if (!(0, $5rgwG.DEBUG_BUILD)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        "protocol",
        "publicKey",
        "host",
        "projectId"
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $iyYYs.logger).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $iyYYs.logger).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$0e35fb3a56a38ccc$var$isValidProtocol(protocol)) {
        (0, $iyYYs.logger).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $iyYYs.logger).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function $0e35fb3a56a38ccc$export$128827c3562ec0cb(from) {
    const components = typeof from === "string" ? $0e35fb3a56a38ccc$export$b892860177f70a30(from) : $0e35fb3a56a38ccc$var$dsnFromComponents(from);
    if (!components || !$0e35fb3a56a38ccc$var$validateDsn(components)) return undefined;
    return components;
}



var $l7pai = parcelRequire("l7pai");

var $9fGKl = parcelRequire("9fGKl");
/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $62ad72e6523a5f50$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $62ad72e6523a5f50$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function $62ad72e6523a5f50$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function $62ad72e6523a5f50$export$604a45d95a155e2b(envelope, types) {
    return $62ad72e6523a5f50$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
/**
 * Encode a string to UTF8.
 */ function $62ad72e6523a5f50$var$encodeUTF8(input, textEncoder) {
    const utf8 = textEncoder || new TextEncoder();
    return utf8.encode(input);
}
/**
 * Serializes an envelope.
 */ function $62ad72e6523a5f50$export$32f9b428425aac85(envelope, textEncoder) {
    const [envHeaders, items] = envelope;
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === "string") parts = typeof next === "string" ? parts + next : [
            $62ad72e6523a5f50$var$encodeUTF8(parts, textEncoder),
            next
        ];
        else parts.push(typeof next === "string" ? $62ad72e6523a5f50$var$encodeUTF8(next, textEncoder) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`\n${JSON.stringify(itemHeaders)}\n`);
        if (typeof payload === "string" || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch (e) {
                // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.strinify()` still
                // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                // performance impact but in this case a performance hit is better than throwing.
                stringifiedPayload = JSON.stringify((0, $l7pai.normalize)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === "string" ? parts : $62ad72e6523a5f50$var$concatBuffers(parts);
}
function $62ad72e6523a5f50$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
/**
 * Parses an envelope
 */ function $62ad72e6523a5f50$export$3338d0c7b6e17a2b(env, textEncoder, textDecoder) {
    let buffer = typeof env === "string" ? textEncoder.encode(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse(textDecoder.decode(readBinary(i)));
    }
    const envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === "number" ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates attachment envelope items
 */ function $62ad72e6523a5f50$export$d8fc80952cc31fa4(attachment, textEncoder) {
    const buffer = typeof attachment.data === "string" ? $62ad72e6523a5f50$var$encodeUTF8(attachment.data, textEncoder) : attachment.data;
    return [
        (0, $9fGKl.dropUndefinedKeys)({
            type: "attachment",
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        }),
        buffer
    ];
}
const $62ad72e6523a5f50$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
    session: "session",
    sessions: "session",
    attachment: "attachment",
    transaction: "transaction",
    event: "error",
    client_report: "internal",
    user_report: "default",
    profile: "profile",
    replay_event: "replay",
    replay_recording: "replay",
    check_in: "monitor",
    feedback: "feedback",
    span: "span",
    statsd: "metric_bucket"
};
/**
 * Maps the type of an envelope item to a data category.
 */ function $62ad72e6523a5f50$export$b11169581eeaf237(type) {
    return $62ad72e6523a5f50$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}
/** Extracts the minimal SDK info from the metadata or an events */ function $62ad72e6523a5f50$export$d369f3b2758f6743(metadataOrEvent) {
    if (!metadataOrEvent || !metadataOrEvent.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function $62ad72e6523a5f50$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    const dynamicSamplingContext = event.sdkProcessingMetadata && event.sdkProcessingMetadata.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $0e35fb3a56a38ccc$export$44d472fbb931a776)(dsn)
        },
        ...dynamicSamplingContext && {
            trace: (0, $9fGKl.dropUndefinedKeys)({
                ...dynamicSamplingContext
            })
        }
    };
}


/**
 * Create envelope from Span item.
 */ function $eb11c280a234a052$export$19a0081d4b39d77(spans, dsn) {
    const headers = {
        sent_at: new Date().toISOString()
    };
    if (dsn) headers.dsn = (0, $0e35fb3a56a38ccc$export$44d472fbb931a776)(dsn);
    const items = spans.map($eb11c280a234a052$var$createSpanItem);
    return (0, $62ad72e6523a5f50$export$f93f7f385160c44e)(headers, items);
}
function $eb11c280a234a052$var$createSpanItem(span) {
    const spanHeaders = {
        type: "span"
    };
    return [
        spanHeaders,
        span
    ];
}


var $4kgMm = parcelRequire("4kgMm");
var $ejob9 = parcelRequire("ejob9");
var $bRL0a = parcelRequire("bRL0a");
var $bbUDW = parcelRequire("bbUDW");
var $4kgMm = parcelRequire("4kgMm");
/**
 * Adds a measurement to the current active transaction.
 */ function $96d2cd9114d3cb84$export$7cc31b475d33a706(name, value, unit) {
    // eslint-disable-next-line deprecation/deprecation
    const transaction = (0, $4kgMm.getActiveTransaction)();
    if (transaction) // eslint-disable-next-line deprecation/deprecation
    transaction.setMeasurement(name, value, unit);
}


var $lBUtp = parcelRequire("lBUtp");
var $ceyhT = parcelRequire("ceyhT");

var $ggG8j = parcelRequire("ggG8j");
var $6DrO1 = parcelRequire("6DrO1");
var $iyYYs = parcelRequire("iyYYs");/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function $73075039f785ecac$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    const query = match[6] || "";
    const fragment = match[8] || "";
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function $73075039f785ecac$export$ce084c78234bd35(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
/**
 * Returns number of URL segments of a passed string URL.
 */ function $73075039f785ecac$export$69dd85280a8d374c(url) {
    // split at '/' or at '\/' to split regex urls correctly
    return url.split(/\\?\//).filter((s)=>s.length > 0 && s !== ",").length;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span description
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $73075039f785ecac$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host && host// Always filter out authority
    .replace(/^.*@/, "[filtered]:[filtered]@")// Don't show standard :80 (http) and :443 (https) ports to reduce the noise
    // TODO: Use new URL global if it exists
    .replace(/(:80)$/, "").replace(/(:443)$/, "") || "";
    return `${protocol ? `${protocol}://` : ""}${filteredHost}${path}`;
}






/**
 * Checks if a given value is a valid measurement value.
 */ function $a04297ea263546cc$export$27169ccae1b439e3(value) {
    return typeof value === "number" && isFinite(value);
}
/**
 * Helper function to start child on transactions. This function will make sure that the transaction will
 * use the start timestamp of the created child span if it is earlier than the transactions actual
 * start timestamp.
 *
 * Note: this will not be possible anymore in v8,
 * unless we do some special handling for browser here...
 */ function $a04297ea263546cc$export$8bd469e1f37aa721(transaction, { startTimestamp: startTimestamp, ...ctx }) {
    // eslint-disable-next-line deprecation/deprecation
    if (startTimestamp && transaction.startTimestamp > startTimestamp) // eslint-disable-next-line deprecation/deprecation
    transaction.startTimestamp = startTimestamp;
    // eslint-disable-next-line deprecation/deprecation
    return transaction.startChild({
        startTimestamp: startTimestamp,
        ...ctx
    });
}



const $cc0305d4af214257$var$MAX_INT_AS_BYTES = 2147483647;
/**
 * Converts from milliseconds to seconds
 * @param time time in ms
 */ function $cc0305d4af214257$var$msToSec(time) {
    return time / 1000;
}
function $cc0305d4af214257$var$getBrowserPerformanceAPI() {
    // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
    return (0, $5e51d76f74d40e19$export$56d8a8a25bd48b81) && (0, $5e51d76f74d40e19$export$56d8a8a25bd48b81).addEventListener && (0, $5e51d76f74d40e19$export$56d8a8a25bd48b81).performance;
}
let $cc0305d4af214257$var$_performanceCursor = 0;
let $cc0305d4af214257$var$_measurements = {};
let $cc0305d4af214257$var$_lcpEntry;
let $cc0305d4af214257$var$_clsEntry;
/**
 * Start tracking web vitals.
 * The callback returned by this function can be used to stop tracking & ensure all measurements are final & captured.
 *
 * @returns A function that forces web vitals collection
 */ function $cc0305d4af214257$export$7c69f0412d101b88() {
    const performance = $cc0305d4af214257$var$getBrowserPerformanceAPI();
    if (performance && (0, $ggG8j.browserPerformanceTimeOrigin)) {
        // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
        if (performance.mark) (0, $5e51d76f74d40e19$export$56d8a8a25bd48b81).performance.mark("sentry-tracing-init");
        const fidCallback = $cc0305d4af214257$var$_trackFID();
        const clsCallback = $cc0305d4af214257$var$_trackCLS();
        const lcpCallback = $cc0305d4af214257$var$_trackLCP();
        const ttfbCallback = $cc0305d4af214257$var$_trackTtfb();
        return ()=>{
            fidCallback();
            clsCallback();
            lcpCallback();
            ttfbCallback();
        };
    }
    return ()=>undefined;
}
/**
 * Start tracking long tasks.
 */ function $cc0305d4af214257$export$f396d19077034ad2() {
    (0, $6b49d60e25dc0568$export$69816c1a049f8db6)("longtask", ({ entries: entries })=>{
        for (const entry of entries){
            // eslint-disable-next-line deprecation/deprecation
            const transaction = (0, $4kgMm.getActiveTransaction)();
            if (!transaction) return;
            const startTime = $cc0305d4af214257$var$msToSec((0, $ggG8j.browserPerformanceTimeOrigin) + entry.startTime);
            const duration = $cc0305d4af214257$var$msToSec(entry.duration);
            // eslint-disable-next-line deprecation/deprecation
            transaction.startChild({
                description: "Main UI thread blocked",
                op: "ui.long-task",
                origin: "auto.ui.browser.metrics",
                startTimestamp: startTime,
                endTimestamp: startTime + duration
            });
        }
    });
}
/**
 * Start tracking interaction events.
 */ function $cc0305d4af214257$export$e27543e0976315e4() {
    (0, $6b49d60e25dc0568$export$69816c1a049f8db6)("event", ({ entries: entries })=>{
        for (const entry of entries){
            // eslint-disable-next-line deprecation/deprecation
            const transaction = (0, $4kgMm.getActiveTransaction)();
            if (!transaction) return;
            if (entry.name === "click") {
                const startTime = $cc0305d4af214257$var$msToSec((0, $ggG8j.browserPerformanceTimeOrigin) + entry.startTime);
                const duration = $cc0305d4af214257$var$msToSec(entry.duration);
                const span = {
                    description: (0, $6DrO1.htmlTreeAsString)(entry.target),
                    op: `ui.interaction.${entry.name}`,
                    origin: "auto.ui.browser.metrics",
                    startTimestamp: startTime,
                    endTimestamp: startTime + duration
                };
                const componentName = (0, $6DrO1.getComponentName)(entry.target);
                if (componentName) span.attributes = {
                    "ui.component_name": componentName
                };
                // eslint-disable-next-line deprecation/deprecation
                transaction.startChild(span);
            }
        }
    });
}
/**
 * Start tracking INP webvital events.
 */ function $cc0305d4af214257$export$f17d06681a4744a3(interactionIdtoRouteNameMapping, interactionsSampleRate) {
    const performance = $cc0305d4af214257$var$getBrowserPerformanceAPI();
    if (performance && (0, $ggG8j.browserPerformanceTimeOrigin)) {
        const inpCallback = $cc0305d4af214257$var$_trackINP(interactionIdtoRouteNameMapping, interactionsSampleRate);
        return ()=>{
            inpCallback();
        };
    }
    return ()=>undefined;
}
/** Starts tracking the Cumulative Layout Shift on the current page. */ function $cc0305d4af214257$var$_trackCLS() {
    return (0, $6b49d60e25dc0568$export$861b82818b37ba5b)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        (0, $8a1bc3da87759f5f$export$16a28057038b10ef) && (0, $iyYYs.logger).log("[Measurements] Adding CLS");
        $cc0305d4af214257$var$_measurements["cls"] = {
            value: metric.value,
            unit: ""
        };
        $cc0305d4af214257$var$_clsEntry = entry;
    }, true);
}
/** Starts tracking the Largest Contentful Paint on the current page. */ function $cc0305d4af214257$var$_trackLCP() {
    return (0, $6b49d60e25dc0568$export$3fd4b53331200102)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        (0, $8a1bc3da87759f5f$export$16a28057038b10ef) && (0, $iyYYs.logger).log("[Measurements] Adding LCP");
        $cc0305d4af214257$var$_measurements["lcp"] = {
            value: metric.value,
            unit: "millisecond"
        };
        $cc0305d4af214257$var$_lcpEntry = entry;
    }, true);
}
/** Starts tracking the First Input Delay on the current page. */ function $cc0305d4af214257$var$_trackFID() {
    return (0, $6b49d60e25dc0568$export$2707d7471c0b918f)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        const timeOrigin = $cc0305d4af214257$var$msToSec((0, $ggG8j.browserPerformanceTimeOrigin));
        const startTime = $cc0305d4af214257$var$msToSec(entry.startTime);
        (0, $8a1bc3da87759f5f$export$16a28057038b10ef) && (0, $iyYYs.logger).log("[Measurements] Adding FID");
        $cc0305d4af214257$var$_measurements["fid"] = {
            value: metric.value,
            unit: "millisecond"
        };
        $cc0305d4af214257$var$_measurements["mark.fid"] = {
            value: timeOrigin + startTime,
            unit: "second"
        };
    });
}
function $cc0305d4af214257$var$_trackTtfb() {
    return (0, $6b49d60e25dc0568$export$699d9529c099a797)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        (0, $8a1bc3da87759f5f$export$16a28057038b10ef) && (0, $iyYYs.logger).log("[Measurements] Adding TTFB");
        $cc0305d4af214257$var$_measurements["ttfb"] = {
            value: metric.value,
            unit: "millisecond"
        };
    });
}
const $cc0305d4af214257$var$INP_ENTRY_MAP = {
    click: "click",
    pointerdown: "click",
    pointerup: "click",
    mousedown: "click",
    mouseup: "click",
    touchstart: "click",
    touchend: "click",
    mouseover: "hover",
    mouseout: "hover",
    mouseenter: "hover",
    mouseleave: "hover",
    pointerover: "hover",
    pointerout: "hover",
    pointerenter: "hover",
    pointerleave: "hover",
    dragstart: "drag",
    dragend: "drag",
    drag: "drag",
    dragenter: "drag",
    dragleave: "drag",
    dragover: "drag",
    drop: "drag",
    keydown: "press",
    keyup: "press",
    keypress: "press",
    input: "press"
};
/** Starts tracking the Interaction to Next Paint on the current page. */ function $cc0305d4af214257$var$_trackINP(interactionIdToRouteNameMapping, interactionsSampleRate) {
    return (0, $6b49d60e25dc0568$export$da3b76aa2022cbd7)(({ metric: metric })=>{
        if (metric.value === undefined) return;
        const entry = metric.entries.find((entry)=>entry.duration === metric.value && $cc0305d4af214257$var$INP_ENTRY_MAP[entry.name] !== undefined);
        const client = (0, $ejob9.getClient)();
        if (!entry || !client) return;
        const interactionType = $cc0305d4af214257$var$INP_ENTRY_MAP[entry.name];
        const options = client.getOptions();
        /** Build the INP span, create an envelope from the span, and then send the envelope */ const startTime = $cc0305d4af214257$var$msToSec((0, $ggG8j.browserPerformanceTimeOrigin) + entry.startTime);
        const duration = $cc0305d4af214257$var$msToSec(metric.value);
        const interaction = entry.interactionId !== undefined ? interactionIdToRouteNameMapping[entry.interactionId] : undefined;
        if (interaction === undefined) return;
        const { routeName: routeName, parentContext: parentContext, activeTransaction: activeTransaction, user: user, replayId: replayId } = interaction;
        const userDisplay = user !== undefined ? user.email || user.id || user.ip_address : undefined;
        // eslint-disable-next-line deprecation/deprecation
        const profileId = activeTransaction !== undefined ? activeTransaction.getProfileId() : undefined;
        const span = new (0, $lBUtp.Span)({
            startTimestamp: startTime,
            endTimestamp: startTime + duration,
            op: `ui.interaction.${interactionType}`,
            name: (0, $6DrO1.htmlTreeAsString)(entry.target),
            attributes: {
                release: options.release,
                environment: options.environment,
                transaction: routeName,
                ...userDisplay !== undefined && userDisplay !== "" ? {
                    user: userDisplay
                } : {},
                ...profileId !== undefined ? {
                    profile_id: profileId
                } : {},
                ...replayId !== undefined ? {
                    replay_id: replayId
                } : {}
            },
            exclusiveTime: metric.value,
            measurements: {
                inp: {
                    value: metric.value,
                    unit: "millisecond"
                }
            }
        });
        /** Check to see if the span should be sampled */ const sampleRate = $cc0305d4af214257$var$getSampleRate(parentContext, options, interactionsSampleRate);
        if (!sampleRate) return;
        if (Math.random() < sampleRate) {
            const envelope = span ? (0, $eb11c280a234a052$export$19a0081d4b39d77)([
                span
            ], client.getDsn()) : undefined;
            const transport = client && client.getTransport();
            if (transport && envelope) transport.send(envelope).then(null, (reason)=>{
                (0, $8a1bc3da87759f5f$export$16a28057038b10ef) && (0, $iyYYs.logger).error("Error while sending interaction:", reason);
            });
            return;
        }
    });
}
/** Add performance related spans to a transaction */ function $cc0305d4af214257$export$5f8fa6b3467a7443(transaction) {
    const performance = $cc0305d4af214257$var$getBrowserPerformanceAPI();
    if (!performance || !(0, $5e51d76f74d40e19$export$56d8a8a25bd48b81).performance.getEntries || !(0, $ggG8j.browserPerformanceTimeOrigin)) // Gatekeeper if performance API not available
    return;
    (0, $8a1bc3da87759f5f$export$16a28057038b10ef) && (0, $iyYYs.logger).log("[Tracing] Adding & adjusting spans using Performance API");
    const timeOrigin = $cc0305d4af214257$var$msToSec((0, $ggG8j.browserPerformanceTimeOrigin));
    const performanceEntries = performance.getEntries();
    const { op: op, start_timestamp: transactionStartTime } = (0, $ceyhT.spanToJSON)(transaction);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    performanceEntries.slice($cc0305d4af214257$var$_performanceCursor).forEach((entry)=>{
        const startTime = $cc0305d4af214257$var$msToSec(entry.startTime);
        const duration = $cc0305d4af214257$var$msToSec(entry.duration);
        // eslint-disable-next-line deprecation/deprecation
        if (transaction.op === "navigation" && transactionStartTime && timeOrigin + startTime < transactionStartTime) return;
        switch(entry.entryType){
            case "navigation":
                $cc0305d4af214257$var$_addNavigationSpans(transaction, entry, timeOrigin);
                break;
            case "mark":
            case "paint":
            case "measure":
                {
                    $cc0305d4af214257$export$bc93b84e4d45912d(transaction, entry, startTime, duration, timeOrigin);
                    // capture web vitals
                    const firstHidden = (0, $41a87e17ca9575f5$export$443f86b2c77012c4)();
                    // Only report if the page wasn't hidden prior to the web vital.
                    const shouldRecord = entry.startTime < firstHidden.firstHiddenTime;
                    if (entry.name === "first-paint" && shouldRecord) {
                        (0, $8a1bc3da87759f5f$export$16a28057038b10ef) && (0, $iyYYs.logger).log("[Measurements] Adding FP");
                        $cc0305d4af214257$var$_measurements["fp"] = {
                            value: entry.startTime,
                            unit: "millisecond"
                        };
                    }
                    if (entry.name === "first-contentful-paint" && shouldRecord) {
                        (0, $8a1bc3da87759f5f$export$16a28057038b10ef) && (0, $iyYYs.logger).log("[Measurements] Adding FCP");
                        $cc0305d4af214257$var$_measurements["fcp"] = {
                            value: entry.startTime,
                            unit: "millisecond"
                        };
                    }
                    break;
                }
            case "resource":
                $cc0305d4af214257$export$c82fe1a70634f317(transaction, entry, entry.name, startTime, duration, timeOrigin);
                break;
        }
    });
    $cc0305d4af214257$var$_performanceCursor = Math.max(performanceEntries.length - 1, 0);
    $cc0305d4af214257$var$_trackNavigator(transaction);
    // Measurements are only available for pageload transactions
    if (op === "pageload") {
        $cc0305d4af214257$var$_addTtfbRequestTimeToMeasurements($cc0305d4af214257$var$_measurements);
        [
            "fcp",
            "fp",
            "lcp"
        ].forEach((name)=>{
            if (!$cc0305d4af214257$var$_measurements[name] || !transactionStartTime || timeOrigin >= transactionStartTime) return;
            // The web vitals, fcp, fp, lcp, and ttfb, all measure relative to timeOrigin.
            // Unfortunately, timeOrigin is not captured within the transaction span data, so these web vitals will need
            // to be adjusted to be relative to transaction.startTimestamp.
            const oldValue = $cc0305d4af214257$var$_measurements[name].value;
            const measurementTimestamp = timeOrigin + $cc0305d4af214257$var$msToSec(oldValue);
            // normalizedValue should be in milliseconds
            const normalizedValue = Math.abs((measurementTimestamp - transactionStartTime) * 1000);
            const delta = normalizedValue - oldValue;
            (0, $8a1bc3da87759f5f$export$16a28057038b10ef) && (0, $iyYYs.logger).log(`[Measurements] Normalized ${name} from ${oldValue} to ${normalizedValue} (${delta})`);
            $cc0305d4af214257$var$_measurements[name].value = normalizedValue;
        });
        const fidMark = $cc0305d4af214257$var$_measurements["mark.fid"];
        if (fidMark && $cc0305d4af214257$var$_measurements["fid"]) {
            // create span for FID
            (0, $a04297ea263546cc$export$8bd469e1f37aa721)(transaction, {
                description: "first input delay",
                endTimestamp: fidMark.value + $cc0305d4af214257$var$msToSec($cc0305d4af214257$var$_measurements["fid"].value),
                op: "ui.action",
                origin: "auto.ui.browser.metrics",
                startTimestamp: fidMark.value
            });
            // Delete mark.fid as we don't want it to be part of final payload
            delete $cc0305d4af214257$var$_measurements["mark.fid"];
        }
        // If FCP is not recorded we should not record the cls value
        // according to the new definition of CLS.
        if (!("fcp" in $cc0305d4af214257$var$_measurements)) delete $cc0305d4af214257$var$_measurements.cls;
        Object.keys($cc0305d4af214257$var$_measurements).forEach((measurementName)=>{
            (0, $96d2cd9114d3cb84$export$7cc31b475d33a706)(measurementName, $cc0305d4af214257$var$_measurements[measurementName].value, $cc0305d4af214257$var$_measurements[measurementName].unit);
        });
        $cc0305d4af214257$var$_tagMetricInfo(transaction);
    }
    $cc0305d4af214257$var$_lcpEntry = undefined;
    $cc0305d4af214257$var$_clsEntry = undefined;
    $cc0305d4af214257$var$_measurements = {};
}
/** Create measure related spans */ function $cc0305d4af214257$export$bc93b84e4d45912d(transaction, // eslint-disable-next-line @typescript-eslint/no-explicit-any
entry, startTime, duration, timeOrigin) {
    const measureStartTimestamp = timeOrigin + startTime;
    const measureEndTimestamp = measureStartTimestamp + duration;
    (0, $a04297ea263546cc$export$8bd469e1f37aa721)(transaction, {
        description: entry.name,
        endTimestamp: measureEndTimestamp,
        op: entry.entryType,
        origin: "auto.resource.browser.metrics",
        startTimestamp: measureStartTimestamp
    });
    return measureStartTimestamp;
}
/** Instrument navigation entries */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $cc0305d4af214257$var$_addNavigationSpans(transaction, entry, timeOrigin) {
    [
        "unloadEvent",
        "redirect",
        "domContentLoadedEvent",
        "loadEvent",
        "connect"
    ].forEach((event)=>{
        $cc0305d4af214257$var$_addPerformanceNavigationTiming(transaction, entry, event, timeOrigin);
    });
    $cc0305d4af214257$var$_addPerformanceNavigationTiming(transaction, entry, "secureConnection", timeOrigin, "TLS/SSL", "connectEnd");
    $cc0305d4af214257$var$_addPerformanceNavigationTiming(transaction, entry, "fetch", timeOrigin, "cache", "domainLookupStart");
    $cc0305d4af214257$var$_addPerformanceNavigationTiming(transaction, entry, "domainLookup", timeOrigin, "DNS");
    $cc0305d4af214257$var$_addRequest(transaction, entry, timeOrigin);
}
/** Create performance navigation related spans */ function $cc0305d4af214257$var$_addPerformanceNavigationTiming(transaction, // eslint-disable-next-line @typescript-eslint/no-explicit-any
entry, event, timeOrigin, description, eventEnd) {
    const end = eventEnd ? entry[eventEnd] : entry[`${event}End`];
    const start = entry[`${event}Start`];
    if (!start || !end) return;
    (0, $a04297ea263546cc$export$8bd469e1f37aa721)(transaction, {
        op: "browser",
        origin: "auto.browser.browser.metrics",
        description: description || event,
        startTimestamp: timeOrigin + $cc0305d4af214257$var$msToSec(start),
        endTimestamp: timeOrigin + $cc0305d4af214257$var$msToSec(end)
    });
}
/** Create request and response related spans */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $cc0305d4af214257$var$_addRequest(transaction, entry, timeOrigin) {
    if (entry.responseEnd) {
        // It is possible that we are collecting these metrics when the page hasn't finished loading yet, for example when the HTML slowly streams in.
        // In this case, ie. when the document request hasn't finished yet, `entry.responseEnd` will be 0.
        // In order not to produce faulty spans, where the end timestamp is before the start timestamp, we will only collect
        // these spans when the responseEnd value is available. The backend (Relay) would drop the entire transaction if it contained faulty spans.
        (0, $a04297ea263546cc$export$8bd469e1f37aa721)(transaction, {
            op: "browser",
            origin: "auto.browser.browser.metrics",
            description: "request",
            startTimestamp: timeOrigin + $cc0305d4af214257$var$msToSec(entry.requestStart),
            endTimestamp: timeOrigin + $cc0305d4af214257$var$msToSec(entry.responseEnd)
        });
        (0, $a04297ea263546cc$export$8bd469e1f37aa721)(transaction, {
            op: "browser",
            origin: "auto.browser.browser.metrics",
            description: "response",
            startTimestamp: timeOrigin + $cc0305d4af214257$var$msToSec(entry.responseStart),
            endTimestamp: timeOrigin + $cc0305d4af214257$var$msToSec(entry.responseEnd)
        });
    }
}
/** Create resource-related spans */ function $cc0305d4af214257$export$c82fe1a70634f317(transaction, entry, resourceUrl, startTime, duration, timeOrigin) {
    // we already instrument based on fetch and xhr, so we don't need to
    // duplicate spans here.
    if (entry.initiatorType === "xmlhttprequest" || entry.initiatorType === "fetch") return;
    const parsedUrl = (0, $73075039f785ecac$export$7a5253c0f62e0150)(resourceUrl);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const data = {};
    $cc0305d4af214257$var$setResourceEntrySizeData(data, entry, "transferSize", "http.response_transfer_size");
    $cc0305d4af214257$var$setResourceEntrySizeData(data, entry, "encodedBodySize", "http.response_content_length");
    $cc0305d4af214257$var$setResourceEntrySizeData(data, entry, "decodedBodySize", "http.decoded_response_content_length");
    if ("renderBlockingStatus" in entry) data["resource.render_blocking_status"] = entry.renderBlockingStatus;
    if (parsedUrl.protocol) data["url.scheme"] = parsedUrl.protocol.split(":").pop(); // the protocol returned by parseUrl includes a :, but OTEL spec does not, so we remove it.
    if (parsedUrl.host) data["server.address"] = parsedUrl.host;
    data["url.same_origin"] = resourceUrl.includes((0, $5e51d76f74d40e19$export$56d8a8a25bd48b81).location.origin);
    const startTimestamp = timeOrigin + startTime;
    const endTimestamp = startTimestamp + duration;
    (0, $a04297ea263546cc$export$8bd469e1f37aa721)(transaction, {
        description: resourceUrl.replace((0, $5e51d76f74d40e19$export$56d8a8a25bd48b81).location.origin, ""),
        endTimestamp: endTimestamp,
        op: entry.initiatorType ? `resource.${entry.initiatorType}` : "resource.other",
        origin: "auto.resource.browser.metrics",
        startTimestamp: startTimestamp,
        data: data
    });
}
/**
 * Capture the information of the user agent.
 */ function $cc0305d4af214257$var$_trackNavigator(transaction) {
    const navigator = (0, $5e51d76f74d40e19$export$56d8a8a25bd48b81).navigator;
    if (!navigator) return;
    // track network connectivity
    const connection = navigator.connection;
    if (connection) {
        if (connection.effectiveType) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("effectiveConnectionType", connection.effectiveType);
        if (connection.type) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("connectionType", connection.type);
        if ((0, $a04297ea263546cc$export$27169ccae1b439e3)(connection.rtt)) $cc0305d4af214257$var$_measurements["connection.rtt"] = {
            value: connection.rtt,
            unit: "millisecond"
        };
    }
    if ((0, $a04297ea263546cc$export$27169ccae1b439e3)(navigator.deviceMemory)) // TODO: Can we rewrite this to an attribute?
    // eslint-disable-next-line deprecation/deprecation
    transaction.setTag("deviceMemory", `${navigator.deviceMemory} GB`);
    if ((0, $a04297ea263546cc$export$27169ccae1b439e3)(navigator.hardwareConcurrency)) // TODO: Can we rewrite this to an attribute?
    // eslint-disable-next-line deprecation/deprecation
    transaction.setTag("hardwareConcurrency", String(navigator.hardwareConcurrency));
}
/** Add LCP / CLS data to transaction to allow debugging */ function $cc0305d4af214257$var$_tagMetricInfo(transaction) {
    if ($cc0305d4af214257$var$_lcpEntry) {
        (0, $8a1bc3da87759f5f$export$16a28057038b10ef) && (0, $iyYYs.logger).log("[Measurements] Adding LCP Data");
        // Capture Properties of the LCP element that contributes to the LCP.
        if ($cc0305d4af214257$var$_lcpEntry.element) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("lcp.element", (0, $6DrO1.htmlTreeAsString)($cc0305d4af214257$var$_lcpEntry.element));
        if ($cc0305d4af214257$var$_lcpEntry.id) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("lcp.id", $cc0305d4af214257$var$_lcpEntry.id);
        if ($cc0305d4af214257$var$_lcpEntry.url) // Trim URL to the first 200 characters.
        // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("lcp.url", $cc0305d4af214257$var$_lcpEntry.url.trim().slice(0, 200));
        // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("lcp.size", $cc0305d4af214257$var$_lcpEntry.size);
    }
    // See: https://developer.mozilla.org/en-US/docs/Web/API/LayoutShift
    if ($cc0305d4af214257$var$_clsEntry && $cc0305d4af214257$var$_clsEntry.sources) {
        (0, $8a1bc3da87759f5f$export$16a28057038b10ef) && (0, $iyYYs.logger).log("[Measurements] Adding CLS Data");
        $cc0305d4af214257$var$_clsEntry.sources.forEach((source, index)=>// TODO: Can we rewrite this to an attribute?
            // eslint-disable-next-line deprecation/deprecation
            transaction.setTag(`cls.source.${index + 1}`, (0, $6DrO1.htmlTreeAsString)(source.node)));
    }
}
function $cc0305d4af214257$var$setResourceEntrySizeData(data, entry, key, dataKey) {
    const entryVal = entry[key];
    if (entryVal != null && entryVal < $cc0305d4af214257$var$MAX_INT_AS_BYTES) data[dataKey] = entryVal;
}
/**
 * Add ttfb request time information to measurements.
 *
 * ttfb information is added via vendored web vitals library.
 */ function $cc0305d4af214257$var$_addTtfbRequestTimeToMeasurements(_measurements) {
    const navEntry = (0, $1eeea86275bf6bcc$export$6431553786c94949)();
    if (!navEntry) return;
    const { responseStart: responseStart, requestStart: requestStart } = navEntry;
    if (requestStart <= responseStart) {
        (0, $8a1bc3da87759f5f$export$16a28057038b10ef) && (0, $iyYYs.logger).log("[Measurements] Adding TTFB Request Time");
        _measurements["ttfb.requestTime"] = {
            value: responseStart - requestStart,
            unit: "millisecond"
        };
    }
}
/** Taken from @sentry/core sampling.ts */ function $cc0305d4af214257$var$getSampleRate(transactionContext, options, interactionsSampleRate) {
    if (!(0, $bRL0a.hasTracingEnabled)(options)) return false;
    let sampleRate;
    if (transactionContext !== undefined && typeof options.tracesSampler === "function") sampleRate = options.tracesSampler({
        transactionContext: transactionContext,
        name: transactionContext.name,
        parentSampled: transactionContext.parentSampled,
        attributes: {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.data,
            ...transactionContext.attributes
        },
        location: (0, $5e51d76f74d40e19$export$56d8a8a25bd48b81).location
    });
    else if (transactionContext !== undefined && transactionContext.sampled !== undefined) sampleRate = transactionContext.sampled;
    else if (typeof options.tracesSampleRate !== "undefined") sampleRate = options.tracesSampleRate;
    else sampleRate = 1;
    if (!(0, $bbUDW.isValidSampleRate)(sampleRate)) {
        (0, $8a1bc3da87759f5f$export$16a28057038b10ef) && (0, $iyYYs.logger).warn("[Tracing] Discarding interaction span because of invalid sample rate.");
        return false;
    }
    if (sampleRate === true) return interactionsSampleRate;
    else if (sampleRate === false) return 0;
    return sampleRate * interactionsSampleRate;
}



var $ejob9 = parcelRequire("ejob9");
var $kVnKi = parcelRequire("kVnKi");
var $l4UCE = parcelRequire("l4UCE");
var $bRL0a = parcelRequire("bRL0a");
var $ePKuD = parcelRequire("ePKuD");
var $h795Y = parcelRequire("h795Y");
var $ceyhT = parcelRequire("ceyhT");
var $aJUSo = parcelRequire("aJUSo");

var $9fGKl = parcelRequire("9fGKl");

var $5rgwG = parcelRequire("5rgwG");

var $iyYYs = parcelRequire("iyYYs");

var $8a8aJ = parcelRequire("8a8aJ");
// eslint-disable-next-line deprecation/deprecation
const $48c2e9fc276160d3$var$WINDOW = (0, $8a8aJ.getGlobalObject)();
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $48c2e9fc276160d3$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $48c2e9fc276160d3$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $48c2e9fc276160d3$export$ab12a5d056f1d3a() {
    try {
        new DOMException("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */ function $48c2e9fc276160d3$export$edf3cb81fd7d2a3e() {
    if (!("fetch" in $48c2e9fc276160d3$var$WINDOW)) return false;
    try {
        new Headers();
        new Request("http://www.example.com");
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $48c2e9fc276160d3$export$18cf36ed71d733e7(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $48c2e9fc276160d3$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === "string") return true;
    if (!$48c2e9fc276160d3$export$edf3cb81fd7d2a3e()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($48c2e9fc276160d3$export$18cf36ed71d733e7($48c2e9fc276160d3$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = $48c2e9fc276160d3$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === "function") try {
        const sandbox = doc.createElement("iframe");
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow && sandbox.contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $48c2e9fc276160d3$export$18cf36ed71d733e7(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $5rgwG.DEBUG_BUILD) && (0, $iyYYs.logger).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $48c2e9fc276160d3$export$531055a6c684a70a() {
    return "ReportingObserver" in $48c2e9fc276160d3$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */ function $48c2e9fc276160d3$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$48c2e9fc276160d3$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request("_", {
            referrerPolicy: "origin"
        });
        return true;
    } catch (e) {
        return false;
    }
}



var $8a8aJ = parcelRequire("8a8aJ");

var $hw7uQ = parcelRequire("hw7uQ");
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $b05f9f4788dda045$export$f75d3c772c923df0(handler) {
    const type = "fetch";
    (0, $hw7uQ.addHandler)(type, handler);
    (0, $hw7uQ.maybeInstrument)(type, $b05f9f4788dda045$var$instrumentFetch);
}
function $b05f9f4788dda045$var$instrumentFetch() {
    if (!(0, $48c2e9fc276160d3$export$c82d238e23c40b21)()) return;
    (0, $9fGKl.fill)((0, $8a8aJ.GLOBAL_OBJ), "fetch", function(originalFetch) {
        return function(...args) {
            const { method: method, url: url } = $b05f9f4788dda045$export$f7a71163cc309d9a(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: Date.now()
            };
            (0, $hw7uQ.triggerHandlers)("fetch", {
                ...handlerData
            });
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply((0, $8a8aJ.GLOBAL_OBJ), args).then((response)=>{
                const finishedHandlerData = {
                    ...handlerData,
                    endTimestamp: Date.now(),
                    response: response
                };
                (0, $hw7uQ.triggerHandlers)("fetch", finishedHandlerData);
                return response;
            }, (error)=>{
                const erroredHandlerData = {
                    ...handlerData,
                    endTimestamp: Date.now(),
                    error: error
                };
                (0, $hw7uQ.triggerHandlers)("fetch", erroredHandlerData);
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
function $b05f9f4788dda045$var$hasProp(obj, prop) {
    return !!obj && typeof obj === "object" && !!obj[prop];
}
function $b05f9f4788dda045$var$getUrlFromResource(resource) {
    if (typeof resource === "string") return resource;
    if (!resource) return "";
    if ($b05f9f4788dda045$var$hasProp(resource, "url")) return resource.url;
    if (resource.toString) return resource.toString();
    return "";
}
/**
 * Parses the fetch arguments to find the used Http method and the url of the request.
 * Exported for tests only.
 */ function $b05f9f4788dda045$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: "GET",
        url: ""
    };
    if (fetchArgs.length === 2) {
        const [url, options] = fetchArgs;
        return {
            url: $b05f9f4788dda045$var$getUrlFromResource(url),
            method: $b05f9f4788dda045$var$hasProp(options, "method") ? String(options.method).toUpperCase() : "GET"
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $b05f9f4788dda045$var$getUrlFromResource(arg),
        method: $b05f9f4788dda045$var$hasProp(arg, "method") ? String(arg.method).toUpperCase() : "GET"
    };
}


var $dR6t7 = parcelRequire("dR6t7");

var $9fGKl = parcelRequire("9fGKl");

var $8a8aJ = parcelRequire("8a8aJ");

var $hw7uQ = parcelRequire("hw7uQ");
const $ca8419f0fe7a9e8d$var$WINDOW = (0, $8a8aJ.GLOBAL_OBJ);
const $ca8419f0fe7a9e8d$export$55b6bb1e45c6cf59 = "__sentry_xhr_v3__";
/**
 * Add an instrumentation handler for when an XHR request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $ca8419f0fe7a9e8d$export$26ace48dd54c9aea(handler) {
    const type = "xhr";
    (0, $hw7uQ.addHandler)(type, handler);
    (0, $hw7uQ.maybeInstrument)(type, $ca8419f0fe7a9e8d$export$c67d533bf77cbf54);
}
/** Exported only for tests. */ function $ca8419f0fe7a9e8d$export$c67d533bf77cbf54() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (!$ca8419f0fe7a9e8d$var$WINDOW.XMLHttpRequest) return;
    const xhrproto = XMLHttpRequest.prototype;
    (0, $9fGKl.fill)(xhrproto, "open", function(originalOpen) {
        return function(...args) {
            const startTimestamp = Date.now();
            // open() should always be called with two or more arguments
            // But to be on the safe side, we actually validate this and bail out if we don't have a method & url
            const method = (0, $dR6t7.isString)(args[0]) ? args[0].toUpperCase() : undefined;
            const url = $ca8419f0fe7a9e8d$var$parseUrl(args[1]);
            if (!method || !url) return originalOpen.apply(this, args);
            this[$ca8419f0fe7a9e8d$export$55b6bb1e45c6cf59] = {
                method: method,
                url: url,
                request_headers: {}
            };
            // if Sentry key appears in URL, don't capture it as a request
            if (method === "POST" && url.match(/sentry_key/)) this.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                // For whatever reason, this is not the same instance here as from the outer method
                const xhrInfo = this[$ca8419f0fe7a9e8d$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (this.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = this.status;
                    } catch (e) {
                    /* do nothing */ }
                    const handlerData = {
                        args: [
                            method,
                            url
                        ],
                        endTimestamp: Date.now(),
                        startTimestamp: startTimestamp,
                        xhr: this
                    };
                    (0, $hw7uQ.triggerHandlers)("xhr", handlerData);
                }
            };
            if ("onreadystatechange" in this && typeof this.onreadystatechange === "function") (0, $9fGKl.fill)(this, "onreadystatechange", function(original) {
                return function(...readyStateArgs) {
                    onreadystatechangeHandler();
                    return original.apply(this, readyStateArgs);
                };
            });
            else this.addEventListener("readystatechange", onreadystatechangeHandler);
            // Intercepting `setRequestHeader` to access the request headers of XHR instance.
            // This will only work for user/library defined headers, not for the default/browser-assigned headers.
            // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
            (0, $9fGKl.fill)(this, "setRequestHeader", function(original) {
                return function(...setRequestHeaderArgs) {
                    const [header, value] = setRequestHeaderArgs;
                    const xhrInfo = this[$ca8419f0fe7a9e8d$export$55b6bb1e45c6cf59];
                    if (xhrInfo && (0, $dR6t7.isString)(header) && (0, $dR6t7.isString)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return original.apply(this, setRequestHeaderArgs);
                };
            });
            return originalOpen.apply(this, args);
        };
    });
    (0, $9fGKl.fill)(xhrproto, "send", function(originalSend) {
        return function(...args) {
            const sentryXhrData = this[$ca8419f0fe7a9e8d$export$55b6bb1e45c6cf59];
            if (!sentryXhrData) return originalSend.apply(this, args);
            if (args[0] !== undefined) sentryXhrData.body = args[0];
            const handlerData = {
                args: [
                    sentryXhrData.method,
                    sentryXhrData.url
                ],
                startTimestamp: Date.now(),
                xhr: this
            };
            (0, $hw7uQ.triggerHandlers)("xhr", handlerData);
            return originalSend.apply(this, args);
        };
    });
}
function $ca8419f0fe7a9e8d$var$parseUrl(url) {
    if ((0, $dR6t7.isString)(url)) return url;
    try {
        // url can be a string or URL
        // but since URL is not available in IE11, we do not check for it,
        // but simply assume it is an URL and return `toString()` from it (which returns the full URL)
        // If that fails, we just return undefined
        return url.toString();
    } catch (e2) {} // eslint-disable-line no-empty
    return undefined;
}


var $9evQX = parcelRequire("9evQX");
var $ggG8j = parcelRequire("ggG8j");
var $dGzPN = parcelRequire("dGzPN");
var $hR2Jv = parcelRequire("hR2Jv");

var $ejob9 = parcelRequire("ejob9");
var $kVnKi = parcelRequire("kVnKi");
var $l4UCE = parcelRequire("l4UCE");
var $bRL0a = parcelRequire("bRL0a");
var $ePKuD = parcelRequire("ePKuD");
var $h795Y = parcelRequire("h795Y");
var $ceyhT = parcelRequire("ceyhT");
var $aJUSo = parcelRequire("aJUSo");

var $9evQX = parcelRequire("9evQX");
var $dGzPN = parcelRequire("dGzPN");
var $dR6t7 = parcelRequire("dR6t7");
/**
 * Create and track fetch request spans for usage in combination with `addInstrumentationHandler`.
 *
 * @returns Span if a span was created, otherwise void.
 */ function $daed9b5ba635c7d1$export$6d73c62358c655be(handlerData, shouldCreateSpan, shouldAttachHeaders, spans, spanOrigin = "auto.http.browser") {
    if (!(0, $bRL0a.hasTracingEnabled)() || !handlerData.fetchData) return undefined;
    const shouldCreateSpanResult = shouldCreateSpan(handlerData.fetchData.url);
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        const spanId = handlerData.fetchData.__span;
        if (!spanId) return;
        const span = spans[spanId];
        if (span) {
            $daed9b5ba635c7d1$var$endSpan(span, handlerData);
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    const scope = (0, $ejob9.getCurrentScope)();
    const client = (0, $ejob9.getClient)();
    const { method: method, url: url } = handlerData.fetchData;
    const fullUrl = $daed9b5ba635c7d1$var$getFullURL(url);
    const host = fullUrl ? (0, $73075039f785ecac$export$7a5253c0f62e0150)(fullUrl).host : undefined;
    const span = shouldCreateSpanResult ? (0, $aJUSo.startInactiveSpan)({
        name: `${method} ${url}`,
        onlyIfParent: true,
        attributes: {
            url: url,
            type: "fetch",
            "http.method": method,
            "http.url": fullUrl,
            "server.address": host,
            [(0, $ePKuD.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: spanOrigin
        },
        op: "http.client"
    }) : undefined;
    if (span) {
        handlerData.fetchData.__span = span.spanContext().spanId;
        spans[span.spanContext().spanId] = span;
    }
    if (shouldAttachHeaders(handlerData.fetchData.url) && client) {
        const request = handlerData.args[0];
        // In case the user hasn't set the second argument of a fetch call we default it to `{}`.
        handlerData.args[1] = handlerData.args[1] || {};
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const options = handlerData.args[1];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
        options.headers = $daed9b5ba635c7d1$export$6717acf674206871(request, client, scope, options, span);
    }
    return span;
}
/**
 * Adds sentry-trace and baggage headers to the various forms of fetch headers
 */ function $daed9b5ba635c7d1$export$6717acf674206871(request, client, scope, options, requestSpan) {
    // eslint-disable-next-line deprecation/deprecation
    const span = requestSpan || scope.getSpan();
    const isolationScope = (0, $l4UCE.getIsolationScope)();
    const { traceId: traceId, spanId: spanId, sampled: sampled, dsc: dsc } = {
        ...isolationScope.getPropagationContext(),
        ...scope.getPropagationContext()
    };
    const sentryTraceHeader = span ? (0, $ceyhT.spanToTraceHeader)(span) : (0, $dGzPN.generateSentryTraceHeader)(traceId, spanId, sampled);
    const sentryBaggageHeader = (0, $9evQX.dynamicSamplingContextToSentryBaggageHeader)(dsc || (span ? (0, $kVnKi.getDynamicSamplingContextFromSpan)(span) : (0, $kVnKi.getDynamicSamplingContextFromClient)(traceId, client, scope)));
    const headers = options.headers || (typeof Request !== "undefined" && (0, $dR6t7.isInstanceOf)(request, Request) ? request.headers : undefined);
    if (!headers) return {
        "sentry-trace": sentryTraceHeader,
        baggage: sentryBaggageHeader
    };
    else if (typeof Headers !== "undefined" && (0, $dR6t7.isInstanceOf)(headers, Headers)) {
        const newHeaders = new Headers(headers);
        newHeaders.append("sentry-trace", sentryTraceHeader);
        if (sentryBaggageHeader) // If the same header is appended multiple times the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.append((0, $9evQX.BAGGAGE_HEADER_NAME), sentryBaggageHeader);
        return newHeaders;
    } else if (Array.isArray(headers)) {
        const newHeaders = [
            ...headers,
            [
                "sentry-trace",
                sentryTraceHeader
            ]
        ];
        if (sentryBaggageHeader) // If there are multiple entries with the same key, the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.push([
            (0, $9evQX.BAGGAGE_HEADER_NAME),
            sentryBaggageHeader
        ]);
        return newHeaders;
    } else {
        const existingBaggageHeader = "baggage" in headers ? headers.baggage : undefined;
        const newBaggageHeaders = [];
        if (Array.isArray(existingBaggageHeader)) newBaggageHeaders.push(...existingBaggageHeader);
        else if (existingBaggageHeader) newBaggageHeaders.push(existingBaggageHeader);
        if (sentryBaggageHeader) newBaggageHeaders.push(sentryBaggageHeader);
        return {
            ...headers,
            "sentry-trace": sentryTraceHeader,
            baggage: newBaggageHeaders.length > 0 ? newBaggageHeaders.join(",") : undefined
        };
    }
}
function $daed9b5ba635c7d1$var$getFullURL(url) {
    try {
        const parsed = new URL(url);
        return parsed.href;
    } catch (e) {
        return undefined;
    }
}
function $daed9b5ba635c7d1$var$endSpan(span, handlerData) {
    if (handlerData.response) {
        (0, $h795Y.setHttpStatus)(span, handlerData.response.status);
        const contentLength = handlerData.response && handlerData.response.headers && handlerData.response.headers.get("content-length");
        if (contentLength) {
            const contentLengthNum = parseInt(contentLength);
            if (contentLengthNum > 0) span.setAttribute("http.response_content_length", contentLengthNum);
        }
    } else if (handlerData.error) span.setStatus("internal_error");
    span.end();
}




/* eslint-disable max-lines */ const $fb36002f93a424ca$export$15bd0305d05ad07b = [
    "localhost",
    /^\/(?!\/)/
];
/** Options for Request Instrumentation */ const $fb36002f93a424ca$export$cc17fb3c0bc95cd7 = {
    traceFetch: true,
    traceXHR: true,
    enableHTTPTimings: true,
    // TODO (v8): Remove this property
    tracingOrigins: $fb36002f93a424ca$export$15bd0305d05ad07b,
    tracePropagationTargets: $fb36002f93a424ca$export$15bd0305d05ad07b
};
/** Registers span creators for xhr and fetch requests  */ function $fb36002f93a424ca$export$864489cb3478db3e(_options) {
    const { traceFetch: traceFetch, traceXHR: traceXHR, tracePropagationTargets: // eslint-disable-next-line deprecation/deprecation
    tracePropagationTargets, tracingOrigins: // eslint-disable-next-line deprecation/deprecation
    tracingOrigins, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings } = {
        traceFetch: $fb36002f93a424ca$export$cc17fb3c0bc95cd7.traceFetch,
        traceXHR: $fb36002f93a424ca$export$cc17fb3c0bc95cd7.traceXHR,
        ..._options
    };
    const shouldCreateSpan = typeof shouldCreateSpanForRequest === "function" ? shouldCreateSpanForRequest : (_)=>true;
    // TODO(v8) Remove tracingOrigins here
    // The only reason we're passing it in here is because this instrumentOutgoingRequests function is publicly exported
    // and we don't want to break the API. We can remove it in v8.
    const shouldAttachHeadersWithTargets = (url)=>$fb36002f93a424ca$export$c260386ab3f0b3dd(url, tracePropagationTargets || tracingOrigins);
    const spans = {};
    if (traceFetch) (0, $b05f9f4788dda045$export$f75d3c772c923df0)((handlerData)=>{
        const createdSpan = (0, $daed9b5ba635c7d1$export$6d73c62358c655be)(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
        // We cannot use `window.location` in the generic fetch instrumentation,
        // but we need it for reliable `server.address` attribute.
        // so we extend this in here
        if (createdSpan) {
            const fullUrl = $fb36002f93a424ca$var$getFullURL(handlerData.fetchData.url);
            const host = fullUrl ? (0, $73075039f785ecac$export$7a5253c0f62e0150)(fullUrl).host : undefined;
            createdSpan.setAttributes({
                "http.url": fullUrl,
                "server.address": host
            });
        }
        if (enableHTTPTimings && createdSpan) $fb36002f93a424ca$var$addHTTPTimings(createdSpan);
    });
    if (traceXHR) (0, $ca8419f0fe7a9e8d$export$26ace48dd54c9aea)((handlerData)=>{
        const createdSpan = $fb36002f93a424ca$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
        if (enableHTTPTimings && createdSpan) $fb36002f93a424ca$var$addHTTPTimings(createdSpan);
    });
}
function $fb36002f93a424ca$var$isPerformanceResourceTiming(entry) {
    return entry.entryType === "resource" && "initiatorType" in entry && typeof entry.nextHopProtocol === "string" && (entry.initiatorType === "fetch" || entry.initiatorType === "xmlhttprequest");
}
/**
 * Creates a temporary observer to listen to the next fetch/xhr resourcing timings,
 * so that when timings hit their per-browser limit they don't need to be removed.
 *
 * @param span A span that has yet to be finished, must contain `url` on data.
 */ function $fb36002f93a424ca$var$addHTTPTimings(span) {
    const { url: url } = (0, $ceyhT.spanToJSON)(span).data || {};
    if (!url || typeof url !== "string") return;
    const cleanup = (0, $6b49d60e25dc0568$export$69816c1a049f8db6)("resource", ({ entries: entries })=>{
        entries.forEach((entry)=>{
            if ($fb36002f93a424ca$var$isPerformanceResourceTiming(entry) && entry.name.endsWith(url)) {
                const spanData = $fb36002f93a424ca$var$resourceTimingEntryToSpanData(entry);
                spanData.forEach((data)=>span.setAttribute(...data));
                // In the next tick, clean this handler up
                // We have to wait here because otherwise this cleans itself up before it is fully done
                setTimeout(cleanup);
            }
        });
    });
}
/**
 * Converts ALPN protocol ids to name and version.
 *
 * (https://www.iana.org/assignments/tls-extensiontype-values/tls-extensiontype-values.xhtml#alpn-protocol-ids)
 * @param nextHopProtocol PerformanceResourceTiming.nextHopProtocol
 */ function $fb36002f93a424ca$export$57c6f824442f9fe1(nextHopProtocol) {
    let name = "unknown";
    let version = "unknown";
    let _name = "";
    for (const char of nextHopProtocol){
        // http/1.1 etc.
        if (char === "/") {
            [name, version] = nextHopProtocol.split("/");
            break;
        }
        // h2, h3 etc.
        if (!isNaN(Number(char))) {
            name = _name === "h" ? "http" : _name;
            version = nextHopProtocol.split(_name)[1];
            break;
        }
        _name += char;
    }
    if (_name === nextHopProtocol) // webrtc, ftp, etc.
    name = _name;
    return {
        name: name,
        version: version
    };
}
function $fb36002f93a424ca$var$getAbsoluteTime(time = 0) {
    return (((0, $ggG8j.browserPerformanceTimeOrigin) || performance.timeOrigin) + time) / 1000;
}
function $fb36002f93a424ca$var$resourceTimingEntryToSpanData(resourceTiming) {
    const { name: name, version: version } = $fb36002f93a424ca$export$57c6f824442f9fe1(resourceTiming.nextHopProtocol);
    const timingSpanData = [];
    timingSpanData.push([
        "network.protocol.version",
        version
    ], [
        "network.protocol.name",
        name
    ]);
    if (!(0, $ggG8j.browserPerformanceTimeOrigin)) return timingSpanData;
    return [
        ...timingSpanData,
        [
            "http.request.redirect_start",
            $fb36002f93a424ca$var$getAbsoluteTime(resourceTiming.redirectStart)
        ],
        [
            "http.request.fetch_start",
            $fb36002f93a424ca$var$getAbsoluteTime(resourceTiming.fetchStart)
        ],
        [
            "http.request.domain_lookup_start",
            $fb36002f93a424ca$var$getAbsoluteTime(resourceTiming.domainLookupStart)
        ],
        [
            "http.request.domain_lookup_end",
            $fb36002f93a424ca$var$getAbsoluteTime(resourceTiming.domainLookupEnd)
        ],
        [
            "http.request.connect_start",
            $fb36002f93a424ca$var$getAbsoluteTime(resourceTiming.connectStart)
        ],
        [
            "http.request.secure_connection_start",
            $fb36002f93a424ca$var$getAbsoluteTime(resourceTiming.secureConnectionStart)
        ],
        [
            "http.request.connection_end",
            $fb36002f93a424ca$var$getAbsoluteTime(resourceTiming.connectEnd)
        ],
        [
            "http.request.request_start",
            $fb36002f93a424ca$var$getAbsoluteTime(resourceTiming.requestStart)
        ],
        [
            "http.request.response_start",
            $fb36002f93a424ca$var$getAbsoluteTime(resourceTiming.responseStart)
        ],
        [
            "http.request.response_end",
            $fb36002f93a424ca$var$getAbsoluteTime(resourceTiming.responseEnd)
        ]
    ];
}
/**
 * A function that determines whether to attach tracing headers to a request.
 * This was extracted from `instrumentOutgoingRequests` to make it easier to test shouldAttachHeaders.
 * We only export this fuction for testing purposes.
 */ function $fb36002f93a424ca$export$c260386ab3f0b3dd(url, tracePropagationTargets) {
    return (0, $hR2Jv.stringMatchesSomePattern)(url, tracePropagationTargets || $fb36002f93a424ca$export$15bd0305d05ad07b);
}
/**
 * Create and track xhr request spans
 *
 * @returns Span if a span was created, otherwise void.
 */ // eslint-disable-next-line complexity
function $fb36002f93a424ca$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeaders, spans) {
    const xhr = handlerData.xhr;
    const sentryXhrData = xhr && xhr[0, $ca8419f0fe7a9e8d$export$55b6bb1e45c6cf59];
    if (!(0, $bRL0a.hasTracingEnabled)() || !xhr || xhr.__sentry_own_request__ || !sentryXhrData) return undefined;
    const shouldCreateSpanResult = shouldCreateSpan(sentryXhrData.url);
    // check first if the request has finished and is tracked by an existing span which should now end
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        const spanId = xhr.__sentry_xhr_span_id__;
        if (!spanId) return;
        const span = spans[spanId];
        if (span && sentryXhrData.status_code !== undefined) {
            (0, $h795Y.setHttpStatus)(span, sentryXhrData.status_code);
            span.end();
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    const scope = (0, $ejob9.getCurrentScope)();
    const isolationScope = (0, $l4UCE.getIsolationScope)();
    const fullUrl = $fb36002f93a424ca$var$getFullURL(sentryXhrData.url);
    const host = fullUrl ? (0, $73075039f785ecac$export$7a5253c0f62e0150)(fullUrl).host : undefined;
    const span = shouldCreateSpanResult ? (0, $aJUSo.startInactiveSpan)({
        name: `${sentryXhrData.method} ${sentryXhrData.url}`,
        onlyIfParent: true,
        attributes: {
            type: "xhr",
            "http.method": sentryXhrData.method,
            "http.url": fullUrl,
            url: sentryXhrData.url,
            "server.address": host,
            [(0, $ePKuD.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: "auto.http.browser"
        },
        op: "http.client"
    }) : undefined;
    if (span) {
        xhr.__sentry_xhr_span_id__ = span.spanContext().spanId;
        spans[xhr.__sentry_xhr_span_id__] = span;
    }
    const client = (0, $ejob9.getClient)();
    if (xhr.setRequestHeader && shouldAttachHeaders(sentryXhrData.url) && client) {
        const { traceId: traceId, spanId: spanId, sampled: sampled, dsc: dsc } = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        const sentryTraceHeader = span ? (0, $ceyhT.spanToTraceHeader)(span) : (0, $dGzPN.generateSentryTraceHeader)(traceId, spanId, sampled);
        const sentryBaggageHeader = (0, $9evQX.dynamicSamplingContextToSentryBaggageHeader)(dsc || (span ? (0, $kVnKi.getDynamicSamplingContextFromSpan)(span) : (0, $kVnKi.getDynamicSamplingContextFromClient)(traceId, client, scope)));
        $fb36002f93a424ca$var$setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader);
    }
    return span;
}
function $fb36002f93a424ca$var$setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader) {
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xhr.setRequestHeader("sentry-trace", sentryTraceHeader);
        if (sentryBaggageHeader) // From MDN: "If this method is called several times with the same header, the values are merged into one single request header."
        // We can therefore simply set a baggage header without checking what was there before
        // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/setRequestHeader
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xhr.setRequestHeader((0, $9evQX.BAGGAGE_HEADER_NAME), sentryBaggageHeader);
    } catch (_) {
    // Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
    }
}
function $fb36002f93a424ca$var$getFullURL(url) {
    try {
        // By adding a base URL to new URL(), this will also work for relative urls
        // If `url` is a full URL, the base URL is ignored anyhow
        const parsed = new URL(url, (0, $5e51d76f74d40e19$export$56d8a8a25bd48b81).location.origin);
        return parsed.href;
    } catch (e) {
        return undefined;
    }
}



var $9fGKl = parcelRequire("9fGKl");



var $8a8aJ = parcelRequire("8a8aJ");

var $8a8aJ = parcelRequire("8a8aJ");
// Based on https://github.com/angular/angular.js/pull/13945/files
// eslint-disable-next-line deprecation/deprecation
const $4f25fd93a9a02c3d$var$WINDOW = (0, $8a8aJ.getGlobalObject)();
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function $4f25fd93a9a02c3d$export$67fc34576016d6ec() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const chromeVar = $4f25fd93a9a02c3d$var$WINDOW.chrome;
    const isChromePackagedApp = chromeVar && chromeVar.app && chromeVar.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */ const hasHistoryApi = "history" in $4f25fd93a9a02c3d$var$WINDOW && !!$4f25fd93a9a02c3d$var$WINDOW.history.pushState && !!$4f25fd93a9a02c3d$var$WINDOW.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}



var $hw7uQ = parcelRequire("hw7uQ");
const $939920159228e1b5$var$WINDOW = (0, $8a8aJ.GLOBAL_OBJ);
let $939920159228e1b5$var$lastHref;
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $939920159228e1b5$export$3f18c56c58114e75(handler) {
    const type = "history";
    (0, $hw7uQ.addHandler)(type, handler);
    (0, $hw7uQ.maybeInstrument)(type, $939920159228e1b5$var$instrumentHistory);
}
function $939920159228e1b5$var$instrumentHistory() {
    if (!(0, $4f25fd93a9a02c3d$export$67fc34576016d6ec)()) return;
    const oldOnPopState = $939920159228e1b5$var$WINDOW.onpopstate;
    $939920159228e1b5$var$WINDOW.onpopstate = function(...args) {
        const to = $939920159228e1b5$var$WINDOW.location.href;
        // keep track of the current URL state, as we always receive only the updated state
        const from = $939920159228e1b5$var$lastHref;
        $939920159228e1b5$var$lastHref = to;
        const handlerData = {
            from: from,
            to: to
        };
        (0, $hw7uQ.triggerHandlers)("history", handlerData);
        if (oldOnPopState) // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
        // https://github.com/getsentry/sentry-javascript/issues/3344
        // https://github.com/bugsnag/bugsnag-js/issues/469
        try {
            return oldOnPopState.apply(this, args);
        } catch (_oO) {
        // no-empty
        }
    };
    function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                const from = $939920159228e1b5$var$lastHref;
                const to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                $939920159228e1b5$var$lastHref = to;
                const handlerData = {
                    from: from,
                    to: to
                };
                (0, $hw7uQ.triggerHandlers)("history", handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $9fGKl.fill)($939920159228e1b5$var$WINDOW.history, "pushState", historyReplacementFunction);
    (0, $9fGKl.fill)($939920159228e1b5$var$WINDOW.history, "replaceState", historyReplacementFunction);
}


var $ggG8j = parcelRequire("ggG8j");
var $iyYYs = parcelRequire("iyYYs");


/**
 * Default function implementing pageload and navigation transactions
 */ function $1513334a660c669e$export$86649cc09fe75143(customStartTransaction, startTransactionOnPageLoad = true, startTransactionOnLocationChange = true) {
    if (!(0, $5e51d76f74d40e19$export$56d8a8a25bd48b81) || !(0, $5e51d76f74d40e19$export$56d8a8a25bd48b81).location) {
        (0, $8a1bc3da87759f5f$export$16a28057038b10ef) && (0, $iyYYs.logger).warn("Could not initialize routing instrumentation due to invalid location");
        return;
    }
    let startingUrl = (0, $5e51d76f74d40e19$export$56d8a8a25bd48b81).location.href;
    let activeTransaction;
    if (startTransactionOnPageLoad) activeTransaction = customStartTransaction({
        name: (0, $5e51d76f74d40e19$export$56d8a8a25bd48b81).location.pathname,
        // pageload should always start at timeOrigin (and needs to be in s, not ms)
        startTimestamp: (0, $ggG8j.browserPerformanceTimeOrigin) ? (0, $ggG8j.browserPerformanceTimeOrigin) / 1000 : undefined,
        op: "pageload",
        origin: "auto.pageload.browser",
        metadata: {
            source: "url"
        }
    });
    if (startTransactionOnLocationChange) (0, $939920159228e1b5$export$3f18c56c58114e75)(({ to: to, from: from })=>{
        /**
       * This early return is there to account for some cases where a navigation transaction starts right after
       * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
       * create an uneccessary navigation transaction.
       *
       * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
       * only be caused in certain development environments where the usage of a hot module reloader is causing
       * errors.
       */ if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
            startingUrl = undefined;
            return;
        }
        if (from !== to) {
            startingUrl = undefined;
            if (activeTransaction) {
                (0, $8a1bc3da87759f5f$export$16a28057038b10ef) && (0, $iyYYs.logger).log(`[Tracing] Finishing current transaction with op: ${activeTransaction.op}`);
                // If there's an open transaction on the scope, we need to finish it before creating an new one.
                activeTransaction.end();
            }
            activeTransaction = customStartTransaction({
                name: (0, $5e51d76f74d40e19$export$56d8a8a25bd48b81).location.pathname,
                op: "navigation",
                origin: "auto.navigation.browser",
                metadata: {
                    source: "url"
                }
            });
        }
    });
}



const $af9d9619b7a5c686$export$bbd2089f30bd3708 = "BrowserTracing";
/** Options for Browser Tracing integration */ const $af9d9619b7a5c686$var$DEFAULT_BROWSER_TRACING_OPTIONS = {
    ...(0, $1COtc.TRACING_DEFAULTS),
    markBackgroundTransactions: true,
    routingInstrumentation: (0, $1513334a660c669e$export$86649cc09fe75143),
    startTransactionOnLocationChange: true,
    startTransactionOnPageLoad: true,
    enableLongTask: true,
    enableInp: false,
    interactionsSampleRate: 1,
    _experiments: {},
    ...(0, $fb36002f93a424ca$export$cc17fb3c0bc95cd7)
};
/** We store up to 10 interaction candidates max to cap memory usage. This is the same cap as getINP from web-vitals */ const $af9d9619b7a5c686$var$MAX_INTERACTIONS = 10;
/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library. This integration uses {@see IdleTransaction} to create transactions.
 *
 * @deprecated Use `browserTracingIntegration()` instead.
 */ class $af9d9619b7a5c686$export$46d3bbd0375f5fa4 {
    // This class currently doesn't have a static `id` field like the other integration classes, because it prevented
    // @sentry/tracing from being treeshaken. Tree shakers do not like static fields, because they behave like side effects.
    // TODO: Come up with a better plan, than using static fields on integration classes, and use that plan on all
    // integrations.
    /** Browser Tracing integration options */ /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    constructor(_options){
        this.name = $af9d9619b7a5c686$export$bbd2089f30bd3708;
        this._hasSetTracePropagationTargets = false;
        (0, $fBYWi.addTracingExtensions)();
        if (0, $8a1bc3da87759f5f$export$16a28057038b10ef) this._hasSetTracePropagationTargets = !!(_options && // eslint-disable-next-line deprecation/deprecation
        (_options.tracePropagationTargets || _options.tracingOrigins));
        this.options = {
            ...$af9d9619b7a5c686$var$DEFAULT_BROWSER_TRACING_OPTIONS,
            ..._options
        };
        // Special case: enableLongTask can be set in _experiments
        // TODO (v8): Remove this in v8
        if (this.options._experiments.enableLongTask !== undefined) this.options.enableLongTask = this.options._experiments.enableLongTask;
        // TODO (v8): remove this block after tracingOrigins is removed
        // Set tracePropagationTargets to tracingOrigins if specified by the user
        // In case both are specified, tracePropagationTargets takes precedence
        // eslint-disable-next-line deprecation/deprecation
        if (_options && !_options.tracePropagationTargets && _options.tracingOrigins) // eslint-disable-next-line deprecation/deprecation
        this.options.tracePropagationTargets = _options.tracingOrigins;
        this._collectWebVitals = (0, $cc0305d4af214257$export$7c69f0412d101b88)();
        /** Stores a mapping of interactionIds from PerformanceEventTimings to the origin interaction path */ this._interactionIdToRouteNameMapping = {};
        if (this.options.enableInp) (0, $cc0305d4af214257$export$f17d06681a4744a3)(this._interactionIdToRouteNameMapping, this.options.interactionsSampleRate);
        if (this.options.enableLongTask) (0, $cc0305d4af214257$export$f396d19077034ad2)();
        if (this.options._experiments.enableInteractions) (0, $cc0305d4af214257$export$e27543e0976315e4)();
        this._latestRoute = {
            name: undefined,
            context: undefined
        };
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    setupOnce(_, getCurrentHub) {
        this._getCurrentHub = getCurrentHub;
        const hub = getCurrentHub();
        // eslint-disable-next-line deprecation/deprecation
        const client = hub.getClient();
        const clientOptions = client && client.getOptions();
        const { routingInstrumentation: instrumentRouting, startTransactionOnLocationChange: startTransactionOnLocationChange, startTransactionOnPageLoad: startTransactionOnPageLoad, markBackgroundTransactions: markBackgroundTransactions, traceFetch: traceFetch, traceXHR: traceXHR, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings, _experiments: _experiments } = this.options;
        const clientOptionsTracePropagationTargets = clientOptions && clientOptions.tracePropagationTargets;
        // There are three ways to configure tracePropagationTargets:
        // 1. via top level client option `tracePropagationTargets`
        // 2. via BrowserTracing option `tracePropagationTargets`
        // 3. via BrowserTracing option `tracingOrigins` (deprecated)
        //
        // To avoid confusion, favour top level client option `tracePropagationTargets`, and fallback to
        // BrowserTracing option `tracePropagationTargets` and then `tracingOrigins` (deprecated).
        // This is done as it minimizes bundle size (we don't have to have undefined checks).
        //
        // If both 1 and either one of 2 or 3 are set (from above), we log out a warning.
        // eslint-disable-next-line deprecation/deprecation
        const tracePropagationTargets = clientOptionsTracePropagationTargets || this.options.tracePropagationTargets;
        if ((0, $8a1bc3da87759f5f$export$16a28057038b10ef) && this._hasSetTracePropagationTargets && clientOptionsTracePropagationTargets) (0, $iyYYs.logger).warn("[Tracing] The `tracePropagationTargets` option was set in the BrowserTracing integration and top level `Sentry.init`. The top level `Sentry.init` value is being used.");
        instrumentRouting((context)=>{
            const transaction = this._createRouteTransaction(context);
            this.options._experiments.onStartRouteTransaction && this.options._experiments.onStartRouteTransaction(transaction, context, getCurrentHub);
            return transaction;
        }, startTransactionOnPageLoad, startTransactionOnLocationChange);
        if (markBackgroundTransactions) (0, $e5c6e0dc933aa8d6$export$6f18f55521af71a1)();
        if (_experiments.enableInteractions) this._registerInteractionListener();
        if (this.options.enableInp) this._registerInpInteractionListener();
        (0, $fb36002f93a424ca$export$864489cb3478db3e)({
            traceFetch: traceFetch,
            traceXHR: traceXHR,
            tracePropagationTargets: tracePropagationTargets,
            shouldCreateSpanForRequest: shouldCreateSpanForRequest,
            enableHTTPTimings: enableHTTPTimings
        });
    }
    /** Create routing idle transaction. */ _createRouteTransaction(context) {
        if (!this._getCurrentHub) {
            (0, $8a1bc3da87759f5f$export$16a28057038b10ef) && (0, $iyYYs.logger).warn(`[Tracing] Did not create ${context.op} transaction because _getCurrentHub is invalid.`);
            return undefined;
        }
        const hub = this._getCurrentHub();
        const { beforeNavigate: beforeNavigate, idleTimeout: idleTimeout, finalTimeout: finalTimeout, heartbeatInterval: heartbeatInterval } = this.options;
        const isPageloadTransaction = context.op === "pageload";
        let expandedContext;
        if (isPageloadTransaction) {
            const sentryTrace = isPageloadTransaction ? $af9d9619b7a5c686$export$f147b32b03c9cf11("sentry-trace") : "";
            const baggage = isPageloadTransaction ? $af9d9619b7a5c686$export$f147b32b03c9cf11("baggage") : undefined;
            const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: sampled } = (0, $dGzPN.propagationContextFromHeaders)(sentryTrace, baggage);
            expandedContext = {
                traceId: traceId,
                parentSpanId: parentSpanId,
                parentSampled: sampled,
                ...context,
                metadata: {
                    // eslint-disable-next-line deprecation/deprecation
                    ...context.metadata,
                    dynamicSamplingContext: dsc
                },
                trimEnd: true
            };
        } else expandedContext = {
            trimEnd: true,
            ...context
        };
        const modifiedContext = typeof beforeNavigate === "function" ? beforeNavigate(expandedContext) : expandedContext;
        // For backwards compatibility reasons, beforeNavigate can return undefined to "drop" the transaction (prevent it
        // from being sent to Sentry).
        const finalContext = modifiedContext === undefined ? {
            ...expandedContext,
            sampled: false
        } : modifiedContext;
        // If `beforeNavigate` set a custom name, record that fact
        // eslint-disable-next-line deprecation/deprecation
        finalContext.metadata = finalContext.name !== expandedContext.name ? {
            ...finalContext.metadata,
            source: "custom"
        } : finalContext.metadata;
        this._latestRoute.name = finalContext.name;
        this._latestRoute.context = finalContext;
        // eslint-disable-next-line deprecation/deprecation
        if (finalContext.sampled === false) (0, $8a1bc3da87759f5f$export$16a28057038b10ef) && (0, $iyYYs.logger).log(`[Tracing] Will not send ${finalContext.op} transaction because of beforeNavigate.`);
        (0, $8a1bc3da87759f5f$export$16a28057038b10ef) && (0, $iyYYs.logger).log(`[Tracing] Starting ${finalContext.op} transaction on scope`);
        const { location: location } = (0, $5e51d76f74d40e19$export$56d8a8a25bd48b81);
        const idleTransaction = (0, $fBYWi.startIdleTransaction)(hub, finalContext, idleTimeout, finalTimeout, true, {
            location: location
        }, heartbeatInterval, isPageloadTransaction);
        if (isPageloadTransaction) {
            if ((0, $5e51d76f74d40e19$export$56d8a8a25bd48b81).document) {
                (0, $5e51d76f74d40e19$export$56d8a8a25bd48b81).document.addEventListener("readystatechange", ()=>{
                    if ([
                        "interactive",
                        "complete"
                    ].includes((0, $5e51d76f74d40e19$export$56d8a8a25bd48b81).document.readyState)) idleTransaction.sendAutoFinishSignal();
                });
                if ([
                    "interactive",
                    "complete"
                ].includes((0, $5e51d76f74d40e19$export$56d8a8a25bd48b81).document.readyState)) idleTransaction.sendAutoFinishSignal();
            }
        }
        idleTransaction.registerBeforeFinishCallback((transaction)=>{
            this._collectWebVitals();
            (0, $cc0305d4af214257$export$5f8fa6b3467a7443)(transaction);
        });
        return idleTransaction;
    }
    /** Start listener for interaction transactions */ _registerInteractionListener() {
        let inflightInteractionTransaction;
        const registerInteractionTransaction = ()=>{
            const { idleTimeout: idleTimeout, finalTimeout: finalTimeout, heartbeatInterval: heartbeatInterval } = this.options;
            const op = "ui.action.click";
            // eslint-disable-next-line deprecation/deprecation
            const currentTransaction = (0, $4kgMm.getActiveTransaction)();
            if (currentTransaction && currentTransaction.op && [
                "navigation",
                "pageload"
            ].includes(currentTransaction.op)) {
                (0, $8a1bc3da87759f5f$export$16a28057038b10ef) && (0, $iyYYs.logger).warn(`[Tracing] Did not create ${op} transaction because a pageload or navigation transaction is in progress.`);
                return undefined;
            }
            if (inflightInteractionTransaction) {
                inflightInteractionTransaction.setFinishReason("interactionInterrupted");
                inflightInteractionTransaction.end();
                inflightInteractionTransaction = undefined;
            }
            if (!this._getCurrentHub) {
                (0, $8a1bc3da87759f5f$export$16a28057038b10ef) && (0, $iyYYs.logger).warn(`[Tracing] Did not create ${op} transaction because _getCurrentHub is invalid.`);
                return undefined;
            }
            if (!this._latestRoute.name) {
                (0, $8a1bc3da87759f5f$export$16a28057038b10ef) && (0, $iyYYs.logger).warn(`[Tracing] Did not create ${op} transaction because _latestRouteName is missing.`);
                return undefined;
            }
            const hub = this._getCurrentHub();
            const { location: location } = (0, $5e51d76f74d40e19$export$56d8a8a25bd48b81);
            const context = {
                name: this._latestRoute.name,
                op: op,
                trimEnd: true,
                data: {
                    [(0, $ePKuD.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: this._latestRoute.context ? $af9d9619b7a5c686$var$getSource(this._latestRoute.context) : "url"
                }
            };
            inflightInteractionTransaction = (0, $fBYWi.startIdleTransaction)(hub, context, idleTimeout, finalTimeout, true, {
                location: location
            }, heartbeatInterval);
        };
        [
            "click"
        ].forEach((type)=>{
            if ((0, $5e51d76f74d40e19$export$56d8a8a25bd48b81).document) addEventListener(type, registerInteractionTransaction, {
                once: false,
                capture: true
            });
        });
    }
    /** Creates a listener on interaction entries, and maps interactionIds to the origin path of the interaction */ _registerInpInteractionListener() {
        const handleEntries = ({ entries: entries })=>{
            const client = (0, $ejob9.getClient)();
            // We need to get the replay, user, and activeTransaction from the current scope
            // so that we can associate replay id, profile id, and a user display to the span
            const replay = client !== undefined && client.getIntegrationByName !== undefined ? client.getIntegrationByName("Replay") : undefined;
            const replayId = replay !== undefined ? replay.getReplayId() : undefined;
            // eslint-disable-next-line deprecation/deprecation
            const activeTransaction = (0, $4kgMm.getActiveTransaction)();
            const currentScope = (0, $ejob9.getCurrentScope)();
            const user = currentScope !== undefined ? currentScope.getUser() : undefined;
            entries.forEach((entry)=>{
                if ($af9d9619b7a5c686$var$isPerformanceEventTiming(entry)) {
                    const interactionId = entry.interactionId;
                    if (interactionId === undefined) return;
                    const existingInteraction = this._interactionIdToRouteNameMapping[interactionId];
                    const duration = entry.duration;
                    const startTime = entry.startTime;
                    const keys = Object.keys(this._interactionIdToRouteNameMapping);
                    const minInteractionId = keys.length > 0 ? keys.reduce((a, b)=>{
                        return this._interactionIdToRouteNameMapping[a].duration < this._interactionIdToRouteNameMapping[b].duration ? a : b;
                    }) : undefined;
                    // For a first input event to be considered, we must check that an interaction event does not already exist with the same duration and start time.
                    // This is also checked in the web-vitals library.
                    if (entry.entryType === "first-input") {
                        const matchingEntry = keys.map((key)=>this._interactionIdToRouteNameMapping[key]).some((interaction)=>{
                            return interaction.duration === duration && interaction.startTime === startTime;
                        });
                        if (matchingEntry) return;
                    }
                    // Interactions with an id of 0 and are not first-input are not valid.
                    if (!interactionId) return;
                    // If the interaction already exists, we want to use the duration of the longest entry, since that is what the INP metric uses.
                    if (existingInteraction) existingInteraction.duration = Math.max(existingInteraction.duration, duration);
                    else if (keys.length < $af9d9619b7a5c686$var$MAX_INTERACTIONS || minInteractionId === undefined || duration > this._interactionIdToRouteNameMapping[minInteractionId].duration) {
                        // If the interaction does not exist, we want to add it to the mapping if there is space, or if the duration is longer than the shortest entry.
                        const routeName = this._latestRoute.name;
                        const parentContext = this._latestRoute.context;
                        if (routeName && parentContext) {
                            if (minInteractionId && Object.keys(this._interactionIdToRouteNameMapping).length >= $af9d9619b7a5c686$var$MAX_INTERACTIONS) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
                            delete this._interactionIdToRouteNameMapping[minInteractionId];
                            this._interactionIdToRouteNameMapping[interactionId] = {
                                routeName: routeName,
                                duration: duration,
                                parentContext: parentContext,
                                user: user,
                                activeTransaction: activeTransaction,
                                replayId: replayId,
                                startTime: startTime
                            };
                        }
                    }
                }
            });
        };
        (0, $6b49d60e25dc0568$export$69816c1a049f8db6)("event", handleEntries);
        (0, $6b49d60e25dc0568$export$69816c1a049f8db6)("first-input", handleEntries);
    }
}
/** Returns the value of a meta tag */ function $af9d9619b7a5c686$export$f147b32b03c9cf11(metaName) {
    // Can't specify generic to `getDomElement` because tracing can be used
    // in a variety of environments, have to disable `no-unsafe-member-access`
    // as a result.
    const metaTag = (0, $6DrO1.getDomElement)(`meta[name=${metaName}]`);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return metaTag ? metaTag.getAttribute("content") : undefined;
}
function $af9d9619b7a5c686$var$getSource(context) {
    const sourceFromAttributes = context.attributes && context.attributes[0, $ePKuD.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
    // eslint-disable-next-line deprecation/deprecation
    const sourceFromData = context.data && context.data[0, $ePKuD.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
    // eslint-disable-next-line deprecation/deprecation
    const sourceFromMetadata = context.metadata && context.metadata.source;
    return sourceFromAttributes || sourceFromData || sourceFromMetadata;
}
function $af9d9619b7a5c686$var$isPerformanceEventTiming(entry) {
    return "duration" in entry;
}

/**
 * This code was originally copied from the 'cookie` module at v0.5.0 and was simplified for our use case.
 * https://github.com/jshttp/cookie/blob/a0c84147aab6266bdb3996cf4062e93907c0b0fc/index.js
 * It had the following license:
 *
 * (The MIT License)
 *
 * Copyright (c) 2012-2014 Roman Shtylman <shtylman@gmail.com>
 * Copyright (c) 2015 Douglas Christopher Wilson <doug@somethingdoug.com>
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * 'Software'), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */ /**
 * Parses a cookie string
 */ function $4853e14926d40f55$export$d0eaf3e94be578f6(str) {
    const obj = {};
    let index = 0;
    while(index < str.length){
        const eqIdx = str.indexOf("=", index);
        // no more cookie pairs
        if (eqIdx === -1) break;
        let endIdx = str.indexOf(";", index);
        if (endIdx === -1) endIdx = str.length;
        else if (endIdx < eqIdx) {
            // backtrack on prior semicolon
            index = str.lastIndexOf(";", eqIdx - 1) + 1;
            continue;
        }
        const key = str.slice(index, eqIdx).trim();
        // only assign once
        if (undefined === obj[key]) {
            let val = str.slice(eqIdx + 1, endIdx).trim();
            // quoted values
            if (val.charCodeAt(0) === 0x22) val = val.slice(1, -1);
            try {
                obj[key] = val.indexOf("%") !== -1 ? decodeURIComponent(val) : val;
            } catch (e) {
                obj[key] = val;
            }
        }
        index = endIdx + 1;
    }
    return obj;
}



var $5rgwG = parcelRequire("5rgwG");

var $dR6t7 = parcelRequire("dR6t7");

var $iyYYs = parcelRequire("iyYYs");

var $l7pai = parcelRequire("l7pai");

const $8a926e7e2f1197af$var$DEFAULT_INCLUDES = {
    ip: false,
    request: true,
    transaction: true,
    user: true
};
const $8a926e7e2f1197af$var$DEFAULT_REQUEST_INCLUDES = [
    "cookies",
    "data",
    "headers",
    "method",
    "query_string",
    "url"
];
const $8a926e7e2f1197af$export$33c1c602a3538e5e = [
    "id",
    "username",
    "email"
];
/**
 * Sets parameterized route as transaction name e.g.: `GET /users/:id`
 * Also adds more context data on the transaction from the request.
 *
 * @deprecated This utility will be removed in v8.
 */ function $8a926e7e2f1197af$export$1973410ef8793cd6(transaction, req, deps) {
    if (!transaction) return;
    // eslint-disable-next-line deprecation/deprecation
    if (!transaction.metadata.source || transaction.metadata.source === "url") {
        // Attempt to grab a parameterized route off of the request
        const [name, source] = $8a926e7e2f1197af$export$8c5ebee2e5bb9575(req, {
            path: true,
            method: true
        });
        transaction.updateName(name);
        // TODO: SEMANTIC_ATTRIBUTE_SENTRY_SOURCE is in core, align this once we merge utils & core
        // eslint-disable-next-line deprecation/deprecation
        transaction.setMetadata({
            source: source
        });
    }
    transaction.setAttribute("url", req.originalUrl || req.url);
    if (req.baseUrl) transaction.setAttribute("baseUrl", req.baseUrl);
    // TODO: We need to rewrite this to a flat format?
    // eslint-disable-next-line deprecation/deprecation
    transaction.setData("query", $8a926e7e2f1197af$var$extractQueryParams(req, deps));
}
/**
 * Extracts a complete and parameterized path from the request object and uses it to construct transaction name.
 * If the parameterized transaction name cannot be extracted, we fall back to the raw URL.
 *
 * Additionally, this function determines and returns the transaction name source
 *
 * eg. GET /mountpoint/user/:id
 *
 * @param req A request object
 * @param options What to include in the transaction name (method, path, or a custom route name to be
 *                used instead of the request's route)
 *
 * @returns A tuple of the fully constructed transaction name [0] and its source [1] (can be either 'route' or 'url')
 */ function $8a926e7e2f1197af$export$8c5ebee2e5bb9575(req, options = {}) {
    const method = req.method && req.method.toUpperCase();
    let path = "";
    let source = "url";
    // Check to see if there's a parameterized route we can use (as there is in Express)
    if (options.customRoute || req.route) {
        path = options.customRoute || `${req.baseUrl || ""}${req.route && req.route.path}`;
        source = "route";
    } else if (req.originalUrl || req.url) path = (0, $73075039f785ecac$export$ce084c78234bd35)(req.originalUrl || req.url || "");
    let name = "";
    if (options.method && method) name += method;
    if (options.method && options.path) name += " ";
    if (options.path && path) name += path;
    return [
        name,
        source
    ];
}
/** JSDoc */ function $8a926e7e2f1197af$var$extractTransaction(req, type) {
    switch(type){
        case "path":
            return $8a926e7e2f1197af$export$8c5ebee2e5bb9575(req, {
                path: true
            })[0];
        case "handler":
            return req.route && req.route.stack && req.route.stack[0] && req.route.stack[0].name || "<anonymous>";
        case "methodPath":
        default:
            {
                // if exist _reconstructedRoute return that path instead of route.path
                const customRoute = req._reconstructedRoute ? req._reconstructedRoute : undefined;
                return $8a926e7e2f1197af$export$8c5ebee2e5bb9575(req, {
                    path: true,
                    method: true,
                    customRoute: customRoute
                })[0];
            }
    }
}
/** JSDoc */ function $8a926e7e2f1197af$var$extractUserData(user, keys) {
    const extractedUser = {};
    const attributes = Array.isArray(keys) ? keys : $8a926e7e2f1197af$export$33c1c602a3538e5e;
    attributes.forEach((key)=>{
        if (user && key in user) extractedUser[key] = user[key];
    });
    return extractedUser;
}
/**
 * Normalize data from the request object, accounting for framework differences.
 *
 * @param req The request object from which to extract data
 * @param options.include An optional array of keys to include in the normalized data. Defaults to
 * DEFAULT_REQUEST_INCLUDES if not provided.
 * @param options.deps Injected, platform-specific dependencies
 * @returns An object containing normalized request data
 */ function $8a926e7e2f1197af$export$b5c5d78255f11c84(req, options) {
    const { include: include = $8a926e7e2f1197af$var$DEFAULT_REQUEST_INCLUDES, deps: deps } = options || {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const requestData = {};
    // headers:
    //   node, express, koa, nextjs: req.headers
    const headers = req.headers || {};
    // method:
    //   node, express, koa, nextjs: req.method
    const method = req.method;
    // host:
    //   express: req.hostname in > 4 and req.host in < 4
    //   koa: req.host
    //   node, nextjs: req.headers.host
    // Express 4 mistakenly strips off port number from req.host / req.hostname so we can't rely on them
    // See: https://github.com/expressjs/express/issues/3047#issuecomment-236653223
    // Also: https://github.com/getsentry/sentry-javascript/issues/1917
    const host = headers.host || req.hostname || req.host || "<no host>";
    // protocol:
    //   node, nextjs: <n/a>
    //   express, koa: req.protocol
    const protocol = req.protocol === "https" || req.socket && req.socket.encrypted ? "https" : "http";
    // url (including path and query string):
    //   node, express: req.originalUrl
    //   koa, nextjs: req.url
    const originalUrl = req.originalUrl || req.url || "";
    // absolute url
    const absoluteUrl = originalUrl.startsWith(protocol) ? originalUrl : `${protocol}://${host}${originalUrl}`;
    include.forEach((key)=>{
        switch(key){
            case "headers":
                requestData.headers = headers;
                // Remove the Cookie header in case cookie data should not be included in the event
                if (!include.includes("cookies")) delete requestData.headers.cookie;
                break;
            case "method":
                requestData.method = method;
                break;
            case "url":
                requestData.url = absoluteUrl;
                break;
            case "cookies":
                // cookies:
                //   node, express, koa: req.headers.cookie
                //   vercel, sails.js, express (w/ cookie middleware), nextjs: req.cookies
                requestData.cookies = // TODO (v8 / #5257): We're only sending the empty object for backwards compatibility, so the last bit can
                // come off in v8
                req.cookies || headers.cookie && (0, $4853e14926d40f55$export$d0eaf3e94be578f6)(headers.cookie) || {};
                break;
            case "query_string":
                // query string:
                //   node: req.url (raw)
                //   express, koa, nextjs: req.query
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                requestData.query_string = $8a926e7e2f1197af$var$extractQueryParams(req, deps);
                break;
            case "data":
                if (method === "GET" || method === "HEAD") break;
                // body data:
                //   express, koa, nextjs: req.body
                //
                //   when using node by itself, you have to read the incoming stream(see
                //   https://nodejs.dev/learn/get-http-request-body-data-using-nodejs); if a user is doing that, we can't know
                //   where they're going to store the final result, so they'll have to capture this data themselves
                if (req.body !== undefined) requestData.data = (0, $dR6t7.isString)(req.body) ? req.body : JSON.stringify((0, $l7pai.normalize)(req.body));
                break;
            default:
                if (({}).hasOwnProperty.call(req, key)) requestData[key] = req[key];
        }
    });
    return requestData;
}
/**
 * Add data from the given request to the given event
 *
 * @param event The event to which the request data will be added
 * @param req Request object
 * @param options.include Flags to control what data is included
 * @param options.deps Injected platform-specific dependencies
 * @returns The mutated `Event` object
 */ function $8a926e7e2f1197af$export$e560aeb323d2791d(event, req, options) {
    const include = {
        ...$8a926e7e2f1197af$var$DEFAULT_INCLUDES,
        ...options && options.include
    };
    if (include.request) {
        const extractedRequestData = Array.isArray(include.request) ? $8a926e7e2f1197af$export$b5c5d78255f11c84(req, {
            include: include.request,
            deps: options && options.deps
        }) : $8a926e7e2f1197af$export$b5c5d78255f11c84(req, {
            deps: options && options.deps
        });
        event.request = {
            ...event.request,
            ...extractedRequestData
        };
    }
    if (include.user) {
        const extractedUser = req.user && (0, $dR6t7.isPlainObject)(req.user) ? $8a926e7e2f1197af$var$extractUserData(req.user, include.user) : {};
        if (Object.keys(extractedUser).length) event.user = {
            ...event.user,
            ...extractedUser
        };
    }
    // client ip:
    //   node, nextjs: req.socket.remoteAddress
    //   express, koa: req.ip
    if (include.ip) {
        const ip = req.ip || req.socket && req.socket.remoteAddress;
        if (ip) event.user = {
            ...event.user,
            ip_address: ip
        };
    }
    if (include.transaction && !event.transaction) // TODO do we even need this anymore?
    // TODO make this work for nextjs
    event.transaction = $8a926e7e2f1197af$var$extractTransaction(req, include.transaction);
    return event;
}
function $8a926e7e2f1197af$var$extractQueryParams(req, deps) {
    // url (including path and query string):
    //   node, express: req.originalUrl
    //   koa, nextjs: req.url
    let originalUrl = req.originalUrl || req.url || "";
    if (!originalUrl) return;
    // The `URL` constructor can't handle internal URLs of the form `/some/path/here`, so stick a dummy protocol and
    // hostname on the beginning. Since the point here is just to grab the query string, it doesn't matter what we use.
    if (originalUrl.startsWith("/")) originalUrl = `http://dogs.are.great${originalUrl}`;
    try {
        return req.query || typeof URL !== "undefined" && new URL(originalUrl).search.slice(1) || // In Node 8, `URL` isn't in the global scope, so we have to use the built-in module from Node
        deps && deps.url && deps.url.parse(originalUrl).query || undefined;
    } catch (e2) {
        return undefined;
    }
}
/**
 * Transforms a `Headers` object that implements the `Web Fetch API` (https://developer.mozilla.org/en-US/docs/Web/API/Headers) into a simple key-value dict.
 * The header keys will be lower case: e.g. A "Content-Type" header will be stored as "content-type".
 */ // TODO(v8): Make this function return undefined when the extraction fails.
function $8a926e7e2f1197af$export$fee0927b05379c23(winterCGHeaders) {
    const headers = {};
    try {
        winterCGHeaders.forEach((value, key)=>{
            if (typeof value === "string") // We check that value is a string even though it might be redundant to make sure prototype pollution is not possible.
            headers[key] = value;
        });
    } catch (e) {
        (0, $5rgwG.DEBUG_BUILD) && (0, $iyYYs.logger).warn("Sentry failed extracting headers from a request object. If you see this, please file an issue.");
    }
    return headers;
}
/**
 * Converts a `Request` object that implements the `Web Fetch API` (https://developer.mozilla.org/en-US/docs/Web/API/Headers) into the format that the `RequestData` integration understands.
 */ function $8a926e7e2f1197af$export$49a11ed11911fd29(req) {
    const headers = $8a926e7e2f1197af$export$fee0927b05379c23(req.headers);
    return {
        method: req.method,
        url: req.url,
        headers: headers
    };
}


var $8a8aJ = parcelRequire("8a8aJ");
var $dR6t7 = parcelRequire("dR6t7");
var $iyYYs = parcelRequire("iyYYs");

var $ePKuD = parcelRequire("ePKuD");
var $ceyhT = parcelRequire("ceyhT");


/* eslint-disable max-lines */ /**
 * Express integration
 *
 * Provides an request and error handler for Express framework as well as tracing capabilities
 */ class $40e74f1beac4ae1e$export$6dafdd8fec05099d {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "Express";
    }
    /**
   * @inheritDoc
   */ /**
   * Express App instance
   */ /**
   * @inheritDoc
   */ constructor(options = {}){
        this.name = $40e74f1beac4ae1e$export$6dafdd8fec05099d.id;
        this._router = options.router || options.app;
        this._methods = (Array.isArray(options.methods) ? options.methods : []).concat("use");
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    setupOnce(_, getCurrentHub) {
        if (!this._router) {
            (0, $8a1bc3da87759f5f$export$16a28057038b10ef) && (0, $iyYYs.logger).error("ExpressIntegration is missing an Express instance");
            return;
        }
        if ((0, $98cbc8e6b5922577$export$34db76d03eb96b7e)(getCurrentHub)) {
            (0, $8a1bc3da87759f5f$export$16a28057038b10ef) && (0, $iyYYs.logger).log("Express Integration is skipped because of instrumenter configuration.");
            return;
        }
        $40e74f1beac4ae1e$var$instrumentMiddlewares(this._router, this._methods);
        $40e74f1beac4ae1e$var$instrumentRouter(this._router);
    }
}
$40e74f1beac4ae1e$export$6dafdd8fec05099d.__initStatic();
/**
 * Wraps original middleware function in a tracing call, which stores the info about the call as a span,
 * and finishes it once the middleware is done invoking.
 *
 * Express middlewares have 3 various forms, thus we have to take care of all of them:
 * // sync
 * app.use(function (req, res) { ... })
 * // async
 * app.use(function (req, res, next) { ... })
 * // error handler
 * app.use(function (err, req, res, next) { ... })
 *
 * They all internally delegate to the `router[method]` of the given application instance.
 */ // eslint-disable-next-line @typescript-eslint/ban-types, @typescript-eslint/no-explicit-any
function $40e74f1beac4ae1e$var$wrap(fn, method) {
    const arity = fn.length;
    switch(arity){
        case 2:
            return function(req, res) {
                const transaction = res.__sentry_transaction;
                if (transaction) {
                    // eslint-disable-next-line deprecation/deprecation
                    const span = transaction.startChild({
                        description: fn.name,
                        op: `middleware.express.${method}`,
                        origin: "auto.middleware.express"
                    });
                    res.once("finish", ()=>{
                        span.end();
                    });
                }
                return fn.call(this, req, res);
            };
        case 3:
            return function(req, res, next) {
                const transaction = res.__sentry_transaction;
                // eslint-disable-next-line deprecation/deprecation
                const span = (0, $89603552ac3124a9$export$3cc482e6b02f32f7)([
                    transaction,
                    "optionalAccess",
                    (_2)=>_2.startChild,
                    "call",
                    (_3)=>_3({
                            description: fn.name,
                            op: `middleware.express.${method}`,
                            origin: "auto.middleware.express"
                        })
                ]);
                fn.call(this, req, res, function(...args) {
                    (0, $89603552ac3124a9$export$3cc482e6b02f32f7)([
                        span,
                        "optionalAccess",
                        (_4)=>_4.end,
                        "call",
                        (_5)=>_5()
                    ]);
                    next.call(this, ...args);
                });
            };
        case 4:
            return function(err, req, res, next) {
                const transaction = res.__sentry_transaction;
                // eslint-disable-next-line deprecation/deprecation
                const span = (0, $89603552ac3124a9$export$3cc482e6b02f32f7)([
                    transaction,
                    "optionalAccess",
                    (_6)=>_6.startChild,
                    "call",
                    (_7)=>_7({
                            description: fn.name,
                            op: `middleware.express.${method}`,
                            origin: "auto.middleware.express"
                        })
                ]);
                fn.call(this, err, req, res, function(...args) {
                    (0, $89603552ac3124a9$export$3cc482e6b02f32f7)([
                        span,
                        "optionalAccess",
                        (_8)=>_8.end,
                        "call",
                        (_9)=>_9()
                    ]);
                    next.call(this, ...args);
                });
            };
        default:
            throw new Error(`Express middleware takes 2-4 arguments. Got: ${arity}`);
    }
}
/**
 * Takes all the function arguments passed to the original `app` or `router` method, eg. `app.use` or `router.use`
 * and wraps every function, as well as array of functions with a call to our `wrap` method.
 * We have to take care of the arrays as well as iterate over all of the arguments,
 * as `app.use` can accept middlewares in few various forms.
 *
 * app.use([<path>], <fn>)
 * app.use([<path>], <fn>, ...<fn>)
 * app.use([<path>], ...<fn>[])
 */ function $40e74f1beac4ae1e$var$wrapMiddlewareArgs(args, method) {
    return args.map((arg)=>{
        if (typeof arg === "function") return $40e74f1beac4ae1e$var$wrap(arg, method);
        if (Array.isArray(arg)) return arg.map((a)=>{
            if (typeof a === "function") return $40e74f1beac4ae1e$var$wrap(a, method);
            return a;
        });
        return arg;
    });
}
/**
 * Patches original router to utilize our tracing functionality
 */ function $40e74f1beac4ae1e$var$patchMiddleware(router, method) {
    const originalCallback = router[method];
    router[method] = function(...args) {
        return originalCallback.call(this, ...$40e74f1beac4ae1e$var$wrapMiddlewareArgs(args, method));
    };
    return router;
}
/**
 * Patches original router methods
 */ function $40e74f1beac4ae1e$var$instrumentMiddlewares(router, methods = []) {
    methods.forEach((method)=>$40e74f1beac4ae1e$var$patchMiddleware(router, method));
}
/**
 * Patches the prototype of Express.Router to accumulate the resolved route
 * if a layer instance's `match` function was called and it returned a successful match.
 *
 * @see https://github.com/expressjs/express/blob/master/lib/router/index.js
 *
 * @param appOrRouter the router instance which can either be an app (i.e. top-level) or a (nested) router.
 */ function $40e74f1beac4ae1e$var$instrumentRouter(appOrRouter) {
    // This is how we can distinguish between app and routers
    const isApp = "settings" in appOrRouter;
    // In case the app's top-level router hasn't been initialized yet, we have to do it now
    if (isApp && appOrRouter._router === undefined && appOrRouter.lazyrouter) appOrRouter.lazyrouter();
    const router = isApp ? appOrRouter._router : appOrRouter;
    if (!router) {
        /*
    If we end up here, this means likely that this integration is used with Express 3 or Express 5.
    For now, we don't support these versions (3 is very old and 5 is still in beta). To support Express 5,
    we'd need to make more changes to the routing instrumentation because the router is no longer part of
    the Express core package but maintained in its own package. The new router has different function
    signatures and works slightly differently, demanding more changes than just taking the router from
    `app.router` instead of `app._router`.
    @see https://github.com/pillarjs/router

    TODO: Proper Express 5 support
    */ (0, $8a1bc3da87759f5f$export$16a28057038b10ef) && (0, $iyYYs.logger).debug("Cannot instrument router for URL Parameterization (did not find a valid router).");
        (0, $8a1bc3da87759f5f$export$16a28057038b10ef) && (0, $iyYYs.logger).debug("Routing instrumentation is currently only supported in Express 4.");
        return;
    }
    const routerProto = Object.getPrototypeOf(router);
    const originalProcessParams = routerProto.process_params;
    routerProto.process_params = function process_params(layer, called, req, res, done) {
        // Base case: We're in the first part of the URL (thus we start with the root '/')
        if (!req._reconstructedRoute) req._reconstructedRoute = "";
        // If the layer's partial route has params, is a regex or an array, the route is stored in layer.route.
        const { layerRoutePath: layerRoutePath, isRegex: isRegex, isArray: isArray, numExtraSegments: numExtraSegments } = $40e74f1beac4ae1e$var$getLayerRoutePathInfo(layer);
        if (layerRoutePath || isRegex || isArray) req._hasParameters = true;
        // Otherwise, the hardcoded path (i.e. a partial route without params) is stored in layer.path
        let partialRoute;
        if (layerRoutePath) partialRoute = layerRoutePath;
        else /**
       * prevent duplicate segment in _reconstructedRoute param if router match multiple routes before final path
       * example:
       * original url: /api/v1/1234
       * prevent: /api/api/v1/:userId
       * router structure
       * /api -> middleware
       * /api/v1 -> middleware
       * /1234 -> endpoint with param :userId
       * final _reconstructedRoute is /api/v1/:userId
       */ partialRoute = $40e74f1beac4ae1e$export$ea5dbbfd8423c1fa(req.originalUrl, req._reconstructedRoute, layer.path) || "";
        // Normalize the partial route so that it doesn't contain leading or trailing slashes
        // and exclude empty or '*' wildcard routes.
        // The exclusion of '*' routes is our best effort to not "pollute" the transaction name
        // with interim handlers (e.g. ones that check authentication or do other middleware stuff).
        // We want to end up with the parameterized URL of the incoming request without any extraneous path segments.
        const finalPartialRoute = partialRoute.split("/").filter((segment)=>segment.length > 0 && (isRegex || isArray || !segment.includes("*"))).join("/");
        // If we found a valid partial URL, we append it to the reconstructed route
        if (finalPartialRoute && finalPartialRoute.length > 0) // If the partial route is from a regex route, we append a '/' to close the regex
        req._reconstructedRoute += `/${finalPartialRoute}${isRegex ? "/" : ""}`;
        // Now we check if we are in the "last" part of the route. We determine this by comparing the
        // number of URL segments from the original URL to that of our reconstructed parameterized URL.
        // If we've reached our final destination, we update the transaction name.
        const urlLength = (0, $73075039f785ecac$export$69dd85280a8d374c)((0, $73075039f785ecac$export$ce084c78234bd35)(req.originalUrl || "")) + numExtraSegments;
        const routeLength = (0, $73075039f785ecac$export$69dd85280a8d374c)(req._reconstructedRoute);
        if (urlLength === routeLength) {
            if (!req._hasParameters) {
                if (req._reconstructedRoute !== req.originalUrl) req._reconstructedRoute = req.originalUrl ? (0, $73075039f785ecac$export$ce084c78234bd35)(req.originalUrl) : req.originalUrl;
            }
            const transaction = res.__sentry_transaction;
            const attributes = transaction && (0, $ceyhT.spanToJSON)(transaction).data || {};
            if (transaction && attributes[0, $ePKuD.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] !== "custom") {
                // If the request URL is '/' or empty, the reconstructed route will be empty.
                // Therefore, we fall back to setting the final route to '/' in this case.
                const finalRoute = req._reconstructedRoute || "/";
                const [name, source] = (0, $8a926e7e2f1197af$export$8c5ebee2e5bb9575)(req, {
                    path: true,
                    method: true,
                    customRoute: finalRoute
                });
                transaction.updateName(name);
                transaction.setAttribute((0, $ePKuD.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE), source);
            }
        }
        return originalProcessParams.call(this, layer, called, req, res, done);
    };
}
/**
 * Recreate layer.route.path from layer.regexp and layer.keys.
 * Works until express.js used package path-to-regexp@0.1.7
 * or until layer.keys contain offset attribute
 *
 * @param layer the layer to extract the stringified route from
 *
 * @returns string in layer.route.path structure 'router/:pathParam' or undefined
 */ const $40e74f1beac4ae1e$export$bde9c19304d7dbd3 = (path, regexp, keys)=>{
    if (!path || !regexp || !keys || Object.keys(keys).length === 0 || (0, $89603552ac3124a9$export$3cc482e6b02f32f7)([
        keys,
        "access",
        (_10)=>_10[0],
        "optionalAccess",
        (_11)=>_11.offset
    ]) === undefined || (0, $89603552ac3124a9$export$3cc482e6b02f32f7)([
        keys,
        "access",
        (_12)=>_12[0],
        "optionalAccess",
        (_13)=>_13.offset
    ]) === null) return undefined;
    const orderedKeys = keys.sort((a, b)=>a.offset - b.offset);
    // add d flag for getting indices from regexp result
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- regexp comes from express.js
    const pathRegex = new RegExp(regexp, `${regexp.flags}d`);
    /**
   * use custom type cause of TS error with missing indices in RegExpExecArray
   */ const execResult = pathRegex.exec(path);
    if (!execResult || !execResult.indices) return undefined;
    /**
   * remove first match from regex cause contain whole layer.path
   */ const [, ...paramIndices] = execResult.indices;
    if (paramIndices.length !== orderedKeys.length) return undefined;
    let resultPath = path;
    let indexShift = 0;
    /**
   * iterate param matches from regexp.exec
   */ paramIndices.forEach((item, index)=>{
        /** check if offsets is define because in some cases regex d flag returns undefined */ if (item) {
            const [startOffset, endOffset] = item;
            /**
       * isolate part before param
       */ const substr1 = resultPath.substring(0, startOffset - indexShift);
            /**
       * define paramName as replacement in format :pathParam
       */ const replacement = `:${orderedKeys[index].name}`;
            /**
       * isolate part after param
       */ const substr2 = resultPath.substring(endOffset - indexShift);
            /**
       * recreate original path but with param replacement
       */ resultPath = substr1 + replacement + substr2;
            /**
       * calculate new index shift after resultPath was modified
       */ indexShift = indexShift + (endOffset - startOffset - replacement.length);
        }
    });
    return resultPath;
};
/**
 * Extracts and stringifies the layer's route which can either be a string with parameters (`users/:id`),
 * a RegEx (`/test/`) or an array of strings and regexes (`['/path1', /\/path[2-5]/, /path/:id]`). Additionally
 * returns extra information about the route, such as if the route is defined as regex or as an array.
 *
 * @param layer the layer to extract the stringified route from
 *
 * @returns an object containing the stringified route, a flag determining if the route was a regex
 *          and the number of extra segments to the matched path that are additionally in the route,
 *          if the route was an array (defaults to 0).
 */ function $40e74f1beac4ae1e$var$getLayerRoutePathInfo(layer) {
    let lrp = (0, $89603552ac3124a9$export$3cc482e6b02f32f7)([
        layer,
        "access",
        (_14)=>_14.route,
        "optionalAccess",
        (_15)=>_15.path
    ]);
    const isRegex = (0, $dR6t7.isRegExp)(lrp);
    const isArray = Array.isArray(lrp);
    if (!lrp) {
        // parse node.js major version
        // Next.js will complain if we directly use `proces.versions` here because of edge runtime.
        const [major] = (0, $8a8aJ.GLOBAL_OBJ).process.versions.node.split(".").map(Number);
        // allow call extractOriginalRoute only if node version support Regex d flag, node 16+
        if (major >= 16) /**
       * If lrp does not exist try to recreate original layer path from route regexp
       */ lrp = $40e74f1beac4ae1e$export$bde9c19304d7dbd3(layer.path, layer.regexp, layer.keys);
    }
    if (!lrp) return {
        isRegex: isRegex,
        isArray: isArray,
        numExtraSegments: 0
    };
    const numExtraSegments = isArray ? Math.max($40e74f1beac4ae1e$var$getNumberOfArrayUrlSegments(lrp) - (0, $73075039f785ecac$export$69dd85280a8d374c)(layer.path || ""), 0) : 0;
    const layerRoutePath = $40e74f1beac4ae1e$var$getLayerRoutePathString(isArray, lrp);
    return {
        layerRoutePath: layerRoutePath,
        isRegex: isRegex,
        isArray: isArray,
        numExtraSegments: numExtraSegments
    };
}
/**
 * Returns the number of URL segments in an array of routes
 *
 * Example: ['/api/test', /\/api\/post[0-9]/, '/users/:id/details`] -> 7
 */ function $40e74f1beac4ae1e$var$getNumberOfArrayUrlSegments(routesArray) {
    return routesArray.reduce((accNumSegments, currentRoute)=>{
        // array members can be a RegEx -> convert them toString
        return accNumSegments + (0, $73075039f785ecac$export$69dd85280a8d374c)(currentRoute.toString());
    }, 0);
}
/**
 * Extracts and returns the stringified version of the layers route path
 * Handles route arrays (by joining the paths together) as well as RegExp and normal
 * string values (in the latter case the toString conversion is technically unnecessary but
 * it doesn't hurt us either).
 */ function $40e74f1beac4ae1e$var$getLayerRoutePathString(isArray, lrp) {
    if (isArray) return lrp.map((r)=>r.toString()).join(",");
    return lrp && lrp.toString();
}
/**
 * remove duplicate segment contain in layerPath against reconstructedRoute,
 * and return only unique segment that can be added into reconstructedRoute
 */ function $40e74f1beac4ae1e$export$ea5dbbfd8423c1fa(originalUrl, reconstructedRoute, layerPath) {
    // filter query params
    const normalizeURL = (0, $73075039f785ecac$export$ce084c78234bd35)(originalUrl || "");
    const originalUrlSplit = (0, $89603552ac3124a9$export$3cc482e6b02f32f7)([
        normalizeURL,
        "optionalAccess",
        (_16)=>_16.split,
        "call",
        (_17)=>_17("/"),
        "access",
        (_18)=>_18.filter,
        "call",
        (_19)=>_19((v)=>!!v)
    ]);
    let tempCounter = 0;
    const currentOffset = (0, $89603552ac3124a9$export$3cc482e6b02f32f7)([
        reconstructedRoute,
        "optionalAccess",
        (_20)=>_20.split,
        "call",
        (_21)=>_21("/"),
        "access",
        (_22)=>_22.filter,
        "call",
        (_23)=>_23((v)=>!!v),
        "access",
        (_24)=>_24.length
    ]) || 0;
    const result = (0, $89603552ac3124a9$export$3cc482e6b02f32f7)([
        layerPath,
        "optionalAccess",
        (_25)=>_25.split,
        "call",
        (_26)=>_26("/"),
        "access",
        (_27)=>_27.filter,
        "call",
        (_28)=>_28((segment)=>{
                if ((0, $89603552ac3124a9$export$3cc482e6b02f32f7)([
                    originalUrlSplit,
                    "optionalAccess",
                    (_29)=>_29[currentOffset + tempCounter]
                ]) === segment) {
                    tempCounter += 1;
                    return true;
                }
                return false;
            }),
        "access",
        (_30)=>_30.join,
        "call",
        (_31)=>_31("/")
    ]);
    return result;
}


var $4kgMm = parcelRequire("4kgMm");
var $9fGKl = parcelRequire("9fGKl");
var $dR6t7 = parcelRequire("dR6t7");
var $4C0Qe = parcelRequire("4C0Qe");
var $iyYYs = parcelRequire("iyYYs");


/** Tracing integration for graphql package */ class $90a1d5a82a97b746$export$b735d011553f1049 {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "GraphQL";
    }
    /**
   * @inheritDoc
   */ constructor(){
        this.name = $90a1d5a82a97b746$export$b735d011553f1049.id;
    }
    /** @inheritdoc */ loadDependency() {
        return this._module = this._module || (0, $4C0Qe.loadModule)("graphql/execution/execute.js");
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    setupOnce(_, getCurrentHub) {
        if ((0, $98cbc8e6b5922577$export$34db76d03eb96b7e)(getCurrentHub)) {
            (0, $8a1bc3da87759f5f$export$16a28057038b10ef) && (0, $iyYYs.logger).log("GraphQL Integration is skipped because of instrumenter configuration.");
            return;
        }
        const pkg = this.loadDependency();
        if (!pkg) {
            (0, $8a1bc3da87759f5f$export$16a28057038b10ef) && (0, $iyYYs.logger).error("GraphQL Integration was unable to require graphql/execution package.");
            return;
        }
        (0, $9fGKl.fill)(pkg, "execute", function(orig) {
            return function(...args) {
                // eslint-disable-next-line deprecation/deprecation
                const scope = getCurrentHub().getScope();
                // eslint-disable-next-line deprecation/deprecation
                const parentSpan = scope.getSpan();
                // eslint-disable-next-line deprecation/deprecation
                const span = (0, $89603552ac3124a9$export$3cc482e6b02f32f7)([
                    parentSpan,
                    "optionalAccess",
                    (_2)=>_2.startChild,
                    "call",
                    (_3)=>_3({
                            description: "execute",
                            op: "graphql.execute",
                            origin: "auto.graphql.graphql"
                        })
                ]);
                // eslint-disable-next-line deprecation/deprecation
                (0, $89603552ac3124a9$export$3cc482e6b02f32f7)([
                    scope,
                    "optionalAccess",
                    (_4)=>_4.setSpan,
                    "call",
                    (_5)=>_5(span)
                ]);
                const rv = orig.call(this, ...args);
                if ((0, $dR6t7.isThenable)(rv)) return rv.then((res)=>{
                    (0, $89603552ac3124a9$export$3cc482e6b02f32f7)([
                        span,
                        "optionalAccess",
                        (_6)=>_6.end,
                        "call",
                        (_7)=>_7()
                    ]);
                    // eslint-disable-next-line deprecation/deprecation
                    (0, $89603552ac3124a9$export$3cc482e6b02f32f7)([
                        scope,
                        "optionalAccess",
                        (_8)=>_8.setSpan,
                        "call",
                        (_9)=>_9(parentSpan)
                    ]);
                    return res;
                });
                (0, $89603552ac3124a9$export$3cc482e6b02f32f7)([
                    span,
                    "optionalAccess",
                    (_10)=>_10.end,
                    "call",
                    (_11)=>_11()
                ]);
                // eslint-disable-next-line deprecation/deprecation
                (0, $89603552ac3124a9$export$3cc482e6b02f32f7)([
                    scope,
                    "optionalAccess",
                    (_12)=>_12.setSpan,
                    "call",
                    (_13)=>_13(parentSpan)
                ]);
                return rv;
            };
        });
    }
}
$90a1d5a82a97b746$export$b735d011553f1049.__initStatic();


var $bRL0a = parcelRequire("bRL0a");
var $1COtc = parcelRequire("1COtc");
var $9fGKl = parcelRequire("9fGKl");
var $dR6t7 = parcelRequire("dR6t7");
var $4C0Qe = parcelRequire("4C0Qe");
var $iyYYs = parcelRequire("iyYYs");


// This allows us to use the same array for both defaults options and the type itself.
// (note `as const` at the end to make it a union of string literal types (i.e. "a" | "b" | ... )
// and not just a string[])
const $e2c439f9353b14e5$var$OPERATIONS = [
    "aggregate",
    "bulkWrite",
    "countDocuments",
    "createIndex",
    "createIndexes",
    "deleteMany",
    "deleteOne",
    "distinct",
    "drop",
    "dropIndex",
    "dropIndexes",
    "estimatedDocumentCount",
    "find",
    "findOne",
    "findOneAndDelete",
    "findOneAndReplace",
    "findOneAndUpdate",
    "indexes",
    "indexExists",
    "indexInformation",
    "initializeOrderedBulkOp",
    "insertMany",
    "insertOne",
    "isCapped",
    "mapReduce",
    "options",
    "parallelCollectionScan",
    "rename",
    "replaceOne",
    "stats",
    "updateMany",
    "updateOne"
];
// All of the operations above take `options` and `callback` as their final parameters, but some of them
// take additional parameters as well. For those operations, this is a map of
// { <operation name>:  [<names of additional parameters>] }, as a way to know what to call the operation's
// positional arguments when we add them to the span's `data` object later
const $e2c439f9353b14e5$var$OPERATION_SIGNATURES = {
    // aggregate intentionally not included because `pipeline` arguments are too complex to serialize well
    // see https://github.com/getsentry/sentry-javascript/pull/3102
    bulkWrite: [
        "operations"
    ],
    countDocuments: [
        "query"
    ],
    createIndex: [
        "fieldOrSpec"
    ],
    createIndexes: [
        "indexSpecs"
    ],
    deleteMany: [
        "filter"
    ],
    deleteOne: [
        "filter"
    ],
    distinct: [
        "key",
        "query"
    ],
    dropIndex: [
        "indexName"
    ],
    find: [
        "query"
    ],
    findOne: [
        "query"
    ],
    findOneAndDelete: [
        "filter"
    ],
    findOneAndReplace: [
        "filter",
        "replacement"
    ],
    findOneAndUpdate: [
        "filter",
        "update"
    ],
    indexExists: [
        "indexes"
    ],
    insertMany: [
        "docs"
    ],
    insertOne: [
        "doc"
    ],
    mapReduce: [
        "map",
        "reduce"
    ],
    rename: [
        "newName"
    ],
    replaceOne: [
        "filter",
        "doc"
    ],
    updateMany: [
        "filter",
        "update"
    ],
    updateOne: [
        "filter",
        "update"
    ]
};
function $e2c439f9353b14e5$var$isCursor(maybeCursor) {
    return maybeCursor && typeof maybeCursor === "object" && maybeCursor.once && typeof maybeCursor.once === "function";
}
/** Tracing integration for mongo package */ class $e2c439f9353b14e5$export$968aa4360b02a334 {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "Mongo";
    }
    /**
   * @inheritDoc
   */ /**
   * @inheritDoc
   */ constructor(options = {}){
        this.name = $e2c439f9353b14e5$export$968aa4360b02a334.id;
        this._operations = Array.isArray(options.operations) ? options.operations : $e2c439f9353b14e5$var$OPERATIONS;
        this._describeOperations = "describeOperations" in options ? options.describeOperations : true;
        this._useMongoose = !!options.useMongoose;
    }
    /** @inheritdoc */ loadDependency() {
        const moduleName = this._useMongoose ? "mongoose" : "mongodb";
        return this._module = this._module || (0, $4C0Qe.loadModule)(moduleName);
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    setupOnce(_, getCurrentHub) {
        if ((0, $98cbc8e6b5922577$export$34db76d03eb96b7e)(getCurrentHub)) {
            (0, $8a1bc3da87759f5f$export$16a28057038b10ef) && (0, $iyYYs.logger).log("Mongo Integration is skipped because of instrumenter configuration.");
            return;
        }
        const pkg = this.loadDependency();
        if (!pkg) {
            const moduleName = this._useMongoose ? "mongoose" : "mongodb";
            (0, $8a1bc3da87759f5f$export$16a28057038b10ef) && (0, $iyYYs.logger).error(`Mongo Integration was unable to require \`${moduleName}\` package.`);
            return;
        }
        this._instrumentOperations(pkg.Collection, this._operations, getCurrentHub);
    }
    /**
   * Patches original collection methods
   */ // eslint-disable-next-line deprecation/deprecation
    _instrumentOperations(collection, operations, getCurrentHub) {
        operations.forEach((operation)=>this._patchOperation(collection, operation, getCurrentHub));
    }
    /**
   * Patches original collection to utilize our tracing functionality
   */ // eslint-disable-next-line deprecation/deprecation
    _patchOperation(collection, operation, getCurrentHub) {
        if (!(operation in collection.prototype)) return;
        const getSpanContext = this._getSpanContextFromOperationArguments.bind(this);
        (0, $9fGKl.fill)(collection.prototype, operation, function(orig) {
            return function(...args) {
                const lastArg = args[args.length - 1];
                // eslint-disable-next-line deprecation/deprecation
                const hub = getCurrentHub();
                // eslint-disable-next-line deprecation/deprecation
                const scope = hub.getScope();
                // eslint-disable-next-line deprecation/deprecation
                const client = hub.getClient();
                // eslint-disable-next-line deprecation/deprecation
                const parentSpan = scope.getSpan();
                const sendDefaultPii = (0, $89603552ac3124a9$export$3cc482e6b02f32f7)([
                    client,
                    "optionalAccess",
                    (_2)=>_2.getOptions,
                    "call",
                    (_3)=>_3(),
                    "access",
                    (_4)=>_4.sendDefaultPii
                ]);
                // Check if the operation was passed a callback. (mapReduce requires a different check, as
                // its (non-callback) arguments can also be functions.)
                if (typeof lastArg !== "function" || operation === "mapReduce" && args.length === 2) {
                    // eslint-disable-next-line deprecation/deprecation
                    const span = (0, $89603552ac3124a9$export$3cc482e6b02f32f7)([
                        parentSpan,
                        "optionalAccess",
                        (_5)=>_5.startChild,
                        "call",
                        (_6)=>_6(getSpanContext(this, operation, args, sendDefaultPii))
                    ]);
                    const maybePromiseOrCursor = orig.call(this, ...args);
                    if ((0, $dR6t7.isThenable)(maybePromiseOrCursor)) return maybePromiseOrCursor.then((res)=>{
                        (0, $89603552ac3124a9$export$3cc482e6b02f32f7)([
                            span,
                            "optionalAccess",
                            (_7)=>_7.end,
                            "call",
                            (_8)=>_8()
                        ]);
                        return res;
                    });
                    else if ($e2c439f9353b14e5$var$isCursor(maybePromiseOrCursor)) {
                        const cursor = maybePromiseOrCursor;
                        try {
                            cursor.once("close", ()=>{
                                (0, $89603552ac3124a9$export$3cc482e6b02f32f7)([
                                    span,
                                    "optionalAccess",
                                    (_9)=>_9.end,
                                    "call",
                                    (_10)=>_10()
                                ]);
                            });
                        } catch (e) {
                            // If the cursor is already closed, `once` will throw an error. In that case, we can
                            // finish the span immediately.
                            (0, $89603552ac3124a9$export$3cc482e6b02f32f7)([
                                span,
                                "optionalAccess",
                                (_11)=>_11.end,
                                "call",
                                (_12)=>_12()
                            ]);
                        }
                        return cursor;
                    } else {
                        (0, $89603552ac3124a9$export$3cc482e6b02f32f7)([
                            span,
                            "optionalAccess",
                            (_13)=>_13.end,
                            "call",
                            (_14)=>_14()
                        ]);
                        return maybePromiseOrCursor;
                    }
                }
                // eslint-disable-next-line deprecation/deprecation
                const span = (0, $89603552ac3124a9$export$3cc482e6b02f32f7)([
                    parentSpan,
                    "optionalAccess",
                    (_15)=>_15.startChild,
                    "call",
                    (_16)=>_16(getSpanContext(this, operation, args.slice(0, -1)))
                ]);
                return orig.call(this, ...args.slice(0, -1), function(err, result) {
                    (0, $89603552ac3124a9$export$3cc482e6b02f32f7)([
                        span,
                        "optionalAccess",
                        (_17)=>_17.end,
                        "call",
                        (_18)=>_18()
                    ]);
                    lastArg(err, result);
                });
            };
        });
    }
    /**
   * Form a SpanContext based on the user input to a given operation.
   */ _getSpanContextFromOperationArguments(collection, operation, args, sendDefaultPii = false) {
        const data = {
            "db.system": "mongodb",
            "db.name": collection.dbName,
            "db.operation": operation,
            "db.mongodb.collection": collection.collectionName
        };
        const spanContext = {
            op: "db",
            // TODO v8: Use `${collection.collectionName}.${operation}`
            origin: "auto.db.mongo",
            description: operation,
            data: data
        };
        // If the operation takes no arguments besides `options` and `callback`, or if argument
        // collection is disabled for this operation, just return early.
        const signature = $e2c439f9353b14e5$var$OPERATION_SIGNATURES[operation];
        const shouldDescribe = Array.isArray(this._describeOperations) ? this._describeOperations.includes(operation) : this._describeOperations;
        if (!signature || !shouldDescribe || !sendDefaultPii) return spanContext;
        try {
            // Special case for `mapReduce`, as the only one accepting functions as arguments.
            if (operation === "mapReduce") {
                const [map, reduce] = args;
                data[signature[0]] = typeof map === "string" ? map : map.name || "<anonymous>";
                data[signature[1]] = typeof reduce === "string" ? reduce : reduce.name || "<anonymous>";
            } else for(let i = 0; i < signature.length; i++)data[`db.mongodb.${signature[i]}`] = JSON.stringify(args[i]);
        } catch (_oO) {
        // no-empty
        }
        return spanContext;
    }
}
$e2c439f9353b14e5$export$968aa4360b02a334.__initStatic();


var $9fGKl = parcelRequire("9fGKl");
var $4C0Qe = parcelRequire("4C0Qe");
var $iyYYs = parcelRequire("iyYYs");


/** Tracing integration for node-mysql package */ class $1049e5fe08eb466b$export$a2cc26ff91a3f8ad {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "Mysql";
    }
    /**
   * @inheritDoc
   */ constructor(){
        this.name = $1049e5fe08eb466b$export$a2cc26ff91a3f8ad.id;
    }
    /** @inheritdoc */ loadDependency() {
        return this._module = this._module || (0, $4C0Qe.loadModule)("mysql/lib/Connection.js");
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    setupOnce(_, getCurrentHub) {
        if ((0, $98cbc8e6b5922577$export$34db76d03eb96b7e)(getCurrentHub)) {
            (0, $8a1bc3da87759f5f$export$16a28057038b10ef) && (0, $iyYYs.logger).log("Mysql Integration is skipped because of instrumenter configuration.");
            return;
        }
        const pkg = this.loadDependency();
        if (!pkg) {
            (0, $8a1bc3da87759f5f$export$16a28057038b10ef) && (0, $iyYYs.logger).error("Mysql Integration was unable to require `mysql` package.");
            return;
        }
        let mySqlConfig = undefined;
        try {
            pkg.prototype.connect = new Proxy(pkg.prototype.connect, {
                apply (wrappingTarget, thisArg, args) {
                    if (!mySqlConfig) mySqlConfig = thisArg.config;
                    return wrappingTarget.apply(thisArg, args);
                }
            });
        } catch (e) {
            (0, $8a1bc3da87759f5f$export$16a28057038b10ef) && (0, $iyYYs.logger).error("Mysql Integration was unable to instrument `mysql` config.");
        }
        function spanDataFromConfig() {
            if (!mySqlConfig) return {};
            return {
                "server.address": mySqlConfig.host,
                "server.port": mySqlConfig.port,
                "db.user": mySqlConfig.user
            };
        }
        function finishSpan(span) {
            if (!span) return;
            const data = spanDataFromConfig();
            Object.keys(data).forEach((key)=>{
                span.setAttribute(key, data[key]);
            });
            span.end();
        }
        // The original function will have one of these signatures:
        //    function (callback) => void
        //    function (options, callback) => void
        //    function (options, values, callback) => void
        (0, $9fGKl.fill)(pkg, "createQuery", function(orig) {
            return function(options, values, callback) {
                // eslint-disable-next-line deprecation/deprecation
                const scope = getCurrentHub().getScope();
                // eslint-disable-next-line deprecation/deprecation
                const parentSpan = scope.getSpan();
                // eslint-disable-next-line deprecation/deprecation
                const span = (0, $89603552ac3124a9$export$3cc482e6b02f32f7)([
                    parentSpan,
                    "optionalAccess",
                    (_2)=>_2.startChild,
                    "call",
                    (_3)=>_3({
                            description: typeof options === "string" ? options : options.sql,
                            op: "db",
                            origin: "auto.db.mysql",
                            data: {
                                "db.system": "mysql"
                            }
                        })
                ]);
                if (typeof callback === "function") return orig.call(this, options, values, function(err, result, fields) {
                    finishSpan(span);
                    callback(err, result, fields);
                });
                if (typeof values === "function") return orig.call(this, options, function(err, result, fields) {
                    finishSpan(span);
                    values(err, result, fields);
                });
                // streaming, no callback!
                const query = orig.call(this, options, values);
                query.on("end", ()=>{
                    finishSpan(span);
                });
                return query;
            };
        });
    }
}
$1049e5fe08eb466b$export$a2cc26ff91a3f8ad.__initStatic();


var $9fGKl = parcelRequire("9fGKl");
var $dR6t7 = parcelRequire("dR6t7");
var $4C0Qe = parcelRequire("4C0Qe");
var $iyYYs = parcelRequire("iyYYs");


/** Tracing integration for node-postgres package */ class $a8b4c728a8258471$export$806ddb599177abc4 {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "Postgres";
    }
    /**
   * @inheritDoc
   */ constructor(options = {}){
        this.name = $a8b4c728a8258471$export$806ddb599177abc4.id;
        this._usePgNative = !!options.usePgNative;
        this._module = options.module;
    }
    /** @inheritdoc */ loadDependency() {
        return this._module = this._module || (0, $4C0Qe.loadModule)("pg");
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    setupOnce(_, getCurrentHub) {
        if ((0, $98cbc8e6b5922577$export$34db76d03eb96b7e)(getCurrentHub)) {
            (0, $8a1bc3da87759f5f$export$16a28057038b10ef) && (0, $iyYYs.logger).log("Postgres Integration is skipped because of instrumenter configuration.");
            return;
        }
        const pkg = this.loadDependency();
        if (!pkg) {
            (0, $8a1bc3da87759f5f$export$16a28057038b10ef) && (0, $iyYYs.logger).error("Postgres Integration was unable to require `pg` package.");
            return;
        }
        const Client = this._usePgNative ? (0, $89603552ac3124a9$export$3cc482e6b02f32f7)([
            pkg,
            "access",
            (_2)=>_2.native,
            "optionalAccess",
            (_3)=>_3.Client
        ]) : pkg.Client;
        if (!Client) {
            (0, $8a1bc3da87759f5f$export$16a28057038b10ef) && (0, $iyYYs.logger).error("Postgres Integration was unable to access 'pg-native' bindings.");
            return;
        }
        /**
     * function (query, callback) => void
     * function (query, params, callback) => void
     * function (query) => Promise
     * function (query, params) => Promise
     * function (pg.Cursor) => pg.Cursor
     */ (0, $9fGKl.fill)(Client.prototype, "query", function(orig) {
            return function(config, values, callback) {
                // eslint-disable-next-line deprecation/deprecation
                const scope = getCurrentHub().getScope();
                // eslint-disable-next-line deprecation/deprecation
                const parentSpan = scope.getSpan();
                const data = {
                    "db.system": "postgresql"
                };
                try {
                    if (this.database) data["db.name"] = this.database;
                    if (this.host) data["server.address"] = this.host;
                    if (this.port) data["server.port"] = this.port;
                    if (this.user) data["db.user"] = this.user;
                } catch (e) {
                // ignore
                }
                // eslint-disable-next-line deprecation/deprecation
                const span = (0, $89603552ac3124a9$export$3cc482e6b02f32f7)([
                    parentSpan,
                    "optionalAccess",
                    (_4)=>_4.startChild,
                    "call",
                    (_5)=>_5({
                            description: typeof config === "string" ? config : config.text,
                            op: "db",
                            origin: "auto.db.postgres",
                            data: data
                        })
                ]);
                if (typeof callback === "function") return orig.call(this, config, values, function(err, result) {
                    (0, $89603552ac3124a9$export$3cc482e6b02f32f7)([
                        span,
                        "optionalAccess",
                        (_6)=>_6.end,
                        "call",
                        (_7)=>_7()
                    ]);
                    callback(err, result);
                });
                if (typeof values === "function") return orig.call(this, config, function(err, result) {
                    (0, $89603552ac3124a9$export$3cc482e6b02f32f7)([
                        span,
                        "optionalAccess",
                        (_8)=>_8.end,
                        "call",
                        (_9)=>_9()
                    ]);
                    values(err, result);
                });
                const rv = typeof values !== "undefined" ? orig.call(this, config, values) : orig.call(this, config);
                if ((0, $dR6t7.isThenable)(rv)) return rv.then((res)=>{
                    (0, $89603552ac3124a9$export$3cc482e6b02f32f7)([
                        span,
                        "optionalAccess",
                        (_10)=>_10.end,
                        "call",
                        (_11)=>_11()
                    ]);
                    return res;
                });
                (0, $89603552ac3124a9$export$3cc482e6b02f32f7)([
                    span,
                    "optionalAccess",
                    (_12)=>_12.end,
                    "call",
                    (_13)=>_13()
                ]);
                return rv;
            };
        });
    }
}
$a8b4c728a8258471$export$806ddb599177abc4.__initStatic();


var $l4UCE = parcelRequire("l4UCE");
var $ePKuD = parcelRequire("ePKuD");
var $aJUSo = parcelRequire("aJUSo");

var $9fGKl = parcelRequire("9fGKl");
var $iyYYs = parcelRequire("iyYYs");


function $d0880cf7ce3926aa$var$isValidPrismaClient(possibleClient) {
    return !!possibleClient && !!possibleClient["$use"];
}
/** Tracing integration for @prisma/client package */ class $d0880cf7ce3926aa$export$e300e6f4779d55c2 {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "Prisma";
    }
    /**
   * @inheritDoc
   */ /**
   * @inheritDoc
   */ constructor(options = {}){
        this.name = $d0880cf7ce3926aa$export$e300e6f4779d55c2.id;
        // We instrument the PrismaClient inside the constructor and not inside `setupOnce` because in some cases of server-side
        // bundling (Next.js) multiple Prisma clients can be instantiated, even though users don't intend to. When instrumenting
        // in setupOnce we can only ever instrument one client.
        // https://github.com/getsentry/sentry-javascript/issues/7216#issuecomment-1602375012
        // In the future we might explore providing a dedicated PrismaClient middleware instead of this hack.
        if ($d0880cf7ce3926aa$var$isValidPrismaClient(options.client) && !options.client._sentryInstrumented) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $9fGKl.addNonEnumerableProperty)(options.client, "_sentryInstrumented", true);
            const clientData = {};
            try {
                const engineConfig = options.client._engineConfig;
                if (engineConfig) {
                    const { activeProvider: activeProvider, clientVersion: clientVersion } = engineConfig;
                    if (activeProvider) clientData["db.system"] = activeProvider;
                    if (clientVersion) clientData["db.prisma.version"] = clientVersion;
                }
            } catch (e) {
            // ignore
            }
            options.client.$use((params, next)=>{
                // eslint-disable-next-line deprecation/deprecation
                if ((0, $98cbc8e6b5922577$export$34db76d03eb96b7e)((0, $l4UCE.getCurrentHub))) return next(params);
                const action = params.action;
                const model = params.model;
                return (0, $aJUSo.startSpan)({
                    name: model ? `${model} ${action}` : action,
                    onlyIfParent: true,
                    op: "db.prisma",
                    attributes: {
                        [(0, $ePKuD.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: "auto.db.prisma"
                    },
                    data: {
                        ...clientData,
                        "db.operation": action
                    }
                }, ()=>next(params));
            });
        } else (0, $8a1bc3da87759f5f$export$16a28057038b10ef) && (0, $iyYYs.logger).warn("Unsupported Prisma client provided to PrismaIntegration. Provided client:", options.client);
    }
    /**
   * @inheritDoc
   */ setupOnce() {
    // Noop - here for backwards compatibility
    }
}
$d0880cf7ce3926aa$export$e300e6f4779d55c2.__initStatic();


var $lBUtp = parcelRequire("lBUtp");
var $h795Y = parcelRequire("h795Y");
var $fBYWi = parcelRequire("fBYWi");
var $dGzPN = parcelRequire("dGzPN");
var $4R5py = parcelRequire("4R5py");
// BrowserTracing is already exported as part of `Integrations` below (and for the moment will remain so for
// backwards compatibility), but that interferes with treeshaking, so we also export it separately
// here.
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 * `BrowserTracing` can be imported from `@sentry/browser` or your framework SDK
 *
 * import { BrowserTracing } from '@sentry/browser';
 * new BrowserTracing()
 */ // eslint-disable-next-line deprecation/deprecation
const $3ecb36adbd376d3d$export$46d3bbd0375f5fa4 = (0, $af9d9619b7a5c686$export$46d3bbd0375f5fa4);
// BrowserTracing is already exported as part of `Integrations` below (and for the moment will remain so for
// backwards compatibility), but that interferes with treeshaking, so we also export it separately
// here.
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 * `BrowserTracing` can be imported from `@sentry/browser` or your framework SDK
 *
 * import { BrowserTracing } from '@sentry/browser';
 * new BrowserTracing()
 */ // eslint-disable-next-line deprecation/deprecation
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 */ const $3ecb36adbd376d3d$export$5a20b45239a3c0a6 = (0, $czKc9.addExtensionMethods);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `getActiveTransaction` can be imported from `@sentry/node`, `@sentry/browser`, or your framework SDK
 */ // eslint-disable-next-line deprecation/deprecation
const $3ecb36adbd376d3d$export$a7feb32fdd923295 = (0, $4kgMm.getActiveTransaction);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `extractTraceparentData` can be imported from `@sentry/node`, `@sentry/browser`, or your framework SDK
 */ // eslint-disable-next-line deprecation/deprecation
const $3ecb36adbd376d3d$export$8e9a29865c0a1226 = (0, $4kgMm.extractTraceparentData);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `spanStatusfromHttpCode` can be imported from `@sentry/node`, `@sentry/browser`, or your framework SDK
 */ // eslint-disable-next-line deprecation/deprecation
const $3ecb36adbd376d3d$export$ac65c70d78fcdb55 = (0, $h795Y.spanStatusfromHttpCode);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `SpanStatusType` can be imported from `@sentry/node`, `@sentry/browser`, or your framework SDK
 */ /**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `Transaction` can be imported from `@sentry/node`, `@sentry/browser`, or your framework SDK
 */ const $3ecb36adbd376d3d$export$febc5573c75cefb0 = (0, $4R5py.Transaction);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `Transaction` can be imported from `@sentry/node`, `@sentry/browser`, or your framework SDK
 */ /**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `Span` can be imported from `@sentry/node`, `@sentry/browser`, or your framework SDK
 */ const $3ecb36adbd376d3d$export$5f1714a13ed34c01 = (0, $lBUtp.Span);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `Span` can be imported from `@sentry/node`, `@sentry/browser`, or your framework SDK
 */ /**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 */ const $3ecb36adbd376d3d$export$bbd2089f30bd3708 = (0, $af9d9619b7a5c686$export$bbd2089f30bd3708);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `defaultRequestInstrumentationOptions` can be imported from `@sentry/browser`, or your framework SDK
 */ const $3ecb36adbd376d3d$export$cc17fb3c0bc95cd7 = (0, $fb36002f93a424ca$export$cc17fb3c0bc95cd7);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `hasTracingEnabled` can be imported from `@sentry/utils`
 */ const $3ecb36adbd376d3d$export$5008da00b1b6dee6 = (0, $bRL0a.hasTracingEnabled);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `stripUrlQueryAndFragment` can be imported from `@sentry/utils`
 */ const $3ecb36adbd376d3d$export$ce084c78234bd35 = (0, $73075039f785ecac$export$ce084c78234bd35);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `TRACEPARENT_REGEXP` can be imported from `@sentry/utils`
 */ const $3ecb36adbd376d3d$export$394a210812ba3012 = (0, $dGzPN.TRACEPARENT_REGEXP);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 */ const $3ecb36adbd376d3d$export$b279e6bd7040371f = (0, $1COtc.IdleTransaction);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 */ /**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 */ const $3ecb36adbd376d3d$export$864489cb3478db3e = (0, $fb36002f93a424ca$export$864489cb3478db3e);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 */ const $3ecb36adbd376d3d$export$479dbd817e392a4f = (0, $fBYWi.startIdleTransaction);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 */ // eslint-disable-next-line deprecation/deprecation
const $3ecb36adbd376d3d$export$beb8e6a823e89c5d = (0, $h795Y.SpanStatus);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 */ // eslint-disable-next-line deprecation/deprecation
const $3ecb36adbd376d3d$export$99d02219d259eb94 = {
    /**
   * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
   * `BrowserTracing` can be imported from `@sentry/browser` or your framework SDK
   *
   * import { BrowserTracing } from '@sentry/browser';
   * new BrowserTracing()
   */ // eslint-disable-next-line deprecation/deprecation
    BrowserTracing: $3ecb36adbd376d3d$export$46d3bbd0375f5fa4,
    /**
   * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
   * `Apollo` can be imported from `@sentry/node`
   *
   * import { Integrations } from '@sentry/node';
   * new Integrations.Apollo({ ... })
   */ // eslint-disable-next-line deprecation/deprecation
    Apollo: (0, $6e5dd3b1dd31093e$export$3db3e396472fda8d),
    /**
   * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
   * `Express` can be imported from `@sentry/node`
   *
   * import { Integrations } from '@sentry/node';
   * new Integrations.Express({ ... })
   */ // eslint-disable-next-line deprecation/deprecation
    Express: (0, $40e74f1beac4ae1e$export$6dafdd8fec05099d),
    /**
   * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
   * `GraphQL` can be imported from `@sentry/node`
   *
   * import { Integrations } from '@sentry/node';
   * new Integrations.GraphQL({ ... })
   */ // eslint-disable-next-line deprecation/deprecation
    GraphQL: (0, $90a1d5a82a97b746$export$b735d011553f1049),
    /**
   * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
   * `Mongo` can be imported from `@sentry/node`
   *
   * import { Integrations } from '@sentry/node';
   * new Integrations.Mongo({ ... })
   */ // eslint-disable-next-line deprecation/deprecation
    Mongo: (0, $e2c439f9353b14e5$export$968aa4360b02a334),
    /**
   * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
   * `Mysql` can be imported from `@sentry/node`
   *
   * import { Integrations } from '@sentry/node';
   * new Integrations.Mysql({ ... })
   */ // eslint-disable-next-line deprecation/deprecation
    Mysql: (0, $1049e5fe08eb466b$export$a2cc26ff91a3f8ad),
    /**
   * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
   * `Postgres` can be imported from `@sentry/node`
   *
   * import { Integrations } from '@sentry/node';
   * new Integrations.Postgres({ ... })
   */ // eslint-disable-next-line deprecation/deprecation
    Postgres: (0, $a8b4c728a8258471$export$806ddb599177abc4),
    /**
   * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
   * `Prisma` can be imported from `@sentry/node`
   *
   * import { Integrations } from '@sentry/node';
   * new Integrations.Prisma({ ... })
   */ // eslint-disable-next-line deprecation/deprecation
    Prisma: (0, $d0880cf7ce3926aa$export$e300e6f4779d55c2)
};
// Treeshakable guard to remove all code related to tracing
// Guard for tree
if (typeof __SENTRY_TRACING__ === "undefined" || __SENTRY_TRACING__) // We are patching the global object with our hub extension methods
(0, $czKc9.addExtensionMethods)();


function $4c538bf77dcd4adb$var$addClass(el, ...args) {
    for (const class_ of args)el.classList.add(class_);
}
function $4c538bf77dcd4adb$var$findAll(sel) {
    return [].slice.call(document.querySelectorAll(sel), 0);
}
function $4c538bf77dcd4adb$var$mountOne(selector, fn) {
    const node = document.querySelector(selector);
    if (node) fn(node);
}
function $4c538bf77dcd4adb$var$mountAll(selector, fn) {
    $4c538bf77dcd4adb$var$findAll(selector).forEach(fn);
}
function $4c538bf77dcd4adb$var$preventDefault(event) {
    event.preventDefault();
}
function $4c538bf77dcd4adb$var$ready(fn) {
    window.addEventListener("DOMContentLoaded", fn);
}
function $4c538bf77dcd4adb$var$removeClass(el, ...args) {
    for (const class_ of args)el.classList.remove(class_);
}
var $4c538bf77dcd4adb$export$2e2bcd8739ae039 = {
    addClass: $4c538bf77dcd4adb$var$addClass,
    mountAll: $4c538bf77dcd4adb$var$mountAll,
    mountOne: $4c538bf77dcd4adb$var$mountOne,
    preventDefault: $4c538bf77dcd4adb$var$preventDefault,
    ready: $4c538bf77dcd4adb$var$ready,
    removeClass: $4c538bf77dcd4adb$var$removeClass
};


// INFO: we suppose we're always having a single map on a page
// TODO: split these into better scoped components
async function $fffadef9b49322ab$var$fetchWithTimeout(resource, options) {
    // see https://dmitripavlutin.com/timeout-fetch-request/
    const { timeout: timeout = 8000 } = options;
    const controller = new AbortController();
    const id = setTimeout(()=>controller.abort(), timeout);
    const response = await fetch(resource, {
        ...options,
        signal: controller.signal
    });
    clearTimeout(id);
    return response;
}
function $fffadef9b49322ab$var$getCurrentPosition(options = {
    timeout: 20000,
    maximumAge: 300000
}) {
    return new Promise((resolve, reject)=>{
        if ("geolocation" in navigator) navigator.geolocation.getCurrentPosition(resolve, reject, options);
        else reject("La g\xe9olocalisation n'est pas disponible sur votre navigateur.");
    });
}
async function $fffadef9b49322ab$var$hasPermission(name) {
    // Exemple name: "geolocation"
    if (!navigator?.permissions?.query) return false;
    // Will return ['granted', 'prompt', 'denied']
    const { state: state } = await navigator.permissions.query({
        name: name
    });
    return state;
}
async function $fffadef9b49322ab$var$getUserLocation(options) {
    const { coords: { latitude: lat, longitude: lon }, timestamp: timestamp } = await $fffadef9b49322ab$var$getCurrentPosition(options);
    let label;
    try {
        // Reverse geolocalization is purely cosmectic, so let's not block on slow requests
        const { features: features } = await $fffadef9b49322ab$var$reverseGeocode({
            lat: lat,
            lon: lon
        }, {
            type: "street",
            timeout: 800
        });
        label = `(${features[0].properties.label})`;
    } catch (e) {
        // if reverse geocoding request timed out, we still obtained coords so it's ok;
        // just log other error types.
        label = "\u2713";
    }
    return $fffadef9b49322ab$var$saveUserLocation({
        lat: lat,
        lon: lon,
        label: label,
        timestamp: timestamp
    });
}
async function $fffadef9b49322ab$var$loadUserLocation(options = {}) {
    const { ttl: ttl, retrieve: retrieve } = {
        ttl: 300000,
        retrieve: true,
        ...options
    };
    let loc = null;
    try {
        loc = JSON.parse(sessionStorage["a4a-loc"] || "null");
    } catch (_) {}
    try {
        if (!loc || loc.timestamp && new Date().getTime() - loc.timestamp > ttl) {
            if (!!retrieve) return await $fffadef9b49322ab$var$getUserLocation();
            else return loc;
        } else return loc;
    } catch (e) {
        console.error(e);
    }
}
async function $fffadef9b49322ab$var$reverseGeocode({ lat: lat, lon: lon }, options = {}) {
    const { timeout: timeout = 8000 } = options;
    let url = `https://api-adresse.data.gouv.fr/reverse/?lon=${lon}&lat=${lat}`;
    if (options.type) url += `&type=${options.type}`;
    try {
        const res = await $fffadef9b49322ab$var$fetchWithTimeout(url, {
            timeout: timeout
        });
        return await res.json();
    } catch (e) {
        console.error("reverse geocoding error", e);
    }
}
function $fffadef9b49322ab$var$saveUserLocation(loc) {
    sessionStorage["a4a-loc"] = JSON.stringify(loc);
    return loc;
}
function $fffadef9b49322ab$var$getMunicipalityApi(q) {
    return `https://geo.api.gouv.fr/communes?nom=${encodeURIComponent(q)}&boost=population&fields=centre,codesPostaux,codeDepartement&limit=10`;
}
function $fffadef9b49322ab$var$getDepartmentApi(q) {
    return `https://geo.api.gouv.fr/departements?nom=${encodeURIComponent(q)}&limit=10`;
}
function $fffadef9b49322ab$var$getDepartmentNumberApi(q) {
    return `https://geo.api.gouv.fr/departements?code=${encodeURIComponent(q)}&limit=10`;
}
function $fffadef9b49322ab$var$getAddressApi(q, loc) {
    let url = `https://api-adresse.data.gouv.fr/search/?q=${encodeURIComponent(q)}&limit=10`;
    const { lat: lat, lon: lon } = loc || {};
    if (lat && lon) url += `&lat=${lat}&lon=${lon}`;
    return url;
}
function $fffadef9b49322ab$var$buildResultFromAddressApi({ properties: { type: type, label: label, context: context, citycode: citycode, postcode: postcode, search_type: search_type, city: city, street: street, municipality: municipality, id: id }, geometry: { coordinates: coordinates } }) {
    context = "" // Empty the context, which initially contains department, region
    ;
    return {
        id: "loc",
        text: label,
        context: context,
        code: citycode,
        ban_id: id,
        lat: coordinates[1],
        lon: coordinates[0],
        search_type: type,
        postcode: postcode,
        street_name: street,
        municipality: municipality
    };
}
function $fffadef9b49322ab$var$buildResultFromMunicipalityApi({ code: code, nom: nom, centre: centre, codesPostaux: codesPostaux, codeDepartement: codeDepartment }) {
    return {
        id: "loc",
        text: `${nom} (${codeDepartment})`,
        context: "",
        code: code,
        lat: centre["coordinates"][1],
        lon: centre["coordinates"][0],
        search_type: "municipality",
        postcode: codesPostaux,
        street_name: "",
        municipality: nom
    };
}
function $fffadef9b49322ab$var$buildResultFromDepartmentApi({ code: code, nom: nom }) {
    return {
        id: "loc",
        text: `${nom} (${code})`,
        context: "",
        code: code,
        search_type: "department"
    };
}
async function $fffadef9b49322ab$var$searchMunicipality(q) {
    const response = await fetch($fffadef9b49322ab$var$getMunicipalityApi(q));
    const json = await response.json();
    const results = json.map($fffadef9b49322ab$var$buildResultFromMunicipalityApi);
    return {
        q: q,
        results: results
    };
}
async function $fffadef9b49322ab$var$searchAddress(q, loc) {
    const response = await fetch($fffadef9b49322ab$var$getAddressApi(q, loc));
    const { features: features } = await response.json();
    let results = features.filter(({ properties: { score: score } })=>{
        return score > 0.4;
    });
    results = results.map($fffadef9b49322ab$var$buildResultFromAddressApi);
    return {
        q: q,
        results: results
    };
}
async function $fffadef9b49322ab$var$searchDepartment(q) {
    const response = await fetch($fffadef9b49322ab$var$getDepartmentApi(q));
    const json = await response.json();
    const results = json.map($fffadef9b49322ab$var$buildResultFromDepartmentApi);
    return {
        q: q,
        results: results
    };
}
async function $fffadef9b49322ab$var$searchDepartmentNumber(q) {
    const response = await fetch($fffadef9b49322ab$var$getDepartmentNumberApi(q));
    const json = await response.json();
    const results = json.map($fffadef9b49322ab$var$buildResultFromDepartmentApi);
    return {
        q: q,
        results: results
    };
}
async function $fffadef9b49322ab$var$searchLocation(q, loc, kind = "") {
    if (q.trim().length < 2) return {
        q: q,
        results: []
    };
    if (kind === "municipality") return await $fffadef9b49322ab$var$searchMunicipality(q);
    if (kind === "department") {
        let departmentResult = await $fffadef9b49322ab$var$searchDepartment(q);
        let remainingSlots = 10 - departmentResult.results.length;
        if (remainingSlots > 0) {
            const municipalityResult = await $fffadef9b49322ab$var$searchMunicipality(q);
            departmentResult.results = departmentResult.results.concat(municipalityResult.results.slice(0, remainingSlots));
        }
        return departmentResult;
    }
    if (kind === "departmentNumber") return await $fffadef9b49322ab$var$searchDepartmentNumber(q);
    return $fffadef9b49322ab$var$searchAddress(q, loc);
}
async function $fffadef9b49322ab$var$getCoordinate(q) {
    let response = await $fffadef9b49322ab$var$searchLocation(q);
    return response;
}
var $fffadef9b49322ab$export$2e2bcd8739ae039 = {
    hasPermission: $fffadef9b49322ab$var$hasPermission,
    loadUserLocation: $fffadef9b49322ab$var$loadUserLocation,
    reverseGeocode: $fffadef9b49322ab$var$reverseGeocode,
    searchLocation: $fffadef9b49322ab$var$searchLocation,
    getCoordinate: $fffadef9b49322ab$var$getCoordinate
};


function $d38fb949d5c835b5$var$generateHTMLForResult(result) {
    let icon = "building";
    let activity_name = "";
    let link = "";
    if (result.properties.activite__vector_icon) {
        // Data from template context
        icon = result.properties.activite__vector_icon;
        activity_name = result.properties.activite__nom;
        link = result.properties.absolute_url;
    } else if (result.properties.activite) {
        // Data from API
        icon = result.properties.activite.vector_icon;
        activity_name = result.properties.activite.nom;
        link = result.properties.web_url;
    }
    return `
    <div class="list-group-item d-flex justify-content-between align-items-center fr-pt-2v fr-pr-2v fr-pb-1v fr-pl-0 map-results">
    <div>
        <div>
          <h3 class="h6 font-weight-bold w-100 fr-mb-0 fr-pb-0">
            <img alt="" class="act-icon act-icon-20 fr-mb-1v" src="/static/img/mapicons.svg#${icon}">
            
            <a class="fr-link" href="${link}">
               ${result.properties.nom}
                <span class="fr-sr-only">
                    ${activity_name}
                    ${result.properties.adresse}
                </span>
            </a>
          </h3>
        </div>
        <div aria-hidden="true">
            <small class="font-weight-bold">${activity_name}</small>
            <address class="d-inline mb-0">
                <small>${result.properties.adresse}</small>
            </address>
        </div>
    </div>
    <button class="btn btn-sm btn-outline-primary d-none d-sm-none d-md-block a4a-icon-btn a4a-geo-link fr-ml-2w"
            title="${gettext("Localiser sur la carte")}"
            data-erp-identifier="${result.properties.uuid}">
        ${gettext("Localiser")}
        <br>
        <i aria-hidden="true" class="icon icon-target"></i>
    </button>
</div>`;
}
var $d38fb949d5c835b5$export$2e2bcd8739ae039 = {
    generateHTMLForResult: $d38fb949d5c835b5$var$generateHTMLForResult
};



function $57c3cca372f9dda5$export$2e2bcd8739ae039(root) {
    root.outerHTML = `
    &nbsp;
    <small>(` + gettext("requis") + `)</small>`;
}


const $819c6a472fb38c36$var$INDENTS_LEVEL = {
    first: 6,
    second: 10
};
const $819c6a472fb38c36$var$rules = [
    // Transport
    {
        source: "transport_station_presence",
        values: [
            "True"
        ],
        targets: [
            "transport_information"
        ]
    },
    // Stationnement
    {
        source: "stationnement_presence",
        values: [
            "True"
        ],
        targets: [
            "stationnement_pmr"
        ],
        indent: $819c6a472fb38c36$var$INDENTS_LEVEL.first
    },
    {
        source: "stationnement_ext_presence",
        values: [
            "True"
        ],
        targets: [
            "stationnement_ext_pmr"
        ],
        indent: $819c6a472fb38c36$var$INDENTS_LEVEL.first
    },
    // Presence d'un extérieur et cheminement
    {
        source: "cheminement_ext_presence",
        values: [
            "True"
        ],
        targets: [
            "cheminement_ext_terrain_stable",
            "cheminement_ext_plain_pied",
            "cheminement_ext_nombre_marches",
            "cheminement_ext_reperage_marches",
            "cheminement_ext_main_courante",
            "cheminement_ext_rampe",
            "cheminement_ext_ascenseur",
            "cheminement_ext_pente_presence",
            "cheminement_ext_devers",
            "cheminement_ext_bande_guidage",
            "cheminement_ext_retrecissement"
        ],
        indent: $819c6a472fb38c36$var$INDENTS_LEVEL.first
    },
    {
        source: "cheminement_ext_plain_pied",
        values: [
            "False"
        ],
        targets: [
            "cheminement_ext_nombre_marches",
            "cheminement_ext_sens_marches",
            "cheminement_ext_reperage_marches",
            "cheminement_ext_main_courante",
            "cheminement_ext_rampe",
            "cheminement_ext_ascenseur"
        ],
        indent: $819c6a472fb38c36$var$INDENTS_LEVEL.second
    },
    {
        source: "cheminement_ext_pente_presence",
        values: [
            "True"
        ],
        targets: [
            "cheminement_ext_pente_degre_difficulte",
            "cheminement_ext_pente_longueur"
        ],
        indent: $819c6a472fb38c36$var$INDENTS_LEVEL.second
    },
    // Entrée
    {
        source: "entree_porte_presence",
        values: [
            "True"
        ],
        targets: [
            "entree_porte_manoeuvre",
            "entree_porte_type",
            "entree_vitree"
        ],
        indent: $819c6a472fb38c36$var$INDENTS_LEVEL.first
    },
    {
        source: "entree_vitree",
        values: [
            "True"
        ],
        targets: [
            "entree_vitree_vitrophanie"
        ],
        indent: $819c6a472fb38c36$var$INDENTS_LEVEL.second
    },
    {
        source: "entree_dispositif_appel",
        values: [
            "True"
        ],
        targets: [
            "entree_dispositif_appel_type"
        ],
        indent: $819c6a472fb38c36$var$INDENTS_LEVEL.first
    },
    {
        source: "entree_plain_pied",
        values: [
            "False"
        ],
        targets: [
            "entree_marches",
            "entree_marches_sens",
            "entree_marches_reperage",
            "entree_marches_main_courante",
            "entree_marches_rampe",
            "entree_ascenseur"
        ],
        indent: $819c6a472fb38c36$var$INDENTS_LEVEL.first
    },
    {
        source: "entree_pmr",
        values: [
            "True"
        ],
        targets: [
            "entree_pmr_informations"
        ],
        indent: $819c6a472fb38c36$var$INDENTS_LEVEL.first
    },
    // Accueil
    {
        source: "accueil_audiodescription_presence",
        values: [
            "True"
        ],
        targets: [
            "accueil_audiodescription"
        ],
        indent: $819c6a472fb38c36$var$INDENTS_LEVEL.first
    },
    {
        source: "accueil_equipements_malentendants_presence",
        values: [
            "True"
        ],
        targets: [
            "accueil_equipements_malentendants"
        ],
        indent: $819c6a472fb38c36$var$INDENTS_LEVEL.first
    },
    {
        source: "accueil_cheminement_plain_pied",
        values: [
            "False"
        ],
        targets: [
            "accueil_cheminement_nombre_marches",
            "accueil_cheminement_sens_marches",
            "accueil_cheminement_reperage_marches",
            "accueil_cheminement_main_courante",
            "accueil_cheminement_rampe",
            "accueil_cheminement_ascenseur"
        ],
        indent: $819c6a472fb38c36$var$INDENTS_LEVEL.first
    },
    // Sanitaires
    {
        source: "sanitaires_presence",
        values: [
            "True"
        ],
        targets: [
            "sanitaires_adaptes"
        ],
        indent: $819c6a472fb38c36$var$INDENTS_LEVEL.first
    },
    // Chambres accessibles
    {
        source: "accueil_chambre_nombre_accessibles",
        minValue: 1,
        targets: [
            "accueil_chambre_douche_plain_pied",
            "accueil_chambre_douche_siege",
            "accueil_chambre_douche_barre_appui",
            "accueil_chambre_sanitaires_barre_appui",
            "accueil_chambre_sanitaires_espace_usage"
        ],
        indent: $819c6a472fb38c36$var$INDENTS_LEVEL.first
    },
    // Labels
    // TODO
    // Publication: registre et conformité
    // a. afficher registre si gestionnaire
    {
        source: "user_type",
        values: [
            "gestionnaire",
            "admin"
        ],
        targets: [
            "registre_url"
        ],
        indent: $819c6a472fb38c36$var$INDENTS_LEVEL.first
    },
    // b. afficher conformité si administration
    {
        source: "user_type",
        values: [
            "admin"
        ],
        targets: [
            "conformite"
        ],
        indent: $819c6a472fb38c36$var$INDENTS_LEVEL.first
    }
];
function $819c6a472fb38c36$var$getFieldInputs(root, field) {
    return Array.from(root.querySelectorAll(`input[name=${field}]`));
}
function $819c6a472fb38c36$var$getValue(root, field) {
    const inputs = $819c6a472fb38c36$var$getFieldInputs(root, field);
    if (inputs.length === 0) // field has not been found in the page, skipping
    return;
    const selectedInput = inputs.filter((input)=>input.checked || input.type == "number")[0];
    return selectedInput?.value;
}
function $819c6a472fb38c36$var$resetField(field) {
    const radioNone = field.querySelector("input[type=radio][value='']");
    if (radioNone) radioNone.click();
    const inputTypes = [
        "textarea",
        "input[type=text]",
        "input[type=url]",
        "input[type=date]",
        "input[type=number]"
    ];
    inputTypes.forEach((inputType)=>{
        const element = field.querySelector(inputType);
        if (element) element.value = "";
    });
}
function $819c6a472fb38c36$var$processTargets(root, rule, value) {
    const SECTION_SELECTOR = ".contrib-inputs-section";
    rule.targets.forEach((target)=>{
        const el = root.querySelector(`.field-${target}`);
        if (!el) return;
        if (typeof rule.minValue !== "undefined" && value && parseInt(value) >= rule.minValue || typeof rule.values !== "undefined" && rule.values.indexOf(value) !== -1) el.closest(SECTION_SELECTOR).classList.remove("hidden");
        else {
            el.closest(SECTION_SELECTOR).classList.add("hidden");
            el.innerHTML.trim();
            $819c6a472fb38c36$var$resetField(el);
        }
    });
}
function $819c6a472fb38c36$var$processRule(root, rule) {
    // grab the source field input elements
    const inputs = $819c6a472fb38c36$var$getFieldInputs(root, rule.source);
    if (inputs.length === 0) // field has not been found in the page, skipping
    return;
    inputs.forEach((input)=>{
        input.addEventListener("change", function({ target: { value: value } }) {
            $819c6a472fb38c36$var$processTargets(root, rule, value);
            rule.targets.forEach((child)=>{
                const childRule = $819c6a472fb38c36$var$rules.filter((rule)=>rule.source === child)[0];
                if (childRule) $819c6a472fb38c36$var$processTargets(root, childRule, $819c6a472fb38c36$var$getValue(root, child));
            });
        });
    });
    $819c6a472fb38c36$var$processTargets(root, rule, $819c6a472fb38c36$var$getValue(root, rule.source));
}
function $819c6a472fb38c36$export$2e2bcd8739ae039(root) {
    $819c6a472fb38c36$var$rules.forEach(function(rule) {
        $819c6a472fb38c36$var$processRule(root, rule);
    });
}



function $a416cb3ead227722$var$GeoLink(root) {
    root.addEventListener("click", (event)=>{
        event.preventDefault();
        event.stopPropagation();
        const identifier = root.dataset?.erpIdentifier;
        if (identifier) (0, $0487332c780ecdcd$export$2e2bcd8739ae039).openMarkerPopup(identifier);
    });
}
var $a416cb3ead227722$export$2e2bcd8739ae039 = $a416cb3ead227722$var$GeoLink;



function $0b722a642fc1bbbb$var$GetGeolocBtn(root) {
    root.addEventListener("click", async (event)=>{
        await (0, $fffadef9b49322ab$export$2e2bcd8739ae039).loadUserLocation({
            retrieve: true
        });
    });
}
var $0b722a642fc1bbbb$export$2e2bcd8739ae039 = $0b722a642fc1bbbb$var$GetGeolocBtn;


function $7b9326ae663eb641$var$ExportResultsBtn(root) {
    if (!root) return;
    root.addEventListener("click", async (event)=>{
        event.preventDefault();
        const form = root.parentElement;
        const url = new URL(form.getAttribute("action"), window.location.origin);
        const params = new URLSearchParams(new FormData(form));
        url.search = params;
        fetch(url, {
            method: "GET"
        }).then((response)=>response.json()).then((data)=>{
            $7b9326ae663eb641$var$displayMessage(data.message, data.success);
        });
    });
}
function $7b9326ae663eb641$var$displayMessage(message, type) {
    type = type === true ? "success" : "error";
    const messageBox = document.createElement("div");
    messageBox.className = `message-box ${type}`;
    messageBox.innerHTML = message;
    document.body.appendChild(messageBox);
    setTimeout(()=>{
        messageBox.remove();
    }, 5000);
}
var $7b9326ae663eb641$export$2e2bcd8739ae039 = $7b9326ae663eb641$var$ExportResultsBtn;


function $287fe86d73c69e2b$var$SyncInputsWithElement(root) {
    if (!root) return;
    const inputNames = root.getAttribute("data-input-names")?.split(",");
    if (!inputNames) return;
    inputNames.forEach((inputName)=>{
        const inputElement = document.querySelector(`input[name="${inputName.trim()}"]`);
        if (!inputElement) return;
        inputElement.addEventListener("input", ()=>{
            root.textContent = inputNames.map((name)=>{
                const input = document.querySelector(`input[name="${name.trim()}"]`);
                return input ? input.value : "";
            }).join(" ");
        });
    });
}
var $287fe86d73c69e2b$export$2e2bcd8739ae039 = $287fe86d73c69e2b$var$SyncInputsWithElement;



function $640168bceedae65e$var$LocalisationMap(root) {
    const mapDomEl = root.querySelector(".a4a-localisation-map");
    const hiddenLat = root.querySelector("input[type=hidden][name=lat]");
    const hiddenLon = root.querySelector("input[type=hidden][name=lon]");
    const mapOptions = JSON.parse(root.querySelector("#map-options").textContent.trim());
    const map = (0, $0487332c780ecdcd$export$2e2bcd8739ae039).createMap(mapDomEl, {
        scrollWheelZoom: false,
        ...mapOptions
    });
    const lat = parseFloat(hiddenLat.value);
    const lon = parseFloat(hiddenLon.value);
    map.setView({
        lat: lat,
        lon: lon
    }, 18);
    const tenKmInDegrees = 10 / 111 // approx. 0.09° (1° ≈ 111 km)
    ;
    const southWest = L.latLng(lat - tenKmInDegrees, lon - tenKmInDegrees);
    const northEast = L.latLng(lat + tenKmInDegrees, lon + tenKmInDegrees);
    const bounds = L.latLngBounds(southWest, northEast);
    map.setMaxBounds(bounds);
    const control = L.control.centerCross({
        show: true,
        position: "topright"
    });
    map.addControl(control);
    map.on("move", function(event) {
        const coords = event.target.getCenter();
        hiddenLat.value = coords.lat;
        hiddenLon.value = coords.lng;
    });
    let numero = document.getElementById("id_numero");
    let voie = document.getElementById("id_voie");
    let lieu_dit = document.getElementById("id_lieu_dit");
    let code_postal = document.getElementById("id_code_postal");
    let ville = document.getElementById("id_commune");
    [
        numero,
        voie,
        lieu_dit,
        code_postal,
        ville
    ].forEach((elem)=>elem.addEventListener("change", function() {
            let query = numero.value + " " + voie.value + " " + lieu_dit.value + " " + code_postal.value + " " + ville.value;
            (0, $0487332c780ecdcd$export$2e2bcd8739ae039).updateMap(query, map);
        }));
}
var $640168bceedae65e$export$2e2bcd8739ae039 = $640168bceedae65e$var$LocalisationMap;



function $893284db34dfae4c$var$MapExpander(root) {
    const mapEl = document.querySelector("#app-map");
    const initialMapHeight = mapEl.style.height;
    const initialMapHeightToggleLinkText = root.textContent;
    function toggleMapHeight(event) {
        event.preventDefault();
        if (mapEl.style.height === initialMapHeight) {
            try {
                window.scrollBy({
                    top: root.offsetTop - window.pageYOffset - 15,
                    behavior: "smooth"
                });
            } catch (e) {}
            mapEl.style.height = "90vh";
            root.textContent = "R\xe9duire la carte";
        } else {
            mapEl.style.height = initialMapHeight;
            root.textContent = initialMapHeightToggleLinkText;
        }
        (0, $0487332c780ecdcd$export$2e2bcd8739ae039).recalculateMapSize();
    }
    root.addEventListener("click", toggleMapHeight);
}
var $893284db34dfae4c$export$2e2bcd8739ae039 = $893284db34dfae4c$var$MapExpander;




function $3fd49769fea2b73d$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $3fd49769fea2b73d$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $3fd49769fea2b73d$var$_toPropertyKey(o.key), o);
    }
}
function $3fd49769fea2b73d$var$_createClass(e, r, t) {
    return r && $3fd49769fea2b73d$var$_defineProperties(e.prototype, r), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $3fd49769fea2b73d$var$_defineProperty(e, r, t) {
    return (r = $3fd49769fea2b73d$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $3fd49769fea2b73d$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $3fd49769fea2b73d$var$_toPropertyKey(t) {
    var i = $3fd49769fea2b73d$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
// Polyfill for element.matches, to support Internet Explorer. It's a relatively
// simple polyfill, so we'll just include it rather than require the user to
// include the polyfill themselves. Adapted from
// https://developer.mozilla.org/en-US/docs/Web/API/Element/matches#Polyfill
var $3fd49769fea2b73d$var$matches = function matches(element, selector) {
    return element.matches ? element.matches(selector) : element.msMatchesSelector ? element.msMatchesSelector(selector) : element.webkitMatchesSelector ? element.webkitMatchesSelector(selector) : null;
};
// Polyfill for element.closest, to support Internet Explorer. It's a relatively
// simple polyfill, so we'll just include it rather than require the user to
// include the polyfill themselves. Adapted from
// https://developer.mozilla.org/en-US/docs/Web/API/Element/closest#Polyfill
var $3fd49769fea2b73d$var$closestPolyfill = function closestPolyfill(el, selector) {
    var element = el;
    while(element && element.nodeType === 1){
        if ($3fd49769fea2b73d$var$matches(element, selector)) return element;
        element = element.parentNode;
    }
    return null;
};
var $3fd49769fea2b73d$var$closest = function closest(element, selector) {
    return element.closest ? element.closest(selector) : $3fd49769fea2b73d$var$closestPolyfill(element, selector);
};
// Returns true if the value has a "then" function. Adapted from
// https://github.com/graphql/graphql-js/blob/499a75939f70c4863d44149371d6a99d57ff7c35/src/jsutils/isPromise.js
var $3fd49769fea2b73d$var$isPromise = function isPromise(value) {
    return Boolean(value && typeof value.then === "function");
};
var $3fd49769fea2b73d$var$AutocompleteCore = /*#__PURE__*/ $3fd49769fea2b73d$var$_createClass(function AutocompleteCore() {
    var _this = this;
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, search = _ref.search, _ref$autoSelect = _ref.autoSelect, autoSelect = _ref$autoSelect === void 0 ? false : _ref$autoSelect, _ref$setValue = _ref.setValue, setValue = _ref$setValue === void 0 ? function() {} : _ref$setValue, _ref$setAttribute = _ref.setAttribute, setAttribute = _ref$setAttribute === void 0 ? function() {} : _ref$setAttribute, _ref$onUpdate = _ref.onUpdate, onUpdate = _ref$onUpdate === void 0 ? function() {} : _ref$onUpdate, _ref$onSubmit = _ref.onSubmit, onSubmit = _ref$onSubmit === void 0 ? function() {} : _ref$onSubmit, _ref$onShow = _ref.onShow, onShow = _ref$onShow === void 0 ? function() {} : _ref$onShow, _ref$autocorrect = _ref.autocorrect, autocorrect = _ref$autocorrect === void 0 ? false : _ref$autocorrect, _ref$onHide = _ref.onHide, onHide = _ref$onHide === void 0 ? function() {} : _ref$onHide, _ref$onLoading = _ref.onLoading, onLoading = _ref$onLoading === void 0 ? function() {} : _ref$onLoading, _ref$onLoaded = _ref.onLoaded, onLoaded = _ref$onLoaded === void 0 ? function() {} : _ref$onLoaded, _ref$submitOnEnter = _ref.submitOnEnter, submitOnEnter = _ref$submitOnEnter === void 0 ? false : _ref$submitOnEnter;
    $3fd49769fea2b73d$var$_classCallCheck(this, AutocompleteCore);
    $3fd49769fea2b73d$var$_defineProperty(this, "value", "");
    $3fd49769fea2b73d$var$_defineProperty(this, "searchCounter", 0);
    $3fd49769fea2b73d$var$_defineProperty(this, "results", []);
    $3fd49769fea2b73d$var$_defineProperty(this, "selectedIndex", -1);
    $3fd49769fea2b73d$var$_defineProperty(this, "selectedResult", null);
    $3fd49769fea2b73d$var$_defineProperty(this, "destroy", function() {
        _this.search = null;
        _this.setValue = null;
        _this.setAttribute = null;
        _this.onUpdate = null;
        _this.onSubmit = null;
        _this.autocorrect = null;
        _this.onShow = null;
        _this.onHide = null;
        _this.onLoading = null;
        _this.onLoaded = null;
    });
    $3fd49769fea2b73d$var$_defineProperty(this, "handleInput", function(event) {
        var value = event.target.value;
        _this.updateResults(value);
        _this.value = value;
    });
    $3fd49769fea2b73d$var$_defineProperty(this, "handleKeyDown", function(event) {
        var key = event.key;
        switch(key){
            case "Up":
            case "Down":
            case "ArrowUp":
            case "ArrowDown":
                var selectedIndex = key === "ArrowUp" || key === "Up" ? _this.selectedIndex - 1 : _this.selectedIndex + 1;
                event.preventDefault();
                _this.handleArrows(selectedIndex);
                break;
            case "Tab":
                _this.selectResult();
                break;
            case "Enter":
                var isListItemSelected = event.target.getAttribute("aria-activedescendant").length > 0;
                _this.selectedResult = _this.results[_this.selectedIndex] || _this.selectedResult;
                _this.selectResult();
                if (_this.submitOnEnter) _this.selectedResult && _this.onSubmit(_this.selectedResult);
                else if (isListItemSelected) event.preventDefault();
                else {
                    _this.selectedResult && _this.onSubmit(_this.selectedResult);
                    _this.selectedResult = null;
                }
                break;
            case "Esc":
            case "Escape":
                _this.hideResults();
                _this.setValue();
                break;
            default:
                return;
        }
    });
    $3fd49769fea2b73d$var$_defineProperty(this, "handleFocus", function(event) {
        var value = event.target.value;
        _this.updateResults(value);
        _this.value = value;
    });
    $3fd49769fea2b73d$var$_defineProperty(this, "handleBlur", function() {
        _this.hideResults();
    });
    // The mousedown event fires before the blur event. Calling preventDefault() when
    // the results list is clicked will prevent it from taking focus, firing the
    // blur event on the input element, and closing the results list before click fires.
    $3fd49769fea2b73d$var$_defineProperty(this, "handleResultMouseDown", function(event) {
        event.preventDefault();
    });
    $3fd49769fea2b73d$var$_defineProperty(this, "handleResultClick", function(event) {
        var target = event.target;
        var result = $3fd49769fea2b73d$var$closest(target, "[data-result-index]");
        if (result) {
            _this.selectedIndex = parseInt(result.dataset.resultIndex, 10);
            var selectedResult = _this.results[_this.selectedIndex];
            _this.selectResult();
            _this.onSubmit(selectedResult);
        }
    });
    $3fd49769fea2b73d$var$_defineProperty(this, "handleArrows", function(selectedIndex) {
        // Loop selectedIndex back to first or last result if out of bounds
        var resultsCount = _this.results.length;
        _this.selectedIndex = (selectedIndex % resultsCount + resultsCount) % resultsCount;
        // Update results and aria attributes
        _this.onUpdate(_this.results, _this.selectedIndex);
    });
    $3fd49769fea2b73d$var$_defineProperty(this, "selectResult", function() {
        var selectedResult = _this.results[_this.selectedIndex];
        if (selectedResult) _this.setValue(selectedResult);
        _this.hideResults();
    });
    $3fd49769fea2b73d$var$_defineProperty(this, "updateResults", function(value) {
        var currentSearch = ++_this.searchCounter;
        _this.onLoading();
        _this.search(value).then(function(results) {
            if (currentSearch !== _this.searchCounter) return;
            _this.results = results;
            _this.onLoaded();
            if (_this.results.length === 0) {
                _this.hideResults();
                return;
            }
            _this.selectedIndex = _this.autoSelect ? 0 : -1;
            _this.onUpdate(_this.results, _this.selectedIndex);
            _this.showResults();
        });
    });
    $3fd49769fea2b73d$var$_defineProperty(this, "showResults", function() {
        _this.setAttribute("aria-expanded", true);
        _this.onShow();
    });
    $3fd49769fea2b73d$var$_defineProperty(this, "hideResults", function() {
        _this.selectedIndex = -1;
        _this.results = [];
        _this.setAttribute("aria-expanded", false);
        _this.setAttribute("aria-activedescendant", "");
        _this.onUpdate(_this.results, _this.selectedIndex);
        _this.onHide();
    });
    // Make sure selected result isn't scrolled out of view
    $3fd49769fea2b73d$var$_defineProperty(this, "checkSelectedResultVisible", function(resultsElement) {
        var selectedResultElement = resultsElement.querySelector('[data-result-index="'.concat(_this.selectedIndex, '"]'));
        if (!selectedResultElement) return;
        var resultsPosition = resultsElement.getBoundingClientRect();
        var selectedPosition = selectedResultElement.getBoundingClientRect();
        if (selectedPosition.top < resultsPosition.top) // Element is above viewable area
        resultsElement.scrollTop -= resultsPosition.top - selectedPosition.top;
        else if (selectedPosition.bottom > resultsPosition.bottom) // Element is below viewable area
        resultsElement.scrollTop += selectedPosition.bottom - resultsPosition.bottom;
    });
    this.search = $3fd49769fea2b73d$var$isPromise(search) ? search : function(value) {
        return Promise.resolve(search(value));
    };
    this.autoSelect = autoSelect;
    this.setValue = setValue;
    this.setAttribute = setAttribute;
    this.onUpdate = onUpdate;
    this.onSubmit = onSubmit;
    this.autocorrect = autocorrect;
    this.onShow = onShow;
    this.onHide = onHide;
    this.onLoading = onLoading;
    this.onLoaded = onLoaded;
    this.submitOnEnter = submitOnEnter;
});
// Generates a unique ID, with optional prefix. Adapted from
// https://github.com/lodash/lodash/blob/61acdd0c295e4447c9c10da04e287b1ebffe452c/uniqueId.js
var $3fd49769fea2b73d$var$idCounter = 0;
var $3fd49769fea2b73d$var$uniqueId = function uniqueId() {
    var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    return "".concat(prefix).concat(++$3fd49769fea2b73d$var$idCounter);
};
// Calculates whether element2 should be above or below element1. Always
// places element2 below unless all of the following:
// 1. There isn't enough visible viewport below to fit element2
// 2. There is more room above element1 than there is below
// 3. Placing elemen2 above 1 won't overflow window
var $3fd49769fea2b73d$var$getRelativePosition = function getRelativePosition(element1, element2) {
    var position1 = element1.getBoundingClientRect();
    var position2 = element2.getBoundingClientRect();
    var positionAbove = /* 1 */ position1.bottom + position2.height > window.innerHeight && /* 2 */ window.innerHeight - position1.bottom < position1.top && /* 3 */ window.pageYOffset + position1.top - position2.height > 0;
    return positionAbove ? "above" : "below";
};
// Credit David Walsh (https://davidwalsh.name/javascript-debounce-function)
// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
var $3fd49769fea2b73d$var$debounce = function debounce(func, wait, immediate) {
    var timeout;
    return function executedFunction() {
        var context = this;
        var args = arguments;
        var later = function later() {
            timeout = null;
            func.apply(context, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
};
/**
 * @typedef {Object} LabelObj
 * @property {string} attribute - `aria-label` | `aria-labelledby`
 * @property {string} content - content of attribute
 */ /**
 * @param {string} labelStr - content for `aria-label` or – if it starts with `#` – ID for `aria-labelledby`
 * @returns {LabelObj} Object with label attribute and its content
 */ var $3fd49769fea2b73d$var$getAriaLabel = function getAriaLabel(labelStr) {
    if (labelStr !== null && labelStr !== void 0 && labelStr.length) {
        var isLabelId = labelStr.startsWith("#");
        return {
            attribute: isLabelId ? "aria-labelledby" : "aria-label",
            content: isLabelId ? labelStr.substring(1) : labelStr
        };
    }
};
// Creates a props object with overridden toString function. toString returns an attributes
// string in the format: `key1="value1" key2="value2"` for easy use in an HTML string.
var $3fd49769fea2b73d$var$Props = /*#__PURE__*/ function() {
    function Props(index, selectedIndex, baseClass) {
        $3fd49769fea2b73d$var$_classCallCheck(this, Props);
        this.id = "".concat(baseClass, "-result-").concat(index);
        this["class"] = "".concat(baseClass, "-result");
        this["data-result-index"] = index;
        this.role = "option";
        if (index === selectedIndex) this["aria-selected"] = "true";
    }
    return $3fd49769fea2b73d$var$_createClass(Props, [
        {
            key: "toString",
            value: function toString() {
                var _this = this;
                return Object.keys(this).reduce(function(str, key) {
                    return "".concat(str, " ").concat(key, '="').concat(_this[key], '"');
                }, "");
            }
        }
    ]);
}();
var $3fd49769fea2b73d$export$2e2bcd8739ae039 = /*#__PURE__*/ $3fd49769fea2b73d$var$_createClass(function Autocomplete(root) {
    var _this2 = this;
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, search = _ref.search, _ref$onSubmit = _ref.onSubmit, onSubmit = _ref$onSubmit === void 0 ? function() {} : _ref$onSubmit, _ref$onUpdate = _ref.onUpdate, onUpdate = _ref$onUpdate === void 0 ? function() {} : _ref$onUpdate, _ref$baseClass = _ref.baseClass, baseClass = _ref$baseClass === void 0 ? "autocomplete" : _ref$baseClass, _ref$autocorrect = _ref.autocorrect, autocorrect = _ref$autocorrect === void 0 ? false : _ref$autocorrect, autoSelect = _ref.autoSelect, _ref$getResultValue = _ref.getResultValue, getResultValue = _ref$getResultValue === void 0 ? function(result) {
        return result;
    } : _ref$getResultValue, renderResult = _ref.renderResult, _ref$debounceTime = _ref.debounceTime, debounceTime = _ref$debounceTime === void 0 ? 0 : _ref$debounceTime, resultListLabel = _ref.resultListLabel, _ref$submitOnEnter = _ref.submitOnEnter, submitOnEnter = _ref$submitOnEnter === void 0 ? false : _ref$submitOnEnter;
    $3fd49769fea2b73d$var$_classCallCheck(this, Autocomplete);
    $3fd49769fea2b73d$var$_defineProperty(this, "expanded", false);
    $3fd49769fea2b73d$var$_defineProperty(this, "loading", false);
    $3fd49769fea2b73d$var$_defineProperty(this, "position", {});
    $3fd49769fea2b73d$var$_defineProperty(this, "resetPosition", true);
    // Set up aria attributes and events
    $3fd49769fea2b73d$var$_defineProperty(this, "initialize", function() {
        _this2.root.style.position = "relative";
        _this2.input.setAttribute("role", "combobox");
        _this2.input.setAttribute("autocomplete", "off");
        _this2.input.setAttribute("autocapitalize", "off");
        if (_this2.autocorrect) _this2.input.setAttribute("autocorrect", "on");
        _this2.input.setAttribute("spellcheck", "false");
        _this2.input.setAttribute("aria-autocomplete", "list");
        _this2.input.setAttribute("aria-haspopup", "listbox");
        _this2.input.setAttribute("aria-expanded", "false");
        _this2.resultList.setAttribute("role", "listbox");
        var resultListAriaLabel = $3fd49769fea2b73d$var$getAriaLabel(_this2.resultListLabel);
        resultListAriaLabel && _this2.resultList.setAttribute(resultListAriaLabel.attribute, resultListAriaLabel.content);
        _this2.resultList.style.position = "absolute";
        _this2.resultList.style.zIndex = "1";
        _this2.resultList.style.width = "100%";
        _this2.resultList.style.boxSizing = "border-box";
        // Generate ID for results list if it doesn't have one
        if (!_this2.resultList.id) _this2.resultList.id = $3fd49769fea2b73d$var$uniqueId("".concat(_this2.baseClass, "-result-list-"));
        _this2.input.setAttribute("aria-owns", _this2.resultList.id);
        document.body.addEventListener("click", _this2.handleDocumentClick);
        _this2.input.addEventListener("input", _this2.core.handleInput);
        _this2.input.addEventListener("keydown", _this2.core.handleKeyDown);
        _this2.input.addEventListener("focus", _this2.core.handleFocus);
        _this2.input.addEventListener("blur", _this2.core.handleBlur);
        _this2.resultList.addEventListener("mousedown", _this2.core.handleResultMouseDown);
        _this2.resultList.addEventListener("click", _this2.core.handleResultClick);
        _this2.updateStyle();
    });
    $3fd49769fea2b73d$var$_defineProperty(this, "destroy", function() {
        document.body.removeEventListener("click", _this2.handleDocumentClick);
        _this2.input.removeEventListener("input", _this2.core.handleInput);
        _this2.input.removeEventListener("keydown", _this2.core.handleKeyDown);
        _this2.input.removeEventListener("focus", _this2.core.handleFocus);
        _this2.input.removeEventListener("blur", _this2.core.handleBlur);
        _this2.resultList.removeEventListener("mousedown", _this2.core.handleResultMouseDown);
        _this2.resultList.removeEventListener("click", _this2.core.handleResultClick);
        _this2.root = null;
        _this2.input = null;
        _this2.resultList = null;
        _this2.getResultValue = null;
        _this2.onUpdate = null;
        _this2.renderResult = null;
        _this2.core.destroy();
        _this2.core = null;
    });
    $3fd49769fea2b73d$var$_defineProperty(this, "setAttribute", function(attribute, value) {
        _this2.input.setAttribute(attribute, value);
    });
    $3fd49769fea2b73d$var$_defineProperty(this, "setValue", function(result) {
        _this2.input.value = result ? _this2.getResultValue(result) : "";
    });
    $3fd49769fea2b73d$var$_defineProperty(this, "renderResult", function(result, props) {
        return "<li ".concat(props, ">").concat(_this2.getResultValue(result), "</li>");
    });
    $3fd49769fea2b73d$var$_defineProperty(this, "handleUpdate", function(results, selectedIndex) {
        _this2.resultList.innerHTML = "";
        results.forEach(function(result, index) {
            var props = new $3fd49769fea2b73d$var$Props(index, selectedIndex, _this2.baseClass);
            var resultHTML = _this2.renderResult(result, props);
            if (typeof resultHTML === "string") _this2.resultList.insertAdjacentHTML("beforeend", resultHTML);
            else _this2.resultList.insertAdjacentElement("beforeend", resultHTML);
        });
        _this2.input.setAttribute("aria-activedescendant", selectedIndex > -1 ? "".concat(_this2.baseClass, "-result-").concat(selectedIndex) : "");
        if (_this2.resetPosition) {
            _this2.resetPosition = false;
            _this2.position = $3fd49769fea2b73d$var$getRelativePosition(_this2.input, _this2.resultList);
            _this2.updateStyle();
        }
        _this2.core.checkSelectedResultVisible(_this2.resultList);
        _this2.onUpdate(results, selectedIndex);
    });
    $3fd49769fea2b73d$var$_defineProperty(this, "handleShow", function() {
        _this2.expanded = true;
        _this2.updateStyle();
    });
    $3fd49769fea2b73d$var$_defineProperty(this, "handleHide", function() {
        _this2.expanded = false;
        _this2.resetPosition = true;
        _this2.updateStyle();
    });
    $3fd49769fea2b73d$var$_defineProperty(this, "handleLoading", function() {
        _this2.loading = true;
        _this2.updateStyle();
    });
    $3fd49769fea2b73d$var$_defineProperty(this, "handleLoaded", function() {
        _this2.loading = false;
        _this2.updateStyle();
    });
    $3fd49769fea2b73d$var$_defineProperty(this, "handleDocumentClick", function(event) {
        if (_this2.root.contains(event.target)) return;
        _this2.core.hideResults();
    });
    $3fd49769fea2b73d$var$_defineProperty(this, "updateStyle", function() {
        _this2.root.dataset.expanded = _this2.expanded;
        _this2.root.dataset.loading = _this2.loading;
        _this2.root.dataset.position = _this2.position;
        _this2.resultList.style.visibility = _this2.expanded ? "visible" : "hidden";
        _this2.resultList.style.pointerEvents = _this2.expanded ? "auto" : "none";
        if (_this2.position === "below") {
            _this2.resultList.style.bottom = null;
            _this2.resultList.style.top = "100%";
        } else {
            _this2.resultList.style.top = null;
            _this2.resultList.style.bottom = "100%";
        }
    });
    this.root = typeof root === "string" ? document.querySelector(root) : root;
    this.input = this.root.querySelector("input");
    this.resultList = this.root.querySelector("ul");
    this.baseClass = baseClass;
    this.autocorrect = autocorrect;
    this.getResultValue = getResultValue;
    this.onUpdate = onUpdate;
    if (typeof renderResult === "function") this.renderResult = renderResult;
    this.resultListLabel = resultListLabel;
    this.submitOnEnter = submitOnEnter;
    var core = new $3fd49769fea2b73d$var$AutocompleteCore({
        search: search,
        autoSelect: autoSelect,
        setValue: this.setValue,
        setAttribute: this.setAttribute,
        onUpdate: this.handleUpdate,
        autocorrect: this.autocorrect,
        onSubmit: onSubmit,
        onShow: this.handleShow,
        onHide: this.handleHide,
        onLoading: this.handleLoading,
        onLoaded: this.handleLoaded,
        submitOnEnter: this.submitOnEnter
    });
    if (debounceTime > 0) core.handleInput = $3fd49769fea2b73d$var$debounce(core.handleInput, debounceTime);
    this.core = core;
    this.initialize();
});


async function $3165890e9c4a6981$var$getCommonResults(loc) {
    const AROUND_ME = gettext("Autour de moi");
    const FRANCE_ENTIERE = gettext("France enti\xe8re");
    return [
        {
            id: "around_me",
            text: `${AROUND_ME} ${loc?.label || ""}`,
            icon: "street-view"
        },
        {
            id: "france_entiere",
            text: FRANCE_ENTIERE,
            icon: "france"
        }
    ];
}
function $3165890e9c4a6981$var$SearchWhere(root) {
    const AROUND_ME = gettext("Autour de moi");
    const FRANCE_ENTIERE = gettext("France enti\xe8re");
    const input = root.querySelector("input[name=where]");
    const a11yGeolocBtn = document.querySelector(".get-geoloc-btn");
    const hiddens = {
        lat: root.querySelector("input[name=lat]"),
        lon: root.querySelector("input[name=lon]"),
        code: root.querySelector("input[name=code]"),
        search_type: root.querySelector("input[name=search_type]"),
        postcode: root.querySelector("input[name=postcode]"),
        street_name: root.querySelector("input[name=street_name]"),
        municipality: root.querySelector("input[name=municipality]")
    };
    const searchInDepartmentsAllowed = input.dataset.autocompleteDepartments === "on";
    input.addEventListener("input", activateSubmitBtn, false);
    activateSubmitBtn(null, false);
    function activateSubmitBtn(event, force1 = false) {
        if (input.value.startsWith(AROUND_ME) && hiddens.lat.getAttribute("value") && hiddens.lon.getAttribute("value")) force1 = true;
        if (force1 || hiddens.code.value.length != 0 || input.value == FRANCE_ENTIERE) input.form.querySelector("button[type=submit]").removeAttribute("disabled");
        else input.form.querySelector("button[type=submit]").setAttribute("disabled", "");
    }
    function setSearchData(loc) {
        hiddens.lat.value = loc?.lat || "";
        hiddens.lon.value = loc?.lon || "";
        hiddens.code.value = loc?.code || "";
        hiddens.search_type.value = loc?.search_type || "";
        hiddens.postcode.value = loc?.postcode || "";
        hiddens.street_name.value = loc?.street_name || "";
        hiddens.municipality.value = loc?.municipality || "";
    }
    function setSearchValue(label) {
        input.value = label;
    }
    function setGeoLoading(loading) {
        if (loading) {
            input.type = "text";
            input.form.addEventListener("submit", (0, $4c538bf77dcd4adb$export$2e2bcd8739ae039).preventDefault);
            (0, $4c538bf77dcd4adb$export$2e2bcd8739ae039).addClass(input, "disabled", "loading");
        } else {
            input.type = "search";
            input.form.removeEventListener("submit", (0, $4c538bf77dcd4adb$export$2e2bcd8739ae039).preventDefault);
            (0, $4c538bf77dcd4adb$export$2e2bcd8739ae039).removeClass(input, "disabled", "loading");
        }
    }
    const autocomplete = new (0, $3fd49769fea2b73d$export$2e2bcd8739ae039)(root, {
        debounceTime: 100,
        submitOnEnter: true,
        getResultValue: ({ text: text })=>text,
        onSubmit: async (result)=>{
            if (!result) return;
            if (result.lat && result.lon || result.code) setSearchData(result);
            else if (result.text.startsWith(AROUND_ME)) {
                if (await (0, $fffadef9b49322ab$export$2e2bcd8739ae039).hasPermission("geolocation") !== "granted") a11yGeolocBtn.focus();
                setGeoLoading(true);
                const loc = await (0, $fffadef9b49322ab$export$2e2bcd8739ae039).loadUserLocation({
                    retrieve: true
                });
                setGeoLoading(false);
                if (!loc) {
                    console.warn("Impossible de r\xe9cup\xe9rer votre localisation\xa0; v\xe9rifiez les autorisations de votre navigateur");
                    setSearchData(null);
                    setSearchValue("");
                    input.focus();
                } else {
                    loc.search_type = AROUND_ME;
                    setSearchData(loc);
                    setSearchValue(`${AROUND_ME} ${loc.label}`);
                    input.form.querySelector("button[type=submit]").focus();
                }
            } else setSearchData(null);
            activateSubmitBtn(null, force = true);
        },
        renderResult: ({ text: text, context: context, icon: icon }, props)=>{
            const active = props["aria-selected"] ? "active" : "";
            return `
        <li class="list-group-item a4a-autocomplete-result ${active}" ${props}>
          ${icon ? `<i aria-hidden="true" class="icon icon-${icon}"></i>` : ""}
          ${text}
          ${context ? `<small class="text-truncate">${context}</small>` : ""}
        </li>
      `;
        },
        search: async (input)=>{
            const loc = await (0, $fffadef9b49322ab$export$2e2bcd8739ae039).loadUserLocation({
                retrieve: false
            });
            const commonResults = await $3165890e9c4a6981$var$getCommonResults(loc);
            if (input.length < 2 || input === FRANCE_ENTIERE || input.startsWith(AROUND_ME)) return commonResults;
            if (searchInDepartmentsAllowed) {
                var { results: results } = await (0, $fffadef9b49322ab$export$2e2bcd8739ae039).searchLocation(input, loc, "departmentNumber");
                if (results.length) return results;
                var { results: results } = await (0, $fffadef9b49322ab$export$2e2bcd8739ae039).searchLocation(input, loc, "department");
                if (results.length) return results;
            }
            var { results: results } = await (0, $fffadef9b49322ab$export$2e2bcd8739ae039).searchLocation(input, loc, "municipality");
            if (results.length) return results;
            var { results: results } = await (0, $fffadef9b49322ab$export$2e2bcd8739ae039).searchLocation(input, loc);
            return results;
        }
    });
    // Invalidate lat/lon on every key stroke in the search input, except when user tabs
    // out of the field or selects and entry by pressing the Enter key.
    autocomplete.input.addEventListener("keydown", (event)=>{
        var ignoredKeys = [
            "Tab",
            "Enter",
            "Shift",
            "Control"
        ];
        if (!ignoredKeys.includes(event.key)) setSearchData(null);
    });
    // Wipe all the search results and input on click if FRANCE_ENTIERE
    autocomplete.input.addEventListener("click", (event)=>{
        if (autocomplete.input.value == FRANCE_ENTIERE) {
            setSearchValue("");
            setSearchData(null);
        }
    });
    // Prevent global form submission when an autocomplete entry is selected by pressing Enter,
    // which usually triggers form submit when a form input has the focus.
    let submittable;
    const observer = new MutationObserver((mutations)=>{
        const exp = mutations.filter(({ attributeName: attributeName })=>attributeName == "aria-expanded")[0];
        setTimeout(()=>{
            try {
                submittable = exp.target.getAttribute("aria-expanded") !== "true";
                if (submittable) activateSubmitBtn(null, false);
            } catch (e) {}
        }, 0);
    });
    observer.observe(input, {
        attributeOldValue: true
    });
    input.form.addEventListener("submit", (event)=>{
        if (!submittable) event.preventDefault();
    });
    return autocomplete;
}
var $3165890e9c4a6981$export$2e2bcd8739ae039 = $3165890e9c4a6981$var$SearchWhere;


function $01ddde9b4667a3e0$var$LabelTag(root) {
    root.addEventListener("click", function(event) {
        let eventType = root.getAttribute("data-event-type");
        const input = event.target.parentElement.querySelector("input");
        input.checked = !input.checked;
        document.dispatchEvent(new CustomEvent(eventType, {
            detail: {
                source: event.target
            }
        }));
    });
}
var $01ddde9b4667a3e0$export$2e2bcd8739ae039 = $01ddde9b4667a3e0$var$LabelTag;


function $3ccd2143be96b790$var$NewActivity(root) {
    root.addEventListener("input", function(e) {
        const { checked: checked } = e.target;
        let inputNewActivity = document.getElementById("new_activity");
        let checkbox = document.getElementById("no_activity");
        let selectActivity = document.getElementById("autocomplete-activity");
        let label = document.querySelector('label[for="new_activity"]');
        if (checked) {
            inputNewActivity.classList.remove("hidden");
            label.classList.remove("hidden");
            inputNewActivity.focus();
            selectActivity.classList.add("hidden");
            checkbox.classList.add("hidden");
            selectActivity.querySelector("input").value = gettext("Autre");
        } else {
            inputNewActivity.classList.add("hidden");
            label.classList.add("hidden");
            inputNewActivity.focus();
            selectActivity.classList.remove("hidden");
            checkbox.classList.remove("hidden");
            selectActivity.querySelector("input").value = gettext("Autre");
        }
    });
}
var $3ccd2143be96b790$export$2e2bcd8739ae039 = $3ccd2143be96b790$var$NewActivity;


function $416ff1ba0b2a05f4$var$refreshSearchURL() {
    let queryParams = new URLSearchParams();
    [
        "equipments",
        "equipments_shortcuts"
    ].forEach(function(inputName) {
        let inputs = document.querySelectorAll(`input[name=${inputName}]:checked`);
        inputs.forEach((input)=>queryParams.append(inputName, input.value));
    });
    [
        "what",
        "where",
        "lat",
        "lon",
        "code",
        "postcode",
        "search_type",
        "municipality"
    ].forEach(function(inputName) {
        let inputs = document.querySelectorAll(`input[name=${inputName}]`);
        inputs.forEach((input)=>input.value ? queryParams.append(inputName, input.value) : "");
    });
    queryParams = queryParams.toString();
    history.replaceState(null, null, queryParams ? "?" + queryParams : location.pathname);
}
var $416ff1ba0b2a05f4$export$2e2bcd8739ae039 = {
    refreshSearchURL: $416ff1ba0b2a05f4$var$refreshSearchURL
};


function $53ad967331b577bb$var$_show(elt) {
    elt.classList.remove("hidden");
}
function $53ad967331b577bb$var$_toggleHidden(elt, display) {
    const isClone = elt.querySelector("label").getAttribute("for").includes("-clone");
    if (display) $53ad967331b577bb$var$_show(elt);
    else if (!isClone) // never hide a clone, the modal should contain all equipments
    elt.classList.add("hidden");
}
function $53ad967331b577bb$var$_toggleChild(parent, display = true, keepItInPlace = false) {
    parent.querySelector("input").checked = display;
    if (keepItInPlace) $53ad967331b577bb$var$_show(parent);
    else $53ad967331b577bb$var$_toggleHidden(parent, display);
    const button = parent.querySelector("button");
    if (button) button.setAttribute("aria-pressed", display);
}
function $53ad967331b577bb$var$_toggleChildren(children, display = true, keepItInPlace = false) {
    children.forEach(function(child) {
        $53ad967331b577bb$var$_toggleChild(document.querySelector(`#${child}`).parentNode, display, keepItInPlace);
        $53ad967331b577bb$var$_toggleChild(document.querySelector(`#${child}-clone`).parentNode, display, keepItInPlace);
    });
}
function $53ad967331b577bb$var$_toggleShortcutSuggestions(shortcut, display = true) {
    shortcut = shortcut.parentNode.querySelector("button");
    let suggestions = shortcut.getAttribute("data-suggestions");
    if (!suggestions) return;
    suggestions = suggestions.split(",");
    suggestions.forEach(function(suggestion) {
        let parent = document.querySelector(`#${suggestion}`).parentNode;
        var wasChecked = parent.querySelector("button").getAttribute("aria-pressed") === "true";
        if (!wasChecked || display) $53ad967331b577bb$var$_toggleHidden(parent, display);
    });
}
function $53ad967331b577bb$var$_toggleDefaultSuggestion(display) {
    document.querySelectorAll(".default-suggestion").forEach(function(btn) {
        let equipmentSlug = btn.parentNode.querySelector("label").getAttribute("for");
        let equipmentAlreadyChecked = document.querySelector(`input[name=equipments][value=${equipmentSlug}]:checked`);
        if (!equipmentAlreadyChecked) $53ad967331b577bb$var$_toggleHidden(btn.parentNode, display);
    });
}
function $53ad967331b577bb$var$_checkForSuggestionToShow(equipmentSlug) {
    // If an equipment is unchecked and if it is part of a checked shortcut, it should reappear in suggestion list
    let shortcutsChecked = document.querySelectorAll("input[name=equipments_shortcuts]:checked");
    if (!shortcutsChecked.length) return;
    let suggestionToShow = false;
    shortcutsChecked.forEach(function(shortcut) {
        if (!suggestionToShow) {
            if ((shortcut.parentNode.querySelector("button").getAttribute("data-suggestions") || []).includes(equipmentSlug)) suggestionToShow = true;
        }
    });
    if (suggestionToShow) {
        let suggestion = document.querySelector(`#${equipmentSlug}`);
        $53ad967331b577bb$var$_toggleHidden(suggestion.parentNode, true);
    }
}
function $53ad967331b577bb$var$listenToLabelEvents() {
    const featureEnabled = document.querySelectorAll(".row.equipments").length;
    if (!featureEnabled) return;
    // Initial map loading, trigger an API search request.
    document.dispatchEvent(new Event("filterChanged"));
    let shortcutsChecked = document.querySelectorAll("input[name=equipments_shortcuts]:checked");
    if (!shortcutsChecked.length) $53ad967331b577bb$var$_toggleDefaultSuggestion(true);
    else shortcutsChecked.forEach(function(shortcut) {
        $53ad967331b577bb$var$_toggleShortcutSuggestions(shortcut, true);
    });
    document.addEventListener("shortcutClicked", function(event) {
        let equipmentsShortcut = event.detail.source;
        let display = equipmentsShortcut.getAttribute("aria-pressed") === "true";
        if (display) $53ad967331b577bb$var$_toggleDefaultSuggestion(false);
        let input = equipmentsShortcut.parentNode.querySelector("input");
        input.checked = display;
        let children = (equipmentsShortcut.getAttribute("data-children") || "").split(",").filter((r)=>r);
        $53ad967331b577bb$var$_toggleChildren(children, display);
        $53ad967331b577bb$var$_toggleShortcutSuggestions(equipmentsShortcut, display);
        document.dispatchEvent(new Event("filterChanged"));
    });
    document.addEventListener("equipmentClicked", function(event) {
        let parent = event.detail.source.parentNode;
        let equipmentSlug = parent.querySelector("label").getAttribute("for").replace("-clone", "");
        const isClone = parent.querySelector("label").getAttribute("for").includes("-clone");
        let display = true;
        if (isClone) display = parent.querySelector("input[type=checkbox]").checked;
        else display = event.detail.source.getAttribute("aria-pressed") === "true";
        $53ad967331b577bb$var$_toggleChildren([
            equipmentSlug
        ], display, true);
        if (!display) $53ad967331b577bb$var$_checkForSuggestionToShow(equipmentSlug);
        if (!(event.skipRefresh && event.skipRefresh === true)) document.dispatchEvent(new Event("filterChanged"));
    });
    document.addEventListener("suggestionClicked", function(event) {
        event.preventDefault();
        let equipmentSlug = event.detail.source.parentNode.querySelector("label").getAttribute("for");
        $53ad967331b577bb$var$_toggleChildren([
            equipmentSlug
        ], true);
        $53ad967331b577bb$var$_toggleChild(event.detail.source.parentNode, false, true);
        document.dispatchEvent(new Event("filterChanged"));
    });
    document.querySelector("#remove-all-filters").addEventListener("click", function() {
        let equipments = document.querySelectorAll(".equipments-selected button");
        equipments.forEach(function(equipment) {
            let equipmentSlug = equipment.parentNode.querySelector("label").getAttribute("for");
            $53ad967331b577bb$var$_toggleChildren([
                equipmentSlug
            ], false);
        });
        let shortcuts = document.querySelectorAll(".equipments-shortcuts button[aria-pressed=true]");
        shortcuts.forEach(function(shortcut) {
            shortcut.parentNode.querySelector("input").checked = false;
            shortcut.parentNode.querySelector("button").setAttribute("aria-pressed", false);
            (0, $416ff1ba0b2a05f4$export$2e2bcd8739ae039).refreshSearchURL();
        });
        document.dispatchEvent(new Event("filterChanged"));
    });
    document.addEventListener("filterChanged", function() {
        let nbTagDisplayed = document.querySelectorAll(".equipments-selected > span:not(.hidden):not(.section-text)").length;
        if (nbTagDisplayed == 0) $53ad967331b577bb$var$_toggleDefaultSuggestion(true);
    });
}
var $53ad967331b577bb$export$2e2bcd8739ae039 = $53ad967331b577bb$var$listenToLabelEvents;


function $342d5c4507824193$var$ProgressBar(root) {
    var bar = root.querySelector(".bar");
    var percentage = parseInt(root.querySelector("span").textContent);
    bar.animate([
        {
            transform: "rotate(45deg)"
        },
        {
            transform: `rotate(${45 + percentage * 1.8}deg)`
        }
    ], {
        duration: 1200,
        easing: "ease-out",
        fill: "forwards"
    });
}
var $342d5c4507824193$export$2e2bcd8739ae039 = $342d5c4507824193$var$ProgressBar;


function $3a16e87f93ad4d61$var$PickAnswerAndSubmit(root) {
    document.querySelector("#unsure-and-submit").addEventListener("click", function(e) {
        e.preventDefault();
        var answer = document.querySelector('input[value="' + root.dataset.answerToPick + '"]');
        answer.checked = true;
        document.querySelector("#contribution-form").submit();
    });
}
var $3a16e87f93ad4d61$export$2e2bcd8739ae039 = $3a16e87f93ad4d61$var$PickAnswerAndSubmit;


function $f26203191611da7e$var$hasVisibleChildren(element) {
    let visibleChildren = false;
    Array.from(element.children).forEach(function(child) {
        if (child.offsetWidth > 0) visibleChildren = true;
    });
    return visibleChildren;
}
function $f26203191611da7e$var$listenToFilterClicked(root) {
    const dataToToogle = root.querySelectorAll("[data-filters]");
    document.addEventListener("filterClicked", ()=>{
        const inputFilters = document.querySelectorAll("[name=erp_filter]:checked");
        const activeFilters = Array.from(inputFilters).map((filter)=>filter.value);
        const titlesToToggle = root.querySelectorAll("[data-filter-title]");
        if (activeFilters.length === 0) {
            dataToToogle.forEach((element)=>{
                element.classList.remove("hidden");
            });
            titlesToToggle.forEach((element)=>{
                element.classList.remove("hidden");
            });
            return;
        }
        dataToToogle.forEach((element)=>{
            const filtersForElement = element.dataset.filters;
            const filterFound = activeFilters.some((filter)=>filtersForElement.includes(filter));
            const forceDisplay = filtersForElement.includes("all");
            if (filterFound || forceDisplay) element.classList.remove("hidden");
            else element.classList.add("hidden");
        });
        $f26203191611da7e$var$hideEmptyTitles(root);
    });
}
function $f26203191611da7e$var$hideEmptyTitles(root) {
    const titlesToToggle = root.querySelectorAll("[data-filter-title]");
    titlesToToggle.forEach((titleElement)=>{
        const shouldBeVisible = $f26203191611da7e$var$hasVisibleChildren(titleElement.nextElementSibling);
        if (shouldBeVisible === true) titleElement.classList.remove("hidden");
        else titleElement.classList.add("hidden");
    });
}
function $f26203191611da7e$var$filterData(root) {
    $f26203191611da7e$var$hideEmptyTitles(root);
    $f26203191611da7e$var$listenToFilterClicked(root);
}
var $f26203191611da7e$export$2e2bcd8739ae039 = $f26203191611da7e$var$filterData;


function $b0884407d3d7b9b6$var$_storeFilterFromSelector(selector) {
    const activeFilters = Array.from(document.querySelectorAll(selector)).map((item)=>item.innerText);
    localStorage.setItem("activeFilters", activeFilters);
}
function $b0884407d3d7b9b6$var$StoreFilters() {
    document.addEventListener("shortcutClicked", function(event) {
        $b0884407d3d7b9b6$var$_storeFilterFromSelector(".equipments-shortcuts button[aria-pressed=true]");
    });
    document.addEventListener("filterClicked", function(event) {
        $b0884407d3d7b9b6$var$_storeFilterFromSelector(".a4a-label-tag[aria-pressed=true]");
    });
}
var $b0884407d3d7b9b6$export$2e2bcd8739ae039 = $b0884407d3d7b9b6$var$StoreFilters;


function $4a2b0dd4b78787b4$var$_clickOnSelector(filter, selector) {
    document.querySelectorAll(selector).forEach((button)=>{
        if (filter === button.innerText) button.click();
    });
}
function $4a2b0dd4b78787b4$var$LoadFilters() {
    const activeFilters = localStorage.getItem("activeFilters");
    if (!activeFilters) return;
    activeFilters.split(",").forEach((item)=>{
        $4a2b0dd4b78787b4$var$_clickOnSelector(item, "[data-event-type=filterClicked]") // ERP details page
        ;
        $4a2b0dd4b78787b4$var$_clickOnSelector(item, "[data-event-type=shortcutClicked]") // Search results page
        ;
    });
}
var $4a2b0dd4b78787b4$export$2e2bcd8739ae039 = $4a2b0dd4b78787b4$var$LoadFilters;


async function $6bbc504ce7530793$var$ContribPagination(root) {
    const PAGINATION_SIZE = 6;
    const resultsContainer = root.querySelector("#internal-results-container");
    const viewMoreButtonContainer = root.querySelector("#view-more-button-container");
    const resultsCountContainer = root.querySelector("#internal-results-count-container");
    let currentPage = 1;
    let currentCount = 0;
    if (!root || !resultsContainer) return;
    const apiKey = root.querySelector("[data-api-key]")?.dataset?.apiKey;
    const apiUrl = root.querySelector("[data-api-url]")?.dataset?.apiUrl;
    if (!apiKey || !apiUrl) return;
    const params = $6bbc504ce7530793$var$getParams({
        root: root,
        currentPage: 1,
        paginationSize: PAGINATION_SIZE
    });
    // Initial first fetch of ERP internal results on page load
    const { results: results, totalCount: totalCount, status: status } = await $6bbc504ce7530793$var$getInternalResults({
        apiUrl: apiUrl,
        apiKey: apiKey,
        params: params
    });
    const shouldDisplayViewMoreButton = totalCount > PAGINATION_SIZE;
    // currentCount initialised with first fetch of ERPs count
    // it is used later on to check whether or not to display/remove "View more" button
    currentCount = results.length;
    // If there are any results, fill in the results list with cards
    $6bbc504ce7530793$var$populateInternalResults({
        resultsContainer: resultsContainer,
        results: results
    });
    if (totalCount > 0) {
        const resultsTranslation = totalCount === 1 ? gettext("r\xe9sultat") : gettext("r\xe9sultats");
        const headingNode = document.createElement("h2");
        const resultNode = document.createElement("p");
        headingNode.classList.add("mt-3", "fr-mb-0", "fr-h3");
        resultNode.classList.add("fr-text--xl");
        headingNode.textContent = gettext("\xc9tablissements enregistr\xe9s sur AccesLibre");
        resultNode.textContent = `${totalCount} ${resultsTranslation}`;
        // List display with title
        resultsCountContainer.appendChild(headingNode);
        resultsCountContainer.appendChild(resultNode);
        currentPage++;
    } else {
        const textNode = document.createElement("p");
        textNode.classList.add("fr-text--xl");
        textNode.textContent = gettext(`Aucun \xe9tablissement n'a pu \xeatre trouv\xe9`);
        // Display with no results
        resultsCountContainer.replaceChildren();
        resultsCountContainer.appendChild(textNode);
    }
    if (shouldDisplayViewMoreButton) {
        // Create and attach the View more button when there are more than PAGINATION_SIZE results
        const viewMoreButton = $6bbc504ce7530793$var$createViewMoreButton({
            callback: onViewMoreCallback
        });
        viewMoreButtonContainer.appendChild(viewMoreButton);
    }
    async function onViewMoreCallback() {
        const params = $6bbc504ce7530793$var$getParams({
            root: root,
            currentPage: currentPage,
            paginationSize: PAGINATION_SIZE
        });
        try {
            const { results: results, status: status } = await $6bbc504ce7530793$var$getInternalResults({
                apiKey: apiKey,
                apiUrl: apiUrl,
                params: params
            });
            // If there are results, continue filling in the list of ERP cards
            if (results?.length > 0) {
                currentCount += results.length;
                $6bbc504ce7530793$var$populateInternalResults({
                    resultsContainer: resultsContainer,
                    results: results
                });
            }
            const shouldDeleteViewMoreButton = currentCount >= totalCount;
            if (status === 200) {
                if (results.length >= PAGINATION_SIZE) currentPage++;
            }
            if (shouldDeleteViewMoreButton) viewMoreButtonContainer.remove();
        } catch (err) {
        // TODO: To do later
        // Error handling, maybe display an Alert notification from DSFR ?
        }
    }
}
function $6bbc504ce7530793$var$populateInternalResults({ resultsContainer: resultsContainer, results: results }) {
    const cards = results.map(({ properties: properties })=>{
        if (!properties) return undefined;
        const { activite: activite, adresse: adresse, nom: nom, web_url: web_url } = properties;
        return $6bbc504ce7530793$var$createCard({
            title: nom ?? "",
            tag: activite?.nom ?? "",
            description: adresse ?? "",
            link: web_url ?? ""
        });
    }).filter(Boolean);
    cards.forEach((card)=>{
        resultsContainer.appendChild(card);
    });
}
/**
 * Get URLSearchParams for subsequent API call
 * @param root - Root container, used to get the activity slug from the hidden input
 * @param currentPage - Current page for the pagination
 * @param paginationSize - Number of results per page
 */ function $6bbc504ce7530793$var$getParams({ root: root, currentPage: currentPage, paginationSize: paginationSize }) {
    // Get query parameters from URL
    // URL example: what=test&new_activity=&activite=Tennis&where=Ch%C3%A9cy+%2845%29&lat=47.9019&lon=2.0223&code=45089&ban_id=&postcode=45430&search_type=&street_name=&municipality=
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
    const q = params.get("what");
    const activitySlug = root.querySelector('input[type="hidden"][name="activity_slug"]')?.value;
    const paramsForApiCall = new URLSearchParams();
    if (params.get("code")) paramsForApiCall.append("code_insee", params.get("code"));
    paramsForApiCall.append("q", q);
    paramsForApiCall.append("activite", activitySlug || params.get("activite"));
    paramsForApiCall.append("page_size", paginationSize);
    paramsForApiCall.append("page", currentPage);
    return paramsForApiCall;
}
async function $6bbc504ce7530793$var$getInternalResults({ apiKey: apiKey, apiUrl: apiUrl, params: params }) {
    const request = await fetch(`${apiUrl}?${params.toString()}`, {
        timeout: 10000,
        headers: {
            Accept: "application/geo+json",
            Authorization: `Api-Key ${apiKey}`
        }
    });
    const response = await request.json();
    return {
        results: response?.features || [],
        totalCount: response?.count || 0,
        status: request.status
    };
}
function $6bbc504ce7530793$var$createViewMoreButton({ callback: callback }) {
    const button = document.createElement("button");
    button.classList.add("fr-btn", "fr-btn--secondary", "fr-btn--lg", "fr-mt-6w");
    button.textContent = gettext(`Afficher plus d\u{2019}\xe9tablissements`);
    button.addEventListener("click", callback);
    return button;
}
/**
 * Function to create a card DOM element, for internal search result
 * @param tag - Tag that will contain the activity name
 * @param description - Description that will contain the address of the ERP
 * @param title - Name of the ERP
 * @param url - URL of the ERP
 * @returns {HTMLDivElement}
 */ function $6bbc504ce7530793$var$createCard({ link: link = "", tag: tag = "", description: description = "", title: title = "", url: url = "" }) {
    const card = document.createElement("div");
    const cardMainContent = document.createElement("div");
    const cardBody = document.createElement("div");
    const cardBodyContent = document.createElement("div");
    const cardBodyContentTitle = document.createElement("h3");
    const cardBodyContentTitleLink = document.createElement("a");
    const cardBodyContentDescription = document.createElement("p");
    const cardBodyContentStart = document.createElement("div");
    const cardBodyContentStartTag = document.createElement("p");
    // Add classes to all nodes
    card.classList.add("fr-col-12", "fr-col-sm-6", "fr-col-lg-4");
    cardMainContent.classList.add("fr-card", "fr-enlarge-link");
    cardBody.classList.add("fr-card__body");
    cardBodyContent.classList.add("fr-card__content");
    cardBodyContentTitle.classList.add("fr-card__title", "fr-h6");
    cardBodyContentDescription.classList.add("fr-card__desc");
    cardBodyContentStart.classList.add("fr-card__start");
    cardBodyContentStartTag.classList.add("fr-tag", "fr-mb-1w");
    // Add child to appropriates nodes
    card.appendChild(cardMainContent);
    cardMainContent.appendChild(cardBody);
    // Body
    cardBody.appendChild(cardBodyContent);
    cardBodyContent.appendChild(cardBodyContentTitle);
    cardBodyContentTitle.appendChild(cardBodyContentTitleLink);
    cardBodyContent.appendChild(cardBodyContentDescription);
    cardBodyContent.appendChild(cardBodyContentStart);
    cardBodyContentStart.appendChild(cardBodyContentStartTag);
    // Inner content
    cardBodyContentStartTag.textContent = tag;
    cardBodyContentTitleLink.textContent = title;
    cardBodyContentTitleLink.setAttribute("href", /^https?:\/\//.test(link) ? new URL(link).href : "#");
    cardBodyContentDescription.textContent = description;
    return card;
}
var $6bbc504ce7530793$export$2e2bcd8739ae039 = $6bbc504ce7530793$var$ContribPagination;


const $adb9f6d3a22231ac$export$ea04cfc45366e5de = "acceslibre-contrib_edit_notification_id";




const $8aa6dd4c84f578f0$var$INPUT_SELECTORS = [
    'input[type="text"]',
    'input[type="url"]',
    'input[type="email"]',
    'input[type="checkbox"]:checked',
    'input[type="radio"]:checked',
    'input[type="number"]',
    'input[type="hidden"]',
    "textarea"
].join(",");
const $8aa6dd4c84f578f0$var$BLACKLISTED_CLASS_SELECTORS = [
    "leaflet-control-layers-selector"
];
function $8aa6dd4c84f578f0$var$purifyRedirectionUrl(content) {
    const el = document.createElement("span");
    el.textContent = content;
    return el.textContent;
}
async function $8aa6dd4c84f578f0$var$FormContribDirtyChecker(root) {
    const dropdown = document.querySelector("#contrib-edit-cta");
    const csrfToken = document.querySelector('input[type="hidden"][name="csrfmiddlewaretoken"]')?.value;
    // URL used for subsequent call to update current step's values
    const currentStepUrl = dropdown?.dataset?.currentUrl;
    const modal = document.querySelector("dialog#contrib-edit-modal-controls");
    const openModalBtn = document.querySelector("button#contrib-edit-open-btn");
    const cancelBtn = document.querySelector("button#contrib-edit-modal-cancel-btn");
    const saveBtn = document.querySelector("button#contrib-edit-modal-save-btn");
    const closeBtn = document.querySelector('button[aria-controls="contrib-edit-modal-controls"]');
    const validateBtn = document.querySelector("input#contrib-edit-modal-validate-btn");
    const publishBtn = document.querySelector("input#contrib-edit-publish-btn");
    if (!root || !dropdown || !csrfToken || !currentStepUrl || !cancelBtn || !saveBtn || !modal || !openModalBtn || !closeBtn || !publishBtn || !validateBtn) return;
    // Sort to guarantee the order since the method querySelectorAll doesn't
    const getInputNodes = ()=>Array.from(root.querySelectorAll($8aa6dd4c84f578f0$var$INPUT_SELECTORS)).sort().filter((input)=>{
            // Exclude blacklisted inputs and ensure the input has a "name" or "id" attribute
            return !$8aa6dd4c84f578f0$var$BLACKLISTED_CLASS_SELECTORS.includes(input.classList.value) && (input.name || input.id);
        });
    const getMapInputs = ()=>{
        const map = new Map();
        getInputNodes().forEach((input)=>{
            const identifier = input.name || input.id;
            const isCheckbox = input.type === "checkbox";
            const { value: value } = input;
            if (map.has(identifier) && isCheckbox) map.set(identifier, [
                ...map.get(identifier),
                value
            ]);
            else if (isCheckbox) map.set(identifier, [
                value
            ]);
            else map.set(identifier, value);
        });
        return map;
    };
    // Make it immutable as it will serve as a base for subsequent comparisons
    const originalInputsMap = Object.freeze(getMapInputs());
    // Check if there were any changes whenever we select a step to go to
    dropdown.addEventListener("input", async (e)=>{
        const updatedInputsMap = getMapInputs();
        // Simple string comparison to check for diffs
        const original = Array.from(originalInputsMap.values()).join();
        const updated = Array.from(updatedInputsMap.values()).join();
        const hasDiffs = original !== updated;
        if (!hasDiffs) {
            const redirectionUrl = e.target.value;
            if (redirectionUrl) window.location.assign(new URL($8aa6dd4c84f578f0$var$purifyRedirectionUrl(redirectionUrl), window.location.origin));
        } else openModalBtn.click();
    });
    cancelBtn.addEventListener("click", ()=>{
        const redirectionUrl = dropdown.value;
        if (!redirectionUrl) return;
        window.location.assign(new URL($8aa6dd4c84f578f0$var$purifyRedirectionUrl(redirectionUrl), window.location.origin));
    });
    saveBtn.addEventListener("click", async ()=>{
        const redirectionUrl = dropdown.value;
        if (!redirectionUrl) return;
        const updatedInputsMap = getMapInputs();
        const entries = updatedInputsMap.entries();
        const formData = new URLSearchParams();
        entries.forEach(([key, value])=>{
            if (Array.isArray(value) && value.length > 0) value.forEach((v)=>{
                formData.append(key, v);
            });
            else formData.append(key, value);
        });
        // empty string is considered as true
        cancelBtn.setAttribute("disabled", "");
        saveBtn.setAttribute("disabled", "");
        fetch(currentStepUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                "X-CSRFToken": csrfToken
            },
            credentials: "include",
            body: formData
        }).then(async (response)=>{
            return response.text().then((html)=>({
                    html: html,
                    redirected: response.redirected
                }));
        }).then(({ html: html, redirected: redirected })=>{
            // Error case
            if (!redirected) {
                let parser = new DOMParser();
                let doc = parser.parseFromString(html, "text/html");
                // Replace only the body content
                document.body.innerHTML = doc.body.innerHTML;
                // Set error message for notification in the local storage
                $8aa6dd4c84f578f0$var$setLocalStorageNotificationError();
                // Re-execute scripts for edit form
                (0, $4c538bf77dcd4adb$export$2e2bcd8739ae039).mountOne(".contrib-container", (0, $5d0ca6427666b040$export$2e2bcd8739ae039).FormContribEditNotification);
                (0, $4c538bf77dcd4adb$export$2e2bcd8739ae039).mountOne(".contrib-container", (0, $5d0ca6427666b040$export$2e2bcd8739ae039).FormContribDirtyChecker);
            } else {
                $8aa6dd4c84f578f0$var$setLocalStorageNotificationSuccess();
                window.location.assign(new URL($8aa6dd4c84f578f0$var$purifyRedirectionUrl(redirectionUrl), window.location.origin));
            }
        }).catch(()=>{
            $8aa6dd4c84f578f0$var$setLocalStorageNotificationError();
        }).finally(()=>{
            saveBtn.removeAttribute("disabled");
            cancelBtn.removeAttribute("disabled");
        });
    });
    cancelBtn.addEventListener("click", ()=>{
        closeBtn.click();
    });
    validateBtn.addEventListener("click", ()=>{
        publishBtn.click();
    });
}
function $8aa6dd4c84f578f0$var$setLocalStorageNotificationError() {
    window.localStorage.setItem((0, $adb9f6d3a22231ac$export$ea04cfc45366e5de), JSON.stringify({
        title: gettext("Modification(s) echou\xe9e(s)"),
        message: gettext(`Une erreur est apparue lors de vos modifications.`),
        hasError: true
    }));
}
function $8aa6dd4c84f578f0$var$setLocalStorageNotificationSuccess() {
    window.localStorage.setItem((0, $adb9f6d3a22231ac$export$ea04cfc45366e5de), JSON.stringify({
        title: gettext("Modification(s) valid\xe9e(s)"),
        message: gettext("Vos modifications ont bien \xe9t\xe9 prises en compte."),
        hasError: false
    }));
}
var $8aa6dd4c84f578f0$export$2e2bcd8739ae039 = $8aa6dd4c84f578f0$var$FormContribDirtyChecker;



function $e7a4c1c7539958f8$var$FormContribEditNotification(root) {
    if (!root) return;
    const notificationNode = root.querySelector("#contrib-edit-notification");
    if (!notificationNode) return;
    const notification = JSON.parse(window.localStorage.getItem((0, $adb9f6d3a22231ac$export$ea04cfc45366e5de)));
    const notificationHasError = !!notification?.hasError;
    const closeBtn = notificationNode.querySelector("button.fr-btn--close");
    if (!closeBtn) return;
    if (notification) {
        notificationNode.classList.add(notificationHasError ? "fr-alert--error" : "fr-alert--success");
        notificationNode.querySelector("#contrib-edit-notification-message").textContent = notification.message;
        notificationNode.querySelector("#contrib-edit-notification-title").textContent = notification.title;
        notificationNode.classList.remove("hidden");
        window.localStorage.removeItem((0, $adb9f6d3a22231ac$export$ea04cfc45366e5de));
    }
    closeBtn.addEventListener("click", function() {
        this.parentNode.remove();
    });
}
var $e7a4c1c7539958f8$export$2e2bcd8739ae039 = $e7a4c1c7539958f8$var$FormContribEditNotification;


function $065f124503762c06$var$TextExpander(root) {
    const seeMoreContent = root.querySelector(".see-more-content");
    const seeMoreCta = root.querySelector(".see-more-cta");
    if (!seeMoreContent || !seeMoreCta) return;
    seeMoreCta.textContent = gettext("Voir plus");
    seeMoreCta.setAttribute("aria-expanded", false);
    seeMoreContent.hidden = true;
    // Button event listener, when clicked upon, text should be displayed/hidden
    seeMoreCta.addEventListener("click", ()=>{
        seeMoreContent.classList.toggle("text--expanded");
        const isExpanded = seeMoreContent.classList.contains("text--expanded");
        seeMoreCta.textContent = isExpanded ? gettext("Voir moins") : gettext("Voir plus");
        seeMoreCta.setAttribute("aria-expanded", isExpanded);
        seeMoreContent.setAttribute("aria-expanded", isExpanded);
        seeMoreContent.hidden = !isExpanded;
    });
}
var $065f124503762c06$export$2e2bcd8739ae039 = $065f124503762c06$var$TextExpander;


function $b926cbc132be08cc$var$ContentToggle(root) {
    const childrenContent = root.querySelector(".children-content");
    const btnToOpen = root.querySelector(".toggle-open");
    const btnToClose = root.querySelector(".toggle-close");
    if (!root || !childrenContent || !btnToOpen || !btnToClose) return;
    btnToOpen.addEventListener("click", ()=>{
        childrenContent.classList.remove("fr-hidden");
        btnToOpen.classList.add("fr-hidden");
    });
    btnToClose.addEventListener("click", ()=>{
        childrenContent.classList.add("fr-hidden");
        btnToOpen.classList.remove("fr-hidden");
    });
}
var $b926cbc132be08cc$export$2e2bcd8739ae039 = $b926cbc132be08cc$var$ContentToggle;


var $5d0ca6427666b040$export$2e2bcd8739ae039 = {
    AsteriskField: $57c3cca372f9dda5$export$2e2bcd8739ae039,
    ConditionalForm: $819c6a472fb38c36$export$2e2bcd8739ae039,
    GeoLink: $a416cb3ead227722$export$2e2bcd8739ae039,
    GetGeolocBtn: $0b722a642fc1bbbb$export$2e2bcd8739ae039,
    ExportResultsBtn: $7b9326ae663eb641$export$2e2bcd8739ae039,
    LocalisationMap: $640168bceedae65e$export$2e2bcd8739ae039,
    MapExpander: $893284db34dfae4c$export$2e2bcd8739ae039,
    SearchWhere: $3165890e9c4a6981$export$2e2bcd8739ae039,
    LabelTag: $01ddde9b4667a3e0$export$2e2bcd8739ae039,
    NewActivity: $3ccd2143be96b790$export$2e2bcd8739ae039,
    listenToLabelEvents: $53ad967331b577bb$export$2e2bcd8739ae039,
    ProgressBar: $342d5c4507824193$export$2e2bcd8739ae039,
    PickAnswerAndSubmit: $3a16e87f93ad4d61$export$2e2bcd8739ae039,
    filterData: $f26203191611da7e$export$2e2bcd8739ae039,
    StoreFilters: $b0884407d3d7b9b6$export$2e2bcd8739ae039,
    LoadFilters: $4a2b0dd4b78787b4$export$2e2bcd8739ae039,
    ContribPagination: $6bbc504ce7530793$export$2e2bcd8739ae039,
    SyncInputsWithElement: $287fe86d73c69e2b$export$2e2bcd8739ae039,
    FormContribDirtyChecker: $8aa6dd4c84f578f0$export$2e2bcd8739ae039,
    FormContribEditNotification: $e7a4c1c7539958f8$export$2e2bcd8739ae039,
    TextExpander: $065f124503762c06$export$2e2bcd8739ae039,
    ContentToggle: $b926cbc132be08cc$export$2e2bcd8739ae039
};




// Default coords used when we have no result and no selected city
const $0487332c780ecdcd$var$DEFAULT_LAT = 46.7;
const $0487332c780ecdcd$var$DEFAULT_LON = 1.9;
var $0487332c780ecdcd$var$L = window.L // Let's make EsLint happy :)
;
let $0487332c780ecdcd$var$currentErpIdentifier, $0487332c780ecdcd$var$layers = [], $0487332c780ecdcd$var$markers = null, $0487332c780ecdcd$var$map, $0487332c780ecdcd$var$satelliteTiles, $0487332c780ecdcd$var$streetTiles, $0487332c780ecdcd$var$shouldRefreshMap, $0487332c780ecdcd$var$shouldTryToBroadenSearchToGetOneResult, $0487332c780ecdcd$var$currentPage, $0487332c780ecdcd$var$geoJsonLayer;
$0487332c780ecdcd$var$shouldRefreshMap = true;
$0487332c780ecdcd$var$shouldTryToBroadenSearchToGetOneResult = false;
$0487332c780ecdcd$var$currentPage = 1;
function $0487332c780ecdcd$var$recalculateMapSize() {
    if (!$0487332c780ecdcd$var$map) return;
    // store current identifier before it gets destroyed for unclear reasons
    const _erpIdentifier = $0487332c780ecdcd$var$currentErpIdentifier;
    $0487332c780ecdcd$var$map.invalidateSize(false);
    // ensure repositioning any opened popup
    // see https://stackoverflow.com/a/38172374
    const currentPopup = $0487332c780ecdcd$var$map._popup;
    if (currentPopup) currentPopup.update();
    else if (_erpIdentifier) $0487332c780ecdcd$var$openMarkerPopup(_erpIdentifier);
}
function $0487332c780ecdcd$var$_createIcon(highlight, iconName) {
    const size = highlight ? 48 : 32;
    const options = {
        iconUrl: `/static/img/mapicons.svg#${iconName}`,
        iconSize: [
            size,
            size
        ],
        iconAnchor: [
            size / 2,
            size
        ],
        popupAnchor: [
            0,
            -size
        ],
        tooltipAnchor: [
            size / 2,
            -28
        ],
        className: `shadow-sm act-icon act-icon-rounded act-icon-${size}${highlight && " act-icon-invert" || ""}`
    };
    return $0487332c780ecdcd$var$L.icon(options);
}
function $0487332c780ecdcd$var$_drawPopUpMarker({ properties: props }, layer) {
    layer.bindPopup(`
    <div class="a4a-map-popup-content">
      <strong>
        <a class="text-primary" href="${props.absolute_url || props.web_url}">${props.nom}</a>
      </strong>
      ${props.activite__nom && "<br>" + props.activite__nom || ""}
      <br>${props.adresse}
    </div>`);
    layer.identifier = props.uuid;
    $0487332c780ecdcd$var$layers.push(layer);
}
function $0487332c780ecdcd$var$_createPointIcon({ properties: props }, coords) {
    let activity_icon = props.activite__vector_icon;
    if (!activity_icon) {
        if (props.activite) activity_icon = props.activite.vector_icon;
        else activity_icon = "building";
    }
    return $0487332c780ecdcd$var$L.marker(coords, {
        alt: props.nom,
        title: (props.activite__nom ? props.activite__nom + ": " : "") + props.nom,
        icon: $0487332c780ecdcd$var$_createIcon($0487332c780ecdcd$var$currentErpIdentifier && Number(props.uuid) === $0487332c780ecdcd$var$currentErpIdentifier, activity_icon)
    });
}
function $0487332c780ecdcd$var$_createClusterIcon(cluster) {
    return $0487332c780ecdcd$var$L.divIcon({
        html: cluster.getChildCount(),
        className: "a4a-cluster-icon",
        iconSize: null
    });
}
function $0487332c780ecdcd$var$createStreetTiles() {
    return $0487332c780ecdcd$var$L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        attribution: `&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> et contributeurs`
    });
}
function $0487332c780ecdcd$var$createCustomTiles(styleId) {
    return $0487332c780ecdcd$var$L.tileLayer("https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}", {
        id: styleId,
        attribution: `
        &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a>
        <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>
        Imagerie \xa9 <a href="https://www.mapbox.com/">Mapbox</a>`,
        maxZoom: 18,
        tileSize: 512,
        zoomOffset: -1,
        accessToken: "pk.eyJ1IjoiYWNjZXNsaWJyZSIsImEiOiJjbGVyN2p0cW8wNzBoM3duMThhaGY4cTRtIn0.jEdq_xNlv-oBu_q_UAmkxw"
    });
}
function $0487332c780ecdcd$var$getStreetTiles() {
    if (!$0487332c780ecdcd$var$streetTiles) $0487332c780ecdcd$var$streetTiles = $0487332c780ecdcd$var$createStreetTiles();
    return $0487332c780ecdcd$var$streetTiles;
}
function $0487332c780ecdcd$var$getSatelliteTiles() {
    if (!$0487332c780ecdcd$var$satelliteTiles) $0487332c780ecdcd$var$satelliteTiles = $0487332c780ecdcd$var$createCustomTiles("acceslibre/cliiv23h1005i01qv6365088q");
    return $0487332c780ecdcd$var$satelliteTiles;
}
function $0487332c780ecdcd$var$safeBase64Encode(data) {
    return btoa(unescape(encodeURIComponent(JSON.stringify(data))));
}
function $0487332c780ecdcd$var$_displayCustomMenu(root, { latlng: latlng, target: map }) {
    // prevent imprecise locations by requiring a minimum zoom level
    if (map.getZoom() < 16) return;
    $0487332c780ecdcd$var$L.popup().setLatLng(latlng).setContent('<a href="#" class="a4a-map-add">Ajouter un \xe9tablissement ici</a>').openOn(map);
    root.querySelector(".a4a-map-add").addEventListener("click", async (event)=>{
        event.preventDefault();
        const { lat: lat, lng: lon } = latlng;
        const { features: features } = await (0, $fffadef9b49322ab$export$2e2bcd8739ae039).reverseGeocode({
            lat: lat,
            lon: lon
        });
        const results = features.filter(({ properties: properties })=>properties.type == "housenumber");
        if (results.length == 0) {
            event.target.outerHTML = "Aucune adresse ne correspond \xe0 cet emplacement.";
            return;
        }
        const adresses = results.map(({ properties: properties, geometry: geometry })=>{
            return {
                label: properties.label,
                data: $0487332c780ecdcd$var$safeBase64Encode({
                    source: "public",
                    source_id: `ban:${properties.id}`,
                    coordonnees: [
                        geometry.coordinates[0],
                        geometry.coordinates[1]
                    ],
                    naf: null,
                    activite: null,
                    nom: null,
                    siret: null,
                    numero: properties.housenumber,
                    voie: properties.street,
                    lieu_dit: properties.locality,
                    code_postal: properties.postcode,
                    commune: properties.city,
                    code_insee: properties.citycode
                })
            };
        }, []);
        event.target.outerHTML = `
      <p><b>Choisissez une adresse :</b></p>
      <ul class="a4a-map-reverse-results">
        ${adresses.map(({ data: data, label: label })=>{
            return `<li><a href="/contrib/admin-infos/?data=${data}">${label}</a></li>`;
        })}
      </ul>`;
    });
}
function $0487332c780ecdcd$var$_loadMoreWhenLastElementIsDisplayed(map) {
    const container = document.querySelector("#erp-results-list");
    if (!container) return;
    // Watch for end of scroll
    container.addEventListener("scroll", ()=>{
        if (container.offsetHeight + container.scrollTop >= container.scrollHeight) {
            $0487332c780ecdcd$var$currentPage += 1;
            $0487332c780ecdcd$var$refreshData(map, $0487332c780ecdcd$var$currentPage);
        }
    });
    // Watch for last result being tabulated
    const nodes = document.querySelectorAll(".map-results");
    const lastElement = nodes[nodes.length - 1];
    if (!lastElement) return;
    lastElement.addEventListener("focusin", function() {
        $0487332c780ecdcd$var$currentPage += 1;
        $0487332c780ecdcd$var$refreshData(map, $0487332c780ecdcd$var$currentPage);
    });
}
function $0487332c780ecdcd$var$createMap(domTarget, options = {}) {
    const defaults = {
        layers: [
            $0487332c780ecdcd$var$getStreetTiles()
        ],
        scrollWheelZoom: true,
        ...options
    };
    const map = $0487332c780ecdcd$var$L.map(domTarget, {
        ...defaults,
        options: options
    });
    $0487332c780ecdcd$var$L.control.scale({
        imperial: false
    }).addTo(map);
    $0487332c780ecdcd$var$L.control.layers({
        "Plan des rues": $0487332c780ecdcd$var$getStreetTiles(),
        "Vue satellite": $0487332c780ecdcd$var$getSatelliteTiles()
    }).addTo(map);
    return map;
}
function $0487332c780ecdcd$var$_parseAround({ lat: lat, lon: lon, label: label }) {
    if (!lat || !lon) return;
    try {
        return {
            label: label,
            point: $0487332c780ecdcd$var$L.latLng(lat, lon)
        };
    } catch (_) {}
}
function $0487332c780ecdcd$var$refreshList(data, clearHTML = true) {
    const listContainer = document.querySelector("#erp-results-list");
    if (!listContainer) return;
    let HTMLResult = listContainer.innerHTML;
    if (clearHTML) HTMLResult = "";
    data.features.forEach(function(point) {
        HTMLResult += (0, $d38fb949d5c835b5$export$2e2bcd8739ae039).generateHTMLForResult(point);
    });
    listContainer.innerHTML = HTMLResult;
}
function $0487332c780ecdcd$var$updateNumberOfResults(data) {
    const numberContainer = document.querySelector("#number-of-results");
    const translation = ngettext("\xe9tablissement", "\xe9tablissements", data.count);
    numberContainer.innerHTML = data.count + " " + translation;
}
function $0487332c780ecdcd$var$_updateExportForm(urlParams) {
    let form = document.getElementById("export-results");
    if (!form) return;
    form = form.querySelector("form");
    form.querySelectorAll('input[type="hidden"]').forEach((input)=>input.remove());
    urlParams.forEach((value, key)=>{
        if (key == "q") key = "what";
        let hiddenInput = document.createElement("input");
        hiddenInput.type = "hidden";
        hiddenInput.name = key;
        hiddenInput.value = value;
        form.appendChild(hiddenInput);
    });
}
function $0487332c780ecdcd$var$_getDataPromiseFromAPI(map, page) {
    const southWest = map.getBounds().getSouthWest();
    const northEast = map.getBounds().getNorthEast();
    let equipments = document.querySelectorAll("input[name=equipments]:checked");
    let urlParams = new URLSearchParams();
    urlParams.set("q", document.querySelector("#what-input").value);
    urlParams.set("zone", `${southWest.lng},${southWest.lat},${northEast.lng},${northEast.lat}`);
    urlParams.set("page", page);
    urlParams.set("sortType", $0487332c780ecdcd$var$_getSortType());
    urlParams.set("where", $0487332c780ecdcd$var$_getWhere());
    equipments.forEach(function(eq) {
        urlParams.append("equipments", eq.value);
    });
    $0487332c780ecdcd$var$_updateExportForm(urlParams);
    return fetch($0487332c780ecdcd$var$_getRefreshApiUrl() + "?" + urlParams.toString(), {
        timeout: 10000,
        headers: {
            Accept: "application/geo+json",
            Authorization: "Api-Key " + $0487332c780ecdcd$var$_getApiKey()
        }
    });
}
function $0487332c780ecdcd$var$_getRoot() {
    return document.querySelector("#app-map");
}
function $0487332c780ecdcd$var$_getRefreshApiUrl() {
    return $0487332c780ecdcd$var$_getRoot().dataset.refreshApiUrl;
}
function $0487332c780ecdcd$var$_getApiKey() {
    return $0487332c780ecdcd$var$_getRoot().dataset.apiKey;
}
function $0487332c780ecdcd$var$_getSortType() {
    return $0487332c780ecdcd$var$_getRoot().dataset.sortType || "";
}
function $0487332c780ecdcd$var$_getWhere() {
    return $0487332c780ecdcd$var$_getRoot().dataset.where || "";
}
function $0487332c780ecdcd$var$refreshData(map, page = 1) {
    if (!$0487332c780ecdcd$var$shouldRefreshMap) {
        $0487332c780ecdcd$var$shouldRefreshMap = true;
        return;
    }
    const fetchPromise = $0487332c780ecdcd$var$_getDataPromiseFromAPI(map, page);
    const clearOldResults = page == 1;
    document.querySelector("#loading-spinner").classList.toggle("show-loader");
    fetchPromise.then((response)=>{
        if (!response.ok) {
            document.querySelector("#loading-spinner").classList.toggle("show-loader");
            return;
        }
        response.json().then((jsonData)=>{
            if (clearOldResults && $0487332c780ecdcd$var$markers) map.removeLayer($0487332c780ecdcd$var$markers);
            $0487332c780ecdcd$var$markers = $0487332c780ecdcd$var$_createMarkersFromGeoJson(jsonData);
            map.addLayer($0487332c780ecdcd$var$markers);
            $0487332c780ecdcd$var$refreshList(jsonData, clearOldResults);
            $0487332c780ecdcd$var$updateNumberOfResults(jsonData);
            (0, $4c538bf77dcd4adb$export$2e2bcd8739ae039).mountAll(".a4a-geo-link", (0, $5d0ca6427666b040$export$2e2bcd8739ae039).GeoLink);
            document.querySelector("#loading-spinner").classList.toggle("show-loader");
            if (jsonData.count > 0) document.querySelector("#no-results").classList.add("hidden");
            else document.querySelector("#no-results").classList.remove("hidden");
            if ($0487332c780ecdcd$var$shouldTryToBroadenSearchToGetOneResult) {
                if (jsonData.count >= 1) $0487332c780ecdcd$var$shouldTryToBroadenSearchToGetOneResult = false;
                else map.setView($0487332c780ecdcd$var$L.latLng(map.getCenter()), map.getZoom() - 1);
            }
        });
    });
}
function $0487332c780ecdcd$var$refreshDataOnMove(map) {
    const debouncedFunction = $0487332c780ecdcd$var$debounce($0487332c780ecdcd$var$refreshData, 300);
    map.on("moveend", function() {
        $0487332c780ecdcd$var$currentPage = 0;
        debouncedFunction(map);
    });
}
const $0487332c780ecdcd$var$debounce = (callback, wait)=>{
    let timeoutId = null;
    return (...args)=>{
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(()=>{
            callback.apply(null, args);
        }, wait);
    };
};
function $0487332c780ecdcd$var$_createMarkersFromGeoJson(geoJson) {
    $0487332c780ecdcd$var$geoJsonLayer = $0487332c780ecdcd$var$L.geoJSON(geoJson, {
        onEachFeature: $0487332c780ecdcd$var$_drawPopUpMarker,
        pointToLayer: $0487332c780ecdcd$var$_createPointIcon
    });
    $0487332c780ecdcd$var$markers = $0487332c780ecdcd$var$L.markerClusterGroup({
        maxClusterRadius: 30,
        showCoverageOnHover: false,
        iconCreateFunction: $0487332c780ecdcd$var$_createClusterIcon
    });
    $0487332c780ecdcd$var$markers.addLayer($0487332c780ecdcd$var$geoJsonLayer);
    return $0487332c780ecdcd$var$markers;
}
function $0487332c780ecdcd$var$_addLocateButton(map) {
    new (0, $873e4daea7377db1$export$acde3ad4f992a4ae)({
        icon: "icon icon-street-view a4a-locate-icon",
        strings: {
            title: "Localisez moi"
        }
    })?.addTo(map);
}
function $0487332c780ecdcd$var$_addMarkerAtCenterOfSearch(dataset, markers) {
    const around = $0487332c780ecdcd$var$_parseAround(dataset);
    if (around) {
        let aroundPoint = $0487332c780ecdcd$var$L.circleMarker(around.point, {
            color: "#fff",
            fillColor: "#3388ff",
            fillOpacity: 1,
            radius: 9
        }).bindPopup(around.label).addTo($0487332c780ecdcd$var$map);
        markers.addLayer(aroundPoint);
    }
}
function $0487332c780ecdcd$var$broadenSearchOnClick(broaderSearchButton, map, root) {
    broaderSearchButton.addEventListener("click", (event)=>{
        event.preventDefault();
        event.stopPropagation();
        $0487332c780ecdcd$var$shouldTryToBroadenSearchToGetOneResult = true;
        map.setView($0487332c780ecdcd$var$L.latLng(root.dataset.lat, root.dataset.lon), map.getZoom() - 1);
    });
}
function $0487332c780ecdcd$var$refreshMapOnEquipmentsChange(equipmentsInputs, map) {
    document.addEventListener("filterChanged", async function() {
        $0487332c780ecdcd$var$refreshData(map);
        (0, $416ff1ba0b2a05f4$export$2e2bcd8739ae039).refreshSearchURL();
    });
}
function $0487332c780ecdcd$var$_setZoomLevel(map, geoJson) {
    const root = $0487332c780ecdcd$var$_getRoot();
    const municipalityData = JSON.parse(root.querySelector("#commune-data").textContent);
    const departementData = JSON.parse(root.querySelector("#departement-data").textContent);
    if (municipalityData) {
        map.setMinZoom(municipalityData.zoom - 2);
        map.setView(municipalityData.center, municipalityData.zoom);
        if (municipalityData.contour) {
            const poly = $0487332c780ecdcd$var$L.polygon(municipalityData.contour, {
                color: "#075ea2",
                opacity: 0.6,
                weight: 3,
                fillOpacity: 0.05
            });
            poly.addTo(map);
            map.fitBounds(poly.getBounds());
        }
    } else if (departementData) {
        const poly = $0487332c780ecdcd$var$L.polygon(departementData, {
            color: "#075ea2",
            opacity: 0.6,
            weight: 3,
            fillOpacity: 0.05
        });
        poly.addTo(map);
        map.fitBounds(poly.getBounds());
    } else if (geoJson && geoJson.features.length > 0) map.fitBounds($0487332c780ecdcd$var$markers.getBounds(), {
        padding: [
            70,
            70
        ]
    });
    else {
        map.setView($0487332c780ecdcd$var$L.latLng(root.dataset.lat || $0487332c780ecdcd$var$DEFAULT_LAT, root.dataset.lon || $0487332c780ecdcd$var$DEFAULT_LON), root.dataset.defaultZoom || 14);
        $0487332c780ecdcd$var$refreshData(map);
    }
}
function $0487332c780ecdcd$var$AppMap(root) {
    const erpIdentifier = root.dataset.erpIdentifier;
    $0487332c780ecdcd$var$shouldRefreshMap = true;
    if (root.dataset.shouldRefreshOnMapLoad == "False") $0487332c780ecdcd$var$shouldRefreshMap = false;
    const erpData = root.querySelector("#erps-data").textContent;
    const options = root.querySelector("#map-options");
    var mapOptions = {};
    if (options) mapOptions = JSON.parse(options.textContent.trim());
    let geoJson = null;
    if (erpData) geoJson = JSON.parse(erpData);
    $0487332c780ecdcd$var$currentErpIdentifier = erpIdentifier;
    $0487332c780ecdcd$var$map = $0487332c780ecdcd$var$createMap(root, mapOptions);
    $0487332c780ecdcd$var$map.on("contextmenu", $0487332c780ecdcd$var$_displayCustomMenu.bind($0487332c780ecdcd$var$map, root));
    const broaderSearchButton = document.querySelector("#broaderSearch");
    if (broaderSearchButton) $0487332c780ecdcd$var$broadenSearchOnClick(broaderSearchButton, $0487332c780ecdcd$var$map, root);
    const equipmentsInputs = document.querySelectorAll("input[name=equipments]");
    if (equipmentsInputs) $0487332c780ecdcd$var$refreshMapOnEquipmentsChange(equipmentsInputs, $0487332c780ecdcd$var$map);
    if (geoJson) {
        $0487332c780ecdcd$var$markers = $0487332c780ecdcd$var$_createMarkersFromGeoJson(geoJson);
        $0487332c780ecdcd$var$_addMarkerAtCenterOfSearch(root.dataset, $0487332c780ecdcd$var$markers);
        $0487332c780ecdcd$var$map.addLayer($0487332c780ecdcd$var$markers);
        $0487332c780ecdcd$var$refreshList(geoJson);
        $0487332c780ecdcd$var$_loadMoreWhenLastElementIsDisplayed($0487332c780ecdcd$var$map);
    }
    $0487332c780ecdcd$var$_setZoomLevel($0487332c780ecdcd$var$map, geoJson);
    $0487332c780ecdcd$var$_addLocateButton($0487332c780ecdcd$var$map);
    if (erpIdentifier) $0487332c780ecdcd$var$openMarkerPopup(erpIdentifier);
    if (root.dataset.shouldRefresh == "True") $0487332c780ecdcd$var$refreshDataOnMove($0487332c780ecdcd$var$map);
    return $0487332c780ecdcd$var$map;
}
function $0487332c780ecdcd$var$openMarkerPopup(erpIdentifier, options = {}) {
    if (!$0487332c780ecdcd$var$markers) {
        console.warn("No marker clusters were registered, cannot open marker.");
        return;
    }
    $0487332c780ecdcd$var$currentErpIdentifier = erpIdentifier;
    $0487332c780ecdcd$var$layers.forEach((layer)=>{
        if (layer.identifier === erpIdentifier) {
            $0487332c780ecdcd$var$shouldRefreshMap = false;
            layer.__parent._group._map = $0487332c780ecdcd$var$map;
            $0487332c780ecdcd$var$markers.zoomToShowLayer(layer, ()=>{
                layer.openPopup();
            });
        }
    });
}
function $0487332c780ecdcd$var$updateMap(query, map) {
    var mapDomEl = document.querySelector(".a4a-localisation-map");
    var btnSubmit = document.querySelector('[name="contribute"]');
    btnSubmit.setAttribute("disabled", "");
    mapDomEl.style.opacity = 0.3;
    (0, $fffadef9b49322ab$export$2e2bcd8739ae039).getCoordinate(query).then(function(response) {
        var result = response.results[0];
        if (result !== undefined) map.setView({
            lat: result.lat,
            lon: result.lon
        }, 18);
    }).then(function() {
        mapDomEl.style.opacity = 1;
        btnSubmit.removeAttribute("disabled");
    });
}
var $0487332c780ecdcd$export$2e2bcd8739ae039 = {
    AppMap: $0487332c780ecdcd$var$AppMap,
    createMap: $0487332c780ecdcd$var$createMap,
    openMarkerPopup: $0487332c780ecdcd$var$openMarkerPopup,
    recalculateMapSize: $0487332c780ecdcd$var$recalculateMapSize,
    updateMap: $0487332c780ecdcd$var$updateMap
};



var $2e68297c44288967$exports = {};
/*!
 * 
 *   @panoramax/web-viewer v4.0.3
 *   https://gitlab.com/panoramax/clients/web-viewer
 *
 *   Copyright (c) Panoramax team
 *
 *   This source code is licensed under the MIT license found in the
 *   LICENSE file in the root directory of this source tree.
 *
 */ !function(Qe, rt) {
    $2e68297c44288967$exports = rt();
}($2e68297c44288967$exports, ()=>(()=>{
        var Qe = {
            9039: (Qe, rt, Wn)=>{
                "use strict";
                Wn.d(rt, {
                    A: ()=>Basic
                });
                var Co = Wn(4542), Dl = Wn(5254), Ll = Wn(4964), Rl = Wn(8340), Ul = Wn(5995), Gl = Wn(7343), Zl = Wn(2614), Hl = Wn.n(Zl), ql = Wn(8330);
                Wn(1865), Wn(3638);
                class Basic extends Co.WF {
                    constructor(){
                        let Qe = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                        super(), this.users = [
                            "geovisio"
                        ], this.mapstyle = this.getAttribute("mapstyle") || Rl.DEFAULT_TILES, this.lang = this.getAttribute("lang") || null, this.endpoint = this.getAttribute("endpoint") || null, this.picture = this.getAttribute("picture") || null, this.sequence = this.getAttribute("sequence") || null, console.info(`\ud83d\udcf7 Panoramax ${this.getClassName()} - Version ${ql.rE} (06eea2b)\n\n\ud83c\udd98 Issues can be reported at ${ql.Jk.O}`), Qe || (this._isInternetFast = null, (0, Gl.isInternetFast)().then((Qe)=>this._isInternetFast = Qe));
                    }
                    connectedCallback() {
                        super.connectedCallback(), this._t = (0, Ll.getTranslations)(this.lang), this.loader = (0, Ul.createWebComp)("pnx-loader", {
                            _parent: this,
                            "no-label": (0, Gl.isInIframe)()
                        }), this._loadsAPI && this.endpoint && this._loadsAPI === this.endpoint || this.api && this.api._endpoint === this.endpoint || !this.endpoint || ((this._loadsAPI || this.api) && (delete this.api, delete this._loadsAPI), this._setupAPI());
                    }
                    _setupAPI() {
                        if (this.loader = this.loader || (0, Ul.createWebComp)("pnx-loader", {
                            _parent: this
                        }), !this.endpoint) return void console.warn("No endpoint is defined");
                        this._loadsAPI = this.endpoint;
                        let Qe = this.endpoint;
                        try {
                            this.mapstyle = JSON.parse(this.mapstyle);
                        } catch (Wn) {}
                        try {
                            this.api = new Dl.A(this.endpoint, {
                                users: this.users,
                                fetch: this.fetchOptions,
                                style: this.mapstyle
                            }), this.api.onceReady().then(()=>{
                                if (Qe != this._loadsAPI || !this.api) return;
                                let rt = this.api.getUnavailableFeatures(), Wn = this.api.getAvailableFeatures();
                                Wn = 0 === rt.length ? "\u2705 All features available" : "\u2705 Available features: " + Wn.join(", "), rt = 0 === rt.length ? "" : "\ud83d\udeab Unavailable features: " + rt.join(", "), console.info(`\ud83c\udf10 Connected to API "${this.api._metadata.name}" (${this.api._endpoint})\n\u2139\ufe0f API runs STAC ${this.api._metadata.stac_version} ${this.api._metadata.geovisio_version ? "& GeoVisio " + this.api._metadata.geovisio_version : ""}\n   ${Wn}\n   ${rt}\n`.trim());
                            }).catch((Qe)=>this.loader.dismiss(Qe, this._t.pnx.error_api)).finally(()=>delete this._loadsAPI);
                        } catch (Wn) {
                            var rt;
                            delete this._loadsAPI, null !== (rt = this.loader) && void 0 !== rt && rt.dismiss ? this.loader.dismiss(Wn, this._t.pnx.error_api) : console.error(Wn);
                        }
                    }
                    onceReady() {
                        throw new Error("You must override this method on sub-class");
                    }
                    onceAPIReady() {
                        return this.api ? this.api.onceReady() : new Promise((Qe)=>setTimeout(Qe, 100)).then(this.onceAPIReady.bind(this));
                    }
                    createRenderRoot() {
                        return this;
                    }
                    attributeChangedCallback(Qe, rt, Wn) {
                        if (super.attributeChangedCallback(Qe, rt, Wn), "endpoint" === Qe && (this._loadsAPI && Wn && this._loadsAPI === Wn || this.api && this.api._endpoint === Wn || !Wn || ((this._loadsAPI || this.api) && (delete this.api, delete this._loadsAPI), this._setupAPI())), [
                            "picture",
                            "sequence"
                        ].includes(Qe)) {
                            let Co, Dl, Ll, Rl;
                            "picture" === Qe ? (Co = this.sequence, Ll = this.sequence, Dl = Wn, Rl = rt) : (Co = Wn, Ll = rt, Dl = this.picture, Rl = this.picture), this.dispatchEvent(new CustomEvent("select", {
                                bubbles: !0,
                                composed: !0,
                                detail: {
                                    seqId: Co,
                                    picId: Dl,
                                    prevSeqId: Ll,
                                    prevPicId: Rl
                                }
                            }));
                        }
                    }
                    getClassName() {
                        return "Basic";
                    }
                    select() {
                        let Qe = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null, rt = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
                        arguments.length > 2 && void 0 !== arguments[2] && arguments[2] && (this.picture = null, this.sequence = null), this.picture = rt, this.sequence = Qe;
                    }
                    isWidthSmall() {
                        return (null === this || void 0 === this ? void 0 : this.offsetWidth) < 576;
                    }
                    isHeightSmall() {
                        return (null === this || void 0 === this ? void 0 : this.offsetHeight) < 400;
                    }
                    render() {
                        return Co.qy`<p>Should not be used directly, use Viewer/CoverageMap/Editor instead</p>`;
                    }
                    getSubComponentsNames() {
                        return [
                            "loader",
                            "api"
                        ];
                    }
                    addEventListener(Qe, rt, Wn) {
                        let Co = Qe.split(":").shift();
                        if (Co && this.getSubComponentsNames().includes(Co)) {
                            var Dl;
                            const Ll = Qe.substring(Co.length + 1);
                            null !== (Dl = this[Co]) && void 0 !== Dl && Dl.addEventListener ? this[Co].addEventListener(Ll, rt, Wn) : setTimeout(()=>this.addEventListener(Qe, rt, Wn), 50);
                        } else super.addEventListener(Qe, rt, Wn);
                    }
                    static GetJSONConverter() {
                        return {
                            fromAttribute: (Qe)=>"object" === typeof Qe ? Qe : Hl().parse(Qe),
                            toAttribute: (Qe)=>JSON.stringify(Qe)
                        };
                    }
                }
                Basic.properties = {
                    picture: {
                        type: String,
                        reflect: !0
                    },
                    sequence: {
                        type: String,
                        reflect: !0
                    },
                    fetchOptions: {
                        converter: Basic.GetJSONConverter()
                    },
                    users: {
                        type: Array,
                        reflect: !0
                    },
                    mapstyle: {
                        type: String
                    },
                    lang: {
                        type: String
                    },
                    endpoint: {
                        type: String
                    }
                };
            },
            153: (Qe, rt, Wn)=>{
                "use strict";
                Wn.d(rt, {
                    A: ()=>CoverageMap
                });
                var Co = Wn(9039), Dl = Wn(5642), Ll = Wn(8340), Rl = Wn(927), Ul = (Wn(7776), Wn(2118));
                class CoverageMap extends Co.A {
                    constructor(){
                        super(), this._mapContainer = document.createElement("div"), this.onceAPIReady().then(()=>{
                            this.loader.setAttribute("value", 30), this._initParams = new Ul.Ay(Ul.Ay.GetComponentProperties(CoverageMap, this)), this._initMap();
                        });
                    }
                    getClassName() {
                        return "CoverageMap";
                    }
                    onceReady() {
                        return this.map && this.map.waitForEnoughMapLoaded ? this.map.waitForEnoughMapLoaded() : new Promise((Qe)=>setTimeout(Qe, 100)).then(this.onceReady.bind(this));
                    }
                    render() {
                        return [
                            this.loader,
                            this._mapContainer
                        ];
                    }
                    getSubComponentsNames() {
                        const Qe = super.getSubComponentsNames();
                        return Qe.push("map"), Qe;
                    }
                    _initMap() {
                        class MyMap extends Dl.A {
                            _getLayerStyleProperties(Qe) {
                                return "pictures_symbols" === Qe ? {
                                    layout: {
                                        visibility: "none"
                                    }
                                } : super._getLayerStyleProperties(Qe);
                            }
                        }
                        this.map = new MyMap(this, this._mapContainer, Object.assign({}, this._initParams.getMapInit(), {
                            hash: !0
                        })), this.map.addControl(new Rl.NavigationControl({
                            showCompass: !1
                        })), this.loader.setAttribute("value", 70), this.addEventListener("select", this._onSelect.bind(this)), this.map.on("picture-click", (Qe)=>this.select(Qe.seqId, Qe.picId)), this.map.on("sequence-click", (Qe)=>this.select(Qe.seqId)), this.map.waitForEnoughMapLoaded().then(async ()=>{
                            await (0, Ul.mK)(this.map, this._initParams.getMapPostInit()), this.map.reloadLayersStyles(), this.loader.dismiss();
                        });
                    }
                    _onSelect(Qe) {
                        if (Qe.detail.picId || Qe.detail.seqId) {
                            const rt = Qe.detail.picId ? "pictures" : "sequences", Wn = this.map.queryRenderedFeatures({
                                layers: [
                                    ...this.map._userLayers
                                ].map((Qe)=>(0, Ll.getUserLayerId)(Qe, rt)),
                                filter: [
                                    "==",
                                    [
                                        "get",
                                        "id"
                                    ],
                                    Qe.detail.picId || Qe.detail.seqId
                                ]
                            });
                            Wn.length >= 0 && null != Wn[0] && this.map._attachPreviewToPictures({
                                features: Wn
                            }, rt);
                        }
                    }
                }
                CoverageMap.properties = {
                    map: {
                        converter: Co.A.GetJSONConverter()
                    },
                    ...Co.A.properties
                }, customElements.define("pnx-coverage-map", CoverageMap);
            },
            1752: (Qe, rt, Wn)=>{
                "use strict";
                Wn.d(rt, {
                    A: ()=>Editor
                });
                Wn(7365);
                var Co = Wn(9039), Dl = Wn(5642), Ll = Wn(9048), Rl = (Wn(7534), Wn(6810), Wn(508)), Ul = Wn(8340), Gl = Wn(1545), Zl = (Wn(4542), Wn(5995));
                const Hl = "sequence-headings";
                class Editor extends Co.A {
                    constructor(){
                        super(), this.raster = null, this.background = "streets", this.users = [], this._psvContainer = document.createElement("div"), this._mapContainer = document.createElement("div"), this.onceAPIReady().then(()=>{
                            this.loader.setAttribute("value", 30), this.sequence || this.loader.dismiss({}, "No sequence is selected"), this.addEventListener("select", this._onSelect.bind(this)), this._initPSV(), this._initMap();
                        });
                    }
                    getClassName() {
                        return "Editor";
                    }
                    onceReady() {
                        var Qe, rt;
                        return this.map && this.psv && null !== (Qe = (rt = this.map).loaded) && void 0 !== Qe && Qe.call(rt) ? Promise.resolve() : new Promise((Qe)=>setTimeout(Qe, 100)).then(this.onceReady.bind(this));
                    }
                    connectedCallback() {
                        Array.isArray(this.users) && this.users.length > 0 && (console.warn("Parameters users can't be changed in Editor, only selected sequence can be visible"), this.users = []), super.connectedCallback();
                    }
                    attributeChangedCallback(Qe, rt, Wn) {
                        "users" === Qe && Array.isArray(Wn) && Wn.length > 0 ? console.warn("Parameters users can't be changed in Editor, only selected sequence can be visible") : super.attributeChangedCallback(Qe, rt, Wn);
                    }
                    render() {
                        return [
                            this.loader,
                            this._psvContainer,
                            this._mapContainer
                        ];
                    }
                    getSubComponentsNames() {
                        return super.getSubComponentsNames().concat([
                            "map",
                            "psv"
                        ]);
                    }
                    _initPSV() {
                        try {
                            this.psv = new Ll.Ay(this, this._psvContainer), this.psv._myVTour.datasource.nodeResolver = this._getNode.bind(this);
                        } catch (Qe) {
                            let rt = Gl.IJ.isWebGLSupported ? this._t.pnx.error_psv : this._t.pnx.error_webgl;
                            this.loader.dismiss(Qe, rt);
                        }
                    }
                    _initMap() {
                        try {
                            this.map = new Dl.A(this, this._mapContainer, {
                                raster: this.raster,
                                background: this.background,
                                supplementaryStyle: this._createMapStyle(),
                                zoom: 15
                            }), (0, Ul.linkMapAndPhoto)(this), this.loader.setAttribute("value", 50), this._loadSequence(), this.map.once("load", ()=>{
                                this.map.hasTwoBackgrounds() && this._addMapBackgroundWidget(), this._bindPicturesEvents();
                            });
                            const Qe = this.map._picMarker.setRotation.bind(this.map._picMarker);
                            this.map._picMarker.setRotation = (rt)=>(rt = void 0 === this._lastRelHeading ? rt : rt + this._lastRelHeading - this.psv.getPictureRelativeHeading(), Qe(rt));
                        } catch (Qe) {
                            this.loader.dismiss(Qe, this._t.pnx.error_psv);
                        }
                    }
                    _createMapStyle() {
                        return {
                            sources: {
                                geovisio_editor_sequences: {
                                    type: "geojson",
                                    data: {
                                        type: "FeatureCollection",
                                        features: []
                                    }
                                }
                            },
                            layers: [
                                {
                                    id: "geovisio_editor_sequences",
                                    type: "line",
                                    source: "geovisio_editor_sequences",
                                    layout: {
                                        ...Ul.VECTOR_STYLES.SEQUENCES.layout
                                    },
                                    paint: {
                                        ...Ul.VECTOR_STYLES.SEQUENCES.paint
                                    }
                                },
                                {
                                    id: "geovisio_editor_pictures",
                                    type: "circle",
                                    source: "geovisio_editor_sequences",
                                    layout: {
                                        ...Ul.VECTOR_STYLES.PICTURES.layout
                                    },
                                    paint: {
                                        ...Ul.VECTOR_STYLES.PICTURES.paint
                                    }
                                }
                            ]
                        };
                    }
                    _bindPicturesEvents() {
                        this.map.on("mousemove", "geovisio_editor_pictures", ()=>{
                            this.map.getCanvas().style.cursor = "pointer";
                        }), this.map.on("mouseleave", "geovisio_editor_pictures", ()=>{
                            this.map.getCanvas().style.cursor = "";
                        }), this.map.on("click", "geovisio_editor_pictures", this.map._onPictureClick.bind(this.map));
                    }
                    _loadSequence() {
                        return this.loader.setAttribute("value", 60), this.api.getSequenceItems(this.sequence).then((Qe)=>{
                            if (this.loader.setAttribute("value", 80), this.map.once("sourcedata", ()=>{
                                this.map.setPaintProperty("geovisio_editor_sequences", "line-color", this.map._getLayerColorStyle("sequences")), this.map.setPaintProperty("geovisio_editor_pictures", "circle-color", this.map._getLayerColorStyle("pictures")), this.map.setLayoutProperty("geovisio_editor_sequences", "visibility", "visible"), this.map.setLayoutProperty("geovisio_editor_pictures", "visibility", "visible"), this.map.once("styledata", ()=>this.loader.dismiss());
                            }), this._sequenceData = Qe.features, this.map.getSource("geovisio_editor_sequences").setData({
                                type: "FeatureCollection",
                                features: [
                                    {
                                        type: "Feature",
                                        properties: {
                                            id: this.sequence
                                        },
                                        geometry: {
                                            type: "LineString",
                                            coordinates: Qe.features.map((Qe)=>Qe.geometry.coordinates)
                                        }
                                    },
                                    ...Qe.features.map((Qe)=>(Qe.properties.id = Qe.id, Qe.properties.sequences = [
                                            this.sequence
                                        ], Qe))
                                ]
                            }), this.picture) {
                                const rt = Qe.features.find((Qe)=>Qe.id === this.picture);
                                rt ? (this.select(this.sequence, this.picture, !0), this.map.jumpTo({
                                    center: rt.geometry.coordinates,
                                    zoom: 18
                                })) : console.log("Picture with ID", rt, "was not found");
                            } else {
                                const rt = [
                                    ...Qe.features[0].geometry.coordinates,
                                    ...Qe.features[0].geometry.coordinates
                                ];
                                for(let Wn = 1; Wn < Qe.features.length; Wn++){
                                    const Co = Qe.features[Wn].geometry.coordinates;
                                    Co[0] < rt[0] && (rt[0] = Co[0]), Co[1] < rt[1] && (rt[1] = Co[1]), Co[0] > rt[2] && (rt[2] = Co[0]), Co[1] > rt[3] && (rt[3] = Co[1]);
                                }
                                this.map.fitBounds(rt, {
                                    animate: !1
                                });
                            }
                        }).catch((Qe)=>this.loader.dismiss(Qe, this._t.pnx.error_api));
                    }
                    _getNode(Qe) {
                        const rt = this._sequenceData.find((rt)=>rt.properties.id === Qe), Wn = rt ? (0, Rl.apiFeatureToPSVNode)(rt, this._t, this._isInternetFast) : null;
                        return Wn && delete Wn.links, Wn;
                    }
                    _addMapBackgroundWidget() {
                        const Qe = (0, Zl.createWebComp)("pnx-map-background", {
                            _parent: this,
                            size: "sm"
                        });
                        this._mapContainer.appendChild(Qe);
                    }
                    previewSequenceHeadingChange(Qe) {
                        const rt = void 0 !== this.map.getLayer(Hl);
                        if (this.map._picMarkerPreview.remove(), void 0 === Qe) return delete this._lastRelHeading, rt && this.map.setLayoutProperty(Hl, "visibility", "none"), void (this.picture && this.map._picMarker.setRotation(this.psv.getXY().x));
                        this._lastRelHeading = Qe, rt || this.map.addLayer({
                            id: Hl,
                            type: "symbol",
                            source: "geovisio_editor_sequences",
                            layout: {
                                "icon-image": "pnx-marker",
                                "icon-overlap": "always",
                                "icon-size": .8
                            }
                        });
                        const Wn = -this.psv.getPictureRelativeHeading();
                        this.map.setLayoutProperty(Hl, "visibility", "visible"), this.map.setLayoutProperty(Hl, "icon-rotate", [
                            "+",
                            [
                                "get",
                                "view:azimuth"
                            ],
                            Wn,
                            Qe
                        ]);
                        const Co = [
                            [
                                "==",
                                [
                                    "geometry-type"
                                ],
                                "Point"
                            ]
                        ];
                        this.picture && Co.push([
                            "!=",
                            [
                                "get",
                                "id"
                            ],
                            this.picture
                        ]), this.map.setFilter(Hl, [
                            "all",
                            ...Co
                        ]), this.picture && this.map._picMarker.setRotation(this.psv.getXY().x);
                    }
                    _onSelect() {
                        void 0 !== this._lastRelHeading && this.previewSequenceHeadingChange(this._lastRelHeading);
                    }
                }
                Editor.properties = {
                    raster: {
                        converter: Co.A.GetJSONConverter()
                    },
                    background: {
                        type: String
                    },
                    ...Co.A.properties
                }, customElements.define("pnx-editor", Editor);
            },
            3407: (Qe, rt, Wn)=>{
                "use strict";
                Wn.d(rt, {
                    A: ()=>PhotoViewer
                });
                Wn(970);
                var Co = Wn(1545), Dl = Wn(4451), Ll = Wn(9039), Rl = Wn(9048), Ul = Wn(5995), Gl = Wn(7343), Zl = Wn(2118), Hl = Wn(4207);
                const ql = Math.PI / 6;
                class PhotoViewer extends Ll.A {
                    constructor(){
                        super(), this.psv = {}, this["url-parameters"] = this.getAttribute("url-parameters") || !0, this.widgets = this.getAttribute("widgets") || "true", this.grid = (0, Ul.createWebComp)("pnx-cornered-grid"), this.psvContainer = document.createElement("div"), this.psvContainer.setAttribute("slot", "bg"), this.grid.appendChild(this.psvContainer), this.popup = (0, Ul.createWebComp)("pnx-popup", {
                            _parent: this,
                            onclose: this._onPopupClose.bind(this)
                        });
                    }
                    _createInitParamsHandler() {
                        var Qe, rt;
                        this._initParams = new Zl.Ay(Zl.Ay.GetComponentProperties(PhotoViewer, this), Object.assign({}, null === (Qe = this.urlHandler) || void 0 === Qe ? void 0 : Qe.currentURLParams(), null === (rt = this.urlHandler) || void 0 === rt ? void 0 : rt.currentURLParams(!0)), {});
                    }
                    _initWidgets() {
                        "false" !== this._initParams.getParentPostInit().widgets && (this.grid.appendChild((0, Ul.createWebComp)("pnx-widget-player", {
                            slot: "top",
                            _parent: this,
                            class: "pnx-only-psv pnx-print-hidden",
                            size: this.isHeightSmall() ? "md" : "xl"
                        })), this.isWidthSmall() ? (this.legend = (0, Ul.createWebComp)("pnx-picture-legend", {
                            _parent: this
                        }), this.bottomDrawer = (0, Ul.createWebComp)("pnx-bottom-drawer", {
                            slot: "bottom",
                            _parent: this,
                            class: this._initParams.getParentPostInit().picture ? void 0 : "pnx-hidden"
                        }), this.bottomDrawer.appendChild(this.legend), this.grid.appendChild(this.bottomDrawer), this.addEventListener("select", (Qe)=>{
                            (0, Gl.isNullId)(Qe.detail.picId) ? this.bottomDrawer.classList.add("pnx-hidden") : this.bottomDrawer.classList.remove("pnx-hidden");
                        })) : (this.legend = (0, Ul.createWebComp)("pnx-widget-legend", {
                            slot: this.isWidthSmall() ? void 0 : "top-left",
                            _parent: this,
                            focus: this._initParams.getParentPostInit().focus,
                            picture: this._initParams.getParentPostInit().picture
                        }), this.grid.appendChild((0, Ul.createWebComp)("pnx-widget-zoom", {
                            slot: "bottom-right",
                            class: "pnx-print-hidden",
                            _parent: this
                        })), this.grid.appendChild(this.legend), this.grid.appendChild((0, Ul.createWebComp)("pnx-hashtags", {
                            slot: "top-right",
                            _parent: this,
                            class: "pnx-only-psv pnx-print-hidden"
                        }))));
                    }
                    connectedCallback() {
                        super.connectedCallback(), this.presetsManager = new Hl.A(this.lang), this["url-parameters"] && "false" !== this["url-parameters"] && (this.urlHandler = new Dl.A(this), this.onceReady().then(()=>{
                            this.urlHandler.listenToChanges(), this.urlHandler._onParentChange();
                        })), this.onceAPIReady().then(this._postAPIInit.bind(this));
                    }
                    firstUpdated() {
                        super.firstUpdated(), this._moveChildToGrid();
                    }
                    getClassName() {
                        return "PhotoViewer";
                    }
                    onceReady() {
                        return this.oncePSVReady().then(()=>this._initParams.getParentPostInit().picture && !this.psv.getPictureMetadata() ? this.onceFirstPicLoaded() : Promise.resolve());
                    }
                    render() {
                        return [
                            this.loader,
                            this.grid,
                            this.popup
                        ];
                    }
                    getSubComponentsNames() {
                        return super.getSubComponentsNames().concat([
                            "psv",
                            "grid",
                            "popup",
                            "urlHandler"
                        ]);
                    }
                    oncePSVReady() {
                        let Qe;
                        return new Promise((rt)=>{
                            Qe = setInterval(()=>{
                                this.psv && "object" === typeof this.psv && (this.psv.container ? (clearInterval(Qe), rt()) : this.psv.addEventListener && this.psv.addEventListener("ready", ()=>{
                                    clearInterval(Qe), rt();
                                }, {
                                    once: !0
                                }));
                            }, 250);
                        });
                    }
                    onceFirstPicLoaded() {
                        return this.oncePSVReady().then(()=>this.psv.getPictureMetadata() ? Promise.resolve() : new Promise((Qe)=>{
                                this.psv.addEventListener("picture-loaded", Qe, {
                                    once: !0
                                });
                            }));
                    }
                    async _postAPIInit() {
                        this.loader.setAttribute("value", 30), this._createInitParamsHandler();
                        const Qe = this._initParams.getParentPostInit();
                        this._initPSV(), this._initWidgets(), (0, Zl.ai)(this, Qe), this._handleKeyboardManagement(), Qe.picture ? this.psv.addEventListener("picture-loaded", ()=>this.loader.dismiss(), {
                            once: !0
                        }) : this.loader.dismiss();
                    }
                    _initPSV() {
                        try {
                            this.psv = new Rl.Ay(this, this.psvContainer, {
                                shouldGoFast: this._psvShouldGoFast.bind(this),
                                keyboard: "always",
                                keyboardActions: {
                                    ...Co.zY.keyboardActions,
                                    8: "ROTATE_UP",
                                    2: "ROTATE_DOWN",
                                    4: "ROTATE_LEFT",
                                    6: "ROTATE_RIGHT",
                                    PageUp: ()=>this.psv.goToNextPicture(),
                                    9: ()=>this.psv.goToNextPicture(),
                                    PageDown: ()=>this.psv.goToPrevPicture(),
                                    3: ()=>this.psv.goToPrevPicture(),
                                    5: ()=>this.moveCenter(),
                                    "*": ()=>this.moveCenter(),
                                    Home: ()=>this._toggleFocus(),
                                    7: ()=>this._toggleFocus(),
                                    End: ()=>this.mini.toggleAttribute("collapsed"),
                                    1: ()=>this.mini.toggleAttribute("collapsed"),
                                    " ": ()=>this.psv.toggleSequencePlaying(),
                                    0: ()=>this.psv.toggleSequencePlaying()
                                },
                                ...this._initParams.getPSVInit()
                            }), this.oncePSVReady().then(()=>{
                                this.loader.setAttribute("value", 50), (0, Zl.Vy)(this.psv, this._initParams.getPSVPostInit());
                            });
                        } catch (Qe) {
                            let rt = Co.IJ.isWebGLSupported ? this._t.pnx.error_psv : this._t.pnx.error_webgl;
                            this.loader.dismiss(Qe, rt);
                        }
                    }
                    _handleKeyboardManagement() {
                        const keytonone = ()=>this.psv.stopKeyboardControl(), keytopsv = ()=>this.psv.startKeyboardControl();
                        this.popup.addEventListener("open", ()=>keytonone()), this.popup.addEventListener("close", ()=>keytopsv());
                        for (let Qe of this.grid.childNodes)"bg" !== Qe.getAttribute("slot") && (Qe.addEventListener("focusin", ()=>keytonone()), Qe.addEventListener("focusout", ()=>{
                            null === this.popup.getAttribute("visible") && keytopsv();
                        }));
                    }
                    _psvShouldGoFast() {
                        return this.psv._sequencePlaying && this.psv.getTransitionDuration() < 1e3;
                    }
                    _moveChildToGrid() {
                        Array.from(this.querySelectorAll("[slot]")).forEach((Qe)=>{
                            var rt;
                            null !== (rt = Qe.tagName) && void 0 !== rt && rt.toLowerCase().startsWith("pnx-") && (Qe._parent = this, Qe._t = this._t), "editors" === Qe.getAttribute("slot") ? this.onceReady().then(()=>{
                                var rt;
                                return null === (rt = this.legend) || void 0 === rt ? void 0 : rt.appendChild(Qe);
                            }) : this.grid.appendChild(Qe);
                        });
                    }
                    setPopup(Qe) {
                        let rt = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
                        Qe ? this.popup.setAttribute("visible", "") : this.popup.removeAttribute("visible"), this.popup.innerHTML = "", "string" === typeof rt ? this.popup.innerHTML = rt : Array.isArray(rt) && rt.forEach((Qe)=>this.popup.appendChild(Qe));
                    }
                    _onPopupClose() {
                        this.dispatchEvent(new CustomEvent("focus-changed", {
                            detail: {
                                focus: this.map && this.isMapWide() ? "map" : "pic"
                            }
                        }));
                    }
                    _showQualityScoreDoc() {
                        this.setPopup(!0, [
                            (0, Ul.createWebComp)("pnx-quality-score-doc", {
                                _t: this._t
                            })
                        ]);
                    }
                    _showReportForm() {
                        if (!this.psv.getPictureMetadata()) throw new Error("No picture currently selected");
                        this.setPopup(!0, [
                            (0, Ul.createWebComp)("pnx-report-form", {
                                _parent: this
                            })
                        ]);
                    }
                    _showShareOptions() {
                        this.setPopup(!0, [
                            (0, Ul.createWebComp)("pnx-share-menu", {
                                _parent: this
                            })
                        ]);
                    }
                    moveCenter() {
                        this.psv.getPictureMetadata() && this._psvAnimate({
                            speed: Rl.LM,
                            yaw: 0,
                            pitch: 0,
                            zoom: Rl.cS
                        });
                    }
                    moveLeft() {
                        this._moveToDirection("left");
                    }
                    moveRight() {
                        this._moveToDirection("right");
                    }
                    moveUp() {
                        this._moveToDirection("up");
                    }
                    moveDown() {
                        this._moveToDirection("down");
                    }
                    _moveToDirection(Qe) {
                        let rt = this.psv.getPosition();
                        switch(Qe){
                            case "up":
                                rt.pitch += ql;
                                break;
                            case "left":
                                rt.yaw -= ql;
                                break;
                            case "down":
                                rt.pitch -= ql;
                                break;
                            case "right":
                                rt.yaw += ql;
                        }
                        this._psvAnimate({
                            speed: Rl.LM,
                            ...rt
                        });
                    }
                    _psvAnimate(Qe) {
                        this._lastPsvAnim && this._lastPsvAnim.cancel(), this._lastPsvAnim = this.psv.animate(Qe);
                    }
                    addEventListener(Qe, rt, Wn) {
                        super.addEventListener(Qe, rt, Wn);
                    }
                }
                PhotoViewer.properties = {
                    psv: {
                        converter: Ll.A.GetJSONConverter()
                    },
                    widgets: {
                        type: String
                    },
                    "url-parameters": {
                        type: String
                    },
                    ...Ll.A.properties
                }, customElements.define("pnx-photo-viewer", PhotoViewer);
            },
            8743: (Qe, rt, Wn)=>{
                "use strict";
                Wn.d(rt, {
                    $: ()=>Ql,
                    A: ()=>Viewer
                });
                Wn(9616);
                var Co = Wn(8340), Dl = Wn(3407), Ll = (Wn(9039), Wn(2771)), Rl = Wn(7343), Ul = Wn(5995), Gl = Wn(9683), Zl = Wn(2e3), Hl = Wn(9438), ql = Wn(2118);
                const Ql = 20, Kl = (Math.PI, 100);
                class Viewer extends Dl.A {
                    constructor(){
                        super(), this.map = !0, this.geocoder = this.getAttribute("geocoder") || "nominatim", this.mini = (0, Ul.createWebComp)("pnx-mini", {
                            slot: "bottom-left",
                            _parent: this,
                            onexpand: this._onMiniExpand.bind(this),
                            collapsed: !!(0, Rl.isNullId)(this.picture) || void 0
                        }), this.mini.addEventListener("expand", this._toggleFocus.bind(this)), this.grid.appendChild(this.mini), this.mapContainer = document.createElement("div");
                    }
                    _createInitParamsHandler() {
                        var Qe, rt;
                        this._initParams = new ql.Ay(ql.Ay.GetComponentProperties(Viewer, this), Object.assign({}, null === (Qe = this.urlHandler) || void 0 === Qe ? void 0 : Qe.currentURLParams(), null === (rt = this.urlHandler) || void 0 === rt ? void 0 : rt.currentURLParams(!0)), {
                            map: (0, Co.getMapParamsFromLocalStorage)()
                        });
                    }
                    _initWidgets() {
                        var Qe, rt;
                        "false" !== this._initParams.getParentPostInit().widgets && (this.grid.appendChild((0, Ul.createWebComp)("pnx-widget-zoom", {
                            slot: this.isWidthSmall() ? "top-left" : "bottom-right",
                            class: this.isWidthSmall() ? "pnx-only-map pnx-print-hidden" : "pnx-print-hidden",
                            _parent: this
                        })), this.isWidthSmall() ? (this.legend = (0, Ul.createWebComp)("pnx-picture-legend", {
                            _parent: this
                        }), this.bottomDrawer = (0, Ul.createWebComp)("pnx-bottom-drawer", {
                            slot: "bottom",
                            _parent: this,
                            class: this._initParams.getParentPostInit().picture ? void 0 : "pnx-hidden"
                        }), this.bottomDrawer.appendChild(this.legend), this.grid.appendChild(this.bottomDrawer), this.addEventListener("select", (Qe)=>{
                            (0, Rl.isNullId)(Qe.detail.picId) ? this.bottomDrawer.classList.add("pnx-hidden") : this.bottomDrawer.classList.remove("pnx-hidden");
                        })) : (this.legend = (0, Ul.createWebComp)("pnx-widget-legend", {
                            slot: this.isWidthSmall() ? "top" : "top-left",
                            _parent: this,
                            focus: this._initParams.getParentPostInit().focus,
                            picture: this._initParams.getParentPostInit().picture
                        }), this.grid.appendChild(this.legend), this.grid.appendChild((0, Ul.createWebComp)("pnx-hashtags", {
                            slot: "top-right",
                            _parent: this,
                            class: "pnx-only-psv pnx-print-hidden"
                        }))), this.grid.appendChild((0, Ul.createWebComp)("pnx-widget-player", {
                            slot: "top",
                            _parent: this,
                            class: "pnx-only-psv pnx-print-hidden",
                            size: this.isHeightSmall() ? "md" : "xl"
                        })), this.grid.appendChild((0, Ul.createWebComp)("pnx-widget-geosearch", {
                            slot: this.isWidthSmall() ? "top-right" : "top-left",
                            _parent: this,
                            class: "pnx-only-map pnx-print-hidden",
                            geocoder: this._initParams.getParentPostInit().geocoder
                        })), this.grid.appendChild((0, Ul.createWebComp)("pnx-widget-mapfilters", {
                            slot: this.isWidthSmall() ? "top-right" : "top-left",
                            _parent: this,
                            "user-search": null !== this.api._endpoints.user_search && null !== this.api._endpoints.user_tiles,
                            "quality-score": (null === (Qe = this.map) || void 0 === Qe || null === (rt = Qe._hasQualityScore) || void 0 === rt ? void 0 : rt.call(Qe)) || !1,
                            class: "pnx-only-map pnx-print-hidden"
                        })), this.grid.appendChild((0, Ul.createWebComp)("pnx-widget-maplayers", {
                            slot: "top-right",
                            _parent: this,
                            class: "pnx-only-map pnx-print-hidden"
                        })));
                    }
                    getClassName() {
                        return "Viewer";
                    }
                    getSubComponentsNames() {
                        return super.getSubComponentsNames().concat([
                            "mini",
                            "map"
                        ]);
                    }
                    onceReady() {
                        return Promise.all([
                            this.oncePSVReady(),
                            this.onceMapReady()
                        ]).then(()=>this._initParams.getParentPostInit().picture && !this.psv.getPictureMetadata() ? this.onceFirstPicLoaded() : Promise.resolve());
                    }
                    attributeChangedCallback(Qe, rt, Wn) {
                        var Co, Dl, Ll, Ul;
                        (super.attributeChangedCallback(Qe, rt, Wn), "picture" === Qe) && (null === (Co = this.legend) || void 0 === Co || null === (Dl = Co.setAttribute) || void 0 === Dl || Dl.call(Co, "picture", Wn), (0, Rl.isNullId)(rt) && !(0, Rl.isNullId)(Wn) && this.mini.removeAttribute("collapsed"), (0, Rl.isNullId)(Wn) ? this.map && this.isMapWide() ? this.mini.classList.add("pnx-hidden") : this.map && !this.isMapWide() && this._setFocus("map") : (this.mini.classList.remove("pnx-hidden"), (0, Rl.isNullId)(rt) && (this._setFocus("pic"), "closed" === (null === (Ll = this.bottomDrawer) || void 0 === Ll || null === (Ul = Ll.getAttribute) || void 0 === Ul ? void 0 : Ul.call(Ll, "openness")) && this.bottomDrawer.setAttribute("openness", "half-opened"))));
                        "focus" === Qe && this._setFocus(Wn);
                    }
                    onceMapReady() {
                        if (!this.map) return Promise.resolve();
                        let Qe;
                        return new Promise((rt)=>{
                            Qe = setInterval(()=>{
                                var Wn, Co, Dl;
                                "object" === typeof this.map && (null !== (Wn = this.map) && void 0 !== Wn && null !== (Co = Wn.loaded) && void 0 !== Co && Co.call(Wn) ? (clearInterval(Qe), rt()) : null !== (Dl = this.map) && void 0 !== Dl && Dl.once && this.map.once("render", ()=>{
                                    clearInterval(Qe), rt();
                                }));
                            }, 250);
                        });
                    }
                    async _initMap() {
                        await new Promise((Qe)=>{
                            this.map = new Ll.A(this, this.mapContainer, this._initParams.getMapInit()), (0, Co.saveMapParamsToLocalStorage)(this.map), this.map.once("users-changed", ()=>{
                                this.loader.setAttribute("value", 75), Qe();
                            });
                        }), await (0, ql.mK)(this.map, this._initParams.getMapPostInit()), (0, Co.initMapKeyboardHandler)(this), (0, Co.linkMapAndPhoto)(this);
                    }
                    async _postAPIInit() {
                        this.loader.setAttribute("value", 30), this._createInitParamsHandler();
                        const Qe = this._initParams.getParentPostInit();
                        this._initPSV(), await this._initMap(), this._initWidgets(), this._moveChildToGrid(), (0, ql.iz)(this, Qe), this._handleKeyboardManagement(), Qe.picture ? this.psv.addEventListener("picture-loaded", ()=>{
                            (0, ql.iz)(this, Qe), this.loader.dismiss();
                        }, {
                            once: !0
                        }) : this.loader.dismiss();
                    }
                    _handleKeyboardManagement() {
                        const keytomap = ()=>{
                            this.psv.stopKeyboardControl(), this.map.keyboard.enable();
                        }, keytopsv = ()=>{
                            this.psv.startKeyboardControl(), this.map.keyboard.disable();
                        }, keytonone = ()=>{
                            this.psv.stopKeyboardControl(), this.map.keyboard.disable();
                        }, keytofocused = ()=>{
                            this.map && this.isMapWide() ? keytomap() : keytopsv();
                        };
                        this.addEventListener("focus-changed", (Qe)=>{
                            "map" === Qe.detail.focus && keytomap(), this.popup.getAttribute("visible") ? keytonone() : keytopsv();
                        }), this.popup.addEventListener("open", ()=>keytonone()), this.popup.addEventListener("close", ()=>keytofocused());
                        for (let Qe of this.grid.childNodes)"bg" !== Qe.getAttribute("slot") && (Qe.addEventListener("focusin", ()=>keytonone()), Qe.addEventListener("focusout", ()=>{
                            null === this.popup.getAttribute("visible") && keytofocused();
                        }));
                    }
                    moveCenter() {
                        const Qe = this.psv.getPictureMetadata();
                        Qe && (this.map && this.isMapWide() ? this.map.flyTo({
                            center: Qe.gps,
                            zoom: 20
                        }) : super.moveCenter());
                    }
                    _moveToDirection(Qe) {
                        if (this.map && this.isMapWide()) {
                            let rt;
                            switch(Qe){
                                case "up":
                                    rt = [
                                        0,
                                        -100
                                    ];
                                    break;
                                case "left":
                                    rt = [
                                        -100,
                                        0
                                    ];
                                    break;
                                case "down":
                                    rt = [
                                        0,
                                        Kl
                                    ];
                                    break;
                                case "right":
                                    rt = [
                                        Kl,
                                        0
                                    ];
                            }
                            this.map.panBy(rt);
                        } else super._moveToDirection(Qe);
                    }
                    isMapWide() {
                        return this.mapContainer.parentNode == this.grid;
                    }
                    _setFocus(Qe) {
                        var rt, Wn, Co, Dl;
                        let Ll = arguments.length > 1 && void 0 !== arguments[1] && arguments[1], Hl = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                        if ("map" === Qe && !this.map) throw new Error("Map is not enabled");
                        if (![
                            "map",
                            "pic"
                        ].includes(Qe)) throw new Error("Invalid focus value (should be pic or map)");
                        if (this.focus = Qe, (Hl || ("map" !== Qe || !this.map || !this.isMapWide()) && ("pic" !== Qe || this.map && this.isMapWide())) && ("map" === Qe ? (this.psvContainer.parentNode == this.grid && (this.grid.removeChild(this.psvContainer), this.psvContainer.removeAttribute("slot")), this.mapContainer.parentNode == this.mini && this.mini.removeChild(this.mapContainer), this.mapContainer.setAttribute("slot", "bg"), this.grid.appendChild(this.mapContainer), this.mini.appendChild(this.psvContainer), this.mini.icon = (0, Ul.fa)(Gl.pt), (0, Rl.isNullId)(this.picture) ? this.mini.classList.add("pnx-hidden") : this.mini.classList.remove("pnx-hidden"), this.map.getCanvas().focus()) : (this.mapContainer.parentNode == this.grid && (this.grid.removeChild(this.mapContainer), this.mapContainer.removeAttribute("slot")), this.psvContainer.parentNode == this.mini && this.mini.removeChild(this.psvContainer), this.psvContainer.setAttribute("slot", "bg"), this.grid.appendChild(this.psvContainer), this.mini.classList.remove("pnx-hidden"), this.mini.appendChild(this.mapContainer), this.mini.icon = (0, Ul.fa)(Zl.e5), this.psvContainer.focus()), null === this || void 0 === this || null === (rt = this.map) || void 0 === rt || null === (Wn = rt.resize) || void 0 === Wn || Wn.call(rt), this.psv.autoSize(), this.psv.forceRefresh(), null === (Co = this.legend) || void 0 === Co || null === (Dl = Co.setAttribute) || void 0 === Dl || Dl.call(Co, "focus", this.focus), !Ll)) {
                            const rt = new CustomEvent("focus-changed", {
                                detail: {
                                    focus: Qe
                                }
                            });
                            this.dispatchEvent(rt);
                        }
                    }
                    _toggleFocus() {
                        this._setFocus(this.isMapWide() ? "pic" : "map");
                    }
                    _onMiniExpand() {
                        this.map.resize(), this.psv.autoSize();
                    }
                    _onMapFiltersChange() {
                        var Qe;
                        const rt = (0, Hl.qi)("#pnx-map-filters-menu"), Wn = null === rt || void 0 === rt ? void 0 : rt.shadowRoot.getElementById("pnx-filter-date-from"), Co = null === rt || void 0 === rt ? void 0 : rt.shadowRoot.getElementById("pnx-filter-date-end"), Dl = null === rt || void 0 === rt ? void 0 : rt.shadowRoot.querySelectorAll("input[name='pnx-filter-type']"), Ll = (0, Hl.qi)("#pnx-map-theme");
                        let Rl = "";
                        for(let Zl = 0; Zl < Dl.length; Zl++){
                            const Qe = Dl[Zl];
                            if (Qe.checked) {
                                Rl = Qe.value;
                                break;
                            }
                        }
                        let Ul = [];
                        if (null !== (Qe = this.map) && void 0 !== Qe && Qe._hasQualityScore()) {
                            const Qe = null === rt || void 0 === rt ? void 0 : rt.shadowRoot.getElementById("pnx-filter-qualityscore");
                            Ul = ((null === Qe || void 0 === Qe ? void 0 : Qe.grade) || "").split(",").map((Qe)=>parseInt(Qe)).filter((Qe)=>!isNaN(Qe)), 5 == Ul.length && (Ul = []);
                        }
                        const Gl = {
                            minDate: null === Wn || void 0 === Wn ? void 0 : Wn.value,
                            maxDate: null === Co || void 0 === Co ? void 0 : Co.value,
                            pic_type: Rl,
                            theme: null === Ll || void 0 === Ll ? void 0 : Ll.value,
                            qualityscore: Ul
                        };
                        this.map.setFilters(Gl);
                    }
                }
                Viewer.properties = {
                    map: {
                        converter: Dl.A.GetJSONConverter()
                    },
                    focus: {
                        type: String,
                        reflect: !0
                    },
                    geocoder: {
                        type: String
                    },
                    ...Dl.A.properties
                }, customElements.define("pnx-viewer", Viewer);
            },
            3921: (Qe, rt, Wn)=>{
                "use strict";
                Wn.r(rt), Wn.d(rt, {
                    Basic: ()=>Co.A,
                    CoverageMap: ()=>Dl.A,
                    Editor: ()=>Ll.A,
                    PhotoViewer: ()=>Ul.A,
                    Viewer: ()=>Rl.A
                });
                var Co = Wn(9039), Dl = Wn(153), Ll = Wn(1752), Rl = Wn(8743), Ul = Wn(3407);
            },
            9341: (Qe, rt, Wn)=>{
                "use strict";
                Wn.r(rt), Wn.d(rt, {
                    core: ()=>Co,
                    layout: ()=>Dl,
                    menus: ()=>Ll,
                    ui: ()=>Rl
                });
                var Co = Wn(3921), Dl = Wn(456), Ll = Wn(8794), Rl = Wn(9472);
            },
            6784: (Qe, rt, Wn)=>{
                "use strict";
                Wn.d(rt, {
                    A: ()=>BottomDrawer
                });
                var Co = Wn(4542), Dl = Wn(1198);
                const Ll = {
                    opened: 0,
                    "half-opened": .7,
                    closed: 1
                };
                class BottomDrawer extends Co.WF {
                    constructor(){
                        super(), this._isDragging = !1, this.openness = "half-opened";
                    }
                    firstUpdated() {
                        var Qe;
                        super.firstUpdated(), this._boundTouchMove = this._onTouchMove.bind(this), this._boundTouchEnd = this._onTouchEnd.bind(this), this._drawerHeight = window.innerHeight - 30;
                        const rt = this._getDrawer();
                        rt && (rt.style.height = `${this._drawerHeight}px`, rt.style.maxHeight = `${this._drawerHeight}px`, null === (Qe = this._parent) || void 0 === Qe || Qe.onceReady().then(()=>{
                            var Qe, rt;
                            null === (Qe = this._parent.map) || void 0 === Qe || Qe.addEventListener("click", ()=>this.openness = "closed"), null === (rt = this._parent.psv) || void 0 === rt || rt.addEventListener("click", ()=>this.openness = "closed");
                        }));
                    }
                    attributeChangedCallback(Qe, rt, Wn) {
                        if (super.attributeChangedCallback(Qe, rt, Wn), "openness" === Qe) {
                            if ("opened" !== Wn) {
                                const Qe = this.shadowRoot.querySelector(".content");
                                Qe && (Qe.scrollTop = 0);
                            }
                            const Qe = this._getDrawer();
                            Qe && (Qe.style.transform = null);
                        }
                    }
                    disconnectedCallback() {
                        super.disconnectedCallback(), this._cleanupTouchListeners();
                    }
                    _getDrawer() {
                        var Qe;
                        return null === (Qe = this.shadowRoot) || void 0 === Qe ? void 0 : Qe.querySelector(".drawer");
                    }
                    _onHandleClick() {
                        "opened" === this.openness ? this.openness = "closed" : "half-opened" === this.openness ? this.openness = "opened" : "closed" === this.openness && (this.openness = "half-opened");
                    }
                    _onTouchStart(Qe) {
                        this._isDragging = !0, this._startFingerY = Qe.touches[0].clientY, this._deltaFingerY = 0, this._drawerY = this._drawerHeight * Ll[this.openness], window.addEventListener("touchmove", this._boundTouchMove, {
                            passive: !0
                        }), window.addEventListener("touchend", this._boundTouchEnd), window.addEventListener("touchcancel", this._boundTouchEnd);
                    }
                    _onTouchMove(Qe) {
                        if (!this._isDragging) return;
                        const rt = this.shadowRoot.querySelector(".content");
                        rt.scrollHeight > rt.offsetHeight && rt.scrollTop > 0 ? this._updateDrawerTransform(0) : (this._deltaFingerY = Qe.touches[0].clientY - this._startFingerY, this._updateDrawerTransform(this._drawerY + this._deltaFingerY));
                    }
                    _onTouchEnd(Qe) {
                        (this._isDragging && !(Math.abs(this._deltaFingerY) < 30) || Qe.target.closest(".handle")) && (Qe.preventDefault(), this._isDragging = !1, 0 === this._deltaFingerY && "closed" === this.openness ? this.openness = "half-opened" : this._updateDrawerTransform(this._drawerY + this._deltaFingerY, !0), this._cleanupTouchListeners(), this._startFingerY = null, this._deltaFingerY = null);
                    }
                    _cleanupTouchListeners() {
                        window.removeEventListener("touchmove", this._boundTouchMove), window.removeEventListener("touchend", this._boundTouchEnd), window.removeEventListener("touchcancel", this._boundTouchCancel);
                    }
                    _updateDrawerTransform(Qe) {
                        let rt = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                        const Wn = this._getDrawer();
                        Wn && (Qe = Math.max(0, Math.min(Qe, this._drawerHeight - 30)), rt && (this._deltaFingerY < 0 ? "closed" === this.openness ? Math.abs(this._deltaFingerY) > this._drawerHeight * (1 - Ll["half-opened"]) ? this.openness = "opened" : this.openness = "half-opened" : this.openness = "opened" : this.openness = "closed", this._drawerY = null, Qe = Math.max(0, Math.min(Ll[this.openness] * this._drawerHeight, this._drawerHeight - 30))), Wn.style.transform = `translateY(${Qe}px)`);
                    }
                    render() {
                        const Qe = {
                            drawer: !0,
                            [this.openness]: !0,
                            dragging: this._isDragging
                        };
                        return Co.qy`
			<div
				class=${(0, Dl.H)(Qe)}
				@touchstart="${this._onTouchStart}"
				@touchmove="${this._onTouchMove}"
				@touchend="${this._onTouchEnd}"
			>
				<div class="handle" @click=${this._onHandleClick}>
					<div class="handle-bar"></div>
				</div>
				<div class="content">
					<slot></slot>
				</div>
			</div>
		`;
                    }
                }
                BottomDrawer.styles = Co.AH`
		:host {
			position: fixed;
			bottom: 0;
			left: 0;
			width: 100%;
			z-index: 130;
			pointer-events: none;
			touch-action: none;
		}

		.drawer {
			background: var(--widget-bg);
			border-top-left-radius: 16px;
			border-top-right-radius: 16px;
			box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.2);
			display: flex;
			flex-direction: column;
			transition: transform 0.3s ease;
			will-change: transform;
			touch-action: auto;
			pointer-events: auto;
		}

		.drawer.dragging { transition: none; }
		.drawer.closed { transform: translateY(calc(100% - 30px)); }
		.drawer.half-opened { transform: translateY(70%); }
		.drawer.half-opened .content { overflow-y: hidden; }
		.drawer.opened { transform: translateY(0%); }

		.handle {
			height: 30px;
			display: flex;
			align-items: center;
			justify-content: center;
			cursor: pointer;
		}

		.handle-bar {
			width: 40px;
			height: 5px;
			background: var(--grey-pale);
			border-radius: 3px;
		}

		.content {
			overflow: auto;
			flex: 1;
		}
	`, BottomDrawer.properties = {
                    _fingerY: {
                        state: !0
                    },
                    _deltaFingerY: {
                        state: !0
                    },
                    _drawerY: {
                        state: !0
                    },
                    _isDragging: {
                        state: !0
                    },
                    _drawerHeight: {
                        state: !0
                    },
                    openness: {
                        type: String,
                        reflect: !0
                    }
                }, customElements.define("pnx-bottom-drawer", BottomDrawer);
            },
            7422: (Qe, rt, Wn)=>{
                "use strict";
                Wn.d(rt, {
                    A: ()=>CorneredGrid
                });
                var Co = Wn(4542);
                class CorneredGrid extends Co.WF {
                    render() {
                        return Co.qy`
			<div class="bg">
				<slot name="bg"></slot>
			</div>
			<div class="row top">
				<div class="corner left" part="corner-top-left">
					<slot name="top-left"></slot>
				</div>
				<div class="corner middle" part="corner-top">
					<slot name="top"></slot>
				</div>
				<div class="corner right" part="corner-top-right">
					<slot name="top-right"></slot>
				</div>
			</div>
			<div class="row bottom">
				<div class="corner left" part="corner-bottom-left">
					<slot name="bottom-left"></slot>
				</div>
				<div class="corner middle" part="corner-bottom">
					<slot name="bottom"></slot>
				</div>
				<div class="corner right" part="corner-bottom-right">
					<slot name="bottom-right"></slot>
				</div>
			</div>
		`;
                    }
                }
                CorneredGrid.styles = Co.AH`
		:host {
			position: relative;
			width: 100%;
			height: 100%;
			display: flex;
			flex-direction: column;
			gap: 5px;
			flex-wrap: no-wrap;
		}

		.bg {
			position: absolute;
			inset: 0;
			z-index: 0;
		}

		.row {
			display: flex;
			flex-direction: row;
			flex: 1 1 50%;
			pointer-events: none;
		}

		.row.bottom { align-items: flex-end; }

		.corner {
			position: relative;
			flex: 1 1 33%;
			display: flex;
			gap: 10px;
			height: min-content;
		}

		.corner slot {
			pointer-events: auto;
			position: relative;
			z-index: 120;
		}

		.row.bottom .corner:not(.middle) { flex-direction: column; }
		.row.bottom .corner.left { flex-direction: column-reverse; justify-content: flex-start; align-items: flex-start; }
		.row.bottom .corner.middle { justify-content: center; align-items: flex-end; }
		.row.bottom .corner.right { justify-content: flex-end; align-items: flex-end; }

		.row.top .corner { flex-direction: row; }
		.row.top .corner.left { justify-content: flex-start; align-items: flex-start; }
		.row.top .corner.middle { justify-content: center; }
		.row.top .corner.right { justify-content: flex-end; align-items: flex-start; }
	`, customElements.define("pnx-cornered-grid", CorneredGrid);
            },
            1445: (Qe, rt, Wn)=>{
                "use strict";
                Wn.d(rt, {
                    A: ()=>Mini
                });
                var Co = Wn(4542), Dl = Wn(1462), Ll = Wn(5721);
                class Mini extends Co.WF {
                    constructor(){
                        super(), this.collapsed = !1, this.icon = null;
                    }
                    render() {
                        var Qe, rt;
                        const Wn = (null === (Qe = this._parent) || void 0 === Qe ? void 0 : Qe.isWidthSmall()) || (null === (rt = this._parent) || void 0 === rt ? void 0 : rt.isHeightSmall()), onExpand = ()=>this.dispatchEvent(new Event("expand", {
                                bubbles: !0,
                                composed: !0
                            }));
                        if (this.collapsed || Wn) {
                            const Qe = Wn ? onExpand : ()=>this.collapsed = !1;
                            return Co.qy`<pnx-button
				kind="flat"
				size="xxl"
				style="bottom: 0"
				@click=${Qe}
			>${this.icon}</pnx-button>`;
                        }
                        var Rl, Ul, Gl;
                        return Co.qy`
				<slot></slot>

				<pnx-button
					kind="superflat"
					title=${null === (Rl = this._parent) || void 0 === Rl ? void 0 : Rl._t.pnx.expand_info}
					style="top: 0; right: 0"
					@click=${onExpand}
				>
					<img src=${Dl} alt="" />
					${null === (Ul = this._parent) || void 0 === Ul ? void 0 : Ul._t.pnx.expand}
				</pnx-button>

				<pnx-button
					kind="flat"
					title=${null === (Gl = this._parent) || void 0 === Gl ? void 0 : Gl._t.pnx.minimize}
					style="bottom: 0; left: 0"
					@click=${()=>this.collapsed = !0}
				>
					<img src=${Ll} alt="" />
				</pnx-button>
			`;
                    }
                }
                Mini.styles = Co.AH`
		:host {
			display: block;
			position: absolute;
			inset: 0;
			pointer-events: none;
		}

		slot {
			z-index: 120;
			pointer-events: auto;
		}

		pnx-button {
			z-index: 121;
			position: absolute;
			pointer-events: auto;
		}

		pnx-button img {
			height: 20px;
		}

		pnx-button:not([size="xxl"])::part(btn) {
			border-top-left-radius: 0;
			border-bottom-right-radius: 0;
		}
	`, Mini.properties = {
                    icon: {
                        type: String
                    },
                    collapsed: {
                        type: Boolean,
                        reflect: !0
                    }
                }, customElements.define("pnx-mini", Mini);
            },
            5534: (Qe, rt, Wn)=>{
                "use strict";
                Wn.d(rt, {
                    A: ()=>Tabs
                });
                var Co = Wn(4542);
                class Tabs extends Co.WF {
                    constructor(){
                        super(), this.activeTabIndex = 0;
                    }
                    _getTabs() {
                        return this.shadowRoot.querySelector("slot[name='title']").assignedNodes();
                    }
                    _getContents() {
                        return this.shadowRoot.querySelector("slot[name='content']").assignedNodes();
                    }
                    _changeTab(Qe, rt) {
                        const Wn = this._getTabs(), Co = this._getContents();
                        void 0 === Qe && void 0 === rt || (Qe && (rt = Wn.findIndex((rt)=>rt === Qe || rt === Qe.parentNode)), !isNaN(rt) && rt >= 0 && rt < Wn.length && Wn.forEach((Qe, Wn)=>{
                            Wn == rt ? (this.activeTabIndex = Wn, Co[Wn].classList.add("active"), Qe.classList.add("active")) : (Co[Wn].classList.remove("active"), Qe.classList.remove("active"));
                        }));
                    }
                    _handleTabClick(Qe) {
                        this._changeTab(Qe.target);
                    }
                    updated(Qe) {
                        Qe.has("activeTabIndex") && this._changeTab(void 0, this.activeTabIndex);
                    }
                    render() {
                        return Co.qy`
			<nav @click="${this._handleTabClick}">
				<slot name="title" @slotchange=${()=>this.activeTabIndex = 0}></slot>
			</nav>
			<div class="contents">
				<slot name="content"></slot>
			</div>
		`;
                    }
                }
                Tabs.styles = Co.AH`
		/* Tabs */
		nav {
			display: flex;
			gap: 5px;
			align-items: stretch;
			overflow-x: auto;
			touch-action: pan-x;
		}
		nav ::slotted(*) {
			color: var(--grey-dark);
			border-bottom: 2px solid rgba(0,0,0,0);
			cursor: pointer;
			transition: all 0.1s;
			flex: 1;
		}
		nav ::slotted(*:hover:not(.active)) { background-color: var(--blue-pale); }
		nav ::slotted(*.active) {
			color: var(--blue-dark);
			border-bottom: 2px solid var(--blue-dark);
		}

		/* Content */
		.contents ::slotted(div) { display: none !important; }
		.contents ::slotted(.active) { display: block !important; }
	`, Tabs.properties = {
                    activeTabIndex: {
                        type: Number,
                        reflect: !0
                    }
                }, customElements.define("pnx-tabs", Tabs);
            },
            456: (Qe, rt, Wn)=>{
                "use strict";
                Wn.r(rt), Wn.d(rt, {
                    BottomDrawer: ()=>Co.A,
                    CorneredGrid: ()=>Dl.A,
                    Mini: ()=>Ll.A,
                    Tabs: ()=>Rl.A
                });
                var Co = Wn(6784), Dl = Wn(7422), Ll = Wn(1445), Rl = Wn(5534);
            },
            1208: (Qe, rt, Wn)=>{
                "use strict";
                Wn.d(rt, {
                    A: ()=>AnnotationsList
                });
                var Co = Wn(4542), Dl = Wn(8591), Ll = Wn(5995), Rl = Wn(1187), Ul = Wn(8466);
                Wn(8983);
                class AnnotationsList extends Co.WF {
                    constructor(){
                        super(), this._selectedAnnotation = null, this._presets = {}, (0, Ll.moreIcons)();
                    }
                    connectedCallback() {
                        var Qe, rt, Wn, Co, Dl, Ll;
                        super.connectedCallback(), this._onPicChange(), null === (Qe = this._parent) || void 0 === Qe || null === (rt = Qe.psv) || void 0 === rt || rt.addEventListener("picture-loaded", this._onPicChange.bind(this)), null === (Wn = this._parent) || void 0 === Wn || null === (Co = Wn.psv) || void 0 === Co || Co.addEventListener("annotation-click", (Qe)=>{
                            var rt, Wn;
                            const Co = null === (rt = this._meta.properties) || void 0 === rt || null === (Wn = rt.annotations) || void 0 === Wn ? void 0 : Wn.findIndex((rt)=>rt.id === Qe.detail.annotationId);
                            Co >= 0 && this._onListItemClick(Object.assign({
                                nb: Co + 1
                            }, this._meta.properties.annotations[Co]));
                        }), null === (Dl = this._parent) || void 0 === Dl || null === (Ll = Dl.psv) || void 0 === Ll || Ll.addEventListener("annotations-unfocused", ()=>{
                            this._onListItemClick(null);
                        });
                    }
                    _onPicChange() {
                        var Qe, rt, Wn, Co, Dl;
                        (this._meta = null === (Qe = this._parent) || void 0 === Qe || null === (rt = Qe.psv) || void 0 === rt ? void 0 : rt.getPictureMetadata(), delete this._prevPsvView, this._selectedAnnotation = null, this._meta && null !== (Wn = this._parent) && void 0 !== Wn && Wn.presetsManager) && (this._presets = {}, (null === (Co = this._meta.properties) || void 0 === Co || null === (Dl = Co.annotations) || void 0 === Dl ? void 0 : Dl.length) > 0 && this._meta.properties.annotations.map((Qe)=>this._parent.presetsManager.getPreset(Qe).then((rt)=>{
                                this._presets[Qe.id] = rt, this.requestUpdate();
                            })));
                    }
                    _onListItemHover(Qe) {
                        Qe ? (this._prevPsvView || (this._prevPsvView = [
                            this._parent.psv.getZoomLevel(),
                            this._parent.psv.getPosition()
                        ]), this._parent.psv.focusOnAnnotation(Qe.id)) : (this._parent.psv.unfocusAnnotation(), this._prevPsvView && (this._parent.psv.zoom(this._prevPsvView[0]), this._parent.psv.rotate(this._prevPsvView[1]), delete this._prevPsvView));
                    }
                    _onListItemClick(Qe) {
                        this._selectedAnnotation = Qe, this._onListItemHover(Qe);
                    }
                    render() {
                        var Qe, rt, Wn, Dl;
                        return this._meta ? null === this._selectedAnnotation ? Co.qy`<div class="list">
				${this._meta.properties.annotations.map((Qe, rt)=>{
                            var Wn, Dl, Ul, Gl;
                            return Co.qy`
					<pnx-list-item
						title=${(null === (Wn = this._presets[Qe.id]) || void 0 === Wn ? void 0 : Wn.name) || (null === (Dl = this._parent) || void 0 === Dl ? void 0 : Dl._t.pnx.semantics_features_default_title.replace("{nb}", rt + 1))}
						subtitle=${null === (Ul = this._parent) || void 0 === Ul ? void 0 : Ul._t.pnx.semantics_features_subtitle.replace("{nb}", Qe.semantics.length)}
						@click=${()=>this._onListItemClick(Object.assign({
                                    nb: rt + 1
                                }, Qe))}
						@mouseover=${()=>this._onListItemHover(Object.assign({
                                    nb: rt + 1
                                }, Qe))}
						@mouseout=${()=>this._onListItemHover(null)}
					>
						<iconify-icon
							slot="icon"
							icon=${(null === (Gl = this._presets[Qe.id]) || void 0 === Gl ? void 0 : Gl.iconify) || "fa6-solid:cube"}
							style="font-size: 1.5em"
						></iconify-icon>
						${(0, Ll.fa)(Rl.Xk, {
                                transform: {
                                    size: 24
                                },
                                attributes: {
                                    slot: "action"
                                }
                            })}
					</pnx-list-item>
				`;
                        })}
			</div>` : Co.qy`<div class="annotation">
				<pnx-list-item
					title=${(null === (Qe = this._presets[this._selectedAnnotation.id]) || void 0 === Qe ? void 0 : Qe.name) || (null === (rt = this._parent) || void 0 === rt ? void 0 : rt._t.pnx.semantics_features_default_title.replace("{nb}", this._selectedAnnotation.nb))}
					@click=${()=>this._onListItemClick(null)}
				>
					${(0, Ll.fa)(Ul.Ce, {
                            transform: {
                                size: 24
                            },
                            attributes: {
                                slot: "icon"
                            }
                        })}
					<iconify-icon
						slot="icon"
						icon=${(null === (Wn = this._presets[this._selectedAnnotation.id]) || void 0 === Wn ? void 0 : Wn.iconify) || "fa6-solid:cube"}
						style="font-size: 1.5em"
					></iconify-icon>
				</pnx-list-item>
				<pnx-semantics-table
					._t=${null === (Dl = this._parent) || void 0 === Dl ? void 0 : Dl._t}
					.source=${this._selectedAnnotation}
				/>
			</div>` : Co.s6;
                    }
                }
                AnnotationsList.styles = [
                    Dl.Op,
                    Dl.wS,
                    Co.AH`
		.annotation { background: var(--white); }
	`
                ], AnnotationsList.properties = {
                    _meta: {
                        state: !0
                    },
                    _selectedAnnotation: {
                        state: !0
                    },
                    _presets: {
                        state: !0
                    }
                }, customElements.define("pnx-annotations-list", AnnotationsList);
            },
            5036: (Qe, rt, Wn)=>{
                "use strict";
                Wn.d(rt, {
                    A: ()=>MapBackground
                });
                var Co = Wn(4542), Dl = Wn(7534), Ll = Wn(6810);
                class MapBackground extends Co.WF {
                    constructor(){
                        super(), this.size = "md";
                    }
                    connectedCallback() {
                        var Qe, rt, Wn, Co;
                        super.connectedCallback(), null === (Qe = this._parent) || void 0 === Qe || null === (rt = Qe.map) || void 0 === rt || rt.on("background-changed", (Qe)=>{
                            this.bg = Qe.background;
                        }), this.bg = null === (Wn = this._parent) || void 0 === Wn || null === (Co = Wn.map) || void 0 === Co ? void 0 : Co.getBackground();
                    }
                    _onBgSelect(Qe) {
                        var rt, Wn;
                        this.bg = Qe.target.value, null === (rt = this._parent) || void 0 === rt || null === (Wn = rt.map) || void 0 === Wn || Wn.setBackground(this.bg);
                    }
                    render() {
                        var Qe, rt;
                        return Co.qy`
			<input
				type="radio"
				id="bg-streets"
				name="bg"
				value="streets"
				@change=${this._onBgSelect}
				.checked=${"streets" == this.bg}
			/>
			<label for="bg-streets">
				<img src=${Ll} class=${this.size} alt="" />
				${null === (Qe = this._parent) || void 0 === Qe ? void 0 : Qe._t.pnx.map_background_streets}
			</label>
			<input
				type="radio"
				id="bg-aerial"
				name="bg"
				value="aerial"
				@change=${this._onBgSelect}
				.checked=${"aerial" == this.bg}
			/>
			<label for="bg-aerial">
				<img src=${Dl} class=${this.size} alt="" />
				${null === (rt = this._parent) || void 0 === rt ? void 0 : rt._t.pnx.map_background_aerial}
			</label>
		`;
                    }
                }
                MapBackground.styles = [
                    Co.AH`
		:host {
			justify-content: space-evenly;
			box-sizing: border-box;
			display: flex;
			gap: 10px;
		}
		input { display: none; }
		label { cursor: pointer; }

		img {
			width: 40px;
			border-radius: 5px;
			vertical-align: middle;
			margin-right: 5px;
			border: 2px solid var(--widget-bg);
		}

		img.sm {
			width: 32px;
		}

		input:checked + label img {
			outline: 3px solid var(--widget-border-btn);
		}
	`
                ], MapBackground.properties = {
                    bg: {
                        state: !0
                    },
                    size: {
                        type: String
                    }
                }, customElements.define("pnx-map-background", MapBackground);
            },
            3581: (Qe, rt, Wn)=>{
                "use strict";
                Wn.d(rt, {
                    A: ()=>MapFilters
                });
                var Co = Wn(4542), Dl = Wn(5995), Ll = Wn(7343), Rl = Wn(8591), Ul = Wn(5279), Gl = Wn(9186), Zl = Wn(6069), Hl = Wn(3233), ql = Wn(6668), Ql = Wn(7879);
                class MapFilters extends Co.WF {
                    constructor(){
                        super(), this._formDelay = null, this.showZoomIn = !0;
                    }
                    connectedCallback() {
                        var Qe, rt;
                        super.connectedCallback();
                        for (let Wn of this.shadowRoot.querySelectorAll("input"))Wn.addEventListener("change", this._onFormChange.bind(this)), Wn.addEventListener("keypress", this._onFormChange.bind(this)), Wn.addEventListener("paste", this._onFormChange.bind(this)), Wn.addEventListener("input", this._onFormChange.bind(this));
                        null === (Qe = this._parent) || void 0 === Qe || null === (rt = Qe.onceMapReady) || void 0 === rt || rt.call(Qe).then(()=>{
                            this._parent.map.on("zoomend", this._onMapZoom.bind(this)), this._parent.map.on("filters-changed", this._onParentFilterChange.bind(this)), this._onMapZoom(), this._onParentFilterChange(this._parent.map._mapFilters);
                        });
                    }
                    _onMapZoom() {
                        this.showZoomIn = this._parent.map.getZoom() < 7;
                    }
                    _onParentFilterChange(Qe) {
                        var rt;
                        if (this.minDate = (null === Qe || void 0 === Qe ? void 0 : Qe.minDate) || null, this.maxDate = (null === Qe || void 0 === Qe ? void 0 : Qe.maxDate) || null, this.minDate && this.maxDate && this.minDate > this.maxDate) {
                            const Qe = this.minDate;
                            this.minDate = this.maxDate, this.maxDate = Qe, this._onFormChange();
                        }
                        this.score = (null === Qe || void 0 === Qe || null === (rt = Qe.qualityscore) || void 0 === rt ? void 0 : rt.length) < 5 ? Qe.qualityscore.join(",") : "", this.type = "", null !== Qe && void 0 !== Qe && Qe.pic_type && "" != Qe.pic_type && (this.type = "flat" == Qe.pic_type ? "flat" : "equirectangular");
                    }
                    _onSubmit(Qe) {
                        return Qe.preventDefault(), this._onFormChange(), !1;
                    }
                    _onFormChange() {
                        this._formDelay && clearTimeout(this._formDelay), this._formDelay = setTimeout(()=>{
                            var Qe;
                            return null === (Qe = this._parent) || void 0 === Qe ? void 0 : Qe._onMapFiltersChange();
                        }, 250);
                    }
                    _userSearch(Qe) {
                        return null === this || void 0 === this ? void 0 : this._parent.api.searchUsers(Qe).then((Qe)=>(Qe || []).map((Qe)=>({
                                    title: Qe.label,
                                    data: Qe
                                })));
                    }
                    _onUserSearchResult(Qe) {
                        var rt, Wn;
                        return Qe.detail ? Qe.target.classList.add("pnx-filter-active") : Qe.target.classList.remove("pnx-filter-active"), null === (rt = this._parent) || void 0 === rt ? void 0 : rt.map.setVisibleUsers(null !== (Wn = Qe.detail) && void 0 !== Wn && Wn.data ? [
                            Qe.detail.data.id
                        ] : [
                            "geovisio"
                        ]);
                    }
                    _onReset() {
                        var Qe, rt;
                        null === (Qe = this.shadowRoot.querySelector("#pnx-filter-qualityscore")) || void 0 === Qe || Qe.setAttribute("grade", ""), null === (rt = this.shadowRoot.querySelector("#pnx-filter-search-user")) || void 0 === rt || rt.reset(), this.minDate = null, this.maxDate = null, this.type = "", this.score = null, this.user = null, this._onFormChange();
                    }
                    _onDateShortcut(Qe) {
                        const rt = this.shadowRoot.getElementById("pnx-filter-date-from"), Wn = this.shadowRoot.getElementById("pnx-filter-date-end");
                        rt && (rt.value !== Qe ? rt.value = Qe : rt.value = ""), Wn && (Wn.value = "");
                    }
                    render() {
                        var Qe, rt, Wn, Rl, Kl, $l, Tc, tu, lu, du, fu, yu, Eu, Tu, Lu, Zu;
                        const Xu = (0, Ll.getUserAccount)();
                        return Co.qy`<form
			@reset=${this._onReset}
			@change=${this._onFormChange}
			@submit=${this._onSubmit}
		>
			<div class="pnx-filter-block">
				<div class="pnx-filter-zoomin ${this.showZoomIn ? "" : "hidden"}">${null === (Qe = this._parent) || void 0 === Qe ? void 0 : Qe._t.pnx.filter_zoom_in}</div>
				<h4>${(0, Dl.fa)(Gl.ok)} ${null === (rt = this._parent) || void 0 === rt ? void 0 : rt._t.pnx.filter_date}</h4>
				<div class="pnx-input-shortcuts">
					<button
						@click=${()=>this._onDateShortcut(new Date((new Date).setMonth((new Date).getMonth() - 1)).toISOString().split("T")[0])}
					>${null === (Wn = this._parent) || void 0 === Wn ? void 0 : Wn._t.pnx.filter_date_1month}</button>
					<button
						@click=${()=>this._onDateShortcut(new Date((new Date).setMonth((new Date).getMonth() - 6)).toISOString().split("T")[0])}
					>${null === (Rl = this._parent) || void 0 === Rl ? void 0 : Rl._t.pnx.filter_date_6months}</button>
					<button
						@click=${()=>this._onDateShortcut(new Date((new Date).setFullYear((new Date).getFullYear() - 1)).toISOString().split("T")[0])}
					>${null === (Kl = this._parent) || void 0 === Kl ? void 0 : Kl._t.pnx.filter_date_1year}</button>
				</div>
				<div class="pnx-input-group">
					<input
						type="date"
						id="pnx-filter-date-from"
						.value=${this.minDate}
						class=${this.minDate && "" != this.minDate ? "pnx-filter-active" : ""}
					/>
					${(0, Dl.fa)(Zl.dm)}
					<input
						type="date"
						id="pnx-filter-date-end"
						.value=${this.maxDate}
						class=${this.maxDate && "" != this.maxDate ? "pnx-filter-active" : ""}
					/>
				</div>
			</div>

			<div class="pnx-filter-block">
				<h4>${(0, Dl.fa)(Ul.jb)} ${null === ($l = this._parent) || void 0 === $l ? void 0 : $l._t.pnx.filter_picture}</h4>
				<div class="pnx-input-group pnx-checkbox-btns" style="justify-content: center;">
					<input
						type="radio"
						id="pnx-filter-type-all"
						name="pnx-filter-type"
						value=""
						.checked=${!this.type || "" === this.type}
					/>
					<label for="pnx-filter-type-all">${null === (Tc = this._parent) || void 0 === Tc ? void 0 : Tc._t.pnx.picture_all}</label>
					<input
						type="radio"
						id="pnx-filter-type-flat"
						name="pnx-filter-type"
						value="flat"
						.checked=${"flat" === this.type}
					/>
					<label for="pnx-filter-type-flat">${null === (tu = this._parent) || void 0 === tu ? void 0 : tu._t.pnx.picture_flat}</label>
					<input
						type="radio"
						id="pnx-filter-type-360"
						name="pnx-filter-type"
						value="equirectangular"
						.checked=${"equirectangular" === this.type}
					/>
					<label for="pnx-filter-type-360">${null === (lu = this._parent) || void 0 === lu ? void 0 : lu._t.pnx.picture_360}</label>
				</div>
			</div>

			${this["quality-score"] ? Co.qy`
				<div class="pnx-filter-block">
					<div class="pnx-filter-zoomin ${this.showZoomIn ? "" : "hidden"}">${null === (du = this._parent) || void 0 === du ? void 0 : du._t.pnx.filter_zoom_in}</div>
					<h4 style="margin-bottom: 3px">
						${(0, Dl.fa)(Hl.B9)} ${null === (fu = this._parent) || void 0 === fu ? void 0 : fu._t.pnx.filter_qualityscore}
						<pnx-button
							title="${null === (yu = this._parent) || void 0 === yu ? void 0 : yu._t.pnx.metadata_quality_help}"
							kind="superinline"
							@click=${()=>{
                            var Qe;
                            return null === (Qe = this._parent) || void 0 === Qe ? void 0 : Qe._showQualityScoreDoc();
                        }}
						>
							${(0, Dl.fa)(ql.iW)}
						</pnx-button>
					</h4>
					<div class="pnx-input-group">
						<pnx-quality-score
							id="pnx-filter-qualityscore"
							_t=${null === (Eu = this._parent) || void 0 === Eu ? void 0 : Eu._t}
							input="pnx-filter-qualityscore"
							grade=${this.score}
							@change=${this._onFormChange}
						>
						</pnx-quality-score>
					</div>
				</div>
			` : Co.s6}

			${this["user-search"] ? Co.qy`
				<div class="pnx-filter-block">
					<h4>${(0, Dl.fa)(Ql.X4)} ${null === (Tu = this._parent) || void 0 === Tu ? void 0 : Tu._t.pnx.filter_user}</h4>
					${Xu ? Co.qy`
						<div class="pnx-input-shortcuts">
							<button>${null === (Lu = this._parent) || void 0 === Lu ? void 0 : Lu._t.pnx.filter_user_mypics}</button>
						</div>
					` : Co.s6}
					<pnx-search-bar
						id="pnx-filter-search-user"
						placeholder=${null === (Zu = this._parent) || void 0 === Zu ? void 0 : Zu._t.pnx.search_user}
						class=${this.user ? "pnx-filter-active" : ""}
						value=${this.user}
						@result=${this._onUserSearchResult}
						.searcher=${this._userSearch.bind(this)}
						._parent=${this._parent}
						no-menu-closure
					>
					</pnx-search-bar>
				</div>
			` : Co.s6}
		</form>`;
                    }
                }
                MapFilters.styles = [
                    Rl.Op,
                    Rl.YC,
                    Co.AH`
		.pnx-input-group {
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: center;
			gap: 5px;
		}

		/* Filter block */
		.pnx-filter-block {
			position: relative;
			padding: 10px 15px;
			border-bottom: 2px solid var(--widget-border-div);
		}
		.pnx-filter-block:first-child {
			padding-top: 15px;
		}
		.pnx-filter-block:last-child {
			border-bottom: none;
			padding-bottom: 15px;
		}
		.pnx-filter-zoomin {
			z-index: 131;
			background-color: rgba(255,255,255,0.8);
			text-align: center;
			font-weight: 800;
			position: absolute;
			top: 0;
			right: 0;
			left: 0;
			bottom: 0;
			display: flex;
			justify-content: center;
			align-items: center;
			border-radius: 25px;
		}
		.pnx-filter-zoomin.hidden {
			display: none;
		}

		/* Input styles */
		.pnx-filter-active,
		pnx-search-bar.pnx-filter-active::part(container),
		pnx-search-bar.pnx-filter-active::part(input) {
			background-color: var(--widget-bg-active) !important;
			border-color: var(--widget-bg-active) !important;
			color: var(--widget-font-active) !important;
		}
		input[type=date] {
			min-width: 0;
			flex-grow: 2;
			padding: 2px 0;
			text-align: center;
			background-color: var(--widget-bg);
			color: var(--widget-font);
			border: 1px solid var(--widget-border-div);
			border-radius: 20px;
			font-family: var(--font-family);
		}

		/* Input shortcuts */
		.pnx-input-shortcuts {
			margin-top: -10px;
			margin-bottom: 5px;
		}
		.pnx-input-shortcuts button {
			border: none;
			font-size: 0.75em;
			padding: 2px 6px;
			vertical-align: middle;
			background-color: var(--grey-pale);
			color: var(--black);
			border-radius: 10px;
			cursor: pointer;
			font-family: var(--font-family);
		}
		.pnx-input-shortcuts button:hover {
			background-color: #d9dcd9;
		}

		/* Checkbox looking like buttons */
		.pnx-input-group.pnx-checkbox-btns {
			gap: 0;
			align-items: stretch;
		}
		.pnx-checkbox-btns label {
			display: inline-block;
			padding: 2px 7px;
			background: none;
			border: 1px solid var(--widget-border-btn);
			color: var(--widget-font-direct);
			cursor: pointer;
			font-size: 16px;
			text-decoration: none;
			border-left-width: 0px;
		}
		.pnx-checkbox-btns label:hover {
			background-color: var(--widget-bg-hover);
		}
		.pnx-checkbox-btns label:first-of-type {
			border-top-left-radius: 8px;
			border-bottom-left-radius: 8px;
			border-left-width: 1px;
		}
		.pnx-checkbox-btns label:last-of-type {
			border-top-right-radius: 8px;
			border-bottom-right-radius: 8px;
		}
		.pnx-checkbox-btns input[type="radio"] { display: none; }
		.pnx-checkbox-btns input[type="radio"]:checked + label {
			background-color: var(--widget-bg-active);
			color: var(--widget-font-active);
		}
		.pnx-checkbox-btns input[type="radio"]:checked + label:first-of-type {
			border-right-color: white;
		}

		/* Force user search width */
		#pnx-filter-search-user::part(container) { width: 100%; }
	`
                ], MapFilters.properties = {
                    "quality-score": {
                        type: Boolean
                    },
                    "user-search": {
                        type: Boolean
                    },
                    showZoomIn: {
                        state: !0
                    },
                    minDate: {
                        state: !0
                    },
                    maxDate: {
                        state: !0
                    },
                    type: {
                        state: !0
                    },
                    score: {
                        state: !0
                    },
                    user: {
                        state: !0
                    }
                }, customElements.define("pnx-map-filters-menu", MapFilters);
            },
            5334: (Qe, rt, Wn)=>{
                "use strict";
                Wn.d(rt, {
                    A: ()=>MapLayers
                });
                var Co = Wn(4542), Dl = Wn(5995), Ll = Wn(8591), Rl = Wn(7343), Ul = Wn(7172), Gl = Wn(8629), Zl = Wn(6668);
                class MapLayers extends Co.WF {
                    connectedCallback() {
                        var Qe, rt;
                        super.connectedCallback(), null === (Qe = this._parent) || void 0 === Qe || null === (rt = Qe.onceMapReady) || void 0 === rt || rt.call(Qe).then(()=>{
                            this.theme = this._parent.map._mapFilters.theme, this._parent.map.on("filters-changed", (Qe)=>this.theme = Qe.theme);
                        });
                    }
                    _onThemeSelect(Qe) {
                        var rt;
                        this.theme = Qe.target.value, null === (rt = this._parent) || void 0 === rt || rt._onMapFiltersChange();
                    }
                    render() {
                        var Qe, rt, Wn, Ll, Hl, ql, Ql, Kl, $l, Tc, tu, lu, du, fu, yu, Eu, Tu, Lu;
                        const Zu = [];
                        var Xu;
                        null !== (Qe = this._parent) && void 0 !== Qe && null !== (rt = Qe.map) && void 0 !== rt && null !== (Wn = rt.hasTwoBackgrounds) && void 0 !== Wn && Wn.call(rt) && Zu.push(Co.qy`
				<h4>${(0, Dl.fa)(Ul.YS)} ${null === (Xu = this._parent) || void 0 === Xu ? void 0 : Xu._t.pnx.map_background}</h4>
				<pnx-map-background ._parent=${this._parent}></pnx-map-background>
			`);
                        return Zu.push(Co.qy`
			<h4>${(0, Dl.fa)(Gl.fy)} ${null === (Ll = this._parent) || void 0 === Ll ? void 0 : Ll._t.pnx.map_theme}</h4>
			<select id="pnx-map-theme" style="width: 100%;" @change=${this._onThemeSelect}>
				<option value="default" .selected=${"default" == this.theme}>${null === (Hl = this._parent) || void 0 === Hl ? void 0 : Hl._t.pnx.map_theme_default}</option>
				<option value="age" .selected=${"age" == this.theme}>${null === (ql = this._parent) || void 0 === ql ? void 0 : ql._t.pnx.map_theme_age}</option>
				<option value="type" .selected=${"type" == this.theme}>${null === (Ql = this._parent) || void 0 === Ql ? void 0 : Ql._t.pnx.map_theme_type}</option>
				${(null === (Kl = this._parent) || void 0 === Kl || null === ($l = Kl.map) || void 0 === $l || null === (Tc = $l._hasQualityScore) || void 0 === Tc ? void 0 : Tc.call($l)) && Co.qy`<option value="score" .selected=${"score" == this.theme}>${null === (tu = this._parent) || void 0 === tu ? void 0 : tu._t.pnx.map_theme_score}</option>`}
			</select>
		`), Zu.push(Co.qy`<div class="legend">
			${"age" == this.theme ? Co.qy`
				<div>
					<div class="legend-entry">
						<span class="legend-color" style="background-color: ${Rl.COLORS.PALETTE_4}"></span>
						${null === (lu = this._parent) || void 0 === lu ? void 0 : lu._t.pnx.map_theme_age_4}
					</div>
					<div class="legend-entry">
						<span class="legend-color" style="background-color: ${Rl.COLORS.PALETTE_3}"></span>
						${null === (du = this._parent) || void 0 === du ? void 0 : du._t.pnx.map_theme_age_3}
					</div>
				</div>
				<div>
					<div class="legend-entry">
						<span class="legend-color" style="background-color: ${Rl.COLORS.PALETTE_2}"></span>
						${null === (fu = this._parent) || void 0 === fu ? void 0 : fu._t.pnx.map_theme_age_2}
					</div>
					<div class="legend-entry">
						<span class="legend-color" style="background-color: ${Rl.COLORS.PALETTE_1}"></span>
						${null === (yu = this._parent) || void 0 === yu ? void 0 : yu._t.pnx.map_theme_age_1}
					</div>
				</div>` : Co.s6}
			
			${"type" == this.theme ? Co.qy`
			 	<div class="legend-entry">
			 		<span class="legend-color" style="background-color: ${Rl.COLORS.QUALI_1}"></span>
			 		${null === (Eu = this._parent) || void 0 === Eu ? void 0 : Eu._t.pnx.picture_360}
			 	</div>
			 	<div class="legend-entry">
			 		<span class="legend-color" style="background-color: ${Rl.COLORS.QUALI_2}"></span>
			 		${null === (Tu = this._parent) || void 0 === Tu ? void 0 : Tu._t.pnx.picture_flat}
			 	</div>` : Co.s6}
			
			${"score" == this.theme ? Co.qy`<div>
				<pnx-quality-score></pnx-quality-score>
				<pnx-button
					title="${null === (Lu = this._parent) || void 0 === Lu ? void 0 : Lu._t.pnx.metadata_quality_help}"
					kind="superinline"
					@click=${()=>{
                            var Qe;
                            return null === (Qe = this._parent) || void 0 === Qe ? void 0 : Qe._showQualityScoreDoc();
                        }}
				>
					${(0, Dl.fa)(Zl.iW)}
				</pnx-button></div>` : Co.s6}
		</div>`), Zu;
                    }
                }
                MapLayers.styles = [
                    Ll.Op,
                    Ll.YC,
                    Ll.Lt,
                    Co.AH`
		.legend {
			display: flex;
			flex-wrap: wrap;
			margin-top: 5px;
			justify-content: space-evenly;
		}

		.legend-entry {
			margin: 10px 8px 5px 0px;
			line-height: 12px;
			display: flex;
			align-items: center;
			font-size: 1.0em;
		}

		.legend-color {
			display: inline-block;
			width: 15px;
			height: 15px;
			border-radius: 3px;
			margin-right: 5px;
		}

		.legend-score {
			justify-content: center;
			gap: 0;
		}
	`
                ], MapLayers.properties = {
                    theme: {
                        state: !0
                    }
                }, customElements.define("pnx-map-layers-menu", MapLayers);
            },
            4749: (Qe, rt, Wn)=>{
                "use strict";
                Wn.d(rt, {
                    A: ()=>MapLegend
                });
                var Co = Wn(4542);
                class MapLegend extends Co.WF {
                    render() {
                        var Qe, rt, Wn, Dl;
                        const Ll = null === (Qe = this._parent) || void 0 === Qe || null === (rt = Qe.map) || void 0 === rt || null === (Wn = rt._attribution) || void 0 === Wn ? void 0 : Wn._innerContainer;
                        return Co.qy`
			${Ll && Ll.innerHTML.length > 0 ? Co.qy`${null === (Dl = this._parent) || void 0 === Dl ? void 0 : Dl._t.map.map_data}<br />${Ll}` : Co.s6}
		`;
                    }
                }
                MapLegend.styles = Co.AH`
		:host {
			font-size: 0.9em;
		}
		small {
			font-size: 1em;
		}
	`, customElements.define("pnx-map-legend", MapLegend);
            },
            3589: (Qe, rt, Wn)=>{
                "use strict";
                Wn.d(rt, {
                    A: ()=>PictureLegend
                });
                var Co = Wn(4542), Dl = Wn(1198), Ll = Wn(5995), Rl = Wn(8466), Ul = Wn(4336), Gl = Wn(2593), Zl = Wn(7879), Hl = Wn(4927), ql = Wn(6311), Ql = Wn(1260), Kl = Wn(8591), $l = Wn(3606);
                class PictureLegend extends Co.WF {
                    constructor(){
                        super(), this._expanded = !0, this.collapsable = !1;
                    }
                    connectedCallback() {
                        super.connectedCallback(), this._expanded = !this.collapsable, this._prevSearches = {}, this._parent.onceReady().then(()=>{
                            this._onPicChange(this._parent.psv.getPictureMetadata()), this._parent.psv.addEventListener("picture-loaded", ()=>{
                                this._onPicChange(this._parent.psv.getPictureMetadata());
                            }), this._parent.psv.addEventListener("sequence-stopped", ()=>{
                                this._onPicChange(this._parent.psv.getPictureMetadata());
                            }), this._parent.psv.addEventListener("annotation-click", ()=>{
                                this._expanded = !0;
                            });
                        });
                    }
                    _onPicChange(Qe) {
                        if (clearTimeout(this._addrTimer1), this._caption = null === Qe || void 0 === Qe ? void 0 : Qe.caption, Qe) {
                            const rt = `${Qe.gps[0].toFixed(4)}/${Qe.gps[1].toFixed(4)}`;
                            this._prevSearches[rt] ? this._addr = this._prevSearches[rt] : this._parent.psv._sequencePlaying || (this._addr = "", this._addrTimer1 = setTimeout(()=>{
                                (0, $l.reverseGeocodingNominatim)(Qe.gps[1], Qe.gps[0]).then((Qe)=>{
                                    clearTimeout(this._addrTimer2), this._addr = Qe, this._prevSearches[rt] = Qe;
                                });
                            }, 500));
                        } else this._addr = "";
                    }
                    _onBackClick() {
                        var Qe, rt;
                        this._parent.isWidthSmall() && "map" === this._parent.focus ? this._parent.select() : null === (Qe = (rt = this._parent)._setFocus) || void 0 === Qe || Qe.call(rt, "map");
                    }
                    render() {
                        var Qe, rt, Wn, Kl, $l;
                        if (!this._caption) return Co.s6;
                        const Tc = (0, Dl.H)({
                            "pnx-hidden": this._expanded
                        }), tu = (0, Dl.H)({
                            "pnx-hidden": !this._expanded
                        });
                        return Co.qy`
			<div class="headline">
				${this._parent._setFocus ? Co.qy`
					<pnx-button
						kind="superinline"
						@click=${this._onBackClick}
					>
						${(0, Ll.fa)(Rl.Ce)}
					</pnx-button>
				` : Co.s6}

				<div id="pic-legend-addr">
					${(null === (Qe = this._addr) || void 0 === Qe ? void 0 : Qe.length) > 0 ? this._addr : Co.qy`<span class="pnx-placeholder-loading">&nbsp;</span>`}
				</div>

				<pnx-picture-legend-actions
					@click=${(Qe)=>Qe.stopPropagation()}
					._parent=${this._parent}
					?full=${this._expanded}
				></pnx-picture-legend-actions>
			</div>

			<div id="pic-legend-info" class=${Tc}>
				${(null === (rt = this._caption.producer) || void 0 === rt ? void 0 : rt.length) > 0 ? Co.qy`<div class="info-block">
					${(0, Ll.fa)(Zl.X4)}
					${this._caption.producer[this._caption.producer.length - 1]}
				</div>` : Co.s6}

				${this._caption.date ? Co.qy`<div class="info-block">
					${(0, Ll.fa)(Hl.BE)}
					${this._caption.date.toLocaleDateString((null === (Wn = this._parent) || void 0 === Wn ? void 0 : Wn.lang) || window.navigator.language, {
                            year: "numeric",
                            month: "long"
                        })}
				</div>` : Co.s6}
			</div>

			<div id="pic-legend-cta" class=${tu}>
				${this._parent.api._endpoints.report ? Co.qy`
						<pnx-button size="sm" @click=${()=>this._parent._showReportForm()}>
							${(0, Ll.fa)(ql.JA)} ${null === (Kl = this._parent) || void 0 === Kl ? void 0 : Kl._t.pnx.report}
						</pnx-button>
				` : Co.s6}

				<pnx-button size="sm" @click=${()=>this._parent._showShareOptions()}>
					${(0, Ll.fa)(Ql.faShareNodes)} ${null === ($l = this._parent) || void 0 === $l ? void 0 : $l._t.pnx.share}
				</pnx-button>

				<slot name="editors">
					<pnx-widget-osmeditors ._parent=${this._parent} />
				</slot>
			</div>

			<pnx-picture-metadata class=${tu} ._parent=${this._parent}></pnx-picture-metadata>

			${this.collapsable ? Co.qy`<pnx-button
				kind="inline"
				size="sm"
				id="pic-legend-expand"
				@click=${()=>this._expanded = !this._expanded}
			>${this._expanded ? (0, Ll.fa)(Ul.w2) : (0, Ll.fa)(Gl.Jt)}</pnx-button>` : Co.s6}
		`;
                    }
                }
                PictureLegend.styles = [
                    Kl.qf,
                    Kl.nd,
                    Kl.R,
                    Co.AH`
		:host {
			overflow-y: auto;
			overflow-x: hidden;
			display: block;
			margin: 0;
			font-family: var(--font-family);
		}

		@media screen and (min-width: 576px) {
			:host { max-height: 70vh; }
			pnx-picture-metadata { width: 30vw; }
		}

		/* Top bar */
		.headline {
			display: flex;
			gap: 10px;
			align-items: center;
			margin: 10px 10px 5px 10px;
			justify-content: space-between;
		}

		/* Address line */
		#pic-legend-addr {
			line-height: 1.2em;
			font-size: 1em;
			margin-bottom: 2px;
			flex-grow: 5;
			font-weight: 800;
		}

		#pic-legend-addr span {
			display: inline-block;
			height: 100%;
			width: 100%;
		}

		/* Minimal info block */
		#pic-legend-info {
			margin: 10px;
			display: flex;
			gap: 10px;
			justify-content: space-around;
		}
		.info-block {
			display: flex;
			flex-shrink: 1;
			gap: 5px;
			font-weight: 600;
			font-size: 0.85em;
			align-items: center;
		}
		.info-block svg { height: 18px; }

		/* Expand button */
		#pic-legend-expand {
			display: block;
			margin-top: 5px;
			max-width: 100%;
		}
		#pic-legend-expand::part(btn) {
			border-radius: 10px;
			border-top-right-radius: 0;
			border-top-left-radius: 0;
		}

		/* Details block */
		pnx-picture-metadata {
			margin: 5px 10px 10px;
			display: block;
			max-width: 450px;
			box-sizing: border-box;
		}

		/* Details actions */
		#pic-legend-cta {
			display: flex;
			margin: 5px 10px;
			border-bottom-left-radius: 10px;
			border-bottom-right-radius: 10px;
			gap: 5px;
			flex-wrap: wrap;
		}

		/* More options menu */
		#pnx-legend-opts { min-width: unset; }

		/* Editors */
		#pic-legend-editors { margin: 0 10px; }
	`
                ], PictureLegend.properties = {
                    _caption: {
                        state: !0
                    },
                    _addr: {
                        state: !0
                    },
                    _expanded: {
                        state: !0
                    },
                    collapsable: {
                        type: Boolean
                    }
                }, customElements.define("pnx-picture-legend", PictureLegend);
            },
            6993: (Qe, rt, Wn)=>{
                "use strict";
                Wn.d(rt, {
                    A: ()=>PictureMetadata
                });
                var Co = Wn(4542), Dl = Wn(686), Ll = Wn(5995), Rl = Wn(3520), Ul = Wn(3233), Gl = Wn(99), Zl = Wn(5279), Hl = Wn(4954), ql = Wn(2077), Ql = Wn(5124), Kl = Wn(6668), $l = Wn(2593), Tc = Wn(4336), tu = Wn(6249), lu = Wn(8591), du = Wn(508), fu = Wn(7343);
                const missing = ()=>(0, Ll.fa)(Ql.Ev, {
                        styles: {
                            height: "16px"
                        }
                    });
                class PictureMetadata extends Co.WF {
                    constructor(){
                        super(), this._semanticsPicShowAll = !1;
                    }
                    connectedCallback() {
                        var Qe, rt, Wn, Co;
                        super.connectedCallback(), this._meta = null === (Qe = this._parent) || void 0 === Qe || null === (rt = Qe.psv) || void 0 === rt ? void 0 : rt.getPictureMetadata(), null === (Wn = this._parent) || void 0 === Wn || null === (Co = Wn.oncePSVReady) || void 0 === Co || Co.call(Wn).then(()=>{
                            this._parent.psv.addEventListener("picture-loaded", ()=>{
                                this._meta = this._parent.psv.getPictureMetadata();
                            }), this._parent.psv.addEventListener("annotation-click", ()=>{
                                const Qe = this.shadowRoot.querySelector("pnx-tabs");
                                Qe && Qe.setAttribute("activeTabIndex", 4);
                            });
                        });
                    }
                    _onQualityScoreClick() {
                        const Qe = this.shadowRoot.querySelector("pnx-tabs");
                        Qe && Qe.setAttribute("activeTabIndex", 3);
                    }
                    _toTab(Qe, rt) {
                        return Dl.qy`
			<h4 slot="title">${Qe}</h4>
			<div slot="content" class="data-blocks">
				${rt.filter((Qe)=>Qe).map((Qe)=>Dl.qy`<div class="data-block" style=${Qe.style}>
					<h5>${Qe.title}</h5>
					<div style=${Qe.content_style}>${Qe.content}</div>
				</div>`)}
			</div>
		`;
                    }
                    render() {
                        var Qe, rt, Wn, Ql, lu, yu, Eu, Tu, Lu, Zu, Xu, Ju, $u, ed, td, id, nd, rd, sd, ad, od, ld, cd, ud, hd, dd, pd, md, fd, gd, Ad, yd, vd, _d, xd, bd, wd, Ed, Md, Sd, Td, Cd, kd, Id, Dd, Ld, Pd, zd, Nd, Rd, Bd, Od, Fd;
                        if (!this._meta) return Co.s6;
                        const jd = (null === (Qe = this._parent) || void 0 === Qe ? void 0 : Qe.lang) || window.navigator.language, Ud = null === (rt = this._meta) || void 0 === rt || null === (Wn = rt.properties) || void 0 === Wn ? void 0 : Wn["pers:interior_orientation"], Vd = [
                            Ud.camera_manufacturer,
                            Ud.camera_model
                        ].filter((Qe)=>Qe).join(" "), Gd = null !== Ud && void 0 !== Ud && Ud.focal_length ? `${null === Ud || void 0 === Ud ? void 0 : Ud.focal_length} mm` : missing();
                        let Zd = null === Ud || void 0 === Ud ? void 0 : Ud.sensor_array_dimensions;
                        Zd && (Zd = `${Zd[0]} x ${Zd[1]} px (${Math.floor(Zd[0] * Zd[1] / 1e6)} Mpx)`);
                        let Hd = null === (Ql = this._parent) || void 0 === Ql ? void 0 : Ql._t.pnx.picture_flat, Wd = null === (lu = this._parent) || void 0 === lu ? void 0 : lu._t.pnx.picture_flat_long, qd = null === Ud || void 0 === Ud ? void 0 : Ud.field_of_view;
                        var Yd, Qd;
                        null !== qd && void 0 !== qd && (360 === qd ? (Hd = null === (Yd = this._parent) || void 0 === Yd ? void 0 : Yd._t.pnx.picture_360, Wd = null === (Qd = this._parent) || void 0 === Qd ? void 0 : Qd._t.pnx.picture_360_long) : Hd += ` (${qd}\xb0)`);
                        const Kd = [
                            {
                                title: null === (yu = this._parent) || void 0 === yu ? void 0 : yu._t.pnx.metadata_camera_make,
                                content: (null === Ud || void 0 === Ud ? void 0 : Ud.camera_manufacturer) || missing()
                            },
                            {
                                title: null === (Eu = this._parent) || void 0 === Eu ? void 0 : Eu._t.pnx.metadata_camera_model,
                                content: (null === Ud || void 0 === Ud ? void 0 : Ud.camera_model) || missing()
                            },
                            {
                                title: null === (Tu = this._parent) || void 0 === Tu ? void 0 : Tu._t.pnx.metadata_camera_type,
                                content: Hd
                            },
                            {
                                title: null === (Lu = this._parent) || void 0 === Lu ? void 0 : Lu._t.pnx.metadata_camera_resolution,
                                content: Zd || missing()
                            },
                            {
                                title: null === (Zu = this._parent) || void 0 === Zu ? void 0 : Zu._t.pnx.metadata_camera_focal_length,
                                content: Gd
                            },
                            (null === (Xu = this._meta) || void 0 === Xu || null === (Ju = Xu.caption) || void 0 === Ju ? void 0 : Ju.date) && {
                                title: null === ($u = this._parent) || void 0 === $u ? void 0 : $u._t.pnx.metadata_general_date,
                                content: Dl.qy`
					<strong>${new Intl.DateTimeFormat(jd, {
                                    timeZone: this._meta.caption.tz,
                                    dateStyle: "short"
                                }).format(this._meta.caption.date)}</strong>
					<br />${new Intl.DateTimeFormat(jd, {
                                    timeZone: this._meta.caption.tz,
                                    hour: "numeric",
                                    minute: "numeric",
                                    second: "numeric",
                                    fractionalSecondDigits: 3,
                                    timeZoneName: "longOffset"
                                }).format(this._meta.caption.date)}
				`
                            }
                        ], Xd = void 0 !== (null === (ed = this._meta) || void 0 === ed || null === (td = ed.properties) || void 0 === td ? void 0 : td["view:azimuth"]) && `${this._meta.properties["view:azimuth"]}\xb0`, Jd = [
                            {
                                title: null === (id = this._parent) || void 0 === id ? void 0 : id._t.pnx.metadata_location_coordinates,
                                content: Dl.qy`
					${this._meta.gps[0]}, ${this._meta.gps[1]}
					<pnx-copy-coordinates
						._parent=${this._parent}
						.gps=${this._meta.gps}
						style="margin-left: 10px"
					></pnx-copy-coordinates>
				`,
                                style: "width: 100%"
                            },
                            {
                                title: null === (nd = this._parent) || void 0 === nd ? void 0 : nd._t.pnx.metadata_location_orientation,
                                content: Xd || missing()
                            },
                            {
                                title: null === (rd = this._parent) || void 0 === rd ? void 0 : rd._t.pnx.metadata_location_precision,
                                content: (0, du.getGPSPrecision)(this._meta) || missing()
                            }
                        ], $d = (null === (sd = this._parent) || void 0 === sd || null === (ad = sd.map) || void 0 === ad || null === (od = ad._hasQualityScore) || void 0 === od ? void 0 : od.call(ad)) || (null === (ld = this._meta) || void 0 === ld || null === (cd = ld.properties) || void 0 === cd ? void 0 : cd["quality:horizontal_accuracy"]) || (null === (ud = this._meta) || void 0 === ud || null === (hd = ud.properties) || void 0 === hd ? void 0 : hd["panoramax:horizontal_pixel_density"]);
                        let up, gp;
                        if ($d) {
                            var Ap, vp, _p, xp, bp, wp, Ep, Mp, Sp, Tp, Cp;
                            const Qe = (0, fu.getGrade)(fu.QUALITYSCORE_GPS_VALUES, null === (Ap = this._meta) || void 0 === Ap || null === (vp = Ap.properties) || void 0 === vp ? void 0 : vp["quality:horizontal_accuracy"]), rt = (0, fu.getGrade)(360 === (null === (_p = this._meta) || void 0 === _p ? void 0 : _p.horizontalFov) ? fu.QUALITYSCORE_RES_360_VALUES : fu.QUALITYSCORE_RES_FLAT_VALUES, null === (xp = this._meta) || void 0 === xp || null === (bp = xp.properties) || void 0 === bp ? void 0 : bp["panoramax:horizontal_pixel_density"]);
                            gp = Math.round((rt || 1) * fu.QUALITYSCORE_POND_RES + (Qe || 1) * fu.QUALITYSCORE_POND_GPS), up = [
                                {
                                    title: Dl.qy`
						${null === (wp = this._parent) || void 0 === wp ? void 0 : wp._t.pnx.metadata_quality_score}
						<pnx-button
							title="${null === (Ep = this._parent) || void 0 === Ep ? void 0 : Ep._t.pnx.metadata_quality_help}"
							kind="superinline"
							@click=${()=>{
                                        var Qe;
                                        return null === (Qe = this._parent) || void 0 === Qe ? void 0 : Qe._showQualityScoreDoc();
                                    }}
						>
							${(0, Ll.fa)(Kl.iW)}
						</pnx-button>
					`,
                                    content: Dl.qy`<pnx-quality-score grade=${gp} style="font-size: 16px"></pnx-quality-score>`,
                                    style: "width: 100%"
                                },
                                {
                                    title: null === (Mp = this._parent) || void 0 === Mp ? void 0 : Mp._t.pnx.metadata_quality_gps_score,
                                    content: (0, Ll.createWebComp)("pnx-grade", {
                                        stars: Qe,
                                        _t: null === (Sp = this._parent) || void 0 === Sp ? void 0 : Sp._t
                                    })
                                },
                                {
                                    title: null === (Tp = this._parent) || void 0 === Tp ? void 0 : Tp._t.pnx.metadata_quality_resolution_score,
                                    content: (0, Ll.createWebComp)("pnx-grade", {
                                        stars: rt,
                                        _t: null === (Cp = this._parent) || void 0 === Cp ? void 0 : Cp._t
                                    })
                                }
                            ];
                        }
                        const kp = (this._meta.properties.semantics || []).length > 0 || (this._meta.properties.annotations || []).length > 0;
                        let Ip = [];
                        var Dp, Lp, Pp, zp, Np, Rp, Bp, Op, Fp;
                        kp && (Ip.push({
                            title: null === (Dp = this._parent) || void 0 === Dp ? void 0 : Dp._t.pnx.semantics_tags_picture,
                            style: "width: 100%",
                            content: Dl.qy`${(null === (Lp = this._meta.properties.semantics) || void 0 === Lp ? void 0 : Lp.length) > 0 ? Dl.qy`
						<pnx-button
							kind="outline"
							size="sm"
							style="width: 100%"
							@click=${()=>this._semanticsPicShowAll = !this._semanticsPicShowAll}
						>
							${this._semanticsPicShowAll ? (0, Ll.fa)(Tc.w2) : (0, Ll.fa)($l.Jt)}
							${this._semanticsPicShowAll ? null === (Pp = this._parent) || void 0 === Pp ? void 0 : Pp._t.pnx.semantics_hide_all_tags : null === (zp = this._parent) || void 0 === zp ? void 0 : zp._t.pnx.semantics_show_all_tags}
						</pnx-button>
						<pnx-semantics-table
							._t=${null === (Np = this._parent) || void 0 === Np ? void 0 : Np._t}
							.source=${this._meta.properties}
							style="margin-top: 5px"
							class=${this._semanticsPicShowAll ? "" : "pnx-hidden"}
						/>
					` : null === (Rp = this._parent) || void 0 === Rp ? void 0 : Rp._t.pnx.semantics_tags_picture_none}`
                        }), Ip.push({
                            title: null === (Bp = this._parent) || void 0 === Bp ? void 0 : Bp._t.pnx.semantics_features,
                            style: "width: 100%",
                            content: Dl.qy`
					${(null === (Op = this._meta.properties.annotations) || void 0 === Op ? void 0 : Op.length) > 0 ? Dl.qy`<pnx-annotations-list ._parent=${this._parent} />` : null === (Fp = this._parent) || void 0 === Fp ? void 0 : Fp._t.pnx.semantics_features_none}
				`
                        }));
                        const jp = Object.entries(this._meta.properties.exif).sort().filter((Qe)=>{
                            let [, rt] = Qe;
                            return rt;
                        }).map((Qe)=>{
                            let [rt, Wn] = Qe;
                            return JSON.stringify(Wn).includes("\\u") && (Wn = JSON.stringify(Wn).replace(/\\u[0-9A-Fa-f]{4}/g, (Qe)=>" 0x" + parseInt(Qe.slice(2), 16).toString(16).toUpperCase().padStart(4, "0")).slice(1, -1).trim()), {
                                title: rt,
                                content: Wn.length > 30 ? Dl.qy`<textarea readonly>${Wn}</textarea>` : Wn,
                                style: Wn.length > 30 ? "width: 100%" : void 0
                            };
                        });
                        jp.unshift({
                            content: Dl.qy`
				<pnx-link-button
					size="sm"
					target="_blank"
					href="https://exiv2.org/metadata.html"
					title=${null === (dd = this._parent) || void 0 === dd ? void 0 : dd._t.pnx.metadata_exif_doc_title}
				>${(0, Ll.fa)(Kl.iW)} ${null === (pd = this._parent) || void 0 === pd ? void 0 : pd._t.pnx.metadata_exif_doc}</pnx-link-button>
			`,
                            style: "width: 100%"
                        });
                        const Up = [
                            (null === (md = this._meta) || void 0 === md || null === (fd = md.caption) || void 0 === fd || null === (gd = fd.producer) || void 0 === gd ? void 0 : gd.length) > 0 && {
                                title: null === (Ad = this._parent) || void 0 === Ad ? void 0 : Ad._t.pnx.metadata_general_author,
                                content: Dl.qy`
					<strong>${this._meta.caption.producer[this._meta.caption.producer.length - 1]}</strong>
					${this._meta.caption.producer.length > 1 ? Dl.qy`<br />${this._meta.caption.producer.slice(0, -1).join(", ")}` : Co.s6}
				`
                            },
                            (null === (yd = this._meta) || void 0 === yd || null === (vd = yd.caption) || void 0 === vd ? void 0 : vd.date) && {
                                title: null === (_d = this._parent) || void 0 === _d ? void 0 : _d._t.pnx.metadata_general_date,
                                content: Dl.qy`
					<strong>${new Intl.DateTimeFormat(jd, {
                                    timeZone: this._meta.caption.tz,
                                    dateStyle: "long"
                                }).format(this._meta.caption.date)}</strong>
					<br />${new Intl.DateTimeFormat(jd, {
                                    timeZone: this._meta.caption.tz,
                                    hour: "numeric",
                                    minute: "numeric"
                                }).format(this._meta.caption.date)}
				`
                            },
                            Ud && {
                                title: null === (xd = this._parent) || void 0 === xd ? void 0 : xd._t.pnx.metadata_camera,
                                content: Dl.qy`
					<strong>${Vd.length > 0 ? Vd : missing()}</strong>
					<br />${Wd}
				`
                            },
                            (null === (bd = this._meta) || void 0 === bd || null === (wd = bd.caption) || void 0 === wd ? void 0 : wd.license) && {
                                title: null === (Ed = this._parent) || void 0 === Ed ? void 0 : Ed._t.pnx.metadata_general_license,
                                content: Dl.qy`${(0, Dl.Bk)(this._meta.caption.license)}`
                            },
                            $d && {
                                title: null === (Md = this._parent) || void 0 === Md ? void 0 : Md._t.pnx.metadata_quality,
                                content: Dl.qy`<pnx-quality-score
					grade=${gp}
					style="font-size: 14px; cursor: pointer"
					@click=${this._onQualityScoreClick}
				/>`
                            },
                            {
                                title: null === (Sd = this._parent) || void 0 === Sd ? void 0 : Sd._t.pnx.metadata_general_copy_id,
                                content_style: "display: flex; gap: 5px;",
                                content: Dl.qy`
					<pnx-copy-button
						kind="outline"
						size="sm"
						._t=${null === (Td = this._parent) || void 0 === Td ? void 0 : Td._t}
						text=${this._meta.id}
						style="flex: 1"
					>
						${(0, Ll.fa)(Zl.jb)} ${null === (Cd = this._parent) || void 0 === Cd ? void 0 : Cd._t.pnx.metadata_general_picid}
					</pnx-copy-button>
					<pnx-copy-button
						kind="outline"
						size="sm"
						._t=${null === (kd = this._parent) || void 0 === kd ? void 0 : kd._t}
						text=${this._meta.sequence.id}
						style="flex: 1"
					>
						${(0, Ll.fa)(Hl.yv)} ${null === (Id = this._parent) || void 0 === Id ? void 0 : Id._t.pnx.metadata_general_seqid}
					</pnx-copy-button>
				`
                            },
                            (null === (Dd = this._meta) || void 0 === Dd ? void 0 : Dd.origInstance) && {
                                title: null === (Ld = this._parent) || void 0 === Ld ? void 0 : Ld._t.pnx.metadata_general_instance,
                                content: Dl.qy`<strong><a href=${this._meta.origInstance.href + window.location.search} target="_blank">
					${this._meta.origInstance.instance_name || this._meta.origInstance.href.replace(/^http.?:\/\//, "")}
				</a></strong>`
                            }
                        ];
                        return Dl.qy`<pnx-tabs>
			${this._toTab(Dl.qy`${(0, Ll.fa)(Zl.jb)} ${null === (Pd = this._parent) || void 0 === Pd ? void 0 : Pd._t.pnx.metadata_summary}`, Up)}

			${this._toTab(Dl.qy`${(0, Ll.fa)(Gl.rw)} ${null === (zd = this._parent) || void 0 === zd ? void 0 : zd._t.pnx.metadata_camera}`, Kd)}

			${this._toTab(Dl.qy`${(0, Ll.fa)(Rl.gK)} ${null === (Nd = this._parent) || void 0 === Nd ? void 0 : Nd._t.pnx.metadata_location}`, Jd)}

			${$d ? this._toTab(Dl.qy`${(0, Ll.fa)(Ul.B9)} ${null === (Rd = this._parent) || void 0 === Rd ? void 0 : Rd._t.pnx.metadata_quality}`, up) : Co.s6}

			${kp ? this._toTab(Dl.qy`${(0, Ll.fa)(tu.DX)} ${null === (Bd = this._parent) || void 0 === Bd ? void 0 : Bd._t.pnx.semantics_title}`, Ip) : Co.s6}

			${null !== (Od = this._meta.properties) && void 0 !== Od && Od.exif ? this._toTab(Dl.qy`${(0, Ll.fa)(ql.DD)} ${null === (Fd = this._parent) || void 0 === Fd ? void 0 : Fd._t.pnx.metadata_exif}`, jp) : Co.s6}
		</pnx-tabs>`;
                    }
                }
                PictureMetadata.styles = [
                    lu.Op,
                    lu.YC,
                    lu.PC,
                    lu.R,
                    Co.AH`
		div[slot="content"] {
			padding: 5px 10px;
			background-color: #ededed;
		}

		/* Small data blocks */
		.data-block {
			display: inline-block;
			min-width: 50%;
			margin: 8px 0;
			box-sizing: border-box;
			vertical-align: top;
		}
		.data-block h5 {
			font-size: 0.8em;
			font-weight: 400;
			color: var(--blue-dark);
			margin: 0 0 5px 0;
		}
		.data-block h5 pnx-button { vertical-align: middle; }
		.data-block h5 svg.svg-inline--fa { height: 14px; }
		.data-block div {
			font-size: 0.8em;
		}

		pnx-semantics-table {
			overflow-x: auto;
  			display: block;
		}
	`
                ], PictureMetadata.properties = {
                    _meta: {
                        state: !0
                    },
                    _semanticsPicShowAll: {
                        state: !0
                    }
                }, customElements.define("pnx-picture-metadata", PictureMetadata);
            },
            499: (Qe, rt, Wn)=>{
                "use strict";
                Wn.d(rt, {
                    A: ()=>PlayerOptions
                });
                var Co = Wn(4542), Dl = Wn(8591), Ll = Wn(7744), Rl = Wn(325), Ul = Wn(9243), Gl = Wn(9048), Zl = Wn(5995);
                class PlayerOptions extends Co.WF {
                    connectedCallback() {
                        var Qe, rt;
                        super.connectedCallback(), null === (Qe = this._parent) || void 0 === Qe || null === (rt = Qe.psv) || void 0 === rt || rt.addEventListener("transition-duration-changed", (Qe)=>{
                            this.renderRoot.querySelector("#pnx-player-speed").value = Gl.Vf - Qe.detail.value;
                        });
                    }
                    _onSpeedChange(Qe) {
                        var rt, Wn;
                        const Co = Gl.Vf - Qe.target.value;
                        null === (rt = this._parent) || void 0 === rt || null === (Wn = rt.psv) || void 0 === Wn || Wn.setTransitionDuration(Co);
                    }
                    _onContrastClick() {
                        const Qe = this.renderRoot.querySelector("#pnx-player-contrast");
                        var rt, Wn, Co, Dl;
                        "true" == Qe.getAttribute("active") ? (Qe.removeAttribute("active"), null === (rt = this._parent) || void 0 === rt || null === (Wn = rt.psv) || void 0 === Wn || Wn.setHigherContrast(!1)) : (Qe.setAttribute("active", "true"), null === (Co = this._parent) || void 0 === Co || null === (Dl = Co.psv) || void 0 === Dl || Dl.setHigherContrast(!0));
                    }
                    render() {
                        var Qe, rt, Wn, Dl;
                        return Co.qy`
			<div class="pnx-input-range" title="${null === (Qe = this._parent) || void 0 === Qe ? void 0 : Qe._t.pnx.sequence_speed}">
				${(0, Zl.fa)(Ul.rO)}
				<input
					id="pnx-player-speed"
					type="range" name="speed"
					min="0" max="${Gl.Vf - 100}"
					value="${Gl.Vf - (null === (rt = this._parent) || void 0 === rt ? void 0 : rt.psv.getTransitionDuration())}"
					title="${null === (Wn = this._parent) || void 0 === Wn ? void 0 : Wn._t.pnx.sequence_speed}"
					style="width: 100%;"
					@change=${this._onSpeedChange}
				/>
				${(0, Zl.fa)(Ll.KM)}
			</div>
			<pnx-button
				id="pnx-player-contrast"
				title="${null === (Dl = this._parent) || void 0 === Dl ? void 0 : Dl._t.pnx.contrast}"
				kind="outline"
				@click=${this._onContrastClick}
			>
				${(0, Zl.fa)(Rl.rC)}
			</pnx-button>
		`;
                    }
                }
                PlayerOptions.styles = [
                    Dl.Op,
                    Co.AH`
		:host {
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: center;
			gap: 15px;
			padding: 5px 15px;
		}

		.pnx-input-range {
			display: flex;
			justify-content: space-between;
			gap: 10px;
			align-items: center;
			width: 100%;
		}
	`
                ], customElements.define("pnx-player-options", PlayerOptions);
            },
            5187: (Qe, rt, Wn)=>{
                "use strict";
                Wn.d(rt, {
                    A: ()=>QualityScoreDoc
                });
                var Co = Wn(4542), Dl = Wn(8591), Ll = Wn(5995), Rl = Wn(3233);
                class QualityScoreDoc extends Co.WF {
                    render() {
                        var Qe, rt, Wn, Dl, Ul;
                        return Co.qy`
			<h4>${(0, Ll.fa)(Rl.B9)} ${null === (Qe = this._t) || void 0 === Qe ? void 0 : Qe.pnx.qualityscore_title}</h4>
			<p>${null === (rt = this._t) || void 0 === rt ? void 0 : rt.pnx.qualityscore_doc_1}</p>
			<p>${null === (Wn = this._t) || void 0 === Wn ? void 0 : Wn.pnx.qualityscore_doc_2}</p>
			<pnx-quality-score grade="5"></pnx-quality-score>
			<p>${null === (Dl = this._t) || void 0 === Dl ? void 0 : Dl.pnx.qualityscore_doc_3}</p>
			<pnx-link-button
				href="https://docs.panoramax.fr/pictures-metadata/quality_score/"
				target="_blank"
				kind="outline"
				style="width: 100%"
			>${null === (Ul = this._t) || void 0 === Ul ? void 0 : Ul.pnx.qualityscore_doc_link}</pnx-link-button>
		`;
                    }
                }
                QualityScoreDoc.styles = [
                    Dl.YC,
                    Dl.Op
                ], customElements.define("pnx-quality-score-doc", QualityScoreDoc);
            },
            9588: (Qe, rt, Wn)=>{
                "use strict";
                Wn.d(rt, {
                    A: ()=>ReportForm
                });
                var Co = Wn(4542), Dl = Wn(8591), Ll = Wn(5995), Rl = Wn(4881), Ul = Wn(6311), Gl = Wn(7516), Zl = Wn(2975), Hl = Wn(1708), ql = Wn(7343);
                const Ql = [
                    "",
                    "blur_missing",
                    "blur_excess",
                    "inappropriate",
                    "privacy",
                    "picture_low_quality",
                    "mislocated",
                    "copyright",
                    "other"
                ];
                class ReportForm extends Co.WF {
                    _onSubmit(Qe) {
                        var rt, Wn, Co, Dl;
                        Qe.preventDefault();
                        const Ll = null === (rt = this._parent) || void 0 === rt || null === (Wn = rt.psv) || void 0 === Wn ? void 0 : Wn.getPictureMetadata(), Rl = Object.fromEntries(new FormData(Qe.target)), Ul = {
                            issue: Rl.issue,
                            picture_id: Rl["whole-sequence"] ? null : null === Ll || void 0 === Ll ? void 0 : Ll.id,
                            reporter_comments: Rl.comments,
                            reporter_email: Rl.email,
                            sequence_id: null === Ll || void 0 === Ll || null === (Co = Ll.sequence) || void 0 === Co ? void 0 : Co.id
                        };
                        this.mode = "wait", null === (Dl = this._parent) || void 0 === Dl || Dl.api.sendReport(Ul).then(()=>{
                            this.mode = "success";
                        }).catch((Qe)=>{
                            console.error(Qe), this.mode = "failure", this.failure = Qe;
                        });
                    }
                    render() {
                        var Qe, rt, Wn, Dl, Kl, $l, Tc, tu, lu, du;
                        const fu = (0, ql.getUserAccount)();
                        var yu, Eu, Tu, Lu;
                        return this.mode ? Co.qy`
				<h4>${(0, Ll.fa)(Ul.JA)} ${null === (yu = this._parent) || void 0 === yu ? void 0 : yu._t.pnx.report}</h4>
				<p>
					${"wait" === this.mode ? null === (Eu = this._parent) || void 0 === Eu ? void 0 : Eu._t.pnx.report_wait : Co.s6}
					${"success" === this.mode ? null === (Tu = this._parent) || void 0 === Tu ? void 0 : Tu._t.pnx.report_success : Co.s6}
					${"failure" === this.mode ? null === (Lu = this._parent) || void 0 === Lu ? void 0 : Lu._t.pnx.report_failure.replace("{e}", this.failure) : Co.s6}
				</p>
			` : Co.qy`
			<h4>${(0, Ll.fa)(Ul.JA)} ${null === (Qe = this._parent) || void 0 === Qe ? void 0 : Qe._t.pnx.report}</h4>

			${fu && null !== (rt = this._parent) && void 0 !== rt && rt._t ? Co.qy`
				<p>${null === (Wn = this._parent) || void 0 === Wn ? void 0 : Wn._t.pnx.report_auth.replace("{a}", fu.name)}</p>
			` : Co.s6}

			<form @submit=${this._onSubmit.bind(this)}>
				<div class="group">
					<label for="issue">${(0, Ll.fa)(Gl.faCircleInfo)} ${null === (Dl = this._parent) || void 0 === Dl ? void 0 : Dl._t.pnx.report_nature_label}</label>
					<select name="issue" id="issue" required class="pnx-100w">
						${Ql.map((Qe)=>{
                            var rt;
                            return Co.qy`
							<option
								value=${Qe}
								${"" === Qe ? Co.qy`disabled selected hidden` : Co.s6}
							>
								${null === (rt = this._parent) || void 0 === rt ? void 0 : rt._t.pnx.report_nature[Qe]}
							</option>
						`;
                        })}
					</select>
				</div>

				<div class="group group-inline">
					<input name="whole-sequence" id="whole-sequence" type="checkbox" />
					<label for="whole-sequence">${null === (Kl = this._parent) || void 0 === Kl ? void 0 : Kl._t.pnx.report_whole_sequence}</label>
				</div>

				<div class="group">
					<label for="comments">${(0, Ll.fa)(Zl.Be)} ${null === ($l = this._parent) || void 0 === $l ? void 0 : $l._t.pnx.report_details}</label>
					<textarea name="comments" id="comments" placeholder=${null === (Tc = this._parent) || void 0 === Tc ? void 0 : Tc._t.pnx.report_details_placeholder}></textarea>
				</div>

				${fu ? Co.s6 : Co.qy`
					<div class="group">
						<label for="email">${(0, Ll.fa)(Rl.Hz)} ${null === (tu = this._parent) || void 0 === tu ? void 0 : tu._t.pnx.report_email}</label>
						<input type="email" name="email" id="email" placeholder=${null === (lu = this._parent) || void 0 === lu ? void 0 : lu._t.pnx.report_email_placeholder} class="pnx-100w" />
					</div>
				`}

				<pnx-button type="submit" style="width: 100%">
					${(0, Ll.fa)(Hl.is)} ${null === (du = this._parent) || void 0 === du ? void 0 : du._t.pnx.report_submit}
				</pnx-button>
			</form>
		`;
                    }
                }
                ReportForm.styles = [
                    Dl.YC,
                    Dl.Op,
                    Dl.Lt,
                    Dl.PC,
                    Dl.hF,
                    Co.AH`
		.group {
			margin-bottom: 10px;
		}

		.group:not(.group-inline) label {
			margin-bottom: 5px;
			display: inline-block;
		}
	`
                ], ReportForm.properties = {
                    mode: {
                        state: !0
                    },
                    failure: {
                        state: !0
                    }
                }, customElements.define("pnx-report-form", ReportForm);
            },
            3765: (Qe, rt, Wn)=>{
                "use strict";
                Wn.d(rt, {
                    A: ()=>ShareMenu
                });
                var Co = Wn(4542), Dl = Wn(5995), Ll = Wn(8591), Rl = Wn(2e3), Ul = Wn(7516), Gl = Wn(6002), Zl = Wn(7964);
                class ShareMenu extends Co.WF {
                    constructor(){
                        super(), this._onUrlChange();
                    }
                    connectedCallback() {
                        var Qe;
                        super.connectedCallback(), null === (Qe = this._parent) || void 0 === Qe || Qe.onceReady().then(()=>{
                            this._onUrlChange(), this._parent.urlHandler.addEventListener("url-changed", this._onUrlChange.bind(this));
                        });
                    }
                    _onUrlChange() {
                        var Qe, rt;
                        const Wn = window.location.href.replace(/\/$/, "");
                        this._url = (null === (Qe = this._parent) || void 0 === Qe || null === (rt = Qe.urlHandler) || void 0 === rt ? void 0 : rt.nextShortLink(Wn)) || Wn;
                    }
                    render() {
                        var Qe, rt, Wn, Ll, Hl, ql;
                        const Ql = `<iframe src="${this._url}" style="border: none; width: 500px; height: 300px"></iframe>`;
                        return Co.qy`
			<h4>${(0, Dl.fa)(Gl.QO)} ${null === (Qe = this._parent) || void 0 === Qe ? void 0 : Qe._t.pnx.share}</h4>
			<pnx-tabs>
				<h4 slot="title">${(0, Dl.fa)(Zl.CQ)} ${null === (rt = this._parent) || void 0 === rt ? void 0 : rt._t.pnx.share_page}</h4>
				<div slot="content">
					<div class="links">
						<input type="text" readonly value=${this._url} style="flex: 2" />
						<pnx-copy-button ._t=${null === (Wn = this._parent) || void 0 === Wn ? void 0 : Wn._t} text=${this._url}></pnx-copy-button>
					</div>
				</div>
					
				<h4 slot="title">${(0, Dl.fa)(Rl.e5)} ${null === (Ll = this._parent) || void 0 === Ll ? void 0 : Ll._t.pnx.share_embed}</h4>
				<div slot="content">
					<div class="embed">
						<pnx-link-button
							href="https://docs.panoramax.fr/web-viewer/03_URL_settings/"
							target="_blank"
							kind="superinline"
							size="sm"
						>
							${(0, Dl.fa)(Ul.faCircleInfo)} ${null === (Hl = this._parent) || void 0 === Hl ? void 0 : Hl._t.pnx.share_embed_docs}
						</pnx-link-button>
						<textarea readonly>${Ql}</textarea>
						<pnx-copy-button
							._t=${null === (ql = this._parent) || void 0 === ql ? void 0 : ql._t}
							text=${Ql}
							style="width: 100%"
						></pnx-copy-button>
					</div>
				</div>
			</pnx-tabs>`;
                    }
                }
                ShareMenu.styles = [
                    Ll.Op,
                    Ll.hF,
                    Ll.PC,
                    Ll.YC,
                    Co.AH`
		div[slot="content"] {
			margin-top: 10px;
		}
		.links {
			display: flex;
			gap: 5px;
		}
		.embed {
			display: flex;
			gap: 5px;
			align-items: center;
			flex-direction: column;
		}
	`
                ], ShareMenu.properties = {
                    _url: {
                        state: !0
                    }
                }, customElements.define("pnx-share-menu", ShareMenu);
            },
            8794: (Qe, rt, Wn)=>{
                "use strict";
                Wn.r(rt), Wn.d(rt, {
                    AnnotationsList: ()=>Co.A,
                    MapBackground: ()=>Rl.A,
                    MapFilters: ()=>Dl.A,
                    MapLayers: ()=>Ll.A,
                    MapLegend: ()=>Ql.A,
                    PictureLegend: ()=>ql.A,
                    PictureMetadata: ()=>Kl.A,
                    PlayerOptions: ()=>Ul.A,
                    QualityScoreDoc: ()=>Gl.A,
                    ReportForm: ()=>Zl.A,
                    Share: ()=>Hl.A
                });
                var Co = Wn(1208), Dl = Wn(3581), Ll = Wn(5334), Rl = Wn(5036), Ul = Wn(499), Gl = Wn(5187), Zl = Wn(9588), Hl = Wn(3765), ql = Wn(3589), Ql = Wn(4749), Kl = Wn(6993);
            },
            8591: (Qe, rt, Wn)=>{
                "use strict";
                Wn.d(rt, {
                    BQ: ()=>Tc,
                    HM: ()=>Hl,
                    Lt: ()=>Gl,
                    Op: ()=>Rl,
                    PC: ()=>Ul,
                    R: ()=>Ll,
                    YC: ()=>Ql,
                    hF: ()=>Zl,
                    kq: ()=>ql,
                    nd: ()=>Dl,
                    qf: ()=>$l,
                    s0: ()=>Kl,
                    tp: ()=>tu,
                    wS: ()=>lu
                });
                var Co = Wn(4542);
                const Dl = Co.AH`
	.pnx-panel {
		position: absolute;
		transition: opacity 0.2s 0.1s;
		border-radius: 25px;
		border: 1px solid var(--widget-border-div);
		background-color: var(--widget-bg);
		color: var(--widget-font);
		min-width: 250px;
		box-sizing: border-box;
		font-family: var(--font-family);
	}

	.pnx-panel.pnx-hidden {
		opacity: 0;
		display: block !important;
		pointer-events: none;
	}

	.pnx-panel.pnx-padded {
		padding: 15px;
	}
`, Ll = Co.AH`
	.pnx-hidden { display: none !important; }
`, Rl = Co.AH`
	.svg-inline--fa {
		display: var(--fa-display, inline-block);
		height: 1em;
		overflow: visible;
		vertical-align: -0.125em;
	}
	svg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {
		overflow: visible;
		box-sizing: content-box;
	}
	@keyframes fa-spin {
		from {transform:rotate(0deg);}
		to {transform:rotate(360deg);}
	}
	.fa-spin {
		animation: fa-spin 2s infinite linear;
	}
`, Ul = Co.AH`
	textarea {
		background-color: var(--widget-bg);
		color: var(--widget-font);
		border: 1px solid var(--widget-border-div);
		border-radius: 10px;
		padding: 5px;
		width: 100%;
		box-sizing: border-box;
		font-family: var(--font-family);
	}
`, Gl = Co.AH`
	select {
		background-color: var(--widget-bg);
		color: var(--widget-font);
		border: 1px solid var(--widget-border-div);
		border-radius: 20px;
		font-size: 16px;
		padding: 2px 10px;
		font-family: var(--font-family);
	}

	select.pnx-100w {
		width: 100%;
		box-sizing: border-box;
	}
`, Zl = Co.AH`
	input {
		background-color: var(--widget-bg);
		color: var(--widget-font);
		border: 1px solid var(--widget-border-div);
		border-radius: 20px;
		font-size: 16px;
		padding: 2px 10px;
		font-family: var(--font-family);
	}

	input.pnx-100w {
		width: 100%;
		box-sizing: border-box;
	}
`, Hl = Co.AH`
	:host {
		display: inline-flex;
	}
	
	/* Common properties */
	.pnx-btn {
		white-space: nowrap;
		font-size: 1em;
		font-family: var(--font-family);
		flex-grow: 1;
		flex-shrink: 1;
		text-align: center;
		padding: 5px;
		font-weight: 600;
		flex-basis: 30%;
		line-height: 18px;
		justify-content: center;
		border-radius: 8px;
		cursor: pointer;
		text-decoration: none;
		display: inline-flex;
		align-items: center;
		gap: 5px;
		position: relative;
		width: 100%;
		height: 100%;
		min-width: 26px;
	}

	.pnx-btn:disabled { color: var(--widget-bg-inactive); }

	.pnx-btn.pnx-btn-active,
	.pnx-btn.pnx-btn-active:hover,
	.pnx-btn.pnx-btn-full.pnx-btn-active:hover,
	.pnx-btn.pnx-btn-outline.pnx-btn-active:hover {
		background-color: var(--widget-bg-active);
		border-color: var(--widget-bg-active);
		color: var(--widget-font-active);
	}

	.pnx-btn .svg-inline--fa,
	.pnx-btn ::slotted(.svg-inline--fa),
	.pnx-btn slot .svg-inline--fa {
		height: 16px;
	}

	/* Sizing */
	.pnx-btn-sm {
		border-radius: 6px;
		line-height: 12px;
		font-size: 12px;
		min-width: unset;
	}

	.pnx-btn.pnx-btn-sm .svg-inline--fa,
	.pnx-btn.pnx-btn-sm ::slotted(.svg-inline--fa) {
		height: 12px;
	}

	.pnx-btn-l {
		border-radius: 12px;
		height: 24px;
		line-height: 24px;
		font-size: 20px;
		min-width: 24px;
	}

	.pnx-btn-xl {
		border-radius: 20px;
		height: 40px;
		line-height: 40px;
		font-size: 16px;
		font-weight: 500;
		min-width: 40px;
		padding: 0 10px;
		gap: 8px;
	}

	.pnx-btn.pnx-btn-xl .svg-inline--fa,
	.pnx-btn.pnx-btn-xl ::slotted(.svg-inline--fa) {
		height: 16px;
	}

	.pnx-btn-xxl {
		border-radius: 28px;
		height: 56px;
		line-height: 56px;
		font-size: 24px;
		min-width: 56px;
	}

	.pnx-btn.pnx-btn-xxl .svg-inline--fa,
	.pnx-btn.pnx-btn-xxl ::slotted(.svg-inline--fa) {
		height: 24px;
	}

	/* Fully-filled style */
	.pnx-btn-full {
		background-color: var(--widget-bg-primary);
		color: var(--widget-font-direct);
		border: none;
	}

	.pnx-btn-full:not(:disabled):hover {
		background-color: var(--widget-bg-primary-hover);
	}

	/* Outline style */
	.pnx-btn-outline {
		border: 1px solid var(--widget-border-btn);
		color: var(--widget-font-direct);
		background-color: var(--widget-bg);
	}

	.pnx-btn-outline:not(:disabled):hover {
		background-color: var(--widget-bg-hover);
	}

	/* Flat style */
	.pnx-btn-flat,
	.pnx-btn-flat.pnx-btn-active,
	.pnx-btn-flat.pnx-btn-active:hover,
	.pnx-btn-flat:not(:disabled):hover {
		border: 1px solid var(--widget-border-div);
		color: var(--widget-font);
		background-color: var(--widget-bg);
	}

	.pnx-btn-flat:not(:disabled):hover {
		background-color: var(--widget-bg-hover);
	}

	/* Superflat style */
	.pnx-btn-superflat,
	.pnx-btn-superflat.pnx-btn-active,
	.pnx-btn-superflat.pnx-btn-active:hover,
	.pnx-btn-superflat:not(:disabled):hover {
		border: 1px solid var(--widget-border-div);
		color: var(--widget-font-direct);
		background-color: var(--widget-bg);
	}

	.pnx-btn-superflat:not(:disabled):hover {
		background-color: var(--widget-bg-hover);
	}

	/* Inline style */
	.pnx-btn-inline,
	.pnx-btn-inline.pnx-btn-active,
	.pnx-btn-inline.pnx-btn-active:hover,
	.pnx-btn-inline:not(:disabled):hover,
	.pnx-btn-superinline,
	.pnx-btn-superinline.pnx-btn-active,
	.pnx-btn-superinline.pnx-btn-active:hover,
	.pnx-btn-superinline:not(:disabled):hover {
		border: none;
		color: var(--widget-font);
		background: none;
	}

	.pnx-btn-inline:not(:disabled):hover,
	.pnx-btn-superinline:not(:disabled):hover {
		background-color: var(--widget-bg-hover);
	}

	/* Superinline style */
	.pnx-btn-superinline,
	.pnx-btn-superinline.pnx-btn-active,
	.pnx-btn-superinline.pnx-btn-active:hover,
	.pnx-btn-superinline:not(:disabled):hover {
		color: var(--widget-font-direct);
	}
`, ql = Co.AH`
	pnx-button-group > pnx-button {
		display: inline-flex;
	}

	pnx-button-group > pnx-button::part(btn) {
		height: unset;
	}

	/* Togglable in group */
	pnx-button-group > pnx-togglable-group > pnx-button {
		width: 100%;
		height: 100%;
	}

	/* Row */
	pnx-button-group[dir="row"] > :not(:first-child):not(:last-child)::part(btn),
	pnx-button-group[dir="row"] > :not(:first-child):not(:last-child) > ::part(btn) {
		border-radius: 0;
		border-left: none;
		border-right: none;
	}

	pnx-button-group[dir="row"] > :first-child::part(btn),
	pnx-button-group[dir="row"] > :first-child > ::part(btn) {
		border-top-right-radius: 0;
		border-bottom-right-radius: 0;
		border-right: none;
	}

	pnx-button-group[dir="row"] > :last-child::part(btn),
	pnx-button-group[dir="row"] > :last-child > ::part(btn) {
		border-top-left-radius: 0;
		border-bottom-left-radius: 0;
		border-left: none;
	}

	/* Column */
	pnx-button-group[dir="column"] > :not(:first-child):not(:last-child)::part(btn),
	pnx-button-group[dir="column"] > :not(:first-child):not(:last-child) > ::part(btn) {
		border-radius: 0;
		border-top: none;
		border-bottom: none;
	}

	pnx-button-group[dir="column"] > :first-child::part(btn),
	pnx-button-group[dir="column"] > :first-child > ::part(btn) {
		border-bottom-right-radius: 0;
		border-bottom-left-radius: 0;
		border-bottom: none;
	}

	pnx-button-group[dir="column"] > :last-child::part(btn),
	pnx-button-group[dir="column"] > :last-child > ::part(btn) {
		border-top-left-radius: 0;
		border-top-right-radius: 0;
		border-top: none;
	}
`, Ql = Co.AH`
	h1, h2, h3, h4, h5, h6 {
		font-family: var(--font-family);
	}
	
	h3 {
		font-size: 1.1em;
		line-height: 1.1em;
		font-weight: 500;
		margin: 10px 0 10px 0;
	}

	h4 {
		font-size: 1.0em;
		line-height: 1.0em;
		font-weight: 500;
		margin: 15px 0;
		display: flex;
		align-items: center;
		justify-content: flex-start;
		gap: 5px;
	}

	h4:first-of-type { margin-top: 0; }

	h4 > svg.svg-inline--fa {
		height: 18px;
	}

	h4[slot="title"] {
		margin: 0;
		justify-content: center;
		font-size: 0.8em;
		line-height: 2em;
		padding: 0.5em 0;
	}
	h4[slot="title"] svg.svg-inline--fa {
		height: 14px;
	}
`, Kl = Co.AH`
	.pnx-active-icon {
		box-sizing: border-box;
		background-color: var(--orange);
		border: 3px solid #fff;
		border-radius: 8px;
		height: 15px;
		left: 20px;
		position: absolute;
		top: 5px;
		width: 15px;
	}
`, $l = Co.AH`
	@keyframes animatedBackground {
		from {
			background-position: 0 0;
		}
		to {
			background-position: 1000px 0;
		}
	}

	.pnx-placeholder-loading {
		width: 100px;
		height: 100px;
		background-image: linear-gradient(
			90deg,
			#e4e4e4 0%,
			#f1f1f1 40%,
			#ededed 60%,
			#e4e4e4 100%
		);
		background-position: 0px 0px;
		background-repeat: repeat;
		animation: animatedBackground 5s linear infinite;
	}
`, Tc = (Co.AH`
	details summary {
		font-size: 1.0em;
		line-height: 1.0em;
		font-weight: 500;
		margin: 15px 0;
		cursor: pointer;
	}

	details summary svg {
		height: 18px;
		vertical-align: sub;
		margin-right: 2px;
	}
`, Co.AH`
	@media print {
		.pnx-print-hidden { display: none !important; }
	}
`), tu = Co.AH`
	table {
		border-collapse: collapse;
		font-size: 0.9rem;
		width: 100%;
		max-width: 100%;
		font-family: var(--font-family);
		background: var(--white);
	}

	th, td {
		padding: 10px;
		text-align: left;
		border-bottom: 1px solid #ddd;
	}

	th { font-weight: 600; }
`, lu = Co.AH`
	iconify-icon {
		display: inline-block;
		width: 1em;
		height: 1em;
	}
`;
            },
            4450: (Qe, rt, Wn)=>{
                "use strict";
                Wn.d(rt, {
                    A: ()=>Button
                });
                var Co = Wn(4542), Dl = Wn(8591);
                class Button extends Co.WF {
                    constructor(){
                        super(), this.active = !1, this.disabled = !1, this.kind = "full", this.size = "md";
                    }
                    connectedCallback() {
                        super.connectedCallback(), "submit" === this.type && this.addEventListener("click", ()=>{
                            var Qe;
                            return null === (Qe = this.closest("FORM")) || void 0 === Qe ? void 0 : Qe.requestSubmit();
                        });
                    }
                    render() {
                        const Qe = document.createElement("button");
                        Qe.setAttribute("part", "btn"), this.constructor.observedAttributes.filter((Qe)=>void 0 !== this[Qe] && !1 !== this[Qe] && ![
                                "active",
                                "kind",
                                "size"
                            ].includes(Qe)).forEach((rt)=>Qe.setAttribute(rt, this[rt])), Qe.classList.add("pnx-btn", `pnx-btn-${this.kind}`, `pnx-btn-${this.size}`), this.active && Qe.classList.add("pnx-btn-active");
                        const rt = document.createElement("slot");
                        return Qe.appendChild(rt), Qe;
                    }
                }
                Button.styles = Dl.HM, Button.properties = {
                    active: {
                        type: Boolean
                    },
                    kind: {
                        type: String
                    },
                    size: {
                        type: String
                    },
                    disabled: {
                        type: Boolean
                    },
                    type: {
                        type: String
                    },
                    title: {
                        type: String
                    }
                }, customElements.define("pnx-button", Button);
            },
            7679: (Qe, rt, Wn)=>{
                "use strict";
                Wn.d(rt, {
                    A: ()=>ButtonGroup
                });
                var Co = Wn(4542);
                Wn(1870);
                class ButtonGroup extends Co.WF {
                    constructor(){
                        super(), this.dir = "row", this.size = "md";
                    }
                    render() {
                        return Co.qy`<div class="${this.dir} ${this.size}">
			<slot></slot>
		</div>`;
                    }
                }
                ButtonGroup.styles = Co.AH`
		div {
			display: flex;
			flex-wrap: nowrap;
			align-items: stretch;
			align-content: stretch;
			justify-content: center;
		}

		div.row { flex-direction: row; }
		div.column { flex-direction: column; }

		div.xl { line-height: 38px; font-size: 20px; }
		div.row.xl { height: 38px; }
		div.column.xl { width: 38px; }

		div.row ::slotted(*) { height: 100%; min-width: 24px; }
		div.column ::slotted(*) { width: 100%; min-height: 24px; }

		div.row.xl ::slotted(*) { min-width: 38px; }
		div.column.xl ::slotted(*) { min-height: 38px; }
	`, ButtonGroup.properties = {
                    dir: {
                        type: String
                    },
                    size: {
                        type: String
                    }
                }, customElements.define("pnx-button-group", ButtonGroup);
            },
            1903: (Qe, rt, Wn)=>{
                "use strict";
                Wn.d(rt, {
                    A: ()=>CopyButton
                });
                var Co = Wn(4542), Dl = Wn(5995), Ll = Wn(174), Rl = Wn(4189), Ul = Wn(8591), Gl = Wn(1198);
                class CopyButton extends Co.WF {
                    constructor(){
                        super(), this.data = "", this.input = "", this.unstyled = !1, this.kind = "full", this.size = "md", this._active = !1, this.addEventListener("click", this._onClick);
                    }
                    _onClick() {
                        var Qe;
                        let rt;
                        if ("" !== this.input) {
                            const Qe = document.getElementById(this.input);
                            rt = Qe.innerText || Qe.value;
                        } else "" !== this.text && (rt = this.text);
                        null !== (Qe = navigator) && void 0 !== Qe && Qe.clipboard ? (navigator.clipboard.writeText(rt), this._active = !0, setTimeout(()=>this._active = !1, 2e3)) : alert("Clipboard is not available");
                    }
                    render() {
                        var Qe, rt;
                        const Wn = {
                            "pnx-btn": !this.unstyled,
                            "pnx-btn-full": !this.unstyled,
                            "pnx-btn-active": !this.unstyled && this._active,
                            "pnx-btn-unstyled": this.unstyled,
                            [`pnx-btn-${this.kind}`]: !this.unstyled,
                            [`pnx-btn-${this.size}`]: !this.unstyled
                        };
                        return Co.qy`<button title=${this.title} class=${(0, Gl.H)(Wn)} part="btn">
			${this._active ? Co.qy`${(null === (Qe = this._t) || void 0 === Qe ? void 0 : Qe.pnx.copied) || ""} ${(0, Dl.fa)(Ll.e6)}` : Co.qy`<slot>${(0, Dl.fa)(Rl.jP)} ${(null === (rt = this._t) || void 0 === rt ? void 0 : rt.pnx.copy) || ""}</slot>`}
		</button>`;
                    }
                }
                CopyButton.styles = [
                    Ul.Op,
                    Ul.HM,
                    Co.AH`
		.pnx-btn-unstyled {
			border: none;
			background: none;
			font-family: var(--font-family);
			font-size: 1em;
			color: var(--widget-font);
			cursor: pointer;
			padding: 0;
			margin: 0;
		}
	`
                ], CopyButton.properties = {
                    text: {
                        type: String
                    },
                    input: {
                        type: String
                    },
                    kind: {
                        type: String
                    },
                    size: {
                        type: String
                    },
                    unstyled: {
                        type: Boolean
                    },
                    title: {
                        type: String
                    },
                    _active: {
                        state: !0,
                        type: Boolean
                    }
                }, customElements.define("pnx-copy-button", CopyButton);
            },
            5051: (Qe, rt, Wn)=>{
                "use strict";
                Wn.d(rt, {
                    A: ()=>Grade
                });
                var Co = Wn(4542), Dl = Wn(5995), Ll = Wn(4780), Rl = Wn(7325), Ul = Wn(8591);
                class Grade extends Co.WF {
                    constructor(){
                        super(), this.stars = 0;
                    }
                    render() {
                        var Qe;
                        const rt = this.stars || 0, Wn = [];
                        for(let Co = 1; Co <= rt; Co++)Wn.push((0, Dl.fa)(Ll.yy));
                        for(let Co = rt + 1; Co <= 5; Co++)Wn.push((0, Dl.fa)(Rl.yy));
                        return Co.qy`<span>
			${Wn}
		</span> (${this.stars ? this.stars + "/5" : (null === (Qe = this._t) || void 0 === Qe ? void 0 : Qe.pnx.metadata_quality_missing) || "?"})`;
                    }
                }
                Grade.styles = [
                    Ul.Op,
                    Co.AH`
		span { color: var(--orange); }
	`
                ], Grade.properties = {
                    stars: {
                        type: Number
                    }
                }, customElements.define("pnx-grade", Grade);
            },
            7939: (Qe, rt, Wn)=>{
                "use strict";
                Wn.d(rt, {
                    A: ()=>HashTags
                });
                var Co = Wn(4542), Dl = Wn(508), Ll = Wn(5995), Rl = Wn(7518);
                class HashTags extends Co.WF {
                    constructor(){
                        super(), this._tags = [], this._visible = !1, this._annotationsToggled = !1;
                    }
                    connectedCallback() {
                        super.connectedCallback(), this._parent.onceReady().then(()=>{
                            var Qe, rt, Wn, Co, Ll, Rl;
                            this._tags = (0, Dl.getHashTags)(null === (Qe = this._parent) || void 0 === Qe || null === (rt = Qe.psv) || void 0 === rt || null === (Wn = rt.getPictureMetadata) || void 0 === Wn ? void 0 : Wn.call(rt)), !this._visible && (this._tags.length > 0 || (0, Dl.hasAnnotations)(null === (Co = this._parent) || void 0 === Co || null === (Ll = Co.psv) || void 0 === Ll || null === (Rl = Ll.getPictureMetadata) || void 0 === Rl ? void 0 : Rl.call(Ll))) && (this._visible = !0, this._parent.psv.toggleAllAnnotations(!0)), this._parent.psv.addEventListener("picture-loaded", ()=>{
                                this._tags = (0, Dl.getHashTags)(this._parent.psv.getPictureMetadata()), !this._visible && (this._tags.length > 0 || (0, Dl.hasAnnotations)(this._parent.psv.getPictureMetadata())) && (this._visible = !0, this._parent.psv.toggleAllAnnotations(!0));
                            }), this._annotationsToggled = this._parent.psv.areAnnotationsVisible() || !1, this._parent.psv.addEventListener("annotations-toggled", (Qe)=>{
                                this._annotationsToggled = Qe.detail.visible;
                            });
                        });
                    }
                    render() {
                        var Qe, rt;
                        return this._visible ? Co.qy`<div>
			${this._tags.join(" ")}
			<pnx-button
				kind="outline"
				style="vertical-align: middle"
				title=${this._annotationsToggled ? null === (Qe = this._parent._t) || void 0 === Qe ? void 0 : Qe.pnx.semantics_hide_annotations : null === (rt = this._parent._t) || void 0 === rt ? void 0 : rt.pnx.semantics_show_annotations}
				active=${this._annotationsToggled ? "" : Co.s6}
				@click=${()=>this._parent.psv.toggleAllAnnotations(!this._annotationsToggled)}
			>${(0, Ll.fa)(Rl.mS)}</pnx-button>
		</div>` : Co.s6;
                    }
                }
                HashTags.styles = Co.AH`
		div {
			background: linear-gradient(to bottom left, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.2));
			margin-top: -10px;
			margin-right: -10px;
			padding: 5px 10px;
			border-bottom-left-radius: 10px;
			font-family: var(--font-family);
			color: white;
			font-size: 0.8em;
		}
	`, HashTags.properties = {
                    _tags: {
                        state: !0
                    },
                    _visible: {
                        state: !0
                    },
                    _annotationsToggled: {
                        state: !0
                    }
                }, customElements.define("pnx-hashtags", HashTags);
            },
            438: (Qe, rt, Wn)=>{
                "use strict";
                Wn.d(rt, {
                    A: ()=>LinkButton
                });
                var Co = Wn(4542), Dl = Wn(8591);
                class LinkButton extends Co.WF {
                    constructor(){
                        super(), this.kind = "full", this.size = "md";
                    }
                    render() {
                        const Qe = document.createElement("a");
                        Qe.setAttribute("part", "btn"), this.constructor.observedAttributes.filter((Qe)=>void 0 !== this[Qe]).forEach((rt)=>Qe.setAttribute(rt, this[rt])), Qe.classList.add("pnx-btn", `pnx-btn-${this.kind}`, `pnx-btn-${this.size}`);
                        const rt = document.createElement("slot");
                        return Qe.appendChild(rt), Qe;
                    }
                }
                LinkButton.styles = Dl.HM, LinkButton.properties = {
                    href: {
                        type: String
                    },
                    target: {
                        type: String
                    },
                    title: {
                        type: String
                    },
                    download: {
                        type: String
                    },
                    class: {
                        type: String
                    },
                    kind: {
                        type: String
                    },
                    size: {
                        type: String
                    }
                }, customElements.define("pnx-link-button", LinkButton);
            },
            5271: (Qe, rt, Wn)=>{
                "use strict";
                Wn.d(rt, {
                    A: ()=>ListGroup
                });
                var Co = Wn(4542), Dl = Wn(8591);
                class ListGroup extends Co.WF {
                    render() {
                        return Co.qy`<slot></slot>`;
                    }
                }
                ListGroup.styles = [
                    Dl.nd,
                    Co.AH`
		:host ::slotted(*) {
			text-decoration: none;
			border: none;
			border-bottom: 1px solid var(--widget-border-div);
			background: none;
			display: block;
			width: 100%;
			color: var(--widget-font);
			font-family: var(--font-family);
			cursor: pointer;
			font-size: 1em;
			font-weight: 400;
			line-height: 18px;
			padding: 5px 10px;
  			min-width: 150px;
			width: 100%;
			text-align: left;
			box-sizing: border-box;
		}

		:host ::slotted(*:hover) {
			background-color: var(--widget-bg-hover);
		}

		:host ::slotted(*:first-child) {
			border-top-left-radius: 5px;
			border-top-right-radius: 5px;
		}

		:host ::slotted(*:last-child) {
			border: none;
			border-bottom-left-radius: 5px;
			border-bottom-right-radius: 5px;
		}
	`
                ], customElements.define("pnx-list-group", ListGroup);
            },
            5525: (Qe, rt, Wn)=>{
                "use strict";
                Wn.d(rt, {
                    A: ()=>ListItem
                });
                var Co = Wn(4542);
                class ListItem extends Co.WF {
                    render() {
                        return Co.qy`
			<div class="list-item">
				<div class="icon">
					<slot name="icon"></slot>
				</div>
				<div class="content">
					<div class="title">${this.title}</div>
					<div class="subtitle">${this.subtitle}</div>
				</div>
				<div class="action">
					<slot name="action"></slot>
				</div>
			</div>
		`;
                    }
                }
                ListItem.styles = Co.AH`
		.list-item {
			display: flex;
			align-items: center;
			padding: 8px 16px;
			cursor: pointer;
			border-bottom: 1px solid #ddd;
			font-family: var(--font-family);
			background: var(--white);
			min-height: 50px;
			box-sizing: border-box;
		}
		.list-item:hover { background: var(--widget-bg-hover); }
		.icon {
			margin-right: 16px;
			display: flex;
			align-items: center;
			gap: 10px;
		}
		.action { margin-left: 16px; }
		.content {
			flex: 1;
		}
		.title {
			font-weight: 600;
		}
		.subtitle {
			font-size: 0.9em;
			color: var(--grey-dark);
		}
	`, ListItem.properties = {
                    title: {
                        type: String
                    },
                    subtitle: {
                        type: String
                    }
                }, customElements.define("pnx-list-item", ListItem);
            },
            3109: (Qe, rt, Wn)=>{
                "use strict";
                Wn.d(rt, {
                    A: ()=>Loader
                });
                var Co = Wn(4542), Dl = Wn(2305), Ll = Wn(5975);
                class Loader extends Co.WF {
                    constructor(){
                        super(), this.visible = !0, this["no-label"] = !1, this._mode = "loading", this._isLabelFun = !1, this.value = -1;
                    }
                    connectedCallback() {
                        super.connectedCallback(), this._nextLabel();
                    }
                    isVisible() {
                        return this.visible;
                    }
                    dismiss() {
                        let Qe = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null, rt = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null, Wn = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
                        if (clearTimeout(this._loaderLabelChanger), Qe) {
                            var Dl;
                            !0 !== Qe && console.error(Qe);
                            let Ul = [
                                null === (Dl = this._parent) || void 0 === Dl ? void 0 : Dl._t.pnx.error,
                                Co.qy`<br />`
                            ];
                            var Ll, Rl;
                            if (rt && Ul.push(rt, Co.qy`<br />`), Wn) Ul.push(Co.qy`<pnx-button kind="full">${null === (Ll = this._parent) || void 0 === Ll ? void 0 : Ll._t.pnx.error_click}</pnx-button>`), this.addEventListener("click", Wn);
                            else Ul.push(Co.qy`<small>${null === (Rl = this._parent) || void 0 === Rl ? void 0 : Rl._t.pnx.error_retry}</small>`);
                            this._mode = "error", this._label = Ul;
                            const Gl = rt || "Panoramax JS had a blocking exception", Zl = new CustomEvent("broken", {
                                detail: {
                                    error: Gl
                                }
                            });
                            throw this._parent.dispatchEvent(Zl), new Error(Gl);
                        }
                        {
                            this.value = 100, this._mode = "done", this.visible = !1, this.style.transition = "all 0.5s", setTimeout(()=>this.parentNode.removeChild(this), 2e3);
                            const Qe = new CustomEvent("ready");
                            this._parent.dispatchEvent(Qe), Wn && Wn();
                        }
                    }
                    _nextLabel() {
                        var Qe, rt, Wn, Co;
                        this._isLabelFun ? this._label = null === (Qe = this._parent) || void 0 === Qe ? void 0 : Qe._t.pnx.loading_labels_fun[Math.floor(Math.random() * (null === (rt = this._parent) || void 0 === rt ? void 0 : rt._t.pnx.loading_labels_fun.length))] : (this._label = null === (Wn = this._parent) || void 0 === Wn ? void 0 : Wn._t.pnx.loading_labels_serious[Math.floor(Math.random() * (null === (Co = this._parent) || void 0 === Co ? void 0 : Co._t.pnx.loading_labels_serious.length))], this._isLabelFun = !0);
                        this._loaderLabelChanger = setTimeout(this._nextLabel.bind(this), 500 + 1e3 * Math.random());
                    }
                    render() {
                        var Qe;
                        return "error" == this._mode ? Co.qy`
				<img class="logo-dead" src=${Dl} alt="" title=${null === (Qe = this._parent) || void 0 === Qe ? void 0 : Qe._t.map.loading} />
				${this._label}
			` : Co.qy`
			<pnx-progress-bar .value=${this.value}></pnx-progress-bar>
			${this["no-label"] ? Co.s6 : Co.qy`<div class="label">${this._label}</div>`}
		`;
                    }
                }
                Loader.styles = Co.AH`
		:host {
			position: absolute;
			inset: 0;
			display: flex;
			flex-direction: column;
			justify-content: center;
			gap: 10px;
			align-items: center;
			background-image: url('${(0, Co.iz)(Ll)}');
			background-repeat: no-repeat;
			background-size: cover;
			background-position: center; 
			z-index: 200;
			font-family: var(--font-family);
			font-weight: 550;
			color: var(--black);
			font-size: 1.4em;
			text-align: center;
			visibility: hidden;
			opacity: 0;
		}
		:host(*[visible]) {
			visibility: visible;
			opacity: 1;
		}

		div.label {
			background-color: rgba(255,255,255,0.5);
			box-shadow: white 0 0 10px;
			padding: 3px 10px;
			border-radius: 50px;
		}
		/* Logo */
		img.logo-dead { width: 100px; }
	`, Loader.properties = {
                    _mode: {
                        state: !0
                    },
                    _label: {
                        state: !0
                    },
                    _isLabelFun: {
                        state: !0
                    },
                    visible: {
                        type: Boolean,
                        reflect: !0
                    },
                    "no-label": {
                        type: Boolean
                    },
                    value: {
                        type: Number
                    }
                }, customElements.define("pnx-loader", Loader);
            },
            5642: (Qe, rt, Wn)=>{
                "use strict";
                Wn.d(rt, {
                    A: ()=>Map1
                });
                Wn(3041);
                var Co = Wn(8340), Dl = Wn(7343), Ll = Wn(6883), Rl = Wn(270), Ul = Wn(6462), Gl = Wn(9740), Zl = (Wn(6795), Wn(927)), Hl = Wn.n(Zl), ql = Wn(2968), Ql = Wn.n(ql), Kl = Wn(748);
                Hl().workerClass = Ql(), Hl().addProtocol("pmtiles", (new Kl.Zs).tile);
                class Map1 extends Hl().Map {
                    constructor(Qe, rt){
                        let Wn = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                        var Dl;
                        (super({
                            container: rt,
                            style: (0, Co.combineStyles)(Qe, Wn),
                            center: [
                                0,
                                0
                            ],
                            zoom: 0,
                            maxZoom: 24,
                            attributionControl: !1,
                            dragRotate: !1,
                            pitchWithRotate: !1,
                            touchZoomRotate: !0,
                            touchPitch: !1,
                            doubleClickZoom: !1,
                            canvasContextAttributes: {
                                preserveDrawingBuffer: !Qe.isWidthSmall()
                            },
                            transformRequest: Qe.api._getMapRequestTransform(),
                            locale: Qe._t.maplibre,
                            hash: !1,
                            ...Wn
                        }), this._loadMarkerImages(), this._parent = Qe, this._options = Wn, this.getContainer().classList.add("pnx-map"), void 0 === Wn.touchZoomRotate) && (null === this || void 0 === this || null === (Dl = this.touchZoomRotate) || void 0 === Dl || Dl.disableRotation());
                        this._options.raster && (this._options.background = this._options.background || "streets"), this._attribution = new (Hl()).AttributionControl({
                            compact: !1,
                            ...Wn.attributionControl
                        }), this.addControl(this._attribution), this._initMapPosition(), this._picMarker = this._getPictureMarker(), this._picMarkerPreview = this._getPictureMarker(!1), this._picThumbUrl = {}, this._seqPictures = {}, this._userLayers = new Set, this._parent.addEventListener("select", this.reloadLayersStyles.bind(this)), setTimeout(()=>{
                            var Qe;
                            !this.loaded() && null !== (Qe = this._parent) && void 0 !== Qe && Qe.loader.isVisible() && this._parent.loader.dismiss({}, this._parent._t.map.slow_loading, async ()=>{
                                await this._postLoad(), this._parent.loader.dismiss();
                            });
                        }, 15e3), this.waitForEnoughMapLoaded().then(async ()=>await this._postLoad());
                    }
                    async _postLoad() {
                        this.resize(), await this.setVisibleUsers(this._parent.users), this.reloadLayersStyles(), this.fire("ready");
                    }
                    destroy() {
                        this.remove(), delete this._parent, delete this._options, delete this._attribution, delete this._picMarker, delete this._picMarkerPreview, delete this._picThumbUrl, delete this._seqPictures, delete this._userLayers;
                    }
                    waitForEnoughMapLoaded() {
                        return new Promise((Qe)=>{
                            let rt = 0, Wn = 0, Co = 0, Dl = 0;
                            const onSourceDataLoading = (Qe)=>{
                                "source" === Qe.dataType && Qe.tile && (Qe.sourceId.startsWith("geovisio") ? Wn++ : rt++);
                            }, onSourceData = (Qe)=>{
                                "source" === Qe.dataType && Qe.tile && (Qe.sourceId.startsWith("geovisio") ? (Dl++, Qe.isSourceLoaded && (Dl = Wn)) : (Co++, Qe.isSourceLoaded && (Co = rt))), checkEnoughLoaded();
                            }, checkEnoughLoaded = ()=>{
                                Co / rt >= .75 && (0 === Wn || Dl / Wn >= .75) && (this.off("sourcedata", onSourceData), this.off("sourcedataloading", onSourceDataLoading), Qe());
                            };
                            this.on("sourcedataloading", onSourceDataLoading), this.on("sourcedata", onSourceData);
                        });
                    }
                    _initMapPosition() {
                        this._options.center && this._options.center != [
                            0,
                            0
                        ] || this._options.zoom && 0 !== this._options.zoom || this._options.hash || this._parent.onceAPIReady().then(()=>{
                            var Qe, rt;
                            let Wn = null === (Qe = this._parent) || void 0 === Qe || null === (rt = Qe.api) || void 0 === rt ? void 0 : rt.getDataBbox();
                            if (Wn) try {
                                Wn = new (Hl()).LngLatBounds(Wn), this.loaded() ? this.fitBounds(Wn, {
                                    animate: !1
                                }) : this.waitForEnoughMapLoaded().then(()=>this.fitBounds(Wn, {
                                        animate: !1
                                    }));
                            } catch (Co) {
                                console.warn("Received invalid bbox: " + Wn);
                            }
                        });
                    }
                    _loadMarkerImages() {
                        [
                            {
                                id: "pnx-marker",
                                img: Ll
                            },
                            {
                                id: "pnx-arrow-flat",
                                img: Ul
                            },
                            {
                                id: "pnx-arrow-360",
                                img: Gl
                            }
                        ].forEach((Qe)=>{
                            const rt = new Image(64, 64);
                            rt.onload = ()=>this.addImage(Qe.id, rt), rt.src = Qe.img;
                        });
                    }
                    _hasQualityScore() {
                        var Qe, rt, Wn, Co;
                        const Dl = (null === (Qe = this.getStyle()) || void 0 === Qe || null === (rt = Qe.metadata) || void 0 === rt ? void 0 : rt["panoramax:fields"]) || {};
                        return (null === Dl || void 0 === Dl || null === (Wn = Dl.pictures) || void 0 === Wn ? void 0 : Wn.includes("gps_accuracy")) && (null === Dl || void 0 === Dl || null === (Co = Dl.pictures) || void 0 === Co ? void 0 : Co.includes("h_pixel_density"));
                    }
                    _hasGridStats() {
                        var Qe, rt, Wn, Co, Dl, Ll;
                        const Rl = (null === (Qe = this.getStyle()) || void 0 === Qe || null === (rt = Qe.metadata) || void 0 === rt ? void 0 : rt["panoramax:fields"]) || {};
                        return (null === Rl || void 0 === Rl || null === (Wn = Rl.grid) || void 0 === Wn ? void 0 : Wn.includes("nb_360_pictures")) && (null === Rl || void 0 === Rl || null === (Co = Rl.grid) || void 0 === Co ? void 0 : Co.includes("nb_flat_pictures")) && (null === Rl || void 0 === Rl || null === (Dl = Rl.grid) || void 0 === Dl ? void 0 : Dl.includes("coef_360_pictures")) && (null === Rl || void 0 === Rl || null === (Ll = Rl.grid) || void 0 === Ll ? void 0 : Ll.includes("coef_flat_pictures"));
                    }
                    reloadVectorTiles() {
                        [
                            ...this._userLayers
                        ].forEach((Qe)=>{
                            const rt = this.getSource((0, Co.getUserSourceId)(Qe));
                            rt.setTiles(rt.tiles);
                        });
                    }
                    hasTwoBackgrounds() {
                        return void 0 !== this.getLayer(Co.RASTER_LAYER_ID);
                    }
                    getBackground() {
                        if (!this.getLayer(Co.RASTER_LAYER_ID)) return "streets";
                        return "visible" == this.getLayoutProperty(Co.RASTER_LAYER_ID, "visibility") ? "aerial" : "streets";
                    }
                    setBackground(Qe) {
                        if (!this.getLayer(Co.RASTER_LAYER_ID) && "aerial" === Qe) throw new Error("No aerial imagery available");
                        this.getLayer(Co.RASTER_LAYER_ID) && (this.setLayoutProperty(Co.RASTER_LAYER_ID, "visibility", "aerial" === Qe ? "visible" : "none"), this.fire("background-changed", {
                            background: Qe || "streets"
                        }));
                    }
                    getVisibleUsers() {
                        return [
                            ...this._userLayers
                        ].filter((Qe)=>this.getLayer((0, Co.getUserLayerId)(Qe, "pictures")) && "visible" === this.getLayoutProperty((0, Co.getUserLayerId)(Qe, "pictures"), "visibility"));
                    }
                    onceLayerReady(Qe) {
                        return this.getLayer(Qe) ? Promise.resolve() : new Promise((Qe)=>{
                            setTimeout(Qe, 250);
                        }).then(()=>this.onceLayerReady(Qe));
                    }
                    async setVisibleUsers() {
                        let Qe = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
                        "string" === typeof Qe ? Qe = [
                            Qe
                        ] : null === Qe && (Qe = []), await Promise.all(Qe.filter((Qe)=>"" != Qe && !this._userLayers.has(Qe)).map((Qe)=>(this._createPicturesTilesLayer(Qe), this.onceLayerReady((0, Co.getUserLayerId)(Qe, "pictures")))));
                        const rt = [
                            "pictures",
                            "sequences",
                            "sequences_plus",
                            "grid",
                            "pictures_symbols"
                        ];
                        [
                            ...this._userLayers
                        ].forEach((Wn)=>{
                            rt.forEach((rt)=>{
                                const Dl = (0, Co.getUserLayerId)(Wn, rt);
                                this.getLayer(Dl) && this.setLayoutProperty(Dl, "visibility", Qe.includes(Wn) ? "visible" : "none");
                            });
                        }), this.fire("users-changed", {
                            usersIds: Qe
                        });
                    }
                    filterUserLayersContent(Qe, rt) {
                        [
                            ...this._userLayers
                        ].forEach((Wn)=>{
                            this.getLayer((0, Co.getUserLayerId)(Wn, Qe)) ? (this.setFilter((0, Co.getUserLayerId)(Wn, Qe), rt), "sequences" === Qe && this.getLayer((0, Co.getUserLayerId)(Wn, "sequences_plus")) && this.setFilter((0, Co.getUserLayerId)(Wn, "sequences_plus"), rt), "pictures" === Qe && this.getLayer((0, Co.getUserLayerId)(Wn, "pictures_symbols")) && this.setFilter((0, Co.getUserLayerId)(Wn, "pictures_symbols"), rt)) : console.warn("Layer", (0, Co.getUserLayerId)(Wn, Qe), "not ready");
                        });
                    }
                    displayPictureMarker(Qe, rt, Wn) {
                        let Dl = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
                        this._picMarkerPreview.remove(), void 0 !== Qe && void 0 !== rt ? this._picMarker.setLngLat([
                            Qe,
                            rt
                        ]).setRotation(Wn).addTo(this) : this._picMarker.remove(), this.reloadLayersStyles(), Dl || void 0 === Qe || void 0 === rt || this.flyTo({
                            center: [
                                Qe,
                                rt
                            ],
                            zoom: this.getZoom() < Co.TILES_PICTURES_ZOOM + 2 ? Co.TILES_PICTURES_ZOOM + 2 : this.getZoom(),
                            maxDuration: 2e3
                        });
                    }
                    reloadLayersStyles() {
                        const updateStyle = (Qe, rt)=>{
                            [
                                ...this._userLayers
                            ].forEach((Wn)=>{
                                const Dl = (0, Co.getUserLayerId)(Wn, Qe);
                                if (this.getLayer(Dl)) {
                                    for(let Qe in rt.layout)this.setLayoutProperty(Dl, Qe, rt.layout[Qe]);
                                    for(let Qe in rt.paint)this.setPaintProperty(Dl, Qe, rt.paint[Qe]);
                                } else console.warn("Layer", Dl, "not ready");
                            });
                        };
                        [
                            "pictures",
                            "pictures_symbols",
                            "sequences"
                        ].forEach((Qe)=>{
                            updateStyle(Qe, this._getLayerStyleProperties(Qe));
                        });
                    }
                    async _createPicturesTilesLayer(Qe) {
                        this._userLayers.add(Qe);
                        const rt = this.getStyle().layers.find(Co.isLabelLayer);
                        if ("geovisio" !== Qe && !this.getSource(`geovisio_${Qe}`)) {
                            const Wn = await this._parent.api.getUserMapStyle(Qe);
                            Object.entries(Wn.sources).forEach((Qe)=>{
                                let [rt, Wn] = Qe;
                                return this.addSource(rt, Wn);
                            }), Wn.layers = Wn.layers || [];
                            Wn.layers.concat((0, Co.getMissingLayerStyles)(Wn.sources, Wn.layers)).filter((Qe)=>Object.keys(Qe).length > 0).forEach((Qe)=>this.addLayer(Qe, null === rt || void 0 === rt ? void 0 : rt.id));
                        }
                        this._picPreviewTimer = null, this._picPopup = new (Hl()).Popup({
                            closeButton: !1,
                            closeOnClick: !this._parent.isWidthSmall(),
                            offset: 3
                        }), this._picPopup.on("close", ()=>{
                            delete this._picPopup._picId;
                        });
                        const Wn = (0, Co.getUserLayerId)(Qe, "pictures");
                        this.on("mousemove", Wn, (Qe)=>{
                            this.getCanvas().style.cursor = "pointer";
                            const rt = Object.assign({}, Qe);
                            clearTimeout(this._picPreviewTimer), this._picPreviewTimer = setTimeout(()=>this._attachPreviewToPictures(rt, Wn), 100);
                        }), this.on("mouseleave", Wn, ()=>{
                            clearTimeout(this._picPreviewTimer), this.getCanvas().style.cursor = "", this._picPopup._picId, this._picPopup.remove();
                        }), this.on("click", Wn, this._onPictureClick.bind(this));
                        const Dl = (0, Co.getUserLayerId)(Qe, "sequences_plus");
                        this.on("mousemove", Dl, (Qe)=>{
                            if (this._onSequenceHover(Qe), this.getZoom() <= Co.TILES_PICTURES_ZOOM + 1 && (this.getCanvas().style.cursor = "pointer", Qe.features[0].properties.id)) {
                                const rt = Object.assign({}, Qe);
                                clearTimeout(this._picPreviewTimer), this._picPreviewTimer = setTimeout(()=>this._attachPreviewToPictures(rt, Dl), 100);
                            }
                        }), this.on("mouseleave", Dl, ()=>{
                            clearTimeout(this._picPreviewTimer), this.getCanvas().style.cursor = "", this._picPopup._picId, this._picPopup.remove();
                        }), this.on("click", Dl, (Qe)=>{
                            Qe.preventDefault(), this.getZoom() <= Co.TILES_PICTURES_ZOOM + 1 && this._onSequenceClick(Qe);
                        }), "geovisio" === Qe && this.getLayer("geovisio_grid") && (this.on("mousemove", "geovisio_grid", (Qe)=>{
                            if (this.getZoom() <= Co.TILES_PICTURES_ZOOM + 1) {
                                this.getCanvas().style.cursor = "pointer";
                                const rt = Object.assign({}, Qe);
                                clearTimeout(this._picPreviewTimer), this._picPreviewTimer = setTimeout(()=>this._attachPreviewToPictures(rt, "geovisio_grid"), 100);
                            }
                        }), this.on("mouseleave", "geovisio_grid", ()=>{
                            clearTimeout(this._picPreviewTimer), this.getCanvas().style.cursor = "", this._picPopup._picId, this._picPopup.remove();
                        }), this.on("click", "geovisio_grid", (Qe)=>{
                            Qe.preventDefault(), this.flyTo({
                                center: Qe.lngLat,
                                zoom: Co.TILES_PICTURES_ZOOM - 6
                            });
                        })), this.on("click", (Qe)=>{
                            !1 === Qe.defaultPrevented && (clearTimeout(this._picPreviewTimer), this._picPopup.remove());
                        });
                    }
                    _getLayerStyleProperties(Qe) {
                        if ("pictures_symbols" === Qe) return {
                            paint: {},
                            layout: {
                                "icon-image": [
                                    "case",
                                    [
                                        "==",
                                        [
                                            "get",
                                            "id"
                                        ],
                                        this._parent.picture
                                    ],
                                    "",
                                    [
                                        "==",
                                        [
                                            "get",
                                            "type"
                                        ],
                                        "equirectangular"
                                    ],
                                    "pnx-arrow-360",
                                    "pnx-arrow-flat"
                                ],
                                "symbol-sort-key": this._getLayerSortStyle(Qe)
                            }
                        };
                        {
                            const rt = {
                                pictures: "circle",
                                sequences: "line"
                            };
                            return {
                                paint: Object.assign({
                                    [`${rt[Qe]}-color`]: this._getLayerColorStyle(Qe)
                                }, Co.VECTOR_STYLES[Qe.toUpperCase()].paint),
                                layout: Object.assign({
                                    [`${rt[Qe]}-sort-key`]: this._getLayerSortStyle(Qe)
                                }, Co.VECTOR_STYLES[Qe.toUpperCase()].layout)
                            };
                        }
                    }
                    _getLayerColorStyle(Qe) {
                        const rt = [
                            "case",
                            [
                                "==",
                                [
                                    "get",
                                    "hidden"
                                ],
                                !0
                            ],
                            Dl.COLORS.HIDDEN,
                            [
                                "==",
                                [
                                    "get",
                                    "geovisio:status"
                                ],
                                "hidden"
                            ],
                            Dl.COLORS.HIDDEN
                        ], Wn = this._parent.sequence;
                        return "sequences" == Qe && Wn ? rt.push([
                            "==",
                            [
                                "get",
                                "id"
                            ],
                            Wn
                        ], Dl.COLORS.SELECTED) : Qe.startsWith("pictures") && Wn && rt.push([
                            "in",
                            Wn,
                            [
                                "get",
                                "sequences"
                            ]
                        ], Dl.COLORS.SELECTED), rt.push(Dl.COLORS.BASE), rt;
                    }
                    _getLayerSortStyle(Qe) {
                        const rt = [
                            "case",
                            [
                                "==",
                                [
                                    "get",
                                    "hidden"
                                ],
                                !0
                            ],
                            90
                        ], Wn = this._parent.sequence;
                        return "sequences" == Qe && Wn ? rt.push([
                            "==",
                            [
                                "get",
                                "id"
                            ],
                            Wn
                        ], 100) : Qe.startsWith("pictures") && Wn && rt.push([
                            "in",
                            Wn,
                            [
                                "get",
                                "sequences"
                            ]
                        ], 100), rt.push(10), rt;
                    }
                    _attachPreviewToPictures(Qe, rt) {
                        let Wn = Qe.features.pop();
                        if (!Wn || Wn.properties.id == this._picPopup._picId) return;
                        let Dl = null;
                        if (rt.endsWith("pictures") ? Dl = Wn.geometry.coordinates.slice() : Qe.lngLat && (Dl = [
                            Qe.lngLat.lng,
                            Qe.lngLat.lat
                        ]), !Dl) {
                            const Qe = "LineString" === Wn.geometry.type ? [
                                Wn.geometry.coordinates
                            ] : Wn.geometry.coordinates;
                            let rt = null;
                            const Co = this.getBounds(), Ll = Co.getCenter();
                            for(let Wn = 0; Wn < Qe.length; Wn++)for(let Rl = 0; Rl < Qe[Wn].length; Rl++)if (Co.contains(Qe[Wn][Rl])) {
                                let Co = Ll.distanceTo(new (Hl()).LngLat(...Qe[Wn][Rl]));
                                (null === rt || Co < rt) && (Dl = Qe[Wn][Rl], rt = Co);
                            }
                            if (!Dl) return;
                        }
                        this._picPopup.setLngLat(Dl).addTo(this), this._picThumbUrl[Wn.properties.id] || this._picPopup.setDOMContent((0, Co.getThumbGif)(this._parent._t)), this._picPopup._loading = Wn.properties.id, this._picPopup._picId = Wn.properties.id;
                        const displayThumb = (Qe)=>{
                            if (this._picPopup._loading === Wn.properties.id) {
                                if (delete this._picPopup._loading, Qe) {
                                    let rt = document.createElement("img");
                                    rt.classList.add("pnx-map-thumb"), rt.alt = this._parent._t.map.thumbnail;
                                    let Co = new Image;
                                    if (Co.src = Qe, Co.addEventListener("load", ()=>{
                                        Wn.properties.hidden ? rt.children[0].src = Co.src : rt.src = Co.src, this._picPopup.setDOMContent(rt);
                                    }), Wn.properties.hidden) {
                                        const Qe = document.createElement("div");
                                        Qe.classList.add("pnx-map-thumb-legend"), Qe.appendChild(document.createTextNode(this._parent._t.map.not_public));
                                        const Wn = document.createElement("div");
                                        Wn.appendChild(rt), Wn.appendChild(Qe), rt = Wn;
                                    }
                                } else this._picPopup.remove();
                            }
                        };
                        rt.endsWith("pictures") ? this._getPictureThumbURL(Wn.properties.id).then(displayThumb) : rt.endsWith("grid") ? this._getThumbURL(Dl).then(displayThumb) : this._getSequenceThumbURL(Wn.properties.id, new (Hl()).LngLat(...Dl)).then(displayThumb);
                    }
                    _getThumbURL(Qe) {
                        return this._parent.api.getPicturesAroundCoordinates(Qe[1], Qe[0], .1, 1).then((Qe)=>{
                            var rt;
                            const Wn = null === Qe || void 0 === Qe || null === (rt = Qe.features) || void 0 === rt ? void 0 : rt.pop();
                            return Wn ? this._parent.api.findThumbnailInPictureFeature(Wn) : null;
                        });
                    }
                    _getSequenceThumbURL(Qe, rt) {
                        return rt ? this._parent.api.getPicturesAroundCoordinates(rt.lat, rt.lng, 1, 1, Qe).then((rt)=>{
                            var Wn;
                            return (null === rt || void 0 === rt || null === (Wn = rt.features) || void 0 === Wn ? void 0 : Wn.length) > 0 ? this._parent.api.findThumbnailInPictureFeature(rt.features[0]) : this._parent.api.getPictureThumbnailURLForSequence(Qe);
                        }) : this._parent.api.getPictureThumbnailURLForSequence(Qe);
                    }
                    _getPictureThumbURL(Qe, rt) {
                        let Wn = null;
                        return Qe && (void 0 !== this._picThumbUrl[Qe] ? Wn = "string" === typeof this._picThumbUrl[Qe] ? Promise.resolve(this._picThumbUrl[Qe]) : this._picThumbUrl[Qe] : (this._picThumbUrl[Qe] = this._parent.api.getPictureThumbnailURL(Qe, rt).then((rt)=>rt ? (this._picThumbUrl[Qe] = rt, rt) : (this._picThumbUrl[Qe] = null, null)).catch(()=>{
                            this._picThumbUrl[Qe] = null;
                        }), Wn = this._picThumbUrl[Qe])), Wn;
                    }
                    _getPictureMarker() {
                        let Qe = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
                        const rt = document.createElement("img");
                        return rt.src = Qe ? Rl : Ll, rt.alt = "", new (Hl()).Marker({
                            element: rt
                        });
                    }
                    _onSequenceHover(Qe) {
                        var rt;
                        Qe.preventDefault(), Qe.features.length > 0 && null !== (rt = Qe.features[0].properties) && void 0 !== rt && rt.id && this.fire("sequence-hover", {
                            seqId: Qe.features[0].properties.id
                        });
                    }
                    _onSequenceClick(Qe) {
                        var rt;
                        Qe.preventDefault(), Qe.features.length > 0 && null !== (rt = Qe.features[0].properties) && void 0 !== rt && rt.id && this.fire("sequence-click", {
                            seqId: Qe.features[0].properties.id,
                            coordinates: Qe.lngLat
                        });
                    }
                    _onPictureClick(Qe) {
                        var rt, Wn;
                        Qe.preventDefault();
                        const Co = (null === Qe || void 0 === Qe || null === (rt = Qe.features) || void 0 === rt ? void 0 : rt.length) > 0 ? Qe.features[0] : null;
                        if (null !== Co && void 0 !== Co && null !== (Wn = Co.properties) && void 0 !== Wn && Wn.id) {
                            let rt = null;
                            try {
                                Co.properties.sequences && (Array.isArray(Co.properties.sequences) || (Co.properties.sequences = JSON.parse(Co.properties.sequences)), rt = Co.properties.sequences.pop());
                            } catch (Qe) {
                                console.log("Sequence ID is not available in vector tiles for picture " + Co.properties.id);
                            }
                            this.fire("picture-click", {
                                picId: Co.properties.id,
                                seqId: rt,
                                feature: Co
                            });
                        }
                    }
                    addEventListener(Qe, rt) {
                        let Wn = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                        null !== Wn && void 0 !== Wn && Wn.once ? this.once(Qe, rt) : this.on(Qe, rt);
                    }
                }
            },
            2771: (Qe, rt, Wn)=>{
                "use strict";
                Wn.d(rt, {
                    A: ()=>MapMore,
                    T: ()=>Ul
                });
                var Co = Wn(5642), Dl = Wn(7343), Ll = Wn(8340);
                const Rl = {
                    DEFAULT: "default",
                    AGE: "age",
                    TYPE: "type",
                    SCORE: "score"
                }, Ul = [
                    "minDate",
                    "maxDate",
                    "pic_type",
                    "camera",
                    "theme",
                    "qualityscore"
                ];
                class MapMore extends Co.A {
                    constructor(Qe, rt){
                        super(Qe, rt, arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}), this._mapFilters = {}, this._options.theme && (this._mapFilters = {
                            theme: this._options.theme
                        });
                    }
                    reloadLayersStyles() {
                        if (super.reloadLayersStyles(), this._hasGridStats()) {
                            let Qe = "coef";
                            this._mapFilters.pic_type && (Qe = "flat" == this._mapFilters.pic_type ? "coef_flat_pictures" : "coef_360_pictures"), this.getStyle().layers.filter((Qe)=>Qe.id.endsWith("_grid")).forEach((rt)=>{
                                const Wn = (0, Ll.switchCoefValue)(rt, Qe);
                                for(let Qe in Wn.layout)this.setLayoutProperty(rt.id, Qe, Wn.layout[Qe]);
                                for(let Qe in Wn.paint)this.setPaintProperty(rt.id, Qe, Wn.paint[Qe]);
                            });
                        }
                    }
                    _getDatesForLayerColors() {
                        const Qe = 864e5, rt = Date.now();
                        return [
                            rt - 30 * Qe,
                            rt - 365 * Qe,
                            rt - 730 * Qe
                        ].map((Qe)=>new Date(Qe).toISOString().split("T")[0]);
                    }
                    _getLayerColorStyle(Qe) {
                        var rt, Wn, Co, Ul, Gl, Zl, Hl, ql;
                        const Ql = [
                            "case",
                            [
                                "==",
                                [
                                    "get",
                                    "hidden"
                                ],
                                !0
                            ],
                            Dl.COLORS.HIDDEN
                        ], Kl = (null === (rt = this._parent.psv) || void 0 === rt || null === (Wn = rt._myVTour) || void 0 === Wn || null === (Co = Wn.state) || void 0 === Co ? void 0 : Co.loadingNode) || (null === (Ul = this._parent.psv) || void 0 === Ul || null === (Gl = Ul._myVTour) || void 0 === Gl || null === (Zl = Gl.state) || void 0 === Zl || null === (Hl = Zl.currentNode) || void 0 === Hl ? void 0 : Hl.id), $l = Kl ? null === (ql = this._parent.psv) || void 0 === ql ? void 0 : ql._picturesSequences[Kl] : null;
                        if ("sequences" == Qe && $l ? Ql.push([
                            "==",
                            [
                                "get",
                                "id"
                            ],
                            $l
                        ], Dl.COLORS.SELECTED) : "pictures" == Qe && $l && Ql.push([
                            "in",
                            $l,
                            [
                                "get",
                                "sequences"
                            ]
                        ], Dl.COLORS.SELECTED), this._mapFilters.theme == Rl.AGE) {
                            const rt = "sequences" == Qe ? "date" : "ts", Wn = this._getDatesForLayerColors();
                            Ql.push([
                                "!",
                                [
                                    "has",
                                    rt
                                ]
                            ], Dl.COLORS.BASE, [
                                ">=",
                                [
                                    "get",
                                    rt
                                ],
                                Wn[0]
                            ], Dl.COLORS.PALETTE_4, [
                                ">=",
                                [
                                    "get",
                                    rt
                                ],
                                Wn[1]
                            ], Dl.COLORS.PALETTE_3, [
                                ">=",
                                [
                                    "get",
                                    rt
                                ],
                                Wn[2]
                            ], Dl.COLORS.PALETTE_2, Dl.COLORS.PALETTE_1);
                        } else this._mapFilters.theme == Rl.TYPE ? Ql.push([
                            "!",
                            [
                                "has",
                                "type"
                            ]
                        ], Dl.COLORS.BASE, [
                            "==",
                            [
                                "get",
                                "type"
                            ],
                            "equirectangular"
                        ], Dl.COLORS.QUALI_1, Dl.COLORS.QUALI_2) : this._mapFilters.theme == Rl.SCORE ? Ql.push([
                            "==",
                            Ll.MAP_EXPR_QUALITYSCORE,
                            5
                        ], Dl.QUALITYSCORE_VALUES[0].color, [
                            "==",
                            Ll.MAP_EXPR_QUALITYSCORE,
                            4
                        ], Dl.QUALITYSCORE_VALUES[1].color, [
                            "==",
                            Ll.MAP_EXPR_QUALITYSCORE,
                            3
                        ], Dl.QUALITYSCORE_VALUES[2].color, [
                            "==",
                            Ll.MAP_EXPR_QUALITYSCORE,
                            2
                        ], Dl.QUALITYSCORE_VALUES[3].color, Dl.QUALITYSCORE_VALUES[4].color) : Ql.push(Dl.COLORS.BASE);
                        return Ql;
                    }
                    _getLayerSortStyle(Qe) {
                        var rt, Wn, Co, Dl, Ul, Gl, Zl, Hl;
                        const ql = [
                            "case",
                            [
                                "==",
                                [
                                    "get",
                                    "hidden"
                                ],
                                !0
                            ],
                            90
                        ], Ql = (null === (rt = this._parent.psv) || void 0 === rt || null === (Wn = rt._myVTour) || void 0 === Wn || null === (Co = Wn.state) || void 0 === Co ? void 0 : Co.loadingNode) || (null === (Dl = this._parent.psv) || void 0 === Dl || null === (Ul = Dl._myVTour) || void 0 === Ul || null === (Gl = Ul.state) || void 0 === Gl || null === (Zl = Gl.currentNode) || void 0 === Zl ? void 0 : Zl.id), Kl = Ql ? null === (Hl = this._parent.psv) || void 0 === Hl ? void 0 : Hl._picturesSequences[Ql] : null;
                        if ("sequences" == Qe && Kl ? ql.push([
                            "==",
                            [
                                "get",
                                "id"
                            ],
                            Kl
                        ], 100) : "pictures" == Qe && Kl && ql.push([
                            "in",
                            Kl,
                            [
                                "get",
                                "sequences"
                            ]
                        ], 100), this._mapFilters.theme == Rl.AGE) {
                            const rt = "sequences" == Qe ? "date" : "ts", Wn = this._getDatesForLayerColors();
                            ql.push([
                                "!",
                                [
                                    "has",
                                    rt
                                ]
                            ], 0, [
                                ">=",
                                [
                                    "get",
                                    rt
                                ],
                                Wn[0]
                            ], 50, [
                                ">=",
                                [
                                    "get",
                                    rt
                                ],
                                Wn[1]
                            ], 49, [
                                ">=",
                                [
                                    "get",
                                    rt
                                ],
                                Wn[2]
                            ], 48);
                        } else this._mapFilters.theme == Rl.TYPE ? ql.push([
                            "!",
                            [
                                "has",
                                "type"
                            ]
                        ], 0, [
                            "==",
                            [
                                "get",
                                "type"
                            ],
                            "equirectangular"
                        ], 50) : this._mapFilters.theme == Rl.SCORE && ql.push([
                            "==",
                            Ll.MAP_EXPR_QUALITYSCORE,
                            5
                        ], 80, [
                            "==",
                            Ll.MAP_EXPR_QUALITYSCORE,
                            4
                        ], 65, [
                            "==",
                            Ll.MAP_EXPR_QUALITYSCORE,
                            3
                        ], 50, [
                            "==",
                            Ll.MAP_EXPR_QUALITYSCORE,
                            2
                        ], 35, [
                            "==",
                            Ll.MAP_EXPR_QUALITYSCORE,
                            1
                        ], 20);
                        return ql.push(10), ql;
                    }
                    setFilters(Qe) {
                        let rt = arguments.length > 1 && void 0 !== arguments[1] && arguments[1], Wn = [], Co = [], Dl = !1;
                        if (this._mapFilters = {}, Qe.minDate && "" !== Qe.minDate && (this._mapFilters.minDate = Qe.minDate, Wn.push([
                            ">=",
                            [
                                "get",
                                "date"
                            ],
                            Qe.minDate
                        ]), Co.push([
                            ">=",
                            [
                                "get",
                                "ts"
                            ],
                            Qe.minDate
                        ])), Qe.maxDate && "" !== Qe.maxDate) {
                            this._mapFilters.maxDate = Qe.maxDate, Wn.push([
                                "<=",
                                [
                                    "get",
                                    "date"
                                ],
                                Qe.maxDate
                            ]);
                            let rt = new Date(Qe.maxDate);
                            rt.setDate(rt.getDate() + 1), rt = rt.toISOString().split("T")[0], Co.push([
                                "<=",
                                [
                                    "get",
                                    "ts"
                                ],
                                rt
                            ]);
                        }
                        if (Qe.pic_type && "" !== Qe.pic_type && (this._mapFilters.pic_type = "flat" === Qe.pic_type ? "flat" : "equirectangular", Wn.push([
                            "==",
                            [
                                "get",
                                "type"
                            ],
                            this._mapFilters.pic_type
                        ]), Co.push([
                            "==",
                            [
                                "get",
                                "type"
                            ],
                            this._mapFilters.pic_type
                        ])), this._hasGridStats() && (Dl = !0), Qe.camera && "" !== Qe.camera) {
                            this._mapFilters.camera = Qe.camera;
                            const rt = Qe.camera.toLowerCase().trim() + "                    ", Dl = Qe.camera.toLowerCase().trim() + "zzzzzzzzzzzzzzzzzzzz", Ll = [
                                "collator",
                                {
                                    "case-sensitive": !1,
                                    "diacritic-sensitive": !1
                                }
                            ];
                            Wn.push([
                                ">=",
                                [
                                    "get",
                                    "model"
                                ],
                                rt,
                                Ll
                            ]), Wn.push([
                                "<=",
                                [
                                    "get",
                                    "model"
                                ],
                                Dl,
                                Ll
                            ]), Co.push([
                                ">=",
                                [
                                    "get",
                                    "model"
                                ],
                                rt,
                                Ll
                            ]), Co.push([
                                "<=",
                                [
                                    "get",
                                    "model"
                                ],
                                Dl,
                                Ll
                            ]);
                        }
                        Qe.qualityscore && Qe.qualityscore.length > 0 && (this._mapFilters.qualityscore = Qe.qualityscore, Wn.push([
                            "in",
                            Ll.MAP_EXPR_QUALITYSCORE,
                            [
                                "literal",
                                this._mapFilters.qualityscore
                            ]
                        ]), Co.push([
                            "in",
                            Ll.MAP_EXPR_QUALITYSCORE,
                            [
                                "literal",
                                this._mapFilters.qualityscore
                            ]
                        ])), Qe.theme && Object.values(Rl).includes(Qe.theme) && (this._mapFilters.theme = Qe.theme, Dl = !0), 0 == Wn.length ? Wn = null : Wn.unshift("all"), 0 == Co.length ? Co = null : (Co.unshift("all"), Co = [
                            "step",
                            [
                                "zoom"
                            ],
                            !0,
                            Ll.TILES_PICTURES_ZOOM,
                            Co
                        ]), Dl && this.reloadLayersStyles();
                        const Ul = this.getVisibleUsers().includes("geovisio");
                        Wn && Ul && (Wn = [
                            "step",
                            [
                                "zoom"
                            ],
                            !0,
                            7,
                            Wn
                        ]), this.filterUserLayersContent("sequences", Wn), this.filterUserLayersContent("pictures", Co), !rt && (null !== Wn || null !== Co || null !== this._mapFilters.theme && this._mapFilters.theme !== Rl.DEFAULT) && Ul && this.getZoom() < 7 && !this._hasGridStats() && this.easeTo({
                            zoom: 7
                        }), this.fire("filters-changed", Object.assign({}, this._mapFilters));
                    }
                }
            },
            9048: (Qe, rt, Wn)=>{
                "use strict";
                Wn.d(rt, {
                    Ay: ()=>Photo,
                    LM: ()=>$l,
                    Vf: ()=>Tc,
                    cS: ()=>Kl
                });
                Wn(5003);
                var Co = Wn(5975), Dl = Wn(2305), Ll = Wn(7343), Rl = Wn(508), Ul = (Wn(3961), Wn(1080), Wn(2710), Wn(1575), Wn(1545)), Gl = Wn(3348), Zl = Wn(4991), Hl = Wn(3727);
                const ql = {
                    baseUrl: Co,
                    width: 1280,
                    cols: 2,
                    rows: 1,
                    tileUrl: ()=>null
                }, Ql = {
                    id: Ll.BASE_PANORAMA_ID,
                    caption: "",
                    panorama: ql,
                    links: [],
                    gps: [
                        0,
                        0
                    ],
                    sequence: {},
                    sphereCorrection: {},
                    horizontalFov: 360,
                    properties: {}
                }, Kl = 30, $l = 250, Tc = 3e3;
                Ul.jM.useNewAnglesOrder = !0;
                class Photo extends Ul.jM {
                    constructor(Qe, rt){
                        var Wn, Co;
                        let Dl = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                        super({
                            container: rt,
                            adapter: [
                                Hl.A,
                                {
                                    showErrorTile: !1,
                                    baseBlur: !1,
                                    resolution: Qe.isWidthSmall() ? 32 : 64,
                                    shouldGoFast: Dl.shouldGoFast
                                }
                            ],
                            withCredentials: "include" == (null === Qe || void 0 === Qe || null === (Wn = Qe.fetchOptions) || void 0 === Wn ? void 0 : Wn.credentials),
                            requestHeaders: null === Qe || void 0 === Qe || null === (Co = Qe.fetchOptions) || void 0 === Co ? void 0 : Co.headers,
                            panorama: ql,
                            lang: Qe._t.psv,
                            minFov: 5,
                            loadingTxt: "&nbsp;",
                            navbar: null,
                            rendererParameters: {
                                preserveDrawingBuffer: !Qe.isWidthSmall()
                            },
                            plugins: [
                                [
                                    Gl.$,
                                    {
                                        dataMode: "server",
                                        positionMode: "gps",
                                        renderMode: "3d",
                                        preload: !0,
                                        getNode: ()=>{},
                                        transitionOptions: ()=>{},
                                        arrowsPosition: {
                                            linkOverlapAngle: Math.PI / 6
                                        }
                                    }
                                ],
                                [
                                    Zl.b,
                                    {}
                                ]
                            ],
                            ...Dl
                        }), this._parent = Qe, this._options = Dl, rt.classList.add("pnx-psv"), this._shouldGoFast = (null === Dl || void 0 === Dl ? void 0 : Dl.shouldGoFast) || (()=>!1), this._transitionDuration = (null === Dl || void 0 === Dl ? void 0 : Dl.transitionDuration) || $l, this._myVTour = this.getPlugin(Gl.$), this._myVTour.datasource.nodeResolver = this._getNodeFromAPI.bind(this), this._myVTour.config.transitionOptions = this._psvNodeTransition.bind(this), this._clearArrows = this._myVTour.arrowsRenderer.clear.bind(this._myVTour.arrowsRenderer), this._myVTour.arrowsRenderer.clear = ()=>{}, this._myMarkers = this.getPlugin(Zl.b), this._annotationsVisible = !1, this._sequencePlaying = !1, this._picturesNavigation = this._options.picturesNavigation || "any", this._picturesSequences = {}, this._myVTour.addEventListener("enter-arrow", this._onEnterArrow.bind(this)), this._myVTour.addEventListener("leave-arrow", this._onLeaveArrow.bind(this)), this._myVTour.addEventListener("node-changed", this._onNodeChanged.bind(this)), this._myMarkers.addEventListener("select-marker", this._onSelectMarker.bind(this)), this.addEventListener("position-updated", this._onPositionUpdated.bind(this)), this.addEventListener("zoom-updated", this._onZoomUpdated.bind(this)), this.addEventListener("dblclick", this._onDoubleClick.bind(this)), this._parent.addEventListener("select", this._onSelect.bind(this)), this.loader.size = 150, this.loader.color = "rgba(61, 61, 61, 0.5)", this.loader.textColor = "rgba(255, 255, 255, 0.7)", this.loader.border = 5, this.loader.thickness = 10, this.loader.canvas.setAttribute("viewBox", "0 0 150 150"), this.loader.__updateContent(), this._options.position && !this._parent.picture && this.goToPosition(...this._options.position);
                    }
                    async _getNodeFromAPI(Qe) {
                        var rt, Wn;
                        if ((0, Ll.isNullId)(Qe)) return Ql;
                        const Co = await fetch(this._parent.api.getPictureMetadataUrl(Qe, this._picturesSequences[Qe]), this._parent.api._getFetchOptions());
                        let Dl = await Co.json();
                        if (Dl.features && (Dl = Dl.features.pop()), !Dl || 0 === Object.keys(Dl).length || !Co.ok) throw this._parent.loader && this._parent.loader.dismiss(!0, this._parent._t.pnx.error_pic), new Error("Picture with ID " + Qe + " was not found");
                        this._picturesSequences[Qe] = Dl.collection;
                        const Ul = (0, Rl.apiFeatureToPSVNode)(Dl, this._parent._t, this._parent._isInternetFast, this._picturesNavFilter.bind(this));
                        var Gl, Zl;
                        null !== Ul && void 0 !== Ul && null !== (rt = Ul.sequence) && void 0 !== rt && rt.prevPic && (this._picturesSequences[null === Ul || void 0 === Ul || null === (Gl = Ul.sequence) || void 0 === Gl ? void 0 : Gl.prevPic] = Dl.collection);
                        null !== Ul && void 0 !== Ul && null !== (Wn = Ul.sequence) && void 0 !== Wn && Wn.nextPic && (this._picturesSequences[null === Ul || void 0 === Ul || null === (Zl = Ul.sequence) || void 0 === Zl ? void 0 : Zl.nextPic] = Dl.collection);
                        return Ul;
                    }
                    _psvNodeTransition(Qe, rt, Wn) {
                        var Co, Dl, Rl;
                        let Ul = {};
                        const Gl = this._shouldGoFast() ? 0 : Math.min($l, this._transitionDuration), Zl = Gl > 100, Hl = null != (Wn || (null === rt || void 0 === rt ? void 0 : rt.links.find((rt)=>rt.nodeId == Qe.id))), ql = rt && Qe.sequence.id === rt.sequence.id, Ql = ((null === rt || void 0 === rt || null === (Co = rt.properties) || void 0 === Co ? void 0 : Co["view:azimuth"]) || 0) * (Math.PI / 180), Tc = ((null === Qe || void 0 === Qe || null === (Dl = Qe.properties) || void 0 === Dl ? void 0 : Dl["view:azimuth"]) || 0) * (Math.PI / 180), tu = (0, Ll.getRelativeHeading)(Qe) * (Math.PI / 180);
                        this.setOption("maxFov", Math.min(3 * Qe.horizontalFov / 4, 90));
                        const lu = {
                            showLoader: !1,
                            effect: "none",
                            speed: 0,
                            rotation: !1,
                            rotateTo: {
                                pitch: 0,
                                yaw: -tu
                            },
                            zoomTo: Kl
                        };
                        if (360 == Qe.horizontalFov) Ul = rt ? (0, Ll.getDistance)(rt.gps, Qe.gps) >= .001 ? lu : {
                            speed: Gl,
                            effect: Hl && Zl ? "fade" : "none",
                            rotation: Hl && ql && Zl,
                            rotateTo: this.getPosition()
                        } : lu;
                        else if (ql) {
                            const Qe = this.getPosition().yaw, Wn = rt.horizontalFov * (Math.PI / 180) / 2, Co = Qe <= Wn || Qe >= 2 * Math.PI - Wn, Dl = Math.abs(Ql - Tc) <= Math.PI / 4;
                            Ul = {
                                speed: Gl,
                                effect: Hl && Dl && Zl ? "fade" : "none",
                                rotation: Hl && Dl && Zl,
                                rotateTo: Co ? this.getPosition() : {
                                    pitch: 0,
                                    yaw: 0
                                },
                                zoomTo: Co ? this.getZoomLevel() : Kl
                            };
                        } else Ul = Object.assign(lu, {
                            rotateTo: {
                                pitch: 0,
                                yaw: 0
                            }
                        });
                        "fade" === Ul.effect && Ul.speed >= 150 ? setTimeout(this._clearArrows, Ul.speed - 100) : this._clearArrows();
                        const du = new CustomEvent("picture-loading", {
                            detail: {
                                ...Object.assign({}, this.getXYZ(), Ul.rotateTo ? {
                                    x: 180 * (Tc + Ul.rotateTo.yaw) / Math.PI
                                } : null, Ul.zoomTo ? {
                                    z: Ul.zoomTo
                                } : null),
                                picId: Qe.id,
                                lon: Qe.gps[0],
                                lat: Qe.gps[1],
                                first: (null === (Rl = this._parent._initParams) || void 0 === Rl ? void 0 : Rl.getParentPostInit().picture) == Qe.id
                            }
                        });
                        return this.dispatchEvent(du), Ul;
                    }
                    _onEnterArrow(Qe) {
                        const rt = Qe.link, Wn = Qe.node;
                        let Co;
                        Wn && (Co = 360 === Wn.horizontalFov ? (this.getPictureOriginalHeading() + 180 * this.getPosition().yaw / Math.PI) % 360 : this.getPictureOriginalHeading());
                        const Dl = new CustomEvent("picture-preview-started", {
                            detail: {
                                picId: rt.nodeId,
                                coordinates: rt.gps,
                                direction: Co
                            }
                        });
                        this.dispatchEvent(Dl);
                    }
                    _onLeaveArrow(Qe) {
                        const rt = Qe.link, Wn = new CustomEvent("picture-preview-stopped", {
                            detail: {
                                picId: rt.nodeId
                            }
                        });
                        this.dispatchEvent(Wn);
                    }
                    _onPositionUpdated(Qe) {
                        let { position: rt } = Qe;
                        const Wn = (0, Ll.positionToXYZ)(rt, this.getZoomLevel());
                        Wn.x += this.getPictureOriginalHeading(), Wn.x = Wn.x % 360;
                        const Co = new CustomEvent("view-rotated", {
                            detail: Wn
                        });
                        this.dispatchEvent(Co), this._onTilesStartLoading();
                    }
                    _onZoomUpdated(Qe) {
                        let { zoomLevel: rt } = Qe;
                        const Wn = new CustomEvent("view-rotated", {
                            detail: {
                                ...this.getXY(),
                                z: rt
                            }
                        });
                        this.dispatchEvent(Wn), this._onTilesStartLoading();
                    }
                    _onDoubleClick() {
                        this.unfocusAnnotation();
                    }
                    _onNodeChanged(Qe) {
                        for (let Dl of document.getElementsByClassName("pnx-psv-tour-arrows"))Dl.classList.remove("pnx-clicked");
                        if (Qe.node.id) {
                            var rt, Wn, Co;
                            const Dl = (null === (rt = this._parent._initParams) || void 0 === rt ? void 0 : rt.getParentPostInit().picture) == Qe.node.id;
                            this._parent.select(null === (Wn = Qe.node) || void 0 === Wn || null === (Co = Wn.sequence) || void 0 === Co ? void 0 : Co.id, Qe.node.id);
                            const Ll = this.getPictureMetadata();
                            if (!Ll) return void this.dispatchEvent(new CustomEvent("picture-loaded", {
                                detail: {}
                            }));
                            this._prevSequence = Ll.sequence.id;
                            const Rl = new CustomEvent("picture-loaded", {
                                detail: {
                                    ...this.getXYZ(),
                                    picId: Qe.node.id,
                                    lon: Ll.gps[0],
                                    lat: Ll.gps[1],
                                    first: Dl
                                }
                            });
                            this.dispatchEvent(Rl), Ll.panorama.hdUrl ? (this.setOption("downloadUrl", Ll.panorama.hdUrl), this.setOption("downloadName", Qe.node.id + ".jpg")) : this.setOption("downloadUrl", null), this._annotationsVisible && this.toggleAllAnnotations(!0);
                        }
                        this._onTilesStartLoading();
                    }
                    _onSelectMarker(Qe) {
                        var rt;
                        if (Qe.marker && null !== (rt = Qe.marker.id) && void 0 !== rt && rt.startsWith("annotation-")) {
                            const rt = new CustomEvent("annotation-click", {
                                detail: {
                                    annotationId: Qe.marker.data.id
                                }
                            });
                            this.dispatchEvent(rt);
                        }
                    }
                    _onTilesStartLoading() {
                        this._tilesQueueTimer && (clearInterval(this._tilesQueueTimer), delete this._tilesQueueTimer), this._tilesQueueTimer = setInterval(()=>{
                            if (0 === Object.keys(this.adapter.queue.tasks).length) {
                                if (this._myVTour.state.currentNode) {
                                    const Qe = new CustomEvent("picture-tiles-loaded", {
                                        detail: {
                                            picId: this._myVTour.state.currentNode.id
                                        }
                                    });
                                    this.dispatchEvent(Qe);
                                }
                                clearInterval(this._tilesQueueTimer), delete this._tilesQueueTimer;
                            }
                        }, 100);
                    }
                    getPictureMetadata() {
                        var Qe, rt, Wn;
                        return (0, Ll.isNullId)(null === (Qe = this._myVTour) || void 0 === Qe || null === (rt = Qe.state) || void 0 === rt || null === (Wn = rt.currentNode) || void 0 === Wn ? void 0 : Wn.id) ? null : this._myVTour.state.currentNode ? Object.assign({}, this._myVTour.state.currentNode) : null;
                    }
                    getPictureId() {
                        var Qe, rt, Wn, Co, Dl;
                        const Rl = (null === (Qe = this._myVTour) || void 0 === Qe || null === (rt = Qe.state) || void 0 === rt ? void 0 : rt.loadingNode) || (null === (Wn = this._myVTour) || void 0 === Wn || null === (Co = Wn.state) || void 0 === Co || null === (Dl = Co.currentNode) || void 0 === Dl ? void 0 : Dl.id);
                        return (0, Ll.isNullId)(Rl) ? null : Rl;
                    }
                    _onSelect(Qe) {
                        var rt;
                        Qe.detail.seqId && (this._picturesSequences[Qe.detail.picId] = Qe.detail.seqId), (null === (rt = this._myVTour.getCurrentNode()) || void 0 === rt ? void 0 : rt.id) !== Qe.detail.picId && (this.loader.show(), this._myVTour.setCurrentNode(Qe.detail.picId).catch((Qe)=>{
                            this.showErrorOverlay(Qe, this._parent._t.pnx.error_pic, !0);
                        }));
                    }
                    goToNextPicture() {
                        if (!this.getPictureMetadata()) throw new Error("No picture currently selected");
                        const Qe = this.getPictureMetadata().sequence.nextPic;
                        if (!Qe) throw new Error("No next picture available");
                        this._parent.select(this.getPictureMetadata().sequence.id, Qe);
                    }
                    goToPrevPicture() {
                        if (!this.getPictureMetadata()) throw new Error("No picture currently selected");
                        const Qe = this.getPictureMetadata().sequence.prevPic;
                        if (!Qe) throw new Error("No previous picture available");
                        this._parent.select(this.getPictureMetadata().sequence.id, Qe);
                    }
                    async goToPosition(Qe, rt) {
                        return this._parent.api.getPicturesAroundCoordinates(Qe, rt).then((Qe)=>{
                            if (Qe.features.length > 0) {
                                const rt = Qe.features.pop();
                                return this._parent.select(null === rt || void 0 === rt ? void 0 : rt.collection, rt.id), rt.id;
                            }
                            return Promise.reject(new Error("No picture found nearby given coordinates"));
                        });
                    }
                    getXY() {
                        const Qe = (0, Ll.positionToXYZ)(this.getPosition());
                        return Qe.x = (Qe.x + this.getPictureOriginalHeading()) % 360, Qe;
                    }
                    getXYZ() {
                        const Qe = this.getXY();
                        return Qe.z = this.getZoomLevel(), Qe;
                    }
                    getPictureOriginalHeading() {
                        var Qe, rt;
                        return (null === (Qe = this.getPictureMetadata()) || void 0 === Qe || null === (rt = Qe.properties) || void 0 === rt ? void 0 : rt["view:azimuth"]) || 0;
                    }
                    getPictureRelativeHeading() {
                        return (0, Ll.getRelativeHeading)(this.getPictureMetadata());
                    }
                    clearPictureMetadataCache() {
                        var Qe, rt, Wn, Co;
                        const Dl = null === (Qe = this.getPictureMetadata()) || void 0 === Qe ? void 0 : Qe.id, Ll = null === (rt = this.getPictureMetadata()) || void 0 === rt || null === (Wn = rt.sequence) || void 0 === Wn ? void 0 : Wn.id;
                        null === (Co = this._myVTour.state.currentTooltip) || void 0 === Co || Co.hide(), this._myVTour.state.currentTooltip = null, this._myVTour.state.currentNode = null, this._myVTour.state.preload = {}, this._myVTour.datasource.nodes = {}, Dl && this._parent.select(Ll, Dl);
                    }
                    setXYZ(Qe, rt, Wn) {
                        const Co = (0, Ll.xyzToPosition)(Qe - this.getPictureOriginalHeading(), rt, Wn);
                        this.rotate({
                            yaw: Co.yaw,
                            pitch: Co.pitch
                        }), this.zoom(Co.zoom);
                    }
                    setHigherContrast(Qe) {
                        this.renderer.renderer.toneMapping = Qe ? 3 : 0, this.renderer.renderer.toneMappingExposure = Qe ? 2 : 1, this.needsUpdate();
                    }
                    getTransitionDuration() {
                        return this._transitionDuration;
                    }
                    setTransitionDuration(Qe) {
                        if ((Qe = parseFloat(Qe)) < 100 || Qe > Tc) throw new Error("Invalid transition duration (should be between 100 and " + Tc + ")");
                        this._transitionDuration = Qe;
                        const rt = new CustomEvent("transition-duration-changed", {
                            detail: {
                                value: Qe
                            }
                        });
                        this.dispatchEvent(rt);
                    }
                    setPanorama(Qe, rt) {
                        const onFailure = (Qe)=>{
                            var rt;
                            return this.showErrorOverlay(Qe, null === (rt = this._parent) || void 0 === rt ? void 0 : rt._t.pnx.error_pic, !0);
                        };
                        try {
                            return super.setPanorama(Qe, rt).catch(onFailure);
                        } catch (Wn) {
                            onFailure(Wn);
                        }
                    }
                    showErrorOverlay(Qe, rt, Wn) {
                        var Co, Ll, Rl, Ul;
                        null !== (Co = this._parent) && void 0 !== Co && Co.loader.isVisible() || !this.overlay.isVisible() ? null === (Ll = this._parent) || void 0 === Ll || Ll.loader.dismiss(Qe, rt, Wn ? ()=>{
                            var Qe;
                            null === (Qe = this._parent) || void 0 === Qe || Qe.loader.dismiss(), this.overlay.hide();
                        } : void 0) : (console.error(Qe), this.overlay.show({
                            image: `<img style="width: 200px" src="${Dl}" alt="" />`,
                            title: null === (Rl = this._parent) || void 0 === Rl ? void 0 : Rl._t.pnx.error,
                            text: rt + "<br />" + (null === (Ul = this._parent) || void 0 === Ul ? void 0 : Ul._t.pnx.error_click),
                            dissmisable: Wn
                        }));
                    }
                    playSequence() {
                        this._sequencePlaying = !0;
                        const Qe = new Event("sequence-playing", {
                            bubbles: !0,
                            composed: !0
                        });
                        this.dispatchEvent(Qe);
                        const nextPicturePlay = ()=>{
                            if (this._sequencePlaying) {
                                this.addEventListener("picture-loaded", ()=>{
                                    this._playTimer = setTimeout(()=>{
                                        nextPicturePlay();
                                    }, this.getTransitionDuration());
                                }, {
                                    once: !0
                                });
                                try {
                                    this.goToNextPicture();
                                } catch (Qe) {
                                    this.stopSequence();
                                }
                            }
                        };
                        this.addEventListener("click", ()=>this.stopSequence()), nextPicturePlay();
                    }
                    stopSequence() {
                        this._sequencePlaying = !1, this._playTimer && (clearTimeout(this._playTimer), delete this._playTimer), this.forceRefresh();
                        const Qe = new Event("sequence-stopped", {
                            bubbles: !0,
                            composed: !0
                        });
                        this.dispatchEvent(Qe);
                    }
                    isSequencePlaying() {
                        return this._sequencePlaying;
                    }
                    toggleSequencePlaying() {
                        this.isSequencePlaying() ? this.stopSequence() : this.playSequence();
                    }
                    getPicturesNavigation() {
                        return this._picturesNavigation;
                    }
                    setPicturesNavigation(Qe) {
                        "none" === Qe && (Qe = "pic"), this._picturesNavigation = Qe;
                        const rt = new CustomEvent("pictures-navigation-changed", {
                            detail: {
                                value: Qe
                            }
                        });
                        this.dispatchEvent(rt);
                    }
                    _picturesNavFilter(Qe) {
                        switch(this._picturesNavigation){
                            case "seq":
                                return [
                                    "next",
                                    "prev"
                                ].includes(Qe.rel);
                            case "pic":
                            case "none":
                                return !1;
                            default:
                                return !0;
                        }
                    }
                    areAnnotationsVisible() {
                        return this._annotationsVisible;
                    }
                    toggleAllAnnotations(Qe) {
                        const rt = this.getPictureMetadata();
                        if (!rt) throw this._myMarkers.clearMarkers(), new Error("No picture currently selected");
                        if (Qe) {
                            var Wn;
                            let Qe = rt.properties.annotations;
                            0 === Qe.length && console.warn("No annotation available on picture", rt.id);
                            const Co = null === (Wn = this.state.textureData.panoData) || void 0 === Wn ? void 0 : Wn.baseData;
                            Qe = Qe.map((Qe)=>{
                                const rt = this.getPictureMetadata().properties["pers:interior_orientation"].sensor_array_dimensions;
                                if (!rt) return console.warn("Picture lacks pers:interior_orientation.sensor_array_dimensions property, can't compute marker"), null;
                                const Wn = Qe.shape.coordinates.map((Qe)=>Qe.map((Qe)=>{
                                        const Wn = [
                                            Qe[0] * Co.croppedWidth / rt[0],
                                            Qe[1] * Co.croppedHeight / rt[1]
                                        ], Dl = [
                                            (Co.croppedX + Wn[0]) / Co.fullWidth,
                                            (Co.croppedY + Wn[1]) / Co.fullHeight
                                        ];
                                        return [
                                            2 * (Dl[0] - .5) * Math.PI,
                                            (.5 - Dl[1]) * Math.PI
                                        ];
                                    }));
                                return {
                                    id: `annotation-${Qe.id}`,
                                    polygon: Wn,
                                    data: {
                                        id: Qe.id
                                    },
                                    svgStyle: {
                                        stroke: "var(--orange)",
                                        strokeWidth: "3px",
                                        fill: "var(--orange-transparent)",
                                        cursor: "pointer"
                                    },
                                    tooltip: this._parent._t.pnx.semantics_annotation_tooltip
                                };
                            }), this._myMarkers.setMarkers(Qe);
                        } else this._myMarkers.clearMarkers();
                        const Co = this._annotationsVisible != Qe;
                        this._annotationsVisible = Qe, Co && this.dispatchEvent(new CustomEvent("annotations-toggled", {
                            detail: {
                                visible: Qe
                            }
                        }));
                    }
                    focusOnAnnotation(Qe) {
                        this.areAnnotationsVisible() || this.toggleAllAnnotations(!0), this.unfocusAnnotation(!0);
                        const rt = `annotation-${Qe}`;
                        this._myMarkers.updateMarker({
                            id: rt,
                            svgStyle: {
                                stroke: "var(--red)",
                                strokeWidth: "3px",
                                fill: "var(--red-transparent)"
                            },
                            data: {
                                selected: !0
                            }
                        }), this._myMarkers.gotoMarker(rt, 0), this.zoom(65);
                    }
                    unfocusAnnotation() {
                        let Qe = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                        const rt = Object.keys(this._myMarkers.markers).filter((Qe)=>{
                            var rt, Wn, Co;
                            return Qe.startsWith("annotation-") && (null === (rt = this._myMarkers.markers[Qe]) || void 0 === rt || null === (Wn = rt.config) || void 0 === Wn || null === (Co = Wn.data) || void 0 === Co ? void 0 : Co.selected);
                        });
                        rt.length > 0 && (rt.forEach((Qe)=>{
                            this._myMarkers.updateMarker({
                                id: Qe,
                                svgStyle: {
                                    stroke: "var(--orange)",
                                    strokeWidth: "3px",
                                    fill: "var(--orange-transparent)"
                                },
                                data: {
                                    selected: !1
                                }
                            });
                        }), Qe || this.dispatchEvent(new Event("annotations-unfocused")));
                    }
                    forceRefresh() {
                        var Qe;
                        const rt = this._myVTour.getCurrentNode();
                        if (rt && rt.panorama.baseUrl !== (null === rt || void 0 === rt || null === (Qe = rt.panorama) || void 0 === Qe ? void 0 : Qe.origBaseUrl)) {
                            const Qe = this.getZoomLevel(), Wn = this.getPosition();
                            this._myVTour.state.currentNode = null, this._myVTour.setCurrentNode(rt.id, {
                                zoomTo: Qe,
                                rotateTo: Wn,
                                fadeIn: !1,
                                speed: 0,
                                rotation: !1
                            });
                        }
                        rt && rt.panorama.rows > 1 && this.adapter.__refresh();
                    }
                }
            },
            4374: (Qe, rt, Wn)=>{
                "use strict";
                Wn.d(rt, {
                    A: ()=>Popup
                });
                var Co = Wn(4542), Dl = Wn(5995), Ll = Wn(8591), Rl = Wn(6627);
                class Popup extends Co.WF {
                    constructor(){
                        super(), this.visible = !1;
                    }
                    connectedCallback() {
                        super.connectedCallback(), this.addEventListener("click", (Qe)=>{
                            Qe.target === this && this.close();
                        }), document.addEventListener("keyup", (Qe)=>{
                            "Escape" === Qe.key && this.visible && this.close();
                        });
                    }
                    attributeChangedCallback(Qe, rt, Wn) {
                        super.attributeChangedCallback(Qe, rt, Wn), "visible" == Qe && ("" !== Wn && !0 !== Wn || this.dispatchEvent(new Event("open")));
                    }
                    close() {
                        this.visible = !1, this.dispatchEvent(new Event("close"));
                    }
                    render() {
                        return Co.qy`
			<div class="pnx-panel pnx-padded">
				<pnx-button
					class="btn-close"
					kind="flat"
					size="l"
					@click=${this.close.bind(this)}
				>
					${(0, Dl.fa)(Rl.Jy)}
				</pnx-button>

				<slot></slot>
			</div>
		`;
                    }
                }
                Popup.styles = [
                    Ll.nd,
                    Ll.Op,
                    Co.AH`
		/* Backdrop */
		:host {
			display: flex;
			align-items: center;
			justify-content: center;
			position: absolute;
			top: 0;
			right: 0;
			left: 0;
			bottom: 0;
			opacity: 0;
			visibility: hidden;
			pointer-events: none;
			transition: all 0.2s;
			background: rgba(0, 0, 0, 0.85);
		}
		:host(*[visible]) {
			opacity: 1;
			visibility: visible;
			pointer-events: unset;
			z-index: 200;
		}

		/* Content backgroud */
		.pnx-panel {
			box-sizing: border-box;
			position: relative;
			width: 90%;
			max-height: 90%;
			max-width: 550px;
			overflow-y: auto;
		}

		.btn-close {
			position: absolute;
			top: 15px;
			right: 15px;
		}
	`
                ], Popup.properties = {
                    visible: {
                        type: Boolean,
                        reflect: !0
                    }
                }, customElements.define("pnx-popup", Popup);
            },
            4364: (Qe, rt, Wn)=>{
                "use strict";
                Wn.d(rt, {
                    A: ()=>ProgressBar
                });
                var Co = Wn(4542);
                class ProgressBar extends Co.WF {
                    render() {
                        var Qe;
                        return Co.qy`
			<progress
				value=${this.value >= 0 ? this.value : Co.s6}
				class=${this.value >= 0 ? Co.s6 : "indeterminate"}
				max="100"
				title=${null === (Qe = this._t) || void 0 === Qe ? void 0 : Qe.map.loading}
			></progress>
		`;
                    }
                }
                ProgressBar.styles = Co.AH`
		progress {
			max-width: 80vh;
			width: 300px;
			height: 16px;
			appearance: none;
			-webkit-appearance: none;
			border: 1px solid var(--grey-semi-dark);
			background-color: var(--grey);
			border-radius: 8px;
			overflow: hidden;
			padding: 3px;
			box-sizing: border-box;
			display: block;
		}

		progress::-webkit-progress-bar {
			background-color: var(--grey);
		}

		/* Don't merge with -moz below, for some f*ing reason a list selector doesn't work with Chrome */
		progress::-webkit-progress-value {
			background-color: var(--blue);
			border-radius: 5px;
			box-sizing: border-box;
		}

		progress::-moz-progress-bar {
			background-color: var(--blue);
			border-radius: 5px;
			box-sizing: border-box;
		}

		progress[value=""]::-moz-progress-bar,
		progress:not([value])::-moz-progress-bar {
			animation: indeterminateAnimation 1.5s infinite linear;
		}

		progress.indeterminate {
			position: relative;
			background-color: var(--grey);
			overflow: hidden;
		}

		progress.indeterminate::after {
			content: "";
			position: absolute;
			left: 3px;
			top: 3px;
			bottom: 3px;
			width: 20%;
			background-color: var(--blue);
			border-radius: 5px;
			animation: indeterminateAnimation 1.5s infinite linear;
			pointer-events: none;
		}

		@keyframes indeterminateAnimation {
			0%   { margin-left: 0%; width: 2%; }
			15%  { margin-left: 0%; width: 20%; }
			50%  { margin-left: 40%; width: 20%; }
			85%  { margin-left: 80%; width: 20%; }
			100% { margin-left: 98%; width: 2%; }
		}
	`, ProgressBar.properties = {
                    value: {
                        type: Number
                    }
                }, customElements.define("pnx-progress-bar", ProgressBar);
            },
            2675: (Qe, rt, Wn)=>{
                "use strict";
                Wn.d(rt, {
                    A: ()=>QualityScore
                });
                var Co = Wn(4542), Dl = Wn(7343);
                class QualityScore extends Co.WF {
                    constructor(){
                        super(), this.grade = 0, this.input = !1;
                    }
                    _onInput() {
                        const Qe = [];
                        for (let rt of this.renderRoot.querySelectorAll("input"))rt.checked && Qe.push(rt.value);
                        this.grade = Qe.join(","), this.dispatchEvent(new CustomEvent("change", {
                            bubbles: !0,
                            composed: !0
                        }));
                    }
                    render() {
                        const Qe = `${this.grade}`.split(",").map((Qe)=>parseInt(Qe)).filter((Qe)=>!isNaN(Qe));
                        return this.input ? Dl.QUALITYSCORE_VALUES.map((rt, Wn)=>{
                            var Dl;
                            return Co.qy`
				<input
					id="${this.input}-${rt.label}"
					type="checkbox"
					name="qualityscore"
					value="${5 - Wn}"
					@change="${this._onInput}"
					.checked=${Qe.includes(5 - Wn)}
				/>
				<label
					for="${this.input}-${rt.label}"
					title="${null === (Dl = this._t) || void 0 === Dl ? void 0 : Dl.pnx.filter_qualityscore_help}"
					style="background-color: ${rt.color}"
				>
					${rt.label}
				</label>
			`;
                        }) : Dl.QUALITYSCORE_VALUES.map((rt, Wn)=>Co.qy`
				<span class="${Qe.includes(5 - Wn) ? "selected" : ""}" style="background-color: ${rt.color}">
					${rt.label}
				</span>
			`);
                    }
                }
                QualityScore.styles = Co.AH`
		:host {
			gap: 0px;
			justify-content: center;
			height: 2em;
			font-size: 18px;
			display: inline-flex;
			align-items: center;
			color: white;
		}
	
		/* Single letter */
		span, label {
			width: 1.2em;
			height: 1.5em;
			line-height: 1.5em;
			display: inline-block;
			border: 0.05em solid white;
			text-align: center;
			background-color: gray;
			color: rgba(255,255,255,0.9);
			font-family: var(--font-family);
			font-weight: 800;
			vertical-align: middle;
		}

		/* Rounded corners for first/last */
		span:first-of-type, label:first-of-type {
			border-top-left-radius: 0.4em;
			border-bottom-left-radius: 0.4em;
		}

		span:last-of-type, label:last-of-type {
			border-top-right-radius: 0.4em;
			border-bottom-right-radius: 0.4em;
		}

		/* Selected letter */
		.selected, input[type="checkbox"]:checked + label {
			font-size: 1.3em;
			height: 1.6em;
			line-height: 1.6em;
			border-radius: 0.3em !important;
		}

		/* Clickable letter for input */
		label { cursor: pointer; }

		label:hover {
			font-size: 1.2em;
			height: 1.6em;
			line-height: 1.6em;
			border-radius: 0.3em !important;
		}

		input[type="checkbox"] { display: none; }
	`, QualityScore.properties = {
                    grade: {
                        type: String
                    },
                    input: {
                        type: String
                    }
                }, customElements.define("pnx-quality-score", QualityScore);
            },
            3409: (Qe, rt, Wn)=>{
                "use strict";
                Wn.d(rt, {
                    A: ()=>SearchBar
                });
                var Co = Wn(4542), Dl = Wn(1198), Ll = Wn(4901), Rl = Wn(5995), Ul = Wn(8591), Gl = Wn(4011), Zl = Wn(7761), Hl = Wn(3444), ql = Wn(6627);
                class SearchBar extends Co.WF {
                    constructor(){
                        super(), this.reduceable = !1, this.reduced = !1, this.placeholder = Co.s6, this.size = "md", this._icon = "search", this._results = null, this["no-menu-closure"] = !1, this._throttler = null, delete this._lastSearch;
                    }
                    connectedCallback() {
                        super.connectedCallback(), this["no-menu-closure"] || (0, Rl.listenForMenuClosure)(this, this.reset.bind(this));
                    }
                    attributeChangedCallback(Qe, rt, Wn) {
                        super.attributeChangedCallback(Qe, rt, Wn), "value" == Qe && "search" == this._icon && (this._icon = "empty");
                    }
                    _onIconClick() {
                        [
                            "empty",
                            "warn"
                        ].includes(this._icon) && this.reset(), this.reduceable && "search" == this._icon && (this.reduced = !this.reduced);
                    }
                    _onInputChange(Qe) {
                        this.value = Qe.target.value, this._throttledSearch();
                    }
                    _onResultClick(Qe) {
                        this.dispatchEvent(new CustomEvent("result", {
                            bubbles: !0,
                            composed: !0,
                            detail: Qe
                        })), this._results = null, this._throttler && (clearTimeout(this._throttler), this._throttler = null), !this.reduceable && Qe ? (this.value = null === Qe || void 0 === Qe ? void 0 : Qe.title, this._icon = "empty") : (this.value = "", this._icon = "search", this.reduceable && (this.reduced = !0));
                    }
                    _throttledSearch() {
                        this._throttler && (clearTimeout(this._throttler), delete this._throttler), this._throttler = setTimeout(this._search.bind(this), 500);
                    }
                    _search() {
                        this.value && 0 != this.value.length ? this.searcher ? (this._icon = "loading", this._results = null, this.searcher(this.value).then((Qe)=>{
                            if ("loading" === this._icon) {
                                if (this._icon = "empty", Qe && 0 != Qe.length) {
                                    if (!0 === Qe) this._results = null;
                                    else {
                                        var rt;
                                        if (this._results = Qe, !this["no-menu-closure"]) null === (rt = this._parent) || void 0 === rt || rt.dispatchEvent(new CustomEvent("menu-opened", {
                                            detail: {
                                                menu: this
                                            }
                                        }));
                                    }
                                } else this._results = [];
                            }
                        }).catch((Qe)=>{
                            console.error(Qe), this._icon = "warn";
                        })) : console.warn("No search handler defined") : this.reset();
                    }
                    reset() {
                        this._onResultClick(null);
                    }
                    render() {
                        var Qe, rt;
                        const Wn = {
                            sb: !0,
                            "sb-xxl": "xxl" === this.size,
                            "sb-reduceable": this.reduceable,
                            "sb-reduced": this.reduced
                        };
                        return Co.qy`<div
			id=${this.id}
			class=${(0, Dl.H)(Wn)}
			part="container"
		>
			<slot name="pre" class=${(0, Dl.H)({
                            "sb-reduced": this.reduced
                        })}></slot>

			<input
				id="${this.id}-input"
				type="text"
				placeholder=${this.placeholder}
				autocomplete="off"
				@change=${this._onInputChange.bind(this)}
				@keypress=${this._onInputChange.bind(this)}
				@paste=${this._onInputChange.bind(this)}
				@input=${this._onInputChange.bind(this)}
				.value=${this.value || ""}
				part="input"
			/>

			<span
				class="sb-icon"
				@click=${this._onIconClick.bind(this)}
			>
				${"search" == this._icon ? (0, Rl.fa)(Zl.$U) : Co.s6}
				${"loading" == this._icon ? (0, Rl.fa)(Hl.s4, {
                            classes: [
                                "fa-spin"
                            ]
                        }) : Co.s6}
				${"empty" == this._icon ? (0, Rl.fa)(ql.Jy) : Co.s6}
				${"warn" == this._icon ? (0, Rl.fa)(Gl.lE) : Co.s6}
			</span>

			${!this.reduced && this._results ? Co.qy`
				<div class="sb-results">
					${0 === this._results.length ? Co.qy`
						<div class="sb-empty">${null === (Qe = this._parent) || void 0 === Qe || null === (rt = Qe._t) || void 0 === rt ? void 0 : rt.pnx.search_empty}</div>
					` : Co.s6}

					${(0, Ll.T)(this._results, (Qe)=>Co.qy`
						<div class="sb-result" @click=${()=>this._onResultClick(Qe)}>
							${Qe.title}
							${Qe.subtitle && "" != Qe.subtitle ? Co.qy`<br /><small>${Qe.subtitle}</small>` : Co.s6}
						</div>
					`)}
				</div>
			` : Co.s6}
		</div>`;
                    }
                }
                SearchBar.styles = [
                    Ul.Op,
                    Co.AH`
		/* Container */
		.sb {
			display: flex;
			align-items: center;
			justify-content: space-between;
			gap: 5px;
			border: 1px solid var(--widget-border-div);
			border-radius: 5px;
			background-color: var(--widget-bg);
			color: var(--widget-font);
			height: 30px;
			border-radius: 20px;
			position: relative;
			padding: 0 0 0 10px;
			width: fit-content;
			max-width: 100%;
			box-sizing: border-box;
			font-family: var(--font-family);
		}
		.sb.sb-xxl {
			height: 40px;
			line-height: 40px;
		}
		.sb.sb-reduceable {
			width: 360px;
		}
		.sb.sb-reduceable.sb-reduced {
			width: fit-content;
			padding: 0;
			gap: 0;
		}

		/* Text field */
		.sb input {
			background: none;
			border: none !important;
			outline: none;
			height: 20px;
			width: 100%;
			font-family: var(--font-family);
		}
		.sb.sb-xxl input {
			font-size: 1.1em;
		}
		.sb.sb-reduceable.sb-reduced input {
			display: none;
		}

		/* Status icon */
		.sb-icon {
			cursor: pointer;
			height: 30px;
			line-height: 30px;
			width: 30px;
			min-width: 30px;
			text-align: center;
		}
		.sb.sb-xxl .sb-icon {
			height: 40px;
			line-height: 40px;
			width: 40px;
			min-width: 40px;
		}
		.sb-icon svg {
			pointer-events: none;
			width: 14px;
			height: 14px;
		}

		/* Search results */
		.sb-results {
			position: absolute;
			top: 35px;
			list-style: none;
			margin: 0;
			padding: 0;
			max-width: calc(100% - 20px);
			border: 1px solid var(--widget-border-div);
			border-radius: 10px;
			background-color: var(--widget-bg);
			color: var(--widget-font);
			z-index: 130;
			font-size: 1.05em;
  			line-height: normal;
			font-family: var(--font-family);
		}
		.sb.sb-xxl .sb-results {
			top: 45px;
		}
		.sb-result,
		.sb-empty {
			display: block;
			padding: 5px 15px;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
			cursor: pointer;
			border-radius: 0;
		}
		.sb-result:hover {
			background-color: var(--widget-bg-hover);
		}
		.sb-result:first-child {
			border-top-right-radius: 10px;
			border-top-left-radius: 10px;
			padding-top: 15px;
		}
		.sb-result:last-child {
			border-bottom-right-radius: 10px;
			border-bottom-left-radius: 10px;
			padding-bottom: 15px;
		}
	`
                ], SearchBar.properties = {
                    id: {
                        type: String
                    },
                    placeholder: {
                        type: String
                    },
                    reduceable: {
                        type: Boolean,
                        reflect: !0
                    },
                    reduced: {
                        type: Boolean,
                        reflect: !0
                    },
                    value: {
                        type: String
                    },
                    size: {
                        type: String
                    },
                    _icon: {
                        state: !0
                    },
                    _results: {
                        state: !0
                    },
                    searcher: {
                        type: Function
                    },
                    "no-menu-closure": {
                        type: Boolean
                    }
                }, customElements.define("pnx-search-bar", SearchBar);
            },
            2373: (Qe, rt, Wn)=>{
                "use strict";
                Wn.d(rt, {
                    A: ()=>SemanticsTable
                });
                var Co = Wn(4542), Dl = Wn(8591), Ll = Wn(2283);
                class SemanticsTable extends Co.WF {
                    render() {
                        if (!this.source) return Co.s6;
                        const Qe = (0, Ll.groupByPrefix)(this.source.semantics);
                        return Co.qy`<table>
			<thead>
				<tr><th>${this._t.pnx.semantics_key}</th><th>${this._t.pnx.semantics_value}</th></tr>
			</thead>
			<tbody>
				${Qe.map((Qe)=>Qe.tags.map((rt)=>Co.qy`
					<tr>
						<td>
							${"" != Qe.prefix ? Qe.logo ? Co.qy`<img src=${Qe.logo} class="prefix-logo" alt=${Qe.prefix} title=${Qe.title} />` : Co.qy`<small>(${Qe.prefix})</small>` : Co.s6}
							${Qe.key_transform ? Qe.key_transform(rt, this._t) : rt.key}
						</td>
						<td>
							${Qe.value_transform ? Qe.value_transform(rt, this._t) : rt.value}
							${rt.qualifiers ? Co.qy`<div class="qualifiers">
								<b>${this._t.pnx.semantics_qualifiers}</b>
								<ul>
									${rt.qualifiers.map((Qe)=>Co.qy`<li>${Qe.subkey} = ${Qe.value}</li>`)}
								</ul>
							</div>` : Co.s6}
						</td>
					</tr>
				`))}
			</tbody>
		</table>`;
                    }
                }
                SemanticsTable.styles = [
                    Dl.tp,
                    Co.AH`
		th:first-child, td:first-child { width: 30%; }
		td { vertical-align: top; }

		td small { color: var(--grey-semi-dark); }
		.qualifiers { margin-top: 5px; }
		.qualifiers > b { margin: 8px 0; }
		.qualifiers ul {
			list-style: none;
			margin: 0px 0px 0px 15px;
			padding: 0;
		}

		img.prefix-logo {
			max-width: 15px;
			max-height: 15px;
			aspect-ratio: 1;
			vertical-align: middle;
		}
	`
                ], SemanticsTable.properties = {
                    source: {
                        type: Object
                    }
                }, customElements.define("pnx-semantics-table", SemanticsTable);
            },
            5202: (Qe, rt, Wn)=>{
                "use strict";
                Wn.d(rt, {
                    A: ()=>TogglableGroup
                });
                var Co = Wn(4542), Dl = Wn(8591), Ll = Wn(5995), Rl = Wn(1198);
                class TogglableGroup extends Co.WF {
                    constructor(){
                        super(), this._opened = !1;
                    }
                    open() {
                        var Qe;
                        this._opened = !0, null === (Qe = this._parent) || void 0 === Qe || Qe.dispatchEvent(new CustomEvent("menu-opened", {
                            detail: {
                                menu: this
                            }
                        })), this.adjustMenuPosition(this._btn), this._chevron && (this._chevron.style.rotate = "180deg");
                    }
                    close() {
                        this._opened = !1, this._chevron && (this._chevron.style.rotate = "");
                    }
                    connectedCallback() {
                        super.connectedCallback(), (0, Ll.listenForMenuClosure)(this, this.close.bind(this));
                    }
                    handleButtonSlotChange(Qe) {
                        this._btn = Qe.target.assignedNodes().pop(), this._btn && (this._chevron = this._btn.querySelector("svg.fa-chevron-down"), this._chevron && (this._chevron.style.transition = "rotate 0.2s", this._chevron.style.rotate = this._opened ? "180deg" : ""), this._btn.addEventListener("click", ()=>{
                            this._opened ? this.close() : this.open();
                        }));
                    }
                    adjustMenuPosition(Qe) {
                        const rt = this.shadowRoot.querySelector("div[part='menu']");
                        rt.style.top = null, rt.style.bottom = null, rt.style.right = null, rt.style.left = null, rt.style.overflowY = null, rt.style.marginTop = null;
                        const Wn = Qe.getBoundingClientRect();
                        let Co = rt.getBoundingClientRect();
                        const Dl = Co.right <= window.innerWidth - 10, Ll = Co.bottom <= window.innerHeight - 10;
                        Dl && Ll ? rt.style.top = `${Wn.bottom + 5}px` : Dl || Ll ? Ll ? Dl || (rt.style.marginTop = "5px", rt.style.right = window.innerWidth - Wn.right + "px") : (rt.style.bottom = "10px", rt.style.top = `${Wn.bottom + 5}px`, rt.style.overflowY = "auto") : (rt.style.right = window.innerWidth - Wn.left + 5 + "px", rt.style.bottom = window.innerHeight - Wn.bottom + "px", Co = rt.getBoundingClientRect(), Co.top - 10 < 0 && (rt.style.bottom = "10px", rt.style.top = `${Wn.top}px`, rt.style.overflowY = "auto"));
                    }
                    render() {
                        const Qe = {
                            "pnx-panel": !0,
                            "pnx-panel-fixed": !0,
                            "pnx-hidden": !this._opened,
                            "pnx-padded": "false" !== this.padded
                        };
                        return Co.qy`<div class="container" @click=${(Qe)=>Qe.stopPropagation()}>
			<slot name="button" @slotchange=${this.handleButtonSlotChange}></slot>
			<div class=${(0, Rl.H)(Qe)} part="menu">
				<slot></slot>
			</div>
		</div>`;
                    }
                }
                TogglableGroup.styles = [
                    Dl.nd,
                    Co.AH`
		div.container {
			position: relative;
			height: 100%;
		}

		.pnx-panel { z-index: 130; }
		.pnx-panel-fixed { position: fixed; }
	`
                ], TogglableGroup.properties = {
                    _opened: {
                        state: !0
                    },
                    padded: {
                        type: String
                    }
                }, customElements.define("pnx-togglable-group", TogglableGroup);
            },
            9472: (Qe, rt, Wn)=>{
                "use strict";
                Wn.r(rt), Wn.d(rt, {
                    Button: ()=>Dl.A,
                    ButtonGroup: ()=>Co.A,
                    CopyButton: ()=>Ll.A,
                    Grade: ()=>Rl.A,
                    HashTags: ()=>Ul.A,
                    LinkButton: ()=>Gl.A,
                    ListGroup: ()=>Zl.A,
                    ListItem: ()=>Hl.A,
                    Loader: ()=>ql.A,
                    Map: ()=>Ql.A,
                    MapMore: ()=>Kl.A,
                    Photo: ()=>$l.Ay,
                    Popup: ()=>Tc.A,
                    ProgressBar: ()=>tu.A,
                    QualityScore: ()=>lu.A,
                    SearchBar: ()=>du.A,
                    SemanticsTable: ()=>fu.A,
                    TogglableGroup: ()=>yu.A,
                    widgets: ()=>Eu
                });
                var Co = Wn(7679), Dl = Wn(4450), Ll = Wn(1903), Rl = Wn(5051), Ul = Wn(7939), Gl = Wn(438), Zl = Wn(5271), Hl = Wn(5525), ql = Wn(3109), Ql = Wn(5642), Kl = Wn(2771), $l = Wn(9048), Tc = Wn(4374), tu = Wn(4364), lu = Wn(2675), du = Wn(3409), fu = Wn(2373), yu = Wn(5202), Eu = Wn(222);
            },
            5114: (Qe, rt, Wn)=>{
                "use strict";
                Wn.d(rt, {
                    A: ()=>CopyCoordinates
                });
                var Co = Wn(4542), Dl = Wn(7343), Ll = Wn(5995), Rl = Wn(2593), Ul = Wn(8591);
                class CopyCoordinates extends Co.WF {
                    render() {
                        var Qe, rt;
                        const Wn = (0, Dl.degToDms)(this.gps[0]), Ul = Wn.d < 0 ? `${Math.abs(Wn.d)}\xb0${Wn.m}'${Wn.s}"W` : `${Wn.d}\xb0${Wn.m}'${Wn.s}"E`, Gl = (0, Dl.degToDms)(this.gps[1]), Zl = Gl.d < 0 ? `${Math.abs(Gl.d)}\xb0${Gl.m}'${Gl.s}"S` : `${Gl.d}\xb0${Gl.m}'${Gl.s}"N`, Hl = {
                            ddeclatlon: `${this.gps[1].toFixed(7)}, ${this.gps[0].toFixed(7)}`,
                            ddeclonlat: `${this.gps[0].toFixed(7)}, ${this.gps[1].toFixed(7)}`,
                            ddmslonlat: `${Ul}, ${Zl}`,
                            ddmslatlon: `${Zl}, ${Ul}`
                        };
                        return Co.qy`<pnx-button-group style="display: inline-block; vertical-align: baseline" dir="row">
			<pnx-copy-button
				size="sm"
				text=${Hl.ddeclonlat}
				title=${null === (Qe = this._parent) || void 0 === Qe ? void 0 : Qe._t.pnx.metadata_location_copy.replace("{v}", Hl.ddeclonlat)}
			></pnx-copy-button>

			<pnx-togglable-group padded="false" ._parent=${this._parent}>
				<pnx-button
					size="sm"
					slot="button"
					title=${null === (rt = this._parent) || void 0 === rt ? void 0 : rt._t.pnx.metadata_location_copy_more}
				>${(0, Ll.fa)(Rl.Jt)}</pnx-button>
				<pnx-list-group>
					${Object.values(Hl).map((Qe)=>{
                            var rt;
                            return Co.qy`
						<pnx-copy-button unstyled text=${Qe} ._t=${this._parent._t}>
							${null === (rt = this._parent) || void 0 === rt ? void 0 : rt._t.pnx.metadata_location_copy.replace("{v}", Qe)}
						</pnx-copy-button>
					`;
                        })}
				</pnx-list-group>
			</pnx-togglable-group>
		</pnx-button-group>`;
                    }
                }
                CopyCoordinates.styles = [
                    Ul.kq,
                    Co.AH`
		pnx-togglable-group::part(menu) {
			border-radius: 5px;
			min-width: unset;
		}
	`
                ], CopyCoordinates.properties = {
                    gps: {
                        type: Array
                    }
                }, customElements.define("pnx-copy-coordinates", CopyCoordinates);
            },
            2603: (Qe, rt, Wn)=>{
                "use strict";
                Wn.d(rt, {
                    A: ()=>GeoSearch
                });
                var Co = Wn(927), Dl = Wn.n(Co), Ll = Wn(4542), Rl = Wn(3606);
                Wn(3630);
                const Ul = {
                    ban: Rl.forwardGeocodingBAN,
                    standard: Rl.forwardGeocodingStandard,
                    nominatim: Rl.forwardGeocodingNominatim
                };
                class GeoSearch extends Ll.WF {
                    constructor(){
                        super(), this.geocoder = "nominatim", this._geolocateCtrl = new (Dl()).GeolocateControl({
                            positionOptions: {
                                enableHighAccuracy: !0,
                                timeout: 6e4,
                                maximumAge: 3e5
                            },
                            showAccuracyCircle: !0,
                            showUserLocation: !0,
                            trackUserLocation: !0
                        });
                    }
                    createRenderRoot() {
                        return this;
                    }
                    connectedCallback() {
                        var Qe, rt;
                        super.connectedCallback(), this._geocoderEngine = Ul[this.geocoder] || ((Qe)=>Ul.standard(Qe, this.geocoder)), null === (Qe = this._parent) || void 0 === Qe || null === (rt = Qe.onceMapReady) || void 0 === rt || rt.call(Qe).then(()=>{
                            this._geolocate = this._geolocateCtrl.onAdd(this._parent.map), this._geolocate.setAttribute("slot", "pre");
                        });
                    }
                    _onInput(Qe) {
                        const rt = Qe.match(/([-+]?\d{1,2}\.\d+),\s*([-+]?\d{1,3}\.\d+)/), Wn = Qe.match(/^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/);
                        if (rt) {
                            const Qe = parseFloat(rt[1]), Wn = parseFloat(rt[2]);
                            return this._parent.map.jumpTo({
                                center: [
                                    Wn,
                                    Qe
                                ],
                                zoom: 16
                            }), Promise.resolve(!0);
                        }
                        return Wn ? (this._parent.select(null, Qe), Promise.resolve(!0)) : this._geocoderEngine({
                            query: Qe,
                            limit: 5,
                            proximity: this._parent.map.getCenter().lat + "," + this._parent.map.getCenter().lng
                        }).then((Qe)=>Qe = Qe.features.map((Qe)=>({
                                    title: Qe.place_name.split(",")[0],
                                    subtitle: Qe.place_name.split(",").slice(1).join(", "),
                                    data: Qe
                                })));
                    }
                    _onSelect(Qe) {
                        const rt = Qe.detail;
                        var Wn, Co;
                        rt && (rt.data.bounds ? null === (Wn = this._parent) || void 0 === Wn || Wn.map.fitBounds(rt.data.bounds, {
                            animate: !1
                        }) : null === (Co = this._parent) || void 0 === Co || Co.map.jumpTo({
                            center: rt.data.center,
                            zoom: rt.data.zoom || 13
                        }));
                    }
                    render() {
                        var Qe, rt;
                        const Wn = (null === (Qe = this._parent) || void 0 === Qe ? void 0 : Qe.isWidthSmall()) || !1;
                        return Ll.qy`
			<pnx-search-bar
				id="pnx-widget-search-bar"
				placeholder=${null === (rt = this._parent) || void 0 === rt ? void 0 : rt._t.pnx.search_address}
				._parent=${this._parent}
				.searcher=${this._onInput.bind(this)}
				.reduceable=${Wn}
				.reduced=${Wn}
				size="xxl"
				class="pnx-print-hidden"
				@result=${this._onSelect.bind(this)}
			>
				${this._geolocate}
			</pnx-search-bar>
		`;
                    }
                }
                GeoSearch.properties = {
                    geocoder: {
                        type: String
                    },
                    _geolocate: {
                        state: !0
                    }
                }, customElements.define("pnx-widget-geosearch", GeoSearch);
            },
            4385: (Qe, rt, Wn)=>{
                "use strict";
                Wn.d(rt, {
                    A: ()=>Legend
                });
                var Co = Wn(4542), Dl = Wn(8591), Ll = Wn(5995), Rl = Wn(6668), Ul = Wn(5940), Gl = Wn(1198);
                class Legend extends Co.WF {
                    render() {
                        var Qe, rt;
                        const Wn = {
                            "pnx-panel": !0,
                            "pnx-padded": "map" == this.focus
                        };
                        return Co.qy`<div class=${(0, Gl.H)(Wn)} part="panel">
			<div
				class="presentation"
				style=${"map" != this.focus && this.picture ? "display: none" : ""}
			>
				<img class="logo" src=${Ul} alt="" />
				<div>
					${null === (Qe = this._parent) || void 0 === Qe ? void 0 : Qe._t.pnx.whats_panoramax}
					<pnx-link-button
						title=${null === (rt = this._parent) || void 0 === rt ? void 0 : rt._t.map.more_panoramax}
						kind="superinline"
						href="https://panoramax.fr"
						target="_blank"
						size="sm"
					>
						${(0, Ll.fa)(Rl.iW)}
					</pnx-link-button>
				</div>
			</div>
			<pnx-picture-legend
				._parent=${this._parent}
				style=${"map" == this.focus ? "display: none" : ""}
				collapsable
			>
				<slot slot="editors" name="editors">
					<pnx-widget-osmeditors ._parent=${this._parent} />
				</slot>
			</pnx-picture-legend>
			<pnx-map-legend
				._parent=${this._parent}
				style=${"map" != this.focus ? "display: none" : ""}
			></pnx-map-legend>
		</div>`;
                    }
                }
                Legend.styles = [
                    Dl.nd,
                    Co.AH`
		.pnx-panel[part="panel"] {
			border-radius: 10px;
			position: relative;
			max-width: 80vw;
			z-index: 121; /* To appear above mini component */
			min-width: unset;
		}
		.pnx-panel[part="panel"].pnx-padded {
			padding: 10px;
			width: 250px;
		}
		.presentation {
			font-size: 0.9em;
			display: flex;
			gap: 5px;
			align-items: center;
		}
		.logo {
			width: 45px;
		}
	`
                ], Legend.properties = {
                    focus: {
                        type: String
                    },
                    picture: {
                        type: String
                    }
                }, customElements.define("pnx-widget-legend", Legend);
            },
            4529: (Qe, rt, Wn)=>{
                "use strict";
                Wn.d(rt, {
                    A: ()=>MapFiltersButton
                });
                var Co = Wn(4542), Dl = Wn(5995), Ll = Wn(1904), Rl = Wn(2593), Ul = Wn(6627), Gl = Wn(8591), Zl = Wn(2771);
                class MapFiltersButton extends Co.WF {
                    constructor(){
                        super(), this["user-search"] = !1, this["quality-score"] = !1, this._active = !1;
                    }
                    connectedCallback() {
                        var Qe, rt;
                        super.connectedCallback(), null === (Qe = this._parent) || void 0 === Qe || null === (rt = Qe.onceMapReady) || void 0 === rt || rt.call(Qe).then(()=>{
                            this._active = Object.keys(this._parent.map._mapFilters).filter((Qe)=>Qe && "theme" !== Qe).length > 0 || this._parent.map.getVisibleUsers().filter((Qe)=>"geovisio" !== Qe).length > 0, this._parent.map.on("filters-changed", (Qe)=>{
                                this._active = Object.keys(Qe).filter((Qe)=>Qe && Zl.T.includes(Qe) && "theme" != Qe).length > 0 || this._parent.map.getVisibleUsers().filter((Qe)=>"geovisio" !== Qe).length > 0;
                            }), this._parent.map.on("users-changed", (Qe)=>{
                                this._active = Object.keys(this._parent.map._mapFilters).filter((Qe)=>Qe && "theme" !== Qe).length > 0 || Qe.usersIds.filter((Qe)=>"geovisio" !== Qe).length > 0;
                            });
                        });
                    }
                    render() {
                        var Qe, rt;
                        const Wn = null === (Qe = this._parent) || void 0 === Qe ? void 0 : Qe.isWidthSmall(), Gl = (0, Dl.fa)(Ul.Jy);
                        return Gl.addEventListener("click", (Qe)=>{
                            Qe.stopPropagation(), this.shadowRoot.querySelector("pnx-map-filters-menu")._onReset(), this.shadowRoot.querySelector("#pnx-widget-filter")._opened = !1;
                        }), Co.qy`
			<pnx-togglable-group
				id="pnx-widget-filter"
				padded="false"
				class="pnx-only-map pnx-print-hidden"
				._parent=${this._parent}
			>
				<pnx-button kind="flat" size="xl" slot="button">
					${(0, Dl.fa)(Ll._$)}
					${this._active ? Co.qy`<span class="pnx-active-icon"></span>` : Co.s6}
					${Wn ? Co.s6 : null === (rt = this._parent) || void 0 === rt ? void 0 : rt._t.pnx.filters}
					${Wn ? Co.s6 : this._active ? Gl : (0, Dl.fa)(Rl.Jt)}
				</pnx-button>
				<pnx-map-filters-menu
					id="pnx-map-filters-menu"
					._parent=${this._parent}
					user-search=${this["user-search"]}
					quality-score=${this["quality-score"]}
				></pnx-map-filters-menu>
			</pnx-togglable-group>
		`;
                    }
                }
                MapFiltersButton.styles = [
                    Gl.s0
                ], MapFiltersButton.properties = {
                    "user-search": {
                        type: Boolean
                    },
                    "quality-score": {
                        type: Boolean
                    },
                    _active: {
                        state: !0
                    }
                }, customElements.define("pnx-widget-mapfilters", MapFiltersButton);
            },
            1614: (Qe, rt, Wn)=>{
                "use strict";
                Wn.d(rt, {
                    A: ()=>MapLayersButton
                });
                var Co = Wn(4542), Dl = Wn(5995), Ll = Wn(4220), Rl = Wn(2593), Ul = Wn(6627), Gl = Wn(8591);
                class MapLayersButton extends Co.WF {
                    constructor(){
                        super(), this._active = !1;
                    }
                    connectedCallback() {
                        var Qe, rt;
                        super.connectedCallback();
                        const Wn = [
                            void 0,
                            null,
                            "",
                            "default"
                        ];
                        null === (Qe = this._parent) || void 0 === Qe || null === (rt = Qe.onceMapReady) || void 0 === rt || rt.call(Qe).then(()=>{
                            this._active = !Wn.includes(this._parent.map._mapFilters.theme), this._parent.map.on("filters-changed", (Qe)=>{
                                this._active = !Wn.includes(Qe.theme);
                            });
                        });
                    }
                    render() {
                        var Qe, rt;
                        const Wn = null === (Qe = this._parent) || void 0 === Qe ? void 0 : Qe.isWidthSmall(), Gl = (0, Dl.fa)(Ul.Jy);
                        return Gl.addEventListener("click", (Qe)=>{
                            Qe.stopPropagation();
                            const rt = this.shadowRoot.querySelector("pnx-map-layers-menu");
                            rt.shadowRoot.querySelector("#pnx-map-theme").value = "default", rt._onThemeSelect({
                                target: {
                                    value: "default"
                                }
                            }), this.shadowRoot.querySelector("#pnx-widget-map-layers")._opened = !1;
                        }), Co.qy`
			<pnx-togglable-group
				id="pnx-widget-map-layers"
				class="pnx-print-hidden"
				._parent=${this._parent}
			>
				<pnx-button kind="flat" size="xl" slot="button">
					${(0, Dl.fa)(Ll.qI)}
					${this._active ? Co.qy`<span class="pnx-active-icon"></span>` : Co.s6}
					${Wn ? Co.s6 : null === (rt = this._parent) || void 0 === rt ? void 0 : rt._t.pnx.layers}
					${Wn ? Co.s6 : this._active ? Gl : (0, Dl.fa)(Rl.Jt)}
				</pnx-button>
				<pnx-map-layers-menu
					id="pnx-map-layers-menu"
					._parent=${this._parent}
				></pnx-map-layers-menu>
			</pnx-togglable-group>
		`;
                    }
                }
                MapLayersButton.styles = [
                    Gl.s0
                ], MapLayersButton.properties = {
                    _active: {
                        state: !0
                    }
                }, customElements.define("pnx-widget-maplayers", MapLayersButton);
            },
            5789: (Qe, rt, Wn)=>{
                "use strict";
                Wn.d(rt, {
                    A: ()=>OSMEditors
                });
                var Co = Wn(4542), Dl = Wn(5995), Ll = Wn(7343), Rl = Wn(7208), Ul = Wn(3520), Gl = Wn(6787), Zl = Wn(7704);
                const Hl = "http://127.0.0.1:8111";
                class OSMEditors extends Co.WF {
                    constructor(){
                        super(), this._josm = !1;
                    }
                    connectedCallback() {
                        var Qe;
                        super.connectedCallback(), null === (Qe = this._parent) || void 0 === Qe || Qe.onceReady().then(()=>{
                            this._parent.onceFirstPicLoaded().then(this._onPictureLoad.bind(this)), this._parent.psv.addEventListener("picture-loaded", this._onPictureLoad.bind(this));
                        });
                    }
                    _onPictureLoad() {
                        var Qe, rt;
                        this._pic = null === (Qe = this._parent) || void 0 === Qe || null === (rt = Qe.psv) || void 0 === rt ? void 0 : rt.getPictureMetadata();
                    }
                    _toggleJOSMLive() {
                        var Qe, rt, Wn, Co, Dl, Rl;
                        (this._josm = !this._josm, this._josm) ? fetch(Hl + "/version").then(()=>{
                            var Qe, rt, Wn, Co, Dl, Rl, Ul, Gl, Zl;
                            const ql = (0, Ll.josmBboxParameters)(null === (Qe = this._parent) || void 0 === Qe || null === (rt = Qe.psv) || void 0 === rt || null === (Wn = rt.getPictureMetadata) || void 0 === Wn ? void 0 : Wn.call(rt));
                            if (ql) fetch(`${Hl}/load_and_zoom?${ql}`).catch((Qe)=>{
                                console.warn(Qe), this._toggleJOSMLive();
                            });
                            this._josmListener = ()=>{
                                var Qe, rt, Wn;
                                const Co = (0, Ll.josmBboxParameters)(null === (Qe = this._parent) || void 0 === Qe || null === (rt = Qe.psv) || void 0 === rt || null === (Wn = rt.getPictureMetadata) || void 0 === Wn ? void 0 : Wn.call(rt));
                                if (Co) fetch(`${Hl}/zoom?${Co}`).catch((Qe)=>{
                                    console.warn(Qe), this._toggleJOSMLive();
                                });
                            }, null === (Co = this._parent) || void 0 === Co || null === (Dl = Co.psv) || void 0 === Dl || null === (Rl = Dl.addEventListener) || void 0 === Rl || Rl.call(Dl, "picture-loaded", this._josmListener), null === (Ul = this._parent) || void 0 === Ul || null === (Gl = Ul.psv) || void 0 === Gl || null === (Zl = Gl.addEventListener) || void 0 === Zl || Zl.call(Gl, "picture-loading", this._josmListener);
                        }).catch((Qe)=>{
                            var rt;
                            console.warn(Qe), alert(null === (rt = this._parent) || void 0 === rt ? void 0 : rt._t.pnx.error_josm), this._toggleJOSMLive();
                        }) : this._josmListener && (null === (Qe = this._parent) || void 0 === Qe || null === (rt = Qe.psv) || void 0 === rt || null === (Wn = rt.removeEventListener) || void 0 === Wn || Wn.call(rt, "picture-loading", this._josmListener), null === (Co = this._parent) || void 0 === Co || null === (Dl = Co.psv) || void 0 === Dl || null === (Rl = Dl.removeEventListener) || void 0 === Rl || Rl.call(Dl, "picture-loaded", this._josmListener), delete this._josmListener);
                    }
                    render() {
                        var Qe, rt;
                        if (!this._pic) return Co.s6;
                        if (null !== (Qe = this._parent) && void 0 !== Qe && Qe.isWidthSmall()) return Co.qy`
				<pnx-link-button
					size="sm"
					href="geo:${this._pic.gps[1]},${this._pic.gps[0]};u=3"
				>
					${(0, Dl.fa)(Zl.A)} ${null === (rt = this._parent) || void 0 === rt ? void 0 : rt._t.pnx.geo_uri}
				</pnx-link-button>
			`;
                        {
                            var Wn, Ll, Hl, ql;
                            const Qe = {
                                map: `19/${this._pic.gps[1]}/${this._pic.gps[0]}`,
                                source: "Panoramax",
                                photo_overlay: "panoramax",
                                photo: `panoramax/${this._pic.id}`
                            }, rt = Qe && `${(0, Rl.IdEditorURL)()}#${new URLSearchParams(Qe).toString()}`;
                            return Co.qy`
				<pnx-link-button
					size="sm"
					href=${rt}
					target="_blank"
					title="${null === (Wn = this._parent) || void 0 === Wn ? void 0 : Wn._t.pnx.contribute_id}"
				>
					${(0, Dl.fa)(Ul.gK)} ${null === (Ll = this._parent) || void 0 === Ll ? void 0 : Ll._t.pnx.id}
				</pnx-link-button>

				<pnx-button
					id="pnx-edit-josm"
					size="sm"
					active=${this._josm ? "" : Co.s6}
					@click=${this._toggleJOSMLive}
					title="${null === (Hl = this._parent) || void 0 === Hl ? void 0 : Hl._t.pnx.josm_live}"
				>
					${(0, Dl.fa)(Gl.hU)} ${null === (ql = this._parent) || void 0 === ql ? void 0 : ql._t.pnx.josm}
				</pnx-button>
			`;
                        }
                    }
                }
                OSMEditors.properties = {
                    _pic: {
                        state: !0
                    },
                    _josm: {
                        state: !0
                    }
                }, OSMEditors.styles = Co.AH`
		:host { display: inline-flex; gap: 5px; }
		:host > * { flex: 1; }
		pnx-link-button::part(btn) { height: auto; }
	`, customElements.define("pnx-widget-osmeditors", OSMEditors);
            },
            8806: (Qe, rt, Wn)=>{
                "use strict";
                Wn.d(rt, {
                    A: ()=>PictureLegendActions
                });
                var Co = Wn(4542), Dl = Wn(5995), Ll = Wn(3613), Rl = Wn(8591);
                class PictureLegendActions extends Co.WF {
                    constructor(){
                        super(), this.full = !1;
                    }
                    connectedCallback() {
                        var Qe;
                        super.connectedCallback(), null === (Qe = this._parent) || void 0 === Qe || Qe.onceReady().then(()=>{
                            this._meta = this._parent.psv.getPictureMetadata(), this._parent.psv.addEventListener("picture-loaded", ()=>{
                                this._meta = this._parent.psv.getPictureMetadata();
                            });
                        });
                    }
                    _onPrint() {
                        this._closeGroup(), window.print();
                    }
                    _closeGroup() {
                        this.renderRoot.querySelector("#pic-legend-headline-menu").close();
                    }
                    _onShareClick() {
                        this._closeGroup(), this._parent._showShareOptions();
                    }
                    _onReportClick() {
                        this._closeGroup(), this._parent._showReportForm();
                    }
                    render() {
                        var Qe, rt, Wn, Rl, Ul, Gl, Zl, Hl, ql, Ql, Kl, $l, Tc, tu, lu, du;
                        return Co.qy`<pnx-togglable-group padded="false" id="pic-legend-headline-menu" ._parent=${this._parent}>
			<pnx-button slot="button" kind="inline">${(0, Dl.fa)(Ll.v)}</pnx-button>
			<pnx-list-group class="pnx-print-hidden" @click=${this._closeMenu}>
				${this.full ? Co.qy`
					<a
						download
						target="_blank"
						href=${null === (Qe = this._meta) || void 0 === Qe || null === (rt = Qe.panorama) || void 0 === rt ? void 0 : rt.hdUrl}
						@click=${this._closeGroup}
					>${null === (Wn = this._parent) || void 0 === Wn ? void 0 : Wn._t.pnx.share_image}</a>
					${this._parent.isWidthSmall() ? Co.s6 : Co.qy`<button @click=${this._onPrint}>
						${null === (Rl = this._parent) || void 0 === Rl ? void 0 : Rl._t.pnx.share_print}
					</button>`}
					${(null === (Ul = this._parent) || void 0 === Ul || null === (Gl = Ul.api) || void 0 === Gl ? void 0 : Gl.getRSSURL()) && Co.qy`
						<a
							target="_blank"
							href=${null === (Zl = this._parent) || void 0 === Zl ? void 0 : Zl.api.getRSSURL(null === (Hl = this._parent) || void 0 === Hl || null === (ql = Hl.map) || void 0 === ql || null === (Ql = ql.getBounds) || void 0 === Ql ? void 0 : Ql.call(ql))}
							title=${null === (Kl = this._parent) || void 0 === Kl ? void 0 : Kl._t.pnx.share_rss_title}
							@click=${this._closeGroup}
						>
							${null === ($l = this._parent) || void 0 === $l ? void 0 : $l._t.pnx.share_rss}
						</a>
					`}
				` : Co.qy`
					<button @click=${this._onReportClick}>
						${null === (Tc = this._parent) || void 0 === Tc ? void 0 : Tc._t.pnx.report}
					</button>
					<button @click=${this._onShareClick}>
						${null === (tu = this._parent) || void 0 === tu ? void 0 : tu._t.pnx.share}
					</button>
					${this._meta ? Co.qy`<pnx-copy-button ._t=${null === (lu = this._parent) || void 0 === lu ? void 0 : lu._t} text=${this._meta.id} unstyled>
						${null === (du = this._parent) || void 0 === du ? void 0 : du._t.pnx.metadata_general_copy_picid}
					</pnx-copy-button>` : Co.s6}
				`}
			</pnx-list-group>
		</pnx-togglable-group>`;
                    }
                }
                PictureLegendActions.styles = [
                    Rl.BQ,
                    Co.AH`
		pnx-togglable-group::part(menu) {
			border-radius: 5px;
			min-width: unset;
		}
	`
                ], PictureLegendActions.properties = {
                    full: {
                        type: Boolean
                    },
                    _meta: {
                        state: !0
                    }
                }, customElements.define("pnx-picture-legend-actions", PictureLegendActions);
            },
            8305: (Qe, rt, Wn)=>{
                "use strict";
                Wn.d(rt, {
                    A: ()=>Player
                });
                var Co = Wn(4542), Dl = Wn(5995), Ll = Wn(1705), Rl = Wn(6386), Ul = Wn(7472), Gl = Wn(5431), Zl = Wn(6533);
                Wn(1230);
                class Player extends Co.WF {
                    constructor(){
                        super(), this.playing = !1, this.size = "xl", this._activePrev = !0, this._activePlay = !0, this._activeNext = !0;
                    }
                    createRenderRoot() {
                        return this;
                    }
                    connectedCallback() {
                        var Qe, rt;
                        super.connectedCallback(), null === (Qe = this._parent) || void 0 === Qe || null === (rt = Qe.oncePSVReady) || void 0 === rt || rt.call(Qe).then(()=>{
                            this._parent.psv.addEventListener("sequence-playing", ()=>this.playing = !0), this._parent.psv.addEventListener("sequence-stopped", ()=>this.playing = !1), this._parent.psv.addEventListener("picture-loaded", this._changeActiveStates.bind(this)), this._parent.addEventListener("pictures-navigation-changed", this._changeActiveStates.bind(this)), this._changeActiveStates();
                        });
                    }
                    _changeActiveStates() {
                        var Qe, rt, Wn, Co, Dl, Ll;
                        "pic" === (null === (Qe = (rt = this._parent.psv).getPicturesNavigation) || void 0 === Qe ? void 0 : Qe.call(rt)) ? (this._activeNext = !1, this._activePlay = !1, this._activePrev = !1) : (this._activePrev = null != (null === (Wn = this._parent.psv.getPictureMetadata()) || void 0 === Wn || null === (Co = Wn.sequence) || void 0 === Co ? void 0 : Co.prevPic), null != (null === (Dl = this._parent.psv.getPictureMetadata()) || void 0 === Dl || null === (Ll = Dl.sequence) || void 0 === Ll ? void 0 : Ll.nextPic) ? (this._activeNext = !0, this._activePlay = !0) : (this._activeNext = !1, this._activePlay = !1));
                        this.requestUpdate();
                    }
                    _onPlayClick() {
                        var Qe, rt, Wn, Co, Dl, Ll;
                        null !== (Qe = this._parent) && void 0 !== Qe && null !== (rt = Qe.psv) && void 0 !== rt && rt.isSequencePlaying() ? (this.playing = !1, null === (Wn = this._parent) || void 0 === Wn || null === (Co = Wn.psv) || void 0 === Co || Co.stopSequence()) : (this.playing = !0, null === (Dl = this._parent) || void 0 === Dl || null === (Ll = Dl.psv) || void 0 === Ll || Ll.playSequence());
                    }
                    render() {
                        var Qe, rt, Wn, Hl, ql, Ql, Kl, $l;
                        return null !== (Qe = this._parent) && void 0 !== Qe && null !== (rt = Qe.psv) && void 0 !== rt && rt.addEventListener ? Co.qy`
			<pnx-button-group
				id="pnx-widget-player"
				dir="row"
				size=${this.size}
				class="pnx-print-hidden"
				style=${this._activePrev || this._activePlay || this._activeNext ? "" : "display: none"}
			>
				<pnx-button
					kind="superflat"
					id="pnx-player-prev"
					title=${null === (Wn = this._parent) || void 0 === Wn ? void 0 : Wn._t.pnx.sequence_prev}
					@click=${()=>{
                            var Qe, rt;
                            return null === (Qe = this._parent) || void 0 === Qe || null === (rt = Qe.psv) || void 0 === rt ? void 0 : rt.goToPrevPicture();
                        }}
					.disabled=${!this._activePrev}
				>${(0, Dl.fa)(Ll.TH)}</pnx-button>

				<pnx-button
					kind="superflat"
					id="pnx-player-play"
					title=${this.playing ? null === (Hl = this._parent) || void 0 === Hl ? void 0 : Hl._t.pnx.sequence_pause : null === (ql = this._parent) || void 0 === ql ? void 0 : ql._t.pnx.sequence_play}
					.disabled=${!this._activePlay}
					@click=${this._onPlayClick.bind(this)}
				>${this.playing ? (0, Dl.fa)(Ul.G1) : (0, Dl.fa)(Rl.ij)}</pnx-button>

				<pnx-button
					kind="superflat"
					id="pnx-player-next"
					title=${null === (Ql = this._parent) || void 0 === Ql ? void 0 : Ql._t.pnx.sequence_next}
					.disabled=${!this._activeNext}
					@click=${()=>{
                            var Qe, rt;
                            return null === (Qe = this._parent) || void 0 === Qe || null === (rt = Qe.psv) || void 0 === rt ? void 0 : rt.goToNextPicture();
                        }}
				>${(0, Dl.fa)(Gl.vF)}</pnx-button>

				${null !== (Kl = this._parent) && void 0 !== Kl && Kl.isWidthSmall() ? Co.s6 : Co.qy`
					<pnx-togglable-group padded="false" ._parent=${this._parent}>
						<pnx-button
							kind="flat"
							id="pnx-player-more"
							title=${null === ($l = this._parent) || void 0 === $l ? void 0 : $l._t.pnx.sequence_more}
							class="pnx-xs-hidden"
							slot="button"
						>${(0, Dl.fa)(Zl.faEllipsisVertical)}</pnx-button>

						<pnx-player-options ._parent=${this._parent}></pnx-player-options>
					</pnx-togglable-group>
				`}
			</pnx-button-group>
		` : Co.s6;
                    }
                }
                Player.properties = {
                    playing: {
                        type: Boolean,
                        reflect: !0
                    },
                    size: {
                        type: String
                    },
                    _activePrev: {
                        state: !0
                    },
                    _activePlay: {
                        state: !0
                    },
                    _activeNext: {
                        state: !0
                    }
                }, customElements.define("pnx-widget-player", Player);
            },
            3023: (Qe, rt, Wn)=>{
                "use strict";
                Wn.d(rt, {
                    A: ()=>Zoom
                });
                var Co = Wn(4542), Dl = Wn(9048), Ll = Wn(8743), Rl = Wn(5995), Ul = Wn(1372), Gl = Wn(7290);
                Wn(1870);
                class Zoom extends Co.WF {
                    createRenderRoot() {
                        return this;
                    }
                    connectedCallback() {
                        var Qe, rt;
                        super.connectedCallback(), null === (Qe = this._parent) || void 0 === Qe || null === (rt = Qe.oncePSVReady) || void 0 === rt || rt.call(Qe).then(()=>{
                            var Qe, rt;
                            return this._lastWantedZoom = (null === (Qe = this._parent) || void 0 === Qe || null === (rt = Qe.psv) || void 0 === rt ? void 0 : rt.getZoomLevel()) || Dl.cS;
                        });
                    }
                    _onClick(Qe, rt) {
                        if (this._parent.map && this._parent.isMapWide()) rt ? this._parent.map.zoomIn({}, {
                            originalEvent: Qe
                        }) : this._parent.map.zoomOut({}, {
                            originalEvent: Qe
                        });
                        else {
                            this._parent.lastPsvAnim && this._parent.lastPsvAnim.cancel();
                            const Qe = rt ? Math.min(100, this._lastWantedZoom + Ll.$) : Math.max(0, this._lastWantedZoom - Ll.$);
                            this._parent.lastPsvAnim = this._parent.psv.animate({
                                speed: Dl.LM,
                                zoom: Qe
                            }), this._lastWantedZoom = Qe;
                        }
                    }
                    render() {
                        var Qe, rt;
                        return Co.qy`
			<pnx-button-group
				id="pnx-widget-zoom"
				dir="column"
				size="xl"
				class="pnx-mobile-hidden pnx-print-hidden"
			>
				<pnx-button
					id="pnx-zoom-in"
					kind="superflat"
					title=${null === (Qe = this._parent) || void 0 === Qe ? void 0 : Qe._t.pnx.zoomIn}
					@click=${(Qe)=>this._onClick(Qe, !0)}
				>${(0, Rl.fa)(Ul.QL)}</pnx-button>

				<pnx-button
					id="pnx-zoom-out"
					kind="superflat"
					title=${null === (rt = this._parent) || void 0 === rt ? void 0 : rt._t.pnx.zoomOut}
					@click=${(Qe)=>this._onClick(Qe, !1)}
				>${(0, Rl.fa)(Gl.EZ)}</pnx-button>
			</pnx-button-group>
		`;
                    }
                }
                Zoom.properties = {
                    _lastWantedZoom: {
                        state: !0
                    }
                }, customElements.define("pnx-widget-zoom", Zoom);
            },
            222: (Qe, rt, Wn)=>{
                "use strict";
                Wn.r(rt), Wn.d(rt, {
                    CopyCoordinates: ()=>Co.A,
                    GeoSearch: ()=>Dl.A,
                    Legend: ()=>Ll.A,
                    MapFiltersButton: ()=>Rl.A,
                    MapLayersButton: ()=>Ul.A,
                    OSMEditors: ()=>Gl.A,
                    PictureLegendActions: ()=>Zl.A,
                    Player: ()=>Hl.A,
                    Zoom: ()=>ql.A
                });
                var Co = Wn(5114), Dl = Wn(2603), Ll = Wn(4385), Rl = Wn(4529), Ul = Wn(1614), Gl = Wn(5789), Zl = Wn(8806), Hl = Wn(8305), ql = Wn(3023);
            },
            5254: (Qe, rt, Wn)=>{
                "use strict";
                Wn.d(rt, {
                    A: ()=>API
                });
                var Co = Wn(8340), Dl = Wn(7343);
                class API extends EventTarget {
                    constructor(Qe){
                        let rt = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                        if (super(), null === Qe || void 0 === Qe || "string" !== typeof Qe) {
                            const Qe = new Error("endpoint parameter is empty or not a valid string");
                            throw this.dispatchEvent(new CustomEvent("broken", {
                                detail: {
                                    error: Qe
                                }
                            })), Qe;
                        }
                        if (Qe.startsWith("/") && (Qe = window.location.href.split("/").slice(0, 3).join("/") + Qe), !API.isValidHttpUrl(Qe)) {
                            const rt = new Error(`endpoint parameter is not a valid URL: ${Qe}`);
                            throw this.dispatchEvent(new CustomEvent("broken", {
                                detail: {
                                    error: rt
                                }
                            })), rt;
                        }
                        this._endpoint = Qe, this._isReady = 0, this._dataBbox = null, this._fetchOpts = (null === rt || void 0 === rt ? void 0 : rt.fetch) || {}, this._metadata = {}, rt.skipReadLanding || (this._readLanding = fetch(Qe, this._getFetchOptions()).then((Qe)=>Qe.json()).then((Qe)=>this._parseLanding(Qe, rt)).catch((Qe)=>(this._isReady = -1, console.error(Qe), this.dispatchEvent(new CustomEvent("broken", {
                                detail: {
                                    error: Qe
                                }
                            })), Promise.reject("Viewer failed to communicate with API"))).then(()=>this._loadMapStyles(rt.style, rt.users)).then(()=>(this._isReady = 1, this.dispatchEvent(new Event("ready")), "API is ready")));
                    }
                    onceReady() {
                        return -1 == this._isReady ? Promise.reject("Viewer failed to communicate with API") : 1 == this._isReady ? Promise.resolve("API is ready") : this._readLanding;
                    }
                    isReady() {
                        return 1 == this._isReady;
                    }
                    getAvailableFeatures() {
                        return Object.entries(this._endpoints).filter((Qe)=>null !== Qe[1]).map((Qe)=>Qe[0]);
                    }
                    getUnavailableFeatures() {
                        return Object.entries(this._endpoints).filter((Qe)=>null === Qe[1]).map((Qe)=>Qe[0]);
                    }
                    _parseLanding(Qe, rt) {
                        var Wn, Co;
                        if (this._endpoints = {
                            collections: null,
                            search: null,
                            style: null,
                            user_style: null,
                            tiles: (null === rt || void 0 === rt ? void 0 : rt.tiles) || null,
                            user_tiles: null,
                            user_search: null,
                            collection_preview: null,
                            item_preview: null,
                            rss: null,
                            report: null
                        }, !Qe || !Qe.links || !Array.isArray(Qe.links)) throw new Error("API Landing page doesn't contain 'links' list");
                        if (!Qe.stac_version.startsWith("1.")) throw new Error(`API is not in a supported STAC version (Panoramax viewer supports only 1.x, API is ${Qe.stac_version})`);
                        this._metadata.name = Qe.title || "Unnamed", this._metadata.stac_version = Qe.stac_version, this._metadata.geovisio_version = Qe.geovisio_version;
                        const Dl = [], Ll = [];
                        if ([
                            {
                                rel: "search",
                                type: "application/geo+json",
                                endpointId: "search",
                                mandatory: !0,
                                missingIssue: "No direct access to pictures metadata."
                            },
                            {
                                rel: "data",
                                type: "application/json",
                                endpointId: "collections",
                                mandatory: !0,
                                missingIssue: "No way for viewer to access sequences."
                            },
                            {
                                rel: "data",
                                type: "application/rss+xml",
                                endpointId: "rss"
                            },
                            {
                                rel: "xyz",
                                type: "application/vnd.mapbox-vector-tile",
                                endpointId: "tiles"
                            },
                            {
                                rel: "xyz-style",
                                type: "application/json",
                                endpointId: "style"
                            },
                            {
                                rel: "user-xyz-style",
                                type: "application/json",
                                endpointId: "user_style"
                            },
                            {
                                rel: "user-xyz",
                                type: "application/vnd.mapbox-vector-tile",
                                endpointId: "user_tiles"
                            },
                            {
                                rel: "user-search",
                                type: "application/json",
                                endpointId: "user_search",
                                missingIssue: "Filter map data by user name will not be available."
                            },
                            {
                                rel: "collection-preview",
                                type: "image/jpeg",
                                endpointId: "collection_preview",
                                missingIssue: "Display of thumbnail could be slower."
                            },
                            {
                                rel: "item-preview",
                                type: "image/jpeg",
                                endpointId: "item_preview",
                                missingIssue: "Display of thumbnail could be slower."
                            },
                            {
                                rel: "report",
                                type: "application/json",
                                endpointId: "report"
                            }
                        ].forEach((rt)=>{
                            const Wn = Qe.links.find((Qe)=>Qe.rel == rt.rel && Qe.type == rt.type);
                            if (Wn) {
                                if (!API.isValidHttpUrl(Wn.href)) throw new Error(`API endpoint '${Wn.rel}' (${Wn.type}) is not a valid URL: ${Wn.href}`);
                                this._endpoints[rt.endpointId] || (this._endpoints[rt.endpointId] = Wn.href);
                            } else if (!this._endpoints[rt.endpointId]) {
                                let Qe = `API doesn't offer a '${rt.rel}' (${rt.type}) endpoint in its links`;
                                rt.missingIssue && (Qe += `\n${rt.missingIssue}`), rt.mandatory ? Dl.push(Qe) : rt.missingIssue && Ll.push(Qe);
                            }
                        }), this._endpoints.style || this._endpoints.tiles || Ll.push("API doesn't offer 'xyz' or 'xyz-style' endpoints in its links.\nMap widget will not be available."), this._endpoints.user_style || this._endpoints.user_tiles || Ll.push("API doesn't offer 'user-xyz' or 'user-xyz-style' endpoints in its links.\nFilter map data by user ID will not be available."), Ll.forEach((Qe)=>console.warn(Qe)), Dl.length > 0) throw new Error(Dl.join("\n"));
                        const Rl = null === Qe || void 0 === Qe || null === (Wn = Qe.extent) || void 0 === Wn || null === (Co = Wn.spatial) || void 0 === Co ? void 0 : Co.bbox;
                        this._dataBbox = Rl && Array.isArray(Rl) && Rl.length > 0 && Array.isArray(Rl[0]) && 4 === Rl[0].length ? [
                            [
                                Rl[0][0],
                                Rl[0][1]
                            ],
                            [
                                Rl[0][2],
                                Rl[0][3]
                            ]
                        ] : null;
                    }
                    _loadMapStyles(Qe, rt) {
                        const Wn = new Set(rt || []);
                        this.mapStyle = {
                            version: 8,
                            sources: {},
                            layers: [],
                            metadata: {}
                        };
                        const Co = [
                            this.getMapStyle()
                        ];
                        if ("string" === typeof Qe) {
                            const rt = Qe.startsWith(this._endpoint) ? this._getFetchOptions() : void 0;
                            Co.push(fetch(Qe, rt).then((Qe)=>Qe.json()));
                        } else "object" === typeof Qe && Co.push(Promise.resolve(Qe));
                        return [
                            ...Wn
                        ].filter((Qe)=>"geovisio" !== Qe).forEach((Qe)=>{
                            Co.push(this.getUserMapStyle(Qe, !0));
                        }), Promise.all(Co).then((Qe)=>{
                            const rt = [
                                "bearing",
                                "center",
                                "glyphs",
                                "light",
                                "name",
                                "pitch",
                                "sky",
                                "sprite",
                                "terrain",
                                "transition",
                                "zoom"
                            ];
                            Qe.forEach((Qe)=>{
                                rt.forEach((rt)=>{
                                    Qe[rt] && (this.mapStyle[rt] = Qe[rt] || this.mapStyle[rt]);
                                }), Object.assign(this.mapStyle.sources, (null === Qe || void 0 === Qe ? void 0 : Qe.sources) || {}), Object.assign(this.mapStyle.metadata, (null === Qe || void 0 === Qe ? void 0 : Qe.metadata) || {}), this.mapStyle.layers = this.mapStyle.layers.concat((null === Qe || void 0 === Qe ? void 0 : Qe.layers) || []);
                            });
                        }).catch((Qe)=>console.error(Qe));
                    }
                    _getFetchOptions() {
                        let Qe = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                        return Object.assign({
                            signal: Qe ? void 0 : AbortSignal.timeout(15e3)
                        }, this._fetchOpts);
                    }
                    _getMapRequestTransform() {
                        const Qe = this._getFetchOptions();
                        if (delete Qe.signal, Object.keys(Qe).length > 0) return (rt)=>{
                            if (rt.startsWith(this._endpoint)) return {
                                url: rt,
                                ...Qe
                            };
                        };
                    }
                    async getSequenceItems(Qe) {
                        let rt = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null, Wn = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
                        if (!this.isReady()) throw new Error("API is not ready to use");
                        try {
                            return API.isIdValid(Qe), fetch(rt || `${this._endpoints.collections}/${Qe}/items`, this._getFetchOptions(!0)).then((Qe)=>Qe.json()).then((rt)=>{
                                let Co = rt;
                                Wn && (Co.features = Wn.features.concat(Co.features));
                                const Dl = rt.links.find((Qe)=>"next" === Qe.rel);
                                return Dl ? this.getSequenceItems(Qe, Dl.href, Co) : Co;
                            });
                        } catch (Co) {
                            return Promise.reject(Co);
                        }
                    }
                    getPicturesAroundCoordinatesUrl(Qe, rt) {
                        let Wn = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 5e-4, Co = arguments.length > 3 ? arguments[3] : void 0, Dl = arguments.length > 4 ? arguments[4] : void 0;
                        if (!this.isReady()) throw new Error("API is not ready to use");
                        if (isNaN(parseFloat(Qe)) || isNaN(parseFloat(rt))) throw new Error("lat and lon parameters should be valid numbers");
                        const Ll = [
                            rt - Wn,
                            Qe - Wn,
                            rt + Wn,
                            Qe + Wn
                        ].map((Qe)=>Qe.toFixed(4)).join(","), Rl = Co ? `&limit=${Co}` : "", Ul = Dl ? `&collections=${Dl}` : "";
                        return `${this._endpoints.search}?bbox=${Ll}${Rl}${Ul}`;
                    }
                    getPicturesAroundCoordinates(Qe, rt, Wn, Co, Dl) {
                        return fetch(this.getPicturesAroundCoordinatesUrl(Qe, rt, Wn, Co, Dl), this._getFetchOptions()).then((Qe)=>Qe.json());
                    }
                    getPictureMetadataUrl(Qe, rt) {
                        if (!this.isReady()) throw new Error("API is not ready to use");
                        if (API.isIdValid(Qe)) return rt ? `${this._endpoints.collections}/${rt}/items/${Qe}` : `${this._endpoints.search}?ids=${Qe}`;
                    }
                    getMapStyle() {
                        if (this.isReady()) return this.mapStyle;
                        let Qe;
                        return Qe = this._endpoints.style ? this._endpoints.style : this._endpoints.tiles ? {
                            version: 8,
                            sources: {
                                geovisio: {
                                    type: "vector",
                                    tiles: [
                                        this._endpoints.tiles
                                    ],
                                    minzoom: 0,
                                    maxzoom: Co.TILES_PICTURES_ZOOM
                                }
                            }
                        } : fetch(`${this._endpoint}/map/14/0/0.mvt`, this._getFetchOptions()).then(()=>(this._endpoints.tiles = `${this._endpoint}/map/{z}/{x}/{y}.mvt`, console.log("Using fallback endpoint for vector tiles"), this.getMapStyle())).catch((Qe)=>(console.error(Qe), Promise.reject(new Error("API doesn't offer a vector tiles endpoint")))), "string" === typeof Qe ? fetch(Qe, this._getFetchOptions()).then((Qe)=>Qe.json()) : Promise.resolve(Qe);
                    }
                    getUserMapStyle(Qe) {
                        let rt;
                        return arguments.length > 1 && void 0 !== arguments[1] && arguments[1] || this.isReady() ? Qe ? (this._endpoints.user_style ? rt = this._endpoints.user_style.replace(/\{userId\}/g, Qe) : this._endpoints.user_tiles && (rt = {
                            version: 8,
                            sources: {
                                [`geovisio_${Qe}`]: {
                                    type: "vector",
                                    tiles: [
                                        this._endpoints.user_tiles.replace(/\{userId\}/g, Qe)
                                    ],
                                    minzoom: 0,
                                    maxzoom: Co.TILES_PICTURES_ZOOM
                                }
                            }
                        }), rt ? "string" === typeof rt ? fetch(rt, this._getFetchOptions()).then((Qe)=>Qe.json()) : Promise.resolve(rt) : Promise.reject(new Error("API doesn't offer map style for specific user"))) : Promise.reject(new Error("Parameter userId is empty")) : Promise.reject(new Error("API is not ready to use"));
                    }
                    findThumbnailInPictureFeature(Qe) {
                        if (!this.isReady()) throw new Error("API is not ready to use");
                        if (!Qe || !Qe.assets) return null;
                        let rt = null;
                        for (let Wn of Object.values(Qe.assets)){
                            if (Wn.roles.includes("thumbnail") && "image/jpeg" == Wn.type && API.isValidHttpUrl(Wn.href)) return Wn.href;
                            Wn.roles.includes("visual") && "image/jpeg" == Wn.type && API.isValidHttpUrl(Wn.href) && (rt = Wn.href);
                        }
                        return rt;
                    }
                    getPictureThumbnailURLForSequence(Qe, rt) {
                        if (!this.isReady()) throw new Error("API is not ready to use");
                        if (this._endpoints.collection_preview) return Promise.resolve(this._endpoints.collection_preview.replace("{id}", Qe));
                        if (rt && Array.isArray(rt.links) && rt.links.length > 0) {
                            let Qe = rt.links.find((Qe)=>"preview" === Qe.rel && "image/jpeg" === Qe.type);
                            if (Qe && API.isValidHttpUrl(Qe.href)) return Promise.resolve(Qe.href);
                        }
                        const Wn = `${this._endpoints.search}?limit=1&collections=${Qe}`;
                        return fetch(Wn, this._getFetchOptions()).then((Qe)=>Qe.json()).then((Qe)=>Array.isArray(Qe.features) && 0 != Qe.features.length ? this.findThumbnailInPictureFeature(Qe.features.pop()) : null);
                    }
                    getPictureThumbnailURL(Qe, rt) {
                        if (!this.isReady()) throw new Error("API is not ready to use");
                        return Qe ? this._endpoints.item_preview ? Promise.resolve(this._endpoints.item_preview.replace("{id}", Qe)) : Qe && rt ? fetch(`${this._endpoints.collections}/${rt}/items/${Qe}`, this._getFetchOptions()).then((Qe)=>Qe.json()).then((Qe)=>Qe ? this.findThumbnailInPictureFeature(Qe) : null) : fetch(`${this._endpoints.search}?ids=${Qe}`, this._getFetchOptions()).then((Qe)=>Qe.json()).then((Qe)=>Qe && Array.isArray(Qe.features) && 0 != Qe.features.length ? this.findThumbnailInPictureFeature(Qe.features.pop()) : null) : Promise.resolve(null);
                    }
                    getRSSURL(Qe) {
                        if (!this.isReady()) throw new Error("API is not ready to use");
                        if (this._endpoints.rss) {
                            let rt = this._endpoints.rss;
                            return Qe && (rt += rt.includes("?") ? "&" : "?", rt += "bbox=" + [
                                Qe.getWest(),
                                Qe.getSouth(),
                                Qe.getEast(),
                                Qe.getNorth()
                            ].join(",")), rt;
                        }
                        return null;
                    }
                    getSequenceMetadataUrl(Qe) {
                        if (!this.isReady()) throw new Error("API is not ready to use");
                        return `${this._endpoints.collections}/${Qe}`;
                    }
                    getDataBbox() {
                        if (!this.isReady()) throw new Error("API is not ready to use");
                        return this._dataBbox;
                    }
                    searchUsers(Qe) {
                        if (!this.isReady()) throw new Error("API is not ready to use");
                        if (!this._endpoints.user_search) throw new Error("User search is not available");
                        return fetch(`${this._endpoints.user_search}?q=${Qe}`, this._getFetchOptions()).then((Qe)=>Qe.json()).then((Qe)=>(null === Qe || void 0 === Qe ? void 0 : Qe.features) || null);
                    }
                    getUserName(Qe) {
                        if (!this.isReady()) throw new Error("API is not ready to use");
                        if (!this._endpoints.user_search) throw new Error("User search is not available");
                        return fetch(this._endpoints.user_search.replace(/\/search$/, `/${Qe}`), this._getFetchOptions()).then((Qe)=>Qe.json()).then((Qe)=>(null === Qe || void 0 === Qe ? void 0 : Qe.name) || null);
                    }
                    sendReport(Qe) {
                        if (!this.isReady()) throw new Error("API is not ready to use");
                        if (!this._endpoints.report) throw new Error("Report sending is not available");
                        const rt = {
                            ...this._getFetchOptions(),
                            method: "POST",
                            body: JSON.stringify(Qe),
                            headers: {
                                "Content-Type": "application/json"
                            }
                        };
                        return fetch(this._endpoints.report, rt).then(async (Qe)=>{
                            if (Qe.status >= 400) {
                                let Wn = await Qe.text();
                                try {
                                    Wn = JSON.parse(Wn).message;
                                } catch (rt) {}
                                return Promise.reject(Wn);
                            }
                            return Qe.json();
                        });
                    }
                    static isValidHttpUrl(Qe) {
                        let rt;
                        try {
                            rt = new URL(Qe);
                        } catch (Wn) {
                            return !1;
                        }
                        return "http:" === rt.protocol || "https:" === rt.protocol;
                    }
                    static isIdValid(Qe) {
                        if ((0, Dl.isNullId)(Qe)) throw new Error("id should be a valid picture unique identifier");
                        return !0;
                    }
                }
            },
            2118: (Qe, rt, Wn)=>{
                "use strict";
                Wn.d(rt, {
                    Ay: ()=>InitParameters,
                    Qm: ()=>Co,
                    Vy: ()=>alterPSVState,
                    ai: ()=>alterPhotoViewerState,
                    iz: ()=>alterViewerState,
                    mK: ()=>alterMapState
                });
                const Co = {
                    minDate: "date_from",
                    maxDate: "date_to",
                    pic_type: "pic_type",
                    camera: "camera",
                    theme: "theme",
                    qualityscore: "pic_score"
                }, Dl = Object.fromEntries(Object.entries(Co).map((Qe)=>[
                        Qe[1],
                        Qe[0]
                    ])), Ll = [
                    "none",
                    "null",
                    "false",
                    !1
                ], Rl = [
                    "antialias",
                    "bearing",
                    "bearingSnap",
                    "bounds",
                    "boxZoom",
                    "clickTolerance",
                    "collectResourceTiming",
                    "cooperativeGestures",
                    "crossSourceCollisions",
                    "doubleClickZoom",
                    "dragPan",
                    "dragRotate",
                    "fadeDuration",
                    "failIfMajorPerformanceCaveat",
                    "fitBoundsOptions",
                    "hash",
                    "interactive",
                    "keyboard",
                    "localIdeographFontFamily",
                    "locale",
                    "logoPosition",
                    "maplibreLogo",
                    "maxBounds",
                    "maxCanvasSize",
                    "maxPitch",
                    "maxTileCacheSize",
                    "maxTileCacheZoomLevels",
                    "maxZoom",
                    "minPitch",
                    "minZoom",
                    "pitch",
                    "pitchWithRotate",
                    "pixelRatio",
                    "preserveDrawingBuffer",
                    "refreshExpiredTiles",
                    "renderWorldCopies",
                    "scrollZoom",
                    "touchPitch",
                    "touchZoomRotate",
                    "trackResize",
                    "transformCameraUpdate",
                    "transformRequest",
                    "validateStyle"
                ];
                class InitParameters {
                    constructor(){
                        var Qe, rt, Wn, Co, Dl, Ul;
                        let Gl = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, Zl = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, Hl = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                        "false" === Gl["url-parameters"] && (Zl = {});
                        let ql = {};
                        "object" === typeof (null === Gl || void 0 === Gl ? void 0 : Gl.psv) && (ql = Gl.psv);
                        let Ql = {};
                        "object" === typeof (null === Gl || void 0 === Gl ? void 0 : Gl.map) && (Ql = Gl.map);
                        let Kl = {};
                        "object" === typeof (null === Hl || void 0 === Hl ? void 0 : Hl.map) && (Kl = Hl.map);
                        let $l = Zl.map && "none" !== Zl.map ? getMapPositionFromString(Zl.map) : null, Tc = !Ll.includes(Zl.map) && !Ll.includes(Gl.map), tu = Zl.focus || Gl.focus, lu = Zl.pic || Gl.picture, du = Zl.users || Gl.users, fu = Zl.speed || (null === (Qe = ql) || void 0 === Qe ? void 0 : Qe.transitionDuration), yu = Zl.nav || (null === (rt = ql) || void 0 === rt ? void 0 : rt.picturesNavigation), Eu = Zl.theme || (null === (Wn = Kl) || void 0 === Wn ? void 0 : Wn.theme) || Ql.theme, Tu = Zl.background || (null === (Co = Kl) || void 0 === Co ? void 0 : Co.background) || Ql.background, Lu = (null === $l || void 0 === $l ? void 0 : $l.center) || (null === (Dl = Kl) || void 0 === Dl ? void 0 : Dl.center) || Ql.center, Zu = (null === $l || void 0 === $l ? void 0 : $l.zoom) || (null === (Ul = Kl) || void 0 === Ul ? void 0 : Ul.zoom) || Ql.zoom, Xu = (null === $l || void 0 === $l ? void 0 : $l.pitch) || Ql.pitch, Ju = (null === $l || void 0 === $l ? void 0 : $l.bearing) || Ql.bearing, $u = Gl.geocoder, ed = Gl.widgets, td = Gl.sequence, id = Gl.fetchOptions, nd = Gl.style, rd = Gl.lang, sd = Gl.endpoint, ad = Ql.raster, od = Ql.attributionControl, ld = (cd = Ql, Object.fromEntries(Object.entries(cd).filter((Qe)=>{
                            let [rt] = Qe;
                            return Rl.includes(rt);
                        })));
                        var cd;
                        let ud = Zl.xyz, hd = Zl.date_from, dd = Zl.date_to, pd = Zl.pic_type, md = Zl.camera, fd = Zl.pic_score;
                        [
                            "map",
                            "pic"
                        ].includes(tu) ? "map" !== tu || Tc || (console.warn("Parameter focus can't be 'map' as map is disabled"), tu = "pic") : (console.warn("Invalid value for parameter focus:", tu), tu = Tc && !lu ? "map" : "pic"), "aerial" != Tu || ad || (console.warn("Parameter background can't be 'aerial' as no aerial imagery is available"), Tu = "streets"), Tc && !lu && (tu = "map"), this._parentInit = {
                            map: Tc,
                            users: du,
                            fetchOptions: id,
                            style: nd,
                            lang: rd,
                            endpoint: sd
                        }, this._parentPostInit = {
                            focus: tu,
                            picture: lu,
                            sequence: td,
                            geocoder: $u,
                            widgets: ed,
                            forceFocus: !0
                        }, this._psvInit = Object.fromEntries(Object.entries(ql).filter((Qe)=>{
                            let [rt] = Qe;
                            return ![
                                "transitionDuration",
                                "picturesNavigation"
                            ].includes(rt);
                        })), this._psvAny = {
                            transitionDuration: fu,
                            picturesNavigation: yu
                        }, this._psvPostInit = {
                            xyz: ud
                        }, this._mapInit = {
                            raster: ad,
                            attributionControl: od,
                            ...ld
                        }, this._mapAny = {
                            theme: Eu,
                            background: Tu,
                            center: Lu,
                            zoom: Zu,
                            pitch: Xu,
                            bearing: Ju,
                            users: du
                        }, this._mapPostInit = {
                            date_from: hd,
                            date_to: dd,
                            pic_type: pd,
                            camera: md,
                            pic_score: fd
                        };
                    }
                    _sanitize(Qe) {
                        return Object.fromEntries(Object.entries(Qe).filter((Qe)=>{
                            let [, rt] = Qe;
                            return void 0 !== rt;
                        }));
                    }
                    getParentInit() {
                        return this._sanitize(this._parentInit);
                    }
                    getParentPostInit() {
                        return this._sanitize(this._parentPostInit);
                    }
                    getPSVInit() {
                        return this._sanitize(Object.assign({}, this._psvInit, this._psvAny));
                    }
                    getPSVPostInit() {
                        return this._sanitize(Object.assign({}, this._psvPostInit, this._psvAny));
                    }
                    getMapInit() {
                        return this._sanitize(Object.assign({}, this._mapInit, this._mapAny));
                    }
                    getMapPostInit() {
                        return this._sanitize(Object.assign({}, this._mapPostInit, this._mapAny));
                    }
                    static GetComponentProperties(Qe, rt) {
                        const Wn = {};
                        for(let Co in Qe.properties)Qe.properties[Co].state || null == rt[Co] || (Wn[Co] = rt[Co]);
                        return Wn;
                    }
                }
                function getMapPositionFromString(Qe, rt) {
                    const Wn = (Qe || "").split("/");
                    if (Wn.length >= 3 && !Wn.some((Qe)=>isNaN(Qe))) {
                        const Qe = {
                            center: [
                                +Wn[2],
                                +Wn[1]
                            ],
                            zoom: +Wn[0],
                            pitch: +(Wn[4] || 0)
                        };
                        return rt && (Qe.bearing = rt.dragRotate.isEnabled() && rt.touchZoomRotate.isEnabled() ? +(Wn[3] || 0) : rt.getBearing()), Qe;
                    }
                    return null;
                }
                function alterPSVState(Qe, rt) {
                    rt.xyz && Qe.addEventListener("picture-loaded", ()=>{
                        const Wn = function(Qe) {
                            const rt = (Qe || "").split("/");
                            return 3 !== rt.length || rt.some((Qe)=>isNaN(Qe)) ? null : {
                                x: +rt[0],
                                y: +rt[1],
                                z: +rt[2]
                            };
                        }(rt.xyz);
                        Qe.setXYZ(Wn.x, Wn.y, Wn.z);
                    }, {
                        once: !0
                    });
                    let Wn = rt.transitionDuration || rt.speed;
                    void 0 !== Wn && Qe.setTransitionDuration(Wn);
                    let Co = rt.picturesNavigation || rt.nav;
                    [
                        "none",
                        "pic",
                        "any",
                        "seq"
                    ].includes(Co) && Qe.setPicturesNavigation(Co);
                }
                async function alterMapState(Qe, rt) {
                    var Wn;
                    const Co = getMapPositionFromString(rt.map, Qe);
                    Co && Qe.jumpTo(Co);
                    let Ll = Array.isArray(rt.users) ? rt.users : (rt.users || "").split(",");
                    (0 === Ll.length || 1 === Ll.length && "" === Ll[0].trim()) && (Ll = [
                        "geovisio"
                    ]), await Qe.setVisibleUsers(Ll), null === (Wn = Qe.setFilters) || void 0 === Wn || Wn.call(Qe, function(Qe) {
                        const rt = {};
                        for(let Wn in Dl)Qe[Wn] && (rt[Dl[Wn]] = Qe[Wn]);
                        if (rt.qualityscore) {
                            let Qe = rt.qualityscore.split("");
                            const Wn = {
                                A: 5,
                                B: 4,
                                C: 3,
                                D: 2,
                                E: 1
                            };
                            rt.qualityscore = Qe.map((Qe)=>Wn[Qe]);
                        }
                        return rt;
                    }(rt)), [
                        "aerial",
                        "streets"
                    ].includes(rt.background) && Qe.setBackground(rt.background);
                }
                function alterPhotoViewerState(Qe, rt) {
                    let Wn = rt.picture || rt.pic;
                    if (Wn) {
                        const rt = Wn.split(";");
                        rt.length > 1 && console.warn("Multiple picture IDs passed in URL, only first one kept"), Qe.select(null, rt[0], !0);
                    } else Qe.select();
                }
                function alterViewerState(Qe, rt) {
                    alterPhotoViewerState(Qe, rt), "map" === rt.focus && null !== Qe && void 0 !== Qe && Qe.map ? (Qe.setPopup(!1), Qe._setFocus("map", null, rt.forceFocus)) : "pic" === rt.focus && null !== Qe && void 0 !== Qe && Qe.mini ? (Qe.setPopup(!1), Qe._setFocus("pic", null, rt.forceFocus)) : rt.focus && "meta" === rt.focus && null !== Qe && void 0 !== Qe && Qe.mini && Qe._setFocus("pic", null, rt.forceFocus);
                }
            },
            3727: (Qe, rt, Wn)=>{
                "use strict";
                Wn.d(rt, {
                    A: ()=>PhotoAdapter
                });
                var Co = Wn(3890);
                class PhotoAdapter extends Co.D {
                    constructor(Qe, rt){
                        super(Qe, rt), this._shouldGoFast = rt.shouldGoFast || (()=>!0);
                    }
                    loadTexture(Qe, rt) {
                        return Qe.origBaseUrl ? Qe.baseUrl = Qe.origBaseUrl : Qe.origBaseUrl = Qe.baseUrl, this._shouldGoFast() && Qe.thumbUrl && !Qe.hdLoaded && 1 == Qe.rows && (Qe.baseUrl = Qe.thumbUrl), super.loadTexture(Qe, rt).then((rt)=>(Qe.baseUrl === Qe.origBaseUrl && (Qe.hdLoaded = !0), rt));
                    }
                    __loadTiles(Qe) {
                        this._shouldGoFast() || super.__loadTiles(Qe);
                    }
                }
            },
            4207: (Qe, rt, Wn)=>{
                "use strict";
                Wn.d(rt, {
                    A: ()=>PresetManager
                });
                var Co = Wn(7208);
                const Dl = {
                    fas: "fa6-solid"
                }, Ll = {
                    "fa6-solid:directions": "fa6-solid:diamond-turn-right"
                };
                class PresetManager {
                    constructor(){
                        let Qe = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null, rt = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                        this._ready = !1, this._presets = null, this._translations = {}, rt || this._load(Qe);
                    }
                    async _load(Qe) {
                        var rt;
                        Qe = Qe || (null === (rt = window.navigator.languages[0]) || void 0 === rt ? void 0 : rt.substring(0, 2));
                        try {
                            var Wn, Rl;
                            const [rt, Zl, Hl] = await Promise.all([
                                fetch(`${(0, Co.PanoramaxPresetsURL)()}/translations/en.min.json`),
                                Qe ? fetch(`${(0, Co.PanoramaxPresetsURL)()}/translations/${Qe}.min.json`) : Promise.resolve({
                                    ok: !0
                                }),
                                fetch(`${(0, Co.PanoramaxPresetsURL)()}/presets.min.json`)
                            ]);
                            if (!rt || !Zl || !Hl || !rt.ok || !Zl.ok || !Hl.ok) throw this._ready = -1, new Error("Presets service is not available");
                            var Ul, Gl;
                            if (this._presets = await Hl.json(), this._translations.en = null === (Wn = await rt.json()) || void 0 === Wn || null === (Rl = Wn.en) || void 0 === Rl ? void 0 : Rl.presets, Qe) this._translations[Qe] = null === (Ul = await Zl.json()) || void 0 === Ul || null === (Gl = Ul[Qe]) || void 0 === Gl ? void 0 : Gl.presets;
                            Object.entries(this._presets).forEach((rt)=>{
                                var Wn, Co, Rl, Ul, Gl, Zl;
                                let [Hl, ql] = rt;
                                if (null !== (Wn = this._translations[Qe]) && void 0 !== Wn && null !== (Co = Wn.presets) && void 0 !== Co && null !== (Rl = Co[Hl]) && void 0 !== Rl && Rl.name ? ql.name = this._translations[Qe].presets[Hl].name : null !== (Ul = this._translations.en) && void 0 !== Ul && null !== (Gl = Ul.presets) && void 0 !== Gl && null !== (Zl = Gl[Hl]) && void 0 !== Zl && Zl.name && (ql.name = this._translations.en.presets[Hl].name), ql.icon) {
                                    const Qe = ql.icon.split("-")[0], rt = Dl[Qe];
                                    ql.iconify = rt ? ql.icon.replace(Qe + "-", rt + ":") : ql.icon.split("-")[0] + ":" + ql.icon.split("-").slice(1).join("-"), Ll[ql.iconify] && (ql.iconify = Ll[ql.iconify]);
                                }
                            }), this._ready = !0;
                        } catch (Zl) {
                            console.error("Presets service throws an error:", Zl), this._ready = -1;
                        }
                    }
                    async onceReady() {
                        return this._ready ? -1 === this._ready ? Promise.reject() : Promise.resolve() : (await new Promise((Qe)=>setTimeout(Qe, 250)), this.onceReady());
                    }
                    async getPreset(Qe) {
                        return this.onceReady().then(()=>{
                            const rt = Object.values(this._presets).filter((rt)=>{
                                if (0 === Object.keys(rt.tags).length) return !1;
                                for(let Wn in rt.tags){
                                    const Co = rt.tags[Wn];
                                    if (!Qe.semantics.find((Qe)=>Qe.key === Wn && ("*" === Co || Co === Qe.value))) return !1;
                                }
                                return !0;
                            });
                            return rt.sort((Qe, rt)=>{
                                const Wn = Object.keys(Qe.tags).length, Co = Object.keys(rt.tags).length;
                                if (Wn > Co) return -1;
                                if (Wn === Co) {
                                    const Wn = Object.values(Qe.tags).filter((Qe)=>"*" === Qe).length, Co = Object.values(rt.tags).filter((Qe)=>"*" === Qe).length;
                                    return Wn < Co ? -1 : Wn > Co ? 1 : 0;
                                }
                                return 1;
                            }), rt.shift();
                        });
                    }
                }
            },
            4451: (Qe, rt, Wn)=>{
                "use strict";
                Wn.d(rt, {
                    A: ()=>URLHandler
                });
                var Co = Wn(2118);
                const Dl = [
                    "speed",
                    "nav",
                    "focus",
                    "pic",
                    "xyz",
                    "map",
                    "background",
                    "users",
                    "pic_score",
                    "s"
                ].concat(Object.values(Co.Qm)), Ll = [
                    "focus-changed",
                    "pictures-navigation-changed"
                ], Rl = [
                    "position-updated",
                    "zoom-updated",
                    "view-rotated",
                    "picture-loaded",
                    "transition-duration-changed"
                ], Ul = [
                    "moveend",
                    "zoomend",
                    "boxzoomend",
                    "background-changed",
                    "users-changed",
                    "filters-changed"
                ];
                class URLHandler extends EventTarget {
                    constructor(Qe){
                        super(), this._parent = Qe, this._delay = null;
                    }
                    listenToChanges() {
                        window.addEventListener("popstate", this._onURLChange.bind(this), !1), Ll.forEach((Qe)=>this._parent.addEventListener(Qe, this._onParentChange.bind(this))), Rl.forEach((Qe)=>this._parent.psv.addEventListener(Qe, this._onParentChange.bind(this))), this._parent.map && Ul.forEach((Qe)=>this._parent.map.on(Qe, this._onParentChange.bind(this)));
                    }
                    nextURLParams() {
                        let Qe = {};
                        "number" == typeof this._parent.psv.getTransitionDuration() && (Qe.speed = this._parent.psv.getTransitionDuration()), [
                            null,
                            "any"
                        ].includes(this._parent.psv.getPicturesNavigation()) || (Qe.nav = this._parent.psv.getPicturesNavigation()), this._parent.psv.getPictureId() && (Qe.pic = this._parent.psv.getPictureId());
                        if (this._parent.psv.getPictureMetadata() && (Qe.xyz = this.currentPSVString()), this._parent.map) {
                            Qe.map = this.currentMapString(), Qe.focus = "pic", this._parent.isMapWide() && (Qe.focus = "map"), this._parent.map.hasTwoBackgrounds() && this._parent.map.getBackground() && (Qe.background = this._parent.map.getBackground());
                            const rt = this._parent.map.getVisibleUsers();
                            if ((rt.length > 1 || !rt.includes("geovisio")) && (Qe.users = rt.join(",")), this._parent.map._mapFilters) {
                                for(let rt in Co.Qm)this._parent.map._mapFilters[rt] && (Qe[Co.Qm[rt]] = this._parent.map._mapFilters[rt]);
                                if (Qe.pic_score) {
                                    const rt = [
                                        null,
                                        "E",
                                        "D",
                                        "C",
                                        "B",
                                        "A"
                                    ];
                                    Qe.pic_score = Qe.pic_score.map((Qe)=>rt[Qe]).join("");
                                }
                            }
                        }
                        return Qe;
                    }
                    nextURLString() {
                        let Qe = "";
                        return Object.entries(this.nextURLParams()).sort((Qe, rt)=>Qe[0].localeCompare(rt[0])).forEach((rt)=>{
                            let [Wn, Co] = rt, Dl = !1;
                            const Ll = Qe.split("&").map((Qe)=>{
                                const rt = Qe.split("=")[0];
                                return rt === Wn ? (Dl = !0, `${rt}=${Co}`) : Qe;
                            }).filter((Qe)=>Qe);
                            Dl || Ll.push(`${Wn}=${Co}`), Qe = `${Ll.join("&")}`;
                        }), `?${Qe}`.replace(/^\?+/, "?");
                    }
                    currentURLParams() {
                        const Qe = (arguments.length > 0 && void 0 !== arguments[0] && arguments[0] ? window.location.hash : window.location.search).replace(/^[?#]/, "");
                        let rt = {};
                        if (Qe.split("&").map((Qe)=>Qe.split("=")).filter((Qe)=>void 0 !== Qe[0] && Qe[0].length > 0 && Dl.includes(Qe[0])).forEach((Qe)=>{
                            rt[Qe[0]] = Qe[1];
                        }), rt.s) {
                            const Qe = Object.fromEntries(decodeURIComponent(rt.s).split(";").map((Qe)=>[
                                    Qe[0],
                                    Qe.substring(1)
                                ]));
                            rt = {}, "m" === Qe.f ? rt.focus = "map" : "p" === Qe.f ? rt.focus = "pic" : "t" === Qe.f && (rt.focus = "meta"), "" !== Qe.s && (rt.speed = 100 * parseFloat(Qe.s)), "a" === Qe.n ? rt.nav = "any" : "s" === Qe.n && (rt.nav = "seq"), "n" === Qe.n && (rt.nav = "none"), "" !== Qe.p && (rt.pic = Qe.p), "" !== Qe.c && (rt.xyz = Qe.c), "" !== Qe.m && (rt.map = Qe.m), "" !== Qe.d && (rt.date_from = Qe.d), "" !== Qe.e && (rt.date_to = Qe.e), "f" === Qe.t ? rt.pic_type = "flat" : "e" === Qe.t && (rt.pic_type = "equirectangular"), "" !== Qe.k && (rt.camera = Qe.k), "d" === Qe.v ? rt.theme = "default" : "a" === Qe.v ? rt.theme = "age" : "t" === Qe.v ? rt.theme = "type" : "s" === Qe.v && (rt.theme = "score"), "s" === Qe.b ? rt.background = "streets" : "a" === Qe.b && (rt.background = "aerial"), "" !== Qe.u && (rt.users = Qe.u), "" !== Qe.q && (rt.pic_score = Qe.q);
                        }
                        return rt;
                    }
                    currentMapString() {
                        const Qe = this._parent.map.getCenter(), rt = Math.round(100 * this._parent.map.getZoom()) / 100, Wn = Math.ceil((rt * Math.LN2 + Math.log(512 / 360 / .5)) / Math.LN10), Co = Math.pow(10, Wn), Dl = Math.round(Qe.lng * Co) / Co, Ll = Math.round(Qe.lat * Co) / Co, Rl = this._parent.map.getBearing(), Ul = this._parent.map.getPitch();
                        let Gl = `${rt}/${Ll}/${Dl}`;
                        return (Rl || Ul) && (Gl += "/" + Math.round(10 * Rl) / 10), Ul && (Gl += `/${Math.round(Ul)}`), Gl;
                    }
                    currentPSVString() {
                        const Qe = this._parent.psv.getXYZ();
                        return `${Qe.x.toFixed(2)}/${Qe.y.toFixed(2)}/${Math.round(Qe.z || 0)}`;
                    }
                    _onURLChange() {
                        let Qe = this.currentURLParams();
                        "Viewer" === this._parent.getClassName() ? (0, Co.iz)(this._parent, Qe) : (0, Co.ai)(this._parent, Qe), (0, Co.Vy)(this._parent.psv, Qe), this._parent.map && (0, Co.mK)(this._parent.map, Qe);
                    }
                    nextShortLink(Qe) {
                        const rt = new URL(Qe), Wn = this.nextURLParams(), Co = {
                            f: (Wn.focus || "").substring(0, 1),
                            s: isNaN(parseInt(Wn.speed)) ? void 0 : Math.floor(parseInt(Wn.speed) / 100),
                            n: (Wn.nav || "").substring(0, 1),
                            p: Wn.pic,
                            c: Wn.xyz,
                            m: Wn.map,
                            d: Wn.date_from,
                            e: Wn.date_to,
                            t: (Wn.pic_type || "").substring(0, 1),
                            k: Wn.camera,
                            v: (Wn.theme || "").substring(0, 1),
                            b: (Wn.background || "").substring(0, 1),
                            u: Wn.users,
                            q: Wn.pic_score
                        }, Dl = Object.entries(Co).filter((Qe)=>{
                            let [, rt] = Qe;
                            return void 0 != rt && "" != rt;
                        }).map((Qe)=>{
                            let [rt, Wn] = Qe;
                            return `${rt}${Wn}`;
                        }).join(";");
                        return rt.search = `s=${Dl}`, rt;
                    }
                    getUnmanagedParameters(Qe) {
                        return new URLSearchParams(Array.from(Qe.searchParams).filter((Qe)=>{
                            let [rt] = Qe;
                            return !Dl.includes(rt);
                        })).toString();
                    }
                    _onParentChange() {
                        this._delay && (clearTimeout(this._delay), this._delay = null), this._delay = setTimeout(()=>{
                            var Qe, rt, Wn;
                            const Co = new URL(window.location.href), Dl = new URL(window.location.href), Ll = this.getUnmanagedParameters(Co);
                            if (Dl.search = this._parent ? this.nextURLString() + (Ll.length > 0 ? "&" + Ll : "") : "", Object.keys(this.currentURLParams(!0)).length > 0 && (Dl.hash = ""), Co.search == Dl.search) return;
                            const Rl = this.currentURLParams().pic || "", Ul = (null === (Qe = this._parent) || void 0 === Qe || null === (rt = Qe.psv) || void 0 === rt || null === (Wn = rt.getPictureId) || void 0 === Wn ? void 0 : Wn.call(rt)) || "";
                            try {
                                if (Rl != Ul ? window.history.pushState(window.history.state, null, Dl.href) : window.history.replaceState(window.history.state, null, Dl.href), this._parent) {
                                    const Qe = new CustomEvent("url-changed", {
                                        detail: {
                                            url: Dl.href
                                        }
                                    });
                                    this.dispatchEvent(Qe);
                                }
                            } catch (Gl) {}
                        }, 500);
                    }
                }
            },
            3606: (Qe, rt, Wn)=>{
                "use strict";
                Wn.r(rt), Wn.d(rt, {
                    forwardGeocodingBAN: ()=>forwardGeocodingBAN,
                    forwardGeocodingNominatim: ()=>forwardGeocodingNominatim,
                    forwardGeocodingStandard: ()=>forwardGeocodingStandard,
                    reverseGeocodingNominatim: ()=>reverseGeocodingNominatim
                });
                var Co = Wn(927), Dl = Wn.n(Co), Ll = Wn(7208);
                const Rl = {
                    house: 20,
                    housenumber: 20,
                    street: 18,
                    locality: 15,
                    district: 13,
                    municipality: 12,
                    city: 12,
                    county: 8,
                    region: 7,
                    state: 7,
                    country: 5
                };
                function geocoderParamsToURLString(Qe) {
                    let rt = {};
                    return Object.entries(Qe).filter((Qe)=>void 0 !== Qe[1] && null !== Qe[1]).forEach((Qe)=>rt[Qe[0]] = Qe[1]), new URLSearchParams(rt).toString();
                }
                function forwardGeocodingNominatim(Qe) {
                    const rt = {
                        q: Qe.query,
                        countrycodes: Qe.countries,
                        limit: Qe.limit,
                        viewbox: Qe.bbox
                    };
                    return fetch(`${(0, Ll.NominatimBaseUrl)()}/search?${geocoderParamsToURLString(rt)}&format=geocodejson&addressdetails=1`).then((Qe)=>Qe.json()).then((Qe)=>{
                        const rt = {
                            features: []
                        }, Wn = [];
                        return (Qe.features || []).forEach((Qe)=>{
                            var Co, Ll, Ul;
                            const Gl = geocodeJsonToPlaceName(null === (Co = Qe.properties) || void 0 === Co ? void 0 : Co.geocoding) || (null === (Ll = Qe.properties) || void 0 === Ll || null === (Ul = Ll.geocoding) || void 0 === Ul ? void 0 : Ul.label);
                            var Zl, Hl;
                            Wn.includes(Gl) || (rt.features.push({
                                place_type: [
                                    "place"
                                ],
                                place_name: Gl,
                                center: new (Dl()).LngLat(...Qe.geometry.coordinates),
                                zoom: Rl[null === (Zl = Qe.properties) || void 0 === Zl || null === (Hl = Zl.geocoding) || void 0 === Hl ? void 0 : Hl.type]
                            }), Wn.push(Gl));
                        }), rt;
                    });
                }
                function reverseGeocodingNominatim(Qe, rt) {
                    return fetch(`${(0, Ll.NominatimBaseUrl)()}/reverse?lat=${Qe}&lon=${rt}&zoom=18&format=geocodejson`).then((Qe)=>Qe.json()).then((Qe)=>{
                        var rt, Wn, Co;
                        return geocodeJsonToPlaceName(null === Qe || void 0 === Qe || null === (rt = Qe.features) || void 0 === rt || null === (Wn = rt.shift()) || void 0 === Wn || null === (Co = Wn.properties) || void 0 === Co ? void 0 : Co.geocoding);
                    });
                }
                function forwardGeocodingBAN(Qe) {
                    return forwardGeocodingStandard(Qe, (0, Ll.AdresseDataGouvBaseURL)());
                }
                function geocodeJsonToPlaceName(Qe) {
                    if (!Qe || "object" != typeof Qe) return "";
                    let rt = Qe.name, Wn = [], Co = [];
                    switch(Qe.type){
                        case "hamlet":
                        case "croft":
                        case "isolated_dwelling":
                        case "neighbourhood":
                        case "allotments":
                        case "quarter":
                        case "farm":
                        case "farmyard":
                        case "industrial":
                        case "commercial":
                        case "retail":
                        case "city_block":
                        case "residential":
                        case "locality":
                        case "district":
                            Co.push(Qe.city), Co.push(Qe.county), Co.push(Qe.state), Co.push(Qe.country);
                            break;
                        case "city":
                        case "region":
                            Co.push(Qe.county), Co.push(Qe.state), Co.push(Qe.country);
                            break;
                        case "country":
                            break;
                        case "house":
                        case "housenumber":
                            Wn.push(Qe.housenumber), Wn.push(Qe.street), Wn.push(Qe.locality), Wn.push(Qe.district), Co.push(Qe.city), Co.push(Qe.county), Co.push(Qe.state), Co.push(Qe.country);
                            break;
                        default:
                            Wn.push(Qe.street), Wn.push(Qe.locality), Wn.push(Qe.district), Co.push(Qe.city), Co.push(Qe.county), Co.push(Qe.state), Co.push(Qe.country);
                    }
                    return Wn = Wn.filter((Qe)=>Qe), Wn = Wn.filter((Qe, Co)=>Qe != rt && (0 === Co || Wn[Co - 1] !== Qe)), Wn = Wn.length > 0 ? Qe.housenumber ? Wn.slice(0, 2).join(" ") : Wn.shift() : null, Wn === rt && (Wn = null), Co = Co.filter((Qe)=>Qe), Co = Co.filter((Qe, Dl)=>Qe != rt && (!Wn || !Wn.includes(Qe)) && (0 === Dl || Co[Dl - 1] !== Qe)), [
                        rt,
                        Wn,
                        Co.shift()
                    ].filter((Qe)=>Qe).join(", ");
                }
                function forwardGeocodingStandard(Qe, rt) {
                    const Wn = {
                        q: Qe.query,
                        limit: Qe.limit
                    };
                    if ("string" === typeof Qe.proximity) {
                        const [rt, Co] = Qe.proximity.split(",").map((Qe)=>parseFloat(Qe.trim()));
                        Wn.lat = rt, Wn.lon = Co;
                    }
                    return fetch(`${rt}/?${geocoderParamsToURLString(Wn)}`).then((Qe)=>Qe.json()).then((Qe)=>{
                        const rt = {
                            features: []
                        }, Wn = [];
                        return (Qe.features || []).forEach((Qe)=>{
                            const Co = geocodeJsonToPlaceName(Qe.properties);
                            Wn.includes(Co) || "other" == Qe.properties.type || (rt.features.push({
                                place_type: [
                                    "place"
                                ],
                                place_name: Co,
                                center: new (Dl()).LngLat(...Qe.geometry.coordinates),
                                zoom: Rl[Qe.properties.type]
                            }), Wn.push(Co));
                        }), rt;
                    });
                }
            },
            4964: (Qe, rt, Wn)=>{
                "use strict";
                Wn.r(rt), Wn.d(rt, {
                    autoDetectLocale: ()=>autoDetectLocale,
                    getTranslations: ()=>getTranslations
                });
                var Co = Wn(4149), Dl = Wn(369), Ll = Wn(389), Rl = Wn(9946), Ul = Wn(8302), Gl = Wn(5222), Zl = Wn(6909), Hl = Wn(4895), ql = Wn(3979), Ql = Wn(6920), Kl = Wn(9026), $l = Wn(991), Tc = Wn(6984);
                const tu = "en", lu = {
                    da: Co,
                    de: Dl,
                    eo: Rl,
                    en: Ll,
                    es: Ul,
                    fr: Gl,
                    hu: Zl,
                    it: Hl,
                    ja: ql,
                    nl: Ql,
                    pl: Kl,
                    sv: $l,
                    "zh-Hant": Tc,
                    zh: Tc
                };
                function autoDetectLocale(Qe, rt) {
                    for (const Wn of window.navigator.languages){
                        let rt = Wn;
                        switch(rt){
                            case "zh-TW":
                            case "zh-HK":
                            case "zh-MO":
                                rt = "zh-Hant";
                                break;
                            case "zh-CN":
                            case "zh-SG":
                                rt = "zh-Hans";
                                break;
                            default:
                                rt.length > 2 && (rt = Wn.substring(0, 2));
                        }
                        const Co = Qe.find((Qe)=>Qe === rt);
                        if (Co) return Co;
                    }
                    return rt;
                }
                function getTranslations() {
                    let Qe = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
                    const rt = JSON.parse(JSON.stringify(Ll));
                    let Wn;
                    if (Qe || (Qe = autoDetectLocale(Object.keys(lu), tu)), lu[Qe] && "en" !== Qe && (Wn = lu[Qe]), Qe.length > 2) {
                        const rt = Qe.substring(0, 2);
                        lu[rt] && (Wn = lu[rt]);
                    }
                    return Wn && Object.entries(Wn).forEach((Qe)=>{
                        let [Wn, Co] = Qe;
                        Object.entries(Co).forEach((Qe)=>{
                            let [Co, Dl] = Qe;
                            Array.isArray(Dl) && (Dl = Dl.filter((Qe)=>null != Qe)), rt[Wn][Co] = Dl;
                        });
                    }), rt;
                }
            },
            2030: (Qe, rt, Wn)=>{
                "use strict";
                Wn.r(rt), Wn.d(rt, {
                    API: ()=>ql.A,
                    PhotoAdapter: ()=>Ql.A,
                    PresetsManager: ()=>Kl.A,
                    URLHandler: ()=>$l.A,
                    geocoder: ()=>Co,
                    i18n: ()=>Dl,
                    map: ()=>Ll,
                    picture: ()=>Rl,
                    semantics: ()=>Ul,
                    services: ()=>Gl,
                    utils: ()=>Zl,
                    widgets: ()=>Hl
                });
                var Co = Wn(3606), Dl = Wn(4964), Ll = Wn(8340), Rl = Wn(508), Ul = Wn(2283), Gl = Wn(7208), Zl = Wn(7343), Hl = Wn(5995), ql = Wn(5254), Ql = Wn(3727), Kl = Wn(4207), $l = Wn(4451);
            },
            8340: (Qe, rt, Wn)=>{
                "use strict";
                Wn.r(rt), Wn.d(rt, {
                    DEFAULT_TILES: ()=>Rl,
                    MAP_EXPR_QUALITYSCORE: ()=>Kl,
                    RASTER_LAYER_ID: ()=>Ul,
                    TILES_PICTURES_SYMBOL_ZOOM: ()=>Zl,
                    TILES_PICTURES_ZOOM: ()=>Gl,
                    VECTOR_STYLES: ()=>Hl,
                    combineStyles: ()=>combineStyles,
                    getMapParamsFromLocalStorage: ()=>getMapParamsFromLocalStorage,
                    getMissingLayerStyles: ()=>getMissingLayerStyles,
                    getThumbGif: ()=>getThumbGif,
                    getUserLayerId: ()=>getUserLayerId,
                    getUserSourceId: ()=>getUserSourceId,
                    initMapKeyboardHandler: ()=>initMapKeyboardHandler,
                    isLabelLayer: ()=>isLabelLayer,
                    linkMapAndPhoto: ()=>linkMapAndPhoto,
                    saveMapParamsToLocalStorage: ()=>saveMapParamsToLocalStorage,
                    switchCoefValue: ()=>switchCoefValue
                });
                var Co = Wn(6883), Dl = Wn(7343), Ll = Wn(4964);
                const Rl = "https://panoramax.openstreetmap.fr/pmtiles/basic.json", Ul = "pnx-aerial", Gl = 15, Zl = 18, Hl = {
                    PICTURES: {
                        paint: {
                            "circle-radius": [
                                "interpolate",
                                [
                                    "linear"
                                ],
                                [
                                    "zoom"
                                ],
                                Gl,
                                4.5,
                                Zl,
                                6,
                                24,
                                12
                            ],
                            "circle-opacity": [
                                "interpolate",
                                [
                                    "linear"
                                ],
                                [
                                    "zoom"
                                ],
                                Gl,
                                0,
                                Gl + 1,
                                1
                            ],
                            "circle-stroke-color": "#ffffff",
                            "circle-stroke-width": [
                                "interpolate",
                                [
                                    "linear"
                                ],
                                [
                                    "zoom"
                                ],
                                Gl + 1,
                                0,
                                Gl + 2,
                                1,
                                Zl,
                                1.5,
                                24,
                                3
                            ]
                        },
                        layout: {}
                    },
                    PICTURES_SYMBOLS: {
                        paint: {
                            "icon-opacity": [
                                "interpolate",
                                [
                                    "linear"
                                ],
                                [
                                    "zoom"
                                ],
                                Zl,
                                0,
                                Zl + 1,
                                1
                            ]
                        },
                        layout: {
                            "icon-image": [
                                "case",
                                [
                                    "==",
                                    [
                                        "get",
                                        "type"
                                    ],
                                    "equirectangular"
                                ],
                                "pnx-arrow-360",
                                "pnx-arrow-flat"
                            ],
                            "icon-size": [
                                "interpolate",
                                [
                                    "linear"
                                ],
                                [
                                    "zoom"
                                ],
                                Zl,
                                .5,
                                24,
                                1
                            ],
                            "icon-rotate": [
                                "to-number",
                                [
                                    "get",
                                    "heading"
                                ]
                            ],
                            "icon-allow-overlap": !0
                        }
                    },
                    SEQUENCES: {
                        paint: {
                            "line-width": [
                                "interpolate",
                                [
                                    "linear"
                                ],
                                [
                                    "zoom"
                                ],
                                0,
                                .5,
                                10,
                                2,
                                14,
                                4,
                                16,
                                5,
                                22,
                                3
                            ]
                        },
                        layout: {
                            "line-cap": "square"
                        }
                    },
                    SEQUENCES_PLUS: {
                        paint: {
                            "line-width": [
                                "interpolate",
                                [
                                    "linear"
                                ],
                                [
                                    "zoom"
                                ],
                                0,
                                15,
                                Gl + 1,
                                30,
                                Gl + 2,
                                0
                            ],
                            "line-opacity": 0,
                            "line-color": "#ff0000"
                        },
                        layout: {
                            "line-cap": "square"
                        }
                    }
                }, ql = [
                    "case",
                    [
                        "==",
                        [
                            "get",
                            "type"
                        ],
                        "equirectangular"
                    ],
                    [
                        "case",
                        [
                            "has",
                            "h_pixel_density"
                        ],
                        [
                            "step",
                            [
                                "get",
                                "h_pixel_density"
                            ],
                            ...Dl.QUALITYSCORE_RES_360_VALUES
                        ],
                        1
                    ],
                    [
                        "case",
                        [
                            "has",
                            "h_pixel_density"
                        ],
                        [
                            "step",
                            [
                                "get",
                                "h_pixel_density"
                            ],
                            ...Dl.QUALITYSCORE_RES_FLAT_VALUES
                        ],
                        1
                    ]
                ], Ql = [
                    "case",
                    [
                        "has",
                        "gps_accuracy"
                    ],
                    [
                        "step",
                        [
                            "get",
                            "gps_accuracy"
                        ],
                        ...Dl.QUALITYSCORE_GPS_VALUES
                    ],
                    1
                ], Kl = [
                    "round",
                    [
                        "+",
                        [
                            "*",
                            ql,
                            Dl.QUALITYSCORE_POND_RES
                        ],
                        [
                            "*",
                            Ql,
                            Dl.QUALITYSCORE_POND_GPS
                        ]
                    ]
                ];
                function getThumbGif(Qe) {
                    const rt = document.createElement("img");
                    return rt.src = Co, rt.alt = Qe.loading, rt.title = Qe.loading, rt.classList.add("pnx-map-thumb", "pnx-map-thumb-loader"), rt;
                }
                function isLabelLayer(Qe) {
                    var rt;
                    return "symbol" === Qe.type && void 0 !== (null === Qe || void 0 === Qe || null === (rt = Qe.layout) || void 0 === rt ? void 0 : rt["text-field"]) && (void 0 === Qe.minzoom || Qe.minzoom < 15);
                }
                function combineStyles(Qe, rt) {
                    var Wn, Co;
                    const Dl = Qe.api.getMapStyle();
                    if (Dl.layers = Dl.layers || [], Dl.layers = Dl.layers.concat(getMissingLayerStyles(Dl.sources, Dl.layers)), Dl.metadata || (Dl.metadata = {}), rt.supplementaryStyle && (Object.assign(Dl.sources, rt.supplementaryStyle.sources || {}), Object.assign(Dl.metadata, rt.supplementaryStyle.metadata || {}), Dl.layers = Dl.layers.concat(rt.supplementaryStyle.layers || [])), Dl.layers = Dl.layers.filter((Qe)=>Qe.id), rt.raster && (Dl.sources["pnx-aerial"] = rt.raster, Dl.layers.push({
                        id: Ul,
                        type: "raster",
                        source: "pnx-aerial",
                        layout: {
                            visibility: "aerial" === rt.background ? "visible" : "none"
                        }
                    })), null !== Qe && void 0 !== Qe && null !== (Wn = Qe.users) && void 0 !== Wn && Wn.includes("geovisio") || Dl.layers.forEach((Qe)=>{
                        "geovisio" === Qe.source && (Qe.layout || (Qe.layout = {}), Qe.layout.visibility = "none");
                    }), Dl.layers.sort((Qe, rt)=>isLabelLayer(Qe) && !isLabelLayer(rt) ? 1 : !isLabelLayer(Qe) && isLabelLayer(rt) ? -1 : Qe.id.startsWith("geovisio") && !rt.id.startsWith("geovisio") ? 1 : !Qe.id.startsWith("geovisio") && rt.id.startsWith("geovisio") ? -1 : Qe.id.endsWith("_pictures") && !rt.id.endsWith("_pictures") ? 1 : !Qe.id.endsWith("_pictures") && rt.id.endsWith("_pictures") ? -1 : 0), null !== (Co = Dl.metadata) && void 0 !== Co && Co["panoramax:locales"] || (Dl.metadata["panoramax:locales"] = [
                        "fr",
                        "en",
                        "de",
                        "es",
                        "ru",
                        "pt",
                        "zh",
                        "hi",
                        "latin"
                    ]), Dl.metadata["panoramax:locales"]) {
                        let rt = Qe.lang || (0, Ll.autoDetectLocale)(Dl.metadata["panoramax:locales"], "latin");
                        rt.includes("-") && (rt = rt.split("-")[0]), rt.includes("_") && (rt = rt.split("_")[0]), Dl.layers.forEach((Qe)=>{
                            isLabelLayer(Qe) && Qe.layout["text-field"].includes("name:latin") && (Qe.layout["text-field"] = [
                                "coalesce",
                                [
                                    "get",
                                    `name:${rt}`
                                ],
                                [
                                    "get",
                                    "name:latin"
                                ],
                                [
                                    "get",
                                    "name"
                                ]
                            ]);
                        });
                    }
                    const Rl = Dl.layers.find((Qe)=>"place_label_city" == Qe.id);
                    let Gl = Dl.layers.find((Qe)=>"place_label_capital" == Qe.id);
                    return Rl && !Gl && (Rl.paint = {
                        "text-color": "hsl(0, 0%, 0%)",
                        "text-halo-blur": 0,
                        "text-halo-color": "hsla(0, 0%, 100%, 1)",
                        "text-halo-width": 3
                    }, Rl.layout["text-letter-spacing"] = .1, Gl = JSON.parse(JSON.stringify(Rl)), Gl.id = "place_label_capital", Gl.filter.push([
                        "<=",
                        "capital",
                        2
                    ]), Rl.filter.push([
                        ">",
                        "capital",
                        2
                    ]), Dl.layers.push(Gl)), Dl;
                }
                function getMissingLayerStyles() {
                    let Qe = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, rt = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [];
                    const Wn = [];
                    return Object.keys(Qe).filter((Qe)=>void 0 === rt.find((rt)=>(null === rt || void 0 === rt ? void 0 : rt.source) === Qe)).forEach((Qe)=>{
                        Qe.startsWith("geovisio") && (Wn.push({
                            id: `${Qe}_sequences`,
                            type: "line",
                            source: Qe,
                            "source-layer": "sequences",
                            layout: {
                                ...Hl.SEQUENCES.layout
                            },
                            paint: {
                                ...Hl.SEQUENCES.paint,
                                "line-color": Dl.COLORS.BASE
                            }
                        }), Wn.push({
                            id: `${Qe}_sequences_plus`,
                            type: "line",
                            source: Qe,
                            "source-layer": "sequences",
                            layout: {
                                ...Hl.SEQUENCES_PLUS.layout
                            },
                            paint: {
                                ...Hl.SEQUENCES_PLUS.paint
                            }
                        }), Wn.push({
                            id: `${Qe}_pictures_symbols`,
                            type: "symbol",
                            source: Qe,
                            "source-layer": "pictures",
                            ...Hl.PICTURES_SYMBOLS
                        }), Wn.push({
                            id: `${Qe}_pictures_symbols`,
                            type: "symbol",
                            source: Qe,
                            "source-layer": "pictures",
                            ...Hl.PICTURES_SYMBOLS
                        }), Wn.push({
                            id: `${Qe}_pictures`,
                            type: "circle",
                            source: Qe,
                            "source-layer": "pictures",
                            layout: {
                                ...Hl.PICTURES.layout
                            },
                            paint: {
                                ...Hl.PICTURES.paint,
                                "circle-color": Dl.COLORS.BASE
                            }
                        }));
                    }), rt.filter((Qe)=>{
                        var Wn;
                        return (null === Qe || void 0 === Qe || null === (Wn = Qe.id) || void 0 === Wn ? void 0 : Wn.endsWith("_sequences")) && void 0 === rt.find((rt)=>(null === rt || void 0 === rt ? void 0 : rt.id) === Qe.id + "_plus");
                    }).forEach((Qe)=>{
                        Wn.push({
                            id: `${Qe.id}_plus`,
                            type: "line",
                            source: Qe.source,
                            "source-layer": Qe["source-layer"],
                            layout: {
                                ...Hl.SEQUENCES_PLUS.layout
                            },
                            paint: {
                                ...Hl.SEQUENCES_PLUS.paint
                            }
                        });
                    }), rt.filter((Qe)=>{
                        var Wn;
                        return (null === Qe || void 0 === Qe || null === (Wn = Qe.id) || void 0 === Wn ? void 0 : Wn.endsWith("_pictures")) && void 0 === rt.find((rt)=>(null === rt || void 0 === rt ? void 0 : rt.id) === Qe.id + "_symbols");
                    }).forEach((Qe)=>{
                        Wn.unshift({
                            id: `${Qe.id}_symbols`,
                            type: "symbol",
                            source: Qe.source,
                            "source-layer": "pictures",
                            ...Hl.PICTURES_SYMBOLS
                        }), Qe.paint = Object.assign(Qe.paint || {}, Hl.PICTURES.paint), Qe.layout = Object.assign(Qe.layout || {}, Hl.PICTURES.layout);
                    }), Wn;
                }
                function getUserLayerId(Qe, rt) {
                    return `${getUserSourceId(Qe)}_${rt}`;
                }
                function getUserSourceId(Qe) {
                    return "geovisio" === Qe ? "geovisio" : "geovisio_" + Qe;
                }
                function switchCoefValue(Qe, rt) {
                    if (Array.isArray(Qe)) return Qe.map((Qe)=>switchCoefValue(Qe, rt));
                    if ("object" === typeof Qe && null !== Qe) {
                        const Wn = {};
                        for(const Co in Qe)Wn[Co] = switchCoefValue(Qe[Co], rt);
                        return Wn;
                    }
                    return "string" === typeof Qe && Qe.startsWith("coef") ? rt : Qe;
                }
                function linkMapAndPhoto(Qe) {
                    const onPicLoad = (rt)=>{
                        var Wn, Co, Ll, Rl;
                        (0, Dl.isNullId)(rt.detail.picId) ? (Qe.map.displayPictureMarker(), null !== Qe && void 0 !== Qe && null !== (Wn = Qe.isMapWide) && void 0 !== Wn && Wn.call(Qe) && (null === Qe || void 0 === Qe || null === (Co = Qe.mini) || void 0 === Co || Co.setAttribute("collapsed", ""))) : (Qe.map.displayPictureMarker(rt.detail.lon, rt.detail.lat, Qe.psv.getXY().x, rt.detail.first), null !== Qe && void 0 !== Qe && null !== (Ll = Qe.isMapWide) && void 0 !== Ll && Ll.call(Qe) && (null === Qe || void 0 === Qe || null === (Rl = Qe.mini) || void 0 === Rl || Rl.removeAttribute("collapsed")));
                    };
                    Qe.psv.addEventListener("picture-loading", onPicLoad), Qe.psv.addEventListener("picture-loaded", onPicLoad), Qe.psv.addEventListener("view-rotated", ()=>{
                        let rt = Qe.psv.getPosition().yaw * (180 / Math.PI);
                        rt += Qe.psv.getPictureOriginalHeading(), Qe.map._picMarker.setRotation(rt);
                    }), Qe.psv.addEventListener("picture-preview-started", (rt)=>{
                        Qe.map._picMarkerPreview.setLngLat(rt.detail.coordinates).setRotation(rt.detail.direction || 0).addTo(Qe.map);
                    }), Qe.psv.addEventListener("picture-preview-stopped", ()=>{
                        Qe.map._picMarkerPreview.remove();
                    }), Qe.psv.addEventListener("picture-loaded", (rt)=>{
                        Qe.isWidthSmall() && Qe._picPopup && rt.detail.picId == Qe._picPopup._picId && Qe._picPopup.remove();
                    }), Qe.map.on("picture-click", (rt)=>{
                        Qe.select(rt.seqId, rt.picId), !Qe.psv._myVTour.state.currentNode && null !== Qe && void 0 !== Qe && Qe._setFocus && Qe._setFocus("pic");
                    }), Qe.map.on("sequence-click", (rt)=>{
                        Qe.api.getPicturesAroundCoordinates(rt.coordinates.lat, rt.coordinates.lng, 1, 1, rt.seqId).then((rt)=>{
                            var Wn, Co;
                            (null === rt || void 0 === rt || null === (Wn = rt.features) || void 0 === Wn ? void 0 : Wn.length) > 0 && (Qe.select(null === (Co = rt.features[0]) || void 0 === Co ? void 0 : Co.collection, rt.features[0].id), !Qe.psv.getPictureMetadata() && null !== Qe && void 0 !== Qe && Qe._setFocus && Qe._setFocus("pic"));
                        });
                    }), Qe._setFocus && (Qe.psv.addEventListener("dblclick", ()=>{
                        Qe.isMapWide() && Qe._setFocus("pic");
                    }), Qe.map.on("dblclick", ()=>{
                        Qe.isMapWide() ? Qe.select() : Qe._setFocus("map");
                    }));
                }
                function initMapKeyboardHandler(Qe) {
                    Qe.map.keyboard.keydown = (function(rt) {
                        if (rt.altKey || rt.ctrlKey || rt.metaKey) return;
                        switch(rt.key){
                            case "*":
                            case "5":
                                return void Qe.moveCenter();
                            case "PageUp":
                            case "9":
                                return void Qe.psv.goToNextPicture();
                            case "PageDown":
                            case "3":
                                return void Qe.psv.goToPrevPicture();
                            case "Home":
                            case "7":
                                return rt.stopPropagation(), void Qe._toggleFocus();
                            case "End":
                            case "1":
                                return void Qe.mini.toggleAttribute("collapsed");
                            case " ":
                            case "0":
                                return void Qe.psv.toggleSequencePlaying();
                        }
                        let Wn = 0, Co = 0, Dl = 0, Ll = 0, Rl = 0;
                        switch(rt.keyCode){
                            case 61:
                            case 107:
                            case 171:
                            case 187:
                                Wn = 1;
                                break;
                            case 189:
                            case 109:
                            case 173:
                                Wn = -1;
                                break;
                            case 37:
                            case 100:
                                rt.shiftKey ? Co = -1 : (rt.preventDefault(), Ll = -1);
                                break;
                            case 39:
                            case 102:
                                rt.shiftKey ? Co = 1 : (rt.preventDefault(), Ll = 1);
                                break;
                            case 38:
                            case 104:
                                rt.shiftKey ? Dl = 1 : (rt.preventDefault(), Rl = -1);
                                break;
                            case 40:
                            case 98:
                                rt.shiftKey ? Dl = -1 : (rt.preventDefault(), Rl = 1);
                                break;
                            default:
                                return;
                        }
                        return this._rotationDisabled && (Co = 0, Dl = 0), {
                            cameraAnimation: (Qe)=>{
                                const Ul = this._tr;
                                Qe.easeTo({
                                    duration: 300,
                                    easeId: "keyboardHandler",
                                    easing: (Qe)=>Qe * (2 - Qe),
                                    zoom: Wn ? Math.round(Ul.zoom) + Wn * (rt.shiftKey ? 2 : 1) : Ul.zoom,
                                    bearing: Ul.bearing + Co * this._bearingStep,
                                    pitch: Ul.pitch + Dl * this._pitchStep,
                                    offset: [
                                        -Ll * this._panStep,
                                        -Rl * this._panStep
                                    ],
                                    center: Ul.center
                                }, {
                                    originalEvent: rt
                                });
                            }
                        };
                    }).bind(Qe.map.keyboard);
                }
                const $l = "pnx-map-parameters";
                function getMapParamsFromLocalStorage() {
                    const Qe = localStorage.getItem($l);
                    if (!Qe) return {};
                    try {
                        return JSON.parse(Qe);
                    } catch (rt) {
                        return console.warn("Can't read map parameters stored in localStorage", rt), {};
                    }
                }
                function saveMapParamsToLocalStorage(Qe) {
                    const save = ()=>localStorage.setItem($l, JSON.stringify({
                            center: Object.fromEntries(Object.entries(Qe.getCenter()).map((Qe)=>{
                                let [rt, Wn] = Qe;
                                return [
                                    rt,
                                    Wn.toFixed(7)
                                ];
                            })),
                            zoom: Qe.getZoom().toFixed(1),
                            background: Qe.getBackground(),
                            theme: Qe._mapFilters.theme
                        }));
                    Qe.on("background-changed", save), Qe.on("filters-changed", save), Qe.on("moveend", save), Qe.on("zoomend", save), Qe.on("dragend", save), Qe.on("boxzoomend", save);
                }
            },
            508: (Qe, rt, Wn)=>{
                "use strict";
                Wn.r(rt), Wn.d(rt, {
                    apiFeatureToPSVNode: ()=>apiFeatureToPSVNode,
                    filterRelatedPicsLinks: ()=>filterRelatedPicsLinks,
                    getCroppedPanoData: ()=>getCroppedPanoData,
                    getExifFloat: ()=>getExifFloat,
                    getGPSPrecision: ()=>getGPSPrecision,
                    getHashTags: ()=>getHashTags,
                    getNodeCaption: ()=>getNodeCaption,
                    getSphereCorrection: ()=>getSphereCorrection,
                    hasAnnotations: ()=>hasAnnotations,
                    sortPicturesInDirection: ()=>sortPicturesInDirection
                });
                var Co = Wn(8407), Dl = Wn(6830), Ll = Wn(7343);
                const Rl = (0, Ll.svgToPSVLink)(Co, "white"), Ul = (0, Ll.svgToPSVLink)(Dl, Ll.COLORS.NEXT);
                function getExifFloat(Qe) {
                    if (!([
                        null,
                        void 0,
                        ""
                    ].includes(Qe) || "string" === typeof Qe && "" === Qe.trim())) {
                        if ("number" === typeof Qe) return Qe;
                        if ("string" !== typeof Qe) ;
                        else {
                            if (/^-?\d+(\.\d+)?\/-?\d+(\.\d+)?$/.test(Qe)) {
                                const rt = Qe.split("/").map((Qe)=>parseFloat(Qe));
                                return rt[0] / rt[1];
                            }
                            try {
                                return parseFloat(Qe);
                            } catch (rt) {}
                        }
                    }
                }
                function getGPSPrecision(Qe) {
                    var rt, Wn, Co, Dl, Ll;
                    let Rl = null;
                    const Ul = (null === Qe || void 0 === Qe || null === (rt = Qe.properties) || void 0 === rt ? void 0 : rt["quality:horizontal_accuracy"]) || getExifFloat(null === Qe || void 0 === Qe || null === (Wn = Qe.properties) || void 0 === Wn || null === (Co = Wn.exif) || void 0 === Co ? void 0 : Co["Exif.GPSInfo.GPSHPositioningError"]), Gl = getExifFloat(null === Qe || void 0 === Qe || null === (Dl = Qe.properties) || void 0 === Dl || null === (Ll = Dl.exif) || void 0 === Ll ? void 0 : Ll["Exif.GPSInfo.GPSDOP"]);
                    return void 0 !== Ul ? Rl = `${Ul} m` : void 0 !== Gl && (Rl = Gl < 1 ? "ideal" : Gl < 2 ? "excellent" : Gl < 5 ? "good" : Gl < 10 ? "moderate" : Gl < 20 ? "fair" : "poor"), Rl;
                }
                function getSphereCorrection(Qe) {
                    var rt, Wn, Co, Dl;
                    let Ll = null === (rt = Qe.properties) || void 0 === rt ? void 0 : rt["view:azimuth"];
                    if (void 0 === Ll) {
                        var Rl, Ul;
                        const rt = getExifFloat(null === (Rl = Qe.properties) || void 0 === Rl || null === (Ul = Rl.exif) || void 0 === Ul ? void 0 : Ul["Exif.GPSInfo.GPSImgDirection"]);
                        void 0 !== rt && (Ll = rt);
                    }
                    Ll = Ll || 0;
                    let Gl = null === (Wn = Qe.properties) || void 0 === Wn ? void 0 : Wn["pers:yaw"], Zl = [
                        "Xmp.GPano.PoseHeadingDegrees",
                        "Xmp.Camera.Yaw",
                        "Exif.MpfInfo.MPFYawAngle"
                    ];
                    if (void 0 === Gl) for (let du of Zl){
                        var Hl, ql;
                        const rt = getExifFloat(null === (Hl = Qe.properties) || void 0 === Hl || null === (ql = Hl.exif) || void 0 === ql ? void 0 : ql[du]);
                        if (void 0 !== rt) {
                            Gl = rt;
                            break;
                        }
                    }
                    Gl = Gl || 0, Math.round(Ll) === Math.round(Gl) && Gl > 0 && console.warn("Picture with UUID", Qe.id, "has same GPS Image direction and Yaw, could cause rendering issues");
                    let Ql = null === (Co = Qe.properties) || void 0 === Co ? void 0 : Co["pers:pitch"];
                    if (Zl = [
                        "Xmp.GPano.PosePitchDegrees",
                        "Xmp.Camera.Pitch",
                        "Exif.MpfInfo.MPFPitchAngle"
                    ], void 0 === Ql) for (let du of Zl){
                        var Kl, $l;
                        const rt = getExifFloat(null === (Kl = Qe.properties) || void 0 === Kl || null === ($l = Kl.exif) || void 0 === $l ? void 0 : $l[du]);
                        if (void 0 !== rt) {
                            Ql = rt;
                            break;
                        }
                    }
                    Ql = Ql || 0;
                    let Tc = null === (Dl = Qe.properties) || void 0 === Dl ? void 0 : Dl["pers:roll"];
                    if (Zl = [
                        "Xmp.GPano.PoseRollDegrees",
                        "Xmp.Camera.Roll",
                        "Exif.MpfInfo.MPFRollAngle"
                    ], void 0 === Tc) for (let du of Zl){
                        var tu, lu;
                        const rt = getExifFloat(null === (tu = Qe.properties) || void 0 === tu || null === (lu = tu.exif) || void 0 === lu ? void 0 : lu[du]);
                        if (void 0 !== rt) {
                            Tc = rt;
                            break;
                        }
                    }
                    return Tc = Tc || 0, 0 !== Ql && 0 !== Tc ? {
                        pan: Gl * Math.PI / 180,
                        tilt: Ql * Math.PI / 180,
                        roll: Tc * Math.PI / 180
                    } : {};
                }
                function getCroppedPanoData(Qe) {
                    var rt, Wn;
                    let Co;
                    var Dl, Ll;
                    if (null !== (rt = Qe.properties) && void 0 !== rt && rt["pers:interior_orientation"] && null !== (Dl = Qe.properties["pers:interior_orientation"]) && void 0 !== Dl && Dl.visible_area && null !== (Ll = Qe.properties["pers:interior_orientation"]) && void 0 !== Ll && Ll.sensor_array_dimensions) {
                        const rt = Qe.properties["pers:interior_orientation"].visible_area, Wn = Qe.properties["pers:interior_orientation"].sensor_array_dimensions;
                        try {
                            Co = {
                                fullWidth: parseInt(Wn[0]),
                                fullHeight: parseInt(Wn[1]),
                                croppedX: parseInt(rt[0]),
                                croppedY: parseInt(rt[1]),
                                croppedWidth: parseInt(Wn[0]) - parseInt(rt[2]) - parseInt(rt[0]),
                                croppedHeight: parseInt(Wn[1]) - parseInt(rt[3]) - parseInt(rt[1])
                            };
                        } catch (Ql) {
                            console.warn("Invalid pers:interior_orientation values for cropped panorama " + Qe.id);
                        }
                    }
                    if (!Co && null !== (Wn = Qe.properties) && void 0 !== Wn && Wn.exif) try {
                        var Rl, Ul, Gl, Zl, Hl, ql;
                        Co = {
                            fullWidth: parseInt(null === (Rl = Qe.properties.exif) || void 0 === Rl ? void 0 : Rl["Xmp.GPano.FullPanoWidthPixels"]),
                            fullHeight: parseInt(null === (Ul = Qe.properties.exif) || void 0 === Ul ? void 0 : Ul["Xmp.GPano.FullPanoHeightPixels"]),
                            croppedX: parseInt(null === (Gl = Qe.properties.exif) || void 0 === Gl ? void 0 : Gl["Xmp.GPano.CroppedAreaLeftPixels"]),
                            croppedY: parseInt(null === (Zl = Qe.properties.exif) || void 0 === Zl ? void 0 : Zl["Xmp.GPano.CroppedAreaTopPixels"]),
                            croppedWidth: parseInt(null === (Hl = Qe.properties.exif) || void 0 === Hl ? void 0 : Hl["Xmp.GPano.CroppedAreaImageWidthPixels"]),
                            croppedHeight: parseInt(null === (ql = Qe.properties.exif) || void 0 === ql ? void 0 : ql["Xmp.GPano.CroppedAreaImageHeightPixels"])
                        };
                    } catch (Ql) {
                        console.warn("Invalid XMP.GPano values for cropped panorama " + Qe.id);
                    }
                    return Co && (Co = Object.fromEntries(Object.entries(Co || {}).filter((Qe)=>!isNaN(Qe[1]))), (!Co.fullWidth && !Co.croppedWidth && Co.fullHeight && !Co.croppedHeight || Co.fullWidth && !Co.croppedWidth && !Co.fullHeight && !Co.croppedHeight || Co.fullWidth && !Co.croppedWidth && Co.fullHeight && !Co.croppedHeight || Co.fullWidth == Co.croppedWidth && Co.fullHeight == Co.croppedHeight) && (Co = {})), Co || {};
                }
                function sortPicturesInDirection(Qe) {
                    return (rt, Wn)=>"related" != rt.rel && "related" != Wn.rel ? 0 : "related" != rt.rel ? -1 : "related" != Wn.rel ? 1 : rt.date == Wn.date ? (0, Ll.getDistance)(Qe, rt.geometry.coordinates) - (0, Ll.getDistance)(Qe, Wn.geometry.coordinates) : Wn.date.localeCompare(rt.date);
                }
                function getNodeCaption(Qe, rt) {
                    var Wn, Co, Dl;
                    const Ll = {};
                    if (null !== Qe && void 0 !== Qe && null !== (Wn = Qe.properties) && void 0 !== Wn && Wn.datetimetz) {
                        Ll.date = new Date(Qe.properties.datetimetz);
                        const rt = Qe.properties.datetimetz.match(/([+-]\d{2}):(\d{2})$|Z$/);
                        rt && ("Z" === rt[0] ? Ll.tz = "UTC" : Ll.tz = rt[0]);
                    } else null !== Qe && void 0 !== Qe && null !== (Co = Qe.properties) && void 0 !== Co && Co.datetime && (Ll.date = new Date(Qe.properties.datetime));
                    if (null !== Qe && void 0 !== Qe && Qe.providers) {
                        var Rl;
                        const rt = null === Qe || void 0 === Qe || null === (Rl = Qe.providers) || void 0 === Rl ? void 0 : Rl.filter((Qe)=>{
                            var rt;
                            return null === Qe || void 0 === Qe || null === (rt = Qe.roles) || void 0 === rt ? void 0 : rt.includes("producer");
                        });
                        if ((null === rt || void 0 === rt ? void 0 : rt.length) >= 0) {
                            const Qe = {};
                            rt.map((Qe)=>Qe.name).forEach((rt)=>{
                                const Wn = rt.toLowerCase().replace(/\s/g, "");
                                Qe[Wn] ? Qe[Wn].push(rt) : Qe[Wn] = [
                                    rt
                                ];
                            }), Ll.producer = [], Object.values(Qe).forEach((Qe)=>{
                                const rt = Qe[0], Wn = Qe.find((Qe)=>Qe.toLowerCase() != Qe);
                                Ll.producer.push(Wn || rt);
                            });
                        }
                    }
                    if (null !== Qe && void 0 !== Qe && null !== (Dl = Qe.properties) && void 0 !== Dl && Dl.license && (Ll.license = Qe.properties.license, null !== Qe && void 0 !== Qe && Qe.links)) {
                        const Wn = Qe.links.find((Qe)=>"license" === (null === Qe || void 0 === Qe ? void 0 : Qe.rel));
                        Wn && (Ll.license = `<a href="${Wn.href}" title="${rt.pnx.metadata_general_license_link}" target="_blank">${Ll.license}</a>`);
                    }
                    return Ll;
                }
                function apiFeatureToPSVNode(Qe, rt) {
                    var Wn, Co, Dl, Ll, Rl, Ul, Gl, Zl, Hl, ql, Ql, Kl, $l, Tc;
                    let tu = arguments.length > 2 && void 0 !== arguments[2] && arguments[2], lu = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null;
                    const du = null != (null === (Wn = Qe.properties) || void 0 === Wn || null === (Co = Wn["pers:interior_orientation"]) || void 0 === Co ? void 0 : Co.field_of_view);
                    let fu = du ? parseInt(Qe.properties["pers:interior_orientation"].field_of_view) : 70;
                    const yu = 360 === fu, Eu = (Object.values(Qe.assets).find((Qe)=>{
                        var rt;
                        return null === Qe || void 0 === Qe || null === (rt = Qe.roles) || void 0 === rt ? void 0 : rt.includes("data");
                    }) || {}).href, Tu = null === Qe || void 0 === Qe || null === (Dl = Qe.properties) || void 0 === Dl || null === (Ll = Dl["tiles:tile_matrix_sets"]) || void 0 === Ll ? void 0 : Ll.geovisio, Lu = null === (Rl = Qe.links) || void 0 === Rl || null === (Ul = Rl.find) || void 0 === Ul ? void 0 : Ul.call(Rl, (Qe)=>"prev" === (null === Qe || void 0 === Qe ? void 0 : Qe.rel) && "application/geo+json" === (null === Qe || void 0 === Qe ? void 0 : Qe.type)), Zu = null === (Gl = Qe.links) || void 0 === Gl || null === (Zl = Gl.find) || void 0 === Zl ? void 0 : Zl.call(Gl, (Qe)=>"next" === (null === Qe || void 0 === Qe ? void 0 : Qe.rel) && "application/geo+json" === (null === Qe || void 0 === Qe ? void 0 : Qe.type)), Xu = Object.values(Qe.assets).find((Qe)=>{
                        var rt;
                        return (null === (rt = Qe.roles) || void 0 === rt ? void 0 : rt.includes("visual")) && "image/webp" === Qe.type;
                    }), Ju = Object.values(Qe.assets).find((Qe)=>{
                        var rt;
                        return (null === (rt = Qe.roles) || void 0 === rt ? void 0 : rt.includes("visual")) && "image/jpeg" === Qe.type;
                    }), $u = (Xu || Ju).href, ed = null === (Hl = Object.values(Qe.assets).find((Qe)=>{
                        var rt;
                        return (null === (rt = Qe.roles) || void 0 === rt ? void 0 : rt.includes("thumbnail")) && "image/jpeg" === Qe.type;
                    })) || void 0 === Hl ? void 0 : Hl.href, td = (null === Qe || void 0 === Qe || null === (ql = Qe.asset_templates) || void 0 === ql ? void 0 : ql.tiles_webp) || (null === Qe || void 0 === Qe || null === (Ql = Qe.asset_templates) || void 0 === Ql ? void 0 : Ql.tiles), id = getCroppedPanoData(Qe), nd = null === (Kl = Qe.links) || void 0 === Kl || null === ($l = Kl.find) || void 0 === $l ? void 0 : $l.call(Kl, (Qe)=>"via" === (null === Qe || void 0 === Qe ? void 0 : Qe.rel) && "application/json" === (null === Qe || void 0 === Qe ? void 0 : Qe.type));
                    let rd;
                    rd = Object.keys(id).length > 0 ? {
                        baseUrl: tu ? Eu : $u,
                        origBaseUrl: tu ? Eu : $u,
                        hdUrl: Eu,
                        thumbUrl: ed,
                        basePanoData: id,
                        cols: 2,
                        rows: 1,
                        width: 2,
                        tileUrl: ()=>null
                    } : yu && Tu ? {
                        baseUrl: $u,
                        origBaseUrl: $u,
                        basePanoData: (Qe)=>({
                                fullWidth: Qe.width,
                                fullHeight: Qe.height
                            }),
                        hdUrl: Eu,
                        thumbUrl: ed,
                        cols: Tu && Tu.tileMatrix[0].matrixWidth,
                        rows: Tu && Tu.tileMatrix[0].matrixHeight,
                        width: Tu && Tu.tileMatrix[0].matrixWidth * Tu.tileMatrix[0].tileWidth,
                        tileUrl: Tu && ((Qe, rt)=>td.href.replace(/\{TileCol\}/g, Qe).replace(/\{TileRow\}/g, rt))
                    } : {
                        baseUrl: tu ? Eu : $u,
                        origBaseUrl: tu ? Eu : $u,
                        hdUrl: Eu,
                        thumbUrl: ed,
                        basePanoData: (Qe)=>{
                            Qe.width < Qe.height && !du && (fu = 35);
                            const rt = fu * Qe.height / Qe.width, Wn = 360 * Qe.width / fu, Co = 180 * Qe.height / rt;
                            return {
                                fullWidth: Wn,
                                fullHeight: Co,
                                croppedWidth: Qe.width,
                                croppedHeight: Qe.height,
                                croppedX: (Wn - Qe.width) / 2,
                                croppedY: (Co - Qe.height) / 2
                            };
                        },
                        cols: 2,
                        rows: 1,
                        width: 2,
                        tileUrl: ()=>null
                    }, null !== (Tc = Qe.properties) && void 0 !== Tc && Tc.semantics && (Qe.properties.semantics = Qe.properties.semantics.filter((Qe)=>Object.keys(Qe).length > 0));
                    return {
                        id: Qe.id,
                        caption: getNodeCaption(Qe, rt),
                        panorama: rd,
                        links: filterRelatedPicsLinks(Qe, lu),
                        gps: Qe.geometry.coordinates,
                        sequence: {
                            id: Qe.collection,
                            nextPic: Zu ? Zu.id : void 0,
                            prevPic: Lu ? Lu.id : void 0
                        },
                        sphereCorrection: getSphereCorrection(Qe),
                        horizontalFov: fu,
                        origInstance: nd,
                        properties: Qe.properties
                    };
                }
                function filterRelatedPicsLinks(Qe) {
                    var rt;
                    let Wn = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
                    const Co = Qe.links.filter((Qe)=>[
                            "next",
                            "prev",
                            "related"
                        ].includes(null === Qe || void 0 === Qe ? void 0 : Qe.rel) && "application/geo+json" === (null === Qe || void 0 === Qe ? void 0 : Qe.type)).filter((Qe)=>!Wn || Wn(Qe)).map((Qe)=>(Qe.datetime && (Qe.date = Qe.datetime.split("T")[0]), Qe)), Dl = Qe.geometry.coordinates, Gl = [], Zl = {
                        N: [],
                        ENE: [],
                        ESE: [],
                        S: [],
                        WSW: [],
                        WNW: []
                    };
                    for (let Rl of Co)Zl[(0, Ll.getSimplifiedAngle)(Dl, Rl.geometry.coordinates)].push(Rl);
                    for(let Ll in Zl){
                        const Qe = Zl[Ll];
                        0 != Qe.length && (Qe.sort(sortPicturesInDirection(Dl)), Gl.push(Qe.shift()));
                    }
                    let arrowStyle = (Qe)=>"related" === Qe.rel ? {
                            element: (0, Ll.getArrow)(Ul),
                            size: {
                                width: 128 / 3,
                                height: 128
                            }
                        } : {
                            element: (0, Ll.getArrow)(Rl),
                            size: {
                                width: 75,
                                height: 75
                            }
                        };
                    const Hl = -((null === (rt = Qe.properties) || void 0 === rt ? void 0 : rt["view:azimuth"]) || 0) * (Math.PI / 180);
                    return Gl.map((Qe)=>({
                            nodeId: Qe.id,
                            gps: Qe.geometry.coordinates,
                            arrowStyle: arrowStyle(Qe),
                            linkOffset: {
                                yaw: Hl
                            }
                        }));
                }
                function getHashTags(Qe) {
                    var rt;
                    if (null === Qe || void 0 === Qe || null === (rt = Qe.properties) || void 0 === rt || !rt.semantics) return [];
                    const Wn = Qe.properties.semantics.filter((Qe)=>"hashtags" === Qe.key), Co = [];
                    return Wn.forEach((Qe)=>Qe.value.split(";").forEach((Qe)=>Co.push(Qe.trim()))), Co;
                }
                function hasAnnotations(Qe) {
                    var rt, Wn;
                    return (null === Qe || void 0 === Qe || null === (rt = Qe.properties) || void 0 === rt || null === (Wn = rt.annotations) || void 0 === Wn ? void 0 : Wn.length) > 0;
                }
            },
            2283: (Qe, rt, Wn)=>{
                "use strict";
                Wn.r(rt), Wn.d(rt, {
                    decodeBasicTag: ()=>decodeBasicTag,
                    decodeKey: ()=>decodeKey,
                    groupByPrefix: ()=>groupByPrefix
                });
                var Co = Wn(4542), Dl = Wn(5995), Ll = Wn(7929), Rl = Wn(1760), Ul = Wn(7091), Gl = Wn(7208);
                function valToValLink(Qe, rt, Wn) {
                    return Co.qy`
		${Qe}
		<pnx-link-button
			kind="superinline"
			size="sm"
			href=${rt}
			target="_blank"
			style="vertical-align: middle"
			title=${Wn}
		>${(0, Dl.fa)(Ll.iW_)}</pnx-link-button>`;
                }
                const Zl = [
                    "highway",
                    "building",
                    "amenity",
                    "landuse",
                    "natural",
                    "waterway",
                    "leisure",
                    "shop",
                    "railway",
                    "tourism",
                    "barrier",
                    "boundary",
                    "place",
                    "power"
                ], Hl = {
                    "": {
                        title: "Panoramax"
                    },
                    osm: {
                        title: "OpenStreetMap",
                        logo: Rl,
                        key_transform: (Qe, rt)=>valToValLink(Qe.key, `${(0, Gl.OSMWikiURL)()}/Key:${Qe.key}`, rt.pnx.semantics_key_doc),
                        value_transform: (Qe, rt)=>Zl.includes(Qe.key) ? valToValLink(Qe.value, `${(0, Gl.OSMWikiURL)()}/Tag:${Qe.key}=${Qe.value}`, rt.pnx.semantics_value_doc) : Qe.value
                    },
                    wd: {
                        title: "Wikidata",
                        logo: Ul,
                        key_transform: (Qe, rt)=>{
                            const Wn = `${(0, Gl.WikidataURL)()}/Property:${Qe.key}`;
                            return rt.pnx.semantics_wikidata_properties[Qe.key] ? valToValLink(`${rt.pnx.semantics_wikidata_properties[Qe.key]} (${Qe.key})`, Wn, rt.pnx.semantics_key_doc) : valToValLink(Qe.key, Wn, rt.pnx.semantics_key_doc);
                        },
                        value_transform: (Qe, rt)=>valToValLink(Qe.value, `${(0, Gl.WikidataURL)()}/${Qe.value}`, rt.pnx.semantics_value_doc)
                    },
                    exif: {
                        title: "EXIF"
                    }
                };
                function decodeBasicTag(Qe) {
                    const rt = (Qe || "").indexOf("=");
                    return rt < 0 ? null : {
                        key: decodeKey(Qe.substring(0, rt)),
                        value: Qe.substring(rt + 1)
                    };
                }
                function decodeKey() {
                    let Qe = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
                    const rt = Qe.match(/^(?:([a-z_]+)\|)?([^[]+)(?:\[(.*)\])?$/);
                    if (!rt) return {
                        prefix: "",
                        subkey: Qe,
                        qualifies: null
                    };
                    const [, Wn, Co, Dl] = rt;
                    return {
                        prefix: Wn || "",
                        subkey: Co,
                        qualifies: decodeBasicTag(Dl)
                    };
                }
                function groupByPrefix(Qe) {
                    const rt = {}, Wn = [];
                    return Qe.forEach((Qe)=>{
                        const Co = decodeKey(Qe.key);
                        Co.qualifies ? Wn.push(Object.assign({}, Qe, Co)) : (rt[Co.prefix] || (rt[Co.prefix] = []), rt[Co.prefix].push(Co.prefix.length > 0 ? {
                            key: Co.subkey,
                            value: Qe.value
                        } : Qe));
                    }), Wn.forEach((Qe)=>{
                        var Wn;
                        let { key: Co, prefix: Dl, subkey: Ll, qualifies: Rl, value: Ul } = Qe;
                        const Gl = null === (Wn = rt[Rl.key.prefix]) || void 0 === Wn ? void 0 : Wn.find((Qe)=>Qe.key === Rl.key.subkey && (!Rl.value || Rl.value === Qe.value));
                        Gl && (Gl.qualifiers || (Gl.qualifiers = []), Gl.qualifiers.push({
                            key: Co,
                            prefix: Dl,
                            subkey: Ll,
                            value: Ul
                        }));
                    }), Object.entries(rt).map((Qe)=>{
                        let [rt, Wn] = Qe;
                        return Hl[rt] ? Object.assign({
                            prefix: rt,
                            tags: Wn
                        }, Hl[rt]) : {
                            prefix: rt,
                            title: rt,
                            tags: Wn
                        };
                    });
                }
            },
            7208: (Qe, rt, Wn)=>{
                "use strict";
                function PanoramaxPresetsURL() {
                    return "https://presets.panoramax.fr";
                }
                function TemakiIconURL(Qe) {
                    return `https://raw.githubusercontent.com/rapideditor/temaki/refs/heads/main/icons/${Qe}.svg`;
                }
                function WikidataURL() {
                    return "https://www.wikidata.org/wiki";
                }
                function IdEditorURL() {
                    return "https://www.openstreetmap.org/edit?editor=id";
                }
                function OSMWikiURL() {
                    return "https://wiki.openstreetmap.org/wiki";
                }
                function InternetFastThreshold() {
                    return 10;
                }
                function InternetFastTestFile() {
                    return "https://panoramax.openstreetmap.fr/images/05/ca/2c/98/0111-4baf-b6f3-587bb8847d2e.jpg";
                }
                function AdresseDataGouvBaseURL() {
                    return "https://data.geopf.fr/geocodage/search";
                }
                function NominatimBaseUrl() {
                    return "https://nominatim.openstreetmap.org";
                }
                Wn.r(rt), Wn.d(rt, {
                    AdresseDataGouvBaseURL: ()=>AdresseDataGouvBaseURL,
                    IdEditorURL: ()=>IdEditorURL,
                    InternetFastTestFile: ()=>InternetFastTestFile,
                    InternetFastThreshold: ()=>InternetFastThreshold,
                    NominatimBaseUrl: ()=>NominatimBaseUrl,
                    OSMWikiURL: ()=>OSMWikiURL,
                    PanoramaxPresetsURL: ()=>PanoramaxPresetsURL,
                    TemakiIconURL: ()=>TemakiIconURL,
                    WikidataURL: ()=>WikidataURL
                });
            },
            7343: (Qe, rt, Wn)=>{
                "use strict";
                Wn.r(rt), Wn.d(rt, {
                    BASE_PANORAMA_ID: ()=>Dl,
                    COLORS: ()=>Ll,
                    COLORS_HEX: ()=>Rl,
                    QUALITYSCORE_GPS_VALUES: ()=>Hl,
                    QUALITYSCORE_POND_GPS: ()=>Ql,
                    QUALITYSCORE_POND_RES: ()=>ql,
                    QUALITYSCORE_RES_360_VALUES: ()=>Zl,
                    QUALITYSCORE_RES_FLAT_VALUES: ()=>Gl,
                    QUALITYSCORE_VALUES: ()=>Ul,
                    degToDms: ()=>degToDms,
                    getArrow: ()=>getArrow,
                    getAzimuth: ()=>getAzimuth,
                    getCookie: ()=>getCookie,
                    getDistance: ()=>getDistance,
                    getGrade: ()=>getGrade,
                    getRelativeHeading: ()=>getRelativeHeading,
                    getSimplifiedAngle: ()=>getSimplifiedAngle,
                    getUserAccount: ()=>getUserAccount,
                    isInIframe: ()=>isInIframe,
                    isInternetFast: ()=>isInternetFast,
                    isNullId: ()=>isNullId,
                    josmBboxParameters: ()=>josmBboxParameters,
                    positionToXYZ: ()=>positionToXYZ,
                    svgToPSVLink: ()=>svgToPSVLink,
                    xyzToPosition: ()=>xyzToPosition
                });
                var Co = Wn(7208);
                const Dl = "geovisio-fake-id-0", Ll = {
                    BASE: "#FF6F00",
                    SELECTED: "#1E88E5",
                    HIDDEN: "#34495E",
                    NEXT: "#ffab40",
                    QUALI_1: "#00695C",
                    QUALI_2: "#fd8d3c",
                    PALETTE_1: "#fecc5c",
                    PALETTE_2: "#fd8d3c",
                    PALETTE_3: "#f03b20",
                    PALETTE_4: "#bd0026"
                }, Rl = Object.fromEntries(Object.entries(Ll).map((Qe)=>(Qe[1] = parseInt(Qe[1].slice(1), 16), Qe))), Ul = [
                    {
                        color: "#007f4e",
                        label: "A"
                    },
                    {
                        color: "#72b043",
                        label: "B"
                    },
                    {
                        color: "#b5be2f",
                        label: "C"
                    },
                    {
                        color: "#f8cc1b",
                        label: "D"
                    },
                    {
                        color: "#f6a020",
                        label: "E"
                    }
                ], Gl = [
                    1,
                    10,
                    2,
                    15,
                    3,
                    30,
                    4
                ], Zl = [
                    3,
                    15,
                    4,
                    30,
                    5
                ], Hl = [
                    5,
                    1.01,
                    4,
                    2.01,
                    3,
                    5.01,
                    2,
                    10.01,
                    1
                ], ql = .8, Ql = .2;
                function isNullId(Qe) {
                    return [
                        null,
                        void 0,
                        "",
                        Dl
                    ].includes(Qe);
                }
                function getGrade(Qe, rt) {
                    if (null === rt || void 0 === rt || "" === rt) return null;
                    for(let Wn = 0; Wn < Qe.length; Wn += 2){
                        const Co = Qe[Wn];
                        if (rt < Qe[Wn + 1]) return Co;
                    }
                    return Qe[Qe.length - 1];
                }
                function getDistance(Qe, rt) {
                    const Wn = Qe[0] - rt[0], Co = Qe[1] - rt[1];
                    return Math.sqrt(Wn * Wn + Co * Co);
                }
                function svgToPSVLink(Qe, rt) {
                    try {
                        const Wn = atob(Qe.replace(/^data:image\/svg\+xml;base64,/, "")), Co = (new DOMParser).parseFromString(Wn, "image/svg+xml").childNodes[0], Dl = document.createElement("button");
                        return Dl.appendChild(Co), Dl.classList.add("pnx-psv-tour-arrows", "pnx-print-hidden"), Dl.style.color = rt, Dl;
                    } catch (Wn) {
                        const rt = document.createElement("img");
                        return rt.src = Qe, rt.alt = "", rt;
                    }
                }
                function getArrow(Qe) {
                    const rt = Qe.cloneNode(!0);
                    return rt.addEventListener("pointerup", ()=>rt.classList.add("pnx-clicked")), rt;
                }
                function getAzimuth(Qe, rt) {
                    return (Math.atan2(rt[0] - Qe[0], rt[1] - Qe[1]) * (180 / Math.PI) + 360) % 360;
                }
                function getRelativeHeading(Qe) {
                    var rt, Wn;
                    if (!Qe) throw new Error("No picture selected");
                    let Co, Dl;
                    const Ll = Qe.properties["view:azimuth"];
                    if (null !== Qe && void 0 !== Qe && null !== (rt = Qe.sequence) && void 0 !== rt && rt.prevPic) {
                        var Rl;
                        const rt = null === Qe || void 0 === Qe || null === (Rl = Qe.links) || void 0 === Rl ? void 0 : Rl.find((rt)=>rt.nodeId === Qe.sequence.prevPic);
                        rt && (Co = (Ll - getAzimuth(rt.gps, Qe.gps) + 180) % 360 - 180);
                    }
                    if (null !== Qe && void 0 !== Qe && null !== (Wn = Qe.sequence) && void 0 !== Wn && Wn.nextPic) {
                        var Ul;
                        const rt = null === Qe || void 0 === Qe || null === (Ul = Qe.links) || void 0 === Ul ? void 0 : Ul.find((rt)=>rt.nodeId === Qe.sequence.nextPic);
                        rt && (Dl = (Ll - getAzimuth(Qe.gps, rt.gps) + 180) % 360 - 180);
                    }
                    return void 0 !== Co ? Co : void 0 !== Dl ? Dl : 0;
                }
                function getSimplifiedAngle(Qe, rt) {
                    const Wn = Math.atan2(rt[0] - Qe[0], rt[1] - Qe[1]) * (180 / Math.PI);
                    return Math.abs(Wn) < 30 ? "N" : Wn >= 30 && Wn < 90 ? "ENE" : Wn >= 90 && Wn < 150 ? "ESE" : Math.abs(Wn) >= 150 ? "S" : Wn <= -30 && Wn > -90 ? "WNW" : Wn <= -90 && Wn > -150 ? "WSW" : void 0;
                }
                function positionToXYZ(Qe) {
                    let rt = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0;
                    const Wn = {
                        x: Qe.yaw * (180 / Math.PI),
                        y: Qe.pitch * (180 / Math.PI)
                    };
                    return void 0 !== rt && (Wn.z = rt), Wn;
                }
                function xyzToPosition(Qe, rt, Wn) {
                    return {
                        yaw: Qe / (180 / Math.PI),
                        pitch: rt / (180 / Math.PI),
                        zoom: Wn
                    };
                }
                function degToDms(Qe) {
                    const rt = Qe < 0 ? Math.ceil(Qe) : Math.floor(Qe), Wn = 60 * Math.abs(Qe - rt), Co = Math.floor(Wn);
                    return {
                        d: rt,
                        m: Co,
                        s: parseFloat((60 * (Wn - Co)).toFixed(3))
                    };
                }
                function josmBboxParameters(Qe) {
                    if (Qe) {
                        var rt;
                        const Wn = Qe.gps, Co = null === Qe || void 0 === Qe || null === (rt = Qe.properties) || void 0 === rt ? void 0 : rt["view:azimuth"], Dl = 2e-4, Ll = {
                            left: Wn[0] - (null === Co || Co >= 180 ? Dl : 0),
                            right: Wn[0] + (null === Co || Co <= 180 ? Dl : 0),
                            top: Wn[1] + (null === Co || Co <= 90 || Co >= 270 ? Dl : 0),
                            bottom: Wn[1] - (null === Co || Co >= 90 && Co <= 270 ? Dl : 0),
                            changeset_source: "Panoramax"
                        };
                        return Object.entries(Ll).map((Qe)=>Qe.join("=")).join("&");
                    }
                    return null;
                }
                function isInIframe() {
                    try {
                        return window.self !== window.top;
                    } catch (Qe) {
                        return !0;
                    }
                }
                const Kl = "pnx-internet-fast";
                function isInternetFast() {
                    try {
                        const Qe = navigator.connection.downlink;
                        return Promise.resolve(Qe >= (0, Co.InternetFastThreshold)());
                    } catch (Qe) {
                        try {
                            const Qe = sessionStorage.getItem(Kl);
                            if ([
                                "true",
                                "false"
                            ].includes(Qe)) return Promise.resolve("true" === Qe);
                            const rt = (new Date).getTime();
                            return fetch(`${(0, Co.InternetFastTestFile)()}?nocache=${rt}`).then(async (Qe)=>[
                                    Qe,
                                    await Qe.blob()
                                ]).then((Qe)=>{
                                let [Wn, Dl] = Qe;
                                const Ll = 8 * parseInt(Wn.headers.get("Content-Length") || Dl.size) / 1024 / 1024 / (((new Date).getTime() - rt) / 1e3) >= (0, Co.InternetFastThreshold)();
                                return sessionStorage.setItem(Kl, Ll ? "true" : "false"), Ll;
                            }).catch((Qe)=>(console.warn("Failed to run speedtest", Qe), !1));
                        } catch (Qe) {
                            return Promise.resolve(!1);
                        }
                    }
                }
                function getCookie(Qe) {
                    var rt, Wn, Co;
                    const Dl = null === (rt = document.cookie) || void 0 === rt || null === (Wn = rt.split(";")) || void 0 === Wn || null === (Co = Wn.find((rt)=>rt.trimStart().startsWith(`${Qe}=`))) || void 0 === Co ? void 0 : Co.split("=");
                    if (Dl) return Dl.shift(), Dl.join("=");
                }
                function getUserAccount() {
                    const Qe = getCookie("session"), rt = getCookie("user_id"), Wn = getCookie("user_name");
                    return Qe && rt && Wn ? {
                        id: rt,
                        name: Wn
                    } : null;
                }
            },
            5995: (Qe, rt, Wn)=>{
                "use strict";
                Wn.r(rt), Wn.d(rt, {
                    createWebComp: ()=>createWebComp,
                    fa: ()=>fa,
                    listenForMenuClosure: ()=>listenForMenuClosure,
                    moreIcons: ()=>moreIcons
                });
                var Co = Wn(3710), Dl = Wn(8983), Ll = Wn(7208);
                function fa(Qe, rt) {
                    return (0, Co.Kk)(Qe, rt).node[0];
                }
                function moreIcons() {
                    (0, Dl.c8)(async (Qe)=>{
                        const rt = await fetch((0, Ll.TemakiIconURL)(Qe));
                        return rt.ok ? {
                            body: await rt.text()
                        } : null;
                    }, "temaki");
                }
                function createWebComp(Qe) {
                    let rt = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                    const Wn = document.createElement(Qe);
                    return Object.entries(rt).forEach((Qe)=>{
                        let [rt, Co] = Qe;
                        rt.startsWith("_") ? Wn[rt] = Co : rt.startsWith("fn") ? Wn[rt.substring(2)] = Co : rt.startsWith("on") ? Wn.addEventListener(rt.substring(2), Co) : Co && Wn.setAttribute(rt, Co);
                    }), Wn;
                }
                function listenForMenuClosure(Qe, rt) {
                    var Wn, Co, Dl, Ll, Rl, Ul, Gl;
                    null === (Wn = Qe._parent) || void 0 === Wn || Wn.addEventListener("menu-opened", (Wn)=>{
                        Wn.detail.menu != Qe && rt();
                    }), null === (Co = Qe._parent) || void 0 === Co || null === (Dl = Co.onceMapReady) || void 0 === Dl || Dl.call(Co).then(()=>{
                        var Wn, Co;
                        null === (Wn = Qe._parent.map) || void 0 === Wn || null === (Co = Wn.on) || void 0 === Co || Co.call(Wn, "click", ()=>rt());
                    }), null === (Ll = Qe._parent) || void 0 === Ll || null === (Rl = Ll.oncePSVReady) || void 0 === Rl || Rl.call(Ll).then(()=>{
                        Qe._parent.psv.addEventListener("click", ()=>rt());
                    }), null === (Ul = Qe._parent) || void 0 === Ul || null === (Gl = Ul.onceReady) || void 0 === Gl || Gl.call(Ul).then(()=>{
                        var Wn;
                        null === (Wn = Qe._parent.legend) || void 0 === Wn || Wn.addEventListener("click", ()=>rt());
                    });
                }
            },
            7325: (Qe, rt)=>{
                "use strict";
                var Wn = "star", Co = [
                    11088,
                    61446
                ], Dl = "f005", Ll = "M287.9 0c9.2 0 17.6 5.2 21.6 13.5l68.6 141.3 153.2 22.6c9 1.3 16.5 7.6 19.3 16.3s.5 18.1-5.9 24.5L433.6 328.4l26.2 155.6c1.5 9-2.2 18.1-9.7 23.5s-17.3 6-25.3 1.7l-137-73.2L151 509.1c-8.1 4.3-17.9 3.7-25.3-1.7s-11.2-14.5-9.7-23.5l26.2-155.6L31.1 218.2c-6.5-6.4-8.7-15.9-5.9-24.5s10.3-14.9 19.3-16.3l153.2-22.6L266.3 13.5C270.4 5.2 278.7 0 287.9 0zm0 79L235.4 187.2c-3.5 7.1-10.2 12.1-18.1 13.3L99 217.9 184.9 303c5.5 5.5 8.1 13.3 6.8 21L171.4 443.7l105.2-56.2c7.1-3.8 15.6-3.8 22.6 0l105.2 56.2L384.2 324.1c-1.3-7.7 1.2-15.5 6.8-21l85.9-85.1L358.6 200.5c-7.8-1.2-14.6-6.1-18.1-13.3L287.9 79z";
                rt.mw = {
                    prefix: "far",
                    iconName: Wn,
                    icon: [
                        576,
                        512,
                        Co,
                        Dl,
                        Ll
                    ]
                }, rt.yy = rt.mw;
            },
            8466: (Qe, rt)=>{
                "use strict";
                var Wn = "arrow-left", Co = [
                    8592
                ], Dl = "f060", Ll = "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z";
                rt.mw = {
                    prefix: "fas",
                    iconName: Wn,
                    icon: [
                        448,
                        512,
                        Co,
                        Dl,
                        Ll
                    ]
                }, rt.Ce = rt.mw;
            },
            6069: (Qe, rt)=>{
                "use strict";
                var Wn = "arrow-right", Co = [
                    8594
                ], Dl = "f061", Ll = "M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z";
                rt.mw = {
                    prefix: "fas",
                    iconName: Wn,
                    icon: [
                        448,
                        512,
                        Co,
                        Dl,
                        Ll
                    ]
                }, rt.dm = rt.mw;
            },
            4881: (Qe, rt)=>{
                "use strict";
                var Wn = [
                    61946
                ], Co = "M256 64C150 64 64 150 64 256s86 192 192 192c17.7 0 32 14.3 32 32s-14.3 32-32 32C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256l0 32c0 53-43 96-96 96c-29.3 0-55.6-13.2-73.2-33.9C320 371.1 289.5 384 256 384c-70.7 0-128-57.3-128-128s57.3-128 128-128c27.9 0 53.7 8.9 74.7 24.1c5.7-5 13.1-8.1 21.3-8.1c17.7 0 32 14.3 32 32l0 80 0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32c0-106-86-192-192-192zm64 192a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z";
                rt.mw = {
                    prefix: "fas",
                    iconName: "at",
                    icon: [
                        512,
                        512,
                        Wn,
                        "40",
                        Co
                    ]
                }, rt.Hz = rt.mw;
            },
            1705: (Qe, rt)=>{
                "use strict";
                var Wn = "backward", Co = [
                    9194
                ], Dl = "f04a", Ll = "M459.5 440.6c9.5 7.9 22.8 9.7 34.1 4.4s18.4-16.6 18.4-29l0-320c0-12.4-7.2-23.7-18.4-29s-24.5-3.6-34.1 4.4L288 214.3l0 41.7 0 41.7L459.5 440.6zM256 352l0-96 0-128 0-32c0-12.4-7.2-23.7-18.4-29s-24.5-3.6-34.1 4.4l-192 160C4.2 237.5 0 246.5 0 256s4.2 18.5 11.5 24.6l192 160c9.5 7.9 22.8 9.7 34.1 4.4s18.4-16.6 18.4-29l0-64z";
                rt.mw = {
                    prefix: "fas",
                    iconName: Wn,
                    icon: [
                        512,
                        512,
                        Co,
                        Dl,
                        Ll
                    ]
                }, rt.TH = rt.mw;
            },
            9186: (Qe, rt)=>{
                "use strict";
                var Wn = "calendar", Co = [
                    128197,
                    128198
                ], Dl = "f133", Ll = "M96 32l0 32L48 64C21.5 64 0 85.5 0 112l0 48 448 0 0-48c0-26.5-21.5-48-48-48l-48 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32L160 64l0-32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192L0 192 0 464c0 26.5 21.5 48 48 48l352 0c26.5 0 48-21.5 48-48l0-272z";
                rt.mw = {
                    prefix: "fas",
                    iconName: Wn,
                    icon: [
                        448,
                        512,
                        Co,
                        Dl,
                        Ll
                    ]
                }, rt.ok = rt.mw;
            },
            4927: (Qe, rt, Wn)=>{
                "use strict";
                var Co = Wn(1577);
                rt.mw = {
                    prefix: Co.prefix,
                    iconName: Co.iconName,
                    icon: [
                        Co.width,
                        Co.height,
                        Co.aliases,
                        Co.unicode,
                        Co.svgPathData
                    ]
                }, rt.BE = rt.mw, Co.prefix, Co.iconName, Co.width, Co.height, Co.aliases, Co.unicode, Co.svgPathData, Co.aliases;
            },
            1577: (Qe, rt)=>{
                "use strict";
                Object.defineProperty(rt, "__esModule", {
                    value: !0
                });
                var Wn = "calendar-days", Co = [
                    "calendar-alt"
                ], Dl = "f073", Ll = "M128 0c17.7 0 32 14.3 32 32l0 32 128 0 0-32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32 48 0c26.5 0 48 21.5 48 48l0 48L0 160l0-48C0 85.5 21.5 64 48 64l48 0 0-32c0-17.7 14.3-32 32-32zM0 192l448 0 0 272c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 192zm64 80l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm128 0l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zM64 400l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zm112 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z";
                rt.definition = {
                    prefix: "fas",
                    iconName: Wn,
                    icon: [
                        448,
                        512,
                        Co,
                        Dl,
                        Ll
                    ]
                }, rt.faCalendarDays = rt.definition, rt.prefix = "fas", rt.iconName = Wn, rt.width = 448, rt.height = 512, rt.ligatures = Co, rt.unicode = Dl, rt.svgPathData = Ll, rt.aliases = Co;
            },
            99: (Qe, rt)=>{
                "use strict";
                var Wn = "camera", Co = [
                    62258,
                    "camera-alt"
                ], Dl = "f030", Ll = "M149.1 64.8L138.7 96 64 96C28.7 96 0 124.7 0 160L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64l-74.7 0L362.9 64.8C356.4 45.2 338.1 32 317.4 32L194.6 32c-20.7 0-39 13.2-45.5 32.8zM256 192a96 96 0 1 1 0 192 96 96 0 1 1 0-192z";
                rt.mw = {
                    prefix: "fas",
                    iconName: Wn,
                    icon: [
                        512,
                        512,
                        Co,
                        Dl,
                        Ll
                    ]
                }, rt.rw = rt.mw;
            },
            174: (Qe, rt)=>{
                "use strict";
                var Wn = "check", Co = [
                    10003,
                    10004
                ], Dl = "f00c", Ll = "M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z";
                rt.mw = {
                    prefix: "fas",
                    iconName: Wn,
                    icon: [
                        448,
                        512,
                        Co,
                        Dl,
                        Ll
                    ]
                }, rt.e6 = rt.mw;
            },
            2593: (Qe, rt)=>{
                "use strict";
                var Wn = "chevron-down", Co = [], Dl = "f078", Ll = "M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z";
                rt.mw = {
                    prefix: "fas",
                    iconName: Wn,
                    icon: [
                        512,
                        512,
                        Co,
                        Dl,
                        Ll
                    ]
                }, rt.Jt = rt.mw;
            },
            1187: (Qe, rt)=>{
                "use strict";
                var Wn = "chevron-right", Co = [
                    9002
                ], Dl = "f054", Ll = "M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z";
                rt.mw = {
                    prefix: "fas",
                    iconName: Wn,
                    icon: [
                        320,
                        512,
                        Co,
                        Dl,
                        Ll
                    ]
                }, rt.Xk = rt.mw;
            },
            4336: (Qe, rt)=>{
                "use strict";
                var Wn = "chevron-up", Co = [], Dl = "f077", Ll = "M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z";
                rt.mw = {
                    prefix: "fas",
                    iconName: Wn,
                    icon: [
                        512,
                        512,
                        Co,
                        Dl,
                        Ll
                    ]
                }, rt.w2 = rt.mw;
            },
            4011: (Qe, rt)=>{
                "use strict";
                var Wn = "circle-exclamation", Co = [
                    "exclamation-circle"
                ], Dl = "f06a", Ll = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z";
                rt.mw = {
                    prefix: "fas",
                    iconName: Wn,
                    icon: [
                        512,
                        512,
                        Co,
                        Dl,
                        Ll
                    ]
                }, rt.lE = rt.mw;
            },
            7516: (Qe, rt)=>{
                "use strict";
                Object.defineProperty(rt, "__esModule", {
                    value: !0
                });
                var Wn = "circle-info", Co = [
                    "info-circle"
                ], Dl = "f05a", Ll = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336l24 0 0-64-24 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 88 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z";
                rt.definition = {
                    prefix: "fas",
                    iconName: Wn,
                    icon: [
                        512,
                        512,
                        Co,
                        Dl,
                        Ll
                    ]
                }, rt.faCircleInfo = rt.definition, rt.prefix = "fas", rt.iconName = Wn, rt.width = 512, rt.height = 512, rt.ligatures = Co, rt.unicode = Dl, rt.svgPathData = Ll, rt.aliases = Co;
            },
            3444: (Qe, rt)=>{
                "use strict";
                var Wn = "circle-notch", Co = [], Dl = "f1ce", Ll = "M222.7 32.1c5 16.9-4.6 34.8-21.5 39.8C121.8 95.6 64 169.1 64 256c0 106 86 192 192 192s192-86 192-192c0-86.9-57.8-160.4-137.1-184.1c-16.9-5-26.6-22.9-21.5-39.8s22.9-26.6 39.8-21.5C434.9 42.1 512 140 512 256c0 141.4-114.6 256-256 256S0 397.4 0 256C0 140 77.1 42.1 182.9 10.6c16.9-5 34.8 4.6 39.8 21.5z";
                rt.mw = {
                    prefix: "fas",
                    iconName: Wn,
                    icon: [
                        512,
                        512,
                        Co,
                        Dl,
                        Ll
                    ]
                }, rt.s4 = rt.mw;
            },
            2975: (Qe, rt)=>{
                "use strict";
                var Wn = "comment-dots", Co = [
                    128172,
                    62075,
                    "commenting"
                ], Dl = "f4ad", Ll = "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0s0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM128 208a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z";
                rt.mw = {
                    prefix: "fas",
                    iconName: Wn,
                    icon: [
                        512,
                        512,
                        Co,
                        Dl,
                        Ll
                    ]
                }, rt.Be = rt.mw;
            },
            4189: (Qe, rt)=>{
                "use strict";
                var Wn = "copy", Co = [], Dl = "f0c5", Ll = "M208 0L332.1 0c12.7 0 24.9 5.1 33.9 14.1l67.9 67.9c9 9 14.1 21.2 14.1 33.9L448 336c0 26.5-21.5 48-48 48l-192 0c-26.5 0-48-21.5-48-48l0-288c0-26.5 21.5-48 48-48zM48 128l80 0 0 64-64 0 0 256 192 0 0-32 64 0 0 48c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 176c0-26.5 21.5-48 48-48z";
                rt.mw = {
                    prefix: "fas",
                    iconName: Wn,
                    icon: [
                        448,
                        512,
                        Co,
                        Dl,
                        Ll
                    ]
                }, rt.jP = rt.mw;
            },
            7518: (Qe, rt)=>{
                "use strict";
                var Wn = "draw-polygon", Co = [], Dl = "f5ee", Ll = "M96 151.4l0 209.1c9.7 5.6 17.8 13.7 23.4 23.4l209.1 0c0-.1 .1-.2 .1-.3l-4.5-7.9-32-56s0 0 0 0c-1.4 .1-2.8 .1-4.2 .1c-35.3 0-64-28.7-64-64s28.7-64 64-64c1.4 0 2.8 0 4.2 .1c0 0 0 0 0 0l32-56 4.5-7.9-.1-.3-209.1 0c-5.6 9.7-13.7 17.8-23.4 23.4zM384.3 352c35.2 .2 63.7 28.7 63.7 64c0 35.3-28.7 64-64 64c-23.7 0-44.4-12.9-55.4-32l-209.1 0c-11.1 19.1-31.7 32-55.4 32c-35.3 0-64-28.7-64-64c0-23.7 12.9-44.4 32-55.4l0-209.1C12.9 140.4 0 119.7 0 96C0 60.7 28.7 32 64 32c23.7 0 44.4 12.9 55.4 32l209.1 0c11.1-19.1 31.7-32 55.4-32c35.3 0 64 28.7 64 64c0 35.3-28.5 63.8-63.7 64l-4.5 7.9-32 56-2.3 4c4.2 8.5 6.5 18 6.5 28.1s-2.3 19.6-6.5 28.1l2.3 4 32 56 4.5 7.9z";
                rt.mw = {
                    prefix: "fas",
                    iconName: Wn,
                    icon: [
                        448,
                        512,
                        Co,
                        Dl,
                        Ll
                    ]
                }, rt.mS = rt.mw;
            },
            7172: (Qe, rt)=>{
                "use strict";
                var Wn = "earth-europe", Co = [
                    "globe-europe"
                ], Dl = "f7a2", Ll = "M266.3 48.3L232.5 73.6c-5.4 4-8.5 10.4-8.5 17.1l0 9.1c0 6.8 5.5 12.3 12.3 12.3c2.4 0 4.8-.7 6.8-2.1l41.8-27.9c2-1.3 4.4-2.1 6.8-2.1l1 0c6.2 0 11.3 5.1 11.3 11.3c0 3-1.2 5.9-3.3 8l-19.9 19.9c-5.8 5.8-12.9 10.2-20.7 12.8l-26.5 8.8c-5.8 1.9-9.6 7.3-9.6 13.4c0 3.7-1.5 7.3-4.1 10l-17.9 17.9c-6.4 6.4-9.9 15-9.9 24l0 4.3c0 16.4 13.6 29.7 29.9 29.7c11 0 21.2-6.2 26.1-16l4-8.1c2.4-4.8 7.4-7.9 12.8-7.9c4.5 0 8.7 2.1 11.4 5.7l16.3 21.7c2.1 2.9 5.5 4.5 9.1 4.5c8.4 0 13.9-8.9 10.1-16.4l-1.1-2.3c-3.5-7 0-15.5 7.5-18l21.2-7.1c7.6-2.5 12.7-9.6 12.7-17.6c0-10.3 8.3-18.6 18.6-18.6l29.4 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-20.7 0c-7.2 0-14.2 2.9-19.3 8l-4.7 4.7c-2.1 2.1-3.3 5-3.3 8c0 6.2 5.1 11.3 11.3 11.3l11.3 0c6 0 11.8 2.4 16 6.6l6.5 6.5c1.8 1.8 2.8 4.3 2.8 6.8s-1 5-2.8 6.8l-7.5 7.5C386 262 384 266.9 384 272s2 10 5.7 13.7L408 304c10.2 10.2 24.1 16 38.6 16l7.3 0c6.5-20.2 10-41.7 10-64c0-111.4-87.6-202.4-197.7-207.7zm172 307.9c-3.7-2.6-8.2-4.1-13-4.1c-6 0-11.8-2.4-16-6.6L396 332c-7.7-7.7-18-12-28.9-12c-9.7 0-19.2-3.5-26.6-9.8L314 287.4c-11.6-9.9-26.4-15.4-41.7-15.4l-20.9 0c-12.6 0-25 3.7-35.5 10.7L188.5 301c-17.8 11.9-28.5 31.9-28.5 53.3l0 3.2c0 17 6.7 33.3 18.7 45.3l16 16c8.5 8.5 20 13.3 32 13.3l21.3 0c13.3 0 24 10.7 24 24c0 2.5 .4 5 1.1 7.3c71.3-5.8 132.5-47.6 165.2-107.2zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM187.3 100.7c-6.2-6.2-16.4-6.2-22.6 0l-32 32c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l32-32c6.2-6.2 6.2-16.4 0-22.6z";
                rt.mw = {
                    prefix: "fas",
                    iconName: Wn,
                    icon: [
                        512,
                        512,
                        Co,
                        Dl,
                        Ll
                    ]
                }, rt.YS = rt.mw;
            },
            3613: (Qe, rt, Wn)=>{
                "use strict";
                var Co = Wn(6533);
                rt.mw = {
                    prefix: Co.prefix,
                    iconName: Co.iconName,
                    icon: [
                        Co.width,
                        Co.height,
                        Co.aliases,
                        Co.unicode,
                        Co.svgPathData
                    ]
                }, rt.v = rt.mw, Co.prefix, Co.iconName, Co.width, Co.height, Co.aliases, Co.unicode, Co.svgPathData, Co.aliases;
            },
            6533: (Qe, rt)=>{
                "use strict";
                Object.defineProperty(rt, "__esModule", {
                    value: !0
                });
                var Wn = "ellipsis-vertical", Co = [
                    "ellipsis-v"
                ], Dl = "f142", Ll = "M64 360a56 56 0 1 0 0 112 56 56 0 1 0 0-112zm0-160a56 56 0 1 0 0 112 56 56 0 1 0 0-112zM120 96A56 56 0 1 0 8 96a56 56 0 1 0 112 0z";
                rt.definition = {
                    prefix: "fas",
                    iconName: Wn,
                    icon: [
                        128,
                        512,
                        Co,
                        Dl,
                        Ll
                    ]
                }, rt.faEllipsisVertical = rt.definition, rt.prefix = "fas", rt.iconName = Wn, rt.width = 128, rt.height = 512, rt.ligatures = Co, rt.unicode = Dl, rt.svgPathData = Ll, rt.aliases = Co;
            },
            7704: (Qe, rt, Wn)=>{
                "use strict";
                var Co = Wn(7144);
                rt.mw = {
                    prefix: Co.prefix,
                    iconName: Co.iconName,
                    icon: [
                        Co.width,
                        Co.height,
                        Co.aliases,
                        Co.unicode,
                        Co.svgPathData
                    ]
                }, rt.A = rt.mw, Co.prefix, Co.iconName, Co.width, Co.height, Co.aliases, Co.unicode, Co.svgPathData, Co.aliases;
            },
            5431: (Qe, rt)=>{
                "use strict";
                var Wn = "forward", Co = [
                    9193
                ], Dl = "f04e", Ll = "M52.5 440.6c-9.5 7.9-22.8 9.7-34.1 4.4S0 428.4 0 416L0 96C0 83.6 7.2 72.3 18.4 67s24.5-3.6 34.1 4.4L224 214.3l0 41.7 0 41.7L52.5 440.6zM256 352l0-96 0-128 0-32c0-12.4 7.2-23.7 18.4-29s24.5-3.6 34.1 4.4l192 160c7.3 6.1 11.5 15.1 11.5 24.6s-4.2 18.5-11.5 24.6l-192 160c-9.5 7.9-22.8 9.7-34.1 4.4s-18.4-16.6-18.4-29l0-64z";
                rt.mw = {
                    prefix: "fas",
                    iconName: Wn,
                    icon: [
                        512,
                        512,
                        Co,
                        Dl,
                        Ll
                    ]
                }, rt.vF = rt.mw;
            },
            5279: (Qe, rt)=>{
                "use strict";
                var Wn = "image", Co = [], Dl = "f03e", Ll = "M0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM323.8 202.5c-4.5-6.6-11.9-10.5-19.8-10.5s-15.4 3.9-19.8 10.5l-87 127.6L170.7 297c-4.6-5.7-11.5-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6l96 0 32 0 208 0c8.9 0 17.1-4.9 21.2-12.8s3.6-17.4-1.4-24.7l-120-176zM112 192a48 48 0 1 0 0-96 48 48 0 1 0 0 96z";
                rt.mw = {
                    prefix: "fas",
                    iconName: Wn,
                    icon: [
                        512,
                        512,
                        Co,
                        Dl,
                        Ll
                    ]
                }, rt.jb = rt.mw;
            },
            4954: (Qe, rt)=>{
                "use strict";
                var Wn = "images", Co = [], Dl = "f302", Ll = "M160 32c-35.3 0-64 28.7-64 64l0 224c0 35.3 28.7 64 64 64l352 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64L160 32zM396 138.7l96 144c4.9 7.4 5.4 16.8 1.2 24.6S480.9 320 472 320l-144 0-48 0-80 0c-9.2 0-17.6-5.3-21.6-13.6s-2.9-18.2 2.9-25.4l64-80c4.6-5.7 11.4-9 18.7-9s14.2 3.3 18.7 9l17.3 21.6 56-84C360.5 132 368 128 376 128s15.5 4 20 10.7zM192 128a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120L0 344c0 75.1 60.9 136 136 136l320 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-320 0c-48.6 0-88-39.4-88-88l0-224z";
                rt.mw = {
                    prefix: "fas",
                    iconName: Wn,
                    icon: [
                        576,
                        512,
                        Co,
                        Dl,
                        Ll
                    ]
                }, rt.yv = rt.mw;
            },
            6668: (Qe, rt, Wn)=>{
                "use strict";
                var Co = Wn(7516);
                rt.mw = {
                    prefix: Co.prefix,
                    iconName: Co.iconName,
                    icon: [
                        Co.width,
                        Co.height,
                        Co.aliases,
                        Co.unicode,
                        Co.svgPathData
                    ]
                }, rt.iW = rt.mw, Co.prefix, Co.iconName, Co.width, Co.height, Co.aliases, Co.unicode, Co.svgPathData, Co.aliases;
            },
            4220: (Qe, rt)=>{
                "use strict";
                var Wn = "layer-group", Co = [], Dl = "f5fd", Ll = "M264.5 5.2c14.9-6.9 32.1-6.9 47 0l218.6 101c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0L45.9 149.8C37.4 145.8 32 137.3 32 128s5.4-17.9 13.9-21.8L264.5 5.2zM476.9 209.6l53.2 24.6c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0L45.9 277.8C37.4 273.8 32 265.3 32 256s5.4-17.9 13.9-21.8l53.2-24.6 152 70.2c23.4 10.8 50.4 10.8 73.8 0l152-70.2zm-152 198.2l152-70.2 53.2 24.6c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0L45.9 405.8C37.4 401.8 32 393.3 32 384s5.4-17.9 13.9-21.8l53.2-24.6 152 70.2c23.4 10.8 50.4 10.8 73.8 0z";
                rt.mw = {
                    prefix: "fas",
                    iconName: Wn,
                    icon: [
                        576,
                        512,
                        Co,
                        Dl,
                        Ll
                    ]
                }, rt.qI = rt.mw;
            },
            325: (Qe, rt)=>{
                "use strict";
                var Wn = "lightbulb", Co = [
                    128161
                ], Dl = "f0eb", Ll = "M272 384c9.6-31.9 29.5-59.1 49.2-86.2c0 0 0 0 0 0c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C368 78.8 289.2 0 192 0S16 78.8 16 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4c0 0 0 0 0 0c19.8 27.1 39.7 54.4 49.2 86.2l160 0zM192 512c44.2 0 80-35.8 80-80l0-16-160 0 0 16c0 44.2 35.8 80 80 80zM112 176c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-61.9 50.1-112 112-112c8.8 0 16 7.2 16 16s-7.2 16-16 16c-44.2 0-80 35.8-80 80z";
                rt.mw = {
                    prefix: "fas",
                    iconName: Wn,
                    icon: [
                        384,
                        512,
                        Co,
                        Dl,
                        Ll
                    ]
                }, rt.rC = rt.mw;
            },
            7964: (Qe, rt)=>{
                "use strict";
                var Wn = "link", Co = [
                    128279,
                    "chain"
                ], Dl = "f0c1", Ll = "M579.8 267.7c56.5-56.5 56.5-148 0-204.5c-50-50-128.8-56.5-186.3-15.4l-1.6 1.1c-14.4 10.3-17.7 30.3-7.4 44.6s30.3 17.7 44.6 7.4l1.6-1.1c32.1-22.9 76-19.3 103.8 8.6c31.5 31.5 31.5 82.5 0 114L422.3 334.8c-31.5 31.5-82.5 31.5-114 0c-27.9-27.9-31.5-71.8-8.6-103.8l1.1-1.6c10.3-14.4 6.9-34.4-7.4-44.6s-34.4-6.9-44.6 7.4l-1.1 1.6C206.5 251.2 213 330 263 380c56.5 56.5 148 56.5 204.5 0L579.8 267.7zM60.2 244.3c-56.5 56.5-56.5 148 0 204.5c50 50 128.8 56.5 186.3 15.4l1.6-1.1c14.4-10.3 17.7-30.3 7.4-44.6s-30.3-17.7-44.6-7.4l-1.6 1.1c-32.1 22.9-76 19.3-103.8-8.6C74 372 74 321 105.5 289.5L217.7 177.2c31.5-31.5 82.5-31.5 114 0c27.9 27.9 31.5 71.8 8.6 103.9l-1.1 1.6c-10.3 14.4-6.9 34.4 7.4 44.6s34.4 6.9 44.6-7.4l1.1-1.6C433.5 260.8 427 182 377 132c-56.5-56.5-148-56.5-204.5 0L60.2 244.3z";
                rt.mw = {
                    prefix: "fas",
                    iconName: Wn,
                    icon: [
                        640,
                        512,
                        Co,
                        Dl,
                        Ll
                    ]
                }, rt.CQ = rt.mw;
            },
            3520: (Qe, rt)=>{
                "use strict";
                var Wn = "location-dot", Co = [
                    "map-marker-alt"
                ], Dl = "f3c5", Ll = "M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z";
                rt.mw = {
                    prefix: "fas",
                    iconName: Wn,
                    icon: [
                        384,
                        512,
                        Co,
                        Dl,
                        Ll
                    ]
                }, rt.gK = rt.mw;
            },
            7761: (Qe, rt)=>{
                "use strict";
                var Wn = "magnifying-glass", Co = [
                    128269,
                    "search"
                ], Dl = "f002", Ll = "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z";
                rt.mw = {
                    prefix: "fas",
                    iconName: Wn,
                    icon: [
                        512,
                        512,
                        Co,
                        Dl,
                        Ll
                    ]
                }, rt.$U = rt.mw;
            },
            2e3: (Qe, rt)=>{
                "use strict";
                var Wn = [
                    128506,
                    62072
                ], Co = "f279", Dl = "M384 476.1L192 421.2l0-385.3L384 90.8l0 385.3zm32-1.2l0-386.5L543.1 37.5c15.8-6.3 32.9 5.3 32.9 22.3l0 334.8c0 9.8-6 18.6-15.1 22.3L416 474.8zM15.1 95.1L160 37.2l0 386.5L32.9 474.5C17.1 480.8 0 469.2 0 452.2L0 117.4c0-9.8 6-18.6 15.1-22.3z";
                rt.mw = {
                    prefix: "fas",
                    iconName: "map",
                    icon: [
                        576,
                        512,
                        Wn,
                        Co,
                        Dl
                    ]
                }, rt.e5 = rt.mw;
            },
            3233: (Qe, rt)=>{
                "use strict";
                var Wn = "medal", Co = [
                    127941
                ], Dl = "f5a2", Ll = "M4.1 38.2C1.4 34.2 0 29.4 0 24.6C0 11 11 0 24.6 0L133.9 0c11.2 0 21.7 5.9 27.4 15.5l68.5 114.1c-48.2 6.1-91.3 28.6-123.4 61.9L4.1 38.2zm503.7 0L405.6 191.5c-32.1-33.3-75.2-55.8-123.4-61.9L350.7 15.5C356.5 5.9 366.9 0 378.1 0L487.4 0C501 0 512 11 512 24.6c0 4.8-1.4 9.6-4.1 13.6zM80 336a176 176 0 1 1 352 0A176 176 0 1 1 80 336zm184.4-94.9c-3.4-7-13.3-7-16.8 0l-22.4 45.4c-1.4 2.8-4 4.7-7 5.1L168 298.9c-7.7 1.1-10.7 10.5-5.2 16l36.3 35.4c2.2 2.2 3.2 5.2 2.7 8.3l-8.6 49.9c-1.3 7.6 6.7 13.5 13.6 9.9l44.8-23.6c2.7-1.4 6-1.4 8.7 0l44.8 23.6c6.9 3.6 14.9-2.2 13.6-9.9l-8.6-49.9c-.5-3 .5-6.1 2.7-8.3l36.3-35.4c5.6-5.4 2.5-14.8-5.2-16l-50.1-7.3c-3-.4-5.7-2.4-7-5.1l-22.4-45.4z";
                rt.mw = {
                    prefix: "fas",
                    iconName: Wn,
                    icon: [
                        512,
                        512,
                        Co,
                        Dl,
                        Ll
                    ]
                }, rt.B9 = rt.mw;
            },
            7290: (Qe, rt)=>{
                "use strict";
                var Wn = "minus", Co = [
                    8211,
                    8722,
                    10134,
                    "subtract"
                ], Dl = "f068", Ll = "M432 256c0 17.7-14.3 32-32 32L48 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l352 0c17.7 0 32 14.3 32 32z";
                rt.mw = {
                    prefix: "fas",
                    iconName: Wn,
                    icon: [
                        448,
                        512,
                        Co,
                        Dl,
                        Ll
                    ]
                }, rt.EZ = rt.mw;
            },
            8629: (Qe, rt)=>{
                "use strict";
                var Wn = "palette", Co = [
                    127912
                ], Dl = "f53f", Ll = "M512 256c0 .9 0 1.8 0 2.7c-.4 36.5-33.6 61.3-70.1 61.3L344 320c-26.5 0-48 21.5-48 48c0 3.4 .4 6.7 1 9.9c2.1 10.2 6.5 20 10.8 29.9c6.1 13.8 12.1 27.5 12.1 42c0 31.8-21.6 60.7-53.4 62c-3.5 .1-7 .2-10.6 .2C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256zM128 288a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0-96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM288 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm96 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64z";
                rt.mw = {
                    prefix: "fas",
                    iconName: Wn,
                    icon: [
                        512,
                        512,
                        Co,
                        Dl,
                        Ll
                    ]
                }, rt.fy = rt.mw;
            },
            9683: (Qe, rt)=>{
                "use strict";
                var Wn = "panorama", Co = [], Dl = "e209", Ll = "M45.6 32C20.4 32 0 52.4 0 77.6L0 434.4C0 459.6 20.4 480 45.6 480c5.1 0 10-.8 14.7-2.4C74.6 472.8 177.6 440 320 440s245.4 32.8 259.6 37.6c4.7 1.6 9.7 2.4 14.7 2.4c25.2 0 45.6-20.4 45.6-45.6l0-356.7C640 52.4 619.6 32 594.4 32c-5 0-10 .8-14.7 2.4C565.4 39.2 462.4 72 320 72S74.6 39.2 60.4 34.4C55.6 32.8 50.7 32 45.6 32zM96 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm272 0c7.9 0 15.4 3.9 19.8 10.5L512.3 353c5.4 8 5.6 18.4 .4 26.5s-14.7 12.3-24.2 10.7C442.7 382.4 385.2 376 320 376c-65.6 0-123.4 6.5-169.3 14.4c-9.8 1.7-19.7-2.9-24.7-11.5s-4.3-19.4 1.9-27.2L197.3 265c4.6-5.7 11.4-9 18.7-9s14.2 3.3 18.7 9l26.4 33.1 87-127.6c4.5-6.6 11.9-10.5 19.8-10.5z";
                rt.mw = {
                    prefix: "fas",
                    iconName: Wn,
                    icon: [
                        640,
                        512,
                        Co,
                        Dl,
                        Ll
                    ]
                }, rt.pt = rt.mw;
            },
            1708: (Qe, rt)=>{
                "use strict";
                var Wn = "paper-plane", Co = [
                    61913
                ], Dl = "f1d8", Ll = "M498.1 5.6c10.1 7 15.4 19.1 13.5 31.2l-64 416c-1.5 9.7-7.4 18.2-16 23s-18.9 5.4-28 1.6L284 427.7l-68.5 74.1c-8.9 9.7-22.9 12.9-35.2 8.1S160 493.2 160 480l0-83.6c0-4 1.5-7.8 4.2-10.8L331.8 202.8c5.8-6.3 5.6-16-.4-22s-15.7-6.4-22-.7L106 360.8 17.7 316.6C7.1 311.3 .3 300.7 0 288.9s5.9-22.8 16.1-28.7l448-256c10.7-6.1 23.9-5.5 34 1.4z";
                rt.mw = {
                    prefix: "fas",
                    iconName: Wn,
                    icon: [
                        512,
                        512,
                        Co,
                        Dl,
                        Ll
                    ]
                }, rt.is = rt.mw;
            },
            7472: (Qe, rt)=>{
                "use strict";
                var Wn = "pause", Co = [
                    9208
                ], Dl = "f04c", Ll = "M48 64C21.5 64 0 85.5 0 112L0 400c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-288c0-26.5-21.5-48-48-48L48 64zm192 0c-26.5 0-48 21.5-48 48l0 288c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-288c0-26.5-21.5-48-48-48l-32 0z";
                rt.mw = {
                    prefix: "fas",
                    iconName: Wn,
                    icon: [
                        320,
                        512,
                        Co,
                        Dl,
                        Ll
                    ]
                }, rt.G1 = rt.mw;
            },
            9243: (Qe, rt)=>{
                "use strict";
                var Wn = "person-biking", Co = [
                    128692,
                    "biking"
                ], Dl = "f84a", Ll = "M400 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm27.2 64l-61.8-48.8c-17.3-13.6-41.7-13.8-59.1-.3l-83.1 64.2c-30.7 23.8-28.5 70.8 4.3 91.6L288 305.1 288 416c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128c0-10.7-5.3-20.7-14.2-26.6L295 232.9l60.3-48.5L396 217c5.7 4.5 12.7 7 20 7l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-52.8 0zM56 384a72 72 0 1 1 144 0A72 72 0 1 1 56 384zm200 0A128 128 0 1 0 0 384a128 128 0 1 0 256 0zm184 0a72 72 0 1 1 144 0 72 72 0 1 1 -144 0zm200 0a128 128 0 1 0 -256 0 128 128 0 1 0 256 0z";
                rt.mw = {
                    prefix: "fas",
                    iconName: Wn,
                    icon: [
                        640,
                        512,
                        Co,
                        Dl,
                        Ll
                    ]
                }, rt.rO = rt.mw;
            },
            6386: (Qe, rt)=>{
                "use strict";
                var Wn = "play", Co = [
                    9654
                ], Dl = "f04b", Ll = "M73 39c-14.8-9.1-33.4-9.4-48.5-.9S0 62.6 0 80L0 432c0 17.4 9.4 33.4 24.5 41.9s33.7 8.1 48.5-.9L361 297c14.3-8.7 23-24.2 23-41s-8.7-32.2-23-41L73 39z";
                rt.mw = {
                    prefix: "fas",
                    iconName: Wn,
                    icon: [
                        384,
                        512,
                        Co,
                        Dl,
                        Ll
                    ]
                }, rt.ij = rt.mw;
            },
            1372: (Qe, rt)=>{
                "use strict";
                var Wn = "plus", Co = [
                    10133,
                    61543,
                    "add"
                ], Dl = "M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 144L48 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0 0 144c0 17.7 14.3 32 32 32s32-14.3 32-32l0-144 144 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-144 0 0-144z";
                rt.mw = {
                    prefix: "fas",
                    iconName: Wn,
                    icon: [
                        448,
                        512,
                        Co,
                        "2b",
                        Dl
                    ]
                }, rt.QL = rt.mw;
            },
            5124: (Qe, rt)=>{
                "use strict";
                var Wn = "question", Co = [
                    10067,
                    10068,
                    61736
                ], Dl = "M80 160c0-35.3 28.7-64 64-64l32 0c35.3 0 64 28.7 64 64l0 3.6c0 21.8-11.1 42.1-29.4 53.8l-42.2 27.1c-25.2 16.2-40.4 44.1-40.4 74l0 1.4c0 17.7 14.3 32 32 32s32-14.3 32-32l0-1.4c0-8.2 4.2-15.8 11-20.2l42.2-27.1c36.6-23.6 58.8-64.1 58.8-107.7l0-3.6c0-70.7-57.3-128-128-128l-32 0C73.3 32 16 89.3 16 160c0 17.7 14.3 32 32 32s32-14.3 32-32zm80 320a40 40 0 1 0 0-80 40 40 0 1 0 0 80z";
                rt.mw = {
                    prefix: "fas",
                    iconName: Wn,
                    icon: [
                        320,
                        512,
                        Co,
                        "3f",
                        Dl
                    ]
                }, rt.Ev = rt.mw;
            },
            7744: (Qe, rt)=>{
                "use strict";
                var Wn = "rocket", Co = [], Dl = "f135", Ll = "M156.6 384.9L125.7 354c-8.5-8.5-11.5-20.8-7.7-32.2c3-8.9 7-20.5 11.8-33.8L24 288c-8.6 0-16.6-4.6-20.9-12.1s-4.2-16.7 .2-24.1l52.5-88.5c13-21.9 36.5-35.3 61.9-35.3l82.3 0c2.4-4 4.8-7.7 7.2-11.3C289.1-4.1 411.1-8.1 483.9 5.3c11.6 2.1 20.6 11.2 22.8 22.8c13.4 72.9 9.3 194.8-111.4 276.7c-3.5 2.4-7.3 4.8-11.3 7.2l0 82.3c0 25.4-13.4 49-35.3 61.9l-88.5 52.5c-7.4 4.4-16.6 4.5-24.1 .2s-12.1-12.2-12.1-20.9l0-107.2c-14.1 4.9-26.4 8.9-35.7 11.9c-11.2 3.6-23.4 .5-31.8-7.8zM384 168a40 40 0 1 0 0-80 40 40 0 1 0 0 80z";
                rt.mw = {
                    prefix: "fas",
                    iconName: Wn,
                    icon: [
                        512,
                        512,
                        Co,
                        Dl,
                        Ll
                    ]
                }, rt.KM = rt.mw;
            },
            6787: (Qe, rt)=>{
                "use strict";
                var Wn = "satellite-dish", Co = [
                    128225
                ], Dl = "f7c0", Ll = "M192 32c0-17.7 14.3-32 32-32C383.1 0 512 128.9 512 288c0 17.7-14.3 32-32 32s-32-14.3-32-32C448 164.3 347.7 64 224 64c-17.7 0-32-14.3-32-32zM60.6 220.6L164.7 324.7l28.4-28.4c-.7-2.6-1.1-5.4-1.1-8.3c0-17.7 14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32c-2.9 0-5.6-.4-8.3-1.1l-28.4 28.4L291.4 451.4c14.5 14.5 11.8 38.8-7.3 46.3C260.5 506.9 234.9 512 208 512C93.1 512 0 418.9 0 304c0-26.9 5.1-52.5 14.4-76.1c7.5-19 31.8-21.8 46.3-7.3zM224 96c106 0 192 86 192 192c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-70.7-57.3-128-128-128c-17.7 0-32-14.3-32-32s14.3-32 32-32z";
                rt.mw = {
                    prefix: "fas",
                    iconName: Wn,
                    icon: [
                        512,
                        512,
                        Co,
                        Dl,
                        Ll
                    ]
                }, rt.hU = rt.mw;
            },
            2077: (Qe, rt)=>{
                "use strict";
                var Wn = "scroll", Co = [
                    128220
                ], Dl = "f70e", Ll = "M0 80l0 48c0 17.7 14.3 32 32 32l16 0 48 0 0-80c0-26.5-21.5-48-48-48S0 53.5 0 80zM112 32c10 13.4 16 30 16 48l0 304c0 35.3 28.7 64 64 64s64-28.7 64-64l0-5.3c0-32.4 26.3-58.7 58.7-58.7L480 320l0-192c0-53-43-96-96-96L112 32zM464 480c61.9 0 112-50.1 112-112c0-8.8-7.2-16-16-16l-245.3 0c-14.7 0-26.7 11.9-26.7 26.7l0 5.3c0 53-43 96-96 96l176 0 96 0z";
                rt.mw = {
                    prefix: "fas",
                    iconName: Wn,
                    icon: [
                        576,
                        512,
                        Co,
                        Dl,
                        Ll
                    ]
                }, rt.DD = rt.mw;
            },
            6002: (Qe, rt, Wn)=>{
                "use strict";
                var Co = Wn(1260);
                rt.mw = {
                    prefix: Co.prefix,
                    iconName: Co.iconName,
                    icon: [
                        Co.width,
                        Co.height,
                        Co.aliases,
                        Co.unicode,
                        Co.svgPathData
                    ]
                }, rt.QO = rt.mw, Co.prefix, Co.iconName, Co.width, Co.height, Co.aliases, Co.unicode, Co.svgPathData, Co.aliases;
            },
            1260: (Qe, rt)=>{
                "use strict";
                Object.defineProperty(rt, "__esModule", {
                    value: !0
                });
                var Wn = "share-nodes", Co = [
                    "share-alt"
                ], Dl = "f1e0", Ll = "M352 224c53 0 96-43 96-96s-43-96-96-96s-96 43-96 96c0 4 .2 8 .7 11.9l-94.1 47C145.4 170.2 121.9 160 96 160c-53 0-96 43-96 96s43 96 96 96c25.9 0 49.4-10.2 66.6-26.9l94.1 47c-.5 3.9-.7 7.8-.7 11.9c0 53 43 96 96 96s96-43 96-96s-43-96-96-96c-25.9 0-49.4 10.2-66.6 26.9l-94.1-47c.5-3.9 .7-7.8 .7-11.9s-.2-8-.7-11.9l94.1-47C302.6 213.8 326.1 224 352 224z";
                rt.definition = {
                    prefix: "fas",
                    iconName: Wn,
                    icon: [
                        448,
                        512,
                        Co,
                        Dl,
                        Ll
                    ]
                }, rt.faShareNodes = rt.definition, rt.prefix = "fas", rt.iconName = Wn, rt.width = 448, rt.height = 512, rt.ligatures = Co, rt.unicode = Dl, rt.svgPathData = Ll, rt.aliases = Co;
            },
            1904: (Qe, rt)=>{
                "use strict";
                var Wn = "sliders", Co = [
                    "sliders-h"
                ], Dl = "f1de", Ll = "M0 416c0 17.7 14.3 32 32 32l54.7 0c12.3 28.3 40.5 48 73.3 48s61-19.7 73.3-48L480 448c17.7 0 32-14.3 32-32s-14.3-32-32-32l-246.7 0c-12.3-28.3-40.5-48-73.3-48s-61 19.7-73.3 48L32 384c-17.7 0-32 14.3-32 32zm128 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM320 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32-80c-32.8 0-61 19.7-73.3 48L32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l246.7 0c12.3 28.3 40.5 48 73.3 48s61-19.7 73.3-48l54.7 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-54.7 0c-12.3-28.3-40.5-48-73.3-48zM192 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm73.3-64C253 35.7 224.8 16 192 16s-61 19.7-73.3 48L32 64C14.3 64 0 78.3 0 96s14.3 32 32 32l86.7 0c12.3 28.3 40.5 48 73.3 48s61-19.7 73.3-48L480 128c17.7 0 32-14.3 32-32s-14.3-32-32-32L265.3 64z";
                rt.mw = {
                    prefix: "fas",
                    iconName: Wn,
                    icon: [
                        512,
                        512,
                        Co,
                        Dl,
                        Ll
                    ]
                }, rt._$ = rt.mw;
            },
            4780: (Qe, rt)=>{
                "use strict";
                var Wn = "star", Co = [
                    11088,
                    61446
                ], Dl = "f005", Ll = "M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z";
                rt.mw = {
                    prefix: "fas",
                    iconName: Wn,
                    icon: [
                        576,
                        512,
                        Co,
                        Dl,
                        Ll
                    ]
                }, rt.yy = rt.mw;
            },
            6249: (Qe, rt)=>{
                "use strict";
                var Wn = "tags", Co = [], Dl = "f02c", Ll = "M345 39.1L472.8 168.4c52.4 53 52.4 138.2 0 191.2L360.8 472.9c-9.3 9.4-24.5 9.5-33.9 .2s-9.5-24.5-.2-33.9L438.6 325.9c33.9-34.3 33.9-89.4 0-123.7L310.9 72.9c-9.3-9.4-9.2-24.6 .2-33.9s24.6-9.2 33.9 .2zM0 229.5L0 80C0 53.5 21.5 32 48 32l149.5 0c17 0 33.3 6.7 45.3 18.7l168 168c25 25 25 65.5 0 90.5L277.3 442.7c-25 25-65.5 25-90.5 0l-168-168C6.7 262.7 0 246.5 0 229.5zM144 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z";
                rt.mw = {
                    prefix: "fas",
                    iconName: Wn,
                    icon: [
                        512,
                        512,
                        Co,
                        Dl,
                        Ll
                    ]
                }, rt.DX = rt.mw;
            },
            6311: (Qe, rt)=>{
                "use strict";
                var Wn = "triangle-exclamation", Co = [
                    9888,
                    "exclamation-triangle",
                    "warning"
                ], Dl = "f071", Ll = "M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480L40 480c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z";
                rt.mw = {
                    prefix: "fas",
                    iconName: Wn,
                    icon: [
                        512,
                        512,
                        Co,
                        Dl,
                        Ll
                    ]
                }, rt.JA = rt.mw;
            },
            7144: (Qe, rt)=>{
                "use strict";
                Object.defineProperty(rt, "__esModule", {
                    value: !0
                });
                var Wn = "up-right-from-square", Co = [
                    "external-link-alt"
                ], Dl = "f35d", Ll = "M352 0c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9L370.7 96 201.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L416 141.3l41.4 41.4c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6l0-128c0-17.7-14.3-32-32-32L352 0zM80 32C35.8 32 0 67.8 0 112L0 432c0 44.2 35.8 80 80 80l320 0c44.2 0 80-35.8 80-80l0-112c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 112c0 8.8-7.2 16-16 16L80 448c-8.8 0-16-7.2-16-16l0-320c0-8.8 7.2-16 16-16l112 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L80 32z";
                rt.definition = {
                    prefix: "fas",
                    iconName: Wn,
                    icon: [
                        512,
                        512,
                        Co,
                        Dl,
                        Ll
                    ]
                }, rt.faUpRightFromSquare = rt.definition, rt.prefix = "fas", rt.iconName = Wn, rt.width = 512, rt.height = 512, rt.ligatures = Co, rt.unicode = Dl, rt.svgPathData = Ll, rt.aliases = Co;
            },
            7879: (Qe, rt)=>{
                "use strict";
                var Wn = "user", Co = [
                    128100,
                    62144
                ], Dl = "f007", Ll = "M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512l388.6 0c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304l-91.4 0z";
                rt.mw = {
                    prefix: "fas",
                    iconName: Wn,
                    icon: [
                        448,
                        512,
                        Co,
                        Dl,
                        Ll
                    ]
                }, rt.X4 = rt.mw;
            },
            6627: (Qe, rt)=>{
                "use strict";
                var Wn = "xmark", Co = [
                    128473,
                    10005,
                    10006,
                    10060,
                    215,
                    "close",
                    "multiply",
                    "remove",
                    "times"
                ], Dl = "f00d", Ll = "M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z";
                rt.mw = {
                    prefix: "fas",
                    iconName: Wn,
                    icon: [
                        384,
                        512,
                        Co,
                        Dl,
                        Ll
                    ]
                }, rt.Jy = rt.mw;
            },
            1545: (Qe, rt, Wn)=>{
                "use strict";
                Wn.d(rt, {
                    AZ: ()=>ld,
                    GR: ()=>Up,
                    IJ: ()=>Fp,
                    Np: ()=>Hp,
                    Qw: ()=>Bp,
                    S: ()=>registerButton,
                    TL: ()=>om,
                    Wp: ()=>Tu,
                    aH: ()=>Rl,
                    e6: ()=>Lu,
                    jM: ()=>Fm,
                    rx: ()=>cd,
                    uj: ()=>Gp,
                    zY: ()=>lm
                });
                var Co = Wn(9435), Dl = Wn(9408), Ll = Object.defineProperty, __export = (Qe, rt)=>{
                    for(var Wn in rt)Ll(Qe, Wn, {
                        get: rt[Wn],
                        enumerable: !0
                    });
                }, Rl = {};
                __export(Rl, {
                    ACTIONS: ()=>lu,
                    ANIMATION_MIN_DURATION: ()=>Gl,
                    CAPTURE_EVENTS_CLASS: ()=>tu,
                    CTRLZOOM_TIMEOUT: ()=>Kl,
                    DBLCLICK_DELAY: ()=>Hl,
                    EASINGS: ()=>Eu,
                    ICONS: ()=>yu,
                    IDS: ()=>du,
                    KEY_CODES: ()=>fu,
                    LONGTOUCH_DELAY: ()=>ql,
                    MOVE_THRESHOLD: ()=>Zl,
                    SPHERE_RADIUS: ()=>$l,
                    TWOFINGERSOVERLAY_DELAY: ()=>Ql,
                    VIEWER_DATA: ()=>Tc
                });
                var Ul, Gl = 500, Zl = 4, Hl = 300, ql = 500, Ql = 100, Kl = 2e3, $l = 10, Tc = "photoSphereViewer", tu = "psv--capture-event", lu = ((Qe)=>(Qe.ROTATE_UP = "ROTATE_UP", Qe.ROTATE_DOWN = "ROTATE_DOWN", Qe.ROTATE_RIGHT = "ROTATE_RIGHT", Qe.ROTATE_LEFT = "ROTATE_LEFT", Qe.ZOOM_IN = "ZOOM_IN", Qe.ZOOM_OUT = "ZOOM_OUT", Qe))(lu || {}), du = {
                    MENU: "menu",
                    TWO_FINGERS: "twoFingers",
                    CTRL_ZOOM: "ctrlZoom",
                    ERROR: "error",
                    DESCRIPTION: "description"
                }, fu = {
                    Enter: "Enter",
                    Control: "Control",
                    Escape: "Escape",
                    Space: " ",
                    PageUp: "PageUp",
                    PageDown: "PageDown",
                    ArrowLeft: "ArrowLeft",
                    ArrowUp: "ArrowUp",
                    ArrowRight: "ArrowRight",
                    ArrowDown: "ArrowDown",
                    Delete: "Delete",
                    Plus: "+",
                    Minus: "-"
                }, yu = {
                    arrow: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="40 40 432 432"><g transform="rotate(0, 256, 256)"><path fill="currentColor" d="M425.23 210.55H227.39a5 5 0 01-3.53-8.53l56.56-56.57a45.5 45.5 0 000-64.28 45.15 45.15 0 00-32.13-13.3 45.15 45.15 0 00-32.14 13.3L41.32 256l174.83 174.83a45.15 45.15 0 0032.14 13.3 45.15 45.15 0 0032.13-13.3 45.5 45.5 0 000-64.28l-56.57-56.57a5 5 0 013.54-8.53h197.84c25.06 0 45.45-20.39 45.45-45.45s-20.4-45.45-45.45-45.45z"/></g><!-- Created by Flatart from the Noun Project --></svg>\n',
                    close: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g fill="currentColor" transform=" translate(50, 50) rotate(45)"><rect x="-5" y="-65" width="10" height="130"/><rect x="-65" y="-5" width="130" height="10"/></g></svg>',
                    download: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><path fill="currentColor" d="M83.3 35.6h-17V3H32.2v32.6H16.6l33.6 32.7 33-32.7z"/><path fill="currentColor" d="M83.3 64.2v16.3H16.6V64.2H-.1v32.6H100V64.2H83.3z"/><!--Created by Michael Zenaty from the Noun Project--></svg>\n',
                    fullscreenIn: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><path fill="currentColor" d="M100 40H87.1V18.8h-21V6H100zM100 93.2H66V80.3h21.1v-21H100zM34 93.2H0v-34h12.9v21.1h21zM12.9 40H0V6h34v12.9H12.8z"/><!--Created by Garrett Knoll from the Noun Project--></svg>\n',
                    fullscreenOut: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><path fill="currentColor" d="M66 7h13v21h21v13H66zM66 60.3h34v12.9H79v21H66zM0 60.3h34v34H21V73.1H0zM21 7h13v34H0V28h21z"/><!--Created by Garrett Knoll from the Noun Project--></svg>\n',
                    info: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path fill="currentColor" d="M28.3 26.1c-1 2.6-1.9 4.8-2.6 7-2.5 7.4-5 14.7-7.2 22-1.3 4.4.5 7.2 4.3 7.8 1.3.2 2.8.2 4.2-.1 8.2-2 11.9-8.6 15.7-15.2l-2.2 2a18.8 18.8 0 0 1-7.4 5.2 2 2 0 0 1-1.6-.2c-.2-.1 0-1 0-1.4l.8-1.8L41.9 28c.5-1.4.9-3 .7-4.4-.2-2.6-3-4.4-6.3-4.4-8.8.2-15 4.5-19.5 11.8-.2.3-.2.6-.3 1.3 3.7-2.8 6.8-6.1 11.8-6.2z"/><circle fill="currentColor" cx="39.3" cy="9.2" r="8.2"/><!--Created by Arafat Uddin from the Noun Project--></svg>\n',
                    menu: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="10 10 80 80"><g fill="currentColor"><circle r="10" cx="20" cy="20"/><circle r="10" cx="50" cy="20"/><circle r="10" cx="80" cy="20"/><circle r="10" cx="20" cy="50"/><circle r="10" cx="50" cy="50"/><circle r="10" cx="80" cy="50"/><circle r="10" cx="20" cy="80"/><circle r="10" cx="50" cy="80"/><circle r="10" cx="80" cy="80"/></g><!-- Created by Richard Kun\xe1k from the Noun Project--></svg>\n',
                    zoomIn: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path fill="currentColor" d="M14.043 12.22a7.738 7.738 0 1 0-1.823 1.822l4.985 4.985c.503.504 1.32.504 1.822 0a1.285 1.285 0 0 0 0-1.822l-4.984-4.985zm-6.305 1.043a5.527 5.527 0 1 1 0-11.053 5.527 5.527 0 0 1 0 11.053z"/><path fill="currentColor" d="M8.728 4.009H6.744v2.737H4.006V8.73h2.738v2.736h1.984V8.73h2.737V6.746H8.728z"/><!--Created by Ryan Canning from the Noun Project--></svg>\n',
                    zoomOut: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path fill="currentColor" d="M14.043 12.22a7.738 7.738 0 1 0-1.823 1.822l4.985 4.985c.503.504 1.32.504 1.822 0a1.285 1.285 0 0 0 0-1.822l-4.984-4.985zm-6.305 1.043a5.527 5.527 0 1 1 0-11.053 5.527 5.527 0 0 1 0 11.053z"/><path fill="currentColor" d="M4.006 6.746h7.459V8.73H4.006z"/><!--Created by Ryan Canning from the Noun Project--></svg>\n'
                }, Eu = {
                    linear: (Qe)=>Qe,
                    inQuad: (Qe)=>Qe * Qe,
                    outQuad: (Qe)=>Qe * (2 - Qe),
                    inOutQuad: (Qe)=>Qe < .5 ? 2 * Qe * Qe : (4 - 2 * Qe) * Qe - 1,
                    inCubic: (Qe)=>Qe * Qe * Qe,
                    outCubic: (Qe)=>--Qe * Qe * Qe + 1,
                    inOutCubic: (Qe)=>Qe < .5 ? 4 * Qe * Qe * Qe : (Qe - 1) * (2 * Qe - 2) * (2 * Qe - 2) + 1,
                    inQuart: (Qe)=>Qe * Qe * Qe * Qe,
                    outQuart: (Qe)=>1 - --Qe * Qe * Qe * Qe,
                    inOutQuart: (Qe)=>Qe < .5 ? 8 * Qe * Qe * Qe * Qe : 1 - 8 * --Qe * Qe * Qe * Qe,
                    inQuint: (Qe)=>Qe * Qe * Qe * Qe * Qe,
                    outQuint: (Qe)=>1 + --Qe * Qe * Qe * Qe * Qe,
                    inOutQuint: (Qe)=>Qe < .5 ? 16 * Qe * Qe * Qe * Qe * Qe : 1 + 16 * --Qe * Qe * Qe * Qe * Qe,
                    inSine: (Qe)=>1 - Math.cos(Qe * (Math.PI / 2)),
                    outSine: (Qe)=>Math.sin(Qe * (Math.PI / 2)),
                    inOutSine: (Qe)=>.5 - .5 * Math.cos(Math.PI * Qe),
                    inExpo: (Qe)=>Math.pow(2, 10 * (Qe - 1)),
                    outExpo: (Qe)=>1 - Math.pow(2, -10 * Qe),
                    inOutExpo: (Qe)=>(Qe = 2 * Qe - 1) < 0 ? .5 * Math.pow(2, 10 * Qe) : 1 - .5 * Math.pow(2, -10 * Qe),
                    inCirc: (Qe)=>1 - Math.sqrt(1 - Qe * Qe),
                    outCirc: (Qe)=>Math.sqrt(1 - (Qe - 1) * (Qe - 1)),
                    inOutCirc: (Qe)=>(Qe *= 2) < 1 ? .5 - .5 * Math.sqrt(1 - Qe * Qe) : .5 + .5 * Math.sqrt(1 - (Qe -= 2) * Qe)
                }, Tu = {};
                function wrap(Qe, rt) {
                    let Wn = Qe % rt;
                    return Wn < 0 && (Wn += rt), Wn;
                }
                function sum(Qe) {
                    return Qe.reduce((Qe, rt)=>Qe + rt, 0);
                }
                function distance(Qe, rt) {
                    return Math.sqrt(Math.pow(Qe.x - rt.x, 2) + Math.pow(Qe.y - rt.y, 2));
                }
                function angle(Qe, rt) {
                    return Math.atan2(rt.y - Qe.y, rt.x - Qe.x);
                }
                function getShortestArc(Qe, rt) {
                    return [
                        0,
                        2 * Math.PI,
                        2 * -Math.PI
                    ].reduce((Wn, Co)=>{
                        const Dl = rt - Qe + Co;
                        return Math.abs(Dl) < Math.abs(Wn) ? Dl : Wn;
                    }, 1 / 0);
                }
                function getAngle(Qe, rt) {
                    return Math.acos(Math.cos(Qe.pitch) * Math.cos(rt.pitch) * Math.cos(Qe.yaw - rt.yaw) + Math.sin(Qe.pitch) * Math.sin(rt.pitch));
                }
                function greatArcDistance(Qe, rt) {
                    let [Wn, Co] = Qe, [Dl, Ll] = rt;
                    Wn - Dl > Math.PI ? Wn -= 2 * Math.PI : Wn - Dl < -Math.PI && (Wn += 2 * Math.PI);
                    const Rl = (Dl - Wn) * Math.cos((Co + Ll) / 2), Ul = Ll - Co;
                    return Math.sqrt(Rl * Rl + Ul * Ul);
                }
                function getElement(Qe) {
                    return "string" === typeof Qe ? Qe.match(/^[a-z]/i) ? document.getElementById(Qe) : document.querySelector(Qe) : Qe;
                }
                function toggleClass(Qe, rt, Wn) {
                    void 0 === Wn ? Qe.classList.toggle(rt) : Wn ? Qe.classList.add(rt) : Wn || Qe.classList.remove(rt);
                }
                function addClasses(Qe, rt) {
                    Qe.classList.add(...rt.split(" ").filter((Qe)=>!!Qe));
                }
                function removeClasses(Qe, rt) {
                    Qe.classList.remove(...rt.split(" ").filter((Qe)=>!!Qe));
                }
                function hasParent(Qe, rt) {
                    let Wn = Qe;
                    do {
                        if (Wn === rt) return !0;
                        Wn = Wn.parentElement;
                    }while (Wn);
                    return !1;
                }
                function getClosest(Qe, rt) {
                    if (!Qe?.matches) return null;
                    let Wn = Qe;
                    do {
                        if (Wn.matches(rt)) return Wn;
                        Wn = Wn.parentElement;
                    }while (Wn);
                    return null;
                }
                function getEventTarget(Qe) {
                    return Qe?.composedPath()[0] || null;
                }
                function getMatchingTarget(Qe, rt) {
                    return Qe ? Qe.composedPath().find((Qe)=>(Qe instanceof HTMLElement || Qe instanceof SVGElement) && Qe.matches(rt)) : null;
                }
                function getPosition(Qe) {
                    let rt = 0, Wn = 0, Co = Qe;
                    for(; Co;)rt += Co.offsetLeft - Co.scrollLeft + Co.clientLeft, Wn += Co.offsetTop - Co.scrollTop + Co.clientTop, Co = Co.offsetParent;
                    return rt -= window.scrollX, Wn -= window.scrollY, {
                        x: rt,
                        y: Wn
                    };
                }
                function getStyleProperty(Qe, rt) {
                    return window.getComputedStyle(Qe).getPropertyValue(rt);
                }
                function getTouchData(Qe) {
                    if (Qe.touches.length < 2) return null;
                    const rt = {
                        x: Qe.touches[0].clientX,
                        y: Qe.touches[0].clientY
                    }, Wn = {
                        x: Qe.touches[1].clientX,
                        y: Qe.touches[1].clientY
                    };
                    return {
                        distance: distance(rt, Wn),
                        angle: angle(rt, Wn),
                        center: {
                            x: (rt.x + Wn.x) / 2,
                            y: (rt.y + Wn.y) / 2
                        }
                    };
                }
                function isFullscreenEnabled(Qe, rt) {
                    return void 0 === rt && (rt = !1), rt ? Qe === Ul : document.fullscreenElement === Qe;
                }
                function requestFullscreen(Qe, rt) {
                    void 0 === rt && (rt = !1), rt ? (Ul = Qe, Qe.classList.add("psv-fullscreen-emulation"), document.dispatchEvent(new Event("fullscreenchange"))) : Qe.requestFullscreen();
                }
                function exitFullscreen(Qe) {
                    void 0 === Qe && (Qe = !1), Qe ? (Ul.classList.remove("psv-fullscreen-emulation"), Ul = null, document.dispatchEvent(new Event("fullscreenchange"))) : document.exitFullscreen();
                }
                function dasherize(Qe) {
                    return Qe.replace(/[A-Z](?:(?=[^A-Z])|[A-Z]*(?=[A-Z][^A-Z]|$))/g, (Qe, rt)=>(rt > 0 ? "-" : "") + Qe.toLowerCase());
                }
                function throttle(Qe, rt) {
                    let Wn = !1;
                    return function() {
                        for(var Co = arguments.length, Dl = new Array(Co), Ll = 0; Ll < Co; Ll++)Dl[Ll] = arguments[Ll];
                        Wn || (Wn = !0, setTimeout(()=>{
                            Qe.apply(this, Dl), Wn = !1;
                        }, rt));
                    };
                }
                function isPlainObject(Qe) {
                    if ("object" !== typeof Qe || null === Qe || "[object Object]" !== Object.prototype.toString.call(Qe)) return !1;
                    if (null === Object.getPrototypeOf(Qe)) return !0;
                    let rt = Qe;
                    for(; null !== Object.getPrototypeOf(rt);)rt = Object.getPrototypeOf(rt);
                    return Object.getPrototypeOf(Qe) === rt;
                }
                function deepmerge(Qe, rt) {
                    const Wn = rt;
                    return function merge(Qe, rt) {
                        return Array.isArray(rt) ? (Qe && Array.isArray(Qe) ? Qe.length = 0 : Qe = [], rt.forEach((rt, Wn)=>{
                            Qe[Wn] = merge(null, rt);
                        })) : "object" === typeof rt ? (Qe && !Array.isArray(Qe) || (Qe = {}), Object.keys(rt).forEach((Co)=>{
                            "object" === typeof rt[Co] && rt[Co] && isPlainObject(rt[Co]) ? rt[Co] !== Wn && (Qe[Co] ? merge(Qe[Co], rt[Co]) : Qe[Co] = merge(null, rt[Co])) : Qe[Co] = rt[Co];
                        })) : Qe = rt, Qe;
                    }(Qe, rt);
                }
                function clone(Qe) {
                    return deepmerge(null, Qe);
                }
                function isEmpty(Qe) {
                    return !Qe || 0 === Object.keys(Qe).length && Qe.constructor === Object;
                }
                function isNil(Qe) {
                    return null === Qe || void 0 === Qe;
                }
                function firstNonNull() {
                    for(var Qe = arguments.length, rt = new Array(Qe), Wn = 0; Wn < Qe; Wn++)rt[Wn] = arguments[Wn];
                    for (const Co of rt)if (!isNil(Co)) return Co;
                    return null;
                }
                function deepEqual(Qe, rt) {
                    if (Qe === rt) return !0;
                    if (isObject(Qe) && isObject(rt)) {
                        if (Object.keys(Qe).length !== Object.keys(rt).length) return !1;
                        for (const Wn of Object.keys(Qe))if (!deepEqual(Qe[Wn], rt[Wn])) return !1;
                        return !0;
                    }
                    return !1;
                }
                function isObject(Qe) {
                    return "object" === typeof Qe && null !== Qe;
                }
                __export(Tu, {
                    Animation: ()=>id,
                    Dynamic: ()=>nd,
                    MultiDynamic: ()=>rd,
                    PressHandler: ()=>sd,
                    Slider: ()=>od,
                    SliderDirection: ()=>ad,
                    addClasses: ()=>addClasses,
                    angle: ()=>angle,
                    applyEulerInverse: ()=>applyEulerInverse,
                    checkClosedShadowDom: ()=>checkClosedShadowDom,
                    checkStylesheet: ()=>checkStylesheet,
                    checkVersion: ()=>checkVersion,
                    cleanCssPosition: ()=>cleanCssPosition,
                    clone: ()=>clone,
                    createTexture: ()=>createTexture,
                    cssPositionIsOrdered: ()=>cssPositionIsOrdered,
                    dasherize: ()=>dasherize,
                    deepEqual: ()=>deepEqual,
                    deepmerge: ()=>deepmerge,
                    distance: ()=>distance,
                    exitFullscreen: ()=>exitFullscreen,
                    firstNonNull: ()=>firstNonNull,
                    getAbortError: ()=>getAbortError,
                    getAngle: ()=>getAngle,
                    getClosest: ()=>getClosest,
                    getConfigParser: ()=>getConfigParser,
                    getElement: ()=>getElement,
                    getEventTarget: ()=>getEventTarget,
                    getMatchingTarget: ()=>getMatchingTarget,
                    getPosition: ()=>getPosition,
                    getShortestArc: ()=>getShortestArc,
                    getStyleProperty: ()=>getStyleProperty,
                    getTouchData: ()=>getTouchData,
                    getXMPValue: ()=>getXMPValue,
                    greatArcDistance: ()=>greatArcDistance,
                    hasParent: ()=>hasParent,
                    invertResolvableBoolean: ()=>invertResolvableBoolean,
                    isAbortError: ()=>isAbortError,
                    isEmpty: ()=>isEmpty,
                    isExtendedPosition: ()=>isExtendedPosition,
                    isFullscreenEnabled: ()=>isFullscreenEnabled,
                    isNil: ()=>isNil,
                    isPlainObject: ()=>isPlainObject,
                    logWarn: ()=>logWarn,
                    mergePanoData: ()=>mergePanoData,
                    parseAngle: ()=>parseAngle,
                    parsePoint: ()=>parsePoint,
                    parseSpeed: ()=>parseSpeed,
                    removeClasses: ()=>removeClasses,
                    requestFullscreen: ()=>requestFullscreen,
                    resolveBoolean: ()=>resolveBoolean,
                    speedToDuration: ()=>speedToDuration,
                    sum: ()=>sum,
                    throttle: ()=>throttle,
                    toggleClass: ()=>toggleClass,
                    wrap: ()=>wrap
                });
                var Lu = class _PSVError extends Error {
                    constructor(Qe, rt){
                        super(rt && rt instanceof Error ? `${Qe}: ${rt.message}` : Qe), this.name = "PSVError", Error.captureStackTrace?.(this, _PSVError);
                    }
                };
                function resolveBoolean(Qe, rt) {
                    isPlainObject(Qe) ? (rt(Qe.initial, !0), Qe.promise.then((Qe)=>rt(Qe, !1))) : rt(Qe, !0);
                }
                function invertResolvableBoolean(Qe) {
                    return {
                        initial: !Qe.initial,
                        promise: Qe.promise.then((Qe)=>!Qe)
                    };
                }
                function getAbortError() {
                    const Qe = new Error("Loading was aborted.");
                    return Qe.name = "AbortError", Qe;
                }
                function isAbortError(Qe) {
                    return "AbortError" === Qe?.name;
                }
                function logWarn(Qe) {
                    console.warn(`PhotoSphereViewer: ${Qe}`);
                }
                function isExtendedPosition(Qe) {
                    return !(!Qe || Array.isArray(Qe)) && [
                        [
                            "textureX",
                            "textureY"
                        ],
                        [
                            "yaw",
                            "pitch"
                        ]
                    ].some((rt)=>{
                        let [Wn, Co] = rt;
                        return void 0 !== Qe[Wn] && void 0 !== Qe[Co];
                    });
                }
                function getXMPValue(Qe, rt, Wn) {
                    void 0 === Wn && (Wn = !0);
                    let Co = Qe.match("<GPano:" + rt + ">(.*)</GPano:" + rt + ">");
                    if (null !== Co) {
                        const Qe = Wn ? parseInt(Co[1], 10) : parseFloat(Co[1]);
                        return isNaN(Qe) ? null : Qe;
                    }
                    if (Co = Qe.match("GPano:" + rt + '="(.*?)"'), null !== Co) {
                        const Qe = Wn ? parseInt(Co[1], 10) : parseFloat(Co[1]);
                        return isNaN(Qe) ? null : Qe;
                    }
                    return null;
                }
                var Zu = {
                    top: "0%",
                    bottom: "100%",
                    left: "0%",
                    right: "100%",
                    center: "50%"
                }, Xu = [
                    "left",
                    "center",
                    "right"
                ], Ju = [
                    "top",
                    "center",
                    "bottom"
                ], $u = [
                    ...Xu,
                    ...Ju
                ], ed = "center";
                function parsePoint(Qe) {
                    if (!Qe) return {
                        x: .5,
                        y: .5
                    };
                    if ("object" === typeof Qe) return Qe;
                    let rt = Qe.toLocaleLowerCase().split(" ").slice(0, 2);
                    1 === rt.length && (rt = Zu[rt[0]] ? [
                        rt[0],
                        ed
                    ] : [
                        rt[0],
                        rt[0]
                    ]);
                    const Wn = "left" !== rt[1] && "right" !== rt[1] && "top" !== rt[0] && "bottom" !== rt[0];
                    rt = rt.map((Qe)=>Zu[Qe] || Qe), Wn || rt.reverse();
                    const Co = rt.join(" ").match(/^([0-9.]+)% ([0-9.]+)%$/);
                    return Co ? {
                        x: parseFloat(Co[1]) / 100,
                        y: parseFloat(Co[2]) / 100
                    } : {
                        x: .5,
                        y: .5
                    };
                }
                function cleanCssPosition(Qe, rt) {
                    let { allowCenter: Wn, cssOrder: Co } = void 0 === rt ? {
                        allowCenter: !0,
                        cssOrder: !0
                    } : rt;
                    return Qe ? ("string" === typeof Qe && (Qe = Qe.split(" ")), 1 === Qe.length && (Qe[0] === ed ? Qe = [
                        ed,
                        ed
                    ] : -1 !== Xu.indexOf(Qe[0]) ? Qe = [
                        ed,
                        Qe[0]
                    ] : -1 !== Ju.indexOf(Qe[0]) && (Qe = [
                        Qe[0],
                        ed
                    ])), 2 !== Qe.length || -1 === $u.indexOf(Qe[0]) || -1 === $u.indexOf(Qe[1]) ? (logWarn(`Unparsable position ${Qe}`), null) : Wn || Qe[0] !== ed || Qe[1] !== ed ? (Co && !cssPositionIsOrdered(Qe) && (Qe = [
                        Qe[1],
                        Qe[0]
                    ]), Qe[1] === ed && -1 !== Xu.indexOf(Qe[0]) && (Qe = [
                        ed,
                        Qe[0]
                    ]), Qe[0] === ed && -1 !== Ju.indexOf(Qe[1]) && (Qe = [
                        Qe[1],
                        ed
                    ]), Qe) : (logWarn("Invalid position center center"), null)) : null;
                }
                function cssPositionIsOrdered(Qe) {
                    return -1 !== Ju.indexOf(Qe[0]) && -1 !== Xu.indexOf(Qe[1]);
                }
                function parseSpeed(Qe) {
                    let rt;
                    if ("string" === typeof Qe) {
                        const Wn = Qe.toString().trim();
                        let Dl = parseFloat(Wn.replace(/^(-?[0-9]+(?:\.[0-9]*)?).*$/, "$1"));
                        const Ll = Wn.replace(/^-?[0-9]+(?:\.[0-9]*)?(.*)$/, "$1").trim();
                        switch(Ll.match(/(pm|per minute)$/) && (Dl /= 60), Ll){
                            case "dpm":
                            case "degrees per minute":
                            case "dps":
                            case "degrees per second":
                                rt = Co.cj9.degToRad(Dl);
                                break;
                            case "rdpm":
                            case "radians per minute":
                            case "rdps":
                            case "radians per second":
                                rt = Dl;
                                break;
                            case "rpm":
                            case "revolutions per minute":
                            case "rps":
                            case "revolutions per second":
                                rt = Dl * Math.PI * 2;
                                break;
                            default:
                                throw new Lu(`Unknown speed unit "${Ll}"`);
                        }
                    } else rt = Qe;
                    return rt;
                }
                function speedToDuration(Qe, rt) {
                    if ("number" !== typeof Qe) {
                        const Wn = parseSpeed(Qe);
                        return rt / Math.abs(Wn) * 1e3;
                    }
                    return Math.abs(Qe);
                }
                function parseAngle(Qe, rt, Wn) {
                    let Dl;
                    if (void 0 === rt && (rt = !1), void 0 === Wn && (Wn = rt), "string" === typeof Qe) {
                        const rt = Qe.toLowerCase().trim().match(/^(-?[0-9]+(?:\.[0-9]*)?)(.*)$/);
                        if (!rt) throw new Lu(`Unknown angle "${Qe}"`);
                        const Wn = parseFloat(rt[1]), Ll = rt[2];
                        if (Ll) switch(Ll){
                            case "deg":
                            case "degs":
                                Dl = Co.cj9.degToRad(Wn);
                                break;
                            case "rad":
                            case "rads":
                                Dl = Wn;
                                break;
                            default:
                                throw new Lu(`Unknown angle unit "${Ll}"`);
                        }
                        else Dl = Wn;
                    } else {
                        if ("number" !== typeof Qe || isNaN(Qe)) throw new Lu(`Unknown angle "${Qe}"`);
                        Dl = Qe;
                    }
                    return Dl = wrap(rt ? Dl + Math.PI : Dl, 2 * Math.PI), rt ? Co.cj9.clamp(Dl - Math.PI, -Math.PI / (Wn ? 2 : 1), Math.PI / (Wn ? 2 : 1)) : Dl;
                }
                function createTexture(Qe, rt) {
                    void 0 === rt && (rt = !1);
                    const Wn = new Co.gPd(Qe);
                    return Wn.needsUpdate = !0, Wn.minFilter = rt ? Co.$_I : Co.k6q, Wn.generateMipmaps = rt, Wn.anisotropy = rt ? 2 : 1, Wn;
                }
                var td = new Co.PTz;
                function applyEulerInverse(Qe, rt) {
                    td.setFromEuler(rt).invert(), Qe.applyQuaternion(td);
                }
                function getConfigParser(Qe, rt) {
                    const parser = function(Wn) {
                        const Co = clone({
                            ...Qe,
                            ...Wn
                        }), Dl = {};
                        for (let [Ll, Rl] of Object.entries(Co)){
                            if (rt && Ll in rt) Rl = rt[Ll](Rl, {
                                rawConfig: Co,
                                defValue: Qe[Ll]
                            });
                            else if (!(Ll in Qe)) {
                                logWarn(`Unknown option ${Ll}`);
                                continue;
                            }
                            Dl[Ll] = Rl;
                        }
                        return Dl;
                    };
                    return parser.defaults = Qe, parser.parsers = rt || {}, parser;
                }
                function checkStylesheet(Qe, rt) {
                    "true" !== getStyleProperty(Qe, `--psv-${rt}-loaded`) && console.error(`PhotoSphereViewer: stylesheet "@photo-sphere-viewer/${rt}/index.css" is not loaded`);
                }
                function checkVersion(Qe, rt, Wn) {
                    rt && rt !== Wn && console.error(`PhotoSphereViewer: @photo-sphere-viewer/${Qe} is in version ${rt} but @photo-sphere-viewer/core is in version ${Wn}`);
                }
                function checkClosedShadowDom(Qe) {
                    do {
                        if (Qe instanceof ShadowRoot && "closed" === Qe.mode) return void console.error("PhotoSphereViewer: closed shadow DOM detected, the viewer might not work as expected");
                        Qe = Qe.parentNode;
                    }while (Qe);
                }
                function mergePanoData(Qe, rt, Wn, Co) {
                    if (!Wn && !Co) {
                        const Co = Math.max(Qe, 2 * rt), Dl = Math.round(Co / 2);
                        Wn = {
                            fullWidth: Co,
                            fullHeight: Dl,
                            croppedWidth: Qe,
                            croppedHeight: rt,
                            croppedX: Math.round((Co - Qe) / 2),
                            croppedY: Math.round((Dl - rt) / 2)
                        };
                    }
                    const Dl = {
                        isEquirectangular: !0,
                        fullWidth: firstNonNull(Wn?.fullWidth, Co?.fullWidth),
                        fullHeight: firstNonNull(Wn?.fullHeight, Co?.fullHeight),
                        croppedWidth: firstNonNull(Wn?.croppedWidth, Co?.croppedWidth, Qe),
                        croppedHeight: firstNonNull(Wn?.croppedHeight, Co?.croppedHeight, rt),
                        croppedX: firstNonNull(Wn?.croppedX, Co?.croppedX, 0),
                        croppedY: firstNonNull(Wn?.croppedY, Co?.croppedY, 0),
                        poseHeading: firstNonNull(Wn?.poseHeading, Co?.poseHeading, 0),
                        posePitch: firstNonNull(Wn?.posePitch, Co?.posePitch, 0),
                        poseRoll: firstNonNull(Wn?.poseRoll, Co?.poseRoll, 0),
                        initialHeading: Co?.initialHeading,
                        initialPitch: Co?.initialPitch,
                        initialFov: Co?.initialFov
                    };
                    return !Dl.fullWidth && Dl.fullHeight ? Dl.fullWidth = 2 * Dl.fullHeight : Dl.fullWidth && Dl.fullHeight || (Dl.fullWidth = Dl.fullWidth ?? Qe, Dl.fullHeight = Dl.fullHeight ?? rt), Dl.croppedWidth === Qe && Dl.croppedHeight === rt || logWarn(`Invalid panoData, croppedWidth/croppedHeight is not coherent with the loaded image.\n        panoData: ${Dl.croppedWidth}x${Dl.croppedHeight}, image: ${Qe}x${rt}`), Math.abs(Dl.fullWidth - 2 * Dl.fullHeight) > 1 && (logWarn("Invalid panoData, fullWidth should be twice fullHeight"), Dl.fullHeight = Math.round(Dl.fullWidth / 2)), Dl.croppedX + Dl.croppedWidth > Dl.fullWidth && (logWarn("Invalid panoData, croppedX + croppedWidth > fullWidth"), Dl.croppedX = Dl.fullWidth - Dl.croppedWidth), Dl.croppedY + Dl.croppedHeight > Dl.fullHeight && (logWarn("Invalid panoData, croppedY + croppedHeight > fullHeight"), Dl.croppedY = Dl.fullHeight - Dl.croppedHeight), Dl.croppedX < 0 && (logWarn("Invalid panoData, croppedX < 0"), Dl.croppedX = 0), Dl.croppedY < 0 && (logWarn("Invalid panoData, croppedY < 0"), Dl.croppedY = 0), Dl;
                }
                var id = class {
                    constructor(Qe){
                        this.easing = Eu.linear, this.callbacks = [], this.resolved = !1, this.cancelled = !1, this.options = Qe, Qe ? (Qe.easing && (this.easing = "function" === typeof Qe.easing ? Qe.easing : Eu[Qe.easing] || Eu.linear), this.delayTimeout = setTimeout(()=>{
                            this.delayTimeout = void 0, this.animationFrame = window.requestAnimationFrame((Qe)=>this.__run(Qe));
                        }, Qe.delay || 0)) : this.resolved = !0;
                    }
                    __run(Qe) {
                        if (this.cancelled) return;
                        this.start || (this.start = Qe);
                        const rt = (Qe - this.start) / this.options.duration, Wn = {};
                        if (rt < 1) {
                            for (const [Qe, Co] of Object.entries(this.options.properties))if (Co) {
                                const Dl = Co.start + (Co.end - Co.start) * this.easing(rt);
                                Wn[Qe] = Dl;
                            }
                            this.options.onTick(Wn, rt), this.animationFrame = window.requestAnimationFrame((Qe)=>this.__run(Qe));
                        } else {
                            for (const [Qe, rt] of Object.entries(this.options.properties))rt && (Wn[Qe] = rt.end);
                            this.options.onTick(Wn, 1), this.__resolve(!0), this.animationFrame = void 0;
                        }
                    }
                    __resolve(Qe) {
                        Qe ? this.resolved = !0 : this.cancelled = !0, this.callbacks.forEach((rt)=>rt(Qe)), this.callbacks.length = 0;
                    }
                    then(Qe) {
                        return this.resolved || this.cancelled ? Promise.resolve(this.resolved).then(Qe) : new Promise((Qe)=>{
                            this.callbacks.push(Qe);
                        }).then(Qe);
                    }
                    cancel() {
                        this.cancelled || this.resolved || (this.__resolve(!1), this.delayTimeout && (window.clearTimeout(this.delayTimeout), this.delayTimeout = void 0), this.animationFrame && (window.cancelAnimationFrame(this.animationFrame), this.animationFrame = void 0));
                    }
                }, nd = class {
                    constructor(Qe, rt){
                        if (this.fn = Qe, this.mode = 0, this.speed = 0, this.speedMult = 0, this.currentSpeed = 0, this.target = 0, this.__current = 0, this.min = rt.min, this.max = rt.max, this.wrap = rt.wrap, this.current = rt.defaultValue, this.wrap && 0 !== this.min) throw new Lu("invalid config");
                        this.fn && this.fn(this.current);
                    }
                    get current() {
                        return this.__current;
                    }
                    set current(Qe) {
                        this.__current = Qe;
                    }
                    setSpeed(Qe) {
                        this.speed = Qe;
                    }
                    goto(Qe, rt) {
                        void 0 === rt && (rt = 1), this.mode = 2, this.target = this.wrap ? wrap(Qe, this.max) : Co.cj9.clamp(Qe, this.min, this.max), this.speedMult = rt;
                    }
                    step(Qe, rt) {
                        void 0 === rt && (rt = 1), 0 === rt ? this.setValue(this.current + Qe) : (2 !== this.mode && (this.target = this.current), this.goto(this.target + Qe, rt));
                    }
                    roll(Qe, rt) {
                        void 0 === Qe && (Qe = !1), void 0 === rt && (rt = 1), this.mode = 1, this.target = Qe ? -1 / 0 : 1 / 0, this.speedMult = rt;
                    }
                    stop() {
                        this.mode = 0;
                    }
                    setValue(Qe) {
                        return this.target = this.wrap ? wrap(Qe, this.max) : Co.cj9.clamp(Qe, this.min, this.max), this.mode = 0, this.currentSpeed = 0, this.target !== this.current && (this.current = this.target, this.fn && this.fn(this.current), !0);
                    }
                    update(Qe) {
                        if (2 === this.mode) {
                            this.wrap && Math.abs(this.target - this.current) > this.max / 2 && (this.current = this.current < this.target ? this.current + this.max : this.current - this.max);
                            const Qe = this.currentSpeed * this.currentSpeed / (this.speed * this.speedMult * 4);
                            Math.abs(this.target - this.current) <= Qe && (this.mode = 0);
                        }
                        let rt = 0 === this.mode ? 0 : this.speed * this.speedMult;
                        this.target < this.current && (rt = -rt), this.currentSpeed < rt ? this.currentSpeed = Math.min(rt, this.currentSpeed + Qe / 1e3 * this.speed * this.speedMult * 2) : this.currentSpeed > rt && (this.currentSpeed = Math.max(rt, this.currentSpeed - Qe / 1e3 * this.speed * this.speedMult * 2));
                        let Wn = null;
                        return this.current > this.target && this.currentSpeed ? Wn = Math.max(this.target, this.current + this.currentSpeed * Qe / 1e3) : this.current < this.target && this.currentSpeed && (Wn = Math.min(this.target, this.current + this.currentSpeed * Qe / 1e3)), null !== Wn && (Wn = this.wrap ? wrap(Wn, this.max) : Co.cj9.clamp(Wn, this.min, this.max), Wn !== this.current) && (this.current = Wn, this.fn && this.fn(this.current), !0);
                    }
                }, rd = class {
                    constructor(Qe, rt){
                        this.fn = Qe, this.dynamics = rt, this.fn && this.fn(this.current);
                    }
                    get current() {
                        return Object.entries(this.dynamics).reduce((Qe, rt)=>{
                            let [Wn, Co] = rt;
                            return Qe[Wn] = Co.current, Qe;
                        }, {});
                    }
                    setSpeed(Qe) {
                        for (const rt of Object.values(this.dynamics))rt.setSpeed(Qe);
                    }
                    goto(Qe, rt) {
                        void 0 === rt && (rt = 1);
                        for (const [Wn, Co] of Object.entries(Qe))this.dynamics[Wn].goto(Co, rt);
                    }
                    step(Qe, rt) {
                        if (void 0 === rt && (rt = 1), 0 === rt) this.setValue(Object.keys(Qe).reduce((rt, Wn)=>(rt[Wn] = Qe[Wn] + this.dynamics[Wn].current, rt), {}));
                        else for (const [Wn, Co] of Object.entries(Qe))this.dynamics[Wn].step(Co, rt);
                    }
                    roll(Qe, rt) {
                        void 0 === rt && (rt = 1);
                        for (const [Wn, Co] of Object.entries(Qe))this.dynamics[Wn].roll(Co, rt);
                    }
                    stop() {
                        for (const Qe of Object.values(this.dynamics))Qe.stop();
                    }
                    setValue(Qe) {
                        let rt = !1;
                        for (const [Wn, Co] of Object.entries(Qe))rt = this.dynamics[Wn].setValue(Co) || rt;
                        return rt && this.fn && this.fn(this.current), rt;
                    }
                    update(Qe) {
                        let rt = !1;
                        for (const Wn of Object.values(this.dynamics))rt = Wn.update(Qe) || rt;
                        return rt && this.fn && this.fn(this.current), rt;
                    }
                }, sd = class {
                    constructor(Qe){
                        void 0 === Qe && (Qe = 200), this.delay = Qe, this.time = 0, this.delay = Qe;
                    }
                    get pending() {
                        return 0 !== this.time;
                    }
                    down(Qe) {
                        this.timeout && (clearTimeout(this.timeout), this.timeout = void 0), this.time = (new Date).getTime(), this.data = Qe;
                    }
                    up(Qe) {
                        if (!this.time) return;
                        Date.now() - this.time < this.delay ? this.timeout = setTimeout(()=>{
                            Qe(this.data), this.timeout = void 0, this.time = 0, this.data = void 0;
                        }, this.delay) : (Qe(this.data), this.time = 0, this.data = void 0);
                    }
                }, ad = ((Qe)=>(Qe.VERTICAL = "VERTICAL", Qe.HORIZONTAL = "HORIZONTAL", Qe))(ad || {}), od = class {
                    constructor(Qe, rt, Wn){
                        this.container = Qe, this.direction = rt, this.listener = Wn, this.mousedown = !1, this.mouseover = !1, this.container.addEventListener("click", this), this.container.addEventListener("mousedown", this), this.container.addEventListener("mouseenter", this), this.container.addEventListener("mouseleave", this), this.container.addEventListener("touchstart", this), this.container.addEventListener("mousemove", this, !0), this.container.addEventListener("touchmove", this, !0), window.addEventListener("mouseup", this), window.addEventListener("touchend", this);
                    }
                    get isVertical() {
                        return "VERTICAL" === this.direction;
                    }
                    get isHorizontal() {
                        return "HORIZONTAL" === this.direction;
                    }
                    destroy() {
                        window.removeEventListener("mouseup", this), window.removeEventListener("touchend", this);
                    }
                    handleEvent(Qe) {
                        switch(Qe.type){
                            case "click":
                                Qe.stopPropagation();
                                break;
                            case "mousedown":
                                this.__onMouseDown(Qe);
                                break;
                            case "mouseenter":
                                this.__onMouseEnter(Qe);
                                break;
                            case "mouseleave":
                                this.__onMouseLeave(Qe);
                                break;
                            case "touchstart":
                                this.__onTouchStart(Qe);
                                break;
                            case "mousemove":
                                this.__onMouseMove(Qe);
                                break;
                            case "touchmove":
                                this.__onTouchMove(Qe);
                                break;
                            case "mouseup":
                                this.__onMouseUp(Qe);
                                break;
                            case "touchend":
                                this.__onTouchEnd(Qe);
                        }
                    }
                    __onMouseDown(Qe) {
                        this.mousedown = !0, this.__update(Qe.clientX, Qe.clientY, !0);
                    }
                    __onMouseEnter(Qe) {
                        this.mouseover = !0, this.__update(Qe.clientX, Qe.clientY, !0);
                    }
                    __onTouchStart(Qe) {
                        this.mouseover = !0, this.mousedown = !0;
                        const rt = Qe.changedTouches[0];
                        this.__update(rt.clientX, rt.clientY, !0);
                    }
                    __onMouseMove(Qe) {
                        (this.mousedown || this.mouseover) && (Qe.stopPropagation(), this.__update(Qe.clientX, Qe.clientY, !0));
                    }
                    __onTouchMove(Qe) {
                        if (this.mousedown || this.mouseover) {
                            Qe.stopPropagation();
                            const rt = Qe.changedTouches[0];
                            this.__update(rt.clientX, rt.clientY, !0);
                        }
                    }
                    __onMouseUp(Qe) {
                        this.mousedown && (this.mousedown = !1, this.__update(Qe.clientX, Qe.clientY, !1));
                    }
                    __onMouseLeave(Qe) {
                        this.mouseover && (this.mouseover = !1, this.__update(Qe.clientX, Qe.clientY, !0));
                    }
                    __onTouchEnd(Qe) {
                        if (this.mousedown) {
                            this.mouseover = !1, this.mousedown = !1;
                            const rt = Qe.changedTouches[0];
                            this.__update(rt.clientX, rt.clientY, !1);
                        }
                    }
                    __update(Qe, rt, Wn) {
                        const Dl = this.container.getBoundingClientRect();
                        let Ll;
                        Ll = this.isVertical ? Co.cj9.clamp((Dl.bottom - rt) / Dl.height, 0, 1) : Co.cj9.clamp((Qe - Dl.left) / Dl.width, 0, 1), this.listener({
                            value: Ll,
                            click: !Wn,
                            mousedown: this.mousedown,
                            mouseover: this.mouseover,
                            cursor: {
                                clientX: Qe,
                                clientY: rt
                            }
                        });
                    }
                }, ld = {};
                __export(ld, {
                    BeforeAnimateEvent: ()=>pd,
                    BeforeRenderEvent: ()=>fd,
                    BeforeRotateEvent: ()=>Ad,
                    ClickEvent: ()=>vd,
                    ConfigChangedEvent: ()=>xd,
                    DoubleClickEvent: ()=>wd,
                    FullscreenEvent: ()=>Md,
                    HideNotificationEvent: ()=>Td,
                    HideOverlayEvent: ()=>kd,
                    HidePanelEvent: ()=>Dd,
                    HideTooltipEvent: ()=>Pd,
                    KeypressEvent: ()=>Nd,
                    LoadProgressEvent: ()=>Bd,
                    ObjectEnterEvent: ()=>Lp,
                    ObjectEvent: ()=>Ip,
                    ObjectHoverEvent: ()=>Rp,
                    ObjectLeaveEvent: ()=>zp,
                    PanoramaErrorEvent: ()=>Gd,
                    PanoramaLoadEvent: ()=>Fd,
                    PanoramaLoadedEvent: ()=>Ud,
                    PositionUpdatedEvent: ()=>qd,
                    ReadyEvent: ()=>Xd,
                    RenderEvent: ()=>$d,
                    RollUpdatedEvent: ()=>Qd,
                    ShowNotificationEvent: ()=>gp,
                    ShowOverlayEvent: ()=>vp,
                    ShowPanelEvent: ()=>xp,
                    ShowTooltipEvent: ()=>wp,
                    SizeUpdatedEvent: ()=>Mp,
                    StopAllEvent: ()=>Tp,
                    TransitionDoneEvent: ()=>Hd,
                    ViewerEvent: ()=>hd,
                    ZoomUpdatedEvent: ()=>kp
                });
                var cd = class extends Event {
                    constructor(Qe, rt){
                        void 0 === rt && (rt = !1), super(Qe, {
                            cancelable: rt
                        });
                    }
                }, ud = class extends EventTarget {
                    dispatchEvent(Qe) {
                        return super.dispatchEvent(Qe);
                    }
                    addEventListener(Qe, rt, Wn) {
                        super.addEventListener(Qe, rt, Wn);
                    }
                    removeEventListener(Qe, rt, Wn) {
                        super.removeEventListener(Qe, rt, Wn);
                    }
                }, hd = class extends cd {
                }, dd = class _BeforeAnimateEvent extends hd {
                    constructor(Qe, rt){
                        super(_BeforeAnimateEvent.type, !0), this.position = Qe, this.zoomLevel = rt;
                    }
                };
                dd.type = "before-animate";
                var pd = dd, md = class _BeforeRenderEvent extends hd {
                    constructor(Qe, rt){
                        super(_BeforeRenderEvent.type), this.timestamp = Qe, this.elapsed = rt;
                    }
                };
                md.type = "before-render";
                var fd = md, gd = class _BeforeRotateEvent extends hd {
                    constructor(Qe){
                        super(_BeforeRotateEvent.type, !0), this.position = Qe;
                    }
                };
                gd.type = "before-rotate";
                var Ad = gd, yd = class _ClickEvent extends hd {
                    constructor(Qe){
                        super(_ClickEvent.type), this.data = Qe;
                    }
                };
                yd.type = "click";
                var vd = yd, _d = class _ConfigChangedEvent extends hd {
                    constructor(Qe){
                        super(_ConfigChangedEvent.type), this.options = Qe;
                    }
                    containsOptions() {
                        for(var Qe = arguments.length, rt = new Array(Qe), Wn = 0; Wn < Qe; Wn++)rt[Wn] = arguments[Wn];
                        return rt.some((Qe)=>this.options.includes(Qe));
                    }
                };
                _d.type = "config-changed";
                var xd = _d, bd = class _DoubleClickEvent extends hd {
                    constructor(Qe){
                        super(_DoubleClickEvent.type), this.data = Qe;
                    }
                };
                bd.type = "dblclick";
                var wd = bd, Ed = class _FullscreenEvent extends hd {
                    constructor(Qe){
                        super(_FullscreenEvent.type), this.fullscreenEnabled = Qe;
                    }
                };
                Ed.type = "fullscreen";
                var Md = Ed, Sd = class _HideNotificationEvent extends hd {
                    constructor(Qe){
                        super(_HideNotificationEvent.type), this.notificationId = Qe;
                    }
                };
                Sd.type = "hide-notification";
                var Td = Sd, Cd = class _HideOverlayEvent extends hd {
                    constructor(Qe){
                        super(_HideOverlayEvent.type), this.overlayId = Qe;
                    }
                };
                Cd.type = "hide-overlay";
                var kd = Cd, Id = class _HidePanelEvent extends hd {
                    constructor(Qe){
                        super(_HidePanelEvent.type), this.panelId = Qe;
                    }
                };
                Id.type = "hide-panel";
                var Dd = Id, Ld = class _HideTooltipEvent extends hd {
                    constructor(Qe){
                        super(_HideTooltipEvent.type), this.tooltipData = Qe;
                    }
                };
                Ld.type = "hide-tooltip";
                var Pd = Ld, zd = class _KeypressEvent extends hd {
                    constructor(Qe, rt){
                        super(_KeypressEvent.type, !0), this.key = Qe, this.originalEvent = rt;
                    }
                };
                zd.type = "key-press";
                var Nd = zd, Rd = class _LoadProgressEvent extends hd {
                    constructor(Qe){
                        super(_LoadProgressEvent.type), this.progress = Qe;
                    }
                };
                Rd.type = "load-progress";
                var Bd = Rd, Od = class _PanoramaLoadEvent extends hd {
                    constructor(Qe){
                        super(_PanoramaLoadEvent.type), this.panorama = Qe;
                    }
                };
                Od.type = "panorama-load";
                var Fd = Od, jd = class _PanoramaLoadedEvent extends hd {
                    constructor(Qe){
                        super(_PanoramaLoadedEvent.type), this.data = Qe;
                    }
                };
                jd.type = "panorama-loaded";
                var Ud = jd, Vd = class _PanoramaErrorEvent extends hd {
                    constructor(Qe, rt){
                        super(_PanoramaErrorEvent.type), this.panorama = Qe, this.error = rt;
                    }
                };
                Vd.type = "panorama-error";
                var Gd = Vd, Zd = class _TransitionDoneEvent extends hd {
                    constructor(Qe){
                        super(_TransitionDoneEvent.type), this.completed = Qe;
                    }
                };
                Zd.type = "transition-done";
                var Hd = Zd, Wd = class _PositionUpdatedEvent extends hd {
                    constructor(Qe){
                        super(_PositionUpdatedEvent.type), this.position = Qe;
                    }
                };
                Wd.type = "position-updated";
                var qd = Wd, Yd = class _RollUpdatedEvent extends hd {
                    constructor(Qe){
                        super(_RollUpdatedEvent.type), this.roll = Qe;
                    }
                };
                Yd.type = "roll-updated";
                var Qd = Yd, Kd = class _ReadyEvent extends hd {
                    constructor(){
                        super(_ReadyEvent.type);
                    }
                };
                Kd.type = "ready";
                var Xd = Kd, Jd = class _RenderEvent extends hd {
                    constructor(){
                        super(_RenderEvent.type);
                    }
                };
                Jd.type = "render";
                var $d = Jd, up = class _ShowNotificationEvent extends hd {
                    constructor(Qe){
                        super(_ShowNotificationEvent.type), this.notificationId = Qe;
                    }
                };
                up.type = "show-notification";
                var gp = up, Ap = class _ShowOverlayEvent extends hd {
                    constructor(Qe){
                        super(_ShowOverlayEvent.type), this.overlayId = Qe;
                    }
                };
                Ap.type = "show-overlay";
                var vp = Ap, _p = class _ShowPanelEvent extends hd {
                    constructor(Qe){
                        super(_ShowPanelEvent.type), this.panelId = Qe;
                    }
                };
                _p.type = "show-panel";
                var xp = _p, bp = class _ShowTooltipEvent extends hd {
                    constructor(Qe, rt){
                        super(_ShowTooltipEvent.type), this.tooltip = Qe, this.tooltipData = rt;
                    }
                };
                bp.type = "show-tooltip";
                var wp = bp, Ep = class _SizeUpdatedEvent extends hd {
                    constructor(Qe){
                        super(_SizeUpdatedEvent.type), this.size = Qe;
                    }
                };
                Ep.type = "size-updated";
                var Mp = Ep, Sp = class _StopAllEvent extends hd {
                    constructor(){
                        super(_StopAllEvent.type);
                    }
                };
                Sp.type = "stop-all";
                var Tp = Sp, Cp = class _ZoomUpdatedEvent extends hd {
                    constructor(Qe){
                        super(_ZoomUpdatedEvent.type), this.zoomLevel = Qe;
                    }
                };
                Cp.type = "zoom-updated";
                var kp = Cp, Ip = class extends hd {
                    constructor(Qe, rt, Wn, Co, Dl){
                        super(Qe), this.originalEvent = rt, this.object = Wn, this.viewerPoint = Co, this.userDataKey = Dl;
                    }
                }, Dp = class _ObjectEnterEvent extends Ip {
                    constructor(Qe, rt, Wn, Co){
                        super(_ObjectEnterEvent.type, Qe, rt, Wn, Co);
                    }
                };
                Dp.type = "enter-object";
                var Lp = Dp, Pp = class _ObjectLeaveEvent extends Ip {
                    constructor(Qe, rt, Wn, Co){
                        super(_ObjectLeaveEvent.type, Qe, rt, Wn, Co);
                    }
                };
                Pp.type = "leave-object";
                var zp = Pp, Np = class _ObjectHoverEvent extends Ip {
                    constructor(Qe, rt, Wn, Co){
                        super(_ObjectHoverEvent.type, Qe, rt, Wn, Co);
                    }
                };
                Np.type = "hover-object";
                var Rp = Np, Bp = class {
                    constructor(Qe){
                        this.viewer = Qe;
                    }
                    init() {}
                    destroy() {}
                    supportsTransition(Qe) {
                        return !1;
                    }
                    supportsPreload(Qe) {
                        return !1;
                    }
                    textureCoordsToSphericalCoords(Qe, rt) {
                        throw new Lu("Current adapter does not support texture coordinates.");
                    }
                    sphericalCoordsToTextureCoords(Qe, rt) {
                        throw new Lu("Current adapter does not support texture coordinates.");
                    }
                };
                function adapterInterop(Qe) {
                    if (Qe) {
                        for (const [, rt] of [
                            [
                                "_",
                                Qe
                            ],
                            ...Object.entries(Qe)
                        ])if (rt.prototype instanceof Bp) return checkVersion(rt.id, rt.VERSION, "5.12.1"), rt;
                    }
                    return null;
                }
                Bp.supportsDownload = !1;
                var Op = `${Tc}_touchSupport`, Fp = {
                    loaded: !1,
                    pixelRatio: 1,
                    isWebGLSupported: !1,
                    maxTextureWidth: 0,
                    isTouchEnabled: null,
                    __maxCanvasWidth: null,
                    isIphone: !1,
                    get maxCanvasWidth () {
                        return null === this.__maxCanvasWidth && (this.__maxCanvasWidth = function(Qe) {
                            let rt = Qe, Wn = !1;
                            const Co = document.createElement("canvas"), Dl = Co.getContext("2d");
                            Co.width = 1, Co.height = 1;
                            for(; rt > 1024 && !Wn;){
                                const Qe = document.createElement("canvas"), Co = Qe.getContext("2d");
                                Qe.width = rt, Qe.height = rt / 2;
                                try {
                                    Co.fillStyle = "white", Co.fillRect(rt - 1, rt / 2 - 1, 1, 1), Dl.drawImage(Qe, rt - 1, rt / 2 - 1, 1, 1, 0, 0, 1, 1), Dl.getImageData(0, 0, 1, 1).data[0] > 0 && (Wn = !0);
                                } catch  {}
                                Qe.width = 0, Qe.height = 0, Wn || (rt /= 2);
                            }
                            if (Wn) return rt;
                            throw new Lu("Unable to detect system capabilities");
                        }(this.maxTextureWidth)), this.__maxCanvasWidth;
                    },
                    load () {
                        if (!this.loaded) {
                            const Qe = function() {
                                try {
                                    return document.createElement("canvas").getContext("webgl2");
                                } catch  {
                                    return null;
                                }
                            }();
                            this.pixelRatio = window.devicePixelRatio || 1, this.isWebGLSupported = !!Qe, this.maxTextureWidth = Qe ? Qe.getParameter(Qe.MAX_TEXTURE_SIZE) : 0, this.isTouchEnabled = function() {
                                let Qe = "ontouchstart" in window || navigator.maxTouchPoints > 0;
                                Op in localStorage && (Qe = "true" === localStorage[Op]);
                                const rt = new Promise((rt)=>{
                                    const clear = ()=>{
                                        window.removeEventListener("mousedown", listenerMouse), window.removeEventListener("touchstart", listenerTouch), clearTimeout(Wn);
                                    }, listenerMouse = ()=>{
                                        clear(), localStorage[Op] = !1, rt(!1);
                                    }, listenerTouch = ()=>{
                                        clear(), localStorage[Op] = !0, rt(!0);
                                    }, listenerTimeout = ()=>{
                                        clear(), localStorage[Op] = Qe, rt(Qe);
                                    };
                                    window.addEventListener("mousedown", listenerMouse, !1), window.addEventListener("touchstart", listenerTouch, !1);
                                    const Wn = setTimeout(listenerTimeout, 1e4);
                                });
                                return {
                                    initial: Qe,
                                    promise: rt
                                };
                            }(), this.isIphone = /iPhone/i.test(navigator.userAgent), this.loaded = !0;
                        }
                        if (!Fp.isWebGLSupported) throw new Lu("WebGL 2 is not supported.");
                        if (0 === Fp.maxTextureWidth) throw new Lu("Unable to detect system capabilities");
                    }
                };
                var jp = getConfigParser({
                    resolution: 64,
                    useXmpData: !0,
                    blur: !1
                }, {
                    resolution: (Qe)=>{
                        if (!Qe || !Co.cj9.isPowerOfTwo(Qe)) throw new Lu("EquirectangularAdapter resolution must be power of two.");
                        return Qe;
                    }
                }), Up = class extends Bp {
                    constructor(Qe, rt){
                        super(Qe), this.config = jp(rt), this.SPHERE_SEGMENTS = this.config.resolution, this.SPHERE_HORIZONTAL_SEGMENTS = this.SPHERE_SEGMENTS / 2;
                    }
                    supportsTransition() {
                        return !0;
                    }
                    supportsPreload() {
                        return !0;
                    }
                    textureCoordsToSphericalCoords(Qe, rt) {
                        if (isNil(Qe.textureX) || isNil(Qe.textureY)) throw new Lu("Texture position is missing 'textureX' or 'textureY'");
                        const Wn = (Qe.textureX + rt.croppedX) / rt.fullWidth * Math.PI * 2, Co = (Qe.textureY + rt.croppedY) / rt.fullHeight * Math.PI;
                        return {
                            yaw: Wn >= Math.PI ? Wn - Math.PI : Wn + Math.PI,
                            pitch: Math.PI / 2 - Co
                        };
                    }
                    sphericalCoordsToTextureCoords(Qe, rt) {
                        const Wn = Qe.yaw / Math.PI / 2 * rt.fullWidth, Co = Qe.pitch / Math.PI * rt.fullHeight;
                        let Dl = Math.round(Qe.yaw < Math.PI ? Wn + rt.fullWidth / 2 : Wn - rt.fullWidth / 2) - rt.croppedX, Ll = Math.round(rt.fullHeight / 2 - Co) - rt.croppedY;
                        return (Dl < 0 || Dl > rt.croppedWidth || Ll < 0 || Ll > rt.croppedHeight) && (Dl = Ll = void 0), {
                            textureX: Dl,
                            textureY: Ll
                        };
                    }
                    async loadTexture(Qe, rt, Wn, Co) {
                        if (void 0 === rt && (rt = !0), void 0 === Co && (Co = this.config.useXmpData), "string" !== typeof Qe && ("object" !== typeof Qe || !Qe.path)) return Promise.reject(new Lu("Invalid panorama url, are you using the right adapter?"));
                        let Dl;
                        Dl = "string" === typeof Qe ? {
                            path: Qe,
                            data: Wn
                        } : {
                            data: Wn,
                            ...Qe
                        };
                        const Ll = await this.viewer.textureLoader.loadFile(Dl.path, rt ? (Qe)=>this.viewer.loader.setProgress(Qe) : null, Dl.path), Rl = Co ? await this.loadXMP(Ll) : null, Ul = await this.viewer.textureLoader.blobToImage(Ll);
                        "function" === typeof Dl.data && (Dl.data = Dl.data(Ul, Rl));
                        const Gl = mergePanoData(Ul.width, Ul.height, Dl.data, Rl);
                        return {
                            panorama: Qe,
                            texture: this.createEquirectangularTexture(Ul),
                            panoData: Gl,
                            cacheKey: Dl.path
                        };
                    }
                    async loadXMP(Qe) {
                        const rt = await this.loadBlobAsString(Qe), Wn = rt.indexOf("<x:xmpmeta");
                        if (-1 === Wn) return null;
                        const Co = rt.indexOf("</x:xmpmeta>", Wn);
                        if (-1 === Co) return null;
                        const Dl = rt.substring(Wn, Co);
                        return Dl.includes("GPano:") ? {
                            fullWidth: getXMPValue(Dl, "FullPanoWidthPixels"),
                            fullHeight: getXMPValue(Dl, "FullPanoHeightPixels"),
                            croppedWidth: getXMPValue(Dl, "CroppedAreaImageWidthPixels"),
                            croppedHeight: getXMPValue(Dl, "CroppedAreaImageHeightPixels"),
                            croppedX: getXMPValue(Dl, "CroppedAreaLeftPixels"),
                            croppedY: getXMPValue(Dl, "CroppedAreaTopPixels"),
                            poseHeading: getXMPValue(Dl, "PoseHeadingDegrees", !1),
                            posePitch: getXMPValue(Dl, "PosePitchDegrees", !1),
                            poseRoll: getXMPValue(Dl, "PoseRollDegrees", !1),
                            initialHeading: getXMPValue(Dl, "InitialViewHeadingDegrees", !1),
                            initialPitch: getXMPValue(Dl, "InitialViewPitchDegrees", !1),
                            initialFov: getXMPValue(Dl, "InitialHorizontalFOVDegrees", !1)
                        } : null;
                    }
                    loadBlobAsString(Qe) {
                        return new Promise((rt, Wn)=>{
                            const Co = new FileReader;
                            Co.onload = ()=>rt(Co.result), Co.onerror = Wn, Co.readAsText(Qe);
                        });
                    }
                    createEquirectangularTexture(Qe) {
                        if (this.config.blur || Qe.width > Fp.maxTextureWidth) {
                            const rt = Math.min(1, Fp.maxCanvasWidth / Qe.width), Wn = new OffscreenCanvas(Math.floor(Qe.width * rt), Math.floor(Qe.height * rt)), Co = Wn.getContext("2d");
                            return this.config.blur && (Co.filter = `blur(${Wn.width / 2048}px)`), Co.drawImage(Qe, 0, 0, Wn.width, Wn.height), createTexture(Wn);
                        }
                        return createTexture(Qe);
                    }
                    createMesh(Qe) {
                        const rt = Qe.croppedX / Qe.fullWidth * 2 * Math.PI, Wn = Qe.croppedWidth / Qe.fullWidth * 2 * Math.PI, Dl = Qe.croppedY / Qe.fullHeight * Math.PI, Ll = Qe.croppedHeight / Qe.fullHeight * Math.PI, Rl = new Co.Gu$($l, Math.round(this.SPHERE_SEGMENTS / (2 * Math.PI) * Wn), Math.round(this.SPHERE_HORIZONTAL_SEGMENTS / Math.PI * Ll), -Math.PI / 2 + rt, Wn, Dl, Ll).scale(-1, 1, 1), Ul = new Co.V9B({
                            depthTest: !1,
                            depthWrite: !1
                        });
                        return new Co.eaF(Rl, Ul);
                    }
                    setTexture(Qe, rt) {
                        Qe.material.map = rt.texture;
                    }
                    setTextureOpacity(Qe, rt) {
                        Qe.material.opacity = rt, Qe.material.transparent = rt < 1;
                    }
                    disposeTexture(Qe) {
                        let { texture: rt } = Qe;
                        rt.dispose();
                    }
                    disposeMesh(Qe) {
                        Qe.geometry.dispose(), Qe.material.dispose();
                    }
                };
                Up.id = "equirectangular", Up.VERSION = "5.12.1", Up.supportsDownload = !0;
                var Vp = class extends Up {
                    constructor(Qe, rt){
                        super(Qe, {
                            resolution: rt?.resolution ?? 64,
                            useXmpData: !1
                        });
                    }
                    async loadTexture(Qe, rt) {
                        const Wn = await super.loadTexture(Qe, rt, null, !1);
                        return Wn.panoData = null, Wn;
                    }
                    createMesh() {
                        const Qe = new Co.Gu$($l, this.SPHERE_SEGMENTS, this.SPHERE_HORIZONTAL_SEGMENTS).scale(-1, 1, 1).toNonIndexed(), rt = Qe.getAttribute("uv"), Wn = Qe.getAttribute("normal");
                        for(let Co = 0; Co < rt.count; Co++)for(let Qe = 0; Qe < 3; Qe++){
                            const Dl = 3 * Co + Qe, Ll = Wn.getX(Dl), Rl = Wn.getY(Dl), Ul = Wn.getZ(Dl), Gl = .947;
                            if (Co < rt.count / 6) {
                                const Qe = 0 === Ll && 0 === Ul ? 1 : Math.acos(Rl) / Math.sqrt(Ll * Ll + Ul * Ul) * (2 / Math.PI);
                                rt.setXY(Dl, Ll * (Gl / 4) * Qe + 1 / 4, Ul * (Gl / 2) * Qe + .5);
                            } else {
                                const Qe = 0 === Ll && 0 === Ul ? 1 : Math.acos(-Rl) / Math.sqrt(Ll * Ll + Ul * Ul) * (2 / Math.PI);
                                rt.setXY(Dl, Gl / 4 * -Ll * Qe + 3 / 4, Ul * (Gl / 2) * Qe + .5);
                            }
                        }
                        Qe.rotateX(-Math.PI / 2), Qe.rotateY(Math.PI);
                        const Dl = new Co.V9B({
                            depthTest: !1,
                            depthWrite: !1
                        });
                        return new Co.eaF(Qe, Dl);
                    }
                };
                Vp.id = "dual-fisheye", Vp.VERSION = "5.12.1";
                var Gp = class _AbstractComponent {
                    constructor(Qe, rt){
                        this.parent = Qe, this.children = [], this.state = {
                            visible: !0
                        }, this.viewer = Qe instanceof _AbstractComponent ? Qe.viewer : Qe, this.container = document.createElement(rt.tagName ?? "div"), this.container.className = rt.className || "", this.parent.children.push(this), this.parent.container.appendChild(this.container);
                    }
                    destroy() {
                        this.parent.container.removeChild(this.container);
                        const Qe = this.parent.children.indexOf(this);
                        -1 !== Qe && this.parent.children.splice(Qe, 1), this.children.slice().forEach((Qe)=>Qe.destroy()), this.children.length = 0;
                    }
                    toggle(Qe) {
                        void 0 === Qe && (Qe = !this.isVisible()), Qe ? this.show() : this.hide();
                    }
                    hide(Qe) {
                        this.container.style.display = "none", this.state.visible = !1;
                    }
                    show(Qe) {
                        this.container.style.display = "", this.state.visible = !0;
                    }
                    isVisible() {
                        return this.state.visible;
                    }
                }, Zp = getConfigParser({
                    id: null,
                    tagName: null,
                    className: null,
                    title: null,
                    hoverScale: !1,
                    collapsable: !1,
                    tabbable: !0,
                    icon: null,
                    iconActive: null
                }), Hp = class extends Gp {
                    constructor(Qe, rt){
                        super(Qe, {
                            tagName: rt.tagName,
                            className: `psv-button ${rt.hoverScale ? "psv-button--hover-scale" : ""} ${rt.className || ""}`
                        }), this.state = {
                            visible: !0,
                            enabled: !0,
                            supported: !0,
                            collapsed: !1,
                            active: !1,
                            width: 0
                        }, this.config = Zp(rt), rt.id || (this.config.id = this.constructor.id), rt.icon && this.__setIcon(rt.icon), this.state.width = this.container.offsetWidth, this.config.title ? this.container.title = this.viewer.config.lang[this.config.title] ?? this.config.title : this.id && this.id in this.viewer.config.lang && (this.container.title = this.viewer.config.lang[this.id]), rt.tabbable && (this.container.tabIndex = 0), this.container.addEventListener("click", (Qe)=>{
                            this.state.enabled && this.onClick(), Qe.stopPropagation();
                        }), this.container.addEventListener("keydown", (Qe)=>{
                            Qe.key === fu.Enter && this.state.enabled && (this.onClick(), Qe.stopPropagation());
                        });
                    }
                    get id() {
                        return this.config.id;
                    }
                    get title() {
                        return this.container.title;
                    }
                    get content() {
                        return this.container.innerHTML;
                    }
                    get width() {
                        return this.state.width;
                    }
                    get collapsable() {
                        return this.config.collapsable;
                    }
                    show(Qe) {
                        void 0 === Qe && (Qe = !0), this.isVisible() || (this.state.visible = !0, this.state.collapsed || (this.container.style.display = ""), Qe && this.viewer.navbar.autoSize());
                    }
                    hide(Qe) {
                        void 0 === Qe && (Qe = !0), this.isVisible() && (this.state.visible = !1, this.container.style.display = "none", Qe && this.viewer.navbar.autoSize());
                    }
                    checkSupported() {
                        resolveBoolean(this.isSupported(), (Qe, rt)=>{
                            this.state && (this.state.supported = Qe, rt ? Qe || this.hide() : this.toggle(Qe));
                        });
                    }
                    autoSize() {}
                    isSupported() {
                        return !0;
                    }
                    toggleActive(Qe) {
                        void 0 === Qe && (Qe = !this.state.active), Qe !== this.state.active && (this.state.active = Qe, toggleClass(this.container, "psv-button--active", this.state.active), this.config.iconActive && this.__setIcon(this.state.active ? this.config.iconActive : this.config.icon));
                    }
                    disable() {
                        this.container.classList.add("psv-button--disabled"), this.state.enabled = !1;
                    }
                    enable() {
                        this.container.classList.remove("psv-button--disabled"), this.state.enabled = !0;
                    }
                    collapse() {
                        this.state.collapsed = !0, this.container.style.display = "none";
                    }
                    uncollapse() {
                        this.state.collapsed = !1, this.state.visible && (this.container.style.display = "");
                    }
                    __setIcon(Qe) {
                        this.container.innerHTML = Qe, addClasses(this.container.querySelector("svg"), "psv-button-svg");
                    }
                }, Wp = class extends Hp {
                    constructor(Qe, rt){
                        super(Qe, {
                            id: rt.id ?? `psvButton-${Math.random().toString(36).substring(2)}`,
                            className: `psv-custom-button ${rt.className || ""}`,
                            hoverScale: !1,
                            collapsable: !1 !== rt.collapsable,
                            tabbable: !1 !== rt.tabbable,
                            title: rt.title
                        }), this.customOnClick = rt.onClick, rt.content && ("string" === typeof rt.content ? this.container.innerHTML = rt.content : (this.container.classList.add("psv-custom-button--no-padding"), rt.content.style.height = "100%", rt.content.attachViewer?.(this.viewer), this.container.appendChild(rt.content))), this.state.width = this.container.offsetWidth, rt.disabled && this.disable(), !1 === rt.visible && this.hide();
                    }
                    onClick() {
                        this.customOnClick?.(this.viewer);
                    }
                }, qp = class extends Hp {
                    constructor(Qe){
                        super(Qe, {
                            className: "psv-description-button",
                            hoverScale: !0,
                            collapsable: !1,
                            tabbable: !0,
                            icon: yu.info
                        }), this.mode = 0, this.viewer.addEventListener(Td.type, this), this.viewer.addEventListener(gp.type, this), this.viewer.addEventListener(Dd.type, this), this.viewer.addEventListener(xp.type, this), this.viewer.addEventListener(xd.type, this);
                    }
                    destroy() {
                        this.viewer.removeEventListener(Td.type, this), this.viewer.removeEventListener(gp.type, this), this.viewer.removeEventListener(Dd.type, this), this.viewer.removeEventListener(xp.type, this), this.viewer.removeEventListener(xd.type, this), super.destroy();
                    }
                    handleEvent(Qe) {
                        if (Qe instanceof xd) return void (Qe.containsOptions("description") && this.autoSize(!0));
                        if (!this.mode) return;
                        let rt = !1;
                        Qe instanceof Td ? rt = 1 === this.mode : Qe instanceof gp ? rt = 1 === this.mode && Qe.notificationId !== du.DESCRIPTION : Qe instanceof Dd ? rt = 2 === this.mode : Qe instanceof xp && (rt = 2 === this.mode && Qe.panelId !== du.DESCRIPTION), rt && (this.toggleActive(!1), this.mode = 0);
                    }
                    onClick() {
                        this.mode ? this.__close() : this.__open();
                    }
                    hide(Qe) {
                        super.hide(Qe), this.mode && this.__close();
                    }
                    autoSize(Qe) {
                        if (void 0 === Qe && (Qe = !1), Qe) {
                            const Qe = this.viewer.navbar.getButton("caption", !1), rt = Qe && !Qe.isVisible(), Wn = !!this.viewer.config.description;
                            rt || Wn ? this.show(!1) : this.hide(!1);
                        }
                    }
                    __close() {
                        switch(this.mode){
                            case 1:
                                this.viewer.notification.hide(du.DESCRIPTION);
                                break;
                            case 2:
                                this.viewer.panel.hide(du.DESCRIPTION);
                        }
                    }
                    __open() {
                        this.toggleActive(!0), this.viewer.config.description ? (this.mode = 2, this.viewer.panel.show({
                            id: du.DESCRIPTION,
                            content: `${this.viewer.config.caption ? `<p>${this.viewer.config.caption}</p>` : ""}${this.viewer.config.description}`
                        })) : (this.mode = 1, this.viewer.notification.show({
                            id: du.DESCRIPTION,
                            content: this.viewer.config.caption
                        }));
                    }
                };
                qp.id = "description";
                var Yp = class extends Hp {
                    constructor(Qe){
                        super(Qe, {
                            tagName: "a",
                            className: "psv-download-button",
                            hoverScale: !0,
                            collapsable: !0,
                            tabbable: !0,
                            icon: yu.download
                        }), this.viewer.addEventListener(xd.type, this), this.viewer.addEventListener(Ud.type, this);
                    }
                    destroy() {
                        this.viewer.removeEventListener(xd.type, this), this.viewer.removeEventListener(Ud.type, this), super.destroy();
                    }
                    handleEvent(Qe) {
                        Qe instanceof xd ? (Qe.containsOptions("downloadUrl") && this.checkSupported(), Qe.containsOptions("downloadUrl", "downloadName") && this.__update()) : Qe instanceof Ud && this.__update();
                    }
                    onClick() {}
                    checkSupported() {
                        this.viewer.adapter.constructor.supportsDownload || this.viewer.config.downloadUrl ? this.show() : this.hide();
                    }
                    __update() {
                        const Qe = this.container;
                        Qe.href = this.viewer.config.downloadUrl || this.viewer.config.panorama, Qe.target = "_blank", Qe.href.startsWith("data:") && !this.viewer.config.downloadName ? Qe.download = "panorama." + Qe.href.substring(0, Qe.href.indexOf(";")).split("/").pop() : Qe.download = this.viewer.config.downloadName || Qe.href.split("/").pop();
                    }
                };
                Yp.id = "download";
                var Qp = class extends Hp {
                    constructor(Qe){
                        super(Qe, {
                            className: "psv-fullscreen-button",
                            hoverScale: !0,
                            collapsable: !1,
                            tabbable: !0,
                            icon: yu.fullscreenIn,
                            iconActive: yu.fullscreenOut
                        }), this.viewer.addEventListener(Md.type, this);
                    }
                    destroy() {
                        this.viewer.removeEventListener(Md.type, this), super.destroy();
                    }
                    handleEvent(Qe) {
                        Qe instanceof Md && this.toggleActive(Qe.fullscreenEnabled);
                    }
                    onClick() {
                        this.viewer.toggleFullscreen();
                    }
                };
                Qp.id = "fullscreen";
                var Kp = class extends Hp {
                    constructor(Qe){
                        super(Qe, {
                            className: "psv-menu-button",
                            hoverScale: !0,
                            collapsable: !1,
                            tabbable: !0,
                            icon: yu.menu
                        }), this.viewer.addEventListener(xp.type, this), this.viewer.addEventListener(Dd.type, this), super.hide();
                    }
                    destroy() {
                        this.viewer.removeEventListener(xp.type, this), this.viewer.removeEventListener(Dd.type, this), super.destroy();
                    }
                    handleEvent(Qe) {
                        Qe instanceof xp ? this.toggleActive(Qe.panelId === du.MENU) : Qe instanceof Dd && this.toggleActive(!1);
                    }
                    onClick() {
                        this.state.active ? this.__hideMenu() : this.__showMenu();
                    }
                    hide(Qe) {
                        super.hide(Qe), this.__hideMenu();
                    }
                    show(Qe) {
                        super.show(Qe), this.state.active && this.__showMenu();
                    }
                    __showMenu() {
                        var Qe, rt;
                        this.viewer.panel.show({
                            id: du.MENU,
                            content: (Qe = this.viewer.navbar.collapsed, rt = this.viewer.config.lang.menu, `\n<div class="psv-panel-menu psv-panel-menu--stripped">\n  <h1 class="psv-panel-menu-title">${yu.menu} ${rt}</h1>\n  <ul class="psv-panel-menu-list">\n    ${Qe.map((Qe)=>`\n    <li data-psv-button="${Qe.id}" class="psv-panel-menu-item" tabindex="0">\n      <span class="psv-panel-menu-item-icon">${Qe.content}</span>\n      <span class="psv-panel-menu-item-label">${Qe.title}</span>\n    </li>\n    `).join("")}\n  </ul>\n</div>\n`),
                            noMargin: !0,
                            clickHandler: (Qe)=>{
                                const rt = Qe ? getClosest(Qe, ".psv-panel-menu-item") : void 0, Wn = rt ? rt.dataset.psvButton : void 0;
                                Wn && (this.viewer.navbar.getButton(Wn).onClick(), this.__hideMenu());
                            }
                        });
                    }
                    __hideMenu() {
                        this.viewer.panel.hide(du.MENU);
                    }
                };
                function getIcon(Qe) {
                    let rt = 0;
                    switch(Qe){
                        case 0:
                            rt = 90;
                            break;
                        case 1:
                            rt = -90;
                            break;
                        case 3:
                            rt = 180;
                            break;
                        default:
                            rt = 0;
                    }
                    return yu.arrow.replace("rotate(0", `rotate(${rt}`);
                }
                Kp.id = "menu";
                var Xp = class extends Hp {
                    constructor(Qe, rt){
                        super(Qe, {
                            className: "psv-move-button",
                            hoverScale: !0,
                            collapsable: !1,
                            tabbable: !0,
                            icon: getIcon(rt)
                        }), this.direction = rt, this.handler = new sd, this.container.addEventListener("mousedown", this), this.container.addEventListener("keydown", this), this.container.addEventListener("keyup", this), this.viewer.container.addEventListener("mouseup", this), this.viewer.container.addEventListener("touchend", this);
                    }
                    destroy() {
                        this.__onMouseUp(), this.viewer.container.removeEventListener("mouseup", this), this.viewer.container.removeEventListener("touchend", this), super.destroy();
                    }
                    handleEvent(Qe) {
                        switch(Qe.type){
                            case "mousedown":
                                this.__onMouseDown();
                                break;
                            case "mouseup":
                            case "touchend":
                                this.__onMouseUp();
                                break;
                            case "keydown":
                                Qe.key === fu.Enter && this.__onMouseDown();
                                break;
                            case "keyup":
                                Qe.key === fu.Enter && this.__onMouseUp();
                        }
                    }
                    onClick() {}
                    isSupported() {
                        return invertResolvableBoolean(Fp.isTouchEnabled);
                    }
                    __onMouseDown() {
                        if (!this.state.enabled) return;
                        const Qe = {};
                        switch(this.direction){
                            case 0:
                                Qe.pitch = !1;
                                break;
                            case 1:
                                Qe.pitch = !0;
                                break;
                            case 3:
                                Qe.yaw = !1;
                                break;
                            default:
                                Qe.yaw = !0;
                        }
                        this.viewer.stopAll(), this.viewer.dynamics.position.roll(Qe), this.handler.down();
                    }
                    __onMouseUp() {
                        this.state.enabled && this.handler.up(()=>{
                            this.viewer.dynamics.position.stop(), this.viewer.resetIdleTimer();
                        });
                    }
                };
                Xp.groupId = "move";
                var Jp = class extends Xp {
                    constructor(Qe){
                        super(Qe, 1);
                    }
                };
                Jp.id = "moveDown";
                var $p = class extends Xp {
                    constructor(Qe){
                        super(Qe, 2);
                    }
                };
                $p.id = "moveLeft";
                var em = class extends Xp {
                    constructor(Qe){
                        super(Qe, 3);
                    }
                };
                em.id = "moveRight";
                var tm = class extends Xp {
                    constructor(Qe){
                        super(Qe, 0);
                    }
                };
                tm.id = "moveUp";
                var im = class extends Hp {
                    constructor(Qe, rt, Wn){
                        super(Qe, {
                            className: "psv-zoom-button",
                            hoverScale: !0,
                            collapsable: !1,
                            tabbable: !0,
                            icon: rt
                        }), this.direction = Wn, this.handler = new sd, this.container.addEventListener("mousedown", this), this.container.addEventListener("keydown", this), this.container.addEventListener("keyup", this), this.viewer.container.addEventListener("mouseup", this), this.viewer.container.addEventListener("touchend", this);
                    }
                    destroy() {
                        this.__onMouseUp(), this.viewer.container.removeEventListener("mouseup", this), this.viewer.container.removeEventListener("touchend", this), super.destroy();
                    }
                    handleEvent(Qe) {
                        switch(Qe.type){
                            case "mousedown":
                                this.__onMouseDown();
                                break;
                            case "mouseup":
                            case "touchend":
                                this.__onMouseUp();
                                break;
                            case "keydown":
                                Qe.key === fu.Enter && this.__onMouseDown();
                                break;
                            case "keyup":
                                Qe.key === fu.Enter && this.__onMouseUp();
                        }
                    }
                    onClick() {}
                    isSupported() {
                        return invertResolvableBoolean(Fp.isTouchEnabled);
                    }
                    __onMouseDown() {
                        this.state.enabled && (this.viewer.dynamics.zoom.roll(1 === this.direction), this.handler.down());
                    }
                    __onMouseUp() {
                        this.state.enabled && this.handler.up(()=>this.viewer.dynamics.zoom.stop());
                    }
                };
                im.groupId = "zoom";
                var nm = class extends im {
                    constructor(Qe){
                        super(Qe, yu.zoomIn, 0);
                    }
                };
                nm.id = "zoomIn";
                var rm = class extends im {
                    constructor(Qe){
                        super(Qe, yu.zoomOut, 1);
                    }
                };
                rm.id = "zoomOut";
                var sm = class extends Hp {
                    constructor(Qe){
                        super(Qe, {
                            className: "psv-zoom-range",
                            hoverScale: !1,
                            collapsable: !1,
                            tabbable: !1
                        }), this.zoomRange = document.createElement("div"), this.zoomRange.className = "psv-zoom-range-line", this.container.appendChild(this.zoomRange), this.zoomValue = document.createElement("div"), this.zoomValue.className = "psv-zoom-range-handle", this.zoomRange.appendChild(this.zoomValue), this.slider = new od(this.container, "HORIZONTAL", (Qe)=>this.__onSliderUpdate(Qe)), this.mediaMinWidth = parseInt(getStyleProperty(this.container, "max-width"), 10), this.viewer.addEventListener(kp.type, this), this.viewer.state.ready ? this.__moveZoomValue(this.viewer.getZoomLevel()) : this.viewer.addEventListener(Xd.type, this);
                    }
                    destroy() {
                        this.slider.destroy(), this.viewer.removeEventListener(kp.type, this), this.viewer.removeEventListener(Xd.type, this), super.destroy();
                    }
                    handleEvent(Qe) {
                        Qe instanceof kp ? this.__moveZoomValue(Qe.zoomLevel) : Qe instanceof Xd && this.__moveZoomValue(this.viewer.getZoomLevel());
                    }
                    onClick() {}
                    isSupported() {
                        return invertResolvableBoolean(Fp.isTouchEnabled);
                    }
                    autoSize() {
                        this.state.supported && (this.viewer.state.size.width <= this.mediaMinWidth && this.state.visible ? this.hide(!1) : this.viewer.state.size.width > this.mediaMinWidth && !this.state.visible && this.show(!1));
                    }
                    __moveZoomValue(Qe) {
                        this.zoomValue.style.left = Qe / 100 * this.zoomRange.offsetWidth - this.zoomValue.offsetWidth / 2 + "px";
                    }
                    __onSliderUpdate(Qe) {
                        Qe.mousedown && this.viewer.zoom(100 * Qe.value);
                    }
                };
                sm.id = "zoomRange", sm.groupId = "zoom";
                var am = class extends ud {
                    constructor(Qe){
                        super(), this.viewer = Qe;
                    }
                    init() {}
                    destroy() {}
                }, om = class extends am {
                    constructor(Qe, rt){
                        super(Qe), this.config = this.constructor.configParser(rt);
                    }
                    setOption(Qe, rt) {
                        this.setOptions({
                            [Qe]: rt
                        });
                    }
                    setOptions(Qe) {
                        const rt = {
                            ...this.config,
                            ...Qe
                        }, Wn = this.constructor, Co = Wn.configParser, Dl = Wn.readonlyOptions, Ll = Wn.id;
                        for (let [Rl, Ul] of Object.entries(Qe))Rl in Co.defaults ? Dl.includes(Rl) ? logWarn(`${Ll}: Option "${Rl}" cannot be updated`) : (Rl in Co.parsers && (Ul = Co.parsers[Rl](Ul, {
                            rawConfig: rt,
                            defValue: Co.defaults[Rl]
                        })), this.config[Rl] = Ul) : logWarn(`${Ll}: Unknown option "${Rl}"`);
                    }
                };
                function pluginInterop(Qe) {
                    if (Qe) {
                        for (const [, rt] of [
                            [
                                "_",
                                Qe
                            ],
                            ...Object.entries(Qe)
                        ])if (rt.prototype instanceof am) return checkVersion(rt.id, rt.VERSION, "5.12.1"), rt;
                    }
                    return null;
                }
                om.readonlyOptions = [];
                var lm = {
                    panorama: null,
                    container: null,
                    adapter: [
                        Up,
                        null
                    ],
                    plugins: [],
                    caption: null,
                    description: null,
                    downloadUrl: null,
                    downloadName: null,
                    loadingImg: null,
                    loadingTxt: "",
                    size: null,
                    fisheye: 0,
                    minFov: 30,
                    maxFov: 90,
                    defaultZoomLvl: 50,
                    defaultYaw: 0,
                    defaultPitch: 0,
                    sphereCorrection: null,
                    moveSpeed: 1,
                    zoomSpeed: 1,
                    moveInertia: .8,
                    mousewheel: !0,
                    mousemove: !0,
                    mousewheelCtrlKey: !1,
                    touchmoveTwoFingers: !1,
                    panoData: null,
                    requestHeaders: null,
                    canvasBackground: "#000",
                    defaultTransition: {
                        speed: 1500,
                        rotation: !0,
                        effect: "fade"
                    },
                    rendererParameters: {
                        alpha: !0,
                        antialias: !0
                    },
                    withCredentials: !1,
                    navbar: [
                        "zoom",
                        "move",
                        "download",
                        "description",
                        "caption",
                        "fullscreen"
                    ],
                    lang: {
                        zoom: "Zoom",
                        zoomOut: "Zoom out",
                        zoomIn: "Zoom in",
                        moveUp: "Move up",
                        moveDown: "Move down",
                        moveLeft: "Move left",
                        moveRight: "Move right",
                        description: "Description",
                        download: "Download",
                        fullscreen: "Fullscreen",
                        loading: "Loading...",
                        menu: "Menu",
                        close: "Close",
                        twoFingers: "Use two fingers to navigate",
                        ctrlZoom: "Use ctrl + scroll to zoom the image",
                        loadError: "The panorama cannot be loaded",
                        webglError: "Your browser does not seem to support WebGL"
                    },
                    keyboard: "fullscreen",
                    keyboardActions: {
                        [fu.ArrowUp]: "ROTATE_UP",
                        [fu.ArrowDown]: "ROTATE_DOWN",
                        [fu.ArrowRight]: "ROTATE_RIGHT",
                        [fu.ArrowLeft]: "ROTATE_LEFT",
                        [fu.PageUp]: "ZOOM_IN",
                        [fu.PageDown]: "ZOOM_OUT",
                        [fu.Plus]: "ZOOM_IN",
                        [fu.Minus]: "ZOOM_OUT"
                    }
                }, cm = {
                    panorama: "Use setPanorama method to change the panorama",
                    panoData: "Use setPanorama method to change the panorama",
                    container: "Cannot change viewer container",
                    adapter: "Cannot change adapter",
                    plugins: "Cannot change plugins"
                }, um = {
                    container: (Qe)=>{
                        if (!Qe) throw new Lu("No value given for container.");
                        return Qe;
                    },
                    adapter: (Qe, rt)=>{
                        let { defValue: Wn } = rt;
                        if (!(Qe = Qe ? Array.isArray(Qe) ? [
                            adapterInterop(Qe[0]),
                            Qe[1]
                        ] : [
                            adapterInterop(Qe),
                            null
                        ] : Wn)[0]) throw new Lu("An undefined value was given for adapter.");
                        if (!Qe[0].id) throw new Lu("Adapter has no id.");
                        return Qe;
                    },
                    defaultYaw: (Qe)=>parseAngle(Qe),
                    defaultPitch: (Qe)=>parseAngle(Qe, !0),
                    defaultZoomLvl: (Qe)=>Co.cj9.clamp(Qe, 0, 100),
                    minFov: (Qe, rt)=>{
                        let { rawConfig: Wn } = rt;
                        return Wn.maxFov < Qe && (logWarn("maxFov cannot be lower than minFov"), Qe = Wn.maxFov), Co.cj9.clamp(Qe, 1, 179);
                    },
                    maxFov: (Qe, rt)=>{
                        let { rawConfig: Wn } = rt;
                        return Qe < Wn.minFov && (Qe = Wn.minFov), Co.cj9.clamp(Qe, 1, 179);
                    },
                    moveInertia: (Qe, rt)=>{
                        let { defValue: Wn } = rt;
                        return !0 === Qe ? Wn : !1 === Qe ? 0 : Qe;
                    },
                    lang: (Qe)=>({
                            ...lm.lang,
                            ...Qe
                        }),
                    keyboardActions: (Qe, rt)=>{
                        let { rawConfig: Wn } = rt;
                        return Wn.keyboard && "object" === typeof Wn.keyboard ? Wn.keyboard : Qe;
                    },
                    fisheye: (Qe)=>!0 === Qe ? 1 : !1 === Qe ? 0 : Qe,
                    requestHeaders: (Qe)=>Qe && "object" === typeof Qe ? ()=>Qe : "function" === typeof Qe ? Qe : null,
                    defaultTransition: (Qe, rt)=>{
                        let { defValue: Wn } = rt;
                        return null === Qe || 0 === Qe.speed ? null : {
                            ...Wn,
                            ...Qe
                        };
                    },
                    rendererParameters: (Qe, rt)=>{
                        let { defValue: Wn } = rt;
                        return {
                            ...Qe,
                            ...Wn
                        };
                    },
                    plugins: (Qe)=>Qe.map((Qe, rt)=>{
                            if (!(Qe = Array.isArray(Qe) ? [
                                pluginInterop(Qe[0]),
                                Qe[1]
                            ] : [
                                pluginInterop(Qe),
                                null
                            ])[0]) throw new Lu(`An undefined value was given for plugin ${rt}.`);
                            if (!Qe[0].id) throw new Lu(`Plugin ${rt} has no id.`);
                            return Qe;
                        }),
                    navbar: (Qe)=>!1 === Qe ? null : !0 === Qe ? clone(lm.navbar) : "string" === typeof Qe ? Qe.split(/[ ,]/) : Qe
                }, hm = getConfigParser(lm, um), dm = class extends Hp {
                    constructor(Qe){
                        super(Qe, {
                            className: "psv-caption",
                            hoverScale: !1,
                            collapsable: !1,
                            tabbable: !0
                        }), this.contentWidth = 0, this.state.width = 0, this.contentElt = document.createElement("div"), this.contentElt.className = "psv-caption-content", this.container.appendChild(this.contentElt), this.setCaption(this.viewer.config.caption);
                    }
                    hide() {
                        this.contentElt.style.display = "none", this.state.visible = !1;
                    }
                    show() {
                        this.contentElt.style.display = "", this.state.visible = !0;
                    }
                    onClick() {}
                    setCaption(Qe) {
                        this.show(), this.contentElt.innerHTML = Qe ?? "", this.contentElt.innerHTML ? this.contentWidth = this.contentElt.offsetWidth : this.contentWidth = 0, this.autoSize();
                    }
                    autoSize() {
                        this.toggle(this.container.offsetWidth >= this.contentWidth), this.__refreshButton();
                    }
                    __refreshButton() {
                        this.viewer.navbar.getButton(qp.id, !1)?.autoSize(!0);
                    }
                };
                dm.id = "caption";
                var pm = {}, mm = {};
                function registerButton(Qe, rt) {
                    if (!Qe.id) throw new Lu("Button id is required");
                    if (pm[Qe.id] = Qe, Qe.groupId && (mm[Qe.groupId] = mm[Qe.groupId] || []).push(Qe), rt) {
                        const Wn = lm.navbar;
                        switch(rt){
                            case "start":
                                Wn.unshift(Qe.id);
                                break;
                            case "end":
                                Wn.push(Qe.id);
                                break;
                            default:
                                {
                                    const [Co, Dl] = rt.split(":"), Ll = Wn.indexOf(Co);
                                    if (!Co || !Dl || -1 === Ll) throw new Lu(`Invalid defaultPosition ${rt}`);
                                    Wn.splice(Ll + ("right" === Dl ? 1 : 0), 0, Qe.id);
                                }
                        }
                    }
                }
                [
                    rm,
                    sm,
                    nm,
                    qp,
                    dm,
                    Yp,
                    Qp,
                    $p,
                    em,
                    tm,
                    Jp
                ].forEach((Qe)=>registerButton(Qe));
                var fm = class extends Gp {
                    constructor(Qe){
                        super(Qe, {
                            className: `psv-navbar ${tu}`
                        }), this.collapsed = [], this.state.visible = !1;
                    }
                    show() {
                        this.viewer.container.classList.add("psv--has-navbar"), this.container.classList.add("psv-navbar--open"), this.state.visible = !0;
                    }
                    hide() {
                        this.viewer.container.classList.remove("psv--has-navbar"), this.container.classList.remove("psv-navbar--open"), this.state.visible = !1;
                    }
                    setButtons(Qe) {
                        this.children.slice().forEach((Qe)=>Qe.destroy()), this.children.length = 0, -1 !== Qe.indexOf(dm.id) && -1 === Qe.indexOf(qp.id) && Qe.splice(Qe.indexOf(dm.id), 0, qp.id), Qe.forEach((Qe)=>{
                            "object" === typeof Qe ? new Wp(this, Qe) : pm[Qe] ? new pm[Qe](this) : mm[Qe] ? mm[Qe].forEach((Qe)=>{
                                new Qe(this);
                            }) : logWarn(`Unknown button ${Qe}`);
                        }), new Kp(this), this.children.forEach((Qe)=>{
                            Qe instanceof Hp && Qe.checkSupported();
                        }), this.autoSize();
                    }
                    setCaption(Qe) {
                        this.children.some((rt)=>rt instanceof dm && (rt.setCaption(Qe), !0));
                    }
                    getButton(Qe, rt) {
                        void 0 === rt && (rt = !0);
                        const Wn = this.children.find((rt)=>rt instanceof Hp && rt.id === Qe);
                        return !Wn && rt && logWarn(`button "${Qe}" not found in the navbar`), Wn;
                    }
                    autoSize() {
                        this.children.forEach((Qe)=>{
                            Qe instanceof Hp && Qe.autoSize();
                        });
                        const Qe = this.container.offsetWidth;
                        let rt = 0;
                        const Wn = [];
                        this.children.forEach((Qe)=>{
                            Qe.isVisible() && Qe instanceof Hp && (rt += Qe.width, Qe.collapsable && Wn.push(Qe));
                        }), 0 !== rt && (Qe < rt && Wn.length > 0 ? (Wn.forEach((Qe)=>Qe.collapse()), this.collapsed = Wn, this.getButton(Kp.id).show(!1)) : Qe >= rt && this.collapsed.length > 0 && (this.collapsed.forEach((Qe)=>Qe.uncollapse()), this.collapsed = [], this.getButton(Kp.id).hide(!1)), this.getButton(dm.id, !1)?.autoSize());
                    }
                };
                Co.l2R.enabled = !1;
                var gm = {
                    enabled: !0,
                    maxItems: 10,
                    ttl: 600,
                    items: {},
                    purgeInterval: null,
                    init () {
                        Co.l2R.enabled && (logWarn("ThreeJS cache should be disabled"), Co.l2R.enabled = !1), !this.purgeInterval && this.enabled && (this.purgeInterval = setInterval(()=>this.purge(), 6e4));
                    },
                    add (Qe, rt, Wn) {
                        this.enabled && rt && (this.items[rt] = this.items[rt] ?? {
                            files: {},
                            lastAccess: null
                        }, this.items[rt].files[Qe] = Wn, this.items[rt].lastAccess = Date.now());
                    },
                    get (Qe, rt) {
                        if (this.enabled && rt && this.items[rt]) return this.items[rt].lastAccess = Date.now(), this.items[rt].files[Qe];
                    },
                    remove (Qe, rt) {
                        this.enabled && rt && this.items[rt] && (delete this.items[rt].files[Qe], 0 === Object.keys(this.items[rt].files).length && delete this.items[rt]);
                    },
                    purge () {
                        Object.entries(this.items).sort((Qe, rt)=>{
                            let [, Wn] = Qe, [, Co] = rt;
                            return Co.lastAccess - Wn.lastAccess;
                        }).forEach((Qe, rt)=>{
                            let [Wn, { lastAccess: Co }] = Qe;
                            rt > 0 && (Date.now() - Co >= 1e3 * this.ttl || rt >= this.maxItems) && delete this.items[Wn];
                        });
                    }
                }, Am = class extends Gp {
                    constructor(Qe){
                        super(Qe, {
                            className: "psv-loader-container"
                        }), this.loader = document.createElement("div"), this.loader.className = "psv-loader", this.container.appendChild(this.loader), this.size = this.loader.offsetWidth, this.canvas = document.createElementNS("http://www.w3.org/2000/svg", "svg"), this.canvas.setAttribute("class", "psv-loader-canvas"), this.canvas.setAttribute("viewBox", `0 0 ${this.size} ${this.size}`), this.loader.appendChild(this.canvas), this.textColor = getStyleProperty(this.loader, "color"), this.color = getStyleProperty(this.canvas, "color"), this.border = parseInt(getStyleProperty(this.loader, "--psv-loader-border"), 10), this.thickness = parseInt(getStyleProperty(this.loader, "--psv-loader-tickness"), 10);
                        const rt = this.size / 2;
                        this.canvas.innerHTML = `\n            <circle cx="${rt}" cy="${rt}" r="${rt}" fill="${this.color}"/>\n            <path d="" fill="none" stroke="${this.textColor}" stroke-width="${this.thickness}" stroke-linecap="round"/>\n        `, this.viewer.addEventListener(xd.type, this), this.__updateContent(), this.hide();
                    }
                    destroy() {
                        this.viewer.removeEventListener(xd.type, this), super.destroy();
                    }
                    handleEvent(Qe) {
                        Qe instanceof xd && Qe.containsOptions("loadingImg", "loadingTxt", "lang") && this.__updateContent();
                    }
                    setProgress(Qe) {
                        const rt = Co.cj9.clamp(Qe, 0, 99.999) / 100 * Math.PI * 2, Wn = this.size / 2, Dl = Wn, Ll = this.thickness / 2 + this.border, Rl = (this.size - this.thickness) / 2 - this.border, Ul = Math.sin(rt) * Rl + Wn, Gl = -Math.cos(rt) * Rl + Wn, Zl = Qe > 50 ? "1" : "0";
                        this.canvas.querySelector("path").setAttributeNS(null, "d", `M ${Dl} ${Ll} A ${Rl} ${Rl} 0 ${Zl} 1 ${Ul} ${Gl}`), this.viewer.dispatchEvent(new Bd(Math.round(Qe)));
                    }
                    __updateContent() {
                        const Qe = this.loader.querySelector(".psv-loader-image, .psv-loader-text");
                        let rt;
                        if (Qe && this.loader.removeChild(Qe), this.viewer.config.loadingImg ? (rt = document.createElement("img"), rt.className = "psv-loader-image", rt.src = this.viewer.config.loadingImg) : null !== this.viewer.config.loadingTxt && (rt = document.createElement("div"), rt.className = "psv-loader-text", rt.innerHTML = this.viewer.config.loadingTxt || this.viewer.config.lang.loading), rt) {
                            const Qe = Math.round(Math.sqrt(2 * Math.pow(this.size / 2 - this.thickness / 2 - this.border, 2)));
                            rt.style.maxWidth = Qe + "px", rt.style.maxHeight = Qe + "px", this.loader.appendChild(rt);
                        }
                    }
                }, ym = class extends Gp {
                    constructor(Qe){
                        super(Qe, {
                            className: "psv-notification"
                        }), this.state = {
                            visible: !1,
                            contentId: null,
                            timeout: null
                        }, this.content = document.createElement("div"), this.content.className = "psv-notification-content", this.container.appendChild(this.content), this.content.addEventListener("click", ()=>this.hide());
                    }
                    isVisible(Qe) {
                        return this.state.visible && (!Qe || !this.state.contentId || this.state.contentId === Qe);
                    }
                    toggle() {
                        throw new Lu("Notification cannot be toggled");
                    }
                    show(Qe) {
                        this.state.timeout && (clearTimeout(this.state.timeout), this.state.timeout = null), "string" === typeof Qe && (Qe = {
                            content: Qe
                        }), this.state.contentId = Qe.id || null, this.content.innerHTML = Qe.content, this.container.classList.add("psv-notification--visible"), this.state.visible = !0, this.viewer.dispatchEvent(new gp(this.state.contentId)), Qe.timeout && (this.state.timeout = setTimeout(()=>this.hide(this.state.contentId), Qe.timeout));
                    }
                    hide(Qe) {
                        if (this.isVisible(Qe)) {
                            const Qe = this.state.contentId;
                            this.container.classList.remove("psv-notification--visible"), this.state.visible = !1, this.state.contentId = null, this.viewer.dispatchEvent(new Td(Qe));
                        }
                    }
                }, vm = class extends Gp {
                    constructor(Qe){
                        super(Qe, {
                            className: `psv-overlay ${tu}`
                        }), this.state = {
                            visible: !1,
                            contentId: null,
                            dismissible: !0
                        }, this.image = document.createElement("div"), this.image.className = "psv-overlay-image", this.container.appendChild(this.image), this.title = document.createElement("div"), this.title.className = "psv-overlay-title", this.container.appendChild(this.title), this.text = document.createElement("div"), this.text.className = "psv-overlay-text", this.container.appendChild(this.text), this.container.addEventListener("click", this), this.viewer.addEventListener(Nd.type, this), super.hide();
                    }
                    destroy() {
                        this.viewer.removeEventListener(Nd.type, this), super.destroy();
                    }
                    handleEvent(Qe) {
                        "click" === Qe.type ? this.isVisible() && this.state.dismissible && (this.hide(), Qe.stopPropagation()) : Qe instanceof Nd && this.isVisible() && this.state.dismissible && Qe.key === fu.Escape && (this.hide(), Qe.preventDefault());
                    }
                    isVisible(Qe) {
                        return this.state.visible && (!Qe || !this.state.contentId || this.state.contentId === Qe);
                    }
                    toggle() {
                        throw new Lu("Overlay cannot be toggled");
                    }
                    show(Qe) {
                        "string" === typeof Qe && (Qe = {
                            title: Qe
                        }), this.state.contentId = Qe.id || null, this.state.dismissible = !1 !== Qe.dismissible, this.image.innerHTML = Qe.image || "", this.title.innerHTML = Qe.title || "", this.text.innerHTML = Qe.text || "", super.show(), this.viewer.dispatchEvent(new vp(this.state.contentId));
                    }
                    hide(Qe) {
                        if (this.isVisible(Qe)) {
                            const Qe = this.state.contentId;
                            super.hide(), this.state.contentId = null, this.viewer.dispatchEvent(new kd(Qe));
                        }
                    }
                }, _m = "psv-panel-content--no-interaction", xm = class extends Gp {
                    constructor(Qe){
                        super(Qe, {
                            className: `psv-panel ${tu}`
                        }), this.state = {
                            visible: !1,
                            contentId: null,
                            mouseX: 0,
                            mouseY: 0,
                            mousedown: !1,
                            clickHandler: null,
                            keyHandler: null,
                            width: {}
                        };
                        const rt = document.createElement("div");
                        rt.className = "psv-panel-resizer", this.container.appendChild(rt);
                        const Wn = document.createElement("div");
                        Wn.className = "psv-panel-close-button", Wn.innerHTML = yu.close, Wn.title = Qe.config.lang.close, this.container.appendChild(Wn), this.content = document.createElement("div"), this.content.className = "psv-panel-content", this.container.appendChild(this.content), Wn.addEventListener("click", ()=>this.hide()), rt.addEventListener("mousedown", this), rt.addEventListener("touchstart", this), this.viewer.container.addEventListener("mouseup", this), this.viewer.container.addEventListener("touchend", this), this.viewer.container.addEventListener("mousemove", this), this.viewer.container.addEventListener("touchmove", this), this.viewer.addEventListener(Nd.type, this);
                    }
                    destroy() {
                        this.viewer.removeEventListener(Nd.type, this), this.viewer.container.removeEventListener("mousemove", this), this.viewer.container.removeEventListener("touchmove", this), this.viewer.container.removeEventListener("mouseup", this), this.viewer.container.removeEventListener("touchend", this), super.destroy();
                    }
                    handleEvent(Qe) {
                        switch(Qe.type){
                            case "mousedown":
                                this.__onMouseDown(Qe);
                                break;
                            case "touchstart":
                                this.__onTouchStart(Qe);
                                break;
                            case "mousemove":
                                this.__onMouseMove(Qe);
                                break;
                            case "touchmove":
                                this.__onTouchMove(Qe);
                                break;
                            case "mouseup":
                                this.__onMouseUp(Qe);
                                break;
                            case "touchend":
                                this.__onTouchEnd(Qe);
                                break;
                            case Nd.type:
                                this.__onKeyPress(Qe);
                        }
                    }
                    isVisible(Qe) {
                        return this.state.visible && (!Qe || !this.state.contentId || this.state.contentId === Qe);
                    }
                    toggle() {
                        throw new Lu("Panel cannot be toggled");
                    }
                    show(Qe) {
                        "string" === typeof Qe && (Qe = {
                            content: Qe
                        });
                        const rt = this.isVisible(Qe.id);
                        this.state.contentId = Qe.id || null, this.state.visible = !0, this.state.clickHandler && (this.content.removeEventListener("click", this.state.clickHandler), this.content.removeEventListener("keydown", this.state.keyHandler), this.state.clickHandler = null, this.state.keyHandler = null), Qe.id && this.state.width[Qe.id] ? this.container.style.width = this.state.width[Qe.id] : Qe.width ? this.container.style.width = Qe.width : this.container.style.width = null, this.content.innerHTML = Qe.content, this.content.scrollTop = 0, this.container.classList.add("psv-panel--open"), toggleClass(this.content, "psv-panel-content--no-margin", !0 === Qe.noMargin), Qe.clickHandler && (this.state.clickHandler = (rt)=>{
                            Qe.clickHandler(getEventTarget(rt));
                        }, this.state.keyHandler = (rt)=>{
                            rt.key === fu.Enter && Qe.clickHandler(getEventTarget(rt));
                        }, this.content.addEventListener("click", this.state.clickHandler), this.content.addEventListener("keydown", this.state.keyHandler), rt || setTimeout(()=>{
                            this.content.querySelector("a,button,[tabindex]")?.focus();
                        }, 300)), this.viewer.dispatchEvent(new xp(this.state.contentId));
                    }
                    hide(Qe) {
                        if (this.isVisible(Qe)) {
                            const Qe = this.state.contentId;
                            this.state.visible = !1, this.state.contentId = null, this.content.innerHTML = null, this.container.classList.remove("psv-panel--open"), this.state.clickHandler && (this.content.removeEventListener("click", this.state.clickHandler), this.content.removeEventListener("keydown", this.state.keyHandler), this.state.clickHandler = null, this.state.keyHandler = null), this.viewer.dispatchEvent(new Dd(Qe));
                        }
                    }
                    __onMouseDown(Qe) {
                        Qe.stopPropagation(), this.__startResize(Qe.clientX, Qe.clientY);
                    }
                    __onTouchStart(Qe) {
                        if (Qe.stopPropagation(), 1 === Qe.touches.length) {
                            const rt = Qe.touches[0];
                            this.__startResize(rt.clientX, rt.clientY);
                        }
                    }
                    __onMouseUp(Qe) {
                        this.state.mousedown && (Qe.stopPropagation(), this.state.mousedown = !1, this.content.classList.remove(_m));
                    }
                    __onTouchEnd(Qe) {
                        this.state.mousedown && (Qe.stopPropagation(), 0 === Qe.touches.length && (this.state.mousedown = !1, this.content.classList.remove(_m)));
                    }
                    __onMouseMove(Qe) {
                        this.state.mousedown && (Qe.stopPropagation(), this.__resize(Qe.clientX, Qe.clientY));
                    }
                    __onTouchMove(Qe) {
                        if (this.state.mousedown) {
                            const rt = Qe.touches[0];
                            this.__resize(rt.clientX, rt.clientY);
                        }
                    }
                    __onKeyPress(Qe) {
                        this.isVisible() && Qe.key === fu.Escape && (this.hide(), Qe.preventDefault());
                    }
                    __startResize(Qe, rt) {
                        this.state.mouseX = Qe, this.state.mouseY = rt, this.state.mousedown = !0, this.content.classList.add(_m);
                    }
                    __resize(Qe, rt) {
                        const Wn = Qe, Co = rt, Dl = Math.max(200, this.container.offsetWidth - (Wn - this.state.mouseX)) + "px";
                        this.state.contentId && (this.state.width[this.state.contentId] = Dl), this.container.style.width = Dl, this.state.mouseX = Wn, this.state.mouseY = Co;
                    }
                }, bm = class extends Gp {
                    constructor(Qe, rt){
                        super(Qe, {
                            className: "psv-tooltip"
                        }), this.state = {
                            visible: !0,
                            arrow: 0,
                            border: 0,
                            state: 0,
                            width: 0,
                            height: 0,
                            pos: "",
                            config: null,
                            data: null,
                            hideTimeout: null
                        }, this.content = document.createElement("div"), this.content.className = "psv-tooltip-content", this.container.appendChild(this.content), this.arrow = document.createElement("div"), this.arrow.className = "psv-tooltip-arrow", this.container.appendChild(this.arrow), this.container.addEventListener("transitionend", this), this.container.addEventListener("touchdown", (Qe)=>Qe.stopPropagation()), this.container.addEventListener("mousedown", (Qe)=>Qe.stopPropagation()), this.container.style.top = "-1000px", this.container.style.left = "-1000px", this.show(rt);
                    }
                    handleEvent(Qe) {
                        "transitionend" === Qe.type && this.__onTransitionEnd(Qe);
                    }
                    destroy() {
                        clearTimeout(this.state.hideTimeout), delete this.state.data, super.destroy();
                    }
                    toggle() {
                        throw new Lu("Tooltip cannot be toggled");
                    }
                    show(Qe) {
                        if (0 !== this.state.state) throw new Lu("Initialized tooltip cannot be re-initialized");
                        Qe.className && addClasses(this.container, Qe.className), Qe.style && Object.assign(this.container.style, Qe.style), this.state.state = 3, this.update(Qe.content, Qe), this.state.data = Qe.data, this.state.state = 1, this.viewer.dispatchEvent(new wp(this, this.state.data)), this.__waitImages();
                    }
                    update(Qe, rt) {
                        this.content.innerHTML = Qe;
                        const Wn = this.container.getBoundingClientRect();
                        this.state.width = Wn.right - Wn.left, this.state.height = Wn.bottom - Wn.top, this.state.arrow = parseInt(getStyleProperty(this.arrow, "border-top-width"), 10), this.state.border = parseInt(getStyleProperty(this.container, "border-top-left-radius"), 10), this.move(rt ?? this.state.config), this.__waitImages();
                    }
                    move(Qe) {
                        if (1 !== this.state.state && 3 !== this.state.state) throw new Lu("Uninitialized tooltip cannot be moved");
                        Qe.box = Qe.box ?? this.state.config?.box ?? {
                            width: 0,
                            height: 0
                        }, this.state.config = Qe;
                        const rt = this.container, Wn = this.arrow, Co = {
                            posClass: cleanCssPosition(Qe.position, {
                                allowCenter: !1,
                                cssOrder: !1
                            }) || [
                                "top",
                                "center"
                            ],
                            width: this.state.width,
                            height: this.state.height,
                            top: 0,
                            left: 0,
                            arrowTop: 0,
                            arrowLeft: 0
                        };
                        this.__computeTooltipPosition(Co, Qe);
                        let Dl = null, Ll = null;
                        if (Co.top < 0 ? Dl = "bottom" : Co.top + Co.height > this.viewer.state.size.height && (Dl = "top"), Co.left < 0 ? Ll = "right" : Co.left + Co.width > this.viewer.state.size.width && (Ll = "left"), Ll || Dl) {
                            const rt = cssPositionIsOrdered(Co.posClass);
                            Dl && (Co.posClass[rt ? 0 : 1] = Dl), Ll && (Co.posClass[rt ? 1 : 0] = Ll), this.__computeTooltipPosition(Co, Qe);
                        }
                        rt.style.top = Co.top + "px", rt.style.left = Co.left + "px", Wn.style.top = Co.arrowTop + "px", Wn.style.left = Co.arrowLeft + "px";
                        const Rl = Co.posClass.join("-");
                        Rl !== this.state.pos && (rt.classList.remove(`psv-tooltip--${this.state.pos}`), this.state.pos = Rl, rt.classList.add(`psv-tooltip--${this.state.pos}`));
                    }
                    hide() {
                        this.container.classList.remove("psv-tooltip--visible"), this.state.state = 2, this.viewer.dispatchEvent(new Pd(this.state.data));
                        const Qe = parseFloat(getStyleProperty(this.container, "transition-duration"));
                        this.state.hideTimeout = setTimeout(()=>{
                            this.destroy();
                        }, 2 * Qe);
                    }
                    __onTransitionEnd(Qe) {
                        if ("transform" === Qe.propertyName) switch(this.state.state){
                            case 1:
                                this.container.classList.add("psv-tooltip--visible"), this.state.state = 3;
                                break;
                            case 2:
                                this.state.state = 0, this.destroy();
                        }
                    }
                    __computeTooltipPosition(Qe, rt) {
                        const Wn = this.state.arrow, Co = rt.top, Dl = Qe.height, Ll = rt.left, Rl = Qe.width, Ul = Wn + this.state.border, Gl = rt.box.width / 2 + 2 * Wn, Zl = rt.box.height / 2 + 2 * Wn;
                        switch(Qe.posClass.join("-")){
                            case "top-left":
                                Qe.top = Co - Zl - Dl, Qe.left = Ll + Ul - Rl, Qe.arrowTop = Dl, Qe.arrowLeft = Rl - Ul - Wn;
                                break;
                            case "top-center":
                                Qe.top = Co - Zl - Dl, Qe.left = Ll - Rl / 2, Qe.arrowTop = Dl, Qe.arrowLeft = Rl / 2 - Wn;
                                break;
                            case "top-right":
                                Qe.top = Co - Zl - Dl, Qe.left = Ll - Ul, Qe.arrowTop = Dl, Qe.arrowLeft = Wn;
                                break;
                            case "bottom-left":
                                Qe.top = Co + Zl, Qe.left = Ll + Ul - Rl, Qe.arrowTop = 2 * -Wn, Qe.arrowLeft = Rl - Ul - Wn;
                                break;
                            case "bottom-center":
                                Qe.top = Co + Zl, Qe.left = Ll - Rl / 2, Qe.arrowTop = 2 * -Wn, Qe.arrowLeft = Rl / 2 - Wn;
                                break;
                            case "bottom-right":
                                Qe.top = Co + Zl, Qe.left = Ll - Ul, Qe.arrowTop = 2 * -Wn, Qe.arrowLeft = Wn;
                                break;
                            case "left-top":
                                Qe.top = Co + Ul - Dl, Qe.left = Ll - Gl - Rl, Qe.arrowTop = Dl - Ul - Wn, Qe.arrowLeft = Rl;
                                break;
                            case "center-left":
                                Qe.top = Co - Dl / 2, Qe.left = Ll - Gl - Rl, Qe.arrowTop = Dl / 2 - Wn, Qe.arrowLeft = Rl;
                                break;
                            case "left-bottom":
                                Qe.top = Co - Ul, Qe.left = Ll - Gl - Rl, Qe.arrowTop = Wn, Qe.arrowLeft = Rl;
                                break;
                            case "right-top":
                                Qe.top = Co + Ul - Dl, Qe.left = Ll + Gl, Qe.arrowTop = Dl - Ul - Wn, Qe.arrowLeft = 2 * -Wn;
                                break;
                            case "center-right":
                                Qe.top = Co - Dl / 2, Qe.left = Ll + Gl, Qe.arrowTop = Dl / 2 - Wn, Qe.arrowLeft = 2 * -Wn;
                                break;
                            case "right-bottom":
                                Qe.top = Co - Ul, Qe.left = Ll + Gl, Qe.arrowTop = Wn, Qe.arrowLeft = 2 * -Wn;
                        }
                    }
                    __waitImages() {
                        const Qe = this.content.querySelectorAll("img");
                        if (Qe.length > 0) {
                            const rt = [];
                            Qe.forEach((Qe)=>{
                                Qe.complete || rt.push(new Promise((rt)=>{
                                    Qe.onload = rt, Qe.onerror = rt;
                                }));
                            }), rt.length && Promise.all(rt).then(()=>{
                                if (1 === this.state.state || 3 === this.state.state) {
                                    const Qe = this.container.getBoundingClientRect();
                                    this.state.width = Qe.right - Qe.left, this.state.height = Qe.bottom - Qe.top, this.move(this.state.config);
                                }
                            });
                        }
                    }
                }, wm = class {
                    constructor(Qe){
                        this.viewer = Qe, this.config = Qe.config, this.state = Qe.state;
                    }
                    destroy() {}
                }, Em = new Co.Pq0, Mm = new Co.O9p(0, 0, 0, "ZXY"), Sm = class extends wm {
                    constructor(Qe){
                        super(Qe);
                    }
                    fovToZoomLevel(Qe) {
                        const rt = Math.round((Qe - this.config.minFov) / (this.config.maxFov - this.config.minFov) * 100);
                        return Co.cj9.clamp(rt - 2 * (rt - 50), 0, 100);
                    }
                    zoomLevelToFov(Qe) {
                        return this.config.maxFov + Qe / 100 * (this.config.minFov - this.config.maxFov);
                    }
                    vFovToHFov(Qe) {
                        return Co.cj9.radToDeg(2 * Math.atan(Math.tan(Co.cj9.degToRad(Qe) / 2) * this.state.aspect));
                    }
                    hFovToVFov(Qe) {
                        return Co.cj9.radToDeg(2 * Math.atan(Math.tan(Co.cj9.degToRad(Qe) / 2) / this.state.aspect));
                    }
                    getAnimationProperties(Qe, rt, Wn) {
                        const Co = !isNil(rt), Dl = !isNil(Wn), Ll = {};
                        let Rl = null;
                        if (Co) {
                            const Wn = this.viewer.getPosition(), Co = getShortestArc(Wn.yaw, rt.yaw);
                            Ll.yaw = {
                                start: Wn.yaw,
                                end: Wn.yaw + Co
                            }, Ll.pitch = {
                                start: Wn.pitch,
                                end: rt.pitch
                            }, Rl = speedToDuration(Qe, getAngle(Wn, rt));
                        }
                        if (Dl) {
                            const rt = this.viewer.getZoomLevel(), Co = Math.abs(Wn - rt);
                            Ll.zoom = {
                                start: rt,
                                end: Wn
                            }, null === Rl && (Rl = speedToDuration(Qe, Math.PI / 4 * Co / 100));
                        }
                        return Rl = null === Rl ? "number" === typeof Qe ? Qe : Gl : Math.max(Gl, Rl), {
                            duration: Rl,
                            properties: Ll
                        };
                    }
                    getTransitionOptions(Qe) {
                        let rt;
                        const Wn = this.config.defaultTransition ?? lm.defaultTransition;
                        return rt = !1 === Qe.transition || null === Qe.transition ? null : !0 === Qe.transition ? {
                            ...Wn
                        } : "object" === typeof Qe.transition ? {
                            ...Wn,
                            ...Qe.transition
                        } : this.config.defaultTransition, rt;
                    }
                    textureCoordsToSphericalCoords(Qe) {
                        if (!this.state.textureData?.panoData) throw new Lu("Current adapter does not support texture coordinates or no texture has been loaded");
                        const rt = this.viewer.adapter.textureCoordsToSphericalCoords(Qe, this.state.textureData.panoData);
                        return Mm.equals(this.viewer.renderer.panoramaPose) && Mm.equals(this.viewer.renderer.sphereCorrection) ? rt : (this.sphericalCoordsToVector3(rt, Em), Em.applyEuler(this.viewer.renderer.panoramaPose), Em.applyEuler(this.viewer.renderer.sphereCorrection), this.vector3ToSphericalCoords(Em));
                    }
                    sphericalCoordsToTextureCoords(Qe) {
                        if (!this.state.textureData?.panoData) throw new Lu("Current adapter does not support texture coordinates or no texture has been loaded");
                        return Mm.equals(this.viewer.renderer.panoramaPose) && Mm.equals(this.viewer.renderer.sphereCorrection) || (this.sphericalCoordsToVector3(Qe, Em), applyEulerInverse(Em, this.viewer.renderer.sphereCorrection), applyEulerInverse(Em, this.viewer.renderer.panoramaPose), Qe = this.vector3ToSphericalCoords(Em)), this.viewer.adapter.sphericalCoordsToTextureCoords(Qe, this.state.textureData.panoData);
                    }
                    sphericalCoordsToVector3(Qe, rt, Wn) {
                        return void 0 === Wn && (Wn = $l), rt || (rt = new Co.Pq0), rt.x = Wn * -Math.cos(Qe.pitch) * Math.sin(Qe.yaw), rt.y = Wn * Math.sin(Qe.pitch), rt.z = Wn * Math.cos(Qe.pitch) * Math.cos(Qe.yaw), rt;
                    }
                    vector3ToSphericalCoords(Qe) {
                        const rt = Math.acos(Qe.y / Math.sqrt(Qe.x * Qe.x + Qe.y * Qe.y + Qe.z * Qe.z)), Wn = Math.atan2(Qe.x, Qe.z);
                        return {
                            yaw: Wn < 0 ? -Wn : 2 * Math.PI - Wn,
                            pitch: Math.PI / 2 - rt
                        };
                    }
                    viewerCoordsToVector3(Qe) {
                        const rt = this.viewer.renderer.getIntersections(Qe).filter((Qe)=>Qe.object.userData[Tc]);
                        return rt.length ? rt[0].point : null;
                    }
                    viewerCoordsToSphericalCoords(Qe) {
                        const rt = this.viewerCoordsToVector3(Qe);
                        return rt ? this.vector3ToSphericalCoords(rt) : null;
                    }
                    vector3ToViewerCoords(Qe) {
                        const rt = Qe.clone();
                        return rt.project(this.viewer.renderer.camera), {
                            x: Math.round((rt.x + 1) / 2 * this.state.size.width),
                            y: Math.round((1 - rt.y) / 2 * this.state.size.height)
                        };
                    }
                    sphericalCoordsToViewerCoords(Qe) {
                        return this.sphericalCoordsToVector3(Qe, Em), this.vector3ToViewerCoords(Em);
                    }
                    isPointVisible(Qe) {
                        let rt, Wn;
                        if (Qe instanceof Co.Pq0) rt = Qe, Wn = this.vector3ToViewerCoords(Qe);
                        else {
                            if (!isExtendedPosition(Qe)) return !1;
                            rt = this.sphericalCoordsToVector3(Qe, Em), Wn = this.vector3ToViewerCoords(rt);
                        }
                        return rt.dot(this.viewer.state.direction) > 0 && Wn.x >= 0 && Wn.x <= this.viewer.state.size.width && Wn.y >= 0 && Wn.y <= this.viewer.state.size.height;
                    }
                    cleanPosition(Qe) {
                        if ("yaw" in Qe || "pitch" in Qe) {
                            if (!("yaw" in Qe) || !("pitch" in Qe)) throw new Lu("Position is missing 'yaw' or 'pitch'");
                            return {
                                yaw: parseAngle(Qe.yaw),
                                pitch: parseAngle(Qe.pitch, !0)
                            };
                        }
                        return this.textureCoordsToSphericalCoords(Qe);
                    }
                    cleanSphereCorrection(Qe) {
                        return {
                            pan: parseAngle(Qe?.pan || 0),
                            tilt: parseAngle(Qe?.tilt || 0, !0),
                            roll: parseAngle(Qe?.roll || 0, !0, !1)
                        };
                    }
                    cleanPanoramaPose(Qe) {
                        return {
                            pan: Co.cj9.degToRad(Qe?.poseHeading || 0),
                            tilt: Co.cj9.degToRad(Qe?.posePitch || 0),
                            roll: Co.cj9.degToRad(Qe?.poseRoll || 0)
                        };
                    }
                    cleanPanoramaOptions(Qe, rt) {
                        return rt?.isEquirectangular ? (isNil(Qe.zoom) && !isNil(rt.initialFov) && (Qe = {
                            ...Qe,
                            zoom: this.fovToZoomLevel(this.hFovToVFov(rt.initialFov))
                        }), !isNil(Qe.position) || isNil(rt.initialHeading) || isNil(rt.initialPitch) || (Qe = {
                            ...Qe,
                            position: {
                                yaw: parseAngle(rt.initialHeading),
                                pitch: parseAngle(rt.initialPitch, !0)
                            }
                        }), Qe) : Qe;
                    }
                }, Tm = class _Step {
                    constructor(){
                        this.$ = _Step.IDLE;
                    }
                    is() {
                        for(var Qe = arguments.length, rt = new Array(Qe), Wn = 0; Wn < Qe; Wn++)rt[Wn] = arguments[Wn];
                        return rt.some((Qe)=>this.$ & Qe);
                    }
                    set(Qe) {
                        this.$ = Qe;
                    }
                    add(Qe) {
                        this.$ |= Qe;
                    }
                    remove(Qe) {
                        this.$ &= ~Qe;
                    }
                };
                Tm.IDLE = 0, Tm.CLICK = 1, Tm.MOVING = 2;
                var Cm = Tm, km = class extends wm {
                    constructor(Qe){
                        super(Qe), this.data = {
                            startMouseX: 0,
                            startMouseY: 0,
                            mouseX: 0,
                            mouseY: 0,
                            pinchDist: 0,
                            moveDelta: {
                                yaw: 0,
                                pitch: 0,
                                zoom: 0
                            },
                            accumulatorFactor: 0,
                            ctrlKeyDown: !1,
                            dblclickData: null,
                            dblclickTimeout: null,
                            longtouchTimeout: null,
                            twofingersTimeout: null,
                            ctrlZoomTimeout: null
                        }, this.step = new Cm, this.keyHandler = new sd, this.resizeObserver = new ResizeObserver(throttle(()=>this.viewer.autoSize(), 50)), this.moveThreshold = Zl * Fp.pixelRatio;
                    }
                    init() {
                        window.addEventListener("keydown", this, {
                            passive: !1
                        }), window.addEventListener("keyup", this), this.viewer.container.addEventListener("mousedown", this), window.addEventListener("mousemove", this, {
                            passive: !1
                        }), window.addEventListener("mouseup", this), this.viewer.container.addEventListener("touchstart", this, {
                            passive: !1
                        }), window.addEventListener("touchmove", this, {
                            passive: !1
                        }), window.addEventListener("touchend", this, {
                            passive: !1
                        }), this.viewer.container.addEventListener("wheel", this, {
                            passive: !1
                        }), document.addEventListener("fullscreenchange", this), this.resizeObserver.observe(this.viewer.container), this.viewer.addEventListener(fd.type, this), this.viewer.addEventListener(Tp.type, this);
                    }
                    destroy() {
                        window.removeEventListener("keydown", this), window.removeEventListener("keyup", this), this.viewer.container.removeEventListener("mousedown", this), window.removeEventListener("mousemove", this), window.removeEventListener("mouseup", this), this.viewer.container.removeEventListener("touchstart", this), window.removeEventListener("touchmove", this), window.removeEventListener("touchend", this), this.viewer.container.removeEventListener("wheel", this), document.removeEventListener("fullscreenchange", this), this.resizeObserver.disconnect(), this.viewer.removeEventListener(fd.type, this), this.viewer.removeEventListener(Tp.type, this), clearTimeout(this.data.dblclickTimeout), clearTimeout(this.data.longtouchTimeout), clearTimeout(this.data.twofingersTimeout), clearTimeout(this.data.ctrlZoomTimeout), super.destroy();
                    }
                    handleEvent(Qe) {
                        switch(Qe.type){
                            case "keydown":
                                this.__onKeyDown(Qe);
                                break;
                            case "keyup":
                                this.__onKeyUp();
                                break;
                            case "mousemove":
                                this.__onMouseMove(Qe);
                                break;
                            case "mouseup":
                                this.__onMouseUp(Qe);
                                break;
                            case "touchmove":
                                this.__onTouchMove(Qe);
                                break;
                            case "touchend":
                                this.__onTouchEnd(Qe);
                                break;
                            case "fullscreenchange":
                                this.__onFullscreenChange();
                                break;
                            case fd.type:
                                this.__applyMoveDelta();
                                break;
                            case Tp.type:
                                this.__clearMoveDelta();
                        }
                        if (!getMatchingTarget(Qe, "." + tu)) switch(Qe.type){
                            case "mousedown":
                                this.__onMouseDown(Qe);
                                break;
                            case "touchstart":
                                this.__onTouchStart(Qe);
                                break;
                            case "wheel":
                                this.__onMouseWheel(Qe);
                        }
                    }
                    __onKeyDown(Qe) {
                        if (this.config.mousewheelCtrlKey && (this.data.ctrlKeyDown = Qe.key === fu.Control, this.data.ctrlKeyDown && (clearTimeout(this.data.ctrlZoomTimeout), this.viewer.overlay.hide(du.CTRL_ZOOM))), !this.viewer.dispatchEvent(new Nd(Qe.key, Qe))) return;
                        if (!this.state.keyboardEnabled) return;
                        const rt = this.config.keyboardActions?.[Qe.key];
                        if ("function" === typeof rt) return rt(this.viewer, Qe), void Qe.preventDefault();
                        if (!(Qe.ctrlKey || Qe.altKey || Qe.shiftKey || Qe.metaKey) && rt && !this.keyHandler.pending) {
                            switch("ZOOM_IN" !== rt && "ZOOM_OUT" !== rt && this.viewer.stopAll(), rt){
                                case "ROTATE_UP":
                                    this.viewer.dynamics.position.roll({
                                        pitch: !1
                                    });
                                    break;
                                case "ROTATE_DOWN":
                                    this.viewer.dynamics.position.roll({
                                        pitch: !0
                                    });
                                    break;
                                case "ROTATE_RIGHT":
                                    this.viewer.dynamics.position.roll({
                                        yaw: !1
                                    });
                                    break;
                                case "ROTATE_LEFT":
                                    this.viewer.dynamics.position.roll({
                                        yaw: !0
                                    });
                                    break;
                                case "ZOOM_IN":
                                    this.viewer.dynamics.zoom.roll(!1);
                                    break;
                                case "ZOOM_OUT":
                                    this.viewer.dynamics.zoom.roll(!0);
                            }
                            this.keyHandler.down(rt), Qe.preventDefault();
                        }
                    }
                    __onKeyUp() {
                        this.data.ctrlKeyDown = !1, this.state.keyboardEnabled && this.keyHandler.up((Qe)=>{
                            "ZOOM_IN" === Qe || "ZOOM_OUT" === Qe ? this.viewer.dynamics.zoom.stop() : (this.viewer.dynamics.position.stop(), this.viewer.resetIdleTimer());
                        });
                    }
                    __onMouseDown(Qe) {
                        this.step.add(Cm.CLICK), this.data.startMouseX = Qe.clientX, this.data.startMouseY = Qe.clientY;
                    }
                    __onMouseUp(Qe) {
                        this.step.is(Cm.CLICK, Cm.MOVING) && this.__stopMove(Qe.clientX, Qe.clientY, Qe, 2 === Qe.button);
                    }
                    __onMouseMove(Qe) {
                        this.config.mousemove && this.step.is(Cm.CLICK, Cm.MOVING) && (Qe.preventDefault(), this.__doMove(Qe.clientX, Qe.clientY)), this.__handleObjectsEvents(Qe);
                    }
                    __onTouchStart(Qe) {
                        1 === Qe.touches.length ? (this.step.add(Cm.CLICK), this.data.startMouseX = Qe.touches[0].clientX, this.data.startMouseY = Qe.touches[0].clientY, this.data.longtouchTimeout || (this.data.longtouchTimeout = setTimeout(()=>{
                            const rt = Qe.touches[0];
                            this.__stopMove(rt.clientX, rt.clientY, Qe, !0), this.data.longtouchTimeout = null;
                        }, ql))) : 2 === Qe.touches.length && (this.step.set(Cm.IDLE), this.__cancelLongTouch(), this.config.mousemove && (this.__cancelTwoFingersOverlay(), this.__startMoveZoom(Qe), Qe.preventDefault()));
                    }
                    __onTouchEnd(Qe) {
                        if (this.__cancelLongTouch(), this.step.is(Cm.CLICK, Cm.MOVING)) {
                            if (Qe.preventDefault(), this.__cancelTwoFingersOverlay(), 1 === Qe.touches.length) this.__stopMove(this.data.mouseX, this.data.mouseY);
                            else if (0 === Qe.touches.length) {
                                const rt = Qe.changedTouches[0];
                                this.__stopMove(rt.clientX, rt.clientY, Qe);
                            }
                        }
                    }
                    __onTouchMove(Qe) {
                        if (this.__cancelLongTouch(), this.config.mousemove) {
                            if (1 === Qe.touches.length) {
                                if (this.config.touchmoveTwoFingers) this.step.is(Cm.CLICK) && !this.data.twofingersTimeout && (this.data.twofingersTimeout = setTimeout(()=>{
                                    this.viewer.overlay.show({
                                        id: du.TWO_FINGERS,
                                        image: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><path fill="currentColor" d="M33.38 33.2a1.96 1.96 0 0 0 1.5-3.23 10.61 10.61 0 0 1 7.18-17.51c.7-.06 1.31-.49 1.61-1.12a13.02 13.02 0 0 1 11.74-7.43c7.14 0 12.96 5.8 12.96 12.9 0 3.07-1.1 6.05-3.1 8.38-.7.82-.61 2.05.21 2.76.83.7 2.07.6 2.78-.22a16.77 16.77 0 0 0 4.04-10.91C72.3 7.54 64.72 0 55.4 0a16.98 16.98 0 0 0-14.79 8.7 14.6 14.6 0 0 0-12.23 14.36c0 3.46 1.25 6.82 3.5 9.45.4.45.94.69 1.5.69m45.74 43.55a22.13 22.13 0 0 1-5.23 12.4c-4 4.55-9.53 6.86-16.42 6.86-12.6 0-20.1-10.8-20.17-10.91a1.82 1.82 0 0 0-.08-.1c-5.3-6.83-14.55-23.82-17.27-28.87-.05-.1 0-.21.02-.23a6.3 6.3 0 0 1 8.24 1.85l9.38 12.59a1.97 1.97 0 0 0 3.54-1.17V25.34a4 4 0 0 1 1.19-2.87 3.32 3.32 0 0 1 2.4-.95c1.88.05 3.4 1.82 3.4 3.94v24.32a1.96 1.96 0 0 0 3.93 0v-33.1a3.5 3.5 0 0 1 7 0v35.39a1.96 1.96 0 0 0 3.93 0v-.44c.05-2.05 1.6-3.7 3.49-3.7 1.93 0 3.5 1.7 3.5 3.82v5.63c0 .24.04.48.13.71l.1.26a1.97 1.97 0 0 0 3.76-.37c.33-1.78 1.77-3.07 3.43-3.07 1.9 0 3.45 1.67 3.5 3.74l-1.77 18.1zM77.39 51c-1.25 0-2.45.32-3.5.9v-.15c0-4.27-3.33-7.74-7.42-7.74-1.26 0-2.45.33-3.5.9V16.69a7.42 7.42 0 0 0-14.85 0v1.86a7 7 0 0 0-3.28-.94 7.21 7.21 0 0 0-5.26 2.07 7.92 7.92 0 0 0-2.38 5.67v37.9l-5.83-7.82a10.2 10.2 0 0 0-13.35-2.92 4.1 4.1 0 0 0-1.53 5.48C20 64.52 28.74 80.45 34.07 87.34c.72 1.04 9.02 12.59 23.4 12.59 7.96 0 14.66-2.84 19.38-8.2a26.06 26.06 0 0 0 6.18-14.6l1.78-18.2v-.2c0-4.26-3.32-7.73-7.42-7.73z"/><!--Created by AomAm from the Noun Project--></svg>\n',
                                        title: this.config.lang.twoFingers
                                    });
                                }, Ql));
                                else if (this.step.is(Cm.CLICK, Cm.MOVING)) {
                                    Qe.preventDefault();
                                    const rt = Qe.touches[0];
                                    this.__doMove(rt.clientX, rt.clientY);
                                }
                            } else this.__doMoveZoom(Qe), this.__cancelTwoFingersOverlay();
                        }
                    }
                    __cancelLongTouch() {
                        this.data.longtouchTimeout && (clearTimeout(this.data.longtouchTimeout), this.data.longtouchTimeout = null);
                    }
                    __cancelTwoFingersOverlay() {
                        this.config.touchmoveTwoFingers && (this.data.twofingersTimeout && (clearTimeout(this.data.twofingersTimeout), this.data.twofingersTimeout = null), this.viewer.overlay.hide(du.TWO_FINGERS));
                    }
                    __onMouseWheel(Qe) {
                        if (!this.config.mousewheel || !Qe.deltaY) return;
                        if (this.config.mousewheelCtrlKey && !this.data.ctrlKeyDown) return this.viewer.overlay.show({
                            id: du.CTRL_ZOOM,
                            image: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="10 17 79 79"><path fill="currentColor" d="M38.1 29.27c-.24 0-.44.2-.44.45v10.7a.45.45 0 00.9 0v-10.7c0-.25-.2-.45-.45-.45zm10.2 26.66a11.54 11.54 0 01-8.48-6.14.45.45 0 10-.8.41 12.45 12.45 0 009.22 6.62.45.45 0 00.07-.9zm24.55-13.08a23.04 23.04 0 00-22.56-23v7.07l-.01.05a2.83 2.83 0 012.39 2.78v14.03l.09-.02h8.84v-9.22a.45.45 0 11.9 0v9.22h10.35v-.9zm0 27.33V44.66H62.5c-.02 2.01-.52 4-1.47 5.76a.45.45 0 01-.61.18.45.45 0 01-.19-.61 11.54 11.54 0 001.36-5.33h-8.83l-.1-.01a2.83 2.83 0 01-2.83 2.84h-.04-.04a2.83 2.83 0 01-2.83-2.83v-14.9a2.82 2.82 0 012.47-2.8v-7.11a23.04 23.04 0 00-22.57 23v.91h14.72V29.88a8.2 8.2 0 015.02-7.57c.22-.1.5.01.59.24.1.23-.01.5-.24.6a7.3 7.3 0 00-4.47 6.73v13.88h3.9a.45.45 0 110 .9h-3.9v.15a7.32 7.32 0 0011.23 6.17.45.45 0 01.49.76 8.22 8.22 0 01-12.62-6.93v-.15H26.82v25.52a23.04 23.04 0 0023.01 23.01 23.04 23.04 0 0023.02-23.01zm1.8-27.33v27.33A24.85 24.85 0 0149.84 95a24.85 24.85 0 01-24.82-24.82V42.85a24.85 24.85 0 0124.82-24.82 24.85 24.85 0 0124.83 24.82zM57.98 29.88v9.36a.45.45 0 11-.9 0v-9.36a7.28 7.28 0 00-3.4-6.17.45.45 0 01.49-.76 8.18 8.18 0 013.8 6.93z"/><!-- Created by Icon Island from the Noun Project --></svg>\n',
                            title: this.config.lang.ctrlZoom
                        }), clearTimeout(this.data.ctrlZoomTimeout), void (this.data.ctrlZoomTimeout = setTimeout(()=>this.viewer.overlay.hide(du.CTRL_ZOOM), Kl));
                        Qe.preventDefault(), Qe.stopPropagation();
                        const rt = Qe.deltaY / Math.abs(Qe.deltaY) * 5 * this.config.zoomSpeed;
                        0 !== rt && this.viewer.dynamics.zoom.step(-rt, 5);
                    }
                    __onFullscreenChange() {
                        const Qe = this.viewer.isFullscreenEnabled();
                        "fullscreen" === this.config.keyboard && (Qe ? this.viewer.startKeyboardControl() : this.viewer.stopKeyboardControl()), this.viewer.dispatchEvent(new Md(Qe));
                    }
                    __resetMove() {
                        this.step.set(Cm.IDLE), this.data.mouseX = 0, this.data.mouseY = 0, this.data.startMouseX = 0, this.data.startMouseY = 0;
                    }
                    __startMoveZoom(Qe) {
                        this.viewer.stopAll(), this.__resetMove();
                        const rt = getTouchData(Qe);
                        this.step.set(Cm.MOVING), this.data.accumulatorFactor = this.config.moveInertia, { distance: this.data.pinchDist, center: { x: this.data.mouseX, y: this.data.mouseY } } = rt;
                    }
                    __stopMove(Qe, rt, Wn, Co) {
                        void 0 === Co && (Co = !1), this.step.is(Cm.CLICK) && !this.__moveThresholdReached(Qe, rt) && this.__doClick(Qe, rt, Wn, Co), this.config.moveInertia && (this.data.accumulatorFactor = Math.pow(this.config.moveInertia, .5)), this.__resetMove(), this.viewer.resetIdleTimer();
                    }
                    __doClick(Qe, rt, Wn, Co) {
                        void 0 === Co && (Co = !1);
                        const Dl = this.viewer.container.getBoundingClientRect(), Ll = Qe - Dl.left, Rl = rt - Dl.top, Ul = this.viewer.renderer.getIntersections({
                            x: Ll,
                            y: Rl
                        }), Gl = Ul.find((Qe)=>Qe.object.userData[Tc]);
                        if (Gl) {
                            const Dl = this.viewer.dataHelper.vector3ToSphericalCoords(Gl.point), Zl = {
                                rightclick: Co,
                                originalEvent: Wn,
                                target: getEventTarget(Wn),
                                clientX: Qe,
                                clientY: rt,
                                viewerX: Ll,
                                viewerY: Rl,
                                yaw: Dl.yaw,
                                pitch: Dl.pitch,
                                objects: Ul.map((Qe)=>Qe.object).filter((Qe)=>!Qe.userData[Tc])
                            };
                            try {
                                const Qe = this.viewer.dataHelper.sphericalCoordsToTextureCoords(Zl);
                                Object.assign(Zl, Qe);
                            } catch  {}
                            this.data.dblclickTimeout ? (Math.abs(this.data.dblclickData.clientX - Zl.clientX) < this.moveThreshold && Math.abs(this.data.dblclickData.clientY - Zl.clientY) < this.moveThreshold && this.viewer.dispatchEvent(new wd(this.data.dblclickData)), clearTimeout(this.data.dblclickTimeout), this.data.dblclickTimeout = null, this.data.dblclickData = null) : (this.viewer.dispatchEvent(new vd(Zl)), this.data.dblclickData = clone(Zl), this.data.dblclickTimeout = setTimeout(()=>{
                                this.data.dblclickTimeout = null, this.data.dblclickData = null;
                            }, Hl));
                        }
                    }
                    __handleObjectsEvents(Qe) {
                        if (!isEmpty(this.state.objectsObservers) && Qe.composedPath().includes(this.viewer.container)) {
                            const rt = getPosition(this.viewer.container), Wn = {
                                x: Qe.clientX - rt.x,
                                y: Qe.clientY - rt.y
                            }, Co = this.viewer.renderer.getIntersections(Wn), emit = (rt, Co, Dl)=>{
                                this.viewer.dispatchEvent(new Dl(Qe, rt, Wn, Co));
                            };
                            for (const [Qe, Dl] of Object.entries(this.state.objectsObservers)){
                                const rt = Co.find((rt)=>rt.object.userData[Qe]);
                                rt ? (Dl && rt.object !== Dl && (emit(Dl, Qe, zp), this.state.objectsObservers[Qe] = null), Dl ? emit(rt.object, Qe, Rp) : (this.state.objectsObservers[Qe] = rt.object, emit(rt.object, Qe, Lp))) : Dl && (emit(Dl, Qe, zp), this.state.objectsObservers[Qe] = null);
                            }
                        }
                    }
                    __doMove(Qe, rt) {
                        if (this.step.is(Cm.CLICK) && this.__moveThresholdReached(Qe, rt)) this.viewer.stopAll(), this.__resetMove(), this.step.set(Cm.MOVING), this.data.mouseX = Qe, this.data.mouseY = rt, this.data.accumulatorFactor = this.config.moveInertia;
                        else if (this.step.is(Cm.MOVING)) {
                            const Wn = (Qe - this.data.mouseX) * Math.cos(this.state.roll) - (rt - this.data.mouseY) * Math.sin(this.state.roll), Dl = (rt - this.data.mouseY) * Math.cos(this.state.roll) + (Qe - this.data.mouseX) * Math.sin(this.state.roll), Ll = {
                                yaw: this.config.moveSpeed * (Wn / this.state.size.width) * Co.cj9.degToRad(this.state.hFov),
                                pitch: this.config.moveSpeed * (Dl / this.state.size.height) * Co.cj9.degToRad(this.state.vFov)
                            };
                            this.data.moveDelta.yaw += Ll.yaw, this.data.moveDelta.pitch += Ll.pitch, this.data.mouseX = Qe, this.data.mouseY = rt;
                        }
                    }
                    __moveThresholdReached(Qe, rt) {
                        return Math.abs(Qe - this.data.startMouseX) >= this.moveThreshold || Math.abs(rt - this.data.startMouseY) >= this.moveThreshold;
                    }
                    __doMoveZoom(Qe) {
                        if (this.step.is(Cm.MOVING)) {
                            Qe.preventDefault();
                            const rt = getTouchData(Qe);
                            this.__doMove(rt.center.x, rt.center.y), this.data.moveDelta.zoom += this.config.zoomSpeed * ((rt.distance - this.data.pinchDist) / Fp.pixelRatio), this.data.pinchDist = rt.distance;
                        }
                    }
                    __applyMoveDelta() {
                        const Qe = .001;
                        if (Math.abs(this.data.moveDelta.yaw) > 0 || Math.abs(this.data.moveDelta.pitch) > 0) {
                            const rt = this.viewer.getPosition();
                            this.viewer.rotate({
                                yaw: rt.yaw - this.data.moveDelta.yaw * (1 - this.config.moveInertia),
                                pitch: rt.pitch + this.data.moveDelta.pitch * (1 - this.config.moveInertia)
                            }), this.data.moveDelta.yaw *= this.data.accumulatorFactor, this.data.moveDelta.pitch *= this.data.accumulatorFactor, Math.abs(this.data.moveDelta.yaw) <= Qe && (this.data.moveDelta.yaw = 0), Math.abs(this.data.moveDelta.pitch) <= Qe && (this.data.moveDelta.pitch = 0);
                        }
                        if (Math.abs(this.data.moveDelta.zoom) > 0) {
                            const rt = this.viewer.getZoomLevel();
                            this.viewer.zoom(rt + this.data.moveDelta.zoom * (1 - this.config.moveInertia)), this.data.moveDelta.zoom *= this.config.moveInertia, Math.abs(this.data.moveDelta.zoom) <= Qe && (this.data.moveDelta.zoom = 0);
                        }
                    }
                    __clearMoveDelta() {
                        this.data.moveDelta.yaw = 0, this.data.moveDelta.pitch = 0, this.data.moveDelta.zoom = 0;
                    }
                };
                Co.ppV.enabled = !1;
                var Im = new Co.I9Y, Dm = new Co.kn4, Lm = new Co.NRn, Pm = class extends wm {
                    constructor(Qe){
                        super(Qe), this.frustumNeedsUpdate = !0, this.renderer = new Dl.JeP(this.config.rendererParameters), this.renderer.setPixelRatio(Fp.pixelRatio), this.renderer.outputColorSpace = Co.Zr2, this.renderer.toneMapping = Co.kyO, this.renderer.domElement.className = "psv-canvas", this.renderer.domElement.style.background = this.config.canvasBackground, this.scene = new Co.Z58, this.camera = new Co.ubm(50, 16 / 9, .1, 2 * $l), this.camera.matrixAutoUpdate = !1;
                        const rt = new Co.eaF(new Co.Gu$($l).scale(-1, 1, 1), new Co.V9B({
                            opacity: 0,
                            transparent: !0,
                            depthTest: !1,
                            depthWrite: !1
                        }));
                        rt.userData = {
                            [Tc]: !0
                        }, this.scene.add(rt), this.raycaster = new Co.tBo, this.frustum = new Co.PPD, this.container = document.createElement("div"), this.container.className = "psv-canvas-container", this.container.appendChild(this.renderer.domElement), this.viewer.container.appendChild(this.container), this.container.addEventListener("contextmenu", (Qe)=>Qe.preventDefault()), this.viewer.addEventListener(Mp.type, this), this.viewer.addEventListener(kp.type, this), this.viewer.addEventListener(qd.type, this), this.viewer.addEventListener(Qd.type, this), this.viewer.addEventListener(xd.type, this), this.hide();
                    }
                    get panoramaPose() {
                        return this.mesh.rotation;
                    }
                    get sphereCorrection() {
                        return this.meshContainer.rotation;
                    }
                    init() {
                        this.show(), this.renderer.setAnimationLoop((Qe)=>this.__renderLoop(Qe));
                    }
                    destroy() {
                        this.renderer.setAnimationLoop(null), this.cleanScene(this.scene), this.renderer.dispose(), this.viewer.container.removeChild(this.container), this.viewer.removeEventListener(Mp.type, this), this.viewer.removeEventListener(kp.type, this), this.viewer.removeEventListener(qd.type, this), this.viewer.removeEventListener(Qd.type, this), this.viewer.removeEventListener(xd.type, this), super.destroy();
                    }
                    handleEvent(Qe) {
                        switch(Qe.type){
                            case Mp.type:
                                this.__onSizeUpdated();
                                break;
                            case kp.type:
                                this.__onZoomUpdated();
                                break;
                            case qd.type:
                            case Qd.type:
                                this.__onPositionUpdated();
                                break;
                            case xd.type:
                                Qe.containsOptions("fisheye") && this.__onPositionUpdated(), Qe.containsOptions("canvasBackground") && (this.renderer.domElement.style.background = this.config.canvasBackground);
                        }
                    }
                    hide() {
                        this.container.style.opacity = "0";
                    }
                    show() {
                        this.container.style.opacity = "1";
                    }
                    setCustomRenderer(Qe) {
                        this.customRenderer = Qe ? Qe(this.renderer) : null, this.viewer.needsUpdate();
                    }
                    __onSizeUpdated() {
                        this.renderer.setSize(this.state.size.width, this.state.size.height), this.camera.aspect = this.state.aspect, this.camera.updateProjectionMatrix(), this.viewer.needsUpdate(), this.frustumNeedsUpdate = !0;
                    }
                    __onZoomUpdated() {
                        this.camera.fov = this.state.vFov, this.camera.updateProjectionMatrix(), this.viewer.needsUpdate(), this.frustumNeedsUpdate = !0;
                    }
                    __onPositionUpdated() {
                        this.camera.position.set(0, 0, 0), this.camera.lookAt(this.state.direction), this.config.fisheye && this.camera.position.copy(this.state.direction).multiplyScalar(this.config.fisheye / 2).negate(), this.camera.rotateZ(-this.state.roll), this.camera.updateMatrix(), this.camera.updateMatrixWorld(), this.viewer.needsUpdate(), this.frustumNeedsUpdate = !0;
                    }
                    __renderLoop(Qe) {
                        const rt = this.timestamp ? Qe - this.timestamp : 0;
                        this.timestamp = Qe, this.viewer.dispatchEvent(new fd(Qe, rt)), this.viewer.dynamics.update(rt), (this.state.needsUpdate || this.state.continuousUpdateCount > 0) && (this.state.needsUpdate = !1, (this.customRenderer || this.renderer).render(this.scene, this.camera), this.viewer.dispatchEvent(new $d));
                    }
                    setTexture(Qe) {
                        this.meshContainer || (this.meshContainer = new Co.YJl, this.scene.add(this.meshContainer)), this.state.textureData && this.viewer.adapter.disposeTexture(this.state.textureData), this.mesh && (this.meshContainer.remove(this.mesh), this.viewer.adapter.disposeMesh(this.mesh)), this.mesh = this.viewer.adapter.createMesh(Qe.panoData), this.viewer.adapter.setTexture(this.mesh, Qe, !1), this.meshContainer.add(this.mesh), this.state.textureData = Qe, this.viewer.needsUpdate();
                    }
                    setPanoramaPose(Qe, rt) {
                        void 0 === rt && (rt = this.mesh);
                        const Wn = this.viewer.dataHelper.cleanPanoramaPose(Qe);
                        rt.rotation.set(Wn.tilt, Wn.pan, Wn.roll, "YXZ");
                    }
                    setSphereCorrection(Qe, rt) {
                        void 0 === rt && (rt = this.meshContainer);
                        const Wn = this.viewer.dataHelper.cleanSphereCorrection(Qe);
                        rt.rotation.set(Wn.tilt, Wn.pan, Wn.roll, "YXZ");
                    }
                    transition(Qe, rt, Wn) {
                        const Dl = "fade" === Wn.effect || Wn.rotation, Ll = !isNil(rt.position), Rl = !isNil(rt.zoom), Ul = new pd(Ll ? this.viewer.dataHelper.cleanPosition(rt.position) : void 0, rt.zoom);
                        this.viewer.dispatchEvent(Ul);
                        const Gl = new Co.YJl, Zl = this.viewer.adapter.createMesh(Qe.panoData);
                        if (this.viewer.adapter.setTexture(Zl, Qe, !0), this.viewer.adapter.setTextureOpacity(Zl, 0), this.setPanoramaPose(Qe.panoData, Zl), this.setSphereCorrection(rt.sphereCorrection, Gl), Ll && !Wn.rotation) {
                            const Qe = this.viewer.getPosition(), rt = new Co.Pq0(0, 1, 0);
                            Gl.rotateOnWorldAxis(rt, Ul.position.yaw - Qe.yaw);
                            const Wn = new Co.Pq0(0, 1, 0).cross(this.camera.getWorldDirection(new Co.Pq0)).normalize();
                            Gl.rotateOnWorldAxis(Wn, Ul.position.pitch - Qe.pitch);
                        }
                        Gl.add(Zl), this.scene.add(Gl), this.renderer.setRenderTarget(new Co.nWS), this.renderer.render(this.scene, this.camera), this.renderer.setRenderTarget(null);
                        const { duration: Hl, properties: ql } = this.viewer.dataHelper.getAnimationProperties(Wn.speed, Wn.rotation ? Ul.position : null, Dl ? Ul.zoomLevel : null), Ql = new id({
                            properties: {
                                ...ql,
                                opacity: {
                                    start: 0,
                                    end: 1
                                }
                            },
                            duration: Hl,
                            easing: "inOutCubic",
                            onTick: (Qe)=>{
                                switch(Wn.effect){
                                    case "fade":
                                        this.viewer.adapter.setTextureOpacity(Zl, Qe.opacity);
                                        break;
                                    case "black":
                                    case "white":
                                        Qe.opacity < .5 ? this.renderer.toneMappingExposure = "black" === Wn.effect ? Co.cj9.mapLinear(Qe.opacity, 0, .5, 1, 0) : Co.cj9.mapLinear(Qe.opacity, 0, .5, 1, 4) : (this.renderer.toneMappingExposure = "black" === Wn.effect ? Co.cj9.mapLinear(Qe.opacity, .5, 1, 0, 1) : Co.cj9.mapLinear(Qe.opacity, .5, 1, 4, 1), this.mesh.visible = !1, this.viewer.adapter.setTextureOpacity(Zl, 1), Rl && !Dl && this.viewer.dynamics.zoom.setValue(Ul.zoomLevel));
                                }
                                Ll && Wn.rotation && this.viewer.dynamics.position.setValue({
                                    yaw: Qe.yaw,
                                    pitch: Qe.pitch
                                }), Rl && Dl && this.viewer.dynamics.zoom.setValue(Qe.zoom), this.viewer.needsUpdate();
                            }
                        });
                        return Ql.then((Co)=>{
                            Gl.remove(Zl), this.scene.remove(Gl), Co ? (this.viewer.adapter.disposeTexture(this.state.textureData), this.meshContainer.remove(this.mesh), this.viewer.adapter.disposeMesh(this.mesh), this.mesh = Zl, this.meshContainer.add(Zl), this.state.textureData = Qe, this.setPanoramaPose(Qe.panoData), this.setSphereCorrection(rt.sphereCorrection), Ll && !Wn.rotation && this.viewer.rotate(rt.position)) : (this.viewer.adapter.disposeTexture(Qe), this.viewer.adapter.disposeMesh(Zl));
                        }), Ql;
                    }
                    getIntersections(Qe) {
                        Im.x = 2 * Qe.x / this.state.size.width - 1, Im.y = -2 * Qe.y / this.state.size.height + 1, this.raycaster.setFromCamera(Im, this.camera);
                        const rt = this.raycaster.intersectObjects(this.scene.children, !0).filter((Qe)=>Qe.object.visible).filter((Qe)=>Qe.object.isMesh && !!Qe.object.userData);
                        return this.customRenderer?.getIntersections && rt.push(...this.customRenderer.getIntersections(this.raycaster, Im)), rt;
                    }
                    isObjectVisible(Qe) {
                        if (!Qe) return !1;
                        if (this.frustumNeedsUpdate && (Dm.multiplyMatrices(this.camera.projectionMatrix, this.camera.matrixWorldInverse), this.frustum.setFromProjectionMatrix(Dm), this.frustumNeedsUpdate = !1), Qe.isVector3) return this.frustum.containsPoint(Qe);
                        if (Qe.isMesh && Qe.geometry) {
                            const rt = Qe;
                            return rt.geometry.boundingBox || rt.geometry.computeBoundingBox(), Lm.copy(rt.geometry.boundingBox).applyMatrix4(rt.matrixWorld), this.frustum.intersectsBox(Lm);
                        }
                        return !!Qe.isObject3D && this.frustum.intersectsObject(Qe);
                    }
                    addObject(Qe) {
                        this.scene.add(Qe);
                    }
                    removeObject(Qe) {
                        this.scene.remove(Qe);
                    }
                    cleanScene(Qe) {
                        const disposeMaterial = (Qe)=>{
                            Qe.map?.dispose(), Qe.uniforms && Object.values(Qe.uniforms).forEach((Qe)=>{
                                Qe.value?.dispose?.();
                            }), Qe.dispose();
                        };
                        Qe.traverse((rt)=>{
                            rt.geometry?.dispose(), rt.material && (Array.isArray(rt.material) ? rt.material.forEach((Qe)=>{
                                disposeMaterial(Qe);
                            }) : disposeMaterial(rt.material)), rt instanceof Co.Z58 || rt.dispose?.(), rt !== Qe && this.cleanScene(rt);
                        });
                    }
                }, zm = class extends Co.aHM {
                    load(Qe, rt, Wn, Co, Dl) {
                        const Ll = new Request(Qe, {
                            headers: new Headers(this.requestHeader),
                            credentials: this.withCredentials ? "include" : "same-origin"
                        });
                        fetch(Ll, {
                            signal: Dl
                        }).then((Qe)=>{
                            if (200 === Qe.status || 0 === Qe.status) {
                                const rt = Qe.body.getReader(), Dl = Qe.headers.get("Content-Length") || Qe.headers.get("X-File-Size"), Ll = Dl ? parseInt(Dl) : 0, Rl = 0 !== Ll;
                                let Ul = 0;
                                const Gl = new ReadableStream({
                                    start (Qe) {
                                        !function readData() {
                                            rt.read().then((rt)=>{
                                                let { done: Co, value: Dl } = rt;
                                                if (Co) Qe.close();
                                                else {
                                                    Ul += Dl.byteLength;
                                                    const rt = new ProgressEvent("progress", {
                                                        lengthComputable: Rl,
                                                        loaded: Ul,
                                                        total: Ll
                                                    });
                                                    Wn(rt), Qe.enqueue(Dl), readData();
                                                }
                                            }).catch((Qe)=>{
                                                Co(Qe);
                                            });
                                        }();
                                    }
                                });
                                return new Response(Gl);
                            }
                            throw new Error(`fetch for "${Qe.url}" responded with ${Qe.status}: ${Qe.statusText}`);
                        }).then((Qe)=>Qe.blob()).then((Qe)=>{
                            rt(Qe);
                        }).catch((Qe)=>{
                            Co(Qe);
                        });
                    }
                }, Nm = class extends Co.aHM {
                    load(Qe, rt, Wn, Co) {
                        const Dl = document.createElement("img");
                        function onImageLoad() {
                            removeEventListeners(), rt(this);
                        }
                        function onImageError(Qe) {
                            if (removeEventListeners(), Co?.aborted) {
                                const Qe = new Error;
                                Qe.name = "AbortError", Qe.message = "The operation was aborted.", Wn(Qe);
                            } else Wn(Qe);
                        }
                        function onAbortSignal() {
                            Dl.src = "";
                        }
                        function removeEventListeners() {
                            Dl.removeEventListener("load", onImageLoad, !1), Dl.removeEventListener("error", onImageError, !1), Co?.removeEventListener("abort", onAbortSignal, !1);
                        }
                        return Dl.addEventListener("load", onImageLoad, !1), Dl.addEventListener("error", onImageError, !1), Co?.addEventListener("abort", onAbortSignal, !1), Qe.startsWith("data:") || void 0 === this.crossOrigin || (Dl.crossOrigin = this.crossOrigin), Dl.src = Qe, Dl;
                    }
                }, Rm = class extends wm {
                    constructor(Qe){
                        super(Qe), this.abortCtrl = {}, this.fileLoader = new zm, this.imageLoader = new Nm, this.config.withCredentials && (this.fileLoader.setWithCredentials(!0), this.imageLoader.setCrossOrigin("use-credentials"));
                    }
                    destroy() {
                        this.abortLoading(), super.destroy();
                    }
                    abortLoading() {
                        Object.values(this.abortCtrl).forEach((Qe)=>Qe.abort()), this.abortCtrl = {};
                    }
                    loadFile(Qe, rt, Wn) {
                        const Co = gm.get(Qe, Wn);
                        if (Co) {
                            if (Co instanceof Blob) return rt?.(100), Promise.resolve(Co);
                            gm.remove(Qe, Wn);
                        }
                        return this.config.requestHeaders && this.fileLoader.setRequestHeader(this.config.requestHeaders(Qe)), new Promise((Co, Dl)=>{
                            let Ll = 0;
                            rt?.(Ll), this.fileLoader.load(Qe, (Dl)=>{
                                Ll = 100, rt?.(Ll), gm.add(Qe, Wn, Dl), Co(Dl);
                            }, (Qe)=>{
                                if (Qe.lengthComputable) {
                                    const Wn = Qe.loaded / Qe.total * 100;
                                    Wn > Ll && (Ll = Wn, rt?.(Ll));
                                }
                            }, (Qe)=>{
                                Dl(Qe);
                            }, this.__getAbortSignal(Wn));
                        });
                    }
                    loadImage(Qe, rt, Wn) {
                        const Co = gm.get(Qe, Wn);
                        return Co ? (rt?.(100), Co instanceof Blob ? this.blobToImage(Co) : Promise.resolve(Co)) : rt || this.config.requestHeaders ? this.loadFile(Qe, rt, Wn).then((Qe)=>this.blobToImage(Qe)) : new Promise((rt, Co)=>{
                            this.imageLoader.load(Qe, (Co)=>{
                                gm.add(Qe, Wn, Co), rt(Co);
                            }, (Qe)=>{
                                Co(Qe);
                            }, this.__getAbortSignal(Wn));
                        });
                    }
                    blobToImage(Qe) {
                        return new Promise((rt, Wn)=>{
                            const Co = document.createElement("img");
                            Co.onload = ()=>{
                                URL.revokeObjectURL(Co.src), rt(Co);
                            }, Co.onerror = Wn, Co.src = URL.createObjectURL(Qe);
                        });
                    }
                    preloadPanorama(Qe) {
                        return this.viewer.adapter.supportsPreload(Qe) ? this.viewer.adapter.loadTexture(Qe, !1) : Promise.reject(new Lu("Current adapter does not support preload"));
                    }
                    __getAbortSignal(Qe) {
                        return Qe ? (this.abortCtrl[Qe]?.signal.aborted && delete this.abortCtrl[Qe], this.abortCtrl[Qe] || (this.abortCtrl[Qe] = new AbortController), this.abortCtrl[Qe].signal) : null;
                    }
                }, Bm = class extends wm {
                    constructor(Qe){
                        super(Qe), this.zoom = new nd((Qe)=>{
                            this.viewer.state.vFov = this.viewer.dataHelper.zoomLevelToFov(Qe), this.viewer.state.hFov = this.viewer.dataHelper.vFovToHFov(this.viewer.state.vFov), this.viewer.dispatchEvent(new kp(Qe));
                        }, {
                            defaultValue: this.viewer.config.defaultZoomLvl,
                            min: 0,
                            max: 100,
                            wrap: !1
                        }), this.position = new rd((Qe)=>{
                            this.viewer.dataHelper.sphericalCoordsToVector3(Qe, this.viewer.state.direction), this.viewer.dispatchEvent(new qd(Qe));
                        }, {
                            yaw: new nd(null, {
                                defaultValue: this.config.defaultYaw,
                                min: 0,
                                max: 2 * Math.PI,
                                wrap: !0
                            }),
                            pitch: new nd(null, {
                                defaultValue: this.config.defaultPitch,
                                min: -Math.PI / 2,
                                max: Math.PI / 2,
                                wrap: !1
                            })
                        }), this.roll = new nd((Qe)=>{
                            this.viewer.state.roll = Qe, this.viewer.dispatchEvent(new Qd(Qe));
                        }, {
                            defaultValue: 0,
                            min: -Math.PI,
                            max: Math.PI,
                            wrap: !1
                        }), this.updateSpeeds();
                    }
                    updateSpeeds() {
                        this.zoom.setSpeed(50 * this.config.zoomSpeed), this.position.setSpeed(Co.cj9.degToRad(50 * this.config.moveSpeed)), this.roll.setSpeed(Co.cj9.degToRad(50 * this.config.moveSpeed));
                    }
                    update(Qe) {
                        this.zoom.update(Qe), this.position.update(Qe), this.roll.update(Qe);
                    }
                }, Om = class {
                    constructor(){
                        this.ready = !1, this.needsUpdate = !1, this.continuousUpdateCount = 0, this.keyboardEnabled = !1, this.direction = new Co.Pq0(0, 0, $l), this.roll = 0, this.vFov = 60, this.hFov = 60, this.aspect = 1, this.animation = null, this.transitionAnimation = null, this.loadingPromise = null, this.idleTime = -1, this.objectsObservers = {}, this.size = {
                            width: 0,
                            height: 0
                        };
                    }
                }, Fm = class extends ud {
                    constructor(Qe){
                        if (super(), this.plugins = {}, this.children = [], this.parent = getElement(Qe.container), !this.parent) throw new Lu('"container" element not found.');
                        this.parent[Tc] = this, this.container = document.createElement("div"), this.container.classList.add("psv-container"), this.parent.appendChild(this.container), checkClosedShadowDom(this.parent), checkStylesheet(this.container, "core"), this.state = new Om, this.config = hm(Qe), this.__setSize(this.config.size), this.overlay = new vm(this);
                        try {
                            Fp.load();
                        } catch (rt) {
                            return console.error(rt), void this.showError(this.config.lang.webglError);
                        }
                        gm.init(), this.adapter = new this.config.adapter[0](this, this.config.adapter[1]), this.renderer = new Pm(this), this.textureLoader = new Rm(this), this.eventsHandler = new km(this), this.dataHelper = new Sm(this), this.dynamics = new Bm(this), this.adapter.init?.(), this.loader = new Am(this), this.navbar = new fm(this), this.panel = new xm(this), this.notification = new ym(this), this.autoSize(), this.setCursor(null), resolveBoolean(Fp.isTouchEnabled, (Qe)=>{
                            toggleClass(this.container, "psv--is-touch", Qe);
                        }), this.config.plugins.forEach((Qe)=>{
                            let [rt, Wn] = Qe;
                            this.plugins[rt.id] = new rt(this, Wn);
                        });
                        for (const Wn of Object.values(this.plugins))Wn.init?.();
                        this.config.navbar && this.navbar.setButtons(this.config.navbar), this.state.loadingPromise || (this.config.panorama ? this.setPanorama(this.config.panorama, {
                            sphereCorrection: this.config.sphereCorrection,
                            panoData: this.config.panoData
                        }) : this.loader.show());
                    }
                    destroy() {
                        this.stopAll(), this.stopKeyboardControl(), this.exitFullscreen();
                        for (const [Qe, rt] of Object.entries(this.plugins))rt.destroy(), delete this.plugins[Qe];
                        this.children.slice().forEach((Qe)=>Qe.destroy()), this.children.length = 0, this.eventsHandler?.destroy(), this.renderer?.destroy(), this.textureLoader?.destroy(), this.dataHelper?.destroy(), this.adapter?.destroy(), this.dynamics?.destroy(), this.parent.removeChild(this.container), delete this.parent[Tc];
                    }
                    init() {
                        this.eventsHandler.init(), this.renderer.init(), this.config.navbar && this.navbar.show(), "always" === this.config.keyboard && this.startKeyboardControl(), this.resetIdleTimer(), this.state.ready = !0, this.dispatchEvent(new Xd);
                    }
                    resetIdleTimer() {
                        this.state.idleTime = performance.now();
                    }
                    disableIdleTimer() {
                        this.state.idleTime = -1;
                    }
                    getPlugin(Qe) {
                        if ("string" === typeof Qe) return this.plugins[Qe];
                        {
                            const rt = pluginInterop(Qe);
                            return rt ? this.plugins[rt.id] : null;
                        }
                    }
                    getPosition() {
                        return this.dataHelper.cleanPosition(this.dynamics.position.current);
                    }
                    getZoomLevel() {
                        return this.dynamics.zoom.current;
                    }
                    getSize() {
                        return {
                            ...this.state.size
                        };
                    }
                    isFullscreenEnabled() {
                        return isFullscreenEnabled(this.parent, Fp.isIphone);
                    }
                    needsUpdate() {
                        this.state.needsUpdate = !0;
                    }
                    needsContinuousUpdate(Qe) {
                        Qe ? this.state.continuousUpdateCount++ : this.state.continuousUpdateCount > 0 && this.state.continuousUpdateCount--;
                    }
                    autoSize() {
                        this.container.clientWidth === this.state.size.width && this.container.clientHeight === this.state.size.height || (this.state.size.width = Math.round(this.container.clientWidth), this.state.size.height = Math.round(this.container.clientHeight), this.state.aspect = this.state.size.width / this.state.size.height, this.state.hFov = this.dataHelper.vFovToHFov(this.state.vFov), this.dispatchEvent(new Mp(this.getSize())), this.navbar.autoSize());
                    }
                    setPanorama(Qe, rt) {
                        void 0 === rt && (rt = {}), this.textureLoader.abortLoading(), this.state.transitionAnimation?.cancel();
                        const Wn = this.dataHelper.getTransitionOptions(rt);
                        void 0 === rt.showLoader && (rt.showLoader = !0), void 0 === rt.caption && (rt.caption = this.config.caption), void 0 === rt.description && (rt.description = this.config.description), rt.panoData || "function" !== typeof this.config.panoData || (rt.panoData = this.config.panoData), this.hideError(), this.resetIdleTimer(), this.config.panorama = Qe, this.config.caption = rt.caption, this.config.description = rt.description, this.config.sphereCorrection = rt.sphereCorrection;
                        const done = (rt)=>{
                            if (isAbortError(rt)) return !1;
                            if (this.loader.hide(), this.state.loadingPromise = null, rt) throw this.navbar.setCaption(null), this.showError(this.config.lang.loadError), console.error(rt), this.dispatchEvent(new Gd(Qe, rt)), rt;
                            return this.navbar.setCaption(this.config.caption), !0;
                        };
                        this.navbar.setCaption(`<em>${this.config.lang.loading}</em>`), !rt.showLoader && this.state.ready || this.loader.show(), this.dispatchEvent(new Fd(Qe));
                        const Co = this.adapter.loadTexture(this.config.panorama, !0, rt.panoData).then((Qe)=>{
                            if (Qe.panorama !== this.config.panorama) throw this.adapter.disposeTexture(Qe), getAbortError();
                            const Wn = this.dataHelper.cleanPanoramaOptions(rt, Qe.panoData);
                            return isNil(Wn.zoom) && isNil(Wn.position) || this.stopAll(), {
                                textureData: Qe,
                                cleanOptions: Wn
                            };
                        });
                        return Wn && this.state.ready && this.adapter.supportsTransition(this.config.panorama) ? this.state.loadingPromise = Co.then((Qe)=>{
                            let { textureData: rt, cleanOptions: Co } = Qe;
                            return this.loader.hide(), this.dispatchEvent(new Ud(rt)), this.state.transitionAnimation = this.renderer.transition(rt, Co, Wn), this.state.transitionAnimation;
                        }).then((Qe)=>{
                            if (this.state.transitionAnimation = null, this.dispatchEvent(new Hd(Qe)), !Qe) throw getAbortError();
                        }).then(()=>done(), (Qe)=>done(Qe)) : this.state.loadingPromise = Co.then((Qe)=>{
                            let { textureData: Wn, cleanOptions: Co } = Qe;
                            this.renderer.show(), this.renderer.setTexture(Wn), this.renderer.setPanoramaPose(Wn.panoData), this.renderer.setSphereCorrection(rt.sphereCorrection), this.state.ready || this.init(), this.dispatchEvent(new Ud(Wn)), isNil(Co.zoom) || this.zoom(Co.zoom), isNil(Co.position) || this.rotate(Co.position);
                        }).then(()=>done(), (Qe)=>done(Qe)), this.state.loadingPromise;
                    }
                    setOptions(Qe) {
                        const rt = {
                            ...this.config,
                            ...Qe
                        };
                        for (let [Wn, Co] of Object.entries(Qe))if (Wn in lm) {
                            if (Wn in cm) logWarn(cm[Wn]);
                            else switch(Wn in um && (Co = um[Wn](Co, {
                                rawConfig: rt,
                                defValue: lm[Wn]
                            })), this.config[Wn] = Co, Wn){
                                case "mousemove":
                                    this.state.cursorOverride || this.setCursor(null);
                                    break;
                                case "caption":
                                    this.navbar.setCaption(this.config.caption);
                                    break;
                                case "size":
                                    this.resize(this.config.size);
                                    break;
                                case "sphereCorrection":
                                    this.renderer.setSphereCorrection(this.config.sphereCorrection);
                                    break;
                                case "navbar":
                                case "lang":
                                    this.navbar.setButtons(this.config.navbar);
                                    break;
                                case "moveSpeed":
                                case "zoomSpeed":
                                    this.dynamics.updateSpeeds();
                                    break;
                                case "minFov":
                                case "maxFov":
                                    this.dynamics.zoom.setValue(this.dataHelper.fovToZoomLevel(this.state.vFov)), this.dispatchEvent(new kp(this.getZoomLevel()));
                                    break;
                                case "keyboard":
                                    "always" === this.config.keyboard ? this.startKeyboardControl() : this.stopKeyboardControl();
                            }
                        } else logWarn(`Unknown option ${Wn}`);
                        this.needsUpdate(), this.dispatchEvent(new xd(Object.keys(Qe)));
                    }
                    setOption(Qe, rt) {
                        this.setOptions({
                            [Qe]: rt
                        });
                    }
                    showError(Qe) {
                        this.overlay.show({
                            id: du.ERROR,
                            image: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="15 15 70 70"><path fill="currentColor" d="M50,16.2c-18.6,0-33.8,15.1-33.8,33.8S31.4,83.7,50,83.7S83.8,68.6,83.8,50S68.6,16.2,50,16.2z M50,80.2c-16.7,0-30.2-13.6-30.2-30.2S33.3,19.7,50,19.7S80.3,33.3,80.3,50S66.7,80.2,50,80.2z"/><rect fill="currentColor" x="48" y="31.7" width="4" height="28"/><rect fill="currentColor" x="48" y="63.2" width="4" height="5"/><!--Created by Shastry from the Noun Project--></svg>\n',
                            title: Qe,
                            dismissible: !1
                        });
                    }
                    hideError() {
                        this.overlay.hide(du.ERROR);
                    }
                    rotate(Qe) {
                        const rt = new Ad(this.dataHelper.cleanPosition(Qe));
                        this.dispatchEvent(rt), rt.defaultPrevented || this.dynamics.position.setValue(rt.position);
                    }
                    zoom(Qe) {
                        this.dynamics.zoom.setValue(Qe);
                    }
                    zoomIn(Qe) {
                        void 0 === Qe && (Qe = 1), this.dynamics.zoom.step(Qe);
                    }
                    zoomOut(Qe) {
                        void 0 === Qe && (Qe = 1), this.dynamics.zoom.step(-Qe);
                    }
                    animate(Qe) {
                        const rt = isExtendedPosition(Qe), Wn = !isNil(Qe.zoom), Co = new pd(rt ? this.dataHelper.cleanPosition(Qe) : void 0, Qe.zoom);
                        if (this.dispatchEvent(Co), Co.defaultPrevented) return;
                        this.stopAll();
                        const { duration: Dl, properties: Ll } = this.dataHelper.getAnimationProperties(Qe.speed, Co.position, Co.zoomLevel);
                        return Dl ? (this.state.animation = new id({
                            properties: Ll,
                            duration: Dl,
                            easing: Qe.easing || "inOutSine",
                            onTick: (Qe)=>{
                                rt && this.dynamics.position.setValue({
                                    yaw: Qe.yaw,
                                    pitch: Qe.pitch
                                }), Wn && this.dynamics.zoom.setValue(Qe.zoom);
                            }
                        }), this.state.animation.then(()=>{
                            this.state.animation = null, this.resetIdleTimer();
                        }), this.state.animation) : (rt && this.rotate(Co.position), Wn && this.zoom(Co.zoomLevel), new id(null));
                    }
                    stopAnimation() {
                        return this.state.animation ? (this.state.animation.cancel(), this.state.animation) : Promise.resolve();
                    }
                    resize(Qe) {
                        this.__setSize(Qe), this.autoSize();
                    }
                    __setSize(Qe) {
                        [
                            "width",
                            "height"
                        ].forEach((rt)=>{
                            Qe?.[rt] && (/^[0-9.]+$/.test(Qe[rt]) && (Qe[rt] += "px"), this.parent.style[rt] = Qe[rt]);
                        });
                    }
                    enterFullscreen() {
                        this.isFullscreenEnabled() || requestFullscreen(this.parent, Fp.isIphone);
                    }
                    exitFullscreen() {
                        this.isFullscreenEnabled() && exitFullscreen(Fp.isIphone);
                    }
                    toggleFullscreen() {
                        this.isFullscreenEnabled() ? this.exitFullscreen() : this.enterFullscreen();
                    }
                    startKeyboardControl() {
                        this.state.keyboardEnabled = !0;
                    }
                    stopKeyboardControl() {
                        this.state.keyboardEnabled = !1;
                    }
                    createTooltip(Qe) {
                        return new bm(this, Qe);
                    }
                    setCursor(Qe) {
                        this.state.cursorOverride = Qe, this.container.style.cursor = Qe || (this.config.mousemove ? "move" : "default");
                    }
                    observeObjects(Qe) {
                        this.state.objectsObservers[Qe] || (this.state.objectsObservers[Qe] = null);
                    }
                    unobserveObjects(Qe) {
                        delete this.state.objectsObservers[Qe];
                    }
                    stopAll() {
                        return this.dispatchEvent(new Tp), this.disableIdleTimer(), this.stopAnimation();
                    }
                };
            },
            3890: (Qe, rt, Wn)=>{
                "use strict";
                Wn.d(rt, {
                    D: ()=>Hl
                });
                var Co = Wn(1545), Dl = Wn(9435), Ll = class {
                    constructor(Qe, rt, Wn){
                        this.id = Qe, this.priority = rt, this.fn = Wn, this.status = 1;
                    }
                    start() {
                        return this.status = 2, this.fn(this).then(()=>{
                            this.status = 4;
                        }, ()=>{
                            this.status = 5;
                        });
                    }
                    cancel() {
                        this.status = 3;
                    }
                    isCancelled() {
                        return 3 === this.status;
                    }
                }, Rl = class {
                    constructor(Qe){
                        void 0 === Qe && (Qe = 4), this.concurency = Qe, this.runningTasks = {}, this.tasks = {};
                    }
                    enqueue(Qe) {
                        this.tasks[Qe.id] = Qe;
                    }
                    clear() {
                        Object.values(this.tasks).forEach((Qe)=>Qe.cancel()), this.tasks = {}, this.runningTasks = {};
                    }
                    setPriority(Qe, rt) {
                        const Wn = this.tasks[Qe];
                        Wn && (Wn.priority = rt, 0 === Wn.status && (Wn.status = 1));
                    }
                    disableAllTasks() {
                        Object.values(this.tasks).forEach((Qe)=>{
                            Qe.status = 0;
                        });
                    }
                    start() {
                        if (Object.keys(this.runningTasks).length >= this.concurency) return;
                        const Qe = Object.values(this.tasks).filter((Qe)=>1 === Qe.status).sort((Qe, rt)=>rt.priority - Qe.priority).pop();
                        Qe && (this.runningTasks[Qe.id] = !0, Qe.start().then(()=>{
                            Qe.isCancelled() || (delete this.tasks[Qe.id], delete this.runningTasks[Qe.id], this.start());
                        }), this.start());
                    }
                };
                var Ul = [
                    "dodgerblue",
                    "limegreen",
                    "indianred"
                ];
                function isMultiTiles(Qe) {
                    return !!Qe.levels;
                }
                function computeTileConfig(Qe, rt, Wn) {
                    return {
                        ...Qe,
                        level: rt,
                        colSize: Qe.width / Qe.cols,
                        rowSize: Qe.width / 2 / Qe.rows,
                        facesByCol: Wn.SPHERE_SEGMENTS / Qe.cols,
                        facesByRow: Wn.SPHERE_HORIZONTAL_SEGMENTS / Qe.rows
                    };
                }
                function getTileConfig(Qe, rt, Wn) {
                    let Co, Dl;
                    return isMultiTiles(Qe) ? (Dl = function(Qe, rt) {
                        return Qe.findIndex((Qe)=>rt >= Qe.zoomRange[0] && rt <= Qe.zoomRange[1]);
                    }(Qe.levels, rt), Co = Qe.levels[Dl]) : (Dl = 0, Co = {
                        ...Qe,
                        zoomRange: [
                            0,
                            100
                        ]
                    }), computeTileConfig(Co, Dl, Wn);
                }
                function getTileConfigByIndex(Qe, rt, Wn) {
                    return isMultiTiles(Qe) && Qe.levels[rt] ? computeTileConfig(Qe.levels[rt], rt, Wn) : null;
                }
                function checkPanoramaConfig(Qe, rt) {
                    if ("object" !== typeof Qe || !Qe.tileUrl) throw new Co.e6("Invalid panorama configuration, are you using the right adapter?");
                    isMultiTiles(Qe) ? (Qe.levels.forEach((Qe)=>checkTile(Qe, rt)), function(Qe) {
                        let rt = 0;
                        Qe.forEach((Wn, Dl)=>{
                            if (!Wn.zoomRange || 2 !== Wn.zoomRange.length) throw new Co.e6(`Tiles level ${Dl} is missing "zoomRange" property`);
                            if (Wn.zoomRange[0] >= Wn.zoomRange[1] || Wn.zoomRange[0] !== rt || 0 === Dl && 0 !== Wn.zoomRange[0] || Dl === Qe.length - 1 && 100 !== Wn.zoomRange[1]) throw new Co.e6('Tiles levels\' "zoomRange" are not orderer or are not covering the whole 0-100 range');
                            rt = Wn.zoomRange[1];
                        });
                    }(Qe.levels)) : checkTile(Qe, rt);
                }
                function checkTile(Qe, rt) {
                    if (!Qe.width || !Qe.cols || !Qe.rows) throw new Co.e6("Invalid panorama configuration, are you using the right adapter?");
                    if (Qe.cols > rt.SPHERE_SEGMENTS) throw new Co.e6(`Panorama cols must not be greater than ${rt.SPHERE_SEGMENTS}.`);
                    if (Qe.rows > rt.SPHERE_HORIZONTAL_SEGMENTS) throw new Co.e6(`Panorama rows must not be greater than ${rt.SPHERE_HORIZONTAL_SEGMENTS}.`);
                    if (!Dl.cj9.isPowerOfTwo(Qe.cols) || !Dl.cj9.isPowerOfTwo(Qe.rows)) throw new Co.e6("Panorama cols and rows must be powers of 2.");
                }
                function getCacheKey(Qe, rt) {
                    for(let Wn = 0; Wn < rt.cols; Wn++){
                        const Co = Qe.tileUrl(Wn, rt.rows / 2, rt.level);
                        if (Co) return Co;
                    }
                    return Qe.tileUrl.toString();
                }
                function tileId(Qe) {
                    return `${Qe.col}x${Qe.row}/${Qe.config.level}`;
                }
                function meshes(Qe) {
                    return Qe.children;
                }
                var Gl = Co.Wp.getConfigParser({
                    resolution: 64,
                    showErrorTile: !0,
                    baseBlur: !0,
                    antialias: !0,
                    debug: !1,
                    useXmpData: !1
                }), Zl = new Dl.Pq0, Hl = class extends Co.Qw {
                    constructor(Qe, rt){
                        super(Qe), this.state = {
                            tileConfig: null,
                            tiles: {},
                            faces: {},
                            geom: null,
                            materials: [],
                            errorMaterial: null,
                            inTransition: !1
                        }, this.queue = new Rl, this.config = Gl(rt), this.adapter = new Co.GR(this.viewer, {
                            resolution: this.config.resolution,
                            blur: this.config.baseBlur
                        }), this.SPHERE_SEGMENTS = this.config.resolution, this.SPHERE_HORIZONTAL_SEGMENTS = this.SPHERE_SEGMENTS / 2, this.NB_VERTICES = 2 * this.SPHERE_SEGMENTS * 3 + (this.SPHERE_HORIZONTAL_SEGMENTS - 2) * this.SPHERE_SEGMENTS * 6, this.NB_GROUPS = this.SPHERE_SEGMENTS * this.SPHERE_HORIZONTAL_SEGMENTS, this.viewer.config.requestHeaders && Co.Wp.logWarn('EquirectangularTilesAdapter fallbacks to file loader because "requestHeaders" where provided. Consider removing "requestHeaders" if you experience performances issues.');
                    }
                    init() {
                        super.init(), this.viewer.addEventListener(Co.AZ.TransitionDoneEvent.type, this), this.viewer.addEventListener(Co.AZ.PositionUpdatedEvent.type, this), this.viewer.addEventListener(Co.AZ.ZoomUpdatedEvent.type, this);
                    }
                    destroy() {
                        this.viewer.removeEventListener(Co.AZ.TransitionDoneEvent.type, this), this.viewer.removeEventListener(Co.AZ.PositionUpdatedEvent.type, this), this.viewer.removeEventListener(Co.AZ.ZoomUpdatedEvent.type, this), this.__cleanup(), this.state.errorMaterial?.map?.dispose(), this.state.errorMaterial?.dispose(), this.adapter.destroy(), delete this.adapter, delete this.state.geom, delete this.state.errorMaterial, super.destroy();
                    }
                    handleEvent(Qe) {
                        switch(Qe.type){
                            case Co.AZ.PositionUpdatedEvent.type:
                            case Co.AZ.ZoomUpdatedEvent.type:
                                this.__refresh();
                                break;
                            case Co.AZ.TransitionDoneEvent.type:
                                this.state.inTransition = !1, Qe.completed && this.__switchMesh(this.viewer.renderer.mesh);
                        }
                    }
                    supportsTransition(Qe) {
                        return !!Qe.baseUrl;
                    }
                    supportsPreload(Qe) {
                        return !!Qe.baseUrl;
                    }
                    textureCoordsToSphericalCoords(Qe, rt) {
                        return this.adapter.textureCoordsToSphericalCoords(Qe, rt);
                    }
                    sphericalCoordsToTextureCoords(Qe, rt) {
                        return this.adapter.sphericalCoordsToTextureCoords(Qe, rt);
                    }
                    async loadTexture(Qe, rt) {
                        void 0 === rt && (rt = !0), checkPanoramaConfig(Qe, this);
                        const Wn = getTileConfig(Qe, 0, this), Co = {
                            isEquirectangular: !0,
                            fullWidth: Wn.width,
                            fullHeight: Wn.width / 2,
                            croppedWidth: Wn.width,
                            croppedHeight: Wn.width / 2,
                            croppedX: 0,
                            croppedY: 0,
                            poseHeading: 0,
                            posePitch: 0,
                            poseRoll: 0
                        };
                        if (Qe.baseUrl) {
                            const Wn = await this.adapter.loadTexture(Qe.baseUrl, rt, Qe.basePanoData, !0);
                            return {
                                panorama: Qe,
                                panoData: {
                                    ...Co,
                                    baseData: Wn.panoData
                                },
                                cacheKey: Wn.cacheKey,
                                texture: Wn.texture
                            };
                        }
                        return {
                            panorama: Qe,
                            panoData: {
                                ...Co,
                                baseData: null
                            },
                            cacheKey: getCacheKey(Qe, Wn),
                            texture: null
                        };
                    }
                    createMesh(Qe) {
                        const rt = this.adapter.createMesh(Qe.baseData ?? Qe), Wn = new Dl.Gu$(Co.aH.SPHERE_RADIUS, this.SPHERE_SEGMENTS, this.SPHERE_HORIZONTAL_SEGMENTS, -Math.PI / 2).scale(-1, 1, 1).toNonIndexed();
                        Wn.clearGroups();
                        let Ll = 0, Rl = 0;
                        for(; Ll < 3 * this.SPHERE_SEGMENTS; Ll += 3)Wn.addGroup(Ll, 3, Rl++);
                        for(; Ll < this.NB_VERTICES - 3 * this.SPHERE_SEGMENTS; Ll += 6)Wn.addGroup(Ll, 6, Rl++);
                        for(; Ll < this.NB_VERTICES; Ll += 3)Wn.addGroup(Ll, 3, Rl++);
                        const Ul = [], Gl = new Dl.V9B({
                            opacity: 0,
                            transparent: !0,
                            depthTest: !1,
                            depthWrite: !1
                        });
                        for(let Co = 0; Co < this.NB_GROUPS; Co++)Ul.push(Gl);
                        const Zl = new Dl.eaF(Wn, Ul);
                        Zl.renderOrder = 1;
                        const Hl = new Dl.YJl;
                        return Hl.add(rt), Hl.add(Zl), Hl;
                    }
                    setTexture(Qe, rt, Wn) {
                        const [Co] = meshes(Qe);
                        rt.texture ? this.adapter.setTexture(Co, {
                            panorama: rt.panorama.baseUrl,
                            texture: rt.texture,
                            panoData: rt.panoData.baseData
                        }) : Co.visible = !1, Wn ? this.state.inTransition = !0 : this.__switchMesh(Qe);
                    }
                    setTextureOpacity(Qe, rt) {
                        const [Wn] = meshes(Qe);
                        this.adapter.setTextureOpacity(Wn, rt);
                    }
                    disposeTexture(Qe) {
                        let { texture: rt } = Qe;
                        rt?.dispose();
                    }
                    disposeMesh(Qe) {
                        const [rt, Wn] = meshes(Qe);
                        rt.geometry.dispose(), rt.material.dispose(), Wn.geometry.dispose(), Wn.material.forEach((Qe)=>Qe.dispose());
                    }
                    __refresh() {
                        if (!this.state.geom || this.state.inTransition) return;
                        const Qe = this.viewer.config.panorama, rt = getTileConfig(Qe, this.viewer.getZoomLevel(), this), Wn = this.state.geom.getAttribute("position"), Co = {};
                        for(let Dl = 0; Dl < this.NB_VERTICES; Dl += 1)if (Zl.fromBufferAttribute(Wn, Dl), Zl.applyEuler(this.viewer.renderer.sphereCorrection), this.viewer.renderer.isObjectVisible(Zl)) {
                            let Wn;
                            Wn = Dl < 3 * this.SPHERE_SEGMENTS ? Math.floor(Dl / 3) : Dl < this.NB_VERTICES - 3 * this.SPHERE_SEGMENTS ? Math.floor((Dl / 3 - this.SPHERE_SEGMENTS) / 2) + this.SPHERE_SEGMENTS : Math.floor((Dl - this.NB_VERTICES - 3 * this.SPHERE_SEGMENTS) / 3) + this.SPHERE_HORIZONTAL_SEGMENTS * (this.SPHERE_SEGMENTS - 1);
                            const Ll = Math.floor(Wn / this.SPHERE_SEGMENTS), Rl = Wn - Ll * this.SPHERE_SEGMENTS;
                            let Ul = rt;
                            for(; Ul;){
                                const rt = Math.floor(Ll / Ul.facesByRow), Wn = Math.floor(Rl / Ul.facesByCol);
                                let Dl = Zl.angleTo(this.viewer.state.direction);
                                0 !== rt && rt !== Ul.rows - 1 || (Dl *= 2);
                                const Gl = {
                                    row: rt,
                                    col: Wn,
                                    angle: Dl,
                                    config: Ul,
                                    url: null
                                }, Hl = tileId(Gl);
                                if (Co[Hl]) {
                                    Co[Hl].angle = Math.min(Co[Hl].angle, Dl);
                                    break;
                                }
                                if (Gl.url = Qe.tileUrl(Wn, rt, Ul.level), Gl.url) {
                                    Co[Hl] = Gl;
                                    break;
                                }
                                Ul = getTileConfigByIndex(Qe, Ul.level - 1, this);
                            }
                        }
                        this.state.tileConfig = rt, this.__loadTiles(Object.values(Co));
                    }
                    __loadTiles(Qe) {
                        this.queue.disableAllTasks(), Qe.forEach((Qe)=>{
                            const rt = tileId(Qe);
                            this.state.tiles[rt] ? this.queue.setPriority(rt, Qe.angle) : (this.state.tiles[rt] = !0, this.queue.enqueue(new Ll(rt, Qe.angle, (rt)=>this.__loadTile(Qe, rt))));
                        }), this.queue.start();
                    }
                    __loadTile(Qe, rt) {
                        return this.viewer.textureLoader.loadImage(Qe.url, null, this.viewer.state.textureData.cacheKey).then((Wn)=>{
                            if (!rt.isCancelled()) {
                                this.config.debug && (Wn = function(Qe, rt, Wn) {
                                    const Co = document.createElement("canvas");
                                    Co.width = Qe.width, Co.height = Qe.height;
                                    const Dl = Co.getContext("2d");
                                    Dl.fillStyle = Ul[rt % Ul.length], Dl.fillRect(0, 0, Co.width, Co.height), Dl.globalCompositeOperation = "multiply", Dl.drawImage(Qe, 0, 0);
                                    const Ll = Qe.width / 7;
                                    return Dl.globalCompositeOperation = "source-over", Dl.fillStyle = "white", Dl.font = `${Ll}px monospace`, Dl.textAlign = "center", Wn.split("\n").forEach((rt, Wn)=>{
                                        Dl.fillText(rt, Qe.width / 2, Qe.height / 2 + Ll * (.3 + Wn));
                                    }), Co;
                                }(Wn, Qe.config.level, tileId(Qe)));
                                const rt = this.config.antialias && Qe.config.level > 0, Ll = new Dl.V9B({
                                    map: Co.Wp.createTexture(Wn, rt)
                                });
                                this.__swapMaterial(Qe, Ll, !1), this.viewer.needsUpdate();
                            }
                        }).catch((Wn)=>{
                            Co.Wp.isAbortError(Wn) || rt.isCancelled() || !this.config.showErrorTile || (this.state.errorMaterial || (this.state.errorMaterial = function() {
                                const Qe = new OffscreenCanvas(512, 512), rt = Qe.getContext("2d");
                                return rt.fillStyle = "#333", rt.fillRect(0, 0, Qe.width, Qe.height), rt.font = Qe.width / 5 + "px serif", rt.fillStyle = "#a22", rt.textAlign = "center", rt.textBaseline = "middle", rt.fillText("\u26A0", Qe.width / 2, Qe.height / 2), new Dl.V9B({
                                    map: Co.Wp.createTexture(Qe)
                                });
                            }()), this.__swapMaterial(Qe, this.state.errorMaterial, !0), this.viewer.needsUpdate());
                        });
                    }
                    __swapMaterial(Qe, rt, Wn) {
                        const Co = this.state.geom.getAttribute("uv");
                        for(let Dl = 0; Dl < Qe.config.facesByCol; Dl++)for(let Ll = 0; Ll < Qe.config.facesByRow; Ll++){
                            const Rl = Qe.col * Qe.config.facesByCol + Dl, Ul = Qe.row * Qe.config.facesByRow + Ll, Gl = 0 === Ul, Zl = Ul === this.SPHERE_HORIZONTAL_SEGMENTS - 1;
                            let Hl;
                            if (Hl = Gl ? 3 * Rl : Zl ? this.NB_VERTICES - 3 * this.SPHERE_SEGMENTS + 3 * Rl : 3 * this.SPHERE_SEGMENTS + (Ul - 1) * this.SPHERE_SEGMENTS * 6 + 6 * Rl, Wn && this.state.faces[Hl] > -1) continue;
                            if (this.state.faces[Hl] > Qe.config.level) continue;
                            this.state.faces[Hl] = Wn ? -1 : Qe.config.level;
                            const ql = this.state.geom.groups.find((Qe)=>Qe.start === Hl).materialIndex;
                            this.state.materials[ql] = rt;
                            const Ql = 1 - Ll / Qe.config.facesByRow, Kl = 1 - (Ll + 1) / Qe.config.facesByRow, $l = Dl / Qe.config.facesByCol, Tc = (Dl + 1) / Qe.config.facesByCol;
                            Gl ? (Co.setXY(Hl, ($l + Tc) / 2, Ql), Co.setXY(Hl + 1, $l, Kl), Co.setXY(Hl + 2, Tc, Kl)) : Zl ? (Co.setXY(Hl, Tc, Ql), Co.setXY(Hl + 1, $l, Ql), Co.setXY(Hl + 2, ($l + Tc) / 2, Kl)) : (Co.setXY(Hl, Tc, Ql), Co.setXY(Hl + 1, $l, Ql), Co.setXY(Hl + 2, Tc, Kl), Co.setXY(Hl + 3, $l, Ql), Co.setXY(Hl + 4, $l, Kl), Co.setXY(Hl + 5, Tc, Kl));
                        }
                        Co.needsUpdate = !0;
                    }
                    __switchMesh(Qe) {
                        const [, rt] = meshes(Qe);
                        if (this.__cleanup(), this.state.materials = rt.material, this.state.geom = rt.geometry, this.config.debug) {
                            const Qe = function(Qe) {
                                const rt = new Dl.XJ7(Qe), Wn = new Dl.DXC(rt);
                                return Wn.material.depthTest = !1, Wn.material.depthWrite = !1, Wn.material.opacity = .25, Wn.material.transparent = !0, Wn;
                            }(this.state.geom);
                            this.viewer.renderer.addObject(Qe), this.viewer.renderer.setSphereCorrection(this.viewer.config.sphereCorrection, Qe);
                        }
                        setTimeout(()=>this.__refresh());
                    }
                    __cleanup() {
                        this.queue.clear(), this.state.tiles = {}, this.state.faces = {}, this.state.materials = [], this.state.inTransition = !1;
                    }
                };
                Hl.id = "equirectangular-tiles", Hl.VERSION = "5.12.1", Hl.supportsDownload = !1;
            },
            4991: (Qe, rt, Wn)=>{
                "use strict";
                Wn.d(rt, {
                    b: ()=>Nd
                });
                var Co = Wn(1545), Dl = Wn(9435), Ll = Object.defineProperty;
                ((Qe, rt)=>{
                    for(var Wn in rt)Ll(Qe, Wn, {
                        get: rt[Wn],
                        enumerable: !0
                    });
                })({}, {
                    EnterMarkerEvent: ()=>$l,
                    GotoMarkerDoneEvent: ()=>Hl,
                    HideMarkersEvent: ()=>Tu,
                    LeaveMarkerEvent: ()=>Ql,
                    MarkerVisibilityEvent: ()=>Gl,
                    MarkersPluginEvent: ()=>Rl,
                    RenderMarkersListEvent: ()=>ed,
                    SelectMarkerEvent: ()=>tu,
                    SelectMarkerListEvent: ()=>du,
                    SetMarkersEvent: ()=>Zu,
                    ShowMarkersEvent: ()=>Ju,
                    UnselectMarkerEvent: ()=>yu
                });
                var Rl = class extends Co.rx {
                }, Ul = class _MarkerVisibilityEvent extends Rl {
                    constructor(Qe, rt){
                        super(_MarkerVisibilityEvent.type), this.marker = Qe, this.visible = rt;
                    }
                };
                Ul.type = "marker-visibility";
                var Gl = Ul, Zl = class _GotoMarkerDoneEvent extends Rl {
                    constructor(Qe){
                        super(_GotoMarkerDoneEvent.type), this.marker = Qe;
                    }
                };
                Zl.type = "goto-marker-done";
                var Hl = Zl, ql = class _LeaveMarkerEvent extends Rl {
                    constructor(Qe){
                        super(_LeaveMarkerEvent.type), this.marker = Qe;
                    }
                };
                ql.type = "leave-marker";
                var Ql = ql, Kl = class _EnterMarkerEvent extends Rl {
                    constructor(Qe){
                        super(_EnterMarkerEvent.type), this.marker = Qe;
                    }
                };
                Kl.type = "enter-marker";
                var $l = Kl, Tc = class _SelectMarkerEvent extends Rl {
                    constructor(Qe, rt, Wn){
                        super(_SelectMarkerEvent.type), this.marker = Qe, this.doubleClick = rt, this.rightClick = Wn;
                    }
                };
                Tc.type = "select-marker";
                var tu = Tc, lu = class _SelectMarkerListEvent extends Rl {
                    constructor(Qe){
                        super(_SelectMarkerListEvent.type), this.marker = Qe;
                    }
                };
                lu.type = "select-marker-list";
                var du = lu, fu = class _UnselectMarkerEvent extends Rl {
                    constructor(Qe){
                        super(_UnselectMarkerEvent.type), this.marker = Qe;
                    }
                };
                fu.type = "unselect-marker";
                var yu = fu, Eu = class _HideMarkersEvent extends Rl {
                    constructor(){
                        super(_HideMarkersEvent.type);
                    }
                };
                Eu.type = "hide-markers";
                var Tu = Eu, Lu = class _SetMarkersEvent extends Rl {
                    constructor(Qe){
                        super(_SetMarkersEvent.type), this.markers = Qe;
                    }
                };
                Lu.type = "set-markers";
                var Zu = Lu, Xu = class _ShowMarkersEvent extends Rl {
                    constructor(){
                        super(_ShowMarkersEvent.type);
                    }
                };
                Xu.type = "show-markers";
                var Ju = Xu, $u = class _RenderMarkersListEvent extends Rl {
                    constructor(Qe){
                        super(_RenderMarkersListEvent.type), this.markers = Qe;
                    }
                };
                $u.type = "render-markers-list";
                var ed = $u, td = class extends Co.Np {
                    constructor(Qe){
                        super(Qe, {
                            className: "psv-markers-button",
                            icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="10 9 81 81"><path fill="currentColor" d="M50.5 90S22.9 51.9 22.9 36.6 35.2 9 50.5 9s27.6 12.4 27.6 27.6S50.5 90 50.5 90zm0-66.3c-6.1 0-11 4.9-11 11s4.9 11 11 11 11-4.9 11-11-4.9-11-11-11z"/><!--Created by Rohith M S from the Noun Project--></svg>\n',
                            hoverScale: !0,
                            collapsable: !0,
                            tabbable: !0
                        }), this.plugin = this.viewer.getPlugin("markers"), this.plugin && (this.plugin.addEventListener(Ju.type, this), this.plugin.addEventListener(Tu.type, this), this.toggleActive(!0));
                    }
                    destroy() {
                        this.plugin && (this.plugin.removeEventListener(Ju.type, this), this.plugin.removeEventListener(Tu.type, this)), super.destroy();
                    }
                    isSupported() {
                        return !!this.plugin;
                    }
                    handleEvent(Qe) {
                        Qe instanceof Ju ? this.toggleActive(!0) : Qe instanceof Tu && this.toggleActive(!1);
                    }
                    onClick() {
                        this.plugin.toggleAllMarkers();
                    }
                };
                td.id = "markers";
                var id = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="9 9 81 81"><path fill="currentColor" d="M37.5 90S9.9 51.9 9.9 36.6 22.2 9 37.5 9s27.6 12.4 27.6 27.6S37.5 90 37.5 90zm0-66.3c-6.1 0-11 4.9-11 11s4.9 11 11 11 11-4.9 11-11-4.9-11-11-11zM86.7 55H70c-1.8 0-3.3-1.5-3.3-3.3s1.5-3.3 3.3-3.3h16.7c1.8 0 3.3 1.5 3.3 3.3S88.5 55 86.7 55zm0-25h-15a3.3 3.3 0 0 1-3.3-3.3c0-1.8 1.5-3.3 3.3-3.3h15c1.8 0 3.3 1.5 3.3 3.3 0 1.8-1.5 3.3-3.3 3.3zM56.5 73h30c1.8 0 3.3 1.5 3.3 3.3 0 1.8-1.5 3.3-3.3 3.3h-30a3.3 3.3 0 0 1-3.3-3.3 3.2 3.2 0 0 1 3.3-3.3z"/><!--Created by Rohith M S from the Noun Project--></svg>\n', nd = "http://www.w3.org/2000/svg", rd = "psvMarker", sd = Co.Wp.dasherize(rd), ad = "marker", od = "markersList", ld = {
                    amount: 2,
                    duration: 100,
                    easing: "linear"
                }, MARKERS_LIST_TEMPLATE = (Qe, rt)=>`\n<div class="psv-panel-menu psv-panel-menu--stripped">\n    <h1 class="psv-panel-menu-title">${id} ${rt}</h1>\n    <ul class="psv-panel-menu-list">\n    ${Qe.map((Qe)=>`\n        <li data-${sd}="${Qe.id}" class="psv-panel-menu-item" tabindex="0">\n          ${"image" === Qe.type ? `<span class="psv-panel-menu-item-icon"><img src="${Qe.definition}"/></span>` : ""}\n          <span class="psv-panel-menu-item-label">${Qe.getListContent()}</span>\n        </li>\n    `).join("")}\n    </ul>\n</div>\n`, cd = class extends Co.Np {
                    constructor(Qe){
                        super(Qe, {
                            className: " psv-markers-list-button",
                            icon: id,
                            hoverScale: !0,
                            collapsable: !0,
                            tabbable: !0
                        }), this.plugin = this.viewer.getPlugin("markers"), this.plugin && (this.viewer.addEventListener(Co.AZ.ShowPanelEvent.type, this), this.viewer.addEventListener(Co.AZ.HidePanelEvent.type, this));
                    }
                    destroy() {
                        this.viewer.removeEventListener(Co.AZ.ShowPanelEvent.type, this), this.viewer.removeEventListener(Co.AZ.HidePanelEvent.type, this), super.destroy();
                    }
                    isSupported() {
                        return !!this.plugin;
                    }
                    handleEvent(Qe) {
                        Qe instanceof Co.AZ.ShowPanelEvent ? this.toggleActive(Qe.panelId === od) : Qe instanceof Co.AZ.HidePanelEvent && this.toggleActive(!1);
                    }
                    onClick() {
                        this.plugin.toggleMarkersList();
                    }
                };
                cd.id = "markersList";
                var ud = new Dl.Pq0, hd = new Dl.PTz, dd = new Dl.Pq0, pd = class extends Dl.B69 {
                    constructor(Qe){
                        void 0 === Qe && (Qe = document.createElement("div")), super(), this.isCSS3DObject = !0, this.element = Qe, this.element.style.position = "absolute", this.element.style.pointerEvents = "auto", this.element.style.userSelect = "none", this.element.setAttribute("draggable", !1), this.addEventListener("removed", function() {
                            this.traverse(function(Qe) {
                                Qe.element instanceof Qe.element.ownerDocument.defaultView.Element && null !== Qe.element.parentNode && Qe.element.remove();
                            });
                        });
                    }
                    copy(Qe, rt) {
                        return super.copy(Qe, rt), this.element = Qe.element.cloneNode(!0), this;
                    }
                }, md = new Dl.kn4, fd = new Dl.kn4, gd = class {
                    constructor(Qe){
                        void 0 === Qe && (Qe = {});
                        const rt = this;
                        let Wn, Co, Dl, Ll;
                        const Rl = {
                            camera: {
                                style: ""
                            },
                            objects: new WeakMap
                        }, Ul = void 0 !== Qe.element ? Qe.element : document.createElement("div");
                        Ul.style.overflow = "hidden", this.domElement = Ul;
                        const Gl = document.createElement("div");
                        Gl.style.transformOrigin = "0 0", Gl.style.pointerEvents = "none", Ul.appendChild(Gl);
                        const Zl = document.createElement("div");
                        function epsilon(Qe) {
                            return Math.abs(Qe) < 1e-10 ? 0 : Qe;
                        }
                        function getCameraCSSMatrix(Qe) {
                            const rt = Qe.elements;
                            return "matrix3d(" + epsilon(rt[0]) + "," + epsilon(-rt[1]) + "," + epsilon(rt[2]) + "," + epsilon(rt[3]) + "," + epsilon(rt[4]) + "," + epsilon(-rt[5]) + "," + epsilon(rt[6]) + "," + epsilon(rt[7]) + "," + epsilon(rt[8]) + "," + epsilon(-rt[9]) + "," + epsilon(rt[10]) + "," + epsilon(rt[11]) + "," + epsilon(rt[12]) + "," + epsilon(-rt[13]) + "," + epsilon(rt[14]) + "," + epsilon(rt[15]) + ")";
                        }
                        function getObjectCSSMatrix(Qe) {
                            const rt = Qe.elements;
                            return "translate(-50%,-50%)" + ("matrix3d(" + epsilon(rt[0]) + "," + epsilon(rt[1]) + "," + epsilon(rt[2]) + "," + epsilon(rt[3]) + "," + epsilon(-rt[4]) + "," + epsilon(-rt[5]) + "," + epsilon(-rt[6]) + "," + epsilon(-rt[7]) + "," + epsilon(rt[8]) + "," + epsilon(rt[9]) + "," + epsilon(rt[10]) + "," + epsilon(rt[11]) + "," + epsilon(rt[12]) + "," + epsilon(rt[13]) + "," + epsilon(rt[14]) + "," + epsilon(rt[15]) + ")");
                        }
                        function hideObject(Qe) {
                            Qe.isCSS3DObject && (Qe.element.style.display = "none");
                            for(let rt = 0, Wn = Qe.children.length; rt < Wn; rt++)hideObject(Qe.children[rt]);
                        }
                        function renderObject(Qe, Wn, Co, Dl) {
                            if (!1 !== Qe.visible) {
                                if (Qe.isCSS3DObject) {
                                    const Dl = !0 === Qe.layers.test(Co.layers), Ll = Qe.element;
                                    if (Ll.style.display = !0 === Dl ? "" : "none", !0 === Dl) {
                                        let Dl;
                                        Qe.onBeforeRender(rt, Wn, Co), Qe.isCSS3DSprite ? (md.copy(Co.matrixWorldInverse), md.transpose(), 0 !== Qe.rotation2D && md.multiply(fd.makeRotationZ(Qe.rotation2D)), Qe.matrixWorld.decompose(ud, hd, dd), md.setPosition(ud), md.scale(dd), md.elements[3] = 0, md.elements[7] = 0, md.elements[11] = 0, md.elements[15] = 1, Dl = getObjectCSSMatrix(md)) : Dl = getObjectCSSMatrix(Qe.matrixWorld);
                                        const Ul = Rl.objects.get(Qe);
                                        if (void 0 === Ul || Ul.style !== Dl) {
                                            Ll.style.transform = Dl;
                                            const rt = {
                                                style: Dl
                                            };
                                            Rl.objects.set(Qe, rt);
                                        }
                                        Ll.parentNode !== Zl && Zl.appendChild(Ll), Qe.onAfterRender(rt, Wn, Co);
                                    }
                                }
                                for(let rt = 0, Ll = Qe.children.length; rt < Ll; rt++)renderObject(Qe.children[rt], Wn, Co, Dl);
                            } else hideObject(Qe);
                        }
                        Zl.style.transformStyle = "preserve-3d", Gl.appendChild(Zl), this.getSize = function() {
                            return {
                                width: Wn,
                                height: Co
                            };
                        }, this.render = function(Qe, rt) {
                            const Ul = rt.projectionMatrix.elements[5] * Ll;
                            let Hl, ql;
                            rt.view && rt.view.enabled ? (Gl.style.transform = `translate( ${-rt.view.offsetX * (Wn / rt.view.width)}px, ${-rt.view.offsetY * (Co / rt.view.height)}px )`, Gl.style.transform += `scale( ${rt.view.fullWidth / rt.view.width}, ${rt.view.fullHeight / rt.view.height} )`) : Gl.style.transform = "", !0 === Qe.matrixWorldAutoUpdate && Qe.updateMatrixWorld(), null === rt.parent && !0 === rt.matrixWorldAutoUpdate && rt.updateMatrixWorld(), rt.isOrthographicCamera && (Hl = -(rt.right + rt.left) / 2, ql = (rt.top + rt.bottom) / 2);
                            const Ql = rt.view && rt.view.enabled ? rt.view.height / rt.view.fullHeight : 1, Kl = rt.isOrthographicCamera ? `scale( ${Ql} )scale(` + Ul + ")translate(" + epsilon(Hl) + "px," + epsilon(ql) + "px)" + getCameraCSSMatrix(rt.matrixWorldInverse) : `scale( ${Ql} )translateZ(` + Ul + "px)" + getCameraCSSMatrix(rt.matrixWorldInverse), $l = (rt.isPerspectiveCamera ? "perspective(" + Ul + "px) " : "") + Kl + "translate(" + Dl + "px," + Ll + "px)";
                            Rl.camera.style !== $l && (Zl.style.transform = $l, Rl.camera.style = $l), renderObject(Qe, Qe, rt, Kl);
                        }, this.setSize = function(Qe, rt) {
                            Wn = Qe, Co = rt, Dl = Wn / 2, Ll = Co / 2, Ul.style.width = Qe + "px", Ul.style.height = rt + "px", Gl.style.width = Qe + "px", Gl.style.height = rt + "px", Zl.style.width = Qe + "px", Zl.style.height = rt + "px";
                        };
                    }
                }, Ad = class {
                    constructor(Qe){
                        this.viewer = Qe, this.element = document.createElement("div"), this.element.className = "psv-markers-css3d-container", this.renderer = new gd({
                            element: this.element
                        }), this.scene = new Dl.Z58, this.intersectionObserver = new IntersectionObserver((Qe)=>{
                            Qe.forEach((Qe)=>{
                                const rt = Qe.target[rd];
                                rt.config.visible && (rt.viewportIntersection = Qe.isIntersecting);
                            });
                        }, {
                            root: this.element
                        }), Qe.addEventListener(Co.AZ.ReadyEvent.type, this, {
                            once: !0
                        }), Qe.addEventListener(Co.AZ.SizeUpdatedEvent.type, this), Qe.addEventListener(Co.AZ.RenderEvent.type, this);
                    }
                    handleEvent(Qe) {
                        switch(Qe.type){
                            case Co.AZ.ReadyEvent.type:
                            case Co.AZ.SizeUpdatedEvent.type:
                                this.updateSize();
                                break;
                            case Co.AZ.RenderEvent.type:
                                this.render();
                        }
                    }
                    destroy() {
                        this.viewer.removeEventListener(Co.AZ.ReadyEvent.type, this), this.viewer.removeEventListener(Co.AZ.SizeUpdatedEvent.type, this), this.viewer.removeEventListener(Co.AZ.RenderEvent.type, this), this.intersectionObserver.disconnect();
                    }
                    updateSize() {
                        const Qe = this.viewer.getSize();
                        this.renderer.setSize(Qe.width, Qe.height);
                    }
                    render() {
                        this.renderer.render(this.scene, this.viewer.renderer.camera);
                    }
                    addObject(Qe) {
                        this.scene.add(Qe.threeElement), this.intersectionObserver.observe(Qe.domElement);
                    }
                    removeObject(Qe) {
                        this.scene.remove(Qe.threeElement), this.intersectionObserver.unobserve(Qe.domElement);
                    }
                }, yd = ((Qe)=>(Qe.image = "image", Qe.html = "html", Qe.element = "element", Qe.imageLayer = "imageLayer", Qe.videoLayer = "videoLayer", Qe.elementLayer = "elementLayer", Qe.polygon = "polygon", Qe.polygonPixels = "polygonPixels", Qe.polyline = "polyline", Qe.polylinePixels = "polylinePixels", Qe.square = "square", Qe.rect = "rect", Qe.circle = "circle", Qe.ellipse = "ellipse", Qe.path = "path", Qe))(yd || {});
                function getMarkerType(Qe, rt) {
                    void 0 === rt && (rt = !1);
                    const Wn = [];
                    if (Object.keys(yd).forEach((rt)=>{
                        Qe[rt] && Wn.push(rt);
                    }), 0 === Wn.length && !rt) throw new Co.e6(`missing marker content, either ${Object.keys(yd).join(", ")}`);
                    if (Wn.length > 1) throw new Co.e6(`multiple marker content, either ${Object.keys(yd).join(", ")}`);
                    return Wn[0];
                }
                var vd = class {
                    constructor(Qe, rt, Wn){
                        if (this.viewer = Qe, this.plugin = rt, this.state = {
                            anchor: null,
                            visible: !1,
                            staticTooltip: !1,
                            position: null,
                            position2D: null,
                            positions3D: null,
                            size: null
                        }, !Wn.id) throw new Co.e6("missing marker id");
                        this.type = getMarkerType(Wn), this.createElement(), this.update(Wn);
                    }
                    get id() {
                        return this.config.id;
                    }
                    get data() {
                        return this.config.data;
                    }
                    get domElement() {
                        return null;
                    }
                    get threeElement() {
                        return null;
                    }
                    get video() {
                        return null;
                    }
                    destroy() {
                        delete this.viewer, delete this.plugin, delete this.element, this.hideTooltip();
                    }
                    is3d() {
                        return !1;
                    }
                    isNormal() {
                        return !1;
                    }
                    isPoly() {
                        return !1;
                    }
                    isSvg() {
                        return !1;
                    }
                    isCss3d() {
                        return !1;
                    }
                    update(Qe) {
                        const rt = getMarkerType(Qe, !0);
                        if (void 0 !== rt && rt !== this.type) throw new Co.e6(`cannot change marker ${Qe.id} type`);
                        if (this.config = Co.Wp.deepmerge(this.config, Qe), "string" === typeof this.config.tooltip && (this.config.tooltip = {
                            content: this.config.tooltip
                        }), this.config.tooltip && !this.config.tooltip.trigger && (this.config.tooltip.trigger = "hover"), Co.Wp.isNil(this.config.visible) && (this.config.visible = !0), Co.Wp.isNil(this.config.zIndex) && (this.config.zIndex = 1), Co.Wp.isNil(this.config.opacity) && (this.config.opacity = 1), this.config.rotation) {
                            const Qe = this.config.rotation;
                            this.config.rotation = "object" === typeof Qe ? {
                                yaw: Qe.yaw ? Co.Wp.parseAngle(Qe.yaw, !0, !1) : 0,
                                pitch: Qe.pitch ? Co.Wp.parseAngle(Qe.pitch, !0, !1) : 0,
                                roll: Qe.roll ? Co.Wp.parseAngle(Qe.roll, !0, !1) : 0
                            } : {
                                yaw: 0,
                                pitch: 0,
                                roll: Co.Wp.parseAngle(Qe, !0, !1)
                            };
                        } else this.config.rotation = {
                            yaw: 0,
                            pitch: 0,
                            roll: 0
                        };
                        this.state.anchor = Co.Wp.parsePoint(this.config.anchor);
                    }
                    getListContent() {
                        return this.config.listContent ? this.config.listContent : this.config.tooltip?.content ? this.config.tooltip.content : this.config.html ? this.config.html : this.id;
                    }
                    showTooltip(Qe, rt, Wn) {
                        if (void 0 === Wn && (Wn = !1), this.state.visible && this.config.tooltip?.content && this.state.position2D) {
                            const Dl = {
                                ...this.config.tooltip,
                                style: {
                                    pointerEvents: this.state.staticTooltip ? "auto" : "none"
                                },
                                data: this,
                                top: 0,
                                left: 0
                            };
                            if (this.isPoly() || this.is3d() || this.isCss3d()) {
                                if (Qe || rt) {
                                    const Wn = Co.Wp.getPosition(this.viewer.container);
                                    Dl.top = rt - Wn.y + 10, Dl.left = Qe - Wn.x, Dl.box = {
                                        width: 20,
                                        height: 20
                                    };
                                } else Dl.top = this.state.position2D.y, Dl.left = this.state.position2D.x;
                            } else {
                                const Qe = this.viewer.dataHelper.vector3ToViewerCoords(this.state.positions3D[0]);
                                let rt = this.state.size.width, Wn = this.state.size.height;
                                this.config.hoverScale && !this.state.staticTooltip && (rt *= this.config.hoverScale.amount, Wn *= this.config.hoverScale.amount), Dl.top = Qe.y - Wn * this.state.anchor.y + Wn / 2, Dl.left = Qe.x - rt * this.state.anchor.x + rt / 2, Dl.box = {
                                    width: rt,
                                    height: Wn
                                };
                            }
                            this.tooltip ? Wn ? this.tooltip.update(this.config.tooltip.content, Dl) : this.tooltip.move(Dl) : this.tooltip = this.viewer.createTooltip(Dl);
                        }
                    }
                    hideTooltip() {
                        this.tooltip && (this.tooltip.hide(), this.tooltip = null);
                    }
                }, _d = class extends vd {
                    get domElement() {
                        return this.element;
                    }
                    constructor(Qe, rt, Wn){
                        super(Qe, rt, Wn);
                    }
                    afterCreateElement() {
                        this.element[rd] = this;
                    }
                    destroy() {
                        delete this.element[rd], super.destroy();
                    }
                    update(Qe) {
                        super.update(Qe);
                        const rt = this.domElement;
                        rt.id = `psv-marker-${this.config.id}`, rt.setAttribute("class", "psv-marker"), this.state.visible && rt.classList.add("psv-marker--visible"), this.config.tooltip && rt.classList.add("psv-marker--has-tooltip"), this.config.content && rt.classList.add("psv-marker--has-content"), this.config.className && Co.Wp.addClasses(rt, this.config.className), rt.style.opacity = `${this.config.opacity}`, rt.style.zIndex = `${30 + this.config.zIndex}`, this.config.style && Object.assign(rt.style, this.config.style);
                    }
                }, xd = class extends _d {
                    constructor(Qe, rt, Wn){
                        super(Qe, rt, Wn);
                    }
                    afterCreateElement() {
                        super.afterCreateElement(), this.domElement.addEventListener("transitionend", ()=>{
                            this.domElement.style.transition = "";
                        });
                    }
                    render(Qe) {
                        let { viewerPosition: rt, zoomLevel: Wn, hoveringMarker: Co } = Qe;
                        this.__updateSize();
                        const Dl = this.viewer.dataHelper.vector3ToViewerCoords(this.state.positions3D[0]);
                        Dl.x -= this.state.size.width * this.state.anchor.x, Dl.y -= this.state.size.height * this.state.anchor.y;
                        return this.state.positions3D[0].dot(this.viewer.state.direction) > 0 && Dl.x + this.state.size.width >= 0 && Dl.x - this.state.size.width <= this.viewer.state.size.width && Dl.y + this.state.size.height >= 0 && Dl.y - this.state.size.height <= this.viewer.state.size.height ? (this.domElement.style.translate = `${Dl.x}px ${Dl.y}px 0px`, this.applyScale({
                            zoomLevel: Wn,
                            viewerPosition: rt,
                            mouseover: this === Co
                        }), Dl) : null;
                    }
                    update(Qe) {
                        if (super.update(Qe), !Co.Wp.isExtendedPosition(this.config.position)) throw new Co.e6(`missing marker ${this.id} position`);
                        try {
                            this.state.position = this.viewer.dataHelper.cleanPosition(this.config.position);
                        } catch (Wn) {
                            throw new Co.e6(`invalid marker ${this.id} position`, Wn);
                        }
                        this.state.positions3D = [
                            this.viewer.dataHelper.sphericalCoordsToVector3(this.state.position)
                        ];
                        const rt = this.domElement;
                        rt.classList.add("psv-marker--normal"), this.config.scale && Array.isArray(this.config.scale) && (this.config.scale = {
                            zoom: this.config.scale
                        }), "boolean" === typeof this.config.hoverScale ? this.config.hoverScale = this.config.hoverScale ? this.plugin.config.defaultHoverScale || ld : null : "number" === typeof this.config.hoverScale ? this.config.hoverScale = {
                            amount: this.config.hoverScale
                        } : this.config.hoverScale || (this.config.hoverScale = this.plugin.config.defaultHoverScale), this.config.hoverScale && (this.config.hoverScale = {
                            ...this.plugin.config.defaultHoverScale,
                            ...this.config.hoverScale
                        }), rt.style.rotate = 0 !== this.config.rotation.roll ? Dl.cj9.radToDeg(this.config.rotation.roll) + "deg" : null, rt.style.transformOrigin = `${100 * this.state.anchor.x}% ${100 * this.state.anchor.y}%`;
                    }
                    __updateSize() {
                        if (!this.needsUpdateSize) return;
                        const Qe = this.domElement, rt = !this.state.visible || !this.state.size;
                        if (rt && Qe.classList.add("psv-marker--transparent"), this.isSvg()) {
                            const rt = Qe.firstElementChild.getBoundingClientRect();
                            this.state.size = {
                                width: rt.width,
                                height: rt.height
                            };
                        } else this.state.size = {
                            width: Qe.offsetWidth,
                            height: Qe.offsetHeight
                        };
                        rt && Qe.classList.remove("psv-marker--transparent"), this.isSvg() && (Qe.style.width = this.state.size.width + "px", Qe.style.height = this.state.size.height + "px"), "element" !== this.type && (this.needsUpdateSize = !1);
                    }
                    applyScale(Qe) {
                        let { zoomLevel: rt, viewerPosition: Wn, mouseover: Ll } = Qe;
                        null !== Ll && this.config.hoverScale && (this.domElement.style.transition = `scale ${this.config.hoverScale.duration}ms ${this.config.hoverScale.easing}`);
                        let Rl = 1;
                        if ("function" === typeof this.config.scale) Rl = this.config.scale(rt, Wn);
                        else if (this.config.scale) {
                            if (Array.isArray(this.config.scale.zoom)) {
                                const [Qe, Wn] = this.config.scale.zoom;
                                Rl *= Qe + (Wn - Qe) * Co.aH.EASINGS.inQuad(rt / 100);
                            }
                            if (Array.isArray(this.config.scale.yaw)) {
                                const [Qe, rt] = this.config.scale.yaw, Ll = Dl.cj9.degToRad(this.viewer.state.hFov) / 2, Ul = Math.abs(Co.Wp.getShortestArc(this.state.position.yaw, Wn.yaw));
                                Rl *= rt + (Qe - rt) * Co.aH.EASINGS.outQuad(Math.max(0, (Ll - Ul) / Ll));
                            }
                        }
                        Ll && this.config.hoverScale && (Rl *= this.config.hoverScale.amount), this.domElement.style.scale = `${Rl}`;
                    }
                }, bd = class extends Dl.BKk {
                    get map() {
                        return this.uniforms.map.value;
                    }
                    set map(Qe) {
                        this.uniforms.map.value = Qe;
                    }
                    set alpha(Qe) {
                        this.uniforms.alpha.value = Qe;
                    }
                    get offset() {
                        return this.uniforms.offset.value;
                    }
                    get repeat() {
                        return this.uniforms.repeat.value;
                    }
                    set chromaKey(Qe) {
                        this.uniforms.keying.value = !0 === Qe?.enabled, Qe?.enabled && ("object" === typeof Qe.color && "r" in Qe.color ? this.uniforms.color.value.set(Qe.color.r / 255, Qe.color.g / 255, Qe.color.b / 255) : this.uniforms.color.value.set(Qe.color ?? 65280), this.uniforms.similarity.value = Qe.similarity ?? .2, this.uniforms.smoothness.value = Qe.smoothness ?? .2);
                    }
                    constructor(Qe){
                        super({
                            transparent: !0,
                            depthTest: !1,
                            depthWrite: !1,
                            uniforms: {
                                map: {
                                    value: Qe?.map
                                },
                                repeat: {
                                    value: new Dl.I9Y(1, 1)
                                },
                                offset: {
                                    value: new Dl.I9Y(0, 0)
                                },
                                alpha: {
                                    value: Qe?.alpha ?? 1
                                },
                                keying: {
                                    value: !1
                                },
                                color: {
                                    value: new Dl.Q1f(65280)
                                },
                                similarity: {
                                    value: .2
                                },
                                smoothness: {
                                    value: .2
                                },
                                spill: {
                                    value: .1
                                }
                            },
                            vertexShader: "varying vec2 vUv;\nuniform vec2 repeat;\nuniform vec2 offset;\n\nvoid main() {\n    vUv = uv * repeat + offset;\n    gl_Position = projectionMatrix *  modelViewMatrix * vec4( position, 1.0 );\n}\n",
                            fragmentShader: "// https://www.8thwall.com/playground/chromakey-threejs\n\nuniform sampler2D map;\nuniform float alpha;\nuniform bool keying;\nuniform vec3 color;\nuniform float similarity;\nuniform float smoothness;\nuniform float spill;\n\nvarying vec2 vUv;\n\nvec2 RGBtoUV(vec3 rgb) {\n    return vec2(\n        rgb.r * -0.169 + rgb.g * -0.331 + rgb.b *  0.5    + 0.5,\n        rgb.r *  0.5   + rgb.g * -0.419 + rgb.b * -0.081  + 0.5\n    );\n}\n\nvoid main(void) {\n    gl_FragColor = texture2D(map, vUv);\n\n    if (keying) {\n        float chromaDist = distance(RGBtoUV(gl_FragColor.rgb), RGBtoUV(color));\n\n        float baseMask = chromaDist - similarity;\n        float fullMask = pow(clamp(baseMask / smoothness, 0., 1.), 1.5);\n        gl_FragColor.a *= fullMask * alpha;\n\n        float spillVal = pow(clamp(baseMask / spill, 0., 1.), 1.5);\n        float desat = clamp(gl_FragColor.r * 0.2126 + gl_FragColor.g * 0.7152 + gl_FragColor.b * 0.0722, 0., 1.);\n        gl_FragColor.rgb = mix(vec3(desat, desat, desat), gl_FragColor.rgb, spillVal);\n    } else {\n        gl_FragColor.a *= alpha;\n    }\n}\n"
                        }), this.chromaKey = Qe?.chromaKey;
                    }
                };
                function greatArcIntermediaryPoint(Qe, rt, Wn) {
                    const [Dl, Ll] = Qe, [Rl, Ul] = rt, Gl = Co.Wp.greatArcDistance(Qe, rt), Zl = Math.sin((1 - Wn) * Gl) / Math.sin(Gl), Hl = Math.sin(Wn * Gl) / Math.sin(Gl), ql = Zl * Math.cos(Ll) * Math.cos(Dl) + Hl * Math.cos(Ul) * Math.cos(Rl), Ql = Zl * Math.cos(Ll) * Math.sin(Dl) + Hl * Math.cos(Ul) * Math.sin(Rl), Kl = Zl * Math.sin(Ll) + Hl * Math.sin(Ul);
                    return [
                        Math.atan2(Ql, ql),
                        Math.atan2(Kl, Math.sqrt(ql * ql + Ql * Ql))
                    ];
                }
                function getPolygonCoherentPoints(Qe) {
                    const rt = [
                        Qe[0]
                    ];
                    let Wn = 0;
                    for(let Co = 1; Co < Qe.length; Co++){
                        const Dl = Qe[Co - 1][0] - Qe[Co][0];
                        Dl > Math.PI ? Wn += 1 : Dl < -Math.PI && (Wn -= 1), rt.push([
                            Qe[Co][0] + 2 * Wn * Math.PI,
                            Qe[Co][1]
                        ]);
                    }
                    return rt;
                }
                function getPolygonCenter(Qe) {
                    const rt = getPolygonCoherentPoints(Qe).reduce((Qe, rt)=>[
                            Qe[0] + rt[0],
                            Qe[1] + rt[1]
                        ]);
                    return [
                        Co.Wp.parseAngle(rt[0] / Qe.length),
                        rt[1] / Qe.length
                    ];
                }
                var wd = new Dl.Pq0, Ed = new Dl.Pq0, Md = new Dl.Pq0, Sd = new Dl.Pq0, Td = new Dl.Pq0, Cd = new Dl.Pq0;
                function getGreatCircleIntersection(Qe, rt, Wn) {
                    wd.copy(Wn).normalize(), Ed.crossVectors(Qe, rt).normalize(), Md.crossVectors(Ed, Qe).normalize(), Sd.copy(Qe).multiplyScalar(-wd.dot(Md)), Td.copy(Md).multiplyScalar(wd.dot(Qe));
                    const Ll = (new Dl.Pq0).addVectors(Sd, Td).normalize();
                    return Cd.crossVectors(Ll, wd), Ll.applyAxisAngle(Cd, .01).multiplyScalar(Co.aH.SPHERE_RADIUS);
                }
                var kd = class extends vd {
                    get threeElement() {
                        return this.element;
                    }
                    get threeMesh() {
                        return this.threeElement.children[0];
                    }
                    get video() {
                        return "videoLayer" === this.type ? this.threeMesh.material.map.image : null;
                    }
                    constructor(Qe, rt, Wn){
                        super(Qe, rt, Wn);
                    }
                    is3d() {
                        return !0;
                    }
                    createElement() {
                        const Qe = new bd({
                            alpha: 0
                        }), rt = new Dl.bdM(1, 1), Wn = new Dl.eaF(rt, Qe);
                        Wn.userData = {
                            [rd]: this
                        }, Object.defineProperty(Wn, "visible", {
                            enumerable: !0,
                            get: function() {
                                return this.userData[rd].config.visible;
                            },
                            set: function(Qe) {
                                this.userData[rd].config.visible = Qe;
                            }
                        }), this.element = (new Dl.YJl).add(Wn), "videoLayer" === this.type && this.viewer.needsContinuousUpdate(!0);
                    }
                    destroy() {
                        delete this.threeMesh.userData[rd], "videoLayer" === this.type && (this.video.pause(), this.viewer.needsContinuousUpdate(!1)), super.destroy();
                    }
                    render() {
                        return this.viewer.renderer.isObjectVisible(this.threeMesh) ? this.viewer.dataHelper.sphericalCoordsToViewerCoords(this.state.position) : null;
                    }
                    update(Qe) {
                        super.update(Qe);
                        const rt = this.threeMesh, Wn = rt.parent, Ll = rt.material;
                        if (Co.Wp.isExtendedPosition(this.config.position)) {
                            try {
                                this.state.position = this.viewer.dataHelper.cleanPosition(this.config.position);
                            } catch (Rl) {
                                throw new Co.e6(`invalid marker ${this.id} position`, Rl);
                            }
                            if (!this.config.size) throw new Co.e6(`missing marker ${this.id} size`);
                            this.state.size = this.config.size, rt.scale.set(this.config.size.width / 100, this.config.size.height / 100, 1), rt.position.set(rt.scale.x * (.5 - this.state.anchor.x), rt.scale.y * (this.state.anchor.y - .5), 0), rt.rotation.set(0, 0, 0), this.viewer.dataHelper.sphericalCoordsToVector3(this.state.position, Wn.position), Wn.lookAt(0, Wn.position.y, 0), rt.rotateY(-this.config.rotation.yaw), rt.rotateX(-this.config.rotation.pitch), rt.rotateZ(-this.config.rotation.roll);
                            const Qe = rt.geometry.getAttribute("position");
                            this.state.positions3D = [
                                0,
                                1,
                                3,
                                2
                            ].map((Wn)=>{
                                const Co = new Dl.Pq0;
                                return Co.fromBufferAttribute(Qe, Wn), rt.localToWorld(Co);
                            });
                        } else {
                            if (4 !== this.config.position?.length) throw new Co.e6(`missing marker ${this.id} position`);
                            let Qe;
                            try {
                                Qe = this.config.position.map((Qe)=>this.viewer.dataHelper.cleanPosition(Qe));
                            } catch (Rl) {
                                throw new Co.e6(`invalid marker ${this.id} position`, Rl);
                            }
                            const Wn = Qe.map((Qe)=>this.viewer.dataHelper.sphericalCoordsToVector3(Qe)), Dl = getPolygonCenter(Qe.map((Qe)=>{
                                let { yaw: rt, pitch: Wn } = Qe;
                                return [
                                    rt,
                                    Wn
                                ];
                            }));
                            this.state.position = {
                                yaw: Dl[0],
                                pitch: Dl[1]
                            }, this.state.positions3D = Wn;
                            const Ul = rt.geometry.getAttribute("position");
                            [
                                Wn[0],
                                Wn[1],
                                Wn[3],
                                Wn[2]
                            ].forEach((Qe, rt)=>{
                                Ul.setX(rt, Qe.x), Ul.setY(rt, Qe.y), Ul.setZ(rt, Qe.z);
                            }), Ul.needsUpdate = !0, this.__setTextureWrap(Ll);
                        }
                        switch(this.type){
                            case "videoLayer":
                                if (this.definition !== this.config.videoLayer) {
                                    Ll.map?.dispose();
                                    const Qe = function(Qe) {
                                        let { src: rt, withCredentials: Wn, muted: Co, autoplay: Dl } = Qe;
                                        const Ll = document.createElement("video");
                                        return Ll.crossOrigin = Wn ? "use-credentials" : "anonymous", Ll.loop = !0, Ll.playsInline = !0, Ll.autoplay = Dl, Ll.muted = Co, Ll.preload = "metadata", rt instanceof MediaStream ? Ll.srcObject = rt : Ll.src = rt, Ll;
                                    }({
                                        src: this.config.videoLayer,
                                        withCredentials: this.viewer.config.withCredentials,
                                        muted: !0,
                                        autoplay: this.config.autoplay ?? !0
                                    }), Wn = new Dl.Nv2(Qe);
                                    Ll.map = Wn, Ll.alpha = 0, Qe.addEventListener("loadedmetadata", ()=>{
                                        this.viewer && (Ll.alpha = this.config.opacity, Co.Wp.isExtendedPosition(this.config.position) || (rt.material.userData[rd] = {
                                            width: Qe.videoWidth,
                                            height: Qe.videoHeight
                                        }, this.__setTextureWrap(Ll)));
                                    }, {
                                        once: !0
                                    }), Qe.autoplay && Qe.play(), this.definition = this.config.videoLayer;
                                } else Ll.alpha = this.config.opacity;
                                break;
                            case "imageLayer":
                                if (this.definition !== this.config.imageLayer) {
                                    Ll.map?.dispose();
                                    const Qe = new Dl.gPd;
                                    Ll.map = Qe, Ll.alpha = 0, this.viewer.textureLoader.loadImage(this.config.imageLayer).then((Wn)=>{
                                        this.viewer && (Co.Wp.isExtendedPosition(this.config.position) || (rt.material.userData[rd] = {
                                            width: Wn.width,
                                            height: Wn.height
                                        }, this.__setTextureWrap(Ll)), Qe.image = Wn, Qe.anisotropy = 4, Qe.needsUpdate = !0, Ll.alpha = this.config.opacity, this.viewer.needsUpdate());
                                    }), this.definition = this.config.imageLayer;
                                } else Ll.alpha = this.config.opacity;
                        }
                        Ll.chromaKey = this.config.chromaKey, rt.renderOrder = 1e3 + this.config.zIndex, rt.geometry.boundingBox = null;
                    }
                    __setTextureWrap(Qe) {
                        const rt = Qe.userData[rd];
                        if (!rt || !rt.height || !rt.width) return Qe.repeat.set(1, 1), void Qe.offset.set(0, 0);
                        const Wn = this.config.position.map((Qe)=>this.viewer.dataHelper.cleanPosition(Qe)), Dl = (Co.Wp.greatArcDistance([
                            Wn[0].yaw,
                            Wn[0].pitch
                        ], [
                            Wn[1].yaw,
                            Wn[1].pitch
                        ]) + Co.Wp.greatArcDistance([
                            Wn[3].yaw,
                            Wn[3].pitch
                        ], [
                            Wn[2].yaw,
                            Wn[2].pitch
                        ])) / (Co.Wp.greatArcDistance([
                            Wn[1].yaw,
                            Wn[1].pitch
                        ], [
                            Wn[2].yaw,
                            Wn[2].pitch
                        ]) + Co.Wp.greatArcDistance([
                            Wn[0].yaw,
                            Wn[0].pitch
                        ], [
                            Wn[3].yaw,
                            Wn[3].pitch
                        ])), Ll = rt.width / rt.height;
                        let Rl = 0, Ul = 0;
                        Dl < Ll ? Rl = Ll - Dl : Ul = 1 / Ll - 1 / Dl, Qe.repeat.set(1 - Rl, 1 - Ul), Qe.offset.set(Rl / 2, Ul / 2);
                    }
                }, Id = class extends _d {
                    constructor(Qe, rt, Wn){
                        super(Qe, rt, Wn), this.viewportIntersection = !1;
                    }
                    get threeElement() {
                        return this.object;
                    }
                    isCss3d() {
                        return !0;
                    }
                    createElement() {
                        this.element = document.createElement("div"), this.object = new pd(this.element), this.object.userData = {
                            [rd]: this
                        }, Object.defineProperty(this.object, "visible", {
                            enumerable: !0,
                            get: function() {
                                return this.userData[rd].config.visible;
                            },
                            set: function(Qe) {
                                this.userData[rd].config.visible = Qe;
                            }
                        }), this.afterCreateElement();
                    }
                    destroy() {
                        delete this.object.userData[rd], delete this.object, super.destroy();
                    }
                    render(Qe) {
                        let { viewerPosition: rt, zoomLevel: Wn } = Qe;
                        const Co = this.domElement;
                        this.state.size = {
                            width: Co.offsetWidth,
                            height: Co.offsetHeight
                        };
                        if (this.state.positions3D[0].dot(this.viewer.state.direction) > 0 && this.viewportIntersection) {
                            const Qe = this.viewer.dataHelper.sphericalCoordsToViewerCoords(this.state.position);
                            return this.config.elementLayer.updateMarker?.({
                                marker: this,
                                position: Qe,
                                viewerPosition: rt,
                                zoomLevel: Wn,
                                viewerSize: this.viewer.state.size
                            }), Qe;
                        }
                        return null;
                    }
                    update(Qe) {
                        if (super.update(Qe), !Co.Wp.isExtendedPosition(this.config.position)) throw new Co.e6(`missing marker ${this.id} position`);
                        try {
                            this.state.position = this.viewer.dataHelper.cleanPosition(this.config.position);
                        } catch (Dl) {
                            throw new Co.e6(`invalid marker ${this.id} position`, Dl);
                        }
                        this.state.positions3D = [
                            this.viewer.dataHelper.sphericalCoordsToVector3(this.state.position)
                        ];
                        const rt = this.threeElement, Wn = this.domElement;
                        Wn.classList.add("psv-marker--css3d"), Wn.childNodes.forEach((Qe)=>Qe.remove()), Wn.appendChild(this.config.elementLayer), this.config.elementLayer.style.display = "block", rt.position.copy(this.state.positions3D[0]).multiplyScalar(100), rt.lookAt(0, 100 * this.state.positions3D[0].y, 0), rt.rotateY(-this.config.rotation.yaw), rt.rotateX(-this.config.rotation.pitch), rt.rotateZ(-this.config.rotation.roll);
                    }
                }, Dd = class extends xd {
                    constructor(Qe, rt, Wn){
                        super(Qe, rt, Wn);
                    }
                    isNormal() {
                        return !0;
                    }
                    createElement() {
                        this.element = document.createElement("div"), this.afterCreateElement();
                    }
                    render(Qe) {
                        const rt = super.render(Qe);
                        return rt && "element" === this.type && this.config.element.updateMarker?.({
                            marker: this,
                            position: rt,
                            viewerPosition: Qe.viewerPosition,
                            zoomLevel: Qe.zoomLevel,
                            viewerSize: this.viewer.state.size
                        }), rt;
                    }
                    update(Qe) {
                        super.update(Qe);
                        const rt = this.domElement;
                        if (this.config.image && !this.config.size) throw new Co.e6(`missing marker ${this.id} size`);
                        switch(this.config.size ? (this.needsUpdateSize = !1, this.state.size = this.config.size, rt.style.width = this.config.size.width + "px", rt.style.height = this.config.size.height + "px") : this.needsUpdateSize = !0, this.type){
                            case "image":
                                this.definition = this.config.image, rt.style.backgroundImage = `url("${this.config.image}")`;
                                break;
                            case "html":
                                this.definition = this.config.html, rt.innerHTML = this.config.html;
                                break;
                            case "element":
                                this.definition !== this.config.element && (this.definition = this.config.element, rt.childNodes.forEach((Qe)=>Qe.remove()), rt.appendChild(this.config.element), this.config.element.style.display = "block");
                        }
                    }
                }, Ld = class extends _d {
                    constructor(Qe, rt, Wn){
                        super(Qe, rt, Wn);
                    }
                    createElement() {
                        this.element = document.createElementNS(nd, "path"), this.element[rd] = this;
                    }
                    isPoly() {
                        return !0;
                    }
                    get isPixels() {
                        return "polygonPixels" === this.type || "polylinePixels" === this.type;
                    }
                    get isPolygon() {
                        return "polygon" === this.type || "polygonPixels" === this.type;
                    }
                    get isPolyline() {
                        return "polyline" === this.type || "polylinePixels" === this.type;
                    }
                    get coords() {
                        return this.definition;
                    }
                    render() {
                        const Qe = this.__getAllPolyPositions();
                        if (Qe[0].length > (this.isPolygon ? 2 : 1)) {
                            const rt = this.viewer.dataHelper.sphericalCoordsToViewerCoords(this.state.position), Wn = Qe.filter((Qe)=>Qe.length > 0).map((Qe)=>{
                                let Wn = "M";
                                return Wn += Qe.map((Qe)=>`${Qe.x - rt.x},${Qe.y - rt.y}`).join("L"), this.isPolygon && (Wn += "Z"), Wn;
                            }).join(" ");
                            return this.domElement.setAttributeNS(null, "d", Wn), this.domElement.setAttributeNS(null, "transform", `translate(${rt.x} ${rt.y})`), rt;
                        }
                        return null;
                    }
                    update(Qe) {
                        super.update(Qe);
                        const rt = this.domElement;
                        rt.classList.add("psv-marker--poly"), this.config.svgStyle ? (Object.entries(this.config.svgStyle).forEach((Qe)=>{
                            let [Wn, Dl] = Qe;
                            rt.setAttributeNS(null, Co.Wp.dasherize(Wn), Dl);
                        }), this.isPolyline && !this.config.svgStyle.fill && rt.setAttributeNS(null, "fill", "none")) : this.isPolygon ? rt.setAttributeNS(null, "fill", "rgba(0,0,0,0.5)") : this.isPolyline && (rt.setAttributeNS(null, "fill", "none"), rt.setAttributeNS(null, "stroke", "rgb(0,0,0)"));
                        try {
                            let Qe = this.config[this.type];
                            if (!Array.isArray(Qe[0]) && "object" !== typeof Qe[0]) for(let rt = 0; rt < Qe.length; rt++)Qe.splice(rt, 2, [
                                Qe[rt],
                                Qe[rt + 1]
                            ]);
                            if (Array.isArray(Qe[0][0]) || "object" === typeof Qe[0][0] || (Qe = [
                                Qe
                            ]), this.isPolyline && Qe.length > 1) throw new Co.e6("polylines cannot have holes");
                            this.isPixels ? this.definition = Qe.map((Qe)=>Qe.map((Qe)=>{
                                    let rt;
                                    return rt = Co.Wp.isExtendedPosition(Qe) ? this.viewer.dataHelper.cleanPosition(Qe) : this.viewer.dataHelper.textureCoordsToSphericalCoords({
                                        textureX: Qe[0],
                                        textureY: Qe[1]
                                    }), [
                                        rt.yaw,
                                        rt.pitch
                                    ];
                                })) : this.definition = Qe.map((Qe)=>Qe.map((Qe)=>{
                                    let rt;
                                    return rt = Co.Wp.isExtendedPosition(Qe) ? this.viewer.dataHelper.cleanPosition(Qe) : this.viewer.dataHelper.cleanPosition({
                                        yaw: Qe[0],
                                        pitch: Qe[1]
                                    }), [
                                        rt.yaw,
                                        rt.pitch
                                    ];
                                }));
                        } catch (Dl) {
                            throw new Co.e6(`invalid marker ${this.id} position`, Dl);
                        }
                        const Wn = this.isPolygon ? getPolygonCenter(this.coords[0]) : function(Qe) {
                            const rt = getPolygonCoherentPoints(Qe);
                            let Wn = 0;
                            const Dl = [];
                            for(let Rl = 0; Rl < rt.length - 1; Rl++){
                                const Qe = Co.Wp.greatArcDistance(rt[Rl], rt[Rl + 1]) * Co.aH.SPHERE_RADIUS;
                                Dl.push(Qe), Wn += Qe;
                            }
                            let Ll = 0;
                            for(let Co = 0; Co < rt.length - 1; Co++){
                                if (Ll + Dl[Co] > Wn / 2) {
                                    const Qe = (Wn / 2 - Ll) / Dl[Co];
                                    return greatArcIntermediaryPoint(rt[Co], rt[Co + 1], Qe);
                                }
                                Ll += Dl[Co];
                            }
                            return rt[Math.round(rt.length / 2)];
                        }(this.coords[0]);
                        this.state.position = {
                            yaw: Wn[0],
                            pitch: Wn[1]
                        }, this.positions3D = this.coords.map((Qe)=>Qe.map((Qe)=>this.viewer.dataHelper.sphericalCoordsToVector3({
                                    yaw: Qe[0],
                                    pitch: Qe[1]
                                }))), this.state.positions3D = this.positions3D[0];
                    }
                    __getAllPolyPositions() {
                        return this.positions3D.map((Qe)=>this.__getPolyPositions(Qe));
                    }
                    __getPolyPositions(Qe) {
                        const rt = Qe.length, Wn = Qe.map((Qe)=>({
                                vector: Qe,
                                visible: Qe.dot(this.viewer.state.direction) > 0
                            })), Co = [];
                        return Wn.forEach((Qe, Dl)=>{
                            if (!Qe.visible) [
                                0 === Dl ? Wn[rt - 1] : Wn[Dl - 1],
                                Dl === rt - 1 ? Wn[0] : Wn[Dl + 1]
                            ].forEach((rt)=>{
                                rt.visible && Co.push({
                                    visible: rt.vector,
                                    invisible: Qe.vector,
                                    index: Dl
                                });
                            });
                        }), Co.reverse().forEach((Qe)=>{
                            Wn.splice(Qe.index, 0, {
                                vector: getGreatCircleIntersection(Qe.visible, Qe.invisible, this.viewer.state.direction),
                                visible: !0
                            });
                        }), Wn.filter((Qe)=>Qe.visible).map((Qe)=>this.viewer.dataHelper.vector3ToViewerCoords(Qe.vector));
                    }
                }, Pd = class extends xd {
                    get svgElement() {
                        return this.domElement.firstElementChild;
                    }
                    constructor(Qe, rt, Wn){
                        super(Qe, rt, Wn);
                    }
                    isSvg() {
                        return !0;
                    }
                    createElement() {
                        const Qe = "square" === this.type ? "rect" : this.type, rt = document.createElementNS(nd, Qe);
                        this.element = document.createElementNS(nd, "svg"), this.element.appendChild(rt), this.afterCreateElement();
                    }
                    update(Qe) {
                        super.update(Qe);
                        const rt = this.svgElement;
                        switch(this.needsUpdateSize = !0, this.type){
                            case "square":
                                this.definition = {
                                    x: 0,
                                    y: 0,
                                    width: this.config.square,
                                    height: this.config.square
                                };
                                break;
                            case "rect":
                                Array.isArray(this.config.rect) ? this.definition = {
                                    x: 0,
                                    y: 0,
                                    width: this.config.rect[0],
                                    height: this.config.rect[1]
                                } : this.definition = {
                                    x: 0,
                                    y: 0,
                                    width: this.config.rect.width,
                                    height: this.config.rect.height
                                };
                                break;
                            case "circle":
                                this.definition = {
                                    cx: this.config.circle,
                                    cy: this.config.circle,
                                    r: this.config.circle
                                };
                                break;
                            case "ellipse":
                                Array.isArray(this.config.ellipse) ? this.definition = {
                                    cx: this.config.ellipse[0],
                                    cy: this.config.ellipse[1],
                                    rx: this.config.ellipse[0],
                                    ry: this.config.ellipse[1]
                                } : this.definition = {
                                    cx: this.config.ellipse.rx,
                                    cy: this.config.ellipse.ry,
                                    rx: this.config.ellipse.rx,
                                    ry: this.config.ellipse.ry
                                };
                                break;
                            case "path":
                                this.definition = {
                                    d: this.config.path
                                };
                        }
                        Object.entries(this.definition).forEach((Qe)=>{
                            let [Wn, Co] = Qe;
                            rt.setAttributeNS(null, Wn, Co);
                        }), this.config.svgStyle ? Object.entries(this.config.svgStyle).forEach((Qe)=>{
                            let [Wn, Dl] = Qe;
                            rt.setAttributeNS(null, Co.Wp.dasherize(Wn), Dl);
                        }) : rt.setAttributeNS(null, "fill", "rgba(0,0,0,0.5)");
                    }
                }, zd = Co.Wp.getConfigParser({
                    clickEventOnMarker: !1,
                    gotoMarkerSpeed: "8rpm",
                    markers: null,
                    defaultHoverScale: null
                }, {
                    defaultHoverScale: (Qe)=>Qe ? (!0 === Qe && (Qe = ld), "number" === typeof Qe && (Qe = {
                            amount: Qe
                        }), {
                            ...ld,
                            ...Qe
                        }) : null
                });
                var Nd = class extends Co.TL {
                    constructor(Qe, rt){
                        super(Qe, rt), this.markers = {}, this.state = {
                            allVisible: !0,
                            showAllTooltips: !1,
                            currentMarker: null,
                            hoveringMarker: null,
                            needsReRender: !1,
                            lastClientX: null,
                            lastClientY: null
                        }, this.container = document.createElement("div"), this.container.className = "psv-markers", this.viewer.container.appendChild(this.container), this.container.addEventListener("contextmenu", (Qe)=>Qe.preventDefault()), this.svgContainer = document.createElementNS(nd, "svg"), this.svgContainer.setAttribute("class", "psv-markers-svg-container"), this.container.appendChild(this.svgContainer), this.css3DContainer = new Ad(Qe), this.container.appendChild(this.css3DContainer.element), this.container.addEventListener("mouseenter", this, !0), this.container.addEventListener("mouseleave", this, !0), this.container.addEventListener("mousemove", this, !0);
                    }
                    init() {
                        super.init(), Co.Wp.checkStylesheet(this.viewer.container, "markers-plugin"), this.viewer.addEventListener(Co.AZ.ClickEvent.type, this), this.viewer.addEventListener(Co.AZ.DoubleClickEvent.type, this), this.viewer.addEventListener(Co.AZ.RenderEvent.type, this), this.viewer.addEventListener(Co.AZ.ConfigChangedEvent.type, this), this.viewer.addEventListener(Co.AZ.ObjectEnterEvent.type, this), this.viewer.addEventListener(Co.AZ.ObjectHoverEvent.type, this), this.viewer.addEventListener(Co.AZ.ObjectLeaveEvent.type, this), this.viewer.addEventListener(Co.AZ.ReadyEvent.type, this, {
                            once: !0
                        });
                    }
                    destroy() {
                        this.clearMarkers(!1), this.viewer.unobserveObjects(rd), this.viewer.removeEventListener(Co.AZ.ClickEvent.type, this), this.viewer.removeEventListener(Co.AZ.DoubleClickEvent.type, this), this.viewer.removeEventListener(Co.AZ.RenderEvent.type, this), this.viewer.removeEventListener(Co.AZ.ObjectEnterEvent.type, this), this.viewer.removeEventListener(Co.AZ.ObjectHoverEvent.type, this), this.viewer.removeEventListener(Co.AZ.ObjectLeaveEvent.type, this), this.viewer.removeEventListener(Co.AZ.ReadyEvent.type, this), this.css3DContainer.destroy(), this.viewer.container.removeChild(this.container), super.destroy();
                    }
                    handleEvent(Qe) {
                        switch(Qe.type){
                            case Co.AZ.ReadyEvent.type:
                                this.config.markers && (this.setMarkers(this.config.markers), delete this.config.markers);
                                break;
                            case Co.AZ.RenderEvent.type:
                                this.renderMarkers();
                                break;
                            case Co.AZ.ClickEvent.type:
                                this.__onClick(Qe, !1);
                                break;
                            case Co.AZ.DoubleClickEvent.type:
                                this.__onClick(Qe, !0);
                                break;
                            case Co.AZ.ObjectEnterEvent.type:
                            case Co.AZ.ObjectLeaveEvent.type:
                            case Co.AZ.ObjectHoverEvent.type:
                                if (Qe.userDataKey === rd) {
                                    const rt = Qe.originalEvent, Wn = Qe.object.userData[rd];
                                    switch(Qe.type){
                                        case Co.AZ.ObjectEnterEvent.type:
                                            Wn.config.style?.cursor ? this.viewer.setCursor(Wn.config.style.cursor) : (Wn.config.tooltip || Wn.config.content) && this.viewer.setCursor("pointer"), this.__onEnterMarker(rt, Wn);
                                            break;
                                        case Co.AZ.ObjectLeaveEvent.type:
                                            this.viewer.setCursor(null), this.__onLeaveMarker(Wn);
                                            break;
                                        case Co.AZ.ObjectHoverEvent.type:
                                            this.__onHoverMarker(rt, Wn);
                                    }
                                }
                                break;
                            case "mouseenter":
                                {
                                    const rt = this.__getTargetMarker(Co.Wp.getEventTarget(Qe));
                                    this.__onEnterMarker(Qe, rt);
                                    break;
                                }
                            case "mouseleave":
                                {
                                    const rt = this.__getTargetMarker(Co.Wp.getEventTarget(Qe));
                                    this.__onLeaveMarker(rt);
                                    break;
                                }
                            case "mousemove":
                                {
                                    const rt = this.__getTargetMarker(Co.Wp.getEventTarget(Qe), !0);
                                    this.__onHoverMarker(Qe, rt);
                                    break;
                                }
                        }
                    }
                    toggleAllMarkers() {
                        this.state.allVisible ? this.hideAllMarkers() : this.showAllMarkers();
                    }
                    showAllMarkers() {
                        this.state.allVisible = !0, Object.values(this.markers).forEach((Qe)=>{
                            Qe.config.visible = !0;
                        }), this.renderMarkers(), this.dispatchEvent(new Ju);
                    }
                    hideAllMarkers() {
                        this.state.allVisible = !1, Object.values(this.markers).forEach((Qe)=>{
                            Qe.config.visible = !1;
                        }), this.renderMarkers(), this.dispatchEvent(new Tu);
                    }
                    toggleAllTooltips() {
                        this.state.showAllTooltips ? this.hideAllTooltips() : this.showAllTooltips();
                    }
                    showAllTooltips() {
                        this.state.showAllTooltips = !0, Object.values(this.markers).forEach((Qe)=>{
                            Qe.state.staticTooltip = !0, Qe.showTooltip();
                        });
                    }
                    hideAllTooltips() {
                        this.state.showAllTooltips = !1, Object.values(this.markers).forEach((Qe)=>{
                            Qe.state.staticTooltip = !1, Qe.hideTooltip();
                        });
                    }
                    getNbMarkers() {
                        return Object.keys(this.markers).length;
                    }
                    getMarkers() {
                        return Object.values(this.markers);
                    }
                    addMarker(Qe, rt) {
                        if (void 0 === rt && (rt = !0), this.markers[Qe.id]) throw new Co.e6(`marker "${Qe.id}" already exists`);
                        const Wn = new (function(Qe) {
                            switch(getMarkerType(Qe, !1)){
                                case "image":
                                case "html":
                                case "element":
                                    return Dd;
                                case "imageLayer":
                                case "videoLayer":
                                    return kd;
                                case "elementLayer":
                                    return Id;
                                case "polygon":
                                case "polyline":
                                case "polygonPixels":
                                case "polylinePixels":
                                    return Ld;
                                case "square":
                                case "rect":
                                case "circle":
                                case "ellipse":
                                case "path":
                                    return Pd;
                                default:
                                    throw new Co.e6("invalid marker type");
                            }
                        }(Qe))(this.viewer, this, Qe);
                        Wn.isPoly() ? this.svgContainer.appendChild(Wn.domElement) : Wn.isCss3d() ? this.css3DContainer.addObject(Wn) : Wn.is3d() ? this.viewer.renderer.addObject(Wn.threeElement) : this.container.appendChild(Wn.domElement), this.markers[Wn.id] = Wn, this.state.showAllTooltips && (Wn.state.staticTooltip = !0), rt && this.__afterChangeMarkers();
                    }
                    getMarker(Qe) {
                        const rt = "object" === typeof Qe ? Qe.id : Qe;
                        if (!this.markers[rt]) throw new Co.e6(`cannot find marker "${rt}"`);
                        return this.markers[rt];
                    }
                    getCurrentMarker() {
                        return this.state.currentMarker;
                    }
                    updateMarker(Qe, rt) {
                        void 0 === rt && (rt = !0);
                        const Wn = this.getMarker(Qe.id);
                        Wn.update(Qe), rt && (this.__afterChangeMarkers(), (Wn === this.state.hoveringMarker && "hover" === Wn.config.tooltip?.trigger || Wn.state.staticTooltip) && Wn.showTooltip(this.state.lastClientX, this.state.lastClientY, !0));
                    }
                    removeMarker(Qe, rt) {
                        void 0 === rt && (rt = !0);
                        const Wn = this.getMarker(Qe);
                        Wn.isPoly() ? this.svgContainer.removeChild(Wn.domElement) : Wn.isCss3d() ? this.css3DContainer.removeObject(Wn) : Wn.is3d() ? this.viewer.renderer.removeObject(Wn.threeElement) : this.container.removeChild(Wn.domElement), this.state.hoveringMarker === Wn && (this.state.hoveringMarker = null), this.state.currentMarker === Wn && (this.state.currentMarker = null), Wn.destroy(), delete this.markers[Wn.id], rt && this.__afterChangeMarkers();
                    }
                    removeMarkers(Qe, rt) {
                        void 0 === rt && (rt = !0), Qe.forEach((Qe)=>this.removeMarker(Qe, !1)), rt && this.__afterChangeMarkers();
                    }
                    setMarkers(Qe, rt) {
                        void 0 === rt && (rt = !0), this.clearMarkers(!1), Qe?.forEach((Qe)=>{
                            this.addMarker(Qe, !1);
                        }), rt && this.__afterChangeMarkers();
                    }
                    clearMarkers(Qe) {
                        void 0 === Qe && (Qe = !0), Object.keys(this.markers).forEach((Qe)=>{
                            this.removeMarker(Qe, !1);
                        }), Qe && this.__afterChangeMarkers();
                    }
                    gotoMarker(Qe, rt) {
                        void 0 === rt && (rt = this.config.gotoMarkerSpeed);
                        const Wn = this.getMarker(Qe);
                        return rt ? this.viewer.animate({
                            ...Wn.state.position,
                            zoom: Wn.config.zoomLvl,
                            speed: rt
                        }).then(()=>{
                            this.dispatchEvent(new Hl(Wn));
                        }) : (this.viewer.rotate(Wn.state.position), Co.Wp.isNil(Wn.config.zoomLvl) || this.viewer.zoom(Wn.config.zoomLvl), this.dispatchEvent(new Hl(Wn)), Promise.resolve());
                    }
                    hideMarker(Qe) {
                        this.toggleMarker(Qe, !1);
                    }
                    showMarker(Qe) {
                        this.toggleMarker(Qe, !0);
                    }
                    showMarkerTooltip(Qe) {
                        const rt = this.getMarker(Qe);
                        rt.state.staticTooltip = !0, rt.showTooltip();
                    }
                    hideMarkerTooltip(Qe) {
                        const rt = this.getMarker(Qe);
                        rt.state.staticTooltip = !1, rt.hideTooltip();
                    }
                    toggleMarker(Qe, rt) {
                        const Wn = this.getMarker(Qe);
                        Wn.config.visible = Co.Wp.isNil(rt) ? !Wn.config.visible : rt, this.renderMarkers();
                    }
                    showMarkerPanel(Qe) {
                        const rt = this.getMarker(Qe);
                        rt.config.content ? this.viewer.panel.show({
                            id: ad,
                            content: rt.config.content
                        }) : this.hideMarkerPanel();
                    }
                    hideMarkerPanel() {
                        this.viewer.panel.hide(ad);
                    }
                    toggleMarkersList() {
                        this.viewer.panel.isVisible(od) ? this.hideMarkersList() : this.showMarkersList();
                    }
                    showMarkersList() {
                        let Qe = [];
                        Object.values(this.markers).forEach((rt)=>{
                            rt.config.visible && !rt.config.hideList && Qe.push(rt);
                        });
                        const rt = new ed(Qe);
                        this.dispatchEvent(rt), Qe = rt.markers, this.viewer.panel.show({
                            id: od,
                            content: MARKERS_LIST_TEMPLATE(Qe, this.viewer.config.lang[td.id]),
                            noMargin: !0,
                            clickHandler: (Qe)=>{
                                const rt = Co.Wp.getClosest(Qe, ".psv-panel-menu-item"), Wn = rt ? rt.dataset[rd] : void 0;
                                if (Wn) {
                                    const Qe = this.getMarker(Wn);
                                    this.dispatchEvent(new du(Qe)), this.gotoMarker(Qe.id), this.hideMarkersList();
                                }
                            }
                        });
                    }
                    hideMarkersList() {
                        this.viewer.panel.hide(od);
                    }
                    renderMarkers() {
                        if (this.state.needsReRender) return void (this.state.needsReRender = !1);
                        const Qe = this.viewer.getZoomLevel(), rt = this.viewer.getPosition(), Wn = this.state.hoveringMarker;
                        Object.values(this.markers).forEach((Dl)=>{
                            let Ll = Dl.config.visible, Rl = !1, Ul = null;
                            Ll && (Ul = Dl.render({
                                viewerPosition: rt,
                                zoomLevel: Qe,
                                hoveringMarker: Wn
                            }), Ll = !!Ul), Rl = Dl.state.visible !== Ll, Dl.state.visible = Ll, Dl.state.position2D = Ul, Dl.domElement && Co.Wp.toggleClass(Dl.domElement, "psv-marker--visible", Ll), Ll ? Dl.state.staticTooltip ? Dl.showTooltip() : Dl !== this.state.hoveringMarker && Dl.hideTooltip() : Dl.hideTooltip(), Rl && (this.dispatchEvent(new Gl(Dl, Ll)), (Dl.is3d() || Dl.isCss3d()) && (this.state.needsReRender = !0));
                        }), this.state.needsReRender && this.viewer.needsUpdate();
                    }
                    __getTargetMarker(Qe, rt) {
                        if (void 0 === rt && (rt = !1), Qe instanceof Node) {
                            const Wn = rt ? Co.Wp.getClosest(Qe, ".psv-marker") : Qe;
                            return Wn ? Wn[rd] : void 0;
                        }
                        return Array.isArray(Qe) ? Qe.map((Qe)=>Qe.userData[rd]).filter((Qe)=>!!Qe).sort((Qe, rt)=>rt.config.zIndex - Qe.config.zIndex)[0] : null;
                    }
                    __onEnterMarker(Qe, rt) {
                        rt && (this.state.hoveringMarker = rt, this.state.lastClientX = Qe.clientX, this.state.lastClientY = Qe.clientY, this.dispatchEvent(new $l(rt)), rt instanceof xd && rt.applyScale({
                            zoomLevel: this.viewer.getZoomLevel(),
                            viewerPosition: this.viewer.getPosition(),
                            mouseover: !0
                        }), rt.state.staticTooltip || "hover" !== rt.config.tooltip?.trigger || rt.showTooltip(Qe.clientX, Qe.clientY));
                    }
                    __onLeaveMarker(Qe) {
                        Qe && (this.dispatchEvent(new Ql(Qe)), Qe instanceof xd && Qe.applyScale({
                            zoomLevel: this.viewer.getZoomLevel(),
                            viewerPosition: this.viewer.getPosition(),
                            mouseover: !1
                        }), this.state.hoveringMarker = null, Qe.state.staticTooltip || "hover" !== Qe.config.tooltip?.trigger ? Qe.state.staticTooltip && Qe.showTooltip() : Qe.hideTooltip());
                    }
                    __onHoverMarker(Qe, rt) {
                        rt && (this.state.lastClientX = Qe.clientX, this.state.lastClientY = Qe.clientY, (rt.isPoly() || rt.is3d() || rt.isCss3d()) && "hover" === rt.config.tooltip?.trigger && rt.showTooltip(Qe.clientX, Qe.clientY));
                    }
                    __onClick(Qe, rt) {
                        const Wn = this.__getTargetMarker(Qe.data.objects), Co = this.__getTargetMarker(Qe.data.target, !0) || Wn;
                        this.state.currentMarker && this.state.currentMarker !== Co && (this.dispatchEvent(new yu(this.state.currentMarker)), this.viewer.panel.hide(ad), this.state.showAllTooltips || "click" !== this.state.currentMarker.config.tooltip?.trigger || this.hideMarkerTooltip(this.state.currentMarker.id), this.state.currentMarker = null), Co && (this.state.currentMarker = Co, this.dispatchEvent(new tu(Co, rt, Qe.data.rightclick)), this.config.clickEventOnMarker ? Qe.data.marker = Co : Qe.stopImmediatePropagation(), this.markers[Co.id] && !Qe.data.rightclick && ("click" === Co.config.tooltip?.trigger ? Co.tooltip ? this.hideMarkerTooltip(Co.id) : this.showMarkerTooltip(Co.id) : this.showMarkerPanel(Co.id)));
                    }
                    __afterChangeMarkers() {
                        this.__refreshUi(), this.__checkObjectsObserver(), this.viewer.needsUpdate(), this.dispatchEvent(new Zu(this.getMarkers()));
                    }
                    __refreshUi() {
                        const Qe = Object.values(this.markers).filter((Qe)=>!Qe.config.hideList).length;
                        0 === Qe ? (this.viewer.panel.isVisible(od) || this.viewer.panel.isVisible(ad)) && this.viewer.panel.hide() : this.viewer.panel.isVisible(od) ? this.showMarkersList() : this.viewer.panel.isVisible(ad) && (this.state.currentMarker ? this.showMarkerPanel(this.state.currentMarker.id) : this.viewer.panel.hide()), this.viewer.navbar.getButton(td.id, !1)?.toggle(Qe > 0), this.viewer.navbar.getButton(cd.id, !1)?.toggle(Qe > 0);
                    }
                    __checkObjectsObserver() {
                        Object.values(this.markers).some((Qe)=>Qe.is3d()) ? this.viewer.observeObjects(rd) : this.viewer.unobserveObjects(rd);
                    }
                };
                Nd.id = "markers", Nd.VERSION = "5.12.1", Nd.configParser = zd, Nd.readonlyOptions = [
                    "markers"
                ], Co.zY.lang[td.id] = "Markers", Co.zY.lang[cd.id] = "Markers list", (0, Co.S)(td, "caption:left"), (0, Co.S)(cd, "caption:left");
            },
            3348: (Qe, rt, Wn)=>{
                "use strict";
                Wn.d(rt, {
                    $: ()=>ld
                });
                var Co = Wn(1545), Dl = Wn(9435), Ll = Object.defineProperty;
                ((Qe, rt)=>{
                    for(var Wn in rt)Ll(Qe, Wn, {
                        get: rt[Wn],
                        enumerable: !0
                    });
                })({}, {
                    EnterArrowEvent: ()=>Zl,
                    LeaveArrowEvent: ()=>ql,
                    NodeChangedEvent: ()=>Ul
                });
                var Rl = class _NodeChangedEvent extends Co.rx {
                    constructor(Qe, rt){
                        super(_NodeChangedEvent.type), this.node = Qe, this.data = rt;
                    }
                };
                Rl.type = "node-changed";
                var Ul = Rl, Gl = class _EnterArrowEvent extends Co.rx {
                    constructor(Qe, rt){
                        super(_EnterArrowEvent.type), this.link = Qe, this.node = rt;
                    }
                };
                Gl.type = "enter-arrow";
                var Zl = Gl, Hl = class _LeaveArrowEvent extends Co.rx {
                    constructor(Qe, rt){
                        super(_LeaveArrowEvent.type), this.link = Qe, this.node = rt;
                    }
                };
                Hl.type = "leave-arrow";
                var ql = Hl, Ql = class extends Dl.B69 {
                    constructor(Qe){
                        void 0 === Qe && (Qe = document.createElement("div")), super(), this.isCSS2DObject = !0, this.element = Qe, this.element.style.position = "absolute", this.element.style.userSelect = "none", this.element.setAttribute("draggable", !1), this.center = new Dl.I9Y(.5, .5), this.addEventListener("removed", function() {
                            this.traverse(function(Qe) {
                                Qe.element instanceof Qe.element.ownerDocument.defaultView.Element && null !== Qe.element.parentNode && Qe.element.remove();
                            });
                        });
                    }
                    copy(Qe, rt) {
                        return super.copy(Qe, rt), this.element = Qe.element.cloneNode(!0), this.center = Qe.center, this;
                    }
                }, Kl = new Dl.Pq0, $l = new Dl.kn4, Tc = new Dl.kn4, tu = new Dl.Pq0, lu = new Dl.Pq0, du = class {
                    constructor(Qe){
                        void 0 === Qe && (Qe = {});
                        const rt = this;
                        let Wn, Co, Dl, Ll;
                        const Rl = {
                            objects: new WeakMap
                        }, Ul = void 0 !== Qe.element ? Qe.element : document.createElement("div");
                        function hideObject(Qe) {
                            Qe.isCSS2DObject && (Qe.element.style.display = "none");
                            for(let rt = 0, Wn = Qe.children.length; rt < Wn; rt++)hideObject(Qe.children[rt]);
                        }
                        function renderObject(Qe, Wn, Co) {
                            if (!1 !== Qe.visible) {
                                if (Qe.isCSS2DObject) {
                                    Kl.setFromMatrixPosition(Qe.matrixWorld), Kl.applyMatrix4(Tc);
                                    const Gl = Kl.z >= -1 && Kl.z <= 1 && !0 === Qe.layers.test(Co.layers), Zl = Qe.element;
                                    Zl.style.display = !0 === Gl ? "" : "none", !0 === Gl && (Qe.onBeforeRender(rt, Wn, Co), Zl.style.transform = "translate(" + -100 * Qe.center.x + "%," + -100 * Qe.center.y + "%)translate(" + (Kl.x * Dl + Dl) + "px," + (-Kl.y * Ll + Ll) + "px)", Zl.parentNode !== Ul && Ul.appendChild(Zl), Qe.onAfterRender(rt, Wn, Co));
                                    const Hl = {
                                        distanceToCameraSquared: getDistanceToSquared(Co, Qe)
                                    };
                                    Rl.objects.set(Qe, Hl);
                                }
                                for(let rt = 0, Dl = Qe.children.length; rt < Dl; rt++)renderObject(Qe.children[rt], Wn, Co);
                            } else hideObject(Qe);
                        }
                        function getDistanceToSquared(Qe, rt) {
                            return tu.setFromMatrixPosition(Qe.matrixWorld), lu.setFromMatrixPosition(rt.matrixWorld), tu.distanceToSquared(lu);
                        }
                        Ul.style.overflow = "hidden", this.domElement = Ul, this.getSize = function() {
                            return {
                                width: Wn,
                                height: Co
                            };
                        }, this.render = function(Qe, rt) {
                            !0 === Qe.matrixWorldAutoUpdate && Qe.updateMatrixWorld(), null === rt.parent && !0 === rt.matrixWorldAutoUpdate && rt.updateMatrixWorld(), $l.copy(rt.matrixWorldInverse), Tc.multiplyMatrices(rt.projectionMatrix, $l), renderObject(Qe, Qe, rt), function(Qe) {
                                const rt = (function(Qe) {
                                    const rt = [];
                                    return Qe.traverseVisible(function(Qe) {
                                        Qe.isCSS2DObject && rt.push(Qe);
                                    }), rt;
                                })(Qe).sort(function(Qe, rt) {
                                    if (Qe.renderOrder !== rt.renderOrder) return rt.renderOrder - Qe.renderOrder;
                                    return Rl.objects.get(Qe).distanceToCameraSquared - Rl.objects.get(rt).distanceToCameraSquared;
                                }), Wn = rt.length;
                                for(let Co = 0, Dl = rt.length; Co < Dl; Co++)rt[Co].element.style.zIndex = Wn - Co;
                            }(Qe);
                        }, this.setSize = function(Qe, rt) {
                            Wn = Qe, Co = rt, Dl = Wn / 2, Ll = Co / 2, Ul.style.width = Qe + "px", Ul.style.height = rt + "px";
                        };
                    }
                }, fu = new Dl.Pq0, yu = new Dl.PTz, Eu = new Dl.Pq0, Tu = class extends Dl.B69 {
                    constructor(Qe){
                        void 0 === Qe && (Qe = document.createElement("div")), super(), this.isCSS3DObject = !0, this.element = Qe, this.element.style.position = "absolute", this.element.style.pointerEvents = "auto", this.element.style.userSelect = "none", this.element.setAttribute("draggable", !1), this.addEventListener("removed", function() {
                            this.traverse(function(Qe) {
                                Qe.element instanceof Qe.element.ownerDocument.defaultView.Element && null !== Qe.element.parentNode && Qe.element.remove();
                            });
                        });
                    }
                    copy(Qe, rt) {
                        return super.copy(Qe, rt), this.element = Qe.element.cloneNode(!0), this;
                    }
                }, Lu = new Dl.kn4, Zu = new Dl.kn4, Xu = class {
                    constructor(Qe){
                        void 0 === Qe && (Qe = {});
                        const rt = this;
                        let Wn, Co, Dl, Ll;
                        const Rl = {
                            camera: {
                                style: ""
                            },
                            objects: new WeakMap
                        }, Ul = void 0 !== Qe.element ? Qe.element : document.createElement("div");
                        Ul.style.overflow = "hidden", this.domElement = Ul;
                        const Gl = document.createElement("div");
                        Gl.style.transformOrigin = "0 0", Gl.style.pointerEvents = "none", Ul.appendChild(Gl);
                        const Zl = document.createElement("div");
                        function epsilon(Qe) {
                            return Math.abs(Qe) < 1e-10 ? 0 : Qe;
                        }
                        function getCameraCSSMatrix(Qe) {
                            const rt = Qe.elements;
                            return "matrix3d(" + epsilon(rt[0]) + "," + epsilon(-rt[1]) + "," + epsilon(rt[2]) + "," + epsilon(rt[3]) + "," + epsilon(rt[4]) + "," + epsilon(-rt[5]) + "," + epsilon(rt[6]) + "," + epsilon(rt[7]) + "," + epsilon(rt[8]) + "," + epsilon(-rt[9]) + "," + epsilon(rt[10]) + "," + epsilon(rt[11]) + "," + epsilon(rt[12]) + "," + epsilon(-rt[13]) + "," + epsilon(rt[14]) + "," + epsilon(rt[15]) + ")";
                        }
                        function getObjectCSSMatrix(Qe) {
                            const rt = Qe.elements;
                            return "translate(-50%,-50%)" + ("matrix3d(" + epsilon(rt[0]) + "," + epsilon(rt[1]) + "," + epsilon(rt[2]) + "," + epsilon(rt[3]) + "," + epsilon(-rt[4]) + "," + epsilon(-rt[5]) + "," + epsilon(-rt[6]) + "," + epsilon(-rt[7]) + "," + epsilon(rt[8]) + "," + epsilon(rt[9]) + "," + epsilon(rt[10]) + "," + epsilon(rt[11]) + "," + epsilon(rt[12]) + "," + epsilon(rt[13]) + "," + epsilon(rt[14]) + "," + epsilon(rt[15]) + ")");
                        }
                        function hideObject(Qe) {
                            Qe.isCSS3DObject && (Qe.element.style.display = "none");
                            for(let rt = 0, Wn = Qe.children.length; rt < Wn; rt++)hideObject(Qe.children[rt]);
                        }
                        function renderObject(Qe, Wn, Co, Dl) {
                            if (!1 !== Qe.visible) {
                                if (Qe.isCSS3DObject) {
                                    const Dl = !0 === Qe.layers.test(Co.layers), Ll = Qe.element;
                                    if (Ll.style.display = !0 === Dl ? "" : "none", !0 === Dl) {
                                        let Dl;
                                        Qe.onBeforeRender(rt, Wn, Co), Qe.isCSS3DSprite ? (Lu.copy(Co.matrixWorldInverse), Lu.transpose(), 0 !== Qe.rotation2D && Lu.multiply(Zu.makeRotationZ(Qe.rotation2D)), Qe.matrixWorld.decompose(fu, yu, Eu), Lu.setPosition(fu), Lu.scale(Eu), Lu.elements[3] = 0, Lu.elements[7] = 0, Lu.elements[11] = 0, Lu.elements[15] = 1, Dl = getObjectCSSMatrix(Lu)) : Dl = getObjectCSSMatrix(Qe.matrixWorld);
                                        const Ul = Rl.objects.get(Qe);
                                        if (void 0 === Ul || Ul.style !== Dl) {
                                            Ll.style.transform = Dl;
                                            const rt = {
                                                style: Dl
                                            };
                                            Rl.objects.set(Qe, rt);
                                        }
                                        Ll.parentNode !== Zl && Zl.appendChild(Ll), Qe.onAfterRender(rt, Wn, Co);
                                    }
                                }
                                for(let rt = 0, Ll = Qe.children.length; rt < Ll; rt++)renderObject(Qe.children[rt], Wn, Co, Dl);
                            } else hideObject(Qe);
                        }
                        Zl.style.transformStyle = "preserve-3d", Gl.appendChild(Zl), this.getSize = function() {
                            return {
                                width: Wn,
                                height: Co
                            };
                        }, this.render = function(Qe, rt) {
                            const Ul = rt.projectionMatrix.elements[5] * Ll;
                            let Hl, ql;
                            rt.view && rt.view.enabled ? (Gl.style.transform = `translate( ${-rt.view.offsetX * (Wn / rt.view.width)}px, ${-rt.view.offsetY * (Co / rt.view.height)}px )`, Gl.style.transform += `scale( ${rt.view.fullWidth / rt.view.width}, ${rt.view.fullHeight / rt.view.height} )`) : Gl.style.transform = "", !0 === Qe.matrixWorldAutoUpdate && Qe.updateMatrixWorld(), null === rt.parent && !0 === rt.matrixWorldAutoUpdate && rt.updateMatrixWorld(), rt.isOrthographicCamera && (Hl = -(rt.right + rt.left) / 2, ql = (rt.top + rt.bottom) / 2);
                            const Ql = rt.view && rt.view.enabled ? rt.view.height / rt.view.fullHeight : 1, Kl = rt.isOrthographicCamera ? `scale( ${Ql} )scale(` + Ul + ")translate(" + epsilon(Hl) + "px," + epsilon(ql) + "px)" + getCameraCSSMatrix(rt.matrixWorldInverse) : `scale( ${Ql} )translateZ(` + Ul + "px)" + getCameraCSSMatrix(rt.matrixWorldInverse), $l = (rt.isPerspectiveCamera ? "perspective(" + Ul + "px) " : "") + Kl + "translate(" + Dl + "px," + Ll + "px)";
                            Rl.camera.style !== $l && (Zl.style.transform = $l, Rl.camera.style = $l), renderObject(Qe, Qe, rt, Kl);
                        }, this.setSize = function(Qe, rt) {
                            Wn = Qe, Co = rt, Dl = Wn / 2, Ll = Co / 2, Ul.style.width = Qe + "px", Ul.style.height = rt + "px", Gl.style.width = Qe + "px", Gl.style.height = rt + "px", Zl.style.width = Qe + "px", Zl.style.height = rt + "px";
                        };
                    }
                }, Ju = "tourLink", $u = "__tour-link__", ed = {
                    className: "psv-virtual-tour-tooltip",
                    content: '<div class="psv-virtual-tour-loader"><div></div><div></div><div></div></div>'
                }, td = {
                    element: ()=>{
                        const Qe = document.createElement("button");
                        return Qe.className = "psv-virtual-tour-arrow", Qe.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">\n    <path fill-rule="even-odd" fill="currentColor" d="\n        M50,50 m45,0\n        a45,45 0 1,0 -90,0\n        a45,45 0 1,0  90,0\n\n        M50,50 m38,0\n        a38,38 0 0,1 -76,0\n        a38,38 0 0,1  76,0\n\n        M50,50 m30,0\n        a30,30 0 1,0 -60,0\n        a30,30 0 1,0  60,0\n        \n        M50,40 m2.5,-2.5\n        l17.5,17.5\n        a 2.5,2.5 0 0 1 -5,5\n        l-15,-15\n        l-15,15\n        a 2.5,2.5 0 0 1 -5,-5\n        l17.5,-17.5\n        a 3.5,3.5 0 0 1 5,0\n    "/>\n</svg>', Qe;
                    },
                    size: {
                        width: 80,
                        height: 80
                    }
                }, id = "arrow", nd = class extends Co.uj {
                    constructor(Qe, rt){
                        super(Qe, {
                            className: "psv-virtual-tour-arrows"
                        }), this.plugin = rt, this.renderer = this.is3D ? new Xu({
                            element: this.container
                        }) : new du({
                            element: this.container
                        }), this.camera = this.is3D ? new Dl.ubm(30, 1) : null, this.scene = new Dl.Z58, this.viewer.addEventListener(Co.AZ.ReadyEvent.type, this, {
                            once: !0
                        }), this.viewer.addEventListener(Co.AZ.PositionUpdatedEvent.type, this), this.viewer.addEventListener(Co.AZ.SizeUpdatedEvent.type, this), this.viewer.addEventListener(Co.AZ.RenderEvent.type, this), this.viewer.addEventListener(Co.AZ.ClickEvent.type, this), this.container.addEventListener("mouseenter", this, !0), this.container.addEventListener("mouseleave", this, !0), this.container.addEventListener("mousemove", this, !0), this.container.addEventListener("contextmenu", (Qe)=>Qe.preventDefault());
                    }
                    get is3D() {
                        return this.plugin.is3D;
                    }
                    get arrowsPosition() {
                        return this.plugin.config.arrowsPosition;
                    }
                    get arrowStyle() {
                        return this.plugin.config.arrowStyle;
                    }
                    init() {
                        this.is3D && (this.gallery = this.viewer.getPlugin("gallery"), this.gallery?.addEventListener("show-gallery", this), this.gallery?.addEventListener("hide-gallery", this));
                    }
                    destroy() {
                        this.viewer.removeEventListener(Co.AZ.ReadyEvent.type, this), this.viewer.removeEventListener(Co.AZ.PositionUpdatedEvent.type, this), this.viewer.removeEventListener(Co.AZ.SizeUpdatedEvent.type, this), this.viewer.removeEventListener(Co.AZ.RenderEvent.type, this), this.viewer.removeEventListener(Co.AZ.ClickEvent.type, this), this.gallery?.removeEventListener("show-gallery", this), this.gallery?.removeEventListener("hide-gallery", this), super.destroy();
                    }
                    handleEvent(Qe) {
                        switch(Qe.type){
                            case Co.AZ.ReadyEvent.type:
                            case Co.AZ.SizeUpdatedEvent.type:
                            case Co.AZ.PositionUpdatedEvent.type:
                                this.__updateCamera();
                                break;
                            case Co.AZ.RenderEvent.type:
                                this.render();
                                break;
                            case Co.AZ.ClickEvent.type:
                                {
                                    if (Qe.data.rightclick) break;
                                    const rt = this.__getTargetLink(Qe.data.target, !0);
                                    rt && this.plugin.setCurrentNode(rt.nodeId, null, rt);
                                    break;
                                }
                            case "mouseenter":
                                {
                                    const rt = this.__getTargetLink(Co.Wp.getEventTarget(Qe));
                                    rt && this.plugin.__onEnterArrow(rt, Qe);
                                    break;
                                }
                            case "mouseleave":
                                {
                                    const rt = this.__getTargetLink(Co.Wp.getEventTarget(Qe));
                                    rt && this.plugin.__onLeaveArrow(rt);
                                    break;
                                }
                            case "mousemove":
                                this.__getTargetLink(Co.Wp.getEventTarget(Qe), !0) && this.plugin.__onHoverArrow(Qe);
                                break;
                            case "hide-gallery":
                                this.__onToggleGallery(!1);
                                break;
                            case "show-gallery":
                                Qe.fullscreen || this.__onToggleGallery(!0);
                        }
                    }
                    __updateCamera() {
                        const Qe = this.viewer.getSize();
                        if (this.renderer.setSize(Qe.width, Qe.height), this.is3D) {
                            const rt = this.viewer.getPosition();
                            rt.pitch = Dl.cj9.clamp(rt.pitch, -this.arrowsPosition.maxPitch, -this.arrowsPosition.minPitch), this.viewer.dataHelper.sphericalCoordsToVector3(rt, this.camera.position, 2 * Qe.height).negate(), this.camera.lookAt(0, 0, 0), this.camera.translateY(Qe.height / 3), this.camera.updateProjectionMatrix();
                        }
                    }
                    render() {
                        if (this.is3D) {
                            const Qe = this.viewer.getPosition(), rt = [];
                            let Wn = Number.MAX_SAFE_INTEGER;
                            this.scene.children.forEach((Dl)=>{
                                const Ll = Dl.userData[id];
                                if (Ll.conflict) {
                                    const Rl = Math.abs(Co.Wp.getShortestArc(Qe.yaw, Ll.yaw));
                                    Wn = Math.min(Wn, Rl), rt.push([
                                        Dl,
                                        Rl
                                    ]);
                                }
                            }), rt.forEach((Qe)=>{
                                let [rt, Co] = Qe;
                                const Dl = Co !== Wn;
                                rt.element.style.opacity = Dl ? "0.5" : null, rt.element.style.zIndex = Dl ? "-1" : null;
                            }), this.renderer.render(this.scene, this.camera);
                        } else this.renderer.render(this.scene, this.viewer.renderer.camera);
                    }
                    clear() {
                        this.scene.clear();
                    }
                    __buildArrowElement(Qe, rt) {
                        if (rt?.image) {
                            const Qe = document.createElement("img");
                            return Qe.src = rt.image, Qe;
                        }
                        if (rt?.element) return "function" === typeof rt.element ? rt.element(Qe) : rt.element;
                    }
                    addLinkArrow(Qe, rt, Wn) {
                        void 0 === Wn && (Wn = 1);
                        let Dl = this.__buildArrowElement(Qe, Qe.arrowStyle);
                        Dl || (Dl = this.__buildArrowElement(Qe, this.arrowStyle)), Dl[Ju] = Qe;
                        const Ll = {
                            ...this.arrowStyle,
                            ...Qe.arrowStyle
                        };
                        if (Dl.classList.add("psv-virtual-tour-link"), Ll.className && Co.Wp.addClasses(Dl, Ll.className), Ll.style && Object.assign(Dl.style, Ll.style), this.is3D) {
                            Dl.style.width = 1.5 * Ll.size.width + "px", Dl.style.height = 1.5 * Ll.size.height + "px";
                            let Qe = !1;
                            this.scene.children.forEach((Wn)=>{
                                const Dl = Wn.userData[id];
                                Math.abs(Co.Wp.getShortestArc(Dl.yaw, rt.yaw)) < this.arrowsPosition.linkOverlapAngle && (Dl.conflict = !0, Qe = !0);
                            });
                            const Rl = new Tu(Dl);
                            Rl.userData[id] = {
                                yaw: rt.yaw,
                                conflict: Qe
                            }, Rl.rotation.set(-Math.PI / 2, 0, Math.PI - rt.yaw), this.viewer.dataHelper.sphericalCoordsToVector3({
                                yaw: rt.yaw,
                                pitch: 0
                            }, Rl.position, 100 * Wn), this.scene.add(Rl);
                        } else {
                            Dl.style.width = Ll.size.width + "px", Dl.style.height = Ll.size.height + "px", Dl.style.pointerEvents = "auto";
                            const Qe = new Ql(Dl);
                            this.viewer.dataHelper.sphericalCoordsToVector3(rt, Qe.position), this.scene.add(Qe);
                        }
                    }
                    __getTargetLink(Qe, rt) {
                        void 0 === rt && (rt = !1);
                        const Wn = rt ? Co.Wp.getClosest(Qe, ".psv-virtual-tour-link") : Qe;
                        return Wn ? Wn[Ju] : void 0;
                    }
                    __onToggleGallery(Qe) {
                        this.container.style.marginBottom = Qe ? this.viewer.container.querySelector(".psv-gallery").offsetHeight + "px" : "";
                    }
                }, rd = class {
                    constructor(Qe, rt){
                        this.plugin = Qe, this.viewer = rt, this.nodes = {};
                    }
                    destroy() {}
                    checkNode(Qe) {
                        if (!Qe.id) throw new Co.e6("No id given for node");
                        if (!Qe.panorama) throw new Co.e6(`No panorama provided for node ${Qe.id}`);
                        if (this.plugin.isGps && !(Qe.gps?.length >= 2)) throw new Co.e6(`No GPS position provided for node ${Qe.id}`);
                        if (!this.plugin.isGps && Qe.markers?.some((Qe)=>Qe.gps && !Qe.position)) throw new Co.e6("Cannot use GPS positioning for markers in manual mode");
                        Qe.links || (Co.Wp.logWarn(`Node ${Qe.id} has no links`), Qe.links = []);
                    }
                    checkLink(Qe, rt) {
                        if (!rt.nodeId) throw new Co.e6(`Link of node ${Qe.id} has no target id`);
                        if (rt.nodeId === Qe.id) throw new Co.e6(`Node ${Qe.id} links to itself`);
                        if (!this.plugin.isGps && !Co.Wp.isExtendedPosition(rt.position)) throw new Co.e6(`No position provided for link ${rt.nodeId} of node ${Qe.id}`);
                        if (this.plugin.isGps && !rt.gps) throw new Co.e6(`No GPS position provided for link ${rt.nodeId} of node ${Qe.id}`);
                    }
                }, sd = class extends rd {
                    async loadNode(Qe) {
                        if (this.nodes[Qe]) return this.nodes[Qe];
                        throw new Co.e6(`Node ${Qe} not found`);
                    }
                    setNodes(Qe) {
                        if (!Qe?.length) throw new Co.e6("No nodes provided");
                        const rt = {}, Wn = {};
                        Qe.forEach((Qe)=>{
                            if (this.checkNode(Qe), rt[Qe.id]) throw new Co.e6(`Duplicate node ${Qe.id}`);
                            rt[Qe.id] = Qe;
                        }), Qe.forEach((Qe)=>{
                            this.__checkLinks(Qe, rt), Qe.links.forEach((Qe)=>{
                                Wn[Qe.nodeId] = !0;
                            });
                        }), Qe.forEach((Qe)=>{
                            Wn[Qe.id] || Co.Wp.logWarn(`Node ${Qe.id} is never linked to`);
                        }), this.nodes = rt;
                    }
                    updateNode(Qe) {
                        if (!Qe.id) throw new Co.e6("No id given for node");
                        const rt = this.nodes[Qe.id];
                        if (!rt) throw new Co.e6(`Node ${Qe.id} does not exist`);
                        return Object.assign(rt, Qe), this.checkNode(rt), this.__checkLinks(rt, this.nodes), rt;
                    }
                    __checkLinks(Qe, rt) {
                        Qe.links.forEach((Wn)=>{
                            if (!rt[Wn.nodeId]) throw new Co.e6(`Target node ${Wn.nodeId} of node ${Qe.id} does not exists`);
                            Wn.gps = Wn.gps || rt[Wn.nodeId].gps, this.checkLink(Qe, Wn);
                        });
                    }
                }, ad = class extends rd {
                    constructor(Qe, rt){
                        if (super(Qe, rt), !Qe.config.getNode) throw new Co.e6("Missing getNode() option.");
                        this.nodeResolver = Qe.config.getNode;
                    }
                    async loadNode(Qe) {
                        if (this.nodes[Qe]) return this.nodes[Qe];
                        {
                            const rt = await this.nodeResolver(Qe);
                            return this.checkNode(rt), rt.links.forEach((Qe)=>{
                                this.checkLink(rt, Qe);
                            }), this.nodes[Qe] = rt, rt;
                        }
                    }
                    clearCache() {
                        this.nodes = {};
                    }
                };
                function gpsToSpherical(Qe, rt) {
                    const Wn = gpsDegToRad(Qe), Dl = gpsDegToRad(rt), Ll = Qe[2] ?? 0, Rl = rt[2] ?? 0;
                    let Ul = 0;
                    Ll !== Rl && (Ul = Math.atan((Rl - Ll) / function(Qe, rt) {
                        return 6371e3 * Co.Wp.greatArcDistance(Qe, rt);
                    }(Wn, Dl)));
                    const Gl = function(Qe, rt) {
                        const [Wn, Co] = Qe, [Dl, Ll] = rt, Rl = Math.sin(Dl - Wn) * Math.cos(Ll), Ul = Math.cos(Co) * Math.sin(Ll) - Math.sin(Co) * Math.cos(Ll) * Math.cos(Dl - Wn);
                        return Math.atan2(Rl, Ul);
                    }(Wn, Dl);
                    return {
                        yaw: Gl,
                        pitch: Ul
                    };
                }
                function gpsDegToRad(Qe) {
                    return [
                        Dl.cj9.degToRad(Qe[0]),
                        Dl.cj9.degToRad(Qe[1])
                    ];
                }
                var od = Co.Wp.getConfigParser({
                    dataMode: "client",
                    positionMode: "manual",
                    renderMode: "3d",
                    nodes: null,
                    getNode: null,
                    startNodeId: null,
                    preload: !1,
                    transitionOptions: {
                        showLoader: !0,
                        speed: "20rpm",
                        effect: "fade",
                        rotation: !0
                    },
                    linksOnCompass: !0,
                    showLinkTooltip: !0,
                    getLinkTooltip: null,
                    arrowStyle: td,
                    arrowsPosition: {
                        minPitch: .3,
                        maxPitch: Math.PI / 2,
                        linkOverlapAngle: Math.PI / 4,
                        linkPitchOffset: -0.1
                    },
                    map: null
                }, {
                    dataMode (Qe) {
                        if ("client" !== Qe && "server" !== Qe) throw new Co.e6("VirtualTourPlugin: invalid dataMode");
                        return Qe;
                    },
                    positionMode (Qe) {
                        if ("gps" !== Qe && "manual" !== Qe) throw new Co.e6("VirtualTourPlugin: invalid positionMode");
                        return Qe;
                    },
                    renderMode (Qe) {
                        if ("3d" !== Qe && "2d" !== Qe) throw new Co.e6("VirtualTourPlugin: invalid renderMode");
                        return Qe;
                    },
                    arrowsPosition (Qe, rt) {
                        let { defValue: Wn } = rt;
                        return {
                            ...Wn,
                            ...Qe
                        };
                    },
                    arrowStyle (Qe, rt) {
                        let { defValue: Wn } = rt;
                        return {
                            ...Wn,
                            ...Qe
                        };
                    },
                    map (Qe, rt) {
                        let { rawConfig: Wn } = rt;
                        if (Qe) {
                            if ("server" === Wn.dataMode) return Co.Wp.logWarn("VirtualTourPlugin: The map cannot be used in server side mode"), null;
                            if (!Qe.imageUrl) return Co.Wp.logWarn('VirtualTourPlugin: configuring the map requires at least "imageUrl"'), null;
                        }
                        return Qe;
                    }
                }), ld = class extends Co.TL {
                    constructor(Qe, rt){
                        super(Qe, rt), this.state = {
                            currentNode: null,
                            currentTooltip: null,
                            loadingNode: null,
                            preload: {}
                        }, this.arrowsRenderer = new nd(this.viewer, this);
                    }
                    get is3D() {
                        return "3d" === this.config.renderMode;
                    }
                    get isServerSide() {
                        return "server" === this.config.dataMode;
                    }
                    get isGps() {
                        return "gps" === this.config.positionMode;
                    }
                    init() {
                        super.init(), this.arrowsRenderer.init(), Co.Wp.checkStylesheet(this.viewer.container, "virtual-tour-plugin"), this.markers = this.viewer.getPlugin("markers"), this.compass = this.viewer.getPlugin("compass"), this.markers?.config.markers && (Co.Wp.logWarn("No default markers can be configured on the MarkersPlugin when using the VirtualTourPlugin. Consider defining `markers` on each tour node."), delete this.markers.config.markers), this.isGps && (this.plan = this.viewer.getPlugin("plan")), this.isServerSide || (this.gallery = this.viewer.getPlugin("gallery"), this.map = this.viewer.getPlugin("map"), this.config.map && !this.map && Co.Wp.logWarn("The map is configured on the VirtualTourPlugin but the MapPlugin is not loaded.")), this.datasource = this.isServerSide ? new ad(this, this.viewer) : new sd(this, this.viewer), this.map && (this.map.addEventListener("select-hotspot", this), this.map.setImage(this.config.map.imageUrl)), this.plan?.addEventListener("select-hotspot", this), this.isServerSide ? this.config.startNodeId && this.setCurrentNode(this.config.startNodeId) : this.config.nodes && (this.setNodes(this.config.nodes, this.config.startNodeId), delete this.config.nodes);
                    }
                    destroy() {
                        this.map?.removeEventListener("select-hotspot", this), this.plan?.removeEventListener("select-hotspot", this), this.datasource.destroy(), this.arrowsRenderer.destroy(), delete this.datasource, delete this.markers, delete this.compass, delete this.gallery, delete this.arrowsRenderer, super.destroy();
                    }
                    handleEvent(Qe) {
                        if (Qe instanceof Co.AZ.ClickEvent) {
                            const rt = Qe.data.objects.find((Qe)=>Qe.userData[Ju])?.userData[Ju];
                            rt && this.setCurrentNode(rt.nodeId, null, rt);
                        } else if ("select-hotspot" === Qe.type) {
                            const rt = Qe.hotspotId;
                            rt.startsWith($u) && this.setCurrentNode(rt.substring(13));
                        }
                    }
                    getCurrentNode() {
                        return this.state.currentNode;
                    }
                    setNodes(Qe, rt) {
                        if (this.isServerSide) throw new Co.e6("Cannot set nodes in server side mode");
                        this.__hideTooltip(), this.state.currentNode = null, this.datasource.setNodes(Qe), rt ? this.datasource.nodes[rt] || (rt = Qe[0].id, Co.Wp.logWarn(`startNodeId not found is provided nodes, resetted to ${rt}`)) : rt = Qe[0].id, this.setCurrentNode(rt), this.__setGalleryItems(), this.__setMapHotspots(), this.__setPlanHotspots();
                    }
                    setCurrentNode(Qe, rt, Wn) {
                        if (Qe === this.state.currentNode?.id && !rt?.forceUpdate) return Promise.resolve(!0);
                        rt?.forceUpdate && this.isServerSide && this.datasource.clearCache(), this.viewer.hideError(), this.state.loadingNode = Qe;
                        const Dl = this.state.currentNode, Ll = Dl && Wn ? this.__getLinkPosition(Dl, Wn) : null;
                        return Promise.resolve(this.state.preload[Qe]).then(()=>{
                            if (this.state.loadingNode !== Qe) throw Co.Wp.getAbortError();
                            return this.datasource.loadNode(Qe);
                        }).then((Rl)=>{
                            if (this.state.loadingNode !== Qe) throw Co.Wp.getAbortError();
                            const Ul = {
                                ...od.defaults.transitionOptions,
                                rotateTo: Ll,
                                zoomTo: Ll ? this.viewer.getZoomLevel() : null,
                                ..."function" === typeof this.config.transitionOptions ? this.config.transitionOptions(Rl, Dl, Wn) : this.config.transitionOptions,
                                ...rt
                            };
                            return Ul.effect || (Ul.effect = "none"), this.__hideTooltip(), this.arrowsRenderer.clear(), this.gallery?.config.hideOnClick && this.gallery.hide(), this.map?.config.minimizeOnHotspotClick && this.map.minimize(), this.plan?.config.minimizeOnHotspotClick && this.plan.minimize(), Ul.rotation && "none" === Ul.effect ? this.viewer.animate({
                                ...Ul.rotateTo,
                                zoom: Ul.zoomTo,
                                speed: Ul.speed
                            }).then(()=>[
                                    Rl,
                                    Ul
                                ]) : Promise.resolve([
                                Rl,
                                Ul
                            ]);
                        }).then((rt)=>{
                            let [Wn, Dl] = rt;
                            if (this.state.loadingNode !== Qe) throw Co.Wp.getAbortError();
                            return this.markers?.clearMarkers(), this.config.linksOnCompass && this.compass?.clearHotspots(), this.viewer.setPanorama(Wn.panorama, {
                                caption: Wn.caption,
                                description: Wn.description,
                                panoData: Wn.panoData,
                                sphereCorrection: Wn.sphereCorrection,
                                showLoader: Dl.showLoader,
                                position: Dl.rotateTo,
                                zoom: Dl.zoomTo,
                                transition: "none" !== Dl.effect && {
                                    effect: Dl.effect,
                                    rotation: Dl.rotation,
                                    speed: Dl.speed
                                }
                            }).then((Qe)=>{
                                if (!Qe) throw Co.Wp.getAbortError();
                                return Wn;
                            });
                        }).then((rt)=>{
                            if (this.state.loadingNode !== Qe) throw Co.Wp.getAbortError();
                            return this.state.currentNode = rt, this.map?.setCenter(this.__getNodeMapPosition(rt)), this.plan?.setCoordinates(rt.gps), this.__addNodeMarkers(rt), this.__renderLinks(rt), this.__preload(rt), this.state.loadingNode = null, this.dispatchEvent(new Ul(rt, {
                                fromNode: Dl,
                                fromLink: Wn,
                                fromLinkPosition: Ll
                            })), this.viewer.resetIdleTimer(), !0;
                        }).catch((Qe)=>{
                            if (Co.Wp.isAbortError(Qe)) return !1;
                            throw this.viewer.showError(this.viewer.config.lang.loadError), this.viewer.loader.hide(), this.viewer.navbar.setCaption(""), this.state.loadingNode = null, Qe;
                        });
                    }
                    async gotoLink(Qe, rt) {
                        void 0 === rt && (rt = "8rpm");
                        const Wn = this.getLinkPosition(Qe);
                        rt ? await this.viewer.animate({
                            ...Wn,
                            speed: rt
                        }) : this.viewer.rotate(Wn);
                    }
                    getLinkPosition(Qe) {
                        const rt = this.state.currentNode?.links.find((rt)=>rt.nodeId === Qe);
                        if (!rt) throw new Co.e6(`Cannot find link "${Qe}"`);
                        return this.__getLinkPosition(this.state.currentNode, rt);
                    }
                    updateNode(Qe) {
                        if (this.isServerSide) throw new Co.e6("Cannot update node in server side mode");
                        const rt = this.datasource.updateNode(Qe);
                        if ((Qe.name || Qe.thumbnail || Qe.panorama) && this.__setGalleryItems(), (Qe.name || Qe.gps || Qe.map) && this.__setMapHotspots(), (Qe.name || Qe.gps || Qe.plan) && this.__setPlanHotspots(), this.state.currentNode?.id === rt.id) {
                            if (this.__hideTooltip(), Qe.panorama || Qe.panoData || Qe.sphereCorrection) return void this.setCurrentNode(rt.id, {
                                forceUpdate: !0
                            });
                            Qe.caption && this.viewer.setOption("caption", rt.caption), Qe.description && this.viewer.setOption("description", rt.description), (Qe.links || Qe.gps) && this.__renderLinks(rt), Qe.gps && this.plan?.setCoordinates(rt.gps), (Qe.map || Qe.gps) && this.map?.setCenter(this.__getNodeMapPosition(rt)), (Qe.markers || Qe.gps) && this.__addNodeMarkers(rt);
                        }
                    }
                    __setGalleryItems() {
                        this.gallery && this.gallery.setItems(Object.values(this.datasource.nodes).filter((Qe)=>!1 !== Qe.showInGallery).map((Qe)=>({
                                id: Qe.id,
                                panorama: Qe.panorama,
                                name: Qe.name,
                                thumbnail: Qe.thumbnail
                            })), (Qe)=>{
                            this.setCurrentNode(Qe);
                        });
                    }
                    __setMapHotspots() {
                        this.map && this.map.setHotspots(Object.values(this.datasource.nodes).map((Qe)=>({
                                ...Qe.map || {},
                                ...this.__getNodeMapPosition(Qe),
                                id: $u + Qe.id,
                                tooltip: Qe.name
                            })));
                    }
                    __setPlanHotspots() {
                        this.plan && this.plan.setHotspots(Object.values(this.datasource.nodes).map((Qe)=>({
                                ...Qe.plan || {},
                                coordinates: Qe.gps,
                                id: $u + Qe.id,
                                tooltip: Qe.name
                            })));
                    }
                    __renderLinks(Qe) {
                        this.arrowsRenderer.clear();
                        const rt = [];
                        Qe.links.forEach((Wn)=>{
                            const Co = this.__getLinkPosition(Qe, Wn);
                            Co.yaw += Wn.linkOffset?.yaw ?? 0, Co.pitch += Wn.linkOffset?.pitch ?? 0, this.isGps && !this.is3D && (Co.pitch += this.config.arrowsPosition.linkPitchOffset), rt.push(Co), this.arrowsRenderer.addLinkArrow(Wn, Co, Wn.linkOffset?.depth);
                        }), this.arrowsRenderer.render(), this.config.linksOnCompass && this.compass?.setHotspots(rt);
                    }
                    __getLinkPosition(Qe, rt) {
                        return this.isGps ? gpsToSpherical(Qe.gps, rt.gps) : this.viewer.dataHelper.cleanPosition(rt.position);
                    }
                    async __getTooltipContent(Qe) {
                        const rt = await this.datasource.loadNode(Qe.nodeId), Wn = [];
                        (rt.name || rt.thumbnail || rt.caption) && (rt.name && Wn.push(`<h3>${rt.name}</h3>`), rt.thumbnail && Wn.push(`<img src="${rt.thumbnail}">`), rt.caption && Wn.push(`<p>${rt.caption}</p>`));
                        let Co = Wn.join("");
                        return this.config.getLinkTooltip && (Co = this.config.getLinkTooltip(Co, Qe, rt)), Co;
                    }
                    __onEnterArrow(Qe, rt) {
                        const Wn = Co.Wp.getPosition(this.viewer.container), Dl = {
                            x: rt.clientX - Wn.x,
                            y: rt.clientY - Wn.y
                        };
                        this.config.showLinkTooltip && (this.state.currentTooltip = this.viewer.createTooltip({
                            ...ed,
                            left: Dl.x,
                            top: Dl.y,
                            box: {
                                width: 20,
                                height: 20
                            }
                        }), this.__getTooltipContent(Qe).then((Qe)=>{
                            Qe ? this.state.currentTooltip.update(Qe) : this.__hideTooltip();
                        })), this.map?.setActiveHotspot($u + Qe.nodeId), this.plan?.setActiveHotspot($u + Qe.nodeId), this.dispatchEvent(new Zl(Qe, this.state.currentNode));
                    }
                    __onHoverArrow(Qe) {
                        const rt = Co.Wp.getPosition(this.viewer.container), Wn = {
                            x: Qe.clientX - rt.x,
                            y: Qe.clientY - rt.y
                        };
                        this.state.currentTooltip?.move({
                            left: Wn.x,
                            top: Wn.y
                        });
                    }
                    __onLeaveArrow(Qe) {
                        this.__hideTooltip(), this.map?.setActiveHotspot(null), this.plan?.setActiveHotspot(null), this.dispatchEvent(new ql(Qe, this.state.currentNode));
                    }
                    __hideTooltip() {
                        this.state.currentTooltip?.hide(), this.state.currentTooltip = null;
                    }
                    __preload(Qe) {
                        this.config.preload && (this.state.preload[Qe.id] = !0, this.state.currentNode.links.filter((Qe)=>!this.state.preload[Qe.nodeId]).filter((Qe)=>"function" !== typeof this.config.preload || this.config.preload(this.state.currentNode, Qe)).forEach((Qe)=>{
                            this.state.preload[Qe.nodeId] = this.datasource.loadNode(Qe.nodeId).then((Qe)=>this.viewer.textureLoader.preloadPanorama(Qe.panorama)).then(()=>{
                                this.state.preload[Qe.nodeId] = !0;
                            }).catch(()=>{
                                delete this.state.preload[Qe.nodeId];
                            });
                        }));
                    }
                    __addNodeMarkers(Qe) {
                        Qe.markers && (this.markers ? this.markers.setMarkers(Qe.markers.map((rt)=>(rt.gps && this.isGps && (rt.position = gpsToSpherical(Qe.gps, rt.gps), rt.data?.map && Object.assign(rt.data.map, this.__getGpsMapPosition(rt.gps)), rt.data?.plan && (rt.data.plan.coordinates = rt.gps)), rt))) : Co.Wp.logWarn(`Node ${Qe.id} markers ignored because the plugin is not loaded.`));
                    }
                    __getNodeMapPosition(Qe) {
                        const rt = this.__getGpsMapPosition(Qe.gps);
                        return rt || (Qe.map ? {
                            x: Qe.map.x,
                            y: Qe.map.y
                        } : null);
                    }
                    __getGpsMapPosition(Qe) {
                        const rt = this.config.map;
                        return this.isGps && rt && rt.extent && rt.size ? {
                            x: Dl.cj9.mapLinear(Qe[0], rt.extent[0], rt.extent[2], 0, rt.size.width),
                            y: Dl.cj9.mapLinear(Qe[1], rt.extent[1], rt.extent[3], 0, rt.size.height)
                        } : null;
                    }
                };
                ld.id = "virtual-tour", ld.VERSION = "5.12.1", ld.configParser = od, ld.readonlyOptions = Object.keys(od.defaults);
            },
            3336: (Qe, rt, Wn)=>{
                "use strict";
                Wn.d(rt, {
                    Rq: ()=>decompressSync
                });
                var Co = Uint8Array, Dl = Uint16Array, Ll = Int32Array, Rl = new Co([
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    1,
                    1,
                    1,
                    2,
                    2,
                    2,
                    2,
                    3,
                    3,
                    3,
                    3,
                    4,
                    4,
                    4,
                    4,
                    5,
                    5,
                    5,
                    5,
                    0,
                    0,
                    0,
                    0
                ]), Ul = new Co([
                    0,
                    0,
                    0,
                    0,
                    1,
                    1,
                    2,
                    2,
                    3,
                    3,
                    4,
                    4,
                    5,
                    5,
                    6,
                    6,
                    7,
                    7,
                    8,
                    8,
                    9,
                    9,
                    10,
                    10,
                    11,
                    11,
                    12,
                    12,
                    13,
                    13,
                    0,
                    0
                ]), Gl = new Co([
                    16,
                    17,
                    18,
                    0,
                    8,
                    7,
                    9,
                    6,
                    10,
                    5,
                    11,
                    4,
                    12,
                    3,
                    13,
                    2,
                    14,
                    1,
                    15
                ]), freb = function(Qe, rt) {
                    for(var Wn = new Dl(31), Co = 0; Co < 31; ++Co)Wn[Co] = rt += 1 << Qe[Co - 1];
                    var Rl = new Ll(Wn[30]);
                    for(Co = 1; Co < 30; ++Co)for(var Ul = Wn[Co]; Ul < Wn[Co + 1]; ++Ul)Rl[Ul] = Ul - Wn[Co] << 5 | Co;
                    return {
                        b: Wn,
                        r: Rl
                    };
                }, Zl = freb(Rl, 2), Hl = Zl.b, ql = Zl.r;
                Hl[28] = 258, ql[258] = 28;
                for(var Ql = freb(Ul, 0), Kl = Ql.b, $l = (Ql.r, new Dl(32768)), Tc = 0; Tc < 32768; ++Tc){
                    var tu = (43690 & Tc) >> 1 | (21845 & Tc) << 1;
                    tu = (61680 & (tu = (52428 & tu) >> 2 | (13107 & tu) << 2)) >> 4 | (3855 & tu) << 4, $l[Tc] = ((65280 & tu) >> 8 | (255 & tu) << 8) >> 1;
                }
                var hMap = function(Qe, rt, Wn) {
                    for(var Co = Qe.length, Ll = 0, Rl = new Dl(rt); Ll < Co; ++Ll)Qe[Ll] && ++Rl[Qe[Ll] - 1];
                    var Ul, Gl = new Dl(rt);
                    for(Ll = 1; Ll < rt; ++Ll)Gl[Ll] = Gl[Ll - 1] + Rl[Ll - 1] << 1;
                    if (Wn) {
                        Ul = new Dl(1 << rt);
                        var Zl = 15 - rt;
                        for(Ll = 0; Ll < Co; ++Ll)if (Qe[Ll]) for(var Hl = Ll << 4 | Qe[Ll], ql = rt - Qe[Ll], Ql = Gl[Qe[Ll] - 1]++ << ql, Kl = Ql | (1 << ql) - 1; Ql <= Kl; ++Ql)Ul[$l[Ql] >> Zl] = Hl;
                    } else for(Ul = new Dl(Co), Ll = 0; Ll < Co; ++Ll)Qe[Ll] && (Ul[Ll] = $l[Gl[Qe[Ll] - 1]++] >> 15 - Qe[Ll]);
                    return Ul;
                }, lu = new Co(288);
                for(Tc = 0; Tc < 144; ++Tc)lu[Tc] = 8;
                for(Tc = 144; Tc < 256; ++Tc)lu[Tc] = 9;
                for(Tc = 256; Tc < 280; ++Tc)lu[Tc] = 7;
                for(Tc = 280; Tc < 288; ++Tc)lu[Tc] = 8;
                var du = new Co(32);
                for(Tc = 0; Tc < 32; ++Tc)du[Tc] = 5;
                var fu = hMap(lu, 9, 1), yu = hMap(du, 5, 1), max = function(Qe) {
                    for(var rt = Qe[0], Wn = 1; Wn < Qe.length; ++Wn)Qe[Wn] > rt && (rt = Qe[Wn]);
                    return rt;
                }, bits = function(Qe, rt, Wn) {
                    var Co = rt / 8 | 0;
                    return (Qe[Co] | Qe[Co + 1] << 8) >> (7 & rt) & Wn;
                }, bits16 = function(Qe, rt) {
                    var Wn = rt / 8 | 0;
                    return (Qe[Wn] | Qe[Wn + 1] << 8 | Qe[Wn + 2] << 16) >> (7 & rt);
                }, shft = function(Qe) {
                    return (Qe + 7) / 8 | 0;
                }, slc = function(Qe, rt, Wn) {
                    return (null == rt || rt < 0) && (rt = 0), (null == Wn || Wn > Qe.length) && (Wn = Qe.length), new Co(Qe.subarray(rt, Wn));
                }, Eu = [
                    "unexpected EOF",
                    "invalid block type",
                    "invalid length/literal",
                    "invalid distance",
                    "stream finished",
                    "no stream handler",
                    ,
                    "no callback",
                    "invalid UTF-8 data",
                    "extra field too long",
                    "date not in range 1980-2099",
                    "filename too long",
                    "stream finishing",
                    "invalid zip data"
                ], err = function(Qe, rt, Wn) {
                    var Co = new Error(rt || Eu[Qe]);
                    if (Co.code = Qe, Error.captureStackTrace && Error.captureStackTrace(Co, err), !Wn) throw Co;
                    return Co;
                }, inflt = function(Qe, rt, Wn, Dl) {
                    var Ll = Qe.length, Zl = Dl ? Dl.length : 0;
                    if (!Ll || rt.f && !rt.l) return Wn || new Co(0);
                    var ql = !Wn, Ql = ql || 2 != rt.i, $l = rt.i;
                    ql && (Wn = new Co(3 * Ll));
                    var cbuf = function(Qe) {
                        var rt = Wn.length;
                        if (Qe > rt) {
                            var Dl = new Co(Math.max(2 * rt, Qe));
                            Dl.set(Wn), Wn = Dl;
                        }
                    }, Tc = rt.f || 0, tu = rt.p || 0, lu = rt.b || 0, du = rt.l, Eu = rt.d, Tu = rt.m, Lu = rt.n, Zu = 8 * Ll;
                    do {
                        if (!du) {
                            Tc = bits(Qe, tu, 1);
                            var Xu = bits(Qe, tu + 1, 3);
                            if (tu += 3, !Xu) {
                                var Ju = Qe[(cd = shft(tu) + 4) - 4] | Qe[cd - 3] << 8, $u = cd + Ju;
                                if ($u > Ll) {
                                    $l && err(0);
                                    break;
                                }
                                Ql && cbuf(lu + Ju), Wn.set(Qe.subarray(cd, $u), lu), rt.b = lu += Ju, rt.p = tu = 8 * $u, rt.f = Tc;
                                continue;
                            }
                            if (1 == Xu) du = fu, Eu = yu, Tu = 9, Lu = 5;
                            else if (2 == Xu) {
                                var ed = bits(Qe, tu, 31) + 257, td = bits(Qe, tu + 10, 15) + 4, id = ed + bits(Qe, tu + 5, 31) + 1;
                                tu += 14;
                                for(var nd = new Co(id), rd = new Co(19), sd = 0; sd < td; ++sd)rd[Gl[sd]] = bits(Qe, tu + 3 * sd, 7);
                                tu += 3 * td;
                                var ad = max(rd), od = (1 << ad) - 1, ld = hMap(rd, ad, 1);
                                for(sd = 0; sd < id;){
                                    var cd, ud = ld[bits(Qe, tu, od)];
                                    if (tu += 15 & ud, (cd = ud >> 4) < 16) nd[sd++] = cd;
                                    else {
                                        var hd = 0, dd = 0;
                                        for(16 == cd ? (dd = 3 + bits(Qe, tu, 3), tu += 2, hd = nd[sd - 1]) : 17 == cd ? (dd = 3 + bits(Qe, tu, 7), tu += 3) : 18 == cd && (dd = 11 + bits(Qe, tu, 127), tu += 7); dd--;)nd[sd++] = hd;
                                    }
                                }
                                var pd = nd.subarray(0, ed), md = nd.subarray(ed);
                                Tu = max(pd), Lu = max(md), du = hMap(pd, Tu, 1), Eu = hMap(md, Lu, 1);
                            } else err(1);
                            if (tu > Zu) {
                                $l && err(0);
                                break;
                            }
                        }
                        Ql && cbuf(lu + 131072);
                        for(var fd = (1 << Tu) - 1, gd = (1 << Lu) - 1, Ad = tu;; Ad = tu){
                            var yd = (hd = du[bits16(Qe, tu) & fd]) >> 4;
                            if ((tu += 15 & hd) > Zu) {
                                $l && err(0);
                                break;
                            }
                            if (hd || err(2), yd < 256) Wn[lu++] = yd;
                            else {
                                if (256 == yd) {
                                    Ad = tu, du = null;
                                    break;
                                }
                                var vd = yd - 254;
                                if (yd > 264) {
                                    var _d = Rl[sd = yd - 257];
                                    vd = bits(Qe, tu, (1 << _d) - 1) + Hl[sd], tu += _d;
                                }
                                var xd = Eu[bits16(Qe, tu) & gd], bd = xd >> 4;
                                xd || err(3), tu += 15 & xd;
                                md = Kl[bd];
                                if (bd > 3) {
                                    _d = Ul[bd];
                                    md += bits16(Qe, tu) & (1 << _d) - 1, tu += _d;
                                }
                                if (tu > Zu) {
                                    $l && err(0);
                                    break;
                                }
                                Ql && cbuf(lu + 131072);
                                var wd = lu + vd;
                                if (lu < md) {
                                    var Ed = Zl - md, Md = Math.min(md, wd);
                                    for(Ed + lu < 0 && err(3); lu < Md; ++lu)Wn[lu] = Dl[Ed + lu];
                                }
                                for(; lu < wd; ++lu)Wn[lu] = Wn[lu - md];
                            }
                        }
                        rt.l = du, rt.p = Ad, rt.b = lu, rt.f = Tc, du && (Tc = 1, rt.m = Tu, rt.d = Eu, rt.n = Lu);
                    }while (!Tc);
                    return lu != Wn.length && ql ? slc(Wn, 0, lu) : Wn.subarray(0, lu);
                }, Tu = new Co(0), gzs = function(Qe) {
                    31 == Qe[0] && 139 == Qe[1] && 8 == Qe[2] || err(6, "invalid gzip data");
                    var rt = Qe[3], Wn = 10;
                    4 & rt && (Wn += 2 + (Qe[10] | Qe[11] << 8));
                    for(var Co = (rt >> 3 & 1) + (rt >> 4 & 1); Co > 0; Co -= !Qe[Wn++]);
                    return Wn + (2 & rt);
                }, gzl = function(Qe) {
                    var rt = Qe.length;
                    return (Qe[rt - 4] | Qe[rt - 3] << 8 | Qe[rt - 2] << 16 | Qe[rt - 1] << 24) >>> 0;
                }, zls = function(Qe, rt) {
                    return (8 != (15 & Qe[0]) || Qe[0] >> 4 > 7 || (Qe[0] << 8 | Qe[1]) % 31) && err(6, "invalid zlib data"), (Qe[1] >> 5 & 1) == +!rt && err(6, "invalid zlib data: " + (32 & Qe[1] ? "need" : "unexpected") + " dictionary"), 2 + (Qe[1] >> 3 & 4);
                };
                function inflateSync(Qe, rt) {
                    return inflt(Qe, {
                        i: 2
                    }, rt && rt.out, rt && rt.dictionary);
                }
                function gunzipSync(Qe, rt) {
                    var Wn = gzs(Qe);
                    return Wn + 8 > Qe.length && err(6, "invalid gzip data"), inflt(Qe.subarray(Wn, -8), {
                        i: 2
                    }, rt && rt.out || new Co(gzl(Qe)), rt && rt.dictionary);
                }
                function unzlibSync(Qe, rt) {
                    return inflt(Qe.subarray(zls(Qe, rt && rt.dictionary), -4), {
                        i: 2
                    }, rt && rt.out, rt && rt.dictionary);
                }
                function decompressSync(Qe, rt) {
                    return 31 == Qe[0] && 139 == Qe[1] && 8 == Qe[2] ? gunzipSync(Qe, rt) : 8 != (15 & Qe[0]) || Qe[0] >> 4 > 7 || (Qe[0] << 8 | Qe[1]) % 31 ? inflateSync(Qe, rt) : unzlibSync(Qe, rt);
                }
                var Lu = "undefined" != typeof TextDecoder && new TextDecoder;
                try {
                    Lu.decode(Tu, {
                        stream: !0
                    });
                } catch (Zu) {}
                "function" == typeof queueMicrotask ? queueMicrotask : "function" == typeof setTimeout && setTimeout;
            },
            2614: function(Qe) {
                Qe.exports = function() {
                    "use strict";
                    function createCommonjsModule(Qe, rt) {
                        return Qe(rt = {
                            exports: {}
                        }, rt.exports), rt.exports;
                    }
                    var Qe = createCommonjsModule(function(Qe) {
                        var rt = Qe.exports = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")();
                        "number" == typeof __g && (__g = rt);
                    }), rt = createCommonjsModule(function(Qe) {
                        var rt = Qe.exports = {
                            version: "2.6.5"
                        };
                        "number" == typeof __e && (__e = rt);
                    }), Wn = (rt.version, function(Qe) {
                        return "object" === typeof Qe ? null !== Qe : "function" === typeof Qe;
                    }), _anObject = function(Qe) {
                        if (!Wn(Qe)) throw TypeError(Qe + " is not an object!");
                        return Qe;
                    }, _fails = function(Qe) {
                        try {
                            return !!Qe();
                        } catch (rt) {
                            return !0;
                        }
                    }, Co = !_fails(function() {
                        return 7 != Object.defineProperty({}, "a", {
                            get: function() {
                                return 7;
                            }
                        }).a;
                    }), Dl = Qe.document, Ll = Wn(Dl) && Wn(Dl.createElement), _domCreate = function(Qe) {
                        return Ll ? Dl.createElement(Qe) : {};
                    }, Rl = !Co && !_fails(function() {
                        return 7 != Object.defineProperty(_domCreate("div"), "a", {
                            get: function() {
                                return 7;
                            }
                        }).a;
                    }), _toPrimitive = function(Qe, rt) {
                        if (!Wn(Qe)) return Qe;
                        var Co, Dl;
                        if (rt && "function" == typeof (Co = Qe.toString) && !Wn(Dl = Co.call(Qe))) return Dl;
                        if ("function" == typeof (Co = Qe.valueOf) && !Wn(Dl = Co.call(Qe))) return Dl;
                        if (!rt && "function" == typeof (Co = Qe.toString) && !Wn(Dl = Co.call(Qe))) return Dl;
                        throw TypeError("Can't convert object to primitive value");
                    }, Ul = Object.defineProperty, Gl = {
                        f: Co ? Object.defineProperty : function(Qe, rt, Wn) {
                            if (_anObject(Qe), rt = _toPrimitive(rt, !0), _anObject(Wn), Rl) try {
                                return Ul(Qe, rt, Wn);
                            } catch (Co) {}
                            if ("get" in Wn || "set" in Wn) throw TypeError("Accessors not supported!");
                            return "value" in Wn && (Qe[rt] = Wn.value), Qe;
                        }
                    }, _propertyDesc = function(Qe, rt) {
                        return {
                            enumerable: !(1 & Qe),
                            configurable: !(2 & Qe),
                            writable: !(4 & Qe),
                            value: rt
                        };
                    }, Zl = Co ? function(Qe, rt, Wn) {
                        return Gl.f(Qe, rt, _propertyDesc(1, Wn));
                    } : function(Qe, rt, Wn) {
                        return Qe[rt] = Wn, Qe;
                    }, Hl = {}.hasOwnProperty, _has = function(Qe, rt) {
                        return Hl.call(Qe, rt);
                    }, ql = 0, Ql = Math.random(), _uid = function(Qe) {
                        return "Symbol(".concat(void 0 === Qe ? "" : Qe, ")_", (++ql + Ql).toString(36));
                    }, Kl = !1, $l = createCommonjsModule(function(Wn) {
                        var Co = "__core-js_shared__", Dl = Qe[Co] || (Qe[Co] = {});
                        (Wn.exports = function(Qe, rt) {
                            return Dl[Qe] || (Dl[Qe] = void 0 !== rt ? rt : {});
                        })("versions", []).push({
                            version: rt.version,
                            mode: Kl ? "pure" : "global",
                            copyright: "\xa9 2019 Denis Pushkarev (zloirock.ru)"
                        });
                    }), Tc = $l("native-function-to-string", Function.toString), tu = createCommonjsModule(function(Wn) {
                        var Co = _uid("src"), Dl = "toString", Ll = ("" + Tc).split(Dl);
                        rt.inspectSource = function(Qe) {
                            return Tc.call(Qe);
                        }, (Wn.exports = function(rt, Wn, Dl, Rl) {
                            var Ul = "function" == typeof Dl;
                            Ul && (_has(Dl, "name") || Zl(Dl, "name", Wn)), rt[Wn] !== Dl && (Ul && (_has(Dl, Co) || Zl(Dl, Co, rt[Wn] ? "" + rt[Wn] : Ll.join(String(Wn)))), rt === Qe ? rt[Wn] = Dl : Rl ? rt[Wn] ? rt[Wn] = Dl : Zl(rt, Wn, Dl) : (delete rt[Wn], Zl(rt, Wn, Dl)));
                        })(Function.prototype, Dl, function() {
                            return "function" == typeof this && this[Co] || Tc.call(this);
                        });
                    }), _aFunction = function(Qe) {
                        if ("function" != typeof Qe) throw TypeError(Qe + " is not a function!");
                        return Qe;
                    }, _ctx = function(Qe, rt, Wn) {
                        if (_aFunction(Qe), void 0 === rt) return Qe;
                        switch(Wn){
                            case 1:
                                return function(Wn) {
                                    return Qe.call(rt, Wn);
                                };
                            case 2:
                                return function(Wn, Co) {
                                    return Qe.call(rt, Wn, Co);
                                };
                            case 3:
                                return function(Wn, Co, Dl) {
                                    return Qe.call(rt, Wn, Co, Dl);
                                };
                        }
                        return function() {
                            return Qe.apply(rt, arguments);
                        };
                    }, lu = "prototype", $export = function(Wn, Co, Dl) {
                        var Ll, Rl, Ul, Gl, Hl = Wn & $export.F, ql = Wn & $export.G, Ql = Wn & $export.S, Kl = Wn & $export.P, $l = Wn & $export.B, Tc = ql ? Qe : Ql ? Qe[Co] || (Qe[Co] = {}) : (Qe[Co] || {})[lu], du = ql ? rt : rt[Co] || (rt[Co] = {}), fu = du[lu] || (du[lu] = {});
                        for(Ll in ql && (Dl = Co), Dl)Ul = ((Rl = !Hl && Tc && void 0 !== Tc[Ll]) ? Tc : Dl)[Ll], Gl = $l && Rl ? _ctx(Ul, Qe) : Kl && "function" == typeof Ul ? _ctx(Function.call, Ul) : Ul, Tc && tu(Tc, Ll, Ul, Wn & $export.U), du[Ll] != Ul && Zl(du, Ll, Gl), Kl && fu[Ll] != Ul && (fu[Ll] = Ul);
                    };
                    Qe.core = rt, $export.F = 1, $export.G = 2, $export.S = 4, $export.P = 8, $export.B = 16, $export.W = 32, $export.U = 64, $export.R = 128;
                    var du, fu = $export, yu = Math.ceil, Eu = Math.floor, _toInteger = function(Qe) {
                        return isNaN(Qe = +Qe) ? 0 : (Qe > 0 ? Eu : yu)(Qe);
                    }, _defined = function(Qe) {
                        if (void 0 == Qe) throw TypeError("Can't call method on  " + Qe);
                        return Qe;
                    }, Tu = (du = !1, function(Qe, rt) {
                        var Wn, Co, Dl = String(_defined(Qe)), Ll = _toInteger(rt), Rl = Dl.length;
                        return Ll < 0 || Ll >= Rl ? du ? "" : void 0 : (Wn = Dl.charCodeAt(Ll)) < 55296 || Wn > 56319 || Ll + 1 === Rl || (Co = Dl.charCodeAt(Ll + 1)) < 56320 || Co > 57343 ? du ? Dl.charAt(Ll) : Wn : du ? Dl.slice(Ll, Ll + 2) : Co - 56320 + (Wn - 55296 << 10) + 65536;
                    });
                    fu(fu.P, "String", {
                        codePointAt: function(Qe) {
                            return Tu(this, Qe);
                        }
                    }), rt.String.codePointAt;
                    var Lu = Math.max, Zu = Math.min, _toAbsoluteIndex = function(Qe, rt) {
                        return (Qe = _toInteger(Qe)) < 0 ? Lu(Qe + rt, 0) : Zu(Qe, rt);
                    }, Xu = String.fromCharCode, Ju = String.fromCodePoint;
                    fu(fu.S + fu.F * (!!Ju && 1 != Ju.length), "String", {
                        fromCodePoint: function(Qe) {
                            for(var rt, Wn = arguments, Co = [], Dl = arguments.length, Ll = 0; Dl > Ll;){
                                if (rt = +Wn[Ll++], _toAbsoluteIndex(rt, 1114111) !== rt) throw RangeError(rt + " is not a valid code point");
                                Co.push(rt < 65536 ? Xu(rt) : Xu(55296 + ((rt -= 65536) >> 10), rt % 1024 + 56320));
                            }
                            return Co.join("");
                        }
                    }), rt.String.fromCodePoint;
                    var $u, ed, td, id, nd, rd, sd, ad, od, ld, cd, ud, hd, dd, pd = {
                        Space_Separator: /[\u1680\u2000-\u200A\u202F\u205F\u3000]/,
                        ID_Start: /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312E\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FEA\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF2D-\uDF4A\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD804[\uDC03-\uDC37\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDF00-\uDF19]|\uD806[\uDCA0-\uDCDF\uDCFF\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE83\uDE86-\uDE89\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50\uDF93-\uDF9F\uDFE0\uDFE1]|\uD821[\uDC00-\uDFEC]|\uD822[\uDC00-\uDEF2]|\uD82C[\uDC00-\uDD1E\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD87E[\uDC00-\uDE1D]/,
                        ID_Continue: /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0300-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u0483-\u0487\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u05D0-\u05EA\u05F0-\u05F2\u0610-\u061A\u0620-\u0669\u066E-\u06D3\u06D5-\u06DC\u06DF-\u06E8\u06EA-\u06FC\u06FF\u0710-\u074A\u074D-\u07B1\u07C0-\u07F5\u07FA\u0800-\u082D\u0840-\u085B\u0860-\u086A\u08A0-\u08B4\u08B6-\u08BD\u08D4-\u08E1\u08E3-\u0963\u0966-\u096F\u0971-\u0983\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BC-\u09C4\u09C7\u09C8\u09CB-\u09CE\u09D7\u09DC\u09DD\u09DF-\u09E3\u09E6-\u09F1\u09FC\u0A01-\u0A03\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A59-\u0A5C\u0A5E\u0A66-\u0A75\u0A81-\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABC-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AD0\u0AE0-\u0AE3\u0AE6-\u0AEF\u0AF9-\u0AFF\u0B01-\u0B03\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3C-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B5C\u0B5D\u0B5F-\u0B63\u0B66-\u0B6F\u0B71\u0B82\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD0\u0BD7\u0BE6-\u0BEF\u0C00-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C58-\u0C5A\u0C60-\u0C63\u0C66-\u0C6F\u0C80-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBC-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CDE\u0CE0-\u0CE3\u0CE6-\u0CEF\u0CF1\u0CF2\u0D00-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D44\u0D46-\u0D48\u0D4A-\u0D4E\u0D54-\u0D57\u0D5F-\u0D63\u0D66-\u0D6F\u0D7A-\u0D7F\u0D82\u0D83\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E01-\u0E3A\u0E40-\u0E4E\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB9\u0EBB-\u0EBD\u0EC0-\u0EC4\u0EC6\u0EC8-\u0ECD\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E-\u0F47\u0F49-\u0F6C\u0F71-\u0F84\u0F86-\u0F97\u0F99-\u0FBC\u0FC6\u1000-\u1049\u1050-\u109D\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u135D-\u135F\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1714\u1720-\u1734\u1740-\u1753\u1760-\u176C\u176E-\u1770\u1772\u1773\u1780-\u17D3\u17D7\u17DC\u17DD\u17E0-\u17E9\u180B-\u180D\u1810-\u1819\u1820-\u1877\u1880-\u18AA\u18B0-\u18F5\u1900-\u191E\u1920-\u192B\u1930-\u193B\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19D9\u1A00-\u1A1B\u1A20-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AA7\u1AB0-\u1ABD\u1B00-\u1B4B\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1BF3\u1C00-\u1C37\u1C40-\u1C49\u1C4D-\u1C7D\u1C80-\u1C88\u1CD0-\u1CD2\u1CD4-\u1CF9\u1D00-\u1DF9\u1DFB-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u203F\u2040\u2054\u2071\u207F\u2090-\u209C\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D7F-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2DE0-\u2DFF\u2E2F\u3005-\u3007\u3021-\u302F\u3031-\u3035\u3038-\u303C\u3041-\u3096\u3099\u309A\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312E\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FEA\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66F\uA674-\uA67D\uA67F-\uA6F1\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA827\uA840-\uA873\uA880-\uA8C5\uA8D0-\uA8D9\uA8E0-\uA8F7\uA8FB\uA8FD\uA900-\uA92D\uA930-\uA953\uA960-\uA97C\uA980-\uA9C0\uA9CF-\uA9D9\uA9E0-\uA9FE\uAA00-\uAA36\uAA40-\uAA4D\uAA50-\uAA59\uAA60-\uAA76\uAA7A-\uAAC2\uAADB-\uAADD\uAAE0-\uAAEF\uAAF2-\uAAF6\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABEA\uABEC\uABED\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE00-\uFE0F\uFE20-\uFE2F\uFE33\uFE34\uFE4D-\uFE4F\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF3F\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDDFD\uDE80-\uDE9C\uDEA0-\uDED0\uDEE0\uDF00-\uDF1F\uDF2D-\uDF4A\uDF50-\uDF7A\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCA0-\uDCA9\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00-\uDE03\uDE05\uDE06\uDE0C-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE38-\uDE3A\uDE3F\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE6\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD804[\uDC00-\uDC46\uDC66-\uDC6F\uDC7F-\uDCBA\uDCD0-\uDCE8\uDCF0-\uDCF9\uDD00-\uDD34\uDD36-\uDD3F\uDD50-\uDD73\uDD76\uDD80-\uDDC4\uDDCA-\uDDCC\uDDD0-\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE37\uDE3E\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEEA\uDEF0-\uDEF9\uDF00-\uDF03\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3C-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF50\uDF57\uDF5D-\uDF63\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC00-\uDC4A\uDC50-\uDC59\uDC80-\uDCC5\uDCC7\uDCD0-\uDCD9\uDD80-\uDDB5\uDDB8-\uDDC0\uDDD8-\uDDDD\uDE00-\uDE40\uDE44\uDE50-\uDE59\uDE80-\uDEB7\uDEC0-\uDEC9\uDF00-\uDF19\uDF1D-\uDF2B\uDF30-\uDF39]|\uD806[\uDCA0-\uDCE9\uDCFF\uDE00-\uDE3E\uDE47\uDE50-\uDE83\uDE86-\uDE99\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC36\uDC38-\uDC40\uDC50-\uDC59\uDC72-\uDC8F\uDC92-\uDCA7\uDCA9-\uDCB6\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD47\uDD50-\uDD59]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE60-\uDE69\uDED0-\uDEED\uDEF0-\uDEF4\uDF00-\uDF36\uDF40-\uDF43\uDF50-\uDF59\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50-\uDF7E\uDF8F-\uDF9F\uDFE0\uDFE1]|\uD821[\uDC00-\uDFEC]|\uD822[\uDC00-\uDEF2]|\uD82C[\uDC00-\uDD1E\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99\uDC9D\uDC9E]|\uD834[\uDD65-\uDD69\uDD6D-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB\uDFCE-\uDFFF]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A]|\uD83A[\uDC00-\uDCC4\uDCD0-\uDCD6\uDD00-\uDD4A\uDD50-\uDD59]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD87E[\uDC00-\uDE1D]|\uDB40[\uDD00-\uDDEF]/
                    }, md = {
                        isSpaceSeparator: function(Qe) {
                            return "string" === typeof Qe && pd.Space_Separator.test(Qe);
                        },
                        isIdStartChar: function(Qe) {
                            return "string" === typeof Qe && (Qe >= "a" && Qe <= "z" || Qe >= "A" && Qe <= "Z" || "$" === Qe || "_" === Qe || pd.ID_Start.test(Qe));
                        },
                        isIdContinueChar: function(Qe) {
                            return "string" === typeof Qe && (Qe >= "a" && Qe <= "z" || Qe >= "A" && Qe <= "Z" || Qe >= "0" && Qe <= "9" || "$" === Qe || "_" === Qe || "\u200C" === Qe || "\u200D" === Qe || pd.ID_Continue.test(Qe));
                        },
                        isDigit: function(Qe) {
                            return "string" === typeof Qe && /[0-9]/.test(Qe);
                        },
                        isHexDigit: function(Qe) {
                            return "string" === typeof Qe && /[0-9A-Fa-f]/.test(Qe);
                        }
                    }, parse = function(Qe, rt) {
                        $u = String(Qe), ed = "start", td = [], id = 0, nd = 1, rd = 0, sd = void 0, ad = void 0, od = void 0;
                        do sd = lex(), gd[ed]();
                        while ("eof" !== sd.type);
                        return "function" === typeof rt ? internalize({
                            "": od
                        }, "", rt) : od;
                    };
                    function internalize(Qe, rt, Wn) {
                        var Co = Qe[rt];
                        if (null != Co && "object" === typeof Co) {
                            if (Array.isArray(Co)) for(var Dl = 0; Dl < Co.length; Dl++){
                                var Ll = String(Dl), Rl = internalize(Co, Ll, Wn);
                                void 0 === Rl ? delete Co[Ll] : Object.defineProperty(Co, Ll, {
                                    value: Rl,
                                    writable: !0,
                                    enumerable: !0,
                                    configurable: !0
                                });
                            }
                            else for(var Ul in Co){
                                var Gl = internalize(Co, Ul, Wn);
                                void 0 === Gl ? delete Co[Ul] : Object.defineProperty(Co, Ul, {
                                    value: Gl,
                                    writable: !0,
                                    enumerable: !0,
                                    configurable: !0
                                });
                            }
                        }
                        return Wn.call(Qe, rt, Co);
                    }
                    function lex() {
                        for(ld = "default", cd = "", ud = !1, hd = 1;;){
                            dd = peek();
                            var Qe = fd[ld]();
                            if (Qe) return Qe;
                        }
                    }
                    function peek() {
                        if ($u[id]) return String.fromCodePoint($u.codePointAt(id));
                    }
                    function read() {
                        var Qe = peek();
                        return "\n" === Qe ? (nd++, rd = 0) : Qe ? rd += Qe.length : rd++, Qe && (id += Qe.length), Qe;
                    }
                    var fd = {
                        default: function() {
                            switch(dd){
                                case "	":
                                case "\v":
                                case "\f":
                                case " ":
                                case "\xa0":
                                case "\uFEFF":
                                case "\n":
                                case "\r":
                                case "\u2028":
                                case "\u2029":
                                    return void read();
                                case "/":
                                    return read(), void (ld = "comment");
                                case void 0:
                                    return read(), newToken("eof");
                            }
                            if (!md.isSpaceSeparator(dd)) return fd[ed]();
                            read();
                        },
                        comment: function() {
                            switch(dd){
                                case "*":
                                    return read(), void (ld = "multiLineComment");
                                case "/":
                                    return read(), void (ld = "singleLineComment");
                            }
                            throw invalidChar(read());
                        },
                        multiLineComment: function() {
                            switch(dd){
                                case "*":
                                    return read(), void (ld = "multiLineCommentAsterisk");
                                case void 0:
                                    throw invalidChar(read());
                            }
                            read();
                        },
                        multiLineCommentAsterisk: function() {
                            switch(dd){
                                case "*":
                                    return void read();
                                case "/":
                                    return read(), void (ld = "default");
                                case void 0:
                                    throw invalidChar(read());
                            }
                            read(), ld = "multiLineComment";
                        },
                        singleLineComment: function() {
                            switch(dd){
                                case "\n":
                                case "\r":
                                case "\u2028":
                                case "\u2029":
                                    return read(), void (ld = "default");
                                case void 0:
                                    return read(), newToken("eof");
                            }
                            read();
                        },
                        value: function() {
                            switch(dd){
                                case "{":
                                case "[":
                                    return newToken("punctuator", read());
                                case "n":
                                    return read(), literal("ull"), newToken("null", null);
                                case "t":
                                    return read(), literal("rue"), newToken("boolean", !0);
                                case "f":
                                    return read(), literal("alse"), newToken("boolean", !1);
                                case "-":
                                case "+":
                                    return "-" === read() && (hd = -1), void (ld = "sign");
                                case ".":
                                    return cd = read(), void (ld = "decimalPointLeading");
                                case "0":
                                    return cd = read(), void (ld = "zero");
                                case "1":
                                case "2":
                                case "3":
                                case "4":
                                case "5":
                                case "6":
                                case "7":
                                case "8":
                                case "9":
                                    return cd = read(), void (ld = "decimalInteger");
                                case "I":
                                    return read(), literal("nfinity"), newToken("numeric", 1 / 0);
                                case "N":
                                    return read(), literal("aN"), newToken("numeric", NaN);
                                case '"':
                                case "'":
                                    return ud = '"' === read(), cd = "", void (ld = "string");
                            }
                            throw invalidChar(read());
                        },
                        identifierNameStartEscape: function() {
                            if ("u" !== dd) throw invalidChar(read());
                            read();
                            var Qe = unicodeEscape();
                            switch(Qe){
                                case "$":
                                case "_":
                                    break;
                                default:
                                    if (!md.isIdStartChar(Qe)) throw invalidIdentifier();
                            }
                            cd += Qe, ld = "identifierName";
                        },
                        identifierName: function() {
                            switch(dd){
                                case "$":
                                case "_":
                                case "\u200C":
                                case "\u200D":
                                    return void (cd += read());
                                case "\\":
                                    return read(), void (ld = "identifierNameEscape");
                            }
                            if (!md.isIdContinueChar(dd)) return newToken("identifier", cd);
                            cd += read();
                        },
                        identifierNameEscape: function() {
                            if ("u" !== dd) throw invalidChar(read());
                            read();
                            var Qe = unicodeEscape();
                            switch(Qe){
                                case "$":
                                case "_":
                                case "\u200C":
                                case "\u200D":
                                    break;
                                default:
                                    if (!md.isIdContinueChar(Qe)) throw invalidIdentifier();
                            }
                            cd += Qe, ld = "identifierName";
                        },
                        sign: function() {
                            switch(dd){
                                case ".":
                                    return cd = read(), void (ld = "decimalPointLeading");
                                case "0":
                                    return cd = read(), void (ld = "zero");
                                case "1":
                                case "2":
                                case "3":
                                case "4":
                                case "5":
                                case "6":
                                case "7":
                                case "8":
                                case "9":
                                    return cd = read(), void (ld = "decimalInteger");
                                case "I":
                                    return read(), literal("nfinity"), newToken("numeric", hd * (1 / 0));
                                case "N":
                                    return read(), literal("aN"), newToken("numeric", NaN);
                            }
                            throw invalidChar(read());
                        },
                        zero: function() {
                            switch(dd){
                                case ".":
                                    return cd += read(), void (ld = "decimalPoint");
                                case "e":
                                case "E":
                                    return cd += read(), void (ld = "decimalExponent");
                                case "x":
                                case "X":
                                    return cd += read(), void (ld = "hexadecimal");
                            }
                            return newToken("numeric", 0 * hd);
                        },
                        decimalInteger: function() {
                            switch(dd){
                                case ".":
                                    return cd += read(), void (ld = "decimalPoint");
                                case "e":
                                case "E":
                                    return cd += read(), void (ld = "decimalExponent");
                            }
                            if (!md.isDigit(dd)) return newToken("numeric", hd * Number(cd));
                            cd += read();
                        },
                        decimalPointLeading: function() {
                            if (md.isDigit(dd)) return cd += read(), void (ld = "decimalFraction");
                            throw invalidChar(read());
                        },
                        decimalPoint: function() {
                            switch(dd){
                                case "e":
                                case "E":
                                    return cd += read(), void (ld = "decimalExponent");
                            }
                            return md.isDigit(dd) ? (cd += read(), void (ld = "decimalFraction")) : newToken("numeric", hd * Number(cd));
                        },
                        decimalFraction: function() {
                            switch(dd){
                                case "e":
                                case "E":
                                    return cd += read(), void (ld = "decimalExponent");
                            }
                            if (!md.isDigit(dd)) return newToken("numeric", hd * Number(cd));
                            cd += read();
                        },
                        decimalExponent: function() {
                            switch(dd){
                                case "+":
                                case "-":
                                    return cd += read(), void (ld = "decimalExponentSign");
                            }
                            if (md.isDigit(dd)) return cd += read(), void (ld = "decimalExponentInteger");
                            throw invalidChar(read());
                        },
                        decimalExponentSign: function() {
                            if (md.isDigit(dd)) return cd += read(), void (ld = "decimalExponentInteger");
                            throw invalidChar(read());
                        },
                        decimalExponentInteger: function() {
                            if (!md.isDigit(dd)) return newToken("numeric", hd * Number(cd));
                            cd += read();
                        },
                        hexadecimal: function() {
                            if (md.isHexDigit(dd)) return cd += read(), void (ld = "hexadecimalInteger");
                            throw invalidChar(read());
                        },
                        hexadecimalInteger: function() {
                            if (!md.isHexDigit(dd)) return newToken("numeric", hd * Number(cd));
                            cd += read();
                        },
                        string: function() {
                            switch(dd){
                                case "\\":
                                    return read(), void (cd += escape());
                                case '"':
                                    return ud ? (read(), newToken("string", cd)) : void (cd += read());
                                case "'":
                                    return ud ? void (cd += read()) : (read(), newToken("string", cd));
                                case "\n":
                                case "\r":
                                    throw invalidChar(read());
                                case "\u2028":
                                case "\u2029":
                                    separatorChar(dd);
                                    break;
                                case void 0:
                                    throw invalidChar(read());
                            }
                            cd += read();
                        },
                        start: function() {
                            switch(dd){
                                case "{":
                                case "[":
                                    return newToken("punctuator", read());
                            }
                            ld = "value";
                        },
                        beforePropertyName: function() {
                            switch(dd){
                                case "$":
                                case "_":
                                    return cd = read(), void (ld = "identifierName");
                                case "\\":
                                    return read(), void (ld = "identifierNameStartEscape");
                                case "}":
                                    return newToken("punctuator", read());
                                case '"':
                                case "'":
                                    return ud = '"' === read(), void (ld = "string");
                            }
                            if (md.isIdStartChar(dd)) return cd += read(), void (ld = "identifierName");
                            throw invalidChar(read());
                        },
                        afterPropertyName: function() {
                            if (":" === dd) return newToken("punctuator", read());
                            throw invalidChar(read());
                        },
                        beforePropertyValue: function() {
                            ld = "value";
                        },
                        afterPropertyValue: function() {
                            switch(dd){
                                case ",":
                                case "}":
                                    return newToken("punctuator", read());
                            }
                            throw invalidChar(read());
                        },
                        beforeArrayValue: function() {
                            if ("]" === dd) return newToken("punctuator", read());
                            ld = "value";
                        },
                        afterArrayValue: function() {
                            switch(dd){
                                case ",":
                                case "]":
                                    return newToken("punctuator", read());
                            }
                            throw invalidChar(read());
                        },
                        end: function() {
                            throw invalidChar(read());
                        }
                    };
                    function newToken(Qe, rt) {
                        return {
                            type: Qe,
                            value: rt,
                            line: nd,
                            column: rd
                        };
                    }
                    function literal(Qe) {
                        for(var rt = 0, Wn = Qe; rt < Wn.length; rt += 1){
                            var Co = Wn[rt];
                            if (peek() !== Co) throw invalidChar(read());
                            read();
                        }
                    }
                    function escape() {
                        switch(peek()){
                            case "b":
                                return read(), "\b";
                            case "f":
                                return read(), "\f";
                            case "n":
                                return read(), "\n";
                            case "r":
                                return read(), "\r";
                            case "t":
                                return read(), "	";
                            case "v":
                                return read(), "\v";
                            case "0":
                                if (read(), md.isDigit(peek())) throw invalidChar(read());
                                return "\x00";
                            case "x":
                                return read(), hexEscape();
                            case "u":
                                return read(), unicodeEscape();
                            case "\n":
                            case "\u2028":
                            case "\u2029":
                                return read(), "";
                            case "\r":
                                return read(), "\n" === peek() && read(), "";
                            case "1":
                            case "2":
                            case "3":
                            case "4":
                            case "5":
                            case "6":
                            case "7":
                            case "8":
                            case "9":
                            case void 0:
                                throw invalidChar(read());
                        }
                        return read();
                    }
                    function hexEscape() {
                        var Qe = "", rt = peek();
                        if (!md.isHexDigit(rt)) throw invalidChar(read());
                        if (Qe += read(), rt = peek(), !md.isHexDigit(rt)) throw invalidChar(read());
                        return Qe += read(), String.fromCodePoint(parseInt(Qe, 16));
                    }
                    function unicodeEscape() {
                        for(var Qe = "", rt = 4; rt-- > 0;){
                            var Wn = peek();
                            if (!md.isHexDigit(Wn)) throw invalidChar(read());
                            Qe += read();
                        }
                        return String.fromCodePoint(parseInt(Qe, 16));
                    }
                    var gd = {
                        start: function() {
                            if ("eof" === sd.type) throw invalidEOF();
                            push();
                        },
                        beforePropertyName: function() {
                            switch(sd.type){
                                case "identifier":
                                case "string":
                                    return ad = sd.value, void (ed = "afterPropertyName");
                                case "punctuator":
                                    return void pop();
                                case "eof":
                                    throw invalidEOF();
                            }
                        },
                        afterPropertyName: function() {
                            if ("eof" === sd.type) throw invalidEOF();
                            ed = "beforePropertyValue";
                        },
                        beforePropertyValue: function() {
                            if ("eof" === sd.type) throw invalidEOF();
                            push();
                        },
                        beforeArrayValue: function() {
                            if ("eof" === sd.type) throw invalidEOF();
                            "punctuator" !== sd.type || "]" !== sd.value ? push() : pop();
                        },
                        afterPropertyValue: function() {
                            if ("eof" === sd.type) throw invalidEOF();
                            switch(sd.value){
                                case ",":
                                    return void (ed = "beforePropertyName");
                                case "}":
                                    pop();
                            }
                        },
                        afterArrayValue: function() {
                            if ("eof" === sd.type) throw invalidEOF();
                            switch(sd.value){
                                case ",":
                                    return void (ed = "beforeArrayValue");
                                case "]":
                                    pop();
                            }
                        },
                        end: function() {}
                    };
                    function push() {
                        var Qe;
                        switch(sd.type){
                            case "punctuator":
                                switch(sd.value){
                                    case "{":
                                        Qe = {};
                                        break;
                                    case "[":
                                        Qe = [];
                                }
                                break;
                            case "null":
                            case "boolean":
                            case "numeric":
                            case "string":
                                Qe = sd.value;
                        }
                        if (void 0 === od) od = Qe;
                        else {
                            var rt = td[td.length - 1];
                            Array.isArray(rt) ? rt.push(Qe) : Object.defineProperty(rt, ad, {
                                value: Qe,
                                writable: !0,
                                enumerable: !0,
                                configurable: !0
                            });
                        }
                        if (null !== Qe && "object" === typeof Qe) td.push(Qe), ed = Array.isArray(Qe) ? "beforeArrayValue" : "beforePropertyName";
                        else {
                            var Wn = td[td.length - 1];
                            ed = null == Wn ? "end" : Array.isArray(Wn) ? "afterArrayValue" : "afterPropertyValue";
                        }
                    }
                    function pop() {
                        td.pop();
                        var Qe = td[td.length - 1];
                        ed = null == Qe ? "end" : Array.isArray(Qe) ? "afterArrayValue" : "afterPropertyValue";
                    }
                    function invalidChar(Qe) {
                        return syntaxError(void 0 === Qe ? "JSON5: invalid end of input at " + nd + ":" + rd : "JSON5: invalid character '" + formatChar(Qe) + "' at " + nd + ":" + rd);
                    }
                    function invalidEOF() {
                        return syntaxError("JSON5: invalid end of input at " + nd + ":" + rd);
                    }
                    function invalidIdentifier() {
                        return syntaxError("JSON5: invalid identifier character at " + nd + ":" + (rd -= 5));
                    }
                    function separatorChar(Qe) {
                        console.warn("JSON5: '" + formatChar(Qe) + "' in strings is not valid ECMAScript; consider escaping");
                    }
                    function formatChar(Qe) {
                        var rt = {
                            "'": "\\'",
                            '"': '\\"',
                            "\\": "\\\\",
                            "\b": "\\b",
                            "\f": "\\f",
                            "\n": "\\n",
                            "\r": "\\r",
                            "	": "\\t",
                            "\v": "\\v",
                            "\x00": "\\0",
                            "\u2028": "\\u2028",
                            "\u2029": "\\u2029"
                        };
                        if (rt[Qe]) return rt[Qe];
                        if (Qe < " ") {
                            var Wn = Qe.charCodeAt(0).toString(16);
                            return "\\x" + ("00" + Wn).substring(Wn.length);
                        }
                        return Qe;
                    }
                    function syntaxError(Qe) {
                        var rt = new SyntaxError(Qe);
                        return rt.lineNumber = nd, rt.columnNumber = rd, rt;
                    }
                    return {
                        parse: parse,
                        stringify: function(Qe, rt, Wn) {
                            var Co, Dl, Ll, Rl = [], Ul = "", Gl = "";
                            if (null == rt || "object" !== typeof rt || Array.isArray(rt) || (Wn = rt.space, Ll = rt.quote, rt = rt.replacer), "function" === typeof rt) Dl = rt;
                            else if (Array.isArray(rt)) {
                                Co = [];
                                for(var Zl = 0, Hl = rt; Zl < Hl.length; Zl += 1){
                                    var ql = Hl[Zl], Ql = void 0;
                                    "string" === typeof ql ? Ql = ql : ("number" === typeof ql || ql instanceof String || ql instanceof Number) && (Ql = String(ql)), void 0 !== Ql && Co.indexOf(Ql) < 0 && Co.push(Ql);
                                }
                            }
                            return Wn instanceof Number ? Wn = Number(Wn) : Wn instanceof String && (Wn = String(Wn)), "number" === typeof Wn ? Wn > 0 && (Wn = Math.min(10, Math.floor(Wn)), Gl = "          ".substr(0, Wn)) : "string" === typeof Wn && (Gl = Wn.substr(0, 10)), serializeProperty("", {
                                "": Qe
                            });
                            function serializeProperty(Qe, rt) {
                                var Wn = rt[Qe];
                                switch(null != Wn && ("function" === typeof Wn.toJSON5 ? Wn = Wn.toJSON5(Qe) : "function" === typeof Wn.toJSON && (Wn = Wn.toJSON(Qe))), Dl && (Wn = Dl.call(rt, Qe, Wn)), Wn instanceof Number ? Wn = Number(Wn) : Wn instanceof String ? Wn = String(Wn) : Wn instanceof Boolean && (Wn = Wn.valueOf()), Wn){
                                    case null:
                                        return "null";
                                    case !0:
                                        return "true";
                                    case !1:
                                        return "false";
                                }
                                return "string" === typeof Wn ? quoteString(Wn, !1) : "number" === typeof Wn ? String(Wn) : "object" === typeof Wn ? Array.isArray(Wn) ? serializeArray(Wn) : serializeObject(Wn) : void 0;
                            }
                            function quoteString(Qe) {
                                for(var rt = {
                                    "'": .1,
                                    '"': .2
                                }, Wn = {
                                    "'": "\\'",
                                    '"': '\\"',
                                    "\\": "\\\\",
                                    "\b": "\\b",
                                    "\f": "\\f",
                                    "\n": "\\n",
                                    "\r": "\\r",
                                    "	": "\\t",
                                    "\v": "\\v",
                                    "\x00": "\\0",
                                    "\u2028": "\\u2028",
                                    "\u2029": "\\u2029"
                                }, Co = "", Dl = 0; Dl < Qe.length; Dl++){
                                    var Rl = Qe[Dl];
                                    switch(Rl){
                                        case "'":
                                        case '"':
                                            rt[Rl]++, Co += Rl;
                                            continue;
                                        case "\x00":
                                            if (md.isDigit(Qe[Dl + 1])) {
                                                Co += "\\x00";
                                                continue;
                                            }
                                    }
                                    if (Wn[Rl]) Co += Wn[Rl];
                                    else if (Rl < " ") {
                                        var Ul = Rl.charCodeAt(0).toString(16);
                                        Co += "\\x" + ("00" + Ul).substring(Ul.length);
                                    } else Co += Rl;
                                }
                                var Gl = Ll || Object.keys(rt).reduce(function(Qe, Wn) {
                                    return rt[Qe] < rt[Wn] ? Qe : Wn;
                                });
                                return Gl + (Co = Co.replace(new RegExp(Gl, "g"), Wn[Gl])) + Gl;
                            }
                            function serializeObject(Qe) {
                                if (Rl.indexOf(Qe) >= 0) throw TypeError("Converting circular structure to JSON5");
                                Rl.push(Qe);
                                var rt = Ul;
                                Ul += Gl;
                                for(var Wn, Dl, Ll = [], Zl = 0, Hl = Co || Object.keys(Qe); Zl < Hl.length; Zl += 1){
                                    var ql = Hl[Zl], Ql = serializeProperty(ql, Qe);
                                    if (void 0 !== Ql) {
                                        var Kl = serializeKey(ql) + ":";
                                        "" !== Gl && (Kl += " "), Kl += Ql, Ll.push(Kl);
                                    }
                                }
                                if (0 === Ll.length) Wn = "{}";
                                else if ("" === Gl) Wn = "{" + (Dl = Ll.join(",")) + "}";
                                else {
                                    var $l = ",\n" + Ul;
                                    Dl = Ll.join($l), Wn = "{\n" + Ul + Dl + ",\n" + rt + "}";
                                }
                                return Rl.pop(), Ul = rt, Wn;
                            }
                            function serializeKey(Qe) {
                                if (0 === Qe.length) return quoteString(Qe, !0);
                                var rt = String.fromCodePoint(Qe.codePointAt(0));
                                if (!md.isIdStartChar(rt)) return quoteString(Qe, !0);
                                for(var Wn = rt.length; Wn < Qe.length; Wn++)if (!md.isIdContinueChar(String.fromCodePoint(Qe.codePointAt(Wn)))) return quoteString(Qe, !0);
                                return Qe;
                            }
                            function serializeArray(Qe) {
                                if (Rl.indexOf(Qe) >= 0) throw TypeError("Converting circular structure to JSON5");
                                Rl.push(Qe);
                                var rt = Ul;
                                Ul += Gl;
                                for(var Wn, Co = [], Dl = 0; Dl < Qe.length; Dl++){
                                    var Ll = serializeProperty(String(Dl), Qe);
                                    Co.push(void 0 !== Ll ? Ll : "null");
                                }
                                if (0 === Co.length) Wn = "[]";
                                else if ("" === Gl) Wn = "[" + Co.join(",") + "]";
                                else {
                                    var Zl = ",\n" + Ul, Hl = Co.join(Zl);
                                    Wn = "[\n" + Ul + Hl + ",\n" + rt + "]";
                                }
                                return Rl.pop(), Ul = rt, Wn;
                            }
                        }
                    };
                }();
            },
            9922: (Qe, rt, Wn)=>{
                "use strict";
                function normalizeSelector(Qe) {
                    function saveUnmatched() {
                        Wn && (Ll.length > 0 && /^[~+>]$/.test(Ll[Ll.length - 1]) && Ll.push(" "), Ll.push(Wn));
                    }
                    var rt, Wn, Co, Dl, Ll = [], Rl = [
                        0
                    ], Ul = 0, Gl = /(?:[^\\]|(?:^|[^\\])(?:\\\\)+)$/, Zl = /^\s+$/, Hl = [
                        /\s+|\/\*|["'>~+[(]/g,
                        /\s+|\/\*|["'[\]()]/g,
                        /\s+|\/\*|["'[\]()]/g,
                        null,
                        /\*\//g
                    ];
                    for(Qe = Qe.trim();;){
                        if (Wn = "", (Co = Hl[Rl[Rl.length - 1]]).lastIndex = Ul, !(rt = Co.exec(Qe))) {
                            Wn = Qe.substr(Ul), saveUnmatched();
                            break;
                        }
                        if ((Dl = Ul) < (Ul = Co.lastIndex) - rt[0].length && (Wn = Qe.substring(Dl, Ul - rt[0].length)), Rl[Rl.length - 1] < 3) {
                            if (saveUnmatched(), "[" === rt[0]) Rl.push(1);
                            else if ("(" === rt[0]) Rl.push(2);
                            else if (/^["']$/.test(rt[0])) Rl.push(3), Hl[3] = new RegExp(rt[0], "g");
                            else if ("/*" === rt[0]) Rl.push(4);
                            else if (/^[\])]$/.test(rt[0]) && Rl.length > 0) Rl.pop();
                            else if (/^(?:\s+|[~+>])$/.test(rt[0]) && (Ll.length > 0 && !Zl.test(Ll[Ll.length - 1]) && 0 === Rl[Rl.length - 1] && Ll.push(" "), 1 === Rl[Rl.length - 1] && 5 === Ll.length && "=" === Ll[2].charAt(Ll[2].length - 1) && (Ll[4] = " " + Ll[4]), Zl.test(rt[0]))) continue;
                            Ll.push(rt[0]);
                        } else Ll[Ll.length - 1] += Wn, Gl.test(Ll[Ll.length - 1]) && (4 === Rl[Rl.length - 1] && (Ll.length < 2 || Zl.test(Ll[Ll.length - 2]) ? Ll.pop() : Ll[Ll.length - 1] = " ", rt[0] = ""), Rl.pop()), Ll[Ll.length - 1] += rt[0];
                    }
                    return Ll.join("").trim();
                }
                Wn.d(rt, {
                    P: ()=>normalizeSelector
                });
            },
            9438: (Qe, rt, Wn)=>{
                "use strict";
                Wn.d(rt, {
                    qi: ()=>querySelectorDeep
                });
                var Co = Wn(9922);
                function querySelectorDeep(Qe, rt, Wn) {
                    return void 0 === rt && (rt = document), void 0 === Wn && (Wn = null), _querySelectorDeep(Qe, !1, rt, Wn);
                }
                function _querySelectorDeep(Qe, rt, Wn, Dl) {
                    void 0 === Dl && (Dl = null), Qe = (0, Co.P)(Qe);
                    let Ll = Wn.querySelector(Qe);
                    if (document.head.createShadowRoot || document.head.attachShadow) {
                        if (!rt && Ll) return Ll;
                        return splitByCharacterUnlessQuoted(Qe, ",").reduce((Qe, Co)=>{
                            if (!rt && Qe) return Qe;
                            const Ll = splitByCharacterUnlessQuoted(Co.replace(/^\s+/g, "").replace(/\s*([>+~]+)\s*/g, "$1"), " ").filter((Qe)=>!!Qe).map((Qe)=>splitByCharacterUnlessQuoted(Qe, ">")), Rl = Ll.length - 1, Ul = function(Qe, rt, Wn) {
                                void 0 === Qe && (Qe = null);
                                void 0 === Wn && (Wn = null);
                                let Co = [];
                                if (Wn) Co = Wn;
                                else {
                                    const findAllElements = function(Qe) {
                                        for(let rt = 0; rt < Qe.length; rt++){
                                            const Wn = Qe[rt];
                                            Co.push(Wn), Wn.shadowRoot && findAllElements(Wn.shadowRoot.querySelectorAll("*"));
                                        }
                                    };
                                    rt.shadowRoot && findAllElements(rt.shadowRoot.querySelectorAll("*")), findAllElements(rt.querySelectorAll("*"));
                                }
                                return Qe ? Co.filter((rt)=>rt.matches(Qe)) : Co;
                            }(Ll[Rl][Ll[Rl].length - 1], Wn, Dl), Gl = function(Qe, rt, Wn) {
                                return (Co)=>{
                                    let Dl = rt, Ll = Co, Rl = !1;
                                    for(; Ll && !isDocumentNode(Ll);){
                                        let rt = !0;
                                        if (1 === Qe[Dl].length) rt = Ll.matches(Qe[Dl]);
                                        else {
                                            const Co = [].concat(Qe[Dl]).reverse();
                                            let Rl = Ll;
                                            for (const Qe of Co){
                                                if (!Rl || !Rl.matches(Qe)) {
                                                    rt = !1;
                                                    break;
                                                }
                                                Rl = findParentOrHost(Rl, Wn);
                                            }
                                        }
                                        if (rt && 0 === Dl) {
                                            Rl = !0;
                                            break;
                                        }
                                        rt && Dl--, Ll = findParentOrHost(Ll, Wn);
                                    }
                                    return Rl;
                                };
                            }(Ll, Rl, Wn);
                            return rt ? Qe = Qe.concat(Ul.filter(Gl)) : (Qe = Ul.find(Gl)) || null;
                        }, rt ? [] : null);
                    }
                    return rt ? Wn.querySelectorAll(Qe) : Ll;
                }
                function splitByCharacterUnlessQuoted(Qe, rt) {
                    return Qe.match(/\\?.|^$/g).reduce((Qe, Wn)=>('"' !== Wn || Qe.sQuote ? "'" !== Wn || Qe.quote ? Qe.quote || Qe.sQuote || Wn !== rt ? Qe.a[Qe.a.length - 1] += Wn : Qe.a.push("") : (Qe.sQuote ^= 1, Qe.a[Qe.a.length - 1] += Wn) : (Qe.quote ^= 1, Qe.a[Qe.a.length - 1] += Wn), Qe), {
                        a: [
                            ""
                        ]
                    }).a;
                }
                function isDocumentNode(Qe) {
                    return Qe.nodeType === Node.DOCUMENT_FRAGMENT_NODE || Qe.nodeType === Node.DOCUMENT_NODE;
                }
                function findParentOrHost(Qe, rt) {
                    const Wn = Qe.parentNode;
                    return Wn && Wn.host && 11 === Wn.nodeType ? Wn.host : Wn === rt ? null : Wn;
                }
            },
            1865: ()=>{},
            3961: ()=>{},
            2710: ()=>{},
            1575: ()=>{},
            1080: ()=>{},
            6795: ()=>{},
            3638: ()=>{},
            7776: ()=>{},
            7365: ()=>{},
            970: ()=>{},
            9616: ()=>{},
            1870: ()=>{},
            3041: ()=>{},
            5003: ()=>{},
            3630: ()=>{},
            1230: ()=>{},
            9740: (Qe)=>{
                "use strict";
                Qe.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjxzdmcKICAgd2lkdGg9IjQ4IgogICBoZWlnaHQ9IjQ4IgogICB2aWV3Qm94PSIwIDAgNDggNDgiCiAgIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICAgeG1sbnM6c3ZnPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPHBhdGgKICAgICBzdHlsZT0iZmlsbDojZmZjYzgwO2ZpbGwtb3BhY2l0eToxO3N0cm9rZTojZmZmZmZmO3N0cm9rZS13aWR0aDoyLjYzNzM2O3N0cm9rZS1kYXNoYXJyYXk6bm9uZTtzdHJva2Utb3BhY2l0eToxIgogICAgIGQ9Ik0gMjQgMS4zMTgzNTk0IEEgMjIuNjgxMzIgMjIuNjgxMzIgMCAwIDAgMS4zMTgzNTk0IDI0IEEgMjIuNjgxMzIgMjIuNjgxMzIgMCAwIDAgMjQgNDYuNjgxNjQxIEEgMjIuNjgxMzIgMjIuNjgxMzIgMCAwIDAgNDYuNjgxNjQxIDI0IEEgMjIuNjgxMzIgMjIuNjgxMzIgMCAwIDAgMjQgMS4zMTgzNTk0IHogTSAyNCAxNC4wMjE0ODQgQSA5Ljk3Nzc1NjUgOS45Nzc3NTY1IDAgMCAxIDMzLjk3ODUxNiAyNCBBIDkuOTc3NzU2NSA5Ljk3Nzc1NjUgMCAwIDEgMjQgMzMuOTc4NTE2IEEgOS45Nzc3NTY1IDkuOTc3NzU2NSAwIDAgMSAxNC4wMjE0ODQgMjQgQSA5Ljk3Nzc1NjUgOS45Nzc3NTY1IDAgMCAxIDI0IDE0LjAyMTQ4NCB6ICIgLz4KICA8cGF0aAogICAgIHN0eWxlPSJmaWxsOiNiZjM2MGM7ZmlsbC1vcGFjaXR5OjE7c3Ryb2tlOiNmZmZmZmY7c3Ryb2tlLXdpZHRoOjIuNTtzdHJva2UtbWl0ZXJsaW1pdDo0O3N0cm9rZS1kYXNoYXJyYXk6bm9uZTtzdHJva2Utb3BhY2l0eToxIgogICAgIGQ9Ik0gMjQgMS4yNDIxODc1IEEgMjIuNTk0MTA3IDIyLjU5NDEwNyAwIDAgMCA4LjAyMTQ4NDQgNy44NTkzNzUgTCAxNy4wNDI5NjkgMTYuODgyODEyIEEgOS45Nzc3NTY1IDkuOTc3NzU2NSAwIDAgMSAyNCAxNC4wMjE0ODQgQSA5Ljk3Nzc1NjUgOS45Nzc3NTY1IDAgMCAxIDMwLjk3NDYwOSAxNi44NjcxODggTCAzOS45Nzg1MTYgNy44NjMyODEyIEEgMjIuNTk0MTA3IDIyLjU5NDEwNyAwIDAgMCAyNCAxLjI0MjE4NzUgeiAiIC8+Cjwvc3ZnPgo=";
            },
            6462: (Qe)=>{
                "use strict";
                Qe.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjxzdmcKICAgd2lkdGg9IjQ4IgogICBoZWlnaHQ9IjQ4IgogICB2aWV3Qm94PSIwIDAgNDggNDgiCiAgIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICAgeG1sbnM6c3ZnPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPHBhdGgKICAgICBzdHlsZT0iZmlsbDojYmYzNjBjO2ZpbGwtb3BhY2l0eToxO3N0cm9rZTojZmZmZmZmO3N0cm9rZS13aWR0aDoyLjUwMDAzO3N0cm9rZS1taXRlcmxpbWl0OjQ7c3Ryb2tlLWRhc2hhcnJheTpub25lO3N0cm9rZS1vcGFjaXR5OjEiCiAgICAgZD0iTSAyNCAxLjI0MjE4NzUgQSAyMi41OTQxMDcgMjIuNTk0MTA3IDAgMCAwIDguMDIxNDg0NCA3Ljg1OTM3NSBMIDE3LjA0Mjk2OSAxNi44ODI4MTIgQSA5Ljk3Nzc1NjUgOS45Nzc3NTY1IDAgMCAxIDI0IDE0LjAyMTQ4NCBBIDkuOTc3NzU2NSA5Ljk3Nzc1NjUgMCAwIDEgMzAuOTc0NjA5IDE2Ljg2NzE4OCBMIDM5Ljk3ODUxNiA3Ljg2MzI4MTIgQSAyMi41OTQxMDcgMjIuNTk0MTA3IDAgMCAwIDI0IDEuMjQyMTg3NSB6ICIgLz4KPC9zdmc+Cg==";
            },
            8407: (Qe)=>{
                "use strict";
                Qe.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjxzdmcKCXZpZXdCb3g9IjAgMCA2NCA2NCIKCXdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIKCXhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKCXhtbG5zOnN2Zz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aAoJZD0iTSAyNy4zNTk0ODYsMTIuNjU1MTMgMS40MzE2MzQ5LDQzLjQ5OTE3IGMgLTMuMjk5OTA4MiwzLjkwNjAxNCAtMC41Mzg3NjA0Niw5Ljk2NzA3IDQuNjQ2ODA5Nyw5Ljk2NzA3IEggNTcuOTM0MTQ2IGMgNS4xMTgyMjUsMCA3Ljk0NjcxOCwtNS45OTM3MTEgNC42NDY4MSwtOS45NjcwNyBMIDM2LjY1MzEwNSwxMi42NTUxMyBjIC0yLjQyNDQyMiwtMi44Mjg0OTMxIC02Ljg2OTE5NywtMi44Mjg0OTMxIC05LjI5MzYxOSwwIHoiCglzdHlsZT0iZmlsbDogY3VycmVudENvbG9yO2ZpbGwtb3BhY2l0eToxO3N0cm9rZS13aWR0aDowLjY3MzQ1MSIgLz4KPC9zdmc+Cg==";
            },
            6830: (Qe)=>{
                "use strict";
                Qe.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+Cjxzdmcgdmlld0JveD0iMCAwIDY0IDE5MiIgd2lkdGg9IjY0IiBoZWlnaHQ9IjE5MiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczpzdmc9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZQoJY3g9IjMyIgoJY3k9IjMyIgoJcj0iMjkuODk3ODA2IgoJc3R5bGU9ImZpbGw6IGN1cnJlbnRDb2xvcjtmaWxsLW9wYWNpdHk6MTtzdHJva2U6I2ZmZmZmZjtzdHJva2Utd2lkdGg6NC4yMDQzOTtzdHJva2UtbWl0ZXJsaW1pdDo0O3N0cm9rZS1kYXNoYXJyYXk6bm9uZTtzdHJva2Utb3BhY2l0eToxIiAvPgo8cGF0aCBkPSJtIDM0LjI3OTg3MywyMC4yNjIxNzEgNi43MTE0NDIsNi43MTQyOTQgYyAwLjg5MTQ2NSwwLjg5MTQ2NSAyLjMzOTk4NiwwLjg5MTQ2NSAzLjIzMTQ1MSwwIDAuODkxNDY2LC0wLjg5MTQ2NSAwLjg5MTQ2NiwtMi4zMzk5ODUgMCwtMy4yMzE0NSAtOS42NjI5MDIsLTkuNjY1ODI5IC0zLjc5NDI4NSwtMy43OTQyODYgLTguMTgwMjk3LC04LjE4MDI5OCAtMS4wNzEzOTYsLTEuMDc0MzIyIC0yLjUyNTY5NiwtMS42NzcxNjUgLTQuMDM5OTcyLC0xLjY3NzE2NSAtMS41MTcxMjksMCAtMi45Njg1NzYsMC42MDI4NTggLTQuMDQyODI1LDEuNjc3MTY1IGwgLTguMTgwMjk4LDguMTgwMjk4IGMgLTAuODk0MzE3LDAuODkxNDY1IC0wLjg5NDMxNywyLjMzOTk4NiAwLDMuMjMxNDUgMC44OTE0NjYsMC44OTE0NjUgMi4zMzk5ODcsMC44OTE0NjUgMy4yMzE0NTIsMCBsIDYuNjk3MTA2LC02LjY5NDI1MyB2IDI3LjcwMzk0MyBjIDAsMCAtMC4xMDk3MDYsMi4xMjYyOTIgMi4yODU5NzEsMi4xMjYyOTIgMi4zOTU2NzYsMCAyLjI4NTk3LC0yLjEyNjI5MiAyLjI4NTk3LC0yLjEyNjI5MiB6IiBzdHlsZT0iZmlsbDojZmZmZmZmO2ZpbGwtb3BhY2l0eToxO2ZpbGwtcnVsZTpldmVub2RkO3N0cm9rZS13aWR0aDowLjczMTQyOSIgLz4KPC9zdmc+Cg==";
            },
            7534: (Qe)=>{
                "use strict";
                Qe.exports = "data:image/jpeg;base64,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";
            },
            6810: (Qe)=>{
                "use strict";
                Qe.exports = "data:image/jpeg;base64,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";
            },
            5975: (Qe)=>{
                "use strict";
                Qe.exports = "data:image/jpeg;base64,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";
            },
            2305: (Qe)=>{
                "use strict";
                Qe.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjwhLS0gQ3JlYXRlZCB3aXRoIElua3NjYXBlIChodHRwOi8vd3d3Lmlua3NjYXBlLm9yZy8pIC0tPgoKPHN2ZwogICB3aWR0aD0iNDgiCiAgIGhlaWdodD0iNDgiCiAgIHZpZXdCb3g9IjAgMCAxMi43IDEyLjciCiAgIHZlcnNpb249IjEuMSIKICAgaWQ9InN2ZzUiCiAgIHhtbDpzcGFjZT0icHJlc2VydmUiCiAgIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICAgeG1sbnM6c3ZnPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnMKICAgICBpZD0iZGVmczIiPjxmaWx0ZXIKICAgICAgIHN0eWxlPSJjb2xvci1pbnRlcnBvbGF0aW9uLWZpbHRlcnM6c1JHQjsiCiAgICAgICBpZD0iZmlsdGVyMTM0NSIKICAgICAgIHg9Ii0wLjIzMTQ0MzgiCiAgICAgICB5PSItMC4yMzE0NDM4IgogICAgICAgd2lkdGg9IjEuNDYyODg3NiIKICAgICAgIGhlaWdodD0iMS40NjI4ODc2Ij48ZmVGbG9vZAogICAgICAgICBmbG9vZC1vcGFjaXR5PSIwLjQ5ODAzOSIKICAgICAgICAgZmxvb2QtY29sb3I9InJnYigwLDAsMCkiCiAgICAgICAgIHJlc3VsdD0iZmxvb2QiCiAgICAgICAgIGlkPSJmZUZsb29kMTMzNSIgLz48ZmVDb21wb3NpdGUKICAgICAgICAgaW49ImZsb29kIgogICAgICAgICBpbjI9IlNvdXJjZUdyYXBoaWMiCiAgICAgICAgIG9wZXJhdG9yPSJpbiIKICAgICAgICAgcmVzdWx0PSJjb21wb3NpdGUxIgogICAgICAgICBpZD0iZmVDb21wb3NpdGUxMzM3IiAvPjxmZUdhdXNzaWFuQmx1cgogICAgICAgICBpbj0iY29tcG9zaXRlMSIKICAgICAgICAgc3RkRGV2aWF0aW9uPSIwLjUiCiAgICAgICAgIHJlc3VsdD0iYmx1ciIKICAgICAgICAgaWQ9ImZlR2F1c3NpYW5CbHVyMTMzOSIgLz48ZmVPZmZzZXQKICAgICAgICAgZHg9IjAiCiAgICAgICAgIGR5PSIwIgogICAgICAgICByZXN1bHQ9Im9mZnNldCIKICAgICAgICAgaWQ9ImZlT2Zmc2V0MTM0MSIgLz48ZmVDb21wb3NpdGUKICAgICAgICAgaW49IlNvdXJjZUdyYXBoaWMiCiAgICAgICAgIGluMj0ib2Zmc2V0IgogICAgICAgICBvcGVyYXRvcj0ib3ZlciIKICAgICAgICAgcmVzdWx0PSJjb21wb3NpdGUyIgogICAgICAgICBpZD0iZmVDb21wb3NpdGUxMzQzIiAvPjwvZmlsdGVyPjxmaWx0ZXIKICAgICAgIHN0eWxlPSJjb2xvci1pbnRlcnBvbGF0aW9uLWZpbHRlcnM6c1JHQjsiCiAgICAgICBpZD0iZmlsdGVyMTM4OSIKICAgICAgIHg9Ii0wLjE5MDM0NTU2IgogICAgICAgeT0iLTAuMTkwMzQ1NTYiCiAgICAgICB3aWR0aD0iMS4zODA2OTExIgogICAgICAgaGVpZ2h0PSIxLjM4MDY5MTEiPjxmZUZsb29kCiAgICAgICAgIGZsb29kLW9wYWNpdHk9IjAuNDk4MDM5IgogICAgICAgICBmbG9vZC1jb2xvcj0icmdiKDAsMCwwKSIKICAgICAgICAgcmVzdWx0PSJmbG9vZCIKICAgICAgICAgaWQ9ImZlRmxvb2QxMzc5IiAvPjxmZUNvbXBvc2l0ZQogICAgICAgICBpbj0iZmxvb2QiCiAgICAgICAgIGluMj0iU291cmNlR3JhcGhpYyIKICAgICAgICAgb3BlcmF0b3I9ImluIgogICAgICAgICByZXN1bHQ9ImNvbXBvc2l0ZTEiCiAgICAgICAgIGlkPSJmZUNvbXBvc2l0ZTEzODEiIC8+PGZlR2F1c3NpYW5CbHVyCiAgICAgICAgIGluPSJjb21wb3NpdGUxIgogICAgICAgICBzdGREZXZpYXRpb249IjAuNSIKICAgICAgICAgcmVzdWx0PSJibHVyIgogICAgICAgICBpZD0iZmVHYXVzc2lhbkJsdXIxMzgzIiAvPjxmZU9mZnNldAogICAgICAgICBkeD0iMCIKICAgICAgICAgZHk9IjAiCiAgICAgICAgIHJlc3VsdD0ib2Zmc2V0IgogICAgICAgICBpZD0iZmVPZmZzZXQxMzg1IiAvPjxmZUNvbXBvc2l0ZQogICAgICAgICBpbj0iU291cmNlR3JhcGhpYyIKICAgICAgICAgaW4yPSJvZmZzZXQiCiAgICAgICAgIG9wZXJhdG9yPSJvdmVyIgogICAgICAgICByZXN1bHQ9ImNvbXBvc2l0ZTIiCiAgICAgICAgIGlkPSJmZUNvbXBvc2l0ZTEzODciIC8+PC9maWx0ZXI+PC9kZWZzPjxnCiAgICAgaWQ9ImxheWVyMSI+PHBhdGgKICAgICAgIHN0eWxlPSJmaWxsOiNiZjY3NGM7ZmlsbC1vcGFjaXR5OjE7c3Ryb2tlOiNmZmZmZmY7c3Ryb2tlLXdpZHRoOjAuNjYxNDU4O3N0cm9rZS1taXRlcmxpbWl0OjQ7c3Ryb2tlLWRhc2hhcnJheTpub25lO3N0cm9rZS1vcGFjaXR5OjE7ZmlsdGVyOnVybCgjZmlsdGVyMTM4OSkiCiAgICAgICBpZD0icGF0aDYzNDIiCiAgICAgICB0cmFuc2Zvcm09Im1hdHJpeCgtMC4yMzAxOTA4OSwtMC44NTkwOTM3MywwLjg1OTA5MjQ2LC0wLjIzMDE5NTY0LDAuOTYxNzMwODMsMC43NjEzNjk0MykiCiAgICAgICBkPSJNIC0xLjI1Nzg5MjYsMS45MTE3NjY4IEEgOC4wNDE4NDI1LDguMDQxODQyNSAwIDAgMSAtOS4yOTk3MzUxLDkuOTUzNjA5MiBWIDEuOTExNzY2OCBaIiAvPjxjaXJjbGUKICAgICAgIHN0eWxlPSJmaWxsOiNiZTYyMWM7ZmlsbC1vcGFjaXR5OjE7c3Ryb2tlOiNmZmZmZmY7c3Ryb2tlLXdpZHRoOjAuODg3ODc7c3Ryb2tlLW1pdGVybGltaXQ6NDtzdHJva2UtZGFzaGFycmF5Om5vbmU7c3Ryb2tlLW9wYWNpdHk6MTtmaWx0ZXI6dXJsKCNmaWx0ZXIxMzQ1KSIKICAgICAgIGlkPSJwYXRoODQ2IgogICAgICAgY3g9IjcuOTI3NzA3MiIKICAgICAgIGN5PSI1LjQ3NTg1MjUiCiAgICAgICByPSIzLjU1MTQ3NzciCiAgICAgICB0cmFuc2Zvcm09Im1hdHJpeCgwLjc3MDI0MTc3LDAuNDQ0Njk5MzMsLTAuNDQ0Njk5MzMsMC43NzAyNDE3NywwLjk2MTczMDgzLDAuNzYxMzY5NDMpIiAvPjxnCiAgICAgICBpZD0iZzg5MiIKICAgICAgIHRyYW5zZm9ybT0ibWF0cml4KDEuMTc4NDYzOSwwLDAsMS4xNzg0NjM5LC0wLjgzNjc2ODYyLC0xLjY1OTk1MjIpIj48cGF0aAogICAgICAgICBkPSJNIDMuNTk5NjY3OCw5LjQxMDYyNTIgSCA1Ljc4MjQ4MDMgViA5LjgwNzUwMDEgSCAzLjU5OTY2NzggWiIKICAgICAgICAgaWQ9InBhdGgyNTQiCiAgICAgICAgIHN0eWxlPSJmaWxsOiNmZmZmZmY7ZmlsbC1vcGFjaXR5OjE7c3Ryb2tlLXdpZHRoOjAuMjY0NTgzIiAvPjxwYXRoCiAgICAgICAgIGQ9Ik0gNC4xMjgzMDUzLDguMjcwMDA2NCAzLjgzMDExOTksOC4wMDQ4OTM5IDQuMDk1MjMyNCw3LjcwNjcwODUgMy43OTg2MzQ1LDcuNDQyOTE4OSAzLjUzMzUyMiw3Ljc0MTEwNDMgMy4yMzUzMzY2LDcuNDc1OTkxOCAyLjk3MTU0Nyw3Ljc3MjU4OTggMy4yNjk3MzI0LDguMDM3NzAyMyAzLjAwNDYxOTksOC4zMzU4ODc3IDMuMzAxMjE3OCw4LjU5OTY3NzIgMy41NjYzMzAzLDguMzAxNDkxOCAzLjg2NDUxNTcsOC41NjY2MDQzIFoiCiAgICAgICAgIGlkPSJwYXRoMjU2IgogICAgICAgICBzdHlsZT0iZmlsbDojZmZmZmZmO2ZpbGwtb3BhY2l0eToxO3N0cm9rZS13aWR0aDowLjI2NDU4MyIgLz48cGF0aAogICAgICAgICBkPSJNIDYuMjc4MDQ0OSw3LjcwNjk3MzEgNS45ODE0NDcsNy40NDMxODM1IDUuNzE2MzM0NSw3Ljc0MTM2ODkgNS40MTgxNDkxLDcuNDc2MjU2NCA1LjE1NDM1OTUsNy43NzI4NTQzIDUuNDUyNTQ0OSw4LjAzNzk2NjggNS4xODc0MzI0LDguMzM2MTUyMiA1LjQ4NDAzMDMsOC41OTk5NDE4IDUuNzQ5MTQyOCw4LjMwMTc1NjQgNi4wNDczMjgyLDguNTY2ODY4OSA2LjMxMTExNzgsOC4yNzAyNzEgNi4wMTI5MzI0LDguMDA1MTU4NSBaIgogICAgICAgICBpZD0icGF0aDI1OCIKICAgICAgICAgc3R5bGU9ImZpbGw6I2ZmZmZmZjtmaWxsLW9wYWNpdHk6MTtzdHJva2Utd2lkdGg6MC4yNjQ1ODMiIC8+PC9nPjwvZz48L3N2Zz4K";
            },
            6883: (Qe)=>{
                "use strict";
                Qe.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjxzdmcKICAgd2lkdGg9IjQ4IgogICBoZWlnaHQ9IjQ4IgogICB2aWV3Qm94PSIwIDAgNDggNDgiCiAgIHZlcnNpb249IjEuMSIKICAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogICB4bWxuczpzdmc9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aAogICAgIGQ9Im0gOC4wMjIyOTI0LDcuODU5Nzk3NyBhIDIyLjU5NDEwNywyMi41OTQxMDcgMCAwIDEgMzEuOTU1NTYzNiwwLjAwMjcgTCAyNC4wMDE0MDksMjMuODM4OTE2IFoiCiAgICAgc3R5bGU9ImZpbGw6I2JmMzYwYztmaWxsLW9wYWNpdHk6MTtzdHJva2U6I2ZmZmZmZjtzdHJva2Utd2lkdGg6Mi41MDAwMztzdHJva2UtbWl0ZXJsaW1pdDo0O3N0cm9rZS1kYXNoYXJyYXk6bm9uZTtzdHJva2Utb3BhY2l0eToxIiAvPgogIDxjaXJjbGUKICAgICBjeD0iMjQiCiAgICAgY3k9IjI0IgogICAgIHI9IjkuOTc3NzU2NSIKICAgICBzdHlsZT0iZmlsbDojZmY2ZjAwO2ZpbGwtb3BhY2l0eToxO3N0cm9rZTojZmZmZmZmO3N0cm9rZS13aWR0aDoyLjQ5NDQ5O3N0cm9rZS1taXRlcmxpbWl0OjQ7c3Ryb2tlLWRhc2hhcnJheTpub25lO3N0cm9rZS1vcGFjaXR5OjEiIC8+Cjwvc3ZnPgo=";
            },
            270: (Qe)=>{
                "use strict";
                Qe.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjxzdmcKICAgd2lkdGg9IjQ4IgogICBoZWlnaHQ9IjQ4IgogICB2aWV3Qm94PSIwIDAgMTIuNyAxMi43IgogICB2ZXJzaW9uPSIxLjEiCiAgIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICAgeG1sbnM6c3ZnPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPGRlZnMKICAgICBpZD0iZGVmczEiIC8+CiAgPHBhdGgKICAgICBkPSJNLTMuMDA3LS4wMDVhNS45NzggNS45NzggMCAwIDEtNS45NzkgNS45NzhWLS4wMDV6IgogICAgIHN0eWxlPSJmaWxsOiMxYTIzN2U7ZmlsbC1vcGFjaXR5OjE7c3Ryb2tlOiNmZmY7c3Ryb2tlLXdpZHRoOjAuNjYxNDU4O3N0cm9rZS1taXRlcmxpbWl0OjQ7c3Ryb2tlLWRhc2hhcnJheTpub25lO3N0cm9rZS1vcGFjaXR5OjEiCiAgICAgdHJhbnNmb3JtPSJyb3RhdGUoLTEzNSkiLz4KICA8Y2lyY2xlCiAgICAgY3g9IjYuMzUiCiAgICAgY3k9IjYuNTQ1IgogICAgIHI9IjIuNjQiCiAgICAgc3R5bGU9ImZpbGw6IzFlODhlNTtmaWxsLW9wYWNpdHk6MTtzdHJva2U6I2ZmZjtzdHJva2Utd2lkdGg6MC42NjAwMjc7c3Ryb2tlLW1pdGVybGltaXQ6NDtzdHJva2UtZGFzaGFycmF5Om5vbmU7c3Ryb2tlLW9wYWNpdHk6MSIgLz4KPC9zdmc+Cg==";
            },
            1760: (Qe)=>{
                "use strict";
                Qe.exports = "data:image/svg+xml;base64,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";
            },
            5940: (Qe)=>{
                "use strict";
                Qe.exports = "data:image/svg+xml;base64,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";
            },
            1462: (Qe)=>{
                "use strict";
                Qe.exports = "data:image/svg+xml;base64,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";
            },
            5721: (Qe)=>{
                "use strict";
                Qe.exports = "data:image/svg+xml;base64,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";
            },
            7091: (Qe)=>{
                "use strict";
                Qe.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAxOCI+PHBhdGggZD0iTTIuNSAxaDF2MTZoLTF6bTIgMGgzdjE2aC0zem00IDBoM3YxNmgtM3oiIGZpbGw9IiM5MDAiLz48cGF0aCBkPSJNMTIuNSAxaDF2MTZoLTF6bTIgMGgxdjE2aC0xem0xMiAwaDF2MTZoLTF6bTIgMGgxdjE2aC0xeiIgZmlsbD0iIzM5NiIvPjxwYXRoIGQ9Ik0xNi41IDFoM3YxNmgtM3ptNCAwaDF2MTZoLTF6bTIgMGgzdjE2aC0zeiIgZmlsbD0iIzA2OSIvPjwvc3ZnPg==";
            },
            2968: ()=>{
                /**
 * MapLibre GL JS
 * @license 3-Clause BSD. Full text of license: https://github.com/maplibre/maplibre-gl-js/blob/v5.3.0/LICENSE.txt
 */ !function() {
                    "use strict";
                    function t(Qe, rt, Wn, Co) {
                        return new (Wn || (Wn = Promise))(function(Dl, Ll) {
                            function o(Qe) {
                                try {
                                    l(Co.next(Qe));
                                } catch (Qe) {
                                    Ll(Qe);
                                }
                            }
                            function a(Qe) {
                                try {
                                    l(Co.throw(Qe));
                                } catch (Qe) {
                                    Ll(Qe);
                                }
                            }
                            function l(Qe) {
                                var rt;
                                Qe.done ? Dl(Qe.value) : (rt = Qe.value, rt instanceof Wn ? rt : new Wn(function(Qe) {
                                    Qe(rt);
                                })).then(o, a);
                            }
                            l((Co = Co.apply(Qe, rt || [])).next());
                        });
                    }
                    function e(Qe) {
                        return Qe && Qe.__esModule && Object.prototype.hasOwnProperty.call(Qe, "default") ? Qe.default : Qe;
                    }
                    var Qe, rt;
                    function i() {
                        if (rt) return Qe;
                        function t(Qe, rt) {
                            this.x = Qe, this.y = rt;
                        }
                        return rt = 1, Qe = t, t.prototype = {
                            clone: function() {
                                return new t(this.x, this.y);
                            },
                            add: function(Qe) {
                                return this.clone()._add(Qe);
                            },
                            sub: function(Qe) {
                                return this.clone()._sub(Qe);
                            },
                            multByPoint: function(Qe) {
                                return this.clone()._multByPoint(Qe);
                            },
                            divByPoint: function(Qe) {
                                return this.clone()._divByPoint(Qe);
                            },
                            mult: function(Qe) {
                                return this.clone()._mult(Qe);
                            },
                            div: function(Qe) {
                                return this.clone()._div(Qe);
                            },
                            rotate: function(Qe) {
                                return this.clone()._rotate(Qe);
                            },
                            rotateAround: function(Qe, rt) {
                                return this.clone()._rotateAround(Qe, rt);
                            },
                            matMult: function(Qe) {
                                return this.clone()._matMult(Qe);
                            },
                            unit: function() {
                                return this.clone()._unit();
                            },
                            perp: function() {
                                return this.clone()._perp();
                            },
                            round: function() {
                                return this.clone()._round();
                            },
                            mag: function() {
                                return Math.sqrt(this.x * this.x + this.y * this.y);
                            },
                            equals: function(Qe) {
                                return this.x === Qe.x && this.y === Qe.y;
                            },
                            dist: function(Qe) {
                                return Math.sqrt(this.distSqr(Qe));
                            },
                            distSqr: function(Qe) {
                                var rt = Qe.x - this.x, Wn = Qe.y - this.y;
                                return rt * rt + Wn * Wn;
                            },
                            angle: function() {
                                return Math.atan2(this.y, this.x);
                            },
                            angleTo: function(Qe) {
                                return Math.atan2(this.y - Qe.y, this.x - Qe.x);
                            },
                            angleWith: function(Qe) {
                                return this.angleWithSep(Qe.x, Qe.y);
                            },
                            angleWithSep: function(Qe, rt) {
                                return Math.atan2(this.x * rt - this.y * Qe, this.x * Qe + this.y * rt);
                            },
                            _matMult: function(Qe) {
                                var rt = Qe[2] * this.x + Qe[3] * this.y;
                                return this.x = Qe[0] * this.x + Qe[1] * this.y, this.y = rt, this;
                            },
                            _add: function(Qe) {
                                return this.x += Qe.x, this.y += Qe.y, this;
                            },
                            _sub: function(Qe) {
                                return this.x -= Qe.x, this.y -= Qe.y, this;
                            },
                            _mult: function(Qe) {
                                return this.x *= Qe, this.y *= Qe, this;
                            },
                            _div: function(Qe) {
                                return this.x /= Qe, this.y /= Qe, this;
                            },
                            _multByPoint: function(Qe) {
                                return this.x *= Qe.x, this.y *= Qe.y, this;
                            },
                            _divByPoint: function(Qe) {
                                return this.x /= Qe.x, this.y /= Qe.y, this;
                            },
                            _unit: function() {
                                return this._div(this.mag()), this;
                            },
                            _perp: function() {
                                var Qe = this.y;
                                return this.y = this.x, this.x = -Qe, this;
                            },
                            _rotate: function(Qe) {
                                var rt = Math.cos(Qe), Wn = Math.sin(Qe), Co = Wn * this.x + rt * this.y;
                                return this.x = rt * this.x - Wn * this.y, this.y = Co, this;
                            },
                            _rotateAround: function(Qe, rt) {
                                var Wn = Math.cos(Qe), Co = Math.sin(Qe), Dl = rt.y + Co * (this.x - rt.x) + Wn * (this.y - rt.y);
                                return this.x = rt.x + Wn * (this.x - rt.x) - Co * (this.y - rt.y), this.y = Dl, this;
                            },
                            _round: function() {
                                return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
                            }
                        }, t.convert = function(Qe) {
                            return Qe instanceof t ? Qe : Array.isArray(Qe) ? new t(Qe[0], Qe[1]) : Qe;
                        }, Qe;
                    }
                    "function" == typeof SuppressedError && SuppressedError;
                    var Wn, Co, Dl = e(i()), Ll = function() {
                        if (Co) return Wn;
                        function t(Qe, rt, Wn, Co) {
                            this.cx = 3 * Qe, this.bx = 3 * (Wn - Qe) - this.cx, this.ax = 1 - this.cx - this.bx, this.cy = 3 * rt, this.by = 3 * (Co - rt) - this.cy, this.ay = 1 - this.cy - this.by, this.p1x = Qe, this.p1y = rt, this.p2x = Wn, this.p2y = Co;
                        }
                        return Co = 1, Wn = t, t.prototype = {
                            sampleCurveX: function(Qe) {
                                return ((this.ax * Qe + this.bx) * Qe + this.cx) * Qe;
                            },
                            sampleCurveY: function(Qe) {
                                return ((this.ay * Qe + this.by) * Qe + this.cy) * Qe;
                            },
                            sampleCurveDerivativeX: function(Qe) {
                                return (3 * this.ax * Qe + 2 * this.bx) * Qe + this.cx;
                            },
                            solveCurveX: function(Qe, rt) {
                                if (void 0 === rt && (rt = 1e-6), Qe < 0) return 0;
                                if (Qe > 1) return 1;
                                for(var Wn = Qe, Co = 0; Co < 8; Co++){
                                    var Dl = this.sampleCurveX(Wn) - Qe;
                                    if (Math.abs(Dl) < rt) return Wn;
                                    var Ll = this.sampleCurveDerivativeX(Wn);
                                    if (Math.abs(Ll) < 1e-6) break;
                                    Wn -= Dl / Ll;
                                }
                                var Rl = 0, Ul = 1;
                                for(Wn = Qe, Co = 0; Co < 20 && (Dl = this.sampleCurveX(Wn), !(Math.abs(Dl - Qe) < rt)); Co++)Qe > Dl ? Rl = Wn : Ul = Wn, Wn = .5 * (Ul - Rl) + Rl;
                                return Wn;
                            },
                            solve: function(Qe, rt) {
                                return this.sampleCurveY(this.solveCurveX(Qe, rt));
                            }
                        }, Wn;
                    }(), Rl = e(Ll);
                    let Ul, Gl;
                    var Zl, Hl = "undefined" != typeof Float32Array ? Float32Array : Array;
                    function d(Qe, rt, Wn) {
                        var Co = rt[0], Dl = rt[1], Ll = rt[2], Rl = rt[3];
                        return Qe[0] = Wn[0] * Co + Wn[4] * Dl + Wn[8] * Ll + Wn[12] * Rl, Qe[1] = Wn[1] * Co + Wn[5] * Dl + Wn[9] * Ll + Wn[13] * Rl, Qe[2] = Wn[2] * Co + Wn[6] * Dl + Wn[10] * Ll + Wn[14] * Rl, Qe[3] = Wn[3] * Co + Wn[7] * Dl + Wn[11] * Ll + Wn[15] * Rl, Qe;
                    }
                    Math.hypot || (Math.hypot = function() {
                        for(var Qe = 0, rt = arguments.length; rt--;)Qe += arguments[rt] * arguments[rt];
                        return Math.sqrt(Qe);
                    }), Zl = new Hl(4), Hl != Float32Array && (Zl[0] = 0, Zl[1] = 0, Zl[2] = 0, Zl[3] = 0);
                    const ql = 8192;
                    function m(Qe, rt, Wn) {
                        return Math.min(Wn, Math.max(rt, Qe));
                    }
                    function g(Qe) {
                        for(var rt = arguments.length, Wn = new Array(rt > 1 ? rt - 1 : 0), Co = 1; Co < rt; Co++)Wn[Co - 1] = arguments[Co];
                        for (const Dl of Wn)for(const rt in Dl)Qe[rt] = Dl[rt];
                        return Qe;
                    }
                    function x(Qe, rt, Wn) {
                        const Co = {};
                        for(const Dl in Qe)Co[Dl] = rt.call(this, Qe[Dl], Dl, Qe);
                        return Co;
                    }
                    function v(Qe) {
                        return Array.isArray(Qe) ? Qe.map(v) : "object" == typeof Qe && Qe ? x(Qe, v) : Qe;
                    }
                    new Rl(.25, .1, .25, 1);
                    const Ql = {};
                    function w(Qe) {
                        Ql[Qe] || ("undefined" != typeof console && console.warn(Qe), Ql[Qe] = !0);
                    }
                    function _(Qe, rt, Wn) {
                        return (Wn.y - Qe.y) * (rt.x - Qe.x) > (rt.y - Qe.y) * (Wn.x - Qe.x);
                    }
                    function S(Qe) {
                        return "undefined" != typeof WorkerGlobalScope && void 0 !== Qe && Qe instanceof WorkerGlobalScope;
                    }
                    function k(Qe) {
                        return "undefined" != typeof ImageBitmap && Qe instanceof ImageBitmap;
                    }
                    let Kl, $l;
                    function M(Qe, rt, Wn, Co) {
                        return Qe.addEventListener(rt, Wn, Co), {
                            unsubscribe: ()=>{
                                Qe.removeEventListener(rt, Wn, Co);
                            }
                        };
                    }
                    class z {
                        constructor(Qe, rt, Wn){
                            const Co = this.cells = [];
                            if (Qe instanceof ArrayBuffer) {
                                this.arrayBuffer = Qe;
                                const Dl = new Int32Array(this.arrayBuffer);
                                Qe = Dl[0], this.d = (rt = Dl[1]) + 2 * (Wn = Dl[2]);
                                for(let Qe = 0; Qe < this.d * this.d; Qe++){
                                    const rt = Dl[3 + Qe], Wn = Dl[3 + Qe + 1];
                                    Co.push(rt === Wn ? null : Dl.subarray(rt, Wn));
                                }
                                const Ll = Dl[3 + Co.length + 1];
                                this.keys = Dl.subarray(Dl[3 + Co.length], Ll), this.bboxes = Dl.subarray(Ll), this.insert = this._insertReadonly;
                            } else {
                                this.d = rt + 2 * Wn;
                                for(let Qe = 0; Qe < this.d * this.d; Qe++)Co.push([]);
                                this.keys = [], this.bboxes = [];
                            }
                            this.n = rt, this.extent = Qe, this.padding = Wn, this.scale = rt / Qe, this.uid = 0;
                            const Dl = Wn / rt * Qe;
                            this.min = -Dl, this.max = Qe + Dl;
                        }
                        insert(Qe, rt, Wn, Co, Dl) {
                            this._forEachCell(rt, Wn, Co, Dl, this._insertCell, this.uid++, void 0, void 0), this.keys.push(Qe), this.bboxes.push(rt), this.bboxes.push(Wn), this.bboxes.push(Co), this.bboxes.push(Dl);
                        }
                        _insertReadonly() {
                            throw new Error("Cannot insert into a GridIndex created from an ArrayBuffer.");
                        }
                        _insertCell(Qe, rt, Wn, Co, Dl, Ll) {
                            this.cells[Dl].push(Ll);
                        }
                        query(Qe, rt, Wn, Co, Dl) {
                            const Ll = this.min, Rl = this.max;
                            if (Qe <= Ll && rt <= Ll && Rl <= Wn && Rl <= Co && !Dl) return Array.prototype.slice.call(this.keys);
                            {
                                const Ll = [];
                                return this._forEachCell(Qe, rt, Wn, Co, this._queryCell, Ll, {}, Dl), Ll;
                            }
                        }
                        _queryCell(Qe, rt, Wn, Co, Dl, Ll, Rl, Ul) {
                            const Gl = this.cells[Dl];
                            if (null !== Gl) {
                                const Dl = this.keys, Zl = this.bboxes;
                                for(let Hl = 0; Hl < Gl.length; Hl++){
                                    const ql = Gl[Hl];
                                    if (void 0 === Rl[ql]) {
                                        const Gl = 4 * ql;
                                        (Ul ? Ul(Zl[Gl + 0], Zl[Gl + 1], Zl[Gl + 2], Zl[Gl + 3]) : Qe <= Zl[Gl + 2] && rt <= Zl[Gl + 3] && Wn >= Zl[Gl + 0] && Co >= Zl[Gl + 1]) ? (Rl[ql] = !0, Ll.push(Dl[ql])) : Rl[ql] = !1;
                                    }
                                }
                            }
                        }
                        _forEachCell(Qe, rt, Wn, Co, Dl, Ll, Rl, Ul) {
                            const Gl = this._convertToCellCoord(Qe), Zl = this._convertToCellCoord(rt), Hl = this._convertToCellCoord(Wn), ql = this._convertToCellCoord(Co);
                            for(let Ql = Gl; Ql <= Hl; Ql++)for(let Gl = Zl; Gl <= ql; Gl++){
                                const Zl = this.d * Gl + Ql;
                                if ((!Ul || Ul(this._convertFromCellCoord(Ql), this._convertFromCellCoord(Gl), this._convertFromCellCoord(Ql + 1), this._convertFromCellCoord(Gl + 1))) && Dl.call(this, Qe, rt, Wn, Co, Zl, Ll, Rl, Ul)) return;
                            }
                        }
                        _convertFromCellCoord(Qe) {
                            return (Qe - this.padding) / this.scale;
                        }
                        _convertToCellCoord(Qe) {
                            return Math.max(0, Math.min(this.d - 1, Math.floor(Qe * this.scale) + this.padding));
                        }
                        toArrayBuffer() {
                            if (this.arrayBuffer) return this.arrayBuffer;
                            const Qe = this.cells, rt = 3 + this.cells.length + 1 + 1;
                            let Wn = 0;
                            for(let Ll = 0; Ll < this.cells.length; Ll++)Wn += this.cells[Ll].length;
                            const Co = new Int32Array(rt + Wn + this.keys.length + this.bboxes.length);
                            Co[0] = this.extent, Co[1] = this.n, Co[2] = this.padding;
                            let Dl = rt;
                            for(let Ll = 0; Ll < Qe.length; Ll++){
                                const rt = Qe[Ll];
                                Co[3 + Ll] = Dl, Co.set(rt, Dl), Dl += rt.length;
                            }
                            return Co[3 + Qe.length] = Dl, Co.set(this.keys, Dl), Dl += this.keys.length, Co[3 + Qe.length + 1] = Dl, Co.set(this.bboxes, Dl), Dl += this.bboxes.length, Co.buffer;
                        }
                        static serialize(Qe, rt) {
                            const Wn = Qe.toArrayBuffer();
                            return rt && rt.push(Wn), {
                                buffer: Wn
                            };
                        }
                        static deserialize(Qe) {
                            return new z(Qe.buffer);
                        }
                    }
                    var Tc = {
                        $version: 8,
                        $root: {
                            version: {
                                required: !0,
                                type: "enum",
                                values: [
                                    8
                                ]
                            },
                            name: {
                                type: "string"
                            },
                            metadata: {
                                type: "*"
                            },
                            center: {
                                type: "array",
                                value: "number"
                            },
                            centerAltitude: {
                                type: "number"
                            },
                            zoom: {
                                type: "number"
                            },
                            bearing: {
                                type: "number",
                                default: 0,
                                period: 360,
                                units: "degrees"
                            },
                            pitch: {
                                type: "number",
                                default: 0,
                                units: "degrees"
                            },
                            roll: {
                                type: "number",
                                default: 0,
                                units: "degrees"
                            },
                            light: {
                                type: "light"
                            },
                            sky: {
                                type: "sky"
                            },
                            projection: {
                                type: "projection"
                            },
                            terrain: {
                                type: "terrain"
                            },
                            sources: {
                                required: !0,
                                type: "sources"
                            },
                            sprite: {
                                type: "sprite"
                            },
                            glyphs: {
                                type: "string"
                            },
                            transition: {
                                type: "transition"
                            },
                            layers: {
                                required: !0,
                                type: "array",
                                value: "layer"
                            }
                        },
                        sources: {
                            "*": {
                                type: "source"
                            }
                        },
                        source: [
                            "source_vector",
                            "source_raster",
                            "source_raster_dem",
                            "source_geojson",
                            "source_video",
                            "source_image"
                        ],
                        source_vector: {
                            type: {
                                required: !0,
                                type: "enum",
                                values: {
                                    vector: {}
                                }
                            },
                            url: {
                                type: "string"
                            },
                            tiles: {
                                type: "array",
                                value: "string"
                            },
                            bounds: {
                                type: "array",
                                value: "number",
                                length: 4,
                                default: [
                                    -180,
                                    -85.051129,
                                    180,
                                    85.051129
                                ]
                            },
                            scheme: {
                                type: "enum",
                                values: {
                                    xyz: {},
                                    tms: {}
                                },
                                default: "xyz"
                            },
                            minzoom: {
                                type: "number",
                                default: 0
                            },
                            maxzoom: {
                                type: "number",
                                default: 22
                            },
                            attribution: {
                                type: "string"
                            },
                            promoteId: {
                                type: "promoteId"
                            },
                            volatile: {
                                type: "boolean",
                                default: !1
                            },
                            "*": {
                                type: "*"
                            }
                        },
                        source_raster: {
                            type: {
                                required: !0,
                                type: "enum",
                                values: {
                                    raster: {}
                                }
                            },
                            url: {
                                type: "string"
                            },
                            tiles: {
                                type: "array",
                                value: "string"
                            },
                            bounds: {
                                type: "array",
                                value: "number",
                                length: 4,
                                default: [
                                    -180,
                                    -85.051129,
                                    180,
                                    85.051129
                                ]
                            },
                            minzoom: {
                                type: "number",
                                default: 0
                            },
                            maxzoom: {
                                type: "number",
                                default: 22
                            },
                            tileSize: {
                                type: "number",
                                default: 512,
                                units: "pixels"
                            },
                            scheme: {
                                type: "enum",
                                values: {
                                    xyz: {},
                                    tms: {}
                                },
                                default: "xyz"
                            },
                            attribution: {
                                type: "string"
                            },
                            volatile: {
                                type: "boolean",
                                default: !1
                            },
                            "*": {
                                type: "*"
                            }
                        },
                        source_raster_dem: {
                            type: {
                                required: !0,
                                type: "enum",
                                values: {
                                    "raster-dem": {}
                                }
                            },
                            url: {
                                type: "string"
                            },
                            tiles: {
                                type: "array",
                                value: "string"
                            },
                            bounds: {
                                type: "array",
                                value: "number",
                                length: 4,
                                default: [
                                    -180,
                                    -85.051129,
                                    180,
                                    85.051129
                                ]
                            },
                            minzoom: {
                                type: "number",
                                default: 0
                            },
                            maxzoom: {
                                type: "number",
                                default: 22
                            },
                            tileSize: {
                                type: "number",
                                default: 512,
                                units: "pixels"
                            },
                            attribution: {
                                type: "string"
                            },
                            encoding: {
                                type: "enum",
                                values: {
                                    terrarium: {},
                                    mapbox: {},
                                    custom: {}
                                },
                                default: "mapbox"
                            },
                            redFactor: {
                                type: "number",
                                default: 1
                            },
                            blueFactor: {
                                type: "number",
                                default: 1
                            },
                            greenFactor: {
                                type: "number",
                                default: 1
                            },
                            baseShift: {
                                type: "number",
                                default: 0
                            },
                            volatile: {
                                type: "boolean",
                                default: !1
                            },
                            "*": {
                                type: "*"
                            }
                        },
                        source_geojson: {
                            type: {
                                required: !0,
                                type: "enum",
                                values: {
                                    geojson: {}
                                }
                            },
                            data: {
                                required: !0,
                                type: "*"
                            },
                            maxzoom: {
                                type: "number",
                                default: 18
                            },
                            attribution: {
                                type: "string"
                            },
                            buffer: {
                                type: "number",
                                default: 128,
                                maximum: 512,
                                minimum: 0
                            },
                            filter: {
                                type: "*"
                            },
                            tolerance: {
                                type: "number",
                                default: .375
                            },
                            cluster: {
                                type: "boolean",
                                default: !1
                            },
                            clusterRadius: {
                                type: "number",
                                default: 50,
                                minimum: 0
                            },
                            clusterMaxZoom: {
                                type: "number"
                            },
                            clusterMinPoints: {
                                type: "number"
                            },
                            clusterProperties: {
                                type: "*"
                            },
                            lineMetrics: {
                                type: "boolean",
                                default: !1
                            },
                            generateId: {
                                type: "boolean",
                                default: !1
                            },
                            promoteId: {
                                type: "promoteId"
                            }
                        },
                        source_video: {
                            type: {
                                required: !0,
                                type: "enum",
                                values: {
                                    video: {}
                                }
                            },
                            urls: {
                                required: !0,
                                type: "array",
                                value: "string"
                            },
                            coordinates: {
                                required: !0,
                                type: "array",
                                length: 4,
                                value: {
                                    type: "array",
                                    length: 2,
                                    value: "number"
                                }
                            }
                        },
                        source_image: {
                            type: {
                                required: !0,
                                type: "enum",
                                values: {
                                    image: {}
                                }
                            },
                            url: {
                                required: !0,
                                type: "string"
                            },
                            coordinates: {
                                required: !0,
                                type: "array",
                                length: 4,
                                value: {
                                    type: "array",
                                    length: 2,
                                    value: "number"
                                }
                            }
                        },
                        layer: {
                            id: {
                                type: "string",
                                required: !0
                            },
                            type: {
                                type: "enum",
                                values: {
                                    fill: {},
                                    line: {},
                                    symbol: {},
                                    circle: {},
                                    heatmap: {},
                                    "fill-extrusion": {},
                                    raster: {},
                                    hillshade: {},
                                    background: {}
                                },
                                required: !0
                            },
                            metadata: {
                                type: "*"
                            },
                            source: {
                                type: "string"
                            },
                            "source-layer": {
                                type: "string"
                            },
                            minzoom: {
                                type: "number",
                                minimum: 0,
                                maximum: 24
                            },
                            maxzoom: {
                                type: "number",
                                minimum: 0,
                                maximum: 24
                            },
                            filter: {
                                type: "filter"
                            },
                            layout: {
                                type: "layout"
                            },
                            paint: {
                                type: "paint"
                            }
                        },
                        layout: [
                            "layout_fill",
                            "layout_line",
                            "layout_circle",
                            "layout_heatmap",
                            "layout_fill-extrusion",
                            "layout_symbol",
                            "layout_raster",
                            "layout_hillshade",
                            "layout_background"
                        ],
                        layout_background: {
                            visibility: {
                                type: "enum",
                                values: {
                                    visible: {},
                                    none: {}
                                },
                                default: "visible",
                                "property-type": "constant"
                            }
                        },
                        layout_fill: {
                            "fill-sort-key": {
                                type: "number",
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom",
                                        "feature"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            visibility: {
                                type: "enum",
                                values: {
                                    visible: {},
                                    none: {}
                                },
                                default: "visible",
                                "property-type": "constant"
                            }
                        },
                        layout_circle: {
                            "circle-sort-key": {
                                type: "number",
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom",
                                        "feature"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            visibility: {
                                type: "enum",
                                values: {
                                    visible: {},
                                    none: {}
                                },
                                default: "visible",
                                "property-type": "constant"
                            }
                        },
                        layout_heatmap: {
                            visibility: {
                                type: "enum",
                                values: {
                                    visible: {},
                                    none: {}
                                },
                                default: "visible",
                                "property-type": "constant"
                            }
                        },
                        "layout_fill-extrusion": {
                            visibility: {
                                type: "enum",
                                values: {
                                    visible: {},
                                    none: {}
                                },
                                default: "visible",
                                "property-type": "constant"
                            }
                        },
                        layout_line: {
                            "line-cap": {
                                type: "enum",
                                values: {
                                    butt: {},
                                    round: {},
                                    square: {}
                                },
                                default: "butt",
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "line-join": {
                                type: "enum",
                                values: {
                                    bevel: {},
                                    round: {},
                                    miter: {}
                                },
                                default: "miter",
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom",
                                        "feature"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "line-miter-limit": {
                                type: "number",
                                default: 2,
                                requires: [
                                    {
                                        "line-join": "miter"
                                    }
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "line-round-limit": {
                                type: "number",
                                default: 1.05,
                                requires: [
                                    {
                                        "line-join": "round"
                                    }
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "line-sort-key": {
                                type: "number",
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom",
                                        "feature"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            visibility: {
                                type: "enum",
                                values: {
                                    visible: {},
                                    none: {}
                                },
                                default: "visible",
                                "property-type": "constant"
                            }
                        },
                        layout_symbol: {
                            "symbol-placement": {
                                type: "enum",
                                values: {
                                    point: {},
                                    line: {},
                                    "line-center": {}
                                },
                                default: "point",
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "symbol-spacing": {
                                type: "number",
                                default: 250,
                                minimum: 1,
                                units: "pixels",
                                requires: [
                                    {
                                        "symbol-placement": "line"
                                    }
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "symbol-avoid-edges": {
                                type: "boolean",
                                default: !1,
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "symbol-sort-key": {
                                type: "number",
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom",
                                        "feature"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "symbol-z-order": {
                                type: "enum",
                                values: {
                                    auto: {},
                                    "viewport-y": {},
                                    source: {}
                                },
                                default: "auto",
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "icon-allow-overlap": {
                                type: "boolean",
                                default: !1,
                                requires: [
                                    "icon-image",
                                    {
                                        "!": "icon-overlap"
                                    }
                                ],
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "icon-overlap": {
                                type: "enum",
                                values: {
                                    never: {},
                                    always: {},
                                    cooperative: {}
                                },
                                requires: [
                                    "icon-image"
                                ],
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "icon-ignore-placement": {
                                type: "boolean",
                                default: !1,
                                requires: [
                                    "icon-image"
                                ],
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "icon-optional": {
                                type: "boolean",
                                default: !1,
                                requires: [
                                    "icon-image",
                                    "text-field"
                                ],
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "icon-rotation-alignment": {
                                type: "enum",
                                values: {
                                    map: {},
                                    viewport: {},
                                    auto: {}
                                },
                                default: "auto",
                                requires: [
                                    "icon-image"
                                ],
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "icon-size": {
                                type: "number",
                                default: 1,
                                minimum: 0,
                                units: "factor of the original icon size",
                                requires: [
                                    "icon-image"
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "icon-text-fit": {
                                type: "enum",
                                values: {
                                    none: {},
                                    width: {},
                                    height: {},
                                    both: {}
                                },
                                default: "none",
                                requires: [
                                    "icon-image",
                                    "text-field"
                                ],
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "icon-text-fit-padding": {
                                type: "array",
                                value: "number",
                                length: 4,
                                default: [
                                    0,
                                    0,
                                    0,
                                    0
                                ],
                                units: "pixels",
                                requires: [
                                    "icon-image",
                                    "text-field",
                                    {
                                        "icon-text-fit": [
                                            "both",
                                            "width",
                                            "height"
                                        ]
                                    }
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "icon-image": {
                                type: "resolvedImage",
                                tokens: !0,
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom",
                                        "feature"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "icon-rotate": {
                                type: "number",
                                default: 0,
                                period: 360,
                                units: "degrees",
                                requires: [
                                    "icon-image"
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "icon-padding": {
                                type: "padding",
                                default: [
                                    2
                                ],
                                units: "pixels",
                                requires: [
                                    "icon-image"
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "icon-keep-upright": {
                                type: "boolean",
                                default: !1,
                                requires: [
                                    "icon-image",
                                    {
                                        "icon-rotation-alignment": "map"
                                    },
                                    {
                                        "symbol-placement": [
                                            "line",
                                            "line-center"
                                        ]
                                    }
                                ],
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "icon-offset": {
                                type: "array",
                                value: "number",
                                length: 2,
                                default: [
                                    0,
                                    0
                                ],
                                requires: [
                                    "icon-image"
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "icon-anchor": {
                                type: "enum",
                                values: {
                                    center: {},
                                    left: {},
                                    right: {},
                                    top: {},
                                    bottom: {},
                                    "top-left": {},
                                    "top-right": {},
                                    "bottom-left": {},
                                    "bottom-right": {}
                                },
                                default: "center",
                                requires: [
                                    "icon-image"
                                ],
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom",
                                        "feature"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "icon-pitch-alignment": {
                                type: "enum",
                                values: {
                                    map: {},
                                    viewport: {},
                                    auto: {}
                                },
                                default: "auto",
                                requires: [
                                    "icon-image"
                                ],
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "text-pitch-alignment": {
                                type: "enum",
                                values: {
                                    map: {},
                                    viewport: {},
                                    auto: {}
                                },
                                default: "auto",
                                requires: [
                                    "text-field"
                                ],
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "text-rotation-alignment": {
                                type: "enum",
                                values: {
                                    map: {},
                                    viewport: {},
                                    "viewport-glyph": {},
                                    auto: {}
                                },
                                default: "auto",
                                requires: [
                                    "text-field"
                                ],
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "text-field": {
                                type: "formatted",
                                default: "",
                                tokens: !0,
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom",
                                        "feature"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "text-font": {
                                type: "array",
                                value: "string",
                                default: [
                                    "Open Sans Regular",
                                    "Arial Unicode MS Regular"
                                ],
                                requires: [
                                    "text-field"
                                ],
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom",
                                        "feature"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "text-size": {
                                type: "number",
                                default: 16,
                                minimum: 0,
                                units: "pixels",
                                requires: [
                                    "text-field"
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "text-max-width": {
                                type: "number",
                                default: 10,
                                minimum: 0,
                                units: "ems",
                                requires: [
                                    "text-field"
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "text-line-height": {
                                type: "number",
                                default: 1.2,
                                units: "ems",
                                requires: [
                                    "text-field"
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "text-letter-spacing": {
                                type: "number",
                                default: 0,
                                units: "ems",
                                requires: [
                                    "text-field"
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "text-justify": {
                                type: "enum",
                                values: {
                                    auto: {},
                                    left: {},
                                    center: {},
                                    right: {}
                                },
                                default: "center",
                                requires: [
                                    "text-field"
                                ],
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom",
                                        "feature"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "text-radial-offset": {
                                type: "number",
                                units: "ems",
                                default: 0,
                                requires: [
                                    "text-field"
                                ],
                                "property-type": "data-driven",
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature"
                                    ]
                                }
                            },
                            "text-variable-anchor": {
                                type: "array",
                                value: "enum",
                                values: {
                                    center: {},
                                    left: {},
                                    right: {},
                                    top: {},
                                    bottom: {},
                                    "top-left": {},
                                    "top-right": {},
                                    "bottom-left": {},
                                    "bottom-right": {}
                                },
                                requires: [
                                    "text-field",
                                    {
                                        "symbol-placement": [
                                            "point"
                                        ]
                                    }
                                ],
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "text-variable-anchor-offset": {
                                type: "variableAnchorOffsetCollection",
                                requires: [
                                    "text-field",
                                    {
                                        "symbol-placement": [
                                            "point"
                                        ]
                                    }
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "text-anchor": {
                                type: "enum",
                                values: {
                                    center: {},
                                    left: {},
                                    right: {},
                                    top: {},
                                    bottom: {},
                                    "top-left": {},
                                    "top-right": {},
                                    "bottom-left": {},
                                    "bottom-right": {}
                                },
                                default: "center",
                                requires: [
                                    "text-field",
                                    {
                                        "!": "text-variable-anchor"
                                    }
                                ],
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom",
                                        "feature"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "text-max-angle": {
                                type: "number",
                                default: 45,
                                units: "degrees",
                                requires: [
                                    "text-field",
                                    {
                                        "symbol-placement": [
                                            "line",
                                            "line-center"
                                        ]
                                    }
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "text-writing-mode": {
                                type: "array",
                                value: "enum",
                                values: {
                                    horizontal: {},
                                    vertical: {}
                                },
                                requires: [
                                    "text-field",
                                    {
                                        "symbol-placement": [
                                            "point"
                                        ]
                                    }
                                ],
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "text-rotate": {
                                type: "number",
                                default: 0,
                                period: 360,
                                units: "degrees",
                                requires: [
                                    "text-field"
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "text-padding": {
                                type: "number",
                                default: 2,
                                minimum: 0,
                                units: "pixels",
                                requires: [
                                    "text-field"
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "text-keep-upright": {
                                type: "boolean",
                                default: !0,
                                requires: [
                                    "text-field",
                                    {
                                        "text-rotation-alignment": "map"
                                    },
                                    {
                                        "symbol-placement": [
                                            "line",
                                            "line-center"
                                        ]
                                    }
                                ],
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "text-transform": {
                                type: "enum",
                                values: {
                                    none: {},
                                    uppercase: {},
                                    lowercase: {}
                                },
                                default: "none",
                                requires: [
                                    "text-field"
                                ],
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom",
                                        "feature"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "text-offset": {
                                type: "array",
                                value: "number",
                                units: "ems",
                                length: 2,
                                default: [
                                    0,
                                    0
                                ],
                                requires: [
                                    "text-field",
                                    {
                                        "!": "text-radial-offset"
                                    }
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "text-allow-overlap": {
                                type: "boolean",
                                default: !1,
                                requires: [
                                    "text-field",
                                    {
                                        "!": "text-overlap"
                                    }
                                ],
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "text-overlap": {
                                type: "enum",
                                values: {
                                    never: {},
                                    always: {},
                                    cooperative: {}
                                },
                                requires: [
                                    "text-field"
                                ],
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "text-ignore-placement": {
                                type: "boolean",
                                default: !1,
                                requires: [
                                    "text-field"
                                ],
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "text-optional": {
                                type: "boolean",
                                default: !1,
                                requires: [
                                    "text-field",
                                    "icon-image"
                                ],
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            visibility: {
                                type: "enum",
                                values: {
                                    visible: {},
                                    none: {}
                                },
                                default: "visible",
                                "property-type": "constant"
                            }
                        },
                        layout_raster: {
                            visibility: {
                                type: "enum",
                                values: {
                                    visible: {},
                                    none: {}
                                },
                                default: "visible",
                                "property-type": "constant"
                            }
                        },
                        layout_hillshade: {
                            visibility: {
                                type: "enum",
                                values: {
                                    visible: {},
                                    none: {}
                                },
                                default: "visible",
                                "property-type": "constant"
                            }
                        },
                        filter: {
                            type: "array",
                            value: "*"
                        },
                        filter_operator: {
                            type: "enum",
                            values: {
                                "==": {},
                                "!=": {},
                                ">": {},
                                ">=": {},
                                "<": {},
                                "<=": {},
                                in: {},
                                "!in": {},
                                all: {},
                                any: {},
                                none: {},
                                has: {},
                                "!has": {}
                            }
                        },
                        geometry_type: {
                            type: "enum",
                            values: {
                                Point: {},
                                LineString: {},
                                Polygon: {}
                            }
                        },
                        function: {
                            expression: {
                                type: "expression"
                            },
                            stops: {
                                type: "array",
                                value: "function_stop"
                            },
                            base: {
                                type: "number",
                                default: 1,
                                minimum: 0
                            },
                            property: {
                                type: "string",
                                default: "$zoom"
                            },
                            type: {
                                type: "enum",
                                values: {
                                    identity: {},
                                    exponential: {},
                                    interval: {},
                                    categorical: {}
                                },
                                default: "exponential"
                            },
                            colorSpace: {
                                type: "enum",
                                values: {
                                    rgb: {},
                                    lab: {},
                                    hcl: {}
                                },
                                default: "rgb"
                            },
                            default: {
                                type: "*",
                                required: !1
                            }
                        },
                        function_stop: {
                            type: "array",
                            minimum: 0,
                            maximum: 24,
                            value: [
                                "number",
                                "color"
                            ],
                            length: 2
                        },
                        expression: {
                            type: "array",
                            value: "*",
                            minimum: 1
                        },
                        light: {
                            anchor: {
                                type: "enum",
                                default: "viewport",
                                values: {
                                    map: {},
                                    viewport: {}
                                },
                                "property-type": "data-constant",
                                transition: !1,
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                }
                            },
                            position: {
                                type: "array",
                                default: [
                                    1.15,
                                    210,
                                    30
                                ],
                                length: 3,
                                value: "number",
                                "property-type": "data-constant",
                                transition: !0,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                }
                            },
                            color: {
                                type: "color",
                                "property-type": "data-constant",
                                default: "#ffffff",
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                transition: !0
                            },
                            intensity: {
                                type: "number",
                                "property-type": "data-constant",
                                default: .5,
                                minimum: 0,
                                maximum: 1,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                transition: !0
                            }
                        },
                        sky: {
                            "sky-color": {
                                type: "color",
                                "property-type": "data-constant",
                                default: "#88C6FC",
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                transition: !0
                            },
                            "horizon-color": {
                                type: "color",
                                "property-type": "data-constant",
                                default: "#ffffff",
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                transition: !0
                            },
                            "fog-color": {
                                type: "color",
                                "property-type": "data-constant",
                                default: "#ffffff",
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                transition: !0
                            },
                            "fog-ground-blend": {
                                type: "number",
                                "property-type": "data-constant",
                                default: .5,
                                minimum: 0,
                                maximum: 1,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                transition: !0
                            },
                            "horizon-fog-blend": {
                                type: "number",
                                "property-type": "data-constant",
                                default: .8,
                                minimum: 0,
                                maximum: 1,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                transition: !0
                            },
                            "sky-horizon-blend": {
                                type: "number",
                                "property-type": "data-constant",
                                default: .8,
                                minimum: 0,
                                maximum: 1,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                transition: !0
                            },
                            "atmosphere-blend": {
                                type: "number",
                                "property-type": "data-constant",
                                default: .8,
                                minimum: 0,
                                maximum: 1,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                transition: !0
                            }
                        },
                        terrain: {
                            source: {
                                type: "string",
                                required: !0
                            },
                            exaggeration: {
                                type: "number",
                                minimum: 0,
                                default: 1
                            }
                        },
                        projection: {
                            type: {
                                type: "projectionDefinition",
                                default: "mercator",
                                "property-type": "data-constant",
                                transition: !1,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                }
                            }
                        },
                        paint: [
                            "paint_fill",
                            "paint_line",
                            "paint_circle",
                            "paint_heatmap",
                            "paint_fill-extrusion",
                            "paint_symbol",
                            "paint_raster",
                            "paint_hillshade",
                            "paint_background"
                        ],
                        paint_fill: {
                            "fill-antialias": {
                                type: "boolean",
                                default: !0,
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "fill-opacity": {
                                type: "number",
                                default: 1,
                                minimum: 0,
                                maximum: 1,
                                transition: !0,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "fill-color": {
                                type: "color",
                                default: "#000000",
                                transition: !0,
                                requires: [
                                    {
                                        "!": "fill-pattern"
                                    }
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "fill-outline-color": {
                                type: "color",
                                transition: !0,
                                requires: [
                                    {
                                        "!": "fill-pattern"
                                    },
                                    {
                                        "fill-antialias": !0
                                    }
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "fill-translate": {
                                type: "array",
                                value: "number",
                                length: 2,
                                default: [
                                    0,
                                    0
                                ],
                                transition: !0,
                                units: "pixels",
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "fill-translate-anchor": {
                                type: "enum",
                                values: {
                                    map: {},
                                    viewport: {}
                                },
                                default: "map",
                                requires: [
                                    "fill-translate"
                                ],
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "fill-pattern": {
                                type: "resolvedImage",
                                transition: !0,
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom",
                                        "feature"
                                    ]
                                },
                                "property-type": "cross-faded-data-driven"
                            }
                        },
                        "paint_fill-extrusion": {
                            "fill-extrusion-opacity": {
                                type: "number",
                                default: 1,
                                minimum: 0,
                                maximum: 1,
                                transition: !0,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "fill-extrusion-color": {
                                type: "color",
                                default: "#000000",
                                transition: !0,
                                requires: [
                                    {
                                        "!": "fill-extrusion-pattern"
                                    }
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "fill-extrusion-translate": {
                                type: "array",
                                value: "number",
                                length: 2,
                                default: [
                                    0,
                                    0
                                ],
                                transition: !0,
                                units: "pixels",
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "fill-extrusion-translate-anchor": {
                                type: "enum",
                                values: {
                                    map: {},
                                    viewport: {}
                                },
                                default: "map",
                                requires: [
                                    "fill-extrusion-translate"
                                ],
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "fill-extrusion-pattern": {
                                type: "resolvedImage",
                                transition: !0,
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom",
                                        "feature"
                                    ]
                                },
                                "property-type": "cross-faded-data-driven"
                            },
                            "fill-extrusion-height": {
                                type: "number",
                                default: 0,
                                minimum: 0,
                                units: "meters",
                                transition: !0,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "fill-extrusion-base": {
                                type: "number",
                                default: 0,
                                minimum: 0,
                                units: "meters",
                                transition: !0,
                                requires: [
                                    "fill-extrusion-height"
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "fill-extrusion-vertical-gradient": {
                                type: "boolean",
                                default: !0,
                                transition: !1,
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            }
                        },
                        paint_line: {
                            "line-opacity": {
                                type: "number",
                                default: 1,
                                minimum: 0,
                                maximum: 1,
                                transition: !0,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "line-color": {
                                type: "color",
                                default: "#000000",
                                transition: !0,
                                requires: [
                                    {
                                        "!": "line-pattern"
                                    }
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "line-translate": {
                                type: "array",
                                value: "number",
                                length: 2,
                                default: [
                                    0,
                                    0
                                ],
                                transition: !0,
                                units: "pixels",
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "line-translate-anchor": {
                                type: "enum",
                                values: {
                                    map: {},
                                    viewport: {}
                                },
                                default: "map",
                                requires: [
                                    "line-translate"
                                ],
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "line-width": {
                                type: "number",
                                default: 1,
                                minimum: 0,
                                transition: !0,
                                units: "pixels",
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "line-gap-width": {
                                type: "number",
                                default: 0,
                                minimum: 0,
                                transition: !0,
                                units: "pixels",
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "line-offset": {
                                type: "number",
                                default: 0,
                                transition: !0,
                                units: "pixels",
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "line-blur": {
                                type: "number",
                                default: 0,
                                minimum: 0,
                                transition: !0,
                                units: "pixels",
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "line-dasharray": {
                                type: "array",
                                value: "number",
                                minimum: 0,
                                transition: !0,
                                units: "line widths",
                                requires: [
                                    {
                                        "!": "line-pattern"
                                    }
                                ],
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "cross-faded"
                            },
                            "line-pattern": {
                                type: "resolvedImage",
                                transition: !0,
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom",
                                        "feature"
                                    ]
                                },
                                "property-type": "cross-faded-data-driven"
                            },
                            "line-gradient": {
                                type: "color",
                                transition: !1,
                                requires: [
                                    {
                                        "!": "line-dasharray"
                                    },
                                    {
                                        "!": "line-pattern"
                                    },
                                    {
                                        source: "geojson",
                                        has: {
                                            lineMetrics: !0
                                        }
                                    }
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "line-progress"
                                    ]
                                },
                                "property-type": "color-ramp"
                            }
                        },
                        paint_circle: {
                            "circle-radius": {
                                type: "number",
                                default: 5,
                                minimum: 0,
                                transition: !0,
                                units: "pixels",
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "circle-color": {
                                type: "color",
                                default: "#000000",
                                transition: !0,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "circle-blur": {
                                type: "number",
                                default: 0,
                                transition: !0,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "circle-opacity": {
                                type: "number",
                                default: 1,
                                minimum: 0,
                                maximum: 1,
                                transition: !0,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "circle-translate": {
                                type: "array",
                                value: "number",
                                length: 2,
                                default: [
                                    0,
                                    0
                                ],
                                transition: !0,
                                units: "pixels",
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "circle-translate-anchor": {
                                type: "enum",
                                values: {
                                    map: {},
                                    viewport: {}
                                },
                                default: "map",
                                requires: [
                                    "circle-translate"
                                ],
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "circle-pitch-scale": {
                                type: "enum",
                                values: {
                                    map: {},
                                    viewport: {}
                                },
                                default: "map",
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "circle-pitch-alignment": {
                                type: "enum",
                                values: {
                                    map: {},
                                    viewport: {}
                                },
                                default: "viewport",
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "circle-stroke-width": {
                                type: "number",
                                default: 0,
                                minimum: 0,
                                transition: !0,
                                units: "pixels",
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "circle-stroke-color": {
                                type: "color",
                                default: "#000000",
                                transition: !0,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "circle-stroke-opacity": {
                                type: "number",
                                default: 1,
                                minimum: 0,
                                maximum: 1,
                                transition: !0,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            }
                        },
                        paint_heatmap: {
                            "heatmap-radius": {
                                type: "number",
                                default: 30,
                                minimum: 1,
                                transition: !0,
                                units: "pixels",
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "heatmap-weight": {
                                type: "number",
                                default: 1,
                                minimum: 0,
                                transition: !1,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "heatmap-intensity": {
                                type: "number",
                                default: 1,
                                minimum: 0,
                                transition: !0,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "heatmap-color": {
                                type: "color",
                                default: [
                                    "interpolate",
                                    [
                                        "linear"
                                    ],
                                    [
                                        "heatmap-density"
                                    ],
                                    0,
                                    "rgba(0, 0, 255, 0)",
                                    .1,
                                    "royalblue",
                                    .3,
                                    "cyan",
                                    .5,
                                    "lime",
                                    .7,
                                    "yellow",
                                    1,
                                    "red"
                                ],
                                transition: !1,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "heatmap-density"
                                    ]
                                },
                                "property-type": "color-ramp"
                            },
                            "heatmap-opacity": {
                                type: "number",
                                default: 1,
                                minimum: 0,
                                maximum: 1,
                                transition: !0,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            }
                        },
                        paint_symbol: {
                            "icon-opacity": {
                                type: "number",
                                default: 1,
                                minimum: 0,
                                maximum: 1,
                                transition: !0,
                                requires: [
                                    "icon-image"
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "icon-color": {
                                type: "color",
                                default: "#000000",
                                transition: !0,
                                requires: [
                                    "icon-image"
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "icon-halo-color": {
                                type: "color",
                                default: "rgba(0, 0, 0, 0)",
                                transition: !0,
                                requires: [
                                    "icon-image"
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "icon-halo-width": {
                                type: "number",
                                default: 0,
                                minimum: 0,
                                transition: !0,
                                units: "pixels",
                                requires: [
                                    "icon-image"
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "icon-halo-blur": {
                                type: "number",
                                default: 0,
                                minimum: 0,
                                transition: !0,
                                units: "pixels",
                                requires: [
                                    "icon-image"
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "icon-translate": {
                                type: "array",
                                value: "number",
                                length: 2,
                                default: [
                                    0,
                                    0
                                ],
                                transition: !0,
                                units: "pixels",
                                requires: [
                                    "icon-image"
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "icon-translate-anchor": {
                                type: "enum",
                                values: {
                                    map: {},
                                    viewport: {}
                                },
                                default: "map",
                                requires: [
                                    "icon-image",
                                    "icon-translate"
                                ],
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "text-opacity": {
                                type: "number",
                                default: 1,
                                minimum: 0,
                                maximum: 1,
                                transition: !0,
                                requires: [
                                    "text-field"
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "text-color": {
                                type: "color",
                                default: "#000000",
                                transition: !0,
                                overridable: !0,
                                requires: [
                                    "text-field"
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "text-halo-color": {
                                type: "color",
                                default: "rgba(0, 0, 0, 0)",
                                transition: !0,
                                requires: [
                                    "text-field"
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "text-halo-width": {
                                type: "number",
                                default: 0,
                                minimum: 0,
                                transition: !0,
                                units: "pixels",
                                requires: [
                                    "text-field"
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "text-halo-blur": {
                                type: "number",
                                default: 0,
                                minimum: 0,
                                transition: !0,
                                units: "pixels",
                                requires: [
                                    "text-field"
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "text-translate": {
                                type: "array",
                                value: "number",
                                length: 2,
                                default: [
                                    0,
                                    0
                                ],
                                transition: !0,
                                units: "pixels",
                                requires: [
                                    "text-field"
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "text-translate-anchor": {
                                type: "enum",
                                values: {
                                    map: {},
                                    viewport: {}
                                },
                                default: "map",
                                requires: [
                                    "text-field",
                                    "text-translate"
                                ],
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            }
                        },
                        paint_raster: {
                            "raster-opacity": {
                                type: "number",
                                default: 1,
                                minimum: 0,
                                maximum: 1,
                                transition: !0,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "raster-hue-rotate": {
                                type: "number",
                                default: 0,
                                period: 360,
                                transition: !0,
                                units: "degrees",
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "raster-brightness-min": {
                                type: "number",
                                default: 0,
                                minimum: 0,
                                maximum: 1,
                                transition: !0,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "raster-brightness-max": {
                                type: "number",
                                default: 1,
                                minimum: 0,
                                maximum: 1,
                                transition: !0,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "raster-saturation": {
                                type: "number",
                                default: 0,
                                minimum: -1,
                                maximum: 1,
                                transition: !0,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "raster-contrast": {
                                type: "number",
                                default: 0,
                                minimum: -1,
                                maximum: 1,
                                transition: !0,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "raster-resampling": {
                                type: "enum",
                                values: {
                                    linear: {},
                                    nearest: {}
                                },
                                default: "linear",
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "raster-fade-duration": {
                                type: "number",
                                default: 300,
                                minimum: 0,
                                transition: !1,
                                units: "milliseconds",
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            }
                        },
                        paint_hillshade: {
                            "hillshade-illumination-direction": {
                                type: "number",
                                default: 335,
                                minimum: 0,
                                maximum: 359,
                                transition: !1,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "hillshade-illumination-anchor": {
                                type: "enum",
                                values: {
                                    map: {},
                                    viewport: {}
                                },
                                default: "viewport",
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "hillshade-exaggeration": {
                                type: "number",
                                default: .5,
                                minimum: 0,
                                maximum: 1,
                                transition: !0,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "hillshade-shadow-color": {
                                type: "color",
                                default: "#000000",
                                transition: !0,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "hillshade-highlight-color": {
                                type: "color",
                                default: "#FFFFFF",
                                transition: !0,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "hillshade-accent-color": {
                                type: "color",
                                default: "#000000",
                                transition: !0,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            }
                        },
                        paint_background: {
                            "background-color": {
                                type: "color",
                                default: "#000000",
                                transition: !0,
                                requires: [
                                    {
                                        "!": "background-pattern"
                                    }
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "background-pattern": {
                                type: "resolvedImage",
                                transition: !0,
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "cross-faded"
                            },
                            "background-opacity": {
                                type: "number",
                                default: 1,
                                minimum: 0,
                                maximum: 1,
                                transition: !0,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            }
                        },
                        transition: {
                            duration: {
                                type: "number",
                                default: 300,
                                minimum: 0,
                                units: "milliseconds"
                            },
                            delay: {
                                type: "number",
                                default: 0,
                                minimum: 0,
                                units: "milliseconds"
                            }
                        },
                        "property-type": {
                            "data-driven": {
                                type: "property-type"
                            },
                            "cross-faded": {
                                type: "property-type"
                            },
                            "cross-faded-data-driven": {
                                type: "property-type"
                            },
                            "color-ramp": {
                                type: "property-type"
                            },
                            "data-constant": {
                                type: "property-type"
                            },
                            constant: {
                                type: "property-type"
                            }
                        },
                        promoteId: {
                            "*": {
                                type: "string"
                            }
                        }
                    };
                    const tu = [
                        "type",
                        "source",
                        "source-layer",
                        "minzoom",
                        "maxzoom",
                        "filter",
                        "layout"
                    ];
                    class B {
                        constructor(Qe, rt, Wn, Co){
                            this.message = (Qe ? `${Qe}: ` : "") + Wn, Co && (this.identifier = Co), null != rt && rt.__line__ && (this.line = rt.__line__);
                        }
                    }
                    function T(Qe) {
                        for(var rt = arguments.length, Wn = new Array(rt > 1 ? rt - 1 : 0), Co = 1; Co < rt; Co++)Wn[Co - 1] = arguments[Co];
                        for (const Dl of Wn)for(const rt in Dl)Qe[rt] = Dl[rt];
                        return Qe;
                    }
                    class V extends Error {
                        constructor(Qe, rt){
                            super(rt), this.message = rt, this.key = Qe;
                        }
                    }
                    class E {
                        constructor(Qe, rt){
                            void 0 === rt && (rt = []), this.parent = Qe, this.bindings = {};
                            for (const [Wn, Co] of rt)this.bindings[Wn] = Co;
                        }
                        concat(Qe) {
                            return new E(this, Qe);
                        }
                        get(Qe) {
                            if (this.bindings[Qe]) return this.bindings[Qe];
                            if (this.parent) return this.parent.get(Qe);
                            throw new Error(`${Qe} not found in scope.`);
                        }
                        has(Qe) {
                            return !!this.bindings[Qe] || !!this.parent && this.parent.has(Qe);
                        }
                    }
                    const lu = {
                        kind: "null"
                    }, du = {
                        kind: "number"
                    }, fu = {
                        kind: "string"
                    }, yu = {
                        kind: "boolean"
                    }, Eu = {
                        kind: "color"
                    }, Tu = {
                        kind: "projectionDefinition"
                    }, Lu = {
                        kind: "object"
                    }, Zu = {
                        kind: "value"
                    }, Xu = {
                        kind: "collator"
                    }, Ju = {
                        kind: "formatted"
                    }, $u = {
                        kind: "padding"
                    }, ed = {
                        kind: "resolvedImage"
                    }, td = {
                        kind: "variableAnchorOffsetCollection"
                    };
                    function H(Qe, rt) {
                        return {
                            kind: "array",
                            itemType: Qe,
                            N: rt
                        };
                    }
                    function Y(Qe) {
                        if ("array" === Qe.kind) {
                            const rt = Y(Qe.itemType);
                            return "number" == typeof Qe.N ? `array<${rt}, ${Qe.N}>` : "value" === Qe.itemType.kind ? "array" : `array<${rt}>`;
                        }
                        return Qe.kind;
                    }
                    const id = [
                        lu,
                        du,
                        fu,
                        yu,
                        Eu,
                        Tu,
                        Ju,
                        Lu,
                        H(Zu),
                        $u,
                        ed,
                        td
                    ];
                    function K(Qe, rt) {
                        if ("error" === rt.kind) return null;
                        if ("array" === Qe.kind) {
                            if ("array" === rt.kind && (0 === rt.N && "value" === rt.itemType.kind || !K(Qe.itemType, rt.itemType)) && ("number" != typeof Qe.N || Qe.N === rt.N)) return null;
                        } else {
                            if (Qe.kind === rt.kind) return null;
                            if ("value" === Qe.kind) {
                                for (const Qe of id)if (!K(Qe, rt)) return null;
                            }
                        }
                        return `Expected ${Y(Qe)} but found ${Y(rt)} instead.`;
                    }
                    function W(Qe, rt) {
                        return rt.some((rt)=>rt.kind === Qe.kind);
                    }
                    function Q(Qe, rt) {
                        return rt.some((rt)=>"null" === rt ? null === Qe : "array" === rt ? Array.isArray(Qe) : "object" === rt ? Qe && !Array.isArray(Qe) && "object" == typeof Qe : rt === typeof Qe);
                    }
                    function tt(Qe, rt) {
                        return "array" === Qe.kind && "array" === rt.kind ? Qe.itemType.kind === rt.itemType.kind && "number" == typeof Qe.N : Qe.kind === rt.kind;
                    }
                    const nd = .96422, rd = .82521, sd = 4 / 29, ad = 6 / 29, od = 3 * ad * ad, ld = ad * ad * ad, cd = Math.PI / 180, ud = 180 / Math.PI;
                    function ut(Qe) {
                        return (Qe %= 360) < 0 && (Qe += 360), Qe;
                    }
                    function ct(Qe) {
                        let rt, Wn, [Co, Dl, Ll, Rl] = Qe;
                        const Ul = pt((.2225045 * (Co = ht(Co)) + .7168786 * (Dl = ht(Dl)) + .0606169 * (Ll = ht(Ll))) / 1);
                        Co === Dl && Dl === Ll ? rt = Wn = Ul : (rt = pt((.4360747 * Co + .3850649 * Dl + .1430804 * Ll) / nd), Wn = pt((.0139322 * Co + .0971045 * Dl + .7141733 * Ll) / rd));
                        const Gl = 116 * Ul - 16;
                        return [
                            Gl < 0 ? 0 : Gl,
                            500 * (rt - Ul),
                            200 * (Ul - Wn),
                            Rl
                        ];
                    }
                    function ht(Qe) {
                        return Qe <= .04045 ? Qe / 12.92 : Math.pow((Qe + .055) / 1.055, 2.4);
                    }
                    function pt(Qe) {
                        return Qe > ld ? Math.pow(Qe, 1 / 3) : Qe / od + sd;
                    }
                    function ft(Qe) {
                        let [rt, Wn, Co, Dl] = Qe, Ll = (rt + 16) / 116, Rl = isNaN(Wn) ? Ll : Ll + Wn / 500, Ul = isNaN(Co) ? Ll : Ll - Co / 200;
                        return Ll = 1 * yt(Ll), Rl = nd * yt(Rl), Ul = rd * yt(Ul), [
                            dt(3.1338561 * Rl - 1.6168667 * Ll - .4906146 * Ul),
                            dt(-0.9787684 * Rl + 1.9161415 * Ll + .033454 * Ul),
                            dt(.0719453 * Rl - .2289914 * Ll + 1.4052427 * Ul),
                            Dl
                        ];
                    }
                    function dt(Qe) {
                        return (Qe = Qe <= .00304 ? 12.92 * Qe : 1.055 * Math.pow(Qe, 1 / 2.4) - .055) < 0 ? 0 : Qe > 1 ? 1 : Qe;
                    }
                    function yt(Qe) {
                        return Qe > ad ? Qe * Qe * Qe : od * (Qe - sd);
                    }
                    function mt(Qe) {
                        return parseInt(Qe.padEnd(2, Qe), 16) / 255;
                    }
                    function gt(Qe, rt) {
                        return xt(rt ? Qe / 100 : Qe, 0, 1);
                    }
                    function xt(Qe, rt, Wn) {
                        return Math.min(Math.max(rt, Qe), Wn);
                    }
                    function vt(Qe) {
                        return !Qe.some(Number.isNaN);
                    }
                    const hd = {
                        aliceblue: [
                            240,
                            248,
                            255
                        ],
                        antiquewhite: [
                            250,
                            235,
                            215
                        ],
                        aqua: [
                            0,
                            255,
                            255
                        ],
                        aquamarine: [
                            127,
                            255,
                            212
                        ],
                        azure: [
                            240,
                            255,
                            255
                        ],
                        beige: [
                            245,
                            245,
                            220
                        ],
                        bisque: [
                            255,
                            228,
                            196
                        ],
                        black: [
                            0,
                            0,
                            0
                        ],
                        blanchedalmond: [
                            255,
                            235,
                            205
                        ],
                        blue: [
                            0,
                            0,
                            255
                        ],
                        blueviolet: [
                            138,
                            43,
                            226
                        ],
                        brown: [
                            165,
                            42,
                            42
                        ],
                        burlywood: [
                            222,
                            184,
                            135
                        ],
                        cadetblue: [
                            95,
                            158,
                            160
                        ],
                        chartreuse: [
                            127,
                            255,
                            0
                        ],
                        chocolate: [
                            210,
                            105,
                            30
                        ],
                        coral: [
                            255,
                            127,
                            80
                        ],
                        cornflowerblue: [
                            100,
                            149,
                            237
                        ],
                        cornsilk: [
                            255,
                            248,
                            220
                        ],
                        crimson: [
                            220,
                            20,
                            60
                        ],
                        cyan: [
                            0,
                            255,
                            255
                        ],
                        darkblue: [
                            0,
                            0,
                            139
                        ],
                        darkcyan: [
                            0,
                            139,
                            139
                        ],
                        darkgoldenrod: [
                            184,
                            134,
                            11
                        ],
                        darkgray: [
                            169,
                            169,
                            169
                        ],
                        darkgreen: [
                            0,
                            100,
                            0
                        ],
                        darkgrey: [
                            169,
                            169,
                            169
                        ],
                        darkkhaki: [
                            189,
                            183,
                            107
                        ],
                        darkmagenta: [
                            139,
                            0,
                            139
                        ],
                        darkolivegreen: [
                            85,
                            107,
                            47
                        ],
                        darkorange: [
                            255,
                            140,
                            0
                        ],
                        darkorchid: [
                            153,
                            50,
                            204
                        ],
                        darkred: [
                            139,
                            0,
                            0
                        ],
                        darksalmon: [
                            233,
                            150,
                            122
                        ],
                        darkseagreen: [
                            143,
                            188,
                            143
                        ],
                        darkslateblue: [
                            72,
                            61,
                            139
                        ],
                        darkslategray: [
                            47,
                            79,
                            79
                        ],
                        darkslategrey: [
                            47,
                            79,
                            79
                        ],
                        darkturquoise: [
                            0,
                            206,
                            209
                        ],
                        darkviolet: [
                            148,
                            0,
                            211
                        ],
                        deeppink: [
                            255,
                            20,
                            147
                        ],
                        deepskyblue: [
                            0,
                            191,
                            255
                        ],
                        dimgray: [
                            105,
                            105,
                            105
                        ],
                        dimgrey: [
                            105,
                            105,
                            105
                        ],
                        dodgerblue: [
                            30,
                            144,
                            255
                        ],
                        firebrick: [
                            178,
                            34,
                            34
                        ],
                        floralwhite: [
                            255,
                            250,
                            240
                        ],
                        forestgreen: [
                            34,
                            139,
                            34
                        ],
                        fuchsia: [
                            255,
                            0,
                            255
                        ],
                        gainsboro: [
                            220,
                            220,
                            220
                        ],
                        ghostwhite: [
                            248,
                            248,
                            255
                        ],
                        gold: [
                            255,
                            215,
                            0
                        ],
                        goldenrod: [
                            218,
                            165,
                            32
                        ],
                        gray: [
                            128,
                            128,
                            128
                        ],
                        green: [
                            0,
                            128,
                            0
                        ],
                        greenyellow: [
                            173,
                            255,
                            47
                        ],
                        grey: [
                            128,
                            128,
                            128
                        ],
                        honeydew: [
                            240,
                            255,
                            240
                        ],
                        hotpink: [
                            255,
                            105,
                            180
                        ],
                        indianred: [
                            205,
                            92,
                            92
                        ],
                        indigo: [
                            75,
                            0,
                            130
                        ],
                        ivory: [
                            255,
                            255,
                            240
                        ],
                        khaki: [
                            240,
                            230,
                            140
                        ],
                        lavender: [
                            230,
                            230,
                            250
                        ],
                        lavenderblush: [
                            255,
                            240,
                            245
                        ],
                        lawngreen: [
                            124,
                            252,
                            0
                        ],
                        lemonchiffon: [
                            255,
                            250,
                            205
                        ],
                        lightblue: [
                            173,
                            216,
                            230
                        ],
                        lightcoral: [
                            240,
                            128,
                            128
                        ],
                        lightcyan: [
                            224,
                            255,
                            255
                        ],
                        lightgoldenrodyellow: [
                            250,
                            250,
                            210
                        ],
                        lightgray: [
                            211,
                            211,
                            211
                        ],
                        lightgreen: [
                            144,
                            238,
                            144
                        ],
                        lightgrey: [
                            211,
                            211,
                            211
                        ],
                        lightpink: [
                            255,
                            182,
                            193
                        ],
                        lightsalmon: [
                            255,
                            160,
                            122
                        ],
                        lightseagreen: [
                            32,
                            178,
                            170
                        ],
                        lightskyblue: [
                            135,
                            206,
                            250
                        ],
                        lightslategray: [
                            119,
                            136,
                            153
                        ],
                        lightslategrey: [
                            119,
                            136,
                            153
                        ],
                        lightsteelblue: [
                            176,
                            196,
                            222
                        ],
                        lightyellow: [
                            255,
                            255,
                            224
                        ],
                        lime: [
                            0,
                            255,
                            0
                        ],
                        limegreen: [
                            50,
                            205,
                            50
                        ],
                        linen: [
                            250,
                            240,
                            230
                        ],
                        magenta: [
                            255,
                            0,
                            255
                        ],
                        maroon: [
                            128,
                            0,
                            0
                        ],
                        mediumaquamarine: [
                            102,
                            205,
                            170
                        ],
                        mediumblue: [
                            0,
                            0,
                            205
                        ],
                        mediumorchid: [
                            186,
                            85,
                            211
                        ],
                        mediumpurple: [
                            147,
                            112,
                            219
                        ],
                        mediumseagreen: [
                            60,
                            179,
                            113
                        ],
                        mediumslateblue: [
                            123,
                            104,
                            238
                        ],
                        mediumspringgreen: [
                            0,
                            250,
                            154
                        ],
                        mediumturquoise: [
                            72,
                            209,
                            204
                        ],
                        mediumvioletred: [
                            199,
                            21,
                            133
                        ],
                        midnightblue: [
                            25,
                            25,
                            112
                        ],
                        mintcream: [
                            245,
                            255,
                            250
                        ],
                        mistyrose: [
                            255,
                            228,
                            225
                        ],
                        moccasin: [
                            255,
                            228,
                            181
                        ],
                        navajowhite: [
                            255,
                            222,
                            173
                        ],
                        navy: [
                            0,
                            0,
                            128
                        ],
                        oldlace: [
                            253,
                            245,
                            230
                        ],
                        olive: [
                            128,
                            128,
                            0
                        ],
                        olivedrab: [
                            107,
                            142,
                            35
                        ],
                        orange: [
                            255,
                            165,
                            0
                        ],
                        orangered: [
                            255,
                            69,
                            0
                        ],
                        orchid: [
                            218,
                            112,
                            214
                        ],
                        palegoldenrod: [
                            238,
                            232,
                            170
                        ],
                        palegreen: [
                            152,
                            251,
                            152
                        ],
                        paleturquoise: [
                            175,
                            238,
                            238
                        ],
                        palevioletred: [
                            219,
                            112,
                            147
                        ],
                        papayawhip: [
                            255,
                            239,
                            213
                        ],
                        peachpuff: [
                            255,
                            218,
                            185
                        ],
                        peru: [
                            205,
                            133,
                            63
                        ],
                        pink: [
                            255,
                            192,
                            203
                        ],
                        plum: [
                            221,
                            160,
                            221
                        ],
                        powderblue: [
                            176,
                            224,
                            230
                        ],
                        purple: [
                            128,
                            0,
                            128
                        ],
                        rebeccapurple: [
                            102,
                            51,
                            153
                        ],
                        red: [
                            255,
                            0,
                            0
                        ],
                        rosybrown: [
                            188,
                            143,
                            143
                        ],
                        royalblue: [
                            65,
                            105,
                            225
                        ],
                        saddlebrown: [
                            139,
                            69,
                            19
                        ],
                        salmon: [
                            250,
                            128,
                            114
                        ],
                        sandybrown: [
                            244,
                            164,
                            96
                        ],
                        seagreen: [
                            46,
                            139,
                            87
                        ],
                        seashell: [
                            255,
                            245,
                            238
                        ],
                        sienna: [
                            160,
                            82,
                            45
                        ],
                        silver: [
                            192,
                            192,
                            192
                        ],
                        skyblue: [
                            135,
                            206,
                            235
                        ],
                        slateblue: [
                            106,
                            90,
                            205
                        ],
                        slategray: [
                            112,
                            128,
                            144
                        ],
                        slategrey: [
                            112,
                            128,
                            144
                        ],
                        snow: [
                            255,
                            250,
                            250
                        ],
                        springgreen: [
                            0,
                            255,
                            127
                        ],
                        steelblue: [
                            70,
                            130,
                            180
                        ],
                        tan: [
                            210,
                            180,
                            140
                        ],
                        teal: [
                            0,
                            128,
                            128
                        ],
                        thistle: [
                            216,
                            191,
                            216
                        ],
                        tomato: [
                            255,
                            99,
                            71
                        ],
                        turquoise: [
                            64,
                            224,
                            208
                        ],
                        violet: [
                            238,
                            130,
                            238
                        ],
                        wheat: [
                            245,
                            222,
                            179
                        ],
                        white: [
                            255,
                            255,
                            255
                        ],
                        whitesmoke: [
                            245,
                            245,
                            245
                        ],
                        yellow: [
                            255,
                            255,
                            0
                        ],
                        yellowgreen: [
                            154,
                            205,
                            50
                        ]
                    };
                    function wt(Qe, rt, Wn) {
                        return Qe + Wn * (rt - Qe);
                    }
                    function _t(Qe, rt, Wn) {
                        return Qe.map((Qe, Co)=>wt(Qe, rt[Co], Wn));
                    }
                    class St {
                        constructor(Qe, rt, Wn, Co, Dl){
                            void 0 === Co && (Co = 1), void 0 === Dl && (Dl = !0), this.r = Qe, this.g = rt, this.b = Wn, this.a = Co, Dl || (this.r *= Co, this.g *= Co, this.b *= Co, Co || this.overwriteGetter("rgb", [
                                Qe,
                                rt,
                                Wn,
                                Co
                            ]));
                        }
                        static parse(Qe) {
                            if (Qe instanceof St) return Qe;
                            if ("string" != typeof Qe) return;
                            const rt = function(Qe) {
                                if ("transparent" === (Qe = Qe.toLowerCase().trim())) return [
                                    0,
                                    0,
                                    0,
                                    0
                                ];
                                const rt = hd[Qe];
                                if (rt) {
                                    const [Qe, Wn, Co] = rt;
                                    return [
                                        Qe / 255,
                                        Wn / 255,
                                        Co / 255,
                                        1
                                    ];
                                }
                                if (Qe.startsWith("#") && /^#(?:[0-9a-f]{3,4}|[0-9a-f]{6}|[0-9a-f]{8})$/.test(Qe)) {
                                    const rt = Qe.length < 6 ? 1 : 2;
                                    let Wn = 1;
                                    return [
                                        mt(Qe.slice(Wn, Wn += rt)),
                                        mt(Qe.slice(Wn, Wn += rt)),
                                        mt(Qe.slice(Wn, Wn += rt)),
                                        mt(Qe.slice(Wn, Wn + rt) || "ff")
                                    ];
                                }
                                if (Qe.startsWith("rgb")) {
                                    const rt = Qe.match(/^rgba?\(\s*([\de.+-]+)(%)?(?:\s+|\s*(,)\s*)([\de.+-]+)(%)?(?:\s+|\s*(,)\s*)([\de.+-]+)(%)?(?:\s*([,\/])\s*([\de.+-]+)(%)?)?\s*\)$/);
                                    if (rt) {
                                        const [Qe, Wn, Co, Dl, Ll, Rl, Ul, Gl, Zl, Hl, ql, Ql] = rt, Kl = [
                                            Dl || " ",
                                            Ul || " ",
                                            Hl
                                        ].join("");
                                        if ("  " === Kl || "  /" === Kl || ",," === Kl || ",,," === Kl) {
                                            const Qe = [
                                                Co,
                                                Rl,
                                                Zl
                                            ].join(""), rt = "%%%" === Qe ? 100 : "" === Qe ? 255 : 0;
                                            if (rt) {
                                                const Qe = [
                                                    xt(+Wn / rt, 0, 1),
                                                    xt(+Ll / rt, 0, 1),
                                                    xt(+Gl / rt, 0, 1),
                                                    ql ? gt(+ql, Ql) : 1
                                                ];
                                                if (vt(Qe)) return Qe;
                                            }
                                        }
                                        return;
                                    }
                                }
                                const Wn = Qe.match(/^hsla?\(\s*([\de.+-]+)(?:deg)?(?:\s+|\s*(,)\s*)([\de.+-]+)%(?:\s+|\s*(,)\s*)([\de.+-]+)%(?:\s*([,\/])\s*([\de.+-]+)(%)?)?\s*\)$/);
                                if (Wn) {
                                    const [Qe, rt, Co, Dl, Ll, Rl, Ul, Gl, Zl] = Wn, Hl = [
                                        Co || " ",
                                        Ll || " ",
                                        Ul
                                    ].join("");
                                    if ("  " === Hl || "  /" === Hl || ",," === Hl || ",,," === Hl) {
                                        const Qe = [
                                            +rt,
                                            xt(+Dl, 0, 100),
                                            xt(+Rl, 0, 100),
                                            Gl ? gt(+Gl, Zl) : 1
                                        ];
                                        if (vt(Qe)) return function(Qe) {
                                            let [rt, Wn, Co, Dl] = Qe;
                                            function i(Qe) {
                                                const Dl = (Qe + rt / 30) % 12, Ll = Wn * Math.min(Co, 1 - Co);
                                                return Co - Ll * Math.max(-1, Math.min(Dl - 3, 9 - Dl, 1));
                                            }
                                            return rt = ut(rt), Wn /= 100, Co /= 100, [
                                                i(0),
                                                i(8),
                                                i(4),
                                                Dl
                                            ];
                                        }(Qe);
                                    }
                                }
                            }(Qe);
                            return rt ? new St(...rt, !1) : void 0;
                        }
                        get rgb() {
                            const { r: Qe, g: rt, b: Wn, a: Co } = this, Dl = Co || 1 / 0;
                            return this.overwriteGetter("rgb", [
                                Qe / Dl,
                                rt / Dl,
                                Wn / Dl,
                                Co
                            ]);
                        }
                        get hcl() {
                            return this.overwriteGetter("hcl", function(Qe) {
                                const [rt, Wn, Co, Dl] = ct(Qe), Ll = Math.sqrt(Wn * Wn + Co * Co);
                                return [
                                    Math.round(1e4 * Ll) ? ut(Math.atan2(Co, Wn) * ud) : NaN,
                                    Ll,
                                    rt,
                                    Dl
                                ];
                            }(this.rgb));
                        }
                        get lab() {
                            return this.overwriteGetter("lab", ct(this.rgb));
                        }
                        overwriteGetter(Qe, rt) {
                            return Object.defineProperty(this, Qe, {
                                value: rt
                            }), rt;
                        }
                        toString() {
                            const [Qe, rt, Wn, Co] = this.rgb;
                            return `rgba(${[
                                Qe,
                                rt,
                                Wn
                            ].map((Qe)=>Math.round(255 * Qe)).join(",")},${Co})`;
                        }
                        static interpolate(Qe, rt, Wn, Co) {
                            switch(void 0 === Co && (Co = "rgb"), Co){
                                case "rgb":
                                    {
                                        const [Co, Dl, Ll, Rl] = _t(Qe.rgb, rt.rgb, Wn);
                                        return new St(Co, Dl, Ll, Rl, !1);
                                    }
                                case "hcl":
                                    {
                                        const [Co, Dl, Ll, Rl] = Qe.hcl, [Ul, Gl, Zl, Hl] = rt.hcl;
                                        let ql, Ql;
                                        if (isNaN(Co) || isNaN(Ul)) isNaN(Co) ? isNaN(Ul) ? ql = NaN : (ql = Ul, 1 !== Ll && 0 !== Ll || (Ql = Gl)) : (ql = Co, 1 !== Zl && 0 !== Zl || (Ql = Dl));
                                        else {
                                            let Qe = Ul - Co;
                                            Ul > Co && Qe > 180 ? Qe -= 360 : Ul < Co && Co - Ul > 180 && (Qe += 360), ql = Co + Wn * Qe;
                                        }
                                        const [Kl, $l, Tc, tu] = function(Qe) {
                                            let [rt, Wn, Co, Dl] = Qe;
                                            return rt = isNaN(rt) ? 0 : rt * cd, ft([
                                                Co,
                                                Math.cos(rt) * Wn,
                                                Math.sin(rt) * Wn,
                                                Dl
                                            ]);
                                        }([
                                            ql,
                                            null != Ql ? Ql : wt(Dl, Gl, Wn),
                                            wt(Ll, Zl, Wn),
                                            wt(Rl, Hl, Wn)
                                        ]);
                                        return new St(Kl, $l, Tc, tu, !1);
                                    }
                                case "lab":
                                    {
                                        const [Co, Dl, Ll, Rl] = ft(_t(Qe.lab, rt.lab, Wn));
                                        return new St(Co, Dl, Ll, Rl, !1);
                                    }
                            }
                        }
                    }
                    St.black = new St(0, 0, 0, 1), St.white = new St(1, 1, 1, 1), St.transparent = new St(0, 0, 0, 0), St.red = new St(1, 0, 0, 1);
                    class kt {
                        constructor(Qe, rt, Wn){
                            this.sensitivity = Qe ? rt ? "variant" : "case" : rt ? "accent" : "base", this.locale = Wn, this.collator = new Intl.Collator(this.locale ? this.locale : [], {
                                sensitivity: this.sensitivity,
                                usage: "search"
                            });
                        }
                        compare(Qe, rt) {
                            return this.collator.compare(Qe, rt);
                        }
                        resolvedLocale() {
                            return new Intl.Collator(this.locale ? this.locale : []).resolvedOptions().locale;
                        }
                    }
                    const dd = [
                        "bottom",
                        "center",
                        "top"
                    ];
                    class It {
                        constructor(Qe, rt, Wn, Co, Dl, Ll){
                            this.text = Qe, this.image = rt, this.scale = Wn, this.fontStack = Co, this.textColor = Dl, this.verticalAlign = Ll;
                        }
                    }
                    class Mt {
                        constructor(Qe){
                            this.sections = Qe;
                        }
                        static fromString(Qe) {
                            return new Mt([
                                new It(Qe, null, null, null, null, null)
                            ]);
                        }
                        isEmpty() {
                            return 0 === this.sections.length || !this.sections.some((Qe)=>0 !== Qe.text.length || Qe.image && 0 !== Qe.image.name.length);
                        }
                        static factory(Qe) {
                            return Qe instanceof Mt ? Qe : Mt.fromString(Qe);
                        }
                        toString() {
                            return 0 === this.sections.length ? "" : this.sections.map((Qe)=>Qe.text).join("");
                        }
                    }
                    class zt {
                        constructor(Qe){
                            this.values = Qe.slice();
                        }
                        static parse(Qe) {
                            if (Qe instanceof zt) return Qe;
                            if ("number" == typeof Qe) return new zt([
                                Qe,
                                Qe,
                                Qe,
                                Qe
                            ]);
                            if (Array.isArray(Qe) && !(Qe.length < 1 || Qe.length > 4)) {
                                for (const rt of Qe)if ("number" != typeof rt) return;
                                switch(Qe.length){
                                    case 1:
                                        Qe = [
                                            Qe[0],
                                            Qe[0],
                                            Qe[0],
                                            Qe[0]
                                        ];
                                        break;
                                    case 2:
                                        Qe = [
                                            Qe[0],
                                            Qe[1],
                                            Qe[0],
                                            Qe[1]
                                        ];
                                        break;
                                    case 3:
                                        Qe = [
                                            Qe[0],
                                            Qe[1],
                                            Qe[2],
                                            Qe[1]
                                        ];
                                }
                                return new zt(Qe);
                            }
                        }
                        toString() {
                            return JSON.stringify(this.values);
                        }
                        static interpolate(Qe, rt, Wn) {
                            return new zt(_t(Qe.values, rt.values, Wn));
                        }
                    }
                    class Pt {
                        constructor(Qe){
                            this.name = "ExpressionEvaluationError", this.message = Qe;
                        }
                        toJSON() {
                            return this.message;
                        }
                    }
                    const pd = new Set([
                        "center",
                        "left",
                        "right",
                        "top",
                        "bottom",
                        "top-left",
                        "top-right",
                        "bottom-left",
                        "bottom-right"
                    ]);
                    class Bt {
                        constructor(Qe){
                            this.values = Qe.slice();
                        }
                        static parse(Qe) {
                            if (Qe instanceof Bt) return Qe;
                            if (Array.isArray(Qe) && !(Qe.length < 1) && Qe.length % 2 == 0) {
                                for(let rt = 0; rt < Qe.length; rt += 2){
                                    const Wn = Qe[rt], Co = Qe[rt + 1];
                                    if ("string" != typeof Wn || !pd.has(Wn)) return;
                                    if (!Array.isArray(Co) || 2 !== Co.length || "number" != typeof Co[0] || "number" != typeof Co[1]) return;
                                }
                                return new Bt(Qe);
                            }
                        }
                        toString() {
                            return JSON.stringify(this.values);
                        }
                        static interpolate(Qe, rt, Wn) {
                            const Co = Qe.values, Dl = rt.values;
                            if (Co.length !== Dl.length) throw new Pt(`Cannot interpolate values of different length. from: ${Qe.toString()}, to: ${rt.toString()}`);
                            const Ll = [];
                            for(let Rl = 0; Rl < Co.length; Rl += 2){
                                if (Co[Rl] !== Dl[Rl]) throw new Pt(`Cannot interpolate values containing mismatched anchors. from[${Rl}]: ${Co[Rl]}, to[${Rl}]: ${Dl[Rl]}`);
                                Ll.push(Co[Rl]);
                                const [Qe, rt] = Co[Rl + 1], [Ul, Gl] = Dl[Rl + 1];
                                Ll.push([
                                    wt(Qe, Ul, Wn),
                                    wt(rt, Gl, Wn)
                                ]);
                            }
                            return new Bt(Ll);
                        }
                    }
                    class Tt {
                        constructor(Qe){
                            this.name = Qe.name, this.available = Qe.available;
                        }
                        toString() {
                            return this.name;
                        }
                        static fromString(Qe) {
                            return Qe ? new Tt({
                                name: Qe,
                                available: !1
                            }) : null;
                        }
                    }
                    class Vt {
                        constructor(Qe, rt, Wn){
                            this.from = Qe, this.to = rt, this.transition = Wn;
                        }
                        static interpolate(Qe, rt, Wn) {
                            return new Vt(Qe, rt, Wn);
                        }
                        static parse(Qe) {
                            return Qe instanceof Vt ? Qe : Array.isArray(Qe) && 3 === Qe.length && "string" == typeof Qe[0] && "string" == typeof Qe[1] && "number" == typeof Qe[2] ? new Vt(Qe[0], Qe[1], Qe[2]) : "object" == typeof Qe && "string" == typeof Qe.from && "string" == typeof Qe.to && "number" == typeof Qe.transition ? new Vt(Qe.from, Qe.to, Qe.transition) : "string" == typeof Qe ? new Vt(Qe, Qe, 1) : void 0;
                        }
                    }
                    function Et(Qe, rt, Wn, Co) {
                        return "number" == typeof Qe && Qe >= 0 && Qe <= 255 && "number" == typeof rt && rt >= 0 && rt <= 255 && "number" == typeof Wn && Wn >= 0 && Wn <= 255 ? void 0 === Co || "number" == typeof Co && Co >= 0 && Co <= 1 ? null : `Invalid rgba value [${[
                            Qe,
                            rt,
                            Wn,
                            Co
                        ].join(", ")}]: 'a' must be between 0 and 1.` : `Invalid rgba value [${("number" == typeof Co ? [
                            Qe,
                            rt,
                            Wn,
                            Co
                        ] : [
                            Qe,
                            rt,
                            Wn
                        ]).join(", ")}]: 'r', 'g', and 'b' must be between 0 and 255.`;
                    }
                    function Ft(Qe) {
                        if (null === Qe || "string" == typeof Qe || "boolean" == typeof Qe || "number" == typeof Qe || Qe instanceof Vt || Qe instanceof St || Qe instanceof kt || Qe instanceof Mt || Qe instanceof zt || Qe instanceof Bt || Qe instanceof Tt) return !0;
                        if (Array.isArray(Qe)) {
                            for (const rt of Qe)if (!Ft(rt)) return !1;
                            return !0;
                        }
                        if ("object" == typeof Qe) {
                            for(const rt in Qe)if (!Ft(Qe[rt])) return !1;
                            return !0;
                        }
                        return !1;
                    }
                    function Dt(Qe) {
                        if (null === Qe) return lu;
                        if ("string" == typeof Qe) return fu;
                        if ("boolean" == typeof Qe) return yu;
                        if ("number" == typeof Qe) return du;
                        if (Qe instanceof St) return Eu;
                        if (Qe instanceof Vt) return Tu;
                        if (Qe instanceof kt) return Xu;
                        if (Qe instanceof Mt) return Ju;
                        if (Qe instanceof zt) return $u;
                        if (Qe instanceof Bt) return td;
                        if (Qe instanceof Tt) return ed;
                        if (Array.isArray(Qe)) {
                            const rt = Qe.length;
                            let Wn;
                            for (const Co of Qe){
                                const Qe = Dt(Co);
                                if (Wn) {
                                    if (Wn === Qe) continue;
                                    Wn = Zu;
                                    break;
                                }
                                Wn = Qe;
                            }
                            return H(Wn || Zu, rt);
                        }
                        return Lu;
                    }
                    function Lt(Qe) {
                        const rt = typeof Qe;
                        return null === Qe ? "" : "string" === rt || "number" === rt || "boolean" === rt ? String(Qe) : Qe instanceof St || Qe instanceof Vt || Qe instanceof Mt || Qe instanceof zt || Qe instanceof Bt || Qe instanceof Tt ? Qe.toString() : JSON.stringify(Qe);
                    }
                    class $t {
                        constructor(Qe, rt){
                            this.type = Qe, this.value = rt;
                        }
                        static parse(Qe, rt) {
                            if (2 !== Qe.length) return rt.error(`'literal' expression requires exactly one argument, but found ${Qe.length - 1} instead.`);
                            if (!Ft(Qe[1])) return rt.error("invalid value");
                            const Wn = Qe[1];
                            let Co = Dt(Wn);
                            const Dl = rt.expectedType;
                            return "array" !== Co.kind || 0 !== Co.N || !Dl || "array" !== Dl.kind || "number" == typeof Dl.N && 0 !== Dl.N || (Co = Dl), new $t(Co, Wn);
                        }
                        evaluate() {
                            return this.value;
                        }
                        eachChild() {}
                        outputDefined() {
                            return !0;
                        }
                    }
                    const md = {
                        string: fu,
                        number: du,
                        boolean: yu,
                        object: Lu
                    };
                    class Rt {
                        constructor(Qe, rt){
                            this.type = Qe, this.args = rt;
                        }
                        static parse(Qe, rt) {
                            if (Qe.length < 2) return rt.error("Expected at least one argument.");
                            let Wn, Co = 1;
                            const Dl = Qe[0];
                            if ("array" === Dl) {
                                let Dl, Ll;
                                if (Qe.length > 2) {
                                    const Wn = Qe[1];
                                    if ("string" != typeof Wn || !(Wn in md) || "object" === Wn) return rt.error('The item type argument of "array" must be one of string, number, boolean', 1);
                                    Dl = md[Wn], Co++;
                                } else Dl = Zu;
                                if (Qe.length > 3) {
                                    if (null !== Qe[2] && ("number" != typeof Qe[2] || Qe[2] < 0 || Qe[2] !== Math.floor(Qe[2]))) return rt.error('The length argument to "array" must be a positive integer literal', 2);
                                    Ll = Qe[2], Co++;
                                }
                                Wn = H(Dl, Ll);
                            } else {
                                if (!md[Dl]) throw new Error(`Types doesn't contain name = ${Dl}`);
                                Wn = md[Dl];
                            }
                            const Ll = [];
                            for(; Co < Qe.length; Co++){
                                const Wn = rt.parse(Qe[Co], Co, Zu);
                                if (!Wn) return null;
                                Ll.push(Wn);
                            }
                            return new Rt(Wn, Ll);
                        }
                        evaluate(Qe) {
                            for(let rt = 0; rt < this.args.length; rt++){
                                const Wn = this.args[rt].evaluate(Qe);
                                if (!K(this.type, Dt(Wn))) return Wn;
                                if (rt === this.args.length - 1) throw new Pt(`Expected value to be of type ${Y(this.type)}, but found ${Y(Dt(Wn))} instead.`);
                            }
                            throw new Error;
                        }
                        eachChild(Qe) {
                            this.args.forEach(Qe);
                        }
                        outputDefined() {
                            return this.args.every((Qe)=>Qe.outputDefined());
                        }
                    }
                    const fd = {
                        "to-boolean": yu,
                        "to-color": Eu,
                        "to-number": du,
                        "to-string": fu
                    };
                    class jt {
                        constructor(Qe, rt){
                            this.type = Qe, this.args = rt;
                        }
                        static parse(Qe, rt) {
                            if (Qe.length < 2) return rt.error("Expected at least one argument.");
                            const Wn = Qe[0];
                            if (!fd[Wn]) throw new Error(`Can't parse ${Wn} as it is not part of the known types`);
                            if (("to-boolean" === Wn || "to-string" === Wn) && 2 !== Qe.length) return rt.error("Expected one argument.");
                            const Co = fd[Wn], Dl = [];
                            for(let Ll = 1; Ll < Qe.length; Ll++){
                                const Wn = rt.parse(Qe[Ll], Ll, Zu);
                                if (!Wn) return null;
                                Dl.push(Wn);
                            }
                            return new jt(Co, Dl);
                        }
                        evaluate(Qe) {
                            switch(this.type.kind){
                                case "boolean":
                                    return Boolean(this.args[0].evaluate(Qe));
                                case "color":
                                    {
                                        let rt, Wn;
                                        for (const Co of this.args){
                                            if (rt = Co.evaluate(Qe), Wn = null, rt instanceof St) return rt;
                                            if ("string" == typeof rt) {
                                                const Wn = Qe.parseColor(rt);
                                                if (Wn) return Wn;
                                            } else if (Array.isArray(rt) && (Wn = rt.length < 3 || rt.length > 4 ? `Invalid rgba value ${JSON.stringify(rt)}: expected an array containing either three or four numeric values.` : Et(rt[0], rt[1], rt[2], rt[3]), !Wn)) return new St(rt[0] / 255, rt[1] / 255, rt[2] / 255, rt[3]);
                                        }
                                        throw new Pt(Wn || `Could not parse color from value '${"string" == typeof rt ? rt : JSON.stringify(rt)}'`);
                                    }
                                case "padding":
                                    {
                                        let rt;
                                        for (const Wn of this.args){
                                            rt = Wn.evaluate(Qe);
                                            const Co = zt.parse(rt);
                                            if (Co) return Co;
                                        }
                                        throw new Pt(`Could not parse padding from value '${"string" == typeof rt ? rt : JSON.stringify(rt)}'`);
                                    }
                                case "variableAnchorOffsetCollection":
                                    {
                                        let rt;
                                        for (const Wn of this.args){
                                            rt = Wn.evaluate(Qe);
                                            const Co = Bt.parse(rt);
                                            if (Co) return Co;
                                        }
                                        throw new Pt(`Could not parse variableAnchorOffsetCollection from value '${"string" == typeof rt ? rt : JSON.stringify(rt)}'`);
                                    }
                                case "number":
                                    {
                                        let rt = null;
                                        for (const Wn of this.args){
                                            if (rt = Wn.evaluate(Qe), null === rt) return 0;
                                            const Co = Number(rt);
                                            if (!isNaN(Co)) return Co;
                                        }
                                        throw new Pt(`Could not convert ${JSON.stringify(rt)} to number.`);
                                    }
                                case "formatted":
                                    return Mt.fromString(Lt(this.args[0].evaluate(Qe)));
                                case "resolvedImage":
                                    return Tt.fromString(Lt(this.args[0].evaluate(Qe)));
                                case "projectionDefinition":
                                    return this.args[0].evaluate(Qe);
                                default:
                                    return Lt(this.args[0].evaluate(Qe));
                            }
                        }
                        eachChild(Qe) {
                            this.args.forEach(Qe);
                        }
                        outputDefined() {
                            return this.args.every((Qe)=>Qe.outputDefined());
                        }
                    }
                    const gd = [
                        "Unknown",
                        "Point",
                        "LineString",
                        "Polygon"
                    ];
                    class Ut {
                        constructor(){
                            this.globals = null, this.feature = null, this.featureState = null, this.formattedSection = null, this._parseColorCache = {}, this.availableImages = null, this.canonical = null;
                        }
                        id() {
                            return this.feature && "id" in this.feature ? this.feature.id : null;
                        }
                        geometryType() {
                            return this.feature ? "number" == typeof this.feature.type ? gd[this.feature.type] : this.feature.type : null;
                        }
                        geometry() {
                            return this.feature && "geometry" in this.feature ? this.feature.geometry : null;
                        }
                        canonicalID() {
                            return this.canonical;
                        }
                        properties() {
                            return this.feature && this.feature.properties || {};
                        }
                        parseColor(Qe) {
                            let rt = this._parseColorCache[Qe];
                            return rt || (rt = this._parseColorCache[Qe] = St.parse(Qe)), rt;
                        }
                    }
                    class Gt {
                        constructor(Qe, rt, Wn, Co, Dl, Ll){
                            void 0 === Wn && (Wn = []), void 0 === Dl && (Dl = new E), void 0 === Ll && (Ll = []), this.registry = Qe, this.path = Wn, this.key = Wn.map((Qe)=>`[${Qe}]`).join(""), this.scope = Dl, this.errors = Ll, this.expectedType = Co, this._isConstant = rt;
                        }
                        parse(Qe, rt, Wn, Co, Dl) {
                            return void 0 === Dl && (Dl = {}), rt ? this.concat(rt, Wn, Co)._parse(Qe, Dl) : this._parse(Qe, Dl);
                        }
                        _parse(Qe, rt) {
                            function r(Qe, rt, Wn) {
                                return "assert" === Wn ? new Rt(rt, [
                                    Qe
                                ]) : "coerce" === Wn ? new jt(rt, [
                                    Qe
                                ]) : Qe;
                            }
                            if (null !== Qe && "string" != typeof Qe && "boolean" != typeof Qe && "number" != typeof Qe || (Qe = [
                                "literal",
                                Qe
                            ]), Array.isArray(Qe)) {
                                if (0 === Qe.length) return this.error('Expected an array with at least one element. If you wanted a literal array, use ["literal", []].');
                                const Wn = Qe[0];
                                if ("string" != typeof Wn) return this.error(`Expression name must be a string, but found ${typeof Wn} instead. If you wanted a literal array, use ["literal", [...]].`, 0), null;
                                const Co = this.registry[Wn];
                                if (Co) {
                                    let Wn = Co.parse(Qe, this);
                                    if (!Wn) return null;
                                    if (this.expectedType) {
                                        const Qe = this.expectedType, Co = Wn.type;
                                        if ("string" !== Qe.kind && "number" !== Qe.kind && "boolean" !== Qe.kind && "object" !== Qe.kind && "array" !== Qe.kind || "value" !== Co.kind) {
                                            if ("projectionDefinition" !== Qe.kind || "string" !== Co.kind && "array" !== Co.kind) {
                                                if ("color" !== Qe.kind && "formatted" !== Qe.kind && "resolvedImage" !== Qe.kind || "value" !== Co.kind && "string" !== Co.kind) {
                                                    if ("padding" !== Qe.kind || "value" !== Co.kind && "number" !== Co.kind && "array" !== Co.kind) {
                                                        if ("variableAnchorOffsetCollection" !== Qe.kind || "value" !== Co.kind && "array" !== Co.kind) {
                                                            if (this.checkSubtype(Qe, Co)) return null;
                                                        } else Wn = r(Wn, Qe, rt.typeAnnotation || "coerce");
                                                    } else Wn = r(Wn, Qe, rt.typeAnnotation || "coerce");
                                                } else Wn = r(Wn, Qe, rt.typeAnnotation || "coerce");
                                            } else Wn = r(Wn, Qe, rt.typeAnnotation || "coerce");
                                        } else Wn = r(Wn, Qe, rt.typeAnnotation || "assert");
                                    }
                                    if (!(Wn instanceof $t) && "resolvedImage" !== Wn.type.kind && this._isConstant(Wn)) {
                                        const rt = new Ut;
                                        try {
                                            Wn = new $t(Wn.type, Wn.evaluate(rt));
                                        } catch (Qe) {
                                            return this.error(Qe.message), null;
                                        }
                                    }
                                    return Wn;
                                }
                                return this.error(`Unknown expression "${Wn}". If you wanted a literal array, use ["literal", [...]].`, 0);
                            }
                            return this.error(void 0 === Qe ? "'undefined' value invalid. Use null instead." : "object" == typeof Qe ? 'Bare objects invalid. Use ["literal", {...}] instead.' : `Expected an array, but found ${typeof Qe} instead.`);
                        }
                        concat(Qe, rt, Wn) {
                            const Co = "number" == typeof Qe ? this.path.concat(Qe) : this.path, Dl = Wn ? this.scope.concat(Wn) : this.scope;
                            return new Gt(this.registry, this._isConstant, Co, rt || null, Dl, this.errors);
                        }
                        error(Qe) {
                            for(var rt = arguments.length, Wn = new Array(rt > 1 ? rt - 1 : 0), Co = 1; Co < rt; Co++)Wn[Co - 1] = arguments[Co];
                            const Dl = `${this.key}${Wn.map((Qe)=>`[${Qe}]`).join("")}`;
                            this.errors.push(new V(Dl, Qe));
                        }
                        checkSubtype(Qe, rt) {
                            const Wn = K(Qe, rt);
                            return Wn && this.error(Wn), Wn;
                        }
                    }
                    class Zt {
                        constructor(Qe, rt){
                            this.type = rt.type, this.bindings = [].concat(Qe), this.result = rt;
                        }
                        evaluate(Qe) {
                            return this.result.evaluate(Qe);
                        }
                        eachChild(Qe) {
                            for (const rt of this.bindings)Qe(rt[1]);
                            Qe(this.result);
                        }
                        static parse(Qe, rt) {
                            if (Qe.length < 4) return rt.error(`Expected at least 3 arguments, but found ${Qe.length - 1} instead.`);
                            const Wn = [];
                            for(let Dl = 1; Dl < Qe.length - 1; Dl += 2){
                                const Co = Qe[Dl];
                                if ("string" != typeof Co) return rt.error(`Expected string, but found ${typeof Co} instead.`, Dl);
                                if (/[^a-zA-Z0-9_]/.test(Co)) return rt.error("Variable names must contain only alphanumeric characters or '_'.", Dl);
                                const Ll = rt.parse(Qe[Dl + 1], Dl + 1);
                                if (!Ll) return null;
                                Wn.push([
                                    Co,
                                    Ll
                                ]);
                            }
                            const Co = rt.parse(Qe[Qe.length - 1], Qe.length - 1, rt.expectedType, Wn);
                            return Co ? new Zt(Wn, Co) : null;
                        }
                        outputDefined() {
                            return this.result.outputDefined();
                        }
                    }
                    class Xt {
                        constructor(Qe, rt){
                            this.type = rt.type, this.name = Qe, this.boundExpression = rt;
                        }
                        static parse(Qe, rt) {
                            if (2 !== Qe.length || "string" != typeof Qe[1]) return rt.error("'var' expression requires exactly one string literal argument.");
                            const Wn = Qe[1];
                            return rt.scope.has(Wn) ? new Xt(Wn, rt.scope.get(Wn)) : rt.error(`Unknown variable "${Wn}". Make sure "${Wn}" has been bound in an enclosing "let" expression before using it.`, 1);
                        }
                        evaluate(Qe) {
                            return this.boundExpression.evaluate(Qe);
                        }
                        eachChild() {}
                        outputDefined() {
                            return !1;
                        }
                    }
                    class Ht {
                        constructor(Qe, rt, Wn){
                            this.type = Qe, this.index = rt, this.input = Wn;
                        }
                        static parse(Qe, rt) {
                            if (3 !== Qe.length) return rt.error(`Expected 2 arguments, but found ${Qe.length - 1} instead.`);
                            const Wn = rt.parse(Qe[1], 1, du), Co = rt.parse(Qe[2], 2, H(rt.expectedType || Zu));
                            return Wn && Co ? new Ht(Co.type.itemType, Wn, Co) : null;
                        }
                        evaluate(Qe) {
                            const rt = this.index.evaluate(Qe), Wn = this.input.evaluate(Qe);
                            if (rt < 0) throw new Pt(`Array index out of bounds: ${rt} < 0.`);
                            if (rt >= Wn.length) throw new Pt(`Array index out of bounds: ${rt} > ${Wn.length - 1}.`);
                            if (rt !== Math.floor(rt)) throw new Pt(`Array index must be an integer, but found ${rt} instead.`);
                            return Wn[rt];
                        }
                        eachChild(Qe) {
                            Qe(this.index), Qe(this.input);
                        }
                        outputDefined() {
                            return !1;
                        }
                    }
                    class Yt {
                        constructor(Qe, rt){
                            this.type = yu, this.needle = Qe, this.haystack = rt;
                        }
                        static parse(Qe, rt) {
                            if (3 !== Qe.length) return rt.error(`Expected 2 arguments, but found ${Qe.length - 1} instead.`);
                            const Wn = rt.parse(Qe[1], 1, Zu), Co = rt.parse(Qe[2], 2, Zu);
                            return Wn && Co ? W(Wn.type, [
                                yu,
                                fu,
                                du,
                                lu,
                                Zu
                            ]) ? new Yt(Wn, Co) : rt.error(`Expected first argument to be of type boolean, string, number or null, but found ${Y(Wn.type)} instead`) : null;
                        }
                        evaluate(Qe) {
                            const rt = this.needle.evaluate(Qe), Wn = this.haystack.evaluate(Qe);
                            if (!Wn) return !1;
                            if (!Q(rt, [
                                "boolean",
                                "string",
                                "number",
                                "null"
                            ])) throw new Pt(`Expected first argument to be of type boolean, string, number or null, but found ${Y(Dt(rt))} instead.`);
                            if (!Q(Wn, [
                                "string",
                                "array"
                            ])) throw new Pt(`Expected second argument to be of type array or string, but found ${Y(Dt(Wn))} instead.`);
                            return Wn.indexOf(rt) >= 0;
                        }
                        eachChild(Qe) {
                            Qe(this.needle), Qe(this.haystack);
                        }
                        outputDefined() {
                            return !0;
                        }
                    }
                    class Jt {
                        constructor(Qe, rt, Wn){
                            this.type = du, this.needle = Qe, this.haystack = rt, this.fromIndex = Wn;
                        }
                        static parse(Qe, rt) {
                            if (Qe.length <= 2 || Qe.length >= 5) return rt.error(`Expected 3 or 4 arguments, but found ${Qe.length - 1} instead.`);
                            const Wn = rt.parse(Qe[1], 1, Zu), Co = rt.parse(Qe[2], 2, Zu);
                            if (!Wn || !Co) return null;
                            if (!W(Wn.type, [
                                yu,
                                fu,
                                du,
                                lu,
                                Zu
                            ])) return rt.error(`Expected first argument to be of type boolean, string, number or null, but found ${Y(Wn.type)} instead`);
                            if (4 === Qe.length) {
                                const Dl = rt.parse(Qe[3], 3, du);
                                return Dl ? new Jt(Wn, Co, Dl) : null;
                            }
                            return new Jt(Wn, Co);
                        }
                        evaluate(Qe) {
                            const rt = this.needle.evaluate(Qe), Wn = this.haystack.evaluate(Qe);
                            if (!Q(rt, [
                                "boolean",
                                "string",
                                "number",
                                "null"
                            ])) throw new Pt(`Expected first argument to be of type boolean, string, number or null, but found ${Y(Dt(rt))} instead.`);
                            let Co;
                            if (this.fromIndex && (Co = this.fromIndex.evaluate(Qe)), Q(Wn, [
                                "string"
                            ])) {
                                const Qe = Wn.indexOf(rt, Co);
                                return -1 === Qe ? -1 : [
                                    ...Wn.slice(0, Qe)
                                ].length;
                            }
                            if (Q(Wn, [
                                "array"
                            ])) return Wn.indexOf(rt, Co);
                            throw new Pt(`Expected second argument to be of type array or string, but found ${Y(Dt(Wn))} instead.`);
                        }
                        eachChild(Qe) {
                            Qe(this.needle), Qe(this.haystack), this.fromIndex && Qe(this.fromIndex);
                        }
                        outputDefined() {
                            return !1;
                        }
                    }
                    class Kt {
                        constructor(Qe, rt, Wn, Co, Dl, Ll){
                            this.inputType = Qe, this.type = rt, this.input = Wn, this.cases = Co, this.outputs = Dl, this.otherwise = Ll;
                        }
                        static parse(Qe, rt) {
                            if (Qe.length < 5) return rt.error(`Expected at least 4 arguments, but found only ${Qe.length - 1}.`);
                            if (Qe.length % 2 != 1) return rt.error("Expected an even number of arguments.");
                            let Wn, Co;
                            rt.expectedType && "value" !== rt.expectedType.kind && (Co = rt.expectedType);
                            const Dl = {}, Ll = [];
                            for(let Gl = 2; Gl < Qe.length - 1; Gl += 2){
                                let Rl = Qe[Gl];
                                const Ul = Qe[Gl + 1];
                                Array.isArray(Rl) || (Rl = [
                                    Rl
                                ]);
                                const Zl = rt.concat(Gl);
                                if (0 === Rl.length) return Zl.error("Expected at least one branch label.");
                                for (const Qe of Rl){
                                    if ("number" != typeof Qe && "string" != typeof Qe) return Zl.error("Branch labels must be numbers or strings.");
                                    if ("number" == typeof Qe && Math.abs(Qe) > Number.MAX_SAFE_INTEGER) return Zl.error(`Branch labels must be integers no larger than ${Number.MAX_SAFE_INTEGER}.`);
                                    if ("number" == typeof Qe && Math.floor(Qe) !== Qe) return Zl.error("Numeric branch labels must be integer values.");
                                    if (Wn) {
                                        if (Zl.checkSubtype(Wn, Dt(Qe))) return null;
                                    } else Wn = Dt(Qe);
                                    if (void 0 !== Dl[String(Qe)]) return Zl.error("Branch labels must be unique.");
                                    Dl[String(Qe)] = Ll.length;
                                }
                                const Hl = rt.parse(Ul, Gl, Co);
                                if (!Hl) return null;
                                Co = Co || Hl.type, Ll.push(Hl);
                            }
                            const Rl = rt.parse(Qe[1], 1, Zu);
                            if (!Rl) return null;
                            const Ul = rt.parse(Qe[Qe.length - 1], Qe.length - 1, Co);
                            return Ul ? "value" !== Rl.type.kind && rt.concat(1).checkSubtype(Wn, Rl.type) ? null : new Kt(Wn, Co, Rl, Dl, Ll, Ul) : null;
                        }
                        evaluate(Qe) {
                            const rt = this.input.evaluate(Qe);
                            return (Dt(rt) === this.inputType && this.outputs[this.cases[rt]] || this.otherwise).evaluate(Qe);
                        }
                        eachChild(Qe) {
                            Qe(this.input), this.outputs.forEach(Qe), Qe(this.otherwise);
                        }
                        outputDefined() {
                            return this.outputs.every((Qe)=>Qe.outputDefined()) && this.otherwise.outputDefined();
                        }
                    }
                    class Wt {
                        constructor(Qe, rt, Wn){
                            this.type = Qe, this.branches = rt, this.otherwise = Wn;
                        }
                        static parse(Qe, rt) {
                            if (Qe.length < 4) return rt.error(`Expected at least 3 arguments, but found only ${Qe.length - 1}.`);
                            if (Qe.length % 2 != 0) return rt.error("Expected an odd number of arguments.");
                            let Wn;
                            rt.expectedType && "value" !== rt.expectedType.kind && (Wn = rt.expectedType);
                            const Co = [];
                            for(let Ll = 1; Ll < Qe.length - 1; Ll += 2){
                                const Dl = rt.parse(Qe[Ll], Ll, yu);
                                if (!Dl) return null;
                                const Rl = rt.parse(Qe[Ll + 1], Ll + 1, Wn);
                                if (!Rl) return null;
                                Co.push([
                                    Dl,
                                    Rl
                                ]), Wn = Wn || Rl.type;
                            }
                            const Dl = rt.parse(Qe[Qe.length - 1], Qe.length - 1, Wn);
                            if (!Dl) return null;
                            if (!Wn) throw new Error("Can't infer output type");
                            return new Wt(Wn, Co, Dl);
                        }
                        evaluate(Qe) {
                            for (const [rt, Wn] of this.branches)if (rt.evaluate(Qe)) return Wn.evaluate(Qe);
                            return this.otherwise.evaluate(Qe);
                        }
                        eachChild(Qe) {
                            for (const [rt, Wn] of this.branches)Qe(rt), Qe(Wn);
                            Qe(this.otherwise);
                        }
                        outputDefined() {
                            return this.branches.every((Qe)=>{
                                let [rt, Wn] = Qe;
                                return Wn.outputDefined();
                            }) && this.otherwise.outputDefined();
                        }
                    }
                    class Qt {
                        constructor(Qe, rt, Wn, Co){
                            this.type = Qe, this.input = rt, this.beginIndex = Wn, this.endIndex = Co;
                        }
                        static parse(Qe, rt) {
                            if (Qe.length <= 2 || Qe.length >= 5) return rt.error(`Expected 3 or 4 arguments, but found ${Qe.length - 1} instead.`);
                            const Wn = rt.parse(Qe[1], 1, Zu), Co = rt.parse(Qe[2], 2, du);
                            if (!Wn || !Co) return null;
                            if (!W(Wn.type, [
                                H(Zu),
                                fu,
                                Zu
                            ])) return rt.error(`Expected first argument to be of type array or string, but found ${Y(Wn.type)} instead`);
                            if (4 === Qe.length) {
                                const Dl = rt.parse(Qe[3], 3, du);
                                return Dl ? new Qt(Wn.type, Wn, Co, Dl) : null;
                            }
                            return new Qt(Wn.type, Wn, Co);
                        }
                        evaluate(Qe) {
                            const rt = this.input.evaluate(Qe), Wn = this.beginIndex.evaluate(Qe);
                            let Co;
                            if (this.endIndex && (Co = this.endIndex.evaluate(Qe)), Q(rt, [
                                "string"
                            ])) return [
                                ...rt
                            ].slice(Wn, Co).join("");
                            if (Q(rt, [
                                "array"
                            ])) return rt.slice(Wn, Co);
                            throw new Pt(`Expected first argument to be of type array or string, but found ${Y(Dt(rt))} instead.`);
                        }
                        eachChild(Qe) {
                            Qe(this.input), Qe(this.beginIndex), this.endIndex && Qe(this.endIndex);
                        }
                        outputDefined() {
                            return !1;
                        }
                    }
                    function te(Qe, rt) {
                        const Wn = Qe.length - 1;
                        let Co, Dl, Ll = 0, Rl = Wn, Ul = 0;
                        for(; Ll <= Rl;)if (Ul = Math.floor((Ll + Rl) / 2), Co = Qe[Ul], Dl = Qe[Ul + 1], Co <= rt) {
                            if (Ul === Wn || rt < Dl) return Ul;
                            Ll = Ul + 1;
                        } else {
                            if (!(Co > rt)) throw new Pt("Input is not a number.");
                            Rl = Ul - 1;
                        }
                        return 0;
                    }
                    class ee {
                        constructor(Qe, rt, Wn){
                            this.type = Qe, this.input = rt, this.labels = [], this.outputs = [];
                            for (const [Co, Dl] of Wn)this.labels.push(Co), this.outputs.push(Dl);
                        }
                        static parse(Qe, rt) {
                            if (Qe.length - 1 < 4) return rt.error(`Expected at least 4 arguments, but found only ${Qe.length - 1}.`);
                            if ((Qe.length - 1) % 2 != 0) return rt.error("Expected an even number of arguments.");
                            const Wn = rt.parse(Qe[1], 1, du);
                            if (!Wn) return null;
                            const Co = [];
                            let Dl = null;
                            rt.expectedType && "value" !== rt.expectedType.kind && (Dl = rt.expectedType);
                            for(let Ll = 1; Ll < Qe.length; Ll += 2){
                                const Wn = 1 === Ll ? -1 / 0 : Qe[Ll], Rl = Qe[Ll + 1], Ul = Ll, Gl = Ll + 1;
                                if ("number" != typeof Wn) return rt.error('Input/output pairs for "step" expressions must be defined using literal numeric values (not computed expressions) for the input values.', Ul);
                                if (Co.length && Co[Co.length - 1][0] >= Wn) return rt.error('Input/output pairs for "step" expressions must be arranged with input values in strictly ascending order.', Ul);
                                const Zl = rt.parse(Rl, Gl, Dl);
                                if (!Zl) return null;
                                Dl = Dl || Zl.type, Co.push([
                                    Wn,
                                    Zl
                                ]);
                            }
                            return new ee(Dl, Wn, Co);
                        }
                        evaluate(Qe) {
                            const rt = this.labels, Wn = this.outputs;
                            if (1 === rt.length) return Wn[0].evaluate(Qe);
                            const Co = this.input.evaluate(Qe);
                            if (Co <= rt[0]) return Wn[0].evaluate(Qe);
                            const Dl = rt.length;
                            return Co >= rt[Dl - 1] ? Wn[Dl - 1].evaluate(Qe) : Wn[te(rt, Co)].evaluate(Qe);
                        }
                        eachChild(Qe) {
                            Qe(this.input);
                            for (const rt of this.outputs)Qe(rt);
                        }
                        outputDefined() {
                            return this.outputs.every((Qe)=>Qe.outputDefined());
                        }
                    }
                    var Ad, yd, vd = function() {
                        if (yd) return Ad;
                        function t(Qe, rt, Wn, Co) {
                            this.cx = 3 * Qe, this.bx = 3 * (Wn - Qe) - this.cx, this.ax = 1 - this.cx - this.bx, this.cy = 3 * rt, this.by = 3 * (Co - rt) - this.cy, this.ay = 1 - this.cy - this.by, this.p1x = Qe, this.p1y = rt, this.p2x = Wn, this.p2y = Co;
                        }
                        return yd = 1, Ad = t, t.prototype = {
                            sampleCurveX: function(Qe) {
                                return ((this.ax * Qe + this.bx) * Qe + this.cx) * Qe;
                            },
                            sampleCurveY: function(Qe) {
                                return ((this.ay * Qe + this.by) * Qe + this.cy) * Qe;
                            },
                            sampleCurveDerivativeX: function(Qe) {
                                return (3 * this.ax * Qe + 2 * this.bx) * Qe + this.cx;
                            },
                            solveCurveX: function(Qe, rt) {
                                if (void 0 === rt && (rt = 1e-6), Qe < 0) return 0;
                                if (Qe > 1) return 1;
                                for(var Wn = Qe, Co = 0; Co < 8; Co++){
                                    var Dl = this.sampleCurveX(Wn) - Qe;
                                    if (Math.abs(Dl) < rt) return Wn;
                                    var Ll = this.sampleCurveDerivativeX(Wn);
                                    if (Math.abs(Ll) < 1e-6) break;
                                    Wn -= Dl / Ll;
                                }
                                var Rl = 0, Ul = 1;
                                for(Wn = Qe, Co = 0; Co < 20 && (Dl = this.sampleCurveX(Wn), !(Math.abs(Dl - Qe) < rt)); Co++)Qe > Dl ? Rl = Wn : Ul = Wn, Wn = .5 * (Ul - Rl) + Rl;
                                return Wn;
                            },
                            solve: function(Qe, rt) {
                                return this.sampleCurveY(this.solveCurveX(Qe, rt));
                            }
                        }, Ad;
                    }(), _d = function(Qe) {
                        return Qe && Qe.__esModule && Object.prototype.hasOwnProperty.call(Qe, "default") ? Qe.default : Qe;
                    }(vd);
                    class ae {
                        constructor(Qe, rt, Wn, Co, Dl){
                            this.type = Qe, this.operator = rt, this.interpolation = Wn, this.input = Co, this.labels = [], this.outputs = [];
                            for (const [Ll, Rl] of Dl)this.labels.push(Ll), this.outputs.push(Rl);
                        }
                        static interpolationFactor(Qe, rt, Wn, Co) {
                            let Dl = 0;
                            if ("exponential" === Qe.name) Dl = le(rt, Qe.base, Wn, Co);
                            else if ("linear" === Qe.name) Dl = le(rt, 1, Wn, Co);
                            else if ("cubic-bezier" === Qe.name) {
                                const Ll = Qe.controlPoints;
                                Dl = new _d(Ll[0], Ll[1], Ll[2], Ll[3]).solve(le(rt, 1, Wn, Co));
                            }
                            return Dl;
                        }
                        static parse(Qe, rt) {
                            let [Wn, Co, Dl, ...Ll] = Qe;
                            if (!Array.isArray(Co) || 0 === Co.length) return rt.error("Expected an interpolation type expression.", 1);
                            if ("linear" === Co[0]) Co = {
                                name: "linear"
                            };
                            else if ("exponential" === Co[0]) {
                                const Qe = Co[1];
                                if ("number" != typeof Qe) return rt.error("Exponential interpolation requires a numeric base.", 1, 1);
                                Co = {
                                    name: "exponential",
                                    base: Qe
                                };
                            } else {
                                if ("cubic-bezier" !== Co[0]) return rt.error(`Unknown interpolation type ${String(Co[0])}`, 1, 0);
                                {
                                    const Qe = Co.slice(1);
                                    if (4 !== Qe.length || Qe.some((Qe)=>"number" != typeof Qe || Qe < 0 || Qe > 1)) return rt.error("Cubic bezier interpolation requires four numeric arguments with values between 0 and 1.", 1);
                                    Co = {
                                        name: "cubic-bezier",
                                        controlPoints: Qe
                                    };
                                }
                            }
                            if (Qe.length - 1 < 4) return rt.error(`Expected at least 4 arguments, but found only ${Qe.length - 1}.`);
                            if ((Qe.length - 1) % 2 != 0) return rt.error("Expected an even number of arguments.");
                            if (Dl = rt.parse(Dl, 2, du), !Dl) return null;
                            const Rl = [];
                            let Ul = null;
                            "interpolate-hcl" === Wn || "interpolate-lab" === Wn ? Ul = Eu : rt.expectedType && "value" !== rt.expectedType.kind && (Ul = rt.expectedType);
                            for(let Gl = 0; Gl < Ll.length; Gl += 2){
                                const Qe = Ll[Gl], Wn = Ll[Gl + 1], Co = Gl + 3, Dl = Gl + 4;
                                if ("number" != typeof Qe) return rt.error('Input/output pairs for "interpolate" expressions must be defined using literal numeric values (not computed expressions) for the input values.', Co);
                                if (Rl.length && Rl[Rl.length - 1][0] >= Qe) return rt.error('Input/output pairs for "interpolate" expressions must be arranged with input values in strictly ascending order.', Co);
                                const Zl = rt.parse(Wn, Dl, Ul);
                                if (!Zl) return null;
                                Ul = Ul || Zl.type, Rl.push([
                                    Qe,
                                    Zl
                                ]);
                            }
                            return tt(Ul, du) || tt(Ul, Tu) || tt(Ul, Eu) || tt(Ul, $u) || tt(Ul, td) || tt(Ul, H(du)) ? new ae(Ul, Wn, Co, Dl, Rl) : rt.error(`Type ${Y(Ul)} is not interpolatable.`);
                        }
                        evaluate(Qe) {
                            const rt = this.labels, Wn = this.outputs;
                            if (1 === rt.length) return Wn[0].evaluate(Qe);
                            const Co = this.input.evaluate(Qe);
                            if (Co <= rt[0]) return Wn[0].evaluate(Qe);
                            const Dl = rt.length;
                            if (Co >= rt[Dl - 1]) return Wn[Dl - 1].evaluate(Qe);
                            const Ll = te(rt, Co), Rl = ae.interpolationFactor(this.interpolation, Co, rt[Ll], rt[Ll + 1]), Ul = Wn[Ll].evaluate(Qe), Gl = Wn[Ll + 1].evaluate(Qe);
                            switch(this.operator){
                                case "interpolate":
                                    switch(this.type.kind){
                                        case "number":
                                            return wt(Ul, Gl, Rl);
                                        case "color":
                                            return St.interpolate(Ul, Gl, Rl);
                                        case "padding":
                                            return zt.interpolate(Ul, Gl, Rl);
                                        case "variableAnchorOffsetCollection":
                                            return Bt.interpolate(Ul, Gl, Rl);
                                        case "array":
                                            return _t(Ul, Gl, Rl);
                                        case "projectionDefinition":
                                            return Vt.interpolate(Ul, Gl, Rl);
                                    }
                                case "interpolate-hcl":
                                    return St.interpolate(Ul, Gl, Rl, "hcl");
                                case "interpolate-lab":
                                    return St.interpolate(Ul, Gl, Rl, "lab");
                            }
                        }
                        eachChild(Qe) {
                            Qe(this.input);
                            for (const rt of this.outputs)Qe(rt);
                        }
                        outputDefined() {
                            return this.outputs.every((Qe)=>Qe.outputDefined());
                        }
                    }
                    function le(Qe, rt, Wn, Co) {
                        const Dl = Co - Wn, Ll = Qe - Wn;
                        return 0 === Dl ? 0 : 1 === rt ? Ll / Dl : (Math.pow(rt, Ll) - 1) / (Math.pow(rt, Dl) - 1);
                    }
                    const xd = {
                        color: St.interpolate,
                        number: wt,
                        padding: zt.interpolate,
                        variableAnchorOffsetCollection: Bt.interpolate,
                        array: _t
                    };
                    class ce {
                        constructor(Qe, rt){
                            this.type = Qe, this.args = rt;
                        }
                        static parse(Qe, rt) {
                            if (Qe.length < 2) return rt.error("Expected at least one argument.");
                            let Wn = null;
                            const Co = rt.expectedType;
                            Co && "value" !== Co.kind && (Wn = Co);
                            const Dl = [];
                            for (const Rl of Qe.slice(1)){
                                const Qe = rt.parse(Rl, 1 + Dl.length, Wn, void 0, {
                                    typeAnnotation: "omit"
                                });
                                if (!Qe) return null;
                                Wn = Wn || Qe.type, Dl.push(Qe);
                            }
                            if (!Wn) throw new Error("No output type");
                            const Ll = Co && Dl.some((Qe)=>K(Co, Qe.type));
                            return new ce(Ll ? Zu : Wn, Dl);
                        }
                        evaluate(Qe) {
                            let rt, Wn = null, Co = 0;
                            for (const Dl of this.args)if (Co++, Wn = Dl.evaluate(Qe), Wn && Wn instanceof Tt && !Wn.available && (rt || (rt = Wn.name), Wn = null, Co === this.args.length && (Wn = rt)), null !== Wn) break;
                            return Wn;
                        }
                        eachChild(Qe) {
                            this.args.forEach(Qe);
                        }
                        outputDefined() {
                            return this.args.every((Qe)=>Qe.outputDefined());
                        }
                    }
                    function he(Qe, rt) {
                        return "==" === Qe || "!=" === Qe ? "boolean" === rt.kind || "string" === rt.kind || "number" === rt.kind || "null" === rt.kind || "value" === rt.kind : "string" === rt.kind || "number" === rt.kind || "value" === rt.kind;
                    }
                    function pe(Qe, rt, Wn, Co) {
                        return 0 === Co.compare(rt, Wn);
                    }
                    function fe(Qe, rt, Wn) {
                        const Co = "==" !== Qe && "!=" !== Qe;
                        return class i {
                            constructor(Qe, rt, Wn){
                                this.type = yu, this.lhs = Qe, this.rhs = rt, this.collator = Wn, this.hasUntypedArgument = "value" === Qe.type.kind || "value" === rt.type.kind;
                            }
                            static parse(Qe, rt) {
                                if (3 !== Qe.length && 4 !== Qe.length) return rt.error("Expected two or three arguments.");
                                const Wn = Qe[0];
                                let Dl = rt.parse(Qe[1], 1, Zu);
                                if (!Dl) return null;
                                if (!he(Wn, Dl.type)) return rt.concat(1).error(`"${Wn}" comparisons are not supported for type '${Y(Dl.type)}'.`);
                                let Ll = rt.parse(Qe[2], 2, Zu);
                                if (!Ll) return null;
                                if (!he(Wn, Ll.type)) return rt.concat(2).error(`"${Wn}" comparisons are not supported for type '${Y(Ll.type)}'.`);
                                if (Dl.type.kind !== Ll.type.kind && "value" !== Dl.type.kind && "value" !== Ll.type.kind) return rt.error(`Cannot compare types '${Y(Dl.type)}' and '${Y(Ll.type)}'.`);
                                Co && ("value" === Dl.type.kind && "value" !== Ll.type.kind ? Dl = new Rt(Ll.type, [
                                    Dl
                                ]) : "value" !== Dl.type.kind && "value" === Ll.type.kind && (Ll = new Rt(Dl.type, [
                                    Ll
                                ])));
                                let Rl = null;
                                if (4 === Qe.length) {
                                    if ("string" !== Dl.type.kind && "string" !== Ll.type.kind && "value" !== Dl.type.kind && "value" !== Ll.type.kind) return rt.error("Cannot use collator to compare non-string types.");
                                    if (Rl = rt.parse(Qe[3], 3, Xu), !Rl) return null;
                                }
                                return new i(Dl, Ll, Rl);
                            }
                            evaluate(Dl) {
                                const Ll = this.lhs.evaluate(Dl), Rl = this.rhs.evaluate(Dl);
                                if (Co && this.hasUntypedArgument) {
                                    const rt = Dt(Ll), Wn = Dt(Rl);
                                    if (rt.kind !== Wn.kind || "string" !== rt.kind && "number" !== rt.kind) throw new Pt(`Expected arguments for "${Qe}" to be (string, string) or (number, number), but found (${rt.kind}, ${Wn.kind}) instead.`);
                                }
                                if (this.collator && !Co && this.hasUntypedArgument) {
                                    const Qe = Dt(Ll), Wn = Dt(Rl);
                                    if ("string" !== Qe.kind || "string" !== Wn.kind) return rt(Dl, Ll, Rl);
                                }
                                return this.collator ? Wn(Dl, Ll, Rl, this.collator.evaluate(Dl)) : rt(Dl, Ll, Rl);
                            }
                            eachChild(Qe) {
                                Qe(this.lhs), Qe(this.rhs), this.collator && Qe(this.collator);
                            }
                            outputDefined() {
                                return !0;
                            }
                        };
                    }
                    const bd = fe("==", function(Qe, rt, Wn) {
                        return rt === Wn;
                    }, pe), wd = fe("!=", function(Qe, rt, Wn) {
                        return rt !== Wn;
                    }, function(Qe, rt, Wn, Co) {
                        return !pe(0, rt, Wn, Co);
                    }), Ed = fe("<", function(Qe, rt, Wn) {
                        return rt < Wn;
                    }, function(Qe, rt, Wn, Co) {
                        return Co.compare(rt, Wn) < 0;
                    }), Md = fe(">", function(Qe, rt, Wn) {
                        return rt > Wn;
                    }, function(Qe, rt, Wn, Co) {
                        return Co.compare(rt, Wn) > 0;
                    }), Sd = fe("<=", function(Qe, rt, Wn) {
                        return rt <= Wn;
                    }, function(Qe, rt, Wn, Co) {
                        return Co.compare(rt, Wn) <= 0;
                    }), Td = fe(">=", function(Qe, rt, Wn) {
                        return rt >= Wn;
                    }, function(Qe, rt, Wn, Co) {
                        return Co.compare(rt, Wn) >= 0;
                    });
                    class be {
                        constructor(Qe, rt, Wn){
                            this.type = Xu, this.locale = Wn, this.caseSensitive = Qe, this.diacriticSensitive = rt;
                        }
                        static parse(Qe, rt) {
                            if (2 !== Qe.length) return rt.error("Expected one argument.");
                            const Wn = Qe[1];
                            if ("object" != typeof Wn || Array.isArray(Wn)) return rt.error("Collator options argument must be an object.");
                            const Co = rt.parse(void 0 !== Wn["case-sensitive"] && Wn["case-sensitive"], 1, yu);
                            if (!Co) return null;
                            const Dl = rt.parse(void 0 !== Wn["diacritic-sensitive"] && Wn["diacritic-sensitive"], 1, yu);
                            if (!Dl) return null;
                            let Ll = null;
                            return Wn.locale && (Ll = rt.parse(Wn.locale, 1, fu), !Ll) ? null : new be(Co, Dl, Ll);
                        }
                        evaluate(Qe) {
                            return new kt(this.caseSensitive.evaluate(Qe), this.diacriticSensitive.evaluate(Qe), this.locale ? this.locale.evaluate(Qe) : null);
                        }
                        eachChild(Qe) {
                            Qe(this.caseSensitive), Qe(this.diacriticSensitive), this.locale && Qe(this.locale);
                        }
                        outputDefined() {
                            return !1;
                        }
                    }
                    class we {
                        constructor(Qe, rt, Wn, Co, Dl){
                            this.type = fu, this.number = Qe, this.locale = rt, this.currency = Wn, this.minFractionDigits = Co, this.maxFractionDigits = Dl;
                        }
                        static parse(Qe, rt) {
                            if (3 !== Qe.length) return rt.error("Expected two arguments.");
                            const Wn = rt.parse(Qe[1], 1, du);
                            if (!Wn) return null;
                            const Co = Qe[2];
                            if ("object" != typeof Co || Array.isArray(Co)) return rt.error("NumberFormat options argument must be an object.");
                            let Dl = null;
                            if (Co.locale && (Dl = rt.parse(Co.locale, 1, fu), !Dl)) return null;
                            let Ll = null;
                            if (Co.currency && (Ll = rt.parse(Co.currency, 1, fu), !Ll)) return null;
                            let Rl = null;
                            if (Co["min-fraction-digits"] && (Rl = rt.parse(Co["min-fraction-digits"], 1, du), !Rl)) return null;
                            let Ul = null;
                            return Co["max-fraction-digits"] && (Ul = rt.parse(Co["max-fraction-digits"], 1, du), !Ul) ? null : new we(Wn, Dl, Ll, Rl, Ul);
                        }
                        evaluate(Qe) {
                            return new Intl.NumberFormat(this.locale ? this.locale.evaluate(Qe) : [], {
                                style: this.currency ? "currency" : "decimal",
                                currency: this.currency ? this.currency.evaluate(Qe) : void 0,
                                minimumFractionDigits: this.minFractionDigits ? this.minFractionDigits.evaluate(Qe) : void 0,
                                maximumFractionDigits: this.maxFractionDigits ? this.maxFractionDigits.evaluate(Qe) : void 0
                            }).format(this.number.evaluate(Qe));
                        }
                        eachChild(Qe) {
                            Qe(this.number), this.locale && Qe(this.locale), this.currency && Qe(this.currency), this.minFractionDigits && Qe(this.minFractionDigits), this.maxFractionDigits && Qe(this.maxFractionDigits);
                        }
                        outputDefined() {
                            return !1;
                        }
                    }
                    class _e {
                        constructor(Qe){
                            this.type = Ju, this.sections = Qe;
                        }
                        static parse(Qe, rt) {
                            if (Qe.length < 2) return rt.error("Expected at least one argument.");
                            const Wn = Qe[1];
                            if (!Array.isArray(Wn) && "object" == typeof Wn) return rt.error("First argument must be an image or text section.");
                            const Co = [];
                            let Dl = !1;
                            for(let Ll = 1; Ll <= Qe.length - 1; ++Ll){
                                const Wn = Qe[Ll];
                                if (Dl && "object" == typeof Wn && !Array.isArray(Wn)) {
                                    Dl = !1;
                                    let Qe = null;
                                    if (Wn["font-scale"] && (Qe = rt.parse(Wn["font-scale"], 1, du), !Qe)) return null;
                                    let Ll = null;
                                    if (Wn["text-font"] && (Ll = rt.parse(Wn["text-font"], 1, H(fu)), !Ll)) return null;
                                    let Rl = null;
                                    if (Wn["text-color"] && (Rl = rt.parse(Wn["text-color"], 1, Eu), !Rl)) return null;
                                    let Ul = null;
                                    if (Wn["vertical-align"]) {
                                        if ("string" == typeof Wn["vertical-align"] && !dd.includes(Wn["vertical-align"])) return rt.error(`'vertical-align' must be one of: 'bottom', 'center', 'top' but found '${Wn["vertical-align"]}' instead.`);
                                        if (Ul = rt.parse(Wn["vertical-align"], 1, fu), !Ul) return null;
                                    }
                                    const Gl = Co[Co.length - 1];
                                    Gl.scale = Qe, Gl.font = Ll, Gl.textColor = Rl, Gl.verticalAlign = Ul;
                                } else {
                                    const Wn = rt.parse(Qe[Ll], 1, Zu);
                                    if (!Wn) return null;
                                    const Rl = Wn.type.kind;
                                    if ("string" !== Rl && "value" !== Rl && "null" !== Rl && "resolvedImage" !== Rl) return rt.error("Formatted text type must be 'string', 'value', 'image' or 'null'.");
                                    Dl = !0, Co.push({
                                        content: Wn,
                                        scale: null,
                                        font: null,
                                        textColor: null,
                                        verticalAlign: null
                                    });
                                }
                            }
                            return new _e(Co);
                        }
                        evaluate(Qe) {
                            return new Mt(this.sections.map((rt)=>{
                                const Wn = rt.content.evaluate(Qe);
                                return Dt(Wn) === ed ? new It("", Wn, null, null, null, rt.verticalAlign ? rt.verticalAlign.evaluate(Qe) : null) : new It(Lt(Wn), null, rt.scale ? rt.scale.evaluate(Qe) : null, rt.font ? rt.font.evaluate(Qe).join(",") : null, rt.textColor ? rt.textColor.evaluate(Qe) : null, rt.verticalAlign ? rt.verticalAlign.evaluate(Qe) : null);
                            }));
                        }
                        eachChild(Qe) {
                            for (const rt of this.sections)Qe(rt.content), rt.scale && Qe(rt.scale), rt.font && Qe(rt.font), rt.textColor && Qe(rt.textColor), rt.verticalAlign && Qe(rt.verticalAlign);
                        }
                        outputDefined() {
                            return !1;
                        }
                    }
                    class Se {
                        constructor(Qe){
                            this.type = ed, this.input = Qe;
                        }
                        static parse(Qe, rt) {
                            if (2 !== Qe.length) return rt.error("Expected two arguments.");
                            const Wn = rt.parse(Qe[1], 1, fu);
                            return Wn ? new Se(Wn) : rt.error("No image name provided.");
                        }
                        evaluate(Qe) {
                            const rt = this.input.evaluate(Qe), Wn = Tt.fromString(rt);
                            return Wn && Qe.availableImages && (Wn.available = Qe.availableImages.indexOf(rt) > -1), Wn;
                        }
                        eachChild(Qe) {
                            Qe(this.input);
                        }
                        outputDefined() {
                            return !1;
                        }
                    }
                    class ke {
                        constructor(Qe){
                            this.type = du, this.input = Qe;
                        }
                        static parse(Qe, rt) {
                            if (2 !== Qe.length) return rt.error(`Expected 1 argument, but found ${Qe.length - 1} instead.`);
                            const Wn = rt.parse(Qe[1], 1);
                            return Wn ? "array" !== Wn.type.kind && "string" !== Wn.type.kind && "value" !== Wn.type.kind ? rt.error(`Expected argument of type string or array, but found ${Y(Wn.type)} instead.`) : new ke(Wn) : null;
                        }
                        evaluate(Qe) {
                            const rt = this.input.evaluate(Qe);
                            if ("string" == typeof rt) return [
                                ...rt
                            ].length;
                            if (Array.isArray(rt)) return rt.length;
                            throw new Pt(`Expected value to be of type string or array, but found ${Y(Dt(rt))} instead.`);
                        }
                        eachChild(Qe) {
                            Qe(this.input);
                        }
                        outputDefined() {
                            return !1;
                        }
                    }
                    const Cd = 8192;
                    function Ie(Qe, rt) {
                        const Wn = (180 + Qe[0]) / 360, Co = (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + Qe[1] * Math.PI / 360))) / 360, Dl = Math.pow(2, rt.z);
                        return [
                            Math.round(Wn * Dl * Cd),
                            Math.round(Co * Dl * Cd)
                        ];
                    }
                    function Me(Qe, rt) {
                        const Wn = Math.pow(2, rt.z);
                        var Co, Dl;
                        return [
                            (Dl = (Qe[0] / Cd + rt.x) / Wn, 360 * Dl - 180),
                            (Co = (Qe[1] / Cd + rt.y) / Wn, 360 / Math.PI * Math.atan(Math.exp((180 - 360 * Co) * Math.PI / 180)) - 90)
                        ];
                    }
                    function ze(Qe, rt) {
                        Qe[0] = Math.min(Qe[0], rt[0]), Qe[1] = Math.min(Qe[1], rt[1]), Qe[2] = Math.max(Qe[2], rt[0]), Qe[3] = Math.max(Qe[3], rt[1]);
                    }
                    function Pe(Qe, rt) {
                        return !(Qe[0] <= rt[0] || Qe[2] >= rt[2] || Qe[1] <= rt[1] || Qe[3] >= rt[3]);
                    }
                    function Ce(Qe, rt, Wn) {
                        const Co = Qe[0] - rt[0], Dl = Qe[1] - rt[1], Ll = Qe[0] - Wn[0], Rl = Qe[1] - Wn[1];
                        return Co * Rl - Ll * Dl == 0 && Co * Ll <= 0 && Dl * Rl <= 0;
                    }
                    function Be(Qe, rt, Wn, Co) {
                        var Dl, Ll;
                        return 0 != (Dl = [
                            Co[0] - Wn[0],
                            Co[1] - Wn[1]
                        ])[0] * (Ll = [
                            rt[0] - Qe[0],
                            rt[1] - Qe[1]
                        ])[1] - Dl[1] * Ll[0] && !(!Le(Qe, rt, Wn, Co) || !Le(Wn, Co, Qe, rt));
                    }
                    function Te(Qe, rt, Wn) {
                        for (const Co of Wn)for(let Wn = 0; Wn < Co.length - 1; ++Wn)if (Be(Qe, rt, Co[Wn], Co[Wn + 1])) return !0;
                        return !1;
                    }
                    function Ve(Qe, rt, Wn) {
                        void 0 === Wn && (Wn = !1);
                        let Co = !1;
                        for (const Ul of rt)for(let rt = 0; rt < Ul.length - 1; rt++){
                            if (Ce(Qe, Ul[rt], Ul[rt + 1])) return Wn;
                            (Ll = Ul[rt])[1] > (Dl = Qe)[1] != (Rl = Ul[rt + 1])[1] > Dl[1] && Dl[0] < (Rl[0] - Ll[0]) * (Dl[1] - Ll[1]) / (Rl[1] - Ll[1]) + Ll[0] && (Co = !Co);
                        }
                        var Dl, Ll, Rl;
                        return Co;
                    }
                    function Ee(Qe, rt) {
                        for (const Wn of rt)if (Ve(Qe, Wn)) return !0;
                        return !1;
                    }
                    function Fe(Qe, rt) {
                        for (const Wn of Qe)if (!Ve(Wn, rt)) return !1;
                        for(let Wn = 0; Wn < Qe.length - 1; ++Wn)if (Te(Qe[Wn], Qe[Wn + 1], rt)) return !1;
                        return !0;
                    }
                    function De(Qe, rt) {
                        for (const Wn of rt)if (Fe(Qe, Wn)) return !0;
                        return !1;
                    }
                    function Le(Qe, rt, Wn, Co) {
                        const Dl = Co[0] - Wn[0], Ll = Co[1] - Wn[1], Rl = (Qe[0] - Wn[0]) * Ll - Dl * (Qe[1] - Wn[1]), Ul = (rt[0] - Wn[0]) * Ll - Dl * (rt[1] - Wn[1]);
                        return Rl > 0 && Ul < 0 || Rl < 0 && Ul > 0;
                    }
                    function $e(Qe, rt, Wn) {
                        const Co = [];
                        for(let Dl = 0; Dl < Qe.length; Dl++){
                            const Ll = [];
                            for(let Co = 0; Co < Qe[Dl].length; Co++){
                                const Rl = Ie(Qe[Dl][Co], Wn);
                                ze(rt, Rl), Ll.push(Rl);
                            }
                            Co.push(Ll);
                        }
                        return Co;
                    }
                    function Oe(Qe, rt, Wn) {
                        const Co = [];
                        for(let Dl = 0; Dl < Qe.length; Dl++){
                            const Ll = $e(Qe[Dl], rt, Wn);
                            Co.push(Ll);
                        }
                        return Co;
                    }
                    function Re(Qe, rt, Wn, Co) {
                        if (Qe[0] < Wn[0] || Qe[0] > Wn[2]) {
                            const rt = .5 * Co;
                            let Dl = Qe[0] - Wn[0] > rt ? -Co : Wn[0] - Qe[0] > rt ? Co : 0;
                            0 === Dl && (Dl = Qe[0] - Wn[2] > rt ? -Co : Wn[2] - Qe[0] > rt ? Co : 0), Qe[0] += Dl;
                        }
                        ze(rt, Qe);
                    }
                    function Ne(Qe, rt, Wn, Co) {
                        const Dl = Math.pow(2, Co.z) * Cd, Ll = [
                            Co.x * Cd,
                            Co.y * Cd
                        ], Rl = [];
                        for (const Ul of Qe)for (const Qe of Ul){
                            const Co = [
                                Qe.x + Ll[0],
                                Qe.y + Ll[1]
                            ];
                            Re(Co, rt, Wn, Dl), Rl.push(Co);
                        }
                        return Rl;
                    }
                    function je(Qe, rt, Wn, Co) {
                        const Dl = Math.pow(2, Co.z) * Cd, Ll = [
                            Co.x * Cd,
                            Co.y * Cd
                        ], Rl = [];
                        for (const Gl of Qe){
                            const Qe = [];
                            for (const Wn of Gl){
                                const Co = [
                                    Wn.x + Ll[0],
                                    Wn.y + Ll[1]
                                ];
                                ze(rt, Co), Qe.push(Co);
                            }
                            Rl.push(Qe);
                        }
                        if (rt[2] - rt[0] <= Dl / 2) {
                            (Ul = rt)[0] = Ul[1] = 1 / 0, Ul[2] = Ul[3] = -1 / 0;
                            for (const Qe of Rl)for (const Co of Qe)Re(Co, rt, Wn, Dl);
                        }
                        var Ul;
                        return Rl;
                    }
                    class qe {
                        constructor(Qe, rt){
                            this.type = yu, this.geojson = Qe, this.geometries = rt;
                        }
                        static parse(Qe, rt) {
                            if (2 !== Qe.length) return rt.error(`'within' expression requires exactly one argument, but found ${Qe.length - 1} instead.`);
                            if (Ft(Qe[1])) {
                                const rt = Qe[1];
                                if ("FeatureCollection" === rt.type) {
                                    const Qe = [];
                                    for (const Wn of rt.features){
                                        const { type: rt, coordinates: Co } = Wn.geometry;
                                        "Polygon" === rt && Qe.push(Co), "MultiPolygon" === rt && Qe.push(...Co);
                                    }
                                    if (Qe.length) return new qe(rt, {
                                        type: "MultiPolygon",
                                        coordinates: Qe
                                    });
                                } else if ("Feature" === rt.type) {
                                    const Qe = rt.geometry.type;
                                    if ("Polygon" === Qe || "MultiPolygon" === Qe) return new qe(rt, rt.geometry);
                                } else if ("Polygon" === rt.type || "MultiPolygon" === rt.type) return new qe(rt, rt);
                            }
                            return rt.error("'within' expression requires valid geojson object that contains polygon geometry type.");
                        }
                        evaluate(Qe) {
                            if (null != Qe.geometry() && null != Qe.canonicalID()) {
                                if ("Point" === Qe.geometryType()) return function(Qe, rt) {
                                    const Wn = [
                                        1 / 0,
                                        1 / 0,
                                        -1 / 0,
                                        -1 / 0
                                    ], Co = [
                                        1 / 0,
                                        1 / 0,
                                        -1 / 0,
                                        -1 / 0
                                    ], Dl = Qe.canonicalID();
                                    if ("Polygon" === rt.type) {
                                        const Ll = $e(rt.coordinates, Co, Dl), Rl = Ne(Qe.geometry(), Wn, Co, Dl);
                                        if (!Pe(Wn, Co)) return !1;
                                        for (const Qe of Rl)if (!Ve(Qe, Ll)) return !1;
                                    }
                                    if ("MultiPolygon" === rt.type) {
                                        const Ll = Oe(rt.coordinates, Co, Dl), Rl = Ne(Qe.geometry(), Wn, Co, Dl);
                                        if (!Pe(Wn, Co)) return !1;
                                        for (const Qe of Rl)if (!Ee(Qe, Ll)) return !1;
                                    }
                                    return !0;
                                }(Qe, this.geometries);
                                if ("LineString" === Qe.geometryType()) return function(Qe, rt) {
                                    const Wn = [
                                        1 / 0,
                                        1 / 0,
                                        -1 / 0,
                                        -1 / 0
                                    ], Co = [
                                        1 / 0,
                                        1 / 0,
                                        -1 / 0,
                                        -1 / 0
                                    ], Dl = Qe.canonicalID();
                                    if ("Polygon" === rt.type) {
                                        const Ll = $e(rt.coordinates, Co, Dl), Rl = je(Qe.geometry(), Wn, Co, Dl);
                                        if (!Pe(Wn, Co)) return !1;
                                        for (const Qe of Rl)if (!Fe(Qe, Ll)) return !1;
                                    }
                                    if ("MultiPolygon" === rt.type) {
                                        const Ll = Oe(rt.coordinates, Co, Dl), Rl = je(Qe.geometry(), Wn, Co, Dl);
                                        if (!Pe(Wn, Co)) return !1;
                                        for (const Qe of Rl)if (!De(Qe, Ll)) return !1;
                                    }
                                    return !0;
                                }(Qe, this.geometries);
                            }
                            return !1;
                        }
                        eachChild() {}
                        outputDefined() {
                            return !0;
                        }
                    }
                    let kd = class {
                        constructor(Qe, rt){
                            if (void 0 === Qe && (Qe = []), void 0 === rt && (rt = (Qe, rt)=>Qe < rt ? -1 : Qe > rt ? 1 : 0), this.data = Qe, this.length = this.data.length, this.compare = rt, this.length > 0) for(let Wn = (this.length >> 1) - 1; Wn >= 0; Wn--)this._down(Wn);
                        }
                        push(Qe) {
                            this.data.push(Qe), this._up(this.length++);
                        }
                        pop() {
                            if (0 === this.length) return;
                            const Qe = this.data[0], rt = this.data.pop();
                            return --this.length > 0 && (this.data[0] = rt, this._down(0)), Qe;
                        }
                        peek() {
                            return this.data[0];
                        }
                        _up(Qe) {
                            const { data: rt, compare: Wn } = this, Co = rt[Qe];
                            for(; Qe > 0;){
                                const Dl = Qe - 1 >> 1, Ll = rt[Dl];
                                if (Wn(Co, Ll) >= 0) break;
                                rt[Qe] = Ll, Qe = Dl;
                            }
                            rt[Qe] = Co;
                        }
                        _down(Qe) {
                            const { data: rt, compare: Wn } = this, Co = this.length >> 1, Dl = rt[Qe];
                            for(; Qe < Co;){
                                let Co = 1 + (Qe << 1);
                                const Ll = Co + 1;
                                if (Ll < this.length && Wn(rt[Ll], rt[Co]) < 0 && (Co = Ll), Wn(rt[Co], Dl) >= 0) break;
                                rt[Qe] = rt[Co], Qe = Co;
                            }
                            rt[Qe] = Dl;
                        }
                    };
                    function Ge(Qe, rt, Wn, Co, Dl) {
                        for(void 0 === Wn && (Wn = 0), void 0 === Co && (Co = Qe.length - 1), void 0 === Dl && (Dl = Xe); Co > Wn;){
                            if (Co - Wn > 600) {
                                const Ll = Co - Wn + 1, Rl = rt - Wn + 1, Ul = Math.log(Ll), Gl = .5 * Math.exp(2 * Ul / 3), Zl = .5 * Math.sqrt(Ul * Gl * (Ll - Gl) / Ll) * (Rl - Ll / 2 < 0 ? -1 : 1);
                                Ge(Qe, rt, Math.max(Wn, Math.floor(rt - Rl * Gl / Ll + Zl)), Math.min(Co, Math.floor(rt + (Ll - Rl) * Gl / Ll + Zl)), Dl);
                            }
                            const Ll = Qe[rt];
                            let Rl = Wn, Ul = Co;
                            for(Ze(Qe, Wn, rt), Dl(Qe[Co], Ll) > 0 && Ze(Qe, Wn, Co); Rl < Ul;){
                                for(Ze(Qe, Rl, Ul), Rl++, Ul--; Dl(Qe[Rl], Ll) < 0;)Rl++;
                                for(; Dl(Qe[Ul], Ll) > 0;)Ul--;
                            }
                            0 === Dl(Qe[Wn], Ll) ? Ze(Qe, Wn, Ul) : (Ul++, Ze(Qe, Ul, Co)), Ul <= rt && (Wn = Ul + 1), rt <= Ul && (Co = Ul - 1);
                        }
                    }
                    function Ze(Qe, rt, Wn) {
                        const Co = Qe[rt];
                        Qe[rt] = Qe[Wn], Qe[Wn] = Co;
                    }
                    function Xe(Qe, rt) {
                        return Qe < rt ? -1 : Qe > rt ? 1 : 0;
                    }
                    function He(Qe, rt) {
                        if (Qe.length <= 1) return [
                            Qe
                        ];
                        const Wn = [];
                        let Co, Dl;
                        for (const Ll of Qe){
                            const Qe = Je(Ll);
                            0 !== Qe && (Ll.area = Math.abs(Qe), void 0 === Dl && (Dl = Qe < 0), Dl === Qe < 0 ? (Co && Wn.push(Co), Co = [
                                Ll
                            ]) : Co.push(Ll));
                        }
                        if (Co && Wn.push(Co), rt > 1) for(let Ll = 0; Ll < Wn.length; Ll++)Wn[Ll].length <= rt || (Ge(Wn[Ll], rt, 1, Wn[Ll].length - 1, Ye), Wn[Ll] = Wn[Ll].slice(0, rt));
                        return Wn;
                    }
                    function Ye(Qe, rt) {
                        return rt.area - Qe.area;
                    }
                    function Je(Qe) {
                        let rt = 0;
                        for(let Wn, Co, Dl = 0, Ll = Qe.length, Rl = Ll - 1; Dl < Ll; Rl = Dl++)Wn = Qe[Dl], Co = Qe[Rl], rt += (Co.x - Wn.x) * (Wn.y + Co.y);
                        return rt;
                    }
                    const Id = 1 / 298.257223563, Dd = Id * (2 - Id), Ld = Math.PI / 180;
                    class tr {
                        constructor(Qe){
                            const rt = 6378.137 * Ld * 1e3, Wn = Math.cos(Qe * Ld), Co = 1 / (1 - Dd * (1 - Wn * Wn)), Dl = Math.sqrt(Co);
                            this.kx = rt * Dl * Wn, this.ky = rt * Dl * Co * (1 - Dd);
                        }
                        distance(Qe, rt) {
                            const Wn = this.wrap(Qe[0] - rt[0]) * this.kx, Co = (Qe[1] - rt[1]) * this.ky;
                            return Math.sqrt(Wn * Wn + Co * Co);
                        }
                        pointOnLine(Qe, rt) {
                            let Wn, Co, Dl, Ll, Rl = 1 / 0;
                            for(let Ul = 0; Ul < Qe.length - 1; Ul++){
                                let Gl = Qe[Ul][0], Zl = Qe[Ul][1], Hl = this.wrap(Qe[Ul + 1][0] - Gl) * this.kx, ql = (Qe[Ul + 1][1] - Zl) * this.ky, Ql = 0;
                                0 === Hl && 0 === ql || (Ql = (this.wrap(rt[0] - Gl) * this.kx * Hl + (rt[1] - Zl) * this.ky * ql) / (Hl * Hl + ql * ql), Ql > 1 ? (Gl = Qe[Ul + 1][0], Zl = Qe[Ul + 1][1]) : Ql > 0 && (Gl += Hl / this.kx * Ql, Zl += ql / this.ky * Ql)), Hl = this.wrap(rt[0] - Gl) * this.kx, ql = (rt[1] - Zl) * this.ky;
                                const Kl = Hl * Hl + ql * ql;
                                Kl < Rl && (Rl = Kl, Wn = Gl, Co = Zl, Dl = Ul, Ll = Ql);
                            }
                            return {
                                point: [
                                    Wn,
                                    Co
                                ],
                                index: Dl,
                                t: Math.max(0, Math.min(1, Ll))
                            };
                        }
                        wrap(Qe) {
                            for(; Qe < -180;)Qe += 360;
                            for(; Qe > 180;)Qe -= 360;
                            return Qe;
                        }
                    }
                    function er(Qe, rt) {
                        return rt[0] - Qe[0];
                    }
                    function rr(Qe) {
                        return Qe[1] - Qe[0] + 1;
                    }
                    function nr(Qe, rt) {
                        return Qe[1] >= Qe[0] && Qe[1] < rt;
                    }
                    function ir(Qe, rt) {
                        if (Qe[0] > Qe[1]) return [
                            null,
                            null
                        ];
                        const Wn = rr(Qe);
                        if (rt) {
                            if (2 === Wn) return [
                                Qe,
                                null
                            ];
                            const rt = Math.floor(Wn / 2);
                            return [
                                [
                                    Qe[0],
                                    Qe[0] + rt
                                ],
                                [
                                    Qe[0] + rt,
                                    Qe[1]
                                ]
                            ];
                        }
                        if (1 === Wn) return [
                            Qe,
                            null
                        ];
                        const Co = Math.floor(Wn / 2) - 1;
                        return [
                            [
                                Qe[0],
                                Qe[0] + Co
                            ],
                            [
                                Qe[0] + Co + 1,
                                Qe[1]
                            ]
                        ];
                    }
                    function sr(Qe, rt) {
                        if (!nr(rt, Qe.length)) return [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ];
                        const Wn = [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ];
                        for(let Co = rt[0]; Co <= rt[1]; ++Co)ze(Wn, Qe[Co]);
                        return Wn;
                    }
                    function or(Qe) {
                        const rt = [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ];
                        for (const Wn of Qe)for (const Qe of Wn)ze(rt, Qe);
                        return rt;
                    }
                    function ar(Qe) {
                        return Qe[0] !== -1 / 0 && Qe[1] !== -1 / 0 && Qe[2] !== 1 / 0 && Qe[3] !== 1 / 0;
                    }
                    function lr(Qe, rt, Wn) {
                        if (!ar(Qe) || !ar(rt)) return NaN;
                        let Co = 0, Dl = 0;
                        return Qe[2] < rt[0] && (Co = rt[0] - Qe[2]), Qe[0] > rt[2] && (Co = Qe[0] - rt[2]), Qe[1] > rt[3] && (Dl = Qe[1] - rt[3]), Qe[3] < rt[1] && (Dl = rt[1] - Qe[3]), Wn.distance([
                            0,
                            0
                        ], [
                            Co,
                            Dl
                        ]);
                    }
                    function ur(Qe, rt, Wn) {
                        const Co = Wn.pointOnLine(rt, Qe);
                        return Wn.distance(Qe, Co.point);
                    }
                    function cr(Qe, rt, Wn, Co, Dl) {
                        const Ll = Math.min(ur(Qe, [
                            Wn,
                            Co
                        ], Dl), ur(rt, [
                            Wn,
                            Co
                        ], Dl)), Rl = Math.min(ur(Wn, [
                            Qe,
                            rt
                        ], Dl), ur(Co, [
                            Qe,
                            rt
                        ], Dl));
                        return Math.min(Ll, Rl);
                    }
                    function hr(Qe, rt, Wn, Co, Dl) {
                        if (!nr(rt, Qe.length) || !nr(Co, Wn.length)) return 1 / 0;
                        let Ll = 1 / 0;
                        for(let Rl = rt[0]; Rl < rt[1]; ++Rl){
                            const rt = Qe[Rl], Ul = Qe[Rl + 1];
                            for(let Qe = Co[0]; Qe < Co[1]; ++Qe){
                                const Co = Wn[Qe], Rl = Wn[Qe + 1];
                                if (Be(rt, Ul, Co, Rl)) return 0;
                                Ll = Math.min(Ll, cr(rt, Ul, Co, Rl, Dl));
                            }
                        }
                        return Ll;
                    }
                    function pr(Qe, rt, Wn, Co, Dl) {
                        if (!nr(rt, Qe.length) || !nr(Co, Wn.length)) return NaN;
                        let Ll = 1 / 0;
                        for(let Rl = rt[0]; Rl <= rt[1]; ++Rl)for(let rt = Co[0]; rt <= Co[1]; ++rt)if (Ll = Math.min(Ll, Dl.distance(Qe[Rl], Wn[rt])), 0 === Ll) return Ll;
                        return Ll;
                    }
                    function fr(Qe, rt, Wn) {
                        if (Ve(Qe, rt, !0)) return 0;
                        let Co = 1 / 0;
                        for (const Dl of rt){
                            const rt = Dl[0], Ll = Dl[Dl.length - 1];
                            if (rt !== Ll && (Co = Math.min(Co, ur(Qe, [
                                Ll,
                                rt
                            ], Wn)), 0 === Co)) return Co;
                            const Rl = Wn.pointOnLine(Dl, Qe);
                            if (Co = Math.min(Co, Wn.distance(Qe, Rl.point)), 0 === Co) return Co;
                        }
                        return Co;
                    }
                    function dr(Qe, rt, Wn, Co) {
                        if (!nr(rt, Qe.length)) return NaN;
                        for(let Ll = rt[0]; Ll <= rt[1]; ++Ll)if (Ve(Qe[Ll], Wn, !0)) return 0;
                        let Dl = 1 / 0;
                        for(let Ll = rt[0]; Ll < rt[1]; ++Ll){
                            const rt = Qe[Ll], Rl = Qe[Ll + 1];
                            for (const Qe of Wn)for(let Wn = 0, Ll = Qe.length, Ul = Ll - 1; Wn < Ll; Ul = Wn++){
                                const Ll = Qe[Ul], Gl = Qe[Wn];
                                if (Be(rt, Rl, Ll, Gl)) return 0;
                                Dl = Math.min(Dl, cr(rt, Rl, Ll, Gl, Co));
                            }
                        }
                        return Dl;
                    }
                    function yr(Qe, rt) {
                        for (const Wn of Qe)for (const Qe of Wn)if (Ve(Qe, rt, !0)) return !0;
                        return !1;
                    }
                    function mr(Qe, rt, Wn, Co) {
                        void 0 === Co && (Co = 1 / 0);
                        const Dl = or(Qe), Ll = or(rt);
                        if (Co !== 1 / 0 && lr(Dl, Ll, Wn) >= Co) return Co;
                        if (Pe(Dl, Ll)) {
                            if (yr(Qe, rt)) return 0;
                        } else if (yr(rt, Qe)) return 0;
                        let Rl = 1 / 0;
                        for (const Ul of Qe)for(let Qe = 0, Co = Ul.length, Dl = Co - 1; Qe < Co; Dl = Qe++){
                            const Co = Ul[Dl], Ll = Ul[Qe];
                            for (const Qe of rt)for(let rt = 0, Dl = Qe.length, Ul = Dl - 1; rt < Dl; Ul = rt++){
                                const Dl = Qe[Ul], Gl = Qe[rt];
                                if (Be(Co, Ll, Dl, Gl)) return 0;
                                Rl = Math.min(Rl, cr(Co, Ll, Dl, Gl, Wn));
                            }
                        }
                        return Rl;
                    }
                    function gr(Qe, rt, Wn, Co, Dl, Ll) {
                        if (!Ll) return;
                        const Rl = lr(sr(Co, Ll), Dl, Wn);
                        Rl < rt && Qe.push([
                            Rl,
                            Ll,
                            [
                                0,
                                0
                            ]
                        ]);
                    }
                    function xr(Qe, rt, Wn, Co, Dl, Ll, Rl) {
                        if (!Ll || !Rl) return;
                        const Ul = lr(sr(Co, Ll), sr(Dl, Rl), Wn);
                        Ul < rt && Qe.push([
                            Ul,
                            Ll,
                            Rl
                        ]);
                    }
                    function vr(Qe, rt, Wn, Co, Dl) {
                        void 0 === Dl && (Dl = 1 / 0);
                        let Ll = Math.min(Co.distance(Qe[0], Wn[0][0]), Dl);
                        if (0 === Ll) return Ll;
                        const Rl = new kd([
                            [
                                0,
                                [
                                    0,
                                    Qe.length - 1
                                ],
                                [
                                    0,
                                    0
                                ]
                            ]
                        ], er), Ul = or(Wn);
                        for(; Rl.length > 0;){
                            const Dl = Rl.pop();
                            if (Dl[0] >= Ll) continue;
                            const Gl = Dl[1], Zl = rt ? 50 : 100;
                            if (rr(Gl) <= Zl) {
                                if (!nr(Gl, Qe.length)) return NaN;
                                if (rt) {
                                    const rt = dr(Qe, Gl, Wn, Co);
                                    if (isNaN(rt) || 0 === rt) return rt;
                                    Ll = Math.min(Ll, rt);
                                } else for(let rt = Gl[0]; rt <= Gl[1]; ++rt){
                                    const Dl = fr(Qe[rt], Wn, Co);
                                    if (Ll = Math.min(Ll, Dl), 0 === Ll) return 0;
                                }
                            } else {
                                const Wn = ir(Gl, rt);
                                gr(Rl, Ll, Co, Qe, Ul, Wn[0]), gr(Rl, Ll, Co, Qe, Ul, Wn[1]);
                            }
                        }
                        return Ll;
                    }
                    function br(Qe, rt, Wn, Co, Dl, Ll) {
                        void 0 === Ll && (Ll = 1 / 0);
                        let Rl = Math.min(Ll, Dl.distance(Qe[0], Wn[0]));
                        if (0 === Rl) return Rl;
                        const Ul = new kd([
                            [
                                0,
                                [
                                    0,
                                    Qe.length - 1
                                ],
                                [
                                    0,
                                    Wn.length - 1
                                ]
                            ]
                        ], er);
                        for(; Ul.length > 0;){
                            const Ll = Ul.pop();
                            if (Ll[0] >= Rl) continue;
                            const Gl = Ll[1], Zl = Ll[2], Hl = rt ? 50 : 100, ql = Co ? 50 : 100;
                            if (rr(Gl) <= Hl && rr(Zl) <= ql) {
                                if (!nr(Gl, Qe.length) && nr(Zl, Wn.length)) return NaN;
                                let Ll;
                                if (rt && Co) Ll = hr(Qe, Gl, Wn, Zl, Dl), Rl = Math.min(Rl, Ll);
                                else if (rt && !Co) {
                                    const rt = Qe.slice(Gl[0], Gl[1] + 1);
                                    for(let Qe = Zl[0]; Qe <= Zl[1]; ++Qe)if (Ll = ur(Wn[Qe], rt, Dl), Rl = Math.min(Rl, Ll), 0 === Rl) return Rl;
                                } else if (!rt && Co) {
                                    const rt = Wn.slice(Zl[0], Zl[1] + 1);
                                    for(let Wn = Gl[0]; Wn <= Gl[1]; ++Wn)if (Ll = ur(Qe[Wn], rt, Dl), Rl = Math.min(Rl, Ll), 0 === Rl) return Rl;
                                } else Ll = pr(Qe, Gl, Wn, Zl, Dl), Rl = Math.min(Rl, Ll);
                            } else {
                                const Ll = ir(Gl, rt), Hl = ir(Zl, Co);
                                xr(Ul, Rl, Dl, Qe, Wn, Ll[0], Hl[0]), xr(Ul, Rl, Dl, Qe, Wn, Ll[0], Hl[1]), xr(Ul, Rl, Dl, Qe, Wn, Ll[1], Hl[0]), xr(Ul, Rl, Dl, Qe, Wn, Ll[1], Hl[1]);
                            }
                        }
                        return Rl;
                    }
                    function wr(Qe) {
                        return "MultiPolygon" === Qe.type ? Qe.coordinates.map((Qe)=>({
                                type: "Polygon",
                                coordinates: Qe
                            })) : "MultiLineString" === Qe.type ? Qe.coordinates.map((Qe)=>({
                                type: "LineString",
                                coordinates: Qe
                            })) : "MultiPoint" === Qe.type ? Qe.coordinates.map((Qe)=>({
                                type: "Point",
                                coordinates: Qe
                            })) : [
                            Qe
                        ];
                    }
                    class _r {
                        constructor(Qe, rt){
                            this.type = du, this.geojson = Qe, this.geometries = rt;
                        }
                        static parse(Qe, rt) {
                            if (2 !== Qe.length) return rt.error(`'distance' expression requires exactly one argument, but found ${Qe.length - 1} instead.`);
                            if (Ft(Qe[1])) {
                                const rt = Qe[1];
                                if ("FeatureCollection" === rt.type) return new _r(rt, rt.features.map((Qe)=>wr(Qe.geometry)).flat());
                                if ("Feature" === rt.type) return new _r(rt, wr(rt.geometry));
                                if ("type" in rt && "coordinates" in rt) return new _r(rt, wr(rt));
                            }
                            return rt.error("'distance' expression requires valid geojson object that contains polygon geometry type.");
                        }
                        evaluate(Qe) {
                            if (null != Qe.geometry() && null != Qe.canonicalID()) {
                                if ("Point" === Qe.geometryType()) return function(Qe, rt) {
                                    const Wn = Qe.geometry(), Co = Wn.flat().map((rt)=>Me([
                                            rt.x,
                                            rt.y
                                        ], Qe.canonical));
                                    if (0 === Wn.length) return NaN;
                                    const Dl = new tr(Co[0][1]);
                                    let Ll = 1 / 0;
                                    for (const Rl of rt){
                                        switch(Rl.type){
                                            case "Point":
                                                Ll = Math.min(Ll, br(Co, !1, [
                                                    Rl.coordinates
                                                ], !1, Dl, Ll));
                                                break;
                                            case "LineString":
                                                Ll = Math.min(Ll, br(Co, !1, Rl.coordinates, !0, Dl, Ll));
                                                break;
                                            case "Polygon":
                                                Ll = Math.min(Ll, vr(Co, !1, Rl.coordinates, Dl, Ll));
                                        }
                                        if (0 === Ll) return Ll;
                                    }
                                    return Ll;
                                }(Qe, this.geometries);
                                if ("LineString" === Qe.geometryType()) return function(Qe, rt) {
                                    const Wn = Qe.geometry(), Co = Wn.flat().map((rt)=>Me([
                                            rt.x,
                                            rt.y
                                        ], Qe.canonical));
                                    if (0 === Wn.length) return NaN;
                                    const Dl = new tr(Co[0][1]);
                                    let Ll = 1 / 0;
                                    for (const Rl of rt){
                                        switch(Rl.type){
                                            case "Point":
                                                Ll = Math.min(Ll, br(Co, !0, [
                                                    Rl.coordinates
                                                ], !1, Dl, Ll));
                                                break;
                                            case "LineString":
                                                Ll = Math.min(Ll, br(Co, !0, Rl.coordinates, !0, Dl, Ll));
                                                break;
                                            case "Polygon":
                                                Ll = Math.min(Ll, vr(Co, !0, Rl.coordinates, Dl, Ll));
                                        }
                                        if (0 === Ll) return Ll;
                                    }
                                    return Ll;
                                }(Qe, this.geometries);
                                if ("Polygon" === Qe.geometryType()) return function(Qe, rt) {
                                    const Wn = Qe.geometry();
                                    if (0 === Wn.length || 0 === Wn[0].length) return NaN;
                                    const Co = He(Wn, 0).map((rt)=>rt.map((rt)=>rt.map((rt)=>Me([
                                                    rt.x,
                                                    rt.y
                                                ], Qe.canonical)))), Dl = new tr(Co[0][0][0][1]);
                                    let Ll = 1 / 0;
                                    for (const Rl of rt)for (const Qe of Co){
                                        switch(Rl.type){
                                            case "Point":
                                                Ll = Math.min(Ll, vr([
                                                    Rl.coordinates
                                                ], !1, Qe, Dl, Ll));
                                                break;
                                            case "LineString":
                                                Ll = Math.min(Ll, vr(Rl.coordinates, !0, Qe, Dl, Ll));
                                                break;
                                            case "Polygon":
                                                Ll = Math.min(Ll, mr(Qe, Rl.coordinates, Dl, Ll));
                                        }
                                        if (0 === Ll) return Ll;
                                    }
                                    return Ll;
                                }(Qe, this.geometries);
                            }
                            return NaN;
                        }
                        eachChild() {}
                        outputDefined() {
                            return !0;
                        }
                    }
                    const Pd = {
                        "==": bd,
                        "!=": wd,
                        ">": Md,
                        "<": Ed,
                        ">=": Td,
                        "<=": Sd,
                        array: Rt,
                        at: Ht,
                        boolean: Rt,
                        case: Wt,
                        coalesce: ce,
                        collator: be,
                        format: _e,
                        image: Se,
                        in: Yt,
                        "index-of": Jt,
                        interpolate: ae,
                        "interpolate-hcl": ae,
                        "interpolate-lab": ae,
                        length: ke,
                        let: Zt,
                        literal: $t,
                        match: Kt,
                        number: Rt,
                        "number-format": we,
                        object: Rt,
                        slice: Qt,
                        step: ee,
                        string: Rt,
                        "to-boolean": jt,
                        "to-color": jt,
                        "to-number": jt,
                        "to-string": jt,
                        var: Xt,
                        within: qe,
                        distance: _r
                    };
                    class kr {
                        constructor(Qe, rt, Wn, Co){
                            this.name = Qe, this.type = rt, this._evaluate = Wn, this.args = Co;
                        }
                        evaluate(Qe) {
                            return this._evaluate(Qe, this.args);
                        }
                        eachChild(Qe) {
                            this.args.forEach(Qe);
                        }
                        outputDefined() {
                            return !1;
                        }
                        static parse(Qe, rt) {
                            const Wn = Qe[0], Co = kr.definitions[Wn];
                            if (!Co) return rt.error(`Unknown expression "${Wn}". If you wanted a literal array, use ["literal", [...]].`, 0);
                            const Dl = Array.isArray(Co) ? Co[0] : Co.type, Ll = Array.isArray(Co) ? [
                                [
                                    Co[1],
                                    Co[2]
                                ]
                            ] : Co.overloads, Rl = Ll.filter((rt)=>{
                                let [Wn] = rt;
                                return !Array.isArray(Wn) || Wn.length === Qe.length - 1;
                            });
                            let Ul = null;
                            for (const [Gl, Zl] of Rl){
                                Ul = new Gt(rt.registry, Pr, rt.path, null, rt.scope);
                                const Co = [];
                                let Ll = !1;
                                for(let rt = 1; rt < Qe.length; rt++){
                                    const Wn = Qe[rt], Dl = Array.isArray(Gl) ? Gl[rt - 1] : Gl.type, Rl = Ul.parse(Wn, 1 + Co.length, Dl);
                                    if (!Rl) {
                                        Ll = !0;
                                        break;
                                    }
                                    Co.push(Rl);
                                }
                                if (!Ll) {
                                    if (Array.isArray(Gl) && Gl.length !== Co.length) Ul.error(`Expected ${Gl.length} arguments, but found ${Co.length} instead.`);
                                    else {
                                        for(let Qe = 0; Qe < Co.length; Qe++){
                                            const rt = Array.isArray(Gl) ? Gl[Qe] : Gl.type, Wn = Co[Qe];
                                            Ul.concat(Qe + 1).checkSubtype(rt, Wn.type);
                                        }
                                        if (0 === Ul.errors.length) return new kr(Wn, Dl, Zl, Co);
                                    }
                                }
                            }
                            if (1 === Rl.length) rt.errors.push(...Ul.errors);
                            else {
                                const Wn = (Rl.length ? Rl : Ll).map((Qe)=>{
                                    let [rt] = Qe;
                                    var Wn;
                                    return Wn = rt, Array.isArray(Wn) ? `(${Wn.map(Y).join(", ")})` : `(${Y(Wn.type)}...)`;
                                }).join(" | "), Co = [];
                                for(let Dl = 1; Dl < Qe.length; Dl++){
                                    const Wn = rt.parse(Qe[Dl], 1 + Co.length);
                                    if (!Wn) return null;
                                    Co.push(Y(Wn.type));
                                }
                                rt.error(`Expected arguments of type ${Wn}, but found (${Co.join(", ")}) instead.`);
                            }
                            return null;
                        }
                        static register(Qe, rt) {
                            kr.definitions = rt;
                            for(const Wn in rt)Qe[Wn] = kr;
                        }
                    }
                    function Ar(Qe, rt) {
                        let [Wn, Co, Dl, Ll] = rt;
                        Wn = Wn.evaluate(Qe), Co = Co.evaluate(Qe), Dl = Dl.evaluate(Qe);
                        const Rl = Ll ? Ll.evaluate(Qe) : 1, Ul = Et(Wn, Co, Dl, Rl);
                        if (Ul) throw new Pt(Ul);
                        return new St(Wn / 255, Co / 255, Dl / 255, Rl, !1);
                    }
                    function Ir(Qe, rt) {
                        return Qe in rt;
                    }
                    function Mr(Qe, rt) {
                        const Wn = rt[Qe];
                        return void 0 === Wn ? null : Wn;
                    }
                    function zr(Qe) {
                        return {
                            type: Qe
                        };
                    }
                    function Pr(Qe) {
                        if (Qe instanceof Xt) return Pr(Qe.boundExpression);
                        if (Qe instanceof kr && "error" === Qe.name) return !1;
                        if (Qe instanceof be) return !1;
                        if (Qe instanceof qe) return !1;
                        if (Qe instanceof _r) return !1;
                        const rt = Qe instanceof jt || Qe instanceof Rt;
                        let Wn = !0;
                        return Qe.eachChild((Qe)=>{
                            Wn = rt ? Wn && Pr(Qe) : Wn && Qe instanceof $t;
                        }), !!Wn && Cr(Qe) && Tr(Qe, [
                            "zoom",
                            "heatmap-density",
                            "line-progress",
                            "accumulated",
                            "is-supported-script"
                        ]);
                    }
                    function Cr(Qe) {
                        if (Qe instanceof kr) {
                            if ("get" === Qe.name && 1 === Qe.args.length) return !1;
                            if ("feature-state" === Qe.name) return !1;
                            if ("has" === Qe.name && 1 === Qe.args.length) return !1;
                            if ("properties" === Qe.name || "geometry-type" === Qe.name || "id" === Qe.name) return !1;
                            if (/^filter-/.test(Qe.name)) return !1;
                        }
                        if (Qe instanceof qe) return !1;
                        if (Qe instanceof _r) return !1;
                        let rt = !0;
                        return Qe.eachChild((Qe)=>{
                            rt && !Cr(Qe) && (rt = !1);
                        }), rt;
                    }
                    function Br(Qe) {
                        if (Qe instanceof kr && "feature-state" === Qe.name) return !1;
                        let rt = !0;
                        return Qe.eachChild((Qe)=>{
                            rt && !Br(Qe) && (rt = !1);
                        }), rt;
                    }
                    function Tr(Qe, rt) {
                        if (Qe instanceof kr && rt.indexOf(Qe.name) >= 0) return !1;
                        let Wn = !0;
                        return Qe.eachChild((Qe)=>{
                            Wn && !Tr(Qe, rt) && (Wn = !1);
                        }), Wn;
                    }
                    function Vr(Qe) {
                        return {
                            result: "success",
                            value: Qe
                        };
                    }
                    function Er(Qe) {
                        return {
                            result: "error",
                            value: Qe
                        };
                    }
                    function Fr(Qe) {
                        return "data-driven" === Qe["property-type"] || "cross-faded-data-driven" === Qe["property-type"];
                    }
                    function Dr(Qe) {
                        return !!Qe.expression && Qe.expression.parameters.indexOf("zoom") > -1;
                    }
                    function Lr(Qe) {
                        return !!Qe.expression && Qe.expression.interpolated;
                    }
                    function $r(Qe) {
                        return Qe instanceof Number ? "number" : Qe instanceof String ? "string" : Qe instanceof Boolean ? "boolean" : Array.isArray(Qe) ? "array" : null === Qe ? "null" : typeof Qe;
                    }
                    function Or(Qe) {
                        return "object" == typeof Qe && null !== Qe && !Array.isArray(Qe);
                    }
                    function Rr(Qe) {
                        return Qe;
                    }
                    function Nr(Qe, rt) {
                        const Wn = "color" === rt.type, Co = Qe.stops && "object" == typeof Qe.stops[0][0], Dl = Co || !(Co || void 0 !== Qe.property), Ll = Qe.type || (Lr(rt) ? "exponential" : "interval");
                        if (Wn || "padding" === rt.type) {
                            const Co = Wn ? St.parse : zt.parse;
                            (Qe = T({}, Qe)).stops && (Qe.stops = Qe.stops.map((Qe)=>[
                                    Qe[0],
                                    Co(Qe[1])
                                ])), Qe.default = Co(Qe.default ? Qe.default : rt.default);
                        }
                        if (Qe.colorSpace && "rgb" !== (Rl = Qe.colorSpace) && "hcl" !== Rl && "lab" !== Rl) throw new Error(`Unknown color space: "${Qe.colorSpace}"`);
                        var Rl;
                        let Ul, Gl, Zl;
                        if ("exponential" === Ll) Ul = Gr;
                        else if ("interval" === Ll) Ul = Ur;
                        else if ("categorical" === Ll) {
                            Ul = qr, Gl = Object.create(null);
                            for (const rt of Qe.stops)Gl[rt[0]] = rt[1];
                            Zl = typeof Qe.stops[0][0];
                        } else {
                            if ("identity" !== Ll) throw new Error(`Unknown function type "${Ll}"`);
                            Ul = Zr;
                        }
                        if (Co) {
                            const Wn = {}, Co = [];
                            for(let rt = 0; rt < Qe.stops.length; rt++){
                                const Dl = Qe.stops[rt], Ll = Dl[0].zoom;
                                void 0 === Wn[Ll] && (Wn[Ll] = {
                                    zoom: Ll,
                                    type: Qe.type,
                                    property: Qe.property,
                                    default: Qe.default,
                                    stops: []
                                }, Co.push(Ll)), Wn[Ll].stops.push([
                                    Dl[0].value,
                                    Dl[1]
                                ]);
                            }
                            const Dl = [];
                            for (const Qe of Co)Dl.push([
                                Wn[Qe].zoom,
                                Nr(Wn[Qe], rt)
                            ]);
                            const Ll = {
                                name: "linear"
                            };
                            return {
                                kind: "composite",
                                interpolationType: Ll,
                                interpolationFactor: ae.interpolationFactor.bind(void 0, Ll),
                                zoomStops: Dl.map((Qe)=>Qe[0]),
                                evaluate: (Wn, Co)=>{
                                    let { zoom: Ll } = Wn;
                                    return Gr({
                                        stops: Dl,
                                        base: Qe.base
                                    }, rt, Ll).evaluate(Ll, Co);
                                }
                            };
                        }
                        if (Dl) {
                            const Wn = "exponential" === Ll ? {
                                name: "exponential",
                                base: void 0 !== Qe.base ? Qe.base : 1
                            } : null;
                            return {
                                kind: "camera",
                                interpolationType: Wn,
                                interpolationFactor: ae.interpolationFactor.bind(void 0, Wn),
                                zoomStops: Qe.stops.map((Qe)=>Qe[0]),
                                evaluate: (Wn)=>{
                                    let { zoom: Co } = Wn;
                                    return Ul(Qe, rt, Co, Gl, Zl);
                                }
                            };
                        }
                        return {
                            kind: "source",
                            evaluate (Wn, Co) {
                                const Dl = Co && Co.properties ? Co.properties[Qe.property] : void 0;
                                return void 0 === Dl ? jr(Qe.default, rt.default) : Ul(Qe, rt, Dl, Gl, Zl);
                            }
                        };
                    }
                    function jr(Qe, rt, Wn) {
                        return void 0 !== Qe ? Qe : void 0 !== rt ? rt : void 0 !== Wn ? Wn : void 0;
                    }
                    function qr(Qe, rt, Wn, Co, Dl) {
                        return jr(typeof Wn === Dl ? Co[Wn] : void 0, Qe.default, rt.default);
                    }
                    function Ur(Qe, rt, Wn) {
                        if ("number" !== $r(Wn)) return jr(Qe.default, rt.default);
                        const Co = Qe.stops.length;
                        if (1 === Co) return Qe.stops[0][1];
                        if (Wn <= Qe.stops[0][0]) return Qe.stops[0][1];
                        if (Wn >= Qe.stops[Co - 1][0]) return Qe.stops[Co - 1][1];
                        const Dl = te(Qe.stops.map((Qe)=>Qe[0]), Wn);
                        return Qe.stops[Dl][1];
                    }
                    function Gr(Qe, rt, Wn) {
                        const Co = void 0 !== Qe.base ? Qe.base : 1;
                        if ("number" !== $r(Wn)) return jr(Qe.default, rt.default);
                        const Dl = Qe.stops.length;
                        if (1 === Dl) return Qe.stops[0][1];
                        if (Wn <= Qe.stops[0][0]) return Qe.stops[0][1];
                        if (Wn >= Qe.stops[Dl - 1][0]) return Qe.stops[Dl - 1][1];
                        const Ll = te(Qe.stops.map((Qe)=>Qe[0]), Wn), Rl = function(Qe, rt, Wn, Co) {
                            const Dl = Co - Wn, Ll = Qe - Wn;
                            return 0 === Dl ? 0 : 1 === rt ? Ll / Dl : (Math.pow(rt, Ll) - 1) / (Math.pow(rt, Dl) - 1);
                        }(Wn, Co, Qe.stops[Ll][0], Qe.stops[Ll + 1][0]), Ul = Qe.stops[Ll][1], Gl = Qe.stops[Ll + 1][1], Zl = xd[rt.type] || Rr;
                        return "function" == typeof Ul.evaluate ? {
                            evaluate () {
                                for(var rt = arguments.length, Wn = new Array(rt), Co = 0; Co < rt; Co++)Wn[Co] = arguments[Co];
                                const Dl = Ul.evaluate.apply(void 0, Wn), Ll = Gl.evaluate.apply(void 0, Wn);
                                if (void 0 !== Dl && void 0 !== Ll) return Zl(Dl, Ll, Rl, Qe.colorSpace);
                            }
                        } : Zl(Ul, Gl, Rl, Qe.colorSpace);
                    }
                    function Zr(Qe, rt, Wn) {
                        switch(rt.type){
                            case "color":
                                Wn = St.parse(Wn);
                                break;
                            case "formatted":
                                Wn = Mt.fromString(Wn.toString());
                                break;
                            case "resolvedImage":
                                Wn = Tt.fromString(Wn.toString());
                                break;
                            case "padding":
                                Wn = zt.parse(Wn);
                                break;
                            default:
                                $r(Wn) === rt.type || "enum" === rt.type && rt.values[Wn] || (Wn = void 0);
                        }
                        return jr(Wn, Qe.default, rt.default);
                    }
                    kr.register(Pd, {
                        error: [
                            {
                                kind: "error"
                            },
                            [
                                fu
                            ],
                            (Qe, rt)=>{
                                let [Wn] = rt;
                                throw new Pt(Wn.evaluate(Qe));
                            }
                        ],
                        typeof: [
                            fu,
                            [
                                Zu
                            ],
                            (Qe, rt)=>{
                                let [Wn] = rt;
                                return Y(Dt(Wn.evaluate(Qe)));
                            }
                        ],
                        "to-rgba": [
                            H(du, 4),
                            [
                                Eu
                            ],
                            (Qe, rt)=>{
                                let [Wn] = rt;
                                const [Co, Dl, Ll, Rl] = Wn.evaluate(Qe).rgb;
                                return [
                                    255 * Co,
                                    255 * Dl,
                                    255 * Ll,
                                    Rl
                                ];
                            }
                        ],
                        rgb: [
                            Eu,
                            [
                                du,
                                du,
                                du
                            ],
                            Ar
                        ],
                        rgba: [
                            Eu,
                            [
                                du,
                                du,
                                du,
                                du
                            ],
                            Ar
                        ],
                        has: {
                            type: yu,
                            overloads: [
                                [
                                    [
                                        fu
                                    ],
                                    (Qe, rt)=>{
                                        let [Wn] = rt;
                                        return Ir(Wn.evaluate(Qe), Qe.properties());
                                    }
                                ],
                                [
                                    [
                                        fu,
                                        Lu
                                    ],
                                    (Qe, rt)=>{
                                        let [Wn, Co] = rt;
                                        return Ir(Wn.evaluate(Qe), Co.evaluate(Qe));
                                    }
                                ]
                            ]
                        },
                        get: {
                            type: Zu,
                            overloads: [
                                [
                                    [
                                        fu
                                    ],
                                    (Qe, rt)=>{
                                        let [Wn] = rt;
                                        return Mr(Wn.evaluate(Qe), Qe.properties());
                                    }
                                ],
                                [
                                    [
                                        fu,
                                        Lu
                                    ],
                                    (Qe, rt)=>{
                                        let [Wn, Co] = rt;
                                        return Mr(Wn.evaluate(Qe), Co.evaluate(Qe));
                                    }
                                ]
                            ]
                        },
                        "feature-state": [
                            Zu,
                            [
                                fu
                            ],
                            (Qe, rt)=>{
                                let [Wn] = rt;
                                return Mr(Wn.evaluate(Qe), Qe.featureState || {});
                            }
                        ],
                        properties: [
                            Lu,
                            [],
                            (Qe)=>Qe.properties()
                        ],
                        "geometry-type": [
                            fu,
                            [],
                            (Qe)=>Qe.geometryType()
                        ],
                        id: [
                            Zu,
                            [],
                            (Qe)=>Qe.id()
                        ],
                        zoom: [
                            du,
                            [],
                            (Qe)=>Qe.globals.zoom
                        ],
                        "heatmap-density": [
                            du,
                            [],
                            (Qe)=>Qe.globals.heatmapDensity || 0
                        ],
                        "line-progress": [
                            du,
                            [],
                            (Qe)=>Qe.globals.lineProgress || 0
                        ],
                        accumulated: [
                            Zu,
                            [],
                            (Qe)=>void 0 === Qe.globals.accumulated ? null : Qe.globals.accumulated
                        ],
                        "+": [
                            du,
                            zr(du),
                            (Qe, rt)=>{
                                let Wn = 0;
                                for (const Co of rt)Wn += Co.evaluate(Qe);
                                return Wn;
                            }
                        ],
                        "*": [
                            du,
                            zr(du),
                            (Qe, rt)=>{
                                let Wn = 1;
                                for (const Co of rt)Wn *= Co.evaluate(Qe);
                                return Wn;
                            }
                        ],
                        "-": {
                            type: du,
                            overloads: [
                                [
                                    [
                                        du,
                                        du
                                    ],
                                    (Qe, rt)=>{
                                        let [Wn, Co] = rt;
                                        return Wn.evaluate(Qe) - Co.evaluate(Qe);
                                    }
                                ],
                                [
                                    [
                                        du
                                    ],
                                    (Qe, rt)=>{
                                        let [Wn] = rt;
                                        return -Wn.evaluate(Qe);
                                    }
                                ]
                            ]
                        },
                        "/": [
                            du,
                            [
                                du,
                                du
                            ],
                            (Qe, rt)=>{
                                let [Wn, Co] = rt;
                                return Wn.evaluate(Qe) / Co.evaluate(Qe);
                            }
                        ],
                        "%": [
                            du,
                            [
                                du,
                                du
                            ],
                            (Qe, rt)=>{
                                let [Wn, Co] = rt;
                                return Wn.evaluate(Qe) % Co.evaluate(Qe);
                            }
                        ],
                        ln2: [
                            du,
                            [],
                            ()=>Math.LN2
                        ],
                        pi: [
                            du,
                            [],
                            ()=>Math.PI
                        ],
                        e: [
                            du,
                            [],
                            ()=>Math.E
                        ],
                        "^": [
                            du,
                            [
                                du,
                                du
                            ],
                            (Qe, rt)=>{
                                let [Wn, Co] = rt;
                                return Math.pow(Wn.evaluate(Qe), Co.evaluate(Qe));
                            }
                        ],
                        sqrt: [
                            du,
                            [
                                du
                            ],
                            (Qe, rt)=>{
                                let [Wn] = rt;
                                return Math.sqrt(Wn.evaluate(Qe));
                            }
                        ],
                        log10: [
                            du,
                            [
                                du
                            ],
                            (Qe, rt)=>{
                                let [Wn] = rt;
                                return Math.log(Wn.evaluate(Qe)) / Math.LN10;
                            }
                        ],
                        ln: [
                            du,
                            [
                                du
                            ],
                            (Qe, rt)=>{
                                let [Wn] = rt;
                                return Math.log(Wn.evaluate(Qe));
                            }
                        ],
                        log2: [
                            du,
                            [
                                du
                            ],
                            (Qe, rt)=>{
                                let [Wn] = rt;
                                return Math.log(Wn.evaluate(Qe)) / Math.LN2;
                            }
                        ],
                        sin: [
                            du,
                            [
                                du
                            ],
                            (Qe, rt)=>{
                                let [Wn] = rt;
                                return Math.sin(Wn.evaluate(Qe));
                            }
                        ],
                        cos: [
                            du,
                            [
                                du
                            ],
                            (Qe, rt)=>{
                                let [Wn] = rt;
                                return Math.cos(Wn.evaluate(Qe));
                            }
                        ],
                        tan: [
                            du,
                            [
                                du
                            ],
                            (Qe, rt)=>{
                                let [Wn] = rt;
                                return Math.tan(Wn.evaluate(Qe));
                            }
                        ],
                        asin: [
                            du,
                            [
                                du
                            ],
                            (Qe, rt)=>{
                                let [Wn] = rt;
                                return Math.asin(Wn.evaluate(Qe));
                            }
                        ],
                        acos: [
                            du,
                            [
                                du
                            ],
                            (Qe, rt)=>{
                                let [Wn] = rt;
                                return Math.acos(Wn.evaluate(Qe));
                            }
                        ],
                        atan: [
                            du,
                            [
                                du
                            ],
                            (Qe, rt)=>{
                                let [Wn] = rt;
                                return Math.atan(Wn.evaluate(Qe));
                            }
                        ],
                        min: [
                            du,
                            zr(du),
                            (Qe, rt)=>Math.min(...rt.map((rt)=>rt.evaluate(Qe)))
                        ],
                        max: [
                            du,
                            zr(du),
                            (Qe, rt)=>Math.max(...rt.map((rt)=>rt.evaluate(Qe)))
                        ],
                        abs: [
                            du,
                            [
                                du
                            ],
                            (Qe, rt)=>{
                                let [Wn] = rt;
                                return Math.abs(Wn.evaluate(Qe));
                            }
                        ],
                        round: [
                            du,
                            [
                                du
                            ],
                            (Qe, rt)=>{
                                let [Wn] = rt;
                                const Co = Wn.evaluate(Qe);
                                return Co < 0 ? -Math.round(-Co) : Math.round(Co);
                            }
                        ],
                        floor: [
                            du,
                            [
                                du
                            ],
                            (Qe, rt)=>{
                                let [Wn] = rt;
                                return Math.floor(Wn.evaluate(Qe));
                            }
                        ],
                        ceil: [
                            du,
                            [
                                du
                            ],
                            (Qe, rt)=>{
                                let [Wn] = rt;
                                return Math.ceil(Wn.evaluate(Qe));
                            }
                        ],
                        "filter-==": [
                            yu,
                            [
                                fu,
                                Zu
                            ],
                            (Qe, rt)=>{
                                let [Wn, Co] = rt;
                                return Qe.properties()[Wn.value] === Co.value;
                            }
                        ],
                        "filter-id-==": [
                            yu,
                            [
                                Zu
                            ],
                            (Qe, rt)=>{
                                let [Wn] = rt;
                                return Qe.id() === Wn.value;
                            }
                        ],
                        "filter-type-==": [
                            yu,
                            [
                                fu
                            ],
                            (Qe, rt)=>{
                                let [Wn] = rt;
                                return Qe.geometryType() === Wn.value;
                            }
                        ],
                        "filter-<": [
                            yu,
                            [
                                fu,
                                Zu
                            ],
                            (Qe, rt)=>{
                                let [Wn, Co] = rt;
                                const Dl = Qe.properties()[Wn.value], Ll = Co.value;
                                return typeof Dl == typeof Ll && Dl < Ll;
                            }
                        ],
                        "filter-id-<": [
                            yu,
                            [
                                Zu
                            ],
                            (Qe, rt)=>{
                                let [Wn] = rt;
                                const Co = Qe.id(), Dl = Wn.value;
                                return typeof Co == typeof Dl && Co < Dl;
                            }
                        ],
                        "filter->": [
                            yu,
                            [
                                fu,
                                Zu
                            ],
                            (Qe, rt)=>{
                                let [Wn, Co] = rt;
                                const Dl = Qe.properties()[Wn.value], Ll = Co.value;
                                return typeof Dl == typeof Ll && Dl > Ll;
                            }
                        ],
                        "filter-id->": [
                            yu,
                            [
                                Zu
                            ],
                            (Qe, rt)=>{
                                let [Wn] = rt;
                                const Co = Qe.id(), Dl = Wn.value;
                                return typeof Co == typeof Dl && Co > Dl;
                            }
                        ],
                        "filter-<=": [
                            yu,
                            [
                                fu,
                                Zu
                            ],
                            (Qe, rt)=>{
                                let [Wn, Co] = rt;
                                const Dl = Qe.properties()[Wn.value], Ll = Co.value;
                                return typeof Dl == typeof Ll && Dl <= Ll;
                            }
                        ],
                        "filter-id-<=": [
                            yu,
                            [
                                Zu
                            ],
                            (Qe, rt)=>{
                                let [Wn] = rt;
                                const Co = Qe.id(), Dl = Wn.value;
                                return typeof Co == typeof Dl && Co <= Dl;
                            }
                        ],
                        "filter->=": [
                            yu,
                            [
                                fu,
                                Zu
                            ],
                            (Qe, rt)=>{
                                let [Wn, Co] = rt;
                                const Dl = Qe.properties()[Wn.value], Ll = Co.value;
                                return typeof Dl == typeof Ll && Dl >= Ll;
                            }
                        ],
                        "filter-id->=": [
                            yu,
                            [
                                Zu
                            ],
                            (Qe, rt)=>{
                                let [Wn] = rt;
                                const Co = Qe.id(), Dl = Wn.value;
                                return typeof Co == typeof Dl && Co >= Dl;
                            }
                        ],
                        "filter-has": [
                            yu,
                            [
                                Zu
                            ],
                            (Qe, rt)=>{
                                let [Wn] = rt;
                                return Wn.value in Qe.properties();
                            }
                        ],
                        "filter-has-id": [
                            yu,
                            [],
                            (Qe)=>null !== Qe.id() && void 0 !== Qe.id()
                        ],
                        "filter-type-in": [
                            yu,
                            [
                                H(fu)
                            ],
                            (Qe, rt)=>{
                                let [Wn] = rt;
                                return Wn.value.indexOf(Qe.geometryType()) >= 0;
                            }
                        ],
                        "filter-id-in": [
                            yu,
                            [
                                H(Zu)
                            ],
                            (Qe, rt)=>{
                                let [Wn] = rt;
                                return Wn.value.indexOf(Qe.id()) >= 0;
                            }
                        ],
                        "filter-in-small": [
                            yu,
                            [
                                fu,
                                H(Zu)
                            ],
                            (Qe, rt)=>{
                                let [Wn, Co] = rt;
                                return Co.value.indexOf(Qe.properties()[Wn.value]) >= 0;
                            }
                        ],
                        "filter-in-large": [
                            yu,
                            [
                                fu,
                                H(Zu)
                            ],
                            (Qe, rt)=>{
                                let [Wn, Co] = rt;
                                return function(Qe, rt, Wn, Co) {
                                    for(; Wn <= Co;){
                                        const Dl = Wn + Co >> 1;
                                        if (rt[Dl] === Qe) return !0;
                                        rt[Dl] > Qe ? Co = Dl - 1 : Wn = Dl + 1;
                                    }
                                    return !1;
                                }(Qe.properties()[Wn.value], Co.value, 0, Co.value.length - 1);
                            }
                        ],
                        all: {
                            type: yu,
                            overloads: [
                                [
                                    [
                                        yu,
                                        yu
                                    ],
                                    (Qe, rt)=>{
                                        let [Wn, Co] = rt;
                                        return Wn.evaluate(Qe) && Co.evaluate(Qe);
                                    }
                                ],
                                [
                                    zr(yu),
                                    (Qe, rt)=>{
                                        for (const Wn of rt)if (!Wn.evaluate(Qe)) return !1;
                                        return !0;
                                    }
                                ]
                            ]
                        },
                        any: {
                            type: yu,
                            overloads: [
                                [
                                    [
                                        yu,
                                        yu
                                    ],
                                    (Qe, rt)=>{
                                        let [Wn, Co] = rt;
                                        return Wn.evaluate(Qe) || Co.evaluate(Qe);
                                    }
                                ],
                                [
                                    zr(yu),
                                    (Qe, rt)=>{
                                        for (const Wn of rt)if (Wn.evaluate(Qe)) return !0;
                                        return !1;
                                    }
                                ]
                            ]
                        },
                        "!": [
                            yu,
                            [
                                yu
                            ],
                            (Qe, rt)=>{
                                let [Wn] = rt;
                                return !Wn.evaluate(Qe);
                            }
                        ],
                        "is-supported-script": [
                            yu,
                            [
                                fu
                            ],
                            (Qe, rt)=>{
                                let [Wn] = rt;
                                const Co = Qe.globals && Qe.globals.isSupportedScript;
                                return !Co || Co(Wn.evaluate(Qe));
                            }
                        ],
                        upcase: [
                            fu,
                            [
                                fu
                            ],
                            (Qe, rt)=>{
                                let [Wn] = rt;
                                return Wn.evaluate(Qe).toUpperCase();
                            }
                        ],
                        downcase: [
                            fu,
                            [
                                fu
                            ],
                            (Qe, rt)=>{
                                let [Wn] = rt;
                                return Wn.evaluate(Qe).toLowerCase();
                            }
                        ],
                        concat: [
                            fu,
                            zr(Zu),
                            (Qe, rt)=>rt.map((rt)=>Lt(rt.evaluate(Qe))).join("")
                        ],
                        "resolved-locale": [
                            fu,
                            [
                                Xu
                            ],
                            (Qe, rt)=>{
                                let [Wn] = rt;
                                return Wn.evaluate(Qe).resolvedLocale();
                            }
                        ]
                    });
                    class Xr {
                        constructor(Qe, rt){
                            var Wn;
                            this.expression = Qe, this._warningHistory = {}, this._evaluator = new Ut, this._defaultValue = rt ? "color" === (Wn = rt).type && Or(Wn.default) ? new St(0, 0, 0, 0) : "color" === Wn.type ? St.parse(Wn.default) || null : "padding" === Wn.type ? zt.parse(Wn.default) || null : "variableAnchorOffsetCollection" === Wn.type ? Bt.parse(Wn.default) || null : "projectionDefinition" === Wn.type ? Vt.parse(Wn.default) || null : void 0 === Wn.default ? null : Wn.default : null, this._enumValues = rt && "enum" === rt.type ? rt.values : null;
                        }
                        evaluateWithoutErrorHandling(Qe, rt, Wn, Co, Dl, Ll) {
                            return this._evaluator.globals = Qe, this._evaluator.feature = rt, this._evaluator.featureState = Wn, this._evaluator.canonical = Co, this._evaluator.availableImages = Dl || null, this._evaluator.formattedSection = Ll, this.expression.evaluate(this._evaluator);
                        }
                        evaluate(Qe, rt, Wn, Co, Dl, Ll) {
                            this._evaluator.globals = Qe, this._evaluator.feature = rt || null, this._evaluator.featureState = Wn || null, this._evaluator.canonical = Co, this._evaluator.availableImages = Dl || null, this._evaluator.formattedSection = Ll || null;
                            try {
                                const Qe = this.expression.evaluate(this._evaluator);
                                if (null == Qe || "number" == typeof Qe && Qe != Qe) return this._defaultValue;
                                if (this._enumValues && !(Qe in this._enumValues)) throw new Pt(`Expected value to be one of ${Object.keys(this._enumValues).map((Qe)=>JSON.stringify(Qe)).join(", ")}, but found ${JSON.stringify(Qe)} instead.`);
                                return Qe;
                            } catch (Qe) {
                                return this._warningHistory[Qe.message] || (this._warningHistory[Qe.message] = !0, "undefined" != typeof console && console.warn(Qe.message)), this._defaultValue;
                            }
                        }
                    }
                    function Hr(Qe) {
                        return Array.isArray(Qe) && Qe.length > 0 && "string" == typeof Qe[0] && Qe[0] in Pd;
                    }
                    function Yr(Qe, rt) {
                        const Wn = new Gt(Pd, Pr, [], rt ? function(Qe) {
                            const rt = {
                                color: Eu,
                                string: fu,
                                number: du,
                                enum: fu,
                                boolean: yu,
                                formatted: Ju,
                                padding: $u,
                                projectionDefinition: Tu,
                                resolvedImage: ed,
                                variableAnchorOffsetCollection: td
                            };
                            return "array" === Qe.type ? H(rt[Qe.value] || Zu, Qe.length) : rt[Qe.type];
                        }(rt) : void 0), Co = Wn.parse(Qe, void 0, void 0, void 0, rt && "string" === rt.type ? {
                            typeAnnotation: "coerce"
                        } : void 0);
                        return Co ? Vr(new Xr(Co, rt)) : Er(Wn.errors);
                    }
                    class Jr {
                        constructor(Qe, rt){
                            this.kind = Qe, this._styleExpression = rt, this.isStateDependent = "constant" !== Qe && !Br(rt.expression);
                        }
                        evaluateWithoutErrorHandling(Qe, rt, Wn, Co, Dl, Ll) {
                            return this._styleExpression.evaluateWithoutErrorHandling(Qe, rt, Wn, Co, Dl, Ll);
                        }
                        evaluate(Qe, rt, Wn, Co, Dl, Ll) {
                            return this._styleExpression.evaluate(Qe, rt, Wn, Co, Dl, Ll);
                        }
                    }
                    class Kr {
                        constructor(Qe, rt, Wn, Co){
                            this.kind = Qe, this.zoomStops = Wn, this._styleExpression = rt, this.isStateDependent = "camera" !== Qe && !Br(rt.expression), this.interpolationType = Co;
                        }
                        evaluateWithoutErrorHandling(Qe, rt, Wn, Co, Dl, Ll) {
                            return this._styleExpression.evaluateWithoutErrorHandling(Qe, rt, Wn, Co, Dl, Ll);
                        }
                        evaluate(Qe, rt, Wn, Co, Dl, Ll) {
                            return this._styleExpression.evaluate(Qe, rt, Wn, Co, Dl, Ll);
                        }
                        interpolationFactor(Qe, rt, Wn) {
                            return this.interpolationType ? ae.interpolationFactor(this.interpolationType, Qe, rt, Wn) : 0;
                        }
                    }
                    function Wr(Qe, rt) {
                        const Wn = Yr(Qe, rt);
                        if ("error" === Wn.result) return Wn;
                        const Co = Wn.value.expression, Dl = Cr(Co);
                        if (!Dl && !Fr(rt)) return Er([
                            new V("", "data expressions not supported")
                        ]);
                        const Ll = Tr(Co, [
                            "zoom"
                        ]);
                        if (!Ll && !Dr(rt)) return Er([
                            new V("", "zoom expressions not supported")
                        ]);
                        const Rl = tn(Co);
                        return Rl || Ll ? Rl instanceof V ? Er([
                            Rl
                        ]) : Rl instanceof ae && !Lr(rt) ? Er([
                            new V("", '"interpolate" expressions cannot be used with this property')
                        ]) : Vr(Rl ? new Kr(Dl ? "camera" : "composite", Wn.value, Rl.labels, Rl instanceof ae ? Rl.interpolation : void 0) : new Jr(Dl ? "constant" : "source", Wn.value)) : Er([
                            new V("", '"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.')
                        ]);
                    }
                    class Qr {
                        constructor(Qe, rt){
                            this._parameters = Qe, this._specification = rt, T(this, Nr(this._parameters, this._specification));
                        }
                        static deserialize(Qe) {
                            return new Qr(Qe._parameters, Qe._specification);
                        }
                        static serialize(Qe) {
                            return {
                                _parameters: Qe._parameters,
                                _specification: Qe._specification
                            };
                        }
                    }
                    function tn(Qe) {
                        let rt = null;
                        if (Qe instanceof Zt) rt = tn(Qe.result);
                        else if (Qe instanceof ce) {
                            for (const Wn of Qe.args)if (rt = tn(Wn), rt) break;
                        } else (Qe instanceof ee || Qe instanceof ae) && Qe.input instanceof kr && "zoom" === Qe.input.name && (rt = Qe);
                        return rt instanceof V || Qe.eachChild((Qe)=>{
                            const Wn = tn(Qe);
                            Wn instanceof V ? rt = Wn : !rt && Wn ? rt = new V("", '"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.') : rt && Wn && rt !== Wn && (rt = new V("", 'Only one zoom-based "step" or "interpolate" subexpression may be used in an expression.'));
                        }), rt;
                    }
                    function en(Qe) {
                        if (!0 === Qe || !1 === Qe) return !0;
                        if (!Array.isArray(Qe) || 0 === Qe.length) return !1;
                        switch(Qe[0]){
                            case "has":
                                return Qe.length >= 2 && "$id" !== Qe[1] && "$type" !== Qe[1];
                            case "in":
                                return Qe.length >= 3 && ("string" != typeof Qe[1] || Array.isArray(Qe[2]));
                            case "!in":
                            case "!has":
                            case "none":
                                return !1;
                            case "==":
                            case "!=":
                            case ">":
                            case ">=":
                            case "<":
                            case "<=":
                                return 3 !== Qe.length || Array.isArray(Qe[1]) || Array.isArray(Qe[2]);
                            case "any":
                            case "all":
                                for (const rt of Qe.slice(1))if (!en(rt) && "boolean" != typeof rt) return !1;
                                return !0;
                            default:
                                return !0;
                        }
                    }
                    const zd = {
                        type: "boolean",
                        default: !1,
                        transition: !1,
                        "property-type": "data-driven",
                        expression: {
                            interpolated: !1,
                            parameters: [
                                "zoom",
                                "feature"
                            ]
                        }
                    };
                    function nn(Qe) {
                        if (null == Qe) return {
                            filter: ()=>!0,
                            needGeometry: !1
                        };
                        en(Qe) || (Qe = an(Qe));
                        const rt = Yr(Qe, zd);
                        if ("error" === rt.result) throw new Error(rt.value.map((Qe)=>`${Qe.key}: ${Qe.message}`).join(", "));
                        return {
                            filter: (Qe, Wn, Co)=>rt.value.evaluate(Qe, Wn, {}, Co),
                            needGeometry: on(Qe)
                        };
                    }
                    function sn(Qe, rt) {
                        return Qe < rt ? -1 : Qe > rt ? 1 : 0;
                    }
                    function on(Qe) {
                        if (!Array.isArray(Qe)) return !1;
                        if ("within" === Qe[0] || "distance" === Qe[0]) return !0;
                        for(let rt = 1; rt < Qe.length; rt++)if (on(Qe[rt])) return !0;
                        return !1;
                    }
                    function an(Qe) {
                        if (!Qe) return !0;
                        const rt = Qe[0];
                        var Wn;
                        return Qe.length <= 1 ? "any" !== rt : "==" === rt ? ln(Qe[1], Qe[2], "==") : "!=" === rt ? hn(ln(Qe[1], Qe[2], "==")) : "<" === rt || ">" === rt || "<=" === rt || ">=" === rt ? ln(Qe[1], Qe[2], rt) : "any" === rt ? (Wn = Qe.slice(1), [
                            "any"
                        ].concat(Wn.map(an))) : "all" === rt ? [
                            "all"
                        ].concat(Qe.slice(1).map(an)) : "none" === rt ? [
                            "all"
                        ].concat(Qe.slice(1).map(an).map(hn)) : "in" === rt ? un(Qe[1], Qe.slice(2)) : "!in" === rt ? hn(un(Qe[1], Qe.slice(2))) : "has" === rt ? cn(Qe[1]) : "!has" !== rt || hn(cn(Qe[1]));
                    }
                    function ln(Qe, rt, Wn) {
                        switch(Qe){
                            case "$type":
                                return [
                                    `filter-type-${Wn}`,
                                    rt
                                ];
                            case "$id":
                                return [
                                    `filter-id-${Wn}`,
                                    rt
                                ];
                            default:
                                return [
                                    `filter-${Wn}`,
                                    Qe,
                                    rt
                                ];
                        }
                    }
                    function un(Qe, rt) {
                        if (0 === rt.length) return !1;
                        switch(Qe){
                            case "$type":
                                return [
                                    "filter-type-in",
                                    [
                                        "literal",
                                        rt
                                    ]
                                ];
                            case "$id":
                                return [
                                    "filter-id-in",
                                    [
                                        "literal",
                                        rt
                                    ]
                                ];
                            default:
                                return rt.length > 200 && !rt.some((Qe)=>typeof Qe != typeof rt[0]) ? [
                                    "filter-in-large",
                                    Qe,
                                    [
                                        "literal",
                                        rt.sort(sn)
                                    ]
                                ] : [
                                    "filter-in-small",
                                    Qe,
                                    [
                                        "literal",
                                        rt
                                    ]
                                ];
                        }
                    }
                    function cn(Qe) {
                        switch(Qe){
                            case "$type":
                                return !0;
                            case "$id":
                                return [
                                    "filter-has-id"
                                ];
                            default:
                                return [
                                    "filter-has",
                                    Qe
                                ];
                        }
                    }
                    function hn(Qe) {
                        return [
                            "!",
                            Qe
                        ];
                    }
                    function pn(Qe) {
                        const rt = typeof Qe;
                        if ("number" === rt || "boolean" === rt || "string" === rt || null == Qe) return JSON.stringify(Qe);
                        if (Array.isArray(Qe)) {
                            let rt = "[";
                            for (const Wn of Qe)rt += `${pn(Wn)},`;
                            return `${rt}]`;
                        }
                        const Wn = Object.keys(Qe).sort();
                        let Co = "{";
                        for(let Dl = 0; Dl < Wn.length; Dl++)Co += `${JSON.stringify(Wn[Dl])}:${pn(Qe[Wn[Dl]])},`;
                        return `${Co}}`;
                    }
                    function fn(Qe) {
                        let rt = "";
                        for (const Wn of tu)rt += `/${pn(Qe[Wn])}`;
                        return rt;
                    }
                    function dn(Qe) {
                        const rt = Qe.value;
                        return rt ? [
                            new B(Qe.key, rt, "constants have been deprecated as of v8")
                        ] : [];
                    }
                    function yn(Qe) {
                        return Qe instanceof Number || Qe instanceof String || Qe instanceof Boolean ? Qe.valueOf() : Qe;
                    }
                    function mn(Qe) {
                        if (Array.isArray(Qe)) return Qe.map(mn);
                        if (Qe instanceof Object && !(Qe instanceof Number || Qe instanceof String || Qe instanceof Boolean)) {
                            const rt = {};
                            for(const Wn in Qe)rt[Wn] = mn(Qe[Wn]);
                            return rt;
                        }
                        return yn(Qe);
                    }
                    function gn(Qe) {
                        const rt = Qe.key, Wn = Qe.value, Co = Qe.valueSpec || {}, Dl = Qe.objectElementValidators || {}, Ll = Qe.style, Rl = Qe.styleSpec, Ul = Qe.validateSpec;
                        let Gl = [];
                        const Zl = $r(Wn);
                        if ("object" !== Zl) return [
                            new B(rt, Wn, `object expected, ${Zl} found`)
                        ];
                        for(const Hl in Wn){
                            const Qe = Hl.split(".")[0], Zl = Co[Qe] || Co["*"];
                            let ql;
                            if (Dl[Qe]) ql = Dl[Qe];
                            else if (Co[Qe]) ql = Ul;
                            else if (Dl["*"]) ql = Dl["*"];
                            else {
                                if (!Co["*"]) {
                                    Gl.push(new B(rt, Wn[Hl], `unknown property "${Hl}"`));
                                    continue;
                                }
                                ql = Ul;
                            }
                            Gl = Gl.concat(ql({
                                key: (rt ? `${rt}.` : rt) + Hl,
                                value: Wn[Hl],
                                valueSpec: Zl,
                                style: Ll,
                                styleSpec: Rl,
                                object: Wn,
                                objectKey: Hl,
                                validateSpec: Ul
                            }, Wn));
                        }
                        for(const Hl in Co)Dl[Hl] || Co[Hl].required && void 0 === Co[Hl].default && void 0 === Wn[Hl] && Gl.push(new B(rt, Wn, `missing required property "${Hl}"`));
                        return Gl;
                    }
                    function xn(Qe) {
                        const rt = Qe.value, Wn = Qe.valueSpec, Co = Qe.style, Dl = Qe.styleSpec, Ll = Qe.key, Rl = Qe.arrayElementValidator || Qe.validateSpec;
                        if ("array" !== $r(rt)) return [
                            new B(Ll, rt, `array expected, ${$r(rt)} found`)
                        ];
                        if (Wn.length && rt.length !== Wn.length) return [
                            new B(Ll, rt, `array length ${Wn.length} expected, length ${rt.length} found`)
                        ];
                        if (Wn["min-length"] && rt.length < Wn["min-length"]) return [
                            new B(Ll, rt, `array length at least ${Wn["min-length"]} expected, length ${rt.length} found`)
                        ];
                        let Ul = {
                            type: Wn.value,
                            values: Wn.values
                        };
                        Dl.$version < 7 && (Ul.function = Wn.function), "object" === $r(Wn.value) && (Ul = Wn.value);
                        let Gl = [];
                        for(let Zl = 0; Zl < rt.length; Zl++)Gl = Gl.concat(Rl({
                            array: rt,
                            arrayIndex: Zl,
                            value: rt[Zl],
                            valueSpec: Ul,
                            validateSpec: Qe.validateSpec,
                            style: Co,
                            styleSpec: Dl,
                            key: `${Ll}[${Zl}]`
                        }));
                        return Gl;
                    }
                    function vn(Qe) {
                        const rt = Qe.key, Wn = Qe.value, Co = Qe.valueSpec;
                        let Dl = $r(Wn);
                        return "number" === Dl && Wn != Wn && (Dl = "NaN"), "number" !== Dl ? [
                            new B(rt, Wn, `number expected, ${Dl} found`)
                        ] : "minimum" in Co && Wn < Co.minimum ? [
                            new B(rt, Wn, `${Wn} is less than the minimum value ${Co.minimum}`)
                        ] : "maximum" in Co && Wn > Co.maximum ? [
                            new B(rt, Wn, `${Wn} is greater than the maximum value ${Co.maximum}`)
                        ] : [];
                    }
                    function bn(Qe) {
                        const rt = Qe.valueSpec, Wn = yn(Qe.value.type);
                        let Co, Dl, Ll, Rl = {};
                        const Ul = "categorical" !== Wn && void 0 === Qe.value.property, Gl = !Ul, Zl = "array" === $r(Qe.value.stops) && "array" === $r(Qe.value.stops[0]) && "object" === $r(Qe.value.stops[0][0]), Hl = gn({
                            key: Qe.key,
                            value: Qe.value,
                            valueSpec: Qe.styleSpec.function,
                            validateSpec: Qe.validateSpec,
                            style: Qe.style,
                            styleSpec: Qe.styleSpec,
                            objectElementValidators: {
                                stops: function(Qe) {
                                    if ("identity" === Wn) return [
                                        new B(Qe.key, Qe.value, 'identity function may not have a "stops" property')
                                    ];
                                    let rt = [];
                                    const Co = Qe.value;
                                    return rt = rt.concat(xn({
                                        key: Qe.key,
                                        value: Co,
                                        valueSpec: Qe.valueSpec,
                                        validateSpec: Qe.validateSpec,
                                        style: Qe.style,
                                        styleSpec: Qe.styleSpec,
                                        arrayElementValidator: h
                                    })), "array" === $r(Co) && 0 === Co.length && rt.push(new B(Qe.key, Co, "array must have at least one stop")), rt;
                                },
                                default: function(Qe) {
                                    return Qe.validateSpec({
                                        key: Qe.key,
                                        value: Qe.value,
                                        valueSpec: rt,
                                        validateSpec: Qe.validateSpec,
                                        style: Qe.style,
                                        styleSpec: Qe.styleSpec
                                    });
                                }
                            }
                        });
                        return "identity" === Wn && Ul && Hl.push(new B(Qe.key, Qe.value, 'missing required property "property"')), "identity" === Wn || Qe.value.stops || Hl.push(new B(Qe.key, Qe.value, 'missing required property "stops"')), "exponential" === Wn && Qe.valueSpec.expression && !Lr(Qe.valueSpec) && Hl.push(new B(Qe.key, Qe.value, "exponential functions not supported")), Qe.styleSpec.$version >= 8 && (Gl && !Fr(Qe.valueSpec) ? Hl.push(new B(Qe.key, Qe.value, "property functions not supported")) : Ul && !Dr(Qe.valueSpec) && Hl.push(new B(Qe.key, Qe.value, "zoom functions not supported"))), "categorical" !== Wn && !Zl || void 0 !== Qe.value.property || Hl.push(new B(Qe.key, Qe.value, '"property" property is required')), Hl;
                        function h(Qe) {
                            let Wn = [];
                            const Co = Qe.value, Ul = Qe.key;
                            if ("array" !== $r(Co)) return [
                                new B(Ul, Co, `array expected, ${$r(Co)} found`)
                            ];
                            if (2 !== Co.length) return [
                                new B(Ul, Co, `array length 2 expected, length ${Co.length} found`)
                            ];
                            if (Zl) {
                                if ("object" !== $r(Co[0])) return [
                                    new B(Ul, Co, `object expected, ${$r(Co[0])} found`)
                                ];
                                if (void 0 === Co[0].zoom) return [
                                    new B(Ul, Co, "object stop key must have zoom")
                                ];
                                if (void 0 === Co[0].value) return [
                                    new B(Ul, Co, "object stop key must have value")
                                ];
                                if (Ll && Ll > yn(Co[0].zoom)) return [
                                    new B(Ul, Co[0].zoom, "stop zoom values must appear in ascending order")
                                ];
                                yn(Co[0].zoom) !== Ll && (Ll = yn(Co[0].zoom), Dl = void 0, Rl = {}), Wn = Wn.concat(gn({
                                    key: `${Ul}[0]`,
                                    value: Co[0],
                                    valueSpec: {
                                        zoom: {}
                                    },
                                    validateSpec: Qe.validateSpec,
                                    style: Qe.style,
                                    styleSpec: Qe.styleSpec,
                                    objectElementValidators: {
                                        zoom: vn,
                                        value: p
                                    }
                                }));
                            } else Wn = Wn.concat(p({
                                key: `${Ul}[0]`,
                                value: Co[0],
                                validateSpec: Qe.validateSpec,
                                style: Qe.style,
                                styleSpec: Qe.styleSpec
                            }, Co));
                            return Hr(mn(Co[1])) ? Wn.concat([
                                new B(`${Ul}[1]`, Co[1], "expressions are not allowed in function stops.")
                            ]) : Wn.concat(Qe.validateSpec({
                                key: `${Ul}[1]`,
                                value: Co[1],
                                valueSpec: rt,
                                validateSpec: Qe.validateSpec,
                                style: Qe.style,
                                styleSpec: Qe.styleSpec
                            }));
                        }
                        function p(Qe, Ll) {
                            const Ul = $r(Qe.value), Gl = yn(Qe.value), Zl = null !== Qe.value ? Qe.value : Ll;
                            if (Co) {
                                if (Ul !== Co) return [
                                    new B(Qe.key, Zl, `${Ul} stop domain type must match previous stop domain type ${Co}`)
                                ];
                            } else Co = Ul;
                            if ("number" !== Ul && "string" !== Ul && "boolean" !== Ul) return [
                                new B(Qe.key, Zl, "stop domain value must be a number, string, or boolean")
                            ];
                            if ("number" !== Ul && "categorical" !== Wn) {
                                let Co = `number expected, ${Ul} found`;
                                return Fr(rt) && void 0 === Wn && (Co += '\nIf you intended to use a categorical function, specify `"type": "categorical"`.'), [
                                    new B(Qe.key, Zl, Co)
                                ];
                            }
                            return "categorical" !== Wn || "number" !== Ul || isFinite(Gl) && Math.floor(Gl) === Gl ? "categorical" !== Wn && "number" === Ul && void 0 !== Dl && Gl < Dl ? [
                                new B(Qe.key, Zl, "stop domain values must appear in ascending order")
                            ] : (Dl = Gl, "categorical" === Wn && Gl in Rl ? [
                                new B(Qe.key, Zl, "stop domain values must be unique")
                            ] : (Rl[Gl] = !0, [])) : [
                                new B(Qe.key, Zl, `integer expected, found ${Gl}`)
                            ];
                        }
                    }
                    function wn(Qe) {
                        const rt = ("property" === Qe.expressionContext ? Wr : Yr)(mn(Qe.value), Qe.valueSpec);
                        if ("error" === rt.result) return rt.value.map((rt)=>new B(`${Qe.key}${rt.key}`, Qe.value, rt.message));
                        const Wn = rt.value.expression || rt.value._styleExpression.expression;
                        if ("property" === Qe.expressionContext && "text-font" === Qe.propertyKey && !Wn.outputDefined()) return [
                            new B(Qe.key, Qe.value, `Invalid data expression for "${Qe.propertyKey}". Output values must be contained as literals within the expression.`)
                        ];
                        if ("property" === Qe.expressionContext && "layout" === Qe.propertyType && !Br(Wn)) return [
                            new B(Qe.key, Qe.value, '"feature-state" data expressions are not supported with layout properties.')
                        ];
                        if ("filter" === Qe.expressionContext && !Br(Wn)) return [
                            new B(Qe.key, Qe.value, '"feature-state" data expressions are not supported with filters.')
                        ];
                        if (Qe.expressionContext && 0 === Qe.expressionContext.indexOf("cluster")) {
                            if (!Tr(Wn, [
                                "zoom",
                                "feature-state"
                            ])) return [
                                new B(Qe.key, Qe.value, '"zoom" and "feature-state" expressions are not supported with cluster properties.')
                            ];
                            if ("cluster-initial" === Qe.expressionContext && !Cr(Wn)) return [
                                new B(Qe.key, Qe.value, "Feature data expressions are not supported with initial expression part of cluster properties.")
                            ];
                        }
                        return [];
                    }
                    function _n(Qe) {
                        const rt = Qe.key, Wn = Qe.value, Co = Qe.valueSpec, Dl = [];
                        return Array.isArray(Co.values) ? -1 === Co.values.indexOf(yn(Wn)) && Dl.push(new B(rt, Wn, `expected one of [${Co.values.join(", ")}], ${JSON.stringify(Wn)} found`)) : -1 === Object.keys(Co.values).indexOf(yn(Wn)) && Dl.push(new B(rt, Wn, `expected one of [${Object.keys(Co.values).join(", ")}], ${JSON.stringify(Wn)} found`)), Dl;
                    }
                    function Sn(Qe) {
                        return en(mn(Qe.value)) ? wn(T({}, Qe, {
                            expressionContext: "filter",
                            valueSpec: {
                                value: "boolean"
                            }
                        })) : kn(Qe);
                    }
                    function kn(Qe) {
                        const rt = Qe.value, Wn = Qe.key;
                        if ("array" !== $r(rt)) return [
                            new B(Wn, rt, `array expected, ${$r(rt)} found`)
                        ];
                        const Co = Qe.styleSpec;
                        let Dl, Ll = [];
                        if (rt.length < 1) return [
                            new B(Wn, rt, "filter array must have at least 1 element")
                        ];
                        switch(Ll = Ll.concat(_n({
                            key: `${Wn}[0]`,
                            value: rt[0],
                            valueSpec: Co.filter_operator,
                            style: Qe.style,
                            styleSpec: Qe.styleSpec
                        })), yn(rt[0])){
                            case "<":
                            case "<=":
                            case ">":
                            case ">=":
                                rt.length >= 2 && "$type" === yn(rt[1]) && Ll.push(new B(Wn, rt, `"$type" cannot be use with operator "${rt[0]}"`));
                            case "==":
                            case "!=":
                                3 !== rt.length && Ll.push(new B(Wn, rt, `filter array for operator "${rt[0]}" must have 3 elements`));
                            case "in":
                            case "!in":
                                rt.length >= 2 && (Dl = $r(rt[1]), "string" !== Dl && Ll.push(new B(`${Wn}[1]`, rt[1], `string expected, ${Dl} found`)));
                                for(let Rl = 2; Rl < rt.length; Rl++)Dl = $r(rt[Rl]), "$type" === yn(rt[1]) ? Ll = Ll.concat(_n({
                                    key: `${Wn}[${Rl}]`,
                                    value: rt[Rl],
                                    valueSpec: Co.geometry_type,
                                    style: Qe.style,
                                    styleSpec: Qe.styleSpec
                                })) : "string" !== Dl && "number" !== Dl && "boolean" !== Dl && Ll.push(new B(`${Wn}[${Rl}]`, rt[Rl], `string, number, or boolean expected, ${Dl} found`));
                                break;
                            case "any":
                            case "all":
                            case "none":
                                for(let Co = 1; Co < rt.length; Co++)Ll = Ll.concat(kn({
                                    key: `${Wn}[${Co}]`,
                                    value: rt[Co],
                                    style: Qe.style,
                                    styleSpec: Qe.styleSpec
                                }));
                                break;
                            case "has":
                            case "!has":
                                Dl = $r(rt[1]), 2 !== rt.length ? Ll.push(new B(Wn, rt, `filter array for "${rt[0]}" operator must have 2 elements`)) : "string" !== Dl && Ll.push(new B(`${Wn}[1]`, rt[1], `string expected, ${Dl} found`));
                        }
                        return Ll;
                    }
                    function An(Qe, rt) {
                        const Wn = Qe.key, Co = Qe.validateSpec, Dl = Qe.style, Ll = Qe.styleSpec, Rl = Qe.value, Ul = Qe.objectKey, Gl = Ll[`${rt}_${Qe.layerType}`];
                        if (!Gl) return [];
                        const Zl = Ul.match(/^(.*)-transition$/);
                        if ("paint" === rt && Zl && Gl[Zl[1]] && Gl[Zl[1]].transition) return Co({
                            key: Wn,
                            value: Rl,
                            valueSpec: Ll.transition,
                            style: Dl,
                            styleSpec: Ll
                        });
                        const Hl = Qe.valueSpec || Gl[Ul];
                        if (!Hl) return [
                            new B(Wn, Rl, `unknown property "${Ul}"`)
                        ];
                        let ql;
                        if ("string" === $r(Rl) && Fr(Hl) && !Hl.tokens && (ql = /^{([^}]+)}$/.exec(Rl))) return [
                            new B(Wn, Rl, `"${Ul}" does not support interpolation syntax\nUse an identity property function instead: \`{ "type": "identity", "property": ${JSON.stringify(ql[1])} }\`.`)
                        ];
                        const Ql = [];
                        return "symbol" === Qe.layerType && ("text-field" === Ul && Dl && !Dl.glyphs && Ql.push(new B(Wn, Rl, 'use of "text-field" requires a style "glyphs" property')), "text-font" === Ul && Or(mn(Rl)) && "identity" === yn(Rl.type) && Ql.push(new B(Wn, Rl, '"text-font" does not support identity functions'))), Ql.concat(Co({
                            key: Qe.key,
                            value: Rl,
                            valueSpec: Hl,
                            style: Dl,
                            styleSpec: Ll,
                            expressionContext: "property",
                            propertyType: rt,
                            propertyKey: Ul
                        }));
                    }
                    function In(Qe) {
                        return An(Qe, "paint");
                    }
                    function Mn(Qe) {
                        return An(Qe, "layout");
                    }
                    function zn(Qe) {
                        let rt = [];
                        const Wn = Qe.value, Co = Qe.key, Dl = Qe.style, Ll = Qe.styleSpec;
                        Wn.type || Wn.ref || rt.push(new B(Co, Wn, 'either "type" or "ref" is required'));
                        let Rl = yn(Wn.type);
                        const Ul = yn(Wn.ref);
                        if (Wn.id) {
                            const Ll = yn(Wn.id);
                            for(let Rl = 0; Rl < Qe.arrayIndex; Rl++){
                                const Qe = Dl.layers[Rl];
                                yn(Qe.id) === Ll && rt.push(new B(Co, Wn.id, `duplicate layer id "${Wn.id}", previously used at line ${Qe.id.__line__}`));
                            }
                        }
                        if ("ref" in Wn) {
                            let Qe;
                            [
                                "type",
                                "source",
                                "source-layer",
                                "filter",
                                "layout"
                            ].forEach((Qe)=>{
                                Qe in Wn && rt.push(new B(Co, Wn[Qe], `"${Qe}" is prohibited for ref layers`));
                            }), Dl.layers.forEach((rt)=>{
                                yn(rt.id) === Ul && (Qe = rt);
                            }), Qe ? Qe.ref ? rt.push(new B(Co, Wn.ref, "ref cannot reference another ref layer")) : Rl = yn(Qe.type) : rt.push(new B(Co, Wn.ref, `ref layer "${Ul}" not found`));
                        } else if ("background" !== Rl) {
                            if (Wn.source) {
                                const Qe = Dl.sources && Dl.sources[Wn.source], Ll = Qe && yn(Qe.type);
                                Qe ? "vector" === Ll && "raster" === Rl ? rt.push(new B(Co, Wn.source, `layer "${Wn.id}" requires a raster source`)) : "raster-dem" !== Ll && "hillshade" === Rl ? rt.push(new B(Co, Wn.source, `layer "${Wn.id}" requires a raster-dem source`)) : "raster" === Ll && "raster" !== Rl ? rt.push(new B(Co, Wn.source, `layer "${Wn.id}" requires a vector source`)) : "vector" !== Ll || Wn["source-layer"] ? "raster-dem" === Ll && "hillshade" !== Rl ? rt.push(new B(Co, Wn.source, "raster-dem source can only be used with layer type 'hillshade'.")) : "line" !== Rl || !Wn.paint || !Wn.paint["line-gradient"] || "geojson" === Ll && Qe.lineMetrics || rt.push(new B(Co, Wn, `layer "${Wn.id}" specifies a line-gradient, which requires a GeoJSON source with \`lineMetrics\` enabled.`)) : rt.push(new B(Co, Wn, `layer "${Wn.id}" must specify a "source-layer"`)) : rt.push(new B(Co, Wn.source, `source "${Wn.source}" not found`));
                            } else rt.push(new B(Co, Wn, 'missing required property "source"'));
                        }
                        return rt = rt.concat(gn({
                            key: Co,
                            value: Wn,
                            valueSpec: Ll.layer,
                            style: Qe.style,
                            styleSpec: Qe.styleSpec,
                            validateSpec: Qe.validateSpec,
                            objectElementValidators: {
                                "*": ()=>[],
                                type: ()=>Qe.validateSpec({
                                        key: `${Co}.type`,
                                        value: Wn.type,
                                        valueSpec: Ll.layer.type,
                                        style: Qe.style,
                                        styleSpec: Qe.styleSpec,
                                        validateSpec: Qe.validateSpec,
                                        object: Wn,
                                        objectKey: "type"
                                    }),
                                filter: Sn,
                                layout: (Qe)=>gn({
                                        layer: Wn,
                                        key: Qe.key,
                                        value: Qe.value,
                                        style: Qe.style,
                                        styleSpec: Qe.styleSpec,
                                        validateSpec: Qe.validateSpec,
                                        objectElementValidators: {
                                            "*": (Qe)=>Mn(T({
                                                    layerType: Rl
                                                }, Qe))
                                        }
                                    }),
                                paint: (Qe)=>gn({
                                        layer: Wn,
                                        key: Qe.key,
                                        value: Qe.value,
                                        style: Qe.style,
                                        styleSpec: Qe.styleSpec,
                                        validateSpec: Qe.validateSpec,
                                        objectElementValidators: {
                                            "*": (Qe)=>In(T({
                                                    layerType: Rl
                                                }, Qe))
                                        }
                                    })
                            }
                        })), rt;
                    }
                    function Pn(Qe) {
                        const rt = Qe.value, Wn = Qe.key, Co = $r(rt);
                        return "string" !== Co ? [
                            new B(Wn, rt, `string expected, ${Co} found`)
                        ] : [];
                    }
                    const Nd = {
                        promoteId: function(Qe) {
                            let { key: rt, value: Wn } = Qe;
                            if ("string" === $r(Wn)) return Pn({
                                key: rt,
                                value: Wn
                            });
                            {
                                const Qe = [];
                                for(const Co in Wn)Qe.push(...Pn({
                                    key: `${rt}.${Co}`,
                                    value: Wn[Co]
                                }));
                                return Qe;
                            }
                        }
                    };
                    function Bn(Qe) {
                        const rt = Qe.value, Wn = Qe.key, Co = Qe.styleSpec, Dl = Qe.style, Ll = Qe.validateSpec;
                        if (!rt.type) return [
                            new B(Wn, rt, '"type" is required')
                        ];
                        const Rl = yn(rt.type);
                        let Ul;
                        switch(Rl){
                            case "vector":
                            case "raster":
                                return Ul = gn({
                                    key: Wn,
                                    value: rt,
                                    valueSpec: Co[`source_${Rl.replace("-", "_")}`],
                                    style: Qe.style,
                                    styleSpec: Co,
                                    objectElementValidators: Nd,
                                    validateSpec: Ll
                                }), Ul;
                            case "raster-dem":
                                return Ul = function(Qe) {
                                    var rt;
                                    const Wn = null !== (rt = Qe.sourceName) && void 0 !== rt ? rt : "", Co = Qe.value, Dl = Qe.styleSpec, Ll = Dl.source_raster_dem, Rl = Qe.style;
                                    let Ul = [];
                                    const Gl = $r(Co);
                                    if (void 0 === Co) return Ul;
                                    if ("object" !== Gl) return Ul.push(new B("source_raster_dem", Co, `object expected, ${Gl} found`)), Ul;
                                    const Zl = "custom" === yn(Co.encoding), Hl = [
                                        "redFactor",
                                        "greenFactor",
                                        "blueFactor",
                                        "baseShift"
                                    ], ql = Qe.value.encoding ? `"${Qe.value.encoding}"` : "Default";
                                    for(const Ql in Co)!Zl && Hl.includes(Ql) ? Ul.push(new B(Ql, Co[Ql], `In "${Wn}": "${Ql}" is only valid when "encoding" is set to "custom". ${ql} encoding found`)) : Ll[Ql] ? Ul = Ul.concat(Qe.validateSpec({
                                        key: Ql,
                                        value: Co[Ql],
                                        valueSpec: Ll[Ql],
                                        validateSpec: Qe.validateSpec,
                                        style: Rl,
                                        styleSpec: Dl
                                    })) : Ul.push(new B(Ql, Co[Ql], `unknown property "${Ql}"`));
                                    return Ul;
                                }({
                                    sourceName: Wn,
                                    value: rt,
                                    style: Qe.style,
                                    styleSpec: Co,
                                    validateSpec: Ll
                                }), Ul;
                            case "geojson":
                                if (Ul = gn({
                                    key: Wn,
                                    value: rt,
                                    valueSpec: Co.source_geojson,
                                    style: Dl,
                                    styleSpec: Co,
                                    validateSpec: Ll,
                                    objectElementValidators: Nd
                                }), rt.cluster) for(const Qe in rt.clusterProperties){
                                    const [Co, Dl] = rt.clusterProperties[Qe], Ll = "string" == typeof Co ? [
                                        Co,
                                        [
                                            "accumulated"
                                        ],
                                        [
                                            "get",
                                            Qe
                                        ]
                                    ] : Co;
                                    Ul.push(...wn({
                                        key: `${Wn}.${Qe}.map`,
                                        value: Dl,
                                        expressionContext: "cluster-map"
                                    })), Ul.push(...wn({
                                        key: `${Wn}.${Qe}.reduce`,
                                        value: Ll,
                                        expressionContext: "cluster-reduce"
                                    }));
                                }
                                return Ul;
                            case "video":
                                return gn({
                                    key: Wn,
                                    value: rt,
                                    valueSpec: Co.source_video,
                                    style: Dl,
                                    validateSpec: Ll,
                                    styleSpec: Co
                                });
                            case "image":
                                return gn({
                                    key: Wn,
                                    value: rt,
                                    valueSpec: Co.source_image,
                                    style: Dl,
                                    validateSpec: Ll,
                                    styleSpec: Co
                                });
                            case "canvas":
                                return [
                                    new B(Wn, null, "Please use runtime APIs to add canvas sources, rather than including them in stylesheets.", "source.canvas")
                                ];
                            default:
                                return _n({
                                    key: `${Wn}.type`,
                                    value: rt.type,
                                    valueSpec: {
                                        values: [
                                            "vector",
                                            "raster",
                                            "raster-dem",
                                            "geojson",
                                            "video",
                                            "image"
                                        ]
                                    }
                                });
                        }
                    }
                    function Tn(Qe) {
                        const rt = Qe.value, Wn = Qe.styleSpec, Co = Wn.light, Dl = Qe.style;
                        let Ll = [];
                        const Rl = $r(rt);
                        if (void 0 === rt) return Ll;
                        if ("object" !== Rl) return Ll = Ll.concat([
                            new B("light", rt, `object expected, ${Rl} found`)
                        ]), Ll;
                        for(const Ul in rt){
                            const Rl = Ul.match(/^(.*)-transition$/);
                            Ll = Ll.concat(Rl && Co[Rl[1]] && Co[Rl[1]].transition ? Qe.validateSpec({
                                key: Ul,
                                value: rt[Ul],
                                valueSpec: Wn.transition,
                                validateSpec: Qe.validateSpec,
                                style: Dl,
                                styleSpec: Wn
                            }) : Co[Ul] ? Qe.validateSpec({
                                key: Ul,
                                value: rt[Ul],
                                valueSpec: Co[Ul],
                                validateSpec: Qe.validateSpec,
                                style: Dl,
                                styleSpec: Wn
                            }) : [
                                new B(Ul, rt[Ul], `unknown property "${Ul}"`)
                            ]);
                        }
                        return Ll;
                    }
                    function Vn(Qe) {
                        const rt = Qe.value, Wn = Qe.styleSpec, Co = Wn.sky, Dl = Qe.style, Ll = $r(rt);
                        if (void 0 === rt) return [];
                        if ("object" !== Ll) return [
                            new B("sky", rt, `object expected, ${Ll} found`)
                        ];
                        let Rl = [];
                        for(const Ul in rt)Rl = Rl.concat(Co[Ul] ? Qe.validateSpec({
                            key: Ul,
                            value: rt[Ul],
                            valueSpec: Co[Ul],
                            style: Dl,
                            styleSpec: Wn
                        }) : [
                            new B(Ul, rt[Ul], `unknown property "${Ul}"`)
                        ]);
                        return Rl;
                    }
                    function En(Qe) {
                        const rt = Qe.value, Wn = Qe.styleSpec, Co = Wn.terrain, Dl = Qe.style;
                        let Ll = [];
                        const Rl = $r(rt);
                        if (void 0 === rt) return Ll;
                        if ("object" !== Rl) return Ll = Ll.concat([
                            new B("terrain", rt, `object expected, ${Rl} found`)
                        ]), Ll;
                        for(const Ul in rt)Ll = Ll.concat(Co[Ul] ? Qe.validateSpec({
                            key: Ul,
                            value: rt[Ul],
                            valueSpec: Co[Ul],
                            validateSpec: Qe.validateSpec,
                            style: Dl,
                            styleSpec: Wn
                        }) : [
                            new B(Ul, rt[Ul], `unknown property "${Ul}"`)
                        ]);
                        return Ll;
                    }
                    function Fn(Qe) {
                        let rt = [];
                        const Wn = Qe.value, Co = Qe.key;
                        if (Array.isArray(Wn)) {
                            const Dl = [], Ll = [];
                            for(const Rl in Wn)Wn[Rl].id && Dl.includes(Wn[Rl].id) && rt.push(new B(Co, Wn, `all the sprites' ids must be unique, but ${Wn[Rl].id} is duplicated`)), Dl.push(Wn[Rl].id), Wn[Rl].url && Ll.includes(Wn[Rl].url) && rt.push(new B(Co, Wn, `all the sprites' URLs must be unique, but ${Wn[Rl].url} is duplicated`)), Ll.push(Wn[Rl].url), rt = rt.concat(gn({
                                key: `${Co}[${Rl}]`,
                                value: Wn[Rl],
                                valueSpec: {
                                    id: {
                                        type: "string",
                                        required: !0
                                    },
                                    url: {
                                        type: "string",
                                        required: !0
                                    }
                                },
                                validateSpec: Qe.validateSpec
                            }));
                            return rt;
                        }
                        return Pn({
                            key: Co,
                            value: Wn
                        });
                    }
                    const Rd = {
                        "*": ()=>[],
                        array: xn,
                        boolean: function(Qe) {
                            const rt = Qe.value, Wn = Qe.key, Co = $r(rt);
                            return "boolean" !== Co ? [
                                new B(Wn, rt, `boolean expected, ${Co} found`)
                            ] : [];
                        },
                        number: vn,
                        color: function(Qe) {
                            const rt = Qe.key, Wn = Qe.value, Co = $r(Wn);
                            return "string" !== Co ? [
                                new B(rt, Wn, `color expected, ${Co} found`)
                            ] : St.parse(String(Wn)) ? [] : [
                                new B(rt, Wn, `color expected, "${Wn}" found`)
                            ];
                        },
                        constants: dn,
                        enum: _n,
                        filter: Sn,
                        function: bn,
                        layer: zn,
                        object: gn,
                        source: Bn,
                        light: Tn,
                        sky: Vn,
                        terrain: En,
                        projection: function(Qe) {
                            const rt = Qe.value, Wn = Qe.styleSpec, Co = Wn.projection, Dl = Qe.style, Ll = $r(rt);
                            if (void 0 === rt) return [];
                            if ("object" !== Ll) return [
                                new B("projection", rt, `object expected, ${Ll} found`)
                            ];
                            let Rl = [];
                            for(const Ul in rt)Rl = Rl.concat(Co[Ul] ? Qe.validateSpec({
                                key: Ul,
                                value: rt[Ul],
                                valueSpec: Co[Ul],
                                style: Dl,
                                styleSpec: Wn
                            }) : [
                                new B(Ul, rt[Ul], `unknown property "${Ul}"`)
                            ]);
                            return Rl;
                        },
                        projectionDefinition: function(Qe) {
                            const rt = Qe.key;
                            let Wn = Qe.value;
                            Wn = Wn instanceof String ? Wn.valueOf() : Wn;
                            const Co = $r(Wn);
                            return "array" !== Co || function(Qe) {
                                return Array.isArray(Qe) && 3 === Qe.length && "string" == typeof Qe[0] && "string" == typeof Qe[1] && "number" == typeof Qe[2];
                            }(Wn) || function(Qe) {
                                return !![
                                    "interpolate",
                                    "step",
                                    "literal"
                                ].includes(Qe[0]);
                            }(Wn) ? [
                                "array",
                                "string"
                            ].includes(Co) ? [] : [
                                new B(rt, Wn, `projection expected, invalid type "${Co}" found`)
                            ] : [
                                new B(rt, Wn, `projection expected, invalid array ${JSON.stringify(Wn)} found`)
                            ];
                        },
                        string: Pn,
                        formatted: function(Qe) {
                            return 0 === Pn(Qe).length ? [] : wn(Qe);
                        },
                        resolvedImage: function(Qe) {
                            return 0 === Pn(Qe).length ? [] : wn(Qe);
                        },
                        padding: function(Qe) {
                            const rt = Qe.key, Wn = Qe.value;
                            if ("array" === $r(Wn)) {
                                if (Wn.length < 1 || Wn.length > 4) return [
                                    new B(rt, Wn, `padding requires 1 to 4 values; ${Wn.length} values found`)
                                ];
                                const Co = {
                                    type: "number"
                                };
                                let Dl = [];
                                for(let Ll = 0; Ll < Wn.length; Ll++)Dl = Dl.concat(Qe.validateSpec({
                                    key: `${rt}[${Ll}]`,
                                    value: Wn[Ll],
                                    validateSpec: Qe.validateSpec,
                                    valueSpec: Co
                                }));
                                return Dl;
                            }
                            return vn({
                                key: rt,
                                value: Wn,
                                valueSpec: {}
                            });
                        },
                        variableAnchorOffsetCollection: function(Qe) {
                            const rt = Qe.key, Wn = Qe.value, Co = $r(Wn), Dl = Qe.styleSpec;
                            if ("array" !== Co || Wn.length < 1 || Wn.length % 2 != 0) return [
                                new B(rt, Wn, "variableAnchorOffsetCollection requires a non-empty array of even length")
                            ];
                            let Ll = [];
                            for(let Rl = 0; Rl < Wn.length; Rl += 2)Ll = Ll.concat(_n({
                                key: `${rt}[${Rl}]`,
                                value: Wn[Rl],
                                valueSpec: Dl.layout_symbol["text-anchor"]
                            })), Ll = Ll.concat(xn({
                                key: `${rt}[${Rl + 1}]`,
                                value: Wn[Rl + 1],
                                valueSpec: {
                                    length: 2,
                                    value: "number"
                                },
                                validateSpec: Qe.validateSpec,
                                style: Qe.style,
                                styleSpec: Dl
                            }));
                            return Ll;
                        },
                        sprite: Fn
                    };
                    function Ln(Qe) {
                        const rt = Qe.value, Wn = Qe.valueSpec, Co = Qe.styleSpec;
                        return Qe.validateSpec = Ln, Wn.expression && Or(yn(rt)) ? bn(Qe) : Wn.expression && Hr(mn(rt)) ? wn(Qe) : Wn.type && Rd[Wn.type] ? Rd[Wn.type](Qe) : gn(T({}, Qe, {
                            valueSpec: Wn.type ? Co[Wn.type] : Wn
                        }));
                    }
                    function $n(Qe) {
                        const rt = Qe.value, Wn = Qe.key, Co = Pn(Qe);
                        return Co.length || (-1 === rt.indexOf("{fontstack}") && Co.push(new B(Wn, rt, '"glyphs" url must include a "{fontstack}" token')), -1 === rt.indexOf("{range}") && Co.push(new B(Wn, rt, '"glyphs" url must include a "{range}" token'))), Co;
                    }
                    function On(Qe, rt) {
                        void 0 === rt && (rt = Tc);
                        let Wn = [];
                        return Wn = Wn.concat(Ln({
                            key: "",
                            value: Qe,
                            valueSpec: rt.$root,
                            styleSpec: rt,
                            style: Qe,
                            validateSpec: Ln,
                            objectElementValidators: {
                                glyphs: $n,
                                "*": ()=>[]
                            }
                        })), Qe.constants && (Wn = Wn.concat(dn({
                            key: "constants",
                            value: Qe.constants
                        }))), Nn(Wn);
                    }
                    function Rn(Qe) {
                        return function(rt) {
                            return Qe({
                                ...rt,
                                validateSpec: Ln
                            });
                        };
                    }
                    function Nn(Qe) {
                        return [].concat(Qe).sort((Qe, rt)=>Qe.line - rt.line);
                    }
                    function jn(Qe) {
                        return function() {
                            for(var rt = arguments.length, Wn = new Array(rt), Co = 0; Co < rt; Co++)Wn[Co] = arguments[Co];
                            return Nn(Qe.apply(this, Wn));
                        };
                    }
                    On.source = jn(Rn(Bn)), On.sprite = jn(Rn(Fn)), On.glyphs = jn(Rn($n)), On.light = jn(Rn(Tn)), On.sky = jn(Rn(Vn)), On.terrain = jn(Rn(En)), On.layer = jn(Rn(zn)), On.filter = jn(Rn(Sn)), On.paintProperty = jn(Rn(In)), On.layoutProperty = jn(Rn(Mn));
                    const Bd = "AbortError";
                    function Un() {
                        return new Error(Bd);
                    }
                    const Od = {
                        REGISTERED_PROTOCOLS: {}
                    };
                    function Zn(Qe, rt) {
                        Od.REGISTERED_PROTOCOLS[Qe] = rt;
                    }
                    function Xn(Qe) {
                        delete Od.REGISTERED_PROTOCOLS[Qe];
                    }
                    const Fd = "global-dispatcher";
                    class Yn extends Error {
                        constructor(Qe, rt, Wn, Co){
                            super(`AJAXError: ${rt} (${Qe}): ${Wn}`), this.status = Qe, this.statusText = rt, this.url = Wn, this.body = Co;
                        }
                    }
                    const Jn = ()=>S(self) ? self.worker && self.worker.referrer : ("blob:" === window.location.protocol ? window.parent : window).location.href, Kn = function(Qe, rt) {
                        if (/:\/\//.test(Qe.url) && !/^https?:|^file:/.test(Qe.url)) {
                            const Co = Od.REGISTERED_PROTOCOLS[(Wn = Qe.url).substring(0, Wn.indexOf("://"))];
                            if (Co) return Co(Qe, rt);
                            if (S(self) && self.worker && self.worker.actor) return self.worker.actor.sendAsync({
                                type: "GR",
                                data: Qe,
                                targetMapId: Fd
                            }, rt);
                        }
                        var Wn;
                        if (!((Qe)=>/^file:/.test(Qe) || /^file:/.test(Jn()) && !/^\w+:/.test(Qe))(Qe.url)) {
                            if (fetch && Request && AbortController && Object.prototype.hasOwnProperty.call(Request.prototype, "signal")) return function(Qe, rt) {
                                return t(this, void 0, void 0, function*() {
                                    const Wn = new Request(Qe.url, {
                                        method: Qe.method || "GET",
                                        body: Qe.body,
                                        credentials: Qe.credentials,
                                        headers: Qe.headers,
                                        cache: Qe.cache,
                                        referrer: Jn(),
                                        signal: rt.signal
                                    });
                                    let Co, Dl;
                                    "json" !== Qe.type || Wn.headers.has("Accept") || Wn.headers.set("Accept", "application/json");
                                    try {
                                        Co = yield fetch(Wn);
                                    } catch (Wn) {
                                        throw new Yn(0, Wn.message, Qe.url, new Blob);
                                    }
                                    if (!Co.ok) {
                                        const rt = yield Co.blob();
                                        throw new Yn(Co.status, Co.statusText, Qe.url, rt);
                                    }
                                    Dl = "arrayBuffer" === Qe.type || "image" === Qe.type ? Co.arrayBuffer() : "json" === Qe.type ? Co.json() : Co.text();
                                    const Ll = yield Dl;
                                    if (rt.signal.aborted) throw Un();
                                    return {
                                        data: Ll,
                                        cacheControl: Co.headers.get("Cache-Control"),
                                        expires: Co.headers.get("Expires")
                                    };
                                });
                            }(Qe, rt);
                            if (S(self) && self.worker && self.worker.actor) return self.worker.actor.sendAsync({
                                type: "GR",
                                data: Qe,
                                mustQueue: !0,
                                targetMapId: Fd
                            }, rt);
                        }
                        return function(Qe, rt) {
                            return new Promise((Wn, Co)=>{
                                var Dl;
                                const Ll = new XMLHttpRequest;
                                Ll.open(Qe.method || "GET", Qe.url, !0), "arrayBuffer" !== Qe.type && "image" !== Qe.type || (Ll.responseType = "arraybuffer");
                                for(const rt in Qe.headers)Ll.setRequestHeader(rt, Qe.headers[rt]);
                                "json" === Qe.type && (Ll.responseType = "text", (null === (Dl = Qe.headers) || void 0 === Dl ? void 0 : Dl.Accept) || Ll.setRequestHeader("Accept", "application/json")), Ll.withCredentials = "include" === Qe.credentials, Ll.onerror = ()=>{
                                    Co(new Error(Ll.statusText));
                                }, Ll.onload = ()=>{
                                    if (!rt.signal.aborted) {
                                        if ((Ll.status >= 200 && Ll.status < 300 || 0 === Ll.status) && null !== Ll.response) {
                                            let rt = Ll.response;
                                            if ("json" === Qe.type) try {
                                                rt = JSON.parse(Ll.response);
                                            } catch (Qe) {
                                                return void Co(Qe);
                                            }
                                            Wn({
                                                data: rt,
                                                cacheControl: Ll.getResponseHeader("Cache-Control"),
                                                expires: Ll.getResponseHeader("Expires")
                                            });
                                        } else {
                                            const rt = new Blob([
                                                Ll.response
                                            ], {
                                                type: Ll.getResponseHeader("Content-Type")
                                            });
                                            Co(new Yn(Ll.status, Ll.statusText, Qe.url, rt));
                                        }
                                    }
                                }, rt.signal.addEventListener("abort", ()=>{
                                    Ll.abort(), Co(Un());
                                }), Ll.send(Qe.body);
                            });
                        }(Qe, rt);
                    }, jd = {};
                    function Qn(Qe, rt, Wn) {
                        if (void 0 === Wn && (Wn = {}), jd[Qe]) throw new Error(`${Qe} is already registered.`);
                        Object.defineProperty(rt, "_classRegistryKey", {
                            value: Qe,
                            writeable: !1
                        }), jd[Qe] = {
                            klass: rt,
                            omit: Wn.omit || [],
                            shallow: Wn.shallow || []
                        };
                    }
                    Qn("Object", Object), Qn("TransferableGridIndex", z), Qn("Color", St), Qn("Error", Error), Qn("AJAXError", Yn), Qn("ResolvedImage", Tt), Qn("StylePropertyFunction", Qr), Qn("StyleExpression", Xr, {
                        omit: [
                            "_evaluator"
                        ]
                    }), Qn("ZoomDependentExpression", Kr), Qn("ZoomConstantExpression", Jr), Qn("CompoundExpression", kr, {
                        omit: [
                            "_evaluate"
                        ]
                    });
                    for(const uf in Pd)Pd[uf]._classRegistryKey || Qn(`Expression_${uf}`, Pd[uf]);
                    function ti(Qe) {
                        return Qe && "undefined" != typeof ArrayBuffer && (Qe instanceof ArrayBuffer || Qe.constructor && "ArrayBuffer" === Qe.constructor.name);
                    }
                    function ei(Qe) {
                        return Qe.$name || Qe.constructor._classRegistryKey;
                    }
                    function ri(Qe) {
                        return !function(Qe) {
                            if (null === Qe || "object" != typeof Qe) return !1;
                            const rt = ei(Qe);
                            return !(!rt || "Object" === rt);
                        }(Qe) && (null == Qe || "boolean" == typeof Qe || "number" == typeof Qe || "string" == typeof Qe || Qe instanceof Boolean || Qe instanceof Number || Qe instanceof String || Qe instanceof Date || Qe instanceof RegExp || Qe instanceof Blob || Qe instanceof Error || ti(Qe) || k(Qe) || ArrayBuffer.isView(Qe) || Qe instanceof ImageData);
                    }
                    function ni(Qe, rt) {
                        if (ri(Qe)) return (ti(Qe) || k(Qe)) && rt && rt.push(Qe), ArrayBuffer.isView(Qe) && rt && rt.push(Qe.buffer), Qe instanceof ImageData && rt && rt.push(Qe.data.buffer), Qe;
                        if (Array.isArray(Qe)) {
                            const Wn = [];
                            for (const Co of Qe)Wn.push(ni(Co, rt));
                            return Wn;
                        }
                        if ("object" != typeof Qe) throw new Error("can't serialize object of type " + typeof Qe);
                        const Wn = ei(Qe);
                        if (!Wn) throw new Error(`can't serialize object of unregistered class ${Qe.constructor.name}`);
                        if (!jd[Wn]) throw new Error(`${Wn} is not registered.`);
                        const { klass: Co } = jd[Wn], Dl = Co.serialize ? Co.serialize(Qe, rt) : {};
                        if (Co.serialize) {
                            if (rt && Dl === rt[rt.length - 1]) throw new Error("statically serialized object won't survive transfer of $name property");
                        } else {
                            for(const Co in Qe){
                                if (!Qe.hasOwnProperty(Co)) continue;
                                if (jd[Wn].omit.indexOf(Co) >= 0) continue;
                                const Ll = Qe[Co];
                                Dl[Co] = jd[Wn].shallow.indexOf(Co) >= 0 ? Ll : ni(Ll, rt);
                            }
                            Qe instanceof Error && (Dl.message = Qe.message);
                        }
                        if (Dl.$name) throw new Error("$name property is reserved for worker serialization logic.");
                        return "Object" !== Wn && (Dl.$name = Wn), Dl;
                    }
                    function ii(Qe) {
                        if (ri(Qe)) return Qe;
                        if (Array.isArray(Qe)) return Qe.map(ii);
                        if ("object" != typeof Qe) throw new Error("can't deserialize object of type " + typeof Qe);
                        const rt = ei(Qe) || "Object";
                        if (!jd[rt]) throw new Error(`can't deserialize unregistered class ${rt}`);
                        const { klass: Wn } = jd[rt];
                        if (!Wn) throw new Error(`can't deserialize unregistered class ${rt}`);
                        if (Wn.deserialize) return Wn.deserialize(Qe);
                        const Co = Object.create(Wn.prototype);
                        for (const Dl of Object.keys(Qe)){
                            if ("$name" === Dl) continue;
                            const Wn = Qe[Dl];
                            Co[Dl] = jd[rt].shallow.indexOf(Dl) >= 0 ? Wn : ii(Wn);
                        }
                        return Co;
                    }
                    class si {
                        constructor(Qe){
                            this._methodToThrottle = Qe, this._triggered = !1, "undefined" != typeof MessageChannel && (this._channel = new MessageChannel, this._channel.port2.onmessage = ()=>{
                                this._triggered = !1, this._methodToThrottle();
                            });
                        }
                        trigger() {
                            this._triggered || (this._triggered = !0, this._channel ? this._channel.port1.postMessage(!0) : setTimeout(()=>{
                                this._triggered = !1, this._methodToThrottle();
                            }, 0));
                        }
                        remove() {
                            delete this._channel, this._methodToThrottle = ()=>{};
                        }
                    }
                    const Ud = {
                        once: !0
                    };
                    class ai {
                        constructor(Qe, rt){
                            this.target = Qe, this.mapId = rt, this.resolveRejects = {}, this.tasks = {}, this.taskQueue = [], this.abortControllers = {}, this.messageHandlers = {}, this.invoker = new si(()=>this.process()), this.subscription = M(this.target, "message", (Qe)=>this.receive(Qe), !1), this.globalScope = S(self) ? Qe : window;
                        }
                        registerMessageHandler(Qe, rt) {
                            this.messageHandlers[Qe] = rt;
                        }
                        sendAsync(Qe, rt) {
                            return new Promise((Wn, Co)=>{
                                const Dl = Math.round(1e18 * Math.random()).toString(36).substring(0, 10), Ll = rt ? M(rt.signal, "abort", ()=>{
                                    null == Ll || Ll.unsubscribe(), delete this.resolveRejects[Dl];
                                    const rt = {
                                        id: Dl,
                                        type: "<cancel>",
                                        origin: location.origin,
                                        targetMapId: Qe.targetMapId,
                                        sourceMapId: this.mapId
                                    };
                                    this.target.postMessage(rt);
                                }, Ud) : null;
                                this.resolveRejects[Dl] = {
                                    resolve: (Qe)=>{
                                        null == Ll || Ll.unsubscribe(), Wn(Qe);
                                    },
                                    reject: (Qe)=>{
                                        null == Ll || Ll.unsubscribe(), Co(Qe);
                                    }
                                };
                                const Rl = [], Ul = Object.assign(Object.assign({}, Qe), {
                                    id: Dl,
                                    sourceMapId: this.mapId,
                                    origin: location.origin,
                                    data: ni(Qe.data, Rl)
                                });
                                this.target.postMessage(Ul, {
                                    transfer: Rl
                                });
                            });
                        }
                        receive(Qe) {
                            const rt = Qe.data, Wn = rt.id;
                            if (!("file://" !== rt.origin && "file://" !== location.origin && "resource://android" !== rt.origin && "resource://android" !== location.origin && rt.origin !== location.origin || rt.targetMapId && this.mapId !== rt.targetMapId)) {
                                if ("<cancel>" === rt.type) {
                                    delete this.tasks[Wn];
                                    const Qe = this.abortControllers[Wn];
                                    return delete this.abortControllers[Wn], void (Qe && Qe.abort());
                                }
                                if (S(self) || rt.mustQueue) return this.tasks[Wn] = rt, this.taskQueue.push(Wn), void this.invoker.trigger();
                                this.processTask(Wn, rt);
                            }
                        }
                        process() {
                            if (0 === this.taskQueue.length) return;
                            const Qe = this.taskQueue.shift(), rt = this.tasks[Qe];
                            delete this.tasks[Qe], this.taskQueue.length > 0 && this.invoker.trigger(), rt && this.processTask(Qe, rt);
                        }
                        processTask(Qe, rt) {
                            return t(this, void 0, void 0, function*() {
                                if ("<response>" === rt.type) {
                                    const Wn = this.resolveRejects[Qe];
                                    if (delete this.resolveRejects[Qe], !Wn) return;
                                    return void (rt.error ? Wn.reject(ii(rt.error)) : Wn.resolve(ii(rt.data)));
                                }
                                if (!this.messageHandlers[rt.type]) return void this.completeTask(Qe, new Error(`Could not find a registered handler for ${rt.type}, map ID: ${this.mapId}, available handlers: ${Object.keys(this.messageHandlers).join(", ")}`));
                                const Wn = ii(rt.data), Co = new AbortController;
                                this.abortControllers[Qe] = Co;
                                try {
                                    const Dl = yield this.messageHandlers[rt.type](rt.sourceMapId, Wn, Co);
                                    this.completeTask(Qe, null, Dl);
                                } catch (Wn) {
                                    this.completeTask(Qe, Wn);
                                }
                            });
                        }
                        completeTask(Qe, rt, Wn) {
                            const Co = [];
                            delete this.abortControllers[Qe];
                            const Dl = {
                                id: Qe,
                                type: "<response>",
                                sourceMapId: this.mapId,
                                origin: location.origin,
                                error: rt ? ni(rt) : null,
                                data: ni(Wn, Co)
                            };
                            this.target.postMessage(Dl, {
                                transfer: Co
                            });
                        }
                        remove() {
                            this.invoker.remove(), this.subscription.unsubscribe();
                        }
                    }
                    function li(Qe, rt, Wn) {
                        Wn[Qe] && -1 !== Wn[Qe].indexOf(rt) || (Wn[Qe] = Wn[Qe] || [], Wn[Qe].push(rt));
                    }
                    function ui(Qe, rt, Wn) {
                        if (Wn && Wn[Qe]) {
                            const Co = Wn[Qe].indexOf(rt);
                            -1 !== Co && Wn[Qe].splice(Co, 1);
                        }
                    }
                    class ci {
                        constructor(Qe, rt){
                            void 0 === rt && (rt = {}), g(this, rt), this.type = Qe;
                        }
                    }
                    class hi extends ci {
                        constructor(Qe, rt){
                            void 0 === rt && (rt = {}), super("error", g({
                                error: Qe
                            }, rt));
                        }
                    }
                    class pi {
                        on(Qe, rt) {
                            return this._listeners = this._listeners || {}, li(Qe, rt, this._listeners), {
                                unsubscribe: ()=>{
                                    this.off(Qe, rt);
                                }
                            };
                        }
                        off(Qe, rt) {
                            return ui(Qe, rt, this._listeners), ui(Qe, rt, this._oneTimeListeners), this;
                        }
                        once(Qe, rt) {
                            return rt ? (this._oneTimeListeners = this._oneTimeListeners || {}, li(Qe, rt, this._oneTimeListeners), this) : new Promise((rt)=>this.once(Qe, rt));
                        }
                        fire(Qe, rt) {
                            "string" == typeof Qe && (Qe = new ci(Qe, rt || {}));
                            const Wn = Qe.type;
                            if (this.listens(Wn)) {
                                Qe.target = this;
                                const rt = this._listeners && this._listeners[Wn] ? this._listeners[Wn].slice() : [];
                                for (const Wn of rt)Wn.call(this, Qe);
                                const Co = this._oneTimeListeners && this._oneTimeListeners[Wn] ? this._oneTimeListeners[Wn].slice() : [];
                                for (const Ll of Co)ui(Wn, Ll, this._oneTimeListeners), Ll.call(this, Qe);
                                const Dl = this._eventedParent;
                                Dl && (g(Qe, "function" == typeof this._eventedParentData ? this._eventedParentData() : this._eventedParentData), Dl.fire(Qe));
                            } else Qe instanceof hi && console.error(Qe.error);
                            return this;
                        }
                        listens(Qe) {
                            return this._listeners && this._listeners[Qe] && this._listeners[Qe].length > 0 || this._oneTimeListeners && this._oneTimeListeners[Qe] && this._oneTimeListeners[Qe].length > 0 || this._eventedParent && this._eventedParent.listens(Qe);
                        }
                        setEventedParent(Qe, rt) {
                            return this._eventedParent = Qe, this._eventedParentData = rt, this;
                        }
                    }
                    const Vd = On, Gd = Vd.paintProperty, Zd = Vd.layoutProperty;
                    class mi {
                        constructor(){
                            this.first = !0;
                        }
                        update(Qe, rt) {
                            const Wn = Math.floor(Qe);
                            return this.first ? (this.first = !1, this.lastIntegerZoom = Wn, this.lastIntegerZoomTime = 0, this.lastZoom = Qe, this.lastFloorZoom = Wn, !0) : (this.lastFloorZoom > Wn ? (this.lastIntegerZoom = Wn + 1, this.lastIntegerZoomTime = rt) : this.lastFloorZoom < Wn && (this.lastIntegerZoom = Wn, this.lastIntegerZoomTime = rt), Qe !== this.lastZoom && (this.lastZoom = Qe, this.lastFloorZoom = Wn, !0));
                        }
                    }
                    const gi_Latin_1_Supplement = (Qe)=>Qe >= 128 && Qe <= 255, gi_Khmer = (Qe)=>Qe >= 6016 && Qe <= 6143, gi_General_Punctuation = (Qe)=>Qe >= 8192 && Qe <= 8303, gi_Letterlike_Symbols = (Qe)=>Qe >= 8448 && Qe <= 8527, gi_Number_Forms = (Qe)=>Qe >= 8528 && Qe <= 8591, gi_Miscellaneous_Technical = (Qe)=>Qe >= 8960 && Qe <= 9215, gi_Control_Pictures = (Qe)=>Qe >= 9216 && Qe <= 9279, gi_Optical_Character_Recognition = (Qe)=>Qe >= 9280 && Qe <= 9311, gi_Enclosed_Alphanumerics = (Qe)=>Qe >= 9312 && Qe <= 9471, gi_Geometric_Shapes = (Qe)=>Qe >= 9632 && Qe <= 9727, gi_Miscellaneous_Symbols = (Qe)=>Qe >= 9728 && Qe <= 9983, gi_Miscellaneous_Symbols_and_Arrows = (Qe)=>Qe >= 11008 && Qe <= 11263, gi_Ideographic_Description_Characters = (Qe)=>Qe >= 12272 && Qe <= 12287, gi_CJK_Symbols_and_Punctuation = (Qe)=>Qe >= 12288 && Qe <= 12351, gi_Katakana = (Qe)=>Qe >= 12448 && Qe <= 12543, gi_Kanbun = (Qe)=>Qe >= 12688 && Qe <= 12703, gi_CJK_Strokes = (Qe)=>Qe >= 12736 && Qe <= 12783, gi_Enclosed_CJK_Letters_and_Months = (Qe)=>Qe >= 12800 && Qe <= 13055, gi_CJK_Compatibility = (Qe)=>Qe >= 13056 && Qe <= 13311, gi_Yijing_Hexagram_Symbols = (Qe)=>Qe >= 19904 && Qe <= 19967, gi_Private_Use_Area = (Qe)=>Qe >= 57344 && Qe <= 63743, gi_Vertical_Forms = (Qe)=>Qe >= 65040 && Qe <= 65055, gi_CJK_Compatibility_Forms = (Qe)=>Qe >= 65072 && Qe <= 65103, gi_Small_Form_Variants = (Qe)=>Qe >= 65104 && Qe <= 65135, gi_Halfwidth_and_Fullwidth_Forms = (Qe)=>Qe >= 65280 && Qe <= 65519;
                    function xi(Qe) {
                        for (const rt of Qe)if (ki(rt.charCodeAt(0))) return !0;
                        return !1;
                    }
                    function vi(Qe) {
                        for (const rt of Qe)if (!_i(rt.charCodeAt(0))) return !1;
                        return !0;
                    }
                    function bi(Qe) {
                        const rt = Qe.map((Qe)=>{
                            try {
                                return new RegExp(`\\p{sc=${Qe}}`, "u").source;
                            } catch (Qe) {
                                return null;
                            }
                        }).filter((Qe)=>Qe);
                        return new RegExp(rt.join("|"), "u");
                    }
                    const Hd = bi([
                        "Arab",
                        "Dupl",
                        "Mong",
                        "Ougr",
                        "Syrc"
                    ]);
                    function _i(Qe) {
                        return !Hd.test(String.fromCodePoint(Qe));
                    }
                    const Wd = bi([
                        "Bopo",
                        "Hani",
                        "Hira",
                        "Kana",
                        "Kits",
                        "Nshu",
                        "Tang",
                        "Yiii"
                    ]);
                    function ki(Qe) {
                        return !(746 !== Qe && 747 !== Qe && (Qe < 4352 || !(gi_CJK_Compatibility_Forms(Qe) && !(Qe >= 65097 && Qe <= 65103) || gi_CJK_Compatibility(Qe) || gi_CJK_Strokes(Qe) || !(!gi_CJK_Symbols_and_Punctuation(Qe) || Qe >= 12296 && Qe <= 12305 || Qe >= 12308 && Qe <= 12319 || 12336 === Qe) || gi_Enclosed_CJK_Letters_and_Months(Qe) || gi_Ideographic_Description_Characters(Qe) || gi_Kanbun(Qe) || gi_Katakana(Qe) && 12540 !== Qe || !(!gi_Halfwidth_and_Fullwidth_Forms(Qe) || 65288 === Qe || 65289 === Qe || 65293 === Qe || Qe >= 65306 && Qe <= 65310 || 65339 === Qe || 65341 === Qe || 65343 === Qe || Qe >= 65371 && Qe <= 65503 || 65507 === Qe || Qe >= 65512 && Qe <= 65519) || !(!gi_Small_Form_Variants(Qe) || Qe >= 65112 && Qe <= 65118 || Qe >= 65123 && Qe <= 65126) || gi_Vertical_Forms(Qe) || gi_Yijing_Hexagram_Symbols(Qe) || /\p{sc=Cans}/u.test(String.fromCodePoint(Qe)) || /\p{sc=Hang}/u.test(String.fromCodePoint(Qe)) || Wd.test(String.fromCodePoint(Qe)))));
                    }
                    function Ai(Qe) {
                        return !(ki(Qe) || function(Qe) {
                            return !!(gi_Latin_1_Supplement(Qe) && (167 === Qe || 169 === Qe || 174 === Qe || 177 === Qe || 188 === Qe || 189 === Qe || 190 === Qe || 215 === Qe || 247 === Qe) || gi_General_Punctuation(Qe) && (8214 === Qe || 8224 === Qe || 8225 === Qe || 8240 === Qe || 8241 === Qe || 8251 === Qe || 8252 === Qe || 8258 === Qe || 8263 === Qe || 8264 === Qe || 8265 === Qe || 8273 === Qe) || gi_Letterlike_Symbols(Qe) || gi_Number_Forms(Qe) || gi_Miscellaneous_Technical(Qe) && (Qe >= 8960 && Qe <= 8967 || Qe >= 8972 && Qe <= 8991 || Qe >= 8996 && Qe <= 9e3 || 9003 === Qe || Qe >= 9085 && Qe <= 9114 || Qe >= 9150 && Qe <= 9165 || 9167 === Qe || Qe >= 9169 && Qe <= 9179 || Qe >= 9186 && Qe <= 9215) || gi_Control_Pictures(Qe) && 9251 !== Qe || gi_Optical_Character_Recognition(Qe) || gi_Enclosed_Alphanumerics(Qe) || gi_Geometric_Shapes(Qe) || gi_Miscellaneous_Symbols(Qe) && !(Qe >= 9754 && Qe <= 9759) || gi_Miscellaneous_Symbols_and_Arrows(Qe) && (Qe >= 11026 && Qe <= 11055 || Qe >= 11088 && Qe <= 11097 || Qe >= 11192 && Qe <= 11243) || gi_CJK_Symbols_and_Punctuation(Qe) || gi_Katakana(Qe) || gi_Private_Use_Area(Qe) || gi_CJK_Compatibility_Forms(Qe) || gi_Small_Form_Variants(Qe) || gi_Halfwidth_and_Fullwidth_Forms(Qe) || 8734 === Qe || 8756 === Qe || 8757 === Qe || Qe >= 9984 && Qe <= 10087 || Qe >= 10102 && Qe <= 10131 || 65532 === Qe || 65533 === Qe);
                        }(Qe));
                    }
                    const qd = bi([
                        "Adlm",
                        "Arab",
                        "Armi",
                        "Avst",
                        "Chrs",
                        "Cprt",
                        "Egyp",
                        "Elym",
                        "Gara",
                        "Hatr",
                        "Hebr",
                        "Hung",
                        "Khar",
                        "Lydi",
                        "Mand",
                        "Mani",
                        "Mend",
                        "Merc",
                        "Mero",
                        "Narb",
                        "Nbat",
                        "Nkoo",
                        "Orkh",
                        "Palm",
                        "Phli",
                        "Phlp",
                        "Phnx",
                        "Prti",
                        "Rohg",
                        "Samr",
                        "Sarb",
                        "Sogo",
                        "Syrc",
                        "Thaa",
                        "Todr",
                        "Yezi"
                    ]);
                    function Mi(Qe) {
                        return qd.test(String.fromCodePoint(Qe));
                    }
                    function zi(Qe, rt) {
                        return !(!rt && Mi(Qe) || Qe >= 2304 && Qe <= 3583 || Qe >= 3840 && Qe <= 4255 || gi_Khmer(Qe));
                    }
                    function Pi(Qe) {
                        for (const rt of Qe)if (Mi(rt.charCodeAt(0))) return !0;
                        return !1;
                    }
                    const Yd = new class {
                        constructor(){
                            this.TIMEOUT = 5e3, this.applyArabicShaping = null, this.processBidirectionalText = null, this.processStyledBidirectionalText = null, this.pluginStatus = "unavailable", this.pluginURL = null, this.loadScriptResolve = ()=>{};
                        }
                        setState(Qe) {
                            this.pluginStatus = Qe.pluginStatus, this.pluginURL = Qe.pluginURL;
                        }
                        getState() {
                            return {
                                pluginStatus: this.pluginStatus,
                                pluginURL: this.pluginURL
                            };
                        }
                        setMethods(Qe) {
                            if (Yd.isParsed()) throw new Error("RTL text plugin already registered.");
                            this.applyArabicShaping = Qe.applyArabicShaping, this.processBidirectionalText = Qe.processBidirectionalText, this.processStyledBidirectionalText = Qe.processStyledBidirectionalText, this.loadScriptResolve();
                        }
                        isParsed() {
                            return null != this.applyArabicShaping && null != this.processBidirectionalText && null != this.processStyledBidirectionalText;
                        }
                        getRTLTextPluginStatus() {
                            return this.pluginStatus;
                        }
                        syncState(Qe, rt) {
                            return t(this, void 0, void 0, function*() {
                                if (this.isParsed()) return this.getState();
                                if ("loading" !== Qe.pluginStatus) return this.setState(Qe), Qe;
                                const Wn = Qe.pluginURL, Co = new Promise((Qe)=>{
                                    this.loadScriptResolve = Qe;
                                });
                                rt(Wn);
                                const Dl = new Promise((Qe)=>setTimeout(()=>Qe(), this.TIMEOUT));
                                if (yield Promise.race([
                                    Co,
                                    Dl
                                ]), this.isParsed()) {
                                    const Qe = {
                                        pluginStatus: "loaded",
                                        pluginURL: Wn
                                    };
                                    return this.setState(Qe), Qe;
                                }
                                throw this.setState({
                                    pluginStatus: "error",
                                    pluginURL: ""
                                }), new Error(`RTL Text Plugin failed to import scripts from ${Wn}`);
                            });
                        }
                    };
                    class Bi {
                        constructor(Qe, rt){
                            this.zoom = Qe, rt ? (this.now = rt.now, this.fadeDuration = rt.fadeDuration, this.zoomHistory = rt.zoomHistory, this.transition = rt.transition) : (this.now = 0, this.fadeDuration = 0, this.zoomHistory = new mi, this.transition = {});
                        }
                        isSupportedScript(Qe) {
                            return function(Qe, rt) {
                                for (const Wn of Qe)if (!zi(Wn.charCodeAt(0), rt)) return !1;
                                return !0;
                            }(Qe, "loaded" === Yd.getRTLTextPluginStatus());
                        }
                        crossFadingFactor() {
                            return 0 === this.fadeDuration ? 1 : Math.min((this.now - this.zoomHistory.lastIntegerZoomTime) / this.fadeDuration, 1);
                        }
                        getCrossfadeParameters() {
                            const Qe = this.zoom, rt = Qe - Math.floor(Qe), Wn = this.crossFadingFactor();
                            return Qe > this.zoomHistory.lastIntegerZoom ? {
                                fromScale: 2,
                                toScale: 1,
                                t: rt + (1 - rt) * Wn
                            } : {
                                fromScale: .5,
                                toScale: 1,
                                t: 1 - (1 - Wn) * rt
                            };
                        }
                    }
                    class Ti {
                        constructor(Qe, rt){
                            this.property = Qe, this.value = rt, this.expression = function(Qe, rt) {
                                if (Or(Qe)) return new Qr(Qe, rt);
                                if (Hr(Qe)) {
                                    const Wn = Wr(Qe, rt);
                                    if ("error" === Wn.result) throw new Error(Wn.value.map((Qe)=>`${Qe.key}: ${Qe.message}`).join(", "));
                                    return Wn.value;
                                }
                                {
                                    let Wn = Qe;
                                    return "color" === rt.type && "string" == typeof Qe ? Wn = St.parse(Qe) : "padding" !== rt.type || "number" != typeof Qe && !Array.isArray(Qe) ? "variableAnchorOffsetCollection" === rt.type && Array.isArray(Qe) ? Wn = Bt.parse(Qe) : "projectionDefinition" === rt.type && "string" == typeof Qe && (Wn = Vt.parse(Qe)) : Wn = zt.parse(Qe), {
                                        kind: "constant",
                                        evaluate: ()=>Wn
                                    };
                                }
                            }(void 0 === rt ? Qe.specification.default : rt, Qe.specification);
                        }
                        isDataDriven() {
                            return "source" === this.expression.kind || "composite" === this.expression.kind;
                        }
                        possiblyEvaluate(Qe, rt, Wn) {
                            return this.property.possiblyEvaluate(this, Qe, rt, Wn);
                        }
                    }
                    class Vi {
                        constructor(Qe){
                            this.property = Qe, this.value = new Ti(Qe, void 0);
                        }
                        transitioned(Qe, rt) {
                            return new Fi(this.property, this.value, rt, g({}, Qe.transition, this.transition), Qe.now);
                        }
                        untransitioned() {
                            return new Fi(this.property, this.value, null, {}, 0);
                        }
                    }
                    class Ei {
                        constructor(Qe){
                            this._properties = Qe, this._values = Object.create(Qe.defaultTransitionablePropertyValues);
                        }
                        getValue(Qe) {
                            return v(this._values[Qe].value.value);
                        }
                        setValue(Qe, rt) {
                            Object.prototype.hasOwnProperty.call(this._values, Qe) || (this._values[Qe] = new Vi(this._values[Qe].property)), this._values[Qe].value = new Ti(this._values[Qe].property, null === rt ? void 0 : v(rt));
                        }
                        getTransition(Qe) {
                            return v(this._values[Qe].transition);
                        }
                        setTransition(Qe, rt) {
                            Object.prototype.hasOwnProperty.call(this._values, Qe) || (this._values[Qe] = new Vi(this._values[Qe].property)), this._values[Qe].transition = v(rt) || void 0;
                        }
                        serialize() {
                            const Qe = {};
                            for (const rt of Object.keys(this._values)){
                                const Wn = this.getValue(rt);
                                void 0 !== Wn && (Qe[rt] = Wn);
                                const Co = this.getTransition(rt);
                                void 0 !== Co && (Qe[`${rt}-transition`] = Co);
                            }
                            return Qe;
                        }
                        transitioned(Qe, rt) {
                            const Wn = new Di(this._properties);
                            for (const Co of Object.keys(this._values))Wn._values[Co] = this._values[Co].transitioned(Qe, rt._values[Co]);
                            return Wn;
                        }
                        untransitioned() {
                            const Qe = new Di(this._properties);
                            for (const rt of Object.keys(this._values))Qe._values[rt] = this._values[rt].untransitioned();
                            return Qe;
                        }
                    }
                    class Fi {
                        constructor(Qe, rt, Wn, Co, Dl){
                            this.property = Qe, this.value = rt, this.begin = Dl + Co.delay || 0, this.end = this.begin + Co.duration || 0, Qe.specification.transition && (Co.delay || Co.duration) && (this.prior = Wn);
                        }
                        possiblyEvaluate(Qe, rt, Wn) {
                            const Co = Qe.now || 0, Dl = this.value.possiblyEvaluate(Qe, rt, Wn), Ll = this.prior;
                            if (Ll) {
                                if (Co > this.end) return this.prior = null, Dl;
                                if (this.value.isDataDriven()) return this.prior = null, Dl;
                                if (Co < this.begin) return Ll.possiblyEvaluate(Qe, rt, Wn);
                                {
                                    const Rl = (Co - this.begin) / (this.end - this.begin);
                                    return this.property.interpolate(Ll.possiblyEvaluate(Qe, rt, Wn), Dl, function(Qe) {
                                        if (Qe <= 0) return 0;
                                        if (Qe >= 1) return 1;
                                        const rt = Qe * Qe, Wn = rt * Qe;
                                        return 4 * (Qe < .5 ? Wn : 3 * (Qe - rt) + Wn - .75);
                                    }(Rl));
                                }
                            }
                            return Dl;
                        }
                    }
                    class Di {
                        constructor(Qe){
                            this._properties = Qe, this._values = Object.create(Qe.defaultTransitioningPropertyValues);
                        }
                        possiblyEvaluate(Qe, rt, Wn) {
                            const Co = new Oi(this._properties);
                            for (const Dl of Object.keys(this._values))Co._values[Dl] = this._values[Dl].possiblyEvaluate(Qe, rt, Wn);
                            return Co;
                        }
                        hasTransition() {
                            for (const Qe of Object.keys(this._values))if (this._values[Qe].prior) return !0;
                            return !1;
                        }
                    }
                    class Li {
                        constructor(Qe){
                            this._properties = Qe, this._values = Object.create(Qe.defaultPropertyValues);
                        }
                        hasValue(Qe) {
                            return void 0 !== this._values[Qe].value;
                        }
                        getValue(Qe) {
                            return v(this._values[Qe].value);
                        }
                        setValue(Qe, rt) {
                            this._values[Qe] = new Ti(this._values[Qe].property, null === rt ? void 0 : v(rt));
                        }
                        serialize() {
                            const Qe = {};
                            for (const rt of Object.keys(this._values)){
                                const Wn = this.getValue(rt);
                                void 0 !== Wn && (Qe[rt] = Wn);
                            }
                            return Qe;
                        }
                        possiblyEvaluate(Qe, rt, Wn) {
                            const Co = new Oi(this._properties);
                            for (const Dl of Object.keys(this._values))Co._values[Dl] = this._values[Dl].possiblyEvaluate(Qe, rt, Wn);
                            return Co;
                        }
                    }
                    class $i {
                        constructor(Qe, rt, Wn){
                            this.property = Qe, this.value = rt, this.parameters = Wn;
                        }
                        isConstant() {
                            return "constant" === this.value.kind;
                        }
                        constantOr(Qe) {
                            return "constant" === this.value.kind ? this.value.value : Qe;
                        }
                        evaluate(Qe, rt, Wn, Co) {
                            return this.property.evaluate(this.value, this.parameters, Qe, rt, Wn, Co);
                        }
                    }
                    class Oi {
                        constructor(Qe){
                            this._properties = Qe, this._values = Object.create(Qe.defaultPossiblyEvaluatedValues);
                        }
                        get(Qe) {
                            return this._values[Qe];
                        }
                    }
                    class Ri {
                        constructor(Qe){
                            this.specification = Qe;
                        }
                        possiblyEvaluate(Qe, rt) {
                            if (Qe.isDataDriven()) throw new Error("Value should not be data driven");
                            return Qe.expression.evaluate(rt);
                        }
                        interpolate(Qe, rt, Wn) {
                            const Co = xd[this.specification.type];
                            return Co ? Co(Qe, rt, Wn) : Qe;
                        }
                    }
                    class Ni {
                        constructor(Qe, rt){
                            this.specification = Qe, this.overrides = rt;
                        }
                        possiblyEvaluate(Qe, rt, Wn, Co) {
                            return new $i(this, "constant" === Qe.expression.kind || "camera" === Qe.expression.kind ? {
                                kind: "constant",
                                value: Qe.expression.evaluate(rt, null, {}, Wn, Co)
                            } : Qe.expression, rt);
                        }
                        interpolate(Qe, rt, Wn) {
                            if ("constant" !== Qe.value.kind || "constant" !== rt.value.kind) return Qe;
                            if (void 0 === Qe.value.value || void 0 === rt.value.value) return new $i(this, {
                                kind: "constant",
                                value: void 0
                            }, Qe.parameters);
                            const Co = xd[this.specification.type];
                            if (Co) {
                                const Dl = Co(Qe.value.value, rt.value.value, Wn);
                                return new $i(this, {
                                    kind: "constant",
                                    value: Dl
                                }, Qe.parameters);
                            }
                            return Qe;
                        }
                        evaluate(Qe, rt, Wn, Co, Dl, Ll) {
                            return "constant" === Qe.kind ? Qe.value : Qe.evaluate(rt, Wn, Co, Dl, Ll);
                        }
                    }
                    class ji extends Ni {
                        possiblyEvaluate(Qe, rt, Wn, Co) {
                            if (void 0 === Qe.value) return new $i(this, {
                                kind: "constant",
                                value: void 0
                            }, rt);
                            if ("constant" === Qe.expression.kind) {
                                const Dl = Qe.expression.evaluate(rt, null, {}, Wn, Co), Ll = "resolvedImage" === Qe.property.specification.type && "string" != typeof Dl ? Dl.name : Dl, Rl = this._calculate(Ll, Ll, Ll, rt);
                                return new $i(this, {
                                    kind: "constant",
                                    value: Rl
                                }, rt);
                            }
                            if ("camera" === Qe.expression.kind) {
                                const Wn = this._calculate(Qe.expression.evaluate({
                                    zoom: rt.zoom - 1
                                }), Qe.expression.evaluate({
                                    zoom: rt.zoom
                                }), Qe.expression.evaluate({
                                    zoom: rt.zoom + 1
                                }), rt);
                                return new $i(this, {
                                    kind: "constant",
                                    value: Wn
                                }, rt);
                            }
                            return new $i(this, Qe.expression, rt);
                        }
                        evaluate(Qe, rt, Wn, Co, Dl, Ll) {
                            if ("source" === Qe.kind) {
                                const Rl = Qe.evaluate(rt, Wn, Co, Dl, Ll);
                                return this._calculate(Rl, Rl, Rl, rt);
                            }
                            return "composite" === Qe.kind ? this._calculate(Qe.evaluate({
                                zoom: Math.floor(rt.zoom) - 1
                            }, Wn, Co), Qe.evaluate({
                                zoom: Math.floor(rt.zoom)
                            }, Wn, Co), Qe.evaluate({
                                zoom: Math.floor(rt.zoom) + 1
                            }, Wn, Co), rt) : Qe.value;
                        }
                        _calculate(Qe, rt, Wn, Co) {
                            return Co.zoom > Co.zoomHistory.lastIntegerZoom ? {
                                from: Qe,
                                to: rt
                            } : {
                                from: Wn,
                                to: rt
                            };
                        }
                        interpolate(Qe) {
                            return Qe;
                        }
                    }
                    class qi {
                        constructor(Qe){
                            this.specification = Qe;
                        }
                        possiblyEvaluate(Qe, rt, Wn, Co) {
                            if (void 0 !== Qe.value) {
                                if ("constant" === Qe.expression.kind) {
                                    const Dl = Qe.expression.evaluate(rt, null, {}, Wn, Co);
                                    return this._calculate(Dl, Dl, Dl, rt);
                                }
                                return this._calculate(Qe.expression.evaluate(new Bi(Math.floor(rt.zoom - 1), rt)), Qe.expression.evaluate(new Bi(Math.floor(rt.zoom), rt)), Qe.expression.evaluate(new Bi(Math.floor(rt.zoom + 1), rt)), rt);
                            }
                        }
                        _calculate(Qe, rt, Wn, Co) {
                            return Co.zoom > Co.zoomHistory.lastIntegerZoom ? {
                                from: Qe,
                                to: rt
                            } : {
                                from: Wn,
                                to: rt
                            };
                        }
                        interpolate(Qe) {
                            return Qe;
                        }
                    }
                    class Ui {
                        constructor(Qe){
                            this.specification = Qe;
                        }
                        possiblyEvaluate(Qe, rt, Wn, Co) {
                            return !!Qe.expression.evaluate(rt, null, {}, Wn, Co);
                        }
                        interpolate() {
                            return !1;
                        }
                    }
                    class Gi {
                        constructor(Qe){
                            this.properties = Qe, this.defaultPropertyValues = {}, this.defaultTransitionablePropertyValues = {}, this.defaultTransitioningPropertyValues = {}, this.defaultPossiblyEvaluatedValues = {}, this.overridableProperties = [];
                            for(const rt in Qe){
                                const Wn = Qe[rt];
                                Wn.specification.overridable && this.overridableProperties.push(rt);
                                const Co = this.defaultPropertyValues[rt] = new Ti(Wn, void 0), Dl = this.defaultTransitionablePropertyValues[rt] = new Vi(Wn);
                                this.defaultTransitioningPropertyValues[rt] = Dl.untransitioned(), this.defaultPossiblyEvaluatedValues[rt] = Co.possiblyEvaluate({});
                            }
                        }
                    }
                    Qn("DataDrivenProperty", Ni), Qn("DataConstantProperty", Ri), Qn("CrossFadedDataDrivenProperty", ji), Qn("CrossFadedProperty", qi), Qn("ColorRampProperty", Ui);
                    const Qd = "-transition";
                    class Xi extends pi {
                        constructor(Qe, rt){
                            if (super(), this.id = Qe.id, this.type = Qe.type, this._featureFilter = {
                                filter: ()=>!0,
                                needGeometry: !1
                            }, "custom" !== Qe.type && (this.metadata = Qe.metadata, this.minzoom = Qe.minzoom, this.maxzoom = Qe.maxzoom, "background" !== Qe.type && (this.source = Qe.source, this.sourceLayer = Qe["source-layer"], this.filter = Qe.filter), rt.layout && (this._unevaluatedLayout = new Li(rt.layout)), rt.paint)) {
                                this._transitionablePaint = new Ei(rt.paint);
                                for(const rt in Qe.paint)this.setPaintProperty(rt, Qe.paint[rt], {
                                    validate: !1
                                });
                                for(const rt in Qe.layout)this.setLayoutProperty(rt, Qe.layout[rt], {
                                    validate: !1
                                });
                                this._transitioningPaint = this._transitionablePaint.untransitioned(), this.paint = new Oi(rt.paint);
                            }
                        }
                        getCrossfadeParameters() {
                            return this._crossfadeParameters;
                        }
                        getLayoutProperty(Qe) {
                            return "visibility" === Qe ? this.visibility : this._unevaluatedLayout.getValue(Qe);
                        }
                        setLayoutProperty(Qe, rt, Wn) {
                            void 0 === Wn && (Wn = {}), null != rt && this._validate(Zd, `layers.${this.id}.layout.${Qe}`, Qe, rt, Wn) || ("visibility" !== Qe ? this._unevaluatedLayout.setValue(Qe, rt) : this.visibility = rt);
                        }
                        getPaintProperty(Qe) {
                            return Qe.endsWith(Qd) ? this._transitionablePaint.getTransition(Qe.slice(0, -11)) : this._transitionablePaint.getValue(Qe);
                        }
                        setPaintProperty(Qe, rt, Wn) {
                            if (void 0 === Wn && (Wn = {}), null != rt && this._validate(Gd, `layers.${this.id}.paint.${Qe}`, Qe, rt, Wn)) return !1;
                            if (Qe.endsWith(Qd)) return this._transitionablePaint.setTransition(Qe.slice(0, -11), rt || void 0), !1;
                            {
                                const Wn = this._transitionablePaint._values[Qe], Co = "cross-faded-data-driven" === Wn.property.specification["property-type"], Dl = Wn.value.isDataDriven(), Ll = Wn.value;
                                this._transitionablePaint.setValue(Qe, rt), this._handleSpecialPaintPropertyUpdate(Qe);
                                const Rl = this._transitionablePaint._values[Qe].value;
                                return Rl.isDataDriven() || Dl || Co || this._handleOverridablePaintPropertyUpdate(Qe, Ll, Rl);
                            }
                        }
                        _handleSpecialPaintPropertyUpdate(Qe) {}
                        _handleOverridablePaintPropertyUpdate(Qe, rt, Wn) {
                            return !1;
                        }
                        isHidden(Qe) {
                            return !!(this.minzoom && Qe < this.minzoom) || !!(this.maxzoom && Qe >= this.maxzoom) || "none" === this.visibility;
                        }
                        updateTransitions(Qe) {
                            this._transitioningPaint = this._transitionablePaint.transitioned(Qe, this._transitioningPaint);
                        }
                        hasTransition() {
                            return this._transitioningPaint.hasTransition();
                        }
                        recalculate(Qe, rt) {
                            Qe.getCrossfadeParameters && (this._crossfadeParameters = Qe.getCrossfadeParameters()), this._unevaluatedLayout && (this.layout = this._unevaluatedLayout.possiblyEvaluate(Qe, void 0, rt)), this.paint = this._transitioningPaint.possiblyEvaluate(Qe, void 0, rt);
                        }
                        serialize() {
                            const Qe = {
                                id: this.id,
                                type: this.type,
                                source: this.source,
                                "source-layer": this.sourceLayer,
                                metadata: this.metadata,
                                minzoom: this.minzoom,
                                maxzoom: this.maxzoom,
                                filter: this.filter,
                                layout: this._unevaluatedLayout && this._unevaluatedLayout.serialize(),
                                paint: this._transitionablePaint && this._transitionablePaint.serialize()
                            };
                            return this.visibility && (Qe.layout = Qe.layout || {}, Qe.layout.visibility = this.visibility), function(Qe, rt) {
                                const Wn = {};
                                for(const Co in Qe)rt.call(this, Qe[Co], Co, Qe) && (Wn[Co] = Qe[Co]);
                                return Wn;
                            }(Qe, (Qe, rt)=>!(void 0 === Qe || "layout" === rt && !Object.keys(Qe).length || "paint" === rt && !Object.keys(Qe).length));
                        }
                        _validate(Qe, rt, Wn, Co, Dl) {
                            return void 0 === Dl && (Dl = {}), (!Dl || !1 !== Dl.validate) && function(Qe, rt) {
                                let Wn = !1;
                                if (rt && rt.length) for (const Co of rt)Qe.fire(new hi(new Error(Co.message))), Wn = !0;
                                return Wn;
                            }(this, Qe.call(Vd, {
                                key: rt,
                                layerType: this.type,
                                objectKey: Wn,
                                value: Co,
                                styleSpec: Tc,
                                style: {
                                    glyphs: !0,
                                    sprite: !0
                                }
                            }));
                        }
                        is3D() {
                            return !1;
                        }
                        isTileClipped() {
                            return !1;
                        }
                        hasOffscreenPass() {
                            return !1;
                        }
                        resize() {}
                        isStateDependent() {
                            for(const Qe in this.paint._values){
                                const rt = this.paint.get(Qe);
                                if (rt instanceof $i && Fr(rt.property.specification) && ("source" === rt.value.kind || "composite" === rt.value.kind) && rt.value.isStateDependent) return !0;
                            }
                            return !1;
                        }
                    }
                    const Kd = {
                        Int8: Int8Array,
                        Uint8: Uint8Array,
                        Int16: Int16Array,
                        Uint16: Uint16Array,
                        Int32: Int32Array,
                        Uint32: Uint32Array,
                        Float32: Float32Array
                    };
                    class Yi {
                        constructor(Qe, rt){
                            this._structArray = Qe, this._pos1 = rt * this.size, this._pos2 = this._pos1 / 2, this._pos4 = this._pos1 / 4, this._pos8 = this._pos1 / 8;
                        }
                    }
                    class Ji {
                        constructor(){
                            this.isTransferred = !1, this.capacity = -1, this.resize(0);
                        }
                        static serialize(Qe, rt) {
                            return Qe._trim(), rt && (Qe.isTransferred = !0, rt.push(Qe.arrayBuffer)), {
                                length: Qe.length,
                                arrayBuffer: Qe.arrayBuffer
                            };
                        }
                        static deserialize(Qe) {
                            const rt = Object.create(this.prototype);
                            return rt.arrayBuffer = Qe.arrayBuffer, rt.length = Qe.length, rt.capacity = Qe.arrayBuffer.byteLength / rt.bytesPerElement, rt._refreshViews(), rt;
                        }
                        _trim() {
                            this.length !== this.capacity && (this.capacity = this.length, this.arrayBuffer = this.arrayBuffer.slice(0, this.length * this.bytesPerElement), this._refreshViews());
                        }
                        clear() {
                            this.length = 0;
                        }
                        resize(Qe) {
                            this.reserve(Qe), this.length = Qe;
                        }
                        reserve(Qe) {
                            if (Qe > this.capacity) {
                                this.capacity = Math.max(Qe, Math.floor(5 * this.capacity), 128), this.arrayBuffer = new ArrayBuffer(this.capacity * this.bytesPerElement);
                                const rt = this.uint8;
                                this._refreshViews(), rt && this.uint8.set(rt);
                            }
                        }
                        _refreshViews() {
                            throw new Error("_refreshViews() must be implemented by each concrete StructArray layout");
                        }
                    }
                    function Ki(Qe, rt) {
                        void 0 === rt && (rt = 1);
                        let Wn = 0, Co = 0;
                        return {
                            members: Qe.map((Qe)=>{
                                const Dl = Kd[Qe.type].BYTES_PER_ELEMENT, Ll = Wn = Wi(Wn, Math.max(rt, Dl)), Rl = Qe.components || 1;
                                return Co = Math.max(Co, Dl), Wn += Dl * Rl, {
                                    name: Qe.name,
                                    type: Qe.type,
                                    components: Rl,
                                    offset: Ll
                                };
                            }),
                            size: Wi(Wn, Math.max(Co, rt)),
                            alignment: rt
                        };
                    }
                    function Wi(Qe, rt) {
                        return Math.ceil(Qe / rt) * rt;
                    }
                    class Qi extends Ji {
                        _refreshViews() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
                        }
                        emplaceBack(Qe, rt) {
                            const Wn = this.length;
                            return this.resize(Wn + 1), this.emplace(Wn, Qe, rt);
                        }
                        emplace(Qe, rt, Wn) {
                            const Co = 2 * Qe;
                            return this.int16[Co + 0] = rt, this.int16[Co + 1] = Wn, Qe;
                        }
                    }
                    Qi.prototype.bytesPerElement = 4, Qn("StructArrayLayout2i4", Qi);
                    class ts extends Ji {
                        _refreshViews() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
                        }
                        emplaceBack(Qe, rt, Wn) {
                            const Co = this.length;
                            return this.resize(Co + 1), this.emplace(Co, Qe, rt, Wn);
                        }
                        emplace(Qe, rt, Wn, Co) {
                            const Dl = 3 * Qe;
                            return this.int16[Dl + 0] = rt, this.int16[Dl + 1] = Wn, this.int16[Dl + 2] = Co, Qe;
                        }
                    }
                    ts.prototype.bytesPerElement = 6, Qn("StructArrayLayout3i6", ts);
                    class es extends Ji {
                        _refreshViews() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
                        }
                        emplaceBack(Qe, rt, Wn, Co) {
                            const Dl = this.length;
                            return this.resize(Dl + 1), this.emplace(Dl, Qe, rt, Wn, Co);
                        }
                        emplace(Qe, rt, Wn, Co, Dl) {
                            const Ll = 4 * Qe;
                            return this.int16[Ll + 0] = rt, this.int16[Ll + 1] = Wn, this.int16[Ll + 2] = Co, this.int16[Ll + 3] = Dl, Qe;
                        }
                    }
                    es.prototype.bytesPerElement = 8, Qn("StructArrayLayout4i8", es);
                    class rs extends Ji {
                        _refreshViews() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
                        }
                        emplaceBack(Qe, rt, Wn, Co, Dl, Ll) {
                            const Rl = this.length;
                            return this.resize(Rl + 1), this.emplace(Rl, Qe, rt, Wn, Co, Dl, Ll);
                        }
                        emplace(Qe, rt, Wn, Co, Dl, Ll, Rl) {
                            const Ul = 6 * Qe;
                            return this.int16[Ul + 0] = rt, this.int16[Ul + 1] = Wn, this.int16[Ul + 2] = Co, this.int16[Ul + 3] = Dl, this.int16[Ul + 4] = Ll, this.int16[Ul + 5] = Rl, Qe;
                        }
                    }
                    rs.prototype.bytesPerElement = 12, Qn("StructArrayLayout2i4i12", rs);
                    class ns extends Ji {
                        _refreshViews() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
                        }
                        emplaceBack(Qe, rt, Wn, Co, Dl, Ll) {
                            const Rl = this.length;
                            return this.resize(Rl + 1), this.emplace(Rl, Qe, rt, Wn, Co, Dl, Ll);
                        }
                        emplace(Qe, rt, Wn, Co, Dl, Ll, Rl) {
                            const Ul = 4 * Qe, Gl = 8 * Qe;
                            return this.int16[Ul + 0] = rt, this.int16[Ul + 1] = Wn, this.uint8[Gl + 4] = Co, this.uint8[Gl + 5] = Dl, this.uint8[Gl + 6] = Ll, this.uint8[Gl + 7] = Rl, Qe;
                        }
                    }
                    ns.prototype.bytesPerElement = 8, Qn("StructArrayLayout2i4ub8", ns);
                    class is extends Ji {
                        _refreshViews() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
                        }
                        emplaceBack(Qe, rt) {
                            const Wn = this.length;
                            return this.resize(Wn + 1), this.emplace(Wn, Qe, rt);
                        }
                        emplace(Qe, rt, Wn) {
                            const Co = 2 * Qe;
                            return this.float32[Co + 0] = rt, this.float32[Co + 1] = Wn, Qe;
                        }
                    }
                    is.prototype.bytesPerElement = 8, Qn("StructArrayLayout2f8", is);
                    class ss extends Ji {
                        _refreshViews() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
                        }
                        emplaceBack(Qe, rt, Wn, Co, Dl, Ll, Rl, Ul, Gl, Zl) {
                            const Hl = this.length;
                            return this.resize(Hl + 1), this.emplace(Hl, Qe, rt, Wn, Co, Dl, Ll, Rl, Ul, Gl, Zl);
                        }
                        emplace(Qe, rt, Wn, Co, Dl, Ll, Rl, Ul, Gl, Zl, Hl) {
                            const ql = 10 * Qe;
                            return this.uint16[ql + 0] = rt, this.uint16[ql + 1] = Wn, this.uint16[ql + 2] = Co, this.uint16[ql + 3] = Dl, this.uint16[ql + 4] = Ll, this.uint16[ql + 5] = Rl, this.uint16[ql + 6] = Ul, this.uint16[ql + 7] = Gl, this.uint16[ql + 8] = Zl, this.uint16[ql + 9] = Hl, Qe;
                        }
                    }
                    ss.prototype.bytesPerElement = 20, Qn("StructArrayLayout10ui20", ss);
                    class os extends Ji {
                        _refreshViews() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
                        }
                        emplaceBack(Qe, rt, Wn, Co, Dl, Ll, Rl, Ul, Gl, Zl, Hl, ql) {
                            const Ql = this.length;
                            return this.resize(Ql + 1), this.emplace(Ql, Qe, rt, Wn, Co, Dl, Ll, Rl, Ul, Gl, Zl, Hl, ql);
                        }
                        emplace(Qe, rt, Wn, Co, Dl, Ll, Rl, Ul, Gl, Zl, Hl, ql, Ql) {
                            const Kl = 12 * Qe;
                            return this.int16[Kl + 0] = rt, this.int16[Kl + 1] = Wn, this.int16[Kl + 2] = Co, this.int16[Kl + 3] = Dl, this.uint16[Kl + 4] = Ll, this.uint16[Kl + 5] = Rl, this.uint16[Kl + 6] = Ul, this.uint16[Kl + 7] = Gl, this.int16[Kl + 8] = Zl, this.int16[Kl + 9] = Hl, this.int16[Kl + 10] = ql, this.int16[Kl + 11] = Ql, Qe;
                        }
                    }
                    os.prototype.bytesPerElement = 24, Qn("StructArrayLayout4i4ui4i24", os);
                    class as extends Ji {
                        _refreshViews() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
                        }
                        emplaceBack(Qe, rt, Wn) {
                            const Co = this.length;
                            return this.resize(Co + 1), this.emplace(Co, Qe, rt, Wn);
                        }
                        emplace(Qe, rt, Wn, Co) {
                            const Dl = 3 * Qe;
                            return this.float32[Dl + 0] = rt, this.float32[Dl + 1] = Wn, this.float32[Dl + 2] = Co, Qe;
                        }
                    }
                    as.prototype.bytesPerElement = 12, Qn("StructArrayLayout3f12", as);
                    class ls extends Ji {
                        _refreshViews() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer);
                        }
                        emplaceBack(Qe) {
                            const rt = this.length;
                            return this.resize(rt + 1), this.emplace(rt, Qe);
                        }
                        emplace(Qe, rt) {
                            return this.uint32[1 * Qe + 0] = rt, Qe;
                        }
                    }
                    ls.prototype.bytesPerElement = 4, Qn("StructArrayLayout1ul4", ls);
                    class us extends Ji {
                        _refreshViews() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
                        }
                        emplaceBack(Qe, rt, Wn, Co, Dl, Ll, Rl, Ul, Gl) {
                            const Zl = this.length;
                            return this.resize(Zl + 1), this.emplace(Zl, Qe, rt, Wn, Co, Dl, Ll, Rl, Ul, Gl);
                        }
                        emplace(Qe, rt, Wn, Co, Dl, Ll, Rl, Ul, Gl, Zl) {
                            const Hl = 10 * Qe, ql = 5 * Qe;
                            return this.int16[Hl + 0] = rt, this.int16[Hl + 1] = Wn, this.int16[Hl + 2] = Co, this.int16[Hl + 3] = Dl, this.int16[Hl + 4] = Ll, this.int16[Hl + 5] = Rl, this.uint32[ql + 3] = Ul, this.uint16[Hl + 8] = Gl, this.uint16[Hl + 9] = Zl, Qe;
                        }
                    }
                    us.prototype.bytesPerElement = 20, Qn("StructArrayLayout6i1ul2ui20", us);
                    class cs extends Ji {
                        _refreshViews() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
                        }
                        emplaceBack(Qe, rt, Wn, Co, Dl, Ll) {
                            const Rl = this.length;
                            return this.resize(Rl + 1), this.emplace(Rl, Qe, rt, Wn, Co, Dl, Ll);
                        }
                        emplace(Qe, rt, Wn, Co, Dl, Ll, Rl) {
                            const Ul = 6 * Qe;
                            return this.int16[Ul + 0] = rt, this.int16[Ul + 1] = Wn, this.int16[Ul + 2] = Co, this.int16[Ul + 3] = Dl, this.int16[Ul + 4] = Ll, this.int16[Ul + 5] = Rl, Qe;
                        }
                    }
                    cs.prototype.bytesPerElement = 12, Qn("StructArrayLayout2i2i2i12", cs);
                    class hs extends Ji {
                        _refreshViews() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
                        }
                        emplaceBack(Qe, rt, Wn, Co, Dl) {
                            const Ll = this.length;
                            return this.resize(Ll + 1), this.emplace(Ll, Qe, rt, Wn, Co, Dl);
                        }
                        emplace(Qe, rt, Wn, Co, Dl, Ll) {
                            const Rl = 4 * Qe, Ul = 8 * Qe;
                            return this.float32[Rl + 0] = rt, this.float32[Rl + 1] = Wn, this.float32[Rl + 2] = Co, this.int16[Ul + 6] = Dl, this.int16[Ul + 7] = Ll, Qe;
                        }
                    }
                    hs.prototype.bytesPerElement = 16, Qn("StructArrayLayout2f1f2i16", hs);
                    class ps extends Ji {
                        _refreshViews() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
                        }
                        emplaceBack(Qe, rt, Wn, Co, Dl, Ll) {
                            const Rl = this.length;
                            return this.resize(Rl + 1), this.emplace(Rl, Qe, rt, Wn, Co, Dl, Ll);
                        }
                        emplace(Qe, rt, Wn, Co, Dl, Ll, Rl) {
                            const Ul = 16 * Qe, Gl = 4 * Qe, Zl = 8 * Qe;
                            return this.uint8[Ul + 0] = rt, this.uint8[Ul + 1] = Wn, this.float32[Gl + 1] = Co, this.float32[Gl + 2] = Dl, this.int16[Zl + 6] = Ll, this.int16[Zl + 7] = Rl, Qe;
                        }
                    }
                    ps.prototype.bytesPerElement = 16, Qn("StructArrayLayout2ub2f2i16", ps);
                    class fs extends Ji {
                        _refreshViews() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
                        }
                        emplaceBack(Qe, rt, Wn) {
                            const Co = this.length;
                            return this.resize(Co + 1), this.emplace(Co, Qe, rt, Wn);
                        }
                        emplace(Qe, rt, Wn, Co) {
                            const Dl = 3 * Qe;
                            return this.uint16[Dl + 0] = rt, this.uint16[Dl + 1] = Wn, this.uint16[Dl + 2] = Co, Qe;
                        }
                    }
                    fs.prototype.bytesPerElement = 6, Qn("StructArrayLayout3ui6", fs);
                    class ds extends Ji {
                        _refreshViews() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
                        }
                        emplaceBack(Qe, rt, Wn, Co, Dl, Ll, Rl, Ul, Gl, Zl, Hl, ql, Ql, Kl, $l, Tc, tu) {
                            const lu = this.length;
                            return this.resize(lu + 1), this.emplace(lu, Qe, rt, Wn, Co, Dl, Ll, Rl, Ul, Gl, Zl, Hl, ql, Ql, Kl, $l, Tc, tu);
                        }
                        emplace(Qe, rt, Wn, Co, Dl, Ll, Rl, Ul, Gl, Zl, Hl, ql, Ql, Kl, $l, Tc, tu, lu) {
                            const du = 24 * Qe, fu = 12 * Qe, yu = 48 * Qe;
                            return this.int16[du + 0] = rt, this.int16[du + 1] = Wn, this.uint16[du + 2] = Co, this.uint16[du + 3] = Dl, this.uint32[fu + 2] = Ll, this.uint32[fu + 3] = Rl, this.uint32[fu + 4] = Ul, this.uint16[du + 10] = Gl, this.uint16[du + 11] = Zl, this.uint16[du + 12] = Hl, this.float32[fu + 7] = ql, this.float32[fu + 8] = Ql, this.uint8[yu + 36] = Kl, this.uint8[yu + 37] = $l, this.uint8[yu + 38] = Tc, this.uint32[fu + 10] = tu, this.int16[du + 22] = lu, Qe;
                        }
                    }
                    ds.prototype.bytesPerElement = 48, Qn("StructArrayLayout2i2ui3ul3ui2f3ub1ul1i48", ds);
                    class ys extends Ji {
                        _refreshViews() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
                        }
                        emplaceBack(Qe, rt, Wn, Co, Dl, Ll, Rl, Ul, Gl, Zl, Hl, ql, Ql, Kl, $l, Tc, tu, lu, du, fu, yu, Eu, Tu, Lu, Zu, Xu, Ju, $u) {
                            const ed = this.length;
                            return this.resize(ed + 1), this.emplace(ed, Qe, rt, Wn, Co, Dl, Ll, Rl, Ul, Gl, Zl, Hl, ql, Ql, Kl, $l, Tc, tu, lu, du, fu, yu, Eu, Tu, Lu, Zu, Xu, Ju, $u);
                        }
                        emplace(Qe, rt, Wn, Co, Dl, Ll, Rl, Ul, Gl, Zl, Hl, ql, Ql, Kl, $l, Tc, tu, lu, du, fu, yu, Eu, Tu, Lu, Zu, Xu, Ju, $u, ed) {
                            const td = 32 * Qe, id = 16 * Qe;
                            return this.int16[td + 0] = rt, this.int16[td + 1] = Wn, this.int16[td + 2] = Co, this.int16[td + 3] = Dl, this.int16[td + 4] = Ll, this.int16[td + 5] = Rl, this.int16[td + 6] = Ul, this.int16[td + 7] = Gl, this.uint16[td + 8] = Zl, this.uint16[td + 9] = Hl, this.uint16[td + 10] = ql, this.uint16[td + 11] = Ql, this.uint16[td + 12] = Kl, this.uint16[td + 13] = $l, this.uint16[td + 14] = Tc, this.uint16[td + 15] = tu, this.uint16[td + 16] = lu, this.uint16[td + 17] = du, this.uint16[td + 18] = fu, this.uint16[td + 19] = yu, this.uint16[td + 20] = Eu, this.uint16[td + 21] = Tu, this.uint16[td + 22] = Lu, this.uint32[id + 12] = Zu, this.float32[id + 13] = Xu, this.float32[id + 14] = Ju, this.uint16[td + 30] = $u, this.uint16[td + 31] = ed, Qe;
                        }
                    }
                    ys.prototype.bytesPerElement = 64, Qn("StructArrayLayout8i15ui1ul2f2ui64", ys);
                    class ms extends Ji {
                        _refreshViews() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
                        }
                        emplaceBack(Qe) {
                            const rt = this.length;
                            return this.resize(rt + 1), this.emplace(rt, Qe);
                        }
                        emplace(Qe, rt) {
                            return this.float32[1 * Qe + 0] = rt, Qe;
                        }
                    }
                    ms.prototype.bytesPerElement = 4, Qn("StructArrayLayout1f4", ms);
                    class gs extends Ji {
                        _refreshViews() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
                        }
                        emplaceBack(Qe, rt, Wn) {
                            const Co = this.length;
                            return this.resize(Co + 1), this.emplace(Co, Qe, rt, Wn);
                        }
                        emplace(Qe, rt, Wn, Co) {
                            const Dl = 3 * Qe;
                            return this.uint16[6 * Qe + 0] = rt, this.float32[Dl + 1] = Wn, this.float32[Dl + 2] = Co, Qe;
                        }
                    }
                    gs.prototype.bytesPerElement = 12, Qn("StructArrayLayout1ui2f12", gs);
                    class xs extends Ji {
                        _refreshViews() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
                        }
                        emplaceBack(Qe, rt, Wn) {
                            const Co = this.length;
                            return this.resize(Co + 1), this.emplace(Co, Qe, rt, Wn);
                        }
                        emplace(Qe, rt, Wn, Co) {
                            const Dl = 4 * Qe;
                            return this.uint32[2 * Qe + 0] = rt, this.uint16[Dl + 2] = Wn, this.uint16[Dl + 3] = Co, Qe;
                        }
                    }
                    xs.prototype.bytesPerElement = 8, Qn("StructArrayLayout1ul2ui8", xs);
                    class vs extends Ji {
                        _refreshViews() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
                        }
                        emplaceBack(Qe, rt) {
                            const Wn = this.length;
                            return this.resize(Wn + 1), this.emplace(Wn, Qe, rt);
                        }
                        emplace(Qe, rt, Wn) {
                            const Co = 2 * Qe;
                            return this.uint16[Co + 0] = rt, this.uint16[Co + 1] = Wn, Qe;
                        }
                    }
                    vs.prototype.bytesPerElement = 4, Qn("StructArrayLayout2ui4", vs);
                    class bs extends Ji {
                        _refreshViews() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
                        }
                        emplaceBack(Qe) {
                            const rt = this.length;
                            return this.resize(rt + 1), this.emplace(rt, Qe);
                        }
                        emplace(Qe, rt) {
                            return this.uint16[1 * Qe + 0] = rt, Qe;
                        }
                    }
                    bs.prototype.bytesPerElement = 2, Qn("StructArrayLayout1ui2", bs);
                    class ws extends Ji {
                        _refreshViews() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
                        }
                        emplaceBack(Qe, rt, Wn, Co) {
                            const Dl = this.length;
                            return this.resize(Dl + 1), this.emplace(Dl, Qe, rt, Wn, Co);
                        }
                        emplace(Qe, rt, Wn, Co, Dl) {
                            const Ll = 4 * Qe;
                            return this.float32[Ll + 0] = rt, this.float32[Ll + 1] = Wn, this.float32[Ll + 2] = Co, this.float32[Ll + 3] = Dl, Qe;
                        }
                    }
                    ws.prototype.bytesPerElement = 16, Qn("StructArrayLayout4f16", ws);
                    class _s extends Yi {
                        get anchorPointX() {
                            return this._structArray.int16[this._pos2 + 0];
                        }
                        get anchorPointY() {
                            return this._structArray.int16[this._pos2 + 1];
                        }
                        get x1() {
                            return this._structArray.int16[this._pos2 + 2];
                        }
                        get y1() {
                            return this._structArray.int16[this._pos2 + 3];
                        }
                        get x2() {
                            return this._structArray.int16[this._pos2 + 4];
                        }
                        get y2() {
                            return this._structArray.int16[this._pos2 + 5];
                        }
                        get featureIndex() {
                            return this._structArray.uint32[this._pos4 + 3];
                        }
                        get sourceLayerIndex() {
                            return this._structArray.uint16[this._pos2 + 8];
                        }
                        get bucketIndex() {
                            return this._structArray.uint16[this._pos2 + 9];
                        }
                        get anchorPoint() {
                            return new Dl(this.anchorPointX, this.anchorPointY);
                        }
                    }
                    _s.prototype.size = 20;
                    class Ss extends us {
                        get(Qe) {
                            return new _s(this, Qe);
                        }
                    }
                    Qn("CollisionBoxArray", Ss);
                    class ks extends Yi {
                        get anchorX() {
                            return this._structArray.int16[this._pos2 + 0];
                        }
                        get anchorY() {
                            return this._structArray.int16[this._pos2 + 1];
                        }
                        get glyphStartIndex() {
                            return this._structArray.uint16[this._pos2 + 2];
                        }
                        get numGlyphs() {
                            return this._structArray.uint16[this._pos2 + 3];
                        }
                        get vertexStartIndex() {
                            return this._structArray.uint32[this._pos4 + 2];
                        }
                        get lineStartIndex() {
                            return this._structArray.uint32[this._pos4 + 3];
                        }
                        get lineLength() {
                            return this._structArray.uint32[this._pos4 + 4];
                        }
                        get segment() {
                            return this._structArray.uint16[this._pos2 + 10];
                        }
                        get lowerSize() {
                            return this._structArray.uint16[this._pos2 + 11];
                        }
                        get upperSize() {
                            return this._structArray.uint16[this._pos2 + 12];
                        }
                        get lineOffsetX() {
                            return this._structArray.float32[this._pos4 + 7];
                        }
                        get lineOffsetY() {
                            return this._structArray.float32[this._pos4 + 8];
                        }
                        get writingMode() {
                            return this._structArray.uint8[this._pos1 + 36];
                        }
                        get placedOrientation() {
                            return this._structArray.uint8[this._pos1 + 37];
                        }
                        set placedOrientation(Qe) {
                            this._structArray.uint8[this._pos1 + 37] = Qe;
                        }
                        get hidden() {
                            return this._structArray.uint8[this._pos1 + 38];
                        }
                        set hidden(Qe) {
                            this._structArray.uint8[this._pos1 + 38] = Qe;
                        }
                        get crossTileID() {
                            return this._structArray.uint32[this._pos4 + 10];
                        }
                        set crossTileID(Qe) {
                            this._structArray.uint32[this._pos4 + 10] = Qe;
                        }
                        get associatedIconIndex() {
                            return this._structArray.int16[this._pos2 + 22];
                        }
                    }
                    ks.prototype.size = 48;
                    class As extends ds {
                        get(Qe) {
                            return new ks(this, Qe);
                        }
                    }
                    Qn("PlacedSymbolArray", As);
                    class Is extends Yi {
                        get anchorX() {
                            return this._structArray.int16[this._pos2 + 0];
                        }
                        get anchorY() {
                            return this._structArray.int16[this._pos2 + 1];
                        }
                        get rightJustifiedTextSymbolIndex() {
                            return this._structArray.int16[this._pos2 + 2];
                        }
                        get centerJustifiedTextSymbolIndex() {
                            return this._structArray.int16[this._pos2 + 3];
                        }
                        get leftJustifiedTextSymbolIndex() {
                            return this._structArray.int16[this._pos2 + 4];
                        }
                        get verticalPlacedTextSymbolIndex() {
                            return this._structArray.int16[this._pos2 + 5];
                        }
                        get placedIconSymbolIndex() {
                            return this._structArray.int16[this._pos2 + 6];
                        }
                        get verticalPlacedIconSymbolIndex() {
                            return this._structArray.int16[this._pos2 + 7];
                        }
                        get key() {
                            return this._structArray.uint16[this._pos2 + 8];
                        }
                        get textBoxStartIndex() {
                            return this._structArray.uint16[this._pos2 + 9];
                        }
                        get textBoxEndIndex() {
                            return this._structArray.uint16[this._pos2 + 10];
                        }
                        get verticalTextBoxStartIndex() {
                            return this._structArray.uint16[this._pos2 + 11];
                        }
                        get verticalTextBoxEndIndex() {
                            return this._structArray.uint16[this._pos2 + 12];
                        }
                        get iconBoxStartIndex() {
                            return this._structArray.uint16[this._pos2 + 13];
                        }
                        get iconBoxEndIndex() {
                            return this._structArray.uint16[this._pos2 + 14];
                        }
                        get verticalIconBoxStartIndex() {
                            return this._structArray.uint16[this._pos2 + 15];
                        }
                        get verticalIconBoxEndIndex() {
                            return this._structArray.uint16[this._pos2 + 16];
                        }
                        get featureIndex() {
                            return this._structArray.uint16[this._pos2 + 17];
                        }
                        get numHorizontalGlyphVertices() {
                            return this._structArray.uint16[this._pos2 + 18];
                        }
                        get numVerticalGlyphVertices() {
                            return this._structArray.uint16[this._pos2 + 19];
                        }
                        get numIconVertices() {
                            return this._structArray.uint16[this._pos2 + 20];
                        }
                        get numVerticalIconVertices() {
                            return this._structArray.uint16[this._pos2 + 21];
                        }
                        get useRuntimeCollisionCircles() {
                            return this._structArray.uint16[this._pos2 + 22];
                        }
                        get crossTileID() {
                            return this._structArray.uint32[this._pos4 + 12];
                        }
                        set crossTileID(Qe) {
                            this._structArray.uint32[this._pos4 + 12] = Qe;
                        }
                        get textBoxScale() {
                            return this._structArray.float32[this._pos4 + 13];
                        }
                        get collisionCircleDiameter() {
                            return this._structArray.float32[this._pos4 + 14];
                        }
                        get textAnchorOffsetStartIndex() {
                            return this._structArray.uint16[this._pos2 + 30];
                        }
                        get textAnchorOffsetEndIndex() {
                            return this._structArray.uint16[this._pos2 + 31];
                        }
                    }
                    Is.prototype.size = 64;
                    class Ms extends ys {
                        get(Qe) {
                            return new Is(this, Qe);
                        }
                    }
                    Qn("SymbolInstanceArray", Ms);
                    class zs extends ms {
                        getoffsetX(Qe) {
                            return this.float32[1 * Qe + 0];
                        }
                    }
                    Qn("GlyphOffsetArray", zs);
                    class Ps extends ts {
                        getx(Qe) {
                            return this.int16[3 * Qe + 0];
                        }
                        gety(Qe) {
                            return this.int16[3 * Qe + 1];
                        }
                        gettileUnitDistanceFromAnchor(Qe) {
                            return this.int16[3 * Qe + 2];
                        }
                    }
                    Qn("SymbolLineVertexArray", Ps);
                    class Cs extends Yi {
                        get textAnchor() {
                            return this._structArray.uint16[this._pos2 + 0];
                        }
                        get textOffset0() {
                            return this._structArray.float32[this._pos4 + 1];
                        }
                        get textOffset1() {
                            return this._structArray.float32[this._pos4 + 2];
                        }
                    }
                    Cs.prototype.size = 12;
                    class Bs extends gs {
                        get(Qe) {
                            return new Cs(this, Qe);
                        }
                    }
                    Qn("TextAnchorOffsetArray", Bs);
                    class Ts extends Yi {
                        get featureIndex() {
                            return this._structArray.uint32[this._pos4 + 0];
                        }
                        get sourceLayerIndex() {
                            return this._structArray.uint16[this._pos2 + 2];
                        }
                        get bucketIndex() {
                            return this._structArray.uint16[this._pos2 + 3];
                        }
                    }
                    Ts.prototype.size = 8;
                    class Vs extends xs {
                        get(Qe) {
                            return new Ts(this, Qe);
                        }
                    }
                    Qn("FeatureIndexArray", Vs);
                    class Es extends Qi {
                    }
                    class Fs extends Qi {
                    }
                    class Ds extends Qi {
                    }
                    class Ls extends rs {
                    }
                    class $s extends ns {
                    }
                    class Os extends is {
                    }
                    class Rs extends ss {
                    }
                    class Ns extends os {
                    }
                    class js extends as {
                    }
                    class qs extends ls {
                    }
                    class Us extends cs {
                    }
                    class Gs extends ps {
                    }
                    class Zs extends fs {
                    }
                    class Xs extends vs {
                    }
                    const Xd = Ki([
                        {
                            name: "a_pos",
                            components: 2,
                            type: "Int16"
                        }
                    ], 4), { members: Jd } = Xd;
                    class Js {
                        constructor(Qe){
                            void 0 === Qe && (Qe = []), this._forceNewSegmentOnNextPrepare = !1, this.segments = Qe;
                        }
                        prepareSegment(Qe, rt, Wn, Co) {
                            const Dl = this.segments[this.segments.length - 1];
                            return Qe > Js.MAX_VERTEX_ARRAY_LENGTH && w(`Max vertices per segment is ${Js.MAX_VERTEX_ARRAY_LENGTH}: bucket requested ${Qe}. Consider using the \`fillLargeMeshArrays\` function if you require meshes with more than ${Js.MAX_VERTEX_ARRAY_LENGTH} vertices.`), this._forceNewSegmentOnNextPrepare || !Dl || Dl.vertexLength + Qe > Js.MAX_VERTEX_ARRAY_LENGTH || Dl.sortKey !== Co ? this.createNewSegment(rt, Wn, Co) : Dl;
                        }
                        createNewSegment(Qe, rt, Wn) {
                            const Co = {
                                vertexOffset: Qe.length,
                                primitiveOffset: rt.length,
                                vertexLength: 0,
                                primitiveLength: 0,
                                vaos: {}
                            };
                            return void 0 !== Wn && (Co.sortKey = Wn), this._forceNewSegmentOnNextPrepare = !1, this.segments.push(Co), Co;
                        }
                        getOrCreateLatestSegment(Qe, rt, Wn) {
                            return this.prepareSegment(0, Qe, rt, Wn);
                        }
                        forceNewSegmentOnNextPrepare() {
                            this._forceNewSegmentOnNextPrepare = !0;
                        }
                        get() {
                            return this.segments;
                        }
                        destroy() {
                            for (const Qe of this.segments)for(const rt in Qe.vaos)Qe.vaos[rt].destroy();
                        }
                        static simpleSegment(Qe, rt, Wn, Co) {
                            return new Js([
                                {
                                    vertexOffset: Qe,
                                    primitiveOffset: rt,
                                    vertexLength: Wn,
                                    primitiveLength: Co,
                                    vaos: {},
                                    sortKey: 0
                                }
                            ]);
                        }
                    }
                    function Ks(Qe, rt) {
                        return 256 * (Qe = m(Math.floor(Qe), 0, 255)) + m(Math.floor(rt), 0, 255);
                    }
                    Js.MAX_VERTEX_ARRAY_LENGTH = Math.pow(2, 16) - 1, Qn("SegmentVector", Js);
                    const $d = Ki([
                        {
                            name: "a_pattern_from",
                            components: 4,
                            type: "Uint16"
                        },
                        {
                            name: "a_pattern_to",
                            components: 4,
                            type: "Uint16"
                        },
                        {
                            name: "a_pixel_ratio_from",
                            components: 1,
                            type: "Uint16"
                        },
                        {
                            name: "a_pixel_ratio_to",
                            components: 1,
                            type: "Uint16"
                        }
                    ]);
                    var up, gp, Ap, vp = {
                        exports: {}
                    }, _p = {
                        exports: {}
                    }, xp = {
                        exports: {}
                    }, bp = function() {
                        if (Ap) return vp.exports;
                        Ap = 1;
                        var Qe = (up || (up = 1, _p.exports = function(Qe, rt) {
                            var Wn, Co, Dl, Ll, Rl, Ul, Gl, Zl;
                            for(Co = Qe.length - (Wn = 3 & Qe.length), Dl = rt, Rl = 3432918353, Ul = 461845907, Zl = 0; Zl < Co;)Gl = 255 & Qe.charCodeAt(Zl) | (255 & Qe.charCodeAt(++Zl)) << 8 | (255 & Qe.charCodeAt(++Zl)) << 16 | (255 & Qe.charCodeAt(++Zl)) << 24, ++Zl, Dl = 27492 + (65535 & (Ll = 5 * (65535 & (Dl = (Dl ^= Gl = (65535 & (Gl = (Gl = (65535 & Gl) * Rl + (((Gl >>> 16) * Rl & 65535) << 16) & 4294967295) << 15 | Gl >>> 17)) * Ul + (((Gl >>> 16) * Ul & 65535) << 16) & 4294967295) << 13 | Dl >>> 19)) + ((5 * (Dl >>> 16) & 65535) << 16) & 4294967295)) + ((58964 + (Ll >>> 16) & 65535) << 16);
                            switch(Gl = 0, Wn){
                                case 3:
                                    Gl ^= (255 & Qe.charCodeAt(Zl + 2)) << 16;
                                case 2:
                                    Gl ^= (255 & Qe.charCodeAt(Zl + 1)) << 8;
                                case 1:
                                    Dl ^= Gl = (65535 & (Gl = (Gl = (65535 & (Gl ^= 255 & Qe.charCodeAt(Zl))) * Rl + (((Gl >>> 16) * Rl & 65535) << 16) & 4294967295) << 15 | Gl >>> 17)) * Ul + (((Gl >>> 16) * Ul & 65535) << 16) & 4294967295;
                            }
                            return Dl ^= Qe.length, Dl = 2246822507 * (65535 & (Dl ^= Dl >>> 16)) + ((2246822507 * (Dl >>> 16) & 65535) << 16) & 4294967295, Dl = 3266489909 * (65535 & (Dl ^= Dl >>> 13)) + ((3266489909 * (Dl >>> 16) & 65535) << 16) & 4294967295, (Dl ^= Dl >>> 16) >>> 0;
                        }), _p.exports), rt = (gp || (gp = 1, xp.exports = function(Qe, rt) {
                            for(var Wn, Co = Qe.length, Dl = rt ^ Co, Ll = 0; Co >= 4;)Wn = 1540483477 * (65535 & (Wn = 255 & Qe.charCodeAt(Ll) | (255 & Qe.charCodeAt(++Ll)) << 8 | (255 & Qe.charCodeAt(++Ll)) << 16 | (255 & Qe.charCodeAt(++Ll)) << 24)) + ((1540483477 * (Wn >>> 16) & 65535) << 16), Dl = 1540483477 * (65535 & Dl) + ((1540483477 * (Dl >>> 16) & 65535) << 16) ^ (Wn = 1540483477 * (65535 & (Wn ^= Wn >>> 24)) + ((1540483477 * (Wn >>> 16) & 65535) << 16)), Co -= 4, ++Ll;
                            switch(Co){
                                case 3:
                                    Dl ^= (255 & Qe.charCodeAt(Ll + 2)) << 16;
                                case 2:
                                    Dl ^= (255 & Qe.charCodeAt(Ll + 1)) << 8;
                                case 1:
                                    Dl = 1540483477 * (65535 & (Dl ^= 255 & Qe.charCodeAt(Ll))) + ((1540483477 * (Dl >>> 16) & 65535) << 16);
                            }
                            return Dl = 1540483477 * (65535 & (Dl ^= Dl >>> 13)) + ((1540483477 * (Dl >>> 16) & 65535) << 16), (Dl ^= Dl >>> 15) >>> 0;
                        }), xp.exports);
                        return vp.exports = Qe, vp.exports.murmur3 = Qe, vp.exports.murmur2 = rt, vp.exports;
                    }(), wp = e(bp);
                    class ao {
                        constructor(){
                            this.ids = [], this.positions = [], this.indexed = !1;
                        }
                        add(Qe, rt, Wn, Co) {
                            this.ids.push(lo(Qe)), this.positions.push(rt, Wn, Co);
                        }
                        getPositions(Qe) {
                            if (!this.indexed) throw new Error("Trying to get index, but feature positions are not indexed");
                            const rt = lo(Qe);
                            let Wn = 0, Co = this.ids.length - 1;
                            for(; Wn < Co;){
                                const Qe = Wn + Co >> 1;
                                this.ids[Qe] >= rt ? Co = Qe : Wn = Qe + 1;
                            }
                            const Dl = [];
                            for(; this.ids[Wn] === rt;)Dl.push({
                                index: this.positions[3 * Wn],
                                start: this.positions[3 * Wn + 1],
                                end: this.positions[3 * Wn + 2]
                            }), Wn++;
                            return Dl;
                        }
                        static serialize(Qe, rt) {
                            const Wn = new Float64Array(Qe.ids), Co = new Uint32Array(Qe.positions);
                            return uo(Wn, Co, 0, Wn.length - 1), rt && rt.push(Wn.buffer, Co.buffer), {
                                ids: Wn,
                                positions: Co
                            };
                        }
                        static deserialize(Qe) {
                            const rt = new ao;
                            return rt.ids = Qe.ids, rt.positions = Qe.positions, rt.indexed = !0, rt;
                        }
                    }
                    function lo(Qe) {
                        const rt = +Qe;
                        return !isNaN(rt) && rt <= Number.MAX_SAFE_INTEGER ? rt : wp(String(Qe));
                    }
                    function uo(Qe, rt, Wn, Co) {
                        for(; Wn < Co;){
                            const Dl = Qe[Wn + Co >> 1];
                            let Ll = Wn - 1, Rl = Co + 1;
                            for(;;){
                                do Ll++;
                                while (Qe[Ll] < Dl);
                                do Rl--;
                                while (Qe[Rl] > Dl);
                                if (Ll >= Rl) break;
                                co(Qe, Ll, Rl), co(rt, 3 * Ll, 3 * Rl), co(rt, 3 * Ll + 1, 3 * Rl + 1), co(rt, 3 * Ll + 2, 3 * Rl + 2);
                            }
                            Rl - Wn < Co - Rl ? (uo(Qe, rt, Wn, Rl), Wn = Rl + 1) : (uo(Qe, rt, Rl + 1, Co), Co = Rl);
                        }
                    }
                    function co(Qe, rt, Wn) {
                        const Co = Qe[rt];
                        Qe[rt] = Qe[Wn], Qe[Wn] = Co;
                    }
                    Qn("FeaturePositionMap", ao);
                    class ho {
                        constructor(Qe, rt){
                            this.gl = Qe.gl, this.location = rt;
                        }
                    }
                    class po extends ho {
                        constructor(Qe, rt){
                            super(Qe, rt), this.current = 0;
                        }
                        set(Qe) {
                            this.current !== Qe && (this.current = Qe, this.gl.uniform1f(this.location, Qe));
                        }
                    }
                    class fo extends ho {
                        constructor(Qe, rt){
                            super(Qe, rt), this.current = [
                                0,
                                0,
                                0,
                                0
                            ];
                        }
                        set(Qe) {
                            Qe[0] === this.current[0] && Qe[1] === this.current[1] && Qe[2] === this.current[2] && Qe[3] === this.current[3] || (this.current = Qe, this.gl.uniform4f(this.location, Qe[0], Qe[1], Qe[2], Qe[3]));
                        }
                    }
                    class yo extends ho {
                        constructor(Qe, rt){
                            super(Qe, rt), this.current = St.transparent;
                        }
                        set(Qe) {
                            Qe.r === this.current.r && Qe.g === this.current.g && Qe.b === this.current.b && Qe.a === this.current.a || (this.current = Qe, this.gl.uniform4f(this.location, Qe.r, Qe.g, Qe.b, Qe.a));
                        }
                    }
                    function mo(Qe) {
                        return [
                            Ks(255 * Qe.r, 255 * Qe.g),
                            Ks(255 * Qe.b, 255 * Qe.a)
                        ];
                    }
                    class go {
                        constructor(Qe, rt, Wn){
                            this.value = Qe, this.uniformNames = rt.map((Qe)=>`u_${Qe}`), this.type = Wn;
                        }
                        setUniform(Qe, rt, Wn) {
                            Qe.set(Wn.constantOr(this.value));
                        }
                        getBinding(Qe, rt, Wn) {
                            return "color" === this.type ? new yo(Qe, rt) : new po(Qe, rt);
                        }
                    }
                    class xo {
                        constructor(Qe, rt){
                            this.uniformNames = rt.map((Qe)=>`u_${Qe}`), this.patternFrom = null, this.patternTo = null, this.pixelRatioFrom = 1, this.pixelRatioTo = 1;
                        }
                        setConstantPatternPositions(Qe, rt) {
                            this.pixelRatioFrom = rt.pixelRatio, this.pixelRatioTo = Qe.pixelRatio, this.patternFrom = rt.tlbr, this.patternTo = Qe.tlbr;
                        }
                        setUniform(Qe, rt, Wn, Co) {
                            const Dl = "u_pattern_to" === Co ? this.patternTo : "u_pattern_from" === Co ? this.patternFrom : "u_pixel_ratio_to" === Co ? this.pixelRatioTo : "u_pixel_ratio_from" === Co ? this.pixelRatioFrom : null;
                            Dl && Qe.set(Dl);
                        }
                        getBinding(Qe, rt, Wn) {
                            return "u_pattern" === Wn.substr(0, 9) ? new fo(Qe, rt) : new po(Qe, rt);
                        }
                    }
                    class vo {
                        constructor(Qe, rt, Wn, Co){
                            this.expression = Qe, this.type = Wn, this.maxValue = 0, this.paintVertexAttributes = rt.map((Qe)=>({
                                    name: `a_${Qe}`,
                                    type: "Float32",
                                    components: "color" === Wn ? 2 : 1,
                                    offset: 0
                                })), this.paintVertexArray = new Co;
                        }
                        populatePaintArray(Qe, rt, Wn, Co, Dl) {
                            const Ll = this.paintVertexArray.length, Rl = this.expression.evaluate(new Bi(0), rt, {}, Co, [], Dl);
                            this.paintVertexArray.resize(Qe), this._setPaintValue(Ll, Qe, Rl);
                        }
                        updatePaintArray(Qe, rt, Wn, Co) {
                            const Dl = this.expression.evaluate({
                                zoom: 0
                            }, Wn, Co);
                            this._setPaintValue(Qe, rt, Dl);
                        }
                        _setPaintValue(Qe, rt, Wn) {
                            if ("color" === this.type) {
                                const Co = mo(Wn);
                                for(let Wn = Qe; Wn < rt; Wn++)this.paintVertexArray.emplace(Wn, Co[0], Co[1]);
                            } else {
                                for(let Co = Qe; Co < rt; Co++)this.paintVertexArray.emplace(Co, Wn);
                                this.maxValue = Math.max(this.maxValue, Math.abs(Wn));
                            }
                        }
                        upload(Qe) {
                            this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer && this.paintVertexBuffer.buffer ? this.paintVertexBuffer.updateData(this.paintVertexArray) : this.paintVertexBuffer = Qe.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent));
                        }
                        destroy() {
                            this.paintVertexBuffer && this.paintVertexBuffer.destroy();
                        }
                    }
                    class bo {
                        constructor(Qe, rt, Wn, Co, Dl, Ll){
                            this.expression = Qe, this.uniformNames = rt.map((Qe)=>`u_${Qe}_t`), this.type = Wn, this.useIntegerZoom = Co, this.zoom = Dl, this.maxValue = 0, this.paintVertexAttributes = rt.map((Qe)=>({
                                    name: `a_${Qe}`,
                                    type: "Float32",
                                    components: "color" === Wn ? 4 : 2,
                                    offset: 0
                                })), this.paintVertexArray = new Ll;
                        }
                        populatePaintArray(Qe, rt, Wn, Co, Dl) {
                            const Ll = this.expression.evaluate(new Bi(this.zoom), rt, {}, Co, [], Dl), Rl = this.expression.evaluate(new Bi(this.zoom + 1), rt, {}, Co, [], Dl), Ul = this.paintVertexArray.length;
                            this.paintVertexArray.resize(Qe), this._setPaintValue(Ul, Qe, Ll, Rl);
                        }
                        updatePaintArray(Qe, rt, Wn, Co) {
                            const Dl = this.expression.evaluate({
                                zoom: this.zoom
                            }, Wn, Co), Ll = this.expression.evaluate({
                                zoom: this.zoom + 1
                            }, Wn, Co);
                            this._setPaintValue(Qe, rt, Dl, Ll);
                        }
                        _setPaintValue(Qe, rt, Wn, Co) {
                            if ("color" === this.type) {
                                const Dl = mo(Wn), Ll = mo(Co);
                                for(let Wn = Qe; Wn < rt; Wn++)this.paintVertexArray.emplace(Wn, Dl[0], Dl[1], Ll[0], Ll[1]);
                            } else {
                                for(let Dl = Qe; Dl < rt; Dl++)this.paintVertexArray.emplace(Dl, Wn, Co);
                                this.maxValue = Math.max(this.maxValue, Math.abs(Wn), Math.abs(Co));
                            }
                        }
                        upload(Qe) {
                            this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer && this.paintVertexBuffer.buffer ? this.paintVertexBuffer.updateData(this.paintVertexArray) : this.paintVertexBuffer = Qe.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent));
                        }
                        destroy() {
                            this.paintVertexBuffer && this.paintVertexBuffer.destroy();
                        }
                        setUniform(Qe, rt) {
                            const Wn = this.useIntegerZoom ? Math.floor(rt.zoom) : rt.zoom, Co = m(this.expression.interpolationFactor(Wn, this.zoom, this.zoom + 1), 0, 1);
                            Qe.set(Co);
                        }
                        getBinding(Qe, rt, Wn) {
                            return new po(Qe, rt);
                        }
                    }
                    class wo {
                        constructor(Qe, rt, Wn, Co, Dl, Ll){
                            this.expression = Qe, this.type = rt, this.useIntegerZoom = Wn, this.zoom = Co, this.layerId = Ll, this.zoomInPaintVertexArray = new Dl, this.zoomOutPaintVertexArray = new Dl;
                        }
                        populatePaintArray(Qe, rt, Wn) {
                            const Co = this.zoomInPaintVertexArray.length;
                            this.zoomInPaintVertexArray.resize(Qe), this.zoomOutPaintVertexArray.resize(Qe), this._setPaintValues(Co, Qe, rt.patterns && rt.patterns[this.layerId], Wn);
                        }
                        updatePaintArray(Qe, rt, Wn, Co, Dl) {
                            this._setPaintValues(Qe, rt, Wn.patterns && Wn.patterns[this.layerId], Dl);
                        }
                        _setPaintValues(Qe, rt, Wn, Co) {
                            if (!Co || !Wn) return;
                            const { min: Dl, mid: Ll, max: Rl } = Wn, Ul = Co[Dl], Gl = Co[Ll], Zl = Co[Rl];
                            if (Ul && Gl && Zl) for(let Hl = Qe; Hl < rt; Hl++)this.zoomInPaintVertexArray.emplace(Hl, Gl.tl[0], Gl.tl[1], Gl.br[0], Gl.br[1], Ul.tl[0], Ul.tl[1], Ul.br[0], Ul.br[1], Gl.pixelRatio, Ul.pixelRatio), this.zoomOutPaintVertexArray.emplace(Hl, Gl.tl[0], Gl.tl[1], Gl.br[0], Gl.br[1], Zl.tl[0], Zl.tl[1], Zl.br[0], Zl.br[1], Gl.pixelRatio, Zl.pixelRatio);
                        }
                        upload(Qe) {
                            this.zoomInPaintVertexArray && this.zoomInPaintVertexArray.arrayBuffer && this.zoomOutPaintVertexArray && this.zoomOutPaintVertexArray.arrayBuffer && (this.zoomInPaintVertexBuffer = Qe.createVertexBuffer(this.zoomInPaintVertexArray, $d.members, this.expression.isStateDependent), this.zoomOutPaintVertexBuffer = Qe.createVertexBuffer(this.zoomOutPaintVertexArray, $d.members, this.expression.isStateDependent));
                        }
                        destroy() {
                            this.zoomOutPaintVertexBuffer && this.zoomOutPaintVertexBuffer.destroy(), this.zoomInPaintVertexBuffer && this.zoomInPaintVertexBuffer.destroy();
                        }
                    }
                    class _o {
                        constructor(Qe, rt, Wn){
                            this.binders = {}, this._buffers = [];
                            const Co = [];
                            for(const Dl in Qe.paint._values){
                                if (!Wn(Dl)) continue;
                                const Ll = Qe.paint.get(Dl);
                                if (!(Ll instanceof $i && Fr(Ll.property.specification))) continue;
                                const Rl = ko(Dl, Qe.type), Ul = Ll.value, Gl = Ll.property.specification.type, Zl = Ll.property.useIntegerZoom, Hl = Ll.property.specification["property-type"], ql = "cross-faded" === Hl || "cross-faded-data-driven" === Hl;
                                if ("constant" === Ul.kind) this.binders[Dl] = ql ? new xo(Ul.value, Rl) : new go(Ul.value, Rl, Gl), Co.push(`/u_${Dl}`);
                                else if ("source" === Ul.kind || ql) {
                                    const Wn = Ao(Dl, Gl, "source");
                                    this.binders[Dl] = ql ? new wo(Ul, Gl, Zl, rt, Wn, Qe.id) : new vo(Ul, Rl, Gl, Wn), Co.push(`/a_${Dl}`);
                                } else {
                                    const Qe = Ao(Dl, Gl, "composite");
                                    this.binders[Dl] = new bo(Ul, Rl, Gl, Zl, rt, Qe), Co.push(`/z_${Dl}`);
                                }
                            }
                            this.cacheKey = Co.sort().join("");
                        }
                        getMaxValue(Qe) {
                            const rt = this.binders[Qe];
                            return rt instanceof vo || rt instanceof bo ? rt.maxValue : 0;
                        }
                        populatePaintArrays(Qe, rt, Wn, Co, Dl) {
                            for(const Ll in this.binders){
                                const Rl = this.binders[Ll];
                                (Rl instanceof vo || Rl instanceof bo || Rl instanceof wo) && Rl.populatePaintArray(Qe, rt, Wn, Co, Dl);
                            }
                        }
                        setConstantPatternPositions(Qe, rt) {
                            for(const Wn in this.binders){
                                const Co = this.binders[Wn];
                                Co instanceof xo && Co.setConstantPatternPositions(Qe, rt);
                            }
                        }
                        updatePaintArrays(Qe, rt, Wn, Co, Dl) {
                            let Ll = !1;
                            for(const Rl in Qe){
                                const Ul = rt.getPositions(Rl);
                                for (const rt of Ul){
                                    const Ul = Wn.feature(rt.index);
                                    for(const Wn in this.binders){
                                        const Gl = this.binders[Wn];
                                        if ((Gl instanceof vo || Gl instanceof bo || Gl instanceof wo) && !0 === Gl.expression.isStateDependent) {
                                            const Zl = Co.paint.get(Wn);
                                            Gl.expression = Zl.value, Gl.updatePaintArray(rt.start, rt.end, Ul, Qe[Rl], Dl), Ll = !0;
                                        }
                                    }
                                }
                            }
                            return Ll;
                        }
                        defines() {
                            const Qe = [];
                            for(const rt in this.binders){
                                const Wn = this.binders[rt];
                                (Wn instanceof go || Wn instanceof xo) && Qe.push(...Wn.uniformNames.map((Qe)=>`#define HAS_UNIFORM_${Qe}`));
                            }
                            return Qe;
                        }
                        getBinderAttributes() {
                            const Qe = [];
                            for(const rt in this.binders){
                                const Wn = this.binders[rt];
                                if (Wn instanceof vo || Wn instanceof bo) for(let rt = 0; rt < Wn.paintVertexAttributes.length; rt++)Qe.push(Wn.paintVertexAttributes[rt].name);
                                else if (Wn instanceof wo) for(let rt = 0; rt < $d.members.length; rt++)Qe.push($d.members[rt].name);
                            }
                            return Qe;
                        }
                        getBinderUniforms() {
                            const Qe = [];
                            for(const rt in this.binders){
                                const Wn = this.binders[rt];
                                if (Wn instanceof go || Wn instanceof xo || Wn instanceof bo) for (const rt of Wn.uniformNames)Qe.push(rt);
                            }
                            return Qe;
                        }
                        getPaintVertexBuffers() {
                            return this._buffers;
                        }
                        getUniforms(Qe, rt) {
                            const Wn = [];
                            for(const Co in this.binders){
                                const Dl = this.binders[Co];
                                if (Dl instanceof go || Dl instanceof xo || Dl instanceof bo) {
                                    for (const Ll of Dl.uniformNames)if (rt[Ll]) {
                                        const Rl = Dl.getBinding(Qe, rt[Ll], Ll);
                                        Wn.push({
                                            name: Ll,
                                            property: Co,
                                            binding: Rl
                                        });
                                    }
                                }
                            }
                            return Wn;
                        }
                        setUniforms(Qe, rt, Wn, Co) {
                            for (const { name: Dl, property: Ll, binding: Rl } of rt)this.binders[Ll].setUniform(Rl, Co, Wn.get(Ll), Dl);
                        }
                        updatePaintBuffers(Qe) {
                            this._buffers = [];
                            for(const rt in this.binders){
                                const Wn = this.binders[rt];
                                if (Qe && Wn instanceof wo) {
                                    const rt = 2 === Qe.fromScale ? Wn.zoomInPaintVertexBuffer : Wn.zoomOutPaintVertexBuffer;
                                    rt && this._buffers.push(rt);
                                } else (Wn instanceof vo || Wn instanceof bo) && Wn.paintVertexBuffer && this._buffers.push(Wn.paintVertexBuffer);
                            }
                        }
                        upload(Qe) {
                            for(const rt in this.binders){
                                const Wn = this.binders[rt];
                                (Wn instanceof vo || Wn instanceof bo || Wn instanceof wo) && Wn.upload(Qe);
                            }
                            this.updatePaintBuffers();
                        }
                        destroy() {
                            for(const Qe in this.binders){
                                const rt = this.binders[Qe];
                                (rt instanceof vo || rt instanceof bo || rt instanceof wo) && rt.destroy();
                            }
                        }
                    }
                    class So {
                        constructor(Qe, rt, Wn){
                            void 0 === Wn && (Wn = ()=>!0), this.programConfigurations = {};
                            for (const Co of Qe)this.programConfigurations[Co.id] = new _o(Co, rt, Wn);
                            this.needsUpload = !1, this._featureMap = new ao, this._bufferOffset = 0;
                        }
                        populatePaintArrays(Qe, rt, Wn, Co, Dl, Ll) {
                            for(const Rl in this.programConfigurations)this.programConfigurations[Rl].populatePaintArrays(Qe, rt, Co, Dl, Ll);
                            void 0 !== rt.id && this._featureMap.add(rt.id, Wn, this._bufferOffset, Qe), this._bufferOffset = Qe, this.needsUpload = !0;
                        }
                        updatePaintArrays(Qe, rt, Wn, Co) {
                            for (const Dl of Wn)this.needsUpload = this.programConfigurations[Dl.id].updatePaintArrays(Qe, this._featureMap, rt, Dl, Co) || this.needsUpload;
                        }
                        get(Qe) {
                            return this.programConfigurations[Qe];
                        }
                        upload(Qe) {
                            if (this.needsUpload) {
                                for(const rt in this.programConfigurations)this.programConfigurations[rt].upload(Qe);
                                this.needsUpload = !1;
                            }
                        }
                        destroy() {
                            for(const Qe in this.programConfigurations)this.programConfigurations[Qe].destroy();
                        }
                    }
                    function ko(Qe, rt) {
                        return ({
                            "text-opacity": [
                                "opacity"
                            ],
                            "icon-opacity": [
                                "opacity"
                            ],
                            "text-color": [
                                "fill_color"
                            ],
                            "icon-color": [
                                "fill_color"
                            ],
                            "text-halo-color": [
                                "halo_color"
                            ],
                            "icon-halo-color": [
                                "halo_color"
                            ],
                            "text-halo-blur": [
                                "halo_blur"
                            ],
                            "icon-halo-blur": [
                                "halo_blur"
                            ],
                            "text-halo-width": [
                                "halo_width"
                            ],
                            "icon-halo-width": [
                                "halo_width"
                            ],
                            "line-gap-width": [
                                "gapwidth"
                            ],
                            "line-pattern": [
                                "pattern_to",
                                "pattern_from",
                                "pixel_ratio_to",
                                "pixel_ratio_from"
                            ],
                            "fill-pattern": [
                                "pattern_to",
                                "pattern_from",
                                "pixel_ratio_to",
                                "pixel_ratio_from"
                            ],
                            "fill-extrusion-pattern": [
                                "pattern_to",
                                "pattern_from",
                                "pixel_ratio_to",
                                "pixel_ratio_from"
                            ]
                        })[Qe] || [
                            Qe.replace(`${rt}-`, "").replace(/-/g, "_")
                        ];
                    }
                    function Ao(Qe, rt, Wn) {
                        const Co = {
                            color: {
                                source: is,
                                composite: ws
                            },
                            number: {
                                source: ms,
                                composite: is
                            }
                        }, Dl = function(Qe) {
                            return ({
                                "line-pattern": {
                                    source: Rs,
                                    composite: Rs
                                },
                                "fill-pattern": {
                                    source: Rs,
                                    composite: Rs
                                },
                                "fill-extrusion-pattern": {
                                    source: Rs,
                                    composite: Rs
                                }
                            })[Qe];
                        }(Qe);
                        return Dl && Dl[Wn] || Co[rt][Wn];
                    }
                    Qn("ConstantBinder", go), Qn("CrossFadedConstantBinder", xo), Qn("SourceExpressionBinder", vo), Qn("CrossFadedCompositeBinder", wo), Qn("CompositeExpressionBinder", bo), Qn("ProgramConfiguration", _o, {
                        omit: [
                            "_buffers"
                        ]
                    }), Qn("ProgramConfigurationSet", So);
                    const Ep = Math.pow(2, 14) - 1, Mp = -Ep - 1;
                    function zo(Qe) {
                        const rt = ql / Qe.extent, Wn = Qe.loadGeometry();
                        for(let Co = 0; Co < Wn.length; Co++){
                            const Qe = Wn[Co];
                            for(let Wn = 0; Wn < Qe.length; Wn++){
                                const Co = Qe[Wn], Dl = Math.round(Co.x * rt), Ll = Math.round(Co.y * rt);
                                Co.x = m(Dl, Mp, Ep), Co.y = m(Ll, Mp, Ep), (Dl < Co.x || Dl > Co.x + 1 || Ll < Co.y || Ll > Co.y + 1) && w("Geometry exceeds allowed extent, reduce your vector tile buffer size");
                            }
                        }
                        return Wn;
                    }
                    function Po(Qe, rt) {
                        return {
                            type: Qe.type,
                            id: Qe.id,
                            properties: Qe.properties,
                            geometry: rt ? zo(Qe) : []
                        };
                    }
                    const Sp = -32768;
                    function Bo(Qe, rt, Wn, Co, Dl) {
                        Qe.emplaceBack(Sp + 8 * rt + Co, Sp + 8 * Wn + Dl);
                    }
                    class To {
                        constructor(Qe){
                            this.zoom = Qe.zoom, this.overscaling = Qe.overscaling, this.layers = Qe.layers, this.layerIds = this.layers.map((Qe)=>Qe.id), this.index = Qe.index, this.hasPattern = !1, this.layoutVertexArray = new Fs, this.indexArray = new Zs, this.segments = new Js, this.programConfigurations = new So(Qe.layers, Qe.zoom), this.stateDependentLayerIds = this.layers.filter((Qe)=>Qe.isStateDependent()).map((Qe)=>Qe.id);
                        }
                        populate(Qe, rt, Wn) {
                            const Co = this.layers[0], Dl = [];
                            let Ll = null, Rl = !1, Ul = "heatmap" === Co.type;
                            if ("circle" === Co.type) {
                                const Qe = Co;
                                Ll = Qe.layout.get("circle-sort-key"), Rl = !Ll.isConstant(), Ul = Ul || "map" === Qe.paint.get("circle-pitch-alignment");
                            }
                            const Gl = Ul ? rt.subdivisionGranularity.circle : 1;
                            for (const { feature: Zl, id: Hl, index: ql, sourceLayerIndex: Ql } of Qe){
                                const Qe = this.layers[0]._featureFilter.needGeometry, rt = Po(Zl, Qe);
                                if (!this.layers[0]._featureFilter.filter(new Bi(this.zoom), rt, Wn)) continue;
                                const Co = Rl ? Ll.evaluate(rt, {}, Wn) : void 0, Ul = {
                                    id: Hl,
                                    properties: Zl.properties,
                                    type: Zl.type,
                                    sourceLayerIndex: Ql,
                                    index: ql,
                                    geometry: Qe ? rt.geometry : zo(Zl),
                                    patterns: {},
                                    sortKey: Co
                                };
                                Dl.push(Ul);
                            }
                            Rl && Dl.sort((Qe, rt)=>Qe.sortKey - rt.sortKey);
                            for (const Zl of Dl){
                                const { geometry: Co, index: Dl, sourceLayerIndex: Ll } = Zl, Rl = Qe[Dl].feature;
                                this.addFeature(Zl, Co, Dl, Wn, Gl), rt.featureIndex.insert(Rl, Co, Dl, Ll, this.index);
                            }
                        }
                        update(Qe, rt, Wn) {
                            this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(Qe, rt, this.stateDependentLayers, Wn);
                        }
                        isEmpty() {
                            return 0 === this.layoutVertexArray.length;
                        }
                        uploadPending() {
                            return !this.uploaded || this.programConfigurations.needsUpload;
                        }
                        upload(Qe) {
                            this.uploaded || (this.layoutVertexBuffer = Qe.createVertexBuffer(this.layoutVertexArray, Jd), this.indexBuffer = Qe.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(Qe), this.uploaded = !0;
                        }
                        destroy() {
                            this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
                        }
                        addFeature(Qe, rt, Wn, Co, Dl) {
                            let Ll;
                            switch(void 0 === Dl && (Dl = 1), Dl){
                                case 1:
                                    Ll = [
                                        0,
                                        7
                                    ];
                                    break;
                                case 3:
                                    Ll = [
                                        0,
                                        2,
                                        5,
                                        7
                                    ];
                                    break;
                                case 5:
                                    Ll = [
                                        0,
                                        1,
                                        3,
                                        4,
                                        6,
                                        7
                                    ];
                                    break;
                                case 7:
                                    Ll = [
                                        0,
                                        1,
                                        2,
                                        3,
                                        4,
                                        5,
                                        6,
                                        7
                                    ];
                                    break;
                                default:
                                    throw new Error(`Invalid circle bucket granularity: ${Dl}; valid values are 1, 3, 5, 7.`);
                            }
                            const Rl = Ll.length;
                            for (const Ul of rt)for (const rt of Ul){
                                const Wn = rt.x, Co = rt.y;
                                if (Wn < 0 || Wn >= ql || Co < 0 || Co >= ql) continue;
                                const Dl = this.segments.prepareSegment(Rl * Rl, this.layoutVertexArray, this.indexArray, Qe.sortKey), Ul = Dl.vertexLength;
                                for(let Qe = 0; Qe < Rl; Qe++)for(let rt = 0; rt < Rl; rt++)Bo(this.layoutVertexArray, Wn, Co, Ll[rt], Ll[Qe]);
                                for(let Qe = 0; Qe < Rl - 1; Qe++)for(let rt = 0; rt < Rl - 1; rt++){
                                    const Wn = Ul + Qe * Rl + rt, Co = Ul + (Qe + 1) * Rl + rt;
                                    this.indexArray.emplaceBack(Wn, Co + 1, Wn + 1), this.indexArray.emplaceBack(Wn, Co, Co + 1);
                                }
                                Dl.vertexLength += Rl * Rl, Dl.primitiveLength += (Rl - 1) * (Rl - 1) * 2;
                            }
                            this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, Qe, Wn, {}, Co);
                        }
                    }
                    function Vo(Qe, rt) {
                        for(let Wn = 0; Wn < Qe.length; Wn++)if (jo(rt, Qe[Wn])) return !0;
                        for(let Wn = 0; Wn < rt.length; Wn++)if (jo(Qe, rt[Wn])) return !0;
                        return !!Lo(Qe, rt);
                    }
                    function Eo(Qe, rt, Wn) {
                        return !!jo(Qe, rt) || !!Oo(rt, Qe, Wn);
                    }
                    function Fo(Qe, rt) {
                        if (1 === Qe.length) return No(rt, Qe[0]);
                        for(let Wn = 0; Wn < rt.length; Wn++){
                            const Co = rt[Wn];
                            for(let rt = 0; rt < Co.length; rt++)if (jo(Qe, Co[rt])) return !0;
                        }
                        for(let Wn = 0; Wn < Qe.length; Wn++)if (No(rt, Qe[Wn])) return !0;
                        for(let Wn = 0; Wn < rt.length; Wn++)if (Lo(Qe, rt[Wn])) return !0;
                        return !1;
                    }
                    function Do(Qe, rt, Wn) {
                        if (Qe.length > 1) {
                            if (Lo(Qe, rt)) return !0;
                            for(let Co = 0; Co < rt.length; Co++)if (Oo(rt[Co], Qe, Wn)) return !0;
                        }
                        for(let Co = 0; Co < Qe.length; Co++)if (Oo(Qe[Co], rt, Wn)) return !0;
                        return !1;
                    }
                    function Lo(Qe, rt) {
                        if (0 === Qe.length || 0 === rt.length) return !1;
                        for(let Wn = 0; Wn < Qe.length - 1; Wn++){
                            const Co = Qe[Wn], Dl = Qe[Wn + 1];
                            for(let Qe = 0; Qe < rt.length - 1; Qe++)if ($o(Co, Dl, rt[Qe], rt[Qe + 1])) return !0;
                        }
                        return !1;
                    }
                    function $o(Qe, rt, Wn, Co) {
                        return _(Qe, Wn, Co) !== _(rt, Wn, Co) && _(Qe, rt, Wn) !== _(Qe, rt, Co);
                    }
                    function Oo(Qe, rt, Wn) {
                        const Co = Wn * Wn;
                        if (1 === rt.length) return Qe.distSqr(rt[0]) < Co;
                        for(let Dl = 1; Dl < rt.length; Dl++)if (Ro(Qe, rt[Dl - 1], rt[Dl]) < Co) return !0;
                        return !1;
                    }
                    function Ro(Qe, rt, Wn) {
                        const Co = rt.distSqr(Wn);
                        if (0 === Co) return Qe.distSqr(rt);
                        const Dl = ((Qe.x - rt.x) * (Wn.x - rt.x) + (Qe.y - rt.y) * (Wn.y - rt.y)) / Co;
                        return Qe.distSqr(Dl < 0 ? rt : Dl > 1 ? Wn : Wn.sub(rt)._mult(Dl)._add(rt));
                    }
                    function No(Qe, rt) {
                        for(let Wn = 0; Wn < Qe.length; Wn++)if (jo(Qe[Wn], rt)) return !0;
                        return !1;
                    }
                    function jo(Qe, rt) {
                        let Wn = !1;
                        for(let Co = 0, Dl = Qe.length - 1; Co < Qe.length; Dl = Co++){
                            const Ll = Qe[Co], Rl = Qe[Dl];
                            Ll.y > rt.y != Rl.y > rt.y && rt.x < (Rl.x - Ll.x) * (rt.y - Ll.y) / (Rl.y - Ll.y) + Ll.x && (Wn = !Wn);
                        }
                        return Wn;
                    }
                    function qo(Qe, rt, Wn) {
                        const Co = Wn[0], Dl = Wn[2];
                        if (Qe.x < Co.x && rt.x < Co.x || Qe.x > Dl.x && rt.x > Dl.x || Qe.y < Co.y && rt.y < Co.y || Qe.y > Dl.y && rt.y > Dl.y) return !1;
                        const Ll = _(Qe, rt, Wn[0]);
                        return Ll !== _(Qe, rt, Wn[1]) || Ll !== _(Qe, rt, Wn[2]) || Ll !== _(Qe, rt, Wn[3]);
                    }
                    function Uo(Qe, rt, Wn) {
                        const Co = rt.paint.get(Qe).value;
                        return "constant" === Co.kind ? Co.value : Wn.programConfigurations.get(rt.id).getMaxValue(Qe);
                    }
                    function Go(Qe) {
                        return Math.sqrt(Qe[0] * Qe[0] + Qe[1] * Qe[1]);
                    }
                    function Zo(Qe, rt, Wn, Co, Ll) {
                        if (!rt[0] && !rt[1]) return Qe;
                        const Rl = Dl.convert(rt)._mult(Ll);
                        "viewport" === Wn && Rl._rotate(-Co);
                        const Ul = [];
                        for(let Dl = 0; Dl < Qe.length; Dl++)Ul.push(Qe[Dl].sub(Rl));
                        return Ul;
                    }
                    let Tp, Cp;
                    Qn("CircleBucket", To, {
                        omit: [
                            "layers"
                        ]
                    });
                    var kp = {
                        get paint () {
                            return Cp = Cp || new Gi({
                                "circle-radius": new Ni(Tc.paint_circle["circle-radius"]),
                                "circle-color": new Ni(Tc.paint_circle["circle-color"]),
                                "circle-blur": new Ni(Tc.paint_circle["circle-blur"]),
                                "circle-opacity": new Ni(Tc.paint_circle["circle-opacity"]),
                                "circle-translate": new Ri(Tc.paint_circle["circle-translate"]),
                                "circle-translate-anchor": new Ri(Tc.paint_circle["circle-translate-anchor"]),
                                "circle-pitch-scale": new Ri(Tc.paint_circle["circle-pitch-scale"]),
                                "circle-pitch-alignment": new Ri(Tc.paint_circle["circle-pitch-alignment"]),
                                "circle-stroke-width": new Ni(Tc.paint_circle["circle-stroke-width"]),
                                "circle-stroke-color": new Ni(Tc.paint_circle["circle-stroke-color"]),
                                "circle-stroke-opacity": new Ni(Tc.paint_circle["circle-stroke-opacity"])
                            });
                        },
                        get layout () {
                            return Tp = Tp || new Gi({
                                "circle-sort-key": new Ni(Tc.layout_circle["circle-sort-key"])
                            });
                        }
                    };
                    class Jo extends Xi {
                        constructor(Qe){
                            super(Qe, kp);
                        }
                        createBucket(Qe) {
                            return new To(Qe);
                        }
                        queryRadius(Qe) {
                            const rt = Qe;
                            return Uo("circle-radius", this, rt) + Uo("circle-stroke-width", this, rt) + Go(this.paint.get("circle-translate"));
                        }
                        queryIntersectsFeature(Qe) {
                            let { queryGeometry: rt, feature: Wn, featureState: Co, geometry: Dl, transform: Ll, pixelsToTileUnits: Rl, unwrappedTileID: Ul, getElevation: Gl } = Qe;
                            const Zl = Zo(rt, this.paint.get("circle-translate"), this.paint.get("circle-translate-anchor"), -Ll.bearingInRadians, Rl), Hl = this.paint.get("circle-radius").evaluate(Wn, Co) + this.paint.get("circle-stroke-width").evaluate(Wn, Co), ql = "map" === this.paint.get("circle-pitch-alignment"), Ql = ql ? Zl : function(Qe, rt, Wn, Co) {
                                return Qe.map((Qe)=>Ko(Qe, rt, Wn, Co));
                            }(Zl, Ll, Ul, Gl), Kl = ql ? Hl * Rl : Hl;
                            for (const $l of Dl)for (const Qe of $l){
                                const rt = ql ? Qe : Ko(Qe, Ll, Ul, Gl);
                                let Wn = Kl;
                                const Co = Ll.projectTileCoordinates(Qe.x, Qe.y, Ul, Gl).signedDistanceFromCamera;
                                if ("viewport" === this.paint.get("circle-pitch-scale") && "map" === this.paint.get("circle-pitch-alignment") ? Wn *= Co / Ll.cameraToCenterDistance : "map" === this.paint.get("circle-pitch-scale") && "viewport" === this.paint.get("circle-pitch-alignment") && (Wn *= Ll.cameraToCenterDistance / Co), Eo(Ql, rt, Wn)) return !0;
                            }
                            return !1;
                        }
                    }
                    function Ko(Qe, rt, Wn, Co) {
                        const Ll = rt.projectTileCoordinates(Qe.x, Qe.y, Wn, Co).point;
                        return new Dl((.5 * Ll.x + .5) * rt.width, (.5 * -Ll.y + .5) * rt.height);
                    }
                    class Wo extends To {
                    }
                    let Ip;
                    Qn("HeatmapBucket", Wo, {
                        omit: [
                            "layers"
                        ]
                    });
                    var Dp = {
                        get paint () {
                            return Ip = Ip || new Gi({
                                "heatmap-radius": new Ni(Tc.paint_heatmap["heatmap-radius"]),
                                "heatmap-weight": new Ni(Tc.paint_heatmap["heatmap-weight"]),
                                "heatmap-intensity": new Ri(Tc.paint_heatmap["heatmap-intensity"]),
                                "heatmap-color": new Ui(Tc.paint_heatmap["heatmap-color"]),
                                "heatmap-opacity": new Ri(Tc.paint_heatmap["heatmap-opacity"])
                            });
                        }
                    };
                    function ea(Qe, rt, Wn, Co) {
                        let { width: Dl, height: Ll } = rt;
                        if (Co) {
                            if (Co instanceof Uint8ClampedArray) Co = new Uint8Array(Co.buffer);
                            else if (Co.length !== Dl * Ll * Wn) throw new RangeError(`mismatched image size. expected: ${Co.length} but got: ${Dl * Ll * Wn}`);
                        } else Co = new Uint8Array(Dl * Ll * Wn);
                        return Qe.width = Dl, Qe.height = Ll, Qe.data = Co, Qe;
                    }
                    function ra(Qe, rt, Wn) {
                        let { width: Co, height: Dl } = rt;
                        if (Co === Qe.width && Dl === Qe.height) return;
                        const Ll = ea({}, {
                            width: Co,
                            height: Dl
                        }, Wn);
                        na(Qe, Ll, {
                            x: 0,
                            y: 0
                        }, {
                            x: 0,
                            y: 0
                        }, {
                            width: Math.min(Qe.width, Co),
                            height: Math.min(Qe.height, Dl)
                        }, Wn), Qe.width = Co, Qe.height = Dl, Qe.data = Ll.data;
                    }
                    function na(Qe, rt, Wn, Co, Dl, Ll) {
                        if (0 === Dl.width || 0 === Dl.height) return rt;
                        if (Dl.width > Qe.width || Dl.height > Qe.height || Wn.x > Qe.width - Dl.width || Wn.y > Qe.height - Dl.height) throw new RangeError("out of range source coordinates for image copy");
                        if (Dl.width > rt.width || Dl.height > rt.height || Co.x > rt.width - Dl.width || Co.y > rt.height - Dl.height) throw new RangeError("out of range destination coordinates for image copy");
                        const Rl = Qe.data, Ul = rt.data;
                        if (Rl === Ul) throw new Error("srcData equals dstData, so image is already copied");
                        for(let Gl = 0; Gl < Dl.height; Gl++){
                            const Zl = ((Wn.y + Gl) * Qe.width + Wn.x) * Ll, Hl = ((Co.y + Gl) * rt.width + Co.x) * Ll;
                            for(let Qe = 0; Qe < Dl.width * Ll; Qe++)Ul[Hl + Qe] = Rl[Zl + Qe];
                        }
                        return rt;
                    }
                    class ia {
                        constructor(Qe, rt){
                            ea(this, Qe, 1, rt);
                        }
                        resize(Qe) {
                            ra(this, Qe, 1);
                        }
                        clone() {
                            return new ia({
                                width: this.width,
                                height: this.height
                            }, new Uint8Array(this.data));
                        }
                        static copy(Qe, rt, Wn, Co, Dl) {
                            na(Qe, rt, Wn, Co, Dl, 1);
                        }
                    }
                    class sa {
                        constructor(Qe, rt){
                            ea(this, Qe, 4, rt);
                        }
                        resize(Qe) {
                            ra(this, Qe, 4);
                        }
                        replace(Qe, rt) {
                            rt ? this.data.set(Qe) : this.data = Qe instanceof Uint8ClampedArray ? new Uint8Array(Qe.buffer) : Qe;
                        }
                        clone() {
                            return new sa({
                                width: this.width,
                                height: this.height
                            }, new Uint8Array(this.data));
                        }
                        static copy(Qe, rt, Wn, Co, Dl) {
                            na(Qe, rt, Wn, Co, Dl, 4);
                        }
                    }
                    Qn("AlphaImage", ia), Qn("RGBAImage", sa);
                    const Lp = "big-fb";
                    class aa extends Xi {
                        createBucket(Qe) {
                            return new Wo(Qe);
                        }
                        constructor(Qe){
                            super(Qe, Dp), this.heatmapFbos = new Map, this._updateColorRamp();
                        }
                        _handleSpecialPaintPropertyUpdate(Qe) {
                            "heatmap-color" === Qe && this._updateColorRamp();
                        }
                        _updateColorRamp() {
                            this.colorRamp = function(Qe) {
                                const rt = {}, Wn = Qe.resolution || 256, Co = Qe.clips ? Qe.clips.length : 1, Dl = Qe.image || new sa({
                                    width: Wn,
                                    height: Co
                                });
                                if (Math.log(Wn) / Math.LN2 % 1 != 0) throw new Error(`width is not a power of 2 - ${Wn}`);
                                const s = (Wn, Co, Ll)=>{
                                    rt[Qe.evaluationKey] = Ll;
                                    const Rl = Qe.expression.evaluate(rt);
                                    Dl.data[Wn + Co + 0] = Math.floor(255 * Rl.r / Rl.a), Dl.data[Wn + Co + 1] = Math.floor(255 * Rl.g / Rl.a), Dl.data[Wn + Co + 2] = Math.floor(255 * Rl.b / Rl.a), Dl.data[Wn + Co + 3] = Math.floor(255 * Rl.a);
                                };
                                if (Qe.clips) for(let Ll = 0, Rl = 0; Ll < Co; ++Ll, Rl += 4 * Wn)for(let rt = 0, Co = 0; rt < Wn; rt++, Co += 4){
                                    const Dl = rt / (Wn - 1), { start: Ul, end: Gl } = Qe.clips[Ll];
                                    s(Rl, Co, Ul * (1 - Dl) + Gl * Dl);
                                }
                                else for(let Ll = 0, Rl = 0; Ll < Wn; Ll++, Rl += 4)s(0, Rl, Ll / (Wn - 1));
                                return Dl;
                            }({
                                expression: this._transitionablePaint._values["heatmap-color"].value.expression,
                                evaluationKey: "heatmapDensity",
                                image: this.colorRamp
                            }), this.colorRampTexture = null;
                        }
                        resize() {
                            this.heatmapFbos.has(Lp) && this.heatmapFbos.delete(Lp);
                        }
                        queryRadius() {
                            return 0;
                        }
                        queryIntersectsFeature() {
                            return !1;
                        }
                        hasOffscreenPass() {
                            return 0 !== this.paint.get("heatmap-opacity") && "none" !== this.visibility;
                        }
                    }
                    let Pp;
                    var zp = {
                        get paint () {
                            return Pp = Pp || new Gi({
                                "hillshade-illumination-direction": new Ri(Tc.paint_hillshade["hillshade-illumination-direction"]),
                                "hillshade-illumination-anchor": new Ri(Tc.paint_hillshade["hillshade-illumination-anchor"]),
                                "hillshade-exaggeration": new Ri(Tc.paint_hillshade["hillshade-exaggeration"]),
                                "hillshade-shadow-color": new Ri(Tc.paint_hillshade["hillshade-shadow-color"]),
                                "hillshade-highlight-color": new Ri(Tc.paint_hillshade["hillshade-highlight-color"]),
                                "hillshade-accent-color": new Ri(Tc.paint_hillshade["hillshade-accent-color"])
                            });
                        }
                    };
                    class ca extends Xi {
                        constructor(Qe){
                            super(Qe, zp);
                        }
                        hasOffscreenPass() {
                            return 0 !== this.paint.get("hillshade-exaggeration") && "none" !== this.visibility;
                        }
                    }
                    const Np = Ki([
                        {
                            name: "a_pos",
                            components: 2,
                            type: "Int16"
                        }
                    ], 4), { members: Rp } = Np;
                    function fa(Qe, rt, Wn) {
                        const Co = Wn.patternDependencies;
                        let Dl = !1;
                        for (const Ll of rt){
                            const rt = Ll.paint.get(`${Qe}-pattern`);
                            rt.isConstant() || (Dl = !0);
                            const Wn = rt.constantOr(null);
                            Wn && (Dl = !0, Co[Wn.to] = !0, Co[Wn.from] = !0);
                        }
                        return Dl;
                    }
                    function da(Qe, rt, Wn, Co, Dl) {
                        const Ll = Dl.patternDependencies;
                        for (const Rl of rt){
                            const rt = Rl.paint.get(`${Qe}-pattern`).value;
                            if ("constant" !== rt.kind) {
                                let Qe = rt.evaluate({
                                    zoom: Co - 1
                                }, Wn, {}, Dl.availableImages), Ul = rt.evaluate({
                                    zoom: Co
                                }, Wn, {}, Dl.availableImages), Gl = rt.evaluate({
                                    zoom: Co + 1
                                }, Wn, {}, Dl.availableImages);
                                Qe = Qe && Qe.name ? Qe.name : Qe, Ul = Ul && Ul.name ? Ul.name : Ul, Gl = Gl && Gl.name ? Gl.name : Gl, Ll[Qe] = !0, Ll[Ul] = !0, Ll[Gl] = !0, Wn.patterns[Rl.id] = {
                                    min: Qe,
                                    mid: Ul,
                                    max: Gl
                                };
                            }
                        }
                        return Wn;
                    }
                    function ya(Qe, rt, Wn, Co, Dl) {
                        let Ll;
                        if (Dl === function(Qe, rt, Wn, Co) {
                            let Dl = 0;
                            for(let Ll = rt, Rl = Wn - Co; Ll < Wn; Ll += Co)Dl += (Qe[Rl] - Qe[Ll]) * (Qe[Ll + 1] + Qe[Rl + 1]), Rl = Ll;
                            return Dl;
                        }(Qe, rt, Wn, Co) > 0) for(let Rl = rt; Rl < Wn; Rl += Co)Ll = La(Rl / Co | 0, Qe[Rl], Qe[Rl + 1], Ll);
                        else for(let Rl = Wn - Co; Rl >= rt; Rl -= Co)Ll = La(Rl / Co | 0, Qe[Rl], Qe[Rl + 1], Ll);
                        return Ll && Ba(Ll, Ll.next) && ($a(Ll), Ll = Ll.next), Ll;
                    }
                    function ma(Qe, rt) {
                        if (!Qe) return Qe;
                        rt || (rt = Qe);
                        let Wn, Co = Qe;
                        do if (Wn = !1, Co.steiner || !Ba(Co, Co.next) && 0 !== Ca(Co.prev, Co, Co.next)) Co = Co.next;
                        else {
                            if ($a(Co), Co = rt = Co.prev, Co === Co.next) break;
                            Wn = !0;
                        }
                        while (Wn || Co !== rt);
                        return rt;
                    }
                    function ga(Qe, rt, Wn, Co, Dl, Ll, Rl) {
                        if (!Qe) return;
                        !Rl && Ll && function(Qe, rt, Wn, Co) {
                            let Dl = Qe;
                            do 0 === Dl.z && (Dl.z = Aa(Dl.x, Dl.y, rt, Wn, Co)), Dl.prevZ = Dl.prev, Dl.nextZ = Dl.next, Dl = Dl.next;
                            while (Dl !== Qe);
                            Dl.prevZ.nextZ = null, Dl.prevZ = null, function(Qe) {
                                let rt, Wn = 1;
                                do {
                                    let Co, Dl = Qe;
                                    Qe = null;
                                    let Ll = null;
                                    for(rt = 0; Dl;){
                                        rt++;
                                        let Rl = Dl, Ul = 0;
                                        for(let Qe = 0; Qe < Wn && (Ul++, Rl = Rl.nextZ, Rl); Qe++);
                                        let Gl = Wn;
                                        for(; Ul > 0 || Gl > 0 && Rl;)0 !== Ul && (0 === Gl || !Rl || Dl.z <= Rl.z) ? (Co = Dl, Dl = Dl.nextZ, Ul--) : (Co = Rl, Rl = Rl.nextZ, Gl--), Ll ? Ll.nextZ = Co : Qe = Co, Co.prevZ = Ll, Ll = Co;
                                        Dl = Rl;
                                    }
                                    Ll.nextZ = null, Wn *= 2;
                                }while (rt > 1);
                            }(Dl);
                        }(Qe, Co, Dl, Ll);
                        let Ul = Qe;
                        for(; Qe.prev !== Qe.next;){
                            const Gl = Qe.prev, Zl = Qe.next;
                            if (Ll ? va(Qe, Co, Dl, Ll) : xa(Qe)) rt.push(Gl.i, Qe.i, Zl.i), $a(Qe), Qe = Zl.next, Ul = Zl.next;
                            else if ((Qe = Zl) === Ul) {
                                Rl ? 1 === Rl ? ga(Qe = ba(ma(Qe), rt), rt, Wn, Co, Dl, Ll, 2) : 2 === Rl && wa(Qe, rt, Wn, Co, Dl, Ll) : ga(ma(Qe), rt, Wn, Co, Dl, Ll, 1);
                                break;
                            }
                        }
                    }
                    function xa(Qe) {
                        const rt = Qe.prev, Wn = Qe, Co = Qe.next;
                        if (Ca(rt, Wn, Co) >= 0) return !1;
                        const Dl = rt.x, Ll = Wn.x, Rl = Co.x, Ul = rt.y, Gl = Wn.y, Zl = Co.y, Hl = Math.min(Dl, Ll, Rl), ql = Math.min(Ul, Gl, Zl), Ql = Math.max(Dl, Ll, Rl), Kl = Math.max(Ul, Gl, Zl);
                        let $l = Co.next;
                        for(; $l !== rt;){
                            if ($l.x >= Hl && $l.x <= Ql && $l.y >= ql && $l.y <= Kl && za(Dl, Ul, Ll, Gl, Rl, Zl, $l.x, $l.y) && Ca($l.prev, $l, $l.next) >= 0) return !1;
                            $l = $l.next;
                        }
                        return !0;
                    }
                    function va(Qe, rt, Wn, Co) {
                        const Dl = Qe.prev, Ll = Qe, Rl = Qe.next;
                        if (Ca(Dl, Ll, Rl) >= 0) return !1;
                        const Ul = Dl.x, Gl = Ll.x, Zl = Rl.x, Hl = Dl.y, ql = Ll.y, Ql = Rl.y, Kl = Math.min(Ul, Gl, Zl), $l = Math.min(Hl, ql, Ql), Tc = Math.max(Ul, Gl, Zl), tu = Math.max(Hl, ql, Ql), lu = Aa(Kl, $l, rt, Wn, Co), du = Aa(Tc, tu, rt, Wn, Co);
                        let fu = Qe.prevZ, yu = Qe.nextZ;
                        for(; fu && fu.z >= lu && yu && yu.z <= du;){
                            if (fu.x >= Kl && fu.x <= Tc && fu.y >= $l && fu.y <= tu && fu !== Dl && fu !== Rl && za(Ul, Hl, Gl, ql, Zl, Ql, fu.x, fu.y) && Ca(fu.prev, fu, fu.next) >= 0) return !1;
                            if (fu = fu.prevZ, yu.x >= Kl && yu.x <= Tc && yu.y >= $l && yu.y <= tu && yu !== Dl && yu !== Rl && za(Ul, Hl, Gl, ql, Zl, Ql, yu.x, yu.y) && Ca(yu.prev, yu, yu.next) >= 0) return !1;
                            yu = yu.nextZ;
                        }
                        for(; fu && fu.z >= lu;){
                            if (fu.x >= Kl && fu.x <= Tc && fu.y >= $l && fu.y <= tu && fu !== Dl && fu !== Rl && za(Ul, Hl, Gl, ql, Zl, Ql, fu.x, fu.y) && Ca(fu.prev, fu, fu.next) >= 0) return !1;
                            fu = fu.prevZ;
                        }
                        for(; yu && yu.z <= du;){
                            if (yu.x >= Kl && yu.x <= Tc && yu.y >= $l && yu.y <= tu && yu !== Dl && yu !== Rl && za(Ul, Hl, Gl, ql, Zl, Ql, yu.x, yu.y) && Ca(yu.prev, yu, yu.next) >= 0) return !1;
                            yu = yu.nextZ;
                        }
                        return !0;
                    }
                    function ba(Qe, rt) {
                        let Wn = Qe;
                        do {
                            const Co = Wn.prev, Dl = Wn.next.next;
                            !Ba(Co, Dl) && Ta(Co, Wn, Wn.next, Dl) && Fa(Co, Dl) && Fa(Dl, Co) && (rt.push(Co.i, Wn.i, Dl.i), $a(Wn), $a(Wn.next), Wn = Qe = Dl), Wn = Wn.next;
                        }while (Wn !== Qe);
                        return ma(Wn);
                    }
                    function wa(Qe, rt, Wn, Co, Dl, Ll) {
                        let Rl = Qe;
                        do {
                            let Qe = Rl.next.next;
                            for(; Qe !== Rl.prev;){
                                if (Rl.i !== Qe.i && Pa(Rl, Qe)) {
                                    let Ul = Da(Rl, Qe);
                                    return Rl = ma(Rl, Rl.next), Ul = ma(Ul, Ul.next), ga(Rl, rt, Wn, Co, Dl, Ll, 0), void ga(Ul, rt, Wn, Co, Dl, Ll, 0);
                                }
                                Qe = Qe.next;
                            }
                            Rl = Rl.next;
                        }while (Rl !== Qe);
                    }
                    function _a(Qe, rt) {
                        let Wn = Qe.x - rt.x;
                        return 0 === Wn && (Wn = Qe.y - rt.y, 0 === Wn) && (Wn = (Qe.next.y - Qe.y) / (Qe.next.x - Qe.x) - (rt.next.y - rt.y) / (rt.next.x - rt.x)), Wn;
                    }
                    function Sa(Qe, rt) {
                        const Wn = function(Qe, rt) {
                            let Wn = rt;
                            const Co = Qe.x, Dl = Qe.y;
                            let Ll, Rl = -1 / 0;
                            if (Ba(Qe, Wn)) return Wn;
                            do {
                                if (Ba(Qe, Wn.next)) return Wn.next;
                                if (Dl <= Wn.y && Dl >= Wn.next.y && Wn.next.y !== Wn.y) {
                                    const Qe = Wn.x + (Dl - Wn.y) * (Wn.next.x - Wn.x) / (Wn.next.y - Wn.y);
                                    if (Qe <= Co && Qe > Rl && (Rl = Qe, Ll = Wn.x < Wn.next.x ? Wn : Wn.next, Qe === Co)) return Ll;
                                }
                                Wn = Wn.next;
                            }while (Wn !== rt);
                            if (!Ll) return null;
                            const Ul = Ll, Gl = Ll.x, Zl = Ll.y;
                            let Hl = 1 / 0;
                            Wn = Ll;
                            do {
                                if (Co >= Wn.x && Wn.x >= Gl && Co !== Wn.x && Ma(Dl < Zl ? Co : Rl, Dl, Gl, Zl, Dl < Zl ? Rl : Co, Dl, Wn.x, Wn.y)) {
                                    const rt = Math.abs(Dl - Wn.y) / (Co - Wn.x);
                                    Fa(Wn, Qe) && (rt < Hl || rt === Hl && (Wn.x > Ll.x || Wn.x === Ll.x && ka(Ll, Wn))) && (Ll = Wn, Hl = rt);
                                }
                                Wn = Wn.next;
                            }while (Wn !== Ul);
                            return Ll;
                        }(Qe, rt);
                        if (!Wn) return rt;
                        const Co = Da(Wn, Qe);
                        return ma(Co, Co.next), ma(Wn, Wn.next);
                    }
                    function ka(Qe, rt) {
                        return Ca(Qe.prev, Qe, rt.prev) < 0 && Ca(rt.next, Qe, Qe.next) < 0;
                    }
                    function Aa(Qe, rt, Wn, Co, Dl) {
                        return (Qe = 1431655765 & ((Qe = 858993459 & ((Qe = 252645135 & ((Qe = 16711935 & ((Qe = (Qe - Wn) * Dl | 0) | Qe << 8)) | Qe << 4)) | Qe << 2)) | Qe << 1)) | (rt = 1431655765 & ((rt = 858993459 & ((rt = 252645135 & ((rt = 16711935 & ((rt = (rt - Co) * Dl | 0) | rt << 8)) | rt << 4)) | rt << 2)) | rt << 1)) << 1;
                    }
                    function Ia(Qe) {
                        let rt = Qe, Wn = Qe;
                        do (rt.x < Wn.x || rt.x === Wn.x && rt.y < Wn.y) && (Wn = rt), rt = rt.next;
                        while (rt !== Qe);
                        return Wn;
                    }
                    function Ma(Qe, rt, Wn, Co, Dl, Ll, Rl, Ul) {
                        return (Dl - Rl) * (rt - Ul) >= (Qe - Rl) * (Ll - Ul) && (Qe - Rl) * (Co - Ul) >= (Wn - Rl) * (rt - Ul) && (Wn - Rl) * (Ll - Ul) >= (Dl - Rl) * (Co - Ul);
                    }
                    function za(Qe, rt, Wn, Co, Dl, Ll, Rl, Ul) {
                        return !(Qe === Rl && rt === Ul) && Ma(Qe, rt, Wn, Co, Dl, Ll, Rl, Ul);
                    }
                    function Pa(Qe, rt) {
                        return Qe.next.i !== rt.i && Qe.prev.i !== rt.i && !function(Qe, rt) {
                            let Wn = Qe;
                            do {
                                if (Wn.i !== Qe.i && Wn.next.i !== Qe.i && Wn.i !== rt.i && Wn.next.i !== rt.i && Ta(Wn, Wn.next, Qe, rt)) return !0;
                                Wn = Wn.next;
                            }while (Wn !== Qe);
                            return !1;
                        }(Qe, rt) && (Fa(Qe, rt) && Fa(rt, Qe) && function(Qe, rt) {
                            let Wn = Qe, Co = !1;
                            const Dl = (Qe.x + rt.x) / 2, Ll = (Qe.y + rt.y) / 2;
                            do Wn.y > Ll != Wn.next.y > Ll && Wn.next.y !== Wn.y && Dl < (Wn.next.x - Wn.x) * (Ll - Wn.y) / (Wn.next.y - Wn.y) + Wn.x && (Co = !Co), Wn = Wn.next;
                            while (Wn !== Qe);
                            return Co;
                        }(Qe, rt) && (Ca(Qe.prev, Qe, rt.prev) || Ca(Qe, rt.prev, rt)) || Ba(Qe, rt) && Ca(Qe.prev, Qe, Qe.next) > 0 && Ca(rt.prev, rt, rt.next) > 0);
                    }
                    function Ca(Qe, rt, Wn) {
                        return (rt.y - Qe.y) * (Wn.x - rt.x) - (rt.x - Qe.x) * (Wn.y - rt.y);
                    }
                    function Ba(Qe, rt) {
                        return Qe.x === rt.x && Qe.y === rt.y;
                    }
                    function Ta(Qe, rt, Wn, Co) {
                        const Dl = Ea(Ca(Qe, rt, Wn)), Ll = Ea(Ca(Qe, rt, Co)), Rl = Ea(Ca(Wn, Co, Qe)), Ul = Ea(Ca(Wn, Co, rt));
                        return Dl !== Ll && Rl !== Ul || !(0 !== Dl || !Va(Qe, Wn, rt)) || !(0 !== Ll || !Va(Qe, Co, rt)) || !(0 !== Rl || !Va(Wn, Qe, Co)) || !(0 !== Ul || !Va(Wn, rt, Co));
                    }
                    function Va(Qe, rt, Wn) {
                        return rt.x <= Math.max(Qe.x, Wn.x) && rt.x >= Math.min(Qe.x, Wn.x) && rt.y <= Math.max(Qe.y, Wn.y) && rt.y >= Math.min(Qe.y, Wn.y);
                    }
                    function Ea(Qe) {
                        return Qe > 0 ? 1 : Qe < 0 ? -1 : 0;
                    }
                    function Fa(Qe, rt) {
                        return Ca(Qe.prev, Qe, Qe.next) < 0 ? Ca(Qe, rt, Qe.next) >= 0 && Ca(Qe, Qe.prev, rt) >= 0 : Ca(Qe, rt, Qe.prev) < 0 || Ca(Qe, Qe.next, rt) < 0;
                    }
                    function Da(Qe, rt) {
                        const Wn = Oa(Qe.i, Qe.x, Qe.y), Co = Oa(rt.i, rt.x, rt.y), Dl = Qe.next, Ll = rt.prev;
                        return Qe.next = rt, rt.prev = Qe, Wn.next = Dl, Dl.prev = Wn, Co.next = Wn, Wn.prev = Co, Ll.next = Co, Co.prev = Ll, Co;
                    }
                    function La(Qe, rt, Wn, Co) {
                        const Dl = Oa(Qe, rt, Wn);
                        return Co ? (Dl.next = Co.next, Dl.prev = Co, Co.next.prev = Dl, Co.next = Dl) : (Dl.prev = Dl, Dl.next = Dl), Dl;
                    }
                    function $a(Qe) {
                        Qe.next.prev = Qe.prev, Qe.prev.next = Qe.next, Qe.prevZ && (Qe.prevZ.nextZ = Qe.nextZ), Qe.nextZ && (Qe.nextZ.prevZ = Qe.prevZ);
                    }
                    function Oa(Qe, rt, Wn) {
                        return {
                            i: Qe,
                            x: rt,
                            y: Wn,
                            prev: null,
                            next: null,
                            z: 0,
                            prevZ: null,
                            nextZ: null,
                            steiner: !1
                        };
                    }
                    class Ra {
                        constructor(Qe, rt){
                            if (rt > Qe) throw new Error("Min granularity must not be greater than base granularity.");
                            this._baseZoomGranularity = Qe, this._minGranularity = rt;
                        }
                        getGranularityForZoomLevel(Qe) {
                            return Math.max(Math.floor(this._baseZoomGranularity / (1 << Qe)), this._minGranularity, 1);
                        }
                    }
                    class Na {
                        constructor(Qe){
                            this.fill = Qe.fill, this.line = Qe.line, this.tile = Qe.tile, this.stencil = Qe.stencil, this.circle = Qe.circle;
                        }
                    }
                    Na.noSubdivision = new Na({
                        fill: new Ra(0, 0),
                        line: new Ra(0, 0),
                        tile: new Ra(0, 0),
                        stencil: new Ra(0, 0),
                        circle: 1
                    }), Qn("SubdivisionGranularityExpression", Ra), Qn("SubdivisionGranularitySetting", Na);
                    const Bp = -32768, Op = 32767;
                    class Ua {
                        constructor(Qe, rt){
                            this._vertexBuffer = [], this._vertexDictionary = new Map, this._used = !1, this._granularity = Qe, this._granularityCellSize = ql / Qe, this._canonical = rt;
                        }
                        _getKey(Qe, rt) {
                            return (Qe += 32768) << 16 | (rt += 32768);
                        }
                        _vertexToIndex(Qe, rt) {
                            if (Qe < -32768 || rt < -32768 || Qe > 32767 || rt > 32767) throw new Error("Vertex coordinates are out of signed 16 bit integer range.");
                            const Wn = 0 | Math.round(Qe), Co = 0 | Math.round(rt), Dl = this._getKey(Wn, Co);
                            if (this._vertexDictionary.has(Dl)) return this._vertexDictionary.get(Dl);
                            const Ll = this._vertexBuffer.length / 2;
                            return this._vertexDictionary.set(Dl, Ll), this._vertexBuffer.push(Wn, Co), Ll;
                        }
                        _subdivideTrianglesScanline(Qe) {
                            if (this._granularity < 2) return function(Qe, rt) {
                                const Wn = [];
                                for(let Co = 0; Co < rt.length; Co += 3){
                                    const Dl = rt[Co], Ll = rt[Co + 1], Rl = rt[Co + 2], Ul = Qe[2 * Dl], Gl = Qe[2 * Dl + 1];
                                    (Qe[2 * Ll] - Ul) * (Qe[2 * Rl + 1] - Gl) - (Qe[2 * Ll + 1] - Gl) * (Qe[2 * Rl] - Ul) > 0 ? (Wn.push(Dl), Wn.push(Rl), Wn.push(Ll)) : (Wn.push(Dl), Wn.push(Ll), Wn.push(Rl));
                                }
                                return Wn;
                            }(this._vertexBuffer, Qe);
                            const rt = [], Wn = Qe.length;
                            for(let Co = 0; Co < Wn; Co += 3){
                                const Wn = [
                                    Qe[Co + 0],
                                    Qe[Co + 1],
                                    Qe[Co + 2]
                                ], Dl = [
                                    this._vertexBuffer[2 * Qe[Co + 0] + 0],
                                    this._vertexBuffer[2 * Qe[Co + 0] + 1],
                                    this._vertexBuffer[2 * Qe[Co + 1] + 0],
                                    this._vertexBuffer[2 * Qe[Co + 1] + 1],
                                    this._vertexBuffer[2 * Qe[Co + 2] + 0],
                                    this._vertexBuffer[2 * Qe[Co + 2] + 1]
                                ];
                                let Ll = 1 / 0, Rl = 1 / 0, Ul = -1 / 0, Gl = -1 / 0;
                                for(let Qe = 0; Qe < 3; Qe++){
                                    const rt = Dl[2 * Qe], Wn = Dl[2 * Qe + 1];
                                    Ll = Math.min(Ll, rt), Ul = Math.max(Ul, rt), Rl = Math.min(Rl, Wn), Gl = Math.max(Gl, Wn);
                                }
                                if (Ll === Ul || Rl === Gl) continue;
                                const Zl = Math.floor(Ll / this._granularityCellSize), Hl = Math.ceil(Ul / this._granularityCellSize), ql = Math.floor(Rl / this._granularityCellSize), Ql = Math.ceil(Gl / this._granularityCellSize);
                                if (Zl !== Hl || ql !== Ql) for(let Qe = ql; Qe < Ql; Qe++){
                                    const Co = this._scanlineGenerateVertexRingForCellRow(Qe, Dl, Wn);
                                    Xa(this._vertexBuffer, Co, rt);
                                }
                                else rt.push(...Wn);
                            }
                            return rt;
                        }
                        _scanlineGenerateVertexRingForCellRow(Qe, rt, Wn) {
                            const Co = Qe * this._granularityCellSize, Dl = Co + this._granularityCellSize, Ll = [];
                            for(let Rl = 0; Rl < 3; Rl++){
                                const Qe = rt[2 * Rl], Ul = rt[2 * Rl + 1], Gl = rt[2 * (Rl + 1) % 6], Zl = rt[(2 * (Rl + 1) + 1) % 6], Hl = rt[2 * (Rl + 2) % 6], ql = rt[(2 * (Rl + 2) + 1) % 6], Ql = Gl - Qe, Kl = Zl - Ul, $l = 0 === Ql, Tc = 0 === Kl, tu = (Co - Ul) / Kl, lu = (Dl - Ul) / Kl, du = Math.min(tu, lu), fu = Math.max(tu, lu);
                                if (!Tc && (du >= 1 || fu <= 0) || Tc && (Ul < Co || Ul > Dl)) {
                                    Zl >= Co && Zl <= Dl && Ll.push(Wn[(Rl + 1) % 3]);
                                    continue;
                                }
                                !Tc && du > 0 && Ll.push(this._vertexToIndex(Qe + Ql * du, Ul + Kl * du));
                                const yu = Qe + Ql * Math.max(du, 0), Eu = Qe + Ql * Math.min(fu, 1);
                                $l || this._generateIntraEdgeVertices(Ll, Qe, Ul, Gl, Zl, yu, Eu), !Tc && fu < 1 && Ll.push(this._vertexToIndex(Qe + Ql * fu, Ul + Kl * fu)), (Tc || Zl >= Co && Zl <= Dl) && Ll.push(Wn[(Rl + 1) % 3]), !Tc && (Zl <= Co || Zl >= Dl) && this._generateInterEdgeVertices(Ll, Qe, Ul, Gl, Zl, Hl, ql, Eu, Co, Dl);
                            }
                            return Ll;
                        }
                        _generateIntraEdgeVertices(Qe, rt, Wn, Co, Dl, Ll, Rl) {
                            const Ul = Co - rt, Gl = Dl - Wn, Zl = 0 === Gl, Hl = Zl ? Math.min(rt, Co) : Math.min(Ll, Rl), ql = Zl ? Math.max(rt, Co) : Math.max(Ll, Rl), Ql = Math.floor(Hl / this._granularityCellSize) + 1, Kl = Math.ceil(ql / this._granularityCellSize) - 1;
                            if (Zl ? rt < Co : Ll < Rl) for(let $l = Ql; $l <= Kl; $l++){
                                const Co = $l * this._granularityCellSize;
                                Qe.push(this._vertexToIndex(Co, Wn + Gl * (Co - rt) / Ul));
                            }
                            else for(let $l = Kl; $l >= Ql; $l--){
                                const Co = $l * this._granularityCellSize;
                                Qe.push(this._vertexToIndex(Co, Wn + Gl * (Co - rt) / Ul));
                            }
                        }
                        _generateInterEdgeVertices(Qe, rt, Wn, Co, Dl, Ll, Rl, Ul, Gl, Zl) {
                            const Hl = Dl - Wn, ql = Ll - Co, Ql = Rl - Dl, Kl = (Gl - Dl) / Ql, $l = (Zl - Dl) / Ql, Tc = Math.min(Kl, $l), tu = Math.max(Kl, $l), lu = Co + ql * Tc;
                            let du = Math.floor(Math.min(lu, Ul) / this._granularityCellSize) + 1, fu = Math.ceil(Math.max(lu, Ul) / this._granularityCellSize) - 1, yu = Ul < lu;
                            const Eu = 0 === Ql;
                            if (Eu && (Rl === Gl || Rl === Zl)) return;
                            if (Eu || Tc >= 1 || tu <= 0) {
                                const Qe = Wn - Rl, Co = Ll + (rt - Ll) * Math.min((Gl - Rl) / Qe, (Zl - Rl) / Qe);
                                du = Math.floor(Math.min(Co, Ul) / this._granularityCellSize) + 1, fu = Math.ceil(Math.max(Co, Ul) / this._granularityCellSize) - 1, yu = Ul < Co;
                            }
                            const Tu = Hl > 0 ? Zl : Gl;
                            if (yu) for(let Lu = du; Lu <= fu; Lu++)Qe.push(this._vertexToIndex(Lu * this._granularityCellSize, Tu));
                            else for(let Lu = fu; Lu >= du; Lu--)Qe.push(this._vertexToIndex(Lu * this._granularityCellSize, Tu));
                        }
                        _generateOutline(Qe) {
                            const rt = [];
                            for (const Wn of Qe){
                                const Qe = Za(Wn, this._granularity, !0), Co = this._pointArrayToIndices(Qe), Dl = [];
                                for(let rt = 1; rt < Co.length; rt++)Dl.push(Co[rt - 1]), Dl.push(Co[rt]);
                                rt.push(Dl);
                            }
                            return rt;
                        }
                        _handlePoles(Qe) {
                            let rt = !1, Wn = !1;
                            this._canonical && (0 === this._canonical.y && (rt = !0), this._canonical.y === (1 << this._canonical.z) - 1 && (Wn = !0)), (rt || Wn) && this._fillPoles(Qe, rt, Wn);
                        }
                        _ensureNoPoleVertices() {
                            const Qe = this._vertexBuffer;
                            for(let rt = 0; rt < Qe.length; rt += 2){
                                const Wn = Qe[rt + 1];
                                Wn === Bp && (Qe[rt + 1] = -32767), Wn === Op && (Qe[rt + 1] = 32766);
                            }
                        }
                        _generatePoleQuad(Qe, rt, Wn, Co, Dl, Ll) {
                            Co > Dl != (Ll === Bp) ? (Qe.push(rt), Qe.push(Wn), Qe.push(this._vertexToIndex(Co, Ll)), Qe.push(Wn), Qe.push(this._vertexToIndex(Dl, Ll)), Qe.push(this._vertexToIndex(Co, Ll))) : (Qe.push(Wn), Qe.push(rt), Qe.push(this._vertexToIndex(Co, Ll)), Qe.push(this._vertexToIndex(Dl, Ll)), Qe.push(Wn), Qe.push(this._vertexToIndex(Co, Ll)));
                        }
                        _fillPoles(Qe, rt, Wn) {
                            const Co = this._vertexBuffer, Dl = ql, Ll = Qe.length;
                            for(let Rl = 2; Rl < Ll; Rl += 3){
                                const Ll = Qe[Rl - 2], Ul = Qe[Rl - 1], Gl = Qe[Rl], Zl = Co[2 * Ll], Hl = Co[2 * Ll + 1], ql = Co[2 * Ul], Ql = Co[2 * Ul + 1], Kl = Co[2 * Gl], $l = Co[2 * Gl + 1];
                                rt && (0 === Hl && 0 === Ql && this._generatePoleQuad(Qe, Ll, Ul, Zl, ql, Bp), 0 === Ql && 0 === $l && this._generatePoleQuad(Qe, Ul, Gl, ql, Kl, Bp), 0 === $l && 0 === Hl && this._generatePoleQuad(Qe, Gl, Ll, Kl, Zl, Bp)), Wn && (Hl === Dl && Ql === Dl && this._generatePoleQuad(Qe, Ll, Ul, Zl, ql, Op), Ql === Dl && $l === Dl && this._generatePoleQuad(Qe, Ul, Gl, ql, Kl, Op), $l === Dl && Hl === Dl && this._generatePoleQuad(Qe, Gl, Ll, Kl, Zl, Op));
                            }
                        }
                        _initializeVertices(Qe) {
                            for(let rt = 0; rt < Qe.length; rt += 2)this._vertexToIndex(Qe[rt], Qe[rt + 1]);
                        }
                        subdividePolygonInternal(Qe, rt) {
                            if (this._used) throw new Error("Subdivision: multiple use not allowed.");
                            this._used = !0;
                            const { flattened: Wn, holeIndices: Co } = function(Qe) {
                                const rt = [], Wn = [];
                                for (const Co of Qe)if (0 !== Co.length) {
                                    Co !== Qe[0] && rt.push(Wn.length / 2);
                                    for(let Qe = 0; Qe < Co.length; Qe++)Wn.push(Co[Qe].x), Wn.push(Co[Qe].y);
                                }
                                return {
                                    flattened: Wn,
                                    holeIndices: rt
                                };
                            }(Qe);
                            let Dl;
                            this._initializeVertices(Wn);
                            try {
                                const Qe = function(Qe, rt, Wn) {
                                    void 0 === Wn && (Wn = 2);
                                    const Co = rt && rt.length, Dl = Co ? rt[0] * Wn : Qe.length;
                                    let Ll = ya(Qe, 0, Dl, Wn, !0);
                                    const Rl = [];
                                    if (!Ll || Ll.next === Ll.prev) return Rl;
                                    let Ul, Gl, Zl;
                                    if (Co && (Ll = function(Qe, rt, Wn, Co) {
                                        const Dl = [];
                                        for(let Ll = 0, Rl = rt.length; Ll < Rl; Ll++){
                                            const Wn = ya(Qe, rt[Ll] * Co, Ll < Rl - 1 ? rt[Ll + 1] * Co : Qe.length, Co, !1);
                                            Wn === Wn.next && (Wn.steiner = !0), Dl.push(Ia(Wn));
                                        }
                                        Dl.sort(_a);
                                        for(let Ll = 0; Ll < Dl.length; Ll++)Wn = Sa(Dl[Ll], Wn);
                                        return Wn;
                                    }(Qe, rt, Ll, Wn)), Qe.length > 80 * Wn) {
                                        Ul = 1 / 0, Gl = 1 / 0;
                                        let rt = -1 / 0, Co = -1 / 0;
                                        for(let Ll = Wn; Ll < Dl; Ll += Wn){
                                            const Wn = Qe[Ll], Dl = Qe[Ll + 1];
                                            Wn < Ul && (Ul = Wn), Dl < Gl && (Gl = Dl), Wn > rt && (rt = Wn), Dl > Co && (Co = Dl);
                                        }
                                        Zl = Math.max(rt - Ul, Co - Gl), Zl = 0 !== Zl ? 32767 / Zl : 0;
                                    }
                                    return ga(Ll, Rl, Wn, Ul, Gl, Zl, 0), Rl;
                                }(Wn, Co), rt = this._convertIndices(Wn, Qe);
                                Dl = this._subdivideTrianglesScanline(rt);
                            } catch (Qe) {
                                console.error(Qe);
                            }
                            let Ll = [];
                            return rt && (Ll = this._generateOutline(Qe)), this._ensureNoPoleVertices(), this._handlePoles(Dl), {
                                verticesFlattened: this._vertexBuffer,
                                indicesTriangles: Dl,
                                indicesLineList: Ll
                            };
                        }
                        _convertIndices(Qe, rt) {
                            const Wn = [];
                            for(let Co = 0; Co < rt.length; Co++)Wn.push(this._vertexToIndex(Qe[2 * rt[Co]], Qe[2 * rt[Co] + 1]));
                            return Wn;
                        }
                        _pointArrayToIndices(Qe) {
                            const rt = [];
                            for(let Wn = 0; Wn < Qe.length; Wn++){
                                const Co = Qe[Wn];
                                rt.push(this._vertexToIndex(Co.x, Co.y));
                            }
                            return rt;
                        }
                    }
                    function Ga(Qe, rt, Wn, Co) {
                        return void 0 === Co && (Co = !0), new Ua(Wn, rt).subdividePolygonInternal(Qe, Co);
                    }
                    function Za(Qe, rt, Wn) {
                        if (void 0 === Wn && (Wn = !1), !Qe || Qe.length < 1) return [];
                        if (Qe.length < 2) return [];
                        const Co = Qe[0], Ll = Qe[Qe.length - 1], Rl = Wn && (Co.x !== Ll.x || Co.y !== Ll.y);
                        if (rt < 2) return Rl ? [
                            ...Qe,
                            Qe[0]
                        ] : [
                            ...Qe
                        ];
                        const Ul = Math.floor(ql / rt), Gl = [];
                        Gl.push(new Dl(Qe[0].x, Qe[0].y));
                        const Zl = Qe.length, Hl = Rl ? Zl : Zl - 1;
                        for(let ql = 0; ql < Hl; ql++){
                            const rt = Qe[ql], Wn = ql < Zl - 1 ? Qe[ql + 1] : Qe[0], Co = rt.x, Ll = rt.y, Rl = Wn.x, Hl = Wn.y, Ql = Co !== Rl, Kl = Ll !== Hl;
                            if (!Ql && !Kl) continue;
                            const $l = Rl - Co, Tc = Hl - Ll, tu = Math.abs($l), lu = Math.abs(Tc);
                            let du = Co, fu = Ll;
                            for(;;){
                                const Qe = $l > 0 ? (Math.floor(du / Ul) + 1) * Ul : (Math.ceil(du / Ul) - 1) * Ul, rt = Tc > 0 ? (Math.floor(fu / Ul) + 1) * Ul : (Math.ceil(fu / Ul) - 1) * Ul, Wn = Math.abs(du - Qe), Co = Math.abs(fu - rt), Ll = Math.abs(du - Rl), Zl = Math.abs(fu - Hl), ql = Ql ? Wn / tu : Number.POSITIVE_INFINITY, yu = Kl ? Co / lu : Number.POSITIVE_INFINITY;
                                if ((Ll <= Wn || !Ql) && (Zl <= Co || !Kl)) break;
                                if (ql < yu && Ql || !Kl) {
                                    du = Qe, fu += Tc * ql;
                                    const rt = new Dl(du, Math.round(fu));
                                    Gl[Gl.length - 1].x === rt.x && Gl[Gl.length - 1].y === rt.y || Gl.push(rt);
                                } else {
                                    du += $l * yu, fu = rt;
                                    const Qe = new Dl(Math.round(du), fu);
                                    Gl[Gl.length - 1].x === Qe.x && Gl[Gl.length - 1].y === Qe.y || Gl.push(Qe);
                                }
                            }
                            const yu = new Dl(Rl, Hl);
                            Gl[Gl.length - 1].x === yu.x && Gl[Gl.length - 1].y === yu.y || Gl.push(yu);
                        }
                        return Gl;
                    }
                    function Xa(Qe, rt, Wn) {
                        if (0 === rt.length) throw new Error("Subdivision vertex ring is empty.");
                        let Co = 0, Dl = Qe[2 * rt[0]];
                        for(let Gl = 1; Gl < rt.length; Gl++){
                            const Wn = Qe[2 * rt[Gl]];
                            Wn < Dl && (Dl = Wn, Co = Gl);
                        }
                        const Ll = rt.length;
                        let Rl = Co, Ul = (Rl + 1) % Ll;
                        for(;;){
                            const Co = Rl - 1 >= 0 ? Rl - 1 : Ll - 1, Dl = (Ul + 1) % Ll, Gl = Qe[2 * rt[Co]], Zl = Qe[2 * rt[Dl]], Hl = Qe[2 * rt[Rl]], ql = Qe[2 * rt[Rl] + 1], Ql = Qe[2 * rt[Ul] + 1];
                            let Kl = !1;
                            if (Gl < Zl) Kl = !0;
                            else if (Gl > Zl) Kl = !1;
                            else {
                                const Wn = Ql - ql, Ll = -(Qe[2 * rt[Ul]] - Hl), Rl = ql < Ql ? 1 : -1;
                                ((Gl - Hl) * Wn + (Qe[2 * rt[Co] + 1] - ql) * Ll) * Rl > ((Zl - Hl) * Wn + (Qe[2 * rt[Dl] + 1] - ql) * Ll) * Rl && (Kl = !0);
                            }
                            if (Kl) {
                                const Qe = rt[Co], Dl = rt[Rl], Gl = rt[Ul];
                                Qe !== Dl && Qe !== Gl && Dl !== Gl && Wn.push(Gl, Dl, Qe), Rl--, Rl < 0 && (Rl = Ll - 1);
                            } else {
                                const Qe = rt[Dl], Co = rt[Rl], Gl = rt[Ul];
                                Qe !== Co && Qe !== Gl && Co !== Gl && Wn.push(Gl, Co, Qe), Ul++, Ul >= Ll && (Ul = 0);
                            }
                            if (Co === Dl) break;
                        }
                    }
                    function Ha(Qe, rt, Wn, Co, Dl, Ll, Rl, Ul, Gl) {
                        const Zl = Dl.length / 2, Hl = Rl && Ul && Gl;
                        if (Zl < Js.MAX_VERTEX_ARRAY_LENGTH) {
                            const ql = rt.prepareSegment(Zl, Wn, Co), Ql = ql.vertexLength;
                            for(let Qe = 0; Qe < Ll.length; Qe += 3)Co.emplaceBack(Ql + Ll[Qe], Ql + Ll[Qe + 1], Ql + Ll[Qe + 2]);
                            let Kl, $l;
                            ql.vertexLength += Zl, ql.primitiveLength += Ll.length / 3, Hl && ($l = Rl.prepareSegment(Zl, Wn, Ul), Kl = $l.vertexLength, $l.vertexLength += Zl);
                            for(let rt = 0; rt < Dl.length; rt += 2)Qe(Dl[rt], Dl[rt + 1]);
                            if (Hl) for(let Qe = 0; Qe < Gl.length; Qe++){
                                const rt = Gl[Qe];
                                for(let Qe = 1; Qe < rt.length; Qe += 2)Ul.emplaceBack(Kl + rt[Qe - 1], Kl + rt[Qe]);
                                $l.primitiveLength += rt.length / 2;
                            }
                        } else !function(Qe, rt, Wn, Co, Dl, Ll) {
                            const Rl = [];
                            for(let ql = 0; ql < Co.length / 2; ql++)Rl.push(-1);
                            const Ul = {
                                count: 0
                            };
                            let Gl = 0, Zl = Qe.getOrCreateLatestSegment(rt, Wn), Hl = Zl.vertexLength;
                            for(let ql = 2; ql < Dl.length; ql += 3){
                                const Ql = Dl[ql - 2], Kl = Dl[ql - 1], $l = Dl[ql];
                                let Tc = Rl[Ql] < Gl, tu = Rl[Kl] < Gl, lu = Rl[$l] < Gl;
                                Zl.vertexLength + ((Tc ? 1 : 0) + (tu ? 1 : 0) + (lu ? 1 : 0)) > Js.MAX_VERTEX_ARRAY_LENGTH && (Zl = Qe.createNewSegment(rt, Wn), Gl = Ul.count, Tc = !0, tu = !0, lu = !0, Hl = 0);
                                const du = Ya(Rl, Co, Ll, Ul, Ql, Tc, Zl), fu = Ya(Rl, Co, Ll, Ul, Kl, tu, Zl), yu = Ya(Rl, Co, Ll, Ul, $l, lu, Zl);
                                Wn.emplaceBack(Hl + du - Gl, Hl + fu - Gl, Hl + yu - Gl), Zl.primitiveLength++;
                            }
                        }(rt, Wn, Co, Dl, Ll, Qe), Hl && function(Qe, rt, Wn, Co, Dl, Ll) {
                            const Rl = [];
                            for(let ql = 0; ql < Co.length / 2; ql++)Rl.push(-1);
                            const Ul = {
                                count: 0
                            };
                            let Gl = 0, Zl = Qe.getOrCreateLatestSegment(rt, Wn), Hl = Zl.vertexLength;
                            for(let ql = 0; ql < Dl.length; ql++){
                                const Ql = Dl[ql];
                                for(let Kl = 1; Kl < Dl[ql].length; Kl += 2){
                                    const Dl = Ql[Kl - 1], ql = Ql[Kl];
                                    let $l = Rl[Dl] < Gl, Tc = Rl[ql] < Gl;
                                    Zl.vertexLength + (($l ? 1 : 0) + (Tc ? 1 : 0)) > Js.MAX_VERTEX_ARRAY_LENGTH && (Zl = Qe.createNewSegment(rt, Wn), Gl = Ul.count, $l = !0, Tc = !0, Hl = 0);
                                    const tu = Ya(Rl, Co, Ll, Ul, Dl, $l, Zl), lu = Ya(Rl, Co, Ll, Ul, ql, Tc, Zl);
                                    Wn.emplaceBack(Hl + tu - Gl, Hl + lu - Gl), Zl.primitiveLength++;
                                }
                            }
                        }(Rl, Wn, Ul, Dl, Gl, Qe), rt.forceNewSegmentOnNextPrepare(), null == Rl || Rl.forceNewSegmentOnNextPrepare();
                    }
                    function Ya(Qe, rt, Wn, Co, Dl, Ll, Rl) {
                        if (Ll) {
                            const Ll = Co.count;
                            return Wn(rt[2 * Dl], rt[2 * Dl + 1]), Qe[Dl] = Co.count, Co.count++, Rl.vertexLength++, Ll;
                        }
                        return Qe[Dl];
                    }
                    class Ja {
                        constructor(Qe){
                            this.zoom = Qe.zoom, this.overscaling = Qe.overscaling, this.layers = Qe.layers, this.layerIds = this.layers.map((Qe)=>Qe.id), this.index = Qe.index, this.hasPattern = !1, this.patternFeatures = [], this.layoutVertexArray = new Ds, this.indexArray = new Zs, this.indexArray2 = new Xs, this.programConfigurations = new So(Qe.layers, Qe.zoom), this.segments = new Js, this.segments2 = new Js, this.stateDependentLayerIds = this.layers.filter((Qe)=>Qe.isStateDependent()).map((Qe)=>Qe.id);
                        }
                        populate(Qe, rt, Wn) {
                            this.hasPattern = fa("fill", this.layers, rt);
                            const Co = this.layers[0].layout.get("fill-sort-key"), Dl = !Co.isConstant(), Ll = [];
                            for (const { feature: Rl, id: Ul, index: Gl, sourceLayerIndex: Zl } of Qe){
                                const Qe = this.layers[0]._featureFilter.needGeometry, Hl = Po(Rl, Qe);
                                if (!this.layers[0]._featureFilter.filter(new Bi(this.zoom), Hl, Wn)) continue;
                                const ql = Dl ? Co.evaluate(Hl, {}, Wn, rt.availableImages) : void 0, Ql = {
                                    id: Ul,
                                    properties: Rl.properties,
                                    type: Rl.type,
                                    sourceLayerIndex: Zl,
                                    index: Gl,
                                    geometry: Qe ? Hl.geometry : zo(Rl),
                                    patterns: {},
                                    sortKey: ql
                                };
                                Ll.push(Ql);
                            }
                            Dl && Ll.sort((Qe, rt)=>Qe.sortKey - rt.sortKey);
                            for (const Rl of Ll){
                                const { geometry: Co, index: Dl, sourceLayerIndex: Ll } = Rl;
                                if (this.hasPattern) {
                                    const Qe = da("fill", this.layers, Rl, this.zoom, rt);
                                    this.patternFeatures.push(Qe);
                                } else this.addFeature(Rl, Co, Dl, Wn, {}, rt.subdivisionGranularity);
                                rt.featureIndex.insert(Qe[Dl].feature, Co, Dl, Ll, this.index);
                            }
                        }
                        update(Qe, rt, Wn) {
                            this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(Qe, rt, this.stateDependentLayers, Wn);
                        }
                        addFeatures(Qe, rt, Wn) {
                            for (const Co of this.patternFeatures)this.addFeature(Co, Co.geometry, Co.index, rt, Wn, Qe.subdivisionGranularity);
                        }
                        isEmpty() {
                            return 0 === this.layoutVertexArray.length;
                        }
                        uploadPending() {
                            return !this.uploaded || this.programConfigurations.needsUpload;
                        }
                        upload(Qe) {
                            this.uploaded || (this.layoutVertexBuffer = Qe.createVertexBuffer(this.layoutVertexArray, Rp), this.indexBuffer = Qe.createIndexBuffer(this.indexArray), this.indexBuffer2 = Qe.createIndexBuffer(this.indexArray2)), this.programConfigurations.upload(Qe), this.uploaded = !0;
                        }
                        destroy() {
                            this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.indexBuffer2.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.segments2.destroy());
                        }
                        addFeature(Qe, rt, Wn, Co, Dl, Ll) {
                            for (const Rl of He(rt, 500)){
                                const Qe = Ga(Rl, Co, Ll.fill.getGranularityForZoomLevel(Co.z)), rt = this.layoutVertexArray;
                                Ha((Qe, Wn)=>{
                                    rt.emplaceBack(Qe, Wn);
                                }, this.segments, this.layoutVertexArray, this.indexArray, Qe.verticesFlattened, Qe.indicesTriangles, this.segments2, this.indexArray2, Qe.indicesLineList);
                            }
                            this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, Qe, Wn, Dl, Co);
                        }
                    }
                    let Fp, jp;
                    Qn("FillBucket", Ja, {
                        omit: [
                            "layers",
                            "patternFeatures"
                        ]
                    });
                    var Up = {
                        get paint () {
                            return jp = jp || new Gi({
                                "fill-antialias": new Ri(Tc.paint_fill["fill-antialias"]),
                                "fill-opacity": new Ni(Tc.paint_fill["fill-opacity"]),
                                "fill-color": new Ni(Tc.paint_fill["fill-color"]),
                                "fill-outline-color": new Ni(Tc.paint_fill["fill-outline-color"]),
                                "fill-translate": new Ri(Tc.paint_fill["fill-translate"]),
                                "fill-translate-anchor": new Ri(Tc.paint_fill["fill-translate-anchor"]),
                                "fill-pattern": new ji(Tc.paint_fill["fill-pattern"])
                            });
                        },
                        get layout () {
                            return Fp = Fp || new Gi({
                                "fill-sort-key": new Ni(Tc.layout_fill["fill-sort-key"])
                            });
                        }
                    };
                    class tl extends Xi {
                        constructor(Qe){
                            super(Qe, Up);
                        }
                        recalculate(Qe, rt) {
                            super.recalculate(Qe, rt);
                            const Wn = this.paint._values["fill-outline-color"];
                            "constant" === Wn.value.kind && void 0 === Wn.value.value && (this.paint._values["fill-outline-color"] = this.paint._values["fill-color"]);
                        }
                        createBucket(Qe) {
                            return new Ja(Qe);
                        }
                        queryRadius() {
                            return Go(this.paint.get("fill-translate"));
                        }
                        queryIntersectsFeature(Qe) {
                            let { queryGeometry: rt, geometry: Wn, transform: Co, pixelsToTileUnits: Dl } = Qe;
                            return Fo(Zo(rt, this.paint.get("fill-translate"), this.paint.get("fill-translate-anchor"), -Co.bearingInRadians, Dl), Wn);
                        }
                        isTileClipped() {
                            return !0;
                        }
                    }
                    const Vp = Ki([
                        {
                            name: "a_pos",
                            components: 2,
                            type: "Int16"
                        },
                        {
                            name: "a_normal_ed",
                            components: 4,
                            type: "Int16"
                        }
                    ], 4), Gp = Ki([
                        {
                            name: "a_centroid",
                            components: 2,
                            type: "Int16"
                        }
                    ], 4), { members: Zp } = Vp;
                    var Hp, Wp, qp, Yp, Qp, Kp, Xp, Jp = {};
                    function pl() {
                        if (Wp) return Hp;
                        Wp = 1;
                        var Qe = i();
                        function e(Qe, rt, Wn, Co, Dl) {
                            this.properties = {}, this.extent = Wn, this.type = 0, this._pbf = Qe, this._geometry = -1, this._keys = Co, this._values = Dl, Qe.readFields(r, this, rt);
                        }
                        function r(Qe, rt, Wn) {
                            1 == Qe ? rt.id = Wn.readVarint() : 2 == Qe ? function(Qe, rt) {
                                for(var Wn = Qe.readVarint() + Qe.pos; Qe.pos < Wn;){
                                    var Co = rt._keys[Qe.readVarint()], Dl = rt._values[Qe.readVarint()];
                                    rt.properties[Co] = Dl;
                                }
                            }(Wn, rt) : 3 == Qe ? rt.type = Wn.readVarint() : 4 == Qe && (rt._geometry = Wn.pos);
                        }
                        function n(Qe) {
                            for(var rt, Wn, Co = 0, Dl = 0, Ll = Qe.length, Rl = Ll - 1; Dl < Ll; Rl = Dl++)Co += ((Wn = Qe[Rl]).x - (rt = Qe[Dl]).x) * (rt.y + Wn.y);
                            return Co;
                        }
                        return Hp = e, e.types = [
                            "Unknown",
                            "Point",
                            "LineString",
                            "Polygon"
                        ], e.prototype.loadGeometry = function() {
                            var rt = this._pbf;
                            rt.pos = this._geometry;
                            for(var Wn, Co = rt.readVarint() + rt.pos, Dl = 1, Ll = 0, Rl = 0, Ul = 0, Gl = []; rt.pos < Co;){
                                if (Ll <= 0) {
                                    var Zl = rt.readVarint();
                                    Dl = 7 & Zl, Ll = Zl >> 3;
                                }
                                if (Ll--, 1 === Dl || 2 === Dl) Rl += rt.readSVarint(), Ul += rt.readSVarint(), 1 === Dl && (Wn && Gl.push(Wn), Wn = []), Wn.push(new Qe(Rl, Ul));
                                else {
                                    if (7 !== Dl) throw new Error("unknown command " + Dl);
                                    Wn && Wn.push(Wn[0].clone());
                                }
                            }
                            return Wn && Gl.push(Wn), Gl;
                        }, e.prototype.bbox = function() {
                            var Qe = this._pbf;
                            Qe.pos = this._geometry;
                            for(var rt = Qe.readVarint() + Qe.pos, Wn = 1, Co = 0, Dl = 0, Ll = 0, Rl = 1 / 0, Ul = -1 / 0, Gl = 1 / 0, Zl = -1 / 0; Qe.pos < rt;){
                                if (Co <= 0) {
                                    var Hl = Qe.readVarint();
                                    Wn = 7 & Hl, Co = Hl >> 3;
                                }
                                if (Co--, 1 === Wn || 2 === Wn) (Dl += Qe.readSVarint()) < Rl && (Rl = Dl), Dl > Ul && (Ul = Dl), (Ll += Qe.readSVarint()) < Gl && (Gl = Ll), Ll > Zl && (Zl = Ll);
                                else if (7 !== Wn) throw new Error("unknown command " + Wn);
                            }
                            return [
                                Rl,
                                Gl,
                                Ul,
                                Zl
                            ];
                        }, e.prototype.toGeoJSON = function(Qe, rt, Wn) {
                            var Co, Dl, Ll = this.extent * Math.pow(2, Wn), Rl = this.extent * Qe, Ul = this.extent * rt, Gl = this.loadGeometry(), Zl = e.types[this.type];
                            function p(Qe) {
                                for(var rt = 0; rt < Qe.length; rt++){
                                    var Wn = Qe[rt];
                                    Qe[rt] = [
                                        360 * (Wn.x + Rl) / Ll - 180,
                                        360 / Math.PI * Math.atan(Math.exp((180 - 360 * (Wn.y + Ul) / Ll) * Math.PI / 180)) - 90
                                    ];
                                }
                            }
                            switch(this.type){
                                case 1:
                                    var Hl = [];
                                    for(Co = 0; Co < Gl.length; Co++)Hl[Co] = Gl[Co][0];
                                    p(Gl = Hl);
                                    break;
                                case 2:
                                    for(Co = 0; Co < Gl.length; Co++)p(Gl[Co]);
                                    break;
                                case 3:
                                    for(Gl = function(Qe) {
                                        var rt = Qe.length;
                                        if (rt <= 1) return [
                                            Qe
                                        ];
                                        for(var Wn, Co, Dl = [], Ll = 0; Ll < rt; Ll++){
                                            var Rl = n(Qe[Ll]);
                                            0 !== Rl && (void 0 === Co && (Co = Rl < 0), Co === Rl < 0 ? (Wn && Dl.push(Wn), Wn = [
                                                Qe[Ll]
                                            ]) : Wn.push(Qe[Ll]));
                                        }
                                        return Wn && Dl.push(Wn), Dl;
                                    }(Gl), Co = 0; Co < Gl.length; Co++)for(Dl = 0; Dl < Gl[Co].length; Dl++)p(Gl[Co][Dl]);
                            }
                            1 === Gl.length ? Gl = Gl[0] : Zl = "Multi" + Zl;
                            var ql = {
                                type: "Feature",
                                geometry: {
                                    type: Zl,
                                    coordinates: Gl
                                },
                                properties: this.properties
                            };
                            return "id" in this && (ql.id = this.id), ql;
                        }, Hp;
                    }
                    function fl() {
                        if (Yp) return qp;
                        Yp = 1;
                        var Qe = pl();
                        function e(Qe, rt) {
                            this.version = 1, this.name = null, this.extent = 4096, this.length = 0, this._pbf = Qe, this._keys = [], this._values = [], this._features = [], Qe.readFields(r, this, rt), this.length = this._features.length;
                        }
                        function r(Qe, rt, Wn) {
                            15 === Qe ? rt.version = Wn.readVarint() : 1 === Qe ? rt.name = Wn.readString() : 5 === Qe ? rt.extent = Wn.readVarint() : 2 === Qe ? rt._features.push(Wn.pos) : 3 === Qe ? rt._keys.push(Wn.readString()) : 4 === Qe && rt._values.push(function(Qe) {
                                for(var rt = null, Wn = Qe.readVarint() + Qe.pos; Qe.pos < Wn;){
                                    var Co = Qe.readVarint() >> 3;
                                    rt = 1 === Co ? Qe.readString() : 2 === Co ? Qe.readFloat() : 3 === Co ? Qe.readDouble() : 4 === Co ? Qe.readVarint64() : 5 === Co ? Qe.readVarint() : 6 === Co ? Qe.readSVarint() : 7 === Co ? Qe.readBoolean() : null;
                                }
                                return rt;
                            }(Wn));
                        }
                        return qp = e, e.prototype.feature = function(rt) {
                            if (rt < 0 || rt >= this._features.length) throw new Error("feature index out of bounds");
                            this._pbf.pos = this._features[rt];
                            var Wn = this._pbf.readVarint() + this._pbf.pos;
                            return new Qe(this._pbf, Wn, this.extent, this._keys, this._values);
                        }, qp;
                    }
                    function dl() {
                        return Xp || (Xp = 1, Jp.VectorTile = function() {
                            if (Kp) return Qp;
                            Kp = 1;
                            var Qe = fl();
                            function e(rt, Wn, Co) {
                                if (3 === rt) {
                                    var Dl = new Qe(Co, Co.readVarint() + Co.pos);
                                    Dl.length && (Wn[Dl.name] = Dl);
                                }
                            }
                            return Qp = function(Qe, rt) {
                                this.layers = Qe.readFields(e, {}, rt);
                            }, Qp;
                        }(), Jp.VectorTileFeature = pl(), Jp.VectorTileLayer = fl()), Jp;
                    }
                    var $p = e(dl());
                    const em = $p.VectorTileFeature.types, tm = Math.pow(2, 13);
                    function xl(Qe, rt, Wn, Co, Dl, Ll, Rl, Ul) {
                        Qe.emplaceBack(rt, Wn, 2 * Math.floor(Co * tm) + Rl, Dl * tm * 2, Ll * tm * 2, Math.round(Ul));
                    }
                    class vl {
                        constructor(Qe){
                            this.zoom = Qe.zoom, this.overscaling = Qe.overscaling, this.layers = Qe.layers, this.layerIds = this.layers.map((Qe)=>Qe.id), this.index = Qe.index, this.hasPattern = !1, this.layoutVertexArray = new Ls, this.centroidVertexArray = new Es, this.indexArray = new Zs, this.programConfigurations = new So(Qe.layers, Qe.zoom), this.segments = new Js, this.stateDependentLayerIds = this.layers.filter((Qe)=>Qe.isStateDependent()).map((Qe)=>Qe.id);
                        }
                        populate(Qe, rt, Wn) {
                            this.features = [], this.hasPattern = fa("fill-extrusion", this.layers, rt);
                            for (const { feature: Co, id: Dl, index: Ll, sourceLayerIndex: Rl } of Qe){
                                const Qe = this.layers[0]._featureFilter.needGeometry, Ul = Po(Co, Qe);
                                if (!this.layers[0]._featureFilter.filter(new Bi(this.zoom), Ul, Wn)) continue;
                                const Gl = {
                                    id: Dl,
                                    sourceLayerIndex: Rl,
                                    index: Ll,
                                    geometry: Qe ? Ul.geometry : zo(Co),
                                    properties: Co.properties,
                                    type: Co.type,
                                    patterns: {}
                                };
                                this.hasPattern ? this.features.push(da("fill-extrusion", this.layers, Gl, this.zoom, rt)) : this.addFeature(Gl, Gl.geometry, Ll, Wn, {}, rt.subdivisionGranularity), rt.featureIndex.insert(Co, Gl.geometry, Ll, Rl, this.index, !0);
                            }
                        }
                        addFeatures(Qe, rt, Wn) {
                            for (const Co of this.features){
                                const { geometry: Dl } = Co;
                                this.addFeature(Co, Dl, Co.index, rt, Wn, Qe.subdivisionGranularity);
                            }
                        }
                        update(Qe, rt, Wn) {
                            this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(Qe, rt, this.stateDependentLayers, Wn);
                        }
                        isEmpty() {
                            return 0 === this.layoutVertexArray.length && 0 === this.centroidVertexArray.length;
                        }
                        uploadPending() {
                            return !this.uploaded || this.programConfigurations.needsUpload;
                        }
                        upload(Qe) {
                            this.uploaded || (this.layoutVertexBuffer = Qe.createVertexBuffer(this.layoutVertexArray, Zp), this.centroidVertexBuffer = Qe.createVertexBuffer(this.centroidVertexArray, Gp.members, !0), this.indexBuffer = Qe.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(Qe), this.uploaded = !0;
                        }
                        destroy() {
                            this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.centroidVertexBuffer.destroy());
                        }
                        addFeature(Qe, rt, Wn, Co, Dl, Ll) {
                            for (const Rl of He(rt, 500)){
                                const rt = {
                                    x: 0,
                                    y: 0,
                                    sampleCount: 0
                                }, Wn = this.layoutVertexArray.length;
                                this.processPolygon(rt, Co, Qe, Rl, Ll);
                                const Dl = this.layoutVertexArray.length - Wn, Ul = Math.floor(rt.x / rt.sampleCount), Gl = Math.floor(rt.y / rt.sampleCount);
                                for(let Qe = 0; Qe < Dl; Qe++)this.centroidVertexArray.emplaceBack(Ul, Gl);
                            }
                            this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, Qe, Wn, Dl, Co);
                        }
                        processPolygon(Qe, rt, Wn, Co, Dl) {
                            if (Co.length < 1) return;
                            if (_l(Co[0])) return;
                            for (const Hl of Co)0 !== Hl.length && bl(Qe, Hl);
                            const Ll = {
                                segment: this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray)
                            }, Rl = Dl.fill.getGranularityForZoomLevel(rt.z), Ul = "Polygon" === em[Wn.type];
                            for (const Hl of Co){
                                if (0 === Hl.length) continue;
                                if (_l(Hl)) continue;
                                const Qe = Za(Hl, Rl, Ul);
                                this._generateSideFaces(Qe, Ll);
                            }
                            if (!Ul) return;
                            const Gl = Ga(Co, rt, Rl, !1), Zl = this.layoutVertexArray;
                            Ha((Qe, rt)=>{
                                xl(Zl, Qe, rt, 0, 0, 1, 1, 0);
                            }, this.segments, this.layoutVertexArray, this.indexArray, Gl.verticesFlattened, Gl.indicesTriangles);
                        }
                        _generateSideFaces(Qe, rt) {
                            let Wn = 0;
                            for(let Co = 1; Co < Qe.length; Co++){
                                const Dl = Qe[Co], Ll = Qe[Co - 1];
                                if (wl(Dl, Ll)) continue;
                                rt.segment.vertexLength + 4 > Js.MAX_VERTEX_ARRAY_LENGTH && (rt.segment = this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray));
                                const Rl = Dl.sub(Ll)._perp()._unit(), Ul = Ll.dist(Dl);
                                Wn + Ul > 32768 && (Wn = 0), xl(this.layoutVertexArray, Dl.x, Dl.y, Rl.x, Rl.y, 0, 0, Wn), xl(this.layoutVertexArray, Dl.x, Dl.y, Rl.x, Rl.y, 0, 1, Wn), Wn += Ul, xl(this.layoutVertexArray, Ll.x, Ll.y, Rl.x, Rl.y, 0, 0, Wn), xl(this.layoutVertexArray, Ll.x, Ll.y, Rl.x, Rl.y, 0, 1, Wn);
                                const Gl = rt.segment.vertexLength;
                                this.indexArray.emplaceBack(Gl, Gl + 2, Gl + 1), this.indexArray.emplaceBack(Gl + 1, Gl + 2, Gl + 3), rt.segment.vertexLength += 4, rt.segment.primitiveLength += 2;
                            }
                        }
                    }
                    function bl(Qe, rt) {
                        for(let Wn = 0; Wn < rt.length; Wn++){
                            const Co = rt[Wn];
                            Wn === rt.length - 1 && rt[0].x === Co.x && rt[0].y === Co.y || (Qe.x += Co.x, Qe.y += Co.y, Qe.sampleCount++);
                        }
                    }
                    function wl(Qe, rt) {
                        return Qe.x === rt.x && (Qe.x < 0 || Qe.x > ql) || Qe.y === rt.y && (Qe.y < 0 || Qe.y > ql);
                    }
                    function _l(Qe) {
                        return Qe.every((Qe)=>Qe.x < 0) || Qe.every((Qe)=>Qe.x > ql) || Qe.every((Qe)=>Qe.y < 0) || Qe.every((Qe)=>Qe.y > ql);
                    }
                    let im;
                    Qn("FillExtrusionBucket", vl, {
                        omit: [
                            "layers",
                            "features"
                        ]
                    });
                    var nm = {
                        get paint () {
                            return im = im || new Gi({
                                "fill-extrusion-opacity": new Ri(Tc["paint_fill-extrusion"]["fill-extrusion-opacity"]),
                                "fill-extrusion-color": new Ni(Tc["paint_fill-extrusion"]["fill-extrusion-color"]),
                                "fill-extrusion-translate": new Ri(Tc["paint_fill-extrusion"]["fill-extrusion-translate"]),
                                "fill-extrusion-translate-anchor": new Ri(Tc["paint_fill-extrusion"]["fill-extrusion-translate-anchor"]),
                                "fill-extrusion-pattern": new ji(Tc["paint_fill-extrusion"]["fill-extrusion-pattern"]),
                                "fill-extrusion-height": new Ni(Tc["paint_fill-extrusion"]["fill-extrusion-height"]),
                                "fill-extrusion-base": new Ni(Tc["paint_fill-extrusion"]["fill-extrusion-base"]),
                                "fill-extrusion-vertical-gradient": new Ri(Tc["paint_fill-extrusion"]["fill-extrusion-vertical-gradient"])
                            });
                        }
                    };
                    class Al extends Xi {
                        constructor(Qe){
                            super(Qe, nm);
                        }
                        createBucket(Qe) {
                            return new vl(Qe);
                        }
                        queryRadius() {
                            return Go(this.paint.get("fill-extrusion-translate"));
                        }
                        is3D() {
                            return !0;
                        }
                        queryIntersectsFeature(Qe) {
                            let { queryGeometry: rt, feature: Wn, featureState: Co, geometry: Ll, transform: Rl, pixelsToTileUnits: Ul, pixelPosMatrix: Gl } = Qe;
                            const Zl = Zo(rt, this.paint.get("fill-extrusion-translate"), this.paint.get("fill-extrusion-translate-anchor"), -Rl.bearingInRadians, Ul), Hl = this.paint.get("fill-extrusion-height").evaluate(Wn, Co), ql = this.paint.get("fill-extrusion-base").evaluate(Wn, Co), Ql = function(Qe, rt) {
                                const Wn = [];
                                for (const Co of Qe){
                                    const Qe = [
                                        Co.x,
                                        Co.y,
                                        0,
                                        1
                                    ];
                                    d(Qe, Qe, rt), Wn.push(new Dl(Qe[0] / Qe[3], Qe[1] / Qe[3]));
                                }
                                return Wn;
                            }(Zl, Gl), Kl = function(Qe, rt, Wn, Co) {
                                const Ll = [], Rl = [], Ul = Co[8] * rt, Gl = Co[9] * rt, Zl = Co[10] * rt, Hl = Co[11] * rt, ql = Co[8] * Wn, Ql = Co[9] * Wn, Kl = Co[10] * Wn, $l = Co[11] * Wn;
                                for (const Tc of Qe){
                                    const Qe = [], rt = [];
                                    for (const Wn of Tc){
                                        const Ll = Wn.x, Rl = Wn.y, Tc = Co[0] * Ll + Co[4] * Rl + Co[12], tu = Co[1] * Ll + Co[5] * Rl + Co[13], lu = Co[2] * Ll + Co[6] * Rl + Co[14], du = Co[3] * Ll + Co[7] * Rl + Co[15], fu = lu + Zl, yu = du + Hl, Eu = Tc + ql, Tu = tu + Ql, Lu = lu + Kl, Zu = du + $l, Xu = new Dl((Tc + Ul) / yu, (tu + Gl) / yu);
                                        Xu.z = fu / yu, Qe.push(Xu);
                                        const Ju = new Dl(Eu / Zu, Tu / Zu);
                                        Ju.z = Lu / Zu, rt.push(Ju);
                                    }
                                    Ll.push(Qe), Rl.push(rt);
                                }
                                return [
                                    Ll,
                                    Rl
                                ];
                            }(Ll, ql, Hl, Gl);
                            return function(Qe, rt, Wn) {
                                let Co = 1 / 0;
                                Fo(Wn, rt) && (Co = Ml(Wn, rt[0]));
                                for(let Dl = 0; Dl < rt.length; Dl++){
                                    const Ll = rt[Dl], Rl = Qe[Dl];
                                    for(let Qe = 0; Qe < Ll.length - 1; Qe++){
                                        const rt = Ll[Qe], Dl = [
                                            rt,
                                            Ll[Qe + 1],
                                            Rl[Qe + 1],
                                            Rl[Qe],
                                            rt
                                        ];
                                        Vo(Wn, Dl) && (Co = Math.min(Co, Ml(Wn, Dl)));
                                    }
                                }
                                return Co !== 1 / 0 && Co;
                            }(Kl[0], Kl[1], Ql);
                        }
                    }
                    function Il(Qe, rt) {
                        return Qe.x * rt.x + Qe.y * rt.y;
                    }
                    function Ml(Qe, rt) {
                        if (1 === Qe.length) {
                            let Wn = 0;
                            const Co = rt[Wn++];
                            let Dl;
                            for(; !Dl || Co.equals(Dl);)if (Dl = rt[Wn++], !Dl) return 1 / 0;
                            for(; Wn < rt.length; Wn++){
                                const Ll = rt[Wn], Rl = Qe[0], Ul = Dl.sub(Co), Gl = Ll.sub(Co), Zl = Rl.sub(Co), Hl = Il(Ul, Ul), ql = Il(Ul, Gl), Ql = Il(Gl, Gl), Kl = Il(Zl, Ul), $l = Il(Zl, Gl), Tc = Hl * Ql - ql * ql, tu = (Ql * Kl - ql * $l) / Tc, lu = (Hl * $l - ql * Kl) / Tc, du = Co.z * (1 - tu - lu) + Dl.z * tu + Ll.z * lu;
                                if (isFinite(du)) return du;
                            }
                            return 1 / 0;
                        }
                        {
                            let Qe = 1 / 0;
                            for (const Wn of rt)Qe = Math.min(Qe, Wn.z);
                            return Qe;
                        }
                    }
                    const rm = Ki([
                        {
                            name: "a_pos_normal",
                            components: 2,
                            type: "Int16"
                        },
                        {
                            name: "a_data",
                            components: 4,
                            type: "Uint8"
                        }
                    ], 4), { members: sm } = rm, am = Ki([
                        {
                            name: "a_uv_x",
                            components: 1,
                            type: "Float32"
                        },
                        {
                            name: "a_split_index",
                            components: 1,
                            type: "Float32"
                        }
                    ]), { members: om } = am, lm = $p.VectorTileFeature.types, cm = Math.cos(Math.PI / 180 * 37.5), um = Math.pow(2, 14) / .5;
                    class Fl {
                        constructor(Qe){
                            this.zoom = Qe.zoom, this.overscaling = Qe.overscaling, this.layers = Qe.layers, this.layerIds = this.layers.map((Qe)=>Qe.id), this.index = Qe.index, this.hasPattern = !1, this.patternFeatures = [], this.lineClipsArray = [], this.gradients = {}, this.layers.forEach((Qe)=>{
                                this.gradients[Qe.id] = {};
                            }), this.layoutVertexArray = new $s, this.layoutVertexArray2 = new Os, this.indexArray = new Zs, this.programConfigurations = new So(Qe.layers, Qe.zoom), this.segments = new Js, this.maxLineLength = 0, this.stateDependentLayerIds = this.layers.filter((Qe)=>Qe.isStateDependent()).map((Qe)=>Qe.id);
                        }
                        populate(Qe, rt, Wn) {
                            this.hasPattern = fa("line", this.layers, rt);
                            const Co = this.layers[0].layout.get("line-sort-key"), Dl = !Co.isConstant(), Ll = [];
                            for (const { feature: Rl, id: Ul, index: Gl, sourceLayerIndex: Zl } of Qe){
                                const Qe = this.layers[0]._featureFilter.needGeometry, rt = Po(Rl, Qe);
                                if (!this.layers[0]._featureFilter.filter(new Bi(this.zoom), rt, Wn)) continue;
                                const Hl = Dl ? Co.evaluate(rt, {}, Wn) : void 0, ql = {
                                    id: Ul,
                                    properties: Rl.properties,
                                    type: Rl.type,
                                    sourceLayerIndex: Zl,
                                    index: Gl,
                                    geometry: Qe ? rt.geometry : zo(Rl),
                                    patterns: {},
                                    sortKey: Hl
                                };
                                Ll.push(ql);
                            }
                            Dl && Ll.sort((Qe, rt)=>Qe.sortKey - rt.sortKey);
                            for (const Rl of Ll){
                                const { geometry: Co, index: Dl, sourceLayerIndex: Ll } = Rl;
                                if (this.hasPattern) {
                                    const Qe = da("line", this.layers, Rl, this.zoom, rt);
                                    this.patternFeatures.push(Qe);
                                } else this.addFeature(Rl, Co, Dl, Wn, {}, rt.subdivisionGranularity);
                                rt.featureIndex.insert(Qe[Dl].feature, Co, Dl, Ll, this.index);
                            }
                        }
                        update(Qe, rt, Wn) {
                            this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(Qe, rt, this.stateDependentLayers, Wn);
                        }
                        addFeatures(Qe, rt, Wn) {
                            for (const Co of this.patternFeatures)this.addFeature(Co, Co.geometry, Co.index, rt, Wn, Qe.subdivisionGranularity);
                        }
                        isEmpty() {
                            return 0 === this.layoutVertexArray.length;
                        }
                        uploadPending() {
                            return !this.uploaded || this.programConfigurations.needsUpload;
                        }
                        upload(Qe) {
                            this.uploaded || (0 !== this.layoutVertexArray2.length && (this.layoutVertexBuffer2 = Qe.createVertexBuffer(this.layoutVertexArray2, om)), this.layoutVertexBuffer = Qe.createVertexBuffer(this.layoutVertexArray, sm), this.indexBuffer = Qe.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(Qe), this.uploaded = !0;
                        }
                        destroy() {
                            this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
                        }
                        lineFeatureClips(Qe) {
                            if (Qe.properties && Object.prototype.hasOwnProperty.call(Qe.properties, "mapbox_clip_start") && Object.prototype.hasOwnProperty.call(Qe.properties, "mapbox_clip_end")) return {
                                start: +Qe.properties.mapbox_clip_start,
                                end: +Qe.properties.mapbox_clip_end
                            };
                        }
                        addFeature(Qe, rt, Wn, Co, Dl, Ll) {
                            const Rl = this.layers[0].layout, Ul = Rl.get("line-join").evaluate(Qe, {}), Gl = Rl.get("line-cap"), Zl = Rl.get("line-miter-limit"), Hl = Rl.get("line-round-limit");
                            this.lineClips = this.lineFeatureClips(Qe);
                            for (const ql of rt)this.addLine(ql, Qe, Ul, Gl, Zl, Hl, Co, Ll);
                            this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, Qe, Wn, Dl, Co);
                        }
                        addLine(Qe, rt, Wn, Co, Dl, Ll, Rl, Ul) {
                            if (this.distance = 0, this.scaledDistance = 0, this.totalDistance = 0, Qe = Za(Qe, Rl ? Ul.line.getGranularityForZoomLevel(Rl.z) : 1), this.lineClips) {
                                this.lineClipsArray.push(this.lineClips);
                                for(let rt = 0; rt < Qe.length - 1; rt++)this.totalDistance += Qe[rt].dist(Qe[rt + 1]);
                                this.updateScaledDistance(), this.maxLineLength = Math.max(this.maxLineLength, this.totalDistance);
                            }
                            const Gl = "Polygon" === lm[rt.type];
                            let Zl = Qe.length;
                            for(; Zl >= 2 && Qe[Zl - 1].equals(Qe[Zl - 2]);)Zl--;
                            let Hl = 0;
                            for(; Hl < Zl - 1 && Qe[Hl].equals(Qe[Hl + 1]);)Hl++;
                            if (Zl < (Gl ? 3 : 2)) return;
                            "bevel" === Wn && (Dl = 1.05);
                            const Ql = this.overscaling <= 16 ? 15 * ql / (512 * this.overscaling) : 0, Kl = this.segments.prepareSegment(10 * Zl, this.layoutVertexArray, this.indexArray);
                            let $l, Tc, tu, lu, du;
                            this.e1 = this.e2 = -1, Gl && ($l = Qe[Zl - 2], du = Qe[Hl].sub($l)._unit()._perp());
                            for(let ql = Hl; ql < Zl; ql++){
                                if (tu = ql === Zl - 1 ? Gl ? Qe[Hl + 1] : void 0 : Qe[ql + 1], tu && Qe[ql].equals(tu)) continue;
                                du && (lu = du), $l && (Tc = $l), $l = Qe[ql], du = tu ? tu.sub($l)._unit()._perp() : lu, lu = lu || du;
                                let rt = lu.add(du);
                                0 === rt.x && 0 === rt.y || rt._unit();
                                const Rl = lu.x * du.x + lu.y * du.y, Ul = rt.x * du.x + rt.y * du.y, fu = 0 !== Ul ? 1 / Ul : 1 / 0, yu = 2 * Math.sqrt(2 - 2 * Ul), Eu = Ul < cm && Tc && tu, Tu = lu.x * du.y - lu.y * du.x > 0;
                                if (Eu && ql > Hl) {
                                    const Qe = $l.dist(Tc);
                                    if (Qe > 2 * Ql) {
                                        const rt = $l.sub($l.sub(Tc)._mult(Ql / Qe)._round());
                                        this.updateDistance(Tc, rt), this.addCurrentVertex(rt, lu, 0, 0, Kl), Tc = rt;
                                    }
                                }
                                const Lu = Tc && tu;
                                let Zu = Lu ? Wn : Gl ? "butt" : Co;
                                if (Lu && "round" === Zu && (fu < Ll ? Zu = "miter" : fu <= 2 && (Zu = "fakeround")), "miter" === Zu && fu > Dl && (Zu = "bevel"), "bevel" === Zu && (fu > 2 && (Zu = "flipbevel"), fu < Dl && (Zu = "miter")), Tc && this.updateDistance(Tc, $l), "miter" === Zu) rt._mult(fu), this.addCurrentVertex($l, rt, 0, 0, Kl);
                                else if ("flipbevel" === Zu) {
                                    if (fu > 100) rt = du.mult(-1);
                                    else {
                                        const Qe = fu * lu.add(du).mag() / lu.sub(du).mag();
                                        rt._perp()._mult(Qe * (Tu ? -1 : 1));
                                    }
                                    this.addCurrentVertex($l, rt, 0, 0, Kl), this.addCurrentVertex($l, rt.mult(-1), 0, 0, Kl);
                                } else if ("bevel" === Zu || "fakeround" === Zu) {
                                    const Qe = -Math.sqrt(fu * fu - 1), rt = Tu ? Qe : 0, Wn = Tu ? 0 : Qe;
                                    if (Tc && this.addCurrentVertex($l, lu, rt, Wn, Kl), "fakeround" === Zu) {
                                        const Qe = Math.round(180 * yu / Math.PI / 20);
                                        for(let rt = 1; rt < Qe; rt++){
                                            let Wn = rt / Qe;
                                            if (.5 !== Wn) {
                                                const Qe = Wn - .5;
                                                Wn += Wn * Qe * (Wn - 1) * ((1.0904 + Rl * (Rl * (3.55645 - 1.43519 * Rl) - 3.2452)) * Qe * Qe + (.848013 + Rl * (.215638 * Rl - 1.06021)));
                                            }
                                            const Co = du.sub(lu)._mult(Wn)._add(lu)._unit()._mult(Tu ? -1 : 1);
                                            this.addHalfVertex($l, Co.x, Co.y, !1, Tu, 0, Kl);
                                        }
                                    }
                                    tu && this.addCurrentVertex($l, du, -rt, -Wn, Kl);
                                } else if ("butt" === Zu) this.addCurrentVertex($l, rt, 0, 0, Kl);
                                else if ("square" === Zu) {
                                    const Qe = Tc ? 1 : -1;
                                    this.addCurrentVertex($l, rt, Qe, Qe, Kl);
                                } else "round" === Zu && (Tc && (this.addCurrentVertex($l, lu, 0, 0, Kl), this.addCurrentVertex($l, lu, 1, 1, Kl, !0)), tu && (this.addCurrentVertex($l, du, -1, -1, Kl, !0), this.addCurrentVertex($l, du, 0, 0, Kl)));
                                if (Eu && ql < Zl - 1) {
                                    const Qe = $l.dist(tu);
                                    if (Qe > 2 * Ql) {
                                        const rt = $l.add(tu.sub($l)._mult(Ql / Qe)._round());
                                        this.updateDistance($l, rt), this.addCurrentVertex(rt, du, 0, 0, Kl), $l = rt;
                                    }
                                }
                            }
                        }
                        addCurrentVertex(Qe, rt, Wn, Co, Dl, Ll) {
                            void 0 === Ll && (Ll = !1);
                            const Rl = rt.y * Co - rt.x, Ul = -rt.y - rt.x * Co;
                            this.addHalfVertex(Qe, rt.x + rt.y * Wn, rt.y - rt.x * Wn, Ll, !1, Wn, Dl), this.addHalfVertex(Qe, Rl, Ul, Ll, !0, -Co, Dl), this.distance > um / 2 && 0 === this.totalDistance && (this.distance = 0, this.updateScaledDistance(), this.addCurrentVertex(Qe, rt, Wn, Co, Dl, Ll));
                        }
                        addHalfVertex(Qe, rt, Wn, Co, Dl, Ll, Rl) {
                            let { x: Ul, y: Gl } = Qe;
                            const Zl = .5 * (this.lineClips ? this.scaledDistance * (um - 1) : this.scaledDistance);
                            this.layoutVertexArray.emplaceBack((Ul << 1) + (Co ? 1 : 0), (Gl << 1) + (Dl ? 1 : 0), Math.round(63 * rt) + 128, Math.round(63 * Wn) + 128, 1 + (0 === Ll ? 0 : Ll < 0 ? -1 : 1) | (63 & Zl) << 2, Zl >> 6), this.lineClips && this.layoutVertexArray2.emplaceBack((this.scaledDistance - this.lineClips.start) / (this.lineClips.end - this.lineClips.start), this.lineClipsArray.length);
                            const Hl = Rl.vertexLength++;
                            this.e1 >= 0 && this.e2 >= 0 && (this.indexArray.emplaceBack(this.e1, Hl, this.e2), Rl.primitiveLength++), Dl ? this.e2 = Hl : this.e1 = Hl;
                        }
                        updateScaledDistance() {
                            this.scaledDistance = this.lineClips ? this.lineClips.start + (this.lineClips.end - this.lineClips.start) * this.distance / this.totalDistance : this.distance;
                        }
                        updateDistance(Qe, rt) {
                            this.distance += Qe.dist(rt), this.updateScaledDistance();
                        }
                    }
                    let hm, dm;
                    Qn("LineBucket", Fl, {
                        omit: [
                            "layers",
                            "patternFeatures"
                        ]
                    });
                    var pm = {
                        get paint () {
                            return dm = dm || new Gi({
                                "line-opacity": new Ni(Tc.paint_line["line-opacity"]),
                                "line-color": new Ni(Tc.paint_line["line-color"]),
                                "line-translate": new Ri(Tc.paint_line["line-translate"]),
                                "line-translate-anchor": new Ri(Tc.paint_line["line-translate-anchor"]),
                                "line-width": new Ni(Tc.paint_line["line-width"]),
                                "line-gap-width": new Ni(Tc.paint_line["line-gap-width"]),
                                "line-offset": new Ni(Tc.paint_line["line-offset"]),
                                "line-blur": new Ni(Tc.paint_line["line-blur"]),
                                "line-dasharray": new qi(Tc.paint_line["line-dasharray"]),
                                "line-pattern": new ji(Tc.paint_line["line-pattern"]),
                                "line-gradient": new Ui(Tc.paint_line["line-gradient"])
                            });
                        },
                        get layout () {
                            return hm = hm || new Gi({
                                "line-cap": new Ri(Tc.layout_line["line-cap"]),
                                "line-join": new Ni(Tc.layout_line["line-join"]),
                                "line-miter-limit": new Ri(Tc.layout_line["line-miter-limit"]),
                                "line-round-limit": new Ri(Tc.layout_line["line-round-limit"]),
                                "line-sort-key": new Ni(Tc.layout_line["line-sort-key"])
                            });
                        }
                    };
                    class Ol extends Ni {
                        possiblyEvaluate(Qe, rt) {
                            return rt = new Bi(Math.floor(rt.zoom), {
                                now: rt.now,
                                fadeDuration: rt.fadeDuration,
                                zoomHistory: rt.zoomHistory,
                                transition: rt.transition
                            }), super.possiblyEvaluate(Qe, rt);
                        }
                        evaluate(Qe, rt, Wn, Co) {
                            return rt = g({}, rt, {
                                zoom: Math.floor(rt.zoom)
                            }), super.evaluate(Qe, rt, Wn, Co);
                        }
                    }
                    let mm;
                    class Nl extends Xi {
                        constructor(Qe){
                            super(Qe, pm), this.gradientVersion = 0, mm || (mm = new Ol(pm.paint.properties["line-width"].specification), mm.useIntegerZoom = !0);
                        }
                        _handleSpecialPaintPropertyUpdate(Qe) {
                            if ("line-gradient" === Qe) {
                                const Qe = this.gradientExpression();
                                this.stepInterpolant = !!function(Qe) {
                                    return void 0 !== Qe._styleExpression;
                                }(Qe) && Qe._styleExpression.expression instanceof ee, this.gradientVersion = (this.gradientVersion + 1) % Number.MAX_SAFE_INTEGER;
                            }
                        }
                        gradientExpression() {
                            return this._transitionablePaint._values["line-gradient"].value.expression;
                        }
                        recalculate(Qe, rt) {
                            super.recalculate(Qe, rt), this.paint._values["line-floorwidth"] = mm.possiblyEvaluate(this._transitioningPaint._values["line-width"].value, Qe);
                        }
                        createBucket(Qe) {
                            return new Fl(Qe);
                        }
                        queryRadius(Qe) {
                            const rt = Qe, Wn = jl(Uo("line-width", this, rt), Uo("line-gap-width", this, rt)), Co = Uo("line-offset", this, rt);
                            return Wn / 2 + Math.abs(Co) + Go(this.paint.get("line-translate"));
                        }
                        queryIntersectsFeature(Qe) {
                            let { queryGeometry: rt, feature: Wn, featureState: Co, geometry: Ll, transform: Rl, pixelsToTileUnits: Ul } = Qe;
                            const Gl = Zo(rt, this.paint.get("line-translate"), this.paint.get("line-translate-anchor"), -Rl.bearingInRadians, Ul), Zl = Ul / 2 * jl(this.paint.get("line-width").evaluate(Wn, Co), this.paint.get("line-gap-width").evaluate(Wn, Co)), Hl = this.paint.get("line-offset").evaluate(Wn, Co);
                            return Hl && (Ll = function(Qe, rt) {
                                const Wn = [];
                                for(let Co = 0; Co < Qe.length; Co++){
                                    const Ll = Qe[Co], Rl = [];
                                    for(let Qe = 0; Qe < Ll.length; Qe++){
                                        const Wn = Ll[Qe - 1], Co = Ll[Qe], Ul = Ll[Qe + 1], Gl = 0 === Qe ? new Dl(0, 0) : Co.sub(Wn)._unit()._perp(), Zl = Qe === Ll.length - 1 ? new Dl(0, 0) : Ul.sub(Co)._unit()._perp(), Hl = Gl._add(Zl)._unit(), ql = Hl.x * Zl.x + Hl.y * Zl.y;
                                        0 !== ql && Hl._mult(1 / ql), Rl.push(Hl._mult(rt)._add(Co));
                                    }
                                    Wn.push(Rl);
                                }
                                return Wn;
                            }(Ll, Hl * Ul)), function(Qe, rt, Wn) {
                                for(let Co = 0; Co < rt.length; Co++){
                                    const Dl = rt[Co];
                                    if (Qe.length >= 3) {
                                        for(let rt = 0; rt < Dl.length; rt++)if (jo(Qe, Dl[rt])) return !0;
                                    }
                                    if (Do(Qe, Dl, Wn)) return !0;
                                }
                                return !1;
                            }(Gl, Ll, Zl);
                        }
                        isTileClipped() {
                            return !0;
                        }
                    }
                    function jl(Qe, rt) {
                        return rt > 0 ? rt + 2 * Qe : Qe;
                    }
                    const fm = Ki([
                        {
                            name: "a_pos_offset",
                            components: 4,
                            type: "Int16"
                        },
                        {
                            name: "a_data",
                            components: 4,
                            type: "Uint16"
                        },
                        {
                            name: "a_pixeloffset",
                            components: 4,
                            type: "Int16"
                        }
                    ], 4), gm = Ki([
                        {
                            name: "a_projected_pos",
                            components: 3,
                            type: "Float32"
                        }
                    ], 4);
                    Ki([
                        {
                            name: "a_fade_opacity",
                            components: 1,
                            type: "Uint32"
                        }
                    ], 4);
                    const Am = Ki([
                        {
                            name: "a_placed",
                            components: 2,
                            type: "Uint8"
                        },
                        {
                            name: "a_shift",
                            components: 2,
                            type: "Float32"
                        },
                        {
                            name: "a_box_real",
                            components: 2,
                            type: "Int16"
                        }
                    ]);
                    Ki([
                        {
                            type: "Int16",
                            name: "anchorPointX"
                        },
                        {
                            type: "Int16",
                            name: "anchorPointY"
                        },
                        {
                            type: "Int16",
                            name: "x1"
                        },
                        {
                            type: "Int16",
                            name: "y1"
                        },
                        {
                            type: "Int16",
                            name: "x2"
                        },
                        {
                            type: "Int16",
                            name: "y2"
                        },
                        {
                            type: "Uint32",
                            name: "featureIndex"
                        },
                        {
                            type: "Uint16",
                            name: "sourceLayerIndex"
                        },
                        {
                            type: "Uint16",
                            name: "bucketIndex"
                        }
                    ]);
                    const ym = Ki([
                        {
                            name: "a_pos",
                            components: 2,
                            type: "Int16"
                        },
                        {
                            name: "a_anchor_pos",
                            components: 2,
                            type: "Int16"
                        },
                        {
                            name: "a_extrude",
                            components: 2,
                            type: "Int16"
                        }
                    ], 4);
                    function Xl(Qe, rt, Wn) {
                        return Qe.sections.forEach((Qe)=>{
                            Qe.text = function(Qe, rt, Wn) {
                                const Co = rt.layout.get("text-transform").evaluate(Wn, {});
                                return "uppercase" === Co ? Qe = Qe.toLocaleUpperCase() : "lowercase" === Co && (Qe = Qe.toLocaleLowerCase()), Yd.applyArabicShaping && (Qe = Yd.applyArabicShaping(Qe)), Qe;
                            }(Qe.text, rt, Wn);
                        }), Qe;
                    }
                    Ki([
                        {
                            name: "a_pos",
                            components: 2,
                            type: "Float32"
                        },
                        {
                            name: "a_radius",
                            components: 1,
                            type: "Float32"
                        },
                        {
                            name: "a_flags",
                            components: 2,
                            type: "Int16"
                        }
                    ], 4), Ki([
                        {
                            name: "triangle",
                            components: 3,
                            type: "Uint16"
                        }
                    ]), Ki([
                        {
                            type: "Int16",
                            name: "anchorX"
                        },
                        {
                            type: "Int16",
                            name: "anchorY"
                        },
                        {
                            type: "Uint16",
                            name: "glyphStartIndex"
                        },
                        {
                            type: "Uint16",
                            name: "numGlyphs"
                        },
                        {
                            type: "Uint32",
                            name: "vertexStartIndex"
                        },
                        {
                            type: "Uint32",
                            name: "lineStartIndex"
                        },
                        {
                            type: "Uint32",
                            name: "lineLength"
                        },
                        {
                            type: "Uint16",
                            name: "segment"
                        },
                        {
                            type: "Uint16",
                            name: "lowerSize"
                        },
                        {
                            type: "Uint16",
                            name: "upperSize"
                        },
                        {
                            type: "Float32",
                            name: "lineOffsetX"
                        },
                        {
                            type: "Float32",
                            name: "lineOffsetY"
                        },
                        {
                            type: "Uint8",
                            name: "writingMode"
                        },
                        {
                            type: "Uint8",
                            name: "placedOrientation"
                        },
                        {
                            type: "Uint8",
                            name: "hidden"
                        },
                        {
                            type: "Uint32",
                            name: "crossTileID"
                        },
                        {
                            type: "Int16",
                            name: "associatedIconIndex"
                        }
                    ]), Ki([
                        {
                            type: "Int16",
                            name: "anchorX"
                        },
                        {
                            type: "Int16",
                            name: "anchorY"
                        },
                        {
                            type: "Int16",
                            name: "rightJustifiedTextSymbolIndex"
                        },
                        {
                            type: "Int16",
                            name: "centerJustifiedTextSymbolIndex"
                        },
                        {
                            type: "Int16",
                            name: "leftJustifiedTextSymbolIndex"
                        },
                        {
                            type: "Int16",
                            name: "verticalPlacedTextSymbolIndex"
                        },
                        {
                            type: "Int16",
                            name: "placedIconSymbolIndex"
                        },
                        {
                            type: "Int16",
                            name: "verticalPlacedIconSymbolIndex"
                        },
                        {
                            type: "Uint16",
                            name: "key"
                        },
                        {
                            type: "Uint16",
                            name: "textBoxStartIndex"
                        },
                        {
                            type: "Uint16",
                            name: "textBoxEndIndex"
                        },
                        {
                            type: "Uint16",
                            name: "verticalTextBoxStartIndex"
                        },
                        {
                            type: "Uint16",
                            name: "verticalTextBoxEndIndex"
                        },
                        {
                            type: "Uint16",
                            name: "iconBoxStartIndex"
                        },
                        {
                            type: "Uint16",
                            name: "iconBoxEndIndex"
                        },
                        {
                            type: "Uint16",
                            name: "verticalIconBoxStartIndex"
                        },
                        {
                            type: "Uint16",
                            name: "verticalIconBoxEndIndex"
                        },
                        {
                            type: "Uint16",
                            name: "featureIndex"
                        },
                        {
                            type: "Uint16",
                            name: "numHorizontalGlyphVertices"
                        },
                        {
                            type: "Uint16",
                            name: "numVerticalGlyphVertices"
                        },
                        {
                            type: "Uint16",
                            name: "numIconVertices"
                        },
                        {
                            type: "Uint16",
                            name: "numVerticalIconVertices"
                        },
                        {
                            type: "Uint16",
                            name: "useRuntimeCollisionCircles"
                        },
                        {
                            type: "Uint32",
                            name: "crossTileID"
                        },
                        {
                            type: "Float32",
                            name: "textBoxScale"
                        },
                        {
                            type: "Float32",
                            name: "collisionCircleDiameter"
                        },
                        {
                            type: "Uint16",
                            name: "textAnchorOffsetStartIndex"
                        },
                        {
                            type: "Uint16",
                            name: "textAnchorOffsetEndIndex"
                        }
                    ]), Ki([
                        {
                            type: "Float32",
                            name: "offsetX"
                        }
                    ]), Ki([
                        {
                            type: "Int16",
                            name: "x"
                        },
                        {
                            type: "Int16",
                            name: "y"
                        },
                        {
                            type: "Int16",
                            name: "tileUnitDistanceFromAnchor"
                        }
                    ]), Ki([
                        {
                            type: "Uint16",
                            name: "textAnchor"
                        },
                        {
                            type: "Float32",
                            components: 2,
                            name: "textOffset"
                        }
                    ]);
                    const vm = {
                        "!": "\uFE15",
                        "#": "\uFF03",
                        $: "\uFF04",
                        "%": "\uFF05",
                        "&": "\uFF06",
                        "(": "\uFE35",
                        ")": "\uFE36",
                        "*": "\uFF0A",
                        "+": "\uFF0B",
                        ",": "\uFE10",
                        "-": "\uFE32",
                        ".": "\u30FB",
                        "/": "\uFF0F",
                        ":": "\uFE13",
                        ";": "\uFE14",
                        "<": "\uFE3F",
                        "=": "\uFF1D",
                        ">": "\uFE40",
                        "?": "\uFE16",
                        "@": "\uFF20",
                        "[": "\uFE47",
                        "\\": "\uFF3C",
                        "]": "\uFE48",
                        "^": "\uFF3E",
                        _: "\uFE33",
                        "`": "\uFF40",
                        "{": "\uFE37",
                        "|": "\u2015",
                        "}": "\uFE38",
                        "~": "\uFF5E",
                        "\xa2": "\uFFE0",
                        "\xa3": "\uFFE1",
                        "\xa5": "\uFFE5",
                        "\xa6": "\uFFE4",
                        "\xac": "\uFFE2",
                        "\xaf": "\uFFE3",
                        "\u2013": "\uFE32",
                        "\u2014": "\uFE31",
                        "\u2018": "\uFE43",
                        "\u2019": "\uFE44",
                        "\u201C": "\uFE41",
                        "\u201D": "\uFE42",
                        "\u2026": "\uFE19",
                        "\u2027": "\u30FB",
                        "\u20A9": "\uFFE6",
                        "\u3001": "\uFE11",
                        "\u3002": "\uFE12",
                        "\u3008": "\uFE3F",
                        "\u3009": "\uFE40",
                        "\u300A": "\uFE3D",
                        "\u300B": "\uFE3E",
                        "\u300C": "\uFE41",
                        "\u300D": "\uFE42",
                        "\u300E": "\uFE43",
                        "\u300F": "\uFE44",
                        "\u3010": "\uFE3B",
                        "\u3011": "\uFE3C",
                        "\u3014": "\uFE39",
                        "\u3015": "\uFE3A",
                        "\u3016": "\uFE17",
                        "\u3017": "\uFE18",
                        "\uFF01": "\uFE15",
                        "\uFF08": "\uFE35",
                        "\uFF09": "\uFE36",
                        "\uFF0C": "\uFE10",
                        "\uFF0D": "\uFE32",
                        "\uFF0E": "\u30FB",
                        "\uFF1A": "\uFE13",
                        "\uFF1B": "\uFE14",
                        "\uFF1C": "\uFE3F",
                        "\uFF1E": "\uFE40",
                        "\uFF1F": "\uFE16",
                        "\uFF3B": "\uFE47",
                        "\uFF3D": "\uFE48",
                        "\uFF3F": "\uFE33",
                        "\uFF5B": "\uFE37",
                        "\uFF5C": "\u2015",
                        "\uFF5D": "\uFE38",
                        "\uFF5F": "\uFE35",
                        "\uFF60": "\uFE36",
                        "\uFF61": "\uFE12",
                        "\uFF62": "\uFE41",
                        "\uFF63": "\uFE42"
                    };
                    var _m, xm, bm, wm = 24, Em = {};
                    function eu() {
                        if (bm) return xm;
                        bm = 1, xm = e;
                        var Qe = (_m || (_m = 1, Em.read = function(Qe, rt, Wn, Co, Dl) {
                            var Ll, Rl, Ul = 8 * Dl - Co - 1, Gl = (1 << Ul) - 1, Zl = Gl >> 1, Hl = -7, ql = Wn ? Dl - 1 : 0, Ql = Wn ? -1 : 1, Kl = Qe[rt + ql];
                            for(ql += Ql, Ll = Kl & (1 << -Hl) - 1, Kl >>= -Hl, Hl += Ul; Hl > 0; Ll = 256 * Ll + Qe[rt + ql], ql += Ql, Hl -= 8);
                            for(Rl = Ll & (1 << -Hl) - 1, Ll >>= -Hl, Hl += Co; Hl > 0; Rl = 256 * Rl + Qe[rt + ql], ql += Ql, Hl -= 8);
                            if (0 === Ll) Ll = 1 - Zl;
                            else {
                                if (Ll === Gl) return Rl ? NaN : 1 / 0 * (Kl ? -1 : 1);
                                Rl += Math.pow(2, Co), Ll -= Zl;
                            }
                            return (Kl ? -1 : 1) * Rl * Math.pow(2, Ll - Co);
                        }, Em.write = function(Qe, rt, Wn, Co, Dl, Ll) {
                            var Rl, Ul, Gl, Zl = 8 * Ll - Dl - 1, Hl = (1 << Zl) - 1, ql = Hl >> 1, Ql = 23 === Dl ? Math.pow(2, -24) - Math.pow(2, -77) : 0, Kl = Co ? 0 : Ll - 1, $l = Co ? 1 : -1, Tc = rt < 0 || 0 === rt && 1 / rt < 0 ? 1 : 0;
                            for(rt = Math.abs(rt), isNaN(rt) || rt === 1 / 0 ? (Ul = isNaN(rt) ? 1 : 0, Rl = Hl) : (Rl = Math.floor(Math.log(rt) / Math.LN2), rt * (Gl = Math.pow(2, -Rl)) < 1 && (Rl--, Gl *= 2), (rt += Rl + ql >= 1 ? Ql / Gl : Ql * Math.pow(2, 1 - ql)) * Gl >= 2 && (Rl++, Gl /= 2), Rl + ql >= Hl ? (Ul = 0, Rl = Hl) : Rl + ql >= 1 ? (Ul = (rt * Gl - 1) * Math.pow(2, Dl), Rl += ql) : (Ul = rt * Math.pow(2, ql - 1) * Math.pow(2, Dl), Rl = 0)); Dl >= 8; Qe[Wn + Kl] = 255 & Ul, Kl += $l, Ul /= 256, Dl -= 8);
                            for(Rl = Rl << Dl | Ul, Zl += Dl; Zl > 0; Qe[Wn + Kl] = 255 & Rl, Kl += $l, Rl /= 256, Zl -= 8);
                            Qe[Wn + Kl - $l] |= 128 * Tc;
                        }), Em);
                        function e(Qe) {
                            this.buf = ArrayBuffer.isView && ArrayBuffer.isView(Qe) ? Qe : new Uint8Array(Qe || 0), this.pos = 0, this.type = 0, this.length = this.buf.length;
                        }
                        e.Varint = 0, e.Fixed64 = 1, e.Bytes = 2, e.Fixed32 = 5;
                        var rt = 4294967296, Wn = 1 / rt, Co = "undefined" == typeof TextDecoder ? null : new TextDecoder("utf-8");
                        function s(Qe) {
                            return Qe.type === e.Bytes ? Qe.readVarint() + Qe.pos : Qe.pos + 1;
                        }
                        function o(Qe, rt, Wn) {
                            return Wn ? 4294967296 * rt + (Qe >>> 0) : 4294967296 * (rt >>> 0) + (Qe >>> 0);
                        }
                        function a(Qe, rt, Wn) {
                            var Co = rt <= 16383 ? 1 : rt <= 2097151 ? 2 : rt <= 268435455 ? 3 : Math.floor(Math.log(rt) / (7 * Math.LN2));
                            Wn.realloc(Co);
                            for(var Dl = Wn.pos - 1; Dl >= Qe; Dl--)Wn.buf[Dl + Co] = Wn.buf[Dl];
                        }
                        function l(Qe, rt) {
                            for(var Wn = 0; Wn < Qe.length; Wn++)rt.writeVarint(Qe[Wn]);
                        }
                        function u(Qe, rt) {
                            for(var Wn = 0; Wn < Qe.length; Wn++)rt.writeSVarint(Qe[Wn]);
                        }
                        function c(Qe, rt) {
                            for(var Wn = 0; Wn < Qe.length; Wn++)rt.writeFloat(Qe[Wn]);
                        }
                        function h(Qe, rt) {
                            for(var Wn = 0; Wn < Qe.length; Wn++)rt.writeDouble(Qe[Wn]);
                        }
                        function p(Qe, rt) {
                            for(var Wn = 0; Wn < Qe.length; Wn++)rt.writeBoolean(Qe[Wn]);
                        }
                        function f(Qe, rt) {
                            for(var Wn = 0; Wn < Qe.length; Wn++)rt.writeFixed32(Qe[Wn]);
                        }
                        function d(Qe, rt) {
                            for(var Wn = 0; Wn < Qe.length; Wn++)rt.writeSFixed32(Qe[Wn]);
                        }
                        function y(Qe, rt) {
                            for(var Wn = 0; Wn < Qe.length; Wn++)rt.writeFixed64(Qe[Wn]);
                        }
                        function m(Qe, rt) {
                            for(var Wn = 0; Wn < Qe.length; Wn++)rt.writeSFixed64(Qe[Wn]);
                        }
                        function g(Qe, rt) {
                            return (Qe[rt] | Qe[rt + 1] << 8 | Qe[rt + 2] << 16) + 16777216 * Qe[rt + 3];
                        }
                        function x(Qe, rt, Wn) {
                            Qe[Wn] = rt, Qe[Wn + 1] = rt >>> 8, Qe[Wn + 2] = rt >>> 16, Qe[Wn + 3] = rt >>> 24;
                        }
                        function v(Qe, rt) {
                            return (Qe[rt] | Qe[rt + 1] << 8 | Qe[rt + 2] << 16) + (Qe[rt + 3] << 24);
                        }
                        return e.prototype = {
                            destroy: function() {
                                this.buf = null;
                            },
                            readFields: function(Qe, rt, Wn) {
                                for(Wn = Wn || this.length; this.pos < Wn;){
                                    var Co = this.readVarint(), Dl = Co >> 3, Ll = this.pos;
                                    this.type = 7 & Co, Qe(Dl, rt, this), this.pos === Ll && this.skip(Co);
                                }
                                return rt;
                            },
                            readMessage: function(Qe, rt) {
                                return this.readFields(Qe, rt, this.readVarint() + this.pos);
                            },
                            readFixed32: function() {
                                var Qe = g(this.buf, this.pos);
                                return this.pos += 4, Qe;
                            },
                            readSFixed32: function() {
                                var Qe = v(this.buf, this.pos);
                                return this.pos += 4, Qe;
                            },
                            readFixed64: function() {
                                var Qe = g(this.buf, this.pos) + g(this.buf, this.pos + 4) * rt;
                                return this.pos += 8, Qe;
                            },
                            readSFixed64: function() {
                                var Qe = g(this.buf, this.pos) + v(this.buf, this.pos + 4) * rt;
                                return this.pos += 8, Qe;
                            },
                            readFloat: function() {
                                var rt = Qe.read(this.buf, this.pos, !0, 23, 4);
                                return this.pos += 4, rt;
                            },
                            readDouble: function() {
                                var rt = Qe.read(this.buf, this.pos, !0, 52, 8);
                                return this.pos += 8, rt;
                            },
                            readVarint: function(Qe) {
                                var rt, Wn, Co = this.buf;
                                return rt = 127 & (Wn = Co[this.pos++]), Wn < 128 ? rt : (rt |= (127 & (Wn = Co[this.pos++])) << 7, Wn < 128 ? rt : (rt |= (127 & (Wn = Co[this.pos++])) << 14, Wn < 128 ? rt : (rt |= (127 & (Wn = Co[this.pos++])) << 21, Wn < 128 ? rt : function(Qe, rt, Wn) {
                                    var Co, Dl, Ll = Wn.buf;
                                    if (Co = (112 & (Dl = Ll[Wn.pos++])) >> 4, Dl < 128) return o(Qe, Co, rt);
                                    if (Co |= (127 & (Dl = Ll[Wn.pos++])) << 3, Dl < 128) return o(Qe, Co, rt);
                                    if (Co |= (127 & (Dl = Ll[Wn.pos++])) << 10, Dl < 128) return o(Qe, Co, rt);
                                    if (Co |= (127 & (Dl = Ll[Wn.pos++])) << 17, Dl < 128) return o(Qe, Co, rt);
                                    if (Co |= (127 & (Dl = Ll[Wn.pos++])) << 24, Dl < 128) return o(Qe, Co, rt);
                                    if (Co |= (1 & (Dl = Ll[Wn.pos++])) << 31, Dl < 128) return o(Qe, Co, rt);
                                    throw new Error("Expected varint not more than 10 bytes");
                                }(rt |= (15 & (Wn = Co[this.pos])) << 28, Qe, this))));
                            },
                            readVarint64: function() {
                                return this.readVarint(!0);
                            },
                            readSVarint: function() {
                                var Qe = this.readVarint();
                                return Qe % 2 == 1 ? (Qe + 1) / -2 : Qe / 2;
                            },
                            readBoolean: function() {
                                return Boolean(this.readVarint());
                            },
                            readString: function() {
                                var Qe = this.readVarint() + this.pos, rt = this.pos;
                                return this.pos = Qe, Qe - rt >= 12 && Co ? function(Qe, rt, Wn) {
                                    return Co.decode(Qe.subarray(rt, Wn));
                                }(this.buf, rt, Qe) : function(Qe, rt, Wn) {
                                    for(var Co = "", Dl = rt; Dl < Wn;){
                                        var Ll, Rl, Ul, Gl = Qe[Dl], Zl = null, Hl = Gl > 239 ? 4 : Gl > 223 ? 3 : Gl > 191 ? 2 : 1;
                                        if (Dl + Hl > Wn) break;
                                        1 === Hl ? Gl < 128 && (Zl = Gl) : 2 === Hl ? 128 == (192 & (Ll = Qe[Dl + 1])) && (Zl = (31 & Gl) << 6 | 63 & Ll) <= 127 && (Zl = null) : 3 === Hl ? (Rl = Qe[Dl + 2], 128 == (192 & (Ll = Qe[Dl + 1])) && 128 == (192 & Rl) && ((Zl = (15 & Gl) << 12 | (63 & Ll) << 6 | 63 & Rl) <= 2047 || Zl >= 55296 && Zl <= 57343) && (Zl = null)) : 4 === Hl && (Rl = Qe[Dl + 2], Ul = Qe[Dl + 3], 128 == (192 & (Ll = Qe[Dl + 1])) && 128 == (192 & Rl) && 128 == (192 & Ul) && ((Zl = (15 & Gl) << 18 | (63 & Ll) << 12 | (63 & Rl) << 6 | 63 & Ul) <= 65535 || Zl >= 1114112) && (Zl = null)), null === Zl ? (Zl = 65533, Hl = 1) : Zl > 65535 && (Zl -= 65536, Co += String.fromCharCode(Zl >>> 10 & 1023 | 55296), Zl = 56320 | 1023 & Zl), Co += String.fromCharCode(Zl), Dl += Hl;
                                    }
                                    return Co;
                                }(this.buf, rt, Qe);
                            },
                            readBytes: function() {
                                var Qe = this.readVarint() + this.pos, rt = this.buf.subarray(this.pos, Qe);
                                return this.pos = Qe, rt;
                            },
                            readPackedVarint: function(Qe, rt) {
                                if (this.type !== e.Bytes) return Qe.push(this.readVarint(rt));
                                var Wn = s(this);
                                for(Qe = Qe || []; this.pos < Wn;)Qe.push(this.readVarint(rt));
                                return Qe;
                            },
                            readPackedSVarint: function(Qe) {
                                if (this.type !== e.Bytes) return Qe.push(this.readSVarint());
                                var rt = s(this);
                                for(Qe = Qe || []; this.pos < rt;)Qe.push(this.readSVarint());
                                return Qe;
                            },
                            readPackedBoolean: function(Qe) {
                                if (this.type !== e.Bytes) return Qe.push(this.readBoolean());
                                var rt = s(this);
                                for(Qe = Qe || []; this.pos < rt;)Qe.push(this.readBoolean());
                                return Qe;
                            },
                            readPackedFloat: function(Qe) {
                                if (this.type !== e.Bytes) return Qe.push(this.readFloat());
                                var rt = s(this);
                                for(Qe = Qe || []; this.pos < rt;)Qe.push(this.readFloat());
                                return Qe;
                            },
                            readPackedDouble: function(Qe) {
                                if (this.type !== e.Bytes) return Qe.push(this.readDouble());
                                var rt = s(this);
                                for(Qe = Qe || []; this.pos < rt;)Qe.push(this.readDouble());
                                return Qe;
                            },
                            readPackedFixed32: function(Qe) {
                                if (this.type !== e.Bytes) return Qe.push(this.readFixed32());
                                var rt = s(this);
                                for(Qe = Qe || []; this.pos < rt;)Qe.push(this.readFixed32());
                                return Qe;
                            },
                            readPackedSFixed32: function(Qe) {
                                if (this.type !== e.Bytes) return Qe.push(this.readSFixed32());
                                var rt = s(this);
                                for(Qe = Qe || []; this.pos < rt;)Qe.push(this.readSFixed32());
                                return Qe;
                            },
                            readPackedFixed64: function(Qe) {
                                if (this.type !== e.Bytes) return Qe.push(this.readFixed64());
                                var rt = s(this);
                                for(Qe = Qe || []; this.pos < rt;)Qe.push(this.readFixed64());
                                return Qe;
                            },
                            readPackedSFixed64: function(Qe) {
                                if (this.type !== e.Bytes) return Qe.push(this.readSFixed64());
                                var rt = s(this);
                                for(Qe = Qe || []; this.pos < rt;)Qe.push(this.readSFixed64());
                                return Qe;
                            },
                            skip: function(Qe) {
                                var rt = 7 & Qe;
                                if (rt === e.Varint) for(; this.buf[this.pos++] > 127;);
                                else if (rt === e.Bytes) this.pos = this.readVarint() + this.pos;
                                else if (rt === e.Fixed32) this.pos += 4;
                                else {
                                    if (rt !== e.Fixed64) throw new Error("Unimplemented type: " + rt);
                                    this.pos += 8;
                                }
                            },
                            writeTag: function(Qe, rt) {
                                this.writeVarint(Qe << 3 | rt);
                            },
                            realloc: function(Qe) {
                                for(var rt = this.length || 16; rt < this.pos + Qe;)rt *= 2;
                                if (rt !== this.length) {
                                    var Wn = new Uint8Array(rt);
                                    Wn.set(this.buf), this.buf = Wn, this.length = rt;
                                }
                            },
                            finish: function() {
                                return this.length = this.pos, this.pos = 0, this.buf.subarray(0, this.length);
                            },
                            writeFixed32: function(Qe) {
                                this.realloc(4), x(this.buf, Qe, this.pos), this.pos += 4;
                            },
                            writeSFixed32: function(Qe) {
                                this.realloc(4), x(this.buf, Qe, this.pos), this.pos += 4;
                            },
                            writeFixed64: function(Qe) {
                                this.realloc(8), x(this.buf, -1 & Qe, this.pos), x(this.buf, Math.floor(Qe * Wn), this.pos + 4), this.pos += 8;
                            },
                            writeSFixed64: function(Qe) {
                                this.realloc(8), x(this.buf, -1 & Qe, this.pos), x(this.buf, Math.floor(Qe * Wn), this.pos + 4), this.pos += 8;
                            },
                            writeVarint: function(Qe) {
                                (Qe = +Qe || 0) > 268435455 || Qe < 0 ? function(Qe, rt) {
                                    var Wn, Co;
                                    if (Qe >= 0 ? (Wn = Qe % 4294967296 | 0, Co = Qe / 4294967296 | 0) : (Co = ~(-Qe / 4294967296), 4294967295 ^ (Wn = ~(-Qe % 4294967296)) ? Wn = Wn + 1 | 0 : (Wn = 0, Co = Co + 1 | 0)), Qe >= 0x10000000000000000 || Qe < -18446744073709552000) throw new Error("Given varint doesn't fit into 10 bytes");
                                    rt.realloc(10), function(Qe, rt, Wn) {
                                        Wn.buf[Wn.pos++] = 127 & Qe | 128, Qe >>>= 7, Wn.buf[Wn.pos++] = 127 & Qe | 128, Qe >>>= 7, Wn.buf[Wn.pos++] = 127 & Qe | 128, Qe >>>= 7, Wn.buf[Wn.pos++] = 127 & Qe | 128, Wn.buf[Wn.pos] = 127 & (Qe >>>= 7);
                                    }(Wn, 0, rt), function(Qe, rt) {
                                        var Wn = (7 & Qe) << 4;
                                        rt.buf[rt.pos++] |= Wn | ((Qe >>>= 3) ? 128 : 0), Qe && (rt.buf[rt.pos++] = 127 & Qe | ((Qe >>>= 7) ? 128 : 0), Qe && (rt.buf[rt.pos++] = 127 & Qe | ((Qe >>>= 7) ? 128 : 0), Qe && (rt.buf[rt.pos++] = 127 & Qe | ((Qe >>>= 7) ? 128 : 0), Qe && (rt.buf[rt.pos++] = 127 & Qe | ((Qe >>>= 7) ? 128 : 0), Qe && (rt.buf[rt.pos++] = 127 & Qe)))));
                                    }(Co, rt);
                                }(Qe, this) : (this.realloc(4), this.buf[this.pos++] = 127 & Qe | (Qe > 127 ? 128 : 0), Qe <= 127 || (this.buf[this.pos++] = 127 & (Qe >>>= 7) | (Qe > 127 ? 128 : 0), Qe <= 127 || (this.buf[this.pos++] = 127 & (Qe >>>= 7) | (Qe > 127 ? 128 : 0), Qe <= 127 || (this.buf[this.pos++] = Qe >>> 7 & 127))));
                            },
                            writeSVarint: function(Qe) {
                                this.writeVarint(Qe < 0 ? 2 * -Qe - 1 : 2 * Qe);
                            },
                            writeBoolean: function(Qe) {
                                this.writeVarint(Boolean(Qe));
                            },
                            writeString: function(Qe) {
                                Qe = String(Qe), this.realloc(4 * Qe.length), this.pos++;
                                var rt = this.pos;
                                this.pos = function(Qe, rt, Wn) {
                                    for(var Co, Dl, Ll = 0; Ll < rt.length; Ll++){
                                        if ((Co = rt.charCodeAt(Ll)) > 55295 && Co < 57344) {
                                            if (!Dl) {
                                                Co > 56319 || Ll + 1 === rt.length ? (Qe[Wn++] = 239, Qe[Wn++] = 191, Qe[Wn++] = 189) : Dl = Co;
                                                continue;
                                            }
                                            if (Co < 56320) {
                                                Qe[Wn++] = 239, Qe[Wn++] = 191, Qe[Wn++] = 189, Dl = Co;
                                                continue;
                                            }
                                            Co = Dl - 55296 << 10 | Co - 56320 | 65536, Dl = null;
                                        } else Dl && (Qe[Wn++] = 239, Qe[Wn++] = 191, Qe[Wn++] = 189, Dl = null);
                                        Co < 128 ? Qe[Wn++] = Co : (Co < 2048 ? Qe[Wn++] = Co >> 6 | 192 : (Co < 65536 ? Qe[Wn++] = Co >> 12 | 224 : (Qe[Wn++] = Co >> 18 | 240, Qe[Wn++] = Co >> 12 & 63 | 128), Qe[Wn++] = Co >> 6 & 63 | 128), Qe[Wn++] = 63 & Co | 128);
                                    }
                                    return Wn;
                                }(this.buf, Qe, this.pos);
                                var Wn = this.pos - rt;
                                Wn >= 128 && a(rt, Wn, this), this.pos = rt - 1, this.writeVarint(Wn), this.pos += Wn;
                            },
                            writeFloat: function(rt) {
                                this.realloc(4), Qe.write(this.buf, rt, this.pos, !0, 23, 4), this.pos += 4;
                            },
                            writeDouble: function(rt) {
                                this.realloc(8), Qe.write(this.buf, rt, this.pos, !0, 52, 8), this.pos += 8;
                            },
                            writeBytes: function(Qe) {
                                var rt = Qe.length;
                                this.writeVarint(rt), this.realloc(rt);
                                for(var Wn = 0; Wn < rt; Wn++)this.buf[this.pos++] = Qe[Wn];
                            },
                            writeRawMessage: function(Qe, rt) {
                                this.pos++;
                                var Wn = this.pos;
                                Qe(rt, this);
                                var Co = this.pos - Wn;
                                Co >= 128 && a(Wn, Co, this), this.pos = Wn - 1, this.writeVarint(Co), this.pos += Co;
                            },
                            writeMessage: function(Qe, rt, Wn) {
                                this.writeTag(Qe, e.Bytes), this.writeRawMessage(rt, Wn);
                            },
                            writePackedVarint: function(Qe, rt) {
                                rt.length && this.writeMessage(Qe, l, rt);
                            },
                            writePackedSVarint: function(Qe, rt) {
                                rt.length && this.writeMessage(Qe, u, rt);
                            },
                            writePackedBoolean: function(Qe, rt) {
                                rt.length && this.writeMessage(Qe, p, rt);
                            },
                            writePackedFloat: function(Qe, rt) {
                                rt.length && this.writeMessage(Qe, c, rt);
                            },
                            writePackedDouble: function(Qe, rt) {
                                rt.length && this.writeMessage(Qe, h, rt);
                            },
                            writePackedFixed32: function(Qe, rt) {
                                rt.length && this.writeMessage(Qe, f, rt);
                            },
                            writePackedSFixed32: function(Qe, rt) {
                                rt.length && this.writeMessage(Qe, d, rt);
                            },
                            writePackedFixed64: function(Qe, rt) {
                                rt.length && this.writeMessage(Qe, y, rt);
                            },
                            writePackedSFixed64: function(Qe, rt) {
                                rt.length && this.writeMessage(Qe, m, rt);
                            },
                            writeBytesField: function(Qe, rt) {
                                this.writeTag(Qe, e.Bytes), this.writeBytes(rt);
                            },
                            writeFixed32Field: function(Qe, rt) {
                                this.writeTag(Qe, e.Fixed32), this.writeFixed32(rt);
                            },
                            writeSFixed32Field: function(Qe, rt) {
                                this.writeTag(Qe, e.Fixed32), this.writeSFixed32(rt);
                            },
                            writeFixed64Field: function(Qe, rt) {
                                this.writeTag(Qe, e.Fixed64), this.writeFixed64(rt);
                            },
                            writeSFixed64Field: function(Qe, rt) {
                                this.writeTag(Qe, e.Fixed64), this.writeSFixed64(rt);
                            },
                            writeVarintField: function(Qe, rt) {
                                this.writeTag(Qe, e.Varint), this.writeVarint(rt);
                            },
                            writeSVarintField: function(Qe, rt) {
                                this.writeTag(Qe, e.Varint), this.writeSVarint(rt);
                            },
                            writeStringField: function(Qe, rt) {
                                this.writeTag(Qe, e.Bytes), this.writeString(rt);
                            },
                            writeFloatField: function(Qe, rt) {
                                this.writeTag(Qe, e.Fixed32), this.writeFloat(rt);
                            },
                            writeDoubleField: function(Qe, rt) {
                                this.writeTag(Qe, e.Fixed64), this.writeDouble(rt);
                            },
                            writeBooleanField: function(Qe, rt) {
                                this.writeVarintField(Qe, Boolean(rt));
                            }
                        }, xm;
                    }
                    var Mm = e(eu());
                    function iu(Qe) {
                        let rt = 0, Wn = 0;
                        for (const Rl of Qe)rt += Rl.w * Rl.h, Wn = Math.max(Wn, Rl.w);
                        Qe.sort((Qe, rt)=>rt.h - Qe.h);
                        const Co = [
                            {
                                x: 0,
                                y: 0,
                                w: Math.max(Math.ceil(Math.sqrt(rt / .95)), Wn),
                                h: 1 / 0
                            }
                        ];
                        let Dl = 0, Ll = 0;
                        for (const Rl of Qe)for(let Qe = Co.length - 1; Qe >= 0; Qe--){
                            const rt = Co[Qe];
                            if (!(Rl.w > rt.w || Rl.h > rt.h)) {
                                if (Rl.x = rt.x, Rl.y = rt.y, Ll = Math.max(Ll, Rl.y + Rl.h), Dl = Math.max(Dl, Rl.x + Rl.w), Rl.w === rt.w && Rl.h === rt.h) {
                                    const rt = Co.pop();
                                    Qe < Co.length && (Co[Qe] = rt);
                                } else Rl.h === rt.h ? (rt.x += Rl.w, rt.w -= Rl.w) : Rl.w === rt.w ? (rt.y += Rl.h, rt.h -= Rl.h) : (Co.push({
                                    x: rt.x + Rl.w,
                                    y: rt.y,
                                    w: rt.w - Rl.w,
                                    h: Rl.h
                                }), rt.y += Rl.h, rt.h -= Rl.h);
                                break;
                            }
                        }
                        return {
                            w: Dl,
                            h: Ll,
                            fill: rt / (Dl * Ll) || 0
                        };
                    }
                    class ou {
                        constructor(Qe, rt){
                            let { pixelRatio: Wn, version: Co, stretchX: Dl, stretchY: Ll, content: Rl, textFitWidth: Ul, textFitHeight: Gl } = rt;
                            this.paddedRect = Qe, this.pixelRatio = Wn, this.stretchX = Dl, this.stretchY = Ll, this.content = Rl, this.version = Co, this.textFitWidth = Ul, this.textFitHeight = Gl;
                        }
                        get tl() {
                            return [
                                this.paddedRect.x + 1,
                                this.paddedRect.y + 1
                            ];
                        }
                        get br() {
                            return [
                                this.paddedRect.x + this.paddedRect.w - 1,
                                this.paddedRect.y + this.paddedRect.h - 1
                            ];
                        }
                        get tlbr() {
                            return this.tl.concat(this.br);
                        }
                        get displaySize() {
                            return [
                                (this.paddedRect.w - 2) / this.pixelRatio,
                                (this.paddedRect.h - 2) / this.pixelRatio
                            ];
                        }
                    }
                    class au {
                        constructor(Qe, rt){
                            const Wn = {}, Co = {};
                            this.haveRenderCallbacks = [];
                            const Dl = [];
                            this.addImages(Qe, Wn, Dl), this.addImages(rt, Co, Dl);
                            const { w: Ll, h: Rl } = iu(Dl), Ul = new sa({
                                width: Ll || 1,
                                height: Rl || 1
                            });
                            for(const Gl in Qe){
                                const rt = Qe[Gl], Co = Wn[Gl].paddedRect;
                                sa.copy(rt.data, Ul, {
                                    x: 0,
                                    y: 0
                                }, {
                                    x: Co.x + 1,
                                    y: Co.y + 1
                                }, rt.data);
                            }
                            for(const Gl in rt){
                                const Qe = rt[Gl], Wn = Co[Gl].paddedRect, Dl = Wn.x + 1, Ll = Wn.y + 1, Rl = Qe.data.width, Zl = Qe.data.height;
                                sa.copy(Qe.data, Ul, {
                                    x: 0,
                                    y: 0
                                }, {
                                    x: Dl,
                                    y: Ll
                                }, Qe.data), sa.copy(Qe.data, Ul, {
                                    x: 0,
                                    y: Zl - 1
                                }, {
                                    x: Dl,
                                    y: Ll - 1
                                }, {
                                    width: Rl,
                                    height: 1
                                }), sa.copy(Qe.data, Ul, {
                                    x: 0,
                                    y: 0
                                }, {
                                    x: Dl,
                                    y: Ll + Zl
                                }, {
                                    width: Rl,
                                    height: 1
                                }), sa.copy(Qe.data, Ul, {
                                    x: Rl - 1,
                                    y: 0
                                }, {
                                    x: Dl - 1,
                                    y: Ll
                                }, {
                                    width: 1,
                                    height: Zl
                                }), sa.copy(Qe.data, Ul, {
                                    x: 0,
                                    y: 0
                                }, {
                                    x: Dl + Rl,
                                    y: Ll
                                }, {
                                    width: 1,
                                    height: Zl
                                });
                            }
                            this.image = Ul, this.iconPositions = Wn, this.patternPositions = Co;
                        }
                        addImages(Qe, rt, Wn) {
                            for(const Co in Qe){
                                const Dl = Qe[Co], Ll = {
                                    x: 0,
                                    y: 0,
                                    w: Dl.data.width + 2,
                                    h: Dl.data.height + 2
                                };
                                Wn.push(Ll), rt[Co] = new ou(Ll, Dl), Dl.hasRenderCallback && this.haveRenderCallbacks.push(Co);
                            }
                        }
                        patchUpdatedImages(Qe, rt) {
                            Qe.dispatchRenderCallbacks(this.haveRenderCallbacks);
                            for(const Wn in Qe.updatedImages)this.patchUpdatedImage(this.iconPositions[Wn], Qe.getImage(Wn), rt), this.patchUpdatedImage(this.patternPositions[Wn], Qe.getImage(Wn), rt);
                        }
                        patchUpdatedImage(Qe, rt, Wn) {
                            if (!Qe || !rt) return;
                            if (Qe.version === rt.version) return;
                            Qe.version = rt.version;
                            const [Co, Dl] = Qe.tl;
                            Wn.update(rt.data, void 0, {
                                x: Co,
                                y: Dl
                            });
                        }
                    }
                    var Sm;
                    Qn("ImagePosition", ou), Qn("ImageAtlas", au), function(Qe) {
                        Qe[Qe.none = 0] = "none", Qe[Qe.horizontal = 1] = "horizontal", Qe[Qe.vertical = 2] = "vertical", Qe[Qe.horizontalOnly = 3] = "horizontalOnly";
                    }(Sm || (Sm = {}));
                    const Tm = -17;
                    class cu {
                        constructor(){
                            this.scale = 1, this.fontStack = "", this.imageName = null, this.verticalAlign = "bottom";
                        }
                        static forText(Qe, rt, Wn) {
                            const Co = new cu;
                            return Co.scale = Qe || 1, Co.fontStack = rt, Co.verticalAlign = Wn || "bottom", Co;
                        }
                        static forImage(Qe, rt) {
                            const Wn = new cu;
                            return Wn.imageName = Qe, Wn.verticalAlign = rt || "bottom", Wn;
                        }
                    }
                    class hu {
                        constructor(){
                            this.text = "", this.sectionIndex = [], this.sections = [], this.imageSectionID = null;
                        }
                        static fromFeature(Qe, rt) {
                            const Wn = new hu;
                            for(let Co = 0; Co < Qe.sections.length; Co++){
                                const Dl = Qe.sections[Co];
                                Dl.image ? Wn.addImageSection(Dl) : Wn.addTextSection(Dl, rt);
                            }
                            return Wn;
                        }
                        length() {
                            return this.text.length;
                        }
                        getSection(Qe) {
                            return this.sections[this.sectionIndex[Qe]];
                        }
                        getSectionIndex(Qe) {
                            return this.sectionIndex[Qe];
                        }
                        getCharCode(Qe) {
                            return this.text.charCodeAt(Qe);
                        }
                        verticalizePunctuation() {
                            this.text = function(Qe) {
                                let rt = "";
                                for(let Wn = 0; Wn < Qe.length; Wn++){
                                    const Co = Qe.charCodeAt(Wn + 1) || null, Dl = Qe.charCodeAt(Wn - 1) || null;
                                    rt += Co && Ai(Co) && !vm[Qe[Wn + 1]] || Dl && Ai(Dl) && !vm[Qe[Wn - 1]] || !vm[Qe[Wn]] ? Qe[Wn] : vm[Qe[Wn]];
                                }
                                return rt;
                            }(this.text);
                        }
                        trim() {
                            let Qe = 0;
                            for(let Wn = 0; Wn < this.text.length && Cm[this.text.charCodeAt(Wn)]; Wn++)Qe++;
                            let rt = this.text.length;
                            for(let Wn = this.text.length - 1; Wn >= 0 && Wn >= Qe && Cm[this.text.charCodeAt(Wn)]; Wn--)rt--;
                            this.text = this.text.substring(Qe, rt), this.sectionIndex = this.sectionIndex.slice(Qe, rt);
                        }
                        substring(Qe, rt) {
                            const Wn = new hu;
                            return Wn.text = this.text.substring(Qe, rt), Wn.sectionIndex = this.sectionIndex.slice(Qe, rt), Wn.sections = this.sections, Wn;
                        }
                        toString() {
                            return this.text;
                        }
                        getMaxScale() {
                            return this.sectionIndex.reduce((Qe, rt)=>Math.max(Qe, this.sections[rt].scale), 0);
                        }
                        getMaxImageSize(Qe) {
                            let rt = 0, Wn = 0;
                            for(let Co = 0; Co < this.length(); Co++){
                                const Dl = this.getSection(Co);
                                if (Dl.imageName) {
                                    const Co = Qe[Dl.imageName];
                                    if (!Co) continue;
                                    const Ll = Co.displaySize;
                                    rt = Math.max(rt, Ll[0]), Wn = Math.max(Wn, Ll[1]);
                                }
                            }
                            return {
                                maxImageWidth: rt,
                                maxImageHeight: Wn
                            };
                        }
                        addTextSection(Qe, rt) {
                            this.text += Qe.text, this.sections.push(cu.forText(Qe.scale, Qe.fontStack || rt, Qe.verticalAlign));
                            const Wn = this.sections.length - 1;
                            for(let Co = 0; Co < Qe.text.length; ++Co)this.sectionIndex.push(Wn);
                        }
                        addImageSection(Qe) {
                            const rt = Qe.image ? Qe.image.name : "";
                            if (0 === rt.length) return void w("Can't add FormattedSection with an empty image.");
                            const Wn = this.getNextImageSectionCharCode();
                            Wn ? (this.text += String.fromCharCode(Wn), this.sections.push(cu.forImage(rt, Qe.verticalAlign)), this.sectionIndex.push(this.sections.length - 1)) : w("Reached maximum number of images 6401");
                        }
                        getNextImageSectionCharCode() {
                            return this.imageSectionID ? this.imageSectionID >= 63743 ? null : ++this.imageSectionID : (this.imageSectionID = 57344, this.imageSectionID);
                        }
                    }
                    function pu(Qe, rt, Wn, Co, Dl, Ll, Rl, Ul, Gl, Zl, Hl, ql, Ql, Kl, $l) {
                        const Tc = hu.fromFeature(Qe, Dl);
                        let tu;
                        ql === Sm.vertical && Tc.verticalizePunctuation();
                        const { processBidirectionalText: lu, processStyledBidirectionalText: du } = Yd;
                        if (lu && 1 === Tc.sections.length) {
                            tu = [];
                            const Qe = lu(Tc.toString(), wu(Tc, Zl, Ll, rt, Co, Kl));
                            for (const rt of Qe){
                                const Qe = new hu;
                                Qe.text = rt, Qe.sections = Tc.sections;
                                for(let Wn = 0; Wn < rt.length; Wn++)Qe.sectionIndex.push(0);
                                tu.push(Qe);
                            }
                        } else if (du) {
                            tu = [];
                            const Qe = du(Tc.text, Tc.sectionIndex, wu(Tc, Zl, Ll, rt, Co, Kl));
                            for (const rt of Qe){
                                const Qe = new hu;
                                Qe.text = rt[0], Qe.sectionIndex = rt[1], Qe.sections = Tc.sections, tu.push(Qe);
                            }
                        } else tu = function(Qe, rt) {
                            const Wn = [], Co = Qe.text;
                            let Dl = 0;
                            for (const Ll of rt)Wn.push(Qe.substring(Dl, Ll)), Dl = Ll;
                            return Dl < Co.length && Wn.push(Qe.substring(Dl, Co.length)), Wn;
                        }(Tc, wu(Tc, Zl, Ll, rt, Co, Kl));
                        const fu = [], yu = {
                            positionedLines: fu,
                            text: Tc.toString(),
                            top: Hl[1],
                            bottom: Hl[1],
                            left: Hl[0],
                            right: Hl[0],
                            writingMode: ql,
                            iconsInText: !1,
                            verticalizable: !1
                        };
                        return function(Qe, rt, Wn, Co, Dl, Ll, Rl, Ul, Gl, Zl, Hl, ql) {
                            let Ql = 0, Kl = 0, $l = 0, Tc = 0;
                            const tu = "right" === Ul ? 1 : "left" === Ul ? 0 : .5, lu = wm / ql;
                            let du = 0;
                            for (const Eu of Dl){
                                Eu.trim();
                                const Dl = Eu.getMaxScale(), Rl = {
                                    positionedGlyphs: [],
                                    lineOffset: 0
                                };
                                Qe.positionedLines[du] = Rl;
                                const Ul = Rl.positionedGlyphs;
                                let ql = 0;
                                if (!Eu.length()) {
                                    Kl += Ll, ++du;
                                    continue;
                                }
                                const fu = Su(Co, Eu, lu);
                                for(let Ll = 0; Ll < Eu.length(); Ll++){
                                    const Rl = Eu.getSection(Ll), $l = Eu.getSectionIndex(Ll), Tc = Eu.getCharCode(Ll), tu = Au(Gl, Hl, Tc);
                                    let du;
                                    if (Rl.imageName) {
                                        if (Qe.iconsInText = !0, Rl.scale = Rl.scale * lu, du = Mu(Rl, tu, Dl, fu, Co), !du) continue;
                                        ql = Math.max(ql, du.imageOffset);
                                    } else if (du = Iu(Rl, Tc, tu, fu, rt, Wn), !du) continue;
                                    const { rect: yu, metrics: Tu, baselineOffset: Lu } = du;
                                    Ul.push({
                                        glyph: Tc,
                                        imageName: Rl.imageName,
                                        x: Ql,
                                        y: Kl + Lu + Tm,
                                        vertical: tu,
                                        scale: Rl.scale,
                                        fontStack: Rl.fontStack,
                                        sectionIndex: $l,
                                        metrics: Tu,
                                        rect: yu
                                    }), tu ? (Qe.verticalizable = !0, Ql += (Rl.imageName ? Tu.advance : wm) * Rl.scale + Zl) : Ql += Tu.advance * Rl.scale + Zl;
                                }
                                0 !== Ul.length && ($l = Math.max(Ql - Zl, $l), zu(Ul, 0, Ul.length - 1, tu)), Ql = 0, Rl.lineOffset = Math.max(ql, (Dl - 1) * wm);
                                const yu = Ll * Dl + ql;
                                Kl += yu, Tc = Math.max(yu, Tc), ++du;
                            }
                            const { horizontalAlign: fu, verticalAlign: yu } = _u(Rl);
                            (function(Qe, rt, Wn, Co, Dl, Ll, Rl, Ul, Gl) {
                                const Zl = (rt - Wn) * Dl;
                                let Hl = 0;
                                Hl = Ll !== Rl ? -Ul * Co - Tm : -Co * Gl * Rl + .5 * Rl;
                                for (const ql of Qe)for (const Qe of ql.positionedGlyphs)Qe.x += Zl, Qe.y += Hl;
                            })(Qe.positionedLines, tu, fu, yu, $l, Tc, Ll, Kl, Dl.length), Qe.top += -yu * Kl, Qe.bottom = Qe.top + Kl, Qe.left += -fu * $l, Qe.right = Qe.left + $l;
                        }(yu, rt, Wn, Co, tu, Rl, Ul, Gl, ql, Zl, Ql, $l), !function(Qe) {
                            for (const rt of Qe)if (0 !== rt.positionedGlyphs.length) return !1;
                            return !0;
                        }(fu) && yu;
                    }
                    const Cm = {
                        9: !0,
                        10: !0,
                        11: !0,
                        12: !0,
                        13: !0,
                        32: !0
                    }, km = {
                        10: !0,
                        32: !0,
                        38: !0,
                        41: !0,
                        43: !0,
                        45: !0,
                        47: !0,
                        173: !0,
                        183: !0,
                        8203: !0,
                        8208: !0,
                        8211: !0,
                        8231: !0
                    }, Im = {
                        40: !0
                    };
                    function mu(Qe, rt, Wn, Co, Dl, Ll) {
                        if (rt.imageName) {
                            const Qe = Co[rt.imageName];
                            return Qe ? Qe.displaySize[0] * rt.scale * wm / Ll + Dl : 0;
                        }
                        {
                            const Co = Wn[rt.fontStack], Ll = Co && Co[Qe];
                            return Ll ? Ll.metrics.advance * rt.scale + Dl : 0;
                        }
                    }
                    function gu(Qe, rt, Wn, Co) {
                        const Dl = Math.pow(Qe - rt, 2);
                        return Co ? Qe < rt ? Dl / 2 : 2 * Dl : Dl + Math.abs(Wn) * Wn;
                    }
                    function xu(Qe, rt, Wn) {
                        let Co = 0;
                        return 10 === Qe && (Co -= 1e4), Wn && (Co += 150), 40 !== Qe && 65288 !== Qe || (Co += 50), 41 !== rt && 65289 !== rt || (Co += 50), Co;
                    }
                    function vu(Qe, rt, Wn, Co, Dl, Ll) {
                        let Rl = null, Ul = gu(rt, Wn, Dl, Ll);
                        for (const Gl of Co){
                            const Qe = gu(rt - Gl.x, Wn, Dl, Ll) + Gl.badness;
                            Qe <= Ul && (Rl = Gl, Ul = Qe);
                        }
                        return {
                            index: Qe,
                            x: rt,
                            priorBreak: Rl,
                            badness: Ul
                        };
                    }
                    function bu(Qe) {
                        return Qe ? bu(Qe.priorBreak).concat(Qe.index) : [];
                    }
                    function wu(Qe, rt, Wn, Co, Dl, Ll) {
                        if (!Qe) return [];
                        const Rl = [], Ul = function(Qe, rt, Wn, Co, Dl, Ll) {
                            let Rl = 0;
                            for(let Ul = 0; Ul < Qe.length(); Ul++){
                                const Wn = Qe.getSection(Ul);
                                Rl += mu(Qe.getCharCode(Ul), Wn, Co, Dl, rt, Ll);
                            }
                            return Rl / Math.max(1, Math.ceil(Rl / Wn));
                        }(Qe, rt, Wn, Co, Dl, Ll), Gl = Qe.text.indexOf("\u200B") >= 0;
                        let Zl = 0;
                        for(let ql = 0; ql < Qe.length(); ql++){
                            const Wn = Qe.getSection(ql), Ql = Qe.getCharCode(ql);
                            if (Cm[Ql] || (Zl += mu(Ql, Wn, Co, Dl, rt, Ll)), ql < Qe.length() - 1) {
                                const rt = !((Hl = Ql) < 11904) && (!!gi_CJK_Compatibility_Forms(Hl) || !!gi_CJK_Compatibility(Hl) || !!gi_CJK_Strokes(Hl) || !!gi_CJK_Symbols_and_Punctuation(Hl) || !!gi_Enclosed_CJK_Letters_and_Months(Hl) || !!gi_Halfwidth_and_Fullwidth_Forms(Hl) || !!gi_Ideographic_Description_Characters(Hl) || !!gi_Vertical_Forms(Hl) || Wd.test(String.fromCodePoint(Hl)));
                                (km[Ql] || rt || Wn.imageName || ql !== Qe.length() - 2 && Im[Qe.getCharCode(ql + 1)]) && Rl.push(vu(ql + 1, Zl, Ul, Rl, xu(Ql, Qe.getCharCode(ql + 1), rt && Gl), !1));
                            }
                        }
                        var Hl;
                        return bu(vu(Qe.length(), Zl, Ul, Rl, 0, !0));
                    }
                    function _u(Qe) {
                        let rt = .5, Wn = .5;
                        switch(Qe){
                            case "right":
                            case "top-right":
                            case "bottom-right":
                                rt = 1;
                                break;
                            case "left":
                            case "top-left":
                            case "bottom-left":
                                rt = 0;
                        }
                        switch(Qe){
                            case "bottom":
                            case "bottom-right":
                            case "bottom-left":
                                Wn = 1;
                                break;
                            case "top":
                            case "top-right":
                            case "top-left":
                                Wn = 0;
                        }
                        return {
                            horizontalAlign: rt,
                            verticalAlign: Wn
                        };
                    }
                    function Su(Qe, rt, Wn) {
                        const Co = rt.getMaxScale() * wm, { maxImageWidth: Dl, maxImageHeight: Ll } = rt.getMaxImageSize(Qe), Rl = Math.max(Co, Ll * Wn);
                        return {
                            verticalLineContentWidth: Math.max(Co, Dl * Wn),
                            horizontalLineContentHeight: Rl
                        };
                    }
                    function ku(Qe) {
                        switch(Qe){
                            case "top":
                                return 0;
                            case "center":
                                return .5;
                            default:
                                return 1;
                        }
                    }
                    function Au(Qe, rt, Wn) {
                        var Co;
                        return !(Qe === Sm.horizontal || !rt && !ki(Wn) || rt && (Cm[Wn] || (Co = Wn, /\p{sc=Arab}/u.test(String.fromCodePoint(Co)))));
                    }
                    function Iu(Qe, rt, Wn, Co, Dl, Ll) {
                        const Rl = Ll[Qe.fontStack], Ul = function(Qe, rt, Wn, Co) {
                            if (Qe && Qe.rect) return Qe;
                            const Dl = rt[Wn.fontStack], Ll = Dl && Dl[Co];
                            return Ll ? {
                                rect: null,
                                metrics: Ll.metrics
                            } : null;
                        }(Rl && Rl[rt], Dl, Qe, rt);
                        if (null === Ul) return null;
                        let Gl;
                        if (Wn) Gl = Co.verticalLineContentWidth - Qe.scale * wm;
                        else {
                            const rt = ku(Qe.verticalAlign);
                            Gl = (Co.horizontalLineContentHeight - Qe.scale * wm) * rt;
                        }
                        return {
                            rect: Ul.rect,
                            metrics: Ul.metrics,
                            baselineOffset: Gl
                        };
                    }
                    function Mu(Qe, rt, Wn, Co, Dl) {
                        const Ll = Dl[Qe.imageName];
                        if (!Ll) return null;
                        const Rl = Ll.paddedRect, Ul = Ll.displaySize, Gl = {
                            width: Ul[0],
                            height: Ul[1],
                            left: 1,
                            top: -3,
                            advance: rt ? Ul[1] : Ul[0]
                        };
                        let Zl;
                        if (rt) Zl = Co.verticalLineContentWidth - Ul[1] * Qe.scale;
                        else {
                            const rt = ku(Qe.verticalAlign);
                            Zl = (Co.horizontalLineContentHeight - Ul[1] * Qe.scale) * rt;
                        }
                        return {
                            rect: Rl,
                            metrics: Gl,
                            baselineOffset: Zl,
                            imageOffset: (rt ? Ul[0] : Ul[1]) * Qe.scale - wm * Wn
                        };
                    }
                    function zu(Qe, rt, Wn, Co) {
                        if (0 === Co) return;
                        const Dl = Qe[Wn], Ll = (Qe[Wn].x + Dl.metrics.advance * Dl.scale) * Co;
                        for(let Rl = rt; Rl <= Wn; Rl++)Qe[Rl].x -= Ll;
                    }
                    function Pu(Qe, rt, Wn) {
                        const { horizontalAlign: Co, verticalAlign: Dl } = _u(Wn), Ll = rt[0] - Qe.displaySize[0] * Co, Rl = rt[1] - Qe.displaySize[1] * Dl;
                        return {
                            image: Qe,
                            top: Rl,
                            bottom: Rl + Qe.displaySize[1],
                            left: Ll,
                            right: Ll + Qe.displaySize[0]
                        };
                    }
                    function Cu(Qe) {
                        var rt, Wn;
                        let Co = Qe.left, Dl = Qe.top, Ll = Qe.right - Co, Rl = Qe.bottom - Dl;
                        const Ul = null !== (rt = Qe.image.textFitWidth) && void 0 !== rt ? rt : "stretchOrShrink", Gl = null !== (Wn = Qe.image.textFitHeight) && void 0 !== Wn ? Wn : "stretchOrShrink", Zl = (Qe.image.content[2] - Qe.image.content[0]) / (Qe.image.content[3] - Qe.image.content[1]);
                        if ("proportional" === Gl) {
                            if ("stretchOnly" === Ul && Ll / Rl < Zl || "proportional" === Ul) {
                                const Qe = Math.ceil(Rl * Zl);
                                Co *= Qe / Ll, Ll = Qe;
                            }
                        } else if ("proportional" === Ul && "stretchOnly" === Gl && 0 !== Zl && Ll / Rl > Zl) {
                            const Qe = Math.ceil(Ll / Zl);
                            Dl *= Qe / Rl, Rl = Qe;
                        }
                        return {
                            x1: Co,
                            y1: Dl,
                            x2: Co + Ll,
                            y2: Dl + Rl
                        };
                    }
                    function Bu(Qe, rt, Wn, Co, Dl, Ll) {
                        const Rl = Qe.image;
                        let Ul;
                        if (Rl.content) {
                            const Qe = Rl.content, rt = Rl.pixelRatio || 1;
                            Ul = [
                                Qe[0] / rt,
                                Qe[1] / rt,
                                Rl.displaySize[0] - Qe[2] / rt,
                                Rl.displaySize[1] - Qe[3] / rt
                            ];
                        }
                        const Gl = rt.left * Ll, Zl = rt.right * Ll;
                        let Hl, ql, Ql, Kl;
                        "width" === Wn || "both" === Wn ? (Kl = Dl[0] + Gl - Co[3], ql = Dl[0] + Zl + Co[1]) : (Kl = Dl[0] + (Gl + Zl - Rl.displaySize[0]) / 2, ql = Kl + Rl.displaySize[0]);
                        const $l = rt.top * Ll, Tc = rt.bottom * Ll;
                        return "height" === Wn || "both" === Wn ? (Hl = Dl[1] + $l - Co[0], Ql = Dl[1] + Tc + Co[2]) : (Hl = Dl[1] + ($l + Tc - Rl.displaySize[1]) / 2, Ql = Hl + Rl.displaySize[1]), {
                            image: Rl,
                            top: Hl,
                            right: ql,
                            bottom: Ql,
                            left: Kl,
                            collisionPadding: Ul
                        };
                    }
                    const Dm = 128, Lm = 32640;
                    function Fu(Qe, rt) {
                        const { expression: Wn } = rt;
                        if ("constant" === Wn.kind) return {
                            kind: "constant",
                            layoutSize: Wn.evaluate(new Bi(Qe + 1))
                        };
                        if ("source" === Wn.kind) return {
                            kind: "source"
                        };
                        {
                            const { zoomStops: rt, interpolationType: Co } = Wn;
                            let Dl = 0;
                            for(; Dl < rt.length && rt[Dl] <= Qe;)Dl++;
                            Dl = Math.max(0, Dl - 1);
                            let Ll = Dl;
                            for(; Ll < rt.length && rt[Ll] < Qe + 1;)Ll++;
                            Ll = Math.min(rt.length - 1, Ll);
                            const Rl = rt[Dl], Ul = rt[Ll];
                            return "composite" === Wn.kind ? {
                                kind: "composite",
                                minZoom: Rl,
                                maxZoom: Ul,
                                interpolationType: Co
                            } : {
                                kind: "camera",
                                minZoom: Rl,
                                maxZoom: Ul,
                                minSize: Wn.evaluate(new Bi(Rl)),
                                maxSize: Wn.evaluate(new Bi(Ul)),
                                interpolationType: Co
                            };
                        }
                    }
                    function Du(Qe, rt, Wn) {
                        let Co = "never";
                        const Dl = Qe.get(rt);
                        return Dl ? Co = Dl : Qe.get(Wn) && (Co = "always"), Co;
                    }
                    const Pm = $p.VectorTileFeature.types, zm = [
                        {
                            name: "a_fade_opacity",
                            components: 1,
                            type: "Uint8",
                            offset: 0
                        }
                    ];
                    function Ou(Qe, rt, Wn, Co, Dl, Ll, Rl, Ul, Gl, Zl, Hl, ql, Ql) {
                        const Kl = Ul ? Math.min(Lm, Math.round(Ul[0])) : 0, $l = Ul ? Math.min(Lm, Math.round(Ul[1])) : 0;
                        Qe.emplaceBack(rt, Wn, Math.round(32 * Co), Math.round(32 * Dl), Ll, Rl, (Kl << 1) + (Gl ? 1 : 0), $l, 16 * Zl, 16 * Hl, 256 * ql, 256 * Ql);
                    }
                    function Ru(Qe, rt, Wn) {
                        Qe.emplaceBack(rt.x, rt.y, Wn), Qe.emplaceBack(rt.x, rt.y, Wn), Qe.emplaceBack(rt.x, rt.y, Wn), Qe.emplaceBack(rt.x, rt.y, Wn);
                    }
                    function Nu(Qe) {
                        for (const rt of Qe.sections)if (Pi(rt.text)) return !0;
                        return !1;
                    }
                    class ju {
                        constructor(Qe){
                            this.layoutVertexArray = new Ns, this.indexArray = new Zs, this.programConfigurations = Qe, this.segments = new Js, this.dynamicLayoutVertexArray = new js, this.opacityVertexArray = new qs, this.hasVisibleVertices = !1, this.placedSymbolArray = new As;
                        }
                        isEmpty() {
                            return 0 === this.layoutVertexArray.length && 0 === this.indexArray.length && 0 === this.dynamicLayoutVertexArray.length && 0 === this.opacityVertexArray.length;
                        }
                        upload(Qe, rt, Wn, Co) {
                            this.isEmpty() || (Wn && (this.layoutVertexBuffer = Qe.createVertexBuffer(this.layoutVertexArray, fm.members), this.indexBuffer = Qe.createIndexBuffer(this.indexArray, rt), this.dynamicLayoutVertexBuffer = Qe.createVertexBuffer(this.dynamicLayoutVertexArray, gm.members, !0), this.opacityVertexBuffer = Qe.createVertexBuffer(this.opacityVertexArray, zm, !0), this.opacityVertexBuffer.itemSize = 1), (Wn || Co) && this.programConfigurations.upload(Qe));
                        }
                        destroy() {
                            this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.dynamicLayoutVertexBuffer.destroy(), this.opacityVertexBuffer.destroy());
                        }
                    }
                    Qn("SymbolBuffers", ju);
                    class qu {
                        constructor(Qe, rt, Wn){
                            this.layoutVertexArray = new Qe, this.layoutAttributes = rt, this.indexArray = new Wn, this.segments = new Js, this.collisionVertexArray = new Gs;
                        }
                        upload(Qe) {
                            this.layoutVertexBuffer = Qe.createVertexBuffer(this.layoutVertexArray, this.layoutAttributes), this.indexBuffer = Qe.createIndexBuffer(this.indexArray), this.collisionVertexBuffer = Qe.createVertexBuffer(this.collisionVertexArray, Am.members, !0);
                        }
                        destroy() {
                            this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.segments.destroy(), this.collisionVertexBuffer.destroy());
                        }
                    }
                    Qn("CollisionBuffers", qu);
                    class Uu {
                        constructor(Qe){
                            this.collisionBoxArray = Qe.collisionBoxArray, this.zoom = Qe.zoom, this.overscaling = Qe.overscaling, this.layers = Qe.layers, this.layerIds = this.layers.map((Qe)=>Qe.id), this.index = Qe.index, this.pixelRatio = Qe.pixelRatio, this.sourceLayerIndex = Qe.sourceLayerIndex, this.hasPattern = !1, this.hasRTLText = !1, this.sortKeyRanges = [], this.collisionCircleArray = [];
                            const rt = this.layers[0]._unevaluatedLayout._values;
                            this.textSizeData = Fu(this.zoom, rt["text-size"]), this.iconSizeData = Fu(this.zoom, rt["icon-size"]);
                            const Wn = this.layers[0].layout, Co = Wn.get("symbol-sort-key"), Dl = Wn.get("symbol-z-order");
                            this.canOverlap = "never" !== Du(Wn, "text-overlap", "text-allow-overlap") || "never" !== Du(Wn, "icon-overlap", "icon-allow-overlap") || Wn.get("text-ignore-placement") || Wn.get("icon-ignore-placement"), this.sortFeaturesByKey = "viewport-y" !== Dl && !Co.isConstant(), this.sortFeaturesByY = ("viewport-y" === Dl || "auto" === Dl && !this.sortFeaturesByKey) && this.canOverlap, "point" === Wn.get("symbol-placement") && (this.writingModes = Wn.get("text-writing-mode").map((Qe)=>Sm[Qe])), this.stateDependentLayerIds = this.layers.filter((Qe)=>Qe.isStateDependent()).map((Qe)=>Qe.id), this.sourceID = Qe.sourceID;
                        }
                        createArrays() {
                            this.text = new ju(new So(this.layers, this.zoom, (Qe)=>/^text/.test(Qe))), this.icon = new ju(new So(this.layers, this.zoom, (Qe)=>/^icon/.test(Qe))), this.glyphOffsetArray = new zs, this.lineVertexArray = new Ps, this.symbolInstances = new Ms, this.textAnchorOffsets = new Bs;
                        }
                        calculateGlyphDependencies(Qe, rt, Wn, Co, Dl) {
                            for(let Ll = 0; Ll < Qe.length; Ll++)if (rt[Qe.charCodeAt(Ll)] = !0, (Wn || Co) && Dl) {
                                const Wn = vm[Qe.charAt(Ll)];
                                Wn && (rt[Wn.charCodeAt(0)] = !0);
                            }
                        }
                        populate(Qe, rt, Wn) {
                            const Co = this.layers[0], Dl = Co.layout, Ll = Dl.get("text-font"), Rl = Dl.get("text-field"), Ul = Dl.get("icon-image"), Gl = ("constant" !== Rl.value.kind || Rl.value.value instanceof Mt && !Rl.value.value.isEmpty() || Rl.value.value.toString().length > 0) && ("constant" !== Ll.value.kind || Ll.value.value.length > 0), Zl = "constant" !== Ul.value.kind || !!Ul.value.value || Object.keys(Ul.parameters).length > 0, Hl = Dl.get("symbol-sort-key");
                            if (this.features = [], !Gl && !Zl) return;
                            const ql = rt.iconDependencies, Ql = rt.glyphDependencies, Kl = rt.availableImages, $l = new Bi(this.zoom);
                            for (const { feature: Tc, id: tu, index: lu, sourceLayerIndex: du } of Qe){
                                const Qe = Co._featureFilter.needGeometry, rt = Po(Tc, Qe);
                                if (!Co._featureFilter.filter($l, rt, Wn)) continue;
                                let Rl, Ul;
                                if (Qe || (rt.geometry = zo(Tc)), Gl) {
                                    const Qe = Co.getValueAndResolveTokens("text-field", rt, Wn, Kl), Dl = Mt.factory(Qe), Ll = this.hasRTLText = this.hasRTLText || Nu(Dl);
                                    (!Ll || "unavailable" === Yd.getRTLTextPluginStatus() || Ll && Yd.isParsed()) && (Rl = Xl(Dl, Co, rt));
                                }
                                if (Zl) {
                                    const Qe = Co.getValueAndResolveTokens("icon-image", rt, Wn, Kl);
                                    Ul = Qe instanceof Tt ? Qe : Tt.fromString(Qe);
                                }
                                if (!Rl && !Ul) continue;
                                const fu = this.sortFeaturesByKey ? Hl.evaluate(rt, {}, Wn) : void 0;
                                if (this.features.push({
                                    id: tu,
                                    text: Rl,
                                    icon: Ul,
                                    index: lu,
                                    sourceLayerIndex: du,
                                    geometry: rt.geometry,
                                    properties: Tc.properties,
                                    type: Pm[Tc.type],
                                    sortKey: fu
                                }), Ul && (ql[Ul.name] = !0), Rl) {
                                    const Qe = Ll.evaluate(rt, {}, Wn).join(","), Co = "viewport" !== Dl.get("text-rotation-alignment") && "point" !== Dl.get("symbol-placement");
                                    this.allowVerticalPlacement = this.writingModes && this.writingModes.indexOf(Sm.vertical) >= 0;
                                    for (const rt of Rl.sections)if (rt.image) ql[rt.image.name] = !0;
                                    else {
                                        const Wn = xi(Rl.toString()), Dl = rt.fontStack || Qe, Ll = Ql[Dl] = Ql[Dl] || {};
                                        this.calculateGlyphDependencies(rt.text, Ll, Co, this.allowVerticalPlacement, Wn);
                                    }
                                }
                            }
                            "line" === Dl.get("symbol-placement") && (this.features = function(Qe) {
                                const rt = {}, Wn = {}, Co = [];
                                let Dl = 0;
                                function s(rt) {
                                    Co.push(Qe[rt]), Dl++;
                                }
                                function o(Qe, rt, Dl) {
                                    const Ll = Wn[Qe];
                                    return delete Wn[Qe], Wn[rt] = Ll, Co[Ll].geometry[0].pop(), Co[Ll].geometry[0] = Co[Ll].geometry[0].concat(Dl[0]), Ll;
                                }
                                function a(Qe, Wn, Dl) {
                                    const Ll = rt[Wn];
                                    return delete rt[Wn], rt[Qe] = Ll, Co[Ll].geometry[0].shift(), Co[Ll].geometry[0] = Dl[0].concat(Co[Ll].geometry[0]), Ll;
                                }
                                function l(Qe, rt, Wn) {
                                    const Co = Wn ? rt[0][rt[0].length - 1] : rt[0][0];
                                    return `${Qe}:${Co.x}:${Co.y}`;
                                }
                                for(let Ll = 0; Ll < Qe.length; Ll++){
                                    const Rl = Qe[Ll], Ul = Rl.geometry, Gl = Rl.text ? Rl.text.toString() : null;
                                    if (!Gl) {
                                        s(Ll);
                                        continue;
                                    }
                                    const Zl = l(Gl, Ul), Hl = l(Gl, Ul, !0);
                                    if (Zl in Wn && Hl in rt && Wn[Zl] !== rt[Hl]) {
                                        const Qe = a(Zl, Hl, Ul), Dl = o(Zl, Hl, Co[Qe].geometry);
                                        delete rt[Zl], delete Wn[Hl], Wn[l(Gl, Co[Dl].geometry, !0)] = Dl, Co[Qe].geometry = null;
                                    } else Zl in Wn ? o(Zl, Hl, Ul) : Hl in rt ? a(Zl, Hl, Ul) : (s(Ll), rt[Zl] = Dl - 1, Wn[Hl] = Dl - 1);
                                }
                                return Co.filter((Qe)=>Qe.geometry);
                            }(this.features)), this.sortFeaturesByKey && this.features.sort((Qe, rt)=>Qe.sortKey - rt.sortKey);
                        }
                        update(Qe, rt, Wn) {
                            this.stateDependentLayers.length && (this.text.programConfigurations.updatePaintArrays(Qe, rt, this.layers, Wn), this.icon.programConfigurations.updatePaintArrays(Qe, rt, this.layers, Wn));
                        }
                        isEmpty() {
                            return 0 === this.symbolInstances.length && !this.hasRTLText;
                        }
                        uploadPending() {
                            return !this.uploaded || this.text.programConfigurations.needsUpload || this.icon.programConfigurations.needsUpload;
                        }
                        upload(Qe) {
                            !this.uploaded && this.hasDebugData() && (this.textCollisionBox.upload(Qe), this.iconCollisionBox.upload(Qe)), this.text.upload(Qe, this.sortFeaturesByY, !this.uploaded, this.text.programConfigurations.needsUpload), this.icon.upload(Qe, this.sortFeaturesByY, !this.uploaded, this.icon.programConfigurations.needsUpload), this.uploaded = !0;
                        }
                        destroyDebugData() {
                            this.textCollisionBox.destroy(), this.iconCollisionBox.destroy();
                        }
                        destroy() {
                            this.text.destroy(), this.icon.destroy(), this.hasDebugData() && this.destroyDebugData();
                        }
                        addToLineVertexArray(Qe, rt) {
                            const Wn = this.lineVertexArray.length;
                            if (void 0 !== Qe.segment) {
                                let Wn = Qe.dist(rt[Qe.segment + 1]), Co = Qe.dist(rt[Qe.segment]);
                                const Dl = {};
                                for(let Ll = Qe.segment + 1; Ll < rt.length; Ll++)Dl[Ll] = {
                                    x: rt[Ll].x,
                                    y: rt[Ll].y,
                                    tileUnitDistanceFromAnchor: Wn
                                }, Ll < rt.length - 1 && (Wn += rt[Ll + 1].dist(rt[Ll]));
                                for(let Ll = Qe.segment || 0; Ll >= 0; Ll--)Dl[Ll] = {
                                    x: rt[Ll].x,
                                    y: rt[Ll].y,
                                    tileUnitDistanceFromAnchor: Co
                                }, Ll > 0 && (Co += rt[Ll - 1].dist(rt[Ll]));
                                for(let Qe = 0; Qe < rt.length; Qe++){
                                    const rt = Dl[Qe];
                                    this.lineVertexArray.emplaceBack(rt.x, rt.y, rt.tileUnitDistanceFromAnchor);
                                }
                            }
                            return {
                                lineStartIndex: Wn,
                                lineLength: this.lineVertexArray.length - Wn
                            };
                        }
                        addSymbols(Qe, rt, Wn, Co, Dl, Ll, Rl, Ul, Gl, Zl, Hl, ql) {
                            const Ql = Qe.indexArray, Kl = Qe.layoutVertexArray, $l = Qe.segments.prepareSegment(4 * rt.length, Kl, Ql, this.canOverlap ? Ll.sortKey : void 0), Tc = this.glyphOffsetArray.length, tu = $l.vertexLength, lu = this.allowVerticalPlacement && Rl === Sm.vertical ? Math.PI / 2 : 0, du = Ll.text && Ll.text.sections;
                            for(let fu = 0; fu < rt.length; fu++){
                                const { tl: Co, tr: Dl, bl: Rl, br: Gl, tex: Zl, pixelOffsetTL: Hl, pixelOffsetBR: Tc, minFontScaleX: tu, minFontScaleY: yu, glyphOffset: Eu, isSDF: Tu, sectionIndex: Lu } = rt[fu], Zu = $l.vertexLength, Xu = Eu[1];
                                Ou(Kl, Ul.x, Ul.y, Co.x, Xu + Co.y, Zl.x, Zl.y, Wn, Tu, Hl.x, Hl.y, tu, yu), Ou(Kl, Ul.x, Ul.y, Dl.x, Xu + Dl.y, Zl.x + Zl.w, Zl.y, Wn, Tu, Tc.x, Hl.y, tu, yu), Ou(Kl, Ul.x, Ul.y, Rl.x, Xu + Rl.y, Zl.x, Zl.y + Zl.h, Wn, Tu, Hl.x, Tc.y, tu, yu), Ou(Kl, Ul.x, Ul.y, Gl.x, Xu + Gl.y, Zl.x + Zl.w, Zl.y + Zl.h, Wn, Tu, Tc.x, Tc.y, tu, yu), Ru(Qe.dynamicLayoutVertexArray, Ul, lu), Ql.emplaceBack(Zu, Zu + 2, Zu + 1), Ql.emplaceBack(Zu + 1, Zu + 2, Zu + 3), $l.vertexLength += 4, $l.primitiveLength += 2, this.glyphOffsetArray.emplaceBack(Eu[0]), fu !== rt.length - 1 && Lu === rt[fu + 1].sectionIndex || Qe.programConfigurations.populatePaintArrays(Kl.length, Ll, Ll.index, {}, ql, du && du[Lu]);
                            }
                            Qe.placedSymbolArray.emplaceBack(Ul.x, Ul.y, Tc, this.glyphOffsetArray.length - Tc, tu, Gl, Zl, Ul.segment, Wn ? Wn[0] : 0, Wn ? Wn[1] : 0, Co[0], Co[1], Rl, 0, !1, 0, Hl);
                        }
                        _addCollisionDebugVertex(Qe, rt, Wn, Co, Dl, Ll) {
                            return rt.emplaceBack(0, 0), Qe.emplaceBack(Wn.x, Wn.y, Co, Dl, Math.round(Ll.x), Math.round(Ll.y));
                        }
                        addCollisionDebugVertices(Qe, rt, Wn, Co, Ll, Rl, Ul) {
                            const Gl = Ll.segments.prepareSegment(4, Ll.layoutVertexArray, Ll.indexArray), Zl = Gl.vertexLength, Hl = Ll.layoutVertexArray, ql = Ll.collisionVertexArray, Ql = Ul.anchorX, Kl = Ul.anchorY;
                            this._addCollisionDebugVertex(Hl, ql, Rl, Ql, Kl, new Dl(Qe, rt)), this._addCollisionDebugVertex(Hl, ql, Rl, Ql, Kl, new Dl(Wn, rt)), this._addCollisionDebugVertex(Hl, ql, Rl, Ql, Kl, new Dl(Wn, Co)), this._addCollisionDebugVertex(Hl, ql, Rl, Ql, Kl, new Dl(Qe, Co)), Gl.vertexLength += 4;
                            const $l = Ll.indexArray;
                            $l.emplaceBack(Zl, Zl + 1), $l.emplaceBack(Zl + 1, Zl + 2), $l.emplaceBack(Zl + 2, Zl + 3), $l.emplaceBack(Zl + 3, Zl), Gl.primitiveLength += 4;
                        }
                        addDebugCollisionBoxes(Qe, rt, Wn, Co) {
                            for(let Dl = Qe; Dl < rt; Dl++){
                                const Qe = this.collisionBoxArray.get(Dl);
                                this.addCollisionDebugVertices(Qe.x1, Qe.y1, Qe.x2, Qe.y2, Co ? this.textCollisionBox : this.iconCollisionBox, Qe.anchorPoint, Wn);
                            }
                        }
                        generateCollisionDebugBuffers() {
                            this.hasDebugData() && this.destroyDebugData(), this.textCollisionBox = new qu(Us, ym.members, Xs), this.iconCollisionBox = new qu(Us, ym.members, Xs);
                            for(let Qe = 0; Qe < this.symbolInstances.length; Qe++){
                                const rt = this.symbolInstances.get(Qe);
                                this.addDebugCollisionBoxes(rt.textBoxStartIndex, rt.textBoxEndIndex, rt, !0), this.addDebugCollisionBoxes(rt.verticalTextBoxStartIndex, rt.verticalTextBoxEndIndex, rt, !0), this.addDebugCollisionBoxes(rt.iconBoxStartIndex, rt.iconBoxEndIndex, rt, !1), this.addDebugCollisionBoxes(rt.verticalIconBoxStartIndex, rt.verticalIconBoxEndIndex, rt, !1);
                            }
                        }
                        _deserializeCollisionBoxesForSymbol(Qe, rt, Wn, Co, Dl, Ll, Rl, Ul, Gl) {
                            const Zl = {};
                            for(let Hl = rt; Hl < Wn; Hl++){
                                const rt = Qe.get(Hl);
                                Zl.textBox = {
                                    x1: rt.x1,
                                    y1: rt.y1,
                                    x2: rt.x2,
                                    y2: rt.y2,
                                    anchorPointX: rt.anchorPointX,
                                    anchorPointY: rt.anchorPointY
                                }, Zl.textFeatureIndex = rt.featureIndex;
                                break;
                            }
                            for(let Hl = Co; Hl < Dl; Hl++){
                                const rt = Qe.get(Hl);
                                Zl.verticalTextBox = {
                                    x1: rt.x1,
                                    y1: rt.y1,
                                    x2: rt.x2,
                                    y2: rt.y2,
                                    anchorPointX: rt.anchorPointX,
                                    anchorPointY: rt.anchorPointY
                                }, Zl.verticalTextFeatureIndex = rt.featureIndex;
                                break;
                            }
                            for(let Hl = Ll; Hl < Rl; Hl++){
                                const rt = Qe.get(Hl);
                                Zl.iconBox = {
                                    x1: rt.x1,
                                    y1: rt.y1,
                                    x2: rt.x2,
                                    y2: rt.y2,
                                    anchorPointX: rt.anchorPointX,
                                    anchorPointY: rt.anchorPointY
                                }, Zl.iconFeatureIndex = rt.featureIndex;
                                break;
                            }
                            for(let Hl = Ul; Hl < Gl; Hl++){
                                const rt = Qe.get(Hl);
                                Zl.verticalIconBox = {
                                    x1: rt.x1,
                                    y1: rt.y1,
                                    x2: rt.x2,
                                    y2: rt.y2,
                                    anchorPointX: rt.anchorPointX,
                                    anchorPointY: rt.anchorPointY
                                }, Zl.verticalIconFeatureIndex = rt.featureIndex;
                                break;
                            }
                            return Zl;
                        }
                        deserializeCollisionBoxes(Qe) {
                            this.collisionArrays = [];
                            for(let rt = 0; rt < this.symbolInstances.length; rt++){
                                const Wn = this.symbolInstances.get(rt);
                                this.collisionArrays.push(this._deserializeCollisionBoxesForSymbol(Qe, Wn.textBoxStartIndex, Wn.textBoxEndIndex, Wn.verticalTextBoxStartIndex, Wn.verticalTextBoxEndIndex, Wn.iconBoxStartIndex, Wn.iconBoxEndIndex, Wn.verticalIconBoxStartIndex, Wn.verticalIconBoxEndIndex));
                            }
                        }
                        hasTextData() {
                            return this.text.segments.get().length > 0;
                        }
                        hasIconData() {
                            return this.icon.segments.get().length > 0;
                        }
                        hasDebugData() {
                            return this.textCollisionBox && this.iconCollisionBox;
                        }
                        hasTextCollisionBoxData() {
                            return this.hasDebugData() && this.textCollisionBox.segments.get().length > 0;
                        }
                        hasIconCollisionBoxData() {
                            return this.hasDebugData() && this.iconCollisionBox.segments.get().length > 0;
                        }
                        addIndicesForPlacedSymbol(Qe, rt) {
                            const Wn = Qe.placedSymbolArray.get(rt), Co = Wn.vertexStartIndex + 4 * Wn.numGlyphs;
                            for(let Dl = Wn.vertexStartIndex; Dl < Co; Dl += 4)Qe.indexArray.emplaceBack(Dl, Dl + 2, Dl + 1), Qe.indexArray.emplaceBack(Dl + 1, Dl + 2, Dl + 3);
                        }
                        getSortedSymbolIndexes(Qe) {
                            if (this.sortedAngle === Qe && void 0 !== this.symbolInstanceIndexes) return this.symbolInstanceIndexes;
                            const rt = Math.sin(Qe), Wn = Math.cos(Qe), Co = [], Dl = [], Ll = [];
                            for(let Rl = 0; Rl < this.symbolInstances.length; ++Rl){
                                Ll.push(Rl);
                                const Qe = this.symbolInstances.get(Rl);
                                Co.push(0 | Math.round(rt * Qe.anchorX + Wn * Qe.anchorY)), Dl.push(Qe.featureIndex);
                            }
                            return Ll.sort((Qe, rt)=>Co[Qe] - Co[rt] || Dl[rt] - Dl[Qe]), Ll;
                        }
                        addToSortKeyRanges(Qe, rt) {
                            const Wn = this.sortKeyRanges[this.sortKeyRanges.length - 1];
                            Wn && Wn.sortKey === rt ? Wn.symbolInstanceEnd = Qe + 1 : this.sortKeyRanges.push({
                                sortKey: rt,
                                symbolInstanceStart: Qe,
                                symbolInstanceEnd: Qe + 1
                            });
                        }
                        sortFeatures(Qe) {
                            if (this.sortFeaturesByY && this.sortedAngle !== Qe && !(this.text.segments.get().length > 1 || this.icon.segments.get().length > 1)) {
                                this.symbolInstanceIndexes = this.getSortedSymbolIndexes(Qe), this.sortedAngle = Qe, this.text.indexArray.clear(), this.icon.indexArray.clear(), this.featureSortOrder = [];
                                for (const Qe of this.symbolInstanceIndexes){
                                    const rt = this.symbolInstances.get(Qe);
                                    this.featureSortOrder.push(rt.featureIndex), [
                                        rt.rightJustifiedTextSymbolIndex,
                                        rt.centerJustifiedTextSymbolIndex,
                                        rt.leftJustifiedTextSymbolIndex
                                    ].forEach((Qe, rt, Wn)=>{
                                        Qe >= 0 && Wn.indexOf(Qe) === rt && this.addIndicesForPlacedSymbol(this.text, Qe);
                                    }), rt.verticalPlacedTextSymbolIndex >= 0 && this.addIndicesForPlacedSymbol(this.text, rt.verticalPlacedTextSymbolIndex), rt.placedIconSymbolIndex >= 0 && this.addIndicesForPlacedSymbol(this.icon, rt.placedIconSymbolIndex), rt.verticalPlacedIconSymbolIndex >= 0 && this.addIndicesForPlacedSymbol(this.icon, rt.verticalPlacedIconSymbolIndex);
                                }
                                this.text.indexBuffer && this.text.indexBuffer.updateData(this.text.indexArray), this.icon.indexBuffer && this.icon.indexBuffer.updateData(this.icon.indexArray);
                            }
                        }
                    }
                    let Nm, Rm;
                    Qn("SymbolBucket", Uu, {
                        omit: [
                            "layers",
                            "collisionBoxArray",
                            "features",
                            "compareText"
                        ]
                    }), Uu.MAX_GLYPHS = 65535, Uu.addDynamicAttributes = Ru;
                    var Bm = {
                        get paint () {
                            return Rm = Rm || new Gi({
                                "icon-opacity": new Ni(Tc.paint_symbol["icon-opacity"]),
                                "icon-color": new Ni(Tc.paint_symbol["icon-color"]),
                                "icon-halo-color": new Ni(Tc.paint_symbol["icon-halo-color"]),
                                "icon-halo-width": new Ni(Tc.paint_symbol["icon-halo-width"]),
                                "icon-halo-blur": new Ni(Tc.paint_symbol["icon-halo-blur"]),
                                "icon-translate": new Ri(Tc.paint_symbol["icon-translate"]),
                                "icon-translate-anchor": new Ri(Tc.paint_symbol["icon-translate-anchor"]),
                                "text-opacity": new Ni(Tc.paint_symbol["text-opacity"]),
                                "text-color": new Ni(Tc.paint_symbol["text-color"], {
                                    runtimeType: Eu,
                                    getOverride: (Qe)=>Qe.textColor,
                                    hasOverride: (Qe)=>!!Qe.textColor
                                }),
                                "text-halo-color": new Ni(Tc.paint_symbol["text-halo-color"]),
                                "text-halo-width": new Ni(Tc.paint_symbol["text-halo-width"]),
                                "text-halo-blur": new Ni(Tc.paint_symbol["text-halo-blur"]),
                                "text-translate": new Ri(Tc.paint_symbol["text-translate"]),
                                "text-translate-anchor": new Ri(Tc.paint_symbol["text-translate-anchor"])
                            });
                        },
                        get layout () {
                            return Nm = Nm || new Gi({
                                "symbol-placement": new Ri(Tc.layout_symbol["symbol-placement"]),
                                "symbol-spacing": new Ri(Tc.layout_symbol["symbol-spacing"]),
                                "symbol-avoid-edges": new Ri(Tc.layout_symbol["symbol-avoid-edges"]),
                                "symbol-sort-key": new Ni(Tc.layout_symbol["symbol-sort-key"]),
                                "symbol-z-order": new Ri(Tc.layout_symbol["symbol-z-order"]),
                                "icon-allow-overlap": new Ri(Tc.layout_symbol["icon-allow-overlap"]),
                                "icon-overlap": new Ri(Tc.layout_symbol["icon-overlap"]),
                                "icon-ignore-placement": new Ri(Tc.layout_symbol["icon-ignore-placement"]),
                                "icon-optional": new Ri(Tc.layout_symbol["icon-optional"]),
                                "icon-rotation-alignment": new Ri(Tc.layout_symbol["icon-rotation-alignment"]),
                                "icon-size": new Ni(Tc.layout_symbol["icon-size"]),
                                "icon-text-fit": new Ri(Tc.layout_symbol["icon-text-fit"]),
                                "icon-text-fit-padding": new Ri(Tc.layout_symbol["icon-text-fit-padding"]),
                                "icon-image": new Ni(Tc.layout_symbol["icon-image"]),
                                "icon-rotate": new Ni(Tc.layout_symbol["icon-rotate"]),
                                "icon-padding": new Ni(Tc.layout_symbol["icon-padding"]),
                                "icon-keep-upright": new Ri(Tc.layout_symbol["icon-keep-upright"]),
                                "icon-offset": new Ni(Tc.layout_symbol["icon-offset"]),
                                "icon-anchor": new Ni(Tc.layout_symbol["icon-anchor"]),
                                "icon-pitch-alignment": new Ri(Tc.layout_symbol["icon-pitch-alignment"]),
                                "text-pitch-alignment": new Ri(Tc.layout_symbol["text-pitch-alignment"]),
                                "text-rotation-alignment": new Ri(Tc.layout_symbol["text-rotation-alignment"]),
                                "text-field": new Ni(Tc.layout_symbol["text-field"]),
                                "text-font": new Ni(Tc.layout_symbol["text-font"]),
                                "text-size": new Ni(Tc.layout_symbol["text-size"]),
                                "text-max-width": new Ni(Tc.layout_symbol["text-max-width"]),
                                "text-line-height": new Ri(Tc.layout_symbol["text-line-height"]),
                                "text-letter-spacing": new Ni(Tc.layout_symbol["text-letter-spacing"]),
                                "text-justify": new Ni(Tc.layout_symbol["text-justify"]),
                                "text-radial-offset": new Ni(Tc.layout_symbol["text-radial-offset"]),
                                "text-variable-anchor": new Ri(Tc.layout_symbol["text-variable-anchor"]),
                                "text-variable-anchor-offset": new Ni(Tc.layout_symbol["text-variable-anchor-offset"]),
                                "text-anchor": new Ni(Tc.layout_symbol["text-anchor"]),
                                "text-max-angle": new Ri(Tc.layout_symbol["text-max-angle"]),
                                "text-writing-mode": new Ri(Tc.layout_symbol["text-writing-mode"]),
                                "text-rotate": new Ni(Tc.layout_symbol["text-rotate"]),
                                "text-padding": new Ri(Tc.layout_symbol["text-padding"]),
                                "text-keep-upright": new Ri(Tc.layout_symbol["text-keep-upright"]),
                                "text-transform": new Ni(Tc.layout_symbol["text-transform"]),
                                "text-offset": new Ni(Tc.layout_symbol["text-offset"]),
                                "text-allow-overlap": new Ri(Tc.layout_symbol["text-allow-overlap"]),
                                "text-overlap": new Ri(Tc.layout_symbol["text-overlap"]),
                                "text-ignore-placement": new Ri(Tc.layout_symbol["text-ignore-placement"]),
                                "text-optional": new Ri(Tc.layout_symbol["text-optional"])
                            });
                        }
                    };
                    class Hu {
                        constructor(Qe){
                            if (void 0 === Qe.property.overrides) throw new Error("overrides must be provided to instantiate FormatSectionOverride class");
                            this.type = Qe.property.overrides ? Qe.property.overrides.runtimeType : lu, this.defaultValue = Qe;
                        }
                        evaluate(Qe) {
                            if (Qe.formattedSection) {
                                const rt = this.defaultValue.property.overrides;
                                if (rt && rt.hasOverride(Qe.formattedSection)) return rt.getOverride(Qe.formattedSection);
                            }
                            return Qe.feature && Qe.featureState ? this.defaultValue.evaluate(Qe.feature, Qe.featureState) : this.defaultValue.property.specification.default;
                        }
                        eachChild(Qe) {
                            this.defaultValue.isConstant() || Qe(this.defaultValue.value._styleExpression.expression);
                        }
                        outputDefined() {
                            return !1;
                        }
                        serialize() {
                            return null;
                        }
                    }
                    Qn("FormatSectionOverride", Hu, {
                        omit: [
                            "defaultValue"
                        ]
                    });
                    class Yu extends Xi {
                        constructor(Qe){
                            super(Qe, Bm);
                        }
                        recalculate(Qe, rt) {
                            if (super.recalculate(Qe, rt), "auto" === this.layout.get("icon-rotation-alignment") && (this.layout._values["icon-rotation-alignment"] = "point" !== this.layout.get("symbol-placement") ? "map" : "viewport"), "auto" === this.layout.get("text-rotation-alignment") && (this.layout._values["text-rotation-alignment"] = "point" !== this.layout.get("symbol-placement") ? "map" : "viewport"), "auto" === this.layout.get("text-pitch-alignment") && (this.layout._values["text-pitch-alignment"] = "map" === this.layout.get("text-rotation-alignment") ? "map" : "viewport"), "auto" === this.layout.get("icon-pitch-alignment") && (this.layout._values["icon-pitch-alignment"] = this.layout.get("icon-rotation-alignment")), "point" === this.layout.get("symbol-placement")) {
                                const Qe = this.layout.get("text-writing-mode");
                                if (Qe) {
                                    const rt = [];
                                    for (const Wn of Qe)rt.indexOf(Wn) < 0 && rt.push(Wn);
                                    this.layout._values["text-writing-mode"] = rt;
                                } else this.layout._values["text-writing-mode"] = [
                                    "horizontal"
                                ];
                            }
                            this._setPaintOverrides();
                        }
                        getValueAndResolveTokens(Qe, rt, Wn, Co) {
                            const Dl = this.layout.get(Qe).evaluate(rt, {}, Wn, Co), Ll = this._unevaluatedLayout._values[Qe];
                            return Ll.isDataDriven() || Hr(Ll.value) || !Dl ? Dl : function(Qe, rt) {
                                return rt.replace(/{([^{}]+)}/g, (rt, Wn)=>Qe && Wn in Qe ? String(Qe[Wn]) : "");
                            }(rt.properties, Dl);
                        }
                        createBucket(Qe) {
                            return new Uu(Qe);
                        }
                        queryRadius() {
                            return 0;
                        }
                        queryIntersectsFeature() {
                            throw new Error("Should take a different path in FeatureIndex");
                        }
                        _setPaintOverrides() {
                            for (const Qe of Bm.paint.overridableProperties){
                                if (!Yu.hasPaintOverride(this.layout, Qe)) continue;
                                const rt = this.paint.get(Qe), Wn = new Hu(rt), Co = new Xr(Wn, rt.property.specification);
                                let Dl = null;
                                Dl = "constant" === rt.value.kind || "source" === rt.value.kind ? new Jr("source", Co) : new Kr("composite", Co, rt.value.zoomStops), this.paint._values[Qe] = new $i(rt.property, Dl, rt.parameters);
                            }
                        }
                        _handleOverridablePaintPropertyUpdate(Qe, rt, Wn) {
                            return !(!this.layout || rt.isDataDriven() || Wn.isDataDriven()) && Yu.hasPaintOverride(this.layout, Qe);
                        }
                        static hasPaintOverride(Qe, rt) {
                            const Wn = Qe.get("text-field"), Co = Bm.paint.properties[rt];
                            let Dl = !1;
                            const s = (Qe)=>{
                                for (const rt of Qe)if (Co.overrides && Co.overrides.hasOverride(rt)) return void (Dl = !0);
                            };
                            if ("constant" === Wn.value.kind && Wn.value.value instanceof Mt) s(Wn.value.value.sections);
                            else if ("source" === Wn.value.kind) {
                                const t = (Qe)=>{
                                    Dl || (Qe instanceof $t && Dt(Qe.value) === Ju ? s(Qe.value.sections) : Qe instanceof _e ? s(Qe.sections) : Qe.eachChild(t));
                                }, Qe = Wn.value;
                                Qe._styleExpression && t(Qe._styleExpression.expression);
                            }
                            return Dl;
                        }
                    }
                    let Om;
                    var Fm = {
                        get paint () {
                            return Om = Om || new Gi({
                                "background-color": new Ri(Tc.paint_background["background-color"]),
                                "background-pattern": new qi(Tc.paint_background["background-pattern"]),
                                "background-opacity": new Ri(Tc.paint_background["background-opacity"])
                            });
                        }
                    };
                    class Wu extends Xi {
                        constructor(Qe){
                            super(Qe, Fm);
                        }
                    }
                    let jm;
                    var Um = {
                        get paint () {
                            return jm = jm || new Gi({
                                "raster-opacity": new Ri(Tc.paint_raster["raster-opacity"]),
                                "raster-hue-rotate": new Ri(Tc.paint_raster["raster-hue-rotate"]),
                                "raster-brightness-min": new Ri(Tc.paint_raster["raster-brightness-min"]),
                                "raster-brightness-max": new Ri(Tc.paint_raster["raster-brightness-max"]),
                                "raster-saturation": new Ri(Tc.paint_raster["raster-saturation"]),
                                "raster-contrast": new Ri(Tc.paint_raster["raster-contrast"]),
                                "raster-resampling": new Ri(Tc.paint_raster["raster-resampling"]),
                                "raster-fade-duration": new Ri(Tc.paint_raster["raster-fade-duration"])
                            });
                        }
                    };
                    class ec extends Xi {
                        constructor(Qe){
                            super(Qe, Um);
                        }
                    }
                    class rc extends Xi {
                        constructor(Qe){
                            super(Qe, {}), this.onAdd = (Qe)=>{
                                this.implementation.onAdd && this.implementation.onAdd(Qe, Qe.painter.context.gl);
                            }, this.onRemove = (Qe)=>{
                                this.implementation.onRemove && this.implementation.onRemove(Qe, Qe.painter.context.gl);
                            }, this.implementation = Qe;
                        }
                        is3D() {
                            return "3d" === this.implementation.renderingMode;
                        }
                        hasOffscreenPass() {
                            return void 0 !== this.implementation.prerender;
                        }
                        recalculate() {}
                        updateTransitions() {}
                        hasTransition() {
                            return !1;
                        }
                        serialize() {
                            throw new Error("Custom layers cannot be serialized");
                        }
                    }
                    function nc(Qe) {
                        if ("custom" === Qe.type) return new rc(Qe);
                        switch(Qe.type){
                            case "background":
                                return new Wu(Qe);
                            case "circle":
                                return new Jo(Qe);
                            case "fill":
                                return new tl(Qe);
                            case "fill-extrusion":
                                return new Al(Qe);
                            case "heatmap":
                                return new aa(Qe);
                            case "hillshade":
                                return new ca(Qe);
                            case "line":
                                return new Nl(Qe);
                            case "raster":
                                return new ec(Qe);
                            case "symbol":
                                return new Yu(Qe);
                        }
                    }
                    class ic {
                        constructor(Qe){
                            this.keyCache = {}, Qe && this.replace(Qe);
                        }
                        replace(Qe) {
                            this._layerConfigs = {}, this._layers = {}, this.update(Qe, []);
                        }
                        update(Qe, rt) {
                            for (const Co of Qe){
                                this._layerConfigs[Co.id] = Co;
                                const Qe = this._layers[Co.id] = nc(Co);
                                Qe._featureFilter = nn(Qe.filter), this.keyCache[Co.id] && delete this.keyCache[Co.id];
                            }
                            for (const Co of rt)delete this.keyCache[Co], delete this._layerConfigs[Co], delete this._layers[Co];
                            this.familiesBySource = {};
                            const Wn = function(Qe, rt) {
                                const Wn = {};
                                for(let Dl = 0; Dl < Qe.length; Dl++){
                                    const Co = rt && rt[Qe[Dl].id] || fn(Qe[Dl]);
                                    rt && (rt[Qe[Dl].id] = Co);
                                    let Ll = Wn[Co];
                                    Ll || (Ll = Wn[Co] = []), Ll.push(Qe[Dl]);
                                }
                                const Co = [];
                                for(const Dl in Wn)Co.push(Wn[Dl]);
                                return Co;
                            }(Object.values(this._layerConfigs), this.keyCache);
                            for (const Co of Wn){
                                const Qe = Co.map((Qe)=>this._layers[Qe.id]), rt = Qe[0];
                                if ("none" === rt.visibility) continue;
                                const Wn = rt.source || "";
                                let Dl = this.familiesBySource[Wn];
                                Dl || (Dl = this.familiesBySource[Wn] = {});
                                const Ll = rt.sourceLayer || "_geojsonTileLayer";
                                let Rl = Dl[Ll];
                                Rl || (Rl = Dl[Ll] = []), Rl.push(Qe);
                            }
                        }
                    }
                    class sc {
                        constructor(Qe){
                            this._stringToNumber = {}, this._numberToString = [];
                            for(let rt = 0; rt < Qe.length; rt++){
                                const Wn = Qe[rt];
                                this._stringToNumber[Wn] = rt, this._numberToString[rt] = Wn;
                            }
                        }
                        encode(Qe) {
                            return this._stringToNumber[Qe];
                        }
                        decode(Qe) {
                            if (Qe >= this._numberToString.length) throw new Error(`Out of bounds. Index requested n=${Qe} can't be >= this._numberToString.length ${this._numberToString.length}`);
                            return this._numberToString[Qe];
                        }
                    }
                    class oc {
                        constructor(Qe, rt, Wn, Co, Dl){
                            this.type = "Feature", this._vectorTileFeature = Qe, Qe._z = rt, Qe._x = Wn, Qe._y = Co, this.properties = Qe.properties, this.id = Dl;
                        }
                        get geometry() {
                            return void 0 === this._geometry && (this._geometry = this._vectorTileFeature.toGeoJSON(this._vectorTileFeature._x, this._vectorTileFeature._y, this._vectorTileFeature._z).geometry), this._geometry;
                        }
                        set geometry(Qe) {
                            this._geometry = Qe;
                        }
                        toJSON() {
                            const Qe = {
                                geometry: this.geometry
                            };
                            for(const rt in this)"_geometry" !== rt && "_vectorTileFeature" !== rt && (Qe[rt] = this[rt]);
                            return Qe;
                        }
                    }
                    class ac {
                        constructor(Qe, rt){
                            this.tileID = Qe, this.x = Qe.canonical.x, this.y = Qe.canonical.y, this.z = Qe.canonical.z, this.grid = new z(ql, 16, 0), this.grid3D = new z(ql, 16, 0), this.featureIndexArray = new Vs, this.promoteId = rt;
                        }
                        insert(Qe, rt, Wn, Co, Dl, Ll) {
                            const Rl = this.featureIndexArray.length;
                            this.featureIndexArray.emplaceBack(Wn, Co, Dl);
                            const Ul = Ll ? this.grid3D : this.grid;
                            for(let Gl = 0; Gl < rt.length; Gl++){
                                const Qe = rt[Gl], Wn = [
                                    1 / 0,
                                    1 / 0,
                                    -1 / 0,
                                    -1 / 0
                                ];
                                for(let rt = 0; rt < Qe.length; rt++){
                                    const Co = Qe[rt];
                                    Wn[0] = Math.min(Wn[0], Co.x), Wn[1] = Math.min(Wn[1], Co.y), Wn[2] = Math.max(Wn[2], Co.x), Wn[3] = Math.max(Wn[3], Co.y);
                                }
                                Wn[0] < ql && Wn[1] < ql && Wn[2] >= 0 && Wn[3] >= 0 && Ul.insert(Rl, Wn[0], Wn[1], Wn[2], Wn[3]);
                            }
                        }
                        loadVTLayers() {
                            return this.vtLayers || (this.vtLayers = new $p.VectorTile(new Mm(this.rawTileData)).layers, this.sourceLayerCoder = new sc(this.vtLayers ? Object.keys(this.vtLayers).sort() : [
                                "_geojsonTileLayer"
                            ])), this.vtLayers;
                        }
                        query(Qe, rt, Wn, Co) {
                            this.loadVTLayers();
                            const Ll = Qe.params, Rl = ql / Qe.tileSize / Qe.scale, Ul = nn(Ll.filter), Gl = Qe.queryGeometry, Zl = Qe.queryPadding * Rl, Hl = uc(Gl), Ql = this.grid.query(Hl.minX - Zl, Hl.minY - Zl, Hl.maxX + Zl, Hl.maxY + Zl), Kl = uc(Qe.cameraQueryGeometry), $l = this.grid3D.query(Kl.minX - Zl, Kl.minY - Zl, Kl.maxX + Zl, Kl.maxY + Zl, (rt, Wn, Co, Ll)=>(function(Qe, rt, Wn, Co, Ll) {
                                    for (const Dl of Qe)if (rt <= Dl.x && Wn <= Dl.y && Co >= Dl.x && Ll >= Dl.y) return !0;
                                    const Rl = [
                                        new Dl(rt, Wn),
                                        new Dl(rt, Ll),
                                        new Dl(Co, Ll),
                                        new Dl(Co, Wn)
                                    ];
                                    if (Qe.length > 2) {
                                        for (const Dl of Rl)if (jo(Qe, Dl)) return !0;
                                    }
                                    for(let Dl = 0; Dl < Qe.length - 1; Dl++)if (qo(Qe[Dl], Qe[Dl + 1], Rl)) return !0;
                                    return !1;
                                })(Qe.cameraQueryGeometry, rt - Zl, Wn - Zl, Co + Zl, Ll + Zl));
                            for (const Dl of $l)Ql.push(Dl);
                            Ql.sort(cc);
                            const Tc = {};
                            let tu;
                            for(let Dl = 0; Dl < Ql.length; Dl++){
                                const Zl = Ql[Dl];
                                if (Zl === tu) continue;
                                tu = Zl;
                                const Hl = this.featureIndexArray.get(Zl);
                                let ql = null;
                                this.loadMatchingFeature(Tc, Hl.bucketIndex, Hl.sourceLayerIndex, Hl.featureIndex, Ul, Ll.layers, Ll.availableImages, rt, Wn, Co, (rt, Wn, Co)=>(ql || (ql = zo(rt)), Wn.queryIntersectsFeature({
                                        queryGeometry: Gl,
                                        feature: rt,
                                        featureState: Co,
                                        geometry: ql,
                                        zoom: this.z,
                                        transform: Qe.transform,
                                        pixelsToTileUnits: Rl,
                                        pixelPosMatrix: Qe.pixelPosMatrix,
                                        unwrappedTileID: this.tileID.toUnwrapped(),
                                        getElevation: Qe.getElevation
                                    })));
                            }
                            return Tc;
                        }
                        loadMatchingFeature(Qe, rt, Wn, Co, Dl, Ll, Rl, Ul, Gl, Zl, Hl) {
                            const ql = this.bucketLayerIDs[rt];
                            if (Ll && !ql.some((Qe)=>Ll.has(Qe))) return;
                            const Ql = this.sourceLayerCoder.decode(Wn), Kl = this.vtLayers[Ql].feature(Co);
                            if (Dl.needGeometry) {
                                const Qe = Po(Kl, !0);
                                if (!Dl.filter(new Bi(this.tileID.overscaledZ), Qe, this.tileID.canonical)) return;
                            } else if (!Dl.filter(new Bi(this.tileID.overscaledZ), Kl)) return;
                            const $l = this.getId(Kl, Ql);
                            for(let Tc = 0; Tc < ql.length; Tc++){
                                const rt = ql[Tc];
                                if (Ll && !Ll.has(rt)) continue;
                                const Wn = Ul[rt];
                                if (!Wn) continue;
                                let Dl = {};
                                $l && Zl && (Dl = Zl.getState(Wn.sourceLayer || "_geojsonTileLayer", $l));
                                const Ql = g({}, Gl[rt]);
                                Ql.paint = lc(Ql.paint, Wn.paint, Kl, Dl, Rl), Ql.layout = lc(Ql.layout, Wn.layout, Kl, Dl, Rl);
                                const tu = !Hl || Hl(Kl, Wn, Dl);
                                if (!tu) continue;
                                const lu = new oc(Kl, this.z, this.x, this.y, $l);
                                lu.layer = Ql;
                                let du = Qe[rt];
                                void 0 === du && (du = Qe[rt] = []), du.push({
                                    featureIndex: Co,
                                    feature: lu,
                                    intersectionZ: tu
                                });
                            }
                        }
                        lookupSymbolFeatures(Qe, rt, Wn, Co, Dl, Ll, Rl, Ul) {
                            const Gl = {};
                            this.loadVTLayers();
                            const Zl = nn(Dl);
                            for (const Hl of Qe)this.loadMatchingFeature(Gl, Wn, Co, Hl, Zl, Ll, Rl, Ul, rt);
                            return Gl;
                        }
                        hasLayer(Qe) {
                            for (const rt of this.bucketLayerIDs)for (const Wn of rt)if (Qe === Wn) return !0;
                            return !1;
                        }
                        getId(Qe, rt) {
                            var Wn;
                            let Co = Qe.id;
                            return this.promoteId && (Co = Qe.properties["string" == typeof this.promoteId ? this.promoteId : this.promoteId[rt]], "boolean" == typeof Co && (Co = Number(Co)), void 0 === Co && (null === (Wn = Qe.properties) || void 0 === Wn ? void 0 : Wn.cluster) && this.promoteId && (Co = Number(Qe.properties.cluster_id))), Co;
                        }
                    }
                    function lc(Qe, rt, Wn, Co, Dl) {
                        return x(Qe, (Qe, Ll)=>{
                            const Rl = rt instanceof Oi ? rt.get(Ll) : null;
                            return Rl && Rl.evaluate ? Rl.evaluate(Wn, Co, Dl) : Rl;
                        });
                    }
                    function uc(Qe) {
                        let rt = 1 / 0, Wn = 1 / 0, Co = -1 / 0, Dl = -1 / 0;
                        for (const Ll of Qe)rt = Math.min(rt, Ll.x), Wn = Math.min(Wn, Ll.y), Co = Math.max(Co, Ll.x), Dl = Math.max(Dl, Ll.y);
                        return {
                            minX: rt,
                            minY: Wn,
                            maxX: Co,
                            maxY: Dl
                        };
                    }
                    function cc(Qe, rt) {
                        return rt - Qe;
                    }
                    Qn("FeatureIndex", ac, {
                        omit: [
                            "rawTileData",
                            "sourceLayerCoder"
                        ]
                    });
                    class hc extends Dl {
                        constructor(Qe, rt, Wn, Co){
                            super(Qe, rt), this.angle = Wn, void 0 !== Co && (this.segment = Co);
                        }
                        clone() {
                            return new hc(this.x, this.y, this.angle, this.segment);
                        }
                    }
                    function pc(Qe, rt, Wn, Co, Dl) {
                        if (void 0 === rt.segment || 0 === Wn) return !0;
                        let Ll = rt, Rl = rt.segment + 1, Ul = 0;
                        for(; Ul > -Wn / 2;){
                            if (Rl--, Rl < 0) return !1;
                            Ul -= Qe[Rl].dist(Ll), Ll = Qe[Rl];
                        }
                        Ul += Qe[Rl].dist(Qe[Rl + 1]), Rl++;
                        const Gl = [];
                        let Zl = 0;
                        for(; Ul < Wn / 2;){
                            const rt = Qe[Rl], Wn = Qe[Rl + 1];
                            if (!Wn) return !1;
                            let Ll = Qe[Rl - 1].angleTo(rt) - rt.angleTo(Wn);
                            for(Ll = Math.abs((Ll + 3 * Math.PI) % (2 * Math.PI) - Math.PI), Gl.push({
                                distance: Ul,
                                angleDelta: Ll
                            }), Zl += Ll; Ul - Gl[0].distance > Co;)Zl -= Gl.shift().angleDelta;
                            if (Zl > Dl) return !1;
                            Rl++, Ul += rt.dist(Wn);
                        }
                        return !0;
                    }
                    function fc(Qe) {
                        let rt = 0;
                        for(let Wn = 0; Wn < Qe.length - 1; Wn++)rt += Qe[Wn].dist(Qe[Wn + 1]);
                        return rt;
                    }
                    function dc(Qe, rt, Wn) {
                        return Qe ? .6 * rt * Wn : 0;
                    }
                    function yc(Qe, rt) {
                        return Math.max(Qe ? Qe.right - Qe.left : 0, rt ? rt.right - rt.left : 0);
                    }
                    function mc(Qe, rt, Wn, Co, Dl, Ll) {
                        const Rl = dc(Wn, Dl, Ll), Ul = yc(Wn, Co) * Ll;
                        let Gl = 0;
                        const Zl = fc(Qe) / 2;
                        for(let Hl = 0; Hl < Qe.length - 1; Hl++){
                            const Wn = Qe[Hl], Co = Qe[Hl + 1], Dl = Wn.dist(Co);
                            if (Gl + Dl > Zl) {
                                const Ll = (Zl - Gl) / Dl, ql = xd.number(Wn.x, Co.x, Ll), Ql = xd.number(Wn.y, Co.y, Ll), Kl = new hc(ql, Ql, Co.angleTo(Wn), Hl);
                                return Kl._round(), !Rl || pc(Qe, Kl, Ul, Rl, rt) ? Kl : void 0;
                            }
                            Gl += Dl;
                        }
                    }
                    function gc(Qe, rt, Wn, Co, Dl, Ll, Rl, Ul, Gl) {
                        const Zl = dc(Co, Ll, Rl), Hl = yc(Co, Dl), ql = Hl * Rl, Ql = 0 === Qe[0].x || Qe[0].x === Gl || 0 === Qe[0].y || Qe[0].y === Gl;
                        return rt - ql < rt / 4 && (rt = ql + rt / 4), xc(Qe, Ql ? rt / 2 * Ul % rt : (Hl / 2 + 2 * Ll) * Rl * Ul % rt, rt, Zl, Wn, ql, Ql, !1, Gl);
                    }
                    function xc(Qe, rt, Wn, Co, Dl, Ll, Rl, Ul, Gl) {
                        const Zl = Ll / 2, Hl = fc(Qe);
                        let ql = 0, Ql = rt - Wn, Kl = [];
                        for(let $l = 0; $l < Qe.length - 1; $l++){
                            const rt = Qe[$l], Rl = Qe[$l + 1], Ul = rt.dist(Rl), Tc = Rl.angleTo(rt);
                            for(; Ql + Wn < ql + Ul;){
                                Ql += Wn;
                                const tu = (Ql - ql) / Ul, lu = xd.number(rt.x, Rl.x, tu), du = xd.number(rt.y, Rl.y, tu);
                                if (lu >= 0 && lu < Gl && du >= 0 && du < Gl && Ql - Zl >= 0 && Ql + Zl <= Hl) {
                                    const rt = new hc(lu, du, Tc, $l);
                                    rt._round(), Co && !pc(Qe, rt, Ll, Co, Dl) || Kl.push(rt);
                                }
                            }
                            ql += Ul;
                        }
                        return Ul || Kl.length || Rl || (Kl = xc(Qe, ql / 2, Wn, Co, Dl, Ll, Rl, !0, Gl)), Kl;
                    }
                    Qn("Anchor", hc);
                    function bc(Qe, rt, Wn, Co) {
                        const Ll = [], Rl = Qe.image, Ul = Rl.pixelRatio, Gl = Rl.paddedRect.w - 2, Zl = Rl.paddedRect.h - 2;
                        let Hl = {
                            x1: Qe.left,
                            y1: Qe.top,
                            x2: Qe.right,
                            y2: Qe.bottom
                        };
                        const ql = Rl.stretchX || [
                            [
                                0,
                                Gl
                            ]
                        ], Ql = Rl.stretchY || [
                            [
                                0,
                                Zl
                            ]
                        ], f = (Qe, rt)=>Qe + rt[1] - rt[0], Kl = ql.reduce(f, 0), $l = Ql.reduce(f, 0), Tc = Gl - Kl, tu = Zl - $l;
                        let lu = 0, du = Kl, fu = 0, yu = $l, Eu = 0, Tu = Tc, Lu = 0, Zu = tu;
                        if (Rl.content && Co) {
                            const rt = Rl.content, Wn = rt[2] - rt[0], Co = rt[3] - rt[1];
                            (Rl.textFitWidth || Rl.textFitHeight) && (Hl = Cu(Qe)), lu = wc(ql, 0, rt[0]), fu = wc(Ql, 0, rt[1]), du = wc(ql, rt[0], rt[2]), yu = wc(Ql, rt[1], rt[3]), Eu = rt[0] - lu, Lu = rt[1] - fu, Tu = Wn - du, Zu = Co - yu;
                        }
                        const Xu = Hl.x1, Ju = Hl.y1, $u = Hl.x2 - Xu, ed = Hl.y2 - Ju, C = (Qe, Co, Ll, Gl)=>{
                            const Zl = Sc(Qe.stretch - lu, du, $u, Xu), Hl = kc(Qe.fixed - Eu, Tu, Qe.stretch, Kl), ql = Sc(Co.stretch - fu, yu, ed, Ju), Ql = kc(Co.fixed - Lu, Zu, Co.stretch, $l), Tc = Sc(Ll.stretch - lu, du, $u, Xu), tu = kc(Ll.fixed - Eu, Tu, Ll.stretch, Kl), td = Sc(Gl.stretch - fu, yu, ed, Ju), id = kc(Gl.fixed - Lu, Zu, Gl.stretch, $l), nd = new Dl(Zl, ql), rd = new Dl(Tc, ql), sd = new Dl(Tc, td), ad = new Dl(Zl, td), od = new Dl(Hl / Ul, Ql / Ul), ld = new Dl(tu / Ul, id / Ul), cd = rt * Math.PI / 180;
                            if (cd) {
                                const Qe = Math.sin(cd), rt = Math.cos(cd), Wn = [
                                    rt,
                                    -Qe,
                                    Qe,
                                    rt
                                ];
                                nd._matMult(Wn), rd._matMult(Wn), ad._matMult(Wn), sd._matMult(Wn);
                            }
                            const ud = Qe.stretch + Qe.fixed, hd = Co.stretch + Co.fixed;
                            return {
                                tl: nd,
                                tr: rd,
                                bl: ad,
                                br: sd,
                                tex: {
                                    x: Rl.paddedRect.x + 1 + ud,
                                    y: Rl.paddedRect.y + 1 + hd,
                                    w: Ll.stretch + Ll.fixed - ud,
                                    h: Gl.stretch + Gl.fixed - hd
                                },
                                writingMode: void 0,
                                glyphOffset: [
                                    0,
                                    0
                                ],
                                sectionIndex: 0,
                                pixelOffsetTL: od,
                                pixelOffsetBR: ld,
                                minFontScaleX: Tu / Ul / $u,
                                minFontScaleY: Zu / Ul / ed,
                                isSDF: Wn
                            };
                        };
                        if (Co && (Rl.stretchX || Rl.stretchY)) {
                            const Qe = _c(ql, Tc, Kl), rt = _c(Ql, tu, $l);
                            for(let Wn = 0; Wn < Qe.length - 1; Wn++){
                                const Co = Qe[Wn], Dl = Qe[Wn + 1];
                                for(let Qe = 0; Qe < rt.length - 1; Qe++)Ll.push(C(Co, rt[Qe], Dl, rt[Qe + 1]));
                            }
                        } else Ll.push(C({
                            fixed: 0,
                            stretch: -1
                        }, {
                            fixed: 0,
                            stretch: -1
                        }, {
                            fixed: 0,
                            stretch: Gl + 1
                        }, {
                            fixed: 0,
                            stretch: Zl + 1
                        }));
                        return Ll;
                    }
                    function wc(Qe, rt, Wn) {
                        let Co = 0;
                        for (const Dl of Qe)Co += Math.max(rt, Math.min(Wn, Dl[1])) - Math.max(rt, Math.min(Wn, Dl[0]));
                        return Co;
                    }
                    function _c(Qe, rt, Wn) {
                        const Co = [
                            {
                                fixed: -1,
                                stretch: 0
                            }
                        ];
                        for (const [Dl, Ll] of Qe){
                            const Qe = Co[Co.length - 1];
                            Co.push({
                                fixed: Dl - Qe.stretch,
                                stretch: Qe.stretch
                            }), Co.push({
                                fixed: Dl - Qe.stretch,
                                stretch: Qe.stretch + (Ll - Dl)
                            });
                        }
                        return Co.push({
                            fixed: rt + 1,
                            stretch: Wn
                        }), Co;
                    }
                    function Sc(Qe, rt, Wn, Co) {
                        return Qe / rt * Wn + Co;
                    }
                    function kc(Qe, rt, Wn, Co) {
                        return Qe - rt * Wn / Co;
                    }
                    class Ac {
                        constructor(Qe, rt, Wn, Co, Ll, Rl, Ul, Gl, Zl, Hl){
                            var ql;
                            if (this.boxStartIndex = Qe.length, Zl) {
                                let Qe = Rl.top, rt = Rl.bottom;
                                const Wn = Rl.collisionPadding;
                                Wn && (Qe -= Wn[1], rt += Wn[3]);
                                let Co = rt - Qe;
                                Co > 0 && (Co = Math.max(10, Co), this.circleDiameter = Co);
                            } else {
                                const Zl = (null === (ql = Rl.image) || void 0 === ql ? void 0 : ql.content) && (Rl.image.textFitWidth || Rl.image.textFitHeight) ? Cu(Rl) : {
                                    x1: Rl.left,
                                    y1: Rl.top,
                                    x2: Rl.right,
                                    y2: Rl.bottom
                                };
                                Zl.y1 = Zl.y1 * Ul - Gl[0], Zl.y2 = Zl.y2 * Ul + Gl[2], Zl.x1 = Zl.x1 * Ul - Gl[3], Zl.x2 = Zl.x2 * Ul + Gl[1];
                                const Ql = Rl.collisionPadding;
                                if (Ql && (Zl.x1 -= Ql[0] * Ul, Zl.y1 -= Ql[1] * Ul, Zl.x2 += Ql[2] * Ul, Zl.y2 += Ql[3] * Ul), Hl) {
                                    const Qe = new Dl(Zl.x1, Zl.y1), rt = new Dl(Zl.x2, Zl.y1), Wn = new Dl(Zl.x1, Zl.y2), Co = new Dl(Zl.x2, Zl.y2), Ll = Hl * Math.PI / 180;
                                    Qe._rotate(Ll), rt._rotate(Ll), Wn._rotate(Ll), Co._rotate(Ll), Zl.x1 = Math.min(Qe.x, rt.x, Wn.x, Co.x), Zl.x2 = Math.max(Qe.x, rt.x, Wn.x, Co.x), Zl.y1 = Math.min(Qe.y, rt.y, Wn.y, Co.y), Zl.y2 = Math.max(Qe.y, rt.y, Wn.y, Co.y);
                                }
                                Qe.emplaceBack(rt.x, rt.y, Zl.x1, Zl.y1, Zl.x2, Zl.y2, Wn, Co, Ll);
                            }
                            this.boxEndIndex = Qe.length;
                        }
                    }
                    class Ic {
                        constructor(Qe, rt){
                            if (void 0 === Qe && (Qe = []), void 0 === rt && (rt = (Qe, rt)=>Qe < rt ? -1 : Qe > rt ? 1 : 0), this.data = Qe, this.length = this.data.length, this.compare = rt, this.length > 0) for(let Wn = (this.length >> 1) - 1; Wn >= 0; Wn--)this._down(Wn);
                        }
                        push(Qe) {
                            this.data.push(Qe), this._up(this.length++);
                        }
                        pop() {
                            if (0 === this.length) return;
                            const Qe = this.data[0], rt = this.data.pop();
                            return --this.length > 0 && (this.data[0] = rt, this._down(0)), Qe;
                        }
                        peek() {
                            return this.data[0];
                        }
                        _up(Qe) {
                            const { data: rt, compare: Wn } = this, Co = rt[Qe];
                            for(; Qe > 0;){
                                const Dl = Qe - 1 >> 1, Ll = rt[Dl];
                                if (Wn(Co, Ll) >= 0) break;
                                rt[Qe] = Ll, Qe = Dl;
                            }
                            rt[Qe] = Co;
                        }
                        _down(Qe) {
                            const { data: rt, compare: Wn } = this, Co = this.length >> 1, Dl = rt[Qe];
                            for(; Qe < Co;){
                                let Co = 1 + (Qe << 1);
                                const Ll = Co + 1;
                                if (Ll < this.length && Wn(rt[Ll], rt[Co]) < 0 && (Co = Ll), Wn(rt[Co], Dl) >= 0) break;
                                rt[Qe] = rt[Co], Qe = Co;
                            }
                            rt[Qe] = Dl;
                        }
                    }
                    function Mc(Qe, rt, Wn) {
                        void 0 === rt && (rt = 1), void 0 === Wn && (Wn = !1);
                        let Co = 1 / 0, Ll = 1 / 0, Rl = -1 / 0, Ul = -1 / 0;
                        const Gl = Qe[0];
                        for(let Dl = 0; Dl < Gl.length; Dl++){
                            const Qe = Gl[Dl];
                            (!Dl || Qe.x < Co) && (Co = Qe.x), (!Dl || Qe.y < Ll) && (Ll = Qe.y), (!Dl || Qe.x > Rl) && (Rl = Qe.x), (!Dl || Qe.y > Ul) && (Ul = Qe.y);
                        }
                        const Zl = Math.min(Rl - Co, Ul - Ll);
                        let Hl = Zl / 2;
                        const ql = new Ic([], zc);
                        if (0 === Zl) return new Dl(Co, Ll);
                        for(let Dl = Co; Dl < Rl; Dl += Zl)for(let rt = Ll; rt < Ul; rt += Zl)ql.push(new Pc(Dl + Hl, rt + Hl, Hl, Qe));
                        let Ql = function(Qe) {
                            let rt = 0, Wn = 0, Co = 0;
                            const Dl = Qe[0];
                            for(let Ll = 0, Rl = Dl.length, Ul = Rl - 1; Ll < Rl; Ul = Ll++){
                                const Qe = Dl[Ll], Rl = Dl[Ul], Gl = Qe.x * Rl.y - Rl.x * Qe.y;
                                Wn += (Qe.x + Rl.x) * Gl, Co += (Qe.y + Rl.y) * Gl, rt += 3 * Gl;
                            }
                            return new Pc(Wn / rt, Co / rt, 0, Qe);
                        }(Qe), Kl = ql.length;
                        for(; ql.length;){
                            const Co = ql.pop();
                            (Co.d > Ql.d || !Ql.d) && (Ql = Co, Wn && console.log("found best %d after %d probes", Math.round(1e4 * Co.d) / 1e4, Kl)), Co.max - Ql.d <= rt || (Hl = Co.h / 2, ql.push(new Pc(Co.p.x - Hl, Co.p.y - Hl, Hl, Qe)), ql.push(new Pc(Co.p.x + Hl, Co.p.y - Hl, Hl, Qe)), ql.push(new Pc(Co.p.x - Hl, Co.p.y + Hl, Hl, Qe)), ql.push(new Pc(Co.p.x + Hl, Co.p.y + Hl, Hl, Qe)), Kl += 4);
                        }
                        return Wn && (console.log(`num probes: ${Kl}`), console.log(`best distance: ${Ql.d}`)), Ql.p;
                    }
                    function zc(Qe, rt) {
                        return rt.max - Qe.max;
                    }
                    function Pc(Qe, rt, Wn, Co) {
                        this.p = new Dl(Qe, rt), this.h = Wn, this.d = function(Qe, rt) {
                            let Wn = !1, Co = 1 / 0;
                            for(let Dl = 0; Dl < rt.length; Dl++){
                                const Ll = rt[Dl];
                                for(let rt = 0, Dl = Ll.length, Rl = Dl - 1; rt < Dl; Rl = rt++){
                                    const Dl = Ll[rt], Ul = Ll[Rl];
                                    Dl.y > Qe.y != Ul.y > Qe.y && Qe.x < (Ul.x - Dl.x) * (Qe.y - Dl.y) / (Ul.y - Dl.y) + Dl.x && (Wn = !Wn), Co = Math.min(Co, Ro(Qe, Dl, Ul));
                                }
                            }
                            return (Wn ? 1 : -1) * Math.sqrt(Co);
                        }(this.p, Co), this.max = this.d + this.h * Math.SQRT2;
                    }
                    var Vm;
                    !function(Qe) {
                        Qe[Qe.center = 1] = "center", Qe[Qe.left = 2] = "left", Qe[Qe.right = 3] = "right", Qe[Qe.top = 4] = "top", Qe[Qe.bottom = 5] = "bottom", Qe[Qe["top-left"] = 6] = "top-left", Qe[Qe["top-right"] = 7] = "top-right", Qe[Qe["bottom-left"] = 8] = "bottom-left", Qe[Qe["bottom-right"] = 9] = "bottom-right";
                    }(Vm || (Vm = {}));
                    const Gm = Number.POSITIVE_INFINITY;
                    function Vc(Qe, rt) {
                        return rt[1] !== Gm ? function(Qe, rt, Wn) {
                            let Co = 0, Dl = 0;
                            switch(rt = Math.abs(rt), Wn = Math.abs(Wn), Qe){
                                case "top-right":
                                case "top-left":
                                case "top":
                                    Dl = Wn - 7;
                                    break;
                                case "bottom-right":
                                case "bottom-left":
                                case "bottom":
                                    Dl = 7 - Wn;
                            }
                            switch(Qe){
                                case "top-right":
                                case "bottom-right":
                                case "right":
                                    Co = -rt;
                                    break;
                                case "top-left":
                                case "bottom-left":
                                case "left":
                                    Co = rt;
                            }
                            return [
                                Co,
                                Dl
                            ];
                        }(Qe, rt[0], rt[1]) : function(Qe, rt) {
                            let Wn = 0, Co = 0;
                            rt < 0 && (rt = 0);
                            const Dl = rt / Math.SQRT2;
                            switch(Qe){
                                case "top-right":
                                case "top-left":
                                    Co = Dl - 7;
                                    break;
                                case "bottom-right":
                                case "bottom-left":
                                    Co = 7 - Dl;
                                    break;
                                case "bottom":
                                    Co = 7 - rt;
                                    break;
                                case "top":
                                    Co = rt - 7;
                            }
                            switch(Qe){
                                case "top-right":
                                case "bottom-right":
                                    Wn = -Dl;
                                    break;
                                case "top-left":
                                case "bottom-left":
                                    Wn = Dl;
                                    break;
                                case "left":
                                    Wn = rt;
                                    break;
                                case "right":
                                    Wn = -rt;
                            }
                            return [
                                Wn,
                                Co
                            ];
                        }(Qe, rt[0]);
                    }
                    function Ec(Qe, rt, Wn) {
                        var Co;
                        const Dl = Qe.layout, Ll = null === (Co = Dl.get("text-variable-anchor-offset")) || void 0 === Co ? void 0 : Co.evaluate(rt, {}, Wn);
                        if (Ll) {
                            const Qe = Ll.values, rt = [];
                            for(let Wn = 0; Wn < Qe.length; Wn += 2){
                                const Co = rt[Wn] = Qe[Wn], Dl = Qe[Wn + 1].map((Qe)=>Qe * wm);
                                Co.startsWith("top") ? Dl[1] -= 7 : Co.startsWith("bottom") && (Dl[1] += 7), rt[Wn + 1] = Dl;
                            }
                            return new Bt(rt);
                        }
                        const Rl = Dl.get("text-variable-anchor");
                        if (Rl) {
                            let Co;
                            Co = void 0 !== Qe._unevaluatedLayout.getValue("text-radial-offset") ? [
                                Dl.get("text-radial-offset").evaluate(rt, {}, Wn) * wm,
                                Gm
                            ] : Dl.get("text-offset").evaluate(rt, {}, Wn).map((Qe)=>Qe * wm);
                            const Ll = [];
                            for (const Qe of Rl)Ll.push(Qe, Vc(Qe, Co));
                            return new Bt(Ll);
                        }
                        return null;
                    }
                    function Fc(Qe) {
                        Qe.bucket.createArrays(), Qe.bucket.tilePixelRatio = ql / (512 * Qe.bucket.overscaling), Qe.bucket.compareText = {}, Qe.bucket.iconsNeedLinear = !1;
                        const rt = Qe.bucket.layers[0], Wn = rt.layout, Co = rt._unevaluatedLayout._values, Dl = {
                            layoutIconSize: Co["icon-size"].possiblyEvaluate(new Bi(Qe.bucket.zoom + 1), Qe.canonical),
                            layoutTextSize: Co["text-size"].possiblyEvaluate(new Bi(Qe.bucket.zoom + 1), Qe.canonical),
                            textMaxSize: Co["text-size"].possiblyEvaluate(new Bi(18))
                        };
                        if ("composite" === Qe.bucket.textSizeData.kind) {
                            const { minZoom: rt, maxZoom: Wn } = Qe.bucket.textSizeData;
                            Dl.compositeTextSizes = [
                                Co["text-size"].possiblyEvaluate(new Bi(rt), Qe.canonical),
                                Co["text-size"].possiblyEvaluate(new Bi(Wn), Qe.canonical)
                            ];
                        }
                        if ("composite" === Qe.bucket.iconSizeData.kind) {
                            const { minZoom: rt, maxZoom: Wn } = Qe.bucket.iconSizeData;
                            Dl.compositeIconSizes = [
                                Co["icon-size"].possiblyEvaluate(new Bi(rt), Qe.canonical),
                                Co["icon-size"].possiblyEvaluate(new Bi(Wn), Qe.canonical)
                            ];
                        }
                        const Ll = Wn.get("text-line-height") * wm, Rl = "viewport" !== Wn.get("text-rotation-alignment") && "point" !== Wn.get("symbol-placement"), Ul = Wn.get("text-keep-upright"), Gl = Wn.get("text-size");
                        for (const Zl of Qe.bucket.features){
                            const Co = Wn.get("text-font").evaluate(Zl, {}, Qe.canonical).join(","), Hl = Gl.evaluate(Zl, {}, Qe.canonical), ql = Dl.layoutTextSize.evaluate(Zl, {}, Qe.canonical), Ql = Dl.layoutIconSize.evaluate(Zl, {}, Qe.canonical), Kl = {
                                horizontal: {},
                                vertical: void 0
                            }, $l = Zl.text;
                            let Tc, tu = [
                                0,
                                0
                            ];
                            if ($l) {
                                const Dl = $l.toString(), Gl = Wn.get("text-letter-spacing").evaluate(Zl, {}, Qe.canonical) * wm, Ql = vi(Dl) ? Gl : 0, Tc = Wn.get("text-anchor").evaluate(Zl, {}, Qe.canonical), lu = Ec(rt, Zl, Qe.canonical);
                                if (!lu) {
                                    const rt = Wn.get("text-radial-offset").evaluate(Zl, {}, Qe.canonical);
                                    tu = rt ? Vc(Tc, [
                                        rt * wm,
                                        Gm
                                    ]) : Wn.get("text-offset").evaluate(Zl, {}, Qe.canonical).map((Qe)=>Qe * wm);
                                }
                                let du = Rl ? "center" : Wn.get("text-justify").evaluate(Zl, {}, Qe.canonical);
                                const fu = "point" === Wn.get("symbol-placement") ? Wn.get("text-max-width").evaluate(Zl, {}, Qe.canonical) * wm : 1 / 0, b = ()=>{
                                    Qe.bucket.allowVerticalPlacement && xi(Dl) && (Kl.vertical = pu($l, Qe.glyphMap, Qe.glyphPositions, Qe.imagePositions, Co, fu, Ll, Tc, "left", Ql, tu, Sm.vertical, !0, ql, Hl));
                                };
                                if (!Rl && lu) {
                                    const rt = new Set;
                                    if ("auto" === du) for(let Qe = 0; Qe < lu.values.length; Qe += 2)rt.add(Dc(lu.values[Qe]));
                                    else rt.add(du);
                                    let Wn = !1;
                                    for (const Dl of rt)if (!Kl.horizontal[Dl]) {
                                        if (Wn) Kl.horizontal[Dl] = Kl.horizontal[0];
                                        else {
                                            const rt = pu($l, Qe.glyphMap, Qe.glyphPositions, Qe.imagePositions, Co, fu, Ll, "center", Dl, Ql, tu, Sm.horizontal, !1, ql, Hl);
                                            rt && (Kl.horizontal[Dl] = rt, Wn = 1 === rt.positionedLines.length);
                                        }
                                    }
                                    b();
                                } else {
                                    "auto" === du && (du = Dc(Tc));
                                    const rt = pu($l, Qe.glyphMap, Qe.glyphPositions, Qe.imagePositions, Co, fu, Ll, Tc, du, Ql, tu, Sm.horizontal, !1, ql, Hl);
                                    rt && (Kl.horizontal[du] = rt), b(), xi(Dl) && Rl && Ul && (Kl.vertical = pu($l, Qe.glyphMap, Qe.glyphPositions, Qe.imagePositions, Co, fu, Ll, Tc, du, Ql, tu, Sm.vertical, !1, ql, Hl));
                                }
                            }
                            let lu = !1;
                            if (Zl.icon && Zl.icon.name) {
                                const rt = Qe.imageMap[Zl.icon.name];
                                rt && (Tc = Pu(Qe.imagePositions[Zl.icon.name], Wn.get("icon-offset").evaluate(Zl, {}, Qe.canonical), Wn.get("icon-anchor").evaluate(Zl, {}, Qe.canonical)), lu = !!rt.sdf, void 0 === Qe.bucket.sdfIcons ? Qe.bucket.sdfIcons = lu : Qe.bucket.sdfIcons !== lu && w("Style sheet warning: Cannot mix SDF and non-SDF icons in one buffer"), (rt.pixelRatio !== Qe.bucket.pixelRatio || 0 !== Wn.get("icon-rotate").constantOr(1)) && (Qe.bucket.iconsNeedLinear = !0));
                            }
                            const du = Oc(Kl.horizontal) || Kl.vertical;
                            Qe.bucket.iconsInText = !!du && du.iconsInText, (du || Tc) && Lc(Qe.bucket, Zl, Kl, Tc, Qe.imageMap, Dl, ql, Ql, tu, lu, Qe.canonical, Qe.subdivisionGranularity);
                        }
                        Qe.showCollisionBoxes && Qe.bucket.generateCollisionDebugBuffers();
                    }
                    function Dc(Qe) {
                        switch(Qe){
                            case "right":
                            case "top-right":
                            case "bottom-right":
                                return "right";
                            case "left":
                            case "top-left":
                            case "bottom-left":
                                return "left";
                        }
                        return "center";
                    }
                    function Lc(Qe, rt, Wn, Co, Ll, Rl, Ul, Gl, Zl, Hl, Ql, Kl) {
                        let $l = Rl.textMaxSize.evaluate(rt, {});
                        void 0 === $l && ($l = Ul);
                        const Tc = Qe.layers[0].layout, tu = Tc.get("icon-offset").evaluate(rt, {}, Ql), lu = Oc(Wn.horizontal), du = Ul / 24, fu = Qe.tilePixelRatio * du, yu = Qe.tilePixelRatio * $l / 24, Eu = Qe.tilePixelRatio * Gl, Tu = Qe.tilePixelRatio * Tc.get("symbol-spacing"), Lu = Tc.get("text-padding") * Qe.tilePixelRatio, Zu = function(Qe, rt, Wn, Co) {
                            void 0 === Co && (Co = 1);
                            const Dl = Qe.get("icon-padding").evaluate(rt, {}, Wn), Ll = Dl && Dl.values;
                            return [
                                Ll[0] * Co,
                                Ll[1] * Co,
                                Ll[2] * Co,
                                Ll[3] * Co
                            ];
                        }(Tc, rt, Ql, Qe.tilePixelRatio), Xu = Tc.get("text-max-angle") / 180 * Math.PI, Ju = "viewport" !== Tc.get("text-rotation-alignment") && "point" !== Tc.get("symbol-placement"), $u = "map" === Tc.get("icon-rotation-alignment") && "point" !== Tc.get("symbol-placement"), ed = Tc.get("symbol-placement"), td = Tu / 2, id = Tc.get("icon-text-fit");
                        let nd;
                        Co && "none" !== id && (Qe.allowVerticalPlacement && Wn.vertical && (nd = Bu(Co, Wn.vertical, id, Tc.get("icon-text-fit-padding"), tu, du)), lu && (Co = Bu(Co, lu, id, Tc.get("icon-text-fit-padding"), tu, du)));
                        const rd = Ql ? Kl.line.getGranularityForZoomLevel(Ql.z) : 1, E = (Dl, Gl)=>{
                            Gl.x < 0 || Gl.x >= ql || Gl.y < 0 || Gl.y >= ql || function(Qe, rt, Wn, Co, Dl, Ll, Rl, Ul, Gl, Zl, Hl, ql, Ql, Kl, $l, Tc, tu, lu, du, fu, yu, Eu, Tu, Lu, Zu) {
                                const Xu = Qe.addToLineVertexArray(rt, Wn);
                                let Ju, $u, ed, td, id = 0, nd = 0, rd = 0, sd = 0, ad = -1, od = -1;
                                const ld = {};
                                let cd = wp("");
                                if (Qe.allowVerticalPlacement && Co.vertical) {
                                    const Qe = Ul.layout.get("text-rotate").evaluate(yu, {}, Lu) + 90;
                                    ed = new Ac(Gl, rt, Zl, Hl, ql, Co.vertical, Ql, Kl, $l, Qe), Rl && (td = new Ac(Gl, rt, Zl, Hl, ql, Rl, tu, lu, $l, Qe));
                                }
                                if (Dl) {
                                    const Wn = Ul.layout.get("icon-rotate").evaluate(yu, {}), Co = "none" !== Ul.layout.get("icon-text-fit"), Ll = bc(Dl, Wn, Tu, Co), Ql = Rl ? bc(Rl, Wn, Tu, Co) : void 0;
                                    $u = new Ac(Gl, rt, Zl, Hl, ql, Dl, tu, lu, !1, Wn), id = 4 * Ll.length;
                                    const Kl = Qe.iconSizeData;
                                    let $l = null;
                                    "source" === Kl.kind ? ($l = [
                                        Dm * Ul.layout.get("icon-size").evaluate(yu, {})
                                    ], $l[0] > Lm && w(`${Qe.layerIds[0]}: Value for "icon-size" is >= 255. Reduce your "icon-size".`)) : "composite" === Kl.kind && ($l = [
                                        Dm * Eu.compositeIconSizes[0].evaluate(yu, {}, Lu),
                                        Dm * Eu.compositeIconSizes[1].evaluate(yu, {}, Lu)
                                    ], ($l[0] > Lm || $l[1] > Lm) && w(`${Qe.layerIds[0]}: Value for "icon-size" is >= 255. Reduce your "icon-size".`)), Qe.addSymbols(Qe.icon, Ll, $l, fu, du, yu, Sm.none, rt, Xu.lineStartIndex, Xu.lineLength, -1, Lu), ad = Qe.icon.placedSymbolArray.length - 1, Ql && (nd = 4 * Ql.length, Qe.addSymbols(Qe.icon, Ql, $l, fu, du, yu, Sm.vertical, rt, Xu.lineStartIndex, Xu.lineLength, -1, Lu), od = Qe.icon.placedSymbolArray.length - 1);
                                }
                                const ud = Object.keys(Co.horizontal);
                                for (const Ed of ud){
                                    const Wn = Co.horizontal[Ed];
                                    if (!Ju) {
                                        cd = wp(Wn.text);
                                        const Qe = Ul.layout.get("text-rotate").evaluate(yu, {}, Lu);
                                        Ju = new Ac(Gl, rt, Zl, Hl, ql, Wn, Ql, Kl, $l, Qe);
                                    }
                                    const Dl = 1 === Wn.positionedLines.length;
                                    if (rd += $c(Qe, rt, Wn, Ll, Ul, $l, yu, Tc, Xu, Co.vertical ? Sm.horizontal : Sm.horizontalOnly, Dl ? ud : [
                                        Ed
                                    ], ld, ad, Eu, Lu), Dl) break;
                                }
                                Co.vertical && (sd += $c(Qe, rt, Co.vertical, Ll, Ul, $l, yu, Tc, Xu, Sm.vertical, [
                                    "vertical"
                                ], ld, od, Eu, Lu));
                                const hd = Ju ? Ju.boxStartIndex : Qe.collisionBoxArray.length, dd = Ju ? Ju.boxEndIndex : Qe.collisionBoxArray.length, pd = ed ? ed.boxStartIndex : Qe.collisionBoxArray.length, md = ed ? ed.boxEndIndex : Qe.collisionBoxArray.length, fd = $u ? $u.boxStartIndex : Qe.collisionBoxArray.length, gd = $u ? $u.boxEndIndex : Qe.collisionBoxArray.length, Ad = td ? td.boxStartIndex : Qe.collisionBoxArray.length, yd = td ? td.boxEndIndex : Qe.collisionBoxArray.length;
                                let vd = -1;
                                const Y = (Qe, rt)=>Qe && Qe.circleDiameter ? Math.max(Qe.circleDiameter, rt) : rt;
                                vd = Y(Ju, vd), vd = Y(ed, vd), vd = Y($u, vd), vd = Y(td, vd);
                                const _d = vd > -1 ? 1 : 0;
                                _d && (vd *= Zu / wm), Qe.glyphOffsetArray.length >= Uu.MAX_GLYPHS && w("Too many glyphs being rendered in a tile. See https://github.com/mapbox/mapbox-gl-js/issues/2907"), void 0 !== yu.sortKey && Qe.addToSortKeyRanges(Qe.symbolInstances.length, yu.sortKey);
                                const xd = Ec(Ul, yu, Lu), [bd, wd] = function(Qe, rt) {
                                    const Wn = Qe.length, Co = null == rt ? void 0 : rt.values;
                                    if ((null == Co ? void 0 : Co.length) > 0) for(let Dl = 0; Dl < Co.length; Dl += 2){
                                        const rt = Co[Dl + 1];
                                        Qe.emplaceBack(Vm[Co[Dl]], rt[0], rt[1]);
                                    }
                                    return [
                                        Wn,
                                        Qe.length
                                    ];
                                }(Qe.textAnchorOffsets, xd);
                                Qe.symbolInstances.emplaceBack(rt.x, rt.y, ld.right >= 0 ? ld.right : -1, ld.center >= 0 ? ld.center : -1, ld.left >= 0 ? ld.left : -1, ld.vertical || -1, ad, od, cd, hd, dd, pd, md, fd, gd, Ad, yd, Zl, rd, sd, id, nd, _d, 0, Ql, vd, bd, wd);
                            }(Qe, Gl, Dl, Wn, Co, Ll, nd, Qe.layers[0], Qe.collisionBoxArray, rt.index, rt.sourceLayerIndex, Qe.index, fu, [
                                Lu,
                                Lu,
                                Lu,
                                Lu
                            ], Ju, Zl, Eu, Zu, $u, tu, rt, Rl, Hl, Ql, Ul);
                        };
                        if ("line" === ed) for (const sd of function(Qe, rt, Wn, Co, Ll) {
                            const Rl = [];
                            for(let Ul = 0; Ul < Qe.length; Ul++){
                                const rt = Qe[Ul];
                                let Wn;
                                for(let Qe = 0; Qe < rt.length - 1; Qe++){
                                    let Ul = rt[Qe], Gl = rt[Qe + 1];
                                    Ul.x < 0 && Gl.x < 0 || (Ul.x < 0 ? Ul = new Dl(0, Ul.y + (0 - Ul.x) / (Gl.x - Ul.x) * (Gl.y - Ul.y))._round() : Gl.x < 0 && (Gl = new Dl(0, Ul.y + (0 - Ul.x) / (Gl.x - Ul.x) * (Gl.y - Ul.y))._round()), Ul.y < 0 && Gl.y < 0 || (Ul.y < 0 ? Ul = new Dl(Ul.x + (0 - Ul.y) / (Gl.y - Ul.y) * (Gl.x - Ul.x), 0)._round() : Gl.y < 0 && (Gl = new Dl(Ul.x + (0 - Ul.y) / (Gl.y - Ul.y) * (Gl.x - Ul.x), 0)._round()), Ul.x >= Co && Gl.x >= Co || (Ul.x >= Co ? Ul = new Dl(Co, Ul.y + (Co - Ul.x) / (Gl.x - Ul.x) * (Gl.y - Ul.y))._round() : Gl.x >= Co && (Gl = new Dl(Co, Ul.y + (Co - Ul.x) / (Gl.x - Ul.x) * (Gl.y - Ul.y))._round()), Ul.y >= Ll && Gl.y >= Ll || (Ul.y >= Ll ? Ul = new Dl(Ul.x + (Ll - Ul.y) / (Gl.y - Ul.y) * (Gl.x - Ul.x), Ll)._round() : Gl.y >= Ll && (Gl = new Dl(Ul.x + (Ll - Ul.y) / (Gl.y - Ul.y) * (Gl.x - Ul.x), Ll)._round()), Wn && Ul.equals(Wn[Wn.length - 1]) || (Wn = [
                                        Ul
                                    ], Rl.push(Wn)), Wn.push(Gl)))));
                                }
                            }
                            return Rl;
                        }(rt.geometry, 0, 0, ql, ql)){
                            const rt = Za(sd, rd), Dl = gc(rt, Tu, Xu, Wn.vertical || lu, Co, 24, yu, Qe.overscaling, ql);
                            for (const Wn of Dl)lu && Rc(Qe, lu.text, td, Wn) || E(rt, Wn);
                        }
                        else if ("line-center" === ed) {
                            for (const Dl of rt.geometry)if (Dl.length > 1) {
                                const Qe = Za(Dl, rd), rt = mc(Qe, Xu, Wn.vertical || lu, Co, 24, yu);
                                rt && E(Qe, rt);
                            }
                        } else if ("Polygon" === rt.type) for (const Dl of He(rt.geometry, 0)){
                            const Qe = Mc(Dl, 16);
                            E(Za(Dl[0], rd, !0), new hc(Qe.x, Qe.y, 0));
                        }
                        else if ("LineString" === rt.type) for (const Dl of rt.geometry){
                            const Qe = Za(Dl, rd);
                            E(Qe, new hc(Qe[0].x, Qe[0].y, 0));
                        }
                        else if ("Point" === rt.type) for (const Dl of rt.geometry)for (const Qe of Dl)E([
                            Qe
                        ], new hc(Qe.x, Qe.y, 0));
                    }
                    function $c(Qe, rt, Wn, Co, Ll, Rl, Ul, Gl, Zl, Hl, ql, Ql, Kl, $l, Tc) {
                        const tu = function(Qe, rt, Wn, Co, Ll, Rl, Ul, Gl) {
                            const Zl = Co.layout.get("text-rotate").evaluate(Rl, {}) * Math.PI / 180, Hl = [];
                            for (const ql of rt.positionedLines)for (const Qe of ql.positionedGlyphs){
                                if (!Qe.rect) continue;
                                const Co = Qe.rect || {};
                                let Rl = 4, Ql = !0, Kl = 1, $l = 0;
                                const Tc = (Ll || Gl) && Qe.vertical, tu = Qe.metrics.advance * Qe.scale / 2;
                                if (Gl && rt.verticalizable && ($l = ql.lineOffset / 2 - (Qe.imageName ? -(wm - Qe.metrics.width * Qe.scale) / 2 : (Qe.scale - 1) * wm)), Qe.imageName) {
                                    const rt = Ul[Qe.imageName];
                                    Ql = rt.sdf, Kl = rt.pixelRatio, Rl = 1 / Kl;
                                }
                                const lu = Ll ? [
                                    Qe.x + tu,
                                    Qe.y
                                ] : [
                                    0,
                                    0
                                ];
                                let du = Ll ? [
                                    0,
                                    0
                                ] : [
                                    Qe.x + tu + Wn[0],
                                    Qe.y + Wn[1] - $l
                                ], fu = [
                                    0,
                                    0
                                ];
                                Tc && (fu = du, du = [
                                    0,
                                    0
                                ]);
                                const yu = Qe.metrics.isDoubleResolution ? 2 : 1, Eu = (Qe.metrics.left - Rl) * Qe.scale - tu + du[0], Tu = (-Qe.metrics.top - Rl) * Qe.scale + du[1], Lu = Eu + Co.w / yu * Qe.scale / Kl, Zu = Tu + Co.h / yu * Qe.scale / Kl, Xu = new Dl(Eu, Tu), Ju = new Dl(Lu, Tu), $u = new Dl(Eu, Zu), ed = new Dl(Lu, Zu);
                                if (Tc) {
                                    const rt = new Dl(-tu, tu - Tm), Wn = -Math.PI / 2, Co = 12 - tu, Ll = new Dl(22 - Co, -(Qe.imageName ? Co : 0)), Rl = new Dl(...fu);
                                    Xu._rotateAround(Wn, rt)._add(Ll)._add(Rl), Ju._rotateAround(Wn, rt)._add(Ll)._add(Rl), $u._rotateAround(Wn, rt)._add(Ll)._add(Rl), ed._rotateAround(Wn, rt)._add(Ll)._add(Rl);
                                }
                                if (Zl) {
                                    const Qe = Math.sin(Zl), rt = Math.cos(Zl), Wn = [
                                        rt,
                                        -Qe,
                                        Qe,
                                        rt
                                    ];
                                    Xu._matMult(Wn), Ju._matMult(Wn), $u._matMult(Wn), ed._matMult(Wn);
                                }
                                const td = new Dl(0, 0), id = new Dl(0, 0);
                                Hl.push({
                                    tl: Xu,
                                    tr: Ju,
                                    bl: $u,
                                    br: ed,
                                    tex: Co,
                                    writingMode: rt.writingMode,
                                    glyphOffset: lu,
                                    sectionIndex: Qe.sectionIndex,
                                    isSDF: Ql,
                                    pixelOffsetTL: td,
                                    pixelOffsetBR: id,
                                    minFontScaleX: 0,
                                    minFontScaleY: 0
                                });
                            }
                            return Hl;
                        }(0, Wn, Gl, Ll, Rl, Ul, Co, Qe.allowVerticalPlacement), lu = Qe.textSizeData;
                        let du = null;
                        "source" === lu.kind ? (du = [
                            Dm * Ll.layout.get("text-size").evaluate(Ul, {})
                        ], du[0] > Lm && w(`${Qe.layerIds[0]}: Value for "text-size" is >= 255. Reduce your "text-size".`)) : "composite" === lu.kind && (du = [
                            Dm * $l.compositeTextSizes[0].evaluate(Ul, {}, Tc),
                            Dm * $l.compositeTextSizes[1].evaluate(Ul, {}, Tc)
                        ], (du[0] > Lm || du[1] > Lm) && w(`${Qe.layerIds[0]}: Value for "text-size" is >= 255. Reduce your "text-size".`)), Qe.addSymbols(Qe.text, tu, du, Gl, Rl, Ul, Hl, rt, Zl.lineStartIndex, Zl.lineLength, Kl, Tc);
                        for (const Dl of ql)Ql[Dl] = Qe.text.placedSymbolArray.length - 1;
                        return 4 * tu.length;
                    }
                    function Oc(Qe) {
                        for(const rt in Qe)return Qe[rt];
                        return null;
                    }
                    function Rc(Qe, rt, Wn, Co) {
                        const Dl = Qe.compareText;
                        if (rt in Dl) {
                            const Qe = Dl[rt];
                            for(let rt = Qe.length - 1; rt >= 0; rt--)if (Co.dist(Qe[rt]) < Wn) return !0;
                        } else Dl[rt] = [];
                        return Dl[rt].push(Co), !1;
                    }
                    class Nc {
                        constructor(Qe){
                            const rt = {}, Wn = [];
                            for(const Rl in Qe){
                                const Co = Qe[Rl], Dl = rt[Rl] = {};
                                for(const Qe in Co){
                                    const rt = Co[+Qe];
                                    if (!rt || 0 === rt.bitmap.width || 0 === rt.bitmap.height) continue;
                                    const Ll = {
                                        x: 0,
                                        y: 0,
                                        w: rt.bitmap.width + 2,
                                        h: rt.bitmap.height + 2
                                    };
                                    Wn.push(Ll), Dl[Qe] = {
                                        rect: Ll,
                                        metrics: rt.metrics
                                    };
                                }
                            }
                            const { w: Co, h: Dl } = iu(Wn), Ll = new ia({
                                width: Co || 1,
                                height: Dl || 1
                            });
                            for(const Rl in Qe){
                                const Wn = Qe[Rl];
                                for(const Qe in Wn){
                                    const Co = Wn[+Qe];
                                    if (!Co || 0 === Co.bitmap.width || 0 === Co.bitmap.height) continue;
                                    const Dl = rt[Rl][Qe].rect;
                                    ia.copy(Co.bitmap, Ll, {
                                        x: 0,
                                        y: 0
                                    }, {
                                        x: Dl.x + 1,
                                        y: Dl.y + 1
                                    }, Co.bitmap);
                                }
                            }
                            this.image = Ll, this.positions = rt;
                        }
                    }
                    function jc(Qe, rt, Wn) {
                        var Co = 2 * Math.PI * 6378137 / 256 / Math.pow(2, Wn);
                        return [
                            Qe * Co - 2 * Math.PI * 6378137 / 2,
                            rt * Co - 2 * Math.PI * 6378137 / 2
                        ];
                    }
                    Qn("GlyphAtlas", Nc);
                    const Zm = 6371008.8;
                    class Uc {
                        constructor(Qe, rt){
                            if (isNaN(Qe) || isNaN(rt)) throw new Error(`Invalid LngLat object: (${Qe}, ${rt})`);
                            if (this.lng = +Qe, this.lat = +rt, this.lat > 90 || this.lat < -90) throw new Error("Invalid LngLat latitude value: must be between -90 and 90");
                        }
                        wrap() {
                            return new Uc(function(Qe, rt) {
                                const Wn = ((Qe - rt) % 360 + 360) % 360 + rt;
                                return Wn === rt ? 180 : Wn;
                            }(this.lng, -180), this.lat);
                        }
                        toArray() {
                            return [
                                this.lng,
                                this.lat
                            ];
                        }
                        toString() {
                            return `LngLat(${this.lng}, ${this.lat})`;
                        }
                        distanceTo(Qe) {
                            const rt = Math.PI / 180, Wn = this.lat * rt, Co = Qe.lat * rt, Dl = Math.sin(Wn) * Math.sin(Co) + Math.cos(Wn) * Math.cos(Co) * Math.cos((Qe.lng - this.lng) * rt);
                            return Zm * Math.acos(Math.min(Dl, 1));
                        }
                        static convert(Qe) {
                            if (Qe instanceof Uc) return Qe;
                            if (Array.isArray(Qe) && (2 === Qe.length || 3 === Qe.length)) return new Uc(Number(Qe[0]), Number(Qe[1]));
                            if (!Array.isArray(Qe) && "object" == typeof Qe && null !== Qe) return new Uc(Number("lng" in Qe ? Qe.lng : Qe.lon), Number(Qe.lat));
                            throw new Error("`LngLatLike` argument must be specified as a LngLat instance, an object {lng: <lng>, lat: <lat>}, an object {lon: <lng>, lat: <lat>}, or an array of [<lng>, <lat>]");
                        }
                    }
                    const Hm = 2 * Math.PI * Zm;
                    function Zc(Qe) {
                        return Hm * Math.cos(Qe * Math.PI / 180);
                    }
                    function Xc(Qe) {
                        return 360 / Math.PI * Math.atan(Math.exp((180 - 360 * Qe) * Math.PI / 180)) - 90;
                    }
                    class Hc {
                        constructor(Qe, rt, Wn){
                            void 0 === Wn && (Wn = 0), this.x = +Qe, this.y = +rt, this.z = +Wn;
                        }
                        static fromLngLat(Qe, rt) {
                            void 0 === rt && (rt = 0);
                            const Wn = Uc.convert(Qe);
                            return new Hc((180 + Wn.lng) / 360, (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + Wn.lat * Math.PI / 360))) / 360, function(Qe, rt) {
                                return Qe / Zc(rt);
                            }(rt, Wn.lat));
                        }
                        toLngLat() {
                            return new Uc(360 * this.x - 180, Xc(this.y));
                        }
                        toAltitude() {
                            return this.z * Zc(Xc(this.y));
                        }
                        meterInMercatorCoordinateUnits() {
                            var Qe;
                            return 1 / Hm * (Qe = Xc(this.y), 1 / Math.cos(Qe * Math.PI / 180));
                        }
                    }
                    class Yc {
                        constructor(Qe, rt, Wn){
                            if (!function(Qe, rt, Wn) {
                                return !(Qe < 0 || Qe > 25 || Wn < 0 || Wn >= Math.pow(2, Qe) || rt < 0 || rt >= Math.pow(2, Qe));
                            }(Qe, rt, Wn)) throw new Error(`x=${rt}, y=${Wn}, z=${Qe} outside of bounds. 0<=x<${Math.pow(2, Qe)}, 0<=y<${Math.pow(2, Qe)} 0<=z<=25 `);
                            this.z = Qe, this.x = rt, this.y = Wn, this.key = Wc(0, Qe, Qe, rt, Wn);
                        }
                        equals(Qe) {
                            return this.z === Qe.z && this.x === Qe.x && this.y === Qe.y;
                        }
                        url(Qe, rt, Wn) {
                            const Co = (Ll = this.y, Rl = this.z, Ul = jc(256 * (Dl = this.x), 256 * (Ll = Math.pow(2, Rl) - Ll - 1), Rl), Gl = jc(256 * (Dl + 1), 256 * (Ll + 1), Rl), Ul[0] + "," + Ul[1] + "," + Gl[0] + "," + Gl[1]);
                            var Dl, Ll, Rl, Ul, Gl;
                            const Zl = function(Qe, rt, Wn) {
                                let Co, Dl = "";
                                for(let Ll = Qe; Ll > 0; Ll--)Co = 1 << Ll - 1, Dl += (rt & Co ? 1 : 0) + (Wn & Co ? 2 : 0);
                                return Dl;
                            }(this.z, this.x, this.y);
                            return Qe[(this.x + this.y) % Qe.length].replace(/{prefix}/g, (this.x % 16).toString(16) + (this.y % 16).toString(16)).replace(/{z}/g, String(this.z)).replace(/{x}/g, String(this.x)).replace(/{y}/g, String("tms" === Wn ? Math.pow(2, this.z) - this.y - 1 : this.y)).replace(/{ratio}/g, rt > 1 ? "@2x" : "").replace(/{quadkey}/g, Zl).replace(/{bbox-epsg-3857}/g, Co);
                        }
                        isChildOf(Qe) {
                            const rt = this.z - Qe.z;
                            return rt > 0 && Qe.x === this.x >> rt && Qe.y === this.y >> rt;
                        }
                        getTilePoint(Qe) {
                            const rt = Math.pow(2, this.z);
                            return new Dl((Qe.x * rt - this.x) * ql, (Qe.y * rt - this.y) * ql);
                        }
                        toString() {
                            return `${this.z}/${this.x}/${this.y}`;
                        }
                    }
                    class Jc {
                        constructor(Qe, rt){
                            this.wrap = Qe, this.canonical = rt, this.key = Wc(Qe, rt.z, rt.z, rt.x, rt.y);
                        }
                    }
                    class Kc {
                        constructor(Qe, rt, Wn, Co, Dl){
                            if (this.terrainRttPosMatrix32f = null, Qe < Wn) throw new Error(`overscaledZ should be >= z; overscaledZ = ${Qe}; z = ${Wn}`);
                            this.overscaledZ = Qe, this.wrap = rt, this.canonical = new Yc(Wn, +Co, +Dl), this.key = Wc(rt, Qe, Wn, Co, Dl);
                        }
                        clone() {
                            return new Kc(this.overscaledZ, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y);
                        }
                        equals(Qe) {
                            return this.overscaledZ === Qe.overscaledZ && this.wrap === Qe.wrap && this.canonical.equals(Qe.canonical);
                        }
                        scaledTo(Qe) {
                            if (Qe > this.overscaledZ) throw new Error(`targetZ > this.overscaledZ; targetZ = ${Qe}; overscaledZ = ${this.overscaledZ}`);
                            const rt = this.canonical.z - Qe;
                            return Qe > this.canonical.z ? new Kc(Qe, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y) : new Kc(Qe, this.wrap, Qe, this.canonical.x >> rt, this.canonical.y >> rt);
                        }
                        calculateScaledKey(Qe, rt) {
                            if (Qe > this.overscaledZ) throw new Error(`targetZ > this.overscaledZ; targetZ = ${Qe}; overscaledZ = ${this.overscaledZ}`);
                            const Wn = this.canonical.z - Qe;
                            return Qe > this.canonical.z ? Wc(this.wrap * +rt, Qe, this.canonical.z, this.canonical.x, this.canonical.y) : Wc(this.wrap * +rt, Qe, Qe, this.canonical.x >> Wn, this.canonical.y >> Wn);
                        }
                        isChildOf(Qe) {
                            if (Qe.wrap !== this.wrap) return !1;
                            const rt = this.canonical.z - Qe.canonical.z;
                            return 0 === Qe.overscaledZ || Qe.overscaledZ < this.overscaledZ && Qe.canonical.x === this.canonical.x >> rt && Qe.canonical.y === this.canonical.y >> rt;
                        }
                        children(Qe) {
                            if (this.overscaledZ >= Qe) return [
                                new Kc(this.overscaledZ + 1, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y)
                            ];
                            const rt = this.canonical.z + 1, Wn = 2 * this.canonical.x, Co = 2 * this.canonical.y;
                            return [
                                new Kc(rt, this.wrap, rt, Wn, Co),
                                new Kc(rt, this.wrap, rt, Wn + 1, Co),
                                new Kc(rt, this.wrap, rt, Wn, Co + 1),
                                new Kc(rt, this.wrap, rt, Wn + 1, Co + 1)
                            ];
                        }
                        isLessThan(Qe) {
                            return this.wrap < Qe.wrap || !(this.wrap > Qe.wrap) && (this.overscaledZ < Qe.overscaledZ || !(this.overscaledZ > Qe.overscaledZ) && (this.canonical.x < Qe.canonical.x || !(this.canonical.x > Qe.canonical.x) && this.canonical.y < Qe.canonical.y));
                        }
                        wrapped() {
                            return new Kc(this.overscaledZ, 0, this.canonical.z, this.canonical.x, this.canonical.y);
                        }
                        unwrapTo(Qe) {
                            return new Kc(this.overscaledZ, Qe, this.canonical.z, this.canonical.x, this.canonical.y);
                        }
                        overscaleFactor() {
                            return Math.pow(2, this.overscaledZ - this.canonical.z);
                        }
                        toUnwrapped() {
                            return new Jc(this.wrap, this.canonical);
                        }
                        toString() {
                            return `${this.overscaledZ}/${this.canonical.x}/${this.canonical.y}`;
                        }
                        getTilePoint(Qe) {
                            return this.canonical.getTilePoint(new Hc(Qe.x - this.wrap, Qe.y));
                        }
                    }
                    function Wc(Qe, rt, Wn, Co, Dl) {
                        (Qe *= 2) < 0 && (Qe = -1 * Qe - 1);
                        const Ll = 1 << Wn;
                        return (Ll * Ll * Qe + Ll * Dl + Co).toString(36) + Wn.toString(36) + rt.toString(36);
                    }
                    Qn("CanonicalTileID", Yc), Qn("OverscaledTileID", Kc, {
                        omit: [
                            "terrainRttPosMatrix32f"
                        ]
                    });
                    class Qc {
                        constructor(Qe){
                            this.tileID = new Kc(Qe.tileID.overscaledZ, Qe.tileID.wrap, Qe.tileID.canonical.z, Qe.tileID.canonical.x, Qe.tileID.canonical.y), this.uid = Qe.uid, this.zoom = Qe.zoom, this.pixelRatio = Qe.pixelRatio, this.tileSize = Qe.tileSize, this.source = Qe.source, this.overscaling = this.tileID.overscaleFactor(), this.showCollisionBoxes = Qe.showCollisionBoxes, this.collectResourceTiming = !!Qe.collectResourceTiming, this.returnDependencies = !!Qe.returnDependencies, this.promoteId = Qe.promoteId, this.inFlightDependencies = [];
                        }
                        parse(Qe, rt, Wn, Co, Dl) {
                            return t(this, void 0, void 0, function*() {
                                this.status = "parsing", this.data = Qe, this.collisionBoxArray = new Ss;
                                const Ll = new sc(Object.keys(Qe.layers).sort()), Rl = new ac(this.tileID, this.promoteId);
                                Rl.bucketLayerIDs = [];
                                const Ul = {}, Gl = {
                                    featureIndex: Rl,
                                    iconDependencies: {},
                                    patternDependencies: {},
                                    glyphDependencies: {},
                                    availableImages: Wn,
                                    subdivisionGranularity: Dl
                                }, Zl = rt.familiesBySource[this.source];
                                for(const rt in Zl){
                                    const Co = Qe.layers[rt];
                                    if (!Co) continue;
                                    1 === Co.version && w(`Vector tile source "${this.source}" layer "${rt}" does not use vector tile spec v2 and therefore may have some rendering errors.`);
                                    const Dl = Ll.encode(rt), Hl = [];
                                    for(let Qe = 0; Qe < Co.length; Qe++){
                                        const Wn = Co.feature(Qe), Ll = Rl.getId(Wn, rt);
                                        Hl.push({
                                            feature: Wn,
                                            id: Ll,
                                            index: Qe,
                                            sourceLayerIndex: Dl
                                        });
                                    }
                                    for (const Qe of Zl[rt]){
                                        const rt = Qe[0];
                                        rt.source !== this.source && w(`layer.source = ${rt.source} does not equal this.source = ${this.source}`), rt.minzoom && this.zoom < Math.floor(rt.minzoom) || rt.maxzoom && this.zoom >= rt.maxzoom || "none" !== rt.visibility && (th(Qe, this.zoom, Wn), (Ul[rt.id] = rt.createBucket({
                                            index: Rl.bucketLayerIDs.length,
                                            layers: Qe,
                                            zoom: this.zoom,
                                            pixelRatio: this.pixelRatio,
                                            overscaling: this.overscaling,
                                            collisionBoxArray: this.collisionBoxArray,
                                            sourceLayerIndex: Dl,
                                            sourceID: this.source
                                        })).populate(Hl, Gl, this.tileID.canonical), Rl.bucketLayerIDs.push(Qe.map((Qe)=>Qe.id)));
                                    }
                                }
                                const Hl = x(Gl.glyphDependencies, (Qe)=>Object.keys(Qe).map(Number));
                                this.inFlightDependencies.forEach((Qe)=>null == Qe ? void 0 : Qe.abort()), this.inFlightDependencies = [];
                                let ql = Promise.resolve({});
                                if (Object.keys(Hl).length) {
                                    const Qe = new AbortController;
                                    this.inFlightDependencies.push(Qe), ql = Co.sendAsync({
                                        type: "GG",
                                        data: {
                                            stacks: Hl,
                                            source: this.source,
                                            tileID: this.tileID,
                                            type: "glyphs"
                                        }
                                    }, Qe);
                                }
                                const Ql = Object.keys(Gl.iconDependencies);
                                let Kl = Promise.resolve({});
                                if (Ql.length) {
                                    const Qe = new AbortController;
                                    this.inFlightDependencies.push(Qe), Kl = Co.sendAsync({
                                        type: "GI",
                                        data: {
                                            icons: Ql,
                                            source: this.source,
                                            tileID: this.tileID,
                                            type: "icons"
                                        }
                                    }, Qe);
                                }
                                const $l = Object.keys(Gl.patternDependencies);
                                let Tc = Promise.resolve({});
                                if ($l.length) {
                                    const Qe = new AbortController;
                                    this.inFlightDependencies.push(Qe), Tc = Co.sendAsync({
                                        type: "GI",
                                        data: {
                                            icons: $l,
                                            source: this.source,
                                            tileID: this.tileID,
                                            type: "patterns"
                                        }
                                    }, Qe);
                                }
                                const [tu, lu, du] = yield Promise.all([
                                    ql,
                                    Kl,
                                    Tc
                                ]), fu = new Nc(tu), yu = new au(lu, du);
                                for(const Qe in Ul){
                                    const rt = Ul[Qe];
                                    rt instanceof Uu ? (th(rt.layers, this.zoom, Wn), Fc({
                                        bucket: rt,
                                        glyphMap: tu,
                                        glyphPositions: fu.positions,
                                        imageMap: lu,
                                        imagePositions: yu.iconPositions,
                                        showCollisionBoxes: this.showCollisionBoxes,
                                        canonical: this.tileID.canonical,
                                        subdivisionGranularity: Gl.subdivisionGranularity
                                    })) : rt.hasPattern && (rt instanceof Fl || rt instanceof Ja || rt instanceof vl) && (th(rt.layers, this.zoom, Wn), rt.addFeatures(Gl, this.tileID.canonical, yu.patternPositions));
                                }
                                return this.status = "done", {
                                    buckets: Object.values(Ul).filter((Qe)=>!Qe.isEmpty()),
                                    featureIndex: Rl,
                                    collisionBoxArray: this.collisionBoxArray,
                                    glyphAtlasImage: fu.image,
                                    imageAtlas: yu,
                                    glyphMap: this.returnDependencies ? tu : null,
                                    iconMap: this.returnDependencies ? lu : null,
                                    glyphPositions: this.returnDependencies ? fu.positions : null
                                };
                            });
                        }
                    }
                    function th(Qe, rt, Wn) {
                        const Co = new Bi(rt);
                        for (const Dl of Qe)Dl.recalculate(Co, Wn);
                    }
                    var Wm, qm, Ym;
                    !function(Qe) {
                        Qe.create = "create", Qe.load = "load", Qe.fullLoad = "fullLoad";
                    }(Wm || (Wm = {}));
                    class ih {
                        constructor(Qe){
                            this._marks = {
                                start: [
                                    Qe.url,
                                    "start"
                                ].join("#"),
                                end: [
                                    Qe.url,
                                    "end"
                                ].join("#"),
                                measure: Qe.url.toString()
                            }, performance.mark(this._marks.start);
                        }
                        finish() {
                            performance.mark(this._marks.end);
                            let Qe = performance.getEntriesByName(this._marks.measure);
                            return 0 === Qe.length && (performance.measure(this._marks.measure, this._marks.start, this._marks.end), Qe = performance.getEntriesByName(this._marks.measure), performance.clearMarks(this._marks.start), performance.clearMarks(this._marks.end), performance.clearMeasures(this._marks.measure)), Qe;
                        }
                    }
                    class sh {
                        constructor(Qe, rt, Wn){
                            this.actor = Qe, this.layerIndex = rt, this.availableImages = Wn, this.fetching = {}, this.loading = {}, this.loaded = {};
                        }
                        loadVectorTile(Qe, rt) {
                            return t(this, void 0, void 0, function*() {
                                const Wn = yield ((Qe, rt)=>Kn(g(Qe, {
                                        type: "arrayBuffer"
                                    }), rt))(Qe.request, rt);
                                try {
                                    return {
                                        vectorTile: new $p.VectorTile(new Mm(Wn.data)),
                                        rawData: Wn.data,
                                        cacheControl: Wn.cacheControl,
                                        expires: Wn.expires
                                    };
                                } catch (rt) {
                                    const Dl = new Uint8Array(Wn.data);
                                    let Ll = `Unable to parse the tile at ${Qe.request.url}, `;
                                    throw Ll += 31 === Dl[0] && 139 === Dl[1] ? "please make sure the data is not gzipped and that you have configured the relevant header in the server" : `got error: ${rt.message}`, new Error(Ll);
                                }
                            });
                        }
                        loadTile(Qe) {
                            return t(this, void 0, void 0, function*() {
                                const rt = Qe.uid, Wn = !!(Qe && Qe.request && Qe.request.collectResourceTiming) && new ih(Qe.request), Co = new Qc(Qe);
                                this.loading[rt] = Co;
                                const Dl = new AbortController;
                                Co.abort = Dl;
                                try {
                                    const Ll = yield this.loadVectorTile(Qe, Dl);
                                    if (delete this.loading[rt], !Ll) return null;
                                    const Rl = Ll.rawData, Ul = {};
                                    Ll.expires && (Ul.expires = Ll.expires), Ll.cacheControl && (Ul.cacheControl = Ll.cacheControl);
                                    const Gl = {};
                                    if (Wn) {
                                        const Qe = Wn.finish();
                                        Qe && (Gl.resourceTiming = JSON.parse(JSON.stringify(Qe)));
                                    }
                                    Co.vectorTile = Ll.vectorTile;
                                    const Zl = Co.parse(Ll.vectorTile, this.layerIndex, this.availableImages, this.actor, Qe.subdivisionGranularity);
                                    this.loaded[rt] = Co, this.fetching[rt] = {
                                        rawTileData: Rl,
                                        cacheControl: Ul,
                                        resourceTiming: Gl
                                    };
                                    try {
                                        const Qe = yield Zl;
                                        return g({
                                            rawTileData: Rl.slice(0)
                                        }, Qe, Ul, Gl);
                                    } finally{
                                        delete this.fetching[rt];
                                    }
                                } catch (Qe) {
                                    throw delete this.loading[rt], Co.status = "done", this.loaded[rt] = Co, Qe;
                                }
                            });
                        }
                        reloadTile(Qe) {
                            return t(this, void 0, void 0, function*() {
                                const rt = Qe.uid;
                                if (!this.loaded || !this.loaded[rt]) throw new Error("Should not be trying to reload a tile that was never loaded or has been removed");
                                const Wn = this.loaded[rt];
                                if (Wn.showCollisionBoxes = Qe.showCollisionBoxes, "parsing" === Wn.status) {
                                    const Co = yield Wn.parse(Wn.vectorTile, this.layerIndex, this.availableImages, this.actor, Qe.subdivisionGranularity);
                                    let Dl;
                                    if (this.fetching[rt]) {
                                        const { rawTileData: Qe, cacheControl: Wn, resourceTiming: Ll } = this.fetching[rt];
                                        delete this.fetching[rt], Dl = g({
                                            rawTileData: Qe.slice(0)
                                        }, Co, Wn, Ll);
                                    } else Dl = Co;
                                    return Dl;
                                }
                                if ("done" === Wn.status && Wn.vectorTile) return Wn.parse(Wn.vectorTile, this.layerIndex, this.availableImages, this.actor, Qe.subdivisionGranularity);
                            });
                        }
                        abortTile(Qe) {
                            return t(this, void 0, void 0, function*() {
                                const rt = this.loading, Wn = Qe.uid;
                                rt && rt[Wn] && rt[Wn].abort && (rt[Wn].abort.abort(), delete rt[Wn]);
                            });
                        }
                        removeTile(Qe) {
                            return t(this, void 0, void 0, function*() {
                                this.loaded && this.loaded[Qe.uid] && delete this.loaded[Qe.uid];
                            });
                        }
                    }
                    class oh {
                        constructor(Qe, rt, Wn, Co, Dl, Ll, Rl){
                            if (void 0 === Co && (Co = 1), void 0 === Dl && (Dl = 1), void 0 === Ll && (Ll = 1), void 0 === Rl && (Rl = 0), this.uid = Qe, rt.height !== rt.width) throw new RangeError("DEM tiles must be square");
                            if (Wn && ![
                                "mapbox",
                                "terrarium",
                                "custom"
                            ].includes(Wn)) return void w(`"${Wn}" is not a valid encoding type. Valid types include "mapbox", "terrarium" and "custom".`);
                            this.stride = rt.height;
                            const Ul = this.dim = rt.height - 2;
                            switch(this.data = new Uint32Array(rt.data.buffer), Wn){
                                case "terrarium":
                                    this.redFactor = 256, this.greenFactor = 1, this.blueFactor = 1 / 256, this.baseShift = 32768;
                                    break;
                                case "custom":
                                    this.redFactor = Co, this.greenFactor = Dl, this.blueFactor = Ll, this.baseShift = Rl;
                                    break;
                                default:
                                    this.redFactor = 6553.6, this.greenFactor = 25.6, this.blueFactor = .1, this.baseShift = 1e4;
                            }
                            for(let Gl = 0; Gl < Ul; Gl++)this.data[this._idx(-1, Gl)] = this.data[this._idx(0, Gl)], this.data[this._idx(Ul, Gl)] = this.data[this._idx(Ul - 1, Gl)], this.data[this._idx(Gl, -1)] = this.data[this._idx(Gl, 0)], this.data[this._idx(Gl, Ul)] = this.data[this._idx(Gl, Ul - 1)];
                            this.data[this._idx(-1, -1)] = this.data[this._idx(0, 0)], this.data[this._idx(Ul, -1)] = this.data[this._idx(Ul - 1, 0)], this.data[this._idx(-1, Ul)] = this.data[this._idx(0, Ul - 1)], this.data[this._idx(Ul, Ul)] = this.data[this._idx(Ul - 1, Ul - 1)], this.min = Number.MAX_SAFE_INTEGER, this.max = Number.MIN_SAFE_INTEGER;
                            for(let Gl = 0; Gl < Ul; Gl++)for(let Qe = 0; Qe < Ul; Qe++){
                                const rt = this.get(Gl, Qe);
                                rt > this.max && (this.max = rt), rt < this.min && (this.min = rt);
                            }
                        }
                        get(Qe, rt) {
                            const Wn = new Uint8Array(this.data.buffer), Co = 4 * this._idx(Qe, rt);
                            return this.unpack(Wn[Co], Wn[Co + 1], Wn[Co + 2]);
                        }
                        getUnpackVector() {
                            return [
                                this.redFactor,
                                this.greenFactor,
                                this.blueFactor,
                                this.baseShift
                            ];
                        }
                        _idx(Qe, rt) {
                            if (Qe < -1 || Qe >= this.dim + 1 || rt < -1 || rt >= this.dim + 1) throw new RangeError("out of range source coordinates for DEM data");
                            return (rt + 1) * this.stride + (Qe + 1);
                        }
                        unpack(Qe, rt, Wn) {
                            return Qe * this.redFactor + rt * this.greenFactor + Wn * this.blueFactor - this.baseShift;
                        }
                        getPixels() {
                            return new sa({
                                width: this.stride,
                                height: this.stride
                            }, new Uint8Array(this.data.buffer));
                        }
                        backfillBorder(Qe, rt, Wn) {
                            if (this.dim !== Qe.dim) throw new Error("dem dimension mismatch");
                            let Co = rt * this.dim, Dl = rt * this.dim + this.dim, Ll = Wn * this.dim, Rl = Wn * this.dim + this.dim;
                            switch(rt){
                                case -1:
                                    Co = Dl - 1;
                                    break;
                                case 1:
                                    Dl = Co + 1;
                            }
                            switch(Wn){
                                case -1:
                                    Ll = Rl - 1;
                                    break;
                                case 1:
                                    Rl = Ll + 1;
                            }
                            const Ul = -rt * this.dim, Gl = -Wn * this.dim;
                            for(let Zl = Ll; Zl < Rl; Zl++)for(let rt = Co; rt < Dl; rt++)this.data[this._idx(rt, Zl)] = Qe.data[this._idx(rt + Ul, Zl + Gl)];
                        }
                    }
                    Qn("DEMData", oh);
                    class ah {
                        constructor(){
                            this.loaded = {};
                        }
                        loadTile(Qe) {
                            return t(this, void 0, void 0, function*() {
                                const { uid: rt, encoding: Wn, rawImageData: Co, redFactor: Dl, greenFactor: Ll, blueFactor: Rl, baseShift: Zl } = Qe, Hl = Co.width + 2, ql = Co.height + 2, Ql = k(Co) ? new sa({
                                    width: Hl,
                                    height: ql
                                }, (yield function(Qe, rt, Wn, Co, Dl) {
                                    return t(this, void 0, void 0, function*() {
                                        if (function() {
                                            if (null == Gl && (Gl = !1, null == Ul && (Ul = "undefined" != typeof OffscreenCanvas && new OffscreenCanvas(1, 1).getContext("2d") && "function" == typeof createImageBitmap), Ul)) {
                                                const Qe = 5, rt = new OffscreenCanvas(Qe, Qe).getContext("2d", {
                                                    willReadFrequently: !0
                                                });
                                                if (rt) {
                                                    for(let Co = 0; Co < Qe * Qe; Co++){
                                                        const Wn = 4 * Co;
                                                        rt.fillStyle = `rgb(${Wn},${Wn + 1},${Wn + 2})`, rt.fillRect(Co % Qe, Math.floor(Co / Qe), 1, 1);
                                                    }
                                                    const Wn = rt.getImageData(0, 0, Qe, Qe).data;
                                                    for(let rt = 0; rt < Qe * Qe * 4; rt++)if (rt % 4 != 3 && Wn[rt] !== rt) {
                                                        Gl = !0;
                                                        break;
                                                    }
                                                }
                                            }
                                            return Gl || !1;
                                        }()) try {
                                            return yield function(Qe, rt, Wn, Co, Dl) {
                                                return t(this, void 0, void 0, function*() {
                                                    if ("undefined" == typeof VideoFrame) throw new Error("VideoFrame not supported");
                                                    const rt = new VideoFrame(Qe, {
                                                        timestamp: 0
                                                    });
                                                    try {
                                                        const Wn = null == rt ? void 0 : rt.format;
                                                        if (!Wn || !Wn.startsWith("BGR") && !Wn.startsWith("RGB")) throw new Error(`Unrecognized format ${Wn}`);
                                                        const Ll = Wn.startsWith("BGR"), Rl = new Uint8ClampedArray(Co * Dl * 4);
                                                        if (yield rt.copyTo(Rl, function(Qe, rt, Wn, Co, Dl) {
                                                            const Ll = 4 * Math.max(1, 0), Rl = (Math.max(0, -1) - -1) * Co * 4 + Ll, Ul = 4 * Co, Gl = Math.max(0, -1), Zl = Math.max(0, -1);
                                                            return {
                                                                rect: {
                                                                    x: Gl,
                                                                    y: Zl,
                                                                    width: Math.min(Qe.width, -1 + Co) - Gl,
                                                                    height: Math.min(Qe.height, -1 + Dl) - Zl
                                                                },
                                                                layout: [
                                                                    {
                                                                        offset: Rl,
                                                                        stride: Ul
                                                                    }
                                                                ]
                                                            };
                                                        }(Qe, 0, 0, Co, Dl)), Ll) for(let Qe = 0; Qe < Rl.length; Qe += 4){
                                                            const rt = Rl[Qe];
                                                            Rl[Qe] = Rl[Qe + 2], Rl[Qe + 2] = rt;
                                                        }
                                                        return Rl;
                                                    } finally{
                                                        rt.close();
                                                    }
                                                });
                                            }(Qe, 0, 0, Co, Dl);
                                        } catch (t) {}
                                        return function(Qe, rt, Wn, Co, Dl) {
                                            const Ll = Qe.width, Rl = Qe.height;
                                            Kl && $l || (Kl = new OffscreenCanvas(Ll, Rl), $l = Kl.getContext("2d", {
                                                willReadFrequently: !0
                                            })), Kl.width = Ll, Kl.height = Rl, $l.drawImage(Qe, 0, 0, Ll, Rl);
                                            const Ul = $l.getImageData(-1, -1, Co, Dl);
                                            return $l.clearRect(0, 0, Ll, Rl), Ul.data;
                                        }(Qe, 0, 0, Co, Dl);
                                    });
                                }(Co, 0, 0, Hl, ql))) : Co, Tc = new oh(rt, Ql, Wn, Dl, Ll, Rl, Zl);
                                return this.loaded = this.loaded || {}, this.loaded[rt] = Tc, Tc;
                            });
                        }
                        removeTile(Qe) {
                            const rt = this.loaded, Wn = Qe.uid;
                            rt && rt[Wn] && delete rt[Wn];
                        }
                    }
                    var Qm = function() {
                        if (Ym) return qm;
                        function t(Qe, rt) {
                            if (0 !== Qe.length) {
                                e(Qe[0], rt);
                                for(var Wn = 1; Wn < Qe.length; Wn++)e(Qe[Wn], !rt);
                            }
                        }
                        function e(Qe, rt) {
                            for(var Wn = 0, Co = 0, Dl = 0, Ll = Qe.length, Rl = Ll - 1; Dl < Ll; Rl = Dl++){
                                var Ul = (Qe[Dl][0] - Qe[Rl][0]) * (Qe[Rl][1] + Qe[Dl][1]), Gl = Wn + Ul;
                                Co += Math.abs(Wn) >= Math.abs(Ul) ? Wn - Gl + Ul : Ul - Gl + Wn, Wn = Gl;
                            }
                            Wn + Co >= 0 != !!rt && Qe.reverse();
                        }
                        return Ym = 1, qm = function e(Qe, rt) {
                            var Wn, Co = Qe && Qe.type;
                            if ("FeatureCollection" === Co) for(Wn = 0; Wn < Qe.features.length; Wn++)e(Qe.features[Wn], rt);
                            else if ("GeometryCollection" === Co) for(Wn = 0; Wn < Qe.geometries.length; Wn++)e(Qe.geometries[Wn], rt);
                            else if ("Feature" === Co) e(Qe.geometry, rt);
                            else if ("Polygon" === Co) t(Qe.coordinates, rt);
                            else if ("MultiPolygon" === Co) for(Wn = 0; Wn < Qe.coordinates.length; Wn++)t(Qe.coordinates[Wn], rt);
                            return Qe;
                        };
                    }(), Km = e(Qm);
                    const Xm = $p.VectorTileFeature.prototype.toGeoJSON;
                    class hh {
                        constructor(Qe){
                            this._feature = Qe, this.extent = ql, this.type = Qe.type, this.properties = Qe.tags, "id" in Qe && !isNaN(Qe.id) && (this.id = parseInt(Qe.id, 10));
                        }
                        loadGeometry() {
                            if (1 === this._feature.type) {
                                const Qe = [];
                                for (const rt of this._feature.geometry)Qe.push([
                                    new Dl(rt[0], rt[1])
                                ]);
                                return Qe;
                            }
                            {
                                const Qe = [];
                                for (const rt of this._feature.geometry){
                                    const Wn = [];
                                    for (const Qe of rt)Wn.push(new Dl(Qe[0], Qe[1]));
                                    Qe.push(Wn);
                                }
                                return Qe;
                            }
                        }
                        toGeoJSON(Qe, rt, Wn) {
                            return Xm.call(this, Qe, rt, Wn);
                        }
                    }
                    class ph {
                        constructor(Qe){
                            this.layers = {
                                _geojsonTileLayer: this
                            }, this.name = "_geojsonTileLayer", this.extent = ql, this.length = Qe.length, this._features = Qe;
                        }
                        feature(Qe) {
                            return new hh(this._features[Qe]);
                        }
                    }
                    var Jm, $m, ef, tf = {
                        exports: {}
                    }, nf = function() {
                        if (ef) return tf.exports;
                        ef = 1;
                        var Qe = eu(), rt = function() {
                            if ($m) return Jm;
                            $m = 1;
                            var Qe = i(), rt = dl().VectorTileFeature;
                            function r(Qe, rt) {
                                this.options = rt || {}, this.features = Qe, this.length = Qe.length;
                            }
                            function n(Qe, rt) {
                                this.id = "number" == typeof Qe.id ? Qe.id : void 0, this.type = Qe.type, this.rawGeometry = 1 === Qe.type ? [
                                    Qe.geometry
                                ] : Qe.geometry, this.properties = Qe.tags, this.extent = rt || 4096;
                            }
                            return Jm = r, r.prototype.feature = function(Qe) {
                                return new n(this.features[Qe], this.options.extent);
                            }, n.prototype.loadGeometry = function() {
                                var rt = this.rawGeometry;
                                this.geometry = [];
                                for(var Wn = 0; Wn < rt.length; Wn++){
                                    for(var Co = rt[Wn], Dl = [], Ll = 0; Ll < Co.length; Ll++)Dl.push(new Qe(Co[Ll][0], Co[Ll][1]));
                                    this.geometry.push(Dl);
                                }
                                return this.geometry;
                            }, n.prototype.bbox = function() {
                                this.geometry || this.loadGeometry();
                                for(var Qe = this.geometry, rt = 1 / 0, Wn = -1 / 0, Co = 1 / 0, Dl = -1 / 0, Ll = 0; Ll < Qe.length; Ll++)for(var Rl = Qe[Ll], Ul = 0; Ul < Rl.length; Ul++){
                                    var Gl = Rl[Ul];
                                    rt = Math.min(rt, Gl.x), Wn = Math.max(Wn, Gl.x), Co = Math.min(Co, Gl.y), Dl = Math.max(Dl, Gl.y);
                                }
                                return [
                                    rt,
                                    Co,
                                    Wn,
                                    Dl
                                ];
                            }, n.prototype.toGeoJSON = rt.prototype.toGeoJSON, Jm;
                        }();
                        function r(rt) {
                            var Wn = new Qe;
                            return function(Qe, rt) {
                                for(var Wn in Qe.layers)rt.writeMessage(3, n, Qe.layers[Wn]);
                            }(rt, Wn), Wn.finish();
                        }
                        function n(Qe, rt) {
                            var Wn;
                            rt.writeVarintField(15, Qe.version || 1), rt.writeStringField(1, Qe.name || ""), rt.writeVarintField(5, Qe.extent || 4096);
                            var Co = {
                                keys: [],
                                values: [],
                                keycache: {},
                                valuecache: {}
                            };
                            for(Wn = 0; Wn < Qe.length; Wn++)Co.feature = Qe.feature(Wn), rt.writeMessage(2, s, Co);
                            var Dl = Co.keys;
                            for(Wn = 0; Wn < Dl.length; Wn++)rt.writeStringField(3, Dl[Wn]);
                            var Ll = Co.values;
                            for(Wn = 0; Wn < Ll.length; Wn++)rt.writeMessage(4, c, Ll[Wn]);
                        }
                        function s(Qe, rt) {
                            var Wn = Qe.feature;
                            void 0 !== Wn.id && rt.writeVarintField(1, Wn.id), rt.writeMessage(2, o, Qe), rt.writeVarintField(3, Wn.type), rt.writeMessage(4, u, Wn);
                        }
                        function o(Qe, rt) {
                            var Wn = Qe.feature, Co = Qe.keys, Dl = Qe.values, Ll = Qe.keycache, Rl = Qe.valuecache;
                            for(var Ul in Wn.properties){
                                var Gl = Wn.properties[Ul], Zl = Ll[Ul];
                                if (null !== Gl) {
                                    void 0 === Zl && (Co.push(Ul), Ll[Ul] = Zl = Co.length - 1), rt.writeVarint(Zl);
                                    var Hl = typeof Gl;
                                    "string" !== Hl && "boolean" !== Hl && "number" !== Hl && (Gl = JSON.stringify(Gl));
                                    var ql = Hl + ":" + Gl, Ql = Rl[ql];
                                    void 0 === Ql && (Dl.push(Gl), Rl[ql] = Ql = Dl.length - 1), rt.writeVarint(Ql);
                                }
                            }
                        }
                        function a(Qe, rt) {
                            return (rt << 3) + (7 & Qe);
                        }
                        function l(Qe) {
                            return Qe << 1 ^ Qe >> 31;
                        }
                        function u(Qe, rt) {
                            for(var Wn = Qe.loadGeometry(), Co = Qe.type, Dl = 0, Ll = 0, Rl = Wn.length, Ul = 0; Ul < Rl; Ul++){
                                var Gl = Wn[Ul], Zl = 1;
                                1 === Co && (Zl = Gl.length), rt.writeVarint(a(1, Zl));
                                for(var Hl = 3 === Co ? Gl.length - 1 : Gl.length, ql = 0; ql < Hl; ql++){
                                    1 === ql && 1 !== Co && rt.writeVarint(a(2, Hl - 1));
                                    var Ql = Gl[ql].x - Dl, Kl = Gl[ql].y - Ll;
                                    rt.writeVarint(l(Ql)), rt.writeVarint(l(Kl)), Dl += Ql, Ll += Kl;
                                }
                                3 === Co && rt.writeVarint(a(7, 1));
                            }
                        }
                        function c(Qe, rt) {
                            var Wn = typeof Qe;
                            "string" === Wn ? rt.writeStringField(1, Qe) : "boolean" === Wn ? rt.writeBooleanField(7, Qe) : "number" === Wn && (Qe % 1 != 0 ? rt.writeDoubleField(3, Qe) : Qe < 0 ? rt.writeSVarintField(6, Qe) : rt.writeVarintField(5, Qe));
                        }
                        return tf.exports = r, tf.exports.fromVectorTileJs = r, tf.exports.fromGeojsonVt = function(Qe, Wn) {
                            Wn = Wn || {};
                            var Co = {};
                            for(var Dl in Qe)Co[Dl] = new rt(Qe[Dl].features, Wn), Co[Dl].name = Dl, Co[Dl].version = Wn.version, Co[Dl].extent = Wn.extent;
                            return r({
                                layers: Co
                            });
                        }, tf.exports.GeoJSONWrapper = rt, tf.exports;
                    }(), rf = e(nf);
                    const sf = [
                        Int8Array,
                        Uint8Array,
                        Uint8ClampedArray,
                        Int16Array,
                        Uint16Array,
                        Int32Array,
                        Uint32Array,
                        Float32Array,
                        Float64Array
                    ];
                    class bh {
                        static from(Qe) {
                            if (!(Qe instanceof ArrayBuffer)) throw new Error("Data must be an instance of ArrayBuffer.");
                            const [rt, Wn] = new Uint8Array(Qe, 0, 2);
                            if (219 !== rt) throw new Error("Data does not appear to be in a KDBush format.");
                            const Co = Wn >> 4;
                            if (1 !== Co) throw new Error(`Got v${Co} data when expected v1.`);
                            const Dl = sf[15 & Wn];
                            if (!Dl) throw new Error("Unrecognized array type.");
                            const [Ll] = new Uint16Array(Qe, 2, 1), [Rl] = new Uint32Array(Qe, 4, 1);
                            return new bh(Rl, Ll, Dl, Qe);
                        }
                        constructor(Qe, rt, Wn, Co){
                            if (void 0 === rt && (rt = 64), void 0 === Wn && (Wn = Float64Array), isNaN(Qe) || Qe < 0) throw new Error(`Unpexpected numItems value: ${Qe}.`);
                            this.numItems = +Qe, this.nodeSize = Math.min(Math.max(+rt, 2), 65535), this.ArrayType = Wn, this.IndexArrayType = Qe < 65536 ? Uint16Array : Uint32Array;
                            const Dl = sf.indexOf(this.ArrayType), Ll = 2 * Qe * this.ArrayType.BYTES_PER_ELEMENT, Rl = Qe * this.IndexArrayType.BYTES_PER_ELEMENT, Ul = (8 - Rl % 8) % 8;
                            if (Dl < 0) throw new Error(`Unexpected typed array class: ${Wn}.`);
                            Co && Co instanceof ArrayBuffer ? (this.data = Co, this.ids = new this.IndexArrayType(this.data, 8, Qe), this.coords = new this.ArrayType(this.data, 8 + Rl + Ul, 2 * Qe), this._pos = 2 * Qe, this._finished = !0) : (this.data = new ArrayBuffer(8 + Ll + Rl + Ul), this.ids = new this.IndexArrayType(this.data, 8, Qe), this.coords = new this.ArrayType(this.data, 8 + Rl + Ul, 2 * Qe), this._pos = 0, this._finished = !1, new Uint8Array(this.data, 0, 2).set([
                                219,
                                16 + Dl
                            ]), new Uint16Array(this.data, 2, 1)[0] = rt, new Uint32Array(this.data, 4, 1)[0] = Qe);
                        }
                        add(Qe, rt) {
                            const Wn = this._pos >> 1;
                            return this.ids[Wn] = Wn, this.coords[this._pos++] = Qe, this.coords[this._pos++] = rt, Wn;
                        }
                        finish() {
                            const Qe = this._pos >> 1;
                            if (Qe !== this.numItems) throw new Error(`Added ${Qe} items when expected ${this.numItems}.`);
                            return wh(this.ids, this.coords, this.nodeSize, 0, this.numItems - 1, 0), this._finished = !0, this;
                        }
                        range(Qe, rt, Wn, Co) {
                            if (!this._finished) throw new Error("Data not yet indexed - call index.finish().");
                            const { ids: Dl, coords: Ll, nodeSize: Rl } = this, Ul = [
                                0,
                                Dl.length - 1,
                                0
                            ], Gl = [];
                            for(; Ul.length;){
                                const Zl = Ul.pop() || 0, Hl = Ul.pop() || 0, ql = Ul.pop() || 0;
                                if (Hl - ql <= Rl) {
                                    for(let Rl = ql; Rl <= Hl; Rl++){
                                        const Ul = Ll[2 * Rl], Zl = Ll[2 * Rl + 1];
                                        Ul >= Qe && Ul <= Wn && Zl >= rt && Zl <= Co && Gl.push(Dl[Rl]);
                                    }
                                    continue;
                                }
                                const Ql = ql + Hl >> 1, Kl = Ll[2 * Ql], $l = Ll[2 * Ql + 1];
                                Kl >= Qe && Kl <= Wn && $l >= rt && $l <= Co && Gl.push(Dl[Ql]), (0 === Zl ? Qe <= Kl : rt <= $l) && (Ul.push(ql), Ul.push(Ql - 1), Ul.push(1 - Zl)), (0 === Zl ? Wn >= Kl : Co >= $l) && (Ul.push(Ql + 1), Ul.push(Hl), Ul.push(1 - Zl));
                            }
                            return Gl;
                        }
                        within(Qe, rt, Wn) {
                            if (!this._finished) throw new Error("Data not yet indexed - call index.finish().");
                            const { ids: Co, coords: Dl, nodeSize: Ll } = this, Rl = [
                                0,
                                Co.length - 1,
                                0
                            ], Ul = [], Gl = Wn * Wn;
                            for(; Rl.length;){
                                const Zl = Rl.pop() || 0, Hl = Rl.pop() || 0, ql = Rl.pop() || 0;
                                if (Hl - ql <= Ll) {
                                    for(let Wn = ql; Wn <= Hl; Wn++)Ah(Dl[2 * Wn], Dl[2 * Wn + 1], Qe, rt) <= Gl && Ul.push(Co[Wn]);
                                    continue;
                                }
                                const Ql = ql + Hl >> 1, Kl = Dl[2 * Ql], $l = Dl[2 * Ql + 1];
                                Ah(Kl, $l, Qe, rt) <= Gl && Ul.push(Co[Ql]), (0 === Zl ? Qe - Wn <= Kl : rt - Wn <= $l) && (Rl.push(ql), Rl.push(Ql - 1), Rl.push(1 - Zl)), (0 === Zl ? Qe + Wn >= Kl : rt + Wn >= $l) && (Rl.push(Ql + 1), Rl.push(Hl), Rl.push(1 - Zl));
                            }
                            return Ul;
                        }
                    }
                    function wh(Qe, rt, Wn, Co, Dl, Ll) {
                        if (Dl - Co <= Wn) return;
                        const Rl = Co + Dl >> 1;
                        _h(Qe, rt, Rl, Co, Dl, Ll), wh(Qe, rt, Wn, Co, Rl - 1, 1 - Ll), wh(Qe, rt, Wn, Rl + 1, Dl, 1 - Ll);
                    }
                    function _h(Qe, rt, Wn, Co, Dl, Ll) {
                        for(; Dl > Co;){
                            if (Dl - Co > 600) {
                                const Rl = Dl - Co + 1, Ul = Wn - Co + 1, Gl = Math.log(Rl), Zl = .5 * Math.exp(2 * Gl / 3), Hl = .5 * Math.sqrt(Gl * Zl * (Rl - Zl) / Rl) * (Ul - Rl / 2 < 0 ? -1 : 1);
                                _h(Qe, rt, Wn, Math.max(Co, Math.floor(Wn - Ul * Zl / Rl + Hl)), Math.min(Dl, Math.floor(Wn + (Rl - Ul) * Zl / Rl + Hl)), Ll);
                            }
                            const Rl = rt[2 * Wn + Ll];
                            let Ul = Co, Gl = Dl;
                            for(Sh(Qe, rt, Co, Wn), rt[2 * Dl + Ll] > Rl && Sh(Qe, rt, Co, Dl); Ul < Gl;){
                                for(Sh(Qe, rt, Ul, Gl), Ul++, Gl--; rt[2 * Ul + Ll] < Rl;)Ul++;
                                for(; rt[2 * Gl + Ll] > Rl;)Gl--;
                            }
                            rt[2 * Co + Ll] === Rl ? Sh(Qe, rt, Co, Gl) : (Gl++, Sh(Qe, rt, Gl, Dl)), Gl <= Wn && (Co = Gl + 1), Wn <= Gl && (Dl = Gl - 1);
                        }
                    }
                    function Sh(Qe, rt, Wn, Co) {
                        kh(Qe, Wn, Co), kh(rt, 2 * Wn, 2 * Co), kh(rt, 2 * Wn + 1, 2 * Co + 1);
                    }
                    function kh(Qe, rt, Wn) {
                        const Co = Qe[rt];
                        Qe[rt] = Qe[Wn], Qe[Wn] = Co;
                    }
                    function Ah(Qe, rt, Wn, Co) {
                        const Dl = Qe - Wn, Ll = rt - Co;
                        return Dl * Dl + Ll * Ll;
                    }
                    const af = {
                        minZoom: 0,
                        maxZoom: 16,
                        minPoints: 2,
                        radius: 40,
                        extent: 512,
                        nodeSize: 64,
                        log: !1,
                        generateId: !1,
                        reduce: null,
                        map: (Qe)=>Qe
                    }, of = Math.fround || (lf = new Float32Array(1), (Qe)=>(lf[0] = +Qe, lf[0]));
                    var lf;
                    class Th {
                        constructor(Qe){
                            this.options = Object.assign(Object.create(af), Qe), this.trees = new Array(this.options.maxZoom + 1), this.stride = this.options.reduce ? 7 : 6, this.clusterProps = [];
                        }
                        load(Qe) {
                            const { log: rt, minZoom: Wn, maxZoom: Co } = this.options;
                            rt && console.time("total time");
                            const Dl = `prepare ${Qe.length} points`;
                            rt && console.time(Dl), this.points = Qe;
                            const Ll = [];
                            for(let Ul = 0; Ul < Qe.length; Ul++){
                                const rt = Qe[Ul];
                                if (!rt.geometry) continue;
                                const [Wn, Co] = rt.geometry.coordinates, Dl = of(Fh(Wn)), Rl = of(Dh(Co));
                                Ll.push(Dl, Rl, 1 / 0, Ul, -1, 1), this.options.reduce && Ll.push(0);
                            }
                            let Rl = this.trees[Co + 1] = this._createTree(Ll);
                            rt && console.timeEnd(Dl);
                            for(let Ul = Co; Ul >= Wn; Ul--){
                                const Qe = +Date.now();
                                Rl = this.trees[Ul] = this._createTree(this._cluster(Rl, Ul)), rt && console.log("z%d: %d clusters in %dms", Ul, Rl.numItems, +Date.now() - Qe);
                            }
                            return rt && console.timeEnd("total time"), this;
                        }
                        getClusters(Qe, rt) {
                            let Wn = ((Qe[0] + 180) % 360 + 360) % 360 - 180;
                            const Co = Math.max(-90, Math.min(90, Qe[1]));
                            let Dl = 180 === Qe[2] ? 180 : ((Qe[2] + 180) % 360 + 360) % 360 - 180;
                            const Ll = Math.max(-90, Math.min(90, Qe[3]));
                            if (Qe[2] - Qe[0] >= 360) Wn = -180, Dl = 180;
                            else if (Wn > Dl) {
                                const Qe = this.getClusters([
                                    Wn,
                                    Co,
                                    180,
                                    Ll
                                ], rt), Rl = this.getClusters([
                                    -180,
                                    Co,
                                    Dl,
                                    Ll
                                ], rt);
                                return Qe.concat(Rl);
                            }
                            const Rl = this.trees[this._limitZoom(rt)], Ul = Rl.range(Fh(Wn), Dh(Ll), Fh(Dl), Dh(Co)), Gl = Rl.data, Zl = [];
                            for (const Hl of Ul){
                                const Qe = this.stride * Hl;
                                Zl.push(Gl[Qe + 5] > 1 ? Vh(Gl, Qe, this.clusterProps) : this.points[Gl[Qe + 3]]);
                            }
                            return Zl;
                        }
                        getChildren(Qe) {
                            const rt = this._getOriginId(Qe), Wn = this._getOriginZoom(Qe), Co = "No cluster with the specified id.", Dl = this.trees[Wn];
                            if (!Dl) throw new Error(Co);
                            const Ll = Dl.data;
                            if (rt * this.stride >= Ll.length) throw new Error(Co);
                            const Rl = this.options.radius / (this.options.extent * Math.pow(2, Wn - 1)), Ul = Dl.within(Ll[rt * this.stride], Ll[rt * this.stride + 1], Rl), Gl = [];
                            for (const Zl of Ul){
                                const rt = Zl * this.stride;
                                Ll[rt + 4] === Qe && Gl.push(Ll[rt + 5] > 1 ? Vh(Ll, rt, this.clusterProps) : this.points[Ll[rt + 3]]);
                            }
                            if (0 === Gl.length) throw new Error(Co);
                            return Gl;
                        }
                        getLeaves(Qe, rt, Wn) {
                            const Co = [];
                            return this._appendLeaves(Co, Qe, rt = rt || 10, Wn = Wn || 0, 0), Co;
                        }
                        getTile(Qe, rt, Wn) {
                            const Co = this.trees[this._limitZoom(Qe)], Dl = Math.pow(2, Qe), { extent: Ll, radius: Rl } = this.options, Ul = Rl / Ll, Gl = (Wn - Ul) / Dl, Zl = (Wn + 1 + Ul) / Dl, Hl = {
                                features: []
                            };
                            return this._addTileFeatures(Co.range((rt - Ul) / Dl, Gl, (rt + 1 + Ul) / Dl, Zl), Co.data, rt, Wn, Dl, Hl), 0 === rt && this._addTileFeatures(Co.range(1 - Ul / Dl, Gl, 1, Zl), Co.data, Dl, Wn, Dl, Hl), rt === Dl - 1 && this._addTileFeatures(Co.range(0, Gl, Ul / Dl, Zl), Co.data, -1, Wn, Dl, Hl), Hl.features.length ? Hl : null;
                        }
                        getClusterExpansionZoom(Qe) {
                            let rt = this._getOriginZoom(Qe) - 1;
                            for(; rt <= this.options.maxZoom;){
                                const Wn = this.getChildren(Qe);
                                if (rt++, 1 !== Wn.length) break;
                                Qe = Wn[0].properties.cluster_id;
                            }
                            return rt;
                        }
                        _appendLeaves(Qe, rt, Wn, Co, Dl) {
                            const Ll = this.getChildren(rt);
                            for (const Rl of Ll){
                                const rt = Rl.properties;
                                if (rt && rt.cluster ? Dl + rt.point_count <= Co ? Dl += rt.point_count : Dl = this._appendLeaves(Qe, rt.cluster_id, Wn, Co, Dl) : Dl < Co ? Dl++ : Qe.push(Rl), Qe.length === Wn) break;
                            }
                            return Dl;
                        }
                        _createTree(Qe) {
                            const rt = new bh(Qe.length / this.stride | 0, this.options.nodeSize, Float32Array);
                            for(let Wn = 0; Wn < Qe.length; Wn += this.stride)rt.add(Qe[Wn], Qe[Wn + 1]);
                            return rt.finish(), rt.data = Qe, rt;
                        }
                        _addTileFeatures(Qe, rt, Wn, Co, Dl, Ll) {
                            for (const Rl of Qe){
                                const Qe = Rl * this.stride, Ul = rt[Qe + 5] > 1;
                                let Gl, Zl, Hl;
                                if (Ul) Gl = Eh(rt, Qe, this.clusterProps), Zl = rt[Qe], Hl = rt[Qe + 1];
                                else {
                                    const Wn = this.points[rt[Qe + 3]];
                                    Gl = Wn.properties;
                                    const [Co, Dl] = Wn.geometry.coordinates;
                                    Zl = Fh(Co), Hl = Dh(Dl);
                                }
                                const ql = {
                                    type: 1,
                                    geometry: [
                                        [
                                            Math.round(this.options.extent * (Zl * Dl - Wn)),
                                            Math.round(this.options.extent * (Hl * Dl - Co))
                                        ]
                                    ],
                                    tags: Gl
                                };
                                let Ql;
                                Ql = Ul || this.options.generateId ? rt[Qe + 3] : this.points[rt[Qe + 3]].id, void 0 !== Ql && (ql.id = Ql), Ll.features.push(ql);
                            }
                        }
                        _limitZoom(Qe) {
                            return Math.max(this.options.minZoom, Math.min(Math.floor(+Qe), this.options.maxZoom + 1));
                        }
                        _cluster(Qe, rt) {
                            const { radius: Wn, extent: Co, reduce: Dl, minPoints: Ll } = this.options, Rl = Wn / (Co * Math.pow(2, rt)), Ul = Qe.data, Gl = [], Zl = this.stride;
                            for(let Hl = 0; Hl < Ul.length; Hl += Zl){
                                if (Ul[Hl + 2] <= rt) continue;
                                Ul[Hl + 2] = rt;
                                const Wn = Ul[Hl], Co = Ul[Hl + 1], ql = Qe.within(Ul[Hl], Ul[Hl + 1], Rl), Ql = Ul[Hl + 5];
                                let Kl = Ql;
                                for (const Qe of ql){
                                    const Wn = Qe * Zl;
                                    Ul[Wn + 2] > rt && (Kl += Ul[Wn + 5]);
                                }
                                if (Kl > Ql && Kl >= Ll) {
                                    let Qe, Ll = Wn * Ql, Rl = Co * Ql, $l = -1;
                                    const Tc = (Hl / Zl << 5) + (rt + 1) + this.points.length;
                                    for (const Wn of ql){
                                        const Co = Wn * Zl;
                                        if (Ul[Co + 2] <= rt) continue;
                                        Ul[Co + 2] = rt;
                                        const Gl = Ul[Co + 5];
                                        Ll += Ul[Co] * Gl, Rl += Ul[Co + 1] * Gl, Ul[Co + 4] = Tc, Dl && (Qe || (Qe = this._map(Ul, Hl, !0), $l = this.clusterProps.length, this.clusterProps.push(Qe)), Dl(Qe, this._map(Ul, Co)));
                                    }
                                    Ul[Hl + 4] = Tc, Gl.push(Ll / Kl, Rl / Kl, 1 / 0, Tc, -1, Kl), Dl && Gl.push($l);
                                } else {
                                    for(let Qe = 0; Qe < Zl; Qe++)Gl.push(Ul[Hl + Qe]);
                                    if (Kl > 1) for (const Qe of ql){
                                        const Wn = Qe * Zl;
                                        if (!(Ul[Wn + 2] <= rt)) {
                                            Ul[Wn + 2] = rt;
                                            for(let Qe = 0; Qe < Zl; Qe++)Gl.push(Ul[Wn + Qe]);
                                        }
                                    }
                                }
                            }
                            return Gl;
                        }
                        _getOriginId(Qe) {
                            return Qe - this.points.length >> 5;
                        }
                        _getOriginZoom(Qe) {
                            return (Qe - this.points.length) % 32;
                        }
                        _map(Qe, rt, Wn) {
                            if (Qe[rt + 5] > 1) {
                                const Co = this.clusterProps[Qe[rt + 6]];
                                return Wn ? Object.assign({}, Co) : Co;
                            }
                            const Co = this.points[Qe[rt + 3]].properties, Dl = this.options.map(Co);
                            return Wn && Dl === Co ? Object.assign({}, Dl) : Dl;
                        }
                    }
                    function Vh(Qe, rt, Wn) {
                        var Co;
                        return {
                            type: "Feature",
                            id: Qe[rt + 3],
                            properties: Eh(Qe, rt, Wn),
                            geometry: {
                                type: "Point",
                                coordinates: [
                                    (Co = Qe[rt], 360 * (Co - .5)),
                                    Lh(Qe[rt + 1])
                                ]
                            }
                        };
                    }
                    function Eh(Qe, rt, Wn) {
                        const Co = Qe[rt + 5], Dl = Co >= 1e4 ? `${Math.round(Co / 1e3)}k` : Co >= 1e3 ? Math.round(Co / 100) / 10 + "k" : Co, Ll = Qe[rt + 6], Rl = -1 === Ll ? {} : Object.assign({}, Wn[Ll]);
                        return Object.assign(Rl, {
                            cluster: !0,
                            cluster_id: Qe[rt + 3],
                            point_count: Co,
                            point_count_abbreviated: Dl
                        });
                    }
                    function Fh(Qe) {
                        return Qe / 360 + .5;
                    }
                    function Dh(Qe) {
                        const rt = Math.sin(Qe * Math.PI / 180), Wn = .5 - .25 * Math.log((1 + rt) / (1 - rt)) / Math.PI;
                        return Wn < 0 ? 0 : Wn > 1 ? 1 : Wn;
                    }
                    function Lh(Qe) {
                        const rt = (180 - 360 * Qe) * Math.PI / 180;
                        return 360 * Math.atan(Math.exp(rt)) / Math.PI - 90;
                    }
                    function $h(Qe, rt, Wn, Co) {
                        let Dl = Co;
                        const Ll = rt + (Wn - rt >> 1);
                        let Rl, Ul = Wn - rt;
                        const Gl = Qe[rt], Zl = Qe[rt + 1], Hl = Qe[Wn], ql = Qe[Wn + 1];
                        for(let Ql = rt + 3; Ql < Wn; Ql += 3){
                            const rt = Oh(Qe[Ql], Qe[Ql + 1], Gl, Zl, Hl, ql);
                            if (rt > Dl) Rl = Ql, Dl = rt;
                            else if (rt === Dl) {
                                const Qe = Math.abs(Ql - Ll);
                                Qe < Ul && (Rl = Ql, Ul = Qe);
                            }
                        }
                        Dl > Co && (Rl - rt > 3 && $h(Qe, rt, Rl, Co), Qe[Rl + 2] = Dl, Wn - Rl > 3 && $h(Qe, Rl, Wn, Co));
                    }
                    function Oh(Qe, rt, Wn, Co, Dl, Ll) {
                        let Rl = Dl - Wn, Ul = Ll - Co;
                        if (0 !== Rl || 0 !== Ul) {
                            const Gl = ((Qe - Wn) * Rl + (rt - Co) * Ul) / (Rl * Rl + Ul * Ul);
                            Gl > 1 ? (Wn = Dl, Co = Ll) : Gl > 0 && (Wn += Rl * Gl, Co += Ul * Gl);
                        }
                        return Rl = Qe - Wn, Ul = rt - Co, Rl * Rl + Ul * Ul;
                    }
                    function Rh(Qe, rt, Wn, Co) {
                        const Dl = {
                            id: null == Qe ? null : Qe,
                            type: rt,
                            geometry: Wn,
                            tags: Co,
                            minX: 1 / 0,
                            minY: 1 / 0,
                            maxX: -1 / 0,
                            maxY: -1 / 0
                        };
                        if ("Point" === rt || "MultiPoint" === rt || "LineString" === rt) Nh(Dl, Wn);
                        else if ("Polygon" === rt) Nh(Dl, Wn[0]);
                        else if ("MultiLineString" === rt) for (const Ll of Wn)Nh(Dl, Ll);
                        else if ("MultiPolygon" === rt) for (const Ll of Wn)Nh(Dl, Ll[0]);
                        return Dl;
                    }
                    function Nh(Qe, rt) {
                        for(let Wn = 0; Wn < rt.length; Wn += 3)Qe.minX = Math.min(Qe.minX, rt[Wn]), Qe.minY = Math.min(Qe.minY, rt[Wn + 1]), Qe.maxX = Math.max(Qe.maxX, rt[Wn]), Qe.maxY = Math.max(Qe.maxY, rt[Wn + 1]);
                    }
                    function jh(Qe, rt, Wn, Co) {
                        if (!rt.geometry) return;
                        const Dl = rt.geometry.coordinates;
                        if (Dl && 0 === Dl.length) return;
                        const Ll = rt.geometry.type, Rl = Math.pow(Wn.tolerance / ((1 << Wn.maxZoom) * Wn.extent), 2);
                        let Ul = [], Gl = rt.id;
                        if (Wn.promoteId ? Gl = rt.properties[Wn.promoteId] : Wn.generateId && (Gl = Co || 0), "Point" === Ll) qh(Dl, Ul);
                        else if ("MultiPoint" === Ll) for (const Zl of Dl)qh(Zl, Ul);
                        else if ("LineString" === Ll) Uh(Dl, Ul, Rl, !1);
                        else if ("MultiLineString" === Ll) {
                            if (Wn.lineMetrics) {
                                for (const Wn of Dl)Ul = [], Uh(Wn, Ul, Rl, !1), Qe.push(Rh(Gl, "LineString", Ul, rt.properties));
                                return;
                            }
                            Gh(Dl, Ul, Rl, !1);
                        } else if ("Polygon" === Ll) Gh(Dl, Ul, Rl, !0);
                        else {
                            if ("MultiPolygon" !== Ll) {
                                if ("GeometryCollection" === Ll) {
                                    for (const Dl of rt.geometry.geometries)jh(Qe, {
                                        id: Gl,
                                        geometry: Dl,
                                        properties: rt.properties
                                    }, Wn, Co);
                                    return;
                                }
                                throw new Error("Input data is not a valid GeoJSON object.");
                            }
                            for (const Qe of Dl){
                                const rt = [];
                                Gh(Qe, rt, Rl, !0), Ul.push(rt);
                            }
                        }
                        Qe.push(Rh(Gl, Ll, Ul, rt.properties));
                    }
                    function qh(Qe, rt) {
                        rt.push(Zh(Qe[0]), Xh(Qe[1]), 0);
                    }
                    function Uh(Qe, rt, Wn, Co) {
                        let Dl, Ll, Rl = 0;
                        for(let Gl = 0; Gl < Qe.length; Gl++){
                            const Wn = Zh(Qe[Gl][0]), Ul = Xh(Qe[Gl][1]);
                            rt.push(Wn, Ul, 0), Gl > 0 && (Rl += Co ? (Dl * Ul - Wn * Ll) / 2 : Math.sqrt(Math.pow(Wn - Dl, 2) + Math.pow(Ul - Ll, 2))), Dl = Wn, Ll = Ul;
                        }
                        const Ul = rt.length - 3;
                        rt[2] = 1, $h(rt, 0, Ul, Wn), rt[Ul + 2] = 1, rt.size = Math.abs(Rl), rt.start = 0, rt.end = rt.size;
                    }
                    function Gh(Qe, rt, Wn, Co) {
                        for(let Dl = 0; Dl < Qe.length; Dl++){
                            const Ll = [];
                            Uh(Qe[Dl], Ll, Wn, Co), rt.push(Ll);
                        }
                    }
                    function Zh(Qe) {
                        return Qe / 360 + .5;
                    }
                    function Xh(Qe) {
                        const rt = Math.sin(Qe * Math.PI / 180), Wn = .5 - .25 * Math.log((1 + rt) / (1 - rt)) / Math.PI;
                        return Wn < 0 ? 0 : Wn > 1 ? 1 : Wn;
                    }
                    function Hh(Qe, rt, Wn, Co, Dl, Ll, Rl, Ul) {
                        if (Co /= rt, Ll >= (Wn /= rt) && Rl < Co) return Qe;
                        if (Rl < Wn || Ll >= Co) return null;
                        const Gl = [];
                        for (const Zl of Qe){
                            const Qe = Zl.geometry;
                            let rt = Zl.type;
                            const Ll = 0 === Dl ? Zl.minX : Zl.minY, Rl = 0 === Dl ? Zl.maxX : Zl.maxY;
                            if (Ll >= Wn && Rl < Co) {
                                Gl.push(Zl);
                                continue;
                            }
                            if (Rl < Wn || Ll >= Co) continue;
                            let Hl = [];
                            if ("Point" === rt || "MultiPoint" === rt) Yh(Qe, Hl, Wn, Co, Dl);
                            else if ("LineString" === rt) Jh(Qe, Hl, Wn, Co, Dl, !1, Ul.lineMetrics);
                            else if ("MultiLineString" === rt) Wh(Qe, Hl, Wn, Co, Dl, !1);
                            else if ("Polygon" === rt) Wh(Qe, Hl, Wn, Co, Dl, !0);
                            else if ("MultiPolygon" === rt) for (const Ul of Qe){
                                const Qe = [];
                                Wh(Ul, Qe, Wn, Co, Dl, !0), Qe.length && Hl.push(Qe);
                            }
                            if (Hl.length) {
                                if (Ul.lineMetrics && "LineString" === rt) {
                                    for (const Qe of Hl)Gl.push(Rh(Zl.id, rt, Qe, Zl.tags));
                                    continue;
                                }
                                "LineString" !== rt && "MultiLineString" !== rt || (1 === Hl.length ? (rt = "LineString", Hl = Hl[0]) : rt = "MultiLineString"), "Point" !== rt && "MultiPoint" !== rt || (rt = 3 === Hl.length ? "Point" : "MultiPoint"), Gl.push(Rh(Zl.id, rt, Hl, Zl.tags));
                            }
                        }
                        return Gl.length ? Gl : null;
                    }
                    function Yh(Qe, rt, Wn, Co, Dl) {
                        for(let Ll = 0; Ll < Qe.length; Ll += 3){
                            const Rl = Qe[Ll + Dl];
                            Rl >= Wn && Rl <= Co && Qh(rt, Qe[Ll], Qe[Ll + 1], Qe[Ll + 2]);
                        }
                    }
                    function Jh(Qe, rt, Wn, Co, Dl, Ll, Rl) {
                        let Ul = Kh(Qe);
                        const Gl = 0 === Dl ? tp : ep;
                        let Zl, Hl, ql = Qe.start;
                        for(let tu = 0; tu < Qe.length - 3; tu += 3){
                            const Ql = Qe[tu], Kl = Qe[tu + 1], $l = Qe[tu + 2], Tc = Qe[tu + 3], lu = Qe[tu + 4], du = 0 === Dl ? Ql : Kl, fu = 0 === Dl ? Tc : lu;
                            let yu = !1;
                            Rl && (Zl = Math.sqrt(Math.pow(Ql - Tc, 2) + Math.pow(Kl - lu, 2))), du < Wn ? fu > Wn && (Hl = Gl(Ul, Ql, Kl, Tc, lu, Wn), Rl && (Ul.start = ql + Zl * Hl)) : du > Co ? fu < Co && (Hl = Gl(Ul, Ql, Kl, Tc, lu, Co), Rl && (Ul.start = ql + Zl * Hl)) : Qh(Ul, Ql, Kl, $l), fu < Wn && du >= Wn && (Hl = Gl(Ul, Ql, Kl, Tc, lu, Wn), yu = !0), fu > Co && du <= Co && (Hl = Gl(Ul, Ql, Kl, Tc, lu, Co), yu = !0), !Ll && yu && (Rl && (Ul.end = ql + Zl * Hl), rt.push(Ul), Ul = Kh(Qe)), Rl && (ql += Zl);
                        }
                        let Ql = Qe.length - 3;
                        const Kl = Qe[Ql], $l = Qe[Ql + 1], Tc = 0 === Dl ? Kl : $l;
                        Tc >= Wn && Tc <= Co && Qh(Ul, Kl, $l, Qe[Ql + 2]), Ql = Ul.length - 3, Ll && Ql >= 3 && (Ul[Ql] !== Ul[0] || Ul[Ql + 1] !== Ul[1]) && Qh(Ul, Ul[0], Ul[1], Ul[2]), Ul.length && rt.push(Ul);
                    }
                    function Kh(Qe) {
                        const rt = [];
                        return rt.size = Qe.size, rt.start = Qe.start, rt.end = Qe.end, rt;
                    }
                    function Wh(Qe, rt, Wn, Co, Dl, Ll) {
                        for (const Rl of Qe)Jh(Rl, rt, Wn, Co, Dl, Ll, !1);
                    }
                    function Qh(Qe, rt, Wn, Co) {
                        Qe.push(rt, Wn, Co);
                    }
                    function tp(Qe, rt, Wn, Co, Dl, Ll) {
                        const Rl = (Ll - rt) / (Co - rt);
                        return Qh(Qe, Ll, Wn + (Dl - Wn) * Rl, 1), Rl;
                    }
                    function ep(Qe, rt, Wn, Co, Dl, Ll) {
                        const Rl = (Ll - Wn) / (Dl - Wn);
                        return Qh(Qe, rt + (Co - rt) * Rl, Ll, 1), Rl;
                    }
                    function rp(Qe, rt) {
                        const Wn = [];
                        for(let Co = 0; Co < Qe.length; Co++){
                            const Dl = Qe[Co], Ll = Dl.type;
                            let Rl;
                            if ("Point" === Ll || "MultiPoint" === Ll || "LineString" === Ll) Rl = np(Dl.geometry, rt);
                            else if ("MultiLineString" === Ll || "Polygon" === Ll) {
                                Rl = [];
                                for (const Qe of Dl.geometry)Rl.push(np(Qe, rt));
                            } else if ("MultiPolygon" === Ll) {
                                Rl = [];
                                for (const Qe of Dl.geometry){
                                    const Wn = [];
                                    for (const Co of Qe)Wn.push(np(Co, rt));
                                    Rl.push(Wn);
                                }
                            }
                            Wn.push(Rh(Dl.id, Ll, Rl, Dl.tags));
                        }
                        return Wn;
                    }
                    function np(Qe, rt) {
                        const Wn = [];
                        Wn.size = Qe.size, void 0 !== Qe.start && (Wn.start = Qe.start, Wn.end = Qe.end);
                        for(let Co = 0; Co < Qe.length; Co += 3)Wn.push(Qe[Co] + rt, Qe[Co + 1], Qe[Co + 2]);
                        return Wn;
                    }
                    function ip(Qe, rt) {
                        if (Qe.transformed) return Qe;
                        const Wn = 1 << Qe.z, Co = Qe.x, Dl = Qe.y;
                        for (const Ll of Qe.features){
                            const Qe = Ll.geometry, Rl = Ll.type;
                            if (Ll.geometry = [], 1 === Rl) for(let Ul = 0; Ul < Qe.length; Ul += 2)Ll.geometry.push(sp(Qe[Ul], Qe[Ul + 1], rt, Wn, Co, Dl));
                            else for(let Ul = 0; Ul < Qe.length; Ul++){
                                const Rl = [];
                                for(let Ll = 0; Ll < Qe[Ul].length; Ll += 2)Rl.push(sp(Qe[Ul][Ll], Qe[Ul][Ll + 1], rt, Wn, Co, Dl));
                                Ll.geometry.push(Rl);
                            }
                        }
                        return Qe.transformed = !0, Qe;
                    }
                    function sp(Qe, rt, Wn, Co, Dl, Ll) {
                        return [
                            Math.round(Wn * (Qe * Co - Dl)),
                            Math.round(Wn * (rt * Co - Ll))
                        ];
                    }
                    function op(Qe, rt, Wn, Co, Dl) {
                        const Ll = rt === Dl.maxZoom ? 0 : Dl.tolerance / ((1 << rt) * Dl.extent), Rl = {
                            features: [],
                            numPoints: 0,
                            numSimplified: 0,
                            numFeatures: Qe.length,
                            source: null,
                            x: Wn,
                            y: Co,
                            z: rt,
                            transformed: !1,
                            minX: 2,
                            minY: 1,
                            maxX: -1,
                            maxY: 0
                        };
                        for (const Ul of Qe)ap(Rl, Ul, Ll, Dl);
                        return Rl;
                    }
                    function ap(Qe, rt, Wn, Co) {
                        const Dl = rt.geometry, Ll = rt.type, Rl = [];
                        if (Qe.minX = Math.min(Qe.minX, rt.minX), Qe.minY = Math.min(Qe.minY, rt.minY), Qe.maxX = Math.max(Qe.maxX, rt.maxX), Qe.maxY = Math.max(Qe.maxY, rt.maxY), "Point" === Ll || "MultiPoint" === Ll) for(let Ul = 0; Ul < Dl.length; Ul += 3)Rl.push(Dl[Ul], Dl[Ul + 1]), Qe.numPoints++, Qe.numSimplified++;
                        else if ("LineString" === Ll) lp(Rl, Dl, Qe, Wn, !1, !1);
                        else if ("MultiLineString" === Ll || "Polygon" === Ll) for(let Ul = 0; Ul < Dl.length; Ul++)lp(Rl, Dl[Ul], Qe, Wn, "Polygon" === Ll, 0 === Ul);
                        else if ("MultiPolygon" === Ll) for(let Ul = 0; Ul < Dl.length; Ul++){
                            const rt = Dl[Ul];
                            for(let Co = 0; Co < rt.length; Co++)lp(Rl, rt[Co], Qe, Wn, !0, 0 === Co);
                        }
                        if (Rl.length) {
                            let Wn = rt.tags || null;
                            if ("LineString" === Ll && Co.lineMetrics) {
                                Wn = {};
                                for(const Qe in rt.tags)Wn[Qe] = rt.tags[Qe];
                                Wn.mapbox_clip_start = Dl.start / Dl.size, Wn.mapbox_clip_end = Dl.end / Dl.size;
                            }
                            const Ul = {
                                geometry: Rl,
                                type: "Polygon" === Ll || "MultiPolygon" === Ll ? 3 : "LineString" === Ll || "MultiLineString" === Ll ? 2 : 1,
                                tags: Wn
                            };
                            null !== rt.id && (Ul.id = rt.id), Qe.features.push(Ul);
                        }
                    }
                    function lp(Qe, rt, Wn, Co, Dl, Ll) {
                        const Rl = Co * Co;
                        if (Co > 0 && rt.size < (Dl ? Rl : Co)) return void (Wn.numPoints += rt.length / 3);
                        const Ul = [];
                        for(let Gl = 0; Gl < rt.length; Gl += 3)(0 === Co || rt[Gl + 2] > Rl) && (Wn.numSimplified++, Ul.push(rt[Gl], rt[Gl + 1])), Wn.numPoints++;
                        Dl && function(Qe, rt) {
                            let Wn = 0;
                            for(let Co = 0, Dl = Qe.length, Ll = Dl - 2; Co < Dl; Ll = Co, Co += 2)Wn += (Qe[Co] - Qe[Ll]) * (Qe[Co + 1] + Qe[Ll + 1]);
                            if (Wn > 0 === rt) for(let Co = 0, Dl = Qe.length; Co < Dl / 2; Co += 2){
                                const rt = Qe[Co], Wn = Qe[Co + 1];
                                Qe[Co] = Qe[Dl - 2 - Co], Qe[Co + 1] = Qe[Dl - 1 - Co], Qe[Dl - 2 - Co] = rt, Qe[Dl - 1 - Co] = Wn;
                            }
                        }(Ul, Ll), Qe.push(Ul);
                    }
                    const cf = {
                        maxZoom: 14,
                        indexMaxZoom: 5,
                        indexMaxPoints: 1e5,
                        tolerance: 3,
                        extent: 4096,
                        buffer: 64,
                        lineMetrics: !1,
                        promoteId: null,
                        generateId: !1,
                        debug: 0
                    };
                    class cp {
                        constructor(Qe, rt){
                            const Wn = (rt = this.options = function(Qe, rt) {
                                for(const Wn in rt)Qe[Wn] = rt[Wn];
                                return Qe;
                            }(Object.create(cf), rt)).debug;
                            if (Wn && console.time("preprocess data"), rt.maxZoom < 0 || rt.maxZoom > 24) throw new Error("maxZoom should be in the 0-24 range");
                            if (rt.promoteId && rt.generateId) throw new Error("promoteId and generateId cannot be used together.");
                            let Co = function(Qe, rt) {
                                const Wn = [];
                                if ("FeatureCollection" === Qe.type) for(let Co = 0; Co < Qe.features.length; Co++)jh(Wn, Qe.features[Co], rt, Co);
                                else jh(Wn, "Feature" === Qe.type ? Qe : {
                                    geometry: Qe
                                }, rt);
                                return Wn;
                            }(Qe, rt);
                            this.tiles = {}, this.tileCoords = [], Wn && (console.timeEnd("preprocess data"), console.log("index: maxZoom: %d, maxPoints: %d", rt.indexMaxZoom, rt.indexMaxPoints), console.time("generate tiles"), this.stats = {}, this.total = 0), Co = function(Qe, rt) {
                                const Wn = rt.buffer / rt.extent;
                                let Co = Qe;
                                const Dl = Hh(Qe, 1, -1 - Wn, Wn, 0, -1, 2, rt), Ll = Hh(Qe, 1, 1 - Wn, 2 + Wn, 0, -1, 2, rt);
                                return (Dl || Ll) && (Co = Hh(Qe, 1, -Wn, 1 + Wn, 0, -1, 2, rt) || [], Dl && (Co = rp(Dl, 1).concat(Co)), Ll && (Co = Co.concat(rp(Ll, -1)))), Co;
                            }(Co, rt), Co.length && this.splitTile(Co, 0, 0, 0), Wn && (Co.length && console.log("features: %d, points: %d", this.tiles[0].numFeatures, this.tiles[0].numPoints), console.timeEnd("generate tiles"), console.log("tiles generated:", this.total, JSON.stringify(this.stats)));
                        }
                        splitTile(Qe, rt, Wn, Co, Dl, Ll, Rl) {
                            const Ul = [
                                Qe,
                                rt,
                                Wn,
                                Co
                            ], Gl = this.options, Zl = Gl.debug;
                            for(; Ul.length;){
                                Co = Ul.pop(), Wn = Ul.pop(), rt = Ul.pop(), Qe = Ul.pop();
                                const Hl = 1 << rt, ql = hp(rt, Wn, Co);
                                let Ql = this.tiles[ql];
                                if (!Ql && (Zl > 1 && console.time("creation"), Ql = this.tiles[ql] = op(Qe, rt, Wn, Co, Gl), this.tileCoords.push({
                                    z: rt,
                                    x: Wn,
                                    y: Co
                                }), Zl)) {
                                    Zl > 1 && (console.log("tile z%d-%d-%d (features: %d, points: %d, simplified: %d)", rt, Wn, Co, Ql.numFeatures, Ql.numPoints, Ql.numSimplified), console.timeEnd("creation"));
                                    const Qe = `z${rt}`;
                                    this.stats[Qe] = (this.stats[Qe] || 0) + 1, this.total++;
                                }
                                if (Ql.source = Qe, null == Dl) {
                                    if (rt === Gl.indexMaxZoom || Ql.numPoints <= Gl.indexMaxPoints) continue;
                                } else {
                                    if (rt === Gl.maxZoom || rt === Dl) continue;
                                    if (null != Dl) {
                                        const Qe = Dl - rt;
                                        if (Wn !== Ll >> Qe || Co !== Rl >> Qe) continue;
                                    }
                                }
                                if (Ql.source = null, 0 === Qe.length) continue;
                                Zl > 1 && console.time("clipping");
                                const Kl = .5 * Gl.buffer / Gl.extent, $l = .5 - Kl, Tc = .5 + Kl, tu = 1 + Kl;
                                let lu = null, du = null, fu = null, yu = null, Eu = Hh(Qe, Hl, Wn - Kl, Wn + Tc, 0, Ql.minX, Ql.maxX, Gl), Tu = Hh(Qe, Hl, Wn + $l, Wn + tu, 0, Ql.minX, Ql.maxX, Gl);
                                Qe = null, Eu && (lu = Hh(Eu, Hl, Co - Kl, Co + Tc, 1, Ql.minY, Ql.maxY, Gl), du = Hh(Eu, Hl, Co + $l, Co + tu, 1, Ql.minY, Ql.maxY, Gl), Eu = null), Tu && (fu = Hh(Tu, Hl, Co - Kl, Co + Tc, 1, Ql.minY, Ql.maxY, Gl), yu = Hh(Tu, Hl, Co + $l, Co + tu, 1, Ql.minY, Ql.maxY, Gl), Tu = null), Zl > 1 && console.timeEnd("clipping"), Ul.push(lu || [], rt + 1, 2 * Wn, 2 * Co), Ul.push(du || [], rt + 1, 2 * Wn, 2 * Co + 1), Ul.push(fu || [], rt + 1, 2 * Wn + 1, 2 * Co), Ul.push(yu || [], rt + 1, 2 * Wn + 1, 2 * Co + 1);
                            }
                        }
                        getTile(Qe, rt, Wn) {
                            Qe = +Qe, rt = +rt, Wn = +Wn;
                            const Co = this.options, { extent: Dl, debug: Ll } = Co;
                            if (Qe < 0 || Qe > 24) return null;
                            const Rl = 1 << Qe, Ul = hp(Qe, rt = rt + Rl & Rl - 1, Wn);
                            if (this.tiles[Ul]) return ip(this.tiles[Ul], Dl);
                            Ll > 1 && console.log("drilling down to z%d-%d-%d", Qe, rt, Wn);
                            let Gl, Zl = Qe, Hl = rt, ql = Wn;
                            for(; !Gl && Zl > 0;)Zl--, Hl >>= 1, ql >>= 1, Gl = this.tiles[hp(Zl, Hl, ql)];
                            return Gl && Gl.source ? (Ll > 1 && (console.log("found parent tile z%d-%d-%d", Zl, Hl, ql), console.time("drilling down")), this.splitTile(Gl.source, Zl, Hl, ql, Qe, rt, Wn), Ll > 1 && console.timeEnd("drilling down"), this.tiles[Ul] ? ip(this.tiles[Ul], Dl) : null) : null;
                        }
                    }
                    function hp(Qe, rt, Wn) {
                        return 32 * ((1 << Qe) * Wn + rt) + Qe;
                    }
                    function pp(Qe, rt) {
                        return rt ? Qe.properties[rt] : Qe.id;
                    }
                    function fp(Qe, rt) {
                        if (null == Qe) return !0;
                        if ("Feature" === Qe.type) return null != pp(Qe, rt);
                        if ("FeatureCollection" === Qe.type) {
                            const Wn = new Set;
                            for (const Co of Qe.features){
                                const Qe = pp(Co, rt);
                                if (null == Qe) return !1;
                                if (Wn.has(Qe)) return !1;
                                Wn.add(Qe);
                            }
                            return !0;
                        }
                        return !1;
                    }
                    function dp(Qe, rt) {
                        const Wn = new Map;
                        if (null == Qe) ;
                        else if ("Feature" === Qe.type) Wn.set(pp(Qe, rt), Qe);
                        else for (const Co of Qe.features)Wn.set(pp(Co, rt), Co);
                        return Wn;
                    }
                    class yp extends sh {
                        constructor(){
                            super(...arguments), this._dataUpdateable = new Map;
                        }
                        loadVectorTile(Qe, rt) {
                            return t(this, void 0, void 0, function*() {
                                const rt = Qe.tileID.canonical;
                                if (!this._geoJSONIndex) throw new Error("Unable to parse the data into a cluster or geojson");
                                const Wn = this._geoJSONIndex.getTile(rt.z, rt.x, rt.y);
                                if (!Wn) return null;
                                const Co = new ph(Wn.features);
                                let Dl = rf(Co);
                                return 0 === Dl.byteOffset && Dl.byteLength === Dl.buffer.byteLength || (Dl = new Uint8Array(Dl)), {
                                    vectorTile: Co,
                                    rawData: Dl.buffer
                                };
                            });
                        }
                        loadData(Qe) {
                            return t(this, void 0, void 0, function*() {
                                var rt;
                                null === (rt = this._pendingRequest) || void 0 === rt || rt.abort();
                                const Wn = !!(Qe && Qe.request && Qe.request.collectResourceTiming) && new ih(Qe.request);
                                this._pendingRequest = new AbortController;
                                try {
                                    this._pendingData = this.loadAndProcessGeoJSON(Qe, this._pendingRequest), this._geoJSONIndex = Qe.cluster ? new Th(function(Qe) {
                                        let { superclusterOptions: rt, clusterProperties: Wn } = Qe;
                                        if (!Wn || !rt) return rt;
                                        const Co = {}, Dl = {}, Ll = {
                                            accumulated: null,
                                            zoom: 0
                                        }, Rl = {
                                            properties: null
                                        }, Ul = Object.keys(Wn);
                                        for (const Gl of Ul){
                                            const [Qe, rt] = Wn[Gl], Ll = Yr(rt), Rl = Yr("string" == typeof Qe ? [
                                                Qe,
                                                [
                                                    "accumulated"
                                                ],
                                                [
                                                    "get",
                                                    Gl
                                                ]
                                            ] : Qe);
                                            Co[Gl] = Ll.value, Dl[Gl] = Rl.value;
                                        }
                                        return rt.map = (Qe)=>{
                                            Rl.properties = Qe;
                                            const rt = {};
                                            for (const Wn of Ul)rt[Wn] = Co[Wn].evaluate(Ll, Rl);
                                            return rt;
                                        }, rt.reduce = (Qe, rt)=>{
                                            Rl.properties = rt;
                                            for (const Wn of Ul)Ll.accumulated = Qe[Wn], Qe[Wn] = Dl[Wn].evaluate(Ll, Rl);
                                        }, rt;
                                    }(Qe)).load((yield this._pendingData).features) : (Co = yield this._pendingData, new cp(Co, Qe.geojsonVtOptions)), this.loaded = {};
                                    const rt = {};
                                    if (Wn) {
                                        const Co = Wn.finish();
                                        Co && (rt.resourceTiming = {}, rt.resourceTiming[Qe.source] = JSON.parse(JSON.stringify(Co)));
                                    }
                                    return rt;
                                } catch (rt) {
                                    if (delete this._pendingRequest, function(Qe) {
                                        return Qe.message === Bd;
                                    }(rt)) return {
                                        abandoned: !0
                                    };
                                    throw rt;
                                }
                                var Co;
                            });
                        }
                        getData() {
                            return t(this, void 0, void 0, function*() {
                                return this._pendingData;
                            });
                        }
                        reloadTile(Qe) {
                            const rt = this.loaded;
                            return rt && rt[Qe.uid] ? super.reloadTile(Qe) : this.loadTile(Qe);
                        }
                        loadAndProcessGeoJSON(Qe, rt) {
                            return t(this, void 0, void 0, function*() {
                                let Wn = yield this.loadGeoJSON(Qe, rt);
                                if (delete this._pendingRequest, "object" != typeof Wn) throw new Error(`Input data given to '${Qe.source}' is not a valid GeoJSON object.`);
                                if (Km(Wn, !0), Qe.filter) {
                                    const rt = Yr(Qe.filter, {
                                        type: "boolean",
                                        "property-type": "data-driven",
                                        overridable: !1,
                                        transition: !1
                                    });
                                    if ("error" === rt.result) throw new Error(rt.value.map((Qe)=>`${Qe.key}: ${Qe.message}`).join(", "));
                                    const Co = Wn.features.filter((Qe)=>rt.value.evaluate({
                                            zoom: 0
                                        }, Qe));
                                    Wn = {
                                        type: "FeatureCollection",
                                        features: Co
                                    };
                                }
                                return Wn;
                            });
                        }
                        loadGeoJSON(Qe, rt) {
                            return t(this, void 0, void 0, function*() {
                                const { promoteId: Wn } = Qe;
                                if (Qe.request) {
                                    const Co = yield ((Qe, rt)=>Kn(g(Qe, {
                                            type: "json"
                                        }), rt))(Qe.request, rt);
                                    return this._dataUpdateable = fp(Co.data, Wn) ? dp(Co.data, Wn) : void 0, Co.data;
                                }
                                if ("string" == typeof Qe.data) try {
                                    const rt = JSON.parse(Qe.data);
                                    return this._dataUpdateable = fp(rt, Wn) ? dp(rt, Wn) : void 0, rt;
                                } catch (Wn) {
                                    throw new Error(`Input data given to '${Qe.source}' is not a valid GeoJSON object.`);
                                }
                                if (!Qe.dataDiff) throw new Error(`Input data given to '${Qe.source}' is not a valid GeoJSON object.`);
                                if (!this._dataUpdateable) throw new Error(`Cannot update existing geojson data in ${Qe.source}`);
                                return function(Qe, rt, Wn) {
                                    var Co, Dl, Ll, Rl;
                                    if (rt.removeAll && Qe.clear(), rt.remove) for (const Ul of rt.remove)Qe.delete(Ul);
                                    if (rt.add) for (const Ul of rt.add){
                                        const rt = pp(Ul, Wn);
                                        null != rt && Qe.set(rt, Ul);
                                    }
                                    if (rt.update) for (const Ul of rt.update){
                                        let rt = Qe.get(Ul.id);
                                        if (null == rt) continue;
                                        const Wn = !Ul.removeAllProperties && ((null === (Co = Ul.removeProperties) || void 0 === Co ? void 0 : Co.length) > 0 || (null === (Dl = Ul.addOrUpdateProperties) || void 0 === Dl ? void 0 : Dl.length) > 0);
                                        if ((Ul.newGeometry || Ul.removeAllProperties || Wn) && (rt = Object.assign({}, rt), Qe.set(Ul.id, rt), Wn && (rt.properties = Object.assign({}, rt.properties))), Ul.newGeometry && (rt.geometry = Ul.newGeometry), Ul.removeAllProperties) rt.properties = {};
                                        else if ((null === (Ll = Ul.removeProperties) || void 0 === Ll ? void 0 : Ll.length) > 0) for (const Qe of Ul.removeProperties)Object.prototype.hasOwnProperty.call(rt.properties, Qe) && delete rt.properties[Qe];
                                        if ((null === (Rl = Ul.addOrUpdateProperties) || void 0 === Rl ? void 0 : Rl.length) > 0) for (const { key: Qe, value: Co } of Ul.addOrUpdateProperties)rt.properties[Qe] = Co;
                                    }
                                }(this._dataUpdateable, Qe.dataDiff, Wn), {
                                    type: "FeatureCollection",
                                    features: Array.from(this._dataUpdateable.values())
                                };
                            });
                        }
                        removeSource(Qe) {
                            return t(this, void 0, void 0, function*() {
                                this._pendingRequest && this._pendingRequest.abort();
                            });
                        }
                        getClusterExpansionZoom(Qe) {
                            return this._geoJSONIndex.getClusterExpansionZoom(Qe.clusterId);
                        }
                        getClusterChildren(Qe) {
                            return this._geoJSONIndex.getChildren(Qe.clusterId);
                        }
                        getClusterLeaves(Qe) {
                            return this._geoJSONIndex.getLeaves(Qe.clusterId, Qe.limit, Qe.offset);
                        }
                    }
                    class mp {
                        constructor(Qe){
                            this.self = Qe, this.actor = new ai(Qe), this.layerIndexes = {}, this.availableImages = {}, this.workerSources = {}, this.demWorkerSources = {}, this.externalWorkerSourceTypes = {}, this.self.registerWorkerSource = (Qe, rt)=>{
                                if (this.externalWorkerSourceTypes[Qe]) throw new Error(`Worker source with name "${Qe}" already registered.`);
                                this.externalWorkerSourceTypes[Qe] = rt;
                            }, this.self.addProtocol = Zn, this.self.removeProtocol = Xn, this.self.registerRTLTextPlugin = (Qe)=>{
                                Yd.setMethods(Qe);
                            }, this.actor.registerMessageHandler("LDT", (Qe, rt)=>this._getDEMWorkerSource(Qe, rt.source).loadTile(rt)), this.actor.registerMessageHandler("RDT", (Qe, rt)=>t(this, void 0, void 0, function*() {
                                    this._getDEMWorkerSource(Qe, rt.source).removeTile(rt);
                                })), this.actor.registerMessageHandler("GCEZ", (Qe, rt)=>t(this, void 0, void 0, function*() {
                                    return this._getWorkerSource(Qe, rt.type, rt.source).getClusterExpansionZoom(rt);
                                })), this.actor.registerMessageHandler("GCC", (Qe, rt)=>t(this, void 0, void 0, function*() {
                                    return this._getWorkerSource(Qe, rt.type, rt.source).getClusterChildren(rt);
                                })), this.actor.registerMessageHandler("GCL", (Qe, rt)=>t(this, void 0, void 0, function*() {
                                    return this._getWorkerSource(Qe, rt.type, rt.source).getClusterLeaves(rt);
                                })), this.actor.registerMessageHandler("LD", (Qe, rt)=>this._getWorkerSource(Qe, rt.type, rt.source).loadData(rt)), this.actor.registerMessageHandler("GD", (Qe, rt)=>this._getWorkerSource(Qe, rt.type, rt.source).getData()), this.actor.registerMessageHandler("LT", (Qe, rt)=>this._getWorkerSource(Qe, rt.type, rt.source).loadTile(rt)), this.actor.registerMessageHandler("RT", (Qe, rt)=>this._getWorkerSource(Qe, rt.type, rt.source).reloadTile(rt)), this.actor.registerMessageHandler("AT", (Qe, rt)=>this._getWorkerSource(Qe, rt.type, rt.source).abortTile(rt)), this.actor.registerMessageHandler("RMT", (Qe, rt)=>this._getWorkerSource(Qe, rt.type, rt.source).removeTile(rt)), this.actor.registerMessageHandler("RS", (Qe, rt)=>t(this, void 0, void 0, function*() {
                                    if (!this.workerSources[Qe] || !this.workerSources[Qe][rt.type] || !this.workerSources[Qe][rt.type][rt.source]) return;
                                    const Wn = this.workerSources[Qe][rt.type][rt.source];
                                    delete this.workerSources[Qe][rt.type][rt.source], void 0 !== Wn.removeSource && Wn.removeSource(rt);
                                })), this.actor.registerMessageHandler("RM", (Qe)=>t(this, void 0, void 0, function*() {
                                    delete this.layerIndexes[Qe], delete this.availableImages[Qe], delete this.workerSources[Qe], delete this.demWorkerSources[Qe];
                                })), this.actor.registerMessageHandler("SR", (Qe, rt)=>t(this, void 0, void 0, function*() {
                                    this.referrer = rt;
                                })), this.actor.registerMessageHandler("SRPS", (Qe, rt)=>this._syncRTLPluginState(Qe, rt)), this.actor.registerMessageHandler("IS", (Qe, rt)=>t(this, void 0, void 0, function*() {
                                    this.self.importScripts(rt);
                                })), this.actor.registerMessageHandler("SI", (Qe, rt)=>this._setImages(Qe, rt)), this.actor.registerMessageHandler("UL", (Qe, rt)=>t(this, void 0, void 0, function*() {
                                    this._getLayerIndex(Qe).update(rt.layers, rt.removedIds);
                                })), this.actor.registerMessageHandler("SL", (Qe, rt)=>t(this, void 0, void 0, function*() {
                                    this._getLayerIndex(Qe).replace(rt);
                                }));
                        }
                        _setImages(Qe, rt) {
                            return t(this, void 0, void 0, function*() {
                                this.availableImages[Qe] = rt;
                                for(const Wn in this.workerSources[Qe]){
                                    const Co = this.workerSources[Qe][Wn];
                                    for(const Qe in Co)Co[Qe].availableImages = rt;
                                }
                            });
                        }
                        _syncRTLPluginState(Qe, rt) {
                            return t(this, void 0, void 0, function*() {
                                return yield Yd.syncState(rt, this.self.importScripts);
                            });
                        }
                        _getAvailableImages(Qe) {
                            let rt = this.availableImages[Qe];
                            return rt || (rt = []), rt;
                        }
                        _getLayerIndex(Qe) {
                            let rt = this.layerIndexes[Qe];
                            return rt || (rt = this.layerIndexes[Qe] = new ic), rt;
                        }
                        _getWorkerSource(Qe, rt, Wn) {
                            if (this.workerSources[Qe] || (this.workerSources[Qe] = {}), this.workerSources[Qe][rt] || (this.workerSources[Qe][rt] = {}), !this.workerSources[Qe][rt][Wn]) {
                                const Co = {
                                    sendAsync: (rt, Wn)=>(rt.targetMapId = Qe, this.actor.sendAsync(rt, Wn))
                                };
                                switch(rt){
                                    case "vector":
                                        this.workerSources[Qe][rt][Wn] = new sh(Co, this._getLayerIndex(Qe), this._getAvailableImages(Qe));
                                        break;
                                    case "geojson":
                                        this.workerSources[Qe][rt][Wn] = new yp(Co, this._getLayerIndex(Qe), this._getAvailableImages(Qe));
                                        break;
                                    default:
                                        this.workerSources[Qe][rt][Wn] = new this.externalWorkerSourceTypes[rt](Co, this._getLayerIndex(Qe), this._getAvailableImages(Qe));
                                }
                            }
                            return this.workerSources[Qe][rt][Wn];
                        }
                        _getDEMWorkerSource(Qe, rt) {
                            return this.demWorkerSources[Qe] || (this.demWorkerSources[Qe] = {}), this.demWorkerSources[Qe][rt] || (this.demWorkerSources[Qe][rt] = new ah), this.demWorkerSources[Qe][rt];
                        }
                    }
                    S(self) && (self.worker = new mp(self));
                }();
            },
            927: function(Qe) {
                /**
 * MapLibre GL JS
 * @license 3-Clause BSD. Full text of license: https://github.com/maplibre/maplibre-gl-js/blob/v5.3.0/LICENSE.txt
 */ Qe.exports = function() {
                    "use strict";
                    var Qe = {}, rt = {};
                    function define(Wn, Co, Dl) {
                        if (rt[Wn] = Dl, "index" === Wn) {
                            var Ll = "var sharedModule = {}; (" + rt.shared + ")(sharedModule); (" + rt.worker + ")(sharedModule);", Rl = {};
                            return rt.shared(Rl), rt.index(Qe, Rl), "undefined" !== typeof window && Qe.setWorkerUrl(window.URL.createObjectURL(new Blob([
                                Ll
                            ], {
                                type: "text/javascript"
                            }))), Qe;
                        }
                    }
                    return define("shared", [
                        "exports"
                    ], function(Qe) {
                        function e(Qe, rt, Wn, Co) {
                            return new (Wn || (Wn = Promise))(function(Dl, Ll) {
                                function a(Qe) {
                                    try {
                                        l(Co.next(Qe));
                                    } catch (Qe) {
                                        Ll(Qe);
                                    }
                                }
                                function o(Qe) {
                                    try {
                                        l(Co.throw(Qe));
                                    } catch (Qe) {
                                        Ll(Qe);
                                    }
                                }
                                function l(Qe) {
                                    var rt;
                                    Qe.done ? Dl(Qe.value) : (rt = Qe.value, rt instanceof Wn ? rt : new Wn(function(Qe) {
                                        Qe(rt);
                                    })).then(a, o);
                                }
                                l((Co = Co.apply(Qe, rt || [])).next());
                            });
                        }
                        function r(Qe) {
                            return Qe && Qe.__esModule && Object.prototype.hasOwnProperty.call(Qe, "default") ? Qe.default : Qe;
                        }
                        var rt, Wn;
                        function s() {
                            if (Wn) return rt;
                            function t(Qe, rt) {
                                this.x = Qe, this.y = rt;
                            }
                            return Wn = 1, rt = t, t.prototype = {
                                clone: function() {
                                    return new t(this.x, this.y);
                                },
                                add: function(Qe) {
                                    return this.clone()._add(Qe);
                                },
                                sub: function(Qe) {
                                    return this.clone()._sub(Qe);
                                },
                                multByPoint: function(Qe) {
                                    return this.clone()._multByPoint(Qe);
                                },
                                divByPoint: function(Qe) {
                                    return this.clone()._divByPoint(Qe);
                                },
                                mult: function(Qe) {
                                    return this.clone()._mult(Qe);
                                },
                                div: function(Qe) {
                                    return this.clone()._div(Qe);
                                },
                                rotate: function(Qe) {
                                    return this.clone()._rotate(Qe);
                                },
                                rotateAround: function(Qe, rt) {
                                    return this.clone()._rotateAround(Qe, rt);
                                },
                                matMult: function(Qe) {
                                    return this.clone()._matMult(Qe);
                                },
                                unit: function() {
                                    return this.clone()._unit();
                                },
                                perp: function() {
                                    return this.clone()._perp();
                                },
                                round: function() {
                                    return this.clone()._round();
                                },
                                mag: function() {
                                    return Math.sqrt(this.x * this.x + this.y * this.y);
                                },
                                equals: function(Qe) {
                                    return this.x === Qe.x && this.y === Qe.y;
                                },
                                dist: function(Qe) {
                                    return Math.sqrt(this.distSqr(Qe));
                                },
                                distSqr: function(Qe) {
                                    var rt = Qe.x - this.x, Wn = Qe.y - this.y;
                                    return rt * rt + Wn * Wn;
                                },
                                angle: function() {
                                    return Math.atan2(this.y, this.x);
                                },
                                angleTo: function(Qe) {
                                    return Math.atan2(this.y - Qe.y, this.x - Qe.x);
                                },
                                angleWith: function(Qe) {
                                    return this.angleWithSep(Qe.x, Qe.y);
                                },
                                angleWithSep: function(Qe, rt) {
                                    return Math.atan2(this.x * rt - this.y * Qe, this.x * Qe + this.y * rt);
                                },
                                _matMult: function(Qe) {
                                    var rt = Qe[2] * this.x + Qe[3] * this.y;
                                    return this.x = Qe[0] * this.x + Qe[1] * this.y, this.y = rt, this;
                                },
                                _add: function(Qe) {
                                    return this.x += Qe.x, this.y += Qe.y, this;
                                },
                                _sub: function(Qe) {
                                    return this.x -= Qe.x, this.y -= Qe.y, this;
                                },
                                _mult: function(Qe) {
                                    return this.x *= Qe, this.y *= Qe, this;
                                },
                                _div: function(Qe) {
                                    return this.x /= Qe, this.y /= Qe, this;
                                },
                                _multByPoint: function(Qe) {
                                    return this.x *= Qe.x, this.y *= Qe.y, this;
                                },
                                _divByPoint: function(Qe) {
                                    return this.x /= Qe.x, this.y /= Qe.y, this;
                                },
                                _unit: function() {
                                    return this._div(this.mag()), this;
                                },
                                _perp: function() {
                                    var Qe = this.y;
                                    return this.y = this.x, this.x = -Qe, this;
                                },
                                _rotate: function(Qe) {
                                    var rt = Math.cos(Qe), Wn = Math.sin(Qe), Co = Wn * this.x + rt * this.y;
                                    return this.x = rt * this.x - Wn * this.y, this.y = Co, this;
                                },
                                _rotateAround: function(Qe, rt) {
                                    var Wn = Math.cos(Qe), Co = Math.sin(Qe), Dl = rt.y + Co * (this.x - rt.x) + Wn * (this.y - rt.y);
                                    return this.x = rt.x + Wn * (this.x - rt.x) - Co * (this.y - rt.y), this.y = Dl, this;
                                },
                                _round: function() {
                                    return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
                                }
                            }, t.convert = function(Qe) {
                                return Qe instanceof t ? Qe : Array.isArray(Qe) ? new t(Qe[0], Qe[1]) : Qe;
                            }, rt;
                        }
                        "function" == typeof SuppressedError && SuppressedError;
                        var Co, Dl, Ll = r(s()), Rl = function() {
                            if (Dl) return Co;
                            function t(Qe, rt, Wn, Co) {
                                this.cx = 3 * Qe, this.bx = 3 * (Wn - Qe) - this.cx, this.ax = 1 - this.cx - this.bx, this.cy = 3 * rt, this.by = 3 * (Co - rt) - this.cy, this.ay = 1 - this.cy - this.by, this.p1x = Qe, this.p1y = rt, this.p2x = Wn, this.p2y = Co;
                            }
                            return Dl = 1, Co = t, t.prototype = {
                                sampleCurveX: function(Qe) {
                                    return ((this.ax * Qe + this.bx) * Qe + this.cx) * Qe;
                                },
                                sampleCurveY: function(Qe) {
                                    return ((this.ay * Qe + this.by) * Qe + this.cy) * Qe;
                                },
                                sampleCurveDerivativeX: function(Qe) {
                                    return (3 * this.ax * Qe + 2 * this.bx) * Qe + this.cx;
                                },
                                solveCurveX: function(Qe, rt) {
                                    if (void 0 === rt && (rt = 1e-6), Qe < 0) return 0;
                                    if (Qe > 1) return 1;
                                    for(var Wn = Qe, Co = 0; Co < 8; Co++){
                                        var Dl = this.sampleCurveX(Wn) - Qe;
                                        if (Math.abs(Dl) < rt) return Wn;
                                        var Ll = this.sampleCurveDerivativeX(Wn);
                                        if (Math.abs(Ll) < 1e-6) break;
                                        Wn -= Dl / Ll;
                                    }
                                    var Rl = 0, Ul = 1;
                                    for(Wn = Qe, Co = 0; Co < 20 && (Dl = this.sampleCurveX(Wn), !(Math.abs(Dl - Qe) < rt)); Co++)Qe > Dl ? Rl = Wn : Ul = Wn, Wn = .5 * (Ul - Rl) + Rl;
                                    return Wn;
                                },
                                solve: function(Qe, rt) {
                                    return this.sampleCurveY(this.solveCurveX(Qe, rt));
                                }
                            }, Co;
                        }(), Ul = r(Rl);
                        let Gl, Zl;
                        function f() {
                            return null == Gl && (Gl = "undefined" != typeof OffscreenCanvas && new OffscreenCanvas(1, 1).getContext("2d") && "function" == typeof createImageBitmap), Gl;
                        }
                        function d() {
                            if (null == Zl && (Zl = !1, f())) {
                                const Qe = 5, rt = new OffscreenCanvas(Qe, Qe).getContext("2d", {
                                    willReadFrequently: !0
                                });
                                if (rt) {
                                    for(let Co = 0; Co < Qe * Qe; Co++){
                                        const Wn = 4 * Co;
                                        rt.fillStyle = `rgb(${Wn},${Wn + 1},${Wn + 2})`, rt.fillRect(Co % Qe, Math.floor(Co / Qe), 1, 1);
                                    }
                                    const Wn = rt.getImageData(0, 0, Qe, Qe).data;
                                    for(let rt = 0; rt < Qe * Qe * 4; rt++)if (rt % 4 != 3 && Wn[rt] !== rt) {
                                        Zl = !0;
                                        break;
                                    }
                                }
                            }
                            return Zl || !1;
                        }
                        var Hl, ql = 1e-6, Ql = "undefined" != typeof Float32Array ? Float32Array : Array;
                        function x() {
                            var Qe = new Ql(9);
                            return Ql != Float32Array && (Qe[1] = 0, Qe[2] = 0, Qe[3] = 0, Qe[5] = 0, Qe[6] = 0, Qe[7] = 0), Qe[0] = 1, Qe[4] = 1, Qe[8] = 1, Qe;
                        }
                        function v(Qe) {
                            return Qe[0] = 1, Qe[1] = 0, Qe[2] = 0, Qe[3] = 0, Qe[4] = 0, Qe[5] = 1, Qe[6] = 0, Qe[7] = 0, Qe[8] = 0, Qe[9] = 0, Qe[10] = 1, Qe[11] = 0, Qe[12] = 0, Qe[13] = 0, Qe[14] = 0, Qe[15] = 1, Qe;
                        }
                        function b() {
                            var Qe = new Ql(3);
                            return Ql != Float32Array && (Qe[0] = 0, Qe[1] = 0, Qe[2] = 0), Qe;
                        }
                        function w(Qe, rt, Wn) {
                            var Co = new Ql(3);
                            return Co[0] = Qe, Co[1] = rt, Co[2] = Wn, Co;
                        }
                        function _(Qe, rt, Wn) {
                            var Co = rt[0], Dl = rt[1], Ll = rt[2], Rl = rt[3];
                            return Qe[0] = Wn[0] * Co + Wn[4] * Dl + Wn[8] * Ll + Wn[12] * Rl, Qe[1] = Wn[1] * Co + Wn[5] * Dl + Wn[9] * Ll + Wn[13] * Rl, Qe[2] = Wn[2] * Co + Wn[6] * Dl + Wn[10] * Ll + Wn[14] * Rl, Qe[3] = Wn[3] * Co + Wn[7] * Dl + Wn[11] * Ll + Wn[15] * Rl, Qe;
                        }
                        function S() {
                            var Qe = new Ql(4);
                            return Ql != Float32Array && (Qe[0] = 0, Qe[1] = 0, Qe[2] = 0), Qe[3] = 1, Qe;
                        }
                        function A() {
                            var Qe = new Ql(2);
                            return Ql != Float32Array && (Qe[0] = 0, Qe[1] = 0), Qe;
                        }
                        function k(Qe, rt) {
                            var Wn = new Ql(2);
                            return Wn[0] = Qe, Wn[1] = rt, Wn;
                        }
                        Math.hypot || (Math.hypot = function() {
                            for(var Qe = 0, rt = arguments.length; rt--;)Qe += arguments[rt] * arguments[rt];
                            return Math.sqrt(Qe);
                        }), b(), Hl = new Ql(4), Ql != Float32Array && (Hl[0] = 0, Hl[1] = 0, Hl[2] = 0, Hl[3] = 0), b(), w(1, 0, 0), w(0, 1, 0), S(), S(), x(), A();
                        const Kl = 8192;
                        function I(Qe, rt, Wn) {
                            return rt * (Kl / (Qe.tileSize * Math.pow(2, Wn - Qe.tileID.overscaledZ)));
                        }
                        function z(Qe, rt) {
                            return (Qe % rt + rt) % rt;
                        }
                        function P(Qe, rt, Wn) {
                            return Qe * (1 - Wn) + rt * Wn;
                        }
                        function C(Qe) {
                            if (Qe <= 0) return 0;
                            if (Qe >= 1) return 1;
                            const rt = Qe * Qe, Wn = rt * Qe;
                            return 4 * (Qe < .5 ? Wn : 3 * (Qe - rt) + Wn - .75);
                        }
                        function B(Qe, rt, Wn, Co) {
                            const Dl = new Ul(Qe, rt, Wn, Co);
                            return (Qe)=>Dl.solve(Qe);
                        }
                        const $l = B(.25, .1, .25, 1);
                        function E(Qe, rt, Wn) {
                            return Math.min(Wn, Math.max(rt, Qe));
                        }
                        function T(Qe, rt, Wn) {
                            const Co = Wn - rt, Dl = ((Qe - rt) % Co + Co) % Co + rt;
                            return Dl === rt ? Wn : Dl;
                        }
                        function F(Qe, ...rt) {
                            for (const Wn of rt)for(const rt in Wn)Qe[rt] = Wn[rt];
                            return Qe;
                        }
                        let Tc = 1;
                        function L1(Qe, rt, Wn) {
                            const Co = {};
                            for(const Dl in Qe)Co[Dl] = rt.call(this, Qe[Dl], Dl, Qe);
                            return Co;
                        }
                        function O(Qe, rt, Wn) {
                            const Co = {};
                            for(const Dl in Qe)rt.call(this, Qe[Dl], Dl, Qe) && (Co[Dl] = Qe[Dl]);
                            return Co;
                        }
                        function D(Qe) {
                            return Array.isArray(Qe) ? Qe.map(D) : "object" == typeof Qe && Qe ? L1(Qe, D) : Qe;
                        }
                        const tu = {};
                        function j(Qe) {
                            tu[Qe] || ("undefined" != typeof console && console.warn(Qe), tu[Qe] = !0);
                        }
                        function N(Qe, rt, Wn) {
                            return (Wn.y - Qe.y) * (rt.x - Qe.x) > (rt.y - Qe.y) * (Wn.x - Qe.x);
                        }
                        function U(Qe) {
                            return "undefined" != typeof WorkerGlobalScope && void 0 !== Qe && Qe instanceof WorkerGlobalScope;
                        }
                        let lu = null;
                        function G(Qe) {
                            return "undefined" != typeof ImageBitmap && Qe instanceof ImageBitmap;
                        }
                        const du = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAC0lEQVQYV2NgAAIAAAUAAarVyFEAAAAASUVORK5CYII=";
                        function K(Qe, rt, Wn, Co, Dl) {
                            return e(this, void 0, void 0, function*() {
                                if ("undefined" == typeof VideoFrame) throw new Error("VideoFrame not supported");
                                const Ll = new VideoFrame(Qe, {
                                    timestamp: 0
                                });
                                try {
                                    const Rl = null == Ll ? void 0 : Ll.format;
                                    if (!Rl || !Rl.startsWith("BGR") && !Rl.startsWith("RGB")) throw new Error(`Unrecognized format ${Rl}`);
                                    const Ul = Rl.startsWith("BGR"), Gl = new Uint8ClampedArray(Co * Dl * 4);
                                    if (yield Ll.copyTo(Gl, function(Qe, rt, Wn, Co, Dl) {
                                        const Ll = 4 * Math.max(1, 0), Rl = (Math.max(0, Wn) - Wn) * Co * 4 + Ll, Ul = 4 * Co, Gl = Math.max(0, rt), Zl = Math.max(0, Wn);
                                        return {
                                            rect: {
                                                x: Gl,
                                                y: Zl,
                                                width: Math.min(Qe.width, rt + Co) - Gl,
                                                height: Math.min(Qe.height, Wn + Dl) - Zl
                                            },
                                            layout: [
                                                {
                                                    offset: Rl,
                                                    stride: Ul
                                                }
                                            ]
                                        };
                                    }(Qe, rt, Wn, Co, Dl)), Ul) for(let Qe = 0; Qe < Gl.length; Qe += 4){
                                        const rt = Gl[Qe];
                                        Gl[Qe] = Gl[Qe + 2], Gl[Qe + 2] = rt;
                                    }
                                    return Gl;
                                } finally{
                                    Ll.close();
                                }
                            });
                        }
                        let fu, yu;
                        function Y(Qe, rt, Wn, Co) {
                            return Qe.addEventListener(rt, Wn, Co), {
                                unsubscribe: ()=>{
                                    Qe.removeEventListener(rt, Wn, Co);
                                }
                            };
                        }
                        function J(Qe) {
                            return Qe / Math.PI * 180;
                        }
                        const Eu = {
                            touchstart: !0,
                            touchmove: !0,
                            touchmoveWindow: !0,
                            touchend: !0,
                            touchcancel: !0
                        }, Tu = {
                            dblclick: !0,
                            click: !0,
                            mouseover: !0,
                            mouseout: !0,
                            mousedown: !0,
                            mousemove: !0,
                            mousemoveWindow: !0,
                            mouseup: !0,
                            mouseupWindow: !0,
                            contextmenu: !0,
                            wheel: !0
                        }, Lu = "AbortError";
                        function et() {
                            return new Error(Lu);
                        }
                        const Zu = {
                            MAX_PARALLEL_IMAGE_REQUESTS: 16,
                            MAX_PARALLEL_IMAGE_REQUESTS_PER_FRAME: 8,
                            MAX_TILE_CACHE_ZOOM_LEVELS: 5,
                            REGISTERED_PROTOCOLS: {},
                            WORKER_URL: ""
                        };
                        function nt(Qe) {
                            return Zu.REGISTERED_PROTOCOLS[Qe.substring(0, Qe.indexOf("://"))];
                        }
                        const Xu = "global-dispatcher";
                        class st extends Error {
                            constructor(Qe, rt, Wn, Co){
                                super(`AJAXError: ${rt} (${Qe}): ${Wn}`), this.status = Qe, this.statusText = rt, this.url = Wn, this.body = Co;
                            }
                        }
                        const at = ()=>U(self) ? self.worker && self.worker.referrer : ("blob:" === window.location.protocol ? window.parent : window).location.href, ot = function(Qe, rt) {
                            if (/:\/\//.test(Qe.url) && !/^https?:|^file:/.test(Qe.url)) {
                                const Wn = nt(Qe.url);
                                if (Wn) return Wn(Qe, rt);
                                if (U(self) && self.worker && self.worker.actor) return self.worker.actor.sendAsync({
                                    type: "GR",
                                    data: Qe,
                                    targetMapId: Xu
                                }, rt);
                            }
                            if (!(/^file:/.test(Wn = Qe.url) || /^file:/.test(at()) && !/^\w+:/.test(Wn))) {
                                if (fetch && Request && AbortController && Object.prototype.hasOwnProperty.call(Request.prototype, "signal")) return function(Qe, rt) {
                                    return e(this, void 0, void 0, function*() {
                                        const Wn = new Request(Qe.url, {
                                            method: Qe.method || "GET",
                                            body: Qe.body,
                                            credentials: Qe.credentials,
                                            headers: Qe.headers,
                                            cache: Qe.cache,
                                            referrer: at(),
                                            signal: rt.signal
                                        });
                                        let Co, Dl;
                                        "json" !== Qe.type || Wn.headers.has("Accept") || Wn.headers.set("Accept", "application/json");
                                        try {
                                            Co = yield fetch(Wn);
                                        } catch (Wn) {
                                            throw new st(0, Wn.message, Qe.url, new Blob);
                                        }
                                        if (!Co.ok) {
                                            const rt = yield Co.blob();
                                            throw new st(Co.status, Co.statusText, Qe.url, rt);
                                        }
                                        Dl = "arrayBuffer" === Qe.type || "image" === Qe.type ? Co.arrayBuffer() : "json" === Qe.type ? Co.json() : Co.text();
                                        const Ll = yield Dl;
                                        if (rt.signal.aborted) throw et();
                                        return {
                                            data: Ll,
                                            cacheControl: Co.headers.get("Cache-Control"),
                                            expires: Co.headers.get("Expires")
                                        };
                                    });
                                }(Qe, rt);
                                if (U(self) && self.worker && self.worker.actor) return self.worker.actor.sendAsync({
                                    type: "GR",
                                    data: Qe,
                                    mustQueue: !0,
                                    targetMapId: Xu
                                }, rt);
                            }
                            var Wn;
                            return function(Qe, rt) {
                                return new Promise((Wn, Co)=>{
                                    var Dl;
                                    const Ll = new XMLHttpRequest;
                                    Ll.open(Qe.method || "GET", Qe.url, !0), "arrayBuffer" !== Qe.type && "image" !== Qe.type || (Ll.responseType = "arraybuffer");
                                    for(const rt in Qe.headers)Ll.setRequestHeader(rt, Qe.headers[rt]);
                                    "json" === Qe.type && (Ll.responseType = "text", (null === (Dl = Qe.headers) || void 0 === Dl ? void 0 : Dl.Accept) || Ll.setRequestHeader("Accept", "application/json")), Ll.withCredentials = "include" === Qe.credentials, Ll.onerror = ()=>{
                                        Co(new Error(Ll.statusText));
                                    }, Ll.onload = ()=>{
                                        if (!rt.signal.aborted) {
                                            if ((Ll.status >= 200 && Ll.status < 300 || 0 === Ll.status) && null !== Ll.response) {
                                                let rt = Ll.response;
                                                if ("json" === Qe.type) try {
                                                    rt = JSON.parse(Ll.response);
                                                } catch (Qe) {
                                                    return void Co(Qe);
                                                }
                                                Wn({
                                                    data: rt,
                                                    cacheControl: Ll.getResponseHeader("Cache-Control"),
                                                    expires: Ll.getResponseHeader("Expires")
                                                });
                                            } else {
                                                const rt = new Blob([
                                                    Ll.response
                                                ], {
                                                    type: Ll.getResponseHeader("Content-Type")
                                                });
                                                Co(new st(Ll.status, Ll.statusText, Qe.url, rt));
                                            }
                                        }
                                    }, rt.signal.addEventListener("abort", ()=>{
                                        Ll.abort(), Co(et());
                                    }), Ll.send(Qe.body);
                                });
                            }(Qe, rt);
                        };
                        function lt(Qe) {
                            if (!Qe || Qe.indexOf("://") <= 0 || 0 === Qe.indexOf("data:image/") || 0 === Qe.indexOf("blob:")) return !0;
                            const rt = new URL(Qe), Wn = window.location;
                            return rt.protocol === Wn.protocol && rt.host === Wn.host;
                        }
                        function ut(Qe, rt, Wn) {
                            Wn[Qe] && -1 !== Wn[Qe].indexOf(rt) || (Wn[Qe] = Wn[Qe] || [], Wn[Qe].push(rt));
                        }
                        function ct(Qe, rt, Wn) {
                            if (Wn && Wn[Qe]) {
                                const Co = Wn[Qe].indexOf(rt);
                                -1 !== Co && Wn[Qe].splice(Co, 1);
                            }
                        }
                        class ht {
                            constructor(Qe, rt = {}){
                                F(this, rt), this.type = Qe;
                            }
                        }
                        class pt extends ht {
                            constructor(Qe, rt = {}){
                                super("error", F({
                                    error: Qe
                                }, rt));
                            }
                        }
                        class ft {
                            on(Qe, rt) {
                                return this._listeners = this._listeners || {}, ut(Qe, rt, this._listeners), {
                                    unsubscribe: ()=>{
                                        this.off(Qe, rt);
                                    }
                                };
                            }
                            off(Qe, rt) {
                                return ct(Qe, rt, this._listeners), ct(Qe, rt, this._oneTimeListeners), this;
                            }
                            once(Qe, rt) {
                                return rt ? (this._oneTimeListeners = this._oneTimeListeners || {}, ut(Qe, rt, this._oneTimeListeners), this) : new Promise((rt)=>this.once(Qe, rt));
                            }
                            fire(Qe, rt) {
                                "string" == typeof Qe && (Qe = new ht(Qe, rt || {}));
                                const Wn = Qe.type;
                                if (this.listens(Wn)) {
                                    Qe.target = this;
                                    const rt = this._listeners && this._listeners[Wn] ? this._listeners[Wn].slice() : [];
                                    for (const Wn of rt)Wn.call(this, Qe);
                                    const Co = this._oneTimeListeners && this._oneTimeListeners[Wn] ? this._oneTimeListeners[Wn].slice() : [];
                                    for (const Ll of Co)ct(Wn, Ll, this._oneTimeListeners), Ll.call(this, Qe);
                                    const Dl = this._eventedParent;
                                    Dl && (F(Qe, "function" == typeof this._eventedParentData ? this._eventedParentData() : this._eventedParentData), Dl.fire(Qe));
                                } else Qe instanceof pt && console.error(Qe.error);
                                return this;
                            }
                            listens(Qe) {
                                return this._listeners && this._listeners[Qe] && this._listeners[Qe].length > 0 || this._oneTimeListeners && this._oneTimeListeners[Qe] && this._oneTimeListeners[Qe].length > 0 || this._eventedParent && this._eventedParent.listens(Qe);
                            }
                            setEventedParent(Qe, rt) {
                                return this._eventedParent = Qe, this._eventedParentData = rt, this;
                            }
                        }
                        var Ju = {
                            $version: 8,
                            $root: {
                                version: {
                                    required: !0,
                                    type: "enum",
                                    values: [
                                        8
                                    ]
                                },
                                name: {
                                    type: "string"
                                },
                                metadata: {
                                    type: "*"
                                },
                                center: {
                                    type: "array",
                                    value: "number"
                                },
                                centerAltitude: {
                                    type: "number"
                                },
                                zoom: {
                                    type: "number"
                                },
                                bearing: {
                                    type: "number",
                                    default: 0,
                                    period: 360,
                                    units: "degrees"
                                },
                                pitch: {
                                    type: "number",
                                    default: 0,
                                    units: "degrees"
                                },
                                roll: {
                                    type: "number",
                                    default: 0,
                                    units: "degrees"
                                },
                                light: {
                                    type: "light"
                                },
                                sky: {
                                    type: "sky"
                                },
                                projection: {
                                    type: "projection"
                                },
                                terrain: {
                                    type: "terrain"
                                },
                                sources: {
                                    required: !0,
                                    type: "sources"
                                },
                                sprite: {
                                    type: "sprite"
                                },
                                glyphs: {
                                    type: "string"
                                },
                                transition: {
                                    type: "transition"
                                },
                                layers: {
                                    required: !0,
                                    type: "array",
                                    value: "layer"
                                }
                            },
                            sources: {
                                "*": {
                                    type: "source"
                                }
                            },
                            source: [
                                "source_vector",
                                "source_raster",
                                "source_raster_dem",
                                "source_geojson",
                                "source_video",
                                "source_image"
                            ],
                            source_vector: {
                                type: {
                                    required: !0,
                                    type: "enum",
                                    values: {
                                        vector: {}
                                    }
                                },
                                url: {
                                    type: "string"
                                },
                                tiles: {
                                    type: "array",
                                    value: "string"
                                },
                                bounds: {
                                    type: "array",
                                    value: "number",
                                    length: 4,
                                    default: [
                                        -180,
                                        -85.051129,
                                        180,
                                        85.051129
                                    ]
                                },
                                scheme: {
                                    type: "enum",
                                    values: {
                                        xyz: {},
                                        tms: {}
                                    },
                                    default: "xyz"
                                },
                                minzoom: {
                                    type: "number",
                                    default: 0
                                },
                                maxzoom: {
                                    type: "number",
                                    default: 22
                                },
                                attribution: {
                                    type: "string"
                                },
                                promoteId: {
                                    type: "promoteId"
                                },
                                volatile: {
                                    type: "boolean",
                                    default: !1
                                },
                                "*": {
                                    type: "*"
                                }
                            },
                            source_raster: {
                                type: {
                                    required: !0,
                                    type: "enum",
                                    values: {
                                        raster: {}
                                    }
                                },
                                url: {
                                    type: "string"
                                },
                                tiles: {
                                    type: "array",
                                    value: "string"
                                },
                                bounds: {
                                    type: "array",
                                    value: "number",
                                    length: 4,
                                    default: [
                                        -180,
                                        -85.051129,
                                        180,
                                        85.051129
                                    ]
                                },
                                minzoom: {
                                    type: "number",
                                    default: 0
                                },
                                maxzoom: {
                                    type: "number",
                                    default: 22
                                },
                                tileSize: {
                                    type: "number",
                                    default: 512,
                                    units: "pixels"
                                },
                                scheme: {
                                    type: "enum",
                                    values: {
                                        xyz: {},
                                        tms: {}
                                    },
                                    default: "xyz"
                                },
                                attribution: {
                                    type: "string"
                                },
                                volatile: {
                                    type: "boolean",
                                    default: !1
                                },
                                "*": {
                                    type: "*"
                                }
                            },
                            source_raster_dem: {
                                type: {
                                    required: !0,
                                    type: "enum",
                                    values: {
                                        "raster-dem": {}
                                    }
                                },
                                url: {
                                    type: "string"
                                },
                                tiles: {
                                    type: "array",
                                    value: "string"
                                },
                                bounds: {
                                    type: "array",
                                    value: "number",
                                    length: 4,
                                    default: [
                                        -180,
                                        -85.051129,
                                        180,
                                        85.051129
                                    ]
                                },
                                minzoom: {
                                    type: "number",
                                    default: 0
                                },
                                maxzoom: {
                                    type: "number",
                                    default: 22
                                },
                                tileSize: {
                                    type: "number",
                                    default: 512,
                                    units: "pixels"
                                },
                                attribution: {
                                    type: "string"
                                },
                                encoding: {
                                    type: "enum",
                                    values: {
                                        terrarium: {},
                                        mapbox: {},
                                        custom: {}
                                    },
                                    default: "mapbox"
                                },
                                redFactor: {
                                    type: "number",
                                    default: 1
                                },
                                blueFactor: {
                                    type: "number",
                                    default: 1
                                },
                                greenFactor: {
                                    type: "number",
                                    default: 1
                                },
                                baseShift: {
                                    type: "number",
                                    default: 0
                                },
                                volatile: {
                                    type: "boolean",
                                    default: !1
                                },
                                "*": {
                                    type: "*"
                                }
                            },
                            source_geojson: {
                                type: {
                                    required: !0,
                                    type: "enum",
                                    values: {
                                        geojson: {}
                                    }
                                },
                                data: {
                                    required: !0,
                                    type: "*"
                                },
                                maxzoom: {
                                    type: "number",
                                    default: 18
                                },
                                attribution: {
                                    type: "string"
                                },
                                buffer: {
                                    type: "number",
                                    default: 128,
                                    maximum: 512,
                                    minimum: 0
                                },
                                filter: {
                                    type: "*"
                                },
                                tolerance: {
                                    type: "number",
                                    default: .375
                                },
                                cluster: {
                                    type: "boolean",
                                    default: !1
                                },
                                clusterRadius: {
                                    type: "number",
                                    default: 50,
                                    minimum: 0
                                },
                                clusterMaxZoom: {
                                    type: "number"
                                },
                                clusterMinPoints: {
                                    type: "number"
                                },
                                clusterProperties: {
                                    type: "*"
                                },
                                lineMetrics: {
                                    type: "boolean",
                                    default: !1
                                },
                                generateId: {
                                    type: "boolean",
                                    default: !1
                                },
                                promoteId: {
                                    type: "promoteId"
                                }
                            },
                            source_video: {
                                type: {
                                    required: !0,
                                    type: "enum",
                                    values: {
                                        video: {}
                                    }
                                },
                                urls: {
                                    required: !0,
                                    type: "array",
                                    value: "string"
                                },
                                coordinates: {
                                    required: !0,
                                    type: "array",
                                    length: 4,
                                    value: {
                                        type: "array",
                                        length: 2,
                                        value: "number"
                                    }
                                }
                            },
                            source_image: {
                                type: {
                                    required: !0,
                                    type: "enum",
                                    values: {
                                        image: {}
                                    }
                                },
                                url: {
                                    required: !0,
                                    type: "string"
                                },
                                coordinates: {
                                    required: !0,
                                    type: "array",
                                    length: 4,
                                    value: {
                                        type: "array",
                                        length: 2,
                                        value: "number"
                                    }
                                }
                            },
                            layer: {
                                id: {
                                    type: "string",
                                    required: !0
                                },
                                type: {
                                    type: "enum",
                                    values: {
                                        fill: {},
                                        line: {},
                                        symbol: {},
                                        circle: {},
                                        heatmap: {},
                                        "fill-extrusion": {},
                                        raster: {},
                                        hillshade: {},
                                        background: {}
                                    },
                                    required: !0
                                },
                                metadata: {
                                    type: "*"
                                },
                                source: {
                                    type: "string"
                                },
                                "source-layer": {
                                    type: "string"
                                },
                                minzoom: {
                                    type: "number",
                                    minimum: 0,
                                    maximum: 24
                                },
                                maxzoom: {
                                    type: "number",
                                    minimum: 0,
                                    maximum: 24
                                },
                                filter: {
                                    type: "filter"
                                },
                                layout: {
                                    type: "layout"
                                },
                                paint: {
                                    type: "paint"
                                }
                            },
                            layout: [
                                "layout_fill",
                                "layout_line",
                                "layout_circle",
                                "layout_heatmap",
                                "layout_fill-extrusion",
                                "layout_symbol",
                                "layout_raster",
                                "layout_hillshade",
                                "layout_background"
                            ],
                            layout_background: {
                                visibility: {
                                    type: "enum",
                                    values: {
                                        visible: {},
                                        none: {}
                                    },
                                    default: "visible",
                                    "property-type": "constant"
                                }
                            },
                            layout_fill: {
                                "fill-sort-key": {
                                    type: "number",
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                visibility: {
                                    type: "enum",
                                    values: {
                                        visible: {},
                                        none: {}
                                    },
                                    default: "visible",
                                    "property-type": "constant"
                                }
                            },
                            layout_circle: {
                                "circle-sort-key": {
                                    type: "number",
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                visibility: {
                                    type: "enum",
                                    values: {
                                        visible: {},
                                        none: {}
                                    },
                                    default: "visible",
                                    "property-type": "constant"
                                }
                            },
                            layout_heatmap: {
                                visibility: {
                                    type: "enum",
                                    values: {
                                        visible: {},
                                        none: {}
                                    },
                                    default: "visible",
                                    "property-type": "constant"
                                }
                            },
                            "layout_fill-extrusion": {
                                visibility: {
                                    type: "enum",
                                    values: {
                                        visible: {},
                                        none: {}
                                    },
                                    default: "visible",
                                    "property-type": "constant"
                                }
                            },
                            layout_line: {
                                "line-cap": {
                                    type: "enum",
                                    values: {
                                        butt: {},
                                        round: {},
                                        square: {}
                                    },
                                    default: "butt",
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "line-join": {
                                    type: "enum",
                                    values: {
                                        bevel: {},
                                        round: {},
                                        miter: {}
                                    },
                                    default: "miter",
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "line-miter-limit": {
                                    type: "number",
                                    default: 2,
                                    requires: [
                                        {
                                            "line-join": "miter"
                                        }
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "line-round-limit": {
                                    type: "number",
                                    default: 1.05,
                                    requires: [
                                        {
                                            "line-join": "round"
                                        }
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "line-sort-key": {
                                    type: "number",
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                visibility: {
                                    type: "enum",
                                    values: {
                                        visible: {},
                                        none: {}
                                    },
                                    default: "visible",
                                    "property-type": "constant"
                                }
                            },
                            layout_symbol: {
                                "symbol-placement": {
                                    type: "enum",
                                    values: {
                                        point: {},
                                        line: {},
                                        "line-center": {}
                                    },
                                    default: "point",
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "symbol-spacing": {
                                    type: "number",
                                    default: 250,
                                    minimum: 1,
                                    units: "pixels",
                                    requires: [
                                        {
                                            "symbol-placement": "line"
                                        }
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "symbol-avoid-edges": {
                                    type: "boolean",
                                    default: !1,
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "symbol-sort-key": {
                                    type: "number",
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "symbol-z-order": {
                                    type: "enum",
                                    values: {
                                        auto: {},
                                        "viewport-y": {},
                                        source: {}
                                    },
                                    default: "auto",
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "icon-allow-overlap": {
                                    type: "boolean",
                                    default: !1,
                                    requires: [
                                        "icon-image",
                                        {
                                            "!": "icon-overlap"
                                        }
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "icon-overlap": {
                                    type: "enum",
                                    values: {
                                        never: {},
                                        always: {},
                                        cooperative: {}
                                    },
                                    requires: [
                                        "icon-image"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "icon-ignore-placement": {
                                    type: "boolean",
                                    default: !1,
                                    requires: [
                                        "icon-image"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "icon-optional": {
                                    type: "boolean",
                                    default: !1,
                                    requires: [
                                        "icon-image",
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "icon-rotation-alignment": {
                                    type: "enum",
                                    values: {
                                        map: {},
                                        viewport: {},
                                        auto: {}
                                    },
                                    default: "auto",
                                    requires: [
                                        "icon-image"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "icon-size": {
                                    type: "number",
                                    default: 1,
                                    minimum: 0,
                                    units: "factor of the original icon size",
                                    requires: [
                                        "icon-image"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "icon-text-fit": {
                                    type: "enum",
                                    values: {
                                        none: {},
                                        width: {},
                                        height: {},
                                        both: {}
                                    },
                                    default: "none",
                                    requires: [
                                        "icon-image",
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "icon-text-fit-padding": {
                                    type: "array",
                                    value: "number",
                                    length: 4,
                                    default: [
                                        0,
                                        0,
                                        0,
                                        0
                                    ],
                                    units: "pixels",
                                    requires: [
                                        "icon-image",
                                        "text-field",
                                        {
                                            "icon-text-fit": [
                                                "both",
                                                "width",
                                                "height"
                                            ]
                                        }
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "icon-image": {
                                    type: "resolvedImage",
                                    tokens: !0,
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "icon-rotate": {
                                    type: "number",
                                    default: 0,
                                    period: 360,
                                    units: "degrees",
                                    requires: [
                                        "icon-image"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "icon-padding": {
                                    type: "padding",
                                    default: [
                                        2
                                    ],
                                    units: "pixels",
                                    requires: [
                                        "icon-image"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "icon-keep-upright": {
                                    type: "boolean",
                                    default: !1,
                                    requires: [
                                        "icon-image",
                                        {
                                            "icon-rotation-alignment": "map"
                                        },
                                        {
                                            "symbol-placement": [
                                                "line",
                                                "line-center"
                                            ]
                                        }
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "icon-offset": {
                                    type: "array",
                                    value: "number",
                                    length: 2,
                                    default: [
                                        0,
                                        0
                                    ],
                                    requires: [
                                        "icon-image"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "icon-anchor": {
                                    type: "enum",
                                    values: {
                                        center: {},
                                        left: {},
                                        right: {},
                                        top: {},
                                        bottom: {},
                                        "top-left": {},
                                        "top-right": {},
                                        "bottom-left": {},
                                        "bottom-right": {}
                                    },
                                    default: "center",
                                    requires: [
                                        "icon-image"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "icon-pitch-alignment": {
                                    type: "enum",
                                    values: {
                                        map: {},
                                        viewport: {},
                                        auto: {}
                                    },
                                    default: "auto",
                                    requires: [
                                        "icon-image"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "text-pitch-alignment": {
                                    type: "enum",
                                    values: {
                                        map: {},
                                        viewport: {},
                                        auto: {}
                                    },
                                    default: "auto",
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "text-rotation-alignment": {
                                    type: "enum",
                                    values: {
                                        map: {},
                                        viewport: {},
                                        "viewport-glyph": {},
                                        auto: {}
                                    },
                                    default: "auto",
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "text-field": {
                                    type: "formatted",
                                    default: "",
                                    tokens: !0,
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "text-font": {
                                    type: "array",
                                    value: "string",
                                    default: [
                                        "Open Sans Regular",
                                        "Arial Unicode MS Regular"
                                    ],
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "text-size": {
                                    type: "number",
                                    default: 16,
                                    minimum: 0,
                                    units: "pixels",
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "text-max-width": {
                                    type: "number",
                                    default: 10,
                                    minimum: 0,
                                    units: "ems",
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "text-line-height": {
                                    type: "number",
                                    default: 1.2,
                                    units: "ems",
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "text-letter-spacing": {
                                    type: "number",
                                    default: 0,
                                    units: "ems",
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "text-justify": {
                                    type: "enum",
                                    values: {
                                        auto: {},
                                        left: {},
                                        center: {},
                                        right: {}
                                    },
                                    default: "center",
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "text-radial-offset": {
                                    type: "number",
                                    units: "ems",
                                    default: 0,
                                    requires: [
                                        "text-field"
                                    ],
                                    "property-type": "data-driven",
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    }
                                },
                                "text-variable-anchor": {
                                    type: "array",
                                    value: "enum",
                                    values: {
                                        center: {},
                                        left: {},
                                        right: {},
                                        top: {},
                                        bottom: {},
                                        "top-left": {},
                                        "top-right": {},
                                        "bottom-left": {},
                                        "bottom-right": {}
                                    },
                                    requires: [
                                        "text-field",
                                        {
                                            "symbol-placement": [
                                                "point"
                                            ]
                                        }
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "text-variable-anchor-offset": {
                                    type: "variableAnchorOffsetCollection",
                                    requires: [
                                        "text-field",
                                        {
                                            "symbol-placement": [
                                                "point"
                                            ]
                                        }
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "text-anchor": {
                                    type: "enum",
                                    values: {
                                        center: {},
                                        left: {},
                                        right: {},
                                        top: {},
                                        bottom: {},
                                        "top-left": {},
                                        "top-right": {},
                                        "bottom-left": {},
                                        "bottom-right": {}
                                    },
                                    default: "center",
                                    requires: [
                                        "text-field",
                                        {
                                            "!": "text-variable-anchor"
                                        }
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "text-max-angle": {
                                    type: "number",
                                    default: 45,
                                    units: "degrees",
                                    requires: [
                                        "text-field",
                                        {
                                            "symbol-placement": [
                                                "line",
                                                "line-center"
                                            ]
                                        }
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "text-writing-mode": {
                                    type: "array",
                                    value: "enum",
                                    values: {
                                        horizontal: {},
                                        vertical: {}
                                    },
                                    requires: [
                                        "text-field",
                                        {
                                            "symbol-placement": [
                                                "point"
                                            ]
                                        }
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "text-rotate": {
                                    type: "number",
                                    default: 0,
                                    period: 360,
                                    units: "degrees",
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "text-padding": {
                                    type: "number",
                                    default: 2,
                                    minimum: 0,
                                    units: "pixels",
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "text-keep-upright": {
                                    type: "boolean",
                                    default: !0,
                                    requires: [
                                        "text-field",
                                        {
                                            "text-rotation-alignment": "map"
                                        },
                                        {
                                            "symbol-placement": [
                                                "line",
                                                "line-center"
                                            ]
                                        }
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "text-transform": {
                                    type: "enum",
                                    values: {
                                        none: {},
                                        uppercase: {},
                                        lowercase: {}
                                    },
                                    default: "none",
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "text-offset": {
                                    type: "array",
                                    value: "number",
                                    units: "ems",
                                    length: 2,
                                    default: [
                                        0,
                                        0
                                    ],
                                    requires: [
                                        "text-field",
                                        {
                                            "!": "text-radial-offset"
                                        }
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "text-allow-overlap": {
                                    type: "boolean",
                                    default: !1,
                                    requires: [
                                        "text-field",
                                        {
                                            "!": "text-overlap"
                                        }
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "text-overlap": {
                                    type: "enum",
                                    values: {
                                        never: {},
                                        always: {},
                                        cooperative: {}
                                    },
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "text-ignore-placement": {
                                    type: "boolean",
                                    default: !1,
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "text-optional": {
                                    type: "boolean",
                                    default: !1,
                                    requires: [
                                        "text-field",
                                        "icon-image"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                visibility: {
                                    type: "enum",
                                    values: {
                                        visible: {},
                                        none: {}
                                    },
                                    default: "visible",
                                    "property-type": "constant"
                                }
                            },
                            layout_raster: {
                                visibility: {
                                    type: "enum",
                                    values: {
                                        visible: {},
                                        none: {}
                                    },
                                    default: "visible",
                                    "property-type": "constant"
                                }
                            },
                            layout_hillshade: {
                                visibility: {
                                    type: "enum",
                                    values: {
                                        visible: {},
                                        none: {}
                                    },
                                    default: "visible",
                                    "property-type": "constant"
                                }
                            },
                            filter: {
                                type: "array",
                                value: "*"
                            },
                            filter_operator: {
                                type: "enum",
                                values: {
                                    "==": {},
                                    "!=": {},
                                    ">": {},
                                    ">=": {},
                                    "<": {},
                                    "<=": {},
                                    in: {},
                                    "!in": {},
                                    all: {},
                                    any: {},
                                    none: {},
                                    has: {},
                                    "!has": {}
                                }
                            },
                            geometry_type: {
                                type: "enum",
                                values: {
                                    Point: {},
                                    LineString: {},
                                    Polygon: {}
                                }
                            },
                            function: {
                                expression: {
                                    type: "expression"
                                },
                                stops: {
                                    type: "array",
                                    value: "function_stop"
                                },
                                base: {
                                    type: "number",
                                    default: 1,
                                    minimum: 0
                                },
                                property: {
                                    type: "string",
                                    default: "$zoom"
                                },
                                type: {
                                    type: "enum",
                                    values: {
                                        identity: {},
                                        exponential: {},
                                        interval: {},
                                        categorical: {}
                                    },
                                    default: "exponential"
                                },
                                colorSpace: {
                                    type: "enum",
                                    values: {
                                        rgb: {},
                                        lab: {},
                                        hcl: {}
                                    },
                                    default: "rgb"
                                },
                                default: {
                                    type: "*",
                                    required: !1
                                }
                            },
                            function_stop: {
                                type: "array",
                                minimum: 0,
                                maximum: 24,
                                value: [
                                    "number",
                                    "color"
                                ],
                                length: 2
                            },
                            expression: {
                                type: "array",
                                value: "*",
                                minimum: 1
                            },
                            light: {
                                anchor: {
                                    type: "enum",
                                    default: "viewport",
                                    values: {
                                        map: {},
                                        viewport: {}
                                    },
                                    "property-type": "data-constant",
                                    transition: !1,
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    }
                                },
                                position: {
                                    type: "array",
                                    default: [
                                        1.15,
                                        210,
                                        30
                                    ],
                                    length: 3,
                                    value: "number",
                                    "property-type": "data-constant",
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    }
                                },
                                color: {
                                    type: "color",
                                    "property-type": "data-constant",
                                    default: "#ffffff",
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    transition: !0
                                },
                                intensity: {
                                    type: "number",
                                    "property-type": "data-constant",
                                    default: .5,
                                    minimum: 0,
                                    maximum: 1,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    transition: !0
                                }
                            },
                            sky: {
                                "sky-color": {
                                    type: "color",
                                    "property-type": "data-constant",
                                    default: "#88C6FC",
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    transition: !0
                                },
                                "horizon-color": {
                                    type: "color",
                                    "property-type": "data-constant",
                                    default: "#ffffff",
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    transition: !0
                                },
                                "fog-color": {
                                    type: "color",
                                    "property-type": "data-constant",
                                    default: "#ffffff",
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    transition: !0
                                },
                                "fog-ground-blend": {
                                    type: "number",
                                    "property-type": "data-constant",
                                    default: .5,
                                    minimum: 0,
                                    maximum: 1,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    transition: !0
                                },
                                "horizon-fog-blend": {
                                    type: "number",
                                    "property-type": "data-constant",
                                    default: .8,
                                    minimum: 0,
                                    maximum: 1,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    transition: !0
                                },
                                "sky-horizon-blend": {
                                    type: "number",
                                    "property-type": "data-constant",
                                    default: .8,
                                    minimum: 0,
                                    maximum: 1,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    transition: !0
                                },
                                "atmosphere-blend": {
                                    type: "number",
                                    "property-type": "data-constant",
                                    default: .8,
                                    minimum: 0,
                                    maximum: 1,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    transition: !0
                                }
                            },
                            terrain: {
                                source: {
                                    type: "string",
                                    required: !0
                                },
                                exaggeration: {
                                    type: "number",
                                    minimum: 0,
                                    default: 1
                                }
                            },
                            projection: {
                                type: {
                                    type: "projectionDefinition",
                                    default: "mercator",
                                    "property-type": "data-constant",
                                    transition: !1,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    }
                                }
                            },
                            paint: [
                                "paint_fill",
                                "paint_line",
                                "paint_circle",
                                "paint_heatmap",
                                "paint_fill-extrusion",
                                "paint_symbol",
                                "paint_raster",
                                "paint_hillshade",
                                "paint_background"
                            ],
                            paint_fill: {
                                "fill-antialias": {
                                    type: "boolean",
                                    default: !0,
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "fill-opacity": {
                                    type: "number",
                                    default: 1,
                                    minimum: 0,
                                    maximum: 1,
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "fill-color": {
                                    type: "color",
                                    default: "#000000",
                                    transition: !0,
                                    requires: [
                                        {
                                            "!": "fill-pattern"
                                        }
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "fill-outline-color": {
                                    type: "color",
                                    transition: !0,
                                    requires: [
                                        {
                                            "!": "fill-pattern"
                                        },
                                        {
                                            "fill-antialias": !0
                                        }
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "fill-translate": {
                                    type: "array",
                                    value: "number",
                                    length: 2,
                                    default: [
                                        0,
                                        0
                                    ],
                                    transition: !0,
                                    units: "pixels",
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "fill-translate-anchor": {
                                    type: "enum",
                                    values: {
                                        map: {},
                                        viewport: {}
                                    },
                                    default: "map",
                                    requires: [
                                        "fill-translate"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "fill-pattern": {
                                    type: "resolvedImage",
                                    transition: !0,
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "cross-faded-data-driven"
                                }
                            },
                            "paint_fill-extrusion": {
                                "fill-extrusion-opacity": {
                                    type: "number",
                                    default: 1,
                                    minimum: 0,
                                    maximum: 1,
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "fill-extrusion-color": {
                                    type: "color",
                                    default: "#000000",
                                    transition: !0,
                                    requires: [
                                        {
                                            "!": "fill-extrusion-pattern"
                                        }
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "fill-extrusion-translate": {
                                    type: "array",
                                    value: "number",
                                    length: 2,
                                    default: [
                                        0,
                                        0
                                    ],
                                    transition: !0,
                                    units: "pixels",
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "fill-extrusion-translate-anchor": {
                                    type: "enum",
                                    values: {
                                        map: {},
                                        viewport: {}
                                    },
                                    default: "map",
                                    requires: [
                                        "fill-extrusion-translate"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "fill-extrusion-pattern": {
                                    type: "resolvedImage",
                                    transition: !0,
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "cross-faded-data-driven"
                                },
                                "fill-extrusion-height": {
                                    type: "number",
                                    default: 0,
                                    minimum: 0,
                                    units: "meters",
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "fill-extrusion-base": {
                                    type: "number",
                                    default: 0,
                                    minimum: 0,
                                    units: "meters",
                                    transition: !0,
                                    requires: [
                                        "fill-extrusion-height"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "fill-extrusion-vertical-gradient": {
                                    type: "boolean",
                                    default: !0,
                                    transition: !1,
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                }
                            },
                            paint_line: {
                                "line-opacity": {
                                    type: "number",
                                    default: 1,
                                    minimum: 0,
                                    maximum: 1,
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "line-color": {
                                    type: "color",
                                    default: "#000000",
                                    transition: !0,
                                    requires: [
                                        {
                                            "!": "line-pattern"
                                        }
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "line-translate": {
                                    type: "array",
                                    value: "number",
                                    length: 2,
                                    default: [
                                        0,
                                        0
                                    ],
                                    transition: !0,
                                    units: "pixels",
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "line-translate-anchor": {
                                    type: "enum",
                                    values: {
                                        map: {},
                                        viewport: {}
                                    },
                                    default: "map",
                                    requires: [
                                        "line-translate"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "line-width": {
                                    type: "number",
                                    default: 1,
                                    minimum: 0,
                                    transition: !0,
                                    units: "pixels",
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "line-gap-width": {
                                    type: "number",
                                    default: 0,
                                    minimum: 0,
                                    transition: !0,
                                    units: "pixels",
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "line-offset": {
                                    type: "number",
                                    default: 0,
                                    transition: !0,
                                    units: "pixels",
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "line-blur": {
                                    type: "number",
                                    default: 0,
                                    minimum: 0,
                                    transition: !0,
                                    units: "pixels",
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "line-dasharray": {
                                    type: "array",
                                    value: "number",
                                    minimum: 0,
                                    transition: !0,
                                    units: "line widths",
                                    requires: [
                                        {
                                            "!": "line-pattern"
                                        }
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "cross-faded"
                                },
                                "line-pattern": {
                                    type: "resolvedImage",
                                    transition: !0,
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "cross-faded-data-driven"
                                },
                                "line-gradient": {
                                    type: "color",
                                    transition: !1,
                                    requires: [
                                        {
                                            "!": "line-dasharray"
                                        },
                                        {
                                            "!": "line-pattern"
                                        },
                                        {
                                            source: "geojson",
                                            has: {
                                                lineMetrics: !0
                                            }
                                        }
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "line-progress"
                                        ]
                                    },
                                    "property-type": "color-ramp"
                                }
                            },
                            paint_circle: {
                                "circle-radius": {
                                    type: "number",
                                    default: 5,
                                    minimum: 0,
                                    transition: !0,
                                    units: "pixels",
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "circle-color": {
                                    type: "color",
                                    default: "#000000",
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "circle-blur": {
                                    type: "number",
                                    default: 0,
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "circle-opacity": {
                                    type: "number",
                                    default: 1,
                                    minimum: 0,
                                    maximum: 1,
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "circle-translate": {
                                    type: "array",
                                    value: "number",
                                    length: 2,
                                    default: [
                                        0,
                                        0
                                    ],
                                    transition: !0,
                                    units: "pixels",
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "circle-translate-anchor": {
                                    type: "enum",
                                    values: {
                                        map: {},
                                        viewport: {}
                                    },
                                    default: "map",
                                    requires: [
                                        "circle-translate"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "circle-pitch-scale": {
                                    type: "enum",
                                    values: {
                                        map: {},
                                        viewport: {}
                                    },
                                    default: "map",
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "circle-pitch-alignment": {
                                    type: "enum",
                                    values: {
                                        map: {},
                                        viewport: {}
                                    },
                                    default: "viewport",
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "circle-stroke-width": {
                                    type: "number",
                                    default: 0,
                                    minimum: 0,
                                    transition: !0,
                                    units: "pixels",
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "circle-stroke-color": {
                                    type: "color",
                                    default: "#000000",
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "circle-stroke-opacity": {
                                    type: "number",
                                    default: 1,
                                    minimum: 0,
                                    maximum: 1,
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                }
                            },
                            paint_heatmap: {
                                "heatmap-radius": {
                                    type: "number",
                                    default: 30,
                                    minimum: 1,
                                    transition: !0,
                                    units: "pixels",
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "heatmap-weight": {
                                    type: "number",
                                    default: 1,
                                    minimum: 0,
                                    transition: !1,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "heatmap-intensity": {
                                    type: "number",
                                    default: 1,
                                    minimum: 0,
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "heatmap-color": {
                                    type: "color",
                                    default: [
                                        "interpolate",
                                        [
                                            "linear"
                                        ],
                                        [
                                            "heatmap-density"
                                        ],
                                        0,
                                        "rgba(0, 0, 255, 0)",
                                        .1,
                                        "royalblue",
                                        .3,
                                        "cyan",
                                        .5,
                                        "lime",
                                        .7,
                                        "yellow",
                                        1,
                                        "red"
                                    ],
                                    transition: !1,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "heatmap-density"
                                        ]
                                    },
                                    "property-type": "color-ramp"
                                },
                                "heatmap-opacity": {
                                    type: "number",
                                    default: 1,
                                    minimum: 0,
                                    maximum: 1,
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                }
                            },
                            paint_symbol: {
                                "icon-opacity": {
                                    type: "number",
                                    default: 1,
                                    minimum: 0,
                                    maximum: 1,
                                    transition: !0,
                                    requires: [
                                        "icon-image"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "icon-color": {
                                    type: "color",
                                    default: "#000000",
                                    transition: !0,
                                    requires: [
                                        "icon-image"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "icon-halo-color": {
                                    type: "color",
                                    default: "rgba(0, 0, 0, 0)",
                                    transition: !0,
                                    requires: [
                                        "icon-image"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "icon-halo-width": {
                                    type: "number",
                                    default: 0,
                                    minimum: 0,
                                    transition: !0,
                                    units: "pixels",
                                    requires: [
                                        "icon-image"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "icon-halo-blur": {
                                    type: "number",
                                    default: 0,
                                    minimum: 0,
                                    transition: !0,
                                    units: "pixels",
                                    requires: [
                                        "icon-image"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "icon-translate": {
                                    type: "array",
                                    value: "number",
                                    length: 2,
                                    default: [
                                        0,
                                        0
                                    ],
                                    transition: !0,
                                    units: "pixels",
                                    requires: [
                                        "icon-image"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "icon-translate-anchor": {
                                    type: "enum",
                                    values: {
                                        map: {},
                                        viewport: {}
                                    },
                                    default: "map",
                                    requires: [
                                        "icon-image",
                                        "icon-translate"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "text-opacity": {
                                    type: "number",
                                    default: 1,
                                    minimum: 0,
                                    maximum: 1,
                                    transition: !0,
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "text-color": {
                                    type: "color",
                                    default: "#000000",
                                    transition: !0,
                                    overridable: !0,
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "text-halo-color": {
                                    type: "color",
                                    default: "rgba(0, 0, 0, 0)",
                                    transition: !0,
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "text-halo-width": {
                                    type: "number",
                                    default: 0,
                                    minimum: 0,
                                    transition: !0,
                                    units: "pixels",
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "text-halo-blur": {
                                    type: "number",
                                    default: 0,
                                    minimum: 0,
                                    transition: !0,
                                    units: "pixels",
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "text-translate": {
                                    type: "array",
                                    value: "number",
                                    length: 2,
                                    default: [
                                        0,
                                        0
                                    ],
                                    transition: !0,
                                    units: "pixels",
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "text-translate-anchor": {
                                    type: "enum",
                                    values: {
                                        map: {},
                                        viewport: {}
                                    },
                                    default: "map",
                                    requires: [
                                        "text-field",
                                        "text-translate"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                }
                            },
                            paint_raster: {
                                "raster-opacity": {
                                    type: "number",
                                    default: 1,
                                    minimum: 0,
                                    maximum: 1,
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "raster-hue-rotate": {
                                    type: "number",
                                    default: 0,
                                    period: 360,
                                    transition: !0,
                                    units: "degrees",
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "raster-brightness-min": {
                                    type: "number",
                                    default: 0,
                                    minimum: 0,
                                    maximum: 1,
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "raster-brightness-max": {
                                    type: "number",
                                    default: 1,
                                    minimum: 0,
                                    maximum: 1,
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "raster-saturation": {
                                    type: "number",
                                    default: 0,
                                    minimum: -1,
                                    maximum: 1,
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "raster-contrast": {
                                    type: "number",
                                    default: 0,
                                    minimum: -1,
                                    maximum: 1,
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "raster-resampling": {
                                    type: "enum",
                                    values: {
                                        linear: {},
                                        nearest: {}
                                    },
                                    default: "linear",
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "raster-fade-duration": {
                                    type: "number",
                                    default: 300,
                                    minimum: 0,
                                    transition: !1,
                                    units: "milliseconds",
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                }
                            },
                            paint_hillshade: {
                                "hillshade-illumination-direction": {
                                    type: "number",
                                    default: 335,
                                    minimum: 0,
                                    maximum: 359,
                                    transition: !1,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "hillshade-illumination-anchor": {
                                    type: "enum",
                                    values: {
                                        map: {},
                                        viewport: {}
                                    },
                                    default: "viewport",
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "hillshade-exaggeration": {
                                    type: "number",
                                    default: .5,
                                    minimum: 0,
                                    maximum: 1,
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "hillshade-shadow-color": {
                                    type: "color",
                                    default: "#000000",
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "hillshade-highlight-color": {
                                    type: "color",
                                    default: "#FFFFFF",
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "hillshade-accent-color": {
                                    type: "color",
                                    default: "#000000",
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                }
                            },
                            paint_background: {
                                "background-color": {
                                    type: "color",
                                    default: "#000000",
                                    transition: !0,
                                    requires: [
                                        {
                                            "!": "background-pattern"
                                        }
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "background-pattern": {
                                    type: "resolvedImage",
                                    transition: !0,
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "cross-faded"
                                },
                                "background-opacity": {
                                    type: "number",
                                    default: 1,
                                    minimum: 0,
                                    maximum: 1,
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                }
                            },
                            transition: {
                                duration: {
                                    type: "number",
                                    default: 300,
                                    minimum: 0,
                                    units: "milliseconds"
                                },
                                delay: {
                                    type: "number",
                                    default: 0,
                                    minimum: 0,
                                    units: "milliseconds"
                                }
                            },
                            "property-type": {
                                "data-driven": {
                                    type: "property-type"
                                },
                                "cross-faded": {
                                    type: "property-type"
                                },
                                "cross-faded-data-driven": {
                                    type: "property-type"
                                },
                                "color-ramp": {
                                    type: "property-type"
                                },
                                "data-constant": {
                                    type: "property-type"
                                },
                                constant: {
                                    type: "property-type"
                                }
                            },
                            promoteId: {
                                "*": {
                                    type: "string"
                                }
                            }
                        };
                        const $u = [
                            "type",
                            "source",
                            "source-layer",
                            "minzoom",
                            "maxzoom",
                            "filter",
                            "layout"
                        ];
                        function mt(Qe, rt) {
                            const Wn = {};
                            for(const Co in Qe)"ref" !== Co && (Wn[Co] = Qe[Co]);
                            return $u.forEach((Qe)=>{
                                Qe in rt && (Wn[Qe] = rt[Qe]);
                            }), Wn;
                        }
                        function gt(Qe, rt) {
                            if (Array.isArray(Qe)) {
                                if (!Array.isArray(rt) || Qe.length !== rt.length) return !1;
                                for(let Wn = 0; Wn < Qe.length; Wn++)if (!gt(Qe[Wn], rt[Wn])) return !1;
                                return !0;
                            }
                            if ("object" == typeof Qe && null !== Qe && null !== rt) {
                                if ("object" != typeof rt) return !1;
                                if (Object.keys(Qe).length !== Object.keys(rt).length) return !1;
                                for(const Wn in Qe)if (!gt(Qe[Wn], rt[Wn])) return !1;
                                return !0;
                            }
                            return Qe === rt;
                        }
                        function xt(Qe, rt) {
                            Qe.push(rt);
                        }
                        function vt(Qe, rt, Wn) {
                            xt(Wn, {
                                command: "addSource",
                                args: [
                                    Qe,
                                    rt[Qe]
                                ]
                            });
                        }
                        function bt(Qe, rt, Wn) {
                            xt(rt, {
                                command: "removeSource",
                                args: [
                                    Qe
                                ]
                            }), Wn[Qe] = !0;
                        }
                        function wt(Qe, rt, Wn, Co) {
                            bt(Qe, Wn, Co), vt(Qe, rt, Wn);
                        }
                        function _t(Qe, rt, Wn) {
                            let Co;
                            for(Co in Qe[Wn])if (Object.prototype.hasOwnProperty.call(Qe[Wn], Co) && "data" !== Co && !gt(Qe[Wn][Co], rt[Wn][Co])) return !1;
                            for(Co in rt[Wn])if (Object.prototype.hasOwnProperty.call(rt[Wn], Co) && "data" !== Co && !gt(Qe[Wn][Co], rt[Wn][Co])) return !1;
                            return !0;
                        }
                        function St(Qe, rt, Wn, Co, Dl, Ll) {
                            Qe = Qe || {}, rt = rt || {};
                            for(const Rl in Qe)Object.prototype.hasOwnProperty.call(Qe, Rl) && (gt(Qe[Rl], rt[Rl]) || Wn.push({
                                command: Ll,
                                args: [
                                    Co,
                                    Rl,
                                    rt[Rl],
                                    Dl
                                ]
                            }));
                            for(const Rl in rt)Object.prototype.hasOwnProperty.call(rt, Rl) && !Object.prototype.hasOwnProperty.call(Qe, Rl) && (gt(Qe[Rl], rt[Rl]) || Wn.push({
                                command: Ll,
                                args: [
                                    Co,
                                    Rl,
                                    rt[Rl],
                                    Dl
                                ]
                            }));
                        }
                        function At(Qe) {
                            return Qe.id;
                        }
                        function kt(Qe, rt) {
                            return Qe[rt.id] = rt, Qe;
                        }
                        class Mt {
                            constructor(Qe, rt, Wn, Co){
                                this.message = (Qe ? `${Qe}: ` : "") + Wn, Co && (this.identifier = Co), null != rt && rt.__line__ && (this.line = rt.__line__);
                            }
                        }
                        function It(Qe, ...rt) {
                            for (const Wn of rt)for(const rt in Wn)Qe[rt] = Wn[rt];
                            return Qe;
                        }
                        class zt extends Error {
                            constructor(Qe, rt){
                                super(rt), this.message = rt, this.key = Qe;
                            }
                        }
                        class Pt {
                            constructor(Qe, rt = []){
                                this.parent = Qe, this.bindings = {};
                                for (const [Wn, Co] of rt)this.bindings[Wn] = Co;
                            }
                            concat(Qe) {
                                return new Pt(this, Qe);
                            }
                            get(Qe) {
                                if (this.bindings[Qe]) return this.bindings[Qe];
                                if (this.parent) return this.parent.get(Qe);
                                throw new Error(`${Qe} not found in scope.`);
                            }
                            has(Qe) {
                                return !!this.bindings[Qe] || !!this.parent && this.parent.has(Qe);
                            }
                        }
                        const ed = {
                            kind: "null"
                        }, td = {
                            kind: "number"
                        }, id = {
                            kind: "string"
                        }, nd = {
                            kind: "boolean"
                        }, rd = {
                            kind: "color"
                        }, sd = {
                            kind: "projectionDefinition"
                        }, ad = {
                            kind: "object"
                        }, od = {
                            kind: "value"
                        }, ld = {
                            kind: "collator"
                        }, cd = {
                            kind: "formatted"
                        }, ud = {
                            kind: "padding"
                        }, hd = {
                            kind: "resolvedImage"
                        }, dd = {
                            kind: "variableAnchorOffsetCollection"
                        };
                        function Ut(Qe, rt) {
                            return {
                                kind: "array",
                                itemType: Qe,
                                N: rt
                            };
                        }
                        function qt(Qe) {
                            if ("array" === Qe.kind) {
                                const rt = qt(Qe.itemType);
                                return "number" == typeof Qe.N ? `array<${rt}, ${Qe.N}>` : "value" === Qe.itemType.kind ? "array" : `array<${rt}>`;
                            }
                            return Qe.kind;
                        }
                        const pd = [
                            ed,
                            td,
                            id,
                            nd,
                            rd,
                            sd,
                            cd,
                            ad,
                            Ut(od),
                            ud,
                            hd,
                            dd
                        ];
                        function Zt(Qe, rt) {
                            if ("error" === rt.kind) return null;
                            if ("array" === Qe.kind) {
                                if ("array" === rt.kind && (0 === rt.N && "value" === rt.itemType.kind || !Zt(Qe.itemType, rt.itemType)) && ("number" != typeof Qe.N || Qe.N === rt.N)) return null;
                            } else {
                                if (Qe.kind === rt.kind) return null;
                                if ("value" === Qe.kind) {
                                    for (const Qe of pd)if (!Zt(Qe, rt)) return null;
                                }
                            }
                            return `Expected ${qt(Qe)} but found ${qt(rt)} instead.`;
                        }
                        function Kt(Qe, rt) {
                            return rt.some((rt)=>rt.kind === Qe.kind);
                        }
                        function Xt(Qe, rt) {
                            return rt.some((rt)=>"null" === rt ? null === Qe : "array" === rt ? Array.isArray(Qe) : "object" === rt ? Qe && !Array.isArray(Qe) && "object" == typeof Qe : rt === typeof Qe);
                        }
                        function Ht(Qe, rt) {
                            return "array" === Qe.kind && "array" === rt.kind ? Qe.itemType.kind === rt.itemType.kind && "number" == typeof Qe.N : Qe.kind === rt.kind;
                        }
                        const md = .96422, fd = .82521, gd = 4 / 29, Ad = 6 / 29, yd = 3 * Ad * Ad, vd = Ad * Ad * Ad, _d = Math.PI / 180, xd = 180 / Math.PI;
                        function ie(Qe) {
                            return (Qe %= 360) < 0 && (Qe += 360), Qe;
                        }
                        function se([Qe, rt, Wn, Co]) {
                            let Dl, Ll;
                            const Rl = oe((.2225045 * (Qe = ae(Qe)) + .7168786 * (rt = ae(rt)) + .0606169 * (Wn = ae(Wn))) / 1);
                            Qe === rt && rt === Wn ? Dl = Ll = Rl : (Dl = oe((.4360747 * Qe + .3850649 * rt + .1430804 * Wn) / md), Ll = oe((.0139322 * Qe + .0971045 * rt + .7141733 * Wn) / fd));
                            const Ul = 116 * Rl - 16;
                            return [
                                Ul < 0 ? 0 : Ul,
                                500 * (Dl - Rl),
                                200 * (Rl - Ll),
                                Co
                            ];
                        }
                        function ae(Qe) {
                            return Qe <= .04045 ? Qe / 12.92 : Math.pow((Qe + .055) / 1.055, 2.4);
                        }
                        function oe(Qe) {
                            return Qe > vd ? Math.pow(Qe, 1 / 3) : Qe / yd + gd;
                        }
                        function le([Qe, rt, Wn, Co]) {
                            let Dl = (Qe + 16) / 116, Ll = isNaN(rt) ? Dl : Dl + rt / 500, Rl = isNaN(Wn) ? Dl : Dl - Wn / 200;
                            return Dl = 1 * ce(Dl), Ll = md * ce(Ll), Rl = fd * ce(Rl), [
                                ue(3.1338561 * Ll - 1.6168667 * Dl - .4906146 * Rl),
                                ue(-0.9787684 * Ll + 1.9161415 * Dl + .033454 * Rl),
                                ue(.0719453 * Ll - .2289914 * Dl + 1.4052427 * Rl),
                                Co
                            ];
                        }
                        function ue(Qe) {
                            return (Qe = Qe <= .00304 ? 12.92 * Qe : 1.055 * Math.pow(Qe, 1 / 2.4) - .055) < 0 ? 0 : Qe > 1 ? 1 : Qe;
                        }
                        function ce(Qe) {
                            return Qe > Ad ? Qe * Qe * Qe : yd * (Qe - gd);
                        }
                        function he(Qe) {
                            return parseInt(Qe.padEnd(2, Qe), 16) / 255;
                        }
                        function pe(Qe, rt) {
                            return fe(rt ? Qe / 100 : Qe, 0, 1);
                        }
                        function fe(Qe, rt, Wn) {
                            return Math.min(Math.max(rt, Qe), Wn);
                        }
                        function de(Qe) {
                            return !Qe.some(Number.isNaN);
                        }
                        const bd = {
                            aliceblue: [
                                240,
                                248,
                                255
                            ],
                            antiquewhite: [
                                250,
                                235,
                                215
                            ],
                            aqua: [
                                0,
                                255,
                                255
                            ],
                            aquamarine: [
                                127,
                                255,
                                212
                            ],
                            azure: [
                                240,
                                255,
                                255
                            ],
                            beige: [
                                245,
                                245,
                                220
                            ],
                            bisque: [
                                255,
                                228,
                                196
                            ],
                            black: [
                                0,
                                0,
                                0
                            ],
                            blanchedalmond: [
                                255,
                                235,
                                205
                            ],
                            blue: [
                                0,
                                0,
                                255
                            ],
                            blueviolet: [
                                138,
                                43,
                                226
                            ],
                            brown: [
                                165,
                                42,
                                42
                            ],
                            burlywood: [
                                222,
                                184,
                                135
                            ],
                            cadetblue: [
                                95,
                                158,
                                160
                            ],
                            chartreuse: [
                                127,
                                255,
                                0
                            ],
                            chocolate: [
                                210,
                                105,
                                30
                            ],
                            coral: [
                                255,
                                127,
                                80
                            ],
                            cornflowerblue: [
                                100,
                                149,
                                237
                            ],
                            cornsilk: [
                                255,
                                248,
                                220
                            ],
                            crimson: [
                                220,
                                20,
                                60
                            ],
                            cyan: [
                                0,
                                255,
                                255
                            ],
                            darkblue: [
                                0,
                                0,
                                139
                            ],
                            darkcyan: [
                                0,
                                139,
                                139
                            ],
                            darkgoldenrod: [
                                184,
                                134,
                                11
                            ],
                            darkgray: [
                                169,
                                169,
                                169
                            ],
                            darkgreen: [
                                0,
                                100,
                                0
                            ],
                            darkgrey: [
                                169,
                                169,
                                169
                            ],
                            darkkhaki: [
                                189,
                                183,
                                107
                            ],
                            darkmagenta: [
                                139,
                                0,
                                139
                            ],
                            darkolivegreen: [
                                85,
                                107,
                                47
                            ],
                            darkorange: [
                                255,
                                140,
                                0
                            ],
                            darkorchid: [
                                153,
                                50,
                                204
                            ],
                            darkred: [
                                139,
                                0,
                                0
                            ],
                            darksalmon: [
                                233,
                                150,
                                122
                            ],
                            darkseagreen: [
                                143,
                                188,
                                143
                            ],
                            darkslateblue: [
                                72,
                                61,
                                139
                            ],
                            darkslategray: [
                                47,
                                79,
                                79
                            ],
                            darkslategrey: [
                                47,
                                79,
                                79
                            ],
                            darkturquoise: [
                                0,
                                206,
                                209
                            ],
                            darkviolet: [
                                148,
                                0,
                                211
                            ],
                            deeppink: [
                                255,
                                20,
                                147
                            ],
                            deepskyblue: [
                                0,
                                191,
                                255
                            ],
                            dimgray: [
                                105,
                                105,
                                105
                            ],
                            dimgrey: [
                                105,
                                105,
                                105
                            ],
                            dodgerblue: [
                                30,
                                144,
                                255
                            ],
                            firebrick: [
                                178,
                                34,
                                34
                            ],
                            floralwhite: [
                                255,
                                250,
                                240
                            ],
                            forestgreen: [
                                34,
                                139,
                                34
                            ],
                            fuchsia: [
                                255,
                                0,
                                255
                            ],
                            gainsboro: [
                                220,
                                220,
                                220
                            ],
                            ghostwhite: [
                                248,
                                248,
                                255
                            ],
                            gold: [
                                255,
                                215,
                                0
                            ],
                            goldenrod: [
                                218,
                                165,
                                32
                            ],
                            gray: [
                                128,
                                128,
                                128
                            ],
                            green: [
                                0,
                                128,
                                0
                            ],
                            greenyellow: [
                                173,
                                255,
                                47
                            ],
                            grey: [
                                128,
                                128,
                                128
                            ],
                            honeydew: [
                                240,
                                255,
                                240
                            ],
                            hotpink: [
                                255,
                                105,
                                180
                            ],
                            indianred: [
                                205,
                                92,
                                92
                            ],
                            indigo: [
                                75,
                                0,
                                130
                            ],
                            ivory: [
                                255,
                                255,
                                240
                            ],
                            khaki: [
                                240,
                                230,
                                140
                            ],
                            lavender: [
                                230,
                                230,
                                250
                            ],
                            lavenderblush: [
                                255,
                                240,
                                245
                            ],
                            lawngreen: [
                                124,
                                252,
                                0
                            ],
                            lemonchiffon: [
                                255,
                                250,
                                205
                            ],
                            lightblue: [
                                173,
                                216,
                                230
                            ],
                            lightcoral: [
                                240,
                                128,
                                128
                            ],
                            lightcyan: [
                                224,
                                255,
                                255
                            ],
                            lightgoldenrodyellow: [
                                250,
                                250,
                                210
                            ],
                            lightgray: [
                                211,
                                211,
                                211
                            ],
                            lightgreen: [
                                144,
                                238,
                                144
                            ],
                            lightgrey: [
                                211,
                                211,
                                211
                            ],
                            lightpink: [
                                255,
                                182,
                                193
                            ],
                            lightsalmon: [
                                255,
                                160,
                                122
                            ],
                            lightseagreen: [
                                32,
                                178,
                                170
                            ],
                            lightskyblue: [
                                135,
                                206,
                                250
                            ],
                            lightslategray: [
                                119,
                                136,
                                153
                            ],
                            lightslategrey: [
                                119,
                                136,
                                153
                            ],
                            lightsteelblue: [
                                176,
                                196,
                                222
                            ],
                            lightyellow: [
                                255,
                                255,
                                224
                            ],
                            lime: [
                                0,
                                255,
                                0
                            ],
                            limegreen: [
                                50,
                                205,
                                50
                            ],
                            linen: [
                                250,
                                240,
                                230
                            ],
                            magenta: [
                                255,
                                0,
                                255
                            ],
                            maroon: [
                                128,
                                0,
                                0
                            ],
                            mediumaquamarine: [
                                102,
                                205,
                                170
                            ],
                            mediumblue: [
                                0,
                                0,
                                205
                            ],
                            mediumorchid: [
                                186,
                                85,
                                211
                            ],
                            mediumpurple: [
                                147,
                                112,
                                219
                            ],
                            mediumseagreen: [
                                60,
                                179,
                                113
                            ],
                            mediumslateblue: [
                                123,
                                104,
                                238
                            ],
                            mediumspringgreen: [
                                0,
                                250,
                                154
                            ],
                            mediumturquoise: [
                                72,
                                209,
                                204
                            ],
                            mediumvioletred: [
                                199,
                                21,
                                133
                            ],
                            midnightblue: [
                                25,
                                25,
                                112
                            ],
                            mintcream: [
                                245,
                                255,
                                250
                            ],
                            mistyrose: [
                                255,
                                228,
                                225
                            ],
                            moccasin: [
                                255,
                                228,
                                181
                            ],
                            navajowhite: [
                                255,
                                222,
                                173
                            ],
                            navy: [
                                0,
                                0,
                                128
                            ],
                            oldlace: [
                                253,
                                245,
                                230
                            ],
                            olive: [
                                128,
                                128,
                                0
                            ],
                            olivedrab: [
                                107,
                                142,
                                35
                            ],
                            orange: [
                                255,
                                165,
                                0
                            ],
                            orangered: [
                                255,
                                69,
                                0
                            ],
                            orchid: [
                                218,
                                112,
                                214
                            ],
                            palegoldenrod: [
                                238,
                                232,
                                170
                            ],
                            palegreen: [
                                152,
                                251,
                                152
                            ],
                            paleturquoise: [
                                175,
                                238,
                                238
                            ],
                            palevioletred: [
                                219,
                                112,
                                147
                            ],
                            papayawhip: [
                                255,
                                239,
                                213
                            ],
                            peachpuff: [
                                255,
                                218,
                                185
                            ],
                            peru: [
                                205,
                                133,
                                63
                            ],
                            pink: [
                                255,
                                192,
                                203
                            ],
                            plum: [
                                221,
                                160,
                                221
                            ],
                            powderblue: [
                                176,
                                224,
                                230
                            ],
                            purple: [
                                128,
                                0,
                                128
                            ],
                            rebeccapurple: [
                                102,
                                51,
                                153
                            ],
                            red: [
                                255,
                                0,
                                0
                            ],
                            rosybrown: [
                                188,
                                143,
                                143
                            ],
                            royalblue: [
                                65,
                                105,
                                225
                            ],
                            saddlebrown: [
                                139,
                                69,
                                19
                            ],
                            salmon: [
                                250,
                                128,
                                114
                            ],
                            sandybrown: [
                                244,
                                164,
                                96
                            ],
                            seagreen: [
                                46,
                                139,
                                87
                            ],
                            seashell: [
                                255,
                                245,
                                238
                            ],
                            sienna: [
                                160,
                                82,
                                45
                            ],
                            silver: [
                                192,
                                192,
                                192
                            ],
                            skyblue: [
                                135,
                                206,
                                235
                            ],
                            slateblue: [
                                106,
                                90,
                                205
                            ],
                            slategray: [
                                112,
                                128,
                                144
                            ],
                            slategrey: [
                                112,
                                128,
                                144
                            ],
                            snow: [
                                255,
                                250,
                                250
                            ],
                            springgreen: [
                                0,
                                255,
                                127
                            ],
                            steelblue: [
                                70,
                                130,
                                180
                            ],
                            tan: [
                                210,
                                180,
                                140
                            ],
                            teal: [
                                0,
                                128,
                                128
                            ],
                            thistle: [
                                216,
                                191,
                                216
                            ],
                            tomato: [
                                255,
                                99,
                                71
                            ],
                            turquoise: [
                                64,
                                224,
                                208
                            ],
                            violet: [
                                238,
                                130,
                                238
                            ],
                            wheat: [
                                245,
                                222,
                                179
                            ],
                            white: [
                                255,
                                255,
                                255
                            ],
                            whitesmoke: [
                                245,
                                245,
                                245
                            ],
                            yellow: [
                                255,
                                255,
                                0
                            ],
                            yellowgreen: [
                                154,
                                205,
                                50
                            ]
                        };
                        function me(Qe, rt, Wn) {
                            return Qe + Wn * (rt - Qe);
                        }
                        function ge(Qe, rt, Wn) {
                            return Qe.map((Qe, Co)=>me(Qe, rt[Co], Wn));
                        }
                        class xe {
                            constructor(Qe, rt, Wn, Co = 1, Dl = !0){
                                this.r = Qe, this.g = rt, this.b = Wn, this.a = Co, Dl || (this.r *= Co, this.g *= Co, this.b *= Co, Co || this.overwriteGetter("rgb", [
                                    Qe,
                                    rt,
                                    Wn,
                                    Co
                                ]));
                            }
                            static parse(Qe) {
                                if (Qe instanceof xe) return Qe;
                                if ("string" != typeof Qe) return;
                                const rt = function(Qe) {
                                    if ("transparent" === (Qe = Qe.toLowerCase().trim())) return [
                                        0,
                                        0,
                                        0,
                                        0
                                    ];
                                    const rt = bd[Qe];
                                    if (rt) {
                                        const [Qe, Wn, Co] = rt;
                                        return [
                                            Qe / 255,
                                            Wn / 255,
                                            Co / 255,
                                            1
                                        ];
                                    }
                                    if (Qe.startsWith("#") && /^#(?:[0-9a-f]{3,4}|[0-9a-f]{6}|[0-9a-f]{8})$/.test(Qe)) {
                                        const rt = Qe.length < 6 ? 1 : 2;
                                        let Wn = 1;
                                        return [
                                            he(Qe.slice(Wn, Wn += rt)),
                                            he(Qe.slice(Wn, Wn += rt)),
                                            he(Qe.slice(Wn, Wn += rt)),
                                            he(Qe.slice(Wn, Wn + rt) || "ff")
                                        ];
                                    }
                                    if (Qe.startsWith("rgb")) {
                                        const rt = Qe.match(/^rgba?\(\s*([\de.+-]+)(%)?(?:\s+|\s*(,)\s*)([\de.+-]+)(%)?(?:\s+|\s*(,)\s*)([\de.+-]+)(%)?(?:\s*([,\/])\s*([\de.+-]+)(%)?)?\s*\)$/);
                                        if (rt) {
                                            const [Qe, Wn, Co, Dl, Ll, Rl, Ul, Gl, Zl, Hl, ql, Ql] = rt, Kl = [
                                                Dl || " ",
                                                Ul || " ",
                                                Hl
                                            ].join("");
                                            if ("  " === Kl || "  /" === Kl || ",," === Kl || ",,," === Kl) {
                                                const Qe = [
                                                    Co,
                                                    Rl,
                                                    Zl
                                                ].join(""), rt = "%%%" === Qe ? 100 : "" === Qe ? 255 : 0;
                                                if (rt) {
                                                    const Qe = [
                                                        fe(+Wn / rt, 0, 1),
                                                        fe(+Ll / rt, 0, 1),
                                                        fe(+Gl / rt, 0, 1),
                                                        ql ? pe(+ql, Ql) : 1
                                                    ];
                                                    if (de(Qe)) return Qe;
                                                }
                                            }
                                            return;
                                        }
                                    }
                                    const Wn = Qe.match(/^hsla?\(\s*([\de.+-]+)(?:deg)?(?:\s+|\s*(,)\s*)([\de.+-]+)%(?:\s+|\s*(,)\s*)([\de.+-]+)%(?:\s*([,\/])\s*([\de.+-]+)(%)?)?\s*\)$/);
                                    if (Wn) {
                                        const [Qe, rt, Co, Dl, Ll, Rl, Ul, Gl, Zl] = Wn, Hl = [
                                            Co || " ",
                                            Ll || " ",
                                            Ul
                                        ].join("");
                                        if ("  " === Hl || "  /" === Hl || ",," === Hl || ",,," === Hl) {
                                            const Qe = [
                                                +rt,
                                                fe(+Dl, 0, 100),
                                                fe(+Rl, 0, 100),
                                                Gl ? pe(+Gl, Zl) : 1
                                            ];
                                            if (de(Qe)) return function([Qe, rt, Wn, Co]) {
                                                function i(Co) {
                                                    const Dl = (Co + Qe / 30) % 12, Ll = rt * Math.min(Wn, 1 - Wn);
                                                    return Wn - Ll * Math.max(-1, Math.min(Dl - 3, 9 - Dl, 1));
                                                }
                                                return Qe = ie(Qe), rt /= 100, Wn /= 100, [
                                                    i(0),
                                                    i(8),
                                                    i(4),
                                                    Co
                                                ];
                                            }(Qe);
                                        }
                                    }
                                }(Qe);
                                return rt ? new xe(...rt, !1) : void 0;
                            }
                            get rgb() {
                                const { r: Qe, g: rt, b: Wn, a: Co } = this, Dl = Co || 1 / 0;
                                return this.overwriteGetter("rgb", [
                                    Qe / Dl,
                                    rt / Dl,
                                    Wn / Dl,
                                    Co
                                ]);
                            }
                            get hcl() {
                                return this.overwriteGetter("hcl", function(Qe) {
                                    const [rt, Wn, Co, Dl] = se(Qe), Ll = Math.sqrt(Wn * Wn + Co * Co);
                                    return [
                                        Math.round(1e4 * Ll) ? ie(Math.atan2(Co, Wn) * xd) : NaN,
                                        Ll,
                                        rt,
                                        Dl
                                    ];
                                }(this.rgb));
                            }
                            get lab() {
                                return this.overwriteGetter("lab", se(this.rgb));
                            }
                            overwriteGetter(Qe, rt) {
                                return Object.defineProperty(this, Qe, {
                                    value: rt
                                }), rt;
                            }
                            toString() {
                                const [Qe, rt, Wn, Co] = this.rgb;
                                return `rgba(${[
                                    Qe,
                                    rt,
                                    Wn
                                ].map((Qe)=>Math.round(255 * Qe)).join(",")},${Co})`;
                            }
                            static interpolate(Qe, rt, Wn, Co = "rgb") {
                                switch(Co){
                                    case "rgb":
                                        {
                                            const [Co, Dl, Ll, Rl] = ge(Qe.rgb, rt.rgb, Wn);
                                            return new xe(Co, Dl, Ll, Rl, !1);
                                        }
                                    case "hcl":
                                        {
                                            const [Co, Dl, Ll, Rl] = Qe.hcl, [Ul, Gl, Zl, Hl] = rt.hcl;
                                            let ql, Ql;
                                            if (isNaN(Co) || isNaN(Ul)) isNaN(Co) ? isNaN(Ul) ? ql = NaN : (ql = Ul, 1 !== Ll && 0 !== Ll || (Ql = Gl)) : (ql = Co, 1 !== Zl && 0 !== Zl || (Ql = Dl));
                                            else {
                                                let Qe = Ul - Co;
                                                Ul > Co && Qe > 180 ? Qe -= 360 : Ul < Co && Co - Ul > 180 && (Qe += 360), ql = Co + Wn * Qe;
                                            }
                                            const [Kl, $l, Tc, tu] = function([Qe, rt, Wn, Co]) {
                                                return Qe = isNaN(Qe) ? 0 : Qe * _d, le([
                                                    Wn,
                                                    Math.cos(Qe) * rt,
                                                    Math.sin(Qe) * rt,
                                                    Co
                                                ]);
                                            }([
                                                ql,
                                                null != Ql ? Ql : me(Dl, Gl, Wn),
                                                me(Ll, Zl, Wn),
                                                me(Rl, Hl, Wn)
                                            ]);
                                            return new xe(Kl, $l, Tc, tu, !1);
                                        }
                                    case "lab":
                                        {
                                            const [Co, Dl, Ll, Rl] = le(ge(Qe.lab, rt.lab, Wn));
                                            return new xe(Co, Dl, Ll, Rl, !1);
                                        }
                                }
                            }
                        }
                        xe.black = new xe(0, 0, 0, 1), xe.white = new xe(1, 1, 1, 1), xe.transparent = new xe(0, 0, 0, 0), xe.red = new xe(1, 0, 0, 1);
                        class ve {
                            constructor(Qe, rt, Wn){
                                this.sensitivity = Qe ? rt ? "variant" : "case" : rt ? "accent" : "base", this.locale = Wn, this.collator = new Intl.Collator(this.locale ? this.locale : [], {
                                    sensitivity: this.sensitivity,
                                    usage: "search"
                                });
                            }
                            compare(Qe, rt) {
                                return this.collator.compare(Qe, rt);
                            }
                            resolvedLocale() {
                                return new Intl.Collator(this.locale ? this.locale : []).resolvedOptions().locale;
                            }
                        }
                        const wd = [
                            "bottom",
                            "center",
                            "top"
                        ];
                        class we {
                            constructor(Qe, rt, Wn, Co, Dl, Ll){
                                this.text = Qe, this.image = rt, this.scale = Wn, this.fontStack = Co, this.textColor = Dl, this.verticalAlign = Ll;
                            }
                        }
                        class _e {
                            constructor(Qe){
                                this.sections = Qe;
                            }
                            static fromString(Qe) {
                                return new _e([
                                    new we(Qe, null, null, null, null, null)
                                ]);
                            }
                            isEmpty() {
                                return 0 === this.sections.length || !this.sections.some((Qe)=>0 !== Qe.text.length || Qe.image && 0 !== Qe.image.name.length);
                            }
                            static factory(Qe) {
                                return Qe instanceof _e ? Qe : _e.fromString(Qe);
                            }
                            toString() {
                                return 0 === this.sections.length ? "" : this.sections.map((Qe)=>Qe.text).join("");
                            }
                        }
                        class Se {
                            constructor(Qe){
                                this.values = Qe.slice();
                            }
                            static parse(Qe) {
                                if (Qe instanceof Se) return Qe;
                                if ("number" == typeof Qe) return new Se([
                                    Qe,
                                    Qe,
                                    Qe,
                                    Qe
                                ]);
                                if (Array.isArray(Qe) && !(Qe.length < 1 || Qe.length > 4)) {
                                    for (const rt of Qe)if ("number" != typeof rt) return;
                                    switch(Qe.length){
                                        case 1:
                                            Qe = [
                                                Qe[0],
                                                Qe[0],
                                                Qe[0],
                                                Qe[0]
                                            ];
                                            break;
                                        case 2:
                                            Qe = [
                                                Qe[0],
                                                Qe[1],
                                                Qe[0],
                                                Qe[1]
                                            ];
                                            break;
                                        case 3:
                                            Qe = [
                                                Qe[0],
                                                Qe[1],
                                                Qe[2],
                                                Qe[1]
                                            ];
                                    }
                                    return new Se(Qe);
                                }
                            }
                            toString() {
                                return JSON.stringify(this.values);
                            }
                            static interpolate(Qe, rt, Wn) {
                                return new Se(ge(Qe.values, rt.values, Wn));
                            }
                        }
                        class Ae {
                            constructor(Qe){
                                this.name = "ExpressionEvaluationError", this.message = Qe;
                            }
                            toJSON() {
                                return this.message;
                            }
                        }
                        const Ed = new Set([
                            "center",
                            "left",
                            "right",
                            "top",
                            "bottom",
                            "top-left",
                            "top-right",
                            "bottom-left",
                            "bottom-right"
                        ]);
                        class Me {
                            constructor(Qe){
                                this.values = Qe.slice();
                            }
                            static parse(Qe) {
                                if (Qe instanceof Me) return Qe;
                                if (Array.isArray(Qe) && !(Qe.length < 1) && Qe.length % 2 == 0) {
                                    for(let rt = 0; rt < Qe.length; rt += 2){
                                        const Wn = Qe[rt], Co = Qe[rt + 1];
                                        if ("string" != typeof Wn || !Ed.has(Wn)) return;
                                        if (!Array.isArray(Co) || 2 !== Co.length || "number" != typeof Co[0] || "number" != typeof Co[1]) return;
                                    }
                                    return new Me(Qe);
                                }
                            }
                            toString() {
                                return JSON.stringify(this.values);
                            }
                            static interpolate(Qe, rt, Wn) {
                                const Co = Qe.values, Dl = rt.values;
                                if (Co.length !== Dl.length) throw new Ae(`Cannot interpolate values of different length. from: ${Qe.toString()}, to: ${rt.toString()}`);
                                const Ll = [];
                                for(let Rl = 0; Rl < Co.length; Rl += 2){
                                    if (Co[Rl] !== Dl[Rl]) throw new Ae(`Cannot interpolate values containing mismatched anchors. from[${Rl}]: ${Co[Rl]}, to[${Rl}]: ${Dl[Rl]}`);
                                    Ll.push(Co[Rl]);
                                    const [Qe, rt] = Co[Rl + 1], [Ul, Gl] = Dl[Rl + 1];
                                    Ll.push([
                                        me(Qe, Ul, Wn),
                                        me(rt, Gl, Wn)
                                    ]);
                                }
                                return new Me(Ll);
                            }
                        }
                        class Ie {
                            constructor(Qe){
                                this.name = Qe.name, this.available = Qe.available;
                            }
                            toString() {
                                return this.name;
                            }
                            static fromString(Qe) {
                                return Qe ? new Ie({
                                    name: Qe,
                                    available: !1
                                }) : null;
                            }
                        }
                        class ze {
                            constructor(Qe, rt, Wn){
                                this.from = Qe, this.to = rt, this.transition = Wn;
                            }
                            static interpolate(Qe, rt, Wn) {
                                return new ze(Qe, rt, Wn);
                            }
                            static parse(Qe) {
                                return Qe instanceof ze ? Qe : Array.isArray(Qe) && 3 === Qe.length && "string" == typeof Qe[0] && "string" == typeof Qe[1] && "number" == typeof Qe[2] ? new ze(Qe[0], Qe[1], Qe[2]) : "object" == typeof Qe && "string" == typeof Qe.from && "string" == typeof Qe.to && "number" == typeof Qe.transition ? new ze(Qe.from, Qe.to, Qe.transition) : "string" == typeof Qe ? new ze(Qe, Qe, 1) : void 0;
                            }
                        }
                        function Pe(Qe, rt, Wn, Co) {
                            return "number" == typeof Qe && Qe >= 0 && Qe <= 255 && "number" == typeof rt && rt >= 0 && rt <= 255 && "number" == typeof Wn && Wn >= 0 && Wn <= 255 ? void 0 === Co || "number" == typeof Co && Co >= 0 && Co <= 1 ? null : `Invalid rgba value [${[
                                Qe,
                                rt,
                                Wn,
                                Co
                            ].join(", ")}]: 'a' must be between 0 and 1.` : `Invalid rgba value [${("number" == typeof Co ? [
                                Qe,
                                rt,
                                Wn,
                                Co
                            ] : [
                                Qe,
                                rt,
                                Wn
                            ]).join(", ")}]: 'r', 'g', and 'b' must be between 0 and 255.`;
                        }
                        function Ce(Qe) {
                            if (null === Qe || "string" == typeof Qe || "boolean" == typeof Qe || "number" == typeof Qe || Qe instanceof ze || Qe instanceof xe || Qe instanceof ve || Qe instanceof _e || Qe instanceof Se || Qe instanceof Me || Qe instanceof Ie) return !0;
                            if (Array.isArray(Qe)) {
                                for (const rt of Qe)if (!Ce(rt)) return !1;
                                return !0;
                            }
                            if ("object" == typeof Qe) {
                                for(const rt in Qe)if (!Ce(Qe[rt])) return !1;
                                return !0;
                            }
                            return !1;
                        }
                        function Be(Qe) {
                            if (null === Qe) return ed;
                            if ("string" == typeof Qe) return id;
                            if ("boolean" == typeof Qe) return nd;
                            if ("number" == typeof Qe) return td;
                            if (Qe instanceof xe) return rd;
                            if (Qe instanceof ze) return sd;
                            if (Qe instanceof ve) return ld;
                            if (Qe instanceof _e) return cd;
                            if (Qe instanceof Se) return ud;
                            if (Qe instanceof Me) return dd;
                            if (Qe instanceof Ie) return hd;
                            if (Array.isArray(Qe)) {
                                const rt = Qe.length;
                                let Wn;
                                for (const Co of Qe){
                                    const Qe = Be(Co);
                                    if (Wn) {
                                        if (Wn === Qe) continue;
                                        Wn = od;
                                        break;
                                    }
                                    Wn = Qe;
                                }
                                return Ut(Wn || od, rt);
                            }
                            return ad;
                        }
                        function Ve(Qe) {
                            const rt = typeof Qe;
                            return null === Qe ? "" : "string" === rt || "number" === rt || "boolean" === rt ? String(Qe) : Qe instanceof xe || Qe instanceof ze || Qe instanceof _e || Qe instanceof Se || Qe instanceof Me || Qe instanceof Ie ? Qe.toString() : JSON.stringify(Qe);
                        }
                        class Ee {
                            constructor(Qe, rt){
                                this.type = Qe, this.value = rt;
                            }
                            static parse(Qe, rt) {
                                if (2 !== Qe.length) return rt.error(`'literal' expression requires exactly one argument, but found ${Qe.length - 1} instead.`);
                                if (!Ce(Qe[1])) return rt.error("invalid value");
                                const Wn = Qe[1];
                                let Co = Be(Wn);
                                const Dl = rt.expectedType;
                                return "array" !== Co.kind || 0 !== Co.N || !Dl || "array" !== Dl.kind || "number" == typeof Dl.N && 0 !== Dl.N || (Co = Dl), new Ee(Co, Wn);
                            }
                            evaluate() {
                                return this.value;
                            }
                            eachChild() {}
                            outputDefined() {
                                return !0;
                            }
                        }
                        const Md = {
                            string: id,
                            number: td,
                            boolean: nd,
                            object: ad
                        };
                        class Fe {
                            constructor(Qe, rt){
                                this.type = Qe, this.args = rt;
                            }
                            static parse(Qe, rt) {
                                if (Qe.length < 2) return rt.error("Expected at least one argument.");
                                let Wn, Co = 1;
                                const Dl = Qe[0];
                                if ("array" === Dl) {
                                    let Dl, Ll;
                                    if (Qe.length > 2) {
                                        const Wn = Qe[1];
                                        if ("string" != typeof Wn || !(Wn in Md) || "object" === Wn) return rt.error('The item type argument of "array" must be one of string, number, boolean', 1);
                                        Dl = Md[Wn], Co++;
                                    } else Dl = od;
                                    if (Qe.length > 3) {
                                        if (null !== Qe[2] && ("number" != typeof Qe[2] || Qe[2] < 0 || Qe[2] !== Math.floor(Qe[2]))) return rt.error('The length argument to "array" must be a positive integer literal', 2);
                                        Ll = Qe[2], Co++;
                                    }
                                    Wn = Ut(Dl, Ll);
                                } else {
                                    if (!Md[Dl]) throw new Error(`Types doesn't contain name = ${Dl}`);
                                    Wn = Md[Dl];
                                }
                                const Ll = [];
                                for(; Co < Qe.length; Co++){
                                    const Wn = rt.parse(Qe[Co], Co, od);
                                    if (!Wn) return null;
                                    Ll.push(Wn);
                                }
                                return new Fe(Wn, Ll);
                            }
                            evaluate(Qe) {
                                for(let rt = 0; rt < this.args.length; rt++){
                                    const Wn = this.args[rt].evaluate(Qe);
                                    if (!Zt(this.type, Be(Wn))) return Wn;
                                    if (rt === this.args.length - 1) throw new Ae(`Expected value to be of type ${qt(this.type)}, but found ${qt(Be(Wn))} instead.`);
                                }
                                throw new Error;
                            }
                            eachChild(Qe) {
                                this.args.forEach(Qe);
                            }
                            outputDefined() {
                                return this.args.every((Qe)=>Qe.outputDefined());
                            }
                        }
                        const Sd = {
                            "to-boolean": nd,
                            "to-color": rd,
                            "to-number": td,
                            "to-string": id
                        };
                        class Le {
                            constructor(Qe, rt){
                                this.type = Qe, this.args = rt;
                            }
                            static parse(Qe, rt) {
                                if (Qe.length < 2) return rt.error("Expected at least one argument.");
                                const Wn = Qe[0];
                                if (!Sd[Wn]) throw new Error(`Can't parse ${Wn} as it is not part of the known types`);
                                if (("to-boolean" === Wn || "to-string" === Wn) && 2 !== Qe.length) return rt.error("Expected one argument.");
                                const Co = Sd[Wn], Dl = [];
                                for(let Ll = 1; Ll < Qe.length; Ll++){
                                    const Wn = rt.parse(Qe[Ll], Ll, od);
                                    if (!Wn) return null;
                                    Dl.push(Wn);
                                }
                                return new Le(Co, Dl);
                            }
                            evaluate(Qe) {
                                switch(this.type.kind){
                                    case "boolean":
                                        return Boolean(this.args[0].evaluate(Qe));
                                    case "color":
                                        {
                                            let rt, Wn;
                                            for (const Co of this.args){
                                                if (rt = Co.evaluate(Qe), Wn = null, rt instanceof xe) return rt;
                                                if ("string" == typeof rt) {
                                                    const Wn = Qe.parseColor(rt);
                                                    if (Wn) return Wn;
                                                } else if (Array.isArray(rt) && (Wn = rt.length < 3 || rt.length > 4 ? `Invalid rgba value ${JSON.stringify(rt)}: expected an array containing either three or four numeric values.` : Pe(rt[0], rt[1], rt[2], rt[3]), !Wn)) return new xe(rt[0] / 255, rt[1] / 255, rt[2] / 255, rt[3]);
                                            }
                                            throw new Ae(Wn || `Could not parse color from value '${"string" == typeof rt ? rt : JSON.stringify(rt)}'`);
                                        }
                                    case "padding":
                                        {
                                            let rt;
                                            for (const Wn of this.args){
                                                rt = Wn.evaluate(Qe);
                                                const Co = Se.parse(rt);
                                                if (Co) return Co;
                                            }
                                            throw new Ae(`Could not parse padding from value '${"string" == typeof rt ? rt : JSON.stringify(rt)}'`);
                                        }
                                    case "variableAnchorOffsetCollection":
                                        {
                                            let rt;
                                            for (const Wn of this.args){
                                                rt = Wn.evaluate(Qe);
                                                const Co = Me.parse(rt);
                                                if (Co) return Co;
                                            }
                                            throw new Ae(`Could not parse variableAnchorOffsetCollection from value '${"string" == typeof rt ? rt : JSON.stringify(rt)}'`);
                                        }
                                    case "number":
                                        {
                                            let rt = null;
                                            for (const Wn of this.args){
                                                if (rt = Wn.evaluate(Qe), null === rt) return 0;
                                                const Co = Number(rt);
                                                if (!isNaN(Co)) return Co;
                                            }
                                            throw new Ae(`Could not convert ${JSON.stringify(rt)} to number.`);
                                        }
                                    case "formatted":
                                        return _e.fromString(Ve(this.args[0].evaluate(Qe)));
                                    case "resolvedImage":
                                        return Ie.fromString(Ve(this.args[0].evaluate(Qe)));
                                    case "projectionDefinition":
                                        return this.args[0].evaluate(Qe);
                                    default:
                                        return Ve(this.args[0].evaluate(Qe));
                                }
                            }
                            eachChild(Qe) {
                                this.args.forEach(Qe);
                            }
                            outputDefined() {
                                return this.args.every((Qe)=>Qe.outputDefined());
                            }
                        }
                        const Td = [
                            "Unknown",
                            "Point",
                            "LineString",
                            "Polygon"
                        ];
                        class De {
                            constructor(){
                                this.globals = null, this.feature = null, this.featureState = null, this.formattedSection = null, this._parseColorCache = {}, this.availableImages = null, this.canonical = null;
                            }
                            id() {
                                return this.feature && "id" in this.feature ? this.feature.id : null;
                            }
                            geometryType() {
                                return this.feature ? "number" == typeof this.feature.type ? Td[this.feature.type] : this.feature.type : null;
                            }
                            geometry() {
                                return this.feature && "geometry" in this.feature ? this.feature.geometry : null;
                            }
                            canonicalID() {
                                return this.canonical;
                            }
                            properties() {
                                return this.feature && this.feature.properties || {};
                            }
                            parseColor(Qe) {
                                let rt = this._parseColorCache[Qe];
                                return rt || (rt = this._parseColorCache[Qe] = xe.parse(Qe)), rt;
                            }
                        }
                        class Re {
                            constructor(Qe, rt, Wn = [], Co, Dl = new Pt, Ll = []){
                                this.registry = Qe, this.path = Wn, this.key = Wn.map((Qe)=>`[${Qe}]`).join(""), this.scope = Dl, this.errors = Ll, this.expectedType = Co, this._isConstant = rt;
                            }
                            parse(Qe, rt, Wn, Co, Dl = {}) {
                                return rt ? this.concat(rt, Wn, Co)._parse(Qe, Dl) : this._parse(Qe, Dl);
                            }
                            _parse(Qe, rt) {
                                function r(Qe, rt, Wn) {
                                    return "assert" === Wn ? new Fe(rt, [
                                        Qe
                                    ]) : "coerce" === Wn ? new Le(rt, [
                                        Qe
                                    ]) : Qe;
                                }
                                if (null !== Qe && "string" != typeof Qe && "boolean" != typeof Qe && "number" != typeof Qe || (Qe = [
                                    "literal",
                                    Qe
                                ]), Array.isArray(Qe)) {
                                    if (0 === Qe.length) return this.error('Expected an array with at least one element. If you wanted a literal array, use ["literal", []].');
                                    const Wn = Qe[0];
                                    if ("string" != typeof Wn) return this.error(`Expression name must be a string, but found ${typeof Wn} instead. If you wanted a literal array, use ["literal", [...]].`, 0), null;
                                    const Co = this.registry[Wn];
                                    if (Co) {
                                        let Wn = Co.parse(Qe, this);
                                        if (!Wn) return null;
                                        if (this.expectedType) {
                                            const Qe = this.expectedType, Co = Wn.type;
                                            if ("string" !== Qe.kind && "number" !== Qe.kind && "boolean" !== Qe.kind && "object" !== Qe.kind && "array" !== Qe.kind || "value" !== Co.kind) {
                                                if ("projectionDefinition" !== Qe.kind || "string" !== Co.kind && "array" !== Co.kind) {
                                                    if ("color" !== Qe.kind && "formatted" !== Qe.kind && "resolvedImage" !== Qe.kind || "value" !== Co.kind && "string" !== Co.kind) {
                                                        if ("padding" !== Qe.kind || "value" !== Co.kind && "number" !== Co.kind && "array" !== Co.kind) {
                                                            if ("variableAnchorOffsetCollection" !== Qe.kind || "value" !== Co.kind && "array" !== Co.kind) {
                                                                if (this.checkSubtype(Qe, Co)) return null;
                                                            } else Wn = r(Wn, Qe, rt.typeAnnotation || "coerce");
                                                        } else Wn = r(Wn, Qe, rt.typeAnnotation || "coerce");
                                                    } else Wn = r(Wn, Qe, rt.typeAnnotation || "coerce");
                                                } else Wn = r(Wn, Qe, rt.typeAnnotation || "coerce");
                                            } else Wn = r(Wn, Qe, rt.typeAnnotation || "assert");
                                        }
                                        if (!(Wn instanceof Ee) && "resolvedImage" !== Wn.type.kind && this._isConstant(Wn)) {
                                            const rt = new De;
                                            try {
                                                Wn = new Ee(Wn.type, Wn.evaluate(rt));
                                            } catch (Qe) {
                                                return this.error(Qe.message), null;
                                            }
                                        }
                                        return Wn;
                                    }
                                    return this.error(`Unknown expression "${Wn}". If you wanted a literal array, use ["literal", [...]].`, 0);
                                }
                                return this.error(void 0 === Qe ? "'undefined' value invalid. Use null instead." : "object" == typeof Qe ? 'Bare objects invalid. Use ["literal", {...}] instead.' : `Expected an array, but found ${typeof Qe} instead.`);
                            }
                            concat(Qe, rt, Wn) {
                                const Co = "number" == typeof Qe ? this.path.concat(Qe) : this.path, Dl = Wn ? this.scope.concat(Wn) : this.scope;
                                return new Re(this.registry, this._isConstant, Co, rt || null, Dl, this.errors);
                            }
                            error(Qe, ...rt) {
                                const Wn = `${this.key}${rt.map((Qe)=>`[${Qe}]`).join("")}`;
                                this.errors.push(new zt(Wn, Qe));
                            }
                            checkSubtype(Qe, rt) {
                                const Wn = Zt(Qe, rt);
                                return Wn && this.error(Wn), Wn;
                            }
                        }
                        class je {
                            constructor(Qe, rt){
                                this.type = rt.type, this.bindings = [].concat(Qe), this.result = rt;
                            }
                            evaluate(Qe) {
                                return this.result.evaluate(Qe);
                            }
                            eachChild(Qe) {
                                for (const rt of this.bindings)Qe(rt[1]);
                                Qe(this.result);
                            }
                            static parse(Qe, rt) {
                                if (Qe.length < 4) return rt.error(`Expected at least 3 arguments, but found ${Qe.length - 1} instead.`);
                                const Wn = [];
                                for(let Dl = 1; Dl < Qe.length - 1; Dl += 2){
                                    const Co = Qe[Dl];
                                    if ("string" != typeof Co) return rt.error(`Expected string, but found ${typeof Co} instead.`, Dl);
                                    if (/[^a-zA-Z0-9_]/.test(Co)) return rt.error("Variable names must contain only alphanumeric characters or '_'.", Dl);
                                    const Ll = rt.parse(Qe[Dl + 1], Dl + 1);
                                    if (!Ll) return null;
                                    Wn.push([
                                        Co,
                                        Ll
                                    ]);
                                }
                                const Co = rt.parse(Qe[Qe.length - 1], Qe.length - 1, rt.expectedType, Wn);
                                return Co ? new je(Wn, Co) : null;
                            }
                            outputDefined() {
                                return this.result.outputDefined();
                            }
                        }
                        class Ne {
                            constructor(Qe, rt){
                                this.type = rt.type, this.name = Qe, this.boundExpression = rt;
                            }
                            static parse(Qe, rt) {
                                if (2 !== Qe.length || "string" != typeof Qe[1]) return rt.error("'var' expression requires exactly one string literal argument.");
                                const Wn = Qe[1];
                                return rt.scope.has(Wn) ? new Ne(Wn, rt.scope.get(Wn)) : rt.error(`Unknown variable "${Wn}". Make sure "${Wn}" has been bound in an enclosing "let" expression before using it.`, 1);
                            }
                            evaluate(Qe) {
                                return this.boundExpression.evaluate(Qe);
                            }
                            eachChild() {}
                            outputDefined() {
                                return !1;
                            }
                        }
                        class Ue {
                            constructor(Qe, rt, Wn){
                                this.type = Qe, this.index = rt, this.input = Wn;
                            }
                            static parse(Qe, rt) {
                                if (3 !== Qe.length) return rt.error(`Expected 2 arguments, but found ${Qe.length - 1} instead.`);
                                const Wn = rt.parse(Qe[1], 1, td), Co = rt.parse(Qe[2], 2, Ut(rt.expectedType || od));
                                return Wn && Co ? new Ue(Co.type.itemType, Wn, Co) : null;
                            }
                            evaluate(Qe) {
                                const rt = this.index.evaluate(Qe), Wn = this.input.evaluate(Qe);
                                if (rt < 0) throw new Ae(`Array index out of bounds: ${rt} < 0.`);
                                if (rt >= Wn.length) throw new Ae(`Array index out of bounds: ${rt} > ${Wn.length - 1}.`);
                                if (rt !== Math.floor(rt)) throw new Ae(`Array index must be an integer, but found ${rt} instead.`);
                                return Wn[rt];
                            }
                            eachChild(Qe) {
                                Qe(this.index), Qe(this.input);
                            }
                            outputDefined() {
                                return !1;
                            }
                        }
                        class qe {
                            constructor(Qe, rt){
                                this.type = nd, this.needle = Qe, this.haystack = rt;
                            }
                            static parse(Qe, rt) {
                                if (3 !== Qe.length) return rt.error(`Expected 2 arguments, but found ${Qe.length - 1} instead.`);
                                const Wn = rt.parse(Qe[1], 1, od), Co = rt.parse(Qe[2], 2, od);
                                return Wn && Co ? Kt(Wn.type, [
                                    nd,
                                    id,
                                    td,
                                    ed,
                                    od
                                ]) ? new qe(Wn, Co) : rt.error(`Expected first argument to be of type boolean, string, number or null, but found ${qt(Wn.type)} instead`) : null;
                            }
                            evaluate(Qe) {
                                const rt = this.needle.evaluate(Qe), Wn = this.haystack.evaluate(Qe);
                                if (!Wn) return !1;
                                if (!Xt(rt, [
                                    "boolean",
                                    "string",
                                    "number",
                                    "null"
                                ])) throw new Ae(`Expected first argument to be of type boolean, string, number or null, but found ${qt(Be(rt))} instead.`);
                                if (!Xt(Wn, [
                                    "string",
                                    "array"
                                ])) throw new Ae(`Expected second argument to be of type array or string, but found ${qt(Be(Wn))} instead.`);
                                return Wn.indexOf(rt) >= 0;
                            }
                            eachChild(Qe) {
                                Qe(this.needle), Qe(this.haystack);
                            }
                            outputDefined() {
                                return !0;
                            }
                        }
                        class Ge {
                            constructor(Qe, rt, Wn){
                                this.type = td, this.needle = Qe, this.haystack = rt, this.fromIndex = Wn;
                            }
                            static parse(Qe, rt) {
                                if (Qe.length <= 2 || Qe.length >= 5) return rt.error(`Expected 3 or 4 arguments, but found ${Qe.length - 1} instead.`);
                                const Wn = rt.parse(Qe[1], 1, od), Co = rt.parse(Qe[2], 2, od);
                                if (!Wn || !Co) return null;
                                if (!Kt(Wn.type, [
                                    nd,
                                    id,
                                    td,
                                    ed,
                                    od
                                ])) return rt.error(`Expected first argument to be of type boolean, string, number or null, but found ${qt(Wn.type)} instead`);
                                if (4 === Qe.length) {
                                    const Dl = rt.parse(Qe[3], 3, td);
                                    return Dl ? new Ge(Wn, Co, Dl) : null;
                                }
                                return new Ge(Wn, Co);
                            }
                            evaluate(Qe) {
                                const rt = this.needle.evaluate(Qe), Wn = this.haystack.evaluate(Qe);
                                if (!Xt(rt, [
                                    "boolean",
                                    "string",
                                    "number",
                                    "null"
                                ])) throw new Ae(`Expected first argument to be of type boolean, string, number or null, but found ${qt(Be(rt))} instead.`);
                                let Co;
                                if (this.fromIndex && (Co = this.fromIndex.evaluate(Qe)), Xt(Wn, [
                                    "string"
                                ])) {
                                    const Qe = Wn.indexOf(rt, Co);
                                    return -1 === Qe ? -1 : [
                                        ...Wn.slice(0, Qe)
                                    ].length;
                                }
                                if (Xt(Wn, [
                                    "array"
                                ])) return Wn.indexOf(rt, Co);
                                throw new Ae(`Expected second argument to be of type array or string, but found ${qt(Be(Wn))} instead.`);
                            }
                            eachChild(Qe) {
                                Qe(this.needle), Qe(this.haystack), this.fromIndex && Qe(this.fromIndex);
                            }
                            outputDefined() {
                                return !1;
                            }
                        }
                        class Ze {
                            constructor(Qe, rt, Wn, Co, Dl, Ll){
                                this.inputType = Qe, this.type = rt, this.input = Wn, this.cases = Co, this.outputs = Dl, this.otherwise = Ll;
                            }
                            static parse(Qe, rt) {
                                if (Qe.length < 5) return rt.error(`Expected at least 4 arguments, but found only ${Qe.length - 1}.`);
                                if (Qe.length % 2 != 1) return rt.error("Expected an even number of arguments.");
                                let Wn, Co;
                                rt.expectedType && "value" !== rt.expectedType.kind && (Co = rt.expectedType);
                                const Dl = {}, Ll = [];
                                for(let Gl = 2; Gl < Qe.length - 1; Gl += 2){
                                    let Rl = Qe[Gl];
                                    const Ul = Qe[Gl + 1];
                                    Array.isArray(Rl) || (Rl = [
                                        Rl
                                    ]);
                                    const Zl = rt.concat(Gl);
                                    if (0 === Rl.length) return Zl.error("Expected at least one branch label.");
                                    for (const Qe of Rl){
                                        if ("number" != typeof Qe && "string" != typeof Qe) return Zl.error("Branch labels must be numbers or strings.");
                                        if ("number" == typeof Qe && Math.abs(Qe) > Number.MAX_SAFE_INTEGER) return Zl.error(`Branch labels must be integers no larger than ${Number.MAX_SAFE_INTEGER}.`);
                                        if ("number" == typeof Qe && Math.floor(Qe) !== Qe) return Zl.error("Numeric branch labels must be integer values.");
                                        if (Wn) {
                                            if (Zl.checkSubtype(Wn, Be(Qe))) return null;
                                        } else Wn = Be(Qe);
                                        if (void 0 !== Dl[String(Qe)]) return Zl.error("Branch labels must be unique.");
                                        Dl[String(Qe)] = Ll.length;
                                    }
                                    const Hl = rt.parse(Ul, Gl, Co);
                                    if (!Hl) return null;
                                    Co = Co || Hl.type, Ll.push(Hl);
                                }
                                const Rl = rt.parse(Qe[1], 1, od);
                                if (!Rl) return null;
                                const Ul = rt.parse(Qe[Qe.length - 1], Qe.length - 1, Co);
                                return Ul ? "value" !== Rl.type.kind && rt.concat(1).checkSubtype(Wn, Rl.type) ? null : new Ze(Wn, Co, Rl, Dl, Ll, Ul) : null;
                            }
                            evaluate(Qe) {
                                const rt = this.input.evaluate(Qe);
                                return (Be(rt) === this.inputType && this.outputs[this.cases[rt]] || this.otherwise).evaluate(Qe);
                            }
                            eachChild(Qe) {
                                Qe(this.input), this.outputs.forEach(Qe), Qe(this.otherwise);
                            }
                            outputDefined() {
                                return this.outputs.every((Qe)=>Qe.outputDefined()) && this.otherwise.outputDefined();
                            }
                        }
                        class Ke {
                            constructor(Qe, rt, Wn){
                                this.type = Qe, this.branches = rt, this.otherwise = Wn;
                            }
                            static parse(Qe, rt) {
                                if (Qe.length < 4) return rt.error(`Expected at least 3 arguments, but found only ${Qe.length - 1}.`);
                                if (Qe.length % 2 != 0) return rt.error("Expected an odd number of arguments.");
                                let Wn;
                                rt.expectedType && "value" !== rt.expectedType.kind && (Wn = rt.expectedType);
                                const Co = [];
                                for(let Ll = 1; Ll < Qe.length - 1; Ll += 2){
                                    const Dl = rt.parse(Qe[Ll], Ll, nd);
                                    if (!Dl) return null;
                                    const Rl = rt.parse(Qe[Ll + 1], Ll + 1, Wn);
                                    if (!Rl) return null;
                                    Co.push([
                                        Dl,
                                        Rl
                                    ]), Wn = Wn || Rl.type;
                                }
                                const Dl = rt.parse(Qe[Qe.length - 1], Qe.length - 1, Wn);
                                if (!Dl) return null;
                                if (!Wn) throw new Error("Can't infer output type");
                                return new Ke(Wn, Co, Dl);
                            }
                            evaluate(Qe) {
                                for (const [rt, Wn] of this.branches)if (rt.evaluate(Qe)) return Wn.evaluate(Qe);
                                return this.otherwise.evaluate(Qe);
                            }
                            eachChild(Qe) {
                                for (const [rt, Wn] of this.branches)Qe(rt), Qe(Wn);
                                Qe(this.otherwise);
                            }
                            outputDefined() {
                                return this.branches.every(([Qe, rt])=>rt.outputDefined()) && this.otherwise.outputDefined();
                            }
                        }
                        class Xe {
                            constructor(Qe, rt, Wn, Co){
                                this.type = Qe, this.input = rt, this.beginIndex = Wn, this.endIndex = Co;
                            }
                            static parse(Qe, rt) {
                                if (Qe.length <= 2 || Qe.length >= 5) return rt.error(`Expected 3 or 4 arguments, but found ${Qe.length - 1} instead.`);
                                const Wn = rt.parse(Qe[1], 1, od), Co = rt.parse(Qe[2], 2, td);
                                if (!Wn || !Co) return null;
                                if (!Kt(Wn.type, [
                                    Ut(od),
                                    id,
                                    od
                                ])) return rt.error(`Expected first argument to be of type array or string, but found ${qt(Wn.type)} instead`);
                                if (4 === Qe.length) {
                                    const Dl = rt.parse(Qe[3], 3, td);
                                    return Dl ? new Xe(Wn.type, Wn, Co, Dl) : null;
                                }
                                return new Xe(Wn.type, Wn, Co);
                            }
                            evaluate(Qe) {
                                const rt = this.input.evaluate(Qe), Wn = this.beginIndex.evaluate(Qe);
                                let Co;
                                if (this.endIndex && (Co = this.endIndex.evaluate(Qe)), Xt(rt, [
                                    "string"
                                ])) return [
                                    ...rt
                                ].slice(Wn, Co).join("");
                                if (Xt(rt, [
                                    "array"
                                ])) return rt.slice(Wn, Co);
                                throw new Ae(`Expected first argument to be of type array or string, but found ${qt(Be(rt))} instead.`);
                            }
                            eachChild(Qe) {
                                Qe(this.input), Qe(this.beginIndex), this.endIndex && Qe(this.endIndex);
                            }
                            outputDefined() {
                                return !1;
                            }
                        }
                        function He(Qe, rt) {
                            const Wn = Qe.length - 1;
                            let Co, Dl, Ll = 0, Rl = Wn, Ul = 0;
                            for(; Ll <= Rl;)if (Ul = Math.floor((Ll + Rl) / 2), Co = Qe[Ul], Dl = Qe[Ul + 1], Co <= rt) {
                                if (Ul === Wn || rt < Dl) return Ul;
                                Ll = Ul + 1;
                            } else {
                                if (!(Co > rt)) throw new Ae("Input is not a number.");
                                Rl = Ul - 1;
                            }
                            return 0;
                        }
                        class Ye {
                            constructor(Qe, rt, Wn){
                                this.type = Qe, this.input = rt, this.labels = [], this.outputs = [];
                                for (const [Co, Dl] of Wn)this.labels.push(Co), this.outputs.push(Dl);
                            }
                            static parse(Qe, rt) {
                                if (Qe.length - 1 < 4) return rt.error(`Expected at least 4 arguments, but found only ${Qe.length - 1}.`);
                                if ((Qe.length - 1) % 2 != 0) return rt.error("Expected an even number of arguments.");
                                const Wn = rt.parse(Qe[1], 1, td);
                                if (!Wn) return null;
                                const Co = [];
                                let Dl = null;
                                rt.expectedType && "value" !== rt.expectedType.kind && (Dl = rt.expectedType);
                                for(let Ll = 1; Ll < Qe.length; Ll += 2){
                                    const Wn = 1 === Ll ? -1 / 0 : Qe[Ll], Rl = Qe[Ll + 1], Ul = Ll, Gl = Ll + 1;
                                    if ("number" != typeof Wn) return rt.error('Input/output pairs for "step" expressions must be defined using literal numeric values (not computed expressions) for the input values.', Ul);
                                    if (Co.length && Co[Co.length - 1][0] >= Wn) return rt.error('Input/output pairs for "step" expressions must be arranged with input values in strictly ascending order.', Ul);
                                    const Zl = rt.parse(Rl, Gl, Dl);
                                    if (!Zl) return null;
                                    Dl = Dl || Zl.type, Co.push([
                                        Wn,
                                        Zl
                                    ]);
                                }
                                return new Ye(Dl, Wn, Co);
                            }
                            evaluate(Qe) {
                                const rt = this.labels, Wn = this.outputs;
                                if (1 === rt.length) return Wn[0].evaluate(Qe);
                                const Co = this.input.evaluate(Qe);
                                if (Co <= rt[0]) return Wn[0].evaluate(Qe);
                                const Dl = rt.length;
                                return Co >= rt[Dl - 1] ? Wn[Dl - 1].evaluate(Qe) : Wn[He(rt, Co)].evaluate(Qe);
                            }
                            eachChild(Qe) {
                                Qe(this.input);
                                for (const rt of this.outputs)Qe(rt);
                            }
                            outputDefined() {
                                return this.outputs.every((Qe)=>Qe.outputDefined());
                            }
                        }
                        function Je(Qe) {
                            return Qe && Qe.__esModule && Object.prototype.hasOwnProperty.call(Qe, "default") ? Qe.default : Qe;
                        }
                        var Cd, kd, Id = function() {
                            if (kd) return Cd;
                            function t(Qe, rt, Wn, Co) {
                                this.cx = 3 * Qe, this.bx = 3 * (Wn - Qe) - this.cx, this.ax = 1 - this.cx - this.bx, this.cy = 3 * rt, this.by = 3 * (Co - rt) - this.cy, this.ay = 1 - this.cy - this.by, this.p1x = Qe, this.p1y = rt, this.p2x = Wn, this.p2y = Co;
                            }
                            return kd = 1, Cd = t, t.prototype = {
                                sampleCurveX: function(Qe) {
                                    return ((this.ax * Qe + this.bx) * Qe + this.cx) * Qe;
                                },
                                sampleCurveY: function(Qe) {
                                    return ((this.ay * Qe + this.by) * Qe + this.cy) * Qe;
                                },
                                sampleCurveDerivativeX: function(Qe) {
                                    return (3 * this.ax * Qe + 2 * this.bx) * Qe + this.cx;
                                },
                                solveCurveX: function(Qe, rt) {
                                    if (void 0 === rt && (rt = 1e-6), Qe < 0) return 0;
                                    if (Qe > 1) return 1;
                                    for(var Wn = Qe, Co = 0; Co < 8; Co++){
                                        var Dl = this.sampleCurveX(Wn) - Qe;
                                        if (Math.abs(Dl) < rt) return Wn;
                                        var Ll = this.sampleCurveDerivativeX(Wn);
                                        if (Math.abs(Ll) < 1e-6) break;
                                        Wn -= Dl / Ll;
                                    }
                                    var Rl = 0, Ul = 1;
                                    for(Wn = Qe, Co = 0; Co < 20 && (Dl = this.sampleCurveX(Wn), !(Math.abs(Dl - Qe) < rt)); Co++)Qe > Dl ? Rl = Wn : Ul = Wn, Wn = .5 * (Ul - Rl) + Rl;
                                    return Wn;
                                },
                                solve: function(Qe, rt) {
                                    return this.sampleCurveY(this.solveCurveX(Qe, rt));
                                }
                            }, Cd;
                        }(), Dd = Je(Id);
                        class rr {
                            constructor(Qe, rt, Wn, Co, Dl){
                                this.type = Qe, this.operator = rt, this.interpolation = Wn, this.input = Co, this.labels = [], this.outputs = [];
                                for (const [Ll, Rl] of Dl)this.labels.push(Ll), this.outputs.push(Rl);
                            }
                            static interpolationFactor(Qe, rt, Wn, Co) {
                                let Dl = 0;
                                if ("exponential" === Qe.name) Dl = nr(rt, Qe.base, Wn, Co);
                                else if ("linear" === Qe.name) Dl = nr(rt, 1, Wn, Co);
                                else if ("cubic-bezier" === Qe.name) {
                                    const Ll = Qe.controlPoints;
                                    Dl = new Dd(Ll[0], Ll[1], Ll[2], Ll[3]).solve(nr(rt, 1, Wn, Co));
                                }
                                return Dl;
                            }
                            static parse(Qe, rt) {
                                let [Wn, Co, Dl, ...Ll] = Qe;
                                if (!Array.isArray(Co) || 0 === Co.length) return rt.error("Expected an interpolation type expression.", 1);
                                if ("linear" === Co[0]) Co = {
                                    name: "linear"
                                };
                                else if ("exponential" === Co[0]) {
                                    const Qe = Co[1];
                                    if ("number" != typeof Qe) return rt.error("Exponential interpolation requires a numeric base.", 1, 1);
                                    Co = {
                                        name: "exponential",
                                        base: Qe
                                    };
                                } else {
                                    if ("cubic-bezier" !== Co[0]) return rt.error(`Unknown interpolation type ${String(Co[0])}`, 1, 0);
                                    {
                                        const Qe = Co.slice(1);
                                        if (4 !== Qe.length || Qe.some((Qe)=>"number" != typeof Qe || Qe < 0 || Qe > 1)) return rt.error("Cubic bezier interpolation requires four numeric arguments with values between 0 and 1.", 1);
                                        Co = {
                                            name: "cubic-bezier",
                                            controlPoints: Qe
                                        };
                                    }
                                }
                                if (Qe.length - 1 < 4) return rt.error(`Expected at least 4 arguments, but found only ${Qe.length - 1}.`);
                                if ((Qe.length - 1) % 2 != 0) return rt.error("Expected an even number of arguments.");
                                if (Dl = rt.parse(Dl, 2, td), !Dl) return null;
                                const Rl = [];
                                let Ul = null;
                                "interpolate-hcl" === Wn || "interpolate-lab" === Wn ? Ul = rd : rt.expectedType && "value" !== rt.expectedType.kind && (Ul = rt.expectedType);
                                for(let Gl = 0; Gl < Ll.length; Gl += 2){
                                    const Qe = Ll[Gl], Wn = Ll[Gl + 1], Co = Gl + 3, Dl = Gl + 4;
                                    if ("number" != typeof Qe) return rt.error('Input/output pairs for "interpolate" expressions must be defined using literal numeric values (not computed expressions) for the input values.', Co);
                                    if (Rl.length && Rl[Rl.length - 1][0] >= Qe) return rt.error('Input/output pairs for "interpolate" expressions must be arranged with input values in strictly ascending order.', Co);
                                    const Zl = rt.parse(Wn, Dl, Ul);
                                    if (!Zl) return null;
                                    Ul = Ul || Zl.type, Rl.push([
                                        Qe,
                                        Zl
                                    ]);
                                }
                                return Ht(Ul, td) || Ht(Ul, sd) || Ht(Ul, rd) || Ht(Ul, ud) || Ht(Ul, dd) || Ht(Ul, Ut(td)) ? new rr(Ul, Wn, Co, Dl, Rl) : rt.error(`Type ${qt(Ul)} is not interpolatable.`);
                            }
                            evaluate(Qe) {
                                const rt = this.labels, Wn = this.outputs;
                                if (1 === rt.length) return Wn[0].evaluate(Qe);
                                const Co = this.input.evaluate(Qe);
                                if (Co <= rt[0]) return Wn[0].evaluate(Qe);
                                const Dl = rt.length;
                                if (Co >= rt[Dl - 1]) return Wn[Dl - 1].evaluate(Qe);
                                const Ll = He(rt, Co), Rl = rr.interpolationFactor(this.interpolation, Co, rt[Ll], rt[Ll + 1]), Ul = Wn[Ll].evaluate(Qe), Gl = Wn[Ll + 1].evaluate(Qe);
                                switch(this.operator){
                                    case "interpolate":
                                        switch(this.type.kind){
                                            case "number":
                                                return me(Ul, Gl, Rl);
                                            case "color":
                                                return xe.interpolate(Ul, Gl, Rl);
                                            case "padding":
                                                return Se.interpolate(Ul, Gl, Rl);
                                            case "variableAnchorOffsetCollection":
                                                return Me.interpolate(Ul, Gl, Rl);
                                            case "array":
                                                return ge(Ul, Gl, Rl);
                                            case "projectionDefinition":
                                                return ze.interpolate(Ul, Gl, Rl);
                                        }
                                    case "interpolate-hcl":
                                        return xe.interpolate(Ul, Gl, Rl, "hcl");
                                    case "interpolate-lab":
                                        return xe.interpolate(Ul, Gl, Rl, "lab");
                                }
                            }
                            eachChild(Qe) {
                                Qe(this.input);
                                for (const rt of this.outputs)Qe(rt);
                            }
                            outputDefined() {
                                return this.outputs.every((Qe)=>Qe.outputDefined());
                            }
                        }
                        function nr(Qe, rt, Wn, Co) {
                            const Dl = Co - Wn, Ll = Qe - Wn;
                            return 0 === Dl ? 0 : 1 === rt ? Ll / Dl : (Math.pow(rt, Ll) - 1) / (Math.pow(rt, Dl) - 1);
                        }
                        const Ld = {
                            color: xe.interpolate,
                            number: me,
                            padding: Se.interpolate,
                            variableAnchorOffsetCollection: Me.interpolate,
                            array: ge
                        };
                        class sr {
                            constructor(Qe, rt){
                                this.type = Qe, this.args = rt;
                            }
                            static parse(Qe, rt) {
                                if (Qe.length < 2) return rt.error("Expected at least one argument.");
                                let Wn = null;
                                const Co = rt.expectedType;
                                Co && "value" !== Co.kind && (Wn = Co);
                                const Dl = [];
                                for (const Rl of Qe.slice(1)){
                                    const Qe = rt.parse(Rl, 1 + Dl.length, Wn, void 0, {
                                        typeAnnotation: "omit"
                                    });
                                    if (!Qe) return null;
                                    Wn = Wn || Qe.type, Dl.push(Qe);
                                }
                                if (!Wn) throw new Error("No output type");
                                const Ll = Co && Dl.some((Qe)=>Zt(Co, Qe.type));
                                return new sr(Ll ? od : Wn, Dl);
                            }
                            evaluate(Qe) {
                                let rt, Wn = null, Co = 0;
                                for (const Dl of this.args)if (Co++, Wn = Dl.evaluate(Qe), Wn && Wn instanceof Ie && !Wn.available && (rt || (rt = Wn.name), Wn = null, Co === this.args.length && (Wn = rt)), null !== Wn) break;
                                return Wn;
                            }
                            eachChild(Qe) {
                                this.args.forEach(Qe);
                            }
                            outputDefined() {
                                return this.args.every((Qe)=>Qe.outputDefined());
                            }
                        }
                        function ar(Qe, rt) {
                            return "==" === Qe || "!=" === Qe ? "boolean" === rt.kind || "string" === rt.kind || "number" === rt.kind || "null" === rt.kind || "value" === rt.kind : "string" === rt.kind || "number" === rt.kind || "value" === rt.kind;
                        }
                        function or(Qe, rt, Wn, Co) {
                            return 0 === Co.compare(rt, Wn);
                        }
                        function lr(Qe, rt, Wn) {
                            const Co = "==" !== Qe && "!=" !== Qe;
                            return class i {
                                constructor(Qe, rt, Wn){
                                    this.type = nd, this.lhs = Qe, this.rhs = rt, this.collator = Wn, this.hasUntypedArgument = "value" === Qe.type.kind || "value" === rt.type.kind;
                                }
                                static parse(Qe, rt) {
                                    if (3 !== Qe.length && 4 !== Qe.length) return rt.error("Expected two or three arguments.");
                                    const Wn = Qe[0];
                                    let Dl = rt.parse(Qe[1], 1, od);
                                    if (!Dl) return null;
                                    if (!ar(Wn, Dl.type)) return rt.concat(1).error(`"${Wn}" comparisons are not supported for type '${qt(Dl.type)}'.`);
                                    let Ll = rt.parse(Qe[2], 2, od);
                                    if (!Ll) return null;
                                    if (!ar(Wn, Ll.type)) return rt.concat(2).error(`"${Wn}" comparisons are not supported for type '${qt(Ll.type)}'.`);
                                    if (Dl.type.kind !== Ll.type.kind && "value" !== Dl.type.kind && "value" !== Ll.type.kind) return rt.error(`Cannot compare types '${qt(Dl.type)}' and '${qt(Ll.type)}'.`);
                                    Co && ("value" === Dl.type.kind && "value" !== Ll.type.kind ? Dl = new Fe(Ll.type, [
                                        Dl
                                    ]) : "value" !== Dl.type.kind && "value" === Ll.type.kind && (Ll = new Fe(Dl.type, [
                                        Ll
                                    ])));
                                    let Rl = null;
                                    if (4 === Qe.length) {
                                        if ("string" !== Dl.type.kind && "string" !== Ll.type.kind && "value" !== Dl.type.kind && "value" !== Ll.type.kind) return rt.error("Cannot use collator to compare non-string types.");
                                        if (Rl = rt.parse(Qe[3], 3, ld), !Rl) return null;
                                    }
                                    return new i(Dl, Ll, Rl);
                                }
                                evaluate(Dl) {
                                    const Ll = this.lhs.evaluate(Dl), Rl = this.rhs.evaluate(Dl);
                                    if (Co && this.hasUntypedArgument) {
                                        const rt = Be(Ll), Wn = Be(Rl);
                                        if (rt.kind !== Wn.kind || "string" !== rt.kind && "number" !== rt.kind) throw new Ae(`Expected arguments for "${Qe}" to be (string, string) or (number, number), but found (${rt.kind}, ${Wn.kind}) instead.`);
                                    }
                                    if (this.collator && !Co && this.hasUntypedArgument) {
                                        const Qe = Be(Ll), Wn = Be(Rl);
                                        if ("string" !== Qe.kind || "string" !== Wn.kind) return rt(Dl, Ll, Rl);
                                    }
                                    return this.collator ? Wn(Dl, Ll, Rl, this.collator.evaluate(Dl)) : rt(Dl, Ll, Rl);
                                }
                                eachChild(Qe) {
                                    Qe(this.lhs), Qe(this.rhs), this.collator && Qe(this.collator);
                                }
                                outputDefined() {
                                    return !0;
                                }
                            };
                        }
                        const Pd = lr("==", function(Qe, rt, Wn) {
                            return rt === Wn;
                        }, or), zd = lr("!=", function(Qe, rt, Wn) {
                            return rt !== Wn;
                        }, function(Qe, rt, Wn, Co) {
                            return !or(0, rt, Wn, Co);
                        }), Nd = lr("<", function(Qe, rt, Wn) {
                            return rt < Wn;
                        }, function(Qe, rt, Wn, Co) {
                            return Co.compare(rt, Wn) < 0;
                        }), Rd = lr(">", function(Qe, rt, Wn) {
                            return rt > Wn;
                        }, function(Qe, rt, Wn, Co) {
                            return Co.compare(rt, Wn) > 0;
                        }), Bd = lr("<=", function(Qe, rt, Wn) {
                            return rt <= Wn;
                        }, function(Qe, rt, Wn, Co) {
                            return Co.compare(rt, Wn) <= 0;
                        }), Od = lr(">=", function(Qe, rt, Wn) {
                            return rt >= Wn;
                        }, function(Qe, rt, Wn, Co) {
                            return Co.compare(rt, Wn) >= 0;
                        });
                        class yr {
                            constructor(Qe, rt, Wn){
                                this.type = ld, this.locale = Wn, this.caseSensitive = Qe, this.diacriticSensitive = rt;
                            }
                            static parse(Qe, rt) {
                                if (2 !== Qe.length) return rt.error("Expected one argument.");
                                const Wn = Qe[1];
                                if ("object" != typeof Wn || Array.isArray(Wn)) return rt.error("Collator options argument must be an object.");
                                const Co = rt.parse(void 0 !== Wn["case-sensitive"] && Wn["case-sensitive"], 1, nd);
                                if (!Co) return null;
                                const Dl = rt.parse(void 0 !== Wn["diacritic-sensitive"] && Wn["diacritic-sensitive"], 1, nd);
                                if (!Dl) return null;
                                let Ll = null;
                                return Wn.locale && (Ll = rt.parse(Wn.locale, 1, id), !Ll) ? null : new yr(Co, Dl, Ll);
                            }
                            evaluate(Qe) {
                                return new ve(this.caseSensitive.evaluate(Qe), this.diacriticSensitive.evaluate(Qe), this.locale ? this.locale.evaluate(Qe) : null);
                            }
                            eachChild(Qe) {
                                Qe(this.caseSensitive), Qe(this.diacriticSensitive), this.locale && Qe(this.locale);
                            }
                            outputDefined() {
                                return !1;
                            }
                        }
                        class mr {
                            constructor(Qe, rt, Wn, Co, Dl){
                                this.type = id, this.number = Qe, this.locale = rt, this.currency = Wn, this.minFractionDigits = Co, this.maxFractionDigits = Dl;
                            }
                            static parse(Qe, rt) {
                                if (3 !== Qe.length) return rt.error("Expected two arguments.");
                                const Wn = rt.parse(Qe[1], 1, td);
                                if (!Wn) return null;
                                const Co = Qe[2];
                                if ("object" != typeof Co || Array.isArray(Co)) return rt.error("NumberFormat options argument must be an object.");
                                let Dl = null;
                                if (Co.locale && (Dl = rt.parse(Co.locale, 1, id), !Dl)) return null;
                                let Ll = null;
                                if (Co.currency && (Ll = rt.parse(Co.currency, 1, id), !Ll)) return null;
                                let Rl = null;
                                if (Co["min-fraction-digits"] && (Rl = rt.parse(Co["min-fraction-digits"], 1, td), !Rl)) return null;
                                let Ul = null;
                                return Co["max-fraction-digits"] && (Ul = rt.parse(Co["max-fraction-digits"], 1, td), !Ul) ? null : new mr(Wn, Dl, Ll, Rl, Ul);
                            }
                            evaluate(Qe) {
                                return new Intl.NumberFormat(this.locale ? this.locale.evaluate(Qe) : [], {
                                    style: this.currency ? "currency" : "decimal",
                                    currency: this.currency ? this.currency.evaluate(Qe) : void 0,
                                    minimumFractionDigits: this.minFractionDigits ? this.minFractionDigits.evaluate(Qe) : void 0,
                                    maximumFractionDigits: this.maxFractionDigits ? this.maxFractionDigits.evaluate(Qe) : void 0
                                }).format(this.number.evaluate(Qe));
                            }
                            eachChild(Qe) {
                                Qe(this.number), this.locale && Qe(this.locale), this.currency && Qe(this.currency), this.minFractionDigits && Qe(this.minFractionDigits), this.maxFractionDigits && Qe(this.maxFractionDigits);
                            }
                            outputDefined() {
                                return !1;
                            }
                        }
                        class gr {
                            constructor(Qe){
                                this.type = cd, this.sections = Qe;
                            }
                            static parse(Qe, rt) {
                                if (Qe.length < 2) return rt.error("Expected at least one argument.");
                                const Wn = Qe[1];
                                if (!Array.isArray(Wn) && "object" == typeof Wn) return rt.error("First argument must be an image or text section.");
                                const Co = [];
                                let Dl = !1;
                                for(let Ll = 1; Ll <= Qe.length - 1; ++Ll){
                                    const Wn = Qe[Ll];
                                    if (Dl && "object" == typeof Wn && !Array.isArray(Wn)) {
                                        Dl = !1;
                                        let Qe = null;
                                        if (Wn["font-scale"] && (Qe = rt.parse(Wn["font-scale"], 1, td), !Qe)) return null;
                                        let Ll = null;
                                        if (Wn["text-font"] && (Ll = rt.parse(Wn["text-font"], 1, Ut(id)), !Ll)) return null;
                                        let Rl = null;
                                        if (Wn["text-color"] && (Rl = rt.parse(Wn["text-color"], 1, rd), !Rl)) return null;
                                        let Ul = null;
                                        if (Wn["vertical-align"]) {
                                            if ("string" == typeof Wn["vertical-align"] && !wd.includes(Wn["vertical-align"])) return rt.error(`'vertical-align' must be one of: 'bottom', 'center', 'top' but found '${Wn["vertical-align"]}' instead.`);
                                            if (Ul = rt.parse(Wn["vertical-align"], 1, id), !Ul) return null;
                                        }
                                        const Gl = Co[Co.length - 1];
                                        Gl.scale = Qe, Gl.font = Ll, Gl.textColor = Rl, Gl.verticalAlign = Ul;
                                    } else {
                                        const Wn = rt.parse(Qe[Ll], 1, od);
                                        if (!Wn) return null;
                                        const Rl = Wn.type.kind;
                                        if ("string" !== Rl && "value" !== Rl && "null" !== Rl && "resolvedImage" !== Rl) return rt.error("Formatted text type must be 'string', 'value', 'image' or 'null'.");
                                        Dl = !0, Co.push({
                                            content: Wn,
                                            scale: null,
                                            font: null,
                                            textColor: null,
                                            verticalAlign: null
                                        });
                                    }
                                }
                                return new gr(Co);
                            }
                            evaluate(Qe) {
                                return new _e(this.sections.map((rt)=>{
                                    const Wn = rt.content.evaluate(Qe);
                                    return Be(Wn) === hd ? new we("", Wn, null, null, null, rt.verticalAlign ? rt.verticalAlign.evaluate(Qe) : null) : new we(Ve(Wn), null, rt.scale ? rt.scale.evaluate(Qe) : null, rt.font ? rt.font.evaluate(Qe).join(",") : null, rt.textColor ? rt.textColor.evaluate(Qe) : null, rt.verticalAlign ? rt.verticalAlign.evaluate(Qe) : null);
                                }));
                            }
                            eachChild(Qe) {
                                for (const rt of this.sections)Qe(rt.content), rt.scale && Qe(rt.scale), rt.font && Qe(rt.font), rt.textColor && Qe(rt.textColor), rt.verticalAlign && Qe(rt.verticalAlign);
                            }
                            outputDefined() {
                                return !1;
                            }
                        }
                        class xr {
                            constructor(Qe){
                                this.type = hd, this.input = Qe;
                            }
                            static parse(Qe, rt) {
                                if (2 !== Qe.length) return rt.error("Expected two arguments.");
                                const Wn = rt.parse(Qe[1], 1, id);
                                return Wn ? new xr(Wn) : rt.error("No image name provided.");
                            }
                            evaluate(Qe) {
                                const rt = this.input.evaluate(Qe), Wn = Ie.fromString(rt);
                                return Wn && Qe.availableImages && (Wn.available = Qe.availableImages.indexOf(rt) > -1), Wn;
                            }
                            eachChild(Qe) {
                                Qe(this.input);
                            }
                            outputDefined() {
                                return !1;
                            }
                        }
                        class vr {
                            constructor(Qe){
                                this.type = td, this.input = Qe;
                            }
                            static parse(Qe, rt) {
                                if (2 !== Qe.length) return rt.error(`Expected 1 argument, but found ${Qe.length - 1} instead.`);
                                const Wn = rt.parse(Qe[1], 1);
                                return Wn ? "array" !== Wn.type.kind && "string" !== Wn.type.kind && "value" !== Wn.type.kind ? rt.error(`Expected argument of type string or array, but found ${qt(Wn.type)} instead.`) : new vr(Wn) : null;
                            }
                            evaluate(Qe) {
                                const rt = this.input.evaluate(Qe);
                                if ("string" == typeof rt) return [
                                    ...rt
                                ].length;
                                if (Array.isArray(rt)) return rt.length;
                                throw new Ae(`Expected value to be of type string or array, but found ${qt(Be(rt))} instead.`);
                            }
                            eachChild(Qe) {
                                Qe(this.input);
                            }
                            outputDefined() {
                                return !1;
                            }
                        }
                        const Fd = 8192;
                        function wr(Qe, rt) {
                            const Wn = (180 + Qe[0]) / 360, Co = (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + Qe[1] * Math.PI / 360))) / 360, Dl = Math.pow(2, rt.z);
                            return [
                                Math.round(Wn * Dl * Fd),
                                Math.round(Co * Dl * Fd)
                            ];
                        }
                        function _r(Qe, rt) {
                            const Wn = Math.pow(2, rt.z);
                            var Co, Dl;
                            return [
                                (Dl = (Qe[0] / Fd + rt.x) / Wn, 360 * Dl - 180),
                                (Co = (Qe[1] / Fd + rt.y) / Wn, 360 / Math.PI * Math.atan(Math.exp((180 - 360 * Co) * Math.PI / 180)) - 90)
                            ];
                        }
                        function Sr(Qe, rt) {
                            Qe[0] = Math.min(Qe[0], rt[0]), Qe[1] = Math.min(Qe[1], rt[1]), Qe[2] = Math.max(Qe[2], rt[0]), Qe[3] = Math.max(Qe[3], rt[1]);
                        }
                        function Ar(Qe, rt) {
                            return !(Qe[0] <= rt[0] || Qe[2] >= rt[2] || Qe[1] <= rt[1] || Qe[3] >= rt[3]);
                        }
                        function kr(Qe, rt, Wn) {
                            const Co = Qe[0] - rt[0], Dl = Qe[1] - rt[1], Ll = Qe[0] - Wn[0], Rl = Qe[1] - Wn[1];
                            return Co * Rl - Ll * Dl == 0 && Co * Ll <= 0 && Dl * Rl <= 0;
                        }
                        function Mr(Qe, rt, Wn, Co) {
                            var Dl, Ll;
                            return 0 != (Dl = [
                                Co[0] - Wn[0],
                                Co[1] - Wn[1]
                            ])[0] * (Ll = [
                                rt[0] - Qe[0],
                                rt[1] - Qe[1]
                            ])[1] - Dl[1] * Ll[0] && !(!Vr(Qe, rt, Wn, Co) || !Vr(Wn, Co, Qe, rt));
                        }
                        function Ir(Qe, rt, Wn) {
                            for (const Co of Wn)for(let Wn = 0; Wn < Co.length - 1; ++Wn)if (Mr(Qe, rt, Co[Wn], Co[Wn + 1])) return !0;
                            return !1;
                        }
                        function zr(Qe, rt, Wn = !1) {
                            let Co = !1;
                            for (const Ul of rt)for(let rt = 0; rt < Ul.length - 1; rt++){
                                if (kr(Qe, Ul[rt], Ul[rt + 1])) return Wn;
                                (Ll = Ul[rt])[1] > (Dl = Qe)[1] != (Rl = Ul[rt + 1])[1] > Dl[1] && Dl[0] < (Rl[0] - Ll[0]) * (Dl[1] - Ll[1]) / (Rl[1] - Ll[1]) + Ll[0] && (Co = !Co);
                            }
                            var Dl, Ll, Rl;
                            return Co;
                        }
                        function Pr(Qe, rt) {
                            for (const Wn of rt)if (zr(Qe, Wn)) return !0;
                            return !1;
                        }
                        function Cr(Qe, rt) {
                            for (const Wn of Qe)if (!zr(Wn, rt)) return !1;
                            for(let Wn = 0; Wn < Qe.length - 1; ++Wn)if (Ir(Qe[Wn], Qe[Wn + 1], rt)) return !1;
                            return !0;
                        }
                        function Br(Qe, rt) {
                            for (const Wn of rt)if (Cr(Qe, Wn)) return !0;
                            return !1;
                        }
                        function Vr(Qe, rt, Wn, Co) {
                            const Dl = Co[0] - Wn[0], Ll = Co[1] - Wn[1], Rl = (Qe[0] - Wn[0]) * Ll - Dl * (Qe[1] - Wn[1]), Ul = (rt[0] - Wn[0]) * Ll - Dl * (rt[1] - Wn[1]);
                            return Rl > 0 && Ul < 0 || Rl < 0 && Ul > 0;
                        }
                        function Er(Qe, rt, Wn) {
                            const Co = [];
                            for(let Dl = 0; Dl < Qe.length; Dl++){
                                const Ll = [];
                                for(let Co = 0; Co < Qe[Dl].length; Co++){
                                    const Rl = wr(Qe[Dl][Co], Wn);
                                    Sr(rt, Rl), Ll.push(Rl);
                                }
                                Co.push(Ll);
                            }
                            return Co;
                        }
                        function Tr(Qe, rt, Wn) {
                            const Co = [];
                            for(let Dl = 0; Dl < Qe.length; Dl++){
                                const Ll = Er(Qe[Dl], rt, Wn);
                                Co.push(Ll);
                            }
                            return Co;
                        }
                        function Fr(Qe, rt, Wn, Co) {
                            if (Qe[0] < Wn[0] || Qe[0] > Wn[2]) {
                                const rt = .5 * Co;
                                let Dl = Qe[0] - Wn[0] > rt ? -Co : Wn[0] - Qe[0] > rt ? Co : 0;
                                0 === Dl && (Dl = Qe[0] - Wn[2] > rt ? -Co : Wn[2] - Qe[0] > rt ? Co : 0), Qe[0] += Dl;
                            }
                            Sr(rt, Qe);
                        }
                        function $r(Qe, rt, Wn, Co) {
                            const Dl = Math.pow(2, Co.z) * Fd, Ll = [
                                Co.x * Fd,
                                Co.y * Fd
                            ], Rl = [];
                            for (const Ul of Qe)for (const Qe of Ul){
                                const Co = [
                                    Qe.x + Ll[0],
                                    Qe.y + Ll[1]
                                ];
                                Fr(Co, rt, Wn, Dl), Rl.push(Co);
                            }
                            return Rl;
                        }
                        function Lr(Qe, rt, Wn, Co) {
                            const Dl = Math.pow(2, Co.z) * Fd, Ll = [
                                Co.x * Fd,
                                Co.y * Fd
                            ], Rl = [];
                            for (const Gl of Qe){
                                const Qe = [];
                                for (const Wn of Gl){
                                    const Co = [
                                        Wn.x + Ll[0],
                                        Wn.y + Ll[1]
                                    ];
                                    Sr(rt, Co), Qe.push(Co);
                                }
                                Rl.push(Qe);
                            }
                            if (rt[2] - rt[0] <= Dl / 2) {
                                (Ul = rt)[0] = Ul[1] = 1 / 0, Ul[2] = Ul[3] = -1 / 0;
                                for (const Qe of Rl)for (const Co of Qe)Fr(Co, rt, Wn, Dl);
                            }
                            var Ul;
                            return Rl;
                        }
                        class Or {
                            constructor(Qe, rt){
                                this.type = nd, this.geojson = Qe, this.geometries = rt;
                            }
                            static parse(Qe, rt) {
                                if (2 !== Qe.length) return rt.error(`'within' expression requires exactly one argument, but found ${Qe.length - 1} instead.`);
                                if (Ce(Qe[1])) {
                                    const rt = Qe[1];
                                    if ("FeatureCollection" === rt.type) {
                                        const Qe = [];
                                        for (const Wn of rt.features){
                                            const { type: rt, coordinates: Co } = Wn.geometry;
                                            "Polygon" === rt && Qe.push(Co), "MultiPolygon" === rt && Qe.push(...Co);
                                        }
                                        if (Qe.length) return new Or(rt, {
                                            type: "MultiPolygon",
                                            coordinates: Qe
                                        });
                                    } else if ("Feature" === rt.type) {
                                        const Qe = rt.geometry.type;
                                        if ("Polygon" === Qe || "MultiPolygon" === Qe) return new Or(rt, rt.geometry);
                                    } else if ("Polygon" === rt.type || "MultiPolygon" === rt.type) return new Or(rt, rt);
                                }
                                return rt.error("'within' expression requires valid geojson object that contains polygon geometry type.");
                            }
                            evaluate(Qe) {
                                if (null != Qe.geometry() && null != Qe.canonicalID()) {
                                    if ("Point" === Qe.geometryType()) return function(Qe, rt) {
                                        const Wn = [
                                            1 / 0,
                                            1 / 0,
                                            -1 / 0,
                                            -1 / 0
                                        ], Co = [
                                            1 / 0,
                                            1 / 0,
                                            -1 / 0,
                                            -1 / 0
                                        ], Dl = Qe.canonicalID();
                                        if ("Polygon" === rt.type) {
                                            const Ll = Er(rt.coordinates, Co, Dl), Rl = $r(Qe.geometry(), Wn, Co, Dl);
                                            if (!Ar(Wn, Co)) return !1;
                                            for (const Qe of Rl)if (!zr(Qe, Ll)) return !1;
                                        }
                                        if ("MultiPolygon" === rt.type) {
                                            const Ll = Tr(rt.coordinates, Co, Dl), Rl = $r(Qe.geometry(), Wn, Co, Dl);
                                            if (!Ar(Wn, Co)) return !1;
                                            for (const Qe of Rl)if (!Pr(Qe, Ll)) return !1;
                                        }
                                        return !0;
                                    }(Qe, this.geometries);
                                    if ("LineString" === Qe.geometryType()) return function(Qe, rt) {
                                        const Wn = [
                                            1 / 0,
                                            1 / 0,
                                            -1 / 0,
                                            -1 / 0
                                        ], Co = [
                                            1 / 0,
                                            1 / 0,
                                            -1 / 0,
                                            -1 / 0
                                        ], Dl = Qe.canonicalID();
                                        if ("Polygon" === rt.type) {
                                            const Ll = Er(rt.coordinates, Co, Dl), Rl = Lr(Qe.geometry(), Wn, Co, Dl);
                                            if (!Ar(Wn, Co)) return !1;
                                            for (const Qe of Rl)if (!Cr(Qe, Ll)) return !1;
                                        }
                                        if ("MultiPolygon" === rt.type) {
                                            const Ll = Tr(rt.coordinates, Co, Dl), Rl = Lr(Qe.geometry(), Wn, Co, Dl);
                                            if (!Ar(Wn, Co)) return !1;
                                            for (const Qe of Rl)if (!Br(Qe, Ll)) return !1;
                                        }
                                        return !0;
                                    }(Qe, this.geometries);
                                }
                                return !1;
                            }
                            eachChild() {}
                            outputDefined() {
                                return !0;
                            }
                        }
                        let jd = class {
                            constructor(Qe = [], rt = (Qe, rt)=>Qe < rt ? -1 : Qe > rt ? 1 : 0){
                                if (this.data = Qe, this.length = this.data.length, this.compare = rt, this.length > 0) for(let Wn = (this.length >> 1) - 1; Wn >= 0; Wn--)this._down(Wn);
                            }
                            push(Qe) {
                                this.data.push(Qe), this._up(this.length++);
                            }
                            pop() {
                                if (0 === this.length) return;
                                const Qe = this.data[0], rt = this.data.pop();
                                return --this.length > 0 && (this.data[0] = rt, this._down(0)), Qe;
                            }
                            peek() {
                                return this.data[0];
                            }
                            _up(Qe) {
                                const { data: rt, compare: Wn } = this, Co = rt[Qe];
                                for(; Qe > 0;){
                                    const Dl = Qe - 1 >> 1, Ll = rt[Dl];
                                    if (Wn(Co, Ll) >= 0) break;
                                    rt[Qe] = Ll, Qe = Dl;
                                }
                                rt[Qe] = Co;
                            }
                            _down(Qe) {
                                const { data: rt, compare: Wn } = this, Co = this.length >> 1, Dl = rt[Qe];
                                for(; Qe < Co;){
                                    let Co = 1 + (Qe << 1);
                                    const Ll = Co + 1;
                                    if (Ll < this.length && Wn(rt[Ll], rt[Co]) < 0 && (Co = Ll), Wn(rt[Co], Dl) >= 0) break;
                                    rt[Qe] = rt[Co], Qe = Co;
                                }
                                rt[Qe] = Dl;
                            }
                        };
                        function Rr(Qe, rt, Wn = 0, Co = Qe.length - 1, Dl = Nr) {
                            for(; Co > Wn;){
                                if (Co - Wn > 600) {
                                    const Ll = Co - Wn + 1, Rl = rt - Wn + 1, Ul = Math.log(Ll), Gl = .5 * Math.exp(2 * Ul / 3), Zl = .5 * Math.sqrt(Ul * Gl * (Ll - Gl) / Ll) * (Rl - Ll / 2 < 0 ? -1 : 1);
                                    Rr(Qe, rt, Math.max(Wn, Math.floor(rt - Rl * Gl / Ll + Zl)), Math.min(Co, Math.floor(rt + (Ll - Rl) * Gl / Ll + Zl)), Dl);
                                }
                                const Ll = Qe[rt];
                                let Rl = Wn, Ul = Co;
                                for(jr(Qe, Wn, rt), Dl(Qe[Co], Ll) > 0 && jr(Qe, Wn, Co); Rl < Ul;){
                                    for(jr(Qe, Rl, Ul), Rl++, Ul--; Dl(Qe[Rl], Ll) < 0;)Rl++;
                                    for(; Dl(Qe[Ul], Ll) > 0;)Ul--;
                                }
                                0 === Dl(Qe[Wn], Ll) ? jr(Qe, Wn, Ul) : (Ul++, jr(Qe, Ul, Co)), Ul <= rt && (Wn = Ul + 1), rt <= Ul && (Co = Ul - 1);
                            }
                        }
                        function jr(Qe, rt, Wn) {
                            const Co = Qe[rt];
                            Qe[rt] = Qe[Wn], Qe[Wn] = Co;
                        }
                        function Nr(Qe, rt) {
                            return Qe < rt ? -1 : Qe > rt ? 1 : 0;
                        }
                        function Ur(Qe, rt) {
                            if (Qe.length <= 1) return [
                                Qe
                            ];
                            const Wn = [];
                            let Co, Dl;
                            for (const Ll of Qe){
                                const Qe = Gr(Ll);
                                0 !== Qe && (Ll.area = Math.abs(Qe), void 0 === Dl && (Dl = Qe < 0), Dl === Qe < 0 ? (Co && Wn.push(Co), Co = [
                                    Ll
                                ]) : Co.push(Ll));
                            }
                            if (Co && Wn.push(Co), rt > 1) for(let Ll = 0; Ll < Wn.length; Ll++)Wn[Ll].length <= rt || (Rr(Wn[Ll], rt, 1, Wn[Ll].length - 1, qr), Wn[Ll] = Wn[Ll].slice(0, rt));
                            return Wn;
                        }
                        function qr(Qe, rt) {
                            return rt.area - Qe.area;
                        }
                        function Gr(Qe) {
                            let rt = 0;
                            for(let Wn, Co, Dl = 0, Ll = Qe.length, Rl = Ll - 1; Dl < Ll; Rl = Dl++)Wn = Qe[Dl], Co = Qe[Rl], rt += (Co.x - Wn.x) * (Wn.y + Co.y);
                            return rt;
                        }
                        const Ud = 1 / 298.257223563, Vd = Ud * (2 - Ud), Gd = Math.PI / 180;
                        class Hr {
                            constructor(Qe){
                                const rt = 6378.137 * Gd * 1e3, Wn = Math.cos(Qe * Gd), Co = 1 / (1 - Vd * (1 - Wn * Wn)), Dl = Math.sqrt(Co);
                                this.kx = rt * Dl * Wn, this.ky = rt * Dl * Co * (1 - Vd);
                            }
                            distance(Qe, rt) {
                                const Wn = this.wrap(Qe[0] - rt[0]) * this.kx, Co = (Qe[1] - rt[1]) * this.ky;
                                return Math.sqrt(Wn * Wn + Co * Co);
                            }
                            pointOnLine(Qe, rt) {
                                let Wn, Co, Dl, Ll, Rl = 1 / 0;
                                for(let Ul = 0; Ul < Qe.length - 1; Ul++){
                                    let Gl = Qe[Ul][0], Zl = Qe[Ul][1], Hl = this.wrap(Qe[Ul + 1][0] - Gl) * this.kx, ql = (Qe[Ul + 1][1] - Zl) * this.ky, Ql = 0;
                                    0 === Hl && 0 === ql || (Ql = (this.wrap(rt[0] - Gl) * this.kx * Hl + (rt[1] - Zl) * this.ky * ql) / (Hl * Hl + ql * ql), Ql > 1 ? (Gl = Qe[Ul + 1][0], Zl = Qe[Ul + 1][1]) : Ql > 0 && (Gl += Hl / this.kx * Ql, Zl += ql / this.ky * Ql)), Hl = this.wrap(rt[0] - Gl) * this.kx, ql = (rt[1] - Zl) * this.ky;
                                    const Kl = Hl * Hl + ql * ql;
                                    Kl < Rl && (Rl = Kl, Wn = Gl, Co = Zl, Dl = Ul, Ll = Ql);
                                }
                                return {
                                    point: [
                                        Wn,
                                        Co
                                    ],
                                    index: Dl,
                                    t: Math.max(0, Math.min(1, Ll))
                                };
                            }
                            wrap(Qe) {
                                for(; Qe < -180;)Qe += 360;
                                for(; Qe > 180;)Qe -= 360;
                                return Qe;
                            }
                        }
                        function Yr(Qe, rt) {
                            return rt[0] - Qe[0];
                        }
                        function Jr(Qe) {
                            return Qe[1] - Qe[0] + 1;
                        }
                        function Wr(Qe, rt) {
                            return Qe[1] >= Qe[0] && Qe[1] < rt;
                        }
                        function Qr(Qe, rt) {
                            if (Qe[0] > Qe[1]) return [
                                null,
                                null
                            ];
                            const Wn = Jr(Qe);
                            if (rt) {
                                if (2 === Wn) return [
                                    Qe,
                                    null
                                ];
                                const rt = Math.floor(Wn / 2);
                                return [
                                    [
                                        Qe[0],
                                        Qe[0] + rt
                                    ],
                                    [
                                        Qe[0] + rt,
                                        Qe[1]
                                    ]
                                ];
                            }
                            if (1 === Wn) return [
                                Qe,
                                null
                            ];
                            const Co = Math.floor(Wn / 2) - 1;
                            return [
                                [
                                    Qe[0],
                                    Qe[0] + Co
                                ],
                                [
                                    Qe[0] + Co + 1,
                                    Qe[1]
                                ]
                            ];
                        }
                        function tn(Qe, rt) {
                            if (!Wr(rt, Qe.length)) return [
                                1 / 0,
                                1 / 0,
                                -1 / 0,
                                -1 / 0
                            ];
                            const Wn = [
                                1 / 0,
                                1 / 0,
                                -1 / 0,
                                -1 / 0
                            ];
                            for(let Co = rt[0]; Co <= rt[1]; ++Co)Sr(Wn, Qe[Co]);
                            return Wn;
                        }
                        function en(Qe) {
                            const rt = [
                                1 / 0,
                                1 / 0,
                                -1 / 0,
                                -1 / 0
                            ];
                            for (const Wn of Qe)for (const Qe of Wn)Sr(rt, Qe);
                            return rt;
                        }
                        function rn(Qe) {
                            return Qe[0] !== -1 / 0 && Qe[1] !== -1 / 0 && Qe[2] !== 1 / 0 && Qe[3] !== 1 / 0;
                        }
                        function nn(Qe, rt, Wn) {
                            if (!rn(Qe) || !rn(rt)) return NaN;
                            let Co = 0, Dl = 0;
                            return Qe[2] < rt[0] && (Co = rt[0] - Qe[2]), Qe[0] > rt[2] && (Co = Qe[0] - rt[2]), Qe[1] > rt[3] && (Dl = Qe[1] - rt[3]), Qe[3] < rt[1] && (Dl = rt[1] - Qe[3]), Wn.distance([
                                0,
                                0
                            ], [
                                Co,
                                Dl
                            ]);
                        }
                        function sn(Qe, rt, Wn) {
                            const Co = Wn.pointOnLine(rt, Qe);
                            return Wn.distance(Qe, Co.point);
                        }
                        function an(Qe, rt, Wn, Co, Dl) {
                            const Ll = Math.min(sn(Qe, [
                                Wn,
                                Co
                            ], Dl), sn(rt, [
                                Wn,
                                Co
                            ], Dl)), Rl = Math.min(sn(Wn, [
                                Qe,
                                rt
                            ], Dl), sn(Co, [
                                Qe,
                                rt
                            ], Dl));
                            return Math.min(Ll, Rl);
                        }
                        function on(Qe, rt, Wn, Co, Dl) {
                            if (!Wr(rt, Qe.length) || !Wr(Co, Wn.length)) return 1 / 0;
                            let Ll = 1 / 0;
                            for(let Rl = rt[0]; Rl < rt[1]; ++Rl){
                                const rt = Qe[Rl], Ul = Qe[Rl + 1];
                                for(let Qe = Co[0]; Qe < Co[1]; ++Qe){
                                    const Co = Wn[Qe], Rl = Wn[Qe + 1];
                                    if (Mr(rt, Ul, Co, Rl)) return 0;
                                    Ll = Math.min(Ll, an(rt, Ul, Co, Rl, Dl));
                                }
                            }
                            return Ll;
                        }
                        function ln(Qe, rt, Wn, Co, Dl) {
                            if (!Wr(rt, Qe.length) || !Wr(Co, Wn.length)) return NaN;
                            let Ll = 1 / 0;
                            for(let Rl = rt[0]; Rl <= rt[1]; ++Rl)for(let rt = Co[0]; rt <= Co[1]; ++rt)if (Ll = Math.min(Ll, Dl.distance(Qe[Rl], Wn[rt])), 0 === Ll) return Ll;
                            return Ll;
                        }
                        function un(Qe, rt, Wn) {
                            if (zr(Qe, rt, !0)) return 0;
                            let Co = 1 / 0;
                            for (const Dl of rt){
                                const rt = Dl[0], Ll = Dl[Dl.length - 1];
                                if (rt !== Ll && (Co = Math.min(Co, sn(Qe, [
                                    Ll,
                                    rt
                                ], Wn)), 0 === Co)) return Co;
                                const Rl = Wn.pointOnLine(Dl, Qe);
                                if (Co = Math.min(Co, Wn.distance(Qe, Rl.point)), 0 === Co) return Co;
                            }
                            return Co;
                        }
                        function cn(Qe, rt, Wn, Co) {
                            if (!Wr(rt, Qe.length)) return NaN;
                            for(let Ll = rt[0]; Ll <= rt[1]; ++Ll)if (zr(Qe[Ll], Wn, !0)) return 0;
                            let Dl = 1 / 0;
                            for(let Ll = rt[0]; Ll < rt[1]; ++Ll){
                                const rt = Qe[Ll], Rl = Qe[Ll + 1];
                                for (const Qe of Wn)for(let Wn = 0, Ll = Qe.length, Ul = Ll - 1; Wn < Ll; Ul = Wn++){
                                    const Ll = Qe[Ul], Gl = Qe[Wn];
                                    if (Mr(rt, Rl, Ll, Gl)) return 0;
                                    Dl = Math.min(Dl, an(rt, Rl, Ll, Gl, Co));
                                }
                            }
                            return Dl;
                        }
                        function hn(Qe, rt) {
                            for (const Wn of Qe)for (const Qe of Wn)if (zr(Qe, rt, !0)) return !0;
                            return !1;
                        }
                        function pn(Qe, rt, Wn, Co = 1 / 0) {
                            const Dl = en(Qe), Ll = en(rt);
                            if (Co !== 1 / 0 && nn(Dl, Ll, Wn) >= Co) return Co;
                            if (Ar(Dl, Ll)) {
                                if (hn(Qe, rt)) return 0;
                            } else if (hn(rt, Qe)) return 0;
                            let Rl = 1 / 0;
                            for (const Ul of Qe)for(let Qe = 0, Co = Ul.length, Dl = Co - 1; Qe < Co; Dl = Qe++){
                                const Co = Ul[Dl], Ll = Ul[Qe];
                                for (const Qe of rt)for(let rt = 0, Dl = Qe.length, Ul = Dl - 1; rt < Dl; Ul = rt++){
                                    const Dl = Qe[Ul], Gl = Qe[rt];
                                    if (Mr(Co, Ll, Dl, Gl)) return 0;
                                    Rl = Math.min(Rl, an(Co, Ll, Dl, Gl, Wn));
                                }
                            }
                            return Rl;
                        }
                        function fn(Qe, rt, Wn, Co, Dl, Ll) {
                            if (!Ll) return;
                            const Rl = nn(tn(Co, Ll), Dl, Wn);
                            Rl < rt && Qe.push([
                                Rl,
                                Ll,
                                [
                                    0,
                                    0
                                ]
                            ]);
                        }
                        function dn(Qe, rt, Wn, Co, Dl, Ll, Rl) {
                            if (!Ll || !Rl) return;
                            const Ul = nn(tn(Co, Ll), tn(Dl, Rl), Wn);
                            Ul < rt && Qe.push([
                                Ul,
                                Ll,
                                Rl
                            ]);
                        }
                        function yn(Qe, rt, Wn, Co, Dl = 1 / 0) {
                            let Ll = Math.min(Co.distance(Qe[0], Wn[0][0]), Dl);
                            if (0 === Ll) return Ll;
                            const Rl = new jd([
                                [
                                    0,
                                    [
                                        0,
                                        Qe.length - 1
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ]
                            ], Yr), Ul = en(Wn);
                            for(; Rl.length > 0;){
                                const Dl = Rl.pop();
                                if (Dl[0] >= Ll) continue;
                                const Gl = Dl[1], Zl = rt ? 50 : 100;
                                if (Jr(Gl) <= Zl) {
                                    if (!Wr(Gl, Qe.length)) return NaN;
                                    if (rt) {
                                        const rt = cn(Qe, Gl, Wn, Co);
                                        if (isNaN(rt) || 0 === rt) return rt;
                                        Ll = Math.min(Ll, rt);
                                    } else for(let rt = Gl[0]; rt <= Gl[1]; ++rt){
                                        const Dl = un(Qe[rt], Wn, Co);
                                        if (Ll = Math.min(Ll, Dl), 0 === Ll) return 0;
                                    }
                                } else {
                                    const Wn = Qr(Gl, rt);
                                    fn(Rl, Ll, Co, Qe, Ul, Wn[0]), fn(Rl, Ll, Co, Qe, Ul, Wn[1]);
                                }
                            }
                            return Ll;
                        }
                        function mn(Qe, rt, Wn, Co, Dl, Ll = 1 / 0) {
                            let Rl = Math.min(Ll, Dl.distance(Qe[0], Wn[0]));
                            if (0 === Rl) return Rl;
                            const Ul = new jd([
                                [
                                    0,
                                    [
                                        0,
                                        Qe.length - 1
                                    ],
                                    [
                                        0,
                                        Wn.length - 1
                                    ]
                                ]
                            ], Yr);
                            for(; Ul.length > 0;){
                                const Ll = Ul.pop();
                                if (Ll[0] >= Rl) continue;
                                const Gl = Ll[1], Zl = Ll[2], Hl = rt ? 50 : 100, ql = Co ? 50 : 100;
                                if (Jr(Gl) <= Hl && Jr(Zl) <= ql) {
                                    if (!Wr(Gl, Qe.length) && Wr(Zl, Wn.length)) return NaN;
                                    let Ll;
                                    if (rt && Co) Ll = on(Qe, Gl, Wn, Zl, Dl), Rl = Math.min(Rl, Ll);
                                    else if (rt && !Co) {
                                        const rt = Qe.slice(Gl[0], Gl[1] + 1);
                                        for(let Qe = Zl[0]; Qe <= Zl[1]; ++Qe)if (Ll = sn(Wn[Qe], rt, Dl), Rl = Math.min(Rl, Ll), 0 === Rl) return Rl;
                                    } else if (!rt && Co) {
                                        const rt = Wn.slice(Zl[0], Zl[1] + 1);
                                        for(let Wn = Gl[0]; Wn <= Gl[1]; ++Wn)if (Ll = sn(Qe[Wn], rt, Dl), Rl = Math.min(Rl, Ll), 0 === Rl) return Rl;
                                    } else Ll = ln(Qe, Gl, Wn, Zl, Dl), Rl = Math.min(Rl, Ll);
                                } else {
                                    const Ll = Qr(Gl, rt), Hl = Qr(Zl, Co);
                                    dn(Ul, Rl, Dl, Qe, Wn, Ll[0], Hl[0]), dn(Ul, Rl, Dl, Qe, Wn, Ll[0], Hl[1]), dn(Ul, Rl, Dl, Qe, Wn, Ll[1], Hl[0]), dn(Ul, Rl, Dl, Qe, Wn, Ll[1], Hl[1]);
                                }
                            }
                            return Rl;
                        }
                        function gn(Qe) {
                            return "MultiPolygon" === Qe.type ? Qe.coordinates.map((Qe)=>({
                                    type: "Polygon",
                                    coordinates: Qe
                                })) : "MultiLineString" === Qe.type ? Qe.coordinates.map((Qe)=>({
                                    type: "LineString",
                                    coordinates: Qe
                                })) : "MultiPoint" === Qe.type ? Qe.coordinates.map((Qe)=>({
                                    type: "Point",
                                    coordinates: Qe
                                })) : [
                                Qe
                            ];
                        }
                        class xn {
                            constructor(Qe, rt){
                                this.type = td, this.geojson = Qe, this.geometries = rt;
                            }
                            static parse(Qe, rt) {
                                if (2 !== Qe.length) return rt.error(`'distance' expression requires exactly one argument, but found ${Qe.length - 1} instead.`);
                                if (Ce(Qe[1])) {
                                    const rt = Qe[1];
                                    if ("FeatureCollection" === rt.type) return new xn(rt, rt.features.map((Qe)=>gn(Qe.geometry)).flat());
                                    if ("Feature" === rt.type) return new xn(rt, gn(rt.geometry));
                                    if ("type" in rt && "coordinates" in rt) return new xn(rt, gn(rt));
                                }
                                return rt.error("'distance' expression requires valid geojson object that contains polygon geometry type.");
                            }
                            evaluate(Qe) {
                                if (null != Qe.geometry() && null != Qe.canonicalID()) {
                                    if ("Point" === Qe.geometryType()) return function(Qe, rt) {
                                        const Wn = Qe.geometry(), Co = Wn.flat().map((rt)=>_r([
                                                rt.x,
                                                rt.y
                                            ], Qe.canonical));
                                        if (0 === Wn.length) return NaN;
                                        const Dl = new Hr(Co[0][1]);
                                        let Ll = 1 / 0;
                                        for (const Rl of rt){
                                            switch(Rl.type){
                                                case "Point":
                                                    Ll = Math.min(Ll, mn(Co, !1, [
                                                        Rl.coordinates
                                                    ], !1, Dl, Ll));
                                                    break;
                                                case "LineString":
                                                    Ll = Math.min(Ll, mn(Co, !1, Rl.coordinates, !0, Dl, Ll));
                                                    break;
                                                case "Polygon":
                                                    Ll = Math.min(Ll, yn(Co, !1, Rl.coordinates, Dl, Ll));
                                            }
                                            if (0 === Ll) return Ll;
                                        }
                                        return Ll;
                                    }(Qe, this.geometries);
                                    if ("LineString" === Qe.geometryType()) return function(Qe, rt) {
                                        const Wn = Qe.geometry(), Co = Wn.flat().map((rt)=>_r([
                                                rt.x,
                                                rt.y
                                            ], Qe.canonical));
                                        if (0 === Wn.length) return NaN;
                                        const Dl = new Hr(Co[0][1]);
                                        let Ll = 1 / 0;
                                        for (const Rl of rt){
                                            switch(Rl.type){
                                                case "Point":
                                                    Ll = Math.min(Ll, mn(Co, !0, [
                                                        Rl.coordinates
                                                    ], !1, Dl, Ll));
                                                    break;
                                                case "LineString":
                                                    Ll = Math.min(Ll, mn(Co, !0, Rl.coordinates, !0, Dl, Ll));
                                                    break;
                                                case "Polygon":
                                                    Ll = Math.min(Ll, yn(Co, !0, Rl.coordinates, Dl, Ll));
                                            }
                                            if (0 === Ll) return Ll;
                                        }
                                        return Ll;
                                    }(Qe, this.geometries);
                                    if ("Polygon" === Qe.geometryType()) return function(Qe, rt) {
                                        const Wn = Qe.geometry();
                                        if (0 === Wn.length || 0 === Wn[0].length) return NaN;
                                        const Co = Ur(Wn, 0).map((rt)=>rt.map((rt)=>rt.map((rt)=>_r([
                                                        rt.x,
                                                        rt.y
                                                    ], Qe.canonical)))), Dl = new Hr(Co[0][0][0][1]);
                                        let Ll = 1 / 0;
                                        for (const Rl of rt)for (const Qe of Co){
                                            switch(Rl.type){
                                                case "Point":
                                                    Ll = Math.min(Ll, yn([
                                                        Rl.coordinates
                                                    ], !1, Qe, Dl, Ll));
                                                    break;
                                                case "LineString":
                                                    Ll = Math.min(Ll, yn(Rl.coordinates, !0, Qe, Dl, Ll));
                                                    break;
                                                case "Polygon":
                                                    Ll = Math.min(Ll, pn(Qe, Rl.coordinates, Dl, Ll));
                                            }
                                            if (0 === Ll) return Ll;
                                        }
                                        return Ll;
                                    }(Qe, this.geometries);
                                }
                                return NaN;
                            }
                            eachChild() {}
                            outputDefined() {
                                return !0;
                            }
                        }
                        const Zd = {
                            "==": Pd,
                            "!=": zd,
                            ">": Rd,
                            "<": Nd,
                            ">=": Od,
                            "<=": Bd,
                            array: Fe,
                            at: Ue,
                            boolean: Fe,
                            case: Ke,
                            coalesce: sr,
                            collator: yr,
                            format: gr,
                            image: xr,
                            in: qe,
                            "index-of": Ge,
                            interpolate: rr,
                            "interpolate-hcl": rr,
                            "interpolate-lab": rr,
                            length: vr,
                            let: je,
                            literal: Ee,
                            match: Ze,
                            number: Fe,
                            "number-format": mr,
                            object: Fe,
                            slice: Xe,
                            step: Ye,
                            string: Fe,
                            "to-boolean": Le,
                            "to-color": Le,
                            "to-number": Le,
                            "to-string": Le,
                            var: Ne,
                            within: Or,
                            distance: xn
                        };
                        class bn {
                            constructor(Qe, rt, Wn, Co){
                                this.name = Qe, this.type = rt, this._evaluate = Wn, this.args = Co;
                            }
                            evaluate(Qe) {
                                return this._evaluate(Qe, this.args);
                            }
                            eachChild(Qe) {
                                this.args.forEach(Qe);
                            }
                            outputDefined() {
                                return !1;
                            }
                            static parse(Qe, rt) {
                                const Wn = Qe[0], Co = bn.definitions[Wn];
                                if (!Co) return rt.error(`Unknown expression "${Wn}". If you wanted a literal array, use ["literal", [...]].`, 0);
                                const Dl = Array.isArray(Co) ? Co[0] : Co.type, Ll = Array.isArray(Co) ? [
                                    [
                                        Co[1],
                                        Co[2]
                                    ]
                                ] : Co.overloads, Rl = Ll.filter(([rt])=>!Array.isArray(rt) || rt.length === Qe.length - 1);
                                let Ul = null;
                                for (const [Gl, Zl] of Rl){
                                    Ul = new Re(rt.registry, kn, rt.path, null, rt.scope);
                                    const Co = [];
                                    let Ll = !1;
                                    for(let rt = 1; rt < Qe.length; rt++){
                                        const Wn = Qe[rt], Dl = Array.isArray(Gl) ? Gl[rt - 1] : Gl.type, Rl = Ul.parse(Wn, 1 + Co.length, Dl);
                                        if (!Rl) {
                                            Ll = !0;
                                            break;
                                        }
                                        Co.push(Rl);
                                    }
                                    if (!Ll) {
                                        if (Array.isArray(Gl) && Gl.length !== Co.length) Ul.error(`Expected ${Gl.length} arguments, but found ${Co.length} instead.`);
                                        else {
                                            for(let Qe = 0; Qe < Co.length; Qe++){
                                                const rt = Array.isArray(Gl) ? Gl[Qe] : Gl.type, Wn = Co[Qe];
                                                Ul.concat(Qe + 1).checkSubtype(rt, Wn.type);
                                            }
                                            if (0 === Ul.errors.length) return new bn(Wn, Dl, Zl, Co);
                                        }
                                    }
                                }
                                if (1 === Rl.length) rt.errors.push(...Ul.errors);
                                else {
                                    const Wn = (Rl.length ? Rl : Ll).map(([Qe])=>{
                                        var rt;
                                        return rt = Qe, Array.isArray(rt) ? `(${rt.map(qt).join(", ")})` : `(${qt(rt.type)}...)`;
                                    }).join(" | "), Co = [];
                                    for(let Dl = 1; Dl < Qe.length; Dl++){
                                        const Wn = rt.parse(Qe[Dl], 1 + Co.length);
                                        if (!Wn) return null;
                                        Co.push(qt(Wn.type));
                                    }
                                    rt.error(`Expected arguments of type ${Wn}, but found (${Co.join(", ")}) instead.`);
                                }
                                return null;
                            }
                            static register(Qe, rt) {
                                bn.definitions = rt;
                                for(const Wn in rt)Qe[Wn] = bn;
                            }
                        }
                        function wn(Qe, [rt, Wn, Co, Dl]) {
                            rt = rt.evaluate(Qe), Wn = Wn.evaluate(Qe), Co = Co.evaluate(Qe);
                            const Ll = Dl ? Dl.evaluate(Qe) : 1, Rl = Pe(rt, Wn, Co, Ll);
                            if (Rl) throw new Ae(Rl);
                            return new xe(rt / 255, Wn / 255, Co / 255, Ll, !1);
                        }
                        function _n(Qe, rt) {
                            return Qe in rt;
                        }
                        function Sn(Qe, rt) {
                            const Wn = rt[Qe];
                            return void 0 === Wn ? null : Wn;
                        }
                        function An(Qe) {
                            return {
                                type: Qe
                            };
                        }
                        function kn(Qe) {
                            if (Qe instanceof Ne) return kn(Qe.boundExpression);
                            if (Qe instanceof bn && "error" === Qe.name) return !1;
                            if (Qe instanceof yr) return !1;
                            if (Qe instanceof Or) return !1;
                            if (Qe instanceof xn) return !1;
                            const rt = Qe instanceof Le || Qe instanceof Fe;
                            let Wn = !0;
                            return Qe.eachChild((Qe)=>{
                                Wn = rt ? Wn && kn(Qe) : Wn && Qe instanceof Ee;
                            }), !!Wn && Mn(Qe) && zn(Qe, [
                                "zoom",
                                "heatmap-density",
                                "line-progress",
                                "accumulated",
                                "is-supported-script"
                            ]);
                        }
                        function Mn(Qe) {
                            if (Qe instanceof bn) {
                                if ("get" === Qe.name && 1 === Qe.args.length) return !1;
                                if ("feature-state" === Qe.name) return !1;
                                if ("has" === Qe.name && 1 === Qe.args.length) return !1;
                                if ("properties" === Qe.name || "geometry-type" === Qe.name || "id" === Qe.name) return !1;
                                if (/^filter-/.test(Qe.name)) return !1;
                            }
                            if (Qe instanceof Or) return !1;
                            if (Qe instanceof xn) return !1;
                            let rt = !0;
                            return Qe.eachChild((Qe)=>{
                                rt && !Mn(Qe) && (rt = !1);
                            }), rt;
                        }
                        function In(Qe) {
                            if (Qe instanceof bn && "feature-state" === Qe.name) return !1;
                            let rt = !0;
                            return Qe.eachChild((Qe)=>{
                                rt && !In(Qe) && (rt = !1);
                            }), rt;
                        }
                        function zn(Qe, rt) {
                            if (Qe instanceof bn && rt.indexOf(Qe.name) >= 0) return !1;
                            let Wn = !0;
                            return Qe.eachChild((Qe)=>{
                                Wn && !zn(Qe, rt) && (Wn = !1);
                            }), Wn;
                        }
                        function Pn(Qe) {
                            return {
                                result: "success",
                                value: Qe
                            };
                        }
                        function Cn(Qe) {
                            return {
                                result: "error",
                                value: Qe
                            };
                        }
                        function Bn(Qe) {
                            return "data-driven" === Qe["property-type"] || "cross-faded-data-driven" === Qe["property-type"];
                        }
                        function Vn(Qe) {
                            return !!Qe.expression && Qe.expression.parameters.indexOf("zoom") > -1;
                        }
                        function En(Qe) {
                            return !!Qe.expression && Qe.expression.interpolated;
                        }
                        function Tn(Qe) {
                            return Qe instanceof Number ? "number" : Qe instanceof String ? "string" : Qe instanceof Boolean ? "boolean" : Array.isArray(Qe) ? "array" : null === Qe ? "null" : typeof Qe;
                        }
                        function Fn(Qe) {
                            return "object" == typeof Qe && null !== Qe && !Array.isArray(Qe);
                        }
                        function $n(Qe) {
                            return Qe;
                        }
                        function Ln(Qe, rt) {
                            const Wn = "color" === rt.type, Co = Qe.stops && "object" == typeof Qe.stops[0][0], Dl = Co || !(Co || void 0 !== Qe.property), Ll = Qe.type || (En(rt) ? "exponential" : "interval");
                            if (Wn || "padding" === rt.type) {
                                const Co = Wn ? xe.parse : Se.parse;
                                (Qe = It({}, Qe)).stops && (Qe.stops = Qe.stops.map((Qe)=>[
                                        Qe[0],
                                        Co(Qe[1])
                                    ])), Qe.default = Co(Qe.default ? Qe.default : rt.default);
                            }
                            if (Qe.colorSpace && "rgb" !== (Rl = Qe.colorSpace) && "hcl" !== Rl && "lab" !== Rl) throw new Error(`Unknown color space: "${Qe.colorSpace}"`);
                            var Rl;
                            let Ul, Gl, Zl;
                            if ("exponential" === Ll) Ul = jn;
                            else if ("interval" === Ll) Ul = Rn;
                            else if ("categorical" === Ll) {
                                Ul = Dn, Gl = Object.create(null);
                                for (const rt of Qe.stops)Gl[rt[0]] = rt[1];
                                Zl = typeof Qe.stops[0][0];
                            } else {
                                if ("identity" !== Ll) throw new Error(`Unknown function type "${Ll}"`);
                                Ul = Nn;
                            }
                            if (Co) {
                                const Wn = {}, Co = [];
                                for(let rt = 0; rt < Qe.stops.length; rt++){
                                    const Dl = Qe.stops[rt], Ll = Dl[0].zoom;
                                    void 0 === Wn[Ll] && (Wn[Ll] = {
                                        zoom: Ll,
                                        type: Qe.type,
                                        property: Qe.property,
                                        default: Qe.default,
                                        stops: []
                                    }, Co.push(Ll)), Wn[Ll].stops.push([
                                        Dl[0].value,
                                        Dl[1]
                                    ]);
                                }
                                const Dl = [];
                                for (const Qe of Co)Dl.push([
                                    Wn[Qe].zoom,
                                    Ln(Wn[Qe], rt)
                                ]);
                                const Ll = {
                                    name: "linear"
                                };
                                return {
                                    kind: "composite",
                                    interpolationType: Ll,
                                    interpolationFactor: rr.interpolationFactor.bind(void 0, Ll),
                                    zoomStops: Dl.map((Qe)=>Qe[0]),
                                    evaluate: ({ zoom: Wn }, Co)=>jn({
                                            stops: Dl,
                                            base: Qe.base
                                        }, rt, Wn).evaluate(Wn, Co)
                                };
                            }
                            if (Dl) {
                                const Wn = "exponential" === Ll ? {
                                    name: "exponential",
                                    base: void 0 !== Qe.base ? Qe.base : 1
                                } : null;
                                return {
                                    kind: "camera",
                                    interpolationType: Wn,
                                    interpolationFactor: rr.interpolationFactor.bind(void 0, Wn),
                                    zoomStops: Qe.stops.map((Qe)=>Qe[0]),
                                    evaluate: ({ zoom: Wn })=>Ul(Qe, rt, Wn, Gl, Zl)
                                };
                            }
                            return {
                                kind: "source",
                                evaluate (Wn, Co) {
                                    const Dl = Co && Co.properties ? Co.properties[Qe.property] : void 0;
                                    return void 0 === Dl ? On(Qe.default, rt.default) : Ul(Qe, rt, Dl, Gl, Zl);
                                }
                            };
                        }
                        function On(Qe, rt, Wn) {
                            return void 0 !== Qe ? Qe : void 0 !== rt ? rt : void 0 !== Wn ? Wn : void 0;
                        }
                        function Dn(Qe, rt, Wn, Co, Dl) {
                            return On(typeof Wn === Dl ? Co[Wn] : void 0, Qe.default, rt.default);
                        }
                        function Rn(Qe, rt, Wn) {
                            if ("number" !== Tn(Wn)) return On(Qe.default, rt.default);
                            const Co = Qe.stops.length;
                            if (1 === Co) return Qe.stops[0][1];
                            if (Wn <= Qe.stops[0][0]) return Qe.stops[0][1];
                            if (Wn >= Qe.stops[Co - 1][0]) return Qe.stops[Co - 1][1];
                            const Dl = He(Qe.stops.map((Qe)=>Qe[0]), Wn);
                            return Qe.stops[Dl][1];
                        }
                        function jn(Qe, rt, Wn) {
                            const Co = void 0 !== Qe.base ? Qe.base : 1;
                            if ("number" !== Tn(Wn)) return On(Qe.default, rt.default);
                            const Dl = Qe.stops.length;
                            if (1 === Dl) return Qe.stops[0][1];
                            if (Wn <= Qe.stops[0][0]) return Qe.stops[0][1];
                            if (Wn >= Qe.stops[Dl - 1][0]) return Qe.stops[Dl - 1][1];
                            const Ll = He(Qe.stops.map((Qe)=>Qe[0]), Wn), Rl = function(Qe, rt, Wn, Co) {
                                const Dl = Co - Wn, Ll = Qe - Wn;
                                return 0 === Dl ? 0 : 1 === rt ? Ll / Dl : (Math.pow(rt, Ll) - 1) / (Math.pow(rt, Dl) - 1);
                            }(Wn, Co, Qe.stops[Ll][0], Qe.stops[Ll + 1][0]), Ul = Qe.stops[Ll][1], Gl = Qe.stops[Ll + 1][1], Zl = Ld[rt.type] || $n;
                            return "function" == typeof Ul.evaluate ? {
                                evaluate (...rt) {
                                    const Wn = Ul.evaluate.apply(void 0, rt), Co = Gl.evaluate.apply(void 0, rt);
                                    if (void 0 !== Wn && void 0 !== Co) return Zl(Wn, Co, Rl, Qe.colorSpace);
                                }
                            } : Zl(Ul, Gl, Rl, Qe.colorSpace);
                        }
                        function Nn(Qe, rt, Wn) {
                            switch(rt.type){
                                case "color":
                                    Wn = xe.parse(Wn);
                                    break;
                                case "formatted":
                                    Wn = _e.fromString(Wn.toString());
                                    break;
                                case "resolvedImage":
                                    Wn = Ie.fromString(Wn.toString());
                                    break;
                                case "padding":
                                    Wn = Se.parse(Wn);
                                    break;
                                default:
                                    Tn(Wn) === rt.type || "enum" === rt.type && rt.values[Wn] || (Wn = void 0);
                            }
                            return On(Wn, Qe.default, rt.default);
                        }
                        bn.register(Zd, {
                            error: [
                                {
                                    kind: "error"
                                },
                                [
                                    id
                                ],
                                (Qe, [rt])=>{
                                    throw new Ae(rt.evaluate(Qe));
                                }
                            ],
                            typeof: [
                                id,
                                [
                                    od
                                ],
                                (Qe, [rt])=>qt(Be(rt.evaluate(Qe)))
                            ],
                            "to-rgba": [
                                Ut(td, 4),
                                [
                                    rd
                                ],
                                (Qe, [rt])=>{
                                    const [Wn, Co, Dl, Ll] = rt.evaluate(Qe).rgb;
                                    return [
                                        255 * Wn,
                                        255 * Co,
                                        255 * Dl,
                                        Ll
                                    ];
                                }
                            ],
                            rgb: [
                                rd,
                                [
                                    td,
                                    td,
                                    td
                                ],
                                wn
                            ],
                            rgba: [
                                rd,
                                [
                                    td,
                                    td,
                                    td,
                                    td
                                ],
                                wn
                            ],
                            has: {
                                type: nd,
                                overloads: [
                                    [
                                        [
                                            id
                                        ],
                                        (Qe, [rt])=>_n(rt.evaluate(Qe), Qe.properties())
                                    ],
                                    [
                                        [
                                            id,
                                            ad
                                        ],
                                        (Qe, [rt, Wn])=>_n(rt.evaluate(Qe), Wn.evaluate(Qe))
                                    ]
                                ]
                            },
                            get: {
                                type: od,
                                overloads: [
                                    [
                                        [
                                            id
                                        ],
                                        (Qe, [rt])=>Sn(rt.evaluate(Qe), Qe.properties())
                                    ],
                                    [
                                        [
                                            id,
                                            ad
                                        ],
                                        (Qe, [rt, Wn])=>Sn(rt.evaluate(Qe), Wn.evaluate(Qe))
                                    ]
                                ]
                            },
                            "feature-state": [
                                od,
                                [
                                    id
                                ],
                                (Qe, [rt])=>Sn(rt.evaluate(Qe), Qe.featureState || {})
                            ],
                            properties: [
                                ad,
                                [],
                                (Qe)=>Qe.properties()
                            ],
                            "geometry-type": [
                                id,
                                [],
                                (Qe)=>Qe.geometryType()
                            ],
                            id: [
                                od,
                                [],
                                (Qe)=>Qe.id()
                            ],
                            zoom: [
                                td,
                                [],
                                (Qe)=>Qe.globals.zoom
                            ],
                            "heatmap-density": [
                                td,
                                [],
                                (Qe)=>Qe.globals.heatmapDensity || 0
                            ],
                            "line-progress": [
                                td,
                                [],
                                (Qe)=>Qe.globals.lineProgress || 0
                            ],
                            accumulated: [
                                od,
                                [],
                                (Qe)=>void 0 === Qe.globals.accumulated ? null : Qe.globals.accumulated
                            ],
                            "+": [
                                td,
                                An(td),
                                (Qe, rt)=>{
                                    let Wn = 0;
                                    for (const Co of rt)Wn += Co.evaluate(Qe);
                                    return Wn;
                                }
                            ],
                            "*": [
                                td,
                                An(td),
                                (Qe, rt)=>{
                                    let Wn = 1;
                                    for (const Co of rt)Wn *= Co.evaluate(Qe);
                                    return Wn;
                                }
                            ],
                            "-": {
                                type: td,
                                overloads: [
                                    [
                                        [
                                            td,
                                            td
                                        ],
                                        (Qe, [rt, Wn])=>rt.evaluate(Qe) - Wn.evaluate(Qe)
                                    ],
                                    [
                                        [
                                            td
                                        ],
                                        (Qe, [rt])=>-rt.evaluate(Qe)
                                    ]
                                ]
                            },
                            "/": [
                                td,
                                [
                                    td,
                                    td
                                ],
                                (Qe, [rt, Wn])=>rt.evaluate(Qe) / Wn.evaluate(Qe)
                            ],
                            "%": [
                                td,
                                [
                                    td,
                                    td
                                ],
                                (Qe, [rt, Wn])=>rt.evaluate(Qe) % Wn.evaluate(Qe)
                            ],
                            ln2: [
                                td,
                                [],
                                ()=>Math.LN2
                            ],
                            pi: [
                                td,
                                [],
                                ()=>Math.PI
                            ],
                            e: [
                                td,
                                [],
                                ()=>Math.E
                            ],
                            "^": [
                                td,
                                [
                                    td,
                                    td
                                ],
                                (Qe, [rt, Wn])=>Math.pow(rt.evaluate(Qe), Wn.evaluate(Qe))
                            ],
                            sqrt: [
                                td,
                                [
                                    td
                                ],
                                (Qe, [rt])=>Math.sqrt(rt.evaluate(Qe))
                            ],
                            log10: [
                                td,
                                [
                                    td
                                ],
                                (Qe, [rt])=>Math.log(rt.evaluate(Qe)) / Math.LN10
                            ],
                            ln: [
                                td,
                                [
                                    td
                                ],
                                (Qe, [rt])=>Math.log(rt.evaluate(Qe))
                            ],
                            log2: [
                                td,
                                [
                                    td
                                ],
                                (Qe, [rt])=>Math.log(rt.evaluate(Qe)) / Math.LN2
                            ],
                            sin: [
                                td,
                                [
                                    td
                                ],
                                (Qe, [rt])=>Math.sin(rt.evaluate(Qe))
                            ],
                            cos: [
                                td,
                                [
                                    td
                                ],
                                (Qe, [rt])=>Math.cos(rt.evaluate(Qe))
                            ],
                            tan: [
                                td,
                                [
                                    td
                                ],
                                (Qe, [rt])=>Math.tan(rt.evaluate(Qe))
                            ],
                            asin: [
                                td,
                                [
                                    td
                                ],
                                (Qe, [rt])=>Math.asin(rt.evaluate(Qe))
                            ],
                            acos: [
                                td,
                                [
                                    td
                                ],
                                (Qe, [rt])=>Math.acos(rt.evaluate(Qe))
                            ],
                            atan: [
                                td,
                                [
                                    td
                                ],
                                (Qe, [rt])=>Math.atan(rt.evaluate(Qe))
                            ],
                            min: [
                                td,
                                An(td),
                                (Qe, rt)=>Math.min(...rt.map((rt)=>rt.evaluate(Qe)))
                            ],
                            max: [
                                td,
                                An(td),
                                (Qe, rt)=>Math.max(...rt.map((rt)=>rt.evaluate(Qe)))
                            ],
                            abs: [
                                td,
                                [
                                    td
                                ],
                                (Qe, [rt])=>Math.abs(rt.evaluate(Qe))
                            ],
                            round: [
                                td,
                                [
                                    td
                                ],
                                (Qe, [rt])=>{
                                    const Wn = rt.evaluate(Qe);
                                    return Wn < 0 ? -Math.round(-Wn) : Math.round(Wn);
                                }
                            ],
                            floor: [
                                td,
                                [
                                    td
                                ],
                                (Qe, [rt])=>Math.floor(rt.evaluate(Qe))
                            ],
                            ceil: [
                                td,
                                [
                                    td
                                ],
                                (Qe, [rt])=>Math.ceil(rt.evaluate(Qe))
                            ],
                            "filter-==": [
                                nd,
                                [
                                    id,
                                    od
                                ],
                                (Qe, [rt, Wn])=>Qe.properties()[rt.value] === Wn.value
                            ],
                            "filter-id-==": [
                                nd,
                                [
                                    od
                                ],
                                (Qe, [rt])=>Qe.id() === rt.value
                            ],
                            "filter-type-==": [
                                nd,
                                [
                                    id
                                ],
                                (Qe, [rt])=>Qe.geometryType() === rt.value
                            ],
                            "filter-<": [
                                nd,
                                [
                                    id,
                                    od
                                ],
                                (Qe, [rt, Wn])=>{
                                    const Co = Qe.properties()[rt.value], Dl = Wn.value;
                                    return typeof Co == typeof Dl && Co < Dl;
                                }
                            ],
                            "filter-id-<": [
                                nd,
                                [
                                    od
                                ],
                                (Qe, [rt])=>{
                                    const Wn = Qe.id(), Co = rt.value;
                                    return typeof Wn == typeof Co && Wn < Co;
                                }
                            ],
                            "filter->": [
                                nd,
                                [
                                    id,
                                    od
                                ],
                                (Qe, [rt, Wn])=>{
                                    const Co = Qe.properties()[rt.value], Dl = Wn.value;
                                    return typeof Co == typeof Dl && Co > Dl;
                                }
                            ],
                            "filter-id->": [
                                nd,
                                [
                                    od
                                ],
                                (Qe, [rt])=>{
                                    const Wn = Qe.id(), Co = rt.value;
                                    return typeof Wn == typeof Co && Wn > Co;
                                }
                            ],
                            "filter-<=": [
                                nd,
                                [
                                    id,
                                    od
                                ],
                                (Qe, [rt, Wn])=>{
                                    const Co = Qe.properties()[rt.value], Dl = Wn.value;
                                    return typeof Co == typeof Dl && Co <= Dl;
                                }
                            ],
                            "filter-id-<=": [
                                nd,
                                [
                                    od
                                ],
                                (Qe, [rt])=>{
                                    const Wn = Qe.id(), Co = rt.value;
                                    return typeof Wn == typeof Co && Wn <= Co;
                                }
                            ],
                            "filter->=": [
                                nd,
                                [
                                    id,
                                    od
                                ],
                                (Qe, [rt, Wn])=>{
                                    const Co = Qe.properties()[rt.value], Dl = Wn.value;
                                    return typeof Co == typeof Dl && Co >= Dl;
                                }
                            ],
                            "filter-id->=": [
                                nd,
                                [
                                    od
                                ],
                                (Qe, [rt])=>{
                                    const Wn = Qe.id(), Co = rt.value;
                                    return typeof Wn == typeof Co && Wn >= Co;
                                }
                            ],
                            "filter-has": [
                                nd,
                                [
                                    od
                                ],
                                (Qe, [rt])=>rt.value in Qe.properties()
                            ],
                            "filter-has-id": [
                                nd,
                                [],
                                (Qe)=>null !== Qe.id() && void 0 !== Qe.id()
                            ],
                            "filter-type-in": [
                                nd,
                                [
                                    Ut(id)
                                ],
                                (Qe, [rt])=>rt.value.indexOf(Qe.geometryType()) >= 0
                            ],
                            "filter-id-in": [
                                nd,
                                [
                                    Ut(od)
                                ],
                                (Qe, [rt])=>rt.value.indexOf(Qe.id()) >= 0
                            ],
                            "filter-in-small": [
                                nd,
                                [
                                    id,
                                    Ut(od)
                                ],
                                (Qe, [rt, Wn])=>Wn.value.indexOf(Qe.properties()[rt.value]) >= 0
                            ],
                            "filter-in-large": [
                                nd,
                                [
                                    id,
                                    Ut(od)
                                ],
                                (Qe, [rt, Wn])=>(function(Qe, rt, Wn, Co) {
                                        for(; Wn <= Co;){
                                            const Dl = Wn + Co >> 1;
                                            if (rt[Dl] === Qe) return !0;
                                            rt[Dl] > Qe ? Co = Dl - 1 : Wn = Dl + 1;
                                        }
                                        return !1;
                                    })(Qe.properties()[rt.value], Wn.value, 0, Wn.value.length - 1)
                            ],
                            all: {
                                type: nd,
                                overloads: [
                                    [
                                        [
                                            nd,
                                            nd
                                        ],
                                        (Qe, [rt, Wn])=>rt.evaluate(Qe) && Wn.evaluate(Qe)
                                    ],
                                    [
                                        An(nd),
                                        (Qe, rt)=>{
                                            for (const Wn of rt)if (!Wn.evaluate(Qe)) return !1;
                                            return !0;
                                        }
                                    ]
                                ]
                            },
                            any: {
                                type: nd,
                                overloads: [
                                    [
                                        [
                                            nd,
                                            nd
                                        ],
                                        (Qe, [rt, Wn])=>rt.evaluate(Qe) || Wn.evaluate(Qe)
                                    ],
                                    [
                                        An(nd),
                                        (Qe, rt)=>{
                                            for (const Wn of rt)if (Wn.evaluate(Qe)) return !0;
                                            return !1;
                                        }
                                    ]
                                ]
                            },
                            "!": [
                                nd,
                                [
                                    nd
                                ],
                                (Qe, [rt])=>!rt.evaluate(Qe)
                            ],
                            "is-supported-script": [
                                nd,
                                [
                                    id
                                ],
                                (Qe, [rt])=>{
                                    const Wn = Qe.globals && Qe.globals.isSupportedScript;
                                    return !Wn || Wn(rt.evaluate(Qe));
                                }
                            ],
                            upcase: [
                                id,
                                [
                                    id
                                ],
                                (Qe, [rt])=>rt.evaluate(Qe).toUpperCase()
                            ],
                            downcase: [
                                id,
                                [
                                    id
                                ],
                                (Qe, [rt])=>rt.evaluate(Qe).toLowerCase()
                            ],
                            concat: [
                                id,
                                An(od),
                                (Qe, rt)=>rt.map((rt)=>Ve(rt.evaluate(Qe))).join("")
                            ],
                            "resolved-locale": [
                                id,
                                [
                                    ld
                                ],
                                (Qe, [rt])=>rt.evaluate(Qe).resolvedLocale()
                            ]
                        });
                        class Un {
                            constructor(Qe, rt){
                                var Wn;
                                this.expression = Qe, this._warningHistory = {}, this._evaluator = new De, this._defaultValue = rt ? "color" === (Wn = rt).type && Fn(Wn.default) ? new xe(0, 0, 0, 0) : "color" === Wn.type ? xe.parse(Wn.default) || null : "padding" === Wn.type ? Se.parse(Wn.default) || null : "variableAnchorOffsetCollection" === Wn.type ? Me.parse(Wn.default) || null : "projectionDefinition" === Wn.type ? ze.parse(Wn.default) || null : void 0 === Wn.default ? null : Wn.default : null, this._enumValues = rt && "enum" === rt.type ? rt.values : null;
                            }
                            evaluateWithoutErrorHandling(Qe, rt, Wn, Co, Dl, Ll) {
                                return this._evaluator.globals = Qe, this._evaluator.feature = rt, this._evaluator.featureState = Wn, this._evaluator.canonical = Co, this._evaluator.availableImages = Dl || null, this._evaluator.formattedSection = Ll, this.expression.evaluate(this._evaluator);
                            }
                            evaluate(Qe, rt, Wn, Co, Dl, Ll) {
                                this._evaluator.globals = Qe, this._evaluator.feature = rt || null, this._evaluator.featureState = Wn || null, this._evaluator.canonical = Co, this._evaluator.availableImages = Dl || null, this._evaluator.formattedSection = Ll || null;
                                try {
                                    const Qe = this.expression.evaluate(this._evaluator);
                                    if (null == Qe || "number" == typeof Qe && Qe != Qe) return this._defaultValue;
                                    if (this._enumValues && !(Qe in this._enumValues)) throw new Ae(`Expected value to be one of ${Object.keys(this._enumValues).map((Qe)=>JSON.stringify(Qe)).join(", ")}, but found ${JSON.stringify(Qe)} instead.`);
                                    return Qe;
                                } catch (Qe) {
                                    return this._warningHistory[Qe.message] || (this._warningHistory[Qe.message] = !0, "undefined" != typeof console && console.warn(Qe.message)), this._defaultValue;
                                }
                            }
                        }
                        function qn(Qe) {
                            return Array.isArray(Qe) && Qe.length > 0 && "string" == typeof Qe[0] && Qe[0] in Zd;
                        }
                        function Gn(Qe, rt) {
                            const Wn = new Re(Zd, kn, [], rt ? function(Qe) {
                                const rt = {
                                    color: rd,
                                    string: id,
                                    number: td,
                                    enum: id,
                                    boolean: nd,
                                    formatted: cd,
                                    padding: ud,
                                    projectionDefinition: sd,
                                    resolvedImage: hd,
                                    variableAnchorOffsetCollection: dd
                                };
                                return "array" === Qe.type ? Ut(rt[Qe.value] || od, Qe.length) : rt[Qe.type];
                            }(rt) : void 0), Co = Wn.parse(Qe, void 0, void 0, void 0, rt && "string" === rt.type ? {
                                typeAnnotation: "coerce"
                            } : void 0);
                            return Co ? Pn(new Un(Co, rt)) : Cn(Wn.errors);
                        }
                        class Zn {
                            constructor(Qe, rt){
                                this.kind = Qe, this._styleExpression = rt, this.isStateDependent = "constant" !== Qe && !In(rt.expression);
                            }
                            evaluateWithoutErrorHandling(Qe, rt, Wn, Co, Dl, Ll) {
                                return this._styleExpression.evaluateWithoutErrorHandling(Qe, rt, Wn, Co, Dl, Ll);
                            }
                            evaluate(Qe, rt, Wn, Co, Dl, Ll) {
                                return this._styleExpression.evaluate(Qe, rt, Wn, Co, Dl, Ll);
                            }
                        }
                        class Kn {
                            constructor(Qe, rt, Wn, Co){
                                this.kind = Qe, this.zoomStops = Wn, this._styleExpression = rt, this.isStateDependent = "camera" !== Qe && !In(rt.expression), this.interpolationType = Co;
                            }
                            evaluateWithoutErrorHandling(Qe, rt, Wn, Co, Dl, Ll) {
                                return this._styleExpression.evaluateWithoutErrorHandling(Qe, rt, Wn, Co, Dl, Ll);
                            }
                            evaluate(Qe, rt, Wn, Co, Dl, Ll) {
                                return this._styleExpression.evaluate(Qe, rt, Wn, Co, Dl, Ll);
                            }
                            interpolationFactor(Qe, rt, Wn) {
                                return this.interpolationType ? rr.interpolationFactor(this.interpolationType, Qe, rt, Wn) : 0;
                            }
                        }
                        function Xn(Qe, rt) {
                            const Wn = Gn(Qe, rt);
                            if ("error" === Wn.result) return Wn;
                            const Co = Wn.value.expression, Dl = Mn(Co);
                            if (!Dl && !Bn(rt)) return Cn([
                                new zt("", "data expressions not supported")
                            ]);
                            const Ll = zn(Co, [
                                "zoom"
                            ]);
                            if (!Ll && !Vn(rt)) return Cn([
                                new zt("", "zoom expressions not supported")
                            ]);
                            const Rl = Yn(Co);
                            return Rl || Ll ? Rl instanceof zt ? Cn([
                                Rl
                            ]) : Rl instanceof rr && !En(rt) ? Cn([
                                new zt("", '"interpolate" expressions cannot be used with this property')
                            ]) : Pn(Rl ? new Kn(Dl ? "camera" : "composite", Wn.value, Rl.labels, Rl instanceof rr ? Rl.interpolation : void 0) : new Zn(Dl ? "constant" : "source", Wn.value)) : Cn([
                                new zt("", '"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.')
                            ]);
                        }
                        class Hn {
                            constructor(Qe, rt){
                                this._parameters = Qe, this._specification = rt, It(this, Ln(this._parameters, this._specification));
                            }
                            static deserialize(Qe) {
                                return new Hn(Qe._parameters, Qe._specification);
                            }
                            static serialize(Qe) {
                                return {
                                    _parameters: Qe._parameters,
                                    _specification: Qe._specification
                                };
                            }
                        }
                        function Yn(Qe) {
                            let rt = null;
                            if (Qe instanceof je) rt = Yn(Qe.result);
                            else if (Qe instanceof sr) {
                                for (const Wn of Qe.args)if (rt = Yn(Wn), rt) break;
                            } else (Qe instanceof Ye || Qe instanceof rr) && Qe.input instanceof bn && "zoom" === Qe.input.name && (rt = Qe);
                            return rt instanceof zt || Qe.eachChild((Qe)=>{
                                const Wn = Yn(Qe);
                                Wn instanceof zt ? rt = Wn : !rt && Wn ? rt = new zt("", '"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.') : rt && Wn && rt !== Wn && (rt = new zt("", 'Only one zoom-based "step" or "interpolate" subexpression may be used in an expression.'));
                            }), rt;
                        }
                        function Jn(Qe) {
                            if (!0 === Qe || !1 === Qe) return !0;
                            if (!Array.isArray(Qe) || 0 === Qe.length) return !1;
                            switch(Qe[0]){
                                case "has":
                                    return Qe.length >= 2 && "$id" !== Qe[1] && "$type" !== Qe[1];
                                case "in":
                                    return Qe.length >= 3 && ("string" != typeof Qe[1] || Array.isArray(Qe[2]));
                                case "!in":
                                case "!has":
                                case "none":
                                    return !1;
                                case "==":
                                case "!=":
                                case ">":
                                case ">=":
                                case "<":
                                case "<=":
                                    return 3 !== Qe.length || Array.isArray(Qe[1]) || Array.isArray(Qe[2]);
                                case "any":
                                case "all":
                                    for (const rt of Qe.slice(1))if (!Jn(rt) && "boolean" != typeof rt) return !1;
                                    return !0;
                                default:
                                    return !0;
                            }
                        }
                        const Hd = {
                            type: "boolean",
                            default: !1,
                            transition: !1,
                            "property-type": "data-driven",
                            expression: {
                                interpolated: !1,
                                parameters: [
                                    "zoom",
                                    "feature"
                                ]
                            }
                        };
                        function Qn(Qe) {
                            if (null == Qe) return {
                                filter: ()=>!0,
                                needGeometry: !1
                            };
                            Jn(Qe) || (Qe = ri(Qe));
                            const rt = Gn(Qe, Hd);
                            if ("error" === rt.result) throw new Error(rt.value.map((Qe)=>`${Qe.key}: ${Qe.message}`).join(", "));
                            return {
                                filter: (Qe, Wn, Co)=>rt.value.evaluate(Qe, Wn, {}, Co),
                                needGeometry: ei(Qe)
                            };
                        }
                        function ti(Qe, rt) {
                            return Qe < rt ? -1 : Qe > rt ? 1 : 0;
                        }
                        function ei(Qe) {
                            if (!Array.isArray(Qe)) return !1;
                            if ("within" === Qe[0] || "distance" === Qe[0]) return !0;
                            for(let rt = 1; rt < Qe.length; rt++)if (ei(Qe[rt])) return !0;
                            return !1;
                        }
                        function ri(Qe) {
                            if (!Qe) return !0;
                            const rt = Qe[0];
                            var Wn;
                            return Qe.length <= 1 ? "any" !== rt : "==" === rt ? ni(Qe[1], Qe[2], "==") : "!=" === rt ? ai(ni(Qe[1], Qe[2], "==")) : "<" === rt || ">" === rt || "<=" === rt || ">=" === rt ? ni(Qe[1], Qe[2], rt) : "any" === rt ? (Wn = Qe.slice(1), [
                                "any"
                            ].concat(Wn.map(ri))) : "all" === rt ? [
                                "all"
                            ].concat(Qe.slice(1).map(ri)) : "none" === rt ? [
                                "all"
                            ].concat(Qe.slice(1).map(ri).map(ai)) : "in" === rt ? ii(Qe[1], Qe.slice(2)) : "!in" === rt ? ai(ii(Qe[1], Qe.slice(2))) : "has" === rt ? si(Qe[1]) : "!has" !== rt || ai(si(Qe[1]));
                        }
                        function ni(Qe, rt, Wn) {
                            switch(Qe){
                                case "$type":
                                    return [
                                        `filter-type-${Wn}`,
                                        rt
                                    ];
                                case "$id":
                                    return [
                                        `filter-id-${Wn}`,
                                        rt
                                    ];
                                default:
                                    return [
                                        `filter-${Wn}`,
                                        Qe,
                                        rt
                                    ];
                            }
                        }
                        function ii(Qe, rt) {
                            if (0 === rt.length) return !1;
                            switch(Qe){
                                case "$type":
                                    return [
                                        "filter-type-in",
                                        [
                                            "literal",
                                            rt
                                        ]
                                    ];
                                case "$id":
                                    return [
                                        "filter-id-in",
                                        [
                                            "literal",
                                            rt
                                        ]
                                    ];
                                default:
                                    return rt.length > 200 && !rt.some((Qe)=>typeof Qe != typeof rt[0]) ? [
                                        "filter-in-large",
                                        Qe,
                                        [
                                            "literal",
                                            rt.sort(ti)
                                        ]
                                    ] : [
                                        "filter-in-small",
                                        Qe,
                                        [
                                            "literal",
                                            rt
                                        ]
                                    ];
                            }
                        }
                        function si(Qe) {
                            switch(Qe){
                                case "$type":
                                    return !0;
                                case "$id":
                                    return [
                                        "filter-has-id"
                                    ];
                                default:
                                    return [
                                        "filter-has",
                                        Qe
                                    ];
                            }
                        }
                        function ai(Qe) {
                            return [
                                "!",
                                Qe
                            ];
                        }
                        function oi(Qe) {
                            const rt = typeof Qe;
                            if ("number" === rt || "boolean" === rt || "string" === rt || null == Qe) return JSON.stringify(Qe);
                            if (Array.isArray(Qe)) {
                                let rt = "[";
                                for (const Wn of Qe)rt += `${oi(Wn)},`;
                                return `${rt}]`;
                            }
                            const Wn = Object.keys(Qe).sort();
                            let Co = "{";
                            for(let Dl = 0; Dl < Wn.length; Dl++)Co += `${JSON.stringify(Wn[Dl])}:${oi(Qe[Wn[Dl]])},`;
                            return `${Co}}`;
                        }
                        function li(Qe) {
                            let rt = "";
                            for (const Wn of $u)rt += `/${oi(Qe[Wn])}`;
                            return rt;
                        }
                        function ui(Qe) {
                            const rt = Qe.value;
                            return rt ? [
                                new Mt(Qe.key, rt, "constants have been deprecated as of v8")
                            ] : [];
                        }
                        function ci(Qe) {
                            return Qe instanceof Number || Qe instanceof String || Qe instanceof Boolean ? Qe.valueOf() : Qe;
                        }
                        function hi(Qe) {
                            if (Array.isArray(Qe)) return Qe.map(hi);
                            if (Qe instanceof Object && !(Qe instanceof Number || Qe instanceof String || Qe instanceof Boolean)) {
                                const rt = {};
                                for(const Wn in Qe)rt[Wn] = hi(Qe[Wn]);
                                return rt;
                            }
                            return ci(Qe);
                        }
                        function pi(Qe) {
                            const rt = Qe.key, Wn = Qe.value, Co = Qe.valueSpec || {}, Dl = Qe.objectElementValidators || {}, Ll = Qe.style, Rl = Qe.styleSpec, Ul = Qe.validateSpec;
                            let Gl = [];
                            const Zl = Tn(Wn);
                            if ("object" !== Zl) return [
                                new Mt(rt, Wn, `object expected, ${Zl} found`)
                            ];
                            for(const Hl in Wn){
                                const Qe = Hl.split(".")[0], Zl = Co[Qe] || Co["*"];
                                let ql;
                                if (Dl[Qe]) ql = Dl[Qe];
                                else if (Co[Qe]) ql = Ul;
                                else if (Dl["*"]) ql = Dl["*"];
                                else {
                                    if (!Co["*"]) {
                                        Gl.push(new Mt(rt, Wn[Hl], `unknown property "${Hl}"`));
                                        continue;
                                    }
                                    ql = Ul;
                                }
                                Gl = Gl.concat(ql({
                                    key: (rt ? `${rt}.` : rt) + Hl,
                                    value: Wn[Hl],
                                    valueSpec: Zl,
                                    style: Ll,
                                    styleSpec: Rl,
                                    object: Wn,
                                    objectKey: Hl,
                                    validateSpec: Ul
                                }, Wn));
                            }
                            for(const Hl in Co)Dl[Hl] || Co[Hl].required && void 0 === Co[Hl].default && void 0 === Wn[Hl] && Gl.push(new Mt(rt, Wn, `missing required property "${Hl}"`));
                            return Gl;
                        }
                        function fi(Qe) {
                            const rt = Qe.value, Wn = Qe.valueSpec, Co = Qe.style, Dl = Qe.styleSpec, Ll = Qe.key, Rl = Qe.arrayElementValidator || Qe.validateSpec;
                            if ("array" !== Tn(rt)) return [
                                new Mt(Ll, rt, `array expected, ${Tn(rt)} found`)
                            ];
                            if (Wn.length && rt.length !== Wn.length) return [
                                new Mt(Ll, rt, `array length ${Wn.length} expected, length ${rt.length} found`)
                            ];
                            if (Wn["min-length"] && rt.length < Wn["min-length"]) return [
                                new Mt(Ll, rt, `array length at least ${Wn["min-length"]} expected, length ${rt.length} found`)
                            ];
                            let Ul = {
                                type: Wn.value,
                                values: Wn.values
                            };
                            Dl.$version < 7 && (Ul.function = Wn.function), "object" === Tn(Wn.value) && (Ul = Wn.value);
                            let Gl = [];
                            for(let Zl = 0; Zl < rt.length; Zl++)Gl = Gl.concat(Rl({
                                array: rt,
                                arrayIndex: Zl,
                                value: rt[Zl],
                                valueSpec: Ul,
                                validateSpec: Qe.validateSpec,
                                style: Co,
                                styleSpec: Dl,
                                key: `${Ll}[${Zl}]`
                            }));
                            return Gl;
                        }
                        function di(Qe) {
                            const rt = Qe.key, Wn = Qe.value, Co = Qe.valueSpec;
                            let Dl = Tn(Wn);
                            return "number" === Dl && Wn != Wn && (Dl = "NaN"), "number" !== Dl ? [
                                new Mt(rt, Wn, `number expected, ${Dl} found`)
                            ] : "minimum" in Co && Wn < Co.minimum ? [
                                new Mt(rt, Wn, `${Wn} is less than the minimum value ${Co.minimum}`)
                            ] : "maximum" in Co && Wn > Co.maximum ? [
                                new Mt(rt, Wn, `${Wn} is greater than the maximum value ${Co.maximum}`)
                            ] : [];
                        }
                        function yi(Qe) {
                            const rt = Qe.valueSpec, Wn = ci(Qe.value.type);
                            let Co, Dl, Ll, Rl = {};
                            const Ul = "categorical" !== Wn && void 0 === Qe.value.property, Gl = !Ul, Zl = "array" === Tn(Qe.value.stops) && "array" === Tn(Qe.value.stops[0]) && "object" === Tn(Qe.value.stops[0][0]), Hl = pi({
                                key: Qe.key,
                                value: Qe.value,
                                valueSpec: Qe.styleSpec.function,
                                validateSpec: Qe.validateSpec,
                                style: Qe.style,
                                styleSpec: Qe.styleSpec,
                                objectElementValidators: {
                                    stops: function(Qe) {
                                        if ("identity" === Wn) return [
                                            new Mt(Qe.key, Qe.value, 'identity function may not have a "stops" property')
                                        ];
                                        let rt = [];
                                        const Co = Qe.value;
                                        return rt = rt.concat(fi({
                                            key: Qe.key,
                                            value: Co,
                                            valueSpec: Qe.valueSpec,
                                            validateSpec: Qe.validateSpec,
                                            style: Qe.style,
                                            styleSpec: Qe.styleSpec,
                                            arrayElementValidator: h
                                        })), "array" === Tn(Co) && 0 === Co.length && rt.push(new Mt(Qe.key, Co, "array must have at least one stop")), rt;
                                    },
                                    default: function(Qe) {
                                        return Qe.validateSpec({
                                            key: Qe.key,
                                            value: Qe.value,
                                            valueSpec: rt,
                                            validateSpec: Qe.validateSpec,
                                            style: Qe.style,
                                            styleSpec: Qe.styleSpec
                                        });
                                    }
                                }
                            });
                            return "identity" === Wn && Ul && Hl.push(new Mt(Qe.key, Qe.value, 'missing required property "property"')), "identity" === Wn || Qe.value.stops || Hl.push(new Mt(Qe.key, Qe.value, 'missing required property "stops"')), "exponential" === Wn && Qe.valueSpec.expression && !En(Qe.valueSpec) && Hl.push(new Mt(Qe.key, Qe.value, "exponential functions not supported")), Qe.styleSpec.$version >= 8 && (Gl && !Bn(Qe.valueSpec) ? Hl.push(new Mt(Qe.key, Qe.value, "property functions not supported")) : Ul && !Vn(Qe.valueSpec) && Hl.push(new Mt(Qe.key, Qe.value, "zoom functions not supported"))), "categorical" !== Wn && !Zl || void 0 !== Qe.value.property || Hl.push(new Mt(Qe.key, Qe.value, '"property" property is required')), Hl;
                            function h(Qe) {
                                let Wn = [];
                                const Co = Qe.value, Ul = Qe.key;
                                if ("array" !== Tn(Co)) return [
                                    new Mt(Ul, Co, `array expected, ${Tn(Co)} found`)
                                ];
                                if (2 !== Co.length) return [
                                    new Mt(Ul, Co, `array length 2 expected, length ${Co.length} found`)
                                ];
                                if (Zl) {
                                    if ("object" !== Tn(Co[0])) return [
                                        new Mt(Ul, Co, `object expected, ${Tn(Co[0])} found`)
                                    ];
                                    if (void 0 === Co[0].zoom) return [
                                        new Mt(Ul, Co, "object stop key must have zoom")
                                    ];
                                    if (void 0 === Co[0].value) return [
                                        new Mt(Ul, Co, "object stop key must have value")
                                    ];
                                    if (Ll && Ll > ci(Co[0].zoom)) return [
                                        new Mt(Ul, Co[0].zoom, "stop zoom values must appear in ascending order")
                                    ];
                                    ci(Co[0].zoom) !== Ll && (Ll = ci(Co[0].zoom), Dl = void 0, Rl = {}), Wn = Wn.concat(pi({
                                        key: `${Ul}[0]`,
                                        value: Co[0],
                                        valueSpec: {
                                            zoom: {}
                                        },
                                        validateSpec: Qe.validateSpec,
                                        style: Qe.style,
                                        styleSpec: Qe.styleSpec,
                                        objectElementValidators: {
                                            zoom: di,
                                            value: p
                                        }
                                    }));
                                } else Wn = Wn.concat(p({
                                    key: `${Ul}[0]`,
                                    value: Co[0],
                                    validateSpec: Qe.validateSpec,
                                    style: Qe.style,
                                    styleSpec: Qe.styleSpec
                                }, Co));
                                return qn(hi(Co[1])) ? Wn.concat([
                                    new Mt(`${Ul}[1]`, Co[1], "expressions are not allowed in function stops.")
                                ]) : Wn.concat(Qe.validateSpec({
                                    key: `${Ul}[1]`,
                                    value: Co[1],
                                    valueSpec: rt,
                                    validateSpec: Qe.validateSpec,
                                    style: Qe.style,
                                    styleSpec: Qe.styleSpec
                                }));
                            }
                            function p(Qe, Ll) {
                                const Ul = Tn(Qe.value), Gl = ci(Qe.value), Zl = null !== Qe.value ? Qe.value : Ll;
                                if (Co) {
                                    if (Ul !== Co) return [
                                        new Mt(Qe.key, Zl, `${Ul} stop domain type must match previous stop domain type ${Co}`)
                                    ];
                                } else Co = Ul;
                                if ("number" !== Ul && "string" !== Ul && "boolean" !== Ul) return [
                                    new Mt(Qe.key, Zl, "stop domain value must be a number, string, or boolean")
                                ];
                                if ("number" !== Ul && "categorical" !== Wn) {
                                    let Co = `number expected, ${Ul} found`;
                                    return Bn(rt) && void 0 === Wn && (Co += '\nIf you intended to use a categorical function, specify `"type": "categorical"`.'), [
                                        new Mt(Qe.key, Zl, Co)
                                    ];
                                }
                                return "categorical" !== Wn || "number" !== Ul || isFinite(Gl) && Math.floor(Gl) === Gl ? "categorical" !== Wn && "number" === Ul && void 0 !== Dl && Gl < Dl ? [
                                    new Mt(Qe.key, Zl, "stop domain values must appear in ascending order")
                                ] : (Dl = Gl, "categorical" === Wn && Gl in Rl ? [
                                    new Mt(Qe.key, Zl, "stop domain values must be unique")
                                ] : (Rl[Gl] = !0, [])) : [
                                    new Mt(Qe.key, Zl, `integer expected, found ${Gl}`)
                                ];
                            }
                        }
                        function mi(Qe) {
                            const rt = ("property" === Qe.expressionContext ? Xn : Gn)(hi(Qe.value), Qe.valueSpec);
                            if ("error" === rt.result) return rt.value.map((rt)=>new Mt(`${Qe.key}${rt.key}`, Qe.value, rt.message));
                            const Wn = rt.value.expression || rt.value._styleExpression.expression;
                            if ("property" === Qe.expressionContext && "text-font" === Qe.propertyKey && !Wn.outputDefined()) return [
                                new Mt(Qe.key, Qe.value, `Invalid data expression for "${Qe.propertyKey}". Output values must be contained as literals within the expression.`)
                            ];
                            if ("property" === Qe.expressionContext && "layout" === Qe.propertyType && !In(Wn)) return [
                                new Mt(Qe.key, Qe.value, '"feature-state" data expressions are not supported with layout properties.')
                            ];
                            if ("filter" === Qe.expressionContext && !In(Wn)) return [
                                new Mt(Qe.key, Qe.value, '"feature-state" data expressions are not supported with filters.')
                            ];
                            if (Qe.expressionContext && 0 === Qe.expressionContext.indexOf("cluster")) {
                                if (!zn(Wn, [
                                    "zoom",
                                    "feature-state"
                                ])) return [
                                    new Mt(Qe.key, Qe.value, '"zoom" and "feature-state" expressions are not supported with cluster properties.')
                                ];
                                if ("cluster-initial" === Qe.expressionContext && !Mn(Wn)) return [
                                    new Mt(Qe.key, Qe.value, "Feature data expressions are not supported with initial expression part of cluster properties.")
                                ];
                            }
                            return [];
                        }
                        function gi(Qe) {
                            const rt = Qe.key, Wn = Qe.value, Co = Qe.valueSpec, Dl = [];
                            return Array.isArray(Co.values) ? -1 === Co.values.indexOf(ci(Wn)) && Dl.push(new Mt(rt, Wn, `expected one of [${Co.values.join(", ")}], ${JSON.stringify(Wn)} found`)) : -1 === Object.keys(Co.values).indexOf(ci(Wn)) && Dl.push(new Mt(rt, Wn, `expected one of [${Object.keys(Co.values).join(", ")}], ${JSON.stringify(Wn)} found`)), Dl;
                        }
                        function xi(Qe) {
                            return Jn(hi(Qe.value)) ? mi(It({}, Qe, {
                                expressionContext: "filter",
                                valueSpec: {
                                    value: "boolean"
                                }
                            })) : vi(Qe);
                        }
                        function vi(Qe) {
                            const rt = Qe.value, Wn = Qe.key;
                            if ("array" !== Tn(rt)) return [
                                new Mt(Wn, rt, `array expected, ${Tn(rt)} found`)
                            ];
                            const Co = Qe.styleSpec;
                            let Dl, Ll = [];
                            if (rt.length < 1) return [
                                new Mt(Wn, rt, "filter array must have at least 1 element")
                            ];
                            switch(Ll = Ll.concat(gi({
                                key: `${Wn}[0]`,
                                value: rt[0],
                                valueSpec: Co.filter_operator,
                                style: Qe.style,
                                styleSpec: Qe.styleSpec
                            })), ci(rt[0])){
                                case "<":
                                case "<=":
                                case ">":
                                case ">=":
                                    rt.length >= 2 && "$type" === ci(rt[1]) && Ll.push(new Mt(Wn, rt, `"$type" cannot be use with operator "${rt[0]}"`));
                                case "==":
                                case "!=":
                                    3 !== rt.length && Ll.push(new Mt(Wn, rt, `filter array for operator "${rt[0]}" must have 3 elements`));
                                case "in":
                                case "!in":
                                    rt.length >= 2 && (Dl = Tn(rt[1]), "string" !== Dl && Ll.push(new Mt(`${Wn}[1]`, rt[1], `string expected, ${Dl} found`)));
                                    for(let Rl = 2; Rl < rt.length; Rl++)Dl = Tn(rt[Rl]), "$type" === ci(rt[1]) ? Ll = Ll.concat(gi({
                                        key: `${Wn}[${Rl}]`,
                                        value: rt[Rl],
                                        valueSpec: Co.geometry_type,
                                        style: Qe.style,
                                        styleSpec: Qe.styleSpec
                                    })) : "string" !== Dl && "number" !== Dl && "boolean" !== Dl && Ll.push(new Mt(`${Wn}[${Rl}]`, rt[Rl], `string, number, or boolean expected, ${Dl} found`));
                                    break;
                                case "any":
                                case "all":
                                case "none":
                                    for(let Co = 1; Co < rt.length; Co++)Ll = Ll.concat(vi({
                                        key: `${Wn}[${Co}]`,
                                        value: rt[Co],
                                        style: Qe.style,
                                        styleSpec: Qe.styleSpec
                                    }));
                                    break;
                                case "has":
                                case "!has":
                                    Dl = Tn(rt[1]), 2 !== rt.length ? Ll.push(new Mt(Wn, rt, `filter array for "${rt[0]}" operator must have 2 elements`)) : "string" !== Dl && Ll.push(new Mt(`${Wn}[1]`, rt[1], `string expected, ${Dl} found`));
                            }
                            return Ll;
                        }
                        function bi(Qe, rt) {
                            const Wn = Qe.key, Co = Qe.validateSpec, Dl = Qe.style, Ll = Qe.styleSpec, Rl = Qe.value, Ul = Qe.objectKey, Gl = Ll[`${rt}_${Qe.layerType}`];
                            if (!Gl) return [];
                            const Zl = Ul.match(/^(.*)-transition$/);
                            if ("paint" === rt && Zl && Gl[Zl[1]] && Gl[Zl[1]].transition) return Co({
                                key: Wn,
                                value: Rl,
                                valueSpec: Ll.transition,
                                style: Dl,
                                styleSpec: Ll
                            });
                            const Hl = Qe.valueSpec || Gl[Ul];
                            if (!Hl) return [
                                new Mt(Wn, Rl, `unknown property "${Ul}"`)
                            ];
                            let ql;
                            if ("string" === Tn(Rl) && Bn(Hl) && !Hl.tokens && (ql = /^{([^}]+)}$/.exec(Rl))) return [
                                new Mt(Wn, Rl, `"${Ul}" does not support interpolation syntax\nUse an identity property function instead: \`{ "type": "identity", "property": ${JSON.stringify(ql[1])} }\`.`)
                            ];
                            const Ql = [];
                            return "symbol" === Qe.layerType && ("text-field" === Ul && Dl && !Dl.glyphs && Ql.push(new Mt(Wn, Rl, 'use of "text-field" requires a style "glyphs" property')), "text-font" === Ul && Fn(hi(Rl)) && "identity" === ci(Rl.type) && Ql.push(new Mt(Wn, Rl, '"text-font" does not support identity functions'))), Ql.concat(Co({
                                key: Qe.key,
                                value: Rl,
                                valueSpec: Hl,
                                style: Dl,
                                styleSpec: Ll,
                                expressionContext: "property",
                                propertyType: rt,
                                propertyKey: Ul
                            }));
                        }
                        function wi(Qe) {
                            return bi(Qe, "paint");
                        }
                        function _i(Qe) {
                            return bi(Qe, "layout");
                        }
                        function Si(Qe) {
                            let rt = [];
                            const Wn = Qe.value, Co = Qe.key, Dl = Qe.style, Ll = Qe.styleSpec;
                            Wn.type || Wn.ref || rt.push(new Mt(Co, Wn, 'either "type" or "ref" is required'));
                            let Rl = ci(Wn.type);
                            const Ul = ci(Wn.ref);
                            if (Wn.id) {
                                const Ll = ci(Wn.id);
                                for(let Rl = 0; Rl < Qe.arrayIndex; Rl++){
                                    const Qe = Dl.layers[Rl];
                                    ci(Qe.id) === Ll && rt.push(new Mt(Co, Wn.id, `duplicate layer id "${Wn.id}", previously used at line ${Qe.id.__line__}`));
                                }
                            }
                            if ("ref" in Wn) {
                                let Qe;
                                [
                                    "type",
                                    "source",
                                    "source-layer",
                                    "filter",
                                    "layout"
                                ].forEach((Qe)=>{
                                    Qe in Wn && rt.push(new Mt(Co, Wn[Qe], `"${Qe}" is prohibited for ref layers`));
                                }), Dl.layers.forEach((rt)=>{
                                    ci(rt.id) === Ul && (Qe = rt);
                                }), Qe ? Qe.ref ? rt.push(new Mt(Co, Wn.ref, "ref cannot reference another ref layer")) : Rl = ci(Qe.type) : rt.push(new Mt(Co, Wn.ref, `ref layer "${Ul}" not found`));
                            } else if ("background" !== Rl) {
                                if (Wn.source) {
                                    const Qe = Dl.sources && Dl.sources[Wn.source], Ll = Qe && ci(Qe.type);
                                    Qe ? "vector" === Ll && "raster" === Rl ? rt.push(new Mt(Co, Wn.source, `layer "${Wn.id}" requires a raster source`)) : "raster-dem" !== Ll && "hillshade" === Rl ? rt.push(new Mt(Co, Wn.source, `layer "${Wn.id}" requires a raster-dem source`)) : "raster" === Ll && "raster" !== Rl ? rt.push(new Mt(Co, Wn.source, `layer "${Wn.id}" requires a vector source`)) : "vector" !== Ll || Wn["source-layer"] ? "raster-dem" === Ll && "hillshade" !== Rl ? rt.push(new Mt(Co, Wn.source, "raster-dem source can only be used with layer type 'hillshade'.")) : "line" !== Rl || !Wn.paint || !Wn.paint["line-gradient"] || "geojson" === Ll && Qe.lineMetrics || rt.push(new Mt(Co, Wn, `layer "${Wn.id}" specifies a line-gradient, which requires a GeoJSON source with \`lineMetrics\` enabled.`)) : rt.push(new Mt(Co, Wn, `layer "${Wn.id}" must specify a "source-layer"`)) : rt.push(new Mt(Co, Wn.source, `source "${Wn.source}" not found`));
                                } else rt.push(new Mt(Co, Wn, 'missing required property "source"'));
                            }
                            return rt = rt.concat(pi({
                                key: Co,
                                value: Wn,
                                valueSpec: Ll.layer,
                                style: Qe.style,
                                styleSpec: Qe.styleSpec,
                                validateSpec: Qe.validateSpec,
                                objectElementValidators: {
                                    "*": ()=>[],
                                    type: ()=>Qe.validateSpec({
                                            key: `${Co}.type`,
                                            value: Wn.type,
                                            valueSpec: Ll.layer.type,
                                            style: Qe.style,
                                            styleSpec: Qe.styleSpec,
                                            validateSpec: Qe.validateSpec,
                                            object: Wn,
                                            objectKey: "type"
                                        }),
                                    filter: xi,
                                    layout: (Qe)=>pi({
                                            layer: Wn,
                                            key: Qe.key,
                                            value: Qe.value,
                                            style: Qe.style,
                                            styleSpec: Qe.styleSpec,
                                            validateSpec: Qe.validateSpec,
                                            objectElementValidators: {
                                                "*": (Qe)=>_i(It({
                                                        layerType: Rl
                                                    }, Qe))
                                            }
                                        }),
                                    paint: (Qe)=>pi({
                                            layer: Wn,
                                            key: Qe.key,
                                            value: Qe.value,
                                            style: Qe.style,
                                            styleSpec: Qe.styleSpec,
                                            validateSpec: Qe.validateSpec,
                                            objectElementValidators: {
                                                "*": (Qe)=>wi(It({
                                                        layerType: Rl
                                                    }, Qe))
                                            }
                                        })
                                }
                            })), rt;
                        }
                        function Ai(Qe) {
                            const rt = Qe.value, Wn = Qe.key, Co = Tn(rt);
                            return "string" !== Co ? [
                                new Mt(Wn, rt, `string expected, ${Co} found`)
                            ] : [];
                        }
                        const Wd = {
                            promoteId: function({ key: Qe, value: rt }) {
                                if ("string" === Tn(rt)) return Ai({
                                    key: Qe,
                                    value: rt
                                });
                                {
                                    const Wn = [];
                                    for(const Co in rt)Wn.push(...Ai({
                                        key: `${Qe}.${Co}`,
                                        value: rt[Co]
                                    }));
                                    return Wn;
                                }
                            }
                        };
                        function Mi(Qe) {
                            const rt = Qe.value, Wn = Qe.key, Co = Qe.styleSpec, Dl = Qe.style, Ll = Qe.validateSpec;
                            if (!rt.type) return [
                                new Mt(Wn, rt, '"type" is required')
                            ];
                            const Rl = ci(rt.type);
                            let Ul;
                            switch(Rl){
                                case "vector":
                                case "raster":
                                    return Ul = pi({
                                        key: Wn,
                                        value: rt,
                                        valueSpec: Co[`source_${Rl.replace("-", "_")}`],
                                        style: Qe.style,
                                        styleSpec: Co,
                                        objectElementValidators: Wd,
                                        validateSpec: Ll
                                    }), Ul;
                                case "raster-dem":
                                    return Ul = function(Qe) {
                                        var rt;
                                        const Wn = null !== (rt = Qe.sourceName) && void 0 !== rt ? rt : "", Co = Qe.value, Dl = Qe.styleSpec, Ll = Dl.source_raster_dem, Rl = Qe.style;
                                        let Ul = [];
                                        const Gl = Tn(Co);
                                        if (void 0 === Co) return Ul;
                                        if ("object" !== Gl) return Ul.push(new Mt("source_raster_dem", Co, `object expected, ${Gl} found`)), Ul;
                                        const Zl = "custom" === ci(Co.encoding), Hl = [
                                            "redFactor",
                                            "greenFactor",
                                            "blueFactor",
                                            "baseShift"
                                        ], ql = Qe.value.encoding ? `"${Qe.value.encoding}"` : "Default";
                                        for(const Ql in Co)!Zl && Hl.includes(Ql) ? Ul.push(new Mt(Ql, Co[Ql], `In "${Wn}": "${Ql}" is only valid when "encoding" is set to "custom". ${ql} encoding found`)) : Ll[Ql] ? Ul = Ul.concat(Qe.validateSpec({
                                            key: Ql,
                                            value: Co[Ql],
                                            valueSpec: Ll[Ql],
                                            validateSpec: Qe.validateSpec,
                                            style: Rl,
                                            styleSpec: Dl
                                        })) : Ul.push(new Mt(Ql, Co[Ql], `unknown property "${Ql}"`));
                                        return Ul;
                                    }({
                                        sourceName: Wn,
                                        value: rt,
                                        style: Qe.style,
                                        styleSpec: Co,
                                        validateSpec: Ll
                                    }), Ul;
                                case "geojson":
                                    if (Ul = pi({
                                        key: Wn,
                                        value: rt,
                                        valueSpec: Co.source_geojson,
                                        style: Dl,
                                        styleSpec: Co,
                                        validateSpec: Ll,
                                        objectElementValidators: Wd
                                    }), rt.cluster) for(const Qe in rt.clusterProperties){
                                        const [Co, Dl] = rt.clusterProperties[Qe], Ll = "string" == typeof Co ? [
                                            Co,
                                            [
                                                "accumulated"
                                            ],
                                            [
                                                "get",
                                                Qe
                                            ]
                                        ] : Co;
                                        Ul.push(...mi({
                                            key: `${Wn}.${Qe}.map`,
                                            value: Dl,
                                            expressionContext: "cluster-map"
                                        })), Ul.push(...mi({
                                            key: `${Wn}.${Qe}.reduce`,
                                            value: Ll,
                                            expressionContext: "cluster-reduce"
                                        }));
                                    }
                                    return Ul;
                                case "video":
                                    return pi({
                                        key: Wn,
                                        value: rt,
                                        valueSpec: Co.source_video,
                                        style: Dl,
                                        validateSpec: Ll,
                                        styleSpec: Co
                                    });
                                case "image":
                                    return pi({
                                        key: Wn,
                                        value: rt,
                                        valueSpec: Co.source_image,
                                        style: Dl,
                                        validateSpec: Ll,
                                        styleSpec: Co
                                    });
                                case "canvas":
                                    return [
                                        new Mt(Wn, null, "Please use runtime APIs to add canvas sources, rather than including them in stylesheets.", "source.canvas")
                                    ];
                                default:
                                    return gi({
                                        key: `${Wn}.type`,
                                        value: rt.type,
                                        valueSpec: {
                                            values: [
                                                "vector",
                                                "raster",
                                                "raster-dem",
                                                "geojson",
                                                "video",
                                                "image"
                                            ]
                                        }
                                    });
                            }
                        }
                        function Ii(Qe) {
                            const rt = Qe.value, Wn = Qe.styleSpec, Co = Wn.light, Dl = Qe.style;
                            let Ll = [];
                            const Rl = Tn(rt);
                            if (void 0 === rt) return Ll;
                            if ("object" !== Rl) return Ll = Ll.concat([
                                new Mt("light", rt, `object expected, ${Rl} found`)
                            ]), Ll;
                            for(const Ul in rt){
                                const Rl = Ul.match(/^(.*)-transition$/);
                                Ll = Ll.concat(Rl && Co[Rl[1]] && Co[Rl[1]].transition ? Qe.validateSpec({
                                    key: Ul,
                                    value: rt[Ul],
                                    valueSpec: Wn.transition,
                                    validateSpec: Qe.validateSpec,
                                    style: Dl,
                                    styleSpec: Wn
                                }) : Co[Ul] ? Qe.validateSpec({
                                    key: Ul,
                                    value: rt[Ul],
                                    valueSpec: Co[Ul],
                                    validateSpec: Qe.validateSpec,
                                    style: Dl,
                                    styleSpec: Wn
                                }) : [
                                    new Mt(Ul, rt[Ul], `unknown property "${Ul}"`)
                                ]);
                            }
                            return Ll;
                        }
                        function zi(Qe) {
                            const rt = Qe.value, Wn = Qe.styleSpec, Co = Wn.sky, Dl = Qe.style, Ll = Tn(rt);
                            if (void 0 === rt) return [];
                            if ("object" !== Ll) return [
                                new Mt("sky", rt, `object expected, ${Ll} found`)
                            ];
                            let Rl = [];
                            for(const Ul in rt)Rl = Rl.concat(Co[Ul] ? Qe.validateSpec({
                                key: Ul,
                                value: rt[Ul],
                                valueSpec: Co[Ul],
                                style: Dl,
                                styleSpec: Wn
                            }) : [
                                new Mt(Ul, rt[Ul], `unknown property "${Ul}"`)
                            ]);
                            return Rl;
                        }
                        function Pi(Qe) {
                            const rt = Qe.value, Wn = Qe.styleSpec, Co = Wn.terrain, Dl = Qe.style;
                            let Ll = [];
                            const Rl = Tn(rt);
                            if (void 0 === rt) return Ll;
                            if ("object" !== Rl) return Ll = Ll.concat([
                                new Mt("terrain", rt, `object expected, ${Rl} found`)
                            ]), Ll;
                            for(const Ul in rt)Ll = Ll.concat(Co[Ul] ? Qe.validateSpec({
                                key: Ul,
                                value: rt[Ul],
                                valueSpec: Co[Ul],
                                validateSpec: Qe.validateSpec,
                                style: Dl,
                                styleSpec: Wn
                            }) : [
                                new Mt(Ul, rt[Ul], `unknown property "${Ul}"`)
                            ]);
                            return Ll;
                        }
                        function Ci(Qe) {
                            let rt = [];
                            const Wn = Qe.value, Co = Qe.key;
                            if (Array.isArray(Wn)) {
                                const Dl = [], Ll = [];
                                for(const Rl in Wn)Wn[Rl].id && Dl.includes(Wn[Rl].id) && rt.push(new Mt(Co, Wn, `all the sprites' ids must be unique, but ${Wn[Rl].id} is duplicated`)), Dl.push(Wn[Rl].id), Wn[Rl].url && Ll.includes(Wn[Rl].url) && rt.push(new Mt(Co, Wn, `all the sprites' URLs must be unique, but ${Wn[Rl].url} is duplicated`)), Ll.push(Wn[Rl].url), rt = rt.concat(pi({
                                    key: `${Co}[${Rl}]`,
                                    value: Wn[Rl],
                                    valueSpec: {
                                        id: {
                                            type: "string",
                                            required: !0
                                        },
                                        url: {
                                            type: "string",
                                            required: !0
                                        }
                                    },
                                    validateSpec: Qe.validateSpec
                                }));
                                return rt;
                            }
                            return Ai({
                                key: Co,
                                value: Wn
                            });
                        }
                        const qd = {
                            "*": ()=>[],
                            array: fi,
                            boolean: function(Qe) {
                                const rt = Qe.value, Wn = Qe.key, Co = Tn(rt);
                                return "boolean" !== Co ? [
                                    new Mt(Wn, rt, `boolean expected, ${Co} found`)
                                ] : [];
                            },
                            number: di,
                            color: function(Qe) {
                                const rt = Qe.key, Wn = Qe.value, Co = Tn(Wn);
                                return "string" !== Co ? [
                                    new Mt(rt, Wn, `color expected, ${Co} found`)
                                ] : xe.parse(String(Wn)) ? [] : [
                                    new Mt(rt, Wn, `color expected, "${Wn}" found`)
                                ];
                            },
                            constants: ui,
                            enum: gi,
                            filter: xi,
                            function: yi,
                            layer: Si,
                            object: pi,
                            source: Mi,
                            light: Ii,
                            sky: zi,
                            terrain: Pi,
                            projection: function(Qe) {
                                const rt = Qe.value, Wn = Qe.styleSpec, Co = Wn.projection, Dl = Qe.style, Ll = Tn(rt);
                                if (void 0 === rt) return [];
                                if ("object" !== Ll) return [
                                    new Mt("projection", rt, `object expected, ${Ll} found`)
                                ];
                                let Rl = [];
                                for(const Ul in rt)Rl = Rl.concat(Co[Ul] ? Qe.validateSpec({
                                    key: Ul,
                                    value: rt[Ul],
                                    valueSpec: Co[Ul],
                                    style: Dl,
                                    styleSpec: Wn
                                }) : [
                                    new Mt(Ul, rt[Ul], `unknown property "${Ul}"`)
                                ]);
                                return Rl;
                            },
                            projectionDefinition: function(Qe) {
                                const rt = Qe.key;
                                let Wn = Qe.value;
                                Wn = Wn instanceof String ? Wn.valueOf() : Wn;
                                const Co = Tn(Wn);
                                return "array" !== Co || function(Qe) {
                                    return Array.isArray(Qe) && 3 === Qe.length && "string" == typeof Qe[0] && "string" == typeof Qe[1] && "number" == typeof Qe[2];
                                }(Wn) || function(Qe) {
                                    return !![
                                        "interpolate",
                                        "step",
                                        "literal"
                                    ].includes(Qe[0]);
                                }(Wn) ? [
                                    "array",
                                    "string"
                                ].includes(Co) ? [] : [
                                    new Mt(rt, Wn, `projection expected, invalid type "${Co}" found`)
                                ] : [
                                    new Mt(rt, Wn, `projection expected, invalid array ${JSON.stringify(Wn)} found`)
                                ];
                            },
                            string: Ai,
                            formatted: function(Qe) {
                                return 0 === Ai(Qe).length ? [] : mi(Qe);
                            },
                            resolvedImage: function(Qe) {
                                return 0 === Ai(Qe).length ? [] : mi(Qe);
                            },
                            padding: function(Qe) {
                                const rt = Qe.key, Wn = Qe.value;
                                if ("array" === Tn(Wn)) {
                                    if (Wn.length < 1 || Wn.length > 4) return [
                                        new Mt(rt, Wn, `padding requires 1 to 4 values; ${Wn.length} values found`)
                                    ];
                                    const Co = {
                                        type: "number"
                                    };
                                    let Dl = [];
                                    for(let Ll = 0; Ll < Wn.length; Ll++)Dl = Dl.concat(Qe.validateSpec({
                                        key: `${rt}[${Ll}]`,
                                        value: Wn[Ll],
                                        validateSpec: Qe.validateSpec,
                                        valueSpec: Co
                                    }));
                                    return Dl;
                                }
                                return di({
                                    key: rt,
                                    value: Wn,
                                    valueSpec: {}
                                });
                            },
                            variableAnchorOffsetCollection: function(Qe) {
                                const rt = Qe.key, Wn = Qe.value, Co = Tn(Wn), Dl = Qe.styleSpec;
                                if ("array" !== Co || Wn.length < 1 || Wn.length % 2 != 0) return [
                                    new Mt(rt, Wn, "variableAnchorOffsetCollection requires a non-empty array of even length")
                                ];
                                let Ll = [];
                                for(let Rl = 0; Rl < Wn.length; Rl += 2)Ll = Ll.concat(gi({
                                    key: `${rt}[${Rl}]`,
                                    value: Wn[Rl],
                                    valueSpec: Dl.layout_symbol["text-anchor"]
                                })), Ll = Ll.concat(fi({
                                    key: `${rt}[${Rl + 1}]`,
                                    value: Wn[Rl + 1],
                                    valueSpec: {
                                        length: 2,
                                        value: "number"
                                    },
                                    validateSpec: Qe.validateSpec,
                                    style: Qe.style,
                                    styleSpec: Dl
                                }));
                                return Ll;
                            },
                            sprite: Ci
                        };
                        function Vi(Qe) {
                            const rt = Qe.value, Wn = Qe.valueSpec, Co = Qe.styleSpec;
                            return Qe.validateSpec = Vi, Wn.expression && Fn(ci(rt)) ? yi(Qe) : Wn.expression && qn(hi(rt)) ? mi(Qe) : Wn.type && qd[Wn.type] ? qd[Wn.type](Qe) : pi(It({}, Qe, {
                                valueSpec: Wn.type ? Co[Wn.type] : Wn
                            }));
                        }
                        function Ei(Qe) {
                            const rt = Qe.value, Wn = Qe.key, Co = Ai(Qe);
                            return Co.length || (-1 === rt.indexOf("{fontstack}") && Co.push(new Mt(Wn, rt, '"glyphs" url must include a "{fontstack}" token')), -1 === rt.indexOf("{range}") && Co.push(new Mt(Wn, rt, '"glyphs" url must include a "{range}" token'))), Co;
                        }
                        function Ti(Qe, rt = Ju) {
                            let Wn = [];
                            return Wn = Wn.concat(Vi({
                                key: "",
                                value: Qe,
                                valueSpec: rt.$root,
                                styleSpec: rt,
                                style: Qe,
                                validateSpec: Vi,
                                objectElementValidators: {
                                    glyphs: Ei,
                                    "*": ()=>[]
                                }
                            })), Qe.constants && (Wn = Wn.concat(ui({
                                key: "constants",
                                value: Qe.constants
                            }))), $i(Wn);
                        }
                        function Fi(Qe) {
                            return function(rt) {
                                return Qe({
                                    ...rt,
                                    validateSpec: Vi
                                });
                            };
                        }
                        function $i(Qe) {
                            return [].concat(Qe).sort((Qe, rt)=>Qe.line - rt.line);
                        }
                        function Li(Qe) {
                            return function(...rt) {
                                return $i(Qe.apply(this, rt));
                            };
                        }
                        Ti.source = Li(Fi(Mi)), Ti.sprite = Li(Fi(Ci)), Ti.glyphs = Li(Fi(Ei)), Ti.light = Li(Fi(Ii)), Ti.sky = Li(Fi(zi)), Ti.terrain = Li(Fi(Pi)), Ti.layer = Li(Fi(Si)), Ti.filter = Li(Fi(xi)), Ti.paintProperty = Li(Fi(wi)), Ti.layoutProperty = Li(Fi(_i));
                        const Yd = Ti, Qd = Yd.light, Kd = Yd.sky, Xd = Yd.paintProperty, Jd = Yd.layoutProperty;
                        function Ui(Qe, rt) {
                            let Wn = !1;
                            if (rt && rt.length) for (const Co of rt)Qe.fire(new pt(new Error(Co.message))), Wn = !0;
                            return Wn;
                        }
                        class qi {
                            constructor(Qe, rt, Wn){
                                const Co = this.cells = [];
                                if (Qe instanceof ArrayBuffer) {
                                    this.arrayBuffer = Qe;
                                    const Dl = new Int32Array(this.arrayBuffer);
                                    Qe = Dl[0], this.d = (rt = Dl[1]) + 2 * (Wn = Dl[2]);
                                    for(let Qe = 0; Qe < this.d * this.d; Qe++){
                                        const rt = Dl[3 + Qe], Wn = Dl[3 + Qe + 1];
                                        Co.push(rt === Wn ? null : Dl.subarray(rt, Wn));
                                    }
                                    const Ll = Dl[3 + Co.length + 1];
                                    this.keys = Dl.subarray(Dl[3 + Co.length], Ll), this.bboxes = Dl.subarray(Ll), this.insert = this._insertReadonly;
                                } else {
                                    this.d = rt + 2 * Wn;
                                    for(let Qe = 0; Qe < this.d * this.d; Qe++)Co.push([]);
                                    this.keys = [], this.bboxes = [];
                                }
                                this.n = rt, this.extent = Qe, this.padding = Wn, this.scale = rt / Qe, this.uid = 0;
                                const Dl = Wn / rt * Qe;
                                this.min = -Dl, this.max = Qe + Dl;
                            }
                            insert(Qe, rt, Wn, Co, Dl) {
                                this._forEachCell(rt, Wn, Co, Dl, this._insertCell, this.uid++, void 0, void 0), this.keys.push(Qe), this.bboxes.push(rt), this.bboxes.push(Wn), this.bboxes.push(Co), this.bboxes.push(Dl);
                            }
                            _insertReadonly() {
                                throw new Error("Cannot insert into a GridIndex created from an ArrayBuffer.");
                            }
                            _insertCell(Qe, rt, Wn, Co, Dl, Ll) {
                                this.cells[Dl].push(Ll);
                            }
                            query(Qe, rt, Wn, Co, Dl) {
                                const Ll = this.min, Rl = this.max;
                                if (Qe <= Ll && rt <= Ll && Rl <= Wn && Rl <= Co && !Dl) return Array.prototype.slice.call(this.keys);
                                {
                                    const Ll = [];
                                    return this._forEachCell(Qe, rt, Wn, Co, this._queryCell, Ll, {}, Dl), Ll;
                                }
                            }
                            _queryCell(Qe, rt, Wn, Co, Dl, Ll, Rl, Ul) {
                                const Gl = this.cells[Dl];
                                if (null !== Gl) {
                                    const Dl = this.keys, Zl = this.bboxes;
                                    for(let Hl = 0; Hl < Gl.length; Hl++){
                                        const ql = Gl[Hl];
                                        if (void 0 === Rl[ql]) {
                                            const Gl = 4 * ql;
                                            (Ul ? Ul(Zl[Gl + 0], Zl[Gl + 1], Zl[Gl + 2], Zl[Gl + 3]) : Qe <= Zl[Gl + 2] && rt <= Zl[Gl + 3] && Wn >= Zl[Gl + 0] && Co >= Zl[Gl + 1]) ? (Rl[ql] = !0, Ll.push(Dl[ql])) : Rl[ql] = !1;
                                        }
                                    }
                                }
                            }
                            _forEachCell(Qe, rt, Wn, Co, Dl, Ll, Rl, Ul) {
                                const Gl = this._convertToCellCoord(Qe), Zl = this._convertToCellCoord(rt), Hl = this._convertToCellCoord(Wn), ql = this._convertToCellCoord(Co);
                                for(let Ql = Gl; Ql <= Hl; Ql++)for(let Gl = Zl; Gl <= ql; Gl++){
                                    const Zl = this.d * Gl + Ql;
                                    if ((!Ul || Ul(this._convertFromCellCoord(Ql), this._convertFromCellCoord(Gl), this._convertFromCellCoord(Ql + 1), this._convertFromCellCoord(Gl + 1))) && Dl.call(this, Qe, rt, Wn, Co, Zl, Ll, Rl, Ul)) return;
                                }
                            }
                            _convertFromCellCoord(Qe) {
                                return (Qe - this.padding) / this.scale;
                            }
                            _convertToCellCoord(Qe) {
                                return Math.max(0, Math.min(this.d - 1, Math.floor(Qe * this.scale) + this.padding));
                            }
                            toArrayBuffer() {
                                if (this.arrayBuffer) return this.arrayBuffer;
                                const Qe = this.cells, rt = 3 + this.cells.length + 1 + 1;
                                let Wn = 0;
                                for(let Ll = 0; Ll < this.cells.length; Ll++)Wn += this.cells[Ll].length;
                                const Co = new Int32Array(rt + Wn + this.keys.length + this.bboxes.length);
                                Co[0] = this.extent, Co[1] = this.n, Co[2] = this.padding;
                                let Dl = rt;
                                for(let Ll = 0; Ll < Qe.length; Ll++){
                                    const rt = Qe[Ll];
                                    Co[3 + Ll] = Dl, Co.set(rt, Dl), Dl += rt.length;
                                }
                                return Co[3 + Qe.length] = Dl, Co.set(this.keys, Dl), Dl += this.keys.length, Co[3 + Qe.length + 1] = Dl, Co.set(this.bboxes, Dl), Dl += this.bboxes.length, Co.buffer;
                            }
                            static serialize(Qe, rt) {
                                const Wn = Qe.toArrayBuffer();
                                return rt && rt.push(Wn), {
                                    buffer: Wn
                                };
                            }
                            static deserialize(Qe) {
                                return new qi(Qe.buffer);
                            }
                        }
                        const $d = {};
                        function Zi(Qe, rt, Wn = {}) {
                            if ($d[Qe]) throw new Error(`${Qe} is already registered.`);
                            Object.defineProperty(rt, "_classRegistryKey", {
                                value: Qe,
                                writeable: !1
                            }), $d[Qe] = {
                                klass: rt,
                                omit: Wn.omit || [],
                                shallow: Wn.shallow || []
                            };
                        }
                        Zi("Object", Object), Zi("TransferableGridIndex", qi), Zi("Color", xe), Zi("Error", Error), Zi("AJAXError", st), Zi("ResolvedImage", Ie), Zi("StylePropertyFunction", Hn), Zi("StyleExpression", Un, {
                            omit: [
                                "_evaluator"
                            ]
                        }), Zi("ZoomDependentExpression", Kn), Zi("ZoomConstantExpression", Zn), Zi("CompoundExpression", bn, {
                            omit: [
                                "_evaluate"
                            ]
                        });
                        for(const _f in Zd)Zd[_f]._classRegistryKey || Zi(`Expression_${_f}`, Zd[_f]);
                        function Ki(Qe) {
                            return Qe && "undefined" != typeof ArrayBuffer && (Qe instanceof ArrayBuffer || Qe.constructor && "ArrayBuffer" === Qe.constructor.name);
                        }
                        function Xi(Qe) {
                            return Qe.$name || Qe.constructor._classRegistryKey;
                        }
                        function Hi(Qe) {
                            return !function(Qe) {
                                if (null === Qe || "object" != typeof Qe) return !1;
                                const rt = Xi(Qe);
                                return !(!rt || "Object" === rt);
                            }(Qe) && (null == Qe || "boolean" == typeof Qe || "number" == typeof Qe || "string" == typeof Qe || Qe instanceof Boolean || Qe instanceof Number || Qe instanceof String || Qe instanceof Date || Qe instanceof RegExp || Qe instanceof Blob || Qe instanceof Error || Ki(Qe) || G(Qe) || ArrayBuffer.isView(Qe) || Qe instanceof ImageData);
                        }
                        function Yi(Qe, rt) {
                            if (Hi(Qe)) return (Ki(Qe) || G(Qe)) && rt && rt.push(Qe), ArrayBuffer.isView(Qe) && rt && rt.push(Qe.buffer), Qe instanceof ImageData && rt && rt.push(Qe.data.buffer), Qe;
                            if (Array.isArray(Qe)) {
                                const Wn = [];
                                for (const Co of Qe)Wn.push(Yi(Co, rt));
                                return Wn;
                            }
                            if ("object" != typeof Qe) throw new Error("can't serialize object of type " + typeof Qe);
                            const Wn = Xi(Qe);
                            if (!Wn) throw new Error(`can't serialize object of unregistered class ${Qe.constructor.name}`);
                            if (!$d[Wn]) throw new Error(`${Wn} is not registered.`);
                            const { klass: Co } = $d[Wn], Dl = Co.serialize ? Co.serialize(Qe, rt) : {};
                            if (Co.serialize) {
                                if (rt && Dl === rt[rt.length - 1]) throw new Error("statically serialized object won't survive transfer of $name property");
                            } else {
                                for(const Co in Qe){
                                    if (!Qe.hasOwnProperty(Co)) continue;
                                    if ($d[Wn].omit.indexOf(Co) >= 0) continue;
                                    const Ll = Qe[Co];
                                    Dl[Co] = $d[Wn].shallow.indexOf(Co) >= 0 ? Ll : Yi(Ll, rt);
                                }
                                Qe instanceof Error && (Dl.message = Qe.message);
                            }
                            if (Dl.$name) throw new Error("$name property is reserved for worker serialization logic.");
                            return "Object" !== Wn && (Dl.$name = Wn), Dl;
                        }
                        function Ji(Qe) {
                            if (Hi(Qe)) return Qe;
                            if (Array.isArray(Qe)) return Qe.map(Ji);
                            if ("object" != typeof Qe) throw new Error("can't deserialize object of type " + typeof Qe);
                            const rt = Xi(Qe) || "Object";
                            if (!$d[rt]) throw new Error(`can't deserialize unregistered class ${rt}`);
                            const { klass: Wn } = $d[rt];
                            if (!Wn) throw new Error(`can't deserialize unregistered class ${rt}`);
                            if (Wn.deserialize) return Wn.deserialize(Qe);
                            const Co = Object.create(Wn.prototype);
                            for (const Dl of Object.keys(Qe)){
                                if ("$name" === Dl) continue;
                                const Wn = Qe[Dl];
                                Co[Dl] = $d[rt].shallow.indexOf(Dl) >= 0 ? Wn : Ji(Wn);
                            }
                            return Co;
                        }
                        class Wi {
                            constructor(){
                                this.first = !0;
                            }
                            update(Qe, rt) {
                                const Wn = Math.floor(Qe);
                                return this.first ? (this.first = !1, this.lastIntegerZoom = Wn, this.lastIntegerZoomTime = 0, this.lastZoom = Qe, this.lastFloorZoom = Wn, !0) : (this.lastFloorZoom > Wn ? (this.lastIntegerZoom = Wn + 1, this.lastIntegerZoomTime = rt) : this.lastFloorZoom < Wn && (this.lastIntegerZoom = Wn, this.lastIntegerZoomTime = rt), Qe !== this.lastZoom && (this.lastZoom = Qe, this.lastFloorZoom = Wn, !0));
                            }
                        }
                        const up = {
                            "Latin-1 Supplement": (Qe)=>Qe >= 128 && Qe <= 255,
                            "Hangul Jamo": (Qe)=>Qe >= 4352 && Qe <= 4607,
                            Khmer: (Qe)=>Qe >= 6016 && Qe <= 6143,
                            "General Punctuation": (Qe)=>Qe >= 8192 && Qe <= 8303,
                            "Letterlike Symbols": (Qe)=>Qe >= 8448 && Qe <= 8527,
                            "Number Forms": (Qe)=>Qe >= 8528 && Qe <= 8591,
                            "Miscellaneous Technical": (Qe)=>Qe >= 8960 && Qe <= 9215,
                            "Control Pictures": (Qe)=>Qe >= 9216 && Qe <= 9279,
                            "Optical Character Recognition": (Qe)=>Qe >= 9280 && Qe <= 9311,
                            "Enclosed Alphanumerics": (Qe)=>Qe >= 9312 && Qe <= 9471,
                            "Geometric Shapes": (Qe)=>Qe >= 9632 && Qe <= 9727,
                            "Miscellaneous Symbols": (Qe)=>Qe >= 9728 && Qe <= 9983,
                            "Miscellaneous Symbols and Arrows": (Qe)=>Qe >= 11008 && Qe <= 11263,
                            "Ideographic Description Characters": (Qe)=>Qe >= 12272 && Qe <= 12287,
                            "CJK Symbols and Punctuation": (Qe)=>Qe >= 12288 && Qe <= 12351,
                            Hiragana: (Qe)=>Qe >= 12352 && Qe <= 12447,
                            Katakana: (Qe)=>Qe >= 12448 && Qe <= 12543,
                            Kanbun: (Qe)=>Qe >= 12688 && Qe <= 12703,
                            "CJK Strokes": (Qe)=>Qe >= 12736 && Qe <= 12783,
                            "Enclosed CJK Letters and Months": (Qe)=>Qe >= 12800 && Qe <= 13055,
                            "CJK Compatibility": (Qe)=>Qe >= 13056 && Qe <= 13311,
                            "Yijing Hexagram Symbols": (Qe)=>Qe >= 19904 && Qe <= 19967,
                            "CJK Unified Ideographs": (Qe)=>Qe >= 19968 && Qe <= 40959,
                            "Hangul Syllables": (Qe)=>Qe >= 44032 && Qe <= 55215,
                            "Private Use Area": (Qe)=>Qe >= 57344 && Qe <= 63743,
                            "Vertical Forms": (Qe)=>Qe >= 65040 && Qe <= 65055,
                            "CJK Compatibility Forms": (Qe)=>Qe >= 65072 && Qe <= 65103,
                            "Small Form Variants": (Qe)=>Qe >= 65104 && Qe <= 65135,
                            "Halfwidth and Fullwidth Forms": (Qe)=>Qe >= 65280 && Qe <= 65519
                        };
                        function ts(Qe) {
                            for (const rt of Qe)if (as(rt.charCodeAt(0))) return !0;
                            return !1;
                        }
                        function es(Qe) {
                            for (const rt of Qe)if (!is(rt.charCodeAt(0))) return !1;
                            return !0;
                        }
                        function rs(Qe) {
                            const rt = Qe.map((Qe)=>{
                                try {
                                    return new RegExp(`\\p{sc=${Qe}}`, "u").source;
                                } catch (Qe) {
                                    return null;
                                }
                            }).filter((Qe)=>Qe);
                            return new RegExp(rt.join("|"), "u");
                        }
                        const gp = rs([
                            "Arab",
                            "Dupl",
                            "Mong",
                            "Ougr",
                            "Syrc"
                        ]);
                        function is(Qe) {
                            return !gp.test(String.fromCodePoint(Qe));
                        }
                        const Ap = rs([
                            "Bopo",
                            "Hani",
                            "Hira",
                            "Kana",
                            "Kits",
                            "Nshu",
                            "Tang",
                            "Yiii"
                        ]);
                        function as(Qe) {
                            return !(746 !== Qe && 747 !== Qe && (Qe < 4352 || !(up["CJK Compatibility Forms"](Qe) && !(Qe >= 65097 && Qe <= 65103) || up["CJK Compatibility"](Qe) || up["CJK Strokes"](Qe) || !(!up["CJK Symbols and Punctuation"](Qe) || Qe >= 12296 && Qe <= 12305 || Qe >= 12308 && Qe <= 12319 || 12336 === Qe) || up["Enclosed CJK Letters and Months"](Qe) || up["Ideographic Description Characters"](Qe) || up.Kanbun(Qe) || up.Katakana(Qe) && 12540 !== Qe || !(!up["Halfwidth and Fullwidth Forms"](Qe) || 65288 === Qe || 65289 === Qe || 65293 === Qe || Qe >= 65306 && Qe <= 65310 || 65339 === Qe || 65341 === Qe || 65343 === Qe || Qe >= 65371 && Qe <= 65503 || 65507 === Qe || Qe >= 65512 && Qe <= 65519) || !(!up["Small Form Variants"](Qe) || Qe >= 65112 && Qe <= 65118 || Qe >= 65123 && Qe <= 65126) || up["Vertical Forms"](Qe) || up["Yijing Hexagram Symbols"](Qe) || /\p{sc=Cans}/u.test(String.fromCodePoint(Qe)) || /\p{sc=Hang}/u.test(String.fromCodePoint(Qe)) || Ap.test(String.fromCodePoint(Qe)))));
                        }
                        function os(Qe) {
                            return !(as(Qe) || function(Qe) {
                                return !!(up["Latin-1 Supplement"](Qe) && (167 === Qe || 169 === Qe || 174 === Qe || 177 === Qe || 188 === Qe || 189 === Qe || 190 === Qe || 215 === Qe || 247 === Qe) || up["General Punctuation"](Qe) && (8214 === Qe || 8224 === Qe || 8225 === Qe || 8240 === Qe || 8241 === Qe || 8251 === Qe || 8252 === Qe || 8258 === Qe || 8263 === Qe || 8264 === Qe || 8265 === Qe || 8273 === Qe) || up["Letterlike Symbols"](Qe) || up["Number Forms"](Qe) || up["Miscellaneous Technical"](Qe) && (Qe >= 8960 && Qe <= 8967 || Qe >= 8972 && Qe <= 8991 || Qe >= 8996 && Qe <= 9e3 || 9003 === Qe || Qe >= 9085 && Qe <= 9114 || Qe >= 9150 && Qe <= 9165 || 9167 === Qe || Qe >= 9169 && Qe <= 9179 || Qe >= 9186 && Qe <= 9215) || up["Control Pictures"](Qe) && 9251 !== Qe || up["Optical Character Recognition"](Qe) || up["Enclosed Alphanumerics"](Qe) || up["Geometric Shapes"](Qe) || up["Miscellaneous Symbols"](Qe) && !(Qe >= 9754 && Qe <= 9759) || up["Miscellaneous Symbols and Arrows"](Qe) && (Qe >= 11026 && Qe <= 11055 || Qe >= 11088 && Qe <= 11097 || Qe >= 11192 && Qe <= 11243) || up["CJK Symbols and Punctuation"](Qe) || up.Katakana(Qe) || up["Private Use Area"](Qe) || up["CJK Compatibility Forms"](Qe) || up["Small Form Variants"](Qe) || up["Halfwidth and Fullwidth Forms"](Qe) || 8734 === Qe || 8756 === Qe || 8757 === Qe || Qe >= 9984 && Qe <= 10087 || Qe >= 10102 && Qe <= 10131 || 65532 === Qe || 65533 === Qe);
                            }(Qe));
                        }
                        const vp = rs([
                            "Adlm",
                            "Arab",
                            "Armi",
                            "Avst",
                            "Chrs",
                            "Cprt",
                            "Egyp",
                            "Elym",
                            "Gara",
                            "Hatr",
                            "Hebr",
                            "Hung",
                            "Khar",
                            "Lydi",
                            "Mand",
                            "Mani",
                            "Mend",
                            "Merc",
                            "Mero",
                            "Narb",
                            "Nbat",
                            "Nkoo",
                            "Orkh",
                            "Palm",
                            "Phli",
                            "Phlp",
                            "Phnx",
                            "Prti",
                            "Rohg",
                            "Samr",
                            "Sarb",
                            "Sogo",
                            "Syrc",
                            "Thaa",
                            "Todr",
                            "Yezi"
                        ]);
                        function us(Qe) {
                            return vp.test(String.fromCodePoint(Qe));
                        }
                        function cs(Qe, rt) {
                            return !(!rt && us(Qe) || Qe >= 2304 && Qe <= 3583 || Qe >= 3840 && Qe <= 4255 || up.Khmer(Qe));
                        }
                        function hs(Qe) {
                            for (const rt of Qe)if (us(rt.charCodeAt(0))) return !0;
                            return !1;
                        }
                        const _p = new class {
                            constructor(){
                                this.TIMEOUT = 5e3, this.applyArabicShaping = null, this.processBidirectionalText = null, this.processStyledBidirectionalText = null, this.pluginStatus = "unavailable", this.pluginURL = null, this.loadScriptResolve = ()=>{};
                            }
                            setState(Qe) {
                                this.pluginStatus = Qe.pluginStatus, this.pluginURL = Qe.pluginURL;
                            }
                            getState() {
                                return {
                                    pluginStatus: this.pluginStatus,
                                    pluginURL: this.pluginURL
                                };
                            }
                            setMethods(Qe) {
                                if (_p.isParsed()) throw new Error("RTL text plugin already registered.");
                                this.applyArabicShaping = Qe.applyArabicShaping, this.processBidirectionalText = Qe.processBidirectionalText, this.processStyledBidirectionalText = Qe.processStyledBidirectionalText, this.loadScriptResolve();
                            }
                            isParsed() {
                                return null != this.applyArabicShaping && null != this.processBidirectionalText && null != this.processStyledBidirectionalText;
                            }
                            getRTLTextPluginStatus() {
                                return this.pluginStatus;
                            }
                            syncState(Qe, rt) {
                                return e(this, void 0, void 0, function*() {
                                    if (this.isParsed()) return this.getState();
                                    if ("loading" !== Qe.pluginStatus) return this.setState(Qe), Qe;
                                    const Wn = Qe.pluginURL, Co = new Promise((Qe)=>{
                                        this.loadScriptResolve = Qe;
                                    });
                                    rt(Wn);
                                    const Dl = new Promise((Qe)=>setTimeout(()=>Qe(), this.TIMEOUT));
                                    if (yield Promise.race([
                                        Co,
                                        Dl
                                    ]), this.isParsed()) {
                                        const Qe = {
                                            pluginStatus: "loaded",
                                            pluginURL: Wn
                                        };
                                        return this.setState(Qe), Qe;
                                    }
                                    throw this.setState({
                                        pluginStatus: "error",
                                        pluginURL: ""
                                    }), new Error(`RTL Text Plugin failed to import scripts from ${Wn}`);
                                });
                            }
                        };
                        class fs {
                            constructor(Qe, rt){
                                this.zoom = Qe, rt ? (this.now = rt.now, this.fadeDuration = rt.fadeDuration, this.zoomHistory = rt.zoomHistory, this.transition = rt.transition) : (this.now = 0, this.fadeDuration = 0, this.zoomHistory = new Wi, this.transition = {});
                            }
                            isSupportedScript(Qe) {
                                return function(Qe, rt) {
                                    for (const Wn of Qe)if (!cs(Wn.charCodeAt(0), rt)) return !1;
                                    return !0;
                                }(Qe, "loaded" === _p.getRTLTextPluginStatus());
                            }
                            crossFadingFactor() {
                                return 0 === this.fadeDuration ? 1 : Math.min((this.now - this.zoomHistory.lastIntegerZoomTime) / this.fadeDuration, 1);
                            }
                            getCrossfadeParameters() {
                                const Qe = this.zoom, rt = Qe - Math.floor(Qe), Wn = this.crossFadingFactor();
                                return Qe > this.zoomHistory.lastIntegerZoom ? {
                                    fromScale: 2,
                                    toScale: 1,
                                    t: rt + (1 - rt) * Wn
                                } : {
                                    fromScale: .5,
                                    toScale: 1,
                                    t: 1 - (1 - Wn) * rt
                                };
                            }
                        }
                        class ds {
                            constructor(Qe, rt){
                                this.property = Qe, this.value = rt, this.expression = function(Qe, rt) {
                                    if (Fn(Qe)) return new Hn(Qe, rt);
                                    if (qn(Qe)) {
                                        const Wn = Xn(Qe, rt);
                                        if ("error" === Wn.result) throw new Error(Wn.value.map((Qe)=>`${Qe.key}: ${Qe.message}`).join(", "));
                                        return Wn.value;
                                    }
                                    {
                                        let Wn = Qe;
                                        return "color" === rt.type && "string" == typeof Qe ? Wn = xe.parse(Qe) : "padding" !== rt.type || "number" != typeof Qe && !Array.isArray(Qe) ? "variableAnchorOffsetCollection" === rt.type && Array.isArray(Qe) ? Wn = Me.parse(Qe) : "projectionDefinition" === rt.type && "string" == typeof Qe && (Wn = ze.parse(Qe)) : Wn = Se.parse(Qe), {
                                            kind: "constant",
                                            evaluate: ()=>Wn
                                        };
                                    }
                                }(void 0 === rt ? Qe.specification.default : rt, Qe.specification);
                            }
                            isDataDriven() {
                                return "source" === this.expression.kind || "composite" === this.expression.kind;
                            }
                            possiblyEvaluate(Qe, rt, Wn) {
                                return this.property.possiblyEvaluate(this, Qe, rt, Wn);
                            }
                        }
                        class ys {
                            constructor(Qe){
                                this.property = Qe, this.value = new ds(Qe, void 0);
                            }
                            transitioned(Qe, rt) {
                                return new gs(this.property, this.value, rt, F({}, Qe.transition, this.transition), Qe.now);
                            }
                            untransitioned() {
                                return new gs(this.property, this.value, null, {}, 0);
                            }
                        }
                        class ms {
                            constructor(Qe){
                                this._properties = Qe, this._values = Object.create(Qe.defaultTransitionablePropertyValues);
                            }
                            getValue(Qe) {
                                return D(this._values[Qe].value.value);
                            }
                            setValue(Qe, rt) {
                                Object.prototype.hasOwnProperty.call(this._values, Qe) || (this._values[Qe] = new ys(this._values[Qe].property)), this._values[Qe].value = new ds(this._values[Qe].property, null === rt ? void 0 : D(rt));
                            }
                            getTransition(Qe) {
                                return D(this._values[Qe].transition);
                            }
                            setTransition(Qe, rt) {
                                Object.prototype.hasOwnProperty.call(this._values, Qe) || (this._values[Qe] = new ys(this._values[Qe].property)), this._values[Qe].transition = D(rt) || void 0;
                            }
                            serialize() {
                                const Qe = {};
                                for (const rt of Object.keys(this._values)){
                                    const Wn = this.getValue(rt);
                                    void 0 !== Wn && (Qe[rt] = Wn);
                                    const Co = this.getTransition(rt);
                                    void 0 !== Co && (Qe[`${rt}-transition`] = Co);
                                }
                                return Qe;
                            }
                            transitioned(Qe, rt) {
                                const Wn = new xs(this._properties);
                                for (const Co of Object.keys(this._values))Wn._values[Co] = this._values[Co].transitioned(Qe, rt._values[Co]);
                                return Wn;
                            }
                            untransitioned() {
                                const Qe = new xs(this._properties);
                                for (const rt of Object.keys(this._values))Qe._values[rt] = this._values[rt].untransitioned();
                                return Qe;
                            }
                        }
                        class gs {
                            constructor(Qe, rt, Wn, Co, Dl){
                                this.property = Qe, this.value = rt, this.begin = Dl + Co.delay || 0, this.end = this.begin + Co.duration || 0, Qe.specification.transition && (Co.delay || Co.duration) && (this.prior = Wn);
                            }
                            possiblyEvaluate(Qe, rt, Wn) {
                                const Co = Qe.now || 0, Dl = this.value.possiblyEvaluate(Qe, rt, Wn), Ll = this.prior;
                                if (Ll) {
                                    if (Co > this.end) return this.prior = null, Dl;
                                    if (this.value.isDataDriven()) return this.prior = null, Dl;
                                    if (Co < this.begin) return Ll.possiblyEvaluate(Qe, rt, Wn);
                                    {
                                        const Rl = (Co - this.begin) / (this.end - this.begin);
                                        return this.property.interpolate(Ll.possiblyEvaluate(Qe, rt, Wn), Dl, C(Rl));
                                    }
                                }
                                return Dl;
                            }
                        }
                        class xs {
                            constructor(Qe){
                                this._properties = Qe, this._values = Object.create(Qe.defaultTransitioningPropertyValues);
                            }
                            possiblyEvaluate(Qe, rt, Wn) {
                                const Co = new ws(this._properties);
                                for (const Dl of Object.keys(this._values))Co._values[Dl] = this._values[Dl].possiblyEvaluate(Qe, rt, Wn);
                                return Co;
                            }
                            hasTransition() {
                                for (const Qe of Object.keys(this._values))if (this._values[Qe].prior) return !0;
                                return !1;
                            }
                        }
                        class vs {
                            constructor(Qe){
                                this._properties = Qe, this._values = Object.create(Qe.defaultPropertyValues);
                            }
                            hasValue(Qe) {
                                return void 0 !== this._values[Qe].value;
                            }
                            getValue(Qe) {
                                return D(this._values[Qe].value);
                            }
                            setValue(Qe, rt) {
                                this._values[Qe] = new ds(this._values[Qe].property, null === rt ? void 0 : D(rt));
                            }
                            serialize() {
                                const Qe = {};
                                for (const rt of Object.keys(this._values)){
                                    const Wn = this.getValue(rt);
                                    void 0 !== Wn && (Qe[rt] = Wn);
                                }
                                return Qe;
                            }
                            possiblyEvaluate(Qe, rt, Wn) {
                                const Co = new ws(this._properties);
                                for (const Dl of Object.keys(this._values))Co._values[Dl] = this._values[Dl].possiblyEvaluate(Qe, rt, Wn);
                                return Co;
                            }
                        }
                        class bs {
                            constructor(Qe, rt, Wn){
                                this.property = Qe, this.value = rt, this.parameters = Wn;
                            }
                            isConstant() {
                                return "constant" === this.value.kind;
                            }
                            constantOr(Qe) {
                                return "constant" === this.value.kind ? this.value.value : Qe;
                            }
                            evaluate(Qe, rt, Wn, Co) {
                                return this.property.evaluate(this.value, this.parameters, Qe, rt, Wn, Co);
                            }
                        }
                        class ws {
                            constructor(Qe){
                                this._properties = Qe, this._values = Object.create(Qe.defaultPossiblyEvaluatedValues);
                            }
                            get(Qe) {
                                return this._values[Qe];
                            }
                        }
                        class _s {
                            constructor(Qe){
                                this.specification = Qe;
                            }
                            possiblyEvaluate(Qe, rt) {
                                if (Qe.isDataDriven()) throw new Error("Value should not be data driven");
                                return Qe.expression.evaluate(rt);
                            }
                            interpolate(Qe, rt, Wn) {
                                const Co = Ld[this.specification.type];
                                return Co ? Co(Qe, rt, Wn) : Qe;
                            }
                        }
                        class Ss {
                            constructor(Qe, rt){
                                this.specification = Qe, this.overrides = rt;
                            }
                            possiblyEvaluate(Qe, rt, Wn, Co) {
                                return new bs(this, "constant" === Qe.expression.kind || "camera" === Qe.expression.kind ? {
                                    kind: "constant",
                                    value: Qe.expression.evaluate(rt, null, {}, Wn, Co)
                                } : Qe.expression, rt);
                            }
                            interpolate(Qe, rt, Wn) {
                                if ("constant" !== Qe.value.kind || "constant" !== rt.value.kind) return Qe;
                                if (void 0 === Qe.value.value || void 0 === rt.value.value) return new bs(this, {
                                    kind: "constant",
                                    value: void 0
                                }, Qe.parameters);
                                const Co = Ld[this.specification.type];
                                if (Co) {
                                    const Dl = Co(Qe.value.value, rt.value.value, Wn);
                                    return new bs(this, {
                                        kind: "constant",
                                        value: Dl
                                    }, Qe.parameters);
                                }
                                return Qe;
                            }
                            evaluate(Qe, rt, Wn, Co, Dl, Ll) {
                                return "constant" === Qe.kind ? Qe.value : Qe.evaluate(rt, Wn, Co, Dl, Ll);
                            }
                        }
                        class As extends Ss {
                            possiblyEvaluate(Qe, rt, Wn, Co) {
                                if (void 0 === Qe.value) return new bs(this, {
                                    kind: "constant",
                                    value: void 0
                                }, rt);
                                if ("constant" === Qe.expression.kind) {
                                    const Dl = Qe.expression.evaluate(rt, null, {}, Wn, Co), Ll = "resolvedImage" === Qe.property.specification.type && "string" != typeof Dl ? Dl.name : Dl, Rl = this._calculate(Ll, Ll, Ll, rt);
                                    return new bs(this, {
                                        kind: "constant",
                                        value: Rl
                                    }, rt);
                                }
                                if ("camera" === Qe.expression.kind) {
                                    const Wn = this._calculate(Qe.expression.evaluate({
                                        zoom: rt.zoom - 1
                                    }), Qe.expression.evaluate({
                                        zoom: rt.zoom
                                    }), Qe.expression.evaluate({
                                        zoom: rt.zoom + 1
                                    }), rt);
                                    return new bs(this, {
                                        kind: "constant",
                                        value: Wn
                                    }, rt);
                                }
                                return new bs(this, Qe.expression, rt);
                            }
                            evaluate(Qe, rt, Wn, Co, Dl, Ll) {
                                if ("source" === Qe.kind) {
                                    const Rl = Qe.evaluate(rt, Wn, Co, Dl, Ll);
                                    return this._calculate(Rl, Rl, Rl, rt);
                                }
                                return "composite" === Qe.kind ? this._calculate(Qe.evaluate({
                                    zoom: Math.floor(rt.zoom) - 1
                                }, Wn, Co), Qe.evaluate({
                                    zoom: Math.floor(rt.zoom)
                                }, Wn, Co), Qe.evaluate({
                                    zoom: Math.floor(rt.zoom) + 1
                                }, Wn, Co), rt) : Qe.value;
                            }
                            _calculate(Qe, rt, Wn, Co) {
                                return Co.zoom > Co.zoomHistory.lastIntegerZoom ? {
                                    from: Qe,
                                    to: rt
                                } : {
                                    from: Wn,
                                    to: rt
                                };
                            }
                            interpolate(Qe) {
                                return Qe;
                            }
                        }
                        class ks {
                            constructor(Qe){
                                this.specification = Qe;
                            }
                            possiblyEvaluate(Qe, rt, Wn, Co) {
                                if (void 0 !== Qe.value) {
                                    if ("constant" === Qe.expression.kind) {
                                        const Dl = Qe.expression.evaluate(rt, null, {}, Wn, Co);
                                        return this._calculate(Dl, Dl, Dl, rt);
                                    }
                                    return this._calculate(Qe.expression.evaluate(new fs(Math.floor(rt.zoom - 1), rt)), Qe.expression.evaluate(new fs(Math.floor(rt.zoom), rt)), Qe.expression.evaluate(new fs(Math.floor(rt.zoom + 1), rt)), rt);
                                }
                            }
                            _calculate(Qe, rt, Wn, Co) {
                                return Co.zoom > Co.zoomHistory.lastIntegerZoom ? {
                                    from: Qe,
                                    to: rt
                                } : {
                                    from: Wn,
                                    to: rt
                                };
                            }
                            interpolate(Qe) {
                                return Qe;
                            }
                        }
                        class Ms {
                            constructor(Qe){
                                this.specification = Qe;
                            }
                            possiblyEvaluate(Qe, rt, Wn, Co) {
                                return !!Qe.expression.evaluate(rt, null, {}, Wn, Co);
                            }
                            interpolate() {
                                return !1;
                            }
                        }
                        class Is {
                            constructor(Qe){
                                this.properties = Qe, this.defaultPropertyValues = {}, this.defaultTransitionablePropertyValues = {}, this.defaultTransitioningPropertyValues = {}, this.defaultPossiblyEvaluatedValues = {}, this.overridableProperties = [];
                                for(const rt in Qe){
                                    const Wn = Qe[rt];
                                    Wn.specification.overridable && this.overridableProperties.push(rt);
                                    const Co = this.defaultPropertyValues[rt] = new ds(Wn, void 0), Dl = this.defaultTransitionablePropertyValues[rt] = new ys(Wn);
                                    this.defaultTransitioningPropertyValues[rt] = Dl.untransitioned(), this.defaultPossiblyEvaluatedValues[rt] = Co.possiblyEvaluate({});
                                }
                            }
                        }
                        Zi("DataDrivenProperty", Ss), Zi("DataConstantProperty", _s), Zi("CrossFadedDataDrivenProperty", As), Zi("CrossFadedProperty", ks), Zi("ColorRampProperty", Ms);
                        const xp = "-transition";
                        class Ps extends ft {
                            constructor(Qe, rt){
                                if (super(), this.id = Qe.id, this.type = Qe.type, this._featureFilter = {
                                    filter: ()=>!0,
                                    needGeometry: !1
                                }, "custom" !== Qe.type && (this.metadata = Qe.metadata, this.minzoom = Qe.minzoom, this.maxzoom = Qe.maxzoom, "background" !== Qe.type && (this.source = Qe.source, this.sourceLayer = Qe["source-layer"], this.filter = Qe.filter), rt.layout && (this._unevaluatedLayout = new vs(rt.layout)), rt.paint)) {
                                    this._transitionablePaint = new ms(rt.paint);
                                    for(const rt in Qe.paint)this.setPaintProperty(rt, Qe.paint[rt], {
                                        validate: !1
                                    });
                                    for(const rt in Qe.layout)this.setLayoutProperty(rt, Qe.layout[rt], {
                                        validate: !1
                                    });
                                    this._transitioningPaint = this._transitionablePaint.untransitioned(), this.paint = new ws(rt.paint);
                                }
                            }
                            getCrossfadeParameters() {
                                return this._crossfadeParameters;
                            }
                            getLayoutProperty(Qe) {
                                return "visibility" === Qe ? this.visibility : this._unevaluatedLayout.getValue(Qe);
                            }
                            setLayoutProperty(Qe, rt, Wn = {}) {
                                null != rt && this._validate(Jd, `layers.${this.id}.layout.${Qe}`, Qe, rt, Wn) || ("visibility" !== Qe ? this._unevaluatedLayout.setValue(Qe, rt) : this.visibility = rt);
                            }
                            getPaintProperty(Qe) {
                                return Qe.endsWith(xp) ? this._transitionablePaint.getTransition(Qe.slice(0, -11)) : this._transitionablePaint.getValue(Qe);
                            }
                            setPaintProperty(Qe, rt, Wn = {}) {
                                if (null != rt && this._validate(Xd, `layers.${this.id}.paint.${Qe}`, Qe, rt, Wn)) return !1;
                                if (Qe.endsWith(xp)) return this._transitionablePaint.setTransition(Qe.slice(0, -11), rt || void 0), !1;
                                {
                                    const Wn = this._transitionablePaint._values[Qe], Co = "cross-faded-data-driven" === Wn.property.specification["property-type"], Dl = Wn.value.isDataDriven(), Ll = Wn.value;
                                    this._transitionablePaint.setValue(Qe, rt), this._handleSpecialPaintPropertyUpdate(Qe);
                                    const Rl = this._transitionablePaint._values[Qe].value;
                                    return Rl.isDataDriven() || Dl || Co || this._handleOverridablePaintPropertyUpdate(Qe, Ll, Rl);
                                }
                            }
                            _handleSpecialPaintPropertyUpdate(Qe) {}
                            _handleOverridablePaintPropertyUpdate(Qe, rt, Wn) {
                                return !1;
                            }
                            isHidden(Qe) {
                                return !!(this.minzoom && Qe < this.minzoom) || !!(this.maxzoom && Qe >= this.maxzoom) || "none" === this.visibility;
                            }
                            updateTransitions(Qe) {
                                this._transitioningPaint = this._transitionablePaint.transitioned(Qe, this._transitioningPaint);
                            }
                            hasTransition() {
                                return this._transitioningPaint.hasTransition();
                            }
                            recalculate(Qe, rt) {
                                Qe.getCrossfadeParameters && (this._crossfadeParameters = Qe.getCrossfadeParameters()), this._unevaluatedLayout && (this.layout = this._unevaluatedLayout.possiblyEvaluate(Qe, void 0, rt)), this.paint = this._transitioningPaint.possiblyEvaluate(Qe, void 0, rt);
                            }
                            serialize() {
                                const Qe = {
                                    id: this.id,
                                    type: this.type,
                                    source: this.source,
                                    "source-layer": this.sourceLayer,
                                    metadata: this.metadata,
                                    minzoom: this.minzoom,
                                    maxzoom: this.maxzoom,
                                    filter: this.filter,
                                    layout: this._unevaluatedLayout && this._unevaluatedLayout.serialize(),
                                    paint: this._transitionablePaint && this._transitionablePaint.serialize()
                                };
                                return this.visibility && (Qe.layout = Qe.layout || {}, Qe.layout.visibility = this.visibility), O(Qe, (Qe, rt)=>!(void 0 === Qe || "layout" === rt && !Object.keys(Qe).length || "paint" === rt && !Object.keys(Qe).length));
                            }
                            _validate(Qe, rt, Wn, Co, Dl = {}) {
                                return (!Dl || !1 !== Dl.validate) && Ui(this, Qe.call(Yd, {
                                    key: rt,
                                    layerType: this.type,
                                    objectKey: Wn,
                                    value: Co,
                                    styleSpec: Ju,
                                    style: {
                                        glyphs: !0,
                                        sprite: !0
                                    }
                                }));
                            }
                            is3D() {
                                return !1;
                            }
                            isTileClipped() {
                                return !1;
                            }
                            hasOffscreenPass() {
                                return !1;
                            }
                            resize() {}
                            isStateDependent() {
                                for(const Qe in this.paint._values){
                                    const rt = this.paint.get(Qe);
                                    if (rt instanceof bs && Bn(rt.property.specification) && ("source" === rt.value.kind || "composite" === rt.value.kind) && rt.value.isStateDependent) return !0;
                                }
                                return !1;
                            }
                        }
                        const bp = {
                            Int8: Int8Array,
                            Uint8: Uint8Array,
                            Int16: Int16Array,
                            Uint16: Uint16Array,
                            Int32: Int32Array,
                            Uint32: Uint32Array,
                            Float32: Float32Array
                        };
                        class Bs {
                            constructor(Qe, rt){
                                this._structArray = Qe, this._pos1 = rt * this.size, this._pos2 = this._pos1 / 2, this._pos4 = this._pos1 / 4, this._pos8 = this._pos1 / 8;
                            }
                        }
                        class Vs {
                            constructor(){
                                this.isTransferred = !1, this.capacity = -1, this.resize(0);
                            }
                            static serialize(Qe, rt) {
                                return Qe._trim(), rt && (Qe.isTransferred = !0, rt.push(Qe.arrayBuffer)), {
                                    length: Qe.length,
                                    arrayBuffer: Qe.arrayBuffer
                                };
                            }
                            static deserialize(Qe) {
                                const rt = Object.create(this.prototype);
                                return rt.arrayBuffer = Qe.arrayBuffer, rt.length = Qe.length, rt.capacity = Qe.arrayBuffer.byteLength / rt.bytesPerElement, rt._refreshViews(), rt;
                            }
                            _trim() {
                                this.length !== this.capacity && (this.capacity = this.length, this.arrayBuffer = this.arrayBuffer.slice(0, this.length * this.bytesPerElement), this._refreshViews());
                            }
                            clear() {
                                this.length = 0;
                            }
                            resize(Qe) {
                                this.reserve(Qe), this.length = Qe;
                            }
                            reserve(Qe) {
                                if (Qe > this.capacity) {
                                    this.capacity = Math.max(Qe, Math.floor(5 * this.capacity), 128), this.arrayBuffer = new ArrayBuffer(this.capacity * this.bytesPerElement);
                                    const rt = this.uint8;
                                    this._refreshViews(), rt && this.uint8.set(rt);
                                }
                            }
                            _refreshViews() {
                                throw new Error("_refreshViews() must be implemented by each concrete StructArray layout");
                            }
                        }
                        function Es(Qe, rt = 1) {
                            let Wn = 0, Co = 0;
                            return {
                                members: Qe.map((Qe)=>{
                                    const Dl = bp[Qe.type].BYTES_PER_ELEMENT, Ll = Wn = Ts(Wn, Math.max(rt, Dl)), Rl = Qe.components || 1;
                                    return Co = Math.max(Co, Dl), Wn += Dl * Rl, {
                                        name: Qe.name,
                                        type: Qe.type,
                                        components: Rl,
                                        offset: Ll
                                    };
                                }),
                                size: Ts(Wn, Math.max(Co, rt)),
                                alignment: rt
                            };
                        }
                        function Ts(Qe, rt) {
                            return Math.ceil(Qe / rt) * rt;
                        }
                        class Fs extends Vs {
                            _refreshViews() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
                            }
                            emplaceBack(Qe, rt) {
                                const Wn = this.length;
                                return this.resize(Wn + 1), this.emplace(Wn, Qe, rt);
                            }
                            emplace(Qe, rt, Wn) {
                                const Co = 2 * Qe;
                                return this.int16[Co + 0] = rt, this.int16[Co + 1] = Wn, Qe;
                            }
                        }
                        Fs.prototype.bytesPerElement = 4, Zi("StructArrayLayout2i4", Fs);
                        class $s extends Vs {
                            _refreshViews() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
                            }
                            emplaceBack(Qe, rt, Wn) {
                                const Co = this.length;
                                return this.resize(Co + 1), this.emplace(Co, Qe, rt, Wn);
                            }
                            emplace(Qe, rt, Wn, Co) {
                                const Dl = 3 * Qe;
                                return this.int16[Dl + 0] = rt, this.int16[Dl + 1] = Wn, this.int16[Dl + 2] = Co, Qe;
                            }
                        }
                        $s.prototype.bytesPerElement = 6, Zi("StructArrayLayout3i6", $s);
                        class Ls extends Vs {
                            _refreshViews() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
                            }
                            emplaceBack(Qe, rt, Wn, Co) {
                                const Dl = this.length;
                                return this.resize(Dl + 1), this.emplace(Dl, Qe, rt, Wn, Co);
                            }
                            emplace(Qe, rt, Wn, Co, Dl) {
                                const Ll = 4 * Qe;
                                return this.int16[Ll + 0] = rt, this.int16[Ll + 1] = Wn, this.int16[Ll + 2] = Co, this.int16[Ll + 3] = Dl, Qe;
                            }
                        }
                        Ls.prototype.bytesPerElement = 8, Zi("StructArrayLayout4i8", Ls);
                        class Os extends Vs {
                            _refreshViews() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
                            }
                            emplaceBack(Qe, rt, Wn, Co, Dl, Ll) {
                                const Rl = this.length;
                                return this.resize(Rl + 1), this.emplace(Rl, Qe, rt, Wn, Co, Dl, Ll);
                            }
                            emplace(Qe, rt, Wn, Co, Dl, Ll, Rl) {
                                const Ul = 6 * Qe;
                                return this.int16[Ul + 0] = rt, this.int16[Ul + 1] = Wn, this.int16[Ul + 2] = Co, this.int16[Ul + 3] = Dl, this.int16[Ul + 4] = Ll, this.int16[Ul + 5] = Rl, Qe;
                            }
                        }
                        Os.prototype.bytesPerElement = 12, Zi("StructArrayLayout2i4i12", Os);
                        class Ds extends Vs {
                            _refreshViews() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
                            }
                            emplaceBack(Qe, rt, Wn, Co, Dl, Ll) {
                                const Rl = this.length;
                                return this.resize(Rl + 1), this.emplace(Rl, Qe, rt, Wn, Co, Dl, Ll);
                            }
                            emplace(Qe, rt, Wn, Co, Dl, Ll, Rl) {
                                const Ul = 4 * Qe, Gl = 8 * Qe;
                                return this.int16[Ul + 0] = rt, this.int16[Ul + 1] = Wn, this.uint8[Gl + 4] = Co, this.uint8[Gl + 5] = Dl, this.uint8[Gl + 6] = Ll, this.uint8[Gl + 7] = Rl, Qe;
                            }
                        }
                        Ds.prototype.bytesPerElement = 8, Zi("StructArrayLayout2i4ub8", Ds);
                        class Rs extends Vs {
                            _refreshViews() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
                            }
                            emplaceBack(Qe, rt) {
                                const Wn = this.length;
                                return this.resize(Wn + 1), this.emplace(Wn, Qe, rt);
                            }
                            emplace(Qe, rt, Wn) {
                                const Co = 2 * Qe;
                                return this.float32[Co + 0] = rt, this.float32[Co + 1] = Wn, Qe;
                            }
                        }
                        Rs.prototype.bytesPerElement = 8, Zi("StructArrayLayout2f8", Rs);
                        class js extends Vs {
                            _refreshViews() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
                            }
                            emplaceBack(Qe, rt, Wn, Co, Dl, Ll, Rl, Ul, Gl, Zl) {
                                const Hl = this.length;
                                return this.resize(Hl + 1), this.emplace(Hl, Qe, rt, Wn, Co, Dl, Ll, Rl, Ul, Gl, Zl);
                            }
                            emplace(Qe, rt, Wn, Co, Dl, Ll, Rl, Ul, Gl, Zl, Hl) {
                                const ql = 10 * Qe;
                                return this.uint16[ql + 0] = rt, this.uint16[ql + 1] = Wn, this.uint16[ql + 2] = Co, this.uint16[ql + 3] = Dl, this.uint16[ql + 4] = Ll, this.uint16[ql + 5] = Rl, this.uint16[ql + 6] = Ul, this.uint16[ql + 7] = Gl, this.uint16[ql + 8] = Zl, this.uint16[ql + 9] = Hl, Qe;
                            }
                        }
                        js.prototype.bytesPerElement = 20, Zi("StructArrayLayout10ui20", js);
                        class Ns extends Vs {
                            _refreshViews() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
                            }
                            emplaceBack(Qe, rt, Wn, Co, Dl, Ll, Rl, Ul, Gl, Zl, Hl, ql) {
                                const Ql = this.length;
                                return this.resize(Ql + 1), this.emplace(Ql, Qe, rt, Wn, Co, Dl, Ll, Rl, Ul, Gl, Zl, Hl, ql);
                            }
                            emplace(Qe, rt, Wn, Co, Dl, Ll, Rl, Ul, Gl, Zl, Hl, ql, Ql) {
                                const Kl = 12 * Qe;
                                return this.int16[Kl + 0] = rt, this.int16[Kl + 1] = Wn, this.int16[Kl + 2] = Co, this.int16[Kl + 3] = Dl, this.uint16[Kl + 4] = Ll, this.uint16[Kl + 5] = Rl, this.uint16[Kl + 6] = Ul, this.uint16[Kl + 7] = Gl, this.int16[Kl + 8] = Zl, this.int16[Kl + 9] = Hl, this.int16[Kl + 10] = ql, this.int16[Kl + 11] = Ql, Qe;
                            }
                        }
                        Ns.prototype.bytesPerElement = 24, Zi("StructArrayLayout4i4ui4i24", Ns);
                        class Us extends Vs {
                            _refreshViews() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
                            }
                            emplaceBack(Qe, rt, Wn) {
                                const Co = this.length;
                                return this.resize(Co + 1), this.emplace(Co, Qe, rt, Wn);
                            }
                            emplace(Qe, rt, Wn, Co) {
                                const Dl = 3 * Qe;
                                return this.float32[Dl + 0] = rt, this.float32[Dl + 1] = Wn, this.float32[Dl + 2] = Co, Qe;
                            }
                        }
                        Us.prototype.bytesPerElement = 12, Zi("StructArrayLayout3f12", Us);
                        class qs extends Vs {
                            _refreshViews() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer);
                            }
                            emplaceBack(Qe) {
                                const rt = this.length;
                                return this.resize(rt + 1), this.emplace(rt, Qe);
                            }
                            emplace(Qe, rt) {
                                return this.uint32[1 * Qe + 0] = rt, Qe;
                            }
                        }
                        qs.prototype.bytesPerElement = 4, Zi("StructArrayLayout1ul4", qs);
                        class Gs extends Vs {
                            _refreshViews() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
                            }
                            emplaceBack(Qe, rt, Wn, Co, Dl, Ll, Rl, Ul, Gl) {
                                const Zl = this.length;
                                return this.resize(Zl + 1), this.emplace(Zl, Qe, rt, Wn, Co, Dl, Ll, Rl, Ul, Gl);
                            }
                            emplace(Qe, rt, Wn, Co, Dl, Ll, Rl, Ul, Gl, Zl) {
                                const Hl = 10 * Qe, ql = 5 * Qe;
                                return this.int16[Hl + 0] = rt, this.int16[Hl + 1] = Wn, this.int16[Hl + 2] = Co, this.int16[Hl + 3] = Dl, this.int16[Hl + 4] = Ll, this.int16[Hl + 5] = Rl, this.uint32[ql + 3] = Ul, this.uint16[Hl + 8] = Gl, this.uint16[Hl + 9] = Zl, Qe;
                            }
                        }
                        Gs.prototype.bytesPerElement = 20, Zi("StructArrayLayout6i1ul2ui20", Gs);
                        class Zs extends Vs {
                            _refreshViews() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
                            }
                            emplaceBack(Qe, rt, Wn, Co, Dl, Ll) {
                                const Rl = this.length;
                                return this.resize(Rl + 1), this.emplace(Rl, Qe, rt, Wn, Co, Dl, Ll);
                            }
                            emplace(Qe, rt, Wn, Co, Dl, Ll, Rl) {
                                const Ul = 6 * Qe;
                                return this.int16[Ul + 0] = rt, this.int16[Ul + 1] = Wn, this.int16[Ul + 2] = Co, this.int16[Ul + 3] = Dl, this.int16[Ul + 4] = Ll, this.int16[Ul + 5] = Rl, Qe;
                            }
                        }
                        Zs.prototype.bytesPerElement = 12, Zi("StructArrayLayout2i2i2i12", Zs);
                        class Ks extends Vs {
                            _refreshViews() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
                            }
                            emplaceBack(Qe, rt, Wn, Co, Dl) {
                                const Ll = this.length;
                                return this.resize(Ll + 1), this.emplace(Ll, Qe, rt, Wn, Co, Dl);
                            }
                            emplace(Qe, rt, Wn, Co, Dl, Ll) {
                                const Rl = 4 * Qe, Ul = 8 * Qe;
                                return this.float32[Rl + 0] = rt, this.float32[Rl + 1] = Wn, this.float32[Rl + 2] = Co, this.int16[Ul + 6] = Dl, this.int16[Ul + 7] = Ll, Qe;
                            }
                        }
                        Ks.prototype.bytesPerElement = 16, Zi("StructArrayLayout2f1f2i16", Ks);
                        class Xs extends Vs {
                            _refreshViews() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
                            }
                            emplaceBack(Qe, rt, Wn, Co, Dl, Ll) {
                                const Rl = this.length;
                                return this.resize(Rl + 1), this.emplace(Rl, Qe, rt, Wn, Co, Dl, Ll);
                            }
                            emplace(Qe, rt, Wn, Co, Dl, Ll, Rl) {
                                const Ul = 16 * Qe, Gl = 4 * Qe, Zl = 8 * Qe;
                                return this.uint8[Ul + 0] = rt, this.uint8[Ul + 1] = Wn, this.float32[Gl + 1] = Co, this.float32[Gl + 2] = Dl, this.int16[Zl + 6] = Ll, this.int16[Zl + 7] = Rl, Qe;
                            }
                        }
                        Xs.prototype.bytesPerElement = 16, Zi("StructArrayLayout2ub2f2i16", Xs);
                        class Hs extends Vs {
                            _refreshViews() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
                            }
                            emplaceBack(Qe, rt, Wn) {
                                const Co = this.length;
                                return this.resize(Co + 1), this.emplace(Co, Qe, rt, Wn);
                            }
                            emplace(Qe, rt, Wn, Co) {
                                const Dl = 3 * Qe;
                                return this.uint16[Dl + 0] = rt, this.uint16[Dl + 1] = Wn, this.uint16[Dl + 2] = Co, Qe;
                            }
                        }
                        Hs.prototype.bytesPerElement = 6, Zi("StructArrayLayout3ui6", Hs);
                        class Ys extends Vs {
                            _refreshViews() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
                            }
                            emplaceBack(Qe, rt, Wn, Co, Dl, Ll, Rl, Ul, Gl, Zl, Hl, ql, Ql, Kl, $l, Tc, tu) {
                                const lu = this.length;
                                return this.resize(lu + 1), this.emplace(lu, Qe, rt, Wn, Co, Dl, Ll, Rl, Ul, Gl, Zl, Hl, ql, Ql, Kl, $l, Tc, tu);
                            }
                            emplace(Qe, rt, Wn, Co, Dl, Ll, Rl, Ul, Gl, Zl, Hl, ql, Ql, Kl, $l, Tc, tu, lu) {
                                const du = 24 * Qe, fu = 12 * Qe, yu = 48 * Qe;
                                return this.int16[du + 0] = rt, this.int16[du + 1] = Wn, this.uint16[du + 2] = Co, this.uint16[du + 3] = Dl, this.uint32[fu + 2] = Ll, this.uint32[fu + 3] = Rl, this.uint32[fu + 4] = Ul, this.uint16[du + 10] = Gl, this.uint16[du + 11] = Zl, this.uint16[du + 12] = Hl, this.float32[fu + 7] = ql, this.float32[fu + 8] = Ql, this.uint8[yu + 36] = Kl, this.uint8[yu + 37] = $l, this.uint8[yu + 38] = Tc, this.uint32[fu + 10] = tu, this.int16[du + 22] = lu, Qe;
                            }
                        }
                        Ys.prototype.bytesPerElement = 48, Zi("StructArrayLayout2i2ui3ul3ui2f3ub1ul1i48", Ys);
                        class Js extends Vs {
                            _refreshViews() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
                            }
                            emplaceBack(Qe, rt, Wn, Co, Dl, Ll, Rl, Ul, Gl, Zl, Hl, ql, Ql, Kl, $l, Tc, tu, lu, du, fu, yu, Eu, Tu, Lu, Zu, Xu, Ju, $u) {
                                const ed = this.length;
                                return this.resize(ed + 1), this.emplace(ed, Qe, rt, Wn, Co, Dl, Ll, Rl, Ul, Gl, Zl, Hl, ql, Ql, Kl, $l, Tc, tu, lu, du, fu, yu, Eu, Tu, Lu, Zu, Xu, Ju, $u);
                            }
                            emplace(Qe, rt, Wn, Co, Dl, Ll, Rl, Ul, Gl, Zl, Hl, ql, Ql, Kl, $l, Tc, tu, lu, du, fu, yu, Eu, Tu, Lu, Zu, Xu, Ju, $u, ed) {
                                const td = 32 * Qe, id = 16 * Qe;
                                return this.int16[td + 0] = rt, this.int16[td + 1] = Wn, this.int16[td + 2] = Co, this.int16[td + 3] = Dl, this.int16[td + 4] = Ll, this.int16[td + 5] = Rl, this.int16[td + 6] = Ul, this.int16[td + 7] = Gl, this.uint16[td + 8] = Zl, this.uint16[td + 9] = Hl, this.uint16[td + 10] = ql, this.uint16[td + 11] = Ql, this.uint16[td + 12] = Kl, this.uint16[td + 13] = $l, this.uint16[td + 14] = Tc, this.uint16[td + 15] = tu, this.uint16[td + 16] = lu, this.uint16[td + 17] = du, this.uint16[td + 18] = fu, this.uint16[td + 19] = yu, this.uint16[td + 20] = Eu, this.uint16[td + 21] = Tu, this.uint16[td + 22] = Lu, this.uint32[id + 12] = Zu, this.float32[id + 13] = Xu, this.float32[id + 14] = Ju, this.uint16[td + 30] = $u, this.uint16[td + 31] = ed, Qe;
                            }
                        }
                        Js.prototype.bytesPerElement = 64, Zi("StructArrayLayout8i15ui1ul2f2ui64", Js);
                        class Ws extends Vs {
                            _refreshViews() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
                            }
                            emplaceBack(Qe) {
                                const rt = this.length;
                                return this.resize(rt + 1), this.emplace(rt, Qe);
                            }
                            emplace(Qe, rt) {
                                return this.float32[1 * Qe + 0] = rt, Qe;
                            }
                        }
                        Ws.prototype.bytesPerElement = 4, Zi("StructArrayLayout1f4", Ws);
                        class Qs extends Vs {
                            _refreshViews() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
                            }
                            emplaceBack(Qe, rt, Wn) {
                                const Co = this.length;
                                return this.resize(Co + 1), this.emplace(Co, Qe, rt, Wn);
                            }
                            emplace(Qe, rt, Wn, Co) {
                                const Dl = 3 * Qe;
                                return this.uint16[6 * Qe + 0] = rt, this.float32[Dl + 1] = Wn, this.float32[Dl + 2] = Co, Qe;
                            }
                        }
                        Qs.prototype.bytesPerElement = 12, Zi("StructArrayLayout1ui2f12", Qs);
                        class ta extends Vs {
                            _refreshViews() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
                            }
                            emplaceBack(Qe, rt, Wn) {
                                const Co = this.length;
                                return this.resize(Co + 1), this.emplace(Co, Qe, rt, Wn);
                            }
                            emplace(Qe, rt, Wn, Co) {
                                const Dl = 4 * Qe;
                                return this.uint32[2 * Qe + 0] = rt, this.uint16[Dl + 2] = Wn, this.uint16[Dl + 3] = Co, Qe;
                            }
                        }
                        ta.prototype.bytesPerElement = 8, Zi("StructArrayLayout1ul2ui8", ta);
                        class ea extends Vs {
                            _refreshViews() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
                            }
                            emplaceBack(Qe, rt) {
                                const Wn = this.length;
                                return this.resize(Wn + 1), this.emplace(Wn, Qe, rt);
                            }
                            emplace(Qe, rt, Wn) {
                                const Co = 2 * Qe;
                                return this.uint16[Co + 0] = rt, this.uint16[Co + 1] = Wn, Qe;
                            }
                        }
                        ea.prototype.bytesPerElement = 4, Zi("StructArrayLayout2ui4", ea);
                        class ra extends Vs {
                            _refreshViews() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
                            }
                            emplaceBack(Qe) {
                                const rt = this.length;
                                return this.resize(rt + 1), this.emplace(rt, Qe);
                            }
                            emplace(Qe, rt) {
                                return this.uint16[1 * Qe + 0] = rt, Qe;
                            }
                        }
                        ra.prototype.bytesPerElement = 2, Zi("StructArrayLayout1ui2", ra);
                        class na extends Vs {
                            _refreshViews() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
                            }
                            emplaceBack(Qe, rt, Wn, Co) {
                                const Dl = this.length;
                                return this.resize(Dl + 1), this.emplace(Dl, Qe, rt, Wn, Co);
                            }
                            emplace(Qe, rt, Wn, Co, Dl) {
                                const Ll = 4 * Qe;
                                return this.float32[Ll + 0] = rt, this.float32[Ll + 1] = Wn, this.float32[Ll + 2] = Co, this.float32[Ll + 3] = Dl, Qe;
                            }
                        }
                        na.prototype.bytesPerElement = 16, Zi("StructArrayLayout4f16", na);
                        class ia extends Bs {
                            get anchorPointX() {
                                return this._structArray.int16[this._pos2 + 0];
                            }
                            get anchorPointY() {
                                return this._structArray.int16[this._pos2 + 1];
                            }
                            get x1() {
                                return this._structArray.int16[this._pos2 + 2];
                            }
                            get y1() {
                                return this._structArray.int16[this._pos2 + 3];
                            }
                            get x2() {
                                return this._structArray.int16[this._pos2 + 4];
                            }
                            get y2() {
                                return this._structArray.int16[this._pos2 + 5];
                            }
                            get featureIndex() {
                                return this._structArray.uint32[this._pos4 + 3];
                            }
                            get sourceLayerIndex() {
                                return this._structArray.uint16[this._pos2 + 8];
                            }
                            get bucketIndex() {
                                return this._structArray.uint16[this._pos2 + 9];
                            }
                            get anchorPoint() {
                                return new Ll(this.anchorPointX, this.anchorPointY);
                            }
                        }
                        ia.prototype.size = 20;
                        class sa extends Gs {
                            get(Qe) {
                                return new ia(this, Qe);
                            }
                        }
                        Zi("CollisionBoxArray", sa);
                        class aa extends Bs {
                            get anchorX() {
                                return this._structArray.int16[this._pos2 + 0];
                            }
                            get anchorY() {
                                return this._structArray.int16[this._pos2 + 1];
                            }
                            get glyphStartIndex() {
                                return this._structArray.uint16[this._pos2 + 2];
                            }
                            get numGlyphs() {
                                return this._structArray.uint16[this._pos2 + 3];
                            }
                            get vertexStartIndex() {
                                return this._structArray.uint32[this._pos4 + 2];
                            }
                            get lineStartIndex() {
                                return this._structArray.uint32[this._pos4 + 3];
                            }
                            get lineLength() {
                                return this._structArray.uint32[this._pos4 + 4];
                            }
                            get segment() {
                                return this._structArray.uint16[this._pos2 + 10];
                            }
                            get lowerSize() {
                                return this._structArray.uint16[this._pos2 + 11];
                            }
                            get upperSize() {
                                return this._structArray.uint16[this._pos2 + 12];
                            }
                            get lineOffsetX() {
                                return this._structArray.float32[this._pos4 + 7];
                            }
                            get lineOffsetY() {
                                return this._structArray.float32[this._pos4 + 8];
                            }
                            get writingMode() {
                                return this._structArray.uint8[this._pos1 + 36];
                            }
                            get placedOrientation() {
                                return this._structArray.uint8[this._pos1 + 37];
                            }
                            set placedOrientation(Qe) {
                                this._structArray.uint8[this._pos1 + 37] = Qe;
                            }
                            get hidden() {
                                return this._structArray.uint8[this._pos1 + 38];
                            }
                            set hidden(Qe) {
                                this._structArray.uint8[this._pos1 + 38] = Qe;
                            }
                            get crossTileID() {
                                return this._structArray.uint32[this._pos4 + 10];
                            }
                            set crossTileID(Qe) {
                                this._structArray.uint32[this._pos4 + 10] = Qe;
                            }
                            get associatedIconIndex() {
                                return this._structArray.int16[this._pos2 + 22];
                            }
                        }
                        aa.prototype.size = 48;
                        class oa extends Ys {
                            get(Qe) {
                                return new aa(this, Qe);
                            }
                        }
                        Zi("PlacedSymbolArray", oa);
                        class la extends Bs {
                            get anchorX() {
                                return this._structArray.int16[this._pos2 + 0];
                            }
                            get anchorY() {
                                return this._structArray.int16[this._pos2 + 1];
                            }
                            get rightJustifiedTextSymbolIndex() {
                                return this._structArray.int16[this._pos2 + 2];
                            }
                            get centerJustifiedTextSymbolIndex() {
                                return this._structArray.int16[this._pos2 + 3];
                            }
                            get leftJustifiedTextSymbolIndex() {
                                return this._structArray.int16[this._pos2 + 4];
                            }
                            get verticalPlacedTextSymbolIndex() {
                                return this._structArray.int16[this._pos2 + 5];
                            }
                            get placedIconSymbolIndex() {
                                return this._structArray.int16[this._pos2 + 6];
                            }
                            get verticalPlacedIconSymbolIndex() {
                                return this._structArray.int16[this._pos2 + 7];
                            }
                            get key() {
                                return this._structArray.uint16[this._pos2 + 8];
                            }
                            get textBoxStartIndex() {
                                return this._structArray.uint16[this._pos2 + 9];
                            }
                            get textBoxEndIndex() {
                                return this._structArray.uint16[this._pos2 + 10];
                            }
                            get verticalTextBoxStartIndex() {
                                return this._structArray.uint16[this._pos2 + 11];
                            }
                            get verticalTextBoxEndIndex() {
                                return this._structArray.uint16[this._pos2 + 12];
                            }
                            get iconBoxStartIndex() {
                                return this._structArray.uint16[this._pos2 + 13];
                            }
                            get iconBoxEndIndex() {
                                return this._structArray.uint16[this._pos2 + 14];
                            }
                            get verticalIconBoxStartIndex() {
                                return this._structArray.uint16[this._pos2 + 15];
                            }
                            get verticalIconBoxEndIndex() {
                                return this._structArray.uint16[this._pos2 + 16];
                            }
                            get featureIndex() {
                                return this._structArray.uint16[this._pos2 + 17];
                            }
                            get numHorizontalGlyphVertices() {
                                return this._structArray.uint16[this._pos2 + 18];
                            }
                            get numVerticalGlyphVertices() {
                                return this._structArray.uint16[this._pos2 + 19];
                            }
                            get numIconVertices() {
                                return this._structArray.uint16[this._pos2 + 20];
                            }
                            get numVerticalIconVertices() {
                                return this._structArray.uint16[this._pos2 + 21];
                            }
                            get useRuntimeCollisionCircles() {
                                return this._structArray.uint16[this._pos2 + 22];
                            }
                            get crossTileID() {
                                return this._structArray.uint32[this._pos4 + 12];
                            }
                            set crossTileID(Qe) {
                                this._structArray.uint32[this._pos4 + 12] = Qe;
                            }
                            get textBoxScale() {
                                return this._structArray.float32[this._pos4 + 13];
                            }
                            get collisionCircleDiameter() {
                                return this._structArray.float32[this._pos4 + 14];
                            }
                            get textAnchorOffsetStartIndex() {
                                return this._structArray.uint16[this._pos2 + 30];
                            }
                            get textAnchorOffsetEndIndex() {
                                return this._structArray.uint16[this._pos2 + 31];
                            }
                        }
                        la.prototype.size = 64;
                        class ua extends Js {
                            get(Qe) {
                                return new la(this, Qe);
                            }
                        }
                        Zi("SymbolInstanceArray", ua);
                        class ca extends Ws {
                            getoffsetX(Qe) {
                                return this.float32[1 * Qe + 0];
                            }
                        }
                        Zi("GlyphOffsetArray", ca);
                        class ha extends $s {
                            getx(Qe) {
                                return this.int16[3 * Qe + 0];
                            }
                            gety(Qe) {
                                return this.int16[3 * Qe + 1];
                            }
                            gettileUnitDistanceFromAnchor(Qe) {
                                return this.int16[3 * Qe + 2];
                            }
                        }
                        Zi("SymbolLineVertexArray", ha);
                        class pa extends Bs {
                            get textAnchor() {
                                return this._structArray.uint16[this._pos2 + 0];
                            }
                            get textOffset0() {
                                return this._structArray.float32[this._pos4 + 1];
                            }
                            get textOffset1() {
                                return this._structArray.float32[this._pos4 + 2];
                            }
                        }
                        pa.prototype.size = 12;
                        class fa extends Qs {
                            get(Qe) {
                                return new pa(this, Qe);
                            }
                        }
                        Zi("TextAnchorOffsetArray", fa);
                        class da extends Bs {
                            get featureIndex() {
                                return this._structArray.uint32[this._pos4 + 0];
                            }
                            get sourceLayerIndex() {
                                return this._structArray.uint16[this._pos2 + 2];
                            }
                            get bucketIndex() {
                                return this._structArray.uint16[this._pos2 + 3];
                            }
                        }
                        da.prototype.size = 8;
                        class ya extends ta {
                            get(Qe) {
                                return new da(this, Qe);
                            }
                        }
                        Zi("FeatureIndexArray", ya);
                        class ma extends Fs {
                        }
                        class ga extends Fs {
                        }
                        class xa extends Fs {
                        }
                        class va extends Os {
                        }
                        class ba extends Ds {
                        }
                        class wa extends Rs {
                        }
                        class _a extends js {
                        }
                        class Sa extends Ns {
                        }
                        class Aa extends Us {
                        }
                        class ka extends qs {
                        }
                        class Ma extends Zs {
                        }
                        class Ia extends Xs {
                        }
                        class za extends Hs {
                        }
                        class Pa extends ea {
                        }
                        const wp = Es([
                            {
                                name: "a_pos",
                                components: 2,
                                type: "Int16"
                            }
                        ], 4), { members: Ep } = wp;
                        class Va {
                            constructor(Qe = []){
                                this._forceNewSegmentOnNextPrepare = !1, this.segments = Qe;
                            }
                            prepareSegment(Qe, rt, Wn, Co) {
                                const Dl = this.segments[this.segments.length - 1];
                                return Qe > Va.MAX_VERTEX_ARRAY_LENGTH && j(`Max vertices per segment is ${Va.MAX_VERTEX_ARRAY_LENGTH}: bucket requested ${Qe}. Consider using the \`fillLargeMeshArrays\` function if you require meshes with more than ${Va.MAX_VERTEX_ARRAY_LENGTH} vertices.`), this._forceNewSegmentOnNextPrepare || !Dl || Dl.vertexLength + Qe > Va.MAX_VERTEX_ARRAY_LENGTH || Dl.sortKey !== Co ? this.createNewSegment(rt, Wn, Co) : Dl;
                            }
                            createNewSegment(Qe, rt, Wn) {
                                const Co = {
                                    vertexOffset: Qe.length,
                                    primitiveOffset: rt.length,
                                    vertexLength: 0,
                                    primitiveLength: 0,
                                    vaos: {}
                                };
                                return void 0 !== Wn && (Co.sortKey = Wn), this._forceNewSegmentOnNextPrepare = !1, this.segments.push(Co), Co;
                            }
                            getOrCreateLatestSegment(Qe, rt, Wn) {
                                return this.prepareSegment(0, Qe, rt, Wn);
                            }
                            forceNewSegmentOnNextPrepare() {
                                this._forceNewSegmentOnNextPrepare = !0;
                            }
                            get() {
                                return this.segments;
                            }
                            destroy() {
                                for (const Qe of this.segments)for(const rt in Qe.vaos)Qe.vaos[rt].destroy();
                            }
                            static simpleSegment(Qe, rt, Wn, Co) {
                                return new Va([
                                    {
                                        vertexOffset: Qe,
                                        primitiveOffset: rt,
                                        vertexLength: Wn,
                                        primitiveLength: Co,
                                        vaos: {},
                                        sortKey: 0
                                    }
                                ]);
                            }
                        }
                        function Ea(Qe, rt) {
                            return 256 * (Qe = E(Math.floor(Qe), 0, 255)) + E(Math.floor(rt), 0, 255);
                        }
                        Va.MAX_VERTEX_ARRAY_LENGTH = Math.pow(2, 16) - 1, Zi("SegmentVector", Va);
                        const Mp = Es([
                            {
                                name: "a_pattern_from",
                                components: 4,
                                type: "Uint16"
                            },
                            {
                                name: "a_pattern_to",
                                components: 4,
                                type: "Uint16"
                            },
                            {
                                name: "a_pixel_ratio_from",
                                components: 1,
                                type: "Uint16"
                            },
                            {
                                name: "a_pixel_ratio_to",
                                components: 1,
                                type: "Uint16"
                            }
                        ]);
                        var Sp, Tp, Cp, kp = {
                            exports: {}
                        }, Ip = {
                            exports: {}
                        }, Dp = {
                            exports: {}
                        }, Lp = function() {
                            if (Cp) return kp.exports;
                            Cp = 1;
                            var Qe = (Sp || (Sp = 1, Ip.exports = function(Qe, rt) {
                                var Wn, Co, Dl, Ll, Rl, Ul, Gl, Zl;
                                for(Co = Qe.length - (Wn = 3 & Qe.length), Dl = rt, Rl = 3432918353, Ul = 461845907, Zl = 0; Zl < Co;)Gl = 255 & Qe.charCodeAt(Zl) | (255 & Qe.charCodeAt(++Zl)) << 8 | (255 & Qe.charCodeAt(++Zl)) << 16 | (255 & Qe.charCodeAt(++Zl)) << 24, ++Zl, Dl = 27492 + (65535 & (Ll = 5 * (65535 & (Dl = (Dl ^= Gl = (65535 & (Gl = (Gl = (65535 & Gl) * Rl + (((Gl >>> 16) * Rl & 65535) << 16) & 4294967295) << 15 | Gl >>> 17)) * Ul + (((Gl >>> 16) * Ul & 65535) << 16) & 4294967295) << 13 | Dl >>> 19)) + ((5 * (Dl >>> 16) & 65535) << 16) & 4294967295)) + ((58964 + (Ll >>> 16) & 65535) << 16);
                                switch(Gl = 0, Wn){
                                    case 3:
                                        Gl ^= (255 & Qe.charCodeAt(Zl + 2)) << 16;
                                    case 2:
                                        Gl ^= (255 & Qe.charCodeAt(Zl + 1)) << 8;
                                    case 1:
                                        Dl ^= Gl = (65535 & (Gl = (Gl = (65535 & (Gl ^= 255 & Qe.charCodeAt(Zl))) * Rl + (((Gl >>> 16) * Rl & 65535) << 16) & 4294967295) << 15 | Gl >>> 17)) * Ul + (((Gl >>> 16) * Ul & 65535) << 16) & 4294967295;
                                }
                                return Dl ^= Qe.length, Dl = 2246822507 * (65535 & (Dl ^= Dl >>> 16)) + ((2246822507 * (Dl >>> 16) & 65535) << 16) & 4294967295, Dl = 3266489909 * (65535 & (Dl ^= Dl >>> 13)) + ((3266489909 * (Dl >>> 16) & 65535) << 16) & 4294967295, (Dl ^= Dl >>> 16) >>> 0;
                            }), Ip.exports), rt = (Tp || (Tp = 1, Dp.exports = function(Qe, rt) {
                                for(var Wn, Co = Qe.length, Dl = rt ^ Co, Ll = 0; Co >= 4;)Wn = 1540483477 * (65535 & (Wn = 255 & Qe.charCodeAt(Ll) | (255 & Qe.charCodeAt(++Ll)) << 8 | (255 & Qe.charCodeAt(++Ll)) << 16 | (255 & Qe.charCodeAt(++Ll)) << 24)) + ((1540483477 * (Wn >>> 16) & 65535) << 16), Dl = 1540483477 * (65535 & Dl) + ((1540483477 * (Dl >>> 16) & 65535) << 16) ^ (Wn = 1540483477 * (65535 & (Wn ^= Wn >>> 24)) + ((1540483477 * (Wn >>> 16) & 65535) << 16)), Co -= 4, ++Ll;
                                switch(Co){
                                    case 3:
                                        Dl ^= (255 & Qe.charCodeAt(Ll + 2)) << 16;
                                    case 2:
                                        Dl ^= (255 & Qe.charCodeAt(Ll + 1)) << 8;
                                    case 1:
                                        Dl = 1540483477 * (65535 & (Dl ^= 255 & Qe.charCodeAt(Ll))) + ((1540483477 * (Dl >>> 16) & 65535) << 16);
                                }
                                return Dl = 1540483477 * (65535 & (Dl ^= Dl >>> 13)) + ((1540483477 * (Dl >>> 16) & 65535) << 16), (Dl ^= Dl >>> 15) >>> 0;
                            }), Dp.exports);
                            return kp.exports = Qe, kp.exports.murmur3 = Qe, kp.exports.murmur2 = rt, kp.exports;
                        }(), Pp = r(Lp);
                        class Ua {
                            constructor(){
                                this.ids = [], this.positions = [], this.indexed = !1;
                            }
                            add(Qe, rt, Wn, Co) {
                                this.ids.push(qa(Qe)), this.positions.push(rt, Wn, Co);
                            }
                            getPositions(Qe) {
                                if (!this.indexed) throw new Error("Trying to get index, but feature positions are not indexed");
                                const rt = qa(Qe);
                                let Wn = 0, Co = this.ids.length - 1;
                                for(; Wn < Co;){
                                    const Qe = Wn + Co >> 1;
                                    this.ids[Qe] >= rt ? Co = Qe : Wn = Qe + 1;
                                }
                                const Dl = [];
                                for(; this.ids[Wn] === rt;)Dl.push({
                                    index: this.positions[3 * Wn],
                                    start: this.positions[3 * Wn + 1],
                                    end: this.positions[3 * Wn + 2]
                                }), Wn++;
                                return Dl;
                            }
                            static serialize(Qe, rt) {
                                const Wn = new Float64Array(Qe.ids), Co = new Uint32Array(Qe.positions);
                                return Ga(Wn, Co, 0, Wn.length - 1), rt && rt.push(Wn.buffer, Co.buffer), {
                                    ids: Wn,
                                    positions: Co
                                };
                            }
                            static deserialize(Qe) {
                                const rt = new Ua;
                                return rt.ids = Qe.ids, rt.positions = Qe.positions, rt.indexed = !0, rt;
                            }
                        }
                        function qa(Qe) {
                            const rt = +Qe;
                            return !isNaN(rt) && rt <= Number.MAX_SAFE_INTEGER ? rt : Pp(String(Qe));
                        }
                        function Ga(Qe, rt, Wn, Co) {
                            for(; Wn < Co;){
                                const Dl = Qe[Wn + Co >> 1];
                                let Ll = Wn - 1, Rl = Co + 1;
                                for(;;){
                                    do Ll++;
                                    while (Qe[Ll] < Dl);
                                    do Rl--;
                                    while (Qe[Rl] > Dl);
                                    if (Ll >= Rl) break;
                                    Za(Qe, Ll, Rl), Za(rt, 3 * Ll, 3 * Rl), Za(rt, 3 * Ll + 1, 3 * Rl + 1), Za(rt, 3 * Ll + 2, 3 * Rl + 2);
                                }
                                Rl - Wn < Co - Rl ? (Ga(Qe, rt, Wn, Rl), Wn = Rl + 1) : (Ga(Qe, rt, Rl + 1, Co), Co = Rl);
                            }
                        }
                        function Za(Qe, rt, Wn) {
                            const Co = Qe[rt];
                            Qe[rt] = Qe[Wn], Qe[Wn] = Co;
                        }
                        Zi("FeaturePositionMap", Ua);
                        class Ka {
                            constructor(Qe, rt){
                                this.gl = Qe.gl, this.location = rt;
                            }
                        }
                        class Xa extends Ka {
                            constructor(Qe, rt){
                                super(Qe, rt), this.current = 0;
                            }
                            set(Qe) {
                                this.current !== Qe && (this.current = Qe, this.gl.uniform1f(this.location, Qe));
                            }
                        }
                        class Ha extends Ka {
                            constructor(Qe, rt){
                                super(Qe, rt), this.current = [
                                    0,
                                    0,
                                    0,
                                    0
                                ];
                            }
                            set(Qe) {
                                Qe[0] === this.current[0] && Qe[1] === this.current[1] && Qe[2] === this.current[2] && Qe[3] === this.current[3] || (this.current = Qe, this.gl.uniform4f(this.location, Qe[0], Qe[1], Qe[2], Qe[3]));
                            }
                        }
                        class Ya extends Ka {
                            constructor(Qe, rt){
                                super(Qe, rt), this.current = xe.transparent;
                            }
                            set(Qe) {
                                Qe.r === this.current.r && Qe.g === this.current.g && Qe.b === this.current.b && Qe.a === this.current.a || (this.current = Qe, this.gl.uniform4f(this.location, Qe.r, Qe.g, Qe.b, Qe.a));
                            }
                        }
                        const zp = new Float32Array(16);
                        function Wa(Qe) {
                            return [
                                Ea(255 * Qe.r, 255 * Qe.g),
                                Ea(255 * Qe.b, 255 * Qe.a)
                            ];
                        }
                        class Qa {
                            constructor(Qe, rt, Wn){
                                this.value = Qe, this.uniformNames = rt.map((Qe)=>`u_${Qe}`), this.type = Wn;
                            }
                            setUniform(Qe, rt, Wn) {
                                Qe.set(Wn.constantOr(this.value));
                            }
                            getBinding(Qe, rt, Wn) {
                                return "color" === this.type ? new Ya(Qe, rt) : new Xa(Qe, rt);
                            }
                        }
                        class to {
                            constructor(Qe, rt){
                                this.uniformNames = rt.map((Qe)=>`u_${Qe}`), this.patternFrom = null, this.patternTo = null, this.pixelRatioFrom = 1, this.pixelRatioTo = 1;
                            }
                            setConstantPatternPositions(Qe, rt) {
                                this.pixelRatioFrom = rt.pixelRatio, this.pixelRatioTo = Qe.pixelRatio, this.patternFrom = rt.tlbr, this.patternTo = Qe.tlbr;
                            }
                            setUniform(Qe, rt, Wn, Co) {
                                const Dl = "u_pattern_to" === Co ? this.patternTo : "u_pattern_from" === Co ? this.patternFrom : "u_pixel_ratio_to" === Co ? this.pixelRatioTo : "u_pixel_ratio_from" === Co ? this.pixelRatioFrom : null;
                                Dl && Qe.set(Dl);
                            }
                            getBinding(Qe, rt, Wn) {
                                return "u_pattern" === Wn.substr(0, 9) ? new Ha(Qe, rt) : new Xa(Qe, rt);
                            }
                        }
                        class eo {
                            constructor(Qe, rt, Wn, Co){
                                this.expression = Qe, this.type = Wn, this.maxValue = 0, this.paintVertexAttributes = rt.map((Qe)=>({
                                        name: `a_${Qe}`,
                                        type: "Float32",
                                        components: "color" === Wn ? 2 : 1,
                                        offset: 0
                                    })), this.paintVertexArray = new Co;
                            }
                            populatePaintArray(Qe, rt, Wn, Co, Dl) {
                                const Ll = this.paintVertexArray.length, Rl = this.expression.evaluate(new fs(0), rt, {}, Co, [], Dl);
                                this.paintVertexArray.resize(Qe), this._setPaintValue(Ll, Qe, Rl);
                            }
                            updatePaintArray(Qe, rt, Wn, Co) {
                                const Dl = this.expression.evaluate({
                                    zoom: 0
                                }, Wn, Co);
                                this._setPaintValue(Qe, rt, Dl);
                            }
                            _setPaintValue(Qe, rt, Wn) {
                                if ("color" === this.type) {
                                    const Co = Wa(Wn);
                                    for(let Wn = Qe; Wn < rt; Wn++)this.paintVertexArray.emplace(Wn, Co[0], Co[1]);
                                } else {
                                    for(let Co = Qe; Co < rt; Co++)this.paintVertexArray.emplace(Co, Wn);
                                    this.maxValue = Math.max(this.maxValue, Math.abs(Wn));
                                }
                            }
                            upload(Qe) {
                                this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer && this.paintVertexBuffer.buffer ? this.paintVertexBuffer.updateData(this.paintVertexArray) : this.paintVertexBuffer = Qe.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent));
                            }
                            destroy() {
                                this.paintVertexBuffer && this.paintVertexBuffer.destroy();
                            }
                        }
                        class ro {
                            constructor(Qe, rt, Wn, Co, Dl, Ll){
                                this.expression = Qe, this.uniformNames = rt.map((Qe)=>`u_${Qe}_t`), this.type = Wn, this.useIntegerZoom = Co, this.zoom = Dl, this.maxValue = 0, this.paintVertexAttributes = rt.map((Qe)=>({
                                        name: `a_${Qe}`,
                                        type: "Float32",
                                        components: "color" === Wn ? 4 : 2,
                                        offset: 0
                                    })), this.paintVertexArray = new Ll;
                            }
                            populatePaintArray(Qe, rt, Wn, Co, Dl) {
                                const Ll = this.expression.evaluate(new fs(this.zoom), rt, {}, Co, [], Dl), Rl = this.expression.evaluate(new fs(this.zoom + 1), rt, {}, Co, [], Dl), Ul = this.paintVertexArray.length;
                                this.paintVertexArray.resize(Qe), this._setPaintValue(Ul, Qe, Ll, Rl);
                            }
                            updatePaintArray(Qe, rt, Wn, Co) {
                                const Dl = this.expression.evaluate({
                                    zoom: this.zoom
                                }, Wn, Co), Ll = this.expression.evaluate({
                                    zoom: this.zoom + 1
                                }, Wn, Co);
                                this._setPaintValue(Qe, rt, Dl, Ll);
                            }
                            _setPaintValue(Qe, rt, Wn, Co) {
                                if ("color" === this.type) {
                                    const Dl = Wa(Wn), Ll = Wa(Co);
                                    for(let Wn = Qe; Wn < rt; Wn++)this.paintVertexArray.emplace(Wn, Dl[0], Dl[1], Ll[0], Ll[1]);
                                } else {
                                    for(let Dl = Qe; Dl < rt; Dl++)this.paintVertexArray.emplace(Dl, Wn, Co);
                                    this.maxValue = Math.max(this.maxValue, Math.abs(Wn), Math.abs(Co));
                                }
                            }
                            upload(Qe) {
                                this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer && this.paintVertexBuffer.buffer ? this.paintVertexBuffer.updateData(this.paintVertexArray) : this.paintVertexBuffer = Qe.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent));
                            }
                            destroy() {
                                this.paintVertexBuffer && this.paintVertexBuffer.destroy();
                            }
                            setUniform(Qe, rt) {
                                const Wn = this.useIntegerZoom ? Math.floor(rt.zoom) : rt.zoom, Co = E(this.expression.interpolationFactor(Wn, this.zoom, this.zoom + 1), 0, 1);
                                Qe.set(Co);
                            }
                            getBinding(Qe, rt, Wn) {
                                return new Xa(Qe, rt);
                            }
                        }
                        class no {
                            constructor(Qe, rt, Wn, Co, Dl, Ll){
                                this.expression = Qe, this.type = rt, this.useIntegerZoom = Wn, this.zoom = Co, this.layerId = Ll, this.zoomInPaintVertexArray = new Dl, this.zoomOutPaintVertexArray = new Dl;
                            }
                            populatePaintArray(Qe, rt, Wn) {
                                const Co = this.zoomInPaintVertexArray.length;
                                this.zoomInPaintVertexArray.resize(Qe), this.zoomOutPaintVertexArray.resize(Qe), this._setPaintValues(Co, Qe, rt.patterns && rt.patterns[this.layerId], Wn);
                            }
                            updatePaintArray(Qe, rt, Wn, Co, Dl) {
                                this._setPaintValues(Qe, rt, Wn.patterns && Wn.patterns[this.layerId], Dl);
                            }
                            _setPaintValues(Qe, rt, Wn, Co) {
                                if (!Co || !Wn) return;
                                const { min: Dl, mid: Ll, max: Rl } = Wn, Ul = Co[Dl], Gl = Co[Ll], Zl = Co[Rl];
                                if (Ul && Gl && Zl) for(let Hl = Qe; Hl < rt; Hl++)this.zoomInPaintVertexArray.emplace(Hl, Gl.tl[0], Gl.tl[1], Gl.br[0], Gl.br[1], Ul.tl[0], Ul.tl[1], Ul.br[0], Ul.br[1], Gl.pixelRatio, Ul.pixelRatio), this.zoomOutPaintVertexArray.emplace(Hl, Gl.tl[0], Gl.tl[1], Gl.br[0], Gl.br[1], Zl.tl[0], Zl.tl[1], Zl.br[0], Zl.br[1], Gl.pixelRatio, Zl.pixelRatio);
                            }
                            upload(Qe) {
                                this.zoomInPaintVertexArray && this.zoomInPaintVertexArray.arrayBuffer && this.zoomOutPaintVertexArray && this.zoomOutPaintVertexArray.arrayBuffer && (this.zoomInPaintVertexBuffer = Qe.createVertexBuffer(this.zoomInPaintVertexArray, Mp.members, this.expression.isStateDependent), this.zoomOutPaintVertexBuffer = Qe.createVertexBuffer(this.zoomOutPaintVertexArray, Mp.members, this.expression.isStateDependent));
                            }
                            destroy() {
                                this.zoomOutPaintVertexBuffer && this.zoomOutPaintVertexBuffer.destroy(), this.zoomInPaintVertexBuffer && this.zoomInPaintVertexBuffer.destroy();
                            }
                        }
                        class io {
                            constructor(Qe, rt, Wn){
                                this.binders = {}, this._buffers = [];
                                const Co = [];
                                for(const Dl in Qe.paint._values){
                                    if (!Wn(Dl)) continue;
                                    const Ll = Qe.paint.get(Dl);
                                    if (!(Ll instanceof bs && Bn(Ll.property.specification))) continue;
                                    const Rl = ao(Dl, Qe.type), Ul = Ll.value, Gl = Ll.property.specification.type, Zl = Ll.property.useIntegerZoom, Hl = Ll.property.specification["property-type"], ql = "cross-faded" === Hl || "cross-faded-data-driven" === Hl;
                                    if ("constant" === Ul.kind) this.binders[Dl] = ql ? new to(Ul.value, Rl) : new Qa(Ul.value, Rl, Gl), Co.push(`/u_${Dl}`);
                                    else if ("source" === Ul.kind || ql) {
                                        const Wn = oo(Dl, Gl, "source");
                                        this.binders[Dl] = ql ? new no(Ul, Gl, Zl, rt, Wn, Qe.id) : new eo(Ul, Rl, Gl, Wn), Co.push(`/a_${Dl}`);
                                    } else {
                                        const Qe = oo(Dl, Gl, "composite");
                                        this.binders[Dl] = new ro(Ul, Rl, Gl, Zl, rt, Qe), Co.push(`/z_${Dl}`);
                                    }
                                }
                                this.cacheKey = Co.sort().join("");
                            }
                            getMaxValue(Qe) {
                                const rt = this.binders[Qe];
                                return rt instanceof eo || rt instanceof ro ? rt.maxValue : 0;
                            }
                            populatePaintArrays(Qe, rt, Wn, Co, Dl) {
                                for(const Ll in this.binders){
                                    const Rl = this.binders[Ll];
                                    (Rl instanceof eo || Rl instanceof ro || Rl instanceof no) && Rl.populatePaintArray(Qe, rt, Wn, Co, Dl);
                                }
                            }
                            setConstantPatternPositions(Qe, rt) {
                                for(const Wn in this.binders){
                                    const Co = this.binders[Wn];
                                    Co instanceof to && Co.setConstantPatternPositions(Qe, rt);
                                }
                            }
                            updatePaintArrays(Qe, rt, Wn, Co, Dl) {
                                let Ll = !1;
                                for(const Rl in Qe){
                                    const Ul = rt.getPositions(Rl);
                                    for (const rt of Ul){
                                        const Ul = Wn.feature(rt.index);
                                        for(const Wn in this.binders){
                                            const Gl = this.binders[Wn];
                                            if ((Gl instanceof eo || Gl instanceof ro || Gl instanceof no) && !0 === Gl.expression.isStateDependent) {
                                                const Zl = Co.paint.get(Wn);
                                                Gl.expression = Zl.value, Gl.updatePaintArray(rt.start, rt.end, Ul, Qe[Rl], Dl), Ll = !0;
                                            }
                                        }
                                    }
                                }
                                return Ll;
                            }
                            defines() {
                                const Qe = [];
                                for(const rt in this.binders){
                                    const Wn = this.binders[rt];
                                    (Wn instanceof Qa || Wn instanceof to) && Qe.push(...Wn.uniformNames.map((Qe)=>`#define HAS_UNIFORM_${Qe}`));
                                }
                                return Qe;
                            }
                            getBinderAttributes() {
                                const Qe = [];
                                for(const rt in this.binders){
                                    const Wn = this.binders[rt];
                                    if (Wn instanceof eo || Wn instanceof ro) for(let rt = 0; rt < Wn.paintVertexAttributes.length; rt++)Qe.push(Wn.paintVertexAttributes[rt].name);
                                    else if (Wn instanceof no) for(let rt = 0; rt < Mp.members.length; rt++)Qe.push(Mp.members[rt].name);
                                }
                                return Qe;
                            }
                            getBinderUniforms() {
                                const Qe = [];
                                for(const rt in this.binders){
                                    const Wn = this.binders[rt];
                                    if (Wn instanceof Qa || Wn instanceof to || Wn instanceof ro) for (const rt of Wn.uniformNames)Qe.push(rt);
                                }
                                return Qe;
                            }
                            getPaintVertexBuffers() {
                                return this._buffers;
                            }
                            getUniforms(Qe, rt) {
                                const Wn = [];
                                for(const Co in this.binders){
                                    const Dl = this.binders[Co];
                                    if (Dl instanceof Qa || Dl instanceof to || Dl instanceof ro) {
                                        for (const Ll of Dl.uniformNames)if (rt[Ll]) {
                                            const Rl = Dl.getBinding(Qe, rt[Ll], Ll);
                                            Wn.push({
                                                name: Ll,
                                                property: Co,
                                                binding: Rl
                                            });
                                        }
                                    }
                                }
                                return Wn;
                            }
                            setUniforms(Qe, rt, Wn, Co) {
                                for (const { name: Dl, property: Ll, binding: Rl } of rt)this.binders[Ll].setUniform(Rl, Co, Wn.get(Ll), Dl);
                            }
                            updatePaintBuffers(Qe) {
                                this._buffers = [];
                                for(const rt in this.binders){
                                    const Wn = this.binders[rt];
                                    if (Qe && Wn instanceof no) {
                                        const rt = 2 === Qe.fromScale ? Wn.zoomInPaintVertexBuffer : Wn.zoomOutPaintVertexBuffer;
                                        rt && this._buffers.push(rt);
                                    } else (Wn instanceof eo || Wn instanceof ro) && Wn.paintVertexBuffer && this._buffers.push(Wn.paintVertexBuffer);
                                }
                            }
                            upload(Qe) {
                                for(const rt in this.binders){
                                    const Wn = this.binders[rt];
                                    (Wn instanceof eo || Wn instanceof ro || Wn instanceof no) && Wn.upload(Qe);
                                }
                                this.updatePaintBuffers();
                            }
                            destroy() {
                                for(const Qe in this.binders){
                                    const rt = this.binders[Qe];
                                    (rt instanceof eo || rt instanceof ro || rt instanceof no) && rt.destroy();
                                }
                            }
                        }
                        class so {
                            constructor(Qe, rt, Wn = ()=>!0){
                                this.programConfigurations = {};
                                for (const Co of Qe)this.programConfigurations[Co.id] = new io(Co, rt, Wn);
                                this.needsUpload = !1, this._featureMap = new Ua, this._bufferOffset = 0;
                            }
                            populatePaintArrays(Qe, rt, Wn, Co, Dl, Ll) {
                                for(const Rl in this.programConfigurations)this.programConfigurations[Rl].populatePaintArrays(Qe, rt, Co, Dl, Ll);
                                void 0 !== rt.id && this._featureMap.add(rt.id, Wn, this._bufferOffset, Qe), this._bufferOffset = Qe, this.needsUpload = !0;
                            }
                            updatePaintArrays(Qe, rt, Wn, Co) {
                                for (const Dl of Wn)this.needsUpload = this.programConfigurations[Dl.id].updatePaintArrays(Qe, this._featureMap, rt, Dl, Co) || this.needsUpload;
                            }
                            get(Qe) {
                                return this.programConfigurations[Qe];
                            }
                            upload(Qe) {
                                if (this.needsUpload) {
                                    for(const rt in this.programConfigurations)this.programConfigurations[rt].upload(Qe);
                                    this.needsUpload = !1;
                                }
                            }
                            destroy() {
                                for(const Qe in this.programConfigurations)this.programConfigurations[Qe].destroy();
                            }
                        }
                        function ao(Qe, rt) {
                            return ({
                                "text-opacity": [
                                    "opacity"
                                ],
                                "icon-opacity": [
                                    "opacity"
                                ],
                                "text-color": [
                                    "fill_color"
                                ],
                                "icon-color": [
                                    "fill_color"
                                ],
                                "text-halo-color": [
                                    "halo_color"
                                ],
                                "icon-halo-color": [
                                    "halo_color"
                                ],
                                "text-halo-blur": [
                                    "halo_blur"
                                ],
                                "icon-halo-blur": [
                                    "halo_blur"
                                ],
                                "text-halo-width": [
                                    "halo_width"
                                ],
                                "icon-halo-width": [
                                    "halo_width"
                                ],
                                "line-gap-width": [
                                    "gapwidth"
                                ],
                                "line-pattern": [
                                    "pattern_to",
                                    "pattern_from",
                                    "pixel_ratio_to",
                                    "pixel_ratio_from"
                                ],
                                "fill-pattern": [
                                    "pattern_to",
                                    "pattern_from",
                                    "pixel_ratio_to",
                                    "pixel_ratio_from"
                                ],
                                "fill-extrusion-pattern": [
                                    "pattern_to",
                                    "pattern_from",
                                    "pixel_ratio_to",
                                    "pixel_ratio_from"
                                ]
                            })[Qe] || [
                                Qe.replace(`${rt}-`, "").replace(/-/g, "_")
                            ];
                        }
                        function oo(Qe, rt, Wn) {
                            const Co = {
                                color: {
                                    source: Rs,
                                    composite: na
                                },
                                number: {
                                    source: Ws,
                                    composite: Rs
                                }
                            }, Dl = function(Qe) {
                                return ({
                                    "line-pattern": {
                                        source: _a,
                                        composite: _a
                                    },
                                    "fill-pattern": {
                                        source: _a,
                                        composite: _a
                                    },
                                    "fill-extrusion-pattern": {
                                        source: _a,
                                        composite: _a
                                    }
                                })[Qe];
                            }(Qe);
                            return Dl && Dl[Wn] || Co[rt][Wn];
                        }
                        Zi("ConstantBinder", Qa), Zi("CrossFadedConstantBinder", to), Zi("SourceExpressionBinder", eo), Zi("CrossFadedCompositeBinder", no), Zi("CompositeExpressionBinder", ro), Zi("ProgramConfiguration", io, {
                            omit: [
                                "_buffers"
                            ]
                        }), Zi("ProgramConfigurationSet", so);
                        const Np = Math.pow(2, 14) - 1, Rp = -Np - 1;
                        function co(Qe) {
                            const rt = Kl / Qe.extent, Wn = Qe.loadGeometry();
                            for(let Co = 0; Co < Wn.length; Co++){
                                const Qe = Wn[Co];
                                for(let Wn = 0; Wn < Qe.length; Wn++){
                                    const Co = Qe[Wn], Dl = Math.round(Co.x * rt), Ll = Math.round(Co.y * rt);
                                    Co.x = E(Dl, Rp, Np), Co.y = E(Ll, Rp, Np), (Dl < Co.x || Dl > Co.x + 1 || Ll < Co.y || Ll > Co.y + 1) && j("Geometry exceeds allowed extent, reduce your vector tile buffer size");
                                }
                            }
                            return Wn;
                        }
                        function ho(Qe, rt) {
                            return {
                                type: Qe.type,
                                id: Qe.id,
                                properties: Qe.properties,
                                geometry: rt ? co(Qe) : []
                            };
                        }
                        const Bp = -32768;
                        function fo(Qe, rt, Wn, Co, Dl) {
                            Qe.emplaceBack(Bp + 8 * rt + Co, Bp + 8 * Wn + Dl);
                        }
                        class yo {
                            constructor(Qe){
                                this.zoom = Qe.zoom, this.overscaling = Qe.overscaling, this.layers = Qe.layers, this.layerIds = this.layers.map((Qe)=>Qe.id), this.index = Qe.index, this.hasPattern = !1, this.layoutVertexArray = new ga, this.indexArray = new za, this.segments = new Va, this.programConfigurations = new so(Qe.layers, Qe.zoom), this.stateDependentLayerIds = this.layers.filter((Qe)=>Qe.isStateDependent()).map((Qe)=>Qe.id);
                            }
                            populate(Qe, rt, Wn) {
                                const Co = this.layers[0], Dl = [];
                                let Ll = null, Rl = !1, Ul = "heatmap" === Co.type;
                                if ("circle" === Co.type) {
                                    const Qe = Co;
                                    Ll = Qe.layout.get("circle-sort-key"), Rl = !Ll.isConstant(), Ul = Ul || "map" === Qe.paint.get("circle-pitch-alignment");
                                }
                                const Gl = Ul ? rt.subdivisionGranularity.circle : 1;
                                for (const { feature: Zl, id: Hl, index: ql, sourceLayerIndex: Ql } of Qe){
                                    const Qe = this.layers[0]._featureFilter.needGeometry, rt = ho(Zl, Qe);
                                    if (!this.layers[0]._featureFilter.filter(new fs(this.zoom), rt, Wn)) continue;
                                    const Co = Rl ? Ll.evaluate(rt, {}, Wn) : void 0, Ul = {
                                        id: Hl,
                                        properties: Zl.properties,
                                        type: Zl.type,
                                        sourceLayerIndex: Ql,
                                        index: ql,
                                        geometry: Qe ? rt.geometry : co(Zl),
                                        patterns: {},
                                        sortKey: Co
                                    };
                                    Dl.push(Ul);
                                }
                                Rl && Dl.sort((Qe, rt)=>Qe.sortKey - rt.sortKey);
                                for (const Zl of Dl){
                                    const { geometry: Co, index: Dl, sourceLayerIndex: Ll } = Zl, Rl = Qe[Dl].feature;
                                    this.addFeature(Zl, Co, Dl, Wn, Gl), rt.featureIndex.insert(Rl, Co, Dl, Ll, this.index);
                                }
                            }
                            update(Qe, rt, Wn) {
                                this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(Qe, rt, this.stateDependentLayers, Wn);
                            }
                            isEmpty() {
                                return 0 === this.layoutVertexArray.length;
                            }
                            uploadPending() {
                                return !this.uploaded || this.programConfigurations.needsUpload;
                            }
                            upload(Qe) {
                                this.uploaded || (this.layoutVertexBuffer = Qe.createVertexBuffer(this.layoutVertexArray, Ep), this.indexBuffer = Qe.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(Qe), this.uploaded = !0;
                            }
                            destroy() {
                                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
                            }
                            addFeature(Qe, rt, Wn, Co, Dl = 1) {
                                let Ll;
                                switch(Dl){
                                    case 1:
                                        Ll = [
                                            0,
                                            7
                                        ];
                                        break;
                                    case 3:
                                        Ll = [
                                            0,
                                            2,
                                            5,
                                            7
                                        ];
                                        break;
                                    case 5:
                                        Ll = [
                                            0,
                                            1,
                                            3,
                                            4,
                                            6,
                                            7
                                        ];
                                        break;
                                    case 7:
                                        Ll = [
                                            0,
                                            1,
                                            2,
                                            3,
                                            4,
                                            5,
                                            6,
                                            7
                                        ];
                                        break;
                                    default:
                                        throw new Error(`Invalid circle bucket granularity: ${Dl}; valid values are 1, 3, 5, 7.`);
                                }
                                const Rl = Ll.length;
                                for (const Ul of rt)for (const rt of Ul){
                                    const Wn = rt.x, Co = rt.y;
                                    if (Wn < 0 || Wn >= Kl || Co < 0 || Co >= Kl) continue;
                                    const Dl = this.segments.prepareSegment(Rl * Rl, this.layoutVertexArray, this.indexArray, Qe.sortKey), Ul = Dl.vertexLength;
                                    for(let Qe = 0; Qe < Rl; Qe++)for(let rt = 0; rt < Rl; rt++)fo(this.layoutVertexArray, Wn, Co, Ll[rt], Ll[Qe]);
                                    for(let Qe = 0; Qe < Rl - 1; Qe++)for(let rt = 0; rt < Rl - 1; rt++){
                                        const Wn = Ul + Qe * Rl + rt, Co = Ul + (Qe + 1) * Rl + rt;
                                        this.indexArray.emplaceBack(Wn, Co + 1, Wn + 1), this.indexArray.emplaceBack(Wn, Co, Co + 1);
                                    }
                                    Dl.vertexLength += Rl * Rl, Dl.primitiveLength += (Rl - 1) * (Rl - 1) * 2;
                                }
                                this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, Qe, Wn, {}, Co);
                            }
                        }
                        function mo(Qe, rt) {
                            for(let Wn = 0; Wn < Qe.length; Wn++)if (ko(rt, Qe[Wn])) return !0;
                            for(let Wn = 0; Wn < rt.length; Wn++)if (ko(Qe, rt[Wn])) return !0;
                            return !!bo(Qe, rt);
                        }
                        function go(Qe, rt, Wn) {
                            return !!ko(Qe, rt) || !!_o(rt, Qe, Wn);
                        }
                        function xo(Qe, rt) {
                            if (1 === Qe.length) return Ao(rt, Qe[0]);
                            for(let Wn = 0; Wn < rt.length; Wn++){
                                const Co = rt[Wn];
                                for(let rt = 0; rt < Co.length; rt++)if (ko(Qe, Co[rt])) return !0;
                            }
                            for(let Wn = 0; Wn < Qe.length; Wn++)if (Ao(rt, Qe[Wn])) return !0;
                            for(let Wn = 0; Wn < rt.length; Wn++)if (bo(Qe, rt[Wn])) return !0;
                            return !1;
                        }
                        function vo(Qe, rt, Wn) {
                            if (Qe.length > 1) {
                                if (bo(Qe, rt)) return !0;
                                for(let Co = 0; Co < rt.length; Co++)if (_o(rt[Co], Qe, Wn)) return !0;
                            }
                            for(let Co = 0; Co < Qe.length; Co++)if (_o(Qe[Co], rt, Wn)) return !0;
                            return !1;
                        }
                        function bo(Qe, rt) {
                            if (0 === Qe.length || 0 === rt.length) return !1;
                            for(let Wn = 0; Wn < Qe.length - 1; Wn++){
                                const Co = Qe[Wn], Dl = Qe[Wn + 1];
                                for(let Qe = 0; Qe < rt.length - 1; Qe++)if (wo(Co, Dl, rt[Qe], rt[Qe + 1])) return !0;
                            }
                            return !1;
                        }
                        function wo(Qe, rt, Wn, Co) {
                            return N(Qe, Wn, Co) !== N(rt, Wn, Co) && N(Qe, rt, Wn) !== N(Qe, rt, Co);
                        }
                        function _o(Qe, rt, Wn) {
                            const Co = Wn * Wn;
                            if (1 === rt.length) return Qe.distSqr(rt[0]) < Co;
                            for(let Dl = 1; Dl < rt.length; Dl++)if (So(Qe, rt[Dl - 1], rt[Dl]) < Co) return !0;
                            return !1;
                        }
                        function So(Qe, rt, Wn) {
                            const Co = rt.distSqr(Wn);
                            if (0 === Co) return Qe.distSqr(rt);
                            const Dl = ((Qe.x - rt.x) * (Wn.x - rt.x) + (Qe.y - rt.y) * (Wn.y - rt.y)) / Co;
                            return Qe.distSqr(Dl < 0 ? rt : Dl > 1 ? Wn : Wn.sub(rt)._mult(Dl)._add(rt));
                        }
                        function Ao(Qe, rt) {
                            for(let Wn = 0; Wn < Qe.length; Wn++)if (ko(Qe[Wn], rt)) return !0;
                            return !1;
                        }
                        function ko(Qe, rt) {
                            let Wn = !1;
                            for(let Co = 0, Dl = Qe.length - 1; Co < Qe.length; Dl = Co++){
                                const Ll = Qe[Co], Rl = Qe[Dl];
                                Ll.y > rt.y != Rl.y > rt.y && rt.x < (Rl.x - Ll.x) * (rt.y - Ll.y) / (Rl.y - Ll.y) + Ll.x && (Wn = !Wn);
                            }
                            return Wn;
                        }
                        function Mo(Qe, rt, Wn) {
                            const Co = Wn[0], Dl = Wn[2];
                            if (Qe.x < Co.x && rt.x < Co.x || Qe.x > Dl.x && rt.x > Dl.x || Qe.y < Co.y && rt.y < Co.y || Qe.y > Dl.y && rt.y > Dl.y) return !1;
                            const Ll = N(Qe, rt, Wn[0]);
                            return Ll !== N(Qe, rt, Wn[1]) || Ll !== N(Qe, rt, Wn[2]) || Ll !== N(Qe, rt, Wn[3]);
                        }
                        function Io(Qe, rt, Wn) {
                            const Co = rt.paint.get(Qe).value;
                            return "constant" === Co.kind ? Co.value : Wn.programConfigurations.get(rt.id).getMaxValue(Qe);
                        }
                        function zo(Qe) {
                            return Math.sqrt(Qe[0] * Qe[0] + Qe[1] * Qe[1]);
                        }
                        function Po(Qe, rt, Wn, Co, Dl) {
                            if (!rt[0] && !rt[1]) return Qe;
                            const Rl = Ll.convert(rt)._mult(Dl);
                            "viewport" === Wn && Rl._rotate(-Co);
                            const Ul = [];
                            for(let Ll = 0; Ll < Qe.length; Ll++)Ul.push(Qe[Ll].sub(Rl));
                            return Ul;
                        }
                        let Op, Fp;
                        Zi("CircleBucket", yo, {
                            omit: [
                                "layers"
                            ]
                        });
                        var jp = {
                            get paint () {
                                return Fp = Fp || new Is({
                                    "circle-radius": new Ss(Ju.paint_circle["circle-radius"]),
                                    "circle-color": new Ss(Ju.paint_circle["circle-color"]),
                                    "circle-blur": new Ss(Ju.paint_circle["circle-blur"]),
                                    "circle-opacity": new Ss(Ju.paint_circle["circle-opacity"]),
                                    "circle-translate": new _s(Ju.paint_circle["circle-translate"]),
                                    "circle-translate-anchor": new _s(Ju.paint_circle["circle-translate-anchor"]),
                                    "circle-pitch-scale": new _s(Ju.paint_circle["circle-pitch-scale"]),
                                    "circle-pitch-alignment": new _s(Ju.paint_circle["circle-pitch-alignment"]),
                                    "circle-stroke-width": new Ss(Ju.paint_circle["circle-stroke-width"]),
                                    "circle-stroke-color": new Ss(Ju.paint_circle["circle-stroke-color"]),
                                    "circle-stroke-opacity": new Ss(Ju.paint_circle["circle-stroke-opacity"])
                                });
                            },
                            get layout () {
                                return Op = Op || new Is({
                                    "circle-sort-key": new Ss(Ju.layout_circle["circle-sort-key"])
                                });
                            }
                        };
                        class Eo extends Ps {
                            constructor(Qe){
                                super(Qe, jp);
                            }
                            createBucket(Qe) {
                                return new yo(Qe);
                            }
                            queryRadius(Qe) {
                                const rt = Qe;
                                return Io("circle-radius", this, rt) + Io("circle-stroke-width", this, rt) + zo(this.paint.get("circle-translate"));
                            }
                            queryIntersectsFeature({ queryGeometry: Qe, feature: rt, featureState: Wn, geometry: Co, transform: Dl, pixelsToTileUnits: Ll, unwrappedTileID: Rl, getElevation: Ul }) {
                                const Gl = Po(Qe, this.paint.get("circle-translate"), this.paint.get("circle-translate-anchor"), -Dl.bearingInRadians, Ll), Zl = this.paint.get("circle-radius").evaluate(rt, Wn) + this.paint.get("circle-stroke-width").evaluate(rt, Wn), Hl = "map" === this.paint.get("circle-pitch-alignment"), ql = Hl ? Gl : function(Qe, rt, Wn, Co) {
                                    return Qe.map((Qe)=>To(Qe, rt, Wn, Co));
                                }(Gl, Dl, Rl, Ul), Ql = Hl ? Zl * Ll : Zl;
                                for (const Kl of Co)for (const Qe of Kl){
                                    const rt = Hl ? Qe : To(Qe, Dl, Rl, Ul);
                                    let Wn = Ql;
                                    const Co = Dl.projectTileCoordinates(Qe.x, Qe.y, Rl, Ul).signedDistanceFromCamera;
                                    if ("viewport" === this.paint.get("circle-pitch-scale") && "map" === this.paint.get("circle-pitch-alignment") ? Wn *= Co / Dl.cameraToCenterDistance : "map" === this.paint.get("circle-pitch-scale") && "viewport" === this.paint.get("circle-pitch-alignment") && (Wn *= Dl.cameraToCenterDistance / Co), go(ql, rt, Wn)) return !0;
                                }
                                return !1;
                            }
                        }
                        function To(Qe, rt, Wn, Co) {
                            const Dl = rt.projectTileCoordinates(Qe.x, Qe.y, Wn, Co).point;
                            return new Ll((.5 * Dl.x + .5) * rt.width, (.5 * -Dl.y + .5) * rt.height);
                        }
                        class Fo extends yo {
                        }
                        let Up;
                        Zi("HeatmapBucket", Fo, {
                            omit: [
                                "layers"
                            ]
                        });
                        var Vp = {
                            get paint () {
                                return Up = Up || new Is({
                                    "heatmap-radius": new Ss(Ju.paint_heatmap["heatmap-radius"]),
                                    "heatmap-weight": new Ss(Ju.paint_heatmap["heatmap-weight"]),
                                    "heatmap-intensity": new _s(Ju.paint_heatmap["heatmap-intensity"]),
                                    "heatmap-color": new Ms(Ju.paint_heatmap["heatmap-color"]),
                                    "heatmap-opacity": new _s(Ju.paint_heatmap["heatmap-opacity"])
                                });
                            }
                        };
                        function Oo(Qe, { width: rt, height: Wn }, Co, Dl) {
                            if (Dl) {
                                if (Dl instanceof Uint8ClampedArray) Dl = new Uint8Array(Dl.buffer);
                                else if (Dl.length !== rt * Wn * Co) throw new RangeError(`mismatched image size. expected: ${Dl.length} but got: ${rt * Wn * Co}`);
                            } else Dl = new Uint8Array(rt * Wn * Co);
                            return Qe.width = rt, Qe.height = Wn, Qe.data = Dl, Qe;
                        }
                        function Do(Qe, { width: rt, height: Wn }, Co) {
                            if (rt === Qe.width && Wn === Qe.height) return;
                            const Dl = Oo({}, {
                                width: rt,
                                height: Wn
                            }, Co);
                            Ro(Qe, Dl, {
                                x: 0,
                                y: 0
                            }, {
                                x: 0,
                                y: 0
                            }, {
                                width: Math.min(Qe.width, rt),
                                height: Math.min(Qe.height, Wn)
                            }, Co), Qe.width = rt, Qe.height = Wn, Qe.data = Dl.data;
                        }
                        function Ro(Qe, rt, Wn, Co, Dl, Ll) {
                            if (0 === Dl.width || 0 === Dl.height) return rt;
                            if (Dl.width > Qe.width || Dl.height > Qe.height || Wn.x > Qe.width - Dl.width || Wn.y > Qe.height - Dl.height) throw new RangeError("out of range source coordinates for image copy");
                            if (Dl.width > rt.width || Dl.height > rt.height || Co.x > rt.width - Dl.width || Co.y > rt.height - Dl.height) throw new RangeError("out of range destination coordinates for image copy");
                            const Rl = Qe.data, Ul = rt.data;
                            if (Rl === Ul) throw new Error("srcData equals dstData, so image is already copied");
                            for(let Gl = 0; Gl < Dl.height; Gl++){
                                const Zl = ((Wn.y + Gl) * Qe.width + Wn.x) * Ll, Hl = ((Co.y + Gl) * rt.width + Co.x) * Ll;
                                for(let Qe = 0; Qe < Dl.width * Ll; Qe++)Ul[Hl + Qe] = Rl[Zl + Qe];
                            }
                            return rt;
                        }
                        class jo {
                            constructor(Qe, rt){
                                Oo(this, Qe, 1, rt);
                            }
                            resize(Qe) {
                                Do(this, Qe, 1);
                            }
                            clone() {
                                return new jo({
                                    width: this.width,
                                    height: this.height
                                }, new Uint8Array(this.data));
                            }
                            static copy(Qe, rt, Wn, Co, Dl) {
                                Ro(Qe, rt, Wn, Co, Dl, 1);
                            }
                        }
                        class No {
                            constructor(Qe, rt){
                                Oo(this, Qe, 4, rt);
                            }
                            resize(Qe) {
                                Do(this, Qe, 4);
                            }
                            replace(Qe, rt) {
                                rt ? this.data.set(Qe) : this.data = Qe instanceof Uint8ClampedArray ? new Uint8Array(Qe.buffer) : Qe;
                            }
                            clone() {
                                return new No({
                                    width: this.width,
                                    height: this.height
                                }, new Uint8Array(this.data));
                            }
                            static copy(Qe, rt, Wn, Co, Dl) {
                                Ro(Qe, rt, Wn, Co, Dl, 4);
                            }
                        }
                        function Uo(Qe) {
                            const rt = {}, Wn = Qe.resolution || 256, Co = Qe.clips ? Qe.clips.length : 1, Dl = Qe.image || new No({
                                width: Wn,
                                height: Co
                            });
                            if (Math.log(Wn) / Math.LN2 % 1 != 0) throw new Error(`width is not a power of 2 - ${Wn}`);
                            const s = (Wn, Co, Ll)=>{
                                rt[Qe.evaluationKey] = Ll;
                                const Rl = Qe.expression.evaluate(rt);
                                Dl.data[Wn + Co + 0] = Math.floor(255 * Rl.r / Rl.a), Dl.data[Wn + Co + 1] = Math.floor(255 * Rl.g / Rl.a), Dl.data[Wn + Co + 2] = Math.floor(255 * Rl.b / Rl.a), Dl.data[Wn + Co + 3] = Math.floor(255 * Rl.a);
                            };
                            if (Qe.clips) for(let Ll = 0, Rl = 0; Ll < Co; ++Ll, Rl += 4 * Wn)for(let rt = 0, Co = 0; rt < Wn; rt++, Co += 4){
                                const Dl = rt / (Wn - 1), { start: Ul, end: Gl } = Qe.clips[Ll];
                                s(Rl, Co, Ul * (1 - Dl) + Gl * Dl);
                            }
                            else for(let Ll = 0, Rl = 0; Ll < Wn; Ll++, Rl += 4)s(0, Rl, Ll / (Wn - 1));
                            return Dl;
                        }
                        Zi("AlphaImage", jo), Zi("RGBAImage", No);
                        const Gp = "big-fb";
                        class Go extends Ps {
                            createBucket(Qe) {
                                return new Fo(Qe);
                            }
                            constructor(Qe){
                                super(Qe, Vp), this.heatmapFbos = new Map, this._updateColorRamp();
                            }
                            _handleSpecialPaintPropertyUpdate(Qe) {
                                "heatmap-color" === Qe && this._updateColorRamp();
                            }
                            _updateColorRamp() {
                                this.colorRamp = Uo({
                                    expression: this._transitionablePaint._values["heatmap-color"].value.expression,
                                    evaluationKey: "heatmapDensity",
                                    image: this.colorRamp
                                }), this.colorRampTexture = null;
                            }
                            resize() {
                                this.heatmapFbos.has(Gp) && this.heatmapFbos.delete(Gp);
                            }
                            queryRadius() {
                                return 0;
                            }
                            queryIntersectsFeature() {
                                return !1;
                            }
                            hasOffscreenPass() {
                                return 0 !== this.paint.get("heatmap-opacity") && "none" !== this.visibility;
                            }
                        }
                        let Zp;
                        var Hp = {
                            get paint () {
                                return Zp = Zp || new Is({
                                    "hillshade-illumination-direction": new _s(Ju.paint_hillshade["hillshade-illumination-direction"]),
                                    "hillshade-illumination-anchor": new _s(Ju.paint_hillshade["hillshade-illumination-anchor"]),
                                    "hillshade-exaggeration": new _s(Ju.paint_hillshade["hillshade-exaggeration"]),
                                    "hillshade-shadow-color": new _s(Ju.paint_hillshade["hillshade-shadow-color"]),
                                    "hillshade-highlight-color": new _s(Ju.paint_hillshade["hillshade-highlight-color"]),
                                    "hillshade-accent-color": new _s(Ju.paint_hillshade["hillshade-accent-color"])
                                });
                            }
                        };
                        class Xo extends Ps {
                            constructor(Qe){
                                super(Qe, Hp);
                            }
                            hasOffscreenPass() {
                                return 0 !== this.paint.get("hillshade-exaggeration") && "none" !== this.visibility;
                            }
                        }
                        const Wp = Es([
                            {
                                name: "a_pos",
                                components: 2,
                                type: "Int16"
                            }
                        ], 4), { members: qp } = Wp;
                        function Jo(Qe, rt, Wn) {
                            const Co = Wn.patternDependencies;
                            let Dl = !1;
                            for (const Ll of rt){
                                const rt = Ll.paint.get(`${Qe}-pattern`);
                                rt.isConstant() || (Dl = !0);
                                const Wn = rt.constantOr(null);
                                Wn && (Dl = !0, Co[Wn.to] = !0, Co[Wn.from] = !0);
                            }
                            return Dl;
                        }
                        function Wo(Qe, rt, Wn, Co, Dl) {
                            const Ll = Dl.patternDependencies;
                            for (const Rl of rt){
                                const rt = Rl.paint.get(`${Qe}-pattern`).value;
                                if ("constant" !== rt.kind) {
                                    let Qe = rt.evaluate({
                                        zoom: Co - 1
                                    }, Wn, {}, Dl.availableImages), Ul = rt.evaluate({
                                        zoom: Co
                                    }, Wn, {}, Dl.availableImages), Gl = rt.evaluate({
                                        zoom: Co + 1
                                    }, Wn, {}, Dl.availableImages);
                                    Qe = Qe && Qe.name ? Qe.name : Qe, Ul = Ul && Ul.name ? Ul.name : Ul, Gl = Gl && Gl.name ? Gl.name : Gl, Ll[Qe] = !0, Ll[Ul] = !0, Ll[Gl] = !0, Wn.patterns[Rl.id] = {
                                        min: Qe,
                                        mid: Ul,
                                        max: Gl
                                    };
                                }
                            }
                            return Wn;
                        }
                        function Qo(Qe, rt, Wn, Co, Dl) {
                            let Ll;
                            if (Dl === function(Qe, rt, Wn, Co) {
                                let Dl = 0;
                                for(let Ll = rt, Rl = Wn - Co; Ll < Wn; Ll += Co)Dl += (Qe[Rl] - Qe[Ll]) * (Qe[Ll + 1] + Qe[Rl + 1]), Rl = Ll;
                                return Dl;
                            }(Qe, rt, Wn, Co) > 0) for(let Rl = rt; Rl < Wn; Rl += Co)Ll = wl(Rl / Co | 0, Qe[Rl], Qe[Rl + 1], Ll);
                            else for(let Rl = Wn - Co; Rl >= rt; Rl -= Co)Ll = wl(Rl / Co | 0, Qe[Rl], Qe[Rl + 1], Ll);
                            return Ll && yl(Ll, Ll.next) && (_l(Ll), Ll = Ll.next), Ll;
                        }
                        function tl(Qe, rt) {
                            if (!Qe) return Qe;
                            rt || (rt = Qe);
                            let Wn, Co = Qe;
                            do if (Wn = !1, Co.steiner || !yl(Co, Co.next) && 0 !== dl(Co.prev, Co, Co.next)) Co = Co.next;
                            else {
                                if (_l(Co), Co = rt = Co.prev, Co === Co.next) break;
                                Wn = !0;
                            }
                            while (Wn || Co !== rt);
                            return rt;
                        }
                        function el(Qe, rt, Wn, Co, Dl, Ll, Rl) {
                            if (!Qe) return;
                            !Rl && Ll && function(Qe, rt, Wn, Co) {
                                let Dl = Qe;
                                do 0 === Dl.z && (Dl.z = ul(Dl.x, Dl.y, rt, Wn, Co)), Dl.prevZ = Dl.prev, Dl.nextZ = Dl.next, Dl = Dl.next;
                                while (Dl !== Qe);
                                Dl.prevZ.nextZ = null, Dl.prevZ = null, function(Qe) {
                                    let rt, Wn = 1;
                                    do {
                                        let Co, Dl = Qe;
                                        Qe = null;
                                        let Ll = null;
                                        for(rt = 0; Dl;){
                                            rt++;
                                            let Rl = Dl, Ul = 0;
                                            for(let Qe = 0; Qe < Wn && (Ul++, Rl = Rl.nextZ, Rl); Qe++);
                                            let Gl = Wn;
                                            for(; Ul > 0 || Gl > 0 && Rl;)0 !== Ul && (0 === Gl || !Rl || Dl.z <= Rl.z) ? (Co = Dl, Dl = Dl.nextZ, Ul--) : (Co = Rl, Rl = Rl.nextZ, Gl--), Ll ? Ll.nextZ = Co : Qe = Co, Co.prevZ = Ll, Ll = Co;
                                            Dl = Rl;
                                        }
                                        Ll.nextZ = null, Wn *= 2;
                                    }while (rt > 1);
                                }(Dl);
                            }(Qe, Co, Dl, Ll);
                            let Ul = Qe;
                            for(; Qe.prev !== Qe.next;){
                                const Gl = Qe.prev, Zl = Qe.next;
                                if (Ll ? nl(Qe, Co, Dl, Ll) : rl(Qe)) rt.push(Gl.i, Qe.i, Zl.i), _l(Qe), Qe = Zl.next, Ul = Zl.next;
                                else if ((Qe = Zl) === Ul) {
                                    Rl ? 1 === Rl ? el(Qe = il(tl(Qe), rt), rt, Wn, Co, Dl, Ll, 2) : 2 === Rl && sl(Qe, rt, Wn, Co, Dl, Ll) : el(tl(Qe), rt, Wn, Co, Dl, Ll, 1);
                                    break;
                                }
                            }
                        }
                        function rl(Qe) {
                            const rt = Qe.prev, Wn = Qe, Co = Qe.next;
                            if (dl(rt, Wn, Co) >= 0) return !1;
                            const Dl = rt.x, Ll = Wn.x, Rl = Co.x, Ul = rt.y, Gl = Wn.y, Zl = Co.y, Hl = Math.min(Dl, Ll, Rl), ql = Math.min(Ul, Gl, Zl), Ql = Math.max(Dl, Ll, Rl), Kl = Math.max(Ul, Gl, Zl);
                            let $l = Co.next;
                            for(; $l !== rt;){
                                if ($l.x >= Hl && $l.x <= Ql && $l.y >= ql && $l.y <= Kl && pl(Dl, Ul, Ll, Gl, Rl, Zl, $l.x, $l.y) && dl($l.prev, $l, $l.next) >= 0) return !1;
                                $l = $l.next;
                            }
                            return !0;
                        }
                        function nl(Qe, rt, Wn, Co) {
                            const Dl = Qe.prev, Ll = Qe, Rl = Qe.next;
                            if (dl(Dl, Ll, Rl) >= 0) return !1;
                            const Ul = Dl.x, Gl = Ll.x, Zl = Rl.x, Hl = Dl.y, ql = Ll.y, Ql = Rl.y, Kl = Math.min(Ul, Gl, Zl), $l = Math.min(Hl, ql, Ql), Tc = Math.max(Ul, Gl, Zl), tu = Math.max(Hl, ql, Ql), lu = ul(Kl, $l, rt, Wn, Co), du = ul(Tc, tu, rt, Wn, Co);
                            let fu = Qe.prevZ, yu = Qe.nextZ;
                            for(; fu && fu.z >= lu && yu && yu.z <= du;){
                                if (fu.x >= Kl && fu.x <= Tc && fu.y >= $l && fu.y <= tu && fu !== Dl && fu !== Rl && pl(Ul, Hl, Gl, ql, Zl, Ql, fu.x, fu.y) && dl(fu.prev, fu, fu.next) >= 0) return !1;
                                if (fu = fu.prevZ, yu.x >= Kl && yu.x <= Tc && yu.y >= $l && yu.y <= tu && yu !== Dl && yu !== Rl && pl(Ul, Hl, Gl, ql, Zl, Ql, yu.x, yu.y) && dl(yu.prev, yu, yu.next) >= 0) return !1;
                                yu = yu.nextZ;
                            }
                            for(; fu && fu.z >= lu;){
                                if (fu.x >= Kl && fu.x <= Tc && fu.y >= $l && fu.y <= tu && fu !== Dl && fu !== Rl && pl(Ul, Hl, Gl, ql, Zl, Ql, fu.x, fu.y) && dl(fu.prev, fu, fu.next) >= 0) return !1;
                                fu = fu.prevZ;
                            }
                            for(; yu && yu.z <= du;){
                                if (yu.x >= Kl && yu.x <= Tc && yu.y >= $l && yu.y <= tu && yu !== Dl && yu !== Rl && pl(Ul, Hl, Gl, ql, Zl, Ql, yu.x, yu.y) && dl(yu.prev, yu, yu.next) >= 0) return !1;
                                yu = yu.nextZ;
                            }
                            return !0;
                        }
                        function il(Qe, rt) {
                            let Wn = Qe;
                            do {
                                const Co = Wn.prev, Dl = Wn.next.next;
                                !yl(Co, Dl) && ml(Co, Wn, Wn.next, Dl) && vl(Co, Dl) && vl(Dl, Co) && (rt.push(Co.i, Wn.i, Dl.i), _l(Wn), _l(Wn.next), Wn = Qe = Dl), Wn = Wn.next;
                            }while (Wn !== Qe);
                            return tl(Wn);
                        }
                        function sl(Qe, rt, Wn, Co, Dl, Ll) {
                            let Rl = Qe;
                            do {
                                let Qe = Rl.next.next;
                                for(; Qe !== Rl.prev;){
                                    if (Rl.i !== Qe.i && fl(Rl, Qe)) {
                                        let Ul = bl(Rl, Qe);
                                        return Rl = tl(Rl, Rl.next), Ul = tl(Ul, Ul.next), el(Rl, rt, Wn, Co, Dl, Ll, 0), void el(Ul, rt, Wn, Co, Dl, Ll, 0);
                                    }
                                    Qe = Qe.next;
                                }
                                Rl = Rl.next;
                            }while (Rl !== Qe);
                        }
                        function al(Qe, rt) {
                            let Wn = Qe.x - rt.x;
                            return 0 === Wn && (Wn = Qe.y - rt.y, 0 === Wn) && (Wn = (Qe.next.y - Qe.y) / (Qe.next.x - Qe.x) - (rt.next.y - rt.y) / (rt.next.x - rt.x)), Wn;
                        }
                        function ol(Qe, rt) {
                            const Wn = function(Qe, rt) {
                                let Wn = rt;
                                const Co = Qe.x, Dl = Qe.y;
                                let Ll, Rl = -1 / 0;
                                if (yl(Qe, Wn)) return Wn;
                                do {
                                    if (yl(Qe, Wn.next)) return Wn.next;
                                    if (Dl <= Wn.y && Dl >= Wn.next.y && Wn.next.y !== Wn.y) {
                                        const Qe = Wn.x + (Dl - Wn.y) * (Wn.next.x - Wn.x) / (Wn.next.y - Wn.y);
                                        if (Qe <= Co && Qe > Rl && (Rl = Qe, Ll = Wn.x < Wn.next.x ? Wn : Wn.next, Qe === Co)) return Ll;
                                    }
                                    Wn = Wn.next;
                                }while (Wn !== rt);
                                if (!Ll) return null;
                                const Ul = Ll, Gl = Ll.x, Zl = Ll.y;
                                let Hl = 1 / 0;
                                Wn = Ll;
                                do {
                                    if (Co >= Wn.x && Wn.x >= Gl && Co !== Wn.x && hl(Dl < Zl ? Co : Rl, Dl, Gl, Zl, Dl < Zl ? Rl : Co, Dl, Wn.x, Wn.y)) {
                                        const rt = Math.abs(Dl - Wn.y) / (Co - Wn.x);
                                        vl(Wn, Qe) && (rt < Hl || rt === Hl && (Wn.x > Ll.x || Wn.x === Ll.x && ll(Ll, Wn))) && (Ll = Wn, Hl = rt);
                                    }
                                    Wn = Wn.next;
                                }while (Wn !== Ul);
                                return Ll;
                            }(Qe, rt);
                            if (!Wn) return rt;
                            const Co = bl(Wn, Qe);
                            return tl(Co, Co.next), tl(Wn, Wn.next);
                        }
                        function ll(Qe, rt) {
                            return dl(Qe.prev, Qe, rt.prev) < 0 && dl(rt.next, Qe, Qe.next) < 0;
                        }
                        function ul(Qe, rt, Wn, Co, Dl) {
                            return (Qe = 1431655765 & ((Qe = 858993459 & ((Qe = 252645135 & ((Qe = 16711935 & ((Qe = (Qe - Wn) * Dl | 0) | Qe << 8)) | Qe << 4)) | Qe << 2)) | Qe << 1)) | (rt = 1431655765 & ((rt = 858993459 & ((rt = 252645135 & ((rt = 16711935 & ((rt = (rt - Co) * Dl | 0) | rt << 8)) | rt << 4)) | rt << 2)) | rt << 1)) << 1;
                        }
                        function cl(Qe) {
                            let rt = Qe, Wn = Qe;
                            do (rt.x < Wn.x || rt.x === Wn.x && rt.y < Wn.y) && (Wn = rt), rt = rt.next;
                            while (rt !== Qe);
                            return Wn;
                        }
                        function hl(Qe, rt, Wn, Co, Dl, Ll, Rl, Ul) {
                            return (Dl - Rl) * (rt - Ul) >= (Qe - Rl) * (Ll - Ul) && (Qe - Rl) * (Co - Ul) >= (Wn - Rl) * (rt - Ul) && (Wn - Rl) * (Ll - Ul) >= (Dl - Rl) * (Co - Ul);
                        }
                        function pl(Qe, rt, Wn, Co, Dl, Ll, Rl, Ul) {
                            return !(Qe === Rl && rt === Ul) && hl(Qe, rt, Wn, Co, Dl, Ll, Rl, Ul);
                        }
                        function fl(Qe, rt) {
                            return Qe.next.i !== rt.i && Qe.prev.i !== rt.i && !function(Qe, rt) {
                                let Wn = Qe;
                                do {
                                    if (Wn.i !== Qe.i && Wn.next.i !== Qe.i && Wn.i !== rt.i && Wn.next.i !== rt.i && ml(Wn, Wn.next, Qe, rt)) return !0;
                                    Wn = Wn.next;
                                }while (Wn !== Qe);
                                return !1;
                            }(Qe, rt) && (vl(Qe, rt) && vl(rt, Qe) && function(Qe, rt) {
                                let Wn = Qe, Co = !1;
                                const Dl = (Qe.x + rt.x) / 2, Ll = (Qe.y + rt.y) / 2;
                                do Wn.y > Ll != Wn.next.y > Ll && Wn.next.y !== Wn.y && Dl < (Wn.next.x - Wn.x) * (Ll - Wn.y) / (Wn.next.y - Wn.y) + Wn.x && (Co = !Co), Wn = Wn.next;
                                while (Wn !== Qe);
                                return Co;
                            }(Qe, rt) && (dl(Qe.prev, Qe, rt.prev) || dl(Qe, rt.prev, rt)) || yl(Qe, rt) && dl(Qe.prev, Qe, Qe.next) > 0 && dl(rt.prev, rt, rt.next) > 0);
                        }
                        function dl(Qe, rt, Wn) {
                            return (rt.y - Qe.y) * (Wn.x - rt.x) - (rt.x - Qe.x) * (Wn.y - rt.y);
                        }
                        function yl(Qe, rt) {
                            return Qe.x === rt.x && Qe.y === rt.y;
                        }
                        function ml(Qe, rt, Wn, Co) {
                            const Dl = xl(dl(Qe, rt, Wn)), Ll = xl(dl(Qe, rt, Co)), Rl = xl(dl(Wn, Co, Qe)), Ul = xl(dl(Wn, Co, rt));
                            return Dl !== Ll && Rl !== Ul || !(0 !== Dl || !gl(Qe, Wn, rt)) || !(0 !== Ll || !gl(Qe, Co, rt)) || !(0 !== Rl || !gl(Wn, Qe, Co)) || !(0 !== Ul || !gl(Wn, rt, Co));
                        }
                        function gl(Qe, rt, Wn) {
                            return rt.x <= Math.max(Qe.x, Wn.x) && rt.x >= Math.min(Qe.x, Wn.x) && rt.y <= Math.max(Qe.y, Wn.y) && rt.y >= Math.min(Qe.y, Wn.y);
                        }
                        function xl(Qe) {
                            return Qe > 0 ? 1 : Qe < 0 ? -1 : 0;
                        }
                        function vl(Qe, rt) {
                            return dl(Qe.prev, Qe, Qe.next) < 0 ? dl(Qe, rt, Qe.next) >= 0 && dl(Qe, Qe.prev, rt) >= 0 : dl(Qe, rt, Qe.prev) < 0 || dl(Qe, Qe.next, rt) < 0;
                        }
                        function bl(Qe, rt) {
                            const Wn = Sl(Qe.i, Qe.x, Qe.y), Co = Sl(rt.i, rt.x, rt.y), Dl = Qe.next, Ll = rt.prev;
                            return Qe.next = rt, rt.prev = Qe, Wn.next = Dl, Dl.prev = Wn, Co.next = Wn, Wn.prev = Co, Ll.next = Co, Co.prev = Ll, Co;
                        }
                        function wl(Qe, rt, Wn, Co) {
                            const Dl = Sl(Qe, rt, Wn);
                            return Co ? (Dl.next = Co.next, Dl.prev = Co, Co.next.prev = Dl, Co.next = Dl) : (Dl.prev = Dl, Dl.next = Dl), Dl;
                        }
                        function _l(Qe) {
                            Qe.next.prev = Qe.prev, Qe.prev.next = Qe.next, Qe.prevZ && (Qe.prevZ.nextZ = Qe.nextZ), Qe.nextZ && (Qe.nextZ.prevZ = Qe.prevZ);
                        }
                        function Sl(Qe, rt, Wn) {
                            return {
                                i: Qe,
                                x: rt,
                                y: Wn,
                                prev: null,
                                next: null,
                                z: 0,
                                prevZ: null,
                                nextZ: null,
                                steiner: !1
                            };
                        }
                        class Al {
                            constructor(Qe, rt){
                                if (rt > Qe) throw new Error("Min granularity must not be greater than base granularity.");
                                this._baseZoomGranularity = Qe, this._minGranularity = rt;
                            }
                            getGranularityForZoomLevel(Qe) {
                                return Math.max(Math.floor(this._baseZoomGranularity / (1 << Qe)), this._minGranularity, 1);
                            }
                        }
                        class kl {
                            constructor(Qe){
                                this.fill = Qe.fill, this.line = Qe.line, this.tile = Qe.tile, this.stencil = Qe.stencil, this.circle = Qe.circle;
                            }
                        }
                        kl.noSubdivision = new kl({
                            fill: new Al(0, 0),
                            line: new Al(0, 0),
                            tile: new Al(0, 0),
                            stencil: new Al(0, 0),
                            circle: 1
                        }), Zi("SubdivisionGranularityExpression", Al), Zi("SubdivisionGranularitySetting", kl);
                        const Yp = -32768, Qp = 32767;
                        class zl {
                            constructor(Qe, rt){
                                this._vertexBuffer = [], this._vertexDictionary = new Map, this._used = !1, this._granularity = Qe, this._granularityCellSize = Kl / Qe, this._canonical = rt;
                            }
                            _getKey(Qe, rt) {
                                return (Qe += 32768) << 16 | (rt += 32768);
                            }
                            _vertexToIndex(Qe, rt) {
                                if (Qe < -32768 || rt < -32768 || Qe > 32767 || rt > 32767) throw new Error("Vertex coordinates are out of signed 16 bit integer range.");
                                const Wn = 0 | Math.round(Qe), Co = 0 | Math.round(rt), Dl = this._getKey(Wn, Co);
                                if (this._vertexDictionary.has(Dl)) return this._vertexDictionary.get(Dl);
                                const Ll = this._vertexBuffer.length / 2;
                                return this._vertexDictionary.set(Dl, Ll), this._vertexBuffer.push(Wn, Co), Ll;
                            }
                            _subdivideTrianglesScanline(Qe) {
                                if (this._granularity < 2) return function(Qe, rt) {
                                    const Wn = [];
                                    for(let Co = 0; Co < rt.length; Co += 3){
                                        const Dl = rt[Co], Ll = rt[Co + 1], Rl = rt[Co + 2], Ul = Qe[2 * Dl], Gl = Qe[2 * Dl + 1];
                                        (Qe[2 * Ll] - Ul) * (Qe[2 * Rl + 1] - Gl) - (Qe[2 * Ll + 1] - Gl) * (Qe[2 * Rl] - Ul) > 0 ? (Wn.push(Dl), Wn.push(Rl), Wn.push(Ll)) : (Wn.push(Dl), Wn.push(Ll), Wn.push(Rl));
                                    }
                                    return Wn;
                                }(this._vertexBuffer, Qe);
                                const rt = [], Wn = Qe.length;
                                for(let Co = 0; Co < Wn; Co += 3){
                                    const Wn = [
                                        Qe[Co + 0],
                                        Qe[Co + 1],
                                        Qe[Co + 2]
                                    ], Dl = [
                                        this._vertexBuffer[2 * Qe[Co + 0] + 0],
                                        this._vertexBuffer[2 * Qe[Co + 0] + 1],
                                        this._vertexBuffer[2 * Qe[Co + 1] + 0],
                                        this._vertexBuffer[2 * Qe[Co + 1] + 1],
                                        this._vertexBuffer[2 * Qe[Co + 2] + 0],
                                        this._vertexBuffer[2 * Qe[Co + 2] + 1]
                                    ];
                                    let Ll = 1 / 0, Rl = 1 / 0, Ul = -1 / 0, Gl = -1 / 0;
                                    for(let Qe = 0; Qe < 3; Qe++){
                                        const rt = Dl[2 * Qe], Wn = Dl[2 * Qe + 1];
                                        Ll = Math.min(Ll, rt), Ul = Math.max(Ul, rt), Rl = Math.min(Rl, Wn), Gl = Math.max(Gl, Wn);
                                    }
                                    if (Ll === Ul || Rl === Gl) continue;
                                    const Zl = Math.floor(Ll / this._granularityCellSize), Hl = Math.ceil(Ul / this._granularityCellSize), ql = Math.floor(Rl / this._granularityCellSize), Ql = Math.ceil(Gl / this._granularityCellSize);
                                    if (Zl !== Hl || ql !== Ql) for(let Qe = ql; Qe < Ql; Qe++){
                                        const Co = this._scanlineGenerateVertexRingForCellRow(Qe, Dl, Wn);
                                        Bl(this._vertexBuffer, Co, rt);
                                    }
                                    else rt.push(...Wn);
                                }
                                return rt;
                            }
                            _scanlineGenerateVertexRingForCellRow(Qe, rt, Wn) {
                                const Co = Qe * this._granularityCellSize, Dl = Co + this._granularityCellSize, Ll = [];
                                for(let Rl = 0; Rl < 3; Rl++){
                                    const Qe = rt[2 * Rl], Ul = rt[2 * Rl + 1], Gl = rt[2 * (Rl + 1) % 6], Zl = rt[(2 * (Rl + 1) + 1) % 6], Hl = rt[2 * (Rl + 2) % 6], ql = rt[(2 * (Rl + 2) + 1) % 6], Ql = Gl - Qe, Kl = Zl - Ul, $l = 0 === Ql, Tc = 0 === Kl, tu = (Co - Ul) / Kl, lu = (Dl - Ul) / Kl, du = Math.min(tu, lu), fu = Math.max(tu, lu);
                                    if (!Tc && (du >= 1 || fu <= 0) || Tc && (Ul < Co || Ul > Dl)) {
                                        Zl >= Co && Zl <= Dl && Ll.push(Wn[(Rl + 1) % 3]);
                                        continue;
                                    }
                                    !Tc && du > 0 && Ll.push(this._vertexToIndex(Qe + Ql * du, Ul + Kl * du));
                                    const yu = Qe + Ql * Math.max(du, 0), Eu = Qe + Ql * Math.min(fu, 1);
                                    $l || this._generateIntraEdgeVertices(Ll, Qe, Ul, Gl, Zl, yu, Eu), !Tc && fu < 1 && Ll.push(this._vertexToIndex(Qe + Ql * fu, Ul + Kl * fu)), (Tc || Zl >= Co && Zl <= Dl) && Ll.push(Wn[(Rl + 1) % 3]), !Tc && (Zl <= Co || Zl >= Dl) && this._generateInterEdgeVertices(Ll, Qe, Ul, Gl, Zl, Hl, ql, Eu, Co, Dl);
                                }
                                return Ll;
                            }
                            _generateIntraEdgeVertices(Qe, rt, Wn, Co, Dl, Ll, Rl) {
                                const Ul = Co - rt, Gl = Dl - Wn, Zl = 0 === Gl, Hl = Zl ? Math.min(rt, Co) : Math.min(Ll, Rl), ql = Zl ? Math.max(rt, Co) : Math.max(Ll, Rl), Ql = Math.floor(Hl / this._granularityCellSize) + 1, Kl = Math.ceil(ql / this._granularityCellSize) - 1;
                                if (Zl ? rt < Co : Ll < Rl) for(let $l = Ql; $l <= Kl; $l++){
                                    const Co = $l * this._granularityCellSize;
                                    Qe.push(this._vertexToIndex(Co, Wn + Gl * (Co - rt) / Ul));
                                }
                                else for(let $l = Kl; $l >= Ql; $l--){
                                    const Co = $l * this._granularityCellSize;
                                    Qe.push(this._vertexToIndex(Co, Wn + Gl * (Co - rt) / Ul));
                                }
                            }
                            _generateInterEdgeVertices(Qe, rt, Wn, Co, Dl, Ll, Rl, Ul, Gl, Zl) {
                                const Hl = Dl - Wn, ql = Ll - Co, Ql = Rl - Dl, Kl = (Gl - Dl) / Ql, $l = (Zl - Dl) / Ql, Tc = Math.min(Kl, $l), tu = Math.max(Kl, $l), lu = Co + ql * Tc;
                                let du = Math.floor(Math.min(lu, Ul) / this._granularityCellSize) + 1, fu = Math.ceil(Math.max(lu, Ul) / this._granularityCellSize) - 1, yu = Ul < lu;
                                const Eu = 0 === Ql;
                                if (Eu && (Rl === Gl || Rl === Zl)) return;
                                if (Eu || Tc >= 1 || tu <= 0) {
                                    const Qe = Wn - Rl, Co = Ll + (rt - Ll) * Math.min((Gl - Rl) / Qe, (Zl - Rl) / Qe);
                                    du = Math.floor(Math.min(Co, Ul) / this._granularityCellSize) + 1, fu = Math.ceil(Math.max(Co, Ul) / this._granularityCellSize) - 1, yu = Ul < Co;
                                }
                                const Tu = Hl > 0 ? Zl : Gl;
                                if (yu) for(let Lu = du; Lu <= fu; Lu++)Qe.push(this._vertexToIndex(Lu * this._granularityCellSize, Tu));
                                else for(let Lu = fu; Lu >= du; Lu--)Qe.push(this._vertexToIndex(Lu * this._granularityCellSize, Tu));
                            }
                            _generateOutline(Qe) {
                                const rt = [];
                                for (const Wn of Qe){
                                    const Qe = Cl(Wn, this._granularity, !0), Co = this._pointArrayToIndices(Qe), Dl = [];
                                    for(let rt = 1; rt < Co.length; rt++)Dl.push(Co[rt - 1]), Dl.push(Co[rt]);
                                    rt.push(Dl);
                                }
                                return rt;
                            }
                            _handlePoles(Qe) {
                                let rt = !1, Wn = !1;
                                this._canonical && (0 === this._canonical.y && (rt = !0), this._canonical.y === (1 << this._canonical.z) - 1 && (Wn = !0)), (rt || Wn) && this._fillPoles(Qe, rt, Wn);
                            }
                            _ensureNoPoleVertices() {
                                const Qe = this._vertexBuffer;
                                for(let rt = 0; rt < Qe.length; rt += 2){
                                    const Wn = Qe[rt + 1];
                                    Wn === Yp && (Qe[rt + 1] = -32767), Wn === Qp && (Qe[rt + 1] = 32766);
                                }
                            }
                            _generatePoleQuad(Qe, rt, Wn, Co, Dl, Ll) {
                                Co > Dl != (Ll === Yp) ? (Qe.push(rt), Qe.push(Wn), Qe.push(this._vertexToIndex(Co, Ll)), Qe.push(Wn), Qe.push(this._vertexToIndex(Dl, Ll)), Qe.push(this._vertexToIndex(Co, Ll))) : (Qe.push(Wn), Qe.push(rt), Qe.push(this._vertexToIndex(Co, Ll)), Qe.push(this._vertexToIndex(Dl, Ll)), Qe.push(Wn), Qe.push(this._vertexToIndex(Co, Ll)));
                            }
                            _fillPoles(Qe, rt, Wn) {
                                const Co = this._vertexBuffer, Dl = Kl, Ll = Qe.length;
                                for(let Rl = 2; Rl < Ll; Rl += 3){
                                    const Ll = Qe[Rl - 2], Ul = Qe[Rl - 1], Gl = Qe[Rl], Zl = Co[2 * Ll], Hl = Co[2 * Ll + 1], ql = Co[2 * Ul], Ql = Co[2 * Ul + 1], Kl = Co[2 * Gl], $l = Co[2 * Gl + 1];
                                    rt && (0 === Hl && 0 === Ql && this._generatePoleQuad(Qe, Ll, Ul, Zl, ql, Yp), 0 === Ql && 0 === $l && this._generatePoleQuad(Qe, Ul, Gl, ql, Kl, Yp), 0 === $l && 0 === Hl && this._generatePoleQuad(Qe, Gl, Ll, Kl, Zl, Yp)), Wn && (Hl === Dl && Ql === Dl && this._generatePoleQuad(Qe, Ll, Ul, Zl, ql, Qp), Ql === Dl && $l === Dl && this._generatePoleQuad(Qe, Ul, Gl, ql, Kl, Qp), $l === Dl && Hl === Dl && this._generatePoleQuad(Qe, Gl, Ll, Kl, Zl, Qp));
                                }
                            }
                            _initializeVertices(Qe) {
                                for(let rt = 0; rt < Qe.length; rt += 2)this._vertexToIndex(Qe[rt], Qe[rt + 1]);
                            }
                            subdividePolygonInternal(Qe, rt) {
                                if (this._used) throw new Error("Subdivision: multiple use not allowed.");
                                this._used = !0;
                                const { flattened: Wn, holeIndices: Co } = function(Qe) {
                                    const rt = [], Wn = [];
                                    for (const Co of Qe)if (0 !== Co.length) {
                                        Co !== Qe[0] && rt.push(Wn.length / 2);
                                        for(let Qe = 0; Qe < Co.length; Qe++)Wn.push(Co[Qe].x), Wn.push(Co[Qe].y);
                                    }
                                    return {
                                        flattened: Wn,
                                        holeIndices: rt
                                    };
                                }(Qe);
                                let Dl;
                                this._initializeVertices(Wn);
                                try {
                                    const Qe = function(Qe, rt, Wn = 2) {
                                        const Co = rt && rt.length, Dl = Co ? rt[0] * Wn : Qe.length;
                                        let Ll = Qo(Qe, 0, Dl, Wn, !0);
                                        const Rl = [];
                                        if (!Ll || Ll.next === Ll.prev) return Rl;
                                        let Ul, Gl, Zl;
                                        if (Co && (Ll = function(Qe, rt, Wn, Co) {
                                            const Dl = [];
                                            for(let Ll = 0, Rl = rt.length; Ll < Rl; Ll++){
                                                const Wn = Qo(Qe, rt[Ll] * Co, Ll < Rl - 1 ? rt[Ll + 1] * Co : Qe.length, Co, !1);
                                                Wn === Wn.next && (Wn.steiner = !0), Dl.push(cl(Wn));
                                            }
                                            Dl.sort(al);
                                            for(let Ll = 0; Ll < Dl.length; Ll++)Wn = ol(Dl[Ll], Wn);
                                            return Wn;
                                        }(Qe, rt, Ll, Wn)), Qe.length > 80 * Wn) {
                                            Ul = 1 / 0, Gl = 1 / 0;
                                            let rt = -1 / 0, Co = -1 / 0;
                                            for(let Ll = Wn; Ll < Dl; Ll += Wn){
                                                const Wn = Qe[Ll], Dl = Qe[Ll + 1];
                                                Wn < Ul && (Ul = Wn), Dl < Gl && (Gl = Dl), Wn > rt && (rt = Wn), Dl > Co && (Co = Dl);
                                            }
                                            Zl = Math.max(rt - Ul, Co - Gl), Zl = 0 !== Zl ? 32767 / Zl : 0;
                                        }
                                        return el(Ll, Rl, Wn, Ul, Gl, Zl, 0), Rl;
                                    }(Wn, Co), rt = this._convertIndices(Wn, Qe);
                                    Dl = this._subdivideTrianglesScanline(rt);
                                } catch (Qe) {
                                    console.error(Qe);
                                }
                                let Ll = [];
                                return rt && (Ll = this._generateOutline(Qe)), this._ensureNoPoleVertices(), this._handlePoles(Dl), {
                                    verticesFlattened: this._vertexBuffer,
                                    indicesTriangles: Dl,
                                    indicesLineList: Ll
                                };
                            }
                            _convertIndices(Qe, rt) {
                                const Wn = [];
                                for(let Co = 0; Co < rt.length; Co++)Wn.push(this._vertexToIndex(Qe[2 * rt[Co]], Qe[2 * rt[Co] + 1]));
                                return Wn;
                            }
                            _pointArrayToIndices(Qe) {
                                const rt = [];
                                for(let Wn = 0; Wn < Qe.length; Wn++){
                                    const Co = Qe[Wn];
                                    rt.push(this._vertexToIndex(Co.x, Co.y));
                                }
                                return rt;
                            }
                        }
                        function Pl(Qe, rt, Wn, Co = !0) {
                            return new zl(Wn, rt).subdividePolygonInternal(Qe, Co);
                        }
                        function Cl(Qe, rt, Wn = !1) {
                            if (!Qe || Qe.length < 1) return [];
                            if (Qe.length < 2) return [];
                            const Co = Qe[0], Dl = Qe[Qe.length - 1], Rl = Wn && (Co.x !== Dl.x || Co.y !== Dl.y);
                            if (rt < 2) return Rl ? [
                                ...Qe,
                                Qe[0]
                            ] : [
                                ...Qe
                            ];
                            const Ul = Math.floor(Kl / rt), Gl = [];
                            Gl.push(new Ll(Qe[0].x, Qe[0].y));
                            const Zl = Qe.length, Hl = Rl ? Zl : Zl - 1;
                            for(let ql = 0; ql < Hl; ql++){
                                const rt = Qe[ql], Wn = ql < Zl - 1 ? Qe[ql + 1] : Qe[0], Co = rt.x, Dl = rt.y, Rl = Wn.x, Hl = Wn.y, Ql = Co !== Rl, Kl = Dl !== Hl;
                                if (!Ql && !Kl) continue;
                                const $l = Rl - Co, Tc = Hl - Dl, tu = Math.abs($l), lu = Math.abs(Tc);
                                let du = Co, fu = Dl;
                                for(;;){
                                    const Qe = $l > 0 ? (Math.floor(du / Ul) + 1) * Ul : (Math.ceil(du / Ul) - 1) * Ul, rt = Tc > 0 ? (Math.floor(fu / Ul) + 1) * Ul : (Math.ceil(fu / Ul) - 1) * Ul, Wn = Math.abs(du - Qe), Co = Math.abs(fu - rt), Dl = Math.abs(du - Rl), Zl = Math.abs(fu - Hl), ql = Ql ? Wn / tu : Number.POSITIVE_INFINITY, yu = Kl ? Co / lu : Number.POSITIVE_INFINITY;
                                    if ((Dl <= Wn || !Ql) && (Zl <= Co || !Kl)) break;
                                    if (ql < yu && Ql || !Kl) {
                                        du = Qe, fu += Tc * ql;
                                        const rt = new Ll(du, Math.round(fu));
                                        Gl[Gl.length - 1].x === rt.x && Gl[Gl.length - 1].y === rt.y || Gl.push(rt);
                                    } else {
                                        du += $l * yu, fu = rt;
                                        const Qe = new Ll(Math.round(du), fu);
                                        Gl[Gl.length - 1].x === Qe.x && Gl[Gl.length - 1].y === Qe.y || Gl.push(Qe);
                                    }
                                }
                                const yu = new Ll(Rl, Hl);
                                Gl[Gl.length - 1].x === yu.x && Gl[Gl.length - 1].y === yu.y || Gl.push(yu);
                            }
                            return Gl;
                        }
                        function Bl(Qe, rt, Wn) {
                            if (0 === rt.length) throw new Error("Subdivision vertex ring is empty.");
                            let Co = 0, Dl = Qe[2 * rt[0]];
                            for(let Gl = 1; Gl < rt.length; Gl++){
                                const Wn = Qe[2 * rt[Gl]];
                                Wn < Dl && (Dl = Wn, Co = Gl);
                            }
                            const Ll = rt.length;
                            let Rl = Co, Ul = (Rl + 1) % Ll;
                            for(;;){
                                const Co = Rl - 1 >= 0 ? Rl - 1 : Ll - 1, Dl = (Ul + 1) % Ll, Gl = Qe[2 * rt[Co]], Zl = Qe[2 * rt[Dl]], Hl = Qe[2 * rt[Rl]], ql = Qe[2 * rt[Rl] + 1], Ql = Qe[2 * rt[Ul] + 1];
                                let Kl = !1;
                                if (Gl < Zl) Kl = !0;
                                else if (Gl > Zl) Kl = !1;
                                else {
                                    const Wn = Ql - ql, Ll = -(Qe[2 * rt[Ul]] - Hl), Rl = ql < Ql ? 1 : -1;
                                    ((Gl - Hl) * Wn + (Qe[2 * rt[Co] + 1] - ql) * Ll) * Rl > ((Zl - Hl) * Wn + (Qe[2 * rt[Dl] + 1] - ql) * Ll) * Rl && (Kl = !0);
                                }
                                if (Kl) {
                                    const Qe = rt[Co], Dl = rt[Rl], Gl = rt[Ul];
                                    Qe !== Dl && Qe !== Gl && Dl !== Gl && Wn.push(Gl, Dl, Qe), Rl--, Rl < 0 && (Rl = Ll - 1);
                                } else {
                                    const Qe = rt[Dl], Co = rt[Rl], Gl = rt[Ul];
                                    Qe !== Co && Qe !== Gl && Co !== Gl && Wn.push(Gl, Co, Qe), Ul++, Ul >= Ll && (Ul = 0);
                                }
                                if (Co === Dl) break;
                            }
                        }
                        function Vl(Qe, rt, Wn, Co, Dl, Ll, Rl, Ul, Gl) {
                            const Zl = Dl.length / 2, Hl = Rl && Ul && Gl;
                            if (Zl < Va.MAX_VERTEX_ARRAY_LENGTH) {
                                const ql = rt.prepareSegment(Zl, Wn, Co), Ql = ql.vertexLength;
                                for(let Qe = 0; Qe < Ll.length; Qe += 3)Co.emplaceBack(Ql + Ll[Qe], Ql + Ll[Qe + 1], Ql + Ll[Qe + 2]);
                                let Kl, $l;
                                ql.vertexLength += Zl, ql.primitiveLength += Ll.length / 3, Hl && ($l = Rl.prepareSegment(Zl, Wn, Ul), Kl = $l.vertexLength, $l.vertexLength += Zl);
                                for(let rt = 0; rt < Dl.length; rt += 2)Qe(Dl[rt], Dl[rt + 1]);
                                if (Hl) for(let Qe = 0; Qe < Gl.length; Qe++){
                                    const rt = Gl[Qe];
                                    for(let Qe = 1; Qe < rt.length; Qe += 2)Ul.emplaceBack(Kl + rt[Qe - 1], Kl + rt[Qe]);
                                    $l.primitiveLength += rt.length / 2;
                                }
                            } else !function(Qe, rt, Wn, Co, Dl, Ll) {
                                const Rl = [];
                                for(let ql = 0; ql < Co.length / 2; ql++)Rl.push(-1);
                                const Ul = {
                                    count: 0
                                };
                                let Gl = 0, Zl = Qe.getOrCreateLatestSegment(rt, Wn), Hl = Zl.vertexLength;
                                for(let ql = 2; ql < Dl.length; ql += 3){
                                    const Ql = Dl[ql - 2], Kl = Dl[ql - 1], $l = Dl[ql];
                                    let Tc = Rl[Ql] < Gl, tu = Rl[Kl] < Gl, lu = Rl[$l] < Gl;
                                    Zl.vertexLength + ((Tc ? 1 : 0) + (tu ? 1 : 0) + (lu ? 1 : 0)) > Va.MAX_VERTEX_ARRAY_LENGTH && (Zl = Qe.createNewSegment(rt, Wn), Gl = Ul.count, Tc = !0, tu = !0, lu = !0, Hl = 0);
                                    const du = El(Rl, Co, Ll, Ul, Ql, Tc, Zl), fu = El(Rl, Co, Ll, Ul, Kl, tu, Zl), yu = El(Rl, Co, Ll, Ul, $l, lu, Zl);
                                    Wn.emplaceBack(Hl + du - Gl, Hl + fu - Gl, Hl + yu - Gl), Zl.primitiveLength++;
                                }
                            }(rt, Wn, Co, Dl, Ll, Qe), Hl && function(Qe, rt, Wn, Co, Dl, Ll) {
                                const Rl = [];
                                for(let ql = 0; ql < Co.length / 2; ql++)Rl.push(-1);
                                const Ul = {
                                    count: 0
                                };
                                let Gl = 0, Zl = Qe.getOrCreateLatestSegment(rt, Wn), Hl = Zl.vertexLength;
                                for(let ql = 0; ql < Dl.length; ql++){
                                    const Ql = Dl[ql];
                                    for(let Kl = 1; Kl < Dl[ql].length; Kl += 2){
                                        const Dl = Ql[Kl - 1], ql = Ql[Kl];
                                        let $l = Rl[Dl] < Gl, Tc = Rl[ql] < Gl;
                                        Zl.vertexLength + (($l ? 1 : 0) + (Tc ? 1 : 0)) > Va.MAX_VERTEX_ARRAY_LENGTH && (Zl = Qe.createNewSegment(rt, Wn), Gl = Ul.count, $l = !0, Tc = !0, Hl = 0);
                                        const tu = El(Rl, Co, Ll, Ul, Dl, $l, Zl), lu = El(Rl, Co, Ll, Ul, ql, Tc, Zl);
                                        Wn.emplaceBack(Hl + tu - Gl, Hl + lu - Gl), Zl.primitiveLength++;
                                    }
                                }
                            }(Rl, Wn, Ul, Dl, Gl, Qe), rt.forceNewSegmentOnNextPrepare(), null == Rl || Rl.forceNewSegmentOnNextPrepare();
                        }
                        function El(Qe, rt, Wn, Co, Dl, Ll, Rl) {
                            if (Ll) {
                                const Ll = Co.count;
                                return Wn(rt[2 * Dl], rt[2 * Dl + 1]), Qe[Dl] = Co.count, Co.count++, Rl.vertexLength++, Ll;
                            }
                            return Qe[Dl];
                        }
                        class Tl {
                            constructor(Qe){
                                this.zoom = Qe.zoom, this.overscaling = Qe.overscaling, this.layers = Qe.layers, this.layerIds = this.layers.map((Qe)=>Qe.id), this.index = Qe.index, this.hasPattern = !1, this.patternFeatures = [], this.layoutVertexArray = new xa, this.indexArray = new za, this.indexArray2 = new Pa, this.programConfigurations = new so(Qe.layers, Qe.zoom), this.segments = new Va, this.segments2 = new Va, this.stateDependentLayerIds = this.layers.filter((Qe)=>Qe.isStateDependent()).map((Qe)=>Qe.id);
                            }
                            populate(Qe, rt, Wn) {
                                this.hasPattern = Jo("fill", this.layers, rt);
                                const Co = this.layers[0].layout.get("fill-sort-key"), Dl = !Co.isConstant(), Ll = [];
                                for (const { feature: Rl, id: Ul, index: Gl, sourceLayerIndex: Zl } of Qe){
                                    const Qe = this.layers[0]._featureFilter.needGeometry, Hl = ho(Rl, Qe);
                                    if (!this.layers[0]._featureFilter.filter(new fs(this.zoom), Hl, Wn)) continue;
                                    const ql = Dl ? Co.evaluate(Hl, {}, Wn, rt.availableImages) : void 0, Ql = {
                                        id: Ul,
                                        properties: Rl.properties,
                                        type: Rl.type,
                                        sourceLayerIndex: Zl,
                                        index: Gl,
                                        geometry: Qe ? Hl.geometry : co(Rl),
                                        patterns: {},
                                        sortKey: ql
                                    };
                                    Ll.push(Ql);
                                }
                                Dl && Ll.sort((Qe, rt)=>Qe.sortKey - rt.sortKey);
                                for (const Rl of Ll){
                                    const { geometry: Co, index: Dl, sourceLayerIndex: Ll } = Rl;
                                    if (this.hasPattern) {
                                        const Qe = Wo("fill", this.layers, Rl, this.zoom, rt);
                                        this.patternFeatures.push(Qe);
                                    } else this.addFeature(Rl, Co, Dl, Wn, {}, rt.subdivisionGranularity);
                                    rt.featureIndex.insert(Qe[Dl].feature, Co, Dl, Ll, this.index);
                                }
                            }
                            update(Qe, rt, Wn) {
                                this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(Qe, rt, this.stateDependentLayers, Wn);
                            }
                            addFeatures(Qe, rt, Wn) {
                                for (const Co of this.patternFeatures)this.addFeature(Co, Co.geometry, Co.index, rt, Wn, Qe.subdivisionGranularity);
                            }
                            isEmpty() {
                                return 0 === this.layoutVertexArray.length;
                            }
                            uploadPending() {
                                return !this.uploaded || this.programConfigurations.needsUpload;
                            }
                            upload(Qe) {
                                this.uploaded || (this.layoutVertexBuffer = Qe.createVertexBuffer(this.layoutVertexArray, qp), this.indexBuffer = Qe.createIndexBuffer(this.indexArray), this.indexBuffer2 = Qe.createIndexBuffer(this.indexArray2)), this.programConfigurations.upload(Qe), this.uploaded = !0;
                            }
                            destroy() {
                                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.indexBuffer2.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.segments2.destroy());
                            }
                            addFeature(Qe, rt, Wn, Co, Dl, Ll) {
                                for (const Rl of Ur(rt, 500)){
                                    const Qe = Pl(Rl, Co, Ll.fill.getGranularityForZoomLevel(Co.z)), rt = this.layoutVertexArray;
                                    Vl((Qe, Wn)=>{
                                        rt.emplaceBack(Qe, Wn);
                                    }, this.segments, this.layoutVertexArray, this.indexArray, Qe.verticesFlattened, Qe.indicesTriangles, this.segments2, this.indexArray2, Qe.indicesLineList);
                                }
                                this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, Qe, Wn, Dl, Co);
                            }
                        }
                        let Kp, Xp;
                        Zi("FillBucket", Tl, {
                            omit: [
                                "layers",
                                "patternFeatures"
                            ]
                        });
                        var Jp = {
                            get paint () {
                                return Xp = Xp || new Is({
                                    "fill-antialias": new _s(Ju.paint_fill["fill-antialias"]),
                                    "fill-opacity": new Ss(Ju.paint_fill["fill-opacity"]),
                                    "fill-color": new Ss(Ju.paint_fill["fill-color"]),
                                    "fill-outline-color": new Ss(Ju.paint_fill["fill-outline-color"]),
                                    "fill-translate": new _s(Ju.paint_fill["fill-translate"]),
                                    "fill-translate-anchor": new _s(Ju.paint_fill["fill-translate-anchor"]),
                                    "fill-pattern": new As(Ju.paint_fill["fill-pattern"])
                                });
                            },
                            get layout () {
                                return Kp = Kp || new Is({
                                    "fill-sort-key": new Ss(Ju.layout_fill["fill-sort-key"])
                                });
                            }
                        };
                        class Ol extends Ps {
                            constructor(Qe){
                                super(Qe, Jp);
                            }
                            recalculate(Qe, rt) {
                                super.recalculate(Qe, rt);
                                const Wn = this.paint._values["fill-outline-color"];
                                "constant" === Wn.value.kind && void 0 === Wn.value.value && (this.paint._values["fill-outline-color"] = this.paint._values["fill-color"]);
                            }
                            createBucket(Qe) {
                                return new Tl(Qe);
                            }
                            queryRadius() {
                                return zo(this.paint.get("fill-translate"));
                            }
                            queryIntersectsFeature({ queryGeometry: Qe, geometry: rt, transform: Wn, pixelsToTileUnits: Co }) {
                                return xo(Po(Qe, this.paint.get("fill-translate"), this.paint.get("fill-translate-anchor"), -Wn.bearingInRadians, Co), rt);
                            }
                            isTileClipped() {
                                return !0;
                            }
                        }
                        const $p = Es([
                            {
                                name: "a_pos",
                                components: 2,
                                type: "Int16"
                            },
                            {
                                name: "a_normal_ed",
                                components: 4,
                                type: "Int16"
                            }
                        ], 4), em = Es([
                            {
                                name: "a_centroid",
                                components: 2,
                                type: "Int16"
                            }
                        ], 4), { members: tm } = $p;
                        var im, nm, rm, sm, am, om, lm, cm = {};
                        function Yl() {
                            if (nm) return im;
                            nm = 1;
                            var Qe = s();
                            function e(Qe, rt, Wn, Co, Dl) {
                                this.properties = {}, this.extent = Wn, this.type = 0, this._pbf = Qe, this._geometry = -1, this._keys = Co, this._values = Dl, Qe.readFields(r, this, rt);
                            }
                            function r(Qe, rt, Wn) {
                                1 == Qe ? rt.id = Wn.readVarint() : 2 == Qe ? function(Qe, rt) {
                                    for(var Wn = Qe.readVarint() + Qe.pos; Qe.pos < Wn;){
                                        var Co = rt._keys[Qe.readVarint()], Dl = rt._values[Qe.readVarint()];
                                        rt.properties[Co] = Dl;
                                    }
                                }(Wn, rt) : 3 == Qe ? rt.type = Wn.readVarint() : 4 == Qe && (rt._geometry = Wn.pos);
                            }
                            function n(Qe) {
                                for(var rt, Wn, Co = 0, Dl = 0, Ll = Qe.length, Rl = Ll - 1; Dl < Ll; Rl = Dl++)Co += ((Wn = Qe[Rl]).x - (rt = Qe[Dl]).x) * (rt.y + Wn.y);
                                return Co;
                            }
                            return im = e, e.types = [
                                "Unknown",
                                "Point",
                                "LineString",
                                "Polygon"
                            ], e.prototype.loadGeometry = function() {
                                var rt = this._pbf;
                                rt.pos = this._geometry;
                                for(var Wn, Co = rt.readVarint() + rt.pos, Dl = 1, Ll = 0, Rl = 0, Ul = 0, Gl = []; rt.pos < Co;){
                                    if (Ll <= 0) {
                                        var Zl = rt.readVarint();
                                        Dl = 7 & Zl, Ll = Zl >> 3;
                                    }
                                    if (Ll--, 1 === Dl || 2 === Dl) Rl += rt.readSVarint(), Ul += rt.readSVarint(), 1 === Dl && (Wn && Gl.push(Wn), Wn = []), Wn.push(new Qe(Rl, Ul));
                                    else {
                                        if (7 !== Dl) throw new Error("unknown command " + Dl);
                                        Wn && Wn.push(Wn[0].clone());
                                    }
                                }
                                return Wn && Gl.push(Wn), Gl;
                            }, e.prototype.bbox = function() {
                                var Qe = this._pbf;
                                Qe.pos = this._geometry;
                                for(var rt = Qe.readVarint() + Qe.pos, Wn = 1, Co = 0, Dl = 0, Ll = 0, Rl = 1 / 0, Ul = -1 / 0, Gl = 1 / 0, Zl = -1 / 0; Qe.pos < rt;){
                                    if (Co <= 0) {
                                        var Hl = Qe.readVarint();
                                        Wn = 7 & Hl, Co = Hl >> 3;
                                    }
                                    if (Co--, 1 === Wn || 2 === Wn) (Dl += Qe.readSVarint()) < Rl && (Rl = Dl), Dl > Ul && (Ul = Dl), (Ll += Qe.readSVarint()) < Gl && (Gl = Ll), Ll > Zl && (Zl = Ll);
                                    else if (7 !== Wn) throw new Error("unknown command " + Wn);
                                }
                                return [
                                    Rl,
                                    Gl,
                                    Ul,
                                    Zl
                                ];
                            }, e.prototype.toGeoJSON = function(Qe, rt, Wn) {
                                var Co, Dl, Ll = this.extent * Math.pow(2, Wn), Rl = this.extent * Qe, Ul = this.extent * rt, Gl = this.loadGeometry(), Zl = e.types[this.type];
                                function p(Qe) {
                                    for(var rt = 0; rt < Qe.length; rt++){
                                        var Wn = Qe[rt];
                                        Qe[rt] = [
                                            360 * (Wn.x + Rl) / Ll - 180,
                                            360 / Math.PI * Math.atan(Math.exp((180 - 360 * (Wn.y + Ul) / Ll) * Math.PI / 180)) - 90
                                        ];
                                    }
                                }
                                switch(this.type){
                                    case 1:
                                        var Hl = [];
                                        for(Co = 0; Co < Gl.length; Co++)Hl[Co] = Gl[Co][0];
                                        p(Gl = Hl);
                                        break;
                                    case 2:
                                        for(Co = 0; Co < Gl.length; Co++)p(Gl[Co]);
                                        break;
                                    case 3:
                                        for(Gl = function(Qe) {
                                            var rt = Qe.length;
                                            if (rt <= 1) return [
                                                Qe
                                            ];
                                            for(var Wn, Co, Dl = [], Ll = 0; Ll < rt; Ll++){
                                                var Rl = n(Qe[Ll]);
                                                0 !== Rl && (void 0 === Co && (Co = Rl < 0), Co === Rl < 0 ? (Wn && Dl.push(Wn), Wn = [
                                                    Qe[Ll]
                                                ]) : Wn.push(Qe[Ll]));
                                            }
                                            return Wn && Dl.push(Wn), Dl;
                                        }(Gl), Co = 0; Co < Gl.length; Co++)for(Dl = 0; Dl < Gl[Co].length; Dl++)p(Gl[Co][Dl]);
                                }
                                1 === Gl.length ? Gl = Gl[0] : Zl = "Multi" + Zl;
                                var ql = {
                                    type: "Feature",
                                    geometry: {
                                        type: Zl,
                                        coordinates: Gl
                                    },
                                    properties: this.properties
                                };
                                return "id" in this && (ql.id = this.id), ql;
                            }, im;
                        }
                        function Jl() {
                            if (sm) return rm;
                            sm = 1;
                            var Qe = Yl();
                            function e(Qe, rt) {
                                this.version = 1, this.name = null, this.extent = 4096, this.length = 0, this._pbf = Qe, this._keys = [], this._values = [], this._features = [], Qe.readFields(r, this, rt), this.length = this._features.length;
                            }
                            function r(Qe, rt, Wn) {
                                15 === Qe ? rt.version = Wn.readVarint() : 1 === Qe ? rt.name = Wn.readString() : 5 === Qe ? rt.extent = Wn.readVarint() : 2 === Qe ? rt._features.push(Wn.pos) : 3 === Qe ? rt._keys.push(Wn.readString()) : 4 === Qe && rt._values.push(function(Qe) {
                                    for(var rt = null, Wn = Qe.readVarint() + Qe.pos; Qe.pos < Wn;){
                                        var Co = Qe.readVarint() >> 3;
                                        rt = 1 === Co ? Qe.readString() : 2 === Co ? Qe.readFloat() : 3 === Co ? Qe.readDouble() : 4 === Co ? Qe.readVarint64() : 5 === Co ? Qe.readVarint() : 6 === Co ? Qe.readSVarint() : 7 === Co ? Qe.readBoolean() : null;
                                    }
                                    return rt;
                                }(Wn));
                            }
                            return rm = e, e.prototype.feature = function(rt) {
                                if (rt < 0 || rt >= this._features.length) throw new Error("feature index out of bounds");
                                this._pbf.pos = this._features[rt];
                                var Wn = this._pbf.readVarint() + this._pbf.pos;
                                return new Qe(this._pbf, Wn, this.extent, this._keys, this._values);
                            }, rm;
                        }
                        function Wl() {
                            return lm || (lm = 1, cm.VectorTile = function() {
                                if (om) return am;
                                om = 1;
                                var Qe = Jl();
                                function e(rt, Wn, Co) {
                                    if (3 === rt) {
                                        var Dl = new Qe(Co, Co.readVarint() + Co.pos);
                                        Dl.length && (Wn[Dl.name] = Dl);
                                    }
                                }
                                return am = function(Qe, rt) {
                                    this.layers = Qe.readFields(e, {}, rt);
                                }, am;
                            }(), cm.VectorTileFeature = Yl(), cm.VectorTileLayer = Jl()), cm;
                        }
                        var um = r(Wl());
                        const hm = um.VectorTileFeature.types, dm = Math.pow(2, 13);
                        function ru(Qe, rt, Wn, Co, Dl, Ll, Rl, Ul) {
                            Qe.emplaceBack(rt, Wn, 2 * Math.floor(Co * dm) + Rl, Dl * dm * 2, Ll * dm * 2, Math.round(Ul));
                        }
                        class nu {
                            constructor(Qe){
                                this.zoom = Qe.zoom, this.overscaling = Qe.overscaling, this.layers = Qe.layers, this.layerIds = this.layers.map((Qe)=>Qe.id), this.index = Qe.index, this.hasPattern = !1, this.layoutVertexArray = new va, this.centroidVertexArray = new ma, this.indexArray = new za, this.programConfigurations = new so(Qe.layers, Qe.zoom), this.segments = new Va, this.stateDependentLayerIds = this.layers.filter((Qe)=>Qe.isStateDependent()).map((Qe)=>Qe.id);
                            }
                            populate(Qe, rt, Wn) {
                                this.features = [], this.hasPattern = Jo("fill-extrusion", this.layers, rt);
                                for (const { feature: Co, id: Dl, index: Ll, sourceLayerIndex: Rl } of Qe){
                                    const Qe = this.layers[0]._featureFilter.needGeometry, Ul = ho(Co, Qe);
                                    if (!this.layers[0]._featureFilter.filter(new fs(this.zoom), Ul, Wn)) continue;
                                    const Gl = {
                                        id: Dl,
                                        sourceLayerIndex: Rl,
                                        index: Ll,
                                        geometry: Qe ? Ul.geometry : co(Co),
                                        properties: Co.properties,
                                        type: Co.type,
                                        patterns: {}
                                    };
                                    this.hasPattern ? this.features.push(Wo("fill-extrusion", this.layers, Gl, this.zoom, rt)) : this.addFeature(Gl, Gl.geometry, Ll, Wn, {}, rt.subdivisionGranularity), rt.featureIndex.insert(Co, Gl.geometry, Ll, Rl, this.index, !0);
                                }
                            }
                            addFeatures(Qe, rt, Wn) {
                                for (const Co of this.features){
                                    const { geometry: Dl } = Co;
                                    this.addFeature(Co, Dl, Co.index, rt, Wn, Qe.subdivisionGranularity);
                                }
                            }
                            update(Qe, rt, Wn) {
                                this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(Qe, rt, this.stateDependentLayers, Wn);
                            }
                            isEmpty() {
                                return 0 === this.layoutVertexArray.length && 0 === this.centroidVertexArray.length;
                            }
                            uploadPending() {
                                return !this.uploaded || this.programConfigurations.needsUpload;
                            }
                            upload(Qe) {
                                this.uploaded || (this.layoutVertexBuffer = Qe.createVertexBuffer(this.layoutVertexArray, tm), this.centroidVertexBuffer = Qe.createVertexBuffer(this.centroidVertexArray, em.members, !0), this.indexBuffer = Qe.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(Qe), this.uploaded = !0;
                            }
                            destroy() {
                                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.centroidVertexBuffer.destroy());
                            }
                            addFeature(Qe, rt, Wn, Co, Dl, Ll) {
                                for (const Rl of Ur(rt, 500)){
                                    const rt = {
                                        x: 0,
                                        y: 0,
                                        sampleCount: 0
                                    }, Wn = this.layoutVertexArray.length;
                                    this.processPolygon(rt, Co, Qe, Rl, Ll);
                                    const Dl = this.layoutVertexArray.length - Wn, Ul = Math.floor(rt.x / rt.sampleCount), Gl = Math.floor(rt.y / rt.sampleCount);
                                    for(let Qe = 0; Qe < Dl; Qe++)this.centroidVertexArray.emplaceBack(Ul, Gl);
                                }
                                this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, Qe, Wn, Dl, Co);
                            }
                            processPolygon(Qe, rt, Wn, Co, Dl) {
                                if (Co.length < 1) return;
                                if (au(Co[0])) return;
                                for (const Hl of Co)0 !== Hl.length && iu(Qe, Hl);
                                const Ll = {
                                    segment: this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray)
                                }, Rl = Dl.fill.getGranularityForZoomLevel(rt.z), Ul = "Polygon" === hm[Wn.type];
                                for (const Hl of Co){
                                    if (0 === Hl.length) continue;
                                    if (au(Hl)) continue;
                                    const Qe = Cl(Hl, Rl, Ul);
                                    this._generateSideFaces(Qe, Ll);
                                }
                                if (!Ul) return;
                                const Gl = Pl(Co, rt, Rl, !1), Zl = this.layoutVertexArray;
                                Vl((Qe, rt)=>{
                                    ru(Zl, Qe, rt, 0, 0, 1, 1, 0);
                                }, this.segments, this.layoutVertexArray, this.indexArray, Gl.verticesFlattened, Gl.indicesTriangles);
                            }
                            _generateSideFaces(Qe, rt) {
                                let Wn = 0;
                                for(let Co = 1; Co < Qe.length; Co++){
                                    const Dl = Qe[Co], Ll = Qe[Co - 1];
                                    if (su(Dl, Ll)) continue;
                                    rt.segment.vertexLength + 4 > Va.MAX_VERTEX_ARRAY_LENGTH && (rt.segment = this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray));
                                    const Rl = Dl.sub(Ll)._perp()._unit(), Ul = Ll.dist(Dl);
                                    Wn + Ul > 32768 && (Wn = 0), ru(this.layoutVertexArray, Dl.x, Dl.y, Rl.x, Rl.y, 0, 0, Wn), ru(this.layoutVertexArray, Dl.x, Dl.y, Rl.x, Rl.y, 0, 1, Wn), Wn += Ul, ru(this.layoutVertexArray, Ll.x, Ll.y, Rl.x, Rl.y, 0, 0, Wn), ru(this.layoutVertexArray, Ll.x, Ll.y, Rl.x, Rl.y, 0, 1, Wn);
                                    const Gl = rt.segment.vertexLength;
                                    this.indexArray.emplaceBack(Gl, Gl + 2, Gl + 1), this.indexArray.emplaceBack(Gl + 1, Gl + 2, Gl + 3), rt.segment.vertexLength += 4, rt.segment.primitiveLength += 2;
                                }
                            }
                        }
                        function iu(Qe, rt) {
                            for(let Wn = 0; Wn < rt.length; Wn++){
                                const Co = rt[Wn];
                                Wn === rt.length - 1 && rt[0].x === Co.x && rt[0].y === Co.y || (Qe.x += Co.x, Qe.y += Co.y, Qe.sampleCount++);
                            }
                        }
                        function su(Qe, rt) {
                            return Qe.x === rt.x && (Qe.x < 0 || Qe.x > Kl) || Qe.y === rt.y && (Qe.y < 0 || Qe.y > Kl);
                        }
                        function au(Qe) {
                            return Qe.every((Qe)=>Qe.x < 0) || Qe.every((Qe)=>Qe.x > Kl) || Qe.every((Qe)=>Qe.y < 0) || Qe.every((Qe)=>Qe.y > Kl);
                        }
                        let pm;
                        Zi("FillExtrusionBucket", nu, {
                            omit: [
                                "layers",
                                "features"
                            ]
                        });
                        var mm = {
                            get paint () {
                                return pm = pm || new Is({
                                    "fill-extrusion-opacity": new _s(Ju["paint_fill-extrusion"]["fill-extrusion-opacity"]),
                                    "fill-extrusion-color": new Ss(Ju["paint_fill-extrusion"]["fill-extrusion-color"]),
                                    "fill-extrusion-translate": new _s(Ju["paint_fill-extrusion"]["fill-extrusion-translate"]),
                                    "fill-extrusion-translate-anchor": new _s(Ju["paint_fill-extrusion"]["fill-extrusion-translate-anchor"]),
                                    "fill-extrusion-pattern": new As(Ju["paint_fill-extrusion"]["fill-extrusion-pattern"]),
                                    "fill-extrusion-height": new Ss(Ju["paint_fill-extrusion"]["fill-extrusion-height"]),
                                    "fill-extrusion-base": new Ss(Ju["paint_fill-extrusion"]["fill-extrusion-base"]),
                                    "fill-extrusion-vertical-gradient": new _s(Ju["paint_fill-extrusion"]["fill-extrusion-vertical-gradient"])
                                });
                            }
                        };
                        class uu extends Ps {
                            constructor(Qe){
                                super(Qe, mm);
                            }
                            createBucket(Qe) {
                                return new nu(Qe);
                            }
                            queryRadius() {
                                return zo(this.paint.get("fill-extrusion-translate"));
                            }
                            is3D() {
                                return !0;
                            }
                            queryIntersectsFeature({ queryGeometry: Qe, feature: rt, featureState: Wn, geometry: Co, transform: Dl, pixelsToTileUnits: Rl, pixelPosMatrix: Ul }) {
                                const Gl = Po(Qe, this.paint.get("fill-extrusion-translate"), this.paint.get("fill-extrusion-translate-anchor"), -Dl.bearingInRadians, Rl), Zl = this.paint.get("fill-extrusion-height").evaluate(rt, Wn), Hl = this.paint.get("fill-extrusion-base").evaluate(rt, Wn), ql = function(Qe, rt) {
                                    const Wn = [];
                                    for (const Co of Qe){
                                        const Qe = [
                                            Co.x,
                                            Co.y,
                                            0,
                                            1
                                        ];
                                        _(Qe, Qe, rt), Wn.push(new Ll(Qe[0] / Qe[3], Qe[1] / Qe[3]));
                                    }
                                    return Wn;
                                }(Gl, Ul), Ql = function(Qe, rt, Wn, Co) {
                                    const Dl = [], Rl = [], Ul = Co[8] * rt, Gl = Co[9] * rt, Zl = Co[10] * rt, Hl = Co[11] * rt, ql = Co[8] * Wn, Ql = Co[9] * Wn, Kl = Co[10] * Wn, $l = Co[11] * Wn;
                                    for (const Tc of Qe){
                                        const Qe = [], rt = [];
                                        for (const Wn of Tc){
                                            const Dl = Wn.x, Rl = Wn.y, Tc = Co[0] * Dl + Co[4] * Rl + Co[12], tu = Co[1] * Dl + Co[5] * Rl + Co[13], lu = Co[2] * Dl + Co[6] * Rl + Co[14], du = Co[3] * Dl + Co[7] * Rl + Co[15], fu = lu + Zl, yu = du + Hl, Eu = Tc + ql, Tu = tu + Ql, Lu = lu + Kl, Zu = du + $l, Xu = new Ll((Tc + Ul) / yu, (tu + Gl) / yu);
                                            Xu.z = fu / yu, Qe.push(Xu);
                                            const Ju = new Ll(Eu / Zu, Tu / Zu);
                                            Ju.z = Lu / Zu, rt.push(Ju);
                                        }
                                        Dl.push(Qe), Rl.push(rt);
                                    }
                                    return [
                                        Dl,
                                        Rl
                                    ];
                                }(Co, Hl, Zl, Ul);
                                return function(Qe, rt, Wn) {
                                    let Co = 1 / 0;
                                    xo(Wn, rt) && (Co = hu(Wn, rt[0]));
                                    for(let Dl = 0; Dl < rt.length; Dl++){
                                        const Ll = rt[Dl], Rl = Qe[Dl];
                                        for(let Qe = 0; Qe < Ll.length - 1; Qe++){
                                            const rt = Ll[Qe], Dl = [
                                                rt,
                                                Ll[Qe + 1],
                                                Rl[Qe + 1],
                                                Rl[Qe],
                                                rt
                                            ];
                                            mo(Wn, Dl) && (Co = Math.min(Co, hu(Wn, Dl)));
                                        }
                                    }
                                    return Co !== 1 / 0 && Co;
                                }(Ql[0], Ql[1], ql);
                            }
                        }
                        function cu(Qe, rt) {
                            return Qe.x * rt.x + Qe.y * rt.y;
                        }
                        function hu(Qe, rt) {
                            if (1 === Qe.length) {
                                let Wn = 0;
                                const Co = rt[Wn++];
                                let Dl;
                                for(; !Dl || Co.equals(Dl);)if (Dl = rt[Wn++], !Dl) return 1 / 0;
                                for(; Wn < rt.length; Wn++){
                                    const Ll = rt[Wn], Rl = Qe[0], Ul = Dl.sub(Co), Gl = Ll.sub(Co), Zl = Rl.sub(Co), Hl = cu(Ul, Ul), ql = cu(Ul, Gl), Ql = cu(Gl, Gl), Kl = cu(Zl, Ul), $l = cu(Zl, Gl), Tc = Hl * Ql - ql * ql, tu = (Ql * Kl - ql * $l) / Tc, lu = (Hl * $l - ql * Kl) / Tc, du = Co.z * (1 - tu - lu) + Dl.z * tu + Ll.z * lu;
                                    if (isFinite(du)) return du;
                                }
                                return 1 / 0;
                            }
                            {
                                let Qe = 1 / 0;
                                for (const Wn of rt)Qe = Math.min(Qe, Wn.z);
                                return Qe;
                            }
                        }
                        const fm = Es([
                            {
                                name: "a_pos_normal",
                                components: 2,
                                type: "Int16"
                            },
                            {
                                name: "a_data",
                                components: 4,
                                type: "Uint8"
                            }
                        ], 4), { members: gm } = fm, Am = Es([
                            {
                                name: "a_uv_x",
                                components: 1,
                                type: "Float32"
                            },
                            {
                                name: "a_split_index",
                                components: 1,
                                type: "Float32"
                            }
                        ]), { members: ym } = Am, vm = um.VectorTileFeature.types, _m = Math.cos(Math.PI / 180 * 37.5), xm = Math.pow(2, 14) / .5;
                        class vu {
                            constructor(Qe){
                                this.zoom = Qe.zoom, this.overscaling = Qe.overscaling, this.layers = Qe.layers, this.layerIds = this.layers.map((Qe)=>Qe.id), this.index = Qe.index, this.hasPattern = !1, this.patternFeatures = [], this.lineClipsArray = [], this.gradients = {}, this.layers.forEach((Qe)=>{
                                    this.gradients[Qe.id] = {};
                                }), this.layoutVertexArray = new ba, this.layoutVertexArray2 = new wa, this.indexArray = new za, this.programConfigurations = new so(Qe.layers, Qe.zoom), this.segments = new Va, this.maxLineLength = 0, this.stateDependentLayerIds = this.layers.filter((Qe)=>Qe.isStateDependent()).map((Qe)=>Qe.id);
                            }
                            populate(Qe, rt, Wn) {
                                this.hasPattern = Jo("line", this.layers, rt);
                                const Co = this.layers[0].layout.get("line-sort-key"), Dl = !Co.isConstant(), Ll = [];
                                for (const { feature: Rl, id: Ul, index: Gl, sourceLayerIndex: Zl } of Qe){
                                    const Qe = this.layers[0]._featureFilter.needGeometry, rt = ho(Rl, Qe);
                                    if (!this.layers[0]._featureFilter.filter(new fs(this.zoom), rt, Wn)) continue;
                                    const Hl = Dl ? Co.evaluate(rt, {}, Wn) : void 0, ql = {
                                        id: Ul,
                                        properties: Rl.properties,
                                        type: Rl.type,
                                        sourceLayerIndex: Zl,
                                        index: Gl,
                                        geometry: Qe ? rt.geometry : co(Rl),
                                        patterns: {},
                                        sortKey: Hl
                                    };
                                    Ll.push(ql);
                                }
                                Dl && Ll.sort((Qe, rt)=>Qe.sortKey - rt.sortKey);
                                for (const Rl of Ll){
                                    const { geometry: Co, index: Dl, sourceLayerIndex: Ll } = Rl;
                                    if (this.hasPattern) {
                                        const Qe = Wo("line", this.layers, Rl, this.zoom, rt);
                                        this.patternFeatures.push(Qe);
                                    } else this.addFeature(Rl, Co, Dl, Wn, {}, rt.subdivisionGranularity);
                                    rt.featureIndex.insert(Qe[Dl].feature, Co, Dl, Ll, this.index);
                                }
                            }
                            update(Qe, rt, Wn) {
                                this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(Qe, rt, this.stateDependentLayers, Wn);
                            }
                            addFeatures(Qe, rt, Wn) {
                                for (const Co of this.patternFeatures)this.addFeature(Co, Co.geometry, Co.index, rt, Wn, Qe.subdivisionGranularity);
                            }
                            isEmpty() {
                                return 0 === this.layoutVertexArray.length;
                            }
                            uploadPending() {
                                return !this.uploaded || this.programConfigurations.needsUpload;
                            }
                            upload(Qe) {
                                this.uploaded || (0 !== this.layoutVertexArray2.length && (this.layoutVertexBuffer2 = Qe.createVertexBuffer(this.layoutVertexArray2, ym)), this.layoutVertexBuffer = Qe.createVertexBuffer(this.layoutVertexArray, gm), this.indexBuffer = Qe.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(Qe), this.uploaded = !0;
                            }
                            destroy() {
                                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
                            }
                            lineFeatureClips(Qe) {
                                if (Qe.properties && Object.prototype.hasOwnProperty.call(Qe.properties, "mapbox_clip_start") && Object.prototype.hasOwnProperty.call(Qe.properties, "mapbox_clip_end")) return {
                                    start: +Qe.properties.mapbox_clip_start,
                                    end: +Qe.properties.mapbox_clip_end
                                };
                            }
                            addFeature(Qe, rt, Wn, Co, Dl, Ll) {
                                const Rl = this.layers[0].layout, Ul = Rl.get("line-join").evaluate(Qe, {}), Gl = Rl.get("line-cap"), Zl = Rl.get("line-miter-limit"), Hl = Rl.get("line-round-limit");
                                this.lineClips = this.lineFeatureClips(Qe);
                                for (const ql of rt)this.addLine(ql, Qe, Ul, Gl, Zl, Hl, Co, Ll);
                                this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, Qe, Wn, Dl, Co);
                            }
                            addLine(Qe, rt, Wn, Co, Dl, Ll, Rl, Ul) {
                                if (this.distance = 0, this.scaledDistance = 0, this.totalDistance = 0, Qe = Cl(Qe, Rl ? Ul.line.getGranularityForZoomLevel(Rl.z) : 1), this.lineClips) {
                                    this.lineClipsArray.push(this.lineClips);
                                    for(let rt = 0; rt < Qe.length - 1; rt++)this.totalDistance += Qe[rt].dist(Qe[rt + 1]);
                                    this.updateScaledDistance(), this.maxLineLength = Math.max(this.maxLineLength, this.totalDistance);
                                }
                                const Gl = "Polygon" === vm[rt.type];
                                let Zl = Qe.length;
                                for(; Zl >= 2 && Qe[Zl - 1].equals(Qe[Zl - 2]);)Zl--;
                                let Hl = 0;
                                for(; Hl < Zl - 1 && Qe[Hl].equals(Qe[Hl + 1]);)Hl++;
                                if (Zl < (Gl ? 3 : 2)) return;
                                "bevel" === Wn && (Dl = 1.05);
                                const ql = this.overscaling <= 16 ? 15 * Kl / (512 * this.overscaling) : 0, Ql = this.segments.prepareSegment(10 * Zl, this.layoutVertexArray, this.indexArray);
                                let $l, Tc, tu, lu, du;
                                this.e1 = this.e2 = -1, Gl && ($l = Qe[Zl - 2], du = Qe[Hl].sub($l)._unit()._perp());
                                for(let Kl = Hl; Kl < Zl; Kl++){
                                    if (tu = Kl === Zl - 1 ? Gl ? Qe[Hl + 1] : void 0 : Qe[Kl + 1], tu && Qe[Kl].equals(tu)) continue;
                                    du && (lu = du), $l && (Tc = $l), $l = Qe[Kl], du = tu ? tu.sub($l)._unit()._perp() : lu, lu = lu || du;
                                    let rt = lu.add(du);
                                    0 === rt.x && 0 === rt.y || rt._unit();
                                    const Rl = lu.x * du.x + lu.y * du.y, Ul = rt.x * du.x + rt.y * du.y, fu = 0 !== Ul ? 1 / Ul : 1 / 0, yu = 2 * Math.sqrt(2 - 2 * Ul), Eu = Ul < _m && Tc && tu, Tu = lu.x * du.y - lu.y * du.x > 0;
                                    if (Eu && Kl > Hl) {
                                        const Qe = $l.dist(Tc);
                                        if (Qe > 2 * ql) {
                                            const rt = $l.sub($l.sub(Tc)._mult(ql / Qe)._round());
                                            this.updateDistance(Tc, rt), this.addCurrentVertex(rt, lu, 0, 0, Ql), Tc = rt;
                                        }
                                    }
                                    const Lu = Tc && tu;
                                    let Zu = Lu ? Wn : Gl ? "butt" : Co;
                                    if (Lu && "round" === Zu && (fu < Ll ? Zu = "miter" : fu <= 2 && (Zu = "fakeround")), "miter" === Zu && fu > Dl && (Zu = "bevel"), "bevel" === Zu && (fu > 2 && (Zu = "flipbevel"), fu < Dl && (Zu = "miter")), Tc && this.updateDistance(Tc, $l), "miter" === Zu) rt._mult(fu), this.addCurrentVertex($l, rt, 0, 0, Ql);
                                    else if ("flipbevel" === Zu) {
                                        if (fu > 100) rt = du.mult(-1);
                                        else {
                                            const Qe = fu * lu.add(du).mag() / lu.sub(du).mag();
                                            rt._perp()._mult(Qe * (Tu ? -1 : 1));
                                        }
                                        this.addCurrentVertex($l, rt, 0, 0, Ql), this.addCurrentVertex($l, rt.mult(-1), 0, 0, Ql);
                                    } else if ("bevel" === Zu || "fakeround" === Zu) {
                                        const Qe = -Math.sqrt(fu * fu - 1), rt = Tu ? Qe : 0, Wn = Tu ? 0 : Qe;
                                        if (Tc && this.addCurrentVertex($l, lu, rt, Wn, Ql), "fakeround" === Zu) {
                                            const Qe = Math.round(180 * yu / Math.PI / 20);
                                            for(let rt = 1; rt < Qe; rt++){
                                                let Wn = rt / Qe;
                                                if (.5 !== Wn) {
                                                    const Qe = Wn - .5;
                                                    Wn += Wn * Qe * (Wn - 1) * ((1.0904 + Rl * (Rl * (3.55645 - 1.43519 * Rl) - 3.2452)) * Qe * Qe + (.848013 + Rl * (.215638 * Rl - 1.06021)));
                                                }
                                                const Co = du.sub(lu)._mult(Wn)._add(lu)._unit()._mult(Tu ? -1 : 1);
                                                this.addHalfVertex($l, Co.x, Co.y, !1, Tu, 0, Ql);
                                            }
                                        }
                                        tu && this.addCurrentVertex($l, du, -rt, -Wn, Ql);
                                    } else if ("butt" === Zu) this.addCurrentVertex($l, rt, 0, 0, Ql);
                                    else if ("square" === Zu) {
                                        const Qe = Tc ? 1 : -1;
                                        this.addCurrentVertex($l, rt, Qe, Qe, Ql);
                                    } else "round" === Zu && (Tc && (this.addCurrentVertex($l, lu, 0, 0, Ql), this.addCurrentVertex($l, lu, 1, 1, Ql, !0)), tu && (this.addCurrentVertex($l, du, -1, -1, Ql, !0), this.addCurrentVertex($l, du, 0, 0, Ql)));
                                    if (Eu && Kl < Zl - 1) {
                                        const Qe = $l.dist(tu);
                                        if (Qe > 2 * ql) {
                                            const rt = $l.add(tu.sub($l)._mult(ql / Qe)._round());
                                            this.updateDistance($l, rt), this.addCurrentVertex(rt, du, 0, 0, Ql), $l = rt;
                                        }
                                    }
                                }
                            }
                            addCurrentVertex(Qe, rt, Wn, Co, Dl, Ll = !1) {
                                const Rl = rt.y * Co - rt.x, Ul = -rt.y - rt.x * Co;
                                this.addHalfVertex(Qe, rt.x + rt.y * Wn, rt.y - rt.x * Wn, Ll, !1, Wn, Dl), this.addHalfVertex(Qe, Rl, Ul, Ll, !0, -Co, Dl), this.distance > xm / 2 && 0 === this.totalDistance && (this.distance = 0, this.updateScaledDistance(), this.addCurrentVertex(Qe, rt, Wn, Co, Dl, Ll));
                            }
                            addHalfVertex({ x: Qe, y: rt }, Wn, Co, Dl, Ll, Rl, Ul) {
                                const Gl = .5 * (this.lineClips ? this.scaledDistance * (xm - 1) : this.scaledDistance);
                                this.layoutVertexArray.emplaceBack((Qe << 1) + (Dl ? 1 : 0), (rt << 1) + (Ll ? 1 : 0), Math.round(63 * Wn) + 128, Math.round(63 * Co) + 128, 1 + (0 === Rl ? 0 : Rl < 0 ? -1 : 1) | (63 & Gl) << 2, Gl >> 6), this.lineClips && this.layoutVertexArray2.emplaceBack((this.scaledDistance - this.lineClips.start) / (this.lineClips.end - this.lineClips.start), this.lineClipsArray.length);
                                const Zl = Ul.vertexLength++;
                                this.e1 >= 0 && this.e2 >= 0 && (this.indexArray.emplaceBack(this.e1, Zl, this.e2), Ul.primitiveLength++), Ll ? this.e2 = Zl : this.e1 = Zl;
                            }
                            updateScaledDistance() {
                                this.scaledDistance = this.lineClips ? this.lineClips.start + (this.lineClips.end - this.lineClips.start) * this.distance / this.totalDistance : this.distance;
                            }
                            updateDistance(Qe, rt) {
                                this.distance += Qe.dist(rt), this.updateScaledDistance();
                            }
                        }
                        let bm, wm;
                        Zi("LineBucket", vu, {
                            omit: [
                                "layers",
                                "patternFeatures"
                            ]
                        });
                        var Em = {
                            get paint () {
                                return wm = wm || new Is({
                                    "line-opacity": new Ss(Ju.paint_line["line-opacity"]),
                                    "line-color": new Ss(Ju.paint_line["line-color"]),
                                    "line-translate": new _s(Ju.paint_line["line-translate"]),
                                    "line-translate-anchor": new _s(Ju.paint_line["line-translate-anchor"]),
                                    "line-width": new Ss(Ju.paint_line["line-width"]),
                                    "line-gap-width": new Ss(Ju.paint_line["line-gap-width"]),
                                    "line-offset": new Ss(Ju.paint_line["line-offset"]),
                                    "line-blur": new Ss(Ju.paint_line["line-blur"]),
                                    "line-dasharray": new ks(Ju.paint_line["line-dasharray"]),
                                    "line-pattern": new As(Ju.paint_line["line-pattern"]),
                                    "line-gradient": new Ms(Ju.paint_line["line-gradient"])
                                });
                            },
                            get layout () {
                                return bm = bm || new Is({
                                    "line-cap": new _s(Ju.layout_line["line-cap"]),
                                    "line-join": new Ss(Ju.layout_line["line-join"]),
                                    "line-miter-limit": new _s(Ju.layout_line["line-miter-limit"]),
                                    "line-round-limit": new _s(Ju.layout_line["line-round-limit"]),
                                    "line-sort-key": new Ss(Ju.layout_line["line-sort-key"])
                                });
                            }
                        };
                        class Su extends Ss {
                            possiblyEvaluate(Qe, rt) {
                                return rt = new fs(Math.floor(rt.zoom), {
                                    now: rt.now,
                                    fadeDuration: rt.fadeDuration,
                                    zoomHistory: rt.zoomHistory,
                                    transition: rt.transition
                                }), super.possiblyEvaluate(Qe, rt);
                            }
                            evaluate(Qe, rt, Wn, Co) {
                                return rt = F({}, rt, {
                                    zoom: Math.floor(rt.zoom)
                                }), super.evaluate(Qe, rt, Wn, Co);
                            }
                        }
                        let Mm;
                        class ku extends Ps {
                            constructor(Qe){
                                super(Qe, Em), this.gradientVersion = 0, Mm || (Mm = new Su(Em.paint.properties["line-width"].specification), Mm.useIntegerZoom = !0);
                            }
                            _handleSpecialPaintPropertyUpdate(Qe) {
                                if ("line-gradient" === Qe) {
                                    const Qe = this.gradientExpression();
                                    this.stepInterpolant = !!function(Qe) {
                                        return void 0 !== Qe._styleExpression;
                                    }(Qe) && Qe._styleExpression.expression instanceof Ye, this.gradientVersion = (this.gradientVersion + 1) % Number.MAX_SAFE_INTEGER;
                                }
                            }
                            gradientExpression() {
                                return this._transitionablePaint._values["line-gradient"].value.expression;
                            }
                            recalculate(Qe, rt) {
                                super.recalculate(Qe, rt), this.paint._values["line-floorwidth"] = Mm.possiblyEvaluate(this._transitioningPaint._values["line-width"].value, Qe);
                            }
                            createBucket(Qe) {
                                return new vu(Qe);
                            }
                            queryRadius(Qe) {
                                const rt = Qe, Wn = Mu(Io("line-width", this, rt), Io("line-gap-width", this, rt)), Co = Io("line-offset", this, rt);
                                return Wn / 2 + Math.abs(Co) + zo(this.paint.get("line-translate"));
                            }
                            queryIntersectsFeature({ queryGeometry: Qe, feature: rt, featureState: Wn, geometry: Co, transform: Dl, pixelsToTileUnits: Rl }) {
                                const Ul = Po(Qe, this.paint.get("line-translate"), this.paint.get("line-translate-anchor"), -Dl.bearingInRadians, Rl), Gl = Rl / 2 * Mu(this.paint.get("line-width").evaluate(rt, Wn), this.paint.get("line-gap-width").evaluate(rt, Wn)), Zl = this.paint.get("line-offset").evaluate(rt, Wn);
                                return Zl && (Co = function(Qe, rt) {
                                    const Wn = [];
                                    for(let Co = 0; Co < Qe.length; Co++){
                                        const Dl = Qe[Co], Rl = [];
                                        for(let Qe = 0; Qe < Dl.length; Qe++){
                                            const Wn = Dl[Qe - 1], Co = Dl[Qe], Ul = Dl[Qe + 1], Gl = 0 === Qe ? new Ll(0, 0) : Co.sub(Wn)._unit()._perp(), Zl = Qe === Dl.length - 1 ? new Ll(0, 0) : Ul.sub(Co)._unit()._perp(), Hl = Gl._add(Zl)._unit(), ql = Hl.x * Zl.x + Hl.y * Zl.y;
                                            0 !== ql && Hl._mult(1 / ql), Rl.push(Hl._mult(rt)._add(Co));
                                        }
                                        Wn.push(Rl);
                                    }
                                    return Wn;
                                }(Co, Zl * Rl)), function(Qe, rt, Wn) {
                                    for(let Co = 0; Co < rt.length; Co++){
                                        const Dl = rt[Co];
                                        if (Qe.length >= 3) {
                                            for(let rt = 0; rt < Dl.length; rt++)if (ko(Qe, Dl[rt])) return !0;
                                        }
                                        if (vo(Qe, Dl, Wn)) return !0;
                                    }
                                    return !1;
                                }(Ul, Co, Gl);
                            }
                            isTileClipped() {
                                return !0;
                            }
                        }
                        function Mu(Qe, rt) {
                            return rt > 0 ? rt + 2 * Qe : Qe;
                        }
                        const Sm = Es([
                            {
                                name: "a_pos_offset",
                                components: 4,
                                type: "Int16"
                            },
                            {
                                name: "a_data",
                                components: 4,
                                type: "Uint16"
                            },
                            {
                                name: "a_pixeloffset",
                                components: 4,
                                type: "Int16"
                            }
                        ], 4), Tm = Es([
                            {
                                name: "a_projected_pos",
                                components: 3,
                                type: "Float32"
                            }
                        ], 4);
                        Es([
                            {
                                name: "a_fade_opacity",
                                components: 1,
                                type: "Uint32"
                            }
                        ], 4);
                        const Cm = Es([
                            {
                                name: "a_placed",
                                components: 2,
                                type: "Uint8"
                            },
                            {
                                name: "a_shift",
                                components: 2,
                                type: "Float32"
                            },
                            {
                                name: "a_box_real",
                                components: 2,
                                type: "Int16"
                            }
                        ]);
                        Es([
                            {
                                type: "Int16",
                                name: "anchorPointX"
                            },
                            {
                                type: "Int16",
                                name: "anchorPointY"
                            },
                            {
                                type: "Int16",
                                name: "x1"
                            },
                            {
                                type: "Int16",
                                name: "y1"
                            },
                            {
                                type: "Int16",
                                name: "x2"
                            },
                            {
                                type: "Int16",
                                name: "y2"
                            },
                            {
                                type: "Uint32",
                                name: "featureIndex"
                            },
                            {
                                type: "Uint16",
                                name: "sourceLayerIndex"
                            },
                            {
                                type: "Uint16",
                                name: "bucketIndex"
                            }
                        ]);
                        const km = Es([
                            {
                                name: "a_pos",
                                components: 2,
                                type: "Int16"
                            },
                            {
                                name: "a_anchor_pos",
                                components: 2,
                                type: "Int16"
                            },
                            {
                                name: "a_extrude",
                                components: 2,
                                type: "Int16"
                            }
                        ], 4), Im = Es([
                            {
                                name: "a_pos",
                                components: 2,
                                type: "Float32"
                            },
                            {
                                name: "a_radius",
                                components: 1,
                                type: "Float32"
                            },
                            {
                                name: "a_flags",
                                components: 2,
                                type: "Int16"
                            }
                        ], 4);
                        function Vu(Qe, rt, Wn) {
                            return Qe.sections.forEach((Qe)=>{
                                Qe.text = function(Qe, rt, Wn) {
                                    const Co = rt.layout.get("text-transform").evaluate(Wn, {});
                                    return "uppercase" === Co ? Qe = Qe.toLocaleUpperCase() : "lowercase" === Co && (Qe = Qe.toLocaleLowerCase()), _p.applyArabicShaping && (Qe = _p.applyArabicShaping(Qe)), Qe;
                                }(Qe.text, rt, Wn);
                            }), Qe;
                        }
                        Es([
                            {
                                name: "triangle",
                                components: 3,
                                type: "Uint16"
                            }
                        ]), Es([
                            {
                                type: "Int16",
                                name: "anchorX"
                            },
                            {
                                type: "Int16",
                                name: "anchorY"
                            },
                            {
                                type: "Uint16",
                                name: "glyphStartIndex"
                            },
                            {
                                type: "Uint16",
                                name: "numGlyphs"
                            },
                            {
                                type: "Uint32",
                                name: "vertexStartIndex"
                            },
                            {
                                type: "Uint32",
                                name: "lineStartIndex"
                            },
                            {
                                type: "Uint32",
                                name: "lineLength"
                            },
                            {
                                type: "Uint16",
                                name: "segment"
                            },
                            {
                                type: "Uint16",
                                name: "lowerSize"
                            },
                            {
                                type: "Uint16",
                                name: "upperSize"
                            },
                            {
                                type: "Float32",
                                name: "lineOffsetX"
                            },
                            {
                                type: "Float32",
                                name: "lineOffsetY"
                            },
                            {
                                type: "Uint8",
                                name: "writingMode"
                            },
                            {
                                type: "Uint8",
                                name: "placedOrientation"
                            },
                            {
                                type: "Uint8",
                                name: "hidden"
                            },
                            {
                                type: "Uint32",
                                name: "crossTileID"
                            },
                            {
                                type: "Int16",
                                name: "associatedIconIndex"
                            }
                        ]), Es([
                            {
                                type: "Int16",
                                name: "anchorX"
                            },
                            {
                                type: "Int16",
                                name: "anchorY"
                            },
                            {
                                type: "Int16",
                                name: "rightJustifiedTextSymbolIndex"
                            },
                            {
                                type: "Int16",
                                name: "centerJustifiedTextSymbolIndex"
                            },
                            {
                                type: "Int16",
                                name: "leftJustifiedTextSymbolIndex"
                            },
                            {
                                type: "Int16",
                                name: "verticalPlacedTextSymbolIndex"
                            },
                            {
                                type: "Int16",
                                name: "placedIconSymbolIndex"
                            },
                            {
                                type: "Int16",
                                name: "verticalPlacedIconSymbolIndex"
                            },
                            {
                                type: "Uint16",
                                name: "key"
                            },
                            {
                                type: "Uint16",
                                name: "textBoxStartIndex"
                            },
                            {
                                type: "Uint16",
                                name: "textBoxEndIndex"
                            },
                            {
                                type: "Uint16",
                                name: "verticalTextBoxStartIndex"
                            },
                            {
                                type: "Uint16",
                                name: "verticalTextBoxEndIndex"
                            },
                            {
                                type: "Uint16",
                                name: "iconBoxStartIndex"
                            },
                            {
                                type: "Uint16",
                                name: "iconBoxEndIndex"
                            },
                            {
                                type: "Uint16",
                                name: "verticalIconBoxStartIndex"
                            },
                            {
                                type: "Uint16",
                                name: "verticalIconBoxEndIndex"
                            },
                            {
                                type: "Uint16",
                                name: "featureIndex"
                            },
                            {
                                type: "Uint16",
                                name: "numHorizontalGlyphVertices"
                            },
                            {
                                type: "Uint16",
                                name: "numVerticalGlyphVertices"
                            },
                            {
                                type: "Uint16",
                                name: "numIconVertices"
                            },
                            {
                                type: "Uint16",
                                name: "numVerticalIconVertices"
                            },
                            {
                                type: "Uint16",
                                name: "useRuntimeCollisionCircles"
                            },
                            {
                                type: "Uint32",
                                name: "crossTileID"
                            },
                            {
                                type: "Float32",
                                name: "textBoxScale"
                            },
                            {
                                type: "Float32",
                                name: "collisionCircleDiameter"
                            },
                            {
                                type: "Uint16",
                                name: "textAnchorOffsetStartIndex"
                            },
                            {
                                type: "Uint16",
                                name: "textAnchorOffsetEndIndex"
                            }
                        ]), Es([
                            {
                                type: "Float32",
                                name: "offsetX"
                            }
                        ]), Es([
                            {
                                type: "Int16",
                                name: "x"
                            },
                            {
                                type: "Int16",
                                name: "y"
                            },
                            {
                                type: "Int16",
                                name: "tileUnitDistanceFromAnchor"
                            }
                        ]), Es([
                            {
                                type: "Uint16",
                                name: "textAnchor"
                            },
                            {
                                type: "Float32",
                                components: 2,
                                name: "textOffset"
                            }
                        ]);
                        const Dm = {
                            "!": "\uFE15",
                            "#": "\uFF03",
                            $: "\uFF04",
                            "%": "\uFF05",
                            "&": "\uFF06",
                            "(": "\uFE35",
                            ")": "\uFE36",
                            "*": "\uFF0A",
                            "+": "\uFF0B",
                            ",": "\uFE10",
                            "-": "\uFE32",
                            ".": "\u30FB",
                            "/": "\uFF0F",
                            ":": "\uFE13",
                            ";": "\uFE14",
                            "<": "\uFE3F",
                            "=": "\uFF1D",
                            ">": "\uFE40",
                            "?": "\uFE16",
                            "@": "\uFF20",
                            "[": "\uFE47",
                            "\\": "\uFF3C",
                            "]": "\uFE48",
                            "^": "\uFF3E",
                            _: "\uFE33",
                            "`": "\uFF40",
                            "{": "\uFE37",
                            "|": "\u2015",
                            "}": "\uFE38",
                            "~": "\uFF5E",
                            "\xa2": "\uFFE0",
                            "\xa3": "\uFFE1",
                            "\xa5": "\uFFE5",
                            "\xa6": "\uFFE4",
                            "\xac": "\uFFE2",
                            "\xaf": "\uFFE3",
                            "\u2013": "\uFE32",
                            "\u2014": "\uFE31",
                            "\u2018": "\uFE43",
                            "\u2019": "\uFE44",
                            "\u201C": "\uFE41",
                            "\u201D": "\uFE42",
                            "\u2026": "\uFE19",
                            "\u2027": "\u30FB",
                            "\u20A9": "\uFFE6",
                            "\u3001": "\uFE11",
                            "\u3002": "\uFE12",
                            "\u3008": "\uFE3F",
                            "\u3009": "\uFE40",
                            "\u300A": "\uFE3D",
                            "\u300B": "\uFE3E",
                            "\u300C": "\uFE41",
                            "\u300D": "\uFE42",
                            "\u300E": "\uFE43",
                            "\u300F": "\uFE44",
                            "\u3010": "\uFE3B",
                            "\u3011": "\uFE3C",
                            "\u3014": "\uFE39",
                            "\u3015": "\uFE3A",
                            "\u3016": "\uFE17",
                            "\u3017": "\uFE18",
                            "\uFF01": "\uFE15",
                            "\uFF08": "\uFE35",
                            "\uFF09": "\uFE36",
                            "\uFF0C": "\uFE10",
                            "\uFF0D": "\uFE32",
                            "\uFF0E": "\u30FB",
                            "\uFF1A": "\uFE13",
                            "\uFF1B": "\uFE14",
                            "\uFF1C": "\uFE3F",
                            "\uFF1E": "\uFE40",
                            "\uFF1F": "\uFE16",
                            "\uFF3B": "\uFE47",
                            "\uFF3D": "\uFE48",
                            "\uFF3F": "\uFE33",
                            "\uFF5B": "\uFE37",
                            "\uFF5C": "\u2015",
                            "\uFF5D": "\uFE38",
                            "\uFF5F": "\uFE35",
                            "\uFF60": "\uFE36",
                            "\uFF61": "\uFE12",
                            "\uFF62": "\uFE41",
                            "\uFF63": "\uFE42"
                        };
                        var Lm, Pm, zm, Nm = 24, Rm = {};
                        function Du() {
                            return Lm || (Lm = 1, Rm.read = function(Qe, rt, Wn, Co, Dl) {
                                var Ll, Rl, Ul = 8 * Dl - Co - 1, Gl = (1 << Ul) - 1, Zl = Gl >> 1, Hl = -7, ql = Wn ? Dl - 1 : 0, Ql = Wn ? -1 : 1, Kl = Qe[rt + ql];
                                for(ql += Ql, Ll = Kl & (1 << -Hl) - 1, Kl >>= -Hl, Hl += Ul; Hl > 0; Ll = 256 * Ll + Qe[rt + ql], ql += Ql, Hl -= 8);
                                for(Rl = Ll & (1 << -Hl) - 1, Ll >>= -Hl, Hl += Co; Hl > 0; Rl = 256 * Rl + Qe[rt + ql], ql += Ql, Hl -= 8);
                                if (0 === Ll) Ll = 1 - Zl;
                                else {
                                    if (Ll === Gl) return Rl ? NaN : 1 / 0 * (Kl ? -1 : 1);
                                    Rl += Math.pow(2, Co), Ll -= Zl;
                                }
                                return (Kl ? -1 : 1) * Rl * Math.pow(2, Ll - Co);
                            }, Rm.write = function(Qe, rt, Wn, Co, Dl, Ll) {
                                var Rl, Ul, Gl, Zl = 8 * Ll - Dl - 1, Hl = (1 << Zl) - 1, ql = Hl >> 1, Ql = 23 === Dl ? Math.pow(2, -24) - Math.pow(2, -77) : 0, Kl = Co ? 0 : Ll - 1, $l = Co ? 1 : -1, Tc = rt < 0 || 0 === rt && 1 / rt < 0 ? 1 : 0;
                                for(rt = Math.abs(rt), isNaN(rt) || rt === 1 / 0 ? (Ul = isNaN(rt) ? 1 : 0, Rl = Hl) : (Rl = Math.floor(Math.log(rt) / Math.LN2), rt * (Gl = Math.pow(2, -Rl)) < 1 && (Rl--, Gl *= 2), (rt += Rl + ql >= 1 ? Ql / Gl : Ql * Math.pow(2, 1 - ql)) * Gl >= 2 && (Rl++, Gl /= 2), Rl + ql >= Hl ? (Ul = 0, Rl = Hl) : Rl + ql >= 1 ? (Ul = (rt * Gl - 1) * Math.pow(2, Dl), Rl += ql) : (Ul = rt * Math.pow(2, ql - 1) * Math.pow(2, Dl), Rl = 0)); Dl >= 8; Qe[Wn + Kl] = 255 & Ul, Kl += $l, Ul /= 256, Dl -= 8);
                                for(Rl = Rl << Dl | Ul, Zl += Dl; Zl > 0; Qe[Wn + Kl] = 255 & Rl, Kl += $l, Rl /= 256, Zl -= 8);
                                Qe[Wn + Kl - $l] |= 128 * Tc;
                            }), Rm;
                        }
                        function Ru() {
                            if (zm) return Pm;
                            zm = 1, Pm = e;
                            var Qe = Du();
                            function e(Qe) {
                                this.buf = ArrayBuffer.isView && ArrayBuffer.isView(Qe) ? Qe : new Uint8Array(Qe || 0), this.pos = 0, this.type = 0, this.length = this.buf.length;
                            }
                            e.Varint = 0, e.Fixed64 = 1, e.Bytes = 2, e.Fixed32 = 5;
                            var rt = 4294967296, Wn = 1 / rt, Co = "undefined" == typeof TextDecoder ? null : new TextDecoder("utf-8");
                            function s(Qe) {
                                return Qe.type === e.Bytes ? Qe.readVarint() + Qe.pos : Qe.pos + 1;
                            }
                            function a(Qe, rt, Wn) {
                                return Wn ? 4294967296 * rt + (Qe >>> 0) : 4294967296 * (rt >>> 0) + (Qe >>> 0);
                            }
                            function o(Qe, rt, Wn) {
                                var Co = rt <= 16383 ? 1 : rt <= 2097151 ? 2 : rt <= 268435455 ? 3 : Math.floor(Math.log(rt) / (7 * Math.LN2));
                                Wn.realloc(Co);
                                for(var Dl = Wn.pos - 1; Dl >= Qe; Dl--)Wn.buf[Dl + Co] = Wn.buf[Dl];
                            }
                            function l(Qe, rt) {
                                for(var Wn = 0; Wn < Qe.length; Wn++)rt.writeVarint(Qe[Wn]);
                            }
                            function u(Qe, rt) {
                                for(var Wn = 0; Wn < Qe.length; Wn++)rt.writeSVarint(Qe[Wn]);
                            }
                            function c(Qe, rt) {
                                for(var Wn = 0; Wn < Qe.length; Wn++)rt.writeFloat(Qe[Wn]);
                            }
                            function h(Qe, rt) {
                                for(var Wn = 0; Wn < Qe.length; Wn++)rt.writeDouble(Qe[Wn]);
                            }
                            function p(Qe, rt) {
                                for(var Wn = 0; Wn < Qe.length; Wn++)rt.writeBoolean(Qe[Wn]);
                            }
                            function f(Qe, rt) {
                                for(var Wn = 0; Wn < Qe.length; Wn++)rt.writeFixed32(Qe[Wn]);
                            }
                            function d(Qe, rt) {
                                for(var Wn = 0; Wn < Qe.length; Wn++)rt.writeSFixed32(Qe[Wn]);
                            }
                            function y(Qe, rt) {
                                for(var Wn = 0; Wn < Qe.length; Wn++)rt.writeFixed64(Qe[Wn]);
                            }
                            function m(Qe, rt) {
                                for(var Wn = 0; Wn < Qe.length; Wn++)rt.writeSFixed64(Qe[Wn]);
                            }
                            function g(Qe, rt) {
                                return (Qe[rt] | Qe[rt + 1] << 8 | Qe[rt + 2] << 16) + 16777216 * Qe[rt + 3];
                            }
                            function x(Qe, rt, Wn) {
                                Qe[Wn] = rt, Qe[Wn + 1] = rt >>> 8, Qe[Wn + 2] = rt >>> 16, Qe[Wn + 3] = rt >>> 24;
                            }
                            function v(Qe, rt) {
                                return (Qe[rt] | Qe[rt + 1] << 8 | Qe[rt + 2] << 16) + (Qe[rt + 3] << 24);
                            }
                            return e.prototype = {
                                destroy: function() {
                                    this.buf = null;
                                },
                                readFields: function(Qe, rt, Wn) {
                                    for(Wn = Wn || this.length; this.pos < Wn;){
                                        var Co = this.readVarint(), Dl = Co >> 3, Ll = this.pos;
                                        this.type = 7 & Co, Qe(Dl, rt, this), this.pos === Ll && this.skip(Co);
                                    }
                                    return rt;
                                },
                                readMessage: function(Qe, rt) {
                                    return this.readFields(Qe, rt, this.readVarint() + this.pos);
                                },
                                readFixed32: function() {
                                    var Qe = g(this.buf, this.pos);
                                    return this.pos += 4, Qe;
                                },
                                readSFixed32: function() {
                                    var Qe = v(this.buf, this.pos);
                                    return this.pos += 4, Qe;
                                },
                                readFixed64: function() {
                                    var Qe = g(this.buf, this.pos) + g(this.buf, this.pos + 4) * rt;
                                    return this.pos += 8, Qe;
                                },
                                readSFixed64: function() {
                                    var Qe = g(this.buf, this.pos) + v(this.buf, this.pos + 4) * rt;
                                    return this.pos += 8, Qe;
                                },
                                readFloat: function() {
                                    var rt = Qe.read(this.buf, this.pos, !0, 23, 4);
                                    return this.pos += 4, rt;
                                },
                                readDouble: function() {
                                    var rt = Qe.read(this.buf, this.pos, !0, 52, 8);
                                    return this.pos += 8, rt;
                                },
                                readVarint: function(Qe) {
                                    var rt, Wn, Co = this.buf;
                                    return rt = 127 & (Wn = Co[this.pos++]), Wn < 128 ? rt : (rt |= (127 & (Wn = Co[this.pos++])) << 7, Wn < 128 ? rt : (rt |= (127 & (Wn = Co[this.pos++])) << 14, Wn < 128 ? rt : (rt |= (127 & (Wn = Co[this.pos++])) << 21, Wn < 128 ? rt : function(Qe, rt, Wn) {
                                        var Co, Dl, Ll = Wn.buf;
                                        if (Co = (112 & (Dl = Ll[Wn.pos++])) >> 4, Dl < 128) return a(Qe, Co, rt);
                                        if (Co |= (127 & (Dl = Ll[Wn.pos++])) << 3, Dl < 128) return a(Qe, Co, rt);
                                        if (Co |= (127 & (Dl = Ll[Wn.pos++])) << 10, Dl < 128) return a(Qe, Co, rt);
                                        if (Co |= (127 & (Dl = Ll[Wn.pos++])) << 17, Dl < 128) return a(Qe, Co, rt);
                                        if (Co |= (127 & (Dl = Ll[Wn.pos++])) << 24, Dl < 128) return a(Qe, Co, rt);
                                        if (Co |= (1 & (Dl = Ll[Wn.pos++])) << 31, Dl < 128) return a(Qe, Co, rt);
                                        throw new Error("Expected varint not more than 10 bytes");
                                    }(rt |= (15 & (Wn = Co[this.pos])) << 28, Qe, this))));
                                },
                                readVarint64: function() {
                                    return this.readVarint(!0);
                                },
                                readSVarint: function() {
                                    var Qe = this.readVarint();
                                    return Qe % 2 == 1 ? (Qe + 1) / -2 : Qe / 2;
                                },
                                readBoolean: function() {
                                    return Boolean(this.readVarint());
                                },
                                readString: function() {
                                    var Qe = this.readVarint() + this.pos, rt = this.pos;
                                    return this.pos = Qe, Qe - rt >= 12 && Co ? function(Qe, rt, Wn) {
                                        return Co.decode(Qe.subarray(rt, Wn));
                                    }(this.buf, rt, Qe) : function(Qe, rt, Wn) {
                                        for(var Co = "", Dl = rt; Dl < Wn;){
                                            var Ll, Rl, Ul, Gl = Qe[Dl], Zl = null, Hl = Gl > 239 ? 4 : Gl > 223 ? 3 : Gl > 191 ? 2 : 1;
                                            if (Dl + Hl > Wn) break;
                                            1 === Hl ? Gl < 128 && (Zl = Gl) : 2 === Hl ? 128 == (192 & (Ll = Qe[Dl + 1])) && (Zl = (31 & Gl) << 6 | 63 & Ll) <= 127 && (Zl = null) : 3 === Hl ? (Rl = Qe[Dl + 2], 128 == (192 & (Ll = Qe[Dl + 1])) && 128 == (192 & Rl) && ((Zl = (15 & Gl) << 12 | (63 & Ll) << 6 | 63 & Rl) <= 2047 || Zl >= 55296 && Zl <= 57343) && (Zl = null)) : 4 === Hl && (Rl = Qe[Dl + 2], Ul = Qe[Dl + 3], 128 == (192 & (Ll = Qe[Dl + 1])) && 128 == (192 & Rl) && 128 == (192 & Ul) && ((Zl = (15 & Gl) << 18 | (63 & Ll) << 12 | (63 & Rl) << 6 | 63 & Ul) <= 65535 || Zl >= 1114112) && (Zl = null)), null === Zl ? (Zl = 65533, Hl = 1) : Zl > 65535 && (Zl -= 65536, Co += String.fromCharCode(Zl >>> 10 & 1023 | 55296), Zl = 56320 | 1023 & Zl), Co += String.fromCharCode(Zl), Dl += Hl;
                                        }
                                        return Co;
                                    }(this.buf, rt, Qe);
                                },
                                readBytes: function() {
                                    var Qe = this.readVarint() + this.pos, rt = this.buf.subarray(this.pos, Qe);
                                    return this.pos = Qe, rt;
                                },
                                readPackedVarint: function(Qe, rt) {
                                    if (this.type !== e.Bytes) return Qe.push(this.readVarint(rt));
                                    var Wn = s(this);
                                    for(Qe = Qe || []; this.pos < Wn;)Qe.push(this.readVarint(rt));
                                    return Qe;
                                },
                                readPackedSVarint: function(Qe) {
                                    if (this.type !== e.Bytes) return Qe.push(this.readSVarint());
                                    var rt = s(this);
                                    for(Qe = Qe || []; this.pos < rt;)Qe.push(this.readSVarint());
                                    return Qe;
                                },
                                readPackedBoolean: function(Qe) {
                                    if (this.type !== e.Bytes) return Qe.push(this.readBoolean());
                                    var rt = s(this);
                                    for(Qe = Qe || []; this.pos < rt;)Qe.push(this.readBoolean());
                                    return Qe;
                                },
                                readPackedFloat: function(Qe) {
                                    if (this.type !== e.Bytes) return Qe.push(this.readFloat());
                                    var rt = s(this);
                                    for(Qe = Qe || []; this.pos < rt;)Qe.push(this.readFloat());
                                    return Qe;
                                },
                                readPackedDouble: function(Qe) {
                                    if (this.type !== e.Bytes) return Qe.push(this.readDouble());
                                    var rt = s(this);
                                    for(Qe = Qe || []; this.pos < rt;)Qe.push(this.readDouble());
                                    return Qe;
                                },
                                readPackedFixed32: function(Qe) {
                                    if (this.type !== e.Bytes) return Qe.push(this.readFixed32());
                                    var rt = s(this);
                                    for(Qe = Qe || []; this.pos < rt;)Qe.push(this.readFixed32());
                                    return Qe;
                                },
                                readPackedSFixed32: function(Qe) {
                                    if (this.type !== e.Bytes) return Qe.push(this.readSFixed32());
                                    var rt = s(this);
                                    for(Qe = Qe || []; this.pos < rt;)Qe.push(this.readSFixed32());
                                    return Qe;
                                },
                                readPackedFixed64: function(Qe) {
                                    if (this.type !== e.Bytes) return Qe.push(this.readFixed64());
                                    var rt = s(this);
                                    for(Qe = Qe || []; this.pos < rt;)Qe.push(this.readFixed64());
                                    return Qe;
                                },
                                readPackedSFixed64: function(Qe) {
                                    if (this.type !== e.Bytes) return Qe.push(this.readSFixed64());
                                    var rt = s(this);
                                    for(Qe = Qe || []; this.pos < rt;)Qe.push(this.readSFixed64());
                                    return Qe;
                                },
                                skip: function(Qe) {
                                    var rt = 7 & Qe;
                                    if (rt === e.Varint) for(; this.buf[this.pos++] > 127;);
                                    else if (rt === e.Bytes) this.pos = this.readVarint() + this.pos;
                                    else if (rt === e.Fixed32) this.pos += 4;
                                    else {
                                        if (rt !== e.Fixed64) throw new Error("Unimplemented type: " + rt);
                                        this.pos += 8;
                                    }
                                },
                                writeTag: function(Qe, rt) {
                                    this.writeVarint(Qe << 3 | rt);
                                },
                                realloc: function(Qe) {
                                    for(var rt = this.length || 16; rt < this.pos + Qe;)rt *= 2;
                                    if (rt !== this.length) {
                                        var Wn = new Uint8Array(rt);
                                        Wn.set(this.buf), this.buf = Wn, this.length = rt;
                                    }
                                },
                                finish: function() {
                                    return this.length = this.pos, this.pos = 0, this.buf.subarray(0, this.length);
                                },
                                writeFixed32: function(Qe) {
                                    this.realloc(4), x(this.buf, Qe, this.pos), this.pos += 4;
                                },
                                writeSFixed32: function(Qe) {
                                    this.realloc(4), x(this.buf, Qe, this.pos), this.pos += 4;
                                },
                                writeFixed64: function(Qe) {
                                    this.realloc(8), x(this.buf, -1 & Qe, this.pos), x(this.buf, Math.floor(Qe * Wn), this.pos + 4), this.pos += 8;
                                },
                                writeSFixed64: function(Qe) {
                                    this.realloc(8), x(this.buf, -1 & Qe, this.pos), x(this.buf, Math.floor(Qe * Wn), this.pos + 4), this.pos += 8;
                                },
                                writeVarint: function(Qe) {
                                    (Qe = +Qe || 0) > 268435455 || Qe < 0 ? function(Qe, rt) {
                                        var Wn, Co;
                                        if (Qe >= 0 ? (Wn = Qe % 4294967296 | 0, Co = Qe / 4294967296 | 0) : (Co = ~(-Qe / 4294967296), 4294967295 ^ (Wn = ~(-Qe % 4294967296)) ? Wn = Wn + 1 | 0 : (Wn = 0, Co = Co + 1 | 0)), Qe >= 0x10000000000000000 || Qe < -18446744073709552000) throw new Error("Given varint doesn't fit into 10 bytes");
                                        rt.realloc(10), function(Qe, rt, Wn) {
                                            Wn.buf[Wn.pos++] = 127 & Qe | 128, Qe >>>= 7, Wn.buf[Wn.pos++] = 127 & Qe | 128, Qe >>>= 7, Wn.buf[Wn.pos++] = 127 & Qe | 128, Qe >>>= 7, Wn.buf[Wn.pos++] = 127 & Qe | 128, Wn.buf[Wn.pos] = 127 & (Qe >>>= 7);
                                        }(Wn, 0, rt), function(Qe, rt) {
                                            var Wn = (7 & Qe) << 4;
                                            rt.buf[rt.pos++] |= Wn | ((Qe >>>= 3) ? 128 : 0), Qe && (rt.buf[rt.pos++] = 127 & Qe | ((Qe >>>= 7) ? 128 : 0), Qe && (rt.buf[rt.pos++] = 127 & Qe | ((Qe >>>= 7) ? 128 : 0), Qe && (rt.buf[rt.pos++] = 127 & Qe | ((Qe >>>= 7) ? 128 : 0), Qe && (rt.buf[rt.pos++] = 127 & Qe | ((Qe >>>= 7) ? 128 : 0), Qe && (rt.buf[rt.pos++] = 127 & Qe)))));
                                        }(Co, rt);
                                    }(Qe, this) : (this.realloc(4), this.buf[this.pos++] = 127 & Qe | (Qe > 127 ? 128 : 0), Qe <= 127 || (this.buf[this.pos++] = 127 & (Qe >>>= 7) | (Qe > 127 ? 128 : 0), Qe <= 127 || (this.buf[this.pos++] = 127 & (Qe >>>= 7) | (Qe > 127 ? 128 : 0), Qe <= 127 || (this.buf[this.pos++] = Qe >>> 7 & 127))));
                                },
                                writeSVarint: function(Qe) {
                                    this.writeVarint(Qe < 0 ? 2 * -Qe - 1 : 2 * Qe);
                                },
                                writeBoolean: function(Qe) {
                                    this.writeVarint(Boolean(Qe));
                                },
                                writeString: function(Qe) {
                                    Qe = String(Qe), this.realloc(4 * Qe.length), this.pos++;
                                    var rt = this.pos;
                                    this.pos = function(Qe, rt, Wn) {
                                        for(var Co, Dl, Ll = 0; Ll < rt.length; Ll++){
                                            if ((Co = rt.charCodeAt(Ll)) > 55295 && Co < 57344) {
                                                if (!Dl) {
                                                    Co > 56319 || Ll + 1 === rt.length ? (Qe[Wn++] = 239, Qe[Wn++] = 191, Qe[Wn++] = 189) : Dl = Co;
                                                    continue;
                                                }
                                                if (Co < 56320) {
                                                    Qe[Wn++] = 239, Qe[Wn++] = 191, Qe[Wn++] = 189, Dl = Co;
                                                    continue;
                                                }
                                                Co = Dl - 55296 << 10 | Co - 56320 | 65536, Dl = null;
                                            } else Dl && (Qe[Wn++] = 239, Qe[Wn++] = 191, Qe[Wn++] = 189, Dl = null);
                                            Co < 128 ? Qe[Wn++] = Co : (Co < 2048 ? Qe[Wn++] = Co >> 6 | 192 : (Co < 65536 ? Qe[Wn++] = Co >> 12 | 224 : (Qe[Wn++] = Co >> 18 | 240, Qe[Wn++] = Co >> 12 & 63 | 128), Qe[Wn++] = Co >> 6 & 63 | 128), Qe[Wn++] = 63 & Co | 128);
                                        }
                                        return Wn;
                                    }(this.buf, Qe, this.pos);
                                    var Wn = this.pos - rt;
                                    Wn >= 128 && o(rt, Wn, this), this.pos = rt - 1, this.writeVarint(Wn), this.pos += Wn;
                                },
                                writeFloat: function(rt) {
                                    this.realloc(4), Qe.write(this.buf, rt, this.pos, !0, 23, 4), this.pos += 4;
                                },
                                writeDouble: function(rt) {
                                    this.realloc(8), Qe.write(this.buf, rt, this.pos, !0, 52, 8), this.pos += 8;
                                },
                                writeBytes: function(Qe) {
                                    var rt = Qe.length;
                                    this.writeVarint(rt), this.realloc(rt);
                                    for(var Wn = 0; Wn < rt; Wn++)this.buf[this.pos++] = Qe[Wn];
                                },
                                writeRawMessage: function(Qe, rt) {
                                    this.pos++;
                                    var Wn = this.pos;
                                    Qe(rt, this);
                                    var Co = this.pos - Wn;
                                    Co >= 128 && o(Wn, Co, this), this.pos = Wn - 1, this.writeVarint(Co), this.pos += Co;
                                },
                                writeMessage: function(Qe, rt, Wn) {
                                    this.writeTag(Qe, e.Bytes), this.writeRawMessage(rt, Wn);
                                },
                                writePackedVarint: function(Qe, rt) {
                                    rt.length && this.writeMessage(Qe, l, rt);
                                },
                                writePackedSVarint: function(Qe, rt) {
                                    rt.length && this.writeMessage(Qe, u, rt);
                                },
                                writePackedBoolean: function(Qe, rt) {
                                    rt.length && this.writeMessage(Qe, p, rt);
                                },
                                writePackedFloat: function(Qe, rt) {
                                    rt.length && this.writeMessage(Qe, c, rt);
                                },
                                writePackedDouble: function(Qe, rt) {
                                    rt.length && this.writeMessage(Qe, h, rt);
                                },
                                writePackedFixed32: function(Qe, rt) {
                                    rt.length && this.writeMessage(Qe, f, rt);
                                },
                                writePackedSFixed32: function(Qe, rt) {
                                    rt.length && this.writeMessage(Qe, d, rt);
                                },
                                writePackedFixed64: function(Qe, rt) {
                                    rt.length && this.writeMessage(Qe, y, rt);
                                },
                                writePackedSFixed64: function(Qe, rt) {
                                    rt.length && this.writeMessage(Qe, m, rt);
                                },
                                writeBytesField: function(Qe, rt) {
                                    this.writeTag(Qe, e.Bytes), this.writeBytes(rt);
                                },
                                writeFixed32Field: function(Qe, rt) {
                                    this.writeTag(Qe, e.Fixed32), this.writeFixed32(rt);
                                },
                                writeSFixed32Field: function(Qe, rt) {
                                    this.writeTag(Qe, e.Fixed32), this.writeSFixed32(rt);
                                },
                                writeFixed64Field: function(Qe, rt) {
                                    this.writeTag(Qe, e.Fixed64), this.writeFixed64(rt);
                                },
                                writeSFixed64Field: function(Qe, rt) {
                                    this.writeTag(Qe, e.Fixed64), this.writeSFixed64(rt);
                                },
                                writeVarintField: function(Qe, rt) {
                                    this.writeTag(Qe, e.Varint), this.writeVarint(rt);
                                },
                                writeSVarintField: function(Qe, rt) {
                                    this.writeTag(Qe, e.Varint), this.writeSVarint(rt);
                                },
                                writeStringField: function(Qe, rt) {
                                    this.writeTag(Qe, e.Bytes), this.writeString(rt);
                                },
                                writeFloatField: function(Qe, rt) {
                                    this.writeTag(Qe, e.Fixed32), this.writeFloat(rt);
                                },
                                writeDoubleField: function(Qe, rt) {
                                    this.writeTag(Qe, e.Fixed64), this.writeDouble(rt);
                                },
                                writeBooleanField: function(Qe, rt) {
                                    this.writeVarintField(Qe, Boolean(rt));
                                }
                            }, Pm;
                        }
                        var Bm = r(Ru());
                        const Om = 3;
                        function Uu(Qe, rt, Wn) {
                            1 === Qe && Wn.readMessage(qu, rt);
                        }
                        function qu(Qe, rt, Wn) {
                            if (3 === Qe) {
                                const { id: Qe, bitmap: Co, width: Dl, height: Ll, left: Rl, top: Ul, advance: Gl } = Wn.readMessage(Gu, {});
                                rt.push({
                                    id: Qe,
                                    bitmap: new jo({
                                        width: Dl + 2 * Om,
                                        height: Ll + 2 * Om
                                    }, Co),
                                    metrics: {
                                        width: Dl,
                                        height: Ll,
                                        left: Rl,
                                        top: Ul,
                                        advance: Gl
                                    }
                                });
                            }
                        }
                        function Gu(Qe, rt, Wn) {
                            1 === Qe ? rt.id = Wn.readVarint() : 2 === Qe ? rt.bitmap = Wn.readBytes() : 3 === Qe ? rt.width = Wn.readVarint() : 4 === Qe ? rt.height = Wn.readVarint() : 5 === Qe ? rt.left = Wn.readSVarint() : 6 === Qe ? rt.top = Wn.readSVarint() : 7 === Qe && (rt.advance = Wn.readVarint());
                        }
                        const Fm = Om;
                        function Ku(Qe) {
                            let rt = 0, Wn = 0;
                            for (const Rl of Qe)rt += Rl.w * Rl.h, Wn = Math.max(Wn, Rl.w);
                            Qe.sort((Qe, rt)=>rt.h - Qe.h);
                            const Co = [
                                {
                                    x: 0,
                                    y: 0,
                                    w: Math.max(Math.ceil(Math.sqrt(rt / .95)), Wn),
                                    h: 1 / 0
                                }
                            ];
                            let Dl = 0, Ll = 0;
                            for (const Rl of Qe)for(let Qe = Co.length - 1; Qe >= 0; Qe--){
                                const rt = Co[Qe];
                                if (!(Rl.w > rt.w || Rl.h > rt.h)) {
                                    if (Rl.x = rt.x, Rl.y = rt.y, Ll = Math.max(Ll, Rl.y + Rl.h), Dl = Math.max(Dl, Rl.x + Rl.w), Rl.w === rt.w && Rl.h === rt.h) {
                                        const rt = Co.pop();
                                        Qe < Co.length && (Co[Qe] = rt);
                                    } else Rl.h === rt.h ? (rt.x += Rl.w, rt.w -= Rl.w) : Rl.w === rt.w ? (rt.y += Rl.h, rt.h -= Rl.h) : (Co.push({
                                        x: rt.x + Rl.w,
                                        y: rt.y,
                                        w: rt.w - Rl.w,
                                        h: Rl.h
                                    }), rt.y += Rl.h, rt.h -= Rl.h);
                                    break;
                                }
                            }
                            return {
                                w: Dl,
                                h: Ll,
                                fill: rt / (Dl * Ll) || 0
                            };
                        }
                        const jm = 1;
                        class Hu {
                            constructor(Qe, { pixelRatio: rt, version: Wn, stretchX: Co, stretchY: Dl, content: Ll, textFitWidth: Rl, textFitHeight: Ul }){
                                this.paddedRect = Qe, this.pixelRatio = rt, this.stretchX = Co, this.stretchY = Dl, this.content = Ll, this.version = Wn, this.textFitWidth = Rl, this.textFitHeight = Ul;
                            }
                            get tl() {
                                return [
                                    this.paddedRect.x + jm,
                                    this.paddedRect.y + jm
                                ];
                            }
                            get br() {
                                return [
                                    this.paddedRect.x + this.paddedRect.w - jm,
                                    this.paddedRect.y + this.paddedRect.h - jm
                                ];
                            }
                            get tlbr() {
                                return this.tl.concat(this.br);
                            }
                            get displaySize() {
                                return [
                                    (this.paddedRect.w - 2 * jm) / this.pixelRatio,
                                    (this.paddedRect.h - 2 * jm) / this.pixelRatio
                                ];
                            }
                        }
                        class Yu {
                            constructor(Qe, rt){
                                const Wn = {}, Co = {};
                                this.haveRenderCallbacks = [];
                                const Dl = [];
                                this.addImages(Qe, Wn, Dl), this.addImages(rt, Co, Dl);
                                const { w: Ll, h: Rl } = Ku(Dl), Ul = new No({
                                    width: Ll || 1,
                                    height: Rl || 1
                                });
                                for(const Gl in Qe){
                                    const rt = Qe[Gl], Co = Wn[Gl].paddedRect;
                                    No.copy(rt.data, Ul, {
                                        x: 0,
                                        y: 0
                                    }, {
                                        x: Co.x + jm,
                                        y: Co.y + jm
                                    }, rt.data);
                                }
                                for(const Gl in rt){
                                    const Qe = rt[Gl], Wn = Co[Gl].paddedRect, Dl = Wn.x + jm, Ll = Wn.y + jm, Rl = Qe.data.width, Zl = Qe.data.height;
                                    No.copy(Qe.data, Ul, {
                                        x: 0,
                                        y: 0
                                    }, {
                                        x: Dl,
                                        y: Ll
                                    }, Qe.data), No.copy(Qe.data, Ul, {
                                        x: 0,
                                        y: Zl - 1
                                    }, {
                                        x: Dl,
                                        y: Ll - 1
                                    }, {
                                        width: Rl,
                                        height: 1
                                    }), No.copy(Qe.data, Ul, {
                                        x: 0,
                                        y: 0
                                    }, {
                                        x: Dl,
                                        y: Ll + Zl
                                    }, {
                                        width: Rl,
                                        height: 1
                                    }), No.copy(Qe.data, Ul, {
                                        x: Rl - 1,
                                        y: 0
                                    }, {
                                        x: Dl - 1,
                                        y: Ll
                                    }, {
                                        width: 1,
                                        height: Zl
                                    }), No.copy(Qe.data, Ul, {
                                        x: 0,
                                        y: 0
                                    }, {
                                        x: Dl + Rl,
                                        y: Ll
                                    }, {
                                        width: 1,
                                        height: Zl
                                    });
                                }
                                this.image = Ul, this.iconPositions = Wn, this.patternPositions = Co;
                            }
                            addImages(Qe, rt, Wn) {
                                for(const Co in Qe){
                                    const Dl = Qe[Co], Ll = {
                                        x: 0,
                                        y: 0,
                                        w: Dl.data.width + 2 * jm,
                                        h: Dl.data.height + 2 * jm
                                    };
                                    Wn.push(Ll), rt[Co] = new Hu(Ll, Dl), Dl.hasRenderCallback && this.haveRenderCallbacks.push(Co);
                                }
                            }
                            patchUpdatedImages(Qe, rt) {
                                Qe.dispatchRenderCallbacks(this.haveRenderCallbacks);
                                for(const Wn in Qe.updatedImages)this.patchUpdatedImage(this.iconPositions[Wn], Qe.getImage(Wn), rt), this.patchUpdatedImage(this.patternPositions[Wn], Qe.getImage(Wn), rt);
                            }
                            patchUpdatedImage(Qe, rt, Wn) {
                                if (!Qe || !rt) return;
                                if (Qe.version === rt.version) return;
                                Qe.version = rt.version;
                                const [Co, Dl] = Qe.tl;
                                Wn.update(rt.data, void 0, {
                                    x: Co,
                                    y: Dl
                                });
                            }
                        }
                        var Um;
                        Zi("ImagePosition", Hu), Zi("ImageAtlas", Yu), Qe.ah = void 0, (Um = Qe.ah || (Qe.ah = {}))[Um.none = 0] = "none", Um[Um.horizontal = 1] = "horizontal", Um[Um.vertical = 2] = "vertical", Um[Um.horizontalOnly = 3] = "horizontalOnly";
                        const Vm = -17;
                        class Qu {
                            constructor(){
                                this.scale = 1, this.fontStack = "", this.imageName = null, this.verticalAlign = "bottom";
                            }
                            static forText(Qe, rt, Wn) {
                                const Co = new Qu;
                                return Co.scale = Qe || 1, Co.fontStack = rt, Co.verticalAlign = Wn || "bottom", Co;
                            }
                            static forImage(Qe, rt) {
                                const Wn = new Qu;
                                return Wn.imageName = Qe, Wn.verticalAlign = rt || "bottom", Wn;
                            }
                        }
                        class tc {
                            constructor(){
                                this.text = "", this.sectionIndex = [], this.sections = [], this.imageSectionID = null;
                            }
                            static fromFeature(Qe, rt) {
                                const Wn = new tc;
                                for(let Co = 0; Co < Qe.sections.length; Co++){
                                    const Dl = Qe.sections[Co];
                                    Dl.image ? Wn.addImageSection(Dl) : Wn.addTextSection(Dl, rt);
                                }
                                return Wn;
                            }
                            length() {
                                return this.text.length;
                            }
                            getSection(Qe) {
                                return this.sections[this.sectionIndex[Qe]];
                            }
                            getSectionIndex(Qe) {
                                return this.sectionIndex[Qe];
                            }
                            getCharCode(Qe) {
                                return this.text.charCodeAt(Qe);
                            }
                            verticalizePunctuation() {
                                this.text = function(Qe) {
                                    let rt = "";
                                    for(let Wn = 0; Wn < Qe.length; Wn++){
                                        const Co = Qe.charCodeAt(Wn + 1) || null, Dl = Qe.charCodeAt(Wn - 1) || null;
                                        rt += Co && os(Co) && !Dm[Qe[Wn + 1]] || Dl && os(Dl) && !Dm[Qe[Wn - 1]] || !Dm[Qe[Wn]] ? Qe[Wn] : Dm[Qe[Wn]];
                                    }
                                    return rt;
                                }(this.text);
                            }
                            trim() {
                                let Qe = 0;
                                for(let Wn = 0; Wn < this.text.length && Gm[this.text.charCodeAt(Wn)]; Wn++)Qe++;
                                let rt = this.text.length;
                                for(let Wn = this.text.length - 1; Wn >= 0 && Wn >= Qe && Gm[this.text.charCodeAt(Wn)]; Wn--)rt--;
                                this.text = this.text.substring(Qe, rt), this.sectionIndex = this.sectionIndex.slice(Qe, rt);
                            }
                            substring(Qe, rt) {
                                const Wn = new tc;
                                return Wn.text = this.text.substring(Qe, rt), Wn.sectionIndex = this.sectionIndex.slice(Qe, rt), Wn.sections = this.sections, Wn;
                            }
                            toString() {
                                return this.text;
                            }
                            getMaxScale() {
                                return this.sectionIndex.reduce((Qe, rt)=>Math.max(Qe, this.sections[rt].scale), 0);
                            }
                            getMaxImageSize(Qe) {
                                let rt = 0, Wn = 0;
                                for(let Co = 0; Co < this.length(); Co++){
                                    const Dl = this.getSection(Co);
                                    if (Dl.imageName) {
                                        const Co = Qe[Dl.imageName];
                                        if (!Co) continue;
                                        const Ll = Co.displaySize;
                                        rt = Math.max(rt, Ll[0]), Wn = Math.max(Wn, Ll[1]);
                                    }
                                }
                                return {
                                    maxImageWidth: rt,
                                    maxImageHeight: Wn
                                };
                            }
                            addTextSection(Qe, rt) {
                                this.text += Qe.text, this.sections.push(Qu.forText(Qe.scale, Qe.fontStack || rt, Qe.verticalAlign));
                                const Wn = this.sections.length - 1;
                                for(let Co = 0; Co < Qe.text.length; ++Co)this.sectionIndex.push(Wn);
                            }
                            addImageSection(Qe) {
                                const rt = Qe.image ? Qe.image.name : "";
                                if (0 === rt.length) return void j("Can't add FormattedSection with an empty image.");
                                const Wn = this.getNextImageSectionCharCode();
                                Wn ? (this.text += String.fromCharCode(Wn), this.sections.push(Qu.forImage(rt, Qe.verticalAlign)), this.sectionIndex.push(this.sections.length - 1)) : j("Reached maximum number of images 6401");
                            }
                            getNextImageSectionCharCode() {
                                return this.imageSectionID ? this.imageSectionID >= 63743 ? null : ++this.imageSectionID : (this.imageSectionID = 57344, this.imageSectionID);
                            }
                        }
                        function ec(rt, Wn, Co, Dl, Ll, Rl, Ul, Gl, Zl, Hl, ql, Ql, Kl, $l, Tc) {
                            const tu = tc.fromFeature(rt, Ll);
                            let lu;
                            Ql === Qe.ah.vertical && tu.verticalizePunctuation();
                            const { processBidirectionalText: du, processStyledBidirectionalText: fu } = _p;
                            if (du && 1 === tu.sections.length) {
                                lu = [];
                                const Qe = du(tu.toString(), cc(tu, Hl, Rl, Wn, Dl, $l));
                                for (const rt of Qe){
                                    const Qe = new tc;
                                    Qe.text = rt, Qe.sections = tu.sections;
                                    for(let Wn = 0; Wn < rt.length; Wn++)Qe.sectionIndex.push(0);
                                    lu.push(Qe);
                                }
                            } else if (fu) {
                                lu = [];
                                const Qe = fu(tu.text, tu.sectionIndex, cc(tu, Hl, Rl, Wn, Dl, $l));
                                for (const rt of Qe){
                                    const Qe = new tc;
                                    Qe.text = rt[0], Qe.sectionIndex = rt[1], Qe.sections = tu.sections, lu.push(Qe);
                                }
                            } else lu = function(Qe, rt) {
                                const Wn = [], Co = Qe.text;
                                let Dl = 0;
                                for (const Ll of rt)Wn.push(Qe.substring(Dl, Ll)), Dl = Ll;
                                return Dl < Co.length && Wn.push(Qe.substring(Dl, Co.length)), Wn;
                            }(tu, cc(tu, Hl, Rl, Wn, Dl, $l));
                            const yu = [], Eu = {
                                positionedLines: yu,
                                text: tu.toString(),
                                top: ql[1],
                                bottom: ql[1],
                                left: ql[0],
                                right: ql[0],
                                writingMode: Ql,
                                iconsInText: !1,
                                verticalizable: !1
                            };
                            return function(Qe, rt, Wn, Co, Dl, Ll, Rl, Ul, Gl, Zl, Hl, ql) {
                                let Ql = 0, Kl = 0, $l = 0, Tc = 0;
                                const tu = "right" === Ul ? 1 : "left" === Ul ? 0 : .5, lu = Nm / ql;
                                let du = 0;
                                for (const Eu of Dl){
                                    Eu.trim();
                                    const Dl = Eu.getMaxScale(), Rl = {
                                        positionedGlyphs: [],
                                        lineOffset: 0
                                    };
                                    Qe.positionedLines[du] = Rl;
                                    const Ul = Rl.positionedGlyphs;
                                    let ql = 0;
                                    if (!Eu.length()) {
                                        Kl += Ll, ++du;
                                        continue;
                                    }
                                    const fu = pc(Co, Eu, lu);
                                    for(let Ll = 0; Ll < Eu.length(); Ll++){
                                        const Rl = Eu.getSection(Ll), $l = Eu.getSectionIndex(Ll), Tc = Eu.getCharCode(Ll), tu = dc(Gl, Hl, Tc);
                                        let du;
                                        if (Rl.imageName) {
                                            if (Qe.iconsInText = !0, Rl.scale = Rl.scale * lu, du = mc(Rl, tu, Dl, fu, Co), !du) continue;
                                            ql = Math.max(ql, du.imageOffset);
                                        } else if (du = yc(Rl, Tc, tu, fu, rt, Wn), !du) continue;
                                        const { rect: yu, metrics: Tu, baselineOffset: Lu } = du;
                                        Ul.push({
                                            glyph: Tc,
                                            imageName: Rl.imageName,
                                            x: Ql,
                                            y: Kl + Lu + Vm,
                                            vertical: tu,
                                            scale: Rl.scale,
                                            fontStack: Rl.fontStack,
                                            sectionIndex: $l,
                                            metrics: Tu,
                                            rect: yu
                                        }), tu ? (Qe.verticalizable = !0, Ql += (Rl.imageName ? Tu.advance : Nm) * Rl.scale + Zl) : Ql += Tu.advance * Rl.scale + Zl;
                                    }
                                    0 !== Ul.length && ($l = Math.max(Ql - Zl, $l), gc(Ul, 0, Ul.length - 1, tu)), Ql = 0, Rl.lineOffset = Math.max(ql, (Dl - 1) * Nm);
                                    const yu = Ll * Dl + ql;
                                    Kl += yu, Tc = Math.max(yu, Tc), ++du;
                                }
                                const { horizontalAlign: fu, verticalAlign: yu } = hc(Rl);
                                (function(Qe, rt, Wn, Co, Dl, Ll, Rl, Ul, Gl) {
                                    const Zl = (rt - Wn) * Dl;
                                    let Hl = 0;
                                    Hl = Ll !== Rl ? -Ul * Co - Vm : -Co * Gl * Rl + .5 * Rl;
                                    for (const ql of Qe)for (const Qe of ql.positionedGlyphs)Qe.x += Zl, Qe.y += Hl;
                                })(Qe.positionedLines, tu, fu, yu, $l, Tc, Ll, Kl, Dl.length), Qe.top += -yu * Kl, Qe.bottom = Qe.top + Kl, Qe.left += -fu * $l, Qe.right = Qe.left + $l;
                            }(Eu, Wn, Co, Dl, lu, Ul, Gl, Zl, Ql, Hl, Kl, Tc), !function(Qe) {
                                for (const rt of Qe)if (0 !== rt.positionedGlyphs.length) return !1;
                                return !0;
                            }(yu) && Eu;
                        }
                        const Gm = {
                            9: !0,
                            10: !0,
                            11: !0,
                            12: !0,
                            13: !0,
                            32: !0
                        }, Zm = {
                            10: !0,
                            32: !0,
                            38: !0,
                            41: !0,
                            43: !0,
                            45: !0,
                            47: !0,
                            173: !0,
                            183: !0,
                            8203: !0,
                            8208: !0,
                            8211: !0,
                            8231: !0
                        }, Hm = {
                            40: !0
                        };
                        function sc(Qe, rt, Wn, Co, Dl, Ll) {
                            if (rt.imageName) {
                                const Qe = Co[rt.imageName];
                                return Qe ? Qe.displaySize[0] * rt.scale * Nm / Ll + Dl : 0;
                            }
                            {
                                const Co = Wn[rt.fontStack], Ll = Co && Co[Qe];
                                return Ll ? Ll.metrics.advance * rt.scale + Dl : 0;
                            }
                        }
                        function ac(Qe, rt, Wn, Co) {
                            const Dl = Math.pow(Qe - rt, 2);
                            return Co ? Qe < rt ? Dl / 2 : 2 * Dl : Dl + Math.abs(Wn) * Wn;
                        }
                        function oc(Qe, rt, Wn) {
                            let Co = 0;
                            return 10 === Qe && (Co -= 1e4), Wn && (Co += 150), 40 !== Qe && 65288 !== Qe || (Co += 50), 41 !== rt && 65289 !== rt || (Co += 50), Co;
                        }
                        function lc(Qe, rt, Wn, Co, Dl, Ll) {
                            let Rl = null, Ul = ac(rt, Wn, Dl, Ll);
                            for (const Gl of Co){
                                const Qe = ac(rt - Gl.x, Wn, Dl, Ll) + Gl.badness;
                                Qe <= Ul && (Rl = Gl, Ul = Qe);
                            }
                            return {
                                index: Qe,
                                x: rt,
                                priorBreak: Rl,
                                badness: Ul
                            };
                        }
                        function uc(Qe) {
                            return Qe ? uc(Qe.priorBreak).concat(Qe.index) : [];
                        }
                        function cc(Qe, rt, Wn, Co, Dl, Ll) {
                            if (!Qe) return [];
                            const Rl = [], Ul = function(Qe, rt, Wn, Co, Dl, Ll) {
                                let Rl = 0;
                                for(let Ul = 0; Ul < Qe.length(); Ul++){
                                    const Wn = Qe.getSection(Ul);
                                    Rl += sc(Qe.getCharCode(Ul), Wn, Co, Dl, rt, Ll);
                                }
                                return Rl / Math.max(1, Math.ceil(Rl / Wn));
                            }(Qe, rt, Wn, Co, Dl, Ll), Gl = Qe.text.indexOf("\u200B") >= 0;
                            let Zl = 0;
                            for(let ql = 0; ql < Qe.length(); ql++){
                                const Wn = Qe.getSection(ql), Ql = Qe.getCharCode(ql);
                                if (Gm[Ql] || (Zl += sc(Ql, Wn, Co, Dl, rt, Ll)), ql < Qe.length() - 1) {
                                    const rt = !((Hl = Ql) < 11904) && (!!up["CJK Compatibility Forms"](Hl) || !!up["CJK Compatibility"](Hl) || !!up["CJK Strokes"](Hl) || !!up["CJK Symbols and Punctuation"](Hl) || !!up["Enclosed CJK Letters and Months"](Hl) || !!up["Halfwidth and Fullwidth Forms"](Hl) || !!up["Ideographic Description Characters"](Hl) || !!up["Vertical Forms"](Hl) || Ap.test(String.fromCodePoint(Hl)));
                                    (Zm[Ql] || rt || Wn.imageName || ql !== Qe.length() - 2 && Hm[Qe.getCharCode(ql + 1)]) && Rl.push(lc(ql + 1, Zl, Ul, Rl, oc(Ql, Qe.getCharCode(ql + 1), rt && Gl), !1));
                                }
                            }
                            var Hl;
                            return uc(lc(Qe.length(), Zl, Ul, Rl, 0, !0));
                        }
                        function hc(Qe) {
                            let rt = .5, Wn = .5;
                            switch(Qe){
                                case "right":
                                case "top-right":
                                case "bottom-right":
                                    rt = 1;
                                    break;
                                case "left":
                                case "top-left":
                                case "bottom-left":
                                    rt = 0;
                            }
                            switch(Qe){
                                case "bottom":
                                case "bottom-right":
                                case "bottom-left":
                                    Wn = 1;
                                    break;
                                case "top":
                                case "top-right":
                                case "top-left":
                                    Wn = 0;
                            }
                            return {
                                horizontalAlign: rt,
                                verticalAlign: Wn
                            };
                        }
                        function pc(Qe, rt, Wn) {
                            const Co = rt.getMaxScale() * Nm, { maxImageWidth: Dl, maxImageHeight: Ll } = rt.getMaxImageSize(Qe), Rl = Math.max(Co, Ll * Wn);
                            return {
                                verticalLineContentWidth: Math.max(Co, Dl * Wn),
                                horizontalLineContentHeight: Rl
                            };
                        }
                        function fc(Qe) {
                            switch(Qe){
                                case "top":
                                    return 0;
                                case "center":
                                    return .5;
                                default:
                                    return 1;
                            }
                        }
                        function dc(rt, Wn, Co) {
                            var Dl;
                            return !(rt === Qe.ah.horizontal || !Wn && !as(Co) || Wn && (Gm[Co] || (Dl = Co, /\p{sc=Arab}/u.test(String.fromCodePoint(Dl)))));
                        }
                        function yc(Qe, rt, Wn, Co, Dl, Ll) {
                            const Rl = Ll[Qe.fontStack], Ul = function(Qe, rt, Wn, Co) {
                                if (Qe && Qe.rect) return Qe;
                                const Dl = rt[Wn.fontStack], Ll = Dl && Dl[Co];
                                return Ll ? {
                                    rect: null,
                                    metrics: Ll.metrics
                                } : null;
                            }(Rl && Rl[rt], Dl, Qe, rt);
                            if (null === Ul) return null;
                            let Gl;
                            if (Wn) Gl = Co.verticalLineContentWidth - Qe.scale * Nm;
                            else {
                                const rt = fc(Qe.verticalAlign);
                                Gl = (Co.horizontalLineContentHeight - Qe.scale * Nm) * rt;
                            }
                            return {
                                rect: Ul.rect,
                                metrics: Ul.metrics,
                                baselineOffset: Gl
                            };
                        }
                        function mc(Qe, rt, Wn, Co, Dl) {
                            const Ll = Dl[Qe.imageName];
                            if (!Ll) return null;
                            const Rl = Ll.paddedRect, Ul = Ll.displaySize, Gl = {
                                width: Ul[0],
                                height: Ul[1],
                                left: jm,
                                top: -3,
                                advance: rt ? Ul[1] : Ul[0]
                            };
                            let Zl;
                            if (rt) Zl = Co.verticalLineContentWidth - Ul[1] * Qe.scale;
                            else {
                                const rt = fc(Qe.verticalAlign);
                                Zl = (Co.horizontalLineContentHeight - Ul[1] * Qe.scale) * rt;
                            }
                            return {
                                rect: Rl,
                                metrics: Gl,
                                baselineOffset: Zl,
                                imageOffset: (rt ? Ul[0] : Ul[1]) * Qe.scale - Nm * Wn
                            };
                        }
                        function gc(Qe, rt, Wn, Co) {
                            if (0 === Co) return;
                            const Dl = Qe[Wn], Ll = (Qe[Wn].x + Dl.metrics.advance * Dl.scale) * Co;
                            for(let Rl = rt; Rl <= Wn; Rl++)Qe[Rl].x -= Ll;
                        }
                        function xc(Qe, rt, Wn) {
                            const { horizontalAlign: Co, verticalAlign: Dl } = hc(Wn), Ll = rt[0] - Qe.displaySize[0] * Co, Rl = rt[1] - Qe.displaySize[1] * Dl;
                            return {
                                image: Qe,
                                top: Rl,
                                bottom: Rl + Qe.displaySize[1],
                                left: Ll,
                                right: Ll + Qe.displaySize[0]
                            };
                        }
                        function vc(Qe) {
                            var rt, Wn;
                            let Co = Qe.left, Dl = Qe.top, Ll = Qe.right - Co, Rl = Qe.bottom - Dl;
                            const Ul = null !== (rt = Qe.image.textFitWidth) && void 0 !== rt ? rt : "stretchOrShrink", Gl = null !== (Wn = Qe.image.textFitHeight) && void 0 !== Wn ? Wn : "stretchOrShrink", Zl = (Qe.image.content[2] - Qe.image.content[0]) / (Qe.image.content[3] - Qe.image.content[1]);
                            if ("proportional" === Gl) {
                                if ("stretchOnly" === Ul && Ll / Rl < Zl || "proportional" === Ul) {
                                    const Qe = Math.ceil(Rl * Zl);
                                    Co *= Qe / Ll, Ll = Qe;
                                }
                            } else if ("proportional" === Ul && "stretchOnly" === Gl && 0 !== Zl && Ll / Rl > Zl) {
                                const Qe = Math.ceil(Ll / Zl);
                                Dl *= Qe / Rl, Rl = Qe;
                            }
                            return {
                                x1: Co,
                                y1: Dl,
                                x2: Co + Ll,
                                y2: Dl + Rl
                            };
                        }
                        function bc(Qe, rt, Wn, Co, Dl, Ll) {
                            const Rl = Qe.image;
                            let Ul;
                            if (Rl.content) {
                                const Qe = Rl.content, rt = Rl.pixelRatio || 1;
                                Ul = [
                                    Qe[0] / rt,
                                    Qe[1] / rt,
                                    Rl.displaySize[0] - Qe[2] / rt,
                                    Rl.displaySize[1] - Qe[3] / rt
                                ];
                            }
                            const Gl = rt.left * Ll, Zl = rt.right * Ll;
                            let Hl, ql, Ql, Kl;
                            "width" === Wn || "both" === Wn ? (Kl = Dl[0] + Gl - Co[3], ql = Dl[0] + Zl + Co[1]) : (Kl = Dl[0] + (Gl + Zl - Rl.displaySize[0]) / 2, ql = Kl + Rl.displaySize[0]);
                            const $l = rt.top * Ll, Tc = rt.bottom * Ll;
                            return "height" === Wn || "both" === Wn ? (Hl = Dl[1] + $l - Co[0], Ql = Dl[1] + Tc + Co[2]) : (Hl = Dl[1] + ($l + Tc - Rl.displaySize[1]) / 2, Ql = Hl + Rl.displaySize[1]), {
                                image: Rl,
                                top: Hl,
                                right: ql,
                                bottom: Ql,
                                left: Kl,
                                collisionPadding: Ul
                            };
                        }
                        const Wm = 255, qm = 128, Ym = Wm * qm;
                        function Ac(Qe, rt) {
                            const { expression: Wn } = rt;
                            if ("constant" === Wn.kind) return {
                                kind: "constant",
                                layoutSize: Wn.evaluate(new fs(Qe + 1))
                            };
                            if ("source" === Wn.kind) return {
                                kind: "source"
                            };
                            {
                                const { zoomStops: rt, interpolationType: Co } = Wn;
                                let Dl = 0;
                                for(; Dl < rt.length && rt[Dl] <= Qe;)Dl++;
                                Dl = Math.max(0, Dl - 1);
                                let Ll = Dl;
                                for(; Ll < rt.length && rt[Ll] < Qe + 1;)Ll++;
                                Ll = Math.min(rt.length - 1, Ll);
                                const Rl = rt[Dl], Ul = rt[Ll];
                                return "composite" === Wn.kind ? {
                                    kind: "composite",
                                    minZoom: Rl,
                                    maxZoom: Ul,
                                    interpolationType: Co
                                } : {
                                    kind: "camera",
                                    minZoom: Rl,
                                    maxZoom: Ul,
                                    minSize: Wn.evaluate(new fs(Rl)),
                                    maxSize: Wn.evaluate(new fs(Ul)),
                                    interpolationType: Co
                                };
                            }
                        }
                        function kc(Qe, rt, Wn) {
                            let Co = "never";
                            const Dl = Qe.get(rt);
                            return Dl ? Co = Dl : Qe.get(Wn) && (Co = "always"), Co;
                        }
                        const Qm = um.VectorTileFeature.types, Km = [
                            {
                                name: "a_fade_opacity",
                                components: 1,
                                type: "Uint8",
                                offset: 0
                            }
                        ];
                        function zc(Qe, rt, Wn, Co, Dl, Ll, Rl, Ul, Gl, Zl, Hl, ql, Ql) {
                            const Kl = Ul ? Math.min(Ym, Math.round(Ul[0])) : 0, $l = Ul ? Math.min(Ym, Math.round(Ul[1])) : 0;
                            Qe.emplaceBack(rt, Wn, Math.round(32 * Co), Math.round(32 * Dl), Ll, Rl, (Kl << 1) + (Gl ? 1 : 0), $l, 16 * Zl, 16 * Hl, 256 * ql, 256 * Ql);
                        }
                        function Pc(Qe, rt, Wn) {
                            Qe.emplaceBack(rt.x, rt.y, Wn), Qe.emplaceBack(rt.x, rt.y, Wn), Qe.emplaceBack(rt.x, rt.y, Wn), Qe.emplaceBack(rt.x, rt.y, Wn);
                        }
                        function Cc(Qe) {
                            for (const rt of Qe.sections)if (hs(rt.text)) return !0;
                            return !1;
                        }
                        class Bc {
                            constructor(Qe){
                                this.layoutVertexArray = new Sa, this.indexArray = new za, this.programConfigurations = Qe, this.segments = new Va, this.dynamicLayoutVertexArray = new Aa, this.opacityVertexArray = new ka, this.hasVisibleVertices = !1, this.placedSymbolArray = new oa;
                            }
                            isEmpty() {
                                return 0 === this.layoutVertexArray.length && 0 === this.indexArray.length && 0 === this.dynamicLayoutVertexArray.length && 0 === this.opacityVertexArray.length;
                            }
                            upload(Qe, rt, Wn, Co) {
                                this.isEmpty() || (Wn && (this.layoutVertexBuffer = Qe.createVertexBuffer(this.layoutVertexArray, Sm.members), this.indexBuffer = Qe.createIndexBuffer(this.indexArray, rt), this.dynamicLayoutVertexBuffer = Qe.createVertexBuffer(this.dynamicLayoutVertexArray, Tm.members, !0), this.opacityVertexBuffer = Qe.createVertexBuffer(this.opacityVertexArray, Km, !0), this.opacityVertexBuffer.itemSize = 1), (Wn || Co) && this.programConfigurations.upload(Qe));
                            }
                            destroy() {
                                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.dynamicLayoutVertexBuffer.destroy(), this.opacityVertexBuffer.destroy());
                            }
                        }
                        Zi("SymbolBuffers", Bc);
                        class Vc {
                            constructor(Qe, rt, Wn){
                                this.layoutVertexArray = new Qe, this.layoutAttributes = rt, this.indexArray = new Wn, this.segments = new Va, this.collisionVertexArray = new Ia;
                            }
                            upload(Qe) {
                                this.layoutVertexBuffer = Qe.createVertexBuffer(this.layoutVertexArray, this.layoutAttributes), this.indexBuffer = Qe.createIndexBuffer(this.indexArray), this.collisionVertexBuffer = Qe.createVertexBuffer(this.collisionVertexArray, Cm.members, !0);
                            }
                            destroy() {
                                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.segments.destroy(), this.collisionVertexBuffer.destroy());
                            }
                        }
                        Zi("CollisionBuffers", Vc);
                        class Ec {
                            constructor(rt){
                                this.collisionBoxArray = rt.collisionBoxArray, this.zoom = rt.zoom, this.overscaling = rt.overscaling, this.layers = rt.layers, this.layerIds = this.layers.map((Qe)=>Qe.id), this.index = rt.index, this.pixelRatio = rt.pixelRatio, this.sourceLayerIndex = rt.sourceLayerIndex, this.hasPattern = !1, this.hasRTLText = !1, this.sortKeyRanges = [], this.collisionCircleArray = [];
                                const Wn = this.layers[0]._unevaluatedLayout._values;
                                this.textSizeData = Ac(this.zoom, Wn["text-size"]), this.iconSizeData = Ac(this.zoom, Wn["icon-size"]);
                                const Co = this.layers[0].layout, Dl = Co.get("symbol-sort-key"), Ll = Co.get("symbol-z-order");
                                this.canOverlap = "never" !== kc(Co, "text-overlap", "text-allow-overlap") || "never" !== kc(Co, "icon-overlap", "icon-allow-overlap") || Co.get("text-ignore-placement") || Co.get("icon-ignore-placement"), this.sortFeaturesByKey = "viewport-y" !== Ll && !Dl.isConstant(), this.sortFeaturesByY = ("viewport-y" === Ll || "auto" === Ll && !this.sortFeaturesByKey) && this.canOverlap, "point" === Co.get("symbol-placement") && (this.writingModes = Co.get("text-writing-mode").map((rt)=>Qe.ah[rt])), this.stateDependentLayerIds = this.layers.filter((Qe)=>Qe.isStateDependent()).map((Qe)=>Qe.id), this.sourceID = rt.sourceID;
                            }
                            createArrays() {
                                this.text = new Bc(new so(this.layers, this.zoom, (Qe)=>/^text/.test(Qe))), this.icon = new Bc(new so(this.layers, this.zoom, (Qe)=>/^icon/.test(Qe))), this.glyphOffsetArray = new ca, this.lineVertexArray = new ha, this.symbolInstances = new ua, this.textAnchorOffsets = new fa;
                            }
                            calculateGlyphDependencies(Qe, rt, Wn, Co, Dl) {
                                for(let Ll = 0; Ll < Qe.length; Ll++)if (rt[Qe.charCodeAt(Ll)] = !0, (Wn || Co) && Dl) {
                                    const Wn = Dm[Qe.charAt(Ll)];
                                    Wn && (rt[Wn.charCodeAt(0)] = !0);
                                }
                            }
                            populate(rt, Wn, Co) {
                                const Dl = this.layers[0], Ll = Dl.layout, Rl = Ll.get("text-font"), Ul = Ll.get("text-field"), Gl = Ll.get("icon-image"), Zl = ("constant" !== Ul.value.kind || Ul.value.value instanceof _e && !Ul.value.value.isEmpty() || Ul.value.value.toString().length > 0) && ("constant" !== Rl.value.kind || Rl.value.value.length > 0), Hl = "constant" !== Gl.value.kind || !!Gl.value.value || Object.keys(Gl.parameters).length > 0, ql = Ll.get("symbol-sort-key");
                                if (this.features = [], !Zl && !Hl) return;
                                const Ql = Wn.iconDependencies, Kl = Wn.glyphDependencies, $l = Wn.availableImages, Tc = new fs(this.zoom);
                                for (const { feature: tu, id: lu, index: du, sourceLayerIndex: fu } of rt){
                                    const rt = Dl._featureFilter.needGeometry, Wn = ho(tu, rt);
                                    if (!Dl._featureFilter.filter(Tc, Wn, Co)) continue;
                                    let Ul, Gl;
                                    if (rt || (Wn.geometry = co(tu)), Zl) {
                                        const Qe = Dl.getValueAndResolveTokens("text-field", Wn, Co, $l), rt = _e.factory(Qe), Ll = this.hasRTLText = this.hasRTLText || Cc(rt);
                                        (!Ll || "unavailable" === _p.getRTLTextPluginStatus() || Ll && _p.isParsed()) && (Ul = Vu(rt, Dl, Wn));
                                    }
                                    if (Hl) {
                                        const Qe = Dl.getValueAndResolveTokens("icon-image", Wn, Co, $l);
                                        Gl = Qe instanceof Ie ? Qe : Ie.fromString(Qe);
                                    }
                                    if (!Ul && !Gl) continue;
                                    const yu = this.sortFeaturesByKey ? ql.evaluate(Wn, {}, Co) : void 0;
                                    if (this.features.push({
                                        id: lu,
                                        text: Ul,
                                        icon: Gl,
                                        index: du,
                                        sourceLayerIndex: fu,
                                        geometry: Wn.geometry,
                                        properties: tu.properties,
                                        type: Qm[tu.type],
                                        sortKey: yu
                                    }), Gl && (Ql[Gl.name] = !0), Ul) {
                                        const rt = Rl.evaluate(Wn, {}, Co).join(","), Dl = "viewport" !== Ll.get("text-rotation-alignment") && "point" !== Ll.get("symbol-placement");
                                        this.allowVerticalPlacement = this.writingModes && this.writingModes.indexOf(Qe.ah.vertical) >= 0;
                                        for (const Qe of Ul.sections)if (Qe.image) Ql[Qe.image.name] = !0;
                                        else {
                                            const Wn = ts(Ul.toString()), Co = Qe.fontStack || rt, Ll = Kl[Co] = Kl[Co] || {};
                                            this.calculateGlyphDependencies(Qe.text, Ll, Dl, this.allowVerticalPlacement, Wn);
                                        }
                                    }
                                }
                                "line" === Ll.get("symbol-placement") && (this.features = function(Qe) {
                                    const rt = {}, Wn = {}, Co = [];
                                    let Dl = 0;
                                    function s(rt) {
                                        Co.push(Qe[rt]), Dl++;
                                    }
                                    function a(Qe, rt, Dl) {
                                        const Ll = Wn[Qe];
                                        return delete Wn[Qe], Wn[rt] = Ll, Co[Ll].geometry[0].pop(), Co[Ll].geometry[0] = Co[Ll].geometry[0].concat(Dl[0]), Ll;
                                    }
                                    function o(Qe, Wn, Dl) {
                                        const Ll = rt[Wn];
                                        return delete rt[Wn], rt[Qe] = Ll, Co[Ll].geometry[0].shift(), Co[Ll].geometry[0] = Dl[0].concat(Co[Ll].geometry[0]), Ll;
                                    }
                                    function l(Qe, rt, Wn) {
                                        const Co = Wn ? rt[0][rt[0].length - 1] : rt[0][0];
                                        return `${Qe}:${Co.x}:${Co.y}`;
                                    }
                                    for(let Ll = 0; Ll < Qe.length; Ll++){
                                        const Rl = Qe[Ll], Ul = Rl.geometry, Gl = Rl.text ? Rl.text.toString() : null;
                                        if (!Gl) {
                                            s(Ll);
                                            continue;
                                        }
                                        const Zl = l(Gl, Ul), Hl = l(Gl, Ul, !0);
                                        if (Zl in Wn && Hl in rt && Wn[Zl] !== rt[Hl]) {
                                            const Qe = o(Zl, Hl, Ul), Dl = a(Zl, Hl, Co[Qe].geometry);
                                            delete rt[Zl], delete Wn[Hl], Wn[l(Gl, Co[Dl].geometry, !0)] = Dl, Co[Qe].geometry = null;
                                        } else Zl in Wn ? a(Zl, Hl, Ul) : Hl in rt ? o(Zl, Hl, Ul) : (s(Ll), rt[Zl] = Dl - 1, Wn[Hl] = Dl - 1);
                                    }
                                    return Co.filter((Qe)=>Qe.geometry);
                                }(this.features)), this.sortFeaturesByKey && this.features.sort((Qe, rt)=>Qe.sortKey - rt.sortKey);
                            }
                            update(Qe, rt, Wn) {
                                this.stateDependentLayers.length && (this.text.programConfigurations.updatePaintArrays(Qe, rt, this.layers, Wn), this.icon.programConfigurations.updatePaintArrays(Qe, rt, this.layers, Wn));
                            }
                            isEmpty() {
                                return 0 === this.symbolInstances.length && !this.hasRTLText;
                            }
                            uploadPending() {
                                return !this.uploaded || this.text.programConfigurations.needsUpload || this.icon.programConfigurations.needsUpload;
                            }
                            upload(Qe) {
                                !this.uploaded && this.hasDebugData() && (this.textCollisionBox.upload(Qe), this.iconCollisionBox.upload(Qe)), this.text.upload(Qe, this.sortFeaturesByY, !this.uploaded, this.text.programConfigurations.needsUpload), this.icon.upload(Qe, this.sortFeaturesByY, !this.uploaded, this.icon.programConfigurations.needsUpload), this.uploaded = !0;
                            }
                            destroyDebugData() {
                                this.textCollisionBox.destroy(), this.iconCollisionBox.destroy();
                            }
                            destroy() {
                                this.text.destroy(), this.icon.destroy(), this.hasDebugData() && this.destroyDebugData();
                            }
                            addToLineVertexArray(Qe, rt) {
                                const Wn = this.lineVertexArray.length;
                                if (void 0 !== Qe.segment) {
                                    let Wn = Qe.dist(rt[Qe.segment + 1]), Co = Qe.dist(rt[Qe.segment]);
                                    const Dl = {};
                                    for(let Ll = Qe.segment + 1; Ll < rt.length; Ll++)Dl[Ll] = {
                                        x: rt[Ll].x,
                                        y: rt[Ll].y,
                                        tileUnitDistanceFromAnchor: Wn
                                    }, Ll < rt.length - 1 && (Wn += rt[Ll + 1].dist(rt[Ll]));
                                    for(let Ll = Qe.segment || 0; Ll >= 0; Ll--)Dl[Ll] = {
                                        x: rt[Ll].x,
                                        y: rt[Ll].y,
                                        tileUnitDistanceFromAnchor: Co
                                    }, Ll > 0 && (Co += rt[Ll - 1].dist(rt[Ll]));
                                    for(let Qe = 0; Qe < rt.length; Qe++){
                                        const rt = Dl[Qe];
                                        this.lineVertexArray.emplaceBack(rt.x, rt.y, rt.tileUnitDistanceFromAnchor);
                                    }
                                }
                                return {
                                    lineStartIndex: Wn,
                                    lineLength: this.lineVertexArray.length - Wn
                                };
                            }
                            addSymbols(rt, Wn, Co, Dl, Ll, Rl, Ul, Gl, Zl, Hl, ql, Ql) {
                                const Kl = rt.indexArray, $l = rt.layoutVertexArray, Tc = rt.segments.prepareSegment(4 * Wn.length, $l, Kl, this.canOverlap ? Rl.sortKey : void 0), tu = this.glyphOffsetArray.length, lu = Tc.vertexLength, du = this.allowVerticalPlacement && Ul === Qe.ah.vertical ? Math.PI / 2 : 0, fu = Rl.text && Rl.text.sections;
                                for(let Qe = 0; Qe < Wn.length; Qe++){
                                    const { tl: Dl, tr: Ll, bl: Ul, br: Zl, tex: Hl, pixelOffsetTL: ql, pixelOffsetBR: tu, minFontScaleX: lu, minFontScaleY: yu, glyphOffset: Eu, isSDF: Tu, sectionIndex: Lu } = Wn[Qe], Zu = Tc.vertexLength, Xu = Eu[1];
                                    zc($l, Gl.x, Gl.y, Dl.x, Xu + Dl.y, Hl.x, Hl.y, Co, Tu, ql.x, ql.y, lu, yu), zc($l, Gl.x, Gl.y, Ll.x, Xu + Ll.y, Hl.x + Hl.w, Hl.y, Co, Tu, tu.x, ql.y, lu, yu), zc($l, Gl.x, Gl.y, Ul.x, Xu + Ul.y, Hl.x, Hl.y + Hl.h, Co, Tu, ql.x, tu.y, lu, yu), zc($l, Gl.x, Gl.y, Zl.x, Xu + Zl.y, Hl.x + Hl.w, Hl.y + Hl.h, Co, Tu, tu.x, tu.y, lu, yu), Pc(rt.dynamicLayoutVertexArray, Gl, du), Kl.emplaceBack(Zu, Zu + 2, Zu + 1), Kl.emplaceBack(Zu + 1, Zu + 2, Zu + 3), Tc.vertexLength += 4, Tc.primitiveLength += 2, this.glyphOffsetArray.emplaceBack(Eu[0]), Qe !== Wn.length - 1 && Lu === Wn[Qe + 1].sectionIndex || rt.programConfigurations.populatePaintArrays($l.length, Rl, Rl.index, {}, Ql, fu && fu[Lu]);
                                }
                                rt.placedSymbolArray.emplaceBack(Gl.x, Gl.y, tu, this.glyphOffsetArray.length - tu, lu, Zl, Hl, Gl.segment, Co ? Co[0] : 0, Co ? Co[1] : 0, Dl[0], Dl[1], Ul, 0, !1, 0, ql);
                            }
                            _addCollisionDebugVertex(Qe, rt, Wn, Co, Dl, Ll) {
                                return rt.emplaceBack(0, 0), Qe.emplaceBack(Wn.x, Wn.y, Co, Dl, Math.round(Ll.x), Math.round(Ll.y));
                            }
                            addCollisionDebugVertices(Qe, rt, Wn, Co, Dl, Rl, Ul) {
                                const Gl = Dl.segments.prepareSegment(4, Dl.layoutVertexArray, Dl.indexArray), Zl = Gl.vertexLength, Hl = Dl.layoutVertexArray, ql = Dl.collisionVertexArray, Ql = Ul.anchorX, Kl = Ul.anchorY;
                                this._addCollisionDebugVertex(Hl, ql, Rl, Ql, Kl, new Ll(Qe, rt)), this._addCollisionDebugVertex(Hl, ql, Rl, Ql, Kl, new Ll(Wn, rt)), this._addCollisionDebugVertex(Hl, ql, Rl, Ql, Kl, new Ll(Wn, Co)), this._addCollisionDebugVertex(Hl, ql, Rl, Ql, Kl, new Ll(Qe, Co)), Gl.vertexLength += 4;
                                const $l = Dl.indexArray;
                                $l.emplaceBack(Zl, Zl + 1), $l.emplaceBack(Zl + 1, Zl + 2), $l.emplaceBack(Zl + 2, Zl + 3), $l.emplaceBack(Zl + 3, Zl), Gl.primitiveLength += 4;
                            }
                            addDebugCollisionBoxes(Qe, rt, Wn, Co) {
                                for(let Dl = Qe; Dl < rt; Dl++){
                                    const Qe = this.collisionBoxArray.get(Dl);
                                    this.addCollisionDebugVertices(Qe.x1, Qe.y1, Qe.x2, Qe.y2, Co ? this.textCollisionBox : this.iconCollisionBox, Qe.anchorPoint, Wn);
                                }
                            }
                            generateCollisionDebugBuffers() {
                                this.hasDebugData() && this.destroyDebugData(), this.textCollisionBox = new Vc(Ma, km.members, Pa), this.iconCollisionBox = new Vc(Ma, km.members, Pa);
                                for(let Qe = 0; Qe < this.symbolInstances.length; Qe++){
                                    const rt = this.symbolInstances.get(Qe);
                                    this.addDebugCollisionBoxes(rt.textBoxStartIndex, rt.textBoxEndIndex, rt, !0), this.addDebugCollisionBoxes(rt.verticalTextBoxStartIndex, rt.verticalTextBoxEndIndex, rt, !0), this.addDebugCollisionBoxes(rt.iconBoxStartIndex, rt.iconBoxEndIndex, rt, !1), this.addDebugCollisionBoxes(rt.verticalIconBoxStartIndex, rt.verticalIconBoxEndIndex, rt, !1);
                                }
                            }
                            _deserializeCollisionBoxesForSymbol(Qe, rt, Wn, Co, Dl, Ll, Rl, Ul, Gl) {
                                const Zl = {};
                                for(let Hl = rt; Hl < Wn; Hl++){
                                    const rt = Qe.get(Hl);
                                    Zl.textBox = {
                                        x1: rt.x1,
                                        y1: rt.y1,
                                        x2: rt.x2,
                                        y2: rt.y2,
                                        anchorPointX: rt.anchorPointX,
                                        anchorPointY: rt.anchorPointY
                                    }, Zl.textFeatureIndex = rt.featureIndex;
                                    break;
                                }
                                for(let Hl = Co; Hl < Dl; Hl++){
                                    const rt = Qe.get(Hl);
                                    Zl.verticalTextBox = {
                                        x1: rt.x1,
                                        y1: rt.y1,
                                        x2: rt.x2,
                                        y2: rt.y2,
                                        anchorPointX: rt.anchorPointX,
                                        anchorPointY: rt.anchorPointY
                                    }, Zl.verticalTextFeatureIndex = rt.featureIndex;
                                    break;
                                }
                                for(let Hl = Ll; Hl < Rl; Hl++){
                                    const rt = Qe.get(Hl);
                                    Zl.iconBox = {
                                        x1: rt.x1,
                                        y1: rt.y1,
                                        x2: rt.x2,
                                        y2: rt.y2,
                                        anchorPointX: rt.anchorPointX,
                                        anchorPointY: rt.anchorPointY
                                    }, Zl.iconFeatureIndex = rt.featureIndex;
                                    break;
                                }
                                for(let Hl = Ul; Hl < Gl; Hl++){
                                    const rt = Qe.get(Hl);
                                    Zl.verticalIconBox = {
                                        x1: rt.x1,
                                        y1: rt.y1,
                                        x2: rt.x2,
                                        y2: rt.y2,
                                        anchorPointX: rt.anchorPointX,
                                        anchorPointY: rt.anchorPointY
                                    }, Zl.verticalIconFeatureIndex = rt.featureIndex;
                                    break;
                                }
                                return Zl;
                            }
                            deserializeCollisionBoxes(Qe) {
                                this.collisionArrays = [];
                                for(let rt = 0; rt < this.symbolInstances.length; rt++){
                                    const Wn = this.symbolInstances.get(rt);
                                    this.collisionArrays.push(this._deserializeCollisionBoxesForSymbol(Qe, Wn.textBoxStartIndex, Wn.textBoxEndIndex, Wn.verticalTextBoxStartIndex, Wn.verticalTextBoxEndIndex, Wn.iconBoxStartIndex, Wn.iconBoxEndIndex, Wn.verticalIconBoxStartIndex, Wn.verticalIconBoxEndIndex));
                                }
                            }
                            hasTextData() {
                                return this.text.segments.get().length > 0;
                            }
                            hasIconData() {
                                return this.icon.segments.get().length > 0;
                            }
                            hasDebugData() {
                                return this.textCollisionBox && this.iconCollisionBox;
                            }
                            hasTextCollisionBoxData() {
                                return this.hasDebugData() && this.textCollisionBox.segments.get().length > 0;
                            }
                            hasIconCollisionBoxData() {
                                return this.hasDebugData() && this.iconCollisionBox.segments.get().length > 0;
                            }
                            addIndicesForPlacedSymbol(Qe, rt) {
                                const Wn = Qe.placedSymbolArray.get(rt), Co = Wn.vertexStartIndex + 4 * Wn.numGlyphs;
                                for(let Dl = Wn.vertexStartIndex; Dl < Co; Dl += 4)Qe.indexArray.emplaceBack(Dl, Dl + 2, Dl + 1), Qe.indexArray.emplaceBack(Dl + 1, Dl + 2, Dl + 3);
                            }
                            getSortedSymbolIndexes(Qe) {
                                if (this.sortedAngle === Qe && void 0 !== this.symbolInstanceIndexes) return this.symbolInstanceIndexes;
                                const rt = Math.sin(Qe), Wn = Math.cos(Qe), Co = [], Dl = [], Ll = [];
                                for(let Rl = 0; Rl < this.symbolInstances.length; ++Rl){
                                    Ll.push(Rl);
                                    const Qe = this.symbolInstances.get(Rl);
                                    Co.push(0 | Math.round(rt * Qe.anchorX + Wn * Qe.anchorY)), Dl.push(Qe.featureIndex);
                                }
                                return Ll.sort((Qe, rt)=>Co[Qe] - Co[rt] || Dl[rt] - Dl[Qe]), Ll;
                            }
                            addToSortKeyRanges(Qe, rt) {
                                const Wn = this.sortKeyRanges[this.sortKeyRanges.length - 1];
                                Wn && Wn.sortKey === rt ? Wn.symbolInstanceEnd = Qe + 1 : this.sortKeyRanges.push({
                                    sortKey: rt,
                                    symbolInstanceStart: Qe,
                                    symbolInstanceEnd: Qe + 1
                                });
                            }
                            sortFeatures(Qe) {
                                if (this.sortFeaturesByY && this.sortedAngle !== Qe && !(this.text.segments.get().length > 1 || this.icon.segments.get().length > 1)) {
                                    this.symbolInstanceIndexes = this.getSortedSymbolIndexes(Qe), this.sortedAngle = Qe, this.text.indexArray.clear(), this.icon.indexArray.clear(), this.featureSortOrder = [];
                                    for (const Qe of this.symbolInstanceIndexes){
                                        const rt = this.symbolInstances.get(Qe);
                                        this.featureSortOrder.push(rt.featureIndex), [
                                            rt.rightJustifiedTextSymbolIndex,
                                            rt.centerJustifiedTextSymbolIndex,
                                            rt.leftJustifiedTextSymbolIndex
                                        ].forEach((Qe, rt, Wn)=>{
                                            Qe >= 0 && Wn.indexOf(Qe) === rt && this.addIndicesForPlacedSymbol(this.text, Qe);
                                        }), rt.verticalPlacedTextSymbolIndex >= 0 && this.addIndicesForPlacedSymbol(this.text, rt.verticalPlacedTextSymbolIndex), rt.placedIconSymbolIndex >= 0 && this.addIndicesForPlacedSymbol(this.icon, rt.placedIconSymbolIndex), rt.verticalPlacedIconSymbolIndex >= 0 && this.addIndicesForPlacedSymbol(this.icon, rt.verticalPlacedIconSymbolIndex);
                                    }
                                    this.text.indexBuffer && this.text.indexBuffer.updateData(this.text.indexArray), this.icon.indexBuffer && this.icon.indexBuffer.updateData(this.icon.indexArray);
                                }
                            }
                        }
                        let Xm, Jm;
                        Zi("SymbolBucket", Ec, {
                            omit: [
                                "layers",
                                "collisionBoxArray",
                                "features",
                                "compareText"
                            ]
                        }), Ec.MAX_GLYPHS = 65535, Ec.addDynamicAttributes = Pc;
                        var $m = {
                            get paint () {
                                return Jm = Jm || new Is({
                                    "icon-opacity": new Ss(Ju.paint_symbol["icon-opacity"]),
                                    "icon-color": new Ss(Ju.paint_symbol["icon-color"]),
                                    "icon-halo-color": new Ss(Ju.paint_symbol["icon-halo-color"]),
                                    "icon-halo-width": new Ss(Ju.paint_symbol["icon-halo-width"]),
                                    "icon-halo-blur": new Ss(Ju.paint_symbol["icon-halo-blur"]),
                                    "icon-translate": new _s(Ju.paint_symbol["icon-translate"]),
                                    "icon-translate-anchor": new _s(Ju.paint_symbol["icon-translate-anchor"]),
                                    "text-opacity": new Ss(Ju.paint_symbol["text-opacity"]),
                                    "text-color": new Ss(Ju.paint_symbol["text-color"], {
                                        runtimeType: rd,
                                        getOverride: (Qe)=>Qe.textColor,
                                        hasOverride: (Qe)=>!!Qe.textColor
                                    }),
                                    "text-halo-color": new Ss(Ju.paint_symbol["text-halo-color"]),
                                    "text-halo-width": new Ss(Ju.paint_symbol["text-halo-width"]),
                                    "text-halo-blur": new Ss(Ju.paint_symbol["text-halo-blur"]),
                                    "text-translate": new _s(Ju.paint_symbol["text-translate"]),
                                    "text-translate-anchor": new _s(Ju.paint_symbol["text-translate-anchor"])
                                });
                            },
                            get layout () {
                                return Xm = Xm || new Is({
                                    "symbol-placement": new _s(Ju.layout_symbol["symbol-placement"]),
                                    "symbol-spacing": new _s(Ju.layout_symbol["symbol-spacing"]),
                                    "symbol-avoid-edges": new _s(Ju.layout_symbol["symbol-avoid-edges"]),
                                    "symbol-sort-key": new Ss(Ju.layout_symbol["symbol-sort-key"]),
                                    "symbol-z-order": new _s(Ju.layout_symbol["symbol-z-order"]),
                                    "icon-allow-overlap": new _s(Ju.layout_symbol["icon-allow-overlap"]),
                                    "icon-overlap": new _s(Ju.layout_symbol["icon-overlap"]),
                                    "icon-ignore-placement": new _s(Ju.layout_symbol["icon-ignore-placement"]),
                                    "icon-optional": new _s(Ju.layout_symbol["icon-optional"]),
                                    "icon-rotation-alignment": new _s(Ju.layout_symbol["icon-rotation-alignment"]),
                                    "icon-size": new Ss(Ju.layout_symbol["icon-size"]),
                                    "icon-text-fit": new _s(Ju.layout_symbol["icon-text-fit"]),
                                    "icon-text-fit-padding": new _s(Ju.layout_symbol["icon-text-fit-padding"]),
                                    "icon-image": new Ss(Ju.layout_symbol["icon-image"]),
                                    "icon-rotate": new Ss(Ju.layout_symbol["icon-rotate"]),
                                    "icon-padding": new Ss(Ju.layout_symbol["icon-padding"]),
                                    "icon-keep-upright": new _s(Ju.layout_symbol["icon-keep-upright"]),
                                    "icon-offset": new Ss(Ju.layout_symbol["icon-offset"]),
                                    "icon-anchor": new Ss(Ju.layout_symbol["icon-anchor"]),
                                    "icon-pitch-alignment": new _s(Ju.layout_symbol["icon-pitch-alignment"]),
                                    "text-pitch-alignment": new _s(Ju.layout_symbol["text-pitch-alignment"]),
                                    "text-rotation-alignment": new _s(Ju.layout_symbol["text-rotation-alignment"]),
                                    "text-field": new Ss(Ju.layout_symbol["text-field"]),
                                    "text-font": new Ss(Ju.layout_symbol["text-font"]),
                                    "text-size": new Ss(Ju.layout_symbol["text-size"]),
                                    "text-max-width": new Ss(Ju.layout_symbol["text-max-width"]),
                                    "text-line-height": new _s(Ju.layout_symbol["text-line-height"]),
                                    "text-letter-spacing": new Ss(Ju.layout_symbol["text-letter-spacing"]),
                                    "text-justify": new Ss(Ju.layout_symbol["text-justify"]),
                                    "text-radial-offset": new Ss(Ju.layout_symbol["text-radial-offset"]),
                                    "text-variable-anchor": new _s(Ju.layout_symbol["text-variable-anchor"]),
                                    "text-variable-anchor-offset": new Ss(Ju.layout_symbol["text-variable-anchor-offset"]),
                                    "text-anchor": new Ss(Ju.layout_symbol["text-anchor"]),
                                    "text-max-angle": new _s(Ju.layout_symbol["text-max-angle"]),
                                    "text-writing-mode": new _s(Ju.layout_symbol["text-writing-mode"]),
                                    "text-rotate": new Ss(Ju.layout_symbol["text-rotate"]),
                                    "text-padding": new _s(Ju.layout_symbol["text-padding"]),
                                    "text-keep-upright": new _s(Ju.layout_symbol["text-keep-upright"]),
                                    "text-transform": new Ss(Ju.layout_symbol["text-transform"]),
                                    "text-offset": new Ss(Ju.layout_symbol["text-offset"]),
                                    "text-allow-overlap": new _s(Ju.layout_symbol["text-allow-overlap"]),
                                    "text-overlap": new _s(Ju.layout_symbol["text-overlap"]),
                                    "text-ignore-placement": new _s(Ju.layout_symbol["text-ignore-placement"]),
                                    "text-optional": new _s(Ju.layout_symbol["text-optional"])
                                });
                            }
                        };
                        class Lc {
                            constructor(Qe){
                                if (void 0 === Qe.property.overrides) throw new Error("overrides must be provided to instantiate FormatSectionOverride class");
                                this.type = Qe.property.overrides ? Qe.property.overrides.runtimeType : ed, this.defaultValue = Qe;
                            }
                            evaluate(Qe) {
                                if (Qe.formattedSection) {
                                    const rt = this.defaultValue.property.overrides;
                                    if (rt && rt.hasOverride(Qe.formattedSection)) return rt.getOverride(Qe.formattedSection);
                                }
                                return Qe.feature && Qe.featureState ? this.defaultValue.evaluate(Qe.feature, Qe.featureState) : this.defaultValue.property.specification.default;
                            }
                            eachChild(Qe) {
                                this.defaultValue.isConstant() || Qe(this.defaultValue.value._styleExpression.expression);
                            }
                            outputDefined() {
                                return !1;
                            }
                            serialize() {
                                return null;
                            }
                        }
                        Zi("FormatSectionOverride", Lc, {
                            omit: [
                                "defaultValue"
                            ]
                        });
                        class Oc extends Ps {
                            constructor(Qe){
                                super(Qe, $m);
                            }
                            recalculate(Qe, rt) {
                                if (super.recalculate(Qe, rt), "auto" === this.layout.get("icon-rotation-alignment") && (this.layout._values["icon-rotation-alignment"] = "point" !== this.layout.get("symbol-placement") ? "map" : "viewport"), "auto" === this.layout.get("text-rotation-alignment") && (this.layout._values["text-rotation-alignment"] = "point" !== this.layout.get("symbol-placement") ? "map" : "viewport"), "auto" === this.layout.get("text-pitch-alignment") && (this.layout._values["text-pitch-alignment"] = "map" === this.layout.get("text-rotation-alignment") ? "map" : "viewport"), "auto" === this.layout.get("icon-pitch-alignment") && (this.layout._values["icon-pitch-alignment"] = this.layout.get("icon-rotation-alignment")), "point" === this.layout.get("symbol-placement")) {
                                    const Qe = this.layout.get("text-writing-mode");
                                    if (Qe) {
                                        const rt = [];
                                        for (const Wn of Qe)rt.indexOf(Wn) < 0 && rt.push(Wn);
                                        this.layout._values["text-writing-mode"] = rt;
                                    } else this.layout._values["text-writing-mode"] = [
                                        "horizontal"
                                    ];
                                }
                                this._setPaintOverrides();
                            }
                            getValueAndResolveTokens(Qe, rt, Wn, Co) {
                                const Dl = this.layout.get(Qe).evaluate(rt, {}, Wn, Co), Ll = this._unevaluatedLayout._values[Qe];
                                return Ll.isDataDriven() || qn(Ll.value) || !Dl ? Dl : function(Qe, rt) {
                                    return rt.replace(/{([^{}]+)}/g, (rt, Wn)=>Qe && Wn in Qe ? String(Qe[Wn]) : "");
                                }(rt.properties, Dl);
                            }
                            createBucket(Qe) {
                                return new Ec(Qe);
                            }
                            queryRadius() {
                                return 0;
                            }
                            queryIntersectsFeature() {
                                throw new Error("Should take a different path in FeatureIndex");
                            }
                            _setPaintOverrides() {
                                for (const Qe of $m.paint.overridableProperties){
                                    if (!Oc.hasPaintOverride(this.layout, Qe)) continue;
                                    const rt = this.paint.get(Qe), Wn = new Lc(rt), Co = new Un(Wn, rt.property.specification);
                                    let Dl = null;
                                    Dl = "constant" === rt.value.kind || "source" === rt.value.kind ? new Zn("source", Co) : new Kn("composite", Co, rt.value.zoomStops), this.paint._values[Qe] = new bs(rt.property, Dl, rt.parameters);
                                }
                            }
                            _handleOverridablePaintPropertyUpdate(Qe, rt, Wn) {
                                return !(!this.layout || rt.isDataDriven() || Wn.isDataDriven()) && Oc.hasPaintOverride(this.layout, Qe);
                            }
                            static hasPaintOverride(Qe, rt) {
                                const Wn = Qe.get("text-field"), Co = $m.paint.properties[rt];
                                let Dl = !1;
                                const s = (Qe)=>{
                                    for (const rt of Qe)if (Co.overrides && Co.overrides.hasOverride(rt)) return void (Dl = !0);
                                };
                                if ("constant" === Wn.value.kind && Wn.value.value instanceof _e) s(Wn.value.value.sections);
                                else if ("source" === Wn.value.kind) {
                                    const t = (Qe)=>{
                                        Dl || (Qe instanceof Ee && Be(Qe.value) === cd ? s(Qe.value.sections) : Qe instanceof gr ? s(Qe.sections) : Qe.eachChild(t));
                                    }, Qe = Wn.value;
                                    Qe._styleExpression && t(Qe._styleExpression.expression);
                                }
                                return Dl;
                            }
                        }
                        let ef;
                        var tf = {
                            get paint () {
                                return ef = ef || new Is({
                                    "background-color": new _s(Ju.paint_background["background-color"]),
                                    "background-pattern": new ks(Ju.paint_background["background-pattern"]),
                                    "background-opacity": new _s(Ju.paint_background["background-opacity"])
                                });
                            }
                        };
                        class jc extends Ps {
                            constructor(Qe){
                                super(Qe, tf);
                            }
                        }
                        let nf;
                        var rf = {
                            get paint () {
                                return nf = nf || new Is({
                                    "raster-opacity": new _s(Ju.paint_raster["raster-opacity"]),
                                    "raster-hue-rotate": new _s(Ju.paint_raster["raster-hue-rotate"]),
                                    "raster-brightness-min": new _s(Ju.paint_raster["raster-brightness-min"]),
                                    "raster-brightness-max": new _s(Ju.paint_raster["raster-brightness-max"]),
                                    "raster-saturation": new _s(Ju.paint_raster["raster-saturation"]),
                                    "raster-contrast": new _s(Ju.paint_raster["raster-contrast"]),
                                    "raster-resampling": new _s(Ju.paint_raster["raster-resampling"]),
                                    "raster-fade-duration": new _s(Ju.paint_raster["raster-fade-duration"])
                                });
                            }
                        };
                        class qc extends Ps {
                            constructor(Qe){
                                super(Qe, rf);
                            }
                        }
                        class Gc extends Ps {
                            constructor(Qe){
                                super(Qe, {}), this.onAdd = (Qe)=>{
                                    this.implementation.onAdd && this.implementation.onAdd(Qe, Qe.painter.context.gl);
                                }, this.onRemove = (Qe)=>{
                                    this.implementation.onRemove && this.implementation.onRemove(Qe, Qe.painter.context.gl);
                                }, this.implementation = Qe;
                            }
                            is3D() {
                                return "3d" === this.implementation.renderingMode;
                            }
                            hasOffscreenPass() {
                                return void 0 !== this.implementation.prerender;
                            }
                            recalculate() {}
                            updateTransitions() {}
                            hasTransition() {
                                return !1;
                            }
                            serialize() {
                                throw new Error("Custom layers cannot be serialized");
                            }
                        }
                        class Zc {
                            constructor(Qe){
                                this._methodToThrottle = Qe, this._triggered = !1, "undefined" != typeof MessageChannel && (this._channel = new MessageChannel, this._channel.port2.onmessage = ()=>{
                                    this._triggered = !1, this._methodToThrottle();
                                });
                            }
                            trigger() {
                                this._triggered || (this._triggered = !0, this._channel ? this._channel.port1.postMessage(!0) : setTimeout(()=>{
                                    this._triggered = !1, this._methodToThrottle();
                                }, 0));
                            }
                            remove() {
                                delete this._channel, this._methodToThrottle = ()=>{};
                            }
                        }
                        const sf = {
                            once: !0
                        }, af = 6371008.8;
                        class Hc {
                            constructor(Qe, rt){
                                if (isNaN(Qe) || isNaN(rt)) throw new Error(`Invalid LngLat object: (${Qe}, ${rt})`);
                                if (this.lng = +Qe, this.lat = +rt, this.lat > 90 || this.lat < -90) throw new Error("Invalid LngLat latitude value: must be between -90 and 90");
                            }
                            wrap() {
                                return new Hc(T(this.lng, -180, 180), this.lat);
                            }
                            toArray() {
                                return [
                                    this.lng,
                                    this.lat
                                ];
                            }
                            toString() {
                                return `LngLat(${this.lng}, ${this.lat})`;
                            }
                            distanceTo(Qe) {
                                const rt = Math.PI / 180, Wn = this.lat * rt, Co = Qe.lat * rt, Dl = Math.sin(Wn) * Math.sin(Co) + Math.cos(Wn) * Math.cos(Co) * Math.cos((Qe.lng - this.lng) * rt);
                                return af * Math.acos(Math.min(Dl, 1));
                            }
                            static convert(Qe) {
                                if (Qe instanceof Hc) return Qe;
                                if (Array.isArray(Qe) && (2 === Qe.length || 3 === Qe.length)) return new Hc(Number(Qe[0]), Number(Qe[1]));
                                if (!Array.isArray(Qe) && "object" == typeof Qe && null !== Qe) return new Hc(Number("lng" in Qe ? Qe.lng : Qe.lon), Number(Qe.lat));
                                throw new Error("`LngLatLike` argument must be specified as a LngLat instance, an object {lng: <lng>, lat: <lat>}, an object {lon: <lng>, lat: <lat>}, or an array of [<lng>, <lat>]");
                            }
                        }
                        const of = 2 * Math.PI * af;
                        function Jc(Qe) {
                            return of * Math.cos(Qe * Math.PI / 180);
                        }
                        function Wc(Qe) {
                            return (180 + Qe) / 360;
                        }
                        function Qc(Qe) {
                            return (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + Qe * Math.PI / 360))) / 360;
                        }
                        function th(Qe, rt) {
                            return Qe / Jc(rt);
                        }
                        function eh(Qe) {
                            return 360 / Math.PI * Math.atan(Math.exp((180 - 360 * Qe) * Math.PI / 180)) - 90;
                        }
                        function rh(Qe, rt) {
                            return Qe * Jc(eh(rt));
                        }
                        class nh {
                            constructor(Qe, rt, Wn = 0){
                                this.x = +Qe, this.y = +rt, this.z = +Wn;
                            }
                            static fromLngLat(Qe, rt = 0) {
                                const Wn = Hc.convert(Qe);
                                return new nh(Wc(Wn.lng), Qc(Wn.lat), th(rt, Wn.lat));
                            }
                            toLngLat() {
                                return new Hc(360 * this.x - 180, eh(this.y));
                            }
                            toAltitude() {
                                return rh(this.z, this.y);
                            }
                            meterInMercatorCoordinateUnits() {
                                var Qe;
                                return 1 / of * (Qe = eh(this.y), 1 / Math.cos(Qe * Math.PI / 180));
                            }
                        }
                        function ih(Qe, rt, Wn) {
                            var Co = 2 * Math.PI * 6378137 / 256 / Math.pow(2, Wn);
                            return [
                                Qe * Co - 2 * Math.PI * 6378137 / 2,
                                rt * Co - 2 * Math.PI * 6378137 / 2
                            ];
                        }
                        class sh {
                            constructor(Qe, rt, Wn){
                                if (!function(Qe, rt, Wn) {
                                    return !(Qe < 0 || Qe > 25 || Wn < 0 || Wn >= Math.pow(2, Qe) || rt < 0 || rt >= Math.pow(2, Qe));
                                }(Qe, rt, Wn)) throw new Error(`x=${rt}, y=${Wn}, z=${Qe} outside of bounds. 0<=x<${Math.pow(2, Qe)}, 0<=y<${Math.pow(2, Qe)} 0<=z<=25 `);
                                this.z = Qe, this.x = rt, this.y = Wn, this.key = lh(0, Qe, Qe, rt, Wn);
                            }
                            equals(Qe) {
                                return this.z === Qe.z && this.x === Qe.x && this.y === Qe.y;
                            }
                            url(Qe, rt, Wn) {
                                const Co = (Ll = this.y, Rl = this.z, Ul = ih(256 * (Dl = this.x), 256 * (Ll = Math.pow(2, Rl) - Ll - 1), Rl), Gl = ih(256 * (Dl + 1), 256 * (Ll + 1), Rl), Ul[0] + "," + Ul[1] + "," + Gl[0] + "," + Gl[1]);
                                var Dl, Ll, Rl, Ul, Gl;
                                const Zl = function(Qe, rt, Wn) {
                                    let Co, Dl = "";
                                    for(let Ll = Qe; Ll > 0; Ll--)Co = 1 << Ll - 1, Dl += (rt & Co ? 1 : 0) + (Wn & Co ? 2 : 0);
                                    return Dl;
                                }(this.z, this.x, this.y);
                                return Qe[(this.x + this.y) % Qe.length].replace(/{prefix}/g, (this.x % 16).toString(16) + (this.y % 16).toString(16)).replace(/{z}/g, String(this.z)).replace(/{x}/g, String(this.x)).replace(/{y}/g, String("tms" === Wn ? Math.pow(2, this.z) - this.y - 1 : this.y)).replace(/{ratio}/g, rt > 1 ? "@2x" : "").replace(/{quadkey}/g, Zl).replace(/{bbox-epsg-3857}/g, Co);
                            }
                            isChildOf(Qe) {
                                const rt = this.z - Qe.z;
                                return rt > 0 && Qe.x === this.x >> rt && Qe.y === this.y >> rt;
                            }
                            getTilePoint(Qe) {
                                const rt = Math.pow(2, this.z);
                                return new Ll((Qe.x * rt - this.x) * Kl, (Qe.y * rt - this.y) * Kl);
                            }
                            toString() {
                                return `${this.z}/${this.x}/${this.y}`;
                            }
                        }
                        class ah {
                            constructor(Qe, rt){
                                this.wrap = Qe, this.canonical = rt, this.key = lh(Qe, rt.z, rt.z, rt.x, rt.y);
                            }
                        }
                        class oh {
                            constructor(Qe, rt, Wn, Co, Dl){
                                if (this.terrainRttPosMatrix32f = null, Qe < Wn) throw new Error(`overscaledZ should be >= z; overscaledZ = ${Qe}; z = ${Wn}`);
                                this.overscaledZ = Qe, this.wrap = rt, this.canonical = new sh(Wn, +Co, +Dl), this.key = lh(rt, Qe, Wn, Co, Dl);
                            }
                            clone() {
                                return new oh(this.overscaledZ, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y);
                            }
                            equals(Qe) {
                                return this.overscaledZ === Qe.overscaledZ && this.wrap === Qe.wrap && this.canonical.equals(Qe.canonical);
                            }
                            scaledTo(Qe) {
                                if (Qe > this.overscaledZ) throw new Error(`targetZ > this.overscaledZ; targetZ = ${Qe}; overscaledZ = ${this.overscaledZ}`);
                                const rt = this.canonical.z - Qe;
                                return Qe > this.canonical.z ? new oh(Qe, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y) : new oh(Qe, this.wrap, Qe, this.canonical.x >> rt, this.canonical.y >> rt);
                            }
                            calculateScaledKey(Qe, rt) {
                                if (Qe > this.overscaledZ) throw new Error(`targetZ > this.overscaledZ; targetZ = ${Qe}; overscaledZ = ${this.overscaledZ}`);
                                const Wn = this.canonical.z - Qe;
                                return Qe > this.canonical.z ? lh(this.wrap * +rt, Qe, this.canonical.z, this.canonical.x, this.canonical.y) : lh(this.wrap * +rt, Qe, Qe, this.canonical.x >> Wn, this.canonical.y >> Wn);
                            }
                            isChildOf(Qe) {
                                if (Qe.wrap !== this.wrap) return !1;
                                const rt = this.canonical.z - Qe.canonical.z;
                                return 0 === Qe.overscaledZ || Qe.overscaledZ < this.overscaledZ && Qe.canonical.x === this.canonical.x >> rt && Qe.canonical.y === this.canonical.y >> rt;
                            }
                            children(Qe) {
                                if (this.overscaledZ >= Qe) return [
                                    new oh(this.overscaledZ + 1, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y)
                                ];
                                const rt = this.canonical.z + 1, Wn = 2 * this.canonical.x, Co = 2 * this.canonical.y;
                                return [
                                    new oh(rt, this.wrap, rt, Wn, Co),
                                    new oh(rt, this.wrap, rt, Wn + 1, Co),
                                    new oh(rt, this.wrap, rt, Wn, Co + 1),
                                    new oh(rt, this.wrap, rt, Wn + 1, Co + 1)
                                ];
                            }
                            isLessThan(Qe) {
                                return this.wrap < Qe.wrap || !(this.wrap > Qe.wrap) && (this.overscaledZ < Qe.overscaledZ || !(this.overscaledZ > Qe.overscaledZ) && (this.canonical.x < Qe.canonical.x || !(this.canonical.x > Qe.canonical.x) && this.canonical.y < Qe.canonical.y));
                            }
                            wrapped() {
                                return new oh(this.overscaledZ, 0, this.canonical.z, this.canonical.x, this.canonical.y);
                            }
                            unwrapTo(Qe) {
                                return new oh(this.overscaledZ, Qe, this.canonical.z, this.canonical.x, this.canonical.y);
                            }
                            overscaleFactor() {
                                return Math.pow(2, this.overscaledZ - this.canonical.z);
                            }
                            toUnwrapped() {
                                return new ah(this.wrap, this.canonical);
                            }
                            toString() {
                                return `${this.overscaledZ}/${this.canonical.x}/${this.canonical.y}`;
                            }
                            getTilePoint(Qe) {
                                return this.canonical.getTilePoint(new nh(Qe.x - this.wrap, Qe.y));
                            }
                        }
                        function lh(Qe, rt, Wn, Co, Dl) {
                            (Qe *= 2) < 0 && (Qe = -1 * Qe - 1);
                            const Ll = 1 << Wn;
                            return (Ll * Ll * Qe + Ll * Dl + Co).toString(36) + Wn.toString(36) + rt.toString(36);
                        }
                        Zi("CanonicalTileID", sh), Zi("OverscaledTileID", oh, {
                            omit: [
                                "terrainRttPosMatrix32f"
                            ]
                        });
                        class uh {
                            constructor(Qe, rt, Wn, Co = 1, Dl = 1, Ll = 1, Rl = 0){
                                if (this.uid = Qe, rt.height !== rt.width) throw new RangeError("DEM tiles must be square");
                                if (Wn && ![
                                    "mapbox",
                                    "terrarium",
                                    "custom"
                                ].includes(Wn)) return void j(`"${Wn}" is not a valid encoding type. Valid types include "mapbox", "terrarium" and "custom".`);
                                this.stride = rt.height;
                                const Ul = this.dim = rt.height - 2;
                                switch(this.data = new Uint32Array(rt.data.buffer), Wn){
                                    case "terrarium":
                                        this.redFactor = 256, this.greenFactor = 1, this.blueFactor = 1 / 256, this.baseShift = 32768;
                                        break;
                                    case "custom":
                                        this.redFactor = Co, this.greenFactor = Dl, this.blueFactor = Ll, this.baseShift = Rl;
                                        break;
                                    default:
                                        this.redFactor = 6553.6, this.greenFactor = 25.6, this.blueFactor = .1, this.baseShift = 1e4;
                                }
                                for(let Gl = 0; Gl < Ul; Gl++)this.data[this._idx(-1, Gl)] = this.data[this._idx(0, Gl)], this.data[this._idx(Ul, Gl)] = this.data[this._idx(Ul - 1, Gl)], this.data[this._idx(Gl, -1)] = this.data[this._idx(Gl, 0)], this.data[this._idx(Gl, Ul)] = this.data[this._idx(Gl, Ul - 1)];
                                this.data[this._idx(-1, -1)] = this.data[this._idx(0, 0)], this.data[this._idx(Ul, -1)] = this.data[this._idx(Ul - 1, 0)], this.data[this._idx(-1, Ul)] = this.data[this._idx(0, Ul - 1)], this.data[this._idx(Ul, Ul)] = this.data[this._idx(Ul - 1, Ul - 1)], this.min = Number.MAX_SAFE_INTEGER, this.max = Number.MIN_SAFE_INTEGER;
                                for(let Gl = 0; Gl < Ul; Gl++)for(let Qe = 0; Qe < Ul; Qe++){
                                    const rt = this.get(Gl, Qe);
                                    rt > this.max && (this.max = rt), rt < this.min && (this.min = rt);
                                }
                            }
                            get(Qe, rt) {
                                const Wn = new Uint8Array(this.data.buffer), Co = 4 * this._idx(Qe, rt);
                                return this.unpack(Wn[Co], Wn[Co + 1], Wn[Co + 2]);
                            }
                            getUnpackVector() {
                                return [
                                    this.redFactor,
                                    this.greenFactor,
                                    this.blueFactor,
                                    this.baseShift
                                ];
                            }
                            _idx(Qe, rt) {
                                if (Qe < -1 || Qe >= this.dim + 1 || rt < -1 || rt >= this.dim + 1) throw new RangeError("out of range source coordinates for DEM data");
                                return (rt + 1) * this.stride + (Qe + 1);
                            }
                            unpack(Qe, rt, Wn) {
                                return Qe * this.redFactor + rt * this.greenFactor + Wn * this.blueFactor - this.baseShift;
                            }
                            getPixels() {
                                return new No({
                                    width: this.stride,
                                    height: this.stride
                                }, new Uint8Array(this.data.buffer));
                            }
                            backfillBorder(Qe, rt, Wn) {
                                if (this.dim !== Qe.dim) throw new Error("dem dimension mismatch");
                                let Co = rt * this.dim, Dl = rt * this.dim + this.dim, Ll = Wn * this.dim, Rl = Wn * this.dim + this.dim;
                                switch(rt){
                                    case -1:
                                        Co = Dl - 1;
                                        break;
                                    case 1:
                                        Dl = Co + 1;
                                }
                                switch(Wn){
                                    case -1:
                                        Ll = Rl - 1;
                                        break;
                                    case 1:
                                        Rl = Ll + 1;
                                }
                                const Ul = -rt * this.dim, Gl = -Wn * this.dim;
                                for(let Zl = Ll; Zl < Rl; Zl++)for(let rt = Co; rt < Dl; rt++)this.data[this._idx(rt, Zl)] = Qe.data[this._idx(rt + Ul, Zl + Gl)];
                            }
                        }
                        Zi("DEMData", uh);
                        class ch {
                            constructor(Qe){
                                this._stringToNumber = {}, this._numberToString = [];
                                for(let rt = 0; rt < Qe.length; rt++){
                                    const Wn = Qe[rt];
                                    this._stringToNumber[Wn] = rt, this._numberToString[rt] = Wn;
                                }
                            }
                            encode(Qe) {
                                return this._stringToNumber[Qe];
                            }
                            decode(Qe) {
                                if (Qe >= this._numberToString.length) throw new Error(`Out of bounds. Index requested n=${Qe} can't be >= this._numberToString.length ${this._numberToString.length}`);
                                return this._numberToString[Qe];
                            }
                        }
                        class hh {
                            constructor(Qe, rt, Wn, Co, Dl){
                                this.type = "Feature", this._vectorTileFeature = Qe, Qe._z = rt, Qe._x = Wn, Qe._y = Co, this.properties = Qe.properties, this.id = Dl;
                            }
                            get geometry() {
                                return void 0 === this._geometry && (this._geometry = this._vectorTileFeature.toGeoJSON(this._vectorTileFeature._x, this._vectorTileFeature._y, this._vectorTileFeature._z).geometry), this._geometry;
                            }
                            set geometry(Qe) {
                                this._geometry = Qe;
                            }
                            toJSON() {
                                const Qe = {
                                    geometry: this.geometry
                                };
                                for(const rt in this)"_geometry" !== rt && "_vectorTileFeature" !== rt && (Qe[rt] = this[rt]);
                                return Qe;
                            }
                        }
                        class ph {
                            constructor(Qe, rt){
                                this.tileID = Qe, this.x = Qe.canonical.x, this.y = Qe.canonical.y, this.z = Qe.canonical.z, this.grid = new qi(Kl, 16, 0), this.grid3D = new qi(Kl, 16, 0), this.featureIndexArray = new ya, this.promoteId = rt;
                            }
                            insert(Qe, rt, Wn, Co, Dl, Ll) {
                                const Rl = this.featureIndexArray.length;
                                this.featureIndexArray.emplaceBack(Wn, Co, Dl);
                                const Ul = Ll ? this.grid3D : this.grid;
                                for(let Gl = 0; Gl < rt.length; Gl++){
                                    const Qe = rt[Gl], Wn = [
                                        1 / 0,
                                        1 / 0,
                                        -1 / 0,
                                        -1 / 0
                                    ];
                                    for(let rt = 0; rt < Qe.length; rt++){
                                        const Co = Qe[rt];
                                        Wn[0] = Math.min(Wn[0], Co.x), Wn[1] = Math.min(Wn[1], Co.y), Wn[2] = Math.max(Wn[2], Co.x), Wn[3] = Math.max(Wn[3], Co.y);
                                    }
                                    Wn[0] < Kl && Wn[1] < Kl && Wn[2] >= 0 && Wn[3] >= 0 && Ul.insert(Rl, Wn[0], Wn[1], Wn[2], Wn[3]);
                                }
                            }
                            loadVTLayers() {
                                return this.vtLayers || (this.vtLayers = new um.VectorTile(new Bm(this.rawTileData)).layers, this.sourceLayerCoder = new ch(this.vtLayers ? Object.keys(this.vtLayers).sort() : [
                                    "_geojsonTileLayer"
                                ])), this.vtLayers;
                            }
                            query(Qe, rt, Wn, Co) {
                                this.loadVTLayers();
                                const Dl = Qe.params, Rl = Kl / Qe.tileSize / Qe.scale, Ul = Qn(Dl.filter), Gl = Qe.queryGeometry, Zl = Qe.queryPadding * Rl, Hl = dh(Gl), ql = this.grid.query(Hl.minX - Zl, Hl.minY - Zl, Hl.maxX + Zl, Hl.maxY + Zl), Ql = dh(Qe.cameraQueryGeometry), $l = this.grid3D.query(Ql.minX - Zl, Ql.minY - Zl, Ql.maxX + Zl, Ql.maxY + Zl, (rt, Wn, Co, Dl)=>(function(Qe, rt, Wn, Co, Dl) {
                                        for (const Ll of Qe)if (rt <= Ll.x && Wn <= Ll.y && Co >= Ll.x && Dl >= Ll.y) return !0;
                                        const Rl = [
                                            new Ll(rt, Wn),
                                            new Ll(rt, Dl),
                                            new Ll(Co, Dl),
                                            new Ll(Co, Wn)
                                        ];
                                        if (Qe.length > 2) {
                                            for (const Ll of Rl)if (ko(Qe, Ll)) return !0;
                                        }
                                        for(let Ll = 0; Ll < Qe.length - 1; Ll++)if (Mo(Qe[Ll], Qe[Ll + 1], Rl)) return !0;
                                        return !1;
                                    })(Qe.cameraQueryGeometry, rt - Zl, Wn - Zl, Co + Zl, Dl + Zl));
                                for (const Ll of $l)ql.push(Ll);
                                ql.sort(yh);
                                const Tc = {};
                                let tu;
                                for(let Ll = 0; Ll < ql.length; Ll++){
                                    const Zl = ql[Ll];
                                    if (Zl === tu) continue;
                                    tu = Zl;
                                    const Hl = this.featureIndexArray.get(Zl);
                                    let Ql = null;
                                    this.loadMatchingFeature(Tc, Hl.bucketIndex, Hl.sourceLayerIndex, Hl.featureIndex, Ul, Dl.layers, Dl.availableImages, rt, Wn, Co, (rt, Wn, Co)=>(Ql || (Ql = co(rt)), Wn.queryIntersectsFeature({
                                            queryGeometry: Gl,
                                            feature: rt,
                                            featureState: Co,
                                            geometry: Ql,
                                            zoom: this.z,
                                            transform: Qe.transform,
                                            pixelsToTileUnits: Rl,
                                            pixelPosMatrix: Qe.pixelPosMatrix,
                                            unwrappedTileID: this.tileID.toUnwrapped(),
                                            getElevation: Qe.getElevation
                                        })));
                                }
                                return Tc;
                            }
                            loadMatchingFeature(Qe, rt, Wn, Co, Dl, Ll, Rl, Ul, Gl, Zl, Hl) {
                                const ql = this.bucketLayerIDs[rt];
                                if (Ll && !ql.some((Qe)=>Ll.has(Qe))) return;
                                const Ql = this.sourceLayerCoder.decode(Wn), Kl = this.vtLayers[Ql].feature(Co);
                                if (Dl.needGeometry) {
                                    const Qe = ho(Kl, !0);
                                    if (!Dl.filter(new fs(this.tileID.overscaledZ), Qe, this.tileID.canonical)) return;
                                } else if (!Dl.filter(new fs(this.tileID.overscaledZ), Kl)) return;
                                const $l = this.getId(Kl, Ql);
                                for(let Tc = 0; Tc < ql.length; Tc++){
                                    const rt = ql[Tc];
                                    if (Ll && !Ll.has(rt)) continue;
                                    const Wn = Ul[rt];
                                    if (!Wn) continue;
                                    let Dl = {};
                                    $l && Zl && (Dl = Zl.getState(Wn.sourceLayer || "_geojsonTileLayer", $l));
                                    const Ql = F({}, Gl[rt]);
                                    Ql.paint = fh(Ql.paint, Wn.paint, Kl, Dl, Rl), Ql.layout = fh(Ql.layout, Wn.layout, Kl, Dl, Rl);
                                    const tu = !Hl || Hl(Kl, Wn, Dl);
                                    if (!tu) continue;
                                    const lu = new hh(Kl, this.z, this.x, this.y, $l);
                                    lu.layer = Ql;
                                    let du = Qe[rt];
                                    void 0 === du && (du = Qe[rt] = []), du.push({
                                        featureIndex: Co,
                                        feature: lu,
                                        intersectionZ: tu
                                    });
                                }
                            }
                            lookupSymbolFeatures(Qe, rt, Wn, Co, Dl, Ll, Rl, Ul) {
                                const Gl = {};
                                this.loadVTLayers();
                                const Zl = Qn(Dl);
                                for (const Hl of Qe)this.loadMatchingFeature(Gl, Wn, Co, Hl, Zl, Ll, Rl, Ul, rt);
                                return Gl;
                            }
                            hasLayer(Qe) {
                                for (const rt of this.bucketLayerIDs)for (const Wn of rt)if (Qe === Wn) return !0;
                                return !1;
                            }
                            getId(Qe, rt) {
                                var Wn;
                                let Co = Qe.id;
                                return this.promoteId && (Co = Qe.properties["string" == typeof this.promoteId ? this.promoteId : this.promoteId[rt]], "boolean" == typeof Co && (Co = Number(Co)), void 0 === Co && (null === (Wn = Qe.properties) || void 0 === Wn ? void 0 : Wn.cluster) && this.promoteId && (Co = Number(Qe.properties.cluster_id))), Co;
                            }
                        }
                        function fh(Qe, rt, Wn, Co, Dl) {
                            return L1(Qe, (Qe, Ll)=>{
                                const Rl = rt instanceof ws ? rt.get(Ll) : null;
                                return Rl && Rl.evaluate ? Rl.evaluate(Wn, Co, Dl) : Rl;
                            });
                        }
                        function dh(Qe) {
                            let rt = 1 / 0, Wn = 1 / 0, Co = -1 / 0, Dl = -1 / 0;
                            for (const Ll of Qe)rt = Math.min(rt, Ll.x), Wn = Math.min(Wn, Ll.y), Co = Math.max(Co, Ll.x), Dl = Math.max(Dl, Ll.y);
                            return {
                                minX: rt,
                                minY: Wn,
                                maxX: Co,
                                maxY: Dl
                            };
                        }
                        function yh(Qe, rt) {
                            return rt - Qe;
                        }
                        function mh(Qe, rt, Wn, Co, Dl) {
                            const Rl = [];
                            for(let Ul = 0; Ul < Qe.length; Ul++){
                                const Gl = Qe[Ul];
                                let Zl;
                                for(let Qe = 0; Qe < Gl.length - 1; Qe++){
                                    let Ul = Gl[Qe], Hl = Gl[Qe + 1];
                                    Ul.x < rt && Hl.x < rt || (Ul.x < rt ? Ul = new Ll(rt, Ul.y + (rt - Ul.x) / (Hl.x - Ul.x) * (Hl.y - Ul.y))._round() : Hl.x < rt && (Hl = new Ll(rt, Ul.y + (rt - Ul.x) / (Hl.x - Ul.x) * (Hl.y - Ul.y))._round()), Ul.y < Wn && Hl.y < Wn || (Ul.y < Wn ? Ul = new Ll(Ul.x + (Wn - Ul.y) / (Hl.y - Ul.y) * (Hl.x - Ul.x), Wn)._round() : Hl.y < Wn && (Hl = new Ll(Ul.x + (Wn - Ul.y) / (Hl.y - Ul.y) * (Hl.x - Ul.x), Wn)._round()), Ul.x >= Co && Hl.x >= Co || (Ul.x >= Co ? Ul = new Ll(Co, Ul.y + (Co - Ul.x) / (Hl.x - Ul.x) * (Hl.y - Ul.y))._round() : Hl.x >= Co && (Hl = new Ll(Co, Ul.y + (Co - Ul.x) / (Hl.x - Ul.x) * (Hl.y - Ul.y))._round()), Ul.y >= Dl && Hl.y >= Dl || (Ul.y >= Dl ? Ul = new Ll(Ul.x + (Dl - Ul.y) / (Hl.y - Ul.y) * (Hl.x - Ul.x), Dl)._round() : Hl.y >= Dl && (Hl = new Ll(Ul.x + (Dl - Ul.y) / (Hl.y - Ul.y) * (Hl.x - Ul.x), Dl)._round()), Zl && Ul.equals(Zl[Zl.length - 1]) || (Zl = [
                                        Ul
                                    ], Rl.push(Zl)), Zl.push(Hl)))));
                                }
                            }
                            return Rl;
                        }
                        Zi("FeatureIndex", ph, {
                            omit: [
                                "rawTileData",
                                "sourceLayerCoder"
                            ]
                        });
                        class gh extends Ll {
                            constructor(Qe, rt, Wn, Co){
                                super(Qe, rt), this.angle = Wn, void 0 !== Co && (this.segment = Co);
                            }
                            clone() {
                                return new gh(this.x, this.y, this.angle, this.segment);
                            }
                        }
                        function xh(Qe, rt, Wn, Co, Dl) {
                            if (void 0 === rt.segment || 0 === Wn) return !0;
                            let Ll = rt, Rl = rt.segment + 1, Ul = 0;
                            for(; Ul > -Wn / 2;){
                                if (Rl--, Rl < 0) return !1;
                                Ul -= Qe[Rl].dist(Ll), Ll = Qe[Rl];
                            }
                            Ul += Qe[Rl].dist(Qe[Rl + 1]), Rl++;
                            const Gl = [];
                            let Zl = 0;
                            for(; Ul < Wn / 2;){
                                const rt = Qe[Rl], Wn = Qe[Rl + 1];
                                if (!Wn) return !1;
                                let Ll = Qe[Rl - 1].angleTo(rt) - rt.angleTo(Wn);
                                for(Ll = Math.abs((Ll + 3 * Math.PI) % (2 * Math.PI) - Math.PI), Gl.push({
                                    distance: Ul,
                                    angleDelta: Ll
                                }), Zl += Ll; Ul - Gl[0].distance > Co;)Zl -= Gl.shift().angleDelta;
                                if (Zl > Dl) return !1;
                                Rl++, Ul += rt.dist(Wn);
                            }
                            return !0;
                        }
                        function vh(Qe) {
                            let rt = 0;
                            for(let Wn = 0; Wn < Qe.length - 1; Wn++)rt += Qe[Wn].dist(Qe[Wn + 1]);
                            return rt;
                        }
                        function bh(Qe, rt, Wn) {
                            return Qe ? .6 * rt * Wn : 0;
                        }
                        function wh(Qe, rt) {
                            return Math.max(Qe ? Qe.right - Qe.left : 0, rt ? rt.right - rt.left : 0);
                        }
                        function _h(Qe, rt, Wn, Co, Dl, Ll) {
                            const Rl = bh(Wn, Dl, Ll), Ul = wh(Wn, Co) * Ll;
                            let Gl = 0;
                            const Zl = vh(Qe) / 2;
                            for(let Hl = 0; Hl < Qe.length - 1; Hl++){
                                const Wn = Qe[Hl], Co = Qe[Hl + 1], Dl = Wn.dist(Co);
                                if (Gl + Dl > Zl) {
                                    const Ll = (Zl - Gl) / Dl, ql = Ld.number(Wn.x, Co.x, Ll), Ql = Ld.number(Wn.y, Co.y, Ll), Kl = new gh(ql, Ql, Co.angleTo(Wn), Hl);
                                    return Kl._round(), !Rl || xh(Qe, Kl, Ul, Rl, rt) ? Kl : void 0;
                                }
                                Gl += Dl;
                            }
                        }
                        function Sh(Qe, rt, Wn, Co, Dl, Ll, Rl, Ul, Gl) {
                            const Zl = bh(Co, Ll, Rl), Hl = wh(Co, Dl), ql = Hl * Rl, Ql = 0 === Qe[0].x || Qe[0].x === Gl || 0 === Qe[0].y || Qe[0].y === Gl;
                            return rt - ql < rt / 4 && (rt = ql + rt / 4), Ah(Qe, Ql ? rt / 2 * Ul % rt : (Hl / 2 + 2 * Ll) * Rl * Ul % rt, rt, Zl, Wn, ql, Ql, !1, Gl);
                        }
                        function Ah(Qe, rt, Wn, Co, Dl, Ll, Rl, Ul, Gl) {
                            const Zl = Ll / 2, Hl = vh(Qe);
                            let ql = 0, Ql = rt - Wn, Kl = [];
                            for(let $l = 0; $l < Qe.length - 1; $l++){
                                const rt = Qe[$l], Rl = Qe[$l + 1], Ul = rt.dist(Rl), Tc = Rl.angleTo(rt);
                                for(; Ql + Wn < ql + Ul;){
                                    Ql += Wn;
                                    const tu = (Ql - ql) / Ul, lu = Ld.number(rt.x, Rl.x, tu), du = Ld.number(rt.y, Rl.y, tu);
                                    if (lu >= 0 && lu < Gl && du >= 0 && du < Gl && Ql - Zl >= 0 && Ql + Zl <= Hl) {
                                        const rt = new gh(lu, du, Tc, $l);
                                        rt._round(), Co && !xh(Qe, rt, Ll, Co, Dl) || Kl.push(rt);
                                    }
                                }
                                ql += Ul;
                            }
                            return Ul || Kl.length || Rl || (Kl = Ah(Qe, ql / 2, Wn, Co, Dl, Ll, Rl, !0, Gl)), Kl;
                        }
                        Zi("Anchor", gh);
                        const lf = jm;
                        function Mh(Qe, rt, Wn, Co) {
                            const Dl = [], Rl = Qe.image, Ul = Rl.pixelRatio, Gl = Rl.paddedRect.w - 2 * lf, Zl = Rl.paddedRect.h - 2 * lf;
                            let Hl = {
                                x1: Qe.left,
                                y1: Qe.top,
                                x2: Qe.right,
                                y2: Qe.bottom
                            };
                            const ql = Rl.stretchX || [
                                [
                                    0,
                                    Gl
                                ]
                            ], Ql = Rl.stretchY || [
                                [
                                    0,
                                    Zl
                                ]
                            ], f = (Qe, rt)=>Qe + rt[1] - rt[0], Kl = ql.reduce(f, 0), $l = Ql.reduce(f, 0), Tc = Gl - Kl, tu = Zl - $l;
                            let lu = 0, du = Kl, fu = 0, yu = $l, Eu = 0, Tu = Tc, Lu = 0, Zu = tu;
                            if (Rl.content && Co) {
                                const rt = Rl.content, Wn = rt[2] - rt[0], Co = rt[3] - rt[1];
                                (Rl.textFitWidth || Rl.textFitHeight) && (Hl = vc(Qe)), lu = Ih(ql, 0, rt[0]), fu = Ih(Ql, 0, rt[1]), du = Ih(ql, rt[0], rt[2]), yu = Ih(Ql, rt[1], rt[3]), Eu = rt[0] - lu, Lu = rt[1] - fu, Tu = Wn - du, Zu = Co - yu;
                            }
                            const Xu = Hl.x1, Ju = Hl.y1, $u = Hl.x2 - Xu, ed = Hl.y2 - Ju, C = (Qe, Co, Dl, Gl)=>{
                                const Zl = Ph(Qe.stretch - lu, du, $u, Xu), Hl = Ch(Qe.fixed - Eu, Tu, Qe.stretch, Kl), ql = Ph(Co.stretch - fu, yu, ed, Ju), Ql = Ch(Co.fixed - Lu, Zu, Co.stretch, $l), Tc = Ph(Dl.stretch - lu, du, $u, Xu), tu = Ch(Dl.fixed - Eu, Tu, Dl.stretch, Kl), td = Ph(Gl.stretch - fu, yu, ed, Ju), id = Ch(Gl.fixed - Lu, Zu, Gl.stretch, $l), nd = new Ll(Zl, ql), rd = new Ll(Tc, ql), sd = new Ll(Tc, td), ad = new Ll(Zl, td), od = new Ll(Hl / Ul, Ql / Ul), ld = new Ll(tu / Ul, id / Ul), cd = rt * Math.PI / 180;
                                if (cd) {
                                    const Qe = Math.sin(cd), rt = Math.cos(cd), Wn = [
                                        rt,
                                        -Qe,
                                        Qe,
                                        rt
                                    ];
                                    nd._matMult(Wn), rd._matMult(Wn), ad._matMult(Wn), sd._matMult(Wn);
                                }
                                const ud = Qe.stretch + Qe.fixed, hd = Co.stretch + Co.fixed;
                                return {
                                    tl: nd,
                                    tr: rd,
                                    bl: ad,
                                    br: sd,
                                    tex: {
                                        x: Rl.paddedRect.x + lf + ud,
                                        y: Rl.paddedRect.y + lf + hd,
                                        w: Dl.stretch + Dl.fixed - ud,
                                        h: Gl.stretch + Gl.fixed - hd
                                    },
                                    writingMode: void 0,
                                    glyphOffset: [
                                        0,
                                        0
                                    ],
                                    sectionIndex: 0,
                                    pixelOffsetTL: od,
                                    pixelOffsetBR: ld,
                                    minFontScaleX: Tu / Ul / $u,
                                    minFontScaleY: Zu / Ul / ed,
                                    isSDF: Wn
                                };
                            };
                            if (Co && (Rl.stretchX || Rl.stretchY)) {
                                const Qe = zh(ql, Tc, Kl), rt = zh(Ql, tu, $l);
                                for(let Wn = 0; Wn < Qe.length - 1; Wn++){
                                    const Co = Qe[Wn], Ll = Qe[Wn + 1];
                                    for(let Qe = 0; Qe < rt.length - 1; Qe++)Dl.push(C(Co, rt[Qe], Ll, rt[Qe + 1]));
                                }
                            } else Dl.push(C({
                                fixed: 0,
                                stretch: -1
                            }, {
                                fixed: 0,
                                stretch: -1
                            }, {
                                fixed: 0,
                                stretch: Gl + 1
                            }, {
                                fixed: 0,
                                stretch: Zl + 1
                            }));
                            return Dl;
                        }
                        function Ih(Qe, rt, Wn) {
                            let Co = 0;
                            for (const Dl of Qe)Co += Math.max(rt, Math.min(Wn, Dl[1])) - Math.max(rt, Math.min(Wn, Dl[0]));
                            return Co;
                        }
                        function zh(Qe, rt, Wn) {
                            const Co = [
                                {
                                    fixed: -1,
                                    stretch: 0
                                }
                            ];
                            for (const [Dl, Ll] of Qe){
                                const Qe = Co[Co.length - 1];
                                Co.push({
                                    fixed: Dl - Qe.stretch,
                                    stretch: Qe.stretch
                                }), Co.push({
                                    fixed: Dl - Qe.stretch,
                                    stretch: Qe.stretch + (Ll - Dl)
                                });
                            }
                            return Co.push({
                                fixed: rt + lf,
                                stretch: Wn
                            }), Co;
                        }
                        function Ph(Qe, rt, Wn, Co) {
                            return Qe / rt * Wn + Co;
                        }
                        function Ch(Qe, rt, Wn, Co) {
                            return Qe - rt * Wn / Co;
                        }
                        class Bh {
                            constructor(Qe, rt, Wn, Co, Dl, Rl, Ul, Gl, Zl, Hl){
                                var ql;
                                if (this.boxStartIndex = Qe.length, Zl) {
                                    let Qe = Rl.top, rt = Rl.bottom;
                                    const Wn = Rl.collisionPadding;
                                    Wn && (Qe -= Wn[1], rt += Wn[3]);
                                    let Co = rt - Qe;
                                    Co > 0 && (Co = Math.max(10, Co), this.circleDiameter = Co);
                                } else {
                                    const Zl = (null === (ql = Rl.image) || void 0 === ql ? void 0 : ql.content) && (Rl.image.textFitWidth || Rl.image.textFitHeight) ? vc(Rl) : {
                                        x1: Rl.left,
                                        y1: Rl.top,
                                        x2: Rl.right,
                                        y2: Rl.bottom
                                    };
                                    Zl.y1 = Zl.y1 * Ul - Gl[0], Zl.y2 = Zl.y2 * Ul + Gl[2], Zl.x1 = Zl.x1 * Ul - Gl[3], Zl.x2 = Zl.x2 * Ul + Gl[1];
                                    const Ql = Rl.collisionPadding;
                                    if (Ql && (Zl.x1 -= Ql[0] * Ul, Zl.y1 -= Ql[1] * Ul, Zl.x2 += Ql[2] * Ul, Zl.y2 += Ql[3] * Ul), Hl) {
                                        const Qe = new Ll(Zl.x1, Zl.y1), rt = new Ll(Zl.x2, Zl.y1), Wn = new Ll(Zl.x1, Zl.y2), Co = new Ll(Zl.x2, Zl.y2), Dl = Hl * Math.PI / 180;
                                        Qe._rotate(Dl), rt._rotate(Dl), Wn._rotate(Dl), Co._rotate(Dl), Zl.x1 = Math.min(Qe.x, rt.x, Wn.x, Co.x), Zl.x2 = Math.max(Qe.x, rt.x, Wn.x, Co.x), Zl.y1 = Math.min(Qe.y, rt.y, Wn.y, Co.y), Zl.y2 = Math.max(Qe.y, rt.y, Wn.y, Co.y);
                                    }
                                    Qe.emplaceBack(rt.x, rt.y, Zl.x1, Zl.y1, Zl.x2, Zl.y2, Wn, Co, Dl);
                                }
                                this.boxEndIndex = Qe.length;
                            }
                        }
                        class Vh {
                            constructor(Qe = [], rt = (Qe, rt)=>Qe < rt ? -1 : Qe > rt ? 1 : 0){
                                if (this.data = Qe, this.length = this.data.length, this.compare = rt, this.length > 0) for(let Wn = (this.length >> 1) - 1; Wn >= 0; Wn--)this._down(Wn);
                            }
                            push(Qe) {
                                this.data.push(Qe), this._up(this.length++);
                            }
                            pop() {
                                if (0 === this.length) return;
                                const Qe = this.data[0], rt = this.data.pop();
                                return --this.length > 0 && (this.data[0] = rt, this._down(0)), Qe;
                            }
                            peek() {
                                return this.data[0];
                            }
                            _up(Qe) {
                                const { data: rt, compare: Wn } = this, Co = rt[Qe];
                                for(; Qe > 0;){
                                    const Dl = Qe - 1 >> 1, Ll = rt[Dl];
                                    if (Wn(Co, Ll) >= 0) break;
                                    rt[Qe] = Ll, Qe = Dl;
                                }
                                rt[Qe] = Co;
                            }
                            _down(Qe) {
                                const { data: rt, compare: Wn } = this, Co = this.length >> 1, Dl = rt[Qe];
                                for(; Qe < Co;){
                                    let Co = 1 + (Qe << 1);
                                    const Ll = Co + 1;
                                    if (Ll < this.length && Wn(rt[Ll], rt[Co]) < 0 && (Co = Ll), Wn(rt[Co], Dl) >= 0) break;
                                    rt[Qe] = rt[Co], Qe = Co;
                                }
                                rt[Qe] = Dl;
                            }
                        }
                        function Eh(Qe, rt = 1, Wn = !1) {
                            let Co = 1 / 0, Dl = 1 / 0, Rl = -1 / 0, Ul = -1 / 0;
                            const Gl = Qe[0];
                            for(let Ll = 0; Ll < Gl.length; Ll++){
                                const Qe = Gl[Ll];
                                (!Ll || Qe.x < Co) && (Co = Qe.x), (!Ll || Qe.y < Dl) && (Dl = Qe.y), (!Ll || Qe.x > Rl) && (Rl = Qe.x), (!Ll || Qe.y > Ul) && (Ul = Qe.y);
                            }
                            const Zl = Math.min(Rl - Co, Ul - Dl);
                            let Hl = Zl / 2;
                            const ql = new Vh([], Th);
                            if (0 === Zl) return new Ll(Co, Dl);
                            for(let Ll = Co; Ll < Rl; Ll += Zl)for(let rt = Dl; rt < Ul; rt += Zl)ql.push(new Fh(Ll + Hl, rt + Hl, Hl, Qe));
                            let Ql = function(Qe) {
                                let rt = 0, Wn = 0, Co = 0;
                                const Dl = Qe[0];
                                for(let Ll = 0, Rl = Dl.length, Ul = Rl - 1; Ll < Rl; Ul = Ll++){
                                    const Qe = Dl[Ll], Rl = Dl[Ul], Gl = Qe.x * Rl.y - Rl.x * Qe.y;
                                    Wn += (Qe.x + Rl.x) * Gl, Co += (Qe.y + Rl.y) * Gl, rt += 3 * Gl;
                                }
                                return new Fh(Wn / rt, Co / rt, 0, Qe);
                            }(Qe), Kl = ql.length;
                            for(; ql.length;){
                                const Co = ql.pop();
                                (Co.d > Ql.d || !Ql.d) && (Ql = Co, Wn && console.log("found best %d after %d probes", Math.round(1e4 * Co.d) / 1e4, Kl)), Co.max - Ql.d <= rt || (Hl = Co.h / 2, ql.push(new Fh(Co.p.x - Hl, Co.p.y - Hl, Hl, Qe)), ql.push(new Fh(Co.p.x + Hl, Co.p.y - Hl, Hl, Qe)), ql.push(new Fh(Co.p.x - Hl, Co.p.y + Hl, Hl, Qe)), ql.push(new Fh(Co.p.x + Hl, Co.p.y + Hl, Hl, Qe)), Kl += 4);
                            }
                            return Wn && (console.log(`num probes: ${Kl}`), console.log(`best distance: ${Ql.d}`)), Ql.p;
                        }
                        function Th(Qe, rt) {
                            return rt.max - Qe.max;
                        }
                        function Fh(Qe, rt, Wn, Co) {
                            this.p = new Ll(Qe, rt), this.h = Wn, this.d = function(Qe, rt) {
                                let Wn = !1, Co = 1 / 0;
                                for(let Dl = 0; Dl < rt.length; Dl++){
                                    const Ll = rt[Dl];
                                    for(let rt = 0, Dl = Ll.length, Rl = Dl - 1; rt < Dl; Rl = rt++){
                                        const Dl = Ll[rt], Ul = Ll[Rl];
                                        Dl.y > Qe.y != Ul.y > Qe.y && Qe.x < (Ul.x - Dl.x) * (Qe.y - Dl.y) / (Ul.y - Dl.y) + Dl.x && (Wn = !Wn), Co = Math.min(Co, So(Qe, Dl, Ul));
                                    }
                                }
                                return (Wn ? 1 : -1) * Math.sqrt(Co);
                            }(this.p, Co), this.max = this.d + this.h * Math.SQRT2;
                        }
                        var cf;
                        Qe.ay = void 0, (cf = Qe.ay || (Qe.ay = {}))[cf.center = 1] = "center", cf[cf.left = 2] = "left", cf[cf.right = 3] = "right", cf[cf.top = 4] = "top", cf[cf.bottom = 5] = "bottom", cf[cf["top-left"] = 6] = "top-left", cf[cf["top-right"] = 7] = "top-right", cf[cf["bottom-left"] = 8] = "bottom-left", cf[cf["bottom-right"] = 9] = "bottom-right";
                        const uf = 7, hf = Number.POSITIVE_INFINITY;
                        function Dh(Qe, rt) {
                            return rt[1] !== hf ? function(Qe, rt, Wn) {
                                let Co = 0, Dl = 0;
                                switch(rt = Math.abs(rt), Wn = Math.abs(Wn), Qe){
                                    case "top-right":
                                    case "top-left":
                                    case "top":
                                        Dl = Wn - uf;
                                        break;
                                    case "bottom-right":
                                    case "bottom-left":
                                    case "bottom":
                                        Dl = -Wn + uf;
                                }
                                switch(Qe){
                                    case "top-right":
                                    case "bottom-right":
                                    case "right":
                                        Co = -rt;
                                        break;
                                    case "top-left":
                                    case "bottom-left":
                                    case "left":
                                        Co = rt;
                                }
                                return [
                                    Co,
                                    Dl
                                ];
                            }(Qe, rt[0], rt[1]) : function(Qe, rt) {
                                let Wn = 0, Co = 0;
                                rt < 0 && (rt = 0);
                                const Dl = rt / Math.SQRT2;
                                switch(Qe){
                                    case "top-right":
                                    case "top-left":
                                        Co = Dl - uf;
                                        break;
                                    case "bottom-right":
                                    case "bottom-left":
                                        Co = -Dl + uf;
                                        break;
                                    case "bottom":
                                        Co = -rt + uf;
                                        break;
                                    case "top":
                                        Co = rt - uf;
                                }
                                switch(Qe){
                                    case "top-right":
                                    case "bottom-right":
                                        Wn = -Dl;
                                        break;
                                    case "top-left":
                                    case "bottom-left":
                                        Wn = Dl;
                                        break;
                                    case "left":
                                        Wn = rt;
                                        break;
                                    case "right":
                                        Wn = -rt;
                                }
                                return [
                                    Wn,
                                    Co
                                ];
                            }(Qe, rt[0]);
                        }
                        function Rh(Qe, rt, Wn) {
                            var Co;
                            const Dl = Qe.layout, Ll = null === (Co = Dl.get("text-variable-anchor-offset")) || void 0 === Co ? void 0 : Co.evaluate(rt, {}, Wn);
                            if (Ll) {
                                const Qe = Ll.values, rt = [];
                                for(let Wn = 0; Wn < Qe.length; Wn += 2){
                                    const Co = rt[Wn] = Qe[Wn], Dl = Qe[Wn + 1].map((Qe)=>Qe * Nm);
                                    Co.startsWith("top") ? Dl[1] -= uf : Co.startsWith("bottom") && (Dl[1] += uf), rt[Wn + 1] = Dl;
                                }
                                return new Me(rt);
                            }
                            const Rl = Dl.get("text-variable-anchor");
                            if (Rl) {
                                let Co;
                                Co = void 0 !== Qe._unevaluatedLayout.getValue("text-radial-offset") ? [
                                    Dl.get("text-radial-offset").evaluate(rt, {}, Wn) * Nm,
                                    hf
                                ] : Dl.get("text-offset").evaluate(rt, {}, Wn).map((Qe)=>Qe * Nm);
                                const Ll = [];
                                for (const Qe of Rl)Ll.push(Qe, Dh(Qe, Co));
                                return new Me(Ll);
                            }
                            return null;
                        }
                        function jh(Qe) {
                            switch(Qe){
                                case "right":
                                case "top-right":
                                case "bottom-right":
                                    return "right";
                                case "left":
                                case "top-left":
                                case "bottom-left":
                                    return "left";
                            }
                            return "center";
                        }
                        function Nh(rt, Wn, Co, Dl, Ll, Rl, Ul, Gl, Zl, Hl, ql, Ql) {
                            let $l = Rl.textMaxSize.evaluate(Wn, {});
                            void 0 === $l && ($l = Ul);
                            const Tc = rt.layers[0].layout, tu = Tc.get("icon-offset").evaluate(Wn, {}, ql), lu = qh(Co.horizontal), du = Ul / 24, fu = rt.tilePixelRatio * du, yu = rt.tilePixelRatio * $l / 24, Eu = rt.tilePixelRatio * Gl, Tu = rt.tilePixelRatio * Tc.get("symbol-spacing"), Lu = Tc.get("text-padding") * rt.tilePixelRatio, Zu = function(Qe, rt, Wn, Co = 1) {
                                const Dl = Qe.get("icon-padding").evaluate(rt, {}, Wn), Ll = Dl && Dl.values;
                                return [
                                    Ll[0] * Co,
                                    Ll[1] * Co,
                                    Ll[2] * Co,
                                    Ll[3] * Co
                                ];
                            }(Tc, Wn, ql, rt.tilePixelRatio), Xu = Tc.get("text-max-angle") / 180 * Math.PI, Ju = "viewport" !== Tc.get("text-rotation-alignment") && "point" !== Tc.get("symbol-placement"), $u = "map" === Tc.get("icon-rotation-alignment") && "point" !== Tc.get("symbol-placement"), ed = Tc.get("symbol-placement"), td = Tu / 2, id = Tc.get("icon-text-fit");
                            let nd;
                            Dl && "none" !== id && (rt.allowVerticalPlacement && Co.vertical && (nd = bc(Dl, Co.vertical, id, Tc.get("icon-text-fit-padding"), tu, du)), lu && (Dl = bc(Dl, lu, id, Tc.get("icon-text-fit-padding"), tu, du)));
                            const rd = ql ? Ql.line.getGranularityForZoomLevel(ql.z) : 1, E = (Gl, Ql)=>{
                                Ql.x < 0 || Ql.x >= Kl || Ql.y < 0 || Ql.y >= Kl || function(rt, Wn, Co, Dl, Ll, Rl, Ul, Gl, Zl, Hl, ql, Ql, Kl, $l, Tc, tu, lu, du, fu, yu, Eu, Tu, Lu, Zu, Xu) {
                                    const Ju = rt.addToLineVertexArray(Wn, Co);
                                    let $u, ed, td, id, nd = 0, rd = 0, sd = 0, ad = 0, od = -1, ld = -1;
                                    const cd = {};
                                    let ud = Pp("");
                                    if (rt.allowVerticalPlacement && Dl.vertical) {
                                        const Qe = Gl.layout.get("text-rotate").evaluate(Eu, {}, Zu) + 90;
                                        td = new Bh(Zl, Wn, Hl, ql, Ql, Dl.vertical, Kl, $l, Tc, Qe), Ul && (id = new Bh(Zl, Wn, Hl, ql, Ql, Ul, lu, du, Tc, Qe));
                                    }
                                    if (Ll) {
                                        const Co = Gl.layout.get("icon-rotate").evaluate(Eu, {}), Dl = "none" !== Gl.layout.get("icon-text-fit"), Rl = Mh(Ll, Co, Lu, Dl), Kl = Ul ? Mh(Ul, Co, Lu, Dl) : void 0;
                                        ed = new Bh(Zl, Wn, Hl, ql, Ql, Ll, lu, du, !1, Co), nd = 4 * Rl.length;
                                        const $l = rt.iconSizeData;
                                        let Tc = null;
                                        "source" === $l.kind ? (Tc = [
                                            qm * Gl.layout.get("icon-size").evaluate(Eu, {})
                                        ], Tc[0] > Ym && j(`${rt.layerIds[0]}: Value for "icon-size" is >= ${Wm}. Reduce your "icon-size".`)) : "composite" === $l.kind && (Tc = [
                                            qm * Tu.compositeIconSizes[0].evaluate(Eu, {}, Zu),
                                            qm * Tu.compositeIconSizes[1].evaluate(Eu, {}, Zu)
                                        ], (Tc[0] > Ym || Tc[1] > Ym) && j(`${rt.layerIds[0]}: Value for "icon-size" is >= ${Wm}. Reduce your "icon-size".`)), rt.addSymbols(rt.icon, Rl, Tc, yu, fu, Eu, Qe.ah.none, Wn, Ju.lineStartIndex, Ju.lineLength, -1, Zu), od = rt.icon.placedSymbolArray.length - 1, Kl && (rd = 4 * Kl.length, rt.addSymbols(rt.icon, Kl, Tc, yu, fu, Eu, Qe.ah.vertical, Wn, Ju.lineStartIndex, Ju.lineLength, -1, Zu), ld = rt.icon.placedSymbolArray.length - 1);
                                    }
                                    const hd = Object.keys(Dl.horizontal);
                                    for (const Md of hd){
                                        const Co = Dl.horizontal[Md];
                                        if (!$u) {
                                            ud = Pp(Co.text);
                                            const Qe = Gl.layout.get("text-rotate").evaluate(Eu, {}, Zu);
                                            $u = new Bh(Zl, Wn, Hl, ql, Ql, Co, Kl, $l, Tc, Qe);
                                        }
                                        const Ll = 1 === Co.positionedLines.length;
                                        if (sd += Uh(rt, Wn, Co, Rl, Gl, Tc, Eu, tu, Ju, Dl.vertical ? Qe.ah.horizontal : Qe.ah.horizontalOnly, Ll ? hd : [
                                            Md
                                        ], cd, od, Tu, Zu), Ll) break;
                                    }
                                    Dl.vertical && (ad += Uh(rt, Wn, Dl.vertical, Rl, Gl, Tc, Eu, tu, Ju, Qe.ah.vertical, [
                                        "vertical"
                                    ], cd, ld, Tu, Zu));
                                    const dd = $u ? $u.boxStartIndex : rt.collisionBoxArray.length, pd = $u ? $u.boxEndIndex : rt.collisionBoxArray.length, md = td ? td.boxStartIndex : rt.collisionBoxArray.length, fd = td ? td.boxEndIndex : rt.collisionBoxArray.length, gd = ed ? ed.boxStartIndex : rt.collisionBoxArray.length, Ad = ed ? ed.boxEndIndex : rt.collisionBoxArray.length, yd = id ? id.boxStartIndex : rt.collisionBoxArray.length, vd = id ? id.boxEndIndex : rt.collisionBoxArray.length;
                                    let _d = -1;
                                    const Y = (Qe, rt)=>Qe && Qe.circleDiameter ? Math.max(Qe.circleDiameter, rt) : rt;
                                    _d = Y($u, _d), _d = Y(td, _d), _d = Y(ed, _d), _d = Y(id, _d);
                                    const xd = _d > -1 ? 1 : 0;
                                    xd && (_d *= Xu / Nm), rt.glyphOffsetArray.length >= Ec.MAX_GLYPHS && j("Too many glyphs being rendered in a tile. See https://github.com/mapbox/mapbox-gl-js/issues/2907"), void 0 !== Eu.sortKey && rt.addToSortKeyRanges(rt.symbolInstances.length, Eu.sortKey);
                                    const bd = Rh(Gl, Eu, Zu), [wd, Ed] = function(rt, Wn) {
                                        const Co = rt.length, Dl = null == Wn ? void 0 : Wn.values;
                                        if ((null == Dl ? void 0 : Dl.length) > 0) for(let Ll = 0; Ll < Dl.length; Ll += 2){
                                            const Wn = Dl[Ll + 1];
                                            rt.emplaceBack(Qe.ay[Dl[Ll]], Wn[0], Wn[1]);
                                        }
                                        return [
                                            Co,
                                            rt.length
                                        ];
                                    }(rt.textAnchorOffsets, bd);
                                    rt.symbolInstances.emplaceBack(Wn.x, Wn.y, cd.right >= 0 ? cd.right : -1, cd.center >= 0 ? cd.center : -1, cd.left >= 0 ? cd.left : -1, cd.vertical || -1, od, ld, ud, dd, pd, md, fd, gd, Ad, yd, vd, Hl, sd, ad, nd, rd, xd, 0, Kl, _d, wd, Ed);
                                }(rt, Ql, Gl, Co, Dl, Ll, nd, rt.layers[0], rt.collisionBoxArray, Wn.index, Wn.sourceLayerIndex, rt.index, fu, [
                                    Lu,
                                    Lu,
                                    Lu,
                                    Lu
                                ], Ju, Zl, Eu, Zu, $u, tu, Wn, Rl, Hl, ql, Ul);
                            };
                            if ("line" === ed) for (const Qe of mh(Wn.geometry, 0, 0, Kl, Kl)){
                                const Wn = Cl(Qe, rd), Ll = Sh(Wn, Tu, Xu, Co.vertical || lu, Dl, 24, yu, rt.overscaling, Kl);
                                for (const Qe of Ll)lu && Gh(rt, lu.text, td, Qe) || E(Wn, Qe);
                            }
                            else if ("line-center" === ed) {
                                for (const Qe of Wn.geometry)if (Qe.length > 1) {
                                    const rt = Cl(Qe, rd), Wn = _h(rt, Xu, Co.vertical || lu, Dl, 24, yu);
                                    Wn && E(rt, Wn);
                                }
                            } else if ("Polygon" === Wn.type) for (const Qe of Ur(Wn.geometry, 0)){
                                const rt = Eh(Qe, 16);
                                E(Cl(Qe[0], rd, !0), new gh(rt.x, rt.y, 0));
                            }
                            else if ("LineString" === Wn.type) for (const Qe of Wn.geometry){
                                const rt = Cl(Qe, rd);
                                E(rt, new gh(rt[0].x, rt[0].y, 0));
                            }
                            else if ("Point" === Wn.type) for (const Qe of Wn.geometry)for (const rt of Qe)E([
                                rt
                            ], new gh(rt.x, rt.y, 0));
                        }
                        function Uh(Qe, rt, Wn, Co, Dl, Rl, Ul, Gl, Zl, Hl, ql, Ql, Kl, $l, Tc) {
                            const tu = function(Qe, rt, Wn, Co, Dl, Rl, Ul, Gl) {
                                const Zl = Co.layout.get("text-rotate").evaluate(Rl, {}) * Math.PI / 180, Hl = [];
                                for (const ql of rt.positionedLines)for (const Qe of ql.positionedGlyphs){
                                    if (!Qe.rect) continue;
                                    const Co = Qe.rect || {};
                                    let Rl = Fm + 1, Ql = !0, Kl = 1, $l = 0;
                                    const Tc = (Dl || Gl) && Qe.vertical, tu = Qe.metrics.advance * Qe.scale / 2;
                                    if (Gl && rt.verticalizable && ($l = ql.lineOffset / 2 - (Qe.imageName ? -(Nm - Qe.metrics.width * Qe.scale) / 2 : (Qe.scale - 1) * Nm)), Qe.imageName) {
                                        const rt = Ul[Qe.imageName];
                                        Ql = rt.sdf, Kl = rt.pixelRatio, Rl = jm / Kl;
                                    }
                                    const lu = Dl ? [
                                        Qe.x + tu,
                                        Qe.y
                                    ] : [
                                        0,
                                        0
                                    ];
                                    let du = Dl ? [
                                        0,
                                        0
                                    ] : [
                                        Qe.x + tu + Wn[0],
                                        Qe.y + Wn[1] - $l
                                    ], fu = [
                                        0,
                                        0
                                    ];
                                    Tc && (fu = du, du = [
                                        0,
                                        0
                                    ]);
                                    const yu = Qe.metrics.isDoubleResolution ? 2 : 1, Eu = (Qe.metrics.left - Rl) * Qe.scale - tu + du[0], Tu = (-Qe.metrics.top - Rl) * Qe.scale + du[1], Lu = Eu + Co.w / yu * Qe.scale / Kl, Zu = Tu + Co.h / yu * Qe.scale / Kl, Xu = new Ll(Eu, Tu), Ju = new Ll(Lu, Tu), $u = new Ll(Eu, Zu), ed = new Ll(Lu, Zu);
                                    if (Tc) {
                                        const rt = new Ll(-tu, tu - Vm), Wn = -Math.PI / 2, Co = Nm / 2 - tu, Dl = new Ll(5 - Vm - Co, -(Qe.imageName ? Co : 0)), Rl = new Ll(...fu);
                                        Xu._rotateAround(Wn, rt)._add(Dl)._add(Rl), Ju._rotateAround(Wn, rt)._add(Dl)._add(Rl), $u._rotateAround(Wn, rt)._add(Dl)._add(Rl), ed._rotateAround(Wn, rt)._add(Dl)._add(Rl);
                                    }
                                    if (Zl) {
                                        const Qe = Math.sin(Zl), rt = Math.cos(Zl), Wn = [
                                            rt,
                                            -Qe,
                                            Qe,
                                            rt
                                        ];
                                        Xu._matMult(Wn), Ju._matMult(Wn), $u._matMult(Wn), ed._matMult(Wn);
                                    }
                                    const td = new Ll(0, 0), id = new Ll(0, 0);
                                    Hl.push({
                                        tl: Xu,
                                        tr: Ju,
                                        bl: $u,
                                        br: ed,
                                        tex: Co,
                                        writingMode: rt.writingMode,
                                        glyphOffset: lu,
                                        sectionIndex: Qe.sectionIndex,
                                        isSDF: Ql,
                                        pixelOffsetTL: td,
                                        pixelOffsetBR: id,
                                        minFontScaleX: 0,
                                        minFontScaleY: 0
                                    });
                                }
                                return Hl;
                            }(0, Wn, Gl, Dl, Rl, Ul, Co, Qe.allowVerticalPlacement), lu = Qe.textSizeData;
                            let du = null;
                            "source" === lu.kind ? (du = [
                                qm * Dl.layout.get("text-size").evaluate(Ul, {})
                            ], du[0] > Ym && j(`${Qe.layerIds[0]}: Value for "text-size" is >= ${Wm}. Reduce your "text-size".`)) : "composite" === lu.kind && (du = [
                                qm * $l.compositeTextSizes[0].evaluate(Ul, {}, Tc),
                                qm * $l.compositeTextSizes[1].evaluate(Ul, {}, Tc)
                            ], (du[0] > Ym || du[1] > Ym) && j(`${Qe.layerIds[0]}: Value for "text-size" is >= ${Wm}. Reduce your "text-size".`)), Qe.addSymbols(Qe.text, tu, du, Gl, Rl, Ul, Hl, rt, Zl.lineStartIndex, Zl.lineLength, Kl, Tc);
                            for (const Ll of ql)Ql[Ll] = Qe.text.placedSymbolArray.length - 1;
                            return 4 * tu.length;
                        }
                        function qh(Qe) {
                            for(const rt in Qe)return Qe[rt];
                            return null;
                        }
                        function Gh(Qe, rt, Wn, Co) {
                            const Dl = Qe.compareText;
                            if (rt in Dl) {
                                const Qe = Dl[rt];
                                for(let rt = Qe.length - 1; rt >= 0; rt--)if (Co.dist(Qe[rt]) < Wn) return !0;
                            } else Dl[rt] = [];
                            return Dl[rt].push(Co), !1;
                        }
                        const df = [
                            Int8Array,
                            Uint8Array,
                            Uint8ClampedArray,
                            Int16Array,
                            Uint16Array,
                            Int32Array,
                            Uint32Array,
                            Float32Array,
                            Float64Array
                        ];
                        class Kh {
                            static from(Qe) {
                                if (!(Qe instanceof ArrayBuffer)) throw new Error("Data must be an instance of ArrayBuffer.");
                                const [rt, Wn] = new Uint8Array(Qe, 0, 2);
                                if (219 !== rt) throw new Error("Data does not appear to be in a KDBush format.");
                                const Co = Wn >> 4;
                                if (1 !== Co) throw new Error(`Got v${Co} data when expected v1.`);
                                const Dl = df[15 & Wn];
                                if (!Dl) throw new Error("Unrecognized array type.");
                                const [Ll] = new Uint16Array(Qe, 2, 1), [Rl] = new Uint32Array(Qe, 4, 1);
                                return new Kh(Rl, Ll, Dl, Qe);
                            }
                            constructor(Qe, rt = 64, Wn = Float64Array, Co){
                                if (isNaN(Qe) || Qe < 0) throw new Error(`Unpexpected numItems value: ${Qe}.`);
                                this.numItems = +Qe, this.nodeSize = Math.min(Math.max(+rt, 2), 65535), this.ArrayType = Wn, this.IndexArrayType = Qe < 65536 ? Uint16Array : Uint32Array;
                                const Dl = df.indexOf(this.ArrayType), Ll = 2 * Qe * this.ArrayType.BYTES_PER_ELEMENT, Rl = Qe * this.IndexArrayType.BYTES_PER_ELEMENT, Ul = (8 - Rl % 8) % 8;
                                if (Dl < 0) throw new Error(`Unexpected typed array class: ${Wn}.`);
                                Co && Co instanceof ArrayBuffer ? (this.data = Co, this.ids = new this.IndexArrayType(this.data, 8, Qe), this.coords = new this.ArrayType(this.data, 8 + Rl + Ul, 2 * Qe), this._pos = 2 * Qe, this._finished = !0) : (this.data = new ArrayBuffer(8 + Ll + Rl + Ul), this.ids = new this.IndexArrayType(this.data, 8, Qe), this.coords = new this.ArrayType(this.data, 8 + Rl + Ul, 2 * Qe), this._pos = 0, this._finished = !1, new Uint8Array(this.data, 0, 2).set([
                                    219,
                                    16 + Dl
                                ]), new Uint16Array(this.data, 2, 1)[0] = rt, new Uint32Array(this.data, 4, 1)[0] = Qe);
                            }
                            add(Qe, rt) {
                                const Wn = this._pos >> 1;
                                return this.ids[Wn] = Wn, this.coords[this._pos++] = Qe, this.coords[this._pos++] = rt, Wn;
                            }
                            finish() {
                                const Qe = this._pos >> 1;
                                if (Qe !== this.numItems) throw new Error(`Added ${Qe} items when expected ${this.numItems}.`);
                                return Xh(this.ids, this.coords, this.nodeSize, 0, this.numItems - 1, 0), this._finished = !0, this;
                            }
                            range(Qe, rt, Wn, Co) {
                                if (!this._finished) throw new Error("Data not yet indexed - call index.finish().");
                                const { ids: Dl, coords: Ll, nodeSize: Rl } = this, Ul = [
                                    0,
                                    Dl.length - 1,
                                    0
                                ], Gl = [];
                                for(; Ul.length;){
                                    const Zl = Ul.pop() || 0, Hl = Ul.pop() || 0, ql = Ul.pop() || 0;
                                    if (Hl - ql <= Rl) {
                                        for(let Rl = ql; Rl <= Hl; Rl++){
                                            const Ul = Ll[2 * Rl], Zl = Ll[2 * Rl + 1];
                                            Ul >= Qe && Ul <= Wn && Zl >= rt && Zl <= Co && Gl.push(Dl[Rl]);
                                        }
                                        continue;
                                    }
                                    const Ql = ql + Hl >> 1, Kl = Ll[2 * Ql], $l = Ll[2 * Ql + 1];
                                    Kl >= Qe && Kl <= Wn && $l >= rt && $l <= Co && Gl.push(Dl[Ql]), (0 === Zl ? Qe <= Kl : rt <= $l) && (Ul.push(ql), Ul.push(Ql - 1), Ul.push(1 - Zl)), (0 === Zl ? Wn >= Kl : Co >= $l) && (Ul.push(Ql + 1), Ul.push(Hl), Ul.push(1 - Zl));
                                }
                                return Gl;
                            }
                            within(Qe, rt, Wn) {
                                if (!this._finished) throw new Error("Data not yet indexed - call index.finish().");
                                const { ids: Co, coords: Dl, nodeSize: Ll } = this, Rl = [
                                    0,
                                    Co.length - 1,
                                    0
                                ], Ul = [], Gl = Wn * Wn;
                                for(; Rl.length;){
                                    const Zl = Rl.pop() || 0, Hl = Rl.pop() || 0, ql = Rl.pop() || 0;
                                    if (Hl - ql <= Ll) {
                                        for(let Wn = ql; Wn <= Hl; Wn++)Wh(Dl[2 * Wn], Dl[2 * Wn + 1], Qe, rt) <= Gl && Ul.push(Co[Wn]);
                                        continue;
                                    }
                                    const Ql = ql + Hl >> 1, Kl = Dl[2 * Ql], $l = Dl[2 * Ql + 1];
                                    Wh(Kl, $l, Qe, rt) <= Gl && Ul.push(Co[Ql]), (0 === Zl ? Qe - Wn <= Kl : rt - Wn <= $l) && (Rl.push(ql), Rl.push(Ql - 1), Rl.push(1 - Zl)), (0 === Zl ? Qe + Wn >= Kl : rt + Wn >= $l) && (Rl.push(Ql + 1), Rl.push(Hl), Rl.push(1 - Zl));
                                }
                                return Ul;
                            }
                        }
                        function Xh(Qe, rt, Wn, Co, Dl, Ll) {
                            if (Dl - Co <= Wn) return;
                            const Rl = Co + Dl >> 1;
                            Hh(Qe, rt, Rl, Co, Dl, Ll), Xh(Qe, rt, Wn, Co, Rl - 1, 1 - Ll), Xh(Qe, rt, Wn, Rl + 1, Dl, 1 - Ll);
                        }
                        function Hh(Qe, rt, Wn, Co, Dl, Ll) {
                            for(; Dl > Co;){
                                if (Dl - Co > 600) {
                                    const Rl = Dl - Co + 1, Ul = Wn - Co + 1, Gl = Math.log(Rl), Zl = .5 * Math.exp(2 * Gl / 3), Hl = .5 * Math.sqrt(Gl * Zl * (Rl - Zl) / Rl) * (Ul - Rl / 2 < 0 ? -1 : 1);
                                    Hh(Qe, rt, Wn, Math.max(Co, Math.floor(Wn - Ul * Zl / Rl + Hl)), Math.min(Dl, Math.floor(Wn + (Rl - Ul) * Zl / Rl + Hl)), Ll);
                                }
                                const Rl = rt[2 * Wn + Ll];
                                let Ul = Co, Gl = Dl;
                                for(Yh(Qe, rt, Co, Wn), rt[2 * Dl + Ll] > Rl && Yh(Qe, rt, Co, Dl); Ul < Gl;){
                                    for(Yh(Qe, rt, Ul, Gl), Ul++, Gl--; rt[2 * Ul + Ll] < Rl;)Ul++;
                                    for(; rt[2 * Gl + Ll] > Rl;)Gl--;
                                }
                                rt[2 * Co + Ll] === Rl ? Yh(Qe, rt, Co, Gl) : (Gl++, Yh(Qe, rt, Gl, Dl)), Gl <= Wn && (Co = Gl + 1), Wn <= Gl && (Dl = Gl - 1);
                            }
                        }
                        function Yh(Qe, rt, Wn, Co) {
                            Jh(Qe, Wn, Co), Jh(rt, 2 * Wn, 2 * Co), Jh(rt, 2 * Wn + 1, 2 * Co + 1);
                        }
                        function Jh(Qe, rt, Wn) {
                            const Co = Qe[rt];
                            Qe[rt] = Qe[Wn], Qe[Wn] = Co;
                        }
                        function Wh(Qe, rt, Wn, Co) {
                            const Dl = Qe - Wn, Ll = rt - Co;
                            return Dl * Dl + Ll * Ll;
                        }
                        var pf;
                        Qe.ck = void 0, (pf = Qe.ck || (Qe.ck = {})).create = "create", pf.load = "load", pf.fullLoad = "fullLoad";
                        let mf = null, ff = [];
                        const gf = 1e3 / 60, Af = "loadTime", yf = "fullLoadTime", vf = {
                            mark (Qe) {
                                performance.mark(Qe);
                            },
                            frame (Qe) {
                                const rt = Qe;
                                null != mf && ff.push(rt - mf), mf = rt;
                            },
                            clearMetrics () {
                                mf = null, ff = [], performance.clearMeasures(Af), performance.clearMeasures(yf);
                                for(const rt in Qe.ck)performance.clearMarks(Qe.ck[rt]);
                            },
                            getPerformanceMetrics () {
                                performance.measure(Af, Qe.ck.create, Qe.ck.load), performance.measure(yf, Qe.ck.create, Qe.ck.fullLoad);
                                const rt = performance.getEntriesByName(Af)[0].duration, Wn = performance.getEntriesByName(yf)[0].duration, Co = ff.length, Dl = 1 / (ff.reduce((Qe, rt)=>Qe + rt, 0) / Co / 1e3), Ll = ff.filter((Qe)=>Qe > gf).reduce((Qe, rt)=>Qe + (rt - gf) / gf, 0);
                                return {
                                    loadTime: rt,
                                    fullLoadTime: Wn,
                                    fps: Dl,
                                    percentDroppedFrames: Ll / (Co + Ll) * 100,
                                    totalFrames: Co
                                };
                            }
                        };
                        Qe.$ = nh, Qe.A = Ql, Qe.B = Ld, Qe.C = fs, Qe.D = _s, Qe.E = ft, Qe.F = Kd, Qe.G = function(Qe) {
                            if (null == lu) {
                                const rt = Qe.navigator ? Qe.navigator.userAgent : null;
                                lu = !!Qe.safari || !(!rt || !(/\b(iPad|iPhone|iPod)\b/.test(rt) || rt.match("Safari") && !rt.match("Chrome")));
                            }
                            return lu;
                        }, Qe.H = class {
                            constructor(Qe, rt){
                                this.target = Qe, this.mapId = rt, this.resolveRejects = {}, this.tasks = {}, this.taskQueue = [], this.abortControllers = {}, this.messageHandlers = {}, this.invoker = new Zc(()=>this.process()), this.subscription = Y(this.target, "message", (Qe)=>this.receive(Qe), !1), this.globalScope = U(self) ? Qe : window;
                            }
                            registerMessageHandler(Qe, rt) {
                                this.messageHandlers[Qe] = rt;
                            }
                            sendAsync(Qe, rt) {
                                return new Promise((Wn, Co)=>{
                                    const Dl = Math.round(1e18 * Math.random()).toString(36).substring(0, 10), Ll = rt ? Y(rt.signal, "abort", ()=>{
                                        null == Ll || Ll.unsubscribe(), delete this.resolveRejects[Dl];
                                        const rt = {
                                            id: Dl,
                                            type: "<cancel>",
                                            origin: location.origin,
                                            targetMapId: Qe.targetMapId,
                                            sourceMapId: this.mapId
                                        };
                                        this.target.postMessage(rt);
                                    }, sf) : null;
                                    this.resolveRejects[Dl] = {
                                        resolve: (Qe)=>{
                                            null == Ll || Ll.unsubscribe(), Wn(Qe);
                                        },
                                        reject: (Qe)=>{
                                            null == Ll || Ll.unsubscribe(), Co(Qe);
                                        }
                                    };
                                    const Rl = [], Ul = Object.assign(Object.assign({}, Qe), {
                                        id: Dl,
                                        sourceMapId: this.mapId,
                                        origin: location.origin,
                                        data: Yi(Qe.data, Rl)
                                    });
                                    this.target.postMessage(Ul, {
                                        transfer: Rl
                                    });
                                });
                            }
                            receive(Qe) {
                                const rt = Qe.data, Wn = rt.id;
                                if (!("file://" !== rt.origin && "file://" !== location.origin && "resource://android" !== rt.origin && "resource://android" !== location.origin && rt.origin !== location.origin || rt.targetMapId && this.mapId !== rt.targetMapId)) {
                                    if ("<cancel>" === rt.type) {
                                        delete this.tasks[Wn];
                                        const Qe = this.abortControllers[Wn];
                                        return delete this.abortControllers[Wn], void (Qe && Qe.abort());
                                    }
                                    if (U(self) || rt.mustQueue) return this.tasks[Wn] = rt, this.taskQueue.push(Wn), void this.invoker.trigger();
                                    this.processTask(Wn, rt);
                                }
                            }
                            process() {
                                if (0 === this.taskQueue.length) return;
                                const Qe = this.taskQueue.shift(), rt = this.tasks[Qe];
                                delete this.tasks[Qe], this.taskQueue.length > 0 && this.invoker.trigger(), rt && this.processTask(Qe, rt);
                            }
                            processTask(Qe, rt) {
                                return e(this, void 0, void 0, function*() {
                                    if ("<response>" === rt.type) {
                                        const Wn = this.resolveRejects[Qe];
                                        if (delete this.resolveRejects[Qe], !Wn) return;
                                        return void (rt.error ? Wn.reject(Ji(rt.error)) : Wn.resolve(Ji(rt.data)));
                                    }
                                    if (!this.messageHandlers[rt.type]) return void this.completeTask(Qe, new Error(`Could not find a registered handler for ${rt.type}, map ID: ${this.mapId}, available handlers: ${Object.keys(this.messageHandlers).join(", ")}`));
                                    const Wn = Ji(rt.data), Co = new AbortController;
                                    this.abortControllers[Qe] = Co;
                                    try {
                                        const Dl = yield this.messageHandlers[rt.type](rt.sourceMapId, Wn, Co);
                                        this.completeTask(Qe, null, Dl);
                                    } catch (Wn) {
                                        this.completeTask(Qe, Wn);
                                    }
                                });
                            }
                            completeTask(Qe, rt, Wn) {
                                const Co = [];
                                delete this.abortControllers[Qe];
                                const Dl = {
                                    id: Qe,
                                    type: "<response>",
                                    sourceMapId: this.mapId,
                                    origin: location.origin,
                                    error: rt ? Yi(rt) : null,
                                    data: Yi(Wn, Co)
                                };
                                this.target.postMessage(Dl, {
                                    transfer: Co
                                });
                            }
                            remove() {
                                this.invoker.remove(), this.subscription.unsubscribe();
                            }
                        }, Qe.I = Hu, Qe.J = Xu, Qe.K = function() {
                            var Qe = new Ql(16);
                            return Ql != Float32Array && (Qe[1] = 0, Qe[2] = 0, Qe[3] = 0, Qe[4] = 0, Qe[6] = 0, Qe[7] = 0, Qe[8] = 0, Qe[9] = 0, Qe[11] = 0, Qe[12] = 0, Qe[13] = 0, Qe[14] = 0), Qe[0] = 1, Qe[5] = 1, Qe[10] = 1, Qe[15] = 1, Qe;
                        }, Qe.L = function(Qe, rt, Wn) {
                            var Co, Dl, Ll, Rl, Ul, Gl, Zl, Hl, ql, Ql, Kl, $l, Tc = Wn[0], tu = Wn[1], lu = Wn[2];
                            return rt === Qe ? (Qe[12] = rt[0] * Tc + rt[4] * tu + rt[8] * lu + rt[12], Qe[13] = rt[1] * Tc + rt[5] * tu + rt[9] * lu + rt[13], Qe[14] = rt[2] * Tc + rt[6] * tu + rt[10] * lu + rt[14], Qe[15] = rt[3] * Tc + rt[7] * tu + rt[11] * lu + rt[15]) : (Dl = rt[1], Ll = rt[2], Rl = rt[3], Ul = rt[4], Gl = rt[5], Zl = rt[6], Hl = rt[7], ql = rt[8], Ql = rt[9], Kl = rt[10], $l = rt[11], Qe[0] = Co = rt[0], Qe[1] = Dl, Qe[2] = Ll, Qe[3] = Rl, Qe[4] = Ul, Qe[5] = Gl, Qe[6] = Zl, Qe[7] = Hl, Qe[8] = ql, Qe[9] = Ql, Qe[10] = Kl, Qe[11] = $l, Qe[12] = Co * Tc + Ul * tu + ql * lu + rt[12], Qe[13] = Dl * Tc + Gl * tu + Ql * lu + rt[13], Qe[14] = Ll * Tc + Zl * tu + Kl * lu + rt[14], Qe[15] = Rl * Tc + Hl * tu + $l * lu + rt[15]), Qe;
                        }, Qe.M = function(Qe, rt, Wn) {
                            var Co = Wn[0], Dl = Wn[1], Ll = Wn[2];
                            return Qe[0] = rt[0] * Co, Qe[1] = rt[1] * Co, Qe[2] = rt[2] * Co, Qe[3] = rt[3] * Co, Qe[4] = rt[4] * Dl, Qe[5] = rt[5] * Dl, Qe[6] = rt[6] * Dl, Qe[7] = rt[7] * Dl, Qe[8] = rt[8] * Ll, Qe[9] = rt[9] * Ll, Qe[10] = rt[10] * Ll, Qe[11] = rt[11] * Ll, Qe[12] = rt[12], Qe[13] = rt[13], Qe[14] = rt[14], Qe[15] = rt[15], Qe;
                        }, Qe.N = function(Qe, rt, Wn) {
                            var Co = rt[0], Dl = rt[1], Ll = rt[2], Rl = rt[3], Ul = rt[4], Gl = rt[5], Zl = rt[6], Hl = rt[7], ql = rt[8], Ql = rt[9], Kl = rt[10], $l = rt[11], Tc = rt[12], tu = rt[13], lu = rt[14], du = rt[15], fu = Wn[0], yu = Wn[1], Eu = Wn[2], Tu = Wn[3];
                            return Qe[0] = fu * Co + yu * Ul + Eu * ql + Tu * Tc, Qe[1] = fu * Dl + yu * Gl + Eu * Ql + Tu * tu, Qe[2] = fu * Ll + yu * Zl + Eu * Kl + Tu * lu, Qe[3] = fu * Rl + yu * Hl + Eu * $l + Tu * du, Qe[4] = (fu = Wn[4]) * Co + (yu = Wn[5]) * Ul + (Eu = Wn[6]) * ql + (Tu = Wn[7]) * Tc, Qe[5] = fu * Dl + yu * Gl + Eu * Ql + Tu * tu, Qe[6] = fu * Ll + yu * Zl + Eu * Kl + Tu * lu, Qe[7] = fu * Rl + yu * Hl + Eu * $l + Tu * du, Qe[8] = (fu = Wn[8]) * Co + (yu = Wn[9]) * Ul + (Eu = Wn[10]) * ql + (Tu = Wn[11]) * Tc, Qe[9] = fu * Dl + yu * Gl + Eu * Ql + Tu * tu, Qe[10] = fu * Ll + yu * Zl + Eu * Kl + Tu * lu, Qe[11] = fu * Rl + yu * Hl + Eu * $l + Tu * du, Qe[12] = (fu = Wn[12]) * Co + (yu = Wn[13]) * Ul + (Eu = Wn[14]) * ql + (Tu = Wn[15]) * Tc, Qe[13] = fu * Dl + yu * Gl + Eu * Ql + Tu * tu, Qe[14] = fu * Ll + yu * Zl + Eu * Kl + Tu * lu, Qe[15] = fu * Rl + yu * Hl + Eu * $l + Tu * du, Qe;
                        }, Qe.O = function(Qe, rt) {
                            const Wn = {};
                            for(let Co = 0; Co < rt.length; Co++){
                                const Dl = rt[Co];
                                Dl in Qe && (Wn[Dl] = Qe[Dl]);
                            }
                            return Wn;
                        }, Qe.P = Ll, Qe.Q = Hc, Qe.R = No, Qe.S = Qc, Qe.T = ms, Qe.U = Wc, Qe.V = f, Qe.W = d, Qe.X = K, Qe.Y = oh, Qe.Z = Kl, Qe._ = e, Qe.a = Zu, Qe.a$ = function(Qe, rt, Wn) {
                            var Co = Math.sin(Wn), Dl = Math.cos(Wn), Ll = rt[4], Rl = rt[5], Ul = rt[6], Gl = rt[7], Zl = rt[8], Hl = rt[9], ql = rt[10], Ql = rt[11];
                            return rt !== Qe && (Qe[0] = rt[0], Qe[1] = rt[1], Qe[2] = rt[2], Qe[3] = rt[3], Qe[12] = rt[12], Qe[13] = rt[13], Qe[14] = rt[14], Qe[15] = rt[15]), Qe[4] = Ll * Dl + Zl * Co, Qe[5] = Rl * Dl + Hl * Co, Qe[6] = Ul * Dl + ql * Co, Qe[7] = Gl * Dl + Ql * Co, Qe[8] = Zl * Dl - Ll * Co, Qe[9] = Hl * Dl - Rl * Co, Qe[10] = ql * Dl - Ul * Co, Qe[11] = Ql * Dl - Gl * Co, Qe;
                        }, Qe.a0 = 25, Qe.a1 = sh, Qe.a2 = (Qe)=>{
                            const rt = window.document.createElement("video");
                            return rt.muted = !0, new Promise((Wn)=>{
                                rt.onloadstart = ()=>{
                                    Wn(rt);
                                };
                                for (const Co of Qe){
                                    const Qe = window.document.createElement("source");
                                    lt(Co) || (rt.crossOrigin = "Anonymous"), Qe.src = Co, rt.appendChild(Qe);
                                }
                            });
                        }, Qe.a3 = Mt, Qe.a4 = function() {
                            return Tc++;
                        }, Qe.a5 = sa, Qe.a6 = Ec, Qe.a7 = Qn, Qe.a8 = ho, Qe.a9 = hh, Qe.aA = jh, Qe.aB = hc, Qe.aC = Kh, Qe.aD = Es, Qe.aE = kl, Qe.aF = ma, Qe.aG = Va, Qe.aH = za, Qe.aI = function(Qe) {
                            return Math.pow(2, Qe);
                        }, Qe.aJ = 85.051129, Qe.aK = th, Qe.aL = T, Qe.aM = J, Qe.aN = rh, Qe.aO = function(Qe, rt, Wn) {
                            return Qe[0] = rt[0] * Wn, Qe[1] = rt[1] * Wn, Qe[2] = rt[2] * Wn, Qe;
                        }, Qe.aP = function(Qe, rt, Wn) {
                            return Qe[0] = rt[0] + Wn[0], Qe[1] = rt[1] + Wn[1], Qe[2] = rt[2] + Wn[2], Qe;
                        }, Qe.aQ = function(Qe) {
                            var rt = new Ql(3);
                            return rt[0] = Qe[0], rt[1] = Qe[1], rt[2] = Qe[2], rt;
                        }, Qe.aR = function(Qe, rt, Wn) {
                            return Qe[0] = rt[0] * Wn[0], Qe[1] = rt[1] * Wn[1], Qe[2] = rt[2] * Wn[2], Qe[3] = rt[3] * Wn[3], Qe;
                        }, Qe.aS = function(Qe, rt, Wn) {
                            return Qe[0] = rt[0] - Wn[0], Qe[1] = rt[1] - Wn[1], Qe[2] = rt[2] - Wn[2], Qe;
                        }, Qe.aT = function(Qe, rt) {
                            var Wn = rt[0], Co = rt[1], Dl = rt[2], Ll = Wn * Wn + Co * Co + Dl * Dl;
                            return Ll > 0 && (Ll = 1 / Math.sqrt(Ll)), Qe[0] = rt[0] * Ll, Qe[1] = rt[1] * Ll, Qe[2] = rt[2] * Ll, Qe;
                        }, Qe.aU = function(Qe, rt, Wn) {
                            var Co = rt[0], Dl = rt[1], Ll = rt[2], Rl = Wn[0], Ul = Wn[1], Gl = Wn[2];
                            return Qe[0] = Dl * Gl - Ll * Ul, Qe[1] = Ll * Rl - Co * Gl, Qe[2] = Co * Ul - Dl * Rl, Qe;
                        }, Qe.aV = function(Qe, rt) {
                            return Qe[0] * rt[0] + Qe[1] * rt[1] + Qe[2] * rt[2];
                        }, Qe.aW = ah, Qe.aX = lh, Qe.aY = function(Qe, rt, Wn, Co, Dl) {
                            var Ll, Rl = 1 / Math.tan(rt / 2);
                            return Qe[0] = Rl / Wn, Qe[1] = 0, Qe[2] = 0, Qe[3] = 0, Qe[4] = 0, Qe[5] = Rl, Qe[6] = 0, Qe[7] = 0, Qe[8] = 0, Qe[9] = 0, Qe[11] = -1, Qe[12] = 0, Qe[13] = 0, Qe[15] = 0, null != Dl && Dl !== 1 / 0 ? (Qe[10] = (Dl + Co) * (Ll = 1 / (Co - Dl)), Qe[14] = 2 * Dl * Co * Ll) : (Qe[10] = -1, Qe[14] = -2 * Co), Qe;
                        }, Qe.aZ = function(Qe) {
                            var rt = new Ql(16);
                            return rt[0] = Qe[0], rt[1] = Qe[1], rt[2] = Qe[2], rt[3] = Qe[3], rt[4] = Qe[4], rt[5] = Qe[5], rt[6] = Qe[6], rt[7] = Qe[7], rt[8] = Qe[8], rt[9] = Qe[9], rt[10] = Qe[10], rt[11] = Qe[11], rt[12] = Qe[12], rt[13] = Qe[13], rt[14] = Qe[14], rt[15] = Qe[15], rt;
                        }, Qe.a_ = function(Qe, rt, Wn) {
                            var Co = Math.sin(Wn), Dl = Math.cos(Wn), Ll = rt[0], Rl = rt[1], Ul = rt[2], Gl = rt[3], Zl = rt[4], Hl = rt[5], ql = rt[6], Ql = rt[7];
                            return rt !== Qe && (Qe[8] = rt[8], Qe[9] = rt[9], Qe[10] = rt[10], Qe[11] = rt[11], Qe[12] = rt[12], Qe[13] = rt[13], Qe[14] = rt[14], Qe[15] = rt[15]), Qe[0] = Ll * Dl + Zl * Co, Qe[1] = Rl * Dl + Hl * Co, Qe[2] = Ul * Dl + ql * Co, Qe[3] = Gl * Dl + Ql * Co, Qe[4] = Zl * Dl - Ll * Co, Qe[5] = Hl * Dl - Rl * Co, Qe[6] = ql * Dl - Ul * Co, Qe[7] = Ql * Dl - Gl * Co, Qe;
                        }, Qe.aa = function(Qe) {
                            const rt = {};
                            if (Qe.replace(/(?:^|(?:\s*\,\s*))([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)(?:\=(?:([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)|(?:\"((?:[^"\\]|\\.)*)\")))?/g, (Qe, Wn, Co, Dl)=>{
                                const Ll = Co || Dl;
                                return rt[Wn] = !Ll || Ll.toLowerCase(), "";
                            }), rt["max-age"]) {
                                const Qe = parseInt(rt["max-age"], 10);
                                isNaN(Qe) ? delete rt["max-age"] : rt["max-age"] = Qe;
                            }
                            return rt;
                        }, Qe.ab = function(Qe) {
                            return Math.log(Qe) / Math.LN2;
                        }, Qe.ac = function(Qe) {
                            var rt = Qe[0], Wn = Qe[1];
                            return rt * rt + Wn * Wn;
                        }, Qe.ad = function(Qe) {
                            return Qe * Math.PI / 180;
                        }, Qe.ae = E, Qe.af = function(Qe, rt) {
                            const Wn = [];
                            for(const Co in Qe)Co in rt || Wn.push(Co);
                            return Wn;
                        }, Qe.ag = function(Qe, rt) {
                            let Wn = 0, Co = 0;
                            if ("constant" === Qe.kind) Co = Qe.layoutSize;
                            else if ("source" !== Qe.kind) {
                                const { interpolationType: Dl, minZoom: Ll, maxZoom: Rl } = Qe, Ul = Dl ? E(rr.interpolationFactor(Dl, rt, Ll, Rl), 0, 1) : 0;
                                "camera" === Qe.kind ? Co = Ld.number(Qe.minSize, Qe.maxSize, Ul) : Wn = Ul;
                            }
                            return {
                                uSizeT: Wn,
                                uSize: Co
                            };
                        }, Qe.ai = function(Qe, { uSize: rt, uSizeT: Wn }, { lowerSize: Co, upperSize: Dl }) {
                            return "source" === Qe.kind ? Co / qm : "composite" === Qe.kind ? Ld.number(Co / qm, Dl / qm, Wn) : rt;
                        }, Qe.aj = function(Qe, rt) {
                            var Wn = rt[0], Co = rt[1], Dl = rt[2], Ll = rt[3], Rl = rt[4], Ul = rt[5], Gl = rt[6], Zl = rt[7], Hl = rt[8], ql = rt[9], Ql = rt[10], Kl = rt[11], $l = rt[12], Tc = rt[13], tu = rt[14], lu = rt[15], du = Wn * Ul - Co * Rl, fu = Wn * Gl - Dl * Rl, yu = Wn * Zl - Ll * Rl, Eu = Co * Gl - Dl * Ul, Tu = Co * Zl - Ll * Ul, Lu = Dl * Zl - Ll * Gl, Zu = Hl * Tc - ql * $l, Xu = Hl * tu - Ql * $l, Ju = Hl * lu - Kl * $l, $u = ql * tu - Ql * Tc, ed = ql * lu - Kl * Tc, td = Ql * lu - Kl * tu, id = du * td - fu * ed + yu * $u + Eu * Ju - Tu * Xu + Lu * Zu;
                            return id ? (Qe[0] = (Ul * td - Gl * ed + Zl * $u) * (id = 1 / id), Qe[1] = (Dl * ed - Co * td - Ll * $u) * id, Qe[2] = (Tc * Lu - tu * Tu + lu * Eu) * id, Qe[3] = (Ql * Tu - ql * Lu - Kl * Eu) * id, Qe[4] = (Gl * Ju - Rl * td - Zl * Xu) * id, Qe[5] = (Wn * td - Dl * Ju + Ll * Xu) * id, Qe[6] = (tu * yu - $l * Lu - lu * fu) * id, Qe[7] = (Hl * Lu - Ql * yu + Kl * fu) * id, Qe[8] = (Rl * ed - Ul * Ju + Zl * Zu) * id, Qe[9] = (Co * Ju - Wn * ed - Ll * Zu) * id, Qe[10] = ($l * Tu - Tc * yu + lu * du) * id, Qe[11] = (ql * yu - Hl * Tu - Kl * du) * id, Qe[12] = (Ul * Xu - Rl * $u - Gl * Zu) * id, Qe[13] = (Wn * $u - Co * Xu + Dl * Zu) * id, Qe[14] = (Tc * fu - $l * Eu - tu * du) * id, Qe[15] = (Hl * Eu - ql * fu + Ql * du) * id, Qe) : null;
                        }, Qe.ak = A, Qe.al = function(Qe) {
                            return Math.hypot(Qe[0], Qe[1]);
                        }, Qe.am = function(Qe) {
                            return Qe[0] = 0, Qe[1] = 0, Qe;
                        }, Qe.an = function(Qe, rt, Wn) {
                            return Qe[0] = rt[0] * Wn, Qe[1] = rt[1] * Wn, Qe;
                        }, Qe.ao = Pc, Qe.ap = _, Qe.aq = function(Qe, rt, Wn, Co) {
                            const Dl = rt.y - Qe.y, Rl = rt.x - Qe.x, Ul = Co.y - Wn.y, Gl = Co.x - Wn.x, Zl = Ul * Rl - Gl * Dl;
                            if (0 === Zl) return null;
                            const Hl = (Gl * (Qe.y - Wn.y) - Ul * (Qe.x - Wn.x)) / Zl;
                            return new Ll(Qe.x + Hl * Rl, Qe.y + Hl * Dl);
                        }, Qe.ar = mh, Qe.as = mo, Qe.at = v, Qe.au = function(Qe) {
                            let rt = 1 / 0, Wn = 1 / 0, Co = -1 / 0, Dl = -1 / 0;
                            for (const Ll of Qe)rt = Math.min(rt, Ll.x), Wn = Math.min(Wn, Ll.y), Co = Math.max(Co, Ll.x), Dl = Math.max(Dl, Ll.y);
                            return [
                                rt,
                                Wn,
                                Co,
                                Dl
                            ];
                        }, Qe.av = Nm, Qe.aw = I, Qe.ax = function(Qe, rt, Wn, Co, Dl = !1) {
                            if (!Wn[0] && !Wn[1]) return [
                                0,
                                0
                            ];
                            const Ll = Dl ? "map" === Co ? -Qe.bearingInRadians : 0 : "viewport" === Co ? Qe.bearingInRadians : 0;
                            if (Ll) {
                                const Qe = Math.sin(Ll), rt = Math.cos(Ll);
                                Wn = [
                                    Wn[0] * rt - Wn[1] * Qe,
                                    Wn[0] * Qe + Wn[1] * rt
                                ];
                            }
                            return [
                                Dl ? Wn[0] : I(rt, Wn[0], Qe.zoom),
                                Dl ? Wn[1] : I(rt, Wn[1], Qe.zoom)
                            ];
                        }, Qe.az = kc, Qe.b = G, Qe.b$ = (Qe)=>"symbol" === Qe.type, Qe.b0 = function() {
                            const Qe = new Float32Array(16);
                            return v(Qe), Qe;
                        }, Qe.b1 = function() {
                            const Qe = new Float64Array(16);
                            return v(Qe), Qe;
                        }, Qe.b2 = function() {
                            return new Float64Array(16);
                        }, Qe.b3 = function(Qe, rt, Wn) {
                            const Co = new Float64Array(4);
                            return function(Qe, rt, Wn, Co) {
                                var Dl = .5 * Math.PI / 180;
                                rt *= Dl, Wn *= Dl, Co *= Dl;
                                var Ll = Math.sin(rt), Rl = Math.cos(rt), Ul = Math.sin(Wn), Gl = Math.cos(Wn), Zl = Math.sin(Co), Hl = Math.cos(Co);
                                Qe[0] = Ll * Gl * Hl - Rl * Ul * Zl, Qe[1] = Rl * Ul * Hl + Ll * Gl * Zl, Qe[2] = Rl * Gl * Zl - Ll * Ul * Hl, Qe[3] = Rl * Gl * Hl + Ll * Ul * Zl;
                            }(Co, Qe, rt - 90, Wn), Co;
                        }, Qe.b4 = function(Qe, rt, Wn, Co) {
                            var Dl, Ll, Rl, Ul, Gl, Zl = rt[0], Hl = rt[1], Ql = rt[2], Kl = rt[3], $l = Wn[0], Tc = Wn[1], tu = Wn[2], lu = Wn[3];
                            return (Ll = Zl * $l + Hl * Tc + Ql * tu + Kl * lu) < 0 && (Ll = -Ll, $l = -$l, Tc = -Tc, tu = -tu, lu = -lu), 1 - Ll > ql ? (Dl = Math.acos(Ll), Rl = Math.sin(Dl), Ul = Math.sin((1 - Co) * Dl) / Rl, Gl = Math.sin(Co * Dl) / Rl) : (Ul = 1 - Co, Gl = Co), Qe[0] = Ul * Zl + Gl * $l, Qe[1] = Ul * Hl + Gl * Tc, Qe[2] = Ul * Ql + Gl * tu, Qe[3] = Ul * Kl + Gl * lu, Qe;
                        }, Qe.b5 = function(Qe) {
                            const rt = new Float64Array(9);
                            var Wn, Co, Dl, Ll, Rl, Ul, Gl, Zl, Hl, ql, Ql, Kl, $l, Tc, tu, lu, du, fu;
                            ql = (Dl = (Co = Qe)[0]) * (Gl = Dl + Dl), Ql = (Ll = Co[1]) * Gl, $l = (Rl = Co[2]) * Gl, Tc = Rl * (Zl = Ll + Ll), lu = (Ul = Co[3]) * Gl, du = Ul * Zl, fu = Ul * (Hl = Rl + Rl), (Wn = rt)[0] = 1 - (Kl = Ll * Zl) - (tu = Rl * Hl), Wn[3] = Ql - fu, Wn[6] = $l + du, Wn[1] = Ql + fu, Wn[4] = 1 - ql - tu, Wn[7] = Tc - lu, Wn[2] = $l - du, Wn[5] = Tc + lu, Wn[8] = 1 - ql - Kl;
                            const yu = J(-Math.asin(E(rt[2], -1, 1)));
                            let Eu, Tu;
                            return Math.hypot(rt[5], rt[8]) < .001 ? (Eu = 0, Tu = -J(Math.atan2(rt[3], rt[4]))) : (Eu = J(0 === rt[5] && 0 === rt[8] ? 0 : Math.atan2(rt[5], rt[8])), Tu = J(0 === rt[1] && 0 === rt[0] ? 0 : Math.atan2(rt[1], rt[0]))), {
                                roll: Eu,
                                pitch: yu + 90,
                                bearing: Tu
                            };
                        }, Qe.b6 = function(Qe, rt) {
                            return Qe.roll == rt.roll && Qe.pitch == rt.pitch && Qe.bearing == rt.bearing;
                        }, Qe.b7 = xe, Qe.b8 = Xa, Qe.b9 = Yp, Qe.bA = function(Qe, rt) {
                            if (!Qe) return [
                                {
                                    command: "setStyle",
                                    args: [
                                        rt
                                    ]
                                }
                            ];
                            let Wn = [];
                            try {
                                if (!gt(Qe.version, rt.version)) return [
                                    {
                                        command: "setStyle",
                                        args: [
                                            rt
                                        ]
                                    }
                                ];
                                gt(Qe.center, rt.center) || Wn.push({
                                    command: "setCenter",
                                    args: [
                                        rt.center
                                    ]
                                }), gt(Qe.centerAltitude, rt.centerAltitude) || Wn.push({
                                    command: "setCenterAltitude",
                                    args: [
                                        rt.centerAltitude
                                    ]
                                }), gt(Qe.zoom, rt.zoom) || Wn.push({
                                    command: "setZoom",
                                    args: [
                                        rt.zoom
                                    ]
                                }), gt(Qe.bearing, rt.bearing) || Wn.push({
                                    command: "setBearing",
                                    args: [
                                        rt.bearing
                                    ]
                                }), gt(Qe.pitch, rt.pitch) || Wn.push({
                                    command: "setPitch",
                                    args: [
                                        rt.pitch
                                    ]
                                }), gt(Qe.roll, rt.roll) || Wn.push({
                                    command: "setRoll",
                                    args: [
                                        rt.roll
                                    ]
                                }), gt(Qe.sprite, rt.sprite) || Wn.push({
                                    command: "setSprite",
                                    args: [
                                        rt.sprite
                                    ]
                                }), gt(Qe.glyphs, rt.glyphs) || Wn.push({
                                    command: "setGlyphs",
                                    args: [
                                        rt.glyphs
                                    ]
                                }), gt(Qe.transition, rt.transition) || Wn.push({
                                    command: "setTransition",
                                    args: [
                                        rt.transition
                                    ]
                                }), gt(Qe.light, rt.light) || Wn.push({
                                    command: "setLight",
                                    args: [
                                        rt.light
                                    ]
                                }), gt(Qe.terrain, rt.terrain) || Wn.push({
                                    command: "setTerrain",
                                    args: [
                                        rt.terrain
                                    ]
                                }), gt(Qe.sky, rt.sky) || Wn.push({
                                    command: "setSky",
                                    args: [
                                        rt.sky
                                    ]
                                }), gt(Qe.projection, rt.projection) || Wn.push({
                                    command: "setProjection",
                                    args: [
                                        rt.projection
                                    ]
                                });
                                const Co = {}, Dl = [];
                                !function(Qe, rt, Wn, Co) {
                                    let Dl;
                                    for(Dl in rt = rt || {}, Qe = Qe || {})Object.prototype.hasOwnProperty.call(Qe, Dl) && (Object.prototype.hasOwnProperty.call(rt, Dl) || bt(Dl, Wn, Co));
                                    for(Dl in rt)Object.prototype.hasOwnProperty.call(rt, Dl) && (Object.prototype.hasOwnProperty.call(Qe, Dl) ? gt(Qe[Dl], rt[Dl]) || ("geojson" === Qe[Dl].type && "geojson" === rt[Dl].type && _t(Qe, rt, Dl) ? xt(Wn, {
                                        command: "setGeoJSONSourceData",
                                        args: [
                                            Dl,
                                            rt[Dl].data
                                        ]
                                    }) : wt(Dl, rt, Wn, Co)) : vt(Dl, rt, Wn));
                                }(Qe.sources, rt.sources, Dl, Co);
                                const Ll = [];
                                Qe.layers && Qe.layers.forEach((Qe)=>{
                                    "source" in Qe && Co[Qe.source] ? Wn.push({
                                        command: "removeLayer",
                                        args: [
                                            Qe.id
                                        ]
                                    }) : Ll.push(Qe);
                                }), Wn = Wn.concat(Dl), function(Qe, rt, Wn) {
                                    rt = rt || [];
                                    const Co = (Qe = Qe || []).map(At), Dl = rt.map(At), Ll = Qe.reduce(kt, {}), Rl = rt.reduce(kt, {}), Ul = Co.slice(), Gl = Object.create(null);
                                    let Zl, Hl, ql, Ql, Kl;
                                    for(let $l = 0, Tc = 0; $l < Co.length; $l++)Zl = Co[$l], Object.prototype.hasOwnProperty.call(Rl, Zl) ? Tc++ : (xt(Wn, {
                                        command: "removeLayer",
                                        args: [
                                            Zl
                                        ]
                                    }), Ul.splice(Ul.indexOf(Zl, Tc), 1));
                                    for(let $l = 0, Tc = 0; $l < Dl.length; $l++)Zl = Dl[Dl.length - 1 - $l], Ul[Ul.length - 1 - $l] !== Zl && (Object.prototype.hasOwnProperty.call(Ll, Zl) ? (xt(Wn, {
                                        command: "removeLayer",
                                        args: [
                                            Zl
                                        ]
                                    }), Ul.splice(Ul.lastIndexOf(Zl, Ul.length - Tc), 1)) : Tc++, Ql = Ul[Ul.length - $l], xt(Wn, {
                                        command: "addLayer",
                                        args: [
                                            Rl[Zl],
                                            Ql
                                        ]
                                    }), Ul.splice(Ul.length - $l, 0, Zl), Gl[Zl] = !0);
                                    for(let $l = 0; $l < Dl.length; $l++)if (Zl = Dl[$l], Hl = Ll[Zl], ql = Rl[Zl], !Gl[Zl] && !gt(Hl, ql)) {
                                        if (gt(Hl.source, ql.source) && gt(Hl["source-layer"], ql["source-layer"]) && gt(Hl.type, ql.type)) {
                                            for(Kl in St(Hl.layout, ql.layout, Wn, Zl, null, "setLayoutProperty"), St(Hl.paint, ql.paint, Wn, Zl, null, "setPaintProperty"), gt(Hl.filter, ql.filter) || xt(Wn, {
                                                command: "setFilter",
                                                args: [
                                                    Zl,
                                                    ql.filter
                                                ]
                                            }), gt(Hl.minzoom, ql.minzoom) && gt(Hl.maxzoom, ql.maxzoom) || xt(Wn, {
                                                command: "setLayerZoomRange",
                                                args: [
                                                    Zl,
                                                    ql.minzoom,
                                                    ql.maxzoom
                                                ]
                                            }), Hl)Object.prototype.hasOwnProperty.call(Hl, Kl) && "layout" !== Kl && "paint" !== Kl && "filter" !== Kl && "metadata" !== Kl && "minzoom" !== Kl && "maxzoom" !== Kl && (0 === Kl.indexOf("paint.") ? St(Hl[Kl], ql[Kl], Wn, Zl, Kl.slice(6), "setPaintProperty") : gt(Hl[Kl], ql[Kl]) || xt(Wn, {
                                                command: "setLayerProperty",
                                                args: [
                                                    Zl,
                                                    Kl,
                                                    ql[Kl]
                                                ]
                                            }));
                                            for(Kl in ql)Object.prototype.hasOwnProperty.call(ql, Kl) && !Object.prototype.hasOwnProperty.call(Hl, Kl) && "layout" !== Kl && "paint" !== Kl && "filter" !== Kl && "metadata" !== Kl && "minzoom" !== Kl && "maxzoom" !== Kl && (0 === Kl.indexOf("paint.") ? St(Hl[Kl], ql[Kl], Wn, Zl, Kl.slice(6), "setPaintProperty") : gt(Hl[Kl], ql[Kl]) || xt(Wn, {
                                                command: "setLayerProperty",
                                                args: [
                                                    Zl,
                                                    Kl,
                                                    ql[Kl]
                                                ]
                                            }));
                                        } else xt(Wn, {
                                            command: "removeLayer",
                                            args: [
                                                Zl
                                            ]
                                        }), Ql = Ul[Ul.lastIndexOf(Zl) + 1], xt(Wn, {
                                            command: "addLayer",
                                            args: [
                                                ql,
                                                Ql
                                            ]
                                        });
                                    }
                                }(Ll, rt.layers, Wn);
                            } catch (Qe) {
                                console.warn("Unable to compute style diff:", Qe), Wn = [
                                    {
                                        command: "setStyle",
                                        args: [
                                            rt
                                        ]
                                    }
                                ];
                            }
                            return Wn;
                        }, Qe.bB = function(Qe) {
                            const rt = [], Wn = Qe.id;
                            return void 0 === Wn && rt.push({
                                message: `layers.${Wn}: missing required property "id"`
                            }), void 0 === Qe.render && rt.push({
                                message: `layers.${Wn}: missing required method "render"`
                            }), Qe.renderingMode && "2d" !== Qe.renderingMode && "3d" !== Qe.renderingMode && rt.push({
                                message: `layers.${Wn}: property "renderingMode" must be either "2d" or "3d"`
                            }), rt;
                        }, Qe.bC = function t(Qe, rt) {
                            if (Array.isArray(Qe)) {
                                if (!Array.isArray(rt) || Qe.length !== rt.length) return !1;
                                for(let Wn = 0; Wn < Qe.length; Wn++)if (!t(Qe[Wn], rt[Wn])) return !1;
                                return !0;
                            }
                            if ("object" == typeof Qe && null !== Qe && null !== rt) {
                                if ("object" != typeof rt) return !1;
                                if (Object.keys(Qe).length !== Object.keys(rt).length) return !1;
                                for(const Wn in Qe)if (!t(Qe[Wn], rt[Wn])) return !1;
                                return !0;
                            }
                            return Qe === rt;
                        }, Qe.bD = L1, Qe.bE = O, Qe.bF = class extends Ka {
                            constructor(Qe, rt){
                                super(Qe, rt), this.current = 0;
                            }
                            set(Qe) {
                                this.current !== Qe && (this.current = Qe, this.gl.uniform1i(this.location, Qe));
                            }
                        }, Qe.bG = Ya, Qe.bH = class extends Ka {
                            constructor(Qe, rt){
                                super(Qe, rt), this.current = zp;
                            }
                            set(Qe) {
                                if (Qe[12] !== this.current[12] || Qe[0] !== this.current[0]) return this.current = Qe, void this.gl.uniformMatrix4fv(this.location, !1, Qe);
                                for(let rt = 1; rt < 16; rt++)if (Qe[rt] !== this.current[rt]) {
                                    this.current = Qe, this.gl.uniformMatrix4fv(this.location, !1, Qe);
                                    break;
                                }
                            }
                        }, Qe.bI = Ha, Qe.bJ = class extends Ka {
                            constructor(Qe, rt){
                                super(Qe, rt), this.current = [
                                    0,
                                    0,
                                    0
                                ];
                            }
                            set(Qe) {
                                Qe[0] === this.current[0] && Qe[1] === this.current[1] && Qe[2] === this.current[2] || (this.current = Qe, this.gl.uniform3f(this.location, Qe[0], Qe[1], Qe[2]));
                            }
                        }, Qe.bK = class extends Ka {
                            constructor(Qe, rt){
                                super(Qe, rt), this.current = [
                                    0,
                                    0
                                ];
                            }
                            set(Qe) {
                                Qe[0] === this.current[0] && Qe[1] === this.current[1] || (this.current = Qe, this.gl.uniform2f(this.location, Qe[0], Qe[1]));
                            }
                        }, Qe.bL = x, Qe.bM = function(Qe, rt) {
                            var Wn = Math.sin(rt), Co = Math.cos(rt);
                            return Qe[0] = Co, Qe[1] = Wn, Qe[2] = 0, Qe[3] = -Wn, Qe[4] = Co, Qe[5] = 0, Qe[6] = 0, Qe[7] = 0, Qe[8] = 1, Qe;
                        }, Qe.bN = function(Qe, rt, Wn) {
                            var Co = rt[0], Dl = rt[1], Ll = rt[2];
                            return Qe[0] = Co * Wn[0] + Dl * Wn[3] + Ll * Wn[6], Qe[1] = Co * Wn[1] + Dl * Wn[4] + Ll * Wn[7], Qe[2] = Co * Wn[2] + Dl * Wn[5] + Ll * Wn[8], Qe;
                        }, Qe.bO = function(Qe, rt, Wn, Co, Dl, Ll, Rl) {
                            var Ul = 1 / (rt - Wn), Gl = 1 / (Co - Dl), Zl = 1 / (Ll - Rl);
                            return Qe[0] = -2 * Ul, Qe[1] = 0, Qe[2] = 0, Qe[3] = 0, Qe[4] = 0, Qe[5] = -2 * Gl, Qe[6] = 0, Qe[7] = 0, Qe[8] = 0, Qe[9] = 0, Qe[10] = 2 * Zl, Qe[11] = 0, Qe[12] = (rt + Wn) * Ul, Qe[13] = (Dl + Co) * Gl, Qe[14] = (Rl + Ll) * Zl, Qe[15] = 1, Qe;
                        }, Qe.bP = class extends Ks {
                        }, Qe.bQ = Im, Qe.bR = class extends Hs {
                        }, Qe.bS = Gp, Qe.bT = function(Qe) {
                            return Qe <= 1 ? 1 : Math.pow(2, Math.ceil(Math.log(Qe) / Math.LN2));
                        }, Qe.bU = Uo, Qe.bV = function(Qe, rt, Wn) {
                            var Co = rt[0], Dl = rt[1], Ll = rt[2], Rl = Wn[3] * Co + Wn[7] * Dl + Wn[11] * Ll + Wn[15];
                            return Qe[0] = (Wn[0] * Co + Wn[4] * Dl + Wn[8] * Ll + Wn[12]) / (Rl = Rl || 1), Qe[1] = (Wn[1] * Co + Wn[5] * Dl + Wn[9] * Ll + Wn[13]) / Rl, Qe[2] = (Wn[2] * Co + Wn[6] * Dl + Wn[10] * Ll + Wn[14]) / Rl, Qe;
                        }, Qe.bW = class extends Ls {
                        }, Qe.bX = class extends ra {
                        }, Qe.bY = function(Qe, rt) {
                            return Qe[0] === rt[0] && Qe[1] === rt[1] && Qe[2] === rt[2] && Qe[3] === rt[3] && Qe[4] === rt[4] && Qe[5] === rt[5] && Qe[6] === rt[6] && Qe[7] === rt[7] && Qe[8] === rt[8] && Qe[9] === rt[9] && Qe[10] === rt[10] && Qe[11] === rt[11] && Qe[12] === rt[12] && Qe[13] === rt[13] && Qe[14] === rt[14] && Qe[15] === rt[15];
                        }, Qe.bZ = function(Qe, rt) {
                            var Wn = Qe[0], Co = Qe[1], Dl = Qe[2], Ll = Qe[3], Rl = Qe[4], Ul = Qe[5], Gl = Qe[6], Zl = Qe[7], Hl = Qe[8], Ql = Qe[9], Kl = Qe[10], $l = Qe[11], Tc = Qe[12], tu = Qe[13], lu = Qe[14], du = Qe[15], fu = rt[0], yu = rt[1], Eu = rt[2], Tu = rt[3], Lu = rt[4], Zu = rt[5], Xu = rt[6], Ju = rt[7], $u = rt[8], ed = rt[9], td = rt[10], id = rt[11], nd = rt[12], rd = rt[13], sd = rt[14], ad = rt[15];
                            return Math.abs(Wn - fu) <= ql * Math.max(1, Math.abs(Wn), Math.abs(fu)) && Math.abs(Co - yu) <= ql * Math.max(1, Math.abs(Co), Math.abs(yu)) && Math.abs(Dl - Eu) <= ql * Math.max(1, Math.abs(Dl), Math.abs(Eu)) && Math.abs(Ll - Tu) <= ql * Math.max(1, Math.abs(Ll), Math.abs(Tu)) && Math.abs(Rl - Lu) <= ql * Math.max(1, Math.abs(Rl), Math.abs(Lu)) && Math.abs(Ul - Zu) <= ql * Math.max(1, Math.abs(Ul), Math.abs(Zu)) && Math.abs(Gl - Xu) <= ql * Math.max(1, Math.abs(Gl), Math.abs(Xu)) && Math.abs(Zl - Ju) <= ql * Math.max(1, Math.abs(Zl), Math.abs(Ju)) && Math.abs(Hl - $u) <= ql * Math.max(1, Math.abs(Hl), Math.abs($u)) && Math.abs(Ql - ed) <= ql * Math.max(1, Math.abs(Ql), Math.abs(ed)) && Math.abs(Kl - td) <= ql * Math.max(1, Math.abs(Kl), Math.abs(td)) && Math.abs($l - id) <= ql * Math.max(1, Math.abs($l), Math.abs(id)) && Math.abs(Tc - nd) <= ql * Math.max(1, Math.abs(Tc), Math.abs(nd)) && Math.abs(tu - rd) <= ql * Math.max(1, Math.abs(tu), Math.abs(rd)) && Math.abs(lu - sd) <= ql * Math.max(1, Math.abs(lu), Math.abs(sd)) && Math.abs(du - ad) <= ql * Math.max(1, Math.abs(du), Math.abs(ad));
                        }, Qe.b_ = function(Qe, rt) {
                            return Qe[0] = rt[0], Qe[1] = rt[1], Qe[2] = rt[2], Qe[3] = rt[3], Qe[4] = rt[4], Qe[5] = rt[5], Qe[6] = rt[6], Qe[7] = rt[7], Qe[8] = rt[8], Qe[9] = rt[9], Qe[10] = rt[10], Qe[11] = rt[11], Qe[12] = rt[12], Qe[13] = rt[13], Qe[14] = rt[14], Qe[15] = rt[15], Qe;
                        }, Qe.ba = Qp, Qe.bb = Al, Qe.bc = P, Qe.bd = C, Qe.be = ze, Qe.bf = function(Qe, rt, Wn, Co, Dl) {
                            return P(Co, Dl, E((Qe - rt) / (Wn - rt), 0, 1));
                        }, Qe.bg = z, Qe.bh = function() {
                            return new Float64Array(4);
                        }, Qe.bi = function() {
                            return new Float64Array(3);
                        }, Qe.bj = function(Qe, rt, Wn, Co) {
                            var Dl = [], Ll = [];
                            return Dl[0] = rt[0] - Wn[0], Dl[1] = rt[1] - Wn[1], Dl[2] = rt[2] - Wn[2], Ll[0] = Dl[0] * Math.cos(Co) - Dl[1] * Math.sin(Co), Ll[1] = Dl[0] * Math.sin(Co) + Dl[1] * Math.cos(Co), Ll[2] = Dl[2], Qe[0] = Ll[0] + Wn[0], Qe[1] = Ll[1] + Wn[1], Qe[2] = Ll[2] + Wn[2], Qe;
                        }, Qe.bk = function(Qe, rt, Wn, Co) {
                            var Dl = [], Ll = [];
                            return Dl[0] = rt[0] - Wn[0], Dl[1] = rt[1] - Wn[1], Dl[2] = rt[2] - Wn[2], Ll[0] = Dl[0], Ll[1] = Dl[1] * Math.cos(Co) - Dl[2] * Math.sin(Co), Ll[2] = Dl[1] * Math.sin(Co) + Dl[2] * Math.cos(Co), Qe[0] = Ll[0] + Wn[0], Qe[1] = Ll[1] + Wn[1], Qe[2] = Ll[2] + Wn[2], Qe;
                        }, Qe.bl = function(Qe, rt, Wn, Co) {
                            var Dl = [], Ll = [];
                            return Dl[0] = rt[0] - Wn[0], Dl[1] = rt[1] - Wn[1], Dl[2] = rt[2] - Wn[2], Ll[0] = Dl[2] * Math.sin(Co) + Dl[0] * Math.cos(Co), Ll[1] = Dl[1], Ll[2] = Dl[2] * Math.cos(Co) - Dl[0] * Math.sin(Co), Qe[0] = Ll[0] + Wn[0], Qe[1] = Ll[1] + Wn[1], Qe[2] = Ll[2] + Wn[2], Qe;
                        }, Qe.bm = function(Qe, rt, Wn) {
                            var Co = Math.sin(Wn), Dl = Math.cos(Wn), Ll = rt[0], Rl = rt[1], Ul = rt[2], Gl = rt[3], Zl = rt[8], Hl = rt[9], ql = rt[10], Ql = rt[11];
                            return rt !== Qe && (Qe[4] = rt[4], Qe[5] = rt[5], Qe[6] = rt[6], Qe[7] = rt[7], Qe[12] = rt[12], Qe[13] = rt[13], Qe[14] = rt[14], Qe[15] = rt[15]), Qe[0] = Ll * Dl - Zl * Co, Qe[1] = Rl * Dl - Hl * Co, Qe[2] = Ul * Dl - ql * Co, Qe[3] = Gl * Dl - Ql * Co, Qe[8] = Ll * Co + Zl * Dl, Qe[9] = Rl * Co + Hl * Dl, Qe[10] = Ul * Co + ql * Dl, Qe[11] = Gl * Co + Ql * Dl, Qe;
                        }, Qe.bn = function(Qe, rt) {
                            const Wn = z(Qe, 360), Co = z(rt, 360), Dl = Co - Wn, Ll = Co > Wn ? Dl - 360 : Dl + 360;
                            return Math.abs(Dl) < Math.abs(Ll) ? Dl : Ll;
                        }, Qe.bo = function(Qe) {
                            return Qe[0] = 0, Qe[1] = 0, Qe[2] = 0, Qe;
                        }, Qe.bp = function(Qe, rt, Wn, Co) {
                            const Dl = Math.sqrt(Qe * Qe + rt * rt), Ll = Math.sqrt(Wn * Wn + Co * Co);
                            Qe /= Dl, rt /= Dl, Wn /= Ll, Co /= Ll;
                            const Rl = Math.acos(Qe * Wn + rt * Co);
                            return -rt * Wn + Qe * Co > 0 ? Rl : -Rl;
                        }, Qe.bq = function(Qe, rt) {
                            return Qe[0] * rt[0] + Qe[1] * rt[1] + Qe[2] * rt[2] + Qe[3];
                        }, Qe.br = af, Qe.bs = function(Qe, rt) {
                            const Wn = z(Qe, 2 * Math.PI), Co = z(rt, 2 * Math.PI);
                            return Math.min(Math.abs(Wn - Co), Math.abs(Wn - Co + 2 * Math.PI), Math.abs(Wn - Co - 2 * Math.PI));
                        }, Qe.bt = function(Qe) {
                            return Math.hypot(Qe[0], Qe[1], Qe[2]);
                        }, Qe.bu = function() {
                            const Qe = {}, rt = Ju.$version;
                            for(const Wn in Ju.$root){
                                const Co = Ju.$root[Wn];
                                if (Co.required) {
                                    let Dl = null;
                                    Dl = "version" === Wn ? rt : "array" === Co.type ? [] : {}, null != Dl && (Qe[Wn] = Dl);
                                }
                            }
                            return Qe;
                        }, Qe.bv = Wi, Qe.bw = at, Qe.bx = function(Qe) {
                            Qe = Qe.slice();
                            const rt = Object.create(null);
                            for(let Wn = 0; Wn < Qe.length; Wn++)rt[Qe[Wn].id] = Qe[Wn];
                            for(let Wn = 0; Wn < Qe.length; Wn++)"ref" in Qe[Wn] && (Qe[Wn] = mt(Qe[Wn], rt[Qe[Wn].ref]));
                            return Qe;
                        }, Qe.by = function(Qe) {
                            if ("custom" === Qe.type) return new Gc(Qe);
                            switch(Qe.type){
                                case "background":
                                    return new jc(Qe);
                                case "circle":
                                    return new Eo(Qe);
                                case "fill":
                                    return new Ol(Qe);
                                case "fill-extrusion":
                                    return new uu(Qe);
                                case "heatmap":
                                    return new Go(Qe);
                                case "hillshade":
                                    return new Xo(Qe);
                                case "line":
                                    return new ku(Qe);
                                case "raster":
                                    return new qc(Qe);
                                case "symbol":
                                    return new Oc(Qe);
                            }
                        }, Qe.bz = D, Qe.c = et, Qe.c0 = (Qe)=>"circle" === Qe.type, Qe.c1 = (Qe)=>"heatmap" === Qe.type, Qe.c2 = (Qe)=>"line" === Qe.type, Qe.c3 = (Qe)=>"fill" === Qe.type, Qe.c4 = (Qe)=>"fill-extrusion" === Qe.type, Qe.c5 = (Qe)=>"hillshade" === Qe.type, Qe.c6 = (Qe)=>"raster" === Qe.type, Qe.c7 = (Qe)=>"background" === Qe.type, Qe.c8 = (Qe)=>"custom" === Qe.type, Qe.c9 = B, Qe.cA = class {
                            constructor(Qe){
                                this._marks = {
                                    start: [
                                        Qe.url,
                                        "start"
                                    ].join("#"),
                                    end: [
                                        Qe.url,
                                        "end"
                                    ].join("#"),
                                    measure: Qe.url.toString()
                                }, performance.mark(this._marks.start);
                            }
                            finish() {
                                performance.mark(this._marks.end);
                                let Qe = performance.getEntriesByName(this._marks.measure);
                                return 0 === Qe.length && (performance.measure(this._marks.measure, this._marks.start, this._marks.end), Qe = performance.getEntriesByName(this._marks.measure), performance.clearMarks(this._marks.start), performance.clearMarks(this._marks.end), performance.clearMeasures(this._marks.measure)), Qe;
                            }
                        }, Qe.cB = function(Qe, rt, Wn, Co, Dl) {
                            return e(this, void 0, void 0, function*() {
                                if (d()) try {
                                    return yield K(Qe, rt, Wn, Co, Dl);
                                } catch (Qe) {}
                                return function(Qe, rt, Wn, Co, Dl) {
                                    const Ll = Qe.width, Rl = Qe.height;
                                    fu && yu || (fu = new OffscreenCanvas(Ll, Rl), yu = fu.getContext("2d", {
                                        willReadFrequently: !0
                                    })), fu.width = Ll, fu.height = Rl, yu.drawImage(Qe, 0, 0, Ll, Rl);
                                    const Ul = yu.getImageData(rt, Wn, Co, Dl);
                                    return yu.clearRect(0, 0, Ll, Rl), Ul.data;
                                }(Qe, rt, Wn, Co, Dl);
                            });
                        }, Qe.cC = uh, Qe.cD = r, Qe.cE = s, Qe.cF = Wl, Qe.cG = Ru, Qe.cH = Gn, Qe.cI = _p, Qe.ca = function(Qe, rt, Wn) {
                            const Co = k(rt.x - Wn.x, rt.y - Wn.y), Dl = k(Qe.x - Wn.x, Qe.y - Wn.y);
                            var Ll, Rl;
                            return J(Math.atan2(Co[0] * Dl[1] - Co[1] * Dl[0], (Ll = Co)[0] * (Rl = Dl)[0] + Ll[1] * Rl[1]));
                        }, Qe.cb = $l, Qe.cc = function(Qe, rt) {
                            return Tu[rt] && (Qe instanceof MouseEvent || Qe instanceof WheelEvent);
                        }, Qe.cd = function(Qe, rt) {
                            return Eu[rt] && "touches" in Qe;
                        }, Qe.ce = function(Qe) {
                            return Eu[Qe] || Tu[Qe];
                        }, Qe.cf = function(Qe, rt, Wn) {
                            var Co = rt[0], Dl = rt[1];
                            return Qe[0] = Wn[0] * Co + Wn[4] * Dl + Wn[12], Qe[1] = Wn[1] * Co + Wn[5] * Dl + Wn[13], Qe;
                        }, Qe.cg = function(Qe, rt) {
                            const { x: Wn, y: Co } = nh.fromLngLat(rt);
                            return !(Qe < 0 || Qe > 25 || Co < 0 || Co >= 1 || Wn < 0 || Wn >= 1);
                        }, Qe.ch = function(Qe, rt) {
                            return Qe[0] = rt[0], Qe[1] = 0, Qe[2] = 0, Qe[3] = 0, Qe[4] = 0, Qe[5] = rt[1], Qe[6] = 0, Qe[7] = 0, Qe[8] = 0, Qe[9] = 0, Qe[10] = rt[2], Qe[11] = 0, Qe[12] = 0, Qe[13] = 0, Qe[14] = 0, Qe[15] = 1, Qe;
                        }, Qe.ci = class extends $s {
                        }, Qe.cj = vf, Qe.cl = function(Qe) {
                            return Qe.message === Lu;
                        }, Qe.cm = st, Qe.cn = function(Qe, rt) {
                            Zu.REGISTERED_PROTOCOLS[Qe] = rt;
                        }, Qe.co = function(Qe) {
                            delete Zu.REGISTERED_PROTOCOLS[Qe];
                        }, Qe.cp = function(Qe, rt) {
                            const Wn = {};
                            for(let Dl = 0; Dl < Qe.length; Dl++){
                                const Co = rt && rt[Qe[Dl].id] || li(Qe[Dl]);
                                rt && (rt[Qe[Dl].id] = Co);
                                let Ll = Wn[Co];
                                Ll || (Ll = Wn[Co] = []), Ll.push(Qe[Dl]);
                            }
                            const Co = [];
                            for(const Dl in Wn)Co.push(Wn[Dl]);
                            return Co;
                        }, Qe.cq = Zi, Qe.cr = ch, Qe.cs = ph, Qe.ct = Yu, Qe.cu = function(rt) {
                            rt.bucket.createArrays(), rt.bucket.tilePixelRatio = Kl / (512 * rt.bucket.overscaling), rt.bucket.compareText = {}, rt.bucket.iconsNeedLinear = !1;
                            const Wn = rt.bucket.layers[0], Co = Wn.layout, Dl = Wn._unevaluatedLayout._values, Ll = {
                                layoutIconSize: Dl["icon-size"].possiblyEvaluate(new fs(rt.bucket.zoom + 1), rt.canonical),
                                layoutTextSize: Dl["text-size"].possiblyEvaluate(new fs(rt.bucket.zoom + 1), rt.canonical),
                                textMaxSize: Dl["text-size"].possiblyEvaluate(new fs(18))
                            };
                            if ("composite" === rt.bucket.textSizeData.kind) {
                                const { minZoom: Qe, maxZoom: Wn } = rt.bucket.textSizeData;
                                Ll.compositeTextSizes = [
                                    Dl["text-size"].possiblyEvaluate(new fs(Qe), rt.canonical),
                                    Dl["text-size"].possiblyEvaluate(new fs(Wn), rt.canonical)
                                ];
                            }
                            if ("composite" === rt.bucket.iconSizeData.kind) {
                                const { minZoom: Qe, maxZoom: Wn } = rt.bucket.iconSizeData;
                                Ll.compositeIconSizes = [
                                    Dl["icon-size"].possiblyEvaluate(new fs(Qe), rt.canonical),
                                    Dl["icon-size"].possiblyEvaluate(new fs(Wn), rt.canonical)
                                ];
                            }
                            const Rl = Co.get("text-line-height") * Nm, Ul = "viewport" !== Co.get("text-rotation-alignment") && "point" !== Co.get("symbol-placement"), Gl = Co.get("text-keep-upright"), Zl = Co.get("text-size");
                            for (const Hl of rt.bucket.features){
                                const Dl = Co.get("text-font").evaluate(Hl, {}, rt.canonical).join(","), ql = Zl.evaluate(Hl, {}, rt.canonical), Ql = Ll.layoutTextSize.evaluate(Hl, {}, rt.canonical), Kl = Ll.layoutIconSize.evaluate(Hl, {}, rt.canonical), $l = {
                                    horizontal: {},
                                    vertical: void 0
                                }, Tc = Hl.text;
                                let tu, lu = [
                                    0,
                                    0
                                ];
                                if (Tc) {
                                    const Ll = Tc.toString(), Zl = Co.get("text-letter-spacing").evaluate(Hl, {}, rt.canonical) * Nm, Kl = es(Ll) ? Zl : 0, tu = Co.get("text-anchor").evaluate(Hl, {}, rt.canonical), du = Rh(Wn, Hl, rt.canonical);
                                    if (!du) {
                                        const Qe = Co.get("text-radial-offset").evaluate(Hl, {}, rt.canonical);
                                        lu = Qe ? Dh(tu, [
                                            Qe * Nm,
                                            hf
                                        ]) : Co.get("text-offset").evaluate(Hl, {}, rt.canonical).map((Qe)=>Qe * Nm);
                                    }
                                    let fu = Ul ? "center" : Co.get("text-justify").evaluate(Hl, {}, rt.canonical);
                                    const yu = "point" === Co.get("symbol-placement") ? Co.get("text-max-width").evaluate(Hl, {}, rt.canonical) * Nm : 1 / 0, w = ()=>{
                                        rt.bucket.allowVerticalPlacement && ts(Ll) && ($l.vertical = ec(Tc, rt.glyphMap, rt.glyphPositions, rt.imagePositions, Dl, yu, Rl, tu, "left", Kl, lu, Qe.ah.vertical, !0, Ql, ql));
                                    };
                                    if (!Ul && du) {
                                        const Wn = new Set;
                                        if ("auto" === fu) for(let Qe = 0; Qe < du.values.length; Qe += 2)Wn.add(jh(du.values[Qe]));
                                        else Wn.add(fu);
                                        let Co = !1;
                                        for (const Ll of Wn)if (!$l.horizontal[Ll]) {
                                            if (Co) $l.horizontal[Ll] = $l.horizontal[0];
                                            else {
                                                const Wn = ec(Tc, rt.glyphMap, rt.glyphPositions, rt.imagePositions, Dl, yu, Rl, "center", Ll, Kl, lu, Qe.ah.horizontal, !1, Ql, ql);
                                                Wn && ($l.horizontal[Ll] = Wn, Co = 1 === Wn.positionedLines.length);
                                            }
                                        }
                                        w();
                                    } else {
                                        "auto" === fu && (fu = jh(tu));
                                        const Wn = ec(Tc, rt.glyphMap, rt.glyphPositions, rt.imagePositions, Dl, yu, Rl, tu, fu, Kl, lu, Qe.ah.horizontal, !1, Ql, ql);
                                        Wn && ($l.horizontal[fu] = Wn), w(), ts(Ll) && Ul && Gl && ($l.vertical = ec(Tc, rt.glyphMap, rt.glyphPositions, rt.imagePositions, Dl, yu, Rl, tu, fu, Kl, lu, Qe.ah.vertical, !1, Ql, ql));
                                    }
                                }
                                let du = !1;
                                if (Hl.icon && Hl.icon.name) {
                                    const Qe = rt.imageMap[Hl.icon.name];
                                    Qe && (tu = xc(rt.imagePositions[Hl.icon.name], Co.get("icon-offset").evaluate(Hl, {}, rt.canonical), Co.get("icon-anchor").evaluate(Hl, {}, rt.canonical)), du = !!Qe.sdf, void 0 === rt.bucket.sdfIcons ? rt.bucket.sdfIcons = du : rt.bucket.sdfIcons !== du && j("Style sheet warning: Cannot mix SDF and non-SDF icons in one buffer"), (Qe.pixelRatio !== rt.bucket.pixelRatio || 0 !== Co.get("icon-rotate").constantOr(1)) && (rt.bucket.iconsNeedLinear = !0));
                                }
                                const fu = qh($l.horizontal) || $l.vertical;
                                rt.bucket.iconsInText = !!fu && fu.iconsInText, (fu || tu) && Nh(rt.bucket, Hl, $l, tu, rt.imageMap, Ll, Ql, Kl, lu, du, rt.canonical, rt.subdivisionGranularity);
                            }
                            rt.showCollisionBoxes && rt.bucket.generateCollisionDebugBuffers();
                        }, Qe.cv = vu, Qe.cw = Tl, Qe.cx = nu, Qe.cy = um, Qe.cz = Bm, Qe.d = lt, Qe.e = F, Qe.f = (Qe)=>e(void 0, void 0, void 0, function*() {
                                if (0 === Qe.byteLength) return createImageBitmap(new ImageData(1, 1));
                                const rt = new Blob([
                                    new Uint8Array(Qe)
                                ], {
                                    type: "image/png"
                                });
                                try {
                                    return createImageBitmap(rt);
                                } catch (Qe) {
                                    throw new Error(`Could not load image because of ${Qe.message}. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported.`);
                                }
                            }), Qe.g = nt, Qe.h = (Qe)=>new Promise((rt, Wn)=>{
                                const Co = new Image;
                                Co.onload = ()=>{
                                    rt(Co), URL.revokeObjectURL(Co.src), Co.onload = null, window.requestAnimationFrame(()=>{
                                        Co.src = du;
                                    });
                                }, Co.onerror = ()=>Wn(new Error("Could not load image. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported."));
                                const Dl = new Blob([
                                    new Uint8Array(Qe)
                                ], {
                                    type: "image/png"
                                });
                                Co.src = Qe.byteLength ? URL.createObjectURL(Dl) : du;
                            }), Qe.i = U, Qe.j = (Qe, rt)=>ot(F(Qe, {
                                type: "json"
                            }), rt), Qe.k = pt, Qe.l = ht, Qe.m = ot, Qe.n = (Qe, rt)=>ot(F(Qe, {
                                type: "arrayBuffer"
                            }), rt), Qe.o = function(Qe) {
                            return new Bm(Qe).readFields(Uu, []);
                        }, Qe.p = Ku, Qe.q = jo, Qe.r = Is, Qe.s = Y, Qe.t = Qd, Qe.u = up, Qe.v = Ju, Qe.w = j, Qe.x = Ui, Qe.y = Yd, Qe.z = function([Qe, rt, Wn]) {
                            return rt += 90, rt *= Math.PI / 180, Wn *= Math.PI / 180, {
                                x: Qe * Math.cos(rt) * Math.sin(Wn),
                                y: Qe * Math.sin(rt) * Math.sin(Wn),
                                z: Qe * Math.cos(Wn)
                            };
                        };
                    }), define("worker", [
                        "./shared"
                    ], function(Qe) {
                        class t {
                            constructor(Qe){
                                this.keyCache = {}, Qe && this.replace(Qe);
                            }
                            replace(Qe) {
                                this._layerConfigs = {}, this._layers = {}, this.update(Qe, []);
                            }
                            update(rt, Wn) {
                                for (const Dl of rt){
                                    this._layerConfigs[Dl.id] = Dl;
                                    const rt = this._layers[Dl.id] = Qe.by(Dl);
                                    rt._featureFilter = Qe.a7(rt.filter), this.keyCache[Dl.id] && delete this.keyCache[Dl.id];
                                }
                                for (const Qe of Wn)delete this.keyCache[Qe], delete this._layerConfigs[Qe], delete this._layers[Qe];
                                this.familiesBySource = {};
                                const Co = Qe.cp(Object.values(this._layerConfigs), this.keyCache);
                                for (const Qe of Co){
                                    const rt = Qe.map((Qe)=>this._layers[Qe.id]), Wn = rt[0];
                                    if ("none" === Wn.visibility) continue;
                                    const Co = Wn.source || "";
                                    let Dl = this.familiesBySource[Co];
                                    Dl || (Dl = this.familiesBySource[Co] = {});
                                    const Ll = Wn.sourceLayer || "_geojsonTileLayer";
                                    let Rl = Dl[Ll];
                                    Rl || (Rl = Dl[Ll] = []), Rl.push(rt);
                                }
                            }
                        }
                        class o {
                            constructor(rt){
                                const Wn = {}, Co = [];
                                for(const Qe in rt){
                                    const Dl = rt[Qe], Ll = Wn[Qe] = {};
                                    for(const Qe in Dl){
                                        const rt = Dl[+Qe];
                                        if (!rt || 0 === rt.bitmap.width || 0 === rt.bitmap.height) continue;
                                        const Wn = {
                                            x: 0,
                                            y: 0,
                                            w: rt.bitmap.width + 2,
                                            h: rt.bitmap.height + 2
                                        };
                                        Co.push(Wn), Ll[Qe] = {
                                            rect: Wn,
                                            metrics: rt.metrics
                                        };
                                    }
                                }
                                const { w: Dl, h: Ll } = Qe.p(Co), Rl = new Qe.q({
                                    width: Dl || 1,
                                    height: Ll || 1
                                });
                                for(const Ul in rt){
                                    const Co = rt[Ul];
                                    for(const rt in Co){
                                        const Dl = Co[+rt];
                                        if (!Dl || 0 === Dl.bitmap.width || 0 === Dl.bitmap.height) continue;
                                        const Ll = Wn[Ul][rt].rect;
                                        Qe.q.copy(Dl.bitmap, Rl, {
                                            x: 0,
                                            y: 0
                                        }, {
                                            x: Ll.x + 1,
                                            y: Ll.y + 1
                                        }, Dl.bitmap);
                                    }
                                }
                                this.image = Rl, this.positions = Wn;
                            }
                        }
                        Qe.cq("GlyphAtlas", o);
                        class i {
                            constructor(rt){
                                this.tileID = new Qe.Y(rt.tileID.overscaledZ, rt.tileID.wrap, rt.tileID.canonical.z, rt.tileID.canonical.x, rt.tileID.canonical.y), this.uid = rt.uid, this.zoom = rt.zoom, this.pixelRatio = rt.pixelRatio, this.tileSize = rt.tileSize, this.source = rt.source, this.overscaling = this.tileID.overscaleFactor(), this.showCollisionBoxes = rt.showCollisionBoxes, this.collectResourceTiming = !!rt.collectResourceTiming, this.returnDependencies = !!rt.returnDependencies, this.promoteId = rt.promoteId, this.inFlightDependencies = [];
                            }
                            parse(rt, Wn, Co, Dl, Ll) {
                                return Qe._(this, void 0, void 0, function*() {
                                    this.status = "parsing", this.data = rt, this.collisionBoxArray = new Qe.a5;
                                    const Rl = new Qe.cr(Object.keys(rt.layers).sort()), Ul = new Qe.cs(this.tileID, this.promoteId);
                                    Ul.bucketLayerIDs = [];
                                    const Gl = {}, Zl = {
                                        featureIndex: Ul,
                                        iconDependencies: {},
                                        patternDependencies: {},
                                        glyphDependencies: {},
                                        availableImages: Co,
                                        subdivisionGranularity: Ll
                                    }, Hl = Wn.familiesBySource[this.source];
                                    for(const Wn in Hl){
                                        const Dl = rt.layers[Wn];
                                        if (!Dl) continue;
                                        1 === Dl.version && Qe.w(`Vector tile source "${this.source}" layer "${Wn}" does not use vector tile spec v2 and therefore may have some rendering errors.`);
                                        const Ll = Rl.encode(Wn), ql = [];
                                        for(let Qe = 0; Qe < Dl.length; Qe++){
                                            const rt = Dl.feature(Qe), Co = Ul.getId(rt, Wn);
                                            ql.push({
                                                feature: rt,
                                                id: Co,
                                                index: Qe,
                                                sourceLayerIndex: Ll
                                            });
                                        }
                                        for (const rt of Hl[Wn]){
                                            const Wn = rt[0];
                                            Wn.source !== this.source && Qe.w(`layer.source = ${Wn.source} does not equal this.source = ${this.source}`), Wn.minzoom && this.zoom < Math.floor(Wn.minzoom) || Wn.maxzoom && this.zoom >= Wn.maxzoom || "none" !== Wn.visibility && (r(rt, this.zoom, Co), (Gl[Wn.id] = Wn.createBucket({
                                                index: Ul.bucketLayerIDs.length,
                                                layers: rt,
                                                zoom: this.zoom,
                                                pixelRatio: this.pixelRatio,
                                                overscaling: this.overscaling,
                                                collisionBoxArray: this.collisionBoxArray,
                                                sourceLayerIndex: Ll,
                                                sourceID: this.source
                                            })).populate(ql, Zl, this.tileID.canonical), Ul.bucketLayerIDs.push(rt.map((Qe)=>Qe.id)));
                                        }
                                    }
                                    const ql = Qe.bD(Zl.glyphDependencies, (Qe)=>Object.keys(Qe).map(Number));
                                    this.inFlightDependencies.forEach((Qe)=>null == Qe ? void 0 : Qe.abort()), this.inFlightDependencies = [];
                                    let Ql = Promise.resolve({});
                                    if (Object.keys(ql).length) {
                                        const Qe = new AbortController;
                                        this.inFlightDependencies.push(Qe), Ql = Dl.sendAsync({
                                            type: "GG",
                                            data: {
                                                stacks: ql,
                                                source: this.source,
                                                tileID: this.tileID,
                                                type: "glyphs"
                                            }
                                        }, Qe);
                                    }
                                    const Kl = Object.keys(Zl.iconDependencies);
                                    let $l = Promise.resolve({});
                                    if (Kl.length) {
                                        const Qe = new AbortController;
                                        this.inFlightDependencies.push(Qe), $l = Dl.sendAsync({
                                            type: "GI",
                                            data: {
                                                icons: Kl,
                                                source: this.source,
                                                tileID: this.tileID,
                                                type: "icons"
                                            }
                                        }, Qe);
                                    }
                                    const Tc = Object.keys(Zl.patternDependencies);
                                    let tu = Promise.resolve({});
                                    if (Tc.length) {
                                        const Qe = new AbortController;
                                        this.inFlightDependencies.push(Qe), tu = Dl.sendAsync({
                                            type: "GI",
                                            data: {
                                                icons: Tc,
                                                source: this.source,
                                                tileID: this.tileID,
                                                type: "patterns"
                                            }
                                        }, Qe);
                                    }
                                    const [lu, du, fu] = yield Promise.all([
                                        Ql,
                                        $l,
                                        tu
                                    ]), yu = new o(lu), Eu = new Qe.ct(du, fu);
                                    for(const rt in Gl){
                                        const Wn = Gl[rt];
                                        Wn instanceof Qe.a6 ? (r(Wn.layers, this.zoom, Co), Qe.cu({
                                            bucket: Wn,
                                            glyphMap: lu,
                                            glyphPositions: yu.positions,
                                            imageMap: du,
                                            imagePositions: Eu.iconPositions,
                                            showCollisionBoxes: this.showCollisionBoxes,
                                            canonical: this.tileID.canonical,
                                            subdivisionGranularity: Zl.subdivisionGranularity
                                        })) : Wn.hasPattern && (Wn instanceof Qe.cv || Wn instanceof Qe.cw || Wn instanceof Qe.cx) && (r(Wn.layers, this.zoom, Co), Wn.addFeatures(Zl, this.tileID.canonical, Eu.patternPositions));
                                    }
                                    return this.status = "done", {
                                        buckets: Object.values(Gl).filter((Qe)=>!Qe.isEmpty()),
                                        featureIndex: Ul,
                                        collisionBoxArray: this.collisionBoxArray,
                                        glyphAtlasImage: yu.image,
                                        imageAtlas: Eu,
                                        glyphMap: this.returnDependencies ? lu : null,
                                        iconMap: this.returnDependencies ? du : null,
                                        glyphPositions: this.returnDependencies ? yu.positions : null
                                    };
                                });
                            }
                        }
                        function r(rt, Wn, Co) {
                            const Dl = new Qe.C(Wn);
                            for (const Qe of rt)Qe.recalculate(Dl, Co);
                        }
                        class s {
                            constructor(Qe, rt, Wn){
                                this.actor = Qe, this.layerIndex = rt, this.availableImages = Wn, this.fetching = {}, this.loading = {}, this.loaded = {};
                            }
                            loadVectorTile(rt, Wn) {
                                return Qe._(this, void 0, void 0, function*() {
                                    const Co = yield Qe.n(rt.request, Wn);
                                    try {
                                        return {
                                            vectorTile: new Qe.cy.VectorTile(new Qe.cz(Co.data)),
                                            rawData: Co.data,
                                            cacheControl: Co.cacheControl,
                                            expires: Co.expires
                                        };
                                    } catch (Qe) {
                                        const Dl = new Uint8Array(Co.data);
                                        let Ll = `Unable to parse the tile at ${rt.request.url}, `;
                                        throw Ll += 31 === Dl[0] && 139 === Dl[1] ? "please make sure the data is not gzipped and that you have configured the relevant header in the server" : `got error: ${Qe.message}`, new Error(Ll);
                                    }
                                });
                            }
                            loadTile(rt) {
                                return Qe._(this, void 0, void 0, function*() {
                                    const Wn = rt.uid, Co = !!(rt && rt.request && rt.request.collectResourceTiming) && new Qe.cA(rt.request), Dl = new i(rt);
                                    this.loading[Wn] = Dl;
                                    const Ll = new AbortController;
                                    Dl.abort = Ll;
                                    try {
                                        const Rl = yield this.loadVectorTile(rt, Ll);
                                        if (delete this.loading[Wn], !Rl) return null;
                                        const Ul = Rl.rawData, Gl = {};
                                        Rl.expires && (Gl.expires = Rl.expires), Rl.cacheControl && (Gl.cacheControl = Rl.cacheControl);
                                        const Zl = {};
                                        if (Co) {
                                            const Qe = Co.finish();
                                            Qe && (Zl.resourceTiming = JSON.parse(JSON.stringify(Qe)));
                                        }
                                        Dl.vectorTile = Rl.vectorTile;
                                        const Hl = Dl.parse(Rl.vectorTile, this.layerIndex, this.availableImages, this.actor, rt.subdivisionGranularity);
                                        this.loaded[Wn] = Dl, this.fetching[Wn] = {
                                            rawTileData: Ul,
                                            cacheControl: Gl,
                                            resourceTiming: Zl
                                        };
                                        try {
                                            const rt = yield Hl;
                                            return Qe.e({
                                                rawTileData: Ul.slice(0)
                                            }, rt, Gl, Zl);
                                        } finally{
                                            delete this.fetching[Wn];
                                        }
                                    } catch (Qe) {
                                        throw delete this.loading[Wn], Dl.status = "done", this.loaded[Wn] = Dl, Qe;
                                    }
                                });
                            }
                            reloadTile(rt) {
                                return Qe._(this, void 0, void 0, function*() {
                                    const Wn = rt.uid;
                                    if (!this.loaded || !this.loaded[Wn]) throw new Error("Should not be trying to reload a tile that was never loaded or has been removed");
                                    const Co = this.loaded[Wn];
                                    if (Co.showCollisionBoxes = rt.showCollisionBoxes, "parsing" === Co.status) {
                                        const Dl = yield Co.parse(Co.vectorTile, this.layerIndex, this.availableImages, this.actor, rt.subdivisionGranularity);
                                        let Ll;
                                        if (this.fetching[Wn]) {
                                            const { rawTileData: rt, cacheControl: Co, resourceTiming: Rl } = this.fetching[Wn];
                                            delete this.fetching[Wn], Ll = Qe.e({
                                                rawTileData: rt.slice(0)
                                            }, Dl, Co, Rl);
                                        } else Ll = Dl;
                                        return Ll;
                                    }
                                    if ("done" === Co.status && Co.vectorTile) return Co.parse(Co.vectorTile, this.layerIndex, this.availableImages, this.actor, rt.subdivisionGranularity);
                                });
                            }
                            abortTile(rt) {
                                return Qe._(this, void 0, void 0, function*() {
                                    const Qe = this.loading, Wn = rt.uid;
                                    Qe && Qe[Wn] && Qe[Wn].abort && (Qe[Wn].abort.abort(), delete Qe[Wn]);
                                });
                            }
                            removeTile(rt) {
                                return Qe._(this, void 0, void 0, function*() {
                                    this.loaded && this.loaded[rt.uid] && delete this.loaded[rt.uid];
                                });
                            }
                        }
                        class n {
                            constructor(){
                                this.loaded = {};
                            }
                            loadTile(rt) {
                                return Qe._(this, void 0, void 0, function*() {
                                    const { uid: Wn, encoding: Co, rawImageData: Dl, redFactor: Ll, greenFactor: Rl, blueFactor: Ul, baseShift: Gl } = rt, Zl = Dl.width + 2, Hl = Dl.height + 2, ql = Qe.b(Dl) ? new Qe.R({
                                        width: Zl,
                                        height: Hl
                                    }, (yield Qe.cB(Dl, -1, -1, Zl, Hl))) : Dl, Ql = new Qe.cC(Wn, ql, Co, Ll, Rl, Ul, Gl);
                                    return this.loaded = this.loaded || {}, this.loaded[Wn] = Ql, Ql;
                                });
                            }
                            removeTile(Qe) {
                                const rt = this.loaded, Wn = Qe.uid;
                                rt && rt[Wn] && delete rt[Wn];
                            }
                        }
                        var rt, Wn, Co = function() {
                            if (Wn) return rt;
                            function e(Qe, rt) {
                                if (0 !== Qe.length) {
                                    t(Qe[0], rt);
                                    for(var Wn = 1; Wn < Qe.length; Wn++)t(Qe[Wn], !rt);
                                }
                            }
                            function t(Qe, rt) {
                                for(var Wn = 0, Co = 0, Dl = 0, Ll = Qe.length, Rl = Ll - 1; Dl < Ll; Rl = Dl++){
                                    var Ul = (Qe[Dl][0] - Qe[Rl][0]) * (Qe[Rl][1] + Qe[Dl][1]), Gl = Wn + Ul;
                                    Co += Math.abs(Wn) >= Math.abs(Ul) ? Wn - Gl + Ul : Ul - Gl + Wn, Wn = Gl;
                                }
                                Wn + Co >= 0 != !!rt && Qe.reverse();
                            }
                            return Wn = 1, rt = function t(Qe, rt) {
                                var Wn, Co = Qe && Qe.type;
                                if ("FeatureCollection" === Co) for(Wn = 0; Wn < Qe.features.length; Wn++)t(Qe.features[Wn], rt);
                                else if ("GeometryCollection" === Co) for(Wn = 0; Wn < Qe.geometries.length; Wn++)t(Qe.geometries[Wn], rt);
                                else if ("Feature" === Co) t(Qe.geometry, rt);
                                else if ("Polygon" === Co) e(Qe.coordinates, rt);
                                else if ("MultiPolygon" === Co) for(Wn = 0; Wn < Qe.coordinates.length; Wn++)e(Qe.coordinates[Wn], rt);
                                return Qe;
                            };
                        }(), Dl = Qe.cD(Co);
                        const Ll = Qe.cy.VectorTileFeature.prototype.toGeoJSON;
                        class d {
                            constructor(rt){
                                this._feature = rt, this.extent = Qe.Z, this.type = rt.type, this.properties = rt.tags, "id" in rt && !isNaN(rt.id) && (this.id = parseInt(rt.id, 10));
                            }
                            loadGeometry() {
                                if (1 === this._feature.type) {
                                    const rt = [];
                                    for (const Wn of this._feature.geometry)rt.push([
                                        new Qe.P(Wn[0], Wn[1])
                                    ]);
                                    return rt;
                                }
                                {
                                    const rt = [];
                                    for (const Wn of this._feature.geometry){
                                        const Co = [];
                                        for (const rt of Wn)Co.push(new Qe.P(rt[0], rt[1]));
                                        rt.push(Co);
                                    }
                                    return rt;
                                }
                            }
                            toGeoJSON(Qe, rt, Wn) {
                                return Ll.call(this, Qe, rt, Wn);
                            }
                        }
                        class f {
                            constructor(rt){
                                this.layers = {
                                    _geojsonTileLayer: this
                                }, this.name = "_geojsonTileLayer", this.extent = Qe.Z, this.length = rt.length, this._features = rt;
                            }
                            feature(Qe) {
                                return new d(this._features[Qe]);
                            }
                        }
                        var Rl, Ul, Gl, Zl = {
                            exports: {}
                        }, Hl = function() {
                            if (Gl) return Zl.exports;
                            Gl = 1;
                            var rt = Qe.cG(), Wn = function() {
                                if (Ul) return Rl;
                                Ul = 1;
                                var rt = Qe.cE(), Wn = Qe.cF().VectorTileFeature;
                                function i(Qe, rt) {
                                    this.options = rt || {}, this.features = Qe, this.length = Qe.length;
                                }
                                function r(Qe, rt) {
                                    this.id = "number" == typeof Qe.id ? Qe.id : void 0, this.type = Qe.type, this.rawGeometry = 1 === Qe.type ? [
                                        Qe.geometry
                                    ] : Qe.geometry, this.properties = Qe.tags, this.extent = rt || 4096;
                                }
                                return Rl = i, i.prototype.feature = function(Qe) {
                                    return new r(this.features[Qe], this.options.extent);
                                }, r.prototype.loadGeometry = function() {
                                    var Qe = this.rawGeometry;
                                    this.geometry = [];
                                    for(var Wn = 0; Wn < Qe.length; Wn++){
                                        for(var Co = Qe[Wn], Dl = [], Ll = 0; Ll < Co.length; Ll++)Dl.push(new rt(Co[Ll][0], Co[Ll][1]));
                                        this.geometry.push(Dl);
                                    }
                                    return this.geometry;
                                }, r.prototype.bbox = function() {
                                    this.geometry || this.loadGeometry();
                                    for(var Qe = this.geometry, rt = 1 / 0, Wn = -1 / 0, Co = 1 / 0, Dl = -1 / 0, Ll = 0; Ll < Qe.length; Ll++)for(var Rl = Qe[Ll], Ul = 0; Ul < Rl.length; Ul++){
                                        var Gl = Rl[Ul];
                                        rt = Math.min(rt, Gl.x), Wn = Math.max(Wn, Gl.x), Co = Math.min(Co, Gl.y), Dl = Math.max(Dl, Gl.y);
                                    }
                                    return [
                                        rt,
                                        Co,
                                        Wn,
                                        Dl
                                    ];
                                }, r.prototype.toGeoJSON = Wn.prototype.toGeoJSON, Rl;
                            }();
                            function i(Qe) {
                                var Wn = new rt;
                                return function(Qe, rt) {
                                    for(var Wn in Qe.layers)rt.writeMessage(3, r, Qe.layers[Wn]);
                                }(Qe, Wn), Wn.finish();
                            }
                            function r(Qe, rt) {
                                var Wn;
                                rt.writeVarintField(15, Qe.version || 1), rt.writeStringField(1, Qe.name || ""), rt.writeVarintField(5, Qe.extent || 4096);
                                var Co = {
                                    keys: [],
                                    values: [],
                                    keycache: {},
                                    valuecache: {}
                                };
                                for(Wn = 0; Wn < Qe.length; Wn++)Co.feature = Qe.feature(Wn), rt.writeMessage(2, s, Co);
                                var Dl = Co.keys;
                                for(Wn = 0; Wn < Dl.length; Wn++)rt.writeStringField(3, Dl[Wn]);
                                var Ll = Co.values;
                                for(Wn = 0; Wn < Ll.length; Wn++)rt.writeMessage(4, u, Ll[Wn]);
                            }
                            function s(Qe, rt) {
                                var Wn = Qe.feature;
                                void 0 !== Wn.id && rt.writeVarintField(1, Wn.id), rt.writeMessage(2, n, Qe), rt.writeVarintField(3, Wn.type), rt.writeMessage(4, c, Wn);
                            }
                            function n(Qe, rt) {
                                var Wn = Qe.feature, Co = Qe.keys, Dl = Qe.values, Ll = Qe.keycache, Rl = Qe.valuecache;
                                for(var Ul in Wn.properties){
                                    var Gl = Wn.properties[Ul], Zl = Ll[Ul];
                                    if (null !== Gl) {
                                        void 0 === Zl && (Co.push(Ul), Ll[Ul] = Zl = Co.length - 1), rt.writeVarint(Zl);
                                        var Hl = typeof Gl;
                                        "string" !== Hl && "boolean" !== Hl && "number" !== Hl && (Gl = JSON.stringify(Gl));
                                        var ql = Hl + ":" + Gl, Ql = Rl[ql];
                                        void 0 === Ql && (Dl.push(Gl), Rl[ql] = Ql = Dl.length - 1), rt.writeVarint(Ql);
                                    }
                                }
                            }
                            function a(Qe, rt) {
                                return (rt << 3) + (7 & Qe);
                            }
                            function l(Qe) {
                                return Qe << 1 ^ Qe >> 31;
                            }
                            function c(Qe, rt) {
                                for(var Wn = Qe.loadGeometry(), Co = Qe.type, Dl = 0, Ll = 0, Rl = Wn.length, Ul = 0; Ul < Rl; Ul++){
                                    var Gl = Wn[Ul], Zl = 1;
                                    1 === Co && (Zl = Gl.length), rt.writeVarint(a(1, Zl));
                                    for(var Hl = 3 === Co ? Gl.length - 1 : Gl.length, ql = 0; ql < Hl; ql++){
                                        1 === ql && 1 !== Co && rt.writeVarint(a(2, Hl - 1));
                                        var Ql = Gl[ql].x - Dl, Kl = Gl[ql].y - Ll;
                                        rt.writeVarint(l(Ql)), rt.writeVarint(l(Kl)), Dl += Ql, Ll += Kl;
                                    }
                                    3 === Co && rt.writeVarint(a(7, 1));
                                }
                            }
                            function u(Qe, rt) {
                                var Wn = typeof Qe;
                                "string" === Wn ? rt.writeStringField(1, Qe) : "boolean" === Wn ? rt.writeBooleanField(7, Qe) : "number" === Wn && (Qe % 1 != 0 ? rt.writeDoubleField(3, Qe) : Qe < 0 ? rt.writeSVarintField(6, Qe) : rt.writeVarintField(5, Qe));
                            }
                            return Zl.exports = i, Zl.exports.fromVectorTileJs = i, Zl.exports.fromGeojsonVt = function(Qe, rt) {
                                rt = rt || {};
                                var Co = {};
                                for(var Dl in Qe)Co[Dl] = new Wn(Qe[Dl].features, rt), Co[Dl].name = Dl, Co[Dl].version = rt.version, Co[Dl].extent = rt.extent;
                                return i({
                                    layers: Co
                                });
                            }, Zl.exports.GeoJSONWrapper = Wn, Zl.exports;
                        }(), ql = Qe.cD(Hl);
                        const Ql = {
                            minZoom: 0,
                            maxZoom: 16,
                            minPoints: 2,
                            radius: 40,
                            extent: 512,
                            nodeSize: 64,
                            log: !1,
                            generateId: !1,
                            reduce: null,
                            map: (Qe)=>Qe
                        }, Kl = Math.fround || ($l = new Float32Array(1), (Qe)=>($l[0] = +Qe, $l[0]));
                        var $l;
                        const Tc = 3, tu = 5, lu = 6;
                        class P {
                            constructor(Qe){
                                this.options = Object.assign(Object.create(Ql), Qe), this.trees = new Array(this.options.maxZoom + 1), this.stride = this.options.reduce ? 7 : 6, this.clusterProps = [];
                            }
                            load(Qe) {
                                const { log: rt, minZoom: Wn, maxZoom: Co } = this.options;
                                rt && console.time("total time");
                                const Dl = `prepare ${Qe.length} points`;
                                rt && console.time(Dl), this.points = Qe;
                                const Ll = [];
                                for(let Ul = 0; Ul < Qe.length; Ul++){
                                    const rt = Qe[Ul];
                                    if (!rt.geometry) continue;
                                    const [Wn, Co] = rt.geometry.coordinates, Dl = Kl(D(Wn)), Rl = Kl(C(Co));
                                    Ll.push(Dl, Rl, 1 / 0, Ul, -1, 1), this.options.reduce && Ll.push(0);
                                }
                                let Rl = this.trees[Co + 1] = this._createTree(Ll);
                                rt && console.timeEnd(Dl);
                                for(let Ul = Co; Ul >= Wn; Ul--){
                                    const Qe = +Date.now();
                                    Rl = this.trees[Ul] = this._createTree(this._cluster(Rl, Ul)), rt && console.log("z%d: %d clusters in %dms", Ul, Rl.numItems, +Date.now() - Qe);
                                }
                                return rt && console.timeEnd("total time"), this;
                            }
                            getClusters(Qe, rt) {
                                let Wn = ((Qe[0] + 180) % 360 + 360) % 360 - 180;
                                const Co = Math.max(-90, Math.min(90, Qe[1]));
                                let Dl = 180 === Qe[2] ? 180 : ((Qe[2] + 180) % 360 + 360) % 360 - 180;
                                const Ll = Math.max(-90, Math.min(90, Qe[3]));
                                if (Qe[2] - Qe[0] >= 360) Wn = -180, Dl = 180;
                                else if (Wn > Dl) {
                                    const Qe = this.getClusters([
                                        Wn,
                                        Co,
                                        180,
                                        Ll
                                    ], rt), Rl = this.getClusters([
                                        -180,
                                        Co,
                                        Dl,
                                        Ll
                                    ], rt);
                                    return Qe.concat(Rl);
                                }
                                const Rl = this.trees[this._limitZoom(rt)], Ul = Rl.range(D(Wn), C(Ll), D(Dl), C(Co)), Gl = Rl.data, Zl = [];
                                for (const Hl of Ul){
                                    const Qe = this.stride * Hl;
                                    Zl.push(Gl[Qe + tu] > 1 ? k(Gl, Qe, this.clusterProps) : this.points[Gl[Qe + Tc]]);
                                }
                                return Zl;
                            }
                            getChildren(Qe) {
                                const rt = this._getOriginId(Qe), Wn = this._getOriginZoom(Qe), Co = "No cluster with the specified id.", Dl = this.trees[Wn];
                                if (!Dl) throw new Error(Co);
                                const Ll = Dl.data;
                                if (rt * this.stride >= Ll.length) throw new Error(Co);
                                const Rl = this.options.radius / (this.options.extent * Math.pow(2, Wn - 1)), Ul = Dl.within(Ll[rt * this.stride], Ll[rt * this.stride + 1], Rl), Gl = [];
                                for (const Zl of Ul){
                                    const rt = Zl * this.stride;
                                    Ll[rt + 4] === Qe && Gl.push(Ll[rt + tu] > 1 ? k(Ll, rt, this.clusterProps) : this.points[Ll[rt + Tc]]);
                                }
                                if (0 === Gl.length) throw new Error(Co);
                                return Gl;
                            }
                            getLeaves(Qe, rt, Wn) {
                                const Co = [];
                                return this._appendLeaves(Co, Qe, rt = rt || 10, Wn = Wn || 0, 0), Co;
                            }
                            getTile(Qe, rt, Wn) {
                                const Co = this.trees[this._limitZoom(Qe)], Dl = Math.pow(2, Qe), { extent: Ll, radius: Rl } = this.options, Ul = Rl / Ll, Gl = (Wn - Ul) / Dl, Zl = (Wn + 1 + Ul) / Dl, Hl = {
                                    features: []
                                };
                                return this._addTileFeatures(Co.range((rt - Ul) / Dl, Gl, (rt + 1 + Ul) / Dl, Zl), Co.data, rt, Wn, Dl, Hl), 0 === rt && this._addTileFeatures(Co.range(1 - Ul / Dl, Gl, 1, Zl), Co.data, Dl, Wn, Dl, Hl), rt === Dl - 1 && this._addTileFeatures(Co.range(0, Gl, Ul / Dl, Zl), Co.data, -1, Wn, Dl, Hl), Hl.features.length ? Hl : null;
                            }
                            getClusterExpansionZoom(Qe) {
                                let rt = this._getOriginZoom(Qe) - 1;
                                for(; rt <= this.options.maxZoom;){
                                    const Wn = this.getChildren(Qe);
                                    if (rt++, 1 !== Wn.length) break;
                                    Qe = Wn[0].properties.cluster_id;
                                }
                                return rt;
                            }
                            _appendLeaves(Qe, rt, Wn, Co, Dl) {
                                const Ll = this.getChildren(rt);
                                for (const Rl of Ll){
                                    const rt = Rl.properties;
                                    if (rt && rt.cluster ? Dl + rt.point_count <= Co ? Dl += rt.point_count : Dl = this._appendLeaves(Qe, rt.cluster_id, Wn, Co, Dl) : Dl < Co ? Dl++ : Qe.push(Rl), Qe.length === Wn) break;
                                }
                                return Dl;
                            }
                            _createTree(rt) {
                                const Wn = new Qe.aC(rt.length / this.stride | 0, this.options.nodeSize, Float32Array);
                                for(let Qe = 0; Qe < rt.length; Qe += this.stride)Wn.add(rt[Qe], rt[Qe + 1]);
                                return Wn.finish(), Wn.data = rt, Wn;
                            }
                            _addTileFeatures(Qe, rt, Wn, Co, Dl, Ll) {
                                for (const Rl of Qe){
                                    const Qe = Rl * this.stride, Ul = rt[Qe + tu] > 1;
                                    let Gl, Zl, Hl;
                                    if (Ul) Gl = T(rt, Qe, this.clusterProps), Zl = rt[Qe], Hl = rt[Qe + 1];
                                    else {
                                        const Wn = this.points[rt[Qe + Tc]];
                                        Gl = Wn.properties;
                                        const [Co, Dl] = Wn.geometry.coordinates;
                                        Zl = D(Co), Hl = C(Dl);
                                    }
                                    const ql = {
                                        type: 1,
                                        geometry: [
                                            [
                                                Math.round(this.options.extent * (Zl * Dl - Wn)),
                                                Math.round(this.options.extent * (Hl * Dl - Co))
                                            ]
                                        ],
                                        tags: Gl
                                    };
                                    let Ql;
                                    Ql = Ul || this.options.generateId ? rt[Qe + Tc] : this.points[rt[Qe + Tc]].id, void 0 !== Ql && (ql.id = Ql), Ll.features.push(ql);
                                }
                            }
                            _limitZoom(Qe) {
                                return Math.max(this.options.minZoom, Math.min(Math.floor(+Qe), this.options.maxZoom + 1));
                            }
                            _cluster(Qe, rt) {
                                const { radius: Wn, extent: Co, reduce: Dl, minPoints: Ll } = this.options, Rl = Wn / (Co * Math.pow(2, rt)), Ul = Qe.data, Gl = [], Zl = this.stride;
                                for(let Hl = 0; Hl < Ul.length; Hl += Zl){
                                    if (Ul[Hl + 2] <= rt) continue;
                                    Ul[Hl + 2] = rt;
                                    const Wn = Ul[Hl], Co = Ul[Hl + 1], ql = Qe.within(Ul[Hl], Ul[Hl + 1], Rl), Ql = Ul[Hl + tu];
                                    let Kl = Ql;
                                    for (const Qe of ql){
                                        const Wn = Qe * Zl;
                                        Ul[Wn + 2] > rt && (Kl += Ul[Wn + tu]);
                                    }
                                    if (Kl > Ql && Kl >= Ll) {
                                        let Qe, Ll = Wn * Ql, Rl = Co * Ql, $l = -1;
                                        const Tc = (Hl / Zl << 5) + (rt + 1) + this.points.length;
                                        for (const Wn of ql){
                                            const Co = Wn * Zl;
                                            if (Ul[Co + 2] <= rt) continue;
                                            Ul[Co + 2] = rt;
                                            const Gl = Ul[Co + tu];
                                            Ll += Ul[Co] * Gl, Rl += Ul[Co + 1] * Gl, Ul[Co + 4] = Tc, Dl && (Qe || (Qe = this._map(Ul, Hl, !0), $l = this.clusterProps.length, this.clusterProps.push(Qe)), Dl(Qe, this._map(Ul, Co)));
                                        }
                                        Ul[Hl + 4] = Tc, Gl.push(Ll / Kl, Rl / Kl, 1 / 0, Tc, -1, Kl), Dl && Gl.push($l);
                                    } else {
                                        for(let Qe = 0; Qe < Zl; Qe++)Gl.push(Ul[Hl + Qe]);
                                        if (Kl > 1) for (const Qe of ql){
                                            const Wn = Qe * Zl;
                                            if (!(Ul[Wn + 2] <= rt)) {
                                                Ul[Wn + 2] = rt;
                                                for(let Qe = 0; Qe < Zl; Qe++)Gl.push(Ul[Wn + Qe]);
                                            }
                                        }
                                    }
                                }
                                return Gl;
                            }
                            _getOriginId(Qe) {
                                return Qe - this.points.length >> 5;
                            }
                            _getOriginZoom(Qe) {
                                return (Qe - this.points.length) % 32;
                            }
                            _map(Qe, rt, Wn) {
                                if (Qe[rt + tu] > 1) {
                                    const Co = this.clusterProps[Qe[rt + lu]];
                                    return Wn ? Object.assign({}, Co) : Co;
                                }
                                const Co = this.points[Qe[rt + Tc]].properties, Dl = this.options.map(Co);
                                return Wn && Dl === Co ? Object.assign({}, Dl) : Dl;
                            }
                        }
                        function k(Qe, rt, Wn) {
                            var Co;
                            return {
                                type: "Feature",
                                id: Qe[rt + Tc],
                                properties: T(Qe, rt, Wn),
                                geometry: {
                                    type: "Point",
                                    coordinates: [
                                        (Co = Qe[rt], 360 * (Co - .5)),
                                        O(Qe[rt + 1])
                                    ]
                                }
                            };
                        }
                        function T(Qe, rt, Wn) {
                            const Co = Qe[rt + tu], Dl = Co >= 1e4 ? `${Math.round(Co / 1e3)}k` : Co >= 1e3 ? Math.round(Co / 100) / 10 + "k" : Co, Ll = Qe[rt + lu], Rl = -1 === Ll ? {} : Object.assign({}, Wn[Ll]);
                            return Object.assign(Rl, {
                                cluster: !0,
                                cluster_id: Qe[rt + Tc],
                                point_count: Co,
                                point_count_abbreviated: Dl
                            });
                        }
                        function D(Qe) {
                            return Qe / 360 + .5;
                        }
                        function C(Qe) {
                            const rt = Math.sin(Qe * Math.PI / 180), Wn = .5 - .25 * Math.log((1 + rt) / (1 - rt)) / Math.PI;
                            return Wn < 0 ? 0 : Wn > 1 ? 1 : Wn;
                        }
                        function O(Qe) {
                            const rt = (180 - 360 * Qe) * Math.PI / 180;
                            return 360 * Math.atan(Math.exp(rt)) / Math.PI - 90;
                        }
                        function L1(Qe, rt, Wn, Co) {
                            let Dl = Co;
                            const Ll = rt + (Wn - rt >> 1);
                            let Rl, Ul = Wn - rt;
                            const Gl = Qe[rt], Zl = Qe[rt + 1], Hl = Qe[Wn], ql = Qe[Wn + 1];
                            for(let Ql = rt + 3; Ql < Wn; Ql += 3){
                                const rt = F(Qe[Ql], Qe[Ql + 1], Gl, Zl, Hl, ql);
                                if (rt > Dl) Rl = Ql, Dl = rt;
                                else if (rt === Dl) {
                                    const Qe = Math.abs(Ql - Ll);
                                    Qe < Ul && (Rl = Ql, Ul = Qe);
                                }
                            }
                            Dl > Co && (Rl - rt > 3 && L1(Qe, rt, Rl, Co), Qe[Rl + 2] = Dl, Wn - Rl > 3 && L1(Qe, Rl, Wn, Co));
                        }
                        function F(Qe, rt, Wn, Co, Dl, Ll) {
                            let Rl = Dl - Wn, Ul = Ll - Co;
                            if (0 !== Rl || 0 !== Ul) {
                                const Gl = ((Qe - Wn) * Rl + (rt - Co) * Ul) / (Rl * Rl + Ul * Ul);
                                Gl > 1 ? (Wn = Dl, Co = Ll) : Gl > 0 && (Wn += Rl * Gl, Co += Ul * Gl);
                            }
                            return Rl = Qe - Wn, Ul = rt - Co, Rl * Rl + Ul * Ul;
                        }
                        function G(Qe, rt, Wn, Co) {
                            const Dl = {
                                id: null == Qe ? null : Qe,
                                type: rt,
                                geometry: Wn,
                                tags: Co,
                                minX: 1 / 0,
                                minY: 1 / 0,
                                maxX: -1 / 0,
                                maxY: -1 / 0
                            };
                            if ("Point" === rt || "MultiPoint" === rt || "LineString" === rt) z(Dl, Wn);
                            else if ("Polygon" === rt) z(Dl, Wn[0]);
                            else if ("MultiLineString" === rt) for (const Ll of Wn)z(Dl, Ll);
                            else if ("MultiPolygon" === rt) for (const Ll of Wn)z(Dl, Ll[0]);
                            return Dl;
                        }
                        function z(Qe, rt) {
                            for(let Wn = 0; Wn < rt.length; Wn += 3)Qe.minX = Math.min(Qe.minX, rt[Wn]), Qe.minY = Math.min(Qe.minY, rt[Wn + 1]), Qe.maxX = Math.max(Qe.maxX, rt[Wn]), Qe.maxY = Math.max(Qe.maxY, rt[Wn + 1]);
                        }
                        function A(Qe, rt, Wn, Co) {
                            if (!rt.geometry) return;
                            const Dl = rt.geometry.coordinates;
                            if (Dl && 0 === Dl.length) return;
                            const Ll = rt.geometry.type, Rl = Math.pow(Wn.tolerance / ((1 << Wn.maxZoom) * Wn.extent), 2);
                            let Ul = [], Gl = rt.id;
                            if (Wn.promoteId ? Gl = rt.properties[Wn.promoteId] : Wn.generateId && (Gl = Co || 0), "Point" === Ll) j(Dl, Ul);
                            else if ("MultiPoint" === Ll) for (const Zl of Dl)j(Zl, Ul);
                            else if ("LineString" === Ll) E(Dl, Ul, Rl, !1);
                            else if ("MultiLineString" === Ll) {
                                if (Wn.lineMetrics) {
                                    for (const Wn of Dl)Ul = [], E(Wn, Ul, Rl, !1), Qe.push(G(Gl, "LineString", Ul, rt.properties));
                                    return;
                                }
                                Z(Dl, Ul, Rl, !1);
                            } else if ("Polygon" === Ll) Z(Dl, Ul, Rl, !0);
                            else {
                                if ("MultiPolygon" !== Ll) {
                                    if ("GeometryCollection" === Ll) {
                                        for (const Dl of rt.geometry.geometries)A(Qe, {
                                            id: Gl,
                                            geometry: Dl,
                                            properties: rt.properties
                                        }, Wn, Co);
                                        return;
                                    }
                                    throw new Error("Input data is not a valid GeoJSON object.");
                                }
                                for (const Qe of Dl){
                                    const rt = [];
                                    Z(Qe, rt, Rl, !0), Ul.push(rt);
                                }
                            }
                            Qe.push(G(Gl, Ll, Ul, rt.properties));
                        }
                        function j(Qe, rt) {
                            rt.push(N(Qe[0]), J(Qe[1]), 0);
                        }
                        function E(Qe, rt, Wn, Co) {
                            let Dl, Ll, Rl = 0;
                            for(let Gl = 0; Gl < Qe.length; Gl++){
                                const Wn = N(Qe[Gl][0]), Ul = J(Qe[Gl][1]);
                                rt.push(Wn, Ul, 0), Gl > 0 && (Rl += Co ? (Dl * Ul - Wn * Ll) / 2 : Math.sqrt(Math.pow(Wn - Dl, 2) + Math.pow(Ul - Ll, 2))), Dl = Wn, Ll = Ul;
                            }
                            const Ul = rt.length - 3;
                            rt[2] = 1, L1(rt, 0, Ul, Wn), rt[Ul + 2] = 1, rt.size = Math.abs(Rl), rt.start = 0, rt.end = rt.size;
                        }
                        function Z(Qe, rt, Wn, Co) {
                            for(let Dl = 0; Dl < Qe.length; Dl++){
                                const Ll = [];
                                E(Qe[Dl], Ll, Wn, Co), rt.push(Ll);
                            }
                        }
                        function N(Qe) {
                            return Qe / 360 + .5;
                        }
                        function J(Qe) {
                            const rt = Math.sin(Qe * Math.PI / 180), Wn = .5 - .25 * Math.log((1 + rt) / (1 - rt)) / Math.PI;
                            return Wn < 0 ? 0 : Wn > 1 ? 1 : Wn;
                        }
                        function W(Qe, rt, Wn, Co, Dl, Ll, Rl, Ul) {
                            if (Co /= rt, Ll >= (Wn /= rt) && Rl < Co) return Qe;
                            if (Rl < Wn || Ll >= Co) return null;
                            const Gl = [];
                            for (const Zl of Qe){
                                const Qe = Zl.geometry;
                                let rt = Zl.type;
                                const Ll = 0 === Dl ? Zl.minX : Zl.minY, Rl = 0 === Dl ? Zl.maxX : Zl.maxY;
                                if (Ll >= Wn && Rl < Co) {
                                    Gl.push(Zl);
                                    continue;
                                }
                                if (Rl < Wn || Ll >= Co) continue;
                                let Hl = [];
                                if ("Point" === rt || "MultiPoint" === rt) R(Qe, Hl, Wn, Co, Dl);
                                else if ("LineString" === rt) Y(Qe, Hl, Wn, Co, Dl, !1, Ul.lineMetrics);
                                else if ("MultiLineString" === rt) H(Qe, Hl, Wn, Co, Dl, !1);
                                else if ("Polygon" === rt) H(Qe, Hl, Wn, Co, Dl, !0);
                                else if ("MultiPolygon" === rt) for (const Ul of Qe){
                                    const Qe = [];
                                    H(Ul, Qe, Wn, Co, Dl, !0), Qe.length && Hl.push(Qe);
                                }
                                if (Hl.length) {
                                    if (Ul.lineMetrics && "LineString" === rt) {
                                        for (const Qe of Hl)Gl.push(G(Zl.id, rt, Qe, Zl.tags));
                                        continue;
                                    }
                                    "LineString" !== rt && "MultiLineString" !== rt || (1 === Hl.length ? (rt = "LineString", Hl = Hl[0]) : rt = "MultiLineString"), "Point" !== rt && "MultiPoint" !== rt || (rt = 3 === Hl.length ? "Point" : "MultiPoint"), Gl.push(G(Zl.id, rt, Hl, Zl.tags));
                                }
                            }
                            return Gl.length ? Gl : null;
                        }
                        function R(Qe, rt, Wn, Co, Dl) {
                            for(let Ll = 0; Ll < Qe.length; Ll += 3){
                                const Rl = Qe[Ll + Dl];
                                Rl >= Wn && Rl <= Co && V(rt, Qe[Ll], Qe[Ll + 1], Qe[Ll + 2]);
                            }
                        }
                        function Y(Qe, rt, Wn, Co, Dl, Ll, Rl) {
                            let Ul = q(Qe);
                            const Gl = 0 === Dl ? X : B;
                            let Zl, Hl, ql = Qe.start;
                            for(let tu = 0; tu < Qe.length - 3; tu += 3){
                                const Ql = Qe[tu], Kl = Qe[tu + 1], $l = Qe[tu + 2], Tc = Qe[tu + 3], lu = Qe[tu + 4], du = 0 === Dl ? Ql : Kl, fu = 0 === Dl ? Tc : lu;
                                let yu = !1;
                                Rl && (Zl = Math.sqrt(Math.pow(Ql - Tc, 2) + Math.pow(Kl - lu, 2))), du < Wn ? fu > Wn && (Hl = Gl(Ul, Ql, Kl, Tc, lu, Wn), Rl && (Ul.start = ql + Zl * Hl)) : du > Co ? fu < Co && (Hl = Gl(Ul, Ql, Kl, Tc, lu, Co), Rl && (Ul.start = ql + Zl * Hl)) : V(Ul, Ql, Kl, $l), fu < Wn && du >= Wn && (Hl = Gl(Ul, Ql, Kl, Tc, lu, Wn), yu = !0), fu > Co && du <= Co && (Hl = Gl(Ul, Ql, Kl, Tc, lu, Co), yu = !0), !Ll && yu && (Rl && (Ul.end = ql + Zl * Hl), rt.push(Ul), Ul = q(Qe)), Rl && (ql += Zl);
                            }
                            let Ql = Qe.length - 3;
                            const Kl = Qe[Ql], $l = Qe[Ql + 1], Tc = 0 === Dl ? Kl : $l;
                            Tc >= Wn && Tc <= Co && V(Ul, Kl, $l, Qe[Ql + 2]), Ql = Ul.length - 3, Ll && Ql >= 3 && (Ul[Ql] !== Ul[0] || Ul[Ql + 1] !== Ul[1]) && V(Ul, Ul[0], Ul[1], Ul[2]), Ul.length && rt.push(Ul);
                        }
                        function q(Qe) {
                            const rt = [];
                            return rt.size = Qe.size, rt.start = Qe.start, rt.end = Qe.end, rt;
                        }
                        function H(Qe, rt, Wn, Co, Dl, Ll) {
                            for (const Rl of Qe)Y(Rl, rt, Wn, Co, Dl, Ll, !1);
                        }
                        function V(Qe, rt, Wn, Co) {
                            Qe.push(rt, Wn, Co);
                        }
                        function X(Qe, rt, Wn, Co, Dl, Ll) {
                            const Rl = (Ll - rt) / (Co - rt);
                            return V(Qe, Ll, Wn + (Dl - Wn) * Rl, 1), Rl;
                        }
                        function B(Qe, rt, Wn, Co, Dl, Ll) {
                            const Rl = (Ll - Wn) / (Dl - Wn);
                            return V(Qe, rt + (Co - rt) * Rl, Ll, 1), Rl;
                        }
                        function $(Qe, rt) {
                            const Wn = [];
                            for(let Co = 0; Co < Qe.length; Co++){
                                const Dl = Qe[Co], Ll = Dl.type;
                                let Rl;
                                if ("Point" === Ll || "MultiPoint" === Ll || "LineString" === Ll) Rl = U(Dl.geometry, rt);
                                else if ("MultiLineString" === Ll || "Polygon" === Ll) {
                                    Rl = [];
                                    for (const Qe of Dl.geometry)Rl.push(U(Qe, rt));
                                } else if ("MultiPolygon" === Ll) {
                                    Rl = [];
                                    for (const Qe of Dl.geometry){
                                        const Wn = [];
                                        for (const Co of Qe)Wn.push(U(Co, rt));
                                        Rl.push(Wn);
                                    }
                                }
                                Wn.push(G(Dl.id, Ll, Rl, Dl.tags));
                            }
                            return Wn;
                        }
                        function U(Qe, rt) {
                            const Wn = [];
                            Wn.size = Qe.size, void 0 !== Qe.start && (Wn.start = Qe.start, Wn.end = Qe.end);
                            for(let Co = 0; Co < Qe.length; Co += 3)Wn.push(Qe[Co] + rt, Qe[Co + 1], Qe[Co + 2]);
                            return Wn;
                        }
                        function K(Qe, rt) {
                            if (Qe.transformed) return Qe;
                            const Wn = 1 << Qe.z, Co = Qe.x, Dl = Qe.y;
                            for (const Ll of Qe.features){
                                const Qe = Ll.geometry, Rl = Ll.type;
                                if (Ll.geometry = [], 1 === Rl) for(let Ul = 0; Ul < Qe.length; Ul += 2)Ll.geometry.push(Q(Qe[Ul], Qe[Ul + 1], rt, Wn, Co, Dl));
                                else for(let Ul = 0; Ul < Qe.length; Ul++){
                                    const Rl = [];
                                    for(let Ll = 0; Ll < Qe[Ul].length; Ll += 2)Rl.push(Q(Qe[Ul][Ll], Qe[Ul][Ll + 1], rt, Wn, Co, Dl));
                                    Ll.geometry.push(Rl);
                                }
                            }
                            return Qe.transformed = !0, Qe;
                        }
                        function Q(Qe, rt, Wn, Co, Dl, Ll) {
                            return [
                                Math.round(Wn * (Qe * Co - Dl)),
                                Math.round(Wn * (rt * Co - Ll))
                            ];
                        }
                        function ee(Qe, rt, Wn, Co, Dl) {
                            const Ll = rt === Dl.maxZoom ? 0 : Dl.tolerance / ((1 << rt) * Dl.extent), Rl = {
                                features: [],
                                numPoints: 0,
                                numSimplified: 0,
                                numFeatures: Qe.length,
                                source: null,
                                x: Wn,
                                y: Co,
                                z: rt,
                                transformed: !1,
                                minX: 2,
                                minY: 1,
                                maxX: -1,
                                maxY: 0
                            };
                            for (const Ul of Qe)te(Rl, Ul, Ll, Dl);
                            return Rl;
                        }
                        function te(Qe, rt, Wn, Co) {
                            const Dl = rt.geometry, Ll = rt.type, Rl = [];
                            if (Qe.minX = Math.min(Qe.minX, rt.minX), Qe.minY = Math.min(Qe.minY, rt.minY), Qe.maxX = Math.max(Qe.maxX, rt.maxX), Qe.maxY = Math.max(Qe.maxY, rt.maxY), "Point" === Ll || "MultiPoint" === Ll) for(let Ul = 0; Ul < Dl.length; Ul += 3)Rl.push(Dl[Ul], Dl[Ul + 1]), Qe.numPoints++, Qe.numSimplified++;
                            else if ("LineString" === Ll) oe(Rl, Dl, Qe, Wn, !1, !1);
                            else if ("MultiLineString" === Ll || "Polygon" === Ll) for(let Ul = 0; Ul < Dl.length; Ul++)oe(Rl, Dl[Ul], Qe, Wn, "Polygon" === Ll, 0 === Ul);
                            else if ("MultiPolygon" === Ll) for(let Ul = 0; Ul < Dl.length; Ul++){
                                const rt = Dl[Ul];
                                for(let Co = 0; Co < rt.length; Co++)oe(Rl, rt[Co], Qe, Wn, !0, 0 === Co);
                            }
                            if (Rl.length) {
                                let Wn = rt.tags || null;
                                if ("LineString" === Ll && Co.lineMetrics) {
                                    Wn = {};
                                    for(const Qe in rt.tags)Wn[Qe] = rt.tags[Qe];
                                    Wn.mapbox_clip_start = Dl.start / Dl.size, Wn.mapbox_clip_end = Dl.end / Dl.size;
                                }
                                const Ul = {
                                    geometry: Rl,
                                    type: "Polygon" === Ll || "MultiPolygon" === Ll ? 3 : "LineString" === Ll || "MultiLineString" === Ll ? 2 : 1,
                                    tags: Wn
                                };
                                null !== rt.id && (Ul.id = rt.id), Qe.features.push(Ul);
                            }
                        }
                        function oe(Qe, rt, Wn, Co, Dl, Ll) {
                            const Rl = Co * Co;
                            if (Co > 0 && rt.size < (Dl ? Rl : Co)) return void (Wn.numPoints += rt.length / 3);
                            const Ul = [];
                            for(let Gl = 0; Gl < rt.length; Gl += 3)(0 === Co || rt[Gl + 2] > Rl) && (Wn.numSimplified++, Ul.push(rt[Gl], rt[Gl + 1])), Wn.numPoints++;
                            Dl && function(Qe, rt) {
                                let Wn = 0;
                                for(let Co = 0, Dl = Qe.length, Ll = Dl - 2; Co < Dl; Ll = Co, Co += 2)Wn += (Qe[Co] - Qe[Ll]) * (Qe[Co + 1] + Qe[Ll + 1]);
                                if (Wn > 0 === rt) for(let Co = 0, Dl = Qe.length; Co < Dl / 2; Co += 2){
                                    const rt = Qe[Co], Wn = Qe[Co + 1];
                                    Qe[Co] = Qe[Dl - 2 - Co], Qe[Co + 1] = Qe[Dl - 1 - Co], Qe[Dl - 2 - Co] = rt, Qe[Dl - 1 - Co] = Wn;
                                }
                            }(Ul, Ll), Qe.push(Ul);
                        }
                        const du = {
                            maxZoom: 14,
                            indexMaxZoom: 5,
                            indexMaxPoints: 1e5,
                            tolerance: 3,
                            extent: 4096,
                            buffer: 64,
                            lineMetrics: !1,
                            promoteId: null,
                            generateId: !1,
                            debug: 0
                        };
                        class re {
                            constructor(Qe, rt){
                                const Wn = (rt = this.options = function(Qe, rt) {
                                    for(const Wn in rt)Qe[Wn] = rt[Wn];
                                    return Qe;
                                }(Object.create(du), rt)).debug;
                                if (Wn && console.time("preprocess data"), rt.maxZoom < 0 || rt.maxZoom > 24) throw new Error("maxZoom should be in the 0-24 range");
                                if (rt.promoteId && rt.generateId) throw new Error("promoteId and generateId cannot be used together.");
                                let Co = function(Qe, rt) {
                                    const Wn = [];
                                    if ("FeatureCollection" === Qe.type) for(let Co = 0; Co < Qe.features.length; Co++)A(Wn, Qe.features[Co], rt, Co);
                                    else A(Wn, "Feature" === Qe.type ? Qe : {
                                        geometry: Qe
                                    }, rt);
                                    return Wn;
                                }(Qe, rt);
                                this.tiles = {}, this.tileCoords = [], Wn && (console.timeEnd("preprocess data"), console.log("index: maxZoom: %d, maxPoints: %d", rt.indexMaxZoom, rt.indexMaxPoints), console.time("generate tiles"), this.stats = {}, this.total = 0), Co = function(Qe, rt) {
                                    const Wn = rt.buffer / rt.extent;
                                    let Co = Qe;
                                    const Dl = W(Qe, 1, -1 - Wn, Wn, 0, -1, 2, rt), Ll = W(Qe, 1, 1 - Wn, 2 + Wn, 0, -1, 2, rt);
                                    return (Dl || Ll) && (Co = W(Qe, 1, -Wn, 1 + Wn, 0, -1, 2, rt) || [], Dl && (Co = $(Dl, 1).concat(Co)), Ll && (Co = Co.concat($(Ll, -1)))), Co;
                                }(Co, rt), Co.length && this.splitTile(Co, 0, 0, 0), Wn && (Co.length && console.log("features: %d, points: %d", this.tiles[0].numFeatures, this.tiles[0].numPoints), console.timeEnd("generate tiles"), console.log("tiles generated:", this.total, JSON.stringify(this.stats)));
                            }
                            splitTile(Qe, rt, Wn, Co, Dl, Ll, Rl) {
                                const Ul = [
                                    Qe,
                                    rt,
                                    Wn,
                                    Co
                                ], Gl = this.options, Zl = Gl.debug;
                                for(; Ul.length;){
                                    Co = Ul.pop(), Wn = Ul.pop(), rt = Ul.pop(), Qe = Ul.pop();
                                    const Hl = 1 << rt, ql = se(rt, Wn, Co);
                                    let Ql = this.tiles[ql];
                                    if (!Ql && (Zl > 1 && console.time("creation"), Ql = this.tiles[ql] = ee(Qe, rt, Wn, Co, Gl), this.tileCoords.push({
                                        z: rt,
                                        x: Wn,
                                        y: Co
                                    }), Zl)) {
                                        Zl > 1 && (console.log("tile z%d-%d-%d (features: %d, points: %d, simplified: %d)", rt, Wn, Co, Ql.numFeatures, Ql.numPoints, Ql.numSimplified), console.timeEnd("creation"));
                                        const Qe = `z${rt}`;
                                        this.stats[Qe] = (this.stats[Qe] || 0) + 1, this.total++;
                                    }
                                    if (Ql.source = Qe, null == Dl) {
                                        if (rt === Gl.indexMaxZoom || Ql.numPoints <= Gl.indexMaxPoints) continue;
                                    } else {
                                        if (rt === Gl.maxZoom || rt === Dl) continue;
                                        if (null != Dl) {
                                            const Qe = Dl - rt;
                                            if (Wn !== Ll >> Qe || Co !== Rl >> Qe) continue;
                                        }
                                    }
                                    if (Ql.source = null, 0 === Qe.length) continue;
                                    Zl > 1 && console.time("clipping");
                                    const Kl = .5 * Gl.buffer / Gl.extent, $l = .5 - Kl, Tc = .5 + Kl, tu = 1 + Kl;
                                    let lu = null, du = null, fu = null, yu = null, Eu = W(Qe, Hl, Wn - Kl, Wn + Tc, 0, Ql.minX, Ql.maxX, Gl), Tu = W(Qe, Hl, Wn + $l, Wn + tu, 0, Ql.minX, Ql.maxX, Gl);
                                    Qe = null, Eu && (lu = W(Eu, Hl, Co - Kl, Co + Tc, 1, Ql.minY, Ql.maxY, Gl), du = W(Eu, Hl, Co + $l, Co + tu, 1, Ql.minY, Ql.maxY, Gl), Eu = null), Tu && (fu = W(Tu, Hl, Co - Kl, Co + Tc, 1, Ql.minY, Ql.maxY, Gl), yu = W(Tu, Hl, Co + $l, Co + tu, 1, Ql.minY, Ql.maxY, Gl), Tu = null), Zl > 1 && console.timeEnd("clipping"), Ul.push(lu || [], rt + 1, 2 * Wn, 2 * Co), Ul.push(du || [], rt + 1, 2 * Wn, 2 * Co + 1), Ul.push(fu || [], rt + 1, 2 * Wn + 1, 2 * Co), Ul.push(yu || [], rt + 1, 2 * Wn + 1, 2 * Co + 1);
                                }
                            }
                            getTile(Qe, rt, Wn) {
                                Qe = +Qe, rt = +rt, Wn = +Wn;
                                const Co = this.options, { extent: Dl, debug: Ll } = Co;
                                if (Qe < 0 || Qe > 24) return null;
                                const Rl = 1 << Qe, Ul = se(Qe, rt = rt + Rl & Rl - 1, Wn);
                                if (this.tiles[Ul]) return K(this.tiles[Ul], Dl);
                                Ll > 1 && console.log("drilling down to z%d-%d-%d", Qe, rt, Wn);
                                let Gl, Zl = Qe, Hl = rt, ql = Wn;
                                for(; !Gl && Zl > 0;)Zl--, Hl >>= 1, ql >>= 1, Gl = this.tiles[se(Zl, Hl, ql)];
                                return Gl && Gl.source ? (Ll > 1 && (console.log("found parent tile z%d-%d-%d", Zl, Hl, ql), console.time("drilling down")), this.splitTile(Gl.source, Zl, Hl, ql, Qe, rt, Wn), Ll > 1 && console.timeEnd("drilling down"), this.tiles[Ul] ? K(this.tiles[Ul], Dl) : null) : null;
                            }
                        }
                        function se(Qe, rt, Wn) {
                            return 32 * ((1 << Qe) * Wn + rt) + Qe;
                        }
                        function ne(Qe, rt) {
                            return rt ? Qe.properties[rt] : Qe.id;
                        }
                        function ae(Qe, rt) {
                            if (null == Qe) return !0;
                            if ("Feature" === Qe.type) return null != ne(Qe, rt);
                            if ("FeatureCollection" === Qe.type) {
                                const Wn = new Set;
                                for (const Co of Qe.features){
                                    const Qe = ne(Co, rt);
                                    if (null == Qe) return !1;
                                    if (Wn.has(Qe)) return !1;
                                    Wn.add(Qe);
                                }
                                return !0;
                            }
                            return !1;
                        }
                        function le(Qe, rt) {
                            const Wn = new Map;
                            if (null == Qe) ;
                            else if ("Feature" === Qe.type) Wn.set(ne(Qe, rt), Qe);
                            else for (const Co of Qe.features)Wn.set(ne(Co, rt), Co);
                            return Wn;
                        }
                        class ce extends s {
                            constructor(){
                                super(...arguments), this._dataUpdateable = new Map;
                            }
                            loadVectorTile(rt, Wn) {
                                return Qe._(this, void 0, void 0, function*() {
                                    const Qe = rt.tileID.canonical;
                                    if (!this._geoJSONIndex) throw new Error("Unable to parse the data into a cluster or geojson");
                                    const Wn = this._geoJSONIndex.getTile(Qe.z, Qe.x, Qe.y);
                                    if (!Wn) return null;
                                    const Co = new f(Wn.features);
                                    let Dl = ql(Co);
                                    return 0 === Dl.byteOffset && Dl.byteLength === Dl.buffer.byteLength || (Dl = new Uint8Array(Dl)), {
                                        vectorTile: Co,
                                        rawData: Dl.buffer
                                    };
                                });
                            }
                            loadData(rt) {
                                return Qe._(this, void 0, void 0, function*() {
                                    var Wn;
                                    null === (Wn = this._pendingRequest) || void 0 === Wn || Wn.abort();
                                    const Co = !!(rt && rt.request && rt.request.collectResourceTiming) && new Qe.cA(rt.request);
                                    this._pendingRequest = new AbortController;
                                    try {
                                        this._pendingData = this.loadAndProcessGeoJSON(rt, this._pendingRequest), this._geoJSONIndex = rt.cluster ? new P(function({ superclusterOptions: rt, clusterProperties: Wn }) {
                                            if (!Wn || !rt) return rt;
                                            const Co = {}, Dl = {}, Ll = {
                                                accumulated: null,
                                                zoom: 0
                                            }, Rl = {
                                                properties: null
                                            }, Ul = Object.keys(Wn);
                                            for (const Gl of Ul){
                                                const [rt, Ll] = Wn[Gl], Rl = Qe.cH(Ll), Ul = Qe.cH("string" == typeof rt ? [
                                                    rt,
                                                    [
                                                        "accumulated"
                                                    ],
                                                    [
                                                        "get",
                                                        Gl
                                                    ]
                                                ] : rt);
                                                Co[Gl] = Rl.value, Dl[Gl] = Ul.value;
                                            }
                                            return rt.map = (Qe)=>{
                                                Rl.properties = Qe;
                                                const rt = {};
                                                for (const Wn of Ul)rt[Wn] = Co[Wn].evaluate(Ll, Rl);
                                                return rt;
                                            }, rt.reduce = (Qe, rt)=>{
                                                Rl.properties = rt;
                                                for (const Wn of Ul)Ll.accumulated = Qe[Wn], Qe[Wn] = Dl[Wn].evaluate(Ll, Rl);
                                            }, rt;
                                        }(rt)).load((yield this._pendingData).features) : (Dl = yield this._pendingData, new re(Dl, rt.geojsonVtOptions)), this.loaded = {};
                                        const Wn = {};
                                        if (Co) {
                                            const Qe = Co.finish();
                                            Qe && (Wn.resourceTiming = {}, Wn.resourceTiming[rt.source] = JSON.parse(JSON.stringify(Qe)));
                                        }
                                        return Wn;
                                    } catch (rt) {
                                        if (delete this._pendingRequest, Qe.cl(rt)) return {
                                            abandoned: !0
                                        };
                                        throw rt;
                                    }
                                    var Dl;
                                });
                            }
                            getData() {
                                return Qe._(this, void 0, void 0, function*() {
                                    return this._pendingData;
                                });
                            }
                            reloadTile(Qe) {
                                const rt = this.loaded;
                                return rt && rt[Qe.uid] ? super.reloadTile(Qe) : this.loadTile(Qe);
                            }
                            loadAndProcessGeoJSON(rt, Wn) {
                                return Qe._(this, void 0, void 0, function*() {
                                    let Co = yield this.loadGeoJSON(rt, Wn);
                                    if (delete this._pendingRequest, "object" != typeof Co) throw new Error(`Input data given to '${rt.source}' is not a valid GeoJSON object.`);
                                    if (Dl(Co, !0), rt.filter) {
                                        const Wn = Qe.cH(rt.filter, {
                                            type: "boolean",
                                            "property-type": "data-driven",
                                            overridable: !1,
                                            transition: !1
                                        });
                                        if ("error" === Wn.result) throw new Error(Wn.value.map((Qe)=>`${Qe.key}: ${Qe.message}`).join(", "));
                                        const Dl = Co.features.filter((Qe)=>Wn.value.evaluate({
                                                zoom: 0
                                            }, Qe));
                                        Co = {
                                            type: "FeatureCollection",
                                            features: Dl
                                        };
                                    }
                                    return Co;
                                });
                            }
                            loadGeoJSON(rt, Wn) {
                                return Qe._(this, void 0, void 0, function*() {
                                    const { promoteId: Co } = rt;
                                    if (rt.request) {
                                        const Dl = yield Qe.j(rt.request, Wn);
                                        return this._dataUpdateable = ae(Dl.data, Co) ? le(Dl.data, Co) : void 0, Dl.data;
                                    }
                                    if ("string" == typeof rt.data) try {
                                        const Qe = JSON.parse(rt.data);
                                        return this._dataUpdateable = ae(Qe, Co) ? le(Qe, Co) : void 0, Qe;
                                    } catch (Qe) {
                                        throw new Error(`Input data given to '${rt.source}' is not a valid GeoJSON object.`);
                                    }
                                    if (!rt.dataDiff) throw new Error(`Input data given to '${rt.source}' is not a valid GeoJSON object.`);
                                    if (!this._dataUpdateable) throw new Error(`Cannot update existing geojson data in ${rt.source}`);
                                    return function(Qe, rt, Wn) {
                                        var Co, Dl, Ll, Rl;
                                        if (rt.removeAll && Qe.clear(), rt.remove) for (const Ul of rt.remove)Qe.delete(Ul);
                                        if (rt.add) for (const Ul of rt.add){
                                            const rt = ne(Ul, Wn);
                                            null != rt && Qe.set(rt, Ul);
                                        }
                                        if (rt.update) for (const Ul of rt.update){
                                            let rt = Qe.get(Ul.id);
                                            if (null == rt) continue;
                                            const Wn = !Ul.removeAllProperties && ((null === (Co = Ul.removeProperties) || void 0 === Co ? void 0 : Co.length) > 0 || (null === (Dl = Ul.addOrUpdateProperties) || void 0 === Dl ? void 0 : Dl.length) > 0);
                                            if ((Ul.newGeometry || Ul.removeAllProperties || Wn) && (rt = Object.assign({}, rt), Qe.set(Ul.id, rt), Wn && (rt.properties = Object.assign({}, rt.properties))), Ul.newGeometry && (rt.geometry = Ul.newGeometry), Ul.removeAllProperties) rt.properties = {};
                                            else if ((null === (Ll = Ul.removeProperties) || void 0 === Ll ? void 0 : Ll.length) > 0) for (const Qe of Ul.removeProperties)Object.prototype.hasOwnProperty.call(rt.properties, Qe) && delete rt.properties[Qe];
                                            if ((null === (Rl = Ul.addOrUpdateProperties) || void 0 === Rl ? void 0 : Rl.length) > 0) for (const { key: Qe, value: Co } of Ul.addOrUpdateProperties)rt.properties[Qe] = Co;
                                        }
                                    }(this._dataUpdateable, rt.dataDiff, Co), {
                                        type: "FeatureCollection",
                                        features: Array.from(this._dataUpdateable.values())
                                    };
                                });
                            }
                            removeSource(rt) {
                                return Qe._(this, void 0, void 0, function*() {
                                    this._pendingRequest && this._pendingRequest.abort();
                                });
                            }
                            getClusterExpansionZoom(Qe) {
                                return this._geoJSONIndex.getClusterExpansionZoom(Qe.clusterId);
                            }
                            getClusterChildren(Qe) {
                                return this._geoJSONIndex.getChildren(Qe.clusterId);
                            }
                            getClusterLeaves(Qe) {
                                return this._geoJSONIndex.getLeaves(Qe.clusterId, Qe.limit, Qe.offset);
                            }
                        }
                        class ue {
                            constructor(rt){
                                this.self = rt, this.actor = new Qe.H(rt), this.layerIndexes = {}, this.availableImages = {}, this.workerSources = {}, this.demWorkerSources = {}, this.externalWorkerSourceTypes = {}, this.self.registerWorkerSource = (Qe, rt)=>{
                                    if (this.externalWorkerSourceTypes[Qe]) throw new Error(`Worker source with name "${Qe}" already registered.`);
                                    this.externalWorkerSourceTypes[Qe] = rt;
                                }, this.self.addProtocol = Qe.cn, this.self.removeProtocol = Qe.co, this.self.registerRTLTextPlugin = (rt)=>{
                                    Qe.cI.setMethods(rt);
                                }, this.actor.registerMessageHandler("LDT", (Qe, rt)=>this._getDEMWorkerSource(Qe, rt.source).loadTile(rt)), this.actor.registerMessageHandler("RDT", (rt, Wn)=>Qe._(this, void 0, void 0, function*() {
                                        this._getDEMWorkerSource(rt, Wn.source).removeTile(Wn);
                                    })), this.actor.registerMessageHandler("GCEZ", (rt, Wn)=>Qe._(this, void 0, void 0, function*() {
                                        return this._getWorkerSource(rt, Wn.type, Wn.source).getClusterExpansionZoom(Wn);
                                    })), this.actor.registerMessageHandler("GCC", (rt, Wn)=>Qe._(this, void 0, void 0, function*() {
                                        return this._getWorkerSource(rt, Wn.type, Wn.source).getClusterChildren(Wn);
                                    })), this.actor.registerMessageHandler("GCL", (rt, Wn)=>Qe._(this, void 0, void 0, function*() {
                                        return this._getWorkerSource(rt, Wn.type, Wn.source).getClusterLeaves(Wn);
                                    })), this.actor.registerMessageHandler("LD", (Qe, rt)=>this._getWorkerSource(Qe, rt.type, rt.source).loadData(rt)), this.actor.registerMessageHandler("GD", (Qe, rt)=>this._getWorkerSource(Qe, rt.type, rt.source).getData()), this.actor.registerMessageHandler("LT", (Qe, rt)=>this._getWorkerSource(Qe, rt.type, rt.source).loadTile(rt)), this.actor.registerMessageHandler("RT", (Qe, rt)=>this._getWorkerSource(Qe, rt.type, rt.source).reloadTile(rt)), this.actor.registerMessageHandler("AT", (Qe, rt)=>this._getWorkerSource(Qe, rt.type, rt.source).abortTile(rt)), this.actor.registerMessageHandler("RMT", (Qe, rt)=>this._getWorkerSource(Qe, rt.type, rt.source).removeTile(rt)), this.actor.registerMessageHandler("RS", (rt, Wn)=>Qe._(this, void 0, void 0, function*() {
                                        if (!this.workerSources[rt] || !this.workerSources[rt][Wn.type] || !this.workerSources[rt][Wn.type][Wn.source]) return;
                                        const Qe = this.workerSources[rt][Wn.type][Wn.source];
                                        delete this.workerSources[rt][Wn.type][Wn.source], void 0 !== Qe.removeSource && Qe.removeSource(Wn);
                                    })), this.actor.registerMessageHandler("RM", (rt)=>Qe._(this, void 0, void 0, function*() {
                                        delete this.layerIndexes[rt], delete this.availableImages[rt], delete this.workerSources[rt], delete this.demWorkerSources[rt];
                                    })), this.actor.registerMessageHandler("SR", (rt, Wn)=>Qe._(this, void 0, void 0, function*() {
                                        this.referrer = Wn;
                                    })), this.actor.registerMessageHandler("SRPS", (Qe, rt)=>this._syncRTLPluginState(Qe, rt)), this.actor.registerMessageHandler("IS", (rt, Wn)=>Qe._(this, void 0, void 0, function*() {
                                        this.self.importScripts(Wn);
                                    })), this.actor.registerMessageHandler("SI", (Qe, rt)=>this._setImages(Qe, rt)), this.actor.registerMessageHandler("UL", (rt, Wn)=>Qe._(this, void 0, void 0, function*() {
                                        this._getLayerIndex(rt).update(Wn.layers, Wn.removedIds);
                                    })), this.actor.registerMessageHandler("SL", (rt, Wn)=>Qe._(this, void 0, void 0, function*() {
                                        this._getLayerIndex(rt).replace(Wn);
                                    }));
                            }
                            _setImages(rt, Wn) {
                                return Qe._(this, void 0, void 0, function*() {
                                    this.availableImages[rt] = Wn;
                                    for(const Qe in this.workerSources[rt]){
                                        const Co = this.workerSources[rt][Qe];
                                        for(const Qe in Co)Co[Qe].availableImages = Wn;
                                    }
                                });
                            }
                            _syncRTLPluginState(rt, Wn) {
                                return Qe._(this, void 0, void 0, function*() {
                                    return yield Qe.cI.syncState(Wn, this.self.importScripts);
                                });
                            }
                            _getAvailableImages(Qe) {
                                let rt = this.availableImages[Qe];
                                return rt || (rt = []), rt;
                            }
                            _getLayerIndex(Qe) {
                                let rt = this.layerIndexes[Qe];
                                return rt || (rt = this.layerIndexes[Qe] = new t), rt;
                            }
                            _getWorkerSource(Qe, rt, Wn) {
                                if (this.workerSources[Qe] || (this.workerSources[Qe] = {}), this.workerSources[Qe][rt] || (this.workerSources[Qe][rt] = {}), !this.workerSources[Qe][rt][Wn]) {
                                    const Co = {
                                        sendAsync: (rt, Wn)=>(rt.targetMapId = Qe, this.actor.sendAsync(rt, Wn))
                                    };
                                    switch(rt){
                                        case "vector":
                                            this.workerSources[Qe][rt][Wn] = new s(Co, this._getLayerIndex(Qe), this._getAvailableImages(Qe));
                                            break;
                                        case "geojson":
                                            this.workerSources[Qe][rt][Wn] = new ce(Co, this._getLayerIndex(Qe), this._getAvailableImages(Qe));
                                            break;
                                        default:
                                            this.workerSources[Qe][rt][Wn] = new this.externalWorkerSourceTypes[rt](Co, this._getLayerIndex(Qe), this._getAvailableImages(Qe));
                                    }
                                }
                                return this.workerSources[Qe][rt][Wn];
                            }
                            _getDEMWorkerSource(Qe, rt) {
                                return this.demWorkerSources[Qe] || (this.demWorkerSources[Qe] = {}), this.demWorkerSources[Qe][rt] || (this.demWorkerSources[Qe][rt] = new n), this.demWorkerSources[Qe][rt];
                            }
                        }
                        return Qe.i(self) && (self.worker = new ue(self)), ue;
                    }), define("index", [
                        "exports",
                        "./shared"
                    ], function(Qe, rt) {
                        var Wn = "5.3.0";
                        function r() {
                            var Qe = new rt.A(4);
                            return rt.A != Float32Array && (Qe[1] = 0, Qe[2] = 0), Qe[0] = 1, Qe[3] = 1, Qe;
                        }
                        let Co, Dl;
                        const Ll = {
                            now: "undefined" != typeof performance && performance && performance.now ? performance.now.bind(performance) : Date.now.bind(Date),
                            frame (Qe, Wn, Co) {
                                const Dl = requestAnimationFrame((Qe)=>{
                                    Ll(), Wn(Qe);
                                }), { unsubscribe: Ll } = rt.s(Qe.signal, "abort", ()=>{
                                    Ll(), cancelAnimationFrame(Dl), Co(rt.c());
                                }, !1);
                            },
                            frameAsync (Qe) {
                                return new Promise((rt, Wn)=>{
                                    this.frame(Qe, rt, Wn);
                                });
                            },
                            getImageData (Qe, rt = 0) {
                                return this.getImageCanvasContext(Qe).getImageData(-rt, -rt, Qe.width + 2 * rt, Qe.height + 2 * rt);
                            },
                            getImageCanvasContext (Qe) {
                                const rt = window.document.createElement("canvas"), Wn = rt.getContext("2d", {
                                    willReadFrequently: !0
                                });
                                if (!Wn) throw new Error("failed to create canvas 2d context");
                                return rt.width = Qe.width, rt.height = Qe.height, Wn.drawImage(Qe, 0, 0, Qe.width, Qe.height), Wn;
                            },
                            resolveURL: (Qe)=>(Co || (Co = document.createElement("a")), Co.href = Qe, Co.href),
                            hardwareConcurrency: "undefined" != typeof navigator && navigator.hardwareConcurrency || 4,
                            get prefersReducedMotion () {
                                return !!matchMedia && (null == Dl && (Dl = matchMedia("(prefers-reduced-motion: reduce)")), Dl.matches);
                            }
                        };
                        class n {
                            static testProp(Qe) {
                                if (!n.docStyle) return Qe[0];
                                for(let rt = 0; rt < Qe.length; rt++)if (Qe[rt] in n.docStyle) return Qe[rt];
                                return Qe[0];
                            }
                            static create(Qe, rt, Wn) {
                                const Co = window.document.createElement(Qe);
                                return void 0 !== rt && (Co.className = rt), Wn && Wn.appendChild(Co), Co;
                            }
                            static createNS(Qe, rt) {
                                return window.document.createElementNS(Qe, rt);
                            }
                            static disableDrag() {
                                n.docStyle && n.selectProp && (n.userSelect = n.docStyle[n.selectProp], n.docStyle[n.selectProp] = "none");
                            }
                            static enableDrag() {
                                n.docStyle && n.selectProp && (n.docStyle[n.selectProp] = n.userSelect);
                            }
                            static setTransform(Qe, rt) {
                                Qe.style[n.transformProp] = rt;
                            }
                            static addEventListener(Qe, rt, Wn, Co = {}) {
                                Qe.addEventListener(rt, Wn, "passive" in Co ? Co : Co.capture);
                            }
                            static removeEventListener(Qe, rt, Wn, Co = {}) {
                                Qe.removeEventListener(rt, Wn, "passive" in Co ? Co : Co.capture);
                            }
                            static suppressClickInternal(Qe) {
                                Qe.preventDefault(), Qe.stopPropagation(), window.removeEventListener("click", n.suppressClickInternal, !0);
                            }
                            static suppressClick() {
                                window.addEventListener("click", n.suppressClickInternal, !0), window.setTimeout(()=>{
                                    window.removeEventListener("click", n.suppressClickInternal, !0);
                                }, 0);
                            }
                            static getScale(Qe) {
                                const rt = Qe.getBoundingClientRect();
                                return {
                                    x: rt.width / Qe.offsetWidth || 1,
                                    y: rt.height / Qe.offsetHeight || 1,
                                    boundingClientRect: rt
                                };
                            }
                            static getPoint(Qe, Wn, Co) {
                                const Dl = Wn.boundingClientRect;
                                return new rt.P((Co.clientX - Dl.left) / Wn.x - Qe.clientLeft, (Co.clientY - Dl.top) / Wn.y - Qe.clientTop);
                            }
                            static mousePos(Qe, rt) {
                                const Wn = n.getScale(Qe);
                                return n.getPoint(Qe, Wn, rt);
                            }
                            static touchPos(Qe, rt) {
                                const Wn = [], Co = n.getScale(Qe);
                                for(let Dl = 0; Dl < rt.length; Dl++)Wn.push(n.getPoint(Qe, Co, rt[Dl]));
                                return Wn;
                            }
                            static mouseButton(Qe) {
                                return Qe.button;
                            }
                            static remove(Qe) {
                                Qe.parentNode && Qe.parentNode.removeChild(Qe);
                            }
                            static sanitize(Qe) {
                                const rt = (new DOMParser).parseFromString(Qe, "text/html").body || document.createElement("body"), Wn = rt.querySelectorAll("script");
                                for (const Co of Wn)Co.remove();
                                return n.clean(rt), rt.innerHTML;
                            }
                            static isPossiblyDangerous(Qe, rt) {
                                const Wn = rt.replace(/\s+/g, "").toLowerCase();
                                return !(![
                                    "src",
                                    "href",
                                    "xlink:href"
                                ].includes(Qe) || !Wn.includes("javascript:") && !Wn.includes("data:")) || !!Qe.startsWith("on") || void 0;
                            }
                            static clean(Qe) {
                                const rt = Qe.children;
                                for (const Wn of rt)n.removeAttributes(Wn), n.clean(Wn);
                            }
                            static removeAttributes(Qe) {
                                for (const { name: rt, value: Wn } of Qe.attributes)n.isPossiblyDangerous(rt, Wn) && Qe.removeAttribute(rt);
                            }
                        }
                        n.docStyle = "undefined" != typeof window && window.document && window.document.documentElement.style, n.selectProp = n.testProp([
                            "userSelect",
                            "MozUserSelect",
                            "WebkitUserSelect",
                            "msUserSelect"
                        ]), n.transformProp = n.testProp([
                            "transform",
                            "WebkitTransform"
                        ]);
                        const Rl = {
                            supported: !1,
                            testSupport: function(Qe) {
                                !Zl && Gl && (Hl ? _(Qe) : Ul = Qe);
                            }
                        };
                        let Ul, Gl, Zl = !1, Hl = !1;
                        function _(Qe) {
                            const rt = Qe.createTexture();
                            Qe.bindTexture(Qe.TEXTURE_2D, rt);
                            try {
                                if (Qe.texImage2D(Qe.TEXTURE_2D, 0, Qe.RGBA, Qe.RGBA, Qe.UNSIGNED_BYTE, Gl), Qe.isContextLost()) return;
                                Rl.supported = !0;
                            } catch (Qe) {}
                            Qe.deleteTexture(rt), Zl = !0;
                        }
                        var ql;
                        "undefined" != typeof document && (Gl = document.createElement("img"), Gl.onload = ()=>{
                            Ul && _(Ul), Ul = null, Hl = !0;
                        }, Gl.onerror = ()=>{
                            Zl = !0, Ul = null;
                        }, Gl.src = "data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAQAAAAfQ//73v/+BiOh/AAA="), function(Qe) {
                            let Wn, Co, Dl, Ll;
                            Qe.resetRequestQueue = ()=>{
                                Wn = [], Co = 0, Dl = 0, Ll = {};
                            }, Qe.addThrottleControl = (Qe)=>{
                                const rt = Dl++;
                                return Ll[rt] = Qe, rt;
                            }, Qe.removeThrottleControl = (Qe)=>{
                                delete Ll[Qe], n();
                            }, Qe.getImage = (Qe, Co, Dl = !0)=>new Promise((Ll, Ul)=>{
                                    Rl.supported && (Qe.headers || (Qe.headers = {}), Qe.headers.accept = "image/webp,*/*"), rt.e(Qe, {
                                        type: "image"
                                    }), Wn.push({
                                        abortController: Co,
                                        requestParameters: Qe,
                                        supportImageRefresh: Dl,
                                        state: "queued",
                                        onError: (Qe)=>{
                                            Ul(Qe);
                                        },
                                        onSuccess: (Qe)=>{
                                            Ll(Qe);
                                        }
                                    }), n();
                                });
                            const s = (Qe)=>rt._(this, void 0, void 0, function*() {
                                    Qe.state = "running";
                                    const { requestParameters: Wn, supportImageRefresh: Dl, onError: Ll, onSuccess: Rl, abortController: Ul } = Qe, Gl = !1 === Dl && !rt.i(self) && !rt.g(Wn.url) && (!Wn.headers || Object.keys(Wn.headers).reduce((Qe, rt)=>Qe && "accept" === rt, !0));
                                    Co++;
                                    const Zl = Gl ? c(Wn, Ul) : rt.m(Wn, Ul);
                                    try {
                                        const Wn = yield Zl;
                                        delete Qe.abortController, Qe.state = "completed", Wn.data instanceof HTMLImageElement || rt.b(Wn.data) ? Rl(Wn) : Wn.data && Rl({
                                            data: yield (Hl = Wn.data, "function" == typeof createImageBitmap ? rt.f(Hl) : rt.h(Hl)),
                                            cacheControl: Wn.cacheControl,
                                            expires: Wn.expires
                                        });
                                    } catch (rt) {
                                        delete Qe.abortController, Ll(rt);
                                    } finally{
                                        Co--, n();
                                    }
                                    var Hl;
                                }), n = ()=>{
                                const Qe = (()=>{
                                    for (const Qe of Object.keys(Ll))if (Ll[Qe]()) return !0;
                                    return !1;
                                })() ? rt.a.MAX_PARALLEL_IMAGE_REQUESTS_PER_FRAME : rt.a.MAX_PARALLEL_IMAGE_REQUESTS;
                                for(let rt = Co; rt < Qe && Wn.length > 0; rt++){
                                    const Qe = Wn.shift();
                                    Qe.abortController.signal.aborted ? rt-- : s(Qe);
                                }
                            }, c = (Qe, Wn)=>new Promise((Co, Dl)=>{
                                    const Ll = new Image, Rl = Qe.url, Ul = Qe.credentials;
                                    Ul && "include" === Ul ? Ll.crossOrigin = "use-credentials" : (Ul && "same-origin" === Ul || !rt.d(Rl)) && (Ll.crossOrigin = "anonymous"), Wn.signal.addEventListener("abort", ()=>{
                                        Ll.src = "", Dl(rt.c());
                                    }), Ll.fetchPriority = "high", Ll.onload = ()=>{
                                        Ll.onerror = Ll.onload = null, Co({
                                            data: Ll
                                        });
                                    }, Ll.onerror = ()=>{
                                        Ll.onerror = Ll.onload = null, Wn.signal.aborted || Dl(new Error("Could not load image. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported."));
                                    }, Ll.src = Rl;
                                });
                        }(ql || (ql = {})), ql.resetRequestQueue();
                        class m {
                            constructor(Qe){
                                this._transformRequestFn = Qe;
                            }
                            transformRequest(Qe, rt) {
                                return this._transformRequestFn && this._transformRequestFn(Qe, rt) || {
                                    url: Qe
                                };
                            }
                            setTransformRequest(Qe) {
                                this._transformRequestFn = Qe;
                            }
                        }
                        function f(Qe) {
                            const rt = [];
                            if ("string" == typeof Qe) rt.push({
                                id: "default",
                                url: Qe
                            });
                            else if (Qe && Qe.length > 0) {
                                const Wn = [];
                                for (const { id: Co, url: Dl } of Qe){
                                    const Qe = `${Co}${Dl}`;
                                    -1 === Wn.indexOf(Qe) && (Wn.push(Qe), rt.push({
                                        id: Co,
                                        url: Dl
                                    }));
                                }
                            }
                            return rt;
                        }
                        function g(Qe, rt, Wn) {
                            try {
                                const Co = new URL(Qe);
                                return Co.pathname += `${rt}${Wn}`, Co.toString();
                            } catch (rt) {
                                throw new Error(`Invalid sprite URL "${Qe}", must be absolute. Modify style specification directly or use TransformStyleFunction to correct the issue dynamically`);
                            }
                        }
                        class v {
                            constructor(Qe, rt, Wn, Co){
                                this.context = Qe, this.format = Wn, this.texture = Qe.gl.createTexture(), this.update(rt, Co);
                            }
                            update(Qe, Wn, Co) {
                                const { width: Dl, height: Ll } = Qe, Rl = !(this.size && this.size[0] === Dl && this.size[1] === Ll || Co), { context: Ul } = this, { gl: Gl } = Ul;
                                if (this.useMipmap = Boolean(Wn && Wn.useMipmap), Gl.bindTexture(Gl.TEXTURE_2D, this.texture), Ul.pixelStoreUnpackFlipY.set(!1), Ul.pixelStoreUnpack.set(1), Ul.pixelStoreUnpackPremultiplyAlpha.set(this.format === Gl.RGBA && (!Wn || !1 !== Wn.premultiply)), Rl) this.size = [
                                    Dl,
                                    Ll
                                ], Qe instanceof HTMLImageElement || Qe instanceof HTMLCanvasElement || Qe instanceof HTMLVideoElement || Qe instanceof ImageData || rt.b(Qe) ? Gl.texImage2D(Gl.TEXTURE_2D, 0, this.format, this.format, Gl.UNSIGNED_BYTE, Qe) : Gl.texImage2D(Gl.TEXTURE_2D, 0, this.format, Dl, Ll, 0, this.format, Gl.UNSIGNED_BYTE, Qe.data);
                                else {
                                    const { x: Wn, y: Rl } = Co || {
                                        x: 0,
                                        y: 0
                                    };
                                    Qe instanceof HTMLImageElement || Qe instanceof HTMLCanvasElement || Qe instanceof HTMLVideoElement || Qe instanceof ImageData || rt.b(Qe) ? Gl.texSubImage2D(Gl.TEXTURE_2D, 0, Wn, Rl, Gl.RGBA, Gl.UNSIGNED_BYTE, Qe) : Gl.texSubImage2D(Gl.TEXTURE_2D, 0, Wn, Rl, Dl, Ll, Gl.RGBA, Gl.UNSIGNED_BYTE, Qe.data);
                                }
                                this.useMipmap && this.isSizePowerOfTwo() && Gl.generateMipmap(Gl.TEXTURE_2D);
                            }
                            bind(Qe, rt, Wn) {
                                const { context: Co } = this, { gl: Dl } = Co;
                                Dl.bindTexture(Dl.TEXTURE_2D, this.texture), Wn !== Dl.LINEAR_MIPMAP_NEAREST || this.isSizePowerOfTwo() || (Wn = Dl.LINEAR), Qe !== this.filter && (Dl.texParameteri(Dl.TEXTURE_2D, Dl.TEXTURE_MAG_FILTER, Qe), Dl.texParameteri(Dl.TEXTURE_2D, Dl.TEXTURE_MIN_FILTER, Wn || Qe), this.filter = Qe), rt !== this.wrap && (Dl.texParameteri(Dl.TEXTURE_2D, Dl.TEXTURE_WRAP_S, rt), Dl.texParameteri(Dl.TEXTURE_2D, Dl.TEXTURE_WRAP_T, rt), this.wrap = rt);
                            }
                            isSizePowerOfTwo() {
                                return this.size[0] === this.size[1] && Math.log(this.size[0]) / Math.LN2 % 1 == 0;
                            }
                            destroy() {
                                const { gl: Qe } = this.context;
                                Qe.deleteTexture(this.texture), this.texture = null;
                            }
                        }
                        function x(Qe) {
                            const { userImage: rt } = Qe;
                            return !!(rt && rt.render && rt.render()) && (Qe.data.replace(new Uint8Array(rt.data.buffer)), !0);
                        }
                        class b extends rt.E {
                            constructor(){
                                super(), this.images = {}, this.updatedImages = {}, this.callbackDispatchedThisFrame = {}, this.loaded = !1, this.requestors = [], this.patterns = {}, this.atlasImage = new rt.R({
                                    width: 1,
                                    height: 1
                                }), this.dirty = !0;
                            }
                            isLoaded() {
                                return this.loaded;
                            }
                            setLoaded(Qe) {
                                if (this.loaded !== Qe && (this.loaded = Qe, Qe)) {
                                    for (const { ids: Qe, promiseResolve: rt } of this.requestors)rt(this._getImagesForIds(Qe));
                                    this.requestors = [];
                                }
                            }
                            getImage(Qe) {
                                const Wn = this.images[Qe];
                                if (Wn && !Wn.data && Wn.spriteData) {
                                    const Qe = Wn.spriteData;
                                    Wn.data = new rt.R({
                                        width: Qe.width,
                                        height: Qe.height
                                    }, Qe.context.getImageData(Qe.x, Qe.y, Qe.width, Qe.height).data), Wn.spriteData = null;
                                }
                                return Wn;
                            }
                            addImage(Qe, rt) {
                                if (this.images[Qe]) throw new Error(`Image id ${Qe} already exist, use updateImage instead`);
                                this._validate(Qe, rt) && (this.images[Qe] = rt);
                            }
                            _validate(Qe, Wn) {
                                let Co = !0;
                                const Dl = Wn.data || Wn.spriteData;
                                return this._validateStretch(Wn.stretchX, Dl && Dl.width) || (this.fire(new rt.k(new Error(`Image "${Qe}" has invalid "stretchX" value`))), Co = !1), this._validateStretch(Wn.stretchY, Dl && Dl.height) || (this.fire(new rt.k(new Error(`Image "${Qe}" has invalid "stretchY" value`))), Co = !1), this._validateContent(Wn.content, Wn) || (this.fire(new rt.k(new Error(`Image "${Qe}" has invalid "content" value`))), Co = !1), Co;
                            }
                            _validateStretch(Qe, rt) {
                                if (!Qe) return !0;
                                let Wn = 0;
                                for (const Co of Qe){
                                    if (Co[0] < Wn || Co[1] < Co[0] || rt < Co[1]) return !1;
                                    Wn = Co[1];
                                }
                                return !0;
                            }
                            _validateContent(Qe, rt) {
                                if (!Qe) return !0;
                                if (4 !== Qe.length) return !1;
                                const Wn = rt.spriteData, Co = Wn && Wn.width || rt.data.width, Dl = Wn && Wn.height || rt.data.height;
                                return !(Qe[0] < 0 || Co < Qe[0] || Qe[1] < 0 || Dl < Qe[1] || Qe[2] < 0 || Co < Qe[2] || Qe[3] < 0 || Dl < Qe[3] || Qe[2] < Qe[0] || Qe[3] < Qe[1]);
                            }
                            updateImage(Qe, rt, Wn = !0) {
                                const Co = this.getImage(Qe);
                                if (Wn && (Co.data.width !== rt.data.width || Co.data.height !== rt.data.height)) throw new Error(`size mismatch between old image (${Co.data.width}x${Co.data.height}) and new image (${rt.data.width}x${rt.data.height}).`);
                                rt.version = Co.version + 1, this.images[Qe] = rt, this.updatedImages[Qe] = !0;
                            }
                            removeImage(Qe) {
                                const rt = this.images[Qe];
                                delete this.images[Qe], delete this.patterns[Qe], rt.userImage && rt.userImage.onRemove && rt.userImage.onRemove();
                            }
                            listImages() {
                                return Object.keys(this.images);
                            }
                            getImages(Qe) {
                                return new Promise((rt, Wn)=>{
                                    let Co = !0;
                                    if (!this.isLoaded()) for (const Dl of Qe)this.images[Dl] || (Co = !1);
                                    this.isLoaded() || Co ? rt(this._getImagesForIds(Qe)) : this.requestors.push({
                                        ids: Qe,
                                        promiseResolve: rt
                                    });
                                });
                            }
                            _getImagesForIds(Qe) {
                                const Wn = {};
                                for (const Co of Qe){
                                    let Qe = this.getImage(Co);
                                    Qe || (this.fire(new rt.l("styleimagemissing", {
                                        id: Co
                                    })), Qe = this.getImage(Co)), Qe ? Wn[Co] = {
                                        data: Qe.data.clone(),
                                        pixelRatio: Qe.pixelRatio,
                                        sdf: Qe.sdf,
                                        version: Qe.version,
                                        stretchX: Qe.stretchX,
                                        stretchY: Qe.stretchY,
                                        content: Qe.content,
                                        textFitWidth: Qe.textFitWidth,
                                        textFitHeight: Qe.textFitHeight,
                                        hasRenderCallback: Boolean(Qe.userImage && Qe.userImage.render)
                                    } : rt.w(`Image "${Co}" could not be loaded. Please make sure you have added the image with map.addImage() or a "sprite" property in your style. You can provide missing images by listening for the "styleimagemissing" map event.`);
                                }
                                return Wn;
                            }
                            getPixelSize() {
                                const { width: Qe, height: rt } = this.atlasImage;
                                return {
                                    width: Qe,
                                    height: rt
                                };
                            }
                            getPattern(Qe) {
                                const Wn = this.patterns[Qe], Co = this.getImage(Qe);
                                if (!Co) return null;
                                if (Wn && Wn.position.version === Co.version) return Wn.position;
                                if (Wn) Wn.position.version = Co.version;
                                else {
                                    const Wn = {
                                        w: Co.data.width + 2,
                                        h: Co.data.height + 2,
                                        x: 0,
                                        y: 0
                                    }, Dl = new rt.I(Wn, Co);
                                    this.patterns[Qe] = {
                                        bin: Wn,
                                        position: Dl
                                    };
                                }
                                return this._updatePatternAtlas(), this.patterns[Qe].position;
                            }
                            bind(Qe) {
                                const rt = Qe.gl;
                                this.atlasTexture ? this.dirty && (this.atlasTexture.update(this.atlasImage), this.dirty = !1) : this.atlasTexture = new v(Qe, this.atlasImage, rt.RGBA), this.atlasTexture.bind(rt.LINEAR, rt.CLAMP_TO_EDGE);
                            }
                            _updatePatternAtlas() {
                                const Qe = [];
                                for(const rt in this.patterns)Qe.push(this.patterns[rt].bin);
                                const { w: Wn, h: Co } = rt.p(Qe), Dl = this.atlasImage;
                                Dl.resize({
                                    width: Wn || 1,
                                    height: Co || 1
                                });
                                for(const Ll in this.patterns){
                                    const { bin: Qe } = this.patterns[Ll], Wn = Qe.x + 1, Co = Qe.y + 1, Rl = this.getImage(Ll).data, Ul = Rl.width, Gl = Rl.height;
                                    rt.R.copy(Rl, Dl, {
                                        x: 0,
                                        y: 0
                                    }, {
                                        x: Wn,
                                        y: Co
                                    }, {
                                        width: Ul,
                                        height: Gl
                                    }), rt.R.copy(Rl, Dl, {
                                        x: 0,
                                        y: Gl - 1
                                    }, {
                                        x: Wn,
                                        y: Co - 1
                                    }, {
                                        width: Ul,
                                        height: 1
                                    }), rt.R.copy(Rl, Dl, {
                                        x: 0,
                                        y: 0
                                    }, {
                                        x: Wn,
                                        y: Co + Gl
                                    }, {
                                        width: Ul,
                                        height: 1
                                    }), rt.R.copy(Rl, Dl, {
                                        x: Ul - 1,
                                        y: 0
                                    }, {
                                        x: Wn - 1,
                                        y: Co
                                    }, {
                                        width: 1,
                                        height: Gl
                                    }), rt.R.copy(Rl, Dl, {
                                        x: 0,
                                        y: 0
                                    }, {
                                        x: Wn + Ul,
                                        y: Co
                                    }, {
                                        width: 1,
                                        height: Gl
                                    });
                                }
                                this.dirty = !0;
                            }
                            beginFrame() {
                                this.callbackDispatchedThisFrame = {};
                            }
                            dispatchRenderCallbacks(Qe) {
                                for (const Wn of Qe){
                                    if (this.callbackDispatchedThisFrame[Wn]) continue;
                                    this.callbackDispatchedThisFrame[Wn] = !0;
                                    const Qe = this.getImage(Wn);
                                    Qe || rt.w(`Image with ID: "${Wn}" was not found`), x(Qe) && this.updateImage(Wn, Qe);
                                }
                            }
                        }
                        const Ql = 1e20;
                        function w(Qe, rt, Wn, Co, Dl, Ll, Rl, Ul, Gl) {
                            for(let Zl = rt; Zl < rt + Co; Zl++)T(Qe, Wn * Ll + Zl, Ll, Dl, Rl, Ul, Gl);
                            for(let Zl = Wn; Zl < Wn + Dl; Zl++)T(Qe, Zl * Ll + rt, 1, Co, Rl, Ul, Gl);
                        }
                        function T(Qe, rt, Wn, Co, Dl, Ll, Rl) {
                            Ll[0] = 0, Rl[0] = -100000000000000000000, Rl[1] = Ql, Dl[0] = Qe[rt];
                            for(let Ul = 1, Gl = 0, Zl = 0; Ul < Co; Ul++){
                                Dl[Ul] = Qe[rt + Ul * Wn];
                                const Co = Ul * Ul;
                                do {
                                    const Qe = Ll[Gl];
                                    Zl = (Dl[Ul] - Dl[Qe] + Co - Qe * Qe) / (Ul - Qe) / 2;
                                }while (Zl <= Rl[Gl] && --Gl > -1);
                                Gl++, Ll[Gl] = Ul, Rl[Gl] = Zl, Rl[Gl + 1] = Ql;
                            }
                            for(let Ul = 0, Gl = 0; Ul < Co; Ul++){
                                for(; Rl[Gl + 1] < Ul;)Gl++;
                                const Co = Ll[Gl], Zl = Ul - Co;
                                Qe[rt + Ul * Wn] = Dl[Co] + Zl * Zl;
                            }
                        }
                        class P {
                            constructor(Qe, rt){
                                this.requestManager = Qe, this.localIdeographFontFamily = rt, this.entries = {};
                            }
                            setURL(Qe) {
                                this.url = Qe;
                            }
                            getGlyphs(Qe) {
                                return rt._(this, void 0, void 0, function*() {
                                    const rt = [];
                                    for(const Dl in Qe)for (const Wn of Qe[Dl])rt.push(this._getAndCacheGlyphsPromise(Dl, Wn));
                                    const Wn = yield Promise.all(rt), Co = {};
                                    for (const { stack: Qe, id: Dl, glyph: Ll } of Wn)Co[Qe] || (Co[Qe] = {}), Co[Qe][Dl] = Ll && {
                                        id: Ll.id,
                                        bitmap: Ll.bitmap.clone(),
                                        metrics: Ll.metrics
                                    };
                                    return Co;
                                });
                            }
                            _getAndCacheGlyphsPromise(Qe, Wn) {
                                return rt._(this, void 0, void 0, function*() {
                                    let rt = this.entries[Qe];
                                    rt || (rt = this.entries[Qe] = {
                                        glyphs: {},
                                        requests: {},
                                        ranges: {}
                                    });
                                    let Co = rt.glyphs[Wn];
                                    if (void 0 !== Co) return {
                                        stack: Qe,
                                        id: Wn,
                                        glyph: Co
                                    };
                                    if (Co = this._tinySDF(rt, Qe, Wn), Co) return rt.glyphs[Wn] = Co, {
                                        stack: Qe,
                                        id: Wn,
                                        glyph: Co
                                    };
                                    const Dl = Math.floor(Wn / 256);
                                    if (256 * Dl > 65535) throw new Error("glyphs > 65535 not supported");
                                    if (rt.ranges[Dl]) return {
                                        stack: Qe,
                                        id: Wn,
                                        glyph: Co
                                    };
                                    if (!this.url) throw new Error("glyphsUrl is not set");
                                    if (!rt.requests[Dl]) {
                                        const Wn = P.loadGlyphRange(Qe, Dl, this.url, this.requestManager);
                                        rt.requests[Dl] = Wn;
                                    }
                                    const Ll = yield rt.requests[Dl];
                                    for(const Qe in Ll)this._doesCharSupportLocalGlyph(+Qe) || (rt.glyphs[+Qe] = Ll[+Qe]);
                                    return rt.ranges[Dl] = !0, {
                                        stack: Qe,
                                        id: Wn,
                                        glyph: Ll[Wn] || null
                                    };
                                });
                            }
                            _doesCharSupportLocalGlyph(Qe) {
                                return !!this.localIdeographFontFamily && (/\p{Ideo}|\p{sc=Hang}|\p{sc=Hira}|\p{sc=Kana}/u.test(String.fromCodePoint(Qe)) || rt.u["CJK Unified Ideographs"](Qe) || rt.u["Hangul Syllables"](Qe) || rt.u.Hiragana(Qe) || rt.u.Katakana(Qe) || rt.u["CJK Symbols and Punctuation"](Qe) || rt.u["Halfwidth and Fullwidth Forms"](Qe));
                            }
                            _tinySDF(Qe, Wn, Co) {
                                const Dl = this.localIdeographFontFamily;
                                if (!Dl) return;
                                if (!this._doesCharSupportLocalGlyph(Co)) return;
                                let Ll = Qe.tinySDF;
                                if (!Ll) {
                                    let rt = "400";
                                    /bold/i.test(Wn) ? rt = "900" : /medium/i.test(Wn) ? rt = "500" : /light/i.test(Wn) && (rt = "200"), Ll = Qe.tinySDF = new P.TinySDF({
                                        fontSize: 48,
                                        buffer: 6,
                                        radius: 16,
                                        cutoff: .25,
                                        fontFamily: Dl,
                                        fontWeight: rt
                                    });
                                }
                                const Rl = Ll.draw(String.fromCharCode(Co));
                                return {
                                    id: Co,
                                    bitmap: new rt.q({
                                        width: Rl.width || 60,
                                        height: Rl.height || 60
                                    }, Rl.data),
                                    metrics: {
                                        width: Rl.glyphWidth / 2 || 24,
                                        height: Rl.glyphHeight / 2 || 24,
                                        left: Rl.glyphLeft / 2 + .5 || 0,
                                        top: Rl.glyphTop / 2 - 27.5 || -8,
                                        advance: Rl.glyphAdvance / 2 || 24,
                                        isDoubleResolution: !0
                                    }
                                };
                            }
                        }
                        P.loadGlyphRange = function(Qe, Wn, Co, Dl) {
                            return rt._(this, void 0, void 0, function*() {
                                const Ll = 256 * Wn, Rl = Ll + 255, Ul = Dl.transformRequest(Co.replace("{fontstack}", Qe).replace("{range}", `${Ll}-${Rl}`), "Glyphs"), Gl = yield rt.n(Ul, new AbortController);
                                if (!Gl || !Gl.data) throw new Error(`Could not load glyph range. range: ${Wn}, ${Ll}-${Rl}`);
                                const Zl = {};
                                for (const Qe of rt.o(Gl.data))Zl[Qe.id] = Qe;
                                return Zl;
                            });
                        }, P.TinySDF = class {
                            constructor({ fontSize: Qe = 24, buffer: rt = 3, radius: Wn = 8, cutoff: Co = .25, fontFamily: Dl = "sans-serif", fontWeight: Ll = "normal", fontStyle: Rl = "normal" } = {}){
                                this.buffer = rt, this.cutoff = Co, this.radius = Wn;
                                const Ul = this.size = Qe + 4 * rt, Gl = this._createCanvas(Ul), Zl = this.ctx = Gl.getContext("2d", {
                                    willReadFrequently: !0
                                });
                                Zl.font = `${Rl} ${Ll} ${Qe}px ${Dl}`, Zl.textBaseline = "alphabetic", Zl.textAlign = "left", Zl.fillStyle = "black", this.gridOuter = new Float64Array(Ul * Ul), this.gridInner = new Float64Array(Ul * Ul), this.f = new Float64Array(Ul), this.z = new Float64Array(Ul + 1), this.v = new Uint16Array(Ul);
                            }
                            _createCanvas(Qe) {
                                const rt = document.createElement("canvas");
                                return rt.width = rt.height = Qe, rt;
                            }
                            draw(Qe) {
                                const { width: rt, actualBoundingBoxAscent: Wn, actualBoundingBoxDescent: Co, actualBoundingBoxLeft: Dl, actualBoundingBoxRight: Ll } = this.ctx.measureText(Qe), Rl = Math.ceil(Wn), Ul = Math.max(0, Math.min(this.size - this.buffer, Math.ceil(Ll - Dl))), Gl = Math.min(this.size - this.buffer, Rl + Math.ceil(Co)), Zl = Ul + 2 * this.buffer, Hl = Gl + 2 * this.buffer, ql = Math.max(Zl * Hl, 0), Kl = new Uint8ClampedArray(ql), $l = {
                                    data: Kl,
                                    width: Zl,
                                    height: Hl,
                                    glyphWidth: Ul,
                                    glyphHeight: Gl,
                                    glyphTop: Rl,
                                    glyphLeft: 0,
                                    glyphAdvance: rt
                                };
                                if (0 === Ul || 0 === Gl) return $l;
                                const { ctx: Tc, buffer: tu, gridInner: lu, gridOuter: du } = this;
                                Tc.clearRect(tu, tu, Ul, Gl), Tc.fillText(Qe, tu, tu + Rl);
                                const fu = Tc.getImageData(tu, tu, Ul, Gl);
                                du.fill(Ql, 0, ql), lu.fill(0, 0, ql);
                                for(let yu = 0; yu < Gl; yu++)for(let Qe = 0; Qe < Ul; Qe++){
                                    const rt = fu.data[4 * (yu * Ul + Qe) + 3] / 255;
                                    if (0 === rt) continue;
                                    const Wn = (yu + tu) * Zl + Qe + tu;
                                    if (1 === rt) du[Wn] = 0, lu[Wn] = Ql;
                                    else {
                                        const Qe = .5 - rt;
                                        du[Wn] = Qe > 0 ? Qe * Qe : 0, lu[Wn] = Qe < 0 ? Qe * Qe : 0;
                                    }
                                }
                                w(du, 0, 0, Zl, Hl, Zl, this.f, this.v, this.z), w(lu, tu, tu, Ul, Gl, Zl, this.f, this.v, this.z);
                                for(let Ql = 0; Ql < ql; Ql++){
                                    const Qe = Math.sqrt(du[Ql]) - Math.sqrt(lu[Ql]);
                                    Kl[Ql] = Math.round(255 - 255 * (Qe / this.radius + this.cutoff));
                                }
                                return $l;
                            }
                        };
                        class C {
                            constructor(){
                                this.specification = rt.v.light.position;
                            }
                            possiblyEvaluate(Qe, Wn) {
                                return rt.z(Qe.expression.evaluate(Wn));
                            }
                            interpolate(Qe, Wn, Co) {
                                return {
                                    x: rt.B.number(Qe.x, Wn.x, Co),
                                    y: rt.B.number(Qe.y, Wn.y, Co),
                                    z: rt.B.number(Qe.z, Wn.z, Co)
                                };
                            }
                        }
                        let Kl;
                        class M extends rt.E {
                            constructor(Qe){
                                super(), Kl = Kl || new rt.r({
                                    anchor: new rt.D(rt.v.light.anchor),
                                    position: new C,
                                    color: new rt.D(rt.v.light.color),
                                    intensity: new rt.D(rt.v.light.intensity)
                                }), this._transitionable = new rt.T(Kl), this.setLight(Qe), this._transitioning = this._transitionable.untransitioned();
                            }
                            getLight() {
                                return this._transitionable.serialize();
                            }
                            setLight(Qe, Wn = {}) {
                                if (!this._validate(rt.t, Qe, Wn)) for(const rt in Qe){
                                    const Wn = Qe[rt];
                                    rt.endsWith("-transition") ? this._transitionable.setTransition(rt.slice(0, -11), Wn) : this._transitionable.setValue(rt, Wn);
                                }
                            }
                            updateTransitions(Qe) {
                                this._transitioning = this._transitionable.transitioned(Qe, this._transitioning);
                            }
                            hasTransition() {
                                return this._transitioning.hasTransition();
                            }
                            recalculate(Qe) {
                                this.properties = this._transitioning.possiblyEvaluate(Qe);
                            }
                            _validate(Qe, Wn, Co) {
                                return (!Co || !1 !== Co.validate) && rt.x(this, Qe.call(rt.y, {
                                    value: Wn,
                                    style: {
                                        glyphs: !0,
                                        sprite: !0
                                    },
                                    styleSpec: rt.v
                                }));
                            }
                        }
                        const $l = new rt.r({
                            "sky-color": new rt.D(rt.v.sky["sky-color"]),
                            "horizon-color": new rt.D(rt.v.sky["horizon-color"]),
                            "fog-color": new rt.D(rt.v.sky["fog-color"]),
                            "fog-ground-blend": new rt.D(rt.v.sky["fog-ground-blend"]),
                            "horizon-fog-blend": new rt.D(rt.v.sky["horizon-fog-blend"]),
                            "sky-horizon-blend": new rt.D(rt.v.sky["sky-horizon-blend"]),
                            "atmosphere-blend": new rt.D(rt.v.sky["atmosphere-blend"])
                        });
                        class S extends rt.E {
                            constructor(Qe){
                                super(), this._transitionable = new rt.T($l), this.setSky(Qe), this._transitioning = this._transitionable.untransitioned(), this.recalculate(new rt.C(0));
                            }
                            setSky(Qe, Wn = {}) {
                                if (!this._validate(rt.F, Qe, Wn)) {
                                    Qe || (Qe = {
                                        "sky-color": "transparent",
                                        "horizon-color": "transparent",
                                        "fog-color": "transparent",
                                        "fog-ground-blend": 1,
                                        "atmosphere-blend": 0
                                    });
                                    for(const rt in Qe){
                                        const Wn = Qe[rt];
                                        rt.endsWith("-transition") ? this._transitionable.setTransition(rt.slice(0, -11), Wn) : this._transitionable.setValue(rt, Wn);
                                    }
                                }
                            }
                            getSky() {
                                return this._transitionable.serialize();
                            }
                            updateTransitions(Qe) {
                                this._transitioning = this._transitionable.transitioned(Qe, this._transitioning);
                            }
                            hasTransition() {
                                return this._transitioning.hasTransition();
                            }
                            recalculate(Qe) {
                                this.properties = this._transitioning.possiblyEvaluate(Qe);
                            }
                            _validate(Qe, Wn, Co = {}) {
                                return !1 !== (null == Co ? void 0 : Co.validate) && rt.x(this, Qe.call(rt.y, rt.e({
                                    value: Wn,
                                    style: {
                                        glyphs: !0,
                                        sprite: !0
                                    },
                                    styleSpec: rt.v
                                })));
                            }
                            calculateFogBlendOpacity(Qe) {
                                return Qe < 60 ? 0 : Qe < 70 ? (Qe - 60) / 10 : 1;
                            }
                        }
                        class R {
                            constructor(Qe, rt){
                                this.width = Qe, this.height = rt, this.nextRow = 0, this.data = new Uint8Array(this.width * this.height), this.dashEntry = {};
                            }
                            getDash(Qe, rt) {
                                const Wn = Qe.join(",") + String(rt);
                                return this.dashEntry[Wn] || (this.dashEntry[Wn] = this.addDash(Qe, rt)), this.dashEntry[Wn];
                            }
                            getDashRanges(Qe, rt, Wn) {
                                const Co = [];
                                let Dl = Qe.length % 2 == 1 ? -Qe[Qe.length - 1] * Wn : 0, Ll = Qe[0] * Wn, Rl = !0;
                                Co.push({
                                    left: Dl,
                                    right: Ll,
                                    isDash: Rl,
                                    zeroLength: 0 === Qe[0]
                                });
                                let Ul = Qe[0];
                                for(let Gl = 1; Gl < Qe.length; Gl++){
                                    Rl = !Rl;
                                    const rt = Qe[Gl];
                                    Dl = Ul * Wn, Ul += rt, Ll = Ul * Wn, Co.push({
                                        left: Dl,
                                        right: Ll,
                                        isDash: Rl,
                                        zeroLength: 0 === rt
                                    });
                                }
                                return Co;
                            }
                            addRoundDash(Qe, rt, Wn) {
                                const Co = rt / 2;
                                for(let Dl = -Wn; Dl <= Wn; Dl++){
                                    const rt = this.width * (this.nextRow + Wn + Dl);
                                    let Ll = 0, Rl = Qe[Ll];
                                    for(let Ul = 0; Ul < this.width; Ul++){
                                        Ul / Rl.right > 1 && (Rl = Qe[++Ll]);
                                        const Gl = Math.abs(Ul - Rl.left), Zl = Math.abs(Ul - Rl.right), Hl = Math.min(Gl, Zl);
                                        let ql;
                                        const Ql = Dl / Wn * (Co + 1);
                                        if (Rl.isDash) {
                                            const Qe = Co - Math.abs(Ql);
                                            ql = Math.sqrt(Hl * Hl + Qe * Qe);
                                        } else ql = Co - Math.sqrt(Hl * Hl + Ql * Ql);
                                        this.data[rt + Ul] = Math.max(0, Math.min(255, ql + 128));
                                    }
                                }
                            }
                            addRegularDash(Qe) {
                                for(let Rl = Qe.length - 1; Rl >= 0; --Rl){
                                    const rt = Qe[Rl], Wn = Qe[Rl + 1];
                                    rt.zeroLength ? Qe.splice(Rl, 1) : Wn && Wn.isDash === rt.isDash && (Wn.left = rt.left, Qe.splice(Rl, 1));
                                }
                                const rt = Qe[0], Wn = Qe[Qe.length - 1];
                                rt.isDash === Wn.isDash && (rt.left = Wn.left - this.width, Wn.right = rt.right + this.width);
                                const Co = this.width * this.nextRow;
                                let Dl = 0, Ll = Qe[Dl];
                                for(let Rl = 0; Rl < this.width; Rl++){
                                    Rl / Ll.right > 1 && (Ll = Qe[++Dl]);
                                    const rt = Math.abs(Rl - Ll.left), Wn = Math.abs(Rl - Ll.right), Ul = Math.min(rt, Wn);
                                    this.data[Co + Rl] = Math.max(0, Math.min(255, (Ll.isDash ? Ul : -Ul) + 128));
                                }
                            }
                            addDash(Qe, Wn) {
                                const Co = Wn ? 7 : 0, Dl = 2 * Co + 1;
                                if (this.nextRow + Dl > this.height) return rt.w("LineAtlas out of space"), null;
                                let Ll = 0;
                                for(let rt = 0; rt < Qe.length; rt++)Ll += Qe[rt];
                                if (0 !== Ll) {
                                    const rt = this.width / Ll, Dl = this.getDashRanges(Qe, this.width, rt);
                                    Wn ? this.addRoundDash(Dl, rt, Co) : this.addRegularDash(Dl);
                                }
                                const Rl = {
                                    y: (this.nextRow + Co + .5) / this.height,
                                    height: 2 * Co / this.height,
                                    width: Ll
                                };
                                return this.nextRow += Dl, this.dirty = !0, Rl;
                            }
                            bind(Qe) {
                                const rt = Qe.gl;
                                this.texture ? (rt.bindTexture(rt.TEXTURE_2D, this.texture), this.dirty && (this.dirty = !1, rt.texSubImage2D(rt.TEXTURE_2D, 0, 0, 0, this.width, this.height, rt.ALPHA, rt.UNSIGNED_BYTE, this.data))) : (this.texture = rt.createTexture(), rt.bindTexture(rt.TEXTURE_2D, this.texture), rt.texParameteri(rt.TEXTURE_2D, rt.TEXTURE_WRAP_S, rt.REPEAT), rt.texParameteri(rt.TEXTURE_2D, rt.TEXTURE_WRAP_T, rt.REPEAT), rt.texParameteri(rt.TEXTURE_2D, rt.TEXTURE_MIN_FILTER, rt.LINEAR), rt.texParameteri(rt.TEXTURE_2D, rt.TEXTURE_MAG_FILTER, rt.LINEAR), rt.texImage2D(rt.TEXTURE_2D, 0, rt.ALPHA, this.width, this.height, 0, rt.ALPHA, rt.UNSIGNED_BYTE, this.data));
                            }
                        }
                        const Tc = "maplibre_preloaded_worker_pool";
                        class z {
                            constructor(){
                                this.active = {};
                            }
                            acquire(Qe) {
                                if (!this.workers) for(this.workers = []; this.workers.length < z.workerCount;)this.workers.push(new Worker(rt.a.WORKER_URL));
                                return this.active[Qe] = !0, this.workers.slice();
                            }
                            release(Qe) {
                                delete this.active[Qe], 0 === this.numActive() && (this.workers.forEach((Qe)=>{
                                    Qe.terminate();
                                }), this.workers = null);
                            }
                            isPreloaded() {
                                return !!this.active[Tc];
                            }
                            numActive() {
                                return Object.keys(this.active).length;
                            }
                        }
                        const tu = Math.floor(Ll.hardwareConcurrency / 2);
                        let lu, du;
                        function F() {
                            return lu || (lu = new z), lu;
                        }
                        z.workerCount = rt.G(globalThis) ? Math.max(Math.min(tu, 3), 1) : 1;
                        class B {
                            constructor(Qe, Wn){
                                this.workerPool = Qe, this.actors = [], this.currentActor = 0, this.id = Wn;
                                const Co = this.workerPool.acquire(Wn);
                                for(let Dl = 0; Dl < Co.length; Dl++){
                                    const Qe = new rt.H(Co[Dl], Wn);
                                    Qe.name = `Worker ${Dl}`, this.actors.push(Qe);
                                }
                                if (!this.actors.length) throw new Error("No actors found");
                            }
                            broadcast(Qe, rt) {
                                const Wn = [];
                                for (const Co of this.actors)Wn.push(Co.sendAsync({
                                    type: Qe,
                                    data: rt
                                }));
                                return Promise.all(Wn);
                            }
                            getActor() {
                                return this.currentActor = (this.currentActor + 1) % this.actors.length, this.actors[this.currentActor];
                            }
                            remove(Qe = !0) {
                                this.actors.forEach((Qe)=>{
                                    Qe.remove();
                                }), this.actors = [], Qe && this.workerPool.release(this.id);
                            }
                            registerMessageHandler(Qe, rt) {
                                for (const Wn of this.actors)Wn.registerMessageHandler(Qe, rt);
                            }
                        }
                        function O() {
                            return du || (du = new B(F(), rt.J), du.registerMessageHandler("GR", (Qe, Wn, Co)=>rt.m(Wn, Co))), du;
                        }
                        function j(Qe, Wn) {
                            const Co = rt.K();
                            return rt.L(Co, Co, [
                                1,
                                1,
                                0
                            ]), rt.M(Co, Co, [
                                .5 * Qe.width,
                                .5 * Qe.height,
                                1
                            ]), Qe.calculatePosMatrix ? rt.N(Co, Co, Qe.calculatePosMatrix(Wn.toUnwrapped())) : Co;
                        }
                        function Z(Qe, rt, Wn, Co, Dl, Ll, Rl) {
                            var Ul;
                            const Gl = function(Qe, rt, Wn) {
                                if (Qe) for (const Co of Qe){
                                    const Qe = rt[Co];
                                    if (Qe && Qe.source === Wn && "fill-extrusion" === Qe.type) return !0;
                                }
                                else for(const Co in rt){
                                    const Qe = rt[Co];
                                    if (Qe.source === Wn && "fill-extrusion" === Qe.type) return !0;
                                }
                                return !1;
                            }(null !== (Ul = null == Dl ? void 0 : Dl.layers) && void 0 !== Ul ? Ul : null, rt, Qe.id), Zl = Ll.maxPitchScaleFactor(), Hl = Qe.tilesIn(Co, Zl, Gl);
                            Hl.sort(N);
                            const ql = [];
                            for (const Ql of Hl)ql.push({
                                wrappedTileID: Ql.tileID.wrapped().key,
                                queryResults: Ql.tile.queryRenderedFeatures(rt, Wn, Qe._state, Ql.queryGeometry, Ql.cameraQueryGeometry, Ql.scale, Dl, Ll, Zl, j(Qe.transform, Ql.tileID), Rl ? (Qe, rt)=>Rl(Ql.tileID, Qe, rt) : void 0)
                            });
                            return function(Qe, rt) {
                                for(const Wn in Qe)for (const Co of Qe[Wn])G(Co, rt);
                                return Qe;
                            }(function(Qe) {
                                const rt = {}, Wn = {};
                                for (const Co of Qe){
                                    const Qe = Co.queryResults, Dl = Co.wrappedTileID, Ll = Wn[Dl] = Wn[Dl] || {};
                                    for(const Wn in Qe){
                                        const Co = Qe[Wn], Dl = Ll[Wn] = Ll[Wn] || {}, Rl = rt[Wn] = rt[Wn] || [];
                                        for (const Qe of Co)Dl[Qe.featureIndex] || (Dl[Qe.featureIndex] = !0, Rl.push(Qe));
                                    }
                                }
                                return rt;
                            }(ql), Qe);
                        }
                        function N(Qe, rt) {
                            const Wn = Qe.tileID, Co = rt.tileID;
                            return Wn.overscaledZ - Co.overscaledZ || Wn.canonical.y - Co.canonical.y || Wn.wrap - Co.wrap || Wn.canonical.x - Co.canonical.x;
                        }
                        function G(Qe, rt) {
                            const Wn = Qe.feature, Co = rt.getFeatureState(Wn.layer["source-layer"], Wn.id);
                            Wn.source = Wn.layer.source, Wn.layer["source-layer"] && (Wn.sourceLayer = Wn.layer["source-layer"]), Wn.state = Co;
                        }
                        function U(Qe, Wn, Co) {
                            return rt._(this, void 0, void 0, function*() {
                                let Dl = Qe;
                                if (Qe.url ? Dl = (yield rt.j(Wn.transformRequest(Qe.url, "Source"), Co)).data : yield Ll.frameAsync(Co), !Dl) return null;
                                const Rl = rt.O(rt.e(Dl, Qe), [
                                    "tiles",
                                    "minzoom",
                                    "maxzoom",
                                    "attribution",
                                    "bounds",
                                    "scheme",
                                    "tileSize",
                                    "encoding"
                                ]);
                                return "vector_layers" in Dl && Dl.vector_layers && (Rl.vectorLayerIds = Dl.vector_layers.map((Qe)=>Qe.id)), Rl;
                            });
                        }
                        class V {
                            constructor(Qe, rt){
                                Qe && (rt ? this.setSouthWest(Qe).setNorthEast(rt) : Array.isArray(Qe) && (4 === Qe.length ? this.setSouthWest([
                                    Qe[0],
                                    Qe[1]
                                ]).setNorthEast([
                                    Qe[2],
                                    Qe[3]
                                ]) : this.setSouthWest(Qe[0]).setNorthEast(Qe[1])));
                            }
                            setNorthEast(Qe) {
                                return this._ne = Qe instanceof rt.Q ? new rt.Q(Qe.lng, Qe.lat) : rt.Q.convert(Qe), this;
                            }
                            setSouthWest(Qe) {
                                return this._sw = Qe instanceof rt.Q ? new rt.Q(Qe.lng, Qe.lat) : rt.Q.convert(Qe), this;
                            }
                            extend(Qe) {
                                const Wn = this._sw, Co = this._ne;
                                let Dl, Ll;
                                if (Qe instanceof rt.Q) Dl = Qe, Ll = Qe;
                                else {
                                    if (!(Qe instanceof V)) return Array.isArray(Qe) ? 4 === Qe.length || Qe.every(Array.isArray) ? this.extend(V.convert(Qe)) : this.extend(rt.Q.convert(Qe)) : Qe && ("lng" in Qe || "lon" in Qe) && "lat" in Qe ? this.extend(rt.Q.convert(Qe)) : this;
                                    if (Dl = Qe._sw, Ll = Qe._ne, !Dl || !Ll) return this;
                                }
                                return Wn || Co ? (Wn.lng = Math.min(Dl.lng, Wn.lng), Wn.lat = Math.min(Dl.lat, Wn.lat), Co.lng = Math.max(Ll.lng, Co.lng), Co.lat = Math.max(Ll.lat, Co.lat)) : (this._sw = new rt.Q(Dl.lng, Dl.lat), this._ne = new rt.Q(Ll.lng, Ll.lat)), this;
                            }
                            getCenter() {
                                return new rt.Q((this._sw.lng + this._ne.lng) / 2, (this._sw.lat + this._ne.lat) / 2);
                            }
                            getSouthWest() {
                                return this._sw;
                            }
                            getNorthEast() {
                                return this._ne;
                            }
                            getNorthWest() {
                                return new rt.Q(this.getWest(), this.getNorth());
                            }
                            getSouthEast() {
                                return new rt.Q(this.getEast(), this.getSouth());
                            }
                            getWest() {
                                return this._sw.lng;
                            }
                            getSouth() {
                                return this._sw.lat;
                            }
                            getEast() {
                                return this._ne.lng;
                            }
                            getNorth() {
                                return this._ne.lat;
                            }
                            toArray() {
                                return [
                                    this._sw.toArray(),
                                    this._ne.toArray()
                                ];
                            }
                            toString() {
                                return `LngLatBounds(${this._sw.toString()}, ${this._ne.toString()})`;
                            }
                            isEmpty() {
                                return !(this._sw && this._ne);
                            }
                            contains(Qe) {
                                const { lng: Wn, lat: Co } = rt.Q.convert(Qe);
                                let Dl = this._sw.lng <= Wn && Wn <= this._ne.lng;
                                return this._sw.lng > this._ne.lng && (Dl = this._sw.lng >= Wn && Wn >= this._ne.lng), this._sw.lat <= Co && Co <= this._ne.lat && Dl;
                            }
                            static convert(Qe) {
                                return Qe instanceof V ? Qe : Qe ? new V(Qe) : Qe;
                            }
                            static fromLngLat(Qe, Wn = 0) {
                                const Co = 360 * Wn / 40075017, Dl = Co / Math.cos(Math.PI / 180 * Qe.lat);
                                return new V(new rt.Q(Qe.lng - Dl, Qe.lat - Co), new rt.Q(Qe.lng + Dl, Qe.lat + Co));
                            }
                            adjustAntiMeridian() {
                                const Qe = new rt.Q(this._sw.lng, this._sw.lat), Wn = new rt.Q(this._ne.lng, this._ne.lat);
                                return new V(Qe, Qe.lng > Wn.lng ? new rt.Q(Wn.lng + 360, Wn.lat) : Wn);
                            }
                        }
                        class q {
                            constructor(Qe, rt, Wn){
                                this.bounds = V.convert(this.validateBounds(Qe)), this.minzoom = rt || 0, this.maxzoom = Wn || 24;
                            }
                            validateBounds(Qe) {
                                return Array.isArray(Qe) && 4 === Qe.length ? [
                                    Math.max(-180, Qe[0]),
                                    Math.max(-90, Qe[1]),
                                    Math.min(180, Qe[2]),
                                    Math.min(90, Qe[3])
                                ] : [
                                    -180,
                                    -90,
                                    180,
                                    90
                                ];
                            }
                            contains(Qe) {
                                const Wn = Math.pow(2, Qe.z), Co = Math.floor(rt.U(this.bounds.getWest()) * Wn), Dl = Math.floor(rt.S(this.bounds.getNorth()) * Wn), Ll = Math.ceil(rt.U(this.bounds.getEast()) * Wn), Rl = Math.ceil(rt.S(this.bounds.getSouth()) * Wn);
                                return Qe.x >= Co && Qe.x < Ll && Qe.y >= Dl && Qe.y < Rl;
                            }
                        }
                        class W extends rt.E {
                            constructor(Qe, Wn, Co, Dl){
                                if (super(), this.id = Qe, this.dispatcher = Co, this.type = "vector", this.minzoom = 0, this.maxzoom = 22, this.scheme = "xyz", this.tileSize = 512, this.reparseOverscaled = !0, this.isTileClipped = !0, this._loaded = !1, rt.e(this, rt.O(Wn, [
                                    "url",
                                    "scheme",
                                    "tileSize",
                                    "promoteId"
                                ])), this._options = rt.e({
                                    type: "vector"
                                }, Wn), this._collectResourceTiming = Wn.collectResourceTiming, 512 !== this.tileSize) throw new Error("vector tile sources must have a tileSize of 512");
                                this.setEventedParent(Dl);
                            }
                            load() {
                                return rt._(this, void 0, void 0, function*() {
                                    this._loaded = !1, this.fire(new rt.l("dataloading", {
                                        dataType: "source"
                                    })), this._tileJSONRequest = new AbortController;
                                    try {
                                        const Qe = yield U(this._options, this.map._requestManager, this._tileJSONRequest);
                                        this._tileJSONRequest = null, this._loaded = !0, this.map.style.sourceCaches[this.id].clearTiles(), Qe && (rt.e(this, Qe), Qe.bounds && (this.tileBounds = new q(Qe.bounds, this.minzoom, this.maxzoom)), this.fire(new rt.l("data", {
                                            dataType: "source",
                                            sourceDataType: "metadata"
                                        })), this.fire(new rt.l("data", {
                                            dataType: "source",
                                            sourceDataType: "content"
                                        })));
                                    } catch (Qe) {
                                        this._tileJSONRequest = null, this.fire(new rt.k(Qe));
                                    }
                                });
                            }
                            loaded() {
                                return this._loaded;
                            }
                            hasTile(Qe) {
                                return !this.tileBounds || this.tileBounds.contains(Qe.canonical);
                            }
                            onAdd(Qe) {
                                this.map = Qe, this.load();
                            }
                            setSourceProperty(Qe) {
                                this._tileJSONRequest && this._tileJSONRequest.abort(), Qe(), this.load();
                            }
                            setTiles(Qe) {
                                return this.setSourceProperty(()=>{
                                    this._options.tiles = Qe;
                                }), this;
                            }
                            setUrl(Qe) {
                                return this.setSourceProperty(()=>{
                                    this.url = Qe, this._options.url = Qe;
                                }), this;
                            }
                            onRemove() {
                                this._tileJSONRequest && (this._tileJSONRequest.abort(), this._tileJSONRequest = null);
                            }
                            serialize() {
                                return rt.e({}, this._options);
                            }
                            loadTile(Qe) {
                                return rt._(this, void 0, void 0, function*() {
                                    const rt = Qe.tileID.canonical.url(this.tiles, this.map.getPixelRatio(), this.scheme), Wn = {
                                        request: this.map._requestManager.transformRequest(rt, "Tile"),
                                        uid: Qe.uid,
                                        tileID: Qe.tileID,
                                        zoom: Qe.tileID.overscaledZ,
                                        tileSize: this.tileSize * Qe.tileID.overscaleFactor(),
                                        type: this.type,
                                        source: this.id,
                                        pixelRatio: this.map.getPixelRatio(),
                                        showCollisionBoxes: this.map.showCollisionBoxes,
                                        promoteId: this.promoteId,
                                        subdivisionGranularity: this.map.style.projection.subdivisionGranularity
                                    };
                                    Wn.request.collectResourceTiming = this._collectResourceTiming;
                                    let Co = "RT";
                                    if (Qe.actor && "expired" !== Qe.state) {
                                        if ("loading" === Qe.state) return new Promise((rt, Wn)=>{
                                            Qe.reloadPromise = {
                                                resolve: rt,
                                                reject: Wn
                                            };
                                        });
                                    } else Qe.actor = this.dispatcher.getActor(), Co = "LT";
                                    Qe.abortController = new AbortController;
                                    try {
                                        const rt = yield Qe.actor.sendAsync({
                                            type: Co,
                                            data: Wn
                                        }, Qe.abortController);
                                        if (delete Qe.abortController, Qe.aborted) return;
                                        this._afterTileLoadWorkerResponse(Qe, rt);
                                    } catch (rt) {
                                        if (delete Qe.abortController, Qe.aborted) return;
                                        if (rt && 404 !== rt.status) throw rt;
                                        this._afterTileLoadWorkerResponse(Qe, null);
                                    }
                                });
                            }
                            _afterTileLoadWorkerResponse(Qe, rt) {
                                if (rt && rt.resourceTiming && (Qe.resourceTiming = rt.resourceTiming), rt && this.map._refreshExpiredTiles && Qe.setExpiryData(rt), Qe.loadVectorData(rt, this.map.painter), Qe.reloadPromise) {
                                    const rt = Qe.reloadPromise;
                                    Qe.reloadPromise = null, this.loadTile(Qe).then(rt.resolve).catch(rt.reject);
                                }
                            }
                            abortTile(Qe) {
                                return rt._(this, void 0, void 0, function*() {
                                    Qe.abortController && (Qe.abortController.abort(), delete Qe.abortController), Qe.actor && (yield Qe.actor.sendAsync({
                                        type: "AT",
                                        data: {
                                            uid: Qe.uid,
                                            type: this.type,
                                            source: this.id
                                        }
                                    }));
                                });
                            }
                            unloadTile(Qe) {
                                return rt._(this, void 0, void 0, function*() {
                                    Qe.unloadVectorData(), Qe.actor && (yield Qe.actor.sendAsync({
                                        type: "RMT",
                                        data: {
                                            uid: Qe.uid,
                                            type: this.type,
                                            source: this.id
                                        }
                                    }));
                                });
                            }
                            hasTransition() {
                                return !1;
                            }
                        }
                        class $ extends rt.E {
                            constructor(Qe, Wn, Co, Dl){
                                super(), this.id = Qe, this.dispatcher = Co, this.setEventedParent(Dl), this.type = "raster", this.minzoom = 0, this.maxzoom = 22, this.roundZoom = !0, this.scheme = "xyz", this.tileSize = 512, this._loaded = !1, this._options = rt.e({
                                    type: "raster"
                                }, Wn), rt.e(this, rt.O(Wn, [
                                    "url",
                                    "scheme",
                                    "tileSize"
                                ]));
                            }
                            load() {
                                return rt._(this, arguments, void 0, function*(Qe = !1) {
                                    this._loaded = !1, this.fire(new rt.l("dataloading", {
                                        dataType: "source"
                                    })), this._tileJSONRequest = new AbortController;
                                    try {
                                        const Wn = yield U(this._options, this.map._requestManager, this._tileJSONRequest);
                                        this._tileJSONRequest = null, this._loaded = !0, Wn && (rt.e(this, Wn), Wn.bounds && (this.tileBounds = new q(Wn.bounds, this.minzoom, this.maxzoom)), this.fire(new rt.l("data", {
                                            dataType: "source",
                                            sourceDataType: "metadata"
                                        })), this.fire(new rt.l("data", {
                                            dataType: "source",
                                            sourceDataType: "content",
                                            sourceDataChanged: Qe
                                        })));
                                    } catch (Qe) {
                                        this._tileJSONRequest = null, this.fire(new rt.k(Qe));
                                    }
                                });
                            }
                            loaded() {
                                return this._loaded;
                            }
                            onAdd(Qe) {
                                this.map = Qe, this.load();
                            }
                            onRemove() {
                                this._tileJSONRequest && (this._tileJSONRequest.abort(), this._tileJSONRequest = null);
                            }
                            setSourceProperty(Qe) {
                                this._tileJSONRequest && (this._tileJSONRequest.abort(), this._tileJSONRequest = null), Qe(), this.load(!0);
                            }
                            setTiles(Qe) {
                                return this.setSourceProperty(()=>{
                                    this._options.tiles = Qe;
                                }), this;
                            }
                            setUrl(Qe) {
                                return this.setSourceProperty(()=>{
                                    this.url = Qe, this._options.url = Qe;
                                }), this;
                            }
                            serialize() {
                                return rt.e({}, this._options);
                            }
                            hasTile(Qe) {
                                return !this.tileBounds || this.tileBounds.contains(Qe.canonical);
                            }
                            loadTile(Qe) {
                                return rt._(this, void 0, void 0, function*() {
                                    const rt = Qe.tileID.canonical.url(this.tiles, this.map.getPixelRatio(), this.scheme);
                                    Qe.abortController = new AbortController;
                                    try {
                                        const Wn = yield ql.getImage(this.map._requestManager.transformRequest(rt, "Tile"), Qe.abortController, this.map._refreshExpiredTiles);
                                        if (delete Qe.abortController, Qe.aborted) return void (Qe.state = "unloaded");
                                        if (Wn && Wn.data) {
                                            this.map._refreshExpiredTiles && Wn.cacheControl && Wn.expires && Qe.setExpiryData({
                                                cacheControl: Wn.cacheControl,
                                                expires: Wn.expires
                                            });
                                            const rt = this.map.painter.context, Co = rt.gl, Dl = Wn.data;
                                            Qe.texture = this.map.painter.getTileTexture(Dl.width), Qe.texture ? Qe.texture.update(Dl, {
                                                useMipmap: !0
                                            }) : (Qe.texture = new v(rt, Dl, Co.RGBA, {
                                                useMipmap: !0
                                            }), Qe.texture.bind(Co.LINEAR, Co.CLAMP_TO_EDGE, Co.LINEAR_MIPMAP_NEAREST)), Qe.state = "loaded";
                                        }
                                    } catch (rt) {
                                        if (delete Qe.abortController, Qe.aborted) Qe.state = "unloaded";
                                        else if (rt) throw Qe.state = "errored", rt;
                                    }
                                });
                            }
                            abortTile(Qe) {
                                return rt._(this, void 0, void 0, function*() {
                                    Qe.abortController && (Qe.abortController.abort(), delete Qe.abortController);
                                });
                            }
                            unloadTile(Qe) {
                                return rt._(this, void 0, void 0, function*() {
                                    Qe.texture && this.map.painter.saveTileTexture(Qe.texture);
                                });
                            }
                            hasTransition() {
                                return !1;
                            }
                        }
                        class H extends $ {
                            constructor(Qe, Wn, Co, Dl){
                                super(Qe, Wn, Co, Dl), this.type = "raster-dem", this.maxzoom = 22, this._options = rt.e({
                                    type: "raster-dem"
                                }, Wn), this.encoding = Wn.encoding || "mapbox", this.redFactor = Wn.redFactor, this.greenFactor = Wn.greenFactor, this.blueFactor = Wn.blueFactor, this.baseShift = Wn.baseShift;
                            }
                            loadTile(Qe) {
                                return rt._(this, void 0, void 0, function*() {
                                    const Wn = Qe.tileID.canonical.url(this.tiles, this.map.getPixelRatio(), this.scheme), Co = this.map._requestManager.transformRequest(Wn, "Tile");
                                    Qe.neighboringTiles = this._getNeighboringTiles(Qe.tileID), Qe.abortController = new AbortController;
                                    try {
                                        const Wn = yield ql.getImage(Co, Qe.abortController, this.map._refreshExpiredTiles);
                                        if (delete Qe.abortController, Qe.aborted) return void (Qe.state = "unloaded");
                                        if (Wn && Wn.data) {
                                            const Co = Wn.data;
                                            this.map._refreshExpiredTiles && Wn.cacheControl && Wn.expires && Qe.setExpiryData({
                                                cacheControl: Wn.cacheControl,
                                                expires: Wn.expires
                                            });
                                            const Dl = rt.b(Co) && rt.V() ? Co : yield this.readImageNow(Co), Ll = {
                                                type: this.type,
                                                uid: Qe.uid,
                                                source: this.id,
                                                rawImageData: Dl,
                                                encoding: this.encoding,
                                                redFactor: this.redFactor,
                                                greenFactor: this.greenFactor,
                                                blueFactor: this.blueFactor,
                                                baseShift: this.baseShift
                                            };
                                            if (!Qe.actor || "expired" === Qe.state) {
                                                Qe.actor = this.dispatcher.getActor();
                                                const rt = yield Qe.actor.sendAsync({
                                                    type: "LDT",
                                                    data: Ll
                                                });
                                                Qe.dem = rt, Qe.needsHillshadePrepare = !0, Qe.needsTerrainPrepare = !0, Qe.state = "loaded";
                                            }
                                        }
                                    } catch (rt) {
                                        if (delete Qe.abortController, Qe.aborted) Qe.state = "unloaded";
                                        else if (rt) throw Qe.state = "errored", rt;
                                    }
                                });
                            }
                            readImageNow(Qe) {
                                return rt._(this, void 0, void 0, function*() {
                                    if ("undefined" != typeof VideoFrame && rt.W()) {
                                        const Wn = Qe.width + 2, Co = Qe.height + 2;
                                        try {
                                            return new rt.R({
                                                width: Wn,
                                                height: Co
                                            }, (yield rt.X(Qe, -1, -1, Wn, Co)));
                                        } catch (Qe) {}
                                    }
                                    return Ll.getImageData(Qe, 1);
                                });
                            }
                            _getNeighboringTiles(Qe) {
                                const Wn = Qe.canonical, Co = Math.pow(2, Wn.z), Dl = (Wn.x - 1 + Co) % Co, Ll = 0 === Wn.x ? Qe.wrap - 1 : Qe.wrap, Rl = (Wn.x + 1 + Co) % Co, Ul = Wn.x + 1 === Co ? Qe.wrap + 1 : Qe.wrap, Gl = {};
                                return Gl[new rt.Y(Qe.overscaledZ, Ll, Wn.z, Dl, Wn.y).key] = {
                                    backfilled: !1
                                }, Gl[new rt.Y(Qe.overscaledZ, Ul, Wn.z, Rl, Wn.y).key] = {
                                    backfilled: !1
                                }, Wn.y > 0 && (Gl[new rt.Y(Qe.overscaledZ, Ll, Wn.z, Dl, Wn.y - 1).key] = {
                                    backfilled: !1
                                }, Gl[new rt.Y(Qe.overscaledZ, Qe.wrap, Wn.z, Wn.x, Wn.y - 1).key] = {
                                    backfilled: !1
                                }, Gl[new rt.Y(Qe.overscaledZ, Ul, Wn.z, Rl, Wn.y - 1).key] = {
                                    backfilled: !1
                                }), Wn.y + 1 < Co && (Gl[new rt.Y(Qe.overscaledZ, Ll, Wn.z, Dl, Wn.y + 1).key] = {
                                    backfilled: !1
                                }, Gl[new rt.Y(Qe.overscaledZ, Qe.wrap, Wn.z, Wn.x, Wn.y + 1).key] = {
                                    backfilled: !1
                                }, Gl[new rt.Y(Qe.overscaledZ, Ul, Wn.z, Rl, Wn.y + 1).key] = {
                                    backfilled: !1
                                }), Gl;
                            }
                            unloadTile(Qe) {
                                return rt._(this, void 0, void 0, function*() {
                                    Qe.demTexture && this.map.painter.saveTileTexture(Qe.demTexture), Qe.fbo && (Qe.fbo.destroy(), delete Qe.fbo), Qe.dem && delete Qe.dem, delete Qe.neighboringTiles, Qe.state = "unloaded", Qe.actor && (yield Qe.actor.sendAsync({
                                        type: "RDT",
                                        data: {
                                            type: this.type,
                                            uid: Qe.uid,
                                            source: this.id
                                        }
                                    }));
                                });
                            }
                        }
                        class K extends rt.E {
                            constructor(Qe, Wn, Co, Dl){
                                super(), this.id = Qe, this.type = "geojson", this.minzoom = 0, this.maxzoom = 18, this.tileSize = 512, this.isTileClipped = !0, this.reparseOverscaled = !0, this._removed = !1, this._pendingLoads = 0, this.actor = Co.getActor(), this.setEventedParent(Dl), this._data = Wn.data, this._options = rt.e({}, Wn), this._collectResourceTiming = Wn.collectResourceTiming, void 0 !== Wn.maxzoom && (this.maxzoom = Wn.maxzoom), Wn.type && (this.type = Wn.type), Wn.attribution && (this.attribution = Wn.attribution), this.promoteId = Wn.promoteId, void 0 !== Wn.clusterMaxZoom && this.maxzoom <= Wn.clusterMaxZoom && rt.w(`The maxzoom value "${this.maxzoom}" is expected to be greater than the clusterMaxZoom value "${Wn.clusterMaxZoom}".`), this.workerOptions = rt.e({
                                    source: this.id,
                                    cluster: Wn.cluster || !1,
                                    geojsonVtOptions: {
                                        buffer: this._pixelsToTileUnits(void 0 !== Wn.buffer ? Wn.buffer : 128),
                                        tolerance: this._pixelsToTileUnits(void 0 !== Wn.tolerance ? Wn.tolerance : .375),
                                        extent: rt.Z,
                                        maxZoom: this.maxzoom,
                                        lineMetrics: Wn.lineMetrics || !1,
                                        generateId: Wn.generateId || !1
                                    },
                                    superclusterOptions: {
                                        maxZoom: void 0 !== Wn.clusterMaxZoom ? Wn.clusterMaxZoom : this.maxzoom - 1,
                                        minPoints: Math.max(2, Wn.clusterMinPoints || 2),
                                        extent: rt.Z,
                                        radius: this._pixelsToTileUnits(Wn.clusterRadius || 50),
                                        log: !1,
                                        generateId: Wn.generateId || !1
                                    },
                                    clusterProperties: Wn.clusterProperties,
                                    filter: Wn.filter
                                }, Wn.workerOptions), "string" == typeof this.promoteId && (this.workerOptions.promoteId = this.promoteId);
                            }
                            _pixelsToTileUnits(Qe) {
                                return Qe * (rt.Z / this.tileSize);
                            }
                            load() {
                                return rt._(this, void 0, void 0, function*() {
                                    yield this._updateWorkerData();
                                });
                            }
                            onAdd(Qe) {
                                this.map = Qe, this.load();
                            }
                            setData(Qe) {
                                return this._data = Qe, this._updateWorkerData(), this;
                            }
                            updateData(Qe) {
                                return this._updateWorkerData(Qe), this;
                            }
                            getData() {
                                return rt._(this, void 0, void 0, function*() {
                                    const Qe = rt.e({
                                        type: this.type
                                    }, this.workerOptions);
                                    return this.actor.sendAsync({
                                        type: "GD",
                                        data: Qe
                                    });
                                });
                            }
                            getCoordinatesFromGeometry(Qe) {
                                return "GeometryCollection" === Qe.type ? Qe.geometries.map((Qe)=>Qe.coordinates).flat(1 / 0) : Qe.coordinates.flat(1 / 0);
                            }
                            getBounds() {
                                return rt._(this, void 0, void 0, function*() {
                                    const Qe = new V, rt = yield this.getData();
                                    let Wn;
                                    switch(rt.type){
                                        case "FeatureCollection":
                                            Wn = rt.features.map((Qe)=>this.getCoordinatesFromGeometry(Qe.geometry)).flat(1 / 0);
                                            break;
                                        case "Feature":
                                            Wn = this.getCoordinatesFromGeometry(rt.geometry);
                                            break;
                                        default:
                                            Wn = this.getCoordinatesFromGeometry(rt);
                                    }
                                    if (0 == Wn.length) return Qe;
                                    for(let Co = 0; Co < Wn.length - 1; Co += 2)Qe.extend([
                                        Wn[Co],
                                        Wn[Co + 1]
                                    ]);
                                    return Qe;
                                });
                            }
                            setClusterOptions(Qe) {
                                return this.workerOptions.cluster = Qe.cluster, Qe && (void 0 !== Qe.clusterRadius && (this.workerOptions.superclusterOptions.radius = this._pixelsToTileUnits(Qe.clusterRadius)), void 0 !== Qe.clusterMaxZoom && (this.workerOptions.superclusterOptions.maxZoom = Qe.clusterMaxZoom)), this._updateWorkerData(), this;
                            }
                            getClusterExpansionZoom(Qe) {
                                return this.actor.sendAsync({
                                    type: "GCEZ",
                                    data: {
                                        type: this.type,
                                        clusterId: Qe,
                                        source: this.id
                                    }
                                });
                            }
                            getClusterChildren(Qe) {
                                return this.actor.sendAsync({
                                    type: "GCC",
                                    data: {
                                        type: this.type,
                                        clusterId: Qe,
                                        source: this.id
                                    }
                                });
                            }
                            getClusterLeaves(Qe, rt, Wn) {
                                return this.actor.sendAsync({
                                    type: "GCL",
                                    data: {
                                        type: this.type,
                                        source: this.id,
                                        clusterId: Qe,
                                        limit: rt,
                                        offset: Wn
                                    }
                                });
                            }
                            _updateWorkerData(Qe) {
                                return rt._(this, void 0, void 0, function*() {
                                    const Wn = rt.e({
                                        type: this.type
                                    }, this.workerOptions);
                                    Qe ? Wn.dataDiff = Qe : "string" == typeof this._data ? (Wn.request = this.map._requestManager.transformRequest(Ll.resolveURL(this._data), "Source"), Wn.request.collectResourceTiming = this._collectResourceTiming) : Wn.data = JSON.stringify(this._data), this._pendingLoads++, this.fire(new rt.l("dataloading", {
                                        dataType: "source"
                                    }));
                                    try {
                                        const Qe = yield this.actor.sendAsync({
                                            type: "LD",
                                            data: Wn
                                        });
                                        if (this._pendingLoads--, this._removed || Qe.abandoned) return void this.fire(new rt.l("dataabort", {
                                            dataType: "source"
                                        }));
                                        let Co = null;
                                        Qe.resourceTiming && Qe.resourceTiming[this.id] && (Co = Qe.resourceTiming[this.id].slice(0));
                                        const Dl = {
                                            dataType: "source"
                                        };
                                        this._collectResourceTiming && Co && Co.length > 0 && rt.e(Dl, {
                                            resourceTiming: Co
                                        }), this.fire(new rt.l("data", Object.assign(Object.assign({}, Dl), {
                                            sourceDataType: "metadata"
                                        }))), this.fire(new rt.l("data", Object.assign(Object.assign({}, Dl), {
                                            sourceDataType: "content"
                                        })));
                                    } catch (Qe) {
                                        if (this._pendingLoads--, this._removed) return void this.fire(new rt.l("dataabort", {
                                            dataType: "source"
                                        }));
                                        this.fire(new rt.k(Qe));
                                    }
                                });
                            }
                            loaded() {
                                return 0 === this._pendingLoads;
                            }
                            loadTile(Qe) {
                                return rt._(this, void 0, void 0, function*() {
                                    const rt = Qe.actor ? "RT" : "LT";
                                    Qe.actor = this.actor;
                                    const Wn = {
                                        type: this.type,
                                        uid: Qe.uid,
                                        tileID: Qe.tileID,
                                        zoom: Qe.tileID.overscaledZ,
                                        maxZoom: this.maxzoom,
                                        tileSize: this.tileSize,
                                        source: this.id,
                                        pixelRatio: this.map.getPixelRatio(),
                                        showCollisionBoxes: this.map.showCollisionBoxes,
                                        promoteId: this.promoteId,
                                        subdivisionGranularity: this.map.style.projection.subdivisionGranularity
                                    };
                                    Qe.abortController = new AbortController;
                                    const Co = yield this.actor.sendAsync({
                                        type: rt,
                                        data: Wn
                                    }, Qe.abortController);
                                    delete Qe.abortController, Qe.unloadVectorData(), Qe.aborted || Qe.loadVectorData(Co, this.map.painter, "RT" === rt);
                                });
                            }
                            abortTile(Qe) {
                                return rt._(this, void 0, void 0, function*() {
                                    Qe.abortController && (Qe.abortController.abort(), delete Qe.abortController), Qe.aborted = !0;
                                });
                            }
                            unloadTile(Qe) {
                                return rt._(this, void 0, void 0, function*() {
                                    Qe.unloadVectorData(), yield this.actor.sendAsync({
                                        type: "RMT",
                                        data: {
                                            uid: Qe.uid,
                                            type: this.type,
                                            source: this.id
                                        }
                                    });
                                });
                            }
                            onRemove() {
                                this._removed = !0, this.actor.sendAsync({
                                    type: "RS",
                                    data: {
                                        type: this.type,
                                        source: this.id
                                    }
                                });
                            }
                            serialize() {
                                return rt.e({}, this._options, {
                                    type: this.type,
                                    data: this._data
                                });
                            }
                            hasTransition() {
                                return !1;
                            }
                        }
                        class X extends rt.E {
                            constructor(Qe, rt, Wn, Co){
                                super(), this.flippedWindingOrder = !1, this.id = Qe, this.dispatcher = Wn, this.coordinates = rt.coordinates, this.type = "image", this.minzoom = 0, this.maxzoom = 22, this.tileSize = 512, this.tiles = {}, this._loaded = !1, this.setEventedParent(Co), this.options = rt;
                            }
                            load(Qe) {
                                return rt._(this, void 0, void 0, function*() {
                                    this._loaded = !1, this.fire(new rt.l("dataloading", {
                                        dataType: "source"
                                    })), this.url = this.options.url, this._request = new AbortController;
                                    try {
                                        const rt = yield ql.getImage(this.map._requestManager.transformRequest(this.url, "Image"), this._request);
                                        this._request = null, this._loaded = !0, rt && rt.data && (this.image = rt.data, Qe && (this.coordinates = Qe), this._finishLoading());
                                    } catch (Qe) {
                                        this._request = null, this._loaded = !0, this.fire(new rt.k(Qe));
                                    }
                                });
                            }
                            loaded() {
                                return this._loaded;
                            }
                            updateImage(Qe) {
                                return Qe.url ? (this._request && (this._request.abort(), this._request = null), this.options.url = Qe.url, this.load(Qe.coordinates).finally(()=>{
                                    this.texture = null;
                                }), this) : this;
                            }
                            _finishLoading() {
                                this.map && (this.setCoordinates(this.coordinates), this.fire(new rt.l("data", {
                                    dataType: "source",
                                    sourceDataType: "metadata"
                                })));
                            }
                            onAdd(Qe) {
                                this.map = Qe, this.load();
                            }
                            onRemove() {
                                this._request && (this._request.abort(), this._request = null);
                            }
                            setCoordinates(Qe) {
                                this.coordinates = Qe;
                                const Wn = Qe.map(rt.$.fromLngLat);
                                var Co;
                                return this.tileID = function(Qe) {
                                    let Wn = 1 / 0, Co = 1 / 0, Dl = -1 / 0, Ll = -1 / 0;
                                    for (const rt of Qe)Wn = Math.min(Wn, rt.x), Co = Math.min(Co, rt.y), Dl = Math.max(Dl, rt.x), Ll = Math.max(Ll, rt.y);
                                    const Rl = Math.max(Dl - Wn, Ll - Co), Ul = Math.max(0, Math.floor(-Math.log(Rl) / Math.LN2)), Gl = Math.pow(2, Ul);
                                    return new rt.a1(Ul, Math.floor((Wn + Dl) / 2 * Gl), Math.floor((Co + Ll) / 2 * Gl));
                                }(Wn), this.terrainTileRanges = this._getOverlappingTileRanges(Wn), this.minzoom = this.maxzoom = this.tileID.z, this.tileCoords = Wn.map((Qe)=>this.tileID.getTilePoint(Qe)._round()), this.flippedWindingOrder = ((Co = this.tileCoords)[1].x - Co[0].x) * (Co[2].y - Co[0].y) - (Co[1].y - Co[0].y) * (Co[2].x - Co[0].x) < 0, this.fire(new rt.l("data", {
                                    dataType: "source",
                                    sourceDataType: "content"
                                })), this;
                            }
                            prepare() {
                                if (0 === Object.keys(this.tiles).length || !this.image) return;
                                const Qe = this.map.painter.context, Wn = Qe.gl;
                                this.texture || (this.texture = new v(Qe, this.image, Wn.RGBA), this.texture.bind(Wn.LINEAR, Wn.CLAMP_TO_EDGE));
                                let Co = !1;
                                for(const rt in this.tiles){
                                    const Qe = this.tiles[rt];
                                    "loaded" !== Qe.state && (Qe.state = "loaded", Qe.texture = this.texture, Co = !0);
                                }
                                Co && this.fire(new rt.l("data", {
                                    dataType: "source",
                                    sourceDataType: "idle",
                                    sourceId: this.id
                                }));
                            }
                            loadTile(Qe) {
                                return rt._(this, void 0, void 0, function*() {
                                    this.tileID && this.tileID.equals(Qe.tileID.canonical) ? (this.tiles[String(Qe.tileID.wrap)] = Qe, Qe.buckets = {}) : Qe.state = "errored";
                                });
                            }
                            serialize() {
                                return {
                                    type: "image",
                                    url: this.options.url,
                                    coordinates: this.coordinates
                                };
                            }
                            hasTransition() {
                                return !1;
                            }
                            _getOverlappingTileRanges(Qe) {
                                let Wn = 1 / 0, Co = 1 / 0, Dl = -1 / 0, Ll = -1 / 0;
                                for (const rt of Qe)Wn = Math.min(Wn, rt.x), Co = Math.min(Co, rt.y), Dl = Math.max(Dl, rt.x), Ll = Math.max(Ll, rt.y);
                                const Rl = {};
                                for(let Ul = 0; Ul <= rt.a0; Ul++){
                                    const Qe = Math.pow(2, Ul), rt = Math.floor(Wn * Qe), Gl = Math.floor(Co * Qe), Zl = Math.floor(Dl * Qe), Hl = Math.floor(Ll * Qe);
                                    Rl[Ul] = {
                                        minTileX: rt,
                                        minTileY: Gl,
                                        maxTileX: Zl,
                                        maxTileY: Hl
                                    };
                                }
                                return Rl;
                            }
                        }
                        class Q extends X {
                            constructor(Qe, rt, Wn, Co){
                                super(Qe, rt, Wn, Co), this.roundZoom = !0, this.type = "video", this.options = rt;
                            }
                            load() {
                                return rt._(this, void 0, void 0, function*() {
                                    this._loaded = !1;
                                    const Qe = this.options;
                                    this.urls = [];
                                    for (const rt of Qe.urls)this.urls.push(this.map._requestManager.transformRequest(rt, "Source").url);
                                    try {
                                        const Qe = yield rt.a2(this.urls);
                                        if (this._loaded = !0, !Qe) return;
                                        this.video = Qe, this.video.loop = !0, this.video.addEventListener("playing", ()=>{
                                            this.map.triggerRepaint();
                                        }), this.map && this.video.play(), this._finishLoading();
                                    } catch (Qe) {
                                        this.fire(new rt.k(Qe));
                                    }
                                });
                            }
                            pause() {
                                this.video && this.video.pause();
                            }
                            play() {
                                this.video && this.video.play();
                            }
                            seek(Qe) {
                                if (this.video) {
                                    const Wn = this.video.seekable;
                                    Qe < Wn.start(0) || Qe > Wn.end(0) ? this.fire(new rt.k(new rt.a3(`sources.${this.id}`, null, `Playback for this video can be set only between the ${Wn.start(0)} and ${Wn.end(0)}-second mark.`))) : this.video.currentTime = Qe;
                                }
                            }
                            getVideo() {
                                return this.video;
                            }
                            onAdd(Qe) {
                                this.map || (this.map = Qe, this.load(), this.video && (this.video.play(), this.setCoordinates(this.coordinates)));
                            }
                            prepare() {
                                if (0 === Object.keys(this.tiles).length || this.video.readyState < 2) return;
                                const Qe = this.map.painter.context, Wn = Qe.gl;
                                this.texture ? this.video.paused || (this.texture.bind(Wn.LINEAR, Wn.CLAMP_TO_EDGE), Wn.texSubImage2D(Wn.TEXTURE_2D, 0, 0, 0, Wn.RGBA, Wn.UNSIGNED_BYTE, this.video)) : (this.texture = new v(Qe, this.video, Wn.RGBA), this.texture.bind(Wn.LINEAR, Wn.CLAMP_TO_EDGE));
                                let Co = !1;
                                for(const rt in this.tiles){
                                    const Qe = this.tiles[rt];
                                    "loaded" !== Qe.state && (Qe.state = "loaded", Qe.texture = this.texture, Co = !0);
                                }
                                Co && this.fire(new rt.l("data", {
                                    dataType: "source",
                                    sourceDataType: "idle",
                                    sourceId: this.id
                                }));
                            }
                            serialize() {
                                return {
                                    type: "video",
                                    urls: this.urls,
                                    coordinates: this.coordinates
                                };
                            }
                            hasTransition() {
                                return this.video && !this.video.paused;
                            }
                        }
                        class Y extends X {
                            constructor(Qe, Wn, Co, Dl){
                                super(Qe, Wn, Co, Dl), Wn.coordinates ? Array.isArray(Wn.coordinates) && 4 === Wn.coordinates.length && !Wn.coordinates.some((Qe)=>!Array.isArray(Qe) || 2 !== Qe.length || Qe.some((Qe)=>"number" != typeof Qe)) || this.fire(new rt.k(new rt.a3(`sources.${Qe}`, null, '"coordinates" property must be an array of 4 longitude/latitude array pairs'))) : this.fire(new rt.k(new rt.a3(`sources.${Qe}`, null, 'missing required property "coordinates"'))), Wn.animate && "boolean" != typeof Wn.animate && this.fire(new rt.k(new rt.a3(`sources.${Qe}`, null, 'optional "animate" property must be a boolean value'))), Wn.canvas ? "string" == typeof Wn.canvas || Wn.canvas instanceof HTMLCanvasElement || this.fire(new rt.k(new rt.a3(`sources.${Qe}`, null, '"canvas" must be either a string representing the ID of the canvas element from which to read, or an HTMLCanvasElement instance'))) : this.fire(new rt.k(new rt.a3(`sources.${Qe}`, null, 'missing required property "canvas"'))), this.options = Wn, this.animate = void 0 === Wn.animate || Wn.animate;
                            }
                            load() {
                                return rt._(this, void 0, void 0, function*() {
                                    this._loaded = !0, this.canvas || (this.canvas = this.options.canvas instanceof HTMLCanvasElement ? this.options.canvas : document.getElementById(this.options.canvas)), this.width = this.canvas.width, this.height = this.canvas.height, this._hasInvalidDimensions() ? this.fire(new rt.k(new Error("Canvas dimensions cannot be less than or equal to zero."))) : (this.play = function() {
                                        this._playing = !0, this.map.triggerRepaint();
                                    }, this.pause = function() {
                                        this._playing && (this.prepare(), this._playing = !1);
                                    }, this._finishLoading());
                                });
                            }
                            getCanvas() {
                                return this.canvas;
                            }
                            onAdd(Qe) {
                                this.map = Qe, this.load(), this.canvas && this.animate && this.play();
                            }
                            onRemove() {
                                this.pause();
                            }
                            prepare() {
                                let Qe = !1;
                                if (this.canvas.width !== this.width && (this.width = this.canvas.width, Qe = !0), this.canvas.height !== this.height && (this.height = this.canvas.height, Qe = !0), this._hasInvalidDimensions()) return;
                                if (0 === Object.keys(this.tiles).length) return;
                                const Wn = this.map.painter.context, Co = Wn.gl;
                                this.texture ? (Qe || this._playing) && this.texture.update(this.canvas, {
                                    premultiply: !0
                                }) : this.texture = new v(Wn, this.canvas, Co.RGBA, {
                                    premultiply: !0
                                });
                                let Dl = !1;
                                for(const rt in this.tiles){
                                    const Qe = this.tiles[rt];
                                    "loaded" !== Qe.state && (Qe.state = "loaded", Qe.texture = this.texture, Dl = !0);
                                }
                                Dl && this.fire(new rt.l("data", {
                                    dataType: "source",
                                    sourceDataType: "idle",
                                    sourceId: this.id
                                }));
                            }
                            serialize() {
                                return {
                                    type: "canvas",
                                    coordinates: this.coordinates
                                };
                            }
                            hasTransition() {
                                return this._playing;
                            }
                            _hasInvalidDimensions() {
                                for (const Qe of [
                                    this.canvas.width,
                                    this.canvas.height
                                ])if (isNaN(Qe) || Qe <= 0) return !0;
                                return !1;
                            }
                        }
                        const fu = {}, ee = (Qe)=>{
                            switch(Qe){
                                case "geojson":
                                    return K;
                                case "image":
                                    return X;
                                case "raster":
                                    return $;
                                case "raster-dem":
                                    return H;
                                case "vector":
                                    return W;
                                case "video":
                                    return Q;
                                case "canvas":
                                    return Y;
                            }
                            return fu[Qe];
                        }, yu = "RTLPluginLoaded";
                        class ie extends rt.E {
                            constructor(){
                                super(...arguments), this.status = "unavailable", this.url = null, this.dispatcher = O();
                            }
                            _syncState(Qe) {
                                return this.status = Qe, this.dispatcher.broadcast("SRPS", {
                                    pluginStatus: Qe,
                                    pluginURL: this.url
                                }).catch((Qe)=>{
                                    throw this.status = "error", Qe;
                                });
                            }
                            getRTLTextPluginStatus() {
                                return this.status;
                            }
                            clearRTLTextPlugin() {
                                this.status = "unavailable", this.url = null;
                            }
                            setRTLTextPlugin(Qe) {
                                return rt._(this, arguments, void 0, function*(Qe, rt = !1) {
                                    if (this.url) throw new Error("setRTLTextPlugin cannot be called multiple times.");
                                    if (this.url = Ll.resolveURL(Qe), !this.url) throw new Error(`requested url ${Qe} is invalid`);
                                    if ("unavailable" === this.status) {
                                        if (!rt) return this._requestImport();
                                        this.status = "deferred", this._syncState(this.status);
                                    } else if ("requested" === this.status) return this._requestImport();
                                });
                            }
                            _requestImport() {
                                return rt._(this, void 0, void 0, function*() {
                                    yield this._syncState("loading"), this.status = "loaded", this.fire(new rt.l(yu));
                                });
                            }
                            lazyLoad() {
                                "unavailable" === this.status ? this.status = "requested" : "deferred" === this.status && this._requestImport();
                            }
                        }
                        let Eu = null;
                        function oe() {
                            return Eu || (Eu = new ie), Eu;
                        }
                        class ae {
                            constructor(Qe, Wn){
                                this.timeAdded = 0, this.fadeEndTime = 0, this.tileID = Qe, this.uid = rt.a4(), this.uses = 0, this.tileSize = Wn, this.buckets = {}, this.expirationTime = null, this.queryPadding = 0, this.hasSymbolBuckets = !1, this.hasRTLText = !1, this.dependencies = {}, this.rtt = [], this.rttCoords = {}, this.expiredRequestCount = 0, this.state = "loading";
                            }
                            registerFadeDuration(Qe) {
                                const rt = Qe + this.timeAdded;
                                rt < this.fadeEndTime || (this.fadeEndTime = rt);
                            }
                            wasRequested() {
                                return "errored" === this.state || "loaded" === this.state || "reloading" === this.state;
                            }
                            clearTextures(Qe) {
                                this.demTexture && Qe.saveTileTexture(this.demTexture), this.demTexture = null;
                            }
                            loadVectorData(Qe, Wn, Co) {
                                if (this.hasData() && this.unloadVectorData(), this.state = "loaded", Qe) {
                                    Qe.featureIndex && (this.latestFeatureIndex = Qe.featureIndex, Qe.rawTileData ? (this.latestRawTileData = Qe.rawTileData, this.latestFeatureIndex.rawTileData = Qe.rawTileData) : this.latestRawTileData && (this.latestFeatureIndex.rawTileData = this.latestRawTileData)), this.collisionBoxArray = Qe.collisionBoxArray, this.buckets = function(Qe, rt) {
                                        const Wn = {};
                                        if (!rt) return Wn;
                                        for (const Co of Qe){
                                            const Qe = Co.layerIds.map((Qe)=>rt.getLayer(Qe)).filter(Boolean);
                                            if (0 !== Qe.length) {
                                                Co.layers = Qe, Co.stateDependentLayerIds && (Co.stateDependentLayers = Co.stateDependentLayerIds.map((rt)=>Qe.filter((Qe)=>Qe.id === rt)[0]));
                                                for (const rt of Qe)Wn[rt.id] = Co;
                                            }
                                        }
                                        return Wn;
                                    }(Qe.buckets, null == Wn ? void 0 : Wn.style), this.hasSymbolBuckets = !1;
                                    for(const Qe in this.buckets){
                                        const Wn = this.buckets[Qe];
                                        if (Wn instanceof rt.a6) {
                                            if (this.hasSymbolBuckets = !0, !Co) break;
                                            Wn.justReloaded = !0;
                                        }
                                    }
                                    if (this.hasRTLText = !1, this.hasSymbolBuckets) for(const Qe in this.buckets){
                                        const Wn = this.buckets[Qe];
                                        if (Wn instanceof rt.a6 && Wn.hasRTLText) {
                                            this.hasRTLText = !0, oe().lazyLoad();
                                            break;
                                        }
                                    }
                                    this.queryPadding = 0;
                                    for(const Qe in this.buckets){
                                        const rt = this.buckets[Qe];
                                        this.queryPadding = Math.max(this.queryPadding, Wn.style.getLayer(Qe).queryRadius(rt));
                                    }
                                    Qe.imageAtlas && (this.imageAtlas = Qe.imageAtlas), Qe.glyphAtlasImage && (this.glyphAtlasImage = Qe.glyphAtlasImage);
                                } else this.collisionBoxArray = new rt.a5;
                            }
                            unloadVectorData() {
                                for(const Qe in this.buckets)this.buckets[Qe].destroy();
                                this.buckets = {}, this.imageAtlasTexture && this.imageAtlasTexture.destroy(), this.imageAtlas && (this.imageAtlas = null), this.glyphAtlasTexture && this.glyphAtlasTexture.destroy(), this.latestFeatureIndex = null, this.state = "unloaded";
                            }
                            getBucket(Qe) {
                                return this.buckets[Qe.id];
                            }
                            upload(Qe) {
                                for(const Wn in this.buckets){
                                    const rt = this.buckets[Wn];
                                    rt.uploadPending() && rt.upload(Qe);
                                }
                                const rt = Qe.gl;
                                this.imageAtlas && !this.imageAtlas.uploaded && (this.imageAtlasTexture = new v(Qe, this.imageAtlas.image, rt.RGBA), this.imageAtlas.uploaded = !0), this.glyphAtlasImage && (this.glyphAtlasTexture = new v(Qe, this.glyphAtlasImage, rt.ALPHA), this.glyphAtlasImage = null);
                            }
                            prepare(Qe) {
                                this.imageAtlas && this.imageAtlas.patchUpdatedImages(Qe, this.imageAtlasTexture);
                            }
                            queryRenderedFeatures(Qe, rt, Wn, Co, Dl, Ll, Rl, Ul, Gl, Zl, Hl) {
                                return this.latestFeatureIndex && this.latestFeatureIndex.rawTileData ? this.latestFeatureIndex.query({
                                    queryGeometry: Co,
                                    cameraQueryGeometry: Dl,
                                    scale: Ll,
                                    tileSize: this.tileSize,
                                    pixelPosMatrix: Zl,
                                    transform: Ul,
                                    params: Rl,
                                    queryPadding: this.queryPadding * Gl,
                                    getElevation: Hl
                                }, Qe, rt, Wn) : {};
                            }
                            querySourceFeatures(Qe, Wn) {
                                const Co = this.latestFeatureIndex;
                                if (!Co || !Co.rawTileData) return;
                                const Dl = Co.loadVTLayers(), Ll = Wn && Wn.sourceLayer ? Wn.sourceLayer : "", Rl = Dl._geojsonTileLayer || Dl[Ll];
                                if (!Rl) return;
                                const Ul = rt.a7(Wn && Wn.filter), { z: Gl, x: Zl, y: Hl } = this.tileID.canonical, ql = {
                                    z: Gl,
                                    x: Zl,
                                    y: Hl
                                };
                                for(let Ql = 0; Ql < Rl.length; Ql++){
                                    const Wn = Rl.feature(Ql);
                                    if (Ul.needGeometry) {
                                        const Qe = rt.a8(Wn, !0);
                                        if (!Ul.filter(new rt.C(this.tileID.overscaledZ), Qe, this.tileID.canonical)) continue;
                                    } else if (!Ul.filter(new rt.C(this.tileID.overscaledZ), Wn)) continue;
                                    const Dl = Co.getId(Wn, Ll), Kl = new rt.a9(Wn, Gl, Zl, Hl, Dl);
                                    Kl.tile = ql, Qe.push(Kl);
                                }
                            }
                            hasData() {
                                return "loaded" === this.state || "reloading" === this.state || "expired" === this.state;
                            }
                            patternsLoaded() {
                                return this.imageAtlas && !!Object.keys(this.imageAtlas.patternPositions).length;
                            }
                            setExpiryData(Qe) {
                                const Wn = this.expirationTime;
                                if (Qe.cacheControl) {
                                    const Wn = rt.aa(Qe.cacheControl);
                                    Wn["max-age"] && (this.expirationTime = Date.now() + 1e3 * Wn["max-age"]);
                                } else Qe.expires && (this.expirationTime = new Date(Qe.expires).getTime());
                                if (this.expirationTime) {
                                    const Qe = Date.now();
                                    let rt = !1;
                                    if (this.expirationTime > Qe) rt = !1;
                                    else if (Wn) {
                                        if (this.expirationTime < Wn) rt = !0;
                                        else {
                                            const Co = this.expirationTime - Wn;
                                            Co ? this.expirationTime = Qe + Math.max(Co, 3e4) : rt = !0;
                                        }
                                    } else rt = !0;
                                    rt ? (this.expiredRequestCount++, this.state = "expired") : this.expiredRequestCount = 0;
                                }
                            }
                            getExpiryTimeout() {
                                if (this.expirationTime) return this.expiredRequestCount ? 1e3 * (1 << Math.min(this.expiredRequestCount - 1, 31)) : Math.min(this.expirationTime - (new Date).getTime(), Math.pow(2, 31) - 1);
                            }
                            setFeatureState(Qe, rt) {
                                if (!this.latestFeatureIndex || !this.latestFeatureIndex.rawTileData || 0 === Object.keys(Qe).length) return;
                                const Wn = this.latestFeatureIndex.loadVTLayers();
                                for(const Co in this.buckets){
                                    if (!rt.style.hasLayer(Co)) continue;
                                    const Dl = this.buckets[Co], Ll = Dl.layers[0].sourceLayer || "_geojsonTileLayer", Rl = Wn[Ll], Ul = Qe[Ll];
                                    if (!Rl || !Ul || 0 === Object.keys(Ul).length) continue;
                                    Dl.update(Ul, Rl, this.imageAtlas && this.imageAtlas.patternPositions || {});
                                    const Gl = rt && rt.style && rt.style.getLayer(Co);
                                    Gl && (this.queryPadding = Math.max(this.queryPadding, Gl.queryRadius(Dl)));
                                }
                            }
                            holdingForFade() {
                                return void 0 !== this.symbolFadeHoldUntil;
                            }
                            symbolFadeFinished() {
                                return !this.symbolFadeHoldUntil || this.symbolFadeHoldUntil < Ll.now();
                            }
                            clearFadeHold() {
                                this.symbolFadeHoldUntil = void 0;
                            }
                            setHoldDuration(Qe) {
                                this.symbolFadeHoldUntil = Ll.now() + Qe;
                            }
                            setDependencies(Qe, rt) {
                                const Wn = {};
                                for (const Co of rt)Wn[Co] = !0;
                                this.dependencies[Qe] = Wn;
                            }
                            hasDependency(Qe, rt) {
                                for (const Wn of Qe){
                                    const Qe = this.dependencies[Wn];
                                    if (Qe) {
                                        for (const Wn of rt)if (Qe[Wn]) return !0;
                                    }
                                }
                                return !1;
                            }
                        }
                        class se {
                            constructor(Qe, rt){
                                this.max = Qe, this.onRemove = rt, this.reset();
                            }
                            reset() {
                                for(const Qe in this.data)for (const rt of this.data[Qe])rt.timeout && clearTimeout(rt.timeout), this.onRemove(rt.value);
                                return this.data = {}, this.order = [], this;
                            }
                            add(Qe, rt, Wn) {
                                const Co = Qe.wrapped().key;
                                void 0 === this.data[Co] && (this.data[Co] = []);
                                const Dl = {
                                    value: rt,
                                    timeout: void 0
                                };
                                if (void 0 !== Wn && (Dl.timeout = setTimeout(()=>{
                                    this.remove(Qe, Dl);
                                }, Wn)), this.data[Co].push(Dl), this.order.push(Co), this.order.length > this.max) {
                                    const Qe = this._getAndRemoveByKey(this.order[0]);
                                    Qe && this.onRemove(Qe);
                                }
                                return this;
                            }
                            has(Qe) {
                                return Qe.wrapped().key in this.data;
                            }
                            getAndRemove(Qe) {
                                return this.has(Qe) ? this._getAndRemoveByKey(Qe.wrapped().key) : null;
                            }
                            _getAndRemoveByKey(Qe) {
                                const rt = this.data[Qe].shift();
                                return rt.timeout && clearTimeout(rt.timeout), 0 === this.data[Qe].length && delete this.data[Qe], this.order.splice(this.order.indexOf(Qe), 1), rt.value;
                            }
                            getByKey(Qe) {
                                const rt = this.data[Qe];
                                return rt ? rt[0].value : null;
                            }
                            get(Qe) {
                                return this.has(Qe) ? this.data[Qe.wrapped().key][0].value : null;
                            }
                            remove(Qe, rt) {
                                if (!this.has(Qe)) return this;
                                const Wn = Qe.wrapped().key, Co = void 0 === rt ? 0 : this.data[Wn].indexOf(rt), Dl = this.data[Wn][Co];
                                return this.data[Wn].splice(Co, 1), Dl.timeout && clearTimeout(Dl.timeout), 0 === this.data[Wn].length && delete this.data[Wn], this.onRemove(Dl.value), this.order.splice(this.order.indexOf(Wn), 1), this;
                            }
                            setMaxSize(Qe) {
                                for(this.max = Qe; this.order.length > this.max;){
                                    const Qe = this._getAndRemoveByKey(this.order[0]);
                                    Qe && this.onRemove(Qe);
                                }
                                return this;
                            }
                            filter(Qe) {
                                const rt = [];
                                for(const Wn in this.data)for (const Co of this.data[Wn])Qe(Co.value) || rt.push(Co);
                                for (const Wn of rt)this.remove(Wn.value.tileID, Wn);
                            }
                        }
                        class ne {
                            constructor(){
                                this.state = {}, this.stateChanges = {}, this.deletedStates = {};
                            }
                            updateState(Qe, Wn, Co) {
                                const Dl = String(Wn);
                                if (this.stateChanges[Qe] = this.stateChanges[Qe] || {}, this.stateChanges[Qe][Dl] = this.stateChanges[Qe][Dl] || {}, rt.e(this.stateChanges[Qe][Dl], Co), null === this.deletedStates[Qe]) {
                                    this.deletedStates[Qe] = {};
                                    for(const rt in this.state[Qe])rt !== Dl && (this.deletedStates[Qe][rt] = null);
                                } else if (this.deletedStates[Qe] && null === this.deletedStates[Qe][Dl]) {
                                    this.deletedStates[Qe][Dl] = {};
                                    for(const rt in this.state[Qe][Dl])Co[rt] || (this.deletedStates[Qe][Dl][rt] = null);
                                } else for(const rt in Co)this.deletedStates[Qe] && this.deletedStates[Qe][Dl] && null === this.deletedStates[Qe][Dl][rt] && delete this.deletedStates[Qe][Dl][rt];
                            }
                            removeFeatureState(Qe, rt, Wn) {
                                if (null === this.deletedStates[Qe]) return;
                                const Co = String(rt);
                                if (this.deletedStates[Qe] = this.deletedStates[Qe] || {}, Wn && void 0 !== rt) null !== this.deletedStates[Qe][Co] && (this.deletedStates[Qe][Co] = this.deletedStates[Qe][Co] || {}, this.deletedStates[Qe][Co][Wn] = null);
                                else if (void 0 !== rt) {
                                    if (this.stateChanges[Qe] && this.stateChanges[Qe][Co]) for(Wn in this.deletedStates[Qe][Co] = {}, this.stateChanges[Qe][Co])this.deletedStates[Qe][Co][Wn] = null;
                                    else this.deletedStates[Qe][Co] = null;
                                } else this.deletedStates[Qe] = null;
                            }
                            getState(Qe, Wn) {
                                const Co = String(Wn), Dl = rt.e({}, (this.state[Qe] || {})[Co], (this.stateChanges[Qe] || {})[Co]);
                                if (null === this.deletedStates[Qe]) return {};
                                if (this.deletedStates[Qe]) {
                                    const rt = this.deletedStates[Qe][Wn];
                                    if (null === rt) return {};
                                    for(const Qe in rt)delete Dl[Qe];
                                }
                                return Dl;
                            }
                            initializeTileState(Qe, rt) {
                                Qe.setFeatureState(this.state, rt);
                            }
                            coalesceChanges(Qe, Wn) {
                                const Co = {};
                                for(const Dl in this.stateChanges){
                                    this.state[Dl] = this.state[Dl] || {};
                                    const Qe = {};
                                    for(const Wn in this.stateChanges[Dl])this.state[Dl][Wn] || (this.state[Dl][Wn] = {}), rt.e(this.state[Dl][Wn], this.stateChanges[Dl][Wn]), Qe[Wn] = this.state[Dl][Wn];
                                    Co[Dl] = Qe;
                                }
                                for(const Dl in this.deletedStates){
                                    this.state[Dl] = this.state[Dl] || {};
                                    const Qe = {};
                                    if (null === this.deletedStates[Dl]) for(const rt in this.state[Dl])Qe[rt] = {}, this.state[Dl][rt] = {};
                                    else for(const rt in this.deletedStates[Dl]){
                                        if (null === this.deletedStates[Dl][rt]) this.state[Dl][rt] = {};
                                        else for (const Qe of Object.keys(this.deletedStates[Dl][rt]))delete this.state[Dl][rt][Qe];
                                        Qe[rt] = this.state[Dl][rt];
                                    }
                                    Co[Dl] = Co[Dl] || {}, rt.e(Co[Dl], Qe);
                                }
                                if (this.stateChanges = {}, this.deletedStates = {}, 0 !== Object.keys(Co).length) for(const rt in Qe)Qe[rt].setFeatureState(Co, Wn);
                            }
                        }
                        function le(Qe, rt, Wn) {
                            const Co = rt.intersectsFrustum(Qe);
                            if (!Wn) return Co;
                            const Dl = rt.intersectsPlane(Wn);
                            return 0 === Co || 0 === Dl ? 0 : 2 === Co && 2 === Dl ? 2 : 1;
                        }
                        function ce(Qe, Wn, Co, Dl, Ll) {
                            let Rl = Qe;
                            const Ul = Math.atan(Wn / Co), Gl = Math.hypot(Wn, Co);
                            return Rl = Qe + rt.ab(Dl / Gl / Math.max(.5, Math.cos(rt.ad(Ll / 2)))), Rl += 1 * rt.ab(Math.cos(Ul)) / 2, Rl += rt.ae(Qe - Rl, -0, 0), Rl;
                        }
                        function he(Qe, Wn) {
                            const Co = (Wn.roundZoom ? Math.round : Math.floor)(Qe.zoom + rt.ab(Qe.tileSize / Wn.tileSize));
                            return Math.max(0, Co);
                        }
                        function ue(Qe, Wn) {
                            const Co = Qe.getCameraFrustum(), Dl = Qe.getClippingPlane(), Ll = Qe.screenPointToMercatorCoordinate(Qe.getCameraPoint()), Rl = rt.$.fromLngLat(Qe.center, Qe.elevation);
                            Ll.z = Rl.z + Math.cos(Qe.pitchInRadians) * Qe.cameraToCenterDistance / Qe.worldSize;
                            const Ul = Qe.getCoveringTilesDetailsProvider(), Gl = Ul.allowVariableZoom(Qe, Wn), Zl = he(Qe, Wn), Hl = Wn.minzoom || 0, ql = void 0 !== Wn.maxzoom ? Wn.maxzoom : Qe.maxZoom, Ql = Math.min(Math.max(0, Zl), ql), Kl = Math.pow(2, Ql), $l = [
                                Kl * Ll.x,
                                Kl * Ll.y,
                                0
                            ], Tc = [
                                Kl * Rl.x,
                                Kl * Rl.y,
                                0
                            ], tu = Math.hypot(Rl.x - Ll.x, Rl.y - Ll.y), lu = Math.abs(Rl.z - Ll.z), du = Math.hypot(tu, lu), x = (Qe)=>({
                                    zoom: 0,
                                    x: 0,
                                    y: 0,
                                    wrap: Qe,
                                    fullyVisible: !1
                                }), fu = [], yu = [];
                            if (Qe.renderWorldCopies && Ul.allowWorldCopies()) for(let rt = 1; rt <= 3; rt++)fu.push(x(-rt)), fu.push(x(rt));
                            for(fu.push(x(0)); fu.length > 0;){
                                const Kl = fu.pop(), tu = Kl.x, Eu = Kl.y;
                                let Tu = Kl.fullyVisible;
                                const Lu = {
                                    x: tu,
                                    y: Eu,
                                    z: Kl.zoom
                                }, Zu = Ul.getTileAABB(Lu, Kl.wrap, Qe.elevation, Wn);
                                if (!Tu) {
                                    const Qe = le(Co, Zu, Dl);
                                    if (0 === Qe) continue;
                                    Tu = 2 === Qe;
                                }
                                const Xu = Ul.distanceToTile2d(Ll.x, Ll.y, Lu, Zu);
                                let Ju = Zl;
                                Gl && (Ju = (Wn.calculateTileZoom || ce)(Qe.zoom + rt.ab(Qe.tileSize / Wn.tileSize), Xu, lu, du, Qe.fov)), Ju = (Wn.roundZoom ? Math.round : Math.floor)(Ju), Ju = Math.max(0, Ju);
                                const $u = Math.min(Ju, ql);
                                if (Kl.wrap = Ul.getWrap(Rl, Lu, Kl.wrap), Kl.zoom >= $u) {
                                    if (Kl.zoom < Hl) continue;
                                    const Qe = Ql - Kl.zoom, Co = $l[0] - .5 - (tu << Qe), Dl = $l[1] - .5 - (Eu << Qe), Ll = Wn.reparseOverscaled ? Math.max(Kl.zoom, Ju) : Kl.zoom;
                                    yu.push({
                                        tileID: new rt.Y(Kl.zoom === ql ? Ll : Kl.zoom, Kl.wrap, Kl.zoom, tu, Eu),
                                        distanceSq: rt.ac([
                                            Tc[0] - .5 - tu,
                                            Tc[1] - .5 - Eu
                                        ]),
                                        tileDistanceToCamera: Math.sqrt(Co * Co + Dl * Dl)
                                    });
                                } else for(let Qe = 0; Qe < 4; Qe++)fu.push({
                                    zoom: Kl.zoom + 1,
                                    x: (tu << 1) + Qe % 2,
                                    y: (Eu << 1) + (Qe >> 1),
                                    wrap: Kl.wrap,
                                    fullyVisible: Tu
                                });
                            }
                            return yu.sort((Qe, rt)=>Qe.distanceSq - rt.distanceSq).map((Qe)=>Qe.tileID);
                        }
                        class de extends rt.E {
                            constructor(Qe, rt, Wn){
                                super(), this.id = Qe, this.dispatcher = Wn, this.on("data", (Qe)=>this._dataHandler(Qe)), this.on("dataloading", ()=>{
                                    this._sourceErrored = !1;
                                }), this.on("error", ()=>{
                                    this._sourceErrored = this._source.loaded();
                                }), this._source = ((Qe, rt, Wn, Co)=>{
                                    const Dl = new (ee(rt.type))(Qe, rt, Wn, Co);
                                    if (Dl.id !== Qe) throw new Error(`Expected Source id to be ${Qe} instead of ${Dl.id}`);
                                    return Dl;
                                })(Qe, rt, Wn, this), this._tiles = {}, this._cache = new se(0, (Qe)=>this._unloadTile(Qe)), this._timers = {}, this._cacheTimers = {}, this._maxTileCacheSize = null, this._maxTileCacheZoomLevels = null, this._loadedParentTiles = {}, this._coveredTiles = {}, this._state = new ne, this._didEmitContent = !1, this._updated = !1;
                            }
                            onAdd(Qe) {
                                this.map = Qe, this._maxTileCacheSize = Qe ? Qe._maxTileCacheSize : null, this._maxTileCacheZoomLevels = Qe ? Qe._maxTileCacheZoomLevels : null, this._source && this._source.onAdd && this._source.onAdd(Qe);
                            }
                            onRemove(Qe) {
                                this.clearTiles(), this._source && this._source.onRemove && this._source.onRemove(Qe);
                            }
                            loaded() {
                                if (this._sourceErrored) return !0;
                                if (!this._sourceLoaded) return !1;
                                if (!this._source.loaded()) return !1;
                                if (!(void 0 === this.used && void 0 === this.usedForTerrain || this.used || this.usedForTerrain)) return !0;
                                if (!this._updated) return !1;
                                for(const Qe in this._tiles){
                                    const rt = this._tiles[Qe];
                                    if ("loaded" !== rt.state && "errored" !== rt.state) return !1;
                                }
                                return !0;
                            }
                            getSource() {
                                return this._source;
                            }
                            pause() {
                                this._paused = !0;
                            }
                            resume() {
                                if (!this._paused) return;
                                const Qe = this._shouldReloadOnResume;
                                this._paused = !1, this._shouldReloadOnResume = !1, Qe && this.reload(), this.transform && this.update(this.transform, this.terrain);
                            }
                            _loadTile(Qe, Wn, Co) {
                                return rt._(this, void 0, void 0, function*() {
                                    try {
                                        yield this._source.loadTile(Qe), this._tileLoaded(Qe, Wn, Co);
                                    } catch (Wn) {
                                        Qe.state = "errored", 404 !== Wn.status ? this._source.fire(new rt.k(Wn, {
                                            tile: Qe
                                        })) : this.update(this.transform, this.terrain);
                                    }
                                });
                            }
                            _unloadTile(Qe) {
                                this._source.unloadTile && this._source.unloadTile(Qe);
                            }
                            _abortTile(Qe) {
                                this._source.abortTile && this._source.abortTile(Qe), this._source.fire(new rt.l("dataabort", {
                                    tile: Qe,
                                    coord: Qe.tileID,
                                    dataType: "source"
                                }));
                            }
                            serialize() {
                                return this._source.serialize();
                            }
                            prepare(Qe) {
                                this._source.prepare && this._source.prepare(), this._state.coalesceChanges(this._tiles, this.map ? this.map.painter : null);
                                for(const rt in this._tiles){
                                    const Wn = this._tiles[rt];
                                    Wn.upload(Qe), Wn.prepare(this.map.style.imageManager);
                                }
                            }
                            getIds() {
                                return Object.values(this._tiles).map((Qe)=>Qe.tileID).sort(_e).map((Qe)=>Qe.key);
                            }
                            getRenderableIds(Qe) {
                                const Wn = [];
                                for(const rt in this._tiles)this._isIdRenderable(rt, Qe) && Wn.push(this._tiles[rt]);
                                return Qe ? Wn.sort((Qe, Wn)=>{
                                    const Co = Qe.tileID, Dl = Wn.tileID, Ll = new rt.P(Co.canonical.x, Co.canonical.y)._rotate(-this.transform.bearingInRadians), Rl = new rt.P(Dl.canonical.x, Dl.canonical.y)._rotate(-this.transform.bearingInRadians);
                                    return Co.overscaledZ - Dl.overscaledZ || Rl.y - Ll.y || Rl.x - Ll.x;
                                }).map((Qe)=>Qe.tileID.key) : Wn.map((Qe)=>Qe.tileID).sort(_e).map((Qe)=>Qe.key);
                            }
                            hasRenderableParent(Qe) {
                                const rt = this.findLoadedParent(Qe, 0);
                                return !!rt && this._isIdRenderable(rt.tileID.key);
                            }
                            _isIdRenderable(Qe, rt) {
                                return this._tiles[Qe] && this._tiles[Qe].hasData() && !this._coveredTiles[Qe] && (rt || !this._tiles[Qe].holdingForFade());
                            }
                            reload(Qe) {
                                if (this._paused) this._shouldReloadOnResume = !0;
                                else {
                                    this._cache.reset();
                                    for(const rt in this._tiles)(Qe || "errored" !== this._tiles[rt].state) && this._reloadTile(rt, "reloading");
                                }
                            }
                            _reloadTile(Qe, Wn) {
                                return rt._(this, void 0, void 0, function*() {
                                    const rt = this._tiles[Qe];
                                    rt && ("loading" !== rt.state && (rt.state = Wn), yield this._loadTile(rt, Qe, Wn));
                                });
                            }
                            _tileLoaded(Qe, Wn, Co) {
                                Qe.timeAdded = Ll.now(), "expired" === Co && (Qe.refreshedUponExpiration = !0), this._setTileReloadTimer(Wn, Qe), "raster-dem" === this.getSource().type && Qe.dem && this._backfillDEM(Qe), this._state.initializeTileState(Qe, this.map ? this.map.painter : null), Qe.aborted || this._source.fire(new rt.l("data", {
                                    dataType: "source",
                                    tile: Qe,
                                    coord: Qe.tileID
                                }));
                            }
                            _backfillDEM(Qe) {
                                const rt = this.getRenderableIds();
                                for(let Wn = 0; Wn < rt.length; Wn++){
                                    const Co = rt[Wn];
                                    if (Qe.neighboringTiles && Qe.neighboringTiles[Co]) {
                                        const rt = this.getTileByID(Co);
                                        i(Qe, rt), i(rt, Qe);
                                    }
                                }
                                function i(Qe, rt) {
                                    Qe.needsHillshadePrepare = !0, Qe.needsTerrainPrepare = !0;
                                    let Wn = rt.tileID.canonical.x - Qe.tileID.canonical.x;
                                    const Co = rt.tileID.canonical.y - Qe.tileID.canonical.y, Dl = Math.pow(2, Qe.tileID.canonical.z), Ll = rt.tileID.key;
                                    0 === Wn && 0 === Co || Math.abs(Co) > 1 || (Math.abs(Wn) > 1 && (1 === Math.abs(Wn + Dl) ? Wn += Dl : 1 === Math.abs(Wn - Dl) && (Wn -= Dl)), rt.dem && Qe.dem && (Qe.dem.backfillBorder(rt.dem, Wn, Co), Qe.neighboringTiles && Qe.neighboringTiles[Ll] && (Qe.neighboringTiles[Ll].backfilled = !0)));
                                }
                            }
                            getTile(Qe) {
                                return this.getTileByID(Qe.key);
                            }
                            getTileByID(Qe) {
                                return this._tiles[Qe];
                            }
                            _retainLoadedChildren(Qe, rt, Wn, Co) {
                                for(const Dl in this._tiles){
                                    let Ll = this._tiles[Dl];
                                    if (Co[Dl] || !Ll.hasData() || Ll.tileID.overscaledZ <= rt || Ll.tileID.overscaledZ > Wn) continue;
                                    let Rl = Ll.tileID;
                                    for(; Ll && Ll.tileID.overscaledZ > rt + 1;){
                                        const Qe = Ll.tileID.scaledTo(Ll.tileID.overscaledZ - 1);
                                        Ll = this._tiles[Qe.key], Ll && Ll.hasData() && (Rl = Qe);
                                    }
                                    let Ul = Rl;
                                    for(; Ul.overscaledZ > rt;)if (Ul = Ul.scaledTo(Ul.overscaledZ - 1), Qe[Ul.key] || Qe[Ul.canonical.key]) {
                                        Co[Rl.key] = Rl;
                                        break;
                                    }
                                }
                            }
                            findLoadedParent(Qe, rt) {
                                if (Qe.key in this._loadedParentTiles) {
                                    const Wn = this._loadedParentTiles[Qe.key];
                                    return Wn && Wn.tileID.overscaledZ >= rt ? Wn : null;
                                }
                                for(let Wn = Qe.overscaledZ - 1; Wn >= rt; Wn--){
                                    const rt = Qe.scaledTo(Wn), Co = this._getLoadedTile(rt);
                                    if (Co) return Co;
                                }
                            }
                            findLoadedSibling(Qe) {
                                return this._getLoadedTile(Qe);
                            }
                            _getLoadedTile(Qe) {
                                const rt = this._tiles[Qe.key];
                                return rt && rt.hasData() ? rt : this._cache.getByKey(Qe.wrapped().key);
                            }
                            updateCacheSize(Qe) {
                                const Wn = Math.ceil(Qe.width / this._source.tileSize) + 1, Co = Math.ceil(Qe.height / this._source.tileSize) + 1, Dl = Math.floor(Wn * Co * (null === this._maxTileCacheZoomLevels ? rt.a.MAX_TILE_CACHE_ZOOM_LEVELS : this._maxTileCacheZoomLevels)), Ll = "number" == typeof this._maxTileCacheSize ? Math.min(this._maxTileCacheSize, Dl) : Dl;
                                this._cache.setMaxSize(Ll);
                            }
                            handleWrapJump(Qe) {
                                const rt = Math.round((Qe - (void 0 === this._prevLng ? Qe : this._prevLng)) / 360);
                                if (this._prevLng = Qe, rt) {
                                    const Qe = {};
                                    for(const Wn in this._tiles){
                                        const Co = this._tiles[Wn];
                                        Co.tileID = Co.tileID.unwrapTo(Co.tileID.wrap + rt), Qe[Co.tileID.key] = Co;
                                    }
                                    this._tiles = Qe;
                                    for(const rt in this._timers)clearTimeout(this._timers[rt]), delete this._timers[rt];
                                    for(const rt in this._tiles)this._setTileReloadTimer(rt, this._tiles[rt]);
                                }
                            }
                            _updateCoveredAndRetainedTiles(Qe, rt, Wn, Co, Dl, Rl) {
                                const Ul = {}, Gl = {}, Zl = Object.keys(Qe), Hl = Ll.now();
                                for (const Ll of Zl){
                                    const Wn = Qe[Ll], Co = this._tiles[Ll];
                                    if (!Co || 0 !== Co.fadeEndTime && Co.fadeEndTime <= Hl) continue;
                                    const Dl = this.findLoadedParent(Wn, rt), Rl = this.findLoadedSibling(Wn), Zl = Dl || Rl || null;
                                    Zl && (this._addTile(Zl.tileID), Ul[Zl.tileID.key] = Zl.tileID), Gl[Ll] = Wn;
                                }
                                this._retainLoadedChildren(Gl, Co, Wn, Qe);
                                for(const Ll in Ul)Qe[Ll] || (this._coveredTiles[Ll] = !0, Qe[Ll] = Ul[Ll]);
                                if (Rl) {
                                    const rt = {}, Wn = {};
                                    for (const Qe of Dl)this._tiles[Qe.key].hasData() ? rt[Qe.key] = Qe : Wn[Qe.key] = Qe;
                                    for(const Co in Wn){
                                        const Dl = Wn[Co].children(this._source.maxzoom);
                                        this._tiles[Dl[0].key] && this._tiles[Dl[1].key] && this._tiles[Dl[2].key] && this._tiles[Dl[3].key] && (rt[Dl[0].key] = Qe[Dl[0].key] = Dl[0], rt[Dl[1].key] = Qe[Dl[1].key] = Dl[1], rt[Dl[2].key] = Qe[Dl[2].key] = Dl[2], rt[Dl[3].key] = Qe[Dl[3].key] = Dl[3], delete Wn[Co]);
                                    }
                                    for(const Co in Wn){
                                        const Dl = Wn[Co], Ll = this.findLoadedParent(Dl, this._source.minzoom), Rl = this.findLoadedSibling(Dl), Ul = Ll || Rl || null;
                                        if (Ul) {
                                            rt[Ul.tileID.key] = Qe[Ul.tileID.key] = Ul.tileID;
                                            for(const Qe in rt)rt[Qe].isChildOf(Ul.tileID) && delete rt[Qe];
                                        }
                                    }
                                    for(const Qe in this._tiles)rt[Qe] || (this._coveredTiles[Qe] = !0);
                                }
                            }
                            update(Qe, Wn) {
                                if (!this._sourceLoaded || this._paused) return;
                                let Co;
                                this.transform = Qe, this.terrain = Wn, this.updateCacheSize(Qe), this.handleWrapJump(this.transform.center.lng), this._coveredTiles = {}, this.used || this.usedForTerrain ? this._source.tileID ? Co = Qe.getVisibleUnwrappedCoordinates(this._source.tileID).map((Qe)=>new rt.Y(Qe.canonical.z, Qe.wrap, Qe.canonical.z, Qe.canonical.x, Qe.canonical.y)) : (Co = ue(Qe, {
                                    tileSize: this.usedForTerrain ? this.tileSize : this._source.tileSize,
                                    minzoom: this._source.minzoom,
                                    maxzoom: this._source.maxzoom,
                                    roundZoom: !this.usedForTerrain && this._source.roundZoom,
                                    reparseOverscaled: this._source.reparseOverscaled,
                                    terrain: Wn,
                                    calculateTileZoom: this._source.calculateTileZoom
                                }), this._source.hasTile && (Co = Co.filter((Qe)=>this._source.hasTile(Qe)))) : Co = [];
                                const Dl = he(Qe, this._source), Ll = Math.max(Dl - de.maxOverzooming, this._source.minzoom), Rl = Math.max(Dl + de.maxUnderzooming, this._source.minzoom);
                                if (this.usedForTerrain) {
                                    const Qe = {};
                                    for (const rt of Co)if (rt.canonical.z > this._source.minzoom) {
                                        const Wn = rt.scaledTo(rt.canonical.z - 1);
                                        Qe[Wn.key] = Wn;
                                        const Co = rt.scaledTo(Math.max(this._source.minzoom, Math.min(rt.canonical.z, 5)));
                                        Qe[Co.key] = Co;
                                    }
                                    Co = Co.concat(Object.values(Qe));
                                }
                                const Ul = 0 === Co.length && !this._updated && this._didEmitContent;
                                this._updated = !0, Ul && this.fire(new rt.l("data", {
                                    sourceDataType: "idle",
                                    dataType: "source",
                                    sourceId: this.id
                                }));
                                const Gl = this._updateRetainedTiles(Co, Dl);
                                pe(this._source.type) && this._updateCoveredAndRetainedTiles(Gl, Ll, Rl, Dl, Co, Wn);
                                for(const rt in Gl)this._tiles[rt].clearFadeHold();
                                const Zl = rt.af(this._tiles, Gl);
                                for (const rt of Zl){
                                    const Qe = this._tiles[rt];
                                    Qe.hasSymbolBuckets && !Qe.holdingForFade() ? Qe.setHoldDuration(this.map._fadeDuration) : Qe.hasSymbolBuckets && !Qe.symbolFadeFinished() || this._removeTile(rt);
                                }
                                this._updateLoadedParentTileCache(), this._updateLoadedSiblingTileCache();
                            }
                            releaseSymbolFadeTiles() {
                                for(const Qe in this._tiles)this._tiles[Qe].holdingForFade() && this._removeTile(Qe);
                            }
                            _updateRetainedTiles(Qe, rt) {
                                var Wn;
                                const Co = {}, Dl = {}, Ll = Math.max(rt - de.maxOverzooming, this._source.minzoom), Rl = Math.max(rt + de.maxUnderzooming, this._source.minzoom), Ul = {};
                                for (const Gl of Qe){
                                    const Qe = this._addTile(Gl);
                                    Co[Gl.key] = Gl, Qe.hasData() || rt < this._source.maxzoom && (Ul[Gl.key] = Gl);
                                }
                                this._retainLoadedChildren(Ul, rt, Rl, Co);
                                for (const Gl of Qe){
                                    let Qe = this._tiles[Gl.key];
                                    if (Qe.hasData()) continue;
                                    if (rt + 1 > this._source.maxzoom) {
                                        const Qe = Gl.children(this._source.maxzoom)[0], rt = this.getTile(Qe);
                                        if (rt && rt.hasData()) {
                                            Co[Qe.key] = Qe;
                                            continue;
                                        }
                                    } else {
                                        const Qe = Gl.children(this._source.maxzoom);
                                        if (Co[Qe[0].key] && Co[Qe[1].key] && Co[Qe[2].key] && Co[Qe[3].key]) continue;
                                    }
                                    let Rl = Qe.wasRequested();
                                    for(let rt = Gl.overscaledZ - 1; rt >= Ll; --rt){
                                        const Ll = Gl.scaledTo(rt);
                                        if (Dl[Ll.key]) break;
                                        if (Dl[Ll.key] = !0, Qe = this.getTile(Ll), !Qe && Rl && (Qe = this._addTile(Ll)), Qe) {
                                            const rt = Qe.hasData();
                                            if ((rt || !(null === (Wn = this.map) || void 0 === Wn ? void 0 : Wn.cancelPendingTileRequestsWhileZooming) || Rl) && (Co[Ll.key] = Ll), Rl = Qe.wasRequested(), rt) break;
                                        }
                                    }
                                }
                                return Co;
                            }
                            _updateLoadedParentTileCache() {
                                this._loadedParentTiles = {};
                                for(const Qe in this._tiles){
                                    const rt = [];
                                    let Wn, Co = this._tiles[Qe].tileID;
                                    for(; Co.overscaledZ > 0;){
                                        if (Co.key in this._loadedParentTiles) {
                                            Wn = this._loadedParentTiles[Co.key];
                                            break;
                                        }
                                        rt.push(Co.key);
                                        const Qe = Co.scaledTo(Co.overscaledZ - 1);
                                        if (Wn = this._getLoadedTile(Qe), Wn) break;
                                        Co = Qe;
                                    }
                                    for (const Qe of rt)this._loadedParentTiles[Qe] = Wn;
                                }
                            }
                            _updateLoadedSiblingTileCache() {
                                this._loadedSiblingTiles = {};
                                for(const Qe in this._tiles){
                                    const rt = this._tiles[Qe].tileID, Wn = this._getLoadedTile(rt);
                                    this._loadedSiblingTiles[rt.key] = Wn;
                                }
                            }
                            _addTile(Qe) {
                                let Wn = this._tiles[Qe.key];
                                if (Wn) return Wn;
                                Wn = this._cache.getAndRemove(Qe), Wn && (this._setTileReloadTimer(Qe.key, Wn), Wn.tileID = Qe, this._state.initializeTileState(Wn, this.map ? this.map.painter : null), this._cacheTimers[Qe.key] && (clearTimeout(this._cacheTimers[Qe.key]), delete this._cacheTimers[Qe.key], this._setTileReloadTimer(Qe.key, Wn)));
                                const Co = Wn;
                                return Wn || (Wn = new ae(Qe, this._source.tileSize * Qe.overscaleFactor()), this._loadTile(Wn, Qe.key, Wn.state)), Wn.uses++, this._tiles[Qe.key] = Wn, Co || this._source.fire(new rt.l("dataloading", {
                                    tile: Wn,
                                    coord: Wn.tileID,
                                    dataType: "source"
                                })), Wn;
                            }
                            _setTileReloadTimer(Qe, rt) {
                                Qe in this._timers && (clearTimeout(this._timers[Qe]), delete this._timers[Qe]);
                                const Wn = rt.getExpiryTimeout();
                                Wn && (this._timers[Qe] = setTimeout(()=>{
                                    this._reloadTile(Qe, "expired"), delete this._timers[Qe];
                                }, Wn));
                            }
                            _removeTile(Qe) {
                                const rt = this._tiles[Qe];
                                rt && (rt.uses--, delete this._tiles[Qe], this._timers[Qe] && (clearTimeout(this._timers[Qe]), delete this._timers[Qe]), rt.uses > 0 || (rt.hasData() && "reloading" !== rt.state ? this._cache.add(rt.tileID, rt, rt.getExpiryTimeout()) : (rt.aborted = !0, this._abortTile(rt), this._unloadTile(rt))));
                            }
                            _dataHandler(Qe) {
                                const rt = Qe.sourceDataType;
                                "source" === Qe.dataType && "metadata" === rt && (this._sourceLoaded = !0), this._sourceLoaded && !this._paused && "source" === Qe.dataType && "content" === rt && (this.reload(Qe.sourceDataChanged), this.transform && this.update(this.transform, this.terrain), this._didEmitContent = !0);
                            }
                            clearTiles() {
                                this._shouldReloadOnResume = !1, this._paused = !1;
                                for(const Qe in this._tiles)this._removeTile(Qe);
                                this._cache.reset();
                            }
                            tilesIn(Qe, Wn, Co) {
                                const Dl = [], Ll = this.transform;
                                if (!Ll) return Dl;
                                const Rl = Co ? Ll.getCameraQueryGeometry(Qe) : Qe, Ul = Qe.map((Qe)=>Ll.screenPointToMercatorCoordinate(Qe, this.terrain)), Gl = Rl.map((Qe)=>Ll.screenPointToMercatorCoordinate(Qe, this.terrain)), Zl = this.getIds();
                                let Hl = 1 / 0, ql = 1 / 0, Ql = -1 / 0, Kl = -1 / 0;
                                for (const rt of Gl)Hl = Math.min(Hl, rt.x), ql = Math.min(ql, rt.y), Ql = Math.max(Ql, rt.x), Kl = Math.max(Kl, rt.y);
                                for(let $l = 0; $l < Zl.length; $l++){
                                    const Qe = this._tiles[Zl[$l]];
                                    if (Qe.holdingForFade()) continue;
                                    const Co = Qe.tileID, Rl = Math.pow(2, Ll.zoom - Qe.tileID.overscaledZ), Tc = Wn * Qe.queryPadding * rt.Z / Qe.tileSize / Rl, tu = [
                                        Co.getTilePoint(new rt.$(Hl, ql)),
                                        Co.getTilePoint(new rt.$(Ql, Kl))
                                    ];
                                    if (tu[0].x - Tc < rt.Z && tu[0].y - Tc < rt.Z && tu[1].x + Tc >= 0 && tu[1].y + Tc >= 0) {
                                        const rt = Ul.map((Qe)=>Co.getTilePoint(Qe)), Wn = Gl.map((Qe)=>Co.getTilePoint(Qe));
                                        Dl.push({
                                            tile: Qe,
                                            tileID: Co,
                                            queryGeometry: rt,
                                            cameraQueryGeometry: Wn,
                                            scale: Rl
                                        });
                                    }
                                }
                                return Dl;
                            }
                            getVisibleCoordinates(Qe) {
                                const rt = this.getRenderableIds(Qe).map((Qe)=>this._tiles[Qe].tileID);
                                return this.transform && this.transform.populateCache(rt), rt;
                            }
                            hasTransition() {
                                if (this._source.hasTransition()) return !0;
                                if (pe(this._source.type)) {
                                    const Qe = Ll.now();
                                    for(const rt in this._tiles)if (this._tiles[rt].fadeEndTime >= Qe) return !0;
                                }
                                return !1;
                            }
                            setFeatureState(Qe, rt, Wn) {
                                this._state.updateState(Qe = Qe || "_geojsonTileLayer", rt, Wn);
                            }
                            removeFeatureState(Qe, rt, Wn) {
                                this._state.removeFeatureState(Qe = Qe || "_geojsonTileLayer", rt, Wn);
                            }
                            getFeatureState(Qe, rt) {
                                return this._state.getState(Qe = Qe || "_geojsonTileLayer", rt);
                            }
                            setDependencies(Qe, rt, Wn) {
                                const Co = this._tiles[Qe];
                                Co && Co.setDependencies(rt, Wn);
                            }
                            reloadTilesForDependencies(Qe, rt) {
                                for(const Wn in this._tiles)this._tiles[Wn].hasDependency(Qe, rt) && this._reloadTile(Wn, "reloading");
                                this._cache.filter((Wn)=>!Wn.hasDependency(Qe, rt));
                            }
                        }
                        function _e(Qe, rt) {
                            const Wn = Math.abs(2 * Qe.wrap) - +(Qe.wrap < 0), Co = Math.abs(2 * rt.wrap) - +(rt.wrap < 0);
                            return Qe.overscaledZ - rt.overscaledZ || Co - Wn || rt.canonical.y - Qe.canonical.y || rt.canonical.x - Qe.canonical.x;
                        }
                        function pe(Qe) {
                            return "raster" === Qe || "image" === Qe || "video" === Qe;
                        }
                        de.maxOverzooming = 10, de.maxUnderzooming = 3;
                        class me {
                            constructor(Qe, rt){
                                this.reset(Qe, rt);
                            }
                            reset(Qe, rt) {
                                this.points = Qe || [], this._distances = [
                                    0
                                ];
                                for(let Wn = 1; Wn < this.points.length; Wn++)this._distances[Wn] = this._distances[Wn - 1] + this.points[Wn].dist(this.points[Wn - 1]);
                                this.length = this._distances[this._distances.length - 1], this.padding = Math.min(rt || 0, .5 * this.length), this.paddedLength = this.length - 2 * this.padding;
                            }
                            lerp(Qe) {
                                if (1 === this.points.length) return this.points[0];
                                Qe = rt.ae(Qe, 0, 1);
                                let Wn = 1, Co = this._distances[Wn];
                                const Dl = Qe * this.paddedLength + this.padding;
                                for(; Co < Dl && Wn < this._distances.length;)Co = this._distances[++Wn];
                                const Ll = Wn - 1, Rl = this._distances[Ll], Ul = Co - Rl, Gl = Ul > 0 ? (Dl - Rl) / Ul : 0;
                                return this.points[Ll].mult(1 - Gl).add(this.points[Wn].mult(Gl));
                            }
                        }
                        function fe(Qe, rt) {
                            let Wn = !0;
                            return "always" === Qe || "never" !== Qe && "never" !== rt || (Wn = !1), Wn;
                        }
                        class ge {
                            constructor(Qe, rt, Wn){
                                const Co = this.boxCells = [], Dl = this.circleCells = [];
                                this.xCellCount = Math.ceil(Qe / Wn), this.yCellCount = Math.ceil(rt / Wn);
                                for(let Ll = 0; Ll < this.xCellCount * this.yCellCount; Ll++)Co.push([]), Dl.push([]);
                                this.circleKeys = [], this.boxKeys = [], this.bboxes = [], this.circles = [], this.width = Qe, this.height = rt, this.xScale = this.xCellCount / Qe, this.yScale = this.yCellCount / rt, this.boxUid = 0, this.circleUid = 0;
                            }
                            keysLength() {
                                return this.boxKeys.length + this.circleKeys.length;
                            }
                            insert(Qe, rt, Wn, Co, Dl) {
                                this._forEachCell(rt, Wn, Co, Dl, this._insertBoxCell, this.boxUid++), this.boxKeys.push(Qe), this.bboxes.push(rt), this.bboxes.push(Wn), this.bboxes.push(Co), this.bboxes.push(Dl);
                            }
                            insertCircle(Qe, rt, Wn, Co) {
                                this._forEachCell(rt - Co, Wn - Co, rt + Co, Wn + Co, this._insertCircleCell, this.circleUid++), this.circleKeys.push(Qe), this.circles.push(rt), this.circles.push(Wn), this.circles.push(Co);
                            }
                            _insertBoxCell(Qe, rt, Wn, Co, Dl, Ll) {
                                this.boxCells[Dl].push(Ll);
                            }
                            _insertCircleCell(Qe, rt, Wn, Co, Dl, Ll) {
                                this.circleCells[Dl].push(Ll);
                            }
                            _query(Qe, rt, Wn, Co, Dl, Ll, Rl) {
                                if (Wn < 0 || Qe > this.width || Co < 0 || rt > this.height) return [];
                                const Ul = [];
                                if (Qe <= 0 && rt <= 0 && this.width <= Wn && this.height <= Co) {
                                    if (Dl) return [
                                        {
                                            key: null,
                                            x1: Qe,
                                            y1: rt,
                                            x2: Wn,
                                            y2: Co
                                        }
                                    ];
                                    for(let Qe = 0; Qe < this.boxKeys.length; Qe++)Ul.push({
                                        key: this.boxKeys[Qe],
                                        x1: this.bboxes[4 * Qe],
                                        y1: this.bboxes[4 * Qe + 1],
                                        x2: this.bboxes[4 * Qe + 2],
                                        y2: this.bboxes[4 * Qe + 3]
                                    });
                                    for(let Qe = 0; Qe < this.circleKeys.length; Qe++){
                                        const rt = this.circles[3 * Qe], Wn = this.circles[3 * Qe + 1], Co = this.circles[3 * Qe + 2];
                                        Ul.push({
                                            key: this.circleKeys[Qe],
                                            x1: rt - Co,
                                            y1: Wn - Co,
                                            x2: rt + Co,
                                            y2: Wn + Co
                                        });
                                    }
                                } else this._forEachCell(Qe, rt, Wn, Co, this._queryCell, Ul, {
                                    hitTest: Dl,
                                    overlapMode: Ll,
                                    seenUids: {
                                        box: {},
                                        circle: {}
                                    }
                                }, Rl);
                                return Ul;
                            }
                            query(Qe, rt, Wn, Co) {
                                return this._query(Qe, rt, Wn, Co, !1, null);
                            }
                            hitTest(Qe, rt, Wn, Co, Dl, Ll) {
                                return this._query(Qe, rt, Wn, Co, !0, Dl, Ll).length > 0;
                            }
                            hitTestCircle(Qe, rt, Wn, Co, Dl) {
                                const Ll = Qe - Wn, Rl = Qe + Wn, Ul = rt - Wn, Gl = rt + Wn;
                                if (Rl < 0 || Ll > this.width || Gl < 0 || Ul > this.height) return !1;
                                const Zl = [];
                                return this._forEachCell(Ll, Ul, Rl, Gl, this._queryCellCircle, Zl, {
                                    hitTest: !0,
                                    overlapMode: Co,
                                    circle: {
                                        x: Qe,
                                        y: rt,
                                        radius: Wn
                                    },
                                    seenUids: {
                                        box: {},
                                        circle: {}
                                    }
                                }, Dl), Zl.length > 0;
                            }
                            _queryCell(Qe, rt, Wn, Co, Dl, Ll, Rl, Ul) {
                                const { seenUids: Gl, hitTest: Zl, overlapMode: Hl } = Rl, ql = this.boxCells[Dl];
                                if (null !== ql) {
                                    const Dl = this.bboxes;
                                    for (const Rl of ql)if (!Gl.box[Rl]) {
                                        Gl.box[Rl] = !0;
                                        const ql = 4 * Rl, Ql = this.boxKeys[Rl];
                                        if (Qe <= Dl[ql + 2] && rt <= Dl[ql + 3] && Wn >= Dl[ql + 0] && Co >= Dl[ql + 1] && (!Ul || Ul(Ql)) && (!Zl || !fe(Hl, Ql.overlapMode)) && (Ll.push({
                                            key: Ql,
                                            x1: Dl[ql],
                                            y1: Dl[ql + 1],
                                            x2: Dl[ql + 2],
                                            y2: Dl[ql + 3]
                                        }), Zl)) return !0;
                                    }
                                }
                                const Ql = this.circleCells[Dl];
                                if (null !== Ql) {
                                    const Dl = this.circles;
                                    for (const Rl of Ql)if (!Gl.circle[Rl]) {
                                        Gl.circle[Rl] = !0;
                                        const ql = 3 * Rl, Ql = this.circleKeys[Rl];
                                        if (this._circleAndRectCollide(Dl[ql], Dl[ql + 1], Dl[ql + 2], Qe, rt, Wn, Co) && (!Ul || Ul(Ql)) && (!Zl || !fe(Hl, Ql.overlapMode))) {
                                            const Qe = Dl[ql], rt = Dl[ql + 1], Wn = Dl[ql + 2];
                                            if (Ll.push({
                                                key: Ql,
                                                x1: Qe - Wn,
                                                y1: rt - Wn,
                                                x2: Qe + Wn,
                                                y2: rt + Wn
                                            }), Zl) return !0;
                                        }
                                    }
                                }
                                return !1;
                            }
                            _queryCellCircle(Qe, rt, Wn, Co, Dl, Ll, Rl, Ul) {
                                const { circle: Gl, seenUids: Zl, overlapMode: Hl } = Rl, ql = this.boxCells[Dl];
                                if (null !== ql) {
                                    const Qe = this.bboxes;
                                    for (const rt of ql)if (!Zl.box[rt]) {
                                        Zl.box[rt] = !0;
                                        const Wn = 4 * rt, Co = this.boxKeys[rt];
                                        if (this._circleAndRectCollide(Gl.x, Gl.y, Gl.radius, Qe[Wn + 0], Qe[Wn + 1], Qe[Wn + 2], Qe[Wn + 3]) && (!Ul || Ul(Co)) && !fe(Hl, Co.overlapMode)) return Ll.push(!0), !0;
                                    }
                                }
                                const Ql = this.circleCells[Dl];
                                if (null !== Ql) {
                                    const Qe = this.circles;
                                    for (const rt of Ql)if (!Zl.circle[rt]) {
                                        Zl.circle[rt] = !0;
                                        const Wn = 3 * rt, Co = this.circleKeys[rt];
                                        if (this._circlesCollide(Qe[Wn], Qe[Wn + 1], Qe[Wn + 2], Gl.x, Gl.y, Gl.radius) && (!Ul || Ul(Co)) && !fe(Hl, Co.overlapMode)) return Ll.push(!0), !0;
                                    }
                                }
                            }
                            _forEachCell(Qe, rt, Wn, Co, Dl, Ll, Rl, Ul) {
                                const Gl = this._convertToXCellCoord(Qe), Zl = this._convertToYCellCoord(rt), Hl = this._convertToXCellCoord(Wn), ql = this._convertToYCellCoord(Co);
                                for(let Ql = Gl; Ql <= Hl; Ql++)for(let Gl = Zl; Gl <= ql; Gl++)if (Dl.call(this, Qe, rt, Wn, Co, this.xCellCount * Gl + Ql, Ll, Rl, Ul)) return;
                            }
                            _convertToXCellCoord(Qe) {
                                return Math.max(0, Math.min(this.xCellCount - 1, Math.floor(Qe * this.xScale)));
                            }
                            _convertToYCellCoord(Qe) {
                                return Math.max(0, Math.min(this.yCellCount - 1, Math.floor(Qe * this.yScale)));
                            }
                            _circlesCollide(Qe, rt, Wn, Co, Dl, Ll) {
                                const Rl = Co - Qe, Ul = Dl - rt, Gl = Wn + Ll;
                                return Gl * Gl > Rl * Rl + Ul * Ul;
                            }
                            _circleAndRectCollide(Qe, rt, Wn, Co, Dl, Ll, Rl) {
                                const Ul = (Ll - Co) / 2, Gl = Math.abs(Qe - (Co + Ul));
                                if (Gl > Ul + Wn) return !1;
                                const Zl = (Rl - Dl) / 2, Hl = Math.abs(rt - (Dl + Zl));
                                if (Hl > Zl + Wn) return !1;
                                if (Gl <= Ul || Hl <= Zl) return !0;
                                const ql = Gl - Ul, Ql = Hl - Zl;
                                return ql * ql + Ql * Ql <= Wn * Wn;
                            }
                        }
                        function ve(Qe, Wn, Co) {
                            const Dl = rt.K();
                            if (!Qe) {
                                const { vecSouth: Qe, vecEast: rt } = be(Wn), Co = r();
                                Co[0] = rt[0], Co[1] = rt[1], Co[2] = Qe[0], Co[3] = Qe[1], Ll = Co, (ql = (Ul = (Rl = Co)[0]) * (Hl = Rl[3]) - (Zl = Rl[2]) * (Gl = Rl[1])) && (Ll[0] = Hl * (ql = 1 / ql), Ll[1] = -Gl * ql, Ll[2] = -Zl * ql, Ll[3] = Ul * ql), Dl[0] = Co[0], Dl[1] = Co[1], Dl[4] = Co[2], Dl[5] = Co[3];
                            }
                            var Ll, Rl, Ul, Gl, Zl, Hl, ql;
                            return rt.M(Dl, Dl, [
                                1 / Co,
                                1 / Co,
                                1
                            ]), Dl;
                        }
                        function xe(Qe, Wn, Co, Dl) {
                            if (Qe) {
                                const Qe = rt.K();
                                if (!Wn) {
                                    const { vecSouth: rt, vecEast: Wn } = be(Co);
                                    Qe[0] = Wn[0], Qe[1] = Wn[1], Qe[4] = rt[0], Qe[5] = rt[1];
                                }
                                return rt.M(Qe, Qe, [
                                    Dl,
                                    Dl,
                                    1
                                ]), Qe;
                            }
                            return Co.pixelsToClipSpaceMatrix;
                        }
                        function be(Qe) {
                            const Wn = Math.cos(Qe.rollInRadians), Co = Math.sin(Qe.rollInRadians), Dl = Math.cos(Qe.pitchInRadians), Ll = Math.cos(Qe.bearingInRadians), Rl = Math.sin(Qe.bearingInRadians), Ul = rt.ak();
                            Ul[0] = -Ll * Dl * Co - Rl * Wn, Ul[1] = -Rl * Dl * Co + Ll * Wn;
                            const Gl = rt.al(Ul);
                            Gl < 1e-9 ? rt.am(Ul) : rt.an(Ul, Ul, 1 / Gl);
                            const Zl = rt.ak();
                            Zl[0] = Ll * Dl * Wn - Rl * Co, Zl[1] = Rl * Dl * Wn + Ll * Co;
                            const Hl = rt.al(Zl);
                            return Hl < 1e-9 ? rt.am(Zl) : rt.an(Zl, Zl, 1 / Hl), {
                                vecEast: Zl,
                                vecSouth: Ul
                            };
                        }
                        function ye(Qe, Wn, Co, Dl) {
                            let Ll;
                            Dl ? (Ll = [
                                Qe,
                                Wn,
                                Dl(Qe, Wn),
                                1
                            ], rt.ap(Ll, Ll, Co)) : (Ll = [
                                Qe,
                                Wn,
                                0,
                                1
                            ], Oe(Ll, Ll, Co));
                            const Rl = Ll[3];
                            return {
                                point: new rt.P(Ll[0] / Rl, Ll[1] / Rl),
                                signedDistanceFromCamera: Rl,
                                isOccluded: !1
                            };
                        }
                        function we(Qe, rt) {
                            return .5 + Qe / rt * .5;
                        }
                        function Te(Qe, rt) {
                            return Qe.x >= -rt[0] && Qe.x <= rt[0] && Qe.y >= -rt[1] && Qe.y <= rt[1];
                        }
                        function Pe(Qe, Wn, Co, Dl, Ll, Rl, Ul, Gl, Zl, Hl, ql, Ql, Kl) {
                            const $l = Co ? Qe.textSizeData : Qe.iconSizeData, Tc = rt.ag($l, Wn.transform.zoom), tu = [
                                256 / Wn.width * 2 + 1,
                                256 / Wn.height * 2 + 1
                            ], lu = Co ? Qe.text.dynamicLayoutVertexArray : Qe.icon.dynamicLayoutVertexArray;
                            lu.clear();
                            const du = Qe.lineVertexArray, fu = Co ? Qe.text.placedSymbolArray : Qe.icon.placedSymbolArray, yu = Wn.transform.width / Wn.transform.height;
                            let Eu = !1;
                            for(let Tu = 0; Tu < fu.length; Tu++){
                                const Co = fu.get(Tu);
                                if (Co.hidden || Co.writingMode === rt.ah.vertical && !Eu) {
                                    Be(Co.numGlyphs, lu);
                                    continue;
                                }
                                Eu = !1;
                                const Lu = new rt.P(Co.anchorX, Co.anchorY), Zu = {
                                    getElevation: Kl,
                                    pitchedLabelPlaneMatrix: Dl,
                                    lineVertexArray: du,
                                    pitchWithMap: Rl,
                                    projectionCache: {
                                        projections: {},
                                        offsets: {},
                                        cachedAnchorPoint: void 0,
                                        anyProjectionOccluded: !1
                                    },
                                    transform: Wn.transform,
                                    tileAnchorPoint: Lu,
                                    unwrappedTileID: Zl,
                                    width: Hl,
                                    height: ql,
                                    translation: Ql
                                }, Xu = ze(Co.anchorX, Co.anchorY, Zu);
                                if (!Te(Xu.point, tu)) {
                                    Be(Co.numGlyphs, lu);
                                    continue;
                                }
                                const Ju = we(Wn.transform.cameraToCenterDistance, Xu.signedDistanceFromCamera), $u = rt.ai($l, Tc, Co), ed = Rl ? $u * Wn.transform.getPitchedTextCorrection(Co.anchorX, Co.anchorY, Zl) / Ju : $u * Ju, td = Me({
                                    projectionContext: Zu,
                                    pitchedLabelPlaneMatrixInverse: Ll,
                                    symbol: Co,
                                    fontSize: ed,
                                    flip: !1,
                                    keepUpright: Ul,
                                    glyphOffsetArray: Qe.glyphOffsetArray,
                                    dynamicLayoutVertexArray: lu,
                                    aspectRatio: yu,
                                    rotateToLine: Gl
                                });
                                Eu = td.useVertical, (td.notEnoughRoom || Eu || td.needsFlipping && Me({
                                    projectionContext: Zu,
                                    pitchedLabelPlaneMatrixInverse: Ll,
                                    symbol: Co,
                                    fontSize: ed,
                                    flip: !0,
                                    keepUpright: Ul,
                                    glyphOffsetArray: Qe.glyphOffsetArray,
                                    dynamicLayoutVertexArray: lu,
                                    aspectRatio: yu,
                                    rotateToLine: Gl
                                }).notEnoughRoom) && Be(Co.numGlyphs, lu);
                            }
                            Co ? Qe.text.dynamicLayoutVertexBuffer.updateData(lu) : Qe.icon.dynamicLayoutVertexBuffer.updateData(lu);
                        }
                        function Ce(Qe, rt, Wn, Co, Dl, Ll, Rl, Ul) {
                            const Gl = Ll.glyphStartIndex + Ll.numGlyphs, Zl = Ll.lineStartIndex, Hl = Ll.lineStartIndex + Ll.lineLength, ql = rt.getoffsetX(Ll.glyphStartIndex), Ql = rt.getoffsetX(Gl - 1), Kl = ke(Qe * ql, Wn, Co, Dl, Ll.segment, Zl, Hl, Ul, Rl);
                            if (!Kl) return null;
                            const $l = ke(Qe * Ql, Wn, Co, Dl, Ll.segment, Zl, Hl, Ul, Rl);
                            return $l ? Ul.projectionCache.anyProjectionOccluded ? null : {
                                first: Kl,
                                last: $l
                            } : null;
                        }
                        function Ie(Qe, Wn, Co, Dl) {
                            return Qe === rt.ah.horizontal && Math.abs(Co.y - Wn.y) > Math.abs(Co.x - Wn.x) * Dl ? {
                                useVertical: !0
                            } : (Qe === rt.ah.vertical ? Wn.y < Co.y : Wn.x > Co.x) ? {
                                needsFlipping: !0
                            } : null;
                        }
                        function Me(Qe) {
                            const { projectionContext: Wn, pitchedLabelPlaneMatrixInverse: Co, symbol: Dl, fontSize: Ll, flip: Rl, keepUpright: Ul, glyphOffsetArray: Gl, dynamicLayoutVertexArray: Zl, aspectRatio: Hl, rotateToLine: ql } = Qe, Ql = Ll / 24, Kl = Dl.lineOffsetX * Ql, $l = Dl.lineOffsetY * Ql;
                            let Tc;
                            if (Dl.numGlyphs > 1) {
                                const Qe = Dl.glyphStartIndex + Dl.numGlyphs, rt = Dl.lineStartIndex, Ll = Dl.lineStartIndex + Dl.lineLength, Zl = Ce(Ql, Gl, Kl, $l, Rl, Dl, ql, Wn);
                                if (!Zl) return {
                                    notEnoughRoom: !0
                                };
                                const tu = De(Zl.first.point.x, Zl.first.point.y, Wn, Co), lu = De(Zl.last.point.x, Zl.last.point.y, Wn, Co);
                                if (Ul && !Rl) {
                                    const Qe = Ie(Dl.writingMode, tu, lu, Hl);
                                    if (Qe) return Qe;
                                }
                                Tc = [
                                    Zl.first
                                ];
                                for(let Co = Dl.glyphStartIndex + 1; Co < Qe - 1; Co++)Tc.push(ke(Ql * Gl.getoffsetX(Co), Kl, $l, Rl, Dl.segment, rt, Ll, Wn, ql));
                                Tc.push(Zl.last);
                            } else {
                                if (Ul && !Rl) {
                                    const Qe = Re(Wn.tileAnchorPoint.x, Wn.tileAnchorPoint.y, Wn).point, Ll = Dl.lineStartIndex + Dl.segment + 1, Rl = new rt.P(Wn.lineVertexArray.getx(Ll), Wn.lineVertexArray.gety(Ll)), Ul = Re(Rl.x, Rl.y, Wn), Gl = Ul.signedDistanceFromCamera > 0 ? Ul.point : Ee(Wn.tileAnchorPoint, Rl, Qe, 1, Wn), Zl = De(Qe.x, Qe.y, Wn, Co), ql = De(Gl.x, Gl.y, Wn, Co), Ql = Ie(Dl.writingMode, Zl, ql, Hl);
                                    if (Ql) return Ql;
                                }
                                const Qe = ke(Ql * Gl.getoffsetX(Dl.glyphStartIndex), Kl, $l, Rl, Dl.segment, Dl.lineStartIndex, Dl.lineStartIndex + Dl.lineLength, Wn, ql);
                                if (!Qe || Wn.projectionCache.anyProjectionOccluded) return {
                                    notEnoughRoom: !0
                                };
                                Tc = [
                                    Qe
                                ];
                            }
                            for (const tu of Tc)rt.ao(Zl, tu.point, tu.angle);
                            return {};
                        }
                        function Ee(Qe, rt, Wn, Co, Dl) {
                            const Ll = Qe.add(Qe.sub(rt)._unit()), Rl = Re(Ll.x, Ll.y, Dl).point, Ul = Wn.sub(Rl);
                            return Wn.add(Ul._mult(Co / Ul.mag()));
                        }
                        function Se(Qe, Wn, Co) {
                            const Dl = Wn.projectionCache;
                            if (Dl.projections[Qe]) return Dl.projections[Qe];
                            const Ll = new rt.P(Wn.lineVertexArray.getx(Qe), Wn.lineVertexArray.gety(Qe)), Rl = Re(Ll.x, Ll.y, Wn);
                            if (Rl.signedDistanceFromCamera > 0) return Dl.projections[Qe] = Rl.point, Dl.anyProjectionOccluded = Dl.anyProjectionOccluded || Rl.isOccluded, Rl.point;
                            const Ul = Qe - Co.direction;
                            return Ee(0 === Co.distanceFromAnchor ? Wn.tileAnchorPoint : new rt.P(Wn.lineVertexArray.getx(Ul), Wn.lineVertexArray.gety(Ul)), Ll, Co.previousVertex, Co.absOffsetX - Co.distanceFromAnchor + 1, Wn);
                        }
                        function Re(Qe, rt, Wn) {
                            const Co = Qe + Wn.translation[0], Dl = rt + Wn.translation[1];
                            let Ll;
                            return Wn.pitchWithMap ? (Ll = ye(Co, Dl, Wn.pitchedLabelPlaneMatrix, Wn.getElevation), Ll.isOccluded = !1) : (Ll = Wn.transform.projectTileCoordinates(Co, Dl, Wn.unwrappedTileID, Wn.getElevation), Ll.point.x = (.5 * Ll.point.x + .5) * Wn.width, Ll.point.y = (.5 * -Ll.point.y + .5) * Wn.height), Ll;
                        }
                        function De(Qe, Wn, Co, Dl) {
                            if (Co.pitchWithMap) {
                                const Ll = [
                                    Qe,
                                    Wn,
                                    0,
                                    1
                                ];
                                return rt.ap(Ll, Ll, Dl), Co.transform.projectTileCoordinates(Ll[0] / Ll[3], Ll[1] / Ll[3], Co.unwrappedTileID, Co.getElevation).point;
                            }
                            return {
                                x: Qe / Co.width * 2 - 1,
                                y: Wn / Co.height * 2 - 1
                            };
                        }
                        function ze(Qe, rt, Wn) {
                            return Wn.transform.projectTileCoordinates(Qe, rt, Wn.unwrappedTileID, Wn.getElevation);
                        }
                        function Ae(Qe, rt, Wn) {
                            return Qe._unit()._perp()._mult(rt * Wn);
                        }
                        function Le(Qe, Wn, Co, Dl, Ll, Rl, Ul, Gl, Zl) {
                            if (Gl.projectionCache.offsets[Qe]) return Gl.projectionCache.offsets[Qe];
                            const Hl = Co.add(Wn);
                            if (Qe + Zl.direction < Dl || Qe + Zl.direction >= Ll) return Gl.projectionCache.offsets[Qe] = Hl, Hl;
                            const ql = Se(Qe + Zl.direction, Gl, Zl), Ql = Ae(ql.sub(Co), Ul, Zl.direction), Kl = Co.add(Ql), $l = ql.add(Ql);
                            return Gl.projectionCache.offsets[Qe] = rt.aq(Rl, Hl, Kl, $l) || Hl, Gl.projectionCache.offsets[Qe];
                        }
                        function ke(Qe, rt, Wn, Co, Dl, Ll, Rl, Ul, Gl) {
                            const Zl = Co ? Qe - rt : Qe + rt;
                            let Hl = Zl > 0 ? 1 : -1, ql = 0;
                            Co && (Hl *= -1, ql = Math.PI), Hl < 0 && (ql += Math.PI);
                            let Ql, Kl = Hl > 0 ? Ll + Dl : Ll + Dl + 1;
                            Ul.projectionCache.cachedAnchorPoint ? Ql = Ul.projectionCache.cachedAnchorPoint : (Ql = Re(Ul.tileAnchorPoint.x, Ul.tileAnchorPoint.y, Ul).point, Ul.projectionCache.cachedAnchorPoint = Ql);
                            let $l, Tc, tu = Ql, lu = Ql, du = 0, fu = 0;
                            const yu = Math.abs(Zl), Eu = [];
                            let Tu;
                            for(; du + fu <= yu;){
                                if (Kl += Hl, Kl < Ll || Kl >= Rl) return null;
                                du += fu, lu = tu, Tc = $l;
                                const Qe = {
                                    absOffsetX: yu,
                                    direction: Hl,
                                    distanceFromAnchor: du,
                                    previousVertex: lu
                                };
                                if (tu = Se(Kl, Ul, Qe), 0 === Wn) Eu.push(lu), Tu = tu.sub(lu);
                                else {
                                    let rt;
                                    const Co = tu.sub(lu);
                                    rt = 0 === Co.mag() ? Ae(Se(Kl + Hl, Ul, Qe).sub(tu), Wn, Hl) : Ae(Co, Wn, Hl), Tc || (Tc = lu.add(rt)), $l = Le(Kl, rt, tu, Ll, Rl, Tc, Wn, Ul, Qe), Eu.push(Tc), Tu = $l.sub(Tc);
                                }
                                fu = Tu.mag();
                            }
                            const Lu = Tu._mult((yu - du) / fu)._add(Tc || lu), Zu = ql + Math.atan2(tu.y - lu.y, tu.x - lu.x);
                            return Eu.push(Lu), {
                                point: Lu,
                                angle: Gl ? Zu : 0,
                                path: Eu
                            };
                        }
                        const Tu = new Float32Array([
                            -1 / 0,
                            -1 / 0,
                            0,
                            -1 / 0,
                            -1 / 0,
                            0,
                            -1 / 0,
                            -1 / 0,
                            0,
                            -1 / 0,
                            -1 / 0,
                            0
                        ]);
                        function Be(Qe, rt) {
                            for(let Wn = 0; Wn < Qe; Wn++){
                                const Qe = rt.length;
                                rt.resize(Qe + 4), rt.float32.set(Tu, 3 * Qe);
                            }
                        }
                        function Oe(Qe, rt, Wn) {
                            const Co = rt[0], Dl = rt[1];
                            return Qe[0] = Wn[0] * Co + Wn[4] * Dl + Wn[12], Qe[1] = Wn[1] * Co + Wn[5] * Dl + Wn[13], Qe[3] = Wn[3] * Co + Wn[7] * Dl + Wn[15], Qe;
                        }
                        const Lu = 100;
                        class Ze {
                            constructor(Qe, rt = new ge(Qe.width + 200, Qe.height + 200, 25), Wn = new ge(Qe.width + 200, Qe.height + 200, 25)){
                                this.transform = Qe, this.grid = rt, this.ignoredGrid = Wn, this.pitchFactor = Math.cos(Qe.pitch * Math.PI / 180) * Qe.cameraToCenterDistance, this.screenRightBoundary = Qe.width + Lu, this.screenBottomBoundary = Qe.height + Lu, this.gridRightBoundary = Qe.width + 200, this.gridBottomBoundary = Qe.height + 200, this.perspectiveRatioCutoff = .6;
                            }
                            placeCollisionBox(Qe, rt, Wn, Co, Dl, Ll, Rl, Ul, Gl, Zl, Hl, ql) {
                                const Ql = this.projectAndGetPerspectiveRatio(Qe.anchorPointX + Ul[0], Qe.anchorPointY + Ul[1], Dl, Zl, ql), Kl = Wn * Ql.perspectiveRatio;
                                let $l;
                                if (Ll || Rl) $l = this._projectCollisionBox(Qe, Kl, Co, Dl, Ll, Rl, Ul, Ql, Zl, Hl, ql);
                                else {
                                    const rt = Ql.x + (Hl ? Hl.x * Kl : 0), Wn = Ql.y + (Hl ? Hl.y * Kl : 0);
                                    $l = {
                                        allPointsOccluded: !1,
                                        box: [
                                            rt + Qe.x1 * Kl,
                                            Wn + Qe.y1 * Kl,
                                            rt + Qe.x2 * Kl,
                                            Wn + Qe.y2 * Kl
                                        ]
                                    };
                                }
                                const [Tc, tu, lu, du] = $l.box, fu = Ll ? $l.allPointsOccluded : Ql.isOccluded;
                                let yu = fu;
                                return yu || (yu = Ql.perspectiveRatio < this.perspectiveRatioCutoff), yu || (yu = !this.isInsideGrid(Tc, tu, lu, du)), yu || "always" !== rt && this.grid.hitTest(Tc, tu, lu, du, rt, Gl) ? {
                                    box: [
                                        Tc,
                                        tu,
                                        lu,
                                        du
                                    ],
                                    placeable: !1,
                                    offscreen: !1,
                                    occluded: fu
                                } : {
                                    box: [
                                        Tc,
                                        tu,
                                        lu,
                                        du
                                    ],
                                    placeable: !0,
                                    offscreen: this.isOffscreen(Tc, tu, lu, du),
                                    occluded: fu
                                };
                            }
                            placeCollisionCircles(Qe, Wn, Co, Dl, Ll, Rl, Ul, Gl, Zl, Hl, ql, Ql, Kl, $l) {
                                const Tc = [], tu = new rt.P(Wn.anchorX, Wn.anchorY), lu = this.getPerspectiveRatio(tu.x, tu.y, Rl, $l), du = (Zl ? Ll * this.transform.getPitchedTextCorrection(Wn.anchorX, Wn.anchorY, Rl) / lu : Ll * lu) / rt.av, fu = {
                                    getElevation: $l,
                                    pitchedLabelPlaneMatrix: Ul,
                                    lineVertexArray: Co,
                                    pitchWithMap: Zl,
                                    projectionCache: {
                                        projections: {},
                                        offsets: {},
                                        cachedAnchorPoint: void 0,
                                        anyProjectionOccluded: !1
                                    },
                                    transform: this.transform,
                                    tileAnchorPoint: tu,
                                    unwrappedTileID: Rl,
                                    width: this.transform.width,
                                    height: this.transform.height,
                                    translation: Kl
                                }, yu = Ce(du, Dl, Wn.lineOffsetX * du, Wn.lineOffsetY * du, !1, Wn, !1, fu);
                                let Eu = !1, Tu = !1, Zu = !0;
                                if (yu) {
                                    const Wn = .5 * ql * lu + Ql, Co = new rt.P(-100, -100), Dl = new rt.P(this.screenRightBoundary, this.screenBottomBoundary), Ll = new me, Rl = yu.first, Ul = yu.last;
                                    let Kl = [];
                                    for(let Qe = Rl.path.length - 1; Qe >= 1; Qe--)Kl.push(Rl.path[Qe]);
                                    for(let Qe = 1; Qe < Ul.path.length; Qe++)Kl.push(Ul.path[Qe]);
                                    const $l = 2.5 * Wn;
                                    if (Zl) {
                                        const Qe = this.projectPathToScreenSpace(Kl, fu);
                                        Kl = Qe.some((Qe)=>Qe.signedDistanceFromCamera <= 0) ? [] : Qe.map((Qe)=>Qe.point);
                                    }
                                    let tu = [];
                                    if (Kl.length > 0) {
                                        const Qe = Kl[0].clone(), Wn = Kl[0].clone();
                                        for(let rt = 1; rt < Kl.length; rt++)Qe.x = Math.min(Qe.x, Kl[rt].x), Qe.y = Math.min(Qe.y, Kl[rt].y), Wn.x = Math.max(Wn.x, Kl[rt].x), Wn.y = Math.max(Wn.y, Kl[rt].y);
                                        tu = Qe.x >= Co.x && Wn.x <= Dl.x && Qe.y >= Co.y && Wn.y <= Dl.y ? [
                                            Kl
                                        ] : Wn.x < Co.x || Qe.x > Dl.x || Wn.y < Co.y || Qe.y > Dl.y ? [] : rt.ar([
                                            Kl
                                        ], Co.x, Co.y, Dl.x, Dl.y);
                                    }
                                    for (const rt of tu){
                                        Ll.reset(rt, .25 * Wn);
                                        let Co = 0;
                                        Co = Ll.length <= .5 * Wn ? 1 : Math.ceil(Ll.paddedLength / $l) + 1;
                                        for(let rt = 0; rt < Co; rt++){
                                            const Dl = rt / Math.max(Co - 1, 1), Rl = Ll.lerp(Dl), Ul = Rl.x + Lu, Zl = Rl.y + Lu;
                                            Tc.push(Ul, Zl, Wn, 0);
                                            const ql = Ul - Wn, Ql = Zl - Wn, Kl = Ul + Wn, $l = Zl + Wn;
                                            if (Zu = Zu && this.isOffscreen(ql, Ql, Kl, $l), Tu = Tu || this.isInsideGrid(ql, Ql, Kl, $l), "always" !== Qe && this.grid.hitTestCircle(Ul, Zl, Wn, Qe, Hl) && (Eu = !0, !Gl)) return {
                                                circles: [],
                                                offscreen: !1,
                                                collisionDetected: Eu
                                            };
                                        }
                                    }
                                }
                                return {
                                    circles: !Gl && Eu || !Tu || lu < this.perspectiveRatioCutoff ? [] : Tc,
                                    offscreen: Zu,
                                    collisionDetected: Eu
                                };
                            }
                            projectPathToScreenSpace(Qe, Wn) {
                                const Co = function(Qe, Wn) {
                                    const Co = rt.K();
                                    return rt.aj(Co, Wn.pitchedLabelPlaneMatrix), Qe.map((Qe)=>{
                                        const rt = ye(Qe.x, Qe.y, Co, Wn.getElevation), Dl = Wn.transform.projectTileCoordinates(rt.point.x, rt.point.y, Wn.unwrappedTileID, Wn.getElevation);
                                        return Dl.point.x = (.5 * Dl.point.x + .5) * Wn.width, Dl.point.y = (.5 * -Dl.point.y + .5) * Wn.height, Dl;
                                    });
                                }(Qe, Wn);
                                return function(Qe) {
                                    let rt = 0, Wn = 0, Co = 0, Dl = 0;
                                    for(let Ll = 0; Ll < Qe.length; Ll++)Qe[Ll].isOccluded ? (Co = Ll + 1, Dl = 0) : (Dl++, Dl > Wn && (Wn = Dl, rt = Co));
                                    return Qe.slice(rt, rt + Wn);
                                }(Co);
                            }
                            queryRenderedSymbols(Qe) {
                                if (0 === Qe.length || 0 === this.grid.keysLength() && 0 === this.ignoredGrid.keysLength()) return {};
                                const Wn = [];
                                let Co = 1 / 0, Dl = 1 / 0, Ll = -1 / 0, Rl = -1 / 0;
                                for (const Hl of Qe){
                                    const Qe = new rt.P(Hl.x + Lu, Hl.y + Lu);
                                    Co = Math.min(Co, Qe.x), Dl = Math.min(Dl, Qe.y), Ll = Math.max(Ll, Qe.x), Rl = Math.max(Rl, Qe.y), Wn.push(Qe);
                                }
                                const Ul = this.grid.query(Co, Dl, Ll, Rl).concat(this.ignoredGrid.query(Co, Dl, Ll, Rl)), Gl = {}, Zl = {};
                                for (const Hl of Ul){
                                    const Qe = Hl.key;
                                    if (void 0 === Gl[Qe.bucketInstanceId] && (Gl[Qe.bucketInstanceId] = {}), Gl[Qe.bucketInstanceId][Qe.featureIndex]) continue;
                                    const Co = [
                                        new rt.P(Hl.x1, Hl.y1),
                                        new rt.P(Hl.x2, Hl.y1),
                                        new rt.P(Hl.x2, Hl.y2),
                                        new rt.P(Hl.x1, Hl.y2)
                                    ];
                                    rt.as(Wn, Co) && (Gl[Qe.bucketInstanceId][Qe.featureIndex] = !0, void 0 === Zl[Qe.bucketInstanceId] && (Zl[Qe.bucketInstanceId] = []), Zl[Qe.bucketInstanceId].push(Qe.featureIndex));
                                }
                                return Zl;
                            }
                            insertCollisionBox(Qe, rt, Wn, Co, Dl, Ll) {
                                (Wn ? this.ignoredGrid : this.grid).insert({
                                    bucketInstanceId: Co,
                                    featureIndex: Dl,
                                    collisionGroupID: Ll,
                                    overlapMode: rt
                                }, Qe[0], Qe[1], Qe[2], Qe[3]);
                            }
                            insertCollisionCircles(Qe, rt, Wn, Co, Dl, Ll) {
                                const Rl = Wn ? this.ignoredGrid : this.grid, Ul = {
                                    bucketInstanceId: Co,
                                    featureIndex: Dl,
                                    collisionGroupID: Ll,
                                    overlapMode: rt
                                };
                                for(let Gl = 0; Gl < Qe.length; Gl += 4)Rl.insertCircle(Ul, Qe[Gl], Qe[Gl + 1], Qe[Gl + 2]);
                            }
                            projectAndGetPerspectiveRatio(Qe, Wn, Co, Dl, Ll) {
                                if (Ll) {
                                    let Co;
                                    Dl ? (Co = [
                                        Qe,
                                        Wn,
                                        Dl(Qe, Wn),
                                        1
                                    ], rt.ap(Co, Co, Ll)) : (Co = [
                                        Qe,
                                        Wn,
                                        0,
                                        1
                                    ], Oe(Co, Co, Ll));
                                    const Rl = Co[3];
                                    return {
                                        x: (Co[0] / Rl + 1) / 2 * this.transform.width + Lu,
                                        y: (-Co[1] / Rl + 1) / 2 * this.transform.height + Lu,
                                        perspectiveRatio: .5 + this.transform.cameraToCenterDistance / Rl * .5,
                                        isOccluded: !1,
                                        signedDistanceFromCamera: Rl
                                    };
                                }
                                {
                                    const rt = this.transform.projectTileCoordinates(Qe, Wn, Co, Dl);
                                    return {
                                        x: (rt.point.x + 1) / 2 * this.transform.width + Lu,
                                        y: (1 - rt.point.y) / 2 * this.transform.height + Lu,
                                        perspectiveRatio: .5 + this.transform.cameraToCenterDistance / rt.signedDistanceFromCamera * .5,
                                        isOccluded: rt.isOccluded,
                                        signedDistanceFromCamera: rt.signedDistanceFromCamera
                                    };
                                }
                            }
                            getPerspectiveRatio(Qe, rt, Wn, Co) {
                                const Dl = this.transform.projectTileCoordinates(Qe, rt, Wn, Co);
                                return .5 + this.transform.cameraToCenterDistance / Dl.signedDistanceFromCamera * .5;
                            }
                            isOffscreen(Qe, rt, Wn, Co) {
                                return Wn < Lu || Qe >= this.screenRightBoundary || Co < Lu || rt > this.screenBottomBoundary;
                            }
                            isInsideGrid(Qe, rt, Wn, Co) {
                                return Wn >= 0 && Qe < this.gridRightBoundary && Co >= 0 && rt < this.gridBottomBoundary;
                            }
                            getViewportMatrix() {
                                const Qe = rt.at([]);
                                return rt.L(Qe, Qe, [
                                    -100,
                                    -100,
                                    0
                                ]), Qe;
                            }
                            _projectCollisionBox(Qe, Wn, Co, Dl, Ll, Rl, Ul, Gl, Zl, Hl, ql) {
                                let Ql = 1, Kl = 0, $l = 0, Tc = 1;
                                const tu = Qe.anchorPointX + Ul[0], lu = Qe.anchorPointY + Ul[1];
                                if (Rl && !Ll) {
                                    const Qe = this.projectAndGetPerspectiveRatio(tu + 1, lu, Dl, Zl, ql), rt = Qe.x - Gl.x, Wn = Math.atan((Qe.y - Gl.y) / rt) + (rt < 0 ? Math.PI : 0), Co = Math.sin(Wn), Ll = Math.cos(Wn);
                                    Ql = Ll, Kl = Co, $l = -Co, Tc = Ll;
                                } else if (!Rl && Ll) {
                                    const Qe = be(this.transform);
                                    Ql = Qe.vecEast[0], Kl = Qe.vecEast[1], $l = Qe.vecSouth[0], Tc = Qe.vecSouth[1];
                                }
                                let du = Gl.x, fu = Gl.y, yu = Wn;
                                Ll && (du = tu, fu = lu, yu = Math.pow(2, -(this.transform.zoom - Co.overscaledZ)), yu *= this.transform.getPitchedTextCorrection(tu, lu, Dl), Hl || (yu *= rt.ae(.5 + Gl.signedDistanceFromCamera / this.transform.cameraToCenterDistance * .5, 0, 4))), Hl && (du += Ql * Hl.x * yu + $l * Hl.y * yu, fu += Kl * Hl.x * yu + Tc * Hl.y * yu);
                                const Eu = Qe.x1 * yu, Tu = Qe.x2 * yu, Lu = (Eu + Tu) / 2, Zu = Qe.y1 * yu, Xu = Qe.y2 * yu, Ju = (Zu + Xu) / 2, $u = [
                                    {
                                        offsetX: Eu,
                                        offsetY: Zu
                                    },
                                    {
                                        offsetX: Lu,
                                        offsetY: Zu
                                    },
                                    {
                                        offsetX: Tu,
                                        offsetY: Zu
                                    },
                                    {
                                        offsetX: Tu,
                                        offsetY: Ju
                                    },
                                    {
                                        offsetX: Tu,
                                        offsetY: Xu
                                    },
                                    {
                                        offsetX: Lu,
                                        offsetY: Xu
                                    },
                                    {
                                        offsetX: Eu,
                                        offsetY: Xu
                                    },
                                    {
                                        offsetX: Eu,
                                        offsetY: Ju
                                    }
                                ];
                                let ed = [];
                                for (const { offsetX: id, offsetY: nd } of $u)ed.push(new rt.P(du + Ql * id + $l * nd, fu + Kl * id + Tc * nd));
                                let td = !1;
                                if (Ll) {
                                    const Qe = ed.map((Qe)=>this.projectAndGetPerspectiveRatio(Qe.x, Qe.y, Dl, Zl, ql));
                                    td = Qe.some((Qe)=>!Qe.isOccluded), ed = Qe.map((Qe)=>new rt.P(Qe.x, Qe.y));
                                } else td = !0;
                                return {
                                    box: rt.au(ed),
                                    allPointsOccluded: !td
                                };
                            }
                        }
                        class Ne {
                            constructor(Qe, rt, Wn, Co){
                                this.opacity = Qe ? Math.max(0, Math.min(1, Qe.opacity + (Qe.placed ? rt : -rt))) : Co && Wn ? 1 : 0, this.placed = Wn;
                            }
                            isHidden() {
                                return 0 === this.opacity && !this.placed;
                            }
                        }
                        class Ge {
                            constructor(Qe, rt, Wn, Co, Dl){
                                this.text = new Ne(Qe ? Qe.text : null, rt, Wn, Dl), this.icon = new Ne(Qe ? Qe.icon : null, rt, Co, Dl);
                            }
                            isHidden() {
                                return this.text.isHidden() && this.icon.isHidden();
                            }
                        }
                        class Ue {
                            constructor(Qe, rt, Wn){
                                this.text = Qe, this.icon = rt, this.skipFade = Wn;
                            }
                        }
                        class Ve {
                            constructor(Qe, rt, Wn, Co, Dl){
                                this.bucketInstanceId = Qe, this.featureIndex = rt, this.sourceLayerIndex = Wn, this.bucketIndex = Co, this.tileID = Dl;
                            }
                        }
                        class qe {
                            constructor(Qe){
                                this.crossSourceCollisions = Qe, this.maxGroupID = 0, this.collisionGroups = {};
                            }
                            get(Qe) {
                                if (this.crossSourceCollisions) return {
                                    ID: 0,
                                    predicate: null
                                };
                                if (!this.collisionGroups[Qe]) {
                                    const rt = ++this.maxGroupID;
                                    this.collisionGroups[Qe] = {
                                        ID: rt,
                                        predicate: (Qe)=>Qe.collisionGroupID === rt
                                    };
                                }
                                return this.collisionGroups[Qe];
                            }
                        }
                        function We(Qe, Wn, Co, Dl, Ll) {
                            const { horizontalAlign: Rl, verticalAlign: Ul } = rt.aB(Qe);
                            return new rt.P(-(Rl - .5) * Wn + Dl[0] * Ll, -(Ul - .5) * Co + Dl[1] * Ll);
                        }
                        class $e {
                            constructor(Qe, rt, Wn, Co, Dl){
                                this.transform = Qe.clone(), this.terrain = rt, this.collisionIndex = new Ze(this.transform), this.placements = {}, this.opacities = {}, this.variableOffsets = {}, this.stale = !1, this.commitTime = 0, this.fadeDuration = Wn, this.retainedQueryData = {}, this.collisionGroups = new qe(Co), this.collisionCircleArrays = {}, this.collisionBoxArrays = new Map, this.prevPlacement = Dl, Dl && (Dl.prevPlacement = void 0), this.placedOrientations = {};
                            }
                            _getTerrainElevationFunc(Qe) {
                                const rt = this.terrain;
                                return rt ? (Wn, Co)=>rt.getElevation(Qe, Wn, Co) : null;
                            }
                            getBucketParts(Qe, Wn, Co, Dl) {
                                const Ll = Co.getBucket(Wn), Rl = Co.latestFeatureIndex;
                                if (!Ll || !Rl || Wn.id !== Ll.layerIds[0]) return;
                                const Ul = Co.collisionBoxArray, Gl = Ll.layers[0].layout, Zl = Ll.layers[0].paint, Hl = Math.pow(2, this.transform.zoom - Co.tileID.overscaledZ), ql = Co.tileSize / rt.Z, Ql = Co.tileID.toUnwrapped(), Kl = "map" === Gl.get("text-rotation-alignment"), $l = rt.aw(Co, 1, this.transform.zoom), Tc = rt.ax(this.collisionIndex.transform, Co, Zl.get("text-translate"), Zl.get("text-translate-anchor")), tu = rt.ax(this.collisionIndex.transform, Co, Zl.get("icon-translate"), Zl.get("icon-translate-anchor")), lu = ve(Kl, this.transform, $l);
                                this.retainedQueryData[Ll.bucketInstanceId] = new Ve(Ll.bucketInstanceId, Rl, Ll.sourceLayerIndex, Ll.index, Co.tileID);
                                const du = {
                                    bucket: Ll,
                                    layout: Gl,
                                    translationText: Tc,
                                    translationIcon: tu,
                                    unwrappedTileID: Ql,
                                    pitchedLabelPlaneMatrix: lu,
                                    scale: Hl,
                                    textPixelRatio: ql,
                                    holdingForFade: Co.holdingForFade(),
                                    collisionBoxArray: Ul,
                                    partiallyEvaluatedTextSize: rt.ag(Ll.textSizeData, this.transform.zoom),
                                    collisionGroup: this.collisionGroups.get(Ll.sourceID)
                                };
                                if (Dl) for (const rt of Ll.sortKeyRanges){
                                    const { sortKey: Wn, symbolInstanceStart: Co, symbolInstanceEnd: Dl } = rt;
                                    Qe.push({
                                        sortKey: Wn,
                                        symbolInstanceStart: Co,
                                        symbolInstanceEnd: Dl,
                                        parameters: du
                                    });
                                }
                                else Qe.push({
                                    symbolInstanceStart: 0,
                                    symbolInstanceEnd: Ll.symbolInstances.length,
                                    parameters: du
                                });
                            }
                            attemptAnchorPlacement(Qe, Wn, Co, Dl, Ll, Rl, Ul, Gl, Zl, Hl, ql, Ql, Kl, $l, Tc, tu, lu, du, fu, yu) {
                                const Eu = rt.ay[Qe.textAnchor], Tu = [
                                    Qe.textOffset0,
                                    Qe.textOffset1
                                ], Lu = We(Eu, Co, Dl, Tu, Ll), Zu = this.collisionIndex.placeCollisionBox(Wn, Ql, Gl, Zl, Hl, Ul, Rl, tu, ql.predicate, fu, Lu, yu);
                                if ((!du || this.collisionIndex.placeCollisionBox(du, Ql, Gl, Zl, Hl, Ul, Rl, lu, ql.predicate, fu, Lu, yu).placeable) && Zu.placeable) {
                                    let Qe;
                                    if (this.prevPlacement && this.prevPlacement.variableOffsets[Kl.crossTileID] && this.prevPlacement.placements[Kl.crossTileID] && this.prevPlacement.placements[Kl.crossTileID].text && (Qe = this.prevPlacement.variableOffsets[Kl.crossTileID].anchor), 0 === Kl.crossTileID) throw new Error("symbolInstance.crossTileID can't be 0");
                                    return this.variableOffsets[Kl.crossTileID] = {
                                        textOffset: Tu,
                                        width: Co,
                                        height: Dl,
                                        anchor: Eu,
                                        textBoxScale: Ll,
                                        prevAnchor: Qe
                                    }, this.markUsedJustification($l, Eu, Kl, Tc), $l.allowVerticalPlacement && (this.markUsedOrientation($l, Tc, Kl), this.placedOrientations[Kl.crossTileID] = Tc), {
                                        shift: Lu,
                                        placedGlyphBoxes: Zu
                                    };
                                }
                            }
                            placeLayerBucketPart(Qe, Wn, Co) {
                                const { bucket: Dl, layout: Ll, translationText: Rl, translationIcon: Ul, unwrappedTileID: Gl, pitchedLabelPlaneMatrix: Zl, textPixelRatio: Hl, holdingForFade: ql, collisionBoxArray: Ql, partiallyEvaluatedTextSize: Kl, collisionGroup: $l } = Qe.parameters, Tc = Ll.get("text-optional"), tu = Ll.get("icon-optional"), lu = rt.az(Ll, "text-overlap", "text-allow-overlap"), du = "always" === lu, fu = rt.az(Ll, "icon-overlap", "icon-allow-overlap"), yu = "always" === fu, Eu = "map" === Ll.get("text-rotation-alignment"), Tu = "map" === Ll.get("text-pitch-alignment"), Lu = "none" !== Ll.get("icon-text-fit"), Zu = "viewport-y" === Ll.get("symbol-z-order"), Xu = du && (yu || !Dl.hasIconData() || tu), Ju = yu && (du || !Dl.hasTextData() || Tc);
                                !Dl.collisionArrays && Ql && Dl.deserializeCollisionBoxes(Ql);
                                const $u = this.retainedQueryData[Dl.bucketInstanceId].tileID, ed = this._getTerrainElevationFunc($u), td = this.transform.getFastPathSimpleProjectionMatrix($u), R = (Qe, Ql, yu)=>{
                                    var Zu, id;
                                    if (Wn[Qe.crossTileID]) return;
                                    if (ql) return void (this.placements[Qe.crossTileID] = new Ue(!1, !1, !1));
                                    let nd = !1, rd = !1, sd = !0, ad = null, od = {
                                        box: null,
                                        placeable: !1,
                                        offscreen: null,
                                        occluded: !1
                                    }, ld = {
                                        placeable: !1
                                    }, cd = null, ud = null, hd = null, dd = 0, pd = 0, md = 0;
                                    Ql.textFeatureIndex ? dd = Ql.textFeatureIndex : Qe.useRuntimeCollisionCircles && (dd = Qe.featureIndex), Ql.verticalTextFeatureIndex && (pd = Ql.verticalTextFeatureIndex);
                                    const fd = Ql.textBox;
                                    if (fd) {
                                        const i = (Wn)=>{
                                            let Co = rt.ah.horizontal;
                                            if (Dl.allowVerticalPlacement && !Wn && this.prevPlacement) {
                                                const rt = this.prevPlacement.placedOrientations[Qe.crossTileID];
                                                rt && (this.placedOrientations[Qe.crossTileID] = rt, Co = rt, this.markUsedOrientation(Dl, Co, Qe));
                                            }
                                            return Co;
                                        }, a = (Wn, Co)=>{
                                            if (Dl.allowVerticalPlacement && Qe.numVerticalGlyphVertices > 0 && Ql.verticalTextBox) {
                                                for (const Qe of Dl.writingModes)if (Qe === rt.ah.vertical ? (od = Co(), ld = od) : od = Wn(), od && od.placeable) break;
                                            } else od = Wn();
                                        }, Wn = Qe.textAnchorOffsetStartIndex, Ll = Qe.textAnchorOffsetEndIndex;
                                        if (Ll === Wn) {
                                            const r = (rt, Wn)=>{
                                                const Co = this.collisionIndex.placeCollisionBox(rt, lu, Hl, $u, Gl, Tu, Eu, Rl, $l.predicate, ed, void 0, td);
                                                return Co && Co.placeable && (this.markUsedOrientation(Dl, Wn, Qe), this.placedOrientations[Qe.crossTileID] = Wn), Co;
                                            };
                                            a(()=>r(fd, rt.ah.horizontal), ()=>{
                                                const Wn = Ql.verticalTextBox;
                                                return Dl.allowVerticalPlacement && Qe.numVerticalGlyphVertices > 0 && Wn ? r(Wn, rt.ah.vertical) : {
                                                    box: null,
                                                    offscreen: null
                                                };
                                            }), i(od && od.placeable);
                                        } else {
                                            let Zl = rt.ay[null === (id = null === (Zu = this.prevPlacement) || void 0 === Zu ? void 0 : Zu.variableOffsets[Qe.crossTileID]) || void 0 === id ? void 0 : id.anchor];
                                            const m = (rt, ql, Ql)=>{
                                                const Kl = rt.x2 - rt.x1, Tc = rt.y2 - rt.y1, tu = Qe.textBoxScale, du = Lu && "never" === fu ? ql : null;
                                                let yu = null, Zu = "never" === lu ? 1 : 2, Xu = "never";
                                                Zl && Zu++;
                                                for(let Co = 0; Co < Zu; Co++){
                                                    for(let Co = Wn; Co < Ll; Co++){
                                                        const Wn = Dl.textAnchorOffsets.get(Co);
                                                        if (Zl && Wn.textAnchor !== Zl) continue;
                                                        const Ll = this.attemptAnchorPlacement(Wn, rt, Kl, Tc, tu, Eu, Tu, Hl, $u, Gl, $l, Xu, Qe, Dl, Ql, Rl, Ul, du, ed);
                                                        if (Ll && (yu = Ll.placedGlyphBoxes, yu && yu.placeable)) return nd = !0, ad = Ll.shift, yu;
                                                    }
                                                    Zl ? Zl = null : Xu = lu;
                                                }
                                                return Co && !yu && (yu = {
                                                    box: this.collisionIndex.placeCollisionBox(fd, "always", Hl, $u, Gl, Tu, Eu, Rl, $l.predicate, ed, void 0, td).box,
                                                    offscreen: !1,
                                                    placeable: !1,
                                                    occluded: !1
                                                }), yu;
                                            };
                                            a(()=>m(fd, Ql.iconBox, rt.ah.horizontal), ()=>{
                                                const Wn = Ql.verticalTextBox;
                                                return Dl.allowVerticalPlacement && (!od || !od.placeable) && Qe.numVerticalGlyphVertices > 0 && Wn ? m(Wn, Ql.verticalIconBox, rt.ah.vertical) : {
                                                    box: null,
                                                    occluded: !0,
                                                    offscreen: null
                                                };
                                            }), od && (nd = od.placeable, sd = od.offscreen);
                                            const ql = i(od && od.placeable);
                                            if (!nd && this.prevPlacement) {
                                                const rt = this.prevPlacement.variableOffsets[Qe.crossTileID];
                                                rt && (this.variableOffsets[Qe.crossTileID] = rt, this.markUsedJustification(Dl, rt.anchor, Qe, ql));
                                            }
                                        }
                                    }
                                    if (cd = od, nd = cd && cd.placeable, sd = cd && cd.offscreen, Qe.useRuntimeCollisionCircles) {
                                        const Wn = Dl.text.placedSymbolArray.get(Qe.centerJustifiedTextSymbolIndex), Ul = rt.ai(Dl.textSizeData, Kl, Wn), Hl = Ll.get("text-padding");
                                        ud = this.collisionIndex.placeCollisionCircles(lu, Wn, Dl.lineVertexArray, Dl.glyphOffsetArray, Ul, Gl, Zl, Co, Tu, $l.predicate, Qe.collisionCircleDiameter, Hl, Rl, ed), ud.circles.length && ud.collisionDetected && !Co && rt.w("Collisions detected, but collision boxes are not shown"), nd = du || ud.circles.length > 0 && !ud.collisionDetected, sd = sd && ud.offscreen;
                                    }
                                    if (Ql.iconFeatureIndex && (md = Ql.iconFeatureIndex), Ql.iconBox) {
                                        const e = (Qe)=>this.collisionIndex.placeCollisionBox(Qe, fu, Hl, $u, Gl, Tu, Eu, Ul, $l.predicate, ed, Lu && ad ? ad : void 0, td);
                                        ld && ld.placeable && Ql.verticalIconBox ? (hd = e(Ql.verticalIconBox), rd = hd.placeable) : (hd = e(Ql.iconBox), rd = hd.placeable), sd = sd && hd.offscreen;
                                    }
                                    const gd = Tc || 0 === Qe.numHorizontalGlyphVertices && 0 === Qe.numVerticalGlyphVertices, Ad = tu || 0 === Qe.numIconVertices;
                                    gd || Ad ? Ad ? gd || (rd = rd && nd) : nd = rd && nd : rd = nd = rd && nd;
                                    const yd = rd && hd.placeable;
                                    if (nd && cd.placeable && this.collisionIndex.insertCollisionBox(cd.box, lu, Ll.get("text-ignore-placement"), Dl.bucketInstanceId, ld && ld.placeable && pd ? pd : dd, $l.ID), yd && this.collisionIndex.insertCollisionBox(hd.box, fu, Ll.get("icon-ignore-placement"), Dl.bucketInstanceId, md, $l.ID), ud && nd && this.collisionIndex.insertCollisionCircles(ud.circles, lu, Ll.get("text-ignore-placement"), Dl.bucketInstanceId, dd, $l.ID), Co && this.storeCollisionData(Dl.bucketInstanceId, yu, Ql, cd, hd, ud), 0 === Qe.crossTileID) throw new Error("symbolInstance.crossTileID can't be 0");
                                    if (0 === Dl.bucketInstanceId) throw new Error("bucket.bucketInstanceId can't be 0");
                                    this.placements[Qe.crossTileID] = new Ue((nd || Xu) && !(null == cd ? void 0 : cd.occluded), (rd || Ju) && !(null == hd ? void 0 : hd.occluded), sd || Dl.justReloaded), Wn[Qe.crossTileID] = !0;
                                };
                                if (Zu) {
                                    if (0 !== Qe.symbolInstanceStart) throw new Error("bucket.bucketInstanceId should be 0");
                                    const rt = Dl.getSortedSymbolIndexes(-this.transform.bearingInRadians);
                                    for(let Qe = rt.length - 1; Qe >= 0; --Qe){
                                        const Wn = rt[Qe];
                                        R(Dl.symbolInstances.get(Wn), Dl.collisionArrays[Wn], Wn);
                                    }
                                } else for(let rt = Qe.symbolInstanceStart; rt < Qe.symbolInstanceEnd; rt++)R(Dl.symbolInstances.get(rt), Dl.collisionArrays[rt], rt);
                                Dl.justReloaded = !1;
                            }
                            storeCollisionData(Qe, rt, Wn, Co, Dl, Ll) {
                                if (Wn.textBox || Wn.iconBox) {
                                    let Ll, Rl;
                                    this.collisionBoxArrays.has(Qe) ? Ll = this.collisionBoxArrays.get(Qe) : (Ll = new Map, this.collisionBoxArrays.set(Qe, Ll)), Ll.has(rt) ? Rl = Ll.get(rt) : (Rl = {
                                        text: null,
                                        icon: null
                                    }, Ll.set(rt, Rl)), Wn.textBox && (Rl.text = Co.box), Wn.iconBox && (Rl.icon = Dl.box);
                                }
                                if (Ll) {
                                    let rt = this.collisionCircleArrays[Qe];
                                    void 0 === rt && (rt = this.collisionCircleArrays[Qe] = []);
                                    for(let Qe = 0; Qe < Ll.circles.length; Qe += 4)rt.push(Ll.circles[Qe + 0] - Lu), rt.push(Ll.circles[Qe + 1] - Lu), rt.push(Ll.circles[Qe + 2]), rt.push(Ll.collisionDetected ? 1 : 0);
                                }
                            }
                            markUsedJustification(Qe, Wn, Co, Dl) {
                                let Ll;
                                Ll = Dl === rt.ah.vertical ? Co.verticalPlacedTextSymbolIndex : ({
                                    left: Co.leftJustifiedTextSymbolIndex,
                                    center: Co.centerJustifiedTextSymbolIndex,
                                    right: Co.rightJustifiedTextSymbolIndex
                                })[rt.aA(Wn)];
                                const Rl = [
                                    Co.leftJustifiedTextSymbolIndex,
                                    Co.centerJustifiedTextSymbolIndex,
                                    Co.rightJustifiedTextSymbolIndex,
                                    Co.verticalPlacedTextSymbolIndex
                                ];
                                for (const rt of Rl)rt >= 0 && (Qe.text.placedSymbolArray.get(rt).crossTileID = Ll >= 0 && rt !== Ll ? 0 : Co.crossTileID);
                            }
                            markUsedOrientation(Qe, Wn, Co) {
                                const Dl = Wn === rt.ah.horizontal || Wn === rt.ah.horizontalOnly ? Wn : 0, Ll = Wn === rt.ah.vertical ? Wn : 0, Rl = [
                                    Co.leftJustifiedTextSymbolIndex,
                                    Co.centerJustifiedTextSymbolIndex,
                                    Co.rightJustifiedTextSymbolIndex
                                ];
                                for (const rt of Rl)Qe.text.placedSymbolArray.get(rt).placedOrientation = Dl;
                                Co.verticalPlacedTextSymbolIndex && (Qe.text.placedSymbolArray.get(Co.verticalPlacedTextSymbolIndex).placedOrientation = Ll);
                            }
                            commit(Qe) {
                                this.commitTime = Qe, this.zoomAtLastRecencyCheck = this.transform.zoom;
                                const rt = this.prevPlacement;
                                let Wn = !1;
                                this.prevZoomAdjustment = rt ? rt.zoomAdjustment(this.transform.zoom) : 0;
                                const Co = rt ? rt.symbolFadeChange(Qe) : 1, Dl = rt ? rt.opacities : {}, Ll = rt ? rt.variableOffsets : {}, Rl = rt ? rt.placedOrientations : {};
                                for(const Ul in this.placements){
                                    const Qe = this.placements[Ul], rt = Dl[Ul];
                                    rt ? (this.opacities[Ul] = new Ge(rt, Co, Qe.text, Qe.icon), Wn = Wn || Qe.text !== rt.text.placed || Qe.icon !== rt.icon.placed) : (this.opacities[Ul] = new Ge(null, Co, Qe.text, Qe.icon, Qe.skipFade), Wn = Wn || Qe.text || Qe.icon);
                                }
                                for(const Ul in Dl){
                                    const Qe = Dl[Ul];
                                    if (!this.opacities[Ul]) {
                                        const rt = new Ge(Qe, Co, !1, !1);
                                        rt.isHidden() || (this.opacities[Ul] = rt, Wn = Wn || Qe.text.placed || Qe.icon.placed);
                                    }
                                }
                                for(const Ul in Ll)this.variableOffsets[Ul] || !this.opacities[Ul] || this.opacities[Ul].isHidden() || (this.variableOffsets[Ul] = Ll[Ul]);
                                for(const Ul in Rl)this.placedOrientations[Ul] || !this.opacities[Ul] || this.opacities[Ul].isHidden() || (this.placedOrientations[Ul] = Rl[Ul]);
                                if (rt && void 0 === rt.lastPlacementChangeTime) throw new Error("Last placement time for previous placement is not defined");
                                Wn ? this.lastPlacementChangeTime = Qe : "number" != typeof this.lastPlacementChangeTime && (this.lastPlacementChangeTime = rt ? rt.lastPlacementChangeTime : Qe);
                            }
                            updateLayerOpacities(Qe, rt) {
                                const Wn = {};
                                for (const Co of rt){
                                    const rt = Co.getBucket(Qe);
                                    rt && Co.latestFeatureIndex && Qe.id === rt.layerIds[0] && this.updateBucketOpacities(rt, Co.tileID, Wn, Co.collisionBoxArray);
                                }
                            }
                            updateBucketOpacities(Qe, Wn, Co, Dl) {
                                Qe.hasTextData() && (Qe.text.opacityVertexArray.clear(), Qe.text.hasVisibleVertices = !1), Qe.hasIconData() && (Qe.icon.opacityVertexArray.clear(), Qe.icon.hasVisibleVertices = !1), Qe.hasIconCollisionBoxData() && Qe.iconCollisionBox.collisionVertexArray.clear(), Qe.hasTextCollisionBoxData() && Qe.textCollisionBox.collisionVertexArray.clear();
                                const Ll = Qe.layers[0], Rl = Ll.layout, Ul = new Ge(null, 0, !1, !1, !0), Gl = Rl.get("text-allow-overlap"), Zl = Rl.get("icon-allow-overlap"), Hl = Ll._unevaluatedLayout.hasValue("text-variable-anchor") || Ll._unevaluatedLayout.hasValue("text-variable-anchor-offset"), ql = "map" === Rl.get("text-rotation-alignment"), Ql = "map" === Rl.get("text-pitch-alignment"), Kl = "none" !== Rl.get("icon-text-fit"), $l = new Ge(null, 0, Gl && (Zl || !Qe.hasIconData() || Rl.get("icon-optional")), Zl && (Gl || !Qe.hasTextData() || Rl.get("text-optional")), !0);
                                !Qe.collisionArrays && Dl && (Qe.hasIconCollisionBoxData() || Qe.hasTextCollisionBoxData()) && Qe.deserializeCollisionBoxes(Dl);
                                const m = (Qe, rt, Wn)=>{
                                    for(let Co = 0; Co < rt / 4; Co++)Qe.opacityVertexArray.emplaceBack(Wn);
                                    Qe.hasVisibleVertices = Qe.hasVisibleVertices || Wn !== nd;
                                }, Tc = this.collisionBoxArrays.get(Qe.bucketInstanceId);
                                for(let tu = 0; tu < Qe.symbolInstances.length; tu++){
                                    const Wn = Qe.symbolInstances.get(tu), { numHorizontalGlyphVertices: Dl, numVerticalGlyphVertices: Ll, crossTileID: Rl } = Wn;
                                    let Gl = this.opacities[Rl];
                                    Co[Rl] ? Gl = Ul : Gl || (Gl = $l, this.opacities[Rl] = Gl), Co[Rl] = !0;
                                    const Zl = Wn.numIconVertices > 0, lu = this.placedOrientations[Wn.crossTileID], du = lu === rt.ah.vertical, fu = lu === rt.ah.horizontal || lu === rt.ah.horizontalOnly;
                                    if (Dl > 0 || Ll > 0) {
                                        const rt = it(Gl.text);
                                        m(Qe.text, Dl, du ? nd : rt), m(Qe.text, Ll, fu ? nd : rt);
                                        const Co = Gl.text.isHidden();
                                        [
                                            Wn.rightJustifiedTextSymbolIndex,
                                            Wn.centerJustifiedTextSymbolIndex,
                                            Wn.leftJustifiedTextSymbolIndex
                                        ].forEach((rt)=>{
                                            rt >= 0 && (Qe.text.placedSymbolArray.get(rt).hidden = Co || du ? 1 : 0);
                                        }), Wn.verticalPlacedTextSymbolIndex >= 0 && (Qe.text.placedSymbolArray.get(Wn.verticalPlacedTextSymbolIndex).hidden = Co || fu ? 1 : 0);
                                        const Rl = this.variableOffsets[Wn.crossTileID];
                                        Rl && this.markUsedJustification(Qe, Rl.anchor, Wn, lu);
                                        const Ul = this.placedOrientations[Wn.crossTileID];
                                        Ul && (this.markUsedJustification(Qe, "left", Wn, Ul), this.markUsedOrientation(Qe, Ul, Wn));
                                    }
                                    if (Zl) {
                                        const rt = it(Gl.icon), Co = !(Kl && Wn.verticalPlacedIconSymbolIndex && du);
                                        Wn.placedIconSymbolIndex >= 0 && (m(Qe.icon, Wn.numIconVertices, Co ? rt : nd), Qe.icon.placedSymbolArray.get(Wn.placedIconSymbolIndex).hidden = Gl.icon.isHidden()), Wn.verticalPlacedIconSymbolIndex >= 0 && (m(Qe.icon, Wn.numVerticalIconVertices, Co ? nd : rt), Qe.icon.placedSymbolArray.get(Wn.verticalPlacedIconSymbolIndex).hidden = Gl.icon.isHidden());
                                    }
                                    const yu = Tc && Tc.has(tu) ? Tc.get(tu) : {
                                        text: null,
                                        icon: null
                                    };
                                    if (Qe.hasIconCollisionBoxData() || Qe.hasTextCollisionBoxData()) {
                                        const Wn = Qe.collisionArrays[tu];
                                        if (Wn) {
                                            let Co = new rt.P(0, 0);
                                            if (Wn.textBox || Wn.verticalTextBox) {
                                                let rt = !0;
                                                if (Hl) {
                                                    const Qe = this.variableOffsets[Rl];
                                                    Qe ? (Co = We(Qe.anchor, Qe.width, Qe.height, Qe.textOffset, Qe.textBoxScale), ql && Co._rotate(Ql ? -this.transform.bearingInRadians : this.transform.bearingInRadians)) : rt = !1;
                                                }
                                                if (Wn.textBox || Wn.verticalTextBox) {
                                                    let Dl;
                                                    Wn.textBox && (Dl = du), Wn.verticalTextBox && (Dl = fu), He(Qe.textCollisionBox.collisionVertexArray, Gl.text.placed, !rt || Dl, yu.text, Co.x, Co.y);
                                                }
                                            }
                                            if (Wn.iconBox || Wn.verticalIconBox) {
                                                const rt = Boolean(!fu && Wn.verticalIconBox);
                                                let Dl;
                                                Wn.iconBox && (Dl = rt), Wn.verticalIconBox && (Dl = !rt), He(Qe.iconCollisionBox.collisionVertexArray, Gl.icon.placed, Dl, yu.icon, Kl ? Co.x : 0, Kl ? Co.y : 0);
                                            }
                                        }
                                    }
                                }
                                if (Qe.sortFeatures(-this.transform.bearingInRadians), this.retainedQueryData[Qe.bucketInstanceId] && (this.retainedQueryData[Qe.bucketInstanceId].featureSortOrder = Qe.featureSortOrder), Qe.hasTextData() && Qe.text.opacityVertexBuffer && Qe.text.opacityVertexBuffer.updateData(Qe.text.opacityVertexArray), Qe.hasIconData() && Qe.icon.opacityVertexBuffer && Qe.icon.opacityVertexBuffer.updateData(Qe.icon.opacityVertexArray), Qe.hasIconCollisionBoxData() && Qe.iconCollisionBox.collisionVertexBuffer && Qe.iconCollisionBox.collisionVertexBuffer.updateData(Qe.iconCollisionBox.collisionVertexArray), Qe.hasTextCollisionBoxData() && Qe.textCollisionBox.collisionVertexBuffer && Qe.textCollisionBox.collisionVertexBuffer.updateData(Qe.textCollisionBox.collisionVertexArray), Qe.text.opacityVertexArray.length !== Qe.text.layoutVertexArray.length / 4) throw new Error(`bucket.text.opacityVertexArray.length (= ${Qe.text.opacityVertexArray.length}) !== bucket.text.layoutVertexArray.length (= ${Qe.text.layoutVertexArray.length}) / 4`);
                                if (Qe.icon.opacityVertexArray.length !== Qe.icon.layoutVertexArray.length / 4) throw new Error(`bucket.icon.opacityVertexArray.length (= ${Qe.icon.opacityVertexArray.length}) !== bucket.icon.layoutVertexArray.length (= ${Qe.icon.layoutVertexArray.length}) / 4`);
                                Qe.bucketInstanceId in this.collisionCircleArrays && (Qe.collisionCircleArray = this.collisionCircleArrays[Qe.bucketInstanceId], delete this.collisionCircleArrays[Qe.bucketInstanceId]);
                            }
                            symbolFadeChange(Qe) {
                                return 0 === this.fadeDuration ? 1 : (Qe - this.commitTime) / this.fadeDuration + this.prevZoomAdjustment;
                            }
                            zoomAdjustment(Qe) {
                                return Math.max(0, (this.transform.zoom - Qe) / 1.5);
                            }
                            hasTransitions(Qe) {
                                return this.stale || Qe - this.lastPlacementChangeTime < this.fadeDuration;
                            }
                            stillRecent(Qe, rt) {
                                const Wn = this.zoomAtLastRecencyCheck === rt ? 1 - this.zoomAdjustment(rt) : 1;
                                return this.zoomAtLastRecencyCheck = rt, this.commitTime + this.fadeDuration * Wn > Qe;
                            }
                            setStale() {
                                this.stale = !0;
                            }
                        }
                        function He(Qe, rt, Wn, Co, Dl, Ll) {
                            Co && 0 !== Co.length || (Co = [
                                0,
                                0,
                                0,
                                0
                            ]);
                            const Rl = Co[0] - Lu, Ul = Co[1] - Lu, Gl = Co[2] - Lu, Zl = Co[3] - Lu;
                            Qe.emplaceBack(rt ? 1 : 0, Wn ? 1 : 0, Dl || 0, Ll || 0, Rl, Ul), Qe.emplaceBack(rt ? 1 : 0, Wn ? 1 : 0, Dl || 0, Ll || 0, Gl, Ul), Qe.emplaceBack(rt ? 1 : 0, Wn ? 1 : 0, Dl || 0, Ll || 0, Gl, Zl), Qe.emplaceBack(rt ? 1 : 0, Wn ? 1 : 0, Dl || 0, Ll || 0, Rl, Zl);
                        }
                        const Zu = Math.pow(2, 25), Xu = Math.pow(2, 24), Ju = Math.pow(2, 17), $u = Math.pow(2, 16), ed = Math.pow(2, 9), td = Math.pow(2, 8), id = Math.pow(2, 1);
                        function it(Qe) {
                            if (0 === Qe.opacity && !Qe.placed) return 0;
                            if (1 === Qe.opacity && Qe.placed) return 4294967295;
                            const rt = Qe.placed ? 1 : 0, Wn = Math.floor(127 * Qe.opacity);
                            return Wn * Zu + rt * Xu + Wn * Ju + rt * $u + Wn * ed + rt * td + Wn * id + rt;
                        }
                        const nd = 0;
                        class ot {
                            constructor(Qe){
                                this._sortAcrossTiles = "viewport-y" !== Qe.layout.get("symbol-z-order") && !Qe.layout.get("symbol-sort-key").isConstant(), this._currentTileIndex = 0, this._currentPartIndex = 0, this._seenCrossTileIDs = {}, this._bucketParts = [];
                            }
                            continuePlacement(Qe, rt, Wn, Co, Dl) {
                                const Ll = this._bucketParts;
                                for(; this._currentTileIndex < Qe.length;)if (rt.getBucketParts(Ll, Co, Qe[this._currentTileIndex], this._sortAcrossTiles), this._currentTileIndex++, Dl()) return !0;
                                for(this._sortAcrossTiles && (this._sortAcrossTiles = !1, Ll.sort((Qe, rt)=>Qe.sortKey - rt.sortKey)); this._currentPartIndex < Ll.length;)if (rt.placeLayerBucketPart(Ll[this._currentPartIndex], this._seenCrossTileIDs, Wn), this._currentPartIndex++, Dl()) return !0;
                                return !1;
                            }
                        }
                        class at {
                            constructor(Qe, rt, Wn, Co, Dl, Ll, Rl, Ul){
                                this.placement = new $e(Qe, rt, Ll, Rl, Ul), this._currentPlacementIndex = Wn.length - 1, this._forceFullPlacement = Co, this._showCollisionBoxes = Dl, this._done = !1;
                            }
                            isDone() {
                                return this._done;
                            }
                            continuePlacement(Qe, rt, Wn) {
                                const Co = Ll.now(), o = ()=>!this._forceFullPlacement && Ll.now() - Co > 2;
                                for(; this._currentPlacementIndex >= 0;){
                                    const Co = rt[Qe[this._currentPlacementIndex]], Dl = this.placement.collisionIndex.transform.zoom;
                                    if ("symbol" === Co.type && (!Co.minzoom || Co.minzoom <= Dl) && (!Co.maxzoom || Co.maxzoom > Dl)) {
                                        if (this._inProgressLayer || (this._inProgressLayer = new ot(Co)), this._inProgressLayer.continuePlacement(Wn[Co.source], this.placement, this._showCollisionBoxes, Co, o)) return;
                                        delete this._inProgressLayer;
                                    }
                                    this._currentPlacementIndex--;
                                }
                                this._done = !0;
                            }
                            commit(Qe) {
                                return this.placement.commit(Qe), this.placement;
                            }
                        }
                        const rd = 512 / rt.Z / 2;
                        class nt {
                            constructor(Qe, Wn, Co){
                                this.tileID = Qe, this.bucketInstanceId = Co, this._symbolsByKey = {};
                                const Dl = new Map;
                                for(let rt = 0; rt < Wn.length; rt++){
                                    const Qe = Wn.get(rt), Co = Qe.key, Ll = Dl.get(Co);
                                    Ll ? Ll.push(Qe) : Dl.set(Co, [
                                        Qe
                                    ]);
                                }
                                for (const [Ll, Rl] of Dl){
                                    const Qe = {
                                        positions: Rl.map((Qe)=>({
                                                x: Math.floor(Qe.anchorX * rd),
                                                y: Math.floor(Qe.anchorY * rd)
                                            })),
                                        crossTileIDs: Rl.map((Qe)=>Qe.crossTileID)
                                    };
                                    if (Qe.positions.length > 128) {
                                        const Wn = new rt.aC(Qe.positions.length, 16, Uint16Array);
                                        for (const { x: rt, y: Co } of Qe.positions)Wn.add(rt, Co);
                                        Wn.finish(), delete Qe.positions, Qe.index = Wn;
                                    }
                                    this._symbolsByKey[Ll] = Qe;
                                }
                            }
                            getScaledCoordinates(Qe, Wn) {
                                const { x: Co, y: Dl, z: Ll } = this.tileID.canonical, { x: Rl, y: Ul, z: Gl } = Wn.canonical, Zl = rd / Math.pow(2, Gl - Ll), Hl = (Ul * rt.Z + Qe.anchorY) * Zl, ql = Dl * rt.Z * rd;
                                return {
                                    x: Math.floor((Rl * rt.Z + Qe.anchorX) * Zl - Co * rt.Z * rd),
                                    y: Math.floor(Hl - ql)
                                };
                            }
                            findMatches(Qe, rt, Wn) {
                                const Co = this.tileID.canonical.z < rt.canonical.z ? 1 : Math.pow(2, this.tileID.canonical.z - rt.canonical.z);
                                for(let Dl = 0; Dl < Qe.length; Dl++){
                                    const Ll = Qe.get(Dl);
                                    if (Ll.crossTileID) continue;
                                    const Rl = this._symbolsByKey[Ll.key];
                                    if (!Rl) continue;
                                    const Ul = this.getScaledCoordinates(Ll, rt);
                                    if (Rl.index) {
                                        const Qe = Rl.index.range(Ul.x - Co, Ul.y - Co, Ul.x + Co, Ul.y + Co).sort();
                                        for (const rt of Qe){
                                            const Qe = Rl.crossTileIDs[rt];
                                            if (!Wn[Qe]) {
                                                Wn[Qe] = !0, Ll.crossTileID = Qe;
                                                break;
                                            }
                                        }
                                    } else if (Rl.positions) for(let Qe = 0; Qe < Rl.positions.length; Qe++){
                                        const rt = Rl.positions[Qe], Dl = Rl.crossTileIDs[Qe];
                                        if (Math.abs(rt.x - Ul.x) <= Co && Math.abs(rt.y - Ul.y) <= Co && !Wn[Dl]) {
                                            Wn[Dl] = !0, Ll.crossTileID = Dl;
                                            break;
                                        }
                                    }
                                }
                            }
                            getCrossTileIDsLists() {
                                return Object.values(this._symbolsByKey).map(({ crossTileIDs: Qe })=>Qe);
                            }
                        }
                        class lt {
                            constructor(){
                                this.maxCrossTileID = 0;
                            }
                            generate() {
                                return ++this.maxCrossTileID;
                            }
                        }
                        class ct {
                            constructor(){
                                this.indexes = {}, this.usedCrossTileIDs = {}, this.lng = 0;
                            }
                            handleWrapJump(Qe) {
                                const rt = Math.round((Qe - this.lng) / 360);
                                if (0 !== rt) for(const Wn in this.indexes){
                                    const Qe = this.indexes[Wn], Co = {};
                                    for(const Wn in Qe){
                                        const Dl = Qe[Wn];
                                        Dl.tileID = Dl.tileID.unwrapTo(Dl.tileID.wrap + rt), Co[Dl.tileID.key] = Dl;
                                    }
                                    this.indexes[Wn] = Co;
                                }
                                this.lng = Qe;
                            }
                            addBucket(Qe, rt, Wn) {
                                if (this.indexes[Qe.overscaledZ] && this.indexes[Qe.overscaledZ][Qe.key]) {
                                    if (this.indexes[Qe.overscaledZ][Qe.key].bucketInstanceId === rt.bucketInstanceId) return !1;
                                    this.removeBucketCrossTileIDs(Qe.overscaledZ, this.indexes[Qe.overscaledZ][Qe.key]);
                                }
                                for(let Dl = 0; Dl < rt.symbolInstances.length; Dl++)rt.symbolInstances.get(Dl).crossTileID = 0;
                                this.usedCrossTileIDs[Qe.overscaledZ] || (this.usedCrossTileIDs[Qe.overscaledZ] = {});
                                const Co = this.usedCrossTileIDs[Qe.overscaledZ];
                                for(const Dl in this.indexes){
                                    const Wn = this.indexes[Dl];
                                    if (Number(Dl) > Qe.overscaledZ) for(const Dl in Wn){
                                        const Ll = Wn[Dl];
                                        Ll.tileID.isChildOf(Qe) && Ll.findMatches(rt.symbolInstances, Qe, Co);
                                    }
                                    else {
                                        const Ll = Wn[Qe.scaledTo(Number(Dl)).key];
                                        Ll && Ll.findMatches(rt.symbolInstances, Qe, Co);
                                    }
                                }
                                for(let Dl = 0; Dl < rt.symbolInstances.length; Dl++){
                                    const Qe = rt.symbolInstances.get(Dl);
                                    Qe.crossTileID || (Qe.crossTileID = Wn.generate(), Co[Qe.crossTileID] = !0);
                                }
                                return void 0 === this.indexes[Qe.overscaledZ] && (this.indexes[Qe.overscaledZ] = {}), this.indexes[Qe.overscaledZ][Qe.key] = new nt(Qe, rt.symbolInstances, rt.bucketInstanceId), !0;
                            }
                            removeBucketCrossTileIDs(Qe, rt) {
                                for (const Wn of rt.getCrossTileIDsLists())for (const rt of Wn)delete this.usedCrossTileIDs[Qe][rt];
                            }
                            removeStaleBuckets(Qe) {
                                let rt = !1;
                                for(const Wn in this.indexes){
                                    const Co = this.indexes[Wn];
                                    for(const Dl in Co)Qe[Co[Dl].bucketInstanceId] || (this.removeBucketCrossTileIDs(Wn, Co[Dl]), delete Co[Dl], rt = !0);
                                }
                                return rt;
                            }
                        }
                        class ht {
                            constructor(){
                                this.layerIndexes = {}, this.crossTileIDs = new lt, this.maxBucketInstanceId = 0, this.bucketsInCurrentPlacement = {};
                            }
                            addLayer(Qe, rt, Wn) {
                                let Co = this.layerIndexes[Qe.id];
                                void 0 === Co && (Co = this.layerIndexes[Qe.id] = new ct);
                                let Dl = !1;
                                const Ll = {};
                                Co.handleWrapJump(Wn);
                                for (const Rl of rt){
                                    const rt = Rl.getBucket(Qe);
                                    rt && Qe.id === rt.layerIds[0] && (rt.bucketInstanceId || (rt.bucketInstanceId = ++this.maxBucketInstanceId), Co.addBucket(Rl.tileID, rt, this.crossTileIDs) && (Dl = !0), Ll[rt.bucketInstanceId] = !0);
                                }
                                return Co.removeStaleBuckets(Ll) && (Dl = !0), Dl;
                            }
                            pruneUnusedLayers(Qe) {
                                const rt = {};
                                Qe.forEach((Qe)=>{
                                    rt[Qe] = !0;
                                });
                                for(const Wn in this.layerIndexes)rt[Wn] || delete this.layerIndexes[Wn];
                            }
                        }
                        var sd = "void main() {fragColor=vec4(1.0);}";
                        const ad = {
                            prelude: _t("#ifdef GL_ES\nprecision mediump float;\n#else\n#if !defined(lowp)\n#define lowp\n#endif\n#if !defined(mediump)\n#define mediump\n#endif\n#if !defined(highp)\n#define highp\n#endif\n#endif\nout highp vec4 fragColor;", "#ifdef GL_ES\nprecision highp float;\n#else\n#if !defined(lowp)\n#define lowp\n#endif\n#if !defined(mediump)\n#define mediump\n#endif\n#if !defined(highp)\n#define highp\n#endif\n#endif\nvec2 unpack_float(const float packedValue) {int packedIntValue=int(packedValue);int v0=packedIntValue/256;return vec2(v0,packedIntValue-v0*256);}vec2 unpack_opacity(const float packedOpacity) {int intOpacity=int(packedOpacity)/2;return vec2(float(intOpacity)/127.0,mod(packedOpacity,2.0));}vec4 decode_color(const vec2 encodedColor) {return vec4(unpack_float(encodedColor[0])/255.0,unpack_float(encodedColor[1])/255.0\n);}float unpack_mix_vec2(const vec2 packedValue,const float t) {return mix(packedValue[0],packedValue[1],t);}vec4 unpack_mix_color(const vec4 packedColors,const float t) {vec4 minColor=decode_color(vec2(packedColors[0],packedColors[1]));vec4 maxColor=decode_color(vec2(packedColors[2],packedColors[3]));return mix(minColor,maxColor,t);}vec2 get_pattern_pos(const vec2 pixel_coord_upper,const vec2 pixel_coord_lower,const vec2 pattern_size,const float tile_units_to_pixels,const vec2 pos) {vec2 offset=mod(mod(mod(pixel_coord_upper,pattern_size)*256.0,pattern_size)*256.0+pixel_coord_lower,pattern_size);return (tile_units_to_pixels*pos+offset)/pattern_size;}mat3 rotationMatrixFromAxisAngle(vec3 u,float angle) {float c=cos(angle);float s=sin(angle);float c2=1.0-c;return mat3(u.x*u.x*c2+      c,u.x*u.y*c2-u.z*s,u.x*u.z*c2+u.y*s,u.y*u.x*c2+u.z*s,u.y*u.y*c2+    c,u.y*u.z*c2-u.x*s,u.z*u.x*c2-u.y*s,u.z*u.y*c2+u.x*s,u.z*u.z*c2+    c\n);}\n#ifdef TERRAIN3D\nuniform sampler2D u_terrain;uniform float u_terrain_dim;uniform mat4 u_terrain_matrix;uniform vec4 u_terrain_unpack;uniform float u_terrain_exaggeration;uniform highp sampler2D u_depth;\n#endif\nconst highp vec4 bitSh=vec4(256.*256.*256.,256.*256.,256.,1.);const highp vec4 bitShifts=vec4(1.)/bitSh;highp float unpack(highp vec4 color) {return dot(color,bitShifts);}highp float depthOpacity(vec3 frag) {\n#ifdef TERRAIN3D\nhighp float d=unpack(texture(u_depth,frag.xy*0.5+0.5))+0.0001-frag.z;return 1.0-max(0.0,min(1.0,-d*500.0));\n#else\nreturn 1.0;\n#endif\n}float calculate_visibility(vec4 pos) {\n#ifdef TERRAIN3D\nvec3 frag=pos.xyz/pos.w;highp float d=depthOpacity(frag);if (d > 0.95) return 1.0;return (d+depthOpacity(frag+vec3(0.0,0.01,0.0)))/2.0;\n#else\nreturn 1.0;\n#endif\n}float ele(vec2 pos) {\n#ifdef TERRAIN3D\nvec4 rgb=(texture(u_terrain,pos)*255.0)*u_terrain_unpack;return rgb.r+rgb.g+rgb.b-u_terrain_unpack.a;\n#else\nreturn 0.0;\n#endif\n}float get_elevation(vec2 pos) {\n#ifdef TERRAIN3D\n#ifdef GLOBE\nif ((pos.y <-32767.5) || (pos.y > 32766.5)) {return 0.0;}\n#endif\nvec2 coord=(u_terrain_matrix*vec4(pos,0.0,1.0)).xy*u_terrain_dim+1.0;vec2 f=fract(coord);vec2 c=(floor(coord)+0.5)/(u_terrain_dim+2.0);float d=1.0/(u_terrain_dim+2.0);float tl=ele(c);float tr=ele(c+vec2(d,0.0));float bl=ele(c+vec2(0.0,d));float br=ele(c+vec2(d,d));float elevation=mix(mix(tl,tr,f.x),mix(bl,br,f.x),f.y);return elevation*u_terrain_exaggeration;\n#else\nreturn 0.0;\n#endif\n}const float PI=3.141592653589793;uniform mat4 u_projection_matrix;"),
                            projectionMercator: _t("", "float projectLineThickness(float tileY) {return 1.0;}float projectCircleRadius(float tileY) {return 1.0;}vec4 projectTile(vec2 p) {vec4 result=u_projection_matrix*vec4(p,0.0,1.0);return result;}vec4 projectTile(vec2 p,vec2 rawPos) {vec4 result=u_projection_matrix*vec4(p,0.0,1.0);if (rawPos.y <-32767.5 || rawPos.y > 32766.5) {result.z=-10000000.0;}return result;}vec4 projectTileWithElevation(vec2 posInTile,float elevation) {return u_projection_matrix*vec4(posInTile,elevation,1.0);}vec4 projectTileFor3D(vec2 posInTile,float elevation) {return projectTileWithElevation(posInTile,elevation);}"),
                            projectionGlobe: _t("", "#define GLOBE_RADIUS 6371008.8\nuniform highp vec4 u_projection_tile_mercator_coords;uniform highp vec4 u_projection_clipping_plane;uniform highp float u_projection_transition;uniform mat4 u_projection_fallback_matrix;vec3 globeRotateVector(vec3 vec,vec2 angles) {vec3 axisRight=vec3(vec.z,0.0,-vec.x);vec3 axisUp=cross(axisRight,vec);axisRight=normalize(axisRight);axisUp=normalize(axisUp);vec2 t=tan(angles);return normalize(vec+axisRight*t.x+axisUp*t.y);}mat3 globeGetRotationMatrix(vec3 spherePos) {vec3 axisRight=vec3(spherePos.z,0.0,-spherePos.x);vec3 axisDown=cross(axisRight,spherePos);axisRight=normalize(axisRight);axisDown=normalize(axisDown);return mat3(axisRight,axisDown,spherePos\n);}float circumferenceRatioAtTileY(float tileY) {float mercator_pos_y=u_projection_tile_mercator_coords.y+u_projection_tile_mercator_coords.w*tileY;float spherical_y=2.0*atan(exp(PI-(mercator_pos_y*PI*2.0)))-PI*0.5;return cos(spherical_y);}float projectLineThickness(float tileY) {float thickness=1.0/circumferenceRatioAtTileY(tileY); \nif (u_projection_transition < 0.999) {return mix(1.0,thickness,u_projection_transition);} else {return thickness;}}vec3 projectToSphere(vec2 translatedPos,vec2 rawPos) {vec2 mercator_pos=u_projection_tile_mercator_coords.xy+u_projection_tile_mercator_coords.zw*translatedPos;vec2 spherical;spherical.x=mercator_pos.x*PI*2.0+PI;spherical.y=2.0*atan(exp(PI-(mercator_pos.y*PI*2.0)))-PI*0.5;float len=cos(spherical.y);vec3 pos=vec3(sin(spherical.x)*len,sin(spherical.y),cos(spherical.x)*len\n);if (rawPos.y <-32767.5) {pos=vec3(0.0,1.0,0.0);}if (rawPos.y > 32766.5) {pos=vec3(0.0,-1.0,0.0);}return pos;}vec3 projectToSphere(vec2 posInTile) {return projectToSphere(posInTile,vec2(0.0,0.0));}float globeComputeClippingZ(vec3 spherePos) {return (1.0-(dot(spherePos,u_projection_clipping_plane.xyz)+u_projection_clipping_plane.w));}vec4 interpolateProjection(vec2 posInTile,vec3 spherePos,float elevation) {vec3 elevatedPos=spherePos*(1.0+elevation/GLOBE_RADIUS);vec4 globePosition=u_projection_matrix*vec4(elevatedPos,1.0);globePosition.z=globeComputeClippingZ(elevatedPos)*globePosition.w;if (u_projection_transition > 0.999) {return globePosition;}vec4 flatPosition=u_projection_fallback_matrix*vec4(posInTile,elevation,1.0);const float z_globeness_threshold=0.2;vec4 result=globePosition;result.z=mix(0.0,globePosition.z,clamp((u_projection_transition-z_globeness_threshold)/(1.0-z_globeness_threshold),0.0,1.0));result.xyw=mix(flatPosition.xyw,globePosition.xyw,u_projection_transition);if ((posInTile.y <-32767.5) || (posInTile.y > 32766.5)) {result=globePosition;const float poles_hidden_anim_percentage=0.02;result.z=mix(globePosition.z,100.0,pow(max((1.0-u_projection_transition)/poles_hidden_anim_percentage,0.0),8.0));}return result;}vec4 interpolateProjectionFor3D(vec2 posInTile,vec3 spherePos,float elevation) {vec3 elevatedPos=spherePos*(1.0+elevation/GLOBE_RADIUS);vec4 globePosition=u_projection_matrix*vec4(elevatedPos,1.0);if (u_projection_transition > 0.999) {return globePosition;}vec4 fallbackPosition=u_projection_fallback_matrix*vec4(posInTile,elevation,1.0);return mix(fallbackPosition,globePosition,u_projection_transition);}vec4 projectTile(vec2 posInTile) {return interpolateProjection(posInTile,projectToSphere(posInTile),0.0);}vec4 projectTile(vec2 posInTile,vec2 rawPos) {return interpolateProjection(posInTile,projectToSphere(posInTile,rawPos),0.0);}vec4 projectTileWithElevation(vec2 posInTile,float elevation) {return interpolateProjection(posInTile,projectToSphere(posInTile),elevation);}vec4 projectTileFor3D(vec2 posInTile,float elevation) {vec3 spherePos=projectToSphere(posInTile,posInTile);return interpolateProjectionFor3D(posInTile,spherePos,elevation);}"),
                            background: _t("uniform vec4 u_color;uniform float u_opacity;void main() {fragColor=u_color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "in vec2 a_pos;void main() {gl_Position=projectTile(a_pos);}"),
                            backgroundPattern: _t("uniform vec2 u_pattern_tl_a;uniform vec2 u_pattern_br_a;uniform vec2 u_pattern_tl_b;uniform vec2 u_pattern_br_b;uniform vec2 u_texsize;uniform float u_mix;uniform float u_opacity;uniform sampler2D u_image;in vec2 v_pos_a;in vec2 v_pos_b;void main() {vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(u_pattern_tl_a/u_texsize,u_pattern_br_a/u_texsize,imagecoord);vec4 color1=texture(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(u_pattern_tl_b/u_texsize,u_pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture(u_image,pos2);fragColor=mix(color1,color2,u_mix)*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform vec2 u_pattern_size_a;uniform vec2 u_pattern_size_b;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_scale_a;uniform float u_scale_b;uniform float u_tile_units_to_pixels;in vec2 a_pos;out vec2 v_pos_a;out vec2 v_pos_b;void main() {gl_Position=projectTile(a_pos);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_scale_a*u_pattern_size_a,u_tile_units_to_pixels,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_scale_b*u_pattern_size_b,u_tile_units_to_pixels,a_pos);}"),
                            circle: _t("in vec3 v_data;in float v_visibility;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 extrude=v_data.xy;float extrude_length=length(extrude);float antialiased_blur=v_data.z;float opacity_t=smoothstep(0.0,antialiased_blur,extrude_length-1.0);float color_t=stroke_width < 0.01 ? 0.0 : smoothstep(antialiased_blur,0.0,extrude_length-radius/(radius+stroke_width));fragColor=v_visibility*opacity_t*mix(color*opacity,stroke_color*stroke_opacity,color_t);const float epsilon=0.5/255.0;if (fragColor.r < epsilon && fragColor.g < epsilon && fragColor.b < epsilon && fragColor.a < epsilon) {discard;}\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform bool u_scale_with_map;uniform bool u_pitch_with_map;uniform vec2 u_extrude_scale;uniform highp float u_globe_extrude_scale;uniform lowp float u_device_pixel_ratio;uniform highp float u_camera_to_center_distance;uniform vec2 u_translate;in vec2 a_pos;out vec3 v_data;out float v_visibility;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nvoid main(void) {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 pos_raw=a_pos+32768.0;vec2 extrude=vec2(mod(pos_raw,8.0)/7.0*2.0-1.0);vec2 circle_center=floor(pos_raw/8.0)+u_translate;float ele=get_elevation(circle_center);v_visibility=calculate_visibility(projectTileWithElevation(circle_center,ele));if (u_pitch_with_map) {\n#ifdef GLOBE\nvec3 center_vector=projectToSphere(circle_center);\n#endif\nfloat angle_scale=u_globe_extrude_scale;vec2 corner_position=circle_center;if (u_scale_with_map) {angle_scale*=(radius+stroke_width);corner_position+=extrude*u_extrude_scale*(radius+stroke_width);} else {\n#ifdef GLOBE\nvec4 projected_center=interpolateProjection(circle_center,center_vector,ele);\n#else\nvec4 projected_center=projectTileWithElevation(circle_center,ele);\n#endif\ncorner_position+=extrude*u_extrude_scale*(radius+stroke_width)*(projected_center.w/u_camera_to_center_distance);angle_scale*=(radius+stroke_width)*(projected_center.w/u_camera_to_center_distance);}\n#ifdef GLOBE\nvec2 angles=extrude*angle_scale;vec3 corner_vector=globeRotateVector(center_vector,angles);gl_Position=interpolateProjection(corner_position,corner_vector,ele);\n#else\ngl_Position=projectTileWithElevation(corner_position,ele);\n#endif\n} else {gl_Position=projectTileWithElevation(circle_center,ele);if (gl_Position.z/gl_Position.w > 1.0) {gl_Position.xy=vec2(10000.0);}if (u_scale_with_map) {gl_Position.xy+=extrude*(radius+stroke_width)*u_extrude_scale*u_camera_to_center_distance;} else {gl_Position.xy+=extrude*(radius+stroke_width)*u_extrude_scale*gl_Position.w;}}float antialiasblur=-max(1.0/u_device_pixel_ratio/(radius+stroke_width),blur);v_data=vec3(extrude.x,extrude.y,antialiasblur);}"),
                            clippingMask: _t(sd, "in vec2 a_pos;void main() {gl_Position=projectTile(a_pos);}"),
                            heatmap: _t("uniform highp float u_intensity;in vec2 v_extrude;\n#pragma mapbox: define highp float weight\n#define GAUSS_COEF 0.3989422804014327\nvoid main() {\n#pragma mapbox: initialize highp float weight\nfloat d=-0.5*3.0*3.0*dot(v_extrude,v_extrude);float val=weight*u_intensity*GAUSS_COEF*exp(d);fragColor=vec4(val,1.0,1.0,1.0);\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform float u_extrude_scale;uniform float u_opacity;uniform float u_intensity;uniform highp float u_globe_extrude_scale;in vec2 a_pos;out vec2 v_extrude;\n#pragma mapbox: define highp float weight\n#pragma mapbox: define mediump float radius\nconst highp float ZERO=1.0/255.0/16.0;\n#define GAUSS_COEF 0.3989422804014327\nvoid main(void) {\n#pragma mapbox: initialize highp float weight\n#pragma mapbox: initialize mediump float radius\nvec2 pos_raw=a_pos+32768.0;vec2 unscaled_extrude=vec2(mod(pos_raw,8.0)/7.0*2.0-1.0);float S=sqrt(-2.0*log(ZERO/weight/u_intensity/GAUSS_COEF))/3.0;v_extrude=S*unscaled_extrude;vec2 extrude=v_extrude*radius*u_extrude_scale;vec2 circle_center=floor(pos_raw/8.0);\n#ifdef GLOBE\nvec2 angles=v_extrude*radius*u_globe_extrude_scale;vec3 center_vector=projectToSphere(circle_center);vec3 corner_vector=globeRotateVector(center_vector,angles);gl_Position=interpolateProjection(circle_center+extrude,corner_vector,0.0);\n#else\ngl_Position=projectTileFor3D(circle_center+extrude,get_elevation(circle_center));\n#endif\n}"),
                            heatmapTexture: _t("uniform sampler2D u_image;uniform sampler2D u_color_ramp;uniform float u_opacity;in vec2 v_pos;void main() {float t=texture(u_image,v_pos).r;vec4 color=texture(u_color_ramp,vec2(t,0.5));fragColor=color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(0.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_world;in vec2 a_pos;out vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos*u_world,0,1);v_pos.x=a_pos.x;v_pos.y=1.0-a_pos.y;}"),
                            collisionBox: _t("in float v_placed;in float v_notUsed;void main() {float alpha=0.5;fragColor=vec4(1.0,0.0,0.0,1.0)*alpha;if (v_placed > 0.5) {fragColor=vec4(0.0,0.0,1.0,0.5)*alpha;}if (v_notUsed > 0.5) {fragColor*=.1;}}", "in vec2 a_anchor_pos;in vec2 a_placed;in vec2 a_box_real;uniform vec2 u_pixel_extrude_scale;out float v_placed;out float v_notUsed;void main() {gl_Position=projectTileWithElevation(a_anchor_pos,get_elevation(a_anchor_pos));gl_Position.xy=((a_box_real+0.5)*u_pixel_extrude_scale*2.0-1.0)*vec2(1.0,-1.0)*gl_Position.w;if (gl_Position.z/gl_Position.w < 1.1) {gl_Position.z=0.5;}v_placed=a_placed.x;v_notUsed=a_placed.y;}"),
                            collisionCircle: _t("in float v_radius;in vec2 v_extrude;in float v_collision;void main() {float alpha=0.5;float stroke_radius=0.9;float distance_to_center=length(v_extrude);float distance_to_edge=abs(distance_to_center-v_radius);float opacity_t=smoothstep(-stroke_radius,0.0,-distance_to_edge);vec4 color=mix(vec4(0.0,0.0,1.0,0.5),vec4(1.0,0.0,0.0,1.0),v_collision);fragColor=color*alpha*opacity_t;}", "in vec2 a_pos;in float a_radius;in vec2 a_flags;uniform vec2 u_viewport_size;out float v_radius;out vec2 v_extrude;out float v_collision;void main() {float radius=a_radius;float collision=a_flags.x;float vertexIdx=a_flags.y;vec2 quadVertexOffset=vec2(mix(-1.0,1.0,float(vertexIdx >=2.0)),mix(-1.0,1.0,float(vertexIdx >=1.0 && vertexIdx <=2.0)));vec2 quadVertexExtent=quadVertexOffset*radius;float padding_factor=1.2;v_radius=radius;v_extrude=quadVertexExtent*padding_factor;v_collision=collision;gl_Position=vec4((a_pos/u_viewport_size*2.0-1.0)*vec2(1.0,-1.0),0.0,1.0)+vec4(quadVertexExtent*padding_factor/u_viewport_size*2.0,0.0,0.0);}"),
                            debug: _t("uniform highp vec4 u_color;uniform sampler2D u_overlay;in vec2 v_uv;void main() {vec4 overlay_color=texture(u_overlay,v_uv);fragColor=mix(u_color,overlay_color,overlay_color.a);}", "in vec2 a_pos;out vec2 v_uv;uniform float u_overlay_scale;void main() {v_uv=a_pos/8192.0;gl_Position=projectTileWithElevation(a_pos*u_overlay_scale,get_elevation(a_pos));}"),
                            depth: _t(sd, "in vec2 a_pos;void main() {\n#ifdef GLOBE\ngl_Position=projectTileFor3D(a_pos,0.0);\n#else\ngl_Position=u_projection_matrix*vec4(a_pos,0.0,1.0);\n#endif\n}"),
                            fill: _t("#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\nfragColor=color*opacity;\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform vec2 u_fill_translate;in vec2 a_pos;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\ngl_Position=projectTile(a_pos+u_fill_translate,a_pos);}"),
                            fillOutline: _t("in vec2 v_pos;\n#ifdef GLOBE\nin float v_depth;\n#endif\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);fragColor=outline_color*(alpha*opacity);\n#ifdef GLOBE\nif (v_depth > 1.0) {discard;}\n#endif\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform vec2 u_world;uniform vec2 u_fill_translate;in vec2 a_pos;out vec2 v_pos;\n#ifdef GLOBE\nout float v_depth;\n#endif\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\ngl_Position=projectTile(a_pos+u_fill_translate,a_pos);v_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;\n#ifdef GLOBE\nv_depth=gl_Position.z/gl_Position.w;\n#endif\n}"),
                            fillOutlinePattern: _t("uniform vec2 u_texsize;uniform sampler2D u_image;uniform float u_fade;in vec2 v_pos_a;in vec2 v_pos_b;in vec2 v_pos;\n#ifdef GLOBE\nin float v_depth;\n#endif\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture(u_image,pos2);float dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);fragColor=mix(color1,color2,u_fade)*alpha*opacity;\n#ifdef GLOBE\nif (v_depth > 1.0) {discard;}\n#endif\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform vec2 u_world;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform vec3 u_scale;uniform vec2 u_fill_translate;in vec2 a_pos;out vec2 v_pos_a;out vec2 v_pos_b;out vec2 v_pos;\n#ifdef GLOBE\nout float v_depth;\n#endif\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;gl_Position=projectTile(a_pos+u_fill_translate,a_pos);vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileRatio,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileRatio,a_pos);v_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;\n#ifdef GLOBE\nv_depth=gl_Position.z/gl_Position.w;\n#endif\n}"),
                            fillPattern: _t("#ifdef GL_ES\nprecision highp float;\n#endif\nuniform vec2 u_texsize;uniform float u_fade;uniform sampler2D u_image;in vec2 v_pos_a;in vec2 v_pos_b;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture(u_image,pos2);fragColor=mix(color1,color2,u_fade)*opacity;\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform vec3 u_scale;uniform vec2 u_fill_translate;in vec2 a_pos;out vec2 v_pos_a;out vec2 v_pos_b;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileZoomRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;gl_Position=projectTile(a_pos+u_fill_translate,a_pos);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileZoomRatio,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileZoomRatio,a_pos);}"),
                            fillExtrusion: _t("in vec4 v_color;void main() {fragColor=v_color;\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp vec3 u_lightpos_globe;uniform lowp float u_lightintensity;uniform float u_vertical_gradient;uniform lowp float u_opacity;uniform vec2 u_fill_translate;in vec2 a_pos;in vec4 a_normal_ed;\n#ifdef TERRAIN3D\nin vec2 a_centroid;\n#endif\nout vec4 v_color;\n#pragma mapbox: define highp float base\n#pragma mapbox: define highp float height\n#pragma mapbox: define highp vec4 color\nvoid main() {\n#pragma mapbox: initialize highp float base\n#pragma mapbox: initialize highp float height\n#pragma mapbox: initialize highp vec4 color\nvec3 normal=a_normal_ed.xyz;\n#ifdef TERRAIN3D\nfloat height_terrain3d_offset=get_elevation(a_centroid);float base_terrain3d_offset=height_terrain3d_offset-(base > 0.0 ? 0.0 : 10.0);\n#else\nfloat height_terrain3d_offset=0.0;float base_terrain3d_offset=0.0;\n#endif\nbase=max(0.0,base)+base_terrain3d_offset;height=max(0.0,height)+height_terrain3d_offset;float t=mod(normal.x,2.0);float elevation=t > 0.0 ? height : base;vec2 posInTile=a_pos+u_fill_translate;\n#ifdef GLOBE\nvec3 spherePos=projectToSphere(posInTile,a_pos);gl_Position=interpolateProjectionFor3D(posInTile,spherePos,elevation);\n#else\ngl_Position=u_projection_matrix*vec4(posInTile,elevation,1.0);\n#endif\nfloat colorvalue=color.r*0.2126+color.g*0.7152+color.b*0.0722;v_color=vec4(0.0,0.0,0.0,1.0);vec4 ambientlight=vec4(0.03,0.03,0.03,1.0);color+=ambientlight;vec3 normalForLighting=normal/16384.0;float directional=clamp(dot(normalForLighting,u_lightpos),0.0,1.0);\n#ifdef GLOBE\nmat3 rotMatrix=globeGetRotationMatrix(spherePos);normalForLighting=rotMatrix*normalForLighting;directional=mix(directional,clamp(dot(normalForLighting,u_lightpos_globe),0.0,1.0),u_projection_transition);\n#endif\ndirectional=mix((1.0-u_lightintensity),max((1.0-colorvalue+u_lightintensity),1.0),directional);if (normal.y !=0.0) {directional*=((1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),mix(0.7,0.98,1.0-u_lightintensity),1.0)));}v_color.r+=clamp(color.r*directional*u_lightcolor.r,mix(0.0,0.3,1.0-u_lightcolor.r),1.0);v_color.g+=clamp(color.g*directional*u_lightcolor.g,mix(0.0,0.3,1.0-u_lightcolor.g),1.0);v_color.b+=clamp(color.b*directional*u_lightcolor.b,mix(0.0,0.3,1.0-u_lightcolor.b),1.0);v_color*=u_opacity;}"),
                            fillExtrusionPattern: _t("uniform vec2 u_texsize;uniform float u_fade;uniform sampler2D u_image;in vec2 v_pos_a;in vec2 v_pos_b;in vec4 v_lighting;\n#pragma mapbox: define lowp float base\n#pragma mapbox: define lowp float height\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float base\n#pragma mapbox: initialize lowp float height\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture(u_image,pos2);vec4 mixedColor=mix(color1,color2,u_fade);fragColor=mixedColor*v_lighting;\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_height_factor;uniform vec3 u_scale;uniform float u_vertical_gradient;uniform lowp float u_opacity;uniform vec2 u_fill_translate;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp vec3 u_lightpos_globe;uniform lowp float u_lightintensity;in vec2 a_pos;in vec4 a_normal_ed;\n#ifdef TERRAIN3D\nin vec2 a_centroid;\n#endif\n#ifdef GLOBE\nout vec3 v_sphere_pos;\n#endif\nout vec2 v_pos_a;out vec2 v_pos_b;out vec4 v_lighting;\n#pragma mapbox: define lowp float base\n#pragma mapbox: define lowp float height\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float base\n#pragma mapbox: initialize lowp float height\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec3 normal=a_normal_ed.xyz;float edgedistance=a_normal_ed.w;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;\n#ifdef TERRAIN3D\nfloat height_terrain3d_offset=get_elevation(a_centroid);float base_terrain3d_offset=height_terrain3d_offset-(base > 0.0 ? 0.0 : 10.0);\n#else\nfloat height_terrain3d_offset=0.0;float base_terrain3d_offset=0.0;\n#endif\nbase=max(0.0,base)+base_terrain3d_offset;height=max(0.0,height)+height_terrain3d_offset;float t=mod(normal.x,2.0);float elevation=t > 0.0 ? height : base;vec2 posInTile=a_pos+u_fill_translate;\n#ifdef GLOBE\nvec3 spherePos=projectToSphere(posInTile,a_pos);vec3 elevatedPos=spherePos*(1.0+elevation/GLOBE_RADIUS);v_sphere_pos=elevatedPos;gl_Position=interpolateProjectionFor3D(posInTile,spherePos,elevation);\n#else\ngl_Position=u_projection_matrix*vec4(posInTile,elevation,1.0);\n#endif\nvec2 pos=normal.x==1.0 && normal.y==0.0 && normal.z==16384.0\n? a_pos\n: vec2(edgedistance,elevation*u_height_factor);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileRatio,pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileRatio,pos);v_lighting=vec4(0.0,0.0,0.0,1.0);float directional=clamp(dot(normal/16383.0,u_lightpos),0.0,1.0);directional=mix((1.0-u_lightintensity),max((0.5+u_lightintensity),1.0),directional);if (normal.y !=0.0) {directional*=((1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),mix(0.7,0.98,1.0-u_lightintensity),1.0)));}v_lighting.rgb+=clamp(directional*u_lightcolor,mix(vec3(0.0),vec3(0.3),1.0-u_lightcolor),vec3(1.0));v_lighting*=u_opacity;}"),
                            hillshadePrepare: _t("#ifdef GL_ES\nprecision highp float;\n#endif\nuniform sampler2D u_image;in vec2 v_pos;uniform vec2 u_dimension;uniform float u_zoom;uniform vec4 u_unpack;float getElevation(vec2 coord,float bias) {vec4 data=texture(u_image,coord)*255.0;data.a=-1.0;return dot(data,u_unpack)/4.0;}void main() {vec2 epsilon=1.0/u_dimension;float a=getElevation(v_pos+vec2(-epsilon.x,-epsilon.y),0.0);float b=getElevation(v_pos+vec2(0,-epsilon.y),0.0);float c=getElevation(v_pos+vec2(epsilon.x,-epsilon.y),0.0);float d=getElevation(v_pos+vec2(-epsilon.x,0),0.0);float e=getElevation(v_pos,0.0);float f=getElevation(v_pos+vec2(epsilon.x,0),0.0);float g=getElevation(v_pos+vec2(-epsilon.x,epsilon.y),0.0);float h=getElevation(v_pos+vec2(0,epsilon.y),0.0);float i=getElevation(v_pos+vec2(epsilon.x,epsilon.y),0.0);float exaggerationFactor=u_zoom < 2.0 ? 0.4 : u_zoom < 4.5 ? 0.35 : 0.3;float exaggeration=u_zoom < 15.0 ? (u_zoom-15.0)*exaggerationFactor : 0.0;vec2 deriv=vec2((c+f+f+i)-(a+d+d+g),(g+h+h+i)-(a+b+b+c))/pow(2.0,exaggeration+(19.2562-u_zoom));fragColor=clamp(vec4(deriv.x/2.0+0.5,deriv.y/2.0+0.5,1.0,1.0),0.0,1.0);\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_dimension;in vec2 a_pos;in vec2 a_texture_pos;out vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);highp vec2 epsilon=1.0/u_dimension;float scale=(u_dimension.x-2.0)/u_dimension.x;v_pos=(a_texture_pos/8192.0)*scale+epsilon;}"),
                            hillshade: _t("uniform sampler2D u_image;in vec2 v_pos;uniform vec2 u_latrange;uniform vec2 u_light;uniform vec4 u_shadow;uniform vec4 u_highlight;uniform vec4 u_accent;\n#define PI 3.141592653589793\nvoid main() {vec4 pixel=texture(u_image,v_pos);vec2 deriv=((pixel.rg*2.0)-1.0);float scaleFactor=cos(radians((u_latrange[0]-u_latrange[1])*(1.0-v_pos.y)+u_latrange[1]));float slope=atan(1.25*length(deriv)/scaleFactor);float aspect=deriv.x !=0.0 ? atan(deriv.y,-deriv.x) : PI/2.0*(deriv.y > 0.0 ? 1.0 :-1.0);float intensity=u_light.x;float azimuth=u_light.y+PI;float base=1.875-intensity*1.75;float maxValue=0.5*PI;float scaledSlope=intensity !=0.5 ? ((pow(base,slope)-1.0)/(pow(base,maxValue)-1.0))*maxValue : slope;float accent=cos(scaledSlope);vec4 accent_color=(1.0-accent)*u_accent*clamp(intensity*2.0,0.0,1.0);float shade=abs(mod((aspect+azimuth)/PI+0.5,2.0)-1.0);vec4 shade_color=mix(u_shadow,u_highlight,shade)*sin(scaledSlope)*clamp(intensity*2.0,0.0,1.0);fragColor=accent_color*(1.0-shade_color.a)+shade_color;\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;in vec2 a_pos;out vec2 v_pos;void main() {gl_Position=projectTile(a_pos,a_pos);v_pos=a_pos/8192.0;if (a_pos.y <-32767.5) {v_pos.y=0.0;}if (a_pos.y > 32766.5) {v_pos.y=1.0;}}"),
                            line: _t("uniform lowp float u_device_pixel_ratio;in vec2 v_width2;in vec2 v_normal;in float v_gamma_scale;\n#ifdef GLOBE\nin float v_depth;\n#endif\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);fragColor=color*(alpha*opacity);\n#ifdef GLOBE\nif (v_depth > 1.0) {discard;}\n#endif\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "\n#define scale 0.015873016\nin vec2 a_pos_normal;in vec4 a_data;uniform vec2 u_translation;uniform mediump float u_ratio;uniform vec2 u_units_to_pixels;uniform lowp float u_device_pixel_ratio;out vec2 v_normal;out vec2 v_width2;out float v_gamma_scale;out highp float v_linesofar;\n#ifdef GLOBE\nout float v_depth;\n#endif\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;v_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*2.0;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);float adjustedThickness=projectLineThickness(pos.y);vec4 projected_no_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation);vec4 projected_with_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation+dist/u_ratio*adjustedThickness);gl_Position=projected_with_extrude;\n#ifdef GLOBE\nv_depth=gl_Position.z/gl_Position.w;\n#endif\n#ifdef TERRAIN3D\nv_gamma_scale=1.0;\n#else\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length((projected_with_extrude.xy-projected_no_extrude.xy)/projected_with_extrude.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;\n#endif\nv_width2=vec2(outset,inset);}"),
                            lineGradient: _t("uniform lowp float u_device_pixel_ratio;uniform sampler2D u_image;in vec2 v_width2;in vec2 v_normal;in float v_gamma_scale;in highp vec2 v_uv;\n#ifdef GLOBE\nin float v_depth;\n#endif\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);vec4 color=texture(u_image,v_uv);fragColor=color*(alpha*opacity);\n#ifdef GLOBE\nif (v_depth > 1.0) {discard;}\n#endif\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "\n#define scale 0.015873016\nin vec2 a_pos_normal;in vec4 a_data;in float a_uv_x;in float a_split_index;uniform vec2 u_translation;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;uniform vec2 u_units_to_pixels;uniform float u_image_height;out vec2 v_normal;out vec2 v_width2;out float v_gamma_scale;out highp vec2 v_uv;\n#ifdef GLOBE\nout float v_depth;\n#endif\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;highp float texel_height=1.0/u_image_height;highp float half_texel_height=0.5*texel_height;v_uv=vec2(a_uv_x,a_split_index*texel_height-half_texel_height);vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);float adjustedThickness=projectLineThickness(pos.y);vec4 projected_no_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation);vec4 projected_with_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation+dist/u_ratio*adjustedThickness);gl_Position=projected_with_extrude;\n#ifdef GLOBE\nv_depth=gl_Position.z/gl_Position.w;\n#endif\n#ifdef TERRAIN3D\nv_gamma_scale=1.0;\n#else\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length((projected_with_extrude.xy-projected_no_extrude.xy)/projected_with_extrude.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;\n#endif\nv_width2=vec2(outset,inset);}"),
                            linePattern: _t("#ifdef GL_ES\nprecision highp float;\n#endif\nuniform lowp float u_device_pixel_ratio;uniform vec2 u_texsize;uniform float u_fade;uniform mediump vec3 u_scale;uniform sampler2D u_image;in vec2 v_normal;in vec2 v_width2;in float v_linesofar;in float v_gamma_scale;in float v_width;\n#ifdef GLOBE\nin float v_depth;\n#endif\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileZoomRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;vec2 pattern_size_a=vec2(display_size_a.x*fromScale/tileZoomRatio,display_size_a.y);vec2 pattern_size_b=vec2(display_size_b.x*toScale/tileZoomRatio,display_size_b.y);float aspect_a=display_size_a.y/v_width;float aspect_b=display_size_b.y/v_width;float dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);float x_a=mod(v_linesofar/pattern_size_a.x*aspect_a,1.0);float x_b=mod(v_linesofar/pattern_size_b.x*aspect_b,1.0);float y=0.5*v_normal.y+0.5;vec2 texel_size=1.0/u_texsize;vec2 pos_a=mix(pattern_tl_a*texel_size-texel_size,pattern_br_a*texel_size+texel_size,vec2(x_a,y));vec2 pos_b=mix(pattern_tl_b*texel_size-texel_size,pattern_br_b*texel_size+texel_size,vec2(x_b,y));vec4 color=mix(texture(u_image,pos_a),texture(u_image,pos_b),u_fade);fragColor=color*alpha*opacity;\n#ifdef GLOBE\nif (v_depth > 1.0) {discard;}\n#endif\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "\n#define scale 0.015873016\n#define LINE_DISTANCE_SCALE 2.0\nin vec2 a_pos_normal;in vec4 a_data;uniform vec2 u_translation;uniform vec2 u_units_to_pixels;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;out vec2 v_normal;out vec2 v_width2;out float v_linesofar;out float v_gamma_scale;out float v_width;\n#ifdef GLOBE\nout float v_depth;\n#endif\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;float a_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*LINE_DISTANCE_SCALE;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);float adjustedThickness=projectLineThickness(pos.y);vec4 projected_no_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation);vec4 projected_with_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation+dist/u_ratio*adjustedThickness);gl_Position=projected_with_extrude;\n#ifdef GLOBE\nv_depth=gl_Position.z/gl_Position.w;\n#endif\n#ifdef TERRAIN3D\nv_gamma_scale=1.0;\n#else\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length((projected_with_extrude.xy-projected_no_extrude.xy)/projected_with_extrude.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;\n#endif\nv_linesofar=a_linesofar;v_width2=vec2(outset,inset);v_width=floorwidth;}"),
                            lineSDF: _t("uniform lowp float u_device_pixel_ratio;uniform sampler2D u_image;uniform float u_sdfgamma;uniform float u_mix;in vec2 v_normal;in vec2 v_width2;in vec2 v_tex_a;in vec2 v_tex_b;in float v_gamma_scale;\n#ifdef GLOBE\nin float v_depth;\n#endif\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);float sdfdist_a=texture(u_image,v_tex_a).a;float sdfdist_b=texture(u_image,v_tex_b).a;float sdfdist=mix(sdfdist_a,sdfdist_b,u_mix);alpha*=smoothstep(0.5-u_sdfgamma/floorwidth,0.5+u_sdfgamma/floorwidth,sdfdist);fragColor=color*(alpha*opacity);\n#ifdef GLOBE\nif (v_depth > 1.0) {discard;}\n#endif\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "\n#define scale 0.015873016\n#define LINE_DISTANCE_SCALE 2.0\nin vec2 a_pos_normal;in vec4 a_data;uniform vec2 u_translation;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;uniform vec2 u_patternscale_a;uniform float u_tex_y_a;uniform vec2 u_patternscale_b;uniform float u_tex_y_b;uniform vec2 u_units_to_pixels;out vec2 v_normal;out vec2 v_width2;out vec2 v_tex_a;out vec2 v_tex_b;out float v_gamma_scale;\n#ifdef GLOBE\nout float v_depth;\n#endif\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;float a_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*LINE_DISTANCE_SCALE;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);float adjustedThickness=projectLineThickness(pos.y);vec4 projected_no_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation);vec4 projected_with_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation+dist/u_ratio*adjustedThickness);gl_Position=projected_with_extrude;\n#ifdef GLOBE\nv_depth=gl_Position.z/gl_Position.w;\n#endif\n#ifdef TERRAIN3D\nv_gamma_scale=1.0;\n#else\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length((projected_with_extrude.xy-projected_no_extrude.xy)/projected_with_extrude.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;\n#endif\nv_tex_a=vec2(a_linesofar*u_patternscale_a.x/floorwidth,normal.y*u_patternscale_a.y+u_tex_y_a);v_tex_b=vec2(a_linesofar*u_patternscale_b.x/floorwidth,normal.y*u_patternscale_b.y+u_tex_y_b);v_width2=vec2(outset,inset);}"),
                            raster: _t("uniform float u_fade_t;uniform float u_opacity;uniform sampler2D u_image0;uniform sampler2D u_image1;in vec2 v_pos0;in vec2 v_pos1;uniform float u_brightness_low;uniform float u_brightness_high;uniform float u_saturation_factor;uniform float u_contrast_factor;uniform vec3 u_spin_weights;void main() {vec4 color0=texture(u_image0,v_pos0);vec4 color1=texture(u_image1,v_pos1);if (color0.a > 0.0) {color0.rgb=color0.rgb/color0.a;}if (color1.a > 0.0) {color1.rgb=color1.rgb/color1.a;}vec4 color=mix(color0,color1,u_fade_t);color.a*=u_opacity;vec3 rgb=color.rgb;rgb=vec3(dot(rgb,u_spin_weights.xyz),dot(rgb,u_spin_weights.zxy),dot(rgb,u_spin_weights.yzx));float average=(color.r+color.g+color.b)/3.0;rgb+=(average-rgb)*u_saturation_factor;rgb=(rgb-0.5)*u_contrast_factor+0.5;vec3 u_high_vec=vec3(u_brightness_low,u_brightness_low,u_brightness_low);vec3 u_low_vec=vec3(u_brightness_high,u_brightness_high,u_brightness_high);fragColor=vec4(mix(u_high_vec,u_low_vec,rgb)*color.a,color.a);\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform vec2 u_tl_parent;uniform float u_scale_parent;uniform float u_buffer_scale;uniform vec4 u_coords_top;uniform vec4 u_coords_bottom;in vec2 a_pos;out vec2 v_pos0;out vec2 v_pos1;void main() {vec2 fractionalPos=a_pos/8192.0;vec2 position=mix(mix(u_coords_top.xy,u_coords_top.zw,fractionalPos.x),mix(u_coords_bottom.xy,u_coords_bottom.zw,fractionalPos.x),fractionalPos.y);gl_Position=projectTile(position,position);v_pos0=((fractionalPos-0.5)/u_buffer_scale)+0.5;\n#ifdef GLOBE\nif (a_pos.y <-32767.5) {v_pos0.y=0.0;}if (a_pos.y > 32766.5) {v_pos0.y=1.0;}\n#endif\nv_pos1=(v_pos0*u_scale_parent)+u_tl_parent;}"),
                            symbolIcon: _t("uniform sampler2D u_texture;in vec2 v_tex;in float v_fade_opacity;\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\nlowp float alpha=opacity*v_fade_opacity;fragColor=texture(u_texture,v_tex)*alpha;\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "in vec4 a_pos_offset;in vec4 a_data;in vec4 a_pixeloffset;in vec3 a_projected_pos;in float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform highp float u_camera_to_center_distance;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform float u_fade_change;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform vec2 u_texsize;uniform bool u_is_along_line;uniform bool u_is_variable_anchor;uniform vec2 u_translation;uniform float u_pitched_scale;out vec2 v_tex;out float v_fade_opacity;\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;float a_size_min=floor(a_size[0]*0.5);vec2 a_pxoffset=a_pixeloffset.xy;vec2 a_minFontScale=a_pixeloffset.zw/256.0;float ele=get_elevation(a_pos);highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec2 translated_a_pos=a_pos+u_translation;vec4 projectedPoint=projectTileWithElevation(translated_a_pos,ele);highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);size*=perspective_ratio;float fontScale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=projectTileWithElevation(translated_a_pos+vec2(1,0),ele);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos;if (u_is_along_line || u_is_variable_anchor) {projected_pos=vec4(a_projected_pos.xy,ele,1.0);} else if (u_pitch_with_map) {projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy+u_translation,ele,1.0);} else {projected_pos=u_label_plane_matrix*projectTileWithElevation(a_projected_pos.xy+u_translation,ele);}float z=float(u_pitch_with_map)*projected_pos.z/projected_pos.w;float projectionScaling=1.0;\n#ifdef GLOBE\nif(u_pitch_with_map) {float anchor_pos_tile_y=(u_coord_matrix*vec4(projected_pos.xy/projected_pos.w,z,1.0)).y;projectionScaling=mix(projectionScaling,1.0/circumferenceRatioAtTileY(anchor_pos_tile_y)*u_pitched_scale,u_projection_transition);}\n#endif\nvec4 finalPos=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*max(a_minFontScale,fontScale)+a_pxoffset/16.0)*projectionScaling,z,1.0);if(u_pitch_with_map) {finalPos=projectTileWithElevation(finalPos.xy,finalPos.z);}gl_Position=finalPos;v_tex=a_tex/u_texsize;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float visibility=calculate_visibility(projectedPoint);v_fade_opacity=max(0.0,min(visibility,fade_opacity[0]+fade_change));}"),
                            symbolSDF: _t("#define SDF_PX 8.0\nuniform bool u_is_halo;uniform sampler2D u_texture;uniform highp float u_gamma_scale;uniform lowp float u_device_pixel_ratio;uniform bool u_is_text;in vec2 v_data0;in vec3 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nfloat EDGE_GAMMA=0.105/u_device_pixel_ratio;vec2 tex=v_data0.xy;float gamma_scale=v_data1.x;float size=v_data1.y;float fade_opacity=v_data1[2];float fontScale=u_is_text ? size/24.0 : size;lowp vec4 color=fill_color;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float inner_edge=(256.0-64.0)/256.0;if (u_is_halo) {color=halo_color;gamma=(halo_blur*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);inner_edge=inner_edge+gamma*gamma_scale;}lowp float dist=texture(u_texture,tex).a;highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(inner_edge-gamma_scaled,inner_edge+gamma_scaled,dist);if (u_is_halo) {lowp float halo_edge=(6.0-halo_width/fontScale)/SDF_PX;alpha=min(smoothstep(halo_edge-gamma_scaled,halo_edge+gamma_scaled,dist),1.0-alpha);}fragColor=color*(alpha*opacity*fade_opacity);\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "in vec4 a_pos_offset;in vec4 a_data;in vec4 a_pixeloffset;in vec3 a_projected_pos;in float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform bool u_is_along_line;uniform bool u_is_variable_anchor;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform highp float u_camera_to_center_distance;uniform float u_fade_change;uniform vec2 u_texsize;uniform vec2 u_translation;uniform float u_pitched_scale;out vec2 v_data0;out vec3 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;float a_size_min=floor(a_size[0]*0.5);vec2 a_pxoffset=a_pixeloffset.xy;float ele=get_elevation(a_pos);highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec2 translated_a_pos=a_pos+u_translation;vec4 projectedPoint=projectTileWithElevation(translated_a_pos,ele);highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);size*=perspective_ratio;float fontScale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=projectTileWithElevation(translated_a_pos+vec2(1,0),ele);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos;if (u_is_along_line || u_is_variable_anchor) {projected_pos=vec4(a_projected_pos.xy,ele,1.0);} else if (u_pitch_with_map) {projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy+u_translation,ele,1.0);} else {projected_pos=u_label_plane_matrix*projectTileWithElevation(a_projected_pos.xy+u_translation,ele);}float z=float(u_pitch_with_map)*projected_pos.z/projected_pos.w;float projectionScaling=1.0;\n#ifdef GLOBE\nif(u_pitch_with_map) {float anchor_pos_tile_y=(u_coord_matrix*vec4(projected_pos.xy/projected_pos.w,z,1.0)).y;projectionScaling=mix(projectionScaling,1.0/circumferenceRatioAtTileY(anchor_pos_tile_y)*u_pitched_scale,u_projection_transition);}\n#endif\nvec4 finalPos=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*fontScale+a_pxoffset)*projectionScaling,z,1.0);if(u_pitch_with_map) {finalPos=projectTileWithElevation(finalPos.xy,finalPos.z);}float gamma_scale=finalPos.w;gl_Position=finalPos;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float visibility=calculate_visibility(projectedPoint);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float interpolated_fade_opacity=max(0.0,min(visibility,fade_opacity[0]+fade_change));v_data0=a_tex/u_texsize;v_data1=vec3(gamma_scale,size,interpolated_fade_opacity);}"),
                            symbolTextAndIcon: _t("#define SDF_PX 8.0\n#define SDF 1.0\n#define ICON 0.0\nuniform bool u_is_halo;uniform sampler2D u_texture;uniform sampler2D u_texture_icon;uniform highp float u_gamma_scale;uniform lowp float u_device_pixel_ratio;in vec4 v_data0;in vec4 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nfloat fade_opacity=v_data1[2];if (v_data1.w==ICON) {vec2 tex_icon=v_data0.zw;lowp float alpha=opacity*fade_opacity;fragColor=texture(u_texture_icon,tex_icon)*alpha;\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\nreturn;}vec2 tex=v_data0.xy;float EDGE_GAMMA=0.105/u_device_pixel_ratio;float gamma_scale=v_data1.x;float size=v_data1.y;float fontScale=size/24.0;lowp vec4 color=fill_color;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float buff=(256.0-64.0)/256.0;if (u_is_halo) {color=halo_color;gamma=(halo_blur*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);buff=(6.0-halo_width/fontScale)/SDF_PX;}lowp float dist=texture(u_texture,tex).a;highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(buff-gamma_scaled,buff+gamma_scaled,dist);fragColor=color*(alpha*opacity*fade_opacity);\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "in vec4 a_pos_offset;in vec4 a_data;in vec3 a_projected_pos;in float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform highp float u_camera_to_center_distance;uniform float u_fade_change;uniform vec2 u_texsize;uniform vec2 u_texsize_icon;uniform bool u_is_along_line;uniform bool u_is_variable_anchor;uniform vec2 u_translation;uniform float u_pitched_scale;out vec4 v_data0;out vec4 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;float a_size_min=floor(a_size[0]*0.5);float is_sdf=a_size[0]-2.0*a_size_min;float ele=get_elevation(a_pos);highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec2 translated_a_pos=a_pos+u_translation;vec4 projectedPoint=projectTileWithElevation(translated_a_pos,ele);highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);size*=perspective_ratio;float fontScale=size/24.0;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=projectTileWithElevation(translated_a_pos+vec2(1,0),ele);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos;if (u_is_along_line || u_is_variable_anchor) {projected_pos=vec4(a_projected_pos.xy,ele,1.0);} else if (u_pitch_with_map) {projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy+u_translation,ele,1.0);} else {projected_pos=u_label_plane_matrix*projectTileWithElevation(a_projected_pos.xy+u_translation,ele);}float z=float(u_pitch_with_map)*projected_pos.z/projected_pos.w;float projectionScaling=1.0;\n#ifdef GLOBE\nif(u_pitch_with_map && !u_is_along_line) {float anchor_pos_tile_y=(u_coord_matrix*vec4(projected_pos.xy/projected_pos.w,z,1.0)).y;projectionScaling=mix(projectionScaling,1.0/circumferenceRatioAtTileY(anchor_pos_tile_y)*u_pitched_scale,u_projection_transition);}\n#endif\nvec4 finalPos=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*fontScale)*projectionScaling,z,1.0);if(u_pitch_with_map) {finalPos=projectTileWithElevation(finalPos.xy,finalPos.z);}float gamma_scale=finalPos.w;gl_Position=finalPos;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float visibility=calculate_visibility(projectedPoint);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float interpolated_fade_opacity=max(0.0,min(visibility,fade_opacity[0]+fade_change));v_data0.xy=a_tex/u_texsize;v_data0.zw=a_tex/u_texsize_icon;v_data1=vec4(gamma_scale,size,interpolated_fade_opacity,is_sdf);}"),
                            terrain: _t("uniform sampler2D u_texture;uniform vec4 u_fog_color;uniform vec4 u_horizon_color;uniform float u_fog_ground_blend;uniform float u_fog_ground_blend_opacity;uniform float u_horizon_fog_blend;uniform bool u_is_globe_mode;in vec2 v_texture_pos;in float v_fog_depth;const float gamma=2.2;vec4 gammaToLinear(vec4 color) {return pow(color,vec4(gamma));}vec4 linearToGamma(vec4 color) {return pow(color,vec4(1.0/gamma));}void main() {vec4 surface_color=texture(u_texture,vec2(v_texture_pos.x,1.0-v_texture_pos.y));if (!u_is_globe_mode && v_fog_depth > u_fog_ground_blend) {vec4 surface_color_linear=gammaToLinear(surface_color);float blend_color=smoothstep(0.0,1.0,max((v_fog_depth-u_horizon_fog_blend)/(1.0-u_horizon_fog_blend),0.0));vec4 fog_horizon_color_linear=mix(gammaToLinear(u_fog_color),gammaToLinear(u_horizon_color),blend_color);float factor_fog=max(v_fog_depth-u_fog_ground_blend,0.0)/(1.0-u_fog_ground_blend);fragColor=linearToGamma(mix(surface_color_linear,fog_horizon_color_linear,pow(factor_fog,2.0)*u_fog_ground_blend_opacity));} else {fragColor=surface_color;}}", "in vec3 a_pos3d;uniform mat4 u_fog_matrix;uniform float u_ele_delta;out vec2 v_texture_pos;out float v_fog_depth;void main() {float ele=get_elevation(a_pos3d.xy);float ele_delta=a_pos3d.z==1.0 ? u_ele_delta : 0.0;v_texture_pos=a_pos3d.xy/8192.0;gl_Position=projectTileFor3D(a_pos3d.xy,get_elevation(a_pos3d.xy)-ele_delta);vec4 pos=u_fog_matrix*vec4(a_pos3d.xy,ele,1.0);v_fog_depth=pos.z/pos.w*0.5+0.5;}"),
                            terrainDepth: _t("in float v_depth;const highp vec4 bitSh=vec4(256.*256.*256.,256.*256.,256.,1.);const highp vec4 bitMsk=vec4(0.,vec3(1./256.0));highp vec4 pack(highp float value) {highp vec4 comp=fract(value*bitSh);comp-=comp.xxyz*bitMsk;return comp;}void main() {fragColor=pack(v_depth);}", "in vec3 a_pos3d;uniform float u_ele_delta;out float v_depth;void main() {float ele=get_elevation(a_pos3d.xy);float ele_delta=a_pos3d.z==1.0 ? u_ele_delta : 0.0;gl_Position=projectTileFor3D(a_pos3d.xy,ele-ele_delta);v_depth=gl_Position.z/gl_Position.w;}"),
                            terrainCoords: _t("precision mediump float;uniform sampler2D u_texture;uniform float u_terrain_coords_id;in vec2 v_texture_pos;void main() {vec4 rgba=texture(u_texture,v_texture_pos);fragColor=vec4(rgba.r,rgba.g,rgba.b,u_terrain_coords_id);}", "in vec3 a_pos3d;uniform float u_ele_delta;out vec2 v_texture_pos;void main() {float ele=get_elevation(a_pos3d.xy);float ele_delta=a_pos3d.z==1.0 ? u_ele_delta : 0.0;v_texture_pos=a_pos3d.xy/8192.0;gl_Position=projectTileFor3D(a_pos3d.xy,ele-ele_delta);}"),
                            projectionErrorMeasurement: _t("in vec4 v_output_error_encoded;void main() {fragColor=v_output_error_encoded;}", "in vec2 a_pos;uniform highp float u_input;uniform highp float u_output_expected;out vec4 v_output_error_encoded;void main() {float real_output=2.0*atan(exp(PI-(u_input*PI*2.0)))-PI*0.5;float error=real_output-u_output_expected;float abs_error=abs(error)*128.0;v_output_error_encoded.x=min(floor(abs_error*256.0),255.0)/255.0;abs_error-=v_output_error_encoded.x;v_output_error_encoded.y=min(floor(abs_error*65536.0),255.0)/255.0;abs_error-=v_output_error_encoded.x/255.0;v_output_error_encoded.z=min(floor(abs_error*16777216.0),255.0)/255.0;v_output_error_encoded.w=error >=0.0 ? 1.0 : 0.0;gl_Position=vec4(a_pos,0.0,1.0);}"),
                            atmosphere: _t("in vec3 view_direction;uniform vec3 u_sun_pos;uniform vec3 u_globe_position;uniform float u_globe_radius;uniform float u_atmosphere_blend;/**Shader use from https:*Made some change to adapt to MapLibre Globe geometry*/const float PI=3.141592653589793;const int iSteps=5;const int jSteps=3;/*radius of the planet*/const float EARTH_RADIUS=6371e3;/*radius of the atmosphere*/const float ATMOS_RADIUS=6471e3;vec2 rsi(vec3 r0,vec3 rd,float sr) {float a=dot(rd,rd);float b=2.0*dot(rd,r0);float c=dot(r0,r0)-(sr*sr);float d=(b*b)-4.0*a*c;if (d < 0.0) return vec2(1e5,-1e5);return vec2((-b-sqrt(d))/(2.0*a),(-b+sqrt(d))/(2.0*a));}vec4 atmosphere(vec3 r,vec3 r0,vec3 pSun,float iSun,float rPlanet,float rAtmos,vec3 kRlh,float kMie,float shRlh,float shMie,float g) {pSun=normalize(pSun);r=normalize(r);vec2 p=rsi(r0,r,rAtmos);if (p.x > p.y) {return vec4(0.0,0.0,0.0,1.0);}if (p.x < 0.0) {p.x=0.0;}vec3 pos=r0+r*p.x;vec2 p2=rsi(r0,r,rPlanet);if (p2.x <=p2.y && p2.x > 0.0) {p.y=min(p.y,p2.x);}float iStepSize=(p.y-p.x)/float(iSteps);float iTime=p.x+iStepSize*0.5;vec3 totalRlh=vec3(0,0,0);vec3 totalMie=vec3(0,0,0);float iOdRlh=0.0;float iOdMie=0.0;float mu=dot(r,pSun);float mumu=mu*mu;float gg=g*g;float pRlh=3.0/(16.0*PI)*(1.0+mumu);float pMie=3.0/(8.0*PI)*((1.0-gg)*(mumu+1.0))/(pow(1.0+gg-2.0*mu*g,1.5)*(2.0+gg));for (int i=0; i < iSteps; i++) {vec3 iPos=r0+r*iTime;float iHeight=length(iPos)-rPlanet;float odStepRlh=exp(-iHeight/shRlh)*iStepSize;float odStepMie=exp(-iHeight/shMie)*iStepSize;iOdRlh+=odStepRlh;iOdMie+=odStepMie;float jStepSize=rsi(iPos,pSun,rAtmos).y/float(jSteps);float jTime=jStepSize*0.5;float jOdRlh=0.0;float jOdMie=0.0;for (int j=0; j < jSteps; j++) {vec3 jPos=iPos+pSun*jTime;float jHeight=length(jPos)-rPlanet;jOdRlh+=exp(-jHeight/shRlh)*jStepSize;jOdMie+=exp(-jHeight/shMie)*jStepSize;jTime+=jStepSize;}vec3 attn=exp(-(kMie*(iOdMie+jOdMie)+kRlh*(iOdRlh+jOdRlh)));totalRlh+=odStepRlh*attn;totalMie+=odStepMie*attn;iTime+=iStepSize;}float opacity=exp(-(length(kRlh)*length(totalRlh)+kMie*length(totalMie)));vec3 color=iSun*(pRlh*kRlh*totalRlh+pMie*kMie*totalMie);return vec4(color,opacity);}void main() {vec3 scale_camera_pos=-u_globe_position*EARTH_RADIUS/u_globe_radius;vec4 color=atmosphere(normalize(view_direction),scale_camera_pos,u_sun_pos,22.0,EARTH_RADIUS,ATMOS_RADIUS,vec3(5.5e-6,13.0e-6,22.4e-6),21e-6,8e3,1.2e3,0.758\n);color.rgb=1.0-exp(-1.0*color.rgb);color=pow(color,vec4(1.0/2.2));fragColor=vec4(color.rgb,1.0-color.a)*u_atmosphere_blend;}", "in vec2 a_pos;uniform mat4 u_inv_proj_matrix;out vec3 view_direction;void main() {view_direction=(u_inv_proj_matrix*vec4(a_pos,0.0,1.0)).xyz;gl_Position=vec4(a_pos,0.0,1.0);}"),
                            sky: _t("uniform vec4 u_sky_color;uniform vec4 u_horizon_color;uniform vec2 u_horizon;uniform vec2 u_horizon_normal;uniform float u_sky_horizon_blend;uniform float u_sky_blend;void main() {float x=gl_FragCoord.x;float y=gl_FragCoord.y;float blend=(y-u_horizon.y)*u_horizon_normal.y+(x-u_horizon.x)*u_horizon_normal.x;if (blend > 0.0) {if (blend < u_sky_horizon_blend) {fragColor=mix(u_sky_color,u_horizon_color,pow(1.0-blend/u_sky_horizon_blend,2.0));} else {fragColor=u_sky_color;}}fragColor=mix(fragColor,vec4(vec3(0.0),0.0),u_sky_blend);}", "in vec2 a_pos;void main() {gl_Position=vec4(a_pos,1.0,1.0);}")
                        };
                        function _t(Qe, rt) {
                            const Wn = /#pragma mapbox: ([\w]+) ([\w]+) ([\w]+) ([\w]+)/g, Co = rt.match(/in ([\w]+) ([\w]+)/g), Dl = Qe.match(/uniform ([\w]+) ([\w]+)([\s]*)([\w]*)/g), Ll = rt.match(/uniform ([\w]+) ([\w]+)([\s]*)([\w]*)/g), Rl = Ll ? Ll.concat(Dl) : Dl, Ul = {};
                            return {
                                fragmentSource: Qe = Qe.replace(Wn, (Qe, rt, Wn, Co, Dl)=>(Ul[Dl] = !0, "define" === rt ? `\n#ifndef HAS_UNIFORM_u_${Dl}\nin ${Wn} ${Co} ${Dl};\n#else\nuniform ${Wn} ${Co} u_${Dl};\n#endif\n` : `\n#ifdef HAS_UNIFORM_u_${Dl}\n    ${Wn} ${Co} ${Dl} = u_${Dl};\n#endif\n`)),
                                vertexSource: rt = rt.replace(Wn, (Qe, rt, Wn, Co, Dl)=>{
                                    const Ll = "float" === Co ? "vec2" : "vec4", Rl = Dl.match(/color/) ? "color" : Ll;
                                    return Ul[Dl] ? "define" === rt ? `\n#ifndef HAS_UNIFORM_u_${Dl}\nuniform lowp float u_${Dl}_t;\nin ${Wn} ${Ll} a_${Dl};\nout ${Wn} ${Co} ${Dl};\n#else\nuniform ${Wn} ${Co} u_${Dl};\n#endif\n` : "vec4" === Rl ? `\n#ifndef HAS_UNIFORM_u_${Dl}\n    ${Dl} = a_${Dl};\n#else\n    ${Wn} ${Co} ${Dl} = u_${Dl};\n#endif\n` : `\n#ifndef HAS_UNIFORM_u_${Dl}\n    ${Dl} = unpack_mix_${Rl}(a_${Dl}, u_${Dl}_t);\n#else\n    ${Wn} ${Co} ${Dl} = u_${Dl};\n#endif\n` : "define" === rt ? `\n#ifndef HAS_UNIFORM_u_${Dl}\nuniform lowp float u_${Dl}_t;\nin ${Wn} ${Ll} a_${Dl};\n#else\nuniform ${Wn} ${Co} u_${Dl};\n#endif\n` : "vec4" === Rl ? `\n#ifndef HAS_UNIFORM_u_${Dl}\n    ${Wn} ${Co} ${Dl} = a_${Dl};\n#else\n    ${Wn} ${Co} ${Dl} = u_${Dl};\n#endif\n` : `\n#ifndef HAS_UNIFORM_u_${Dl}\n    ${Wn} ${Co} ${Dl} = unpack_mix_${Rl}(a_${Dl}, u_${Dl}_t);\n#else\n    ${Wn} ${Co} ${Dl} = u_${Dl};\n#endif\n`;
                                }),
                                staticAttributes: Co,
                                staticUniforms: Rl
                            };
                        }
                        class pt {
                            constructor(Qe, rt, Wn){
                                this.vertexBuffer = Qe, this.indexBuffer = rt, this.segments = Wn;
                            }
                            destroy() {
                                this.vertexBuffer.destroy(), this.indexBuffer.destroy(), this.segments.destroy(), this.vertexBuffer = null, this.indexBuffer = null, this.segments = null;
                            }
                        }
                        var od = rt.aD([
                            {
                                name: "a_pos",
                                type: "Int16",
                                components: 2
                            }
                        ]);
                        const ld = "#define PROJECTION_MERCATOR", cd = "mercator";
                        class vt {
                            constructor(){
                                this._cachedMesh = null;
                            }
                            get name() {
                                return "mercator";
                            }
                            get useSubdivision() {
                                return !1;
                            }
                            get shaderVariantName() {
                                return cd;
                            }
                            get shaderDefine() {
                                return ld;
                            }
                            get shaderPreludeCode() {
                                return ad.projectionMercator;
                            }
                            get vertexShaderPreludeCode() {
                                return ad.projectionMercator.vertexSource;
                            }
                            get subdivisionGranularity() {
                                return rt.aE.noSubdivision;
                            }
                            get useGlobeControls() {
                                return !1;
                            }
                            get transitionState() {
                                return 0;
                            }
                            get latitudeErrorCorrectionRadians() {
                                return 0;
                            }
                            destroy() {}
                            updateGPUdependent(Qe) {}
                            getMeshFromTileID(Qe, Wn, Co, Dl, Ll) {
                                if (this._cachedMesh) return this._cachedMesh;
                                const Rl = new rt.aF;
                                Rl.emplaceBack(0, 0), Rl.emplaceBack(rt.Z, 0), Rl.emplaceBack(0, rt.Z), Rl.emplaceBack(rt.Z, rt.Z);
                                const Ul = Qe.createVertexBuffer(Rl, od.members), Gl = rt.aG.simpleSegment(0, 0, 4, 2), Zl = new rt.aH;
                                Zl.emplaceBack(1, 0, 2), Zl.emplaceBack(1, 2, 3);
                                const Hl = Qe.createIndexBuffer(Zl);
                                return this._cachedMesh = new pt(Ul, Hl, Gl), this._cachedMesh;
                            }
                            recalculate() {}
                            hasTransition() {
                                return !1;
                            }
                            setErrorQueryLatitudeDegrees(Qe) {}
                        }
                        function xt(Qe, Wn) {
                            const Co = rt.ae(Wn.lat, -85.051129, rt.aJ);
                            return new rt.P(rt.U(Wn.lng) * Qe, rt.S(Co) * Qe);
                        }
                        function bt(Qe, Wn) {
                            return new rt.$(Wn.x / Qe, Wn.y / Qe).toLngLat();
                        }
                        function yt(Qe) {
                            return Qe.cameraToCenterDistance * Math.min(.85 * Math.tan(rt.ad(90 - Qe.pitch)), Math.tan(rt.ad(89.25 - Qe.pitch)));
                        }
                        function wt(Qe, Wn) {
                            const Co = Qe.canonical, Dl = Wn / rt.aI(Co.z), Ll = Co.x + Math.pow(2, Co.z) * Qe.wrap, Rl = rt.at(new Float64Array(16));
                            return rt.L(Rl, Rl, [
                                Ll * Dl,
                                Co.y * Dl,
                                0
                            ]), rt.M(Rl, Rl, [
                                Dl / rt.Z,
                                Dl / rt.Z,
                                1
                            ]), Rl;
                        }
                        function Tt(Qe, Wn, Co, Dl, Ll) {
                            const Rl = rt.$.fromLngLat(Qe, Wn), Ul = Ll * rt.aK(1, Qe.lat), Gl = Ul * Math.cos(rt.ad(Co)), Zl = Math.sqrt(Ul * Ul - Gl * Gl), Hl = Zl * Math.sin(rt.ad(-Dl)), ql = Zl * Math.cos(rt.ad(-Dl));
                            return new rt.$(Rl.x + Hl, Rl.y + ql, Rl.z + Gl);
                        }
                        class Pt {
                            constructor(Qe = 0, rt = 0, Wn = 0, Co = 0){
                                if (isNaN(Qe) || Qe < 0 || isNaN(rt) || rt < 0 || isNaN(Wn) || Wn < 0 || isNaN(Co) || Co < 0) throw new Error("Invalid value for edge-insets, top, bottom, left and right must all be numbers");
                                this.top = Qe, this.bottom = rt, this.left = Wn, this.right = Co;
                            }
                            interpolate(Qe, Wn, Co) {
                                return null != Wn.top && null != Qe.top && (this.top = rt.B.number(Qe.top, Wn.top, Co)), null != Wn.bottom && null != Qe.bottom && (this.bottom = rt.B.number(Qe.bottom, Wn.bottom, Co)), null != Wn.left && null != Qe.left && (this.left = rt.B.number(Qe.left, Wn.left, Co)), null != Wn.right && null != Qe.right && (this.right = rt.B.number(Qe.right, Wn.right, Co)), this;
                            }
                            getCenter(Qe, Wn) {
                                const Co = rt.ae((this.left + Qe - this.right) / 2, 0, Qe), Dl = rt.ae((this.top + Wn - this.bottom) / 2, 0, Wn);
                                return new rt.P(Co, Dl);
                            }
                            equals(Qe) {
                                return this.top === Qe.top && this.bottom === Qe.bottom && this.left === Qe.left && this.right === Qe.right;
                            }
                            clone() {
                                return new Pt(this.top, this.bottom, this.left, this.right);
                            }
                            toJSON() {
                                return {
                                    top: this.top,
                                    bottom: this.bottom,
                                    left: this.left,
                                    right: this.right
                                };
                            }
                        }
                        function Ct(Qe, rt) {
                            if (!Qe.renderWorldCopies || Qe.lngRange) return;
                            const Wn = rt.lng - Qe.center.lng;
                            rt.lng += Wn > 180 ? -360 : Wn < -180 ? 360 : 0;
                        }
                        function It(Qe) {
                            return Math.max(0, Math.floor(Qe));
                        }
                        class Mt {
                            constructor(Qe, Wn, Co, Dl, Ll, Rl){
                                this._callbacks = Qe, this._tileSize = 512, this._renderWorldCopies = void 0 === Rl || !!Rl, this._minZoom = Wn || 0, this._maxZoom = Co || 22, this._minPitch = null == Dl ? 0 : Dl, this._maxPitch = null == Ll ? 60 : Ll, this.setMaxBounds(), this._width = 0, this._height = 0, this._center = new rt.Q(0, 0), this._elevation = 0, this._zoom = 0, this._tileZoom = It(this._zoom), this._scale = rt.aI(this._zoom), this._bearingInRadians = 0, this._fovInRadians = .6435011087932844, this._pitchInRadians = 0, this._rollInRadians = 0, this._unmodified = !0, this._edgeInsets = new Pt, this._minElevationForCurrentTile = 0, this._autoCalculateNearFarZ = !0;
                            }
                            apply(Qe, Wn, Co) {
                                this._latRange = Qe.latRange, this._lngRange = Qe.lngRange, this._width = Qe.width, this._height = Qe.height, this._center = Qe.center, this._elevation = Qe.elevation, this._minElevationForCurrentTile = Qe.minElevationForCurrentTile, this._zoom = Qe.zoom, this._tileZoom = It(this._zoom), this._scale = rt.aI(this._zoom), this._bearingInRadians = Qe.bearingInRadians, this._fovInRadians = Qe.fovInRadians, this._pitchInRadians = Qe.pitchInRadians, this._rollInRadians = Qe.rollInRadians, this._unmodified = Qe.unmodified, this._edgeInsets = new Pt(Qe.padding.top, Qe.padding.bottom, Qe.padding.left, Qe.padding.right), this._minZoom = Qe.minZoom, this._maxZoom = Qe.maxZoom, this._minPitch = Qe.minPitch, this._maxPitch = Qe.maxPitch, this._renderWorldCopies = Qe.renderWorldCopies, this._cameraToCenterDistance = Qe.cameraToCenterDistance, this._nearZ = Qe.nearZ, this._farZ = Qe.farZ, this._autoCalculateNearFarZ = !Co && Qe.autoCalculateNearFarZ, Wn && this._constrain(), this._calcMatrices();
                            }
                            get pixelsToClipSpaceMatrix() {
                                return this._pixelsToClipSpaceMatrix;
                            }
                            get clipSpaceToPixelsMatrix() {
                                return this._clipSpaceToPixelsMatrix;
                            }
                            get minElevationForCurrentTile() {
                                return this._minElevationForCurrentTile;
                            }
                            setMinElevationForCurrentTile(Qe) {
                                this._minElevationForCurrentTile = Qe;
                            }
                            get tileSize() {
                                return this._tileSize;
                            }
                            get tileZoom() {
                                return this._tileZoom;
                            }
                            get scale() {
                                return this._scale;
                            }
                            get width() {
                                return this._width;
                            }
                            get height() {
                                return this._height;
                            }
                            get bearingInRadians() {
                                return this._bearingInRadians;
                            }
                            get lngRange() {
                                return this._lngRange;
                            }
                            get latRange() {
                                return this._latRange;
                            }
                            get pixelsToGLUnits() {
                                return this._pixelsToGLUnits;
                            }
                            get minZoom() {
                                return this._minZoom;
                            }
                            setMinZoom(Qe) {
                                this._minZoom !== Qe && (this._minZoom = Qe, this.setZoom(this.getConstrained(this._center, this.zoom).zoom));
                            }
                            get maxZoom() {
                                return this._maxZoom;
                            }
                            setMaxZoom(Qe) {
                                this._maxZoom !== Qe && (this._maxZoom = Qe, this.setZoom(this.getConstrained(this._center, this.zoom).zoom));
                            }
                            get minPitch() {
                                return this._minPitch;
                            }
                            setMinPitch(Qe) {
                                this._minPitch !== Qe && (this._minPitch = Qe, this.setPitch(Math.max(this.pitch, Qe)));
                            }
                            get maxPitch() {
                                return this._maxPitch;
                            }
                            setMaxPitch(Qe) {
                                this._maxPitch !== Qe && (this._maxPitch = Qe, this.setPitch(Math.min(this.pitch, Qe)));
                            }
                            get renderWorldCopies() {
                                return this._renderWorldCopies;
                            }
                            setRenderWorldCopies(Qe) {
                                void 0 === Qe ? Qe = !0 : null === Qe && (Qe = !1), this._renderWorldCopies = Qe;
                            }
                            get worldSize() {
                                return this._tileSize * this._scale;
                            }
                            get centerOffset() {
                                return this.centerPoint._sub(this.size._div(2));
                            }
                            get size() {
                                return new rt.P(this._width, this._height);
                            }
                            get bearing() {
                                return this._bearingInRadians / Math.PI * 180;
                            }
                            setBearing(Qe) {
                                const Wn = rt.aL(Qe, -180, 180) * Math.PI / 180;
                                var Co, Dl, Ll, Rl, Ul, Gl, Zl, Hl, ql;
                                this._bearingInRadians !== Wn && (this._unmodified = !1, this._bearingInRadians = Wn, this._calcMatrices(), this._rotationMatrix = r(), Co = this._rotationMatrix, Ll = -this._bearingInRadians, Rl = (Dl = this._rotationMatrix)[0], Ul = Dl[1], Gl = Dl[2], Zl = Dl[3], Hl = Math.sin(Ll), ql = Math.cos(Ll), Co[0] = Rl * ql + Gl * Hl, Co[1] = Ul * ql + Zl * Hl, Co[2] = Rl * -Hl + Gl * ql, Co[3] = Ul * -Hl + Zl * ql);
                            }
                            get rotationMatrix() {
                                return this._rotationMatrix;
                            }
                            get pitchInRadians() {
                                return this._pitchInRadians;
                            }
                            get pitch() {
                                return this._pitchInRadians / Math.PI * 180;
                            }
                            setPitch(Qe) {
                                const Wn = rt.ae(Qe, this.minPitch, this.maxPitch) / 180 * Math.PI;
                                this._pitchInRadians !== Wn && (this._unmodified = !1, this._pitchInRadians = Wn, this._calcMatrices());
                            }
                            get rollInRadians() {
                                return this._rollInRadians;
                            }
                            get roll() {
                                return this._rollInRadians / Math.PI * 180;
                            }
                            setRoll(Qe) {
                                const rt = Qe / 180 * Math.PI;
                                this._rollInRadians !== rt && (this._unmodified = !1, this._rollInRadians = rt, this._calcMatrices());
                            }
                            get fovInRadians() {
                                return this._fovInRadians;
                            }
                            get fov() {
                                return rt.aM(this._fovInRadians);
                            }
                            setFov(Qe) {
                                Qe = rt.ae(Qe, .1, 150), this.fov !== Qe && (this._unmodified = !1, this._fovInRadians = rt.ad(Qe), this._calcMatrices());
                            }
                            get zoom() {
                                return this._zoom;
                            }
                            setZoom(Qe) {
                                const Wn = this.getConstrained(this._center, Qe).zoom;
                                this._zoom !== Wn && (this._unmodified = !1, this._zoom = Wn, this._tileZoom = Math.max(0, Math.floor(Wn)), this._scale = rt.aI(Wn), this._constrain(), this._calcMatrices());
                            }
                            get center() {
                                return this._center;
                            }
                            setCenter(Qe) {
                                Qe.lat === this._center.lat && Qe.lng === this._center.lng || (this._unmodified = !1, this._center = Qe, this._constrain(), this._calcMatrices());
                            }
                            get elevation() {
                                return this._elevation;
                            }
                            setElevation(Qe) {
                                Qe !== this._elevation && (this._elevation = Qe, this._constrain(), this._calcMatrices());
                            }
                            get padding() {
                                return this._edgeInsets.toJSON();
                            }
                            setPadding(Qe) {
                                this._edgeInsets.equals(Qe) || (this._unmodified = !1, this._edgeInsets.interpolate(this._edgeInsets, Qe, 1), this._calcMatrices());
                            }
                            get centerPoint() {
                                return this._edgeInsets.getCenter(this._width, this._height);
                            }
                            get pixelsPerMeter() {
                                return this._pixelPerMeter;
                            }
                            get unmodified() {
                                return this._unmodified;
                            }
                            get cameraToCenterDistance() {
                                return this._cameraToCenterDistance;
                            }
                            get nearZ() {
                                return this._nearZ;
                            }
                            get farZ() {
                                return this._farZ;
                            }
                            get autoCalculateNearFarZ() {
                                return this._autoCalculateNearFarZ;
                            }
                            overrideNearFarZ(Qe, rt) {
                                this._autoCalculateNearFarZ = !1, this._nearZ = Qe, this._farZ = rt, this._calcMatrices();
                            }
                            clearNearFarZOverride() {
                                this._autoCalculateNearFarZ = !0, this._calcMatrices();
                            }
                            isPaddingEqual(Qe) {
                                return this._edgeInsets.equals(Qe);
                            }
                            interpolatePadding(Qe, rt, Wn) {
                                this._unmodified = !1, this._edgeInsets.interpolate(Qe, rt, Wn), this._constrain(), this._calcMatrices();
                            }
                            resize(Qe, rt, Wn = !0) {
                                this._width = Qe, this._height = rt, Wn && this._constrain(), this._calcMatrices();
                            }
                            getMaxBounds() {
                                return this._latRange && 2 === this._latRange.length && this._lngRange && 2 === this._lngRange.length ? new V([
                                    this._lngRange[0],
                                    this._latRange[0]
                                ], [
                                    this._lngRange[1],
                                    this._latRange[1]
                                ]) : null;
                            }
                            setMaxBounds(Qe) {
                                Qe ? (this._lngRange = [
                                    Qe.getWest(),
                                    Qe.getEast()
                                ], this._latRange = [
                                    Qe.getSouth(),
                                    Qe.getNorth()
                                ], this._constrain()) : (this._lngRange = null, this._latRange = [
                                    -85.051129,
                                    rt.aJ
                                ]);
                            }
                            getConstrained(Qe, rt) {
                                return this._callbacks.getConstrained(Qe, rt);
                            }
                            getCameraQueryGeometry(Qe, Wn) {
                                if (1 === Wn.length) return [
                                    Wn[0],
                                    Qe
                                ];
                                {
                                    let Co = Qe.x, Dl = Qe.y, Ll = Qe.x, Rl = Qe.y;
                                    for (const Qe of Wn)Co = Math.min(Co, Qe.x), Dl = Math.min(Dl, Qe.y), Ll = Math.max(Ll, Qe.x), Rl = Math.max(Rl, Qe.y);
                                    return [
                                        new rt.P(Co, Dl),
                                        new rt.P(Ll, Dl),
                                        new rt.P(Ll, Rl),
                                        new rt.P(Co, Rl),
                                        new rt.P(Co, Dl)
                                    ];
                                }
                            }
                            _constrain() {
                                if (!this.center || !this._width || !this._height || this._constraining) return;
                                this._constraining = !0;
                                const Qe = this._unmodified, { center: rt, zoom: Wn } = this.getConstrained(this.center, this.zoom);
                                this.setCenter(rt), this.setZoom(Wn), this._unmodified = Qe, this._constraining = !1;
                            }
                            _calcMatrices() {
                                if (this._width && this._height) {
                                    this._pixelsToGLUnits = [
                                        2 / this._width,
                                        -2 / this._height
                                    ];
                                    let Qe = rt.at(new Float64Array(16));
                                    rt.M(Qe, Qe, [
                                        this._width / 2,
                                        -this._height / 2,
                                        1
                                    ]), rt.L(Qe, Qe, [
                                        1,
                                        -1,
                                        0
                                    ]), this._clipSpaceToPixelsMatrix = Qe, Qe = rt.at(new Float64Array(16)), rt.M(Qe, Qe, [
                                        1,
                                        -1,
                                        1
                                    ]), rt.L(Qe, Qe, [
                                        -1,
                                        -1,
                                        0
                                    ]), rt.M(Qe, Qe, [
                                        2 / this._width,
                                        2 / this._height,
                                        1
                                    ]), this._pixelsToClipSpaceMatrix = Qe, this._cameraToCenterDistance = .5 / Math.tan(this.fovInRadians / 2) * this._height;
                                }
                                this._callbacks.calcMatrices();
                            }
                            calculateCenterFromCameraLngLatAlt(Qe, Wn, Co, Dl) {
                                const Ll = void 0 !== Co ? Co : this.bearing, Rl = Dl = void 0 !== Dl ? Dl : this.pitch, Ul = rt.$.fromLngLat(Qe, Wn), Gl = -Math.cos(rt.ad(Rl)), Zl = Math.sin(rt.ad(Rl)), Hl = Zl * Math.sin(rt.ad(Ll)), ql = -Zl * Math.cos(rt.ad(Ll));
                                let Ql = this.elevation;
                                const Kl = Wn - Ql;
                                let $l;
                                Gl * Kl >= 0 || Math.abs(Gl) < .1 ? ($l = 1e4, Ql = Wn + $l * Gl) : $l = -Kl / Gl;
                                let Tc, tu, lu = rt.aN(1, Ul.y), du = 0;
                                do {
                                    if (du += 1, du > 10) break;
                                    tu = $l / lu, Tc = new rt.$(Ul.x + Hl * tu, Ul.y + ql * tu), lu = 1 / Tc.meterInMercatorCoordinateUnits();
                                }while (Math.abs($l - tu * lu) > 1e-12);
                                return {
                                    center: Tc.toLngLat(),
                                    elevation: Ql,
                                    zoom: rt.ab(this.height / 2 / Math.tan(this.fovInRadians / 2) / tu / this.tileSize)
                                };
                            }
                            recalculateZoomAndCenter(Qe) {
                                if (this.elevation - Qe == 0) return;
                                const Wn = rt.aK(1, this.center.lat) * this.worldSize, Co = this.cameraToCenterDistance / Wn, Dl = rt.$.fromLngLat(this.center, this.elevation), Ll = Tt(this.center, this.elevation, this.pitch, this.bearing, Co);
                                this._elevation = Qe;
                                const Rl = this.calculateCenterFromCameraLngLatAlt(Ll.toLngLat(), rt.aN(Ll.z, Dl.y), this.bearing, this.pitch);
                                this._elevation = Rl.elevation, this._center = Rl.center, this.setZoom(Rl.zoom);
                            }
                            getCameraPoint() {
                                const Qe = Math.tan(this.pitchInRadians) * (this.cameraToCenterDistance || 1);
                                return this.centerPoint.add(new rt.P(Qe * Math.sin(this.rollInRadians), Qe * Math.cos(this.rollInRadians)));
                            }
                            getCameraAltitude() {
                                return Math.cos(this.pitchInRadians) * this._cameraToCenterDistance / this._pixelPerMeter + this.elevation;
                            }
                            getCameraLngLat() {
                                const Qe = rt.aK(1, this.center.lat) * this.worldSize;
                                return Tt(this.center, this.elevation, this.pitch, this.bearing, this.cameraToCenterDistance / Qe).toLngLat();
                            }
                            getMercatorTileCoordinates(Qe) {
                                if (!Qe) return [
                                    0,
                                    0,
                                    1,
                                    1
                                ];
                                const Wn = Qe.canonical.z >= 0 ? 1 << Qe.canonical.z : Math.pow(2, Qe.canonical.z);
                                return [
                                    Qe.canonical.x / Wn,
                                    Qe.canonical.y / Wn,
                                    1 / Wn / rt.Z,
                                    1 / Wn / rt.Z
                                ];
                            }
                        }
                        class Et {
                            constructor(Qe, Wn){
                                this.min = Qe, this.max = Wn, this.center = rt.aO([], rt.aP([], this.min, this.max), .5);
                            }
                            quadrant(Qe) {
                                const Wn = [
                                    Qe % 2 == 0,
                                    Qe < 2
                                ], Co = rt.aQ(this.min), Dl = rt.aQ(this.max);
                                for(let rt = 0; rt < Wn.length; rt++)Co[rt] = Wn[rt] ? this.min[rt] : this.center[rt], Dl[rt] = Wn[rt] ? this.center[rt] : this.max[rt];
                                return Dl[2] = this.max[2], new Et(Co, Dl);
                            }
                            distanceX(Qe) {
                                return Math.max(Math.min(this.max[0], Qe[0]), this.min[0]) - Qe[0];
                            }
                            distanceY(Qe) {
                                return Math.max(Math.min(this.max[1], Qe[1]), this.min[1]) - Qe[1];
                            }
                            intersectsFrustum(Qe) {
                                let rt = !0;
                                for(let Wn = 0; Wn < Qe.planes.length; Wn++){
                                    const Co = this.intersectsPlane(Qe.planes[Wn]);
                                    if (0 === Co) return 0;
                                    1 === Co && (rt = !1);
                                }
                                return rt ? 2 : Qe.aabb.min[0] > this.max[0] || Qe.aabb.min[1] > this.max[1] || Qe.aabb.min[2] > this.max[2] || Qe.aabb.max[0] < this.min[0] || Qe.aabb.max[1] < this.min[1] || Qe.aabb.max[2] < this.min[2] ? 0 : 1;
                            }
                            intersectsPlane(Qe) {
                                let rt = Qe[3], Wn = Qe[3];
                                for(let Co = 0; Co < 3; Co++)Qe[Co] > 0 ? (rt += Qe[Co] * this.min[Co], Wn += Qe[Co] * this.max[Co]) : (Wn += Qe[Co] * this.min[Co], rt += Qe[Co] * this.max[Co]);
                                return rt >= 0 ? 2 : Wn < 0 ? 0 : 1;
                            }
                        }
                        class St {
                            distanceToTile2d(Qe, rt, Wn, Co) {
                                const Dl = Co.distanceX([
                                    Qe,
                                    rt
                                ]), Ll = Co.distanceY([
                                    Qe,
                                    rt
                                ]);
                                return Math.hypot(Dl, Ll);
                            }
                            getWrap(Qe, rt, Wn) {
                                return Wn;
                            }
                            getTileAABB(Qe, Wn, Co, Dl) {
                                var Ll, Rl;
                                let Ul = Co, Gl = Co;
                                if (Dl.terrain) {
                                    const Zl = new rt.Y(Qe.z, Wn, Qe.z, Qe.x, Qe.y), Hl = Dl.terrain.getMinMaxElevation(Zl);
                                    Ul = null !== (Ll = Hl.minElevation) && void 0 !== Ll ? Ll : Co, Gl = null !== (Rl = Hl.maxElevation) && void 0 !== Rl ? Rl : Co;
                                }
                                const Zl = 1 << Qe.z;
                                return new Et([
                                    Wn + Qe.x / Zl,
                                    Qe.y / Zl,
                                    Ul
                                ], [
                                    Wn + (Qe.x + 1) / Zl,
                                    (Qe.y + 1) / Zl,
                                    Gl
                                ]);
                            }
                            allowVariableZoom(Qe, Wn) {
                                const Co = Qe.fov * (Math.abs(Math.cos(Qe.rollInRadians)) * Qe.height + Math.abs(Math.sin(Qe.rollInRadians)) * Qe.width) / Qe.height, Dl = rt.ae(78.5 - Co / 2, 0, 60);
                                return !!Wn.terrain || Qe.pitch > Dl;
                            }
                            allowWorldCopies() {
                                return !0;
                            }
                            recalculateCache() {}
                        }
                        class Rt {
                            constructor(Qe, rt, Wn){
                                this.points = Qe, this.planes = rt, this.aabb = Wn;
                            }
                            static fromInvProjectionMatrix(Qe, Wn = 1, Co = 0) {
                                const Dl = Math.pow(2, Co), Ll = [
                                    [
                                        -1,
                                        1,
                                        -1,
                                        1
                                    ],
                                    [
                                        1,
                                        1,
                                        -1,
                                        1
                                    ],
                                    [
                                        1,
                                        -1,
                                        -1,
                                        1
                                    ],
                                    [
                                        -1,
                                        -1,
                                        -1,
                                        1
                                    ],
                                    [
                                        -1,
                                        1,
                                        1,
                                        1
                                    ],
                                    [
                                        1,
                                        1,
                                        1,
                                        1
                                    ],
                                    [
                                        1,
                                        -1,
                                        1,
                                        1
                                    ],
                                    [
                                        -1,
                                        -1,
                                        1,
                                        1
                                    ]
                                ].map((Co)=>{
                                    const Ll = 1 / (Co = rt.ap([], Co, Qe))[3] / Wn * Dl;
                                    return rt.aR(Co, Co, [
                                        Ll,
                                        Ll,
                                        1 / Co[3],
                                        Ll
                                    ]);
                                }), Rl = [
                                    [
                                        0,
                                        1,
                                        2
                                    ],
                                    [
                                        6,
                                        5,
                                        4
                                    ],
                                    [
                                        0,
                                        3,
                                        7
                                    ],
                                    [
                                        2,
                                        1,
                                        5
                                    ],
                                    [
                                        3,
                                        2,
                                        6
                                    ],
                                    [
                                        0,
                                        4,
                                        5
                                    ]
                                ].map((Qe)=>{
                                    const Wn = rt.aS([], Ll[Qe[0]], Ll[Qe[1]]), Co = rt.aS([], Ll[Qe[2]], Ll[Qe[1]]), Dl = rt.aT([], rt.aU([], Wn, Co)), Rl = -rt.aV(Dl, Ll[Qe[1]]);
                                    return Dl.concat(Rl);
                                }), Ul = [
                                    Number.POSITIVE_INFINITY,
                                    Number.POSITIVE_INFINITY,
                                    Number.POSITIVE_INFINITY
                                ], Gl = [
                                    Number.NEGATIVE_INFINITY,
                                    Number.NEGATIVE_INFINITY,
                                    Number.NEGATIVE_INFINITY
                                ];
                                for (const rt of Ll)for(let Qe = 0; Qe < 3; Qe++)Ul[Qe] = Math.min(Ul[Qe], rt[Qe]), Gl[Qe] = Math.max(Gl[Qe], rt[Qe]);
                                return new Rt(Ll, Rl, new Et(Ul, Gl));
                            }
                        }
                        class Dt {
                            get pixelsToClipSpaceMatrix() {
                                return this._helper.pixelsToClipSpaceMatrix;
                            }
                            get clipSpaceToPixelsMatrix() {
                                return this._helper.clipSpaceToPixelsMatrix;
                            }
                            get pixelsToGLUnits() {
                                return this._helper.pixelsToGLUnits;
                            }
                            get centerOffset() {
                                return this._helper.centerOffset;
                            }
                            get size() {
                                return this._helper.size;
                            }
                            get rotationMatrix() {
                                return this._helper.rotationMatrix;
                            }
                            get centerPoint() {
                                return this._helper.centerPoint;
                            }
                            get pixelsPerMeter() {
                                return this._helper.pixelsPerMeter;
                            }
                            setMinZoom(Qe) {
                                this._helper.setMinZoom(Qe);
                            }
                            setMaxZoom(Qe) {
                                this._helper.setMaxZoom(Qe);
                            }
                            setMinPitch(Qe) {
                                this._helper.setMinPitch(Qe);
                            }
                            setMaxPitch(Qe) {
                                this._helper.setMaxPitch(Qe);
                            }
                            setRenderWorldCopies(Qe) {
                                this._helper.setRenderWorldCopies(Qe);
                            }
                            setBearing(Qe) {
                                this._helper.setBearing(Qe);
                            }
                            setPitch(Qe) {
                                this._helper.setPitch(Qe);
                            }
                            setRoll(Qe) {
                                this._helper.setRoll(Qe);
                            }
                            setFov(Qe) {
                                this._helper.setFov(Qe);
                            }
                            setZoom(Qe) {
                                this._helper.setZoom(Qe);
                            }
                            setCenter(Qe) {
                                this._helper.setCenter(Qe);
                            }
                            setElevation(Qe) {
                                this._helper.setElevation(Qe);
                            }
                            setMinElevationForCurrentTile(Qe) {
                                this._helper.setMinElevationForCurrentTile(Qe);
                            }
                            setPadding(Qe) {
                                this._helper.setPadding(Qe);
                            }
                            interpolatePadding(Qe, rt, Wn) {
                                return this._helper.interpolatePadding(Qe, rt, Wn);
                            }
                            isPaddingEqual(Qe) {
                                return this._helper.isPaddingEqual(Qe);
                            }
                            resize(Qe, rt, Wn = !0) {
                                this._helper.resize(Qe, rt, Wn);
                            }
                            getMaxBounds() {
                                return this._helper.getMaxBounds();
                            }
                            setMaxBounds(Qe) {
                                this._helper.setMaxBounds(Qe);
                            }
                            overrideNearFarZ(Qe, rt) {
                                this._helper.overrideNearFarZ(Qe, rt);
                            }
                            clearNearFarZOverride() {
                                this._helper.clearNearFarZOverride();
                            }
                            getCameraQueryGeometry(Qe) {
                                return this._helper.getCameraQueryGeometry(this.getCameraPoint(), Qe);
                            }
                            get tileSize() {
                                return this._helper.tileSize;
                            }
                            get tileZoom() {
                                return this._helper.tileZoom;
                            }
                            get scale() {
                                return this._helper.scale;
                            }
                            get worldSize() {
                                return this._helper.worldSize;
                            }
                            get width() {
                                return this._helper.width;
                            }
                            get height() {
                                return this._helper.height;
                            }
                            get lngRange() {
                                return this._helper.lngRange;
                            }
                            get latRange() {
                                return this._helper.latRange;
                            }
                            get minZoom() {
                                return this._helper.minZoom;
                            }
                            get maxZoom() {
                                return this._helper.maxZoom;
                            }
                            get zoom() {
                                return this._helper.zoom;
                            }
                            get center() {
                                return this._helper.center;
                            }
                            get minPitch() {
                                return this._helper.minPitch;
                            }
                            get maxPitch() {
                                return this._helper.maxPitch;
                            }
                            get pitch() {
                                return this._helper.pitch;
                            }
                            get pitchInRadians() {
                                return this._helper.pitchInRadians;
                            }
                            get roll() {
                                return this._helper.roll;
                            }
                            get rollInRadians() {
                                return this._helper.rollInRadians;
                            }
                            get bearing() {
                                return this._helper.bearing;
                            }
                            get bearingInRadians() {
                                return this._helper.bearingInRadians;
                            }
                            get fov() {
                                return this._helper.fov;
                            }
                            get fovInRadians() {
                                return this._helper.fovInRadians;
                            }
                            get elevation() {
                                return this._helper.elevation;
                            }
                            get minElevationForCurrentTile() {
                                return this._helper.minElevationForCurrentTile;
                            }
                            get padding() {
                                return this._helper.padding;
                            }
                            get unmodified() {
                                return this._helper.unmodified;
                            }
                            get renderWorldCopies() {
                                return this._helper.renderWorldCopies;
                            }
                            get cameraToCenterDistance() {
                                return this._helper.cameraToCenterDistance;
                            }
                            get nearZ() {
                                return this._helper.nearZ;
                            }
                            get farZ() {
                                return this._helper.farZ;
                            }
                            get autoCalculateNearFarZ() {
                                return this._helper.autoCalculateNearFarZ;
                            }
                            setTransitionState(Qe, rt) {}
                            constructor(Qe, rt, Wn, Co, Dl){
                                this._posMatrixCache = new Map, this._alignedPosMatrixCache = new Map, this._fogMatrixCacheF32 = new Map, this._helper = new Mt({
                                    calcMatrices: ()=>{
                                        this._calcMatrices();
                                    },
                                    getConstrained: (Qe, rt)=>this.getConstrained(Qe, rt)
                                }, Qe, rt, Wn, Co, Dl), this._coveringTilesDetailsProvider = new St;
                            }
                            clone() {
                                const Qe = new Dt;
                                return Qe.apply(this), Qe;
                            }
                            apply(Qe, rt, Wn) {
                                this._helper.apply(Qe, rt, Wn);
                            }
                            get cameraPosition() {
                                return this._cameraPosition;
                            }
                            get projectionMatrix() {
                                return this._projectionMatrix;
                            }
                            get modelViewProjectionMatrix() {
                                return this._viewProjMatrix;
                            }
                            get inverseProjectionMatrix() {
                                return this._invProjMatrix;
                            }
                            get mercatorMatrix() {
                                return this._mercatorMatrix;
                            }
                            getVisibleUnwrappedCoordinates(Qe) {
                                const Wn = [
                                    new rt.aW(0, Qe)
                                ];
                                if (this._helper._renderWorldCopies) {
                                    const Co = this.screenPointToMercatorCoordinate(new rt.P(0, 0)), Dl = this.screenPointToMercatorCoordinate(new rt.P(this._helper._width, 0)), Ll = this.screenPointToMercatorCoordinate(new rt.P(this._helper._width, this._helper._height)), Rl = this.screenPointToMercatorCoordinate(new rt.P(0, this._helper._height)), Ul = Math.floor(Math.min(Co.x, Dl.x, Ll.x, Rl.x)), Gl = Math.floor(Math.max(Co.x, Dl.x, Ll.x, Rl.x)), Zl = 1;
                                    for(let Hl = Ul - Zl; Hl <= Gl + Zl; Hl++)0 !== Hl && Wn.push(new rt.aW(Hl, Qe));
                                }
                                return Wn;
                            }
                            getCameraFrustum() {
                                return Rt.fromInvProjectionMatrix(this._invViewProjMatrix, this.worldSize);
                            }
                            getClippingPlane() {
                                return null;
                            }
                            getCoveringTilesDetailsProvider() {
                                return this._coveringTilesDetailsProvider;
                            }
                            recalculateZoomAndCenter(Qe) {
                                const rt = this.screenPointToLocation(this.centerPoint, Qe), Wn = Qe ? Qe.getElevationForLngLatZoom(rt, this._helper._tileZoom) : 0;
                                this._helper.recalculateZoomAndCenter(Wn);
                            }
                            setLocationAtPoint(Qe, Wn) {
                                const Co = rt.aK(this.elevation, this.center.lat), Dl = this.screenPointToMercatorCoordinateAtZ(Wn, Co), Ll = this.screenPointToMercatorCoordinateAtZ(this.centerPoint, Co), Rl = rt.$.fromLngLat(Qe), Ul = new rt.$(Rl.x - (Dl.x - Ll.x), Rl.y - (Dl.y - Ll.y));
                                this.setCenter(null == Ul ? void 0 : Ul.toLngLat()), this._helper._renderWorldCopies && this.setCenter(this.center.wrap());
                            }
                            locationToScreenPoint(Qe, Wn) {
                                return Wn ? this.coordinatePoint(rt.$.fromLngLat(Qe), Wn.getElevationForLngLatZoom(Qe, this._helper._tileZoom), this._pixelMatrix3D) : this.coordinatePoint(rt.$.fromLngLat(Qe));
                            }
                            screenPointToLocation(Qe, rt) {
                                var Wn;
                                return null === (Wn = this.screenPointToMercatorCoordinate(Qe, rt)) || void 0 === Wn ? void 0 : Wn.toLngLat();
                            }
                            screenPointToMercatorCoordinate(Qe, rt) {
                                if (rt) {
                                    const Wn = rt.pointCoordinate(Qe);
                                    if (null != Wn) return Wn;
                                }
                                return this.screenPointToMercatorCoordinateAtZ(Qe);
                            }
                            screenPointToMercatorCoordinateAtZ(Qe, Wn) {
                                const Co = Wn || 0, Dl = [
                                    Qe.x,
                                    Qe.y,
                                    0,
                                    1
                                ], Ll = [
                                    Qe.x,
                                    Qe.y,
                                    1,
                                    1
                                ];
                                rt.ap(Dl, Dl, this._pixelMatrixInverse), rt.ap(Ll, Ll, this._pixelMatrixInverse);
                                const Rl = Dl[3], Ul = Ll[3], Gl = Dl[1] / Rl, Zl = Ll[1] / Ul, Hl = Dl[2] / Rl, ql = Ll[2] / Ul, Ql = Hl === ql ? 0 : (Co - Hl) / (ql - Hl);
                                return new rt.$(rt.B.number(Dl[0] / Rl, Ll[0] / Ul, Ql) / this.worldSize, rt.B.number(Gl, Zl, Ql) / this.worldSize, Co);
                            }
                            coordinatePoint(Qe, Wn = 0, Co = this._pixelMatrix) {
                                const Dl = [
                                    Qe.x * this.worldSize,
                                    Qe.y * this.worldSize,
                                    Wn,
                                    1
                                ];
                                return rt.ap(Dl, Dl, Co), new rt.P(Dl[0] / Dl[3], Dl[1] / Dl[3]);
                            }
                            getBounds() {
                                const Qe = Math.max(0, this._helper._height / 2 - yt(this));
                                return (new V).extend(this.screenPointToLocation(new rt.P(0, Qe))).extend(this.screenPointToLocation(new rt.P(this._helper._width, Qe))).extend(this.screenPointToLocation(new rt.P(this._helper._width, this._helper._height))).extend(this.screenPointToLocation(new rt.P(0, this._helper._height)));
                            }
                            isPointOnMapSurface(Qe, rt) {
                                return rt ? null != rt.pointCoordinate(Qe) : Qe.y > this.height / 2 - yt(this);
                            }
                            calculatePosMatrix(Qe, Wn = !1, Co) {
                                var Dl;
                                const Ll = null !== (Dl = Qe.key) && void 0 !== Dl ? Dl : rt.aX(Qe.wrap, Qe.canonical.z, Qe.canonical.z, Qe.canonical.x, Qe.canonical.y), Rl = Wn ? this._alignedPosMatrixCache : this._posMatrixCache;
                                if (Rl.has(Ll)) {
                                    const Qe = Rl.get(Ll);
                                    return Co ? Qe.f32 : Qe.f64;
                                }
                                const Ul = wt(Qe, this.worldSize);
                                rt.N(Ul, Wn ? this._alignedProjMatrix : this._viewProjMatrix, Ul);
                                const Gl = {
                                    f64: Ul,
                                    f32: new Float32Array(Ul)
                                };
                                return Rl.set(Ll, Gl), Co ? Gl.f32 : Gl.f64;
                            }
                            calculateFogMatrix(Qe) {
                                const Wn = Qe.key, Co = this._fogMatrixCacheF32;
                                if (Co.has(Wn)) return Co.get(Wn);
                                const Dl = wt(Qe, this.worldSize);
                                return rt.N(Dl, this._fogMatrix, Dl), Co.set(Wn, new Float32Array(Dl)), Co.get(Wn);
                            }
                            getConstrained(Qe, Wn) {
                                Wn = rt.ae(+Wn, this.minZoom, this.maxZoom);
                                const Co = {
                                    center: new rt.Q(Qe.lng, Qe.lat),
                                    zoom: Wn
                                };
                                let Dl = this._helper._lngRange;
                                this._helper._renderWorldCopies || null !== Dl || (Dl = [
                                    -179.9999999999,
                                    180 - 1e-10
                                ]);
                                const Ll = this.tileSize * rt.aI(Co.zoom);
                                let Rl = 0, Ul = Ll, Gl = 0, Zl = Ll, Hl = 0, ql = 0;
                                const { x: Ql, y: Kl } = this.size;
                                if (this._helper._latRange) {
                                    const Qe = this._helper._latRange;
                                    Rl = rt.S(Qe[1]) * Ll, Ul = rt.S(Qe[0]) * Ll, Ul - Rl < Kl && (Hl = Kl / (Ul - Rl));
                                }
                                Dl && (Gl = rt.aL(rt.U(Dl[0]) * Ll, 0, Ll), Zl = rt.aL(rt.U(Dl[1]) * Ll, 0, Ll), Zl < Gl && (Zl += Ll), Zl - Gl < Ql && (ql = Ql / (Zl - Gl)));
                                const { x: $l, y: Tc } = xt(Ll, Qe);
                                let tu, lu;
                                const du = Math.max(ql || 0, Hl || 0);
                                if (du) {
                                    const Qe = new rt.P(ql ? (Zl + Gl) / 2 : $l, Hl ? (Ul + Rl) / 2 : Tc);
                                    return Co.center = bt(Ll, Qe).wrap(), Co.zoom += rt.ab(du), Co;
                                }
                                if (this._helper._latRange) {
                                    const Qe = Kl / 2;
                                    Tc - Qe < Rl && (lu = Rl + Qe), Tc + Qe > Ul && (lu = Ul - Qe);
                                }
                                if (Dl) {
                                    const Qe = (Gl + Zl) / 2;
                                    let Wn = $l;
                                    this._helper._renderWorldCopies && (Wn = rt.aL($l, Qe - Ll / 2, Qe + Ll / 2));
                                    const Co = Ql / 2;
                                    Wn - Co < Gl && (tu = Gl + Co), Wn + Co > Zl && (tu = Zl - Co);
                                }
                                if (void 0 !== tu || void 0 !== lu) {
                                    const Qe = new rt.P(null != tu ? tu : $l, null != lu ? lu : Tc);
                                    Co.center = bt(Ll, Qe).wrap();
                                }
                                return Co;
                            }
                            calculateCenterFromCameraLngLatAlt(Qe, rt, Wn, Co) {
                                return this._helper.calculateCenterFromCameraLngLatAlt(Qe, rt, Wn, Co);
                            }
                            _calculateNearFarZIfNeeded(Qe, Wn, Co) {
                                if (!this._helper.autoCalculateNearFarZ) return;
                                const Dl = Math.min(this.elevation, this.minElevationForCurrentTile, this.getCameraAltitude() - 100), Ll = Qe - Dl * this._helper._pixelPerMeter / Math.cos(Wn), Rl = Dl < 0 ? Ll : Qe, Ul = Math.PI / 2 + this.pitchInRadians, Gl = rt.ad(this.fov) * (Math.abs(Math.cos(rt.ad(this.roll))) * this.height + Math.abs(Math.sin(rt.ad(this.roll))) * this.width) / this.height * (.5 + Co.y / this.height), Zl = Math.sin(Gl) * Rl / Math.sin(rt.ae(Math.PI - Ul - Gl, .01, Math.PI - .01)), Hl = yt(this), ql = Math.atan(Hl / this._helper.cameraToCenterDistance), Ql = rt.ad(.75), Kl = ql > Ql ? 2 * ql * (.5 + Co.y / (2 * Hl)) : Ql, $l = Math.sin(Kl) * Rl / Math.sin(rt.ae(Math.PI - Ul - Kl, .01, Math.PI - .01)), Tc = Math.min(Zl, $l);
                                this._helper._farZ = 1.01 * (Math.cos(Math.PI / 2 - Wn) * Tc + Rl), this._helper._nearZ = this._helper._height / 50;
                            }
                            _calcMatrices() {
                                if (!this._helper._height) return;
                                const Qe = this.centerOffset, Wn = xt(this.worldSize, this.center), Co = Wn.x, Dl = Wn.y;
                                this._helper._pixelPerMeter = rt.aK(1, this.center.lat) * this.worldSize;
                                const Ll = rt.ad(Math.min(this.pitch, 89.25)), Rl = Math.max(this._helper.cameraToCenterDistance / 2, this._helper.cameraToCenterDistance + this._helper._elevation * this._helper._pixelPerMeter / Math.cos(Ll));
                                let Ul;
                                this._calculateNearFarZIfNeeded(Rl, Ll, Qe), Ul = new Float64Array(16), rt.aY(Ul, this.fovInRadians, this._helper._width / this._helper._height, this._helper._nearZ, this._helper._farZ), this._invProjMatrix = new Float64Array(16), rt.aj(this._invProjMatrix, Ul), Ul[8] = 2 * -Qe.x / this._helper._width, Ul[9] = 2 * Qe.y / this._helper._height, this._projectionMatrix = rt.aZ(Ul), rt.M(Ul, Ul, [
                                    1,
                                    -1,
                                    1
                                ]), rt.L(Ul, Ul, [
                                    0,
                                    0,
                                    -this._helper.cameraToCenterDistance
                                ]), rt.a_(Ul, Ul, -this.rollInRadians), rt.a$(Ul, Ul, this.pitchInRadians), rt.a_(Ul, Ul, -this.bearingInRadians), rt.L(Ul, Ul, [
                                    -Co,
                                    -Dl,
                                    0
                                ]), this._mercatorMatrix = rt.M([], Ul, [
                                    this.worldSize,
                                    this.worldSize,
                                    this.worldSize
                                ]), rt.M(Ul, Ul, [
                                    1,
                                    1,
                                    this._helper._pixelPerMeter
                                ]), this._pixelMatrix = rt.N(new Float64Array(16), this.clipSpaceToPixelsMatrix, Ul), rt.L(Ul, Ul, [
                                    0,
                                    0,
                                    -this.elevation
                                ]), this._viewProjMatrix = Ul, this._invViewProjMatrix = rt.aj([], Ul);
                                const Gl = [
                                    0,
                                    0,
                                    -1,
                                    1
                                ];
                                rt.ap(Gl, Gl, this._invViewProjMatrix), this._cameraPosition = [
                                    Gl[0] / Gl[3],
                                    Gl[1] / Gl[3],
                                    Gl[2] / Gl[3]
                                ], this._fogMatrix = new Float64Array(16), rt.aY(this._fogMatrix, this.fovInRadians, this.width / this.height, Rl, this._helper._farZ), this._fogMatrix[8] = 2 * -Qe.x / this.width, this._fogMatrix[9] = 2 * Qe.y / this.height, rt.M(this._fogMatrix, this._fogMatrix, [
                                    1,
                                    -1,
                                    1
                                ]), rt.L(this._fogMatrix, this._fogMatrix, [
                                    0,
                                    0,
                                    -this.cameraToCenterDistance
                                ]), rt.a_(this._fogMatrix, this._fogMatrix, -this.rollInRadians), rt.a$(this._fogMatrix, this._fogMatrix, this.pitchInRadians), rt.a_(this._fogMatrix, this._fogMatrix, -this.bearingInRadians), rt.L(this._fogMatrix, this._fogMatrix, [
                                    -Co,
                                    -Dl,
                                    0
                                ]), rt.M(this._fogMatrix, this._fogMatrix, [
                                    1,
                                    1,
                                    this._helper._pixelPerMeter
                                ]), rt.L(this._fogMatrix, this._fogMatrix, [
                                    0,
                                    0,
                                    -this.elevation
                                ]), this._pixelMatrix3D = rt.N(new Float64Array(16), this.clipSpaceToPixelsMatrix, Ul);
                                const Zl = this._helper._width % 2 / 2, Hl = this._helper._height % 2 / 2, ql = Math.cos(this.bearingInRadians), Ql = Math.sin(-this.bearingInRadians), Kl = Co - Math.round(Co) + ql * Zl + Ql * Hl, $l = Dl - Math.round(Dl) + ql * Hl + Ql * Zl, Tc = new Float64Array(Ul);
                                if (rt.L(Tc, Tc, [
                                    Kl > .5 ? Kl - 1 : Kl,
                                    $l > .5 ? $l - 1 : $l,
                                    0
                                ]), this._alignedProjMatrix = Tc, Ul = rt.aj(new Float64Array(16), this._pixelMatrix), !Ul) throw new Error("failed to invert matrix");
                                this._pixelMatrixInverse = Ul, this._clearMatrixCaches();
                            }
                            _clearMatrixCaches() {
                                this._posMatrixCache.clear(), this._alignedPosMatrixCache.clear(), this._fogMatrixCacheF32.clear();
                            }
                            maxPitchScaleFactor() {
                                if (!this._pixelMatrixInverse) return 1;
                                const Qe = this.screenPointToMercatorCoordinate(new rt.P(0, 0)), Wn = [
                                    Qe.x * this.worldSize,
                                    Qe.y * this.worldSize,
                                    0,
                                    1
                                ];
                                return rt.ap(Wn, Wn, this._pixelMatrix)[3] / this._helper.cameraToCenterDistance;
                            }
                            getCameraPoint() {
                                return this._helper.getCameraPoint();
                            }
                            getCameraAltitude() {
                                return this._helper.getCameraAltitude();
                            }
                            getCameraLngLat() {
                                const Qe = rt.aK(1, this.center.lat) * this.worldSize;
                                return Tt(this.center, this.elevation, this.pitch, this.bearing, this._helper.cameraToCenterDistance / Qe).toLngLat();
                            }
                            lngLatToCameraDepth(Qe, Wn) {
                                const Co = rt.$.fromLngLat(Qe), Dl = [
                                    Co.x * this.worldSize,
                                    Co.y * this.worldSize,
                                    Wn,
                                    1
                                ];
                                return rt.ap(Dl, Dl, this._viewProjMatrix), Dl[2] / Dl[3];
                            }
                            getProjectionData(Qe) {
                                const { overscaledTileID: Wn, aligned: Co, applyTerrainMatrix: Dl } = Qe, Ll = this._helper.getMercatorTileCoordinates(Wn), Rl = Wn ? this.calculatePosMatrix(Wn, Co, !0) : null;
                                let Ul;
                                return Ul = Wn && Wn.terrainRttPosMatrix32f && Dl ? Wn.terrainRttPosMatrix32f : Rl || rt.b0(), {
                                    mainMatrix: Ul,
                                    tileMercatorCoords: Ll,
                                    clippingPlane: [
                                        0,
                                        0,
                                        0,
                                        0
                                    ],
                                    projectionTransition: 0,
                                    fallbackMatrix: Ul
                                };
                            }
                            isLocationOccluded(Qe) {
                                return !1;
                            }
                            getPixelScale() {
                                return 1;
                            }
                            getCircleRadiusCorrection() {
                                return 1;
                            }
                            getPitchedTextCorrection(Qe, rt, Wn) {
                                return 1;
                            }
                            transformLightDirection(Qe) {
                                return rt.aQ(Qe);
                            }
                            getRayDirectionFromPixel(Qe) {
                                throw new Error("Not implemented.");
                            }
                            projectTileCoordinates(Qe, Wn, Co, Dl) {
                                const Ll = this.calculatePosMatrix(Co);
                                let Rl;
                                Dl ? (Rl = [
                                    Qe,
                                    Wn,
                                    Dl(Qe, Wn),
                                    1
                                ], rt.ap(Rl, Rl, Ll)) : (Rl = [
                                    Qe,
                                    Wn,
                                    0,
                                    1
                                ], Oe(Rl, Rl, Ll));
                                const Ul = Rl[3];
                                return {
                                    point: new rt.P(Rl[0] / Ul, Rl[1] / Ul),
                                    signedDistanceFromCamera: Ul,
                                    isOccluded: !1
                                };
                            }
                            populateCache(Qe) {
                                for (const rt of Qe)this.calculatePosMatrix(rt);
                            }
                            getMatrixForModel(Qe, Wn) {
                                const Co = rt.$.fromLngLat(Qe, Wn), Dl = Co.meterInMercatorCoordinateUnits(), Ll = rt.b1();
                                return rt.L(Ll, Ll, [
                                    Co.x,
                                    Co.y,
                                    Co.z
                                ]), rt.a_(Ll, Ll, Math.PI), rt.a$(Ll, Ll, Math.PI / 2), rt.M(Ll, Ll, [
                                    -Dl,
                                    Dl,
                                    Dl
                                ]), Ll;
                            }
                            getProjectionDataForCustomLayer(Qe = !0) {
                                const Wn = new rt.Y(0, 0, 0, 0, 0), Co = this.getProjectionData({
                                    overscaledTileID: Wn,
                                    applyGlobeMatrix: Qe
                                }), Dl = wt(Wn, this.worldSize);
                                rt.N(Dl, this._viewProjMatrix, Dl), Co.tileMercatorCoords = [
                                    0,
                                    0,
                                    1,
                                    1
                                ];
                                const Ll = [
                                    rt.Z,
                                    rt.Z,
                                    this.worldSize / this._helper.pixelsPerMeter
                                ], Rl = rt.b2();
                                return rt.M(Rl, Dl, Ll), Co.fallbackMatrix = Rl, Co.mainMatrix = Rl, Co;
                            }
                            getFastPathSimpleProjectionMatrix(Qe) {
                                return this.calculatePosMatrix(Qe);
                            }
                        }
                        function zt() {
                            rt.w("Map cannot fit within canvas with the given bounds, padding, and/or offset.");
                        }
                        function At(Qe) {
                            if (Qe.useSlerp) {
                                if (Qe.k < 1) {
                                    const Wn = rt.b3(Qe.startEulerAngles.roll, Qe.startEulerAngles.pitch, Qe.startEulerAngles.bearing), Co = rt.b3(Qe.endEulerAngles.roll, Qe.endEulerAngles.pitch, Qe.endEulerAngles.bearing), Dl = new Float64Array(4);
                                    rt.b4(Dl, Wn, Co, Qe.k);
                                    const Ll = rt.b5(Dl);
                                    Qe.tr.setRoll(Ll.roll), Qe.tr.setPitch(Ll.pitch), Qe.tr.setBearing(Ll.bearing);
                                } else Qe.tr.setRoll(Qe.endEulerAngles.roll), Qe.tr.setPitch(Qe.endEulerAngles.pitch), Qe.tr.setBearing(Qe.endEulerAngles.bearing);
                            } else Qe.tr.setRoll(rt.B.number(Qe.startEulerAngles.roll, Qe.endEulerAngles.roll, Qe.k)), Qe.tr.setPitch(rt.B.number(Qe.startEulerAngles.pitch, Qe.endEulerAngles.pitch, Qe.k)), Qe.tr.setBearing(rt.B.number(Qe.startEulerAngles.bearing, Qe.endEulerAngles.bearing, Qe.k));
                        }
                        function Lt(Qe, Wn, Co, Dl, Ll) {
                            const Rl = Ll.padding, Ul = xt(Ll.worldSize, Co.getNorthWest()), Gl = xt(Ll.worldSize, Co.getNorthEast()), Zl = xt(Ll.worldSize, Co.getSouthEast()), Hl = xt(Ll.worldSize, Co.getSouthWest()), ql = rt.ad(-Dl), Ql = Ul.rotate(ql), Kl = Gl.rotate(ql), $l = Zl.rotate(ql), Tc = Hl.rotate(ql), tu = new rt.P(Math.max(Ql.x, Kl.x, Tc.x, $l.x), Math.max(Ql.y, Kl.y, Tc.y, $l.y)), lu = new rt.P(Math.min(Ql.x, Kl.x, Tc.x, $l.x), Math.min(Ql.y, Kl.y, Tc.y, $l.y)), du = tu.sub(lu), fu = (Ll.width - (Rl.left + Rl.right + Wn.left + Wn.right)) / du.x, yu = (Ll.height - (Rl.top + Rl.bottom + Wn.top + Wn.bottom)) / du.y;
                            if (yu < 0 || fu < 0) return void zt();
                            const Eu = Math.min(rt.ab(Ll.scale * Math.min(fu, yu)), Qe.maxZoom), Tu = rt.P.convert(Qe.offset), Lu = new rt.P((Wn.left - Wn.right) / 2, (Wn.top - Wn.bottom) / 2).rotate(rt.ad(Dl)), Zu = Tu.add(Lu).mult(Ll.scale / rt.aI(Eu));
                            return {
                                center: bt(Ll.worldSize, Ul.add(Zl).div(2).sub(Zu)),
                                zoom: Eu,
                                bearing: Dl
                            };
                        }
                        class kt {
                            get useGlobeControls() {
                                return !1;
                            }
                            handlePanInertia(Qe, rt) {
                                return {
                                    easingOffset: Qe,
                                    easingCenter: rt.center
                                };
                            }
                            handleMapControlsRollPitchBearingZoom(Qe, rt) {
                                Qe.bearingDelta && rt.setBearing(rt.bearing + Qe.bearingDelta), Qe.pitchDelta && rt.setPitch(rt.pitch + Qe.pitchDelta), Qe.rollDelta && rt.setRoll(rt.roll + Qe.rollDelta), Qe.zoomDelta && rt.setZoom(rt.zoom + Qe.zoomDelta);
                            }
                            handleMapControlsPan(Qe, rt, Wn) {
                                Qe.around.distSqr(rt.centerPoint) < .01 || rt.setLocationAtPoint(Wn, Qe.around);
                            }
                            cameraForBoxAndBearing(Qe, rt, Wn, Co, Dl) {
                                return Lt(Qe, rt, Wn, Co, Dl);
                            }
                            handleJumpToCenterZoom(Qe, Wn) {
                                Qe.zoom !== (void 0 !== Wn.zoom ? +Wn.zoom : Qe.zoom) && Qe.setZoom(+Wn.zoom), void 0 !== Wn.center && Qe.setCenter(rt.Q.convert(Wn.center));
                            }
                            handleEaseTo(Qe, Wn) {
                                const Co = Qe.zoom, Dl = Qe.padding, Ll = {
                                    roll: Qe.roll,
                                    pitch: Qe.pitch,
                                    bearing: Qe.bearing
                                }, Rl = {
                                    roll: void 0 === Wn.roll ? Qe.roll : Wn.roll,
                                    pitch: void 0 === Wn.pitch ? Qe.pitch : Wn.pitch,
                                    bearing: void 0 === Wn.bearing ? Qe.bearing : Wn.bearing
                                }, Ul = void 0 !== Wn.zoom, Gl = !Qe.isPaddingEqual(Wn.padding);
                                let Zl = !1;
                                const Hl = Ul ? +Wn.zoom : Qe.zoom;
                                let ql = Qe.centerPoint.add(Wn.offsetAsPoint);
                                const Ql = Qe.screenPointToLocation(ql), { center: Kl, zoom: $l } = Qe.getConstrained(rt.Q.convert(Wn.center || Ql), null != Hl ? Hl : Co);
                                Ct(Qe, Kl);
                                const Tc = xt(Qe.worldSize, Ql), tu = xt(Qe.worldSize, Kl).sub(Tc), lu = rt.aI($l - Co);
                                return Zl = $l !== Co, {
                                    easeFunc: (Ul)=>{
                                        if (Zl && Qe.setZoom(rt.B.number(Co, $l, Ul)), rt.b6(Ll, Rl) || At({
                                            startEulerAngles: Ll,
                                            endEulerAngles: Rl,
                                            tr: Qe,
                                            k: Ul,
                                            useSlerp: Ll.roll != Rl.roll
                                        }), Gl && (Qe.interpolatePadding(Dl, Wn.padding, Ul), ql = Qe.centerPoint.add(Wn.offsetAsPoint)), Wn.around) Qe.setLocationAtPoint(Wn.around, Wn.aroundPoint);
                                        else {
                                            const Wn = rt.aI(Qe.zoom - Co), Dl = $l > Co ? Math.min(2, lu) : Math.max(.5, lu), Ll = Math.pow(Dl, 1 - Ul), Rl = bt(Qe.worldSize, Tc.add(tu.mult(Ul * Ll)).mult(Wn));
                                            Qe.setLocationAtPoint(Qe.renderWorldCopies ? Rl.wrap() : Rl, ql);
                                        }
                                    },
                                    isZooming: Zl,
                                    elevationCenter: Kl
                                };
                            }
                            handleFlyTo(Qe, Wn) {
                                const Co = void 0 !== Wn.zoom, Dl = Qe.zoom, Ll = Qe.getConstrained(rt.Q.convert(Wn.center || Wn.locationAtOffset), Co ? +Wn.zoom : Dl), Rl = Ll.center, Ul = Ll.zoom;
                                Ct(Qe, Rl);
                                const Gl = xt(Qe.worldSize, Wn.locationAtOffset), Zl = xt(Qe.worldSize, Rl).sub(Gl), Hl = Zl.mag(), ql = rt.aI(Ul - Dl);
                                let Ql;
                                if (void 0 !== Wn.minZoom) {
                                    const Co = Math.min(+Wn.minZoom, Dl, Ul), Ll = Qe.getConstrained(Rl, Co).zoom;
                                    Ql = rt.aI(Ll - Dl);
                                }
                                return {
                                    easeFunc: (Wn, Co, Ll, Hl)=>{
                                        Qe.setZoom(1 === Wn ? Ul : Dl + rt.ab(Co));
                                        const ql = 1 === Wn ? Rl : bt(Qe.worldSize, Gl.add(Zl.mult(Ll)).mult(Co));
                                        Qe.setLocationAtPoint(Qe.renderWorldCopies ? ql.wrap() : ql, Hl);
                                    },
                                    scaleOfZoom: ql,
                                    targetCenter: Rl,
                                    scaleOfMinZoom: Ql,
                                    pixelPathLength: Hl
                                };
                            }
                        }
                        class Ft {
                            constructor(Qe, rt, Wn){
                                this.blendFunction = Qe, this.blendColor = rt, this.mask = Wn;
                            }
                        }
                        Ft.Replace = [
                            1,
                            0
                        ], Ft.disabled = new Ft(Ft.Replace, rt.b7.transparent, [
                            !1,
                            !1,
                            !1,
                            !1
                        ]), Ft.unblended = new Ft(Ft.Replace, rt.b7.transparent, [
                            !0,
                            !0,
                            !0,
                            !0
                        ]), Ft.alphaBlended = new Ft([
                            1,
                            771
                        ], rt.b7.transparent, [
                            !0,
                            !0,
                            !0,
                            !0
                        ]);
                        const ud = 2305;
                        class Ot {
                            constructor(Qe, rt, Wn){
                                this.enable = Qe, this.mode = rt, this.frontFace = Wn;
                            }
                        }
                        Ot.disabled = new Ot(!1, 1029, ud), Ot.backCCW = new Ot(!0, 1029, ud), Ot.frontCCW = new Ot(!0, 1028, ud);
                        class jt {
                            constructor(Qe, rt, Wn){
                                this.func = Qe, this.mask = rt, this.range = Wn;
                            }
                        }
                        jt.ReadOnly = !1, jt.ReadWrite = !0, jt.disabled = new jt(519, jt.ReadOnly, [
                            0,
                            1
                        ]);
                        const hd = 7680;
                        class Nt {
                            constructor(Qe, rt, Wn, Co, Dl, Ll){
                                this.test = Qe, this.ref = rt, this.mask = Wn, this.fail = Co, this.depthFail = Dl, this.pass = Ll;
                            }
                        }
                        Nt.disabled = new Nt({
                            func: 519,
                            mask: 0
                        }, 0, 0, hd, hd, hd);
                        const dd = new WeakMap;
                        function Ut(Qe) {
                            var rt;
                            if (dd.has(Qe)) return dd.get(Qe);
                            {
                                const Wn = null === (rt = Qe.getParameter(Qe.VERSION)) || void 0 === rt ? void 0 : rt.startsWith("WebGL 2.0");
                                return dd.set(Qe, Wn), Wn;
                            }
                        }
                        class Vt {
                            get awaitingQuery() {
                                return !!this._readbackQueue;
                            }
                            constructor(Qe){
                                this._readbackWaitFrames = 4, this._measureWaitFrames = 6, this._texWidth = 1, this._texHeight = 1, this._measuredError = 0, this._updateCount = 0, this._lastReadbackFrame = -1000, this._readbackQueue = null, this._cachedRenderContext = Qe;
                                const Wn = Qe.context, Co = Wn.gl;
                                this._texFormat = Co.RGBA, this._texType = Co.UNSIGNED_BYTE;
                                const Dl = new rt.aF;
                                Dl.emplaceBack(-1, -1), Dl.emplaceBack(2, -1), Dl.emplaceBack(-1, 2);
                                const Ll = new rt.aH;
                                Ll.emplaceBack(0, 1, 2), this._fullscreenTriangle = new pt(Wn.createVertexBuffer(Dl, od.members), Wn.createIndexBuffer(Ll), rt.aG.simpleSegment(0, 0, Dl.length, Ll.length)), this._resultBuffer = new Uint8Array(4), Wn.activeTexture.set(Co.TEXTURE1);
                                const Rl = Co.createTexture();
                                Co.bindTexture(Co.TEXTURE_2D, Rl), Co.texParameteri(Co.TEXTURE_2D, Co.TEXTURE_WRAP_S, Co.CLAMP_TO_EDGE), Co.texParameteri(Co.TEXTURE_2D, Co.TEXTURE_WRAP_T, Co.CLAMP_TO_EDGE), Co.texParameteri(Co.TEXTURE_2D, Co.TEXTURE_MIN_FILTER, Co.NEAREST), Co.texParameteri(Co.TEXTURE_2D, Co.TEXTURE_MAG_FILTER, Co.NEAREST), Co.texImage2D(Co.TEXTURE_2D, 0, this._texFormat, this._texWidth, this._texHeight, 0, this._texFormat, this._texType, null), this._fbo = Wn.createFramebuffer(this._texWidth, this._texHeight, !1, !1), this._fbo.colorAttachment.set(Rl), Ut(Co) && (this._pbo = Co.createBuffer(), Co.bindBuffer(Co.PIXEL_PACK_BUFFER, this._pbo), Co.bufferData(Co.PIXEL_PACK_BUFFER, 4, Co.STREAM_READ), Co.bindBuffer(Co.PIXEL_PACK_BUFFER, null));
                            }
                            destroy() {
                                const Qe = this._cachedRenderContext.context.gl;
                                this._fullscreenTriangle.destroy(), this._fbo.destroy(), Qe.deleteBuffer(this._pbo), this._fullscreenTriangle = null, this._fbo = null, this._pbo = null, this._resultBuffer = null;
                            }
                            updateErrorLoop(Qe, rt) {
                                const Wn = this._updateCount;
                                return this._readbackQueue ? Wn >= this._readbackQueue.frameNumberIssued + this._readbackWaitFrames && this._tryReadback() : Wn >= this._lastReadbackFrame + this._measureWaitFrames && this._renderErrorTexture(Qe, rt), this._updateCount++, this._measuredError;
                            }
                            _bindFramebuffer() {
                                const Qe = this._cachedRenderContext.context, rt = Qe.gl;
                                Qe.activeTexture.set(rt.TEXTURE1), rt.bindTexture(rt.TEXTURE_2D, this._fbo.colorAttachment.get()), Qe.bindFramebuffer.set(this._fbo.framebuffer);
                            }
                            _renderErrorTexture(Qe, Wn) {
                                const Co = this._cachedRenderContext.context, Dl = Co.gl;
                                if (this._bindFramebuffer(), Co.viewport.set([
                                    0,
                                    0,
                                    this._texWidth,
                                    this._texHeight
                                ]), Co.clear({
                                    color: rt.b7.transparent
                                }), this._cachedRenderContext.useProgram("projectionErrorMeasurement").draw(Co, Dl.TRIANGLES, jt.disabled, Nt.disabled, Ft.unblended, Ot.disabled, ((Qe, rt)=>({
                                        u_input: Qe,
                                        u_output_expected: rt
                                    }))(Qe, Wn), null, null, "$clipping", this._fullscreenTriangle.vertexBuffer, this._fullscreenTriangle.indexBuffer, this._fullscreenTriangle.segments), this._pbo && Ut(Dl)) {
                                    Dl.bindBuffer(Dl.PIXEL_PACK_BUFFER, this._pbo), Dl.readBuffer(Dl.COLOR_ATTACHMENT0), Dl.readPixels(0, 0, this._texWidth, this._texHeight, this._texFormat, this._texType, 0), Dl.bindBuffer(Dl.PIXEL_PACK_BUFFER, null);
                                    const Qe = Dl.fenceSync(Dl.SYNC_GPU_COMMANDS_COMPLETE, 0);
                                    Dl.flush(), this._readbackQueue = {
                                        frameNumberIssued: this._updateCount,
                                        sync: Qe
                                    };
                                } else this._readbackQueue = {
                                    frameNumberIssued: this._updateCount,
                                    sync: null
                                };
                            }
                            _tryReadback() {
                                const Qe = this._cachedRenderContext.context.gl;
                                if (this._pbo && this._readbackQueue && Ut(Qe)) {
                                    const Wn = Qe.clientWaitSync(this._readbackQueue.sync, 0, 0);
                                    if (Wn === Qe.WAIT_FAILED) return rt.w("WebGL2 clientWaitSync failed."), this._readbackQueue = null, void (this._lastReadbackFrame = this._updateCount);
                                    if (Wn === Qe.TIMEOUT_EXPIRED) return;
                                    Qe.bindBuffer(Qe.PIXEL_PACK_BUFFER, this._pbo), Qe.getBufferSubData(Qe.PIXEL_PACK_BUFFER, 0, this._resultBuffer, 0, 4), Qe.bindBuffer(Qe.PIXEL_PACK_BUFFER, null);
                                } else this._bindFramebuffer(), Qe.readPixels(0, 0, this._texWidth, this._texHeight, this._texFormat, this._texType, this._resultBuffer);
                                this._readbackQueue = null, this._measuredError = Vt._parseRGBA8float(this._resultBuffer), this._lastReadbackFrame = this._updateCount;
                            }
                            static _parseRGBA8float(Qe) {
                                let rt = 0;
                                return rt += Qe[0] / 256, rt += Qe[1] / 65536, rt += Qe[2] / 16777216, Qe[3] < 127 && (rt = -rt), rt / 128;
                            }
                        }
                        const pd = rt.Z / 128;
                        function Wt(Qe, Wn) {
                            const Co = void 0 !== Qe.granularity ? Math.max(Qe.granularity, 1) : 1, Dl = Co + (Qe.generateBorders ? 2 : 0), Ll = Co + (Qe.extendToNorthPole || Qe.generateBorders ? 1 : 0) + (Qe.extendToSouthPole || Qe.generateBorders ? 1 : 0), Rl = Dl + 1, Ul = Ll + 1, Gl = Qe.generateBorders ? -1 : 0, Zl = Qe.generateBorders || Qe.extendToNorthPole ? -1 : 0, Hl = Co + (Qe.generateBorders ? 1 : 0), ql = Co + (Qe.generateBorders || Qe.extendToSouthPole ? 1 : 0), Ql = Rl * Ul, Kl = Dl * Ll * 6, $l = Rl * Ul > 65536;
                            if ($l && "16bit" === Wn) throw new Error("Granularity is too large and meshes would not fit inside 16 bit vertex indices.");
                            const Tc = $l || "32bit" === Wn, tu = new Int16Array(2 * Ql);
                            let lu = 0;
                            for(let yu = Zl; yu <= ql; yu++)for(let Wn = Gl; Wn <= Hl; Wn++){
                                let Dl = Wn / Co * rt.Z;
                                -1 === Wn && (Dl = -64), Wn === Co + 1 && (Dl = rt.Z + pd);
                                let Ll = yu / Co * rt.Z;
                                -1 === yu && (Ll = Qe.extendToNorthPole ? rt.b9 : -64), yu === Co + 1 && (Ll = Qe.extendToSouthPole ? rt.ba : rt.Z + pd), tu[lu++] = Dl, tu[lu++] = Ll;
                            }
                            const du = Tc ? new Uint32Array(Kl) : new Uint16Array(Kl);
                            let fu = 0;
                            for(let rt = 0; rt < Ll; rt++)for(let Qe = 0; Qe < Dl; Qe++){
                                const Wn = Qe + 1 + rt * Rl, Co = Qe + (rt + 1) * Rl, Dl = Qe + 1 + (rt + 1) * Rl;
                                du[fu++] = Qe + rt * Rl, du[fu++] = Co, du[fu++] = Wn, du[fu++] = Wn, du[fu++] = Co, du[fu++] = Dl;
                            }
                            return {
                                vertices: tu.buffer.slice(0),
                                indices: du.buffer.slice(0),
                                uses32bitIndices: Tc
                            };
                        }
                        const md = new rt.aE({
                            fill: new rt.bb(128, 2),
                            line: new rt.bb(512, 0),
                            tile: new rt.bb(128, 32),
                            stencil: new rt.bb(128, 1),
                            circle: 3
                        });
                        class Ht {
                            constructor(){
                                this._tileMeshCache = {}, this._errorCorrectionUsable = 0, this._errorMeasurementLastValue = 0, this._errorCorrectionPreviousValue = 0, this._errorMeasurementLastChangeTime = -1000;
                            }
                            get name() {
                                return "vertical-perspective";
                            }
                            get transitionState() {
                                return 1;
                            }
                            get useSubdivision() {
                                return !0;
                            }
                            get shaderVariantName() {
                                return "globe";
                            }
                            get shaderDefine() {
                                return "#define GLOBE";
                            }
                            get shaderPreludeCode() {
                                return ad.projectionGlobe;
                            }
                            get vertexShaderPreludeCode() {
                                return ad.projectionMercator.vertexSource;
                            }
                            get subdivisionGranularity() {
                                return md;
                            }
                            get useGlobeControls() {
                                return !0;
                            }
                            get latitudeErrorCorrectionRadians() {
                                return this._errorCorrectionUsable;
                            }
                            destroy() {
                                this._errorMeasurement && this._errorMeasurement.destroy();
                            }
                            updateGPUdependent(Qe) {
                                this._errorMeasurement || (this._errorMeasurement = new Vt(Qe));
                                const Wn = rt.S(this._errorQueryLatitudeDegrees), Co = 2 * Math.atan(Math.exp(Math.PI - Wn * Math.PI * 2)) - .5 * Math.PI, Dl = this._errorMeasurement.updateErrorLoop(Wn, Co), Rl = Ll.now();
                                Dl !== this._errorMeasurementLastValue && (this._errorCorrectionPreviousValue = this._errorCorrectionUsable, this._errorMeasurementLastValue = Dl, this._errorMeasurementLastChangeTime = Rl);
                                const Ul = Math.min(Math.max((Rl - this._errorMeasurementLastChangeTime) / 1e3 / .5, 0), 1);
                                this._errorCorrectionUsable = rt.bc(this._errorCorrectionPreviousValue, -this._errorMeasurementLastValue, rt.bd(Ul));
                            }
                            _getMeshKey(Qe) {
                                return `${Qe.granularity.toString(36)}_${Qe.generateBorders ? "b" : ""}${Qe.extendToNorthPole ? "n" : ""}${Qe.extendToSouthPole ? "s" : ""}`;
                            }
                            getMeshFromTileID(Qe, rt, Wn, Co, Dl) {
                                const Ll = ("stencil" === Dl ? md.stencil : md.tile).getGranularityForZoomLevel(rt.z);
                                return this._getMesh(Qe, {
                                    granularity: Ll,
                                    generateBorders: Wn,
                                    extendToNorthPole: 0 === rt.y && Co,
                                    extendToSouthPole: rt.y === (1 << rt.z) - 1 && Co
                                });
                            }
                            _getMesh(Qe, Wn) {
                                const Co = this._getMeshKey(Wn);
                                if (Co in this._tileMeshCache) return this._tileMeshCache[Co];
                                const Dl = function(Qe, Wn) {
                                    const Co = Wt(Wn, "16bit"), Dl = rt.aF.deserialize({
                                        arrayBuffer: Co.vertices,
                                        length: Co.vertices.byteLength / 2 / 2
                                    }), Ll = rt.aH.deserialize({
                                        arrayBuffer: Co.indices,
                                        length: Co.indices.byteLength / 2 / 3
                                    });
                                    return new pt(Qe.createVertexBuffer(Dl, od.members), Qe.createIndexBuffer(Ll), rt.aG.simpleSegment(0, 0, Dl.length, Ll.length));
                                }(Qe, Wn);
                                return this._tileMeshCache[Co] = Dl, Dl;
                            }
                            recalculate(Qe) {}
                            hasTransition() {
                                const Qe = Ll.now();
                                let rt = !1;
                                return rt = rt || (Qe - this._errorMeasurementLastChangeTime) / 1e3 < .7, rt = rt || this._errorMeasurement && this._errorMeasurement.awaitingQuery, rt;
                            }
                            setErrorQueryLatitudeDegrees(Qe) {
                                this._errorQueryLatitudeDegrees = Qe;
                            }
                        }
                        const fd = new rt.r({
                            type: new rt.D(rt.v.projection.type)
                        });
                        class Xt extends rt.E {
                            constructor(Qe){
                                super(), this._transitionable = new rt.T(fd), this.setProjection(Qe), this._transitioning = this._transitionable.untransitioned(), this.recalculate(new rt.C(0)), this._mercatorProjection = new vt, this._verticalPerspectiveProjection = new Ht;
                            }
                            get transitionState() {
                                const Qe = this.properties.get("type");
                                if ("string" == typeof Qe && "mercator" === Qe) return 0;
                                if ("string" == typeof Qe && "vertical-perspective" === Qe) return 1;
                                if (Qe instanceof rt.be) {
                                    if ("vertical-perspective" === Qe.from && "mercator" === Qe.to) return 1 - Qe.transition;
                                    if ("mercator" === Qe.from && "vertical-perspective" === Qe.to) return Qe.transition;
                                }
                                return 1;
                            }
                            get useGlobeRendering() {
                                return this.transitionState > 0;
                            }
                            get latitudeErrorCorrectionRadians() {
                                return this._verticalPerspectiveProjection.latitudeErrorCorrectionRadians;
                            }
                            get currentProjection() {
                                return this.useGlobeRendering ? this._verticalPerspectiveProjection : this._mercatorProjection;
                            }
                            get name() {
                                return "globe";
                            }
                            get useSubdivision() {
                                return this.currentProjection.useSubdivision;
                            }
                            get shaderVariantName() {
                                return this.currentProjection.shaderVariantName;
                            }
                            get shaderDefine() {
                                return this.currentProjection.shaderDefine;
                            }
                            get shaderPreludeCode() {
                                return this.currentProjection.shaderPreludeCode;
                            }
                            get vertexShaderPreludeCode() {
                                return this.currentProjection.vertexShaderPreludeCode;
                            }
                            get subdivisionGranularity() {
                                return this.currentProjection.subdivisionGranularity;
                            }
                            get useGlobeControls() {
                                return this.transitionState > 0;
                            }
                            destroy() {
                                this._mercatorProjection.destroy(), this._verticalPerspectiveProjection.destroy();
                            }
                            updateGPUdependent(Qe) {
                                this._mercatorProjection.updateGPUdependent(Qe), this._verticalPerspectiveProjection.updateGPUdependent(Qe);
                            }
                            getMeshFromTileID(Qe, rt, Wn, Co, Dl) {
                                return this.currentProjection.getMeshFromTileID(Qe, rt, Wn, Co, Dl);
                            }
                            setProjection(Qe) {
                                this._transitionable.setValue("type", (null == Qe ? void 0 : Qe.type) || "mercator");
                            }
                            updateTransitions(Qe) {
                                this._transitioning = this._transitionable.transitioned(Qe, this._transitioning);
                            }
                            hasTransition() {
                                return this._transitioning.hasTransition() || this.currentProjection.hasTransition();
                            }
                            recalculate(Qe) {
                                this.properties = this._transitioning.possiblyEvaluate(Qe);
                            }
                            setErrorQueryLatitudeDegrees(Qe) {
                                this._verticalPerspectiveProjection.setErrorQueryLatitudeDegrees(Qe), this._mercatorProjection.setErrorQueryLatitudeDegrees(Qe);
                            }
                        }
                        function Qt(Qe) {
                            const rt = ei(Qe.worldSize, Qe.center.lat);
                            return 2 * Math.PI * rt;
                        }
                        function Yt(Qe, Wn, Co, Dl, Ll) {
                            const Rl = 1 / (1 << Ll), Ul = Wn / rt.Z * Rl + Dl * Rl, Gl = rt.bg((Qe / rt.Z * Rl + Co * Rl) * Math.PI * 2 + Math.PI, 2 * Math.PI), Zl = 2 * Math.atan(Math.exp(Math.PI - Ul * Math.PI * 2)) - .5 * Math.PI, Hl = Math.cos(Zl), ql = new Float64Array(3);
                            return ql[0] = Math.sin(Gl) * Hl, ql[1] = Math.sin(Zl), ql[2] = Math.cos(Gl) * Hl, ql;
                        }
                        function Jt(Qe) {
                            return function(Qe, rt) {
                                const Wn = Math.cos(rt), Co = new Float64Array(3);
                                return Co[0] = Math.sin(Qe) * Wn, Co[1] = Math.sin(rt), Co[2] = Math.cos(Qe) * Wn, Co;
                            }(Qe.lng * Math.PI / 180, Qe.lat * Math.PI / 180);
                        }
                        function ei(Qe, rt) {
                            return Qe / (2 * Math.PI) / Math.cos(rt * Math.PI / 180);
                        }
                        function ti(Qe) {
                            const Wn = Math.asin(Qe[1]) / Math.PI * 180, Co = Math.sqrt(Qe[0] * Qe[0] + Qe[2] * Qe[2]);
                            if (Co > 1e-6) {
                                const Dl = Qe[0] / Co, Ll = Math.acos(Qe[2] / Co), Rl = (Dl > 0 ? Ll : -Ll) / Math.PI * 180;
                                return new rt.Q(rt.aL(Rl, -180, 180), Wn);
                            }
                            return new rt.Q(0, Wn);
                        }
                        function ii(Qe) {
                            return Math.cos(Qe * Math.PI / 180);
                        }
                        function ri(Qe, Wn) {
                            const Co = ii(Qe), Dl = ii(Wn);
                            return rt.ab(Dl / Co);
                        }
                        function oi(Qe, Wn) {
                            const Co = Qe.rotate(Wn.bearingInRadians), Dl = Wn.zoom + ri(Wn.center.lat, 0), Ll = rt.bc(1 / ii(Wn.center.lat), 1 / ii(Math.min(Math.abs(Wn.center.lat), 60)), rt.bf(Dl, 7, 3, 0, 1)), Rl = 360 / Qt({
                                worldSize: Wn.worldSize,
                                center: {
                                    lat: Wn.center.lat
                                }
                            });
                            return new rt.Q(Wn.center.lng - Co.x * Rl * Ll, rt.ae(Wn.center.lat + Co.y * Rl, -85.051129, rt.aJ));
                        }
                        function ai(Qe) {
                            const rt = .5 * Qe, Wn = Math.sin(rt), Co = Math.cos(rt);
                            return Math.log(Wn + Co) - Math.log(Co - Wn);
                        }
                        function si(Qe, Wn, Co, Dl) {
                            const Ll = Qe.lat + Co * Dl;
                            if (Math.abs(Co) > 1) {
                                const Rl = (Math.sign(Qe.lat + Co) !== Math.sign(Qe.lat) ? -Math.abs(Qe.lat) : Math.abs(Qe.lat)) * Math.PI / 180, Ul = Math.abs(Qe.lat + Co) * Math.PI / 180, Gl = ai(Rl + Dl * (Ul - Rl)), Zl = ai(Rl), Hl = ai(Ul);
                                return new rt.Q(Qe.lng + Wn * ((Gl - Zl) / (Hl - Zl)), Ll);
                            }
                            return new rt.Q(Qe.lng + Wn * Dl, Ll);
                        }
                        class ni {
                            constructor(Qe){
                                this._cachePrevious = new Map, this._cache = new Map, this._hadAnyChanges = !1, this._aabbFactory = Qe;
                            }
                            recalculateCache() {
                                if (!this._hadAnyChanges) return;
                                const Qe = this._cachePrevious;
                                this._cachePrevious = this._cache, this._cache = Qe, this._cache.clear(), this._hadAnyChanges = !1;
                            }
                            getTileAABB(Qe, rt, Wn, Co) {
                                const Dl = `${Qe.z}_${Qe.x}_${Qe.y}`, Ll = this._cache.get(Dl);
                                if (Ll) return Ll;
                                const Rl = this._cachePrevious.get(Dl);
                                if (Rl) return this._cache.set(Dl, Rl), Rl;
                                const Ul = this._aabbFactory(Qe, rt, Wn, Co);
                                return this._cache.set(Dl, Ul), this._hadAnyChanges = !0, Ul;
                            }
                        }
                        function li(Qe, rt, Wn) {
                            const Co = Qe - rt;
                            return Co < 0 ? -Co : Math.max(0, Co - Wn);
                        }
                        function ci(Qe, rt, Wn, Co, Dl) {
                            const Ll = Qe - Wn;
                            let Rl;
                            return Rl = Ll < 0 ? Math.min(-Ll, 1 + Ll - Dl) : Ll > 1 ? Math.min(Math.max(Ll - Dl, 0), 1 - Ll) : 0, Math.max(Rl, li(rt, Co, Dl));
                        }
                        class hi {
                            constructor(){
                                this._aabbCache = new ni(this._computeTileAABB);
                            }
                            recalculateCache() {
                                this._aabbCache.recalculateCache();
                            }
                            distanceToTile2d(Qe, rt, Wn, Co) {
                                const Dl = 1 << Wn.z, Ll = 1 / Dl, Rl = Wn.x / Dl, Ul = Wn.y / Dl;
                                let Gl = 2;
                                return Gl = Math.min(Gl, ci(Qe, rt, Rl, Ul, Ll)), Gl = Math.min(Gl, ci(Qe, rt, Rl + .5, -Ul - Ll, Ll)), Gl = Math.min(Gl, ci(Qe, rt, Rl + .5, 2 - Ul - Ll, Ll)), Gl;
                            }
                            getWrap(Qe, rt, Wn) {
                                const Co = 1 << rt.z, Dl = 1 / Co, Ll = rt.x / Co, Rl = li(Qe.x, Ll, Dl), Ul = li(Qe.x, Ll - 1, Dl), Gl = li(Qe.x, Ll + 1, Dl), Zl = Math.min(Rl, Ul, Gl);
                                return Zl === Gl ? 1 : Zl === Ul ? -1 : 0;
                            }
                            allowVariableZoom(Qe, rt) {
                                return he(Qe, rt) > 4;
                            }
                            allowWorldCopies() {
                                return !1;
                            }
                            getTileAABB(Qe, rt, Wn, Co) {
                                return this._aabbCache.getTileAABB(Qe, rt, Wn, Co);
                            }
                            _computeTileAABB(Qe, Wn, Co, Dl) {
                                if (Qe.z <= 0) return new Et([
                                    -1,
                                    -1,
                                    -1
                                ], [
                                    1,
                                    1,
                                    1
                                ]);
                                if (1 === Qe.z) return new Et([
                                    0 === Qe.x ? -1 : 0,
                                    0 === Qe.y ? 0 : -1,
                                    -1
                                ], [
                                    0 === Qe.x ? 0 : 1,
                                    0 === Qe.y ? 1 : 0,
                                    1
                                ]);
                                {
                                    const Wn = [
                                        Yt(0, 0, Qe.x, Qe.y, Qe.z),
                                        Yt(rt.Z, 0, Qe.x, Qe.y, Qe.z),
                                        Yt(rt.Z, rt.Z, Qe.x, Qe.y, Qe.z),
                                        Yt(0, rt.Z, Qe.x, Qe.y, Qe.z)
                                    ], Co = [
                                        1,
                                        1,
                                        1
                                    ], Dl = [
                                        -1,
                                        -1,
                                        -1
                                    ];
                                    for (const Qe of Wn)for(let rt = 0; rt < 3; rt++)Co[rt] = Math.min(Co[rt], Qe[rt]), Dl[rt] = Math.max(Dl[rt], Qe[rt]);
                                    if (0 === Qe.y || Qe.y === (1 << Qe.z) - 1) {
                                        const rt = [
                                            0,
                                            0 === Qe.y ? 1 : -1,
                                            0
                                        ];
                                        for(let Qe = 0; Qe < 3; Qe++)Co[Qe] = Math.min(Co[Qe], rt[Qe]), Dl[Qe] = Math.max(Dl[Qe], rt[Qe]);
                                    }
                                    return new Et(Co, Dl);
                                }
                            }
                        }
                        class ui {
                            get pixelsToClipSpaceMatrix() {
                                return this._helper.pixelsToClipSpaceMatrix;
                            }
                            get clipSpaceToPixelsMatrix() {
                                return this._helper.clipSpaceToPixelsMatrix;
                            }
                            get pixelsToGLUnits() {
                                return this._helper.pixelsToGLUnits;
                            }
                            get centerOffset() {
                                return this._helper.centerOffset;
                            }
                            get size() {
                                return this._helper.size;
                            }
                            get rotationMatrix() {
                                return this._helper.rotationMatrix;
                            }
                            get centerPoint() {
                                return this._helper.centerPoint;
                            }
                            get pixelsPerMeter() {
                                return this._helper.pixelsPerMeter;
                            }
                            setMinZoom(Qe) {
                                this._helper.setMinZoom(Qe);
                            }
                            setMaxZoom(Qe) {
                                this._helper.setMaxZoom(Qe);
                            }
                            setMinPitch(Qe) {
                                this._helper.setMinPitch(Qe);
                            }
                            setMaxPitch(Qe) {
                                this._helper.setMaxPitch(Qe);
                            }
                            setRenderWorldCopies(Qe) {
                                this._helper.setRenderWorldCopies(Qe);
                            }
                            setBearing(Qe) {
                                this._helper.setBearing(Qe);
                            }
                            setPitch(Qe) {
                                this._helper.setPitch(Qe);
                            }
                            setRoll(Qe) {
                                this._helper.setRoll(Qe);
                            }
                            setFov(Qe) {
                                this._helper.setFov(Qe);
                            }
                            setZoom(Qe) {
                                this._helper.setZoom(Qe);
                            }
                            setCenter(Qe) {
                                this._helper.setCenter(Qe);
                            }
                            setElevation(Qe) {
                                this._helper.setElevation(Qe);
                            }
                            setMinElevationForCurrentTile(Qe) {
                                this._helper.setMinElevationForCurrentTile(Qe);
                            }
                            setPadding(Qe) {
                                this._helper.setPadding(Qe);
                            }
                            interpolatePadding(Qe, rt, Wn) {
                                return this._helper.interpolatePadding(Qe, rt, Wn);
                            }
                            isPaddingEqual(Qe) {
                                return this._helper.isPaddingEqual(Qe);
                            }
                            resize(Qe, rt) {
                                this._helper.resize(Qe, rt);
                            }
                            getMaxBounds() {
                                return this._helper.getMaxBounds();
                            }
                            setMaxBounds(Qe) {
                                this._helper.setMaxBounds(Qe);
                            }
                            overrideNearFarZ(Qe, rt) {
                                this._helper.overrideNearFarZ(Qe, rt);
                            }
                            clearNearFarZOverride() {
                                this._helper.clearNearFarZOverride();
                            }
                            getCameraQueryGeometry(Qe) {
                                return this._helper.getCameraQueryGeometry(this.getCameraPoint(), Qe);
                            }
                            get tileSize() {
                                return this._helper.tileSize;
                            }
                            get tileZoom() {
                                return this._helper.tileZoom;
                            }
                            get scale() {
                                return this._helper.scale;
                            }
                            get worldSize() {
                                return this._helper.worldSize;
                            }
                            get width() {
                                return this._helper.width;
                            }
                            get height() {
                                return this._helper.height;
                            }
                            get lngRange() {
                                return this._helper.lngRange;
                            }
                            get latRange() {
                                return this._helper.latRange;
                            }
                            get minZoom() {
                                return this._helper.minZoom;
                            }
                            get maxZoom() {
                                return this._helper.maxZoom;
                            }
                            get zoom() {
                                return this._helper.zoom;
                            }
                            get center() {
                                return this._helper.center;
                            }
                            get minPitch() {
                                return this._helper.minPitch;
                            }
                            get maxPitch() {
                                return this._helper.maxPitch;
                            }
                            get pitch() {
                                return this._helper.pitch;
                            }
                            get pitchInRadians() {
                                return this._helper.pitchInRadians;
                            }
                            get roll() {
                                return this._helper.roll;
                            }
                            get rollInRadians() {
                                return this._helper.rollInRadians;
                            }
                            get bearing() {
                                return this._helper.bearing;
                            }
                            get bearingInRadians() {
                                return this._helper.bearingInRadians;
                            }
                            get fov() {
                                return this._helper.fov;
                            }
                            get fovInRadians() {
                                return this._helper.fovInRadians;
                            }
                            get elevation() {
                                return this._helper.elevation;
                            }
                            get minElevationForCurrentTile() {
                                return this._helper.minElevationForCurrentTile;
                            }
                            get padding() {
                                return this._helper.padding;
                            }
                            get unmodified() {
                                return this._helper.unmodified;
                            }
                            get renderWorldCopies() {
                                return this._helper.renderWorldCopies;
                            }
                            get nearZ() {
                                return this._helper.nearZ;
                            }
                            get farZ() {
                                return this._helper.farZ;
                            }
                            get autoCalculateNearFarZ() {
                                return this._helper.autoCalculateNearFarZ;
                            }
                            setTransitionState(Qe) {}
                            constructor(){
                                this._cachedClippingPlane = rt.bh(), this._projectionMatrix = rt.b1(), this._globeViewProjMatrix32f = rt.b0(), this._globeViewProjMatrixNoCorrection = rt.b1(), this._globeViewProjMatrixNoCorrectionInverted = rt.b1(), this._globeProjMatrixInverted = rt.b1(), this._cameraPosition = rt.bi(), this._globeLatitudeErrorCorrectionRadians = 0, this._helper = new Mt({
                                    calcMatrices: ()=>{
                                        this._calcMatrices();
                                    },
                                    getConstrained: (Qe, rt)=>this.getConstrained(Qe, rt)
                                }), this._coveringTilesDetailsProvider = new hi;
                            }
                            clone() {
                                const Qe = new ui;
                                return Qe.apply(this), Qe;
                            }
                            apply(Qe, rt) {
                                this._globeLatitudeErrorCorrectionRadians = rt || 0, this._helper.apply(Qe);
                            }
                            get projectionMatrix() {
                                return this._projectionMatrix;
                            }
                            get modelViewProjectionMatrix() {
                                return this._globeViewProjMatrixNoCorrection;
                            }
                            get inverseProjectionMatrix() {
                                return this._globeProjMatrixInverted;
                            }
                            get cameraPosition() {
                                const Qe = rt.bi();
                                return Qe[0] = this._cameraPosition[0], Qe[1] = this._cameraPosition[1], Qe[2] = this._cameraPosition[2], Qe;
                            }
                            get cameraToCenterDistance() {
                                return this._helper.cameraToCenterDistance;
                            }
                            getProjectionData(Qe) {
                                const { overscaledTileID: rt, applyGlobeMatrix: Wn } = Qe, Co = this._helper.getMercatorTileCoordinates(rt);
                                return {
                                    mainMatrix: this._globeViewProjMatrix32f,
                                    tileMercatorCoords: Co,
                                    clippingPlane: this._cachedClippingPlane,
                                    projectionTransition: Wn ? 1 : 0,
                                    fallbackMatrix: this._globeViewProjMatrix32f
                                };
                            }
                            _computeClippingPlane(Qe) {
                                const Wn = this.pitchInRadians, Co = this.cameraToCenterDistance / Qe, Dl = Math.sin(Wn) * Co, Ll = Math.cos(Wn) * Co + 1, Rl = 1 / Math.sqrt(Dl * Dl + Ll * Ll) * 1;
                                let Ul = -Dl, Gl = Ll;
                                const Zl = Math.sqrt(Ul * Ul + Gl * Gl);
                                Ul /= Zl, Gl /= Zl;
                                const Hl = [
                                    0,
                                    Ul,
                                    Gl
                                ];
                                return rt.bj(Hl, Hl, [
                                    0,
                                    0,
                                    0
                                ], -this.bearingInRadians), rt.bk(Hl, Hl, [
                                    0,
                                    0,
                                    0
                                ], -1 * this.center.lat * Math.PI / 180), rt.bl(Hl, Hl, [
                                    0,
                                    0,
                                    0
                                ], this.center.lng * Math.PI / 180), rt.aO(Hl, Hl, .25), [
                                    ...Hl,
                                    .25 * -Rl
                                ];
                            }
                            isLocationOccluded(Qe) {
                                return !this.isSurfacePointVisible(Jt(Qe));
                            }
                            transformLightDirection(Qe) {
                                const Wn = this._helper._center.lng * Math.PI / 180, Co = this._helper._center.lat * Math.PI / 180, Dl = Math.cos(Co), Ll = [
                                    Math.sin(Wn) * Dl,
                                    Math.sin(Co),
                                    Math.cos(Wn) * Dl
                                ], Rl = [
                                    Ll[2],
                                    0,
                                    -Ll[0]
                                ], Ul = [
                                    0,
                                    0,
                                    0
                                ];
                                rt.aU(Ul, Rl, Ll), rt.aT(Rl, Rl), rt.aT(Ul, Ul);
                                const Gl = [
                                    0,
                                    0,
                                    0
                                ];
                                return rt.aT(Gl, [
                                    Rl[0] * Qe[0] + Ul[0] * Qe[1] + Ll[0] * Qe[2],
                                    Rl[1] * Qe[0] + Ul[1] * Qe[1] + Ll[1] * Qe[2],
                                    Rl[2] * Qe[0] + Ul[2] * Qe[1] + Ll[2] * Qe[2]
                                ]), Gl;
                            }
                            getPixelScale() {
                                return 1 / Math.cos(this._helper._center.lat * Math.PI / 180);
                            }
                            getCircleRadiusCorrection() {
                                return Math.cos(this._helper._center.lat * Math.PI / 180);
                            }
                            getPitchedTextCorrection(Qe, Wn, Co) {
                                const Dl = function(Qe, Wn, Co) {
                                    const Dl = 1 / (1 << Co.z);
                                    return new rt.$(Qe / rt.Z * Dl + Co.x * Dl, Wn / rt.Z * Dl + Co.y * Dl);
                                }(Qe, Wn, Co.canonical), Ll = (Rl = Dl.y, [
                                    rt.bg(Dl.x * Math.PI * 2 + Math.PI, 2 * Math.PI),
                                    2 * Math.atan(Math.exp(Math.PI - Rl * Math.PI * 2)) - .5 * Math.PI
                                ]);
                                var Rl;
                                return this.getCircleRadiusCorrection() / Math.cos(Ll[1]);
                            }
                            projectTileCoordinates(Qe, Wn, Co, Dl) {
                                const Ll = Co.canonical, Rl = Yt(Qe, Wn, Ll.x, Ll.y, Ll.z), Ul = 1 + (Dl ? Dl(Qe, Wn) : 0) / rt.br, Gl = [
                                    Rl[0] * Ul,
                                    Rl[1] * Ul,
                                    Rl[2] * Ul,
                                    1
                                ];
                                rt.ap(Gl, Gl, this._globeViewProjMatrixNoCorrection);
                                const Zl = this._cachedClippingPlane, Hl = Zl[0] * Rl[0] + Zl[1] * Rl[1] + Zl[2] * Rl[2] + Zl[3] < 0;
                                return {
                                    point: new rt.P(Gl[0] / Gl[3], Gl[1] / Gl[3]),
                                    signedDistanceFromCamera: Gl[3],
                                    isOccluded: Hl
                                };
                            }
                            _calcMatrices() {
                                if (!this._helper._width || !this._helper._height) return;
                                const Qe = ei(this.worldSize, this.center.lat), Wn = rt.b2(), Co = rt.b2();
                                this._helper.autoCalculateNearFarZ && (this._helper._nearZ = .5, this._helper._farZ = this.cameraToCenterDistance + 2 * Qe), rt.aY(Wn, this.fovInRadians, this.width / this.height, this._helper._nearZ, this._helper._farZ);
                                const Dl = this.centerOffset;
                                Wn[8] = 2 * -Dl.x / this._helper._width, Wn[9] = 2 * Dl.y / this._helper._height, this._projectionMatrix = rt.aZ(Wn), this._globeProjMatrixInverted = rt.b2(), rt.aj(this._globeProjMatrixInverted, Wn), rt.L(Wn, Wn, [
                                    0,
                                    0,
                                    -this.cameraToCenterDistance
                                ]), rt.a_(Wn, Wn, this.rollInRadians), rt.a$(Wn, Wn, -this.pitchInRadians), rt.a_(Wn, Wn, this.bearingInRadians), rt.L(Wn, Wn, [
                                    0,
                                    0,
                                    -Qe
                                ]);
                                const Ll = rt.bi();
                                Ll[0] = Qe, Ll[1] = Qe, Ll[2] = Qe, rt.a$(Co, Wn, this.center.lat * Math.PI / 180), rt.bm(Co, Co, -this.center.lng * Math.PI / 180), rt.M(Co, Co, Ll), this._globeViewProjMatrixNoCorrection = Co, rt.a$(Wn, Wn, this.center.lat * Math.PI / 180 - this._globeLatitudeErrorCorrectionRadians), rt.bm(Wn, Wn, -this.center.lng * Math.PI / 180), rt.M(Wn, Wn, Ll), this._globeViewProjMatrix32f = new Float32Array(Wn), this._globeViewProjMatrixNoCorrectionInverted = rt.b2(), rt.aj(this._globeViewProjMatrixNoCorrectionInverted, Co);
                                const Rl = rt.bi();
                                this._cameraPosition = rt.bi(), this._cameraPosition[2] = this.cameraToCenterDistance / Qe, rt.bj(this._cameraPosition, this._cameraPosition, Rl, -this.rollInRadians), rt.bk(this._cameraPosition, this._cameraPosition, Rl, this.pitchInRadians), rt.bj(this._cameraPosition, this._cameraPosition, Rl, -this.bearingInRadians), rt.aP(this._cameraPosition, this._cameraPosition, [
                                    0,
                                    0,
                                    1
                                ]), rt.bk(this._cameraPosition, this._cameraPosition, Rl, -this.center.lat * Math.PI / 180), rt.bl(this._cameraPosition, this._cameraPosition, Rl, this.center.lng * Math.PI / 180), this._cachedClippingPlane = this._computeClippingPlane(Qe);
                                const Ul = rt.aZ(this._globeViewProjMatrixNoCorrectionInverted);
                                rt.M(Ul, Ul, [
                                    1,
                                    1,
                                    -1
                                ]), this._cachedFrustum = Rt.fromInvProjectionMatrix(Ul);
                            }
                            calculateFogMatrix(Qe) {
                                rt.w("calculateFogMatrix is not supported on globe projection.");
                                const Wn = rt.b2();
                                return rt.at(Wn), Wn;
                            }
                            getVisibleUnwrappedCoordinates(Qe) {
                                return [
                                    new rt.aW(0, Qe)
                                ];
                            }
                            getCameraFrustum() {
                                return this._cachedFrustum;
                            }
                            getClippingPlane() {
                                return this._cachedClippingPlane;
                            }
                            getCoveringTilesDetailsProvider() {
                                return this._coveringTilesDetailsProvider;
                            }
                            recalculateZoomAndCenter(Qe) {
                                Qe && rt.w("terrain is not fully supported on vertical perspective projection."), this._helper.recalculateZoomAndCenter(0);
                            }
                            maxPitchScaleFactor() {
                                return 1;
                            }
                            getCameraPoint() {
                                return this._helper.getCameraPoint();
                            }
                            getCameraAltitude() {
                                return this._helper.getCameraAltitude();
                            }
                            getCameraLngLat() {
                                return this._helper.getCameraLngLat();
                            }
                            lngLatToCameraDepth(Qe, Wn) {
                                if (!this._globeViewProjMatrixNoCorrection) return 1;
                                const Co = Jt(Qe);
                                rt.aO(Co, Co, 1 + Wn / rt.br);
                                const Dl = rt.bh();
                                return rt.ap(Dl, [
                                    Co[0],
                                    Co[1],
                                    Co[2],
                                    1
                                ], this._globeViewProjMatrixNoCorrection), Dl[2] / Dl[3];
                            }
                            populateCache(Qe) {}
                            getBounds() {
                                const Qe = .5 * this.width, Wn = .5 * this.height, Co = [
                                    new rt.P(0, 0),
                                    new rt.P(Qe, 0),
                                    new rt.P(this.width, 0),
                                    new rt.P(this.width, Wn),
                                    new rt.P(this.width, this.height),
                                    new rt.P(Qe, this.height),
                                    new rt.P(0, this.height),
                                    new rt.P(0, Wn)
                                ], Dl = [];
                                for (const rt of Co)Dl.push(this.unprojectScreenPoint(rt));
                                let Ll = 0, Rl = 0, Ul = 0, Gl = 0;
                                const Zl = this.center;
                                for (const ql of Dl){
                                    const Qe = rt.bn(Zl.lng, ql.lng), Wn = rt.bn(Zl.lat, ql.lat);
                                    Qe < Rl && (Rl = Qe), Qe > Ll && (Ll = Qe), Wn < Gl && (Gl = Wn), Wn > Ul && (Ul = Wn);
                                }
                                const Hl = [
                                    Zl.lng + Rl,
                                    Zl.lat + Gl,
                                    Zl.lng + Ll,
                                    Zl.lat + Ul
                                ];
                                return this.isSurfacePointOnScreen([
                                    0,
                                    1,
                                    0
                                ]) && (Hl[3] = 90, Hl[0] = -180, Hl[2] = 180), this.isSurfacePointOnScreen([
                                    0,
                                    -1,
                                    0
                                ]) && (Hl[1] = -90, Hl[0] = -180, Hl[2] = 180), new V(Hl);
                            }
                            getConstrained(Qe, Wn) {
                                const Co = rt.ae(Qe.lat, -85.051129, rt.aJ), Dl = rt.ae(+Wn, this.minZoom + ri(0, Co), this.maxZoom);
                                return {
                                    center: new rt.Q(Qe.lng, Co),
                                    zoom: Dl
                                };
                            }
                            calculateCenterFromCameraLngLatAlt(Qe, rt, Wn, Co) {
                                return this._helper.calculateCenterFromCameraLngLatAlt(Qe, rt, Wn, Co);
                            }
                            setLocationAtPoint(Qe, Wn) {
                                const Co = Jt(this.unprojectScreenPoint(Wn)), Dl = Jt(Qe), Ll = rt.bi();
                                rt.bo(Ll);
                                const Rl = rt.bi();
                                rt.bl(Rl, Co, Ll, -this.center.lng * Math.PI / 180), rt.bk(Rl, Rl, Ll, this.center.lat * Math.PI / 180);
                                const Ul = Dl[0] * Dl[0] + Dl[2] * Dl[2], Gl = Rl[0] * Rl[0];
                                if (Ul < Gl) return;
                                const Zl = Math.sqrt(Ul - Gl), Hl = -Zl, ql = rt.bp(Dl[0], Dl[2], Rl[0], Zl), Ql = rt.bp(Dl[0], Dl[2], Rl[0], Hl), Kl = rt.bi();
                                rt.bl(Kl, Dl, Ll, -ql);
                                const $l = rt.bp(Kl[1], Kl[2], Rl[1], Rl[2]), Tc = rt.bi();
                                rt.bl(Tc, Dl, Ll, -Ql);
                                const tu = rt.bp(Tc[1], Tc[2], Rl[1], Rl[2]), lu = .5 * Math.PI, du = $l >= -lu && $l <= lu, fu = tu >= -lu && tu <= lu;
                                let yu, Eu;
                                if (du && fu) {
                                    const Qe = this.center.lng * Math.PI / 180, Wn = this.center.lat * Math.PI / 180;
                                    rt.bs(ql, Qe) + rt.bs($l, Wn) < rt.bs(Ql, Qe) + rt.bs(tu, Wn) ? (yu = ql, Eu = $l) : (yu = Ql, Eu = tu);
                                } else if (du) yu = ql, Eu = $l;
                                else {
                                    if (!fu) return;
                                    yu = Ql, Eu = tu;
                                }
                                const Tu = yu / Math.PI * 180, Lu = Eu / Math.PI * 180, Zu = this.center.lat;
                                this.setCenter(new rt.Q(Tu, rt.ae(Lu, -90, 90))), this.setZoom(this.zoom + ri(Zu, this.center.lat));
                            }
                            locationToScreenPoint(Qe, Wn) {
                                const Co = Jt(Qe);
                                if (Wn) {
                                    const Dl = Wn.getElevationForLngLatZoom(Qe, this._helper._tileZoom);
                                    rt.aO(Co, Co, 1 + Dl / rt.br);
                                }
                                return this._projectSurfacePointToScreen(Co);
                            }
                            _projectSurfacePointToScreen(Qe) {
                                const Wn = rt.bh();
                                return rt.ap(Wn, [
                                    ...Qe,
                                    1
                                ], this._globeViewProjMatrixNoCorrection), Wn[0] /= Wn[3], Wn[1] /= Wn[3], new rt.P((.5 * Wn[0] + .5) * this.width, (.5 * -Wn[1] + .5) * this.height);
                            }
                            screenPointToMercatorCoordinate(Qe, Wn) {
                                if (Wn) {
                                    const rt = Wn.pointCoordinate(Qe);
                                    if (rt) return rt;
                                }
                                return rt.$.fromLngLat(this.unprojectScreenPoint(Qe));
                            }
                            screenPointToLocation(Qe, rt) {
                                var Wn;
                                return null === (Wn = this.screenPointToMercatorCoordinate(Qe, rt)) || void 0 === Wn ? void 0 : Wn.toLngLat();
                            }
                            isPointOnMapSurface(Qe, rt) {
                                const Wn = this._cameraPosition, Co = this.getRayDirectionFromPixel(Qe);
                                return !!this.rayPlanetIntersection(Wn, Co);
                            }
                            getRayDirectionFromPixel(Qe) {
                                const Wn = rt.bh();
                                Wn[0] = Qe.x / this.width * 2 - 1, Wn[1] = -1 * (Qe.y / this.height * 2 - 1), Wn[2] = 1, Wn[3] = 1, rt.ap(Wn, Wn, this._globeViewProjMatrixNoCorrectionInverted), Wn[0] /= Wn[3], Wn[1] /= Wn[3], Wn[2] /= Wn[3];
                                const Co = rt.bi();
                                Co[0] = Wn[0] - this._cameraPosition[0], Co[1] = Wn[1] - this._cameraPosition[1], Co[2] = Wn[2] - this._cameraPosition[2];
                                const Dl = rt.bi();
                                return rt.aT(Dl, Co), Dl;
                            }
                            isSurfacePointVisible(Qe) {
                                const rt = this._cachedClippingPlane;
                                return rt[0] * Qe[0] + rt[1] * Qe[1] + rt[2] * Qe[2] + rt[3] >= 0;
                            }
                            isSurfacePointOnScreen(Qe) {
                                if (!this.isSurfacePointVisible(Qe)) return !1;
                                const Wn = rt.bh();
                                return rt.ap(Wn, [
                                    ...Qe,
                                    1
                                ], this._globeViewProjMatrixNoCorrection), Wn[0] /= Wn[3], Wn[1] /= Wn[3], Wn[2] /= Wn[3], Wn[0] > -1 && Wn[0] < 1 && Wn[1] > -1 && Wn[1] < 1 && Wn[2] > -1 && Wn[2] < 1;
                            }
                            rayPlanetIntersection(Qe, Wn) {
                                const Co = rt.aV(Qe, Wn), Dl = rt.bi(), Ll = rt.bi();
                                rt.aO(Ll, Wn, Co), rt.aS(Dl, Qe, Ll);
                                const Rl = 1 - rt.aV(Dl, Dl);
                                if (Rl < 0) return null;
                                const Ul = rt.aV(Qe, Qe) - 1, Gl = -Co + (Co < 0 ? 1 : -1) * Math.sqrt(Rl), Zl = Ul / Gl, Hl = Gl;
                                return {
                                    tMin: Math.min(Zl, Hl),
                                    tMax: Math.max(Zl, Hl)
                                };
                            }
                            unprojectScreenPoint(Qe) {
                                const Wn = this._cameraPosition, Co = this.getRayDirectionFromPixel(Qe), Dl = this.rayPlanetIntersection(Wn, Co);
                                if (Dl) {
                                    const Qe = rt.bi();
                                    rt.aP(Qe, Wn, [
                                        Co[0] * Dl.tMin,
                                        Co[1] * Dl.tMin,
                                        Co[2] * Dl.tMin
                                    ]);
                                    const Ll = rt.bi();
                                    return rt.aT(Ll, Qe), ti(Ll);
                                }
                                const Ll = this._cachedClippingPlane[0] * Co[0] + this._cachedClippingPlane[1] * Co[1] + this._cachedClippingPlane[2] * Co[2], Rl = -rt.bq(this._cachedClippingPlane, Wn) / Ll, Ul = rt.bi();
                                if (Rl > 0) rt.aP(Ul, Wn, [
                                    Co[0] * Rl,
                                    Co[1] * Rl,
                                    Co[2] * Rl
                                ]);
                                else {
                                    const Qe = rt.bi();
                                    rt.aP(Qe, Wn, [
                                        2 * Co[0],
                                        2 * Co[1],
                                        2 * Co[2]
                                    ]);
                                    const Dl = rt.bq(this._cachedClippingPlane, Qe);
                                    rt.aS(Ul, Qe, [
                                        this._cachedClippingPlane[0] * Dl,
                                        this._cachedClippingPlane[1] * Dl,
                                        this._cachedClippingPlane[2] * Dl
                                    ]);
                                }
                                const Gl = rt.bi();
                                return rt.aT(Gl, Ul), ti(Gl);
                            }
                            getMatrixForModel(Qe, Wn) {
                                const Co = rt.Q.convert(Qe), Dl = 1 / rt.br, Ll = rt.b1();
                                return rt.bm(Ll, Ll, Co.lng / 180 * Math.PI), rt.a$(Ll, Ll, -Co.lat / 180 * Math.PI), rt.L(Ll, Ll, [
                                    0,
                                    0,
                                    1 + Wn / rt.br
                                ]), rt.a$(Ll, Ll, .5 * Math.PI), rt.M(Ll, Ll, [
                                    Dl,
                                    Dl,
                                    Dl
                                ]), Ll;
                            }
                            getProjectionDataForCustomLayer(Qe = !0) {
                                const Wn = this.getProjectionData({
                                    overscaledTileID: new rt.Y(0, 0, 0, 0, 0),
                                    applyGlobeMatrix: Qe
                                });
                                return Wn.tileMercatorCoords = [
                                    0,
                                    0,
                                    1,
                                    1
                                ], Wn;
                            }
                            getFastPathSimpleProjectionMatrix(Qe) {}
                        }
                        class di {
                            get pixelsToClipSpaceMatrix() {
                                return this._helper.pixelsToClipSpaceMatrix;
                            }
                            get clipSpaceToPixelsMatrix() {
                                return this._helper.clipSpaceToPixelsMatrix;
                            }
                            get pixelsToGLUnits() {
                                return this._helper.pixelsToGLUnits;
                            }
                            get centerOffset() {
                                return this._helper.centerOffset;
                            }
                            get size() {
                                return this._helper.size;
                            }
                            get rotationMatrix() {
                                return this._helper.rotationMatrix;
                            }
                            get centerPoint() {
                                return this._helper.centerPoint;
                            }
                            get pixelsPerMeter() {
                                return this._helper.pixelsPerMeter;
                            }
                            setMinZoom(Qe) {
                                this._helper.setMinZoom(Qe);
                            }
                            setMaxZoom(Qe) {
                                this._helper.setMaxZoom(Qe);
                            }
                            setMinPitch(Qe) {
                                this._helper.setMinPitch(Qe);
                            }
                            setMaxPitch(Qe) {
                                this._helper.setMaxPitch(Qe);
                            }
                            setRenderWorldCopies(Qe) {
                                this._helper.setRenderWorldCopies(Qe);
                            }
                            setBearing(Qe) {
                                this._helper.setBearing(Qe);
                            }
                            setPitch(Qe) {
                                this._helper.setPitch(Qe);
                            }
                            setRoll(Qe) {
                                this._helper.setRoll(Qe);
                            }
                            setFov(Qe) {
                                this._helper.setFov(Qe);
                            }
                            setZoom(Qe) {
                                this._helper.setZoom(Qe);
                            }
                            setCenter(Qe) {
                                this._helper.setCenter(Qe);
                            }
                            setElevation(Qe) {
                                this._helper.setElevation(Qe);
                            }
                            setMinElevationForCurrentTile(Qe) {
                                this._helper.setMinElevationForCurrentTile(Qe);
                            }
                            setPadding(Qe) {
                                this._helper.setPadding(Qe);
                            }
                            interpolatePadding(Qe, rt, Wn) {
                                return this._helper.interpolatePadding(Qe, rt, Wn);
                            }
                            isPaddingEqual(Qe) {
                                return this._helper.isPaddingEqual(Qe);
                            }
                            resize(Qe, rt, Wn = !0) {
                                this._helper.resize(Qe, rt, Wn);
                            }
                            getMaxBounds() {
                                return this._helper.getMaxBounds();
                            }
                            setMaxBounds(Qe) {
                                this._helper.setMaxBounds(Qe);
                            }
                            overrideNearFarZ(Qe, rt) {
                                this._helper.overrideNearFarZ(Qe, rt);
                            }
                            clearNearFarZOverride() {
                                this._helper.clearNearFarZOverride();
                            }
                            getCameraQueryGeometry(Qe) {
                                return this._helper.getCameraQueryGeometry(this.getCameraPoint(), Qe);
                            }
                            get tileSize() {
                                return this._helper.tileSize;
                            }
                            get tileZoom() {
                                return this._helper.tileZoom;
                            }
                            get scale() {
                                return this._helper.scale;
                            }
                            get worldSize() {
                                return this._helper.worldSize;
                            }
                            get width() {
                                return this._helper.width;
                            }
                            get height() {
                                return this._helper.height;
                            }
                            get lngRange() {
                                return this._helper.lngRange;
                            }
                            get latRange() {
                                return this._helper.latRange;
                            }
                            get minZoom() {
                                return this._helper.minZoom;
                            }
                            get maxZoom() {
                                return this._helper.maxZoom;
                            }
                            get zoom() {
                                return this._helper.zoom;
                            }
                            get center() {
                                return this._helper.center;
                            }
                            get minPitch() {
                                return this._helper.minPitch;
                            }
                            get maxPitch() {
                                return this._helper.maxPitch;
                            }
                            get pitch() {
                                return this._helper.pitch;
                            }
                            get pitchInRadians() {
                                return this._helper.pitchInRadians;
                            }
                            get roll() {
                                return this._helper.roll;
                            }
                            get rollInRadians() {
                                return this._helper.rollInRadians;
                            }
                            get bearing() {
                                return this._helper.bearing;
                            }
                            get bearingInRadians() {
                                return this._helper.bearingInRadians;
                            }
                            get fov() {
                                return this._helper.fov;
                            }
                            get fovInRadians() {
                                return this._helper.fovInRadians;
                            }
                            get elevation() {
                                return this._helper.elevation;
                            }
                            get minElevationForCurrentTile() {
                                return this._helper.minElevationForCurrentTile;
                            }
                            get padding() {
                                return this._helper.padding;
                            }
                            get unmodified() {
                                return this._helper.unmodified;
                            }
                            get renderWorldCopies() {
                                return this._helper.renderWorldCopies;
                            }
                            get cameraToCenterDistance() {
                                return this._helper.cameraToCenterDistance;
                            }
                            get nearZ() {
                                return this._helper.nearZ;
                            }
                            get farZ() {
                                return this._helper.farZ;
                            }
                            get autoCalculateNearFarZ() {
                                return this._helper.autoCalculateNearFarZ;
                            }
                            get isGlobeRendering() {
                                return this._globeness > 0;
                            }
                            setTransitionState(Qe, rt) {
                                this._globeness = Qe, this._globeLatitudeErrorCorrectionRadians = rt, this._calcMatrices(), this._verticalPerspectiveTransform.getCoveringTilesDetailsProvider().recalculateCache(), this._mercatorTransform.getCoveringTilesDetailsProvider().recalculateCache();
                            }
                            get currentTransform() {
                                return this.isGlobeRendering ? this._verticalPerspectiveTransform : this._mercatorTransform;
                            }
                            constructor(){
                                this._globeLatitudeErrorCorrectionRadians = 0, this._globeness = 1, this._helper = new Mt({
                                    calcMatrices: ()=>{
                                        this._calcMatrices();
                                    },
                                    getConstrained: (Qe, rt)=>this.getConstrained(Qe, rt)
                                }), this._globeness = 1, this._mercatorTransform = new Dt, this._verticalPerspectiveTransform = new ui;
                            }
                            clone() {
                                const Qe = new di;
                                return Qe._globeness = this._globeness, Qe._globeLatitudeErrorCorrectionRadians = this._globeLatitudeErrorCorrectionRadians, Qe.apply(this), Qe;
                            }
                            apply(Qe) {
                                this._helper.apply(Qe), this._mercatorTransform.apply(this), this._verticalPerspectiveTransform.apply(this, this._globeLatitudeErrorCorrectionRadians);
                            }
                            get projectionMatrix() {
                                return this.currentTransform.projectionMatrix;
                            }
                            get modelViewProjectionMatrix() {
                                return this.currentTransform.modelViewProjectionMatrix;
                            }
                            get inverseProjectionMatrix() {
                                return this.currentTransform.inverseProjectionMatrix;
                            }
                            get cameraPosition() {
                                return this.currentTransform.cameraPosition;
                            }
                            getProjectionData(Qe) {
                                const rt = this._mercatorTransform.getProjectionData(Qe), Wn = this._verticalPerspectiveTransform.getProjectionData(Qe);
                                return {
                                    mainMatrix: this.isGlobeRendering ? Wn.mainMatrix : rt.mainMatrix,
                                    clippingPlane: Wn.clippingPlane,
                                    tileMercatorCoords: Wn.tileMercatorCoords,
                                    projectionTransition: Qe.applyGlobeMatrix ? this._globeness : 0,
                                    fallbackMatrix: rt.fallbackMatrix
                                };
                            }
                            isLocationOccluded(Qe) {
                                return this.currentTransform.isLocationOccluded(Qe);
                            }
                            transformLightDirection(Qe) {
                                return this.currentTransform.transformLightDirection(Qe);
                            }
                            getPixelScale() {
                                return rt.bc(this._mercatorTransform.getPixelScale(), this._verticalPerspectiveTransform.getPixelScale(), this._globeness);
                            }
                            getCircleRadiusCorrection() {
                                return rt.bc(this._mercatorTransform.getCircleRadiusCorrection(), this._verticalPerspectiveTransform.getCircleRadiusCorrection(), this._globeness);
                            }
                            getPitchedTextCorrection(Qe, Wn, Co) {
                                const Dl = this._mercatorTransform.getPitchedTextCorrection(Qe, Wn, Co), Ll = this._verticalPerspectiveTransform.getPitchedTextCorrection(Qe, Wn, Co);
                                return rt.bc(Dl, Ll, this._globeness);
                            }
                            projectTileCoordinates(Qe, rt, Wn, Co) {
                                return this.currentTransform.projectTileCoordinates(Qe, rt, Wn, Co);
                            }
                            _calcMatrices() {
                                this._helper._width && this._helper._height && (this._verticalPerspectiveTransform.apply(this, this._globeLatitudeErrorCorrectionRadians), this._helper._nearZ = this._verticalPerspectiveTransform.nearZ, this._helper._farZ = this._verticalPerspectiveTransform.farZ, this._mercatorTransform.apply(this, !0, this.isGlobeRendering), this._helper._nearZ = this._mercatorTransform.nearZ, this._helper._farZ = this._mercatorTransform.farZ);
                            }
                            calculateFogMatrix(Qe) {
                                return this.currentTransform.calculateFogMatrix(Qe);
                            }
                            getVisibleUnwrappedCoordinates(Qe) {
                                return this.currentTransform.getVisibleUnwrappedCoordinates(Qe);
                            }
                            getCameraFrustum() {
                                return this.currentTransform.getCameraFrustum();
                            }
                            getClippingPlane() {
                                return this.currentTransform.getClippingPlane();
                            }
                            getCoveringTilesDetailsProvider() {
                                return this.currentTransform.getCoveringTilesDetailsProvider();
                            }
                            recalculateZoomAndCenter(Qe) {
                                this._mercatorTransform.recalculateZoomAndCenter(Qe), this._verticalPerspectiveTransform.recalculateZoomAndCenter(Qe);
                            }
                            maxPitchScaleFactor() {
                                return this._mercatorTransform.maxPitchScaleFactor();
                            }
                            getCameraPoint() {
                                return this._helper.getCameraPoint();
                            }
                            getCameraAltitude() {
                                return this._helper.getCameraAltitude();
                            }
                            getCameraLngLat() {
                                return this._helper.getCameraLngLat();
                            }
                            lngLatToCameraDepth(Qe, rt) {
                                return this.currentTransform.lngLatToCameraDepth(Qe, rt);
                            }
                            populateCache(Qe) {
                                this._mercatorTransform.populateCache(Qe), this._verticalPerspectiveTransform.populateCache(Qe);
                            }
                            getBounds() {
                                return this.currentTransform.getBounds();
                            }
                            getConstrained(Qe, rt) {
                                return this.currentTransform.getConstrained(Qe, rt);
                            }
                            calculateCenterFromCameraLngLatAlt(Qe, rt, Wn, Co) {
                                return this._helper.calculateCenterFromCameraLngLatAlt(Qe, rt, Wn, Co);
                            }
                            setLocationAtPoint(Qe, rt) {
                                if (!this.isGlobeRendering) return this._mercatorTransform.setLocationAtPoint(Qe, rt), void this.apply(this._mercatorTransform);
                                this._verticalPerspectiveTransform.setLocationAtPoint(Qe, rt), this.apply(this._verticalPerspectiveTransform);
                            }
                            locationToScreenPoint(Qe, rt) {
                                return this.currentTransform.locationToScreenPoint(Qe, rt);
                            }
                            screenPointToMercatorCoordinate(Qe, rt) {
                                return this.currentTransform.screenPointToMercatorCoordinate(Qe, rt);
                            }
                            screenPointToLocation(Qe, rt) {
                                return this.currentTransform.screenPointToLocation(Qe, rt);
                            }
                            isPointOnMapSurface(Qe, rt) {
                                return this.currentTransform.isPointOnMapSurface(Qe, rt);
                            }
                            getRayDirectionFromPixel(Qe) {
                                return this._verticalPerspectiveTransform.getRayDirectionFromPixel(Qe);
                            }
                            getMatrixForModel(Qe, rt) {
                                return this.currentTransform.getMatrixForModel(Qe, rt);
                            }
                            getProjectionDataForCustomLayer(Qe = !0) {
                                const rt = this._mercatorTransform.getProjectionDataForCustomLayer(Qe);
                                if (!this.isGlobeRendering) return rt;
                                const Wn = this._verticalPerspectiveTransform.getProjectionDataForCustomLayer(Qe);
                                return Wn.fallbackMatrix = rt.mainMatrix, Wn;
                            }
                            getFastPathSimpleProjectionMatrix(Qe) {
                                return this.currentTransform.getFastPathSimpleProjectionMatrix(Qe);
                            }
                        }
                        class _i {
                            get useGlobeControls() {
                                return !0;
                            }
                            handlePanInertia(Qe, Wn) {
                                const Co = oi(Qe, Wn);
                                return Math.abs(Co.lng - Wn.center.lng) > 180 && (Co.lng = Wn.center.lng + 179.5 * Math.sign(Co.lng - Wn.center.lng)), {
                                    easingCenter: Co,
                                    easingOffset: new rt.P(0, 0)
                                };
                            }
                            handleMapControlsRollPitchBearingZoom(Qe, Wn) {
                                const Co = Qe.around, Dl = Wn.screenPointToLocation(Co);
                                Qe.bearingDelta && Wn.setBearing(Wn.bearing + Qe.bearingDelta), Qe.pitchDelta && Wn.setPitch(Wn.pitch + Qe.pitchDelta), Qe.rollDelta && Wn.setRoll(Wn.roll + Qe.rollDelta);
                                const Ll = Wn.zoom;
                                Qe.zoomDelta && Wn.setZoom(Wn.zoom + Qe.zoomDelta);
                                const Rl = Wn.zoom - Ll;
                                if (0 === Rl) return;
                                const Ul = rt.bn(Wn.center.lng, Dl.lng), Gl = Ul / (Math.abs(Ul / 180) + 1), Zl = rt.bn(Wn.center.lat, Dl.lat), Hl = Wn.getRayDirectionFromPixel(Co), ql = Wn.cameraPosition, Ql = -1 * rt.aV(ql, Hl), Kl = rt.bi();
                                rt.aP(Kl, ql, [
                                    Hl[0] * Ql,
                                    Hl[1] * Ql,
                                    Hl[2] * Ql
                                ]);
                                const $l = rt.bt(Kl) - 1, Tc = Math.exp(.5 * -Math.max($l - .3, 0)), tu = ei(Wn.worldSize, Wn.center.lat) / Math.min(Wn.width, Wn.height), lu = rt.bf(tu, .9, .5, 1, .25), du = (1 - rt.aI(-Rl)) * Math.min(Tc, lu), fu = Wn.center.lat, yu = Wn.zoom, Eu = new rt.Q(Wn.center.lng + Gl * du, rt.ae(Wn.center.lat + Zl * du, -85.051129, rt.aJ));
                                Wn.setLocationAtPoint(Dl, Co);
                                const Tu = Wn.center, Lu = rt.bf(Math.abs(Ul), 45, 85, 0, 1), Zu = rt.bf(tu, .75, .35, 0, 1), Xu = Math.pow(Math.max(Lu, Zu), .25), Ju = rt.bn(Tu.lng, Eu.lng), $u = rt.bn(Tu.lat, Eu.lat);
                                Wn.setCenter(new rt.Q(Tu.lng + Ju * Xu, Tu.lat + $u * Xu).wrap()), Wn.setZoom(yu + ri(fu, Wn.center.lat));
                            }
                            handleMapControlsPan(Qe, rt, Wn) {
                                if (!Qe.panDelta) return;
                                const Co = rt.center.lat, Dl = rt.zoom;
                                rt.setCenter(oi(Qe.panDelta, rt).wrap()), rt.setZoom(Dl + ri(Co, rt.center.lat));
                            }
                            cameraForBoxAndBearing(Qe, Wn, Co, Dl, Ll) {
                                const Rl = Lt(Qe, Wn, Co, Dl, Ll), Ul = Wn.left / Ll.width * 2 - 1, Gl = (Ll.width - Wn.right) / Ll.width * 2 - 1, Zl = Wn.top / Ll.height * -2 + 1, Hl = (Ll.height - Wn.bottom) / Ll.height * -2 + 1, ql = rt.bn(Co.getWest(), Co.getEast()) < 0, Ql = ql ? Co.getEast() : Co.getWest(), Kl = ql ? Co.getWest() : Co.getEast(), $l = Math.max(Co.getNorth(), Co.getSouth()), Tc = Math.min(Co.getNorth(), Co.getSouth()), tu = Ql + .5 * rt.bn(Ql, Kl), lu = $l + .5 * rt.bn($l, Tc), du = Ll.clone();
                                du.setCenter(Rl.center), du.setBearing(Rl.bearing), du.setPitch(0), du.setRoll(0), du.setZoom(Rl.zoom);
                                const fu = du.modelViewProjectionMatrix, yu = [
                                    Jt(Co.getNorthWest()),
                                    Jt(Co.getNorthEast()),
                                    Jt(Co.getSouthWest()),
                                    Jt(Co.getSouthEast()),
                                    Jt(new rt.Q(Kl, lu)),
                                    Jt(new rt.Q(Ql, lu)),
                                    Jt(new rt.Q(tu, $l)),
                                    Jt(new rt.Q(tu, Tc))
                                ], Eu = Jt(Rl.center);
                                let Tu = Number.POSITIVE_INFINITY;
                                for (const rt of yu)Ul < 0 && (Tu = _i.getLesserNonNegativeNonNull(Tu, _i.solveVectorScale(rt, Eu, fu, "x", Ul))), Gl > 0 && (Tu = _i.getLesserNonNegativeNonNull(Tu, _i.solveVectorScale(rt, Eu, fu, "x", Gl))), Zl > 0 && (Tu = _i.getLesserNonNegativeNonNull(Tu, _i.solveVectorScale(rt, Eu, fu, "y", Zl))), Hl < 0 && (Tu = _i.getLesserNonNegativeNonNull(Tu, _i.solveVectorScale(rt, Eu, fu, "y", Hl)));
                                if (Number.isFinite(Tu) && 0 !== Tu) return Rl.zoom = du.zoom + rt.ab(Tu), Rl;
                                zt();
                            }
                            handleJumpToCenterZoom(Qe, Wn) {
                                const Co = Qe.center.lat, Dl = Qe.getConstrained(Wn.center ? rt.Q.convert(Wn.center) : Qe.center, Qe.zoom).center;
                                Qe.setCenter(Dl.wrap());
                                const Ll = void 0 !== Wn.zoom ? +Wn.zoom : Qe.zoom + ri(Co, Dl.lat);
                                Qe.zoom !== Ll && Qe.setZoom(Ll);
                            }
                            handleEaseTo(Qe, Wn) {
                                const Co = Qe.zoom, Dl = Qe.center, Ll = Qe.padding, Rl = {
                                    roll: Qe.roll,
                                    pitch: Qe.pitch,
                                    bearing: Qe.bearing
                                }, Ul = {
                                    roll: void 0 === Wn.roll ? Qe.roll : Wn.roll,
                                    pitch: void 0 === Wn.pitch ? Qe.pitch : Wn.pitch,
                                    bearing: void 0 === Wn.bearing ? Qe.bearing : Wn.bearing
                                }, Gl = void 0 !== Wn.zoom, Zl = !Qe.isPaddingEqual(Wn.padding);
                                let Hl = !1;
                                const ql = Wn.center ? rt.Q.convert(Wn.center) : Dl, Ql = Qe.getConstrained(ql, Co).center;
                                Ct(Qe, Ql);
                                const Kl = Qe.clone();
                                Kl.setCenter(Ql), Kl.setZoom(Gl ? +Wn.zoom : Co + ri(Dl.lat, ql.lat)), Kl.setBearing(Wn.bearing);
                                const $l = new rt.P(rt.ae(Qe.centerPoint.x + Wn.offsetAsPoint.x, 0, Qe.width), rt.ae(Qe.centerPoint.y + Wn.offsetAsPoint.y, 0, Qe.height));
                                Kl.setLocationAtPoint(Ql, $l);
                                const Tc = (Wn.offset && Wn.offsetAsPoint.mag()) > 0 ? Kl.center : Ql, tu = Gl ? +Wn.zoom : Co + ri(Dl.lat, Tc.lat), lu = Co + ri(Dl.lat, 0), du = tu + ri(Tc.lat, 0), fu = rt.bn(Dl.lng, Tc.lng), yu = rt.bn(Dl.lat, Tc.lat), Eu = rt.aI(du - lu);
                                return Hl = tu !== Co, {
                                    easeFunc: (Co)=>{
                                        if (rt.b6(Rl, Ul) || At({
                                            startEulerAngles: Rl,
                                            endEulerAngles: Ul,
                                            tr: Qe,
                                            k: Co,
                                            useSlerp: Rl.roll != Ul.roll
                                        }), Zl && Qe.interpolatePadding(Ll, Wn.padding, Co), Wn.around) rt.w("Easing around a point is not supported under globe projection."), Qe.setLocationAtPoint(Wn.around, Wn.aroundPoint);
                                        else {
                                            const rt = du > lu ? Math.min(2, Eu) : Math.max(.5, Eu), Wn = Math.pow(rt, 1 - Co), Ll = si(Dl, fu, yu, Co * Wn);
                                            Qe.setCenter(Ll.wrap());
                                        }
                                        if (Hl) {
                                            const Wn = rt.B.number(lu, du, Co) + ri(0, Qe.center.lat);
                                            Qe.setZoom(Wn);
                                        }
                                    },
                                    isZooming: Hl,
                                    elevationCenter: Tc
                                };
                            }
                            handleFlyTo(Qe, Wn) {
                                const Co = void 0 !== Wn.zoom, Dl = Qe.center, Ll = Qe.zoom, Rl = Qe.padding, Ul = !Qe.isPaddingEqual(Wn.padding), Gl = Qe.getConstrained(rt.Q.convert(Wn.center || Wn.locationAtOffset), Ll).center, Zl = Co ? +Wn.zoom : Qe.zoom + ri(Qe.center.lat, Gl.lat), Hl = Qe.clone();
                                Hl.setCenter(Gl), Hl.setZoom(Zl), Hl.setBearing(Wn.bearing);
                                const ql = new rt.P(rt.ae(Qe.centerPoint.x + Wn.offsetAsPoint.x, 0, Qe.width), rt.ae(Qe.centerPoint.y + Wn.offsetAsPoint.y, 0, Qe.height));
                                Hl.setLocationAtPoint(Gl, ql);
                                const Ql = Hl.center;
                                Ct(Qe, Ql);
                                const Kl = function(Qe, Wn, Co) {
                                    const Dl = Jt(Wn), Ll = Jt(Co), Rl = rt.aV(Dl, Ll), Ul = Math.acos(Rl), Gl = Qt(Qe);
                                    return Ul / (2 * Math.PI) * Gl;
                                }(Qe, Dl, Ql), $l = Ll + ri(Dl.lat, 0), Tc = Zl + ri(Ql.lat, 0), tu = rt.aI(Tc - $l);
                                let lu;
                                if ("number" == typeof Wn.minZoom) {
                                    const Co = +Wn.minZoom + ri(Ql.lat, 0), Dl = Math.min(Co, $l, Tc) + ri(0, Ql.lat), Ll = Qe.getConstrained(Ql, Dl).zoom + ri(Ql.lat, 0);
                                    lu = rt.aI(Ll - $l);
                                }
                                const du = rt.bn(Dl.lng, Ql.lng), fu = rt.bn(Dl.lat, Ql.lat);
                                return {
                                    easeFunc: (Co, Ll, Gl, Hl)=>{
                                        const ql = si(Dl, du, fu, Gl);
                                        Ul && Qe.interpolatePadding(Rl, Wn.padding, Co);
                                        const Kl = 1 === Co ? Ql : ql;
                                        Qe.setCenter(Kl.wrap());
                                        const Tc = $l + rt.ab(Ll);
                                        Qe.setZoom(1 === Co ? Zl : Tc + ri(0, Kl.lat));
                                    },
                                    scaleOfZoom: tu,
                                    targetCenter: Ql,
                                    scaleOfMinZoom: lu,
                                    pixelPathLength: Kl
                                };
                            }
                            static solveVectorScale(Qe, rt, Wn, Co, Dl) {
                                const Ll = "x" === Co ? [
                                    Wn[0],
                                    Wn[4],
                                    Wn[8],
                                    Wn[12]
                                ] : [
                                    Wn[1],
                                    Wn[5],
                                    Wn[9],
                                    Wn[13]
                                ], Rl = [
                                    Wn[3],
                                    Wn[7],
                                    Wn[11],
                                    Wn[15]
                                ], Ul = Qe[0] * Ll[0] + Qe[1] * Ll[1] + Qe[2] * Ll[2], Gl = Qe[0] * Rl[0] + Qe[1] * Rl[1] + Qe[2] * Rl[2], Zl = rt[0] * Ll[0] + rt[1] * Ll[1] + rt[2] * Ll[2], Hl = rt[0] * Rl[0] + rt[1] * Rl[1] + rt[2] * Rl[2];
                                return Zl + Dl * Gl === Ul + Dl * Hl || Rl[3] * (Ul - Zl) + Ll[3] * (Hl - Gl) + Ul * Hl == Zl * Gl ? null : (Zl + Ll[3] - Dl * Hl - Dl * Rl[3]) / (Zl - Ul - Dl * Hl + Dl * Gl);
                            }
                            static getLesserNonNegativeNonNull(Qe, rt) {
                                return null !== rt && rt >= 0 && rt < Qe ? rt : Qe;
                            }
                        }
                        class pi {
                            constructor(Qe){
                                this._globe = Qe, this._mercatorCameraHelper = new kt, this._verticalPerspectiveCameraHelper = new _i;
                            }
                            get useGlobeControls() {
                                return this._globe.useGlobeRendering;
                            }
                            get currentHelper() {
                                return this.useGlobeControls ? this._verticalPerspectiveCameraHelper : this._mercatorCameraHelper;
                            }
                            handlePanInertia(Qe, rt) {
                                return this.currentHelper.handlePanInertia(Qe, rt);
                            }
                            handleMapControlsRollPitchBearingZoom(Qe, rt) {
                                return this.currentHelper.handleMapControlsRollPitchBearingZoom(Qe, rt);
                            }
                            handleMapControlsPan(Qe, rt, Wn) {
                                this.currentHelper.handleMapControlsPan(Qe, rt, Wn);
                            }
                            cameraForBoxAndBearing(Qe, rt, Wn, Co, Dl) {
                                return this.currentHelper.cameraForBoxAndBearing(Qe, rt, Wn, Co, Dl);
                            }
                            handleJumpToCenterZoom(Qe, rt) {
                                this.currentHelper.handleJumpToCenterZoom(Qe, rt);
                            }
                            handleEaseTo(Qe, rt) {
                                return this.currentHelper.handleEaseTo(Qe, rt);
                            }
                            handleFlyTo(Qe, rt) {
                                return this.currentHelper.handleFlyTo(Qe, rt);
                            }
                        }
                        const mi = (Qe, Wn)=>rt.x(Qe, Wn && Wn.filter((Qe)=>"source.canvas" !== Qe.identifier)), gd = rt.bu();
                        class gi extends rt.E {
                            constructor(Qe, Wn = {}){
                                super(), this._rtlPluginLoaded = ()=>{
                                    for(const Qe in this.sourceCaches){
                                        const rt = this.sourceCaches[Qe].getSource().type;
                                        "vector" !== rt && "geojson" !== rt || this.sourceCaches[Qe].reload();
                                    }
                                }, this.map = Qe, this.dispatcher = new B(F(), Qe._getMapId()), this.dispatcher.registerMessageHandler("GG", (Qe, rt)=>this.getGlyphs(Qe, rt)), this.dispatcher.registerMessageHandler("GI", (Qe, rt)=>this.getImages(Qe, rt)), this.imageManager = new b, this.imageManager.setEventedParent(this), this.glyphManager = new P(Qe._requestManager, Wn.localIdeographFontFamily), this.lineAtlas = new R(256, 512), this.crossTileSymbolIndex = new ht, this._spritesImagesIds = {}, this._layers = {}, this._order = [], this.sourceCaches = {}, this.zoomHistory = new rt.bv, this._loaded = !1, this._availableImages = [], this._resetUpdates(), this.dispatcher.broadcast("SR", rt.bw()), oe().on(yu, this._rtlPluginLoaded), this.on("data", (Qe)=>{
                                    if ("source" !== Qe.dataType || "metadata" !== Qe.sourceDataType) return;
                                    const rt = this.sourceCaches[Qe.sourceId];
                                    if (!rt) return;
                                    const Wn = rt.getSource();
                                    if (Wn && Wn.vectorLayerIds) for(const Co in this._layers){
                                        const Qe = this._layers[Co];
                                        Qe.source === Wn.id && this._validateLayer(Qe);
                                    }
                                });
                            }
                            loadURL(Qe, Wn = {}, Co) {
                                this.fire(new rt.l("dataloading", {
                                    dataType: "style"
                                })), Wn.validate = "boolean" != typeof Wn.validate || Wn.validate;
                                const Dl = this.map._requestManager.transformRequest(Qe, "Style");
                                this._loadStyleRequest = new AbortController;
                                const Ll = this._loadStyleRequest;
                                rt.j(Dl, this._loadStyleRequest).then((Qe)=>{
                                    this._loadStyleRequest = null, this._load(Qe.data, Wn, Co);
                                }).catch((Qe)=>{
                                    this._loadStyleRequest = null, Qe && !Ll.signal.aborted && this.fire(new rt.k(Qe));
                                });
                            }
                            loadJSON(Qe, Wn = {}, Co) {
                                this.fire(new rt.l("dataloading", {
                                    dataType: "style"
                                })), this._frameRequest = new AbortController, Ll.frameAsync(this._frameRequest).then(()=>{
                                    this._frameRequest = null, Wn.validate = !1 !== Wn.validate, this._load(Qe, Wn, Co);
                                }).catch(()=>{});
                            }
                            loadEmpty() {
                                this.fire(new rt.l("dataloading", {
                                    dataType: "style"
                                })), this._load(gd, {
                                    validate: !1
                                });
                            }
                            _load(Qe, Wn, Co) {
                                var Dl, Ll;
                                const Rl = Wn.transformStyle ? Wn.transformStyle(Co, Qe) : Qe;
                                if (!Wn.validate || !mi(this, rt.y(Rl))) {
                                    this._loaded = !0, this.stylesheet = Rl;
                                    for(const Qe in Rl.sources)this.addSource(Qe, Rl.sources[Qe], {
                                        validate: !1
                                    });
                                    Rl.sprite ? this._loadSprite(Rl.sprite) : this.imageManager.setLoaded(!0), this.glyphManager.setURL(Rl.glyphs), this._createLayers(), this.light = new M(this.stylesheet.light), this._setProjectionInternal((null === (Dl = this.stylesheet.projection) || void 0 === Dl ? void 0 : Dl.type) || "mercator"), this.sky = new S(this.stylesheet.sky), this.map.setTerrain(null !== (Ll = this.stylesheet.terrain) && void 0 !== Ll ? Ll : null), this.fire(new rt.l("data", {
                                        dataType: "style"
                                    })), this.fire(new rt.l("style.load"));
                                }
                            }
                            _createLayers() {
                                const Qe = rt.bx(this.stylesheet.layers);
                                this.dispatcher.broadcast("SL", Qe), this._order = Qe.map((Qe)=>Qe.id), this._layers = {}, this._serializedLayers = null;
                                for (const Wn of Qe){
                                    const Qe = rt.by(Wn);
                                    Qe.setEventedParent(this, {
                                        layer: {
                                            id: Wn.id
                                        }
                                    }), this._layers[Wn.id] = Qe;
                                }
                            }
                            _loadSprite(Qe, Wn = !1, Co) {
                                let Dl;
                                this.imageManager.setLoaded(!1), this._spriteRequest = new AbortController, (function(Qe, Wn, Co, Dl) {
                                    return rt._(this, void 0, void 0, function*() {
                                        const Rl = f(Qe), Ul = Co > 1 ? "@2x" : "", Gl = {}, Zl = {};
                                        for (const { id: Qe, url: Co } of Rl){
                                            const Ll = Wn.transformRequest(g(Co, Ul, ".json"), "SpriteJSON");
                                            Gl[Qe] = rt.j(Ll, Dl);
                                            const Rl = Wn.transformRequest(g(Co, Ul, ".png"), "SpriteImage");
                                            Zl[Qe] = ql.getImage(Rl, Dl);
                                        }
                                        return yield Promise.all([
                                            ...Object.values(Gl),
                                            ...Object.values(Zl)
                                        ]), function(Qe, Wn) {
                                            return rt._(this, void 0, void 0, function*() {
                                                const rt = {};
                                                for(const Co in Qe){
                                                    rt[Co] = {};
                                                    const Dl = Ll.getImageCanvasContext((yield Wn[Co]).data), Rl = (yield Qe[Co]).data;
                                                    for(const Qe in Rl){
                                                        const { width: Wn, height: Ll, x: Ul, y: Gl, sdf: Zl, pixelRatio: Hl, stretchX: ql, stretchY: Ql, content: Kl, textFitWidth: $l, textFitHeight: Tc } = Rl[Qe];
                                                        rt[Co][Qe] = {
                                                            data: null,
                                                            pixelRatio: Hl,
                                                            sdf: Zl,
                                                            stretchX: ql,
                                                            stretchY: Ql,
                                                            content: Kl,
                                                            textFitWidth: $l,
                                                            textFitHeight: Tc,
                                                            spriteData: {
                                                                width: Wn,
                                                                height: Ll,
                                                                x: Ul,
                                                                y: Gl,
                                                                context: Dl
                                                            }
                                                        };
                                                    }
                                                }
                                                return rt;
                                            });
                                        }(Gl, Zl);
                                    });
                                })(Qe, this.map._requestManager, this.map.getPixelRatio(), this._spriteRequest).then((Qe)=>{
                                    if (this._spriteRequest = null, Qe) for(const rt in Qe){
                                        this._spritesImagesIds[rt] = [];
                                        const Co = this._spritesImagesIds[rt] ? this._spritesImagesIds[rt].filter((rt)=>!(rt in Qe)) : [];
                                        for (const Qe of Co)this.imageManager.removeImage(Qe), this._changedImages[Qe] = !0;
                                        for(const Dl in Qe[rt]){
                                            const Co = "default" === rt ? Dl : `${rt}:${Dl}`;
                                            this._spritesImagesIds[rt].push(Co), Co in this.imageManager.images ? this.imageManager.updateImage(Co, Qe[rt][Dl], !1) : this.imageManager.addImage(Co, Qe[rt][Dl]), Wn && (this._changedImages[Co] = !0);
                                        }
                                    }
                                }).catch((Qe)=>{
                                    this._spriteRequest = null, Dl = Qe, this.fire(new rt.k(Dl));
                                }).finally(()=>{
                                    this.imageManager.setLoaded(!0), this._availableImages = this.imageManager.listImages(), Wn && (this._changed = !0), this.dispatcher.broadcast("SI", this._availableImages), this.fire(new rt.l("data", {
                                        dataType: "style"
                                    })), Co && Co(Dl);
                                });
                            }
                            _unloadSprite() {
                                for (const Qe of Object.values(this._spritesImagesIds).flat())this.imageManager.removeImage(Qe), this._changedImages[Qe] = !0;
                                this._spritesImagesIds = {}, this._availableImages = this.imageManager.listImages(), this._changed = !0, this.dispatcher.broadcast("SI", this._availableImages), this.fire(new rt.l("data", {
                                    dataType: "style"
                                }));
                            }
                            _validateLayer(Qe) {
                                const Wn = this.sourceCaches[Qe.source];
                                if (!Wn) return;
                                const Co = Qe.sourceLayer;
                                if (!Co) return;
                                const Dl = Wn.getSource();
                                ("geojson" === Dl.type || Dl.vectorLayerIds && -1 === Dl.vectorLayerIds.indexOf(Co)) && this.fire(new rt.k(new Error(`Source layer "${Co}" does not exist on source "${Dl.id}" as specified by style layer "${Qe.id}".`)));
                            }
                            loaded() {
                                if (!this._loaded) return !1;
                                if (Object.keys(this._updatedSources).length) return !1;
                                for(const Qe in this.sourceCaches)if (!this.sourceCaches[Qe].loaded()) return !1;
                                return !!this.imageManager.isLoaded();
                            }
                            _serializeByIds(Qe, Wn = !1) {
                                const Co = this._serializedAllLayers();
                                if (!Qe || 0 === Qe.length) return Object.values(Wn ? rt.bz(Co) : Co);
                                const Dl = [];
                                for (const Ll of Qe)if (Co[Ll]) {
                                    const Qe = Wn ? rt.bz(Co[Ll]) : Co[Ll];
                                    Dl.push(Qe);
                                }
                                return Dl;
                            }
                            _serializedAllLayers() {
                                let Qe = this._serializedLayers;
                                if (Qe) return Qe;
                                Qe = this._serializedLayers = {};
                                const rt = Object.keys(this._layers);
                                for (const Wn of rt){
                                    const rt = this._layers[Wn];
                                    "custom" !== rt.type && (Qe[Wn] = rt.serialize());
                                }
                                return Qe;
                            }
                            hasTransitions() {
                                var Qe, rt, Wn;
                                if (null === (Qe = this.light) || void 0 === Qe ? void 0 : Qe.hasTransition()) return !0;
                                if (null === (rt = this.sky) || void 0 === rt ? void 0 : rt.hasTransition()) return !0;
                                if (null === (Wn = this.projection) || void 0 === Wn ? void 0 : Wn.hasTransition()) return !0;
                                for(const Co in this.sourceCaches)if (this.sourceCaches[Co].hasTransition()) return !0;
                                for(const Co in this._layers)if (this._layers[Co].hasTransition()) return !0;
                                return !1;
                            }
                            _checkLoaded() {
                                if (!this._loaded) throw new Error("Style is not done loading.");
                            }
                            update(Qe) {
                                if (!this._loaded) return;
                                const Wn = this._changed;
                                if (Wn) {
                                    const rt = Object.keys(this._updatedLayers), Wn = Object.keys(this._removedLayers);
                                    (rt.length || Wn.length) && this._updateWorkerLayers(rt, Wn);
                                    for(const Qe in this._updatedSources){
                                        const rt = this._updatedSources[Qe];
                                        if ("reload" === rt) this._reloadSource(Qe);
                                        else {
                                            if ("clear" !== rt) throw new Error(`Invalid action ${rt}`);
                                            this._clearSource(Qe);
                                        }
                                    }
                                    this._updateTilesForChangedImages(), this._updateTilesForChangedGlyphs();
                                    for(const Co in this._updatedPaintProps)this._layers[Co].updateTransitions(Qe);
                                    this.light.updateTransitions(Qe), this.sky.updateTransitions(Qe), this._resetUpdates();
                                }
                                const Co = {};
                                for(const rt in this.sourceCaches){
                                    const Qe = this.sourceCaches[rt];
                                    Co[rt] = Qe.used, Qe.used = !1;
                                }
                                for (const rt of this._order){
                                    const Wn = this._layers[rt];
                                    Wn.recalculate(Qe, this._availableImages), !Wn.isHidden(Qe.zoom) && Wn.source && (this.sourceCaches[Wn.source].used = !0);
                                }
                                for(const Dl in Co){
                                    const Qe = this.sourceCaches[Dl];
                                    !!Co[Dl] != !!Qe.used && Qe.fire(new rt.l("data", {
                                        sourceDataType: "visibility",
                                        dataType: "source",
                                        sourceId: Dl
                                    }));
                                }
                                this.light.recalculate(Qe), this.sky.recalculate(Qe), this.projection.recalculate(Qe), this.z = Qe.zoom, Wn && this.fire(new rt.l("data", {
                                    dataType: "style"
                                }));
                            }
                            _updateTilesForChangedImages() {
                                const Qe = Object.keys(this._changedImages);
                                if (Qe.length) {
                                    for(const rt in this.sourceCaches)this.sourceCaches[rt].reloadTilesForDependencies([
                                        "icons",
                                        "patterns"
                                    ], Qe);
                                    this._changedImages = {};
                                }
                            }
                            _updateTilesForChangedGlyphs() {
                                if (this._glyphsDidChange) {
                                    for(const Qe in this.sourceCaches)this.sourceCaches[Qe].reloadTilesForDependencies([
                                        "glyphs"
                                    ], [
                                        ""
                                    ]);
                                    this._glyphsDidChange = !1;
                                }
                            }
                            _updateWorkerLayers(Qe, rt) {
                                this.dispatcher.broadcast("UL", {
                                    layers: this._serializeByIds(Qe, !1),
                                    removedIds: rt
                                });
                            }
                            _resetUpdates() {
                                this._changed = !1, this._updatedLayers = {}, this._removedLayers = {}, this._updatedSources = {}, this._updatedPaintProps = {}, this._changedImages = {}, this._glyphsDidChange = !1;
                            }
                            setState(Qe, Wn = {}) {
                                var Co;
                                this._checkLoaded();
                                const Dl = this.serialize();
                                if (Qe = Wn.transformStyle ? Wn.transformStyle(Dl, Qe) : Qe, (null === (Co = Wn.validate) || void 0 === Co || Co) && mi(this, rt.y(Qe))) return !1;
                                (Qe = rt.bz(Qe)).layers = rt.bx(Qe.layers);
                                const Ll = rt.bA(Dl, Qe), Rl = this._getOperationsToPerform(Ll);
                                if (Rl.unimplemented.length > 0) throw new Error(`Unimplemented: ${Rl.unimplemented.join(", ")}.`);
                                if (0 === Rl.operations.length) return !1;
                                for (const rt of Rl.operations)rt();
                                return this.stylesheet = Qe, this._serializedLayers = null, !0;
                            }
                            _getOperationsToPerform(Qe) {
                                const rt = [], Wn = [];
                                for (const Co of Qe)switch(Co.command){
                                    case "setCenter":
                                    case "setZoom":
                                    case "setBearing":
                                    case "setPitch":
                                    case "setRoll":
                                        continue;
                                    case "addLayer":
                                        rt.push(()=>this.addLayer.apply(this, Co.args));
                                        break;
                                    case "removeLayer":
                                        rt.push(()=>this.removeLayer.apply(this, Co.args));
                                        break;
                                    case "setPaintProperty":
                                        rt.push(()=>this.setPaintProperty.apply(this, Co.args));
                                        break;
                                    case "setLayoutProperty":
                                        rt.push(()=>this.setLayoutProperty.apply(this, Co.args));
                                        break;
                                    case "setFilter":
                                        rt.push(()=>this.setFilter.apply(this, Co.args));
                                        break;
                                    case "addSource":
                                        rt.push(()=>this.addSource.apply(this, Co.args));
                                        break;
                                    case "removeSource":
                                        rt.push(()=>this.removeSource.apply(this, Co.args));
                                        break;
                                    case "setLayerZoomRange":
                                        rt.push(()=>this.setLayerZoomRange.apply(this, Co.args));
                                        break;
                                    case "setLight":
                                        rt.push(()=>this.setLight.apply(this, Co.args));
                                        break;
                                    case "setGeoJSONSourceData":
                                        rt.push(()=>this.setGeoJSONSourceData.apply(this, Co.args));
                                        break;
                                    case "setGlyphs":
                                        rt.push(()=>this.setGlyphs.apply(this, Co.args));
                                        break;
                                    case "setSprite":
                                        rt.push(()=>this.setSprite.apply(this, Co.args));
                                        break;
                                    case "setTerrain":
                                        rt.push(()=>this.map.setTerrain.apply(this, Co.args));
                                        break;
                                    case "setSky":
                                        rt.push(()=>this.setSky.apply(this, Co.args));
                                        break;
                                    case "setProjection":
                                        this.setProjection.apply(this, Co.args);
                                        break;
                                    case "setTransition":
                                        rt.push(()=>{});
                                        break;
                                    default:
                                        Wn.push(Co.command);
                                }
                                return {
                                    operations: rt,
                                    unimplemented: Wn
                                };
                            }
                            addImage(Qe, Wn) {
                                if (this.getImage(Qe)) return this.fire(new rt.k(new Error(`An image named "${Qe}" already exists.`)));
                                this.imageManager.addImage(Qe, Wn), this._afterImageUpdated(Qe);
                            }
                            updateImage(Qe, rt) {
                                this.imageManager.updateImage(Qe, rt);
                            }
                            getImage(Qe) {
                                return this.imageManager.getImage(Qe);
                            }
                            removeImage(Qe) {
                                if (!this.getImage(Qe)) return this.fire(new rt.k(new Error(`An image named "${Qe}" does not exist.`)));
                                this.imageManager.removeImage(Qe), this._afterImageUpdated(Qe);
                            }
                            _afterImageUpdated(Qe) {
                                this._availableImages = this.imageManager.listImages(), this._changedImages[Qe] = !0, this._changed = !0, this.dispatcher.broadcast("SI", this._availableImages), this.fire(new rt.l("data", {
                                    dataType: "style"
                                }));
                            }
                            listImages() {
                                return this._checkLoaded(), this.imageManager.listImages();
                            }
                            addSource(Qe, Wn, Co = {}) {
                                if (this._checkLoaded(), void 0 !== this.sourceCaches[Qe]) throw new Error(`Source "${Qe}" already exists.`);
                                if (!Wn.type) throw new Error(`The type property must be defined, but only the following properties were given: ${Object.keys(Wn).join(", ")}.`);
                                if ([
                                    "vector",
                                    "raster",
                                    "geojson",
                                    "video",
                                    "image"
                                ].indexOf(Wn.type) >= 0 && this._validate(rt.y.source, `sources.${Qe}`, Wn, null, Co)) return;
                                this.map && this.map._collectResourceTiming && (Wn.collectResourceTiming = !0);
                                const Dl = this.sourceCaches[Qe] = new de(Qe, Wn, this.dispatcher);
                                Dl.style = this, Dl.setEventedParent(this, ()=>({
                                        isSourceLoaded: Dl.loaded(),
                                        source: Dl.serialize(),
                                        sourceId: Qe
                                    })), Dl.onAdd(this.map), this._changed = !0;
                            }
                            removeSource(Qe) {
                                if (this._checkLoaded(), void 0 === this.sourceCaches[Qe]) throw new Error("There is no source with this ID");
                                for(const Co in this._layers)if (this._layers[Co].source === Qe) return this.fire(new rt.k(new Error(`Source "${Qe}" cannot be removed while layer "${Co}" is using it.`)));
                                const Wn = this.sourceCaches[Qe];
                                delete this.sourceCaches[Qe], delete this._updatedSources[Qe], Wn.fire(new rt.l("data", {
                                    sourceDataType: "metadata",
                                    dataType: "source",
                                    sourceId: Qe
                                })), Wn.setEventedParent(null), Wn.onRemove(this.map), this._changed = !0;
                            }
                            setGeoJSONSourceData(Qe, rt) {
                                if (this._checkLoaded(), void 0 === this.sourceCaches[Qe]) throw new Error(`There is no source with this ID=${Qe}`);
                                const Wn = this.sourceCaches[Qe].getSource();
                                if ("geojson" !== Wn.type) throw new Error(`geojsonSource.type is ${Wn.type}, which is !== 'geojson`);
                                Wn.setData(rt), this._changed = !0;
                            }
                            getSource(Qe) {
                                return this.sourceCaches[Qe] && this.sourceCaches[Qe].getSource();
                            }
                            addLayer(Qe, Wn, Co = {}) {
                                this._checkLoaded();
                                const Dl = Qe.id;
                                if (this.getLayer(Dl)) return void this.fire(new rt.k(new Error(`Layer "${Dl}" already exists on this map.`)));
                                let Ll;
                                if ("custom" === Qe.type) {
                                    if (mi(this, rt.bB(Qe))) return;
                                    Ll = rt.by(Qe);
                                } else {
                                    if ("source" in Qe && "object" == typeof Qe.source && (this.addSource(Dl, Qe.source), Qe = rt.bz(Qe), Qe = rt.e(Qe, {
                                        source: Dl
                                    })), this._validate(rt.y.layer, `layers.${Dl}`, Qe, {
                                        arrayIndex: -1
                                    }, Co)) return;
                                    Ll = rt.by(Qe), this._validateLayer(Ll), Ll.setEventedParent(this, {
                                        layer: {
                                            id: Dl
                                        }
                                    });
                                }
                                const Rl = Wn ? this._order.indexOf(Wn) : this._order.length;
                                if (Wn && -1 === Rl) this.fire(new rt.k(new Error(`Cannot add layer "${Dl}" before non-existing layer "${Wn}".`)));
                                else {
                                    if (this._order.splice(Rl, 0, Dl), this._layerOrderChanged = !0, this._layers[Dl] = Ll, this._removedLayers[Dl] && Ll.source && "custom" !== Ll.type) {
                                        const Qe = this._removedLayers[Dl];
                                        delete this._removedLayers[Dl], Qe.type !== Ll.type ? this._updatedSources[Ll.source] = "clear" : (this._updatedSources[Ll.source] = "reload", this.sourceCaches[Ll.source].pause());
                                    }
                                    this._updateLayer(Ll), Ll.onAdd && Ll.onAdd(this.map);
                                }
                            }
                            moveLayer(Qe, Wn) {
                                if (this._checkLoaded(), this._changed = !0, !this._layers[Qe]) return void this.fire(new rt.k(new Error(`The layer '${Qe}' does not exist in the map's style and cannot be moved.`)));
                                if (Qe === Wn) return;
                                const Co = this._order.indexOf(Qe);
                                this._order.splice(Co, 1);
                                const Dl = Wn ? this._order.indexOf(Wn) : this._order.length;
                                Wn && -1 === Dl ? this.fire(new rt.k(new Error(`Cannot move layer "${Qe}" before non-existing layer "${Wn}".`))) : (this._order.splice(Dl, 0, Qe), this._layerOrderChanged = !0);
                            }
                            removeLayer(Qe) {
                                this._checkLoaded();
                                const Wn = this._layers[Qe];
                                if (!Wn) return void this.fire(new rt.k(new Error(`Cannot remove non-existing layer "${Qe}".`)));
                                Wn.setEventedParent(null);
                                const Co = this._order.indexOf(Qe);
                                this._order.splice(Co, 1), this._layerOrderChanged = !0, this._changed = !0, this._removedLayers[Qe] = Wn, delete this._layers[Qe], this._serializedLayers && delete this._serializedLayers[Qe], delete this._updatedLayers[Qe], delete this._updatedPaintProps[Qe], Wn.onRemove && Wn.onRemove(this.map);
                            }
                            getLayer(Qe) {
                                return this._layers[Qe];
                            }
                            getLayersOrder() {
                                return [
                                    ...this._order
                                ];
                            }
                            hasLayer(Qe) {
                                return Qe in this._layers;
                            }
                            setLayerZoomRange(Qe, Wn, Co) {
                                this._checkLoaded();
                                const Dl = this.getLayer(Qe);
                                Dl ? Dl.minzoom === Wn && Dl.maxzoom === Co || (null != Wn && (Dl.minzoom = Wn), null != Co && (Dl.maxzoom = Co), this._updateLayer(Dl)) : this.fire(new rt.k(new Error(`Cannot set the zoom range of non-existing layer "${Qe}".`)));
                            }
                            setFilter(Qe, Wn, Co = {}) {
                                this._checkLoaded();
                                const Dl = this.getLayer(Qe);
                                if (Dl) {
                                    if (!rt.bC(Dl.filter, Wn)) return null == Wn ? (Dl.filter = void 0, void this._updateLayer(Dl)) : void (this._validate(rt.y.filter, `layers.${Dl.id}.filter`, Wn, null, Co) || (Dl.filter = rt.bz(Wn), this._updateLayer(Dl)));
                                } else this.fire(new rt.k(new Error(`Cannot filter non-existing layer "${Qe}".`)));
                            }
                            getFilter(Qe) {
                                return rt.bz(this.getLayer(Qe).filter);
                            }
                            setLayoutProperty(Qe, Wn, Co, Dl = {}) {
                                this._checkLoaded();
                                const Ll = this.getLayer(Qe);
                                Ll ? rt.bC(Ll.getLayoutProperty(Wn), Co) || (Ll.setLayoutProperty(Wn, Co, Dl), this._updateLayer(Ll)) : this.fire(new rt.k(new Error(`Cannot style non-existing layer "${Qe}".`)));
                            }
                            getLayoutProperty(Qe, Wn) {
                                const Co = this.getLayer(Qe);
                                if (Co) return Co.getLayoutProperty(Wn);
                                this.fire(new rt.k(new Error(`Cannot get style of non-existing layer "${Qe}".`)));
                            }
                            setPaintProperty(Qe, Wn, Co, Dl = {}) {
                                this._checkLoaded();
                                const Ll = this.getLayer(Qe);
                                Ll ? rt.bC(Ll.getPaintProperty(Wn), Co) || (Ll.setPaintProperty(Wn, Co, Dl) && this._updateLayer(Ll), this._changed = !0, this._updatedPaintProps[Qe] = !0, this._serializedLayers = null) : this.fire(new rt.k(new Error(`Cannot style non-existing layer "${Qe}".`)));
                            }
                            getPaintProperty(Qe, rt) {
                                return this.getLayer(Qe).getPaintProperty(rt);
                            }
                            setFeatureState(Qe, Wn) {
                                this._checkLoaded();
                                const Co = Qe.source, Dl = Qe.sourceLayer, Ll = this.sourceCaches[Co];
                                if (void 0 === Ll) return void this.fire(new rt.k(new Error(`The source '${Co}' does not exist in the map's style.`)));
                                const Rl = Ll.getSource().type;
                                "geojson" === Rl && Dl ? this.fire(new rt.k(new Error("GeoJSON sources cannot have a sourceLayer parameter."))) : "vector" !== Rl || Dl ? (void 0 === Qe.id && this.fire(new rt.k(new Error("The feature id parameter must be provided."))), Ll.setFeatureState(Dl, Qe.id, Wn)) : this.fire(new rt.k(new Error("The sourceLayer parameter must be provided for vector source types.")));
                            }
                            removeFeatureState(Qe, Wn) {
                                this._checkLoaded();
                                const Co = Qe.source, Dl = this.sourceCaches[Co];
                                if (void 0 === Dl) return void this.fire(new rt.k(new Error(`The source '${Co}' does not exist in the map's style.`)));
                                const Ll = Dl.getSource().type, Rl = "vector" === Ll ? Qe.sourceLayer : void 0;
                                "vector" !== Ll || Rl ? Wn && "string" != typeof Qe.id && "number" != typeof Qe.id ? this.fire(new rt.k(new Error("A feature id is required to remove its specific state property."))) : Dl.removeFeatureState(Rl, Qe.id, Wn) : this.fire(new rt.k(new Error("The sourceLayer parameter must be provided for vector source types.")));
                            }
                            getFeatureState(Qe) {
                                this._checkLoaded();
                                const Wn = Qe.source, Co = Qe.sourceLayer, Dl = this.sourceCaches[Wn];
                                if (void 0 !== Dl) return "vector" !== Dl.getSource().type || Co ? (void 0 === Qe.id && this.fire(new rt.k(new Error("The feature id parameter must be provided."))), Dl.getFeatureState(Co, Qe.id)) : void this.fire(new rt.k(new Error("The sourceLayer parameter must be provided for vector source types.")));
                                this.fire(new rt.k(new Error(`The source '${Wn}' does not exist in the map's style.`)));
                            }
                            getTransition() {
                                return rt.e({
                                    duration: 300,
                                    delay: 0
                                }, this.stylesheet && this.stylesheet.transition);
                            }
                            serialize() {
                                if (!this._loaded) return;
                                const Qe = rt.bD(this.sourceCaches, (Qe)=>Qe.serialize()), Wn = this._serializeByIds(this._order, !0), Co = this.map.getTerrain() || void 0, Dl = this.stylesheet;
                                return rt.bE({
                                    version: Dl.version,
                                    name: Dl.name,
                                    metadata: Dl.metadata,
                                    light: Dl.light,
                                    sky: Dl.sky,
                                    center: Dl.center,
                                    zoom: Dl.zoom,
                                    bearing: Dl.bearing,
                                    pitch: Dl.pitch,
                                    sprite: Dl.sprite,
                                    glyphs: Dl.glyphs,
                                    transition: Dl.transition,
                                    projection: Dl.projection,
                                    sources: Qe,
                                    layers: Wn,
                                    terrain: Co
                                }, (Qe)=>void 0 !== Qe);
                            }
                            _updateLayer(Qe) {
                                this._updatedLayers[Qe.id] = !0, Qe.source && !this._updatedSources[Qe.source] && "raster" !== this.sourceCaches[Qe.source].getSource().type && (this._updatedSources[Qe.source] = "reload", this.sourceCaches[Qe.source].pause()), this._serializedLayers = null, this._changed = !0;
                            }
                            _flattenAndSortRenderedFeatures(Qe) {
                                const t = (Qe)=>"fill-extrusion" === this._layers[Qe].type, rt = {}, Wn = [];
                                for(let Dl = this._order.length - 1; Dl >= 0; Dl--){
                                    const Co = this._order[Dl];
                                    if (t(Co)) {
                                        rt[Co] = Dl;
                                        for (const rt of Qe){
                                            const Qe = rt[Co];
                                            if (Qe) for (const rt of Qe)Wn.push(rt);
                                        }
                                    }
                                }
                                Wn.sort((Qe, rt)=>rt.intersectionZ - Qe.intersectionZ);
                                const Co = [];
                                for(let Dl = this._order.length - 1; Dl >= 0; Dl--){
                                    const Ll = this._order[Dl];
                                    if (t(Ll)) for(let Qe = Wn.length - 1; Qe >= 0; Qe--){
                                        const Ll = Wn[Qe].feature;
                                        if (rt[Ll.layer.id] < Dl) break;
                                        Co.push(Ll), Wn.pop();
                                    }
                                    else for (const rt of Qe){
                                        const Qe = rt[Ll];
                                        if (Qe) for (const rt of Qe)Co.push(rt.feature);
                                    }
                                }
                                return Co;
                            }
                            queryRenderedFeatures(Qe, Wn, Co) {
                                Wn && Wn.filter && this._validate(rt.y.filter, "queryRenderedFeatures.filter", Wn.filter, null, Wn);
                                const Dl = {};
                                if (Wn && Wn.layers) {
                                    if (!(Array.isArray(Wn.layers) || Wn.layers instanceof Set)) return this.fire(new rt.k(new Error("parameters.layers must be an Array or a Set of strings"))), [];
                                    for (const Qe of Wn.layers){
                                        const Wn = this._layers[Qe];
                                        if (!Wn) return this.fire(new rt.k(new Error(`The layer '${Qe}' does not exist in the map's style and cannot be queried for features.`))), [];
                                        Dl[Wn.source] = !0;
                                    }
                                }
                                const Ll = [];
                                Wn.availableImages = this._availableImages;
                                const Rl = this._serializedAllLayers(), Ul = Wn.layers instanceof Set ? Wn.layers : Array.isArray(Wn.layers) ? new Set(Wn.layers) : null, Gl = Object.assign(Object.assign({}, Wn), {
                                    layers: Ul
                                });
                                for(const rt in this.sourceCaches)Wn.layers && !Dl[rt] || Ll.push(Z(this.sourceCaches[rt], this._layers, Rl, Qe, Gl, Co, this.map.terrain ? (Qe, rt, Wn)=>this.map.terrain.getElevation(Qe, rt, Wn) : void 0));
                                return this.placement && Ll.push(function(Qe, rt, Wn, Co, Dl, Ll, Rl) {
                                    const Ul = {}, Gl = Ll.queryRenderedSymbols(Co), Zl = [];
                                    for (const Hl of Object.keys(Gl).map(Number))Zl.push(Rl[Hl]);
                                    Zl.sort(N);
                                    for (const Hl of Zl){
                                        const Wn = Hl.featureIndex.lookupSymbolFeatures(Gl[Hl.bucketInstanceId], rt, Hl.bucketIndex, Hl.sourceLayerIndex, Dl.filter, Dl.layers, Dl.availableImages, Qe);
                                        for(const Qe in Wn){
                                            const rt = Ul[Qe] = Ul[Qe] || [], Co = Wn[Qe];
                                            Co.sort((Qe, rt)=>{
                                                const Wn = Hl.featureSortOrder;
                                                if (Wn) {
                                                    const Co = Wn.indexOf(Qe.featureIndex);
                                                    return Wn.indexOf(rt.featureIndex) - Co;
                                                }
                                                return rt.featureIndex - Qe.featureIndex;
                                            });
                                            for (const Qe of Co)rt.push(Qe);
                                        }
                                    }
                                    return function(Qe, rt, Wn) {
                                        for(const Co in Qe)for (const Dl of Qe[Co])G(Dl, Wn[rt[Co].source]);
                                        return Qe;
                                    }(Ul, Qe, Wn);
                                }(this._layers, Rl, this.sourceCaches, Qe, Gl, this.placement.collisionIndex, this.placement.retainedQueryData)), this._flattenAndSortRenderedFeatures(Ll);
                            }
                            querySourceFeatures(Qe, Wn) {
                                Wn && Wn.filter && this._validate(rt.y.filter, "querySourceFeatures.filter", Wn.filter, null, Wn);
                                const Co = this.sourceCaches[Qe];
                                return Co ? function(Qe, rt) {
                                    const Wn = Qe.getRenderableIds().map((rt)=>Qe.getTileByID(rt)), Co = [], Dl = {};
                                    for(let Ll = 0; Ll < Wn.length; Ll++){
                                        const Qe = Wn[Ll], Rl = Qe.tileID.canonical.key;
                                        Dl[Rl] || (Dl[Rl] = !0, Qe.querySourceFeatures(Co, rt));
                                    }
                                    return Co;
                                }(Co, Wn) : [];
                            }
                            getLight() {
                                return this.light.getLight();
                            }
                            setLight(Qe, Wn = {}) {
                                this._checkLoaded();
                                const Co = this.light.getLight();
                                let Dl = !1;
                                for(const Ll in Qe)if (!rt.bC(Qe[Ll], Co[Ll])) {
                                    Dl = !0;
                                    break;
                                }
                                if (!Dl) return;
                                const Rl = {
                                    now: Ll.now(),
                                    transition: rt.e({
                                        duration: 300,
                                        delay: 0
                                    }, this.stylesheet.transition)
                                };
                                this.light.setLight(Qe, Wn), this.light.updateTransitions(Rl);
                            }
                            getProjection() {
                                var Qe;
                                return null === (Qe = this.stylesheet) || void 0 === Qe ? void 0 : Qe.projection;
                            }
                            setProjection(Qe) {
                                if (this._checkLoaded(), this.projection) {
                                    if (this.projection.name === Qe.type) return;
                                    this.projection.destroy(), delete this.projection;
                                }
                                this.stylesheet.projection = Qe, this._setProjectionInternal(Qe.type);
                            }
                            getSky() {
                                var Qe;
                                return null === (Qe = this.stylesheet) || void 0 === Qe ? void 0 : Qe.sky;
                            }
                            setSky(Qe, Wn = {}) {
                                this._checkLoaded();
                                const Co = this.getSky();
                                let Dl = !1;
                                if (!Qe && !Co) return;
                                if (Qe && !Co) Dl = !0;
                                else if (!Qe && Co) Dl = !0;
                                else for(const Ll in Qe)if (!rt.bC(Qe[Ll], Co[Ll])) {
                                    Dl = !0;
                                    break;
                                }
                                if (!Dl) return;
                                const Rl = {
                                    now: Ll.now(),
                                    transition: rt.e({
                                        duration: 300,
                                        delay: 0
                                    }, this.stylesheet.transition)
                                };
                                this.stylesheet.sky = Qe, this.sky.setSky(Qe, Wn), this.sky.updateTransitions(Rl);
                            }
                            _setProjectionInternal(Qe) {
                                const Wn = function(Qe) {
                                    if (Array.isArray(Qe)) {
                                        const rt = new Xt({
                                            type: Qe
                                        });
                                        return {
                                            projection: rt,
                                            transform: new di,
                                            cameraHelper: new pi(rt)
                                        };
                                    }
                                    switch(Qe){
                                        case "mercator":
                                            return {
                                                projection: new vt,
                                                transform: new Dt,
                                                cameraHelper: new kt
                                            };
                                        case "globe":
                                            {
                                                const Qe = new Xt({
                                                    type: [
                                                        "interpolate",
                                                        [
                                                            "linear"
                                                        ],
                                                        [
                                                            "zoom"
                                                        ],
                                                        11,
                                                        "vertical-perspective",
                                                        12,
                                                        "mercator"
                                                    ]
                                                });
                                                return {
                                                    projection: Qe,
                                                    transform: new di,
                                                    cameraHelper: new pi(Qe)
                                                };
                                            }
                                        case "vertical-perspective":
                                            return {
                                                projection: new Ht,
                                                transform: new ui,
                                                cameraHelper: new _i
                                            };
                                        default:
                                            return rt.w(`Unknown projection name: ${Qe}. Falling back to mercator projection.`), {
                                                projection: new vt,
                                                transform: new Dt,
                                                cameraHelper: new kt
                                            };
                                    }
                                }(Qe);
                                this.projection = Wn.projection, this.map.migrateProjection(Wn.transform, Wn.cameraHelper);
                                for(const rt in this.sourceCaches)this.sourceCaches[rt].reload();
                            }
                            _validate(Qe, Wn, Co, Dl, Ll = {}) {
                                return (!Ll || !1 !== Ll.validate) && mi(this, Qe.call(rt.y, rt.e({
                                    key: Wn,
                                    style: this.serialize(),
                                    value: Co,
                                    styleSpec: rt.v
                                }, Dl)));
                            }
                            _remove(Qe = !0) {
                                this._frameRequest && (this._frameRequest.abort(), this._frameRequest = null), this._loadStyleRequest && (this._loadStyleRequest.abort(), this._loadStyleRequest = null), this._spriteRequest && (this._spriteRequest.abort(), this._spriteRequest = null), oe().off(yu, this._rtlPluginLoaded);
                                for(const rt in this._layers)this._layers[rt].setEventedParent(null);
                                for(const rt in this.sourceCaches){
                                    const Qe = this.sourceCaches[rt];
                                    Qe.setEventedParent(null), Qe.onRemove(this.map);
                                }
                                this.imageManager.setEventedParent(null), this.setEventedParent(null), Qe && this.dispatcher.broadcast("RM", void 0), this.dispatcher.remove(Qe);
                            }
                            _clearSource(Qe) {
                                this.sourceCaches[Qe].clearTiles();
                            }
                            _reloadSource(Qe) {
                                this.sourceCaches[Qe].resume(), this.sourceCaches[Qe].reload();
                            }
                            _updateSources(Qe) {
                                for(const rt in this.sourceCaches)this.sourceCaches[rt].update(Qe, this.map.terrain);
                            }
                            _generateCollisionBoxes() {
                                for(const Qe in this.sourceCaches)this._reloadSource(Qe);
                            }
                            _updatePlacement(Qe, rt, Wn, Co, Dl = !1) {
                                let Rl = !1, Ul = !1;
                                const Gl = {};
                                for (const Ll of this._order){
                                    const rt = this._layers[Ll];
                                    if ("symbol" !== rt.type) continue;
                                    if (!Gl[rt.source]) {
                                        const Qe = this.sourceCaches[rt.source];
                                        Gl[rt.source] = Qe.getRenderableIds(!0).map((rt)=>Qe.getTileByID(rt)).sort((Qe, rt)=>rt.tileID.overscaledZ - Qe.tileID.overscaledZ || (Qe.tileID.isLessThan(rt.tileID) ? -1 : 1));
                                    }
                                    const Wn = this.crossTileSymbolIndex.addLayer(rt, Gl[rt.source], Qe.center.lng);
                                    Rl = Rl || Wn;
                                }
                                if (this.crossTileSymbolIndex.pruneUnusedLayers(this._order), ((Dl = Dl || this._layerOrderChanged || 0 === Wn) || !this.pauseablePlacement || this.pauseablePlacement.isDone() && !this.placement.stillRecent(Ll.now(), Qe.zoom)) && (this.pauseablePlacement = new at(Qe, this.map.terrain, this._order, Dl, rt, Wn, Co, this.placement), this._layerOrderChanged = !1), this.pauseablePlacement.isDone() ? this.placement.setStale() : (this.pauseablePlacement.continuePlacement(this._order, this._layers, Gl), this.pauseablePlacement.isDone() && (this.placement = this.pauseablePlacement.commit(Ll.now()), Ul = !0), Rl && this.pauseablePlacement.placement.setStale()), Ul || Rl) for (const Ll of this._order){
                                    const Qe = this._layers[Ll];
                                    "symbol" === Qe.type && this.placement.updateLayerOpacities(Qe, Gl[Qe.source]);
                                }
                                return !this.pauseablePlacement.isDone() || this.placement.hasTransitions(Ll.now());
                            }
                            _releaseSymbolFadeTiles() {
                                for(const Qe in this.sourceCaches)this.sourceCaches[Qe].releaseSymbolFadeTiles();
                            }
                            getImages(Qe, Wn) {
                                return rt._(this, void 0, void 0, function*() {
                                    const Qe = yield this.imageManager.getImages(Wn.icons);
                                    this._updateTilesForChangedImages();
                                    const rt = this.sourceCaches[Wn.source];
                                    return rt && rt.setDependencies(Wn.tileID.key, Wn.type, Wn.icons), Qe;
                                });
                            }
                            getGlyphs(Qe, Wn) {
                                return rt._(this, void 0, void 0, function*() {
                                    const Qe = yield this.glyphManager.getGlyphs(Wn.stacks), rt = this.sourceCaches[Wn.source];
                                    return rt && rt.setDependencies(Wn.tileID.key, Wn.type, [
                                        ""
                                    ]), Qe;
                                });
                            }
                            getGlyphsUrl() {
                                return this.stylesheet.glyphs || null;
                            }
                            setGlyphs(Qe, Wn = {}) {
                                this._checkLoaded(), Qe && this._validate(rt.y.glyphs, "glyphs", Qe, null, Wn) || (this._glyphsDidChange = !0, this.stylesheet.glyphs = Qe, this.glyphManager.entries = {}, this.glyphManager.setURL(Qe));
                            }
                            addSprite(Qe, Wn, Co = {}, Dl) {
                                this._checkLoaded();
                                const Ll = [
                                    {
                                        id: Qe,
                                        url: Wn
                                    }
                                ], Rl = [
                                    ...f(this.stylesheet.sprite),
                                    ...Ll
                                ];
                                this._validate(rt.y.sprite, "sprite", Rl, null, Co) || (this.stylesheet.sprite = Rl, this._loadSprite(Ll, !0, Dl));
                            }
                            removeSprite(Qe) {
                                this._checkLoaded();
                                const Wn = f(this.stylesheet.sprite);
                                if (Wn.find((rt)=>rt.id === Qe)) {
                                    if (this._spritesImagesIds[Qe]) for (const rt of this._spritesImagesIds[Qe])this.imageManager.removeImage(rt), this._changedImages[rt] = !0;
                                    Wn.splice(Wn.findIndex((rt)=>rt.id === Qe), 1), this.stylesheet.sprite = Wn.length > 0 ? Wn : void 0, delete this._spritesImagesIds[Qe], this._availableImages = this.imageManager.listImages(), this._changed = !0, this.dispatcher.broadcast("SI", this._availableImages), this.fire(new rt.l("data", {
                                        dataType: "style"
                                    }));
                                } else this.fire(new rt.k(new Error(`Sprite "${Qe}" doesn't exists on this map.`)));
                            }
                            getSprite() {
                                return f(this.stylesheet.sprite);
                            }
                            setSprite(Qe, Wn = {}, Co) {
                                this._checkLoaded(), Qe && this._validate(rt.y.sprite, "sprite", Qe, null, Wn) || (this.stylesheet.sprite = Qe, Qe ? this._loadSprite(Qe, !0, Co) : (this._unloadSprite(), Co && Co(null)));
                            }
                        }
                        var Ad = rt.aD([
                            {
                                name: "a_pos",
                                type: "Int16",
                                components: 2
                            },
                            {
                                name: "a_texture_pos",
                                type: "Int16",
                                components: 2
                            }
                        ]);
                        class xi {
                            constructor(){
                                this.boundProgram = null, this.boundLayoutVertexBuffer = null, this.boundPaintVertexBuffers = [], this.boundIndexBuffer = null, this.boundVertexOffset = null, this.boundDynamicVertexBuffer = null, this.vao = null;
                            }
                            bind(Qe, rt, Wn, Co, Dl, Ll, Rl, Ul, Gl) {
                                this.context = Qe;
                                let Zl = this.boundPaintVertexBuffers.length !== Co.length;
                                for(let Hl = 0; !Zl && Hl < Co.length; Hl++)this.boundPaintVertexBuffers[Hl] !== Co[Hl] && (Zl = !0);
                                !this.vao || this.boundProgram !== rt || this.boundLayoutVertexBuffer !== Wn || Zl || this.boundIndexBuffer !== Dl || this.boundVertexOffset !== Ll || this.boundDynamicVertexBuffer !== Rl || this.boundDynamicVertexBuffer2 !== Ul || this.boundDynamicVertexBuffer3 !== Gl ? this.freshBind(rt, Wn, Co, Dl, Ll, Rl, Ul, Gl) : (Qe.bindVertexArray.set(this.vao), Rl && Rl.bind(), Dl && Dl.dynamicDraw && Dl.bind(), Ul && Ul.bind(), Gl && Gl.bind());
                            }
                            freshBind(Qe, rt, Wn, Co, Dl, Ll, Rl, Ul) {
                                const Gl = Qe.numAttributes, Zl = this.context, Hl = Zl.gl;
                                this.vao && this.destroy(), this.vao = Zl.createVertexArray(), Zl.bindVertexArray.set(this.vao), this.boundProgram = Qe, this.boundLayoutVertexBuffer = rt, this.boundPaintVertexBuffers = Wn, this.boundIndexBuffer = Co, this.boundVertexOffset = Dl, this.boundDynamicVertexBuffer = Ll, this.boundDynamicVertexBuffer2 = Rl, this.boundDynamicVertexBuffer3 = Ul, rt.enableAttributes(Hl, Qe);
                                for (const ql of Wn)ql.enableAttributes(Hl, Qe);
                                Ll && Ll.enableAttributes(Hl, Qe), Rl && Rl.enableAttributes(Hl, Qe), Ul && Ul.enableAttributes(Hl, Qe), rt.bind(), rt.setVertexAttribPointers(Hl, Qe, Dl);
                                for (const ql of Wn)ql.bind(), ql.setVertexAttribPointers(Hl, Qe, Dl);
                                Ll && (Ll.bind(), Ll.setVertexAttribPointers(Hl, Qe, Dl)), Co && Co.bind(), Rl && (Rl.bind(), Rl.setVertexAttribPointers(Hl, Qe, Dl)), Ul && (Ul.bind(), Ul.setVertexAttribPointers(Hl, Qe, Dl)), Zl.currentNumAttributes = Gl;
                            }
                            destroy() {
                                this.vao && (this.context.deleteVertexArray(this.vao), this.vao = null);
                            }
                        }
                        const bi = (Qe, Wn, Co, Dl, Ll)=>({
                                u_texture: 0,
                                u_ele_delta: Qe,
                                u_fog_matrix: Wn,
                                u_fog_color: Co ? Co.properties.get("fog-color") : rt.b7.white,
                                u_fog_ground_blend: Co ? Co.properties.get("fog-ground-blend") : 1,
                                u_fog_ground_blend_opacity: Ll ? 0 : Co ? Co.calculateFogBlendOpacity(Dl) : 0,
                                u_horizon_color: Co ? Co.properties.get("horizon-color") : rt.b7.white,
                                u_horizon_fog_blend: Co ? Co.properties.get("horizon-fog-blend") : 1,
                                u_is_globe_mode: Ll ? 1 : 0
                            }), yd = {
                            mainMatrix: "u_projection_matrix",
                            tileMercatorCoords: "u_projection_tile_mercator_coords",
                            clippingPlane: "u_projection_clipping_plane",
                            projectionTransition: "u_projection_transition",
                            fallbackMatrix: "u_projection_fallback_matrix"
                        };
                        function wi(Qe) {
                            const rt = [];
                            for(let Wn = 0; Wn < Qe.length; Wn++){
                                if (null === Qe[Wn]) continue;
                                const Co = Qe[Wn].split(" ");
                                rt.push(Co.pop());
                            }
                            return rt;
                        }
                        class Ti {
                            constructor(Qe, Wn, Co, Dl, Ll, Rl, Ul, Gl){
                                const Zl = Qe.gl;
                                this.program = Zl.createProgram();
                                const Hl = wi(Wn.staticAttributes), ql = Co ? Co.getBinderAttributes() : [], Ql = Hl.concat(ql), Kl = ad.prelude.staticUniforms ? wi(ad.prelude.staticUniforms) : [], $l = Ul.staticUniforms ? wi(Ul.staticUniforms) : [], Tc = Wn.staticUniforms ? wi(Wn.staticUniforms) : [], tu = Co ? Co.getBinderUniforms() : [], lu = Kl.concat($l).concat(Tc).concat(tu), du = [];
                                for (const rt of lu)du.indexOf(rt) < 0 && du.push(rt);
                                const fu = Co ? Co.defines() : [];
                                Ut(Zl) && fu.unshift("#version 300 es"), Ll && fu.push("#define OVERDRAW_INSPECTOR;"), Rl && fu.push("#define TERRAIN3D;"), Gl && fu.push(Gl);
                                let yu = fu.concat(ad.prelude.fragmentSource, Ul.fragmentSource, Wn.fragmentSource).join("\n"), Eu = fu.concat(ad.prelude.vertexSource, Ul.vertexSource, Wn.vertexSource).join("\n");
                                Ut(Zl) || (yu = function(Qe) {
                                    return Qe.replace(/\bin\s/g, "varying ").replace("out highp vec4 fragColor;", "").replace(/fragColor/g, "gl_FragColor").replace(/texture\(/g, "texture2D(");
                                }(yu), Eu = function(Qe) {
                                    return Qe.replace(/\bin\s/g, "attribute ").replace(/\bout\s/g, "varying ").replace(/texture\(/g, "texture2D(");
                                }(Eu));
                                const Tu = Zl.createShader(Zl.FRAGMENT_SHADER);
                                if (Zl.isContextLost()) return void (this.failedToCreate = !0);
                                if (Zl.shaderSource(Tu, yu), Zl.compileShader(Tu), !Zl.getShaderParameter(Tu, Zl.COMPILE_STATUS)) throw new Error(`Could not compile fragment shader: ${Zl.getShaderInfoLog(Tu)}`);
                                Zl.attachShader(this.program, Tu);
                                const Lu = Zl.createShader(Zl.VERTEX_SHADER);
                                if (Zl.isContextLost()) return void (this.failedToCreate = !0);
                                if (Zl.shaderSource(Lu, Eu), Zl.compileShader(Lu), !Zl.getShaderParameter(Lu, Zl.COMPILE_STATUS)) throw new Error(`Could not compile vertex shader: ${Zl.getShaderInfoLog(Lu)}`);
                                Zl.attachShader(this.program, Lu), this.attributes = {};
                                const Zu = {};
                                this.numAttributes = Ql.length;
                                for(let rt = 0; rt < this.numAttributes; rt++)Ql[rt] && (Zl.bindAttribLocation(this.program, rt, Ql[rt]), this.attributes[Ql[rt]] = rt);
                                if (Zl.linkProgram(this.program), !Zl.getProgramParameter(this.program, Zl.LINK_STATUS)) throw new Error(`Program failed to link: ${Zl.getProgramInfoLog(this.program)}`);
                                Zl.deleteShader(Lu), Zl.deleteShader(Tu);
                                for(let rt = 0; rt < du.length; rt++){
                                    const Qe = du[rt];
                                    if (Qe && !Zu[Qe]) {
                                        const rt = Zl.getUniformLocation(this.program, Qe);
                                        rt && (Zu[Qe] = rt);
                                    }
                                }
                                this.fixedUniforms = Dl(Qe, Zu), this.terrainUniforms = ((Qe, Wn)=>({
                                        u_depth: new rt.bF(Qe, Wn.u_depth),
                                        u_terrain: new rt.bF(Qe, Wn.u_terrain),
                                        u_terrain_dim: new rt.b8(Qe, Wn.u_terrain_dim),
                                        u_terrain_matrix: new rt.bH(Qe, Wn.u_terrain_matrix),
                                        u_terrain_unpack: new rt.bI(Qe, Wn.u_terrain_unpack),
                                        u_terrain_exaggeration: new rt.b8(Qe, Wn.u_terrain_exaggeration)
                                    }))(Qe, Zu), this.projectionUniforms = ((Qe, Wn)=>({
                                        u_projection_matrix: new rt.bH(Qe, Wn.u_projection_matrix),
                                        u_projection_tile_mercator_coords: new rt.bI(Qe, Wn.u_projection_tile_mercator_coords),
                                        u_projection_clipping_plane: new rt.bI(Qe, Wn.u_projection_clipping_plane),
                                        u_projection_transition: new rt.b8(Qe, Wn.u_projection_transition),
                                        u_projection_fallback_matrix: new rt.bH(Qe, Wn.u_projection_fallback_matrix)
                                    }))(Qe, Zu), this.binderUniforms = Co ? Co.getUniforms(Qe, Zu) : [];
                            }
                            draw(Qe, rt, Wn, Co, Dl, Ll, Rl, Ul, Gl, Zl, Hl, ql, Ql, Kl, $l, Tc, tu, lu, du) {
                                const fu = Qe.gl;
                                if (this.failedToCreate) return;
                                if (Qe.program.set(this.program), Qe.setDepthMode(Wn), Qe.setStencilMode(Co), Qe.setColorMode(Dl), Qe.setCullFace(Ll), Ul) {
                                    Qe.activeTexture.set(fu.TEXTURE2), fu.bindTexture(fu.TEXTURE_2D, Ul.depthTexture), Qe.activeTexture.set(fu.TEXTURE3), fu.bindTexture(fu.TEXTURE_2D, Ul.texture);
                                    for(const Qe in this.terrainUniforms)this.terrainUniforms[Qe].set(Ul[Qe]);
                                }
                                if (Gl) for(const Eu in Gl)this.projectionUniforms[yd[Eu]].set(Gl[Eu]);
                                if (Rl) for(const Eu in this.fixedUniforms)this.fixedUniforms[Eu].set(Rl[Eu]);
                                Tc && Tc.setUniforms(Qe, this.binderUniforms, Kl, {
                                    zoom: $l
                                });
                                let yu = 0;
                                switch(rt){
                                    case fu.LINES:
                                        yu = 2;
                                        break;
                                    case fu.TRIANGLES:
                                        yu = 3;
                                        break;
                                    case fu.LINE_STRIP:
                                        yu = 1;
                                }
                                for (const Eu of Ql.get()){
                                    const Wn = Eu.vaos || (Eu.vaos = {});
                                    (Wn[Zl] || (Wn[Zl] = new xi)).bind(Qe, this, Hl, Tc ? Tc.getPaintVertexBuffers() : [], ql, Eu.vertexOffset, tu, lu, du), fu.drawElements(rt, Eu.primitiveLength * yu, fu.UNSIGNED_SHORT, Eu.primitiveOffset * yu * 2);
                                }
                            }
                        }
                        function Pi(Qe, Wn, Co) {
                            const Dl = 1 / rt.aw(Co, 1, Wn.transform.tileZoom), Ll = Math.pow(2, Co.tileID.overscaledZ), Rl = Co.tileSize * Math.pow(2, Wn.transform.tileZoom) / Ll, Ul = Rl * (Co.tileID.canonical.x + Co.tileID.wrap * Ll), Gl = Rl * Co.tileID.canonical.y;
                            return {
                                u_image: 0,
                                u_texsize: Co.imageAtlasTexture.size,
                                u_scale: [
                                    Dl,
                                    Qe.fromScale,
                                    Qe.toScale
                                ],
                                u_fade: Qe.t,
                                u_pixel_coord_upper: [
                                    Ul >> 16,
                                    Gl >> 16
                                ],
                                u_pixel_coord_lower: [
                                    65535 & Ul,
                                    65535 & Gl
                                ]
                            };
                        }
                        const Ci = (Qe, Wn, Co, Dl)=>{
                            const Ll = Qe.style.light, Rl = Ll.properties.get("position"), Ul = [
                                Rl.x,
                                Rl.y,
                                Rl.z
                            ], Gl = rt.bL();
                            "viewport" === Ll.properties.get("anchor") && rt.bM(Gl, Qe.transform.bearingInRadians), rt.bN(Ul, Ul, Gl);
                            const Zl = Qe.transform.transformLightDirection(Ul), Hl = Ll.properties.get("color");
                            return {
                                u_lightpos: Ul,
                                u_lightpos_globe: Zl,
                                u_lightintensity: Ll.properties.get("intensity"),
                                u_lightcolor: [
                                    Hl.r,
                                    Hl.g,
                                    Hl.b
                                ],
                                u_vertical_gradient: +Wn,
                                u_opacity: Co,
                                u_fill_translate: Dl
                            };
                        }, Ii = (Qe, Wn, Co, Dl, Ll, Rl, Ul)=>rt.e(Ci(Qe, Wn, Co, Dl), Pi(Rl, Qe, Ul), {
                                u_height_factor: -Math.pow(2, Ll.overscaledZ) / Ul.tileSize / 8
                            }), Mi = (Qe, Wn, Co, Dl)=>rt.e(Pi(Wn, Qe, Co), {
                                u_fill_translate: Dl
                            }), Ei = (Qe, rt)=>({
                                u_world: Qe,
                                u_fill_translate: rt
                            }), Si = (Qe, Wn, Co, Dl, Ll)=>rt.e(Mi(Qe, Wn, Co, Ll), {
                                u_world: Dl
                            }), Ri = (Qe, Wn, Co, Dl, Ll)=>{
                            const Rl = Qe.transform;
                            let Ul, Gl, Zl = 0;
                            if ("map" === Co.paint.get("circle-pitch-alignment")) {
                                const Qe = rt.aw(Wn, 1, Rl.zoom);
                                Ul = !0, Gl = [
                                    Qe,
                                    Qe
                                ], Zl = Qe / (rt.Z * Math.pow(2, Wn.tileID.overscaledZ)) * 2 * Math.PI * Ll;
                            } else Ul = !1, Gl = Rl.pixelsToGLUnits;
                            return {
                                u_camera_to_center_distance: Rl.cameraToCenterDistance,
                                u_scale_with_map: +("map" === Co.paint.get("circle-pitch-scale")),
                                u_pitch_with_map: +Ul,
                                u_device_pixel_ratio: Qe.pixelRatio,
                                u_extrude_scale: Gl,
                                u_globe_extrude_scale: Zl,
                                u_translate: Dl
                            };
                        }, Di = (Qe)=>({
                                u_pixel_extrude_scale: [
                                    1 / Qe.width,
                                    1 / Qe.height
                                ]
                            }), zi = (Qe)=>({
                                u_viewport_size: [
                                    Qe.width,
                                    Qe.height
                                ]
                            }), Ai = (Qe, rt = 1)=>({
                                u_color: Qe,
                                u_overlay: 0,
                                u_overlay_scale: rt
                            }), Li = (Qe, Wn, Co, Dl)=>{
                            const Ll = rt.aw(Qe, 1, Wn) / (rt.Z * Math.pow(2, Qe.tileID.overscaledZ)) * 2 * Math.PI * Dl;
                            return {
                                u_extrude_scale: rt.aw(Qe, 1, Wn),
                                u_intensity: Co,
                                u_globe_extrude_scale: Ll
                            };
                        }, ki = (Qe, Wn, Co, Dl)=>{
                            const Ll = rt.K();
                            rt.bO(Ll, 0, Qe.width, Qe.height, 0, 0, 1);
                            const Rl = Qe.context.gl;
                            return {
                                u_matrix: Ll,
                                u_world: [
                                    Rl.drawingBufferWidth,
                                    Rl.drawingBufferHeight
                                ],
                                u_image: Co,
                                u_color_ramp: Dl,
                                u_opacity: Wn.paint.get("heatmap-opacity")
                            };
                        }, Fi = (Qe, rt, Wn)=>{
                            const Co = Wn.paint.get("hillshade-shadow-color"), Dl = Wn.paint.get("hillshade-highlight-color"), Ll = Wn.paint.get("hillshade-accent-color");
                            let Rl = Wn.paint.get("hillshade-illumination-direction") * (Math.PI / 180);
                            return "viewport" === Wn.paint.get("hillshade-illumination-anchor") && (Rl += Qe.transform.bearingInRadians), {
                                u_image: 0,
                                u_latrange: Oi(0, rt.tileID),
                                u_light: [
                                    Wn.paint.get("hillshade-exaggeration"),
                                    Rl
                                ],
                                u_shadow: Co,
                                u_highlight: Dl,
                                u_accent: Ll
                            };
                        }, Bi = (Qe, Wn)=>{
                            const Co = Wn.stride, Dl = rt.K();
                            return rt.bO(Dl, 0, rt.Z, -8192, 0, 0, 1), rt.L(Dl, Dl, [
                                0,
                                -8192,
                                0
                            ]), {
                                u_matrix: Dl,
                                u_image: 1,
                                u_dimension: [
                                    Co,
                                    Co
                                ],
                                u_zoom: Qe.overscaledZ,
                                u_unpack: Wn.getUnpackVector()
                            };
                        };
                        function Oi(Qe, Wn) {
                            const Co = Math.pow(2, Wn.canonical.z), Dl = Wn.canonical.y;
                            return [
                                new rt.$(0, Dl / Co).toLngLat().lat,
                                new rt.$(0, (Dl + 1) / Co).toLngLat().lat
                            ];
                        }
                        const ji = (Qe, Wn, Co, Dl)=>{
                            const Ll = Qe.transform;
                            return {
                                u_translation: Vi(Qe, Wn, Co),
                                u_ratio: Dl / rt.aw(Wn, 1, Ll.zoom),
                                u_device_pixel_ratio: Qe.pixelRatio,
                                u_units_to_pixels: [
                                    1 / Ll.pixelsToGLUnits[0],
                                    1 / Ll.pixelsToGLUnits[1]
                                ]
                            };
                        }, Zi = (Qe, Wn, Co, Dl, Ll)=>rt.e(ji(Qe, Wn, Co, Dl), {
                                u_image: 0,
                                u_image_height: Ll
                            }), Ni = (Qe, Wn, Co, Dl, Ll)=>{
                            const Rl = Qe.transform, Ul = Ui(Wn, Rl);
                            return {
                                u_translation: Vi(Qe, Wn, Co),
                                u_texsize: Wn.imageAtlasTexture.size,
                                u_ratio: Dl / rt.aw(Wn, 1, Rl.zoom),
                                u_device_pixel_ratio: Qe.pixelRatio,
                                u_image: 0,
                                u_scale: [
                                    Ul,
                                    Ll.fromScale,
                                    Ll.toScale
                                ],
                                u_fade: Ll.t,
                                u_units_to_pixels: [
                                    1 / Rl.pixelsToGLUnits[0],
                                    1 / Rl.pixelsToGLUnits[1]
                                ]
                            };
                        }, Gi = (Qe, Wn, Co, Dl, Ll, Rl)=>{
                            const Ul = Qe.lineAtlas, Gl = Ui(Wn, Qe.transform), Zl = "round" === Co.layout.get("line-cap"), Hl = Ul.getDash(Ll.from, Zl), ql = Ul.getDash(Ll.to, Zl), Ql = Hl.width * Rl.fromScale, Kl = ql.width * Rl.toScale;
                            return rt.e(ji(Qe, Wn, Co, Dl), {
                                u_patternscale_a: [
                                    Gl / Ql,
                                    -Hl.height / 2
                                ],
                                u_patternscale_b: [
                                    Gl / Kl,
                                    -ql.height / 2
                                ],
                                u_sdfgamma: Ul.width / (256 * Math.min(Ql, Kl) * Qe.pixelRatio) / 2,
                                u_image: 0,
                                u_tex_y_a: Hl.y,
                                u_tex_y_b: ql.y,
                                u_mix: Rl.t
                            });
                        };
                        function Ui(Qe, Wn) {
                            return 1 / rt.aw(Qe, 1, Wn.tileZoom);
                        }
                        function Vi(Qe, Wn, Co) {
                            return rt.ax(Qe.transform, Wn, Co.paint.get("line-translate"), Co.paint.get("line-translate-anchor"));
                        }
                        const qi = (Qe, rt, Wn, Co, Dl)=>{
                            var Ll, Rl;
                            return {
                                u_tl_parent: Qe,
                                u_scale_parent: rt,
                                u_buffer_scale: 1,
                                u_fade_t: Wn.mix,
                                u_opacity: Wn.opacity * Co.paint.get("raster-opacity"),
                                u_image0: 0,
                                u_image1: 1,
                                u_brightness_low: Co.paint.get("raster-brightness-min"),
                                u_brightness_high: Co.paint.get("raster-brightness-max"),
                                u_saturation_factor: (Rl = Co.paint.get("raster-saturation"), Rl > 0 ? 1 - 1 / (1.001 - Rl) : -Rl),
                                u_contrast_factor: (Ll = Co.paint.get("raster-contrast"), Ll > 0 ? 1 / (1 - Ll) : 1 + Ll),
                                u_spin_weights: Wi(Co.paint.get("raster-hue-rotate")),
                                u_coords_top: [
                                    Dl[0].x,
                                    Dl[0].y,
                                    Dl[1].x,
                                    Dl[1].y
                                ],
                                u_coords_bottom: [
                                    Dl[3].x,
                                    Dl[3].y,
                                    Dl[2].x,
                                    Dl[2].y
                                ]
                            };
                        };
                        function Wi(Qe) {
                            Qe *= Math.PI / 180;
                            const rt = Math.sin(Qe), Wn = Math.cos(Qe);
                            return [
                                (2 * Wn + 1) / 3,
                                (-Math.sqrt(3) * rt - Wn + 1) / 3,
                                (Math.sqrt(3) * rt - Wn + 1) / 3
                            ];
                        }
                        const $i = (Qe, rt, Wn, Co, Dl, Ll, Rl, Ul, Gl, Zl, Hl, ql, Ql)=>{
                            const Kl = Rl.transform;
                            return {
                                u_is_size_zoom_constant: +("constant" === Qe || "source" === Qe),
                                u_is_size_feature_constant: +("constant" === Qe || "camera" === Qe),
                                u_size_t: rt ? rt.uSizeT : 0,
                                u_size: rt ? rt.uSize : 0,
                                u_camera_to_center_distance: Kl.cameraToCenterDistance,
                                u_pitch: Kl.pitch / 360 * 2 * Math.PI,
                                u_rotate_symbol: +Wn,
                                u_aspect_ratio: Kl.width / Kl.height,
                                u_fade_change: Rl.options.fadeDuration ? Rl.symbolFadeChange : 1,
                                u_label_plane_matrix: Ul,
                                u_coord_matrix: Gl,
                                u_is_text: +Hl,
                                u_pitch_with_map: +Co,
                                u_is_along_line: Dl,
                                u_is_variable_anchor: Ll,
                                u_texsize: ql,
                                u_texture: 0,
                                u_translation: Zl,
                                u_pitched_scale: Ql
                            };
                        }, Hi = (Qe, Wn, Co, Dl, Ll, Rl, Ul, Gl, Zl, Hl, ql, Ql, Kl, $l)=>{
                            const Tc = Ul.transform;
                            return rt.e($i(Qe, Wn, Co, Dl, Ll, Rl, Ul, Gl, Zl, Hl, ql, Ql, $l), {
                                u_gamma_scale: Dl ? Math.cos(Tc.pitch * Math.PI / 180) * Tc.cameraToCenterDistance : 1,
                                u_device_pixel_ratio: Ul.pixelRatio,
                                u_is_halo: 1
                            });
                        }, Ki = (Qe, Wn, Co, Dl, Ll, Rl, Ul, Gl, Zl, Hl, ql, Ql, Kl)=>rt.e(Hi(Qe, Wn, Co, Dl, Ll, Rl, Ul, Gl, Zl, Hl, !0, ql, 0, Kl), {
                                u_texsize_icon: Ql,
                                u_texture_icon: 1
                            }), Xi = (Qe, rt)=>({
                                u_opacity: Qe,
                                u_color: rt
                            }), Qi = (Qe, Wn, Co, Dl, Ll)=>rt.e(function(Qe, Wn, Co, Dl) {
                                const Ll = Co.imageManager.getPattern(Qe.from.toString()), Rl = Co.imageManager.getPattern(Qe.to.toString()), { width: Ul, height: Gl } = Co.imageManager.getPixelSize(), Zl = Math.pow(2, Dl.tileID.overscaledZ), Hl = Dl.tileSize * Math.pow(2, Co.transform.tileZoom) / Zl, ql = Hl * (Dl.tileID.canonical.x + Dl.tileID.wrap * Zl), Ql = Hl * Dl.tileID.canonical.y;
                                return {
                                    u_image: 0,
                                    u_pattern_tl_a: Ll.tl,
                                    u_pattern_br_a: Ll.br,
                                    u_pattern_tl_b: Rl.tl,
                                    u_pattern_br_b: Rl.br,
                                    u_texsize: [
                                        Ul,
                                        Gl
                                    ],
                                    u_mix: Wn.t,
                                    u_pattern_size_a: Ll.displaySize,
                                    u_pattern_size_b: Rl.displaySize,
                                    u_scale_a: Wn.fromScale,
                                    u_scale_b: Wn.toScale,
                                    u_tile_units_to_pixels: 1 / rt.aw(Dl, 1, Co.transform.tileZoom),
                                    u_pixel_coord_upper: [
                                        ql >> 16,
                                        Ql >> 16
                                    ],
                                    u_pixel_coord_lower: [
                                        65535 & ql,
                                        65535 & Ql
                                    ]
                                };
                            }(Co, Ll, Wn, Dl), {
                                u_opacity: Qe
                            }), Yi = (Qe, rt)=>{}, vd = {
                            fillExtrusion: (Qe, Wn)=>({
                                    u_lightpos: new rt.bJ(Qe, Wn.u_lightpos),
                                    u_lightpos_globe: new rt.bJ(Qe, Wn.u_lightpos_globe),
                                    u_lightintensity: new rt.b8(Qe, Wn.u_lightintensity),
                                    u_lightcolor: new rt.bJ(Qe, Wn.u_lightcolor),
                                    u_vertical_gradient: new rt.b8(Qe, Wn.u_vertical_gradient),
                                    u_opacity: new rt.b8(Qe, Wn.u_opacity),
                                    u_fill_translate: new rt.bK(Qe, Wn.u_fill_translate)
                                }),
                            fillExtrusionPattern: (Qe, Wn)=>({
                                    u_lightpos: new rt.bJ(Qe, Wn.u_lightpos),
                                    u_lightpos_globe: new rt.bJ(Qe, Wn.u_lightpos_globe),
                                    u_lightintensity: new rt.b8(Qe, Wn.u_lightintensity),
                                    u_lightcolor: new rt.bJ(Qe, Wn.u_lightcolor),
                                    u_vertical_gradient: new rt.b8(Qe, Wn.u_vertical_gradient),
                                    u_height_factor: new rt.b8(Qe, Wn.u_height_factor),
                                    u_opacity: new rt.b8(Qe, Wn.u_opacity),
                                    u_fill_translate: new rt.bK(Qe, Wn.u_fill_translate),
                                    u_image: new rt.bF(Qe, Wn.u_image),
                                    u_texsize: new rt.bK(Qe, Wn.u_texsize),
                                    u_pixel_coord_upper: new rt.bK(Qe, Wn.u_pixel_coord_upper),
                                    u_pixel_coord_lower: new rt.bK(Qe, Wn.u_pixel_coord_lower),
                                    u_scale: new rt.bJ(Qe, Wn.u_scale),
                                    u_fade: new rt.b8(Qe, Wn.u_fade)
                                }),
                            fill: (Qe, Wn)=>({
                                    u_fill_translate: new rt.bK(Qe, Wn.u_fill_translate)
                                }),
                            fillPattern: (Qe, Wn)=>({
                                    u_image: new rt.bF(Qe, Wn.u_image),
                                    u_texsize: new rt.bK(Qe, Wn.u_texsize),
                                    u_pixel_coord_upper: new rt.bK(Qe, Wn.u_pixel_coord_upper),
                                    u_pixel_coord_lower: new rt.bK(Qe, Wn.u_pixel_coord_lower),
                                    u_scale: new rt.bJ(Qe, Wn.u_scale),
                                    u_fade: new rt.b8(Qe, Wn.u_fade),
                                    u_fill_translate: new rt.bK(Qe, Wn.u_fill_translate)
                                }),
                            fillOutline: (Qe, Wn)=>({
                                    u_world: new rt.bK(Qe, Wn.u_world),
                                    u_fill_translate: new rt.bK(Qe, Wn.u_fill_translate)
                                }),
                            fillOutlinePattern: (Qe, Wn)=>({
                                    u_world: new rt.bK(Qe, Wn.u_world),
                                    u_image: new rt.bF(Qe, Wn.u_image),
                                    u_texsize: new rt.bK(Qe, Wn.u_texsize),
                                    u_pixel_coord_upper: new rt.bK(Qe, Wn.u_pixel_coord_upper),
                                    u_pixel_coord_lower: new rt.bK(Qe, Wn.u_pixel_coord_lower),
                                    u_scale: new rt.bJ(Qe, Wn.u_scale),
                                    u_fade: new rt.b8(Qe, Wn.u_fade),
                                    u_fill_translate: new rt.bK(Qe, Wn.u_fill_translate)
                                }),
                            circle: (Qe, Wn)=>({
                                    u_camera_to_center_distance: new rt.b8(Qe, Wn.u_camera_to_center_distance),
                                    u_scale_with_map: new rt.bF(Qe, Wn.u_scale_with_map),
                                    u_pitch_with_map: new rt.bF(Qe, Wn.u_pitch_with_map),
                                    u_extrude_scale: new rt.bK(Qe, Wn.u_extrude_scale),
                                    u_device_pixel_ratio: new rt.b8(Qe, Wn.u_device_pixel_ratio),
                                    u_globe_extrude_scale: new rt.b8(Qe, Wn.u_globe_extrude_scale),
                                    u_translate: new rt.bK(Qe, Wn.u_translate)
                                }),
                            collisionBox: (Qe, Wn)=>({
                                    u_pixel_extrude_scale: new rt.bK(Qe, Wn.u_pixel_extrude_scale)
                                }),
                            collisionCircle: (Qe, Wn)=>({
                                    u_viewport_size: new rt.bK(Qe, Wn.u_viewport_size)
                                }),
                            debug: (Qe, Wn)=>({
                                    u_color: new rt.bG(Qe, Wn.u_color),
                                    u_overlay: new rt.bF(Qe, Wn.u_overlay),
                                    u_overlay_scale: new rt.b8(Qe, Wn.u_overlay_scale)
                                }),
                            depth: Yi,
                            clippingMask: Yi,
                            heatmap: (Qe, Wn)=>({
                                    u_extrude_scale: new rt.b8(Qe, Wn.u_extrude_scale),
                                    u_intensity: new rt.b8(Qe, Wn.u_intensity),
                                    u_globe_extrude_scale: new rt.b8(Qe, Wn.u_globe_extrude_scale)
                                }),
                            heatmapTexture: (Qe, Wn)=>({
                                    u_matrix: new rt.bH(Qe, Wn.u_matrix),
                                    u_world: new rt.bK(Qe, Wn.u_world),
                                    u_image: new rt.bF(Qe, Wn.u_image),
                                    u_color_ramp: new rt.bF(Qe, Wn.u_color_ramp),
                                    u_opacity: new rt.b8(Qe, Wn.u_opacity)
                                }),
                            hillshade: (Qe, Wn)=>({
                                    u_image: new rt.bF(Qe, Wn.u_image),
                                    u_latrange: new rt.bK(Qe, Wn.u_latrange),
                                    u_light: new rt.bK(Qe, Wn.u_light),
                                    u_shadow: new rt.bG(Qe, Wn.u_shadow),
                                    u_highlight: new rt.bG(Qe, Wn.u_highlight),
                                    u_accent: new rt.bG(Qe, Wn.u_accent)
                                }),
                            hillshadePrepare: (Qe, Wn)=>({
                                    u_matrix: new rt.bH(Qe, Wn.u_matrix),
                                    u_image: new rt.bF(Qe, Wn.u_image),
                                    u_dimension: new rt.bK(Qe, Wn.u_dimension),
                                    u_zoom: new rt.b8(Qe, Wn.u_zoom),
                                    u_unpack: new rt.bI(Qe, Wn.u_unpack)
                                }),
                            line: (Qe, Wn)=>({
                                    u_translation: new rt.bK(Qe, Wn.u_translation),
                                    u_ratio: new rt.b8(Qe, Wn.u_ratio),
                                    u_device_pixel_ratio: new rt.b8(Qe, Wn.u_device_pixel_ratio),
                                    u_units_to_pixels: new rt.bK(Qe, Wn.u_units_to_pixels)
                                }),
                            lineGradient: (Qe, Wn)=>({
                                    u_translation: new rt.bK(Qe, Wn.u_translation),
                                    u_ratio: new rt.b8(Qe, Wn.u_ratio),
                                    u_device_pixel_ratio: new rt.b8(Qe, Wn.u_device_pixel_ratio),
                                    u_units_to_pixels: new rt.bK(Qe, Wn.u_units_to_pixels),
                                    u_image: new rt.bF(Qe, Wn.u_image),
                                    u_image_height: new rt.b8(Qe, Wn.u_image_height)
                                }),
                            linePattern: (Qe, Wn)=>({
                                    u_translation: new rt.bK(Qe, Wn.u_translation),
                                    u_texsize: new rt.bK(Qe, Wn.u_texsize),
                                    u_ratio: new rt.b8(Qe, Wn.u_ratio),
                                    u_device_pixel_ratio: new rt.b8(Qe, Wn.u_device_pixel_ratio),
                                    u_image: new rt.bF(Qe, Wn.u_image),
                                    u_units_to_pixels: new rt.bK(Qe, Wn.u_units_to_pixels),
                                    u_scale: new rt.bJ(Qe, Wn.u_scale),
                                    u_fade: new rt.b8(Qe, Wn.u_fade)
                                }),
                            lineSDF: (Qe, Wn)=>({
                                    u_translation: new rt.bK(Qe, Wn.u_translation),
                                    u_ratio: new rt.b8(Qe, Wn.u_ratio),
                                    u_device_pixel_ratio: new rt.b8(Qe, Wn.u_device_pixel_ratio),
                                    u_units_to_pixels: new rt.bK(Qe, Wn.u_units_to_pixels),
                                    u_patternscale_a: new rt.bK(Qe, Wn.u_patternscale_a),
                                    u_patternscale_b: new rt.bK(Qe, Wn.u_patternscale_b),
                                    u_sdfgamma: new rt.b8(Qe, Wn.u_sdfgamma),
                                    u_image: new rt.bF(Qe, Wn.u_image),
                                    u_tex_y_a: new rt.b8(Qe, Wn.u_tex_y_a),
                                    u_tex_y_b: new rt.b8(Qe, Wn.u_tex_y_b),
                                    u_mix: new rt.b8(Qe, Wn.u_mix)
                                }),
                            raster: (Qe, Wn)=>({
                                    u_tl_parent: new rt.bK(Qe, Wn.u_tl_parent),
                                    u_scale_parent: new rt.b8(Qe, Wn.u_scale_parent),
                                    u_buffer_scale: new rt.b8(Qe, Wn.u_buffer_scale),
                                    u_fade_t: new rt.b8(Qe, Wn.u_fade_t),
                                    u_opacity: new rt.b8(Qe, Wn.u_opacity),
                                    u_image0: new rt.bF(Qe, Wn.u_image0),
                                    u_image1: new rt.bF(Qe, Wn.u_image1),
                                    u_brightness_low: new rt.b8(Qe, Wn.u_brightness_low),
                                    u_brightness_high: new rt.b8(Qe, Wn.u_brightness_high),
                                    u_saturation_factor: new rt.b8(Qe, Wn.u_saturation_factor),
                                    u_contrast_factor: new rt.b8(Qe, Wn.u_contrast_factor),
                                    u_spin_weights: new rt.bJ(Qe, Wn.u_spin_weights),
                                    u_coords_top: new rt.bI(Qe, Wn.u_coords_top),
                                    u_coords_bottom: new rt.bI(Qe, Wn.u_coords_bottom)
                                }),
                            symbolIcon: (Qe, Wn)=>({
                                    u_is_size_zoom_constant: new rt.bF(Qe, Wn.u_is_size_zoom_constant),
                                    u_is_size_feature_constant: new rt.bF(Qe, Wn.u_is_size_feature_constant),
                                    u_size_t: new rt.b8(Qe, Wn.u_size_t),
                                    u_size: new rt.b8(Qe, Wn.u_size),
                                    u_camera_to_center_distance: new rt.b8(Qe, Wn.u_camera_to_center_distance),
                                    u_pitch: new rt.b8(Qe, Wn.u_pitch),
                                    u_rotate_symbol: new rt.bF(Qe, Wn.u_rotate_symbol),
                                    u_aspect_ratio: new rt.b8(Qe, Wn.u_aspect_ratio),
                                    u_fade_change: new rt.b8(Qe, Wn.u_fade_change),
                                    u_label_plane_matrix: new rt.bH(Qe, Wn.u_label_plane_matrix),
                                    u_coord_matrix: new rt.bH(Qe, Wn.u_coord_matrix),
                                    u_is_text: new rt.bF(Qe, Wn.u_is_text),
                                    u_pitch_with_map: new rt.bF(Qe, Wn.u_pitch_with_map),
                                    u_is_along_line: new rt.bF(Qe, Wn.u_is_along_line),
                                    u_is_variable_anchor: new rt.bF(Qe, Wn.u_is_variable_anchor),
                                    u_texsize: new rt.bK(Qe, Wn.u_texsize),
                                    u_texture: new rt.bF(Qe, Wn.u_texture),
                                    u_translation: new rt.bK(Qe, Wn.u_translation),
                                    u_pitched_scale: new rt.b8(Qe, Wn.u_pitched_scale)
                                }),
                            symbolSDF: (Qe, Wn)=>({
                                    u_is_size_zoom_constant: new rt.bF(Qe, Wn.u_is_size_zoom_constant),
                                    u_is_size_feature_constant: new rt.bF(Qe, Wn.u_is_size_feature_constant),
                                    u_size_t: new rt.b8(Qe, Wn.u_size_t),
                                    u_size: new rt.b8(Qe, Wn.u_size),
                                    u_camera_to_center_distance: new rt.b8(Qe, Wn.u_camera_to_center_distance),
                                    u_pitch: new rt.b8(Qe, Wn.u_pitch),
                                    u_rotate_symbol: new rt.bF(Qe, Wn.u_rotate_symbol),
                                    u_aspect_ratio: new rt.b8(Qe, Wn.u_aspect_ratio),
                                    u_fade_change: new rt.b8(Qe, Wn.u_fade_change),
                                    u_label_plane_matrix: new rt.bH(Qe, Wn.u_label_plane_matrix),
                                    u_coord_matrix: new rt.bH(Qe, Wn.u_coord_matrix),
                                    u_is_text: new rt.bF(Qe, Wn.u_is_text),
                                    u_pitch_with_map: new rt.bF(Qe, Wn.u_pitch_with_map),
                                    u_is_along_line: new rt.bF(Qe, Wn.u_is_along_line),
                                    u_is_variable_anchor: new rt.bF(Qe, Wn.u_is_variable_anchor),
                                    u_texsize: new rt.bK(Qe, Wn.u_texsize),
                                    u_texture: new rt.bF(Qe, Wn.u_texture),
                                    u_gamma_scale: new rt.b8(Qe, Wn.u_gamma_scale),
                                    u_device_pixel_ratio: new rt.b8(Qe, Wn.u_device_pixel_ratio),
                                    u_is_halo: new rt.bF(Qe, Wn.u_is_halo),
                                    u_translation: new rt.bK(Qe, Wn.u_translation),
                                    u_pitched_scale: new rt.b8(Qe, Wn.u_pitched_scale)
                                }),
                            symbolTextAndIcon: (Qe, Wn)=>({
                                    u_is_size_zoom_constant: new rt.bF(Qe, Wn.u_is_size_zoom_constant),
                                    u_is_size_feature_constant: new rt.bF(Qe, Wn.u_is_size_feature_constant),
                                    u_size_t: new rt.b8(Qe, Wn.u_size_t),
                                    u_size: new rt.b8(Qe, Wn.u_size),
                                    u_camera_to_center_distance: new rt.b8(Qe, Wn.u_camera_to_center_distance),
                                    u_pitch: new rt.b8(Qe, Wn.u_pitch),
                                    u_rotate_symbol: new rt.bF(Qe, Wn.u_rotate_symbol),
                                    u_aspect_ratio: new rt.b8(Qe, Wn.u_aspect_ratio),
                                    u_fade_change: new rt.b8(Qe, Wn.u_fade_change),
                                    u_label_plane_matrix: new rt.bH(Qe, Wn.u_label_plane_matrix),
                                    u_coord_matrix: new rt.bH(Qe, Wn.u_coord_matrix),
                                    u_is_text: new rt.bF(Qe, Wn.u_is_text),
                                    u_pitch_with_map: new rt.bF(Qe, Wn.u_pitch_with_map),
                                    u_is_along_line: new rt.bF(Qe, Wn.u_is_along_line),
                                    u_is_variable_anchor: new rt.bF(Qe, Wn.u_is_variable_anchor),
                                    u_texsize: new rt.bK(Qe, Wn.u_texsize),
                                    u_texsize_icon: new rt.bK(Qe, Wn.u_texsize_icon),
                                    u_texture: new rt.bF(Qe, Wn.u_texture),
                                    u_texture_icon: new rt.bF(Qe, Wn.u_texture_icon),
                                    u_gamma_scale: new rt.b8(Qe, Wn.u_gamma_scale),
                                    u_device_pixel_ratio: new rt.b8(Qe, Wn.u_device_pixel_ratio),
                                    u_is_halo: new rt.bF(Qe, Wn.u_is_halo),
                                    u_translation: new rt.bK(Qe, Wn.u_translation),
                                    u_pitched_scale: new rt.b8(Qe, Wn.u_pitched_scale)
                                }),
                            background: (Qe, Wn)=>({
                                    u_opacity: new rt.b8(Qe, Wn.u_opacity),
                                    u_color: new rt.bG(Qe, Wn.u_color)
                                }),
                            backgroundPattern: (Qe, Wn)=>({
                                    u_opacity: new rt.b8(Qe, Wn.u_opacity),
                                    u_image: new rt.bF(Qe, Wn.u_image),
                                    u_pattern_tl_a: new rt.bK(Qe, Wn.u_pattern_tl_a),
                                    u_pattern_br_a: new rt.bK(Qe, Wn.u_pattern_br_a),
                                    u_pattern_tl_b: new rt.bK(Qe, Wn.u_pattern_tl_b),
                                    u_pattern_br_b: new rt.bK(Qe, Wn.u_pattern_br_b),
                                    u_texsize: new rt.bK(Qe, Wn.u_texsize),
                                    u_mix: new rt.b8(Qe, Wn.u_mix),
                                    u_pattern_size_a: new rt.bK(Qe, Wn.u_pattern_size_a),
                                    u_pattern_size_b: new rt.bK(Qe, Wn.u_pattern_size_b),
                                    u_scale_a: new rt.b8(Qe, Wn.u_scale_a),
                                    u_scale_b: new rt.b8(Qe, Wn.u_scale_b),
                                    u_pixel_coord_upper: new rt.bK(Qe, Wn.u_pixel_coord_upper),
                                    u_pixel_coord_lower: new rt.bK(Qe, Wn.u_pixel_coord_lower),
                                    u_tile_units_to_pixels: new rt.b8(Qe, Wn.u_tile_units_to_pixels)
                                }),
                            terrain: (Qe, Wn)=>({
                                    u_texture: new rt.bF(Qe, Wn.u_texture),
                                    u_ele_delta: new rt.b8(Qe, Wn.u_ele_delta),
                                    u_fog_matrix: new rt.bH(Qe, Wn.u_fog_matrix),
                                    u_fog_color: new rt.bG(Qe, Wn.u_fog_color),
                                    u_fog_ground_blend: new rt.b8(Qe, Wn.u_fog_ground_blend),
                                    u_fog_ground_blend_opacity: new rt.b8(Qe, Wn.u_fog_ground_blend_opacity),
                                    u_horizon_color: new rt.bG(Qe, Wn.u_horizon_color),
                                    u_horizon_fog_blend: new rt.b8(Qe, Wn.u_horizon_fog_blend),
                                    u_is_globe_mode: new rt.b8(Qe, Wn.u_is_globe_mode)
                                }),
                            terrainDepth: (Qe, Wn)=>({
                                    u_ele_delta: new rt.b8(Qe, Wn.u_ele_delta)
                                }),
                            terrainCoords: (Qe, Wn)=>({
                                    u_texture: new rt.bF(Qe, Wn.u_texture),
                                    u_terrain_coords_id: new rt.b8(Qe, Wn.u_terrain_coords_id),
                                    u_ele_delta: new rt.b8(Qe, Wn.u_ele_delta)
                                }),
                            projectionErrorMeasurement: (Qe, Wn)=>({
                                    u_input: new rt.b8(Qe, Wn.u_input),
                                    u_output_expected: new rt.b8(Qe, Wn.u_output_expected)
                                }),
                            atmosphere: (Qe, Wn)=>({
                                    u_sun_pos: new rt.bJ(Qe, Wn.u_sun_pos),
                                    u_atmosphere_blend: new rt.b8(Qe, Wn.u_atmosphere_blend),
                                    u_globe_position: new rt.bJ(Qe, Wn.u_globe_position),
                                    u_globe_radius: new rt.b8(Qe, Wn.u_globe_radius),
                                    u_inv_proj_matrix: new rt.bH(Qe, Wn.u_inv_proj_matrix)
                                }),
                            sky: (Qe, Wn)=>({
                                    u_sky_color: new rt.bG(Qe, Wn.u_sky_color),
                                    u_horizon_color: new rt.bG(Qe, Wn.u_horizon_color),
                                    u_horizon: new rt.bK(Qe, Wn.u_horizon),
                                    u_horizon_normal: new rt.bK(Qe, Wn.u_horizon_normal),
                                    u_sky_horizon_blend: new rt.b8(Qe, Wn.u_sky_horizon_blend),
                                    u_sky_blend: new rt.b8(Qe, Wn.u_sky_blend)
                                })
                        };
                        class er {
                            constructor(Qe, rt, Wn){
                                this.context = Qe;
                                const Co = Qe.gl;
                                this.buffer = Co.createBuffer(), this.dynamicDraw = Boolean(Wn), this.context.unbindVAO(), Qe.bindElementBuffer.set(this.buffer), Co.bufferData(Co.ELEMENT_ARRAY_BUFFER, rt.arrayBuffer, this.dynamicDraw ? Co.DYNAMIC_DRAW : Co.STATIC_DRAW), this.dynamicDraw || delete rt.arrayBuffer;
                            }
                            bind() {
                                this.context.bindElementBuffer.set(this.buffer);
                            }
                            updateData(Qe) {
                                const rt = this.context.gl;
                                if (!this.dynamicDraw) throw new Error("Attempted to update data while not in dynamic mode.");
                                this.context.unbindVAO(), this.bind(), rt.bufferSubData(rt.ELEMENT_ARRAY_BUFFER, 0, Qe.arrayBuffer);
                            }
                            destroy() {
                                this.buffer && (this.context.gl.deleteBuffer(this.buffer), delete this.buffer);
                            }
                        }
                        const _d = {
                            Int8: "BYTE",
                            Uint8: "UNSIGNED_BYTE",
                            Int16: "SHORT",
                            Uint16: "UNSIGNED_SHORT",
                            Int32: "INT",
                            Uint32: "UNSIGNED_INT",
                            Float32: "FLOAT"
                        };
                        class ir {
                            constructor(Qe, rt, Wn, Co){
                                this.length = rt.length, this.attributes = Wn, this.itemSize = rt.bytesPerElement, this.dynamicDraw = Co, this.context = Qe;
                                const Dl = Qe.gl;
                                this.buffer = Dl.createBuffer(), Qe.bindVertexBuffer.set(this.buffer), Dl.bufferData(Dl.ARRAY_BUFFER, rt.arrayBuffer, this.dynamicDraw ? Dl.DYNAMIC_DRAW : Dl.STATIC_DRAW), this.dynamicDraw || delete rt.arrayBuffer;
                            }
                            bind() {
                                this.context.bindVertexBuffer.set(this.buffer);
                            }
                            updateData(Qe) {
                                if (Qe.length !== this.length) throw new Error(`Length of new data is ${Qe.length}, which doesn't match current length of ${this.length}`);
                                const rt = this.context.gl;
                                this.bind(), rt.bufferSubData(rt.ARRAY_BUFFER, 0, Qe.arrayBuffer);
                            }
                            enableAttributes(Qe, rt) {
                                for(let Wn = 0; Wn < this.attributes.length; Wn++){
                                    const Co = rt.attributes[this.attributes[Wn].name];
                                    void 0 !== Co && Qe.enableVertexAttribArray(Co);
                                }
                            }
                            setVertexAttribPointers(Qe, rt, Wn) {
                                for(let Co = 0; Co < this.attributes.length; Co++){
                                    const Dl = this.attributes[Co], Ll = rt.attributes[Dl.name];
                                    void 0 !== Ll && Qe.vertexAttribPointer(Ll, Dl.components, Qe[_d[Dl.type]], !1, this.itemSize, Dl.offset + this.itemSize * (Wn || 0));
                                }
                            }
                            destroy() {
                                this.buffer && (this.context.gl.deleteBuffer(this.buffer), delete this.buffer);
                            }
                        }
                        class rr {
                            constructor(Qe){
                                this.gl = Qe.gl, this.default = this.getDefault(), this.current = this.default, this.dirty = !1;
                            }
                            get() {
                                return this.current;
                            }
                            set(Qe) {}
                            getDefault() {
                                return this.default;
                            }
                            setDefault() {
                                this.set(this.default);
                            }
                        }
                        class or extends rr {
                            getDefault() {
                                return rt.b7.transparent;
                            }
                            set(Qe) {
                                const rt = this.current;
                                (Qe.r !== rt.r || Qe.g !== rt.g || Qe.b !== rt.b || Qe.a !== rt.a || this.dirty) && (this.gl.clearColor(Qe.r, Qe.g, Qe.b, Qe.a), this.current = Qe, this.dirty = !1);
                            }
                        }
                        class ar extends rr {
                            getDefault() {
                                return 1;
                            }
                            set(Qe) {
                                (Qe !== this.current || this.dirty) && (this.gl.clearDepth(Qe), this.current = Qe, this.dirty = !1);
                            }
                        }
                        class sr extends rr {
                            getDefault() {
                                return 0;
                            }
                            set(Qe) {
                                (Qe !== this.current || this.dirty) && (this.gl.clearStencil(Qe), this.current = Qe, this.dirty = !1);
                            }
                        }
                        class nr extends rr {
                            getDefault() {
                                return [
                                    !0,
                                    !0,
                                    !0,
                                    !0
                                ];
                            }
                            set(Qe) {
                                const rt = this.current;
                                (Qe[0] !== rt[0] || Qe[1] !== rt[1] || Qe[2] !== rt[2] || Qe[3] !== rt[3] || this.dirty) && (this.gl.colorMask(Qe[0], Qe[1], Qe[2], Qe[3]), this.current = Qe, this.dirty = !1);
                            }
                        }
                        class lr extends rr {
                            getDefault() {
                                return !0;
                            }
                            set(Qe) {
                                (Qe !== this.current || this.dirty) && (this.gl.depthMask(Qe), this.current = Qe, this.dirty = !1);
                            }
                        }
                        class cr extends rr {
                            getDefault() {
                                return 255;
                            }
                            set(Qe) {
                                (Qe !== this.current || this.dirty) && (this.gl.stencilMask(Qe), this.current = Qe, this.dirty = !1);
                            }
                        }
                        class hr extends rr {
                            getDefault() {
                                return {
                                    func: this.gl.ALWAYS,
                                    ref: 0,
                                    mask: 255
                                };
                            }
                            set(Qe) {
                                const rt = this.current;
                                (Qe.func !== rt.func || Qe.ref !== rt.ref || Qe.mask !== rt.mask || this.dirty) && (this.gl.stencilFunc(Qe.func, Qe.ref, Qe.mask), this.current = Qe, this.dirty = !1);
                            }
                        }
                        class ur extends rr {
                            getDefault() {
                                const Qe = this.gl;
                                return [
                                    Qe.KEEP,
                                    Qe.KEEP,
                                    Qe.KEEP
                                ];
                            }
                            set(Qe) {
                                const rt = this.current;
                                (Qe[0] !== rt[0] || Qe[1] !== rt[1] || Qe[2] !== rt[2] || this.dirty) && (this.gl.stencilOp(Qe[0], Qe[1], Qe[2]), this.current = Qe, this.dirty = !1);
                            }
                        }
                        class dr extends rr {
                            getDefault() {
                                return !1;
                            }
                            set(Qe) {
                                if (Qe === this.current && !this.dirty) return;
                                const rt = this.gl;
                                Qe ? rt.enable(rt.STENCIL_TEST) : rt.disable(rt.STENCIL_TEST), this.current = Qe, this.dirty = !1;
                            }
                        }
                        class _r extends rr {
                            getDefault() {
                                return [
                                    0,
                                    1
                                ];
                            }
                            set(Qe) {
                                const rt = this.current;
                                (Qe[0] !== rt[0] || Qe[1] !== rt[1] || this.dirty) && (this.gl.depthRange(Qe[0], Qe[1]), this.current = Qe, this.dirty = !1);
                            }
                        }
                        class pr extends rr {
                            getDefault() {
                                return !1;
                            }
                            set(Qe) {
                                if (Qe === this.current && !this.dirty) return;
                                const rt = this.gl;
                                Qe ? rt.enable(rt.DEPTH_TEST) : rt.disable(rt.DEPTH_TEST), this.current = Qe, this.dirty = !1;
                            }
                        }
                        class mr extends rr {
                            getDefault() {
                                return this.gl.LESS;
                            }
                            set(Qe) {
                                (Qe !== this.current || this.dirty) && (this.gl.depthFunc(Qe), this.current = Qe, this.dirty = !1);
                            }
                        }
                        class fr extends rr {
                            getDefault() {
                                return !1;
                            }
                            set(Qe) {
                                if (Qe === this.current && !this.dirty) return;
                                const rt = this.gl;
                                Qe ? rt.enable(rt.BLEND) : rt.disable(rt.BLEND), this.current = Qe, this.dirty = !1;
                            }
                        }
                        class gr extends rr {
                            getDefault() {
                                const Qe = this.gl;
                                return [
                                    Qe.ONE,
                                    Qe.ZERO
                                ];
                            }
                            set(Qe) {
                                const rt = this.current;
                                (Qe[0] !== rt[0] || Qe[1] !== rt[1] || this.dirty) && (this.gl.blendFunc(Qe[0], Qe[1]), this.current = Qe, this.dirty = !1);
                            }
                        }
                        class vr extends rr {
                            getDefault() {
                                return rt.b7.transparent;
                            }
                            set(Qe) {
                                const rt = this.current;
                                (Qe.r !== rt.r || Qe.g !== rt.g || Qe.b !== rt.b || Qe.a !== rt.a || this.dirty) && (this.gl.blendColor(Qe.r, Qe.g, Qe.b, Qe.a), this.current = Qe, this.dirty = !1);
                            }
                        }
                        class xr extends rr {
                            getDefault() {
                                return this.gl.FUNC_ADD;
                            }
                            set(Qe) {
                                (Qe !== this.current || this.dirty) && (this.gl.blendEquation(Qe), this.current = Qe, this.dirty = !1);
                            }
                        }
                        class br extends rr {
                            getDefault() {
                                return !1;
                            }
                            set(Qe) {
                                if (Qe === this.current && !this.dirty) return;
                                const rt = this.gl;
                                Qe ? rt.enable(rt.CULL_FACE) : rt.disable(rt.CULL_FACE), this.current = Qe, this.dirty = !1;
                            }
                        }
                        class yr extends rr {
                            getDefault() {
                                return this.gl.BACK;
                            }
                            set(Qe) {
                                (Qe !== this.current || this.dirty) && (this.gl.cullFace(Qe), this.current = Qe, this.dirty = !1);
                            }
                        }
                        class wr extends rr {
                            getDefault() {
                                return this.gl.CCW;
                            }
                            set(Qe) {
                                (Qe !== this.current || this.dirty) && (this.gl.frontFace(Qe), this.current = Qe, this.dirty = !1);
                            }
                        }
                        class Tr extends rr {
                            getDefault() {
                                return null;
                            }
                            set(Qe) {
                                (Qe !== this.current || this.dirty) && (this.gl.useProgram(Qe), this.current = Qe, this.dirty = !1);
                            }
                        }
                        class Pr extends rr {
                            getDefault() {
                                return this.gl.TEXTURE0;
                            }
                            set(Qe) {
                                (Qe !== this.current || this.dirty) && (this.gl.activeTexture(Qe), this.current = Qe, this.dirty = !1);
                            }
                        }
                        class Cr extends rr {
                            getDefault() {
                                const Qe = this.gl;
                                return [
                                    0,
                                    0,
                                    Qe.drawingBufferWidth,
                                    Qe.drawingBufferHeight
                                ];
                            }
                            set(Qe) {
                                const rt = this.current;
                                (Qe[0] !== rt[0] || Qe[1] !== rt[1] || Qe[2] !== rt[2] || Qe[3] !== rt[3] || this.dirty) && (this.gl.viewport(Qe[0], Qe[1], Qe[2], Qe[3]), this.current = Qe, this.dirty = !1);
                            }
                        }
                        class Ir extends rr {
                            getDefault() {
                                return null;
                            }
                            set(Qe) {
                                if (Qe === this.current && !this.dirty) return;
                                const rt = this.gl;
                                rt.bindFramebuffer(rt.FRAMEBUFFER, Qe), this.current = Qe, this.dirty = !1;
                            }
                        }
                        class Mr extends rr {
                            getDefault() {
                                return null;
                            }
                            set(Qe) {
                                if (Qe === this.current && !this.dirty) return;
                                const rt = this.gl;
                                rt.bindRenderbuffer(rt.RENDERBUFFER, Qe), this.current = Qe, this.dirty = !1;
                            }
                        }
                        class Er extends rr {
                            getDefault() {
                                return null;
                            }
                            set(Qe) {
                                if (Qe === this.current && !this.dirty) return;
                                const rt = this.gl;
                                rt.bindTexture(rt.TEXTURE_2D, Qe), this.current = Qe, this.dirty = !1;
                            }
                        }
                        class Sr extends rr {
                            getDefault() {
                                return null;
                            }
                            set(Qe) {
                                if (Qe === this.current && !this.dirty) return;
                                const rt = this.gl;
                                rt.bindBuffer(rt.ARRAY_BUFFER, Qe), this.current = Qe, this.dirty = !1;
                            }
                        }
                        class Rr extends rr {
                            getDefault() {
                                return null;
                            }
                            set(Qe) {
                                const rt = this.gl;
                                rt.bindBuffer(rt.ELEMENT_ARRAY_BUFFER, Qe), this.current = Qe, this.dirty = !1;
                            }
                        }
                        class Dr extends rr {
                            getDefault() {
                                return null;
                            }
                            set(Qe) {
                                var rt;
                                if (Qe === this.current && !this.dirty) return;
                                const Wn = this.gl;
                                Ut(Wn) ? Wn.bindVertexArray(Qe) : null === (rt = Wn.getExtension("OES_vertex_array_object")) || void 0 === rt || rt.bindVertexArrayOES(Qe), this.current = Qe, this.dirty = !1;
                            }
                        }
                        class zr extends rr {
                            getDefault() {
                                return 4;
                            }
                            set(Qe) {
                                if (Qe === this.current && !this.dirty) return;
                                const rt = this.gl;
                                rt.pixelStorei(rt.UNPACK_ALIGNMENT, Qe), this.current = Qe, this.dirty = !1;
                            }
                        }
                        class Ar extends rr {
                            getDefault() {
                                return !1;
                            }
                            set(Qe) {
                                if (Qe === this.current && !this.dirty) return;
                                const rt = this.gl;
                                rt.pixelStorei(rt.UNPACK_PREMULTIPLY_ALPHA_WEBGL, Qe), this.current = Qe, this.dirty = !1;
                            }
                        }
                        class Lr extends rr {
                            getDefault() {
                                return !1;
                            }
                            set(Qe) {
                                if (Qe === this.current && !this.dirty) return;
                                const rt = this.gl;
                                rt.pixelStorei(rt.UNPACK_FLIP_Y_WEBGL, Qe), this.current = Qe, this.dirty = !1;
                            }
                        }
                        class kr extends rr {
                            constructor(Qe, rt){
                                super(Qe), this.context = Qe, this.parent = rt;
                            }
                            getDefault() {
                                return null;
                            }
                        }
                        class Fr extends kr {
                            setDirty() {
                                this.dirty = !0;
                            }
                            set(Qe) {
                                if (Qe === this.current && !this.dirty) return;
                                this.context.bindFramebuffer.set(this.parent);
                                const rt = this.gl;
                                rt.framebufferTexture2D(rt.FRAMEBUFFER, rt.COLOR_ATTACHMENT0, rt.TEXTURE_2D, Qe, 0), this.current = Qe, this.dirty = !1;
                            }
                        }
                        class Br extends kr {
                            set(Qe) {
                                if (Qe === this.current && !this.dirty) return;
                                this.context.bindFramebuffer.set(this.parent);
                                const rt = this.gl;
                                rt.framebufferRenderbuffer(rt.FRAMEBUFFER, rt.DEPTH_ATTACHMENT, rt.RENDERBUFFER, Qe), this.current = Qe, this.dirty = !1;
                            }
                        }
                        class Or extends kr {
                            set(Qe) {
                                if (Qe === this.current && !this.dirty) return;
                                this.context.bindFramebuffer.set(this.parent);
                                const rt = this.gl;
                                rt.framebufferRenderbuffer(rt.FRAMEBUFFER, rt.DEPTH_STENCIL_ATTACHMENT, rt.RENDERBUFFER, Qe), this.current = Qe, this.dirty = !1;
                            }
                        }
                        const xd = "Framebuffer is not complete";
                        class Zr {
                            constructor(Qe, rt, Wn, Co, Dl){
                                this.context = Qe, this.width = rt, this.height = Wn;
                                const Ll = Qe.gl, Rl = this.framebuffer = Ll.createFramebuffer();
                                if (this.colorAttachment = new Fr(Qe, Rl), Co) this.depthAttachment = Dl ? new Or(Qe, Rl) : new Br(Qe, Rl);
                                else if (Dl) throw new Error("Stencil cannot be set without depth");
                                if (Ll.checkFramebufferStatus(Ll.FRAMEBUFFER) !== Ll.FRAMEBUFFER_COMPLETE) throw new Error(xd);
                            }
                            destroy() {
                                const Qe = this.context.gl, rt = this.colorAttachment.get();
                                if (rt && Qe.deleteTexture(rt), this.depthAttachment) {
                                    const rt = this.depthAttachment.get();
                                    rt && Qe.deleteRenderbuffer(rt);
                                }
                                Qe.deleteFramebuffer(this.framebuffer);
                            }
                        }
                        class Nr {
                            constructor(Qe){
                                var rt, Wn;
                                if (this.gl = Qe, this.clearColor = new or(this), this.clearDepth = new ar(this), this.clearStencil = new sr(this), this.colorMask = new nr(this), this.depthMask = new lr(this), this.stencilMask = new cr(this), this.stencilFunc = new hr(this), this.stencilOp = new ur(this), this.stencilTest = new dr(this), this.depthRange = new _r(this), this.depthTest = new pr(this), this.depthFunc = new mr(this), this.blend = new fr(this), this.blendFunc = new gr(this), this.blendColor = new vr(this), this.blendEquation = new xr(this), this.cullFace = new br(this), this.cullFaceSide = new yr(this), this.frontFace = new wr(this), this.program = new Tr(this), this.activeTexture = new Pr(this), this.viewport = new Cr(this), this.bindFramebuffer = new Ir(this), this.bindRenderbuffer = new Mr(this), this.bindTexture = new Er(this), this.bindVertexBuffer = new Sr(this), this.bindElementBuffer = new Rr(this), this.bindVertexArray = new Dr(this), this.pixelStoreUnpack = new zr(this), this.pixelStoreUnpackPremultiplyAlpha = new Ar(this), this.pixelStoreUnpackFlipY = new Lr(this), this.extTextureFilterAnisotropic = Qe.getExtension("EXT_texture_filter_anisotropic") || Qe.getExtension("MOZ_EXT_texture_filter_anisotropic") || Qe.getExtension("WEBKIT_EXT_texture_filter_anisotropic"), this.extTextureFilterAnisotropic && (this.extTextureFilterAnisotropicMax = Qe.getParameter(this.extTextureFilterAnisotropic.MAX_TEXTURE_MAX_ANISOTROPY_EXT)), this.maxTextureSize = Qe.getParameter(Qe.MAX_TEXTURE_SIZE), Ut(Qe)) {
                                    this.HALF_FLOAT = Qe.HALF_FLOAT;
                                    const Co = Qe.getExtension("EXT_color_buffer_half_float");
                                    this.RGBA16F = null !== (rt = Qe.RGBA16F) && void 0 !== rt ? rt : null == Co ? void 0 : Co.RGBA16F_EXT, this.RGB16F = null !== (Wn = Qe.RGB16F) && void 0 !== Wn ? Wn : null == Co ? void 0 : Co.RGB16F_EXT, Qe.getExtension("EXT_color_buffer_float");
                                } else {
                                    Qe.getExtension("EXT_color_buffer_half_float"), Qe.getExtension("OES_texture_half_float_linear");
                                    const rt = Qe.getExtension("OES_texture_half_float");
                                    this.HALF_FLOAT = null == rt ? void 0 : rt.HALF_FLOAT_OES;
                                }
                            }
                            setDefault() {
                                this.unbindVAO(), this.clearColor.setDefault(), this.clearDepth.setDefault(), this.clearStencil.setDefault(), this.colorMask.setDefault(), this.depthMask.setDefault(), this.stencilMask.setDefault(), this.stencilFunc.setDefault(), this.stencilOp.setDefault(), this.stencilTest.setDefault(), this.depthRange.setDefault(), this.depthTest.setDefault(), this.depthFunc.setDefault(), this.blend.setDefault(), this.blendFunc.setDefault(), this.blendColor.setDefault(), this.blendEquation.setDefault(), this.cullFace.setDefault(), this.cullFaceSide.setDefault(), this.frontFace.setDefault(), this.program.setDefault(), this.activeTexture.setDefault(), this.bindFramebuffer.setDefault(), this.pixelStoreUnpack.setDefault(), this.pixelStoreUnpackPremultiplyAlpha.setDefault(), this.pixelStoreUnpackFlipY.setDefault();
                            }
                            setDirty() {
                                this.clearColor.dirty = !0, this.clearDepth.dirty = !0, this.clearStencil.dirty = !0, this.colorMask.dirty = !0, this.depthMask.dirty = !0, this.stencilMask.dirty = !0, this.stencilFunc.dirty = !0, this.stencilOp.dirty = !0, this.stencilTest.dirty = !0, this.depthRange.dirty = !0, this.depthTest.dirty = !0, this.depthFunc.dirty = !0, this.blend.dirty = !0, this.blendFunc.dirty = !0, this.blendColor.dirty = !0, this.blendEquation.dirty = !0, this.cullFace.dirty = !0, this.cullFaceSide.dirty = !0, this.frontFace.dirty = !0, this.program.dirty = !0, this.activeTexture.dirty = !0, this.viewport.dirty = !0, this.bindFramebuffer.dirty = !0, this.bindRenderbuffer.dirty = !0, this.bindTexture.dirty = !0, this.bindVertexBuffer.dirty = !0, this.bindElementBuffer.dirty = !0, this.bindVertexArray.dirty = !0, this.pixelStoreUnpack.dirty = !0, this.pixelStoreUnpackPremultiplyAlpha.dirty = !0, this.pixelStoreUnpackFlipY.dirty = !0;
                            }
                            createIndexBuffer(Qe, rt) {
                                return new er(this, Qe, rt);
                            }
                            createVertexBuffer(Qe, rt, Wn) {
                                return new ir(this, Qe, rt, Wn);
                            }
                            createRenderbuffer(Qe, rt, Wn) {
                                const Co = this.gl, Dl = Co.createRenderbuffer();
                                return this.bindRenderbuffer.set(Dl), Co.renderbufferStorage(Co.RENDERBUFFER, Qe, rt, Wn), this.bindRenderbuffer.set(null), Dl;
                            }
                            createFramebuffer(Qe, rt, Wn, Co) {
                                return new Zr(this, Qe, rt, Wn, Co);
                            }
                            clear({ color: Qe, depth: rt, stencil: Wn }) {
                                const Co = this.gl;
                                let Dl = 0;
                                Qe && (Dl |= Co.COLOR_BUFFER_BIT, this.clearColor.set(Qe), this.colorMask.set([
                                    !0,
                                    !0,
                                    !0,
                                    !0
                                ])), void 0 !== rt && (Dl |= Co.DEPTH_BUFFER_BIT, this.depthRange.set([
                                    0,
                                    1
                                ]), this.clearDepth.set(rt), this.depthMask.set(!0)), void 0 !== Wn && (Dl |= Co.STENCIL_BUFFER_BIT, this.clearStencil.set(Wn), this.stencilMask.set(255)), Co.clear(Dl);
                            }
                            setCullFace(Qe) {
                                !1 === Qe.enable ? this.cullFace.set(!1) : (this.cullFace.set(!0), this.cullFaceSide.set(Qe.mode), this.frontFace.set(Qe.frontFace));
                            }
                            setDepthMode(Qe) {
                                Qe.func !== this.gl.ALWAYS || Qe.mask ? (this.depthTest.set(!0), this.depthFunc.set(Qe.func), this.depthMask.set(Qe.mask), this.depthRange.set(Qe.range)) : this.depthTest.set(!1);
                            }
                            setStencilMode(Qe) {
                                Qe.test.func !== this.gl.ALWAYS || Qe.mask ? (this.stencilTest.set(!0), this.stencilMask.set(Qe.mask), this.stencilOp.set([
                                    Qe.fail,
                                    Qe.depthFail,
                                    Qe.pass
                                ]), this.stencilFunc.set({
                                    func: Qe.test.func,
                                    ref: Qe.ref,
                                    mask: Qe.test.mask
                                })) : this.stencilTest.set(!1);
                            }
                            setColorMode(Qe) {
                                rt.bC(Qe.blendFunction, Ft.Replace) ? this.blend.set(!1) : (this.blend.set(!0), this.blendFunc.set(Qe.blendFunction), this.blendColor.set(Qe.blendColor)), this.colorMask.set(Qe.mask);
                            }
                            createVertexArray() {
                                var Qe;
                                return Ut(this.gl) ? this.gl.createVertexArray() : null === (Qe = this.gl.getExtension("OES_vertex_array_object")) || void 0 === Qe ? void 0 : Qe.createVertexArrayOES();
                            }
                            deleteVertexArray(Qe) {
                                var rt;
                                return Ut(this.gl) ? this.gl.deleteVertexArray(Qe) : null === (rt = this.gl.getExtension("OES_vertex_array_object")) || void 0 === rt ? void 0 : rt.deleteVertexArrayOES(Qe);
                            }
                            unbindVAO() {
                                this.bindVertexArray.set(null);
                            }
                        }
                        let bd;
                        function Ur(Qe, Wn, Co, Dl, Ll) {
                            const Rl = Qe.context, Ul = Qe.transform, Gl = Rl.gl, Zl = Qe.useProgram("collisionBox"), Hl = [];
                            let ql = 0, Ql = 0;
                            for(let rt = 0; rt < Dl.length; rt++){
                                const Kl = Dl[rt], $l = Wn.getTile(Kl).getBucket(Co);
                                if (!$l) continue;
                                const Tc = Ll ? $l.textCollisionBox : $l.iconCollisionBox, tu = $l.collisionCircleArray;
                                tu.length > 0 && (Hl.push({
                                    circleArray: tu,
                                    circleOffset: Ql,
                                    coord: Kl
                                }), ql += tu.length / 4, Ql = ql), Tc && Zl.draw(Rl, Gl.LINES, jt.disabled, Nt.disabled, Qe.colorModeForRenderPass(), Ot.disabled, Di(Qe.transform), Qe.style.map.terrain && Qe.style.map.terrain.getTerrainData(Kl), Ul.getProjectionData({
                                    overscaledTileID: Kl,
                                    applyGlobeMatrix: !0,
                                    applyTerrainMatrix: !0
                                }), Co.id, Tc.layoutVertexBuffer, Tc.indexBuffer, Tc.segments, null, Qe.transform.zoom, null, null, Tc.collisionVertexBuffer);
                            }
                            if (!Ll || !Hl.length) return;
                            const Kl = Qe.useProgram("collisionCircle"), $l = new rt.bP;
                            $l.resize(4 * ql), $l._trim();
                            let Tc = 0;
                            for (const rt of Hl)for(let Qe = 0; Qe < rt.circleArray.length / 4; Qe++){
                                const Wn = 4 * Qe, Co = rt.circleArray[Wn + 0], Dl = rt.circleArray[Wn + 1], Ll = rt.circleArray[Wn + 2], Rl = rt.circleArray[Wn + 3];
                                $l.emplace(Tc++, Co, Dl, Ll, Rl, 0), $l.emplace(Tc++, Co, Dl, Ll, Rl, 1), $l.emplace(Tc++, Co, Dl, Ll, Rl, 2), $l.emplace(Tc++, Co, Dl, Ll, Rl, 3);
                            }
                            (!bd || bd.length < 2 * ql) && (bd = function(Qe) {
                                const Wn = 2 * Qe, Co = new rt.bR;
                                Co.resize(Wn), Co._trim();
                                for(let rt = 0; rt < Wn; rt++){
                                    const Qe = 6 * rt;
                                    Co.uint16[Qe + 0] = 4 * rt + 0, Co.uint16[Qe + 1] = 4 * rt + 1, Co.uint16[Qe + 2] = 4 * rt + 2, Co.uint16[Qe + 3] = 4 * rt + 2, Co.uint16[Qe + 4] = 4 * rt + 3, Co.uint16[Qe + 5] = 4 * rt + 0;
                                }
                                return Co;
                            }(ql));
                            const tu = Rl.createIndexBuffer(bd, !0), lu = Rl.createVertexBuffer($l, rt.bQ.members, !0);
                            for (const du of Hl){
                                const Wn = zi(Qe.transform);
                                Kl.draw(Rl, Gl.TRIANGLES, jt.disabled, Nt.disabled, Qe.colorModeForRenderPass(), Ot.disabled, Wn, Qe.style.map.terrain && Qe.style.map.terrain.getTerrainData(du.coord), null, Co.id, lu, tu, rt.aG.simpleSegment(0, 2 * du.circleOffset, du.circleArray.length, du.circleArray.length / 2), null, Qe.transform.zoom, null, null, null);
                            }
                            lu.destroy(), tu.destroy();
                        }
                        const wd = rt.at(new Float32Array(16));
                        function qr(Qe, Wn, Co, Dl, Ll, Rl) {
                            const { horizontalAlign: Ul, verticalAlign: Gl } = rt.aB(Qe);
                            return new rt.P((-(Ul - .5) * Wn / Ll + Dl[0]) * Rl, (-(Gl - .5) * Co / Ll + Dl[1]) * Rl);
                        }
                        function Wr(Qe, Wn, Co, Dl, Ll, Rl) {
                            const Ul = Wn.tileAnchorPoint.add(new rt.P(Wn.translation[0], Wn.translation[1]));
                            if (Wn.pitchWithMap) {
                                let Qe = Dl.mult(Rl);
                                Co || (Qe = Qe.rotate(-Ll));
                                const rt = Ul.add(Qe);
                                return ye(rt.x, rt.y, Wn.pitchedLabelPlaneMatrix, Wn.getElevation).point;
                            }
                            if (Co) {
                                const rt = Re(Wn.tileAnchorPoint.x + 1, Wn.tileAnchorPoint.y, Wn).point.sub(Qe), Co = Math.atan(rt.y / rt.x) + (rt.x < 0 ? Math.PI : 0);
                                return Qe.add(Dl.rotate(Co));
                            }
                            return Qe.add(Dl);
                        }
                        function $r(Qe, Wn, Co, Dl, Ll, Rl, Ul, Gl, Zl, Hl, ql, Ql) {
                            const Kl = Qe.text.placedSymbolArray, $l = Qe.text.dynamicLayoutVertexArray, Tc = Qe.icon.dynamicLayoutVertexArray, tu = {};
                            $l.clear();
                            for(let lu = 0; lu < Kl.length; lu++){
                                const Tc = Kl.get(lu), du = Tc.hidden || !Tc.crossTileID || Qe.allowVerticalPlacement && !Tc.placedOrientation ? null : Dl[Tc.crossTileID];
                                if (du) {
                                    const Dl = new rt.P(Tc.anchorX, Tc.anchorY), Kl = {
                                        getElevation: Ql,
                                        width: Ll.width,
                                        height: Ll.height,
                                        pitchedLabelPlaneMatrix: Rl,
                                        pitchWithMap: Co,
                                        transform: Ll,
                                        tileAnchorPoint: Dl,
                                        translation: Hl,
                                        unwrappedTileID: ql
                                    }, lu = Co ? ze(Dl.x, Dl.y, Kl) : Re(Dl.x, Dl.y, Kl), fu = we(Ll.cameraToCenterDistance, lu.signedDistanceFromCamera);
                                    let yu = rt.ai(Qe.textSizeData, Gl, Tc) * fu / rt.av;
                                    Co && (yu *= Qe.tilePixelRatio / Ul);
                                    const { width: Eu, height: Tu, anchor: Lu, textOffset: Zu, textBoxScale: Xu } = du, Ju = qr(Lu, Eu, Tu, Zu, Xu, yu), $u = Ll.getPitchedTextCorrection(Dl.x + Hl[0], Dl.y + Hl[1], ql), ed = Wr(lu.point, Kl, Wn, Ju, -Ll.bearingInRadians, $u), td = Qe.allowVerticalPlacement && Tc.placedOrientation === rt.ah.vertical ? Math.PI / 2 : 0;
                                    for(let Qe = 0; Qe < Tc.numGlyphs; Qe++)rt.ao($l, ed, td);
                                    Zl && Tc.associatedIconIndex >= 0 && (tu[Tc.associatedIconIndex] = {
                                        shiftedAnchor: ed,
                                        angle: td
                                    });
                                } else Be(Tc.numGlyphs, $l);
                            }
                            if (Zl) {
                                Tc.clear();
                                const Wn = Qe.icon.placedSymbolArray;
                                for(let Qe = 0; Qe < Wn.length; Qe++){
                                    const Co = Wn.get(Qe);
                                    if (Co.hidden) Be(Co.numGlyphs, Tc);
                                    else {
                                        const Wn = tu[Qe];
                                        if (Wn) for(let Qe = 0; Qe < Co.numGlyphs; Qe++)rt.ao(Tc, Wn.shiftedAnchor, Wn.angle);
                                        else Be(Co.numGlyphs, Tc);
                                    }
                                }
                                Qe.icon.dynamicLayoutVertexBuffer.updateData(Tc);
                            }
                            Qe.text.dynamicLayoutVertexBuffer.updateData($l);
                        }
                        function Hr(Qe, rt, Wn) {
                            return Wn.iconsInText && rt ? "symbolTextAndIcon" : Qe ? "symbolSDF" : "symbolIcon";
                        }
                        function Kr(Qe, Wn, Co, Dl, Ll, Rl, Ul, Gl, Zl, Hl, ql, Ql, Kl) {
                            const $l = Qe.context, Tc = $l.gl, tu = Qe.transform, lu = "map" === Gl, du = "map" === Zl, fu = "viewport" !== Gl && "point" !== Co.layout.get("symbol-placement"), yu = lu && !du && !fu, Eu = !Co.layout.get("symbol-sort-key").isConstant();
                            let Tu = !1;
                            const Lu = Qe.getDepthModeForSublayer(0, jt.ReadOnly), Zu = Co._unevaluatedLayout.hasValue("text-variable-anchor") || Co._unevaluatedLayout.hasValue("text-variable-anchor-offset"), Xu = [], Ju = tu.getCircleRadiusCorrection();
                            for (const $u of Dl){
                                const Dl = Wn.getTile($u), Gl = Dl.getBucket(Co);
                                if (!Gl) continue;
                                const Zl = Ll ? Gl.text : Gl.icon;
                                if (!Zl || !Zl.segments.get().length || !Zl.hasVisibleVertices) continue;
                                const ql = Zl.programConfigurations.get(Co.id), Ql = Ll || Gl.sdfIcons, $l = Ll ? Gl.textSizeData : Gl.iconSizeData, Lu = du || 0 !== tu.pitch, ed = Qe.useProgram(Hr(Ql, Ll, Gl), ql), td = rt.ag($l, tu.zoom), id = Qe.style.map.terrain && Qe.style.map.terrain.getTerrainData($u);
                                let nd, rd, sd, ad, od = [
                                    0,
                                    0
                                ], ld = null;
                                if (Ll) rd = Dl.glyphAtlasTexture, sd = Tc.LINEAR, nd = Dl.glyphAtlasTexture.size, Gl.iconsInText && (od = Dl.imageAtlasTexture.size, ld = Dl.imageAtlasTexture, ad = Lu || Qe.options.rotating || Qe.options.zooming || "composite" === $l.kind || "camera" === $l.kind ? Tc.LINEAR : Tc.NEAREST);
                                else {
                                    const rt = 1 !== Co.layout.get("icon-size").constantOr(0) || Gl.iconsNeedLinear;
                                    rd = Dl.imageAtlasTexture, sd = Ql || Qe.options.rotating || Qe.options.zooming || rt || Lu ? Tc.LINEAR : Tc.NEAREST, nd = Dl.imageAtlasTexture.size;
                                }
                                const cd = rt.aw(Dl, 1, Qe.transform.zoom), ud = ve(lu, Qe.transform, cd), hd = rt.K();
                                rt.aj(hd, ud);
                                const dd = xe(du, lu, Qe.transform, cd), pd = rt.ax(tu, Dl, Rl, Ul), md = tu.getProjectionData({
                                    overscaledTileID: $u,
                                    applyGlobeMatrix: !Kl,
                                    applyTerrainMatrix: !0
                                }), fd = Zu && Gl.hasTextData(), gd = "none" !== Co.layout.get("icon-text-fit") && fd && Gl.hasIconData();
                                if (fu) {
                                    const rt = Qe.style.map.terrain ? (rt, Wn)=>Qe.style.map.terrain.getElevation($u, rt, Wn) : null, Wn = "map" === Co.layout.get("text-rotation-alignment");
                                    Pe(Gl, Qe, Ll, ud, hd, du, Hl, Wn, $u.toUnwrapped(), tu.width, tu.height, pd, rt);
                                }
                                const Ad = Ll && Zu || gd, yd = fu || Ad ? wd : du ? ud : Qe.transform.clipSpaceToPixelsMatrix, vd = Ql && 0 !== Co.paint.get(Ll ? "text-halo-width" : "icon-halo-width").constantOr(1);
                                let _d;
                                _d = Ql ? Gl.iconsInText ? Ki($l.kind, td, yu, du, fu, Ad, Qe, yd, dd, pd, nd, od, Ju) : Hi($l.kind, td, yu, du, fu, Ad, Qe, yd, dd, pd, Ll, nd, 0, Ju) : $i($l.kind, td, yu, du, fu, Ad, Qe, yd, dd, pd, Ll, nd, Ju);
                                const xd = {
                                    program: ed,
                                    buffers: Zl,
                                    uniformValues: _d,
                                    projectionData: md,
                                    atlasTexture: rd,
                                    atlasTextureIcon: ld,
                                    atlasInterpolation: sd,
                                    atlasInterpolationIcon: ad,
                                    isSDF: Ql,
                                    hasHalo: vd
                                };
                                if (Eu && Gl.canOverlap) {
                                    Tu = !0;
                                    const Qe = Zl.segments.get();
                                    for (const Wn of Qe)Xu.push({
                                        segments: new rt.aG([
                                            Wn
                                        ]),
                                        sortKey: Wn.sortKey,
                                        state: xd,
                                        terrainData: id
                                    });
                                } else Xu.push({
                                    segments: Zl.segments,
                                    sortKey: 0,
                                    state: xd,
                                    terrainData: id
                                });
                            }
                            Tu && Xu.sort((Qe, rt)=>Qe.sortKey - rt.sortKey);
                            for (const rt of Xu){
                                const Wn = rt.state;
                                if ($l.activeTexture.set(Tc.TEXTURE0), Wn.atlasTexture.bind(Wn.atlasInterpolation, Tc.CLAMP_TO_EDGE), Wn.atlasTextureIcon && ($l.activeTexture.set(Tc.TEXTURE1), Wn.atlasTextureIcon && Wn.atlasTextureIcon.bind(Wn.atlasInterpolationIcon, Tc.CLAMP_TO_EDGE)), Wn.isSDF) {
                                    const Dl = Wn.uniformValues;
                                    Wn.hasHalo && (Dl.u_is_halo = 1, Xr(Wn.buffers, rt.segments, Co, Qe, Wn.program, Lu, ql, Ql, Dl, Wn.projectionData, rt.terrainData)), Dl.u_is_halo = 0;
                                }
                                Xr(Wn.buffers, rt.segments, Co, Qe, Wn.program, Lu, ql, Ql, Wn.uniformValues, Wn.projectionData, rt.terrainData);
                            }
                        }
                        function Xr(Qe, rt, Wn, Co, Dl, Ll, Rl, Ul, Gl, Zl, Hl) {
                            const ql = Co.context;
                            Dl.draw(ql, ql.gl.TRIANGLES, Ll, Rl, Ul, Ot.backCCW, Gl, Hl, Zl, Wn.id, Qe.layoutVertexBuffer, Qe.indexBuffer, rt, Wn.paint, Co.transform.zoom, Qe.programConfigurations.get(Wn.id), Qe.dynamicLayoutVertexBuffer, Qe.opacityVertexBuffer);
                        }
                        function Qr(Qe, Wn, Co, Dl, Ll) {
                            const Rl = Qe.context, Ul = Rl.gl, Gl = Nt.disabled, Zl = new Ft([
                                Ul.ONE,
                                Ul.ONE
                            ], rt.b7.transparent, [
                                !0,
                                !0,
                                !0,
                                !0
                            ]), Hl = Wn.getBucket(Co);
                            if (!Hl) return;
                            const ql = Dl.key;
                            let Ql = Co.heatmapFbos.get(ql);
                            Ql || (Ql = Jr(Rl, Wn.tileSize, Wn.tileSize), Co.heatmapFbos.set(ql, Ql)), Rl.bindFramebuffer.set(Ql.framebuffer), Rl.viewport.set([
                                0,
                                0,
                                Wn.tileSize,
                                Wn.tileSize
                            ]), Rl.clear({
                                color: rt.b7.transparent
                            });
                            const Kl = Hl.programConfigurations.get(Co.id), $l = Qe.useProgram("heatmap", Kl, !Ll), Tc = Qe.transform.getProjectionData({
                                overscaledTileID: Wn.tileID,
                                applyGlobeMatrix: !0,
                                applyTerrainMatrix: !0
                            }), tu = Qe.style.map.terrain.getTerrainData(Dl);
                            $l.draw(Rl, Ul.TRIANGLES, jt.disabled, Gl, Zl, Ot.disabled, Li(Wn, Qe.transform.zoom, Co.paint.get("heatmap-intensity"), 1), tu, Tc, Co.id, Hl.layoutVertexBuffer, Hl.indexBuffer, Hl.segments, Co.paint, Qe.transform.zoom, Kl);
                        }
                        function Yr(Qe, rt, Wn, Co, Dl) {
                            const Ll = Qe.context, Rl = Ll.gl, Ul = Qe.transform;
                            Ll.setColorMode(Qe.colorModeForRenderPass());
                            const Gl = eo(Ll, rt), Zl = Wn.key, Hl = rt.heatmapFbos.get(Zl);
                            if (!Hl) return;
                            Ll.activeTexture.set(Rl.TEXTURE0), Rl.bindTexture(Rl.TEXTURE_2D, Hl.colorAttachment.get()), Ll.activeTexture.set(Rl.TEXTURE1), Gl.bind(Rl.LINEAR, Rl.CLAMP_TO_EDGE);
                            const ql = Ul.getProjectionData({
                                overscaledTileID: Wn,
                                applyTerrainMatrix: Dl,
                                applyGlobeMatrix: !Co
                            });
                            Qe.useProgram("heatmapTexture").draw(Ll, Rl.TRIANGLES, jt.disabled, Nt.disabled, Qe.colorModeForRenderPass(), Ot.disabled, ki(Qe, rt, 0, 1), null, ql, rt.id, Qe.rasterBoundsBuffer, Qe.quadTriangleIndexBuffer, Qe.rasterBoundsSegments, rt.paint, Ul.zoom), Hl.destroy(), rt.heatmapFbos.delete(Zl);
                        }
                        function Jr(Qe, rt, Wn) {
                            var Co, Dl;
                            const Ll = Qe.gl, Rl = Ll.createTexture();
                            Ll.bindTexture(Ll.TEXTURE_2D, Rl), Ll.texParameteri(Ll.TEXTURE_2D, Ll.TEXTURE_WRAP_S, Ll.CLAMP_TO_EDGE), Ll.texParameteri(Ll.TEXTURE_2D, Ll.TEXTURE_WRAP_T, Ll.CLAMP_TO_EDGE), Ll.texParameteri(Ll.TEXTURE_2D, Ll.TEXTURE_MIN_FILTER, Ll.LINEAR), Ll.texParameteri(Ll.TEXTURE_2D, Ll.TEXTURE_MAG_FILTER, Ll.LINEAR);
                            const Ul = null !== (Co = Qe.HALF_FLOAT) && void 0 !== Co ? Co : Ll.UNSIGNED_BYTE, Gl = null !== (Dl = Qe.RGBA16F) && void 0 !== Dl ? Dl : Ll.RGBA;
                            Ll.texImage2D(Ll.TEXTURE_2D, 0, Gl, rt, Wn, 0, Ll.RGBA, Ul, null);
                            const Zl = Qe.createFramebuffer(rt, Wn, !1, !1);
                            return Zl.colorAttachment.set(Rl), Zl;
                        }
                        function eo(Qe, rt) {
                            return rt.colorRampTexture || (rt.colorRampTexture = new v(Qe, rt.colorRamp, Qe.gl.RGBA)), rt.colorRampTexture;
                        }
                        function to(Qe, rt, Wn, Co, Dl) {
                            if (!Wn || !Co || !Co.imageAtlas) return;
                            const Ll = Co.imageAtlas.patternPositions;
                            let Rl = Ll[Wn.to.toString()], Ul = Ll[Wn.from.toString()];
                            if (!Rl && Ul && (Rl = Ul), !Ul && Rl && (Ul = Rl), !Rl || !Ul) {
                                const Qe = Dl.getPaintProperty(rt);
                                Rl = Ll[Qe], Ul = Ll[Qe];
                            }
                            Rl && Ul && Qe.setConstantPatternPositions(Rl, Ul);
                        }
                        function io(Qe, Wn, Co, Dl, Ll, Rl, Ul, Gl) {
                            const Zl = Qe.context.gl, Hl = "fill-pattern", ql = Co.paint.get(Hl), Ql = ql && ql.constantOr(1), Kl = Co.getCrossfadeParameters();
                            let $l, Tc, tu, lu, du;
                            const fu = Qe.transform, yu = Co.paint.get("fill-translate"), Eu = Co.paint.get("fill-translate-anchor");
                            Ul ? (Tc = Ql && !Co.getPaintProperty("fill-outline-color") ? "fillOutlinePattern" : "fillOutline", $l = Zl.LINES) : (Tc = Ql ? "fillPattern" : "fill", $l = Zl.TRIANGLES);
                            const Tu = ql.constantOr(null);
                            for (const Lu of Dl){
                                const ql = Wn.getTile(Lu);
                                if (Ql && !ql.patternsLoaded()) continue;
                                const Zu = ql.getBucket(Co);
                                if (!Zu) continue;
                                const Xu = Zu.programConfigurations.get(Co.id), Ju = Qe.useProgram(Tc, Xu), $u = Qe.style.map.terrain && Qe.style.map.terrain.getTerrainData(Lu);
                                Ql && (Qe.context.activeTexture.set(Zl.TEXTURE0), ql.imageAtlasTexture.bind(Zl.LINEAR, Zl.CLAMP_TO_EDGE), Xu.updatePaintBuffers(Kl)), to(Xu, Hl, Tu, ql, Co);
                                const ed = fu.getProjectionData({
                                    overscaledTileID: Lu,
                                    applyGlobeMatrix: !Gl,
                                    applyTerrainMatrix: !0
                                }), td = rt.ax(fu, ql, yu, Eu);
                                if (Ul) {
                                    lu = Zu.indexBuffer2, du = Zu.segments2;
                                    const rt = [
                                        Zl.drawingBufferWidth,
                                        Zl.drawingBufferHeight
                                    ];
                                    tu = "fillOutlinePattern" === Tc && Ql ? Si(Qe, Kl, ql, rt, td) : Ei(rt, td);
                                } else lu = Zu.indexBuffer, du = Zu.segments, tu = Ql ? Mi(Qe, Kl, ql, td) : {
                                    u_fill_translate: td
                                };
                                let id;
                                if ("translucent" === Qe.renderPass && Gl) {
                                    const [rt] = Qe.getStencilConfigForOverlapAndUpdateStencilID(Dl);
                                    id = rt[Lu.overscaledZ];
                                } else id = Qe.stencilModeForClipping(Lu);
                                Ju.draw(Qe.context, $l, Ll, id, Rl, Ot.backCCW, tu, $u, ed, Co.id, Zu.layoutVertexBuffer, lu, du, Co.paint, Qe.transform.zoom, Xu);
                            }
                        }
                        function ro(Qe, Wn, Co, Dl, Ll, Rl, Ul, Gl) {
                            const Zl = Qe.context, Hl = Zl.gl, ql = "fill-extrusion-pattern", Ql = Co.paint.get(ql), Kl = Ql.constantOr(1), $l = Co.getCrossfadeParameters(), Tc = Co.paint.get("fill-extrusion-opacity"), tu = Ql.constantOr(null), lu = Qe.transform;
                            for (const du of Dl){
                                const Dl = Wn.getTile(du), Ql = Dl.getBucket(Co);
                                if (!Ql) continue;
                                const fu = Qe.style.map.terrain && Qe.style.map.terrain.getTerrainData(du), yu = Ql.programConfigurations.get(Co.id), Eu = Qe.useProgram(Kl ? "fillExtrusionPattern" : "fillExtrusion", yu);
                                Kl && (Qe.context.activeTexture.set(Hl.TEXTURE0), Dl.imageAtlasTexture.bind(Hl.LINEAR, Hl.CLAMP_TO_EDGE), yu.updatePaintBuffers($l));
                                const Tu = lu.getProjectionData({
                                    overscaledTileID: du,
                                    applyGlobeMatrix: !Gl,
                                    applyTerrainMatrix: !0
                                });
                                to(yu, ql, tu, Dl, Co);
                                const Lu = rt.ax(lu, Dl, Co.paint.get("fill-extrusion-translate"), Co.paint.get("fill-extrusion-translate-anchor")), Zu = Co.paint.get("fill-extrusion-vertical-gradient"), Xu = Kl ? Ii(Qe, Zu, Tc, Lu, du, $l, Dl) : Ci(Qe, Zu, Tc, Lu);
                                Eu.draw(Zl, Zl.gl.TRIANGLES, Ll, Rl, Ul, Ot.backCCW, Xu, fu, Tu, Co.id, Ql.layoutVertexBuffer, Ql.indexBuffer, Ql.segments, Co.paint, Qe.transform.zoom, yu, Qe.style.map.terrain && Ql.centroidVertexBuffer);
                            }
                        }
                        function oo(Qe, rt, Wn, Co, Dl, Ll, Rl, Ul, Gl) {
                            var Zl;
                            const Hl = Qe.style.projection, ql = Qe.context, Ql = Qe.transform, Kl = ql.gl, $l = Qe.useProgram("hillshade"), Tc = !Qe.options.moving;
                            for (const tu of Co){
                                const Co = rt.getTile(tu), lu = Co.fbo;
                                if (!lu) continue;
                                const du = Hl.getMeshFromTileID(ql, tu.canonical, Ul, !0, "raster"), fu = null === (Zl = Qe.style.map.terrain) || void 0 === Zl ? void 0 : Zl.getTerrainData(tu);
                                ql.activeTexture.set(Kl.TEXTURE0), Kl.bindTexture(Kl.TEXTURE_2D, lu.colorAttachment.get());
                                const yu = Ql.getProjectionData({
                                    overscaledTileID: tu,
                                    aligned: Tc,
                                    applyGlobeMatrix: !Gl,
                                    applyTerrainMatrix: !0
                                });
                                $l.draw(ql, Kl.TRIANGLES, Ll, Dl[tu.overscaledZ], Rl, Ot.backCCW, Fi(Qe, Co, Wn), fu, yu, Wn.id, du.vertexBuffer, du.indexBuffer, du.segments);
                            }
                        }
                        const Ed = [
                            new rt.P(0, 0),
                            new rt.P(rt.Z, 0),
                            new rt.P(rt.Z, rt.Z),
                            new rt.P(0, rt.Z)
                        ];
                        function so(Qe, rt, Wn, Co, Dl, Ll, Rl, Ul, Gl = !1, Zl = !1) {
                            const Hl = Co[Co.length - 1].overscaledZ, ql = Qe.context, Ql = ql.gl, Kl = Qe.useProgram("raster"), $l = Qe.transform, Tc = Qe.style.projection, tu = Qe.colorModeForRenderPass(), lu = !Qe.options.moving;
                            for (const du of Co){
                                const Co = Qe.getDepthModeForSublayer(du.overscaledZ - Hl, 1 === Wn.paint.get("raster-opacity") ? jt.ReadWrite : jt.ReadOnly, Ql.LESS), fu = rt.getTile(du);
                                fu.registerFadeDuration(Wn.paint.get("raster-fade-duration"));
                                const yu = rt.findLoadedParent(du, 0), Eu = rt.findLoadedSibling(du), Tu = no(fu, yu || Eu || null, rt, Wn, Qe.transform, Qe.style.map.terrain);
                                let Lu, Zu;
                                const Xu = "nearest" === Wn.paint.get("raster-resampling") ? Ql.NEAREST : Ql.LINEAR;
                                ql.activeTexture.set(Ql.TEXTURE0), fu.texture.bind(Xu, Ql.CLAMP_TO_EDGE, Ql.LINEAR_MIPMAP_NEAREST), ql.activeTexture.set(Ql.TEXTURE1), yu ? (yu.texture.bind(Xu, Ql.CLAMP_TO_EDGE, Ql.LINEAR_MIPMAP_NEAREST), Lu = Math.pow(2, yu.tileID.overscaledZ - fu.tileID.overscaledZ), Zu = [
                                    fu.tileID.canonical.x * Lu % 1,
                                    fu.tileID.canonical.y * Lu % 1
                                ]) : fu.texture.bind(Xu, Ql.CLAMP_TO_EDGE, Ql.LINEAR_MIPMAP_NEAREST), fu.texture.useMipmap && ql.extTextureFilterAnisotropic && Qe.transform.pitch > 20 && Ql.texParameterf(Ql.TEXTURE_2D, ql.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, ql.extTextureFilterAnisotropicMax);
                                const Ju = Qe.style.map.terrain && Qe.style.map.terrain.getTerrainData(du), $u = $l.getProjectionData({
                                    overscaledTileID: du,
                                    aligned: lu,
                                    applyGlobeMatrix: !Zl,
                                    applyTerrainMatrix: !0
                                }), ed = qi(Zu || [
                                    0,
                                    0
                                ], Lu || 1, Tu, Wn, Ul), td = Tc.getMeshFromTileID(ql, du.canonical, Ll, Rl, "raster");
                                Kl.draw(ql, Ql.TRIANGLES, Co, Dl ? Dl[du.overscaledZ] : Nt.disabled, tu, Gl ? Ot.frontCCW : Ot.backCCW, ed, Ju, $u, Wn.id, td.vertexBuffer, td.indexBuffer, td.segments);
                            }
                        }
                        function no(Qe, Wn, Co, Dl, Rl, Ul) {
                            const Gl = Dl.paint.get("raster-fade-duration");
                            if (!Ul && Gl > 0) {
                                const Dl = Ll.now(), Ul = (Dl - Qe.timeAdded) / Gl, Zl = Wn ? (Dl - Wn.timeAdded) / Gl : -1, Hl = Co.getSource(), ql = he(Rl, {
                                    tileSize: Hl.tileSize,
                                    roundZoom: Hl.roundZoom
                                }), Ql = !Wn || Math.abs(Wn.tileID.overscaledZ - ql) > Math.abs(Qe.tileID.overscaledZ - ql), Kl = Ql && Qe.refreshedUponExpiration ? 1 : rt.ae(Ql ? Ul : 1 - Zl, 0, 1);
                                return Qe.refreshedUponExpiration && Ul >= 1 && (Qe.refreshedUponExpiration = !1), Wn ? {
                                    opacity: 1,
                                    mix: 1 - Kl
                                } : {
                                    opacity: Kl,
                                    mix: 0
                                };
                            }
                            return {
                                opacity: 1,
                                mix: 0
                            };
                        }
                        const Md = new rt.b7(1, 0, 0, 1), Sd = new rt.b7(0, 1, 0, 1), Td = new rt.b7(0, 0, 1, 1), Cd = new rt.b7(1, 0, 1, 1), kd = new rt.b7(0, 1, 1, 1);
                        function po(Qe, rt, Wn, Co) {
                            fo(Qe, 0, rt + Wn / 2, Qe.transform.width, Wn, Co);
                        }
                        function mo(Qe, rt, Wn, Co) {
                            fo(Qe, rt - Wn / 2, 0, Wn, Qe.transform.height, Co);
                        }
                        function fo(Qe, rt, Wn, Co, Dl, Ll) {
                            const Rl = Qe.context, Ul = Rl.gl;
                            Ul.enable(Ul.SCISSOR_TEST), Ul.scissor(rt * Qe.pixelRatio, Wn * Qe.pixelRatio, Co * Qe.pixelRatio, Dl * Qe.pixelRatio), Rl.clear({
                                color: Ll
                            }), Ul.disable(Ul.SCISSOR_TEST);
                        }
                        function go(Qe, Wn, Co) {
                            const Dl = Qe.context, Ll = Dl.gl, Rl = Qe.useProgram("debug"), Ul = jt.disabled, Gl = Nt.disabled, Zl = Qe.colorModeForRenderPass(), Hl = "$debug", ql = Qe.style.map.terrain && Qe.style.map.terrain.getTerrainData(Co);
                            Dl.activeTexture.set(Ll.TEXTURE0);
                            const Ql = Wn.getTileByID(Co.key).latestRawTileData, Kl = Math.floor((Ql && Ql.byteLength || 0) / 1024), $l = Wn.getTile(Co).tileSize, Tc = 512 / Math.min($l, 512) * (Co.overscaledZ / Qe.transform.zoom) * .5;
                            let tu = Co.canonical.toString();
                            Co.overscaledZ !== Co.canonical.z && (tu += ` => ${Co.overscaledZ}`), function(Qe, rt) {
                                Qe.initDebugOverlayCanvas();
                                const Wn = Qe.debugOverlayCanvas, Co = Qe.context.gl, Dl = Qe.debugOverlayCanvas.getContext("2d");
                                Dl.clearRect(0, 0, Wn.width, Wn.height), Dl.shadowColor = "white", Dl.shadowBlur = 2, Dl.lineWidth = 1.5, Dl.strokeStyle = "white", Dl.textBaseline = "top", Dl.font = "bold 36px Open Sans, sans-serif", Dl.fillText(rt, 5, 5), Dl.strokeText(rt, 5, 5), Qe.debugOverlayTexture.update(Wn), Qe.debugOverlayTexture.bind(Co.LINEAR, Co.CLAMP_TO_EDGE);
                            }(Qe, `${tu} ${Kl}kB`);
                            const lu = Qe.transform.getProjectionData({
                                overscaledTileID: Co,
                                applyGlobeMatrix: !0,
                                applyTerrainMatrix: !0
                            });
                            Rl.draw(Dl, Ll.TRIANGLES, Ul, Gl, Ft.alphaBlended, Ot.disabled, Ai(rt.b7.transparent, Tc), null, lu, Hl, Qe.debugBuffer, Qe.quadTriangleIndexBuffer, Qe.debugSegments), Rl.draw(Dl, Ll.LINE_STRIP, Ul, Gl, Zl, Ot.disabled, Ai(rt.b7.red), ql, lu, Hl, Qe.debugBuffer, Qe.tileBorderIndexBuffer, Qe.debugSegments);
                        }
                        function vo(Qe, rt, Wn, Co) {
                            const { isRenderingGlobe: Dl } = Co, Ll = Qe.context, Rl = Ll.gl, Ul = Qe.transform, Gl = Qe.colorModeForRenderPass(), Zl = Qe.getDepthModeFor3D(), Hl = Qe.useProgram("terrain");
                            Ll.bindFramebuffer.set(null), Ll.viewport.set([
                                0,
                                0,
                                Qe.width,
                                Qe.height
                            ]);
                            for (const ql of Wn){
                                const Wn = rt.getTerrainMesh(ql.tileID), Co = Qe.renderToTexture.getTexture(ql), Ql = rt.getTerrainData(ql.tileID);
                                Ll.activeTexture.set(Rl.TEXTURE0), Rl.bindTexture(Rl.TEXTURE_2D, Co.texture);
                                const Kl = rt.getMeshFrameDelta(Ul.zoom), $l = Ul.calculateFogMatrix(ql.tileID.toUnwrapped()), Tc = bi(Kl, $l, Qe.style.sky, Ul.pitch, Dl), tu = Ul.getProjectionData({
                                    overscaledTileID: ql.tileID,
                                    applyTerrainMatrix: !1,
                                    applyGlobeMatrix: !0
                                });
                                Hl.draw(Ll, Rl.TRIANGLES, Zl, Nt.disabled, Gl, Ot.backCCW, Tc, Ql, tu, "terrain", Wn.vertexBuffer, Wn.indexBuffer, Wn.segments);
                            }
                        }
                        function xo(Qe, Wn) {
                            if (!Wn.mesh) {
                                const Co = new rt.aF;
                                Co.emplaceBack(-1, -1), Co.emplaceBack(1, -1), Co.emplaceBack(1, 1), Co.emplaceBack(-1, 1);
                                const Dl = new rt.aH;
                                Dl.emplaceBack(0, 1, 2), Dl.emplaceBack(0, 2, 3), Wn.mesh = new pt(Qe.createVertexBuffer(Co, od.members), Qe.createIndexBuffer(Dl), rt.aG.simpleSegment(0, 0, Co.length, Dl.length));
                            }
                            return Wn.mesh;
                        }
                        class bo {
                            constructor(Qe, Wn){
                                this.context = new Nr(Qe), this.transform = Wn, this._tileTextures = {}, this.terrainFacilitator = {
                                    dirty: !0,
                                    matrix: rt.at(new Float64Array(16)),
                                    renderTime: 0
                                }, this.setup(), this.numSublayers = de.maxUnderzooming + de.maxOverzooming + 1, this.depthEpsilon = 1 / Math.pow(2, 16), this.crossTileSymbolIndex = new ht;
                            }
                            resize(Qe, rt, Wn) {
                                if (this.width = Math.floor(Qe * Wn), this.height = Math.floor(rt * Wn), this.pixelRatio = Wn, this.context.viewport.set([
                                    0,
                                    0,
                                    this.width,
                                    this.height
                                ]), this.style) for (const Co of this.style._order)this.style._layers[Co].resize();
                            }
                            setup() {
                                const Qe = this.context, Wn = new rt.aF;
                                Wn.emplaceBack(0, 0), Wn.emplaceBack(rt.Z, 0), Wn.emplaceBack(0, rt.Z), Wn.emplaceBack(rt.Z, rt.Z), this.tileExtentBuffer = Qe.createVertexBuffer(Wn, od.members), this.tileExtentSegments = rt.aG.simpleSegment(0, 0, 4, 2);
                                const Co = new rt.aF;
                                Co.emplaceBack(0, 0), Co.emplaceBack(rt.Z, 0), Co.emplaceBack(0, rt.Z), Co.emplaceBack(rt.Z, rt.Z), this.debugBuffer = Qe.createVertexBuffer(Co, od.members), this.debugSegments = rt.aG.simpleSegment(0, 0, 4, 5);
                                const Dl = new rt.bW;
                                Dl.emplaceBack(0, 0, 0, 0), Dl.emplaceBack(rt.Z, 0, rt.Z, 0), Dl.emplaceBack(0, rt.Z, 0, rt.Z), Dl.emplaceBack(rt.Z, rt.Z, rt.Z, rt.Z), this.rasterBoundsBuffer = Qe.createVertexBuffer(Dl, Ad.members), this.rasterBoundsSegments = rt.aG.simpleSegment(0, 0, 4, 2);
                                const Ll = new rt.aF;
                                Ll.emplaceBack(0, 0), Ll.emplaceBack(rt.Z, 0), Ll.emplaceBack(0, rt.Z), Ll.emplaceBack(rt.Z, rt.Z), this.rasterBoundsBufferPosOnly = Qe.createVertexBuffer(Ll, od.members), this.rasterBoundsSegmentsPosOnly = rt.aG.simpleSegment(0, 0, 4, 5);
                                const Rl = new rt.aF;
                                Rl.emplaceBack(0, 0), Rl.emplaceBack(1, 0), Rl.emplaceBack(0, 1), Rl.emplaceBack(1, 1), this.viewportBuffer = Qe.createVertexBuffer(Rl, od.members), this.viewportSegments = rt.aG.simpleSegment(0, 0, 4, 2);
                                const Ul = new rt.bX;
                                Ul.emplaceBack(0), Ul.emplaceBack(1), Ul.emplaceBack(3), Ul.emplaceBack(2), Ul.emplaceBack(0), this.tileBorderIndexBuffer = Qe.createIndexBuffer(Ul);
                                const Gl = new rt.aH;
                                Gl.emplaceBack(1, 0, 2), Gl.emplaceBack(1, 2, 3), this.quadTriangleIndexBuffer = Qe.createIndexBuffer(Gl);
                                const Zl = this.context.gl;
                                this.stencilClearMode = new Nt({
                                    func: Zl.ALWAYS,
                                    mask: 0
                                }, 0, 255, Zl.ZERO, Zl.ZERO, Zl.ZERO), this.tileExtentMesh = new pt(this.tileExtentBuffer, this.quadTriangleIndexBuffer, this.tileExtentSegments);
                            }
                            clearStencil() {
                                const Qe = this.context, Wn = Qe.gl;
                                this.nextStencilID = 1, this.currentStencilSource = void 0;
                                const Co = rt.K();
                                rt.bO(Co, 0, this.width, this.height, 0, 0, 1), rt.M(Co, Co, [
                                    Wn.drawingBufferWidth,
                                    Wn.drawingBufferHeight,
                                    0
                                ]);
                                const Dl = {
                                    mainMatrix: Co,
                                    tileMercatorCoords: [
                                        0,
                                        0,
                                        1,
                                        1
                                    ],
                                    clippingPlane: [
                                        0,
                                        0,
                                        0,
                                        0
                                    ],
                                    projectionTransition: 0,
                                    fallbackMatrix: Co
                                };
                                this.useProgram("clippingMask", null, !0).draw(Qe, Wn.TRIANGLES, jt.disabled, this.stencilClearMode, Ft.disabled, Ot.disabled, null, null, Dl, "$clipping", this.viewportBuffer, this.quadTriangleIndexBuffer, this.viewportSegments);
                            }
                            _renderTileClippingMasks(Qe, rt, Wn) {
                                if (this.currentStencilSource === Qe.source || !Qe.isTileClipped() || !rt || !rt.length) return;
                                this.currentStencilSource = Qe.source, this.nextStencilID + rt.length > 256 && this.clearStencil();
                                const Co = this.context;
                                Co.setColorMode(Ft.disabled), Co.setDepthMode(jt.disabled);
                                const Dl = {};
                                for (const Ll of rt)Dl[Ll.key] = this.nextStencilID++;
                                this._renderTileMasks(Dl, rt, Wn, !0), this._renderTileMasks(Dl, rt, Wn, !1), this._tileClippingMaskIDs = Dl;
                            }
                            _renderTileMasks(Qe, rt, Wn, Co) {
                                const Dl = this.context, Ll = Dl.gl, Rl = this.style.projection, Ul = this.transform, Gl = this.useProgram("clippingMask");
                                for (const Zl of rt){
                                    const rt = Qe[Zl.key], Hl = this.style.map.terrain && this.style.map.terrain.getTerrainData(Zl), ql = Rl.getMeshFromTileID(this.context, Zl.canonical, Co, !0, "stencil"), Ql = Ul.getProjectionData({
                                        overscaledTileID: Zl,
                                        applyGlobeMatrix: !0,
                                        applyTerrainMatrix: !0
                                    });
                                    Gl.draw(Dl, Ll.TRIANGLES, jt.disabled, new Nt({
                                        func: Ll.ALWAYS,
                                        mask: 0
                                    }, rt, 255, Ll.KEEP, Ll.KEEP, Ll.REPLACE), Ft.disabled, Wn ? Ot.disabled : Ot.backCCW, null, Hl, Ql, "$clipping", ql.vertexBuffer, ql.indexBuffer, ql.segments);
                                }
                            }
                            _renderTilesDepthBuffer() {
                                const Qe = this.context, rt = Qe.gl, Wn = this.style.projection, Co = this.transform, Dl = this.useProgram("depth"), Ll = this.getDepthModeFor3D(), Rl = ue(Co, {
                                    tileSize: Co.tileSize
                                });
                                for (const Ul of Rl){
                                    const Rl = this.style.map.terrain && this.style.map.terrain.getTerrainData(Ul), Gl = Wn.getMeshFromTileID(this.context, Ul.canonical, !0, !0, "raster"), Zl = Co.getProjectionData({
                                        overscaledTileID: Ul,
                                        applyGlobeMatrix: !0,
                                        applyTerrainMatrix: !0
                                    });
                                    Dl.draw(Qe, rt.TRIANGLES, Ll, Nt.disabled, Ft.disabled, Ot.backCCW, null, Rl, Zl, "$clipping", Gl.vertexBuffer, Gl.indexBuffer, Gl.segments);
                                }
                            }
                            stencilModeFor3D() {
                                this.currentStencilSource = void 0, this.nextStencilID + 1 > 256 && this.clearStencil();
                                const Qe = this.nextStencilID++, rt = this.context.gl;
                                return new Nt({
                                    func: rt.NOTEQUAL,
                                    mask: 255
                                }, Qe, 255, rt.KEEP, rt.KEEP, rt.REPLACE);
                            }
                            stencilModeForClipping(Qe) {
                                const rt = this.context.gl;
                                return new Nt({
                                    func: rt.EQUAL,
                                    mask: 255
                                }, this._tileClippingMaskIDs[Qe.key], 0, rt.KEEP, rt.KEEP, rt.REPLACE);
                            }
                            getStencilConfigForOverlapAndUpdateStencilID(Qe) {
                                const rt = this.context.gl, Wn = Qe.sort((Qe, rt)=>rt.overscaledZ - Qe.overscaledZ), Co = Wn[Wn.length - 1].overscaledZ, Dl = Wn[0].overscaledZ - Co + 1;
                                if (Dl > 1) {
                                    this.currentStencilSource = void 0, this.nextStencilID + Dl > 256 && this.clearStencil();
                                    const Qe = {};
                                    for(let Wn = 0; Wn < Dl; Wn++)Qe[Wn + Co] = new Nt({
                                        func: rt.GEQUAL,
                                        mask: 255
                                    }, Wn + this.nextStencilID, 255, rt.KEEP, rt.KEEP, rt.REPLACE);
                                    return this.nextStencilID += Dl, [
                                        Qe,
                                        Wn
                                    ];
                                }
                                return [
                                    {
                                        [Co]: Nt.disabled
                                    },
                                    Wn
                                ];
                            }
                            stencilConfigForOverlapTwoPass(Qe) {
                                const rt = this.context.gl, Wn = Qe.sort((Qe, rt)=>rt.overscaledZ - Qe.overscaledZ), Co = Wn[Wn.length - 1].overscaledZ, Dl = Wn[0].overscaledZ - Co + 1;
                                if (this.clearStencil(), Dl > 1) {
                                    const Qe = {}, Ll = {};
                                    for(let Wn = 0; Wn < Dl; Wn++)Qe[Wn + Co] = new Nt({
                                        func: rt.GREATER,
                                        mask: 255
                                    }, Dl + 1 + Wn, 255, rt.KEEP, rt.KEEP, rt.REPLACE), Ll[Wn + Co] = new Nt({
                                        func: rt.GREATER,
                                        mask: 255
                                    }, 1 + Wn, 255, rt.KEEP, rt.KEEP, rt.REPLACE);
                                    return this.nextStencilID = 2 * Dl + 1, [
                                        Qe,
                                        Ll,
                                        Wn
                                    ];
                                }
                                return this.nextStencilID = 3, [
                                    {
                                        [Co]: new Nt({
                                            func: rt.GREATER,
                                            mask: 255
                                        }, 2, 255, rt.KEEP, rt.KEEP, rt.REPLACE)
                                    },
                                    {
                                        [Co]: new Nt({
                                            func: rt.GREATER,
                                            mask: 255
                                        }, 1, 255, rt.KEEP, rt.KEEP, rt.REPLACE)
                                    },
                                    Wn
                                ];
                            }
                            colorModeForRenderPass() {
                                const Qe = this.context.gl;
                                if (this._showOverdrawInspector) {
                                    const Wn = 1 / 8;
                                    return new Ft([
                                        Qe.CONSTANT_COLOR,
                                        Qe.ONE
                                    ], new rt.b7(Wn, Wn, Wn, 0), [
                                        !0,
                                        !0,
                                        !0,
                                        !0
                                    ]);
                                }
                                return "opaque" === this.renderPass ? Ft.unblended : Ft.alphaBlended;
                            }
                            getDepthModeForSublayer(Qe, rt, Wn) {
                                if (!this.opaquePassEnabledForLayer()) return jt.disabled;
                                const Co = 1 - ((1 + this.currentLayer) * this.numSublayers + Qe) * this.depthEpsilon;
                                return new jt(Wn || this.context.gl.LEQUAL, rt, [
                                    Co,
                                    Co
                                ]);
                            }
                            getDepthModeFor3D() {
                                return new jt(this.context.gl.LEQUAL, jt.ReadWrite, this.depthRangeFor3D);
                            }
                            opaquePassEnabledForLayer() {
                                return this.currentLayer < this.opaquePassCutoff;
                            }
                            render(Qe, Wn) {
                                var Co, Dl;
                                this.style = Qe, this.options = Wn, this.lineAtlas = Qe.lineAtlas, this.imageManager = Qe.imageManager, this.glyphManager = Qe.glyphManager, this.symbolFadeChange = Qe.placement.symbolFadeChange(Ll.now()), this.imageManager.beginFrame();
                                const Rl = this.style._order, Ul = this.style.sourceCaches, Gl = {}, Zl = {}, Hl = {}, ql = {
                                    isRenderingToTexture: !1,
                                    isRenderingGlobe: (null === (Co = Qe.projection) || void 0 === Co ? void 0 : Co.transitionState) > 0
                                };
                                for(const rt in Ul){
                                    const Qe = Ul[rt];
                                    Qe.used && Qe.prepare(this.context), Gl[rt] = Qe.getVisibleCoordinates(!1), Zl[rt] = Gl[rt].slice().reverse(), Hl[rt] = Qe.getVisibleCoordinates(!0).reverse();
                                }
                                this.opaquePassCutoff = 1 / 0;
                                for(let rt = 0; rt < Rl.length; rt++)if (this.style._layers[Rl[rt]].is3D()) {
                                    this.opaquePassCutoff = rt;
                                    break;
                                }
                                this.maybeDrawDepthAndCoords(!1), this.renderToTexture && (this.renderToTexture.prepareForRender(this.style, this.transform.zoom), this.opaquePassCutoff = 0), this.renderPass = "offscreen";
                                for (const rt of Rl){
                                    const Qe = this.style._layers[rt];
                                    if (!Qe.hasOffscreenPass() || Qe.isHidden(this.transform.zoom)) continue;
                                    const Wn = Zl[Qe.source];
                                    ("custom" === Qe.type || Wn.length) && this.renderLayer(this, Ul[Qe.source], Qe, Wn, ql);
                                }
                                if (null === (Dl = this.style.projection) || void 0 === Dl || Dl.updateGPUdependent({
                                    context: this.context,
                                    useProgram: (Qe)=>this.useProgram(Qe)
                                }), this.context.viewport.set([
                                    0,
                                    0,
                                    this.width,
                                    this.height
                                ]), this.context.bindFramebuffer.set(null), this.context.clear({
                                    color: Wn.showOverdrawInspector ? rt.b7.black : rt.b7.transparent,
                                    depth: 1
                                }), this.clearStencil(), this.style.sky && function(Qe, rt) {
                                    const Wn = Qe.context, Co = Wn.gl, Dl = ((Qe, rt, Wn)=>{
                                        const Co = Math.cos(rt.rollInRadians), Dl = Math.sin(rt.rollInRadians), Ll = yt(rt), Rl = rt.getProjectionData({
                                            overscaledTileID: null,
                                            applyGlobeMatrix: !0,
                                            applyTerrainMatrix: !0
                                        }).projectionTransition;
                                        return {
                                            u_sky_color: Qe.properties.get("sky-color"),
                                            u_horizon_color: Qe.properties.get("horizon-color"),
                                            u_horizon: [
                                                (rt.width / 2 - Ll * Dl) * Wn,
                                                (rt.height / 2 + Ll * Co) * Wn
                                            ],
                                            u_horizon_normal: [
                                                -Dl,
                                                Co
                                            ],
                                            u_sky_horizon_blend: Qe.properties.get("sky-horizon-blend") * rt.height / 2 * Wn,
                                            u_sky_blend: Rl
                                        };
                                    })(rt, Qe.style.map.transform, Qe.pixelRatio), Ll = new jt(Co.LEQUAL, jt.ReadWrite, [
                                        0,
                                        1
                                    ]), Rl = Nt.disabled, Ul = Qe.colorModeForRenderPass(), Gl = Qe.useProgram("sky"), Zl = xo(Wn, rt);
                                    Gl.draw(Wn, Co.TRIANGLES, Ll, Rl, Ul, Ot.disabled, Dl, null, void 0, "sky", Zl.vertexBuffer, Zl.indexBuffer, Zl.segments);
                                }(this, this.style.sky), this._showOverdrawInspector = Wn.showOverdrawInspector, this.depthRangeFor3D = [
                                    0,
                                    1 - (Qe._order.length + 2) * this.numSublayers * this.depthEpsilon
                                ], !this.renderToTexture) for(this.renderPass = "opaque", this.currentLayer = Rl.length - 1; this.currentLayer >= 0; this.currentLayer--){
                                    const Qe = this.style._layers[Rl[this.currentLayer]], rt = Ul[Qe.source], Wn = Gl[Qe.source];
                                    this._renderTileClippingMasks(Qe, Wn, !1), this.renderLayer(this, rt, Qe, Wn, ql);
                                }
                                this.renderPass = "translucent";
                                let Ql = !1;
                                for(this.currentLayer = 0; this.currentLayer < Rl.length; this.currentLayer++){
                                    const Qe = this.style._layers[Rl[this.currentLayer]], rt = Ul[Qe.source];
                                    if (this.renderToTexture && this.renderToTexture.renderLayer(Qe, ql)) continue;
                                    this.opaquePassEnabledForLayer() || Ql || (Ql = !0, ql.isRenderingGlobe && !this.style.map.terrain && this._renderTilesDepthBuffer());
                                    const Wn = ("symbol" === Qe.type ? Hl : Zl)[Qe.source];
                                    this._renderTileClippingMasks(Qe, Gl[Qe.source], !1), this.renderLayer(this, rt, Qe, Wn, ql);
                                }
                                if (ql.isRenderingGlobe && function(Qe, Wn, Co) {
                                    const Dl = Qe.context, Ll = Dl.gl, Rl = Qe.useProgram("atmosphere"), Ul = new jt(Ll.LEQUAL, jt.ReadOnly, [
                                        0,
                                        1
                                    ]), Gl = Qe.transform, Zl = function(Qe, Wn) {
                                        const Co = Qe.properties.get("position"), Dl = [
                                            -Co.x,
                                            -Co.y,
                                            -Co.z
                                        ], Ll = rt.at(new Float64Array(16));
                                        return "map" === Qe.properties.get("anchor") && (rt.a_(Ll, Ll, Wn.rollInRadians), rt.a$(Ll, Ll, -Wn.pitchInRadians), rt.a_(Ll, Ll, Wn.bearingInRadians), rt.a$(Ll, Ll, Wn.center.lat * Math.PI / 180), rt.bm(Ll, Ll, -Wn.center.lng * Math.PI / 180)), rt.bV(Dl, Dl, Ll), Dl;
                                    }(Co, Qe.transform), Hl = Gl.getProjectionData({
                                        overscaledTileID: null,
                                        applyGlobeMatrix: !0,
                                        applyTerrainMatrix: !0
                                    }), ql = Wn.properties.get("atmosphere-blend") * Hl.projectionTransition;
                                    if (0 === ql) return;
                                    const Ql = ei(Gl.worldSize, Gl.center.lat), Kl = Gl.inverseProjectionMatrix, $l = new Float64Array(4);
                                    $l[3] = 1, rt.ap($l, $l, Gl.modelViewProjectionMatrix), $l[0] /= $l[3], $l[1] /= $l[3], $l[2] /= $l[3], $l[3] = 1, rt.ap($l, $l, Kl), $l[0] /= $l[3], $l[1] /= $l[3], $l[2] /= $l[3], $l[3] = 1;
                                    const Tc = ((Qe, rt, Wn, Co, Dl)=>({
                                            u_sun_pos: Qe,
                                            u_atmosphere_blend: rt,
                                            u_globe_position: Wn,
                                            u_globe_radius: Co,
                                            u_inv_proj_matrix: Dl
                                        }))(Zl, ql, [
                                        $l[0],
                                        $l[1],
                                        $l[2]
                                    ], Ql, Kl), tu = xo(Dl, Wn);
                                    Rl.draw(Dl, Ll.TRIANGLES, Ul, Nt.disabled, Ft.alphaBlended, Ot.disabled, Tc, null, null, "atmosphere", tu.vertexBuffer, tu.indexBuffer, tu.segments);
                                }(this, this.style.sky, this.style.light), this.options.showTileBoundaries) {
                                    const Qe = function(Qe, rt) {
                                        let Wn = null;
                                        const Co = Object.values(Qe._layers).flatMap((Wn)=>Wn.source && !Wn.isHidden(rt) ? [
                                                Qe.sourceCaches[Wn.source]
                                            ] : []), Dl = Co.filter((Qe)=>"vector" === Qe.getSource().type), Ll = Co.filter((Qe)=>"vector" !== Qe.getSource().type), s = (Qe)=>{
                                            (!Wn || Wn.getSource().maxzoom < Qe.getSource().maxzoom) && (Wn = Qe);
                                        };
                                        return Dl.forEach((Qe)=>s(Qe)), Wn || Ll.forEach((Qe)=>s(Qe)), Wn;
                                    }(this.style, this.transform.zoom);
                                    Qe && function(Qe, rt, Wn) {
                                        for(let Co = 0; Co < Wn.length; Co++)go(Qe, rt, Wn[Co]);
                                    }(this, Qe, Qe.getVisibleCoordinates());
                                }
                                this.options.showPadding && function(Qe) {
                                    const rt = Qe.transform.padding;
                                    po(Qe, Qe.transform.height - (rt.top || 0), 3, Md), po(Qe, rt.bottom || 0, 3, Sd), mo(Qe, rt.left || 0, 3, Td), mo(Qe, Qe.transform.width - (rt.right || 0), 3, Cd);
                                    const Wn = Qe.transform.centerPoint;
                                    !function(Qe, rt, Wn, Co) {
                                        fo(Qe, rt - 1, Wn - 10, 2, 20, Co), fo(Qe, rt - 10, Wn - 1, 20, 2, Co);
                                    }(Qe, Wn.x, Qe.transform.height - Wn.y, kd);
                                }(this), this.context.setDefault();
                            }
                            maybeDrawDepthAndCoords(Qe) {
                                if (!this.style || !this.style.map || !this.style.map.terrain) return;
                                const Wn = this.terrainFacilitator.matrix, Co = this.transform.modelViewProjectionMatrix;
                                let Dl = this.terrainFacilitator.dirty;
                                Dl || (Dl = Qe ? !rt.bY(Wn, Co) : !rt.bZ(Wn, Co)), Dl || (Dl = this.style.map.terrain.sourceCache.anyTilesAfterTime(this.terrainFacilitator.renderTime)), Dl && (rt.b_(Wn, Co), this.terrainFacilitator.renderTime = Date.now(), this.terrainFacilitator.dirty = !1, function(Qe, Wn) {
                                    const Co = Qe.context, Dl = Co.gl, Ll = Qe.transform, Rl = Ft.unblended, Ul = new jt(Dl.LEQUAL, jt.ReadWrite, [
                                        0,
                                        1
                                    ]), Gl = Wn.sourceCache.getRenderableTiles(), Zl = Qe.useProgram("terrainDepth");
                                    Co.bindFramebuffer.set(Wn.getFramebuffer("depth").framebuffer), Co.viewport.set([
                                        0,
                                        0,
                                        Qe.width / devicePixelRatio,
                                        Qe.height / devicePixelRatio
                                    ]), Co.clear({
                                        color: rt.b7.transparent,
                                        depth: 1
                                    });
                                    for (const rt of Gl){
                                        const Qe = Wn.getTerrainMesh(rt.tileID), Gl = Wn.getTerrainData(rt.tileID), Hl = Ll.getProjectionData({
                                            overscaledTileID: rt.tileID,
                                            applyTerrainMatrix: !1,
                                            applyGlobeMatrix: !0
                                        }), ql = {
                                            u_ele_delta: Wn.getMeshFrameDelta(Ll.zoom)
                                        };
                                        Zl.draw(Co, Dl.TRIANGLES, Ul, Nt.disabled, Rl, Ot.backCCW, ql, Gl, Hl, "terrain", Qe.vertexBuffer, Qe.indexBuffer, Qe.segments);
                                    }
                                    Co.bindFramebuffer.set(null), Co.viewport.set([
                                        0,
                                        0,
                                        Qe.width,
                                        Qe.height
                                    ]);
                                }(this, this.style.map.terrain), function(Qe, Wn) {
                                    const Co = Qe.context, Dl = Co.gl, Ll = Qe.transform, Rl = Ft.unblended, Ul = new jt(Dl.LEQUAL, jt.ReadWrite, [
                                        0,
                                        1
                                    ]), Gl = Wn.getCoordsTexture(), Zl = Wn.sourceCache.getRenderableTiles(), Hl = Qe.useProgram("terrainCoords");
                                    Co.bindFramebuffer.set(Wn.getFramebuffer("coords").framebuffer), Co.viewport.set([
                                        0,
                                        0,
                                        Qe.width / devicePixelRatio,
                                        Qe.height / devicePixelRatio
                                    ]), Co.clear({
                                        color: rt.b7.transparent,
                                        depth: 1
                                    }), Wn.coordsIndex = [];
                                    for (const rt of Zl){
                                        const Qe = Wn.getTerrainMesh(rt.tileID), Zl = Wn.getTerrainData(rt.tileID);
                                        Co.activeTexture.set(Dl.TEXTURE0), Dl.bindTexture(Dl.TEXTURE_2D, Gl.texture);
                                        const ql = {
                                            u_terrain_coords_id: (255 - Wn.coordsIndex.length) / 255,
                                            u_texture: 0,
                                            u_ele_delta: Wn.getMeshFrameDelta(Ll.zoom)
                                        }, Ql = Ll.getProjectionData({
                                            overscaledTileID: rt.tileID,
                                            applyTerrainMatrix: !1,
                                            applyGlobeMatrix: !0
                                        });
                                        Hl.draw(Co, Dl.TRIANGLES, Ul, Nt.disabled, Rl, Ot.backCCW, ql, Zl, Ql, "terrain", Qe.vertexBuffer, Qe.indexBuffer, Qe.segments), Wn.coordsIndex.push(rt.tileID.key);
                                    }
                                    Co.bindFramebuffer.set(null), Co.viewport.set([
                                        0,
                                        0,
                                        Qe.width,
                                        Qe.height
                                    ]);
                                }(this, this.style.map.terrain));
                            }
                            renderLayer(Qe, Wn, Co, Dl, Ll) {
                                Co.isHidden(this.transform.zoom) || ("background" === Co.type || "custom" === Co.type || (Dl || []).length) && (this.id = Co.id, rt.b$(Co) ? function(Qe, Wn, Co, Dl, Ll, Rl) {
                                    if ("translucent" !== Qe.renderPass) return;
                                    const { isRenderingToTexture: Ul } = Rl, Gl = Nt.disabled, Zl = Qe.colorModeForRenderPass();
                                    (Co._unevaluatedLayout.hasValue("text-variable-anchor") || Co._unevaluatedLayout.hasValue("text-variable-anchor-offset")) && function(Qe, Wn, Co, Dl, Ll, Rl, Ul, Gl, Zl) {
                                        const Hl = Wn.transform, ql = Wn.style.map.terrain, Ql = "map" === Ll, Kl = "map" === Rl;
                                        for (const $l of Qe){
                                            const Qe = Dl.getTile($l), Ll = Qe.getBucket(Co);
                                            if (!Ll || !Ll.text || !Ll.text.segments.get().length) continue;
                                            const Rl = rt.ag(Ll.textSizeData, Hl.zoom), Tc = rt.aw(Qe, 1, Wn.transform.zoom), tu = ve(Ql, Wn.transform, Tc), lu = "none" !== Co.layout.get("icon-text-fit") && Ll.hasIconData();
                                            if (Rl) {
                                                const Wn = Math.pow(2, Hl.zoom - Qe.tileID.overscaledZ), Co = ql ? (Qe, rt)=>ql.getElevation($l, Qe, rt) : null;
                                                $r(Ll, Ql, Kl, Zl, Hl, tu, Wn, Rl, lu, rt.ax(Hl, Qe, Ul, Gl), $l.toUnwrapped(), Co);
                                            }
                                        }
                                    }(Dl, Qe, Co, Wn, Co.layout.get("text-rotation-alignment"), Co.layout.get("text-pitch-alignment"), Co.paint.get("text-translate"), Co.paint.get("text-translate-anchor"), Ll), 0 !== Co.paint.get("icon-opacity").constantOr(1) && Kr(Qe, Wn, Co, Dl, !1, Co.paint.get("icon-translate"), Co.paint.get("icon-translate-anchor"), Co.layout.get("icon-rotation-alignment"), Co.layout.get("icon-pitch-alignment"), Co.layout.get("icon-keep-upright"), Gl, Zl, Ul), 0 !== Co.paint.get("text-opacity").constantOr(1) && Kr(Qe, Wn, Co, Dl, !0, Co.paint.get("text-translate"), Co.paint.get("text-translate-anchor"), Co.layout.get("text-rotation-alignment"), Co.layout.get("text-pitch-alignment"), Co.layout.get("text-keep-upright"), Gl, Zl, Ul), Wn.map.showCollisionBoxes && (Ur(Qe, Wn, Co, Dl, !0), Ur(Qe, Wn, Co, Dl, !1));
                                }(Qe, Wn, Co, Dl, this.style.placement.variableOffsets, Ll) : rt.c0(Co) ? function(Qe, Wn, Co, Dl, Ll) {
                                    if ("translucent" !== Qe.renderPass) return;
                                    const { isRenderingToTexture: Rl } = Ll, Ul = Co.paint.get("circle-opacity"), Gl = Co.paint.get("circle-stroke-width"), Zl = Co.paint.get("circle-stroke-opacity"), Hl = !Co.layout.get("circle-sort-key").isConstant();
                                    if (0 === Ul.constantOr(1) && (0 === Gl.constantOr(1) || 0 === Zl.constantOr(1))) return;
                                    const ql = Qe.context, Ql = ql.gl, Kl = Qe.transform, $l = Qe.getDepthModeForSublayer(0, jt.ReadOnly), Tc = Nt.disabled, tu = Qe.colorModeForRenderPass(), lu = [], du = Kl.getCircleRadiusCorrection();
                                    for(let fu = 0; fu < Dl.length; fu++){
                                        const Ll = Dl[fu], Ul = Wn.getTile(Ll), Gl = Ul.getBucket(Co);
                                        if (!Gl) continue;
                                        const Zl = Co.paint.get("circle-translate"), ql = Co.paint.get("circle-translate-anchor"), Ql = rt.ax(Kl, Ul, Zl, ql), $l = Gl.programConfigurations.get(Co.id), Tc = Qe.useProgram("circle", $l), tu = Gl.layoutVertexBuffer, yu = Gl.indexBuffer, Eu = Qe.style.map.terrain && Qe.style.map.terrain.getTerrainData(Ll), Tu = {
                                            programConfiguration: $l,
                                            program: Tc,
                                            layoutVertexBuffer: tu,
                                            indexBuffer: yu,
                                            uniformValues: Ri(Qe, Ul, Co, Ql, du),
                                            terrainData: Eu,
                                            projectionData: Kl.getProjectionData({
                                                overscaledTileID: Ll,
                                                applyGlobeMatrix: !Rl,
                                                applyTerrainMatrix: !0
                                            })
                                        };
                                        if (Hl) {
                                            const Qe = Gl.segments.get();
                                            for (const Wn of Qe)lu.push({
                                                segments: new rt.aG([
                                                    Wn
                                                ]),
                                                sortKey: Wn.sortKey,
                                                state: Tu
                                            });
                                        } else lu.push({
                                            segments: Gl.segments,
                                            sortKey: 0,
                                            state: Tu
                                        });
                                    }
                                    Hl && lu.sort((Qe, rt)=>Qe.sortKey - rt.sortKey);
                                    for (const rt of lu){
                                        const { programConfiguration: Wn, program: Dl, layoutVertexBuffer: Ll, indexBuffer: Rl, uniformValues: Ul, terrainData: Gl, projectionData: Zl } = rt.state;
                                        Dl.draw(ql, Ql.TRIANGLES, $l, Tc, tu, Ot.backCCW, Ul, Gl, Zl, Co.id, Ll, Rl, rt.segments, Co.paint, Qe.transform.zoom, Wn);
                                    }
                                }(Qe, Wn, Co, Dl, Ll) : rt.c1(Co) ? function(Qe, Wn, Co, Dl, Ll) {
                                    if (0 === Co.paint.get("heatmap-opacity")) return;
                                    const Rl = Qe.context, { isRenderingToTexture: Ul, isRenderingGlobe: Gl } = Ll;
                                    if (Qe.style.map.terrain) {
                                        for (const rt of Dl){
                                            const Dl = Wn.getTile(rt);
                                            Wn.hasRenderableParent(rt) || ("offscreen" === Qe.renderPass ? Qr(Qe, Dl, Co, rt, Gl) : "translucent" === Qe.renderPass && Yr(Qe, Co, rt, Ul, Gl));
                                        }
                                        Rl.viewport.set([
                                            0,
                                            0,
                                            Qe.width,
                                            Qe.height
                                        ]);
                                    } else "offscreen" === Qe.renderPass ? function(Qe, Wn, Co, Dl) {
                                        const Ll = Qe.context, Rl = Ll.gl, Ul = Qe.transform, Gl = Nt.disabled, Zl = new Ft([
                                            Rl.ONE,
                                            Rl.ONE
                                        ], rt.b7.transparent, [
                                            !0,
                                            !0,
                                            !0,
                                            !0
                                        ]);
                                        (function(Qe, Wn, Co) {
                                            const Dl = Qe.gl;
                                            Qe.activeTexture.set(Dl.TEXTURE1), Qe.viewport.set([
                                                0,
                                                0,
                                                Wn.width / 4,
                                                Wn.height / 4
                                            ]);
                                            let Ll = Co.heatmapFbos.get(rt.bS);
                                            Ll ? (Dl.bindTexture(Dl.TEXTURE_2D, Ll.colorAttachment.get()), Qe.bindFramebuffer.set(Ll.framebuffer)) : (Ll = Jr(Qe, Wn.width / 4, Wn.height / 4), Co.heatmapFbos.set(rt.bS, Ll));
                                        })(Ll, Qe, Co), Ll.clear({
                                            color: rt.b7.transparent
                                        });
                                        for(let rt = 0; rt < Dl.length; rt++){
                                            const Hl = Dl[rt];
                                            if (Wn.hasRenderableParent(Hl)) continue;
                                            const ql = Wn.getTile(Hl), Ql = ql.getBucket(Co);
                                            if (!Ql) continue;
                                            const Kl = Ql.programConfigurations.get(Co.id), $l = Qe.useProgram("heatmap", Kl), Tc = Ul.getProjectionData({
                                                overscaledTileID: Hl,
                                                applyGlobeMatrix: !0,
                                                applyTerrainMatrix: !1
                                            }), tu = Ul.getCircleRadiusCorrection();
                                            $l.draw(Ll, Rl.TRIANGLES, jt.disabled, Gl, Zl, Ot.backCCW, Li(ql, Ul.zoom, Co.paint.get("heatmap-intensity"), tu), null, Tc, Co.id, Ql.layoutVertexBuffer, Ql.indexBuffer, Ql.segments, Co.paint, Ul.zoom, Kl);
                                        }
                                        Ll.viewport.set([
                                            0,
                                            0,
                                            Qe.width,
                                            Qe.height
                                        ]);
                                    }(Qe, Wn, Co, Dl) : "translucent" === Qe.renderPass && function(Qe, Wn) {
                                        const Co = Qe.context, Dl = Co.gl;
                                        Co.setColorMode(Qe.colorModeForRenderPass());
                                        const Ll = Wn.heatmapFbos.get(rt.bS);
                                        Ll && (Co.activeTexture.set(Dl.TEXTURE0), Dl.bindTexture(Dl.TEXTURE_2D, Ll.colorAttachment.get()), Co.activeTexture.set(Dl.TEXTURE1), eo(Co, Wn).bind(Dl.LINEAR, Dl.CLAMP_TO_EDGE), Qe.useProgram("heatmapTexture").draw(Co, Dl.TRIANGLES, jt.disabled, Nt.disabled, Qe.colorModeForRenderPass(), Ot.disabled, ki(Qe, Wn, 0, 1), null, null, Wn.id, Qe.viewportBuffer, Qe.quadTriangleIndexBuffer, Qe.viewportSegments, Wn.paint, Qe.transform.zoom));
                                    }(Qe, Co);
                                }(Qe, Wn, Co, Dl, Ll) : rt.c2(Co) ? function(Qe, Wn, Co, Dl, Ll) {
                                    if ("translucent" !== Qe.renderPass) return;
                                    const { isRenderingToTexture: Rl } = Ll, Ul = Co.paint.get("line-opacity"), Gl = Co.paint.get("line-width");
                                    if (0 === Ul.constantOr(1) || 0 === Gl.constantOr(1)) return;
                                    const Zl = Qe.getDepthModeForSublayer(0, jt.ReadOnly), Hl = Qe.colorModeForRenderPass(), ql = Co.paint.get("line-dasharray"), Ql = Co.paint.get("line-pattern"), Kl = Ql.constantOr(1), $l = Co.paint.get("line-gradient"), Tc = Co.getCrossfadeParameters(), tu = Kl ? "linePattern" : ql ? "lineSDF" : $l ? "lineGradient" : "line", lu = Qe.context, du = lu.gl, fu = Qe.transform;
                                    let yu = !0;
                                    for (const Eu of Dl){
                                        const Ll = Wn.getTile(Eu);
                                        if (Kl && !Ll.patternsLoaded()) continue;
                                        const Ul = Ll.getBucket(Co);
                                        if (!Ul) continue;
                                        const Gl = Ul.programConfigurations.get(Co.id), Tu = Qe.context.program.get(), Lu = Qe.useProgram(tu, Gl), Zu = yu || Lu.program !== Tu, Xu = Qe.style.map.terrain && Qe.style.map.terrain.getTerrainData(Eu), Ju = Ql.constantOr(null);
                                        if (Ju && Ll.imageAtlas) {
                                            const Qe = Ll.imageAtlas, rt = Qe.patternPositions[Ju.to.toString()], Wn = Qe.patternPositions[Ju.from.toString()];
                                            rt && Wn && Gl.setConstantPatternPositions(rt, Wn);
                                        }
                                        const $u = fu.getProjectionData({
                                            overscaledTileID: Eu,
                                            applyGlobeMatrix: !Rl,
                                            applyTerrainMatrix: !0
                                        }), ed = fu.getPixelScale(), td = Kl ? Ni(Qe, Ll, Co, ed, Tc) : ql ? Gi(Qe, Ll, Co, ed, ql, Tc) : $l ? Zi(Qe, Ll, Co, ed, Ul.lineClipsArray.length) : ji(Qe, Ll, Co, ed);
                                        if (Kl) lu.activeTexture.set(du.TEXTURE0), Ll.imageAtlasTexture.bind(du.LINEAR, du.CLAMP_TO_EDGE), Gl.updatePaintBuffers(Tc);
                                        else if (ql && (Zu || Qe.lineAtlas.dirty)) lu.activeTexture.set(du.TEXTURE0), Qe.lineAtlas.bind(lu);
                                        else if ($l) {
                                            const Dl = Ul.gradients[Co.id];
                                            let Ll = Dl.texture;
                                            if (Co.gradientVersion !== Dl.version) {
                                                let Rl = 256;
                                                if (Co.stepInterpolant) {
                                                    const Co = Wn.getSource().maxzoom, Dl = Eu.canonical.z === Co ? Math.ceil(1 << Qe.transform.maxZoom - Eu.canonical.z) : 1;
                                                    Rl = rt.ae(rt.bT(Ul.maxLineLength / rt.Z * 1024 * Dl), 256, lu.maxTextureSize);
                                                }
                                                Dl.gradient = rt.bU({
                                                    expression: Co.gradientExpression(),
                                                    evaluationKey: "lineProgress",
                                                    resolution: Rl,
                                                    image: Dl.gradient || void 0,
                                                    clips: Ul.lineClipsArray
                                                }), Dl.texture ? Dl.texture.update(Dl.gradient) : Dl.texture = new v(lu, Dl.gradient, du.RGBA), Dl.version = Co.gradientVersion, Ll = Dl.texture;
                                            }
                                            lu.activeTexture.set(du.TEXTURE0), Ll.bind(Co.stepInterpolant ? du.NEAREST : du.LINEAR, du.CLAMP_TO_EDGE);
                                        }
                                        let id;
                                        if (Rl) {
                                            const [rt] = Qe.getStencilConfigForOverlapAndUpdateStencilID(Dl);
                                            id = rt[Eu.overscaledZ];
                                        } else id = Qe.stencilModeForClipping(Eu);
                                        Lu.draw(lu, du.TRIANGLES, Zl, id, Hl, Ot.disabled, td, Xu, $u, Co.id, Ul.layoutVertexBuffer, Ul.indexBuffer, Ul.segments, Co.paint, Qe.transform.zoom, Gl, Ul.layoutVertexBuffer2), yu = !1;
                                    }
                                }(Qe, Wn, Co, Dl, Ll) : rt.c3(Co) ? function(Qe, Wn, Co, Dl, Ll) {
                                    const Rl = Co.paint.get("fill-color"), Ul = Co.paint.get("fill-opacity");
                                    if (0 === Ul.constantOr(1)) return;
                                    const { isRenderingToTexture: Gl } = Ll, Zl = Qe.colorModeForRenderPass(), Hl = Co.paint.get("fill-pattern"), ql = Qe.opaquePassEnabledForLayer() && !Hl.constantOr(1) && 1 === Rl.constantOr(rt.b7.transparent).a && 1 === Ul.constantOr(0) ? "opaque" : "translucent";
                                    if (Qe.renderPass === ql) {
                                        const rt = Qe.getDepthModeForSublayer(1, "opaque" === Qe.renderPass ? jt.ReadWrite : jt.ReadOnly);
                                        io(Qe, Wn, Co, Dl, rt, Zl, !1, Gl);
                                    }
                                    if ("translucent" === Qe.renderPass && Co.paint.get("fill-antialias")) {
                                        const rt = Qe.getDepthModeForSublayer(Co.getPaintProperty("fill-outline-color") ? 2 : 0, jt.ReadOnly);
                                        io(Qe, Wn, Co, Dl, rt, Zl, !0, Gl);
                                    }
                                }(Qe, Wn, Co, Dl, Ll) : rt.c4(Co) ? function(Qe, rt, Wn, Co, Dl) {
                                    const Ll = Wn.paint.get("fill-extrusion-opacity");
                                    if (0 === Ll) return;
                                    const { isRenderingToTexture: Rl } = Dl;
                                    if ("translucent" === Qe.renderPass) {
                                        const Dl = new jt(Qe.context.gl.LEQUAL, jt.ReadWrite, Qe.depthRangeFor3D);
                                        if (1 !== Ll || Wn.paint.get("fill-extrusion-pattern").constantOr(1)) ro(Qe, rt, Wn, Co, Dl, Nt.disabled, Ft.disabled, Rl), ro(Qe, rt, Wn, Co, Dl, Qe.stencilModeFor3D(), Qe.colorModeForRenderPass(), Rl);
                                        else {
                                            const Ll = Qe.colorModeForRenderPass();
                                            ro(Qe, rt, Wn, Co, Dl, Nt.disabled, Ll, Rl);
                                        }
                                    }
                                }(Qe, Wn, Co, Dl, Ll) : rt.c5(Co) ? function(Qe, rt, Wn, Co, Dl) {
                                    if ("offscreen" !== Qe.renderPass && "translucent" !== Qe.renderPass) return;
                                    const { isRenderingToTexture: Ll } = Dl, Rl = Qe.context, Ul = Qe.style.projection.useSubdivision, Gl = Qe.getDepthModeForSublayer(0, jt.ReadOnly), Zl = Qe.colorModeForRenderPass();
                                    if ("offscreen" === Qe.renderPass) !function(Qe, rt, Wn, Co, Dl, Ll, Rl) {
                                        const Ul = Qe.context, Gl = Ul.gl;
                                        for (const Zl of Wn){
                                            const Wn = rt.getTile(Zl), Hl = Wn.dem;
                                            if (!Hl || !Hl.data) continue;
                                            if (!Wn.needsHillshadePrepare) continue;
                                            const ql = Hl.dim, Ql = Hl.stride, Kl = Hl.getPixels();
                                            if (Ul.activeTexture.set(Gl.TEXTURE1), Ul.pixelStoreUnpackPremultiplyAlpha.set(!1), Wn.demTexture = Wn.demTexture || Qe.getTileTexture(Ql), Wn.demTexture) {
                                                const Qe = Wn.demTexture;
                                                Qe.update(Kl, {
                                                    premultiply: !1
                                                }), Qe.bind(Gl.NEAREST, Gl.CLAMP_TO_EDGE);
                                            } else Wn.demTexture = new v(Ul, Kl, Gl.RGBA, {
                                                premultiply: !1
                                            }), Wn.demTexture.bind(Gl.NEAREST, Gl.CLAMP_TO_EDGE);
                                            Ul.activeTexture.set(Gl.TEXTURE0);
                                            let $l = Wn.fbo;
                                            if (!$l) {
                                                const Qe = new v(Ul, {
                                                    width: ql,
                                                    height: ql,
                                                    data: null
                                                }, Gl.RGBA);
                                                Qe.bind(Gl.LINEAR, Gl.CLAMP_TO_EDGE), $l = Wn.fbo = Ul.createFramebuffer(ql, ql, !0, !1), $l.colorAttachment.set(Qe.texture);
                                            }
                                            Ul.bindFramebuffer.set($l.framebuffer), Ul.viewport.set([
                                                0,
                                                0,
                                                ql,
                                                ql
                                            ]), Qe.useProgram("hillshadePrepare").draw(Ul, Gl.TRIANGLES, Dl, Ll, Rl, Ot.disabled, Bi(Wn.tileID, Hl), null, null, Co.id, Qe.rasterBoundsBuffer, Qe.quadTriangleIndexBuffer, Qe.rasterBoundsSegments), Wn.needsHillshadePrepare = !1;
                                        }
                                    }(Qe, rt, Co, Wn, Gl, Nt.disabled, Zl), Rl.viewport.set([
                                        0,
                                        0,
                                        Qe.width,
                                        Qe.height
                                    ]);
                                    else if ("translucent" === Qe.renderPass) {
                                        if (Ul) {
                                            const [Dl, Rl, Ul] = Qe.stencilConfigForOverlapTwoPass(Co);
                                            oo(Qe, rt, Wn, Ul, Dl, Gl, Zl, !1, Ll), oo(Qe, rt, Wn, Ul, Rl, Gl, Zl, !0, Ll);
                                        } else {
                                            const [Dl, Rl] = Qe.getStencilConfigForOverlapAndUpdateStencilID(Co);
                                            oo(Qe, rt, Wn, Rl, Dl, Gl, Zl, !1, Ll);
                                        }
                                    }
                                }(Qe, Wn, Co, Dl, Ll) : rt.c6(Co) ? function(Qe, rt, Wn, Co, Dl) {
                                    if ("translucent" !== Qe.renderPass) return;
                                    if (0 === Wn.paint.get("raster-opacity")) return;
                                    if (!Co.length) return;
                                    const { isRenderingToTexture: Ll } = Dl, Rl = rt.getSource(), Ul = Qe.style.projection.useSubdivision;
                                    if (Rl instanceof X) so(Qe, rt, Wn, Co, null, !1, !1, Rl.tileCoords, Rl.flippedWindingOrder, Ll);
                                    else if (Ul) {
                                        const [Dl, Rl, Ul] = Qe.stencilConfigForOverlapTwoPass(Co);
                                        so(Qe, rt, Wn, Ul, Dl, !1, !0, Ed, !1, Ll), so(Qe, rt, Wn, Ul, Rl, !0, !0, Ed, !1, Ll);
                                    } else {
                                        const [Dl, Rl] = Qe.getStencilConfigForOverlapAndUpdateStencilID(Co);
                                        so(Qe, rt, Wn, Rl, Dl, !1, !0, Ed, !1, Ll);
                                    }
                                }(Qe, Wn, Co, Dl, Ll) : rt.c7(Co) ? function(Qe, rt, Wn, Co, Dl) {
                                    const Ll = Wn.paint.get("background-color"), Rl = Wn.paint.get("background-opacity");
                                    if (0 === Rl) return;
                                    const { isRenderingToTexture: Ul } = Dl, Gl = Qe.context, Zl = Gl.gl, Hl = Qe.style.projection, ql = Qe.transform, Ql = ql.tileSize, Kl = Wn.paint.get("background-pattern");
                                    if (Qe.isPatternMissing(Kl)) return;
                                    const $l = !Kl && 1 === Ll.a && 1 === Rl && Qe.opaquePassEnabledForLayer() ? "opaque" : "translucent";
                                    if (Qe.renderPass !== $l) return;
                                    const Tc = Nt.disabled, tu = Qe.getDepthModeForSublayer(0, "opaque" === $l ? jt.ReadWrite : jt.ReadOnly), lu = Qe.colorModeForRenderPass(), du = Qe.useProgram(Kl ? "backgroundPattern" : "background"), fu = Co || ue(ql, {
                                        tileSize: Ql,
                                        terrain: Qe.style.map.terrain
                                    });
                                    Kl && (Gl.activeTexture.set(Zl.TEXTURE0), Qe.imageManager.bind(Qe.context));
                                    const yu = Wn.getCrossfadeParameters();
                                    for (const Eu of fu){
                                        const rt = ql.getProjectionData({
                                            overscaledTileID: Eu,
                                            applyGlobeMatrix: !Ul,
                                            applyTerrainMatrix: !0
                                        }), Co = Kl ? Qi(Rl, Qe, Kl, {
                                            tileID: Eu,
                                            tileSize: Ql
                                        }, yu) : Xi(Rl, Ll), Dl = Qe.style.map.terrain && Qe.style.map.terrain.getTerrainData(Eu), $l = Hl.getMeshFromTileID(Gl, Eu.canonical, !1, !0, "raster");
                                        du.draw(Gl, Zl.TRIANGLES, tu, Tc, lu, Ot.backCCW, Co, Dl, rt, Wn.id, $l.vertexBuffer, $l.indexBuffer, $l.segments);
                                    }
                                }(Qe, 0, Co, Dl, Ll) : rt.c8(Co) && function(Qe, rt, Wn, Co) {
                                    const { isRenderingGlobe: Dl } = Co, Ll = Qe.context, Rl = Wn.implementation, Ul = Qe.style.projection, Gl = Qe.transform, Zl = Gl.getProjectionDataForCustomLayer(Dl), Hl = {
                                        farZ: Gl.farZ,
                                        nearZ: Gl.nearZ,
                                        fov: Gl.fov * Math.PI / 180,
                                        modelViewProjectionMatrix: Gl.modelViewProjectionMatrix,
                                        projectionMatrix: Gl.projectionMatrix,
                                        shaderData: {
                                            variantName: Ul.shaderVariantName,
                                            vertexShaderPrelude: `const float PI = 3.141592653589793;\nuniform mat4 u_projection_matrix;\n${Ul.shaderPreludeCode.vertexSource}`,
                                            define: Ul.shaderDefine
                                        },
                                        defaultProjectionData: Zl
                                    }, ql = Rl.renderingMode ? Rl.renderingMode : "2d";
                                    if ("offscreen" === Qe.renderPass) {
                                        const rt = Rl.prerender;
                                        rt && (Qe.setCustomLayerDefaults(), Ll.setColorMode(Qe.colorModeForRenderPass()), rt.call(Rl, Ll.gl, Hl), Ll.setDirty(), Qe.setBaseState());
                                    } else if ("translucent" === Qe.renderPass) {
                                        Qe.setCustomLayerDefaults(), Ll.setColorMode(Qe.colorModeForRenderPass()), Ll.setStencilMode(Nt.disabled);
                                        const rt = "3d" === ql ? Qe.getDepthModeFor3D() : Qe.getDepthModeForSublayer(0, jt.ReadOnly);
                                        Ll.setDepthMode(rt), Rl.render(Ll.gl, Hl), Ll.setDirty(), Qe.setBaseState(), Ll.bindFramebuffer.set(null);
                                    }
                                }(Qe, 0, Co, Ll));
                            }
                            saveTileTexture(Qe) {
                                const rt = this._tileTextures[Qe.size[0]];
                                rt ? rt.push(Qe) : this._tileTextures[Qe.size[0]] = [
                                    Qe
                                ];
                            }
                            getTileTexture(Qe) {
                                const rt = this._tileTextures[Qe];
                                return rt && rt.length > 0 ? rt.pop() : null;
                            }
                            isPatternMissing(Qe) {
                                if (!Qe) return !1;
                                if (!Qe.from || !Qe.to) return !0;
                                const rt = this.imageManager.getPattern(Qe.from.toString()), Wn = this.imageManager.getPattern(Qe.to.toString());
                                return !rt || !Wn;
                            }
                            useProgram(Qe, rt, Wn = !1) {
                                this.cache = this.cache || {};
                                const Co = !!this.style.map.terrain, Dl = this.style.projection, Ll = Qe + (rt ? rt.cacheKey : "") + `/${Wn ? cd : Dl.shaderVariantName}` + (this._showOverdrawInspector ? "/overdraw" : "") + (Co ? "/terrain" : "");
                                return this.cache[Ll] || (this.cache[Ll] = new Ti(this.context, ad[Qe], rt, vd[Qe], this._showOverdrawInspector, Co, Wn ? ad.projectionMercator : Dl.shaderPreludeCode, Wn ? ld : Dl.shaderDefine)), this.cache[Ll];
                            }
                            setCustomLayerDefaults() {
                                this.context.unbindVAO(), this.context.cullFace.setDefault(), this.context.activeTexture.setDefault(), this.context.pixelStoreUnpack.setDefault(), this.context.pixelStoreUnpackPremultiplyAlpha.setDefault(), this.context.pixelStoreUnpackFlipY.setDefault();
                            }
                            setBaseState() {
                                const Qe = this.context.gl;
                                this.context.cullFace.set(!1), this.context.viewport.set([
                                    0,
                                    0,
                                    this.width,
                                    this.height
                                ]), this.context.blendEquation.set(Qe.FUNC_ADD);
                            }
                            initDebugOverlayCanvas() {
                                null == this.debugOverlayCanvas && (this.debugOverlayCanvas = document.createElement("canvas"), this.debugOverlayCanvas.width = 512, this.debugOverlayCanvas.height = 512, this.debugOverlayTexture = new v(this.context, this.debugOverlayCanvas, this.context.gl.RGBA));
                            }
                            destroy() {
                                this.debugOverlayTexture && this.debugOverlayTexture.destroy();
                            }
                            overLimit() {
                                const { drawingBufferWidth: Qe, drawingBufferHeight: rt } = this.context.gl;
                                return this.width !== Qe || this.height !== rt;
                            }
                        }
                        function yo(Qe, rt) {
                            let Wn, Co = !1, Dl = null, Ll = null;
                            const s = ()=>{
                                Dl = null, Co && (Qe.apply(Ll, Wn), Dl = setTimeout(s, rt), Co = !1);
                            };
                            return (...Qe)=>(Co = !0, Ll = this, Wn = Qe, Dl || s(), Dl);
                        }
                        class wo {
                            constructor(Qe){
                                this._getCurrentHash = ()=>{
                                    const Qe = window.location.hash.replace("#", "");
                                    if (this._hashName) {
                                        let rt;
                                        return Qe.split("&").map((Qe)=>Qe.split("=")).forEach((Qe)=>{
                                            Qe[0] === this._hashName && (rt = Qe);
                                        }), (rt && rt[1] || "").split("/");
                                    }
                                    return Qe.split("/");
                                }, this._onHashChange = ()=>{
                                    const Qe = this._getCurrentHash();
                                    if (!this._isValidHash(Qe)) return !1;
                                    const rt = this._map.dragRotate.isEnabled() && this._map.touchZoomRotate.isEnabled() ? +(Qe[3] || 0) : this._map.getBearing();
                                    return this._map.jumpTo({
                                        center: [
                                            +Qe[2],
                                            +Qe[1]
                                        ],
                                        zoom: +Qe[0],
                                        bearing: rt,
                                        pitch: +(Qe[4] || 0)
                                    }), !0;
                                }, this._updateHashUnthrottled = ()=>{
                                    const Qe = window.location.href.replace(/(#.*)?$/, this.getHashString());
                                    window.history.replaceState(window.history.state, null, Qe);
                                }, this._removeHash = ()=>{
                                    const Qe = this._getCurrentHash();
                                    if (0 === Qe.length) return;
                                    const rt = Qe.join("/");
                                    let Wn = rt;
                                    Wn.split("&").length > 0 && (Wn = Wn.split("&")[0]), this._hashName && (Wn = `${this._hashName}=${rt}`);
                                    let Co = window.location.hash.replace(Wn, "");
                                    Co.startsWith("#&") ? Co = Co.slice(0, 1) + Co.slice(2) : "#" === Co && (Co = "");
                                    let Dl = window.location.href.replace(/(#.+)?$/, Co);
                                    Dl = Dl.replace("&&", "&"), window.history.replaceState(window.history.state, null, Dl);
                                }, this._updateHash = yo(this._updateHashUnthrottled, 300), this._hashName = Qe && encodeURIComponent(Qe);
                            }
                            addTo(Qe) {
                                return this._map = Qe, addEventListener("hashchange", this._onHashChange, !1), this._map.on("moveend", this._updateHash), this;
                            }
                            remove() {
                                return removeEventListener("hashchange", this._onHashChange, !1), this._map.off("moveend", this._updateHash), clearTimeout(this._updateHash()), this._removeHash(), delete this._map, this;
                            }
                            getHashString(Qe) {
                                const rt = this._map.getCenter(), Wn = Math.round(100 * this._map.getZoom()) / 100, Co = Math.ceil((Wn * Math.LN2 + Math.log(512 / 360 / .5)) / Math.LN10), Dl = Math.pow(10, Co), Ll = Math.round(rt.lng * Dl) / Dl, Rl = Math.round(rt.lat * Dl) / Dl, Ul = this._map.getBearing(), Gl = this._map.getPitch();
                                let Zl = "";
                                if (Zl += Qe ? `/${Ll}/${Rl}/${Wn}` : `${Wn}/${Rl}/${Ll}`, (Ul || Gl) && (Zl += "/" + Math.round(10 * Ul) / 10), Gl && (Zl += `/${Math.round(Gl)}`), this._hashName) {
                                    const Qe = this._hashName;
                                    let rt = !1;
                                    const Wn = window.location.hash.slice(1).split("&").map((Wn)=>{
                                        const Co = Wn.split("=")[0];
                                        return Co === Qe ? (rt = !0, `${Co}=${Zl}`) : Wn;
                                    }).filter((Qe)=>Qe);
                                    return rt || Wn.push(`${Qe}=${Zl}`), `#${Wn.join("&")}`;
                                }
                                return `#${Zl}`;
                            }
                            _isValidHash(Qe) {
                                if (Qe.length < 3 || Qe.some(isNaN)) return !1;
                                try {
                                    new rt.Q(+Qe[2], +Qe[1]);
                                } catch (Qe) {
                                    return !1;
                                }
                                const Wn = +Qe[0], Co = +(Qe[3] || 0), Dl = +(Qe[4] || 0);
                                return Wn >= this._map.getMinZoom() && Wn <= this._map.getMaxZoom() && Co >= -180 && Co <= 180 && Dl >= this._map.getMinPitch() && Dl <= this._map.getMaxPitch();
                            }
                        }
                        const Id = {
                            linearity: .3,
                            easing: rt.c9(0, 0, .3, 1)
                        }, Dd = rt.e({
                            deceleration: 2500,
                            maxSpeed: 1400
                        }, Id), Ld = rt.e({
                            deceleration: 20,
                            maxSpeed: 1400
                        }, Id), Pd = rt.e({
                            deceleration: 1e3,
                            maxSpeed: 360
                        }, Id), zd = rt.e({
                            deceleration: 1e3,
                            maxSpeed: 90
                        }, Id), Nd = rt.e({
                            deceleration: 1e3,
                            maxSpeed: 360
                        }, Id);
                        class So {
                            constructor(Qe){
                                this._map = Qe, this.clear();
                            }
                            clear() {
                                this._inertiaBuffer = [];
                            }
                            record(Qe) {
                                this._drainInertiaBuffer(), this._inertiaBuffer.push({
                                    time: Ll.now(),
                                    settings: Qe
                                });
                            }
                            _drainInertiaBuffer() {
                                const Qe = this._inertiaBuffer, rt = Ll.now();
                                for(; Qe.length > 0 && rt - Qe[0].time > 160;)Qe.shift();
                            }
                            _onMoveEnd(Qe) {
                                if (this._drainInertiaBuffer(), this._inertiaBuffer.length < 2) return;
                                const Wn = {
                                    zoom: 0,
                                    bearing: 0,
                                    pitch: 0,
                                    roll: 0,
                                    pan: new rt.P(0, 0),
                                    pinchAround: void 0,
                                    around: void 0
                                };
                                for (const { settings: rt } of this._inertiaBuffer)Wn.zoom += rt.zoomDelta || 0, Wn.bearing += rt.bearingDelta || 0, Wn.pitch += rt.pitchDelta || 0, Wn.roll += rt.rollDelta || 0, rt.panDelta && Wn.pan._add(rt.panDelta), rt.around && (Wn.around = rt.around), rt.pinchAround && (Wn.pinchAround = rt.pinchAround);
                                const Co = this._inertiaBuffer[this._inertiaBuffer.length - 1].time - this._inertiaBuffer[0].time, Dl = {};
                                if (Wn.pan.mag()) {
                                    const Ll = Do(Wn.pan.mag(), Co, rt.e({}, Dd, Qe || {})), Rl = Wn.pan.mult(Ll.amount / Wn.pan.mag()), Ul = this._map.cameraHelper.handlePanInertia(Rl, this._map.transform);
                                    Dl.center = Ul.easingCenter, Dl.offset = Ul.easingOffset, Ro(Dl, Ll);
                                }
                                if (Wn.zoom) {
                                    const Qe = Do(Wn.zoom, Co, Ld);
                                    Dl.zoom = this._map.transform.zoom + Qe.amount, Ro(Dl, Qe);
                                }
                                if (Wn.bearing) {
                                    const Qe = Do(Wn.bearing, Co, Pd);
                                    Dl.bearing = this._map.transform.bearing + rt.ae(Qe.amount, -179, 179), Ro(Dl, Qe);
                                }
                                if (Wn.pitch) {
                                    const Qe = Do(Wn.pitch, Co, zd);
                                    Dl.pitch = this._map.transform.pitch + Qe.amount, Ro(Dl, Qe);
                                }
                                if (Wn.roll) {
                                    const Qe = Do(Wn.roll, Co, Nd);
                                    Dl.roll = this._map.transform.roll + rt.ae(Qe.amount, -179, 179), Ro(Dl, Qe);
                                }
                                if (Dl.zoom || Dl.bearing) {
                                    const Qe = void 0 === Wn.pinchAround ? Wn.around : Wn.pinchAround;
                                    Dl.around = Qe ? this._map.unproject(Qe) : this._map.getCenter();
                                }
                                return this.clear(), rt.e(Dl, {
                                    noMoveStart: !0
                                });
                            }
                        }
                        function Ro(Qe, rt) {
                            (!Qe.duration || Qe.duration < rt.duration) && (Qe.duration = rt.duration, Qe.easing = rt.easing);
                        }
                        function Do(Qe, Wn, Co) {
                            const { maxSpeed: Dl, linearity: Ll, deceleration: Rl } = Co, Ul = rt.ae(Qe * Ll / (Wn / 1e3), -Dl, Dl), Gl = Math.abs(Ul) / (Rl * Ll);
                            return {
                                easing: Co.easing,
                                duration: 1e3 * Gl,
                                amount: Ul * (Gl / 2)
                            };
                        }
                        class zo extends rt.l {
                            preventDefault() {
                                this._defaultPrevented = !0;
                            }
                            get defaultPrevented() {
                                return this._defaultPrevented;
                            }
                            constructor(Qe, Wn, Co, Dl = {}){
                                Co = Co instanceof MouseEvent ? Co : new MouseEvent(Qe, Co);
                                const Ll = n.mousePos(Wn.getCanvas(), Co), Rl = Wn.unproject(Ll);
                                super(Qe, rt.e({
                                    point: Ll,
                                    lngLat: Rl,
                                    originalEvent: Co
                                }, Dl)), this._defaultPrevented = !1, this.target = Wn;
                            }
                        }
                        class Ao extends rt.l {
                            preventDefault() {
                                this._defaultPrevented = !0;
                            }
                            get defaultPrevented() {
                                return this._defaultPrevented;
                            }
                            constructor(Qe, Wn, Co){
                                const Dl = "touchend" === Qe ? Co.changedTouches : Co.touches, Ll = n.touchPos(Wn.getCanvasContainer(), Dl), Rl = Ll.map((Qe)=>Wn.unproject(Qe)), Ul = Ll.reduce((Qe, rt, Wn, Co)=>Qe.add(rt.div(Co.length)), new rt.P(0, 0));
                                super(Qe, {
                                    points: Ll,
                                    point: Ul,
                                    lngLats: Rl,
                                    lngLat: Wn.unproject(Ul),
                                    originalEvent: Co
                                }), this._defaultPrevented = !1;
                            }
                        }
                        class Lo extends rt.l {
                            preventDefault() {
                                this._defaultPrevented = !0;
                            }
                            get defaultPrevented() {
                                return this._defaultPrevented;
                            }
                            constructor(Qe, rt, Wn){
                                super(Qe, {
                                    originalEvent: Wn
                                }), this._defaultPrevented = !1;
                            }
                        }
                        class ko {
                            constructor(Qe, rt){
                                this._map = Qe, this._clickTolerance = rt.clickTolerance;
                            }
                            reset() {
                                delete this._mousedownPos;
                            }
                            wheel(Qe) {
                                return this._firePreventable(new Lo(Qe.type, this._map, Qe));
                            }
                            mousedown(Qe, rt) {
                                return this._mousedownPos = rt, this._firePreventable(new zo(Qe.type, this._map, Qe));
                            }
                            mouseup(Qe) {
                                this._map.fire(new zo(Qe.type, this._map, Qe));
                            }
                            click(Qe, rt) {
                                this._mousedownPos && this._mousedownPos.dist(rt) >= this._clickTolerance || this._map.fire(new zo(Qe.type, this._map, Qe));
                            }
                            dblclick(Qe) {
                                return this._firePreventable(new zo(Qe.type, this._map, Qe));
                            }
                            mouseover(Qe) {
                                this._map.fire(new zo(Qe.type, this._map, Qe));
                            }
                            mouseout(Qe) {
                                this._map.fire(new zo(Qe.type, this._map, Qe));
                            }
                            touchstart(Qe) {
                                return this._firePreventable(new Ao(Qe.type, this._map, Qe));
                            }
                            touchmove(Qe) {
                                this._map.fire(new Ao(Qe.type, this._map, Qe));
                            }
                            touchend(Qe) {
                                this._map.fire(new Ao(Qe.type, this._map, Qe));
                            }
                            touchcancel(Qe) {
                                this._map.fire(new Ao(Qe.type, this._map, Qe));
                            }
                            _firePreventable(Qe) {
                                if (this._map.fire(Qe), Qe.defaultPrevented) return {};
                            }
                            isEnabled() {
                                return !0;
                            }
                            isActive() {
                                return !1;
                            }
                            enable() {}
                            disable() {}
                        }
                        class Fo {
                            constructor(Qe){
                                this._map = Qe;
                            }
                            reset() {
                                this._delayContextMenu = !1, this._ignoreContextMenu = !0, delete this._contextMenuEvent;
                            }
                            mousemove(Qe) {
                                this._map.fire(new zo(Qe.type, this._map, Qe));
                            }
                            mousedown() {
                                this._delayContextMenu = !0, this._ignoreContextMenu = !1;
                            }
                            mouseup() {
                                this._delayContextMenu = !1, this._contextMenuEvent && (this._map.fire(new zo("contextmenu", this._map, this._contextMenuEvent)), delete this._contextMenuEvent);
                            }
                            contextmenu(Qe) {
                                this._delayContextMenu ? this._contextMenuEvent = Qe : this._ignoreContextMenu || this._map.fire(new zo(Qe.type, this._map, Qe)), this._map.listens("contextmenu") && Qe.preventDefault();
                            }
                            isEnabled() {
                                return !0;
                            }
                            isActive() {
                                return !1;
                            }
                            enable() {}
                            disable() {}
                        }
                        class Bo {
                            constructor(Qe){
                                this._map = Qe;
                            }
                            get transform() {
                                return this._map._requestedCameraState || this._map.transform;
                            }
                            get center() {
                                return {
                                    lng: this.transform.center.lng,
                                    lat: this.transform.center.lat
                                };
                            }
                            get zoom() {
                                return this.transform.zoom;
                            }
                            get pitch() {
                                return this.transform.pitch;
                            }
                            get bearing() {
                                return this.transform.bearing;
                            }
                            unproject(Qe) {
                                return this.transform.screenPointToLocation(rt.P.convert(Qe), this._map.terrain);
                            }
                        }
                        class Oo {
                            constructor(Qe, rt){
                                this._map = Qe, this._tr = new Bo(Qe), this._el = Qe.getCanvasContainer(), this._container = Qe.getContainer(), this._clickTolerance = rt.clickTolerance || 1;
                            }
                            isEnabled() {
                                return !!this._enabled;
                            }
                            isActive() {
                                return !!this._active;
                            }
                            enable() {
                                this.isEnabled() || (this._enabled = !0);
                            }
                            disable() {
                                this.isEnabled() && (this._enabled = !1);
                            }
                            mousedown(Qe, rt) {
                                this.isEnabled() && Qe.shiftKey && 0 === Qe.button && (n.disableDrag(), this._startPos = this._lastPos = rt, this._active = !0);
                            }
                            mousemoveWindow(Qe, rt) {
                                if (!this._active) return;
                                const Wn = rt;
                                if (this._lastPos.equals(Wn) || !this._box && Wn.dist(this._startPos) < this._clickTolerance) return;
                                const Co = this._startPos;
                                this._lastPos = Wn, this._box || (this._box = n.create("div", "maplibregl-boxzoom", this._container), this._container.classList.add("maplibregl-crosshair"), this._fireEvent("boxzoomstart", Qe));
                                const Dl = Math.min(Co.x, Wn.x), Ll = Math.max(Co.x, Wn.x), Rl = Math.min(Co.y, Wn.y), Ul = Math.max(Co.y, Wn.y);
                                n.setTransform(this._box, `translate(${Dl}px,${Rl}px)`), this._box.style.width = Ll - Dl + "px", this._box.style.height = Ul - Rl + "px";
                            }
                            mouseupWindow(Qe, Wn) {
                                if (!this._active) return;
                                if (0 !== Qe.button) return;
                                const Co = this._startPos, Dl = Wn;
                                if (this.reset(), n.suppressClick(), Co.x !== Dl.x || Co.y !== Dl.y) return this._map.fire(new rt.l("boxzoomend", {
                                    originalEvent: Qe
                                })), {
                                    cameraAnimation: (Qe)=>Qe.fitScreenCoordinates(Co, Dl, this._tr.bearing, {
                                            linear: !0
                                        })
                                };
                                this._fireEvent("boxzoomcancel", Qe);
                            }
                            keydown(Qe) {
                                this._active && 27 === Qe.keyCode && (this.reset(), this._fireEvent("boxzoomcancel", Qe));
                            }
                            reset() {
                                this._active = !1, this._container.classList.remove("maplibregl-crosshair"), this._box && (n.remove(this._box), this._box = null), n.enableDrag(), delete this._startPos, delete this._lastPos;
                            }
                            _fireEvent(Qe, Wn) {
                                return this._map.fire(new rt.l(Qe, {
                                    originalEvent: Wn
                                }));
                            }
                        }
                        function jo(Qe, rt) {
                            if (Qe.length !== rt.length) throw new Error(`The number of touches and points are not equal - touches ${Qe.length}, points ${rt.length}`);
                            const Wn = {};
                            for(let Co = 0; Co < Qe.length; Co++)Wn[Qe[Co].identifier] = rt[Co];
                            return Wn;
                        }
                        class Zo {
                            constructor(Qe){
                                this.reset(), this.numTouches = Qe.numTouches;
                            }
                            reset() {
                                delete this.centroid, delete this.startTime, delete this.touches, this.aborted = !1;
                            }
                            touchstart(Qe, Wn, Co) {
                                (this.centroid || Co.length > this.numTouches) && (this.aborted = !0), this.aborted || (void 0 === this.startTime && (this.startTime = Qe.timeStamp), Co.length === this.numTouches && (this.centroid = function(Qe) {
                                    const Wn = new rt.P(0, 0);
                                    for (const rt of Qe)Wn._add(rt);
                                    return Wn.div(Qe.length);
                                }(Wn), this.touches = jo(Co, Wn)));
                            }
                            touchmove(Qe, rt, Wn) {
                                if (this.aborted || !this.centroid) return;
                                const Co = jo(Wn, rt);
                                for(const Dl in this.touches){
                                    const Qe = Co[Dl];
                                    (!Qe || Qe.dist(this.touches[Dl]) > 30) && (this.aborted = !0);
                                }
                            }
                            touchend(Qe, rt, Wn) {
                                if ((!this.centroid || Qe.timeStamp - this.startTime > 500) && (this.aborted = !0), 0 === Wn.length) {
                                    const Qe = !this.aborted && this.centroid;
                                    if (this.reset(), Qe) return Qe;
                                }
                            }
                        }
                        class No {
                            constructor(Qe){
                                this.singleTap = new Zo(Qe), this.numTaps = Qe.numTaps, this.reset();
                            }
                            reset() {
                                this.lastTime = 1 / 0, delete this.lastTap, this.count = 0, this.singleTap.reset();
                            }
                            touchstart(Qe, rt, Wn) {
                                this.singleTap.touchstart(Qe, rt, Wn);
                            }
                            touchmove(Qe, rt, Wn) {
                                this.singleTap.touchmove(Qe, rt, Wn);
                            }
                            touchend(Qe, rt, Wn) {
                                const Co = this.singleTap.touchend(Qe, rt, Wn);
                                if (Co) {
                                    const rt = Qe.timeStamp - this.lastTime < 500, Wn = !this.lastTap || this.lastTap.dist(Co) < 30;
                                    if (rt && Wn || this.reset(), this.count++, this.lastTime = Qe.timeStamp, this.lastTap = Co, this.count === this.numTaps) return this.reset(), Co;
                                }
                            }
                        }
                        class Go {
                            constructor(Qe){
                                this._tr = new Bo(Qe), this._zoomIn = new No({
                                    numTouches: 1,
                                    numTaps: 2
                                }), this._zoomOut = new No({
                                    numTouches: 2,
                                    numTaps: 1
                                }), this.reset();
                            }
                            reset() {
                                this._active = !1, this._zoomIn.reset(), this._zoomOut.reset();
                            }
                            touchstart(Qe, rt, Wn) {
                                this._zoomIn.touchstart(Qe, rt, Wn), this._zoomOut.touchstart(Qe, rt, Wn);
                            }
                            touchmove(Qe, rt, Wn) {
                                this._zoomIn.touchmove(Qe, rt, Wn), this._zoomOut.touchmove(Qe, rt, Wn);
                            }
                            touchend(Qe, rt, Wn) {
                                const Co = this._zoomIn.touchend(Qe, rt, Wn), Dl = this._zoomOut.touchend(Qe, rt, Wn), Ll = this._tr;
                                return Co ? (this._active = !0, Qe.preventDefault(), setTimeout(()=>this.reset(), 0), {
                                    cameraAnimation: (rt)=>rt.easeTo({
                                            duration: 300,
                                            zoom: Ll.zoom + 1,
                                            around: Ll.unproject(Co)
                                        }, {
                                            originalEvent: Qe
                                        })
                                }) : Dl ? (this._active = !0, Qe.preventDefault(), setTimeout(()=>this.reset(), 0), {
                                    cameraAnimation: (rt)=>rt.easeTo({
                                            duration: 300,
                                            zoom: Ll.zoom - 1,
                                            around: Ll.unproject(Dl)
                                        }, {
                                            originalEvent: Qe
                                        })
                                }) : void 0;
                            }
                            touchcancel() {
                                this.reset();
                            }
                            enable() {
                                this._enabled = !0;
                            }
                            disable() {
                                this._enabled = !1, this.reset();
                            }
                            isEnabled() {
                                return this._enabled;
                            }
                            isActive() {
                                return this._active;
                            }
                        }
                        class Uo {
                            constructor(Qe){
                                this._enabled = !!Qe.enable, this._moveStateManager = Qe.moveStateManager, this._clickTolerance = Qe.clickTolerance || 1, this._moveFunction = Qe.move, this._activateOnStart = !!Qe.activateOnStart, Qe.assignEvents(this), this.reset();
                            }
                            reset(Qe) {
                                this._active = !1, this._moved = !1, delete this._lastPoint, this._moveStateManager.endMove(Qe);
                            }
                            _move(...Qe) {
                                const rt = this._moveFunction(...Qe);
                                if (rt.bearingDelta || rt.pitchDelta || rt.rollDelta || rt.around || rt.panDelta) return this._active = !0, rt;
                            }
                            dragStart(Qe, rt) {
                                this.isEnabled() && !this._lastPoint && this._moveStateManager.isValidStartEvent(Qe) && (this._moveStateManager.startMove(Qe), this._lastPoint = Array.isArray(rt) ? rt[0] : rt, this._activateOnStart && this._lastPoint && (this._active = !0));
                            }
                            dragMove(Qe, rt) {
                                if (!this.isEnabled()) return;
                                const Wn = this._lastPoint;
                                if (!Wn) return;
                                if (Qe.preventDefault(), !this._moveStateManager.isValidMoveEvent(Qe)) return void this.reset(Qe);
                                const Co = Array.isArray(rt) ? rt[0] : rt;
                                return !this._moved && Co.dist(Wn) < this._clickTolerance ? void 0 : (this._moved = !0, this._lastPoint = Co, this._move(Wn, Co));
                            }
                            dragEnd(Qe) {
                                this.isEnabled() && this._lastPoint && this._moveStateManager.isValidEndEvent(Qe) && (this._moved && n.suppressClick(), this.reset(Qe));
                            }
                            enable() {
                                this._enabled = !0;
                            }
                            disable() {
                                this._enabled = !1, this.reset();
                            }
                            isEnabled() {
                                return this._enabled;
                            }
                            isActive() {
                                return this._active;
                            }
                            getClickTolerance() {
                                return this._clickTolerance;
                            }
                        }
                        const Rd = {
                            0: 1,
                            2: 2
                        };
                        class qo {
                            constructor(Qe){
                                this._correctEvent = Qe.checkCorrectEvent;
                            }
                            startMove(Qe) {
                                const rt = n.mouseButton(Qe);
                                this._eventButton = rt;
                            }
                            endMove(Qe) {
                                delete this._eventButton;
                            }
                            isValidStartEvent(Qe) {
                                return this._correctEvent(Qe);
                            }
                            isValidMoveEvent(Qe) {
                                return !function(Qe, rt) {
                                    const Wn = Rd[rt];
                                    return void 0 === Qe.buttons || (Qe.buttons & Wn) !== Wn;
                                }(Qe, this._eventButton);
                            }
                            isValidEndEvent(Qe) {
                                return n.mouseButton(Qe) === this._eventButton;
                            }
                        }
                        class Wo {
                            constructor(){
                                this._firstTouch = void 0;
                            }
                            _isOneFingerTouch(Qe) {
                                return 1 === Qe.targetTouches.length;
                            }
                            _isSameTouchEvent(Qe) {
                                return Qe.targetTouches[0].identifier === this._firstTouch;
                            }
                            startMove(Qe) {
                                this._firstTouch = Qe.targetTouches[0].identifier;
                            }
                            endMove(Qe) {
                                delete this._firstTouch;
                            }
                            isValidStartEvent(Qe) {
                                return this._isOneFingerTouch(Qe);
                            }
                            isValidMoveEvent(Qe) {
                                return this._isOneFingerTouch(Qe) && this._isSameTouchEvent(Qe);
                            }
                            isValidEndEvent(Qe) {
                                return this._isOneFingerTouch(Qe) && this._isSameTouchEvent(Qe);
                            }
                        }
                        class $o {
                            constructor(Qe = new qo({
                                checkCorrectEvent: ()=>!0
                            }), rt = new Wo){
                                this.mouseMoveStateManager = Qe, this.oneFingerTouchMoveStateManager = rt;
                            }
                            _executeRelevantHandler(Qe, rt, Wn) {
                                return Qe instanceof MouseEvent ? rt(Qe) : "undefined" != typeof TouchEvent && Qe instanceof TouchEvent ? Wn(Qe) : void 0;
                            }
                            startMove(Qe) {
                                this._executeRelevantHandler(Qe, (Qe)=>this.mouseMoveStateManager.startMove(Qe), (Qe)=>this.oneFingerTouchMoveStateManager.startMove(Qe));
                            }
                            endMove(Qe) {
                                this._executeRelevantHandler(Qe, (Qe)=>this.mouseMoveStateManager.endMove(Qe), (Qe)=>this.oneFingerTouchMoveStateManager.endMove(Qe));
                            }
                            isValidStartEvent(Qe) {
                                return this._executeRelevantHandler(Qe, (Qe)=>this.mouseMoveStateManager.isValidStartEvent(Qe), (Qe)=>this.oneFingerTouchMoveStateManager.isValidStartEvent(Qe));
                            }
                            isValidMoveEvent(Qe) {
                                return this._executeRelevantHandler(Qe, (Qe)=>this.mouseMoveStateManager.isValidMoveEvent(Qe), (Qe)=>this.oneFingerTouchMoveStateManager.isValidMoveEvent(Qe));
                            }
                            isValidEndEvent(Qe) {
                                return this._executeRelevantHandler(Qe, (Qe)=>this.mouseMoveStateManager.isValidEndEvent(Qe), (Qe)=>this.oneFingerTouchMoveStateManager.isValidEndEvent(Qe));
                            }
                        }
                        const Ho = (Qe)=>{
                            Qe.mousedown = Qe.dragStart, Qe.mousemoveWindow = Qe.dragMove, Qe.mouseup = Qe.dragEnd, Qe.contextmenu = (Qe)=>{
                                Qe.preventDefault();
                            };
                        };
                        class Ko {
                            constructor(Qe, rt){
                                this._clickTolerance = Qe.clickTolerance || 1, this._map = rt, this.reset();
                            }
                            reset() {
                                this._active = !1, this._touches = {}, this._sum = new rt.P(0, 0);
                            }
                            _shouldBePrevented(Qe) {
                                return Qe < (this._map.cooperativeGestures.isEnabled() ? 2 : 1);
                            }
                            touchstart(Qe, rt, Wn) {
                                return this._calculateTransform(Qe, rt, Wn);
                            }
                            touchmove(Qe, rt, Wn) {
                                if (this._active) {
                                    if (!this._shouldBePrevented(Wn.length)) return Qe.preventDefault(), this._calculateTransform(Qe, rt, Wn);
                                    this._map.cooperativeGestures.notifyGestureBlocked("touch_pan", Qe);
                                }
                            }
                            touchend(Qe, rt, Wn) {
                                this._calculateTransform(Qe, rt, Wn), this._active && this._shouldBePrevented(Wn.length) && this.reset();
                            }
                            touchcancel() {
                                this.reset();
                            }
                            _calculateTransform(Qe, Wn, Co) {
                                Co.length > 0 && (this._active = !0);
                                const Dl = jo(Co, Wn), Ll = new rt.P(0, 0), Rl = new rt.P(0, 0);
                                let Ul = 0;
                                for(const rt in Dl){
                                    const Qe = Dl[rt], Wn = this._touches[rt];
                                    Wn && (Ll._add(Qe), Rl._add(Qe.sub(Wn)), Ul++, Dl[rt] = Qe);
                                }
                                if (this._touches = Dl, this._shouldBePrevented(Ul) || !Rl.mag()) return;
                                const Gl = Rl.div(Ul);
                                return this._sum._add(Gl), this._sum.mag() < this._clickTolerance ? void 0 : {
                                    around: Ll.div(Ul),
                                    panDelta: Gl
                                };
                            }
                            enable() {
                                this._enabled = !0;
                            }
                            disable() {
                                this._enabled = !1, this.reset();
                            }
                            isEnabled() {
                                return this._enabled;
                            }
                            isActive() {
                                return this._active;
                            }
                        }
                        class Xo {
                            constructor(){
                                this.reset();
                            }
                            reset() {
                                this._active = !1, delete this._firstTwoTouches;
                            }
                            touchstart(Qe, rt, Wn) {
                                this._firstTwoTouches || Wn.length < 2 || (this._firstTwoTouches = [
                                    Wn[0].identifier,
                                    Wn[1].identifier
                                ], this._start([
                                    rt[0],
                                    rt[1]
                                ]));
                            }
                            touchmove(Qe, rt, Wn) {
                                if (!this._firstTwoTouches) return;
                                Qe.preventDefault();
                                const [Co, Dl] = this._firstTwoTouches, Ll = Qo(Wn, rt, Co), Rl = Qo(Wn, rt, Dl);
                                if (!Ll || !Rl) return;
                                const Ul = this._aroundCenter ? null : Ll.add(Rl).div(2);
                                return this._move([
                                    Ll,
                                    Rl
                                ], Ul, Qe);
                            }
                            touchend(Qe, rt, Wn) {
                                if (!this._firstTwoTouches) return;
                                const [Co, Dl] = this._firstTwoTouches, Ll = Qo(Wn, rt, Co), Rl = Qo(Wn, rt, Dl);
                                Ll && Rl || (this._active && n.suppressClick(), this.reset());
                            }
                            touchcancel() {
                                this.reset();
                            }
                            enable(Qe) {
                                this._enabled = !0, this._aroundCenter = !!Qe && "center" === Qe.around;
                            }
                            disable() {
                                this._enabled = !1, this.reset();
                            }
                            isEnabled() {
                                return !!this._enabled;
                            }
                            isActive() {
                                return !!this._active;
                            }
                        }
                        function Qo(Qe, rt, Wn) {
                            for(let Co = 0; Co < Qe.length; Co++)if (Qe[Co].identifier === Wn) return rt[Co];
                        }
                        function Yo(Qe, rt) {
                            return Math.log(Qe / rt) / Math.LN2;
                        }
                        class Jo extends Xo {
                            reset() {
                                super.reset(), delete this._distance, delete this._startDistance;
                            }
                            _start(Qe) {
                                this._startDistance = this._distance = Qe[0].dist(Qe[1]);
                            }
                            _move(Qe, rt) {
                                const Wn = this._distance;
                                if (this._distance = Qe[0].dist(Qe[1]), this._active || !(Math.abs(Yo(this._distance, this._startDistance)) < .1)) return this._active = !0, {
                                    zoomDelta: Yo(this._distance, Wn),
                                    pinchAround: rt
                                };
                            }
                        }
                        function ea(Qe, rt) {
                            return 180 * Qe.angleWith(rt) / Math.PI;
                        }
                        class ta extends Xo {
                            reset() {
                                super.reset(), delete this._minDiameter, delete this._startVector, delete this._vector;
                            }
                            _start(Qe) {
                                this._startVector = this._vector = Qe[0].sub(Qe[1]), this._minDiameter = Qe[0].dist(Qe[1]);
                            }
                            _move(Qe, rt, Wn) {
                                const Co = this._vector;
                                if (this._vector = Qe[0].sub(Qe[1]), this._active || !this._isBelowThreshold(this._vector)) return this._active = !0, {
                                    bearingDelta: ea(this._vector, Co),
                                    pinchAround: rt
                                };
                            }
                            _isBelowThreshold(Qe) {
                                this._minDiameter = Math.min(this._minDiameter, Qe.mag());
                                const rt = 25 / (Math.PI * this._minDiameter) * 360, Wn = ea(Qe, this._startVector);
                                return Math.abs(Wn) < rt;
                            }
                        }
                        function ia(Qe) {
                            return Math.abs(Qe.y) > Math.abs(Qe.x);
                        }
                        class ra extends Xo {
                            constructor(Qe){
                                super(), this._currentTouchCount = 0, this._map = Qe;
                            }
                            reset() {
                                super.reset(), this._valid = void 0, delete this._firstMove, delete this._lastPoints;
                            }
                            touchstart(Qe, rt, Wn) {
                                super.touchstart(Qe, rt, Wn), this._currentTouchCount = Wn.length;
                            }
                            _start(Qe) {
                                this._lastPoints = Qe, ia(Qe[0].sub(Qe[1])) && (this._valid = !1);
                            }
                            _move(Qe, rt, Wn) {
                                if (this._map.cooperativeGestures.isEnabled() && this._currentTouchCount < 3) return;
                                const Co = Qe[0].sub(this._lastPoints[0]), Dl = Qe[1].sub(this._lastPoints[1]);
                                return this._valid = this.gestureBeginsVertically(Co, Dl, Wn.timeStamp), this._valid ? (this._lastPoints = Qe, this._active = !0, {
                                    pitchDelta: (Co.y + Dl.y) / 2 * -0.5
                                }) : void 0;
                            }
                            gestureBeginsVertically(Qe, rt, Wn) {
                                if (void 0 !== this._valid) return this._valid;
                                const Co = Qe.mag() >= 2, Dl = rt.mag() >= 2;
                                if (!Co && !Dl) return;
                                if (!Co || !Dl) return void 0 === this._firstMove && (this._firstMove = Wn), Wn - this._firstMove < 100 && void 0;
                                const Ll = Qe.y > 0 == rt.y > 0;
                                return ia(Qe) && ia(rt) && Ll;
                            }
                        }
                        const Bd = {
                            panStep: 100,
                            bearingStep: 15,
                            pitchStep: 10
                        };
                        class aa {
                            constructor(Qe){
                                this._tr = new Bo(Qe);
                                const rt = Bd;
                                this._panStep = rt.panStep, this._bearingStep = rt.bearingStep, this._pitchStep = rt.pitchStep, this._rotationDisabled = !1;
                            }
                            reset() {
                                this._active = !1;
                            }
                            keydown(Qe) {
                                if (Qe.altKey || Qe.ctrlKey || Qe.metaKey) return;
                                let rt = 0, Wn = 0, Co = 0, Dl = 0, Ll = 0;
                                switch(Qe.keyCode){
                                    case 61:
                                    case 107:
                                    case 171:
                                    case 187:
                                        rt = 1;
                                        break;
                                    case 189:
                                    case 109:
                                    case 173:
                                        rt = -1;
                                        break;
                                    case 37:
                                        Qe.shiftKey ? Wn = -1 : (Qe.preventDefault(), Dl = -1);
                                        break;
                                    case 39:
                                        Qe.shiftKey ? Wn = 1 : (Qe.preventDefault(), Dl = 1);
                                        break;
                                    case 38:
                                        Qe.shiftKey ? Co = 1 : (Qe.preventDefault(), Ll = -1);
                                        break;
                                    case 40:
                                        Qe.shiftKey ? Co = -1 : (Qe.preventDefault(), Ll = 1);
                                        break;
                                    default:
                                        return;
                                }
                                return this._rotationDisabled && (Wn = 0, Co = 0), {
                                    cameraAnimation: (Rl)=>{
                                        const Ul = this._tr;
                                        Rl.easeTo({
                                            duration: 300,
                                            easeId: "keyboardHandler",
                                            easing: sa,
                                            zoom: rt ? Math.round(Ul.zoom) + rt * (Qe.shiftKey ? 2 : 1) : Ul.zoom,
                                            bearing: Ul.bearing + Wn * this._bearingStep,
                                            pitch: Ul.pitch + Co * this._pitchStep,
                                            offset: [
                                                -Dl * this._panStep,
                                                -Ll * this._panStep
                                            ],
                                            center: Ul.center
                                        }, {
                                            originalEvent: Qe
                                        });
                                    }
                                };
                            }
                            enable() {
                                this._enabled = !0;
                            }
                            disable() {
                                this._enabled = !1, this.reset();
                            }
                            isEnabled() {
                                return this._enabled;
                            }
                            isActive() {
                                return this._active;
                            }
                            disableRotation() {
                                this._rotationDisabled = !0;
                            }
                            enableRotation() {
                                this._rotationDisabled = !1;
                            }
                        }
                        function sa(Qe) {
                            return Qe * (2 - Qe);
                        }
                        const Od = 4.000244140625;
                        class la {
                            constructor(Qe, rt){
                                this._onTimeout = (Qe)=>{
                                    this._type = "wheel", this._delta -= this._lastValue, this._active || this._start(Qe);
                                }, this._map = Qe, this._tr = new Bo(Qe), this._triggerRenderFrame = rt, this._delta = 0, this._defaultZoomRate = .01, this._wheelZoomRate = .0022222222222222222;
                            }
                            setZoomRate(Qe) {
                                this._defaultZoomRate = Qe;
                            }
                            setWheelZoomRate(Qe) {
                                this._wheelZoomRate = Qe;
                            }
                            isEnabled() {
                                return !!this._enabled;
                            }
                            isActive() {
                                return !!this._active || void 0 !== this._finishTimeout;
                            }
                            isZooming() {
                                return !!this._zooming;
                            }
                            enable(Qe) {
                                this.isEnabled() || (this._enabled = !0, this._aroundCenter = !!Qe && "center" === Qe.around);
                            }
                            disable() {
                                this.isEnabled() && (this._enabled = !1);
                            }
                            _shouldBePrevented(Qe) {
                                return !!this._map.cooperativeGestures.isEnabled() && !(Qe.ctrlKey || this._map.cooperativeGestures.isBypassed(Qe));
                            }
                            wheel(Qe) {
                                if (!this.isEnabled()) return;
                                if (this._shouldBePrevented(Qe)) return void this._map.cooperativeGestures.notifyGestureBlocked("wheel_zoom", Qe);
                                let rt = Qe.deltaMode === WheelEvent.DOM_DELTA_LINE ? 40 * Qe.deltaY : Qe.deltaY;
                                const Wn = Ll.now(), Co = Wn - (this._lastWheelEventTime || 0);
                                this._lastWheelEventTime = Wn, 0 !== rt && rt % Od == 0 ? this._type = "wheel" : 0 !== rt && Math.abs(rt) < 4 ? this._type = "trackpad" : Co > 400 ? (this._type = null, this._lastValue = rt, this._timeout = setTimeout(this._onTimeout, 40, Qe)) : this._type || (this._type = Math.abs(Co * rt) < 200 ? "trackpad" : "wheel", this._timeout && (clearTimeout(this._timeout), this._timeout = null, rt += this._lastValue)), Qe.shiftKey && rt && (rt /= 4), this._type && (this._lastWheelEvent = Qe, this._delta -= rt, this._active || this._start(Qe)), Qe.preventDefault();
                            }
                            _start(Qe) {
                                if (!this._delta) return;
                                this._frameId && (this._frameId = null), this._active = !0, this.isZooming() || (this._zooming = !0), this._finishTimeout && (clearTimeout(this._finishTimeout), delete this._finishTimeout);
                                const Wn = n.mousePos(this._map.getCanvas(), Qe), Co = this._tr;
                                this._aroundPoint = this._aroundCenter ? Co.transform.locationToScreenPoint(rt.Q.convert(Co.center)) : Wn, this._frameId || (this._frameId = !0, this._triggerRenderFrame());
                            }
                            renderFrame() {
                                if (!this._frameId) return;
                                if (this._frameId = null, !this.isActive()) return;
                                const Qe = this._tr.transform;
                                if ("number" == typeof this._lastExpectedZoom) {
                                    const rt = Qe.zoom - this._lastExpectedZoom;
                                    "number" == typeof this._startZoom && (this._startZoom += rt), "number" == typeof this._targetZoom && (this._targetZoom += rt);
                                }
                                if (0 !== this._delta) {
                                    const Wn = "wheel" === this._type && Math.abs(this._delta) > Od ? this._wheelZoomRate : this._defaultZoomRate;
                                    let Co = 2 / (1 + Math.exp(-Math.abs(this._delta * Wn)));
                                    this._delta < 0 && 0 !== Co && (Co = 1 / Co);
                                    const Dl = "number" != typeof this._targetZoom ? Qe.scale : rt.aI(this._targetZoom);
                                    this._targetZoom = Math.min(Qe.maxZoom, Math.max(Qe.minZoom, rt.ab(Dl * Co))), "wheel" === this._type && (this._startZoom = Qe.zoom, this._easing = this._smoothOutEasing(200)), this._delta = 0;
                                }
                                const Wn = "number" != typeof this._targetZoom ? Qe.zoom : this._targetZoom, Co = this._startZoom, Dl = this._easing;
                                let Rl, Ul = !1;
                                if ("wheel" === this._type && Co && Dl) {
                                    const Qe = Ll.now() - this._lastWheelEventTime, Gl = Math.min((Qe + 5) / 200, 1), Zl = Dl(Gl);
                                    Rl = rt.B.number(Co, Wn, Zl), Gl < 1 ? this._frameId || (this._frameId = !0) : Ul = !0;
                                } else Rl = Wn, Ul = !0;
                                return this._active = !0, Ul && (this._active = !1, this._finishTimeout = setTimeout(()=>{
                                    this._zooming = !1, this._triggerRenderFrame(), delete this._targetZoom, delete this._lastExpectedZoom, delete this._finishTimeout;
                                }, 200)), this._lastExpectedZoom = Rl, {
                                    noInertia: !0,
                                    needsRenderFrame: !Ul,
                                    zoomDelta: Rl - Qe.zoom,
                                    around: this._aroundPoint,
                                    originalEvent: this._lastWheelEvent
                                };
                            }
                            _smoothOutEasing(Qe) {
                                let Wn = rt.cb;
                                if (this._prevEase) {
                                    const Qe = this._prevEase, Co = (Ll.now() - Qe.start) / Qe.duration, Dl = Qe.easing(Co + .01) - Qe.easing(Co), Rl = .27 / Math.sqrt(Dl * Dl + 1e-4) * .01, Ul = Math.sqrt(.0729 - Rl * Rl);
                                    Wn = rt.c9(Rl, Ul, .25, 1);
                                }
                                return this._prevEase = {
                                    start: Ll.now(),
                                    duration: Qe,
                                    easing: Wn
                                }, Wn;
                            }
                            reset() {
                                this._active = !1, this._zooming = !1, delete this._targetZoom, delete this._lastExpectedZoom, this._finishTimeout && (clearTimeout(this._finishTimeout), delete this._finishTimeout);
                            }
                        }
                        class ca {
                            constructor(Qe, rt){
                                this._clickZoom = Qe, this._tapZoom = rt;
                            }
                            enable() {
                                this._clickZoom.enable(), this._tapZoom.enable();
                            }
                            disable() {
                                this._clickZoom.disable(), this._tapZoom.disable();
                            }
                            isEnabled() {
                                return this._clickZoom.isEnabled() && this._tapZoom.isEnabled();
                            }
                            isActive() {
                                return this._clickZoom.isActive() || this._tapZoom.isActive();
                            }
                        }
                        class ha {
                            constructor(Qe){
                                this._tr = new Bo(Qe), this.reset();
                            }
                            reset() {
                                this._active = !1;
                            }
                            dblclick(Qe, rt) {
                                return Qe.preventDefault(), {
                                    cameraAnimation: (Wn)=>{
                                        Wn.easeTo({
                                            duration: 300,
                                            zoom: this._tr.zoom + (Qe.shiftKey ? -1 : 1),
                                            around: this._tr.unproject(rt)
                                        }, {
                                            originalEvent: Qe
                                        });
                                    }
                                };
                            }
                            enable() {
                                this._enabled = !0;
                            }
                            disable() {
                                this._enabled = !1, this.reset();
                            }
                            isEnabled() {
                                return this._enabled;
                            }
                            isActive() {
                                return this._active;
                            }
                        }
                        class ua {
                            constructor(){
                                this._tap = new No({
                                    numTouches: 1,
                                    numTaps: 1
                                }), this.reset();
                            }
                            reset() {
                                this._active = !1, delete this._swipePoint, delete this._swipeTouch, delete this._tapTime, delete this._tapPoint, this._tap.reset();
                            }
                            touchstart(Qe, rt, Wn) {
                                if (!this._swipePoint) {
                                    if (this._tapTime) {
                                        const Co = rt[0], Dl = Qe.timeStamp - this._tapTime < 500, Ll = this._tapPoint.dist(Co) < 30;
                                        Dl && Ll ? Wn.length > 0 && (this._swipePoint = Co, this._swipeTouch = Wn[0].identifier) : this.reset();
                                    } else this._tap.touchstart(Qe, rt, Wn);
                                }
                            }
                            touchmove(Qe, rt, Wn) {
                                if (this._tapTime) {
                                    if (this._swipePoint) {
                                        if (Wn[0].identifier !== this._swipeTouch) return;
                                        const Co = rt[0], Dl = Co.y - this._swipePoint.y;
                                        return this._swipePoint = Co, Qe.preventDefault(), this._active = !0, {
                                            zoomDelta: Dl / 128
                                        };
                                    }
                                } else this._tap.touchmove(Qe, rt, Wn);
                            }
                            touchend(Qe, rt, Wn) {
                                if (this._tapTime) this._swipePoint && 0 === Wn.length && this.reset();
                                else {
                                    const Co = this._tap.touchend(Qe, rt, Wn);
                                    Co && (this._tapTime = Qe.timeStamp, this._tapPoint = Co);
                                }
                            }
                            touchcancel() {
                                this.reset();
                            }
                            enable() {
                                this._enabled = !0;
                            }
                            disable() {
                                this._enabled = !1, this.reset();
                            }
                            isEnabled() {
                                return this._enabled;
                            }
                            isActive() {
                                return this._active;
                            }
                        }
                        class da {
                            constructor(Qe, rt, Wn){
                                this._el = Qe, this._mousePan = rt, this._touchPan = Wn;
                            }
                            enable(Qe) {
                                this._inertiaOptions = Qe || {}, this._mousePan.enable(), this._touchPan.enable(), this._el.classList.add("maplibregl-touch-drag-pan");
                            }
                            disable() {
                                this._mousePan.disable(), this._touchPan.disable(), this._el.classList.remove("maplibregl-touch-drag-pan");
                            }
                            isEnabled() {
                                return this._mousePan.isEnabled() && this._touchPan.isEnabled();
                            }
                            isActive() {
                                return this._mousePan.isActive() || this._touchPan.isActive();
                            }
                        }
                        class _a {
                            constructor(Qe, rt, Wn, Co){
                                this._pitchWithRotate = Qe.pitchWithRotate, this._rollEnabled = Qe.rollEnabled, this._mouseRotate = rt, this._mousePitch = Wn, this._mouseRoll = Co;
                            }
                            enable() {
                                this._mouseRotate.enable(), this._pitchWithRotate && this._mousePitch.enable(), this._rollEnabled && this._mouseRoll.enable();
                            }
                            disable() {
                                this._mouseRotate.disable(), this._mousePitch.disable(), this._mouseRoll.disable();
                            }
                            isEnabled() {
                                return this._mouseRotate.isEnabled() && (!this._pitchWithRotate || this._mousePitch.isEnabled()) && (!this._rollEnabled || this._mouseRoll.isEnabled());
                            }
                            isActive() {
                                return this._mouseRotate.isActive() || this._mousePitch.isActive() || this._mouseRoll.isActive();
                            }
                        }
                        class pa {
                            constructor(Qe, rt, Wn, Co){
                                this._el = Qe, this._touchZoom = rt, this._touchRotate = Wn, this._tapDragZoom = Co, this._rotationDisabled = !1, this._enabled = !0;
                            }
                            enable(Qe) {
                                this._touchZoom.enable(Qe), this._rotationDisabled || this._touchRotate.enable(Qe), this._tapDragZoom.enable(), this._el.classList.add("maplibregl-touch-zoom-rotate");
                            }
                            disable() {
                                this._touchZoom.disable(), this._touchRotate.disable(), this._tapDragZoom.disable(), this._el.classList.remove("maplibregl-touch-zoom-rotate");
                            }
                            isEnabled() {
                                return this._touchZoom.isEnabled() && (this._rotationDisabled || this._touchRotate.isEnabled()) && this._tapDragZoom.isEnabled();
                            }
                            isActive() {
                                return this._touchZoom.isActive() || this._touchRotate.isActive() || this._tapDragZoom.isActive();
                            }
                            disableRotation() {
                                this._rotationDisabled = !0, this._touchRotate.disable();
                            }
                            enableRotation() {
                                this._rotationDisabled = !1, this._touchZoom.isEnabled() && this._touchRotate.enable();
                            }
                        }
                        class ma {
                            constructor(Qe, rt){
                                this._bypassKey = -1 !== navigator.userAgent.indexOf("Mac") ? "metaKey" : "ctrlKey", this._map = Qe, this._options = rt, this._enabled = !1;
                            }
                            isActive() {
                                return !1;
                            }
                            reset() {}
                            _setupUI() {
                                if (this._container) return;
                                const Qe = this._map.getCanvasContainer();
                                Qe.classList.add("maplibregl-cooperative-gestures"), this._container = n.create("div", "maplibregl-cooperative-gesture-screen", Qe);
                                let rt = this._map._getUIString("CooperativeGesturesHandler.WindowsHelpText");
                                "metaKey" === this._bypassKey && (rt = this._map._getUIString("CooperativeGesturesHandler.MacHelpText"));
                                const Wn = this._map._getUIString("CooperativeGesturesHandler.MobileHelpText"), Co = document.createElement("div");
                                Co.className = "maplibregl-desktop-message", Co.textContent = rt, this._container.appendChild(Co);
                                const Dl = document.createElement("div");
                                Dl.className = "maplibregl-mobile-message", Dl.textContent = Wn, this._container.appendChild(Dl), this._container.setAttribute("aria-hidden", "true");
                            }
                            _destroyUI() {
                                this._container && (n.remove(this._container), this._map.getCanvasContainer().classList.remove("maplibregl-cooperative-gestures")), delete this._container;
                            }
                            enable() {
                                this._setupUI(), this._enabled = !0;
                            }
                            disable() {
                                this._enabled = !1, this._destroyUI();
                            }
                            isEnabled() {
                                return this._enabled;
                            }
                            isBypassed(Qe) {
                                return Qe[this._bypassKey];
                            }
                            notifyGestureBlocked(Qe, Wn) {
                                this._enabled && (this._map.fire(new rt.l("cooperativegestureprevented", {
                                    gestureType: Qe,
                                    originalEvent: Wn
                                })), this._container.classList.add("maplibregl-show"), setTimeout(()=>{
                                    this._container.classList.remove("maplibregl-show");
                                }, 100));
                            }
                        }
                        const fa = (Qe)=>Qe.zoom || Qe.drag || Qe.roll || Qe.pitch || Qe.rotate;
                        class ga extends rt.l {
                        }
                        function va(Qe) {
                            return Qe.panDelta && Qe.panDelta.mag() || Qe.zoomDelta || Qe.bearingDelta || Qe.pitchDelta || Qe.rollDelta;
                        }
                        class xa {
                            constructor(Qe, Wn){
                                this.handleWindowEvent = (Qe)=>{
                                    this.handleEvent(Qe, `${Qe.type}Window`);
                                }, this.handleEvent = (Qe, Wn)=>{
                                    if ("blur" === Qe.type) return void this.stop(!0);
                                    this._updatingCamera = !0;
                                    const Co = "renderFrame" === Qe.type ? void 0 : Qe, Dl = {
                                        needsRenderFrame: !1
                                    }, Ll = {}, Rl = {};
                                    for (const { handlerName: Zl, handler: Hl, allowed: ql } of this._handlers){
                                        if (!Hl.isEnabled()) continue;
                                        let Ul;
                                        if (this._blockedByActive(Rl, ql, Zl)) Hl.reset();
                                        else if (Hl[Wn || Qe.type]) {
                                            if (rt.cc(Qe, Wn || Qe.type)) {
                                                const rt = n.mousePos(this._map.getCanvas(), Qe);
                                                Ul = Hl[Wn || Qe.type](Qe, rt);
                                            } else if (rt.cd(Qe, Wn || Qe.type)) {
                                                const rt = this._getMapTouches(Qe.touches), Co = n.touchPos(this._map.getCanvas(), rt);
                                                Ul = Hl[Wn || Qe.type](Qe, Co, rt);
                                            } else rt.ce(Wn || Qe.type) || (Ul = Hl[Wn || Qe.type](Qe));
                                            this.mergeHandlerResult(Dl, Ll, Ul, Zl, Co), Ul && Ul.needsRenderFrame && this._triggerRenderFrame();
                                        }
                                        (Ul || Hl.isActive()) && (Rl[Zl] = Hl);
                                    }
                                    const Ul = {};
                                    for(const rt in this._previousActiveHandlers)Rl[rt] || (Ul[rt] = Co);
                                    this._previousActiveHandlers = Rl, (Object.keys(Ul).length || va(Dl)) && (this._changes.push([
                                        Dl,
                                        Ll,
                                        Ul
                                    ]), this._triggerRenderFrame()), (Object.keys(Rl).length || va(Dl)) && this._map._stop(!0), this._updatingCamera = !1;
                                    const { cameraAnimation: Gl } = Dl;
                                    Gl && (this._inertia.clear(), this._fireEvents({}, {}, !0), this._changes = [], Gl(this._map));
                                }, this._map = Qe, this._el = this._map.getCanvasContainer(), this._handlers = [], this._handlersById = {}, this._changes = [], this._inertia = new So(Qe), this._bearingSnap = Wn.bearingSnap, this._previousActiveHandlers = {}, this._eventsInProgress = {}, this._addDefaultHandlers(Wn);
                                const Co = this._el;
                                this._listeners = [
                                    [
                                        Co,
                                        "touchstart",
                                        {
                                            passive: !0
                                        }
                                    ],
                                    [
                                        Co,
                                        "touchmove",
                                        {
                                            passive: !1
                                        }
                                    ],
                                    [
                                        Co,
                                        "touchend",
                                        void 0
                                    ],
                                    [
                                        Co,
                                        "touchcancel",
                                        void 0
                                    ],
                                    [
                                        Co,
                                        "mousedown",
                                        void 0
                                    ],
                                    [
                                        Co,
                                        "mousemove",
                                        void 0
                                    ],
                                    [
                                        Co,
                                        "mouseup",
                                        void 0
                                    ],
                                    [
                                        document,
                                        "mousemove",
                                        {
                                            capture: !0
                                        }
                                    ],
                                    [
                                        document,
                                        "mouseup",
                                        void 0
                                    ],
                                    [
                                        Co,
                                        "mouseover",
                                        void 0
                                    ],
                                    [
                                        Co,
                                        "mouseout",
                                        void 0
                                    ],
                                    [
                                        Co,
                                        "dblclick",
                                        void 0
                                    ],
                                    [
                                        Co,
                                        "click",
                                        void 0
                                    ],
                                    [
                                        Co,
                                        "keydown",
                                        {
                                            capture: !1
                                        }
                                    ],
                                    [
                                        Co,
                                        "keyup",
                                        void 0
                                    ],
                                    [
                                        Co,
                                        "wheel",
                                        {
                                            passive: !1
                                        }
                                    ],
                                    [
                                        Co,
                                        "contextmenu",
                                        void 0
                                    ],
                                    [
                                        window,
                                        "blur",
                                        void 0
                                    ]
                                ];
                                for (const [rt, Dl, Ll] of this._listeners)n.addEventListener(rt, Dl, rt === document ? this.handleWindowEvent : this.handleEvent, Ll);
                            }
                            destroy() {
                                for (const [Qe, rt, Wn] of this._listeners)n.removeEventListener(Qe, rt, Qe === document ? this.handleWindowEvent : this.handleEvent, Wn);
                            }
                            _addDefaultHandlers(Qe) {
                                const Wn = this._map, Co = Wn.getCanvasContainer();
                                this._add("mapEvent", new ko(Wn, Qe));
                                const Dl = Wn.boxZoom = new Oo(Wn, Qe);
                                this._add("boxZoom", Dl), Qe.interactive && Qe.boxZoom && Dl.enable();
                                const Ll = Wn.cooperativeGestures = new ma(Wn, Qe.cooperativeGestures);
                                this._add("cooperativeGestures", Ll), Qe.cooperativeGestures && Ll.enable();
                                const Rl = new Go(Wn), Ul = new ha(Wn);
                                Wn.doubleClickZoom = new ca(Ul, Rl), this._add("tapZoom", Rl), this._add("clickZoom", Ul), Qe.interactive && Qe.doubleClickZoom && Wn.doubleClickZoom.enable();
                                const Gl = new ua;
                                this._add("tapDragZoom", Gl);
                                const Zl = Wn.touchPitch = new ra(Wn);
                                this._add("touchPitch", Zl), Qe.interactive && Qe.touchPitch && Wn.touchPitch.enable(Qe.touchPitch);
                                const u = ()=>Wn.project(Wn.getCenter()), Hl = function({ enable: Qe, clickTolerance: Wn, aroundCenter: Co = !0, minPixelCenterThreshold: Dl = 100, rotateDegreesPerPixelMoved: Ll = .8 }, Rl) {
                                    const Ul = new qo({
                                        checkCorrectEvent: (Qe)=>0 === n.mouseButton(Qe) && Qe.ctrlKey || 2 === n.mouseButton(Qe) && !Qe.ctrlKey
                                    });
                                    return new Uo({
                                        clickTolerance: Wn,
                                        move: (Qe, Wn)=>{
                                            const Ul = Rl();
                                            if (Co && Math.abs(Ul.y - Qe.y) > Dl) return {
                                                bearingDelta: rt.ca(new rt.P(Qe.x, Wn.y), Wn, Ul)
                                            };
                                            let Gl = (Wn.x - Qe.x) * Ll;
                                            return Co && Wn.y < Ul.y && (Gl = -Gl), {
                                                bearingDelta: Gl
                                            };
                                        },
                                        moveStateManager: Ul,
                                        enable: Qe,
                                        assignEvents: Ho
                                    });
                                }(Qe, u), ql = function({ enable: Qe, clickTolerance: rt, pitchDegreesPerPixelMoved: Wn = -0.5 }) {
                                    const Co = new qo({
                                        checkCorrectEvent: (Qe)=>0 === n.mouseButton(Qe) && Qe.ctrlKey || 2 === n.mouseButton(Qe)
                                    });
                                    return new Uo({
                                        clickTolerance: rt,
                                        move: (Qe, rt)=>({
                                                pitchDelta: (rt.y - Qe.y) * Wn
                                            }),
                                        moveStateManager: Co,
                                        enable: Qe,
                                        assignEvents: Ho
                                    });
                                }(Qe), Ql = function({ enable: Qe, clickTolerance: rt, rollDegreesPerPixelMoved: Wn = .3 }, Co) {
                                    const Dl = new qo({
                                        checkCorrectEvent: (Qe)=>2 === n.mouseButton(Qe) && Qe.ctrlKey
                                    });
                                    return new Uo({
                                        clickTolerance: rt,
                                        move: (Qe, rt)=>{
                                            const Dl = Co();
                                            let Ll = (rt.x - Qe.x) * Wn;
                                            return rt.y < Dl.y && (Ll = -Ll), {
                                                rollDelta: Ll
                                            };
                                        },
                                        moveStateManager: Dl,
                                        enable: Qe,
                                        assignEvents: Ho
                                    });
                                }(Qe, u);
                                Wn.dragRotate = new _a(Qe, Hl, ql, Ql), this._add("mouseRotate", Hl, [
                                    "mousePitch"
                                ]), this._add("mousePitch", ql, [
                                    "mouseRotate",
                                    "mouseRoll"
                                ]), this._add("mouseRoll", Ql, [
                                    "mousePitch"
                                ]), Qe.interactive && Qe.dragRotate && Wn.dragRotate.enable();
                                const Kl = function({ enable: Qe, clickTolerance: rt }) {
                                    const Wn = new qo({
                                        checkCorrectEvent: (Qe)=>0 === n.mouseButton(Qe) && !Qe.ctrlKey
                                    });
                                    return new Uo({
                                        clickTolerance: rt,
                                        move: (Qe, rt)=>({
                                                around: rt,
                                                panDelta: rt.sub(Qe)
                                            }),
                                        activateOnStart: !0,
                                        moveStateManager: Wn,
                                        enable: Qe,
                                        assignEvents: Ho
                                    });
                                }(Qe), $l = new Ko(Qe, Wn);
                                Wn.dragPan = new da(Co, Kl, $l), this._add("mousePan", Kl), this._add("touchPan", $l, [
                                    "touchZoom",
                                    "touchRotate"
                                ]), Qe.interactive && Qe.dragPan && Wn.dragPan.enable(Qe.dragPan);
                                const Tc = new ta, tu = new Jo;
                                Wn.touchZoomRotate = new pa(Co, tu, Tc, Gl), this._add("touchRotate", Tc, [
                                    "touchPan",
                                    "touchZoom"
                                ]), this._add("touchZoom", tu, [
                                    "touchPan",
                                    "touchRotate"
                                ]), Qe.interactive && Qe.touchZoomRotate && Wn.touchZoomRotate.enable(Qe.touchZoomRotate);
                                const lu = Wn.scrollZoom = new la(Wn, ()=>this._triggerRenderFrame());
                                this._add("scrollZoom", lu, [
                                    "mousePan"
                                ]), Qe.interactive && Qe.scrollZoom && Wn.scrollZoom.enable(Qe.scrollZoom);
                                const du = Wn.keyboard = new aa(Wn);
                                this._add("keyboard", du), Qe.interactive && Qe.keyboard && Wn.keyboard.enable(), this._add("blockableMapEvent", new Fo(Wn));
                            }
                            _add(Qe, rt, Wn) {
                                this._handlers.push({
                                    handlerName: Qe,
                                    handler: rt,
                                    allowed: Wn
                                }), this._handlersById[Qe] = rt;
                            }
                            stop(Qe) {
                                if (!this._updatingCamera) {
                                    for (const { handler: Qe } of this._handlers)Qe.reset();
                                    this._inertia.clear(), this._fireEvents({}, {}, Qe), this._changes = [];
                                }
                            }
                            isActive() {
                                for (const { handler: Qe } of this._handlers)if (Qe.isActive()) return !0;
                                return !1;
                            }
                            isZooming() {
                                return !!this._eventsInProgress.zoom || this._map.scrollZoom.isZooming();
                            }
                            isRotating() {
                                return !!this._eventsInProgress.rotate;
                            }
                            isMoving() {
                                return Boolean(fa(this._eventsInProgress)) || this.isZooming();
                            }
                            _blockedByActive(Qe, rt, Wn) {
                                for(const Co in Qe)if (Co !== Wn && (!rt || rt.indexOf(Co) < 0)) return !0;
                                return !1;
                            }
                            _getMapTouches(Qe) {
                                const rt = [];
                                for (const Wn of Qe)this._el.contains(Wn.target) && rt.push(Wn);
                                return rt;
                            }
                            mergeHandlerResult(Qe, Wn, Co, Dl, Ll) {
                                if (!Co) return;
                                rt.e(Qe, Co);
                                const Rl = {
                                    handlerName: Dl,
                                    originalEvent: Co.originalEvent || Ll
                                };
                                void 0 !== Co.zoomDelta && (Wn.zoom = Rl), void 0 !== Co.panDelta && (Wn.drag = Rl), void 0 !== Co.rollDelta && (Wn.roll = Rl), void 0 !== Co.pitchDelta && (Wn.pitch = Rl), void 0 !== Co.bearingDelta && (Wn.rotate = Rl);
                            }
                            _applyChanges() {
                                const Qe = {}, Wn = {}, Co = {};
                                for (const [Dl, Ll, Rl] of this._changes)Dl.panDelta && (Qe.panDelta = (Qe.panDelta || new rt.P(0, 0))._add(Dl.panDelta)), Dl.zoomDelta && (Qe.zoomDelta = (Qe.zoomDelta || 0) + Dl.zoomDelta), Dl.bearingDelta && (Qe.bearingDelta = (Qe.bearingDelta || 0) + Dl.bearingDelta), Dl.pitchDelta && (Qe.pitchDelta = (Qe.pitchDelta || 0) + Dl.pitchDelta), Dl.rollDelta && (Qe.rollDelta = (Qe.rollDelta || 0) + Dl.rollDelta), void 0 !== Dl.around && (Qe.around = Dl.around), void 0 !== Dl.pinchAround && (Qe.pinchAround = Dl.pinchAround), Dl.noInertia && (Qe.noInertia = Dl.noInertia), rt.e(Wn, Ll), rt.e(Co, Rl);
                                this._updateMapTransform(Qe, Wn, Co), this._changes = [];
                            }
                            _updateMapTransform(Qe, rt, Wn) {
                                const Co = this._map, Dl = Co._getTransformForUpdate(), Ll = Co.terrain;
                                if (!(va(Qe) || Ll && this._terrainMovement)) return this._fireEvents(rt, Wn, !0);
                                Co._stop(!0);
                                let { panDelta: Rl, zoomDelta: Ul, bearingDelta: Gl, pitchDelta: Zl, rollDelta: Hl, around: ql, pinchAround: Ql } = Qe;
                                void 0 !== Ql && (ql = Ql), ql = ql || Co.transform.centerPoint, Ll && !Dl.isPointOnMapSurface(ql) && (ql = Dl.centerPoint);
                                const Kl = {
                                    panDelta: Rl,
                                    zoomDelta: Ul,
                                    rollDelta: Hl,
                                    pitchDelta: Zl,
                                    bearingDelta: Gl,
                                    around: ql
                                };
                                this._map.cameraHelper.useGlobeControls && !Dl.isPointOnMapSurface(ql) && (ql = Dl.centerPoint);
                                const $l = ql.distSqr(Dl.centerPoint) < .01 ? Dl.center : Dl.screenPointToLocation(Rl ? ql.sub(Rl) : ql);
                                Ll ? (this._map.cameraHelper.handleMapControlsRollPitchBearingZoom(Kl, Dl), this._terrainMovement || !rt.drag && !rt.zoom ? rt.drag && this._terrainMovement ? Dl.setCenter(Dl.screenPointToLocation(Dl.centerPoint.sub(Rl))) : this._map.cameraHelper.handleMapControlsPan(Kl, Dl, $l) : (this._terrainMovement = !0, this._map._elevationFreeze = !0, this._map.cameraHelper.handleMapControlsPan(Kl, Dl, $l))) : (this._map.cameraHelper.handleMapControlsRollPitchBearingZoom(Kl, Dl), this._map.cameraHelper.handleMapControlsPan(Kl, Dl, $l)), Co._applyUpdatedTransform(Dl), this._map._update(), Qe.noInertia || this._inertia.record(Qe), this._fireEvents(rt, Wn, !0);
                            }
                            _fireEvents(Qe, Wn, Co) {
                                const Dl = fa(this._eventsInProgress), Rl = fa(Qe), Ul = {};
                                for(const rt in Qe){
                                    const { originalEvent: Wn } = Qe[rt];
                                    this._eventsInProgress[rt] || (Ul[`${rt}start`] = Wn), this._eventsInProgress[rt] = Qe[rt];
                                }
                                !Dl && Rl && this._fireEvent("movestart", Rl.originalEvent);
                                for(const rt in Ul)this._fireEvent(rt, Ul[rt]);
                                Rl && this._fireEvent("move", Rl.originalEvent);
                                for(const rt in Qe){
                                    const { originalEvent: Wn } = Qe[rt];
                                    this._fireEvent(rt, Wn);
                                }
                                const Gl = {};
                                let Zl;
                                for(const rt in this._eventsInProgress){
                                    const { handlerName: Qe, originalEvent: Co } = this._eventsInProgress[rt];
                                    this._handlersById[Qe].isActive() || (delete this._eventsInProgress[rt], Zl = Wn[Qe] || Co, Gl[`${rt}end`] = Zl);
                                }
                                for(const rt in Gl)this._fireEvent(rt, Gl[rt]);
                                const Hl = fa(this._eventsInProgress), ql = (Dl || Rl) && !Hl;
                                if (ql && this._terrainMovement) {
                                    this._map._elevationFreeze = !1, this._terrainMovement = !1;
                                    const Qe = this._map._getTransformForUpdate();
                                    this._map.getCenterClampedToGround() && Qe.recalculateZoomAndCenter(this._map.terrain), this._map._applyUpdatedTransform(Qe);
                                }
                                if (Co && ql) {
                                    this._updatingCamera = !0;
                                    const Qe = this._inertia._onMoveEnd(this._map.dragPan._inertiaOptions), i = (Qe)=>0 !== Qe && -this._bearingSnap < Qe && Qe < this._bearingSnap;
                                    !Qe || !Qe.essential && Ll.prefersReducedMotion ? (this._map.fire(new rt.l("moveend", {
                                        originalEvent: Zl
                                    })), i(this._map.getBearing()) && this._map.resetNorth()) : (i(Qe.bearing || this._map.getBearing()) && (Qe.bearing = 0), Qe.freezeElevation = !0, this._map.easeTo(Qe, {
                                        originalEvent: Zl
                                    })), this._updatingCamera = !1;
                                }
                            }
                            _fireEvent(Qe, Wn) {
                                this._map.fire(new rt.l(Qe, Wn ? {
                                    originalEvent: Wn
                                } : {}));
                            }
                            _requestFrame() {
                                return this._map.triggerRepaint(), this._map._renderTaskQueue.add((Qe)=>{
                                    delete this._frameId, this.handleEvent(new ga("renderFrame", {
                                        timeStamp: Qe
                                    })), this._applyChanges();
                                });
                            }
                            _triggerRenderFrame() {
                                void 0 === this._frameId && (this._frameId = this._requestFrame());
                            }
                        }
                        class ba extends rt.E {
                            constructor(Qe, rt, Wn){
                                super(), this._renderFrameCallback = ()=>{
                                    const Qe = Math.min((Ll.now() - this._easeStart) / this._easeOptions.duration, 1);
                                    this._onEaseFrame(this._easeOptions.easing(Qe)), Qe < 1 && this._easeFrameId ? this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback) : this.stop();
                                }, this._moving = !1, this._zooming = !1, this.transform = Qe, this._bearingSnap = Wn.bearingSnap, this.cameraHelper = rt, this.on("moveend", ()=>{
                                    delete this._requestedCameraState;
                                });
                            }
                            migrateProjection(Qe, rt) {
                                Qe.apply(this.transform), this.transform = Qe, this.cameraHelper = rt;
                            }
                            getCenter() {
                                return new rt.Q(this.transform.center.lng, this.transform.center.lat);
                            }
                            setCenter(Qe, rt) {
                                return this.jumpTo({
                                    center: Qe
                                }, rt);
                            }
                            getCenterElevation() {
                                return this.transform.elevation;
                            }
                            setCenterElevation(Qe, rt) {
                                return this.jumpTo({
                                    elevation: Qe
                                }, rt), this;
                            }
                            getCenterClampedToGround() {
                                return this._centerClampedToGround;
                            }
                            setCenterClampedToGround(Qe) {
                                this._centerClampedToGround = Qe;
                            }
                            panBy(Qe, Wn, Co) {
                                return Qe = rt.P.convert(Qe).mult(-1), this.panTo(this.transform.center, rt.e({
                                    offset: Qe
                                }, Wn), Co);
                            }
                            panTo(Qe, Wn, Co) {
                                return this.easeTo(rt.e({
                                    center: Qe
                                }, Wn), Co);
                            }
                            getZoom() {
                                return this.transform.zoom;
                            }
                            setZoom(Qe, rt) {
                                return this.jumpTo({
                                    zoom: Qe
                                }, rt), this;
                            }
                            zoomTo(Qe, Wn, Co) {
                                return this.easeTo(rt.e({
                                    zoom: Qe
                                }, Wn), Co);
                            }
                            zoomIn(Qe, rt) {
                                return this.zoomTo(this.getZoom() + 1, Qe, rt), this;
                            }
                            zoomOut(Qe, rt) {
                                return this.zoomTo(this.getZoom() - 1, Qe, rt), this;
                            }
                            getVerticalFieldOfView() {
                                return this.transform.fov;
                            }
                            setVerticalFieldOfView(Qe, Wn) {
                                return Qe != this.transform.fov && (this.transform.setFov(Qe), this.fire(new rt.l("movestart", Wn)).fire(new rt.l("move", Wn)).fire(new rt.l("moveend", Wn))), this;
                            }
                            getBearing() {
                                return this.transform.bearing;
                            }
                            setBearing(Qe, rt) {
                                return this.jumpTo({
                                    bearing: Qe
                                }, rt), this;
                            }
                            getPadding() {
                                return this.transform.padding;
                            }
                            setPadding(Qe, rt) {
                                return this.jumpTo({
                                    padding: Qe
                                }, rt), this;
                            }
                            rotateTo(Qe, Wn, Co) {
                                return this.easeTo(rt.e({
                                    bearing: Qe
                                }, Wn), Co);
                            }
                            resetNorth(Qe, Wn) {
                                return this.rotateTo(0, rt.e({
                                    duration: 1e3
                                }, Qe), Wn), this;
                            }
                            resetNorthPitch(Qe, Wn) {
                                return this.easeTo(rt.e({
                                    bearing: 0,
                                    pitch: 0,
                                    roll: 0,
                                    duration: 1e3
                                }, Qe), Wn), this;
                            }
                            snapToNorth(Qe, rt) {
                                return Math.abs(this.getBearing()) < this._bearingSnap ? this.resetNorth(Qe, rt) : this;
                            }
                            getPitch() {
                                return this.transform.pitch;
                            }
                            setPitch(Qe, rt) {
                                return this.jumpTo({
                                    pitch: Qe
                                }, rt), this;
                            }
                            getRoll() {
                                return this.transform.roll;
                            }
                            setRoll(Qe, rt) {
                                return this.jumpTo({
                                    roll: Qe
                                }, rt), this;
                            }
                            cameraForBounds(Qe, rt) {
                                Qe = V.convert(Qe).adjustAntiMeridian();
                                const Wn = rt && rt.bearing || 0;
                                return this._cameraForBoxAndBearing(Qe.getNorthWest(), Qe.getSouthEast(), Wn, rt);
                            }
                            _cameraForBoxAndBearing(Qe, Wn, Co, Dl) {
                                const Ll = {
                                    top: 0,
                                    bottom: 0,
                                    right: 0,
                                    left: 0
                                };
                                if ("number" == typeof (Dl = rt.e({
                                    padding: Ll,
                                    offset: [
                                        0,
                                        0
                                    ],
                                    maxZoom: this.transform.maxZoom
                                }, Dl)).padding) {
                                    const Qe = Dl.padding;
                                    Dl.padding = {
                                        top: Qe,
                                        bottom: Qe,
                                        right: Qe,
                                        left: Qe
                                    };
                                }
                                const Rl = rt.e(Ll, Dl.padding);
                                Dl.padding = Rl;
                                const Ul = this.transform, Gl = new V(Qe, Wn);
                                return this.cameraHelper.cameraForBoxAndBearing(Dl, Rl, Gl, Co, Ul);
                            }
                            fitBounds(Qe, rt, Wn) {
                                return this._fitInternal(this.cameraForBounds(Qe, rt), rt, Wn);
                            }
                            fitScreenCoordinates(Qe, Wn, Co, Dl, Ll) {
                                return this._fitInternal(this._cameraForBoxAndBearing(this.transform.screenPointToLocation(rt.P.convert(Qe)), this.transform.screenPointToLocation(rt.P.convert(Wn)), Co, Dl), Dl, Ll);
                            }
                            _fitInternal(Qe, Wn, Co) {
                                return Qe ? (delete (Wn = rt.e(Qe, Wn)).padding, Wn.linear ? this.easeTo(Wn, Co) : this.flyTo(Wn, Co)) : this;
                            }
                            jumpTo(Qe, Wn) {
                                this.stop();
                                const Co = this._getTransformForUpdate();
                                let Dl = !1, Ll = !1, Rl = !1;
                                const Ul = Co.zoom;
                                this.cameraHelper.handleJumpToCenterZoom(Co, Qe);
                                const Gl = Co.zoom !== Ul;
                                return "elevation" in Qe && Co.elevation !== +Qe.elevation && Co.setElevation(+Qe.elevation), "bearing" in Qe && Co.bearing !== +Qe.bearing && (Dl = !0, Co.setBearing(+Qe.bearing)), "pitch" in Qe && Co.pitch !== +Qe.pitch && (Ll = !0, Co.setPitch(+Qe.pitch)), "roll" in Qe && Co.roll !== +Qe.roll && (Rl = !0, Co.setRoll(+Qe.roll)), null == Qe.padding || Co.isPaddingEqual(Qe.padding) || Co.setPadding(Qe.padding), this._applyUpdatedTransform(Co), this.fire(new rt.l("movestart", Wn)).fire(new rt.l("move", Wn)), Gl && this.fire(new rt.l("zoomstart", Wn)).fire(new rt.l("zoom", Wn)).fire(new rt.l("zoomend", Wn)), Dl && this.fire(new rt.l("rotatestart", Wn)).fire(new rt.l("rotate", Wn)).fire(new rt.l("rotateend", Wn)), Ll && this.fire(new rt.l("pitchstart", Wn)).fire(new rt.l("pitch", Wn)).fire(new rt.l("pitchend", Wn)), Rl && this.fire(new rt.l("rollstart", Wn)).fire(new rt.l("roll", Wn)).fire(new rt.l("rollend", Wn)), this.fire(new rt.l("moveend", Wn));
                            }
                            calculateCameraOptionsFromTo(Qe, Wn, Co, Dl = 0) {
                                const Ll = rt.$.fromLngLat(Qe, Wn), Rl = rt.$.fromLngLat(Co, Dl), Ul = Rl.x - Ll.x, Gl = Rl.y - Ll.y, Zl = Rl.z - Ll.z, Hl = Math.hypot(Ul, Gl, Zl);
                                if (0 === Hl) throw new Error("Can't calculate camera options with same From and To");
                                const ql = Math.hypot(Ul, Gl), Ql = rt.ab(this.transform.cameraToCenterDistance / Hl / this.transform.tileSize), Kl = 180 * Math.atan2(Ul, -Gl) / Math.PI;
                                let $l = 180 * Math.acos(ql / Hl) / Math.PI;
                                return $l = Zl < 0 ? 90 - $l : 90 + $l, {
                                    center: Rl.toLngLat(),
                                    elevation: Dl,
                                    zoom: Ql,
                                    pitch: $l,
                                    bearing: Kl
                                };
                            }
                            calculateCameraOptionsFromCameraLngLatAltRotation(Qe, rt, Wn, Co, Dl) {
                                const Ll = this.transform.calculateCenterFromCameraLngLatAlt(Qe, rt, Wn, Co);
                                return {
                                    center: Ll.center,
                                    elevation: Ll.elevation,
                                    zoom: Ll.zoom,
                                    bearing: Wn,
                                    pitch: Co,
                                    roll: Dl
                                };
                            }
                            easeTo(Qe, Wn) {
                                this._stop(!1, Qe.easeId), (!1 === (Qe = rt.e({
                                    offset: [
                                        0,
                                        0
                                    ],
                                    duration: 500,
                                    easing: rt.cb
                                }, Qe)).animate || !Qe.essential && Ll.prefersReducedMotion) && (Qe.duration = 0);
                                const Co = this._getTransformForUpdate(), Dl = this.getBearing(), Rl = Co.pitch, Ul = Co.roll, Gl = "bearing" in Qe ? this._normalizeBearing(Qe.bearing, Dl) : Dl, Zl = "pitch" in Qe ? +Qe.pitch : Rl, Hl = "roll" in Qe ? this._normalizeBearing(Qe.roll, Ul) : Ul, ql = "padding" in Qe ? Qe.padding : Co.padding, Ql = rt.P.convert(Qe.offset);
                                let Kl, $l;
                                Qe.around && (Kl = rt.Q.convert(Qe.around), $l = Co.locationToScreenPoint(Kl));
                                const Tc = {
                                    moving: this._moving,
                                    zooming: this._zooming,
                                    rotating: this._rotating,
                                    pitching: this._pitching,
                                    rolling: this._rolling
                                }, tu = this.cameraHelper.handleEaseTo(Co, {
                                    bearing: Gl,
                                    pitch: Zl,
                                    roll: Hl,
                                    padding: ql,
                                    around: Kl,
                                    aroundPoint: $l,
                                    offsetAsPoint: Ql,
                                    offset: Qe.offset,
                                    zoom: Qe.zoom,
                                    center: Qe.center
                                });
                                return this._rotating = this._rotating || Dl !== Gl, this._pitching = this._pitching || Zl !== Rl, this._rolling = this._rolling || Hl !== Ul, this._padding = !Co.isPaddingEqual(ql), this._zooming = this._zooming || tu.isZooming, this._easeId = Qe.easeId, this._prepareEase(Wn, Qe.noMoveStart, Tc), this.terrain && this._prepareElevation(tu.elevationCenter), this._ease((rt)=>{
                                    tu.easeFunc(rt), this.terrain && !Qe.freezeElevation && this._updateElevation(rt), this._applyUpdatedTransform(Co), this._fireMoveEvents(Wn);
                                }, (rt)=>{
                                    this.terrain && Qe.freezeElevation && this._finalizeElevation(), this._afterEase(Wn, rt);
                                }, Qe), this;
                            }
                            _prepareEase(Qe, Wn, Co = {}) {
                                this._moving = !0, Wn || Co.moving || this.fire(new rt.l("movestart", Qe)), this._zooming && !Co.zooming && this.fire(new rt.l("zoomstart", Qe)), this._rotating && !Co.rotating && this.fire(new rt.l("rotatestart", Qe)), this._pitching && !Co.pitching && this.fire(new rt.l("pitchstart", Qe)), this._rolling && !Co.rolling && this.fire(new rt.l("rollstart", Qe));
                            }
                            _prepareElevation(Qe) {
                                this._elevationCenter = Qe, this._elevationStart = this.transform.elevation, this._elevationTarget = this.terrain.getElevationForLngLatZoom(Qe, this.transform.tileZoom), this._elevationFreeze = !0;
                            }
                            _updateElevation(Qe) {
                                this.transform.setMinElevationForCurrentTile(this.terrain.getMinTileElevationForLngLatZoom(this._elevationCenter, this.transform.tileZoom));
                                const Wn = this.terrain.getElevationForLngLatZoom(this._elevationCenter, this.transform.tileZoom);
                                if (Qe < 1 && Wn !== this._elevationTarget) {
                                    const rt = this._elevationTarget - this._elevationStart;
                                    this._elevationStart += Qe * (rt - (Wn - (rt * Qe + this._elevationStart)) / (1 - Qe)), this._elevationTarget = Wn;
                                }
                                this.transform.setElevation(rt.B.number(this._elevationStart, this._elevationTarget, Qe));
                            }
                            _finalizeElevation() {
                                this._elevationFreeze = !1, this.getCenterClampedToGround() && this.transform.recalculateZoomAndCenter(this.terrain);
                            }
                            _getTransformForUpdate() {
                                return this.transformCameraUpdate || this.terrain ? (this._requestedCameraState || (this._requestedCameraState = this.transform.clone()), this._requestedCameraState) : this.transform;
                            }
                            _elevateCameraIfInsideTerrain(Qe) {
                                if (!this.terrain && Qe.elevation >= 0 && Qe.pitch <= 90) return {};
                                const rt = Qe.getCameraLngLat(), Wn = Qe.getCameraAltitude(), Co = this.terrain ? this.terrain.getElevationForLngLatZoom(rt, Qe.zoom) : 0;
                                if (Wn < Co) {
                                    const Wn = this.calculateCameraOptionsFromTo(rt, Co, Qe.center, Qe.elevation);
                                    return {
                                        pitch: Wn.pitch,
                                        zoom: Wn.zoom
                                    };
                                }
                                return {};
                            }
                            _applyUpdatedTransform(Qe) {
                                const rt = [];
                                if (rt.push((Qe)=>this._elevateCameraIfInsideTerrain(Qe)), this.transformCameraUpdate && rt.push((Qe)=>this.transformCameraUpdate(Qe)), !rt.length) return;
                                const Wn = Qe.clone();
                                for (const Co of rt){
                                    const Qe = Wn.clone(), { center: rt, zoom: Dl, roll: Ll, pitch: Rl, bearing: Ul, elevation: Gl } = Co(Qe);
                                    rt && Qe.setCenter(rt), void 0 !== Gl && Qe.setElevation(Gl), void 0 !== Dl && Qe.setZoom(Dl), void 0 !== Ll && Qe.setRoll(Ll), void 0 !== Rl && Qe.setPitch(Rl), void 0 !== Ul && Qe.setBearing(Ul), Wn.apply(Qe);
                                }
                                this.transform.apply(Wn);
                            }
                            _fireMoveEvents(Qe) {
                                this.fire(new rt.l("move", Qe)), this._zooming && this.fire(new rt.l("zoom", Qe)), this._rotating && this.fire(new rt.l("rotate", Qe)), this._pitching && this.fire(new rt.l("pitch", Qe)), this._rolling && this.fire(new rt.l("roll", Qe));
                            }
                            _afterEase(Qe, Wn) {
                                if (this._easeId && Wn && this._easeId === Wn) return;
                                delete this._easeId;
                                const Co = this._zooming, Dl = this._rotating, Ll = this._pitching, Rl = this._rolling;
                                this._moving = !1, this._zooming = !1, this._rotating = !1, this._pitching = !1, this._rolling = !1, this._padding = !1, Co && this.fire(new rt.l("zoomend", Qe)), Dl && this.fire(new rt.l("rotateend", Qe)), Ll && this.fire(new rt.l("pitchend", Qe)), Rl && this.fire(new rt.l("rollend", Qe)), this.fire(new rt.l("moveend", Qe));
                            }
                            flyTo(Qe, Wn) {
                                if (!Qe.essential && Ll.prefersReducedMotion) {
                                    const Co = rt.O(Qe, [
                                        "center",
                                        "zoom",
                                        "bearing",
                                        "pitch",
                                        "roll",
                                        "elevation"
                                    ]);
                                    return this.jumpTo(Co, Wn);
                                }
                                this.stop(), Qe = rt.e({
                                    offset: [
                                        0,
                                        0
                                    ],
                                    speed: 1.2,
                                    curve: 1.42,
                                    easing: rt.cb
                                }, Qe);
                                const Co = this._getTransformForUpdate(), Dl = Co.bearing, Rl = Co.pitch, Ul = Co.roll, Gl = Co.padding, Zl = "bearing" in Qe ? this._normalizeBearing(Qe.bearing, Dl) : Dl, Hl = "pitch" in Qe ? +Qe.pitch : Rl, ql = "roll" in Qe ? this._normalizeBearing(Qe.roll, Ul) : Ul, Ql = "padding" in Qe ? Qe.padding : Co.padding, Kl = rt.P.convert(Qe.offset);
                                let $l = Co.centerPoint.add(Kl);
                                const Tc = Co.screenPointToLocation($l), tu = this.cameraHelper.handleFlyTo(Co, {
                                    bearing: Zl,
                                    pitch: Hl,
                                    roll: ql,
                                    padding: Ql,
                                    locationAtOffset: Tc,
                                    offsetAsPoint: Kl,
                                    center: Qe.center,
                                    minZoom: Qe.minZoom,
                                    zoom: Qe.zoom
                                });
                                let lu = Qe.curve;
                                const du = Math.max(Co.width, Co.height), fu = du / tu.scaleOfZoom, yu = tu.pixelPathLength;
                                "number" == typeof tu.scaleOfMinZoom && (lu = Math.sqrt(du / tu.scaleOfMinZoom / yu * 2));
                                const Eu = lu * lu;
                                function w(Qe) {
                                    const rt = (fu * fu - du * du + (Qe ? -1 : 1) * Eu * Eu * yu * yu) / (2 * (Qe ? fu : du) * Eu * yu);
                                    return Math.log(Math.sqrt(rt * rt + 1) - rt);
                                }
                                function T(Qe) {
                                    return (Math.exp(Qe) - Math.exp(-Qe)) / 2;
                                }
                                function P(Qe) {
                                    return (Math.exp(Qe) + Math.exp(-Qe)) / 2;
                                }
                                const Tu = w(!1);
                                let I = function(Qe) {
                                    return P(Tu) / P(Tu + lu * Qe);
                                }, M = function(Qe) {
                                    var rt;
                                    return du * ((P(Tu) * (T(rt = Tu + lu * Qe) / P(rt)) - T(Tu)) / Eu) / yu;
                                }, Lu = (w(!0) - Tu) / lu;
                                if (Math.abs(yu) < 2e-6 || !isFinite(Lu)) {
                                    if (Math.abs(du - fu) < 1e-6) return this.easeTo(Qe, Wn);
                                    const rt = fu < du ? -1 : 1;
                                    Lu = Math.abs(Math.log(fu / du)) / lu, M = ()=>0, I = (Qe)=>Math.exp(rt * lu * Qe);
                                }
                                return Qe.duration = "duration" in Qe ? +Qe.duration : 1e3 * Lu / ("screenSpeed" in Qe ? +Qe.screenSpeed / lu : +Qe.speed), Qe.maxDuration && Qe.duration > Qe.maxDuration && (Qe.duration = 0), this._zooming = !0, this._rotating = Dl !== Zl, this._pitching = Hl !== Rl, this._rolling = ql !== Ul, this._padding = !Co.isPaddingEqual(Ql), this._prepareEase(Wn, !1), this.terrain && this._prepareElevation(tu.targetCenter), this._ease((Ll)=>{
                                    const Tc = Ll * Lu, lu = 1 / I(Tc), du = M(Tc);
                                    this._rotating && Co.setBearing(rt.B.number(Dl, Zl, Ll)), this._pitching && Co.setPitch(rt.B.number(Rl, Hl, Ll)), this._rolling && Co.setRoll(rt.B.number(Ul, ql, Ll)), this._padding && (Co.interpolatePadding(Gl, Ql, Ll), $l = Co.centerPoint.add(Kl)), tu.easeFunc(Ll, lu, du, $l), this.terrain && !Qe.freezeElevation && this._updateElevation(Ll), this._applyUpdatedTransform(Co), this._fireMoveEvents(Wn);
                                }, ()=>{
                                    this.terrain && Qe.freezeElevation && this._finalizeElevation(), this._afterEase(Wn);
                                }, Qe), this;
                            }
                            isEasing() {
                                return !!this._easeFrameId;
                            }
                            stop() {
                                return this._stop();
                            }
                            _stop(Qe, rt) {
                                var Wn;
                                if (this._easeFrameId && (this._cancelRenderFrame(this._easeFrameId), delete this._easeFrameId, delete this._onEaseFrame), this._onEaseEnd) {
                                    const Qe = this._onEaseEnd;
                                    delete this._onEaseEnd, Qe.call(this, rt);
                                }
                                return Qe || null === (Wn = this.handlers) || void 0 === Wn || Wn.stop(!1), this;
                            }
                            _ease(Qe, rt, Wn) {
                                !1 === Wn.animate || 0 === Wn.duration ? (Qe(1), rt()) : (this._easeStart = Ll.now(), this._easeOptions = Wn, this._onEaseFrame = Qe, this._onEaseEnd = rt, this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback));
                            }
                            _normalizeBearing(Qe, Wn) {
                                Qe = rt.aL(Qe, -180, 180);
                                const Co = Math.abs(Qe - Wn);
                                return Math.abs(Qe - 360 - Wn) < Co && (Qe -= 360), Math.abs(Qe + 360 - Wn) < Co && (Qe += 360), Qe;
                            }
                            queryTerrainElevation(Qe) {
                                return this.terrain ? this.terrain.getElevationForLngLatZoom(rt.Q.convert(Qe), this.transform.tileZoom) : null;
                            }
                        }
                        const Fd = {
                            compact: !0,
                            customAttribution: '<a href="https://maplibre.org/" target="_blank">MapLibre</a>'
                        };
                        class wa {
                            constructor(Qe = Fd){
                                this._toggleAttribution = ()=>{
                                    this._container.classList.contains("maplibregl-compact") && (this._container.classList.contains("maplibregl-compact-show") ? (this._container.setAttribute("open", ""), this._container.classList.remove("maplibregl-compact-show")) : (this._container.classList.add("maplibregl-compact-show"), this._container.removeAttribute("open")));
                                }, this._updateData = (Qe)=>{
                                    !Qe || "metadata" !== Qe.sourceDataType && "visibility" !== Qe.sourceDataType && "style" !== Qe.dataType && "terrain" !== Qe.type || this._updateAttributions();
                                }, this._updateCompact = ()=>{
                                    this._map.getCanvasContainer().offsetWidth <= 640 || this._compact ? !1 === this._compact ? this._container.setAttribute("open", "") : this._container.classList.contains("maplibregl-compact") || this._container.classList.contains("maplibregl-attrib-empty") || (this._container.setAttribute("open", ""), this._container.classList.add("maplibregl-compact", "maplibregl-compact-show")) : (this._container.setAttribute("open", ""), this._container.classList.contains("maplibregl-compact") && this._container.classList.remove("maplibregl-compact", "maplibregl-compact-show"));
                                }, this._updateCompactMinimize = ()=>{
                                    this._container.classList.contains("maplibregl-compact") && this._container.classList.contains("maplibregl-compact-show") && this._container.classList.remove("maplibregl-compact-show");
                                }, this.options = Qe;
                            }
                            getDefaultPosition() {
                                return "bottom-right";
                            }
                            onAdd(Qe) {
                                return this._map = Qe, this._compact = this.options.compact, this._container = n.create("details", "maplibregl-ctrl maplibregl-ctrl-attrib"), this._compactButton = n.create("summary", "maplibregl-ctrl-attrib-button", this._container), this._compactButton.addEventListener("click", this._toggleAttribution), this._setElementTitle(this._compactButton, "ToggleAttribution"), this._innerContainer = n.create("div", "maplibregl-ctrl-attrib-inner", this._container), this._updateAttributions(), this._updateCompact(), this._map.on("styledata", this._updateData), this._map.on("sourcedata", this._updateData), this._map.on("terrain", this._updateData), this._map.on("resize", this._updateCompact), this._map.on("drag", this._updateCompactMinimize), this._container;
                            }
                            onRemove() {
                                n.remove(this._container), this._map.off("styledata", this._updateData), this._map.off("sourcedata", this._updateData), this._map.off("terrain", this._updateData), this._map.off("resize", this._updateCompact), this._map.off("drag", this._updateCompactMinimize), this._map = void 0, this._compact = void 0, this._attribHTML = void 0;
                            }
                            _setElementTitle(Qe, rt) {
                                const Wn = this._map._getUIString(`AttributionControl.${rt}`);
                                Qe.title = Wn, Qe.setAttribute("aria-label", Wn);
                            }
                            _updateAttributions() {
                                if (!this._map.style) return;
                                let Qe = [];
                                if (this.options.customAttribution && (Array.isArray(this.options.customAttribution) ? Qe = Qe.concat(this.options.customAttribution.map((Qe)=>"string" != typeof Qe ? "" : Qe)) : "string" == typeof this.options.customAttribution && Qe.push(this.options.customAttribution)), this._map.style.stylesheet) {
                                    const Qe = this._map.style.stylesheet;
                                    this.styleOwner = Qe.owner, this.styleId = Qe.id;
                                }
                                const rt = this._map.style.sourceCaches;
                                for(const Co in rt){
                                    const Wn = rt[Co];
                                    if (Wn.used || Wn.usedForTerrain) {
                                        const rt = Wn.getSource();
                                        rt.attribution && Qe.indexOf(rt.attribution) < 0 && Qe.push(rt.attribution);
                                    }
                                }
                                Qe = Qe.filter((Qe)=>String(Qe).trim()), Qe.sort((Qe, rt)=>Qe.length - rt.length), Qe = Qe.filter((rt, Wn)=>{
                                    for(let Co = Wn + 1; Co < Qe.length; Co++)if (Qe[Co].indexOf(rt) >= 0) return !1;
                                    return !0;
                                });
                                const Wn = Qe.join(" | ");
                                Wn !== this._attribHTML && (this._attribHTML = Wn, Qe.length ? (this._innerContainer.innerHTML = n.sanitize(Wn), this._container.classList.remove("maplibregl-attrib-empty")) : this._container.classList.add("maplibregl-attrib-empty"), this._updateCompact(), this._editLink = null);
                            }
                        }
                        class Ta {
                            constructor(Qe = {}){
                                this._updateCompact = ()=>{
                                    const Qe = this._container.children;
                                    if (Qe.length) {
                                        const rt = Qe[0];
                                        this._map.getCanvasContainer().offsetWidth <= 640 || this._compact ? !1 !== this._compact && rt.classList.add("maplibregl-compact") : rt.classList.remove("maplibregl-compact");
                                    }
                                }, this.options = Qe;
                            }
                            getDefaultPosition() {
                                return "bottom-left";
                            }
                            onAdd(Qe) {
                                this._map = Qe, this._compact = this.options && this.options.compact, this._container = n.create("div", "maplibregl-ctrl");
                                const rt = n.create("a", "maplibregl-ctrl-logo");
                                return rt.target = "_blank", rt.rel = "noopener nofollow", rt.href = "https://maplibre.org/", rt.setAttribute("aria-label", this._map._getUIString("LogoControl.Title")), rt.setAttribute("rel", "noopener nofollow"), this._container.appendChild(rt), this._container.style.display = "block", this._map.on("resize", this._updateCompact), this._updateCompact(), this._container;
                            }
                            onRemove() {
                                n.remove(this._container), this._map.off("resize", this._updateCompact), this._map = void 0, this._compact = void 0;
                            }
                        }
                        class Pa {
                            constructor(){
                                this._queue = [], this._id = 0, this._cleared = !1, this._currentlyRunning = !1;
                            }
                            add(Qe) {
                                const rt = ++this._id;
                                return this._queue.push({
                                    callback: Qe,
                                    id: rt,
                                    cancelled: !1
                                }), rt;
                            }
                            remove(Qe) {
                                const rt = this._currentlyRunning, Wn = rt ? this._queue.concat(rt) : this._queue;
                                for (const Co of Wn)if (Co.id === Qe) return void (Co.cancelled = !0);
                            }
                            run(Qe = 0) {
                                if (this._currentlyRunning) throw new Error("Attempting to run(), but is already running.");
                                const rt = this._currentlyRunning = this._queue;
                                this._queue = [];
                                for (const Wn of rt)if (!Wn.cancelled && (Wn.callback(Qe), this._cleared)) break;
                                this._cleared = !1, this._currentlyRunning = !1;
                            }
                            clear() {
                                this._currentlyRunning && (this._cleared = !0), this._queue = [];
                            }
                        }
                        var jd = rt.aD([
                            {
                                name: "a_pos3d",
                                type: "Int16",
                                components: 3
                            }
                        ]);
                        class Ia extends rt.E {
                            constructor(Qe){
                                super(), this._lastTilesetChange = Ll.now(), this.sourceCache = Qe, this._tiles = {}, this._renderableTilesKeys = [], this._sourceTileCache = {}, this.minzoom = 0, this.maxzoom = 22, this.deltaZoom = 1, this.tileSize = Qe._source.tileSize * 2 ** this.deltaZoom, Qe.usedForTerrain = !0, Qe.tileSize = this.tileSize;
                            }
                            destruct() {
                                this.sourceCache.usedForTerrain = !1, this.sourceCache.tileSize = null;
                            }
                            update(Qe, Wn) {
                                this.sourceCache.update(Qe, Wn), this._renderableTilesKeys = [];
                                const Co = {};
                                for (const Dl of ue(Qe, {
                                    tileSize: this.tileSize,
                                    minzoom: this.minzoom,
                                    maxzoom: this.maxzoom,
                                    reparseOverscaled: !1,
                                    terrain: Wn,
                                    calculateTileZoom: this.sourceCache._source.calculateTileZoom
                                }))Co[Dl.key] = !0, this._renderableTilesKeys.push(Dl.key), this._tiles[Dl.key] || (Dl.terrainRttPosMatrix32f = new Float64Array(16), rt.bO(Dl.terrainRttPosMatrix32f, 0, rt.Z, rt.Z, 0, 0, 1), this._tiles[Dl.key] = new ae(Dl, this.tileSize), this._lastTilesetChange = Ll.now());
                                for(const rt in this._tiles)Co[rt] || delete this._tiles[rt];
                            }
                            freeRtt(Qe) {
                                for(const rt in this._tiles){
                                    const Wn = this._tiles[rt];
                                    (!Qe || Wn.tileID.equals(Qe) || Wn.tileID.isChildOf(Qe) || Qe.isChildOf(Wn.tileID)) && (Wn.rtt = []);
                                }
                            }
                            getRenderableTiles() {
                                return this._renderableTilesKeys.map((Qe)=>this.getTileByID(Qe));
                            }
                            getTileByID(Qe) {
                                return this._tiles[Qe];
                            }
                            getTerrainCoords(Qe, rt) {
                                return rt ? this._getTerrainCoordsForTileRanges(Qe, rt) : this._getTerrainCoordsForRegularTile(Qe);
                            }
                            _getTerrainCoordsForRegularTile(Qe) {
                                const Wn = {};
                                for (const Co of this._renderableTilesKeys){
                                    const Dl = this._tiles[Co].tileID, Ll = Qe.clone(), Rl = rt.b2();
                                    if (Dl.canonical.equals(Qe.canonical)) rt.bO(Rl, 0, rt.Z, rt.Z, 0, 0, 1);
                                    else if (Dl.canonical.isChildOf(Qe.canonical)) {
                                        const Wn = Dl.canonical.z - Qe.canonical.z, Co = Dl.canonical.x - (Dl.canonical.x >> Wn << Wn), Ll = Dl.canonical.y - (Dl.canonical.y >> Wn << Wn), Ul = rt.Z >> Wn;
                                        rt.bO(Rl, 0, Ul, Ul, 0, 0, 1), rt.L(Rl, Rl, [
                                            -Co * Ul,
                                            -Ll * Ul,
                                            0
                                        ]);
                                    } else {
                                        if (!Qe.canonical.isChildOf(Dl.canonical)) continue;
                                        {
                                            const Wn = Qe.canonical.z - Dl.canonical.z, Co = Qe.canonical.x - (Qe.canonical.x >> Wn << Wn), Ll = Qe.canonical.y - (Qe.canonical.y >> Wn << Wn), Ul = rt.Z >> Wn;
                                            rt.bO(Rl, 0, rt.Z, rt.Z, 0, 0, 1), rt.L(Rl, Rl, [
                                                Co * Ul,
                                                Ll * Ul,
                                                0
                                            ]), rt.M(Rl, Rl, [
                                                1 / 2 ** Wn,
                                                1 / 2 ** Wn,
                                                0
                                            ]);
                                        }
                                    }
                                    Ll.terrainRttPosMatrix32f = new Float32Array(Rl), Wn[Co] = Ll;
                                }
                                return Wn;
                            }
                            _getTerrainCoordsForTileRanges(Qe, Wn) {
                                const Co = {};
                                for (const Dl of this._renderableTilesKeys){
                                    const Ll = this._tiles[Dl].tileID;
                                    if (!this._isWithinTileRanges(Ll, Wn)) continue;
                                    const Rl = Qe.clone(), Ul = rt.b2();
                                    if (Ll.canonical.z === Qe.canonical.z) {
                                        const Wn = Qe.canonical.x - Ll.canonical.x, Co = Qe.canonical.y - Ll.canonical.y;
                                        rt.bO(Ul, 0, rt.Z, rt.Z, 0, 0, 1), rt.L(Ul, Ul, [
                                            Wn * rt.Z,
                                            Co * rt.Z,
                                            0
                                        ]);
                                    } else if (Ll.canonical.z > Qe.canonical.z) {
                                        const Wn = Ll.canonical.z - Qe.canonical.z, Co = Ll.canonical.x - (Ll.canonical.x >> Wn << Wn), Dl = Ll.canonical.y - (Ll.canonical.y >> Wn << Wn), Rl = Qe.canonical.x - (Ll.canonical.x >> Wn), Gl = Qe.canonical.y - (Ll.canonical.y >> Wn), Zl = rt.Z >> Wn;
                                        rt.bO(Ul, 0, Zl, Zl, 0, 0, 1), rt.L(Ul, Ul, [
                                            -Co * Zl + Rl * rt.Z,
                                            -Dl * Zl + Gl * rt.Z,
                                            0
                                        ]);
                                    } else {
                                        const Wn = Qe.canonical.z - Ll.canonical.z, Co = Qe.canonical.x - (Qe.canonical.x >> Wn << Wn), Dl = Qe.canonical.y - (Qe.canonical.y >> Wn << Wn), Rl = (Qe.canonical.x >> Wn) - Ll.canonical.x, Gl = (Qe.canonical.y >> Wn) - Ll.canonical.y, Zl = rt.Z << Wn;
                                        rt.bO(Ul, 0, Zl, Zl, 0, 0, 1), rt.L(Ul, Ul, [
                                            Co * rt.Z + Rl * Zl,
                                            Dl * rt.Z + Gl * Zl,
                                            0
                                        ]);
                                    }
                                    Rl.terrainRttPosMatrix32f = new Float32Array(Ul), Co[Dl] = Rl;
                                }
                                return Co;
                            }
                            getSourceTile(Qe, rt) {
                                const Wn = this.sourceCache._source;
                                let Co = Qe.overscaledZ - this.deltaZoom;
                                if (Co > Wn.maxzoom && (Co = Wn.maxzoom), Co < Wn.minzoom) return null;
                                this._sourceTileCache[Qe.key] || (this._sourceTileCache[Qe.key] = Qe.scaledTo(Co).key);
                                let Dl = this.sourceCache.getTileByID(this._sourceTileCache[Qe.key]);
                                if ((!Dl || !Dl.dem) && rt) for(; Co >= Wn.minzoom && (!Dl || !Dl.dem);)Dl = this.sourceCache.getTileByID(Qe.scaledTo(Co--).key);
                                return Dl;
                            }
                            anyTilesAfterTime(Qe = Date.now()) {
                                return this._lastTilesetChange >= Qe;
                            }
                            _isWithinTileRanges(Qe, rt) {
                                return rt[Qe.canonical.z] && Qe.canonical.x >= rt[Qe.canonical.z].minTileX && Qe.canonical.x <= rt[Qe.canonical.z].maxTileX && Qe.canonical.y >= rt[Qe.canonical.z].minTileY && Qe.canonical.y <= rt[Qe.canonical.z].maxTileY;
                            }
                        }
                        class Ma {
                            constructor(Qe, rt, Wn){
                                this._meshCache = {}, this.painter = Qe, this.sourceCache = new Ia(rt), this.options = Wn, this.exaggeration = "number" == typeof Wn.exaggeration ? Wn.exaggeration : 1, this.qualityFactor = 2, this.meshSize = 128, this._demMatrixCache = {}, this.coordsIndex = [], this._coordsTextureSize = 1024;
                            }
                            getDEMElevation(Qe, Wn, Co, Dl = rt.Z) {
                                var Ll;
                                if (!(Wn >= 0 && Wn < Dl && Co >= 0 && Co < Dl)) return 0;
                                const Rl = this.getTerrainData(Qe), Ul = null === (Ll = Rl.tile) || void 0 === Ll ? void 0 : Ll.dem;
                                if (!Ul) return 0;
                                const Gl = rt.cf([], [
                                    Wn / Dl * rt.Z,
                                    Co / Dl * rt.Z
                                ], Rl.u_terrain_matrix), Zl = [
                                    Gl[0] * Ul.dim,
                                    Gl[1] * Ul.dim
                                ], Hl = Math.floor(Zl[0]), ql = Math.floor(Zl[1]), Ql = Zl[0] - Hl, Kl = Zl[1] - ql;
                                return Ul.get(Hl, ql) * (1 - Ql) * (1 - Kl) + Ul.get(Hl + 1, ql) * Ql * (1 - Kl) + Ul.get(Hl, ql + 1) * (1 - Ql) * Kl + Ul.get(Hl + 1, ql + 1) * Ql * Kl;
                            }
                            getElevationForLngLatZoom(Qe, Wn) {
                                if (!rt.cg(Wn, Qe.wrap())) return 0;
                                const { tileID: Co, mercatorX: Dl, mercatorY: Ll } = this._getOverscaledTileIDFromLngLatZoom(Qe, Wn);
                                return this.getElevation(Co, Dl % rt.Z, Ll % rt.Z, rt.Z);
                            }
                            getElevation(Qe, Wn, Co, Dl = rt.Z) {
                                return this.getDEMElevation(Qe, Wn, Co, Dl) * this.exaggeration;
                            }
                            getTerrainData(Qe) {
                                if (!this._emptyDemTexture) {
                                    const Qe = this.painter.context, Wn = new rt.R({
                                        width: 1,
                                        height: 1
                                    }, new Uint8Array(4));
                                    this._emptyDepthTexture = new v(Qe, Wn, Qe.gl.RGBA, {
                                        premultiply: !1
                                    }), this._emptyDemUnpack = [
                                        0,
                                        0,
                                        0,
                                        0
                                    ], this._emptyDemTexture = new v(Qe, new rt.R({
                                        width: 1,
                                        height: 1
                                    }), Qe.gl.RGBA, {
                                        premultiply: !1
                                    }), this._emptyDemTexture.bind(Qe.gl.NEAREST, Qe.gl.CLAMP_TO_EDGE), this._emptyDemMatrix = rt.at([]);
                                }
                                const Wn = this.sourceCache.getSourceTile(Qe, !0);
                                if (Wn && Wn.dem && (!Wn.demTexture || Wn.needsTerrainPrepare)) {
                                    const Qe = this.painter.context;
                                    Wn.demTexture = this.painter.getTileTexture(Wn.dem.stride), Wn.demTexture ? Wn.demTexture.update(Wn.dem.getPixels(), {
                                        premultiply: !1
                                    }) : Wn.demTexture = new v(Qe, Wn.dem.getPixels(), Qe.gl.RGBA, {
                                        premultiply: !1
                                    }), Wn.demTexture.bind(Qe.gl.NEAREST, Qe.gl.CLAMP_TO_EDGE), Wn.needsTerrainPrepare = !1;
                                }
                                const Co = Wn && Wn + Wn.tileID.key + Qe.key;
                                if (Co && !this._demMatrixCache[Co]) {
                                    const Co = this.sourceCache.sourceCache._source.maxzoom;
                                    let Dl = Qe.canonical.z - Wn.tileID.canonical.z;
                                    Qe.overscaledZ > Qe.canonical.z && (Qe.canonical.z >= Co ? Dl = Qe.canonical.z - Co : rt.w("cannot calculate elevation if elevation maxzoom > source.maxzoom"));
                                    const Ll = Qe.canonical.x - (Qe.canonical.x >> Dl << Dl), Rl = Qe.canonical.y - (Qe.canonical.y >> Dl << Dl), Ul = rt.ch(new Float64Array(16), [
                                        1 / (rt.Z << Dl),
                                        1 / (rt.Z << Dl),
                                        0
                                    ]);
                                    rt.L(Ul, Ul, [
                                        Ll * rt.Z,
                                        Rl * rt.Z,
                                        0
                                    ]), this._demMatrixCache[Qe.key] = {
                                        matrix: Ul,
                                        coord: Qe
                                    };
                                }
                                return {
                                    u_depth: 2,
                                    u_terrain: 3,
                                    u_terrain_dim: Wn && Wn.dem && Wn.dem.dim || 1,
                                    u_terrain_matrix: Co ? this._demMatrixCache[Qe.key].matrix : this._emptyDemMatrix,
                                    u_terrain_unpack: Wn && Wn.dem && Wn.dem.getUnpackVector() || this._emptyDemUnpack,
                                    u_terrain_exaggeration: this.exaggeration,
                                    texture: (Wn && Wn.demTexture || this._emptyDemTexture).texture,
                                    depthTexture: (this._fboDepthTexture || this._emptyDepthTexture).texture,
                                    tile: Wn
                                };
                            }
                            getFramebuffer(Qe) {
                                const rt = this.painter, Wn = rt.width / devicePixelRatio, Co = rt.height / devicePixelRatio;
                                return !this._fbo || this._fbo.width === Wn && this._fbo.height === Co || (this._fbo.destroy(), this._fboCoordsTexture.destroy(), this._fboDepthTexture.destroy(), delete this._fbo, delete this._fboDepthTexture, delete this._fboCoordsTexture), this._fboCoordsTexture || (this._fboCoordsTexture = new v(rt.context, {
                                    width: Wn,
                                    height: Co,
                                    data: null
                                }, rt.context.gl.RGBA, {
                                    premultiply: !1
                                }), this._fboCoordsTexture.bind(rt.context.gl.NEAREST, rt.context.gl.CLAMP_TO_EDGE)), this._fboDepthTexture || (this._fboDepthTexture = new v(rt.context, {
                                    width: Wn,
                                    height: Co,
                                    data: null
                                }, rt.context.gl.RGBA, {
                                    premultiply: !1
                                }), this._fboDepthTexture.bind(rt.context.gl.NEAREST, rt.context.gl.CLAMP_TO_EDGE)), this._fbo || (this._fbo = rt.context.createFramebuffer(Wn, Co, !0, !1), this._fbo.depthAttachment.set(rt.context.createRenderbuffer(rt.context.gl.DEPTH_COMPONENT16, Wn, Co))), this._fbo.colorAttachment.set("coords" === Qe ? this._fboCoordsTexture.texture : this._fboDepthTexture.texture), this._fbo;
                            }
                            getCoordsTexture() {
                                const Qe = this.painter.context;
                                if (this._coordsTexture) return this._coordsTexture;
                                const Wn = new Uint8Array(this._coordsTextureSize * this._coordsTextureSize * 4);
                                for(let rt = 0, Ll = 0; rt < this._coordsTextureSize; rt++)for(let Qe = 0; Qe < this._coordsTextureSize; Qe++, Ll += 4)Wn[Ll + 0] = 255 & Qe, Wn[Ll + 1] = 255 & rt, Wn[Ll + 2] = Qe >> 8 << 4 | rt >> 8, Wn[Ll + 3] = 0;
                                const Co = new rt.R({
                                    width: this._coordsTextureSize,
                                    height: this._coordsTextureSize
                                }, new Uint8Array(Wn.buffer)), Dl = new v(Qe, Co, Qe.gl.RGBA, {
                                    premultiply: !1
                                });
                                return Dl.bind(Qe.gl.NEAREST, Qe.gl.CLAMP_TO_EDGE), this._coordsTexture = Dl, Dl;
                            }
                            pointCoordinate(Qe) {
                                this.painter.maybeDrawDepthAndCoords(!0);
                                const Wn = new Uint8Array(4), Co = this.painter.context, Dl = Co.gl, Ll = Math.round(Qe.x * this.painter.pixelRatio / devicePixelRatio), Rl = Math.round(Qe.y * this.painter.pixelRatio / devicePixelRatio), Ul = Math.round(this.painter.height / devicePixelRatio);
                                Co.bindFramebuffer.set(this.getFramebuffer("coords").framebuffer), Dl.readPixels(Ll, Ul - Rl - 1, 1, 1, Dl.RGBA, Dl.UNSIGNED_BYTE, Wn), Co.bindFramebuffer.set(null);
                                const Gl = Wn[0] + (Wn[2] >> 4 << 8), Zl = Wn[1] + ((15 & Wn[2]) << 8), Hl = this.coordsIndex[255 - Wn[3]], ql = Hl && this.sourceCache.getTileByID(Hl);
                                if (!ql) return null;
                                const Ql = this._coordsTextureSize, Kl = (1 << ql.tileID.canonical.z) * Ql;
                                return new rt.$((ql.tileID.canonical.x * Ql + Gl) / Kl + ql.tileID.wrap, (ql.tileID.canonical.y * Ql + Zl) / Kl, this.getElevation(ql.tileID, Gl, Zl, Ql));
                            }
                            depthAtPoint(Qe) {
                                const rt = new Uint8Array(4), Wn = this.painter.context, Co = Wn.gl;
                                return Wn.bindFramebuffer.set(this.getFramebuffer("depth").framebuffer), Co.readPixels(Qe.x, this.painter.height / devicePixelRatio - Qe.y - 1, 1, 1, Co.RGBA, Co.UNSIGNED_BYTE, rt), Wn.bindFramebuffer.set(null), (rt[0] / 16777216 + rt[1] / 65536 + rt[2] / 256 + rt[3]) / 256;
                            }
                            getTerrainMesh(Qe) {
                                var Wn;
                                const Co = (null === (Wn = this.painter.style.projection) || void 0 === Wn ? void 0 : Wn.transitionState) > 0, Dl = Co && 0 === Qe.canonical.y, Ll = Co && Qe.canonical.y === (1 << Qe.canonical.z) - 1, Rl = `m_${Dl ? "n" : ""}_${Ll ? "s" : ""}`;
                                if (this._meshCache[Rl]) return this._meshCache[Rl];
                                const Ul = this.painter.context, Gl = new rt.ci, Zl = new rt.aH, Hl = this.meshSize, ql = rt.Z / Hl, Ql = Hl * Hl;
                                for(let rt = 0; rt <= Hl; rt++)for(let Qe = 0; Qe <= Hl; Qe++)Gl.emplaceBack(Qe * ql, rt * ql, 0);
                                for(let rt = 0; rt < Ql; rt += Hl + 1)for(let Qe = 0; Qe < Hl; Qe++)Zl.emplaceBack(Qe + rt, Hl + Qe + rt + 1, Hl + Qe + rt + 2), Zl.emplaceBack(Qe + rt, Hl + Qe + rt + 2, Qe + rt + 1);
                                const Kl = Gl.length, $l = Kl + (Hl + 1), Tc = (Hl + 1) * Hl, tu = Dl ? rt.b9 : 0, lu = Dl ? 0 : 1, du = Ll ? rt.ba : rt.Z, fu = Ll ? 0 : 1;
                                for(let rt = 0; rt <= Hl; rt++)Gl.emplaceBack(rt * ql, tu, lu);
                                for(let rt = 0; rt <= Hl; rt++)Gl.emplaceBack(rt * ql, du, fu);
                                for(let rt = 0; rt < Hl; rt++)Zl.emplaceBack(Tc + rt, $l + rt, $l + rt + 1), Zl.emplaceBack(Tc + rt, $l + rt + 1, Tc + rt + 1), Zl.emplaceBack(0 + rt, Kl + rt + 1, Kl + rt), Zl.emplaceBack(0 + rt, 0 + rt + 1, Kl + rt + 1);
                                const yu = Gl.length, Eu = yu + 2 * (Hl + 1);
                                for (const Lu of [
                                    0,
                                    1
                                ])for(let Qe = 0; Qe <= Hl; Qe++)for (const Wn of [
                                    0,
                                    1
                                ])Gl.emplaceBack(Lu * rt.Z, Qe * ql, Wn);
                                for(let rt = 0; rt < 2 * Hl; rt += 2)Zl.emplaceBack(yu + rt, yu + rt + 1, yu + rt + 3), Zl.emplaceBack(yu + rt, yu + rt + 3, yu + rt + 2), Zl.emplaceBack(Eu + rt, Eu + rt + 3, Eu + rt + 1), Zl.emplaceBack(Eu + rt, Eu + rt + 2, Eu + rt + 3);
                                const Tu = new pt(Ul.createVertexBuffer(Gl, jd.members), Ul.createIndexBuffer(Zl), rt.aG.simpleSegment(0, 0, Gl.length, Zl.length));
                                return this._meshCache[Rl] = Tu, Tu;
                            }
                            getMeshFrameDelta(Qe) {
                                return 2 * Math.PI * rt.br / Math.pow(2, Math.max(Qe, 0)) / 5;
                            }
                            getMinTileElevationForLngLatZoom(Qe, rt) {
                                var Wn;
                                const { tileID: Co } = this._getOverscaledTileIDFromLngLatZoom(Qe, rt);
                                return null !== (Wn = this.getMinMaxElevation(Co).minElevation) && void 0 !== Wn ? Wn : 0;
                            }
                            getMinMaxElevation(Qe) {
                                const rt = this.getTerrainData(Qe).tile, Wn = {
                                    minElevation: null,
                                    maxElevation: null
                                };
                                return rt && rt.dem && (Wn.minElevation = rt.dem.min * this.exaggeration, Wn.maxElevation = rt.dem.max * this.exaggeration), Wn;
                            }
                            _getOverscaledTileIDFromLngLatZoom(Qe, Wn) {
                                const Co = rt.$.fromLngLat(Qe.wrap()), Dl = (1 << Wn) * rt.Z, Ll = Co.x * Dl, Rl = Co.y * Dl, Ul = Math.floor(Ll / rt.Z), Gl = Math.floor(Rl / rt.Z);
                                return {
                                    tileID: new rt.Y(Wn, 0, Wn, Ul, Gl),
                                    mercatorX: Ll,
                                    mercatorY: Rl
                                };
                            }
                        }
                        class Ea {
                            constructor(Qe, rt, Wn){
                                this._context = Qe, this._size = rt, this._tileSize = Wn, this._objects = [], this._recentlyUsed = [], this._stamp = 0;
                            }
                            destruct() {
                                for (const Qe of this._objects)Qe.texture.destroy(), Qe.fbo.destroy();
                            }
                            _createObject(Qe) {
                                const rt = this._context.createFramebuffer(this._tileSize, this._tileSize, !0, !0), Wn = new v(this._context, {
                                    width: this._tileSize,
                                    height: this._tileSize,
                                    data: null
                                }, this._context.gl.RGBA);
                                return Wn.bind(this._context.gl.LINEAR, this._context.gl.CLAMP_TO_EDGE), this._context.extTextureFilterAnisotropic && this._context.gl.texParameterf(this._context.gl.TEXTURE_2D, this._context.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, this._context.extTextureFilterAnisotropicMax), rt.depthAttachment.set(this._context.createRenderbuffer(this._context.gl.DEPTH_STENCIL, this._tileSize, this._tileSize)), rt.colorAttachment.set(Wn.texture), {
                                    id: Qe,
                                    fbo: rt,
                                    texture: Wn,
                                    stamp: -1,
                                    inUse: !1
                                };
                            }
                            getObjectForId(Qe) {
                                return this._objects[Qe];
                            }
                            useObject(Qe) {
                                Qe.inUse = !0, this._recentlyUsed = this._recentlyUsed.filter((rt)=>Qe.id !== rt), this._recentlyUsed.push(Qe.id);
                            }
                            stampObject(Qe) {
                                Qe.stamp = ++this._stamp;
                            }
                            getOrCreateFreeObject() {
                                for (const rt of this._recentlyUsed)if (!this._objects[rt].inUse) return this._objects[rt];
                                if (this._objects.length >= this._size) throw new Error("No free RenderPool available, call freeAllObjects() required!");
                                const Qe = this._createObject(this._objects.length);
                                return this._objects.push(Qe), Qe;
                            }
                            freeObject(Qe) {
                                Qe.inUse = !1;
                            }
                            freeAllObjects() {
                                for (const Qe of this._objects)this.freeObject(Qe);
                            }
                            isFull() {
                                return !(this._objects.length < this._size) && !1 === this._objects.some((Qe)=>!Qe.inUse);
                            }
                        }
                        const Ud = {
                            background: !0,
                            fill: !0,
                            line: !0,
                            raster: !0,
                            hillshade: !0
                        };
                        class Ra {
                            constructor(Qe, rt){
                                this.painter = Qe, this.terrain = rt, this.pool = new Ea(Qe.context, 30, rt.sourceCache.tileSize * rt.qualityFactor);
                            }
                            destruct() {
                                this.pool.destruct();
                            }
                            getTexture(Qe) {
                                return this.pool.getObjectForId(Qe.rtt[this._stacks.length - 1].id).texture;
                            }
                            prepareForRender(Qe, rt) {
                                this._stacks = [], this._prevType = null, this._rttTiles = [], this._renderableTiles = this.terrain.sourceCache.getRenderableTiles(), this._renderableLayerIds = Qe._order.filter((Wn)=>!Qe._layers[Wn].isHidden(rt)), this._coordsAscending = {};
                                for(const Wn in Qe.sourceCaches){
                                    this._coordsAscending[Wn] = {};
                                    const rt = Qe.sourceCaches[Wn].getVisibleCoordinates(), Co = Qe.sourceCaches[Wn].getSource(), Dl = Co instanceof X ? Co.terrainTileRanges : null;
                                    for (const Qe of rt){
                                        const rt = this.terrain.sourceCache.getTerrainCoords(Qe, Dl);
                                        for(const Qe in rt)this._coordsAscending[Wn][Qe] || (this._coordsAscending[Wn][Qe] = []), this._coordsAscending[Wn][Qe].push(rt[Qe]);
                                    }
                                }
                                this._coordsAscendingStr = {};
                                for (const Wn of Qe._order){
                                    const rt = Qe._layers[Wn], Co = rt.source;
                                    if (Ud[rt.type] && !this._coordsAscendingStr[Co]) {
                                        this._coordsAscendingStr[Co] = {};
                                        for(const Qe in this._coordsAscending[Co])this._coordsAscendingStr[Co][Qe] = this._coordsAscending[Co][Qe].map((Qe)=>Qe.key).sort().join();
                                    }
                                }
                                for (const Wn of this._renderableTiles)for(const Qe in this._coordsAscendingStr){
                                    const rt = this._coordsAscendingStr[Qe][Wn.tileID.key];
                                    rt && rt !== Wn.rttCoords[Qe] && (Wn.rtt = []);
                                }
                            }
                            renderLayer(Qe, Wn) {
                                if (Qe.isHidden(this.painter.transform.zoom)) return !1;
                                const Co = Object.assign(Object.assign({}, Wn), {
                                    isRenderingToTexture: !0
                                }), Dl = Qe.type, Ll = this.painter, Rl = this._renderableLayerIds[this._renderableLayerIds.length - 1] === Qe.id;
                                if (Ud[Dl] && (this._prevType && Ud[this._prevType] || this._stacks.push([]), this._prevType = Dl, this._stacks[this._stacks.length - 1].push(Qe.id), !Rl)) return !0;
                                if (Ud[this._prevType] || Ud[Dl] && Rl) {
                                    this._prevType = Dl;
                                    const Qe = this._stacks.length - 1, Wn = this._stacks[Qe] || [];
                                    for (const Dl of this._renderableTiles){
                                        if (this.pool.isFull() && (vo(this.painter, this.terrain, this._rttTiles, Co), this._rttTiles = [], this.pool.freeAllObjects()), this._rttTiles.push(Dl), Dl.rtt[Qe]) {
                                            const rt = this.pool.getObjectForId(Dl.rtt[Qe].id);
                                            if (rt.stamp === Dl.rtt[Qe].stamp) {
                                                this.pool.useObject(rt);
                                                continue;
                                            }
                                        }
                                        const Rl = this.pool.getOrCreateFreeObject();
                                        this.pool.useObject(Rl), this.pool.stampObject(Rl), Dl.rtt[Qe] = {
                                            id: Rl.id,
                                            stamp: Rl.stamp
                                        }, Ll.context.bindFramebuffer.set(Rl.fbo.framebuffer), Ll.context.clear({
                                            color: rt.b7.transparent,
                                            stencil: 0
                                        }), Ll.currentStencilSource = void 0;
                                        for(let Qe = 0; Qe < Wn.length; Qe++){
                                            const rt = Ll.style._layers[Wn[Qe]], Ul = rt.source ? this._coordsAscending[rt.source][Dl.tileID.key] : [
                                                Dl.tileID
                                            ];
                                            Ll.context.viewport.set([
                                                0,
                                                0,
                                                Rl.fbo.width,
                                                Rl.fbo.height
                                            ]), Ll._renderTileClippingMasks(rt, Ul, !0), Ll.renderLayer(Ll, Ll.style.sourceCaches[rt.source], rt, Ul, Co), rt.source && (Dl.rttCoords[rt.source] = this._coordsAscendingStr[rt.source][Dl.tileID.key]);
                                        }
                                    }
                                    return vo(this.painter, this.terrain, this._rttTiles, Co), this._rttTiles = [], this.pool.freeAllObjects(), Ud[Dl];
                                }
                                return !1;
                            }
                        }
                        const Vd = {
                            "AttributionControl.ToggleAttribution": "Toggle attribution",
                            "AttributionControl.MapFeedback": "Map feedback",
                            "FullscreenControl.Enter": "Enter fullscreen",
                            "FullscreenControl.Exit": "Exit fullscreen",
                            "GeolocateControl.FindMyLocation": "Find my location",
                            "GeolocateControl.LocationNotAvailable": "Location not available",
                            "LogoControl.Title": "MapLibre logo",
                            "Map.Title": "Map",
                            "Marker.Title": "Map marker",
                            "NavigationControl.ResetBearing": "Reset bearing to north",
                            "NavigationControl.ZoomIn": "Zoom in",
                            "NavigationControl.ZoomOut": "Zoom out",
                            "Popup.Close": "Close popup",
                            "ScaleControl.Feet": "ft",
                            "ScaleControl.Meters": "m",
                            "ScaleControl.Kilometers": "km",
                            "ScaleControl.Miles": "mi",
                            "ScaleControl.NauticalMiles": "nm",
                            "GlobeControl.Enable": "Enable globe",
                            "GlobeControl.Disable": "Disable globe",
                            "TerrainControl.Enable": "Enable terrain",
                            "TerrainControl.Disable": "Disable terrain",
                            "CooperativeGesturesHandler.WindowsHelpText": "Use Ctrl + scroll to zoom the map",
                            "CooperativeGesturesHandler.MacHelpText": "Use \u2318 + scroll to zoom the map",
                            "CooperativeGesturesHandler.MobileHelpText": "Use two fingers to move the map"
                        }, Gd = Wn, Zd = {
                            hash: !1,
                            interactive: !0,
                            bearingSnap: 7,
                            attributionControl: Fd,
                            maplibreLogo: !1,
                            refreshExpiredTiles: !0,
                            canvasContextAttributes: {
                                antialias: !1,
                                preserveDrawingBuffer: !1,
                                powerPreference: "high-performance",
                                failIfMajorPerformanceCaveat: !1,
                                desynchronized: !1,
                                contextType: void 0
                            },
                            scrollZoom: !0,
                            minZoom: -2,
                            maxZoom: 22,
                            minPitch: 0,
                            maxPitch: 60,
                            boxZoom: !0,
                            dragRotate: !0,
                            dragPan: !0,
                            keyboard: !0,
                            doubleClickZoom: !0,
                            touchZoomRotate: !0,
                            touchPitch: !0,
                            cooperativeGestures: !1,
                            trackResize: !0,
                            center: [
                                0,
                                0
                            ],
                            elevation: 0,
                            zoom: 0,
                            bearing: 0,
                            pitch: 0,
                            roll: 0,
                            renderWorldCopies: !0,
                            maxTileCacheSize: null,
                            maxTileCacheZoomLevels: rt.a.MAX_TILE_CACHE_ZOOM_LEVELS,
                            transformRequest: null,
                            transformCameraUpdate: null,
                            fadeDuration: 300,
                            crossSourceCollisions: !0,
                            clickTolerance: 3,
                            localIdeographFontFamily: "sans-serif",
                            pitchWithRotate: !0,
                            rollEnabled: !1,
                            validateStyle: !0,
                            maxCanvasSize: [
                                4096,
                                4096
                            ],
                            cancelPendingTileRequestsWhileZooming: !0,
                            centerClampedToGround: !0
                        }, Hd = {
                            showCompass: !0,
                            showZoom: !0,
                            visualizePitch: !1,
                            visualizeRoll: !0
                        };
                        class ka {
                            constructor(Qe, Wn, Co = !1){
                                this.mousedown = (Qe)=>{
                                    this.startMove(Qe, n.mousePos(this.element, Qe)), n.addEventListener(window, "mousemove", this.mousemove), n.addEventListener(window, "mouseup", this.mouseup);
                                }, this.mousemove = (Qe)=>{
                                    this.move(Qe, n.mousePos(this.element, Qe));
                                }, this.mouseup = (Qe)=>{
                                    this._rotatePitchHanlder.dragEnd(Qe), this.offTemp();
                                }, this.touchstart = (Qe)=>{
                                    1 !== Qe.targetTouches.length ? this.reset() : (this._startPos = this._lastPos = n.touchPos(this.element, Qe.targetTouches)[0], this.startMove(Qe, this._startPos), n.addEventListener(window, "touchmove", this.touchmove, {
                                        passive: !1
                                    }), n.addEventListener(window, "touchend", this.touchend));
                                }, this.touchmove = (Qe)=>{
                                    1 !== Qe.targetTouches.length ? this.reset() : (this._lastPos = n.touchPos(this.element, Qe.targetTouches)[0], this.move(Qe, this._lastPos));
                                }, this.touchend = (Qe)=>{
                                    0 === Qe.targetTouches.length && this._startPos && this._lastPos && this._startPos.dist(this._lastPos) < this._clickTolerance && this.element.click(), delete this._startPos, delete this._lastPos, this.offTemp();
                                }, this.reset = ()=>{
                                    this._rotatePitchHanlder.reset(), delete this._startPos, delete this._lastPos, this.offTemp();
                                }, this._clickTolerance = 10, this.element = Wn;
                                const Dl = new $o;
                                this._rotatePitchHanlder = new Uo({
                                    clickTolerance: 3,
                                    move: (Qe, Dl)=>{
                                        const Ll = Wn.getBoundingClientRect(), Rl = new rt.P((Ll.bottom - Ll.top) / 2, (Ll.right - Ll.left) / 2);
                                        return {
                                            bearingDelta: rt.ca(new rt.P(Qe.x, Dl.y), Dl, Rl),
                                            pitchDelta: Co ? -0.5 * (Dl.y - Qe.y) : void 0
                                        };
                                    },
                                    moveStateManager: Dl,
                                    enable: !0,
                                    assignEvents: ()=>{}
                                }), this.map = Qe, n.addEventListener(Wn, "mousedown", this.mousedown), n.addEventListener(Wn, "touchstart", this.touchstart, {
                                    passive: !1
                                }), n.addEventListener(Wn, "touchcancel", this.reset);
                            }
                            startMove(Qe, rt) {
                                this._rotatePitchHanlder.dragStart(Qe, rt), n.disableDrag();
                            }
                            move(Qe, rt) {
                                const Wn = this.map, { bearingDelta: Co, pitchDelta: Dl } = this._rotatePitchHanlder.dragMove(Qe, rt) || {};
                                Co && Wn.setBearing(Wn.getBearing() + Co), Dl && Wn.setPitch(Wn.getPitch() + Dl);
                            }
                            off() {
                                const Qe = this.element;
                                n.removeEventListener(Qe, "mousedown", this.mousedown), n.removeEventListener(Qe, "touchstart", this.touchstart, {
                                    passive: !1
                                }), n.removeEventListener(window, "touchmove", this.touchmove, {
                                    passive: !1
                                }), n.removeEventListener(window, "touchend", this.touchend), n.removeEventListener(Qe, "touchcancel", this.reset), this.offTemp();
                            }
                            offTemp() {
                                n.enableDrag(), n.removeEventListener(window, "mousemove", this.mousemove), n.removeEventListener(window, "mouseup", this.mouseup), n.removeEventListener(window, "touchmove", this.touchmove, {
                                    passive: !1
                                }), n.removeEventListener(window, "touchend", this.touchend);
                            }
                        }
                        let Wd;
                        function Ba(Qe, Wn, Co) {
                            const Dl = new rt.Q(Qe.lng, Qe.lat);
                            if (Qe = new rt.Q(Qe.lng, Qe.lat), Wn) {
                                const Dl = new rt.Q(Qe.lng - 360, Qe.lat), Ll = new rt.Q(Qe.lng + 360, Qe.lat), Rl = Co.locationToScreenPoint(Qe).distSqr(Wn);
                                Co.locationToScreenPoint(Dl).distSqr(Wn) < Rl ? Qe = Dl : Co.locationToScreenPoint(Ll).distSqr(Wn) < Rl && (Qe = Ll);
                            }
                            for(; Math.abs(Qe.lng - Co.center.lng) > 180;){
                                const rt = Co.locationToScreenPoint(Qe);
                                if (rt.x >= 0 && rt.y >= 0 && rt.x <= Co.width && rt.y <= Co.height) break;
                                Qe.lng > Co.center.lng ? Qe.lng -= 360 : Qe.lng += 360;
                            }
                            return Qe.lng !== Dl.lng && Co.isPointOnMapSurface(Co.locationToScreenPoint(Qe)) ? Qe : Dl;
                        }
                        const qd = {
                            center: "translate(-50%,-50%)",
                            top: "translate(-50%,0)",
                            "top-left": "translate(0,0)",
                            "top-right": "translate(-100%,0)",
                            bottom: "translate(-50%,-100%)",
                            "bottom-left": "translate(0,-100%)",
                            "bottom-right": "translate(-100%,-100%)",
                            left: "translate(0,-50%)",
                            right: "translate(-100%,-50%)"
                        };
                        function ja(Qe, rt, Wn) {
                            const Co = Qe.classList;
                            for(const Dl in qd)Co.remove(`maplibregl-${Wn}-anchor-${Dl}`);
                            Co.add(`maplibregl-${Wn}-anchor-${rt}`);
                        }
                        class Za extends rt.E {
                            constructor(Qe){
                                if (super(), this._onKeyPress = (Qe)=>{
                                    const rt = Qe.code, Wn = Qe.charCode || Qe.keyCode;
                                    "Space" !== rt && "Enter" !== rt && 32 !== Wn && 13 !== Wn || this.togglePopup();
                                }, this._onMapClick = (Qe)=>{
                                    const rt = Qe.originalEvent.target, Wn = this._element;
                                    this._popup && (rt === Wn || Wn.contains(rt)) && this.togglePopup();
                                }, this._update = (Qe)=>{
                                    var rt;
                                    if (!this._map) return;
                                    const Wn = this._map.loaded() && !this._map.isMoving();
                                    ("terrain" === (null == Qe ? void 0 : Qe.type) || "render" === (null == Qe ? void 0 : Qe.type) && !Wn) && this._map.once("render", this._update), this._lngLat = this._map.transform.renderWorldCopies ? Ba(this._lngLat, this._flatPos, this._map.transform) : null === (rt = this._lngLat) || void 0 === rt ? void 0 : rt.wrap(), this._flatPos = this._pos = this._map.project(this._lngLat)._add(this._offset), this._map.terrain && (this._flatPos = this._map.transform.locationToScreenPoint(this._lngLat)._add(this._offset));
                                    let Co = "";
                                    "viewport" === this._rotationAlignment || "auto" === this._rotationAlignment ? Co = `rotateZ(${this._rotation}deg)` : "map" === this._rotationAlignment && (Co = `rotateZ(${this._rotation - this._map.getBearing()}deg)`);
                                    let Dl = "";
                                    "viewport" === this._pitchAlignment || "auto" === this._pitchAlignment ? Dl = "rotateX(0deg)" : "map" === this._pitchAlignment && (Dl = `rotateX(${this._map.getPitch()}deg)`), this._subpixelPositioning || Qe && "moveend" !== Qe.type || (this._pos = this._pos.round()), n.setTransform(this._element, `${qd[this._anchor]} translate(${this._pos.x}px, ${this._pos.y}px) ${Dl} ${Co}`), Ll.frameAsync(new AbortController).then(()=>{
                                        this._updateOpacity(Qe && "moveend" === Qe.type);
                                    }).catch(()=>{});
                                }, this._onMove = (Qe)=>{
                                    if (!this._isDragging) {
                                        const rt = this._clickTolerance || this._map._clickTolerance;
                                        this._isDragging = Qe.point.dist(this._pointerdownPos) >= rt;
                                    }
                                    this._isDragging && (this._pos = Qe.point.sub(this._positionDelta), this._lngLat = this._map.unproject(this._pos), this.setLngLat(this._lngLat), this._element.style.pointerEvents = "none", "pending" === this._state && (this._state = "active", this.fire(new rt.l("dragstart"))), this.fire(new rt.l("drag")));
                                }, this._onUp = ()=>{
                                    this._element.style.pointerEvents = "auto", this._positionDelta = null, this._pointerdownPos = null, this._isDragging = !1, this._map.off("mousemove", this._onMove), this._map.off("touchmove", this._onMove), "active" === this._state && this.fire(new rt.l("dragend")), this._state = "inactive";
                                }, this._addDragHandler = (Qe)=>{
                                    this._element.contains(Qe.originalEvent.target) && (Qe.preventDefault(), this._positionDelta = Qe.point.sub(this._pos).add(this._offset), this._pointerdownPos = Qe.point, this._state = "pending", this._map.on("mousemove", this._onMove), this._map.on("touchmove", this._onMove), this._map.once("mouseup", this._onUp), this._map.once("touchend", this._onUp));
                                }, this._anchor = Qe && Qe.anchor || "center", this._color = Qe && Qe.color || "#3FB1CE", this._scale = Qe && Qe.scale || 1, this._draggable = Qe && Qe.draggable || !1, this._clickTolerance = Qe && Qe.clickTolerance || 0, this._subpixelPositioning = Qe && Qe.subpixelPositioning || !1, this._isDragging = !1, this._state = "inactive", this._rotation = Qe && Qe.rotation || 0, this._rotationAlignment = Qe && Qe.rotationAlignment || "auto", this._pitchAlignment = Qe && Qe.pitchAlignment && "auto" !== Qe.pitchAlignment ? Qe.pitchAlignment : this._rotationAlignment, this.setOpacity(null == Qe ? void 0 : Qe.opacity, null == Qe ? void 0 : Qe.opacityWhenCovered), Qe && Qe.element) this._element = Qe.element, this._offset = rt.P.convert(Qe && Qe.offset || [
                                    0,
                                    0
                                ]);
                                else {
                                    this._defaultMarker = !0, this._element = n.create("div");
                                    const Wn = n.createNS("http://www.w3.org/2000/svg", "svg"), Co = 41, Dl = 27;
                                    Wn.setAttributeNS(null, "display", "block"), Wn.setAttributeNS(null, "height", `${Co}px`), Wn.setAttributeNS(null, "width", `${Dl}px`), Wn.setAttributeNS(null, "viewBox", `0 0 ${Dl} ${Co}`);
                                    const Ll = n.createNS("http://www.w3.org/2000/svg", "g");
                                    Ll.setAttributeNS(null, "stroke", "none"), Ll.setAttributeNS(null, "stroke-width", "1"), Ll.setAttributeNS(null, "fill", "none"), Ll.setAttributeNS(null, "fill-rule", "evenodd");
                                    const Rl = n.createNS("http://www.w3.org/2000/svg", "g");
                                    Rl.setAttributeNS(null, "fill-rule", "nonzero");
                                    const Ul = n.createNS("http://www.w3.org/2000/svg", "g");
                                    Ul.setAttributeNS(null, "transform", "translate(3.0, 29.0)"), Ul.setAttributeNS(null, "fill", "#000000");
                                    const Gl = [
                                        {
                                            rx: "10.5",
                                            ry: "5.25002273"
                                        },
                                        {
                                            rx: "10.5",
                                            ry: "5.25002273"
                                        },
                                        {
                                            rx: "9.5",
                                            ry: "4.77275007"
                                        },
                                        {
                                            rx: "8.5",
                                            ry: "4.29549936"
                                        },
                                        {
                                            rx: "7.5",
                                            ry: "3.81822308"
                                        },
                                        {
                                            rx: "6.5",
                                            ry: "3.34094679"
                                        },
                                        {
                                            rx: "5.5",
                                            ry: "2.86367051"
                                        },
                                        {
                                            rx: "4.5",
                                            ry: "2.38636864"
                                        }
                                    ];
                                    for (const Qe of Gl){
                                        const rt = n.createNS("http://www.w3.org/2000/svg", "ellipse");
                                        rt.setAttributeNS(null, "opacity", "0.04"), rt.setAttributeNS(null, "cx", "10.5"), rt.setAttributeNS(null, "cy", "5.80029008"), rt.setAttributeNS(null, "rx", Qe.rx), rt.setAttributeNS(null, "ry", Qe.ry), Ul.appendChild(rt);
                                    }
                                    const Zl = n.createNS("http://www.w3.org/2000/svg", "g");
                                    Zl.setAttributeNS(null, "fill", this._color);
                                    const Hl = n.createNS("http://www.w3.org/2000/svg", "path");
                                    Hl.setAttributeNS(null, "d", "M27,13.5 C27,19.074644 20.250001,27.000002 14.75,34.500002 C14.016665,35.500004 12.983335,35.500004 12.25,34.500002 C6.7499993,27.000002 0,19.222562 0,13.5 C0,6.0441559 6.0441559,0 13.5,0 C20.955844,0 27,6.0441559 27,13.5 Z"), Zl.appendChild(Hl);
                                    const ql = n.createNS("http://www.w3.org/2000/svg", "g");
                                    ql.setAttributeNS(null, "opacity", "0.25"), ql.setAttributeNS(null, "fill", "#000000");
                                    const Ql = n.createNS("http://www.w3.org/2000/svg", "path");
                                    Ql.setAttributeNS(null, "d", "M13.5,0 C6.0441559,0 0,6.0441559 0,13.5 C0,19.222562 6.7499993,27 12.25,34.5 C13,35.522727 14.016664,35.500004 14.75,34.5 C20.250001,27 27,19.074644 27,13.5 C27,6.0441559 20.955844,0 13.5,0 Z M13.5,1 C20.415404,1 26,6.584596 26,13.5 C26,15.898657 24.495584,19.181431 22.220703,22.738281 C19.945823,26.295132 16.705119,30.142167 13.943359,33.908203 C13.743445,34.180814 13.612715,34.322738 13.5,34.441406 C13.387285,34.322738 13.256555,34.180814 13.056641,33.908203 C10.284481,30.127985 7.4148684,26.314159 5.015625,22.773438 C2.6163816,19.232715 1,15.953538 1,13.5 C1,6.584596 6.584596,1 13.5,1 Z"), ql.appendChild(Ql);
                                    const Kl = n.createNS("http://www.w3.org/2000/svg", "g");
                                    Kl.setAttributeNS(null, "transform", "translate(6.0, 7.0)"), Kl.setAttributeNS(null, "fill", "#FFFFFF");
                                    const $l = n.createNS("http://www.w3.org/2000/svg", "g");
                                    $l.setAttributeNS(null, "transform", "translate(8.0, 8.0)");
                                    const Tc = n.createNS("http://www.w3.org/2000/svg", "circle");
                                    Tc.setAttributeNS(null, "fill", "#000000"), Tc.setAttributeNS(null, "opacity", "0.25"), Tc.setAttributeNS(null, "cx", "5.5"), Tc.setAttributeNS(null, "cy", "5.5"), Tc.setAttributeNS(null, "r", "5.4999962");
                                    const tu = n.createNS("http://www.w3.org/2000/svg", "circle");
                                    tu.setAttributeNS(null, "fill", "#FFFFFF"), tu.setAttributeNS(null, "cx", "5.5"), tu.setAttributeNS(null, "cy", "5.5"), tu.setAttributeNS(null, "r", "5.4999962"), $l.appendChild(Tc), $l.appendChild(tu), Rl.appendChild(Ul), Rl.appendChild(Zl), Rl.appendChild(ql), Rl.appendChild(Kl), Rl.appendChild($l), Wn.appendChild(Rl), Wn.setAttributeNS(null, "height", Co * this._scale + "px"), Wn.setAttributeNS(null, "width", Dl * this._scale + "px"), this._element.appendChild(Wn), this._offset = rt.P.convert(Qe && Qe.offset || [
                                        0,
                                        -14
                                    ]);
                                }
                                if (this._element.classList.add("maplibregl-marker"), this._element.addEventListener("dragstart", (Qe)=>{
                                    Qe.preventDefault();
                                }), this._element.addEventListener("mousedown", (Qe)=>{
                                    Qe.preventDefault();
                                }), ja(this._element, this._anchor, "marker"), Qe && Qe.className) for (const rt of Qe.className.split(" "))this._element.classList.add(rt);
                                this._popup = null;
                            }
                            addTo(Qe) {
                                return this.remove(), this._map = Qe, this._element.setAttribute("aria-label", Qe._getUIString("Marker.Title")), Qe.getCanvasContainer().appendChild(this._element), Qe.on("move", this._update), Qe.on("moveend", this._update), Qe.on("terrain", this._update), Qe.on("projectiontransition", this._update), this.setDraggable(this._draggable), this._update(), this._map.on("click", this._onMapClick), this;
                            }
                            remove() {
                                return this._opacityTimeout && (clearTimeout(this._opacityTimeout), delete this._opacityTimeout), this._map && (this._map.off("click", this._onMapClick), this._map.off("move", this._update), this._map.off("moveend", this._update), this._map.off("terrain", this._update), this._map.off("projectiontransition", this._update), this._map.off("mousedown", this._addDragHandler), this._map.off("touchstart", this._addDragHandler), this._map.off("mouseup", this._onUp), this._map.off("touchend", this._onUp), this._map.off("mousemove", this._onMove), this._map.off("touchmove", this._onMove), delete this._map), n.remove(this._element), this._popup && this._popup.remove(), this;
                            }
                            getLngLat() {
                                return this._lngLat;
                            }
                            setLngLat(Qe) {
                                return this._lngLat = rt.Q.convert(Qe), this._pos = null, this._popup && this._popup.setLngLat(this._lngLat), this._update(), this;
                            }
                            getElement() {
                                return this._element;
                            }
                            setPopup(Qe) {
                                if (this._popup && (this._popup.remove(), this._popup = null, this._element.removeEventListener("keypress", this._onKeyPress), this._originalTabIndex || this._element.removeAttribute("tabindex")), Qe) {
                                    if (!("offset" in Qe.options)) {
                                        const rt = 38.1, Wn = 13.5, Co = Math.abs(Wn) / Math.SQRT2;
                                        Qe.options.offset = this._defaultMarker ? {
                                            top: [
                                                0,
                                                0
                                            ],
                                            "top-left": [
                                                0,
                                                0
                                            ],
                                            "top-right": [
                                                0,
                                                0
                                            ],
                                            bottom: [
                                                0,
                                                -38.1
                                            ],
                                            "bottom-left": [
                                                Co,
                                                -1 * (rt - Wn + Co)
                                            ],
                                            "bottom-right": [
                                                -Co,
                                                -1 * (rt - Wn + Co)
                                            ],
                                            left: [
                                                Wn,
                                                -1 * (rt - Wn)
                                            ],
                                            right: [
                                                -13.5,
                                                -1 * (rt - Wn)
                                            ]
                                        } : this._offset;
                                    }
                                    this._popup = Qe, this._originalTabIndex = this._element.getAttribute("tabindex"), this._originalTabIndex || this._element.setAttribute("tabindex", "0"), this._element.addEventListener("keypress", this._onKeyPress);
                                }
                                return this;
                            }
                            setSubpixelPositioning(Qe) {
                                return this._subpixelPositioning = Qe, this;
                            }
                            getPopup() {
                                return this._popup;
                            }
                            togglePopup() {
                                const Qe = this._popup;
                                return this._element.style.opacity === this._opacityWhenCovered ? this : Qe ? (Qe.isOpen() ? Qe.remove() : (Qe.setLngLat(this._lngLat), Qe.addTo(this._map)), this) : this;
                            }
                            _updateOpacity(Qe = !1) {
                                var Wn, Co;
                                if (!(null === (Wn = this._map) || void 0 === Wn ? void 0 : Wn.terrain)) {
                                    const Qe = this._map.transform.isLocationOccluded(this._lngLat) ? this._opacityWhenCovered : this._opacity;
                                    return void (this._element.style.opacity !== Qe && (this._element.style.opacity = Qe));
                                }
                                if (Qe) this._opacityTimeout = null;
                                else {
                                    if (this._opacityTimeout) return;
                                    this._opacityTimeout = setTimeout(()=>{
                                        this._opacityTimeout = null;
                                    }, 100);
                                }
                                const Dl = this._map, Ll = Dl.terrain.depthAtPoint(this._pos), Rl = Dl.terrain.getElevationForLngLatZoom(this._lngLat, Dl.transform.tileZoom);
                                if (Dl.transform.lngLatToCameraDepth(this._lngLat, Rl) - Ll < .006) return void (this._element.style.opacity = this._opacity);
                                const Ul = -this._offset.y / Dl.transform.pixelsPerMeter, Gl = Math.sin(Dl.getPitch() * Math.PI / 180) * Ul, Zl = Dl.terrain.depthAtPoint(new rt.P(this._pos.x, this._pos.y - this._offset.y)), Hl = Dl.transform.lngLatToCameraDepth(this._lngLat, Rl + Gl) - Zl > .006;
                                (null === (Co = this._popup) || void 0 === Co ? void 0 : Co.isOpen()) && Hl && this._popup.remove(), this._element.style.opacity = Hl ? this._opacityWhenCovered : this._opacity;
                            }
                            getOffset() {
                                return this._offset;
                            }
                            setOffset(Qe) {
                                return this._offset = rt.P.convert(Qe), this._update(), this;
                            }
                            addClassName(Qe) {
                                this._element.classList.add(Qe);
                            }
                            removeClassName(Qe) {
                                this._element.classList.remove(Qe);
                            }
                            toggleClassName(Qe) {
                                return this._element.classList.toggle(Qe);
                            }
                            setDraggable(Qe) {
                                return this._draggable = !!Qe, this._map && (Qe ? (this._map.on("mousedown", this._addDragHandler), this._map.on("touchstart", this._addDragHandler)) : (this._map.off("mousedown", this._addDragHandler), this._map.off("touchstart", this._addDragHandler))), this;
                            }
                            isDraggable() {
                                return this._draggable;
                            }
                            setRotation(Qe) {
                                return this._rotation = Qe || 0, this._update(), this;
                            }
                            getRotation() {
                                return this._rotation;
                            }
                            setRotationAlignment(Qe) {
                                return this._rotationAlignment = Qe || "auto", this._update(), this;
                            }
                            getRotationAlignment() {
                                return this._rotationAlignment;
                            }
                            setPitchAlignment(Qe) {
                                return this._pitchAlignment = Qe && "auto" !== Qe ? Qe : this._rotationAlignment, this._update(), this;
                            }
                            getPitchAlignment() {
                                return this._pitchAlignment;
                            }
                            setOpacity(Qe, rt) {
                                return (void 0 === this._opacity || void 0 === Qe && void 0 === rt) && (this._opacity = "1", this._opacityWhenCovered = "0.2"), void 0 !== Qe && (this._opacity = Qe), void 0 !== rt && (this._opacityWhenCovered = rt), this._map && this._updateOpacity(!0), this;
                            }
                        }
                        const Yd = {
                            positionOptions: {
                                enableHighAccuracy: !1,
                                maximumAge: 0,
                                timeout: 6e3
                            },
                            fitBoundsOptions: {
                                maxZoom: 15
                            },
                            trackUserLocation: !1,
                            showAccuracyCircle: !0,
                            showUserLocation: !0
                        };
                        let Qd = 0, Kd = !1;
                        const Xd = {
                            maxWidth: 100,
                            unit: "metric"
                        };
                        function qa(Qe, rt, Wn) {
                            const Co = Wn && Wn.maxWidth || 100, Dl = Qe._container.clientHeight / 2, Ll = Qe._container.clientWidth / 2, Rl = Qe.unproject([
                                Ll - Co / 2,
                                Dl
                            ]), Ul = Qe.unproject([
                                Ll + Co / 2,
                                Dl
                            ]), Gl = Math.round(Qe.project(Ul).x - Qe.project(Rl).x), Zl = Math.min(Co, Gl, Qe._container.clientWidth), Hl = Rl.distanceTo(Ul);
                            if (Wn && "imperial" === Wn.unit) {
                                const Wn = 3.2808 * Hl;
                                Wn > 5280 ? Wa(rt, Zl, Wn / 5280, Qe._getUIString("ScaleControl.Miles")) : Wa(rt, Zl, Wn, Qe._getUIString("ScaleControl.Feet"));
                            } else Wn && "nautical" === Wn.unit ? Wa(rt, Zl, Hl / 1852, Qe._getUIString("ScaleControl.NauticalMiles")) : Hl >= 1e3 ? Wa(rt, Zl, Hl / 1e3, Qe._getUIString("ScaleControl.Kilometers")) : Wa(rt, Zl, Hl, Qe._getUIString("ScaleControl.Meters"));
                        }
                        function Wa(Qe, rt, Wn, Co) {
                            const Dl = function(Qe) {
                                const rt = Math.pow(10, `${Math.floor(Qe)}`.length - 1);
                                let Wn = Qe / rt;
                                return Wn = Wn >= 10 ? 10 : Wn >= 5 ? 5 : Wn >= 3 ? 3 : Wn >= 2 ? 2 : Wn >= 1 ? 1 : function(Qe) {
                                    const rt = Math.pow(10, Math.ceil(-Math.log(Qe) / Math.LN10));
                                    return Math.round(Qe * rt) / rt;
                                }(Wn), rt * Wn;
                            }(Wn);
                            Qe.style.width = rt * (Dl / Wn) + "px", Qe.innerHTML = `${Dl}&nbsp;${Co}`;
                        }
                        const Jd = {
                            closeButton: !0,
                            closeOnClick: !0,
                            focusAfterOpen: !0,
                            className: "",
                            maxWidth: "240px",
                            subpixelPositioning: !1,
                            locationOccludedOpacity: void 0
                        }, $d = [
                            "a[href]",
                            "[tabindex]:not([tabindex='-1'])",
                            "[contenteditable]:not([contenteditable='false'])",
                            "button:not([disabled])",
                            "input:not([disabled])",
                            "select:not([disabled])",
                            "textarea:not([disabled])"
                        ].join(", ");
                        function Ka(Qe) {
                            if (Qe) {
                                if ("number" == typeof Qe) {
                                    const Wn = Math.round(Math.abs(Qe) / Math.SQRT2);
                                    return {
                                        center: new rt.P(0, 0),
                                        top: new rt.P(0, Qe),
                                        "top-left": new rt.P(Wn, Wn),
                                        "top-right": new rt.P(-Wn, Wn),
                                        bottom: new rt.P(0, -Qe),
                                        "bottom-left": new rt.P(Wn, -Wn),
                                        "bottom-right": new rt.P(-Wn, -Wn),
                                        left: new rt.P(Qe, 0),
                                        right: new rt.P(-Qe, 0)
                                    };
                                }
                                if (Qe instanceof rt.P || Array.isArray(Qe)) {
                                    const Wn = rt.P.convert(Qe);
                                    return {
                                        center: Wn,
                                        top: Wn,
                                        "top-left": Wn,
                                        "top-right": Wn,
                                        bottom: Wn,
                                        "bottom-left": Wn,
                                        "bottom-right": Wn,
                                        left: Wn,
                                        right: Wn
                                    };
                                }
                                return {
                                    center: rt.P.convert(Qe.center || [
                                        0,
                                        0
                                    ]),
                                    top: rt.P.convert(Qe.top || [
                                        0,
                                        0
                                    ]),
                                    "top-left": rt.P.convert(Qe["top-left"] || [
                                        0,
                                        0
                                    ]),
                                    "top-right": rt.P.convert(Qe["top-right"] || [
                                        0,
                                        0
                                    ]),
                                    bottom: rt.P.convert(Qe.bottom || [
                                        0,
                                        0
                                    ]),
                                    "bottom-left": rt.P.convert(Qe["bottom-left"] || [
                                        0,
                                        0
                                    ]),
                                    "bottom-right": rt.P.convert(Qe["bottom-right"] || [
                                        0,
                                        0
                                    ]),
                                    left: rt.P.convert(Qe.left || [
                                        0,
                                        0
                                    ]),
                                    right: rt.P.convert(Qe.right || [
                                        0,
                                        0
                                    ])
                                };
                            }
                            return Ka(new rt.P(0, 0));
                        }
                        const up = Wn;
                        Qe.AJAXError = rt.cm, Qe.Event = rt.l, Qe.Evented = rt.E, Qe.LngLat = rt.Q, Qe.MercatorCoordinate = rt.$, Qe.Point = rt.P, Qe.addProtocol = rt.cn, Qe.config = rt.a, Qe.removeProtocol = rt.co, Qe.AttributionControl = wa, Qe.BoxZoomHandler = Oo, Qe.CanvasSource = Y, Qe.CooperativeGesturesHandler = ma, Qe.DoubleClickZoomHandler = ca, Qe.DragPanHandler = da, Qe.DragRotateHandler = _a, Qe.EdgeInsets = Pt, Qe.FullscreenControl = class extends rt.E {
                            constructor(Qe = {}){
                                super(), this._onFullscreenChange = ()=>{
                                    var Qe;
                                    let rt = window.document.fullscreenElement || window.document.mozFullScreenElement || window.document.webkitFullscreenElement || window.document.msFullscreenElement;
                                    for(; null === (Qe = null == rt ? void 0 : rt.shadowRoot) || void 0 === Qe ? void 0 : Qe.fullscreenElement;)rt = rt.shadowRoot.fullscreenElement;
                                    rt === this._container !== this._fullscreen && this._handleFullscreenChange();
                                }, this._onClickFullscreen = ()=>{
                                    this._isFullscreen() ? this._exitFullscreen() : this._requestFullscreen();
                                }, this._fullscreen = !1, Qe && Qe.container && (Qe.container instanceof HTMLElement ? this._container = Qe.container : rt.w("Full screen control 'container' must be a DOM element.")), "onfullscreenchange" in document ? this._fullscreenchange = "fullscreenchange" : "onmozfullscreenchange" in document ? this._fullscreenchange = "mozfullscreenchange" : "onwebkitfullscreenchange" in document ? this._fullscreenchange = "webkitfullscreenchange" : "onmsfullscreenchange" in document && (this._fullscreenchange = "MSFullscreenChange");
                            }
                            onAdd(Qe) {
                                return this._map = Qe, this._container || (this._container = this._map.getContainer()), this._controlContainer = n.create("div", "maplibregl-ctrl maplibregl-ctrl-group"), this._setupUI(), this._controlContainer;
                            }
                            onRemove() {
                                n.remove(this._controlContainer), this._map = null, window.document.removeEventListener(this._fullscreenchange, this._onFullscreenChange);
                            }
                            _setupUI() {
                                const Qe = this._fullscreenButton = n.create("button", "maplibregl-ctrl-fullscreen", this._controlContainer);
                                n.create("span", "maplibregl-ctrl-icon", Qe).setAttribute("aria-hidden", "true"), Qe.type = "button", this._updateTitle(), this._fullscreenButton.addEventListener("click", this._onClickFullscreen), window.document.addEventListener(this._fullscreenchange, this._onFullscreenChange);
                            }
                            _updateTitle() {
                                const Qe = this._getTitle();
                                this._fullscreenButton.setAttribute("aria-label", Qe), this._fullscreenButton.title = Qe;
                            }
                            _getTitle() {
                                return this._map._getUIString(this._isFullscreen() ? "FullscreenControl.Exit" : "FullscreenControl.Enter");
                            }
                            _isFullscreen() {
                                return this._fullscreen;
                            }
                            _handleFullscreenChange() {
                                this._fullscreen = !this._fullscreen, this._fullscreenButton.classList.toggle("maplibregl-ctrl-shrink"), this._fullscreenButton.classList.toggle("maplibregl-ctrl-fullscreen"), this._updateTitle(), this._fullscreen ? (this.fire(new rt.l("fullscreenstart")), this._prevCooperativeGesturesEnabled = this._map.cooperativeGestures.isEnabled(), this._map.cooperativeGestures.disable()) : (this.fire(new rt.l("fullscreenend")), this._prevCooperativeGesturesEnabled && this._map.cooperativeGestures.enable());
                            }
                            _exitFullscreen() {
                                window.document.exitFullscreen ? window.document.exitFullscreen() : window.document.mozCancelFullScreen ? window.document.mozCancelFullScreen() : window.document.msExitFullscreen ? window.document.msExitFullscreen() : window.document.webkitCancelFullScreen ? window.document.webkitCancelFullScreen() : this._togglePseudoFullScreen();
                            }
                            _requestFullscreen() {
                                this._container.requestFullscreen ? this._container.requestFullscreen() : this._container.mozRequestFullScreen ? this._container.mozRequestFullScreen() : this._container.msRequestFullscreen ? this._container.msRequestFullscreen() : this._container.webkitRequestFullscreen ? this._container.webkitRequestFullscreen() : this._togglePseudoFullScreen();
                            }
                            _togglePseudoFullScreen() {
                                this._container.classList.toggle("maplibregl-pseudo-fullscreen"), this._handleFullscreenChange(), this._map.resize();
                            }
                        }, Qe.GeoJSONSource = K, Qe.GeolocateControl = class extends rt.E {
                            constructor(Qe){
                                super(), this._onSuccess = (Qe)=>{
                                    if (this._map) {
                                        if (this._isOutOfMapMaxBounds(Qe)) return this._setErrorState(), this.fire(new rt.l("outofmaxbounds", Qe)), this._updateMarker(), void this._finish();
                                        if (this.options.trackUserLocation) switch(this._lastKnownPosition = Qe, this._watchState){
                                            case "WAITING_ACTIVE":
                                            case "ACTIVE_LOCK":
                                            case "ACTIVE_ERROR":
                                                this._watchState = "ACTIVE_LOCK", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active-error"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-active");
                                                break;
                                            case "BACKGROUND":
                                            case "BACKGROUND_ERROR":
                                                this._watchState = "BACKGROUND", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background-error"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-background");
                                                break;
                                            default:
                                                throw new Error(`Unexpected watchState ${this._watchState}`);
                                        }
                                        this.options.showUserLocation && "OFF" !== this._watchState && this._updateMarker(Qe), this.options.trackUserLocation && "ACTIVE_LOCK" !== this._watchState || this._updateCamera(Qe), this.options.showUserLocation && this._dotElement.classList.remove("maplibregl-user-location-dot-stale"), this.fire(new rt.l("geolocate", Qe)), this._finish();
                                    }
                                }, this._updateCamera = (Qe)=>{
                                    const Wn = new rt.Q(Qe.coords.longitude, Qe.coords.latitude), Co = Qe.coords.accuracy, Dl = this._map.getBearing(), Ll = rt.e({
                                        bearing: Dl
                                    }, this.options.fitBoundsOptions), Rl = V.fromLngLat(Wn, Co);
                                    this._map.fitBounds(Rl, Ll, {
                                        geolocateSource: !0
                                    });
                                }, this._updateMarker = (Qe)=>{
                                    if (Qe) {
                                        const Wn = new rt.Q(Qe.coords.longitude, Qe.coords.latitude);
                                        this._accuracyCircleMarker.setLngLat(Wn).addTo(this._map), this._userLocationDotMarker.setLngLat(Wn).addTo(this._map), this._accuracy = Qe.coords.accuracy, this.options.showUserLocation && this.options.showAccuracyCircle && this._updateCircleRadius();
                                    } else this._userLocationDotMarker.remove(), this._accuracyCircleMarker.remove();
                                }, this._onZoom = ()=>{
                                    this.options.showUserLocation && this.options.showAccuracyCircle && this._updateCircleRadius();
                                }, this._onError = (Qe)=>{
                                    if (this._map) {
                                        if (this.options.trackUserLocation) {
                                            if (1 === Qe.code) {
                                                this._watchState = "OFF", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active-error"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background-error"), this._geolocateButton.disabled = !0;
                                                const Qe = this._map._getUIString("GeolocateControl.LocationNotAvailable");
                                                this._geolocateButton.title = Qe, this._geolocateButton.setAttribute("aria-label", Qe), void 0 !== this._geolocationWatchID && this._clearWatch();
                                            } else {
                                                if (3 === Qe.code && Kd) return;
                                                this._setErrorState();
                                            }
                                        }
                                        "OFF" !== this._watchState && this.options.showUserLocation && this._dotElement.classList.add("maplibregl-user-location-dot-stale"), this.fire(new rt.l("error", Qe)), this._finish();
                                    }
                                }, this._finish = ()=>{
                                    this._timeoutId && clearTimeout(this._timeoutId), this._timeoutId = void 0;
                                }, this._setupUI = ()=>{
                                    this._map && (this._container.addEventListener("contextmenu", (Qe)=>Qe.preventDefault()), this._geolocateButton = n.create("button", "maplibregl-ctrl-geolocate", this._container), n.create("span", "maplibregl-ctrl-icon", this._geolocateButton).setAttribute("aria-hidden", "true"), this._geolocateButton.type = "button", this._geolocateButton.disabled = !0);
                                }, this._finishSetupUI = (Qe)=>{
                                    if (this._map) {
                                        if (!1 === Qe) {
                                            rt.w("Geolocation support is not available so the GeolocateControl will be disabled.");
                                            const Qe = this._map._getUIString("GeolocateControl.LocationNotAvailable");
                                            this._geolocateButton.disabled = !0, this._geolocateButton.title = Qe, this._geolocateButton.setAttribute("aria-label", Qe);
                                        } else {
                                            const Qe = this._map._getUIString("GeolocateControl.FindMyLocation");
                                            this._geolocateButton.disabled = !1, this._geolocateButton.title = Qe, this._geolocateButton.setAttribute("aria-label", Qe);
                                        }
                                        this.options.trackUserLocation && (this._geolocateButton.setAttribute("aria-pressed", "false"), this._watchState = "OFF"), this.options.showUserLocation && (this._dotElement = n.create("div", "maplibregl-user-location-dot"), this._userLocationDotMarker = new Za({
                                            element: this._dotElement
                                        }), this._circleElement = n.create("div", "maplibregl-user-location-accuracy-circle"), this._accuracyCircleMarker = new Za({
                                            element: this._circleElement,
                                            pitchAlignment: "map"
                                        }), this.options.trackUserLocation && (this._watchState = "OFF"), this._map.on("zoom", this._onZoom)), this._geolocateButton.addEventListener("click", ()=>this.trigger()), this._setup = !0, this.options.trackUserLocation && this._map.on("movestart", (Qe)=>{
                                            Qe.geolocateSource || "ACTIVE_LOCK" !== this._watchState || Qe.originalEvent && "resize" === Qe.originalEvent.type || (this._watchState = "BACKGROUND", this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active"), this.fire(new rt.l("trackuserlocationend")), this.fire(new rt.l("userlocationlostfocus")));
                                        });
                                    }
                                }, this.options = rt.e({}, Yd, Qe);
                            }
                            onAdd(Qe) {
                                return this._map = Qe, this._container = n.create("div", "maplibregl-ctrl maplibregl-ctrl-group"), this._setupUI(), (function() {
                                    return rt._(this, arguments, void 0, function*(Qe = !1) {
                                        if (void 0 !== Wd && !Qe) return Wd;
                                        if (void 0 === window.navigator.permissions) return Wd = !!window.navigator.geolocation, Wd;
                                        try {
                                            const Qe = yield window.navigator.permissions.query({
                                                name: "geolocation"
                                            });
                                            Wd = "denied" !== Qe.state;
                                        } catch (Qe) {
                                            Wd = !!window.navigator.geolocation;
                                        }
                                        return Wd;
                                    });
                                })().then((Qe)=>this._finishSetupUI(Qe)), this._container;
                            }
                            onRemove() {
                                void 0 !== this._geolocationWatchID && (window.navigator.geolocation.clearWatch(this._geolocationWatchID), this._geolocationWatchID = void 0), this.options.showUserLocation && this._userLocationDotMarker && this._userLocationDotMarker.remove(), this.options.showAccuracyCircle && this._accuracyCircleMarker && this._accuracyCircleMarker.remove(), n.remove(this._container), this._map.off("zoom", this._onZoom), this._map = void 0, Qd = 0, Kd = !1;
                            }
                            _isOutOfMapMaxBounds(Qe) {
                                const rt = this._map.getMaxBounds(), Wn = Qe.coords;
                                return rt && (Wn.longitude < rt.getWest() || Wn.longitude > rt.getEast() || Wn.latitude < rt.getSouth() || Wn.latitude > rt.getNorth());
                            }
                            _setErrorState() {
                                switch(this._watchState){
                                    case "WAITING_ACTIVE":
                                        this._watchState = "ACTIVE_ERROR", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-active-error");
                                        break;
                                    case "ACTIVE_LOCK":
                                        this._watchState = "ACTIVE_ERROR", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-active-error"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-waiting");
                                        break;
                                    case "BACKGROUND":
                                        this._watchState = "BACKGROUND_ERROR", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-background-error"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-waiting");
                                        break;
                                    case "ACTIVE_ERROR":
                                        break;
                                    default:
                                        throw new Error(`Unexpected watchState ${this._watchState}`);
                                }
                            }
                            _updateCircleRadius() {
                                const Qe = this._map.getBounds(), rt = Qe.getSouthEast(), Wn = Qe.getNorthEast(), Co = rt.distanceTo(Wn), Dl = Math.ceil(this._accuracy / (Co / this._map._container.clientHeight) * 2);
                                this._circleElement.style.width = `${Dl}px`, this._circleElement.style.height = `${Dl}px`;
                            }
                            trigger() {
                                if (!this._setup) return rt.w("Geolocate control triggered before added to a map"), !1;
                                if (this.options.trackUserLocation) {
                                    switch(this._watchState){
                                        case "OFF":
                                            this._watchState = "WAITING_ACTIVE", this.fire(new rt.l("trackuserlocationstart"));
                                            break;
                                        case "WAITING_ACTIVE":
                                        case "ACTIVE_LOCK":
                                        case "ACTIVE_ERROR":
                                        case "BACKGROUND_ERROR":
                                            Qd--, Kd = !1, this._watchState = "OFF", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active-error"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background-error"), this.fire(new rt.l("trackuserlocationend"));
                                            break;
                                        case "BACKGROUND":
                                            this._watchState = "ACTIVE_LOCK", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background"), this._lastKnownPosition && this._updateCamera(this._lastKnownPosition), this.fire(new rt.l("trackuserlocationstart")), this.fire(new rt.l("userlocationfocus"));
                                            break;
                                        default:
                                            throw new Error(`Unexpected watchState ${this._watchState}`);
                                    }
                                    switch(this._watchState){
                                        case "WAITING_ACTIVE":
                                            this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-active");
                                            break;
                                        case "ACTIVE_LOCK":
                                            this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-active");
                                            break;
                                        case "OFF":
                                            break;
                                        default:
                                            throw new Error(`Unexpected watchState ${this._watchState}`);
                                    }
                                    if ("OFF" === this._watchState && void 0 !== this._geolocationWatchID) this._clearWatch();
                                    else if (void 0 === this._geolocationWatchID) {
                                        let Qe;
                                        this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.setAttribute("aria-pressed", "true"), Qd++, Qd > 1 ? (Qe = {
                                            maximumAge: 6e5,
                                            timeout: 0
                                        }, Kd = !0) : (Qe = this.options.positionOptions, Kd = !1), this._geolocationWatchID = window.navigator.geolocation.watchPosition(this._onSuccess, this._onError, Qe);
                                    }
                                } else window.navigator.geolocation.getCurrentPosition(this._onSuccess, this._onError, this.options.positionOptions), this._timeoutId = setTimeout(this._finish, 1e4);
                                return !0;
                            }
                            _clearWatch() {
                                window.navigator.geolocation.clearWatch(this._geolocationWatchID), this._geolocationWatchID = void 0, this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.setAttribute("aria-pressed", "false"), this.options.showUserLocation && this._updateMarker(null);
                            }
                        }, Qe.GlobeControl = class {
                            constructor(){
                                this._toggleProjection = ()=>{
                                    var Qe;
                                    const rt = null === (Qe = this._map.getProjection()) || void 0 === Qe ? void 0 : Qe.type;
                                    this._map.setProjection("mercator" !== rt && rt ? {
                                        type: "mercator"
                                    } : {
                                        type: "globe"
                                    }), this._updateGlobeIcon();
                                }, this._updateGlobeIcon = ()=>{
                                    var Qe;
                                    this._globeButton.classList.remove("maplibregl-ctrl-globe"), this._globeButton.classList.remove("maplibregl-ctrl-globe-enabled"), "globe" === (null === (Qe = this._map.getProjection()) || void 0 === Qe ? void 0 : Qe.type) ? (this._globeButton.classList.add("maplibregl-ctrl-globe-enabled"), this._globeButton.title = this._map._getUIString("GlobeControl.Disable")) : (this._globeButton.classList.add("maplibregl-ctrl-globe"), this._globeButton.title = this._map._getUIString("GlobeControl.Enable"));
                                };
                            }
                            onAdd(Qe) {
                                return this._map = Qe, this._container = n.create("div", "maplibregl-ctrl maplibregl-ctrl-group"), this._globeButton = n.create("button", "maplibregl-ctrl-globe", this._container), n.create("span", "maplibregl-ctrl-icon", this._globeButton).setAttribute("aria-hidden", "true"), this._globeButton.type = "button", this._globeButton.addEventListener("click", this._toggleProjection), this._updateGlobeIcon(), this._map.on("styledata", this._updateGlobeIcon), this._container;
                            }
                            onRemove() {
                                n.remove(this._container), this._map.off("styledata", this._updateGlobeIcon), this._globeButton.removeEventListener("click", this._toggleProjection), this._map = void 0;
                            }
                        }, Qe.Hash = wo, Qe.ImageSource = X, Qe.KeyboardHandler = aa, Qe.LngLatBounds = V, Qe.LogoControl = Ta, Qe.Map = class extends ba {
                            constructor(Qe){
                                var Wn, Co;
                                rt.cj.mark(rt.ck.create);
                                const Dl = Object.assign(Object.assign(Object.assign({}, Zd), Qe), {
                                    canvasContextAttributes: Object.assign(Object.assign({}, Zd.canvasContextAttributes), Qe.canvasContextAttributes)
                                });
                                if (null != Dl.minZoom && null != Dl.maxZoom && Dl.minZoom > Dl.maxZoom) throw new Error("maxZoom must be greater than or equal to minZoom");
                                if (null != Dl.minPitch && null != Dl.maxPitch && Dl.minPitch > Dl.maxPitch) throw new Error("maxPitch must be greater than or equal to minPitch");
                                if (null != Dl.minPitch && Dl.minPitch < 0) throw new Error("minPitch must be greater than or equal to 0");
                                if (null != Dl.maxPitch && Dl.maxPitch > 180) throw new Error("maxPitch must be less than or equal to 180");
                                const Ll = new Dt, Rl = new kt;
                                if (void 0 !== Dl.minZoom && Ll.setMinZoom(Dl.minZoom), void 0 !== Dl.maxZoom && Ll.setMaxZoom(Dl.maxZoom), void 0 !== Dl.minPitch && Ll.setMinPitch(Dl.minPitch), void 0 !== Dl.maxPitch && Ll.setMaxPitch(Dl.maxPitch), void 0 !== Dl.renderWorldCopies && Ll.setRenderWorldCopies(Dl.renderWorldCopies), super(Ll, Rl, {
                                    bearingSnap: Dl.bearingSnap
                                }), this._idleTriggered = !1, this._crossFadingFactor = 1, this._renderTaskQueue = new Pa, this._controls = [], this._mapId = rt.a4(), this._contextLost = (Qe)=>{
                                    Qe.preventDefault(), this._frameRequest && (this._frameRequest.abort(), this._frameRequest = null), this.fire(new rt.l("webglcontextlost", {
                                        originalEvent: Qe
                                    }));
                                }, this._contextRestored = (Qe)=>{
                                    this._setupPainter(), this.resize(), this._update(), this.fire(new rt.l("webglcontextrestored", {
                                        originalEvent: Qe
                                    }));
                                }, this._onMapScroll = (Qe)=>{
                                    if (Qe.target === this._container) return this._container.scrollTop = 0, this._container.scrollLeft = 0, !1;
                                }, this._onWindowOnline = ()=>{
                                    this._update();
                                }, this._interactive = Dl.interactive, this._maxTileCacheSize = Dl.maxTileCacheSize, this._maxTileCacheZoomLevels = Dl.maxTileCacheZoomLevels, this._canvasContextAttributes = Object.assign({}, Dl.canvasContextAttributes), this._trackResize = !0 === Dl.trackResize, this._bearingSnap = Dl.bearingSnap, this._centerClampedToGround = Dl.centerClampedToGround, this._refreshExpiredTiles = !0 === Dl.refreshExpiredTiles, this._fadeDuration = Dl.fadeDuration, this._crossSourceCollisions = !0 === Dl.crossSourceCollisions, this._collectResourceTiming = !0 === Dl.collectResourceTiming, this._locale = Object.assign(Object.assign({}, Vd), Dl.locale), this._clickTolerance = Dl.clickTolerance, this._overridePixelRatio = Dl.pixelRatio, this._maxCanvasSize = Dl.maxCanvasSize, this.transformCameraUpdate = Dl.transformCameraUpdate, this.cancelPendingTileRequestsWhileZooming = !0 === Dl.cancelPendingTileRequestsWhileZooming, this._imageQueueHandle = ql.addThrottleControl(()=>this.isMoving()), this._requestManager = new m(Dl.transformRequest), "string" == typeof Dl.container) {
                                    if (this._container = document.getElementById(Dl.container), !this._container) throw new Error(`Container '${Dl.container}' not found.`);
                                } else {
                                    if (!(Dl.container instanceof HTMLElement)) throw new Error("Invalid type: 'container' must be a String or HTMLElement.");
                                    this._container = Dl.container;
                                }
                                if (Dl.maxBounds && this.setMaxBounds(Dl.maxBounds), this._setupContainer(), this._setupPainter(), this.on("move", ()=>this._update(!1)), this.on("moveend", ()=>this._update(!1)), this.on("zoom", ()=>this._update(!0)), this.on("terrain", ()=>{
                                    this.painter.terrainFacilitator.dirty = !0, this._update(!0);
                                }), this.once("idle", ()=>{
                                    this._idleTriggered = !0;
                                }), "undefined" != typeof window) {
                                    addEventListener("online", this._onWindowOnline, !1);
                                    let Qe = !1;
                                    const rt = yo((Qe)=>{
                                        this._trackResize && !this._removed && (this.resize(Qe), this.redraw());
                                    }, 50);
                                    this._resizeObserver = new ResizeObserver((Wn)=>{
                                        Qe ? rt(Wn) : Qe = !0;
                                    }), this._resizeObserver.observe(this._container);
                                }
                                this.handlers = new xa(this, Dl), this._hash = Dl.hash && new wo("string" == typeof Dl.hash && Dl.hash || void 0).addTo(this), this._hash && this._hash._onHashChange() || (this.jumpTo({
                                    center: Dl.center,
                                    elevation: Dl.elevation,
                                    zoom: Dl.zoom,
                                    bearing: Dl.bearing,
                                    pitch: Dl.pitch,
                                    roll: Dl.roll
                                }), Dl.bounds && (this.resize(), this.fitBounds(Dl.bounds, rt.e({}, Dl.fitBoundsOptions, {
                                    duration: 0
                                }))));
                                const Ul = "string" == typeof Dl.style || !("globe" === (null === (Co = null === (Wn = Dl.style) || void 0 === Wn ? void 0 : Wn.projection) || void 0 === Co ? void 0 : Co.type));
                                this.resize(null, Ul), this._localIdeographFontFamily = Dl.localIdeographFontFamily, this._validateStyle = Dl.validateStyle, Dl.style && this.setStyle(Dl.style, {
                                    localIdeographFontFamily: Dl.localIdeographFontFamily
                                }), Dl.attributionControl && this.addControl(new wa("boolean" == typeof Dl.attributionControl ? void 0 : Dl.attributionControl)), Dl.maplibreLogo && this.addControl(new Ta, Dl.logoPosition), this.on("style.load", ()=>{
                                    if (Ul || this._resizeTransform(), this.transform.unmodified) {
                                        const Qe = rt.O(this.style.stylesheet, [
                                            "center",
                                            "zoom",
                                            "bearing",
                                            "pitch",
                                            "roll"
                                        ]);
                                        this.jumpTo(Qe);
                                    }
                                }), this.on("data", (Qe)=>{
                                    this._update("style" === Qe.dataType), this.fire(new rt.l(`${Qe.dataType}data`, Qe));
                                }), this.on("dataloading", (Qe)=>{
                                    this.fire(new rt.l(`${Qe.dataType}dataloading`, Qe));
                                }), this.on("dataabort", (Qe)=>{
                                    this.fire(new rt.l("sourcedataabort", Qe));
                                });
                            }
                            _getMapId() {
                                return this._mapId;
                            }
                            addControl(Qe, Wn) {
                                if (void 0 === Wn && (Wn = Qe.getDefaultPosition ? Qe.getDefaultPosition() : "top-right"), !Qe || !Qe.onAdd) return this.fire(new rt.k(new Error("Invalid argument to map.addControl(). Argument must be a control with onAdd and onRemove methods.")));
                                const Co = Qe.onAdd(this);
                                this._controls.push(Qe);
                                const Dl = this._controlPositions[Wn];
                                return -1 !== Wn.indexOf("bottom") ? Dl.insertBefore(Co, Dl.firstChild) : Dl.appendChild(Co), this;
                            }
                            removeControl(Qe) {
                                if (!Qe || !Qe.onRemove) return this.fire(new rt.k(new Error("Invalid argument to map.removeControl(). Argument must be a control with onAdd and onRemove methods.")));
                                const Wn = this._controls.indexOf(Qe);
                                return Wn > -1 && this._controls.splice(Wn, 1), Qe.onRemove(this), this;
                            }
                            hasControl(Qe) {
                                return this._controls.indexOf(Qe) > -1;
                            }
                            calculateCameraOptionsFromTo(Qe, rt, Wn, Co) {
                                return null == Co && this.terrain && (Co = this.terrain.getElevationForLngLatZoom(Wn, this.transform.tileZoom)), super.calculateCameraOptionsFromTo(Qe, rt, Wn, Co);
                            }
                            resize(Qe, Wn = !0) {
                                const [Co, Dl] = this._containerDimensions(), Ll = this._getClampedPixelRatio(Co, Dl);
                                if (this._resizeCanvas(Co, Dl, Ll), this.painter.resize(Co, Dl, Ll), this.painter.overLimit()) {
                                    const Qe = this.painter.context.gl;
                                    this._maxCanvasSize = [
                                        Qe.drawingBufferWidth,
                                        Qe.drawingBufferHeight
                                    ];
                                    const rt = this._getClampedPixelRatio(Co, Dl);
                                    this._resizeCanvas(Co, Dl, rt), this.painter.resize(Co, Dl, rt);
                                }
                                this._resizeTransform(Wn);
                                const Rl = !this._moving;
                                return Rl && (this.stop(), this.fire(new rt.l("movestart", Qe)).fire(new rt.l("move", Qe))), this.fire(new rt.l("resize", Qe)), Rl && this.fire(new rt.l("moveend", Qe)), this;
                            }
                            _resizeTransform(Qe = !0) {
                                var rt;
                                const [Wn, Co] = this._containerDimensions();
                                this.transform.resize(Wn, Co, Qe), null === (rt = this._requestedCameraState) || void 0 === rt || rt.resize(Wn, Co, Qe);
                            }
                            _getClampedPixelRatio(Qe, rt) {
                                const { 0: Wn, 1: Co } = this._maxCanvasSize, Dl = this.getPixelRatio(), Ll = Qe * Dl, Rl = rt * Dl;
                                return Math.min(Ll > Wn ? Wn / Ll : 1, Rl > Co ? Co / Rl : 1) * Dl;
                            }
                            getPixelRatio() {
                                var Qe;
                                return null !== (Qe = this._overridePixelRatio) && void 0 !== Qe ? Qe : devicePixelRatio;
                            }
                            setPixelRatio(Qe) {
                                this._overridePixelRatio = Qe, this.resize();
                            }
                            getBounds() {
                                return this.transform.getBounds();
                            }
                            getMaxBounds() {
                                return this.transform.getMaxBounds();
                            }
                            setMaxBounds(Qe) {
                                return this.transform.setMaxBounds(V.convert(Qe)), this._update();
                            }
                            setMinZoom(Qe) {
                                if ((Qe = null == Qe ? -2 : Qe) >= -2 && Qe <= this.transform.maxZoom) return this.transform.setMinZoom(Qe), this._update(), this.getZoom() < Qe && this.setZoom(Qe), this;
                                throw new Error("minZoom must be between -2 and the current maxZoom, inclusive");
                            }
                            getMinZoom() {
                                return this.transform.minZoom;
                            }
                            setMaxZoom(Qe) {
                                if ((Qe = null == Qe ? 22 : Qe) >= this.transform.minZoom) return this.transform.setMaxZoom(Qe), this._update(), this.getZoom() > Qe && this.setZoom(Qe), this;
                                throw new Error("maxZoom must be greater than the current minZoom");
                            }
                            getMaxZoom() {
                                return this.transform.maxZoom;
                            }
                            setMinPitch(Qe) {
                                if ((Qe = null == Qe ? 0 : Qe) < 0) throw new Error("minPitch must be greater than or equal to 0");
                                if (Qe >= 0 && Qe <= this.transform.maxPitch) return this.transform.setMinPitch(Qe), this._update(), this.getPitch() < Qe && this.setPitch(Qe), this;
                                throw new Error("minPitch must be between 0 and the current maxPitch, inclusive");
                            }
                            getMinPitch() {
                                return this.transform.minPitch;
                            }
                            setMaxPitch(Qe) {
                                if ((Qe = null == Qe ? 60 : Qe) > 180) throw new Error("maxPitch must be less than or equal to 180");
                                if (Qe >= this.transform.minPitch) return this.transform.setMaxPitch(Qe), this._update(), this.getPitch() > Qe && this.setPitch(Qe), this;
                                throw new Error("maxPitch must be greater than the current minPitch");
                            }
                            getMaxPitch() {
                                return this.transform.maxPitch;
                            }
                            getRenderWorldCopies() {
                                return this.transform.renderWorldCopies;
                            }
                            setRenderWorldCopies(Qe) {
                                return this.transform.setRenderWorldCopies(Qe), this._update();
                            }
                            project(Qe) {
                                return this.transform.locationToScreenPoint(rt.Q.convert(Qe), this.style && this.terrain);
                            }
                            unproject(Qe) {
                                return this.transform.screenPointToLocation(rt.P.convert(Qe), this.terrain);
                            }
                            isMoving() {
                                var Qe;
                                return this._moving || (null === (Qe = this.handlers) || void 0 === Qe ? void 0 : Qe.isMoving());
                            }
                            isZooming() {
                                var Qe;
                                return this._zooming || (null === (Qe = this.handlers) || void 0 === Qe ? void 0 : Qe.isZooming());
                            }
                            isRotating() {
                                var Qe;
                                return this._rotating || (null === (Qe = this.handlers) || void 0 === Qe ? void 0 : Qe.isRotating());
                            }
                            _createDelegatedListener(Qe, rt, Wn) {
                                if ("mouseenter" === Qe || "mouseover" === Qe) {
                                    let Co = !1;
                                    const o = (Dl)=>{
                                        const Ll = rt.filter((Qe)=>this.getLayer(Qe)), Rl = 0 !== Ll.length ? this.queryRenderedFeatures(Dl.point, {
                                            layers: Ll
                                        }) : [];
                                        Rl.length ? Co || (Co = !0, Wn.call(this, new zo(Qe, this, Dl.originalEvent, {
                                            features: Rl
                                        }))) : Co = !1;
                                    };
                                    return {
                                        layers: rt,
                                        listener: Wn,
                                        delegates: {
                                            mousemove: o,
                                            mouseout: ()=>{
                                                Co = !1;
                                            }
                                        }
                                    };
                                }
                                if ("mouseleave" === Qe || "mouseout" === Qe) {
                                    let Co = !1;
                                    const o = (Dl)=>{
                                        const Ll = rt.filter((Qe)=>this.getLayer(Qe));
                                        (0 !== Ll.length ? this.queryRenderedFeatures(Dl.point, {
                                            layers: Ll
                                        }) : []).length ? Co = !0 : Co && (Co = !1, Wn.call(this, new zo(Qe, this, Dl.originalEvent)));
                                    }, a = (rt)=>{
                                        Co && (Co = !1, Wn.call(this, new zo(Qe, this, rt.originalEvent)));
                                    };
                                    return {
                                        layers: rt,
                                        listener: Wn,
                                        delegates: {
                                            mousemove: o,
                                            mouseout: a
                                        }
                                    };
                                }
                                {
                                    const r = (Qe)=>{
                                        const Co = rt.filter((Qe)=>this.getLayer(Qe)), Dl = 0 !== Co.length ? this.queryRenderedFeatures(Qe.point, {
                                            layers: Co
                                        }) : [];
                                        Dl.length && (Qe.features = Dl, Wn.call(this, Qe), delete Qe.features);
                                    };
                                    return {
                                        layers: rt,
                                        listener: Wn,
                                        delegates: {
                                            [Qe]: r
                                        }
                                    };
                                }
                            }
                            _saveDelegatedListener(Qe, rt) {
                                this._delegatedListeners = this._delegatedListeners || {}, this._delegatedListeners[Qe] = this._delegatedListeners[Qe] || [], this._delegatedListeners[Qe].push(rt);
                            }
                            _removeDelegatedListener(Qe, rt, Wn) {
                                if (!this._delegatedListeners || !this._delegatedListeners[Qe]) return;
                                const Co = this._delegatedListeners[Qe];
                                for(let Dl = 0; Dl < Co.length; Dl++){
                                    const Qe = Co[Dl];
                                    if (Qe.listener === Wn && Qe.layers.length === rt.length && Qe.layers.every((Qe)=>rt.includes(Qe))) {
                                        for(const rt in Qe.delegates)this.off(rt, Qe.delegates[rt]);
                                        return void Co.splice(Dl, 1);
                                    }
                                }
                            }
                            on(Qe, rt, Wn) {
                                if (void 0 === Wn) return super.on(Qe, rt);
                                const Co = "string" == typeof rt ? [
                                    rt
                                ] : rt, Dl = this._createDelegatedListener(Qe, Co, Wn);
                                this._saveDelegatedListener(Qe, Dl);
                                for(const Ll in Dl.delegates)this.on(Ll, Dl.delegates[Ll]);
                                return {
                                    unsubscribe: ()=>{
                                        this._removeDelegatedListener(Qe, Co, Wn);
                                    }
                                };
                            }
                            once(Qe, rt, Wn) {
                                if (void 0 === Wn) return super.once(Qe, rt);
                                const Co = "string" == typeof rt ? [
                                    rt
                                ] : rt, Dl = this._createDelegatedListener(Qe, Co, Wn);
                                for(const Ll in Dl.delegates){
                                    const rt = Dl.delegates[Ll];
                                    Dl.delegates[Ll] = (...Dl)=>{
                                        this._removeDelegatedListener(Qe, Co, Wn), rt(...Dl);
                                    };
                                }
                                this._saveDelegatedListener(Qe, Dl);
                                for(const Ll in Dl.delegates)this.once(Ll, Dl.delegates[Ll]);
                                return this;
                            }
                            off(Qe, rt, Wn) {
                                return void 0 === Wn ? super.off(Qe, rt) : (this._removeDelegatedListener(Qe, "string" == typeof rt ? [
                                    rt
                                ] : rt, Wn), this);
                            }
                            queryRenderedFeatures(Qe, Wn) {
                                if (!this.style) return [];
                                let Co;
                                const Dl = Qe instanceof rt.P || Array.isArray(Qe), Ll = Dl ? Qe : [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        this.transform.width,
                                        this.transform.height
                                    ]
                                ];
                                if (Wn = Wn || (Dl ? {} : Qe) || {}, Ll instanceof rt.P || "number" == typeof Ll[0]) Co = [
                                    rt.P.convert(Ll)
                                ];
                                else {
                                    const Qe = rt.P.convert(Ll[0]), Wn = rt.P.convert(Ll[1]);
                                    Co = [
                                        Qe,
                                        new rt.P(Wn.x, Qe.y),
                                        Wn,
                                        new rt.P(Qe.x, Wn.y),
                                        Qe
                                    ];
                                }
                                return this.style.queryRenderedFeatures(Co, Wn, this.transform);
                            }
                            querySourceFeatures(Qe, rt) {
                                return this.style.querySourceFeatures(Qe, rt);
                            }
                            setStyle(Qe, Wn) {
                                return !1 !== (Wn = rt.e({}, {
                                    localIdeographFontFamily: this._localIdeographFontFamily,
                                    validate: this._validateStyle
                                }, Wn)).diff && Wn.localIdeographFontFamily === this._localIdeographFontFamily && this.style && Qe ? (this._diffStyle(Qe, Wn), this) : (this._localIdeographFontFamily = Wn.localIdeographFontFamily, this._updateStyle(Qe, Wn));
                            }
                            setTransformRequest(Qe) {
                                return this._requestManager.setTransformRequest(Qe), this;
                            }
                            _getUIString(Qe) {
                                const rt = this._locale[Qe];
                                if (null == rt) throw new Error(`Missing UI string '${Qe}'`);
                                return rt;
                            }
                            _updateStyle(Qe, rt) {
                                var Wn, Co;
                                if (rt.transformStyle && this.style && !this.style._loaded) return void this.style.once("style.load", ()=>this._updateStyle(Qe, rt));
                                const Dl = this.style && rt.transformStyle ? this.style.serialize() : void 0;
                                return this.style && (this.style.setEventedParent(null), this.style._remove(!Qe)), Qe ? (this.style = new gi(this, rt || {}), this.style.setEventedParent(this, {
                                    style: this.style
                                }), "string" == typeof Qe ? this.style.loadURL(Qe, rt, Dl) : this.style.loadJSON(Qe, rt, Dl), this) : (null === (Co = null === (Wn = this.style) || void 0 === Wn ? void 0 : Wn.projection) || void 0 === Co || Co.destroy(), delete this.style, this);
                            }
                            _lazyInitEmptyStyle() {
                                this.style || (this.style = new gi(this, {}), this.style.setEventedParent(this, {
                                    style: this.style
                                }), this.style.loadEmpty());
                            }
                            _diffStyle(Qe, Wn) {
                                if ("string" == typeof Qe) {
                                    const Co = this._requestManager.transformRequest(Qe, "Style");
                                    rt.j(Co, new AbortController).then((Qe)=>{
                                        this._updateDiff(Qe.data, Wn);
                                    }).catch((Qe)=>{
                                        Qe && this.fire(new rt.k(Qe));
                                    });
                                } else "object" == typeof Qe && this._updateDiff(Qe, Wn);
                            }
                            _updateDiff(Qe, Wn) {
                                try {
                                    this.style.setState(Qe, Wn) && this._update(!0);
                                } catch (r) {
                                    rt.w(`Unable to perform style diff: ${r.message || r.error || r}.  Rebuilding the style from scratch.`), this._updateStyle(Qe, Wn);
                                }
                            }
                            getStyle() {
                                if (this.style) return this.style.serialize();
                            }
                            isStyleLoaded() {
                                return this.style ? this.style.loaded() : rt.w("There is no style added to the map.");
                            }
                            addSource(Qe, rt) {
                                return this._lazyInitEmptyStyle(), this.style.addSource(Qe, rt), this._update(!0);
                            }
                            isSourceLoaded(Qe) {
                                const Wn = this.style && this.style.sourceCaches[Qe];
                                if (void 0 !== Wn) return Wn.loaded();
                                this.fire(new rt.k(new Error(`There is no source with ID '${Qe}'`)));
                            }
                            setTerrain(Qe) {
                                if (this.style._checkLoaded(), this._terrainDataCallback && this.style.off("data", this._terrainDataCallback), Qe) {
                                    const Wn = this.style.sourceCaches[Qe.source];
                                    if (!Wn) throw new Error(`cannot load terrain, because there exists no source with ID: ${Qe.source}`);
                                    null === this.terrain && Wn.reload();
                                    for(const Co in this.style._layers){
                                        const Wn = this.style._layers[Co];
                                        "hillshade" === Wn.type && Wn.source === Qe.source && rt.w("You are using the same source for a hillshade layer and for 3D terrain. Please consider using two separate sources to improve rendering quality.");
                                    }
                                    this.terrain = new Ma(this.painter, Wn, Qe), this.painter.renderToTexture = new Ra(this.painter, this.terrain), this.transform.setMinElevationForCurrentTile(this.terrain.getMinTileElevationForLngLatZoom(this.transform.center, this.transform.tileZoom)), this.transform.setElevation(this.terrain.getElevationForLngLatZoom(this.transform.center, this.transform.tileZoom)), this._terrainDataCallback = (rt)=>{
                                        var Wn;
                                        "style" === rt.dataType ? this.terrain.sourceCache.freeRtt() : "source" === rt.dataType && rt.tile && (rt.sourceId !== Qe.source || this._elevationFreeze || (this.transform.setMinElevationForCurrentTile(this.terrain.getMinTileElevationForLngLatZoom(this.transform.center, this.transform.tileZoom)), this._centerClampedToGround && this.transform.setElevation(this.terrain.getElevationForLngLatZoom(this.transform.center, this.transform.tileZoom))), "image" === (null === (Wn = rt.source) || void 0 === Wn ? void 0 : Wn.type) ? this.terrain.sourceCache.freeRtt() : this.terrain.sourceCache.freeRtt(rt.tile.tileID));
                                    }, this.style.on("data", this._terrainDataCallback);
                                } else this.terrain && this.terrain.sourceCache.destruct(), this.terrain = null, this.painter.renderToTexture && this.painter.renderToTexture.destruct(), this.painter.renderToTexture = null, this.transform.setMinElevationForCurrentTile(0), this._centerClampedToGround && this.transform.setElevation(0);
                                return this.fire(new rt.l("terrain", {
                                    terrain: Qe
                                })), this;
                            }
                            getTerrain() {
                                var Qe, rt;
                                return null !== (rt = null === (Qe = this.terrain) || void 0 === Qe ? void 0 : Qe.options) && void 0 !== rt ? rt : null;
                            }
                            areTilesLoaded() {
                                const Qe = this.style && this.style.sourceCaches;
                                for(const rt in Qe){
                                    const Wn = Qe[rt]._tiles;
                                    for(const Qe in Wn){
                                        const rt = Wn[Qe];
                                        if ("loaded" !== rt.state && "errored" !== rt.state) return !1;
                                    }
                                }
                                return !0;
                            }
                            removeSource(Qe) {
                                return this.style.removeSource(Qe), this._update(!0);
                            }
                            getSource(Qe) {
                                return this.style.getSource(Qe);
                            }
                            addImage(Qe, Wn, Co = {}) {
                                const { pixelRatio: Dl = 1, sdf: Rl = !1, stretchX: Ul, stretchY: Gl, content: Zl, textFitWidth: Hl, textFitHeight: ql } = Co;
                                if (this._lazyInitEmptyStyle(), !(Wn instanceof HTMLImageElement || rt.b(Wn))) {
                                    if (void 0 === Wn.width || void 0 === Wn.height) return this.fire(new rt.k(new Error("Invalid arguments to map.addImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));
                                    {
                                        const { width: Co, height: Ll, data: Ql } = Wn, Kl = Wn;
                                        return this.style.addImage(Qe, {
                                            data: new rt.R({
                                                width: Co,
                                                height: Ll
                                            }, new Uint8Array(Ql)),
                                            pixelRatio: Dl,
                                            stretchX: Ul,
                                            stretchY: Gl,
                                            content: Zl,
                                            textFitWidth: Hl,
                                            textFitHeight: ql,
                                            sdf: Rl,
                                            version: 0,
                                            userImage: Kl
                                        }), Kl.onAdd && Kl.onAdd(this, Qe), this;
                                    }
                                }
                                {
                                    const { width: Co, height: Ql, data: Kl } = Ll.getImageData(Wn);
                                    this.style.addImage(Qe, {
                                        data: new rt.R({
                                            width: Co,
                                            height: Ql
                                        }, Kl),
                                        pixelRatio: Dl,
                                        stretchX: Ul,
                                        stretchY: Gl,
                                        content: Zl,
                                        textFitWidth: Hl,
                                        textFitHeight: ql,
                                        sdf: Rl,
                                        version: 0
                                    });
                                }
                            }
                            updateImage(Qe, Wn) {
                                const Co = this.style.getImage(Qe);
                                if (!Co) return this.fire(new rt.k(new Error("The map has no image with that id. If you are adding a new image use `map.addImage(...)` instead.")));
                                const Dl = Wn instanceof HTMLImageElement || rt.b(Wn) ? Ll.getImageData(Wn) : Wn, { width: Rl, height: Ul, data: Gl } = Dl;
                                if (void 0 === Rl || void 0 === Ul) return this.fire(new rt.k(new Error("Invalid arguments to map.updateImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));
                                if (Rl !== Co.data.width || Ul !== Co.data.height) return this.fire(new rt.k(new Error("The width and height of the updated image must be that same as the previous version of the image")));
                                const Zl = !(Wn instanceof HTMLImageElement || rt.b(Wn));
                                return Co.data.replace(Gl, Zl), this.style.updateImage(Qe, Co), this;
                            }
                            getImage(Qe) {
                                return this.style.getImage(Qe);
                            }
                            hasImage(Qe) {
                                return Qe ? !!this.style.getImage(Qe) : (this.fire(new rt.k(new Error("Missing required image id"))), !1);
                            }
                            removeImage(Qe) {
                                this.style.removeImage(Qe);
                            }
                            loadImage(Qe) {
                                return ql.getImage(this._requestManager.transformRequest(Qe, "Image"), new AbortController);
                            }
                            listImages() {
                                return this.style.listImages();
                            }
                            addLayer(Qe, rt) {
                                return this._lazyInitEmptyStyle(), this.style.addLayer(Qe, rt), this._update(!0);
                            }
                            moveLayer(Qe, rt) {
                                return this.style.moveLayer(Qe, rt), this._update(!0);
                            }
                            removeLayer(Qe) {
                                return this.style.removeLayer(Qe), this._update(!0);
                            }
                            getLayer(Qe) {
                                return this.style.getLayer(Qe);
                            }
                            getLayersOrder() {
                                return this.style.getLayersOrder();
                            }
                            setLayerZoomRange(Qe, rt, Wn) {
                                return this.style.setLayerZoomRange(Qe, rt, Wn), this._update(!0);
                            }
                            setFilter(Qe, rt, Wn = {}) {
                                return this.style.setFilter(Qe, rt, Wn), this._update(!0);
                            }
                            getFilter(Qe) {
                                return this.style.getFilter(Qe);
                            }
                            setPaintProperty(Qe, rt, Wn, Co = {}) {
                                return this.style.setPaintProperty(Qe, rt, Wn, Co), this._update(!0);
                            }
                            getPaintProperty(Qe, rt) {
                                return this.style.getPaintProperty(Qe, rt);
                            }
                            setLayoutProperty(Qe, rt, Wn, Co = {}) {
                                return this.style.setLayoutProperty(Qe, rt, Wn, Co), this._update(!0);
                            }
                            getLayoutProperty(Qe, rt) {
                                return this.style.getLayoutProperty(Qe, rt);
                            }
                            setGlyphs(Qe, rt = {}) {
                                return this._lazyInitEmptyStyle(), this.style.setGlyphs(Qe, rt), this._update(!0);
                            }
                            getGlyphs() {
                                return this.style.getGlyphsUrl();
                            }
                            addSprite(Qe, rt, Wn = {}) {
                                return this._lazyInitEmptyStyle(), this.style.addSprite(Qe, rt, Wn, (Qe)=>{
                                    Qe || this._update(!0);
                                }), this;
                            }
                            removeSprite(Qe) {
                                return this._lazyInitEmptyStyle(), this.style.removeSprite(Qe), this._update(!0);
                            }
                            getSprite() {
                                return this.style.getSprite();
                            }
                            setSprite(Qe, rt = {}) {
                                return this._lazyInitEmptyStyle(), this.style.setSprite(Qe, rt, (Qe)=>{
                                    Qe || this._update(!0);
                                }), this;
                            }
                            setLight(Qe, rt = {}) {
                                return this._lazyInitEmptyStyle(), this.style.setLight(Qe, rt), this._update(!0);
                            }
                            getLight() {
                                return this.style.getLight();
                            }
                            setSky(Qe, rt = {}) {
                                return this._lazyInitEmptyStyle(), this.style.setSky(Qe, rt), this._update(!0);
                            }
                            getSky() {
                                return this.style.getSky();
                            }
                            setFeatureState(Qe, rt) {
                                return this.style.setFeatureState(Qe, rt), this._update();
                            }
                            removeFeatureState(Qe, rt) {
                                return this.style.removeFeatureState(Qe, rt), this._update();
                            }
                            getFeatureState(Qe) {
                                return this.style.getFeatureState(Qe);
                            }
                            getContainer() {
                                return this._container;
                            }
                            getCanvasContainer() {
                                return this._canvasContainer;
                            }
                            getCanvas() {
                                return this._canvas;
                            }
                            _containerDimensions() {
                                let Qe = 0, rt = 0;
                                return this._container && (Qe = this._container.clientWidth || 400, rt = this._container.clientHeight || 300), [
                                    Qe,
                                    rt
                                ];
                            }
                            _setupContainer() {
                                const Qe = this._container;
                                Qe.classList.add("maplibregl-map");
                                const rt = this._canvasContainer = n.create("div", "maplibregl-canvas-container", Qe);
                                this._interactive && rt.classList.add("maplibregl-interactive"), this._canvas = n.create("canvas", "maplibregl-canvas", rt), this._canvas.addEventListener("webglcontextlost", this._contextLost, !1), this._canvas.addEventListener("webglcontextrestored", this._contextRestored, !1), this._canvas.setAttribute("tabindex", this._interactive ? "0" : "-1"), this._canvas.setAttribute("aria-label", this._getUIString("Map.Title")), this._canvas.setAttribute("role", "region");
                                const Wn = this._containerDimensions(), Co = this._getClampedPixelRatio(Wn[0], Wn[1]);
                                this._resizeCanvas(Wn[0], Wn[1], Co);
                                const Dl = this._controlContainer = n.create("div", "maplibregl-control-container", Qe), Ll = this._controlPositions = {};
                                [
                                    "top-left",
                                    "top-right",
                                    "bottom-left",
                                    "bottom-right"
                                ].forEach((Qe)=>{
                                    Ll[Qe] = n.create("div", `maplibregl-ctrl-${Qe} `, Dl);
                                }), this._container.addEventListener("scroll", this._onMapScroll, !1);
                            }
                            _resizeCanvas(Qe, rt, Wn) {
                                this._canvas.width = Math.floor(Wn * Qe), this._canvas.height = Math.floor(Wn * rt), this._canvas.style.width = `${Qe}px`, this._canvas.style.height = `${rt}px`;
                            }
                            _setupPainter() {
                                const Qe = Object.assign(Object.assign({}, this._canvasContextAttributes), {
                                    alpha: !0,
                                    depth: !0,
                                    stencil: !0,
                                    premultipliedAlpha: !0
                                });
                                let rt = null;
                                this._canvas.addEventListener("webglcontextcreationerror", (Wn)=>{
                                    rt = {
                                        requestedAttributes: Qe
                                    }, Wn && (rt.statusMessage = Wn.statusMessage, rt.type = Wn.type);
                                }, {
                                    once: !0
                                });
                                let Wn = null;
                                if (Wn = this._canvasContextAttributes.contextType ? this._canvas.getContext(this._canvasContextAttributes.contextType, Qe) : this._canvas.getContext("webgl2", Qe) || this._canvas.getContext("webgl", Qe), !Wn) {
                                    const Qe = "Failed to initialize WebGL";
                                    throw rt ? (rt.message = Qe, new Error(JSON.stringify(rt))) : new Error(Qe);
                                }
                                this.painter = new bo(Wn, this.transform), Rl.testSupport(Wn);
                            }
                            migrateProjection(Qe, Wn) {
                                super.migrateProjection(Qe, Wn), this.painter.transform = Qe, this.fire(new rt.l("projectiontransition", {
                                    newProjection: this.style.projection.name
                                }));
                            }
                            loaded() {
                                return !this._styleDirty && !this._sourcesDirty && !!this.style && this.style.loaded();
                            }
                            _update(Qe) {
                                return this.style && this.style._loaded ? (this._styleDirty = this._styleDirty || Qe, this._sourcesDirty = !0, this.triggerRepaint(), this) : this;
                            }
                            _requestRenderFrame(Qe) {
                                return this._update(), this._renderTaskQueue.add(Qe);
                            }
                            _cancelRenderFrame(Qe) {
                                this._renderTaskQueue.remove(Qe);
                            }
                            _render(Qe) {
                                var Wn, Co, Dl, Rl, Ul;
                                const Gl = this._idleTriggered ? this._fadeDuration : 0, Zl = (null === (Wn = this.style.projection) || void 0 === Wn ? void 0 : Wn.transitionState) > 0;
                                if (this.painter.context.setDirty(), this.painter.setBaseState(), this._renderTaskQueue.run(Qe), this._removed) return;
                                let Hl = !1;
                                if (this.style && this._styleDirty) {
                                    this._styleDirty = !1;
                                    const Qe = this.transform.zoom, Wn = Ll.now();
                                    this.style.zoomHistory.update(Qe, Wn);
                                    const Co = new rt.C(Qe, {
                                        now: Wn,
                                        fadeDuration: Gl,
                                        zoomHistory: this.style.zoomHistory,
                                        transition: this.style.getTransition()
                                    }), Dl = Co.crossFadingFactor();
                                    1 === Dl && Dl === this._crossFadingFactor || (Hl = !0, this._crossFadingFactor = Dl), this.style.update(Co);
                                }
                                const ql = (null === (Co = this.style.projection) || void 0 === Co ? void 0 : Co.transitionState) > 0 !== Zl;
                                null === (Dl = this.style.projection) || void 0 === Dl || Dl.setErrorQueryLatitudeDegrees(this.transform.center.lat), this.transform.setTransitionState(null === (Rl = this.style.projection) || void 0 === Rl ? void 0 : Rl.transitionState, null === (Ul = this.style.projection) || void 0 === Ul ? void 0 : Ul.latitudeErrorCorrectionRadians), this.style && (this._sourcesDirty || ql) && (this._sourcesDirty = !1, this.style._updateSources(this.transform)), this.terrain ? (this.terrain.sourceCache.update(this.transform, this.terrain), this.transform.setMinElevationForCurrentTile(this.terrain.getMinTileElevationForLngLatZoom(this.transform.center, this.transform.tileZoom)), !this._elevationFreeze && this._centerClampedToGround && this.transform.setElevation(this.terrain.getElevationForLngLatZoom(this.transform.center, this.transform.tileZoom))) : (this.transform.setMinElevationForCurrentTile(0), this._centerClampedToGround && this.transform.setElevation(0)), this._placementDirty = this.style && this.style._updatePlacement(this.transform, this.showCollisionBoxes, Gl, this._crossSourceCollisions, ql), this.painter.render(this.style, {
                                    showTileBoundaries: this.showTileBoundaries,
                                    showOverdrawInspector: this._showOverdrawInspector,
                                    rotating: this.isRotating(),
                                    zooming: this.isZooming(),
                                    moving: this.isMoving(),
                                    fadeDuration: Gl,
                                    showPadding: this.showPadding
                                }), this.fire(new rt.l("render")), this.loaded() && !this._loaded && (this._loaded = !0, rt.cj.mark(rt.ck.load), this.fire(new rt.l("load"))), this.style && (this.style.hasTransitions() || Hl) && (this._styleDirty = !0), this.style && !this._placementDirty && this.style._releaseSymbolFadeTiles();
                                const Ql = this._sourcesDirty || this._styleDirty || this._placementDirty;
                                return Ql || this._repaint ? this.triggerRepaint() : !this.isMoving() && this.loaded() && this.fire(new rt.l("idle")), !this._loaded || this._fullyLoaded || Ql || (this._fullyLoaded = !0, rt.cj.mark(rt.ck.fullLoad)), this;
                            }
                            redraw() {
                                return this.style && (this._frameRequest && (this._frameRequest.abort(), this._frameRequest = null), this._render(0)), this;
                            }
                            remove() {
                                var Qe;
                                this._hash && this._hash.remove();
                                for (const rt of this._controls)rt.onRemove(this);
                                this._controls = [], this._frameRequest && (this._frameRequest.abort(), this._frameRequest = null), this._renderTaskQueue.clear(), this.painter.destroy(), this.handlers.destroy(), delete this.handlers, this.setStyle(null), "undefined" != typeof window && removeEventListener("online", this._onWindowOnline, !1), ql.removeThrottleControl(this._imageQueueHandle), null === (Qe = this._resizeObserver) || void 0 === Qe || Qe.disconnect();
                                const Wn = this.painter.context.gl.getExtension("WEBGL_lose_context");
                                (null == Wn ? void 0 : Wn.loseContext) && Wn.loseContext(), this._canvas.removeEventListener("webglcontextrestored", this._contextRestored, !1), this._canvas.removeEventListener("webglcontextlost", this._contextLost, !1), n.remove(this._canvasContainer), n.remove(this._controlContainer), this._container.removeEventListener("scroll", this._onMapScroll, !1), this._container.classList.remove("maplibregl-map"), rt.cj.clearMetrics(), this._removed = !0, this.fire(new rt.l("remove"));
                            }
                            triggerRepaint() {
                                this.style && !this._frameRequest && (this._frameRequest = new AbortController, Ll.frame(this._frameRequest, (Qe)=>{
                                    rt.cj.frame(Qe), this._frameRequest = null;
                                    try {
                                        this._render(Qe);
                                    } catch (Qe) {
                                        if (!rt.cl(Qe) && !function(Qe) {
                                            return Qe.message === xd;
                                        }(Qe)) throw Qe;
                                    }
                                }, ()=>{}));
                            }
                            get showTileBoundaries() {
                                return !!this._showTileBoundaries;
                            }
                            set showTileBoundaries(Qe) {
                                this._showTileBoundaries !== Qe && (this._showTileBoundaries = Qe, this._update());
                            }
                            get showPadding() {
                                return !!this._showPadding;
                            }
                            set showPadding(Qe) {
                                this._showPadding !== Qe && (this._showPadding = Qe, this._update());
                            }
                            get showCollisionBoxes() {
                                return !!this._showCollisionBoxes;
                            }
                            set showCollisionBoxes(Qe) {
                                this._showCollisionBoxes !== Qe && (this._showCollisionBoxes = Qe, Qe ? this.style._generateCollisionBoxes() : this._update());
                            }
                            get showOverdrawInspector() {
                                return !!this._showOverdrawInspector;
                            }
                            set showOverdrawInspector(Qe) {
                                this._showOverdrawInspector !== Qe && (this._showOverdrawInspector = Qe, this._update());
                            }
                            get repaint() {
                                return !!this._repaint;
                            }
                            set repaint(Qe) {
                                this._repaint !== Qe && (this._repaint = Qe, this.triggerRepaint());
                            }
                            get vertices() {
                                return !!this._vertices;
                            }
                            set vertices(Qe) {
                                this._vertices = Qe, this._update();
                            }
                            get version() {
                                return Gd;
                            }
                            getCameraTargetElevation() {
                                return this.transform.elevation;
                            }
                            getProjection() {
                                return this.style.getProjection();
                            }
                            setProjection(Qe) {
                                return this._lazyInitEmptyStyle(), this.style.setProjection(Qe), this._update(!0);
                            }
                        }, Qe.MapMouseEvent = zo, Qe.MapTouchEvent = Ao, Qe.MapWheelEvent = Lo, Qe.Marker = Za, Qe.NavigationControl = class {
                            constructor(Qe){
                                this._updateZoomButtons = ()=>{
                                    const Qe = this._map.getZoom(), rt = Qe === this._map.getMaxZoom(), Wn = Qe === this._map.getMinZoom();
                                    this._zoomInButton.disabled = rt, this._zoomOutButton.disabled = Wn, this._zoomInButton.setAttribute("aria-disabled", rt.toString()), this._zoomOutButton.setAttribute("aria-disabled", Wn.toString());
                                }, this._rotateCompassArrow = ()=>{
                                    this._compassIcon.style.transform = this.options.visualizePitch && this.options.visualizeRoll ? `scale(${1 / Math.pow(Math.cos(this._map.transform.pitchInRadians), .5)}) rotateZ(${-this._map.transform.roll}deg) rotateX(${this._map.transform.pitch}deg) rotateZ(${-this._map.transform.bearing}deg)` : this.options.visualizePitch ? `scale(${1 / Math.pow(Math.cos(this._map.transform.pitchInRadians), .5)}) rotateX(${this._map.transform.pitch}deg) rotateZ(${-this._map.transform.bearing}deg)` : this.options.visualizeRoll ? `rotate(${-this._map.transform.bearing - this._map.transform.roll}deg)` : `rotate(${-this._map.transform.bearing}deg)`;
                                }, this._setButtonTitle = (Qe, rt)=>{
                                    const Wn = this._map._getUIString(`NavigationControl.${rt}`);
                                    Qe.title = Wn, Qe.setAttribute("aria-label", Wn);
                                }, this.options = rt.e({}, Hd, Qe), this._container = n.create("div", "maplibregl-ctrl maplibregl-ctrl-group"), this._container.addEventListener("contextmenu", (Qe)=>Qe.preventDefault()), this.options.showZoom && (this._zoomInButton = this._createButton("maplibregl-ctrl-zoom-in", (Qe)=>this._map.zoomIn({}, {
                                        originalEvent: Qe
                                    })), n.create("span", "maplibregl-ctrl-icon", this._zoomInButton).setAttribute("aria-hidden", "true"), this._zoomOutButton = this._createButton("maplibregl-ctrl-zoom-out", (Qe)=>this._map.zoomOut({}, {
                                        originalEvent: Qe
                                    })), n.create("span", "maplibregl-ctrl-icon", this._zoomOutButton).setAttribute("aria-hidden", "true")), this.options.showCompass && (this._compass = this._createButton("maplibregl-ctrl-compass", (Qe)=>{
                                    this.options.visualizePitch ? this._map.resetNorthPitch({}, {
                                        originalEvent: Qe
                                    }) : this._map.resetNorth({}, {
                                        originalEvent: Qe
                                    });
                                }), this._compassIcon = n.create("span", "maplibregl-ctrl-icon", this._compass), this._compassIcon.setAttribute("aria-hidden", "true"));
                            }
                            onAdd(Qe) {
                                return this._map = Qe, this.options.showZoom && (this._setButtonTitle(this._zoomInButton, "ZoomIn"), this._setButtonTitle(this._zoomOutButton, "ZoomOut"), this._map.on("zoom", this._updateZoomButtons), this._updateZoomButtons()), this.options.showCompass && (this._setButtonTitle(this._compass, "ResetBearing"), this.options.visualizePitch && this._map.on("pitch", this._rotateCompassArrow), this.options.visualizeRoll && this._map.on("roll", this._rotateCompassArrow), this._map.on("rotate", this._rotateCompassArrow), this._rotateCompassArrow(), this._handler = new ka(this._map, this._compass, this.options.visualizePitch)), this._container;
                            }
                            onRemove() {
                                n.remove(this._container), this.options.showZoom && this._map.off("zoom", this._updateZoomButtons), this.options.showCompass && (this.options.visualizePitch && this._map.off("pitch", this._rotateCompassArrow), this.options.visualizeRoll && this._map.off("roll", this._rotateCompassArrow), this._map.off("rotate", this._rotateCompassArrow), this._handler.off(), delete this._handler), delete this._map;
                            }
                            _createButton(Qe, rt) {
                                const Wn = n.create("button", Qe, this._container);
                                return Wn.type = "button", Wn.addEventListener("click", rt), Wn;
                            }
                        }, Qe.Popup = class extends rt.E {
                            constructor(Qe){
                                super(), this._updateOpacity = ()=>{
                                    void 0 !== this.options.locationOccludedOpacity && (this._container.style.opacity = this._map.transform.isLocationOccluded(this.getLngLat()) ? `${this.options.locationOccludedOpacity}` : void 0);
                                }, this.remove = ()=>(this._content && n.remove(this._content), this._container && (n.remove(this._container), delete this._container), this._closeButton && this._closeButton.removeEventListener("click", this._onClose), this._map && (this._map.off("move", this._update), this._map.off("move", this._onClose), this._map.off("click", this._onClose), this._map.off("remove", this.remove), this._map.off("mousemove", this._onMouseMove), this._map.off("mouseup", this._onMouseUp), this._map.off("drag", this._onDrag), this._map._canvasContainer.classList.remove("maplibregl-track-pointer"), delete this._map, this.fire(new rt.l("close"))), this), this._onMouseUp = (Qe)=>{
                                    this._update(Qe.point);
                                }, this._onMouseMove = (Qe)=>{
                                    this._update(Qe.point);
                                }, this._onDrag = (Qe)=>{
                                    this._update(Qe.point);
                                }, this._update = (Qe)=>{
                                    var rt;
                                    if (!this._map || !this._lngLat && !this._trackPointer || !this._content) return;
                                    if (!this._container) {
                                        if (this._container = n.create("div", "maplibregl-popup", this._map.getContainer()), this._tip = n.create("div", "maplibregl-popup-tip", this._container), this._container.appendChild(this._content), this.options.className) for (const Qe of this.options.className.split(" "))this._container.classList.add(Qe);
                                        this._closeButton && this._closeButton.setAttribute("aria-label", this._map._getUIString("Popup.Close")), this._trackPointer && this._container.classList.add("maplibregl-popup-track-pointer");
                                    }
                                    if (this.options.maxWidth && this._container.style.maxWidth !== this.options.maxWidth && (this._container.style.maxWidth = this.options.maxWidth), this._lngLat = this._map.transform.renderWorldCopies && !this._trackPointer ? Ba(this._lngLat, this._flatPos, this._map.transform) : null === (rt = this._lngLat) || void 0 === rt ? void 0 : rt.wrap(), this._trackPointer && !Qe) return;
                                    const Wn = this._flatPos = this._pos = this._trackPointer && Qe ? Qe : this._map.project(this._lngLat);
                                    this._map.terrain && (this._flatPos = this._trackPointer && Qe ? Qe : this._map.transform.locationToScreenPoint(this._lngLat));
                                    let Co = this.options.anchor;
                                    const Dl = Ka(this.options.offset);
                                    if (!Co) {
                                        const Qe = this._container.offsetWidth, rt = this._container.offsetHeight;
                                        let Ll;
                                        Ll = Wn.y + Dl.bottom.y < rt ? [
                                            "top"
                                        ] : Wn.y > this._map.transform.height - rt ? [
                                            "bottom"
                                        ] : [], Wn.x < Qe / 2 ? Ll.push("left") : Wn.x > this._map.transform.width - Qe / 2 && Ll.push("right"), Co = 0 === Ll.length ? "bottom" : Ll.join("-");
                                    }
                                    let Ll = Wn.add(Dl[Co]);
                                    this.options.subpixelPositioning || (Ll = Ll.round()), n.setTransform(this._container, `${qd[Co]} translate(${Ll.x}px,${Ll.y}px)`), ja(this._container, Co, "popup"), this._updateOpacity();
                                }, this._onClose = ()=>{
                                    this.remove();
                                }, this.options = rt.e(Object.create(Jd), Qe);
                            }
                            addTo(Qe) {
                                return this._map && this.remove(), this._map = Qe, this.options.closeOnClick && this._map.on("click", this._onClose), this.options.closeOnMove && this._map.on("move", this._onClose), this._map.on("remove", this.remove), this._update(), this._focusFirstElement(), this._trackPointer ? (this._map.on("mousemove", this._onMouseMove), this._map.on("mouseup", this._onMouseUp), this._container && this._container.classList.add("maplibregl-popup-track-pointer"), this._map._canvasContainer.classList.add("maplibregl-track-pointer")) : this._map.on("move", this._update), this.fire(new rt.l("open")), this;
                            }
                            isOpen() {
                                return !!this._map;
                            }
                            getLngLat() {
                                return this._lngLat;
                            }
                            setLngLat(Qe) {
                                return this._lngLat = rt.Q.convert(Qe), this._pos = null, this._flatPos = null, this._trackPointer = !1, this._update(), this._map && (this._map.on("move", this._update), this._map.off("mousemove", this._onMouseMove), this._container && this._container.classList.remove("maplibregl-popup-track-pointer"), this._map._canvasContainer.classList.remove("maplibregl-track-pointer")), this;
                            }
                            trackPointer() {
                                return this._trackPointer = !0, this._pos = null, this._flatPos = null, this._update(), this._map && (this._map.off("move", this._update), this._map.on("mousemove", this._onMouseMove), this._map.on("drag", this._onDrag), this._container && this._container.classList.add("maplibregl-popup-track-pointer"), this._map._canvasContainer.classList.add("maplibregl-track-pointer")), this;
                            }
                            getElement() {
                                return this._container;
                            }
                            setText(Qe) {
                                return this.setDOMContent(document.createTextNode(Qe));
                            }
                            setHTML(Qe) {
                                const rt = document.createDocumentFragment(), Wn = document.createElement("body");
                                let Co;
                                for(Wn.innerHTML = Qe; Co = Wn.firstChild, Co;)rt.appendChild(Co);
                                return this.setDOMContent(rt);
                            }
                            getMaxWidth() {
                                var Qe;
                                return null === (Qe = this._container) || void 0 === Qe ? void 0 : Qe.style.maxWidth;
                            }
                            setMaxWidth(Qe) {
                                return this.options.maxWidth = Qe, this._update(), this;
                            }
                            setDOMContent(Qe) {
                                if (this._content) for(; this._content.hasChildNodes();)this._content.firstChild && this._content.removeChild(this._content.firstChild);
                                else this._content = n.create("div", "maplibregl-popup-content", this._container);
                                return this._content.appendChild(Qe), this._createCloseButton(), this._update(), this._focusFirstElement(), this;
                            }
                            addClassName(Qe) {
                                return this._container && this._container.classList.add(Qe), this;
                            }
                            removeClassName(Qe) {
                                return this._container && this._container.classList.remove(Qe), this;
                            }
                            setOffset(Qe) {
                                return this.options.offset = Qe, this._update(), this;
                            }
                            toggleClassName(Qe) {
                                if (this._container) return this._container.classList.toggle(Qe);
                            }
                            setSubpixelPositioning(Qe) {
                                this.options.subpixelPositioning = Qe;
                            }
                            _createCloseButton() {
                                this.options.closeButton && (this._closeButton = n.create("button", "maplibregl-popup-close-button", this._content), this._closeButton.type = "button", this._closeButton.innerHTML = "&#215;", this._closeButton.addEventListener("click", this._onClose));
                            }
                            _focusFirstElement() {
                                if (!this.options.focusAfterOpen || !this._container) return;
                                const Qe = this._container.querySelector($d);
                                Qe && Qe.focus();
                            }
                        }, Qe.RasterDEMTileSource = H, Qe.RasterTileSource = $, Qe.ScaleControl = class {
                            constructor(Qe){
                                this._onMove = ()=>{
                                    qa(this._map, this._container, this.options);
                                }, this.setUnit = (Qe)=>{
                                    this.options.unit = Qe, qa(this._map, this._container, this.options);
                                }, this.options = Object.assign(Object.assign({}, Xd), Qe);
                            }
                            getDefaultPosition() {
                                return "bottom-left";
                            }
                            onAdd(Qe) {
                                return this._map = Qe, this._container = n.create("div", "maplibregl-ctrl maplibregl-ctrl-scale", Qe.getContainer()), this._map.on("move", this._onMove), this._onMove(), this._container;
                            }
                            onRemove() {
                                n.remove(this._container), this._map.off("move", this._onMove), this._map = void 0;
                            }
                        }, Qe.ScrollZoomHandler = la, Qe.Style = gi, Qe.TerrainControl = class {
                            constructor(Qe){
                                this._toggleTerrain = ()=>{
                                    this._map.getTerrain() ? this._map.setTerrain(null) : this._map.setTerrain(this.options), this._updateTerrainIcon();
                                }, this._updateTerrainIcon = ()=>{
                                    this._terrainButton.classList.remove("maplibregl-ctrl-terrain"), this._terrainButton.classList.remove("maplibregl-ctrl-terrain-enabled"), this._map.terrain ? (this._terrainButton.classList.add("maplibregl-ctrl-terrain-enabled"), this._terrainButton.title = this._map._getUIString("TerrainControl.Disable")) : (this._terrainButton.classList.add("maplibregl-ctrl-terrain"), this._terrainButton.title = this._map._getUIString("TerrainControl.Enable"));
                                }, this.options = Qe;
                            }
                            onAdd(Qe) {
                                return this._map = Qe, this._container = n.create("div", "maplibregl-ctrl maplibregl-ctrl-group"), this._terrainButton = n.create("button", "maplibregl-ctrl-terrain", this._container), n.create("span", "maplibregl-ctrl-icon", this._terrainButton).setAttribute("aria-hidden", "true"), this._terrainButton.type = "button", this._terrainButton.addEventListener("click", this._toggleTerrain), this._updateTerrainIcon(), this._map.on("terrain", this._updateTerrainIcon), this._container;
                            }
                            onRemove() {
                                n.remove(this._container), this._map.off("terrain", this._updateTerrainIcon), this._map = void 0;
                            }
                        }, Qe.TwoFingersTouchPitchHandler = ra, Qe.TwoFingersTouchRotateHandler = ta, Qe.TwoFingersTouchZoomHandler = Jo, Qe.TwoFingersTouchZoomRotateHandler = pa, Qe.VectorTileSource = W, Qe.VideoSource = Q, Qe.addSourceType = (Qe, Wn)=>rt._(void 0, void 0, void 0, function*() {
                                if (ee(Qe)) throw new Error(`A source type called "${Qe}" already exists.`);
                                ((Qe, rt)=>{
                                    fu[Qe] = rt;
                                })(Qe, Wn);
                            }), Qe.clearPrewarmedResources = function() {
                            const Qe = lu;
                            Qe && (Qe.isPreloaded() && 1 === Qe.numActive() ? (Qe.release(Tc), lu = null) : console.warn("Could not clear WebWorkers since there are active Map instances that still reference it. The pre-warmed WebWorker pool can only be cleared when all map instances have been removed with map.remove()"));
                        }, Qe.createTileMesh = Wt, Qe.getMaxParallelImageRequests = function() {
                            return rt.a.MAX_PARALLEL_IMAGE_REQUESTS;
                        }, Qe.getRTLTextPluginStatus = function() {
                            return oe().getRTLTextPluginStatus();
                        }, Qe.getVersion = function() {
                            return up;
                        }, Qe.getWorkerCount = function() {
                            return z.workerCount;
                        }, Qe.getWorkerUrl = function() {
                            return rt.a.WORKER_URL;
                        }, Qe.importScriptInWorkers = function(Qe) {
                            return O().broadcast("IS", Qe);
                        }, Qe.prewarm = function() {
                            F().acquire(Tc);
                        }, Qe.setMaxParallelImageRequests = function(Qe) {
                            rt.a.MAX_PARALLEL_IMAGE_REQUESTS = Qe;
                        }, Qe.setRTLTextPlugin = function(Qe, rt) {
                            return oe().setRTLTextPlugin(Qe, rt);
                        }, Qe.setWorkerCount = function(Qe) {
                            z.workerCount = Qe;
                        }, Qe.setWorkerUrl = function(Qe) {
                            rt.a.WORKER_URL = Qe;
                        };
                    }), Qe;
                }();
            },
            3710: (Qe, rt, Wn)=>{
                "use strict";
                /*!
 * Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2024 Fonticons, Inc.
 */ function _defineProperty(Qe, rt, Wn) {
                    return (rt = function(Qe) {
                        var rt = function(Qe, rt) {
                            if ("object" != typeof Qe || !Qe) return Qe;
                            var Wn = Qe[Symbol.toPrimitive];
                            if (void 0 !== Wn) {
                                var Co = Wn.call(Qe, rt || "default");
                                if ("object" != typeof Co) return Co;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === rt ? String : Number)(Qe);
                        }(Qe, "string");
                        return "symbol" == typeof rt ? rt : rt + "";
                    }(rt)) in Qe ? Object.defineProperty(Qe, rt, {
                        value: Wn,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : Qe[rt] = Wn, Qe;
                }
                function ownKeys(Qe, rt) {
                    var Wn = Object.keys(Qe);
                    if (Object.getOwnPropertySymbols) {
                        var Co = Object.getOwnPropertySymbols(Qe);
                        rt && (Co = Co.filter(function(rt) {
                            return Object.getOwnPropertyDescriptor(Qe, rt).enumerable;
                        })), Wn.push.apply(Wn, Co);
                    }
                    return Wn;
                }
                function _objectSpread2(Qe) {
                    for(var rt = 1; rt < arguments.length; rt++){
                        var Wn = null != arguments[rt] ? arguments[rt] : {};
                        rt % 2 ? ownKeys(Object(Wn), !0).forEach(function(rt) {
                            _defineProperty(Qe, rt, Wn[rt]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Qe, Object.getOwnPropertyDescriptors(Wn)) : ownKeys(Object(Wn)).forEach(function(rt) {
                            Object.defineProperty(Qe, rt, Object.getOwnPropertyDescriptor(Wn, rt));
                        });
                    }
                    return Qe;
                }
                Wn.d(rt, {
                    Kk: ()=>Yp
                });
                const noop = ()=>{};
                let Co = {}, Dl = {}, Ll = null, Rl = {
                    mark: noop,
                    measure: noop
                };
                try {
                    "undefined" !== typeof window && (Co = window), "undefined" !== typeof document && (Dl = document), "undefined" !== typeof MutationObserver && (Ll = MutationObserver), "undefined" !== typeof performance && (Rl = performance);
                } catch (Qp) {}
                const { userAgent: Ul = "" } = Co.navigator || {}, Gl = Co, Zl = Dl, Hl = Ll, ql = Rl, Ql = (Gl.document, !!Zl.documentElement && !!Zl.head && "function" === typeof Zl.addEventListener && "function" === typeof Zl.createElement), Kl = ~Ul.indexOf("MSIE") || ~Ul.indexOf("Trident/");
                var $l = {
                    classic: {
                        fa: "solid",
                        fas: "solid",
                        "fa-solid": "solid",
                        far: "regular",
                        "fa-regular": "regular",
                        fal: "light",
                        "fa-light": "light",
                        fat: "thin",
                        "fa-thin": "thin",
                        fab: "brands",
                        "fa-brands": "brands"
                    },
                    duotone: {
                        fa: "solid",
                        fad: "solid",
                        "fa-solid": "solid",
                        "fa-duotone": "solid",
                        fadr: "regular",
                        "fa-regular": "regular",
                        fadl: "light",
                        "fa-light": "light",
                        fadt: "thin",
                        "fa-thin": "thin"
                    },
                    sharp: {
                        fa: "solid",
                        fass: "solid",
                        "fa-solid": "solid",
                        fasr: "regular",
                        "fa-regular": "regular",
                        fasl: "light",
                        "fa-light": "light",
                        fast: "thin",
                        "fa-thin": "thin"
                    },
                    "sharp-duotone": {
                        fa: "solid",
                        fasds: "solid",
                        "fa-solid": "solid",
                        fasdr: "regular",
                        "fa-regular": "regular",
                        fasdl: "light",
                        "fa-light": "light",
                        fasdt: "thin",
                        "fa-thin": "thin"
                    }
                }, Tc = [
                    "fa-classic",
                    "fa-duotone",
                    "fa-sharp",
                    "fa-sharp-duotone"
                ], tu = "classic", lu = "duotone", du = [
                    tu,
                    lu,
                    "sharp",
                    "sharp-duotone"
                ], fu = new Map([
                    [
                        "classic",
                        {
                            defaultShortPrefixId: "fas",
                            defaultStyleId: "solid",
                            styleIds: [
                                "solid",
                                "regular",
                                "light",
                                "thin",
                                "brands"
                            ],
                            futureStyleIds: [],
                            defaultFontWeight: 900
                        }
                    ],
                    [
                        "sharp",
                        {
                            defaultShortPrefixId: "fass",
                            defaultStyleId: "solid",
                            styleIds: [
                                "solid",
                                "regular",
                                "light",
                                "thin"
                            ],
                            futureStyleIds: [],
                            defaultFontWeight: 900
                        }
                    ],
                    [
                        "duotone",
                        {
                            defaultShortPrefixId: "fad",
                            defaultStyleId: "solid",
                            styleIds: [
                                "solid",
                                "regular",
                                "light",
                                "thin"
                            ],
                            futureStyleIds: [],
                            defaultFontWeight: 900
                        }
                    ],
                    [
                        "sharp-duotone",
                        {
                            defaultShortPrefixId: "fasds",
                            defaultStyleId: "solid",
                            styleIds: [
                                "solid",
                                "regular",
                                "light",
                                "thin"
                            ],
                            futureStyleIds: [],
                            defaultFontWeight: 900
                        }
                    ]
                ]), yu = [
                    "fak",
                    "fa-kit",
                    "fakd",
                    "fa-kit-duotone"
                ], Eu = {
                    fak: "kit",
                    "fa-kit": "kit"
                }, Tu = {
                    fakd: "kit-duotone",
                    "fa-kit-duotone": "kit-duotone"
                }, Lu = [
                    "fak",
                    "fakd"
                ], Zu = {
                    kit: "fak"
                }, Xu = {
                    "kit-duotone": "fakd"
                }, Ju = {
                    GROUP: "duotone-group",
                    SWAP_OPACITY: "swap-opacity",
                    PRIMARY: "primary",
                    SECONDARY: "secondary"
                }, $u = [
                    "fak",
                    "fa-kit",
                    "fakd",
                    "fa-kit-duotone"
                ], ed = {
                    classic: {
                        fab: "fa-brands",
                        fad: "fa-duotone",
                        fal: "fa-light",
                        far: "fa-regular",
                        fas: "fa-solid",
                        fat: "fa-thin"
                    },
                    duotone: {
                        fadr: "fa-regular",
                        fadl: "fa-light",
                        fadt: "fa-thin"
                    },
                    sharp: {
                        fass: "fa-solid",
                        fasr: "fa-regular",
                        fasl: "fa-light",
                        fast: "fa-thin"
                    },
                    "sharp-duotone": {
                        fasds: "fa-solid",
                        fasdr: "fa-regular",
                        fasdl: "fa-light",
                        fasdt: "fa-thin"
                    }
                }, td = [
                    "fa",
                    "fas",
                    "far",
                    "fal",
                    "fat",
                    "fad",
                    "fadr",
                    "fadl",
                    "fadt",
                    "fab",
                    "fass",
                    "fasr",
                    "fasl",
                    "fast",
                    "fasds",
                    "fasdr",
                    "fasdl",
                    "fasdt",
                    "fa-classic",
                    "fa-duotone",
                    "fa-sharp",
                    "fa-sharp-duotone",
                    "fa-solid",
                    "fa-regular",
                    "fa-light",
                    "fa-thin",
                    "fa-duotone",
                    "fa-brands"
                ], id = [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10
                ], nd = id.concat([
                    11,
                    12,
                    13,
                    14,
                    15,
                    16,
                    17,
                    18,
                    19,
                    20
                ]), rd = [
                    ...Object.keys({
                        classic: [
                            "fas",
                            "far",
                            "fal",
                            "fat",
                            "fad"
                        ],
                        duotone: [
                            "fadr",
                            "fadl",
                            "fadt"
                        ],
                        sharp: [
                            "fass",
                            "fasr",
                            "fasl",
                            "fast"
                        ],
                        "sharp-duotone": [
                            "fasds",
                            "fasdr",
                            "fasdl",
                            "fasdt"
                        ]
                    }),
                    "solid",
                    "regular",
                    "light",
                    "thin",
                    "duotone",
                    "brands",
                    "2xs",
                    "xs",
                    "sm",
                    "lg",
                    "xl",
                    "2xl",
                    "beat",
                    "border",
                    "fade",
                    "beat-fade",
                    "bounce",
                    "flip-both",
                    "flip-horizontal",
                    "flip-vertical",
                    "flip",
                    "fw",
                    "inverse",
                    "layers-counter",
                    "layers-text",
                    "layers",
                    "li",
                    "pull-left",
                    "pull-right",
                    "pulse",
                    "rotate-180",
                    "rotate-270",
                    "rotate-90",
                    "rotate-by",
                    "shake",
                    "spin-pulse",
                    "spin-reverse",
                    "spin",
                    "stack-1x",
                    "stack-2x",
                    "stack",
                    "ul",
                    Ju.GROUP,
                    Ju.SWAP_OPACITY,
                    Ju.PRIMARY,
                    Ju.SECONDARY
                ].concat(id.map((Qe)=>"".concat(Qe, "x"))).concat(nd.map((Qe)=>"w-".concat(Qe)));
                const sd = "___FONT_AWESOME___", ad = 16, od = "svg-inline--fa", ld = "data-fa-i2svg", cd = "data-fa-pseudo-element", ud = "data-prefix", hd = "data-icon", dd = "fontawesome-i2svg", pd = [
                    "HTML",
                    "HEAD",
                    "STYLE",
                    "SCRIPT"
                ], md = (()=>{
                    try {
                        return !0;
                    } catch (Qe) {
                        return !1;
                    }
                })();
                function familyProxy(Qe) {
                    return new Proxy(Qe, {
                        get: (Qe, rt)=>rt in Qe ? Qe[rt] : Qe[tu]
                    });
                }
                const fd = _objectSpread2({}, $l);
                fd[tu] = _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, {
                    "fa-duotone": "duotone"
                }), $l[tu]), Eu), Tu);
                const gd = familyProxy(fd), Ad = _objectSpread2({}, {
                    classic: {
                        solid: "fas",
                        regular: "far",
                        light: "fal",
                        thin: "fat",
                        brands: "fab"
                    },
                    duotone: {
                        solid: "fad",
                        regular: "fadr",
                        light: "fadl",
                        thin: "fadt"
                    },
                    sharp: {
                        solid: "fass",
                        regular: "fasr",
                        light: "fasl",
                        thin: "fast"
                    },
                    "sharp-duotone": {
                        solid: "fasds",
                        regular: "fasdr",
                        light: "fasdl",
                        thin: "fasdt"
                    }
                });
                Ad[tu] = _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, {
                    duotone: "fad"
                }), Ad[tu]), Zu), Xu);
                const yd = familyProxy(Ad), vd = _objectSpread2({}, ed);
                vd[tu] = _objectSpread2(_objectSpread2({}, vd[tu]), {
                    fak: "fa-kit"
                });
                const _d = familyProxy(vd), xd = _objectSpread2({}, {
                    classic: {
                        "fa-brands": "fab",
                        "fa-duotone": "fad",
                        "fa-light": "fal",
                        "fa-regular": "far",
                        "fa-solid": "fas",
                        "fa-thin": "fat"
                    },
                    duotone: {
                        "fa-regular": "fadr",
                        "fa-light": "fadl",
                        "fa-thin": "fadt"
                    },
                    sharp: {
                        "fa-solid": "fass",
                        "fa-regular": "fasr",
                        "fa-light": "fasl",
                        "fa-thin": "fast"
                    },
                    "sharp-duotone": {
                        "fa-solid": "fasds",
                        "fa-regular": "fasdr",
                        "fa-light": "fasdl",
                        "fa-thin": "fasdt"
                    }
                });
                xd[tu] = _objectSpread2(_objectSpread2({}, xd[tu]), {
                    "fa-kit": "fak"
                });
                familyProxy(xd);
                const bd = /fa(s|r|l|t|d|dr|dl|dt|b|k|kd|ss|sr|sl|st|sds|sdr|sdl|sdt)?[\-\ ]/, wd = "fa-layers-text", Ed = /Font ?Awesome ?([56 ]*)(Solid|Regular|Light|Thin|Duotone|Brands|Free|Pro|Sharp Duotone|Sharp|Kit)?.*/i, Md = (familyProxy(_objectSpread2({}, {
                    classic: {
                        900: "fas",
                        400: "far",
                        normal: "far",
                        300: "fal",
                        100: "fat"
                    },
                    duotone: {
                        900: "fad",
                        400: "fadr",
                        300: "fadl",
                        100: "fadt"
                    },
                    sharp: {
                        900: "fass",
                        400: "fasr",
                        300: "fasl",
                        100: "fast"
                    },
                    "sharp-duotone": {
                        900: "fasds",
                        400: "fasdr",
                        300: "fasdl",
                        100: "fasdt"
                    }
                })), [
                    "class",
                    "data-prefix",
                    "data-icon",
                    "data-fa-transform",
                    "data-fa-mask"
                ]), Sd = {
                    GROUP: "duotone-group",
                    SWAP_OPACITY: "swap-opacity",
                    PRIMARY: "primary",
                    SECONDARY: "secondary"
                }, Td = [
                    "kit",
                    ...rd
                ], Cd = Gl.FontAwesomeConfig || {};
                if (Zl && "function" === typeof Zl.querySelector) [
                    [
                        "data-family-prefix",
                        "familyPrefix"
                    ],
                    [
                        "data-css-prefix",
                        "cssPrefix"
                    ],
                    [
                        "data-family-default",
                        "familyDefault"
                    ],
                    [
                        "data-style-default",
                        "styleDefault"
                    ],
                    [
                        "data-replacement-class",
                        "replacementClass"
                    ],
                    [
                        "data-auto-replace-svg",
                        "autoReplaceSvg"
                    ],
                    [
                        "data-auto-add-css",
                        "autoAddCss"
                    ],
                    [
                        "data-auto-a11y",
                        "autoA11y"
                    ],
                    [
                        "data-search-pseudo-elements",
                        "searchPseudoElements"
                    ],
                    [
                        "data-observe-mutations",
                        "observeMutations"
                    ],
                    [
                        "data-mutate-approach",
                        "mutateApproach"
                    ],
                    [
                        "data-keep-original-source",
                        "keepOriginalSource"
                    ],
                    [
                        "data-measure-performance",
                        "measurePerformance"
                    ],
                    [
                        "data-show-missing-icons",
                        "showMissingIcons"
                    ]
                ].forEach((Qe)=>{
                    let [rt, Wn] = Qe;
                    const Co = function(Qe) {
                        return "" === Qe || "false" !== Qe && ("true" === Qe || Qe);
                    }(function(Qe) {
                        var rt = Zl.querySelector("script[" + Qe + "]");
                        if (rt) return rt.getAttribute(Qe);
                    }(rt));
                    void 0 !== Co && null !== Co && (Cd[Wn] = Co);
                });
                const kd = {
                    styleDefault: "solid",
                    familyDefault: tu,
                    cssPrefix: "fa",
                    replacementClass: od,
                    autoReplaceSvg: !0,
                    autoAddCss: !0,
                    autoA11y: !0,
                    searchPseudoElements: !1,
                    observeMutations: !0,
                    mutateApproach: "async",
                    keepOriginalSource: !0,
                    measurePerformance: !1,
                    showMissingIcons: !0
                };
                Cd.familyPrefix && (Cd.cssPrefix = Cd.familyPrefix);
                const Id = _objectSpread2(_objectSpread2({}, kd), Cd);
                Id.autoReplaceSvg || (Id.observeMutations = !1);
                const Dd = {};
                Object.keys(kd).forEach((Qe)=>{
                    Object.defineProperty(Dd, Qe, {
                        enumerable: !0,
                        set: function(rt) {
                            Id[Qe] = rt, Ld.forEach((Qe)=>Qe(Dd));
                        },
                        get: function() {
                            return Id[Qe];
                        }
                    });
                }), Object.defineProperty(Dd, "familyPrefix", {
                    enumerable: !0,
                    set: function(Qe) {
                        Id.cssPrefix = Qe, Ld.forEach((Qe)=>Qe(Dd));
                    },
                    get: function() {
                        return Id.cssPrefix;
                    }
                }), Gl.FontAwesomeConfig = Dd;
                const Ld = [];
                const Pd = ad, zd = {
                    size: 16,
                    x: 0,
                    y: 0,
                    rotate: 0,
                    flipX: !1,
                    flipY: !1
                };
                function nextUniqueId() {
                    let Qe = 12, rt = "";
                    for(; Qe-- > 0;)rt += "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ"[62 * Math.random() | 0];
                    return rt;
                }
                function toArray(Qe) {
                    const rt = [];
                    for(let Wn = (Qe || []).length >>> 0; Wn--;)rt[Wn] = Qe[Wn];
                    return rt;
                }
                function classArray(Qe) {
                    return Qe.classList ? toArray(Qe.classList) : (Qe.getAttribute("class") || "").split(" ").filter((Qe)=>Qe);
                }
                function htmlEscape(Qe) {
                    return "".concat(Qe).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
                }
                function joinStyles(Qe) {
                    return Object.keys(Qe || {}).reduce((rt, Wn)=>rt + "".concat(Wn, ": ").concat(Qe[Wn].trim(), ";"), "");
                }
                function transformIsMeaningful(Qe) {
                    return Qe.size !== zd.size || Qe.x !== zd.x || Qe.y !== zd.y || Qe.rotate !== zd.rotate || Qe.flipX || Qe.flipY;
                }
                function css() {
                    const Qe = "fa", rt = od, Wn = Dd.cssPrefix, Co = Dd.replacementClass;
                    let Dl = ':root, :host {\n  --fa-font-solid: normal 900 1em/1 "Font Awesome 6 Free";\n  --fa-font-regular: normal 400 1em/1 "Font Awesome 6 Free";\n  --fa-font-light: normal 300 1em/1 "Font Awesome 6 Pro";\n  --fa-font-thin: normal 100 1em/1 "Font Awesome 6 Pro";\n  --fa-font-duotone: normal 900 1em/1 "Font Awesome 6 Duotone";\n  --fa-font-duotone-regular: normal 400 1em/1 "Font Awesome 6 Duotone";\n  --fa-font-duotone-light: normal 300 1em/1 "Font Awesome 6 Duotone";\n  --fa-font-duotone-thin: normal 100 1em/1 "Font Awesome 6 Duotone";\n  --fa-font-brands: normal 400 1em/1 "Font Awesome 6 Brands";\n  --fa-font-sharp-solid: normal 900 1em/1 "Font Awesome 6 Sharp";\n  --fa-font-sharp-regular: normal 400 1em/1 "Font Awesome 6 Sharp";\n  --fa-font-sharp-light: normal 300 1em/1 "Font Awesome 6 Sharp";\n  --fa-font-sharp-thin: normal 100 1em/1 "Font Awesome 6 Sharp";\n  --fa-font-sharp-duotone-solid: normal 900 1em/1 "Font Awesome 6 Sharp Duotone";\n  --fa-font-sharp-duotone-regular: normal 400 1em/1 "Font Awesome 6 Sharp Duotone";\n  --fa-font-sharp-duotone-light: normal 300 1em/1 "Font Awesome 6 Sharp Duotone";\n  --fa-font-sharp-duotone-thin: normal 100 1em/1 "Font Awesome 6 Sharp Duotone";\n}\n\nsvg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {\n  overflow: visible;\n  box-sizing: content-box;\n}\n\n.svg-inline--fa {\n  display: var(--fa-display, inline-block);\n  height: 1em;\n  overflow: visible;\n  vertical-align: -0.125em;\n}\n.svg-inline--fa.fa-2xs {\n  vertical-align: 0.1em;\n}\n.svg-inline--fa.fa-xs {\n  vertical-align: 0em;\n}\n.svg-inline--fa.fa-sm {\n  vertical-align: -0.0714285705em;\n}\n.svg-inline--fa.fa-lg {\n  vertical-align: -0.2em;\n}\n.svg-inline--fa.fa-xl {\n  vertical-align: -0.25em;\n}\n.svg-inline--fa.fa-2xl {\n  vertical-align: -0.3125em;\n}\n.svg-inline--fa.fa-pull-left {\n  margin-right: var(--fa-pull-margin, 0.3em);\n  width: auto;\n}\n.svg-inline--fa.fa-pull-right {\n  margin-left: var(--fa-pull-margin, 0.3em);\n  width: auto;\n}\n.svg-inline--fa.fa-li {\n  width: var(--fa-li-width, 2em);\n  top: 0.25em;\n}\n.svg-inline--fa.fa-fw {\n  width: var(--fa-fw-width, 1.25em);\n}\n\n.fa-layers svg.svg-inline--fa {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.fa-layers-counter, .fa-layers-text {\n  display: inline-block;\n  position: absolute;\n  text-align: center;\n}\n\n.fa-layers {\n  display: inline-block;\n  height: 1em;\n  position: relative;\n  text-align: center;\n  vertical-align: -0.125em;\n  width: 1em;\n}\n.fa-layers svg.svg-inline--fa {\n  transform-origin: center center;\n}\n\n.fa-layers-text {\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  transform-origin: center center;\n}\n\n.fa-layers-counter {\n  background-color: var(--fa-counter-background-color, #ff253a);\n  border-radius: var(--fa-counter-border-radius, 1em);\n  box-sizing: border-box;\n  color: var(--fa-inverse, #fff);\n  line-height: var(--fa-counter-line-height, 1);\n  max-width: var(--fa-counter-max-width, 5em);\n  min-width: var(--fa-counter-min-width, 1.5em);\n  overflow: hidden;\n  padding: var(--fa-counter-padding, 0.25em 0.5em);\n  right: var(--fa-right, 0);\n  text-overflow: ellipsis;\n  top: var(--fa-top, 0);\n  transform: scale(var(--fa-counter-scale, 0.25));\n  transform-origin: top right;\n}\n\n.fa-layers-bottom-right {\n  bottom: var(--fa-bottom, 0);\n  right: var(--fa-right, 0);\n  top: auto;\n  transform: scale(var(--fa-layers-scale, 0.25));\n  transform-origin: bottom right;\n}\n\n.fa-layers-bottom-left {\n  bottom: var(--fa-bottom, 0);\n  left: var(--fa-left, 0);\n  right: auto;\n  top: auto;\n  transform: scale(var(--fa-layers-scale, 0.25));\n  transform-origin: bottom left;\n}\n\n.fa-layers-top-right {\n  top: var(--fa-top, 0);\n  right: var(--fa-right, 0);\n  transform: scale(var(--fa-layers-scale, 0.25));\n  transform-origin: top right;\n}\n\n.fa-layers-top-left {\n  left: var(--fa-left, 0);\n  right: auto;\n  top: var(--fa-top, 0);\n  transform: scale(var(--fa-layers-scale, 0.25));\n  transform-origin: top left;\n}\n\n.fa-1x {\n  font-size: 1em;\n}\n\n.fa-2x {\n  font-size: 2em;\n}\n\n.fa-3x {\n  font-size: 3em;\n}\n\n.fa-4x {\n  font-size: 4em;\n}\n\n.fa-5x {\n  font-size: 5em;\n}\n\n.fa-6x {\n  font-size: 6em;\n}\n\n.fa-7x {\n  font-size: 7em;\n}\n\n.fa-8x {\n  font-size: 8em;\n}\n\n.fa-9x {\n  font-size: 9em;\n}\n\n.fa-10x {\n  font-size: 10em;\n}\n\n.fa-2xs {\n  font-size: 0.625em;\n  line-height: 0.1em;\n  vertical-align: 0.225em;\n}\n\n.fa-xs {\n  font-size: 0.75em;\n  line-height: 0.0833333337em;\n  vertical-align: 0.125em;\n}\n\n.fa-sm {\n  font-size: 0.875em;\n  line-height: 0.0714285718em;\n  vertical-align: 0.0535714295em;\n}\n\n.fa-lg {\n  font-size: 1.25em;\n  line-height: 0.05em;\n  vertical-align: -0.075em;\n}\n\n.fa-xl {\n  font-size: 1.5em;\n  line-height: 0.0416666682em;\n  vertical-align: -0.125em;\n}\n\n.fa-2xl {\n  font-size: 2em;\n  line-height: 0.03125em;\n  vertical-align: -0.1875em;\n}\n\n.fa-fw {\n  text-align: center;\n  width: 1.25em;\n}\n\n.fa-ul {\n  list-style-type: none;\n  margin-left: var(--fa-li-margin, 2.5em);\n  padding-left: 0;\n}\n.fa-ul > li {\n  position: relative;\n}\n\n.fa-li {\n  left: calc(-1 * var(--fa-li-width, 2em));\n  position: absolute;\n  text-align: center;\n  width: var(--fa-li-width, 2em);\n  line-height: inherit;\n}\n\n.fa-border {\n  border-color: var(--fa-border-color, #eee);\n  border-radius: var(--fa-border-radius, 0.1em);\n  border-style: var(--fa-border-style, solid);\n  border-width: var(--fa-border-width, 0.08em);\n  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);\n}\n\n.fa-pull-left {\n  float: left;\n  margin-right: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-pull-right {\n  float: right;\n  margin-left: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-beat {\n  animation-name: fa-beat;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-bounce {\n  animation-name: fa-bounce;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));\n}\n\n.fa-fade {\n  animation-name: fa-fade;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-beat-fade {\n  animation-name: fa-beat-fade;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-flip {\n  animation-name: fa-flip;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-shake {\n  animation-name: fa-shake;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin {\n  animation-name: fa-spin;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 2s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin-reverse {\n  --fa-animation-direction: reverse;\n}\n\n.fa-pulse,\n.fa-spin-pulse {\n  animation-name: fa-spin;\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, steps(8));\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .fa-beat,\n.fa-bounce,\n.fa-fade,\n.fa-beat-fade,\n.fa-flip,\n.fa-pulse,\n.fa-shake,\n.fa-spin,\n.fa-spin-pulse {\n    animation-delay: -1ms;\n    animation-duration: 1ms;\n    animation-iteration-count: 1;\n    transition-delay: 0s;\n    transition-duration: 0s;\n  }\n}\n@keyframes fa-beat {\n  0%, 90% {\n    transform: scale(1);\n  }\n  45% {\n    transform: scale(var(--fa-beat-scale, 1.25));\n  }\n}\n@keyframes fa-bounce {\n  0% {\n    transform: scale(1, 1) translateY(0);\n  }\n  10% {\n    transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n  }\n  30% {\n    transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n  }\n  50% {\n    transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n  }\n  57% {\n    transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n  }\n  64% {\n    transform: scale(1, 1) translateY(0);\n  }\n  100% {\n    transform: scale(1, 1) translateY(0);\n  }\n}\n@keyframes fa-fade {\n  50% {\n    opacity: var(--fa-fade-opacity, 0.4);\n  }\n}\n@keyframes fa-beat-fade {\n  0%, 100% {\n    opacity: var(--fa-beat-fade-opacity, 0.4);\n    transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    transform: scale(var(--fa-beat-fade-scale, 1.125));\n  }\n}\n@keyframes fa-flip {\n  50% {\n    transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n  }\n}\n@keyframes fa-shake {\n  0% {\n    transform: rotate(-15deg);\n  }\n  4% {\n    transform: rotate(15deg);\n  }\n  8%, 24% {\n    transform: rotate(-18deg);\n  }\n  12%, 28% {\n    transform: rotate(18deg);\n  }\n  16% {\n    transform: rotate(-22deg);\n  }\n  20% {\n    transform: rotate(22deg);\n  }\n  32% {\n    transform: rotate(-12deg);\n  }\n  36% {\n    transform: rotate(12deg);\n  }\n  40%, 100% {\n    transform: rotate(0deg);\n  }\n}\n@keyframes fa-spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.fa-rotate-90 {\n  transform: rotate(90deg);\n}\n\n.fa-rotate-180 {\n  transform: rotate(180deg);\n}\n\n.fa-rotate-270 {\n  transform: rotate(270deg);\n}\n\n.fa-flip-horizontal {\n  transform: scale(-1, 1);\n}\n\n.fa-flip-vertical {\n  transform: scale(1, -1);\n}\n\n.fa-flip-both,\n.fa-flip-horizontal.fa-flip-vertical {\n  transform: scale(-1, -1);\n}\n\n.fa-rotate-by {\n  transform: rotate(var(--fa-rotate-angle, 0));\n}\n\n.fa-stack {\n  display: inline-block;\n  vertical-align: middle;\n  height: 2em;\n  position: relative;\n  width: 2.5em;\n}\n\n.fa-stack-1x,\n.fa-stack-2x {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: var(--fa-stack-z-index, auto);\n}\n\n.svg-inline--fa.fa-stack-1x {\n  height: 1em;\n  width: 1.25em;\n}\n.svg-inline--fa.fa-stack-2x {\n  height: 2em;\n  width: 2.5em;\n}\n\n.fa-inverse {\n  color: var(--fa-inverse, #fff);\n}\n\n.sr-only,\n.fa-sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.sr-only-focusable:not(:focus),\n.fa-sr-only-focusable:not(:focus) {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.svg-inline--fa .fa-primary {\n  fill: var(--fa-primary-color, currentColor);\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa .fa-secondary {\n  fill: var(--fa-secondary-color, currentColor);\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-primary {\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-secondary {\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa mask .fa-primary,\n.svg-inline--fa mask .fa-secondary {\n  fill: black;\n}';
                    if (Wn !== Qe || Co !== rt) {
                        const Ll = new RegExp("\\.".concat(Qe, "\\-"), "g"), Rl = new RegExp("\\--".concat(Qe, "\\-"), "g"), Ul = new RegExp("\\.".concat(rt), "g");
                        Dl = Dl.replace(Ll, ".".concat(Wn, "-")).replace(Rl, "--".concat(Wn, "-")).replace(Ul, ".".concat(Co));
                    }
                    return Dl;
                }
                let Nd = !1;
                function ensureCss() {
                    Dd.autoAddCss && !Nd && (!function(Qe) {
                        if (!Qe || !Ql) return;
                        const rt = Zl.createElement("style");
                        rt.setAttribute("type", "text/css"), rt.innerHTML = Qe;
                        const Wn = Zl.head.childNodes;
                        let Co = null;
                        for(let Dl = Wn.length - 1; Dl > -1; Dl--){
                            const Qe = Wn[Dl], rt = (Qe.tagName || "").toUpperCase();
                            [
                                "STYLE",
                                "LINK"
                            ].indexOf(rt) > -1 && (Co = Qe);
                        }
                        Zl.head.insertBefore(rt, Co);
                    }(css()), Nd = !0);
                }
                var Rd = {
                    mixout: ()=>({
                            dom: {
                                css: css,
                                insertCss: ensureCss
                            }
                        }),
                    hooks: ()=>({
                            beforeDOMElementCreation () {
                                ensureCss();
                            },
                            beforeI2svg () {
                                ensureCss();
                            }
                        })
                };
                const Bd = Gl || {};
                Bd[sd] || (Bd[sd] = {}), Bd[sd].styles || (Bd[sd].styles = {}), Bd[sd].hooks || (Bd[sd].hooks = {}), Bd[sd].shims || (Bd[sd].shims = []);
                var Od = Bd[sd];
                const Fd = [], listener = function() {
                    Zl.removeEventListener("DOMContentLoaded", listener), jd = 1, Fd.map((Qe)=>Qe());
                };
                let jd = !1;
                function toHtml(Qe) {
                    const { tag: rt, attributes: Wn = {}, children: Co = [] } = Qe;
                    return "string" === typeof Qe ? htmlEscape(Qe) : "<".concat(rt, " ").concat(function(Qe) {
                        return Object.keys(Qe || {}).reduce((rt, Wn)=>rt + "".concat(Wn, '="').concat(htmlEscape(Qe[Wn]), '" '), "").trim();
                    }(Wn), ">").concat(Co.map(toHtml).join(""), "</").concat(rt, ">");
                }
                function iconFromMapping(Qe, rt, Wn) {
                    if (Qe && Qe[rt] && Qe[rt][Wn]) return {
                        prefix: rt,
                        iconName: Wn,
                        icon: Qe[rt][Wn]
                    };
                }
                Ql && (jd = (Zl.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(Zl.readyState), jd || Zl.addEventListener("DOMContentLoaded", listener));
                var reduce = function(Qe, rt, Wn, Co) {
                    var Dl, Ll, Rl, Ul = Object.keys(Qe), Gl = Ul.length, Zl = void 0 !== Co ? function(Qe, rt) {
                        return function(Wn, Co, Dl, Ll) {
                            return Qe.call(rt, Wn, Co, Dl, Ll);
                        };
                    }(rt, Co) : rt;
                    for(void 0 === Wn ? (Dl = 1, Rl = Qe[Ul[0]]) : (Dl = 0, Rl = Wn); Dl < Gl; Dl++)Rl = Zl(Rl, Qe[Ll = Ul[Dl]], Ll, Qe);
                    return Rl;
                };
                function toHex(Qe) {
                    const rt = function(Qe) {
                        const rt = [];
                        let Wn = 0;
                        const Co = Qe.length;
                        for(; Wn < Co;){
                            const Dl = Qe.charCodeAt(Wn++);
                            if (Dl >= 55296 && Dl <= 56319 && Wn < Co) {
                                const Co = Qe.charCodeAt(Wn++);
                                56320 == (64512 & Co) ? rt.push(((1023 & Dl) << 10) + (1023 & Co) + 65536) : (rt.push(Dl), Wn--);
                            } else rt.push(Dl);
                        }
                        return rt;
                    }(Qe);
                    return 1 === rt.length ? rt[0].toString(16) : null;
                }
                function normalizeIcons(Qe) {
                    return Object.keys(Qe).reduce((rt, Wn)=>{
                        const Co = Qe[Wn];
                        return !!Co.icon ? rt[Co.iconName] = Co.icon : rt[Wn] = Co, rt;
                    }, {});
                }
                function defineIcons(Qe, rt) {
                    let Wn = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                    const { skipHooks: Co = !1 } = Wn, Dl = normalizeIcons(rt);
                    "function" !== typeof Od.hooks.addPack || Co ? Od.styles[Qe] = _objectSpread2(_objectSpread2({}, Od.styles[Qe] || {}), Dl) : Od.hooks.addPack(Qe, normalizeIcons(rt)), "fas" === Qe && defineIcons("fa", rt);
                }
                const { styles: Ud, shims: Vd } = Od, Gd = Object.keys(_d), Zd = Gd.reduce((Qe, rt)=>(Qe[rt] = Object.keys(_d[rt]), Qe), {});
                let Hd = null, Wd = {}, qd = {}, Yd = {}, Qd = {}, Kd = {};
                function getIconName(Qe, rt) {
                    const Wn = rt.split("-"), Co = Wn[0], Dl = Wn.slice(1).join("-");
                    var Ll;
                    return Co !== Qe || "" === Dl || (Ll = Dl, ~Td.indexOf(Ll)) ? null : Dl;
                }
                const build = ()=>{
                    const lookup = (Qe)=>reduce(Ud, (rt, Wn, Co)=>(rt[Co] = reduce(Wn, Qe, {}), rt), {});
                    Wd = lookup((Qe, rt, Wn)=>{
                        if (rt[3] && (Qe[rt[3]] = Wn), rt[2]) rt[2].filter((Qe)=>"number" === typeof Qe).forEach((rt)=>{
                            Qe[rt.toString(16)] = Wn;
                        });
                        return Qe;
                    }), qd = lookup((Qe, rt, Wn)=>{
                        if (Qe[Wn] = Wn, rt[2]) rt[2].filter((Qe)=>"string" === typeof Qe).forEach((rt)=>{
                            Qe[rt] = Wn;
                        });
                        return Qe;
                    }), Kd = lookup((Qe, rt, Wn)=>{
                        const Co = rt[2];
                        return Qe[Wn] = Wn, Co.forEach((rt)=>{
                            Qe[rt] = Wn;
                        }), Qe;
                    });
                    const Qe = "far" in Ud || Dd.autoFetchSvg, rt = reduce(Vd, (rt, Wn)=>{
                        const Co = Wn[0];
                        let Dl = Wn[1];
                        const Ll = Wn[2];
                        return "far" !== Dl || Qe || (Dl = "fas"), "string" === typeof Co && (rt.names[Co] = {
                            prefix: Dl,
                            iconName: Ll
                        }), "number" === typeof Co && (rt.unicodes[Co.toString(16)] = {
                            prefix: Dl,
                            iconName: Ll
                        }), rt;
                    }, {
                        names: {},
                        unicodes: {}
                    });
                    Yd = rt.names, Qd = rt.unicodes, Hd = getCanonicalPrefix(Dd.styleDefault, {
                        family: Dd.familyDefault
                    });
                };
                var Xd;
                function byUnicode(Qe, rt) {
                    return (Wd[Qe] || {})[rt];
                }
                function byAlias(Qe, rt) {
                    return (Kd[Qe] || {})[rt];
                }
                function byOldName(Qe) {
                    return Yd[Qe] || {
                        prefix: null,
                        iconName: null
                    };
                }
                function getDefaultUsablePrefix() {
                    return Hd;
                }
                Xd = (Qe)=>{
                    Hd = getCanonicalPrefix(Qe.styleDefault, {
                        family: Dd.familyDefault
                    });
                }, Ld.push(Xd), build();
                function getCanonicalPrefix(Qe) {
                    let rt = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                    const { family: Wn = tu } = rt, Co = gd[Wn][Qe];
                    if (Wn === lu && !Qe) return "fad";
                    const Dl = yd[Wn][Qe] || yd[Wn][Co], Ll = Qe in Od.styles ? Qe : null;
                    return Dl || Ll || null;
                }
                function sortedUniqueValues(Qe) {
                    return Qe.sort().filter((Qe, rt, Wn)=>Wn.indexOf(Qe) === rt);
                }
                function getCanonicalIcon(Qe) {
                    let rt = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                    const { skipLookups: Wn = !1 } = rt;
                    let Co = null;
                    const Dl = td.concat($u), Ll = sortedUniqueValues(Qe.filter((Qe)=>Dl.includes(Qe))), Rl = sortedUniqueValues(Qe.filter((Qe)=>!td.includes(Qe))), Ul = Ll.filter((Qe)=>(Co = Qe, !Tc.includes(Qe))), [Gl = null] = Ul, Zl = function(Qe) {
                        let rt = tu;
                        const Wn = Gd.reduce((Qe, rt)=>(Qe[rt] = "".concat(Dd.cssPrefix, "-").concat(rt), Qe), {});
                        return du.forEach((Co)=>{
                            (Qe.includes(Wn[Co]) || Qe.some((Qe)=>Zd[Co].includes(Qe))) && (rt = Co);
                        }), rt;
                    }(Ll), Hl = _objectSpread2(_objectSpread2({}, function(Qe) {
                        let rt = [], Wn = null;
                        return Qe.forEach((Qe)=>{
                            const Co = getIconName(Dd.cssPrefix, Qe);
                            Co ? Wn = Co : Qe && rt.push(Qe);
                        }), {
                            iconName: Wn,
                            rest: rt
                        };
                    }(Rl)), {}, {
                        prefix: getCanonicalPrefix(Gl, {
                            family: Zl
                        })
                    });
                    return _objectSpread2(_objectSpread2(_objectSpread2({}, Hl), function(Qe) {
                        const { values: rt, family: Wn, canonical: Co, givenPrefix: Dl = "", styles: Ll = {}, config: Rl = {} } = Qe, Ul = Wn === lu, Gl = rt.includes("fa-duotone") || rt.includes("fad"), Zl = "duotone" === Rl.familyDefault, Hl = "fad" === Co.prefix || "fa-duotone" === Co.prefix;
                        !Ul && (Gl || Zl || Hl) && (Co.prefix = "fad");
                        (rt.includes("fa-brands") || rt.includes("fab")) && (Co.prefix = "fab");
                        if (!Co.prefix && Jd.includes(Wn)) {
                            if (Object.keys(Ll).find((Qe)=>$d.includes(Qe)) || Rl.autoFetchSvg) {
                                const Qe = fu.get(Wn).defaultShortPrefixId;
                                Co.prefix = Qe, Co.iconName = byAlias(Co.prefix, Co.iconName) || Co.iconName;
                            }
                        }
                        "fa" !== Co.prefix && "fa" !== Dl || (Co.prefix = getDefaultUsablePrefix() || "fas");
                        return Co;
                    }({
                        values: Qe,
                        family: Zl,
                        styles: Ud,
                        config: Dd,
                        canonical: Hl,
                        givenPrefix: Co
                    })), function(Qe, rt, Wn) {
                        let { prefix: Co, iconName: Dl } = Wn;
                        if (Qe || !Co || !Dl) return {
                            prefix: Co,
                            iconName: Dl
                        };
                        const Ll = "fa" === rt ? byOldName(Dl) : {}, Rl = byAlias(Co, Dl);
                        Dl = Ll.iconName || Rl || Dl, Co = Ll.prefix || Co, "far" !== Co || Ud.far || !Ud.fas || Dd.autoFetchSvg || (Co = "fas");
                        return {
                            prefix: Co,
                            iconName: Dl
                        };
                    }(Wn, Co, Hl));
                }
                const Jd = du.filter((Qe)=>Qe !== tu || Qe !== lu), $d = Object.keys(ed).filter((Qe)=>Qe !== tu).map((Qe)=>Object.keys(ed[Qe])).flat();
                let up = [], gp = {};
                const Ap = {}, vp = Object.keys(Ap);
                function chainHooks(Qe, rt) {
                    for(var Wn = arguments.length, Co = new Array(Wn > 2 ? Wn - 2 : 0), Dl = 2; Dl < Wn; Dl++)Co[Dl - 2] = arguments[Dl];
                    return (gp[Qe] || []).forEach((Qe)=>{
                        rt = Qe.apply(null, [
                            rt,
                            ...Co
                        ]);
                    }), rt;
                }
                function callHooks(Qe) {
                    for(var rt = arguments.length, Wn = new Array(rt > 1 ? rt - 1 : 0), Co = 1; Co < rt; Co++)Wn[Co - 1] = arguments[Co];
                    (gp[Qe] || []).forEach((Qe)=>{
                        Qe.apply(null, Wn);
                    });
                }
                function callProvided() {
                    const Qe = arguments[0], rt = Array.prototype.slice.call(arguments, 1);
                    return Ap[Qe] ? Ap[Qe].apply(null, rt) : void 0;
                }
                function findIconDefinition(Qe) {
                    "fa" === Qe.prefix && (Qe.prefix = "fas");
                    let { iconName: rt } = Qe;
                    const Wn = Qe.prefix || getDefaultUsablePrefix();
                    if (rt) return rt = byAlias(Wn, rt) || rt, iconFromMapping(_p.definitions, Wn, rt) || iconFromMapping(Od.styles, Wn, rt);
                }
                const _p = new class {
                    constructor(){
                        this.definitions = {};
                    }
                    add() {
                        for(var Qe = arguments.length, rt = new Array(Qe), Wn = 0; Wn < Qe; Wn++)rt[Wn] = arguments[Wn];
                        const Co = rt.reduce(this._pullDefinitions, {});
                        Object.keys(Co).forEach((Qe)=>{
                            this.definitions[Qe] = _objectSpread2(_objectSpread2({}, this.definitions[Qe] || {}), Co[Qe]), defineIcons(Qe, Co[Qe]);
                            const rt = _d[tu][Qe];
                            rt && defineIcons(rt, Co[Qe]), build();
                        });
                    }
                    reset() {
                        this.definitions = {};
                    }
                    _pullDefinitions(Qe, rt) {
                        const Wn = rt.prefix && rt.iconName && rt.icon ? {
                            0: rt
                        } : rt;
                        return Object.keys(Wn).map((rt)=>{
                            const { prefix: Co, iconName: Dl, icon: Ll } = Wn[rt], Rl = Ll[2];
                            Qe[Co] || (Qe[Co] = {}), Rl.length > 0 && Rl.forEach((rt)=>{
                                "string" === typeof rt && (Qe[Co][rt] = Ll);
                            }), Qe[Co][Dl] = Ll;
                        }), Qe;
                    }
                }, xp = {
                    i2svg: function() {
                        let Qe = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                        return Ql ? (callHooks("beforeI2svg", Qe), callProvided("pseudoElements2svg", Qe), callProvided("i2svg", Qe)) : Promise.reject(new Error("Operation requires a DOM of some kind."));
                    },
                    watch: function() {
                        let Qe = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                        const { autoReplaceSvgRoot: rt } = Qe;
                        var Wn;
                        !1 === Dd.autoReplaceSvg && (Dd.autoReplaceSvg = !0), Dd.observeMutations = !0, Wn = ()=>{
                            autoReplace({
                                autoReplaceSvgRoot: rt
                            }), callHooks("watch", Qe);
                        }, Ql && (jd ? setTimeout(Wn, 0) : Fd.push(Wn));
                    }
                }, bp = {
                    icon: (Qe)=>{
                        if (null === Qe) return null;
                        if ("object" === typeof Qe && Qe.prefix && Qe.iconName) return {
                            prefix: Qe.prefix,
                            iconName: byAlias(Qe.prefix, Qe.iconName) || Qe.iconName
                        };
                        if (Array.isArray(Qe) && 2 === Qe.length) {
                            const rt = 0 === Qe[1].indexOf("fa-") ? Qe[1].slice(3) : Qe[1], Wn = getCanonicalPrefix(Qe[0]);
                            return {
                                prefix: Wn,
                                iconName: byAlias(Wn, rt) || rt
                            };
                        }
                        if ("string" === typeof Qe && (Qe.indexOf("".concat(Dd.cssPrefix, "-")) > -1 || Qe.match(bd))) {
                            const rt = getCanonicalIcon(Qe.split(" "), {
                                skipLookups: !0
                            });
                            return {
                                prefix: rt.prefix || getDefaultUsablePrefix(),
                                iconName: byAlias(rt.prefix, rt.iconName) || rt.iconName
                            };
                        }
                        if ("string" === typeof Qe) {
                            const rt = getDefaultUsablePrefix();
                            return {
                                prefix: rt,
                                iconName: byAlias(rt, Qe) || Qe
                            };
                        }
                    }
                }, wp = {
                    noAuto: ()=>{
                        Dd.autoReplaceSvg = !1, Dd.observeMutations = !1, callHooks("noAuto");
                    },
                    config: Dd,
                    dom: xp,
                    parse: bp,
                    library: _p,
                    findIconDefinition: findIconDefinition,
                    toHtml: toHtml
                }, autoReplace = function() {
                    let Qe = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                    const { autoReplaceSvgRoot: rt = Zl } = Qe;
                    (Object.keys(Od.styles).length > 0 || Dd.autoFetchSvg) && Ql && Dd.autoReplaceSvg && wp.dom.i2svg({
                        node: rt
                    });
                };
                function domVariants(Qe, rt) {
                    return Object.defineProperty(Qe, "abstract", {
                        get: rt
                    }), Object.defineProperty(Qe, "html", {
                        get: function() {
                            return Qe.abstract.map((Qe)=>toHtml(Qe));
                        }
                    }), Object.defineProperty(Qe, "node", {
                        get: function() {
                            if (!Ql) return;
                            const rt = Zl.createElement("div");
                            return rt.innerHTML = Qe.html, rt.children;
                        }
                    }), Qe;
                }
                function makeInlineSvgAbstract(Qe) {
                    const { icons: { main: rt, mask: Wn }, prefix: Co, iconName: Dl, transform: Ll, symbol: Rl, title: Ul, maskId: Gl, titleId: Zl, extra: Hl, watchable: ql = !1 } = Qe, { width: Ql, height: Kl } = Wn.found ? Wn : rt, $l = Lu.includes(Co), Tc = [
                        Dd.replacementClass,
                        Dl ? "".concat(Dd.cssPrefix, "-").concat(Dl) : ""
                    ].filter((Qe)=>-1 === Hl.classes.indexOf(Qe)).filter((Qe)=>"" !== Qe || !!Qe).concat(Hl.classes).join(" ");
                    let tu = {
                        children: [],
                        attributes: _objectSpread2(_objectSpread2({}, Hl.attributes), {}, {
                            "data-prefix": Co,
                            "data-icon": Dl,
                            class: Tc,
                            role: Hl.attributes.role || "img",
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 ".concat(Ql, " ").concat(Kl)
                        })
                    };
                    const lu = $l && !~Hl.classes.indexOf("fa-fw") ? {
                        width: "".concat(Ql / Kl * 1, "em")
                    } : {};
                    ql && (tu.attributes[ld] = ""), Ul && (tu.children.push({
                        tag: "title",
                        attributes: {
                            id: tu.attributes["aria-labelledby"] || "title-".concat(Zl || nextUniqueId())
                        },
                        children: [
                            Ul
                        ]
                    }), delete tu.attributes.title);
                    const du = _objectSpread2(_objectSpread2({}, tu), {}, {
                        prefix: Co,
                        iconName: Dl,
                        main: rt,
                        mask: Wn,
                        maskId: Gl,
                        transform: Ll,
                        symbol: Rl,
                        styles: _objectSpread2(_objectSpread2({}, lu), Hl.styles)
                    }), { children: fu, attributes: yu } = Wn.found && rt.found ? callProvided("generateAbstractMask", du) || {
                        children: [],
                        attributes: {}
                    } : callProvided("generateAbstractIcon", du) || {
                        children: [],
                        attributes: {}
                    };
                    return du.children = fu, du.attributes = yu, Rl ? function(Qe) {
                        let { prefix: rt, iconName: Wn, children: Co, attributes: Dl, symbol: Ll } = Qe;
                        const Rl = !0 === Ll ? "".concat(rt, "-").concat(Dd.cssPrefix, "-").concat(Wn) : Ll;
                        return [
                            {
                                tag: "svg",
                                attributes: {
                                    style: "display: none;"
                                },
                                children: [
                                    {
                                        tag: "symbol",
                                        attributes: _objectSpread2(_objectSpread2({}, Dl), {}, {
                                            id: Rl
                                        }),
                                        children: Co
                                    }
                                ]
                            }
                        ];
                    }(du) : function(Qe) {
                        let { children: rt, main: Wn, mask: Co, attributes: Dl, styles: Ll, transform: Rl } = Qe;
                        if (transformIsMeaningful(Rl) && Wn.found && !Co.found) {
                            const { width: Qe, height: rt } = Wn, Co = {
                                x: Qe / rt / 2,
                                y: .5
                            };
                            Dl.style = joinStyles(_objectSpread2(_objectSpread2({}, Ll), {}, {
                                "transform-origin": "".concat(Co.x + Rl.x / 16, "em ").concat(Co.y + Rl.y / 16, "em")
                            }));
                        }
                        return [
                            {
                                tag: "svg",
                                attributes: Dl,
                                children: rt
                            }
                        ];
                    }(du);
                }
                function makeLayersTextAbstract(Qe) {
                    const { content: rt, width: Wn, height: Co, transform: Dl, title: Ll, extra: Rl, watchable: Ul = !1 } = Qe, Gl = _objectSpread2(_objectSpread2(_objectSpread2({}, Rl.attributes), Ll ? {
                        title: Ll
                    } : {}), {}, {
                        class: Rl.classes.join(" ")
                    });
                    Ul && (Gl[ld] = "");
                    const Zl = _objectSpread2({}, Rl.styles);
                    transformIsMeaningful(Dl) && (Zl.transform = function(Qe) {
                        let { transform: rt, width: Wn = ad, height: Co = ad, startCentered: Dl = !1 } = Qe, Ll = "";
                        return Ll += Dl && Kl ? "translate(".concat(rt.x / Pd - Wn / 2, "em, ").concat(rt.y / Pd - Co / 2, "em) ") : Dl ? "translate(calc(-50% + ".concat(rt.x / Pd, "em), calc(-50% + ").concat(rt.y / Pd, "em)) ") : "translate(".concat(rt.x / Pd, "em, ").concat(rt.y / Pd, "em) "), Ll += "scale(".concat(rt.size / Pd * (rt.flipX ? -1 : 1), ", ").concat(rt.size / Pd * (rt.flipY ? -1 : 1), ") "), Ll += "rotate(".concat(rt.rotate, "deg) "), Ll;
                    }({
                        transform: Dl,
                        startCentered: !0,
                        width: Wn,
                        height: Co
                    }), Zl["-webkit-transform"] = Zl.transform);
                    const Hl = joinStyles(Zl);
                    Hl.length > 0 && (Gl.style = Hl);
                    const ql = [];
                    return ql.push({
                        tag: "span",
                        attributes: Gl,
                        children: [
                            rt
                        ]
                    }), Ll && ql.push({
                        tag: "span",
                        attributes: {
                            class: "sr-only"
                        },
                        children: [
                            Ll
                        ]
                    }), ql;
                }
                const { styles: Ep } = Od;
                function asFoundIcon(Qe) {
                    const rt = Qe[0], Wn = Qe[1], [Co] = Qe.slice(4);
                    let Dl = null;
                    return Dl = Array.isArray(Co) ? {
                        tag: "g",
                        attributes: {
                            class: "".concat(Dd.cssPrefix, "-").concat(Sd.GROUP)
                        },
                        children: [
                            {
                                tag: "path",
                                attributes: {
                                    class: "".concat(Dd.cssPrefix, "-").concat(Sd.SECONDARY),
                                    fill: "currentColor",
                                    d: Co[0]
                                }
                            },
                            {
                                tag: "path",
                                attributes: {
                                    class: "".concat(Dd.cssPrefix, "-").concat(Sd.PRIMARY),
                                    fill: "currentColor",
                                    d: Co[1]
                                }
                            }
                        ]
                    } : {
                        tag: "path",
                        attributes: {
                            fill: "currentColor",
                            d: Co
                        }
                    }, {
                        found: !0,
                        width: rt,
                        height: Wn,
                        icon: Dl
                    };
                }
                const Mp = {
                    found: !1,
                    width: 512,
                    height: 512
                };
                function findIcon(Qe, rt) {
                    let Wn = rt;
                    return "fa" === rt && null !== Dd.styleDefault && (rt = getDefaultUsablePrefix()), new Promise((Co, Dl)=>{
                        if ("fa" === Wn) {
                            const Wn = byOldName(Qe) || {};
                            Qe = Wn.iconName || Qe, rt = Wn.prefix || rt;
                        }
                        if (Qe && rt && Ep[rt] && Ep[rt][Qe]) return Co(asFoundIcon(Ep[rt][Qe]));
                        !function(Qe, rt) {
                            md || Dd.showMissingIcons || !Qe || console.error('Icon with name "'.concat(Qe, '" and prefix "').concat(rt, '" is missing.'));
                        }(Qe, rt), Co(_objectSpread2(_objectSpread2({}, Mp), {}, {
                            icon: Dd.showMissingIcons && Qe && callProvided("missingIconAbstract") || {}
                        }));
                    });
                }
                const noop$1 = ()=>{}, Sp = Dd.measurePerformance && ql && ql.mark && ql.measure ? ql : {
                    mark: noop$1,
                    measure: noop$1
                }, Tp = 'FA "6.7.2"', end = (Qe)=>{
                    Sp.mark("".concat(Tp, " ").concat(Qe, " ends")), Sp.measure("".concat(Tp, " ").concat(Qe), "".concat(Tp, " ").concat(Qe, " begins"), "".concat(Tp, " ").concat(Qe, " ends"));
                };
                var perf_begin = (Qe)=>(Sp.mark("".concat(Tp, " ").concat(Qe, " begins")), ()=>end(Qe));
                const noop$2 = ()=>{};
                function isWatched(Qe) {
                    return "string" === typeof (Qe.getAttribute ? Qe.getAttribute(ld) : null);
                }
                function createElementNS(Qe) {
                    return Zl.createElementNS("http://www.w3.org/2000/svg", Qe);
                }
                function createElement(Qe) {
                    return Zl.createElement(Qe);
                }
                function convertSVG(Qe) {
                    let rt = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                    const { ceFn: Wn = "svg" === Qe.tag ? createElementNS : createElement } = rt;
                    if ("string" === typeof Qe) return Zl.createTextNode(Qe);
                    const Co = Wn(Qe.tag);
                    Object.keys(Qe.attributes || []).forEach(function(rt) {
                        Co.setAttribute(rt, Qe.attributes[rt]);
                    });
                    return (Qe.children || []).forEach(function(Qe) {
                        Co.appendChild(convertSVG(Qe, {
                            ceFn: Wn
                        }));
                    }), Co;
                }
                const Cp = {
                    replace: function(Qe) {
                        const rt = Qe[0];
                        if (rt.parentNode) {
                            if (Qe[1].forEach((Qe)=>{
                                rt.parentNode.insertBefore(convertSVG(Qe), rt);
                            }), null === rt.getAttribute(ld) && Dd.keepOriginalSource) {
                                let Qe = Zl.createComment(function(Qe) {
                                    let rt = " ".concat(Qe.outerHTML, " ");
                                    return rt = "".concat(rt, "Font Awesome fontawesome.com "), rt;
                                }(rt));
                                rt.parentNode.replaceChild(Qe, rt);
                            } else rt.remove();
                        }
                    },
                    nest: function(Qe) {
                        const rt = Qe[0], Wn = Qe[1];
                        if (~classArray(rt).indexOf(Dd.replacementClass)) return Cp.replace(Qe);
                        const Co = new RegExp("".concat(Dd.cssPrefix, "-.*"));
                        if (delete Wn[0].attributes.id, Wn[0].attributes.class) {
                            const Qe = Wn[0].attributes.class.split(" ").reduce((Qe, rt)=>(rt === Dd.replacementClass || rt.match(Co) ? Qe.toSvg.push(rt) : Qe.toNode.push(rt), Qe), {
                                toNode: [],
                                toSvg: []
                            });
                            Wn[0].attributes.class = Qe.toSvg.join(" "), 0 === Qe.toNode.length ? rt.removeAttribute("class") : rt.setAttribute("class", Qe.toNode.join(" "));
                        }
                        const Dl = Wn.map((Qe)=>toHtml(Qe)).join("\n");
                        rt.setAttribute(ld, ""), rt.innerHTML = Dl;
                    }
                };
                function performOperationSync(Qe) {
                    Qe();
                }
                function perform(Qe, rt) {
                    const Wn = "function" === typeof rt ? rt : noop$2;
                    if (0 === Qe.length) Wn();
                    else {
                        let rt = performOperationSync;
                        "async" === Dd.mutateApproach && (rt = Gl.requestAnimationFrame || performOperationSync), rt(()=>{
                            const rt = !0 === Dd.autoReplaceSvg ? Cp.replace : Cp[Dd.autoReplaceSvg] || Cp.replace, Co = perf_begin("mutate");
                            Qe.map(rt), Co(), Wn();
                        });
                    }
                }
                let kp = !1;
                function disableObservation() {
                    kp = !0;
                }
                function enableObservation() {
                    kp = !1;
                }
                let Ip = null;
                function observe(Qe) {
                    if (!Hl) return;
                    if (!Dd.observeMutations) return;
                    const { treeCallback: rt = noop$2, nodeCallback: Wn = noop$2, pseudoElementsCallback: Co = noop$2, observeMutationsRoot: Dl = Zl } = Qe;
                    Ip = new Hl((Qe)=>{
                        if (kp) return;
                        const Dl = getDefaultUsablePrefix();
                        toArray(Qe).forEach((Qe)=>{
                            if ("childList" === Qe.type && Qe.addedNodes.length > 0 && !isWatched(Qe.addedNodes[0]) && (Dd.searchPseudoElements && Co(Qe.target), rt(Qe.target)), "attributes" === Qe.type && Qe.target.parentNode && Dd.searchPseudoElements && Co(Qe.target.parentNode), "attributes" === Qe.type && isWatched(Qe.target) && ~Md.indexOf(Qe.attributeName)) {
                                if ("class" === Qe.attributeName && function(Qe) {
                                    const rt = Qe.getAttribute ? Qe.getAttribute(ud) : null, Wn = Qe.getAttribute ? Qe.getAttribute(hd) : null;
                                    return rt && Wn;
                                }(Qe.target)) {
                                    const { prefix: rt, iconName: Wn } = getCanonicalIcon(classArray(Qe.target));
                                    Qe.target.setAttribute(ud, rt || Dl), Wn && Qe.target.setAttribute(hd, Wn);
                                } else (Ll = Qe.target) && Ll.classList && Ll.classList.contains && Ll.classList.contains(Dd.replacementClass) && Wn(Qe.target);
                            }
                            var Ll;
                        });
                    }), Ql && Ip.observe(Dl, {
                        childList: !0,
                        attributes: !0,
                        characterData: !0,
                        subtree: !0
                    });
                }
                function classParser(Qe) {
                    const rt = Qe.getAttribute("data-prefix"), Wn = Qe.getAttribute("data-icon"), Co = void 0 !== Qe.innerText ? Qe.innerText.trim() : "";
                    let Dl = getCanonicalIcon(classArray(Qe));
                    var Ll, Rl;
                    return Dl.prefix || (Dl.prefix = getDefaultUsablePrefix()), rt && Wn && (Dl.prefix = rt, Dl.iconName = Wn), Dl.iconName && Dl.prefix || (Dl.prefix && Co.length > 0 && (Dl.iconName = (Ll = Dl.prefix, Rl = Qe.innerText, (qd[Ll] || {})[Rl] || byUnicode(Dl.prefix, toHex(Qe.innerText)))), !Dl.iconName && Dd.autoFetchSvg && Qe.firstChild && Qe.firstChild.nodeType === Node.TEXT_NODE && (Dl.iconName = Qe.firstChild.data)), Dl;
                }
                function parseMeta(Qe) {
                    let rt = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
                        styleParser: !0
                    };
                    const { iconName: Wn, prefix: Co, rest: Dl } = classParser(Qe), Ll = function(Qe) {
                        const rt = toArray(Qe.attributes).reduce((Qe, rt)=>("class" !== Qe.name && "style" !== Qe.name && (Qe[rt.name] = rt.value), Qe), {}), Wn = Qe.getAttribute("title"), Co = Qe.getAttribute("data-fa-title-id");
                        return Dd.autoA11y && (Wn ? rt["aria-labelledby"] = "".concat(Dd.replacementClass, "-title-").concat(Co || nextUniqueId()) : (rt["aria-hidden"] = "true", rt.focusable = "false")), rt;
                    }(Qe), Rl = chainHooks("parseNodeAttributes", {}, Qe);
                    let Ul = rt.styleParser ? function(Qe) {
                        const rt = Qe.getAttribute("style");
                        let Wn = [];
                        return rt && (Wn = rt.split(";").reduce((Qe, rt)=>{
                            const Wn = rt.split(":"), Co = Wn[0], Dl = Wn.slice(1);
                            return Co && Dl.length > 0 && (Qe[Co] = Dl.join(":").trim()), Qe;
                        }, {})), Wn;
                    }(Qe) : [];
                    return _objectSpread2({
                        iconName: Wn,
                        title: Qe.getAttribute("title"),
                        titleId: Qe.getAttribute("data-fa-title-id"),
                        prefix: Co,
                        transform: zd,
                        mask: {
                            iconName: null,
                            prefix: null,
                            rest: []
                        },
                        maskId: null,
                        symbol: !1,
                        extra: {
                            classes: Dl,
                            styles: Ul,
                            attributes: Ll
                        }
                    }, Rl);
                }
                const { styles: Dp } = Od;
                function generateMutation(Qe) {
                    const rt = "nest" === Dd.autoReplaceSvg ? parseMeta(Qe, {
                        styleParser: !1
                    }) : parseMeta(Qe);
                    return ~rt.extra.classes.indexOf(wd) ? callProvided("generateLayersText", Qe, rt) : callProvided("generateSvgReplacementMutation", Qe, rt);
                }
                function onTree(Qe) {
                    let rt = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
                    if (!Ql) return Promise.resolve();
                    const Wn = Zl.documentElement.classList, hclAdd = (Qe)=>Wn.add("".concat(dd, "-").concat(Qe)), hclRemove = (Qe)=>Wn.remove("".concat(dd, "-").concat(Qe)), Co = Dd.autoFetchSvg ? [
                        ...yu,
                        ...td
                    ] : Tc.concat(Object.keys(Dp));
                    Co.includes("fa") || Co.push("fa");
                    const Dl = [
                        ".".concat(wd, ":not([").concat(ld, "])")
                    ].concat(Co.map((Qe)=>".".concat(Qe, ":not([").concat(ld, "])"))).join(", ");
                    if (0 === Dl.length) return Promise.resolve();
                    let Ll = [];
                    try {
                        Ll = toArray(Qe.querySelectorAll(Dl));
                    } catch (Gl) {}
                    if (!(Ll.length > 0)) return Promise.resolve();
                    hclAdd("pending"), hclRemove("complete");
                    const Rl = perf_begin("onTree"), Ul = Ll.reduce((Qe, rt)=>{
                        try {
                            const Wn = generateMutation(rt);
                            Wn && Qe.push(Wn);
                        } catch (Gl) {
                            md || "MissingIcon" === Gl.name && console.error(Gl);
                        }
                        return Qe;
                    }, []);
                    return new Promise((Qe, Wn)=>{
                        Promise.all(Ul).then((Wn)=>{
                            perform(Wn, ()=>{
                                hclAdd("active"), hclAdd("complete"), hclRemove("pending"), "function" === typeof rt && rt(), Rl(), Qe();
                            });
                        }).catch((Qe)=>{
                            Rl(), Wn(Qe);
                        });
                    });
                }
                function onNode(Qe) {
                    let rt = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
                    generateMutation(Qe).then((Qe)=>{
                        Qe && perform([
                            Qe
                        ], rt);
                    });
                }
                const render = function(Qe) {
                    let rt = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                    const { transform: Wn = zd, symbol: Co = !1, mask: Dl = null, maskId: Ll = null, title: Rl = null, titleId: Ul = null, classes: Gl = [], attributes: Zl = {}, styles: Hl = {} } = rt;
                    if (!Qe) return;
                    const { prefix: ql, iconName: Ql, icon: Kl } = Qe;
                    return domVariants(_objectSpread2({
                        type: "icon"
                    }, Qe), ()=>(callHooks("beforeDOMElementCreation", {
                            iconDefinition: Qe,
                            params: rt
                        }), Dd.autoA11y && (Rl ? Zl["aria-labelledby"] = "".concat(Dd.replacementClass, "-title-").concat(Ul || nextUniqueId()) : (Zl["aria-hidden"] = "true", Zl.focusable = "false")), makeInlineSvgAbstract({
                            icons: {
                                main: asFoundIcon(Kl),
                                mask: Dl ? asFoundIcon(Dl.icon) : {
                                    found: !1,
                                    width: null,
                                    height: null,
                                    icon: {}
                                }
                            },
                            prefix: ql,
                            iconName: Ql,
                            transform: _objectSpread2(_objectSpread2({}, zd), Wn),
                            symbol: Co,
                            title: Rl,
                            maskId: Ll,
                            titleId: Ul,
                            extra: {
                                attributes: Zl,
                                styles: Hl,
                                classes: Gl
                            }
                        })));
                };
                var Lp = {
                    mixout () {
                        var Qe;
                        return {
                            icon: (Qe = render, function(rt) {
                                let Wn = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                                const Co = (rt || {}).icon ? rt : findIconDefinition(rt || {});
                                let { mask: Dl } = Wn;
                                return Dl && (Dl = (Dl || {}).icon ? Dl : findIconDefinition(Dl || {})), Qe(Co, _objectSpread2(_objectSpread2({}, Wn), {}, {
                                    mask: Dl
                                }));
                            })
                        };
                    },
                    hooks: ()=>({
                            mutationObserverCallbacks: (Qe)=>(Qe.treeCallback = onTree, Qe.nodeCallback = onNode, Qe)
                        }),
                    provides (Qe) {
                        Qe.i2svg = function(Qe) {
                            const { node: rt = Zl, callback: Wn = ()=>{} } = Qe;
                            return onTree(rt, Wn);
                        }, Qe.generateSvgReplacementMutation = function(Qe, rt) {
                            const { iconName: Wn, title: Co, titleId: Dl, prefix: Ll, transform: Rl, symbol: Ul, mask: Gl, maskId: Zl, extra: Hl } = rt;
                            return new Promise((rt, ql)=>{
                                Promise.all([
                                    findIcon(Wn, Ll),
                                    Gl.iconName ? findIcon(Gl.iconName, Gl.prefix) : Promise.resolve({
                                        found: !1,
                                        width: 512,
                                        height: 512,
                                        icon: {}
                                    })
                                ]).then((Gl)=>{
                                    let [ql, Ql] = Gl;
                                    rt([
                                        Qe,
                                        makeInlineSvgAbstract({
                                            icons: {
                                                main: ql,
                                                mask: Ql
                                            },
                                            prefix: Ll,
                                            iconName: Wn,
                                            transform: Rl,
                                            symbol: Ul,
                                            maskId: Zl,
                                            title: Co,
                                            titleId: Dl,
                                            extra: Hl,
                                            watchable: !0
                                        })
                                    ]);
                                }).catch(ql);
                            });
                        }, Qe.generateAbstractIcon = function(Qe) {
                            let { children: rt, attributes: Wn, main: Co, transform: Dl, styles: Ll } = Qe;
                            const Rl = joinStyles(Ll);
                            let Ul;
                            return Rl.length > 0 && (Wn.style = Rl), transformIsMeaningful(Dl) && (Ul = callProvided("generateAbstractTransformGrouping", {
                                main: Co,
                                transform: Dl,
                                containerWidth: Co.width,
                                iconWidth: Co.width
                            })), rt.push(Ul || Co.icon), {
                                children: rt,
                                attributes: Wn
                            };
                        };
                    }
                }, Pp = {
                    mixout: ()=>({
                            layer (Qe) {
                                let rt = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                                const { classes: Wn = [] } = rt;
                                return domVariants({
                                    type: "layer"
                                }, ()=>{
                                    callHooks("beforeDOMElementCreation", {
                                        assembler: Qe,
                                        params: rt
                                    });
                                    let Co = [];
                                    return Qe((Qe)=>{
                                        Array.isArray(Qe) ? Qe.map((Qe)=>{
                                            Co = Co.concat(Qe.abstract);
                                        }) : Co = Co.concat(Qe.abstract);
                                    }), [
                                        {
                                            tag: "span",
                                            attributes: {
                                                class: [
                                                    "".concat(Dd.cssPrefix, "-layers"),
                                                    ...Wn
                                                ].join(" ")
                                            },
                                            children: Co
                                        }
                                    ];
                                });
                            }
                        })
                }, zp = {
                    mixout: ()=>({
                            counter (Qe) {
                                let rt = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                                const { title: Wn = null, classes: Co = [], attributes: Dl = {}, styles: Ll = {} } = rt;
                                return domVariants({
                                    type: "counter",
                                    content: Qe
                                }, ()=>(callHooks("beforeDOMElementCreation", {
                                        content: Qe,
                                        params: rt
                                    }), function(Qe) {
                                        const { content: rt, title: Wn, extra: Co } = Qe, Dl = _objectSpread2(_objectSpread2(_objectSpread2({}, Co.attributes), Wn ? {
                                            title: Wn
                                        } : {}), {}, {
                                            class: Co.classes.join(" ")
                                        }), Ll = joinStyles(Co.styles);
                                        Ll.length > 0 && (Dl.style = Ll);
                                        const Rl = [];
                                        return Rl.push({
                                            tag: "span",
                                            attributes: Dl,
                                            children: [
                                                rt
                                            ]
                                        }), Wn && Rl.push({
                                            tag: "span",
                                            attributes: {
                                                class: "sr-only"
                                            },
                                            children: [
                                                Wn
                                            ]
                                        }), Rl;
                                    }({
                                        content: Qe.toString(),
                                        title: Wn,
                                        extra: {
                                            attributes: Dl,
                                            styles: Ll,
                                            classes: [
                                                "".concat(Dd.cssPrefix, "-layers-counter"),
                                                ...Co
                                            ]
                                        }
                                    })));
                            }
                        })
                }, Np = {
                    mixout: ()=>({
                            text (Qe) {
                                let rt = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                                const { transform: Wn = zd, title: Co = null, classes: Dl = [], attributes: Ll = {}, styles: Rl = {} } = rt;
                                return domVariants({
                                    type: "text",
                                    content: Qe
                                }, ()=>(callHooks("beforeDOMElementCreation", {
                                        content: Qe,
                                        params: rt
                                    }), makeLayersTextAbstract({
                                        content: Qe,
                                        transform: _objectSpread2(_objectSpread2({}, zd), Wn),
                                        title: Co,
                                        extra: {
                                            attributes: Ll,
                                            styles: Rl,
                                            classes: [
                                                "".concat(Dd.cssPrefix, "-layers-text"),
                                                ...Dl
                                            ]
                                        }
                                    })));
                            }
                        }),
                    provides (Qe) {
                        Qe.generateLayersText = function(Qe, rt) {
                            const { title: Wn, transform: Co, extra: Dl } = rt;
                            let Ll = null, Rl = null;
                            if (Kl) {
                                const rt = parseInt(getComputedStyle(Qe).fontSize, 10), Wn = Qe.getBoundingClientRect();
                                Ll = Wn.width / rt, Rl = Wn.height / rt;
                            }
                            return Dd.autoA11y && !Wn && (Dl.attributes["aria-hidden"] = "true"), Promise.resolve([
                                Qe,
                                makeLayersTextAbstract({
                                    content: Qe.innerHTML,
                                    width: Ll,
                                    height: Rl,
                                    transform: Co,
                                    title: Wn,
                                    extra: Dl,
                                    watchable: !0
                                })
                            ]);
                        };
                    }
                };
                const Rp = new RegExp('"', "ug"), Bp = [
                    1105920,
                    1112319
                ], Op = _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, {
                    FontAwesome: {
                        normal: "fas",
                        400: "fas"
                    }
                }), {
                    "Font Awesome 6 Free": {
                        900: "fas",
                        400: "far"
                    },
                    "Font Awesome 6 Pro": {
                        900: "fas",
                        400: "far",
                        normal: "far",
                        300: "fal",
                        100: "fat"
                    },
                    "Font Awesome 6 Brands": {
                        400: "fab",
                        normal: "fab"
                    },
                    "Font Awesome 6 Duotone": {
                        900: "fad",
                        400: "fadr",
                        normal: "fadr",
                        300: "fadl",
                        100: "fadt"
                    },
                    "Font Awesome 6 Sharp": {
                        900: "fass",
                        400: "fasr",
                        normal: "fasr",
                        300: "fasl",
                        100: "fast"
                    },
                    "Font Awesome 6 Sharp Duotone": {
                        900: "fasds",
                        400: "fasdr",
                        normal: "fasdr",
                        300: "fasdl",
                        100: "fasdt"
                    }
                }), {
                    "Font Awesome 5 Free": {
                        900: "fas",
                        400: "far"
                    },
                    "Font Awesome 5 Pro": {
                        900: "fas",
                        400: "far",
                        normal: "far",
                        300: "fal"
                    },
                    "Font Awesome 5 Brands": {
                        400: "fab",
                        normal: "fab"
                    },
                    "Font Awesome 5 Duotone": {
                        900: "fad"
                    }
                }), {
                    "Font Awesome Kit": {
                        400: "fak",
                        normal: "fak"
                    },
                    "Font Awesome Kit Duotone": {
                        400: "fakd",
                        normal: "fakd"
                    }
                }), Fp = Object.keys(Op).reduce((Qe, rt)=>(Qe[rt.toLowerCase()] = Op[rt], Qe), {}), jp = Object.keys(Fp).reduce((Qe, rt)=>{
                    const Wn = Fp[rt];
                    return Qe[rt] = Wn[900] || [
                        ...Object.entries(Wn)
                    ][0][1], Qe;
                }, {});
                function replaceForPosition(Qe, rt) {
                    const Wn = "".concat("data-fa-pseudo-element-pending").concat(rt.replace(":", "-"));
                    return new Promise((Co, Dl)=>{
                        if (null !== Qe.getAttribute(Wn)) return Co();
                        const Ll = toArray(Qe.children).filter((Qe)=>Qe.getAttribute(cd) === rt)[0], Rl = Gl.getComputedStyle(Qe, rt), Ul = Rl.getPropertyValue("font-family"), Hl = Ul.match(Ed), ql = Rl.getPropertyValue("font-weight"), Ql = Rl.getPropertyValue("content");
                        if (Ll && !Hl) return Qe.removeChild(Ll), Co();
                        if (Hl && "none" !== Ql && "" !== Ql) {
                            const Gl = Rl.getPropertyValue("content");
                            let Ql = function(Qe, rt) {
                                const Wn = Qe.replace(/^['"]|['"]$/g, "").toLowerCase(), Co = parseInt(rt), Dl = isNaN(Co) ? "normal" : Co;
                                return (Fp[Wn] || {})[Dl] || jp[Wn];
                            }(Ul, ql);
                            const { value: Kl, isSecondary: $l } = function(Qe) {
                                const rt = Qe.replace(Rp, ""), Wn = function(Qe, rt) {
                                    const Wn = Qe.length;
                                    let Co, Dl = Qe.charCodeAt(rt);
                                    return Dl >= 55296 && Dl <= 56319 && Wn > rt + 1 && (Co = Qe.charCodeAt(rt + 1), Co >= 56320 && Co <= 57343) ? 1024 * (Dl - 55296) + Co - 56320 + 65536 : Dl;
                                }(rt, 0), Co = Wn >= Bp[0] && Wn <= Bp[1], Dl = 2 === rt.length && rt[0] === rt[1];
                                return {
                                    value: toHex(Dl ? rt[0] : rt),
                                    isSecondary: Co || Dl
                                };
                            }(Gl), Tc = Hl[0].startsWith("FontAwesome");
                            let tu = byUnicode(Ql, Kl), lu = tu;
                            if (Tc) {
                                const Qe = function(Qe) {
                                    const rt = Qd[Qe], Wn = byUnicode("fas", Qe);
                                    return rt || (Wn ? {
                                        prefix: "fas",
                                        iconName: Wn
                                    } : null) || {
                                        prefix: null,
                                        iconName: null
                                    };
                                }(Kl);
                                Qe.iconName && Qe.prefix && (tu = Qe.iconName, Ql = Qe.prefix);
                            }
                            if (!tu || $l || Ll && Ll.getAttribute(ud) === Ql && Ll.getAttribute(hd) === lu) Co();
                            else {
                                Qe.setAttribute(Wn, lu), Ll && Qe.removeChild(Ll);
                                const Rl = {
                                    iconName: null,
                                    title: null,
                                    titleId: null,
                                    prefix: null,
                                    transform: zd,
                                    symbol: !1,
                                    mask: {
                                        iconName: null,
                                        prefix: null,
                                        rest: []
                                    },
                                    maskId: null,
                                    extra: {
                                        classes: [],
                                        styles: {},
                                        attributes: {}
                                    }
                                }, { extra: Ul } = Rl;
                                Ul.attributes[cd] = rt, findIcon(tu, Ql).then((Dl)=>{
                                    const Ll = makeInlineSvgAbstract(_objectSpread2(_objectSpread2({}, Rl), {}, {
                                        icons: {
                                            main: Dl,
                                            mask: {
                                                prefix: null,
                                                iconName: null,
                                                rest: []
                                            }
                                        },
                                        prefix: Ql,
                                        iconName: lu,
                                        extra: Ul,
                                        watchable: !0
                                    })), Gl = Zl.createElementNS("http://www.w3.org/2000/svg", "svg");
                                    "::before" === rt ? Qe.insertBefore(Gl, Qe.firstChild) : Qe.appendChild(Gl), Gl.outerHTML = Ll.map((Qe)=>toHtml(Qe)).join("\n"), Qe.removeAttribute(Wn), Co();
                                }).catch(Dl);
                            }
                        } else Co();
                    });
                }
                function replace(Qe) {
                    return Promise.all([
                        replaceForPosition(Qe, "::before"),
                        replaceForPosition(Qe, "::after")
                    ]);
                }
                function processable(Qe) {
                    return Qe.parentNode !== document.head && !~pd.indexOf(Qe.tagName.toUpperCase()) && !Qe.getAttribute(cd) && (!Qe.parentNode || "svg" !== Qe.parentNode.tagName);
                }
                function searchPseudoElements(Qe) {
                    if (Ql) return new Promise((rt, Wn)=>{
                        const Co = toArray(Qe.querySelectorAll("*")).filter(processable).map(replace), Dl = perf_begin("searchPseudoElements");
                        disableObservation(), Promise.all(Co).then(()=>{
                            Dl(), enableObservation(), rt();
                        }).catch(()=>{
                            Dl(), enableObservation(), Wn();
                        });
                    });
                }
                var Up = {
                    hooks: ()=>({
                            mutationObserverCallbacks: (Qe)=>(Qe.pseudoElementsCallback = searchPseudoElements, Qe)
                        }),
                    provides (Qe) {
                        Qe.pseudoElements2svg = function(Qe) {
                            const { node: rt = Zl } = Qe;
                            Dd.searchPseudoElements && searchPseudoElements(rt);
                        };
                    }
                };
                let Vp = !1;
                var Gp = {
                    mixout: ()=>({
                            dom: {
                                unwatch () {
                                    disableObservation(), Vp = !0;
                                }
                            }
                        }),
                    hooks: ()=>({
                            bootstrap () {
                                observe(chainHooks("mutationObserverCallbacks", {}));
                            },
                            noAuto () {
                                Ip && Ip.disconnect();
                            },
                            watch (Qe) {
                                const { observeMutationsRoot: rt } = Qe;
                                Vp ? enableObservation() : observe(chainHooks("mutationObserverCallbacks", {
                                    observeMutationsRoot: rt
                                }));
                            }
                        })
                };
                const parseTransformString = (Qe)=>Qe.toLowerCase().split(" ").reduce((Qe, rt)=>{
                        const Wn = rt.toLowerCase().split("-"), Co = Wn[0];
                        let Dl = Wn.slice(1).join("-");
                        if (Co && "h" === Dl) return Qe.flipX = !0, Qe;
                        if (Co && "v" === Dl) return Qe.flipY = !0, Qe;
                        if (Dl = parseFloat(Dl), isNaN(Dl)) return Qe;
                        switch(Co){
                            case "grow":
                                Qe.size = Qe.size + Dl;
                                break;
                            case "shrink":
                                Qe.size = Qe.size - Dl;
                                break;
                            case "left":
                                Qe.x = Qe.x - Dl;
                                break;
                            case "right":
                                Qe.x = Qe.x + Dl;
                                break;
                            case "up":
                                Qe.y = Qe.y - Dl;
                                break;
                            case "down":
                                Qe.y = Qe.y + Dl;
                                break;
                            case "rotate":
                                Qe.rotate = Qe.rotate + Dl;
                        }
                        return Qe;
                    }, {
                        size: 16,
                        x: 0,
                        y: 0,
                        flipX: !1,
                        flipY: !1,
                        rotate: 0
                    });
                var Zp = {
                    mixout: ()=>({
                            parse: {
                                transform: (Qe)=>parseTransformString(Qe)
                            }
                        }),
                    hooks: ()=>({
                            parseNodeAttributes (Qe, rt) {
                                const Wn = rt.getAttribute("data-fa-transform");
                                return Wn && (Qe.transform = parseTransformString(Wn)), Qe;
                            }
                        }),
                    provides (Qe) {
                        Qe.generateAbstractTransformGrouping = function(Qe) {
                            let { main: rt, transform: Wn, containerWidth: Co, iconWidth: Dl } = Qe;
                            const Ll = {
                                transform: "translate(".concat(Co / 2, " 256)")
                            }, Rl = "translate(".concat(32 * Wn.x, ", ").concat(32 * Wn.y, ") "), Ul = "scale(".concat(Wn.size / 16 * (Wn.flipX ? -1 : 1), ", ").concat(Wn.size / 16 * (Wn.flipY ? -1 : 1), ") "), Gl = "rotate(".concat(Wn.rotate, " 0 0)"), Zl = {
                                outer: Ll,
                                inner: {
                                    transform: "".concat(Rl, " ").concat(Ul, " ").concat(Gl)
                                },
                                path: {
                                    transform: "translate(".concat(Dl / 2 * -1, " -256)")
                                }
                            };
                            return {
                                tag: "g",
                                attributes: _objectSpread2({}, Zl.outer),
                                children: [
                                    {
                                        tag: "g",
                                        attributes: _objectSpread2({}, Zl.inner),
                                        children: [
                                            {
                                                tag: rt.icon.tag,
                                                children: rt.icon.children,
                                                attributes: _objectSpread2(_objectSpread2({}, rt.icon.attributes), Zl.path)
                                            }
                                        ]
                                    }
                                ]
                            };
                        };
                    }
                };
                const Hp = {
                    x: 0,
                    y: 0,
                    width: "100%",
                    height: "100%"
                };
                function fillBlack(Qe) {
                    let rt = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
                    return Qe.attributes && (Qe.attributes.fill || rt) && (Qe.attributes.fill = "black"), Qe;
                }
                var Wp = {
                    hooks: ()=>({
                            parseNodeAttributes (Qe, rt) {
                                const Wn = rt.getAttribute("data-fa-mask"), Co = Wn ? getCanonicalIcon(Wn.split(" ").map((Qe)=>Qe.trim())) : {
                                    prefix: null,
                                    iconName: null,
                                    rest: []
                                };
                                return Co.prefix || (Co.prefix = getDefaultUsablePrefix()), Qe.mask = Co, Qe.maskId = rt.getAttribute("data-fa-mask-id"), Qe;
                            }
                        }),
                    provides (Qe) {
                        Qe.generateAbstractMask = function(Qe) {
                            let { children: rt, attributes: Wn, main: Co, mask: Dl, maskId: Ll, transform: Rl } = Qe;
                            const { width: Ul, icon: Gl } = Co, { width: Zl, icon: Hl } = Dl, ql = function(Qe) {
                                let { transform: rt, containerWidth: Wn, iconWidth: Co } = Qe;
                                const Dl = {
                                    transform: "translate(".concat(Wn / 2, " 256)")
                                }, Ll = "translate(".concat(32 * rt.x, ", ").concat(32 * rt.y, ") "), Rl = "scale(".concat(rt.size / 16 * (rt.flipX ? -1 : 1), ", ").concat(rt.size / 16 * (rt.flipY ? -1 : 1), ") "), Ul = "rotate(".concat(rt.rotate, " 0 0)");
                                return {
                                    outer: Dl,
                                    inner: {
                                        transform: "".concat(Ll, " ").concat(Rl, " ").concat(Ul)
                                    },
                                    path: {
                                        transform: "translate(".concat(Co / 2 * -1, " -256)")
                                    }
                                };
                            }({
                                transform: Rl,
                                containerWidth: Zl,
                                iconWidth: Ul
                            }), Ql = {
                                tag: "rect",
                                attributes: _objectSpread2(_objectSpread2({}, Hp), {}, {
                                    fill: "white"
                                })
                            }, Kl = Gl.children ? {
                                children: Gl.children.map(fillBlack)
                            } : {}, $l = {
                                tag: "g",
                                attributes: _objectSpread2({}, ql.inner),
                                children: [
                                    fillBlack(_objectSpread2({
                                        tag: Gl.tag,
                                        attributes: _objectSpread2(_objectSpread2({}, Gl.attributes), ql.path)
                                    }, Kl))
                                ]
                            }, Tc = {
                                tag: "g",
                                attributes: _objectSpread2({}, ql.outer),
                                children: [
                                    $l
                                ]
                            }, tu = "mask-".concat(Ll || nextUniqueId()), lu = "clip-".concat(Ll || nextUniqueId()), du = {
                                tag: "mask",
                                attributes: _objectSpread2(_objectSpread2({}, Hp), {}, {
                                    id: tu,
                                    maskUnits: "userSpaceOnUse",
                                    maskContentUnits: "userSpaceOnUse"
                                }),
                                children: [
                                    Ql,
                                    Tc
                                ]
                            }, fu = {
                                tag: "defs",
                                children: [
                                    {
                                        tag: "clipPath",
                                        attributes: {
                                            id: lu
                                        },
                                        children: (yu = Hl, "g" === yu.tag ? yu.children : [
                                            yu
                                        ])
                                    },
                                    du
                                ]
                            };
                            var yu;
                            return rt.push(fu, {
                                tag: "rect",
                                attributes: _objectSpread2({
                                    fill: "currentColor",
                                    "clip-path": "url(#".concat(lu, ")"),
                                    mask: "url(#".concat(tu, ")")
                                }, Hp)
                            }), {
                                children: rt,
                                attributes: Wn
                            };
                        };
                    }
                }, qp = {
                    provides (Qe) {
                        let rt = !1;
                        Gl.matchMedia && (rt = Gl.matchMedia("(prefers-reduced-motion: reduce)").matches), Qe.missingIconAbstract = function() {
                            const Qe = [], Wn = {
                                fill: "currentColor"
                            }, Co = {
                                attributeType: "XML",
                                repeatCount: "indefinite",
                                dur: "2s"
                            };
                            Qe.push({
                                tag: "path",
                                attributes: _objectSpread2(_objectSpread2({}, Wn), {}, {
                                    d: "M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z"
                                })
                            });
                            const Dl = _objectSpread2(_objectSpread2({}, Co), {}, {
                                attributeName: "opacity"
                            }), Ll = {
                                tag: "circle",
                                attributes: _objectSpread2(_objectSpread2({}, Wn), {}, {
                                    cx: "256",
                                    cy: "364",
                                    r: "28"
                                }),
                                children: []
                            };
                            return rt || Ll.children.push({
                                tag: "animate",
                                attributes: _objectSpread2(_objectSpread2({}, Co), {}, {
                                    attributeName: "r",
                                    values: "28;14;28;28;14;28;"
                                })
                            }, {
                                tag: "animate",
                                attributes: _objectSpread2(_objectSpread2({}, Dl), {}, {
                                    values: "1;0;1;1;0;1;"
                                })
                            }), Qe.push(Ll), Qe.push({
                                tag: "path",
                                attributes: _objectSpread2(_objectSpread2({}, Wn), {}, {
                                    opacity: "1",
                                    d: "M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z"
                                }),
                                children: rt ? [] : [
                                    {
                                        tag: "animate",
                                        attributes: _objectSpread2(_objectSpread2({}, Dl), {}, {
                                            values: "1;0;0;0;0;1;"
                                        })
                                    }
                                ]
                            }), rt || Qe.push({
                                tag: "path",
                                attributes: _objectSpread2(_objectSpread2({}, Wn), {}, {
                                    opacity: "0",
                                    d: "M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z"
                                }),
                                children: [
                                    {
                                        tag: "animate",
                                        attributes: _objectSpread2(_objectSpread2({}, Dl), {}, {
                                            values: "0;0;1;1;0;0;"
                                        })
                                    }
                                ]
                            }), {
                                tag: "g",
                                attributes: {
                                    class: "missing"
                                },
                                children: Qe
                            };
                        };
                    }
                };
                !function(Qe, rt) {
                    let { mixoutsTo: Wn } = rt;
                    up = Qe, gp = {}, Object.keys(Ap).forEach((Qe)=>{
                        -1 === vp.indexOf(Qe) && delete Ap[Qe];
                    }), up.forEach((Qe)=>{
                        const rt = Qe.mixout ? Qe.mixout() : {};
                        if (Object.keys(rt).forEach((Qe)=>{
                            "function" === typeof rt[Qe] && (Wn[Qe] = rt[Qe]), "object" === typeof rt[Qe] && Object.keys(rt[Qe]).forEach((Co)=>{
                                Wn[Qe] || (Wn[Qe] = {}), Wn[Qe][Co] = rt[Qe][Co];
                            });
                        }), Qe.hooks) {
                            const rt = Qe.hooks();
                            Object.keys(rt).forEach((Qe)=>{
                                gp[Qe] || (gp[Qe] = []), gp[Qe].push(rt[Qe]);
                            });
                        }
                        Qe.provides && Qe.provides(Ap);
                    });
                }([
                    Rd,
                    Lp,
                    Pp,
                    zp,
                    Np,
                    Up,
                    Gp,
                    Zp,
                    Wp,
                    qp,
                    {
                        hooks: ()=>({
                                parseNodeAttributes (Qe, rt) {
                                    const Wn = rt.getAttribute("data-fa-symbol"), Co = null !== Wn && ("" === Wn || Wn);
                                    return Qe.symbol = Co, Qe;
                                }
                            })
                    }
                ], {
                    mixoutsTo: wp
                });
                const Yp = wp.icon;
            },
            7929: (Qe, rt, Wn)=>{
                "use strict";
                Wn.d(rt, {
                    iW_: ()=>Dl
                });
                /*!
 * Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2024 Fonticons, Inc.
 */ const Co = {
                    prefix: "fas",
                    iconName: "circle-info",
                    icon: [
                        512,
                        512,
                        [
                            "info-circle"
                        ],
                        "f05a",
                        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336l24 0 0-64-24 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 88 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                    ]
                }, Dl = Co;
            },
            4161: (Qe, rt, Wn)=>{
                "use strict";
                Wn.d(rt, {
                    AH: ()=>i,
                    Rf: ()=>S,
                    iz: ()=>r,
                    sk: ()=>Ul
                });
                /**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const Co = globalThis, Dl = Co.ShadowRoot && (void 0 === Co.ShadyCSS || Co.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, Ll = Symbol(), Rl = new WeakMap;
                class n {
                    constructor(Qe, rt, Wn){
                        if (this._$cssResult$ = !0, Wn !== Ll) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
                        this.cssText = Qe, this.t = rt;
                    }
                    get styleSheet() {
                        let Qe = this.o;
                        const rt = this.t;
                        if (Dl && void 0 === Qe) {
                            const Wn = void 0 !== rt && 1 === rt.length;
                            Wn && (Qe = Rl.get(rt)), void 0 === Qe && ((this.o = Qe = new CSSStyleSheet).replaceSync(this.cssText), Wn && Rl.set(rt, Qe));
                        }
                        return Qe;
                    }
                    toString() {
                        return this.cssText;
                    }
                }
                const r = (Qe)=>new n("string" == typeof Qe ? Qe : Qe + "", void 0, Ll), i = function(Qe) {
                    for(var rt = arguments.length, Wn = new Array(rt > 1 ? rt - 1 : 0), Co = 1; Co < rt; Co++)Wn[Co - 1] = arguments[Co];
                    const Dl = 1 === Qe.length ? Qe[0] : Wn.reduce((rt, Wn, Co)=>rt + ((Qe)=>{
                            if (!0 === Qe._$cssResult$) return Qe.cssText;
                            if ("number" == typeof Qe) return Qe;
                            throw Error("Value passed to 'css' function must be a 'css' function result: " + Qe + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
                        })(Wn) + Qe[Co + 1], Qe[0]);
                    return new n(Dl, Qe, Ll);
                }, S = (Qe, rt)=>{
                    if (Dl) Qe.adoptedStyleSheets = rt.map((Qe)=>Qe instanceof CSSStyleSheet ? Qe : Qe.styleSheet);
                    else for (const Wn of rt){
                        const rt = document.createElement("style"), Dl = Co.litNonce;
                        void 0 !== Dl && rt.setAttribute("nonce", Dl), rt.textContent = Wn.cssText, Qe.appendChild(rt);
                    }
                }, Ul = Dl ? (Qe)=>Qe : (Qe)=>Qe instanceof CSSStyleSheet ? ((Qe)=>{
                        let rt = "";
                        for (const Wn of Qe.cssRules)rt += Wn.cssText;
                        return r(rt);
                    })(Qe) : Qe;
            },
            8789: (Qe, rt, Wn)=>{
                "use strict";
                Wn.d(rt, {
                    AH: ()=>Co.AH,
                    iz: ()=>Co.iz,
                    mN: ()=>b
                });
                var Co = Wn(4161);
                /**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const { is: Dl, defineProperty: Ll, getOwnPropertyDescriptor: Rl, getOwnPropertyNames: Ul, getOwnPropertySymbols: Gl, getPrototypeOf: Zl } = Object, Hl = globalThis, ql = Hl.trustedTypes, Ql = ql ? ql.emptyScript : "", Kl = Hl.reactiveElementPolyfillSupport, d = (Qe, rt)=>Qe, $l = {
                    toAttribute (Qe, rt) {
                        switch(rt){
                            case Boolean:
                                Qe = Qe ? Ql : null;
                                break;
                            case Object:
                            case Array:
                                Qe = null == Qe ? Qe : JSON.stringify(Qe);
                        }
                        return Qe;
                    },
                    fromAttribute (Qe, rt) {
                        let Wn = Qe;
                        switch(rt){
                            case Boolean:
                                Wn = null !== Qe;
                                break;
                            case Number:
                                Wn = null === Qe ? null : Number(Qe);
                                break;
                            case Object:
                            case Array:
                                try {
                                    Wn = JSON.parse(Qe);
                                } catch (Qe) {
                                    Wn = null;
                                }
                        }
                        return Wn;
                    }
                }, f = (Qe, rt)=>!Dl(Qe, rt), Tc = {
                    attribute: !0,
                    type: String,
                    converter: $l,
                    reflect: !1,
                    hasChanged: f
                };
                Symbol.metadata ??= Symbol("metadata"), Hl.litPropertyMetadata ??= new WeakMap;
                class b extends HTMLElement {
                    static addInitializer(Qe) {
                        this._$Ei(), (this.l ??= []).push(Qe);
                    }
                    static get observedAttributes() {
                        return this.finalize(), this._$Eh && [
                            ...this._$Eh.keys()
                        ];
                    }
                    static createProperty(Qe, rt) {
                        if (void 0 === rt && (rt = Tc), rt.state && (rt.attribute = !1), this._$Ei(), this.elementProperties.set(Qe, rt), !rt.noAccessor) {
                            const Wn = Symbol(), Co = this.getPropertyDescriptor(Qe, Wn, rt);
                            void 0 !== Co && Ll(this.prototype, Qe, Co);
                        }
                    }
                    static getPropertyDescriptor(Qe, rt, Wn) {
                        const { get: Co, set: Dl } = Rl(this.prototype, Qe) ?? {
                            get () {
                                return this[rt];
                            },
                            set (Qe) {
                                this[rt] = Qe;
                            }
                        };
                        return {
                            get () {
                                return Co?.call(this);
                            },
                            set (rt) {
                                const Ll = Co?.call(this);
                                Dl.call(this, rt), this.requestUpdate(Qe, Ll, Wn);
                            },
                            configurable: !0,
                            enumerable: !0
                        };
                    }
                    static getPropertyOptions(Qe) {
                        return this.elementProperties.get(Qe) ?? Tc;
                    }
                    static _$Ei() {
                        if (this.hasOwnProperty(d("elementProperties"))) return;
                        const Qe = Zl(this);
                        Qe.finalize(), void 0 !== Qe.l && (this.l = [
                            ...Qe.l
                        ]), this.elementProperties = new Map(Qe.elementProperties);
                    }
                    static finalize() {
                        if (this.hasOwnProperty(d("finalized"))) return;
                        if (this.finalized = !0, this._$Ei(), this.hasOwnProperty(d("properties"))) {
                            const Qe = this.properties, rt = [
                                ...Ul(Qe),
                                ...Gl(Qe)
                            ];
                            for (const Wn of rt)this.createProperty(Wn, Qe[Wn]);
                        }
                        const Qe = this[Symbol.metadata];
                        if (null !== Qe) {
                            const rt = litPropertyMetadata.get(Qe);
                            if (void 0 !== rt) for (const [Qe, Wn] of rt)this.elementProperties.set(Qe, Wn);
                        }
                        this._$Eh = new Map;
                        for (const [rt, Wn] of this.elementProperties){
                            const Qe = this._$Eu(rt, Wn);
                            void 0 !== Qe && this._$Eh.set(Qe, rt);
                        }
                        this.elementStyles = this.finalizeStyles(this.styles);
                    }
                    static finalizeStyles(Qe) {
                        const rt = [];
                        if (Array.isArray(Qe)) {
                            const Wn = new Set(Qe.flat(1 / 0).reverse());
                            for (const Qe of Wn)rt.unshift((0, Co.sk)(Qe));
                        } else void 0 !== Qe && rt.push((0, Co.sk)(Qe));
                        return rt;
                    }
                    static _$Eu(Qe, rt) {
                        const Wn = rt.attribute;
                        return !1 === Wn ? void 0 : "string" == typeof Wn ? Wn : "string" == typeof Qe ? Qe.toLowerCase() : void 0;
                    }
                    constructor(){
                        super(), this._$Ep = void 0, this.isUpdatePending = !1, this.hasUpdated = !1, this._$Em = null, this._$Ev();
                    }
                    _$Ev() {
                        this._$ES = new Promise((Qe)=>this.enableUpdating = Qe), this._$AL = new Map, this._$E_(), this.requestUpdate(), this.constructor.l?.forEach((Qe)=>Qe(this));
                    }
                    addController(Qe) {
                        (this._$EO ??= new Set).add(Qe), void 0 !== this.renderRoot && this.isConnected && Qe.hostConnected?.();
                    }
                    removeController(Qe) {
                        this._$EO?.delete(Qe);
                    }
                    _$E_() {
                        const Qe = new Map, rt = this.constructor.elementProperties;
                        for (const Wn of rt.keys())this.hasOwnProperty(Wn) && (Qe.set(Wn, this[Wn]), delete this[Wn]);
                        Qe.size > 0 && (this._$Ep = Qe);
                    }
                    createRenderRoot() {
                        const Qe = this.shadowRoot ?? this.attachShadow(this.constructor.shadowRootOptions);
                        return (0, Co.Rf)(Qe, this.constructor.elementStyles), Qe;
                    }
                    connectedCallback() {
                        this.renderRoot ??= this.createRenderRoot(), this.enableUpdating(!0), this._$EO?.forEach((Qe)=>Qe.hostConnected?.());
                    }
                    enableUpdating(Qe) {}
                    disconnectedCallback() {
                        this._$EO?.forEach((Qe)=>Qe.hostDisconnected?.());
                    }
                    attributeChangedCallback(Qe, rt, Wn) {
                        this._$AK(Qe, Wn);
                    }
                    _$EC(Qe, rt) {
                        const Wn = this.constructor.elementProperties.get(Qe), Co = this.constructor._$Eu(Qe, Wn);
                        if (void 0 !== Co && !0 === Wn.reflect) {
                            const Dl = (void 0 !== Wn.converter?.toAttribute ? Wn.converter : $l).toAttribute(rt, Wn.type);
                            this._$Em = Qe, null == Dl ? this.removeAttribute(Co) : this.setAttribute(Co, Dl), this._$Em = null;
                        }
                    }
                    _$AK(Qe, rt) {
                        const Wn = this.constructor, Co = Wn._$Eh.get(Qe);
                        if (void 0 !== Co && this._$Em !== Co) {
                            const Qe = Wn.getPropertyOptions(Co), Dl = "function" == typeof Qe.converter ? {
                                fromAttribute: Qe.converter
                            } : void 0 !== Qe.converter?.fromAttribute ? Qe.converter : $l;
                            this._$Em = Co, this[Co] = Dl.fromAttribute(rt, Qe.type), this._$Em = null;
                        }
                    }
                    requestUpdate(Qe, rt, Wn) {
                        if (void 0 !== Qe) {
                            if (Wn ??= this.constructor.getPropertyOptions(Qe), !(Wn.hasChanged ?? f)(this[Qe], rt)) return;
                            this.P(Qe, rt, Wn);
                        }
                        !1 === this.isUpdatePending && (this._$ES = this._$ET());
                    }
                    P(Qe, rt, Wn) {
                        this._$AL.has(Qe) || this._$AL.set(Qe, rt), !0 === Wn.reflect && this._$Em !== Qe && (this._$Ej ??= new Set).add(Qe);
                    }
                    async _$ET() {
                        this.isUpdatePending = !0;
                        try {
                            await this._$ES;
                        } catch (Qe) {
                            Promise.reject(Qe);
                        }
                        const Qe = this.scheduleUpdate();
                        return null != Qe && await Qe, !this.isUpdatePending;
                    }
                    scheduleUpdate() {
                        return this.performUpdate();
                    }
                    performUpdate() {
                        if (!this.isUpdatePending) return;
                        if (!this.hasUpdated) {
                            if (this.renderRoot ??= this.createRenderRoot(), this._$Ep) {
                                for (const [Qe, rt] of this._$Ep)this[Qe] = rt;
                                this._$Ep = void 0;
                            }
                            const Qe = this.constructor.elementProperties;
                            if (Qe.size > 0) for (const [rt, Wn] of Qe)!0 !== Wn.wrapped || this._$AL.has(rt) || void 0 === this[rt] || this.P(rt, this[rt], Wn);
                        }
                        let Qe = !1;
                        const rt = this._$AL;
                        try {
                            Qe = this.shouldUpdate(rt), Qe ? (this.willUpdate(rt), this._$EO?.forEach((Qe)=>Qe.hostUpdate?.()), this.update(rt)) : this._$EU();
                        } catch (rt) {
                            throw Qe = !1, this._$EU(), rt;
                        }
                        Qe && this._$AE(rt);
                    }
                    willUpdate(Qe) {}
                    _$AE(Qe) {
                        this._$EO?.forEach((Qe)=>Qe.hostUpdated?.()), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(Qe)), this.updated(Qe);
                    }
                    _$EU() {
                        this._$AL = new Map, this.isUpdatePending = !1;
                    }
                    get updateComplete() {
                        return this.getUpdateComplete();
                    }
                    getUpdateComplete() {
                        return this._$ES;
                    }
                    shouldUpdate(Qe) {
                        return !0;
                    }
                    update(Qe) {
                        this._$Ej &&= this._$Ej.forEach((Qe)=>this._$EC(Qe, this[Qe])), this._$EU();
                    }
                    updated(Qe) {}
                    firstUpdated(Qe) {}
                }
                b.elementStyles = [], b.shadowRootOptions = {
                    mode: "open"
                }, b[d("elementProperties")] = new Map, b[d("finalized")] = new Map, Kl?.({
                    ReactiveElement: b
                }), (Hl.reactiveElementVersions ??= []).push("2.0.4");
            },
            8983: (Qe, rt, Wn)=>{
                "use strict";
                Wn.d(rt, {
                    c8: ()=>yd
                });
                /**
* (c) Iconify
*
* For the full copyright and license information, please view the license.txt
* files at https://github.com/iconify/iconify
*
* Licensed under MIT.
*
* @license MIT
* @version 3.0.0
*/ const Co = Object.freeze({
                    left: 0,
                    top: 0,
                    width: 16,
                    height: 16
                }), Dl = Object.freeze({
                    rotate: 0,
                    vFlip: !1,
                    hFlip: !1
                }), Ll = Object.freeze({
                    ...Co,
                    ...Dl
                }), Rl = Object.freeze({
                    ...Ll,
                    body: "",
                    hidden: !1
                }), Ul = Object.freeze({
                    width: null,
                    height: null
                }), Gl = Object.freeze({
                    ...Ul,
                    ...Dl
                });
                const Zl = /[\s,]+/;
                const Hl = {
                    ...Gl,
                    preserveAspectRatio: ""
                };
                function getCustomisations(Qe) {
                    const rt = {
                        ...Hl
                    }, attr = (rt, Wn)=>Qe.getAttribute(rt) || Wn;
                    var Wn;
                    return rt.width = attr("width", null), rt.height = attr("height", null), rt.rotate = function(Qe, rt) {
                        void 0 === rt && (rt = 0);
                        const Wn = Qe.replace(/^-?[0-9.]*/, "");
                        function cleanup(Qe) {
                            for(; Qe < 0;)Qe += 4;
                            return Qe % 4;
                        }
                        if ("" === Wn) {
                            const rt = parseInt(Qe);
                            return isNaN(rt) ? 0 : cleanup(rt);
                        }
                        if (Wn !== Qe) {
                            let rt = 0;
                            switch(Wn){
                                case "%":
                                    rt = 25;
                                    break;
                                case "deg":
                                    rt = 90;
                            }
                            if (rt) {
                                let Co = parseFloat(Qe.slice(0, Qe.length - Wn.length));
                                return isNaN(Co) ? 0 : (Co /= rt, Co % 1 === 0 ? cleanup(Co) : 0);
                            }
                        }
                        return rt;
                    }(attr("rotate", "")), Wn = rt, attr("flip", "").split(Zl).forEach((Qe)=>{
                        switch(Qe.trim()){
                            case "horizontal":
                                Wn.hFlip = !0;
                                break;
                            case "vertical":
                                Wn.vFlip = !0;
                        }
                    }), rt.preserveAspectRatio = attr("preserveAspectRatio", attr("preserveaspectratio", "")), rt;
                }
                const ql = /^[a-z0-9]+(-[a-z0-9]+)*$/, stringToIcon = function(Qe, rt, Wn, Co) {
                    void 0 === Co && (Co = "");
                    const Dl = Qe.split(":");
                    if ("@" === Qe.slice(0, 1)) {
                        if (Dl.length < 2 || Dl.length > 3) return null;
                        Co = Dl.shift().slice(1);
                    }
                    if (Dl.length > 3 || !Dl.length) return null;
                    if (Dl.length > 1) {
                        const Qe = Dl.pop(), Wn = Dl.pop(), Ll = {
                            provider: Dl.length > 0 ? Dl[0] : Co,
                            prefix: Wn,
                            name: Qe
                        };
                        return rt && !validateIconName(Ll) ? null : Ll;
                    }
                    const Ll = Dl[0], Rl = Ll.split("-");
                    if (Rl.length > 1) {
                        const Qe = {
                            provider: Co,
                            prefix: Rl.shift(),
                            name: Rl.join("-")
                        };
                        return rt && !validateIconName(Qe) ? null : Qe;
                    }
                    if (Wn && "" === Co) {
                        const Qe = {
                            provider: Co,
                            prefix: "",
                            name: Ll
                        };
                        return rt && !validateIconName(Qe, Wn) ? null : Qe;
                    }
                    return null;
                }, validateIconName = (Qe, rt)=>!!Qe && !(!(rt && "" === Qe.prefix || Qe.prefix) || !Qe.name);
                function mergeIconData(Qe, rt) {
                    const Wn = function(Qe, rt) {
                        const Wn = {};
                        !Qe.hFlip !== !rt.hFlip && (Wn.hFlip = !0), !Qe.vFlip !== !rt.vFlip && (Wn.vFlip = !0);
                        const Co = ((Qe.rotate || 0) + (rt.rotate || 0)) % 4;
                        return Co && (Wn.rotate = Co), Wn;
                    }(Qe, rt);
                    for(const Co in Rl)Co in Dl ? Co in Qe && !(Co in Wn) && (Wn[Co] = Dl[Co]) : Co in rt ? Wn[Co] = rt[Co] : Co in Qe && (Wn[Co] = Qe[Co]);
                    return Wn;
                }
                function internalGetIconData(Qe, rt, Wn) {
                    const Co = Qe.icons, Dl = Qe.aliases || Object.create(null);
                    let Ll = {};
                    function parse(Qe) {
                        Ll = mergeIconData(Co[Qe] || Dl[Qe], Ll);
                    }
                    return parse(rt), Wn.forEach(parse), mergeIconData(Qe, Ll);
                }
                function parseIconSet(Qe, rt) {
                    const Wn = [];
                    if ("object" !== typeof Qe || "object" !== typeof Qe.icons) return Wn;
                    Qe.not_found instanceof Array && Qe.not_found.forEach((Qe)=>{
                        rt(Qe, null), Wn.push(Qe);
                    });
                    const Co = function(Qe) {
                        const rt = Qe.icons, Wn = Qe.aliases || Object.create(null), Co = Object.create(null);
                        return Object.keys(rt).concat(Object.keys(Wn)).forEach(function resolve(Qe) {
                            if (rt[Qe]) return Co[Qe] = [];
                            if (!(Qe in Co)) {
                                Co[Qe] = null;
                                const rt = Wn[Qe] && Wn[Qe].parent, Dl = rt && resolve(rt);
                                Dl && (Co[Qe] = [
                                    rt
                                ].concat(Dl));
                            }
                            return Co[Qe];
                        }), Co;
                    }(Qe);
                    for(const Dl in Co){
                        const Ll = Co[Dl];
                        Ll && (rt(Dl, internalGetIconData(Qe, Dl, Ll)), Wn.push(Dl));
                    }
                    return Wn;
                }
                const Ql = {
                    provider: "",
                    aliases: {},
                    not_found: {},
                    ...Co
                };
                function checkOptionalProps(Qe, rt) {
                    for(const Wn in rt)if (Wn in Qe && typeof Qe[Wn] !== typeof rt[Wn]) return !1;
                    return !0;
                }
                function quicklyValidateIconSet(Qe) {
                    if ("object" !== typeof Qe || null === Qe) return null;
                    const rt = Qe;
                    if ("string" !== typeof rt.prefix || !Qe.icons || "object" !== typeof Qe.icons) return null;
                    if (!checkOptionalProps(Qe, Ql)) return null;
                    const Wn = rt.icons;
                    for(const Dl in Wn){
                        const Qe = Wn[Dl];
                        if (!Dl || "string" !== typeof Qe.body || !checkOptionalProps(Qe, Rl)) return null;
                    }
                    const Co = rt.aliases || Object.create(null);
                    for(const Dl in Co){
                        const Qe = Co[Dl], rt = Qe.parent;
                        if (!Dl || "string" !== typeof rt || !Wn[rt] && !Co[rt] || !checkOptionalProps(Qe, Rl)) return null;
                    }
                    return rt;
                }
                const Kl = Object.create(null);
                function getStorage(Qe, rt) {
                    const Wn = Kl[Qe] || (Kl[Qe] = Object.create(null));
                    return Wn[rt] || (Wn[rt] = function(Qe, rt) {
                        return {
                            provider: Qe,
                            prefix: rt,
                            icons: Object.create(null),
                            missing: new Set
                        };
                    }(Qe, rt));
                }
                function addIconSet(Qe, rt) {
                    return quicklyValidateIconSet(rt) ? parseIconSet(rt, (rt, Wn)=>{
                        Wn ? Qe.icons[rt] = Wn : Qe.missing.add(rt);
                    }) : [];
                }
                function listIcons$1(Qe, rt) {
                    let Wn = [];
                    return ("string" === typeof Qe ? [
                        Qe
                    ] : Object.keys(Kl)).forEach((Qe)=>{
                        ("string" === typeof Qe && "string" === typeof rt ? [
                            rt
                        ] : Object.keys(Kl[Qe] || {})).forEach((rt)=>{
                            const Co = getStorage(Qe, rt);
                            Wn = Wn.concat(Object.keys(Co.icons).map((Wn)=>("" !== Qe ? "@" + Qe + ":" : "") + rt + ":" + Wn));
                        });
                    }), Wn;
                }
                let $l = !1;
                function allowSimpleNames(Qe) {
                    return "boolean" === typeof Qe && ($l = Qe), $l;
                }
                function getIconData(Qe) {
                    const rt = "string" === typeof Qe ? stringToIcon(Qe, !0, $l) : Qe;
                    if (rt) {
                        const Qe = getStorage(rt.provider, rt.prefix), Wn = rt.name;
                        return Qe.icons[Wn] || (Qe.missing.has(Wn) ? null : void 0);
                    }
                }
                function addIcon$1(Qe, rt) {
                    const Wn = stringToIcon(Qe, !0, $l);
                    if (!Wn) return !1;
                    const Co = getStorage(Wn.provider, Wn.prefix);
                    return rt ? function(Qe, rt, Wn) {
                        try {
                            if ("string" === typeof Wn.body) return Qe.icons[rt] = {
                                ...Wn
                            }, !0;
                        } catch (Co) {}
                        return !1;
                    }(Co, Wn.name, rt) : (Co.missing.add(Wn.name), !0);
                }
                function addCollection$1(Qe, rt) {
                    if ("object" !== typeof Qe) return !1;
                    if ("string" !== typeof rt && (rt = Qe.provider || ""), $l && !rt && !Qe.prefix) {
                        let rt = !1;
                        return quicklyValidateIconSet(Qe) && (Qe.prefix = "", parseIconSet(Qe, (Qe, Wn)=>{
                            addIcon$1(Qe, Wn) && (rt = !0);
                        })), rt;
                    }
                    const Wn = Qe.prefix;
                    if (!validateIconName({
                        prefix: Wn,
                        name: "a"
                    })) return !1;
                    return !!addIconSet(getStorage(rt, Wn), Qe);
                }
                function iconLoaded$1(Qe) {
                    return !!getIconData(Qe);
                }
                function getIcon$1(Qe) {
                    const rt = getIconData(Qe);
                    return rt ? {
                        ...Ll,
                        ...rt
                    } : rt;
                }
                function removeCallback(Qe, rt) {
                    Qe.forEach((Qe)=>{
                        const Wn = Qe.loaderCallbacks;
                        Wn && (Qe.loaderCallbacks = Wn.filter((Qe)=>Qe.id !== rt));
                    });
                }
                let Tc = 0;
                const tu = Object.create(null);
                function setAPIModule(Qe, rt) {
                    tu[Qe] = rt;
                }
                function getAPIModule(Qe) {
                    return tu[Qe] || tu[""];
                }
                var lu = {
                    resources: [],
                    index: 0,
                    timeout: 2e3,
                    rotate: 750,
                    random: !1,
                    dataAfterTimeout: !1
                };
                function sendQuery(Qe, rt, Wn, Co) {
                    const Dl = Qe.resources.length, Ll = Qe.random ? Math.floor(Math.random() * Dl) : Qe.index;
                    let Rl;
                    if (Qe.random) {
                        let rt = Qe.resources.slice(0);
                        for(Rl = []; rt.length > 1;){
                            const Qe = Math.floor(Math.random() * rt.length);
                            Rl.push(rt[Qe]), rt = rt.slice(0, Qe).concat(rt.slice(Qe + 1));
                        }
                        Rl = Rl.concat(rt);
                    } else Rl = Qe.resources.slice(Ll).concat(Qe.resources.slice(0, Ll));
                    const Ul = Date.now();
                    let Gl, Zl = "pending", Hl = 0, ql = null, Ql = [], Kl = [];
                    function resetTimer() {
                        ql && (clearTimeout(ql), ql = null);
                    }
                    function abort() {
                        "pending" === Zl && (Zl = "aborted"), resetTimer(), Ql.forEach((Qe)=>{
                            "pending" === Qe.status && (Qe.status = "aborted");
                        }), Ql = [];
                    }
                    function subscribe(Qe, rt) {
                        rt && (Kl = []), "function" === typeof Qe && Kl.push(Qe);
                    }
                    function failQuery() {
                        Zl = "failed", Kl.forEach((Qe)=>{
                            Qe(void 0, Gl);
                        });
                    }
                    function clearQueue() {
                        Ql.forEach((Qe)=>{
                            "pending" === Qe.status && (Qe.status = "aborted");
                        }), Ql = [];
                    }
                    function execNext() {
                        if ("pending" !== Zl) return;
                        resetTimer();
                        const Co = Rl.shift();
                        if (void 0 === Co) return Ql.length ? void (ql = setTimeout(()=>{
                            resetTimer(), "pending" === Zl && (clearQueue(), failQuery());
                        }, Qe.timeout)) : void failQuery();
                        const Dl = {
                            status: "pending",
                            resource: Co,
                            callback: (rt, Wn)=>{
                                !function(rt, Wn, Co) {
                                    const Dl = "success" !== Wn;
                                    switch(Ql = Ql.filter((Qe)=>Qe !== rt), Zl){
                                        case "pending":
                                            break;
                                        case "failed":
                                            if (Dl || !Qe.dataAfterTimeout) return;
                                            break;
                                        default:
                                            return;
                                    }
                                    if ("abort" === Wn) return Gl = Co, void failQuery();
                                    if (Dl) return Gl = Co, void (Ql.length || (Rl.length ? execNext() : failQuery()));
                                    if (resetTimer(), clearQueue(), !Qe.random) {
                                        const Wn = Qe.resources.indexOf(rt.resource);
                                        -1 !== Wn && Wn !== Qe.index && (Qe.index = Wn);
                                    }
                                    Zl = "completed", Kl.forEach((Qe)=>{
                                        Qe(Co);
                                    });
                                }(Dl, rt, Wn);
                            }
                        };
                        Ql.push(Dl), Hl++, ql = setTimeout(execNext, Qe.rotate), Wn(Co, rt, Dl.callback);
                    }
                    return "function" === typeof Co && Kl.push(Co), setTimeout(execNext), function() {
                        return {
                            startTime: Ul,
                            payload: rt,
                            status: Zl,
                            queriesSent: Hl,
                            queriesPending: Ql.length,
                            subscribe: subscribe,
                            abort: abort
                        };
                    };
                }
                function initRedundancy(Qe) {
                    const rt = {
                        ...lu,
                        ...Qe
                    };
                    let Wn = [];
                    function cleanup() {
                        Wn = Wn.filter((Qe)=>"pending" === Qe().status);
                    }
                    return {
                        query: function(Qe, Co, Dl) {
                            const Ll = sendQuery(rt, Qe, Co, (Qe, rt)=>{
                                cleanup(), Dl && Dl(Qe, rt);
                            });
                            return Wn.push(Ll), Ll;
                        },
                        find: function(Qe) {
                            return Wn.find((rt)=>Qe(rt)) || null;
                        },
                        setIndex: (Qe)=>{
                            rt.index = Qe;
                        },
                        getIndex: ()=>rt.index,
                        cleanup: cleanup
                    };
                }
                function createAPIConfig(Qe) {
                    let rt;
                    if ("string" === typeof Qe.resources) rt = [
                        Qe.resources
                    ];
                    else if (rt = Qe.resources, !(rt instanceof Array) || !rt.length) return null;
                    return {
                        resources: rt,
                        path: Qe.path || "/",
                        maxURL: Qe.maxURL || 500,
                        rotate: Qe.rotate || 750,
                        timeout: Qe.timeout || 5e3,
                        random: !0 === Qe.random,
                        index: Qe.index || 0,
                        dataAfterTimeout: !1 !== Qe.dataAfterTimeout
                    };
                }
                const du = Object.create(null), fu = [
                    "https://api.simplesvg.com",
                    "https://api.unisvg.com"
                ], yu = [];
                for(; fu.length > 0;)1 === fu.length || Math.random() > .5 ? yu.push(fu.shift()) : yu.push(fu.pop());
                function addAPIProvider$1(Qe, rt) {
                    const Wn = createAPIConfig(rt);
                    return null !== Wn && (du[Qe] = Wn, !0);
                }
                function getAPIConfig(Qe) {
                    return du[Qe];
                }
                function listAPIProviders() {
                    return Object.keys(du);
                }
                function emptyCallback$1() {}
                du[""] = createAPIConfig({
                    resources: [
                        "https://api.iconify.design"
                    ].concat(yu)
                });
                const Eu = Object.create(null);
                function sendAPIQuery(Qe, rt, Wn) {
                    let Co, Dl;
                    if ("string" === typeof Qe) {
                        const rt = getAPIModule(Qe);
                        if (!rt) return Wn(void 0, 424), emptyCallback$1;
                        Dl = rt.send;
                        const Ll = function(Qe) {
                            if (!Eu[Qe]) {
                                const rt = getAPIConfig(Qe);
                                if (!rt) return;
                                const Wn = {
                                    config: rt,
                                    redundancy: initRedundancy(rt)
                                };
                                Eu[Qe] = Wn;
                            }
                            return Eu[Qe];
                        }(Qe);
                        Ll && (Co = Ll.redundancy);
                    } else {
                        const rt = createAPIConfig(Qe);
                        if (rt) {
                            Co = initRedundancy(rt);
                            const Wn = getAPIModule(Qe.resources ? Qe.resources[0] : "");
                            Wn && (Dl = Wn.send);
                        }
                    }
                    return Co && Dl ? Co.query(rt, Dl, Wn)().abort : (Wn(void 0, 424), emptyCallback$1);
                }
                function emptyCallback() {}
                function loadedNewIcons(Qe) {
                    Qe.iconsLoaderFlag || (Qe.iconsLoaderFlag = !0, setTimeout(()=>{
                        Qe.iconsLoaderFlag = !1, function(Qe) {
                            Qe.pendingCallbacksFlag || (Qe.pendingCallbacksFlag = !0, setTimeout(()=>{
                                Qe.pendingCallbacksFlag = !1;
                                const rt = Qe.loaderCallbacks ? Qe.loaderCallbacks.slice(0) : [];
                                if (!rt.length) return;
                                let Wn = !1;
                                const Co = Qe.provider, Dl = Qe.prefix;
                                rt.forEach((rt)=>{
                                    const Ll = rt.icons, Rl = Ll.pending.length;
                                    Ll.pending = Ll.pending.filter((rt)=>{
                                        if (rt.prefix !== Dl) return !0;
                                        const Rl = rt.name;
                                        if (Qe.icons[Rl]) Ll.loaded.push({
                                            provider: Co,
                                            prefix: Dl,
                                            name: Rl
                                        });
                                        else {
                                            if (!Qe.missing.has(Rl)) return Wn = !0, !0;
                                            Ll.missing.push({
                                                provider: Co,
                                                prefix: Dl,
                                                name: Rl
                                            });
                                        }
                                        return !1;
                                    }), Ll.pending.length !== Rl && (Wn || removeCallback([
                                        Qe
                                    ], rt.id), rt.callback(Ll.loaded.slice(0), Ll.missing.slice(0), Ll.pending.slice(0), rt.abort));
                                });
                            }));
                        }(Qe);
                    }));
                }
                function parseLoaderResponse(Qe, rt, Wn) {
                    function checkMissing() {
                        const Wn = Qe.pendingIcons;
                        rt.forEach((rt)=>{
                            Wn && Wn.delete(rt), Qe.icons[rt] || Qe.missing.add(rt);
                        });
                    }
                    if (Wn && "object" === typeof Wn) try {
                        if (!addIconSet(Qe, Wn).length) return void checkMissing();
                    } catch (Co) {
                        console.error(Co);
                    }
                    checkMissing(), loadedNewIcons(Qe);
                }
                function parsePossiblyAsyncResponse(Qe, rt) {
                    Qe instanceof Promise ? Qe.then((Qe)=>{
                        rt(Qe);
                    }).catch(()=>{
                        rt(null);
                    }) : rt(Qe);
                }
                function loadNewIcons(Qe, rt) {
                    Qe.iconsToLoad ? Qe.iconsToLoad = Qe.iconsToLoad.concat(rt).sort() : Qe.iconsToLoad = rt, Qe.iconsQueueFlag || (Qe.iconsQueueFlag = !0, setTimeout(()=>{
                        Qe.iconsQueueFlag = !1;
                        const { provider: rt, prefix: Wn } = Qe, Co = Qe.iconsToLoad;
                        if (delete Qe.iconsToLoad, !Co || !Co.length) return;
                        const Dl = Qe.loadIcon;
                        if (Qe.loadIcons && (Co.length > 1 || !Dl)) return void parsePossiblyAsyncResponse(Qe.loadIcons(Co, Wn, rt), (rt)=>{
                            parseLoaderResponse(Qe, Co, rt);
                        });
                        if (Dl) return void Co.forEach((Co)=>{
                            parsePossiblyAsyncResponse(Dl(Co, Wn, rt), (rt)=>{
                                parseLoaderResponse(Qe, [
                                    Co
                                ], rt ? {
                                    prefix: Wn,
                                    icons: {
                                        [Co]: rt
                                    }
                                } : null);
                            });
                        });
                        const { valid: Ll, invalid: Rl } = function(Qe) {
                            const rt = [], Wn = [];
                            return Qe.forEach((Qe)=>{
                                (Qe.match(ql) ? rt : Wn).push(Qe);
                            }), {
                                valid: rt,
                                invalid: Wn
                            };
                        }(Co);
                        if (Rl.length && parseLoaderResponse(Qe, Rl, null), !Ll.length) return;
                        const Ul = Wn.match(ql) ? getAPIModule(rt) : null;
                        if (!Ul) return void parseLoaderResponse(Qe, Ll, null);
                        Ul.prepare(rt, Wn, Ll).forEach((Wn)=>{
                            sendAPIQuery(rt, Wn, (rt)=>{
                                parseLoaderResponse(Qe, Wn.icons, rt);
                            });
                        });
                    }));
                }
                const loadIcons$1 = (Qe, rt)=>{
                    const Wn = function(Qe, rt, Wn) {
                        void 0 === rt && (rt = !0), void 0 === Wn && (Wn = !1);
                        const Co = [];
                        return Qe.forEach((Qe)=>{
                            const Dl = "string" === typeof Qe ? stringToIcon(Qe, rt, Wn) : Qe;
                            Dl && Co.push(Dl);
                        }), Co;
                    }(Qe, !0, allowSimpleNames()), Co = function(Qe) {
                        const rt = {
                            loaded: [],
                            missing: [],
                            pending: []
                        }, Wn = Object.create(null);
                        Qe.sort((Qe, rt)=>Qe.provider !== rt.provider ? Qe.provider.localeCompare(rt.provider) : Qe.prefix !== rt.prefix ? Qe.prefix.localeCompare(rt.prefix) : Qe.name.localeCompare(rt.name));
                        let Co = {
                            provider: "",
                            prefix: "",
                            name: ""
                        };
                        return Qe.forEach((Qe)=>{
                            if (Co.name === Qe.name && Co.prefix === Qe.prefix && Co.provider === Qe.provider) return;
                            Co = Qe;
                            const Dl = Qe.provider, Ll = Qe.prefix, Rl = Qe.name, Ul = Wn[Dl] || (Wn[Dl] = Object.create(null)), Gl = Ul[Ll] || (Ul[Ll] = getStorage(Dl, Ll));
                            let Zl;
                            Zl = Rl in Gl.icons ? rt.loaded : "" === Ll || Gl.missing.has(Rl) ? rt.missing : rt.pending;
                            const Hl = {
                                provider: Dl,
                                prefix: Ll,
                                name: Rl
                            };
                            Zl.push(Hl);
                        }), rt;
                    }(Wn);
                    if (!Co.pending.length) {
                        let Qe = !0;
                        return rt && setTimeout(()=>{
                            Qe && rt(Co.loaded, Co.missing, Co.pending, emptyCallback);
                        }), ()=>{
                            Qe = !1;
                        };
                    }
                    const Dl = Object.create(null), Ll = [];
                    let Rl, Ul;
                    return Co.pending.forEach((Qe)=>{
                        const { provider: rt, prefix: Wn } = Qe;
                        if (Wn === Ul && rt === Rl) return;
                        Rl = rt, Ul = Wn, Ll.push(getStorage(rt, Wn));
                        const Co = Dl[rt] || (Dl[rt] = Object.create(null));
                        Co[Wn] || (Co[Wn] = []);
                    }), Co.pending.forEach((Qe)=>{
                        const { provider: rt, prefix: Wn, name: Co } = Qe, Ll = getStorage(rt, Wn), Rl = Ll.pendingIcons || (Ll.pendingIcons = new Set);
                        Rl.has(Co) || (Rl.add(Co), Dl[rt][Wn].push(Co));
                    }), Ll.forEach((Qe)=>{
                        const rt = Dl[Qe.provider][Qe.prefix];
                        rt.length && loadNewIcons(Qe, rt);
                    }), rt ? function(Qe, rt, Wn) {
                        const Co = Tc++, Dl = removeCallback.bind(null, Wn, Co);
                        if (!rt.pending.length) return Dl;
                        const Ll = {
                            id: Co,
                            icons: rt,
                            callback: Qe,
                            abort: Dl
                        };
                        return Wn.forEach((Qe)=>{
                            (Qe.loaderCallbacks || (Qe.loaderCallbacks = [])).push(Ll);
                        }), Dl;
                    }(rt, Co, Ll) : emptyCallback;
                }, loadIcon$1 = (Qe)=>new Promise((rt, Wn)=>{
                        const Co = "string" === typeof Qe ? stringToIcon(Qe, !0) : Qe;
                        Co ? loadIcons$1([
                            Co || Qe
                        ], (Dl)=>{
                            if (Dl.length && Co) {
                                const Qe = getIconData(Co);
                                if (Qe) return void rt({
                                    ...Ll,
                                    ...Qe
                                });
                            }
                            Wn(Qe);
                        }) : Wn(Qe);
                    });
                function testIconObject(Qe) {
                    try {
                        const rt = "string" === typeof Qe ? JSON.parse(Qe) : Qe;
                        if ("string" === typeof rt.body) return {
                            ...rt
                        };
                    } catch (rt) {}
                }
                let Tu = !1;
                try {
                    Tu = 0 === navigator.vendor.indexOf("Apple");
                } catch (bd) {}
                const Lu = /(-?[0-9.]*[0-9]+[0-9.]*)/g, Zu = /^-?[0-9.]*[0-9]+[0-9.]*$/g;
                function calculateSize$1(Qe, rt, Wn) {
                    if (1 === rt) return Qe;
                    if (Wn = Wn || 100, "number" === typeof Qe) return Math.ceil(Qe * rt * Wn) / Wn;
                    if ("string" !== typeof Qe) return Qe;
                    const Co = Qe.split(Lu);
                    if (null === Co || !Co.length) return Qe;
                    const Dl = [];
                    let Ll = Co.shift(), Rl = Zu.test(Ll);
                    for(;;){
                        if (Rl) {
                            const Qe = parseFloat(Ll);
                            isNaN(Qe) ? Dl.push(Ll) : Dl.push(Math.ceil(Qe * rt * Wn) / Wn);
                        } else Dl.push(Ll);
                        if (Ll = Co.shift(), void 0 === Ll) return Dl.join("");
                        Rl = !Rl;
                    }
                }
                function iconToSVG(Qe, rt) {
                    const Wn = {
                        ...Ll,
                        ...Qe
                    }, Co = {
                        ...Gl,
                        ...rt
                    }, Dl = {
                        left: Wn.left,
                        top: Wn.top,
                        width: Wn.width,
                        height: Wn.height
                    };
                    let Rl = Wn.body;
                    [
                        Wn,
                        Co
                    ].forEach((Qe)=>{
                        const rt = [], Wn = Qe.hFlip, Co = Qe.vFlip;
                        let Ll, Ul = Qe.rotate;
                        switch(Wn ? Co ? Ul += 2 : (rt.push("translate(" + (Dl.width + Dl.left).toString() + " " + (0 - Dl.top).toString() + ")"), rt.push("scale(-1 1)"), Dl.top = Dl.left = 0) : Co && (rt.push("translate(" + (0 - Dl.left).toString() + " " + (Dl.height + Dl.top).toString() + ")"), rt.push("scale(1 -1)"), Dl.top = Dl.left = 0), Ul < 0 && (Ul -= 4 * Math.floor(Ul / 4)), Ul %= 4, Ul){
                            case 1:
                                Ll = Dl.height / 2 + Dl.top, rt.unshift("rotate(90 " + Ll.toString() + " " + Ll.toString() + ")");
                                break;
                            case 2:
                                rt.unshift("rotate(180 " + (Dl.width / 2 + Dl.left).toString() + " " + (Dl.height / 2 + Dl.top).toString() + ")");
                                break;
                            case 3:
                                Ll = Dl.width / 2 + Dl.left, rt.unshift("rotate(-90 " + Ll.toString() + " " + Ll.toString() + ")");
                        }
                        Ul % 2 === 1 && (Dl.left !== Dl.top && (Ll = Dl.left, Dl.left = Dl.top, Dl.top = Ll), Dl.width !== Dl.height && (Ll = Dl.width, Dl.width = Dl.height, Dl.height = Ll)), rt.length && (Rl = function(Qe, rt, Wn) {
                            const Co = function(Qe, rt) {
                                void 0 === rt && (rt = "defs");
                                let Wn = "";
                                const Co = Qe.indexOf("<" + rt);
                                for(; Co >= 0;){
                                    const Dl = Qe.indexOf(">", Co), Ll = Qe.indexOf("</" + rt);
                                    if (-1 === Dl || -1 === Ll) break;
                                    const Rl = Qe.indexOf(">", Ll);
                                    if (-1 === Rl) break;
                                    Wn += Qe.slice(Dl + 1, Ll).trim(), Qe = Qe.slice(0, Co).trim() + Qe.slice(Rl + 1);
                                }
                                return {
                                    defs: Wn,
                                    content: Qe
                                };
                            }(Qe);
                            var Dl, Ll;
                            return Dl = Co.defs, Ll = rt + Co.content + Wn, Dl ? "<defs>" + Dl + "</defs>" + Ll : Ll;
                        }(Rl, '<g transform="' + rt.join(" ") + '">', "</g>"));
                    });
                    const Ul = Co.width, Zl = Co.height, Hl = Dl.width, ql = Dl.height;
                    let Ql, Kl;
                    null === Ul ? (Kl = null === Zl ? "1em" : "auto" === Zl ? ql : Zl, Ql = calculateSize$1(Kl, Hl / ql)) : (Ql = "auto" === Ul ? Hl : Ul, Kl = null === Zl ? calculateSize$1(Ql, ql / Hl) : "auto" === Zl ? ql : Zl);
                    const $l = {}, setAttr = (Qe, rt)=>{
                        ((Qe)=>"unset" === Qe || "undefined" === Qe || "none" === Qe)(rt) || ($l[Qe] = rt.toString());
                    };
                    setAttr("width", Ql), setAttr("height", Kl);
                    const Tc = [
                        Dl.left,
                        Dl.top,
                        Hl,
                        ql
                    ];
                    return $l.viewBox = Tc.join(" "), {
                        attributes: $l,
                        viewBox: Tc,
                        body: Rl
                    };
                }
                function iconToHTML$1(Qe, rt) {
                    let Wn = -1 === Qe.indexOf("xlink:") ? "" : ' xmlns:xlink="http://www.w3.org/1999/xlink"';
                    for(const Co in rt)Wn += " " + Co + '="' + rt[Co] + '"';
                    return '<svg xmlns="http://www.w3.org/2000/svg"' + Wn + ">" + Qe + "</svg>";
                }
                function svgToURL$1(Qe) {
                    return 'url("' + function(Qe) {
                        return "data:image/svg+xml," + function(Qe) {
                            return Qe.replace(/"/g, "'").replace(/%/g, "%25").replace(/#/g, "%23").replace(/</g, "%3C").replace(/>/g, "%3E").replace(/\s+/g, " ");
                        }(Qe);
                    }(Qe) + '")';
                }
                let Xu = (()=>{
                    let Qe;
                    try {
                        if (Qe = fetch, "function" === typeof Qe) return Qe;
                    } catch (bd) {}
                })();
                function setFetch(Qe) {
                    Xu = Qe;
                }
                function getFetch() {
                    return Xu;
                }
                const Ju = {
                    prepare: (Qe, rt, Wn)=>{
                        const Co = [], Dl = function(Qe, rt) {
                            const Wn = getAPIConfig(Qe);
                            if (!Wn) return 0;
                            let Co;
                            if (Wn.maxURL) {
                                let Qe = 0;
                                Wn.resources.forEach((rt)=>{
                                    const Wn = rt;
                                    Qe = Math.max(Qe, Wn.length);
                                });
                                const Dl = rt + ".json?icons=";
                                Co = Wn.maxURL - Qe - Wn.path.length - Dl.length;
                            } else Co = 0;
                            return Co;
                        }(Qe, rt), Ll = "icons";
                        let Rl = {
                            type: Ll,
                            provider: Qe,
                            prefix: rt,
                            icons: []
                        }, Ul = 0;
                        return Wn.forEach((Wn, Gl)=>{
                            Ul += Wn.length + 1, Ul >= Dl && Gl > 0 && (Co.push(Rl), Rl = {
                                type: Ll,
                                provider: Qe,
                                prefix: rt,
                                icons: []
                            }, Ul = Wn.length), Rl.icons.push(Wn);
                        }), Co.push(Rl), Co;
                    },
                    send: (Qe, rt, Wn)=>{
                        if (!Xu) return void Wn("abort", 424);
                        let Co = function(Qe) {
                            if ("string" === typeof Qe) {
                                const rt = getAPIConfig(Qe);
                                if (rt) return rt.path;
                            }
                            return "/";
                        }(rt.provider);
                        switch(rt.type){
                            case "icons":
                                {
                                    const Qe = rt.prefix, Wn = rt.icons.join(",");
                                    Co += Qe + ".json?" + new URLSearchParams({
                                        icons: Wn
                                    }).toString();
                                    break;
                                }
                            case "custom":
                                {
                                    const Qe = rt.uri;
                                    Co += "/" === Qe.slice(0, 1) ? Qe.slice(1) : Qe;
                                    break;
                                }
                            default:
                                return void Wn("abort", 400);
                        }
                        let Dl = 503;
                        Xu(Qe + Co).then((Qe)=>{
                            const rt = Qe.status;
                            if (200 === rt) return Dl = 501, Qe.json();
                            setTimeout(()=>{
                                Wn(function(Qe) {
                                    return 404 === Qe;
                                }(rt) ? "abort" : "next", rt);
                            });
                        }).then((Qe)=>{
                            "object" === typeof Qe && null !== Qe ? setTimeout(()=>{
                                Wn("success", Qe);
                            }) : setTimeout(()=>{
                                404 === Qe ? Wn("abort", Qe) : Wn("next", Dl);
                            });
                        }).catch(()=>{
                            Wn("next", Dl);
                        });
                    }
                };
                function setCustomIconsLoader$1(Qe, rt, Wn) {
                    getStorage(Wn || "", rt).loadIcons = Qe;
                }
                function setCustomIconLoader$1(Qe, rt, Wn) {
                    getStorage(Wn || "", rt).loadIcon = Qe;
                }
                const $u = "data-style";
                let ed = "";
                function appendCustomStyle(Qe) {
                    ed = Qe;
                }
                function updateStyle(Qe, rt) {
                    let Wn = Array.from(Qe.childNodes).find((Qe)=>Qe.hasAttribute && Qe.hasAttribute($u));
                    Wn || (Wn = document.createElement("style"), Wn.setAttribute($u, $u), Qe.appendChild(Wn)), Wn.textContent = ":host{display:inline-block;vertical-align:" + (rt ? "-0.125em" : "0") + "}span,svg{display:block;margin:auto}" + ed;
                }
                function exportFunctions() {
                    let Qe;
                    setAPIModule("", Ju), allowSimpleNames(!0);
                    try {
                        Qe = window;
                    } catch (bd) {}
                    if (Qe) {
                        if (void 0 !== Qe.IconifyPreload) {
                            const rt = Qe.IconifyPreload, Wn = "Invalid IconifyPreload syntax.";
                            "object" === typeof rt && null !== rt && (rt instanceof Array ? rt : [
                                rt
                            ]).forEach((Qe)=>{
                                try {
                                    ("object" !== typeof Qe || null === Qe || Qe instanceof Array || "object" !== typeof Qe.icons || "string" !== typeof Qe.prefix || !addCollection$1(Qe)) && console.error(Wn);
                                } catch (rt) {
                                    console.error(Wn);
                                }
                            });
                        }
                        if (void 0 !== Qe.IconifyProviders) {
                            const Wn = Qe.IconifyProviders;
                            if ("object" === typeof Wn && null !== Wn) for(const Qe in Wn){
                                const Co = "IconifyProviders[" + Qe + "] is invalid.";
                                try {
                                    const rt = Wn[Qe];
                                    if ("object" !== typeof rt || !rt || void 0 === rt.resources) continue;
                                    addAPIProvider$1(Qe, rt) || console.error(Co);
                                } catch (rt) {
                                    console.error(Co);
                                }
                            }
                        }
                    }
                    return {
                        iconLoaded: iconLoaded$1,
                        getIcon: getIcon$1,
                        listIcons: listIcons$1,
                        addIcon: addIcon$1,
                        addCollection: addCollection$1,
                        calculateSize: calculateSize$1,
                        buildIcon: iconToSVG,
                        iconToHTML: iconToHTML$1,
                        svgToURL: svgToURL$1,
                        loadIcons: loadIcons$1,
                        loadIcon: loadIcon$1,
                        addAPIProvider: addAPIProvider$1,
                        setCustomIconLoader: setCustomIconLoader$1,
                        setCustomIconsLoader: setCustomIconsLoader$1,
                        appendCustomStyle: appendCustomStyle,
                        _api: {
                            getAPIConfig: getAPIConfig,
                            setAPIModule: setAPIModule,
                            sendAPIQuery: sendAPIQuery,
                            setFetch: setFetch,
                            getFetch: getFetch,
                            listAPIProviders: listAPIProviders
                        }
                    };
                }
                const td = {
                    "background-color": "currentColor"
                }, id = {
                    "background-color": "transparent"
                }, nd = {
                    image: "var(--svg)",
                    repeat: "no-repeat",
                    size: "100% 100%"
                }, rd = {
                    "-webkit-mask": td,
                    mask: td,
                    background: id
                };
                for(const wd in rd){
                    const Qe = rd[wd];
                    for(const rt in nd)Qe[wd + "-" + rt] = nd[rt];
                }
                function fixSize(Qe) {
                    return Qe ? Qe + (Qe.match(/^[-0-9.]+$/) ? "px" : "") : "inherit";
                }
                let sd;
                function cleanUpInnerHTML(Qe) {
                    return void 0 === sd && function() {
                        try {
                            sd = window.trustedTypes.createPolicy("iconify", {
                                createHTML: (Qe)=>Qe
                            });
                        } catch (bd) {
                            sd = null;
                        }
                    }(), sd ? sd.createHTML(Qe) : Qe;
                }
                function findIconElement(Qe) {
                    return Array.from(Qe.childNodes).find((Qe)=>{
                        const rt = Qe.tagName && Qe.tagName.toUpperCase();
                        return "SPAN" === rt || "SVG" === rt;
                    });
                }
                function renderIcon(Qe, rt) {
                    const Wn = rt.icon.data, Co = rt.customisations, Dl = iconToSVG(Wn, Co);
                    Co.preserveAspectRatio && (Dl.attributes.preserveAspectRatio = Co.preserveAspectRatio);
                    const Rl = rt.renderedMode;
                    let Ul;
                    if ("svg" === Rl) Ul = function(Qe) {
                        const rt = document.createElement("span"), Wn = Qe.attributes;
                        let Co = "";
                        Wn.width || (Co = "width: inherit;"), Wn.height || (Co += "height: inherit;"), Co && (Wn.style = Co);
                        const Dl = iconToHTML$1(Qe.body, Wn);
                        return rt.innerHTML = cleanUpInnerHTML(Dl), rt.firstChild;
                    }(Dl);
                    else Ul = function(Qe, rt, Wn) {
                        const Co = document.createElement("span");
                        let Dl = Qe.body;
                        -1 !== Dl.indexOf("<a") && (Dl += "<!-- " + Date.now() + " -->");
                        const Ll = Qe.attributes, Rl = svgToURL$1(iconToHTML$1(Dl, {
                            ...Ll,
                            width: rt.width + "",
                            height: rt.height + ""
                        })), Ul = Co.style, Gl = {
                            "--svg": Rl,
                            width: fixSize(Ll.width),
                            height: fixSize(Ll.height),
                            ...Wn ? td : id
                        };
                        for(const Zl in Gl)Ul.setProperty(Zl, Gl[Zl]);
                        return Co;
                    }(Dl, {
                        ...Ll,
                        ...Wn
                    }, "mask" === Rl);
                    const Gl = findIconElement(Qe);
                    Gl ? "SPAN" === Ul.tagName && Gl.tagName === Ul.tagName ? Gl.setAttribute("style", Ul.getAttribute("style")) : Qe.replaceChild(Ul, Gl) : Qe.appendChild(Ul);
                }
                function setPendingState(Qe, rt, Wn) {
                    return {
                        rendered: !1,
                        inline: rt,
                        icon: Qe,
                        lastRender: Wn && (Wn.rendered ? Wn : Wn.lastRender)
                    };
                }
                const ad = function(Qe) {
                    let rt, Wn;
                    void 0 === Qe && (Qe = "iconify-icon");
                    try {
                        rt = window.customElements, Wn = window.HTMLElement;
                    } catch (bd) {
                        return;
                    }
                    if (!rt || !Wn) return;
                    const Co = rt.get(Qe);
                    if (Co) return Co;
                    const Dl = [
                        "icon",
                        "mode",
                        "inline",
                        "noobserver",
                        "width",
                        "height",
                        "rotate",
                        "flip"
                    ], Ll = class extends Wn {
                        constructor(){
                            super(), this._shadowRoot = void 0, this._initialised = !1, this._state = void 0, this._checkQueued = !1, this._connected = !1, this._observer = null, this._visible = !0;
                            const Qe = this._shadowRoot = this.attachShadow({
                                mode: "open"
                            }), rt = this.hasAttribute("inline");
                            updateStyle(Qe, rt), this._state = setPendingState({
                                value: ""
                            }, rt), this._queueCheck();
                        }
                        connectedCallback() {
                            this._connected = !0, this.startObserver();
                        }
                        disconnectedCallback() {
                            this._connected = !1, this.stopObserver();
                        }
                        static get observedAttributes() {
                            return Dl.slice(0);
                        }
                        attributeChangedCallback(Qe) {
                            switch(Qe){
                                case "inline":
                                    {
                                        const Qe = this.hasAttribute("inline"), rt = this._state;
                                        Qe !== rt.inline && (rt.inline = Qe, updateStyle(this._shadowRoot, Qe));
                                        break;
                                    }
                                case "noobserver":
                                    this.hasAttribute("noobserver") ? this.startObserver() : this.stopObserver();
                                    break;
                                default:
                                    this._queueCheck();
                            }
                        }
                        get icon() {
                            const Qe = this.getAttribute("icon");
                            if (Qe && "{" === Qe.slice(0, 1)) try {
                                return JSON.parse(Qe);
                            } catch (bd) {}
                            return Qe;
                        }
                        set icon(Qe) {
                            "object" === typeof Qe && (Qe = JSON.stringify(Qe)), this.setAttribute("icon", Qe);
                        }
                        get inline() {
                            return this.hasAttribute("inline");
                        }
                        set inline(Qe) {
                            Qe ? this.setAttribute("inline", "true") : this.removeAttribute("inline");
                        }
                        get observer() {
                            return this.hasAttribute("observer");
                        }
                        set observer(Qe) {
                            Qe ? this.setAttribute("observer", "true") : this.removeAttribute("observer");
                        }
                        restartAnimation() {
                            const Qe = this._state;
                            if (Qe.rendered) {
                                const rt = this._shadowRoot;
                                if ("svg" === Qe.renderedMode) try {
                                    return void rt.lastChild.setCurrentTime(0);
                                } catch (bd) {}
                                renderIcon(rt, Qe);
                            }
                        }
                        get status() {
                            const Qe = this._state;
                            return Qe.rendered ? "rendered" : null === Qe.icon.data ? "failed" : "loading";
                        }
                        _queueCheck() {
                            this._checkQueued || (this._checkQueued = !0, setTimeout(()=>{
                                this._check();
                            }));
                        }
                        _check() {
                            if (!this._checkQueued) return;
                            this._checkQueued = !1;
                            const Qe = this._state, rt = this.getAttribute("icon");
                            if (rt !== Qe.icon.value) return void this._iconChanged(rt);
                            if (!Qe.rendered || !this._visible) return;
                            const Wn = this.getAttribute("mode"), Co = getCustomisations(this);
                            Qe.attrMode === Wn && !function(Qe, rt) {
                                for(const Wn in Hl)if (Qe[Wn] !== rt[Wn]) return !0;
                                return !1;
                            }(Qe.customisations, Co) && findIconElement(this._shadowRoot) || this._renderIcon(Qe.icon, Co, Wn);
                        }
                        _iconChanged(Qe) {
                            const rt = function(Qe, rt) {
                                if ("object" === typeof Qe) return {
                                    data: testIconObject(Qe),
                                    value: Qe
                                };
                                if ("string" !== typeof Qe) return {
                                    value: Qe
                                };
                                if (Qe.includes("{")) {
                                    const rt = testIconObject(Qe);
                                    if (rt) return {
                                        data: rt,
                                        value: Qe
                                    };
                                }
                                const Wn = stringToIcon(Qe, !0, !0);
                                if (!Wn) return {
                                    value: Qe
                                };
                                const Co = getIconData(Wn);
                                if (void 0 !== Co || !Wn.prefix) return {
                                    value: Qe,
                                    name: Wn,
                                    data: Co
                                };
                                const Dl = loadIcons$1([
                                    Wn
                                ], ()=>rt(Qe, Wn, getIconData(Wn)));
                                return {
                                    value: Qe,
                                    name: Wn,
                                    loading: Dl
                                };
                            }(Qe, (Qe, rt, Wn)=>{
                                const Co = this._state;
                                if (Co.rendered || this.getAttribute("icon") !== Qe) return;
                                const Dl = {
                                    value: Qe,
                                    name: rt,
                                    data: Wn
                                };
                                Dl.data ? this._gotIconData(Dl) : Co.icon = Dl;
                            });
                            rt.data ? this._gotIconData(rt) : this._state = setPendingState(rt, this._state.inline, this._state);
                        }
                        _forceRender() {
                            if (this._visible) this._queueCheck();
                            else {
                                const Qe = findIconElement(this._shadowRoot);
                                Qe && this._shadowRoot.removeChild(Qe);
                            }
                        }
                        _gotIconData(Qe) {
                            this._checkQueued = !1, this._renderIcon(Qe, getCustomisations(this), this.getAttribute("mode"));
                        }
                        _renderIcon(Qe, rt, Wn) {
                            const Co = function(Qe, rt) {
                                switch(rt){
                                    case "svg":
                                    case "bg":
                                    case "mask":
                                        return rt;
                                }
                                return "style" === rt || !Tu && -1 !== Qe.indexOf("<a") ? -1 === Qe.indexOf("currentColor") ? "bg" : "mask" : "svg";
                            }(Qe.data.body, Wn), Dl = this._state.inline;
                            renderIcon(this._shadowRoot, this._state = {
                                rendered: !0,
                                icon: Qe,
                                inline: Dl,
                                customisations: rt,
                                attrMode: Wn,
                                renderedMode: Co
                            });
                        }
                        startObserver() {
                            if (!this._observer && !this.hasAttribute("noobserver")) try {
                                this._observer = new IntersectionObserver((Qe)=>{
                                    const rt = Qe.some((Qe)=>Qe.isIntersecting);
                                    rt !== this._visible && (this._visible = rt, this._forceRender());
                                }), this._observer.observe(this);
                            } catch (bd) {
                                if (this._observer) {
                                    try {
                                        this._observer.disconnect();
                                    } catch (bd) {}
                                    this._observer = null;
                                }
                            }
                        }
                        stopObserver() {
                            this._observer && (this._observer.disconnect(), this._observer = null, this._visible = !0, this._connected && this._forceRender());
                        }
                    };
                    Dl.forEach((Qe)=>{
                        Qe in Ll.prototype || Object.defineProperty(Ll.prototype, Qe, {
                            get: function() {
                                return this.getAttribute(Qe);
                            },
                            set: function(rt) {
                                null !== rt ? this.setAttribute(Qe, rt) : this.removeAttribute(Qe);
                            }
                        });
                    });
                    const Rl = exportFunctions();
                    for(const Ul in Rl)Ll[Ul] = Ll.prototype[Ul] = Rl[Ul];
                    return rt.define(Qe, Ll), Ll;
                }() || exportFunctions(), { iconLoaded: od, getIcon: ld, listIcons: cd, addIcon: ud, addCollection: hd, calculateSize: dd, buildIcon: pd, iconToHTML: md, svgToURL: fd, loadIcons: gd, loadIcon: Ad, setCustomIconLoader: yd, setCustomIconsLoader: vd, addAPIProvider: _d, _api: xd } = ad;
            },
            1331: (Qe, rt, Wn)=>{
                "use strict";
                Wn.d(rt, {
                    AH: ()=>Co.AH,
                    WF: ()=>r,
                    iz: ()=>Co.iz,
                    qy: ()=>Dl.qy,
                    s6: ()=>Dl.s6
                });
                var Co = Wn(8789), Dl = Wn(8531);
                /**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ class r extends Co.mN {
                    constructor(){
                        super(...arguments), this.renderOptions = {
                            host: this
                        }, this._$Do = void 0;
                    }
                    createRenderRoot() {
                        const Qe = super.createRenderRoot();
                        return this.renderOptions.renderBefore ??= Qe.firstChild, Qe;
                    }
                    update(Qe) {
                        const rt = this.render();
                        this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(Qe), this._$Do = (0, Dl.XX)(rt, this.renderRoot, this.renderOptions);
                    }
                    connectedCallback() {
                        super.connectedCallback(), this._$Do?.setConnected(!0);
                    }
                    disconnectedCallback() {
                        super.disconnectedCallback(), this._$Do?.setConnected(!1);
                    }
                    render() {
                        return Dl.c0;
                    }
                }
                r._$litElement$ = !0, r.finalized = !0, globalThis.litElementHydrateSupport?.({
                    LitElement: r
                });
                const Ll = globalThis.litElementPolyfillSupport;
                Ll?.({
                    LitElement: r
                });
                (globalThis.litElementVersions ??= []).push("4.1.1");
            },
            533: (Qe, rt, Wn)=>{
                "use strict";
                Wn.d(rt, {
                    OA: ()=>Co,
                    WL: ()=>i,
                    u$: ()=>e
                });
                /**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const Co = {
                    ATTRIBUTE: 1,
                    CHILD: 2,
                    PROPERTY: 3,
                    BOOLEAN_ATTRIBUTE: 4,
                    EVENT: 5,
                    ELEMENT: 6
                }, e = (Qe)=>function() {
                        for(var rt = arguments.length, Wn = new Array(rt), Co = 0; Co < rt; Co++)Wn[Co] = arguments[Co];
                        return {
                            _$litDirective$: Qe,
                            values: Wn
                        };
                    };
                class i {
                    constructor(Qe){}
                    get _$AU() {
                        return this._$AM._$AU;
                    }
                    _$AT(Qe, rt, Wn) {
                        this._$Ct = Qe, this._$AM = rt, this._$Ci = Wn;
                    }
                    _$AS(Qe, rt) {
                        return this.update(Qe, rt);
                    }
                    update(Qe, rt) {
                        return this.render(...rt);
                    }
                }
            },
            9744: (Qe, rt, Wn)=>{
                "use strict";
                Wn.d(rt, {
                    H: ()=>Ll
                });
                var Co = Wn(8531), Dl = Wn(533);
                /**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const Ll = (0, Dl.u$)(class extends Dl.WL {
                    constructor(Qe){
                        if (super(Qe), Qe.type !== Dl.OA.ATTRIBUTE || "class" !== Qe.name || Qe.strings?.length > 2) throw Error("`classMap()` can only be used in the `class` attribute and must be the only part in the attribute.");
                    }
                    render(Qe) {
                        return " " + Object.keys(Qe).filter((rt)=>Qe[rt]).join(" ") + " ";
                    }
                    update(Qe, rt) {
                        let [Wn] = rt;
                        if (void 0 === this.st) {
                            this.st = new Set, void 0 !== Qe.strings && (this.nt = new Set(Qe.strings.join(" ").split(/\s/).filter((Qe)=>"" !== Qe)));
                            for(const Qe in Wn)Wn[Qe] && !this.nt?.has(Qe) && this.st.add(Qe);
                            return this.render(Wn);
                        }
                        const Dl = Qe.element.classList;
                        for (const Co of this.st)Co in Wn || (Dl.remove(Co), this.st.delete(Co));
                        for(const Co in Wn){
                            const Qe = !!Wn[Co];
                            Qe === this.st.has(Co) || this.nt?.has(Co) || (Qe ? (Dl.add(Co), this.st.add(Co)) : (Dl.remove(Co), this.st.delete(Co)));
                        }
                        return Co.c0;
                    }
                });
            },
            4901: (Qe, rt, Wn)=>{
                "use strict";
                /**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function* o(Qe, rt) {
                    if (void 0 !== Qe) {
                        let Wn = 0;
                        for (const Co of Qe)yield rt(Co, Wn++);
                    }
                }
                Wn.d(rt, {
                    T: ()=>o
                });
            },
            8531: (Qe, rt, Wn)=>{
                "use strict";
                Wn.d(rt, {
                    JW: ()=>Eu,
                    XX: ()=>B,
                    c0: ()=>Lu,
                    ej: ()=>Tu,
                    qy: ()=>yu,
                    s6: ()=>Zu
                });
                /**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const Co = globalThis, Dl = Co.trustedTypes, Ll = Dl ? Dl.createPolicy("lit-html", {
                    createHTML: (Qe)=>Qe
                }) : void 0, Rl = "$lit$", Ul = `lit$${Math.random().toFixed(9).slice(2)}$`, Gl = "?" + Ul, Zl = `<${Gl}>`, Hl = document, l = ()=>Hl.createComment(""), c = (Qe)=>null === Qe || "object" != typeof Qe && "function" != typeof Qe, ql = Array.isArray, u = (Qe)=>ql(Qe) || "function" == typeof Qe?.[Symbol.iterator], Ql = "[ 	\n\f\r]", Kl = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, $l = /-->/g, Tc = />/g, tu = RegExp(`>|${Ql}(?:([^\\s"'>=/]+)(${Ql}*=${Ql}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`, "g"), lu = /'/g, du = /"/g, fu = /^(?:script|style|textarea|title)$/i, y = (Qe)=>function(rt) {
                        for(var Wn = arguments.length, Co = new Array(Wn > 1 ? Wn - 1 : 0), Dl = 1; Dl < Wn; Dl++)Co[Dl - 1] = arguments[Dl];
                        return {
                            _$litType$: Qe,
                            strings: rt,
                            values: Co
                        };
                    }, yu = y(1), Eu = y(2), Tu = y(3), Lu = Symbol.for("lit-noChange"), Zu = Symbol.for("lit-nothing"), Xu = new WeakMap, Ju = Hl.createTreeWalker(Hl, 129);
                function P(Qe, rt) {
                    if (!ql(Qe) || !Qe.hasOwnProperty("raw")) throw Error("invalid template strings array");
                    return void 0 !== Ll ? Ll.createHTML(rt) : rt;
                }
                const V = (Qe, rt)=>{
                    const Wn = Qe.length - 1, Co = [];
                    let Dl, Ll = 2 === rt ? "<svg>" : 3 === rt ? "<math>" : "", Gl = Kl;
                    for(let Hl = 0; Hl < Wn; Hl++){
                        const rt = Qe[Hl];
                        let Wn, ql, Ql = -1, yu = 0;
                        for(; yu < rt.length && (Gl.lastIndex = yu, ql = Gl.exec(rt), null !== ql);)yu = Gl.lastIndex, Gl === Kl ? "!--" === ql[1] ? Gl = $l : void 0 !== ql[1] ? Gl = Tc : void 0 !== ql[2] ? (fu.test(ql[2]) && (Dl = RegExp("</" + ql[2], "g")), Gl = tu) : void 0 !== ql[3] && (Gl = tu) : Gl === tu ? ">" === ql[0] ? (Gl = Dl ?? Kl, Ql = -1) : void 0 === ql[1] ? Ql = -2 : (Ql = Gl.lastIndex - ql[2].length, Wn = ql[1], Gl = void 0 === ql[3] ? tu : '"' === ql[3] ? du : lu) : Gl === du || Gl === lu ? Gl = tu : Gl === $l || Gl === Tc ? Gl = Kl : (Gl = tu, Dl = void 0);
                        const Eu = Gl === tu && Qe[Hl + 1].startsWith("/>") ? " " : "";
                        Ll += Gl === Kl ? rt + Zl : Ql >= 0 ? (Co.push(Wn), rt.slice(0, Ql) + Rl + rt.slice(Ql) + Ul + Eu) : rt + Ul + (-2 === Ql ? Hl : Eu);
                    }
                    return [
                        P(Qe, Ll + (Qe[Wn] || "<?>") + (2 === rt ? "</svg>" : 3 === rt ? "</math>" : "")),
                        Co
                    ];
                };
                class N {
                    constructor(Qe, rt){
                        let Wn, { strings: Co, _$litType$: Ll } = Qe;
                        this.parts = [];
                        let Zl = 0, Hl = 0;
                        const ql = Co.length - 1, Ql = this.parts, [Kl, $l] = V(Co, Ll);
                        if (this.el = N.createElement(Kl, rt), Ju.currentNode = this.el.content, 2 === Ll || 3 === Ll) {
                            const Qe = this.el.content.firstChild;
                            Qe.replaceWith(...Qe.childNodes);
                        }
                        for(; null !== (Wn = Ju.nextNode()) && Ql.length < ql;){
                            if (1 === Wn.nodeType) {
                                if (Wn.hasAttributes()) for (const Qe of Wn.getAttributeNames())if (Qe.endsWith(Rl)) {
                                    const rt = $l[Hl++], Co = Wn.getAttribute(Qe).split(Ul), Dl = /([.?@])?(.*)/.exec(rt);
                                    Ql.push({
                                        type: 1,
                                        index: Zl,
                                        name: Dl[2],
                                        strings: Co,
                                        ctor: "." === Dl[1] ? H : "?" === Dl[1] ? I : "@" === Dl[1] ? L1 : k
                                    }), Wn.removeAttribute(Qe);
                                } else Qe.startsWith(Ul) && (Ql.push({
                                    type: 6,
                                    index: Zl
                                }), Wn.removeAttribute(Qe));
                                if (fu.test(Wn.tagName)) {
                                    const Qe = Wn.textContent.split(Ul), rt = Qe.length - 1;
                                    if (rt > 0) {
                                        Wn.textContent = Dl ? Dl.emptyScript : "";
                                        for(let Co = 0; Co < rt; Co++)Wn.append(Qe[Co], l()), Ju.nextNode(), Ql.push({
                                            type: 2,
                                            index: ++Zl
                                        });
                                        Wn.append(Qe[rt], l());
                                    }
                                }
                            } else if (8 === Wn.nodeType) {
                                if (Wn.data === Gl) Ql.push({
                                    type: 2,
                                    index: Zl
                                });
                                else {
                                    let Qe = -1;
                                    for(; -1 !== (Qe = Wn.data.indexOf(Ul, Qe + 1));)Ql.push({
                                        type: 7,
                                        index: Zl
                                    }), Qe += Ul.length - 1;
                                }
                            }
                            Zl++;
                        }
                    }
                    static createElement(Qe, rt) {
                        const Wn = Hl.createElement("template");
                        return Wn.innerHTML = Qe, Wn;
                    }
                }
                function S(Qe, rt, Wn, Co) {
                    if (void 0 === Wn && (Wn = Qe), rt === Lu) return rt;
                    let Dl = void 0 !== Co ? Wn._$Co?.[Co] : Wn._$Cl;
                    const Ll = c(rt) ? void 0 : rt._$litDirective$;
                    return Dl?.constructor !== Ll && (Dl?._$AO?.(!1), void 0 === Ll ? Dl = void 0 : (Dl = new Ll(Qe), Dl._$AT(Qe, Wn, Co)), void 0 !== Co ? (Wn._$Co ??= [])[Co] = Dl : Wn._$Cl = Dl), void 0 !== Dl && (rt = S(Qe, Dl._$AS(Qe, rt.values), Dl, Co)), rt;
                }
                class M {
                    constructor(Qe, rt){
                        this._$AV = [], this._$AN = void 0, this._$AD = Qe, this._$AM = rt;
                    }
                    get parentNode() {
                        return this._$AM.parentNode;
                    }
                    get _$AU() {
                        return this._$AM._$AU;
                    }
                    u(Qe) {
                        const { el: { content: rt }, parts: Wn } = this._$AD, Co = (Qe?.creationScope ?? Hl).importNode(rt, !0);
                        Ju.currentNode = Co;
                        let Dl = Ju.nextNode(), Ll = 0, Rl = 0, Ul = Wn[0];
                        for(; void 0 !== Ul;){
                            if (Ll === Ul.index) {
                                let rt;
                                2 === Ul.type ? rt = new R(Dl, Dl.nextSibling, this, Qe) : 1 === Ul.type ? rt = new Ul.ctor(Dl, Ul.name, Ul.strings, this, Qe) : 6 === Ul.type && (rt = new z(Dl, this, Qe)), this._$AV.push(rt), Ul = Wn[++Rl];
                            }
                            Ll !== Ul?.index && (Dl = Ju.nextNode(), Ll++);
                        }
                        return Ju.currentNode = Hl, Co;
                    }
                    p(Qe) {
                        let rt = 0;
                        for (const Wn of this._$AV)void 0 !== Wn && (void 0 !== Wn.strings ? (Wn._$AI(Qe, Wn, rt), rt += Wn.strings.length - 2) : Wn._$AI(Qe[rt])), rt++;
                    }
                }
                class R {
                    get _$AU() {
                        return this._$AM?._$AU ?? this._$Cv;
                    }
                    constructor(Qe, rt, Wn, Co){
                        this.type = 2, this._$AH = Zu, this._$AN = void 0, this._$AA = Qe, this._$AB = rt, this._$AM = Wn, this.options = Co, this._$Cv = Co?.isConnected ?? !0;
                    }
                    get parentNode() {
                        let Qe = this._$AA.parentNode;
                        const rt = this._$AM;
                        return void 0 !== rt && 11 === Qe?.nodeType && (Qe = rt.parentNode), Qe;
                    }
                    get startNode() {
                        return this._$AA;
                    }
                    get endNode() {
                        return this._$AB;
                    }
                    _$AI(Qe, rt) {
                        void 0 === rt && (rt = this), Qe = S(this, Qe, rt), c(Qe) ? Qe === Zu || null == Qe || "" === Qe ? (this._$AH !== Zu && this._$AR(), this._$AH = Zu) : Qe !== this._$AH && Qe !== Lu && this._(Qe) : void 0 !== Qe._$litType$ ? this.$(Qe) : void 0 !== Qe.nodeType ? this.T(Qe) : u(Qe) ? this.k(Qe) : this._(Qe);
                    }
                    O(Qe) {
                        return this._$AA.parentNode.insertBefore(Qe, this._$AB);
                    }
                    T(Qe) {
                        this._$AH !== Qe && (this._$AR(), this._$AH = this.O(Qe));
                    }
                    _(Qe) {
                        this._$AH !== Zu && c(this._$AH) ? this._$AA.nextSibling.data = Qe : this.T(Hl.createTextNode(Qe)), this._$AH = Qe;
                    }
                    $(Qe) {
                        const { values: rt, _$litType$: Wn } = Qe, Co = "number" == typeof Wn ? this._$AC(Qe) : (void 0 === Wn.el && (Wn.el = N.createElement(P(Wn.h, Wn.h[0]), this.options)), Wn);
                        if (this._$AH?._$AD === Co) this._$AH.p(rt);
                        else {
                            const Qe = new M(Co, this), Wn = Qe.u(this.options);
                            Qe.p(rt), this.T(Wn), this._$AH = Qe;
                        }
                    }
                    _$AC(Qe) {
                        let rt = Xu.get(Qe.strings);
                        return void 0 === rt && Xu.set(Qe.strings, rt = new N(Qe)), rt;
                    }
                    k(Qe) {
                        ql(this._$AH) || (this._$AH = [], this._$AR());
                        const rt = this._$AH;
                        let Wn, Co = 0;
                        for (const Dl of Qe)Co === rt.length ? rt.push(Wn = new R(this.O(l()), this.O(l()), this, this.options)) : Wn = rt[Co], Wn._$AI(Dl), Co++;
                        Co < rt.length && (this._$AR(Wn && Wn._$AB.nextSibling, Co), rt.length = Co);
                    }
                    _$AR(Qe, rt) {
                        for(void 0 === Qe && (Qe = this._$AA.nextSibling), this._$AP?.(!1, !0, rt); Qe && Qe !== this._$AB;){
                            const rt = Qe.nextSibling;
                            Qe.remove(), Qe = rt;
                        }
                    }
                    setConnected(Qe) {
                        void 0 === this._$AM && (this._$Cv = Qe, this._$AP?.(Qe));
                    }
                }
                class k {
                    get tagName() {
                        return this.element.tagName;
                    }
                    get _$AU() {
                        return this._$AM._$AU;
                    }
                    constructor(Qe, rt, Wn, Co, Dl){
                        this.type = 1, this._$AH = Zu, this._$AN = void 0, this.element = Qe, this.name = rt, this._$AM = Co, this.options = Dl, Wn.length > 2 || "" !== Wn[0] || "" !== Wn[1] ? (this._$AH = Array(Wn.length - 1).fill(new String), this.strings = Wn) : this._$AH = Zu;
                    }
                    _$AI(Qe, rt, Wn, Co) {
                        void 0 === rt && (rt = this);
                        const Dl = this.strings;
                        let Ll = !1;
                        if (void 0 === Dl) Qe = S(this, Qe, rt, 0), Ll = !c(Qe) || Qe !== this._$AH && Qe !== Lu, Ll && (this._$AH = Qe);
                        else {
                            const Co = Qe;
                            let Rl, Ul;
                            for(Qe = Dl[0], Rl = 0; Rl < Dl.length - 1; Rl++)Ul = S(this, Co[Wn + Rl], rt, Rl), Ul === Lu && (Ul = this._$AH[Rl]), Ll ||= !c(Ul) || Ul !== this._$AH[Rl], Ul === Zu ? Qe = Zu : Qe !== Zu && (Qe += (Ul ?? "") + Dl[Rl + 1]), this._$AH[Rl] = Ul;
                        }
                        Ll && !Co && this.j(Qe);
                    }
                    j(Qe) {
                        Qe === Zu ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, Qe ?? "");
                    }
                }
                class H extends k {
                    constructor(){
                        super(...arguments), this.type = 3;
                    }
                    j(Qe) {
                        this.element[this.name] = Qe === Zu ? void 0 : Qe;
                    }
                }
                class I extends k {
                    constructor(){
                        super(...arguments), this.type = 4;
                    }
                    j(Qe) {
                        this.element.toggleAttribute(this.name, !!Qe && Qe !== Zu);
                    }
                }
                class L1 extends k {
                    constructor(Qe, rt, Wn, Co, Dl){
                        super(Qe, rt, Wn, Co, Dl), this.type = 5;
                    }
                    _$AI(Qe, rt) {
                        if (void 0 === rt && (rt = this), (Qe = S(this, Qe, rt, 0) ?? Zu) === Lu) return;
                        const Wn = this._$AH, Co = Qe === Zu && Wn !== Zu || Qe.capture !== Wn.capture || Qe.once !== Wn.once || Qe.passive !== Wn.passive, Dl = Qe !== Zu && (Wn === Zu || Co);
                        Co && this.element.removeEventListener(this.name, this, Wn), Dl && this.element.addEventListener(this.name, this, Qe), this._$AH = Qe;
                    }
                    handleEvent(Qe) {
                        "function" == typeof this._$AH ? this._$AH.call(this.options?.host ?? this.element, Qe) : this._$AH.handleEvent(Qe);
                    }
                }
                class z {
                    constructor(Qe, rt, Wn){
                        this.element = Qe, this.type = 6, this._$AN = void 0, this._$AM = rt, this.options = Wn;
                    }
                    get _$AU() {
                        return this._$AM._$AU;
                    }
                    _$AI(Qe) {
                        S(this, Qe);
                    }
                }
                const $u = Co.litHtmlPolyfillSupport;
                $u?.(N, R), (Co.litHtmlVersions ??= []).push("3.2.1");
                const B = (Qe, rt, Wn)=>{
                    const Co = Wn?.renderBefore ?? rt;
                    let Dl = Co._$litPart$;
                    if (void 0 === Dl) {
                        const Qe = Wn?.renderBefore ?? null;
                        Co._$litPart$ = Dl = new R(rt.insertBefore(l(), Qe), Qe, void 0, Wn ?? {});
                    }
                    return Dl._$AI(Qe), Dl;
                };
            },
            5080: (Qe, rt, Wn)=>{
                "use strict";
                Wn.d(rt, {
                    Bk: ()=>s,
                    qy: ()=>Rl
                });
                var Co = Wn(8531);
                /**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const Dl = Symbol.for(""), o = (Qe)=>{
                    if (Qe?.r === Dl) return Qe?._$litStatic$;
                }, s = (Qe)=>({
                        _$litStatic$: Qe,
                        r: Dl
                    }), Ll = new Map, n = (Qe)=>function(rt) {
                        for(var Wn = arguments.length, Co = new Array(Wn > 1 ? Wn - 1 : 0), Dl = 1; Dl < Wn; Dl++)Co[Dl - 1] = arguments[Dl];
                        const Rl = Co.length;
                        let Ul, Gl;
                        const Zl = [], Hl = [];
                        let ql, Ql = 0, Kl = !1;
                        for(; Ql < Rl;){
                            for(ql = rt[Ql]; Ql < Rl && void 0 !== (Gl = Co[Ql], Ul = o(Gl));)ql += Ul + rt[++Ql], Kl = !0;
                            Ql !== Rl && Hl.push(Gl), Zl.push(ql), Ql++;
                        }
                        if (Ql === Rl && Zl.push(rt[Rl]), Kl) {
                            const Qe = Zl.join("$$lit$$");
                            void 0 === (rt = Ll.get(Qe)) && (Zl.raw = Zl, Ll.set(Qe, rt = Zl)), Co = Hl;
                        }
                        return Qe(rt, ...Co);
                    }, Rl = n(Co.qy);
                n(Co.JW), n(Co.ej);
            },
            1198: (Qe, rt, Wn)=>{
                "use strict";
                Wn.d(rt, {
                    H: ()=>Co.H
                });
                var Co = Wn(9744);
            },
            4542: (Qe, rt, Wn)=>{
                "use strict";
                Wn.d(rt, {
                    AH: ()=>Co.AH,
                    WF: ()=>Co.WF,
                    iz: ()=>Co.iz,
                    qy: ()=>Co.qy,
                    s6: ()=>Co.s6
                });
                Wn(8789), Wn(8531);
                var Co = Wn(1331);
            },
            686: (Qe, rt, Wn)=>{
                "use strict";
                Wn.d(rt, {
                    Bk: ()=>Co.Bk,
                    qy: ()=>Co.qy
                });
                var Co = Wn(5080);
            },
            748: (Qe, rt, Wn)=>{
                "use strict";
                Wn.d(rt, {
                    Zs: ()=>Gl
                });
                var Co = Wn(3336), Dl = Object.defineProperty, Ll = Math.pow, l = (Qe, rt)=>Dl(Qe, "name", {
                        value: rt,
                        configurable: !0
                    }), m = (Qe, rt, Wn)=>new Promise((Co, Dl)=>{
                        var s = (Qe)=>{
                            try {
                                a(Wn.next(Qe));
                            } catch (rt) {
                                Dl(rt);
                            }
                        }, o = (Qe)=>{
                            try {
                                a(Wn.throw(Qe));
                            } catch (rt) {
                                Dl(rt);
                            }
                        }, a = (Qe)=>Qe.done ? Co(Qe.value) : Promise.resolve(Qe.value).then(s, o);
                        a((Wn = Wn.apply(Qe, rt)).next());
                    }), Rl = (l((Qe, rt)=>{
                    let Wn = !1, Co = "";
                    return new (L.GridLayer.extend({
                        createTile: l((rt, Dl)=>{
                            let Ll = document.createElement("img"), Rl = new AbortController, Ul = Rl.signal;
                            return Ll.cancel = ()=>{
                                Rl.abort();
                            }, Wn || (Qe.getHeader().then((Qe)=>{
                                1 === Qe.tileType ? console.error("Error: archive contains MVT vector tiles, but leafletRasterLayer is for displaying raster tiles. See https://github.com/protomaps/PMTiles/tree/main/js for details.") : 2 === Qe.tileType ? Co = "image/png" : 3 === Qe.tileType ? Co = "image/jpeg" : 4 === Qe.tileType ? Co = "image/webp" : 5 === Qe.tileType && (Co = "image/avif");
                            }), Wn = !0), Qe.getZxy(rt.z, rt.x, rt.y, Ul).then((Qe)=>{
                                if (Qe) {
                                    let rt = new Blob([
                                        Qe.data
                                    ], {
                                        type: Co
                                    }), Wn = window.URL.createObjectURL(rt);
                                    Ll.src = Wn, Ll.cancel = void 0, Dl(void 0, Ll);
                                }
                            }).catch((Qe)=>{
                                if ("AbortError" !== Qe.name) throw Qe;
                            }), Ll;
                        }, "createTile"),
                        _removeTile: l(function(Qe) {
                            let rt = this._tiles[Qe];
                            rt && (rt.el.cancel && rt.el.cancel(), rt.el.width = 0, rt.el.height = 0, rt.el.deleted = !0, L.DomUtil.remove(rt.el), delete this._tiles[Qe], this.fire("tileunload", {
                                tile: rt.el,
                                coords: this._keyToTileCoords(Qe)
                            }));
                        }, "_removeTile")
                    }))(rt);
                }, "leafletRasterLayer"), l((Qe)=>(rt, Wn)=>{
                        if (Wn instanceof AbortController) return Qe(rt, Wn);
                        let Co = new AbortController;
                        return Qe(rt, Co).then((Qe)=>Wn(void 0, Qe.data, Qe.cacheControl || "", Qe.expires || ""), (Qe)=>Wn(Qe)).catch((Qe)=>Wn(Qe)), {
                            cancel: l(()=>Co.abort(), "cancel")
                        };
                    }, "v3compat")), Ul = class {
                    constructor(Qe){
                        this.tilev4 = l((Qe, rt)=>m(this, null, function*() {
                                if ("json" === Qe.type) {
                                    let rt = Qe.url.substr(10), Wn = this.tiles.get(rt);
                                    if (Wn || (Wn = new Lu(rt), this.tiles.set(rt, Wn)), this.metadata) return {
                                        data: yield Wn.getTileJson(Qe.url)
                                    };
                                    let Co = yield Wn.getHeader();
                                    return (Co.minLon >= Co.maxLon || Co.minLat >= Co.maxLat) && console.error(`Bounds of PMTiles archive ${Co.minLon},${Co.minLat},${Co.maxLon},${Co.maxLat} are not valid.`), {
                                        data: {
                                            tiles: [
                                                `${Qe.url}/{z}/{x}/{y}`
                                            ],
                                            minzoom: Co.minZoom,
                                            maxzoom: Co.maxZoom,
                                            bounds: [
                                                Co.minLon,
                                                Co.minLat,
                                                Co.maxLon,
                                                Co.maxLat
                                            ]
                                        }
                                    };
                                }
                                let Wn = new RegExp(/pmtiles:\/\/(.+)\/(\d+)\/(\d+)\/(\d+)/), Co = Qe.url.match(Wn);
                                if (!Co) throw new Error("Invalid PMTiles protocol URL");
                                let Dl = Co[1], Ll = this.tiles.get(Dl);
                                Ll || (Ll = new Lu(Dl), this.tiles.set(Dl, Ll));
                                let Rl = Co[2], Ul = Co[3], Gl = Co[4], Zl = yield Ll.getHeader(), Hl = yield null == Ll ? void 0 : Ll.getZxy(+Rl, +Ul, +Gl, rt.signal);
                                if (Hl) return {
                                    data: new Uint8Array(Hl.data),
                                    cacheControl: Hl.cacheControl,
                                    expires: Hl.expires
                                };
                                if (1 === Zl.tileType) {
                                    if (this.errorOnMissingTile) throw new Error("Tile not found.");
                                    return {
                                        data: new Uint8Array
                                    };
                                }
                                return {
                                    data: null
                                };
                            }), "tilev4"), this.tile = Rl(this.tilev4), this.tiles = new Map, this.metadata = (null == Qe ? void 0 : Qe.metadata) || !1, this.errorOnMissingTile = (null == Qe ? void 0 : Qe.errorOnMissingTile) || !1;
                    }
                    add(Qe) {
                        this.tiles.set(Qe.source.getKey(), Qe);
                    }
                    get(Qe) {
                        return this.tiles.get(Qe);
                    }
                };
                l(Ul, "Protocol");
                var Gl = Ul;
                function w(Qe, rt) {
                    return 4294967296 * (rt >>> 0) + (Qe >>> 0);
                }
                function F(Qe, rt) {
                    let Wn = rt.buf, Co = Wn[rt.pos++], Dl = (112 & Co) >> 4;
                    if (Co < 128 || (Co = Wn[rt.pos++], Dl |= (127 & Co) << 3, Co < 128) || (Co = Wn[rt.pos++], Dl |= (127 & Co) << 10, Co < 128) || (Co = Wn[rt.pos++], Dl |= (127 & Co) << 17, Co < 128) || (Co = Wn[rt.pos++], Dl |= (127 & Co) << 24, Co < 128) || (Co = Wn[rt.pos++], Dl |= (1 & Co) << 31, Co < 128)) return w(Qe, Dl);
                    throw new Error("Expected varint not more than 10 bytes");
                }
                function v(Qe) {
                    let rt = Qe.buf, Wn = rt[Qe.pos++], Co = 127 & Wn;
                    return Wn < 128 || (Wn = rt[Qe.pos++], Co |= (127 & Wn) << 7, Wn < 128) || (Wn = rt[Qe.pos++], Co |= (127 & Wn) << 14, Wn < 128) || (Wn = rt[Qe.pos++], Co |= (127 & Wn) << 21, Wn < 128) ? Co : (Wn = rt[Qe.pos], Co |= (15 & Wn) << 28, F(Co, Qe));
                }
                function k(Qe, rt, Wn, Co) {
                    if (0 === Co) {
                        1 === Wn && (rt[0] = Qe - 1 - rt[0], rt[1] = Qe - 1 - rt[1]);
                        let Co = rt[0];
                        rt[0] = rt[1], rt[1] = Co;
                    }
                }
                function N(Qe, rt) {
                    let Wn = Ll(2, Qe), Co = rt, Dl = rt, Rl = rt, Ul = [
                        0,
                        0
                    ], Gl = 1;
                    for(; Gl < Wn;)Co = 1 & Rl / 2, Dl = 1 & (Rl ^ Co), k(Gl, Ul, Co, Dl), Ul[0] += Gl * Co, Ul[1] += Gl * Dl, Rl /= 4, Gl *= 2;
                    return [
                        Qe,
                        Ul[0],
                        Ul[1]
                    ];
                }
                l(w, "toNum"), l(F, "readVarintRemainder"), l(v, "readVarint"), l(k, "rotate"), l(N, "idOnLevel");
                var Zl = [
                    0,
                    1,
                    5,
                    21,
                    85,
                    341,
                    1365,
                    5461,
                    21845,
                    87381,
                    349525,
                    1398101,
                    5592405,
                    22369621,
                    89478485,
                    357913941,
                    1431655765,
                    5726623061,
                    22906492245,
                    91625968981,
                    366503875925,
                    1466015503701,
                    5864062014805,
                    23456248059221,
                    93824992236885,
                    375299968947541,
                    0x5555555555555
                ];
                function G(Qe, rt, Wn) {
                    if (Qe > 26) throw new Error("Tile zoom level exceeds max safe number limit (26)");
                    if (rt > Ll(2, Qe) - 1 || Wn > Ll(2, Qe) - 1) throw new Error("tile x/y outside zoom level bounds");
                    let Co = Zl[Qe], Dl = 0, Rl = 0, Ul = 0, Gl = [
                        rt,
                        Wn
                    ], Hl = Ll(2, Qe) / 2;
                    for(; Hl > 0;)Dl = (Gl[0] & Hl) > 0 ? 1 : 0, Rl = (Gl[1] & Hl) > 0 ? 1 : 0, Ul += Hl * Hl * (3 * Dl ^ Rl), k(Hl, Gl, Dl, Rl), Hl /= 2;
                    return Co + Ul;
                }
                l(G, "zxyToTileId"), l(function(Qe) {
                    let rt = 0;
                    for(let Wn = 0; Wn < 27; Wn++){
                        let Co = (1 << Wn) * (1 << Wn);
                        if (rt + Co > Qe) return N(Wn, Qe - rt);
                        rt += Co;
                    }
                    throw new Error("Tile zoom level exceeds max safe number limit (26)");
                }, "tileIdToZxy");
                var Hl, ql = ((Hl = ql || {})[Hl.Unknown = 0] = "Unknown", Hl[Hl.None = 1] = "None", Hl[Hl.Gzip = 2] = "Gzip", Hl[Hl.Brotli = 3] = "Brotli", Hl[Hl.Zstd = 4] = "Zstd", Hl);
                function D(Qe, rt) {
                    return m(this, null, function*() {
                        if (1 === rt || 0 === rt) return Qe;
                        if (2 === rt) {
                            if ("undefined" == typeof globalThis.DecompressionStream) return (0, Co.Rq)(new Uint8Array(Qe));
                            let rt = new Response(Qe).body;
                            if (!rt) throw new Error("Failed to read response stream");
                            let Wn = rt.pipeThrough(new globalThis.DecompressionStream("gzip"));
                            return new Response(Wn).arrayBuffer();
                        }
                        throw new Error("Compression method not supported");
                    });
                }
                l(D, "defaultDecompress");
                var Ql, Kl = ((Ql = Kl || {})[Ql.Unknown = 0] = "Unknown", Ql[Ql.Mvt = 1] = "Mvt", Ql[Ql.Png = 2] = "Png", Ql[Ql.Jpeg = 3] = "Jpeg", Ql[Ql.Webp = 4] = "Webp", Ql[Ql.Avif = 5] = "Avif", Ql);
                function _(Qe) {
                    return 1 === Qe ? ".mvt" : 2 === Qe ? ".png" : 3 === Qe ? ".jpg" : 4 === Qe ? ".webp" : 5 === Qe ? ".avif" : "";
                }
                l(_, "tileTypeExt");
                function Q(Qe, rt) {
                    let Wn = 0, Co = Qe.length - 1;
                    for(; Wn <= Co;){
                        let Dl = Co + Wn >> 1, Ll = rt - Qe[Dl].tileId;
                        if (Ll > 0) Wn = Dl + 1;
                        else {
                            if (!(Ll < 0)) return Qe[Dl];
                            Co = Dl - 1;
                        }
                    }
                    return Co >= 0 && (0 === Qe[Co].runLength || rt - Qe[Co].tileId < Qe[Co].runLength) ? Qe[Co] : null;
                }
                l(Q, "findTile");
                var $l = class {
                    constructor(Qe){
                        this.file = Qe;
                    }
                    getKey() {
                        return this.file.name;
                    }
                    getBytes(Qe, rt) {
                        return m(this, null, function*() {
                            return {
                                data: yield this.file.slice(Qe, Qe + rt).arrayBuffer()
                            };
                        });
                    }
                };
                l($l, "FileSource");
                var Tc = class {
                    constructor(Qe, rt){
                        void 0 === rt && (rt = new Headers), this.url = Qe, this.customHeaders = rt, this.mustReload = !1;
                        let Wn = "";
                        "navigator" in globalThis && (Wn = globalThis.navigator.userAgent || "");
                        let Co = Wn.indexOf("Windows") > -1, Dl = /Chrome|Chromium|Edg|OPR|Brave/.test(Wn);
                        this.chromeWindowsNoCache = !1, Co && Dl && (this.chromeWindowsNoCache = !0);
                    }
                    getKey() {
                        return this.url;
                    }
                    setHeaders(Qe) {
                        this.customHeaders = Qe;
                    }
                    getBytes(Qe, rt, Wn, Co) {
                        return m(this, null, function*() {
                            let Dl, Ll;
                            Wn ? Ll = Wn : (Dl = new AbortController, Ll = Dl.signal);
                            let Rl, Ul = new Headers(this.customHeaders);
                            Ul.set("range", `bytes=${Qe}-${Qe + rt - 1}`), this.mustReload ? Rl = "reload" : this.chromeWindowsNoCache && (Rl = "no-store");
                            let Gl = yield fetch(this.url, {
                                signal: Ll,
                                cache: Rl,
                                headers: Ul
                            });
                            if (0 === Qe && 416 === Gl.status) {
                                let Qe = Gl.headers.get("Content-Range");
                                if (!Qe || !Qe.startsWith("bytes */")) throw new Error("Missing content-length on 416 response");
                                let rt = +Qe.substr(8);
                                Gl = yield fetch(this.url, {
                                    signal: Ll,
                                    cache: "reload",
                                    headers: {
                                        range: "bytes=0-" + (rt - 1)
                                    }
                                });
                            }
                            let Zl = Gl.headers.get("Etag");
                            if (null != Zl && Zl.startsWith("W/") && (Zl = null), 416 === Gl.status || Co && Zl && Zl !== Co) throw this.mustReload = !0, new du(`Server returned non-matching ETag ${Co} after one retry. Check browser extensions and servers for issues that may affect correct ETag headers.`);
                            if (Gl.status >= 300) throw new Error(`Bad response code: ${Gl.status}`);
                            let Hl = Gl.headers.get("Content-Length");
                            if (200 === Gl.status && (!Hl || +Hl > rt)) throw Dl && Dl.abort(), new Error("Server returned no content-length header or content-length exceeding request. Check that your storage backend supports HTTP Byte Serving.");
                            return {
                                data: yield Gl.arrayBuffer(),
                                etag: Zl || void 0,
                                cacheControl: Gl.headers.get("Cache-Control") || void 0,
                                expires: Gl.headers.get("Expires") || void 0
                            };
                        });
                    }
                };
                l(Tc, "FetchSource");
                var tu = Tc;
                function g(Qe, rt) {
                    let Wn = Qe.getUint32(rt + 4, !0), Co = Qe.getUint32(rt + 0, !0);
                    return Wn * Ll(2, 32) + Co;
                }
                function X(Qe, rt) {
                    let Wn = new DataView(Qe), Co = Wn.getUint8(7);
                    if (Co > 3) throw new Error(`Archive is spec version ${Co} but this library supports up to spec version 3`);
                    return {
                        specVersion: Co,
                        rootDirectoryOffset: g(Wn, 8),
                        rootDirectoryLength: g(Wn, 16),
                        jsonMetadataOffset: g(Wn, 24),
                        jsonMetadataLength: g(Wn, 32),
                        leafDirectoryOffset: g(Wn, 40),
                        leafDirectoryLength: g(Wn, 48),
                        tileDataOffset: g(Wn, 56),
                        tileDataLength: g(Wn, 64),
                        numAddressedTiles: g(Wn, 72),
                        numTileEntries: g(Wn, 80),
                        numTileContents: g(Wn, 88),
                        clustered: 1 === Wn.getUint8(96),
                        internalCompression: Wn.getUint8(97),
                        tileCompression: Wn.getUint8(98),
                        tileType: Wn.getUint8(99),
                        minZoom: Wn.getUint8(100),
                        maxZoom: Wn.getUint8(101),
                        minLon: Wn.getInt32(102, !0) / 1e7,
                        minLat: Wn.getInt32(106, !0) / 1e7,
                        maxLon: Wn.getInt32(110, !0) / 1e7,
                        maxLat: Wn.getInt32(114, !0) / 1e7,
                        centerZoom: Wn.getUint8(118),
                        centerLon: Wn.getInt32(119, !0) / 1e7,
                        centerLat: Wn.getInt32(123, !0) / 1e7,
                        etag: rt
                    };
                }
                function Z(Qe) {
                    let rt = {
                        buf: new Uint8Array(Qe),
                        pos: 0
                    }, Wn = v(rt), Co = [], Dl = 0;
                    for(let Ll = 0; Ll < Wn; Ll++){
                        let Qe = v(rt);
                        Co.push({
                            tileId: Dl + Qe,
                            offset: 0,
                            length: 0,
                            runLength: 1
                        }), Dl += Qe;
                    }
                    for(let Ll = 0; Ll < Wn; Ll++)Co[Ll].runLength = v(rt);
                    for(let Ll = 0; Ll < Wn; Ll++)Co[Ll].length = v(rt);
                    for(let Ll = 0; Ll < Wn; Ll++){
                        let Qe = v(rt);
                        Co[Ll].offset = 0 === Qe && Ll > 0 ? Co[Ll - 1].offset + Co[Ll - 1].length : Qe - 1;
                    }
                    return Co;
                }
                l(g, "getUint64"), l(X, "bytesToHeader"), l(Z, "deserializeIndex");
                var lu = class extends Error {
                };
                l(lu, "EtagMismatch");
                var du = lu;
                function K(Qe, rt) {
                    return m(this, null, function*() {
                        let Wn = yield Qe.getBytes(0, 16384);
                        if (19792 !== new DataView(Wn.data).getUint16(0, !0)) throw new Error("Wrong magic number for PMTiles archive");
                        let Co = X(Wn.data.slice(0, 127), Wn.etag), Dl = Wn.data.slice(Co.rootDirectoryOffset, Co.rootDirectoryOffset + Co.rootDirectoryLength), Ll = `${Qe.getKey()}|${Co.etag || ""}|${Co.rootDirectoryOffset}|${Co.rootDirectoryLength}`, Rl = Z((yield rt(Dl, Co.internalCompression)));
                        return [
                            Co,
                            [
                                Ll,
                                Rl.length,
                                Rl
                            ]
                        ];
                    });
                }
                function I(Qe, rt, Wn, Co, Dl) {
                    return m(this, null, function*() {
                        let Ll = yield Qe.getBytes(Wn, Co, void 0, Dl.etag), Rl = Z((yield rt(Ll.data, Dl.internalCompression)));
                        if (0 === Rl.length) throw new Error("Empty directory is invalid");
                        return Rl;
                    });
                }
                l(K, "getHeaderAndRoot"), l(I, "getDirectory");
                var fu = class {
                    constructor(Qe, rt, Wn){
                        void 0 === Qe && (Qe = 100), void 0 === rt && (rt = !0), void 0 === Wn && (Wn = D), this.cache = new Map, this.maxCacheEntries = Qe, this.counter = 1, this.decompress = Wn;
                    }
                    getHeader(Qe) {
                        return m(this, null, function*() {
                            let rt = Qe.getKey(), Wn = this.cache.get(rt);
                            if (Wn) return Wn.lastUsed = this.counter++, Wn.data;
                            let Co = yield K(Qe, this.decompress);
                            return Co[1] && this.cache.set(Co[1][0], {
                                lastUsed: this.counter++,
                                data: Co[1][2]
                            }), this.cache.set(rt, {
                                lastUsed: this.counter++,
                                data: Co[0]
                            }), this.prune(), Co[0];
                        });
                    }
                    getDirectory(Qe, rt, Wn, Co) {
                        return m(this, null, function*() {
                            let Dl = `${Qe.getKey()}|${Co.etag || ""}|${rt}|${Wn}`, Ll = this.cache.get(Dl);
                            if (Ll) return Ll.lastUsed = this.counter++, Ll.data;
                            let Rl = yield I(Qe, this.decompress, rt, Wn, Co);
                            return this.cache.set(Dl, {
                                lastUsed: this.counter++,
                                data: Rl
                            }), this.prune(), Rl;
                        });
                    }
                    prune() {
                        if (this.cache.size > this.maxCacheEntries) {
                            let Qe, rt = 1 / 0;
                            this.cache.forEach((Wn, Co)=>{
                                Wn.lastUsed < rt && (rt = Wn.lastUsed, Qe = Co);
                            }), Qe && this.cache.delete(Qe);
                        }
                    }
                    invalidate(Qe) {
                        return m(this, null, function*() {
                            this.cache.delete(Qe.getKey());
                        });
                    }
                };
                l(fu, "ResolvedValueCache");
                var yu = class {
                    constructor(Qe, rt, Wn){
                        void 0 === Qe && (Qe = 100), void 0 === rt && (rt = !0), void 0 === Wn && (Wn = D), this.cache = new Map, this.invalidations = new Map, this.maxCacheEntries = Qe, this.counter = 1, this.decompress = Wn;
                    }
                    getHeader(Qe) {
                        return m(this, null, function*() {
                            let rt = Qe.getKey(), Wn = this.cache.get(rt);
                            if (Wn) return Wn.lastUsed = this.counter++, yield Wn.data;
                            let Co = new Promise((rt, Wn)=>{
                                K(Qe, this.decompress).then((Qe)=>{
                                    Qe[1] && this.cache.set(Qe[1][0], {
                                        lastUsed: this.counter++,
                                        data: Promise.resolve(Qe[1][2])
                                    }), rt(Qe[0]), this.prune();
                                }).catch((Qe)=>{
                                    Wn(Qe);
                                });
                            });
                            return this.cache.set(rt, {
                                lastUsed: this.counter++,
                                data: Co
                            }), Co;
                        });
                    }
                    getDirectory(Qe, rt, Wn, Co) {
                        return m(this, null, function*() {
                            let Dl = `${Qe.getKey()}|${Co.etag || ""}|${rt}|${Wn}`, Ll = this.cache.get(Dl);
                            if (Ll) return Ll.lastUsed = this.counter++, yield Ll.data;
                            let Rl = new Promise((Dl, Ll)=>{
                                I(Qe, this.decompress, rt, Wn, Co).then((Qe)=>{
                                    Dl(Qe), this.prune();
                                }).catch((Qe)=>{
                                    Ll(Qe);
                                });
                            });
                            return this.cache.set(Dl, {
                                lastUsed: this.counter++,
                                data: Rl
                            }), Rl;
                        });
                    }
                    prune() {
                        if (this.cache.size >= this.maxCacheEntries) {
                            let Qe, rt = 1 / 0;
                            this.cache.forEach((Wn, Co)=>{
                                Wn.lastUsed < rt && (rt = Wn.lastUsed, Qe = Co);
                            }), Qe && this.cache.delete(Qe);
                        }
                    }
                    invalidate(Qe) {
                        return m(this, null, function*() {
                            let rt = Qe.getKey();
                            if (this.invalidations.get(rt)) return yield this.invalidations.get(rt);
                            this.cache.delete(Qe.getKey());
                            let Wn = new Promise((Wn, Co)=>{
                                this.getHeader(Qe).then((Qe)=>{
                                    Wn(), this.invalidations.delete(rt);
                                }).catch((Qe)=>{
                                    Co(Qe);
                                });
                            });
                            this.invalidations.set(rt, Wn);
                        });
                    }
                };
                l(yu, "SharedPromiseCache");
                var Eu = yu, Tu = class {
                    constructor(Qe, rt, Wn){
                        this.source = "string" == typeof Qe ? new tu(Qe) : Qe, this.decompress = Wn || D, this.cache = rt || new Eu;
                    }
                    getHeader() {
                        return m(this, null, function*() {
                            return yield this.cache.getHeader(this.source);
                        });
                    }
                    getZxyAttempt(Qe, rt, Wn, Co) {
                        return m(this, null, function*() {
                            let Dl = G(Qe, rt, Wn), Ll = yield this.cache.getHeader(this.source);
                            if (Qe < Ll.minZoom || Qe > Ll.maxZoom) return;
                            let Rl = Ll.rootDirectoryOffset, Ul = Ll.rootDirectoryLength;
                            for(let Qe = 0; Qe <= 3; Qe++){
                                let Qe = Q((yield this.cache.getDirectory(this.source, Rl, Ul, Ll)), Dl);
                                if (!Qe) return;
                                if (Qe.runLength > 0) {
                                    let rt = yield this.source.getBytes(Ll.tileDataOffset + Qe.offset, Qe.length, Co, Ll.etag);
                                    return {
                                        data: yield this.decompress(rt.data, Ll.tileCompression),
                                        cacheControl: rt.cacheControl,
                                        expires: rt.expires
                                    };
                                }
                                Rl = Ll.leafDirectoryOffset + Qe.offset, Ul = Qe.length;
                            }
                            throw new Error("Maximum directory depth exceeded");
                        });
                    }
                    getZxy(Qe, rt, Wn, Co) {
                        return m(this, null, function*() {
                            try {
                                return yield this.getZxyAttempt(Qe, rt, Wn, Co);
                            } catch (Hl) {
                                if (Hl instanceof du) return this.cache.invalidate(this.source), yield this.getZxyAttempt(Qe, rt, Wn, Co);
                                throw Hl;
                            }
                        });
                    }
                    getMetadataAttempt() {
                        return m(this, null, function*() {
                            let Qe = yield this.cache.getHeader(this.source), rt = yield this.source.getBytes(Qe.jsonMetadataOffset, Qe.jsonMetadataLength, void 0, Qe.etag), Wn = yield this.decompress(rt.data, Qe.internalCompression), Co = new TextDecoder("utf-8");
                            return JSON.parse(Co.decode(Wn));
                        });
                    }
                    getMetadata() {
                        return m(this, null, function*() {
                            try {
                                return yield this.getMetadataAttempt();
                            } catch (Qe) {
                                if (Qe instanceof du) return this.cache.invalidate(this.source), yield this.getMetadataAttempt();
                                throw Qe;
                            }
                        });
                    }
                    getTileJson(Qe) {
                        return m(this, null, function*() {
                            let rt = yield this.getHeader(), Wn = yield this.getMetadata(), Co = _(rt.tileType);
                            return {
                                tilejson: "3.0.0",
                                scheme: "xyz",
                                tiles: [
                                    `${Qe}/{z}/{x}/{y}${Co}`
                                ],
                                vector_layers: Wn.vector_layers,
                                attribution: Wn.attribution,
                                description: Wn.description,
                                name: Wn.name,
                                version: Wn.version,
                                bounds: [
                                    rt.minLon,
                                    rt.minLat,
                                    rt.maxLon,
                                    rt.maxLat
                                ],
                                center: [
                                    rt.centerLon,
                                    rt.centerLat,
                                    rt.centerZoom
                                ],
                                minzoom: rt.minZoom,
                                maxzoom: rt.maxZoom
                            };
                        });
                    }
                };
                l(Tu, "PMTiles");
                var Lu = Tu;
            },
            9435: (Qe, rt, Wn)=>{
                "use strict";
                Wn.d(rt, {
                    $EB: ()=>Ql,
                    $Yl: ()=>ld,
                    $_I: ()=>Gd,
                    $ei: ()=>Lu,
                    A$4: ()=>Uint16BufferAttribute,
                    AQS: ()=>arrayNeedsUint32,
                    B69: ()=>Object3D,
                    BKk: ()=>ShaderMaterial,
                    BXX: ()=>Pp,
                    B_h: ()=>Vp,
                    CMB: ()=>bp,
                    CSG: ()=>MeshDepthMaterial,
                    CVz: ()=>Op,
                    CWW: ()=>om,
                    Cfg: ()=>jd,
                    DXC: ()=>LineSegments,
                    Dmk: ()=>gp,
                    EZo: ()=>Tc,
                    EdD: ()=>lu,
                    FFZ: ()=>Im,
                    FV: ()=>Sd,
                    FXf: ()=>yu,
                    Fn: ()=>tm,
                    GJx: ()=>Nd,
                    GWd: ()=>_p,
                    Gu$: ()=>SphereGeometry,
                    Gwm: ()=>gd,
                    H23: ()=>im,
                    HIg: ()=>vp,
                    HO_: ()=>am,
                    HXV: ()=>Rp,
                    I9Y: ()=>Vector2,
                    IE4: ()=>Ip,
                    IUQ: ()=>Vector4,
                    Iit: ()=>mergeUniforms,
                    Jnc: ()=>Rl,
                    K52: ()=>Ad,
                    KDk: ()=>jp,
                    KLL: ()=>xm,
                    KRh: ()=>_d,
                    Kef: ()=>rm,
                    Kwu: ()=>tu,
                    Kzv: ()=>xp,
                    LAk: ()=>Cd,
                    LiQ: ()=>$u,
                    LlO: ()=>kg,
                    LoY: ()=>BufferGeometry,
                    MW4: ()=>Uint32BufferAttribute,
                    Mjd: ()=>Ed,
                    Mmk: ()=>toReversedProjectionMatrix,
                    N5j: ()=>mm,
                    NRn: ()=>Box3,
                    NTi: ()=>$l,
                    Nex: ()=>getByteLength,
                    Nt7: ()=>nd,
                    Nv2: ()=>VideoTexture,
                    Nz6: ()=>Dp,
                    O9p: ()=>Euler,
                    OUM: ()=>Zd,
                    Om: ()=>zd,
                    OuU: ()=>td,
                    PPD: ()=>Frustum,
                    PTz: ()=>Quaternion,
                    Pq0: ()=>Vector3,
                    Q1f: ()=>Color,
                    QP0: ()=>Ul,
                    Qev: ()=>EventDispatcher,
                    Qrf: ()=>Hp,
                    R3r: ()=>WebXRController,
                    RQf: ()=>Kd,
                    Riy: ()=>Fp,
                    RrE: ()=>od,
                    RyA: ()=>Zl,
                    S$4: ()=>em,
                    THS: ()=>BufferAttribute,
                    TdN: ()=>Pm,
                    TiK: ()=>Sm,
                    TkQ: ()=>Cp,
                    U3G: ()=>fd,
                    V3x: ()=>up,
                    V9B: ()=>MeshBasicMaterial,
                    VCu: ()=>DepthTexture,
                    VT0: ()=>Mp,
                    Vb5: ()=>Ll,
                    VxR: ()=>_m,
                    W9U: ()=>nm,
                    WNZ: ()=>Dl,
                    Wdf: ()=>Lm,
                    Wew: ()=>Jd,
                    Wk7: ()=>Gl,
                    XG_: ()=>sm,
                    XIg: ()=>Kl,
                    XJ7: ()=>WireframeGeometry,
                    XrR: ()=>xd,
                    YJl: ()=>Group,
                    Yuy: ()=>Yd,
                    Z58: ()=>Scene,
                    ZQM: ()=>Sp,
                    Zcv: ()=>Plane,
                    Zr2: ()=>vm,
                    _QJ: ()=>Yp,
                    _Ut: ()=>getUnlitUniformColorSpace,
                    a55: ()=>Om,
                    a5J: ()=>qp,
                    aEY: ()=>sd,
                    aHM: ()=>Loader,
                    aJ8: ()=>kd,
                    aVO: ()=>MeshDistanceMaterial,
                    amv: ()=>wm,
                    b4q: ()=>CubeTexture,
                    bC7: ()=>Xp,
                    bCz: ()=>du,
                    bI3: ()=>fm,
                    bdM: ()=>PlaneGeometry,
                    bkx: ()=>Qd,
                    brA: ()=>pd,
                    bw0: ()=>yd,
                    c90: ()=>kp,
                    cHt: ()=>qd,
                    caT: ()=>vd,
                    cj9: ()=>Fm,
                    czI: ()=>Gp,
                    dYF: ()=>Data3DTexture,
                    dcC: ()=>Ep,
                    dwI: ()=>Matrix3,
                    e0p: ()=>cd,
                    eHc: ()=>hd,
                    eaF: ()=>Mesh,
                    eoi: ()=>Tm,
                    er$: ()=>ym,
                    f4X: ()=>Ju,
                    fBL: ()=>Wd,
                    g7M: ()=>Td,
                    gJ2: ()=>$d,
                    gO9: ()=>fu,
                    gPd: ()=>Texture,
                    gWB: ()=>km,
                    ghU: ()=>Rd,
                    hB5: ()=>Hl,
                    hdd: ()=>id,
                    hgQ: ()=>ad,
                    hsX: ()=>ql,
                    hxR: ()=>Od,
                    hy7: ()=>Id,
                    iNn: ()=>BoxGeometry,
                    ie2: ()=>ed,
                    ix0: ()=>Xd,
                    jR7: ()=>Lp,
                    jej: ()=>probeAsync,
                    jf0: ()=>Am,
                    jzd: ()=>Cm,
                    k6Q: ()=>zp,
                    k6q: ()=>Ud,
                    kO0: ()=>Mm,
                    kRr: ()=>Vd,
                    kTW: ()=>Bd,
                    kTp: ()=>Np,
                    kn4: ()=>Matrix4,
                    kyO: ()=>wd,
                    l2R: ()=>Qg,
                    lGu: ()=>dd,
                    lPF: ()=>createCanvasElement,
                    lxW: ()=>cloneUniforms,
                    lyL: ()=>Kp,
                    mcG: ()=>warnOnce,
                    nNL: ()=>Md,
                    nST: ()=>Eu,
                    nWS: ()=>WebGLRenderTarget,
                    nZQ: ()=>ArrayCamera,
                    o6l: ()=>WebGLCubeRenderTarget,
                    ojh: ()=>Zu,
                    ojs: ()=>$p,
                    ov9: ()=>ud,
                    pBf: ()=>Bp,
                    pHI: ()=>Fd,
                    paN: ()=>Tp,
                    ppV: ()=>Zm,
                    psI: ()=>Wp,
                    qUd: ()=>OrthographicCamera,
                    qa3: ()=>Up,
                    qad: ()=>Xu,
                    qq$: ()=>createElementNS,
                    rFo: ()=>DataArrayTexture,
                    rSH: ()=>Zp,
                    sPf: ()=>Co,
                    tBo: ()=>Raycaster,
                    tJf: ()=>Hd,
                    uB5: ()=>Qp,
                    uV5: ()=>Pd,
                    ubm: ()=>PerspectiveCamera,
                    vim: ()=>Em,
                    vyJ: ()=>gm,
                    wfO: ()=>Ld,
                    wn6: ()=>rd,
                    wrO: ()=>Ap,
                    xFO: ()=>Dd,
                    xSv: ()=>md,
                    xiE: ()=>toNormalizedProjectionMatrix,
                    y3Z: ()=>Jp,
                    y_p: ()=>bd,
                    zdS: ()=>wp,
                    zgK: ()=>Layers,
                    znC: ()=>Tu
                });
                /**
 * @license
 * Copyright 2010-2025 Three.js Authors
 * SPDX-License-Identifier: MIT
 */ const Co = "173", Dl = 0, Ll = 1, Rl = 2, Ul = 1, Gl = 2, Zl = 3, Hl = 0, ql = 1, Ql = 2, Kl = 0, $l = 1, Tc = 2, tu = 3, lu = 4, du = 5, fu = 100, yu = 101, Eu = 102, Tu = 103, Lu = 104, Zu = 200, Xu = 201, Ju = 202, $u = 203, ed = 204, td = 205, id = 206, nd = 207, rd = 208, sd = 209, ad = 210, od = 211, ld = 212, cd = 213, ud = 214, hd = 0, dd = 1, pd = 2, md = 3, fd = 4, gd = 5, Ad = 6, yd = 7, vd = 0, _d = 1, xd = 2, bd = 0, wd = 1, Ed = 2, Md = 3, Sd = 4, Td = 5, Cd = 6, kd = 7, Id = 301, Dd = 302, Ld = 303, Pd = 304, zd = 306, Nd = 1e3, Rd = 1001, Bd = 1002, Od = 1003, Fd = 1004, jd = 1005, Ud = 1006, Vd = 1007, Gd = 1008, Zd = 1009, Hd = 1010, Wd = 1011, qd = 1012, Yd = 1013, Qd = 1014, Kd = 1015, Xd = 1016, Jd = 1017, $d = 1018, up = 1020, gp = 35902, Ap = 1021, vp = 1022, _p = 1023, xp = 1024, bp = 1025, wp = 1026, Ep = 1027, Mp = 1028, Sp = 1029, Tp = 1030, Cp = 1031, kp = 1033, Ip = 33776, Dp = 33777, Lp = 33778, Pp = 33779, zp = 35840, Np = 35841, Rp = 35842, Bp = 35843, Op = 36196, Fp = 37492, jp = 37496, Up = 37808, Vp = 37809, Gp = 37810, Zp = 37811, Hp = 37812, Wp = 37813, qp = 37814, Yp = 37815, Qp = 37816, Kp = 37817, Xp = 37818, Jp = 37819, $p = 37820, em = 37821, tm = 36492, im = 36494, nm = 36495, rm = 36283, sm = 36284, am = 36285, om = 36286, lm = 2300, cm = 2301, um = 2302, hm = 2400, dm = 2401, pm = 2402, mm = 3201, fm = 0, gm = 1, Am = "", ym = "srgb", vm = "srgb-linear", _m = "linear", xm = "srgb", bm = 7680, wm = 512, Em = 513, Mm = 514, Sm = 515, Tm = 516, Cm = 517, km = 518, Im = 519, Dm = 35044, Lm = "300 es", Pm = 2e3, zm = 2001;
                class EventDispatcher {
                    addEventListener(Qe, rt) {
                        void 0 === this._listeners && (this._listeners = {});
                        const Wn = this._listeners;
                        void 0 === Wn[Qe] && (Wn[Qe] = []), -1 === Wn[Qe].indexOf(rt) && Wn[Qe].push(rt);
                    }
                    hasEventListener(Qe, rt) {
                        const Wn = this._listeners;
                        return void 0 !== Wn && void 0 !== Wn[Qe] && -1 !== Wn[Qe].indexOf(rt);
                    }
                    removeEventListener(Qe, rt) {
                        const Wn = this._listeners;
                        if (void 0 === Wn) return;
                        const Co = Wn[Qe];
                        if (void 0 !== Co) {
                            const Qe = Co.indexOf(rt);
                            -1 !== Qe && Co.splice(Qe, 1);
                        }
                    }
                    dispatchEvent(Qe) {
                        const rt = this._listeners;
                        if (void 0 === rt) return;
                        const Wn = rt[Qe.type];
                        if (void 0 !== Wn) {
                            Qe.target = this;
                            const rt = Wn.slice(0);
                            for(let Wn = 0, Co = rt.length; Wn < Co; Wn++)rt[Wn].call(this, Qe);
                            Qe.target = null;
                        }
                    }
                }
                const Nm = [
                    "00",
                    "01",
                    "02",
                    "03",
                    "04",
                    "05",
                    "06",
                    "07",
                    "08",
                    "09",
                    "0a",
                    "0b",
                    "0c",
                    "0d",
                    "0e",
                    "0f",
                    "10",
                    "11",
                    "12",
                    "13",
                    "14",
                    "15",
                    "16",
                    "17",
                    "18",
                    "19",
                    "1a",
                    "1b",
                    "1c",
                    "1d",
                    "1e",
                    "1f",
                    "20",
                    "21",
                    "22",
                    "23",
                    "24",
                    "25",
                    "26",
                    "27",
                    "28",
                    "29",
                    "2a",
                    "2b",
                    "2c",
                    "2d",
                    "2e",
                    "2f",
                    "30",
                    "31",
                    "32",
                    "33",
                    "34",
                    "35",
                    "36",
                    "37",
                    "38",
                    "39",
                    "3a",
                    "3b",
                    "3c",
                    "3d",
                    "3e",
                    "3f",
                    "40",
                    "41",
                    "42",
                    "43",
                    "44",
                    "45",
                    "46",
                    "47",
                    "48",
                    "49",
                    "4a",
                    "4b",
                    "4c",
                    "4d",
                    "4e",
                    "4f",
                    "50",
                    "51",
                    "52",
                    "53",
                    "54",
                    "55",
                    "56",
                    "57",
                    "58",
                    "59",
                    "5a",
                    "5b",
                    "5c",
                    "5d",
                    "5e",
                    "5f",
                    "60",
                    "61",
                    "62",
                    "63",
                    "64",
                    "65",
                    "66",
                    "67",
                    "68",
                    "69",
                    "6a",
                    "6b",
                    "6c",
                    "6d",
                    "6e",
                    "6f",
                    "70",
                    "71",
                    "72",
                    "73",
                    "74",
                    "75",
                    "76",
                    "77",
                    "78",
                    "79",
                    "7a",
                    "7b",
                    "7c",
                    "7d",
                    "7e",
                    "7f",
                    "80",
                    "81",
                    "82",
                    "83",
                    "84",
                    "85",
                    "86",
                    "87",
                    "88",
                    "89",
                    "8a",
                    "8b",
                    "8c",
                    "8d",
                    "8e",
                    "8f",
                    "90",
                    "91",
                    "92",
                    "93",
                    "94",
                    "95",
                    "96",
                    "97",
                    "98",
                    "99",
                    "9a",
                    "9b",
                    "9c",
                    "9d",
                    "9e",
                    "9f",
                    "a0",
                    "a1",
                    "a2",
                    "a3",
                    "a4",
                    "a5",
                    "a6",
                    "a7",
                    "a8",
                    "a9",
                    "aa",
                    "ab",
                    "ac",
                    "ad",
                    "ae",
                    "af",
                    "b0",
                    "b1",
                    "b2",
                    "b3",
                    "b4",
                    "b5",
                    "b6",
                    "b7",
                    "b8",
                    "b9",
                    "ba",
                    "bb",
                    "bc",
                    "bd",
                    "be",
                    "bf",
                    "c0",
                    "c1",
                    "c2",
                    "c3",
                    "c4",
                    "c5",
                    "c6",
                    "c7",
                    "c8",
                    "c9",
                    "ca",
                    "cb",
                    "cc",
                    "cd",
                    "ce",
                    "cf",
                    "d0",
                    "d1",
                    "d2",
                    "d3",
                    "d4",
                    "d5",
                    "d6",
                    "d7",
                    "d8",
                    "d9",
                    "da",
                    "db",
                    "dc",
                    "dd",
                    "de",
                    "df",
                    "e0",
                    "e1",
                    "e2",
                    "e3",
                    "e4",
                    "e5",
                    "e6",
                    "e7",
                    "e8",
                    "e9",
                    "ea",
                    "eb",
                    "ec",
                    "ed",
                    "ee",
                    "ef",
                    "f0",
                    "f1",
                    "f2",
                    "f3",
                    "f4",
                    "f5",
                    "f6",
                    "f7",
                    "f8",
                    "f9",
                    "fa",
                    "fb",
                    "fc",
                    "fd",
                    "fe",
                    "ff"
                ];
                let Rm = 1234567;
                const Bm = Math.PI / 180, Om = 180 / Math.PI;
                function generateUUID() {
                    const Qe = 4294967295 * Math.random() | 0, rt = 4294967295 * Math.random() | 0, Wn = 4294967295 * Math.random() | 0, Co = 4294967295 * Math.random() | 0;
                    return (Nm[255 & Qe] + Nm[Qe >> 8 & 255] + Nm[Qe >> 16 & 255] + Nm[Qe >> 24 & 255] + "-" + Nm[255 & rt] + Nm[rt >> 8 & 255] + "-" + Nm[rt >> 16 & 15 | 64] + Nm[rt >> 24 & 255] + "-" + Nm[63 & Wn | 128] + Nm[Wn >> 8 & 255] + "-" + Nm[Wn >> 16 & 255] + Nm[Wn >> 24 & 255] + Nm[255 & Co] + Nm[Co >> 8 & 255] + Nm[Co >> 16 & 255] + Nm[Co >> 24 & 255]).toLowerCase();
                }
                function clamp(Qe, rt, Wn) {
                    return Math.max(rt, Math.min(Wn, Qe));
                }
                function euclideanModulo(Qe, rt) {
                    return (Qe % rt + rt) % rt;
                }
                function lerp(Qe, rt, Wn) {
                    return (1 - Wn) * Qe + Wn * rt;
                }
                function denormalize(Qe, rt) {
                    switch(rt.constructor){
                        case Float32Array:
                            return Qe;
                        case Uint32Array:
                            return Qe / 4294967295;
                        case Uint16Array:
                            return Qe / 65535;
                        case Uint8Array:
                            return Qe / 255;
                        case Int32Array:
                            return Math.max(Qe / 2147483647, -1);
                        case Int16Array:
                            return Math.max(Qe / 32767, -1);
                        case Int8Array:
                            return Math.max(Qe / 127, -1);
                        default:
                            throw new Error("Invalid component type.");
                    }
                }
                function normalize(Qe, rt) {
                    switch(rt.constructor){
                        case Float32Array:
                            return Qe;
                        case Uint32Array:
                            return Math.round(4294967295 * Qe);
                        case Uint16Array:
                            return Math.round(65535 * Qe);
                        case Uint8Array:
                            return Math.round(255 * Qe);
                        case Int32Array:
                            return Math.round(2147483647 * Qe);
                        case Int16Array:
                            return Math.round(32767 * Qe);
                        case Int8Array:
                            return Math.round(127 * Qe);
                        default:
                            throw new Error("Invalid component type.");
                    }
                }
                const Fm = {
                    DEG2RAD: Bm,
                    RAD2DEG: Om,
                    generateUUID: generateUUID,
                    clamp: clamp,
                    euclideanModulo: euclideanModulo,
                    mapLinear: function(Qe, rt, Wn, Co, Dl) {
                        return Co + (Qe - rt) * (Dl - Co) / (Wn - rt);
                    },
                    inverseLerp: function(Qe, rt, Wn) {
                        return Qe !== rt ? (Wn - Qe) / (rt - Qe) : 0;
                    },
                    lerp: lerp,
                    damp: function(Qe, rt, Wn, Co) {
                        return lerp(Qe, rt, 1 - Math.exp(-Wn * Co));
                    },
                    pingpong: function(Qe, rt) {
                        return void 0 === rt && (rt = 1), rt - Math.abs(euclideanModulo(Qe, 2 * rt) - rt);
                    },
                    smoothstep: function(Qe, rt, Wn) {
                        return Qe <= rt ? 0 : Qe >= Wn ? 1 : (Qe = (Qe - rt) / (Wn - rt)) * Qe * (3 - 2 * Qe);
                    },
                    smootherstep: function(Qe, rt, Wn) {
                        return Qe <= rt ? 0 : Qe >= Wn ? 1 : (Qe = (Qe - rt) / (Wn - rt)) * Qe * Qe * (Qe * (6 * Qe - 15) + 10);
                    },
                    randInt: function(Qe, rt) {
                        return Qe + Math.floor(Math.random() * (rt - Qe + 1));
                    },
                    randFloat: function(Qe, rt) {
                        return Qe + Math.random() * (rt - Qe);
                    },
                    randFloatSpread: function(Qe) {
                        return Qe * (.5 - Math.random());
                    },
                    seededRandom: function(Qe) {
                        void 0 !== Qe && (Rm = Qe);
                        let rt = Rm += 1831565813;
                        return rt = Math.imul(rt ^ rt >>> 15, 1 | rt), rt ^= rt + Math.imul(rt ^ rt >>> 7, 61 | rt), ((rt ^ rt >>> 14) >>> 0) / 4294967296;
                    },
                    degToRad: function(Qe) {
                        return Qe * Bm;
                    },
                    radToDeg: function(Qe) {
                        return Qe * Om;
                    },
                    isPowerOfTwo: function(Qe) {
                        return 0 === (Qe & Qe - 1) && 0 !== Qe;
                    },
                    ceilPowerOfTwo: function(Qe) {
                        return Math.pow(2, Math.ceil(Math.log(Qe) / Math.LN2));
                    },
                    floorPowerOfTwo: function(Qe) {
                        return Math.pow(2, Math.floor(Math.log(Qe) / Math.LN2));
                    },
                    setQuaternionFromProperEuler: function(Qe, rt, Wn, Co, Dl) {
                        const Ll = Math.cos, Rl = Math.sin, Ul = Ll(Wn / 2), Gl = Rl(Wn / 2), Zl = Ll((rt + Co) / 2), Hl = Rl((rt + Co) / 2), ql = Ll((rt - Co) / 2), Ql = Rl((rt - Co) / 2), Kl = Ll((Co - rt) / 2), $l = Rl((Co - rt) / 2);
                        switch(Dl){
                            case "XYX":
                                Qe.set(Ul * Hl, Gl * ql, Gl * Ql, Ul * Zl);
                                break;
                            case "YZY":
                                Qe.set(Gl * Ql, Ul * Hl, Gl * ql, Ul * Zl);
                                break;
                            case "ZXZ":
                                Qe.set(Gl * ql, Gl * Ql, Ul * Hl, Ul * Zl);
                                break;
                            case "XZX":
                                Qe.set(Ul * Hl, Gl * $l, Gl * Kl, Ul * Zl);
                                break;
                            case "YXY":
                                Qe.set(Gl * Kl, Ul * Hl, Gl * $l, Ul * Zl);
                                break;
                            case "ZYZ":
                                Qe.set(Gl * $l, Gl * Kl, Ul * Hl, Ul * Zl);
                                break;
                            default:
                                console.warn("THREE.MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: " + Dl);
                        }
                    },
                    normalize: normalize,
                    denormalize: denormalize
                };
                class Vector2 {
                    constructor(Qe, rt){
                        void 0 === Qe && (Qe = 0), void 0 === rt && (rt = 0), Vector2.prototype.isVector2 = !0, this.x = Qe, this.y = rt;
                    }
                    get width() {
                        return this.x;
                    }
                    set width(Qe) {
                        this.x = Qe;
                    }
                    get height() {
                        return this.y;
                    }
                    set height(Qe) {
                        this.y = Qe;
                    }
                    set(Qe, rt) {
                        return this.x = Qe, this.y = rt, this;
                    }
                    setScalar(Qe) {
                        return this.x = Qe, this.y = Qe, this;
                    }
                    setX(Qe) {
                        return this.x = Qe, this;
                    }
                    setY(Qe) {
                        return this.y = Qe, this;
                    }
                    setComponent(Qe, rt) {
                        switch(Qe){
                            case 0:
                                this.x = rt;
                                break;
                            case 1:
                                this.y = rt;
                                break;
                            default:
                                throw new Error("index is out of range: " + Qe);
                        }
                        return this;
                    }
                    getComponent(Qe) {
                        switch(Qe){
                            case 0:
                                return this.x;
                            case 1:
                                return this.y;
                            default:
                                throw new Error("index is out of range: " + Qe);
                        }
                    }
                    clone() {
                        return new this.constructor(this.x, this.y);
                    }
                    copy(Qe) {
                        return this.x = Qe.x, this.y = Qe.y, this;
                    }
                    add(Qe) {
                        return this.x += Qe.x, this.y += Qe.y, this;
                    }
                    addScalar(Qe) {
                        return this.x += Qe, this.y += Qe, this;
                    }
                    addVectors(Qe, rt) {
                        return this.x = Qe.x + rt.x, this.y = Qe.y + rt.y, this;
                    }
                    addScaledVector(Qe, rt) {
                        return this.x += Qe.x * rt, this.y += Qe.y * rt, this;
                    }
                    sub(Qe) {
                        return this.x -= Qe.x, this.y -= Qe.y, this;
                    }
                    subScalar(Qe) {
                        return this.x -= Qe, this.y -= Qe, this;
                    }
                    subVectors(Qe, rt) {
                        return this.x = Qe.x - rt.x, this.y = Qe.y - rt.y, this;
                    }
                    multiply(Qe) {
                        return this.x *= Qe.x, this.y *= Qe.y, this;
                    }
                    multiplyScalar(Qe) {
                        return this.x *= Qe, this.y *= Qe, this;
                    }
                    divide(Qe) {
                        return this.x /= Qe.x, this.y /= Qe.y, this;
                    }
                    divideScalar(Qe) {
                        return this.multiplyScalar(1 / Qe);
                    }
                    applyMatrix3(Qe) {
                        const rt = this.x, Wn = this.y, Co = Qe.elements;
                        return this.x = Co[0] * rt + Co[3] * Wn + Co[6], this.y = Co[1] * rt + Co[4] * Wn + Co[7], this;
                    }
                    min(Qe) {
                        return this.x = Math.min(this.x, Qe.x), this.y = Math.min(this.y, Qe.y), this;
                    }
                    max(Qe) {
                        return this.x = Math.max(this.x, Qe.x), this.y = Math.max(this.y, Qe.y), this;
                    }
                    clamp(Qe, rt) {
                        return this.x = clamp(this.x, Qe.x, rt.x), this.y = clamp(this.y, Qe.y, rt.y), this;
                    }
                    clampScalar(Qe, rt) {
                        return this.x = clamp(this.x, Qe, rt), this.y = clamp(this.y, Qe, rt), this;
                    }
                    clampLength(Qe, rt) {
                        const Wn = this.length();
                        return this.divideScalar(Wn || 1).multiplyScalar(clamp(Wn, Qe, rt));
                    }
                    floor() {
                        return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this;
                    }
                    ceil() {
                        return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this;
                    }
                    round() {
                        return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
                    }
                    roundToZero() {
                        return this.x = Math.trunc(this.x), this.y = Math.trunc(this.y), this;
                    }
                    negate() {
                        return this.x = -this.x, this.y = -this.y, this;
                    }
                    dot(Qe) {
                        return this.x * Qe.x + this.y * Qe.y;
                    }
                    cross(Qe) {
                        return this.x * Qe.y - this.y * Qe.x;
                    }
                    lengthSq() {
                        return this.x * this.x + this.y * this.y;
                    }
                    length() {
                        return Math.sqrt(this.x * this.x + this.y * this.y);
                    }
                    manhattanLength() {
                        return Math.abs(this.x) + Math.abs(this.y);
                    }
                    normalize() {
                        return this.divideScalar(this.length() || 1);
                    }
                    angle() {
                        return Math.atan2(-this.y, -this.x) + Math.PI;
                    }
                    angleTo(Qe) {
                        const rt = Math.sqrt(this.lengthSq() * Qe.lengthSq());
                        if (0 === rt) return Math.PI / 2;
                        const Wn = this.dot(Qe) / rt;
                        return Math.acos(clamp(Wn, -1, 1));
                    }
                    distanceTo(Qe) {
                        return Math.sqrt(this.distanceToSquared(Qe));
                    }
                    distanceToSquared(Qe) {
                        const rt = this.x - Qe.x, Wn = this.y - Qe.y;
                        return rt * rt + Wn * Wn;
                    }
                    manhattanDistanceTo(Qe) {
                        return Math.abs(this.x - Qe.x) + Math.abs(this.y - Qe.y);
                    }
                    setLength(Qe) {
                        return this.normalize().multiplyScalar(Qe);
                    }
                    lerp(Qe, rt) {
                        return this.x += (Qe.x - this.x) * rt, this.y += (Qe.y - this.y) * rt, this;
                    }
                    lerpVectors(Qe, rt, Wn) {
                        return this.x = Qe.x + (rt.x - Qe.x) * Wn, this.y = Qe.y + (rt.y - Qe.y) * Wn, this;
                    }
                    equals(Qe) {
                        return Qe.x === this.x && Qe.y === this.y;
                    }
                    fromArray(Qe, rt) {
                        return void 0 === rt && (rt = 0), this.x = Qe[rt], this.y = Qe[rt + 1], this;
                    }
                    toArray(Qe, rt) {
                        return void 0 === Qe && (Qe = []), void 0 === rt && (rt = 0), Qe[rt] = this.x, Qe[rt + 1] = this.y, Qe;
                    }
                    fromBufferAttribute(Qe, rt) {
                        return this.x = Qe.getX(rt), this.y = Qe.getY(rt), this;
                    }
                    rotateAround(Qe, rt) {
                        const Wn = Math.cos(rt), Co = Math.sin(rt), Dl = this.x - Qe.x, Ll = this.y - Qe.y;
                        return this.x = Dl * Wn - Ll * Co + Qe.x, this.y = Dl * Co + Ll * Wn + Qe.y, this;
                    }
                    random() {
                        return this.x = Math.random(), this.y = Math.random(), this;
                    }
                    *[Symbol.iterator]() {
                        yield this.x, yield this.y;
                    }
                }
                class Matrix3 {
                    constructor(Qe, rt, Wn, Co, Dl, Ll, Rl, Ul, Gl){
                        Matrix3.prototype.isMatrix3 = !0, this.elements = [
                            1,
                            0,
                            0,
                            0,
                            1,
                            0,
                            0,
                            0,
                            1
                        ], void 0 !== Qe && this.set(Qe, rt, Wn, Co, Dl, Ll, Rl, Ul, Gl);
                    }
                    set(Qe, rt, Wn, Co, Dl, Ll, Rl, Ul, Gl) {
                        const Zl = this.elements;
                        return Zl[0] = Qe, Zl[1] = Co, Zl[2] = Rl, Zl[3] = rt, Zl[4] = Dl, Zl[5] = Ul, Zl[6] = Wn, Zl[7] = Ll, Zl[8] = Gl, this;
                    }
                    identity() {
                        return this.set(1, 0, 0, 0, 1, 0, 0, 0, 1), this;
                    }
                    copy(Qe) {
                        const rt = this.elements, Wn = Qe.elements;
                        return rt[0] = Wn[0], rt[1] = Wn[1], rt[2] = Wn[2], rt[3] = Wn[3], rt[4] = Wn[4], rt[5] = Wn[5], rt[6] = Wn[6], rt[7] = Wn[7], rt[8] = Wn[8], this;
                    }
                    extractBasis(Qe, rt, Wn) {
                        return Qe.setFromMatrix3Column(this, 0), rt.setFromMatrix3Column(this, 1), Wn.setFromMatrix3Column(this, 2), this;
                    }
                    setFromMatrix4(Qe) {
                        const rt = Qe.elements;
                        return this.set(rt[0], rt[4], rt[8], rt[1], rt[5], rt[9], rt[2], rt[6], rt[10]), this;
                    }
                    multiply(Qe) {
                        return this.multiplyMatrices(this, Qe);
                    }
                    premultiply(Qe) {
                        return this.multiplyMatrices(Qe, this);
                    }
                    multiplyMatrices(Qe, rt) {
                        const Wn = Qe.elements, Co = rt.elements, Dl = this.elements, Ll = Wn[0], Rl = Wn[3], Ul = Wn[6], Gl = Wn[1], Zl = Wn[4], Hl = Wn[7], ql = Wn[2], Ql = Wn[5], Kl = Wn[8], $l = Co[0], Tc = Co[3], tu = Co[6], lu = Co[1], du = Co[4], fu = Co[7], yu = Co[2], Eu = Co[5], Tu = Co[8];
                        return Dl[0] = Ll * $l + Rl * lu + Ul * yu, Dl[3] = Ll * Tc + Rl * du + Ul * Eu, Dl[6] = Ll * tu + Rl * fu + Ul * Tu, Dl[1] = Gl * $l + Zl * lu + Hl * yu, Dl[4] = Gl * Tc + Zl * du + Hl * Eu, Dl[7] = Gl * tu + Zl * fu + Hl * Tu, Dl[2] = ql * $l + Ql * lu + Kl * yu, Dl[5] = ql * Tc + Ql * du + Kl * Eu, Dl[8] = ql * tu + Ql * fu + Kl * Tu, this;
                    }
                    multiplyScalar(Qe) {
                        const rt = this.elements;
                        return rt[0] *= Qe, rt[3] *= Qe, rt[6] *= Qe, rt[1] *= Qe, rt[4] *= Qe, rt[7] *= Qe, rt[2] *= Qe, rt[5] *= Qe, rt[8] *= Qe, this;
                    }
                    determinant() {
                        const Qe = this.elements, rt = Qe[0], Wn = Qe[1], Co = Qe[2], Dl = Qe[3], Ll = Qe[4], Rl = Qe[5], Ul = Qe[6], Gl = Qe[7], Zl = Qe[8];
                        return rt * Ll * Zl - rt * Rl * Gl - Wn * Dl * Zl + Wn * Rl * Ul + Co * Dl * Gl - Co * Ll * Ul;
                    }
                    invert() {
                        const Qe = this.elements, rt = Qe[0], Wn = Qe[1], Co = Qe[2], Dl = Qe[3], Ll = Qe[4], Rl = Qe[5], Ul = Qe[6], Gl = Qe[7], Zl = Qe[8], Hl = Zl * Ll - Rl * Gl, ql = Rl * Ul - Zl * Dl, Ql = Gl * Dl - Ll * Ul, Kl = rt * Hl + Wn * ql + Co * Ql;
                        if (0 === Kl) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
                        const $l = 1 / Kl;
                        return Qe[0] = Hl * $l, Qe[1] = (Co * Gl - Zl * Wn) * $l, Qe[2] = (Rl * Wn - Co * Ll) * $l, Qe[3] = ql * $l, Qe[4] = (Zl * rt - Co * Ul) * $l, Qe[5] = (Co * Dl - Rl * rt) * $l, Qe[6] = Ql * $l, Qe[7] = (Wn * Ul - Gl * rt) * $l, Qe[8] = (Ll * rt - Wn * Dl) * $l, this;
                    }
                    transpose() {
                        let Qe;
                        const rt = this.elements;
                        return Qe = rt[1], rt[1] = rt[3], rt[3] = Qe, Qe = rt[2], rt[2] = rt[6], rt[6] = Qe, Qe = rt[5], rt[5] = rt[7], rt[7] = Qe, this;
                    }
                    getNormalMatrix(Qe) {
                        return this.setFromMatrix4(Qe).invert().transpose();
                    }
                    transposeIntoArray(Qe) {
                        const rt = this.elements;
                        return Qe[0] = rt[0], Qe[1] = rt[3], Qe[2] = rt[6], Qe[3] = rt[1], Qe[4] = rt[4], Qe[5] = rt[7], Qe[6] = rt[2], Qe[7] = rt[5], Qe[8] = rt[8], this;
                    }
                    setUvTransform(Qe, rt, Wn, Co, Dl, Ll, Rl) {
                        const Ul = Math.cos(Dl), Gl = Math.sin(Dl);
                        return this.set(Wn * Ul, Wn * Gl, -Wn * (Ul * Ll + Gl * Rl) + Ll + Qe, -Co * Gl, Co * Ul, -Co * (-Gl * Ll + Ul * Rl) + Rl + rt, 0, 0, 1), this;
                    }
                    scale(Qe, rt) {
                        return this.premultiply(jm.makeScale(Qe, rt)), this;
                    }
                    rotate(Qe) {
                        return this.premultiply(jm.makeRotation(-Qe)), this;
                    }
                    translate(Qe, rt) {
                        return this.premultiply(jm.makeTranslation(Qe, rt)), this;
                    }
                    makeTranslation(Qe, rt) {
                        return Qe.isVector2 ? this.set(1, 0, Qe.x, 0, 1, Qe.y, 0, 0, 1) : this.set(1, 0, Qe, 0, 1, rt, 0, 0, 1), this;
                    }
                    makeRotation(Qe) {
                        const rt = Math.cos(Qe), Wn = Math.sin(Qe);
                        return this.set(rt, -Wn, 0, Wn, rt, 0, 0, 0, 1), this;
                    }
                    makeScale(Qe, rt) {
                        return this.set(Qe, 0, 0, 0, rt, 0, 0, 0, 1), this;
                    }
                    equals(Qe) {
                        const rt = this.elements, Wn = Qe.elements;
                        for(let Co = 0; Co < 9; Co++)if (rt[Co] !== Wn[Co]) return !1;
                        return !0;
                    }
                    fromArray(Qe, rt) {
                        void 0 === rt && (rt = 0);
                        for(let Wn = 0; Wn < 9; Wn++)this.elements[Wn] = Qe[Wn + rt];
                        return this;
                    }
                    toArray(Qe, rt) {
                        void 0 === Qe && (Qe = []), void 0 === rt && (rt = 0);
                        const Wn = this.elements;
                        return Qe[rt] = Wn[0], Qe[rt + 1] = Wn[1], Qe[rt + 2] = Wn[2], Qe[rt + 3] = Wn[3], Qe[rt + 4] = Wn[4], Qe[rt + 5] = Wn[5], Qe[rt + 6] = Wn[6], Qe[rt + 7] = Wn[7], Qe[rt + 8] = Wn[8], Qe;
                    }
                    clone() {
                        return (new this.constructor).fromArray(this.elements);
                    }
                }
                const jm = new Matrix3;
                function arrayNeedsUint32(Qe) {
                    for(let rt = Qe.length - 1; rt >= 0; --rt)if (Qe[rt] >= 65535) return !0;
                    return !1;
                }
                Int8Array, Uint8Array, Uint8ClampedArray, Int16Array, Uint16Array, Int32Array, Uint32Array, Float32Array, Float64Array;
                function createElementNS(Qe) {
                    return document.createElementNS("http://www.w3.org/1999/xhtml", Qe);
                }
                function createCanvasElement() {
                    const Qe = createElementNS("canvas");
                    return Qe.style.display = "block", Qe;
                }
                const Um = {};
                function warnOnce(Qe) {
                    Qe in Um || (Um[Qe] = !0, console.warn(Qe));
                }
                function probeAsync(Qe, rt, Wn) {
                    return new Promise(function(Co, Dl) {
                        setTimeout(function probe() {
                            switch(Qe.clientWaitSync(rt, Qe.SYNC_FLUSH_COMMANDS_BIT, 0)){
                                case Qe.WAIT_FAILED:
                                    Dl();
                                    break;
                                case Qe.TIMEOUT_EXPIRED:
                                    setTimeout(probe, Wn);
                                    break;
                                default:
                                    Co();
                            }
                        }, Wn);
                    });
                }
                function toNormalizedProjectionMatrix(Qe) {
                    const rt = Qe.elements;
                    rt[2] = .5 * rt[2] + .5 * rt[3], rt[6] = .5 * rt[6] + .5 * rt[7], rt[10] = .5 * rt[10] + .5 * rt[11], rt[14] = .5 * rt[14] + .5 * rt[15];
                }
                function toReversedProjectionMatrix(Qe) {
                    const rt = Qe.elements;
                    -1 === rt[11] ? (rt[10] = -rt[10] - 1, rt[14] = -rt[14]) : (rt[10] = -rt[10], rt[14] = 1 - rt[14]);
                }
                const Vm = (new Matrix3).set(.4123908, .3575843, .1804808, .212639, .7151687, .0721923, .0193308, .1191948, .9505322), Gm = (new Matrix3).set(3.2409699, -1.5373832, -0.4986108, -0.9692436, 1.8759675, .0415551, .0556301, -0.203977, 1.0569715);
                function createColorManagement() {
                    const Qe = {
                        enabled: !0,
                        workingColorSpace: vm,
                        spaces: {},
                        convert: function(Qe, rt, Wn) {
                            return !1 !== this.enabled && rt !== Wn && rt && Wn ? (this.spaces[rt].transfer === xm && (Qe.r = SRGBToLinear(Qe.r), Qe.g = SRGBToLinear(Qe.g), Qe.b = SRGBToLinear(Qe.b)), this.spaces[rt].primaries !== this.spaces[Wn].primaries && (Qe.applyMatrix3(this.spaces[rt].toXYZ), Qe.applyMatrix3(this.spaces[Wn].fromXYZ)), this.spaces[Wn].transfer === xm && (Qe.r = LinearToSRGB(Qe.r), Qe.g = LinearToSRGB(Qe.g), Qe.b = LinearToSRGB(Qe.b)), Qe) : Qe;
                        },
                        fromWorkingColorSpace: function(Qe, rt) {
                            return this.convert(Qe, this.workingColorSpace, rt);
                        },
                        toWorkingColorSpace: function(Qe, rt) {
                            return this.convert(Qe, rt, this.workingColorSpace);
                        },
                        getPrimaries: function(Qe) {
                            return this.spaces[Qe].primaries;
                        },
                        getTransfer: function(Qe) {
                            return Qe === Am ? _m : this.spaces[Qe].transfer;
                        },
                        getLuminanceCoefficients: function(Qe, rt) {
                            return void 0 === rt && (rt = this.workingColorSpace), Qe.fromArray(this.spaces[rt].luminanceCoefficients);
                        },
                        define: function(Qe) {
                            Object.assign(this.spaces, Qe);
                        },
                        _getMatrix: function(Qe, rt, Wn) {
                            return Qe.copy(this.spaces[rt].toXYZ).multiply(this.spaces[Wn].fromXYZ);
                        },
                        _getDrawingBufferColorSpace: function(Qe) {
                            return this.spaces[Qe].outputColorSpaceConfig.drawingBufferColorSpace;
                        },
                        _getUnpackColorSpace: function(Qe) {
                            return void 0 === Qe && (Qe = this.workingColorSpace), this.spaces[Qe].workingColorSpaceConfig.unpackColorSpace;
                        }
                    }, rt = [
                        .64,
                        .33,
                        .3,
                        .6,
                        .15,
                        .06
                    ], Wn = [
                        .2126,
                        .7152,
                        .0722
                    ], Co = [
                        .3127,
                        .329
                    ];
                    return Qe.define({
                        [vm]: {
                            primaries: rt,
                            whitePoint: Co,
                            transfer: _m,
                            toXYZ: Vm,
                            fromXYZ: Gm,
                            luminanceCoefficients: Wn,
                            workingColorSpaceConfig: {
                                unpackColorSpace: ym
                            },
                            outputColorSpaceConfig: {
                                drawingBufferColorSpace: ym
                            }
                        },
                        [ym]: {
                            primaries: rt,
                            whitePoint: Co,
                            transfer: xm,
                            toXYZ: Vm,
                            fromXYZ: Gm,
                            luminanceCoefficients: Wn,
                            outputColorSpaceConfig: {
                                drawingBufferColorSpace: ym
                            }
                        }
                    }), Qe;
                }
                const Zm = createColorManagement();
                function SRGBToLinear(Qe) {
                    return Qe < .04045 ? .0773993808 * Qe : Math.pow(.9478672986 * Qe + .0521327014, 2.4);
                }
                function LinearToSRGB(Qe) {
                    return Qe < .0031308 ? 12.92 * Qe : 1.055 * Math.pow(Qe, .41666) - .055;
                }
                let Hm;
                class ImageUtils {
                    static getDataURL(Qe) {
                        if (/^data:/i.test(Qe.src)) return Qe.src;
                        if ("undefined" === typeof HTMLCanvasElement) return Qe.src;
                        let rt;
                        if (Qe instanceof HTMLCanvasElement) rt = Qe;
                        else {
                            void 0 === Hm && (Hm = createElementNS("canvas")), Hm.width = Qe.width, Hm.height = Qe.height;
                            const Wn = Hm.getContext("2d");
                            Qe instanceof ImageData ? Wn.putImageData(Qe, 0, 0) : Wn.drawImage(Qe, 0, 0, Qe.width, Qe.height), rt = Hm;
                        }
                        return rt.toDataURL("image/png");
                    }
                    static sRGBToLinear(Qe) {
                        if ("undefined" !== typeof HTMLImageElement && Qe instanceof HTMLImageElement || "undefined" !== typeof HTMLCanvasElement && Qe instanceof HTMLCanvasElement || "undefined" !== typeof ImageBitmap && Qe instanceof ImageBitmap) {
                            const rt = createElementNS("canvas");
                            rt.width = Qe.width, rt.height = Qe.height;
                            const Wn = rt.getContext("2d");
                            Wn.drawImage(Qe, 0, 0, Qe.width, Qe.height);
                            const Co = Wn.getImageData(0, 0, Qe.width, Qe.height), Dl = Co.data;
                            for(let Qe = 0; Qe < Dl.length; Qe++)Dl[Qe] = 255 * SRGBToLinear(Dl[Qe] / 255);
                            return Wn.putImageData(Co, 0, 0), rt;
                        }
                        if (Qe.data) {
                            const rt = Qe.data.slice(0);
                            for(let Qe = 0; Qe < rt.length; Qe++)rt instanceof Uint8Array || rt instanceof Uint8ClampedArray ? rt[Qe] = Math.floor(255 * SRGBToLinear(rt[Qe] / 255)) : rt[Qe] = SRGBToLinear(rt[Qe]);
                            return {
                                data: rt,
                                width: Qe.width,
                                height: Qe.height
                            };
                        }
                        return console.warn("THREE.ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied."), Qe;
                    }
                }
                let Wm = 0;
                class Source {
                    constructor(Qe){
                        void 0 === Qe && (Qe = null), this.isSource = !0, Object.defineProperty(this, "id", {
                            value: Wm++
                        }), this.uuid = generateUUID(), this.data = Qe, this.dataReady = !0, this.version = 0;
                    }
                    set needsUpdate(Qe) {
                        !0 === Qe && this.version++;
                    }
                    toJSON(Qe) {
                        const rt = void 0 === Qe || "string" === typeof Qe;
                        if (!rt && void 0 !== Qe.images[this.uuid]) return Qe.images[this.uuid];
                        const Wn = {
                            uuid: this.uuid,
                            url: ""
                        }, Co = this.data;
                        if (null !== Co) {
                            let Qe;
                            if (Array.isArray(Co)) {
                                Qe = [];
                                for(let rt = 0, Wn = Co.length; rt < Wn; rt++)Co[rt].isDataTexture ? Qe.push(serializeImage(Co[rt].image)) : Qe.push(serializeImage(Co[rt]));
                            } else Qe = serializeImage(Co);
                            Wn.url = Qe;
                        }
                        return rt || (Qe.images[this.uuid] = Wn), Wn;
                    }
                }
                function serializeImage(Qe) {
                    return "undefined" !== typeof HTMLImageElement && Qe instanceof HTMLImageElement || "undefined" !== typeof HTMLCanvasElement && Qe instanceof HTMLCanvasElement || "undefined" !== typeof ImageBitmap && Qe instanceof ImageBitmap ? ImageUtils.getDataURL(Qe) : Qe.data ? {
                        data: Array.from(Qe.data),
                        width: Qe.width,
                        height: Qe.height,
                        type: Qe.data.constructor.name
                    } : (console.warn("THREE.Texture: Unable to serialize Texture."), {});
                }
                let qm = 0;
                class Texture extends EventDispatcher {
                    constructor(Qe, rt, Wn, Co, Dl, Ll, Rl, Ul, Gl, Zl){
                        void 0 === Qe && (Qe = Texture.DEFAULT_IMAGE), void 0 === rt && (rt = Texture.DEFAULT_MAPPING), void 0 === Wn && (Wn = Rd), void 0 === Co && (Co = Rd), void 0 === Dl && (Dl = Ud), void 0 === Ll && (Ll = Gd), void 0 === Rl && (Rl = _p), void 0 === Ul && (Ul = Zd), void 0 === Gl && (Gl = Texture.DEFAULT_ANISOTROPY), void 0 === Zl && (Zl = Am), super(), this.isTexture = !0, Object.defineProperty(this, "id", {
                            value: qm++
                        }), this.uuid = generateUUID(), this.name = "", this.source = new Source(Qe), this.mipmaps = [], this.mapping = rt, this.channel = 0, this.wrapS = Wn, this.wrapT = Co, this.magFilter = Dl, this.minFilter = Ll, this.anisotropy = Gl, this.format = Rl, this.internalFormat = null, this.type = Ul, this.offset = new Vector2(0, 0), this.repeat = new Vector2(1, 1), this.center = new Vector2(0, 0), this.rotation = 0, this.matrixAutoUpdate = !0, this.matrix = new Matrix3, this.generateMipmaps = !0, this.premultiplyAlpha = !1, this.flipY = !0, this.unpackAlignment = 4, this.colorSpace = Zl, this.userData = {}, this.version = 0, this.onUpdate = null, this.renderTarget = null, this.isRenderTargetTexture = !1, this.pmremVersion = 0;
                    }
                    get image() {
                        return this.source.data;
                    }
                    set image(Qe) {
                        void 0 === Qe && (Qe = null), this.source.data = Qe;
                    }
                    updateMatrix() {
                        this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y);
                    }
                    clone() {
                        return (new this.constructor).copy(this);
                    }
                    copy(Qe) {
                        return this.name = Qe.name, this.source = Qe.source, this.mipmaps = Qe.mipmaps.slice(0), this.mapping = Qe.mapping, this.channel = Qe.channel, this.wrapS = Qe.wrapS, this.wrapT = Qe.wrapT, this.magFilter = Qe.magFilter, this.minFilter = Qe.minFilter, this.anisotropy = Qe.anisotropy, this.format = Qe.format, this.internalFormat = Qe.internalFormat, this.type = Qe.type, this.offset.copy(Qe.offset), this.repeat.copy(Qe.repeat), this.center.copy(Qe.center), this.rotation = Qe.rotation, this.matrixAutoUpdate = Qe.matrixAutoUpdate, this.matrix.copy(Qe.matrix), this.generateMipmaps = Qe.generateMipmaps, this.premultiplyAlpha = Qe.premultiplyAlpha, this.flipY = Qe.flipY, this.unpackAlignment = Qe.unpackAlignment, this.colorSpace = Qe.colorSpace, this.renderTarget = Qe.renderTarget, this.isRenderTargetTexture = Qe.isRenderTargetTexture, this.userData = JSON.parse(JSON.stringify(Qe.userData)), this.needsUpdate = !0, this;
                    }
                    toJSON(Qe) {
                        const rt = void 0 === Qe || "string" === typeof Qe;
                        if (!rt && void 0 !== Qe.textures[this.uuid]) return Qe.textures[this.uuid];
                        const Wn = {
                            metadata: {
                                version: 4.6,
                                type: "Texture",
                                generator: "Texture.toJSON"
                            },
                            uuid: this.uuid,
                            name: this.name,
                            image: this.source.toJSON(Qe).uuid,
                            mapping: this.mapping,
                            channel: this.channel,
                            repeat: [
                                this.repeat.x,
                                this.repeat.y
                            ],
                            offset: [
                                this.offset.x,
                                this.offset.y
                            ],
                            center: [
                                this.center.x,
                                this.center.y
                            ],
                            rotation: this.rotation,
                            wrap: [
                                this.wrapS,
                                this.wrapT
                            ],
                            format: this.format,
                            internalFormat: this.internalFormat,
                            type: this.type,
                            colorSpace: this.colorSpace,
                            minFilter: this.minFilter,
                            magFilter: this.magFilter,
                            anisotropy: this.anisotropy,
                            flipY: this.flipY,
                            generateMipmaps: this.generateMipmaps,
                            premultiplyAlpha: this.premultiplyAlpha,
                            unpackAlignment: this.unpackAlignment
                        };
                        return Object.keys(this.userData).length > 0 && (Wn.userData = this.userData), rt || (Qe.textures[this.uuid] = Wn), Wn;
                    }
                    dispose() {
                        this.dispatchEvent({
                            type: "dispose"
                        });
                    }
                    transformUv(Qe) {
                        if (300 !== this.mapping) return Qe;
                        if (Qe.applyMatrix3(this.matrix), Qe.x < 0 || Qe.x > 1) switch(this.wrapS){
                            case Nd:
                                Qe.x = Qe.x - Math.floor(Qe.x);
                                break;
                            case Rd:
                                Qe.x = Qe.x < 0 ? 0 : 1;
                                break;
                            case Bd:
                                1 === Math.abs(Math.floor(Qe.x) % 2) ? Qe.x = Math.ceil(Qe.x) - Qe.x : Qe.x = Qe.x - Math.floor(Qe.x);
                        }
                        if (Qe.y < 0 || Qe.y > 1) switch(this.wrapT){
                            case Nd:
                                Qe.y = Qe.y - Math.floor(Qe.y);
                                break;
                            case Rd:
                                Qe.y = Qe.y < 0 ? 0 : 1;
                                break;
                            case Bd:
                                1 === Math.abs(Math.floor(Qe.y) % 2) ? Qe.y = Math.ceil(Qe.y) - Qe.y : Qe.y = Qe.y - Math.floor(Qe.y);
                        }
                        return this.flipY && (Qe.y = 1 - Qe.y), Qe;
                    }
                    set needsUpdate(Qe) {
                        !0 === Qe && (this.version++, this.source.needsUpdate = !0);
                    }
                    set needsPMREMUpdate(Qe) {
                        !0 === Qe && this.pmremVersion++;
                    }
                }
                Texture.DEFAULT_IMAGE = null, Texture.DEFAULT_MAPPING = 300, Texture.DEFAULT_ANISOTROPY = 1;
                class Vector4 {
                    constructor(Qe, rt, Wn, Co){
                        void 0 === Qe && (Qe = 0), void 0 === rt && (rt = 0), void 0 === Wn && (Wn = 0), void 0 === Co && (Co = 1), Vector4.prototype.isVector4 = !0, this.x = Qe, this.y = rt, this.z = Wn, this.w = Co;
                    }
                    get width() {
                        return this.z;
                    }
                    set width(Qe) {
                        this.z = Qe;
                    }
                    get height() {
                        return this.w;
                    }
                    set height(Qe) {
                        this.w = Qe;
                    }
                    set(Qe, rt, Wn, Co) {
                        return this.x = Qe, this.y = rt, this.z = Wn, this.w = Co, this;
                    }
                    setScalar(Qe) {
                        return this.x = Qe, this.y = Qe, this.z = Qe, this.w = Qe, this;
                    }
                    setX(Qe) {
                        return this.x = Qe, this;
                    }
                    setY(Qe) {
                        return this.y = Qe, this;
                    }
                    setZ(Qe) {
                        return this.z = Qe, this;
                    }
                    setW(Qe) {
                        return this.w = Qe, this;
                    }
                    setComponent(Qe, rt) {
                        switch(Qe){
                            case 0:
                                this.x = rt;
                                break;
                            case 1:
                                this.y = rt;
                                break;
                            case 2:
                                this.z = rt;
                                break;
                            case 3:
                                this.w = rt;
                                break;
                            default:
                                throw new Error("index is out of range: " + Qe);
                        }
                        return this;
                    }
                    getComponent(Qe) {
                        switch(Qe){
                            case 0:
                                return this.x;
                            case 1:
                                return this.y;
                            case 2:
                                return this.z;
                            case 3:
                                return this.w;
                            default:
                                throw new Error("index is out of range: " + Qe);
                        }
                    }
                    clone() {
                        return new this.constructor(this.x, this.y, this.z, this.w);
                    }
                    copy(Qe) {
                        return this.x = Qe.x, this.y = Qe.y, this.z = Qe.z, this.w = void 0 !== Qe.w ? Qe.w : 1, this;
                    }
                    add(Qe) {
                        return this.x += Qe.x, this.y += Qe.y, this.z += Qe.z, this.w += Qe.w, this;
                    }
                    addScalar(Qe) {
                        return this.x += Qe, this.y += Qe, this.z += Qe, this.w += Qe, this;
                    }
                    addVectors(Qe, rt) {
                        return this.x = Qe.x + rt.x, this.y = Qe.y + rt.y, this.z = Qe.z + rt.z, this.w = Qe.w + rt.w, this;
                    }
                    addScaledVector(Qe, rt) {
                        return this.x += Qe.x * rt, this.y += Qe.y * rt, this.z += Qe.z * rt, this.w += Qe.w * rt, this;
                    }
                    sub(Qe) {
                        return this.x -= Qe.x, this.y -= Qe.y, this.z -= Qe.z, this.w -= Qe.w, this;
                    }
                    subScalar(Qe) {
                        return this.x -= Qe, this.y -= Qe, this.z -= Qe, this.w -= Qe, this;
                    }
                    subVectors(Qe, rt) {
                        return this.x = Qe.x - rt.x, this.y = Qe.y - rt.y, this.z = Qe.z - rt.z, this.w = Qe.w - rt.w, this;
                    }
                    multiply(Qe) {
                        return this.x *= Qe.x, this.y *= Qe.y, this.z *= Qe.z, this.w *= Qe.w, this;
                    }
                    multiplyScalar(Qe) {
                        return this.x *= Qe, this.y *= Qe, this.z *= Qe, this.w *= Qe, this;
                    }
                    applyMatrix4(Qe) {
                        const rt = this.x, Wn = this.y, Co = this.z, Dl = this.w, Ll = Qe.elements;
                        return this.x = Ll[0] * rt + Ll[4] * Wn + Ll[8] * Co + Ll[12] * Dl, this.y = Ll[1] * rt + Ll[5] * Wn + Ll[9] * Co + Ll[13] * Dl, this.z = Ll[2] * rt + Ll[6] * Wn + Ll[10] * Co + Ll[14] * Dl, this.w = Ll[3] * rt + Ll[7] * Wn + Ll[11] * Co + Ll[15] * Dl, this;
                    }
                    divide(Qe) {
                        return this.x /= Qe.x, this.y /= Qe.y, this.z /= Qe.z, this.w /= Qe.w, this;
                    }
                    divideScalar(Qe) {
                        return this.multiplyScalar(1 / Qe);
                    }
                    setAxisAngleFromQuaternion(Qe) {
                        this.w = 2 * Math.acos(Qe.w);
                        const rt = Math.sqrt(1 - Qe.w * Qe.w);
                        return rt < 1e-4 ? (this.x = 1, this.y = 0, this.z = 0) : (this.x = Qe.x / rt, this.y = Qe.y / rt, this.z = Qe.z / rt), this;
                    }
                    setAxisAngleFromRotationMatrix(Qe) {
                        let rt, Wn, Co, Dl;
                        const Ll = .01, Rl = .1, Ul = Qe.elements, Gl = Ul[0], Zl = Ul[4], Hl = Ul[8], ql = Ul[1], Ql = Ul[5], Kl = Ul[9], $l = Ul[2], Tc = Ul[6], tu = Ul[10];
                        if (Math.abs(Zl - ql) < Ll && Math.abs(Hl - $l) < Ll && Math.abs(Kl - Tc) < Ll) {
                            if (Math.abs(Zl + ql) < Rl && Math.abs(Hl + $l) < Rl && Math.abs(Kl + Tc) < Rl && Math.abs(Gl + Ql + tu - 3) < Rl) return this.set(1, 0, 0, 0), this;
                            rt = Math.PI;
                            const Qe = (Gl + 1) / 2, Ul = (Ql + 1) / 2, lu = (tu + 1) / 2, du = (Zl + ql) / 4, fu = (Hl + $l) / 4, yu = (Kl + Tc) / 4;
                            return Qe > Ul && Qe > lu ? Qe < Ll ? (Wn = 0, Co = .707106781, Dl = .707106781) : (Wn = Math.sqrt(Qe), Co = du / Wn, Dl = fu / Wn) : Ul > lu ? Ul < Ll ? (Wn = .707106781, Co = 0, Dl = .707106781) : (Co = Math.sqrt(Ul), Wn = du / Co, Dl = yu / Co) : lu < Ll ? (Wn = .707106781, Co = .707106781, Dl = 0) : (Dl = Math.sqrt(lu), Wn = fu / Dl, Co = yu / Dl), this.set(Wn, Co, Dl, rt), this;
                        }
                        let lu = Math.sqrt((Tc - Kl) * (Tc - Kl) + (Hl - $l) * (Hl - $l) + (ql - Zl) * (ql - Zl));
                        return Math.abs(lu) < .001 && (lu = 1), this.x = (Tc - Kl) / lu, this.y = (Hl - $l) / lu, this.z = (ql - Zl) / lu, this.w = Math.acos((Gl + Ql + tu - 1) / 2), this;
                    }
                    setFromMatrixPosition(Qe) {
                        const rt = Qe.elements;
                        return this.x = rt[12], this.y = rt[13], this.z = rt[14], this.w = rt[15], this;
                    }
                    min(Qe) {
                        return this.x = Math.min(this.x, Qe.x), this.y = Math.min(this.y, Qe.y), this.z = Math.min(this.z, Qe.z), this.w = Math.min(this.w, Qe.w), this;
                    }
                    max(Qe) {
                        return this.x = Math.max(this.x, Qe.x), this.y = Math.max(this.y, Qe.y), this.z = Math.max(this.z, Qe.z), this.w = Math.max(this.w, Qe.w), this;
                    }
                    clamp(Qe, rt) {
                        return this.x = clamp(this.x, Qe.x, rt.x), this.y = clamp(this.y, Qe.y, rt.y), this.z = clamp(this.z, Qe.z, rt.z), this.w = clamp(this.w, Qe.w, rt.w), this;
                    }
                    clampScalar(Qe, rt) {
                        return this.x = clamp(this.x, Qe, rt), this.y = clamp(this.y, Qe, rt), this.z = clamp(this.z, Qe, rt), this.w = clamp(this.w, Qe, rt), this;
                    }
                    clampLength(Qe, rt) {
                        const Wn = this.length();
                        return this.divideScalar(Wn || 1).multiplyScalar(clamp(Wn, Qe, rt));
                    }
                    floor() {
                        return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this.w = Math.floor(this.w), this;
                    }
                    ceil() {
                        return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this.w = Math.ceil(this.w), this;
                    }
                    round() {
                        return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this.w = Math.round(this.w), this;
                    }
                    roundToZero() {
                        return this.x = Math.trunc(this.x), this.y = Math.trunc(this.y), this.z = Math.trunc(this.z), this.w = Math.trunc(this.w), this;
                    }
                    negate() {
                        return this.x = -this.x, this.y = -this.y, this.z = -this.z, this.w = -this.w, this;
                    }
                    dot(Qe) {
                        return this.x * Qe.x + this.y * Qe.y + this.z * Qe.z + this.w * Qe.w;
                    }
                    lengthSq() {
                        return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
                    }
                    length() {
                        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
                    }
                    manhattanLength() {
                        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
                    }
                    normalize() {
                        return this.divideScalar(this.length() || 1);
                    }
                    setLength(Qe) {
                        return this.normalize().multiplyScalar(Qe);
                    }
                    lerp(Qe, rt) {
                        return this.x += (Qe.x - this.x) * rt, this.y += (Qe.y - this.y) * rt, this.z += (Qe.z - this.z) * rt, this.w += (Qe.w - this.w) * rt, this;
                    }
                    lerpVectors(Qe, rt, Wn) {
                        return this.x = Qe.x + (rt.x - Qe.x) * Wn, this.y = Qe.y + (rt.y - Qe.y) * Wn, this.z = Qe.z + (rt.z - Qe.z) * Wn, this.w = Qe.w + (rt.w - Qe.w) * Wn, this;
                    }
                    equals(Qe) {
                        return Qe.x === this.x && Qe.y === this.y && Qe.z === this.z && Qe.w === this.w;
                    }
                    fromArray(Qe, rt) {
                        return void 0 === rt && (rt = 0), this.x = Qe[rt], this.y = Qe[rt + 1], this.z = Qe[rt + 2], this.w = Qe[rt + 3], this;
                    }
                    toArray(Qe, rt) {
                        return void 0 === Qe && (Qe = []), void 0 === rt && (rt = 0), Qe[rt] = this.x, Qe[rt + 1] = this.y, Qe[rt + 2] = this.z, Qe[rt + 3] = this.w, Qe;
                    }
                    fromBufferAttribute(Qe, rt) {
                        return this.x = Qe.getX(rt), this.y = Qe.getY(rt), this.z = Qe.getZ(rt), this.w = Qe.getW(rt), this;
                    }
                    random() {
                        return this.x = Math.random(), this.y = Math.random(), this.z = Math.random(), this.w = Math.random(), this;
                    }
                    *[Symbol.iterator]() {
                        yield this.x, yield this.y, yield this.z, yield this.w;
                    }
                }
                class RenderTarget extends EventDispatcher {
                    constructor(Qe, rt, Wn){
                        void 0 === Qe && (Qe = 1), void 0 === rt && (rt = 1), void 0 === Wn && (Wn = {}), super(), this.isRenderTarget = !0, this.width = Qe, this.height = rt, this.depth = 1, this.scissor = new Vector4(0, 0, Qe, rt), this.scissorTest = !1, this.viewport = new Vector4(0, 0, Qe, rt);
                        const Co = {
                            width: Qe,
                            height: rt,
                            depth: 1
                        };
                        Wn = Object.assign({
                            generateMipmaps: !1,
                            internalFormat: null,
                            minFilter: Ud,
                            depthBuffer: !0,
                            stencilBuffer: !1,
                            resolveDepthBuffer: !0,
                            resolveStencilBuffer: !0,
                            depthTexture: null,
                            samples: 0,
                            count: 1
                        }, Wn);
                        const Dl = new Texture(Co, Wn.mapping, Wn.wrapS, Wn.wrapT, Wn.magFilter, Wn.minFilter, Wn.format, Wn.type, Wn.anisotropy, Wn.colorSpace);
                        Dl.flipY = !1, Dl.generateMipmaps = Wn.generateMipmaps, Dl.internalFormat = Wn.internalFormat, this.textures = [];
                        const Ll = Wn.count;
                        for(let Rl = 0; Rl < Ll; Rl++)this.textures[Rl] = Dl.clone(), this.textures[Rl].isRenderTargetTexture = !0, this.textures[Rl].renderTarget = this;
                        this.depthBuffer = Wn.depthBuffer, this.stencilBuffer = Wn.stencilBuffer, this.resolveDepthBuffer = Wn.resolveDepthBuffer, this.resolveStencilBuffer = Wn.resolveStencilBuffer, this._depthTexture = null, this.depthTexture = Wn.depthTexture, this.samples = Wn.samples;
                    }
                    get texture() {
                        return this.textures[0];
                    }
                    set texture(Qe) {
                        this.textures[0] = Qe;
                    }
                    set depthTexture(Qe) {
                        null !== this._depthTexture && (this._depthTexture.renderTarget = null), null !== Qe && (Qe.renderTarget = this), this._depthTexture = Qe;
                    }
                    get depthTexture() {
                        return this._depthTexture;
                    }
                    setSize(Qe, rt, Wn) {
                        if (void 0 === Wn && (Wn = 1), this.width !== Qe || this.height !== rt || this.depth !== Wn) {
                            this.width = Qe, this.height = rt, this.depth = Wn;
                            for(let Co = 0, Dl = this.textures.length; Co < Dl; Co++)this.textures[Co].image.width = Qe, this.textures[Co].image.height = rt, this.textures[Co].image.depth = Wn;
                            this.dispose();
                        }
                        this.viewport.set(0, 0, Qe, rt), this.scissor.set(0, 0, Qe, rt);
                    }
                    clone() {
                        return (new this.constructor).copy(this);
                    }
                    copy(Qe) {
                        this.width = Qe.width, this.height = Qe.height, this.depth = Qe.depth, this.scissor.copy(Qe.scissor), this.scissorTest = Qe.scissorTest, this.viewport.copy(Qe.viewport), this.textures.length = 0;
                        for(let Wn = 0, Co = Qe.textures.length; Wn < Co; Wn++)this.textures[Wn] = Qe.textures[Wn].clone(), this.textures[Wn].isRenderTargetTexture = !0, this.textures[Wn].renderTarget = this;
                        const rt = Object.assign({}, Qe.texture.image);
                        return this.texture.source = new Source(rt), this.depthBuffer = Qe.depthBuffer, this.stencilBuffer = Qe.stencilBuffer, this.resolveDepthBuffer = Qe.resolveDepthBuffer, this.resolveStencilBuffer = Qe.resolveStencilBuffer, null !== Qe.depthTexture && (this.depthTexture = Qe.depthTexture.clone()), this.samples = Qe.samples, this;
                    }
                    dispose() {
                        this.dispatchEvent({
                            type: "dispose"
                        });
                    }
                }
                class WebGLRenderTarget extends RenderTarget {
                    constructor(Qe, rt, Wn){
                        void 0 === Qe && (Qe = 1), void 0 === rt && (rt = 1), void 0 === Wn && (Wn = {}), super(Qe, rt, Wn), this.isWebGLRenderTarget = !0;
                    }
                }
                class DataArrayTexture extends Texture {
                    constructor(Qe, rt, Wn, Co){
                        void 0 === Qe && (Qe = null), void 0 === rt && (rt = 1), void 0 === Wn && (Wn = 1), void 0 === Co && (Co = 1), super(null), this.isDataArrayTexture = !0, this.image = {
                            data: Qe,
                            width: rt,
                            height: Wn,
                            depth: Co
                        }, this.magFilter = Od, this.minFilter = Od, this.wrapR = Rd, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1, this.layerUpdates = new Set;
                    }
                    addLayerUpdate(Qe) {
                        this.layerUpdates.add(Qe);
                    }
                    clearLayerUpdates() {
                        this.layerUpdates.clear();
                    }
                }
                class Data3DTexture extends Texture {
                    constructor(Qe, rt, Wn, Co){
                        void 0 === Qe && (Qe = null), void 0 === rt && (rt = 1), void 0 === Wn && (Wn = 1), void 0 === Co && (Co = 1), super(null), this.isData3DTexture = !0, this.image = {
                            data: Qe,
                            width: rt,
                            height: Wn,
                            depth: Co
                        }, this.magFilter = Od, this.minFilter = Od, this.wrapR = Rd, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1;
                    }
                }
                class Quaternion {
                    constructor(Qe, rt, Wn, Co){
                        void 0 === Qe && (Qe = 0), void 0 === rt && (rt = 0), void 0 === Wn && (Wn = 0), void 0 === Co && (Co = 1), this.isQuaternion = !0, this._x = Qe, this._y = rt, this._z = Wn, this._w = Co;
                    }
                    static slerpFlat(Qe, rt, Wn, Co, Dl, Ll, Rl) {
                        let Ul = Wn[Co + 0], Gl = Wn[Co + 1], Zl = Wn[Co + 2], Hl = Wn[Co + 3];
                        const ql = Dl[Ll + 0], Ql = Dl[Ll + 1], Kl = Dl[Ll + 2], $l = Dl[Ll + 3];
                        if (0 === Rl) return Qe[rt + 0] = Ul, Qe[rt + 1] = Gl, Qe[rt + 2] = Zl, void (Qe[rt + 3] = Hl);
                        if (1 === Rl) return Qe[rt + 0] = ql, Qe[rt + 1] = Ql, Qe[rt + 2] = Kl, void (Qe[rt + 3] = $l);
                        if (Hl !== $l || Ul !== ql || Gl !== Ql || Zl !== Kl) {
                            let Qe = 1 - Rl;
                            const rt = Ul * ql + Gl * Ql + Zl * Kl + Hl * $l, Wn = rt >= 0 ? 1 : -1, Co = 1 - rt * rt;
                            if (Co > Number.EPSILON) {
                                const Dl = Math.sqrt(Co), Ll = Math.atan2(Dl, rt * Wn);
                                Qe = Math.sin(Qe * Ll) / Dl, Rl = Math.sin(Rl * Ll) / Dl;
                            }
                            const Dl = Rl * Wn;
                            if (Ul = Ul * Qe + ql * Dl, Gl = Gl * Qe + Ql * Dl, Zl = Zl * Qe + Kl * Dl, Hl = Hl * Qe + $l * Dl, Qe === 1 - Rl) {
                                const Qe = 1 / Math.sqrt(Ul * Ul + Gl * Gl + Zl * Zl + Hl * Hl);
                                Ul *= Qe, Gl *= Qe, Zl *= Qe, Hl *= Qe;
                            }
                        }
                        Qe[rt] = Ul, Qe[rt + 1] = Gl, Qe[rt + 2] = Zl, Qe[rt + 3] = Hl;
                    }
                    static multiplyQuaternionsFlat(Qe, rt, Wn, Co, Dl, Ll) {
                        const Rl = Wn[Co], Ul = Wn[Co + 1], Gl = Wn[Co + 2], Zl = Wn[Co + 3], Hl = Dl[Ll], ql = Dl[Ll + 1], Ql = Dl[Ll + 2], Kl = Dl[Ll + 3];
                        return Qe[rt] = Rl * Kl + Zl * Hl + Ul * Ql - Gl * ql, Qe[rt + 1] = Ul * Kl + Zl * ql + Gl * Hl - Rl * Ql, Qe[rt + 2] = Gl * Kl + Zl * Ql + Rl * ql - Ul * Hl, Qe[rt + 3] = Zl * Kl - Rl * Hl - Ul * ql - Gl * Ql, Qe;
                    }
                    get x() {
                        return this._x;
                    }
                    set x(Qe) {
                        this._x = Qe, this._onChangeCallback();
                    }
                    get y() {
                        return this._y;
                    }
                    set y(Qe) {
                        this._y = Qe, this._onChangeCallback();
                    }
                    get z() {
                        return this._z;
                    }
                    set z(Qe) {
                        this._z = Qe, this._onChangeCallback();
                    }
                    get w() {
                        return this._w;
                    }
                    set w(Qe) {
                        this._w = Qe, this._onChangeCallback();
                    }
                    set(Qe, rt, Wn, Co) {
                        return this._x = Qe, this._y = rt, this._z = Wn, this._w = Co, this._onChangeCallback(), this;
                    }
                    clone() {
                        return new this.constructor(this._x, this._y, this._z, this._w);
                    }
                    copy(Qe) {
                        return this._x = Qe.x, this._y = Qe.y, this._z = Qe.z, this._w = Qe.w, this._onChangeCallback(), this;
                    }
                    setFromEuler(Qe, rt) {
                        void 0 === rt && (rt = !0);
                        const Wn = Qe._x, Co = Qe._y, Dl = Qe._z, Ll = Qe._order, Rl = Math.cos, Ul = Math.sin, Gl = Rl(Wn / 2), Zl = Rl(Co / 2), Hl = Rl(Dl / 2), ql = Ul(Wn / 2), Ql = Ul(Co / 2), Kl = Ul(Dl / 2);
                        switch(Ll){
                            case "XYZ":
                                this._x = ql * Zl * Hl + Gl * Ql * Kl, this._y = Gl * Ql * Hl - ql * Zl * Kl, this._z = Gl * Zl * Kl + ql * Ql * Hl, this._w = Gl * Zl * Hl - ql * Ql * Kl;
                                break;
                            case "YXZ":
                                this._x = ql * Zl * Hl + Gl * Ql * Kl, this._y = Gl * Ql * Hl - ql * Zl * Kl, this._z = Gl * Zl * Kl - ql * Ql * Hl, this._w = Gl * Zl * Hl + ql * Ql * Kl;
                                break;
                            case "ZXY":
                                this._x = ql * Zl * Hl - Gl * Ql * Kl, this._y = Gl * Ql * Hl + ql * Zl * Kl, this._z = Gl * Zl * Kl + ql * Ql * Hl, this._w = Gl * Zl * Hl - ql * Ql * Kl;
                                break;
                            case "ZYX":
                                this._x = ql * Zl * Hl - Gl * Ql * Kl, this._y = Gl * Ql * Hl + ql * Zl * Kl, this._z = Gl * Zl * Kl - ql * Ql * Hl, this._w = Gl * Zl * Hl + ql * Ql * Kl;
                                break;
                            case "YZX":
                                this._x = ql * Zl * Hl + Gl * Ql * Kl, this._y = Gl * Ql * Hl + ql * Zl * Kl, this._z = Gl * Zl * Kl - ql * Ql * Hl, this._w = Gl * Zl * Hl - ql * Ql * Kl;
                                break;
                            case "XZY":
                                this._x = ql * Zl * Hl - Gl * Ql * Kl, this._y = Gl * Ql * Hl - ql * Zl * Kl, this._z = Gl * Zl * Kl + ql * Ql * Hl, this._w = Gl * Zl * Hl + ql * Ql * Kl;
                                break;
                            default:
                                console.warn("THREE.Quaternion: .setFromEuler() encountered an unknown order: " + Ll);
                        }
                        return !0 === rt && this._onChangeCallback(), this;
                    }
                    setFromAxisAngle(Qe, rt) {
                        const Wn = rt / 2, Co = Math.sin(Wn);
                        return this._x = Qe.x * Co, this._y = Qe.y * Co, this._z = Qe.z * Co, this._w = Math.cos(Wn), this._onChangeCallback(), this;
                    }
                    setFromRotationMatrix(Qe) {
                        const rt = Qe.elements, Wn = rt[0], Co = rt[4], Dl = rt[8], Ll = rt[1], Rl = rt[5], Ul = rt[9], Gl = rt[2], Zl = rt[6], Hl = rt[10], ql = Wn + Rl + Hl;
                        if (ql > 0) {
                            const Qe = .5 / Math.sqrt(ql + 1);
                            this._w = .25 / Qe, this._x = (Zl - Ul) * Qe, this._y = (Dl - Gl) * Qe, this._z = (Ll - Co) * Qe;
                        } else if (Wn > Rl && Wn > Hl) {
                            const Qe = 2 * Math.sqrt(1 + Wn - Rl - Hl);
                            this._w = (Zl - Ul) / Qe, this._x = .25 * Qe, this._y = (Co + Ll) / Qe, this._z = (Dl + Gl) / Qe;
                        } else if (Rl > Hl) {
                            const Qe = 2 * Math.sqrt(1 + Rl - Wn - Hl);
                            this._w = (Dl - Gl) / Qe, this._x = (Co + Ll) / Qe, this._y = .25 * Qe, this._z = (Ul + Zl) / Qe;
                        } else {
                            const Qe = 2 * Math.sqrt(1 + Hl - Wn - Rl);
                            this._w = (Ll - Co) / Qe, this._x = (Dl + Gl) / Qe, this._y = (Ul + Zl) / Qe, this._z = .25 * Qe;
                        }
                        return this._onChangeCallback(), this;
                    }
                    setFromUnitVectors(Qe, rt) {
                        let Wn = Qe.dot(rt) + 1;
                        return Wn < Number.EPSILON ? (Wn = 0, Math.abs(Qe.x) > Math.abs(Qe.z) ? (this._x = -Qe.y, this._y = Qe.x, this._z = 0, this._w = Wn) : (this._x = 0, this._y = -Qe.z, this._z = Qe.y, this._w = Wn)) : (this._x = Qe.y * rt.z - Qe.z * rt.y, this._y = Qe.z * rt.x - Qe.x * rt.z, this._z = Qe.x * rt.y - Qe.y * rt.x, this._w = Wn), this.normalize();
                    }
                    angleTo(Qe) {
                        return 2 * Math.acos(Math.abs(clamp(this.dot(Qe), -1, 1)));
                    }
                    rotateTowards(Qe, rt) {
                        const Wn = this.angleTo(Qe);
                        if (0 === Wn) return this;
                        const Co = Math.min(1, rt / Wn);
                        return this.slerp(Qe, Co), this;
                    }
                    identity() {
                        return this.set(0, 0, 0, 1);
                    }
                    invert() {
                        return this.conjugate();
                    }
                    conjugate() {
                        return this._x *= -1, this._y *= -1, this._z *= -1, this._onChangeCallback(), this;
                    }
                    dot(Qe) {
                        return this._x * Qe._x + this._y * Qe._y + this._z * Qe._z + this._w * Qe._w;
                    }
                    lengthSq() {
                        return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
                    }
                    length() {
                        return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
                    }
                    normalize() {
                        let Qe = this.length();
                        return 0 === Qe ? (this._x = 0, this._y = 0, this._z = 0, this._w = 1) : (Qe = 1 / Qe, this._x = this._x * Qe, this._y = this._y * Qe, this._z = this._z * Qe, this._w = this._w * Qe), this._onChangeCallback(), this;
                    }
                    multiply(Qe) {
                        return this.multiplyQuaternions(this, Qe);
                    }
                    premultiply(Qe) {
                        return this.multiplyQuaternions(Qe, this);
                    }
                    multiplyQuaternions(Qe, rt) {
                        const Wn = Qe._x, Co = Qe._y, Dl = Qe._z, Ll = Qe._w, Rl = rt._x, Ul = rt._y, Gl = rt._z, Zl = rt._w;
                        return this._x = Wn * Zl + Ll * Rl + Co * Gl - Dl * Ul, this._y = Co * Zl + Ll * Ul + Dl * Rl - Wn * Gl, this._z = Dl * Zl + Ll * Gl + Wn * Ul - Co * Rl, this._w = Ll * Zl - Wn * Rl - Co * Ul - Dl * Gl, this._onChangeCallback(), this;
                    }
                    slerp(Qe, rt) {
                        if (0 === rt) return this;
                        if (1 === rt) return this.copy(Qe);
                        const Wn = this._x, Co = this._y, Dl = this._z, Ll = this._w;
                        let Rl = Ll * Qe._w + Wn * Qe._x + Co * Qe._y + Dl * Qe._z;
                        if (Rl < 0 ? (this._w = -Qe._w, this._x = -Qe._x, this._y = -Qe._y, this._z = -Qe._z, Rl = -Rl) : this.copy(Qe), Rl >= 1) return this._w = Ll, this._x = Wn, this._y = Co, this._z = Dl, this;
                        const Ul = 1 - Rl * Rl;
                        if (Ul <= Number.EPSILON) {
                            const Qe = 1 - rt;
                            return this._w = Qe * Ll + rt * this._w, this._x = Qe * Wn + rt * this._x, this._y = Qe * Co + rt * this._y, this._z = Qe * Dl + rt * this._z, this.normalize(), this;
                        }
                        const Gl = Math.sqrt(Ul), Zl = Math.atan2(Gl, Rl), Hl = Math.sin((1 - rt) * Zl) / Gl, ql = Math.sin(rt * Zl) / Gl;
                        return this._w = Ll * Hl + this._w * ql, this._x = Wn * Hl + this._x * ql, this._y = Co * Hl + this._y * ql, this._z = Dl * Hl + this._z * ql, this._onChangeCallback(), this;
                    }
                    slerpQuaternions(Qe, rt, Wn) {
                        return this.copy(Qe).slerp(rt, Wn);
                    }
                    random() {
                        const Qe = 2 * Math.PI * Math.random(), rt = 2 * Math.PI * Math.random(), Wn = Math.random(), Co = Math.sqrt(1 - Wn), Dl = Math.sqrt(Wn);
                        return this.set(Co * Math.sin(Qe), Co * Math.cos(Qe), Dl * Math.sin(rt), Dl * Math.cos(rt));
                    }
                    equals(Qe) {
                        return Qe._x === this._x && Qe._y === this._y && Qe._z === this._z && Qe._w === this._w;
                    }
                    fromArray(Qe, rt) {
                        return void 0 === rt && (rt = 0), this._x = Qe[rt], this._y = Qe[rt + 1], this._z = Qe[rt + 2], this._w = Qe[rt + 3], this._onChangeCallback(), this;
                    }
                    toArray(Qe, rt) {
                        return void 0 === Qe && (Qe = []), void 0 === rt && (rt = 0), Qe[rt] = this._x, Qe[rt + 1] = this._y, Qe[rt + 2] = this._z, Qe[rt + 3] = this._w, Qe;
                    }
                    fromBufferAttribute(Qe, rt) {
                        return this._x = Qe.getX(rt), this._y = Qe.getY(rt), this._z = Qe.getZ(rt), this._w = Qe.getW(rt), this._onChangeCallback(), this;
                    }
                    toJSON() {
                        return this.toArray();
                    }
                    _onChange(Qe) {
                        return this._onChangeCallback = Qe, this;
                    }
                    _onChangeCallback() {}
                    *[Symbol.iterator]() {
                        yield this._x, yield this._y, yield this._z, yield this._w;
                    }
                }
                class Vector3 {
                    constructor(Qe, rt, Wn){
                        void 0 === Qe && (Qe = 0), void 0 === rt && (rt = 0), void 0 === Wn && (Wn = 0), Vector3.prototype.isVector3 = !0, this.x = Qe, this.y = rt, this.z = Wn;
                    }
                    set(Qe, rt, Wn) {
                        return void 0 === Wn && (Wn = this.z), this.x = Qe, this.y = rt, this.z = Wn, this;
                    }
                    setScalar(Qe) {
                        return this.x = Qe, this.y = Qe, this.z = Qe, this;
                    }
                    setX(Qe) {
                        return this.x = Qe, this;
                    }
                    setY(Qe) {
                        return this.y = Qe, this;
                    }
                    setZ(Qe) {
                        return this.z = Qe, this;
                    }
                    setComponent(Qe, rt) {
                        switch(Qe){
                            case 0:
                                this.x = rt;
                                break;
                            case 1:
                                this.y = rt;
                                break;
                            case 2:
                                this.z = rt;
                                break;
                            default:
                                throw new Error("index is out of range: " + Qe);
                        }
                        return this;
                    }
                    getComponent(Qe) {
                        switch(Qe){
                            case 0:
                                return this.x;
                            case 1:
                                return this.y;
                            case 2:
                                return this.z;
                            default:
                                throw new Error("index is out of range: " + Qe);
                        }
                    }
                    clone() {
                        return new this.constructor(this.x, this.y, this.z);
                    }
                    copy(Qe) {
                        return this.x = Qe.x, this.y = Qe.y, this.z = Qe.z, this;
                    }
                    add(Qe) {
                        return this.x += Qe.x, this.y += Qe.y, this.z += Qe.z, this;
                    }
                    addScalar(Qe) {
                        return this.x += Qe, this.y += Qe, this.z += Qe, this;
                    }
                    addVectors(Qe, rt) {
                        return this.x = Qe.x + rt.x, this.y = Qe.y + rt.y, this.z = Qe.z + rt.z, this;
                    }
                    addScaledVector(Qe, rt) {
                        return this.x += Qe.x * rt, this.y += Qe.y * rt, this.z += Qe.z * rt, this;
                    }
                    sub(Qe) {
                        return this.x -= Qe.x, this.y -= Qe.y, this.z -= Qe.z, this;
                    }
                    subScalar(Qe) {
                        return this.x -= Qe, this.y -= Qe, this.z -= Qe, this;
                    }
                    subVectors(Qe, rt) {
                        return this.x = Qe.x - rt.x, this.y = Qe.y - rt.y, this.z = Qe.z - rt.z, this;
                    }
                    multiply(Qe) {
                        return this.x *= Qe.x, this.y *= Qe.y, this.z *= Qe.z, this;
                    }
                    multiplyScalar(Qe) {
                        return this.x *= Qe, this.y *= Qe, this.z *= Qe, this;
                    }
                    multiplyVectors(Qe, rt) {
                        return this.x = Qe.x * rt.x, this.y = Qe.y * rt.y, this.z = Qe.z * rt.z, this;
                    }
                    applyEuler(Qe) {
                        return this.applyQuaternion(Qm.setFromEuler(Qe));
                    }
                    applyAxisAngle(Qe, rt) {
                        return this.applyQuaternion(Qm.setFromAxisAngle(Qe, rt));
                    }
                    applyMatrix3(Qe) {
                        const rt = this.x, Wn = this.y, Co = this.z, Dl = Qe.elements;
                        return this.x = Dl[0] * rt + Dl[3] * Wn + Dl[6] * Co, this.y = Dl[1] * rt + Dl[4] * Wn + Dl[7] * Co, this.z = Dl[2] * rt + Dl[5] * Wn + Dl[8] * Co, this;
                    }
                    applyNormalMatrix(Qe) {
                        return this.applyMatrix3(Qe).normalize();
                    }
                    applyMatrix4(Qe) {
                        const rt = this.x, Wn = this.y, Co = this.z, Dl = Qe.elements, Ll = 1 / (Dl[3] * rt + Dl[7] * Wn + Dl[11] * Co + Dl[15]);
                        return this.x = (Dl[0] * rt + Dl[4] * Wn + Dl[8] * Co + Dl[12]) * Ll, this.y = (Dl[1] * rt + Dl[5] * Wn + Dl[9] * Co + Dl[13]) * Ll, this.z = (Dl[2] * rt + Dl[6] * Wn + Dl[10] * Co + Dl[14]) * Ll, this;
                    }
                    applyQuaternion(Qe) {
                        const rt = this.x, Wn = this.y, Co = this.z, Dl = Qe.x, Ll = Qe.y, Rl = Qe.z, Ul = Qe.w, Gl = 2 * (Ll * Co - Rl * Wn), Zl = 2 * (Rl * rt - Dl * Co), Hl = 2 * (Dl * Wn - Ll * rt);
                        return this.x = rt + Ul * Gl + Ll * Hl - Rl * Zl, this.y = Wn + Ul * Zl + Rl * Gl - Dl * Hl, this.z = Co + Ul * Hl + Dl * Zl - Ll * Gl, this;
                    }
                    project(Qe) {
                        return this.applyMatrix4(Qe.matrixWorldInverse).applyMatrix4(Qe.projectionMatrix);
                    }
                    unproject(Qe) {
                        return this.applyMatrix4(Qe.projectionMatrixInverse).applyMatrix4(Qe.matrixWorld);
                    }
                    transformDirection(Qe) {
                        const rt = this.x, Wn = this.y, Co = this.z, Dl = Qe.elements;
                        return this.x = Dl[0] * rt + Dl[4] * Wn + Dl[8] * Co, this.y = Dl[1] * rt + Dl[5] * Wn + Dl[9] * Co, this.z = Dl[2] * rt + Dl[6] * Wn + Dl[10] * Co, this.normalize();
                    }
                    divide(Qe) {
                        return this.x /= Qe.x, this.y /= Qe.y, this.z /= Qe.z, this;
                    }
                    divideScalar(Qe) {
                        return this.multiplyScalar(1 / Qe);
                    }
                    min(Qe) {
                        return this.x = Math.min(this.x, Qe.x), this.y = Math.min(this.y, Qe.y), this.z = Math.min(this.z, Qe.z), this;
                    }
                    max(Qe) {
                        return this.x = Math.max(this.x, Qe.x), this.y = Math.max(this.y, Qe.y), this.z = Math.max(this.z, Qe.z), this;
                    }
                    clamp(Qe, rt) {
                        return this.x = clamp(this.x, Qe.x, rt.x), this.y = clamp(this.y, Qe.y, rt.y), this.z = clamp(this.z, Qe.z, rt.z), this;
                    }
                    clampScalar(Qe, rt) {
                        return this.x = clamp(this.x, Qe, rt), this.y = clamp(this.y, Qe, rt), this.z = clamp(this.z, Qe, rt), this;
                    }
                    clampLength(Qe, rt) {
                        const Wn = this.length();
                        return this.divideScalar(Wn || 1).multiplyScalar(clamp(Wn, Qe, rt));
                    }
                    floor() {
                        return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this;
                    }
                    ceil() {
                        return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this;
                    }
                    round() {
                        return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this;
                    }
                    roundToZero() {
                        return this.x = Math.trunc(this.x), this.y = Math.trunc(this.y), this.z = Math.trunc(this.z), this;
                    }
                    negate() {
                        return this.x = -this.x, this.y = -this.y, this.z = -this.z, this;
                    }
                    dot(Qe) {
                        return this.x * Qe.x + this.y * Qe.y + this.z * Qe.z;
                    }
                    lengthSq() {
                        return this.x * this.x + this.y * this.y + this.z * this.z;
                    }
                    length() {
                        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
                    }
                    manhattanLength() {
                        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
                    }
                    normalize() {
                        return this.divideScalar(this.length() || 1);
                    }
                    setLength(Qe) {
                        return this.normalize().multiplyScalar(Qe);
                    }
                    lerp(Qe, rt) {
                        return this.x += (Qe.x - this.x) * rt, this.y += (Qe.y - this.y) * rt, this.z += (Qe.z - this.z) * rt, this;
                    }
                    lerpVectors(Qe, rt, Wn) {
                        return this.x = Qe.x + (rt.x - Qe.x) * Wn, this.y = Qe.y + (rt.y - Qe.y) * Wn, this.z = Qe.z + (rt.z - Qe.z) * Wn, this;
                    }
                    cross(Qe) {
                        return this.crossVectors(this, Qe);
                    }
                    crossVectors(Qe, rt) {
                        const Wn = Qe.x, Co = Qe.y, Dl = Qe.z, Ll = rt.x, Rl = rt.y, Ul = rt.z;
                        return this.x = Co * Ul - Dl * Rl, this.y = Dl * Ll - Wn * Ul, this.z = Wn * Rl - Co * Ll, this;
                    }
                    projectOnVector(Qe) {
                        const rt = Qe.lengthSq();
                        if (0 === rt) return this.set(0, 0, 0);
                        const Wn = Qe.dot(this) / rt;
                        return this.copy(Qe).multiplyScalar(Wn);
                    }
                    projectOnPlane(Qe) {
                        return Ym.copy(this).projectOnVector(Qe), this.sub(Ym);
                    }
                    reflect(Qe) {
                        return this.sub(Ym.copy(Qe).multiplyScalar(2 * this.dot(Qe)));
                    }
                    angleTo(Qe) {
                        const rt = Math.sqrt(this.lengthSq() * Qe.lengthSq());
                        if (0 === rt) return Math.PI / 2;
                        const Wn = this.dot(Qe) / rt;
                        return Math.acos(clamp(Wn, -1, 1));
                    }
                    distanceTo(Qe) {
                        return Math.sqrt(this.distanceToSquared(Qe));
                    }
                    distanceToSquared(Qe) {
                        const rt = this.x - Qe.x, Wn = this.y - Qe.y, Co = this.z - Qe.z;
                        return rt * rt + Wn * Wn + Co * Co;
                    }
                    manhattanDistanceTo(Qe) {
                        return Math.abs(this.x - Qe.x) + Math.abs(this.y - Qe.y) + Math.abs(this.z - Qe.z);
                    }
                    setFromSpherical(Qe) {
                        return this.setFromSphericalCoords(Qe.radius, Qe.phi, Qe.theta);
                    }
                    setFromSphericalCoords(Qe, rt, Wn) {
                        const Co = Math.sin(rt) * Qe;
                        return this.x = Co * Math.sin(Wn), this.y = Math.cos(rt) * Qe, this.z = Co * Math.cos(Wn), this;
                    }
                    setFromCylindrical(Qe) {
                        return this.setFromCylindricalCoords(Qe.radius, Qe.theta, Qe.y);
                    }
                    setFromCylindricalCoords(Qe, rt, Wn) {
                        return this.x = Qe * Math.sin(rt), this.y = Wn, this.z = Qe * Math.cos(rt), this;
                    }
                    setFromMatrixPosition(Qe) {
                        const rt = Qe.elements;
                        return this.x = rt[12], this.y = rt[13], this.z = rt[14], this;
                    }
                    setFromMatrixScale(Qe) {
                        const rt = this.setFromMatrixColumn(Qe, 0).length(), Wn = this.setFromMatrixColumn(Qe, 1).length(), Co = this.setFromMatrixColumn(Qe, 2).length();
                        return this.x = rt, this.y = Wn, this.z = Co, this;
                    }
                    setFromMatrixColumn(Qe, rt) {
                        return this.fromArray(Qe.elements, 4 * rt);
                    }
                    setFromMatrix3Column(Qe, rt) {
                        return this.fromArray(Qe.elements, 3 * rt);
                    }
                    setFromEuler(Qe) {
                        return this.x = Qe._x, this.y = Qe._y, this.z = Qe._z, this;
                    }
                    setFromColor(Qe) {
                        return this.x = Qe.r, this.y = Qe.g, this.z = Qe.b, this;
                    }
                    equals(Qe) {
                        return Qe.x === this.x && Qe.y === this.y && Qe.z === this.z;
                    }
                    fromArray(Qe, rt) {
                        return void 0 === rt && (rt = 0), this.x = Qe[rt], this.y = Qe[rt + 1], this.z = Qe[rt + 2], this;
                    }
                    toArray(Qe, rt) {
                        return void 0 === Qe && (Qe = []), void 0 === rt && (rt = 0), Qe[rt] = this.x, Qe[rt + 1] = this.y, Qe[rt + 2] = this.z, Qe;
                    }
                    fromBufferAttribute(Qe, rt) {
                        return this.x = Qe.getX(rt), this.y = Qe.getY(rt), this.z = Qe.getZ(rt), this;
                    }
                    random() {
                        return this.x = Math.random(), this.y = Math.random(), this.z = Math.random(), this;
                    }
                    randomDirection() {
                        const Qe = Math.random() * Math.PI * 2, rt = 2 * Math.random() - 1, Wn = Math.sqrt(1 - rt * rt);
                        return this.x = Wn * Math.cos(Qe), this.y = rt, this.z = Wn * Math.sin(Qe), this;
                    }
                    *[Symbol.iterator]() {
                        yield this.x, yield this.y, yield this.z;
                    }
                }
                const Ym = new Vector3, Qm = new Quaternion;
                class Box3 {
                    constructor(Qe, rt){
                        void 0 === Qe && (Qe = new Vector3(1 / 0, 1 / 0, 1 / 0)), void 0 === rt && (rt = new Vector3(-1 / 0, -1 / 0, -1 / 0)), this.isBox3 = !0, this.min = Qe, this.max = rt;
                    }
                    set(Qe, rt) {
                        return this.min.copy(Qe), this.max.copy(rt), this;
                    }
                    setFromArray(Qe) {
                        this.makeEmpty();
                        for(let rt = 0, Wn = Qe.length; rt < Wn; rt += 3)this.expandByPoint(Xm.fromArray(Qe, rt));
                        return this;
                    }
                    setFromBufferAttribute(Qe) {
                        this.makeEmpty();
                        for(let rt = 0, Wn = Qe.count; rt < Wn; rt++)this.expandByPoint(Xm.fromBufferAttribute(Qe, rt));
                        return this;
                    }
                    setFromPoints(Qe) {
                        this.makeEmpty();
                        for(let rt = 0, Wn = Qe.length; rt < Wn; rt++)this.expandByPoint(Qe[rt]);
                        return this;
                    }
                    setFromCenterAndSize(Qe, rt) {
                        const Wn = Xm.copy(rt).multiplyScalar(.5);
                        return this.min.copy(Qe).sub(Wn), this.max.copy(Qe).add(Wn), this;
                    }
                    setFromObject(Qe, rt) {
                        return void 0 === rt && (rt = !1), this.makeEmpty(), this.expandByObject(Qe, rt);
                    }
                    clone() {
                        return (new this.constructor).copy(this);
                    }
                    copy(Qe) {
                        return this.min.copy(Qe.min), this.max.copy(Qe.max), this;
                    }
                    makeEmpty() {
                        return this.min.x = this.min.y = this.min.z = 1 / 0, this.max.x = this.max.y = this.max.z = -1 / 0, this;
                    }
                    isEmpty() {
                        return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
                    }
                    getCenter(Qe) {
                        return this.isEmpty() ? Qe.set(0, 0, 0) : Qe.addVectors(this.min, this.max).multiplyScalar(.5);
                    }
                    getSize(Qe) {
                        return this.isEmpty() ? Qe.set(0, 0, 0) : Qe.subVectors(this.max, this.min);
                    }
                    expandByPoint(Qe) {
                        return this.min.min(Qe), this.max.max(Qe), this;
                    }
                    expandByVector(Qe) {
                        return this.min.sub(Qe), this.max.add(Qe), this;
                    }
                    expandByScalar(Qe) {
                        return this.min.addScalar(-Qe), this.max.addScalar(Qe), this;
                    }
                    expandByObject(Qe, rt) {
                        void 0 === rt && (rt = !1), Qe.updateWorldMatrix(!1, !1);
                        const Wn = Qe.geometry;
                        if (void 0 !== Wn) {
                            const Co = Wn.getAttribute("position");
                            if (!0 === rt && void 0 !== Co && !0 !== Qe.isInstancedMesh) for(let rt = 0, Wn = Co.count; rt < Wn; rt++)!0 === Qe.isMesh ? Qe.getVertexPosition(rt, Xm) : Xm.fromBufferAttribute(Co, rt), Xm.applyMatrix4(Qe.matrixWorld), this.expandByPoint(Xm);
                            else void 0 !== Qe.boundingBox ? (null === Qe.boundingBox && Qe.computeBoundingBox(), Jm.copy(Qe.boundingBox)) : (null === Wn.boundingBox && Wn.computeBoundingBox(), Jm.copy(Wn.boundingBox)), Jm.applyMatrix4(Qe.matrixWorld), this.union(Jm);
                        }
                        const Co = Qe.children;
                        for(let Dl = 0, Ll = Co.length; Dl < Ll; Dl++)this.expandByObject(Co[Dl], rt);
                        return this;
                    }
                    containsPoint(Qe) {
                        return Qe.x >= this.min.x && Qe.x <= this.max.x && Qe.y >= this.min.y && Qe.y <= this.max.y && Qe.z >= this.min.z && Qe.z <= this.max.z;
                    }
                    containsBox(Qe) {
                        return this.min.x <= Qe.min.x && Qe.max.x <= this.max.x && this.min.y <= Qe.min.y && Qe.max.y <= this.max.y && this.min.z <= Qe.min.z && Qe.max.z <= this.max.z;
                    }
                    getParameter(Qe, rt) {
                        return rt.set((Qe.x - this.min.x) / (this.max.x - this.min.x), (Qe.y - this.min.y) / (this.max.y - this.min.y), (Qe.z - this.min.z) / (this.max.z - this.min.z));
                    }
                    intersectsBox(Qe) {
                        return Qe.max.x >= this.min.x && Qe.min.x <= this.max.x && Qe.max.y >= this.min.y && Qe.min.y <= this.max.y && Qe.max.z >= this.min.z && Qe.min.z <= this.max.z;
                    }
                    intersectsSphere(Qe) {
                        return this.clampPoint(Qe.center, Xm), Xm.distanceToSquared(Qe.center) <= Qe.radius * Qe.radius;
                    }
                    intersectsPlane(Qe) {
                        let rt, Wn;
                        return Qe.normal.x > 0 ? (rt = Qe.normal.x * this.min.x, Wn = Qe.normal.x * this.max.x) : (rt = Qe.normal.x * this.max.x, Wn = Qe.normal.x * this.min.x), Qe.normal.y > 0 ? (rt += Qe.normal.y * this.min.y, Wn += Qe.normal.y * this.max.y) : (rt += Qe.normal.y * this.max.y, Wn += Qe.normal.y * this.min.y), Qe.normal.z > 0 ? (rt += Qe.normal.z * this.min.z, Wn += Qe.normal.z * this.max.z) : (rt += Qe.normal.z * this.max.z, Wn += Qe.normal.z * this.min.z), rt <= -Qe.constant && Wn >= -Qe.constant;
                    }
                    intersectsTriangle(Qe) {
                        if (this.isEmpty()) return !1;
                        this.getCenter(af), of.subVectors(this.max, af), $m.subVectors(Qe.a, af), ef.subVectors(Qe.b, af), tf.subVectors(Qe.c, af), nf.subVectors(ef, $m), rf.subVectors(tf, ef), sf.subVectors($m, tf);
                        let rt = [
                            0,
                            -nf.z,
                            nf.y,
                            0,
                            -rf.z,
                            rf.y,
                            0,
                            -sf.z,
                            sf.y,
                            nf.z,
                            0,
                            -nf.x,
                            rf.z,
                            0,
                            -rf.x,
                            sf.z,
                            0,
                            -sf.x,
                            -nf.y,
                            nf.x,
                            0,
                            -rf.y,
                            rf.x,
                            0,
                            -sf.y,
                            sf.x,
                            0
                        ];
                        return !!satForAxes(rt, $m, ef, tf, of) && (rt = [
                            1,
                            0,
                            0,
                            0,
                            1,
                            0,
                            0,
                            0,
                            1
                        ], !!satForAxes(rt, $m, ef, tf, of) && (lf.crossVectors(nf, rf), rt = [
                            lf.x,
                            lf.y,
                            lf.z
                        ], satForAxes(rt, $m, ef, tf, of)));
                    }
                    clampPoint(Qe, rt) {
                        return rt.copy(Qe).clamp(this.min, this.max);
                    }
                    distanceToPoint(Qe) {
                        return this.clampPoint(Qe, Xm).distanceTo(Qe);
                    }
                    getBoundingSphere(Qe) {
                        return this.isEmpty() ? Qe.makeEmpty() : (this.getCenter(Qe.center), Qe.radius = .5 * this.getSize(Xm).length()), Qe;
                    }
                    intersect(Qe) {
                        return this.min.max(Qe.min), this.max.min(Qe.max), this.isEmpty() && this.makeEmpty(), this;
                    }
                    union(Qe) {
                        return this.min.min(Qe.min), this.max.max(Qe.max), this;
                    }
                    applyMatrix4(Qe) {
                        return this.isEmpty() || (Km[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(Qe), Km[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(Qe), Km[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(Qe), Km[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(Qe), Km[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(Qe), Km[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(Qe), Km[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(Qe), Km[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(Qe), this.setFromPoints(Km)), this;
                    }
                    translate(Qe) {
                        return this.min.add(Qe), this.max.add(Qe), this;
                    }
                    equals(Qe) {
                        return Qe.min.equals(this.min) && Qe.max.equals(this.max);
                    }
                }
                const Km = [
                    new Vector3,
                    new Vector3,
                    new Vector3,
                    new Vector3,
                    new Vector3,
                    new Vector3,
                    new Vector3,
                    new Vector3
                ], Xm = new Vector3, Jm = new Box3, $m = new Vector3, ef = new Vector3, tf = new Vector3, nf = new Vector3, rf = new Vector3, sf = new Vector3, af = new Vector3, of = new Vector3, lf = new Vector3, cf = new Vector3;
                function satForAxes(Qe, rt, Wn, Co, Dl) {
                    for(let Ll = 0, Rl = Qe.length - 3; Ll <= Rl; Ll += 3){
                        cf.fromArray(Qe, Ll);
                        const Rl = Dl.x * Math.abs(cf.x) + Dl.y * Math.abs(cf.y) + Dl.z * Math.abs(cf.z), Ul = rt.dot(cf), Gl = Wn.dot(cf), Zl = Co.dot(cf);
                        if (Math.max(-Math.max(Ul, Gl, Zl), Math.min(Ul, Gl, Zl)) > Rl) return !1;
                    }
                    return !0;
                }
                const uf = new Box3, hf = new Vector3, df = new Vector3;
                class Sphere {
                    constructor(Qe, rt){
                        void 0 === Qe && (Qe = new Vector3), void 0 === rt && (rt = -1), this.isSphere = !0, this.center = Qe, this.radius = rt;
                    }
                    set(Qe, rt) {
                        return this.center.copy(Qe), this.radius = rt, this;
                    }
                    setFromPoints(Qe, rt) {
                        const Wn = this.center;
                        void 0 !== rt ? Wn.copy(rt) : uf.setFromPoints(Qe).getCenter(Wn);
                        let Co = 0;
                        for(let Dl = 0, Ll = Qe.length; Dl < Ll; Dl++)Co = Math.max(Co, Wn.distanceToSquared(Qe[Dl]));
                        return this.radius = Math.sqrt(Co), this;
                    }
                    copy(Qe) {
                        return this.center.copy(Qe.center), this.radius = Qe.radius, this;
                    }
                    isEmpty() {
                        return this.radius < 0;
                    }
                    makeEmpty() {
                        return this.center.set(0, 0, 0), this.radius = -1, this;
                    }
                    containsPoint(Qe) {
                        return Qe.distanceToSquared(this.center) <= this.radius * this.radius;
                    }
                    distanceToPoint(Qe) {
                        return Qe.distanceTo(this.center) - this.radius;
                    }
                    intersectsSphere(Qe) {
                        const rt = this.radius + Qe.radius;
                        return Qe.center.distanceToSquared(this.center) <= rt * rt;
                    }
                    intersectsBox(Qe) {
                        return Qe.intersectsSphere(this);
                    }
                    intersectsPlane(Qe) {
                        return Math.abs(Qe.distanceToPoint(this.center)) <= this.radius;
                    }
                    clampPoint(Qe, rt) {
                        const Wn = this.center.distanceToSquared(Qe);
                        return rt.copy(Qe), Wn > this.radius * this.radius && (rt.sub(this.center).normalize(), rt.multiplyScalar(this.radius).add(this.center)), rt;
                    }
                    getBoundingBox(Qe) {
                        return this.isEmpty() ? (Qe.makeEmpty(), Qe) : (Qe.set(this.center, this.center), Qe.expandByScalar(this.radius), Qe);
                    }
                    applyMatrix4(Qe) {
                        return this.center.applyMatrix4(Qe), this.radius = this.radius * Qe.getMaxScaleOnAxis(), this;
                    }
                    translate(Qe) {
                        return this.center.add(Qe), this;
                    }
                    expandByPoint(Qe) {
                        if (this.isEmpty()) return this.center.copy(Qe), this.radius = 0, this;
                        hf.subVectors(Qe, this.center);
                        const rt = hf.lengthSq();
                        if (rt > this.radius * this.radius) {
                            const Qe = Math.sqrt(rt), Wn = .5 * (Qe - this.radius);
                            this.center.addScaledVector(hf, Wn / Qe), this.radius += Wn;
                        }
                        return this;
                    }
                    union(Qe) {
                        return Qe.isEmpty() ? this : this.isEmpty() ? (this.copy(Qe), this) : (!0 === this.center.equals(Qe.center) ? this.radius = Math.max(this.radius, Qe.radius) : (df.subVectors(Qe.center, this.center).setLength(Qe.radius), this.expandByPoint(hf.copy(Qe.center).add(df)), this.expandByPoint(hf.copy(Qe.center).sub(df))), this);
                    }
                    equals(Qe) {
                        return Qe.center.equals(this.center) && Qe.radius === this.radius;
                    }
                    clone() {
                        return (new this.constructor).copy(this);
                    }
                }
                const pf = new Vector3, mf = new Vector3, ff = new Vector3, gf = new Vector3, Af = new Vector3, yf = new Vector3, vf = new Vector3;
                class Ray {
                    constructor(Qe, rt){
                        void 0 === Qe && (Qe = new Vector3), void 0 === rt && (rt = new Vector3(0, 0, -1)), this.origin = Qe, this.direction = rt;
                    }
                    set(Qe, rt) {
                        return this.origin.copy(Qe), this.direction.copy(rt), this;
                    }
                    copy(Qe) {
                        return this.origin.copy(Qe.origin), this.direction.copy(Qe.direction), this;
                    }
                    at(Qe, rt) {
                        return rt.copy(this.origin).addScaledVector(this.direction, Qe);
                    }
                    lookAt(Qe) {
                        return this.direction.copy(Qe).sub(this.origin).normalize(), this;
                    }
                    recast(Qe) {
                        return this.origin.copy(this.at(Qe, pf)), this;
                    }
                    closestPointToPoint(Qe, rt) {
                        rt.subVectors(Qe, this.origin);
                        const Wn = rt.dot(this.direction);
                        return Wn < 0 ? rt.copy(this.origin) : rt.copy(this.origin).addScaledVector(this.direction, Wn);
                    }
                    distanceToPoint(Qe) {
                        return Math.sqrt(this.distanceSqToPoint(Qe));
                    }
                    distanceSqToPoint(Qe) {
                        const rt = pf.subVectors(Qe, this.origin).dot(this.direction);
                        return rt < 0 ? this.origin.distanceToSquared(Qe) : (pf.copy(this.origin).addScaledVector(this.direction, rt), pf.distanceToSquared(Qe));
                    }
                    distanceSqToSegment(Qe, rt, Wn, Co) {
                        mf.copy(Qe).add(rt).multiplyScalar(.5), ff.copy(rt).sub(Qe).normalize(), gf.copy(this.origin).sub(mf);
                        const Dl = .5 * Qe.distanceTo(rt), Ll = -this.direction.dot(ff), Rl = gf.dot(this.direction), Ul = -gf.dot(ff), Gl = gf.lengthSq(), Zl = Math.abs(1 - Ll * Ll);
                        let Hl, ql, Ql, Kl;
                        if (Zl > 0) {
                            if (Hl = Ll * Ul - Rl, ql = Ll * Rl - Ul, Kl = Dl * Zl, Hl >= 0) {
                                if (ql >= -Kl) {
                                    if (ql <= Kl) {
                                        const Qe = 1 / Zl;
                                        Hl *= Qe, ql *= Qe, Ql = Hl * (Hl + Ll * ql + 2 * Rl) + ql * (Ll * Hl + ql + 2 * Ul) + Gl;
                                    } else ql = Dl, Hl = Math.max(0, -(Ll * ql + Rl)), Ql = -Hl * Hl + ql * (ql + 2 * Ul) + Gl;
                                } else ql = -Dl, Hl = Math.max(0, -(Ll * ql + Rl)), Ql = -Hl * Hl + ql * (ql + 2 * Ul) + Gl;
                            } else ql <= -Kl ? (Hl = Math.max(0, -(-Ll * Dl + Rl)), ql = Hl > 0 ? -Dl : Math.min(Math.max(-Dl, -Ul), Dl), Ql = -Hl * Hl + ql * (ql + 2 * Ul) + Gl) : ql <= Kl ? (Hl = 0, ql = Math.min(Math.max(-Dl, -Ul), Dl), Ql = ql * (ql + 2 * Ul) + Gl) : (Hl = Math.max(0, -(Ll * Dl + Rl)), ql = Hl > 0 ? Dl : Math.min(Math.max(-Dl, -Ul), Dl), Ql = -Hl * Hl + ql * (ql + 2 * Ul) + Gl);
                        } else ql = Ll > 0 ? -Dl : Dl, Hl = Math.max(0, -(Ll * ql + Rl)), Ql = -Hl * Hl + ql * (ql + 2 * Ul) + Gl;
                        return Wn && Wn.copy(this.origin).addScaledVector(this.direction, Hl), Co && Co.copy(mf).addScaledVector(ff, ql), Ql;
                    }
                    intersectSphere(Qe, rt) {
                        pf.subVectors(Qe.center, this.origin);
                        const Wn = pf.dot(this.direction), Co = pf.dot(pf) - Wn * Wn, Dl = Qe.radius * Qe.radius;
                        if (Co > Dl) return null;
                        const Ll = Math.sqrt(Dl - Co), Rl = Wn - Ll, Ul = Wn + Ll;
                        return Ul < 0 ? null : Rl < 0 ? this.at(Ul, rt) : this.at(Rl, rt);
                    }
                    intersectsSphere(Qe) {
                        return this.distanceSqToPoint(Qe.center) <= Qe.radius * Qe.radius;
                    }
                    distanceToPlane(Qe) {
                        const rt = Qe.normal.dot(this.direction);
                        if (0 === rt) return 0 === Qe.distanceToPoint(this.origin) ? 0 : null;
                        const Wn = -(this.origin.dot(Qe.normal) + Qe.constant) / rt;
                        return Wn >= 0 ? Wn : null;
                    }
                    intersectPlane(Qe, rt) {
                        const Wn = this.distanceToPlane(Qe);
                        return null === Wn ? null : this.at(Wn, rt);
                    }
                    intersectsPlane(Qe) {
                        const rt = Qe.distanceToPoint(this.origin);
                        if (0 === rt) return !0;
                        return Qe.normal.dot(this.direction) * rt < 0;
                    }
                    intersectBox(Qe, rt) {
                        let Wn, Co, Dl, Ll, Rl, Ul;
                        const Gl = 1 / this.direction.x, Zl = 1 / this.direction.y, Hl = 1 / this.direction.z, ql = this.origin;
                        return Gl >= 0 ? (Wn = (Qe.min.x - ql.x) * Gl, Co = (Qe.max.x - ql.x) * Gl) : (Wn = (Qe.max.x - ql.x) * Gl, Co = (Qe.min.x - ql.x) * Gl), Zl >= 0 ? (Dl = (Qe.min.y - ql.y) * Zl, Ll = (Qe.max.y - ql.y) * Zl) : (Dl = (Qe.max.y - ql.y) * Zl, Ll = (Qe.min.y - ql.y) * Zl), Wn > Ll || Dl > Co ? null : ((Dl > Wn || isNaN(Wn)) && (Wn = Dl), (Ll < Co || isNaN(Co)) && (Co = Ll), Hl >= 0 ? (Rl = (Qe.min.z - ql.z) * Hl, Ul = (Qe.max.z - ql.z) * Hl) : (Rl = (Qe.max.z - ql.z) * Hl, Ul = (Qe.min.z - ql.z) * Hl), Wn > Ul || Rl > Co ? null : ((Rl > Wn || Wn !== Wn) && (Wn = Rl), (Ul < Co || Co !== Co) && (Co = Ul), Co < 0 ? null : this.at(Wn >= 0 ? Wn : Co, rt)));
                    }
                    intersectsBox(Qe) {
                        return null !== this.intersectBox(Qe, pf);
                    }
                    intersectTriangle(Qe, rt, Wn, Co, Dl) {
                        Af.subVectors(rt, Qe), yf.subVectors(Wn, Qe), vf.crossVectors(Af, yf);
                        let Ll, Rl = this.direction.dot(vf);
                        if (Rl > 0) {
                            if (Co) return null;
                            Ll = 1;
                        } else {
                            if (!(Rl < 0)) return null;
                            Ll = -1, Rl = -Rl;
                        }
                        gf.subVectors(this.origin, Qe);
                        const Ul = Ll * this.direction.dot(yf.crossVectors(gf, yf));
                        if (Ul < 0) return null;
                        const Gl = Ll * this.direction.dot(Af.cross(gf));
                        if (Gl < 0) return null;
                        if (Ul + Gl > Rl) return null;
                        const Zl = -Ll * gf.dot(vf);
                        return Zl < 0 ? null : this.at(Zl / Rl, Dl);
                    }
                    applyMatrix4(Qe) {
                        return this.origin.applyMatrix4(Qe), this.direction.transformDirection(Qe), this;
                    }
                    equals(Qe) {
                        return Qe.origin.equals(this.origin) && Qe.direction.equals(this.direction);
                    }
                    clone() {
                        return (new this.constructor).copy(this);
                    }
                }
                class Matrix4 {
                    constructor(Qe, rt, Wn, Co, Dl, Ll, Rl, Ul, Gl, Zl, Hl, ql, Ql, Kl, $l, Tc){
                        Matrix4.prototype.isMatrix4 = !0, this.elements = [
                            1,
                            0,
                            0,
                            0,
                            0,
                            1,
                            0,
                            0,
                            0,
                            0,
                            1,
                            0,
                            0,
                            0,
                            0,
                            1
                        ], void 0 !== Qe && this.set(Qe, rt, Wn, Co, Dl, Ll, Rl, Ul, Gl, Zl, Hl, ql, Ql, Kl, $l, Tc);
                    }
                    set(Qe, rt, Wn, Co, Dl, Ll, Rl, Ul, Gl, Zl, Hl, ql, Ql, Kl, $l, Tc) {
                        const tu = this.elements;
                        return tu[0] = Qe, tu[4] = rt, tu[8] = Wn, tu[12] = Co, tu[1] = Dl, tu[5] = Ll, tu[9] = Rl, tu[13] = Ul, tu[2] = Gl, tu[6] = Zl, tu[10] = Hl, tu[14] = ql, tu[3] = Ql, tu[7] = Kl, tu[11] = $l, tu[15] = Tc, this;
                    }
                    identity() {
                        return this.set(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1), this;
                    }
                    clone() {
                        return (new Matrix4).fromArray(this.elements);
                    }
                    copy(Qe) {
                        const rt = this.elements, Wn = Qe.elements;
                        return rt[0] = Wn[0], rt[1] = Wn[1], rt[2] = Wn[2], rt[3] = Wn[3], rt[4] = Wn[4], rt[5] = Wn[5], rt[6] = Wn[6], rt[7] = Wn[7], rt[8] = Wn[8], rt[9] = Wn[9], rt[10] = Wn[10], rt[11] = Wn[11], rt[12] = Wn[12], rt[13] = Wn[13], rt[14] = Wn[14], rt[15] = Wn[15], this;
                    }
                    copyPosition(Qe) {
                        const rt = this.elements, Wn = Qe.elements;
                        return rt[12] = Wn[12], rt[13] = Wn[13], rt[14] = Wn[14], this;
                    }
                    setFromMatrix3(Qe) {
                        const rt = Qe.elements;
                        return this.set(rt[0], rt[3], rt[6], 0, rt[1], rt[4], rt[7], 0, rt[2], rt[5], rt[8], 0, 0, 0, 0, 1), this;
                    }
                    extractBasis(Qe, rt, Wn) {
                        return Qe.setFromMatrixColumn(this, 0), rt.setFromMatrixColumn(this, 1), Wn.setFromMatrixColumn(this, 2), this;
                    }
                    makeBasis(Qe, rt, Wn) {
                        return this.set(Qe.x, rt.x, Wn.x, 0, Qe.y, rt.y, Wn.y, 0, Qe.z, rt.z, Wn.z, 0, 0, 0, 0, 1), this;
                    }
                    extractRotation(Qe) {
                        const rt = this.elements, Wn = Qe.elements, Co = 1 / _f.setFromMatrixColumn(Qe, 0).length(), Dl = 1 / _f.setFromMatrixColumn(Qe, 1).length(), Ll = 1 / _f.setFromMatrixColumn(Qe, 2).length();
                        return rt[0] = Wn[0] * Co, rt[1] = Wn[1] * Co, rt[2] = Wn[2] * Co, rt[3] = 0, rt[4] = Wn[4] * Dl, rt[5] = Wn[5] * Dl, rt[6] = Wn[6] * Dl, rt[7] = 0, rt[8] = Wn[8] * Ll, rt[9] = Wn[9] * Ll, rt[10] = Wn[10] * Ll, rt[11] = 0, rt[12] = 0, rt[13] = 0, rt[14] = 0, rt[15] = 1, this;
                    }
                    makeRotationFromEuler(Qe) {
                        const rt = this.elements, Wn = Qe.x, Co = Qe.y, Dl = Qe.z, Ll = Math.cos(Wn), Rl = Math.sin(Wn), Ul = Math.cos(Co), Gl = Math.sin(Co), Zl = Math.cos(Dl), Hl = Math.sin(Dl);
                        if ("XYZ" === Qe.order) {
                            const Qe = Ll * Zl, Wn = Ll * Hl, Co = Rl * Zl, Dl = Rl * Hl;
                            rt[0] = Ul * Zl, rt[4] = -Ul * Hl, rt[8] = Gl, rt[1] = Wn + Co * Gl, rt[5] = Qe - Dl * Gl, rt[9] = -Rl * Ul, rt[2] = Dl - Qe * Gl, rt[6] = Co + Wn * Gl, rt[10] = Ll * Ul;
                        } else if ("YXZ" === Qe.order) {
                            const Qe = Ul * Zl, Wn = Ul * Hl, Co = Gl * Zl, Dl = Gl * Hl;
                            rt[0] = Qe + Dl * Rl, rt[4] = Co * Rl - Wn, rt[8] = Ll * Gl, rt[1] = Ll * Hl, rt[5] = Ll * Zl, rt[9] = -Rl, rt[2] = Wn * Rl - Co, rt[6] = Dl + Qe * Rl, rt[10] = Ll * Ul;
                        } else if ("ZXY" === Qe.order) {
                            const Qe = Ul * Zl, Wn = Ul * Hl, Co = Gl * Zl, Dl = Gl * Hl;
                            rt[0] = Qe - Dl * Rl, rt[4] = -Ll * Hl, rt[8] = Co + Wn * Rl, rt[1] = Wn + Co * Rl, rt[5] = Ll * Zl, rt[9] = Dl - Qe * Rl, rt[2] = -Ll * Gl, rt[6] = Rl, rt[10] = Ll * Ul;
                        } else if ("ZYX" === Qe.order) {
                            const Qe = Ll * Zl, Wn = Ll * Hl, Co = Rl * Zl, Dl = Rl * Hl;
                            rt[0] = Ul * Zl, rt[4] = Co * Gl - Wn, rt[8] = Qe * Gl + Dl, rt[1] = Ul * Hl, rt[5] = Dl * Gl + Qe, rt[9] = Wn * Gl - Co, rt[2] = -Gl, rt[6] = Rl * Ul, rt[10] = Ll * Ul;
                        } else if ("YZX" === Qe.order) {
                            const Qe = Ll * Ul, Wn = Ll * Gl, Co = Rl * Ul, Dl = Rl * Gl;
                            rt[0] = Ul * Zl, rt[4] = Dl - Qe * Hl, rt[8] = Co * Hl + Wn, rt[1] = Hl, rt[5] = Ll * Zl, rt[9] = -Rl * Zl, rt[2] = -Gl * Zl, rt[6] = Wn * Hl + Co, rt[10] = Qe - Dl * Hl;
                        } else if ("XZY" === Qe.order) {
                            const Qe = Ll * Ul, Wn = Ll * Gl, Co = Rl * Ul, Dl = Rl * Gl;
                            rt[0] = Ul * Zl, rt[4] = -Hl, rt[8] = Gl * Zl, rt[1] = Qe * Hl + Dl, rt[5] = Ll * Zl, rt[9] = Wn * Hl - Co, rt[2] = Co * Hl - Wn, rt[6] = Rl * Zl, rt[10] = Dl * Hl + Qe;
                        }
                        return rt[3] = 0, rt[7] = 0, rt[11] = 0, rt[12] = 0, rt[13] = 0, rt[14] = 0, rt[15] = 1, this;
                    }
                    makeRotationFromQuaternion(Qe) {
                        return this.compose(bf, Qe, wf);
                    }
                    lookAt(Qe, rt, Wn) {
                        const Co = this.elements;
                        return Sf.subVectors(Qe, rt), 0 === Sf.lengthSq() && (Sf.z = 1), Sf.normalize(), Ef.crossVectors(Wn, Sf), 0 === Ef.lengthSq() && (1 === Math.abs(Wn.z) ? Sf.x += 1e-4 : Sf.z += 1e-4, Sf.normalize(), Ef.crossVectors(Wn, Sf)), Ef.normalize(), Mf.crossVectors(Sf, Ef), Co[0] = Ef.x, Co[4] = Mf.x, Co[8] = Sf.x, Co[1] = Ef.y, Co[5] = Mf.y, Co[9] = Sf.y, Co[2] = Ef.z, Co[6] = Mf.z, Co[10] = Sf.z, this;
                    }
                    multiply(Qe) {
                        return this.multiplyMatrices(this, Qe);
                    }
                    premultiply(Qe) {
                        return this.multiplyMatrices(Qe, this);
                    }
                    multiplyMatrices(Qe, rt) {
                        const Wn = Qe.elements, Co = rt.elements, Dl = this.elements, Ll = Wn[0], Rl = Wn[4], Ul = Wn[8], Gl = Wn[12], Zl = Wn[1], Hl = Wn[5], ql = Wn[9], Ql = Wn[13], Kl = Wn[2], $l = Wn[6], Tc = Wn[10], tu = Wn[14], lu = Wn[3], du = Wn[7], fu = Wn[11], yu = Wn[15], Eu = Co[0], Tu = Co[4], Lu = Co[8], Zu = Co[12], Xu = Co[1], Ju = Co[5], $u = Co[9], ed = Co[13], td = Co[2], id = Co[6], nd = Co[10], rd = Co[14], sd = Co[3], ad = Co[7], od = Co[11], ld = Co[15];
                        return Dl[0] = Ll * Eu + Rl * Xu + Ul * td + Gl * sd, Dl[4] = Ll * Tu + Rl * Ju + Ul * id + Gl * ad, Dl[8] = Ll * Lu + Rl * $u + Ul * nd + Gl * od, Dl[12] = Ll * Zu + Rl * ed + Ul * rd + Gl * ld, Dl[1] = Zl * Eu + Hl * Xu + ql * td + Ql * sd, Dl[5] = Zl * Tu + Hl * Ju + ql * id + Ql * ad, Dl[9] = Zl * Lu + Hl * $u + ql * nd + Ql * od, Dl[13] = Zl * Zu + Hl * ed + ql * rd + Ql * ld, Dl[2] = Kl * Eu + $l * Xu + Tc * td + tu * sd, Dl[6] = Kl * Tu + $l * Ju + Tc * id + tu * ad, Dl[10] = Kl * Lu + $l * $u + Tc * nd + tu * od, Dl[14] = Kl * Zu + $l * ed + Tc * rd + tu * ld, Dl[3] = lu * Eu + du * Xu + fu * td + yu * sd, Dl[7] = lu * Tu + du * Ju + fu * id + yu * ad, Dl[11] = lu * Lu + du * $u + fu * nd + yu * od, Dl[15] = lu * Zu + du * ed + fu * rd + yu * ld, this;
                    }
                    multiplyScalar(Qe) {
                        const rt = this.elements;
                        return rt[0] *= Qe, rt[4] *= Qe, rt[8] *= Qe, rt[12] *= Qe, rt[1] *= Qe, rt[5] *= Qe, rt[9] *= Qe, rt[13] *= Qe, rt[2] *= Qe, rt[6] *= Qe, rt[10] *= Qe, rt[14] *= Qe, rt[3] *= Qe, rt[7] *= Qe, rt[11] *= Qe, rt[15] *= Qe, this;
                    }
                    determinant() {
                        const Qe = this.elements, rt = Qe[0], Wn = Qe[4], Co = Qe[8], Dl = Qe[12], Ll = Qe[1], Rl = Qe[5], Ul = Qe[9], Gl = Qe[13], Zl = Qe[2], Hl = Qe[6], ql = Qe[10], Ql = Qe[14];
                        return Qe[3] * (+Dl * Ul * Hl - Co * Gl * Hl - Dl * Rl * ql + Wn * Gl * ql + Co * Rl * Ql - Wn * Ul * Ql) + Qe[7] * (+rt * Ul * Ql - rt * Gl * ql + Dl * Ll * ql - Co * Ll * Ql + Co * Gl * Zl - Dl * Ul * Zl) + Qe[11] * (+rt * Gl * Hl - rt * Rl * Ql - Dl * Ll * Hl + Wn * Ll * Ql + Dl * Rl * Zl - Wn * Gl * Zl) + Qe[15] * (-Co * Rl * Zl - rt * Ul * Hl + rt * Rl * ql + Co * Ll * Hl - Wn * Ll * ql + Wn * Ul * Zl);
                    }
                    transpose() {
                        const Qe = this.elements;
                        let rt;
                        return rt = Qe[1], Qe[1] = Qe[4], Qe[4] = rt, rt = Qe[2], Qe[2] = Qe[8], Qe[8] = rt, rt = Qe[6], Qe[6] = Qe[9], Qe[9] = rt, rt = Qe[3], Qe[3] = Qe[12], Qe[12] = rt, rt = Qe[7], Qe[7] = Qe[13], Qe[13] = rt, rt = Qe[11], Qe[11] = Qe[14], Qe[14] = rt, this;
                    }
                    setPosition(Qe, rt, Wn) {
                        const Co = this.elements;
                        return Qe.isVector3 ? (Co[12] = Qe.x, Co[13] = Qe.y, Co[14] = Qe.z) : (Co[12] = Qe, Co[13] = rt, Co[14] = Wn), this;
                    }
                    invert() {
                        const Qe = this.elements, rt = Qe[0], Wn = Qe[1], Co = Qe[2], Dl = Qe[3], Ll = Qe[4], Rl = Qe[5], Ul = Qe[6], Gl = Qe[7], Zl = Qe[8], Hl = Qe[9], ql = Qe[10], Ql = Qe[11], Kl = Qe[12], $l = Qe[13], Tc = Qe[14], tu = Qe[15], lu = Hl * Tc * Gl - $l * ql * Gl + $l * Ul * Ql - Rl * Tc * Ql - Hl * Ul * tu + Rl * ql * tu, du = Kl * ql * Gl - Zl * Tc * Gl - Kl * Ul * Ql + Ll * Tc * Ql + Zl * Ul * tu - Ll * ql * tu, fu = Zl * $l * Gl - Kl * Hl * Gl + Kl * Rl * Ql - Ll * $l * Ql - Zl * Rl * tu + Ll * Hl * tu, yu = Kl * Hl * Ul - Zl * $l * Ul - Kl * Rl * ql + Ll * $l * ql + Zl * Rl * Tc - Ll * Hl * Tc, Eu = rt * lu + Wn * du + Co * fu + Dl * yu;
                        if (0 === Eu) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
                        const Tu = 1 / Eu;
                        return Qe[0] = lu * Tu, Qe[1] = ($l * ql * Dl - Hl * Tc * Dl - $l * Co * Ql + Wn * Tc * Ql + Hl * Co * tu - Wn * ql * tu) * Tu, Qe[2] = (Rl * Tc * Dl - $l * Ul * Dl + $l * Co * Gl - Wn * Tc * Gl - Rl * Co * tu + Wn * Ul * tu) * Tu, Qe[3] = (Hl * Ul * Dl - Rl * ql * Dl - Hl * Co * Gl + Wn * ql * Gl + Rl * Co * Ql - Wn * Ul * Ql) * Tu, Qe[4] = du * Tu, Qe[5] = (Zl * Tc * Dl - Kl * ql * Dl + Kl * Co * Ql - rt * Tc * Ql - Zl * Co * tu + rt * ql * tu) * Tu, Qe[6] = (Kl * Ul * Dl - Ll * Tc * Dl - Kl * Co * Gl + rt * Tc * Gl + Ll * Co * tu - rt * Ul * tu) * Tu, Qe[7] = (Ll * ql * Dl - Zl * Ul * Dl + Zl * Co * Gl - rt * ql * Gl - Ll * Co * Ql + rt * Ul * Ql) * Tu, Qe[8] = fu * Tu, Qe[9] = (Kl * Hl * Dl - Zl * $l * Dl - Kl * Wn * Ql + rt * $l * Ql + Zl * Wn * tu - rt * Hl * tu) * Tu, Qe[10] = (Ll * $l * Dl - Kl * Rl * Dl + Kl * Wn * Gl - rt * $l * Gl - Ll * Wn * tu + rt * Rl * tu) * Tu, Qe[11] = (Zl * Rl * Dl - Ll * Hl * Dl - Zl * Wn * Gl + rt * Hl * Gl + Ll * Wn * Ql - rt * Rl * Ql) * Tu, Qe[12] = yu * Tu, Qe[13] = (Zl * $l * Co - Kl * Hl * Co + Kl * Wn * ql - rt * $l * ql - Zl * Wn * Tc + rt * Hl * Tc) * Tu, Qe[14] = (Kl * Rl * Co - Ll * $l * Co - Kl * Wn * Ul + rt * $l * Ul + Ll * Wn * Tc - rt * Rl * Tc) * Tu, Qe[15] = (Ll * Hl * Co - Zl * Rl * Co + Zl * Wn * Ul - rt * Hl * Ul - Ll * Wn * ql + rt * Rl * ql) * Tu, this;
                    }
                    scale(Qe) {
                        const rt = this.elements, Wn = Qe.x, Co = Qe.y, Dl = Qe.z;
                        return rt[0] *= Wn, rt[4] *= Co, rt[8] *= Dl, rt[1] *= Wn, rt[5] *= Co, rt[9] *= Dl, rt[2] *= Wn, rt[6] *= Co, rt[10] *= Dl, rt[3] *= Wn, rt[7] *= Co, rt[11] *= Dl, this;
                    }
                    getMaxScaleOnAxis() {
                        const Qe = this.elements, rt = Qe[0] * Qe[0] + Qe[1] * Qe[1] + Qe[2] * Qe[2], Wn = Qe[4] * Qe[4] + Qe[5] * Qe[5] + Qe[6] * Qe[6], Co = Qe[8] * Qe[8] + Qe[9] * Qe[9] + Qe[10] * Qe[10];
                        return Math.sqrt(Math.max(rt, Wn, Co));
                    }
                    makeTranslation(Qe, rt, Wn) {
                        return Qe.isVector3 ? this.set(1, 0, 0, Qe.x, 0, 1, 0, Qe.y, 0, 0, 1, Qe.z, 0, 0, 0, 1) : this.set(1, 0, 0, Qe, 0, 1, 0, rt, 0, 0, 1, Wn, 0, 0, 0, 1), this;
                    }
                    makeRotationX(Qe) {
                        const rt = Math.cos(Qe), Wn = Math.sin(Qe);
                        return this.set(1, 0, 0, 0, 0, rt, -Wn, 0, 0, Wn, rt, 0, 0, 0, 0, 1), this;
                    }
                    makeRotationY(Qe) {
                        const rt = Math.cos(Qe), Wn = Math.sin(Qe);
                        return this.set(rt, 0, Wn, 0, 0, 1, 0, 0, -Wn, 0, rt, 0, 0, 0, 0, 1), this;
                    }
                    makeRotationZ(Qe) {
                        const rt = Math.cos(Qe), Wn = Math.sin(Qe);
                        return this.set(rt, -Wn, 0, 0, Wn, rt, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1), this;
                    }
                    makeRotationAxis(Qe, rt) {
                        const Wn = Math.cos(rt), Co = Math.sin(rt), Dl = 1 - Wn, Ll = Qe.x, Rl = Qe.y, Ul = Qe.z, Gl = Dl * Ll, Zl = Dl * Rl;
                        return this.set(Gl * Ll + Wn, Gl * Rl - Co * Ul, Gl * Ul + Co * Rl, 0, Gl * Rl + Co * Ul, Zl * Rl + Wn, Zl * Ul - Co * Ll, 0, Gl * Ul - Co * Rl, Zl * Ul + Co * Ll, Dl * Ul * Ul + Wn, 0, 0, 0, 0, 1), this;
                    }
                    makeScale(Qe, rt, Wn) {
                        return this.set(Qe, 0, 0, 0, 0, rt, 0, 0, 0, 0, Wn, 0, 0, 0, 0, 1), this;
                    }
                    makeShear(Qe, rt, Wn, Co, Dl, Ll) {
                        return this.set(1, Wn, Dl, 0, Qe, 1, Ll, 0, rt, Co, 1, 0, 0, 0, 0, 1), this;
                    }
                    compose(Qe, rt, Wn) {
                        const Co = this.elements, Dl = rt._x, Ll = rt._y, Rl = rt._z, Ul = rt._w, Gl = Dl + Dl, Zl = Ll + Ll, Hl = Rl + Rl, ql = Dl * Gl, Ql = Dl * Zl, Kl = Dl * Hl, $l = Ll * Zl, Tc = Ll * Hl, tu = Rl * Hl, lu = Ul * Gl, du = Ul * Zl, fu = Ul * Hl, yu = Wn.x, Eu = Wn.y, Tu = Wn.z;
                        return Co[0] = (1 - ($l + tu)) * yu, Co[1] = (Ql + fu) * yu, Co[2] = (Kl - du) * yu, Co[3] = 0, Co[4] = (Ql - fu) * Eu, Co[5] = (1 - (ql + tu)) * Eu, Co[6] = (Tc + lu) * Eu, Co[7] = 0, Co[8] = (Kl + du) * Tu, Co[9] = (Tc - lu) * Tu, Co[10] = (1 - (ql + $l)) * Tu, Co[11] = 0, Co[12] = Qe.x, Co[13] = Qe.y, Co[14] = Qe.z, Co[15] = 1, this;
                    }
                    decompose(Qe, rt, Wn) {
                        const Co = this.elements;
                        let Dl = _f.set(Co[0], Co[1], Co[2]).length();
                        const Ll = _f.set(Co[4], Co[5], Co[6]).length(), Rl = _f.set(Co[8], Co[9], Co[10]).length();
                        this.determinant() < 0 && (Dl = -Dl), Qe.x = Co[12], Qe.y = Co[13], Qe.z = Co[14], xf.copy(this);
                        const Ul = 1 / Dl, Gl = 1 / Ll, Zl = 1 / Rl;
                        return xf.elements[0] *= Ul, xf.elements[1] *= Ul, xf.elements[2] *= Ul, xf.elements[4] *= Gl, xf.elements[5] *= Gl, xf.elements[6] *= Gl, xf.elements[8] *= Zl, xf.elements[9] *= Zl, xf.elements[10] *= Zl, rt.setFromRotationMatrix(xf), Wn.x = Dl, Wn.y = Ll, Wn.z = Rl, this;
                    }
                    makePerspective(Qe, rt, Wn, Co, Dl, Ll, Rl) {
                        void 0 === Rl && (Rl = Pm);
                        const Ul = this.elements, Gl = 2 * Dl / (rt - Qe), Zl = 2 * Dl / (Wn - Co), Hl = (rt + Qe) / (rt - Qe), ql = (Wn + Co) / (Wn - Co);
                        let Ql, Kl;
                        if (Rl === Pm) Ql = -(Ll + Dl) / (Ll - Dl), Kl = -2 * Ll * Dl / (Ll - Dl);
                        else {
                            if (Rl !== zm) throw new Error("THREE.Matrix4.makePerspective(): Invalid coordinate system: " + Rl);
                            Ql = -Ll / (Ll - Dl), Kl = -Ll * Dl / (Ll - Dl);
                        }
                        return Ul[0] = Gl, Ul[4] = 0, Ul[8] = Hl, Ul[12] = 0, Ul[1] = 0, Ul[5] = Zl, Ul[9] = ql, Ul[13] = 0, Ul[2] = 0, Ul[6] = 0, Ul[10] = Ql, Ul[14] = Kl, Ul[3] = 0, Ul[7] = 0, Ul[11] = -1, Ul[15] = 0, this;
                    }
                    makeOrthographic(Qe, rt, Wn, Co, Dl, Ll, Rl) {
                        void 0 === Rl && (Rl = Pm);
                        const Ul = this.elements, Gl = 1 / (rt - Qe), Zl = 1 / (Wn - Co), Hl = 1 / (Ll - Dl), ql = (rt + Qe) * Gl, Ql = (Wn + Co) * Zl;
                        let Kl, $l;
                        if (Rl === Pm) Kl = (Ll + Dl) * Hl, $l = -2 * Hl;
                        else {
                            if (Rl !== zm) throw new Error("THREE.Matrix4.makeOrthographic(): Invalid coordinate system: " + Rl);
                            Kl = Dl * Hl, $l = -1 * Hl;
                        }
                        return Ul[0] = 2 * Gl, Ul[4] = 0, Ul[8] = 0, Ul[12] = -ql, Ul[1] = 0, Ul[5] = 2 * Zl, Ul[9] = 0, Ul[13] = -Ql, Ul[2] = 0, Ul[6] = 0, Ul[10] = $l, Ul[14] = -Kl, Ul[3] = 0, Ul[7] = 0, Ul[11] = 0, Ul[15] = 1, this;
                    }
                    equals(Qe) {
                        const rt = this.elements, Wn = Qe.elements;
                        for(let Co = 0; Co < 16; Co++)if (rt[Co] !== Wn[Co]) return !1;
                        return !0;
                    }
                    fromArray(Qe, rt) {
                        void 0 === rt && (rt = 0);
                        for(let Wn = 0; Wn < 16; Wn++)this.elements[Wn] = Qe[Wn + rt];
                        return this;
                    }
                    toArray(Qe, rt) {
                        void 0 === Qe && (Qe = []), void 0 === rt && (rt = 0);
                        const Wn = this.elements;
                        return Qe[rt] = Wn[0], Qe[rt + 1] = Wn[1], Qe[rt + 2] = Wn[2], Qe[rt + 3] = Wn[3], Qe[rt + 4] = Wn[4], Qe[rt + 5] = Wn[5], Qe[rt + 6] = Wn[6], Qe[rt + 7] = Wn[7], Qe[rt + 8] = Wn[8], Qe[rt + 9] = Wn[9], Qe[rt + 10] = Wn[10], Qe[rt + 11] = Wn[11], Qe[rt + 12] = Wn[12], Qe[rt + 13] = Wn[13], Qe[rt + 14] = Wn[14], Qe[rt + 15] = Wn[15], Qe;
                    }
                }
                const _f = new Vector3, xf = new Matrix4, bf = new Vector3(0, 0, 0), wf = new Vector3(1, 1, 1), Ef = new Vector3, Mf = new Vector3, Sf = new Vector3, Tf = new Matrix4, Cf = new Quaternion;
                class Euler {
                    constructor(Qe, rt, Wn, Co){
                        void 0 === Qe && (Qe = 0), void 0 === rt && (rt = 0), void 0 === Wn && (Wn = 0), void 0 === Co && (Co = Euler.DEFAULT_ORDER), this.isEuler = !0, this._x = Qe, this._y = rt, this._z = Wn, this._order = Co;
                    }
                    get x() {
                        return this._x;
                    }
                    set x(Qe) {
                        this._x = Qe, this._onChangeCallback();
                    }
                    get y() {
                        return this._y;
                    }
                    set y(Qe) {
                        this._y = Qe, this._onChangeCallback();
                    }
                    get z() {
                        return this._z;
                    }
                    set z(Qe) {
                        this._z = Qe, this._onChangeCallback();
                    }
                    get order() {
                        return this._order;
                    }
                    set order(Qe) {
                        this._order = Qe, this._onChangeCallback();
                    }
                    set(Qe, rt, Wn, Co) {
                        return void 0 === Co && (Co = this._order), this._x = Qe, this._y = rt, this._z = Wn, this._order = Co, this._onChangeCallback(), this;
                    }
                    clone() {
                        return new this.constructor(this._x, this._y, this._z, this._order);
                    }
                    copy(Qe) {
                        return this._x = Qe._x, this._y = Qe._y, this._z = Qe._z, this._order = Qe._order, this._onChangeCallback(), this;
                    }
                    setFromRotationMatrix(Qe, rt, Wn) {
                        void 0 === rt && (rt = this._order), void 0 === Wn && (Wn = !0);
                        const Co = Qe.elements, Dl = Co[0], Ll = Co[4], Rl = Co[8], Ul = Co[1], Gl = Co[5], Zl = Co[9], Hl = Co[2], ql = Co[6], Ql = Co[10];
                        switch(rt){
                            case "XYZ":
                                this._y = Math.asin(clamp(Rl, -1, 1)), Math.abs(Rl) < .9999999 ? (this._x = Math.atan2(-Zl, Ql), this._z = Math.atan2(-Ll, Dl)) : (this._x = Math.atan2(ql, Gl), this._z = 0);
                                break;
                            case "YXZ":
                                this._x = Math.asin(-clamp(Zl, -1, 1)), Math.abs(Zl) < .9999999 ? (this._y = Math.atan2(Rl, Ql), this._z = Math.atan2(Ul, Gl)) : (this._y = Math.atan2(-Hl, Dl), this._z = 0);
                                break;
                            case "ZXY":
                                this._x = Math.asin(clamp(ql, -1, 1)), Math.abs(ql) < .9999999 ? (this._y = Math.atan2(-Hl, Ql), this._z = Math.atan2(-Ll, Gl)) : (this._y = 0, this._z = Math.atan2(Ul, Dl));
                                break;
                            case "ZYX":
                                this._y = Math.asin(-clamp(Hl, -1, 1)), Math.abs(Hl) < .9999999 ? (this._x = Math.atan2(ql, Ql), this._z = Math.atan2(Ul, Dl)) : (this._x = 0, this._z = Math.atan2(-Ll, Gl));
                                break;
                            case "YZX":
                                this._z = Math.asin(clamp(Ul, -1, 1)), Math.abs(Ul) < .9999999 ? (this._x = Math.atan2(-Zl, Gl), this._y = Math.atan2(-Hl, Dl)) : (this._x = 0, this._y = Math.atan2(Rl, Ql));
                                break;
                            case "XZY":
                                this._z = Math.asin(-clamp(Ll, -1, 1)), Math.abs(Ll) < .9999999 ? (this._x = Math.atan2(ql, Gl), this._y = Math.atan2(Rl, Dl)) : (this._x = Math.atan2(-Zl, Ql), this._y = 0);
                                break;
                            default:
                                console.warn("THREE.Euler: .setFromRotationMatrix() encountered an unknown order: " + rt);
                        }
                        return this._order = rt, !0 === Wn && this._onChangeCallback(), this;
                    }
                    setFromQuaternion(Qe, rt, Wn) {
                        return Tf.makeRotationFromQuaternion(Qe), this.setFromRotationMatrix(Tf, rt, Wn);
                    }
                    setFromVector3(Qe, rt) {
                        return void 0 === rt && (rt = this._order), this.set(Qe.x, Qe.y, Qe.z, rt);
                    }
                    reorder(Qe) {
                        return Cf.setFromEuler(this), this.setFromQuaternion(Cf, Qe);
                    }
                    equals(Qe) {
                        return Qe._x === this._x && Qe._y === this._y && Qe._z === this._z && Qe._order === this._order;
                    }
                    fromArray(Qe) {
                        return this._x = Qe[0], this._y = Qe[1], this._z = Qe[2], void 0 !== Qe[3] && (this._order = Qe[3]), this._onChangeCallback(), this;
                    }
                    toArray(Qe, rt) {
                        return void 0 === Qe && (Qe = []), void 0 === rt && (rt = 0), Qe[rt] = this._x, Qe[rt + 1] = this._y, Qe[rt + 2] = this._z, Qe[rt + 3] = this._order, Qe;
                    }
                    _onChange(Qe) {
                        return this._onChangeCallback = Qe, this;
                    }
                    _onChangeCallback() {}
                    *[Symbol.iterator]() {
                        yield this._x, yield this._y, yield this._z, yield this._order;
                    }
                }
                Euler.DEFAULT_ORDER = "XYZ";
                class Layers {
                    constructor(){
                        this.mask = 1;
                    }
                    set(Qe) {
                        this.mask = 1 << Qe >>> 0;
                    }
                    enable(Qe) {
                        this.mask |= 1 << Qe;
                    }
                    enableAll() {
                        this.mask = -1;
                    }
                    toggle(Qe) {
                        this.mask ^= 1 << Qe;
                    }
                    disable(Qe) {
                        this.mask &= ~(1 << Qe);
                    }
                    disableAll() {
                        this.mask = 0;
                    }
                    test(Qe) {
                        return 0 !== (this.mask & Qe.mask);
                    }
                    isEnabled(Qe) {
                        return 0 !== (this.mask & 1 << Qe);
                    }
                }
                let kf = 0;
                const If = new Vector3, Df = new Quaternion, Lf = new Matrix4, Pf = new Vector3, zf = new Vector3, Nf = new Vector3, Rf = new Quaternion, Bf = new Vector3(1, 0, 0), Of = new Vector3(0, 1, 0), Ff = new Vector3(0, 0, 1), jf = {
                    type: "added"
                }, Uf = {
                    type: "removed"
                }, Vf = {
                    type: "childadded",
                    child: null
                }, Gf = {
                    type: "childremoved",
                    child: null
                };
                class Object3D extends EventDispatcher {
                    constructor(){
                        super(), this.isObject3D = !0, Object.defineProperty(this, "id", {
                            value: kf++
                        }), this.uuid = generateUUID(), this.name = "", this.type = "Object3D", this.parent = null, this.children = [], this.up = Object3D.DEFAULT_UP.clone();
                        const Qe = new Vector3, rt = new Euler, Wn = new Quaternion, Co = new Vector3(1, 1, 1);
                        rt._onChange(function() {
                            Wn.setFromEuler(rt, !1);
                        }), Wn._onChange(function() {
                            rt.setFromQuaternion(Wn, void 0, !1);
                        }), Object.defineProperties(this, {
                            position: {
                                configurable: !0,
                                enumerable: !0,
                                value: Qe
                            },
                            rotation: {
                                configurable: !0,
                                enumerable: !0,
                                value: rt
                            },
                            quaternion: {
                                configurable: !0,
                                enumerable: !0,
                                value: Wn
                            },
                            scale: {
                                configurable: !0,
                                enumerable: !0,
                                value: Co
                            },
                            modelViewMatrix: {
                                value: new Matrix4
                            },
                            normalMatrix: {
                                value: new Matrix3
                            }
                        }), this.matrix = new Matrix4, this.matrixWorld = new Matrix4, this.matrixAutoUpdate = Object3D.DEFAULT_MATRIX_AUTO_UPDATE, this.matrixWorldAutoUpdate = Object3D.DEFAULT_MATRIX_WORLD_AUTO_UPDATE, this.matrixWorldNeedsUpdate = !1, this.layers = new Layers, this.visible = !0, this.castShadow = !1, this.receiveShadow = !1, this.frustumCulled = !0, this.renderOrder = 0, this.animations = [], this.userData = {};
                    }
                    onBeforeShadow() {}
                    onAfterShadow() {}
                    onBeforeRender() {}
                    onAfterRender() {}
                    applyMatrix4(Qe) {
                        this.matrixAutoUpdate && this.updateMatrix(), this.matrix.premultiply(Qe), this.matrix.decompose(this.position, this.quaternion, this.scale);
                    }
                    applyQuaternion(Qe) {
                        return this.quaternion.premultiply(Qe), this;
                    }
                    setRotationFromAxisAngle(Qe, rt) {
                        this.quaternion.setFromAxisAngle(Qe, rt);
                    }
                    setRotationFromEuler(Qe) {
                        this.quaternion.setFromEuler(Qe, !0);
                    }
                    setRotationFromMatrix(Qe) {
                        this.quaternion.setFromRotationMatrix(Qe);
                    }
                    setRotationFromQuaternion(Qe) {
                        this.quaternion.copy(Qe);
                    }
                    rotateOnAxis(Qe, rt) {
                        return Df.setFromAxisAngle(Qe, rt), this.quaternion.multiply(Df), this;
                    }
                    rotateOnWorldAxis(Qe, rt) {
                        return Df.setFromAxisAngle(Qe, rt), this.quaternion.premultiply(Df), this;
                    }
                    rotateX(Qe) {
                        return this.rotateOnAxis(Bf, Qe);
                    }
                    rotateY(Qe) {
                        return this.rotateOnAxis(Of, Qe);
                    }
                    rotateZ(Qe) {
                        return this.rotateOnAxis(Ff, Qe);
                    }
                    translateOnAxis(Qe, rt) {
                        return If.copy(Qe).applyQuaternion(this.quaternion), this.position.add(If.multiplyScalar(rt)), this;
                    }
                    translateX(Qe) {
                        return this.translateOnAxis(Bf, Qe);
                    }
                    translateY(Qe) {
                        return this.translateOnAxis(Of, Qe);
                    }
                    translateZ(Qe) {
                        return this.translateOnAxis(Ff, Qe);
                    }
                    localToWorld(Qe) {
                        return this.updateWorldMatrix(!0, !1), Qe.applyMatrix4(this.matrixWorld);
                    }
                    worldToLocal(Qe) {
                        return this.updateWorldMatrix(!0, !1), Qe.applyMatrix4(Lf.copy(this.matrixWorld).invert());
                    }
                    lookAt(Qe, rt, Wn) {
                        Qe.isVector3 ? Pf.copy(Qe) : Pf.set(Qe, rt, Wn);
                        const Co = this.parent;
                        this.updateWorldMatrix(!0, !1), zf.setFromMatrixPosition(this.matrixWorld), this.isCamera || this.isLight ? Lf.lookAt(zf, Pf, this.up) : Lf.lookAt(Pf, zf, this.up), this.quaternion.setFromRotationMatrix(Lf), Co && (Lf.extractRotation(Co.matrixWorld), Df.setFromRotationMatrix(Lf), this.quaternion.premultiply(Df.invert()));
                    }
                    add(Qe) {
                        if (arguments.length > 1) {
                            for(let Qe = 0; Qe < arguments.length; Qe++)this.add(arguments[Qe]);
                            return this;
                        }
                        return Qe === this ? (console.error("THREE.Object3D.add: object can't be added as a child of itself.", Qe), this) : (Qe && Qe.isObject3D ? (Qe.removeFromParent(), Qe.parent = this, this.children.push(Qe), Qe.dispatchEvent(jf), Vf.child = Qe, this.dispatchEvent(Vf), Vf.child = null) : console.error("THREE.Object3D.add: object not an instance of THREE.Object3D.", Qe), this);
                    }
                    remove(Qe) {
                        if (arguments.length > 1) {
                            for(let Qe = 0; Qe < arguments.length; Qe++)this.remove(arguments[Qe]);
                            return this;
                        }
                        const rt = this.children.indexOf(Qe);
                        return -1 !== rt && (Qe.parent = null, this.children.splice(rt, 1), Qe.dispatchEvent(Uf), Gf.child = Qe, this.dispatchEvent(Gf), Gf.child = null), this;
                    }
                    removeFromParent() {
                        const Qe = this.parent;
                        return null !== Qe && Qe.remove(this), this;
                    }
                    clear() {
                        return this.remove(...this.children);
                    }
                    attach(Qe) {
                        return this.updateWorldMatrix(!0, !1), Lf.copy(this.matrixWorld).invert(), null !== Qe.parent && (Qe.parent.updateWorldMatrix(!0, !1), Lf.multiply(Qe.parent.matrixWorld)), Qe.applyMatrix4(Lf), Qe.removeFromParent(), Qe.parent = this, this.children.push(Qe), Qe.updateWorldMatrix(!1, !0), Qe.dispatchEvent(jf), Vf.child = Qe, this.dispatchEvent(Vf), Vf.child = null, this;
                    }
                    getObjectById(Qe) {
                        return this.getObjectByProperty("id", Qe);
                    }
                    getObjectByName(Qe) {
                        return this.getObjectByProperty("name", Qe);
                    }
                    getObjectByProperty(Qe, rt) {
                        if (this[Qe] === rt) return this;
                        for(let Wn = 0, Co = this.children.length; Wn < Co; Wn++){
                            const Co = this.children[Wn].getObjectByProperty(Qe, rt);
                            if (void 0 !== Co) return Co;
                        }
                    }
                    getObjectsByProperty(Qe, rt, Wn) {
                        void 0 === Wn && (Wn = []), this[Qe] === rt && Wn.push(this);
                        const Co = this.children;
                        for(let Dl = 0, Ll = Co.length; Dl < Ll; Dl++)Co[Dl].getObjectsByProperty(Qe, rt, Wn);
                        return Wn;
                    }
                    getWorldPosition(Qe) {
                        return this.updateWorldMatrix(!0, !1), Qe.setFromMatrixPosition(this.matrixWorld);
                    }
                    getWorldQuaternion(Qe) {
                        return this.updateWorldMatrix(!0, !1), this.matrixWorld.decompose(zf, Qe, Nf), Qe;
                    }
                    getWorldScale(Qe) {
                        return this.updateWorldMatrix(!0, !1), this.matrixWorld.decompose(zf, Rf, Qe), Qe;
                    }
                    getWorldDirection(Qe) {
                        this.updateWorldMatrix(!0, !1);
                        const rt = this.matrixWorld.elements;
                        return Qe.set(rt[8], rt[9], rt[10]).normalize();
                    }
                    raycast() {}
                    traverse(Qe) {
                        Qe(this);
                        const rt = this.children;
                        for(let Wn = 0, Co = rt.length; Wn < Co; Wn++)rt[Wn].traverse(Qe);
                    }
                    traverseVisible(Qe) {
                        if (!1 === this.visible) return;
                        Qe(this);
                        const rt = this.children;
                        for(let Wn = 0, Co = rt.length; Wn < Co; Wn++)rt[Wn].traverseVisible(Qe);
                    }
                    traverseAncestors(Qe) {
                        const rt = this.parent;
                        null !== rt && (Qe(rt), rt.traverseAncestors(Qe));
                    }
                    updateMatrix() {
                        this.matrix.compose(this.position, this.quaternion, this.scale), this.matrixWorldNeedsUpdate = !0;
                    }
                    updateMatrixWorld(Qe) {
                        this.matrixAutoUpdate && this.updateMatrix(), (this.matrixWorldNeedsUpdate || Qe) && (!0 === this.matrixWorldAutoUpdate && (null === this.parent ? this.matrixWorld.copy(this.matrix) : this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix)), this.matrixWorldNeedsUpdate = !1, Qe = !0);
                        const rt = this.children;
                        for(let Wn = 0, Co = rt.length; Wn < Co; Wn++)rt[Wn].updateMatrixWorld(Qe);
                    }
                    updateWorldMatrix(Qe, rt) {
                        const Wn = this.parent;
                        if (!0 === Qe && null !== Wn && Wn.updateWorldMatrix(!0, !1), this.matrixAutoUpdate && this.updateMatrix(), !0 === this.matrixWorldAutoUpdate && (null === this.parent ? this.matrixWorld.copy(this.matrix) : this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix)), !0 === rt) {
                            const Qe = this.children;
                            for(let rt = 0, Wn = Qe.length; rt < Wn; rt++)Qe[rt].updateWorldMatrix(!1, !0);
                        }
                    }
                    toJSON(Qe) {
                        const rt = void 0 === Qe || "string" === typeof Qe, Wn = {};
                        rt && (Qe = {
                            geometries: {},
                            materials: {},
                            textures: {},
                            images: {},
                            shapes: {},
                            skeletons: {},
                            animations: {},
                            nodes: {}
                        }, Wn.metadata = {
                            version: 4.6,
                            type: "Object",
                            generator: "Object3D.toJSON"
                        });
                        const Co = {};
                        function serialize(rt, Wn) {
                            return void 0 === rt[Wn.uuid] && (rt[Wn.uuid] = Wn.toJSON(Qe)), Wn.uuid;
                        }
                        if (Co.uuid = this.uuid, Co.type = this.type, "" !== this.name && (Co.name = this.name), !0 === this.castShadow && (Co.castShadow = !0), !0 === this.receiveShadow && (Co.receiveShadow = !0), !1 === this.visible && (Co.visible = !1), !1 === this.frustumCulled && (Co.frustumCulled = !1), 0 !== this.renderOrder && (Co.renderOrder = this.renderOrder), Object.keys(this.userData).length > 0 && (Co.userData = this.userData), Co.layers = this.layers.mask, Co.matrix = this.matrix.toArray(), Co.up = this.up.toArray(), !1 === this.matrixAutoUpdate && (Co.matrixAutoUpdate = !1), this.isInstancedMesh && (Co.type = "InstancedMesh", Co.count = this.count, Co.instanceMatrix = this.instanceMatrix.toJSON(), null !== this.instanceColor && (Co.instanceColor = this.instanceColor.toJSON())), this.isBatchedMesh && (Co.type = "BatchedMesh", Co.perObjectFrustumCulled = this.perObjectFrustumCulled, Co.sortObjects = this.sortObjects, Co.drawRanges = this._drawRanges, Co.reservedRanges = this._reservedRanges, Co.visibility = this._visibility, Co.active = this._active, Co.bounds = this._bounds.map((Qe)=>({
                                boxInitialized: Qe.boxInitialized,
                                boxMin: Qe.box.min.toArray(),
                                boxMax: Qe.box.max.toArray(),
                                sphereInitialized: Qe.sphereInitialized,
                                sphereRadius: Qe.sphere.radius,
                                sphereCenter: Qe.sphere.center.toArray()
                            })), Co.maxInstanceCount = this._maxInstanceCount, Co.maxVertexCount = this._maxVertexCount, Co.maxIndexCount = this._maxIndexCount, Co.geometryInitialized = this._geometryInitialized, Co.geometryCount = this._geometryCount, Co.matricesTexture = this._matricesTexture.toJSON(Qe), null !== this._colorsTexture && (Co.colorsTexture = this._colorsTexture.toJSON(Qe)), null !== this.boundingSphere && (Co.boundingSphere = {
                            center: Co.boundingSphere.center.toArray(),
                            radius: Co.boundingSphere.radius
                        }), null !== this.boundingBox && (Co.boundingBox = {
                            min: Co.boundingBox.min.toArray(),
                            max: Co.boundingBox.max.toArray()
                        })), this.isScene) this.background && (this.background.isColor ? Co.background = this.background.toJSON() : this.background.isTexture && (Co.background = this.background.toJSON(Qe).uuid)), this.environment && this.environment.isTexture && !0 !== this.environment.isRenderTargetTexture && (Co.environment = this.environment.toJSON(Qe).uuid);
                        else if (this.isMesh || this.isLine || this.isPoints) {
                            Co.geometry = serialize(Qe.geometries, this.geometry);
                            const rt = this.geometry.parameters;
                            if (void 0 !== rt && void 0 !== rt.shapes) {
                                const Wn = rt.shapes;
                                if (Array.isArray(Wn)) for(let rt = 0, Co = Wn.length; rt < Co; rt++){
                                    const Co = Wn[rt];
                                    serialize(Qe.shapes, Co);
                                }
                                else serialize(Qe.shapes, Wn);
                            }
                        }
                        if (this.isSkinnedMesh && (Co.bindMode = this.bindMode, Co.bindMatrix = this.bindMatrix.toArray(), void 0 !== this.skeleton && (serialize(Qe.skeletons, this.skeleton), Co.skeleton = this.skeleton.uuid)), void 0 !== this.material) {
                            if (Array.isArray(this.material)) {
                                const rt = [];
                                for(let Wn = 0, Co = this.material.length; Wn < Co; Wn++)rt.push(serialize(Qe.materials, this.material[Wn]));
                                Co.material = rt;
                            } else Co.material = serialize(Qe.materials, this.material);
                        }
                        if (this.children.length > 0) {
                            Co.children = [];
                            for(let rt = 0; rt < this.children.length; rt++)Co.children.push(this.children[rt].toJSON(Qe).object);
                        }
                        if (this.animations.length > 0) {
                            Co.animations = [];
                            for(let rt = 0; rt < this.animations.length; rt++){
                                const Wn = this.animations[rt];
                                Co.animations.push(serialize(Qe.animations, Wn));
                            }
                        }
                        if (rt) {
                            const rt = extractFromCache(Qe.geometries), Co = extractFromCache(Qe.materials), Dl = extractFromCache(Qe.textures), Ll = extractFromCache(Qe.images), Rl = extractFromCache(Qe.shapes), Ul = extractFromCache(Qe.skeletons), Gl = extractFromCache(Qe.animations), Zl = extractFromCache(Qe.nodes);
                            rt.length > 0 && (Wn.geometries = rt), Co.length > 0 && (Wn.materials = Co), Dl.length > 0 && (Wn.textures = Dl), Ll.length > 0 && (Wn.images = Ll), Rl.length > 0 && (Wn.shapes = Rl), Ul.length > 0 && (Wn.skeletons = Ul), Gl.length > 0 && (Wn.animations = Gl), Zl.length > 0 && (Wn.nodes = Zl);
                        }
                        return Wn.object = Co, Wn;
                        function extractFromCache(Qe) {
                            const rt = [];
                            for(const Wn in Qe){
                                const Co = Qe[Wn];
                                delete Co.metadata, rt.push(Co);
                            }
                            return rt;
                        }
                    }
                    clone(Qe) {
                        return (new this.constructor).copy(this, Qe);
                    }
                    copy(Qe, rt) {
                        if (void 0 === rt && (rt = !0), this.name = Qe.name, this.up.copy(Qe.up), this.position.copy(Qe.position), this.rotation.order = Qe.rotation.order, this.quaternion.copy(Qe.quaternion), this.scale.copy(Qe.scale), this.matrix.copy(Qe.matrix), this.matrixWorld.copy(Qe.matrixWorld), this.matrixAutoUpdate = Qe.matrixAutoUpdate, this.matrixWorldAutoUpdate = Qe.matrixWorldAutoUpdate, this.matrixWorldNeedsUpdate = Qe.matrixWorldNeedsUpdate, this.layers.mask = Qe.layers.mask, this.visible = Qe.visible, this.castShadow = Qe.castShadow, this.receiveShadow = Qe.receiveShadow, this.frustumCulled = Qe.frustumCulled, this.renderOrder = Qe.renderOrder, this.animations = Qe.animations.slice(), this.userData = JSON.parse(JSON.stringify(Qe.userData)), !0 === rt) for(let Wn = 0; Wn < Qe.children.length; Wn++){
                            const rt = Qe.children[Wn];
                            this.add(rt.clone());
                        }
                        return this;
                    }
                }
                Object3D.DEFAULT_UP = new Vector3(0, 1, 0), Object3D.DEFAULT_MATRIX_AUTO_UPDATE = !0, Object3D.DEFAULT_MATRIX_WORLD_AUTO_UPDATE = !0;
                const Zf = new Vector3, Hf = new Vector3, Wf = new Vector3, qf = new Vector3, Yf = new Vector3, Qf = new Vector3, Kf = new Vector3, Xf = new Vector3, Jf = new Vector3, $f = new Vector3, eg = new Vector4, tg = new Vector4, ig = new Vector4;
                class Triangle {
                    constructor(Qe, rt, Wn){
                        void 0 === Qe && (Qe = new Vector3), void 0 === rt && (rt = new Vector3), void 0 === Wn && (Wn = new Vector3), this.a = Qe, this.b = rt, this.c = Wn;
                    }
                    static getNormal(Qe, rt, Wn, Co) {
                        Co.subVectors(Wn, rt), Zf.subVectors(Qe, rt), Co.cross(Zf);
                        const Dl = Co.lengthSq();
                        return Dl > 0 ? Co.multiplyScalar(1 / Math.sqrt(Dl)) : Co.set(0, 0, 0);
                    }
                    static getBarycoord(Qe, rt, Wn, Co, Dl) {
                        Zf.subVectors(Co, rt), Hf.subVectors(Wn, rt), Wf.subVectors(Qe, rt);
                        const Ll = Zf.dot(Zf), Rl = Zf.dot(Hf), Ul = Zf.dot(Wf), Gl = Hf.dot(Hf), Zl = Hf.dot(Wf), Hl = Ll * Gl - Rl * Rl;
                        if (0 === Hl) return Dl.set(0, 0, 0), null;
                        const ql = 1 / Hl, Ql = (Gl * Ul - Rl * Zl) * ql, Kl = (Ll * Zl - Rl * Ul) * ql;
                        return Dl.set(1 - Ql - Kl, Kl, Ql);
                    }
                    static containsPoint(Qe, rt, Wn, Co) {
                        return null !== this.getBarycoord(Qe, rt, Wn, Co, qf) && qf.x >= 0 && qf.y >= 0 && qf.x + qf.y <= 1;
                    }
                    static getInterpolation(Qe, rt, Wn, Co, Dl, Ll, Rl, Ul) {
                        return null === this.getBarycoord(Qe, rt, Wn, Co, qf) ? (Ul.x = 0, Ul.y = 0, "z" in Ul && (Ul.z = 0), "w" in Ul && (Ul.w = 0), null) : (Ul.setScalar(0), Ul.addScaledVector(Dl, qf.x), Ul.addScaledVector(Ll, qf.y), Ul.addScaledVector(Rl, qf.z), Ul);
                    }
                    static getInterpolatedAttribute(Qe, rt, Wn, Co, Dl, Ll) {
                        return eg.setScalar(0), tg.setScalar(0), ig.setScalar(0), eg.fromBufferAttribute(Qe, rt), tg.fromBufferAttribute(Qe, Wn), ig.fromBufferAttribute(Qe, Co), Ll.setScalar(0), Ll.addScaledVector(eg, Dl.x), Ll.addScaledVector(tg, Dl.y), Ll.addScaledVector(ig, Dl.z), Ll;
                    }
                    static isFrontFacing(Qe, rt, Wn, Co) {
                        return Zf.subVectors(Wn, rt), Hf.subVectors(Qe, rt), Zf.cross(Hf).dot(Co) < 0;
                    }
                    set(Qe, rt, Wn) {
                        return this.a.copy(Qe), this.b.copy(rt), this.c.copy(Wn), this;
                    }
                    setFromPointsAndIndices(Qe, rt, Wn, Co) {
                        return this.a.copy(Qe[rt]), this.b.copy(Qe[Wn]), this.c.copy(Qe[Co]), this;
                    }
                    setFromAttributeAndIndices(Qe, rt, Wn, Co) {
                        return this.a.fromBufferAttribute(Qe, rt), this.b.fromBufferAttribute(Qe, Wn), this.c.fromBufferAttribute(Qe, Co), this;
                    }
                    clone() {
                        return (new this.constructor).copy(this);
                    }
                    copy(Qe) {
                        return this.a.copy(Qe.a), this.b.copy(Qe.b), this.c.copy(Qe.c), this;
                    }
                    getArea() {
                        return Zf.subVectors(this.c, this.b), Hf.subVectors(this.a, this.b), .5 * Zf.cross(Hf).length();
                    }
                    getMidpoint(Qe) {
                        return Qe.addVectors(this.a, this.b).add(this.c).multiplyScalar(1 / 3);
                    }
                    getNormal(Qe) {
                        return Triangle.getNormal(this.a, this.b, this.c, Qe);
                    }
                    getPlane(Qe) {
                        return Qe.setFromCoplanarPoints(this.a, this.b, this.c);
                    }
                    getBarycoord(Qe, rt) {
                        return Triangle.getBarycoord(Qe, this.a, this.b, this.c, rt);
                    }
                    getInterpolation(Qe, rt, Wn, Co, Dl) {
                        return Triangle.getInterpolation(Qe, this.a, this.b, this.c, rt, Wn, Co, Dl);
                    }
                    containsPoint(Qe) {
                        return Triangle.containsPoint(Qe, this.a, this.b, this.c);
                    }
                    isFrontFacing(Qe) {
                        return Triangle.isFrontFacing(this.a, this.b, this.c, Qe);
                    }
                    intersectsBox(Qe) {
                        return Qe.intersectsTriangle(this);
                    }
                    closestPointToPoint(Qe, rt) {
                        const Wn = this.a, Co = this.b, Dl = this.c;
                        let Ll, Rl;
                        Yf.subVectors(Co, Wn), Qf.subVectors(Dl, Wn), Xf.subVectors(Qe, Wn);
                        const Ul = Yf.dot(Xf), Gl = Qf.dot(Xf);
                        if (Ul <= 0 && Gl <= 0) return rt.copy(Wn);
                        Jf.subVectors(Qe, Co);
                        const Zl = Yf.dot(Jf), Hl = Qf.dot(Jf);
                        if (Zl >= 0 && Hl <= Zl) return rt.copy(Co);
                        const ql = Ul * Hl - Zl * Gl;
                        if (ql <= 0 && Ul >= 0 && Zl <= 0) return Ll = Ul / (Ul - Zl), rt.copy(Wn).addScaledVector(Yf, Ll);
                        $f.subVectors(Qe, Dl);
                        const Ql = Yf.dot($f), Kl = Qf.dot($f);
                        if (Kl >= 0 && Ql <= Kl) return rt.copy(Dl);
                        const $l = Ql * Gl - Ul * Kl;
                        if ($l <= 0 && Gl >= 0 && Kl <= 0) return Rl = Gl / (Gl - Kl), rt.copy(Wn).addScaledVector(Qf, Rl);
                        const Tc = Zl * Kl - Ql * Hl;
                        if (Tc <= 0 && Hl - Zl >= 0 && Ql - Kl >= 0) return Kf.subVectors(Dl, Co), Rl = (Hl - Zl) / (Hl - Zl + (Ql - Kl)), rt.copy(Co).addScaledVector(Kf, Rl);
                        const tu = 1 / (Tc + $l + ql);
                        return Ll = $l * tu, Rl = ql * tu, rt.copy(Wn).addScaledVector(Yf, Ll).addScaledVector(Qf, Rl);
                    }
                    equals(Qe) {
                        return Qe.a.equals(this.a) && Qe.b.equals(this.b) && Qe.c.equals(this.c);
                    }
                }
                const ng = {
                    aliceblue: 15792383,
                    antiquewhite: 16444375,
                    aqua: 65535,
                    aquamarine: 8388564,
                    azure: 15794175,
                    beige: 16119260,
                    bisque: 16770244,
                    black: 0,
                    blanchedalmond: 16772045,
                    blue: 255,
                    blueviolet: 9055202,
                    brown: 10824234,
                    burlywood: 14596231,
                    cadetblue: 6266528,
                    chartreuse: 8388352,
                    chocolate: 13789470,
                    coral: 16744272,
                    cornflowerblue: 6591981,
                    cornsilk: 16775388,
                    crimson: 14423100,
                    cyan: 65535,
                    darkblue: 139,
                    darkcyan: 35723,
                    darkgoldenrod: 12092939,
                    darkgray: 11119017,
                    darkgreen: 25600,
                    darkgrey: 11119017,
                    darkkhaki: 12433259,
                    darkmagenta: 9109643,
                    darkolivegreen: 5597999,
                    darkorange: 16747520,
                    darkorchid: 10040012,
                    darkred: 9109504,
                    darksalmon: 15308410,
                    darkseagreen: 9419919,
                    darkslateblue: 4734347,
                    darkslategray: 3100495,
                    darkslategrey: 3100495,
                    darkturquoise: 52945,
                    darkviolet: 9699539,
                    deeppink: 16716947,
                    deepskyblue: 49151,
                    dimgray: 6908265,
                    dimgrey: 6908265,
                    dodgerblue: 2003199,
                    firebrick: 11674146,
                    floralwhite: 16775920,
                    forestgreen: 2263842,
                    fuchsia: 16711935,
                    gainsboro: 14474460,
                    ghostwhite: 16316671,
                    gold: 16766720,
                    goldenrod: 14329120,
                    gray: 8421504,
                    green: 32768,
                    greenyellow: 11403055,
                    grey: 8421504,
                    honeydew: 15794160,
                    hotpink: 16738740,
                    indianred: 13458524,
                    indigo: 4915330,
                    ivory: 16777200,
                    khaki: 15787660,
                    lavender: 15132410,
                    lavenderblush: 16773365,
                    lawngreen: 8190976,
                    lemonchiffon: 16775885,
                    lightblue: 11393254,
                    lightcoral: 15761536,
                    lightcyan: 14745599,
                    lightgoldenrodyellow: 16448210,
                    lightgray: 13882323,
                    lightgreen: 9498256,
                    lightgrey: 13882323,
                    lightpink: 16758465,
                    lightsalmon: 16752762,
                    lightseagreen: 2142890,
                    lightskyblue: 8900346,
                    lightslategray: 7833753,
                    lightslategrey: 7833753,
                    lightsteelblue: 11584734,
                    lightyellow: 16777184,
                    lime: 65280,
                    limegreen: 3329330,
                    linen: 16445670,
                    magenta: 16711935,
                    maroon: 8388608,
                    mediumaquamarine: 6737322,
                    mediumblue: 205,
                    mediumorchid: 12211667,
                    mediumpurple: 9662683,
                    mediumseagreen: 3978097,
                    mediumslateblue: 8087790,
                    mediumspringgreen: 64154,
                    mediumturquoise: 4772300,
                    mediumvioletred: 13047173,
                    midnightblue: 1644912,
                    mintcream: 16121850,
                    mistyrose: 16770273,
                    moccasin: 16770229,
                    navajowhite: 16768685,
                    navy: 128,
                    oldlace: 16643558,
                    olive: 8421376,
                    olivedrab: 7048739,
                    orange: 16753920,
                    orangered: 16729344,
                    orchid: 14315734,
                    palegoldenrod: 15657130,
                    palegreen: 10025880,
                    paleturquoise: 11529966,
                    palevioletred: 14381203,
                    papayawhip: 16773077,
                    peachpuff: 16767673,
                    peru: 13468991,
                    pink: 16761035,
                    plum: 14524637,
                    powderblue: 11591910,
                    purple: 8388736,
                    rebeccapurple: 6697881,
                    red: 16711680,
                    rosybrown: 12357519,
                    royalblue: 4286945,
                    saddlebrown: 9127187,
                    salmon: 16416882,
                    sandybrown: 16032864,
                    seagreen: 3050327,
                    seashell: 16774638,
                    sienna: 10506797,
                    silver: 12632256,
                    skyblue: 8900331,
                    slateblue: 6970061,
                    slategray: 7372944,
                    slategrey: 7372944,
                    snow: 16775930,
                    springgreen: 65407,
                    steelblue: 4620980,
                    tan: 13808780,
                    teal: 32896,
                    thistle: 14204888,
                    tomato: 16737095,
                    turquoise: 4251856,
                    violet: 15631086,
                    wheat: 16113331,
                    white: 16777215,
                    whitesmoke: 16119285,
                    yellow: 16776960,
                    yellowgreen: 10145074
                }, rg = {
                    h: 0,
                    s: 0,
                    l: 0
                }, sg = {
                    h: 0,
                    s: 0,
                    l: 0
                };
                function hue2rgb(Qe, rt, Wn) {
                    return Wn < 0 && (Wn += 1), Wn > 1 && (Wn -= 1), Wn < 1 / 6 ? Qe + 6 * (rt - Qe) * Wn : Wn < .5 ? rt : Wn < 2 / 3 ? Qe + 6 * (rt - Qe) * (2 / 3 - Wn) : Qe;
                }
                class Color {
                    constructor(Qe, rt, Wn){
                        return this.isColor = !0, this.r = 1, this.g = 1, this.b = 1, this.set(Qe, rt, Wn);
                    }
                    set(Qe, rt, Wn) {
                        if (void 0 === rt && void 0 === Wn) {
                            const rt = Qe;
                            rt && rt.isColor ? this.copy(rt) : "number" === typeof rt ? this.setHex(rt) : "string" === typeof rt && this.setStyle(rt);
                        } else this.setRGB(Qe, rt, Wn);
                        return this;
                    }
                    setScalar(Qe) {
                        return this.r = Qe, this.g = Qe, this.b = Qe, this;
                    }
                    setHex(Qe, rt) {
                        return void 0 === rt && (rt = ym), Qe = Math.floor(Qe), this.r = (Qe >> 16 & 255) / 255, this.g = (Qe >> 8 & 255) / 255, this.b = (255 & Qe) / 255, Zm.toWorkingColorSpace(this, rt), this;
                    }
                    setRGB(Qe, rt, Wn, Co) {
                        return void 0 === Co && (Co = Zm.workingColorSpace), this.r = Qe, this.g = rt, this.b = Wn, Zm.toWorkingColorSpace(this, Co), this;
                    }
                    setHSL(Qe, rt, Wn, Co) {
                        if (void 0 === Co && (Co = Zm.workingColorSpace), Qe = euclideanModulo(Qe, 1), rt = clamp(rt, 0, 1), Wn = clamp(Wn, 0, 1), 0 === rt) this.r = this.g = this.b = Wn;
                        else {
                            const Co = Wn <= .5 ? Wn * (1 + rt) : Wn + rt - Wn * rt, Dl = 2 * Wn - Co;
                            this.r = hue2rgb(Dl, Co, Qe + 1 / 3), this.g = hue2rgb(Dl, Co, Qe), this.b = hue2rgb(Dl, Co, Qe - 1 / 3);
                        }
                        return Zm.toWorkingColorSpace(this, Co), this;
                    }
                    setStyle(Qe, rt) {
                        function handleAlpha(rt) {
                            void 0 !== rt && parseFloat(rt) < 1 && console.warn("THREE.Color: Alpha component of " + Qe + " will be ignored.");
                        }
                        let Wn;
                        if (void 0 === rt && (rt = ym), Wn = /^(\w+)\(([^\)]*)\)/.exec(Qe)) {
                            let Co;
                            const Dl = Wn[1], Ll = Wn[2];
                            switch(Dl){
                                case "rgb":
                                case "rgba":
                                    if (Co = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(Ll)) return handleAlpha(Co[4]), this.setRGB(Math.min(255, parseInt(Co[1], 10)) / 255, Math.min(255, parseInt(Co[2], 10)) / 255, Math.min(255, parseInt(Co[3], 10)) / 255, rt);
                                    if (Co = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(Ll)) return handleAlpha(Co[4]), this.setRGB(Math.min(100, parseInt(Co[1], 10)) / 100, Math.min(100, parseInt(Co[2], 10)) / 100, Math.min(100, parseInt(Co[3], 10)) / 100, rt);
                                    break;
                                case "hsl":
                                case "hsla":
                                    if (Co = /^\s*(\d*\.?\d+)\s*,\s*(\d*\.?\d+)\%\s*,\s*(\d*\.?\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(Ll)) return handleAlpha(Co[4]), this.setHSL(parseFloat(Co[1]) / 360, parseFloat(Co[2]) / 100, parseFloat(Co[3]) / 100, rt);
                                    break;
                                default:
                                    console.warn("THREE.Color: Unknown color model " + Qe);
                            }
                        } else if (Wn = /^\#([A-Fa-f\d]+)$/.exec(Qe)) {
                            const Co = Wn[1], Dl = Co.length;
                            if (3 === Dl) return this.setRGB(parseInt(Co.charAt(0), 16) / 15, parseInt(Co.charAt(1), 16) / 15, parseInt(Co.charAt(2), 16) / 15, rt);
                            if (6 === Dl) return this.setHex(parseInt(Co, 16), rt);
                            console.warn("THREE.Color: Invalid hex color " + Qe);
                        } else if (Qe && Qe.length > 0) return this.setColorName(Qe, rt);
                        return this;
                    }
                    setColorName(Qe, rt) {
                        void 0 === rt && (rt = ym);
                        const Wn = ng[Qe.toLowerCase()];
                        return void 0 !== Wn ? this.setHex(Wn, rt) : console.warn("THREE.Color: Unknown color " + Qe), this;
                    }
                    clone() {
                        return new this.constructor(this.r, this.g, this.b);
                    }
                    copy(Qe) {
                        return this.r = Qe.r, this.g = Qe.g, this.b = Qe.b, this;
                    }
                    copySRGBToLinear(Qe) {
                        return this.r = SRGBToLinear(Qe.r), this.g = SRGBToLinear(Qe.g), this.b = SRGBToLinear(Qe.b), this;
                    }
                    copyLinearToSRGB(Qe) {
                        return this.r = LinearToSRGB(Qe.r), this.g = LinearToSRGB(Qe.g), this.b = LinearToSRGB(Qe.b), this;
                    }
                    convertSRGBToLinear() {
                        return this.copySRGBToLinear(this), this;
                    }
                    convertLinearToSRGB() {
                        return this.copyLinearToSRGB(this), this;
                    }
                    getHex(Qe) {
                        return void 0 === Qe && (Qe = ym), Zm.fromWorkingColorSpace(ag.copy(this), Qe), 65536 * Math.round(clamp(255 * ag.r, 0, 255)) + 256 * Math.round(clamp(255 * ag.g, 0, 255)) + Math.round(clamp(255 * ag.b, 0, 255));
                    }
                    getHexString(Qe) {
                        return void 0 === Qe && (Qe = ym), ("000000" + this.getHex(Qe).toString(16)).slice(-6);
                    }
                    getHSL(Qe, rt) {
                        void 0 === rt && (rt = Zm.workingColorSpace), Zm.fromWorkingColorSpace(ag.copy(this), rt);
                        const Wn = ag.r, Co = ag.g, Dl = ag.b, Ll = Math.max(Wn, Co, Dl), Rl = Math.min(Wn, Co, Dl);
                        let Ul, Gl;
                        const Zl = (Rl + Ll) / 2;
                        if (Rl === Ll) Ul = 0, Gl = 0;
                        else {
                            const Qe = Ll - Rl;
                            switch(Gl = Zl <= .5 ? Qe / (Ll + Rl) : Qe / (2 - Ll - Rl), Ll){
                                case Wn:
                                    Ul = (Co - Dl) / Qe + (Co < Dl ? 6 : 0);
                                    break;
                                case Co:
                                    Ul = (Dl - Wn) / Qe + 2;
                                    break;
                                case Dl:
                                    Ul = (Wn - Co) / Qe + 4;
                            }
                            Ul /= 6;
                        }
                        return Qe.h = Ul, Qe.s = Gl, Qe.l = Zl, Qe;
                    }
                    getRGB(Qe, rt) {
                        return void 0 === rt && (rt = Zm.workingColorSpace), Zm.fromWorkingColorSpace(ag.copy(this), rt), Qe.r = ag.r, Qe.g = ag.g, Qe.b = ag.b, Qe;
                    }
                    getStyle(Qe) {
                        void 0 === Qe && (Qe = ym), Zm.fromWorkingColorSpace(ag.copy(this), Qe);
                        const rt = ag.r, Wn = ag.g, Co = ag.b;
                        return Qe !== ym ? `color(${Qe} ${rt.toFixed(3)} ${Wn.toFixed(3)} ${Co.toFixed(3)})` : `rgb(${Math.round(255 * rt)},${Math.round(255 * Wn)},${Math.round(255 * Co)})`;
                    }
                    offsetHSL(Qe, rt, Wn) {
                        return this.getHSL(rg), this.setHSL(rg.h + Qe, rg.s + rt, rg.l + Wn);
                    }
                    add(Qe) {
                        return this.r += Qe.r, this.g += Qe.g, this.b += Qe.b, this;
                    }
                    addColors(Qe, rt) {
                        return this.r = Qe.r + rt.r, this.g = Qe.g + rt.g, this.b = Qe.b + rt.b, this;
                    }
                    addScalar(Qe) {
                        return this.r += Qe, this.g += Qe, this.b += Qe, this;
                    }
                    sub(Qe) {
                        return this.r = Math.max(0, this.r - Qe.r), this.g = Math.max(0, this.g - Qe.g), this.b = Math.max(0, this.b - Qe.b), this;
                    }
                    multiply(Qe) {
                        return this.r *= Qe.r, this.g *= Qe.g, this.b *= Qe.b, this;
                    }
                    multiplyScalar(Qe) {
                        return this.r *= Qe, this.g *= Qe, this.b *= Qe, this;
                    }
                    lerp(Qe, rt) {
                        return this.r += (Qe.r - this.r) * rt, this.g += (Qe.g - this.g) * rt, this.b += (Qe.b - this.b) * rt, this;
                    }
                    lerpColors(Qe, rt, Wn) {
                        return this.r = Qe.r + (rt.r - Qe.r) * Wn, this.g = Qe.g + (rt.g - Qe.g) * Wn, this.b = Qe.b + (rt.b - Qe.b) * Wn, this;
                    }
                    lerpHSL(Qe, rt) {
                        this.getHSL(rg), Qe.getHSL(sg);
                        const Wn = lerp(rg.h, sg.h, rt), Co = lerp(rg.s, sg.s, rt), Dl = lerp(rg.l, sg.l, rt);
                        return this.setHSL(Wn, Co, Dl), this;
                    }
                    setFromVector3(Qe) {
                        return this.r = Qe.x, this.g = Qe.y, this.b = Qe.z, this;
                    }
                    applyMatrix3(Qe) {
                        const rt = this.r, Wn = this.g, Co = this.b, Dl = Qe.elements;
                        return this.r = Dl[0] * rt + Dl[3] * Wn + Dl[6] * Co, this.g = Dl[1] * rt + Dl[4] * Wn + Dl[7] * Co, this.b = Dl[2] * rt + Dl[5] * Wn + Dl[8] * Co, this;
                    }
                    equals(Qe) {
                        return Qe.r === this.r && Qe.g === this.g && Qe.b === this.b;
                    }
                    fromArray(Qe, rt) {
                        return void 0 === rt && (rt = 0), this.r = Qe[rt], this.g = Qe[rt + 1], this.b = Qe[rt + 2], this;
                    }
                    toArray(Qe, rt) {
                        return void 0 === Qe && (Qe = []), void 0 === rt && (rt = 0), Qe[rt] = this.r, Qe[rt + 1] = this.g, Qe[rt + 2] = this.b, Qe;
                    }
                    fromBufferAttribute(Qe, rt) {
                        return this.r = Qe.getX(rt), this.g = Qe.getY(rt), this.b = Qe.getZ(rt), this;
                    }
                    toJSON() {
                        return this.getHex();
                    }
                    *[Symbol.iterator]() {
                        yield this.r, yield this.g, yield this.b;
                    }
                }
                const ag = new Color;
                Color.NAMES = ng;
                let og = 0;
                class Material extends EventDispatcher {
                    constructor(){
                        super(), this.isMaterial = !0, Object.defineProperty(this, "id", {
                            value: og++
                        }), this.uuid = generateUUID(), this.name = "", this.type = "Material", this.blending = $l, this.side = Hl, this.vertexColors = !1, this.opacity = 1, this.transparent = !1, this.alphaHash = !1, this.blendSrc = ed, this.blendDst = td, this.blendEquation = fu, this.blendSrcAlpha = null, this.blendDstAlpha = null, this.blendEquationAlpha = null, this.blendColor = new Color(0, 0, 0), this.blendAlpha = 0, this.depthFunc = md, this.depthTest = !0, this.depthWrite = !0, this.stencilWriteMask = 255, this.stencilFunc = 519, this.stencilRef = 0, this.stencilFuncMask = 255, this.stencilFail = bm, this.stencilZFail = bm, this.stencilZPass = bm, this.stencilWrite = !1, this.clippingPlanes = null, this.clipIntersection = !1, this.clipShadows = !1, this.shadowSide = null, this.colorWrite = !0, this.precision = null, this.polygonOffset = !1, this.polygonOffsetFactor = 0, this.polygonOffsetUnits = 0, this.dithering = !1, this.alphaToCoverage = !1, this.premultipliedAlpha = !1, this.forceSinglePass = !1, this.visible = !0, this.toneMapped = !0, this.userData = {}, this.version = 0, this._alphaTest = 0;
                    }
                    get alphaTest() {
                        return this._alphaTest;
                    }
                    set alphaTest(Qe) {
                        this._alphaTest > 0 !== Qe > 0 && this.version++, this._alphaTest = Qe;
                    }
                    onBeforeRender() {}
                    onBeforeCompile() {}
                    customProgramCacheKey() {
                        return this.onBeforeCompile.toString();
                    }
                    setValues(Qe) {
                        if (void 0 !== Qe) for(const rt in Qe){
                            const Wn = Qe[rt];
                            if (void 0 === Wn) {
                                console.warn(`THREE.Material: parameter '${rt}' has value of undefined.`);
                                continue;
                            }
                            const Co = this[rt];
                            void 0 !== Co ? Co && Co.isColor ? Co.set(Wn) : Co && Co.isVector3 && Wn && Wn.isVector3 ? Co.copy(Wn) : this[rt] = Wn : console.warn(`THREE.Material: '${rt}' is not a property of THREE.${this.type}.`);
                        }
                    }
                    toJSON(Qe) {
                        const rt = void 0 === Qe || "string" === typeof Qe;
                        rt && (Qe = {
                            textures: {},
                            images: {}
                        });
                        const Wn = {
                            metadata: {
                                version: 4.6,
                                type: "Material",
                                generator: "Material.toJSON"
                            }
                        };
                        function extractFromCache(Qe) {
                            const rt = [];
                            for(const Wn in Qe){
                                const Co = Qe[Wn];
                                delete Co.metadata, rt.push(Co);
                            }
                            return rt;
                        }
                        if (Wn.uuid = this.uuid, Wn.type = this.type, "" !== this.name && (Wn.name = this.name), this.color && this.color.isColor && (Wn.color = this.color.getHex()), void 0 !== this.roughness && (Wn.roughness = this.roughness), void 0 !== this.metalness && (Wn.metalness = this.metalness), void 0 !== this.sheen && (Wn.sheen = this.sheen), this.sheenColor && this.sheenColor.isColor && (Wn.sheenColor = this.sheenColor.getHex()), void 0 !== this.sheenRoughness && (Wn.sheenRoughness = this.sheenRoughness), this.emissive && this.emissive.isColor && (Wn.emissive = this.emissive.getHex()), void 0 !== this.emissiveIntensity && 1 !== this.emissiveIntensity && (Wn.emissiveIntensity = this.emissiveIntensity), this.specular && this.specular.isColor && (Wn.specular = this.specular.getHex()), void 0 !== this.specularIntensity && (Wn.specularIntensity = this.specularIntensity), this.specularColor && this.specularColor.isColor && (Wn.specularColor = this.specularColor.getHex()), void 0 !== this.shininess && (Wn.shininess = this.shininess), void 0 !== this.clearcoat && (Wn.clearcoat = this.clearcoat), void 0 !== this.clearcoatRoughness && (Wn.clearcoatRoughness = this.clearcoatRoughness), this.clearcoatMap && this.clearcoatMap.isTexture && (Wn.clearcoatMap = this.clearcoatMap.toJSON(Qe).uuid), this.clearcoatRoughnessMap && this.clearcoatRoughnessMap.isTexture && (Wn.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON(Qe).uuid), this.clearcoatNormalMap && this.clearcoatNormalMap.isTexture && (Wn.clearcoatNormalMap = this.clearcoatNormalMap.toJSON(Qe).uuid, Wn.clearcoatNormalScale = this.clearcoatNormalScale.toArray()), void 0 !== this.dispersion && (Wn.dispersion = this.dispersion), void 0 !== this.iridescence && (Wn.iridescence = this.iridescence), void 0 !== this.iridescenceIOR && (Wn.iridescenceIOR = this.iridescenceIOR), void 0 !== this.iridescenceThicknessRange && (Wn.iridescenceThicknessRange = this.iridescenceThicknessRange), this.iridescenceMap && this.iridescenceMap.isTexture && (Wn.iridescenceMap = this.iridescenceMap.toJSON(Qe).uuid), this.iridescenceThicknessMap && this.iridescenceThicknessMap.isTexture && (Wn.iridescenceThicknessMap = this.iridescenceThicknessMap.toJSON(Qe).uuid), void 0 !== this.anisotropy && (Wn.anisotropy = this.anisotropy), void 0 !== this.anisotropyRotation && (Wn.anisotropyRotation = this.anisotropyRotation), this.anisotropyMap && this.anisotropyMap.isTexture && (Wn.anisotropyMap = this.anisotropyMap.toJSON(Qe).uuid), this.map && this.map.isTexture && (Wn.map = this.map.toJSON(Qe).uuid), this.matcap && this.matcap.isTexture && (Wn.matcap = this.matcap.toJSON(Qe).uuid), this.alphaMap && this.alphaMap.isTexture && (Wn.alphaMap = this.alphaMap.toJSON(Qe).uuid), this.lightMap && this.lightMap.isTexture && (Wn.lightMap = this.lightMap.toJSON(Qe).uuid, Wn.lightMapIntensity = this.lightMapIntensity), this.aoMap && this.aoMap.isTexture && (Wn.aoMap = this.aoMap.toJSON(Qe).uuid, Wn.aoMapIntensity = this.aoMapIntensity), this.bumpMap && this.bumpMap.isTexture && (Wn.bumpMap = this.bumpMap.toJSON(Qe).uuid, Wn.bumpScale = this.bumpScale), this.normalMap && this.normalMap.isTexture && (Wn.normalMap = this.normalMap.toJSON(Qe).uuid, Wn.normalMapType = this.normalMapType, Wn.normalScale = this.normalScale.toArray()), this.displacementMap && this.displacementMap.isTexture && (Wn.displacementMap = this.displacementMap.toJSON(Qe).uuid, Wn.displacementScale = this.displacementScale, Wn.displacementBias = this.displacementBias), this.roughnessMap && this.roughnessMap.isTexture && (Wn.roughnessMap = this.roughnessMap.toJSON(Qe).uuid), this.metalnessMap && this.metalnessMap.isTexture && (Wn.metalnessMap = this.metalnessMap.toJSON(Qe).uuid), this.emissiveMap && this.emissiveMap.isTexture && (Wn.emissiveMap = this.emissiveMap.toJSON(Qe).uuid), this.specularMap && this.specularMap.isTexture && (Wn.specularMap = this.specularMap.toJSON(Qe).uuid), this.specularIntensityMap && this.specularIntensityMap.isTexture && (Wn.specularIntensityMap = this.specularIntensityMap.toJSON(Qe).uuid), this.specularColorMap && this.specularColorMap.isTexture && (Wn.specularColorMap = this.specularColorMap.toJSON(Qe).uuid), this.envMap && this.envMap.isTexture && (Wn.envMap = this.envMap.toJSON(Qe).uuid, void 0 !== this.combine && (Wn.combine = this.combine)), void 0 !== this.envMapRotation && (Wn.envMapRotation = this.envMapRotation.toArray()), void 0 !== this.envMapIntensity && (Wn.envMapIntensity = this.envMapIntensity), void 0 !== this.reflectivity && (Wn.reflectivity = this.reflectivity), void 0 !== this.refractionRatio && (Wn.refractionRatio = this.refractionRatio), this.gradientMap && this.gradientMap.isTexture && (Wn.gradientMap = this.gradientMap.toJSON(Qe).uuid), void 0 !== this.transmission && (Wn.transmission = this.transmission), this.transmissionMap && this.transmissionMap.isTexture && (Wn.transmissionMap = this.transmissionMap.toJSON(Qe).uuid), void 0 !== this.thickness && (Wn.thickness = this.thickness), this.thicknessMap && this.thicknessMap.isTexture && (Wn.thicknessMap = this.thicknessMap.toJSON(Qe).uuid), void 0 !== this.attenuationDistance && this.attenuationDistance !== 1 / 0 && (Wn.attenuationDistance = this.attenuationDistance), void 0 !== this.attenuationColor && (Wn.attenuationColor = this.attenuationColor.getHex()), void 0 !== this.size && (Wn.size = this.size), null !== this.shadowSide && (Wn.shadowSide = this.shadowSide), void 0 !== this.sizeAttenuation && (Wn.sizeAttenuation = this.sizeAttenuation), this.blending !== $l && (Wn.blending = this.blending), this.side !== Hl && (Wn.side = this.side), !0 === this.vertexColors && (Wn.vertexColors = !0), this.opacity < 1 && (Wn.opacity = this.opacity), !0 === this.transparent && (Wn.transparent = !0), this.blendSrc !== ed && (Wn.blendSrc = this.blendSrc), this.blendDst !== td && (Wn.blendDst = this.blendDst), this.blendEquation !== fu && (Wn.blendEquation = this.blendEquation), null !== this.blendSrcAlpha && (Wn.blendSrcAlpha = this.blendSrcAlpha), null !== this.blendDstAlpha && (Wn.blendDstAlpha = this.blendDstAlpha), null !== this.blendEquationAlpha && (Wn.blendEquationAlpha = this.blendEquationAlpha), this.blendColor && this.blendColor.isColor && (Wn.blendColor = this.blendColor.getHex()), 0 !== this.blendAlpha && (Wn.blendAlpha = this.blendAlpha), this.depthFunc !== md && (Wn.depthFunc = this.depthFunc), !1 === this.depthTest && (Wn.depthTest = this.depthTest), !1 === this.depthWrite && (Wn.depthWrite = this.depthWrite), !1 === this.colorWrite && (Wn.colorWrite = this.colorWrite), 255 !== this.stencilWriteMask && (Wn.stencilWriteMask = this.stencilWriteMask), 519 !== this.stencilFunc && (Wn.stencilFunc = this.stencilFunc), 0 !== this.stencilRef && (Wn.stencilRef = this.stencilRef), 255 !== this.stencilFuncMask && (Wn.stencilFuncMask = this.stencilFuncMask), this.stencilFail !== bm && (Wn.stencilFail = this.stencilFail), this.stencilZFail !== bm && (Wn.stencilZFail = this.stencilZFail), this.stencilZPass !== bm && (Wn.stencilZPass = this.stencilZPass), !0 === this.stencilWrite && (Wn.stencilWrite = this.stencilWrite), void 0 !== this.rotation && 0 !== this.rotation && (Wn.rotation = this.rotation), !0 === this.polygonOffset && (Wn.polygonOffset = !0), 0 !== this.polygonOffsetFactor && (Wn.polygonOffsetFactor = this.polygonOffsetFactor), 0 !== this.polygonOffsetUnits && (Wn.polygonOffsetUnits = this.polygonOffsetUnits), void 0 !== this.linewidth && 1 !== this.linewidth && (Wn.linewidth = this.linewidth), void 0 !== this.dashSize && (Wn.dashSize = this.dashSize), void 0 !== this.gapSize && (Wn.gapSize = this.gapSize), void 0 !== this.scale && (Wn.scale = this.scale), !0 === this.dithering && (Wn.dithering = !0), this.alphaTest > 0 && (Wn.alphaTest = this.alphaTest), !0 === this.alphaHash && (Wn.alphaHash = !0), !0 === this.alphaToCoverage && (Wn.alphaToCoverage = !0), !0 === this.premultipliedAlpha && (Wn.premultipliedAlpha = !0), !0 === this.forceSinglePass && (Wn.forceSinglePass = !0), !0 === this.wireframe && (Wn.wireframe = !0), this.wireframeLinewidth > 1 && (Wn.wireframeLinewidth = this.wireframeLinewidth), "round" !== this.wireframeLinecap && (Wn.wireframeLinecap = this.wireframeLinecap), "round" !== this.wireframeLinejoin && (Wn.wireframeLinejoin = this.wireframeLinejoin), !0 === this.flatShading && (Wn.flatShading = !0), !1 === this.visible && (Wn.visible = !1), !1 === this.toneMapped && (Wn.toneMapped = !1), !1 === this.fog && (Wn.fog = !1), Object.keys(this.userData).length > 0 && (Wn.userData = this.userData), rt) {
                            const rt = extractFromCache(Qe.textures), Co = extractFromCache(Qe.images);
                            rt.length > 0 && (Wn.textures = rt), Co.length > 0 && (Wn.images = Co);
                        }
                        return Wn;
                    }
                    clone() {
                        return (new this.constructor).copy(this);
                    }
                    copy(Qe) {
                        this.name = Qe.name, this.blending = Qe.blending, this.side = Qe.side, this.vertexColors = Qe.vertexColors, this.opacity = Qe.opacity, this.transparent = Qe.transparent, this.blendSrc = Qe.blendSrc, this.blendDst = Qe.blendDst, this.blendEquation = Qe.blendEquation, this.blendSrcAlpha = Qe.blendSrcAlpha, this.blendDstAlpha = Qe.blendDstAlpha, this.blendEquationAlpha = Qe.blendEquationAlpha, this.blendColor.copy(Qe.blendColor), this.blendAlpha = Qe.blendAlpha, this.depthFunc = Qe.depthFunc, this.depthTest = Qe.depthTest, this.depthWrite = Qe.depthWrite, this.stencilWriteMask = Qe.stencilWriteMask, this.stencilFunc = Qe.stencilFunc, this.stencilRef = Qe.stencilRef, this.stencilFuncMask = Qe.stencilFuncMask, this.stencilFail = Qe.stencilFail, this.stencilZFail = Qe.stencilZFail, this.stencilZPass = Qe.stencilZPass, this.stencilWrite = Qe.stencilWrite;
                        const rt = Qe.clippingPlanes;
                        let Wn = null;
                        if (null !== rt) {
                            const Qe = rt.length;
                            Wn = new Array(Qe);
                            for(let Co = 0; Co !== Qe; ++Co)Wn[Co] = rt[Co].clone();
                        }
                        return this.clippingPlanes = Wn, this.clipIntersection = Qe.clipIntersection, this.clipShadows = Qe.clipShadows, this.shadowSide = Qe.shadowSide, this.colorWrite = Qe.colorWrite, this.precision = Qe.precision, this.polygonOffset = Qe.polygonOffset, this.polygonOffsetFactor = Qe.polygonOffsetFactor, this.polygonOffsetUnits = Qe.polygonOffsetUnits, this.dithering = Qe.dithering, this.alphaTest = Qe.alphaTest, this.alphaHash = Qe.alphaHash, this.alphaToCoverage = Qe.alphaToCoverage, this.premultipliedAlpha = Qe.premultipliedAlpha, this.forceSinglePass = Qe.forceSinglePass, this.visible = Qe.visible, this.toneMapped = Qe.toneMapped, this.userData = JSON.parse(JSON.stringify(Qe.userData)), this;
                    }
                    dispose() {
                        this.dispatchEvent({
                            type: "dispose"
                        });
                    }
                    set needsUpdate(Qe) {
                        !0 === Qe && this.version++;
                    }
                    onBuild() {
                        console.warn("Material: onBuild() has been removed.");
                    }
                }
                class MeshBasicMaterial extends Material {
                    constructor(Qe){
                        super(), this.isMeshBasicMaterial = !0, this.type = "MeshBasicMaterial", this.color = new Color(16777215), this.map = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.specularMap = null, this.alphaMap = null, this.envMap = null, this.envMapRotation = new Euler, this.combine = vd, this.reflectivity = 1, this.refractionRatio = .98, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.fog = !0, this.setValues(Qe);
                    }
                    copy(Qe) {
                        return super.copy(Qe), this.color.copy(Qe.color), this.map = Qe.map, this.lightMap = Qe.lightMap, this.lightMapIntensity = Qe.lightMapIntensity, this.aoMap = Qe.aoMap, this.aoMapIntensity = Qe.aoMapIntensity, this.specularMap = Qe.specularMap, this.alphaMap = Qe.alphaMap, this.envMap = Qe.envMap, this.envMapRotation.copy(Qe.envMapRotation), this.combine = Qe.combine, this.reflectivity = Qe.reflectivity, this.refractionRatio = Qe.refractionRatio, this.wireframe = Qe.wireframe, this.wireframeLinewidth = Qe.wireframeLinewidth, this.wireframeLinecap = Qe.wireframeLinecap, this.wireframeLinejoin = Qe.wireframeLinejoin, this.fog = Qe.fog, this;
                    }
                }
                const lg = new Vector3, cg = new Vector2;
                let ug = 0;
                class BufferAttribute {
                    constructor(Qe, rt, Wn){
                        if (void 0 === Wn && (Wn = !1), Array.isArray(Qe)) throw new TypeError("THREE.BufferAttribute: array should be a Typed Array.");
                        this.isBufferAttribute = !0, Object.defineProperty(this, "id", {
                            value: ug++
                        }), this.name = "", this.array = Qe, this.itemSize = rt, this.count = void 0 !== Qe ? Qe.length / rt : 0, this.normalized = Wn, this.usage = Dm, this.updateRanges = [], this.gpuType = Kd, this.version = 0;
                    }
                    onUploadCallback() {}
                    set needsUpdate(Qe) {
                        !0 === Qe && this.version++;
                    }
                    setUsage(Qe) {
                        return this.usage = Qe, this;
                    }
                    addUpdateRange(Qe, rt) {
                        this.updateRanges.push({
                            start: Qe,
                            count: rt
                        });
                    }
                    clearUpdateRanges() {
                        this.updateRanges.length = 0;
                    }
                    copy(Qe) {
                        return this.name = Qe.name, this.array = new Qe.array.constructor(Qe.array), this.itemSize = Qe.itemSize, this.count = Qe.count, this.normalized = Qe.normalized, this.usage = Qe.usage, this.gpuType = Qe.gpuType, this;
                    }
                    copyAt(Qe, rt, Wn) {
                        Qe *= this.itemSize, Wn *= rt.itemSize;
                        for(let Co = 0, Dl = this.itemSize; Co < Dl; Co++)this.array[Qe + Co] = rt.array[Wn + Co];
                        return this;
                    }
                    copyArray(Qe) {
                        return this.array.set(Qe), this;
                    }
                    applyMatrix3(Qe) {
                        if (2 === this.itemSize) for(let rt = 0, Wn = this.count; rt < Wn; rt++)cg.fromBufferAttribute(this, rt), cg.applyMatrix3(Qe), this.setXY(rt, cg.x, cg.y);
                        else if (3 === this.itemSize) for(let rt = 0, Wn = this.count; rt < Wn; rt++)lg.fromBufferAttribute(this, rt), lg.applyMatrix3(Qe), this.setXYZ(rt, lg.x, lg.y, lg.z);
                        return this;
                    }
                    applyMatrix4(Qe) {
                        for(let rt = 0, Wn = this.count; rt < Wn; rt++)lg.fromBufferAttribute(this, rt), lg.applyMatrix4(Qe), this.setXYZ(rt, lg.x, lg.y, lg.z);
                        return this;
                    }
                    applyNormalMatrix(Qe) {
                        for(let rt = 0, Wn = this.count; rt < Wn; rt++)lg.fromBufferAttribute(this, rt), lg.applyNormalMatrix(Qe), this.setXYZ(rt, lg.x, lg.y, lg.z);
                        return this;
                    }
                    transformDirection(Qe) {
                        for(let rt = 0, Wn = this.count; rt < Wn; rt++)lg.fromBufferAttribute(this, rt), lg.transformDirection(Qe), this.setXYZ(rt, lg.x, lg.y, lg.z);
                        return this;
                    }
                    set(Qe, rt) {
                        return void 0 === rt && (rt = 0), this.array.set(Qe, rt), this;
                    }
                    getComponent(Qe, rt) {
                        let Wn = this.array[Qe * this.itemSize + rt];
                        return this.normalized && (Wn = denormalize(Wn, this.array)), Wn;
                    }
                    setComponent(Qe, rt, Wn) {
                        return this.normalized && (Wn = normalize(Wn, this.array)), this.array[Qe * this.itemSize + rt] = Wn, this;
                    }
                    getX(Qe) {
                        let rt = this.array[Qe * this.itemSize];
                        return this.normalized && (rt = denormalize(rt, this.array)), rt;
                    }
                    setX(Qe, rt) {
                        return this.normalized && (rt = normalize(rt, this.array)), this.array[Qe * this.itemSize] = rt, this;
                    }
                    getY(Qe) {
                        let rt = this.array[Qe * this.itemSize + 1];
                        return this.normalized && (rt = denormalize(rt, this.array)), rt;
                    }
                    setY(Qe, rt) {
                        return this.normalized && (rt = normalize(rt, this.array)), this.array[Qe * this.itemSize + 1] = rt, this;
                    }
                    getZ(Qe) {
                        let rt = this.array[Qe * this.itemSize + 2];
                        return this.normalized && (rt = denormalize(rt, this.array)), rt;
                    }
                    setZ(Qe, rt) {
                        return this.normalized && (rt = normalize(rt, this.array)), this.array[Qe * this.itemSize + 2] = rt, this;
                    }
                    getW(Qe) {
                        let rt = this.array[Qe * this.itemSize + 3];
                        return this.normalized && (rt = denormalize(rt, this.array)), rt;
                    }
                    setW(Qe, rt) {
                        return this.normalized && (rt = normalize(rt, this.array)), this.array[Qe * this.itemSize + 3] = rt, this;
                    }
                    setXY(Qe, rt, Wn) {
                        return Qe *= this.itemSize, this.normalized && (rt = normalize(rt, this.array), Wn = normalize(Wn, this.array)), this.array[Qe + 0] = rt, this.array[Qe + 1] = Wn, this;
                    }
                    setXYZ(Qe, rt, Wn, Co) {
                        return Qe *= this.itemSize, this.normalized && (rt = normalize(rt, this.array), Wn = normalize(Wn, this.array), Co = normalize(Co, this.array)), this.array[Qe + 0] = rt, this.array[Qe + 1] = Wn, this.array[Qe + 2] = Co, this;
                    }
                    setXYZW(Qe, rt, Wn, Co, Dl) {
                        return Qe *= this.itemSize, this.normalized && (rt = normalize(rt, this.array), Wn = normalize(Wn, this.array), Co = normalize(Co, this.array), Dl = normalize(Dl, this.array)), this.array[Qe + 0] = rt, this.array[Qe + 1] = Wn, this.array[Qe + 2] = Co, this.array[Qe + 3] = Dl, this;
                    }
                    onUpload(Qe) {
                        return this.onUploadCallback = Qe, this;
                    }
                    clone() {
                        return new this.constructor(this.array, this.itemSize).copy(this);
                    }
                    toJSON() {
                        const Qe = {
                            itemSize: this.itemSize,
                            type: this.array.constructor.name,
                            array: Array.from(this.array),
                            normalized: this.normalized
                        };
                        return "" !== this.name && (Qe.name = this.name), this.usage !== Dm && (Qe.usage = this.usage), Qe;
                    }
                }
                class Uint16BufferAttribute extends BufferAttribute {
                    constructor(Qe, rt, Wn){
                        super(new Uint16Array(Qe), rt, Wn);
                    }
                }
                class Uint32BufferAttribute extends BufferAttribute {
                    constructor(Qe, rt, Wn){
                        super(new Uint32Array(Qe), rt, Wn);
                    }
                }
                class Float32BufferAttribute extends BufferAttribute {
                    constructor(Qe, rt, Wn){
                        super(new Float32Array(Qe), rt, Wn);
                    }
                }
                let hg = 0;
                const dg = new Matrix4, pg = new Object3D, mg = new Vector3, fg = new Box3, gg = new Box3, Ag = new Vector3;
                class BufferGeometry extends EventDispatcher {
                    constructor(){
                        super(), this.isBufferGeometry = !0, Object.defineProperty(this, "id", {
                            value: hg++
                        }), this.uuid = generateUUID(), this.name = "", this.type = "BufferGeometry", this.index = null, this.indirect = null, this.attributes = {}, this.morphAttributes = {}, this.morphTargetsRelative = !1, this.groups = [], this.boundingBox = null, this.boundingSphere = null, this.drawRange = {
                            start: 0,
                            count: 1 / 0
                        }, this.userData = {};
                    }
                    getIndex() {
                        return this.index;
                    }
                    setIndex(Qe) {
                        return Array.isArray(Qe) ? this.index = new (arrayNeedsUint32(Qe) ? Uint32BufferAttribute : Uint16BufferAttribute)(Qe, 1) : this.index = Qe, this;
                    }
                    setIndirect(Qe) {
                        return this.indirect = Qe, this;
                    }
                    getIndirect() {
                        return this.indirect;
                    }
                    getAttribute(Qe) {
                        return this.attributes[Qe];
                    }
                    setAttribute(Qe, rt) {
                        return this.attributes[Qe] = rt, this;
                    }
                    deleteAttribute(Qe) {
                        return delete this.attributes[Qe], this;
                    }
                    hasAttribute(Qe) {
                        return void 0 !== this.attributes[Qe];
                    }
                    addGroup(Qe, rt, Wn) {
                        void 0 === Wn && (Wn = 0), this.groups.push({
                            start: Qe,
                            count: rt,
                            materialIndex: Wn
                        });
                    }
                    clearGroups() {
                        this.groups = [];
                    }
                    setDrawRange(Qe, rt) {
                        this.drawRange.start = Qe, this.drawRange.count = rt;
                    }
                    applyMatrix4(Qe) {
                        const rt = this.attributes.position;
                        void 0 !== rt && (rt.applyMatrix4(Qe), rt.needsUpdate = !0);
                        const Wn = this.attributes.normal;
                        if (void 0 !== Wn) {
                            const rt = (new Matrix3).getNormalMatrix(Qe);
                            Wn.applyNormalMatrix(rt), Wn.needsUpdate = !0;
                        }
                        const Co = this.attributes.tangent;
                        return void 0 !== Co && (Co.transformDirection(Qe), Co.needsUpdate = !0), null !== this.boundingBox && this.computeBoundingBox(), null !== this.boundingSphere && this.computeBoundingSphere(), this;
                    }
                    applyQuaternion(Qe) {
                        return dg.makeRotationFromQuaternion(Qe), this.applyMatrix4(dg), this;
                    }
                    rotateX(Qe) {
                        return dg.makeRotationX(Qe), this.applyMatrix4(dg), this;
                    }
                    rotateY(Qe) {
                        return dg.makeRotationY(Qe), this.applyMatrix4(dg), this;
                    }
                    rotateZ(Qe) {
                        return dg.makeRotationZ(Qe), this.applyMatrix4(dg), this;
                    }
                    translate(Qe, rt, Wn) {
                        return dg.makeTranslation(Qe, rt, Wn), this.applyMatrix4(dg), this;
                    }
                    scale(Qe, rt, Wn) {
                        return dg.makeScale(Qe, rt, Wn), this.applyMatrix4(dg), this;
                    }
                    lookAt(Qe) {
                        return pg.lookAt(Qe), pg.updateMatrix(), this.applyMatrix4(pg.matrix), this;
                    }
                    center() {
                        return this.computeBoundingBox(), this.boundingBox.getCenter(mg).negate(), this.translate(mg.x, mg.y, mg.z), this;
                    }
                    setFromPoints(Qe) {
                        const rt = this.getAttribute("position");
                        if (void 0 === rt) {
                            const rt = [];
                            for(let Wn = 0, Co = Qe.length; Wn < Co; Wn++){
                                const Co = Qe[Wn];
                                rt.push(Co.x, Co.y, Co.z || 0);
                            }
                            this.setAttribute("position", new Float32BufferAttribute(rt, 3));
                        } else {
                            const Wn = Math.min(Qe.length, rt.count);
                            for(let Co = 0; Co < Wn; Co++){
                                const Wn = Qe[Co];
                                rt.setXYZ(Co, Wn.x, Wn.y, Wn.z || 0);
                            }
                            Qe.length > rt.count && console.warn("THREE.BufferGeometry: Buffer size too small for points data. Use .dispose() and create a new geometry."), rt.needsUpdate = !0;
                        }
                        return this;
                    }
                    computeBoundingBox() {
                        null === this.boundingBox && (this.boundingBox = new Box3);
                        const Qe = this.attributes.position, rt = this.morphAttributes.position;
                        if (Qe && Qe.isGLBufferAttribute) return console.error("THREE.BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box.", this), void this.boundingBox.set(new Vector3(-1 / 0, -1 / 0, -1 / 0), new Vector3(1 / 0, 1 / 0, 1 / 0));
                        if (void 0 !== Qe) {
                            if (this.boundingBox.setFromBufferAttribute(Qe), rt) for(let Wn = 0, Co = rt.length; Wn < Co; Wn++){
                                const Qe = rt[Wn];
                                fg.setFromBufferAttribute(Qe), this.morphTargetsRelative ? (Ag.addVectors(this.boundingBox.min, fg.min), this.boundingBox.expandByPoint(Ag), Ag.addVectors(this.boundingBox.max, fg.max), this.boundingBox.expandByPoint(Ag)) : (this.boundingBox.expandByPoint(fg.min), this.boundingBox.expandByPoint(fg.max));
                            }
                        } else this.boundingBox.makeEmpty();
                        (isNaN(this.boundingBox.min.x) || isNaN(this.boundingBox.min.y) || isNaN(this.boundingBox.min.z)) && console.error('THREE.BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this);
                    }
                    computeBoundingSphere() {
                        null === this.boundingSphere && (this.boundingSphere = new Sphere);
                        const Qe = this.attributes.position, rt = this.morphAttributes.position;
                        if (Qe && Qe.isGLBufferAttribute) return console.error("THREE.BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere.", this), void this.boundingSphere.set(new Vector3, 1 / 0);
                        if (Qe) {
                            const Wn = this.boundingSphere.center;
                            if (fg.setFromBufferAttribute(Qe), rt) for(let Qe = 0, Dl = rt.length; Qe < Dl; Qe++){
                                const Wn = rt[Qe];
                                gg.setFromBufferAttribute(Wn), this.morphTargetsRelative ? (Ag.addVectors(fg.min, gg.min), fg.expandByPoint(Ag), Ag.addVectors(fg.max, gg.max), fg.expandByPoint(Ag)) : (fg.expandByPoint(gg.min), fg.expandByPoint(gg.max));
                            }
                            fg.getCenter(Wn);
                            let Co = 0;
                            for(let rt = 0, Dl = Qe.count; rt < Dl; rt++)Ag.fromBufferAttribute(Qe, rt), Co = Math.max(Co, Wn.distanceToSquared(Ag));
                            if (rt) for(let Dl = 0, Ll = rt.length; Dl < Ll; Dl++){
                                const Ll = rt[Dl], Rl = this.morphTargetsRelative;
                                for(let rt = 0, Dl = Ll.count; rt < Dl; rt++)Ag.fromBufferAttribute(Ll, rt), Rl && (mg.fromBufferAttribute(Qe, rt), Ag.add(mg)), Co = Math.max(Co, Wn.distanceToSquared(Ag));
                            }
                            this.boundingSphere.radius = Math.sqrt(Co), isNaN(this.boundingSphere.radius) && console.error('THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this);
                        }
                    }
                    computeTangents() {
                        const Qe = this.index, rt = this.attributes;
                        if (null === Qe || void 0 === rt.position || void 0 === rt.normal || void 0 === rt.uv) return void console.error("THREE.BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)");
                        const Wn = rt.position, Co = rt.normal, Dl = rt.uv;
                        !1 === this.hasAttribute("tangent") && this.setAttribute("tangent", new BufferAttribute(new Float32Array(4 * Wn.count), 4));
                        const Ll = this.getAttribute("tangent"), Rl = [], Ul = [];
                        for(let Eu = 0; Eu < Wn.count; Eu++)Rl[Eu] = new Vector3, Ul[Eu] = new Vector3;
                        const Gl = new Vector3, Zl = new Vector3, Hl = new Vector3, ql = new Vector2, Ql = new Vector2, Kl = new Vector2, $l = new Vector3, Tc = new Vector3;
                        function handleTriangle(Qe, rt, Co) {
                            Gl.fromBufferAttribute(Wn, Qe), Zl.fromBufferAttribute(Wn, rt), Hl.fromBufferAttribute(Wn, Co), ql.fromBufferAttribute(Dl, Qe), Ql.fromBufferAttribute(Dl, rt), Kl.fromBufferAttribute(Dl, Co), Zl.sub(Gl), Hl.sub(Gl), Ql.sub(ql), Kl.sub(ql);
                            const Ll = 1 / (Ql.x * Kl.y - Kl.x * Ql.y);
                            isFinite(Ll) && ($l.copy(Zl).multiplyScalar(Kl.y).addScaledVector(Hl, -Ql.y).multiplyScalar(Ll), Tc.copy(Hl).multiplyScalar(Ql.x).addScaledVector(Zl, -Kl.x).multiplyScalar(Ll), Rl[Qe].add($l), Rl[rt].add($l), Rl[Co].add($l), Ul[Qe].add(Tc), Ul[rt].add(Tc), Ul[Co].add(Tc));
                        }
                        let tu = this.groups;
                        0 === tu.length && (tu = [
                            {
                                start: 0,
                                count: Qe.count
                            }
                        ]);
                        for(let Eu = 0, Tu = tu.length; Eu < Tu; ++Eu){
                            const rt = tu[Eu], Wn = rt.start;
                            for(let Co = Wn, Dl = Wn + rt.count; Co < Dl; Co += 3)handleTriangle(Qe.getX(Co + 0), Qe.getX(Co + 1), Qe.getX(Co + 2));
                        }
                        const lu = new Vector3, du = new Vector3, fu = new Vector3, yu = new Vector3;
                        function handleVertex(Qe) {
                            fu.fromBufferAttribute(Co, Qe), yu.copy(fu);
                            const rt = Rl[Qe];
                            lu.copy(rt), lu.sub(fu.multiplyScalar(fu.dot(rt))).normalize(), du.crossVectors(yu, rt);
                            const Wn = du.dot(Ul[Qe]) < 0 ? -1 : 1;
                            Ll.setXYZW(Qe, lu.x, lu.y, lu.z, Wn);
                        }
                        for(let Eu = 0, Tu = tu.length; Eu < Tu; ++Eu){
                            const rt = tu[Eu], Wn = rt.start;
                            for(let Co = Wn, Dl = Wn + rt.count; Co < Dl; Co += 3)handleVertex(Qe.getX(Co + 0)), handleVertex(Qe.getX(Co + 1)), handleVertex(Qe.getX(Co + 2));
                        }
                    }
                    computeVertexNormals() {
                        const Qe = this.index, rt = this.getAttribute("position");
                        if (void 0 !== rt) {
                            let Wn = this.getAttribute("normal");
                            if (void 0 === Wn) Wn = new BufferAttribute(new Float32Array(3 * rt.count), 3), this.setAttribute("normal", Wn);
                            else for(let Qe = 0, rt = Wn.count; Qe < rt; Qe++)Wn.setXYZ(Qe, 0, 0, 0);
                            const Co = new Vector3, Dl = new Vector3, Ll = new Vector3, Rl = new Vector3, Ul = new Vector3, Gl = new Vector3, Zl = new Vector3, Hl = new Vector3;
                            if (Qe) for(let ql = 0, Ql = Qe.count; ql < Ql; ql += 3){
                                const Ql = Qe.getX(ql + 0), Kl = Qe.getX(ql + 1), $l = Qe.getX(ql + 2);
                                Co.fromBufferAttribute(rt, Ql), Dl.fromBufferAttribute(rt, Kl), Ll.fromBufferAttribute(rt, $l), Zl.subVectors(Ll, Dl), Hl.subVectors(Co, Dl), Zl.cross(Hl), Rl.fromBufferAttribute(Wn, Ql), Ul.fromBufferAttribute(Wn, Kl), Gl.fromBufferAttribute(Wn, $l), Rl.add(Zl), Ul.add(Zl), Gl.add(Zl), Wn.setXYZ(Ql, Rl.x, Rl.y, Rl.z), Wn.setXYZ(Kl, Ul.x, Ul.y, Ul.z), Wn.setXYZ($l, Gl.x, Gl.y, Gl.z);
                            }
                            else for(let Qe = 0, ql = rt.count; Qe < ql; Qe += 3)Co.fromBufferAttribute(rt, Qe + 0), Dl.fromBufferAttribute(rt, Qe + 1), Ll.fromBufferAttribute(rt, Qe + 2), Zl.subVectors(Ll, Dl), Hl.subVectors(Co, Dl), Zl.cross(Hl), Wn.setXYZ(Qe + 0, Zl.x, Zl.y, Zl.z), Wn.setXYZ(Qe + 1, Zl.x, Zl.y, Zl.z), Wn.setXYZ(Qe + 2, Zl.x, Zl.y, Zl.z);
                            this.normalizeNormals(), Wn.needsUpdate = !0;
                        }
                    }
                    normalizeNormals() {
                        const Qe = this.attributes.normal;
                        for(let rt = 0, Wn = Qe.count; rt < Wn; rt++)Ag.fromBufferAttribute(Qe, rt), Ag.normalize(), Qe.setXYZ(rt, Ag.x, Ag.y, Ag.z);
                    }
                    toNonIndexed() {
                        function convertBufferAttribute(Qe, rt) {
                            const Wn = Qe.array, Co = Qe.itemSize, Dl = Qe.normalized, Ll = new Wn.constructor(rt.length * Co);
                            let Rl = 0, Ul = 0;
                            for(let Gl = 0, Zl = rt.length; Gl < Zl; Gl++){
                                Rl = Qe.isInterleavedBufferAttribute ? rt[Gl] * Qe.data.stride + Qe.offset : rt[Gl] * Co;
                                for(let Qe = 0; Qe < Co; Qe++)Ll[Ul++] = Wn[Rl++];
                            }
                            return new BufferAttribute(Ll, Co, Dl);
                        }
                        if (null === this.index) return console.warn("THREE.BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed."), this;
                        const Qe = new BufferGeometry, rt = this.index.array, Wn = this.attributes;
                        for(const Ll in Wn){
                            const Co = convertBufferAttribute(Wn[Ll], rt);
                            Qe.setAttribute(Ll, Co);
                        }
                        const Co = this.morphAttributes;
                        for(const Ll in Co){
                            const Wn = [], Dl = Co[Ll];
                            for(let Qe = 0, Co = Dl.length; Qe < Co; Qe++){
                                const Co = convertBufferAttribute(Dl[Qe], rt);
                                Wn.push(Co);
                            }
                            Qe.morphAttributes[Ll] = Wn;
                        }
                        Qe.morphTargetsRelative = this.morphTargetsRelative;
                        const Dl = this.groups;
                        for(let Ll = 0, Rl = Dl.length; Ll < Rl; Ll++){
                            const rt = Dl[Ll];
                            Qe.addGroup(rt.start, rt.count, rt.materialIndex);
                        }
                        return Qe;
                    }
                    toJSON() {
                        const Qe = {
                            metadata: {
                                version: 4.6,
                                type: "BufferGeometry",
                                generator: "BufferGeometry.toJSON"
                            }
                        };
                        if (Qe.uuid = this.uuid, Qe.type = this.type, "" !== this.name && (Qe.name = this.name), Object.keys(this.userData).length > 0 && (Qe.userData = this.userData), void 0 !== this.parameters) {
                            const rt = this.parameters;
                            for(const Wn in rt)void 0 !== rt[Wn] && (Qe[Wn] = rt[Wn]);
                            return Qe;
                        }
                        Qe.data = {
                            attributes: {}
                        };
                        const rt = this.index;
                        null !== rt && (Qe.data.index = {
                            type: rt.array.constructor.name,
                            array: Array.prototype.slice.call(rt.array)
                        });
                        const Wn = this.attributes;
                        for(const Ul in Wn){
                            const rt = Wn[Ul];
                            Qe.data.attributes[Ul] = rt.toJSON(Qe.data);
                        }
                        const Co = {};
                        let Dl = !1;
                        for(const Ul in this.morphAttributes){
                            const rt = this.morphAttributes[Ul], Wn = [];
                            for(let Co = 0, Dl = rt.length; Co < Dl; Co++){
                                const Dl = rt[Co];
                                Wn.push(Dl.toJSON(Qe.data));
                            }
                            Wn.length > 0 && (Co[Ul] = Wn, Dl = !0);
                        }
                        Dl && (Qe.data.morphAttributes = Co, Qe.data.morphTargetsRelative = this.morphTargetsRelative);
                        const Ll = this.groups;
                        Ll.length > 0 && (Qe.data.groups = JSON.parse(JSON.stringify(Ll)));
                        const Rl = this.boundingSphere;
                        return null !== Rl && (Qe.data.boundingSphere = {
                            center: Rl.center.toArray(),
                            radius: Rl.radius
                        }), Qe;
                    }
                    clone() {
                        return (new this.constructor).copy(this);
                    }
                    copy(Qe) {
                        this.index = null, this.attributes = {}, this.morphAttributes = {}, this.groups = [], this.boundingBox = null, this.boundingSphere = null;
                        const rt = {};
                        this.name = Qe.name;
                        const Wn = Qe.index;
                        null !== Wn && this.setIndex(Wn.clone(rt));
                        const Co = Qe.attributes;
                        for(const Gl in Co){
                            const Qe = Co[Gl];
                            this.setAttribute(Gl, Qe.clone(rt));
                        }
                        const Dl = Qe.morphAttributes;
                        for(const Gl in Dl){
                            const Qe = [], Wn = Dl[Gl];
                            for(let Co = 0, Dl = Wn.length; Co < Dl; Co++)Qe.push(Wn[Co].clone(rt));
                            this.morphAttributes[Gl] = Qe;
                        }
                        this.morphTargetsRelative = Qe.morphTargetsRelative;
                        const Ll = Qe.groups;
                        for(let Gl = 0, Zl = Ll.length; Gl < Zl; Gl++){
                            const Qe = Ll[Gl];
                            this.addGroup(Qe.start, Qe.count, Qe.materialIndex);
                        }
                        const Rl = Qe.boundingBox;
                        null !== Rl && (this.boundingBox = Rl.clone());
                        const Ul = Qe.boundingSphere;
                        return null !== Ul && (this.boundingSphere = Ul.clone()), this.drawRange.start = Qe.drawRange.start, this.drawRange.count = Qe.drawRange.count, this.userData = Qe.userData, this;
                    }
                    dispose() {
                        this.dispatchEvent({
                            type: "dispose"
                        });
                    }
                }
                const yg = new Matrix4, vg = new Ray, _g = new Sphere, xg = new Vector3, bg = new Vector3, wg = new Vector3, Eg = new Vector3, Mg = new Vector3, Sg = new Vector3, Tg = new Vector3, Cg = new Vector3;
                class Mesh extends Object3D {
                    constructor(Qe, rt){
                        void 0 === Qe && (Qe = new BufferGeometry), void 0 === rt && (rt = new MeshBasicMaterial), super(), this.isMesh = !0, this.type = "Mesh", this.geometry = Qe, this.material = rt, this.updateMorphTargets();
                    }
                    copy(Qe, rt) {
                        return super.copy(Qe, rt), void 0 !== Qe.morphTargetInfluences && (this.morphTargetInfluences = Qe.morphTargetInfluences.slice()), void 0 !== Qe.morphTargetDictionary && (this.morphTargetDictionary = Object.assign({}, Qe.morphTargetDictionary)), this.material = Array.isArray(Qe.material) ? Qe.material.slice() : Qe.material, this.geometry = Qe.geometry, this;
                    }
                    updateMorphTargets() {
                        const Qe = this.geometry.morphAttributes, rt = Object.keys(Qe);
                        if (rt.length > 0) {
                            const Wn = Qe[rt[0]];
                            if (void 0 !== Wn) {
                                this.morphTargetInfluences = [], this.morphTargetDictionary = {};
                                for(let Qe = 0, rt = Wn.length; Qe < rt; Qe++){
                                    const rt = Wn[Qe].name || String(Qe);
                                    this.morphTargetInfluences.push(0), this.morphTargetDictionary[rt] = Qe;
                                }
                            }
                        }
                    }
                    getVertexPosition(Qe, rt) {
                        const Wn = this.geometry, Co = Wn.attributes.position, Dl = Wn.morphAttributes.position, Ll = Wn.morphTargetsRelative;
                        rt.fromBufferAttribute(Co, Qe);
                        const Rl = this.morphTargetInfluences;
                        if (Dl && Rl) {
                            Sg.set(0, 0, 0);
                            for(let Wn = 0, Co = Dl.length; Wn < Co; Wn++){
                                const Co = Rl[Wn], Ul = Dl[Wn];
                                0 !== Co && (Mg.fromBufferAttribute(Ul, Qe), Ll ? Sg.addScaledVector(Mg, Co) : Sg.addScaledVector(Mg.sub(rt), Co));
                            }
                            rt.add(Sg);
                        }
                        return rt;
                    }
                    raycast(Qe, rt) {
                        const Wn = this.geometry, Co = this.material, Dl = this.matrixWorld;
                        if (void 0 !== Co) {
                            if (null === Wn.boundingSphere && Wn.computeBoundingSphere(), _g.copy(Wn.boundingSphere), _g.applyMatrix4(Dl), vg.copy(Qe.ray).recast(Qe.near), !1 === _g.containsPoint(vg.origin)) {
                                if (null === vg.intersectSphere(_g, xg)) return;
                                if (vg.origin.distanceToSquared(xg) > (Qe.far - Qe.near) ** 2) return;
                            }
                            yg.copy(Dl).invert(), vg.copy(Qe.ray).applyMatrix4(yg), null !== Wn.boundingBox && !1 === vg.intersectsBox(Wn.boundingBox) || this._computeIntersections(Qe, rt, vg);
                        }
                    }
                    _computeIntersections(Qe, rt, Wn) {
                        let Co;
                        const Dl = this.geometry, Ll = this.material, Rl = Dl.index, Ul = Dl.attributes.position, Gl = Dl.attributes.uv, Zl = Dl.attributes.uv1, Hl = Dl.attributes.normal, ql = Dl.groups, Ql = Dl.drawRange;
                        if (null !== Rl) {
                            if (Array.isArray(Ll)) for(let Kl = 0, $l = ql.length; Kl < $l; Kl++){
                                const Dl = ql[Kl], Ul = Ll[Dl.materialIndex];
                                for(let Ll = Math.max(Dl.start, Ql.start), ql = Math.min(Rl.count, Math.min(Dl.start + Dl.count, Ql.start + Ql.count)); Ll < ql; Ll += 3)Co = checkGeometryIntersection(this, Ul, Qe, Wn, Gl, Zl, Hl, Rl.getX(Ll), Rl.getX(Ll + 1), Rl.getX(Ll + 2)), Co && (Co.faceIndex = Math.floor(Ll / 3), Co.face.materialIndex = Dl.materialIndex, rt.push(Co));
                            }
                            else for(let Dl = Math.max(0, Ql.start), Ul = Math.min(Rl.count, Ql.start + Ql.count); Dl < Ul; Dl += 3)Co = checkGeometryIntersection(this, Ll, Qe, Wn, Gl, Zl, Hl, Rl.getX(Dl), Rl.getX(Dl + 1), Rl.getX(Dl + 2)), Co && (Co.faceIndex = Math.floor(Dl / 3), rt.push(Co));
                        } else if (void 0 !== Ul) {
                            if (Array.isArray(Ll)) for(let Kl = 0, $l = ql.length; Kl < $l; Kl++){
                                const Dl = ql[Kl], Rl = Ll[Dl.materialIndex];
                                for(let Ll = Math.max(Dl.start, Ql.start), ql = Math.min(Ul.count, Math.min(Dl.start + Dl.count, Ql.start + Ql.count)); Ll < ql; Ll += 3)Co = checkGeometryIntersection(this, Rl, Qe, Wn, Gl, Zl, Hl, Ll, Ll + 1, Ll + 2), Co && (Co.faceIndex = Math.floor(Ll / 3), Co.face.materialIndex = Dl.materialIndex, rt.push(Co));
                            }
                            else for(let Dl = Math.max(0, Ql.start), Rl = Math.min(Ul.count, Ql.start + Ql.count); Dl < Rl; Dl += 3)Co = checkGeometryIntersection(this, Ll, Qe, Wn, Gl, Zl, Hl, Dl, Dl + 1, Dl + 2), Co && (Co.faceIndex = Math.floor(Dl / 3), rt.push(Co));
                        }
                    }
                }
                function checkGeometryIntersection(Qe, rt, Wn, Co, Dl, Ll, Rl, Ul, Gl, Zl) {
                    Qe.getVertexPosition(Ul, bg), Qe.getVertexPosition(Gl, wg), Qe.getVertexPosition(Zl, Eg);
                    const Ql = function(Qe, rt, Wn, Co, Dl, Ll, Rl, Ul) {
                        let Gl;
                        if (Gl = rt.side === ql ? Co.intersectTriangle(Rl, Ll, Dl, !0, Ul) : Co.intersectTriangle(Dl, Ll, Rl, rt.side === Hl, Ul), null === Gl) return null;
                        Cg.copy(Ul), Cg.applyMatrix4(Qe.matrixWorld);
                        const Zl = Wn.ray.origin.distanceTo(Cg);
                        return Zl < Wn.near || Zl > Wn.far ? null : {
                            distance: Zl,
                            point: Cg.clone(),
                            object: Qe
                        };
                    }(Qe, rt, Wn, Co, bg, wg, Eg, Tg);
                    if (Ql) {
                        const Qe = new Vector3;
                        Triangle.getBarycoord(Tg, bg, wg, Eg, Qe), Dl && (Ql.uv = Triangle.getInterpolatedAttribute(Dl, Ul, Gl, Zl, Qe, new Vector2)), Ll && (Ql.uv1 = Triangle.getInterpolatedAttribute(Ll, Ul, Gl, Zl, Qe, new Vector2)), Rl && (Ql.normal = Triangle.getInterpolatedAttribute(Rl, Ul, Gl, Zl, Qe, new Vector3), Ql.normal.dot(Co.direction) > 0 && Ql.normal.multiplyScalar(-1));
                        const rt = {
                            a: Ul,
                            b: Gl,
                            c: Zl,
                            normal: new Vector3,
                            materialIndex: 0
                        };
                        Triangle.getNormal(bg, wg, Eg, rt.normal), Ql.face = rt, Ql.barycoord = Qe;
                    }
                    return Ql;
                }
                class BoxGeometry extends BufferGeometry {
                    constructor(Qe, rt, Wn, Co, Dl, Ll){
                        void 0 === Qe && (Qe = 1), void 0 === rt && (rt = 1), void 0 === Wn && (Wn = 1), void 0 === Co && (Co = 1), void 0 === Dl && (Dl = 1), void 0 === Ll && (Ll = 1), super(), this.type = "BoxGeometry", this.parameters = {
                            width: Qe,
                            height: rt,
                            depth: Wn,
                            widthSegments: Co,
                            heightSegments: Dl,
                            depthSegments: Ll
                        };
                        const Rl = this;
                        Co = Math.floor(Co), Dl = Math.floor(Dl), Ll = Math.floor(Ll);
                        const Ul = [], Gl = [], Zl = [], Hl = [];
                        let ql = 0, Ql = 0;
                        function buildPlane(Qe, rt, Wn, Co, Dl, Ll, Kl, $l, Tc, tu, lu) {
                            const du = Ll / Tc, fu = Kl / tu, yu = Ll / 2, Eu = Kl / 2, Tu = $l / 2, Lu = Tc + 1, Zu = tu + 1;
                            let Xu = 0, Ju = 0;
                            const $u = new Vector3;
                            for(let Rl = 0; Rl < Zu; Rl++){
                                const Ll = Rl * fu - Eu;
                                for(let Ul = 0; Ul < Lu; Ul++){
                                    const ql = Ul * du - yu;
                                    $u[Qe] = ql * Co, $u[rt] = Ll * Dl, $u[Wn] = Tu, Gl.push($u.x, $u.y, $u.z), $u[Qe] = 0, $u[rt] = 0, $u[Wn] = $l > 0 ? 1 : -1, Zl.push($u.x, $u.y, $u.z), Hl.push(Ul / Tc), Hl.push(1 - Rl / tu), Xu += 1;
                                }
                            }
                            for(let Rl = 0; Rl < tu; Rl++)for(let Qe = 0; Qe < Tc; Qe++){
                                const rt = ql + Qe + Lu * Rl, Wn = ql + Qe + Lu * (Rl + 1), Co = ql + (Qe + 1) + Lu * (Rl + 1), Dl = ql + (Qe + 1) + Lu * Rl;
                                Ul.push(rt, Wn, Dl), Ul.push(Wn, Co, Dl), Ju += 6;
                            }
                            Rl.addGroup(Ql, Ju, lu), Ql += Ju, ql += Xu;
                        }
                        buildPlane("z", "y", "x", -1, -1, Wn, rt, Qe, Ll, Dl, 0), buildPlane("z", "y", "x", 1, -1, Wn, rt, -Qe, Ll, Dl, 1), buildPlane("x", "z", "y", 1, 1, Qe, Wn, rt, Co, Ll, 2), buildPlane("x", "z", "y", 1, -1, Qe, Wn, -rt, Co, Ll, 3), buildPlane("x", "y", "z", 1, -1, Qe, rt, Wn, Co, Dl, 4), buildPlane("x", "y", "z", -1, -1, Qe, rt, -Wn, Co, Dl, 5), this.setIndex(Ul), this.setAttribute("position", new Float32BufferAttribute(Gl, 3)), this.setAttribute("normal", new Float32BufferAttribute(Zl, 3)), this.setAttribute("uv", new Float32BufferAttribute(Hl, 2));
                    }
                    copy(Qe) {
                        return super.copy(Qe), this.parameters = Object.assign({}, Qe.parameters), this;
                    }
                    static fromJSON(Qe) {
                        return new BoxGeometry(Qe.width, Qe.height, Qe.depth, Qe.widthSegments, Qe.heightSegments, Qe.depthSegments);
                    }
                }
                function cloneUniforms(Qe) {
                    const rt = {};
                    for(const Wn in Qe){
                        rt[Wn] = {};
                        for(const Co in Qe[Wn]){
                            const Dl = Qe[Wn][Co];
                            Dl && (Dl.isColor || Dl.isMatrix3 || Dl.isMatrix4 || Dl.isVector2 || Dl.isVector3 || Dl.isVector4 || Dl.isTexture || Dl.isQuaternion) ? Dl.isRenderTargetTexture ? (console.warn("UniformsUtils: Textures of render targets cannot be cloned via cloneUniforms() or mergeUniforms()."), rt[Wn][Co] = null) : rt[Wn][Co] = Dl.clone() : Array.isArray(Dl) ? rt[Wn][Co] = Dl.slice() : rt[Wn][Co] = Dl;
                        }
                    }
                    return rt;
                }
                function mergeUniforms(Qe) {
                    const rt = {};
                    for(let Wn = 0; Wn < Qe.length; Wn++){
                        const Co = cloneUniforms(Qe[Wn]);
                        for(const Qe in Co)rt[Qe] = Co[Qe];
                    }
                    return rt;
                }
                function getUnlitUniformColorSpace(Qe) {
                    const rt = Qe.getRenderTarget();
                    return null === rt ? Qe.outputColorSpace : !0 === rt.isXRRenderTarget ? rt.texture.colorSpace : Zm.workingColorSpace;
                }
                const kg = {
                    clone: cloneUniforms,
                    merge: mergeUniforms
                };
                class ShaderMaterial extends Material {
                    constructor(Qe){
                        super(), this.isShaderMaterial = !0, this.type = "ShaderMaterial", this.defines = {}, this.uniforms = {}, this.uniformsGroups = [], this.vertexShader = "void main() {\n	gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}", this.fragmentShader = "void main() {\n	gl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );\n}", this.linewidth = 1, this.wireframe = !1, this.wireframeLinewidth = 1, this.fog = !1, this.lights = !1, this.clipping = !1, this.forceSinglePass = !0, this.extensions = {
                            clipCullDistance: !1,
                            multiDraw: !1
                        }, this.defaultAttributeValues = {
                            color: [
                                1,
                                1,
                                1
                            ],
                            uv: [
                                0,
                                0
                            ],
                            uv1: [
                                0,
                                0
                            ]
                        }, this.index0AttributeName = void 0, this.uniformsNeedUpdate = !1, this.glslVersion = null, void 0 !== Qe && this.setValues(Qe);
                    }
                    copy(Qe) {
                        return super.copy(Qe), this.fragmentShader = Qe.fragmentShader, this.vertexShader = Qe.vertexShader, this.uniforms = cloneUniforms(Qe.uniforms), this.uniformsGroups = function(Qe) {
                            const rt = [];
                            for(let Wn = 0; Wn < Qe.length; Wn++)rt.push(Qe[Wn].clone());
                            return rt;
                        }(Qe.uniformsGroups), this.defines = Object.assign({}, Qe.defines), this.wireframe = Qe.wireframe, this.wireframeLinewidth = Qe.wireframeLinewidth, this.fog = Qe.fog, this.lights = Qe.lights, this.clipping = Qe.clipping, this.extensions = Object.assign({}, Qe.extensions), this.glslVersion = Qe.glslVersion, this;
                    }
                    toJSON(Qe) {
                        const rt = super.toJSON(Qe);
                        rt.glslVersion = this.glslVersion, rt.uniforms = {};
                        for(const Co in this.uniforms){
                            const Wn = this.uniforms[Co].value;
                            Wn && Wn.isTexture ? rt.uniforms[Co] = {
                                type: "t",
                                value: Wn.toJSON(Qe).uuid
                            } : Wn && Wn.isColor ? rt.uniforms[Co] = {
                                type: "c",
                                value: Wn.getHex()
                            } : Wn && Wn.isVector2 ? rt.uniforms[Co] = {
                                type: "v2",
                                value: Wn.toArray()
                            } : Wn && Wn.isVector3 ? rt.uniforms[Co] = {
                                type: "v3",
                                value: Wn.toArray()
                            } : Wn && Wn.isVector4 ? rt.uniforms[Co] = {
                                type: "v4",
                                value: Wn.toArray()
                            } : Wn && Wn.isMatrix3 ? rt.uniforms[Co] = {
                                type: "m3",
                                value: Wn.toArray()
                            } : Wn && Wn.isMatrix4 ? rt.uniforms[Co] = {
                                type: "m4",
                                value: Wn.toArray()
                            } : rt.uniforms[Co] = {
                                value: Wn
                            };
                        }
                        Object.keys(this.defines).length > 0 && (rt.defines = this.defines), rt.vertexShader = this.vertexShader, rt.fragmentShader = this.fragmentShader, rt.lights = this.lights, rt.clipping = this.clipping;
                        const Wn = {};
                        for(const Co in this.extensions)!0 === this.extensions[Co] && (Wn[Co] = !0);
                        return Object.keys(Wn).length > 0 && (rt.extensions = Wn), rt;
                    }
                }
                class Camera extends Object3D {
                    constructor(){
                        super(), this.isCamera = !0, this.type = "Camera", this.matrixWorldInverse = new Matrix4, this.projectionMatrix = new Matrix4, this.projectionMatrixInverse = new Matrix4, this.coordinateSystem = Pm;
                    }
                    copy(Qe, rt) {
                        return super.copy(Qe, rt), this.matrixWorldInverse.copy(Qe.matrixWorldInverse), this.projectionMatrix.copy(Qe.projectionMatrix), this.projectionMatrixInverse.copy(Qe.projectionMatrixInverse), this.coordinateSystem = Qe.coordinateSystem, this;
                    }
                    getWorldDirection(Qe) {
                        return super.getWorldDirection(Qe).negate();
                    }
                    updateMatrixWorld(Qe) {
                        super.updateMatrixWorld(Qe), this.matrixWorldInverse.copy(this.matrixWorld).invert();
                    }
                    updateWorldMatrix(Qe, rt) {
                        super.updateWorldMatrix(Qe, rt), this.matrixWorldInverse.copy(this.matrixWorld).invert();
                    }
                    clone() {
                        return (new this.constructor).copy(this);
                    }
                }
                const Ig = new Vector3, Dg = new Vector2, Lg = new Vector2;
                class PerspectiveCamera extends Camera {
                    constructor(Qe, rt, Wn, Co){
                        void 0 === Qe && (Qe = 50), void 0 === rt && (rt = 1), void 0 === Wn && (Wn = .1), void 0 === Co && (Co = 2e3), super(), this.isPerspectiveCamera = !0, this.type = "PerspectiveCamera", this.fov = Qe, this.zoom = 1, this.near = Wn, this.far = Co, this.focus = 10, this.aspect = rt, this.view = null, this.filmGauge = 35, this.filmOffset = 0, this.updateProjectionMatrix();
                    }
                    copy(Qe, rt) {
                        return super.copy(Qe, rt), this.fov = Qe.fov, this.zoom = Qe.zoom, this.near = Qe.near, this.far = Qe.far, this.focus = Qe.focus, this.aspect = Qe.aspect, this.view = null === Qe.view ? null : Object.assign({}, Qe.view), this.filmGauge = Qe.filmGauge, this.filmOffset = Qe.filmOffset, this;
                    }
                    setFocalLength(Qe) {
                        const rt = .5 * this.getFilmHeight() / Qe;
                        this.fov = 2 * Om * Math.atan(rt), this.updateProjectionMatrix();
                    }
                    getFocalLength() {
                        const Qe = Math.tan(.5 * Bm * this.fov);
                        return .5 * this.getFilmHeight() / Qe;
                    }
                    getEffectiveFOV() {
                        return 2 * Om * Math.atan(Math.tan(.5 * Bm * this.fov) / this.zoom);
                    }
                    getFilmWidth() {
                        return this.filmGauge * Math.min(this.aspect, 1);
                    }
                    getFilmHeight() {
                        return this.filmGauge / Math.max(this.aspect, 1);
                    }
                    getViewBounds(Qe, rt, Wn) {
                        Ig.set(-1, -1, .5).applyMatrix4(this.projectionMatrixInverse), rt.set(Ig.x, Ig.y).multiplyScalar(-Qe / Ig.z), Ig.set(1, 1, .5).applyMatrix4(this.projectionMatrixInverse), Wn.set(Ig.x, Ig.y).multiplyScalar(-Qe / Ig.z);
                    }
                    getViewSize(Qe, rt) {
                        return this.getViewBounds(Qe, Dg, Lg), rt.subVectors(Lg, Dg);
                    }
                    setViewOffset(Qe, rt, Wn, Co, Dl, Ll) {
                        this.aspect = Qe / rt, null === this.view && (this.view = {
                            enabled: !0,
                            fullWidth: 1,
                            fullHeight: 1,
                            offsetX: 0,
                            offsetY: 0,
                            width: 1,
                            height: 1
                        }), this.view.enabled = !0, this.view.fullWidth = Qe, this.view.fullHeight = rt, this.view.offsetX = Wn, this.view.offsetY = Co, this.view.width = Dl, this.view.height = Ll, this.updateProjectionMatrix();
                    }
                    clearViewOffset() {
                        null !== this.view && (this.view.enabled = !1), this.updateProjectionMatrix();
                    }
                    updateProjectionMatrix() {
                        const Qe = this.near;
                        let rt = Qe * Math.tan(.5 * Bm * this.fov) / this.zoom, Wn = 2 * rt, Co = this.aspect * Wn, Dl = -0.5 * Co;
                        const Ll = this.view;
                        if (null !== this.view && this.view.enabled) {
                            const Qe = Ll.fullWidth, Rl = Ll.fullHeight;
                            Dl += Ll.offsetX * Co / Qe, rt -= Ll.offsetY * Wn / Rl, Co *= Ll.width / Qe, Wn *= Ll.height / Rl;
                        }
                        const Rl = this.filmOffset;
                        0 !== Rl && (Dl += Qe * Rl / this.getFilmWidth()), this.projectionMatrix.makePerspective(Dl, Dl + Co, rt, rt - Wn, Qe, this.far, this.coordinateSystem), this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
                    }
                    toJSON(Qe) {
                        const rt = super.toJSON(Qe);
                        return rt.object.fov = this.fov, rt.object.zoom = this.zoom, rt.object.near = this.near, rt.object.far = this.far, rt.object.focus = this.focus, rt.object.aspect = this.aspect, null !== this.view && (rt.object.view = Object.assign({}, this.view)), rt.object.filmGauge = this.filmGauge, rt.object.filmOffset = this.filmOffset, rt;
                    }
                }
                const Pg = -90;
                class CubeCamera extends Object3D {
                    constructor(Qe, rt, Wn){
                        super(), this.type = "CubeCamera", this.renderTarget = Wn, this.coordinateSystem = null, this.activeMipmapLevel = 0;
                        const Co = new PerspectiveCamera(Pg, 1, Qe, rt);
                        Co.layers = this.layers, this.add(Co);
                        const Dl = new PerspectiveCamera(Pg, 1, Qe, rt);
                        Dl.layers = this.layers, this.add(Dl);
                        const Ll = new PerspectiveCamera(Pg, 1, Qe, rt);
                        Ll.layers = this.layers, this.add(Ll);
                        const Rl = new PerspectiveCamera(Pg, 1, Qe, rt);
                        Rl.layers = this.layers, this.add(Rl);
                        const Ul = new PerspectiveCamera(Pg, 1, Qe, rt);
                        Ul.layers = this.layers, this.add(Ul);
                        const Gl = new PerspectiveCamera(Pg, 1, Qe, rt);
                        Gl.layers = this.layers, this.add(Gl);
                    }
                    updateCoordinateSystem() {
                        const Qe = this.coordinateSystem, rt = this.children.concat(), [Wn, Co, Dl, Ll, Rl, Ul] = rt;
                        for (const Gl of rt)this.remove(Gl);
                        if (Qe === Pm) Wn.up.set(0, 1, 0), Wn.lookAt(1, 0, 0), Co.up.set(0, 1, 0), Co.lookAt(-1, 0, 0), Dl.up.set(0, 0, -1), Dl.lookAt(0, 1, 0), Ll.up.set(0, 0, 1), Ll.lookAt(0, -1, 0), Rl.up.set(0, 1, 0), Rl.lookAt(0, 0, 1), Ul.up.set(0, 1, 0), Ul.lookAt(0, 0, -1);
                        else {
                            if (Qe !== zm) throw new Error("THREE.CubeCamera.updateCoordinateSystem(): Invalid coordinate system: " + Qe);
                            Wn.up.set(0, -1, 0), Wn.lookAt(-1, 0, 0), Co.up.set(0, -1, 0), Co.lookAt(1, 0, 0), Dl.up.set(0, 0, 1), Dl.lookAt(0, 1, 0), Ll.up.set(0, 0, -1), Ll.lookAt(0, -1, 0), Rl.up.set(0, -1, 0), Rl.lookAt(0, 0, 1), Ul.up.set(0, -1, 0), Ul.lookAt(0, 0, -1);
                        }
                        for (const Gl of rt)this.add(Gl), Gl.updateMatrixWorld();
                    }
                    update(Qe, rt) {
                        null === this.parent && this.updateMatrixWorld();
                        const { renderTarget: Wn, activeMipmapLevel: Co } = this;
                        this.coordinateSystem !== Qe.coordinateSystem && (this.coordinateSystem = Qe.coordinateSystem, this.updateCoordinateSystem());
                        const [Dl, Ll, Rl, Ul, Gl, Zl] = this.children, Hl = Qe.getRenderTarget(), ql = Qe.getActiveCubeFace(), Ql = Qe.getActiveMipmapLevel(), Kl = Qe.xr.enabled;
                        Qe.xr.enabled = !1;
                        const $l = Wn.texture.generateMipmaps;
                        Wn.texture.generateMipmaps = !1, Qe.setRenderTarget(Wn, 0, Co), Qe.render(rt, Dl), Qe.setRenderTarget(Wn, 1, Co), Qe.render(rt, Ll), Qe.setRenderTarget(Wn, 2, Co), Qe.render(rt, Rl), Qe.setRenderTarget(Wn, 3, Co), Qe.render(rt, Ul), Qe.setRenderTarget(Wn, 4, Co), Qe.render(rt, Gl), Wn.texture.generateMipmaps = $l, Qe.setRenderTarget(Wn, 5, Co), Qe.render(rt, Zl), Qe.setRenderTarget(Hl, ql, Ql), Qe.xr.enabled = Kl, Wn.texture.needsPMREMUpdate = !0;
                    }
                }
                class CubeTexture extends Texture {
                    constructor(Qe, rt, Wn, Co, Dl, Ll, Rl, Ul, Gl, Zl){
                        super(Qe = void 0 !== Qe ? Qe : [], rt = void 0 !== rt ? rt : Id, Wn, Co, Dl, Ll, Rl, Ul, Gl, Zl), this.isCubeTexture = !0, this.flipY = !1;
                    }
                    get images() {
                        return this.image;
                    }
                    set images(Qe) {
                        this.image = Qe;
                    }
                }
                class WebGLCubeRenderTarget extends WebGLRenderTarget {
                    constructor(Qe, rt){
                        void 0 === Qe && (Qe = 1), void 0 === rt && (rt = {}), super(Qe, Qe, rt), this.isWebGLCubeRenderTarget = !0;
                        const Wn = {
                            width: Qe,
                            height: Qe,
                            depth: 1
                        }, Co = [
                            Wn,
                            Wn,
                            Wn,
                            Wn,
                            Wn,
                            Wn
                        ];
                        this.texture = new CubeTexture(Co, rt.mapping, rt.wrapS, rt.wrapT, rt.magFilter, rt.minFilter, rt.format, rt.type, rt.anisotropy, rt.colorSpace), this.texture.isRenderTargetTexture = !0, this.texture.generateMipmaps = void 0 !== rt.generateMipmaps && rt.generateMipmaps, this.texture.minFilter = void 0 !== rt.minFilter ? rt.minFilter : Ud;
                    }
                    fromEquirectangularTexture(Qe, rt) {
                        this.texture.type = rt.type, this.texture.colorSpace = rt.colorSpace, this.texture.generateMipmaps = rt.generateMipmaps, this.texture.minFilter = rt.minFilter, this.texture.magFilter = rt.magFilter;
                        const Wn = {
                            uniforms: {
                                tEquirect: {
                                    value: null
                                }
                            },
                            vertexShader: "\n\n				varying vec3 vWorldDirection;\n\n				vec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n\n					return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n\n				}\n\n				void main() {\n\n					vWorldDirection = transformDirection( position, modelMatrix );\n\n					#include <begin_vertex>\n					#include <project_vertex>\n\n				}\n			",
                            fragmentShader: "\n\n				uniform sampler2D tEquirect;\n\n				varying vec3 vWorldDirection;\n\n				#include <common>\n\n				void main() {\n\n					vec3 direction = normalize( vWorldDirection );\n\n					vec2 sampleUV = equirectUv( direction );\n\n					gl_FragColor = texture2D( tEquirect, sampleUV );\n\n				}\n			"
                        }, Co = new BoxGeometry(5, 5, 5), Dl = new ShaderMaterial({
                            name: "CubemapFromEquirect",
                            uniforms: cloneUniforms(Wn.uniforms),
                            vertexShader: Wn.vertexShader,
                            fragmentShader: Wn.fragmentShader,
                            side: ql,
                            blending: Kl
                        });
                        Dl.uniforms.tEquirect.value = rt;
                        const Ll = new Mesh(Co, Dl), Rl = rt.minFilter;
                        rt.minFilter === Gd && (rt.minFilter = Ud);
                        return new CubeCamera(1, 10, this).update(Qe, Ll), rt.minFilter = Rl, Ll.geometry.dispose(), Ll.material.dispose(), this;
                    }
                    clear(Qe, rt, Wn, Co) {
                        const Dl = Qe.getRenderTarget();
                        for(let Ll = 0; Ll < 6; Ll++)Qe.setRenderTarget(this, Ll), Qe.clear(rt, Wn, Co);
                        Qe.setRenderTarget(Dl);
                    }
                }
                class Group extends Object3D {
                    constructor(){
                        super(), this.isGroup = !0, this.type = "Group";
                    }
                }
                const zg = {
                    type: "move"
                };
                class WebXRController {
                    constructor(){
                        this._targetRay = null, this._grip = null, this._hand = null;
                    }
                    getHandSpace() {
                        return null === this._hand && (this._hand = new Group, this._hand.matrixAutoUpdate = !1, this._hand.visible = !1, this._hand.joints = {}, this._hand.inputState = {
                            pinching: !1
                        }), this._hand;
                    }
                    getTargetRaySpace() {
                        return null === this._targetRay && (this._targetRay = new Group, this._targetRay.matrixAutoUpdate = !1, this._targetRay.visible = !1, this._targetRay.hasLinearVelocity = !1, this._targetRay.linearVelocity = new Vector3, this._targetRay.hasAngularVelocity = !1, this._targetRay.angularVelocity = new Vector3), this._targetRay;
                    }
                    getGripSpace() {
                        return null === this._grip && (this._grip = new Group, this._grip.matrixAutoUpdate = !1, this._grip.visible = !1, this._grip.hasLinearVelocity = !1, this._grip.linearVelocity = new Vector3, this._grip.hasAngularVelocity = !1, this._grip.angularVelocity = new Vector3), this._grip;
                    }
                    dispatchEvent(Qe) {
                        return null !== this._targetRay && this._targetRay.dispatchEvent(Qe), null !== this._grip && this._grip.dispatchEvent(Qe), null !== this._hand && this._hand.dispatchEvent(Qe), this;
                    }
                    connect(Qe) {
                        if (Qe && Qe.hand) {
                            const rt = this._hand;
                            if (rt) for (const Wn of Qe.hand.values())this._getHandJoint(rt, Wn);
                        }
                        return this.dispatchEvent({
                            type: "connected",
                            data: Qe
                        }), this;
                    }
                    disconnect(Qe) {
                        return this.dispatchEvent({
                            type: "disconnected",
                            data: Qe
                        }), null !== this._targetRay && (this._targetRay.visible = !1), null !== this._grip && (this._grip.visible = !1), null !== this._hand && (this._hand.visible = !1), this;
                    }
                    update(Qe, rt, Wn) {
                        let Co = null, Dl = null, Ll = null;
                        const Rl = this._targetRay, Ul = this._grip, Gl = this._hand;
                        if (Qe && "visible-blurred" !== rt.session.visibilityState) {
                            if (Gl && Qe.hand) {
                                Ll = !0;
                                for (const Ll of Qe.hand.values()){
                                    const Qe = rt.getJointPose(Ll, Wn), Co = this._getHandJoint(Gl, Ll);
                                    null !== Qe && (Co.matrix.fromArray(Qe.transform.matrix), Co.matrix.decompose(Co.position, Co.rotation, Co.scale), Co.matrixWorldNeedsUpdate = !0, Co.jointRadius = Qe.radius), Co.visible = null !== Qe;
                                }
                                const Co = Gl.joints["index-finger-tip"], Dl = Gl.joints["thumb-tip"], Rl = Co.position.distanceTo(Dl.position), Ul = .02, Zl = .005;
                                Gl.inputState.pinching && Rl > Ul + Zl ? (Gl.inputState.pinching = !1, this.dispatchEvent({
                                    type: "pinchend",
                                    handedness: Qe.handedness,
                                    target: this
                                })) : !Gl.inputState.pinching && Rl <= Ul - Zl && (Gl.inputState.pinching = !0, this.dispatchEvent({
                                    type: "pinchstart",
                                    handedness: Qe.handedness,
                                    target: this
                                }));
                            } else null !== Ul && Qe.gripSpace && (Dl = rt.getPose(Qe.gripSpace, Wn), null !== Dl && (Ul.matrix.fromArray(Dl.transform.matrix), Ul.matrix.decompose(Ul.position, Ul.rotation, Ul.scale), Ul.matrixWorldNeedsUpdate = !0, Dl.linearVelocity ? (Ul.hasLinearVelocity = !0, Ul.linearVelocity.copy(Dl.linearVelocity)) : Ul.hasLinearVelocity = !1, Dl.angularVelocity ? (Ul.hasAngularVelocity = !0, Ul.angularVelocity.copy(Dl.angularVelocity)) : Ul.hasAngularVelocity = !1));
                            null !== Rl && (Co = rt.getPose(Qe.targetRaySpace, Wn), null === Co && null !== Dl && (Co = Dl), null !== Co && (Rl.matrix.fromArray(Co.transform.matrix), Rl.matrix.decompose(Rl.position, Rl.rotation, Rl.scale), Rl.matrixWorldNeedsUpdate = !0, Co.linearVelocity ? (Rl.hasLinearVelocity = !0, Rl.linearVelocity.copy(Co.linearVelocity)) : Rl.hasLinearVelocity = !1, Co.angularVelocity ? (Rl.hasAngularVelocity = !0, Rl.angularVelocity.copy(Co.angularVelocity)) : Rl.hasAngularVelocity = !1, this.dispatchEvent(zg)));
                        }
                        return null !== Rl && (Rl.visible = null !== Co), null !== Ul && (Ul.visible = null !== Dl), null !== Gl && (Gl.visible = null !== Ll), this;
                    }
                    _getHandJoint(Qe, rt) {
                        if (void 0 === Qe.joints[rt.jointName]) {
                            const Wn = new Group;
                            Wn.matrixAutoUpdate = !1, Wn.visible = !1, Qe.joints[rt.jointName] = Wn, Qe.add(Wn);
                        }
                        return Qe.joints[rt.jointName];
                    }
                }
                class Scene extends Object3D {
                    constructor(){
                        super(), this.isScene = !0, this.type = "Scene", this.background = null, this.environment = null, this.fog = null, this.backgroundBlurriness = 0, this.backgroundIntensity = 1, this.backgroundRotation = new Euler, this.environmentIntensity = 1, this.environmentRotation = new Euler, this.overrideMaterial = null, "undefined" !== typeof __THREE_DEVTOOLS__ && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", {
                            detail: this
                        }));
                    }
                    copy(Qe, rt) {
                        return super.copy(Qe, rt), null !== Qe.background && (this.background = Qe.background.clone()), null !== Qe.environment && (this.environment = Qe.environment.clone()), null !== Qe.fog && (this.fog = Qe.fog.clone()), this.backgroundBlurriness = Qe.backgroundBlurriness, this.backgroundIntensity = Qe.backgroundIntensity, this.backgroundRotation.copy(Qe.backgroundRotation), this.environmentIntensity = Qe.environmentIntensity, this.environmentRotation.copy(Qe.environmentRotation), null !== Qe.overrideMaterial && (this.overrideMaterial = Qe.overrideMaterial.clone()), this.matrixAutoUpdate = Qe.matrixAutoUpdate, this;
                    }
                    toJSON(Qe) {
                        const rt = super.toJSON(Qe);
                        return null !== this.fog && (rt.object.fog = this.fog.toJSON()), this.backgroundBlurriness > 0 && (rt.object.backgroundBlurriness = this.backgroundBlurriness), 1 !== this.backgroundIntensity && (rt.object.backgroundIntensity = this.backgroundIntensity), rt.object.backgroundRotation = this.backgroundRotation.toArray(), 1 !== this.environmentIntensity && (rt.object.environmentIntensity = this.environmentIntensity), rt.object.environmentRotation = this.environmentRotation.toArray(), rt;
                    }
                }
                const Ng = new Vector3, Rg = new Vector3, Bg = new Matrix3;
                class Plane {
                    constructor(Qe, rt){
                        void 0 === Qe && (Qe = new Vector3(1, 0, 0)), void 0 === rt && (rt = 0), this.isPlane = !0, this.normal = Qe, this.constant = rt;
                    }
                    set(Qe, rt) {
                        return this.normal.copy(Qe), this.constant = rt, this;
                    }
                    setComponents(Qe, rt, Wn, Co) {
                        return this.normal.set(Qe, rt, Wn), this.constant = Co, this;
                    }
                    setFromNormalAndCoplanarPoint(Qe, rt) {
                        return this.normal.copy(Qe), this.constant = -rt.dot(this.normal), this;
                    }
                    setFromCoplanarPoints(Qe, rt, Wn) {
                        const Co = Ng.subVectors(Wn, rt).cross(Rg.subVectors(Qe, rt)).normalize();
                        return this.setFromNormalAndCoplanarPoint(Co, Qe), this;
                    }
                    copy(Qe) {
                        return this.normal.copy(Qe.normal), this.constant = Qe.constant, this;
                    }
                    normalize() {
                        const Qe = 1 / this.normal.length();
                        return this.normal.multiplyScalar(Qe), this.constant *= Qe, this;
                    }
                    negate() {
                        return this.constant *= -1, this.normal.negate(), this;
                    }
                    distanceToPoint(Qe) {
                        return this.normal.dot(Qe) + this.constant;
                    }
                    distanceToSphere(Qe) {
                        return this.distanceToPoint(Qe.center) - Qe.radius;
                    }
                    projectPoint(Qe, rt) {
                        return rt.copy(Qe).addScaledVector(this.normal, -this.distanceToPoint(Qe));
                    }
                    intersectLine(Qe, rt) {
                        const Wn = Qe.delta(Ng), Co = this.normal.dot(Wn);
                        if (0 === Co) return 0 === this.distanceToPoint(Qe.start) ? rt.copy(Qe.start) : null;
                        const Dl = -(Qe.start.dot(this.normal) + this.constant) / Co;
                        return Dl < 0 || Dl > 1 ? null : rt.copy(Qe.start).addScaledVector(Wn, Dl);
                    }
                    intersectsLine(Qe) {
                        const rt = this.distanceToPoint(Qe.start), Wn = this.distanceToPoint(Qe.end);
                        return rt < 0 && Wn > 0 || Wn < 0 && rt > 0;
                    }
                    intersectsBox(Qe) {
                        return Qe.intersectsPlane(this);
                    }
                    intersectsSphere(Qe) {
                        return Qe.intersectsPlane(this);
                    }
                    coplanarPoint(Qe) {
                        return Qe.copy(this.normal).multiplyScalar(-this.constant);
                    }
                    applyMatrix4(Qe, rt) {
                        const Wn = rt || Bg.getNormalMatrix(Qe), Co = this.coplanarPoint(Ng).applyMatrix4(Qe), Dl = this.normal.applyMatrix3(Wn).normalize();
                        return this.constant = -Co.dot(Dl), this;
                    }
                    translate(Qe) {
                        return this.constant -= Qe.dot(this.normal), this;
                    }
                    equals(Qe) {
                        return Qe.normal.equals(this.normal) && Qe.constant === this.constant;
                    }
                    clone() {
                        return (new this.constructor).copy(this);
                    }
                }
                const Og = new Sphere, Fg = new Vector3;
                class Frustum {
                    constructor(Qe, rt, Wn, Co, Dl, Ll){
                        void 0 === Qe && (Qe = new Plane), void 0 === rt && (rt = new Plane), void 0 === Wn && (Wn = new Plane), void 0 === Co && (Co = new Plane), void 0 === Dl && (Dl = new Plane), void 0 === Ll && (Ll = new Plane), this.planes = [
                            Qe,
                            rt,
                            Wn,
                            Co,
                            Dl,
                            Ll
                        ];
                    }
                    set(Qe, rt, Wn, Co, Dl, Ll) {
                        const Rl = this.planes;
                        return Rl[0].copy(Qe), Rl[1].copy(rt), Rl[2].copy(Wn), Rl[3].copy(Co), Rl[4].copy(Dl), Rl[5].copy(Ll), this;
                    }
                    copy(Qe) {
                        const rt = this.planes;
                        for(let Wn = 0; Wn < 6; Wn++)rt[Wn].copy(Qe.planes[Wn]);
                        return this;
                    }
                    setFromProjectionMatrix(Qe, rt) {
                        void 0 === rt && (rt = Pm);
                        const Wn = this.planes, Co = Qe.elements, Dl = Co[0], Ll = Co[1], Rl = Co[2], Ul = Co[3], Gl = Co[4], Zl = Co[5], Hl = Co[6], ql = Co[7], Ql = Co[8], Kl = Co[9], $l = Co[10], Tc = Co[11], tu = Co[12], lu = Co[13], du = Co[14], fu = Co[15];
                        if (Wn[0].setComponents(Ul - Dl, ql - Gl, Tc - Ql, fu - tu).normalize(), Wn[1].setComponents(Ul + Dl, ql + Gl, Tc + Ql, fu + tu).normalize(), Wn[2].setComponents(Ul + Ll, ql + Zl, Tc + Kl, fu + lu).normalize(), Wn[3].setComponents(Ul - Ll, ql - Zl, Tc - Kl, fu - lu).normalize(), Wn[4].setComponents(Ul - Rl, ql - Hl, Tc - $l, fu - du).normalize(), rt === Pm) Wn[5].setComponents(Ul + Rl, ql + Hl, Tc + $l, fu + du).normalize();
                        else {
                            if (rt !== zm) throw new Error("THREE.Frustum.setFromProjectionMatrix(): Invalid coordinate system: " + rt);
                            Wn[5].setComponents(Rl, Hl, $l, du).normalize();
                        }
                        return this;
                    }
                    intersectsObject(Qe) {
                        if (void 0 !== Qe.boundingSphere) null === Qe.boundingSphere && Qe.computeBoundingSphere(), Og.copy(Qe.boundingSphere).applyMatrix4(Qe.matrixWorld);
                        else {
                            const rt = Qe.geometry;
                            null === rt.boundingSphere && rt.computeBoundingSphere(), Og.copy(rt.boundingSphere).applyMatrix4(Qe.matrixWorld);
                        }
                        return this.intersectsSphere(Og);
                    }
                    intersectsSprite(Qe) {
                        return Og.center.set(0, 0, 0), Og.radius = .7071067811865476, Og.applyMatrix4(Qe.matrixWorld), this.intersectsSphere(Og);
                    }
                    intersectsSphere(Qe) {
                        const rt = this.planes, Wn = Qe.center, Co = -Qe.radius;
                        for(let Dl = 0; Dl < 6; Dl++){
                            if (rt[Dl].distanceToPoint(Wn) < Co) return !1;
                        }
                        return !0;
                    }
                    intersectsBox(Qe) {
                        const rt = this.planes;
                        for(let Wn = 0; Wn < 6; Wn++){
                            const Co = rt[Wn];
                            if (Fg.x = Co.normal.x > 0 ? Qe.max.x : Qe.min.x, Fg.y = Co.normal.y > 0 ? Qe.max.y : Qe.min.y, Fg.z = Co.normal.z > 0 ? Qe.max.z : Qe.min.z, Co.distanceToPoint(Fg) < 0) return !1;
                        }
                        return !0;
                    }
                    containsPoint(Qe) {
                        const rt = this.planes;
                        for(let Wn = 0; Wn < 6; Wn++)if (rt[Wn].distanceToPoint(Qe) < 0) return !1;
                        return !0;
                    }
                    clone() {
                        return (new this.constructor).copy(this);
                    }
                }
                class LineBasicMaterial extends Material {
                    constructor(Qe){
                        super(), this.isLineBasicMaterial = !0, this.type = "LineBasicMaterial", this.color = new Color(16777215), this.map = null, this.linewidth = 1, this.linecap = "round", this.linejoin = "round", this.fog = !0, this.setValues(Qe);
                    }
                    copy(Qe) {
                        return super.copy(Qe), this.color.copy(Qe.color), this.map = Qe.map, this.linewidth = Qe.linewidth, this.linecap = Qe.linecap, this.linejoin = Qe.linejoin, this.fog = Qe.fog, this;
                    }
                }
                const jg = new Vector3, Ug = new Vector3, Vg = new Matrix4, Gg = new Ray, Zg = new Sphere, Hg = new Vector3, Wg = new Vector3;
                class Line extends Object3D {
                    constructor(Qe, rt){
                        void 0 === Qe && (Qe = new BufferGeometry), void 0 === rt && (rt = new LineBasicMaterial), super(), this.isLine = !0, this.type = "Line", this.geometry = Qe, this.material = rt, this.updateMorphTargets();
                    }
                    copy(Qe, rt) {
                        return super.copy(Qe, rt), this.material = Array.isArray(Qe.material) ? Qe.material.slice() : Qe.material, this.geometry = Qe.geometry, this;
                    }
                    computeLineDistances() {
                        const Qe = this.geometry;
                        if (null === Qe.index) {
                            const rt = Qe.attributes.position, Wn = [
                                0
                            ];
                            for(let Qe = 1, Co = rt.count; Qe < Co; Qe++)jg.fromBufferAttribute(rt, Qe - 1), Ug.fromBufferAttribute(rt, Qe), Wn[Qe] = Wn[Qe - 1], Wn[Qe] += jg.distanceTo(Ug);
                            Qe.setAttribute("lineDistance", new Float32BufferAttribute(Wn, 1));
                        } else console.warn("THREE.Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
                        return this;
                    }
                    raycast(Qe, rt) {
                        const Wn = this.geometry, Co = this.matrixWorld, Dl = Qe.params.Line.threshold, Ll = Wn.drawRange;
                        if (null === Wn.boundingSphere && Wn.computeBoundingSphere(), Zg.copy(Wn.boundingSphere), Zg.applyMatrix4(Co), Zg.radius += Dl, !1 === Qe.ray.intersectsSphere(Zg)) return;
                        Vg.copy(Co).invert(), Gg.copy(Qe.ray).applyMatrix4(Vg);
                        const Rl = Dl / ((this.scale.x + this.scale.y + this.scale.z) / 3), Ul = Rl * Rl, Gl = this.isLineSegments ? 2 : 1, Zl = Wn.index, Hl = Wn.attributes.position;
                        if (null !== Zl) {
                            const Wn = Math.max(0, Ll.start), Co = Math.min(Zl.count, Ll.start + Ll.count);
                            for(let Dl = Wn, Ll = Co - 1; Dl < Ll; Dl += Gl){
                                const Wn = Zl.getX(Dl), Co = Zl.getX(Dl + 1), Ll = checkIntersection(this, Qe, Gg, Ul, Wn, Co, Dl);
                                Ll && rt.push(Ll);
                            }
                            if (this.isLineLoop) {
                                const Dl = Zl.getX(Co - 1), Ll = Zl.getX(Wn), Rl = checkIntersection(this, Qe, Gg, Ul, Dl, Ll, Co - 1);
                                Rl && rt.push(Rl);
                            }
                        } else {
                            const Wn = Math.max(0, Ll.start), Co = Math.min(Hl.count, Ll.start + Ll.count);
                            for(let Dl = Wn, Ll = Co - 1; Dl < Ll; Dl += Gl){
                                const Wn = checkIntersection(this, Qe, Gg, Ul, Dl, Dl + 1, Dl);
                                Wn && rt.push(Wn);
                            }
                            if (this.isLineLoop) {
                                const Dl = checkIntersection(this, Qe, Gg, Ul, Co - 1, Wn, Co - 1);
                                Dl && rt.push(Dl);
                            }
                        }
                    }
                    updateMorphTargets() {
                        const Qe = this.geometry.morphAttributes, rt = Object.keys(Qe);
                        if (rt.length > 0) {
                            const Wn = Qe[rt[0]];
                            if (void 0 !== Wn) {
                                this.morphTargetInfluences = [], this.morphTargetDictionary = {};
                                for(let Qe = 0, rt = Wn.length; Qe < rt; Qe++){
                                    const rt = Wn[Qe].name || String(Qe);
                                    this.morphTargetInfluences.push(0), this.morphTargetDictionary[rt] = Qe;
                                }
                            }
                        }
                    }
                }
                function checkIntersection(Qe, rt, Wn, Co, Dl, Ll, Rl) {
                    const Ul = Qe.geometry.attributes.position;
                    jg.fromBufferAttribute(Ul, Dl), Ug.fromBufferAttribute(Ul, Ll);
                    if (Wn.distanceSqToSegment(jg, Ug, Hg, Wg) > Co) return;
                    Hg.applyMatrix4(Qe.matrixWorld);
                    const Gl = rt.ray.origin.distanceTo(Hg);
                    return Gl < rt.near || Gl > rt.far ? void 0 : {
                        distance: Gl,
                        point: Wg.clone().applyMatrix4(Qe.matrixWorld),
                        index: Rl,
                        face: null,
                        faceIndex: null,
                        barycoord: null,
                        object: Qe
                    };
                }
                const qg = new Vector3, Yg = new Vector3;
                class LineSegments extends Line {
                    constructor(Qe, rt){
                        super(Qe, rt), this.isLineSegments = !0, this.type = "LineSegments";
                    }
                    computeLineDistances() {
                        const Qe = this.geometry;
                        if (null === Qe.index) {
                            const rt = Qe.attributes.position, Wn = [];
                            for(let Qe = 0, Co = rt.count; Qe < Co; Qe += 2)qg.fromBufferAttribute(rt, Qe), Yg.fromBufferAttribute(rt, Qe + 1), Wn[Qe] = 0 === Qe ? 0 : Wn[Qe - 1], Wn[Qe + 1] = Wn[Qe] + qg.distanceTo(Yg);
                            Qe.setAttribute("lineDistance", new Float32BufferAttribute(Wn, 1));
                        } else console.warn("THREE.LineSegments.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
                        return this;
                    }
                }
                class VideoTexture extends Texture {
                    constructor(Qe, rt, Wn, Co, Dl, Ll, Rl, Ul, Gl){
                        super(Qe, rt, Wn, Co, Dl, Ll, Rl, Ul, Gl), this.isVideoTexture = !0, this.minFilter = void 0 !== Ll ? Ll : Ud, this.magFilter = void 0 !== Dl ? Dl : Ud, this.generateMipmaps = !1;
                        const Zl = this;
                        "requestVideoFrameCallback" in Qe && Qe.requestVideoFrameCallback(function updateVideo() {
                            Zl.needsUpdate = !0, Qe.requestVideoFrameCallback(updateVideo);
                        });
                    }
                    clone() {
                        return new this.constructor(this.image).copy(this);
                    }
                    update() {
                        const Qe = this.image;
                        !1 === "requestVideoFrameCallback" in Qe && Qe.readyState >= Qe.HAVE_CURRENT_DATA && (this.needsUpdate = !0);
                    }
                }
                class DepthTexture extends Texture {
                    constructor(Qe, rt, Wn, Co, Dl, Ll, Rl, Ul, Gl, Zl){
                        if (void 0 === Zl && (Zl = wp), Zl !== wp && Zl !== Ep) throw new Error("DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat");
                        void 0 === Wn && Zl === wp && (Wn = Qd), void 0 === Wn && Zl === Ep && (Wn = up), super(null, Co, Dl, Ll, Rl, Ul, Zl, Wn, Gl), this.isDepthTexture = !0, this.image = {
                            width: Qe,
                            height: rt
                        }, this.magFilter = void 0 !== Rl ? Rl : Od, this.minFilter = void 0 !== Ul ? Ul : Od, this.flipY = !1, this.generateMipmaps = !1, this.compareFunction = null;
                    }
                    copy(Qe) {
                        return super.copy(Qe), this.compareFunction = Qe.compareFunction, this;
                    }
                    toJSON(Qe) {
                        const rt = super.toJSON(Qe);
                        return null !== this.compareFunction && (rt.compareFunction = this.compareFunction), rt;
                    }
                }
                class PlaneGeometry extends BufferGeometry {
                    constructor(Qe, rt, Wn, Co){
                        void 0 === Qe && (Qe = 1), void 0 === rt && (rt = 1), void 0 === Wn && (Wn = 1), void 0 === Co && (Co = 1), super(), this.type = "PlaneGeometry", this.parameters = {
                            width: Qe,
                            height: rt,
                            widthSegments: Wn,
                            heightSegments: Co
                        };
                        const Dl = Qe / 2, Ll = rt / 2, Rl = Math.floor(Wn), Ul = Math.floor(Co), Gl = Rl + 1, Zl = Ul + 1, Hl = Qe / Rl, ql = rt / Ul, Ql = [], Kl = [], $l = [], Tc = [];
                        for(let tu = 0; tu < Zl; tu++){
                            const Qe = tu * ql - Ll;
                            for(let rt = 0; rt < Gl; rt++){
                                const Wn = rt * Hl - Dl;
                                Kl.push(Wn, -Qe, 0), $l.push(0, 0, 1), Tc.push(rt / Rl), Tc.push(1 - tu / Ul);
                            }
                        }
                        for(let tu = 0; tu < Ul; tu++)for(let Qe = 0; Qe < Rl; Qe++){
                            const rt = Qe + Gl * tu, Wn = Qe + Gl * (tu + 1), Co = Qe + 1 + Gl * (tu + 1), Dl = Qe + 1 + Gl * tu;
                            Ql.push(rt, Wn, Dl), Ql.push(Wn, Co, Dl);
                        }
                        this.setIndex(Ql), this.setAttribute("position", new Float32BufferAttribute(Kl, 3)), this.setAttribute("normal", new Float32BufferAttribute($l, 3)), this.setAttribute("uv", new Float32BufferAttribute(Tc, 2));
                    }
                    copy(Qe) {
                        return super.copy(Qe), this.parameters = Object.assign({}, Qe.parameters), this;
                    }
                    static fromJSON(Qe) {
                        return new PlaneGeometry(Qe.width, Qe.height, Qe.widthSegments, Qe.heightSegments);
                    }
                }
                class SphereGeometry extends BufferGeometry {
                    constructor(Qe, rt, Wn, Co, Dl, Ll, Rl){
                        void 0 === Qe && (Qe = 1), void 0 === rt && (rt = 32), void 0 === Wn && (Wn = 16), void 0 === Co && (Co = 0), void 0 === Dl && (Dl = 2 * Math.PI), void 0 === Ll && (Ll = 0), void 0 === Rl && (Rl = Math.PI), super(), this.type = "SphereGeometry", this.parameters = {
                            radius: Qe,
                            widthSegments: rt,
                            heightSegments: Wn,
                            phiStart: Co,
                            phiLength: Dl,
                            thetaStart: Ll,
                            thetaLength: Rl
                        }, rt = Math.max(3, Math.floor(rt)), Wn = Math.max(2, Math.floor(Wn));
                        const Ul = Math.min(Ll + Rl, Math.PI);
                        let Gl = 0;
                        const Zl = [], Hl = new Vector3, ql = new Vector3, Ql = [], Kl = [], $l = [], Tc = [];
                        for(let tu = 0; tu <= Wn; tu++){
                            const Ql = [], lu = tu / Wn;
                            let du = 0;
                            0 === tu && 0 === Ll ? du = .5 / rt : tu === Wn && Ul === Math.PI && (du = -0.5 / rt);
                            for(let Wn = 0; Wn <= rt; Wn++){
                                const Ul = Wn / rt;
                                Hl.x = -Qe * Math.cos(Co + Ul * Dl) * Math.sin(Ll + lu * Rl), Hl.y = Qe * Math.cos(Ll + lu * Rl), Hl.z = Qe * Math.sin(Co + Ul * Dl) * Math.sin(Ll + lu * Rl), Kl.push(Hl.x, Hl.y, Hl.z), ql.copy(Hl).normalize(), $l.push(ql.x, ql.y, ql.z), Tc.push(Ul + du, 1 - lu), Ql.push(Gl++);
                            }
                            Zl.push(Ql);
                        }
                        for(let tu = 0; tu < Wn; tu++)for(let Qe = 0; Qe < rt; Qe++){
                            const rt = Zl[tu][Qe + 1], Co = Zl[tu][Qe], Dl = Zl[tu + 1][Qe], Rl = Zl[tu + 1][Qe + 1];
                            (0 !== tu || Ll > 0) && Ql.push(rt, Co, Rl), (tu !== Wn - 1 || Ul < Math.PI) && Ql.push(Co, Dl, Rl);
                        }
                        this.setIndex(Ql), this.setAttribute("position", new Float32BufferAttribute(Kl, 3)), this.setAttribute("normal", new Float32BufferAttribute($l, 3)), this.setAttribute("uv", new Float32BufferAttribute(Tc, 2));
                    }
                    copy(Qe) {
                        return super.copy(Qe), this.parameters = Object.assign({}, Qe.parameters), this;
                    }
                    static fromJSON(Qe) {
                        return new SphereGeometry(Qe.radius, Qe.widthSegments, Qe.heightSegments, Qe.phiStart, Qe.phiLength, Qe.thetaStart, Qe.thetaLength);
                    }
                }
                class WireframeGeometry extends BufferGeometry {
                    constructor(Qe){
                        if (void 0 === Qe && (Qe = null), super(), this.type = "WireframeGeometry", this.parameters = {
                            geometry: Qe
                        }, null !== Qe) {
                            const rt = [], Wn = new Set, Co = new Vector3, Dl = new Vector3;
                            if (null !== Qe.index) {
                                const Ll = Qe.attributes.position, Rl = Qe.index;
                                let Ul = Qe.groups;
                                0 === Ul.length && (Ul = [
                                    {
                                        start: 0,
                                        count: Rl.count,
                                        materialIndex: 0
                                    }
                                ]);
                                for(let Qe = 0, Gl = Ul.length; Qe < Gl; ++Qe){
                                    const Gl = Ul[Qe], Zl = Gl.start;
                                    for(let Qe = Zl, Ul = Zl + Gl.count; Qe < Ul; Qe += 3)for(let Gl = 0; Gl < 3; Gl++){
                                        const Ul = Rl.getX(Qe + Gl), Zl = Rl.getX(Qe + (Gl + 1) % 3);
                                        Co.fromBufferAttribute(Ll, Ul), Dl.fromBufferAttribute(Ll, Zl), !0 === isUniqueEdge(Co, Dl, Wn) && (rt.push(Co.x, Co.y, Co.z), rt.push(Dl.x, Dl.y, Dl.z));
                                    }
                                }
                            } else {
                                const Ll = Qe.attributes.position;
                                for(let Qe = 0, Rl = Ll.count / 3; Qe < Rl; Qe++)for(let Ul = 0; Ul < 3; Ul++){
                                    const Rl = 3 * Qe + Ul, Gl = 3 * Qe + (Ul + 1) % 3;
                                    Co.fromBufferAttribute(Ll, Rl), Dl.fromBufferAttribute(Ll, Gl), !0 === isUniqueEdge(Co, Dl, Wn) && (rt.push(Co.x, Co.y, Co.z), rt.push(Dl.x, Dl.y, Dl.z));
                                }
                            }
                            this.setAttribute("position", new Float32BufferAttribute(rt, 3));
                        }
                    }
                    copy(Qe) {
                        return super.copy(Qe), this.parameters = Object.assign({}, Qe.parameters), this;
                    }
                }
                function isUniqueEdge(Qe, rt, Wn) {
                    const Co = `${Qe.x},${Qe.y},${Qe.z}-${rt.x},${rt.y},${rt.z}`, Dl = `${rt.x},${rt.y},${rt.z}-${Qe.x},${Qe.y},${Qe.z}`;
                    return !0 !== Wn.has(Co) && !0 !== Wn.has(Dl) && (Wn.add(Co), Wn.add(Dl), !0);
                }
                class MeshDepthMaterial extends Material {
                    constructor(Qe){
                        super(), this.isMeshDepthMaterial = !0, this.type = "MeshDepthMaterial", this.depthPacking = 3200, this.map = null, this.alphaMap = null, this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.wireframe = !1, this.wireframeLinewidth = 1, this.setValues(Qe);
                    }
                    copy(Qe) {
                        return super.copy(Qe), this.depthPacking = Qe.depthPacking, this.map = Qe.map, this.alphaMap = Qe.alphaMap, this.displacementMap = Qe.displacementMap, this.displacementScale = Qe.displacementScale, this.displacementBias = Qe.displacementBias, this.wireframe = Qe.wireframe, this.wireframeLinewidth = Qe.wireframeLinewidth, this;
                    }
                }
                class MeshDistanceMaterial extends Material {
                    constructor(Qe){
                        super(), this.isMeshDistanceMaterial = !0, this.type = "MeshDistanceMaterial", this.map = null, this.alphaMap = null, this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.setValues(Qe);
                    }
                    copy(Qe) {
                        return super.copy(Qe), this.map = Qe.map, this.alphaMap = Qe.alphaMap, this.displacementMap = Qe.displacementMap, this.displacementScale = Qe.displacementScale, this.displacementBias = Qe.displacementBias, this;
                    }
                }
                function convertArray(Qe, rt, Wn) {
                    return !Qe || !Wn && Qe.constructor === rt ? Qe : "number" === typeof rt.BYTES_PER_ELEMENT ? new rt(Qe) : Array.prototype.slice.call(Qe);
                }
                function isTypedArray(Qe) {
                    return ArrayBuffer.isView(Qe) && !(Qe instanceof DataView);
                }
                class Interpolant {
                    constructor(Qe, rt, Wn, Co){
                        this.parameterPositions = Qe, this._cachedIndex = 0, this.resultBuffer = void 0 !== Co ? Co : new rt.constructor(Wn), this.sampleValues = rt, this.valueSize = Wn, this.settings = null, this.DefaultSettings_ = {};
                    }
                    evaluate(Qe) {
                        const rt = this.parameterPositions;
                        let Wn = this._cachedIndex, Co = rt[Wn], Dl = rt[Wn - 1];
                        e: {
                            t: {
                                let Ll;
                                i: {
                                    n: if (!(Qe < Co)) {
                                        for(let Ll = Wn + 2;;){
                                            if (void 0 === Co) {
                                                if (Qe < Dl) break n;
                                                return Wn = rt.length, this._cachedIndex = Wn, this.copySampleValue_(Wn - 1);
                                            }
                                            if (Wn === Ll) break;
                                            if (Dl = Co, Co = rt[++Wn], Qe < Co) break t;
                                        }
                                        Ll = rt.length;
                                        break i;
                                    }
                                    if (Qe >= Dl) break e;
                                    {
                                        const Rl = rt[1];
                                        Qe < Rl && (Wn = 2, Dl = Rl);
                                        for(let Ll = Wn - 2;;){
                                            if (void 0 === Dl) return this._cachedIndex = 0, this.copySampleValue_(0);
                                            if (Wn === Ll) break;
                                            if (Co = Dl, Dl = rt[--Wn - 1], Qe >= Dl) break t;
                                        }
                                        Ll = Wn, Wn = 0;
                                    }
                                }
                                for(; Wn < Ll;){
                                    const Co = Wn + Ll >>> 1;
                                    Qe < rt[Co] ? Ll = Co : Wn = Co + 1;
                                }
                                if (Co = rt[Wn], Dl = rt[Wn - 1], void 0 === Dl) return this._cachedIndex = 0, this.copySampleValue_(0);
                                if (void 0 === Co) return Wn = rt.length, this._cachedIndex = Wn, this.copySampleValue_(Wn - 1);
                            }
                            this._cachedIndex = Wn, this.intervalChanged_(Wn, Dl, Co);
                        }
                        return this.interpolate_(Wn, Dl, Qe, Co);
                    }
                    getSettings_() {
                        return this.settings || this.DefaultSettings_;
                    }
                    copySampleValue_(Qe) {
                        const rt = this.resultBuffer, Wn = this.sampleValues, Co = this.valueSize, Dl = Qe * Co;
                        for(let Ll = 0; Ll !== Co; ++Ll)rt[Ll] = Wn[Dl + Ll];
                        return rt;
                    }
                    interpolate_() {
                        throw new Error("call to abstract method");
                    }
                    intervalChanged_() {}
                }
                class CubicInterpolant extends Interpolant {
                    constructor(Qe, rt, Wn, Co){
                        super(Qe, rt, Wn, Co), this._weightPrev = -0, this._offsetPrev = -0, this._weightNext = -0, this._offsetNext = -0, this.DefaultSettings_ = {
                            endingStart: hm,
                            endingEnd: hm
                        };
                    }
                    intervalChanged_(Qe, rt, Wn) {
                        const Co = this.parameterPositions;
                        let Dl = Qe - 2, Ll = Qe + 1, Rl = Co[Dl], Ul = Co[Ll];
                        if (void 0 === Rl) switch(this.getSettings_().endingStart){
                            case dm:
                                Dl = Qe, Rl = 2 * rt - Wn;
                                break;
                            case pm:
                                Dl = Co.length - 2, Rl = rt + Co[Dl] - Co[Dl + 1];
                                break;
                            default:
                                Dl = Qe, Rl = Wn;
                        }
                        if (void 0 === Ul) switch(this.getSettings_().endingEnd){
                            case dm:
                                Ll = Qe, Ul = 2 * Wn - rt;
                                break;
                            case pm:
                                Ll = 1, Ul = Wn + Co[1] - Co[0];
                                break;
                            default:
                                Ll = Qe - 1, Ul = rt;
                        }
                        const Gl = .5 * (Wn - rt), Zl = this.valueSize;
                        this._weightPrev = Gl / (rt - Rl), this._weightNext = Gl / (Ul - Wn), this._offsetPrev = Dl * Zl, this._offsetNext = Ll * Zl;
                    }
                    interpolate_(Qe, rt, Wn, Co) {
                        const Dl = this.resultBuffer, Ll = this.sampleValues, Rl = this.valueSize, Ul = Qe * Rl, Gl = Ul - Rl, Zl = this._offsetPrev, Hl = this._offsetNext, ql = this._weightPrev, Ql = this._weightNext, Kl = (Wn - rt) / (Co - rt), $l = Kl * Kl, Tc = $l * Kl, tu = -ql * Tc + 2 * ql * $l - ql * Kl, lu = (1 + ql) * Tc + (-1.5 - 2 * ql) * $l + (-0.5 + ql) * Kl + 1, du = (-1 - Ql) * Tc + (1.5 + Ql) * $l + .5 * Kl, fu = Ql * Tc - Ql * $l;
                        for(let yu = 0; yu !== Rl; ++yu)Dl[yu] = tu * Ll[Zl + yu] + lu * Ll[Gl + yu] + du * Ll[Ul + yu] + fu * Ll[Hl + yu];
                        return Dl;
                    }
                }
                class LinearInterpolant extends Interpolant {
                    constructor(Qe, rt, Wn, Co){
                        super(Qe, rt, Wn, Co);
                    }
                    interpolate_(Qe, rt, Wn, Co) {
                        const Dl = this.resultBuffer, Ll = this.sampleValues, Rl = this.valueSize, Ul = Qe * Rl, Gl = Ul - Rl, Zl = (Wn - rt) / (Co - rt), Hl = 1 - Zl;
                        for(let ql = 0; ql !== Rl; ++ql)Dl[ql] = Ll[Gl + ql] * Hl + Ll[Ul + ql] * Zl;
                        return Dl;
                    }
                }
                class DiscreteInterpolant extends Interpolant {
                    constructor(Qe, rt, Wn, Co){
                        super(Qe, rt, Wn, Co);
                    }
                    interpolate_(Qe) {
                        return this.copySampleValue_(Qe - 1);
                    }
                }
                class KeyframeTrack {
                    constructor(Qe, rt, Wn, Co){
                        if (void 0 === Qe) throw new Error("THREE.KeyframeTrack: track name is undefined");
                        if (void 0 === rt || 0 === rt.length) throw new Error("THREE.KeyframeTrack: no keyframes in track named " + Qe);
                        this.name = Qe, this.times = convertArray(rt, this.TimeBufferType), this.values = convertArray(Wn, this.ValueBufferType), this.setInterpolation(Co || this.DefaultInterpolation);
                    }
                    static toJSON(Qe) {
                        const rt = Qe.constructor;
                        let Wn;
                        if (rt.toJSON !== this.toJSON) Wn = rt.toJSON(Qe);
                        else {
                            Wn = {
                                name: Qe.name,
                                times: convertArray(Qe.times, Array),
                                values: convertArray(Qe.values, Array)
                            };
                            const rt = Qe.getInterpolation();
                            rt !== Qe.DefaultInterpolation && (Wn.interpolation = rt);
                        }
                        return Wn.type = Qe.ValueTypeName, Wn;
                    }
                    InterpolantFactoryMethodDiscrete(Qe) {
                        return new DiscreteInterpolant(this.times, this.values, this.getValueSize(), Qe);
                    }
                    InterpolantFactoryMethodLinear(Qe) {
                        return new LinearInterpolant(this.times, this.values, this.getValueSize(), Qe);
                    }
                    InterpolantFactoryMethodSmooth(Qe) {
                        return new CubicInterpolant(this.times, this.values, this.getValueSize(), Qe);
                    }
                    setInterpolation(Qe) {
                        let rt;
                        switch(Qe){
                            case lm:
                                rt = this.InterpolantFactoryMethodDiscrete;
                                break;
                            case cm:
                                rt = this.InterpolantFactoryMethodLinear;
                                break;
                            case um:
                                rt = this.InterpolantFactoryMethodSmooth;
                        }
                        if (void 0 === rt) {
                            const rt = "unsupported interpolation for " + this.ValueTypeName + " keyframe track named " + this.name;
                            if (void 0 === this.createInterpolant) {
                                if (Qe === this.DefaultInterpolation) throw new Error(rt);
                                this.setInterpolation(this.DefaultInterpolation);
                            }
                            return console.warn("THREE.KeyframeTrack:", rt), this;
                        }
                        return this.createInterpolant = rt, this;
                    }
                    getInterpolation() {
                        switch(this.createInterpolant){
                            case this.InterpolantFactoryMethodDiscrete:
                                return lm;
                            case this.InterpolantFactoryMethodLinear:
                                return cm;
                            case this.InterpolantFactoryMethodSmooth:
                                return um;
                        }
                    }
                    getValueSize() {
                        return this.values.length / this.times.length;
                    }
                    shift(Qe) {
                        if (0 !== Qe) {
                            const rt = this.times;
                            for(let Wn = 0, Co = rt.length; Wn !== Co; ++Wn)rt[Wn] += Qe;
                        }
                        return this;
                    }
                    scale(Qe) {
                        if (1 !== Qe) {
                            const rt = this.times;
                            for(let Wn = 0, Co = rt.length; Wn !== Co; ++Wn)rt[Wn] *= Qe;
                        }
                        return this;
                    }
                    trim(Qe, rt) {
                        const Wn = this.times, Co = Wn.length;
                        let Dl = 0, Ll = Co - 1;
                        for(; Dl !== Co && Wn[Dl] < Qe;)++Dl;
                        for(; -1 !== Ll && Wn[Ll] > rt;)--Ll;
                        if (++Ll, 0 !== Dl || Ll !== Co) {
                            Dl >= Ll && (Ll = Math.max(Ll, 1), Dl = Ll - 1);
                            const Qe = this.getValueSize();
                            this.times = Wn.slice(Dl, Ll), this.values = this.values.slice(Dl * Qe, Ll * Qe);
                        }
                        return this;
                    }
                    validate() {
                        let Qe = !0;
                        const rt = this.getValueSize();
                        rt - Math.floor(rt) !== 0 && (console.error("THREE.KeyframeTrack: Invalid value size in track.", this), Qe = !1);
                        const Wn = this.times, Co = this.values, Dl = Wn.length;
                        0 === Dl && (console.error("THREE.KeyframeTrack: Track is empty.", this), Qe = !1);
                        let Ll = null;
                        for(let Rl = 0; Rl !== Dl; Rl++){
                            const rt = Wn[Rl];
                            if ("number" === typeof rt && isNaN(rt)) {
                                console.error("THREE.KeyframeTrack: Time is not a valid number.", this, Rl, rt), Qe = !1;
                                break;
                            }
                            if (null !== Ll && Ll > rt) {
                                console.error("THREE.KeyframeTrack: Out of order keys.", this, Rl, rt, Ll), Qe = !1;
                                break;
                            }
                            Ll = rt;
                        }
                        if (void 0 !== Co && isTypedArray(Co)) for(let Rl = 0, Ul = Co.length; Rl !== Ul; ++Rl){
                            const rt = Co[Rl];
                            if (isNaN(rt)) {
                                console.error("THREE.KeyframeTrack: Value is not a valid number.", this, Rl, rt), Qe = !1;
                                break;
                            }
                        }
                        return Qe;
                    }
                    optimize() {
                        const Qe = this.times.slice(), rt = this.values.slice(), Wn = this.getValueSize(), Co = this.getInterpolation() === um, Dl = Qe.length - 1;
                        let Ll = 1;
                        for(let Rl = 1; Rl < Dl; ++Rl){
                            let Dl = !1;
                            const Ul = Qe[Rl];
                            if (Ul !== Qe[Rl + 1] && (1 !== Rl || Ul !== Qe[0])) {
                                if (Co) Dl = !0;
                                else {
                                    const Qe = Rl * Wn, Co = Qe - Wn, Ll = Qe + Wn;
                                    for(let Rl = 0; Rl !== Wn; ++Rl){
                                        const Wn = rt[Qe + Rl];
                                        if (Wn !== rt[Co + Rl] || Wn !== rt[Ll + Rl]) {
                                            Dl = !0;
                                            break;
                                        }
                                    }
                                }
                            }
                            if (Dl) {
                                if (Rl !== Ll) {
                                    Qe[Ll] = Qe[Rl];
                                    const Co = Rl * Wn, Dl = Ll * Wn;
                                    for(let Qe = 0; Qe !== Wn; ++Qe)rt[Dl + Qe] = rt[Co + Qe];
                                }
                                ++Ll;
                            }
                        }
                        if (Dl > 0) {
                            Qe[Ll] = Qe[Dl];
                            for(let Qe = Dl * Wn, Co = Ll * Wn, Rl = 0; Rl !== Wn; ++Rl)rt[Co + Rl] = rt[Qe + Rl];
                            ++Ll;
                        }
                        return Ll !== Qe.length ? (this.times = Qe.slice(0, Ll), this.values = rt.slice(0, Ll * Wn)) : (this.times = Qe, this.values = rt), this;
                    }
                    clone() {
                        const Qe = this.times.slice(), rt = this.values.slice(), Wn = new this.constructor(this.name, Qe, rt);
                        return Wn.createInterpolant = this.createInterpolant, Wn;
                    }
                }
                KeyframeTrack.prototype.TimeBufferType = Float32Array, KeyframeTrack.prototype.ValueBufferType = Float32Array, KeyframeTrack.prototype.DefaultInterpolation = cm;
                class BooleanKeyframeTrack extends KeyframeTrack {
                    constructor(Qe, rt, Wn){
                        super(Qe, rt, Wn);
                    }
                }
                BooleanKeyframeTrack.prototype.ValueTypeName = "bool", BooleanKeyframeTrack.prototype.ValueBufferType = Array, BooleanKeyframeTrack.prototype.DefaultInterpolation = lm, BooleanKeyframeTrack.prototype.InterpolantFactoryMethodLinear = void 0, BooleanKeyframeTrack.prototype.InterpolantFactoryMethodSmooth = void 0;
                class ColorKeyframeTrack extends KeyframeTrack {
                }
                ColorKeyframeTrack.prototype.ValueTypeName = "color";
                class NumberKeyframeTrack extends KeyframeTrack {
                }
                NumberKeyframeTrack.prototype.ValueTypeName = "number";
                class QuaternionLinearInterpolant extends Interpolant {
                    constructor(Qe, rt, Wn, Co){
                        super(Qe, rt, Wn, Co);
                    }
                    interpolate_(Qe, rt, Wn, Co) {
                        const Dl = this.resultBuffer, Ll = this.sampleValues, Rl = this.valueSize, Ul = (Wn - rt) / (Co - rt);
                        let Gl = Qe * Rl;
                        for(let Zl = Gl + Rl; Gl !== Zl; Gl += 4)Quaternion.slerpFlat(Dl, 0, Ll, Gl - Rl, Ll, Gl, Ul);
                        return Dl;
                    }
                }
                class QuaternionKeyframeTrack extends KeyframeTrack {
                    InterpolantFactoryMethodLinear(Qe) {
                        return new QuaternionLinearInterpolant(this.times, this.values, this.getValueSize(), Qe);
                    }
                }
                QuaternionKeyframeTrack.prototype.ValueTypeName = "quaternion", QuaternionKeyframeTrack.prototype.InterpolantFactoryMethodSmooth = void 0;
                class StringKeyframeTrack extends KeyframeTrack {
                    constructor(Qe, rt, Wn){
                        super(Qe, rt, Wn);
                    }
                }
                StringKeyframeTrack.prototype.ValueTypeName = "string", StringKeyframeTrack.prototype.ValueBufferType = Array, StringKeyframeTrack.prototype.DefaultInterpolation = lm, StringKeyframeTrack.prototype.InterpolantFactoryMethodLinear = void 0, StringKeyframeTrack.prototype.InterpolantFactoryMethodSmooth = void 0;
                class VectorKeyframeTrack extends KeyframeTrack {
                }
                VectorKeyframeTrack.prototype.ValueTypeName = "vector";
                const Qg = {
                    enabled: !1,
                    files: {},
                    add: function(Qe, rt) {
                        !1 !== this.enabled && (this.files[Qe] = rt);
                    },
                    get: function(Qe) {
                        if (!1 !== this.enabled) return this.files[Qe];
                    },
                    remove: function(Qe) {
                        delete this.files[Qe];
                    },
                    clear: function() {
                        this.files = {};
                    }
                };
                class LoadingManager {
                    constructor(Qe, rt, Wn){
                        const Co = this;
                        let Dl, Ll = !1, Rl = 0, Ul = 0;
                        const Gl = [];
                        this.onStart = void 0, this.onLoad = Qe, this.onProgress = rt, this.onError = Wn, this.itemStart = function(Qe) {
                            Ul++, !1 === Ll && void 0 !== Co.onStart && Co.onStart(Qe, Rl, Ul), Ll = !0;
                        }, this.itemEnd = function(Qe) {
                            Rl++, void 0 !== Co.onProgress && Co.onProgress(Qe, Rl, Ul), Rl === Ul && (Ll = !1, void 0 !== Co.onLoad && Co.onLoad());
                        }, this.itemError = function(Qe) {
                            void 0 !== Co.onError && Co.onError(Qe);
                        }, this.resolveURL = function(Qe) {
                            return Dl ? Dl(Qe) : Qe;
                        }, this.setURLModifier = function(Qe) {
                            return Dl = Qe, this;
                        }, this.addHandler = function(Qe, rt) {
                            return Gl.push(Qe, rt), this;
                        }, this.removeHandler = function(Qe) {
                            const rt = Gl.indexOf(Qe);
                            return -1 !== rt && Gl.splice(rt, 2), this;
                        }, this.getHandler = function(Qe) {
                            for(let rt = 0, Wn = Gl.length; rt < Wn; rt += 2){
                                const Wn = Gl[rt], Co = Gl[rt + 1];
                                if (Wn.global && (Wn.lastIndex = 0), Wn.test(Qe)) return Co;
                            }
                            return null;
                        };
                    }
                }
                const Kg = new LoadingManager;
                class Loader {
                    constructor(Qe){
                        this.manager = void 0 !== Qe ? Qe : Kg, this.crossOrigin = "anonymous", this.withCredentials = !1, this.path = "", this.resourcePath = "", this.requestHeader = {};
                    }
                    load() {}
                    loadAsync(Qe, rt) {
                        const Wn = this;
                        return new Promise(function(Co, Dl) {
                            Wn.load(Qe, Co, rt, Dl);
                        });
                    }
                    parse() {}
                    setCrossOrigin(Qe) {
                        return this.crossOrigin = Qe, this;
                    }
                    setWithCredentials(Qe) {
                        return this.withCredentials = Qe, this;
                    }
                    setPath(Qe) {
                        return this.path = Qe, this;
                    }
                    setResourcePath(Qe) {
                        return this.resourcePath = Qe, this;
                    }
                    setRequestHeader(Qe) {
                        return this.requestHeader = Qe, this;
                    }
                }
                Loader.DEFAULT_MATERIAL_NAME = "__DEFAULT";
                Error;
                class OrthographicCamera extends Camera {
                    constructor(Qe, rt, Wn, Co, Dl, Ll){
                        void 0 === Qe && (Qe = -1), void 0 === rt && (rt = 1), void 0 === Wn && (Wn = 1), void 0 === Co && (Co = -1), void 0 === Dl && (Dl = .1), void 0 === Ll && (Ll = 2e3), super(), this.isOrthographicCamera = !0, this.type = "OrthographicCamera", this.zoom = 1, this.view = null, this.left = Qe, this.right = rt, this.top = Wn, this.bottom = Co, this.near = Dl, this.far = Ll, this.updateProjectionMatrix();
                    }
                    copy(Qe, rt) {
                        return super.copy(Qe, rt), this.left = Qe.left, this.right = Qe.right, this.top = Qe.top, this.bottom = Qe.bottom, this.near = Qe.near, this.far = Qe.far, this.zoom = Qe.zoom, this.view = null === Qe.view ? null : Object.assign({}, Qe.view), this;
                    }
                    setViewOffset(Qe, rt, Wn, Co, Dl, Ll) {
                        null === this.view && (this.view = {
                            enabled: !0,
                            fullWidth: 1,
                            fullHeight: 1,
                            offsetX: 0,
                            offsetY: 0,
                            width: 1,
                            height: 1
                        }), this.view.enabled = !0, this.view.fullWidth = Qe, this.view.fullHeight = rt, this.view.offsetX = Wn, this.view.offsetY = Co, this.view.width = Dl, this.view.height = Ll, this.updateProjectionMatrix();
                    }
                    clearViewOffset() {
                        null !== this.view && (this.view.enabled = !1), this.updateProjectionMatrix();
                    }
                    updateProjectionMatrix() {
                        const Qe = (this.right - this.left) / (2 * this.zoom), rt = (this.top - this.bottom) / (2 * this.zoom), Wn = (this.right + this.left) / 2, Co = (this.top + this.bottom) / 2;
                        let Dl = Wn - Qe, Ll = Wn + Qe, Rl = Co + rt, Ul = Co - rt;
                        if (null !== this.view && this.view.enabled) {
                            const Qe = (this.right - this.left) / this.view.fullWidth / this.zoom, rt = (this.top - this.bottom) / this.view.fullHeight / this.zoom;
                            Dl += Qe * this.view.offsetX, Ll = Dl + Qe * this.view.width, Rl -= rt * this.view.offsetY, Ul = Rl - rt * this.view.height;
                        }
                        this.projectionMatrix.makeOrthographic(Dl, Ll, Rl, Ul, this.near, this.far, this.coordinateSystem), this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
                    }
                    toJSON(Qe) {
                        const rt = super.toJSON(Qe);
                        return rt.object.zoom = this.zoom, rt.object.left = this.left, rt.object.right = this.right, rt.object.top = this.top, rt.object.bottom = this.bottom, rt.object.near = this.near, rt.object.far = this.far, null !== this.view && (rt.object.view = Object.assign({}, this.view)), rt;
                    }
                }
                class ArrayCamera extends PerspectiveCamera {
                    constructor(Qe){
                        void 0 === Qe && (Qe = []), super(), this.isArrayCamera = !0, this.cameras = Qe, this.index = 0;
                    }
                }
                const Xg = "\\[\\]\\.:\\/", Jg = new RegExp("[" + Xg + "]", "g"), $g = "[^" + Xg + "]", eA = "[^" + Xg.replace("\\.", "") + "]", tA = new RegExp("^" + /((?:WC+[\/:])*)/.source.replace("WC", $g) + /(WCOD+)?/.source.replace("WCOD", eA) + /(?:\.(WC+)(?:\[(.+)\])?)?/.source.replace("WC", $g) + /\.(WC+)(?:\[(.+)\])?/.source.replace("WC", $g) + "$"), iA = [
                    "material",
                    "materials",
                    "bones",
                    "map"
                ];
                class PropertyBinding {
                    constructor(Qe, rt, Wn){
                        this.path = rt, this.parsedPath = Wn || PropertyBinding.parseTrackName(rt), this.node = PropertyBinding.findNode(Qe, this.parsedPath.nodeName), this.rootNode = Qe, this.getValue = this._getValue_unbound, this.setValue = this._setValue_unbound;
                    }
                    static create(Qe, rt, Wn) {
                        return Qe && Qe.isAnimationObjectGroup ? new PropertyBinding.Composite(Qe, rt, Wn) : new PropertyBinding(Qe, rt, Wn);
                    }
                    static sanitizeNodeName(Qe) {
                        return Qe.replace(/\s/g, "_").replace(Jg, "");
                    }
                    static parseTrackName(Qe) {
                        const rt = tA.exec(Qe);
                        if (null === rt) throw new Error("PropertyBinding: Cannot parse trackName: " + Qe);
                        const Wn = {
                            nodeName: rt[2],
                            objectName: rt[3],
                            objectIndex: rt[4],
                            propertyName: rt[5],
                            propertyIndex: rt[6]
                        }, Co = Wn.nodeName && Wn.nodeName.lastIndexOf(".");
                        if (void 0 !== Co && -1 !== Co) {
                            const Qe = Wn.nodeName.substring(Co + 1);
                            -1 !== iA.indexOf(Qe) && (Wn.nodeName = Wn.nodeName.substring(0, Co), Wn.objectName = Qe);
                        }
                        if (null === Wn.propertyName || 0 === Wn.propertyName.length) throw new Error("PropertyBinding: can not parse propertyName from trackName: " + Qe);
                        return Wn;
                    }
                    static findNode(Qe, rt) {
                        if (void 0 === rt || "" === rt || "." === rt || -1 === rt || rt === Qe.name || rt === Qe.uuid) return Qe;
                        if (Qe.skeleton) {
                            const Wn = Qe.skeleton.getBoneByName(rt);
                            if (void 0 !== Wn) return Wn;
                        }
                        if (Qe.children) {
                            const searchNodeSubtree = function(Qe) {
                                for(let Wn = 0; Wn < Qe.length; Wn++){
                                    const Co = Qe[Wn];
                                    if (Co.name === rt || Co.uuid === rt) return Co;
                                    const Dl = searchNodeSubtree(Co.children);
                                    if (Dl) return Dl;
                                }
                                return null;
                            }, Wn = searchNodeSubtree(Qe.children);
                            if (Wn) return Wn;
                        }
                        return null;
                    }
                    _getValue_unavailable() {}
                    _setValue_unavailable() {}
                    _getValue_direct(Qe, rt) {
                        Qe[rt] = this.targetObject[this.propertyName];
                    }
                    _getValue_array(Qe, rt) {
                        const Wn = this.resolvedProperty;
                        for(let Co = 0, Dl = Wn.length; Co !== Dl; ++Co)Qe[rt++] = Wn[Co];
                    }
                    _getValue_arrayElement(Qe, rt) {
                        Qe[rt] = this.resolvedProperty[this.propertyIndex];
                    }
                    _getValue_toArray(Qe, rt) {
                        this.resolvedProperty.toArray(Qe, rt);
                    }
                    _setValue_direct(Qe, rt) {
                        this.targetObject[this.propertyName] = Qe[rt];
                    }
                    _setValue_direct_setNeedsUpdate(Qe, rt) {
                        this.targetObject[this.propertyName] = Qe[rt], this.targetObject.needsUpdate = !0;
                    }
                    _setValue_direct_setMatrixWorldNeedsUpdate(Qe, rt) {
                        this.targetObject[this.propertyName] = Qe[rt], this.targetObject.matrixWorldNeedsUpdate = !0;
                    }
                    _setValue_array(Qe, rt) {
                        const Wn = this.resolvedProperty;
                        for(let Co = 0, Dl = Wn.length; Co !== Dl; ++Co)Wn[Co] = Qe[rt++];
                    }
                    _setValue_array_setNeedsUpdate(Qe, rt) {
                        const Wn = this.resolvedProperty;
                        for(let Co = 0, Dl = Wn.length; Co !== Dl; ++Co)Wn[Co] = Qe[rt++];
                        this.targetObject.needsUpdate = !0;
                    }
                    _setValue_array_setMatrixWorldNeedsUpdate(Qe, rt) {
                        const Wn = this.resolvedProperty;
                        for(let Co = 0, Dl = Wn.length; Co !== Dl; ++Co)Wn[Co] = Qe[rt++];
                        this.targetObject.matrixWorldNeedsUpdate = !0;
                    }
                    _setValue_arrayElement(Qe, rt) {
                        this.resolvedProperty[this.propertyIndex] = Qe[rt];
                    }
                    _setValue_arrayElement_setNeedsUpdate(Qe, rt) {
                        this.resolvedProperty[this.propertyIndex] = Qe[rt], this.targetObject.needsUpdate = !0;
                    }
                    _setValue_arrayElement_setMatrixWorldNeedsUpdate(Qe, rt) {
                        this.resolvedProperty[this.propertyIndex] = Qe[rt], this.targetObject.matrixWorldNeedsUpdate = !0;
                    }
                    _setValue_fromArray(Qe, rt) {
                        this.resolvedProperty.fromArray(Qe, rt);
                    }
                    _setValue_fromArray_setNeedsUpdate(Qe, rt) {
                        this.resolvedProperty.fromArray(Qe, rt), this.targetObject.needsUpdate = !0;
                    }
                    _setValue_fromArray_setMatrixWorldNeedsUpdate(Qe, rt) {
                        this.resolvedProperty.fromArray(Qe, rt), this.targetObject.matrixWorldNeedsUpdate = !0;
                    }
                    _getValue_unbound(Qe, rt) {
                        this.bind(), this.getValue(Qe, rt);
                    }
                    _setValue_unbound(Qe, rt) {
                        this.bind(), this.setValue(Qe, rt);
                    }
                    bind() {
                        let Qe = this.node;
                        const rt = this.parsedPath, Wn = rt.objectName, Co = rt.propertyName;
                        let Dl = rt.propertyIndex;
                        if (Qe || (Qe = PropertyBinding.findNode(this.rootNode, rt.nodeName), this.node = Qe), this.getValue = this._getValue_unavailable, this.setValue = this._setValue_unavailable, !Qe) return void console.warn("THREE.PropertyBinding: No target node found for track: " + this.path + ".");
                        if (Wn) {
                            let Co = rt.objectIndex;
                            switch(Wn){
                                case "materials":
                                    if (!Qe.material) return void console.error("THREE.PropertyBinding: Can not bind to material as node does not have a material.", this);
                                    if (!Qe.material.materials) return void console.error("THREE.PropertyBinding: Can not bind to material.materials as node.material does not have a materials array.", this);
                                    Qe = Qe.material.materials;
                                    break;
                                case "bones":
                                    if (!Qe.skeleton) return void console.error("THREE.PropertyBinding: Can not bind to bones as node does not have a skeleton.", this);
                                    Qe = Qe.skeleton.bones;
                                    for(let rt = 0; rt < Qe.length; rt++)if (Qe[rt].name === Co) {
                                        Co = rt;
                                        break;
                                    }
                                    break;
                                case "map":
                                    if ("map" in Qe) {
                                        Qe = Qe.map;
                                        break;
                                    }
                                    if (!Qe.material) return void console.error("THREE.PropertyBinding: Can not bind to material as node does not have a material.", this);
                                    if (!Qe.material.map) return void console.error("THREE.PropertyBinding: Can not bind to material.map as node.material does not have a map.", this);
                                    Qe = Qe.material.map;
                                    break;
                                default:
                                    if (void 0 === Qe[Wn]) return void console.error("THREE.PropertyBinding: Can not bind to objectName of node undefined.", this);
                                    Qe = Qe[Wn];
                            }
                            if (void 0 !== Co) {
                                if (void 0 === Qe[Co]) return void console.error("THREE.PropertyBinding: Trying to bind to objectIndex of objectName, but is undefined.", this, Qe);
                                Qe = Qe[Co];
                            }
                        }
                        const Ll = Qe[Co];
                        if (void 0 === Ll) {
                            const Wn = rt.nodeName;
                            return void console.error("THREE.PropertyBinding: Trying to update property for track: " + Wn + "." + Co + " but it wasn't found.", Qe);
                        }
                        let Rl = this.Versioning.None;
                        this.targetObject = Qe, !0 === Qe.isMaterial ? Rl = this.Versioning.NeedsUpdate : !0 === Qe.isObject3D && (Rl = this.Versioning.MatrixWorldNeedsUpdate);
                        let Ul = this.BindingType.Direct;
                        if (void 0 !== Dl) {
                            if ("morphTargetInfluences" === Co) {
                                if (!Qe.geometry) return void console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.", this);
                                if (!Qe.geometry.morphAttributes) return void console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphAttributes.", this);
                                void 0 !== Qe.morphTargetDictionary[Dl] && (Dl = Qe.morphTargetDictionary[Dl]);
                            }
                            Ul = this.BindingType.ArrayElement, this.resolvedProperty = Ll, this.propertyIndex = Dl;
                        } else void 0 !== Ll.fromArray && void 0 !== Ll.toArray ? (Ul = this.BindingType.HasFromToArray, this.resolvedProperty = Ll) : Array.isArray(Ll) ? (Ul = this.BindingType.EntireArray, this.resolvedProperty = Ll) : this.propertyName = Co;
                        this.getValue = this.GetterByBindingType[Ul], this.setValue = this.SetterByBindingTypeAndVersioning[Ul][Rl];
                    }
                    unbind() {
                        this.node = null, this.getValue = this._getValue_unbound, this.setValue = this._setValue_unbound;
                    }
                }
                PropertyBinding.Composite = class {
                    constructor(Qe, rt, Wn){
                        const Co = Wn || PropertyBinding.parseTrackName(rt);
                        this._targetGroup = Qe, this._bindings = Qe.subscribe_(rt, Co);
                    }
                    getValue(Qe, rt) {
                        this.bind();
                        const Wn = this._targetGroup.nCachedObjects_, Co = this._bindings[Wn];
                        void 0 !== Co && Co.getValue(Qe, rt);
                    }
                    setValue(Qe, rt) {
                        const Wn = this._bindings;
                        for(let Co = this._targetGroup.nCachedObjects_, Dl = Wn.length; Co !== Dl; ++Co)Wn[Co].setValue(Qe, rt);
                    }
                    bind() {
                        const Qe = this._bindings;
                        for(let rt = this._targetGroup.nCachedObjects_, Wn = Qe.length; rt !== Wn; ++rt)Qe[rt].bind();
                    }
                    unbind() {
                        const Qe = this._bindings;
                        for(let rt = this._targetGroup.nCachedObjects_, Wn = Qe.length; rt !== Wn; ++rt)Qe[rt].unbind();
                    }
                }, PropertyBinding.prototype.BindingType = {
                    Direct: 0,
                    EntireArray: 1,
                    ArrayElement: 2,
                    HasFromToArray: 3
                }, PropertyBinding.prototype.Versioning = {
                    None: 0,
                    NeedsUpdate: 1,
                    MatrixWorldNeedsUpdate: 2
                }, PropertyBinding.prototype.GetterByBindingType = [
                    PropertyBinding.prototype._getValue_direct,
                    PropertyBinding.prototype._getValue_array,
                    PropertyBinding.prototype._getValue_arrayElement,
                    PropertyBinding.prototype._getValue_toArray
                ], PropertyBinding.prototype.SetterByBindingTypeAndVersioning = [
                    [
                        PropertyBinding.prototype._setValue_direct,
                        PropertyBinding.prototype._setValue_direct_setNeedsUpdate,
                        PropertyBinding.prototype._setValue_direct_setMatrixWorldNeedsUpdate
                    ],
                    [
                        PropertyBinding.prototype._setValue_array,
                        PropertyBinding.prototype._setValue_array_setNeedsUpdate,
                        PropertyBinding.prototype._setValue_array_setMatrixWorldNeedsUpdate
                    ],
                    [
                        PropertyBinding.prototype._setValue_arrayElement,
                        PropertyBinding.prototype._setValue_arrayElement_setNeedsUpdate,
                        PropertyBinding.prototype._setValue_arrayElement_setMatrixWorldNeedsUpdate
                    ],
                    [
                        PropertyBinding.prototype._setValue_fromArray,
                        PropertyBinding.prototype._setValue_fromArray_setNeedsUpdate,
                        PropertyBinding.prototype._setValue_fromArray_setMatrixWorldNeedsUpdate
                    ]
                ];
                new Float32Array(1);
                const nA = new Matrix4;
                class Raycaster {
                    constructor(Qe, rt, Wn, Co){
                        void 0 === Wn && (Wn = 0), void 0 === Co && (Co = 1 / 0), this.ray = new Ray(Qe, rt), this.near = Wn, this.far = Co, this.camera = null, this.layers = new Layers, this.params = {
                            Mesh: {},
                            Line: {
                                threshold: 1
                            },
                            LOD: {},
                            Points: {
                                threshold: 1
                            },
                            Sprite: {}
                        };
                    }
                    set(Qe, rt) {
                        this.ray.set(Qe, rt);
                    }
                    setFromCamera(Qe, rt) {
                        rt.isPerspectiveCamera ? (this.ray.origin.setFromMatrixPosition(rt.matrixWorld), this.ray.direction.set(Qe.x, Qe.y, .5).unproject(rt).sub(this.ray.origin).normalize(), this.camera = rt) : rt.isOrthographicCamera ? (this.ray.origin.set(Qe.x, Qe.y, (rt.near + rt.far) / (rt.near - rt.far)).unproject(rt), this.ray.direction.set(0, 0, -1).transformDirection(rt.matrixWorld), this.camera = rt) : console.error("THREE.Raycaster: Unsupported camera type: " + rt.type);
                    }
                    setFromXRController(Qe) {
                        return nA.identity().extractRotation(Qe.matrixWorld), this.ray.origin.setFromMatrixPosition(Qe.matrixWorld), this.ray.direction.set(0, 0, -1).applyMatrix4(nA), this;
                    }
                    intersectObject(Qe, rt, Wn) {
                        return void 0 === rt && (rt = !0), void 0 === Wn && (Wn = []), intersect(Qe, this, Wn, rt), Wn.sort(ascSort), Wn;
                    }
                    intersectObjects(Qe, rt, Wn) {
                        void 0 === rt && (rt = !0), void 0 === Wn && (Wn = []);
                        for(let Co = 0, Dl = Qe.length; Co < Dl; Co++)intersect(Qe[Co], this, Wn, rt);
                        return Wn.sort(ascSort), Wn;
                    }
                }
                function ascSort(Qe, rt) {
                    return Qe.distance - rt.distance;
                }
                function intersect(Qe, rt, Wn, Co) {
                    let Dl = !0;
                    if (Qe.layers.test(rt.layers)) !1 === Qe.raycast(rt, Wn) && (Dl = !1);
                    if (!0 === Dl && !0 === Co) {
                        const Co = Qe.children;
                        for(let Qe = 0, Dl = Co.length; Qe < Dl; Qe++)intersect(Co[Qe], rt, Wn, !0);
                    }
                }
                function getByteLength(Qe, rt, Wn, Co) {
                    const Dl = function(Qe) {
                        switch(Qe){
                            case Zd:
                            case Hd:
                                return {
                                    byteLength: 1,
                                    components: 1
                                };
                            case qd:
                            case Wd:
                            case Xd:
                                return {
                                    byteLength: 2,
                                    components: 1
                                };
                            case Jd:
                            case $d:
                                return {
                                    byteLength: 2,
                                    components: 4
                                };
                            case Qd:
                            case Yd:
                            case Kd:
                                return {
                                    byteLength: 4,
                                    components: 1
                                };
                            case gp:
                                return {
                                    byteLength: 4,
                                    components: 3
                                };
                        }
                        throw new Error(`Unknown texture type ${Qe}.`);
                    }(Co);
                    switch(Wn){
                        case Ap:
                        case xp:
                            return Qe * rt;
                        case bp:
                            return Qe * rt * 2;
                        case Mp:
                        case Sp:
                            return Qe * rt / Dl.components * Dl.byteLength;
                        case Tp:
                        case Cp:
                            return Qe * rt * 2 / Dl.components * Dl.byteLength;
                        case vp:
                            return Qe * rt * 3 / Dl.components * Dl.byteLength;
                        case _p:
                        case kp:
                            return Qe * rt * 4 / Dl.components * Dl.byteLength;
                        case Ip:
                        case Dp:
                            return Math.floor((Qe + 3) / 4) * Math.floor((rt + 3) / 4) * 8;
                        case Lp:
                        case Pp:
                            return Math.floor((Qe + 3) / 4) * Math.floor((rt + 3) / 4) * 16;
                        case Np:
                        case Bp:
                            return Math.max(Qe, 16) * Math.max(rt, 8) / 4;
                        case zp:
                        case Rp:
                            return Math.max(Qe, 8) * Math.max(rt, 8) / 2;
                        case Op:
                        case Fp:
                            return Math.floor((Qe + 3) / 4) * Math.floor((rt + 3) / 4) * 8;
                        case jp:
                        case Up:
                            return Math.floor((Qe + 3) / 4) * Math.floor((rt + 3) / 4) * 16;
                        case Vp:
                            return Math.floor((Qe + 4) / 5) * Math.floor((rt + 3) / 4) * 16;
                        case Gp:
                            return Math.floor((Qe + 4) / 5) * Math.floor((rt + 4) / 5) * 16;
                        case Zp:
                            return Math.floor((Qe + 5) / 6) * Math.floor((rt + 4) / 5) * 16;
                        case Hp:
                            return Math.floor((Qe + 5) / 6) * Math.floor((rt + 5) / 6) * 16;
                        case Wp:
                            return Math.floor((Qe + 7) / 8) * Math.floor((rt + 4) / 5) * 16;
                        case qp:
                            return Math.floor((Qe + 7) / 8) * Math.floor((rt + 5) / 6) * 16;
                        case Yp:
                            return Math.floor((Qe + 7) / 8) * Math.floor((rt + 7) / 8) * 16;
                        case Qp:
                            return Math.floor((Qe + 9) / 10) * Math.floor((rt + 4) / 5) * 16;
                        case Kp:
                            return Math.floor((Qe + 9) / 10) * Math.floor((rt + 5) / 6) * 16;
                        case Xp:
                            return Math.floor((Qe + 9) / 10) * Math.floor((rt + 7) / 8) * 16;
                        case Jp:
                            return Math.floor((Qe + 9) / 10) * Math.floor((rt + 9) / 10) * 16;
                        case $p:
                            return Math.floor((Qe + 11) / 12) * Math.floor((rt + 9) / 10) * 16;
                        case em:
                            return Math.floor((Qe + 11) / 12) * Math.floor((rt + 11) / 12) * 16;
                        case tm:
                        case im:
                        case nm:
                            return Math.ceil(Qe / 4) * Math.ceil(rt / 4) * 16;
                        case rm:
                        case sm:
                            return Math.ceil(Qe / 4) * Math.ceil(rt / 4) * 8;
                        case am:
                        case om:
                            return Math.ceil(Qe / 4) * Math.ceil(rt / 4) * 16;
                    }
                    throw new Error(`Unable to determine texture byte length for ${Wn} format.`);
                }
                "undefined" !== typeof __THREE_DEVTOOLS__ && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("register", {
                    detail: {
                        revision: Co
                    }
                })), "undefined" !== typeof window && (window.__THREE__ ? console.warn("WARNING: Multiple instances of Three.js being imported.") : window.__THREE__ = Co);
            },
            9408: (Qe, rt, Wn)=>{
                "use strict";
                Wn.d(rt, {
                    JeP: ()=>WebGLRenderer
                });
                var Co = Wn(9435);
                /**
 * @license
 * Copyright 2010-2025 Three.js Authors
 * SPDX-License-Identifier: MIT
 */ function WebGLAnimation() {
                    let Qe = null, rt = !1, Wn = null, Co = null;
                    function onAnimationFrame(rt, Dl) {
                        Wn(rt, Dl), Co = Qe.requestAnimationFrame(onAnimationFrame);
                    }
                    return {
                        start: function() {
                            !0 !== rt && null !== Wn && (Co = Qe.requestAnimationFrame(onAnimationFrame), rt = !0);
                        },
                        stop: function() {
                            Qe.cancelAnimationFrame(Co), rt = !1;
                        },
                        setAnimationLoop: function(Qe) {
                            Wn = Qe;
                        },
                        setContext: function(rt) {
                            Qe = rt;
                        }
                    };
                }
                function WebGLAttributes(Qe) {
                    const rt = new WeakMap;
                    return {
                        get: function(Qe) {
                            return Qe.isInterleavedBufferAttribute && (Qe = Qe.data), rt.get(Qe);
                        },
                        remove: function(Wn) {
                            Wn.isInterleavedBufferAttribute && (Wn = Wn.data);
                            const Co = rt.get(Wn);
                            Co && (Qe.deleteBuffer(Co.buffer), rt.delete(Wn));
                        },
                        update: function(Wn, Co) {
                            if (Wn.isInterleavedBufferAttribute && (Wn = Wn.data), Wn.isGLBufferAttribute) {
                                const Qe = rt.get(Wn);
                                return void ((!Qe || Qe.version < Wn.version) && rt.set(Wn, {
                                    buffer: Wn.buffer,
                                    type: Wn.type,
                                    bytesPerElement: Wn.elementSize,
                                    version: Wn.version
                                }));
                            }
                            const Dl = rt.get(Wn);
                            if (void 0 === Dl) rt.set(Wn, function(rt, Wn) {
                                const Co = rt.array, Dl = rt.usage, Ll = Co.byteLength, Rl = Qe.createBuffer();
                                let Ul;
                                if (Qe.bindBuffer(Wn, Rl), Qe.bufferData(Wn, Co, Dl), rt.onUploadCallback(), Co instanceof Float32Array) Ul = Qe.FLOAT;
                                else if (Co instanceof Uint16Array) Ul = rt.isFloat16BufferAttribute ? Qe.HALF_FLOAT : Qe.UNSIGNED_SHORT;
                                else if (Co instanceof Int16Array) Ul = Qe.SHORT;
                                else if (Co instanceof Uint32Array) Ul = Qe.UNSIGNED_INT;
                                else if (Co instanceof Int32Array) Ul = Qe.INT;
                                else if (Co instanceof Int8Array) Ul = Qe.BYTE;
                                else if (Co instanceof Uint8Array) Ul = Qe.UNSIGNED_BYTE;
                                else {
                                    if (!(Co instanceof Uint8ClampedArray)) throw new Error("THREE.WebGLAttributes: Unsupported buffer data format: " + Co);
                                    Ul = Qe.UNSIGNED_BYTE;
                                }
                                return {
                                    buffer: Rl,
                                    type: Ul,
                                    bytesPerElement: Co.BYTES_PER_ELEMENT,
                                    version: rt.version,
                                    size: Ll
                                };
                            }(Wn, Co));
                            else if (Dl.version < Wn.version) {
                                if (Dl.size !== Wn.array.byteLength) throw new Error("THREE.WebGLAttributes: The size of the buffer attribute's array buffer does not match the original size. Resizing buffer attributes is not supported.");
                                !function(rt, Wn, Co) {
                                    const Dl = Wn.array, Ll = Wn.updateRanges;
                                    if (Qe.bindBuffer(Co, rt), 0 === Ll.length) Qe.bufferSubData(Co, 0, Dl);
                                    else {
                                        Ll.sort((Qe, rt)=>Qe.start - rt.start);
                                        let rt = 0;
                                        for(let Qe = 1; Qe < Ll.length; Qe++){
                                            const Wn = Ll[rt], Co = Ll[Qe];
                                            Co.start <= Wn.start + Wn.count + 1 ? Wn.count = Math.max(Wn.count, Co.start + Co.count - Wn.start) : (++rt, Ll[rt] = Co);
                                        }
                                        Ll.length = rt + 1;
                                        for(let Wn = 0, Rl = Ll.length; Wn < Rl; Wn++){
                                            const rt = Ll[Wn];
                                            Qe.bufferSubData(Co, rt.start * Dl.BYTES_PER_ELEMENT, Dl, rt.start, rt.count);
                                        }
                                        Wn.clearUpdateRanges();
                                    }
                                    Wn.onUploadCallback();
                                }(Dl.buffer, Wn, Co), Dl.version = Wn.version;
                            }
                        }
                    };
                }
                const Dl = {
                    alphahash_fragment: "#ifdef USE_ALPHAHASH\n	if ( diffuseColor.a < getAlphaHashThreshold( vPosition ) ) discard;\n#endif",
                    alphahash_pars_fragment: "#ifdef USE_ALPHAHASH\n	const float ALPHA_HASH_SCALE = 0.05;\n	float hash2D( vec2 value ) {\n		return fract( 1.0e4 * sin( 17.0 * value.x + 0.1 * value.y ) * ( 0.1 + abs( sin( 13.0 * value.y + value.x ) ) ) );\n	}\n	float hash3D( vec3 value ) {\n		return hash2D( vec2( hash2D( value.xy ), value.z ) );\n	}\n	float getAlphaHashThreshold( vec3 position ) {\n		float maxDeriv = max(\n			length( dFdx( position.xyz ) ),\n			length( dFdy( position.xyz ) )\n		);\n		float pixScale = 1.0 / ( ALPHA_HASH_SCALE * maxDeriv );\n		vec2 pixScales = vec2(\n			exp2( floor( log2( pixScale ) ) ),\n			exp2( ceil( log2( pixScale ) ) )\n		);\n		vec2 alpha = vec2(\n			hash3D( floor( pixScales.x * position.xyz ) ),\n			hash3D( floor( pixScales.y * position.xyz ) )\n		);\n		float lerpFactor = fract( log2( pixScale ) );\n		float x = ( 1.0 - lerpFactor ) * alpha.x + lerpFactor * alpha.y;\n		float a = min( lerpFactor, 1.0 - lerpFactor );\n		vec3 cases = vec3(\n			x * x / ( 2.0 * a * ( 1.0 - a ) ),\n			( x - 0.5 * a ) / ( 1.0 - a ),\n			1.0 - ( ( 1.0 - x ) * ( 1.0 - x ) / ( 2.0 * a * ( 1.0 - a ) ) )\n		);\n		float threshold = ( x < ( 1.0 - a ) )\n			? ( ( x < a ) ? cases.x : cases.y )\n			: cases.z;\n		return clamp( threshold , 1.0e-6, 1.0 );\n	}\n#endif",
                    alphamap_fragment: "#ifdef USE_ALPHAMAP\n	diffuseColor.a *= texture2D( alphaMap, vAlphaMapUv ).g;\n#endif",
                    alphamap_pars_fragment: "#ifdef USE_ALPHAMAP\n	uniform sampler2D alphaMap;\n#endif",
                    alphatest_fragment: "#ifdef USE_ALPHATEST\n	#ifdef ALPHA_TO_COVERAGE\n	diffuseColor.a = smoothstep( alphaTest, alphaTest + fwidth( diffuseColor.a ), diffuseColor.a );\n	if ( diffuseColor.a == 0.0 ) discard;\n	#else\n	if ( diffuseColor.a < alphaTest ) discard;\n	#endif\n#endif",
                    alphatest_pars_fragment: "#ifdef USE_ALPHATEST\n	uniform float alphaTest;\n#endif",
                    aomap_fragment: "#ifdef USE_AOMAP\n	float ambientOcclusion = ( texture2D( aoMap, vAoMapUv ).r - 1.0 ) * aoMapIntensity + 1.0;\n	reflectedLight.indirectDiffuse *= ambientOcclusion;\n	#if defined( USE_CLEARCOAT ) \n		clearcoatSpecularIndirect *= ambientOcclusion;\n	#endif\n	#if defined( USE_SHEEN ) \n		sheenSpecularIndirect *= ambientOcclusion;\n	#endif\n	#if defined( USE_ENVMAP ) && defined( STANDARD )\n		float dotNV = saturate( dot( geometryNormal, geometryViewDir ) );\n		reflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.roughness );\n	#endif\n#endif",
                    aomap_pars_fragment: "#ifdef USE_AOMAP\n	uniform sampler2D aoMap;\n	uniform float aoMapIntensity;\n#endif",
                    batching_pars_vertex: "#ifdef USE_BATCHING\n	#if ! defined( GL_ANGLE_multi_draw )\n	#define gl_DrawID _gl_DrawID\n	uniform int _gl_DrawID;\n	#endif\n	uniform highp sampler2D batchingTexture;\n	uniform highp usampler2D batchingIdTexture;\n	mat4 getBatchingMatrix( const in float i ) {\n		int size = textureSize( batchingTexture, 0 ).x;\n		int j = int( i ) * 4;\n		int x = j % size;\n		int y = j / size;\n		vec4 v1 = texelFetch( batchingTexture, ivec2( x, y ), 0 );\n		vec4 v2 = texelFetch( batchingTexture, ivec2( x + 1, y ), 0 );\n		vec4 v3 = texelFetch( batchingTexture, ivec2( x + 2, y ), 0 );\n		vec4 v4 = texelFetch( batchingTexture, ivec2( x + 3, y ), 0 );\n		return mat4( v1, v2, v3, v4 );\n	}\n	float getIndirectIndex( const in int i ) {\n		int size = textureSize( batchingIdTexture, 0 ).x;\n		int x = i % size;\n		int y = i / size;\n		return float( texelFetch( batchingIdTexture, ivec2( x, y ), 0 ).r );\n	}\n#endif\n#ifdef USE_BATCHING_COLOR\n	uniform sampler2D batchingColorTexture;\n	vec3 getBatchingColor( const in float i ) {\n		int size = textureSize( batchingColorTexture, 0 ).x;\n		int j = int( i );\n		int x = j % size;\n		int y = j / size;\n		return texelFetch( batchingColorTexture, ivec2( x, y ), 0 ).rgb;\n	}\n#endif",
                    batching_vertex: "#ifdef USE_BATCHING\n	mat4 batchingMatrix = getBatchingMatrix( getIndirectIndex( gl_DrawID ) );\n#endif",
                    begin_vertex: "vec3 transformed = vec3( position );\n#ifdef USE_ALPHAHASH\n	vPosition = vec3( position );\n#endif",
                    beginnormal_vertex: "vec3 objectNormal = vec3( normal );\n#ifdef USE_TANGENT\n	vec3 objectTangent = vec3( tangent.xyz );\n#endif",
                    bsdfs: "float G_BlinnPhong_Implicit( ) {\n	return 0.25;\n}\nfloat D_BlinnPhong( const in float shininess, const in float dotNH ) {\n	return RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );\n}\nvec3 BRDF_BlinnPhong( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float shininess ) {\n	vec3 halfDir = normalize( lightDir + viewDir );\n	float dotNH = saturate( dot( normal, halfDir ) );\n	float dotVH = saturate( dot( viewDir, halfDir ) );\n	vec3 F = F_Schlick( specularColor, 1.0, dotVH );\n	float G = G_BlinnPhong_Implicit( );\n	float D = D_BlinnPhong( shininess, dotNH );\n	return F * ( G * D );\n} // validated",
                    iridescence_fragment: "#ifdef USE_IRIDESCENCE\n	const mat3 XYZ_TO_REC709 = mat3(\n		 3.2404542, -0.9692660,  0.0556434,\n		-1.5371385,  1.8760108, -0.2040259,\n		-0.4985314,  0.0415560,  1.0572252\n	);\n	vec3 Fresnel0ToIor( vec3 fresnel0 ) {\n		vec3 sqrtF0 = sqrt( fresnel0 );\n		return ( vec3( 1.0 ) + sqrtF0 ) / ( vec3( 1.0 ) - sqrtF0 );\n	}\n	vec3 IorToFresnel0( vec3 transmittedIor, float incidentIor ) {\n		return pow2( ( transmittedIor - vec3( incidentIor ) ) / ( transmittedIor + vec3( incidentIor ) ) );\n	}\n	float IorToFresnel0( float transmittedIor, float incidentIor ) {\n		return pow2( ( transmittedIor - incidentIor ) / ( transmittedIor + incidentIor ));\n	}\n	vec3 evalSensitivity( float OPD, vec3 shift ) {\n		float phase = 2.0 * PI * OPD * 1.0e-9;\n		vec3 val = vec3( 5.4856e-13, 4.4201e-13, 5.2481e-13 );\n		vec3 pos = vec3( 1.6810e+06, 1.7953e+06, 2.2084e+06 );\n		vec3 var = vec3( 4.3278e+09, 9.3046e+09, 6.6121e+09 );\n		vec3 xyz = val * sqrt( 2.0 * PI * var ) * cos( pos * phase + shift ) * exp( - pow2( phase ) * var );\n		xyz.x += 9.7470e-14 * sqrt( 2.0 * PI * 4.5282e+09 ) * cos( 2.2399e+06 * phase + shift[ 0 ] ) * exp( - 4.5282e+09 * pow2( phase ) );\n		xyz /= 1.0685e-7;\n		vec3 rgb = XYZ_TO_REC709 * xyz;\n		return rgb;\n	}\n	vec3 evalIridescence( float outsideIOR, float eta2, float cosTheta1, float thinFilmThickness, vec3 baseF0 ) {\n		vec3 I;\n		float iridescenceIOR = mix( outsideIOR, eta2, smoothstep( 0.0, 0.03, thinFilmThickness ) );\n		float sinTheta2Sq = pow2( outsideIOR / iridescenceIOR ) * ( 1.0 - pow2( cosTheta1 ) );\n		float cosTheta2Sq = 1.0 - sinTheta2Sq;\n		if ( cosTheta2Sq < 0.0 ) {\n			return vec3( 1.0 );\n		}\n		float cosTheta2 = sqrt( cosTheta2Sq );\n		float R0 = IorToFresnel0( iridescenceIOR, outsideIOR );\n		float R12 = F_Schlick( R0, 1.0, cosTheta1 );\n		float T121 = 1.0 - R12;\n		float phi12 = 0.0;\n		if ( iridescenceIOR < outsideIOR ) phi12 = PI;\n		float phi21 = PI - phi12;\n		vec3 baseIOR = Fresnel0ToIor( clamp( baseF0, 0.0, 0.9999 ) );		vec3 R1 = IorToFresnel0( baseIOR, iridescenceIOR );\n		vec3 R23 = F_Schlick( R1, 1.0, cosTheta2 );\n		vec3 phi23 = vec3( 0.0 );\n		if ( baseIOR[ 0 ] < iridescenceIOR ) phi23[ 0 ] = PI;\n		if ( baseIOR[ 1 ] < iridescenceIOR ) phi23[ 1 ] = PI;\n		if ( baseIOR[ 2 ] < iridescenceIOR ) phi23[ 2 ] = PI;\n		float OPD = 2.0 * iridescenceIOR * thinFilmThickness * cosTheta2;\n		vec3 phi = vec3( phi21 ) + phi23;\n		vec3 R123 = clamp( R12 * R23, 1e-5, 0.9999 );\n		vec3 r123 = sqrt( R123 );\n		vec3 Rs = pow2( T121 ) * R23 / ( vec3( 1.0 ) - R123 );\n		vec3 C0 = R12 + Rs;\n		I = C0;\n		vec3 Cm = Rs - T121;\n		for ( int m = 1; m <= 2; ++ m ) {\n			Cm *= r123;\n			vec3 Sm = 2.0 * evalSensitivity( float( m ) * OPD, float( m ) * phi );\n			I += Cm * Sm;\n		}\n		return max( I, vec3( 0.0 ) );\n	}\n#endif",
                    bumpmap_pars_fragment: "#ifdef USE_BUMPMAP\n	uniform sampler2D bumpMap;\n	uniform float bumpScale;\n	vec2 dHdxy_fwd() {\n		vec2 dSTdx = dFdx( vBumpMapUv );\n		vec2 dSTdy = dFdy( vBumpMapUv );\n		float Hll = bumpScale * texture2D( bumpMap, vBumpMapUv ).x;\n		float dBx = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdx ).x - Hll;\n		float dBy = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdy ).x - Hll;\n		return vec2( dBx, dBy );\n	}\n	vec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {\n		vec3 vSigmaX = normalize( dFdx( surf_pos.xyz ) );\n		vec3 vSigmaY = normalize( dFdy( surf_pos.xyz ) );\n		vec3 vN = surf_norm;\n		vec3 R1 = cross( vSigmaY, vN );\n		vec3 R2 = cross( vN, vSigmaX );\n		float fDet = dot( vSigmaX, R1 ) * faceDirection;\n		vec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );\n		return normalize( abs( fDet ) * surf_norm - vGrad );\n	}\n#endif",
                    clipping_planes_fragment: "#if NUM_CLIPPING_PLANES > 0\n	vec4 plane;\n	#ifdef ALPHA_TO_COVERAGE\n		float distanceToPlane, distanceGradient;\n		float clipOpacity = 1.0;\n		#pragma unroll_loop_start\n		for ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n			plane = clippingPlanes[ i ];\n			distanceToPlane = - dot( vClipPosition, plane.xyz ) + plane.w;\n			distanceGradient = fwidth( distanceToPlane ) / 2.0;\n			clipOpacity *= smoothstep( - distanceGradient, distanceGradient, distanceToPlane );\n			if ( clipOpacity == 0.0 ) discard;\n		}\n		#pragma unroll_loop_end\n		#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n			float unionClipOpacity = 1.0;\n			#pragma unroll_loop_start\n			for ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n				plane = clippingPlanes[ i ];\n				distanceToPlane = - dot( vClipPosition, plane.xyz ) + plane.w;\n				distanceGradient = fwidth( distanceToPlane ) / 2.0;\n				unionClipOpacity *= 1.0 - smoothstep( - distanceGradient, distanceGradient, distanceToPlane );\n			}\n			#pragma unroll_loop_end\n			clipOpacity *= 1.0 - unionClipOpacity;\n		#endif\n		diffuseColor.a *= clipOpacity;\n		if ( diffuseColor.a == 0.0 ) discard;\n	#else\n		#pragma unroll_loop_start\n		for ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n			plane = clippingPlanes[ i ];\n			if ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;\n		}\n		#pragma unroll_loop_end\n		#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n			bool clipped = true;\n			#pragma unroll_loop_start\n			for ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n				plane = clippingPlanes[ i ];\n				clipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;\n			}\n			#pragma unroll_loop_end\n			if ( clipped ) discard;\n		#endif\n	#endif\n#endif",
                    clipping_planes_pars_fragment: "#if NUM_CLIPPING_PLANES > 0\n	varying vec3 vClipPosition;\n	uniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];\n#endif",
                    clipping_planes_pars_vertex: "#if NUM_CLIPPING_PLANES > 0\n	varying vec3 vClipPosition;\n#endif",
                    clipping_planes_vertex: "#if NUM_CLIPPING_PLANES > 0\n	vClipPosition = - mvPosition.xyz;\n#endif",
                    color_fragment: "#if defined( USE_COLOR_ALPHA )\n	diffuseColor *= vColor;\n#elif defined( USE_COLOR )\n	diffuseColor.rgb *= vColor;\n#endif",
                    color_pars_fragment: "#if defined( USE_COLOR_ALPHA )\n	varying vec4 vColor;\n#elif defined( USE_COLOR )\n	varying vec3 vColor;\n#endif",
                    color_pars_vertex: "#if defined( USE_COLOR_ALPHA )\n	varying vec4 vColor;\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR ) || defined( USE_BATCHING_COLOR )\n	varying vec3 vColor;\n#endif",
                    color_vertex: "#if defined( USE_COLOR_ALPHA )\n	vColor = vec4( 1.0 );\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR ) || defined( USE_BATCHING_COLOR )\n	vColor = vec3( 1.0 );\n#endif\n#ifdef USE_COLOR\n	vColor *= color;\n#endif\n#ifdef USE_INSTANCING_COLOR\n	vColor.xyz *= instanceColor.xyz;\n#endif\n#ifdef USE_BATCHING_COLOR\n	vec3 batchingColor = getBatchingColor( getIndirectIndex( gl_DrawID ) );\n	vColor.xyz *= batchingColor.xyz;\n#endif",
                    common: "#define PI 3.141592653589793\n#define PI2 6.283185307179586\n#define PI_HALF 1.5707963267948966\n#define RECIPROCAL_PI 0.3183098861837907\n#define RECIPROCAL_PI2 0.15915494309189535\n#define EPSILON 1e-6\n#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\n#define whiteComplement( a ) ( 1.0 - saturate( a ) )\nfloat pow2( const in float x ) { return x*x; }\nvec3 pow2( const in vec3 x ) { return x*x; }\nfloat pow3( const in float x ) { return x*x*x; }\nfloat pow4( const in float x ) { float x2 = x*x; return x2*x2; }\nfloat max3( const in vec3 v ) { return max( max( v.x, v.y ), v.z ); }\nfloat average( const in vec3 v ) { return dot( v, vec3( 0.3333333 ) ); }\nhighp float rand( const in vec2 uv ) {\n	const highp float a = 12.9898, b = 78.233, c = 43758.5453;\n	highp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );\n	return fract( sin( sn ) * c );\n}\n#ifdef HIGH_PRECISION\n	float precisionSafeLength( vec3 v ) { return length( v ); }\n#else\n	float precisionSafeLength( vec3 v ) {\n		float maxComponent = max3( abs( v ) );\n		return length( v / maxComponent ) * maxComponent;\n	}\n#endif\nstruct IncidentLight {\n	vec3 color;\n	vec3 direction;\n	bool visible;\n};\nstruct ReflectedLight {\n	vec3 directDiffuse;\n	vec3 directSpecular;\n	vec3 indirectDiffuse;\n	vec3 indirectSpecular;\n};\n#ifdef USE_ALPHAHASH\n	varying vec3 vPosition;\n#endif\nvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n	return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n}\nvec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {\n	return normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );\n}\nmat3 transposeMat3( const in mat3 m ) {\n	mat3 tmp;\n	tmp[ 0 ] = vec3( m[ 0 ].x, m[ 1 ].x, m[ 2 ].x );\n	tmp[ 1 ] = vec3( m[ 0 ].y, m[ 1 ].y, m[ 2 ].y );\n	tmp[ 2 ] = vec3( m[ 0 ].z, m[ 1 ].z, m[ 2 ].z );\n	return tmp;\n}\nbool isPerspectiveMatrix( mat4 m ) {\n	return m[ 2 ][ 3 ] == - 1.0;\n}\nvec2 equirectUv( in vec3 dir ) {\n	float u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;\n	float v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;\n	return vec2( u, v );\n}\nvec3 BRDF_Lambert( const in vec3 diffuseColor ) {\n	return RECIPROCAL_PI * diffuseColor;\n}\nvec3 F_Schlick( const in vec3 f0, const in float f90, const in float dotVH ) {\n	float fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n	return f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n}\nfloat F_Schlick( const in float f0, const in float f90, const in float dotVH ) {\n	float fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n	return f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n} // validated",
                    cube_uv_reflection_fragment: "#ifdef ENVMAP_TYPE_CUBE_UV\n	#define cubeUV_minMipLevel 4.0\n	#define cubeUV_minTileSize 16.0\n	float getFace( vec3 direction ) {\n		vec3 absDirection = abs( direction );\n		float face = - 1.0;\n		if ( absDirection.x > absDirection.z ) {\n			if ( absDirection.x > absDirection.y )\n				face = direction.x > 0.0 ? 0.0 : 3.0;\n			else\n				face = direction.y > 0.0 ? 1.0 : 4.0;\n		} else {\n			if ( absDirection.z > absDirection.y )\n				face = direction.z > 0.0 ? 2.0 : 5.0;\n			else\n				face = direction.y > 0.0 ? 1.0 : 4.0;\n		}\n		return face;\n	}\n	vec2 getUV( vec3 direction, float face ) {\n		vec2 uv;\n		if ( face == 0.0 ) {\n			uv = vec2( direction.z, direction.y ) / abs( direction.x );\n		} else if ( face == 1.0 ) {\n			uv = vec2( - direction.x, - direction.z ) / abs( direction.y );\n		} else if ( face == 2.0 ) {\n			uv = vec2( - direction.x, direction.y ) / abs( direction.z );\n		} else if ( face == 3.0 ) {\n			uv = vec2( - direction.z, direction.y ) / abs( direction.x );\n		} else if ( face == 4.0 ) {\n			uv = vec2( - direction.x, direction.z ) / abs( direction.y );\n		} else {\n			uv = vec2( direction.x, direction.y ) / abs( direction.z );\n		}\n		return 0.5 * ( uv + 1.0 );\n	}\n	vec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {\n		float face = getFace( direction );\n		float filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );\n		mipInt = max( mipInt, cubeUV_minMipLevel );\n		float faceSize = exp2( mipInt );\n		highp vec2 uv = getUV( direction, face ) * ( faceSize - 2.0 ) + 1.0;\n		if ( face > 2.0 ) {\n			uv.y += faceSize;\n			face -= 3.0;\n		}\n		uv.x += face * faceSize;\n		uv.x += filterInt * 3.0 * cubeUV_minTileSize;\n		uv.y += 4.0 * ( exp2( CUBEUV_MAX_MIP ) - faceSize );\n		uv.x *= CUBEUV_TEXEL_WIDTH;\n		uv.y *= CUBEUV_TEXEL_HEIGHT;\n		#ifdef texture2DGradEXT\n			return texture2DGradEXT( envMap, uv, vec2( 0.0 ), vec2( 0.0 ) ).rgb;\n		#else\n			return texture2D( envMap, uv ).rgb;\n		#endif\n	}\n	#define cubeUV_r0 1.0\n	#define cubeUV_m0 - 2.0\n	#define cubeUV_r1 0.8\n	#define cubeUV_m1 - 1.0\n	#define cubeUV_r4 0.4\n	#define cubeUV_m4 2.0\n	#define cubeUV_r5 0.305\n	#define cubeUV_m5 3.0\n	#define cubeUV_r6 0.21\n	#define cubeUV_m6 4.0\n	float roughnessToMip( float roughness ) {\n		float mip = 0.0;\n		if ( roughness >= cubeUV_r1 ) {\n			mip = ( cubeUV_r0 - roughness ) * ( cubeUV_m1 - cubeUV_m0 ) / ( cubeUV_r0 - cubeUV_r1 ) + cubeUV_m0;\n		} else if ( roughness >= cubeUV_r4 ) {\n			mip = ( cubeUV_r1 - roughness ) * ( cubeUV_m4 - cubeUV_m1 ) / ( cubeUV_r1 - cubeUV_r4 ) + cubeUV_m1;\n		} else if ( roughness >= cubeUV_r5 ) {\n			mip = ( cubeUV_r4 - roughness ) * ( cubeUV_m5 - cubeUV_m4 ) / ( cubeUV_r4 - cubeUV_r5 ) + cubeUV_m4;\n		} else if ( roughness >= cubeUV_r6 ) {\n			mip = ( cubeUV_r5 - roughness ) * ( cubeUV_m6 - cubeUV_m5 ) / ( cubeUV_r5 - cubeUV_r6 ) + cubeUV_m5;\n		} else {\n			mip = - 2.0 * log2( 1.16 * roughness );		}\n		return mip;\n	}\n	vec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {\n		float mip = clamp( roughnessToMip( roughness ), cubeUV_m0, CUBEUV_MAX_MIP );\n		float mipF = fract( mip );\n		float mipInt = floor( mip );\n		vec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );\n		if ( mipF == 0.0 ) {\n			return vec4( color0, 1.0 );\n		} else {\n			vec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );\n			return vec4( mix( color0, color1, mipF ), 1.0 );\n		}\n	}\n#endif",
                    defaultnormal_vertex: "vec3 transformedNormal = objectNormal;\n#ifdef USE_TANGENT\n	vec3 transformedTangent = objectTangent;\n#endif\n#ifdef USE_BATCHING\n	mat3 bm = mat3( batchingMatrix );\n	transformedNormal /= vec3( dot( bm[ 0 ], bm[ 0 ] ), dot( bm[ 1 ], bm[ 1 ] ), dot( bm[ 2 ], bm[ 2 ] ) );\n	transformedNormal = bm * transformedNormal;\n	#ifdef USE_TANGENT\n		transformedTangent = bm * transformedTangent;\n	#endif\n#endif\n#ifdef USE_INSTANCING\n	mat3 im = mat3( instanceMatrix );\n	transformedNormal /= vec3( dot( im[ 0 ], im[ 0 ] ), dot( im[ 1 ], im[ 1 ] ), dot( im[ 2 ], im[ 2 ] ) );\n	transformedNormal = im * transformedNormal;\n	#ifdef USE_TANGENT\n		transformedTangent = im * transformedTangent;\n	#endif\n#endif\ntransformedNormal = normalMatrix * transformedNormal;\n#ifdef FLIP_SIDED\n	transformedNormal = - transformedNormal;\n#endif\n#ifdef USE_TANGENT\n	transformedTangent = ( modelViewMatrix * vec4( transformedTangent, 0.0 ) ).xyz;\n	#ifdef FLIP_SIDED\n		transformedTangent = - transformedTangent;\n	#endif\n#endif",
                    displacementmap_pars_vertex: "#ifdef USE_DISPLACEMENTMAP\n	uniform sampler2D displacementMap;\n	uniform float displacementScale;\n	uniform float displacementBias;\n#endif",
                    displacementmap_vertex: "#ifdef USE_DISPLACEMENTMAP\n	transformed += normalize( objectNormal ) * ( texture2D( displacementMap, vDisplacementMapUv ).x * displacementScale + displacementBias );\n#endif",
                    emissivemap_fragment: "#ifdef USE_EMISSIVEMAP\n	vec4 emissiveColor = texture2D( emissiveMap, vEmissiveMapUv );\n	#ifdef DECODE_VIDEO_TEXTURE_EMISSIVE\n		emissiveColor = sRGBTransferEOTF( emissiveColor );\n	#endif\n	totalEmissiveRadiance *= emissiveColor.rgb;\n#endif",
                    emissivemap_pars_fragment: "#ifdef USE_EMISSIVEMAP\n	uniform sampler2D emissiveMap;\n#endif",
                    colorspace_fragment: "gl_FragColor = linearToOutputTexel( gl_FragColor );",
                    colorspace_pars_fragment: "vec4 LinearTransferOETF( in vec4 value ) {\n	return value;\n}\nvec4 sRGBTransferEOTF( in vec4 value ) {\n	return vec4( mix( pow( value.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), value.rgb * 0.0773993808, vec3( lessThanEqual( value.rgb, vec3( 0.04045 ) ) ) ), value.a );\n}\nvec4 sRGBTransferOETF( in vec4 value ) {\n	return vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );\n}",
                    envmap_fragment: "#ifdef USE_ENVMAP\n	#ifdef ENV_WORLDPOS\n		vec3 cameraToFrag;\n		if ( isOrthographic ) {\n			cameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n		} else {\n			cameraToFrag = normalize( vWorldPosition - cameraPosition );\n		}\n		vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n		#ifdef ENVMAP_MODE_REFLECTION\n			vec3 reflectVec = reflect( cameraToFrag, worldNormal );\n		#else\n			vec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );\n		#endif\n	#else\n		vec3 reflectVec = vReflect;\n	#endif\n	#ifdef ENVMAP_TYPE_CUBE\n		vec4 envColor = textureCube( envMap, envMapRotation * vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );\n	#else\n		vec4 envColor = vec4( 0.0 );\n	#endif\n	#ifdef ENVMAP_BLENDING_MULTIPLY\n		outgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );\n	#elif defined( ENVMAP_BLENDING_MIX )\n		outgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );\n	#elif defined( ENVMAP_BLENDING_ADD )\n		outgoingLight += envColor.xyz * specularStrength * reflectivity;\n	#endif\n#endif",
                    envmap_common_pars_fragment: "#ifdef USE_ENVMAP\n	uniform float envMapIntensity;\n	uniform float flipEnvMap;\n	uniform mat3 envMapRotation;\n	#ifdef ENVMAP_TYPE_CUBE\n		uniform samplerCube envMap;\n	#else\n		uniform sampler2D envMap;\n	#endif\n	\n#endif",
                    envmap_pars_fragment: "#ifdef USE_ENVMAP\n	uniform float reflectivity;\n	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n		#define ENV_WORLDPOS\n	#endif\n	#ifdef ENV_WORLDPOS\n		varying vec3 vWorldPosition;\n		uniform float refractionRatio;\n	#else\n		varying vec3 vReflect;\n	#endif\n#endif",
                    envmap_pars_vertex: "#ifdef USE_ENVMAP\n	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n		#define ENV_WORLDPOS\n	#endif\n	#ifdef ENV_WORLDPOS\n		\n		varying vec3 vWorldPosition;\n	#else\n		varying vec3 vReflect;\n		uniform float refractionRatio;\n	#endif\n#endif",
                    envmap_physical_pars_fragment: "#ifdef USE_ENVMAP\n	vec3 getIBLIrradiance( const in vec3 normal ) {\n		#ifdef ENVMAP_TYPE_CUBE_UV\n			vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n			vec4 envMapColor = textureCubeUV( envMap, envMapRotation * worldNormal, 1.0 );\n			return PI * envMapColor.rgb * envMapIntensity;\n		#else\n			return vec3( 0.0 );\n		#endif\n	}\n	vec3 getIBLRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness ) {\n		#ifdef ENVMAP_TYPE_CUBE_UV\n			vec3 reflectVec = reflect( - viewDir, normal );\n			reflectVec = normalize( mix( reflectVec, normal, roughness * roughness) );\n			reflectVec = inverseTransformDirection( reflectVec, viewMatrix );\n			vec4 envMapColor = textureCubeUV( envMap, envMapRotation * reflectVec, roughness );\n			return envMapColor.rgb * envMapIntensity;\n		#else\n			return vec3( 0.0 );\n		#endif\n	}\n	#ifdef USE_ANISOTROPY\n		vec3 getIBLAnisotropyRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness, const in vec3 bitangent, const in float anisotropy ) {\n			#ifdef ENVMAP_TYPE_CUBE_UV\n				vec3 bentNormal = cross( bitangent, viewDir );\n				bentNormal = normalize( cross( bentNormal, bitangent ) );\n				bentNormal = normalize( mix( bentNormal, normal, pow2( pow2( 1.0 - anisotropy * ( 1.0 - roughness ) ) ) ) );\n				return getIBLRadiance( viewDir, bentNormal, roughness );\n			#else\n				return vec3( 0.0 );\n			#endif\n		}\n	#endif\n#endif",
                    envmap_vertex: "#ifdef USE_ENVMAP\n	#ifdef ENV_WORLDPOS\n		vWorldPosition = worldPosition.xyz;\n	#else\n		vec3 cameraToVertex;\n		if ( isOrthographic ) {\n			cameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n		} else {\n			cameraToVertex = normalize( worldPosition.xyz - cameraPosition );\n		}\n		vec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n		#ifdef ENVMAP_MODE_REFLECTION\n			vReflect = reflect( cameraToVertex, worldNormal );\n		#else\n			vReflect = refract( cameraToVertex, worldNormal, refractionRatio );\n		#endif\n	#endif\n#endif",
                    fog_vertex: "#ifdef USE_FOG\n	vFogDepth = - mvPosition.z;\n#endif",
                    fog_pars_vertex: "#ifdef USE_FOG\n	varying float vFogDepth;\n#endif",
                    fog_fragment: "#ifdef USE_FOG\n	#ifdef FOG_EXP2\n		float fogFactor = 1.0 - exp( - fogDensity * fogDensity * vFogDepth * vFogDepth );\n	#else\n		float fogFactor = smoothstep( fogNear, fogFar, vFogDepth );\n	#endif\n	gl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );\n#endif",
                    fog_pars_fragment: "#ifdef USE_FOG\n	uniform vec3 fogColor;\n	varying float vFogDepth;\n	#ifdef FOG_EXP2\n		uniform float fogDensity;\n	#else\n		uniform float fogNear;\n		uniform float fogFar;\n	#endif\n#endif",
                    gradientmap_pars_fragment: "#ifdef USE_GRADIENTMAP\n	uniform sampler2D gradientMap;\n#endif\nvec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {\n	float dotNL = dot( normal, lightDirection );\n	vec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );\n	#ifdef USE_GRADIENTMAP\n		return vec3( texture2D( gradientMap, coord ).r );\n	#else\n		vec2 fw = fwidth( coord ) * 0.5;\n		return mix( vec3( 0.7 ), vec3( 1.0 ), smoothstep( 0.7 - fw.x, 0.7 + fw.x, coord.x ) );\n	#endif\n}",
                    lightmap_pars_fragment: "#ifdef USE_LIGHTMAP\n	uniform sampler2D lightMap;\n	uniform float lightMapIntensity;\n#endif",
                    lights_lambert_fragment: "LambertMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularStrength = specularStrength;",
                    lights_lambert_pars_fragment: "varying vec3 vViewPosition;\nstruct LambertMaterial {\n	vec3 diffuseColor;\n	float specularStrength;\n};\nvoid RE_Direct_Lambert( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n	float dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n	vec3 irradiance = dotNL * directLight.color;\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Lambert( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct				RE_Direct_Lambert\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_Lambert",
                    lights_pars_begin: "uniform bool receiveShadow;\nuniform vec3 ambientLightColor;\n#if defined( USE_LIGHT_PROBES )\n	uniform vec3 lightProbe[ 9 ];\n#endif\nvec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {\n	float x = normal.x, y = normal.y, z = normal.z;\n	vec3 result = shCoefficients[ 0 ] * 0.886227;\n	result += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;\n	result += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;\n	result += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;\n	result += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;\n	result += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;\n	result += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );\n	result += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;\n	result += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );\n	return result;\n}\nvec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in vec3 normal ) {\n	vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n	vec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );\n	return irradiance;\n}\nvec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {\n	vec3 irradiance = ambientLightColor;\n	return irradiance;\n}\nfloat getDistanceAttenuation( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {\n	float distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );\n	if ( cutoffDistance > 0.0 ) {\n		distanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );\n	}\n	return distanceFalloff;\n}\nfloat getSpotAttenuation( const in float coneCosine, const in float penumbraCosine, const in float angleCosine ) {\n	return smoothstep( coneCosine, penumbraCosine, angleCosine );\n}\n#if NUM_DIR_LIGHTS > 0\n	struct DirectionalLight {\n		vec3 direction;\n		vec3 color;\n	};\n	uniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];\n	void getDirectionalLightInfo( const in DirectionalLight directionalLight, out IncidentLight light ) {\n		light.color = directionalLight.color;\n		light.direction = directionalLight.direction;\n		light.visible = true;\n	}\n#endif\n#if NUM_POINT_LIGHTS > 0\n	struct PointLight {\n		vec3 position;\n		vec3 color;\n		float distance;\n		float decay;\n	};\n	uniform PointLight pointLights[ NUM_POINT_LIGHTS ];\n	void getPointLightInfo( const in PointLight pointLight, const in vec3 geometryPosition, out IncidentLight light ) {\n		vec3 lVector = pointLight.position - geometryPosition;\n		light.direction = normalize( lVector );\n		float lightDistance = length( lVector );\n		light.color = pointLight.color;\n		light.color *= getDistanceAttenuation( lightDistance, pointLight.distance, pointLight.decay );\n		light.visible = ( light.color != vec3( 0.0 ) );\n	}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n	struct SpotLight {\n		vec3 position;\n		vec3 direction;\n		vec3 color;\n		float distance;\n		float decay;\n		float coneCos;\n		float penumbraCos;\n	};\n	uniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];\n	void getSpotLightInfo( const in SpotLight spotLight, const in vec3 geometryPosition, out IncidentLight light ) {\n		vec3 lVector = spotLight.position - geometryPosition;\n		light.direction = normalize( lVector );\n		float angleCos = dot( light.direction, spotLight.direction );\n		float spotAttenuation = getSpotAttenuation( spotLight.coneCos, spotLight.penumbraCos, angleCos );\n		if ( spotAttenuation > 0.0 ) {\n			float lightDistance = length( lVector );\n			light.color = spotLight.color * spotAttenuation;\n			light.color *= getDistanceAttenuation( lightDistance, spotLight.distance, spotLight.decay );\n			light.visible = ( light.color != vec3( 0.0 ) );\n		} else {\n			light.color = vec3( 0.0 );\n			light.visible = false;\n		}\n	}\n#endif\n#if NUM_RECT_AREA_LIGHTS > 0\n	struct RectAreaLight {\n		vec3 color;\n		vec3 position;\n		vec3 halfWidth;\n		vec3 halfHeight;\n	};\n	uniform sampler2D ltc_1;	uniform sampler2D ltc_2;\n	uniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];\n#endif\n#if NUM_HEMI_LIGHTS > 0\n	struct HemisphereLight {\n		vec3 direction;\n		vec3 skyColor;\n		vec3 groundColor;\n	};\n	uniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];\n	vec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in vec3 normal ) {\n		float dotNL = dot( normal, hemiLight.direction );\n		float hemiDiffuseWeight = 0.5 * dotNL + 0.5;\n		vec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );\n		return irradiance;\n	}\n#endif",
                    lights_toon_fragment: "ToonMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;",
                    lights_toon_pars_fragment: "varying vec3 vViewPosition;\nstruct ToonMaterial {\n	vec3 diffuseColor;\n};\nvoid RE_Direct_Toon( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n	vec3 irradiance = getGradientIrradiance( geometryNormal, directLight.direction ) * directLight.color;\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct				RE_Direct_Toon\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_Toon",
                    lights_phong_fragment: "BlinnPhongMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularColor = specular;\nmaterial.specularShininess = shininess;\nmaterial.specularStrength = specularStrength;",
                    lights_phong_pars_fragment: "varying vec3 vViewPosition;\nstruct BlinnPhongMaterial {\n	vec3 diffuseColor;\n	vec3 specularColor;\n	float specularShininess;\n	float specularStrength;\n};\nvoid RE_Direct_BlinnPhong( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n	float dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n	vec3 irradiance = dotNL * directLight.color;\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n	reflectedLight.directSpecular += irradiance * BRDF_BlinnPhong( directLight.direction, geometryViewDir, geometryNormal, material.specularColor, material.specularShininess ) * material.specularStrength;\n}\nvoid RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct				RE_Direct_BlinnPhong\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_BlinnPhong",
                    lights_physical_fragment: "PhysicalMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );\nvec3 dxy = max( abs( dFdx( nonPerturbedNormal ) ), abs( dFdy( nonPerturbedNormal ) ) );\nfloat geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );\nmaterial.roughness = max( roughnessFactor, 0.0525 );material.roughness += geometryRoughness;\nmaterial.roughness = min( material.roughness, 1.0 );\n#ifdef IOR\n	material.ior = ior;\n	#ifdef USE_SPECULAR\n		float specularIntensityFactor = specularIntensity;\n		vec3 specularColorFactor = specularColor;\n		#ifdef USE_SPECULAR_COLORMAP\n			specularColorFactor *= texture2D( specularColorMap, vSpecularColorMapUv ).rgb;\n		#endif\n		#ifdef USE_SPECULAR_INTENSITYMAP\n			specularIntensityFactor *= texture2D( specularIntensityMap, vSpecularIntensityMapUv ).a;\n		#endif\n		material.specularF90 = mix( specularIntensityFactor, 1.0, metalnessFactor );\n	#else\n		float specularIntensityFactor = 1.0;\n		vec3 specularColorFactor = vec3( 1.0 );\n		material.specularF90 = 1.0;\n	#endif\n	material.specularColor = mix( min( pow2( ( material.ior - 1.0 ) / ( material.ior + 1.0 ) ) * specularColorFactor, vec3( 1.0 ) ) * specularIntensityFactor, diffuseColor.rgb, metalnessFactor );\n#else\n	material.specularColor = mix( vec3( 0.04 ), diffuseColor.rgb, metalnessFactor );\n	material.specularF90 = 1.0;\n#endif\n#ifdef USE_CLEARCOAT\n	material.clearcoat = clearcoat;\n	material.clearcoatRoughness = clearcoatRoughness;\n	material.clearcoatF0 = vec3( 0.04 );\n	material.clearcoatF90 = 1.0;\n	#ifdef USE_CLEARCOATMAP\n		material.clearcoat *= texture2D( clearcoatMap, vClearcoatMapUv ).x;\n	#endif\n	#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n		material.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vClearcoatRoughnessMapUv ).y;\n	#endif\n	material.clearcoat = saturate( material.clearcoat );	material.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );\n	material.clearcoatRoughness += geometryRoughness;\n	material.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );\n#endif\n#ifdef USE_DISPERSION\n	material.dispersion = dispersion;\n#endif\n#ifdef USE_IRIDESCENCE\n	material.iridescence = iridescence;\n	material.iridescenceIOR = iridescenceIOR;\n	#ifdef USE_IRIDESCENCEMAP\n		material.iridescence *= texture2D( iridescenceMap, vIridescenceMapUv ).r;\n	#endif\n	#ifdef USE_IRIDESCENCE_THICKNESSMAP\n		material.iridescenceThickness = (iridescenceThicknessMaximum - iridescenceThicknessMinimum) * texture2D( iridescenceThicknessMap, vIridescenceThicknessMapUv ).g + iridescenceThicknessMinimum;\n	#else\n		material.iridescenceThickness = iridescenceThicknessMaximum;\n	#endif\n#endif\n#ifdef USE_SHEEN\n	material.sheenColor = sheenColor;\n	#ifdef USE_SHEEN_COLORMAP\n		material.sheenColor *= texture2D( sheenColorMap, vSheenColorMapUv ).rgb;\n	#endif\n	material.sheenRoughness = clamp( sheenRoughness, 0.07, 1.0 );\n	#ifdef USE_SHEEN_ROUGHNESSMAP\n		material.sheenRoughness *= texture2D( sheenRoughnessMap, vSheenRoughnessMapUv ).a;\n	#endif\n#endif\n#ifdef USE_ANISOTROPY\n	#ifdef USE_ANISOTROPYMAP\n		mat2 anisotropyMat = mat2( anisotropyVector.x, anisotropyVector.y, - anisotropyVector.y, anisotropyVector.x );\n		vec3 anisotropyPolar = texture2D( anisotropyMap, vAnisotropyMapUv ).rgb;\n		vec2 anisotropyV = anisotropyMat * normalize( 2.0 * anisotropyPolar.rg - vec2( 1.0 ) ) * anisotropyPolar.b;\n	#else\n		vec2 anisotropyV = anisotropyVector;\n	#endif\n	material.anisotropy = length( anisotropyV );\n	if( material.anisotropy == 0.0 ) {\n		anisotropyV = vec2( 1.0, 0.0 );\n	} else {\n		anisotropyV /= material.anisotropy;\n		material.anisotropy = saturate( material.anisotropy );\n	}\n	material.alphaT = mix( pow2( material.roughness ), 1.0, pow2( material.anisotropy ) );\n	material.anisotropyT = tbn[ 0 ] * anisotropyV.x + tbn[ 1 ] * anisotropyV.y;\n	material.anisotropyB = tbn[ 1 ] * anisotropyV.x - tbn[ 0 ] * anisotropyV.y;\n#endif",
                    lights_physical_pars_fragment: "struct PhysicalMaterial {\n	vec3 diffuseColor;\n	float roughness;\n	vec3 specularColor;\n	float specularF90;\n	float dispersion;\n	#ifdef USE_CLEARCOAT\n		float clearcoat;\n		float clearcoatRoughness;\n		vec3 clearcoatF0;\n		float clearcoatF90;\n	#endif\n	#ifdef USE_IRIDESCENCE\n		float iridescence;\n		float iridescenceIOR;\n		float iridescenceThickness;\n		vec3 iridescenceFresnel;\n		vec3 iridescenceF0;\n	#endif\n	#ifdef USE_SHEEN\n		vec3 sheenColor;\n		float sheenRoughness;\n	#endif\n	#ifdef IOR\n		float ior;\n	#endif\n	#ifdef USE_TRANSMISSION\n		float transmission;\n		float transmissionAlpha;\n		float thickness;\n		float attenuationDistance;\n		vec3 attenuationColor;\n	#endif\n	#ifdef USE_ANISOTROPY\n		float anisotropy;\n		float alphaT;\n		vec3 anisotropyT;\n		vec3 anisotropyB;\n	#endif\n};\nvec3 clearcoatSpecularDirect = vec3( 0.0 );\nvec3 clearcoatSpecularIndirect = vec3( 0.0 );\nvec3 sheenSpecularDirect = vec3( 0.0 );\nvec3 sheenSpecularIndirect = vec3(0.0 );\nvec3 Schlick_to_F0( const in vec3 f, const in float f90, const in float dotVH ) {\n    float x = clamp( 1.0 - dotVH, 0.0, 1.0 );\n    float x2 = x * x;\n    float x5 = clamp( x * x2 * x2, 0.0, 0.9999 );\n    return ( f - vec3( f90 ) * x5 ) / ( 1.0 - x5 );\n}\nfloat V_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {\n	float a2 = pow2( alpha );\n	float gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n	float gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n	return 0.5 / max( gv + gl, EPSILON );\n}\nfloat D_GGX( const in float alpha, const in float dotNH ) {\n	float a2 = pow2( alpha );\n	float denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;\n	return RECIPROCAL_PI * a2 / pow2( denom );\n}\n#ifdef USE_ANISOTROPY\n	float V_GGX_SmithCorrelated_Anisotropic( const in float alphaT, const in float alphaB, const in float dotTV, const in float dotBV, const in float dotTL, const in float dotBL, const in float dotNV, const in float dotNL ) {\n		float gv = dotNL * length( vec3( alphaT * dotTV, alphaB * dotBV, dotNV ) );\n		float gl = dotNV * length( vec3( alphaT * dotTL, alphaB * dotBL, dotNL ) );\n		float v = 0.5 / ( gv + gl );\n		return saturate(v);\n	}\n	float D_GGX_Anisotropic( const in float alphaT, const in float alphaB, const in float dotNH, const in float dotTH, const in float dotBH ) {\n		float a2 = alphaT * alphaB;\n		highp vec3 v = vec3( alphaB * dotTH, alphaT * dotBH, a2 * dotNH );\n		highp float v2 = dot( v, v );\n		float w2 = a2 / v2;\n		return RECIPROCAL_PI * a2 * pow2 ( w2 );\n	}\n#endif\n#ifdef USE_CLEARCOAT\n	vec3 BRDF_GGX_Clearcoat( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material) {\n		vec3 f0 = material.clearcoatF0;\n		float f90 = material.clearcoatF90;\n		float roughness = material.clearcoatRoughness;\n		float alpha = pow2( roughness );\n		vec3 halfDir = normalize( lightDir + viewDir );\n		float dotNL = saturate( dot( normal, lightDir ) );\n		float dotNV = saturate( dot( normal, viewDir ) );\n		float dotNH = saturate( dot( normal, halfDir ) );\n		float dotVH = saturate( dot( viewDir, halfDir ) );\n		vec3 F = F_Schlick( f0, f90, dotVH );\n		float V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n		float D = D_GGX( alpha, dotNH );\n		return F * ( V * D );\n	}\n#endif\nvec3 BRDF_GGX( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material ) {\n	vec3 f0 = material.specularColor;\n	float f90 = material.specularF90;\n	float roughness = material.roughness;\n	float alpha = pow2( roughness );\n	vec3 halfDir = normalize( lightDir + viewDir );\n	float dotNL = saturate( dot( normal, lightDir ) );\n	float dotNV = saturate( dot( normal, viewDir ) );\n	float dotNH = saturate( dot( normal, halfDir ) );\n	float dotVH = saturate( dot( viewDir, halfDir ) );\n	vec3 F = F_Schlick( f0, f90, dotVH );\n	#ifdef USE_IRIDESCENCE\n		F = mix( F, material.iridescenceFresnel, material.iridescence );\n	#endif\n	#ifdef USE_ANISOTROPY\n		float dotTL = dot( material.anisotropyT, lightDir );\n		float dotTV = dot( material.anisotropyT, viewDir );\n		float dotTH = dot( material.anisotropyT, halfDir );\n		float dotBL = dot( material.anisotropyB, lightDir );\n		float dotBV = dot( material.anisotropyB, viewDir );\n		float dotBH = dot( material.anisotropyB, halfDir );\n		float V = V_GGX_SmithCorrelated_Anisotropic( material.alphaT, alpha, dotTV, dotBV, dotTL, dotBL, dotNV, dotNL );\n		float D = D_GGX_Anisotropic( material.alphaT, alpha, dotNH, dotTH, dotBH );\n	#else\n		float V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n		float D = D_GGX( alpha, dotNH );\n	#endif\n	return F * ( V * D );\n}\nvec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {\n	const float LUT_SIZE = 64.0;\n	const float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;\n	const float LUT_BIAS = 0.5 / LUT_SIZE;\n	float dotNV = saturate( dot( N, V ) );\n	vec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );\n	uv = uv * LUT_SCALE + LUT_BIAS;\n	return uv;\n}\nfloat LTC_ClippedSphereFormFactor( const in vec3 f ) {\n	float l = length( f );\n	return max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );\n}\nvec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {\n	float x = dot( v1, v2 );\n	float y = abs( x );\n	float a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;\n	float b = 3.4175940 + ( 4.1616724 + y ) * y;\n	float v = a / b;\n	float theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;\n	return cross( v1, v2 ) * theta_sintheta;\n}\nvec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {\n	vec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];\n	vec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];\n	vec3 lightNormal = cross( v1, v2 );\n	if( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );\n	vec3 T1, T2;\n	T1 = normalize( V - N * dot( V, N ) );\n	T2 = - cross( N, T1 );\n	mat3 mat = mInv * transposeMat3( mat3( T1, T2, N ) );\n	vec3 coords[ 4 ];\n	coords[ 0 ] = mat * ( rectCoords[ 0 ] - P );\n	coords[ 1 ] = mat * ( rectCoords[ 1 ] - P );\n	coords[ 2 ] = mat * ( rectCoords[ 2 ] - P );\n	coords[ 3 ] = mat * ( rectCoords[ 3 ] - P );\n	coords[ 0 ] = normalize( coords[ 0 ] );\n	coords[ 1 ] = normalize( coords[ 1 ] );\n	coords[ 2 ] = normalize( coords[ 2 ] );\n	coords[ 3 ] = normalize( coords[ 3 ] );\n	vec3 vectorFormFactor = vec3( 0.0 );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );\n	float result = LTC_ClippedSphereFormFactor( vectorFormFactor );\n	return vec3( result );\n}\n#if defined( USE_SHEEN )\nfloat D_Charlie( float roughness, float dotNH ) {\n	float alpha = pow2( roughness );\n	float invAlpha = 1.0 / alpha;\n	float cos2h = dotNH * dotNH;\n	float sin2h = max( 1.0 - cos2h, 0.0078125 );\n	return ( 2.0 + invAlpha ) * pow( sin2h, invAlpha * 0.5 ) / ( 2.0 * PI );\n}\nfloat V_Neubelt( float dotNV, float dotNL ) {\n	return saturate( 1.0 / ( 4.0 * ( dotNL + dotNV - dotNL * dotNV ) ) );\n}\nvec3 BRDF_Sheen( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, vec3 sheenColor, const in float sheenRoughness ) {\n	vec3 halfDir = normalize( lightDir + viewDir );\n	float dotNL = saturate( dot( normal, lightDir ) );\n	float dotNV = saturate( dot( normal, viewDir ) );\n	float dotNH = saturate( dot( normal, halfDir ) );\n	float D = D_Charlie( sheenRoughness, dotNH );\n	float V = V_Neubelt( dotNV, dotNL );\n	return sheenColor * ( D * V );\n}\n#endif\nfloat IBLSheenBRDF( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n	float dotNV = saturate( dot( normal, viewDir ) );\n	float r2 = roughness * roughness;\n	float a = roughness < 0.25 ? -339.2 * r2 + 161.4 * roughness - 25.9 : -8.48 * r2 + 14.3 * roughness - 9.95;\n	float b = roughness < 0.25 ? 44.0 * r2 - 23.7 * roughness + 3.26 : 1.97 * r2 - 3.27 * roughness + 0.72;\n	float DG = exp( a * dotNV + b ) + ( roughness < 0.25 ? 0.0 : 0.1 * ( roughness - 0.25 ) );\n	return saturate( DG * RECIPROCAL_PI );\n}\nvec2 DFGApprox( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n	float dotNV = saturate( dot( normal, viewDir ) );\n	const vec4 c0 = vec4( - 1, - 0.0275, - 0.572, 0.022 );\n	const vec4 c1 = vec4( 1, 0.0425, 1.04, - 0.04 );\n	vec4 r = roughness * c0 + c1;\n	float a004 = min( r.x * r.x, exp2( - 9.28 * dotNV ) ) * r.x + r.y;\n	vec2 fab = vec2( - 1.04, 1.04 ) * a004 + r.zw;\n	return fab;\n}\nvec3 EnvironmentBRDF( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness ) {\n	vec2 fab = DFGApprox( normal, viewDir, roughness );\n	return specularColor * fab.x + specularF90 * fab.y;\n}\n#ifdef USE_IRIDESCENCE\nvoid computeMultiscatteringIridescence( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float iridescence, const in vec3 iridescenceF0, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#else\nvoid computeMultiscattering( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#endif\n	vec2 fab = DFGApprox( normal, viewDir, roughness );\n	#ifdef USE_IRIDESCENCE\n		vec3 Fr = mix( specularColor, iridescenceF0, iridescence );\n	#else\n		vec3 Fr = specularColor;\n	#endif\n	vec3 FssEss = Fr * fab.x + specularF90 * fab.y;\n	float Ess = fab.x + fab.y;\n	float Ems = 1.0 - Ess;\n	vec3 Favg = Fr + ( 1.0 - Fr ) * 0.047619;	vec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );\n	singleScatter += FssEss;\n	multiScatter += Fms * Ems;\n}\n#if NUM_RECT_AREA_LIGHTS > 0\n	void RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n		vec3 normal = geometryNormal;\n		vec3 viewDir = geometryViewDir;\n		vec3 position = geometryPosition;\n		vec3 lightPos = rectAreaLight.position;\n		vec3 halfWidth = rectAreaLight.halfWidth;\n		vec3 halfHeight = rectAreaLight.halfHeight;\n		vec3 lightColor = rectAreaLight.color;\n		float roughness = material.roughness;\n		vec3 rectCoords[ 4 ];\n		rectCoords[ 0 ] = lightPos + halfWidth - halfHeight;		rectCoords[ 1 ] = lightPos - halfWidth - halfHeight;\n		rectCoords[ 2 ] = lightPos - halfWidth + halfHeight;\n		rectCoords[ 3 ] = lightPos + halfWidth + halfHeight;\n		vec2 uv = LTC_Uv( normal, viewDir, roughness );\n		vec4 t1 = texture2D( ltc_1, uv );\n		vec4 t2 = texture2D( ltc_2, uv );\n		mat3 mInv = mat3(\n			vec3( t1.x, 0, t1.y ),\n			vec3(    0, 1,    0 ),\n			vec3( t1.z, 0, t1.w )\n		);\n		vec3 fresnel = ( material.specularColor * t2.x + ( vec3( 1.0 ) - material.specularColor ) * t2.y );\n		reflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );\n		reflectedLight.directDiffuse += lightColor * material.diffuseColor * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );\n	}\n#endif\nvoid RE_Direct_Physical( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n	float dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n	vec3 irradiance = dotNL * directLight.color;\n	#ifdef USE_CLEARCOAT\n		float dotNLcc = saturate( dot( geometryClearcoatNormal, directLight.direction ) );\n		vec3 ccIrradiance = dotNLcc * directLight.color;\n		clearcoatSpecularDirect += ccIrradiance * BRDF_GGX_Clearcoat( directLight.direction, geometryViewDir, geometryClearcoatNormal, material );\n	#endif\n	#ifdef USE_SHEEN\n		sheenSpecularDirect += irradiance * BRDF_Sheen( directLight.direction, geometryViewDir, geometryNormal, material.sheenColor, material.sheenRoughness );\n	#endif\n	reflectedLight.directSpecular += irradiance * BRDF_GGX( directLight.direction, geometryViewDir, geometryNormal, material );\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {\n	#ifdef USE_CLEARCOAT\n		clearcoatSpecularIndirect += clearcoatRadiance * EnvironmentBRDF( geometryClearcoatNormal, geometryViewDir, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );\n	#endif\n	#ifdef USE_SHEEN\n		sheenSpecularIndirect += irradiance * material.sheenColor * IBLSheenBRDF( geometryNormal, geometryViewDir, material.sheenRoughness );\n	#endif\n	vec3 singleScattering = vec3( 0.0 );\n	vec3 multiScattering = vec3( 0.0 );\n	vec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;\n	#ifdef USE_IRIDESCENCE\n		computeMultiscatteringIridescence( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.iridescence, material.iridescenceFresnel, material.roughness, singleScattering, multiScattering );\n	#else\n		computeMultiscattering( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.roughness, singleScattering, multiScattering );\n	#endif\n	vec3 totalScattering = singleScattering + multiScattering;\n	vec3 diffuse = material.diffuseColor * ( 1.0 - max( max( totalScattering.r, totalScattering.g ), totalScattering.b ) );\n	reflectedLight.indirectSpecular += radiance * singleScattering;\n	reflectedLight.indirectSpecular += multiScattering * cosineWeightedIrradiance;\n	reflectedLight.indirectDiffuse += diffuse * cosineWeightedIrradiance;\n}\n#define RE_Direct				RE_Direct_Physical\n#define RE_Direct_RectArea		RE_Direct_RectArea_Physical\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_Physical\n#define RE_IndirectSpecular		RE_IndirectSpecular_Physical\nfloat computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {\n	return saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );\n}",
                    lights_fragment_begin: "\nvec3 geometryPosition = - vViewPosition;\nvec3 geometryNormal = normal;\nvec3 geometryViewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );\nvec3 geometryClearcoatNormal = vec3( 0.0 );\n#ifdef USE_CLEARCOAT\n	geometryClearcoatNormal = clearcoatNormal;\n#endif\n#ifdef USE_IRIDESCENCE\n	float dotNVi = saturate( dot( normal, geometryViewDir ) );\n	if ( material.iridescenceThickness == 0.0 ) {\n		material.iridescence = 0.0;\n	} else {\n		material.iridescence = saturate( material.iridescence );\n	}\n	if ( material.iridescence > 0.0 ) {\n		material.iridescenceFresnel = evalIridescence( 1.0, material.iridescenceIOR, dotNVi, material.iridescenceThickness, material.specularColor );\n		material.iridescenceF0 = Schlick_to_F0( material.iridescenceFresnel, 1.0, dotNVi );\n	}\n#endif\nIncidentLight directLight;\n#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )\n	PointLight pointLight;\n	#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0\n	PointLightShadow pointLightShadow;\n	#endif\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n		pointLight = pointLights[ i ];\n		getPointLightInfo( pointLight, geometryPosition, directLight );\n		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS )\n		pointLightShadow = pointLightShadows[ i ];\n		directLight.color *= ( directLight.visible && receiveShadow ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowIntensity, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;\n		#endif\n		RE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )\n	SpotLight spotLight;\n	vec4 spotColor;\n	vec3 spotLightCoord;\n	bool inSpotLightMap;\n	#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0\n	SpotLightShadow spotLightShadow;\n	#endif\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n		spotLight = spotLights[ i ];\n		getSpotLightInfo( spotLight, geometryPosition, directLight );\n		#if ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n		#define SPOT_LIGHT_MAP_INDEX UNROLLED_LOOP_INDEX\n		#elif ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n		#define SPOT_LIGHT_MAP_INDEX NUM_SPOT_LIGHT_MAPS\n		#else\n		#define SPOT_LIGHT_MAP_INDEX ( UNROLLED_LOOP_INDEX - NUM_SPOT_LIGHT_SHADOWS + NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n		#endif\n		#if ( SPOT_LIGHT_MAP_INDEX < NUM_SPOT_LIGHT_MAPS )\n			spotLightCoord = vSpotLightCoord[ i ].xyz / vSpotLightCoord[ i ].w;\n			inSpotLightMap = all( lessThan( abs( spotLightCoord * 2. - 1. ), vec3( 1.0 ) ) );\n			spotColor = texture2D( spotLightMap[ SPOT_LIGHT_MAP_INDEX ], spotLightCoord.xy );\n			directLight.color = inSpotLightMap ? directLight.color * spotColor.rgb : directLight.color;\n		#endif\n		#undef SPOT_LIGHT_MAP_INDEX\n		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n		spotLightShadow = spotLightShadows[ i ];\n		directLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowIntensity, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n		#endif\n		RE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )\n	DirectionalLight directionalLight;\n	#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0\n	DirectionalLightShadow directionalLightShadow;\n	#endif\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n		directionalLight = directionalLights[ i ];\n		getDirectionalLightInfo( directionalLight, directLight );\n		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )\n		directionalLightShadow = directionalLightShadows[ i ];\n		directLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowIntensity, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n		#endif\n		RE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )\n	RectAreaLight rectAreaLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {\n		rectAreaLight = rectAreaLights[ i ];\n		RE_Direct_RectArea( rectAreaLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if defined( RE_IndirectDiffuse )\n	vec3 iblIrradiance = vec3( 0.0 );\n	vec3 irradiance = getAmbientLightIrradiance( ambientLightColor );\n	#if defined( USE_LIGHT_PROBES )\n		irradiance += getLightProbeIrradiance( lightProbe, geometryNormal );\n	#endif\n	#if ( NUM_HEMI_LIGHTS > 0 )\n		#pragma unroll_loop_start\n		for ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n			irradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometryNormal );\n		}\n		#pragma unroll_loop_end\n	#endif\n#endif\n#if defined( RE_IndirectSpecular )\n	vec3 radiance = vec3( 0.0 );\n	vec3 clearcoatRadiance = vec3( 0.0 );\n#endif",
                    lights_fragment_maps: "#if defined( RE_IndirectDiffuse )\n	#ifdef USE_LIGHTMAP\n		vec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n		vec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\n		irradiance += lightMapIrradiance;\n	#endif\n	#if defined( USE_ENVMAP ) && defined( STANDARD ) && defined( ENVMAP_TYPE_CUBE_UV )\n		iblIrradiance += getIBLIrradiance( geometryNormal );\n	#endif\n#endif\n#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )\n	#ifdef USE_ANISOTROPY\n		radiance += getIBLAnisotropyRadiance( geometryViewDir, geometryNormal, material.roughness, material.anisotropyB, material.anisotropy );\n	#else\n		radiance += getIBLRadiance( geometryViewDir, geometryNormal, material.roughness );\n	#endif\n	#ifdef USE_CLEARCOAT\n		clearcoatRadiance += getIBLRadiance( geometryViewDir, geometryClearcoatNormal, material.clearcoatRoughness );\n	#endif\n#endif",
                    lights_fragment_end: "#if defined( RE_IndirectDiffuse )\n	RE_IndirectDiffuse( irradiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n#endif\n#if defined( RE_IndirectSpecular )\n	RE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n#endif",
                    logdepthbuf_fragment: "#if defined( USE_LOGDEPTHBUF )\n	gl_FragDepth = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;\n#endif",
                    logdepthbuf_pars_fragment: "#if defined( USE_LOGDEPTHBUF )\n	uniform float logDepthBufFC;\n	varying float vFragDepth;\n	varying float vIsPerspective;\n#endif",
                    logdepthbuf_pars_vertex: "#ifdef USE_LOGDEPTHBUF\n	varying float vFragDepth;\n	varying float vIsPerspective;\n#endif",
                    logdepthbuf_vertex: "#ifdef USE_LOGDEPTHBUF\n	vFragDepth = 1.0 + gl_Position.w;\n	vIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );\n#endif",
                    map_fragment: "#ifdef USE_MAP\n	vec4 sampledDiffuseColor = texture2D( map, vMapUv );\n	#ifdef DECODE_VIDEO_TEXTURE\n		sampledDiffuseColor = sRGBTransferEOTF( sampledDiffuseColor );\n	#endif\n	diffuseColor *= sampledDiffuseColor;\n#endif",
                    map_pars_fragment: "#ifdef USE_MAP\n	uniform sampler2D map;\n#endif",
                    map_particle_fragment: "#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n	#if defined( USE_POINTS_UV )\n		vec2 uv = vUv;\n	#else\n		vec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;\n	#endif\n#endif\n#ifdef USE_MAP\n	diffuseColor *= texture2D( map, uv );\n#endif\n#ifdef USE_ALPHAMAP\n	diffuseColor.a *= texture2D( alphaMap, uv ).g;\n#endif",
                    map_particle_pars_fragment: "#if defined( USE_POINTS_UV )\n	varying vec2 vUv;\n#else\n	#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n		uniform mat3 uvTransform;\n	#endif\n#endif\n#ifdef USE_MAP\n	uniform sampler2D map;\n#endif\n#ifdef USE_ALPHAMAP\n	uniform sampler2D alphaMap;\n#endif",
                    metalnessmap_fragment: "float metalnessFactor = metalness;\n#ifdef USE_METALNESSMAP\n	vec4 texelMetalness = texture2D( metalnessMap, vMetalnessMapUv );\n	metalnessFactor *= texelMetalness.b;\n#endif",
                    metalnessmap_pars_fragment: "#ifdef USE_METALNESSMAP\n	uniform sampler2D metalnessMap;\n#endif",
                    morphinstance_vertex: "#ifdef USE_INSTANCING_MORPH\n	float morphTargetInfluences[ MORPHTARGETS_COUNT ];\n	float morphTargetBaseInfluence = texelFetch( morphTexture, ivec2( 0, gl_InstanceID ), 0 ).r;\n	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n		morphTargetInfluences[i] =  texelFetch( morphTexture, ivec2( i + 1, gl_InstanceID ), 0 ).r;\n	}\n#endif",
                    morphcolor_vertex: "#if defined( USE_MORPHCOLORS )\n	vColor *= morphTargetBaseInfluence;\n	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n		#if defined( USE_COLOR_ALPHA )\n			if ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ) * morphTargetInfluences[ i ];\n		#elif defined( USE_COLOR )\n			if ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ).rgb * morphTargetInfluences[ i ];\n		#endif\n	}\n#endif",
                    morphnormal_vertex: "#ifdef USE_MORPHNORMALS\n	objectNormal *= morphTargetBaseInfluence;\n	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n		if ( morphTargetInfluences[ i ] != 0.0 ) objectNormal += getMorph( gl_VertexID, i, 1 ).xyz * morphTargetInfluences[ i ];\n	}\n#endif",
                    morphtarget_pars_vertex: "#ifdef USE_MORPHTARGETS\n	#ifndef USE_INSTANCING_MORPH\n		uniform float morphTargetBaseInfluence;\n		uniform float morphTargetInfluences[ MORPHTARGETS_COUNT ];\n	#endif\n	uniform sampler2DArray morphTargetsTexture;\n	uniform ivec2 morphTargetsTextureSize;\n	vec4 getMorph( const in int vertexIndex, const in int morphTargetIndex, const in int offset ) {\n		int texelIndex = vertexIndex * MORPHTARGETS_TEXTURE_STRIDE + offset;\n		int y = texelIndex / morphTargetsTextureSize.x;\n		int x = texelIndex - y * morphTargetsTextureSize.x;\n		ivec3 morphUV = ivec3( x, y, morphTargetIndex );\n		return texelFetch( morphTargetsTexture, morphUV, 0 );\n	}\n#endif",
                    morphtarget_vertex: "#ifdef USE_MORPHTARGETS\n	transformed *= morphTargetBaseInfluence;\n	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n		if ( morphTargetInfluences[ i ] != 0.0 ) transformed += getMorph( gl_VertexID, i, 0 ).xyz * morphTargetInfluences[ i ];\n	}\n#endif",
                    normal_fragment_begin: "float faceDirection = gl_FrontFacing ? 1.0 : - 1.0;\n#ifdef FLAT_SHADED\n	vec3 fdx = dFdx( vViewPosition );\n	vec3 fdy = dFdy( vViewPosition );\n	vec3 normal = normalize( cross( fdx, fdy ) );\n#else\n	vec3 normal = normalize( vNormal );\n	#ifdef DOUBLE_SIDED\n		normal *= faceDirection;\n	#endif\n#endif\n#if defined( USE_NORMALMAP_TANGENTSPACE ) || defined( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY )\n	#ifdef USE_TANGENT\n		mat3 tbn = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n	#else\n		mat3 tbn = getTangentFrame( - vViewPosition, normal,\n		#if defined( USE_NORMALMAP )\n			vNormalMapUv\n		#elif defined( USE_CLEARCOAT_NORMALMAP )\n			vClearcoatNormalMapUv\n		#else\n			vUv\n		#endif\n		);\n	#endif\n	#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )\n		tbn[0] *= faceDirection;\n		tbn[1] *= faceDirection;\n	#endif\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	#ifdef USE_TANGENT\n		mat3 tbn2 = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n	#else\n		mat3 tbn2 = getTangentFrame( - vViewPosition, normal, vClearcoatNormalMapUv );\n	#endif\n	#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )\n		tbn2[0] *= faceDirection;\n		tbn2[1] *= faceDirection;\n	#endif\n#endif\nvec3 nonPerturbedNormal = normal;",
                    normal_fragment_maps: "#ifdef USE_NORMALMAP_OBJECTSPACE\n	normal = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n	#ifdef FLIP_SIDED\n		normal = - normal;\n	#endif\n	#ifdef DOUBLE_SIDED\n		normal = normal * faceDirection;\n	#endif\n	normal = normalize( normalMatrix * normal );\n#elif defined( USE_NORMALMAP_TANGENTSPACE )\n	vec3 mapN = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n	mapN.xy *= normalScale;\n	normal = normalize( tbn * mapN );\n#elif defined( USE_BUMPMAP )\n	normal = perturbNormalArb( - vViewPosition, normal, dHdxy_fwd(), faceDirection );\n#endif",
                    normal_pars_fragment: "#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n	#ifdef USE_TANGENT\n		varying vec3 vTangent;\n		varying vec3 vBitangent;\n	#endif\n#endif",
                    normal_pars_vertex: "#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n	#ifdef USE_TANGENT\n		varying vec3 vTangent;\n		varying vec3 vBitangent;\n	#endif\n#endif",
                    normal_vertex: "#ifndef FLAT_SHADED\n	vNormal = normalize( transformedNormal );\n	#ifdef USE_TANGENT\n		vTangent = normalize( transformedTangent );\n		vBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );\n	#endif\n#endif",
                    normalmap_pars_fragment: "#ifdef USE_NORMALMAP\n	uniform sampler2D normalMap;\n	uniform vec2 normalScale;\n#endif\n#ifdef USE_NORMALMAP_OBJECTSPACE\n	uniform mat3 normalMatrix;\n#endif\n#if ! defined ( USE_TANGENT ) && ( defined ( USE_NORMALMAP_TANGENTSPACE ) || defined ( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY ) )\n	mat3 getTangentFrame( vec3 eye_pos, vec3 surf_norm, vec2 uv ) {\n		vec3 q0 = dFdx( eye_pos.xyz );\n		vec3 q1 = dFdy( eye_pos.xyz );\n		vec2 st0 = dFdx( uv.st );\n		vec2 st1 = dFdy( uv.st );\n		vec3 N = surf_norm;\n		vec3 q1perp = cross( q1, N );\n		vec3 q0perp = cross( N, q0 );\n		vec3 T = q1perp * st0.x + q0perp * st1.x;\n		vec3 B = q1perp * st0.y + q0perp * st1.y;\n		float det = max( dot( T, T ), dot( B, B ) );\n		float scale = ( det == 0.0 ) ? 0.0 : inversesqrt( det );\n		return mat3( T * scale, B * scale, N );\n	}\n#endif",
                    clearcoat_normal_fragment_begin: "#ifdef USE_CLEARCOAT\n	vec3 clearcoatNormal = nonPerturbedNormal;\n#endif",
                    clearcoat_normal_fragment_maps: "#ifdef USE_CLEARCOAT_NORMALMAP\n	vec3 clearcoatMapN = texture2D( clearcoatNormalMap, vClearcoatNormalMapUv ).xyz * 2.0 - 1.0;\n	clearcoatMapN.xy *= clearcoatNormalScale;\n	clearcoatNormal = normalize( tbn2 * clearcoatMapN );\n#endif",
                    clearcoat_pars_fragment: "#ifdef USE_CLEARCOATMAP\n	uniform sampler2D clearcoatMap;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	uniform sampler2D clearcoatNormalMap;\n	uniform vec2 clearcoatNormalScale;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n	uniform sampler2D clearcoatRoughnessMap;\n#endif",
                    iridescence_pars_fragment: "#ifdef USE_IRIDESCENCEMAP\n	uniform sampler2D iridescenceMap;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n	uniform sampler2D iridescenceThicknessMap;\n#endif",
                    opaque_fragment: "#ifdef OPAQUE\ndiffuseColor.a = 1.0;\n#endif\n#ifdef USE_TRANSMISSION\ndiffuseColor.a *= material.transmissionAlpha;\n#endif\ngl_FragColor = vec4( outgoingLight, diffuseColor.a );",
                    packing: "vec3 packNormalToRGB( const in vec3 normal ) {\n	return normalize( normal ) * 0.5 + 0.5;\n}\nvec3 unpackRGBToNormal( const in vec3 rgb ) {\n	return 2.0 * rgb.xyz - 1.0;\n}\nconst float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;const float ShiftRight8 = 1. / 256.;\nconst float Inv255 = 1. / 255.;\nconst vec4 PackFactors = vec4( 1.0, 256.0, 256.0 * 256.0, 256.0 * 256.0 * 256.0 );\nconst vec2 UnpackFactors2 = vec2( UnpackDownscale, 1.0 / PackFactors.g );\nconst vec3 UnpackFactors3 = vec3( UnpackDownscale / PackFactors.rg, 1.0 / PackFactors.b );\nconst vec4 UnpackFactors4 = vec4( UnpackDownscale / PackFactors.rgb, 1.0 / PackFactors.a );\nvec4 packDepthToRGBA( const in float v ) {\n	if( v <= 0.0 )\n		return vec4( 0., 0., 0., 0. );\n	if( v >= 1.0 )\n		return vec4( 1., 1., 1., 1. );\n	float vuf;\n	float af = modf( v * PackFactors.a, vuf );\n	float bf = modf( vuf * ShiftRight8, vuf );\n	float gf = modf( vuf * ShiftRight8, vuf );\n	return vec4( vuf * Inv255, gf * PackUpscale, bf * PackUpscale, af );\n}\nvec3 packDepthToRGB( const in float v ) {\n	if( v <= 0.0 )\n		return vec3( 0., 0., 0. );\n	if( v >= 1.0 )\n		return vec3( 1., 1., 1. );\n	float vuf;\n	float bf = modf( v * PackFactors.b, vuf );\n	float gf = modf( vuf * ShiftRight8, vuf );\n	return vec3( vuf * Inv255, gf * PackUpscale, bf );\n}\nvec2 packDepthToRG( const in float v ) {\n	if( v <= 0.0 )\n		return vec2( 0., 0. );\n	if( v >= 1.0 )\n		return vec2( 1., 1. );\n	float vuf;\n	float gf = modf( v * 256., vuf );\n	return vec2( vuf * Inv255, gf );\n}\nfloat unpackRGBAToDepth( const in vec4 v ) {\n	return dot( v, UnpackFactors4 );\n}\nfloat unpackRGBToDepth( const in vec3 v ) {\n	return dot( v, UnpackFactors3 );\n}\nfloat unpackRGToDepth( const in vec2 v ) {\n	return v.r * UnpackFactors2.r + v.g * UnpackFactors2.g;\n}\nvec4 pack2HalfToRGBA( const in vec2 v ) {\n	vec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ) );\n	return vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w );\n}\nvec2 unpackRGBATo2Half( const in vec4 v ) {\n	return vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );\n}\nfloat viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {\n	return ( viewZ + near ) / ( near - far );\n}\nfloat orthographicDepthToViewZ( const in float depth, const in float near, const in float far ) {\n	return depth * ( near - far ) - near;\n}\nfloat viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {\n	return ( ( near + viewZ ) * far ) / ( ( far - near ) * viewZ );\n}\nfloat perspectiveDepthToViewZ( const in float depth, const in float near, const in float far ) {\n	return ( near * far ) / ( ( far - near ) * depth - far );\n}",
                    premultiplied_alpha_fragment: "#ifdef PREMULTIPLIED_ALPHA\n	gl_FragColor.rgb *= gl_FragColor.a;\n#endif",
                    project_vertex: "vec4 mvPosition = vec4( transformed, 1.0 );\n#ifdef USE_BATCHING\n	mvPosition = batchingMatrix * mvPosition;\n#endif\n#ifdef USE_INSTANCING\n	mvPosition = instanceMatrix * mvPosition;\n#endif\nmvPosition = modelViewMatrix * mvPosition;\ngl_Position = projectionMatrix * mvPosition;",
                    dithering_fragment: "#ifdef DITHERING\n	gl_FragColor.rgb = dithering( gl_FragColor.rgb );\n#endif",
                    dithering_pars_fragment: "#ifdef DITHERING\n	vec3 dithering( vec3 color ) {\n		float grid_position = rand( gl_FragCoord.xy );\n		vec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );\n		dither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );\n		return color + dither_shift_RGB;\n	}\n#endif",
                    roughnessmap_fragment: "float roughnessFactor = roughness;\n#ifdef USE_ROUGHNESSMAP\n	vec4 texelRoughness = texture2D( roughnessMap, vRoughnessMapUv );\n	roughnessFactor *= texelRoughness.g;\n#endif",
                    roughnessmap_pars_fragment: "#ifdef USE_ROUGHNESSMAP\n	uniform sampler2D roughnessMap;\n#endif",
                    shadowmap_pars_fragment: "#if NUM_SPOT_LIGHT_COORDS > 0\n	varying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#if NUM_SPOT_LIGHT_MAPS > 0\n	uniform sampler2D spotLightMap[ NUM_SPOT_LIGHT_MAPS ];\n#endif\n#ifdef USE_SHADOWMAP\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n		uniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];\n		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n		struct DirectionalLightShadow {\n			float shadowIntensity;\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_SPOT_LIGHT_SHADOWS > 0\n		uniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];\n		struct SpotLightShadow {\n			float shadowIntensity;\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n		uniform sampler2D pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];\n		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n		struct PointLightShadow {\n			float shadowIntensity;\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n			float shadowCameraNear;\n			float shadowCameraFar;\n		};\n		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n	#endif\n	float texture2DCompare( sampler2D depths, vec2 uv, float compare ) {\n		return step( compare, unpackRGBAToDepth( texture2D( depths, uv ) ) );\n	}\n	vec2 texture2DDistribution( sampler2D shadow, vec2 uv ) {\n		return unpackRGBATo2Half( texture2D( shadow, uv ) );\n	}\n	float VSMShadow (sampler2D shadow, vec2 uv, float compare ){\n		float occlusion = 1.0;\n		vec2 distribution = texture2DDistribution( shadow, uv );\n		float hard_shadow = step( compare , distribution.x );\n		if (hard_shadow != 1.0 ) {\n			float distance = compare - distribution.x ;\n			float variance = max( 0.00000, distribution.y * distribution.y );\n			float softness_probability = variance / (variance + distance * distance );			softness_probability = clamp( ( softness_probability - 0.3 ) / ( 0.95 - 0.3 ), 0.0, 1.0 );			occlusion = clamp( max( hard_shadow, softness_probability ), 0.0, 1.0 );\n		}\n		return occlusion;\n	}\n	float getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n		float shadow = 1.0;\n		shadowCoord.xyz /= shadowCoord.w;\n		shadowCoord.z += shadowBias;\n		bool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;\n		bool frustumTest = inFrustum && shadowCoord.z <= 1.0;\n		if ( frustumTest ) {\n		#if defined( SHADOWMAP_TYPE_PCF )\n			vec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n			float dx0 = - texelSize.x * shadowRadius;\n			float dy0 = - texelSize.y * shadowRadius;\n			float dx1 = + texelSize.x * shadowRadius;\n			float dy1 = + texelSize.y * shadowRadius;\n			float dx2 = dx0 / 2.0;\n			float dy2 = dy0 / 2.0;\n			float dx3 = dx1 / 2.0;\n			float dy3 = dy1 / 2.0;\n			shadow = (\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy2 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy2 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy2 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy3 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy3 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy3 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )\n			) * ( 1.0 / 17.0 );\n		#elif defined( SHADOWMAP_TYPE_PCF_SOFT )\n			vec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n			float dx = texelSize.x;\n			float dy = texelSize.y;\n			vec2 uv = shadowCoord.xy;\n			vec2 f = fract( uv * shadowMapSize + 0.5 );\n			uv -= f * texelSize;\n			shadow = (\n				texture2DCompare( shadowMap, uv, shadowCoord.z ) +\n				texture2DCompare( shadowMap, uv + vec2( dx, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, uv + vec2( 0.0, dy ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, uv + texelSize, shadowCoord.z ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( -dx, 0.0 ), shadowCoord.z ),\n					 texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 0.0 ), shadowCoord.z ),\n					 f.x ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( -dx, dy ), shadowCoord.z ),\n					 texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, dy ), shadowCoord.z ),\n					 f.x ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( 0.0, -dy ), shadowCoord.z ),\n					 texture2DCompare( shadowMap, uv + vec2( 0.0, 2.0 * dy ), shadowCoord.z ),\n					 f.y ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( dx, -dy ), shadowCoord.z ),\n					 texture2DCompare( shadowMap, uv + vec2( dx, 2.0 * dy ), shadowCoord.z ),\n					 f.y ) +\n				mix( mix( texture2DCompare( shadowMap, uv + vec2( -dx, -dy ), shadowCoord.z ),\n						  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, -dy ), shadowCoord.z ),\n						  f.x ),\n					 mix( texture2DCompare( shadowMap, uv + vec2( -dx, 2.0 * dy ), shadowCoord.z ),\n						  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 2.0 * dy ), shadowCoord.z ),\n						  f.x ),\n					 f.y )\n			) * ( 1.0 / 9.0 );\n		#elif defined( SHADOWMAP_TYPE_VSM )\n			shadow = VSMShadow( shadowMap, shadowCoord.xy, shadowCoord.z );\n		#else\n			shadow = texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );\n		#endif\n		}\n		return mix( 1.0, shadow, shadowIntensity );\n	}\n	vec2 cubeToUV( vec3 v, float texelSizeY ) {\n		vec3 absV = abs( v );\n		float scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );\n		absV *= scaleToCube;\n		v *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );\n		vec2 planar = v.xy;\n		float almostATexel = 1.5 * texelSizeY;\n		float almostOne = 1.0 - almostATexel;\n		if ( absV.z >= almostOne ) {\n			if ( v.z > 0.0 )\n				planar.x = 4.0 - v.x;\n		} else if ( absV.x >= almostOne ) {\n			float signX = sign( v.x );\n			planar.x = v.z * signX + 2.0 * signX;\n		} else if ( absV.y >= almostOne ) {\n			float signY = sign( v.y );\n			planar.x = v.x + 2.0 * signY + 2.0;\n			planar.y = v.z * signY - 2.0;\n		}\n		return vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );\n	}\n	float getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {\n		float shadow = 1.0;\n		vec3 lightToPosition = shadowCoord.xyz;\n		\n		float lightToPositionLength = length( lightToPosition );\n		if ( lightToPositionLength - shadowCameraFar <= 0.0 && lightToPositionLength - shadowCameraNear >= 0.0 ) {\n			float dp = ( lightToPositionLength - shadowCameraNear ) / ( shadowCameraFar - shadowCameraNear );			dp += shadowBias;\n			vec3 bd3D = normalize( lightToPosition );\n			vec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );\n			#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT ) || defined( SHADOWMAP_TYPE_VSM )\n				vec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;\n				shadow = (\n					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +\n					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +\n					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +\n					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +\n					texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +\n					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +\n					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +\n					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +\n					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )\n				) * ( 1.0 / 9.0 );\n			#else\n				shadow = texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );\n			#endif\n		}\n		return mix( 1.0, shadow, shadowIntensity );\n	}\n#endif",
                    shadowmap_pars_vertex: "#if NUM_SPOT_LIGHT_COORDS > 0\n	uniform mat4 spotLightMatrix[ NUM_SPOT_LIGHT_COORDS ];\n	varying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#ifdef USE_SHADOWMAP\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n		uniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];\n		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n		struct DirectionalLightShadow {\n			float shadowIntensity;\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_SPOT_LIGHT_SHADOWS > 0\n		struct SpotLightShadow {\n			float shadowIntensity;\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n		uniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];\n		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n		struct PointLightShadow {\n			float shadowIntensity;\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n			float shadowCameraNear;\n			float shadowCameraFar;\n		};\n		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n	#endif\n#endif",
                    shadowmap_vertex: "#if ( defined( USE_SHADOWMAP ) && ( NUM_DIR_LIGHT_SHADOWS > 0 || NUM_POINT_LIGHT_SHADOWS > 0 ) ) || ( NUM_SPOT_LIGHT_COORDS > 0 )\n	vec3 shadowWorldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n	vec4 shadowWorldPosition;\n#endif\n#if defined( USE_SHADOWMAP )\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n		#pragma unroll_loop_start\n		for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n			shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );\n			vDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;\n		}\n		#pragma unroll_loop_end\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n		#pragma unroll_loop_start\n		for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n			shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );\n			vPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;\n		}\n		#pragma unroll_loop_end\n	#endif\n#endif\n#if NUM_SPOT_LIGHT_COORDS > 0\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_SPOT_LIGHT_COORDS; i ++ ) {\n		shadowWorldPosition = worldPosition;\n		#if ( defined( USE_SHADOWMAP ) && UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n			shadowWorldPosition.xyz += shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias;\n		#endif\n		vSpotLightCoord[ i ] = spotLightMatrix[ i ] * shadowWorldPosition;\n	}\n	#pragma unroll_loop_end\n#endif",
                    shadowmask_pars_fragment: "float getShadowMask() {\n	float shadow = 1.0;\n	#ifdef USE_SHADOWMAP\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n	DirectionalLightShadow directionalLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n		directionalLight = directionalLightShadows[ i ];\n		shadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowIntensity, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#if NUM_SPOT_LIGHT_SHADOWS > 0\n	SpotLightShadow spotLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {\n		spotLight = spotLightShadows[ i ];\n		shadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowIntensity, spotLight.shadowBias, spotLight.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n	PointLightShadow pointLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n		pointLight = pointLightShadows[ i ];\n		shadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowIntensity, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#endif\n	return shadow;\n}",
                    skinbase_vertex: "#ifdef USE_SKINNING\n	mat4 boneMatX = getBoneMatrix( skinIndex.x );\n	mat4 boneMatY = getBoneMatrix( skinIndex.y );\n	mat4 boneMatZ = getBoneMatrix( skinIndex.z );\n	mat4 boneMatW = getBoneMatrix( skinIndex.w );\n#endif",
                    skinning_pars_vertex: "#ifdef USE_SKINNING\n	uniform mat4 bindMatrix;\n	uniform mat4 bindMatrixInverse;\n	uniform highp sampler2D boneTexture;\n	mat4 getBoneMatrix( const in float i ) {\n		int size = textureSize( boneTexture, 0 ).x;\n		int j = int( i ) * 4;\n		int x = j % size;\n		int y = j / size;\n		vec4 v1 = texelFetch( boneTexture, ivec2( x, y ), 0 );\n		vec4 v2 = texelFetch( boneTexture, ivec2( x + 1, y ), 0 );\n		vec4 v3 = texelFetch( boneTexture, ivec2( x + 2, y ), 0 );\n		vec4 v4 = texelFetch( boneTexture, ivec2( x + 3, y ), 0 );\n		return mat4( v1, v2, v3, v4 );\n	}\n#endif",
                    skinning_vertex: "#ifdef USE_SKINNING\n	vec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );\n	vec4 skinned = vec4( 0.0 );\n	skinned += boneMatX * skinVertex * skinWeight.x;\n	skinned += boneMatY * skinVertex * skinWeight.y;\n	skinned += boneMatZ * skinVertex * skinWeight.z;\n	skinned += boneMatW * skinVertex * skinWeight.w;\n	transformed = ( bindMatrixInverse * skinned ).xyz;\n#endif",
                    skinnormal_vertex: "#ifdef USE_SKINNING\n	mat4 skinMatrix = mat4( 0.0 );\n	skinMatrix += skinWeight.x * boneMatX;\n	skinMatrix += skinWeight.y * boneMatY;\n	skinMatrix += skinWeight.z * boneMatZ;\n	skinMatrix += skinWeight.w * boneMatW;\n	skinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;\n	objectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;\n	#ifdef USE_TANGENT\n		objectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n	#endif\n#endif",
                    specularmap_fragment: "float specularStrength;\n#ifdef USE_SPECULARMAP\n	vec4 texelSpecular = texture2D( specularMap, vSpecularMapUv );\n	specularStrength = texelSpecular.r;\n#else\n	specularStrength = 1.0;\n#endif",
                    specularmap_pars_fragment: "#ifdef USE_SPECULARMAP\n	uniform sampler2D specularMap;\n#endif",
                    tonemapping_fragment: "#if defined( TONE_MAPPING )\n	gl_FragColor.rgb = toneMapping( gl_FragColor.rgb );\n#endif",
                    tonemapping_pars_fragment: "#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\nuniform float toneMappingExposure;\nvec3 LinearToneMapping( vec3 color ) {\n	return saturate( toneMappingExposure * color );\n}\nvec3 ReinhardToneMapping( vec3 color ) {\n	color *= toneMappingExposure;\n	return saturate( color / ( vec3( 1.0 ) + color ) );\n}\nvec3 CineonToneMapping( vec3 color ) {\n	color *= toneMappingExposure;\n	color = max( vec3( 0.0 ), color - 0.004 );\n	return pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );\n}\nvec3 RRTAndODTFit( vec3 v ) {\n	vec3 a = v * ( v + 0.0245786 ) - 0.000090537;\n	vec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;\n	return a / b;\n}\nvec3 ACESFilmicToneMapping( vec3 color ) {\n	const mat3 ACESInputMat = mat3(\n		vec3( 0.59719, 0.07600, 0.02840 ),		vec3( 0.35458, 0.90834, 0.13383 ),\n		vec3( 0.04823, 0.01566, 0.83777 )\n	);\n	const mat3 ACESOutputMat = mat3(\n		vec3(  1.60475, -0.10208, -0.00327 ),		vec3( -0.53108,  1.10813, -0.07276 ),\n		vec3( -0.07367, -0.00605,  1.07602 )\n	);\n	color *= toneMappingExposure / 0.6;\n	color = ACESInputMat * color;\n	color = RRTAndODTFit( color );\n	color = ACESOutputMat * color;\n	return saturate( color );\n}\nconst mat3 LINEAR_REC2020_TO_LINEAR_SRGB = mat3(\n	vec3( 1.6605, - 0.1246, - 0.0182 ),\n	vec3( - 0.5876, 1.1329, - 0.1006 ),\n	vec3( - 0.0728, - 0.0083, 1.1187 )\n);\nconst mat3 LINEAR_SRGB_TO_LINEAR_REC2020 = mat3(\n	vec3( 0.6274, 0.0691, 0.0164 ),\n	vec3( 0.3293, 0.9195, 0.0880 ),\n	vec3( 0.0433, 0.0113, 0.8956 )\n);\nvec3 agxDefaultContrastApprox( vec3 x ) {\n	vec3 x2 = x * x;\n	vec3 x4 = x2 * x2;\n	return + 15.5 * x4 * x2\n		- 40.14 * x4 * x\n		+ 31.96 * x4\n		- 6.868 * x2 * x\n		+ 0.4298 * x2\n		+ 0.1191 * x\n		- 0.00232;\n}\nvec3 AgXToneMapping( vec3 color ) {\n	const mat3 AgXInsetMatrix = mat3(\n		vec3( 0.856627153315983, 0.137318972929847, 0.11189821299995 ),\n		vec3( 0.0951212405381588, 0.761241990602591, 0.0767994186031903 ),\n		vec3( 0.0482516061458583, 0.101439036467562, 0.811302368396859 )\n	);\n	const mat3 AgXOutsetMatrix = mat3(\n		vec3( 1.1271005818144368, - 0.1413297634984383, - 0.14132976349843826 ),\n		vec3( - 0.11060664309660323, 1.157823702216272, - 0.11060664309660294 ),\n		vec3( - 0.016493938717834573, - 0.016493938717834257, 1.2519364065950405 )\n	);\n	const float AgxMinEv = - 12.47393;	const float AgxMaxEv = 4.026069;\n	color *= toneMappingExposure;\n	color = LINEAR_SRGB_TO_LINEAR_REC2020 * color;\n	color = AgXInsetMatrix * color;\n	color = max( color, 1e-10 );	color = log2( color );\n	color = ( color - AgxMinEv ) / ( AgxMaxEv - AgxMinEv );\n	color = clamp( color, 0.0, 1.0 );\n	color = agxDefaultContrastApprox( color );\n	color = AgXOutsetMatrix * color;\n	color = pow( max( vec3( 0.0 ), color ), vec3( 2.2 ) );\n	color = LINEAR_REC2020_TO_LINEAR_SRGB * color;\n	color = clamp( color, 0.0, 1.0 );\n	return color;\n}\nvec3 NeutralToneMapping( vec3 color ) {\n	const float StartCompression = 0.8 - 0.04;\n	const float Desaturation = 0.15;\n	color *= toneMappingExposure;\n	float x = min( color.r, min( color.g, color.b ) );\n	float offset = x < 0.08 ? x - 6.25 * x * x : 0.04;\n	color -= offset;\n	float peak = max( color.r, max( color.g, color.b ) );\n	if ( peak < StartCompression ) return color;\n	float d = 1. - StartCompression;\n	float newPeak = 1. - d * d / ( peak + d - StartCompression );\n	color *= newPeak / peak;\n	float g = 1. - 1. / ( Desaturation * ( peak - newPeak ) + 1. );\n	return mix( color, vec3( newPeak ), g );\n}\nvec3 CustomToneMapping( vec3 color ) { return color; }",
                    transmission_fragment: "#ifdef USE_TRANSMISSION\n	material.transmission = transmission;\n	material.transmissionAlpha = 1.0;\n	material.thickness = thickness;\n	material.attenuationDistance = attenuationDistance;\n	material.attenuationColor = attenuationColor;\n	#ifdef USE_TRANSMISSIONMAP\n		material.transmission *= texture2D( transmissionMap, vTransmissionMapUv ).r;\n	#endif\n	#ifdef USE_THICKNESSMAP\n		material.thickness *= texture2D( thicknessMap, vThicknessMapUv ).g;\n	#endif\n	vec3 pos = vWorldPosition;\n	vec3 v = normalize( cameraPosition - pos );\n	vec3 n = inverseTransformDirection( normal, viewMatrix );\n	vec4 transmitted = getIBLVolumeRefraction(\n		n, v, material.roughness, material.diffuseColor, material.specularColor, material.specularF90,\n		pos, modelMatrix, viewMatrix, projectionMatrix, material.dispersion, material.ior, material.thickness,\n		material.attenuationColor, material.attenuationDistance );\n	material.transmissionAlpha = mix( material.transmissionAlpha, transmitted.a, material.transmission );\n	totalDiffuse = mix( totalDiffuse, transmitted.rgb, material.transmission );\n#endif",
                    transmission_pars_fragment: "#ifdef USE_TRANSMISSION\n	uniform float transmission;\n	uniform float thickness;\n	uniform float attenuationDistance;\n	uniform vec3 attenuationColor;\n	#ifdef USE_TRANSMISSIONMAP\n		uniform sampler2D transmissionMap;\n	#endif\n	#ifdef USE_THICKNESSMAP\n		uniform sampler2D thicknessMap;\n	#endif\n	uniform vec2 transmissionSamplerSize;\n	uniform sampler2D transmissionSamplerMap;\n	uniform mat4 modelMatrix;\n	uniform mat4 projectionMatrix;\n	varying vec3 vWorldPosition;\n	float w0( float a ) {\n		return ( 1.0 / 6.0 ) * ( a * ( a * ( - a + 3.0 ) - 3.0 ) + 1.0 );\n	}\n	float w1( float a ) {\n		return ( 1.0 / 6.0 ) * ( a *  a * ( 3.0 * a - 6.0 ) + 4.0 );\n	}\n	float w2( float a ){\n		return ( 1.0 / 6.0 ) * ( a * ( a * ( - 3.0 * a + 3.0 ) + 3.0 ) + 1.0 );\n	}\n	float w3( float a ) {\n		return ( 1.0 / 6.0 ) * ( a * a * a );\n	}\n	float g0( float a ) {\n		return w0( a ) + w1( a );\n	}\n	float g1( float a ) {\n		return w2( a ) + w3( a );\n	}\n	float h0( float a ) {\n		return - 1.0 + w1( a ) / ( w0( a ) + w1( a ) );\n	}\n	float h1( float a ) {\n		return 1.0 + w3( a ) / ( w2( a ) + w3( a ) );\n	}\n	vec4 bicubic( sampler2D tex, vec2 uv, vec4 texelSize, float lod ) {\n		uv = uv * texelSize.zw + 0.5;\n		vec2 iuv = floor( uv );\n		vec2 fuv = fract( uv );\n		float g0x = g0( fuv.x );\n		float g1x = g1( fuv.x );\n		float h0x = h0( fuv.x );\n		float h1x = h1( fuv.x );\n		float h0y = h0( fuv.y );\n		float h1y = h1( fuv.y );\n		vec2 p0 = ( vec2( iuv.x + h0x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n		vec2 p1 = ( vec2( iuv.x + h1x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n		vec2 p2 = ( vec2( iuv.x + h0x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n		vec2 p3 = ( vec2( iuv.x + h1x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n		return g0( fuv.y ) * ( g0x * textureLod( tex, p0, lod ) + g1x * textureLod( tex, p1, lod ) ) +\n			g1( fuv.y ) * ( g0x * textureLod( tex, p2, lod ) + g1x * textureLod( tex, p3, lod ) );\n	}\n	vec4 textureBicubic( sampler2D sampler, vec2 uv, float lod ) {\n		vec2 fLodSize = vec2( textureSize( sampler, int( lod ) ) );\n		vec2 cLodSize = vec2( textureSize( sampler, int( lod + 1.0 ) ) );\n		vec2 fLodSizeInv = 1.0 / fLodSize;\n		vec2 cLodSizeInv = 1.0 / cLodSize;\n		vec4 fSample = bicubic( sampler, uv, vec4( fLodSizeInv, fLodSize ), floor( lod ) );\n		vec4 cSample = bicubic( sampler, uv, vec4( cLodSizeInv, cLodSize ), ceil( lod ) );\n		return mix( fSample, cSample, fract( lod ) );\n	}\n	vec3 getVolumeTransmissionRay( const in vec3 n, const in vec3 v, const in float thickness, const in float ior, const in mat4 modelMatrix ) {\n		vec3 refractionVector = refract( - v, normalize( n ), 1.0 / ior );\n		vec3 modelScale;\n		modelScale.x = length( vec3( modelMatrix[ 0 ].xyz ) );\n		modelScale.y = length( vec3( modelMatrix[ 1 ].xyz ) );\n		modelScale.z = length( vec3( modelMatrix[ 2 ].xyz ) );\n		return normalize( refractionVector ) * thickness * modelScale;\n	}\n	float applyIorToRoughness( const in float roughness, const in float ior ) {\n		return roughness * clamp( ior * 2.0 - 2.0, 0.0, 1.0 );\n	}\n	vec4 getTransmissionSample( const in vec2 fragCoord, const in float roughness, const in float ior ) {\n		float lod = log2( transmissionSamplerSize.x ) * applyIorToRoughness( roughness, ior );\n		return textureBicubic( transmissionSamplerMap, fragCoord.xy, lod );\n	}\n	vec3 volumeAttenuation( const in float transmissionDistance, const in vec3 attenuationColor, const in float attenuationDistance ) {\n		if ( isinf( attenuationDistance ) ) {\n			return vec3( 1.0 );\n		} else {\n			vec3 attenuationCoefficient = -log( attenuationColor ) / attenuationDistance;\n			vec3 transmittance = exp( - attenuationCoefficient * transmissionDistance );			return transmittance;\n		}\n	}\n	vec4 getIBLVolumeRefraction( const in vec3 n, const in vec3 v, const in float roughness, const in vec3 diffuseColor,\n		const in vec3 specularColor, const in float specularF90, const in vec3 position, const in mat4 modelMatrix,\n		const in mat4 viewMatrix, const in mat4 projMatrix, const in float dispersion, const in float ior, const in float thickness,\n		const in vec3 attenuationColor, const in float attenuationDistance ) {\n		vec4 transmittedLight;\n		vec3 transmittance;\n		#ifdef USE_DISPERSION\n			float halfSpread = ( ior - 1.0 ) * 0.025 * dispersion;\n			vec3 iors = vec3( ior - halfSpread, ior, ior + halfSpread );\n			for ( int i = 0; i < 3; i ++ ) {\n				vec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, iors[ i ], modelMatrix );\n				vec3 refractedRayExit = position + transmissionRay;\n				vec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );\n				vec2 refractionCoords = ndcPos.xy / ndcPos.w;\n				refractionCoords += 1.0;\n				refractionCoords /= 2.0;\n				vec4 transmissionSample = getTransmissionSample( refractionCoords, roughness, iors[ i ] );\n				transmittedLight[ i ] = transmissionSample[ i ];\n				transmittedLight.a += transmissionSample.a;\n				transmittance[ i ] = diffuseColor[ i ] * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance )[ i ];\n			}\n			transmittedLight.a /= 3.0;\n		#else\n			vec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, ior, modelMatrix );\n			vec3 refractedRayExit = position + transmissionRay;\n			vec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );\n			vec2 refractionCoords = ndcPos.xy / ndcPos.w;\n			refractionCoords += 1.0;\n			refractionCoords /= 2.0;\n			transmittedLight = getTransmissionSample( refractionCoords, roughness, ior );\n			transmittance = diffuseColor * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance );\n		#endif\n		vec3 attenuatedColor = transmittance * transmittedLight.rgb;\n		vec3 F = EnvironmentBRDF( n, v, specularColor, specularF90, roughness );\n		float transmittanceFactor = ( transmittance.r + transmittance.g + transmittance.b ) / 3.0;\n		return vec4( ( 1.0 - F ) * attenuatedColor, 1.0 - ( 1.0 - transmittedLight.a ) * transmittanceFactor );\n	}\n#endif",
                    uv_pars_fragment: "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n	varying vec2 vUv;\n#endif\n#ifdef USE_MAP\n	varying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n	varying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n	varying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n	varying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n	varying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n	varying vec2 vNormalMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n	varying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n	varying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n	varying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_ANISOTROPYMAP\n	varying vec2 vAnisotropyMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n	varying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	varying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n	varying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n	varying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n	varying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n	varying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n	varying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n	varying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n	varying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n	varying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n	uniform mat3 transmissionMapTransform;\n	varying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n	uniform mat3 thicknessMapTransform;\n	varying vec2 vThicknessMapUv;\n#endif",
                    uv_pars_vertex: "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n	varying vec2 vUv;\n#endif\n#ifdef USE_MAP\n	uniform mat3 mapTransform;\n	varying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n	uniform mat3 alphaMapTransform;\n	varying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n	uniform mat3 lightMapTransform;\n	varying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n	uniform mat3 aoMapTransform;\n	varying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n	uniform mat3 bumpMapTransform;\n	varying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n	uniform mat3 normalMapTransform;\n	varying vec2 vNormalMapUv;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n	uniform mat3 displacementMapTransform;\n	varying vec2 vDisplacementMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n	uniform mat3 emissiveMapTransform;\n	varying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n	uniform mat3 metalnessMapTransform;\n	varying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n	uniform mat3 roughnessMapTransform;\n	varying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_ANISOTROPYMAP\n	uniform mat3 anisotropyMapTransform;\n	varying vec2 vAnisotropyMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n	uniform mat3 clearcoatMapTransform;\n	varying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	uniform mat3 clearcoatNormalMapTransform;\n	varying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n	uniform mat3 clearcoatRoughnessMapTransform;\n	varying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n	uniform mat3 sheenColorMapTransform;\n	varying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n	uniform mat3 sheenRoughnessMapTransform;\n	varying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n	uniform mat3 iridescenceMapTransform;\n	varying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n	uniform mat3 iridescenceThicknessMapTransform;\n	varying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n	uniform mat3 specularMapTransform;\n	varying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n	uniform mat3 specularColorMapTransform;\n	varying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n	uniform mat3 specularIntensityMapTransform;\n	varying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n	uniform mat3 transmissionMapTransform;\n	varying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n	uniform mat3 thicknessMapTransform;\n	varying vec2 vThicknessMapUv;\n#endif",
                    uv_vertex: "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n	vUv = vec3( uv, 1 ).xy;\n#endif\n#ifdef USE_MAP\n	vMapUv = ( mapTransform * vec3( MAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ALPHAMAP\n	vAlphaMapUv = ( alphaMapTransform * vec3( ALPHAMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_LIGHTMAP\n	vLightMapUv = ( lightMapTransform * vec3( LIGHTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_AOMAP\n	vAoMapUv = ( aoMapTransform * vec3( AOMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_BUMPMAP\n	vBumpMapUv = ( bumpMapTransform * vec3( BUMPMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_NORMALMAP\n	vNormalMapUv = ( normalMapTransform * vec3( NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n	vDisplacementMapUv = ( displacementMapTransform * vec3( DISPLACEMENTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_EMISSIVEMAP\n	vEmissiveMapUv = ( emissiveMapTransform * vec3( EMISSIVEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_METALNESSMAP\n	vMetalnessMapUv = ( metalnessMapTransform * vec3( METALNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ROUGHNESSMAP\n	vRoughnessMapUv = ( roughnessMapTransform * vec3( ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ANISOTROPYMAP\n	vAnisotropyMapUv = ( anisotropyMapTransform * vec3( ANISOTROPYMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOATMAP\n	vClearcoatMapUv = ( clearcoatMapTransform * vec3( CLEARCOATMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	vClearcoatNormalMapUv = ( clearcoatNormalMapTransform * vec3( CLEARCOAT_NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n	vClearcoatRoughnessMapUv = ( clearcoatRoughnessMapTransform * vec3( CLEARCOAT_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n	vIridescenceMapUv = ( iridescenceMapTransform * vec3( IRIDESCENCEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n	vIridescenceThicknessMapUv = ( iridescenceThicknessMapTransform * vec3( IRIDESCENCE_THICKNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n	vSheenColorMapUv = ( sheenColorMapTransform * vec3( SHEEN_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n	vSheenRoughnessMapUv = ( sheenRoughnessMapTransform * vec3( SHEEN_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULARMAP\n	vSpecularMapUv = ( specularMapTransform * vec3( SPECULARMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n	vSpecularColorMapUv = ( specularColorMapTransform * vec3( SPECULAR_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n	vSpecularIntensityMapUv = ( specularIntensityMapTransform * vec3( SPECULAR_INTENSITYMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n	vTransmissionMapUv = ( transmissionMapTransform * vec3( TRANSMISSIONMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_THICKNESSMAP\n	vThicknessMapUv = ( thicknessMapTransform * vec3( THICKNESSMAP_UV, 1 ) ).xy;\n#endif",
                    worldpos_vertex: "#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP ) || defined ( USE_TRANSMISSION ) || NUM_SPOT_LIGHT_COORDS > 0\n	vec4 worldPosition = vec4( transformed, 1.0 );\n	#ifdef USE_BATCHING\n		worldPosition = batchingMatrix * worldPosition;\n	#endif\n	#ifdef USE_INSTANCING\n		worldPosition = instanceMatrix * worldPosition;\n	#endif\n	worldPosition = modelMatrix * worldPosition;\n#endif",
                    background_vert: "varying vec2 vUv;\nuniform mat3 uvTransform;\nvoid main() {\n	vUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n	gl_Position = vec4( position.xy, 1.0, 1.0 );\n}",
                    background_frag: "uniform sampler2D t2D;\nuniform float backgroundIntensity;\nvarying vec2 vUv;\nvoid main() {\n	vec4 texColor = texture2D( t2D, vUv );\n	#ifdef DECODE_VIDEO_TEXTURE\n		texColor = vec4( mix( pow( texColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), texColor.rgb * 0.0773993808, vec3( lessThanEqual( texColor.rgb, vec3( 0.04045 ) ) ) ), texColor.w );\n	#endif\n	texColor.rgb *= backgroundIntensity;\n	gl_FragColor = texColor;\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n}",
                    backgroundCube_vert: "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vWorldDirection = transformDirection( position, modelMatrix );\n	#include <begin_vertex>\n	#include <project_vertex>\n	gl_Position.z = gl_Position.w;\n}",
                    backgroundCube_frag: "#ifdef ENVMAP_TYPE_CUBE\n	uniform samplerCube envMap;\n#elif defined( ENVMAP_TYPE_CUBE_UV )\n	uniform sampler2D envMap;\n#endif\nuniform float flipEnvMap;\nuniform float backgroundBlurriness;\nuniform float backgroundIntensity;\nuniform mat3 backgroundRotation;\nvarying vec3 vWorldDirection;\n#include <cube_uv_reflection_fragment>\nvoid main() {\n	#ifdef ENVMAP_TYPE_CUBE\n		vec4 texColor = textureCube( envMap, backgroundRotation * vec3( flipEnvMap * vWorldDirection.x, vWorldDirection.yz ) );\n	#elif defined( ENVMAP_TYPE_CUBE_UV )\n		vec4 texColor = textureCubeUV( envMap, backgroundRotation * vWorldDirection, backgroundBlurriness );\n	#else\n		vec4 texColor = vec4( 0.0, 0.0, 0.0, 1.0 );\n	#endif\n	texColor.rgb *= backgroundIntensity;\n	gl_FragColor = texColor;\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n}",
                    cube_vert: "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vWorldDirection = transformDirection( position, modelMatrix );\n	#include <begin_vertex>\n	#include <project_vertex>\n	gl_Position.z = gl_Position.w;\n}",
                    cube_frag: "uniform samplerCube tCube;\nuniform float tFlip;\nuniform float opacity;\nvarying vec3 vWorldDirection;\nvoid main() {\n	vec4 texColor = textureCube( tCube, vec3( tFlip * vWorldDirection.x, vWorldDirection.yz ) );\n	gl_FragColor = texColor;\n	gl_FragColor.a *= opacity;\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n}",
                    depth_vert: "#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n	#include <uv_vertex>\n	#include <batching_vertex>\n	#include <skinbase_vertex>\n	#include <morphinstance_vertex>\n	#ifdef USE_DISPLACEMENTMAP\n		#include <beginnormal_vertex>\n		#include <morphnormal_vertex>\n		#include <skinnormal_vertex>\n	#endif\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vHighPrecisionZW = gl_Position.zw;\n}",
                    depth_frag: "#if DEPTH_PACKING == 3200\n	uniform float opacity;\n#endif\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n	vec4 diffuseColor = vec4( 1.0 );\n	#include <clipping_planes_fragment>\n	#if DEPTH_PACKING == 3200\n		diffuseColor.a = opacity;\n	#endif\n	#include <map_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <logdepthbuf_fragment>\n	float fragCoordZ = 0.5 * vHighPrecisionZW[0] / vHighPrecisionZW[1] + 0.5;\n	#if DEPTH_PACKING == 3200\n		gl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );\n	#elif DEPTH_PACKING == 3201\n		gl_FragColor = packDepthToRGBA( fragCoordZ );\n	#elif DEPTH_PACKING == 3202\n		gl_FragColor = vec4( packDepthToRGB( fragCoordZ ), 1.0 );\n	#elif DEPTH_PACKING == 3203\n		gl_FragColor = vec4( packDepthToRG( fragCoordZ ), 0.0, 1.0 );\n	#endif\n}",
                    distanceRGBA_vert: "#define DISTANCE\nvarying vec3 vWorldPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <batching_vertex>\n	#include <skinbase_vertex>\n	#include <morphinstance_vertex>\n	#ifdef USE_DISPLACEMENTMAP\n		#include <beginnormal_vertex>\n		#include <morphnormal_vertex>\n		#include <skinnormal_vertex>\n	#endif\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <worldpos_vertex>\n	#include <clipping_planes_vertex>\n	vWorldPosition = worldPosition.xyz;\n}",
                    distanceRGBA_frag: "#define DISTANCE\nuniform vec3 referencePosition;\nuniform float nearDistance;\nuniform float farDistance;\nvarying vec3 vWorldPosition;\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main () {\n	vec4 diffuseColor = vec4( 1.0 );\n	#include <clipping_planes_fragment>\n	#include <map_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	float dist = length( vWorldPosition - referencePosition );\n	dist = ( dist - nearDistance ) / ( farDistance - nearDistance );\n	dist = saturate( dist );\n	gl_FragColor = packDepthToRGBA( dist );\n}",
                    equirect_vert: "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vWorldDirection = transformDirection( position, modelMatrix );\n	#include <begin_vertex>\n	#include <project_vertex>\n}",
                    equirect_frag: "uniform sampler2D tEquirect;\nvarying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vec3 direction = normalize( vWorldDirection );\n	vec2 sampleUV = equirectUv( direction );\n	gl_FragColor = texture2D( tEquirect, sampleUV );\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n}",
                    linedashed_vert: "uniform float scale;\nattribute float lineDistance;\nvarying float vLineDistance;\n#include <common>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	vLineDistance = scale * lineDistance;\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphinstance_vertex>\n	#include <morphcolor_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <fog_vertex>\n}",
                    linedashed_frag: "uniform vec3 diffuse;\nuniform float opacity;\nuniform float dashSize;\nuniform float totalSize;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <clipping_planes_fragment>\n	if ( mod( vLineDistance, totalSize ) > dashSize ) {\n		discard;\n	}\n	vec3 outgoingLight = vec3( 0.0 );\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	outgoingLight = diffuseColor.rgb;\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n}",
                    meshbasic_vert: "#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphinstance_vertex>\n	#include <morphcolor_vertex>\n	#include <batching_vertex>\n	#if defined ( USE_ENVMAP ) || defined ( USE_SKINNING )\n		#include <beginnormal_vertex>\n		#include <morphnormal_vertex>\n		#include <skinbase_vertex>\n		#include <skinnormal_vertex>\n		#include <defaultnormal_vertex>\n	#endif\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <worldpos_vertex>\n	#include <envmap_vertex>\n	#include <fog_vertex>\n}",
                    meshbasic_frag: "uniform vec3 diffuse;\nuniform float opacity;\n#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n#endif\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <clipping_planes_fragment>\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <specularmap_fragment>\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	#ifdef USE_LIGHTMAP\n		vec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n		reflectedLight.indirectDiffuse += lightMapTexel.rgb * lightMapIntensity * RECIPROCAL_PI;\n	#else\n		reflectedLight.indirectDiffuse += vec3( 1.0 );\n	#endif\n	#include <aomap_fragment>\n	reflectedLight.indirectDiffuse *= diffuseColor.rgb;\n	vec3 outgoingLight = reflectedLight.indirectDiffuse;\n	#include <envmap_fragment>\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}",
                    meshlambert_vert: "#define LAMBERT\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphinstance_vertex>\n	#include <morphcolor_vertex>\n	#include <batching_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <envmap_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}",
                    meshlambert_frag: "#define LAMBERT\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_lambert_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <clipping_planes_fragment>\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <specularmap_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_lambert_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n	#include <envmap_fragment>\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}",
                    meshmatcap_vert: "#define MATCAP\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphinstance_vertex>\n	#include <morphcolor_vertex>\n	#include <batching_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <fog_vertex>\n	vViewPosition = - mvPosition.xyz;\n}",
                    meshmatcap_frag: "#define MATCAP\nuniform vec3 diffuse;\nuniform float opacity;\nuniform sampler2D matcap;\nvarying vec3 vViewPosition;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <clipping_planes_fragment>\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	vec3 viewDir = normalize( vViewPosition );\n	vec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );\n	vec3 y = cross( viewDir, x );\n	vec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;\n	#ifdef USE_MATCAP\n		vec4 matcapColor = texture2D( matcap, uv );\n	#else\n		vec4 matcapColor = vec4( vec3( mix( 0.2, 0.8, uv.y ) ), 1.0 );\n	#endif\n	vec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}",
                    meshnormal_vert: "#define NORMAL\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n	varying vec3 vViewPosition;\n#endif\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <batching_vertex>\n	#include <beginnormal_vertex>\n	#include <morphinstance_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n	vViewPosition = - mvPosition.xyz;\n#endif\n}",
                    meshnormal_frag: "#define NORMAL\nuniform float opacity;\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n	varying vec3 vViewPosition;\n#endif\n#include <packing>\n#include <uv_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( 0.0, 0.0, 0.0, opacity );\n	#include <clipping_planes_fragment>\n	#include <logdepthbuf_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	gl_FragColor = vec4( packNormalToRGB( normal ), diffuseColor.a );\n	#ifdef OPAQUE\n		gl_FragColor.a = 1.0;\n	#endif\n}",
                    meshphong_vert: "#define PHONG\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <batching_vertex>\n	#include <beginnormal_vertex>\n	#include <morphinstance_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <envmap_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}",
                    meshphong_frag: "#define PHONG\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform vec3 specular;\nuniform float shininess;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_phong_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <clipping_planes_fragment>\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <specularmap_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_phong_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n	#include <envmap_fragment>\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}",
                    meshphysical_vert: "#define STANDARD\nvarying vec3 vViewPosition;\n#ifdef USE_TRANSMISSION\n	varying vec3 vWorldPosition;\n#endif\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphinstance_vertex>\n	#include <morphcolor_vertex>\n	#include <batching_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n#ifdef USE_TRANSMISSION\n	vWorldPosition = worldPosition.xyz;\n#endif\n}",
                    meshphysical_frag: "#define STANDARD\n#ifdef PHYSICAL\n	#define IOR\n	#define USE_SPECULAR\n#endif\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float roughness;\nuniform float metalness;\nuniform float opacity;\n#ifdef IOR\n	uniform float ior;\n#endif\n#ifdef USE_SPECULAR\n	uniform float specularIntensity;\n	uniform vec3 specularColor;\n	#ifdef USE_SPECULAR_COLORMAP\n		uniform sampler2D specularColorMap;\n	#endif\n	#ifdef USE_SPECULAR_INTENSITYMAP\n		uniform sampler2D specularIntensityMap;\n	#endif\n#endif\n#ifdef USE_CLEARCOAT\n	uniform float clearcoat;\n	uniform float clearcoatRoughness;\n#endif\n#ifdef USE_DISPERSION\n	uniform float dispersion;\n#endif\n#ifdef USE_IRIDESCENCE\n	uniform float iridescence;\n	uniform float iridescenceIOR;\n	uniform float iridescenceThicknessMinimum;\n	uniform float iridescenceThicknessMaximum;\n#endif\n#ifdef USE_SHEEN\n	uniform vec3 sheenColor;\n	uniform float sheenRoughness;\n	#ifdef USE_SHEEN_COLORMAP\n		uniform sampler2D sheenColorMap;\n	#endif\n	#ifdef USE_SHEEN_ROUGHNESSMAP\n		uniform sampler2D sheenRoughnessMap;\n	#endif\n#endif\n#ifdef USE_ANISOTROPY\n	uniform vec2 anisotropyVector;\n	#ifdef USE_ANISOTROPYMAP\n		uniform sampler2D anisotropyMap;\n	#endif\n#endif\nvarying vec3 vViewPosition;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <iridescence_fragment>\n#include <cube_uv_reflection_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_physical_pars_fragment>\n#include <fog_pars_fragment>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_physical_pars_fragment>\n#include <transmission_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <clearcoat_pars_fragment>\n#include <iridescence_pars_fragment>\n#include <roughnessmap_pars_fragment>\n#include <metalnessmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <clipping_planes_fragment>\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <roughnessmap_fragment>\n	#include <metalnessmap_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <clearcoat_normal_fragment_begin>\n	#include <clearcoat_normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_physical_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 totalDiffuse = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;\n	vec3 totalSpecular = reflectedLight.directSpecular + reflectedLight.indirectSpecular;\n	#include <transmission_fragment>\n	vec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;\n	#ifdef USE_SHEEN\n		float sheenEnergyComp = 1.0 - 0.157 * max3( material.sheenColor );\n		outgoingLight = outgoingLight * sheenEnergyComp + sheenSpecularDirect + sheenSpecularIndirect;\n	#endif\n	#ifdef USE_CLEARCOAT\n		float dotNVcc = saturate( dot( geometryClearcoatNormal, geometryViewDir ) );\n		vec3 Fcc = F_Schlick( material.clearcoatF0, material.clearcoatF90, dotNVcc );\n		outgoingLight = outgoingLight * ( 1.0 - material.clearcoat * Fcc ) + ( clearcoatSpecularDirect + clearcoatSpecularIndirect ) * material.clearcoat;\n	#endif\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}",
                    meshtoon_vert: "#define TOON\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphinstance_vertex>\n	#include <morphcolor_vertex>\n	#include <batching_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}",
                    meshtoon_frag: "#define TOON\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <gradientmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_toon_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <clipping_planes_fragment>\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_toon_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}",
                    points_vert: "uniform float size;\nuniform float scale;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\n#ifdef USE_POINTS_UV\n	varying vec2 vUv;\n	uniform mat3 uvTransform;\n#endif\nvoid main() {\n	#ifdef USE_POINTS_UV\n		vUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n	#endif\n	#include <color_vertex>\n	#include <morphinstance_vertex>\n	#include <morphcolor_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <project_vertex>\n	gl_PointSize = size;\n	#ifdef USE_SIZEATTENUATION\n		bool isPerspective = isPerspectiveMatrix( projectionMatrix );\n		if ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );\n	#endif\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <worldpos_vertex>\n	#include <fog_vertex>\n}",
                    points_frag: "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <color_pars_fragment>\n#include <map_particle_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <clipping_planes_fragment>\n	vec3 outgoingLight = vec3( 0.0 );\n	#include <logdepthbuf_fragment>\n	#include <map_particle_fragment>\n	#include <color_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	outgoingLight = diffuseColor.rgb;\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n}",
                    shadow_vert: "#include <common>\n#include <batching_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <shadowmap_pars_vertex>\nvoid main() {\n	#include <batching_vertex>\n	#include <beginnormal_vertex>\n	#include <morphinstance_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <worldpos_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}",
                    shadow_frag: "uniform vec3 color;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <logdepthbuf_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\nvoid main() {\n	#include <logdepthbuf_fragment>\n	gl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n}",
                    sprite_vert: "uniform float rotation;\nuniform vec2 center;\n#include <common>\n#include <uv_pars_vertex>\n#include <fog_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	vec4 mvPosition = modelViewMatrix[ 3 ];\n	vec2 scale = vec2( length( modelMatrix[ 0 ].xyz ), length( modelMatrix[ 1 ].xyz ) );\n	#ifndef USE_SIZEATTENUATION\n		bool isPerspective = isPerspectiveMatrix( projectionMatrix );\n		if ( isPerspective ) scale *= - mvPosition.z;\n	#endif\n	vec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;\n	vec2 rotatedPosition;\n	rotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;\n	rotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;\n	mvPosition.xy += rotatedPosition;\n	gl_Position = projectionMatrix * mvPosition;\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <fog_vertex>\n}",
                    sprite_frag: "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <clipping_planes_fragment>\n	vec3 outgoingLight = vec3( 0.0 );\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	outgoingLight = diffuseColor.rgb;\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n}"
                }, Ll = {
                    common: {
                        diffuse: {
                            value: new Co.Q1f(16777215)
                        },
                        opacity: {
                            value: 1
                        },
                        map: {
                            value: null
                        },
                        mapTransform: {
                            value: new Co.dwI
                        },
                        alphaMap: {
                            value: null
                        },
                        alphaMapTransform: {
                            value: new Co.dwI
                        },
                        alphaTest: {
                            value: 0
                        }
                    },
                    specularmap: {
                        specularMap: {
                            value: null
                        },
                        specularMapTransform: {
                            value: new Co.dwI
                        }
                    },
                    envmap: {
                        envMap: {
                            value: null
                        },
                        envMapRotation: {
                            value: new Co.dwI
                        },
                        flipEnvMap: {
                            value: -1
                        },
                        reflectivity: {
                            value: 1
                        },
                        ior: {
                            value: 1.5
                        },
                        refractionRatio: {
                            value: .98
                        }
                    },
                    aomap: {
                        aoMap: {
                            value: null
                        },
                        aoMapIntensity: {
                            value: 1
                        },
                        aoMapTransform: {
                            value: new Co.dwI
                        }
                    },
                    lightmap: {
                        lightMap: {
                            value: null
                        },
                        lightMapIntensity: {
                            value: 1
                        },
                        lightMapTransform: {
                            value: new Co.dwI
                        }
                    },
                    bumpmap: {
                        bumpMap: {
                            value: null
                        },
                        bumpMapTransform: {
                            value: new Co.dwI
                        },
                        bumpScale: {
                            value: 1
                        }
                    },
                    normalmap: {
                        normalMap: {
                            value: null
                        },
                        normalMapTransform: {
                            value: new Co.dwI
                        },
                        normalScale: {
                            value: new Co.I9Y(1, 1)
                        }
                    },
                    displacementmap: {
                        displacementMap: {
                            value: null
                        },
                        displacementMapTransform: {
                            value: new Co.dwI
                        },
                        displacementScale: {
                            value: 1
                        },
                        displacementBias: {
                            value: 0
                        }
                    },
                    emissivemap: {
                        emissiveMap: {
                            value: null
                        },
                        emissiveMapTransform: {
                            value: new Co.dwI
                        }
                    },
                    metalnessmap: {
                        metalnessMap: {
                            value: null
                        },
                        metalnessMapTransform: {
                            value: new Co.dwI
                        }
                    },
                    roughnessmap: {
                        roughnessMap: {
                            value: null
                        },
                        roughnessMapTransform: {
                            value: new Co.dwI
                        }
                    },
                    gradientmap: {
                        gradientMap: {
                            value: null
                        }
                    },
                    fog: {
                        fogDensity: {
                            value: 25e-5
                        },
                        fogNear: {
                            value: 1
                        },
                        fogFar: {
                            value: 2e3
                        },
                        fogColor: {
                            value: new Co.Q1f(16777215)
                        }
                    },
                    lights: {
                        ambientLightColor: {
                            value: []
                        },
                        lightProbe: {
                            value: []
                        },
                        directionalLights: {
                            value: [],
                            properties: {
                                direction: {},
                                color: {}
                            }
                        },
                        directionalLightShadows: {
                            value: [],
                            properties: {
                                shadowIntensity: 1,
                                shadowBias: {},
                                shadowNormalBias: {},
                                shadowRadius: {},
                                shadowMapSize: {}
                            }
                        },
                        directionalShadowMap: {
                            value: []
                        },
                        directionalShadowMatrix: {
                            value: []
                        },
                        spotLights: {
                            value: [],
                            properties: {
                                color: {},
                                position: {},
                                direction: {},
                                distance: {},
                                coneCos: {},
                                penumbraCos: {},
                                decay: {}
                            }
                        },
                        spotLightShadows: {
                            value: [],
                            properties: {
                                shadowIntensity: 1,
                                shadowBias: {},
                                shadowNormalBias: {},
                                shadowRadius: {},
                                shadowMapSize: {}
                            }
                        },
                        spotLightMap: {
                            value: []
                        },
                        spotShadowMap: {
                            value: []
                        },
                        spotLightMatrix: {
                            value: []
                        },
                        pointLights: {
                            value: [],
                            properties: {
                                color: {},
                                position: {},
                                decay: {},
                                distance: {}
                            }
                        },
                        pointLightShadows: {
                            value: [],
                            properties: {
                                shadowIntensity: 1,
                                shadowBias: {},
                                shadowNormalBias: {},
                                shadowRadius: {},
                                shadowMapSize: {},
                                shadowCameraNear: {},
                                shadowCameraFar: {}
                            }
                        },
                        pointShadowMap: {
                            value: []
                        },
                        pointShadowMatrix: {
                            value: []
                        },
                        hemisphereLights: {
                            value: [],
                            properties: {
                                direction: {},
                                skyColor: {},
                                groundColor: {}
                            }
                        },
                        rectAreaLights: {
                            value: [],
                            properties: {
                                color: {},
                                position: {},
                                width: {},
                                height: {}
                            }
                        },
                        ltc_1: {
                            value: null
                        },
                        ltc_2: {
                            value: null
                        }
                    },
                    points: {
                        diffuse: {
                            value: new Co.Q1f(16777215)
                        },
                        opacity: {
                            value: 1
                        },
                        size: {
                            value: 1
                        },
                        scale: {
                            value: 1
                        },
                        map: {
                            value: null
                        },
                        alphaMap: {
                            value: null
                        },
                        alphaMapTransform: {
                            value: new Co.dwI
                        },
                        alphaTest: {
                            value: 0
                        },
                        uvTransform: {
                            value: new Co.dwI
                        }
                    },
                    sprite: {
                        diffuse: {
                            value: new Co.Q1f(16777215)
                        },
                        opacity: {
                            value: 1
                        },
                        center: {
                            value: new Co.I9Y(.5, .5)
                        },
                        rotation: {
                            value: 0
                        },
                        map: {
                            value: null
                        },
                        mapTransform: {
                            value: new Co.dwI
                        },
                        alphaMap: {
                            value: null
                        },
                        alphaMapTransform: {
                            value: new Co.dwI
                        },
                        alphaTest: {
                            value: 0
                        }
                    }
                }, Rl = {
                    basic: {
                        uniforms: (0, Co.Iit)([
                            Ll.common,
                            Ll.specularmap,
                            Ll.envmap,
                            Ll.aomap,
                            Ll.lightmap,
                            Ll.fog
                        ]),
                        vertexShader: Dl.meshbasic_vert,
                        fragmentShader: Dl.meshbasic_frag
                    },
                    lambert: {
                        uniforms: (0, Co.Iit)([
                            Ll.common,
                            Ll.specularmap,
                            Ll.envmap,
                            Ll.aomap,
                            Ll.lightmap,
                            Ll.emissivemap,
                            Ll.bumpmap,
                            Ll.normalmap,
                            Ll.displacementmap,
                            Ll.fog,
                            Ll.lights,
                            {
                                emissive: {
                                    value: new Co.Q1f(0)
                                }
                            }
                        ]),
                        vertexShader: Dl.meshlambert_vert,
                        fragmentShader: Dl.meshlambert_frag
                    },
                    phong: {
                        uniforms: (0, Co.Iit)([
                            Ll.common,
                            Ll.specularmap,
                            Ll.envmap,
                            Ll.aomap,
                            Ll.lightmap,
                            Ll.emissivemap,
                            Ll.bumpmap,
                            Ll.normalmap,
                            Ll.displacementmap,
                            Ll.fog,
                            Ll.lights,
                            {
                                emissive: {
                                    value: new Co.Q1f(0)
                                },
                                specular: {
                                    value: new Co.Q1f(1118481)
                                },
                                shininess: {
                                    value: 30
                                }
                            }
                        ]),
                        vertexShader: Dl.meshphong_vert,
                        fragmentShader: Dl.meshphong_frag
                    },
                    standard: {
                        uniforms: (0, Co.Iit)([
                            Ll.common,
                            Ll.envmap,
                            Ll.aomap,
                            Ll.lightmap,
                            Ll.emissivemap,
                            Ll.bumpmap,
                            Ll.normalmap,
                            Ll.displacementmap,
                            Ll.roughnessmap,
                            Ll.metalnessmap,
                            Ll.fog,
                            Ll.lights,
                            {
                                emissive: {
                                    value: new Co.Q1f(0)
                                },
                                roughness: {
                                    value: 1
                                },
                                metalness: {
                                    value: 0
                                },
                                envMapIntensity: {
                                    value: 1
                                }
                            }
                        ]),
                        vertexShader: Dl.meshphysical_vert,
                        fragmentShader: Dl.meshphysical_frag
                    },
                    toon: {
                        uniforms: (0, Co.Iit)([
                            Ll.common,
                            Ll.aomap,
                            Ll.lightmap,
                            Ll.emissivemap,
                            Ll.bumpmap,
                            Ll.normalmap,
                            Ll.displacementmap,
                            Ll.gradientmap,
                            Ll.fog,
                            Ll.lights,
                            {
                                emissive: {
                                    value: new Co.Q1f(0)
                                }
                            }
                        ]),
                        vertexShader: Dl.meshtoon_vert,
                        fragmentShader: Dl.meshtoon_frag
                    },
                    matcap: {
                        uniforms: (0, Co.Iit)([
                            Ll.common,
                            Ll.bumpmap,
                            Ll.normalmap,
                            Ll.displacementmap,
                            Ll.fog,
                            {
                                matcap: {
                                    value: null
                                }
                            }
                        ]),
                        vertexShader: Dl.meshmatcap_vert,
                        fragmentShader: Dl.meshmatcap_frag
                    },
                    points: {
                        uniforms: (0, Co.Iit)([
                            Ll.points,
                            Ll.fog
                        ]),
                        vertexShader: Dl.points_vert,
                        fragmentShader: Dl.points_frag
                    },
                    dashed: {
                        uniforms: (0, Co.Iit)([
                            Ll.common,
                            Ll.fog,
                            {
                                scale: {
                                    value: 1
                                },
                                dashSize: {
                                    value: 1
                                },
                                totalSize: {
                                    value: 2
                                }
                            }
                        ]),
                        vertexShader: Dl.linedashed_vert,
                        fragmentShader: Dl.linedashed_frag
                    },
                    depth: {
                        uniforms: (0, Co.Iit)([
                            Ll.common,
                            Ll.displacementmap
                        ]),
                        vertexShader: Dl.depth_vert,
                        fragmentShader: Dl.depth_frag
                    },
                    normal: {
                        uniforms: (0, Co.Iit)([
                            Ll.common,
                            Ll.bumpmap,
                            Ll.normalmap,
                            Ll.displacementmap,
                            {
                                opacity: {
                                    value: 1
                                }
                            }
                        ]),
                        vertexShader: Dl.meshnormal_vert,
                        fragmentShader: Dl.meshnormal_frag
                    },
                    sprite: {
                        uniforms: (0, Co.Iit)([
                            Ll.sprite,
                            Ll.fog
                        ]),
                        vertexShader: Dl.sprite_vert,
                        fragmentShader: Dl.sprite_frag
                    },
                    background: {
                        uniforms: {
                            uvTransform: {
                                value: new Co.dwI
                            },
                            t2D: {
                                value: null
                            },
                            backgroundIntensity: {
                                value: 1
                            }
                        },
                        vertexShader: Dl.background_vert,
                        fragmentShader: Dl.background_frag
                    },
                    backgroundCube: {
                        uniforms: {
                            envMap: {
                                value: null
                            },
                            flipEnvMap: {
                                value: -1
                            },
                            backgroundBlurriness: {
                                value: 0
                            },
                            backgroundIntensity: {
                                value: 1
                            },
                            backgroundRotation: {
                                value: new Co.dwI
                            }
                        },
                        vertexShader: Dl.backgroundCube_vert,
                        fragmentShader: Dl.backgroundCube_frag
                    },
                    cube: {
                        uniforms: {
                            tCube: {
                                value: null
                            },
                            tFlip: {
                                value: -1
                            },
                            opacity: {
                                value: 1
                            }
                        },
                        vertexShader: Dl.cube_vert,
                        fragmentShader: Dl.cube_frag
                    },
                    equirect: {
                        uniforms: {
                            tEquirect: {
                                value: null
                            }
                        },
                        vertexShader: Dl.equirect_vert,
                        fragmentShader: Dl.equirect_frag
                    },
                    distanceRGBA: {
                        uniforms: (0, Co.Iit)([
                            Ll.common,
                            Ll.displacementmap,
                            {
                                referencePosition: {
                                    value: new Co.Pq0
                                },
                                nearDistance: {
                                    value: 1
                                },
                                farDistance: {
                                    value: 1e3
                                }
                            }
                        ]),
                        vertexShader: Dl.distanceRGBA_vert,
                        fragmentShader: Dl.distanceRGBA_frag
                    },
                    shadow: {
                        uniforms: (0, Co.Iit)([
                            Ll.lights,
                            Ll.fog,
                            {
                                color: {
                                    value: new Co.Q1f(0)
                                },
                                opacity: {
                                    value: 1
                                }
                            }
                        ]),
                        vertexShader: Dl.shadow_vert,
                        fragmentShader: Dl.shadow_frag
                    }
                };
                Rl.physical = {
                    uniforms: (0, Co.Iit)([
                        Rl.standard.uniforms,
                        {
                            clearcoat: {
                                value: 0
                            },
                            clearcoatMap: {
                                value: null
                            },
                            clearcoatMapTransform: {
                                value: new Co.dwI
                            },
                            clearcoatNormalMap: {
                                value: null
                            },
                            clearcoatNormalMapTransform: {
                                value: new Co.dwI
                            },
                            clearcoatNormalScale: {
                                value: new Co.I9Y(1, 1)
                            },
                            clearcoatRoughness: {
                                value: 0
                            },
                            clearcoatRoughnessMap: {
                                value: null
                            },
                            clearcoatRoughnessMapTransform: {
                                value: new Co.dwI
                            },
                            dispersion: {
                                value: 0
                            },
                            iridescence: {
                                value: 0
                            },
                            iridescenceMap: {
                                value: null
                            },
                            iridescenceMapTransform: {
                                value: new Co.dwI
                            },
                            iridescenceIOR: {
                                value: 1.3
                            },
                            iridescenceThicknessMinimum: {
                                value: 100
                            },
                            iridescenceThicknessMaximum: {
                                value: 400
                            },
                            iridescenceThicknessMap: {
                                value: null
                            },
                            iridescenceThicknessMapTransform: {
                                value: new Co.dwI
                            },
                            sheen: {
                                value: 0
                            },
                            sheenColor: {
                                value: new Co.Q1f(0)
                            },
                            sheenColorMap: {
                                value: null
                            },
                            sheenColorMapTransform: {
                                value: new Co.dwI
                            },
                            sheenRoughness: {
                                value: 1
                            },
                            sheenRoughnessMap: {
                                value: null
                            },
                            sheenRoughnessMapTransform: {
                                value: new Co.dwI
                            },
                            transmission: {
                                value: 0
                            },
                            transmissionMap: {
                                value: null
                            },
                            transmissionMapTransform: {
                                value: new Co.dwI
                            },
                            transmissionSamplerSize: {
                                value: new Co.I9Y
                            },
                            transmissionSamplerMap: {
                                value: null
                            },
                            thickness: {
                                value: 0
                            },
                            thicknessMap: {
                                value: null
                            },
                            thicknessMapTransform: {
                                value: new Co.dwI
                            },
                            attenuationDistance: {
                                value: 0
                            },
                            attenuationColor: {
                                value: new Co.Q1f(0)
                            },
                            specularColor: {
                                value: new Co.Q1f(1, 1, 1)
                            },
                            specularColorMap: {
                                value: null
                            },
                            specularColorMapTransform: {
                                value: new Co.dwI
                            },
                            specularIntensity: {
                                value: 1
                            },
                            specularIntensityMap: {
                                value: null
                            },
                            specularIntensityMapTransform: {
                                value: new Co.dwI
                            },
                            anisotropyVector: {
                                value: new Co.I9Y
                            },
                            anisotropyMap: {
                                value: null
                            },
                            anisotropyMapTransform: {
                                value: new Co.dwI
                            }
                        }
                    ]),
                    vertexShader: Dl.meshphysical_vert,
                    fragmentShader: Dl.meshphysical_frag
                };
                const Ul = {
                    r: 0,
                    b: 0,
                    g: 0
                }, Gl = new Co.O9p, Zl = new Co.kn4;
                function WebGLBackground(Qe, rt, Wn, Dl, Ll, Hl, ql) {
                    const Ql = new Co.Q1f(0);
                    let Kl, $l, Tc = !0 === Hl ? 0 : 1, tu = null, lu = 0, du = null;
                    function getBackground(Qe) {
                        let Co = !0 === Qe.isScene ? Qe.background : null;
                        if (Co && Co.isTexture) Co = (Qe.backgroundBlurriness > 0 ? Wn : rt).get(Co);
                        return Co;
                    }
                    function setClear(rt, Wn) {
                        rt.getRGB(Ul, (0, Co._Ut)(Qe)), Dl.buffers.color.setClear(Ul.r, Ul.g, Ul.b, Wn, ql);
                    }
                    return {
                        getClearColor: function() {
                            return Ql;
                        },
                        setClearColor: function(Qe, rt) {
                            void 0 === rt && (rt = 1), Ql.set(Qe), Tc = rt, setClear(Ql, Tc);
                        },
                        getClearAlpha: function() {
                            return Tc;
                        },
                        setClearAlpha: function(Qe) {
                            Tc = Qe, setClear(Ql, Tc);
                        },
                        render: function(rt) {
                            let Wn = !1;
                            const Co = getBackground(rt);
                            null === Co ? setClear(Ql, Tc) : Co && Co.isColor && (setClear(Co, 1), Wn = !0);
                            const Ll = Qe.xr.getEnvironmentBlendMode();
                            "additive" === Ll ? Dl.buffers.color.setClear(0, 0, 0, 1, ql) : "alpha-blend" === Ll && Dl.buffers.color.setClear(0, 0, 0, 0, ql), (Qe.autoClear || Wn) && (Dl.buffers.depth.setTest(!0), Dl.buffers.depth.setMask(!0), Dl.buffers.color.setMask(!0), Qe.clear(Qe.autoClearColor, Qe.autoClearDepth, Qe.autoClearStencil));
                        },
                        addToRenderList: function(rt, Wn) {
                            const Dl = getBackground(Wn);
                            Dl && (Dl.isCubeTexture || Dl.mapping === Co.Om) ? (void 0 === $l && ($l = new Co.eaF(new Co.iNn(1, 1, 1), new Co.BKk({
                                name: "BackgroundCubeMaterial",
                                uniforms: (0, Co.lxW)(Rl.backgroundCube.uniforms),
                                vertexShader: Rl.backgroundCube.vertexShader,
                                fragmentShader: Rl.backgroundCube.fragmentShader,
                                side: Co.hsX,
                                depthTest: !1,
                                depthWrite: !1,
                                fog: !1
                            })), $l.geometry.deleteAttribute("normal"), $l.geometry.deleteAttribute("uv"), $l.onBeforeRender = function(Qe, rt, Wn) {
                                this.matrixWorld.copyPosition(Wn.matrixWorld);
                            }, Object.defineProperty($l.material, "envMap", {
                                get: function() {
                                    return this.uniforms.envMap.value;
                                }
                            }), Ll.update($l)), Gl.copy(Wn.backgroundRotation), Gl.x *= -1, Gl.y *= -1, Gl.z *= -1, Dl.isCubeTexture && !1 === Dl.isRenderTargetTexture && (Gl.y *= -1, Gl.z *= -1), $l.material.uniforms.envMap.value = Dl, $l.material.uniforms.flipEnvMap.value = Dl.isCubeTexture && !1 === Dl.isRenderTargetTexture ? -1 : 1, $l.material.uniforms.backgroundBlurriness.value = Wn.backgroundBlurriness, $l.material.uniforms.backgroundIntensity.value = Wn.backgroundIntensity, $l.material.uniforms.backgroundRotation.value.setFromMatrix4(Zl.makeRotationFromEuler(Gl)), $l.material.toneMapped = Co.ppV.getTransfer(Dl.colorSpace) !== Co.KLL, tu === Dl && lu === Dl.version && du === Qe.toneMapping || ($l.material.needsUpdate = !0, tu = Dl, lu = Dl.version, du = Qe.toneMapping), $l.layers.enableAll(), rt.unshift($l, $l.geometry, $l.material, 0, 0, null)) : Dl && Dl.isTexture && (void 0 === Kl && (Kl = new Co.eaF(new Co.bdM(2, 2), new Co.BKk({
                                name: "BackgroundMaterial",
                                uniforms: (0, Co.lxW)(Rl.background.uniforms),
                                vertexShader: Rl.background.vertexShader,
                                fragmentShader: Rl.background.fragmentShader,
                                side: Co.hB5,
                                depthTest: !1,
                                depthWrite: !1,
                                fog: !1
                            })), Kl.geometry.deleteAttribute("normal"), Object.defineProperty(Kl.material, "map", {
                                get: function() {
                                    return this.uniforms.t2D.value;
                                }
                            }), Ll.update(Kl)), Kl.material.uniforms.t2D.value = Dl, Kl.material.uniforms.backgroundIntensity.value = Wn.backgroundIntensity, Kl.material.toneMapped = Co.ppV.getTransfer(Dl.colorSpace) !== Co.KLL, !0 === Dl.matrixAutoUpdate && Dl.updateMatrix(), Kl.material.uniforms.uvTransform.value.copy(Dl.matrix), tu === Dl && lu === Dl.version && du === Qe.toneMapping || (Kl.material.needsUpdate = !0, tu = Dl, lu = Dl.version, du = Qe.toneMapping), Kl.layers.enableAll(), rt.unshift(Kl, Kl.geometry, Kl.material, 0, 0, null));
                        },
                        dispose: function() {
                            void 0 !== $l && ($l.geometry.dispose(), $l.material.dispose(), $l = void 0), void 0 !== Kl && (Kl.geometry.dispose(), Kl.material.dispose(), Kl = void 0);
                        }
                    };
                }
                function WebGLBindingStates(Qe, rt) {
                    const Wn = Qe.getParameter(Qe.MAX_VERTEX_ATTRIBS), Dl = {}, Ll = createBindingState(null);
                    let Rl = Ll, Ul = !1;
                    function bindVertexArrayObject(rt) {
                        return Qe.bindVertexArray(rt);
                    }
                    function deleteVertexArrayObject(rt) {
                        return Qe.deleteVertexArray(rt);
                    }
                    function createBindingState(Qe) {
                        const rt = [], Co = [], Dl = [];
                        for(let Ll = 0; Ll < Wn; Ll++)rt[Ll] = 0, Co[Ll] = 0, Dl[Ll] = 0;
                        return {
                            geometry: null,
                            program: null,
                            wireframe: !1,
                            newAttributes: rt,
                            enabledAttributes: Co,
                            attributeDivisors: Dl,
                            object: Qe,
                            attributes: {},
                            index: null
                        };
                    }
                    function initAttributes() {
                        const Qe = Rl.newAttributes;
                        for(let rt = 0, Wn = Qe.length; rt < Wn; rt++)Qe[rt] = 0;
                    }
                    function enableAttribute(Qe) {
                        enableAttributeAndDivisor(Qe, 0);
                    }
                    function enableAttributeAndDivisor(rt, Wn) {
                        const Co = Rl.newAttributes, Dl = Rl.enabledAttributes, Ll = Rl.attributeDivisors;
                        Co[rt] = 1, 0 === Dl[rt] && (Qe.enableVertexAttribArray(rt), Dl[rt] = 1), Ll[rt] !== Wn && (Qe.vertexAttribDivisor(rt, Wn), Ll[rt] = Wn);
                    }
                    function disableUnusedAttributes() {
                        const rt = Rl.newAttributes, Wn = Rl.enabledAttributes;
                        for(let Co = 0, Dl = Wn.length; Co < Dl; Co++)Wn[Co] !== rt[Co] && (Qe.disableVertexAttribArray(Co), Wn[Co] = 0);
                    }
                    function vertexAttribPointer(rt, Wn, Co, Dl, Ll, Rl, Ul) {
                        !0 === Ul ? Qe.vertexAttribIPointer(rt, Wn, Co, Ll, Rl) : Qe.vertexAttribPointer(rt, Wn, Co, Dl, Ll, Rl);
                    }
                    function reset() {
                        resetDefaultState(), Ul = !0, Rl !== Ll && (Rl = Ll, bindVertexArrayObject(Rl.object));
                    }
                    function resetDefaultState() {
                        Ll.geometry = null, Ll.program = null, Ll.wireframe = !1;
                    }
                    return {
                        setup: function(Wn, Ll, Gl, Zl, Hl) {
                            let ql = !1;
                            const Ql = function(rt, Wn, Co) {
                                const Ll = !0 === Co.wireframe;
                                let Rl = Dl[rt.id];
                                void 0 === Rl && (Rl = {}, Dl[rt.id] = Rl);
                                let Ul = Rl[Wn.id];
                                void 0 === Ul && (Ul = {}, Rl[Wn.id] = Ul);
                                let Gl = Ul[Ll];
                                void 0 === Gl && (Gl = createBindingState(Qe.createVertexArray()), Ul[Ll] = Gl);
                                return Gl;
                            }(Zl, Gl, Ll);
                            Rl !== Ql && (Rl = Ql, bindVertexArrayObject(Rl.object)), ql = function(Qe, rt, Wn, Co) {
                                const Dl = Rl.attributes, Ll = rt.attributes;
                                let Ul = 0;
                                const Gl = Wn.getAttributes();
                                for(const Rl in Gl)if (Gl[Rl].location >= 0) {
                                    const rt = Dl[Rl];
                                    let Wn = Ll[Rl];
                                    if (void 0 === Wn && ("instanceMatrix" === Rl && Qe.instanceMatrix && (Wn = Qe.instanceMatrix), "instanceColor" === Rl && Qe.instanceColor && (Wn = Qe.instanceColor)), void 0 === rt) return !0;
                                    if (rt.attribute !== Wn) return !0;
                                    if (Wn && rt.data !== Wn.data) return !0;
                                    Ul++;
                                }
                                return Rl.attributesNum !== Ul || Rl.index !== Co;
                            }(Wn, Zl, Gl, Hl), ql && function(Qe, rt, Wn, Co) {
                                const Dl = {}, Ll = rt.attributes;
                                let Ul = 0;
                                const Gl = Wn.getAttributes();
                                for(const Rl in Gl)if (Gl[Rl].location >= 0) {
                                    let rt = Ll[Rl];
                                    void 0 === rt && ("instanceMatrix" === Rl && Qe.instanceMatrix && (rt = Qe.instanceMatrix), "instanceColor" === Rl && Qe.instanceColor && (rt = Qe.instanceColor));
                                    const Wn = {};
                                    Wn.attribute = rt, rt && rt.data && (Wn.data = rt.data), Dl[Rl] = Wn, Ul++;
                                }
                                Rl.attributes = Dl, Rl.attributesNum = Ul, Rl.index = Co;
                            }(Wn, Zl, Gl, Hl), null !== Hl && rt.update(Hl, Qe.ELEMENT_ARRAY_BUFFER), (ql || Ul) && (Ul = !1, function(Wn, Dl, Ll, Rl) {
                                initAttributes();
                                const Ul = Rl.attributes, Gl = Ll.getAttributes(), Zl = Dl.defaultAttributeValues;
                                for(const Hl in Gl){
                                    const Dl = Gl[Hl];
                                    if (Dl.location >= 0) {
                                        let Ll = Ul[Hl];
                                        if (void 0 === Ll && ("instanceMatrix" === Hl && Wn.instanceMatrix && (Ll = Wn.instanceMatrix), "instanceColor" === Hl && Wn.instanceColor && (Ll = Wn.instanceColor)), void 0 !== Ll) {
                                            const Ul = Ll.normalized, Gl = Ll.itemSize, Zl = rt.get(Ll);
                                            if (void 0 === Zl) continue;
                                            const Hl = Zl.buffer, ql = Zl.type, Ql = Zl.bytesPerElement, Kl = ql === Qe.INT || ql === Qe.UNSIGNED_INT || Ll.gpuType === Co.Yuy;
                                            if (Ll.isInterleavedBufferAttribute) {
                                                const rt = Ll.data, Co = rt.stride, Zl = Ll.offset;
                                                if (rt.isInstancedInterleavedBuffer) {
                                                    for(let Qe = 0; Qe < Dl.locationSize; Qe++)enableAttributeAndDivisor(Dl.location + Qe, rt.meshPerAttribute);
                                                    !0 !== Wn.isInstancedMesh && void 0 === Rl._maxInstanceCount && (Rl._maxInstanceCount = rt.meshPerAttribute * rt.count);
                                                } else for(let Qe = 0; Qe < Dl.locationSize; Qe++)enableAttribute(Dl.location + Qe);
                                                Qe.bindBuffer(Qe.ARRAY_BUFFER, Hl);
                                                for(let Qe = 0; Qe < Dl.locationSize; Qe++)vertexAttribPointer(Dl.location + Qe, Gl / Dl.locationSize, ql, Ul, Co * Ql, (Zl + Gl / Dl.locationSize * Qe) * Ql, Kl);
                                            } else {
                                                if (Ll.isInstancedBufferAttribute) {
                                                    for(let Qe = 0; Qe < Dl.locationSize; Qe++)enableAttributeAndDivisor(Dl.location + Qe, Ll.meshPerAttribute);
                                                    !0 !== Wn.isInstancedMesh && void 0 === Rl._maxInstanceCount && (Rl._maxInstanceCount = Ll.meshPerAttribute * Ll.count);
                                                } else for(let Qe = 0; Qe < Dl.locationSize; Qe++)enableAttribute(Dl.location + Qe);
                                                Qe.bindBuffer(Qe.ARRAY_BUFFER, Hl);
                                                for(let Qe = 0; Qe < Dl.locationSize; Qe++)vertexAttribPointer(Dl.location + Qe, Gl / Dl.locationSize, ql, Ul, Gl * Ql, Gl / Dl.locationSize * Qe * Ql, Kl);
                                            }
                                        } else if (void 0 !== Zl) {
                                            const rt = Zl[Hl];
                                            if (void 0 !== rt) switch(rt.length){
                                                case 2:
                                                    Qe.vertexAttrib2fv(Dl.location, rt);
                                                    break;
                                                case 3:
                                                    Qe.vertexAttrib3fv(Dl.location, rt);
                                                    break;
                                                case 4:
                                                    Qe.vertexAttrib4fv(Dl.location, rt);
                                                    break;
                                                default:
                                                    Qe.vertexAttrib1fv(Dl.location, rt);
                                            }
                                        }
                                    }
                                }
                                disableUnusedAttributes();
                            }(Wn, Ll, Gl, Zl), null !== Hl && Qe.bindBuffer(Qe.ELEMENT_ARRAY_BUFFER, rt.get(Hl).buffer));
                        },
                        reset: reset,
                        resetDefaultState: resetDefaultState,
                        dispose: function() {
                            reset();
                            for(const Qe in Dl){
                                const rt = Dl[Qe];
                                for(const Qe in rt){
                                    const Wn = rt[Qe];
                                    for(const Qe in Wn)deleteVertexArrayObject(Wn[Qe].object), delete Wn[Qe];
                                    delete rt[Qe];
                                }
                                delete Dl[Qe];
                            }
                        },
                        releaseStatesOfGeometry: function(Qe) {
                            if (void 0 === Dl[Qe.id]) return;
                            const rt = Dl[Qe.id];
                            for(const Wn in rt){
                                const Qe = rt[Wn];
                                for(const rt in Qe)deleteVertexArrayObject(Qe[rt].object), delete Qe[rt];
                                delete rt[Wn];
                            }
                            delete Dl[Qe.id];
                        },
                        releaseStatesOfProgram: function(Qe) {
                            for(const rt in Dl){
                                const Wn = Dl[rt];
                                if (void 0 === Wn[Qe.id]) continue;
                                const Co = Wn[Qe.id];
                                for(const Qe in Co)deleteVertexArrayObject(Co[Qe].object), delete Co[Qe];
                                delete Wn[Qe.id];
                            }
                        },
                        initAttributes: initAttributes,
                        enableAttribute: enableAttribute,
                        disableUnusedAttributes: disableUnusedAttributes
                    };
                }
                function WebGLBufferRenderer(Qe, rt, Wn) {
                    let Co;
                    function renderInstances(rt, Dl, Ll) {
                        0 !== Ll && (Qe.drawArraysInstanced(Co, rt, Dl, Ll), Wn.update(Dl, Co, Ll));
                    }
                    this.setMode = function(Qe) {
                        Co = Qe;
                    }, this.render = function(rt, Dl) {
                        Qe.drawArrays(Co, rt, Dl), Wn.update(Dl, Co, 1);
                    }, this.renderInstances = renderInstances, this.renderMultiDraw = function(Qe, Dl, Ll) {
                        if (0 === Ll) return;
                        rt.get("WEBGL_multi_draw").multiDrawArraysWEBGL(Co, Qe, 0, Dl, 0, Ll);
                        let Rl = 0;
                        for(let rt = 0; rt < Ll; rt++)Rl += Dl[rt];
                        Wn.update(Rl, Co, 1);
                    }, this.renderMultiDrawInstances = function(Qe, Dl, Ll, Rl) {
                        if (0 === Ll) return;
                        const Ul = rt.get("WEBGL_multi_draw");
                        if (null === Ul) for(let rt = 0; rt < Qe.length; rt++)renderInstances(Qe[rt], Dl[rt], Rl[rt]);
                        else {
                            Ul.multiDrawArraysInstancedWEBGL(Co, Qe, 0, Dl, 0, Rl, 0, Ll);
                            let rt = 0;
                            for(let Qe = 0; Qe < Ll; Qe++)rt += Dl[Qe] * Rl[Qe];
                            Wn.update(rt, Co, 1);
                        }
                    };
                }
                function WebGLCapabilities(Qe, rt, Wn, Dl) {
                    let Ll;
                    function getMaxPrecision(rt) {
                        if ("highp" === rt) {
                            if (Qe.getShaderPrecisionFormat(Qe.VERTEX_SHADER, Qe.HIGH_FLOAT).precision > 0 && Qe.getShaderPrecisionFormat(Qe.FRAGMENT_SHADER, Qe.HIGH_FLOAT).precision > 0) return "highp";
                            rt = "mediump";
                        }
                        return "mediump" === rt && Qe.getShaderPrecisionFormat(Qe.VERTEX_SHADER, Qe.MEDIUM_FLOAT).precision > 0 && Qe.getShaderPrecisionFormat(Qe.FRAGMENT_SHADER, Qe.MEDIUM_FLOAT).precision > 0 ? "mediump" : "lowp";
                    }
                    let Rl = void 0 !== Wn.precision ? Wn.precision : "highp";
                    const Ul = getMaxPrecision(Rl);
                    Ul !== Rl && (console.warn("THREE.WebGLRenderer:", Rl, "not supported, using", Ul, "instead."), Rl = Ul);
                    const Gl = !0 === Wn.logarithmicDepthBuffer, Zl = !0 === Wn.reverseDepthBuffer && rt.has("EXT_clip_control"), Hl = Qe.getParameter(Qe.MAX_TEXTURE_IMAGE_UNITS), ql = Qe.getParameter(Qe.MAX_VERTEX_TEXTURE_IMAGE_UNITS);
                    return {
                        isWebGL2: !0,
                        getMaxAnisotropy: function() {
                            if (void 0 !== Ll) return Ll;
                            if (!0 === rt.has("EXT_texture_filter_anisotropic")) {
                                const Wn = rt.get("EXT_texture_filter_anisotropic");
                                Ll = Qe.getParameter(Wn.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
                            } else Ll = 0;
                            return Ll;
                        },
                        getMaxPrecision: getMaxPrecision,
                        textureFormatReadable: function(rt) {
                            return rt === Co.GWd || Dl.convert(rt) === Qe.getParameter(Qe.IMPLEMENTATION_COLOR_READ_FORMAT);
                        },
                        textureTypeReadable: function(Wn) {
                            const Ll = Wn === Co.ix0 && (rt.has("EXT_color_buffer_half_float") || rt.has("EXT_color_buffer_float"));
                            return !(Wn !== Co.OUM && Dl.convert(Wn) !== Qe.getParameter(Qe.IMPLEMENTATION_COLOR_READ_TYPE) && Wn !== Co.RQf && !Ll);
                        },
                        precision: Rl,
                        logarithmicDepthBuffer: Gl,
                        reverseDepthBuffer: Zl,
                        maxTextures: Hl,
                        maxVertexTextures: ql,
                        maxTextureSize: Qe.getParameter(Qe.MAX_TEXTURE_SIZE),
                        maxCubemapSize: Qe.getParameter(Qe.MAX_CUBE_MAP_TEXTURE_SIZE),
                        maxAttributes: Qe.getParameter(Qe.MAX_VERTEX_ATTRIBS),
                        maxVertexUniforms: Qe.getParameter(Qe.MAX_VERTEX_UNIFORM_VECTORS),
                        maxVaryings: Qe.getParameter(Qe.MAX_VARYING_VECTORS),
                        maxFragmentUniforms: Qe.getParameter(Qe.MAX_FRAGMENT_UNIFORM_VECTORS),
                        vertexTextures: ql > 0,
                        maxSamples: Qe.getParameter(Qe.MAX_SAMPLES)
                    };
                }
                function WebGLClipping(Qe) {
                    const rt = this;
                    let Wn = null, Dl = 0, Ll = !1, Rl = !1;
                    const Ul = new Co.Zcv, Gl = new Co.dwI, Zl = {
                        value: null,
                        needsUpdate: !1
                    };
                    function projectPlanes(Qe, Wn, Co, Dl) {
                        const Ll = null !== Qe ? Qe.length : 0;
                        let Rl = null;
                        if (0 !== Ll) {
                            if (Rl = Zl.value, !0 !== Dl || null === Rl) {
                                const rt = Co + 4 * Ll, Dl = Wn.matrixWorldInverse;
                                Gl.getNormalMatrix(Dl), (null === Rl || Rl.length < rt) && (Rl = new Float32Array(rt));
                                for(let Wn = 0, Zl = Co; Wn !== Ll; ++Wn, Zl += 4)Ul.copy(Qe[Wn]).applyMatrix4(Dl, Gl), Ul.normal.toArray(Rl, Zl), Rl[Zl + 3] = Ul.constant;
                            }
                            Zl.value = Rl, Zl.needsUpdate = !0;
                        }
                        return rt.numPlanes = Ll, rt.numIntersection = 0, Rl;
                    }
                    this.uniform = Zl, this.numPlanes = 0, this.numIntersection = 0, this.init = function(Qe, rt) {
                        const Wn = 0 !== Qe.length || rt || 0 !== Dl || Ll;
                        return Ll = rt, Dl = Qe.length, Wn;
                    }, this.beginShadows = function() {
                        Rl = !0, projectPlanes(null);
                    }, this.endShadows = function() {
                        Rl = !1;
                    }, this.setGlobalState = function(Qe, rt) {
                        Wn = projectPlanes(Qe, rt, 0);
                    }, this.setState = function(Co, Ul, Gl) {
                        const Hl = Co.clippingPlanes, ql = Co.clipIntersection, Ql = Co.clipShadows, Kl = Qe.get(Co);
                        if (!Ll || null === Hl || 0 === Hl.length || Rl && !Ql) Rl ? projectPlanes(null) : function() {
                            Zl.value !== Wn && (Zl.value = Wn, Zl.needsUpdate = Dl > 0);
                            rt.numPlanes = Dl, rt.numIntersection = 0;
                        }();
                        else {
                            const Qe = Rl ? 0 : Dl, rt = 4 * Qe;
                            let Co = Kl.clippingState || null;
                            Zl.value = Co, Co = projectPlanes(Hl, Ul, rt, Gl);
                            for(let Dl = 0; Dl !== rt; ++Dl)Co[Dl] = Wn[Dl];
                            Kl.clippingState = Co, this.numIntersection = ql ? this.numPlanes : 0, this.numPlanes += Qe;
                        }
                    };
                }
                function WebGLCubeMaps(Qe) {
                    let rt = new WeakMap;
                    function mapTextureMapping(Qe, rt) {
                        return rt === Co.wfO ? Qe.mapping = Co.hy7 : rt === Co.uV5 && (Qe.mapping = Co.xFO), Qe;
                    }
                    function onTextureDispose(Qe) {
                        const Wn = Qe.target;
                        Wn.removeEventListener("dispose", onTextureDispose);
                        const Co = rt.get(Wn);
                        void 0 !== Co && (rt.delete(Wn), Co.dispose());
                    }
                    return {
                        get: function(Wn) {
                            if (Wn && Wn.isTexture) {
                                const Dl = Wn.mapping;
                                if (Dl === Co.wfO || Dl === Co.uV5) {
                                    if (rt.has(Wn)) return mapTextureMapping(rt.get(Wn).texture, Wn.mapping);
                                    {
                                        const Dl = Wn.image;
                                        if (Dl && Dl.height > 0) {
                                            const Ll = new Co.o6l(Dl.height);
                                            return Ll.fromEquirectangularTexture(Qe, Wn), rt.set(Wn, Ll), Wn.addEventListener("dispose", onTextureDispose), mapTextureMapping(Ll.texture, Wn.mapping);
                                        }
                                        return null;
                                    }
                                }
                            }
                            return Wn;
                        },
                        dispose: function() {
                            rt = new WeakMap;
                        }
                    };
                }
                const Hl = [
                    .125,
                    .215,
                    .35,
                    .446,
                    .526,
                    .582
                ], ql = 20, Ql = new Co.qUd, Kl = new Co.Q1f;
                let $l = null, Tc = 0, tu = 0, lu = !1;
                const du = (1 + Math.sqrt(5)) / 2, fu = 1 / du, yu = [
                    new Co.Pq0(-du, fu, 0),
                    new Co.Pq0(du, fu, 0),
                    new Co.Pq0(-fu, 0, du),
                    new Co.Pq0(fu, 0, du),
                    new Co.Pq0(0, du, -fu),
                    new Co.Pq0(0, du, fu),
                    new Co.Pq0(-1, 1, -1),
                    new Co.Pq0(1, 1, -1),
                    new Co.Pq0(-1, 1, 1),
                    new Co.Pq0(1, 1, 1)
                ];
                class PMREMGenerator {
                    constructor(Qe){
                        this._renderer = Qe, this._pingPongRenderTarget = null, this._lodMax = 0, this._cubeSize = 0, this._lodPlanes = [], this._sizeLods = [], this._sigmas = [], this._blurMaterial = null, this._cubemapMaterial = null, this._equirectMaterial = null, this._compileMaterial(this._blurMaterial);
                    }
                    fromScene(Qe, rt, Wn, Co) {
                        void 0 === rt && (rt = 0), void 0 === Wn && (Wn = .1), void 0 === Co && (Co = 100), $l = this._renderer.getRenderTarget(), Tc = this._renderer.getActiveCubeFace(), tu = this._renderer.getActiveMipmapLevel(), lu = this._renderer.xr.enabled, this._renderer.xr.enabled = !1, this._setSize(256);
                        const Dl = this._allocateTargets();
                        return Dl.depthBuffer = !0, this._sceneToCubeUV(Qe, Wn, Co, Dl), rt > 0 && this._blur(Dl, 0, 0, rt), this._applyPMREM(Dl), this._cleanup(Dl), Dl;
                    }
                    fromEquirectangular(Qe, rt) {
                        return void 0 === rt && (rt = null), this._fromTexture(Qe, rt);
                    }
                    fromCubemap(Qe, rt) {
                        return void 0 === rt && (rt = null), this._fromTexture(Qe, rt);
                    }
                    compileCubemapShader() {
                        null === this._cubemapMaterial && (this._cubemapMaterial = _getCubemapMaterial(), this._compileMaterial(this._cubemapMaterial));
                    }
                    compileEquirectangularShader() {
                        null === this._equirectMaterial && (this._equirectMaterial = _getEquirectMaterial(), this._compileMaterial(this._equirectMaterial));
                    }
                    dispose() {
                        this._dispose(), null !== this._cubemapMaterial && this._cubemapMaterial.dispose(), null !== this._equirectMaterial && this._equirectMaterial.dispose();
                    }
                    _setSize(Qe) {
                        this._lodMax = Math.floor(Math.log2(Qe)), this._cubeSize = Math.pow(2, this._lodMax);
                    }
                    _dispose() {
                        null !== this._blurMaterial && this._blurMaterial.dispose(), null !== this._pingPongRenderTarget && this._pingPongRenderTarget.dispose();
                        for(let Qe = 0; Qe < this._lodPlanes.length; Qe++)this._lodPlanes[Qe].dispose();
                    }
                    _cleanup(Qe) {
                        this._renderer.setRenderTarget($l, Tc, tu), this._renderer.xr.enabled = lu, Qe.scissorTest = !1, _setViewport(Qe, 0, 0, Qe.width, Qe.height);
                    }
                    _fromTexture(Qe, rt) {
                        Qe.mapping === Co.hy7 || Qe.mapping === Co.xFO ? this._setSize(0 === Qe.image.length ? 16 : Qe.image[0].width || Qe.image[0].image.width) : this._setSize(Qe.image.width / 4), $l = this._renderer.getRenderTarget(), Tc = this._renderer.getActiveCubeFace(), tu = this._renderer.getActiveMipmapLevel(), lu = this._renderer.xr.enabled, this._renderer.xr.enabled = !1;
                        const Wn = rt || this._allocateTargets();
                        return this._textureToCubeUV(Qe, Wn), this._applyPMREM(Wn), this._cleanup(Wn), Wn;
                    }
                    _allocateTargets() {
                        const Qe = 3 * Math.max(this._cubeSize, 112), rt = 4 * this._cubeSize, Wn = {
                            magFilter: Co.k6q,
                            minFilter: Co.k6q,
                            generateMipmaps: !1,
                            type: Co.ix0,
                            format: Co.GWd,
                            colorSpace: Co.Zr2,
                            depthBuffer: !1
                        }, Dl = _createRenderTarget(Qe, rt, Wn);
                        if (null === this._pingPongRenderTarget || this._pingPongRenderTarget.width !== Qe || this._pingPongRenderTarget.height !== rt) {
                            null !== this._pingPongRenderTarget && this._dispose(), this._pingPongRenderTarget = _createRenderTarget(Qe, rt, Wn);
                            const { _lodMax: Dl } = this;
                            ({ sizeLods: this._sizeLods, lodPlanes: this._lodPlanes, sigmas: this._sigmas } = function(Qe) {
                                const rt = [], Wn = [], Dl = [];
                                let Ll = Qe;
                                const Rl = Qe - 4 + 1 + Hl.length;
                                for(let Ul = 0; Ul < Rl; Ul++){
                                    const Rl = Math.pow(2, Ll);
                                    Wn.push(Rl);
                                    let Gl = 1 / Rl;
                                    Ul > Qe - 4 ? Gl = Hl[Ul - Qe + 4 - 1] : 0 === Ul && (Gl = 0), Dl.push(Gl);
                                    const Zl = 1 / (Rl - 2), ql = -Zl, Ql = 1 + Zl, Kl = [
                                        ql,
                                        ql,
                                        Ql,
                                        ql,
                                        Ql,
                                        Ql,
                                        ql,
                                        ql,
                                        Ql,
                                        Ql,
                                        ql,
                                        Ql
                                    ], $l = 6, Tc = 6, tu = 3, lu = 2, du = 1, fu = new Float32Array(tu * Tc * $l), yu = new Float32Array(lu * Tc * $l), Eu = new Float32Array(du * Tc * $l);
                                    for(let Qe = 0; Qe < $l; Qe++){
                                        const rt = Qe % 3 * 2 / 3 - 1, Wn = Qe > 2 ? 0 : -1, Co = [
                                            rt,
                                            Wn,
                                            0,
                                            rt + 2 / 3,
                                            Wn,
                                            0,
                                            rt + 2 / 3,
                                            Wn + 1,
                                            0,
                                            rt,
                                            Wn,
                                            0,
                                            rt + 2 / 3,
                                            Wn + 1,
                                            0,
                                            rt,
                                            Wn + 1,
                                            0
                                        ];
                                        fu.set(Co, tu * Tc * Qe), yu.set(Kl, lu * Tc * Qe);
                                        const Dl = [
                                            Qe,
                                            Qe,
                                            Qe,
                                            Qe,
                                            Qe,
                                            Qe
                                        ];
                                        Eu.set(Dl, du * Tc * Qe);
                                    }
                                    const Tu = new Co.LoY;
                                    Tu.setAttribute("position", new Co.THS(fu, tu)), Tu.setAttribute("uv", new Co.THS(yu, lu)), Tu.setAttribute("faceIndex", new Co.THS(Eu, du)), rt.push(Tu), Ll > 4 && Ll--;
                                }
                                return {
                                    lodPlanes: rt,
                                    sizeLods: Wn,
                                    sigmas: Dl
                                };
                            }(Dl)), this._blurMaterial = function(Qe, rt, Wn) {
                                const Dl = new Float32Array(ql), Ll = new Co.Pq0(0, 1, 0), Rl = new Co.BKk({
                                    name: "SphericalGaussianBlur",
                                    defines: {
                                        n: ql,
                                        CUBEUV_TEXEL_WIDTH: 1 / rt,
                                        CUBEUV_TEXEL_HEIGHT: 1 / Wn,
                                        CUBEUV_MAX_MIP: `${Qe}.0`
                                    },
                                    uniforms: {
                                        envMap: {
                                            value: null
                                        },
                                        samples: {
                                            value: 1
                                        },
                                        weights: {
                                            value: Dl
                                        },
                                        latitudinal: {
                                            value: !1
                                        },
                                        dTheta: {
                                            value: 0
                                        },
                                        mipInt: {
                                            value: 0
                                        },
                                        poleAxis: {
                                            value: Ll
                                        }
                                    },
                                    vertexShader: _getCommonVertexShader(),
                                    fragmentShader: "\n\n			precision mediump float;\n			precision mediump int;\n\n			varying vec3 vOutputDirection;\n\n			uniform sampler2D envMap;\n			uniform int samples;\n			uniform float weights[ n ];\n			uniform bool latitudinal;\n			uniform float dTheta;\n			uniform float mipInt;\n			uniform vec3 poleAxis;\n\n			#define ENVMAP_TYPE_CUBE_UV\n			#include <cube_uv_reflection_fragment>\n\n			vec3 getSample( float theta, vec3 axis ) {\n\n				float cosTheta = cos( theta );\n				// Rodrigues' axis-angle rotation\n				vec3 sampleDirection = vOutputDirection * cosTheta\n					+ cross( axis, vOutputDirection ) * sin( theta )\n					+ axis * dot( axis, vOutputDirection ) * ( 1.0 - cosTheta );\n\n				return bilinearCubeUV( envMap, sampleDirection, mipInt );\n\n			}\n\n			void main() {\n\n				vec3 axis = latitudinal ? poleAxis : cross( poleAxis, vOutputDirection );\n\n				if ( all( equal( axis, vec3( 0.0 ) ) ) ) {\n\n					axis = vec3( vOutputDirection.z, 0.0, - vOutputDirection.x );\n\n				}\n\n				axis = normalize( axis );\n\n				gl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );\n				gl_FragColor.rgb += weights[ 0 ] * getSample( 0.0, axis );\n\n				for ( int i = 1; i < n; i++ ) {\n\n					if ( i >= samples ) {\n\n						break;\n\n					}\n\n					float theta = dTheta * float( i );\n					gl_FragColor.rgb += weights[ i ] * getSample( -1.0 * theta, axis );\n					gl_FragColor.rgb += weights[ i ] * getSample( theta, axis );\n\n				}\n\n			}\n		",
                                    blending: Co.XIg,
                                    depthTest: !1,
                                    depthWrite: !1
                                });
                                return Rl;
                            }(Dl, Qe, rt);
                        }
                        return Dl;
                    }
                    _compileMaterial(Qe) {
                        const rt = new Co.eaF(this._lodPlanes[0], Qe);
                        this._renderer.compile(rt, Ql);
                    }
                    _sceneToCubeUV(Qe, rt, Wn, Dl) {
                        const Ll = new Co.ubm(90, 1, rt, Wn), Rl = [
                            1,
                            -1,
                            1,
                            1,
                            1,
                            1
                        ], Ul = [
                            1,
                            1,
                            1,
                            -1,
                            -1,
                            -1
                        ], Gl = this._renderer, Zl = Gl.autoClear, Hl = Gl.toneMapping;
                        Gl.getClearColor(Kl), Gl.toneMapping = Co.y_p, Gl.autoClear = !1;
                        const ql = new Co.V9B({
                            name: "PMREM.Background",
                            side: Co.hsX,
                            depthWrite: !1,
                            depthTest: !1
                        }), Ql = new Co.eaF(new Co.iNn, ql);
                        let $l = !1;
                        const Tc = Qe.background;
                        Tc ? Tc.isColor && (ql.color.copy(Tc), Qe.background = null, $l = !0) : (ql.color.copy(Kl), $l = !0);
                        for(let Co = 0; Co < 6; Co++){
                            const rt = Co % 3;
                            0 === rt ? (Ll.up.set(0, Rl[Co], 0), Ll.lookAt(Ul[Co], 0, 0)) : 1 === rt ? (Ll.up.set(0, 0, Rl[Co]), Ll.lookAt(0, Ul[Co], 0)) : (Ll.up.set(0, Rl[Co], 0), Ll.lookAt(0, 0, Ul[Co]));
                            const Wn = this._cubeSize;
                            _setViewport(Dl, rt * Wn, Co > 2 ? Wn : 0, Wn, Wn), Gl.setRenderTarget(Dl), $l && Gl.render(Ql, Ll), Gl.render(Qe, Ll);
                        }
                        Ql.geometry.dispose(), Ql.material.dispose(), Gl.toneMapping = Hl, Gl.autoClear = Zl, Qe.background = Tc;
                    }
                    _textureToCubeUV(Qe, rt) {
                        const Wn = this._renderer, Dl = Qe.mapping === Co.hy7 || Qe.mapping === Co.xFO;
                        Dl ? (null === this._cubemapMaterial && (this._cubemapMaterial = _getCubemapMaterial()), this._cubemapMaterial.uniforms.flipEnvMap.value = !1 === Qe.isRenderTargetTexture ? -1 : 1) : null === this._equirectMaterial && (this._equirectMaterial = _getEquirectMaterial());
                        const Ll = Dl ? this._cubemapMaterial : this._equirectMaterial, Rl = new Co.eaF(this._lodPlanes[0], Ll);
                        Ll.uniforms.envMap.value = Qe;
                        const Ul = this._cubeSize;
                        _setViewport(rt, 0, 0, 3 * Ul, 2 * Ul), Wn.setRenderTarget(rt), Wn.render(Rl, Ql);
                    }
                    _applyPMREM(Qe) {
                        const rt = this._renderer, Wn = rt.autoClear;
                        rt.autoClear = !1;
                        const Co = this._lodPlanes.length;
                        for(let Dl = 1; Dl < Co; Dl++){
                            const rt = Math.sqrt(this._sigmas[Dl] * this._sigmas[Dl] - this._sigmas[Dl - 1] * this._sigmas[Dl - 1]), Wn = yu[(Co - Dl - 1) % yu.length];
                            this._blur(Qe, Dl - 1, Dl, rt, Wn);
                        }
                        rt.autoClear = Wn;
                    }
                    _blur(Qe, rt, Wn, Co, Dl) {
                        const Ll = this._pingPongRenderTarget;
                        this._halfBlur(Qe, Ll, rt, Wn, Co, "latitudinal", Dl), this._halfBlur(Ll, Qe, Wn, Wn, Co, "longitudinal", Dl);
                    }
                    _halfBlur(Qe, rt, Wn, Dl, Ll, Rl, Ul) {
                        const Gl = this._renderer, Zl = this._blurMaterial;
                        "latitudinal" !== Rl && "longitudinal" !== Rl && console.error("blur direction must be either latitudinal or longitudinal!");
                        const Hl = new Co.eaF(this._lodPlanes[Dl], Zl), Kl = Zl.uniforms, $l = this._sizeLods[Wn] - 1, Tc = isFinite(Ll) ? Math.PI / (2 * $l) : 2 * Math.PI / 39, tu = Ll / Tc, lu = isFinite(Ll) ? 1 + Math.floor(3 * tu) : ql;
                        lu > ql && console.warn(`sigmaRadians, ${Ll}, is too large and will clip, as it requested ${lu} samples when the maximum is set to 20`);
                        const du = [];
                        let fu = 0;
                        for(let Co = 0; Co < ql; ++Co){
                            const Qe = Co / tu, rt = Math.exp(-Qe * Qe / 2);
                            du.push(rt), 0 === Co ? fu += rt : Co < lu && (fu += 2 * rt);
                        }
                        for(let Co = 0; Co < du.length; Co++)du[Co] = du[Co] / fu;
                        Kl.envMap.value = Qe.texture, Kl.samples.value = lu, Kl.weights.value = du, Kl.latitudinal.value = "latitudinal" === Rl, Ul && (Kl.poleAxis.value = Ul);
                        const { _lodMax: yu } = this;
                        Kl.dTheta.value = Tc, Kl.mipInt.value = yu - Wn;
                        const Eu = this._sizeLods[Dl];
                        _setViewport(rt, 3 * Eu * (Dl > yu - 4 ? Dl - yu + 4 : 0), 4 * (this._cubeSize - Eu), 3 * Eu, 2 * Eu), Gl.setRenderTarget(rt), Gl.render(Hl, Ql);
                    }
                }
                function _createRenderTarget(Qe, rt, Wn) {
                    const Dl = new Co.nWS(Qe, rt, Wn);
                    return Dl.texture.mapping = Co.Om, Dl.texture.name = "PMREM.cubeUv", Dl.scissorTest = !0, Dl;
                }
                function _setViewport(Qe, rt, Wn, Co, Dl) {
                    Qe.viewport.set(rt, Wn, Co, Dl), Qe.scissor.set(rt, Wn, Co, Dl);
                }
                function _getEquirectMaterial() {
                    return new Co.BKk({
                        name: "EquirectangularToCubeUV",
                        uniforms: {
                            envMap: {
                                value: null
                            }
                        },
                        vertexShader: _getCommonVertexShader(),
                        fragmentShader: "\n\n			precision mediump float;\n			precision mediump int;\n\n			varying vec3 vOutputDirection;\n\n			uniform sampler2D envMap;\n\n			#include <common>\n\n			void main() {\n\n				vec3 outputDirection = normalize( vOutputDirection );\n				vec2 uv = equirectUv( outputDirection );\n\n				gl_FragColor = vec4( texture2D ( envMap, uv ).rgb, 1.0 );\n\n			}\n		",
                        blending: Co.XIg,
                        depthTest: !1,
                        depthWrite: !1
                    });
                }
                function _getCubemapMaterial() {
                    return new Co.BKk({
                        name: "CubemapToCubeUV",
                        uniforms: {
                            envMap: {
                                value: null
                            },
                            flipEnvMap: {
                                value: -1
                            }
                        },
                        vertexShader: _getCommonVertexShader(),
                        fragmentShader: "\n\n			precision mediump float;\n			precision mediump int;\n\n			uniform float flipEnvMap;\n\n			varying vec3 vOutputDirection;\n\n			uniform samplerCube envMap;\n\n			void main() {\n\n				gl_FragColor = textureCube( envMap, vec3( flipEnvMap * vOutputDirection.x, vOutputDirection.yz ) );\n\n			}\n		",
                        blending: Co.XIg,
                        depthTest: !1,
                        depthWrite: !1
                    });
                }
                function _getCommonVertexShader() {
                    return "\n\n		precision mediump float;\n		precision mediump int;\n\n		attribute float faceIndex;\n\n		varying vec3 vOutputDirection;\n\n		// RH coordinate system; PMREM face-indexing convention\n		vec3 getDirection( vec2 uv, float face ) {\n\n			uv = 2.0 * uv - 1.0;\n\n			vec3 direction = vec3( uv, 1.0 );\n\n			if ( face == 0.0 ) {\n\n				direction = direction.zyx; // ( 1, v, u ) pos x\n\n			} else if ( face == 1.0 ) {\n\n				direction = direction.xzy;\n				direction.xz *= -1.0; // ( -u, 1, -v ) pos y\n\n			} else if ( face == 2.0 ) {\n\n				direction.x *= -1.0; // ( -u, v, 1 ) pos z\n\n			} else if ( face == 3.0 ) {\n\n				direction = direction.zyx;\n				direction.xz *= -1.0; // ( -1, v, -u ) neg x\n\n			} else if ( face == 4.0 ) {\n\n				direction = direction.xzy;\n				direction.xy *= -1.0; // ( -u, -1, v ) neg y\n\n			} else if ( face == 5.0 ) {\n\n				direction.z *= -1.0; // ( u, v, -1 ) neg z\n\n			}\n\n			return direction;\n\n		}\n\n		void main() {\n\n			vOutputDirection = getDirection( uv, faceIndex );\n			gl_Position = vec4( position, 1.0 );\n\n		}\n	";
                }
                function WebGLCubeUVMaps(Qe) {
                    let rt = new WeakMap, Wn = null;
                    function onTextureDispose(Qe) {
                        const Wn = Qe.target;
                        Wn.removeEventListener("dispose", onTextureDispose);
                        const Co = rt.get(Wn);
                        void 0 !== Co && (rt.delete(Wn), Co.dispose());
                    }
                    return {
                        get: function(Dl) {
                            if (Dl && Dl.isTexture) {
                                const Ll = Dl.mapping, Rl = Ll === Co.wfO || Ll === Co.uV5, Ul = Ll === Co.hy7 || Ll === Co.xFO;
                                if (Rl || Ul) {
                                    let Co = rt.get(Dl);
                                    const Ll = void 0 !== Co ? Co.texture.pmremVersion : 0;
                                    if (Dl.isRenderTargetTexture && Dl.pmremVersion !== Ll) return null === Wn && (Wn = new PMREMGenerator(Qe)), Co = Rl ? Wn.fromEquirectangular(Dl, Co) : Wn.fromCubemap(Dl, Co), Co.texture.pmremVersion = Dl.pmremVersion, rt.set(Dl, Co), Co.texture;
                                    if (void 0 !== Co) return Co.texture;
                                    {
                                        const Ll = Dl.image;
                                        return Rl && Ll && Ll.height > 0 || Ul && Ll && function(Qe) {
                                            let rt = 0;
                                            const Wn = 6;
                                            for(let Co = 0; Co < Wn; Co++)void 0 !== Qe[Co] && rt++;
                                            return rt === Wn;
                                        }(Ll) ? (null === Wn && (Wn = new PMREMGenerator(Qe)), Co = Rl ? Wn.fromEquirectangular(Dl) : Wn.fromCubemap(Dl), Co.texture.pmremVersion = Dl.pmremVersion, rt.set(Dl, Co), Dl.addEventListener("dispose", onTextureDispose), Co.texture) : null;
                                    }
                                }
                            }
                            return Dl;
                        },
                        dispose: function() {
                            rt = new WeakMap, null !== Wn && (Wn.dispose(), Wn = null);
                        }
                    };
                }
                function WebGLExtensions(Qe) {
                    const rt = {};
                    function getExtension(Wn) {
                        if (void 0 !== rt[Wn]) return rt[Wn];
                        let Co;
                        switch(Wn){
                            case "WEBGL_depth_texture":
                                Co = Qe.getExtension("WEBGL_depth_texture") || Qe.getExtension("MOZ_WEBGL_depth_texture") || Qe.getExtension("WEBKIT_WEBGL_depth_texture");
                                break;
                            case "EXT_texture_filter_anisotropic":
                                Co = Qe.getExtension("EXT_texture_filter_anisotropic") || Qe.getExtension("MOZ_EXT_texture_filter_anisotropic") || Qe.getExtension("WEBKIT_EXT_texture_filter_anisotropic");
                                break;
                            case "WEBGL_compressed_texture_s3tc":
                                Co = Qe.getExtension("WEBGL_compressed_texture_s3tc") || Qe.getExtension("MOZ_WEBGL_compressed_texture_s3tc") || Qe.getExtension("WEBKIT_WEBGL_compressed_texture_s3tc");
                                break;
                            case "WEBGL_compressed_texture_pvrtc":
                                Co = Qe.getExtension("WEBGL_compressed_texture_pvrtc") || Qe.getExtension("WEBKIT_WEBGL_compressed_texture_pvrtc");
                                break;
                            default:
                                Co = Qe.getExtension(Wn);
                        }
                        return rt[Wn] = Co, Co;
                    }
                    return {
                        has: function(Qe) {
                            return null !== getExtension(Qe);
                        },
                        init: function() {
                            getExtension("EXT_color_buffer_float"), getExtension("WEBGL_clip_cull_distance"), getExtension("OES_texture_float_linear"), getExtension("EXT_color_buffer_half_float"), getExtension("WEBGL_multisampled_render_to_texture"), getExtension("WEBGL_render_shared_exponent");
                        },
                        get: function(Qe) {
                            const rt = getExtension(Qe);
                            return null === rt && (0, Co.mcG)("THREE.WebGLRenderer: " + Qe + " extension not supported."), rt;
                        }
                    };
                }
                function WebGLGeometries(Qe, rt, Wn, Dl) {
                    const Ll = {}, Rl = new WeakMap;
                    function onGeometryDispose(Qe) {
                        const Co = Qe.target;
                        null !== Co.index && rt.remove(Co.index);
                        for(const Wn in Co.attributes)rt.remove(Co.attributes[Wn]);
                        Co.removeEventListener("dispose", onGeometryDispose), delete Ll[Co.id];
                        const Ul = Rl.get(Co);
                        Ul && (rt.remove(Ul), Rl.delete(Co)), Dl.releaseStatesOfGeometry(Co), !0 === Co.isInstancedBufferGeometry && delete Co._maxInstanceCount, Wn.memory.geometries--;
                    }
                    function updateWireframeAttribute(Qe) {
                        const Wn = [], Dl = Qe.index, Ll = Qe.attributes.position;
                        let Ul = 0;
                        if (null !== Dl) {
                            const Qe = Dl.array;
                            Ul = Dl.version;
                            for(let rt = 0, Co = Qe.length; rt < Co; rt += 3){
                                const Co = Qe[rt + 0], Dl = Qe[rt + 1], Ll = Qe[rt + 2];
                                Wn.push(Co, Dl, Dl, Ll, Ll, Co);
                            }
                        } else {
                            if (void 0 === Ll) return;
                            {
                                const Qe = Ll.array;
                                Ul = Ll.version;
                                for(let rt = 0, Co = Qe.length / 3 - 1; rt < Co; rt += 3){
                                    const Qe = rt + 0, Co = rt + 1, Dl = rt + 2;
                                    Wn.push(Qe, Co, Co, Dl, Dl, Qe);
                                }
                            }
                        }
                        const Gl = new ((0, Co.AQS)(Wn) ? Co.MW4 : Co.A$4)(Wn, 1);
                        Gl.version = Ul;
                        const Zl = Rl.get(Qe);
                        Zl && rt.remove(Zl), Rl.set(Qe, Gl);
                    }
                    return {
                        get: function(Qe, rt) {
                            return !0 === Ll[rt.id] || (rt.addEventListener("dispose", onGeometryDispose), Ll[rt.id] = !0, Wn.memory.geometries++), rt;
                        },
                        update: function(Wn) {
                            const Co = Wn.attributes;
                            for(const Dl in Co)rt.update(Co[Dl], Qe.ARRAY_BUFFER);
                        },
                        getWireframeAttribute: function(Qe) {
                            const rt = Rl.get(Qe);
                            if (rt) {
                                const Wn = Qe.index;
                                null !== Wn && rt.version < Wn.version && updateWireframeAttribute(Qe);
                            } else updateWireframeAttribute(Qe);
                            return Rl.get(Qe);
                        }
                    };
                }
                function WebGLIndexedBufferRenderer(Qe, rt, Wn) {
                    let Co, Dl, Ll;
                    function renderInstances(rt, Rl, Ul) {
                        0 !== Ul && (Qe.drawElementsInstanced(Co, Rl, Dl, rt * Ll, Ul), Wn.update(Rl, Co, Ul));
                    }
                    this.setMode = function(Qe) {
                        Co = Qe;
                    }, this.setIndex = function(Qe) {
                        Dl = Qe.type, Ll = Qe.bytesPerElement;
                    }, this.render = function(rt, Rl) {
                        Qe.drawElements(Co, Rl, Dl, rt * Ll), Wn.update(Rl, Co, 1);
                    }, this.renderInstances = renderInstances, this.renderMultiDraw = function(Qe, Ll, Rl) {
                        if (0 === Rl) return;
                        rt.get("WEBGL_multi_draw").multiDrawElementsWEBGL(Co, Ll, 0, Dl, Qe, 0, Rl);
                        let Ul = 0;
                        for(let rt = 0; rt < Rl; rt++)Ul += Ll[rt];
                        Wn.update(Ul, Co, 1);
                    }, this.renderMultiDrawInstances = function(Qe, Rl, Ul, Gl) {
                        if (0 === Ul) return;
                        const Zl = rt.get("WEBGL_multi_draw");
                        if (null === Zl) for(let rt = 0; rt < Qe.length; rt++)renderInstances(Qe[rt] / Ll, Rl[rt], Gl[rt]);
                        else {
                            Zl.multiDrawElementsInstancedWEBGL(Co, Rl, 0, Dl, Qe, 0, Gl, 0, Ul);
                            let rt = 0;
                            for(let Qe = 0; Qe < Ul; Qe++)rt += Rl[Qe] * Gl[Qe];
                            Wn.update(rt, Co, 1);
                        }
                    };
                }
                function WebGLInfo(Qe) {
                    const rt = {
                        frame: 0,
                        calls: 0,
                        triangles: 0,
                        points: 0,
                        lines: 0
                    };
                    return {
                        memory: {
                            geometries: 0,
                            textures: 0
                        },
                        render: rt,
                        programs: null,
                        autoReset: !0,
                        reset: function() {
                            rt.calls = 0, rt.triangles = 0, rt.points = 0, rt.lines = 0;
                        },
                        update: function(Wn, Co, Dl) {
                            switch(rt.calls++, Co){
                                case Qe.TRIANGLES:
                                    rt.triangles += Dl * (Wn / 3);
                                    break;
                                case Qe.LINES:
                                    rt.lines += Dl * (Wn / 2);
                                    break;
                                case Qe.LINE_STRIP:
                                    rt.lines += Dl * (Wn - 1);
                                    break;
                                case Qe.LINE_LOOP:
                                    rt.lines += Dl * Wn;
                                    break;
                                case Qe.POINTS:
                                    rt.points += Dl * Wn;
                                    break;
                                default:
                                    console.error("THREE.WebGLInfo: Unknown draw mode:", Co);
                            }
                        }
                    };
                }
                function WebGLMorphtargets(Qe, rt, Wn) {
                    const Dl = new WeakMap, Ll = new Co.IUQ;
                    return {
                        update: function(Rl, Ul, Gl) {
                            const Zl = Rl.morphTargetInfluences, Hl = Ul.morphAttributes.position || Ul.morphAttributes.normal || Ul.morphAttributes.color, ql = void 0 !== Hl ? Hl.length : 0;
                            let Ql = Dl.get(Ul);
                            if (void 0 === Ql || Ql.count !== ql) {
                                void 0 !== Ql && Ql.texture.dispose();
                                const Kl = void 0 !== Ul.morphAttributes.position, $l = void 0 !== Ul.morphAttributes.normal, Tc = void 0 !== Ul.morphAttributes.color, tu = Ul.morphAttributes.position || [], lu = Ul.morphAttributes.normal || [], du = Ul.morphAttributes.color || [];
                                let fu = 0;
                                !0 === Kl && (fu = 1), !0 === $l && (fu = 2), !0 === Tc && (fu = 3);
                                let yu = Ul.attributes.position.count * fu, Eu = 1;
                                yu > rt.maxTextureSize && (Eu = Math.ceil(yu / rt.maxTextureSize), yu = rt.maxTextureSize);
                                const Tu = new Float32Array(yu * Eu * 4 * ql), Lu = new Co.rFo(Tu, yu, Eu, ql);
                                Lu.type = Co.RQf, Lu.needsUpdate = !0;
                                const Zu = 4 * fu;
                                for(let Xu = 0; Xu < ql; Xu++){
                                    const Ju = tu[Xu], $u = lu[Xu], ed = du[Xu], td = yu * Eu * 4 * Xu;
                                    for(let id = 0; id < Ju.count; id++){
                                        const nd = id * Zu;
                                        !0 === Kl && (Ll.fromBufferAttribute(Ju, id), Tu[td + nd + 0] = Ll.x, Tu[td + nd + 1] = Ll.y, Tu[td + nd + 2] = Ll.z, Tu[td + nd + 3] = 0), !0 === $l && (Ll.fromBufferAttribute($u, id), Tu[td + nd + 4] = Ll.x, Tu[td + nd + 5] = Ll.y, Tu[td + nd + 6] = Ll.z, Tu[td + nd + 7] = 0), !0 === Tc && (Ll.fromBufferAttribute(ed, id), Tu[td + nd + 8] = Ll.x, Tu[td + nd + 9] = Ll.y, Tu[td + nd + 10] = Ll.z, Tu[td + nd + 11] = 4 === ed.itemSize ? Ll.w : 1);
                                    }
                                }
                                function disposeTexture() {
                                    Lu.dispose(), Dl.delete(Ul), Ul.removeEventListener("dispose", disposeTexture);
                                }
                                Ql = {
                                    count: ql,
                                    texture: Lu,
                                    size: new Co.I9Y(yu, Eu)
                                }, Dl.set(Ul, Ql), Ul.addEventListener("dispose", disposeTexture);
                            }
                            if (!0 === Rl.isInstancedMesh && null !== Rl.morphTexture) Gl.getUniforms().setValue(Qe, "morphTexture", Rl.morphTexture, Wn);
                            else {
                                let rd = 0;
                                for(let ad = 0; ad < Zl.length; ad++)rd += Zl[ad];
                                const sd = Ul.morphTargetsRelative ? 1 : 1 - rd;
                                Gl.getUniforms().setValue(Qe, "morphTargetBaseInfluence", sd), Gl.getUniforms().setValue(Qe, "morphTargetInfluences", Zl);
                            }
                            Gl.getUniforms().setValue(Qe, "morphTargetsTexture", Ql.texture, Wn), Gl.getUniforms().setValue(Qe, "morphTargetsTextureSize", Ql.size);
                        }
                    };
                }
                function WebGLObjects(Qe, rt, Wn, Co) {
                    let Dl = new WeakMap;
                    function onInstancedMeshDispose(Qe) {
                        const rt = Qe.target;
                        rt.removeEventListener("dispose", onInstancedMeshDispose), Wn.remove(rt.instanceMatrix), null !== rt.instanceColor && Wn.remove(rt.instanceColor);
                    }
                    return {
                        update: function(Ll) {
                            const Rl = Co.render.frame, Ul = Ll.geometry, Gl = rt.get(Ll, Ul);
                            if (Dl.get(Gl) !== Rl && (rt.update(Gl), Dl.set(Gl, Rl)), Ll.isInstancedMesh && (!1 === Ll.hasEventListener("dispose", onInstancedMeshDispose) && Ll.addEventListener("dispose", onInstancedMeshDispose), Dl.get(Ll) !== Rl && (Wn.update(Ll.instanceMatrix, Qe.ARRAY_BUFFER), null !== Ll.instanceColor && Wn.update(Ll.instanceColor, Qe.ARRAY_BUFFER), Dl.set(Ll, Rl))), Ll.isSkinnedMesh) {
                                const Qe = Ll.skeleton;
                                Dl.get(Qe) !== Rl && (Qe.update(), Dl.set(Qe, Rl));
                            }
                            return Gl;
                        },
                        dispose: function() {
                            Dl = new WeakMap;
                        }
                    };
                }
                const Eu = new Co.gPd, Tu = new Co.VCu(1, 1), Lu = new Co.rFo, Zu = new Co.dYF, Xu = new Co.b4q, Ju = [], $u = [], ed = new Float32Array(16), td = new Float32Array(9), id = new Float32Array(4);
                function flatten(Qe, rt, Wn) {
                    const Co = Qe[0];
                    if (Co <= 0 || Co > 0) return Qe;
                    const Dl = rt * Wn;
                    let Ll = Ju[Dl];
                    if (void 0 === Ll && (Ll = new Float32Array(Dl), Ju[Dl] = Ll), 0 !== rt) {
                        Co.toArray(Ll, 0);
                        for(let Co = 1, Dl = 0; Co !== rt; ++Co)Dl += Wn, Qe[Co].toArray(Ll, Dl);
                    }
                    return Ll;
                }
                function arraysEqual(Qe, rt) {
                    if (Qe.length !== rt.length) return !1;
                    for(let Wn = 0, Co = Qe.length; Wn < Co; Wn++)if (Qe[Wn] !== rt[Wn]) return !1;
                    return !0;
                }
                function copyArray(Qe, rt) {
                    for(let Wn = 0, Co = rt.length; Wn < Co; Wn++)Qe[Wn] = rt[Wn];
                }
                function allocTexUnits(Qe, rt) {
                    let Wn = $u[rt];
                    void 0 === Wn && (Wn = new Int32Array(rt), $u[rt] = Wn);
                    for(let Co = 0; Co !== rt; ++Co)Wn[Co] = Qe.allocateTextureUnit();
                    return Wn;
                }
                function setValueV1f(Qe, rt) {
                    const Wn = this.cache;
                    Wn[0] !== rt && (Qe.uniform1f(this.addr, rt), Wn[0] = rt);
                }
                function setValueV2f(Qe, rt) {
                    const Wn = this.cache;
                    if (void 0 !== rt.x) Wn[0] === rt.x && Wn[1] === rt.y || (Qe.uniform2f(this.addr, rt.x, rt.y), Wn[0] = rt.x, Wn[1] = rt.y);
                    else {
                        if (arraysEqual(Wn, rt)) return;
                        Qe.uniform2fv(this.addr, rt), copyArray(Wn, rt);
                    }
                }
                function setValueV3f(Qe, rt) {
                    const Wn = this.cache;
                    if (void 0 !== rt.x) Wn[0] === rt.x && Wn[1] === rt.y && Wn[2] === rt.z || (Qe.uniform3f(this.addr, rt.x, rt.y, rt.z), Wn[0] = rt.x, Wn[1] = rt.y, Wn[2] = rt.z);
                    else if (void 0 !== rt.r) Wn[0] === rt.r && Wn[1] === rt.g && Wn[2] === rt.b || (Qe.uniform3f(this.addr, rt.r, rt.g, rt.b), Wn[0] = rt.r, Wn[1] = rt.g, Wn[2] = rt.b);
                    else {
                        if (arraysEqual(Wn, rt)) return;
                        Qe.uniform3fv(this.addr, rt), copyArray(Wn, rt);
                    }
                }
                function setValueV4f(Qe, rt) {
                    const Wn = this.cache;
                    if (void 0 !== rt.x) Wn[0] === rt.x && Wn[1] === rt.y && Wn[2] === rt.z && Wn[3] === rt.w || (Qe.uniform4f(this.addr, rt.x, rt.y, rt.z, rt.w), Wn[0] = rt.x, Wn[1] = rt.y, Wn[2] = rt.z, Wn[3] = rt.w);
                    else {
                        if (arraysEqual(Wn, rt)) return;
                        Qe.uniform4fv(this.addr, rt), copyArray(Wn, rt);
                    }
                }
                function setValueM2(Qe, rt) {
                    const Wn = this.cache, Co = rt.elements;
                    if (void 0 === Co) {
                        if (arraysEqual(Wn, rt)) return;
                        Qe.uniformMatrix2fv(this.addr, !1, rt), copyArray(Wn, rt);
                    } else {
                        if (arraysEqual(Wn, Co)) return;
                        id.set(Co), Qe.uniformMatrix2fv(this.addr, !1, id), copyArray(Wn, Co);
                    }
                }
                function setValueM3(Qe, rt) {
                    const Wn = this.cache, Co = rt.elements;
                    if (void 0 === Co) {
                        if (arraysEqual(Wn, rt)) return;
                        Qe.uniformMatrix3fv(this.addr, !1, rt), copyArray(Wn, rt);
                    } else {
                        if (arraysEqual(Wn, Co)) return;
                        td.set(Co), Qe.uniformMatrix3fv(this.addr, !1, td), copyArray(Wn, Co);
                    }
                }
                function setValueM4(Qe, rt) {
                    const Wn = this.cache, Co = rt.elements;
                    if (void 0 === Co) {
                        if (arraysEqual(Wn, rt)) return;
                        Qe.uniformMatrix4fv(this.addr, !1, rt), copyArray(Wn, rt);
                    } else {
                        if (arraysEqual(Wn, Co)) return;
                        ed.set(Co), Qe.uniformMatrix4fv(this.addr, !1, ed), copyArray(Wn, Co);
                    }
                }
                function setValueV1i(Qe, rt) {
                    const Wn = this.cache;
                    Wn[0] !== rt && (Qe.uniform1i(this.addr, rt), Wn[0] = rt);
                }
                function setValueV2i(Qe, rt) {
                    const Wn = this.cache;
                    if (void 0 !== rt.x) Wn[0] === rt.x && Wn[1] === rt.y || (Qe.uniform2i(this.addr, rt.x, rt.y), Wn[0] = rt.x, Wn[1] = rt.y);
                    else {
                        if (arraysEqual(Wn, rt)) return;
                        Qe.uniform2iv(this.addr, rt), copyArray(Wn, rt);
                    }
                }
                function setValueV3i(Qe, rt) {
                    const Wn = this.cache;
                    if (void 0 !== rt.x) Wn[0] === rt.x && Wn[1] === rt.y && Wn[2] === rt.z || (Qe.uniform3i(this.addr, rt.x, rt.y, rt.z), Wn[0] = rt.x, Wn[1] = rt.y, Wn[2] = rt.z);
                    else {
                        if (arraysEqual(Wn, rt)) return;
                        Qe.uniform3iv(this.addr, rt), copyArray(Wn, rt);
                    }
                }
                function setValueV4i(Qe, rt) {
                    const Wn = this.cache;
                    if (void 0 !== rt.x) Wn[0] === rt.x && Wn[1] === rt.y && Wn[2] === rt.z && Wn[3] === rt.w || (Qe.uniform4i(this.addr, rt.x, rt.y, rt.z, rt.w), Wn[0] = rt.x, Wn[1] = rt.y, Wn[2] = rt.z, Wn[3] = rt.w);
                    else {
                        if (arraysEqual(Wn, rt)) return;
                        Qe.uniform4iv(this.addr, rt), copyArray(Wn, rt);
                    }
                }
                function setValueV1ui(Qe, rt) {
                    const Wn = this.cache;
                    Wn[0] !== rt && (Qe.uniform1ui(this.addr, rt), Wn[0] = rt);
                }
                function setValueV2ui(Qe, rt) {
                    const Wn = this.cache;
                    if (void 0 !== rt.x) Wn[0] === rt.x && Wn[1] === rt.y || (Qe.uniform2ui(this.addr, rt.x, rt.y), Wn[0] = rt.x, Wn[1] = rt.y);
                    else {
                        if (arraysEqual(Wn, rt)) return;
                        Qe.uniform2uiv(this.addr, rt), copyArray(Wn, rt);
                    }
                }
                function setValueV3ui(Qe, rt) {
                    const Wn = this.cache;
                    if (void 0 !== rt.x) Wn[0] === rt.x && Wn[1] === rt.y && Wn[2] === rt.z || (Qe.uniform3ui(this.addr, rt.x, rt.y, rt.z), Wn[0] = rt.x, Wn[1] = rt.y, Wn[2] = rt.z);
                    else {
                        if (arraysEqual(Wn, rt)) return;
                        Qe.uniform3uiv(this.addr, rt), copyArray(Wn, rt);
                    }
                }
                function setValueV4ui(Qe, rt) {
                    const Wn = this.cache;
                    if (void 0 !== rt.x) Wn[0] === rt.x && Wn[1] === rt.y && Wn[2] === rt.z && Wn[3] === rt.w || (Qe.uniform4ui(this.addr, rt.x, rt.y, rt.z, rt.w), Wn[0] = rt.x, Wn[1] = rt.y, Wn[2] = rt.z, Wn[3] = rt.w);
                    else {
                        if (arraysEqual(Wn, rt)) return;
                        Qe.uniform4uiv(this.addr, rt), copyArray(Wn, rt);
                    }
                }
                function setValueT1(Qe, rt, Wn) {
                    const Dl = this.cache, Ll = Wn.allocateTextureUnit();
                    let Rl;
                    Dl[0] !== Ll && (Qe.uniform1i(this.addr, Ll), Dl[0] = Ll), this.type === Qe.SAMPLER_2D_SHADOW ? (Tu.compareFunction = Co.TiK, Rl = Tu) : Rl = Eu, Wn.setTexture2D(rt || Rl, Ll);
                }
                function setValueT3D1(Qe, rt, Wn) {
                    const Co = this.cache, Dl = Wn.allocateTextureUnit();
                    Co[0] !== Dl && (Qe.uniform1i(this.addr, Dl), Co[0] = Dl), Wn.setTexture3D(rt || Zu, Dl);
                }
                function setValueT6(Qe, rt, Wn) {
                    const Co = this.cache, Dl = Wn.allocateTextureUnit();
                    Co[0] !== Dl && (Qe.uniform1i(this.addr, Dl), Co[0] = Dl), Wn.setTextureCube(rt || Xu, Dl);
                }
                function setValueT2DArray1(Qe, rt, Wn) {
                    const Co = this.cache, Dl = Wn.allocateTextureUnit();
                    Co[0] !== Dl && (Qe.uniform1i(this.addr, Dl), Co[0] = Dl), Wn.setTexture2DArray(rt || Lu, Dl);
                }
                function setValueV1fArray(Qe, rt) {
                    Qe.uniform1fv(this.addr, rt);
                }
                function setValueV2fArray(Qe, rt) {
                    const Wn = flatten(rt, this.size, 2);
                    Qe.uniform2fv(this.addr, Wn);
                }
                function setValueV3fArray(Qe, rt) {
                    const Wn = flatten(rt, this.size, 3);
                    Qe.uniform3fv(this.addr, Wn);
                }
                function setValueV4fArray(Qe, rt) {
                    const Wn = flatten(rt, this.size, 4);
                    Qe.uniform4fv(this.addr, Wn);
                }
                function setValueM2Array(Qe, rt) {
                    const Wn = flatten(rt, this.size, 4);
                    Qe.uniformMatrix2fv(this.addr, !1, Wn);
                }
                function setValueM3Array(Qe, rt) {
                    const Wn = flatten(rt, this.size, 9);
                    Qe.uniformMatrix3fv(this.addr, !1, Wn);
                }
                function setValueM4Array(Qe, rt) {
                    const Wn = flatten(rt, this.size, 16);
                    Qe.uniformMatrix4fv(this.addr, !1, Wn);
                }
                function setValueV1iArray(Qe, rt) {
                    Qe.uniform1iv(this.addr, rt);
                }
                function setValueV2iArray(Qe, rt) {
                    Qe.uniform2iv(this.addr, rt);
                }
                function setValueV3iArray(Qe, rt) {
                    Qe.uniform3iv(this.addr, rt);
                }
                function setValueV4iArray(Qe, rt) {
                    Qe.uniform4iv(this.addr, rt);
                }
                function setValueV1uiArray(Qe, rt) {
                    Qe.uniform1uiv(this.addr, rt);
                }
                function setValueV2uiArray(Qe, rt) {
                    Qe.uniform2uiv(this.addr, rt);
                }
                function setValueV3uiArray(Qe, rt) {
                    Qe.uniform3uiv(this.addr, rt);
                }
                function setValueV4uiArray(Qe, rt) {
                    Qe.uniform4uiv(this.addr, rt);
                }
                function setValueT1Array(Qe, rt, Wn) {
                    const Co = this.cache, Dl = rt.length, Ll = allocTexUnits(Wn, Dl);
                    arraysEqual(Co, Ll) || (Qe.uniform1iv(this.addr, Ll), copyArray(Co, Ll));
                    for(let Rl = 0; Rl !== Dl; ++Rl)Wn.setTexture2D(rt[Rl] || Eu, Ll[Rl]);
                }
                function setValueT3DArray(Qe, rt, Wn) {
                    const Co = this.cache, Dl = rt.length, Ll = allocTexUnits(Wn, Dl);
                    arraysEqual(Co, Ll) || (Qe.uniform1iv(this.addr, Ll), copyArray(Co, Ll));
                    for(let Rl = 0; Rl !== Dl; ++Rl)Wn.setTexture3D(rt[Rl] || Zu, Ll[Rl]);
                }
                function setValueT6Array(Qe, rt, Wn) {
                    const Co = this.cache, Dl = rt.length, Ll = allocTexUnits(Wn, Dl);
                    arraysEqual(Co, Ll) || (Qe.uniform1iv(this.addr, Ll), copyArray(Co, Ll));
                    for(let Rl = 0; Rl !== Dl; ++Rl)Wn.setTextureCube(rt[Rl] || Xu, Ll[Rl]);
                }
                function setValueT2DArrayArray(Qe, rt, Wn) {
                    const Co = this.cache, Dl = rt.length, Ll = allocTexUnits(Wn, Dl);
                    arraysEqual(Co, Ll) || (Qe.uniform1iv(this.addr, Ll), copyArray(Co, Ll));
                    for(let Rl = 0; Rl !== Dl; ++Rl)Wn.setTexture2DArray(rt[Rl] || Lu, Ll[Rl]);
                }
                class SingleUniform {
                    constructor(Qe, rt, Wn){
                        this.id = Qe, this.addr = Wn, this.cache = [], this.type = rt.type, this.setValue = function(Qe) {
                            switch(Qe){
                                case 5126:
                                    return setValueV1f;
                                case 35664:
                                    return setValueV2f;
                                case 35665:
                                    return setValueV3f;
                                case 35666:
                                    return setValueV4f;
                                case 35674:
                                    return setValueM2;
                                case 35675:
                                    return setValueM3;
                                case 35676:
                                    return setValueM4;
                                case 5124:
                                case 35670:
                                    return setValueV1i;
                                case 35667:
                                case 35671:
                                    return setValueV2i;
                                case 35668:
                                case 35672:
                                    return setValueV3i;
                                case 35669:
                                case 35673:
                                    return setValueV4i;
                                case 5125:
                                    return setValueV1ui;
                                case 36294:
                                    return setValueV2ui;
                                case 36295:
                                    return setValueV3ui;
                                case 36296:
                                    return setValueV4ui;
                                case 35678:
                                case 36198:
                                case 36298:
                                case 36306:
                                case 35682:
                                    return setValueT1;
                                case 35679:
                                case 36299:
                                case 36307:
                                    return setValueT3D1;
                                case 35680:
                                case 36300:
                                case 36308:
                                case 36293:
                                    return setValueT6;
                                case 36289:
                                case 36303:
                                case 36311:
                                case 36292:
                                    return setValueT2DArray1;
                            }
                        }(rt.type);
                    }
                }
                class PureArrayUniform {
                    constructor(Qe, rt, Wn){
                        this.id = Qe, this.addr = Wn, this.cache = [], this.type = rt.type, this.size = rt.size, this.setValue = function(Qe) {
                            switch(Qe){
                                case 5126:
                                    return setValueV1fArray;
                                case 35664:
                                    return setValueV2fArray;
                                case 35665:
                                    return setValueV3fArray;
                                case 35666:
                                    return setValueV4fArray;
                                case 35674:
                                    return setValueM2Array;
                                case 35675:
                                    return setValueM3Array;
                                case 35676:
                                    return setValueM4Array;
                                case 5124:
                                case 35670:
                                    return setValueV1iArray;
                                case 35667:
                                case 35671:
                                    return setValueV2iArray;
                                case 35668:
                                case 35672:
                                    return setValueV3iArray;
                                case 35669:
                                case 35673:
                                    return setValueV4iArray;
                                case 5125:
                                    return setValueV1uiArray;
                                case 36294:
                                    return setValueV2uiArray;
                                case 36295:
                                    return setValueV3uiArray;
                                case 36296:
                                    return setValueV4uiArray;
                                case 35678:
                                case 36198:
                                case 36298:
                                case 36306:
                                case 35682:
                                    return setValueT1Array;
                                case 35679:
                                case 36299:
                                case 36307:
                                    return setValueT3DArray;
                                case 35680:
                                case 36300:
                                case 36308:
                                case 36293:
                                    return setValueT6Array;
                                case 36289:
                                case 36303:
                                case 36311:
                                case 36292:
                                    return setValueT2DArrayArray;
                            }
                        }(rt.type);
                    }
                }
                class StructuredUniform {
                    constructor(Qe){
                        this.id = Qe, this.seq = [], this.map = {};
                    }
                    setValue(Qe, rt, Wn) {
                        const Co = this.seq;
                        for(let Dl = 0, Ll = Co.length; Dl !== Ll; ++Dl){
                            const Ll = Co[Dl];
                            Ll.setValue(Qe, rt[Ll.id], Wn);
                        }
                    }
                }
                const nd = /(\w+)(\])?(\[|\.)?/g;
                function addUniform(Qe, rt) {
                    Qe.seq.push(rt), Qe.map[rt.id] = rt;
                }
                function parseUniform(Qe, rt, Wn) {
                    const Co = Qe.name, Dl = Co.length;
                    for(nd.lastIndex = 0;;){
                        const Ll = nd.exec(Co), Rl = nd.lastIndex;
                        let Ul = Ll[1];
                        const Gl = "]" === Ll[2], Zl = Ll[3];
                        if (Gl && (Ul |= 0), void 0 === Zl || "[" === Zl && Rl + 2 === Dl) {
                            addUniform(Wn, void 0 === Zl ? new SingleUniform(Ul, Qe, rt) : new PureArrayUniform(Ul, Qe, rt));
                            break;
                        }
                        {
                            let Qe = Wn.map[Ul];
                            void 0 === Qe && (Qe = new StructuredUniform(Ul), addUniform(Wn, Qe)), Wn = Qe;
                        }
                    }
                }
                class WebGLUniforms {
                    constructor(Qe, rt){
                        this.seq = [], this.map = {};
                        const Wn = Qe.getProgramParameter(rt, Qe.ACTIVE_UNIFORMS);
                        for(let Co = 0; Co < Wn; ++Co){
                            const Wn = Qe.getActiveUniform(rt, Co);
                            parseUniform(Wn, Qe.getUniformLocation(rt, Wn.name), this);
                        }
                    }
                    setValue(Qe, rt, Wn, Co) {
                        const Dl = this.map[rt];
                        void 0 !== Dl && Dl.setValue(Qe, Wn, Co);
                    }
                    setOptional(Qe, rt, Wn) {
                        const Co = rt[Wn];
                        void 0 !== Co && this.setValue(Qe, Wn, Co);
                    }
                    static upload(Qe, rt, Wn, Co) {
                        for(let Dl = 0, Ll = rt.length; Dl !== Ll; ++Dl){
                            const Ll = rt[Dl], Rl = Wn[Ll.id];
                            !1 !== Rl.needsUpdate && Ll.setValue(Qe, Rl.value, Co);
                        }
                    }
                    static seqWithValue(Qe, rt) {
                        const Wn = [];
                        for(let Co = 0, Dl = Qe.length; Co !== Dl; ++Co){
                            const Dl = Qe[Co];
                            Dl.id in rt && Wn.push(Dl);
                        }
                        return Wn;
                    }
                }
                function WebGLShader(Qe, rt, Wn) {
                    const Co = Qe.createShader(rt);
                    return Qe.shaderSource(Co, Wn), Qe.compileShader(Co), Co;
                }
                let rd = 0;
                const sd = new Co.dwI;
                function getShaderErrors(Qe, rt, Wn) {
                    const Co = Qe.getShaderParameter(rt, Qe.COMPILE_STATUS), Dl = Qe.getShaderInfoLog(rt).trim();
                    if (Co && "" === Dl) return "";
                    const Ll = /ERROR: 0:(\d+)/.exec(Dl);
                    if (Ll) {
                        const Co = parseInt(Ll[1]);
                        return Wn.toUpperCase() + "\n\n" + Dl + "\n\n" + function(Qe, rt) {
                            const Wn = Qe.split("\n"), Co = [], Dl = Math.max(rt - 6, 0), Ll = Math.min(rt + 6, Wn.length);
                            for(let Rl = Dl; Rl < Ll; Rl++){
                                const Qe = Rl + 1;
                                Co.push(`${Qe === rt ? ">" : " "} ${Qe}: ${Wn[Rl]}`);
                            }
                            return Co.join("\n");
                        }(Qe.getShaderSource(rt), Co);
                    }
                    return Dl;
                }
                function getTexelEncodingFunction(Qe, rt) {
                    const Wn = function(Qe) {
                        Co.ppV._getMatrix(sd, Co.ppV.workingColorSpace, Qe);
                        const rt = `mat3( ${sd.elements.map((Qe)=>Qe.toFixed(4))} )`;
                        switch(Co.ppV.getTransfer(Qe)){
                            case Co.VxR:
                                return [
                                    rt,
                                    "LinearTransferOETF"
                                ];
                            case Co.KLL:
                                return [
                                    rt,
                                    "sRGBTransferOETF"
                                ];
                            default:
                                return console.warn("THREE.WebGLProgram: Unsupported color space: ", Qe), [
                                    rt,
                                    "LinearTransferOETF"
                                ];
                        }
                    }(rt);
                    return [
                        `vec4 ${Qe}( vec4 value ) {`,
                        `\treturn ${Wn[1]}( vec4( value.rgb * ${Wn[0]}, value.a ) );`,
                        "}"
                    ].join("\n");
                }
                function getToneMappingFunction(Qe, rt) {
                    let Wn;
                    switch(rt){
                        case Co.kyO:
                            Wn = "Linear";
                            break;
                        case Co.Mjd:
                            Wn = "Reinhard";
                            break;
                        case Co.nNL:
                            Wn = "Cineon";
                            break;
                        case Co.FV:
                            Wn = "ACESFilmic";
                            break;
                        case Co.LAk:
                            Wn = "AgX";
                            break;
                        case Co.aJ8:
                            Wn = "Neutral";
                            break;
                        case Co.g7M:
                            Wn = "Custom";
                            break;
                        default:
                            console.warn("THREE.WebGLProgram: Unsupported toneMapping:", rt), Wn = "Linear";
                    }
                    return "vec3 " + Qe + "( vec3 color ) { return " + Wn + "ToneMapping( color ); }";
                }
                const ad = new Co.Pq0;
                function getLuminanceFunction() {
                    Co.ppV.getLuminanceCoefficients(ad);
                    return [
                        "float luminance( const in vec3 rgb ) {",
                        `\tconst vec3 weights = vec3( ${ad.x.toFixed(4)}, ${ad.y.toFixed(4)}, ${ad.z.toFixed(4)} );`,
                        "	return dot( weights, rgb );",
                        "}"
                    ].join("\n");
                }
                function filterEmptyLine(Qe) {
                    return "" !== Qe;
                }
                function replaceLightNums(Qe, rt) {
                    const Wn = rt.numSpotLightShadows + rt.numSpotLightMaps - rt.numSpotLightShadowsWithMaps;
                    return Qe.replace(/NUM_DIR_LIGHTS/g, rt.numDirLights).replace(/NUM_SPOT_LIGHTS/g, rt.numSpotLights).replace(/NUM_SPOT_LIGHT_MAPS/g, rt.numSpotLightMaps).replace(/NUM_SPOT_LIGHT_COORDS/g, Wn).replace(/NUM_RECT_AREA_LIGHTS/g, rt.numRectAreaLights).replace(/NUM_POINT_LIGHTS/g, rt.numPointLights).replace(/NUM_HEMI_LIGHTS/g, rt.numHemiLights).replace(/NUM_DIR_LIGHT_SHADOWS/g, rt.numDirLightShadows).replace(/NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS/g, rt.numSpotLightShadowsWithMaps).replace(/NUM_SPOT_LIGHT_SHADOWS/g, rt.numSpotLightShadows).replace(/NUM_POINT_LIGHT_SHADOWS/g, rt.numPointLightShadows);
                }
                function replaceClippingPlaneNums(Qe, rt) {
                    return Qe.replace(/NUM_CLIPPING_PLANES/g, rt.numClippingPlanes).replace(/UNION_CLIPPING_PLANES/g, rt.numClippingPlanes - rt.numClipIntersection);
                }
                const od = /^[ \t]*#include +<([\w\d./]+)>/gm;
                function resolveIncludes(Qe) {
                    return Qe.replace(od, includeReplacer);
                }
                const ld = new Map;
                function includeReplacer(Qe, rt) {
                    let Wn = Dl[rt];
                    if (void 0 === Wn) {
                        const Qe = ld.get(rt);
                        if (void 0 === Qe) throw new Error("Can not resolve #include <" + rt + ">");
                        Wn = Dl[Qe], console.warn('THREE.WebGLRenderer: Shader chunk "%s" has been deprecated. Use "%s" instead.', rt, Qe);
                    }
                    return resolveIncludes(Wn);
                }
                const cd = /#pragma unroll_loop_start\s+for\s*\(\s*int\s+i\s*=\s*(\d+)\s*;\s*i\s*<\s*(\d+)\s*;\s*i\s*\+\+\s*\)\s*{([\s\S]+?)}\s+#pragma unroll_loop_end/g;
                function unrollLoops(Qe) {
                    return Qe.replace(cd, loopReplacer);
                }
                function loopReplacer(Qe, rt, Wn, Co) {
                    let Dl = "";
                    for(let Ll = parseInt(rt); Ll < parseInt(Wn); Ll++)Dl += Co.replace(/\[\s*i\s*\]/g, "[ " + Ll + " ]").replace(/UNROLLED_LOOP_INDEX/g, Ll);
                    return Dl;
                }
                function generatePrecision(Qe) {
                    let rt = `precision ${Qe.precision} float;\n\tprecision ${Qe.precision} int;\n\tprecision ${Qe.precision} sampler2D;\n\tprecision ${Qe.precision} samplerCube;\n\tprecision ${Qe.precision} sampler3D;\n\tprecision ${Qe.precision} sampler2DArray;\n\tprecision ${Qe.precision} sampler2DShadow;\n\tprecision ${Qe.precision} samplerCubeShadow;\n\tprecision ${Qe.precision} sampler2DArrayShadow;\n\tprecision ${Qe.precision} isampler2D;\n\tprecision ${Qe.precision} isampler3D;\n\tprecision ${Qe.precision} isamplerCube;\n\tprecision ${Qe.precision} isampler2DArray;\n\tprecision ${Qe.precision} usampler2D;\n\tprecision ${Qe.precision} usampler3D;\n\tprecision ${Qe.precision} usamplerCube;\n\tprecision ${Qe.precision} usampler2DArray;\n\t`;
                    return "highp" === Qe.precision ? rt += "\n#define HIGH_PRECISION" : "mediump" === Qe.precision ? rt += "\n#define MEDIUM_PRECISION" : "lowp" === Qe.precision && (rt += "\n#define LOW_PRECISION"), rt;
                }
                function WebGLProgram(Qe, rt, Wn, Ll) {
                    const Rl = Qe.getContext(), Ul = Wn.defines;
                    let Gl = Wn.vertexShader, Zl = Wn.fragmentShader;
                    const Hl = function(Qe) {
                        let rt = "SHADOWMAP_TYPE_BASIC";
                        return Qe.shadowMapType === Co.QP0 ? rt = "SHADOWMAP_TYPE_PCF" : Qe.shadowMapType === Co.Wk7 ? rt = "SHADOWMAP_TYPE_PCF_SOFT" : Qe.shadowMapType === Co.RyA && (rt = "SHADOWMAP_TYPE_VSM"), rt;
                    }(Wn), ql = function(Qe) {
                        let rt = "ENVMAP_TYPE_CUBE";
                        if (Qe.envMap) switch(Qe.envMapMode){
                            case Co.hy7:
                            case Co.xFO:
                                rt = "ENVMAP_TYPE_CUBE";
                                break;
                            case Co.Om:
                                rt = "ENVMAP_TYPE_CUBE_UV";
                        }
                        return rt;
                    }(Wn), Ql = function(Qe) {
                        let rt = "ENVMAP_MODE_REFLECTION";
                        Qe.envMap && Qe.envMapMode === Co.xFO && (rt = "ENVMAP_MODE_REFRACTION");
                        return rt;
                    }(Wn), Kl = function(Qe) {
                        let rt = "ENVMAP_BLENDING_NONE";
                        if (Qe.envMap) switch(Qe.combine){
                            case Co.caT:
                                rt = "ENVMAP_BLENDING_MULTIPLY";
                                break;
                            case Co.KRh:
                                rt = "ENVMAP_BLENDING_MIX";
                                break;
                            case Co.XrR:
                                rt = "ENVMAP_BLENDING_ADD";
                        }
                        return rt;
                    }(Wn), $l = function(Qe) {
                        const rt = Qe.envMapCubeUVHeight;
                        if (null === rt) return null;
                        const Wn = Math.log2(rt) - 2, Co = 1 / rt;
                        return {
                            texelWidth: 1 / (3 * Math.max(Math.pow(2, Wn), 112)),
                            texelHeight: Co,
                            maxMip: Wn
                        };
                    }(Wn), Tc = function(Qe) {
                        return [
                            Qe.extensionClipCullDistance ? "#extension GL_ANGLE_clip_cull_distance : require" : "",
                            Qe.extensionMultiDraw ? "#extension GL_ANGLE_multi_draw : require" : ""
                        ].filter(filterEmptyLine).join("\n");
                    }(Wn), tu = function(Qe) {
                        const rt = [];
                        for(const Wn in Qe){
                            const Co = Qe[Wn];
                            !1 !== Co && rt.push("#define " + Wn + " " + Co);
                        }
                        return rt.join("\n");
                    }(Ul), lu = Rl.createProgram();
                    let du, fu, yu = Wn.glslVersion ? "#version " + Wn.glslVersion + "\n" : "";
                    Wn.isRawShaderMaterial ? (du = [
                        "#define SHADER_TYPE " + Wn.shaderType,
                        "#define SHADER_NAME " + Wn.shaderName,
                        tu
                    ].filter(filterEmptyLine).join("\n"), du.length > 0 && (du += "\n"), fu = [
                        "#define SHADER_TYPE " + Wn.shaderType,
                        "#define SHADER_NAME " + Wn.shaderName,
                        tu
                    ].filter(filterEmptyLine).join("\n"), fu.length > 0 && (fu += "\n")) : (du = [
                        generatePrecision(Wn),
                        "#define SHADER_TYPE " + Wn.shaderType,
                        "#define SHADER_NAME " + Wn.shaderName,
                        tu,
                        Wn.extensionClipCullDistance ? "#define USE_CLIP_DISTANCE" : "",
                        Wn.batching ? "#define USE_BATCHING" : "",
                        Wn.batchingColor ? "#define USE_BATCHING_COLOR" : "",
                        Wn.instancing ? "#define USE_INSTANCING" : "",
                        Wn.instancingColor ? "#define USE_INSTANCING_COLOR" : "",
                        Wn.instancingMorph ? "#define USE_INSTANCING_MORPH" : "",
                        Wn.useFog && Wn.fog ? "#define USE_FOG" : "",
                        Wn.useFog && Wn.fogExp2 ? "#define FOG_EXP2" : "",
                        Wn.map ? "#define USE_MAP" : "",
                        Wn.envMap ? "#define USE_ENVMAP" : "",
                        Wn.envMap ? "#define " + Ql : "",
                        Wn.lightMap ? "#define USE_LIGHTMAP" : "",
                        Wn.aoMap ? "#define USE_AOMAP" : "",
                        Wn.bumpMap ? "#define USE_BUMPMAP" : "",
                        Wn.normalMap ? "#define USE_NORMALMAP" : "",
                        Wn.normalMapObjectSpace ? "#define USE_NORMALMAP_OBJECTSPACE" : "",
                        Wn.normalMapTangentSpace ? "#define USE_NORMALMAP_TANGENTSPACE" : "",
                        Wn.displacementMap ? "#define USE_DISPLACEMENTMAP" : "",
                        Wn.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
                        Wn.anisotropy ? "#define USE_ANISOTROPY" : "",
                        Wn.anisotropyMap ? "#define USE_ANISOTROPYMAP" : "",
                        Wn.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
                        Wn.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
                        Wn.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
                        Wn.iridescenceMap ? "#define USE_IRIDESCENCEMAP" : "",
                        Wn.iridescenceThicknessMap ? "#define USE_IRIDESCENCE_THICKNESSMAP" : "",
                        Wn.specularMap ? "#define USE_SPECULARMAP" : "",
                        Wn.specularColorMap ? "#define USE_SPECULAR_COLORMAP" : "",
                        Wn.specularIntensityMap ? "#define USE_SPECULAR_INTENSITYMAP" : "",
                        Wn.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
                        Wn.metalnessMap ? "#define USE_METALNESSMAP" : "",
                        Wn.alphaMap ? "#define USE_ALPHAMAP" : "",
                        Wn.alphaHash ? "#define USE_ALPHAHASH" : "",
                        Wn.transmission ? "#define USE_TRANSMISSION" : "",
                        Wn.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
                        Wn.thicknessMap ? "#define USE_THICKNESSMAP" : "",
                        Wn.sheenColorMap ? "#define USE_SHEEN_COLORMAP" : "",
                        Wn.sheenRoughnessMap ? "#define USE_SHEEN_ROUGHNESSMAP" : "",
                        Wn.mapUv ? "#define MAP_UV " + Wn.mapUv : "",
                        Wn.alphaMapUv ? "#define ALPHAMAP_UV " + Wn.alphaMapUv : "",
                        Wn.lightMapUv ? "#define LIGHTMAP_UV " + Wn.lightMapUv : "",
                        Wn.aoMapUv ? "#define AOMAP_UV " + Wn.aoMapUv : "",
                        Wn.emissiveMapUv ? "#define EMISSIVEMAP_UV " + Wn.emissiveMapUv : "",
                        Wn.bumpMapUv ? "#define BUMPMAP_UV " + Wn.bumpMapUv : "",
                        Wn.normalMapUv ? "#define NORMALMAP_UV " + Wn.normalMapUv : "",
                        Wn.displacementMapUv ? "#define DISPLACEMENTMAP_UV " + Wn.displacementMapUv : "",
                        Wn.metalnessMapUv ? "#define METALNESSMAP_UV " + Wn.metalnessMapUv : "",
                        Wn.roughnessMapUv ? "#define ROUGHNESSMAP_UV " + Wn.roughnessMapUv : "",
                        Wn.anisotropyMapUv ? "#define ANISOTROPYMAP_UV " + Wn.anisotropyMapUv : "",
                        Wn.clearcoatMapUv ? "#define CLEARCOATMAP_UV " + Wn.clearcoatMapUv : "",
                        Wn.clearcoatNormalMapUv ? "#define CLEARCOAT_NORMALMAP_UV " + Wn.clearcoatNormalMapUv : "",
                        Wn.clearcoatRoughnessMapUv ? "#define CLEARCOAT_ROUGHNESSMAP_UV " + Wn.clearcoatRoughnessMapUv : "",
                        Wn.iridescenceMapUv ? "#define IRIDESCENCEMAP_UV " + Wn.iridescenceMapUv : "",
                        Wn.iridescenceThicknessMapUv ? "#define IRIDESCENCE_THICKNESSMAP_UV " + Wn.iridescenceThicknessMapUv : "",
                        Wn.sheenColorMapUv ? "#define SHEEN_COLORMAP_UV " + Wn.sheenColorMapUv : "",
                        Wn.sheenRoughnessMapUv ? "#define SHEEN_ROUGHNESSMAP_UV " + Wn.sheenRoughnessMapUv : "",
                        Wn.specularMapUv ? "#define SPECULARMAP_UV " + Wn.specularMapUv : "",
                        Wn.specularColorMapUv ? "#define SPECULAR_COLORMAP_UV " + Wn.specularColorMapUv : "",
                        Wn.specularIntensityMapUv ? "#define SPECULAR_INTENSITYMAP_UV " + Wn.specularIntensityMapUv : "",
                        Wn.transmissionMapUv ? "#define TRANSMISSIONMAP_UV " + Wn.transmissionMapUv : "",
                        Wn.thicknessMapUv ? "#define THICKNESSMAP_UV " + Wn.thicknessMapUv : "",
                        Wn.vertexTangents && !1 === Wn.flatShading ? "#define USE_TANGENT" : "",
                        Wn.vertexColors ? "#define USE_COLOR" : "",
                        Wn.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
                        Wn.vertexUv1s ? "#define USE_UV1" : "",
                        Wn.vertexUv2s ? "#define USE_UV2" : "",
                        Wn.vertexUv3s ? "#define USE_UV3" : "",
                        Wn.pointsUvs ? "#define USE_POINTS_UV" : "",
                        Wn.flatShading ? "#define FLAT_SHADED" : "",
                        Wn.skinning ? "#define USE_SKINNING" : "",
                        Wn.morphTargets ? "#define USE_MORPHTARGETS" : "",
                        Wn.morphNormals && !1 === Wn.flatShading ? "#define USE_MORPHNORMALS" : "",
                        Wn.morphColors ? "#define USE_MORPHCOLORS" : "",
                        Wn.morphTargetsCount > 0 ? "#define MORPHTARGETS_TEXTURE_STRIDE " + Wn.morphTextureStride : "",
                        Wn.morphTargetsCount > 0 ? "#define MORPHTARGETS_COUNT " + Wn.morphTargetsCount : "",
                        Wn.doubleSided ? "#define DOUBLE_SIDED" : "",
                        Wn.flipSided ? "#define FLIP_SIDED" : "",
                        Wn.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
                        Wn.shadowMapEnabled ? "#define " + Hl : "",
                        Wn.sizeAttenuation ? "#define USE_SIZEATTENUATION" : "",
                        Wn.numLightProbes > 0 ? "#define USE_LIGHT_PROBES" : "",
                        Wn.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "",
                        Wn.reverseDepthBuffer ? "#define USE_REVERSEDEPTHBUF" : "",
                        "uniform mat4 modelMatrix;",
                        "uniform mat4 modelViewMatrix;",
                        "uniform mat4 projectionMatrix;",
                        "uniform mat4 viewMatrix;",
                        "uniform mat3 normalMatrix;",
                        "uniform vec3 cameraPosition;",
                        "uniform bool isOrthographic;",
                        "#ifdef USE_INSTANCING",
                        "	attribute mat4 instanceMatrix;",
                        "#endif",
                        "#ifdef USE_INSTANCING_COLOR",
                        "	attribute vec3 instanceColor;",
                        "#endif",
                        "#ifdef USE_INSTANCING_MORPH",
                        "	uniform sampler2D morphTexture;",
                        "#endif",
                        "attribute vec3 position;",
                        "attribute vec3 normal;",
                        "attribute vec2 uv;",
                        "#ifdef USE_UV1",
                        "	attribute vec2 uv1;",
                        "#endif",
                        "#ifdef USE_UV2",
                        "	attribute vec2 uv2;",
                        "#endif",
                        "#ifdef USE_UV3",
                        "	attribute vec2 uv3;",
                        "#endif",
                        "#ifdef USE_TANGENT",
                        "	attribute vec4 tangent;",
                        "#endif",
                        "#if defined( USE_COLOR_ALPHA )",
                        "	attribute vec4 color;",
                        "#elif defined( USE_COLOR )",
                        "	attribute vec3 color;",
                        "#endif",
                        "#ifdef USE_SKINNING",
                        "	attribute vec4 skinIndex;",
                        "	attribute vec4 skinWeight;",
                        "#endif",
                        "\n"
                    ].filter(filterEmptyLine).join("\n"), fu = [
                        generatePrecision(Wn),
                        "#define SHADER_TYPE " + Wn.shaderType,
                        "#define SHADER_NAME " + Wn.shaderName,
                        tu,
                        Wn.useFog && Wn.fog ? "#define USE_FOG" : "",
                        Wn.useFog && Wn.fogExp2 ? "#define FOG_EXP2" : "",
                        Wn.alphaToCoverage ? "#define ALPHA_TO_COVERAGE" : "",
                        Wn.map ? "#define USE_MAP" : "",
                        Wn.matcap ? "#define USE_MATCAP" : "",
                        Wn.envMap ? "#define USE_ENVMAP" : "",
                        Wn.envMap ? "#define " + ql : "",
                        Wn.envMap ? "#define " + Ql : "",
                        Wn.envMap ? "#define " + Kl : "",
                        $l ? "#define CUBEUV_TEXEL_WIDTH " + $l.texelWidth : "",
                        $l ? "#define CUBEUV_TEXEL_HEIGHT " + $l.texelHeight : "",
                        $l ? "#define CUBEUV_MAX_MIP " + $l.maxMip + ".0" : "",
                        Wn.lightMap ? "#define USE_LIGHTMAP" : "",
                        Wn.aoMap ? "#define USE_AOMAP" : "",
                        Wn.bumpMap ? "#define USE_BUMPMAP" : "",
                        Wn.normalMap ? "#define USE_NORMALMAP" : "",
                        Wn.normalMapObjectSpace ? "#define USE_NORMALMAP_OBJECTSPACE" : "",
                        Wn.normalMapTangentSpace ? "#define USE_NORMALMAP_TANGENTSPACE" : "",
                        Wn.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
                        Wn.anisotropy ? "#define USE_ANISOTROPY" : "",
                        Wn.anisotropyMap ? "#define USE_ANISOTROPYMAP" : "",
                        Wn.clearcoat ? "#define USE_CLEARCOAT" : "",
                        Wn.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
                        Wn.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
                        Wn.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
                        Wn.dispersion ? "#define USE_DISPERSION" : "",
                        Wn.iridescence ? "#define USE_IRIDESCENCE" : "",
                        Wn.iridescenceMap ? "#define USE_IRIDESCENCEMAP" : "",
                        Wn.iridescenceThicknessMap ? "#define USE_IRIDESCENCE_THICKNESSMAP" : "",
                        Wn.specularMap ? "#define USE_SPECULARMAP" : "",
                        Wn.specularColorMap ? "#define USE_SPECULAR_COLORMAP" : "",
                        Wn.specularIntensityMap ? "#define USE_SPECULAR_INTENSITYMAP" : "",
                        Wn.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
                        Wn.metalnessMap ? "#define USE_METALNESSMAP" : "",
                        Wn.alphaMap ? "#define USE_ALPHAMAP" : "",
                        Wn.alphaTest ? "#define USE_ALPHATEST" : "",
                        Wn.alphaHash ? "#define USE_ALPHAHASH" : "",
                        Wn.sheen ? "#define USE_SHEEN" : "",
                        Wn.sheenColorMap ? "#define USE_SHEEN_COLORMAP" : "",
                        Wn.sheenRoughnessMap ? "#define USE_SHEEN_ROUGHNESSMAP" : "",
                        Wn.transmission ? "#define USE_TRANSMISSION" : "",
                        Wn.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
                        Wn.thicknessMap ? "#define USE_THICKNESSMAP" : "",
                        Wn.vertexTangents && !1 === Wn.flatShading ? "#define USE_TANGENT" : "",
                        Wn.vertexColors || Wn.instancingColor || Wn.batchingColor ? "#define USE_COLOR" : "",
                        Wn.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
                        Wn.vertexUv1s ? "#define USE_UV1" : "",
                        Wn.vertexUv2s ? "#define USE_UV2" : "",
                        Wn.vertexUv3s ? "#define USE_UV3" : "",
                        Wn.pointsUvs ? "#define USE_POINTS_UV" : "",
                        Wn.gradientMap ? "#define USE_GRADIENTMAP" : "",
                        Wn.flatShading ? "#define FLAT_SHADED" : "",
                        Wn.doubleSided ? "#define DOUBLE_SIDED" : "",
                        Wn.flipSided ? "#define FLIP_SIDED" : "",
                        Wn.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
                        Wn.shadowMapEnabled ? "#define " + Hl : "",
                        Wn.premultipliedAlpha ? "#define PREMULTIPLIED_ALPHA" : "",
                        Wn.numLightProbes > 0 ? "#define USE_LIGHT_PROBES" : "",
                        Wn.decodeVideoTexture ? "#define DECODE_VIDEO_TEXTURE" : "",
                        Wn.decodeVideoTextureEmissive ? "#define DECODE_VIDEO_TEXTURE_EMISSIVE" : "",
                        Wn.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "",
                        Wn.reverseDepthBuffer ? "#define USE_REVERSEDEPTHBUF" : "",
                        "uniform mat4 viewMatrix;",
                        "uniform vec3 cameraPosition;",
                        "uniform bool isOrthographic;",
                        Wn.toneMapping !== Co.y_p ? "#define TONE_MAPPING" : "",
                        Wn.toneMapping !== Co.y_p ? Dl.tonemapping_pars_fragment : "",
                        Wn.toneMapping !== Co.y_p ? getToneMappingFunction("toneMapping", Wn.toneMapping) : "",
                        Wn.dithering ? "#define DITHERING" : "",
                        Wn.opaque ? "#define OPAQUE" : "",
                        Dl.colorspace_pars_fragment,
                        getTexelEncodingFunction("linearToOutputTexel", Wn.outputColorSpace),
                        getLuminanceFunction(),
                        Wn.useDepthPacking ? "#define DEPTH_PACKING " + Wn.depthPacking : "",
                        "\n"
                    ].filter(filterEmptyLine).join("\n")), Gl = resolveIncludes(Gl), Gl = replaceLightNums(Gl, Wn), Gl = replaceClippingPlaneNums(Gl, Wn), Zl = resolveIncludes(Zl), Zl = replaceLightNums(Zl, Wn), Zl = replaceClippingPlaneNums(Zl, Wn), Gl = unrollLoops(Gl), Zl = unrollLoops(Zl), !0 !== Wn.isRawShaderMaterial && (yu = "#version 300 es\n", du = [
                        Tc,
                        "#define attribute in",
                        "#define varying out",
                        "#define texture2D texture"
                    ].join("\n") + "\n" + du, fu = [
                        "#define varying in",
                        Wn.glslVersion === Co.Wdf ? "" : "layout(location = 0) out highp vec4 pc_fragColor;",
                        Wn.glslVersion === Co.Wdf ? "" : "#define gl_FragColor pc_fragColor",
                        "#define gl_FragDepthEXT gl_FragDepth",
                        "#define texture2D texture",
                        "#define textureCube texture",
                        "#define texture2DProj textureProj",
                        "#define texture2DLodEXT textureLod",
                        "#define texture2DProjLodEXT textureProjLod",
                        "#define textureCubeLodEXT textureLod",
                        "#define texture2DGradEXT textureGrad",
                        "#define texture2DProjGradEXT textureProjGrad",
                        "#define textureCubeGradEXT textureGrad"
                    ].join("\n") + "\n" + fu);
                    const Eu = yu + du + Gl, Tu = yu + fu + Zl, Lu = WebGLShader(Rl, Rl.VERTEX_SHADER, Eu), Zu = WebGLShader(Rl, Rl.FRAGMENT_SHADER, Tu);
                    function onFirstUse(rt) {
                        if (Qe.debug.checkShaderErrors) {
                            const Wn = Rl.getProgramInfoLog(lu).trim(), Co = Rl.getShaderInfoLog(Lu).trim(), Dl = Rl.getShaderInfoLog(Zu).trim();
                            let Ll = !0, Ul = !0;
                            if (!1 === Rl.getProgramParameter(lu, Rl.LINK_STATUS)) {
                                if (Ll = !1, "function" === typeof Qe.debug.onShaderError) Qe.debug.onShaderError(Rl, lu, Lu, Zu);
                                else {
                                    const Qe = getShaderErrors(Rl, Lu, "vertex"), Co = getShaderErrors(Rl, Zu, "fragment");
                                    console.error("THREE.WebGLProgram: Shader Error " + Rl.getError() + " - VALIDATE_STATUS " + Rl.getProgramParameter(lu, Rl.VALIDATE_STATUS) + "\n\nMaterial Name: " + rt.name + "\nMaterial Type: " + rt.type + "\n\nProgram Info Log: " + Wn + "\n" + Qe + "\n" + Co);
                                }
                            } else "" !== Wn ? console.warn("THREE.WebGLProgram: Program Info Log:", Wn) : "" !== Co && "" !== Dl || (Ul = !1);
                            Ul && (rt.diagnostics = {
                                runnable: Ll,
                                programLog: Wn,
                                vertexShader: {
                                    log: Co,
                                    prefix: du
                                },
                                fragmentShader: {
                                    log: Dl,
                                    prefix: fu
                                }
                            });
                        }
                        Rl.deleteShader(Lu), Rl.deleteShader(Zu), Xu = new WebGLUniforms(Rl, lu), Ju = function(Qe, rt) {
                            const Wn = {}, Co = Qe.getProgramParameter(rt, Qe.ACTIVE_ATTRIBUTES);
                            for(let Dl = 0; Dl < Co; Dl++){
                                const Co = Qe.getActiveAttrib(rt, Dl), Ll = Co.name;
                                let Rl = 1;
                                Co.type === Qe.FLOAT_MAT2 && (Rl = 2), Co.type === Qe.FLOAT_MAT3 && (Rl = 3), Co.type === Qe.FLOAT_MAT4 && (Rl = 4), Wn[Ll] = {
                                    type: Co.type,
                                    location: Qe.getAttribLocation(rt, Ll),
                                    locationSize: Rl
                                };
                            }
                            return Wn;
                        }(Rl, lu);
                    }
                    let Xu, Ju;
                    Rl.attachShader(lu, Lu), Rl.attachShader(lu, Zu), void 0 !== Wn.index0AttributeName ? Rl.bindAttribLocation(lu, 0, Wn.index0AttributeName) : !0 === Wn.morphTargets && Rl.bindAttribLocation(lu, 0, "position"), Rl.linkProgram(lu), this.getUniforms = function() {
                        return void 0 === Xu && onFirstUse(this), Xu;
                    }, this.getAttributes = function() {
                        return void 0 === Ju && onFirstUse(this), Ju;
                    };
                    let $u = !1 === Wn.rendererExtensionParallelShaderCompile;
                    return this.isReady = function() {
                        return !1 === $u && ($u = Rl.getProgramParameter(lu, 37297)), $u;
                    }, this.destroy = function() {
                        Ll.releaseStatesOfProgram(this), Rl.deleteProgram(lu), this.program = void 0;
                    }, this.type = Wn.shaderType, this.name = Wn.shaderName, this.id = rd++, this.cacheKey = rt, this.usedTimes = 1, this.program = lu, this.vertexShader = Lu, this.fragmentShader = Zu, this;
                }
                let ud = 0;
                class WebGLShaderCache {
                    constructor(){
                        this.shaderCache = new Map, this.materialCache = new Map;
                    }
                    update(Qe) {
                        const rt = Qe.vertexShader, Wn = Qe.fragmentShader, Co = this._getShaderStage(rt), Dl = this._getShaderStage(Wn), Ll = this._getShaderCacheForMaterial(Qe);
                        return !1 === Ll.has(Co) && (Ll.add(Co), Co.usedTimes++), !1 === Ll.has(Dl) && (Ll.add(Dl), Dl.usedTimes++), this;
                    }
                    remove(Qe) {
                        const rt = this.materialCache.get(Qe);
                        for (const Wn of rt)Wn.usedTimes--, 0 === Wn.usedTimes && this.shaderCache.delete(Wn.code);
                        return this.materialCache.delete(Qe), this;
                    }
                    getVertexShaderID(Qe) {
                        return this._getShaderStage(Qe.vertexShader).id;
                    }
                    getFragmentShaderID(Qe) {
                        return this._getShaderStage(Qe.fragmentShader).id;
                    }
                    dispose() {
                        this.shaderCache.clear(), this.materialCache.clear();
                    }
                    _getShaderCacheForMaterial(Qe) {
                        const rt = this.materialCache;
                        let Wn = rt.get(Qe);
                        return void 0 === Wn && (Wn = new Set, rt.set(Qe, Wn)), Wn;
                    }
                    _getShaderStage(Qe) {
                        const rt = this.shaderCache;
                        let Wn = rt.get(Qe);
                        return void 0 === Wn && (Wn = new WebGLShaderStage(Qe), rt.set(Qe, Wn)), Wn;
                    }
                }
                class WebGLShaderStage {
                    constructor(Qe){
                        this.id = ud++, this.code = Qe, this.usedTimes = 0;
                    }
                }
                function WebGLPrograms(Qe, rt, Wn, Dl, Ll, Ul, Gl) {
                    const Zl = new Co.zgK, Hl = new WebGLShaderCache, ql = new Set, Ql = [], Kl = Ll.logarithmicDepthBuffer, $l = Ll.vertexTextures;
                    let Tc = Ll.precision;
                    const tu = {
                        MeshDepthMaterial: "depth",
                        MeshDistanceMaterial: "distanceRGBA",
                        MeshNormalMaterial: "normal",
                        MeshBasicMaterial: "basic",
                        MeshLambertMaterial: "lambert",
                        MeshPhongMaterial: "phong",
                        MeshToonMaterial: "toon",
                        MeshStandardMaterial: "physical",
                        MeshPhysicalMaterial: "physical",
                        MeshMatcapMaterial: "matcap",
                        LineBasicMaterial: "basic",
                        LineDashedMaterial: "dashed",
                        PointsMaterial: "points",
                        ShadowMaterial: "shadow",
                        SpriteMaterial: "sprite"
                    };
                    function getChannel(Qe) {
                        return ql.add(Qe), 0 === Qe ? "uv" : `uv${Qe}`;
                    }
                    return {
                        getParameters: function(Ul, Zl, Ql, lu, du) {
                            const fu = lu.fog, yu = du.geometry, Eu = Ul.isMeshStandardMaterial ? lu.environment : null, Tu = (Ul.isMeshStandardMaterial ? Wn : rt).get(Ul.envMap || Eu), Lu = Tu && Tu.mapping === Co.Om ? Tu.image.height : null, Zu = tu[Ul.type];
                            null !== Ul.precision && (Tc = Ll.getMaxPrecision(Ul.precision), Tc !== Ul.precision && console.warn("THREE.WebGLProgram.getParameters:", Ul.precision, "not supported, using", Tc, "instead."));
                            const Xu = yu.morphAttributes.position || yu.morphAttributes.normal || yu.morphAttributes.color, Ju = void 0 !== Xu ? Xu.length : 0;
                            let $u, ed, td, id, nd = 0;
                            if (void 0 !== yu.morphAttributes.position && (nd = 1), void 0 !== yu.morphAttributes.normal && (nd = 2), void 0 !== yu.morphAttributes.color && (nd = 3), Zu) {
                                const Qe = Rl[Zu];
                                $u = Qe.vertexShader, ed = Qe.fragmentShader;
                            } else $u = Ul.vertexShader, ed = Ul.fragmentShader, Hl.update(Ul), td = Hl.getVertexShaderID(Ul), id = Hl.getFragmentShaderID(Ul);
                            const rd = Qe.getRenderTarget(), sd = Qe.state.buffers.depth.getReversed(), ad = !0 === du.isInstancedMesh, od = !0 === du.isBatchedMesh, ld = !!Ul.map, cd = !!Ul.matcap, ud = !!Tu, hd = !!Ul.aoMap, dd = !!Ul.lightMap, pd = !!Ul.bumpMap, md = !!Ul.normalMap, fd = !!Ul.displacementMap, gd = !!Ul.emissiveMap, Ad = !!Ul.metalnessMap, yd = !!Ul.roughnessMap, vd = Ul.anisotropy > 0, _d = Ul.clearcoat > 0, xd = Ul.dispersion > 0, bd = Ul.iridescence > 0, wd = Ul.sheen > 0, Ed = Ul.transmission > 0, Md = vd && !!Ul.anisotropyMap, Sd = _d && !!Ul.clearcoatMap, Td = _d && !!Ul.clearcoatNormalMap, Cd = _d && !!Ul.clearcoatRoughnessMap, kd = bd && !!Ul.iridescenceMap, Id = bd && !!Ul.iridescenceThicknessMap, Dd = wd && !!Ul.sheenColorMap, Ld = wd && !!Ul.sheenRoughnessMap, Pd = !!Ul.specularMap, zd = !!Ul.specularColorMap, Nd = !!Ul.specularIntensityMap, Rd = Ed && !!Ul.transmissionMap, Bd = Ed && !!Ul.thicknessMap, Od = !!Ul.gradientMap, Fd = !!Ul.alphaMap, jd = Ul.alphaTest > 0, Ud = !!Ul.alphaHash, Vd = !!Ul.extensions;
                            let Gd = Co.y_p;
                            Ul.toneMapped && (null !== rd && !0 !== rd.isXRRenderTarget || (Gd = Qe.toneMapping));
                            const Zd = {
                                shaderID: Zu,
                                shaderType: Ul.type,
                                shaderName: Ul.name,
                                vertexShader: $u,
                                fragmentShader: ed,
                                defines: Ul.defines,
                                customVertexShaderID: td,
                                customFragmentShaderID: id,
                                isRawShaderMaterial: !0 === Ul.isRawShaderMaterial,
                                glslVersion: Ul.glslVersion,
                                precision: Tc,
                                batching: od,
                                batchingColor: od && null !== du._colorsTexture,
                                instancing: ad,
                                instancingColor: ad && null !== du.instanceColor,
                                instancingMorph: ad && null !== du.morphTexture,
                                supportsVertexTextures: $l,
                                outputColorSpace: null === rd ? Qe.outputColorSpace : !0 === rd.isXRRenderTarget ? rd.texture.colorSpace : Co.Zr2,
                                alphaToCoverage: !!Ul.alphaToCoverage,
                                map: ld,
                                matcap: cd,
                                envMap: ud,
                                envMapMode: ud && Tu.mapping,
                                envMapCubeUVHeight: Lu,
                                aoMap: hd,
                                lightMap: dd,
                                bumpMap: pd,
                                normalMap: md,
                                displacementMap: $l && fd,
                                emissiveMap: gd,
                                normalMapObjectSpace: md && Ul.normalMapType === Co.vyJ,
                                normalMapTangentSpace: md && Ul.normalMapType === Co.bI3,
                                metalnessMap: Ad,
                                roughnessMap: yd,
                                anisotropy: vd,
                                anisotropyMap: Md,
                                clearcoat: _d,
                                clearcoatMap: Sd,
                                clearcoatNormalMap: Td,
                                clearcoatRoughnessMap: Cd,
                                dispersion: xd,
                                iridescence: bd,
                                iridescenceMap: kd,
                                iridescenceThicknessMap: Id,
                                sheen: wd,
                                sheenColorMap: Dd,
                                sheenRoughnessMap: Ld,
                                specularMap: Pd,
                                specularColorMap: zd,
                                specularIntensityMap: Nd,
                                transmission: Ed,
                                transmissionMap: Rd,
                                thicknessMap: Bd,
                                gradientMap: Od,
                                opaque: !1 === Ul.transparent && Ul.blending === Co.NTi && !1 === Ul.alphaToCoverage,
                                alphaMap: Fd,
                                alphaTest: jd,
                                alphaHash: Ud,
                                combine: Ul.combine,
                                mapUv: ld && getChannel(Ul.map.channel),
                                aoMapUv: hd && getChannel(Ul.aoMap.channel),
                                lightMapUv: dd && getChannel(Ul.lightMap.channel),
                                bumpMapUv: pd && getChannel(Ul.bumpMap.channel),
                                normalMapUv: md && getChannel(Ul.normalMap.channel),
                                displacementMapUv: fd && getChannel(Ul.displacementMap.channel),
                                emissiveMapUv: gd && getChannel(Ul.emissiveMap.channel),
                                metalnessMapUv: Ad && getChannel(Ul.metalnessMap.channel),
                                roughnessMapUv: yd && getChannel(Ul.roughnessMap.channel),
                                anisotropyMapUv: Md && getChannel(Ul.anisotropyMap.channel),
                                clearcoatMapUv: Sd && getChannel(Ul.clearcoatMap.channel),
                                clearcoatNormalMapUv: Td && getChannel(Ul.clearcoatNormalMap.channel),
                                clearcoatRoughnessMapUv: Cd && getChannel(Ul.clearcoatRoughnessMap.channel),
                                iridescenceMapUv: kd && getChannel(Ul.iridescenceMap.channel),
                                iridescenceThicknessMapUv: Id && getChannel(Ul.iridescenceThicknessMap.channel),
                                sheenColorMapUv: Dd && getChannel(Ul.sheenColorMap.channel),
                                sheenRoughnessMapUv: Ld && getChannel(Ul.sheenRoughnessMap.channel),
                                specularMapUv: Pd && getChannel(Ul.specularMap.channel),
                                specularColorMapUv: zd && getChannel(Ul.specularColorMap.channel),
                                specularIntensityMapUv: Nd && getChannel(Ul.specularIntensityMap.channel),
                                transmissionMapUv: Rd && getChannel(Ul.transmissionMap.channel),
                                thicknessMapUv: Bd && getChannel(Ul.thicknessMap.channel),
                                alphaMapUv: Fd && getChannel(Ul.alphaMap.channel),
                                vertexTangents: !!yu.attributes.tangent && (md || vd),
                                vertexColors: Ul.vertexColors,
                                vertexAlphas: !0 === Ul.vertexColors && !!yu.attributes.color && 4 === yu.attributes.color.itemSize,
                                pointsUvs: !0 === du.isPoints && !!yu.attributes.uv && (ld || Fd),
                                fog: !!fu,
                                useFog: !0 === Ul.fog,
                                fogExp2: !!fu && fu.isFogExp2,
                                flatShading: !0 === Ul.flatShading,
                                sizeAttenuation: !0 === Ul.sizeAttenuation,
                                logarithmicDepthBuffer: Kl,
                                reverseDepthBuffer: sd,
                                skinning: !0 === du.isSkinnedMesh,
                                morphTargets: void 0 !== yu.morphAttributes.position,
                                morphNormals: void 0 !== yu.morphAttributes.normal,
                                morphColors: void 0 !== yu.morphAttributes.color,
                                morphTargetsCount: Ju,
                                morphTextureStride: nd,
                                numDirLights: Zl.directional.length,
                                numPointLights: Zl.point.length,
                                numSpotLights: Zl.spot.length,
                                numSpotLightMaps: Zl.spotLightMap.length,
                                numRectAreaLights: Zl.rectArea.length,
                                numHemiLights: Zl.hemi.length,
                                numDirLightShadows: Zl.directionalShadowMap.length,
                                numPointLightShadows: Zl.pointShadowMap.length,
                                numSpotLightShadows: Zl.spotShadowMap.length,
                                numSpotLightShadowsWithMaps: Zl.numSpotLightShadowsWithMaps,
                                numLightProbes: Zl.numLightProbes,
                                numClippingPlanes: Gl.numPlanes,
                                numClipIntersection: Gl.numIntersection,
                                dithering: Ul.dithering,
                                shadowMapEnabled: Qe.shadowMap.enabled && Ql.length > 0,
                                shadowMapType: Qe.shadowMap.type,
                                toneMapping: Gd,
                                decodeVideoTexture: ld && !0 === Ul.map.isVideoTexture && Co.ppV.getTransfer(Ul.map.colorSpace) === Co.KLL,
                                decodeVideoTextureEmissive: gd && !0 === Ul.emissiveMap.isVideoTexture && Co.ppV.getTransfer(Ul.emissiveMap.colorSpace) === Co.KLL,
                                premultipliedAlpha: Ul.premultipliedAlpha,
                                doubleSided: Ul.side === Co.$EB,
                                flipSided: Ul.side === Co.hsX,
                                useDepthPacking: Ul.depthPacking >= 0,
                                depthPacking: Ul.depthPacking || 0,
                                index0AttributeName: Ul.index0AttributeName,
                                extensionClipCullDistance: Vd && !0 === Ul.extensions.clipCullDistance && Dl.has("WEBGL_clip_cull_distance"),
                                extensionMultiDraw: (Vd && !0 === Ul.extensions.multiDraw || od) && Dl.has("WEBGL_multi_draw"),
                                rendererExtensionParallelShaderCompile: Dl.has("KHR_parallel_shader_compile"),
                                customProgramCacheKey: Ul.customProgramCacheKey()
                            };
                            return Zd.vertexUv1s = ql.has(1), Zd.vertexUv2s = ql.has(2), Zd.vertexUv3s = ql.has(3), ql.clear(), Zd;
                        },
                        getProgramCacheKey: function(rt) {
                            const Wn = [];
                            if (rt.shaderID ? Wn.push(rt.shaderID) : (Wn.push(rt.customVertexShaderID), Wn.push(rt.customFragmentShaderID)), void 0 !== rt.defines) for(const Qe in rt.defines)Wn.push(Qe), Wn.push(rt.defines[Qe]);
                            return !1 === rt.isRawShaderMaterial && (!function(Qe, rt) {
                                Qe.push(rt.precision), Qe.push(rt.outputColorSpace), Qe.push(rt.envMapMode), Qe.push(rt.envMapCubeUVHeight), Qe.push(rt.mapUv), Qe.push(rt.alphaMapUv), Qe.push(rt.lightMapUv), Qe.push(rt.aoMapUv), Qe.push(rt.bumpMapUv), Qe.push(rt.normalMapUv), Qe.push(rt.displacementMapUv), Qe.push(rt.emissiveMapUv), Qe.push(rt.metalnessMapUv), Qe.push(rt.roughnessMapUv), Qe.push(rt.anisotropyMapUv), Qe.push(rt.clearcoatMapUv), Qe.push(rt.clearcoatNormalMapUv), Qe.push(rt.clearcoatRoughnessMapUv), Qe.push(rt.iridescenceMapUv), Qe.push(rt.iridescenceThicknessMapUv), Qe.push(rt.sheenColorMapUv), Qe.push(rt.sheenRoughnessMapUv), Qe.push(rt.specularMapUv), Qe.push(rt.specularColorMapUv), Qe.push(rt.specularIntensityMapUv), Qe.push(rt.transmissionMapUv), Qe.push(rt.thicknessMapUv), Qe.push(rt.combine), Qe.push(rt.fogExp2), Qe.push(rt.sizeAttenuation), Qe.push(rt.morphTargetsCount), Qe.push(rt.morphAttributeCount), Qe.push(rt.numDirLights), Qe.push(rt.numPointLights), Qe.push(rt.numSpotLights), Qe.push(rt.numSpotLightMaps), Qe.push(rt.numHemiLights), Qe.push(rt.numRectAreaLights), Qe.push(rt.numDirLightShadows), Qe.push(rt.numPointLightShadows), Qe.push(rt.numSpotLightShadows), Qe.push(rt.numSpotLightShadowsWithMaps), Qe.push(rt.numLightProbes), Qe.push(rt.shadowMapType), Qe.push(rt.toneMapping), Qe.push(rt.numClippingPlanes), Qe.push(rt.numClipIntersection), Qe.push(rt.depthPacking);
                            }(Wn, rt), function(Qe, rt) {
                                Zl.disableAll(), rt.supportsVertexTextures && Zl.enable(0);
                                rt.instancing && Zl.enable(1);
                                rt.instancingColor && Zl.enable(2);
                                rt.instancingMorph && Zl.enable(3);
                                rt.matcap && Zl.enable(4);
                                rt.envMap && Zl.enable(5);
                                rt.normalMapObjectSpace && Zl.enable(6);
                                rt.normalMapTangentSpace && Zl.enable(7);
                                rt.clearcoat && Zl.enable(8);
                                rt.iridescence && Zl.enable(9);
                                rt.alphaTest && Zl.enable(10);
                                rt.vertexColors && Zl.enable(11);
                                rt.vertexAlphas && Zl.enable(12);
                                rt.vertexUv1s && Zl.enable(13);
                                rt.vertexUv2s && Zl.enable(14);
                                rt.vertexUv3s && Zl.enable(15);
                                rt.vertexTangents && Zl.enable(16);
                                rt.anisotropy && Zl.enable(17);
                                rt.alphaHash && Zl.enable(18);
                                rt.batching && Zl.enable(19);
                                rt.dispersion && Zl.enable(20);
                                rt.batchingColor && Zl.enable(21);
                                Qe.push(Zl.mask), Zl.disableAll(), rt.fog && Zl.enable(0);
                                rt.useFog && Zl.enable(1);
                                rt.flatShading && Zl.enable(2);
                                rt.logarithmicDepthBuffer && Zl.enable(3);
                                rt.reverseDepthBuffer && Zl.enable(4);
                                rt.skinning && Zl.enable(5);
                                rt.morphTargets && Zl.enable(6);
                                rt.morphNormals && Zl.enable(7);
                                rt.morphColors && Zl.enable(8);
                                rt.premultipliedAlpha && Zl.enable(9);
                                rt.shadowMapEnabled && Zl.enable(10);
                                rt.doubleSided && Zl.enable(11);
                                rt.flipSided && Zl.enable(12);
                                rt.useDepthPacking && Zl.enable(13);
                                rt.dithering && Zl.enable(14);
                                rt.transmission && Zl.enable(15);
                                rt.sheen && Zl.enable(16);
                                rt.opaque && Zl.enable(17);
                                rt.pointsUvs && Zl.enable(18);
                                rt.decodeVideoTexture && Zl.enable(19);
                                rt.decodeVideoTextureEmissive && Zl.enable(20);
                                rt.alphaToCoverage && Zl.enable(21);
                                Qe.push(Zl.mask);
                            }(Wn, rt), Wn.push(Qe.outputColorSpace)), Wn.push(rt.customProgramCacheKey), Wn.join();
                        },
                        getUniforms: function(Qe) {
                            const rt = tu[Qe.type];
                            let Wn;
                            if (rt) {
                                const Qe = Rl[rt];
                                Wn = Co.LlO.clone(Qe.uniforms);
                            } else Wn = Qe.uniforms;
                            return Wn;
                        },
                        acquireProgram: function(rt, Wn) {
                            let Co;
                            for(let Qe = 0, Dl = Ql.length; Qe < Dl; Qe++){
                                const rt = Ql[Qe];
                                if (rt.cacheKey === Wn) {
                                    Co = rt, ++Co.usedTimes;
                                    break;
                                }
                            }
                            return void 0 === Co && (Co = new WebGLProgram(Qe, Wn, rt, Ul), Ql.push(Co)), Co;
                        },
                        releaseProgram: function(Qe) {
                            if (0 === --Qe.usedTimes) {
                                const rt = Ql.indexOf(Qe);
                                Ql[rt] = Ql[Ql.length - 1], Ql.pop(), Qe.destroy();
                            }
                        },
                        releaseShaderCache: function(Qe) {
                            Hl.remove(Qe);
                        },
                        programs: Ql,
                        dispose: function() {
                            Hl.dispose();
                        }
                    };
                }
                function WebGLProperties() {
                    let Qe = new WeakMap;
                    return {
                        has: function(rt) {
                            return Qe.has(rt);
                        },
                        get: function(rt) {
                            let Wn = Qe.get(rt);
                            return void 0 === Wn && (Wn = {}, Qe.set(rt, Wn)), Wn;
                        },
                        remove: function(rt) {
                            Qe.delete(rt);
                        },
                        update: function(rt, Wn, Co) {
                            Qe.get(rt)[Wn] = Co;
                        },
                        dispose: function() {
                            Qe = new WeakMap;
                        }
                    };
                }
                function painterSortStable(Qe, rt) {
                    return Qe.groupOrder !== rt.groupOrder ? Qe.groupOrder - rt.groupOrder : Qe.renderOrder !== rt.renderOrder ? Qe.renderOrder - rt.renderOrder : Qe.material.id !== rt.material.id ? Qe.material.id - rt.material.id : Qe.z !== rt.z ? Qe.z - rt.z : Qe.id - rt.id;
                }
                function reversePainterSortStable(Qe, rt) {
                    return Qe.groupOrder !== rt.groupOrder ? Qe.groupOrder - rt.groupOrder : Qe.renderOrder !== rt.renderOrder ? Qe.renderOrder - rt.renderOrder : Qe.z !== rt.z ? rt.z - Qe.z : Qe.id - rt.id;
                }
                function WebGLRenderList() {
                    const Qe = [];
                    let rt = 0;
                    const Wn = [], Co = [], Dl = [];
                    function getNextRenderItem(Wn, Co, Dl, Ll, Rl, Ul) {
                        let Gl = Qe[rt];
                        return void 0 === Gl ? (Gl = {
                            id: Wn.id,
                            object: Wn,
                            geometry: Co,
                            material: Dl,
                            groupOrder: Ll,
                            renderOrder: Wn.renderOrder,
                            z: Rl,
                            group: Ul
                        }, Qe[rt] = Gl) : (Gl.id = Wn.id, Gl.object = Wn, Gl.geometry = Co, Gl.material = Dl, Gl.groupOrder = Ll, Gl.renderOrder = Wn.renderOrder, Gl.z = Rl, Gl.group = Ul), rt++, Gl;
                    }
                    return {
                        opaque: Wn,
                        transmissive: Co,
                        transparent: Dl,
                        init: function() {
                            rt = 0, Wn.length = 0, Co.length = 0, Dl.length = 0;
                        },
                        push: function(Qe, rt, Ll, Rl, Ul, Gl) {
                            const Zl = getNextRenderItem(Qe, rt, Ll, Rl, Ul, Gl);
                            Ll.transmission > 0 ? Co.push(Zl) : !0 === Ll.transparent ? Dl.push(Zl) : Wn.push(Zl);
                        },
                        unshift: function(Qe, rt, Ll, Rl, Ul, Gl) {
                            const Zl = getNextRenderItem(Qe, rt, Ll, Rl, Ul, Gl);
                            Ll.transmission > 0 ? Co.unshift(Zl) : !0 === Ll.transparent ? Dl.unshift(Zl) : Wn.unshift(Zl);
                        },
                        finish: function() {
                            for(let Wn = rt, Co = Qe.length; Wn < Co; Wn++){
                                const rt = Qe[Wn];
                                if (null === rt.id) break;
                                rt.id = null, rt.object = null, rt.geometry = null, rt.material = null, rt.group = null;
                            }
                        },
                        sort: function(Qe, rt) {
                            Wn.length > 1 && Wn.sort(Qe || painterSortStable), Co.length > 1 && Co.sort(rt || reversePainterSortStable), Dl.length > 1 && Dl.sort(rt || reversePainterSortStable);
                        }
                    };
                }
                function WebGLRenderLists() {
                    let Qe = new WeakMap;
                    return {
                        get: function(rt, Wn) {
                            const Co = Qe.get(rt);
                            let Dl;
                            return void 0 === Co ? (Dl = new WebGLRenderList, Qe.set(rt, [
                                Dl
                            ])) : Wn >= Co.length ? (Dl = new WebGLRenderList, Co.push(Dl)) : Dl = Co[Wn], Dl;
                        },
                        dispose: function() {
                            Qe = new WeakMap;
                        }
                    };
                }
                function UniformsCache() {
                    const Qe = {};
                    return {
                        get: function(rt) {
                            if (void 0 !== Qe[rt.id]) return Qe[rt.id];
                            let Wn;
                            switch(rt.type){
                                case "DirectionalLight":
                                    Wn = {
                                        direction: new Co.Pq0,
                                        color: new Co.Q1f
                                    };
                                    break;
                                case "SpotLight":
                                    Wn = {
                                        position: new Co.Pq0,
                                        direction: new Co.Pq0,
                                        color: new Co.Q1f,
                                        distance: 0,
                                        coneCos: 0,
                                        penumbraCos: 0,
                                        decay: 0
                                    };
                                    break;
                                case "PointLight":
                                    Wn = {
                                        position: new Co.Pq0,
                                        color: new Co.Q1f,
                                        distance: 0,
                                        decay: 0
                                    };
                                    break;
                                case "HemisphereLight":
                                    Wn = {
                                        direction: new Co.Pq0,
                                        skyColor: new Co.Q1f,
                                        groundColor: new Co.Q1f
                                    };
                                    break;
                                case "RectAreaLight":
                                    Wn = {
                                        color: new Co.Q1f,
                                        position: new Co.Pq0,
                                        halfWidth: new Co.Pq0,
                                        halfHeight: new Co.Pq0
                                    };
                            }
                            return Qe[rt.id] = Wn, Wn;
                        }
                    };
                }
                let hd = 0;
                function shadowCastingAndTexturingLightsFirst(Qe, rt) {
                    return (rt.castShadow ? 2 : 0) - (Qe.castShadow ? 2 : 0) + (rt.map ? 1 : 0) - (Qe.map ? 1 : 0);
                }
                function WebGLLights(Qe) {
                    const rt = new UniformsCache, Wn = function() {
                        const Qe = {};
                        return {
                            get: function(rt) {
                                if (void 0 !== Qe[rt.id]) return Qe[rt.id];
                                let Wn;
                                switch(rt.type){
                                    case "DirectionalLight":
                                    case "SpotLight":
                                        Wn = {
                                            shadowIntensity: 1,
                                            shadowBias: 0,
                                            shadowNormalBias: 0,
                                            shadowRadius: 1,
                                            shadowMapSize: new Co.I9Y
                                        };
                                        break;
                                    case "PointLight":
                                        Wn = {
                                            shadowIntensity: 1,
                                            shadowBias: 0,
                                            shadowNormalBias: 0,
                                            shadowRadius: 1,
                                            shadowMapSize: new Co.I9Y,
                                            shadowCameraNear: 1,
                                            shadowCameraFar: 1e3
                                        };
                                }
                                return Qe[rt.id] = Wn, Wn;
                            }
                        };
                    }(), Dl = {
                        version: 0,
                        hash: {
                            directionalLength: -1,
                            pointLength: -1,
                            spotLength: -1,
                            rectAreaLength: -1,
                            hemiLength: -1,
                            numDirectionalShadows: -1,
                            numPointShadows: -1,
                            numSpotShadows: -1,
                            numSpotMaps: -1,
                            numLightProbes: -1
                        },
                        ambient: [
                            0,
                            0,
                            0
                        ],
                        probe: [],
                        directional: [],
                        directionalShadow: [],
                        directionalShadowMap: [],
                        directionalShadowMatrix: [],
                        spot: [],
                        spotLightMap: [],
                        spotShadow: [],
                        spotShadowMap: [],
                        spotLightMatrix: [],
                        rectArea: [],
                        rectAreaLTC1: null,
                        rectAreaLTC2: null,
                        point: [],
                        pointShadow: [],
                        pointShadowMap: [],
                        pointShadowMatrix: [],
                        hemi: [],
                        numSpotLightShadowsWithMaps: 0,
                        numLightProbes: 0
                    };
                    for(let Ll = 0; Ll < 9; Ll++)Dl.probe.push(new Co.Pq0);
                    const Rl = new Co.Pq0, Ul = new Co.kn4, Gl = new Co.kn4;
                    return {
                        setup: function(Co) {
                            let Rl = 0, Ul = 0, Gl = 0;
                            for(let Qe = 0; Qe < 9; Qe++)Dl.probe[Qe].set(0, 0, 0);
                            let Zl = 0, Hl = 0, ql = 0, Ql = 0, Kl = 0, $l = 0, Tc = 0, tu = 0, lu = 0, du = 0, fu = 0;
                            Co.sort(shadowCastingAndTexturingLightsFirst);
                            for(let Qe = 0, Ll = Co.length; Qe < Ll; Qe++){
                                const Ll = Co[Qe], yu = Ll.color, Eu = Ll.intensity, Tu = Ll.distance, Lu = Ll.shadow && Ll.shadow.map ? Ll.shadow.map.texture : null;
                                if (Ll.isAmbientLight) Rl += yu.r * Eu, Ul += yu.g * Eu, Gl += yu.b * Eu;
                                else if (Ll.isLightProbe) {
                                    for(let Qe = 0; Qe < 9; Qe++)Dl.probe[Qe].addScaledVector(Ll.sh.coefficients[Qe], Eu);
                                    fu++;
                                } else if (Ll.isDirectionalLight) {
                                    const Qe = rt.get(Ll);
                                    if (Qe.color.copy(Ll.color).multiplyScalar(Ll.intensity), Ll.castShadow) {
                                        const Qe = Ll.shadow, rt = Wn.get(Ll);
                                        rt.shadowIntensity = Qe.intensity, rt.shadowBias = Qe.bias, rt.shadowNormalBias = Qe.normalBias, rt.shadowRadius = Qe.radius, rt.shadowMapSize = Qe.mapSize, Dl.directionalShadow[Zl] = rt, Dl.directionalShadowMap[Zl] = Lu, Dl.directionalShadowMatrix[Zl] = Ll.shadow.matrix, $l++;
                                    }
                                    Dl.directional[Zl] = Qe, Zl++;
                                } else if (Ll.isSpotLight) {
                                    const Qe = rt.get(Ll);
                                    Qe.position.setFromMatrixPosition(Ll.matrixWorld), Qe.color.copy(yu).multiplyScalar(Eu), Qe.distance = Tu, Qe.coneCos = Math.cos(Ll.angle), Qe.penumbraCos = Math.cos(Ll.angle * (1 - Ll.penumbra)), Qe.decay = Ll.decay, Dl.spot[ql] = Qe;
                                    const Co = Ll.shadow;
                                    if (Ll.map && (Dl.spotLightMap[lu] = Ll.map, lu++, Co.updateMatrices(Ll), Ll.castShadow && du++), Dl.spotLightMatrix[ql] = Co.matrix, Ll.castShadow) {
                                        const Qe = Wn.get(Ll);
                                        Qe.shadowIntensity = Co.intensity, Qe.shadowBias = Co.bias, Qe.shadowNormalBias = Co.normalBias, Qe.shadowRadius = Co.radius, Qe.shadowMapSize = Co.mapSize, Dl.spotShadow[ql] = Qe, Dl.spotShadowMap[ql] = Lu, tu++;
                                    }
                                    ql++;
                                } else if (Ll.isRectAreaLight) {
                                    const Qe = rt.get(Ll);
                                    Qe.color.copy(yu).multiplyScalar(Eu), Qe.halfWidth.set(.5 * Ll.width, 0, 0), Qe.halfHeight.set(0, .5 * Ll.height, 0), Dl.rectArea[Ql] = Qe, Ql++;
                                } else if (Ll.isPointLight) {
                                    const Qe = rt.get(Ll);
                                    if (Qe.color.copy(Ll.color).multiplyScalar(Ll.intensity), Qe.distance = Ll.distance, Qe.decay = Ll.decay, Ll.castShadow) {
                                        const Qe = Ll.shadow, rt = Wn.get(Ll);
                                        rt.shadowIntensity = Qe.intensity, rt.shadowBias = Qe.bias, rt.shadowNormalBias = Qe.normalBias, rt.shadowRadius = Qe.radius, rt.shadowMapSize = Qe.mapSize, rt.shadowCameraNear = Qe.camera.near, rt.shadowCameraFar = Qe.camera.far, Dl.pointShadow[Hl] = rt, Dl.pointShadowMap[Hl] = Lu, Dl.pointShadowMatrix[Hl] = Ll.shadow.matrix, Tc++;
                                    }
                                    Dl.point[Hl] = Qe, Hl++;
                                } else if (Ll.isHemisphereLight) {
                                    const Qe = rt.get(Ll);
                                    Qe.skyColor.copy(Ll.color).multiplyScalar(Eu), Qe.groundColor.copy(Ll.groundColor).multiplyScalar(Eu), Dl.hemi[Kl] = Qe, Kl++;
                                }
                            }
                            Ql > 0 && (!0 === Qe.has("OES_texture_float_linear") ? (Dl.rectAreaLTC1 = Ll.LTC_FLOAT_1, Dl.rectAreaLTC2 = Ll.LTC_FLOAT_2) : (Dl.rectAreaLTC1 = Ll.LTC_HALF_1, Dl.rectAreaLTC2 = Ll.LTC_HALF_2)), Dl.ambient[0] = Rl, Dl.ambient[1] = Ul, Dl.ambient[2] = Gl;
                            const yu = Dl.hash;
                            yu.directionalLength === Zl && yu.pointLength === Hl && yu.spotLength === ql && yu.rectAreaLength === Ql && yu.hemiLength === Kl && yu.numDirectionalShadows === $l && yu.numPointShadows === Tc && yu.numSpotShadows === tu && yu.numSpotMaps === lu && yu.numLightProbes === fu || (Dl.directional.length = Zl, Dl.spot.length = ql, Dl.rectArea.length = Ql, Dl.point.length = Hl, Dl.hemi.length = Kl, Dl.directionalShadow.length = $l, Dl.directionalShadowMap.length = $l, Dl.pointShadow.length = Tc, Dl.pointShadowMap.length = Tc, Dl.spotShadow.length = tu, Dl.spotShadowMap.length = tu, Dl.directionalShadowMatrix.length = $l, Dl.pointShadowMatrix.length = Tc, Dl.spotLightMatrix.length = tu + lu - du, Dl.spotLightMap.length = lu, Dl.numSpotLightShadowsWithMaps = du, Dl.numLightProbes = fu, yu.directionalLength = Zl, yu.pointLength = Hl, yu.spotLength = ql, yu.rectAreaLength = Ql, yu.hemiLength = Kl, yu.numDirectionalShadows = $l, yu.numPointShadows = Tc, yu.numSpotShadows = tu, yu.numSpotMaps = lu, yu.numLightProbes = fu, Dl.version = hd++);
                        },
                        setupView: function(Qe, rt) {
                            let Wn = 0, Co = 0, Ll = 0, Zl = 0, Hl = 0;
                            const ql = rt.matrixWorldInverse;
                            for(let Ql = 0, Kl = Qe.length; Ql < Kl; Ql++){
                                const rt = Qe[Ql];
                                if (rt.isDirectionalLight) {
                                    const Qe = Dl.directional[Wn];
                                    Qe.direction.setFromMatrixPosition(rt.matrixWorld), Rl.setFromMatrixPosition(rt.target.matrixWorld), Qe.direction.sub(Rl), Qe.direction.transformDirection(ql), Wn++;
                                } else if (rt.isSpotLight) {
                                    const Qe = Dl.spot[Ll];
                                    Qe.position.setFromMatrixPosition(rt.matrixWorld), Qe.position.applyMatrix4(ql), Qe.direction.setFromMatrixPosition(rt.matrixWorld), Rl.setFromMatrixPosition(rt.target.matrixWorld), Qe.direction.sub(Rl), Qe.direction.transformDirection(ql), Ll++;
                                } else if (rt.isRectAreaLight) {
                                    const Qe = Dl.rectArea[Zl];
                                    Qe.position.setFromMatrixPosition(rt.matrixWorld), Qe.position.applyMatrix4(ql), Gl.identity(), Ul.copy(rt.matrixWorld), Ul.premultiply(ql), Gl.extractRotation(Ul), Qe.halfWidth.set(.5 * rt.width, 0, 0), Qe.halfHeight.set(0, .5 * rt.height, 0), Qe.halfWidth.applyMatrix4(Gl), Qe.halfHeight.applyMatrix4(Gl), Zl++;
                                } else if (rt.isPointLight) {
                                    const Qe = Dl.point[Co];
                                    Qe.position.setFromMatrixPosition(rt.matrixWorld), Qe.position.applyMatrix4(ql), Co++;
                                } else if (rt.isHemisphereLight) {
                                    const Qe = Dl.hemi[Hl];
                                    Qe.direction.setFromMatrixPosition(rt.matrixWorld), Qe.direction.transformDirection(ql), Hl++;
                                }
                            }
                        },
                        state: Dl
                    };
                }
                function WebGLRenderState(Qe) {
                    const rt = new WebGLLights(Qe), Wn = [], Co = [];
                    const Dl = {
                        lightsArray: Wn,
                        shadowsArray: Co,
                        camera: null,
                        lights: rt,
                        transmissionRenderTarget: {}
                    };
                    return {
                        init: function(Qe) {
                            Dl.camera = Qe, Wn.length = 0, Co.length = 0;
                        },
                        state: Dl,
                        setupLights: function() {
                            rt.setup(Wn);
                        },
                        setupLightsView: function(Qe) {
                            rt.setupView(Wn, Qe);
                        },
                        pushLight: function(Qe) {
                            Wn.push(Qe);
                        },
                        pushShadow: function(Qe) {
                            Co.push(Qe);
                        }
                    };
                }
                function WebGLRenderStates(Qe) {
                    let rt = new WeakMap;
                    return {
                        get: function(Wn, Co) {
                            void 0 === Co && (Co = 0);
                            const Dl = rt.get(Wn);
                            let Ll;
                            return void 0 === Dl ? (Ll = new WebGLRenderState(Qe), rt.set(Wn, [
                                Ll
                            ])) : Co >= Dl.length ? (Ll = new WebGLRenderState(Qe), Dl.push(Ll)) : Ll = Dl[Co], Ll;
                        },
                        dispose: function() {
                            rt = new WeakMap;
                        }
                    };
                }
                function WebGLShadowMap(Qe, rt, Wn) {
                    let Dl = new Co.PPD;
                    const Ll = new Co.I9Y, Rl = new Co.I9Y, Ul = new Co.IUQ, Gl = new Co.CSG({
                        depthPacking: Co.N5j
                    }), Zl = new Co.aVO, Hl = {}, ql = Wn.maxTextureSize, Ql = {
                        [Co.hB5]: Co.hsX,
                        [Co.hsX]: Co.hB5,
                        [Co.$EB]: Co.$EB
                    }, Kl = new Co.BKk({
                        defines: {
                            VSM_SAMPLES: 8
                        },
                        uniforms: {
                            shadow_pass: {
                                value: null
                            },
                            resolution: {
                                value: new Co.I9Y
                            },
                            radius: {
                                value: 4
                            }
                        },
                        vertexShader: "void main() {\n	gl_Position = vec4( position, 1.0 );\n}",
                        fragmentShader: "uniform sampler2D shadow_pass;\nuniform vec2 resolution;\nuniform float radius;\n#include <packing>\nvoid main() {\n	const float samples = float( VSM_SAMPLES );\n	float mean = 0.0;\n	float squared_mean = 0.0;\n	float uvStride = samples <= 1.0 ? 0.0 : 2.0 / ( samples - 1.0 );\n	float uvStart = samples <= 1.0 ? 0.0 : - 1.0;\n	for ( float i = 0.0; i < samples; i ++ ) {\n		float uvOffset = uvStart + i * uvStride;\n		#ifdef HORIZONTAL_PASS\n			vec2 distribution = unpackRGBATo2Half( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( uvOffset, 0.0 ) * radius ) / resolution ) );\n			mean += distribution.x;\n			squared_mean += distribution.y * distribution.y + distribution.x * distribution.x;\n		#else\n			float depth = unpackRGBAToDepth( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( 0.0, uvOffset ) * radius ) / resolution ) );\n			mean += depth;\n			squared_mean += depth * depth;\n		#endif\n	}\n	mean = mean / samples;\n	squared_mean = squared_mean / samples;\n	float std_dev = sqrt( squared_mean - mean * mean );\n	gl_FragColor = pack2HalfToRGBA( vec2( mean, std_dev ) );\n}"
                    }), $l = Kl.clone();
                    $l.defines.HORIZONTAL_PASS = 1;
                    const Tc = new Co.LoY;
                    Tc.setAttribute("position", new Co.THS(new Float32Array([
                        -1,
                        -1,
                        .5,
                        3,
                        -1,
                        .5,
                        -1,
                        3,
                        .5
                    ]), 3));
                    const tu = new Co.eaF(Tc, Kl), lu = this;
                    this.enabled = !1, this.autoUpdate = !0, this.needsUpdate = !1, this.type = Co.QP0;
                    let du = this.type;
                    function VSMPass(Wn, Dl) {
                        const Rl = rt.update(tu);
                        Kl.defines.VSM_SAMPLES !== Wn.blurSamples && (Kl.defines.VSM_SAMPLES = Wn.blurSamples, $l.defines.VSM_SAMPLES = Wn.blurSamples, Kl.needsUpdate = !0, $l.needsUpdate = !0), null === Wn.mapPass && (Wn.mapPass = new Co.nWS(Ll.x, Ll.y)), Kl.uniforms.shadow_pass.value = Wn.map.texture, Kl.uniforms.resolution.value = Wn.mapSize, Kl.uniforms.radius.value = Wn.radius, Qe.setRenderTarget(Wn.mapPass), Qe.clear(), Qe.renderBufferDirect(Dl, null, Rl, Kl, tu, null), $l.uniforms.shadow_pass.value = Wn.mapPass.texture, $l.uniforms.resolution.value = Wn.mapSize, $l.uniforms.radius.value = Wn.radius, Qe.setRenderTarget(Wn.map), Qe.clear(), Qe.renderBufferDirect(Dl, null, Rl, $l, tu, null);
                    }
                    function getDepthMaterial(rt, Wn, Dl, Ll) {
                        let Rl = null;
                        const Ul = !0 === Dl.isPointLight ? rt.customDistanceMaterial : rt.customDepthMaterial;
                        if (void 0 !== Ul) Rl = Ul;
                        else if (Rl = !0 === Dl.isPointLight ? Zl : Gl, Qe.localClippingEnabled && !0 === Wn.clipShadows && Array.isArray(Wn.clippingPlanes) && 0 !== Wn.clippingPlanes.length || Wn.displacementMap && 0 !== Wn.displacementScale || Wn.alphaMap && Wn.alphaTest > 0 || Wn.map && Wn.alphaTest > 0) {
                            const Qe = Rl.uuid, rt = Wn.uuid;
                            let Co = Hl[Qe];
                            void 0 === Co && (Co = {}, Hl[Qe] = Co);
                            let Dl = Co[rt];
                            void 0 === Dl && (Dl = Rl.clone(), Co[rt] = Dl, Wn.addEventListener("dispose", onMaterialDispose)), Rl = Dl;
                        }
                        if (Rl.visible = Wn.visible, Rl.wireframe = Wn.wireframe, Ll === Co.RyA ? Rl.side = null !== Wn.shadowSide ? Wn.shadowSide : Wn.side : Rl.side = null !== Wn.shadowSide ? Wn.shadowSide : Ql[Wn.side], Rl.alphaMap = Wn.alphaMap, Rl.alphaTest = Wn.alphaTest, Rl.map = Wn.map, Rl.clipShadows = Wn.clipShadows, Rl.clippingPlanes = Wn.clippingPlanes, Rl.clipIntersection = Wn.clipIntersection, Rl.displacementMap = Wn.displacementMap, Rl.displacementScale = Wn.displacementScale, Rl.displacementBias = Wn.displacementBias, Rl.wireframeLinewidth = Wn.wireframeLinewidth, Rl.linewidth = Wn.linewidth, !0 === Dl.isPointLight && !0 === Rl.isMeshDistanceMaterial) Qe.properties.get(Rl).light = Dl;
                        return Rl;
                    }
                    function renderObject(Wn, Ll, Rl, Ul, Gl) {
                        if (!1 === Wn.visible) return;
                        if (Wn.layers.test(Ll.layers) && (Wn.isMesh || Wn.isLine || Wn.isPoints) && (Wn.castShadow || Wn.receiveShadow && Gl === Co.RyA) && (!Wn.frustumCulled || Dl.intersectsObject(Wn))) {
                            Wn.modelViewMatrix.multiplyMatrices(Rl.matrixWorldInverse, Wn.matrixWorld);
                            const Co = rt.update(Wn), Dl = Wn.material;
                            if (Array.isArray(Dl)) {
                                const rt = Co.groups;
                                for(let Zl = 0, Hl = rt.length; Zl < Hl; Zl++){
                                    const Hl = rt[Zl], ql = Dl[Hl.materialIndex];
                                    if (ql && ql.visible) {
                                        const rt = getDepthMaterial(Wn, ql, Ul, Gl);
                                        Wn.onBeforeShadow(Qe, Wn, Ll, Rl, Co, rt, Hl), Qe.renderBufferDirect(Rl, null, Co, rt, Wn, Hl), Wn.onAfterShadow(Qe, Wn, Ll, Rl, Co, rt, Hl);
                                    }
                                }
                            } else if (Dl.visible) {
                                const rt = getDepthMaterial(Wn, Dl, Ul, Gl);
                                Wn.onBeforeShadow(Qe, Wn, Ll, Rl, Co, rt, null), Qe.renderBufferDirect(Rl, null, Co, rt, Wn, null), Wn.onAfterShadow(Qe, Wn, Ll, Rl, Co, rt, null);
                            }
                        }
                        const Zl = Wn.children;
                        for(let Qe = 0, rt = Zl.length; Qe < rt; Qe++)renderObject(Zl[Qe], Ll, Rl, Ul, Gl);
                    }
                    function onMaterialDispose(Qe) {
                        Qe.target.removeEventListener("dispose", onMaterialDispose);
                        for(const rt in Hl){
                            const Wn = Hl[rt], Co = Qe.target.uuid;
                            if (Co in Wn) Wn[Co].dispose(), delete Wn[Co];
                        }
                    }
                    this.render = function(rt, Wn, Gl) {
                        if (!1 === lu.enabled) return;
                        if (!1 === lu.autoUpdate && !1 === lu.needsUpdate) return;
                        if (0 === rt.length) return;
                        const Zl = Qe.getRenderTarget(), Hl = Qe.getActiveCubeFace(), Ql = Qe.getActiveMipmapLevel(), Kl = Qe.state;
                        Kl.setBlending(Co.XIg), Kl.buffers.color.setClear(1, 1, 1, 1), Kl.buffers.depth.setTest(!0), Kl.setScissorTest(!1);
                        const $l = du !== Co.RyA && this.type === Co.RyA, Tc = du === Co.RyA && this.type !== Co.RyA;
                        for(let tu = 0, lu = rt.length; tu < lu; tu++){
                            const Zl = rt[tu], Hl = Zl.shadow;
                            if (void 0 === Hl) {
                                console.warn("THREE.WebGLShadowMap:", Zl, "has no shadow.");
                                continue;
                            }
                            if (!1 === Hl.autoUpdate && !1 === Hl.needsUpdate) continue;
                            Ll.copy(Hl.mapSize);
                            const Ql = Hl.getFrameExtents();
                            if (Ll.multiply(Ql), Rl.copy(Hl.mapSize), (Ll.x > ql || Ll.y > ql) && (Ll.x > ql && (Rl.x = Math.floor(ql / Ql.x), Ll.x = Rl.x * Ql.x, Hl.mapSize.x = Rl.x), Ll.y > ql && (Rl.y = Math.floor(ql / Ql.y), Ll.y = Rl.y * Ql.y, Hl.mapSize.y = Rl.y)), null === Hl.map || !0 === $l || !0 === Tc) {
                                const Qe = this.type !== Co.RyA ? {
                                    minFilter: Co.hxR,
                                    magFilter: Co.hxR
                                } : {};
                                null !== Hl.map && Hl.map.dispose(), Hl.map = new Co.nWS(Ll.x, Ll.y, Qe), Hl.map.texture.name = Zl.name + ".shadowMap", Hl.camera.updateProjectionMatrix();
                            }
                            Qe.setRenderTarget(Hl.map), Qe.clear();
                            const lu = Hl.getViewportCount();
                            for(let Qe = 0; Qe < lu; Qe++){
                                const rt = Hl.getViewport(Qe);
                                Ul.set(Rl.x * rt.x, Rl.y * rt.y, Rl.x * rt.z, Rl.y * rt.w), Kl.viewport(Ul), Hl.updateMatrices(Zl, Qe), Dl = Hl.getFrustum(), renderObject(Wn, Gl, Hl.camera, Zl, this.type);
                            }
                            !0 !== Hl.isPointLightShadow && this.type === Co.RyA && VSMPass(Hl, Gl), Hl.needsUpdate = !1;
                        }
                        du = this.type, lu.needsUpdate = !1, Qe.setRenderTarget(Zl, Hl, Ql);
                    };
                }
                const dd = {
                    [Co.eHc]: Co.lGu,
                    [Co.brA]: Co.K52,
                    [Co.U3G]: Co.bw0,
                    [Co.xSv]: Co.Gwm,
                    [Co.lGu]: Co.eHc,
                    [Co.K52]: Co.brA,
                    [Co.bw0]: Co.U3G,
                    [Co.Gwm]: Co.xSv
                };
                function WebGLState(Qe, rt) {
                    const Wn = new function() {
                        let rt = !1;
                        const Wn = new Co.IUQ;
                        let Dl = null;
                        const Ll = new Co.IUQ(0, 0, 0, 0);
                        return {
                            setMask: function(Wn) {
                                Dl === Wn || rt || (Qe.colorMask(Wn, Wn, Wn, Wn), Dl = Wn);
                            },
                            setLocked: function(Qe) {
                                rt = Qe;
                            },
                            setClear: function(rt, Co, Dl, Rl, Ul) {
                                !0 === Ul && (rt *= Rl, Co *= Rl, Dl *= Rl), Wn.set(rt, Co, Dl, Rl), !1 === Ll.equals(Wn) && (Qe.clearColor(rt, Co, Dl, Rl), Ll.copy(Wn));
                            },
                            reset: function() {
                                rt = !1, Dl = null, Ll.set(-1, 0, 0, 0);
                            }
                        };
                    }, Dl = new function() {
                        let Wn = !1, Dl = !1, Ll = null, Rl = null, Ul = null;
                        return {
                            setReversed: function(Qe) {
                                if (Dl !== Qe) {
                                    const Qe = rt.get("EXT_clip_control");
                                    Dl ? Qe.clipControlEXT(Qe.LOWER_LEFT_EXT, Qe.ZERO_TO_ONE_EXT) : Qe.clipControlEXT(Qe.LOWER_LEFT_EXT, Qe.NEGATIVE_ONE_TO_ONE_EXT);
                                    const Wn = Ul;
                                    Ul = null, this.setClear(Wn);
                                }
                                Dl = Qe;
                            },
                            getReversed: function() {
                                return Dl;
                            },
                            setTest: function(rt) {
                                rt ? enable(Qe.DEPTH_TEST) : disable(Qe.DEPTH_TEST);
                            },
                            setMask: function(rt) {
                                Ll === rt || Wn || (Qe.depthMask(rt), Ll = rt);
                            },
                            setFunc: function(rt) {
                                if (Dl && (rt = dd[rt]), Rl !== rt) {
                                    switch(rt){
                                        case Co.eHc:
                                            Qe.depthFunc(Qe.NEVER);
                                            break;
                                        case Co.lGu:
                                            Qe.depthFunc(Qe.ALWAYS);
                                            break;
                                        case Co.brA:
                                            Qe.depthFunc(Qe.LESS);
                                            break;
                                        case Co.xSv:
                                            Qe.depthFunc(Qe.LEQUAL);
                                            break;
                                        case Co.U3G:
                                            Qe.depthFunc(Qe.EQUAL);
                                            break;
                                        case Co.Gwm:
                                            Qe.depthFunc(Qe.GEQUAL);
                                            break;
                                        case Co.K52:
                                            Qe.depthFunc(Qe.GREATER);
                                            break;
                                        case Co.bw0:
                                            Qe.depthFunc(Qe.NOTEQUAL);
                                            break;
                                        default:
                                            Qe.depthFunc(Qe.LEQUAL);
                                    }
                                    Rl = rt;
                                }
                            },
                            setLocked: function(Qe) {
                                Wn = Qe;
                            },
                            setClear: function(rt) {
                                Ul !== rt && (Dl && (rt = 1 - rt), Qe.clearDepth(rt), Ul = rt);
                            },
                            reset: function() {
                                Wn = !1, Ll = null, Rl = null, Ul = null, Dl = !1;
                            }
                        };
                    }, Ll = new function() {
                        let rt = !1, Wn = null, Co = null, Dl = null, Ll = null, Rl = null, Ul = null, Gl = null, Zl = null;
                        return {
                            setTest: function(Wn) {
                                rt || (Wn ? enable(Qe.STENCIL_TEST) : disable(Qe.STENCIL_TEST));
                            },
                            setMask: function(Co) {
                                Wn === Co || rt || (Qe.stencilMask(Co), Wn = Co);
                            },
                            setFunc: function(rt, Wn, Rl) {
                                Co === rt && Dl === Wn && Ll === Rl || (Qe.stencilFunc(rt, Wn, Rl), Co = rt, Dl = Wn, Ll = Rl);
                            },
                            setOp: function(rt, Wn, Co) {
                                Rl === rt && Ul === Wn && Gl === Co || (Qe.stencilOp(rt, Wn, Co), Rl = rt, Ul = Wn, Gl = Co);
                            },
                            setLocked: function(Qe) {
                                rt = Qe;
                            },
                            setClear: function(rt) {
                                Zl !== rt && (Qe.clearStencil(rt), Zl = rt);
                            },
                            reset: function() {
                                rt = !1, Wn = null, Co = null, Dl = null, Ll = null, Rl = null, Ul = null, Gl = null, Zl = null;
                            }
                        };
                    }, Rl = new WeakMap, Ul = new WeakMap;
                    let Gl = {}, Zl = {}, Hl = new WeakMap, ql = [], Ql = null, Kl = !1, $l = null, Tc = null, tu = null, lu = null, du = null, fu = null, yu = null, Eu = new Co.Q1f(0, 0, 0), Tu = 0, Lu = !1, Zu = null, Xu = null, Ju = null, $u = null, ed = null;
                    const td = Qe.getParameter(Qe.MAX_COMBINED_TEXTURE_IMAGE_UNITS);
                    let id = !1, nd = 0;
                    const rd = Qe.getParameter(Qe.VERSION);
                    -1 !== rd.indexOf("WebGL") ? (nd = parseFloat(/^WebGL (\d)/.exec(rd)[1]), id = nd >= 1) : -1 !== rd.indexOf("OpenGL ES") && (nd = parseFloat(/^OpenGL ES (\d)/.exec(rd)[1]), id = nd >= 2);
                    let sd = null, ad = {};
                    const od = Qe.getParameter(Qe.SCISSOR_BOX), ld = Qe.getParameter(Qe.VIEWPORT), cd = (new Co.IUQ).fromArray(od), ud = (new Co.IUQ).fromArray(ld);
                    function createTexture(rt, Wn, Co, Dl) {
                        const Ll = new Uint8Array(4), Rl = Qe.createTexture();
                        Qe.bindTexture(rt, Rl), Qe.texParameteri(rt, Qe.TEXTURE_MIN_FILTER, Qe.NEAREST), Qe.texParameteri(rt, Qe.TEXTURE_MAG_FILTER, Qe.NEAREST);
                        for(let Ul = 0; Ul < Co; Ul++)rt === Qe.TEXTURE_3D || rt === Qe.TEXTURE_2D_ARRAY ? Qe.texImage3D(Wn, 0, Qe.RGBA, 1, 1, Dl, 0, Qe.RGBA, Qe.UNSIGNED_BYTE, Ll) : Qe.texImage2D(Wn + Ul, 0, Qe.RGBA, 1, 1, 0, Qe.RGBA, Qe.UNSIGNED_BYTE, Ll);
                        return Rl;
                    }
                    const hd = {};
                    function enable(rt) {
                        !0 !== Gl[rt] && (Qe.enable(rt), Gl[rt] = !0);
                    }
                    function disable(rt) {
                        !1 !== Gl[rt] && (Qe.disable(rt), Gl[rt] = !1);
                    }
                    hd[Qe.TEXTURE_2D] = createTexture(Qe.TEXTURE_2D, Qe.TEXTURE_2D, 1), hd[Qe.TEXTURE_CUBE_MAP] = createTexture(Qe.TEXTURE_CUBE_MAP, Qe.TEXTURE_CUBE_MAP_POSITIVE_X, 6), hd[Qe.TEXTURE_2D_ARRAY] = createTexture(Qe.TEXTURE_2D_ARRAY, Qe.TEXTURE_2D_ARRAY, 1, 1), hd[Qe.TEXTURE_3D] = createTexture(Qe.TEXTURE_3D, Qe.TEXTURE_3D, 1, 1), Wn.setClear(0, 0, 0, 1), Dl.setClear(1), Ll.setClear(0), enable(Qe.DEPTH_TEST), Dl.setFunc(Co.xSv), setFlipSided(!1), setCullFace(Co.Vb5), enable(Qe.CULL_FACE), setBlending(Co.XIg);
                    const pd = {
                        [Co.gO9]: Qe.FUNC_ADD,
                        [Co.FXf]: Qe.FUNC_SUBTRACT,
                        [Co.nST]: Qe.FUNC_REVERSE_SUBTRACT
                    };
                    pd[Co.znC] = Qe.MIN, pd[Co.$ei] = Qe.MAX;
                    const md = {
                        [Co.ojh]: Qe.ZERO,
                        [Co.qad]: Qe.ONE,
                        [Co.f4X]: Qe.SRC_COLOR,
                        [Co.ie2]: Qe.SRC_ALPHA,
                        [Co.hgQ]: Qe.SRC_ALPHA_SATURATE,
                        [Co.wn6]: Qe.DST_COLOR,
                        [Co.hdd]: Qe.DST_ALPHA,
                        [Co.LiQ]: Qe.ONE_MINUS_SRC_COLOR,
                        [Co.OuU]: Qe.ONE_MINUS_SRC_ALPHA,
                        [Co.aEY]: Qe.ONE_MINUS_DST_COLOR,
                        [Co.Nt7]: Qe.ONE_MINUS_DST_ALPHA,
                        [Co.RrE]: Qe.CONSTANT_COLOR,
                        [Co.$Yl]: Qe.ONE_MINUS_CONSTANT_COLOR,
                        [Co.e0p]: Qe.CONSTANT_ALPHA,
                        [Co.ov9]: Qe.ONE_MINUS_CONSTANT_ALPHA
                    };
                    function setBlending(rt, Wn, Dl, Ll, Rl, Ul, Gl, Zl, Hl, ql) {
                        if (rt !== Co.XIg) {
                            if (!1 === Kl && (enable(Qe.BLEND), Kl = !0), rt === Co.bCz) Rl = Rl || Wn, Ul = Ul || Dl, Gl = Gl || Ll, Wn === Tc && Rl === du || (Qe.blendEquationSeparate(pd[Wn], pd[Rl]), Tc = Wn, du = Rl), Dl === tu && Ll === lu && Ul === fu && Gl === yu || (Qe.blendFuncSeparate(md[Dl], md[Ll], md[Ul], md[Gl]), tu = Dl, lu = Ll, fu = Ul, yu = Gl), !1 !== Zl.equals(Eu) && Hl === Tu || (Qe.blendColor(Zl.r, Zl.g, Zl.b, Hl), Eu.copy(Zl), Tu = Hl), $l = rt, Lu = !1;
                            else if (rt !== $l || ql !== Lu) {
                                if (Tc === Co.gO9 && du === Co.gO9 || (Qe.blendEquation(Qe.FUNC_ADD), Tc = Co.gO9, du = Co.gO9), ql) switch(rt){
                                    case Co.NTi:
                                        Qe.blendFuncSeparate(Qe.ONE, Qe.ONE_MINUS_SRC_ALPHA, Qe.ONE, Qe.ONE_MINUS_SRC_ALPHA);
                                        break;
                                    case Co.EZo:
                                        Qe.blendFunc(Qe.ONE, Qe.ONE);
                                        break;
                                    case Co.Kwu:
                                        Qe.blendFuncSeparate(Qe.ZERO, Qe.ONE_MINUS_SRC_COLOR, Qe.ZERO, Qe.ONE);
                                        break;
                                    case Co.EdD:
                                        Qe.blendFuncSeparate(Qe.ZERO, Qe.SRC_COLOR, Qe.ZERO, Qe.SRC_ALPHA);
                                        break;
                                    default:
                                        console.error("THREE.WebGLState: Invalid blending: ", rt);
                                }
                                else switch(rt){
                                    case Co.NTi:
                                        Qe.blendFuncSeparate(Qe.SRC_ALPHA, Qe.ONE_MINUS_SRC_ALPHA, Qe.ONE, Qe.ONE_MINUS_SRC_ALPHA);
                                        break;
                                    case Co.EZo:
                                        Qe.blendFunc(Qe.SRC_ALPHA, Qe.ONE);
                                        break;
                                    case Co.Kwu:
                                        Qe.blendFuncSeparate(Qe.ZERO, Qe.ONE_MINUS_SRC_COLOR, Qe.ZERO, Qe.ONE);
                                        break;
                                    case Co.EdD:
                                        Qe.blendFunc(Qe.ZERO, Qe.SRC_COLOR);
                                        break;
                                    default:
                                        console.error("THREE.WebGLState: Invalid blending: ", rt);
                                }
                                tu = null, lu = null, fu = null, yu = null, Eu.set(0, 0, 0), Tu = 0, $l = rt, Lu = ql;
                            }
                        } else !0 === Kl && (disable(Qe.BLEND), Kl = !1);
                    }
                    function setFlipSided(rt) {
                        Zu !== rt && (rt ? Qe.frontFace(Qe.CW) : Qe.frontFace(Qe.CCW), Zu = rt);
                    }
                    function setCullFace(rt) {
                        rt !== Co.WNZ ? (enable(Qe.CULL_FACE), rt !== Xu && (rt === Co.Vb5 ? Qe.cullFace(Qe.BACK) : rt === Co.Jnc ? Qe.cullFace(Qe.FRONT) : Qe.cullFace(Qe.FRONT_AND_BACK))) : disable(Qe.CULL_FACE), Xu = rt;
                    }
                    function setPolygonOffset(rt, Wn, Co) {
                        rt ? (enable(Qe.POLYGON_OFFSET_FILL), $u === Wn && ed === Co || (Qe.polygonOffset(Wn, Co), $u = Wn, ed = Co)) : disable(Qe.POLYGON_OFFSET_FILL);
                    }
                    return {
                        buffers: {
                            color: Wn,
                            depth: Dl,
                            stencil: Ll
                        },
                        enable: enable,
                        disable: disable,
                        bindFramebuffer: function(rt, Wn) {
                            return Zl[rt] !== Wn && (Qe.bindFramebuffer(rt, Wn), Zl[rt] = Wn, rt === Qe.DRAW_FRAMEBUFFER && (Zl[Qe.FRAMEBUFFER] = Wn), rt === Qe.FRAMEBUFFER && (Zl[Qe.DRAW_FRAMEBUFFER] = Wn), !0);
                        },
                        drawBuffers: function(rt, Wn) {
                            let Co = ql, Dl = !1;
                            if (rt) {
                                Co = Hl.get(Wn), void 0 === Co && (Co = [], Hl.set(Wn, Co));
                                const Ll = rt.textures;
                                if (Co.length !== Ll.length || Co[0] !== Qe.COLOR_ATTACHMENT0) {
                                    for(let rt = 0, Wn = Ll.length; rt < Wn; rt++)Co[rt] = Qe.COLOR_ATTACHMENT0 + rt;
                                    Co.length = Ll.length, Dl = !0;
                                }
                            } else Co[0] !== Qe.BACK && (Co[0] = Qe.BACK, Dl = !0);
                            Dl && Qe.drawBuffers(Co);
                        },
                        useProgram: function(rt) {
                            return Ql !== rt && (Qe.useProgram(rt), Ql = rt, !0);
                        },
                        setBlending: setBlending,
                        setMaterial: function(rt, Rl) {
                            rt.side === Co.$EB ? disable(Qe.CULL_FACE) : enable(Qe.CULL_FACE);
                            let Ul = rt.side === Co.hsX;
                            Rl && (Ul = !Ul), setFlipSided(Ul), rt.blending === Co.NTi && !1 === rt.transparent ? setBlending(Co.XIg) : setBlending(rt.blending, rt.blendEquation, rt.blendSrc, rt.blendDst, rt.blendEquationAlpha, rt.blendSrcAlpha, rt.blendDstAlpha, rt.blendColor, rt.blendAlpha, rt.premultipliedAlpha), Dl.setFunc(rt.depthFunc), Dl.setTest(rt.depthTest), Dl.setMask(rt.depthWrite), Wn.setMask(rt.colorWrite);
                            const Gl = rt.stencilWrite;
                            Ll.setTest(Gl), Gl && (Ll.setMask(rt.stencilWriteMask), Ll.setFunc(rt.stencilFunc, rt.stencilRef, rt.stencilFuncMask), Ll.setOp(rt.stencilFail, rt.stencilZFail, rt.stencilZPass)), setPolygonOffset(rt.polygonOffset, rt.polygonOffsetFactor, rt.polygonOffsetUnits), !0 === rt.alphaToCoverage ? enable(Qe.SAMPLE_ALPHA_TO_COVERAGE) : disable(Qe.SAMPLE_ALPHA_TO_COVERAGE);
                        },
                        setFlipSided: setFlipSided,
                        setCullFace: setCullFace,
                        setLineWidth: function(rt) {
                            rt !== Ju && (id && Qe.lineWidth(rt), Ju = rt);
                        },
                        setPolygonOffset: setPolygonOffset,
                        setScissorTest: function(rt) {
                            rt ? enable(Qe.SCISSOR_TEST) : disable(Qe.SCISSOR_TEST);
                        },
                        activeTexture: function(rt) {
                            void 0 === rt && (rt = Qe.TEXTURE0 + td - 1), sd !== rt && (Qe.activeTexture(rt), sd = rt);
                        },
                        bindTexture: function(rt, Wn, Co) {
                            void 0 === Co && (Co = null === sd ? Qe.TEXTURE0 + td - 1 : sd);
                            let Dl = ad[Co];
                            void 0 === Dl && (Dl = {
                                type: void 0,
                                texture: void 0
                            }, ad[Co] = Dl), Dl.type === rt && Dl.texture === Wn || (sd !== Co && (Qe.activeTexture(Co), sd = Co), Qe.bindTexture(rt, Wn || hd[rt]), Dl.type = rt, Dl.texture = Wn);
                        },
                        unbindTexture: function() {
                            const rt = ad[sd];
                            void 0 !== rt && void 0 !== rt.type && (Qe.bindTexture(rt.type, null), rt.type = void 0, rt.texture = void 0);
                        },
                        compressedTexImage2D: function() {
                            try {
                                Qe.compressedTexImage2D.apply(Qe, arguments);
                            } catch (rt) {
                                console.error("THREE.WebGLState:", rt);
                            }
                        },
                        compressedTexImage3D: function() {
                            try {
                                Qe.compressedTexImage3D.apply(Qe, arguments);
                            } catch (rt) {
                                console.error("THREE.WebGLState:", rt);
                            }
                        },
                        texImage2D: function() {
                            try {
                                Qe.texImage2D.apply(Qe, arguments);
                            } catch (rt) {
                                console.error("THREE.WebGLState:", rt);
                            }
                        },
                        texImage3D: function() {
                            try {
                                Qe.texImage3D.apply(Qe, arguments);
                            } catch (rt) {
                                console.error("THREE.WebGLState:", rt);
                            }
                        },
                        updateUBOMapping: function(rt, Wn) {
                            let Co = Ul.get(Wn);
                            void 0 === Co && (Co = new WeakMap, Ul.set(Wn, Co));
                            let Dl = Co.get(rt);
                            void 0 === Dl && (Dl = Qe.getUniformBlockIndex(Wn, rt.name), Co.set(rt, Dl));
                        },
                        uniformBlockBinding: function(rt, Wn) {
                            const Co = Ul.get(Wn).get(rt);
                            Rl.get(Wn) !== Co && (Qe.uniformBlockBinding(Wn, Co, rt.__bindingPointIndex), Rl.set(Wn, Co));
                        },
                        texStorage2D: function() {
                            try {
                                Qe.texStorage2D.apply(Qe, arguments);
                            } catch (rt) {
                                console.error("THREE.WebGLState:", rt);
                            }
                        },
                        texStorage3D: function() {
                            try {
                                Qe.texStorage3D.apply(Qe, arguments);
                            } catch (rt) {
                                console.error("THREE.WebGLState:", rt);
                            }
                        },
                        texSubImage2D: function() {
                            try {
                                Qe.texSubImage2D.apply(Qe, arguments);
                            } catch (rt) {
                                console.error("THREE.WebGLState:", rt);
                            }
                        },
                        texSubImage3D: function() {
                            try {
                                Qe.texSubImage3D.apply(Qe, arguments);
                            } catch (rt) {
                                console.error("THREE.WebGLState:", rt);
                            }
                        },
                        compressedTexSubImage2D: function() {
                            try {
                                Qe.compressedTexSubImage2D.apply(Qe, arguments);
                            } catch (rt) {
                                console.error("THREE.WebGLState:", rt);
                            }
                        },
                        compressedTexSubImage3D: function() {
                            try {
                                Qe.compressedTexSubImage3D.apply(Qe, arguments);
                            } catch (rt) {
                                console.error("THREE.WebGLState:", rt);
                            }
                        },
                        scissor: function(rt) {
                            !1 === cd.equals(rt) && (Qe.scissor(rt.x, rt.y, rt.z, rt.w), cd.copy(rt));
                        },
                        viewport: function(rt) {
                            !1 === ud.equals(rt) && (Qe.viewport(rt.x, rt.y, rt.z, rt.w), ud.copy(rt));
                        },
                        reset: function() {
                            Qe.disable(Qe.BLEND), Qe.disable(Qe.CULL_FACE), Qe.disable(Qe.DEPTH_TEST), Qe.disable(Qe.POLYGON_OFFSET_FILL), Qe.disable(Qe.SCISSOR_TEST), Qe.disable(Qe.STENCIL_TEST), Qe.disable(Qe.SAMPLE_ALPHA_TO_COVERAGE), Qe.blendEquation(Qe.FUNC_ADD), Qe.blendFunc(Qe.ONE, Qe.ZERO), Qe.blendFuncSeparate(Qe.ONE, Qe.ZERO, Qe.ONE, Qe.ZERO), Qe.blendColor(0, 0, 0, 0), Qe.colorMask(!0, !0, !0, !0), Qe.clearColor(0, 0, 0, 0), Qe.depthMask(!0), Qe.depthFunc(Qe.LESS), Dl.setReversed(!1), Qe.clearDepth(1), Qe.stencilMask(4294967295), Qe.stencilFunc(Qe.ALWAYS, 0, 4294967295), Qe.stencilOp(Qe.KEEP, Qe.KEEP, Qe.KEEP), Qe.clearStencil(0), Qe.cullFace(Qe.BACK), Qe.frontFace(Qe.CCW), Qe.polygonOffset(0, 0), Qe.activeTexture(Qe.TEXTURE0), Qe.bindFramebuffer(Qe.FRAMEBUFFER, null), Qe.bindFramebuffer(Qe.DRAW_FRAMEBUFFER, null), Qe.bindFramebuffer(Qe.READ_FRAMEBUFFER, null), Qe.useProgram(null), Qe.lineWidth(1), Qe.scissor(0, 0, Qe.canvas.width, Qe.canvas.height), Qe.viewport(0, 0, Qe.canvas.width, Qe.canvas.height), Gl = {}, sd = null, ad = {}, Zl = {}, Hl = new WeakMap, ql = [], Ql = null, Kl = !1, $l = null, Tc = null, tu = null, lu = null, du = null, fu = null, yu = null, Eu = new Co.Q1f(0, 0, 0), Tu = 0, Lu = !1, Zu = null, Xu = null, Ju = null, $u = null, ed = null, cd.set(0, 0, Qe.canvas.width, Qe.canvas.height), ud.set(0, 0, Qe.canvas.width, Qe.canvas.height), Wn.reset(), Dl.reset(), Ll.reset();
                        }
                    };
                }
                function WebGLTextures(Qe, rt, Wn, Dl, Ll, Rl, Ul) {
                    const Gl = rt.has("WEBGL_multisampled_render_to_texture") ? rt.get("WEBGL_multisampled_render_to_texture") : null, Zl = "undefined" !== typeof navigator && /OculusBrowser/g.test(navigator.userAgent), Hl = new Co.I9Y, ql = new WeakMap;
                    let Ql;
                    const Kl = new WeakMap;
                    let $l = !1;
                    try {
                        $l = "undefined" !== typeof OffscreenCanvas && null !== new OffscreenCanvas(1, 1).getContext("2d");
                    } catch (Eu) {}
                    function createCanvas(Qe, rt) {
                        return $l ? new OffscreenCanvas(Qe, rt) : (0, Co.qq$)("canvas");
                    }
                    function resizeImage(Qe, rt, Wn) {
                        let Co = 1;
                        const Dl = getDimensions(Qe);
                        if ((Dl.width > Wn || Dl.height > Wn) && (Co = Wn / Math.max(Dl.width, Dl.height)), Co < 1) {
                            if ("undefined" !== typeof HTMLImageElement && Qe instanceof HTMLImageElement || "undefined" !== typeof HTMLCanvasElement && Qe instanceof HTMLCanvasElement || "undefined" !== typeof ImageBitmap && Qe instanceof ImageBitmap || "undefined" !== typeof VideoFrame && Qe instanceof VideoFrame) {
                                const Wn = Math.floor(Co * Dl.width), Ll = Math.floor(Co * Dl.height);
                                void 0 === Ql && (Ql = createCanvas(Wn, Ll));
                                const Rl = rt ? createCanvas(Wn, Ll) : Ql;
                                Rl.width = Wn, Rl.height = Ll;
                                return Rl.getContext("2d").drawImage(Qe, 0, 0, Wn, Ll), console.warn("THREE.WebGLRenderer: Texture has been resized from (" + Dl.width + "x" + Dl.height + ") to (" + Wn + "x" + Ll + ")."), Rl;
                            }
                            return "data" in Qe && console.warn("THREE.WebGLRenderer: Image in DataTexture is too big (" + Dl.width + "x" + Dl.height + ")."), Qe;
                        }
                        return Qe;
                    }
                    function textureNeedsGenerateMipmaps(Qe) {
                        return Qe.generateMipmaps;
                    }
                    function generateMipmap(rt) {
                        Qe.generateMipmap(rt);
                    }
                    function getTargetType(rt) {
                        return rt.isWebGLCubeRenderTarget ? Qe.TEXTURE_CUBE_MAP : rt.isWebGL3DRenderTarget ? Qe.TEXTURE_3D : rt.isWebGLArrayRenderTarget || rt.isCompressedArrayTexture ? Qe.TEXTURE_2D_ARRAY : Qe.TEXTURE_2D;
                    }
                    function getInternalFormat(Wn, Dl, Ll, Rl, Ul) {
                        if (void 0 === Ul && (Ul = !1), null !== Wn) {
                            if (void 0 !== Qe[Wn]) return Qe[Wn];
                            console.warn("THREE.WebGLRenderer: Attempt to use non-existing WebGL internal format '" + Wn + "'");
                        }
                        let Gl = Dl;
                        if (Dl === Qe.RED && (Ll === Qe.FLOAT && (Gl = Qe.R32F), Ll === Qe.HALF_FLOAT && (Gl = Qe.R16F), Ll === Qe.UNSIGNED_BYTE && (Gl = Qe.R8)), Dl === Qe.RED_INTEGER && (Ll === Qe.UNSIGNED_BYTE && (Gl = Qe.R8UI), Ll === Qe.UNSIGNED_SHORT && (Gl = Qe.R16UI), Ll === Qe.UNSIGNED_INT && (Gl = Qe.R32UI), Ll === Qe.BYTE && (Gl = Qe.R8I), Ll === Qe.SHORT && (Gl = Qe.R16I), Ll === Qe.INT && (Gl = Qe.R32I)), Dl === Qe.RG && (Ll === Qe.FLOAT && (Gl = Qe.RG32F), Ll === Qe.HALF_FLOAT && (Gl = Qe.RG16F), Ll === Qe.UNSIGNED_BYTE && (Gl = Qe.RG8)), Dl === Qe.RG_INTEGER && (Ll === Qe.UNSIGNED_BYTE && (Gl = Qe.RG8UI), Ll === Qe.UNSIGNED_SHORT && (Gl = Qe.RG16UI), Ll === Qe.UNSIGNED_INT && (Gl = Qe.RG32UI), Ll === Qe.BYTE && (Gl = Qe.RG8I), Ll === Qe.SHORT && (Gl = Qe.RG16I), Ll === Qe.INT && (Gl = Qe.RG32I)), Dl === Qe.RGB_INTEGER && (Ll === Qe.UNSIGNED_BYTE && (Gl = Qe.RGB8UI), Ll === Qe.UNSIGNED_SHORT && (Gl = Qe.RGB16UI), Ll === Qe.UNSIGNED_INT && (Gl = Qe.RGB32UI), Ll === Qe.BYTE && (Gl = Qe.RGB8I), Ll === Qe.SHORT && (Gl = Qe.RGB16I), Ll === Qe.INT && (Gl = Qe.RGB32I)), Dl === Qe.RGBA_INTEGER && (Ll === Qe.UNSIGNED_BYTE && (Gl = Qe.RGBA8UI), Ll === Qe.UNSIGNED_SHORT && (Gl = Qe.RGBA16UI), Ll === Qe.UNSIGNED_INT && (Gl = Qe.RGBA32UI), Ll === Qe.BYTE && (Gl = Qe.RGBA8I), Ll === Qe.SHORT && (Gl = Qe.RGBA16I), Ll === Qe.INT && (Gl = Qe.RGBA32I)), Dl === Qe.RGB && Ll === Qe.UNSIGNED_INT_5_9_9_9_REV && (Gl = Qe.RGB9_E5), Dl === Qe.RGBA) {
                            const rt = Ul ? Co.VxR : Co.ppV.getTransfer(Rl);
                            Ll === Qe.FLOAT && (Gl = Qe.RGBA32F), Ll === Qe.HALF_FLOAT && (Gl = Qe.RGBA16F), Ll === Qe.UNSIGNED_BYTE && (Gl = rt === Co.KLL ? Qe.SRGB8_ALPHA8 : Qe.RGBA8), Ll === Qe.UNSIGNED_SHORT_4_4_4_4 && (Gl = Qe.RGBA4), Ll === Qe.UNSIGNED_SHORT_5_5_5_1 && (Gl = Qe.RGB5_A1);
                        }
                        return Gl !== Qe.R16F && Gl !== Qe.R32F && Gl !== Qe.RG16F && Gl !== Qe.RG32F && Gl !== Qe.RGBA16F && Gl !== Qe.RGBA32F || rt.get("EXT_color_buffer_float"), Gl;
                    }
                    function getInternalDepthFormat(rt, Wn) {
                        let Dl;
                        return rt ? null === Wn || Wn === Co.bkx || Wn === Co.V3x ? Dl = Qe.DEPTH24_STENCIL8 : Wn === Co.RQf ? Dl = Qe.DEPTH32F_STENCIL8 : Wn === Co.cHt && (Dl = Qe.DEPTH24_STENCIL8, console.warn("DepthTexture: 16 bit depth attachment is not supported with stencil. Using 24-bit attachment.")) : null === Wn || Wn === Co.bkx || Wn === Co.V3x ? Dl = Qe.DEPTH_COMPONENT24 : Wn === Co.RQf ? Dl = Qe.DEPTH_COMPONENT32F : Wn === Co.cHt && (Dl = Qe.DEPTH_COMPONENT16), Dl;
                    }
                    function getMipLevels(Qe, rt) {
                        return !0 === textureNeedsGenerateMipmaps(Qe) || Qe.isFramebufferTexture && Qe.minFilter !== Co.hxR && Qe.minFilter !== Co.k6q ? Math.log2(Math.max(rt.width, rt.height)) + 1 : void 0 !== Qe.mipmaps && Qe.mipmaps.length > 0 ? Qe.mipmaps.length : Qe.isCompressedTexture && Array.isArray(Qe.image) ? rt.mipmaps.length : 1;
                    }
                    function onTextureDispose(Qe) {
                        const rt = Qe.target;
                        rt.removeEventListener("dispose", onTextureDispose), function(Qe) {
                            const rt = Dl.get(Qe);
                            if (void 0 === rt.__webglInit) return;
                            const Wn = Qe.source, Co = Kl.get(Wn);
                            if (Co) {
                                const Dl = Co[rt.__cacheKey];
                                Dl.usedTimes--, 0 === Dl.usedTimes && deleteTexture(Qe), 0 === Object.keys(Co).length && Kl.delete(Wn);
                            }
                            Dl.remove(Qe);
                        }(rt), rt.isVideoTexture && ql.delete(rt);
                    }
                    function onRenderTargetDispose(rt) {
                        const Wn = rt.target;
                        Wn.removeEventListener("dispose", onRenderTargetDispose), function(rt) {
                            const Wn = Dl.get(rt);
                            rt.depthTexture && (rt.depthTexture.dispose(), Dl.remove(rt.depthTexture));
                            if (rt.isWebGLCubeRenderTarget) for(let Dl = 0; Dl < 6; Dl++){
                                if (Array.isArray(Wn.__webglFramebuffer[Dl])) for(let rt = 0; rt < Wn.__webglFramebuffer[Dl].length; rt++)Qe.deleteFramebuffer(Wn.__webglFramebuffer[Dl][rt]);
                                else Qe.deleteFramebuffer(Wn.__webglFramebuffer[Dl]);
                                Wn.__webglDepthbuffer && Qe.deleteRenderbuffer(Wn.__webglDepthbuffer[Dl]);
                            }
                            else {
                                if (Array.isArray(Wn.__webglFramebuffer)) for(let rt = 0; rt < Wn.__webglFramebuffer.length; rt++)Qe.deleteFramebuffer(Wn.__webglFramebuffer[rt]);
                                else Qe.deleteFramebuffer(Wn.__webglFramebuffer);
                                if (Wn.__webglDepthbuffer && Qe.deleteRenderbuffer(Wn.__webglDepthbuffer), Wn.__webglMultisampledFramebuffer && Qe.deleteFramebuffer(Wn.__webglMultisampledFramebuffer), Wn.__webglColorRenderbuffer) for(let rt = 0; rt < Wn.__webglColorRenderbuffer.length; rt++)Wn.__webglColorRenderbuffer[rt] && Qe.deleteRenderbuffer(Wn.__webglColorRenderbuffer[rt]);
                                Wn.__webglDepthRenderbuffer && Qe.deleteRenderbuffer(Wn.__webglDepthRenderbuffer);
                            }
                            const Co = rt.textures;
                            for(let Ll = 0, Rl = Co.length; Ll < Rl; Ll++){
                                const rt = Dl.get(Co[Ll]);
                                rt.__webglTexture && (Qe.deleteTexture(rt.__webglTexture), Ul.memory.textures--), Dl.remove(Co[Ll]);
                            }
                            Dl.remove(rt);
                        }(Wn);
                    }
                    function deleteTexture(rt) {
                        const Wn = Dl.get(rt);
                        Qe.deleteTexture(Wn.__webglTexture);
                        const Co = rt.source;
                        delete Kl.get(Co)[Wn.__cacheKey], Ul.memory.textures--;
                    }
                    let Tc = 0;
                    function setTexture2D(rt, Co) {
                        const Ll = Dl.get(rt);
                        if (rt.isVideoTexture && function(Qe) {
                            const rt = Ul.render.frame;
                            ql.get(Qe) !== rt && (ql.set(Qe, rt), Qe.update());
                        }(rt), !1 === rt.isRenderTargetTexture && rt.version > 0 && Ll.__version !== rt.version) {
                            const Qe = rt.image;
                            if (null === Qe) console.warn("THREE.WebGLRenderer: Texture marked for update but no image data found.");
                            else {
                                if (!1 !== Qe.complete) return void uploadTexture(Ll, rt, Co);
                                console.warn("THREE.WebGLRenderer: Texture marked for update but image is incomplete");
                            }
                        }
                        Wn.bindTexture(Qe.TEXTURE_2D, Ll.__webglTexture, Qe.TEXTURE0 + Co);
                    }
                    const tu = {
                        [Co.GJx]: Qe.REPEAT,
                        [Co.ghU]: Qe.CLAMP_TO_EDGE,
                        [Co.kTW]: Qe.MIRRORED_REPEAT
                    }, lu = {
                        [Co.hxR]: Qe.NEAREST,
                        [Co.pHI]: Qe.NEAREST_MIPMAP_NEAREST,
                        [Co.Cfg]: Qe.NEAREST_MIPMAP_LINEAR,
                        [Co.k6q]: Qe.LINEAR,
                        [Co.kRr]: Qe.LINEAR_MIPMAP_NEAREST,
                        [Co.$_I]: Qe.LINEAR_MIPMAP_LINEAR
                    }, du = {
                        [Co.amv]: Qe.NEVER,
                        [Co.FFZ]: Qe.ALWAYS,
                        [Co.vim]: Qe.LESS,
                        [Co.TiK]: Qe.LEQUAL,
                        [Co.kO0]: Qe.EQUAL,
                        [Co.gWB]: Qe.GEQUAL,
                        [Co.eoi]: Qe.GREATER,
                        [Co.jzd]: Qe.NOTEQUAL
                    };
                    function setTextureParameters(Wn, Rl) {
                        if (Rl.type !== Co.RQf || !1 !== rt.has("OES_texture_float_linear") || Rl.magFilter !== Co.k6q && Rl.magFilter !== Co.kRr && Rl.magFilter !== Co.Cfg && Rl.magFilter !== Co.$_I && Rl.minFilter !== Co.k6q && Rl.minFilter !== Co.kRr && Rl.minFilter !== Co.Cfg && Rl.minFilter !== Co.$_I || console.warn("THREE.WebGLRenderer: Unable to use linear filtering with floating point textures. OES_texture_float_linear not supported on this device."), Qe.texParameteri(Wn, Qe.TEXTURE_WRAP_S, tu[Rl.wrapS]), Qe.texParameteri(Wn, Qe.TEXTURE_WRAP_T, tu[Rl.wrapT]), Wn !== Qe.TEXTURE_3D && Wn !== Qe.TEXTURE_2D_ARRAY || Qe.texParameteri(Wn, Qe.TEXTURE_WRAP_R, tu[Rl.wrapR]), Qe.texParameteri(Wn, Qe.TEXTURE_MAG_FILTER, lu[Rl.magFilter]), Qe.texParameteri(Wn, Qe.TEXTURE_MIN_FILTER, lu[Rl.minFilter]), Rl.compareFunction && (Qe.texParameteri(Wn, Qe.TEXTURE_COMPARE_MODE, Qe.COMPARE_REF_TO_TEXTURE), Qe.texParameteri(Wn, Qe.TEXTURE_COMPARE_FUNC, du[Rl.compareFunction])), !0 === rt.has("EXT_texture_filter_anisotropic")) {
                            if (Rl.magFilter === Co.hxR) return;
                            if (Rl.minFilter !== Co.Cfg && Rl.minFilter !== Co.$_I) return;
                            if (Rl.type === Co.RQf && !1 === rt.has("OES_texture_float_linear")) return;
                            if (Rl.anisotropy > 1 || Dl.get(Rl).__currentAnisotropy) {
                                const Co = rt.get("EXT_texture_filter_anisotropic");
                                Qe.texParameterf(Wn, Co.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(Rl.anisotropy, Ll.getMaxAnisotropy())), Dl.get(Rl).__currentAnisotropy = Rl.anisotropy;
                            }
                        }
                    }
                    function initTexture(rt, Wn) {
                        let Co = !1;
                        void 0 === rt.__webglInit && (rt.__webglInit = !0, Wn.addEventListener("dispose", onTextureDispose));
                        const Dl = Wn.source;
                        let Ll = Kl.get(Dl);
                        void 0 === Ll && (Ll = {}, Kl.set(Dl, Ll));
                        const Rl = function(Qe) {
                            const rt = [];
                            return rt.push(Qe.wrapS), rt.push(Qe.wrapT), rt.push(Qe.wrapR || 0), rt.push(Qe.magFilter), rt.push(Qe.minFilter), rt.push(Qe.anisotropy), rt.push(Qe.internalFormat), rt.push(Qe.format), rt.push(Qe.type), rt.push(Qe.generateMipmaps), rt.push(Qe.premultiplyAlpha), rt.push(Qe.flipY), rt.push(Qe.unpackAlignment), rt.push(Qe.colorSpace), rt.join();
                        }(Wn);
                        if (Rl !== rt.__cacheKey) {
                            void 0 === Ll[Rl] && (Ll[Rl] = {
                                texture: Qe.createTexture(),
                                usedTimes: 0
                            }, Ul.memory.textures++, Co = !0), Ll[Rl].usedTimes++;
                            const Dl = Ll[rt.__cacheKey];
                            void 0 !== Dl && (Ll[rt.__cacheKey].usedTimes--, 0 === Dl.usedTimes && deleteTexture(Wn)), rt.__cacheKey = Rl, rt.__webglTexture = Ll[Rl].texture;
                        }
                        return Co;
                    }
                    function uploadTexture(rt, Ul, Gl) {
                        let Zl = Qe.TEXTURE_2D;
                        (Ul.isDataArrayTexture || Ul.isCompressedArrayTexture) && (Zl = Qe.TEXTURE_2D_ARRAY), Ul.isData3DTexture && (Zl = Qe.TEXTURE_3D);
                        const Hl = initTexture(rt, Ul), ql = Ul.source;
                        Wn.bindTexture(Zl, rt.__webglTexture, Qe.TEXTURE0 + Gl);
                        const Ql = Dl.get(ql);
                        if (ql.version !== Ql.__version || !0 === Hl) {
                            Wn.activeTexture(Qe.TEXTURE0 + Gl);
                            const rt = Co.ppV.getPrimaries(Co.ppV.workingColorSpace), Dl = Ul.colorSpace === Co.jf0 ? null : Co.ppV.getPrimaries(Ul.colorSpace), Kl = Ul.colorSpace === Co.jf0 || rt === Dl ? Qe.NONE : Qe.BROWSER_DEFAULT_WEBGL;
                            Qe.pixelStorei(Qe.UNPACK_FLIP_Y_WEBGL, Ul.flipY), Qe.pixelStorei(Qe.UNPACK_PREMULTIPLY_ALPHA_WEBGL, Ul.premultiplyAlpha), Qe.pixelStorei(Qe.UNPACK_ALIGNMENT, Ul.unpackAlignment), Qe.pixelStorei(Qe.UNPACK_COLORSPACE_CONVERSION_WEBGL, Kl);
                            let $l = resizeImage(Ul.image, !1, Ll.maxTextureSize);
                            $l = verifyColorSpace(Ul, $l);
                            const Tc = Rl.convert(Ul.format, Ul.colorSpace), tu = Rl.convert(Ul.type);
                            let lu, du = getInternalFormat(Ul.internalFormat, Tc, tu, Ul.colorSpace, Ul.isVideoTexture);
                            setTextureParameters(Zl, Ul);
                            const fu = Ul.mipmaps, yu = !0 !== Ul.isVideoTexture, Eu = void 0 === Ql.__version || !0 === Hl, Tu = ql.dataReady, Lu = getMipLevels(Ul, $l);
                            if (Ul.isDepthTexture) du = getInternalDepthFormat(Ul.format === Co.dcC, Ul.type), Eu && (yu ? Wn.texStorage2D(Qe.TEXTURE_2D, 1, du, $l.width, $l.height) : Wn.texImage2D(Qe.TEXTURE_2D, 0, du, $l.width, $l.height, 0, Tc, tu, null));
                            else if (Ul.isDataTexture) {
                                if (fu.length > 0) {
                                    yu && Eu && Wn.texStorage2D(Qe.TEXTURE_2D, Lu, du, fu[0].width, fu[0].height);
                                    for(let rt = 0, Co = fu.length; rt < Co; rt++)lu = fu[rt], yu ? Tu && Wn.texSubImage2D(Qe.TEXTURE_2D, rt, 0, 0, lu.width, lu.height, Tc, tu, lu.data) : Wn.texImage2D(Qe.TEXTURE_2D, rt, du, lu.width, lu.height, 0, Tc, tu, lu.data);
                                    Ul.generateMipmaps = !1;
                                } else yu ? (Eu && Wn.texStorage2D(Qe.TEXTURE_2D, Lu, du, $l.width, $l.height), Tu && Wn.texSubImage2D(Qe.TEXTURE_2D, 0, 0, 0, $l.width, $l.height, Tc, tu, $l.data)) : Wn.texImage2D(Qe.TEXTURE_2D, 0, du, $l.width, $l.height, 0, Tc, tu, $l.data);
                            } else if (Ul.isCompressedTexture) {
                                if (Ul.isCompressedArrayTexture) {
                                    yu && Eu && Wn.texStorage3D(Qe.TEXTURE_2D_ARRAY, Lu, du, fu[0].width, fu[0].height, $l.depth);
                                    for(let rt = 0, Dl = fu.length; rt < Dl; rt++)if (lu = fu[rt], Ul.format !== Co.GWd) {
                                        if (null !== Tc) {
                                            if (yu) {
                                                if (Tu) {
                                                    if (Ul.layerUpdates.size > 0) {
                                                        const Dl = (0, Co.Nex)(lu.width, lu.height, Ul.format, Ul.type);
                                                        for (const Co of Ul.layerUpdates){
                                                            const Ll = lu.data.subarray(Co * Dl / lu.data.BYTES_PER_ELEMENT, (Co + 1) * Dl / lu.data.BYTES_PER_ELEMENT);
                                                            Wn.compressedTexSubImage3D(Qe.TEXTURE_2D_ARRAY, rt, 0, 0, Co, lu.width, lu.height, 1, Tc, Ll);
                                                        }
                                                        Ul.clearLayerUpdates();
                                                    } else Wn.compressedTexSubImage3D(Qe.TEXTURE_2D_ARRAY, rt, 0, 0, 0, lu.width, lu.height, $l.depth, Tc, lu.data);
                                                }
                                            } else Wn.compressedTexImage3D(Qe.TEXTURE_2D_ARRAY, rt, du, lu.width, lu.height, $l.depth, 0, lu.data, 0, 0);
                                        } else console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()");
                                    } else yu ? Tu && Wn.texSubImage3D(Qe.TEXTURE_2D_ARRAY, rt, 0, 0, 0, lu.width, lu.height, $l.depth, Tc, tu, lu.data) : Wn.texImage3D(Qe.TEXTURE_2D_ARRAY, rt, du, lu.width, lu.height, $l.depth, 0, Tc, tu, lu.data);
                                } else {
                                    yu && Eu && Wn.texStorage2D(Qe.TEXTURE_2D, Lu, du, fu[0].width, fu[0].height);
                                    for(let rt = 0, Dl = fu.length; rt < Dl; rt++)lu = fu[rt], Ul.format !== Co.GWd ? null !== Tc ? yu ? Tu && Wn.compressedTexSubImage2D(Qe.TEXTURE_2D, rt, 0, 0, lu.width, lu.height, Tc, lu.data) : Wn.compressedTexImage2D(Qe.TEXTURE_2D, rt, du, lu.width, lu.height, 0, lu.data) : console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()") : yu ? Tu && Wn.texSubImage2D(Qe.TEXTURE_2D, rt, 0, 0, lu.width, lu.height, Tc, tu, lu.data) : Wn.texImage2D(Qe.TEXTURE_2D, rt, du, lu.width, lu.height, 0, Tc, tu, lu.data);
                                }
                            } else if (Ul.isDataArrayTexture) {
                                if (yu) {
                                    if (Eu && Wn.texStorage3D(Qe.TEXTURE_2D_ARRAY, Lu, du, $l.width, $l.height, $l.depth), Tu) {
                                        if (Ul.layerUpdates.size > 0) {
                                            const rt = (0, Co.Nex)($l.width, $l.height, Ul.format, Ul.type);
                                            for (const Co of Ul.layerUpdates){
                                                const Dl = $l.data.subarray(Co * rt / $l.data.BYTES_PER_ELEMENT, (Co + 1) * rt / $l.data.BYTES_PER_ELEMENT);
                                                Wn.texSubImage3D(Qe.TEXTURE_2D_ARRAY, 0, 0, 0, Co, $l.width, $l.height, 1, Tc, tu, Dl);
                                            }
                                            Ul.clearLayerUpdates();
                                        } else Wn.texSubImage3D(Qe.TEXTURE_2D_ARRAY, 0, 0, 0, 0, $l.width, $l.height, $l.depth, Tc, tu, $l.data);
                                    }
                                } else Wn.texImage3D(Qe.TEXTURE_2D_ARRAY, 0, du, $l.width, $l.height, $l.depth, 0, Tc, tu, $l.data);
                            } else if (Ul.isData3DTexture) yu ? (Eu && Wn.texStorage3D(Qe.TEXTURE_3D, Lu, du, $l.width, $l.height, $l.depth), Tu && Wn.texSubImage3D(Qe.TEXTURE_3D, 0, 0, 0, 0, $l.width, $l.height, $l.depth, Tc, tu, $l.data)) : Wn.texImage3D(Qe.TEXTURE_3D, 0, du, $l.width, $l.height, $l.depth, 0, Tc, tu, $l.data);
                            else if (Ul.isFramebufferTexture) {
                                if (Eu) {
                                    if (yu) Wn.texStorage2D(Qe.TEXTURE_2D, Lu, du, $l.width, $l.height);
                                    else {
                                        let rt = $l.width, Co = $l.height;
                                        for(let Dl = 0; Dl < Lu; Dl++)Wn.texImage2D(Qe.TEXTURE_2D, Dl, du, rt, Co, 0, Tc, tu, null), rt >>= 1, Co >>= 1;
                                    }
                                }
                            } else if (fu.length > 0) {
                                if (yu && Eu) {
                                    const rt = getDimensions(fu[0]);
                                    Wn.texStorage2D(Qe.TEXTURE_2D, Lu, du, rt.width, rt.height);
                                }
                                for(let rt = 0, Co = fu.length; rt < Co; rt++)lu = fu[rt], yu ? Tu && Wn.texSubImage2D(Qe.TEXTURE_2D, rt, 0, 0, Tc, tu, lu) : Wn.texImage2D(Qe.TEXTURE_2D, rt, du, Tc, tu, lu);
                                Ul.generateMipmaps = !1;
                            } else if (yu) {
                                if (Eu) {
                                    const rt = getDimensions($l);
                                    Wn.texStorage2D(Qe.TEXTURE_2D, Lu, du, rt.width, rt.height);
                                }
                                Tu && Wn.texSubImage2D(Qe.TEXTURE_2D, 0, 0, 0, Tc, tu, $l);
                            } else Wn.texImage2D(Qe.TEXTURE_2D, 0, du, Tc, tu, $l);
                            textureNeedsGenerateMipmaps(Ul) && generateMipmap(Zl), Ql.__version = ql.version, Ul.onUpdate && Ul.onUpdate(Ul);
                        }
                        rt.__version = Ul.version;
                    }
                    function setupFrameBufferTexture(rt, Co, Ll, Ul, Zl, Hl) {
                        const ql = Rl.convert(Ll.format, Ll.colorSpace), Ql = Rl.convert(Ll.type), Kl = getInternalFormat(Ll.internalFormat, ql, Ql, Ll.colorSpace), $l = Dl.get(Co), Tc = Dl.get(Ll);
                        if (Tc.__renderTarget = Co, !$l.__hasExternalTextures) {
                            const rt = Math.max(1, Co.width >> Hl), Dl = Math.max(1, Co.height >> Hl);
                            Zl === Qe.TEXTURE_3D || Zl === Qe.TEXTURE_2D_ARRAY ? Wn.texImage3D(Zl, Hl, Kl, rt, Dl, Co.depth, 0, ql, Ql, null) : Wn.texImage2D(Zl, Hl, Kl, rt, Dl, 0, ql, Ql, null);
                        }
                        Wn.bindFramebuffer(Qe.FRAMEBUFFER, rt), useMultisampledRTT(Co) ? Gl.framebufferTexture2DMultisampleEXT(Qe.FRAMEBUFFER, Ul, Zl, Tc.__webglTexture, 0, getRenderTargetSamples(Co)) : (Zl === Qe.TEXTURE_2D || Zl >= Qe.TEXTURE_CUBE_MAP_POSITIVE_X && Zl <= Qe.TEXTURE_CUBE_MAP_NEGATIVE_Z) && Qe.framebufferTexture2D(Qe.FRAMEBUFFER, Ul, Zl, Tc.__webglTexture, Hl), Wn.bindFramebuffer(Qe.FRAMEBUFFER, null);
                    }
                    function setupRenderBufferStorage(rt, Wn, Co) {
                        if (Qe.bindRenderbuffer(Qe.RENDERBUFFER, rt), Wn.depthBuffer) {
                            const Dl = Wn.depthTexture, Ll = Dl && Dl.isDepthTexture ? Dl.type : null, Rl = getInternalDepthFormat(Wn.stencilBuffer, Ll), Ul = Wn.stencilBuffer ? Qe.DEPTH_STENCIL_ATTACHMENT : Qe.DEPTH_ATTACHMENT, Zl = getRenderTargetSamples(Wn);
                            useMultisampledRTT(Wn) ? Gl.renderbufferStorageMultisampleEXT(Qe.RENDERBUFFER, Zl, Rl, Wn.width, Wn.height) : Co ? Qe.renderbufferStorageMultisample(Qe.RENDERBUFFER, Zl, Rl, Wn.width, Wn.height) : Qe.renderbufferStorage(Qe.RENDERBUFFER, Rl, Wn.width, Wn.height), Qe.framebufferRenderbuffer(Qe.FRAMEBUFFER, Ul, Qe.RENDERBUFFER, rt);
                        } else {
                            const rt = Wn.textures;
                            for(let Dl = 0; Dl < rt.length; Dl++){
                                const Ll = rt[Dl], Ul = Rl.convert(Ll.format, Ll.colorSpace), Zl = Rl.convert(Ll.type), Hl = getInternalFormat(Ll.internalFormat, Ul, Zl, Ll.colorSpace), ql = getRenderTargetSamples(Wn);
                                Co && !1 === useMultisampledRTT(Wn) ? Qe.renderbufferStorageMultisample(Qe.RENDERBUFFER, ql, Hl, Wn.width, Wn.height) : useMultisampledRTT(Wn) ? Gl.renderbufferStorageMultisampleEXT(Qe.RENDERBUFFER, ql, Hl, Wn.width, Wn.height) : Qe.renderbufferStorage(Qe.RENDERBUFFER, Hl, Wn.width, Wn.height);
                            }
                        }
                        Qe.bindRenderbuffer(Qe.RENDERBUFFER, null);
                    }
                    function setupDepthRenderbuffer(rt) {
                        const Ll = Dl.get(rt), Rl = !0 === rt.isWebGLCubeRenderTarget;
                        if (Ll.__boundDepthTexture !== rt.depthTexture) {
                            const Qe = rt.depthTexture;
                            if (Ll.__depthDisposeCallback && Ll.__depthDisposeCallback(), Qe) {
                                const disposeEvent = ()=>{
                                    delete Ll.__boundDepthTexture, delete Ll.__depthDisposeCallback, Qe.removeEventListener("dispose", disposeEvent);
                                };
                                Qe.addEventListener("dispose", disposeEvent), Ll.__depthDisposeCallback = disposeEvent;
                            }
                            Ll.__boundDepthTexture = Qe;
                        }
                        if (rt.depthTexture && !Ll.__autoAllocateDepthBuffer) {
                            if (Rl) throw new Error("target.depthTexture not supported in Cube render targets");
                            !function(rt, Ll) {
                                if (Ll && Ll.isWebGLCubeRenderTarget) throw new Error("Depth Texture with cube render targets is not supported");
                                if (Wn.bindFramebuffer(Qe.FRAMEBUFFER, rt), !Ll.depthTexture || !Ll.depthTexture.isDepthTexture) throw new Error("renderTarget.depthTexture must be an instance of THREE.DepthTexture");
                                const Rl = Dl.get(Ll.depthTexture);
                                Rl.__renderTarget = Ll, Rl.__webglTexture && Ll.depthTexture.image.width === Ll.width && Ll.depthTexture.image.height === Ll.height || (Ll.depthTexture.image.width = Ll.width, Ll.depthTexture.image.height = Ll.height, Ll.depthTexture.needsUpdate = !0), setTexture2D(Ll.depthTexture, 0);
                                const Ul = Rl.__webglTexture, Zl = getRenderTargetSamples(Ll);
                                if (Ll.depthTexture.format === Co.zdS) useMultisampledRTT(Ll) ? Gl.framebufferTexture2DMultisampleEXT(Qe.FRAMEBUFFER, Qe.DEPTH_ATTACHMENT, Qe.TEXTURE_2D, Ul, 0, Zl) : Qe.framebufferTexture2D(Qe.FRAMEBUFFER, Qe.DEPTH_ATTACHMENT, Qe.TEXTURE_2D, Ul, 0);
                                else {
                                    if (Ll.depthTexture.format !== Co.dcC) throw new Error("Unknown depthTexture format");
                                    useMultisampledRTT(Ll) ? Gl.framebufferTexture2DMultisampleEXT(Qe.FRAMEBUFFER, Qe.DEPTH_STENCIL_ATTACHMENT, Qe.TEXTURE_2D, Ul, 0, Zl) : Qe.framebufferTexture2D(Qe.FRAMEBUFFER, Qe.DEPTH_STENCIL_ATTACHMENT, Qe.TEXTURE_2D, Ul, 0);
                                }
                            }(Ll.__webglFramebuffer, rt);
                        } else if (Rl) {
                            Ll.__webglDepthbuffer = [];
                            for(let Co = 0; Co < 6; Co++)if (Wn.bindFramebuffer(Qe.FRAMEBUFFER, Ll.__webglFramebuffer[Co]), void 0 === Ll.__webglDepthbuffer[Co]) Ll.__webglDepthbuffer[Co] = Qe.createRenderbuffer(), setupRenderBufferStorage(Ll.__webglDepthbuffer[Co], rt, !1);
                            else {
                                const Wn = rt.stencilBuffer ? Qe.DEPTH_STENCIL_ATTACHMENT : Qe.DEPTH_ATTACHMENT, Dl = Ll.__webglDepthbuffer[Co];
                                Qe.bindRenderbuffer(Qe.RENDERBUFFER, Dl), Qe.framebufferRenderbuffer(Qe.FRAMEBUFFER, Wn, Qe.RENDERBUFFER, Dl);
                            }
                        } else if (Wn.bindFramebuffer(Qe.FRAMEBUFFER, Ll.__webglFramebuffer), void 0 === Ll.__webglDepthbuffer) Ll.__webglDepthbuffer = Qe.createRenderbuffer(), setupRenderBufferStorage(Ll.__webglDepthbuffer, rt, !1);
                        else {
                            const Wn = rt.stencilBuffer ? Qe.DEPTH_STENCIL_ATTACHMENT : Qe.DEPTH_ATTACHMENT, Co = Ll.__webglDepthbuffer;
                            Qe.bindRenderbuffer(Qe.RENDERBUFFER, Co), Qe.framebufferRenderbuffer(Qe.FRAMEBUFFER, Wn, Qe.RENDERBUFFER, Co);
                        }
                        Wn.bindFramebuffer(Qe.FRAMEBUFFER, null);
                    }
                    const fu = [], yu = [];
                    function getRenderTargetSamples(Qe) {
                        return Math.min(Ll.maxSamples, Qe.samples);
                    }
                    function useMultisampledRTT(Qe) {
                        const Wn = Dl.get(Qe);
                        return Qe.samples > 0 && !0 === rt.has("WEBGL_multisampled_render_to_texture") && !1 !== Wn.__useRenderToTexture;
                    }
                    function verifyColorSpace(Qe, rt) {
                        const Wn = Qe.colorSpace, Dl = Qe.format, Ll = Qe.type;
                        return !0 === Qe.isCompressedTexture || !0 === Qe.isVideoTexture || Wn !== Co.Zr2 && Wn !== Co.jf0 && (Co.ppV.getTransfer(Wn) === Co.KLL ? Dl === Co.GWd && Ll === Co.OUM || console.warn("THREE.WebGLTextures: sRGB encoded textures have to use RGBAFormat and UnsignedByteType.") : console.error("THREE.WebGLTextures: Unsupported texture color space:", Wn)), rt;
                    }
                    function getDimensions(Qe) {
                        return "undefined" !== typeof HTMLImageElement && Qe instanceof HTMLImageElement ? (Hl.width = Qe.naturalWidth || Qe.width, Hl.height = Qe.naturalHeight || Qe.height) : "undefined" !== typeof VideoFrame && Qe instanceof VideoFrame ? (Hl.width = Qe.displayWidth, Hl.height = Qe.displayHeight) : (Hl.width = Qe.width, Hl.height = Qe.height), Hl;
                    }
                    this.allocateTextureUnit = function() {
                        const Qe = Tc;
                        return Qe >= Ll.maxTextures && console.warn("THREE.WebGLTextures: Trying to use " + Qe + " texture units while this GPU supports only " + Ll.maxTextures), Tc += 1, Qe;
                    }, this.resetTextureUnits = function() {
                        Tc = 0;
                    }, this.setTexture2D = setTexture2D, this.setTexture2DArray = function(rt, Co) {
                        const Ll = Dl.get(rt);
                        rt.version > 0 && Ll.__version !== rt.version ? uploadTexture(Ll, rt, Co) : Wn.bindTexture(Qe.TEXTURE_2D_ARRAY, Ll.__webglTexture, Qe.TEXTURE0 + Co);
                    }, this.setTexture3D = function(rt, Co) {
                        const Ll = Dl.get(rt);
                        rt.version > 0 && Ll.__version !== rt.version ? uploadTexture(Ll, rt, Co) : Wn.bindTexture(Qe.TEXTURE_3D, Ll.__webglTexture, Qe.TEXTURE0 + Co);
                    }, this.setTextureCube = function(rt, Ul) {
                        const Gl = Dl.get(rt);
                        rt.version > 0 && Gl.__version !== rt.version ? function(rt, Ul, Gl) {
                            if (6 !== Ul.image.length) return;
                            const Zl = initTexture(rt, Ul), Hl = Ul.source;
                            Wn.bindTexture(Qe.TEXTURE_CUBE_MAP, rt.__webglTexture, Qe.TEXTURE0 + Gl);
                            const ql = Dl.get(Hl);
                            if (Hl.version !== ql.__version || !0 === Zl) {
                                Wn.activeTexture(Qe.TEXTURE0 + Gl);
                                const rt = Co.ppV.getPrimaries(Co.ppV.workingColorSpace), Dl = Ul.colorSpace === Co.jf0 ? null : Co.ppV.getPrimaries(Ul.colorSpace), Ql = Ul.colorSpace === Co.jf0 || rt === Dl ? Qe.NONE : Qe.BROWSER_DEFAULT_WEBGL;
                                Qe.pixelStorei(Qe.UNPACK_FLIP_Y_WEBGL, Ul.flipY), Qe.pixelStorei(Qe.UNPACK_PREMULTIPLY_ALPHA_WEBGL, Ul.premultiplyAlpha), Qe.pixelStorei(Qe.UNPACK_ALIGNMENT, Ul.unpackAlignment), Qe.pixelStorei(Qe.UNPACK_COLORSPACE_CONVERSION_WEBGL, Ql);
                                const Kl = Ul.isCompressedTexture || Ul.image[0].isCompressedTexture, $l = Ul.image[0] && Ul.image[0].isDataTexture, Tc = [];
                                for(let Qe = 0; Qe < 6; Qe++)Tc[Qe] = Kl || $l ? $l ? Ul.image[Qe].image : Ul.image[Qe] : resizeImage(Ul.image[Qe], !0, Ll.maxCubemapSize), Tc[Qe] = verifyColorSpace(Ul, Tc[Qe]);
                                const tu = Tc[0], lu = Rl.convert(Ul.format, Ul.colorSpace), du = Rl.convert(Ul.type), fu = getInternalFormat(Ul.internalFormat, lu, du, Ul.colorSpace), yu = !0 !== Ul.isVideoTexture, Eu = void 0 === ql.__version || !0 === Zl, Tu = Hl.dataReady;
                                let Lu, Zu = getMipLevels(Ul, tu);
                                if (setTextureParameters(Qe.TEXTURE_CUBE_MAP, Ul), Kl) {
                                    yu && Eu && Wn.texStorage2D(Qe.TEXTURE_CUBE_MAP, Zu, fu, tu.width, tu.height);
                                    for(let rt = 0; rt < 6; rt++){
                                        Lu = Tc[rt].mipmaps;
                                        for(let Dl = 0; Dl < Lu.length; Dl++){
                                            const Ll = Lu[Dl];
                                            Ul.format !== Co.GWd ? null !== lu ? yu ? Tu && Wn.compressedTexSubImage2D(Qe.TEXTURE_CUBE_MAP_POSITIVE_X + rt, Dl, 0, 0, Ll.width, Ll.height, lu, Ll.data) : Wn.compressedTexImage2D(Qe.TEXTURE_CUBE_MAP_POSITIVE_X + rt, Dl, fu, Ll.width, Ll.height, 0, Ll.data) : console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()") : yu ? Tu && Wn.texSubImage2D(Qe.TEXTURE_CUBE_MAP_POSITIVE_X + rt, Dl, 0, 0, Ll.width, Ll.height, lu, du, Ll.data) : Wn.texImage2D(Qe.TEXTURE_CUBE_MAP_POSITIVE_X + rt, Dl, fu, Ll.width, Ll.height, 0, lu, du, Ll.data);
                                        }
                                    }
                                } else {
                                    if (Lu = Ul.mipmaps, yu && Eu) {
                                        Lu.length > 0 && Zu++;
                                        const rt = getDimensions(Tc[0]);
                                        Wn.texStorage2D(Qe.TEXTURE_CUBE_MAP, Zu, fu, rt.width, rt.height);
                                    }
                                    for(let rt = 0; rt < 6; rt++)if ($l) {
                                        yu ? Tu && Wn.texSubImage2D(Qe.TEXTURE_CUBE_MAP_POSITIVE_X + rt, 0, 0, 0, Tc[rt].width, Tc[rt].height, lu, du, Tc[rt].data) : Wn.texImage2D(Qe.TEXTURE_CUBE_MAP_POSITIVE_X + rt, 0, fu, Tc[rt].width, Tc[rt].height, 0, lu, du, Tc[rt].data);
                                        for(let Co = 0; Co < Lu.length; Co++){
                                            const Dl = Lu[Co].image[rt].image;
                                            yu ? Tu && Wn.texSubImage2D(Qe.TEXTURE_CUBE_MAP_POSITIVE_X + rt, Co + 1, 0, 0, Dl.width, Dl.height, lu, du, Dl.data) : Wn.texImage2D(Qe.TEXTURE_CUBE_MAP_POSITIVE_X + rt, Co + 1, fu, Dl.width, Dl.height, 0, lu, du, Dl.data);
                                        }
                                    } else {
                                        yu ? Tu && Wn.texSubImage2D(Qe.TEXTURE_CUBE_MAP_POSITIVE_X + rt, 0, 0, 0, lu, du, Tc[rt]) : Wn.texImage2D(Qe.TEXTURE_CUBE_MAP_POSITIVE_X + rt, 0, fu, lu, du, Tc[rt]);
                                        for(let Co = 0; Co < Lu.length; Co++){
                                            const Dl = Lu[Co];
                                            yu ? Tu && Wn.texSubImage2D(Qe.TEXTURE_CUBE_MAP_POSITIVE_X + rt, Co + 1, 0, 0, lu, du, Dl.image[rt]) : Wn.texImage2D(Qe.TEXTURE_CUBE_MAP_POSITIVE_X + rt, Co + 1, fu, lu, du, Dl.image[rt]);
                                        }
                                    }
                                }
                                textureNeedsGenerateMipmaps(Ul) && generateMipmap(Qe.TEXTURE_CUBE_MAP), ql.__version = Hl.version, Ul.onUpdate && Ul.onUpdate(Ul);
                            }
                            rt.__version = Ul.version;
                        }(Gl, rt, Ul) : Wn.bindTexture(Qe.TEXTURE_CUBE_MAP, Gl.__webglTexture, Qe.TEXTURE0 + Ul);
                    }, this.rebindTextures = function(rt, Wn, Co) {
                        const Ll = Dl.get(rt);
                        void 0 !== Wn && setupFrameBufferTexture(Ll.__webglFramebuffer, rt, rt.texture, Qe.COLOR_ATTACHMENT0, Qe.TEXTURE_2D, 0), void 0 !== Co && setupDepthRenderbuffer(rt);
                    }, this.setupRenderTarget = function(rt) {
                        const Co = rt.texture, Ll = Dl.get(rt), Gl = Dl.get(Co);
                        rt.addEventListener("dispose", onRenderTargetDispose);
                        const Zl = rt.textures, Hl = !0 === rt.isWebGLCubeRenderTarget, ql = Zl.length > 1;
                        if (ql || (void 0 === Gl.__webglTexture && (Gl.__webglTexture = Qe.createTexture()), Gl.__version = Co.version, Ul.memory.textures++), Hl) {
                            Ll.__webglFramebuffer = [];
                            for(let rt = 0; rt < 6; rt++)if (Co.mipmaps && Co.mipmaps.length > 0) {
                                Ll.__webglFramebuffer[rt] = [];
                                for(let Wn = 0; Wn < Co.mipmaps.length; Wn++)Ll.__webglFramebuffer[rt][Wn] = Qe.createFramebuffer();
                            } else Ll.__webglFramebuffer[rt] = Qe.createFramebuffer();
                        } else {
                            if (Co.mipmaps && Co.mipmaps.length > 0) {
                                Ll.__webglFramebuffer = [];
                                for(let rt = 0; rt < Co.mipmaps.length; rt++)Ll.__webglFramebuffer[rt] = Qe.createFramebuffer();
                            } else Ll.__webglFramebuffer = Qe.createFramebuffer();
                            if (ql) for(let rt = 0, Wn = Zl.length; rt < Wn; rt++){
                                const Wn = Dl.get(Zl[rt]);
                                void 0 === Wn.__webglTexture && (Wn.__webglTexture = Qe.createTexture(), Ul.memory.textures++);
                            }
                            if (rt.samples > 0 && !1 === useMultisampledRTT(rt)) {
                                Ll.__webglMultisampledFramebuffer = Qe.createFramebuffer(), Ll.__webglColorRenderbuffer = [], Wn.bindFramebuffer(Qe.FRAMEBUFFER, Ll.__webglMultisampledFramebuffer);
                                for(let Wn = 0; Wn < Zl.length; Wn++){
                                    const Co = Zl[Wn];
                                    Ll.__webglColorRenderbuffer[Wn] = Qe.createRenderbuffer(), Qe.bindRenderbuffer(Qe.RENDERBUFFER, Ll.__webglColorRenderbuffer[Wn]);
                                    const Dl = Rl.convert(Co.format, Co.colorSpace), Ul = Rl.convert(Co.type), Gl = getInternalFormat(Co.internalFormat, Dl, Ul, Co.colorSpace, !0 === rt.isXRRenderTarget), Hl = getRenderTargetSamples(rt);
                                    Qe.renderbufferStorageMultisample(Qe.RENDERBUFFER, Hl, Gl, rt.width, rt.height), Qe.framebufferRenderbuffer(Qe.FRAMEBUFFER, Qe.COLOR_ATTACHMENT0 + Wn, Qe.RENDERBUFFER, Ll.__webglColorRenderbuffer[Wn]);
                                }
                                Qe.bindRenderbuffer(Qe.RENDERBUFFER, null), rt.depthBuffer && (Ll.__webglDepthRenderbuffer = Qe.createRenderbuffer(), setupRenderBufferStorage(Ll.__webglDepthRenderbuffer, rt, !0)), Wn.bindFramebuffer(Qe.FRAMEBUFFER, null);
                            }
                        }
                        if (Hl) {
                            Wn.bindTexture(Qe.TEXTURE_CUBE_MAP, Gl.__webglTexture), setTextureParameters(Qe.TEXTURE_CUBE_MAP, Co);
                            for(let Wn = 0; Wn < 6; Wn++)if (Co.mipmaps && Co.mipmaps.length > 0) for(let Dl = 0; Dl < Co.mipmaps.length; Dl++)setupFrameBufferTexture(Ll.__webglFramebuffer[Wn][Dl], rt, Co, Qe.COLOR_ATTACHMENT0, Qe.TEXTURE_CUBE_MAP_POSITIVE_X + Wn, Dl);
                            else setupFrameBufferTexture(Ll.__webglFramebuffer[Wn], rt, Co, Qe.COLOR_ATTACHMENT0, Qe.TEXTURE_CUBE_MAP_POSITIVE_X + Wn, 0);
                            textureNeedsGenerateMipmaps(Co) && generateMipmap(Qe.TEXTURE_CUBE_MAP), Wn.unbindTexture();
                        } else if (ql) {
                            for(let Co = 0, Rl = Zl.length; Co < Rl; Co++){
                                const Rl = Zl[Co], Ul = Dl.get(Rl);
                                Wn.bindTexture(Qe.TEXTURE_2D, Ul.__webglTexture), setTextureParameters(Qe.TEXTURE_2D, Rl), setupFrameBufferTexture(Ll.__webglFramebuffer, rt, Rl, Qe.COLOR_ATTACHMENT0 + Co, Qe.TEXTURE_2D, 0), textureNeedsGenerateMipmaps(Rl) && generateMipmap(Qe.TEXTURE_2D);
                            }
                            Wn.unbindTexture();
                        } else {
                            let Dl = Qe.TEXTURE_2D;
                            if ((rt.isWebGL3DRenderTarget || rt.isWebGLArrayRenderTarget) && (Dl = rt.isWebGL3DRenderTarget ? Qe.TEXTURE_3D : Qe.TEXTURE_2D_ARRAY), Wn.bindTexture(Dl, Gl.__webglTexture), setTextureParameters(Dl, Co), Co.mipmaps && Co.mipmaps.length > 0) for(let Wn = 0; Wn < Co.mipmaps.length; Wn++)setupFrameBufferTexture(Ll.__webglFramebuffer[Wn], rt, Co, Qe.COLOR_ATTACHMENT0, Dl, Wn);
                            else setupFrameBufferTexture(Ll.__webglFramebuffer, rt, Co, Qe.COLOR_ATTACHMENT0, Dl, 0);
                            textureNeedsGenerateMipmaps(Co) && generateMipmap(Dl), Wn.unbindTexture();
                        }
                        rt.depthBuffer && setupDepthRenderbuffer(rt);
                    }, this.updateRenderTargetMipmap = function(Qe) {
                        const rt = Qe.textures;
                        for(let Co = 0, Ll = rt.length; Co < Ll; Co++){
                            const Ll = rt[Co];
                            if (textureNeedsGenerateMipmaps(Ll)) {
                                const rt = getTargetType(Qe), Co = Dl.get(Ll).__webglTexture;
                                Wn.bindTexture(rt, Co), generateMipmap(rt), Wn.unbindTexture();
                            }
                        }
                    }, this.updateMultisampleRenderTarget = function(rt) {
                        if (rt.samples > 0) {
                            if (!1 === useMultisampledRTT(rt)) {
                                const Co = rt.textures, Ll = rt.width, Rl = rt.height;
                                let Ul = Qe.COLOR_BUFFER_BIT;
                                const Gl = rt.stencilBuffer ? Qe.DEPTH_STENCIL_ATTACHMENT : Qe.DEPTH_ATTACHMENT, Hl = Dl.get(rt), ql = Co.length > 1;
                                if (ql) for(let rt = 0; rt < Co.length; rt++)Wn.bindFramebuffer(Qe.FRAMEBUFFER, Hl.__webglMultisampledFramebuffer), Qe.framebufferRenderbuffer(Qe.FRAMEBUFFER, Qe.COLOR_ATTACHMENT0 + rt, Qe.RENDERBUFFER, null), Wn.bindFramebuffer(Qe.FRAMEBUFFER, Hl.__webglFramebuffer), Qe.framebufferTexture2D(Qe.DRAW_FRAMEBUFFER, Qe.COLOR_ATTACHMENT0 + rt, Qe.TEXTURE_2D, null, 0);
                                Wn.bindFramebuffer(Qe.READ_FRAMEBUFFER, Hl.__webglMultisampledFramebuffer), Wn.bindFramebuffer(Qe.DRAW_FRAMEBUFFER, Hl.__webglFramebuffer);
                                for(let Wn = 0; Wn < Co.length; Wn++){
                                    if (rt.resolveDepthBuffer && (rt.depthBuffer && (Ul |= Qe.DEPTH_BUFFER_BIT), rt.stencilBuffer && rt.resolveStencilBuffer && (Ul |= Qe.STENCIL_BUFFER_BIT)), ql) {
                                        Qe.framebufferRenderbuffer(Qe.READ_FRAMEBUFFER, Qe.COLOR_ATTACHMENT0, Qe.RENDERBUFFER, Hl.__webglColorRenderbuffer[Wn]);
                                        const rt = Dl.get(Co[Wn]).__webglTexture;
                                        Qe.framebufferTexture2D(Qe.DRAW_FRAMEBUFFER, Qe.COLOR_ATTACHMENT0, Qe.TEXTURE_2D, rt, 0);
                                    }
                                    Qe.blitFramebuffer(0, 0, Ll, Rl, 0, 0, Ll, Rl, Ul, Qe.NEAREST), !0 === Zl && (fu.length = 0, yu.length = 0, fu.push(Qe.COLOR_ATTACHMENT0 + Wn), rt.depthBuffer && !1 === rt.resolveDepthBuffer && (fu.push(Gl), yu.push(Gl), Qe.invalidateFramebuffer(Qe.DRAW_FRAMEBUFFER, yu)), Qe.invalidateFramebuffer(Qe.READ_FRAMEBUFFER, fu));
                                }
                                if (Wn.bindFramebuffer(Qe.READ_FRAMEBUFFER, null), Wn.bindFramebuffer(Qe.DRAW_FRAMEBUFFER, null), ql) for(let rt = 0; rt < Co.length; rt++){
                                    Wn.bindFramebuffer(Qe.FRAMEBUFFER, Hl.__webglMultisampledFramebuffer), Qe.framebufferRenderbuffer(Qe.FRAMEBUFFER, Qe.COLOR_ATTACHMENT0 + rt, Qe.RENDERBUFFER, Hl.__webglColorRenderbuffer[rt]);
                                    const Ll = Dl.get(Co[rt]).__webglTexture;
                                    Wn.bindFramebuffer(Qe.FRAMEBUFFER, Hl.__webglFramebuffer), Qe.framebufferTexture2D(Qe.DRAW_FRAMEBUFFER, Qe.COLOR_ATTACHMENT0 + rt, Qe.TEXTURE_2D, Ll, 0);
                                }
                                Wn.bindFramebuffer(Qe.DRAW_FRAMEBUFFER, Hl.__webglMultisampledFramebuffer);
                            } else if (rt.depthBuffer && !1 === rt.resolveDepthBuffer && Zl) {
                                const Wn = rt.stencilBuffer ? Qe.DEPTH_STENCIL_ATTACHMENT : Qe.DEPTH_ATTACHMENT;
                                Qe.invalidateFramebuffer(Qe.DRAW_FRAMEBUFFER, [
                                    Wn
                                ]);
                            }
                        }
                    }, this.setupDepthRenderbuffer = setupDepthRenderbuffer, this.setupFrameBufferTexture = setupFrameBufferTexture, this.useMultisampledRTT = useMultisampledRTT;
                }
                function WebGLUtils(Qe, rt) {
                    return {
                        convert: function(Wn, Dl) {
                            let Ll;
                            void 0 === Dl && (Dl = Co.jf0);
                            const Rl = Co.ppV.getTransfer(Dl);
                            if (Wn === Co.OUM) return Qe.UNSIGNED_BYTE;
                            if (Wn === Co.Wew) return Qe.UNSIGNED_SHORT_4_4_4_4;
                            if (Wn === Co.gJ2) return Qe.UNSIGNED_SHORT_5_5_5_1;
                            if (Wn === Co.Dmk) return Qe.UNSIGNED_INT_5_9_9_9_REV;
                            if (Wn === Co.tJf) return Qe.BYTE;
                            if (Wn === Co.fBL) return Qe.SHORT;
                            if (Wn === Co.cHt) return Qe.UNSIGNED_SHORT;
                            if (Wn === Co.Yuy) return Qe.INT;
                            if (Wn === Co.bkx) return Qe.UNSIGNED_INT;
                            if (Wn === Co.RQf) return Qe.FLOAT;
                            if (Wn === Co.ix0) return Qe.HALF_FLOAT;
                            if (Wn === Co.wrO) return Qe.ALPHA;
                            if (Wn === Co.HIg) return Qe.RGB;
                            if (Wn === Co.GWd) return Qe.RGBA;
                            if (Wn === Co.Kzv) return Qe.LUMINANCE;
                            if (Wn === Co.CMB) return Qe.LUMINANCE_ALPHA;
                            if (Wn === Co.zdS) return Qe.DEPTH_COMPONENT;
                            if (Wn === Co.dcC) return Qe.DEPTH_STENCIL;
                            if (Wn === Co.VT0) return Qe.RED;
                            if (Wn === Co.ZQM) return Qe.RED_INTEGER;
                            if (Wn === Co.paN) return Qe.RG;
                            if (Wn === Co.TkQ) return Qe.RG_INTEGER;
                            if (Wn === Co.c90) return Qe.RGBA_INTEGER;
                            if (Wn === Co.IE4 || Wn === Co.Nz6 || Wn === Co.jR7 || Wn === Co.BXX) {
                                if (Rl === Co.KLL) {
                                    if (Ll = rt.get("WEBGL_compressed_texture_s3tc_srgb"), null === Ll) return null;
                                    if (Wn === Co.IE4) return Ll.COMPRESSED_SRGB_S3TC_DXT1_EXT;
                                    if (Wn === Co.Nz6) return Ll.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT;
                                    if (Wn === Co.jR7) return Ll.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT;
                                    if (Wn === Co.BXX) return Ll.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT;
                                } else {
                                    if (Ll = rt.get("WEBGL_compressed_texture_s3tc"), null === Ll) return null;
                                    if (Wn === Co.IE4) return Ll.COMPRESSED_RGB_S3TC_DXT1_EXT;
                                    if (Wn === Co.Nz6) return Ll.COMPRESSED_RGBA_S3TC_DXT1_EXT;
                                    if (Wn === Co.jR7) return Ll.COMPRESSED_RGBA_S3TC_DXT3_EXT;
                                    if (Wn === Co.BXX) return Ll.COMPRESSED_RGBA_S3TC_DXT5_EXT;
                                }
                            }
                            if (Wn === Co.k6Q || Wn === Co.kTp || Wn === Co.HXV || Wn === Co.pBf) {
                                if (Ll = rt.get("WEBGL_compressed_texture_pvrtc"), null === Ll) return null;
                                if (Wn === Co.k6Q) return Ll.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
                                if (Wn === Co.kTp) return Ll.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
                                if (Wn === Co.HXV) return Ll.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
                                if (Wn === Co.pBf) return Ll.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
                            }
                            if (Wn === Co.CVz || Wn === Co.Riy || Wn === Co.KDk) {
                                if (Ll = rt.get("WEBGL_compressed_texture_etc"), null === Ll) return null;
                                if (Wn === Co.CVz || Wn === Co.Riy) return Rl === Co.KLL ? Ll.COMPRESSED_SRGB8_ETC2 : Ll.COMPRESSED_RGB8_ETC2;
                                if (Wn === Co.KDk) return Rl === Co.KLL ? Ll.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC : Ll.COMPRESSED_RGBA8_ETC2_EAC;
                            }
                            if (Wn === Co.qa3 || Wn === Co.B_h || Wn === Co.czI || Wn === Co.rSH || Wn === Co.Qrf || Wn === Co.psI || Wn === Co.a5J || Wn === Co._QJ || Wn === Co.uB5 || Wn === Co.lyL || Wn === Co.bC7 || Wn === Co.y3Z || Wn === Co.ojs || Wn === Co.S$4) {
                                if (Ll = rt.get("WEBGL_compressed_texture_astc"), null === Ll) return null;
                                if (Wn === Co.qa3) return Rl === Co.KLL ? Ll.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR : Ll.COMPRESSED_RGBA_ASTC_4x4_KHR;
                                if (Wn === Co.B_h) return Rl === Co.KLL ? Ll.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR : Ll.COMPRESSED_RGBA_ASTC_5x4_KHR;
                                if (Wn === Co.czI) return Rl === Co.KLL ? Ll.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR : Ll.COMPRESSED_RGBA_ASTC_5x5_KHR;
                                if (Wn === Co.rSH) return Rl === Co.KLL ? Ll.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR : Ll.COMPRESSED_RGBA_ASTC_6x5_KHR;
                                if (Wn === Co.Qrf) return Rl === Co.KLL ? Ll.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR : Ll.COMPRESSED_RGBA_ASTC_6x6_KHR;
                                if (Wn === Co.psI) return Rl === Co.KLL ? Ll.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR : Ll.COMPRESSED_RGBA_ASTC_8x5_KHR;
                                if (Wn === Co.a5J) return Rl === Co.KLL ? Ll.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR : Ll.COMPRESSED_RGBA_ASTC_8x6_KHR;
                                if (Wn === Co._QJ) return Rl === Co.KLL ? Ll.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR : Ll.COMPRESSED_RGBA_ASTC_8x8_KHR;
                                if (Wn === Co.uB5) return Rl === Co.KLL ? Ll.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR : Ll.COMPRESSED_RGBA_ASTC_10x5_KHR;
                                if (Wn === Co.lyL) return Rl === Co.KLL ? Ll.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR : Ll.COMPRESSED_RGBA_ASTC_10x6_KHR;
                                if (Wn === Co.bC7) return Rl === Co.KLL ? Ll.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR : Ll.COMPRESSED_RGBA_ASTC_10x8_KHR;
                                if (Wn === Co.y3Z) return Rl === Co.KLL ? Ll.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR : Ll.COMPRESSED_RGBA_ASTC_10x10_KHR;
                                if (Wn === Co.ojs) return Rl === Co.KLL ? Ll.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR : Ll.COMPRESSED_RGBA_ASTC_12x10_KHR;
                                if (Wn === Co.S$4) return Rl === Co.KLL ? Ll.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR : Ll.COMPRESSED_RGBA_ASTC_12x12_KHR;
                            }
                            if (Wn === Co.Fn || Wn === Co.H23 || Wn === Co.W9U) {
                                if (Ll = rt.get("EXT_texture_compression_bptc"), null === Ll) return null;
                                if (Wn === Co.Fn) return Rl === Co.KLL ? Ll.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT : Ll.COMPRESSED_RGBA_BPTC_UNORM_EXT;
                                if (Wn === Co.H23) return Ll.COMPRESSED_RGB_BPTC_SIGNED_FLOAT_EXT;
                                if (Wn === Co.W9U) return Ll.COMPRESSED_RGB_BPTC_UNSIGNED_FLOAT_EXT;
                            }
                            if (Wn === Co.Kef || Wn === Co.XG_ || Wn === Co.HO_ || Wn === Co.CWW) {
                                if (Ll = rt.get("EXT_texture_compression_rgtc"), null === Ll) return null;
                                if (Wn === Co.Fn) return Ll.COMPRESSED_RED_RGTC1_EXT;
                                if (Wn === Co.XG_) return Ll.COMPRESSED_SIGNED_RED_RGTC1_EXT;
                                if (Wn === Co.HO_) return Ll.COMPRESSED_RED_GREEN_RGTC2_EXT;
                                if (Wn === Co.CWW) return Ll.COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT;
                            }
                            return Wn === Co.V3x ? Qe.UNSIGNED_INT_24_8 : void 0 !== Qe[Wn] ? Qe[Wn] : null;
                        }
                    };
                }
                class WebXRDepthSensing {
                    constructor(){
                        this.texture = null, this.mesh = null, this.depthNear = 0, this.depthFar = 0;
                    }
                    init(Qe, rt, Wn) {
                        if (null === this.texture) {
                            const Dl = new Co.gPd;
                            Qe.properties.get(Dl).__webglTexture = rt.texture, rt.depthNear === Wn.depthNear && rt.depthFar === Wn.depthFar || (this.depthNear = rt.depthNear, this.depthFar = rt.depthFar), this.texture = Dl;
                        }
                    }
                    getMesh(Qe) {
                        if (null !== this.texture && null === this.mesh) {
                            const rt = Qe.cameras[0].viewport, Wn = new Co.BKk({
                                vertexShader: "\nvoid main() {\n\n	gl_Position = vec4( position, 1.0 );\n\n}",
                                fragmentShader: "\nuniform sampler2DArray depthColor;\nuniform float depthWidth;\nuniform float depthHeight;\n\nvoid main() {\n\n	vec2 coord = vec2( gl_FragCoord.x / depthWidth, gl_FragCoord.y / depthHeight );\n\n	if ( coord.x >= 1.0 ) {\n\n		gl_FragDepth = texture( depthColor, vec3( coord.x - 1.0, coord.y, 1 ) ).r;\n\n	} else {\n\n		gl_FragDepth = texture( depthColor, vec3( coord.x, coord.y, 0 ) ).r;\n\n	}\n\n}",
                                uniforms: {
                                    depthColor: {
                                        value: this.texture
                                    },
                                    depthWidth: {
                                        value: rt.z
                                    },
                                    depthHeight: {
                                        value: rt.w
                                    }
                                }
                            });
                            this.mesh = new Co.eaF(new Co.bdM(20, 20), Wn);
                        }
                        return this.mesh;
                    }
                    reset() {
                        this.texture = null, this.mesh = null;
                    }
                    getDepthTexture() {
                        return this.texture;
                    }
                }
                class WebXRManager extends Co.Qev {
                    constructor(Qe, rt){
                        super();
                        const Wn = this;
                        let Dl = null, Ll = 1, Rl = null, Ul = "local-floor", Gl = 1, Zl = null, Hl = null, ql = null, Ql = null, Kl = null, $l = null;
                        const Tc = new WebXRDepthSensing, tu = rt.getContextAttributes();
                        let lu = null, du = null;
                        const fu = [], yu = [], Eu = new Co.I9Y;
                        let Tu = null;
                        const Lu = new Co.ubm;
                        Lu.viewport = new Co.IUQ;
                        const Zu = new Co.ubm;
                        Zu.viewport = new Co.IUQ;
                        const Xu = [
                            Lu,
                            Zu
                        ], Ju = new Co.nZQ;
                        let $u = null, ed = null;
                        function onSessionEvent(Qe) {
                            const rt = yu.indexOf(Qe.inputSource);
                            if (-1 === rt) return;
                            const Wn = fu[rt];
                            void 0 !== Wn && (Wn.update(Qe.inputSource, Qe.frame, Zl || Rl), Wn.dispatchEvent({
                                type: Qe.type,
                                data: Qe.inputSource
                            }));
                        }
                        function onSessionEnd() {
                            Dl.removeEventListener("select", onSessionEvent), Dl.removeEventListener("selectstart", onSessionEvent), Dl.removeEventListener("selectend", onSessionEvent), Dl.removeEventListener("squeeze", onSessionEvent), Dl.removeEventListener("squeezestart", onSessionEvent), Dl.removeEventListener("squeezeend", onSessionEvent), Dl.removeEventListener("end", onSessionEnd), Dl.removeEventListener("inputsourceschange", onInputSourcesChange);
                            for(let Qe = 0; Qe < fu.length; Qe++){
                                const rt = yu[Qe];
                                null !== rt && (yu[Qe] = null, fu[Qe].disconnect(rt));
                            }
                            $u = null, ed = null, Tc.reset(), Qe.setRenderTarget(lu), Kl = null, Ql = null, ql = null, Dl = null, du = null, rd.stop(), Wn.isPresenting = !1, Qe.setPixelRatio(Tu), Qe.setSize(Eu.width, Eu.height, !1), Wn.dispatchEvent({
                                type: "sessionend"
                            });
                        }
                        function onInputSourcesChange(Qe) {
                            for(let rt = 0; rt < Qe.removed.length; rt++){
                                const Wn = Qe.removed[rt], Co = yu.indexOf(Wn);
                                Co >= 0 && (yu[Co] = null, fu[Co].disconnect(Wn));
                            }
                            for(let rt = 0; rt < Qe.added.length; rt++){
                                const Wn = Qe.added[rt];
                                let Co = yu.indexOf(Wn);
                                if (-1 === Co) {
                                    for(let Qe = 0; Qe < fu.length; Qe++){
                                        if (Qe >= yu.length) {
                                            yu.push(Wn), Co = Qe;
                                            break;
                                        }
                                        if (null === yu[Qe]) {
                                            yu[Qe] = Wn, Co = Qe;
                                            break;
                                        }
                                    }
                                    if (-1 === Co) break;
                                }
                                const Dl = fu[Co];
                                Dl && Dl.connect(Wn);
                            }
                        }
                        this.cameraAutoUpdate = !0, this.enabled = !1, this.isPresenting = !1, this.getController = function(Qe) {
                            let rt = fu[Qe];
                            return void 0 === rt && (rt = new Co.R3r, fu[Qe] = rt), rt.getTargetRaySpace();
                        }, this.getControllerGrip = function(Qe) {
                            let rt = fu[Qe];
                            return void 0 === rt && (rt = new Co.R3r, fu[Qe] = rt), rt.getGripSpace();
                        }, this.getHand = function(Qe) {
                            let rt = fu[Qe];
                            return void 0 === rt && (rt = new Co.R3r, fu[Qe] = rt), rt.getHandSpace();
                        }, this.setFramebufferScaleFactor = function(Qe) {
                            Ll = Qe, !0 === Wn.isPresenting && console.warn("THREE.WebXRManager: Cannot change framebuffer scale while presenting.");
                        }, this.setReferenceSpaceType = function(Qe) {
                            Ul = Qe, !0 === Wn.isPresenting && console.warn("THREE.WebXRManager: Cannot change reference space type while presenting.");
                        }, this.getReferenceSpace = function() {
                            return Zl || Rl;
                        }, this.setReferenceSpace = function(Qe) {
                            Zl = Qe;
                        }, this.getBaseLayer = function() {
                            return null !== Ql ? Ql : Kl;
                        }, this.getBinding = function() {
                            return ql;
                        }, this.getFrame = function() {
                            return $l;
                        }, this.getSession = function() {
                            return Dl;
                        }, this.setSession = async function(Hl) {
                            if (Dl = Hl, null !== Dl) {
                                lu = Qe.getRenderTarget(), Dl.addEventListener("select", onSessionEvent), Dl.addEventListener("selectstart", onSessionEvent), Dl.addEventListener("selectend", onSessionEvent), Dl.addEventListener("squeeze", onSessionEvent), Dl.addEventListener("squeezestart", onSessionEvent), Dl.addEventListener("squeezeend", onSessionEvent), Dl.addEventListener("end", onSessionEnd), Dl.addEventListener("inputsourceschange", onInputSourcesChange), !0 !== tu.xrCompatible && await rt.makeXRCompatible(), Tu = Qe.getPixelRatio(), Qe.getSize(Eu);
                                if ("undefined" !== typeof XRWebGLBinding && "createProjectionLayer" in XRWebGLBinding.prototype) {
                                    let Wn = null, Rl = null, Ul = null;
                                    tu.depth && (Ul = tu.stencil ? rt.DEPTH24_STENCIL8 : rt.DEPTH_COMPONENT24, Wn = tu.stencil ? Co.dcC : Co.zdS, Rl = tu.stencil ? Co.V3x : Co.bkx);
                                    const Gl = {
                                        colorFormat: rt.RGBA8,
                                        depthFormat: Ul,
                                        scaleFactor: Ll
                                    };
                                    ql = new XRWebGLBinding(Dl, rt), Ql = ql.createProjectionLayer(Gl), Dl.updateRenderState({
                                        layers: [
                                            Ql
                                        ]
                                    }), Qe.setPixelRatio(1), Qe.setSize(Ql.textureWidth, Ql.textureHeight, !1), du = new Co.nWS(Ql.textureWidth, Ql.textureHeight, {
                                        format: Co.GWd,
                                        type: Co.OUM,
                                        depthTexture: new Co.VCu(Ql.textureWidth, Ql.textureHeight, Rl, void 0, void 0, void 0, void 0, void 0, void 0, Wn),
                                        stencilBuffer: tu.stencil,
                                        colorSpace: Qe.outputColorSpace,
                                        samples: tu.antialias ? 4 : 0,
                                        resolveDepthBuffer: !1 === Ql.ignoreDepthValues
                                    });
                                } else {
                                    const Wn = {
                                        antialias: tu.antialias,
                                        alpha: !0,
                                        depth: tu.depth,
                                        stencil: tu.stencil,
                                        framebufferScaleFactor: Ll
                                    };
                                    Kl = new XRWebGLLayer(Dl, rt, Wn), Dl.updateRenderState({
                                        baseLayer: Kl
                                    }), Qe.setPixelRatio(1), Qe.setSize(Kl.framebufferWidth, Kl.framebufferHeight, !1), du = new Co.nWS(Kl.framebufferWidth, Kl.framebufferHeight, {
                                        format: Co.GWd,
                                        type: Co.OUM,
                                        colorSpace: Qe.outputColorSpace,
                                        stencilBuffer: tu.stencil
                                    });
                                }
                                du.isXRRenderTarget = !0, this.setFoveation(Gl), Zl = null, Rl = await Dl.requestReferenceSpace(Ul), rd.setContext(Dl), rd.start(), Wn.isPresenting = !0, Wn.dispatchEvent({
                                    type: "sessionstart"
                                });
                            }
                        }, this.getEnvironmentBlendMode = function() {
                            if (null !== Dl) return Dl.environmentBlendMode;
                        }, this.getDepthTexture = function() {
                            return Tc.getDepthTexture();
                        };
                        const td = new Co.Pq0, id = new Co.Pq0;
                        function updateCamera(Qe, rt) {
                            null === rt ? Qe.matrixWorld.copy(Qe.matrix) : Qe.matrixWorld.multiplyMatrices(rt.matrixWorld, Qe.matrix), Qe.matrixWorldInverse.copy(Qe.matrixWorld).invert();
                        }
                        this.updateCamera = function(Qe) {
                            if (null === Dl) return;
                            let rt = Qe.near, Wn = Qe.far;
                            null !== Tc.texture && (Tc.depthNear > 0 && (rt = Tc.depthNear), Tc.depthFar > 0 && (Wn = Tc.depthFar)), Ju.near = Zu.near = Lu.near = rt, Ju.far = Zu.far = Lu.far = Wn, $u === Ju.near && ed === Ju.far || (Dl.updateRenderState({
                                depthNear: Ju.near,
                                depthFar: Ju.far
                            }), $u = Ju.near, ed = Ju.far), Lu.layers.mask = 2 | Qe.layers.mask, Zu.layers.mask = 4 | Qe.layers.mask, Ju.layers.mask = Lu.layers.mask | Zu.layers.mask;
                            const Ll = Qe.parent, Rl = Ju.cameras;
                            updateCamera(Ju, Ll);
                            for(let Co = 0; Co < Rl.length; Co++)updateCamera(Rl[Co], Ll);
                            2 === Rl.length ? function(Qe, rt, Wn) {
                                td.setFromMatrixPosition(rt.matrixWorld), id.setFromMatrixPosition(Wn.matrixWorld);
                                const Co = td.distanceTo(id), Dl = rt.projectionMatrix.elements, Ll = Wn.projectionMatrix.elements, Rl = Dl[14] / (Dl[10] - 1), Ul = Dl[14] / (Dl[10] + 1), Gl = (Dl[9] + 1) / Dl[5], Zl = (Dl[9] - 1) / Dl[5], Hl = (Dl[8] - 1) / Dl[0], ql = (Ll[8] + 1) / Ll[0], Ql = Rl * Hl, Kl = Rl * ql, $l = Co / (-Hl + ql), Tc = $l * -Hl;
                                if (rt.matrixWorld.decompose(Qe.position, Qe.quaternion, Qe.scale), Qe.translateX(Tc), Qe.translateZ($l), Qe.matrixWorld.compose(Qe.position, Qe.quaternion, Qe.scale), Qe.matrixWorldInverse.copy(Qe.matrixWorld).invert(), -1 === Dl[10]) Qe.projectionMatrix.copy(rt.projectionMatrix), Qe.projectionMatrixInverse.copy(rt.projectionMatrixInverse);
                                else {
                                    const rt = Rl + $l, Wn = Ul + $l, Dl = Ql - Tc, Ll = Kl + (Co - Tc), Hl = Gl * Ul / Wn * rt, ql = Zl * Ul / Wn * rt;
                                    Qe.projectionMatrix.makePerspective(Dl, Ll, Hl, ql, rt, Wn), Qe.projectionMatrixInverse.copy(Qe.projectionMatrix).invert();
                                }
                            }(Ju, Lu, Zu) : Ju.projectionMatrix.copy(Lu.projectionMatrix), function(Qe, rt, Wn) {
                                null === Wn ? Qe.matrix.copy(rt.matrixWorld) : (Qe.matrix.copy(Wn.matrixWorld), Qe.matrix.invert(), Qe.matrix.multiply(rt.matrixWorld));
                                Qe.matrix.decompose(Qe.position, Qe.quaternion, Qe.scale), Qe.updateMatrixWorld(!0), Qe.projectionMatrix.copy(rt.projectionMatrix), Qe.projectionMatrixInverse.copy(rt.projectionMatrixInverse), Qe.isPerspectiveCamera && (Qe.fov = 2 * Co.a55 * Math.atan(1 / Qe.projectionMatrix.elements[5]), Qe.zoom = 1);
                            }(Qe, Ju, Ll);
                        }, this.getCamera = function() {
                            return Ju;
                        }, this.getFoveation = function() {
                            if (null !== Ql || null !== Kl) return Gl;
                        }, this.setFoveation = function(Qe) {
                            Gl = Qe, null !== Ql && (Ql.fixedFoveation = Qe), null !== Kl && void 0 !== Kl.fixedFoveation && (Kl.fixedFoveation = Qe);
                        }, this.hasDepthSensing = function() {
                            return null !== Tc.texture;
                        }, this.getDepthSensingMesh = function() {
                            return Tc.getMesh(Ju);
                        };
                        let nd = null;
                        const rd = new WebGLAnimation;
                        rd.setAnimationLoop(function(rt, Ll) {
                            if (Hl = Ll.getViewerPose(Zl || Rl), $l = Ll, null !== Hl) {
                                const rt = Hl.views;
                                null !== Kl && (Qe.setRenderTargetFramebuffer(du, Kl.framebuffer), Qe.setRenderTarget(du));
                                let Wn = !1;
                                rt.length !== Ju.cameras.length && (Ju.cameras.length = 0, Wn = !0);
                                for(let Dl = 0; Dl < rt.length; Dl++){
                                    const Ll = rt[Dl];
                                    let Rl = null;
                                    if (null !== Kl) Rl = Kl.getViewport(Ll);
                                    else {
                                        const rt = ql.getViewSubImage(Ql, Ll);
                                        Rl = rt.viewport, 0 === Dl && (Qe.setRenderTargetTextures(du, rt.colorTexture, Ql.ignoreDepthValues ? void 0 : rt.depthStencilTexture), Qe.setRenderTarget(du));
                                    }
                                    let Ul = Xu[Dl];
                                    void 0 === Ul && (Ul = new Co.ubm, Ul.layers.enable(Dl), Ul.viewport = new Co.IUQ, Xu[Dl] = Ul), Ul.matrix.fromArray(Ll.transform.matrix), Ul.matrix.decompose(Ul.position, Ul.quaternion, Ul.scale), Ul.projectionMatrix.fromArray(Ll.projectionMatrix), Ul.projectionMatrixInverse.copy(Ul.projectionMatrix).invert(), Ul.viewport.set(Rl.x, Rl.y, Rl.width, Rl.height), 0 === Dl && (Ju.matrix.copy(Ul.matrix), Ju.matrix.decompose(Ju.position, Ju.quaternion, Ju.scale)), !0 === Wn && Ju.cameras.push(Ul);
                                }
                                const Ll = Dl.enabledFeatures;
                                if (Ll && Ll.includes("depth-sensing") && "gpu-optimized" == Dl.depthUsage && ql) {
                                    const Wn = ql.getDepthInformation(rt[0]);
                                    Wn && Wn.isValid && Wn.texture && Tc.init(Qe, Wn, Dl.renderState);
                                }
                            }
                            for(let Qe = 0; Qe < fu.length; Qe++){
                                const rt = yu[Qe], Wn = fu[Qe];
                                null !== rt && void 0 !== Wn && Wn.update(rt, Ll, Zl || Rl);
                            }
                            nd && nd(rt, Ll), Ll.detectedPlanes && Wn.dispatchEvent({
                                type: "planesdetected",
                                data: Ll
                            }), $l = null;
                        }), this.setAnimationLoop = function(Qe) {
                            nd = Qe;
                        }, this.dispose = function() {};
                    }
                }
                const pd = new Co.O9p, md = new Co.kn4;
                function WebGLMaterials(Qe, rt) {
                    function refreshTransformUniform(Qe, rt) {
                        !0 === Qe.matrixAutoUpdate && Qe.updateMatrix(), rt.value.copy(Qe.matrix);
                    }
                    function refreshUniformsCommon(Qe, Wn) {
                        Qe.opacity.value = Wn.opacity, Wn.color && Qe.diffuse.value.copy(Wn.color), Wn.emissive && Qe.emissive.value.copy(Wn.emissive).multiplyScalar(Wn.emissiveIntensity), Wn.map && (Qe.map.value = Wn.map, refreshTransformUniform(Wn.map, Qe.mapTransform)), Wn.alphaMap && (Qe.alphaMap.value = Wn.alphaMap, refreshTransformUniform(Wn.alphaMap, Qe.alphaMapTransform)), Wn.bumpMap && (Qe.bumpMap.value = Wn.bumpMap, refreshTransformUniform(Wn.bumpMap, Qe.bumpMapTransform), Qe.bumpScale.value = Wn.bumpScale, Wn.side === Co.hsX && (Qe.bumpScale.value *= -1)), Wn.normalMap && (Qe.normalMap.value = Wn.normalMap, refreshTransformUniform(Wn.normalMap, Qe.normalMapTransform), Qe.normalScale.value.copy(Wn.normalScale), Wn.side === Co.hsX && Qe.normalScale.value.negate()), Wn.displacementMap && (Qe.displacementMap.value = Wn.displacementMap, refreshTransformUniform(Wn.displacementMap, Qe.displacementMapTransform), Qe.displacementScale.value = Wn.displacementScale, Qe.displacementBias.value = Wn.displacementBias), Wn.emissiveMap && (Qe.emissiveMap.value = Wn.emissiveMap, refreshTransformUniform(Wn.emissiveMap, Qe.emissiveMapTransform)), Wn.specularMap && (Qe.specularMap.value = Wn.specularMap, refreshTransformUniform(Wn.specularMap, Qe.specularMapTransform)), Wn.alphaTest > 0 && (Qe.alphaTest.value = Wn.alphaTest);
                        const Dl = rt.get(Wn), Ll = Dl.envMap, Rl = Dl.envMapRotation;
                        Ll && (Qe.envMap.value = Ll, pd.copy(Rl), pd.x *= -1, pd.y *= -1, pd.z *= -1, Ll.isCubeTexture && !1 === Ll.isRenderTargetTexture && (pd.y *= -1, pd.z *= -1), Qe.envMapRotation.value.setFromMatrix4(md.makeRotationFromEuler(pd)), Qe.flipEnvMap.value = Ll.isCubeTexture && !1 === Ll.isRenderTargetTexture ? -1 : 1, Qe.reflectivity.value = Wn.reflectivity, Qe.ior.value = Wn.ior, Qe.refractionRatio.value = Wn.refractionRatio), Wn.lightMap && (Qe.lightMap.value = Wn.lightMap, Qe.lightMapIntensity.value = Wn.lightMapIntensity, refreshTransformUniform(Wn.lightMap, Qe.lightMapTransform)), Wn.aoMap && (Qe.aoMap.value = Wn.aoMap, Qe.aoMapIntensity.value = Wn.aoMapIntensity, refreshTransformUniform(Wn.aoMap, Qe.aoMapTransform));
                    }
                    return {
                        refreshFogUniforms: function(rt, Wn) {
                            Wn.color.getRGB(rt.fogColor.value, (0, Co._Ut)(Qe)), Wn.isFog ? (rt.fogNear.value = Wn.near, rt.fogFar.value = Wn.far) : Wn.isFogExp2 && (rt.fogDensity.value = Wn.density);
                        },
                        refreshMaterialUniforms: function(Qe, Wn, Dl, Ll, Rl) {
                            Wn.isMeshBasicMaterial || Wn.isMeshLambertMaterial ? refreshUniformsCommon(Qe, Wn) : Wn.isMeshToonMaterial ? (refreshUniformsCommon(Qe, Wn), function(Qe, rt) {
                                rt.gradientMap && (Qe.gradientMap.value = rt.gradientMap);
                            }(Qe, Wn)) : Wn.isMeshPhongMaterial ? (refreshUniformsCommon(Qe, Wn), function(Qe, rt) {
                                Qe.specular.value.copy(rt.specular), Qe.shininess.value = Math.max(rt.shininess, 1e-4);
                            }(Qe, Wn)) : Wn.isMeshStandardMaterial ? (refreshUniformsCommon(Qe, Wn), function(Qe, rt) {
                                Qe.metalness.value = rt.metalness, rt.metalnessMap && (Qe.metalnessMap.value = rt.metalnessMap, refreshTransformUniform(rt.metalnessMap, Qe.metalnessMapTransform));
                                Qe.roughness.value = rt.roughness, rt.roughnessMap && (Qe.roughnessMap.value = rt.roughnessMap, refreshTransformUniform(rt.roughnessMap, Qe.roughnessMapTransform));
                                rt.envMap && (Qe.envMapIntensity.value = rt.envMapIntensity);
                            }(Qe, Wn), Wn.isMeshPhysicalMaterial && function(Qe, rt, Wn) {
                                Qe.ior.value = rt.ior, rt.sheen > 0 && (Qe.sheenColor.value.copy(rt.sheenColor).multiplyScalar(rt.sheen), Qe.sheenRoughness.value = rt.sheenRoughness, rt.sheenColorMap && (Qe.sheenColorMap.value = rt.sheenColorMap, refreshTransformUniform(rt.sheenColorMap, Qe.sheenColorMapTransform)), rt.sheenRoughnessMap && (Qe.sheenRoughnessMap.value = rt.sheenRoughnessMap, refreshTransformUniform(rt.sheenRoughnessMap, Qe.sheenRoughnessMapTransform)));
                                rt.clearcoat > 0 && (Qe.clearcoat.value = rt.clearcoat, Qe.clearcoatRoughness.value = rt.clearcoatRoughness, rt.clearcoatMap && (Qe.clearcoatMap.value = rt.clearcoatMap, refreshTransformUniform(rt.clearcoatMap, Qe.clearcoatMapTransform)), rt.clearcoatRoughnessMap && (Qe.clearcoatRoughnessMap.value = rt.clearcoatRoughnessMap, refreshTransformUniform(rt.clearcoatRoughnessMap, Qe.clearcoatRoughnessMapTransform)), rt.clearcoatNormalMap && (Qe.clearcoatNormalMap.value = rt.clearcoatNormalMap, refreshTransformUniform(rt.clearcoatNormalMap, Qe.clearcoatNormalMapTransform), Qe.clearcoatNormalScale.value.copy(rt.clearcoatNormalScale), rt.side === Co.hsX && Qe.clearcoatNormalScale.value.negate()));
                                rt.dispersion > 0 && (Qe.dispersion.value = rt.dispersion);
                                rt.iridescence > 0 && (Qe.iridescence.value = rt.iridescence, Qe.iridescenceIOR.value = rt.iridescenceIOR, Qe.iridescenceThicknessMinimum.value = rt.iridescenceThicknessRange[0], Qe.iridescenceThicknessMaximum.value = rt.iridescenceThicknessRange[1], rt.iridescenceMap && (Qe.iridescenceMap.value = rt.iridescenceMap, refreshTransformUniform(rt.iridescenceMap, Qe.iridescenceMapTransform)), rt.iridescenceThicknessMap && (Qe.iridescenceThicknessMap.value = rt.iridescenceThicknessMap, refreshTransformUniform(rt.iridescenceThicknessMap, Qe.iridescenceThicknessMapTransform)));
                                rt.transmission > 0 && (Qe.transmission.value = rt.transmission, Qe.transmissionSamplerMap.value = Wn.texture, Qe.transmissionSamplerSize.value.set(Wn.width, Wn.height), rt.transmissionMap && (Qe.transmissionMap.value = rt.transmissionMap, refreshTransformUniform(rt.transmissionMap, Qe.transmissionMapTransform)), Qe.thickness.value = rt.thickness, rt.thicknessMap && (Qe.thicknessMap.value = rt.thicknessMap, refreshTransformUniform(rt.thicknessMap, Qe.thicknessMapTransform)), Qe.attenuationDistance.value = rt.attenuationDistance, Qe.attenuationColor.value.copy(rt.attenuationColor));
                                rt.anisotropy > 0 && (Qe.anisotropyVector.value.set(rt.anisotropy * Math.cos(rt.anisotropyRotation), rt.anisotropy * Math.sin(rt.anisotropyRotation)), rt.anisotropyMap && (Qe.anisotropyMap.value = rt.anisotropyMap, refreshTransformUniform(rt.anisotropyMap, Qe.anisotropyMapTransform)));
                                Qe.specularIntensity.value = rt.specularIntensity, Qe.specularColor.value.copy(rt.specularColor), rt.specularColorMap && (Qe.specularColorMap.value = rt.specularColorMap, refreshTransformUniform(rt.specularColorMap, Qe.specularColorMapTransform));
                                rt.specularIntensityMap && (Qe.specularIntensityMap.value = rt.specularIntensityMap, refreshTransformUniform(rt.specularIntensityMap, Qe.specularIntensityMapTransform));
                            }(Qe, Wn, Rl)) : Wn.isMeshMatcapMaterial ? (refreshUniformsCommon(Qe, Wn), function(Qe, rt) {
                                rt.matcap && (Qe.matcap.value = rt.matcap);
                            }(Qe, Wn)) : Wn.isMeshDepthMaterial ? refreshUniformsCommon(Qe, Wn) : Wn.isMeshDistanceMaterial ? (refreshUniformsCommon(Qe, Wn), function(Qe, Wn) {
                                const Co = rt.get(Wn).light;
                                Qe.referencePosition.value.setFromMatrixPosition(Co.matrixWorld), Qe.nearDistance.value = Co.shadow.camera.near, Qe.farDistance.value = Co.shadow.camera.far;
                            }(Qe, Wn)) : Wn.isMeshNormalMaterial ? refreshUniformsCommon(Qe, Wn) : Wn.isLineBasicMaterial ? (function(Qe, rt) {
                                Qe.diffuse.value.copy(rt.color), Qe.opacity.value = rt.opacity, rt.map && (Qe.map.value = rt.map, refreshTransformUniform(rt.map, Qe.mapTransform));
                            }(Qe, Wn), Wn.isLineDashedMaterial && function(Qe, rt) {
                                Qe.dashSize.value = rt.dashSize, Qe.totalSize.value = rt.dashSize + rt.gapSize, Qe.scale.value = rt.scale;
                            }(Qe, Wn)) : Wn.isPointsMaterial ? function(Qe, rt, Wn, Co) {
                                Qe.diffuse.value.copy(rt.color), Qe.opacity.value = rt.opacity, Qe.size.value = rt.size * Wn, Qe.scale.value = .5 * Co, rt.map && (Qe.map.value = rt.map, refreshTransformUniform(rt.map, Qe.uvTransform));
                                rt.alphaMap && (Qe.alphaMap.value = rt.alphaMap, refreshTransformUniform(rt.alphaMap, Qe.alphaMapTransform));
                                rt.alphaTest > 0 && (Qe.alphaTest.value = rt.alphaTest);
                            }(Qe, Wn, Dl, Ll) : Wn.isSpriteMaterial ? function(Qe, rt) {
                                Qe.diffuse.value.copy(rt.color), Qe.opacity.value = rt.opacity, Qe.rotation.value = rt.rotation, rt.map && (Qe.map.value = rt.map, refreshTransformUniform(rt.map, Qe.mapTransform));
                                rt.alphaMap && (Qe.alphaMap.value = rt.alphaMap, refreshTransformUniform(rt.alphaMap, Qe.alphaMapTransform));
                                rt.alphaTest > 0 && (Qe.alphaTest.value = rt.alphaTest);
                            }(Qe, Wn) : Wn.isShadowMaterial ? (Qe.color.value.copy(Wn.color), Qe.opacity.value = Wn.opacity) : Wn.isShaderMaterial && (Wn.uniformsNeedUpdate = !1);
                        }
                    };
                }
                function WebGLUniformsGroups(Qe, rt, Wn, Co) {
                    let Dl = {}, Ll = {}, Rl = [];
                    const Ul = Qe.getParameter(Qe.MAX_UNIFORM_BUFFER_BINDINGS);
                    function hasUniformChanged(Qe, rt, Wn, Co) {
                        const Dl = Qe.value, Ll = rt + "_" + Wn;
                        if (void 0 === Co[Ll]) return Co[Ll] = "number" === typeof Dl || "boolean" === typeof Dl ? Dl : Dl.clone(), !0;
                        {
                            const Qe = Co[Ll];
                            if ("number" === typeof Dl || "boolean" === typeof Dl) {
                                if (Qe !== Dl) return Co[Ll] = Dl, !0;
                            } else if (!1 === Qe.equals(Dl)) return Qe.copy(Dl), !0;
                        }
                        return !1;
                    }
                    function getUniformSize(Qe) {
                        const rt = {
                            boundary: 0,
                            storage: 0
                        };
                        return "number" === typeof Qe || "boolean" === typeof Qe ? (rt.boundary = 4, rt.storage = 4) : Qe.isVector2 ? (rt.boundary = 8, rt.storage = 8) : Qe.isVector3 || Qe.isColor ? (rt.boundary = 16, rt.storage = 12) : Qe.isVector4 ? (rt.boundary = 16, rt.storage = 16) : Qe.isMatrix3 ? (rt.boundary = 48, rt.storage = 48) : Qe.isMatrix4 ? (rt.boundary = 64, rt.storage = 64) : Qe.isTexture ? console.warn("THREE.WebGLRenderer: Texture samplers can not be part of an uniforms group.") : console.warn("THREE.WebGLRenderer: Unsupported uniform value type.", Qe), rt;
                    }
                    function onUniformsGroupsDispose(rt) {
                        const Wn = rt.target;
                        Wn.removeEventListener("dispose", onUniformsGroupsDispose);
                        const Co = Rl.indexOf(Wn.__bindingPointIndex);
                        Rl.splice(Co, 1), Qe.deleteBuffer(Dl[Wn.id]), delete Dl[Wn.id], delete Ll[Wn.id];
                    }
                    return {
                        bind: function(Qe, rt) {
                            const Wn = rt.program;
                            Co.uniformBlockBinding(Qe, Wn);
                        },
                        update: function(Wn, Gl) {
                            let Zl = Dl[Wn.id];
                            void 0 === Zl && (!function(Qe) {
                                const rt = Qe.uniforms;
                                let Wn = 0;
                                const Co = 16;
                                for(let Ll = 0, Rl = rt.length; Ll < Rl; Ll++){
                                    const Qe = Array.isArray(rt[Ll]) ? rt[Ll] : [
                                        rt[Ll]
                                    ];
                                    for(let rt = 0, Dl = Qe.length; rt < Dl; rt++){
                                        const Dl = Qe[rt], Ll = Array.isArray(Dl.value) ? Dl.value : [
                                            Dl.value
                                        ];
                                        for(let Qe = 0, rt = Ll.length; Qe < rt; Qe++){
                                            const rt = getUniformSize(Ll[Qe]), Rl = Wn % Co, Ul = Rl % rt.boundary, Gl = Rl + Ul;
                                            Wn += Ul, 0 !== Gl && Co - Gl < rt.storage && (Wn += Co - Gl), Dl.__data = new Float32Array(rt.storage / Float32Array.BYTES_PER_ELEMENT), Dl.__offset = Wn, Wn += rt.storage;
                                        }
                                    }
                                }
                                const Dl = Wn % Co;
                                Dl > 0 && (Wn += Co - Dl);
                                Qe.__size = Wn, Qe.__cache = {};
                            }(Wn), Zl = function(rt) {
                                const Wn = function() {
                                    for(let Qe = 0; Qe < Ul; Qe++)if (-1 === Rl.indexOf(Qe)) return Rl.push(Qe), Qe;
                                    return console.error("THREE.WebGLRenderer: Maximum number of simultaneously usable uniforms groups reached."), 0;
                                }();
                                rt.__bindingPointIndex = Wn;
                                const Co = Qe.createBuffer(), Dl = rt.__size, Ll = rt.usage;
                                return Qe.bindBuffer(Qe.UNIFORM_BUFFER, Co), Qe.bufferData(Qe.UNIFORM_BUFFER, Dl, Ll), Qe.bindBuffer(Qe.UNIFORM_BUFFER, null), Qe.bindBufferBase(Qe.UNIFORM_BUFFER, Wn, Co), Co;
                            }(Wn), Dl[Wn.id] = Zl, Wn.addEventListener("dispose", onUniformsGroupsDispose));
                            const Hl = Gl.program;
                            Co.updateUBOMapping(Wn, Hl);
                            const ql = rt.render.frame;
                            Ll[Wn.id] !== ql && (!function(rt) {
                                const Wn = Dl[rt.id], Co = rt.uniforms, Ll = rt.__cache;
                                Qe.bindBuffer(Qe.UNIFORM_BUFFER, Wn);
                                for(let Dl = 0, Rl = Co.length; Dl < Rl; Dl++){
                                    const rt = Array.isArray(Co[Dl]) ? Co[Dl] : [
                                        Co[Dl]
                                    ];
                                    for(let Wn = 0, Co = rt.length; Wn < Co; Wn++){
                                        const Co = rt[Wn];
                                        if (!0 === hasUniformChanged(Co, Dl, Wn, Ll)) {
                                            const rt = Co.__offset, Wn = Array.isArray(Co.value) ? Co.value : [
                                                Co.value
                                            ];
                                            let Dl = 0;
                                            for(let Ll = 0; Ll < Wn.length; Ll++){
                                                const Rl = Wn[Ll], Ul = getUniformSize(Rl);
                                                "number" === typeof Rl || "boolean" === typeof Rl ? (Co.__data[0] = Rl, Qe.bufferSubData(Qe.UNIFORM_BUFFER, rt + Dl, Co.__data)) : Rl.isMatrix3 ? (Co.__data[0] = Rl.elements[0], Co.__data[1] = Rl.elements[1], Co.__data[2] = Rl.elements[2], Co.__data[3] = 0, Co.__data[4] = Rl.elements[3], Co.__data[5] = Rl.elements[4], Co.__data[6] = Rl.elements[5], Co.__data[7] = 0, Co.__data[8] = Rl.elements[6], Co.__data[9] = Rl.elements[7], Co.__data[10] = Rl.elements[8], Co.__data[11] = 0) : (Rl.toArray(Co.__data, Dl), Dl += Ul.storage / Float32Array.BYTES_PER_ELEMENT);
                                            }
                                            Qe.bufferSubData(Qe.UNIFORM_BUFFER, rt, Co.__data);
                                        }
                                    }
                                }
                                Qe.bindBuffer(Qe.UNIFORM_BUFFER, null);
                            }(Wn), Ll[Wn.id] = ql);
                        },
                        dispose: function() {
                            for(const rt in Dl)Qe.deleteBuffer(Dl[rt]);
                            Rl = [], Dl = {}, Ll = {};
                        }
                    };
                }
                class WebGLRenderer {
                    constructor(Qe){
                        void 0 === Qe && (Qe = {});
                        const { canvas: rt = (0, Co.lPF)(), context: Wn = null, depth: Dl = !0, stencil: Ll = !1, alpha: Rl = !1, antialias: Ul = !1, premultipliedAlpha: Gl = !0, preserveDrawingBuffer: Zl = !1, powerPreference: Hl = "default", failIfMajorPerformanceCaveat: ql = !1, reverseDepthBuffer: Ql = !1 } = Qe;
                        let Kl;
                        if (this.isWebGLRenderer = !0, null !== Wn) {
                            if ("undefined" !== typeof WebGLRenderingContext && Wn instanceof WebGLRenderingContext) throw new Error("THREE.WebGLRenderer: WebGL 1 is not supported since r163.");
                            Kl = Wn.getContextAttributes().alpha;
                        } else Kl = Rl;
                        const $l = new Uint32Array(4), Tc = new Int32Array(4);
                        let tu = null, lu = null;
                        const du = [], fu = [];
                        this.domElement = rt, this.debug = {
                            checkShaderErrors: !0,
                            onShaderError: null
                        }, this.autoClear = !0, this.autoClearColor = !0, this.autoClearDepth = !0, this.autoClearStencil = !0, this.sortObjects = !0, this.clippingPlanes = [], this.localClippingEnabled = !1, this._outputColorSpace = Co.er$, this.toneMapping = Co.y_p, this.toneMappingExposure = 1;
                        const yu = this;
                        let Eu = !1, Tu = 0, Lu = 0, Zu = null, Xu = -1, Ju = null;
                        const $u = new Co.IUQ, ed = new Co.IUQ;
                        let td = null;
                        const id = new Co.Q1f(0);
                        let nd = 0, rd = rt.width, sd = rt.height, ad = 1, od = null, ld = null;
                        const cd = new Co.IUQ(0, 0, rd, sd), ud = new Co.IUQ(0, 0, rd, sd);
                        let hd = !1;
                        const dd = new Co.PPD;
                        let pd = !1, md = !1;
                        this.transmissionResolutionScale = 1;
                        const fd = new Co.kn4, gd = new Co.kn4, Ad = new Co.Pq0, yd = new Co.IUQ, vd = {
                            background: null,
                            fog: null,
                            environment: null,
                            overrideMaterial: null,
                            isScene: !0
                        };
                        let _d = !1;
                        function getTargetPixelRatio() {
                            return null === Zu ? ad : 1;
                        }
                        let xd, bd, wd, Ed, Md, Sd, Td, Cd, kd, Id, Dd, Ld, Pd, zd, Nd, Rd, Bd, Od, Fd, jd, Ud, Vd, Gd, Zd, Hd = Wn;
                        function getContext(Qe, Wn) {
                            return rt.getContext(Qe, Wn);
                        }
                        try {
                            const Qe = {
                                alpha: !0,
                                depth: Dl,
                                stencil: Ll,
                                antialias: Ul,
                                premultipliedAlpha: Gl,
                                preserveDrawingBuffer: Zl,
                                powerPreference: Hl,
                                failIfMajorPerformanceCaveat: ql
                            };
                            if ("setAttribute" in rt && rt.setAttribute("data-engine", `three.js r${Co.sPf}`), rt.addEventListener("webglcontextlost", onContextLost, !1), rt.addEventListener("webglcontextrestored", onContextRestore, !1), rt.addEventListener("webglcontextcreationerror", onContextCreationError, !1), null === Hd) {
                                const rt = "webgl2";
                                if (Hd = getContext(rt, Qe), null === Hd) throw getContext(rt) ? new Error("Error creating WebGL context with your selected attributes.") : new Error("Error creating WebGL context.");
                            }
                        } catch (Jd) {
                            throw console.error("THREE.WebGLRenderer: " + Jd.message), Jd;
                        }
                        function initGLContext() {
                            xd = new WebGLExtensions(Hd), xd.init(), Vd = new WebGLUtils(Hd, xd), bd = new WebGLCapabilities(Hd, xd, Qe, Vd), wd = new WebGLState(Hd, xd), bd.reverseDepthBuffer && Ql && wd.buffers.depth.setReversed(!0), Ed = new WebGLInfo(Hd), Md = new WebGLProperties, Sd = new WebGLTextures(Hd, xd, wd, Md, bd, Vd, Ed), Td = new WebGLCubeMaps(yu), Cd = new WebGLCubeUVMaps(yu), kd = new WebGLAttributes(Hd), Gd = new WebGLBindingStates(Hd, kd), Id = new WebGLGeometries(Hd, kd, Ed, Gd), Dd = new WebGLObjects(Hd, Id, kd, Ed), Fd = new WebGLMorphtargets(Hd, bd, Sd), Rd = new WebGLClipping(Md), Ld = new WebGLPrograms(yu, Td, Cd, xd, bd, Gd, Rd), Pd = new WebGLMaterials(yu, Md), zd = new WebGLRenderLists, Nd = new WebGLRenderStates(xd), Od = new WebGLBackground(yu, Td, Cd, wd, Dd, Kl, Gl), Bd = new WebGLShadowMap(yu, Dd, bd), Zd = new WebGLUniformsGroups(Hd, Ed, bd, wd), jd = new WebGLBufferRenderer(Hd, xd, Ed), Ud = new WebGLIndexedBufferRenderer(Hd, xd, Ed), Ed.programs = Ld.programs, yu.capabilities = bd, yu.extensions = xd, yu.properties = Md, yu.renderLists = zd, yu.shadowMap = Bd, yu.state = wd, yu.info = Ed;
                        }
                        initGLContext();
                        const Wd = new WebXRManager(yu, Hd);
                        function onContextLost(Qe) {
                            Qe.preventDefault(), console.log("THREE.WebGLRenderer: Context Lost."), Eu = !0;
                        }
                        function onContextRestore() {
                            console.log("THREE.WebGLRenderer: Context Restored."), Eu = !1;
                            const Qe = Ed.autoReset, rt = Bd.enabled, Wn = Bd.autoUpdate, Co = Bd.needsUpdate, Dl = Bd.type;
                            initGLContext(), Ed.autoReset = Qe, Bd.enabled = rt, Bd.autoUpdate = Wn, Bd.needsUpdate = Co, Bd.type = Dl;
                        }
                        function onContextCreationError(Qe) {
                            console.error("THREE.WebGLRenderer: A WebGL context could not be created. Reason: ", Qe.statusMessage);
                        }
                        function onMaterialDispose(Qe) {
                            const rt = Qe.target;
                            rt.removeEventListener("dispose", onMaterialDispose), function(Qe) {
                                (function(Qe) {
                                    const rt = Md.get(Qe).programs;
                                    void 0 !== rt && (rt.forEach(function(Qe) {
                                        Ld.releaseProgram(Qe);
                                    }), Qe.isShaderMaterial && Ld.releaseShaderCache(Qe));
                                })(Qe), Md.remove(Qe);
                            }(rt);
                        }
                        function prepareMaterial(Qe, rt, Wn) {
                            !0 === Qe.transparent && Qe.side === Co.$EB && !1 === Qe.forceSinglePass ? (Qe.side = Co.hsX, Qe.needsUpdate = !0, getProgram(Qe, rt, Wn), Qe.side = Co.hB5, Qe.needsUpdate = !0, getProgram(Qe, rt, Wn), Qe.side = Co.$EB) : getProgram(Qe, rt, Wn);
                        }
                        this.xr = Wd, this.getContext = function() {
                            return Hd;
                        }, this.getContextAttributes = function() {
                            return Hd.getContextAttributes();
                        }, this.forceContextLoss = function() {
                            const Qe = xd.get("WEBGL_lose_context");
                            Qe && Qe.loseContext();
                        }, this.forceContextRestore = function() {
                            const Qe = xd.get("WEBGL_lose_context");
                            Qe && Qe.restoreContext();
                        }, this.getPixelRatio = function() {
                            return ad;
                        }, this.setPixelRatio = function(Qe) {
                            void 0 !== Qe && (ad = Qe, this.setSize(rd, sd, !1));
                        }, this.getSize = function(Qe) {
                            return Qe.set(rd, sd);
                        }, this.setSize = function(Qe, Wn, Co) {
                            void 0 === Co && (Co = !0), Wd.isPresenting ? console.warn("THREE.WebGLRenderer: Can't change size while VR device is presenting.") : (rd = Qe, sd = Wn, rt.width = Math.floor(Qe * ad), rt.height = Math.floor(Wn * ad), !0 === Co && (rt.style.width = Qe + "px", rt.style.height = Wn + "px"), this.setViewport(0, 0, Qe, Wn));
                        }, this.getDrawingBufferSize = function(Qe) {
                            return Qe.set(rd * ad, sd * ad).floor();
                        }, this.setDrawingBufferSize = function(Qe, Wn, Co) {
                            rd = Qe, sd = Wn, ad = Co, rt.width = Math.floor(Qe * Co), rt.height = Math.floor(Wn * Co), this.setViewport(0, 0, Qe, Wn);
                        }, this.getCurrentViewport = function(Qe) {
                            return Qe.copy($u);
                        }, this.getViewport = function(Qe) {
                            return Qe.copy(cd);
                        }, this.setViewport = function(Qe, rt, Wn, Co) {
                            Qe.isVector4 ? cd.set(Qe.x, Qe.y, Qe.z, Qe.w) : cd.set(Qe, rt, Wn, Co), wd.viewport($u.copy(cd).multiplyScalar(ad).round());
                        }, this.getScissor = function(Qe) {
                            return Qe.copy(ud);
                        }, this.setScissor = function(Qe, rt, Wn, Co) {
                            Qe.isVector4 ? ud.set(Qe.x, Qe.y, Qe.z, Qe.w) : ud.set(Qe, rt, Wn, Co), wd.scissor(ed.copy(ud).multiplyScalar(ad).round());
                        }, this.getScissorTest = function() {
                            return hd;
                        }, this.setScissorTest = function(Qe) {
                            wd.setScissorTest(hd = Qe);
                        }, this.setOpaqueSort = function(Qe) {
                            od = Qe;
                        }, this.setTransparentSort = function(Qe) {
                            ld = Qe;
                        }, this.getClearColor = function(Qe) {
                            return Qe.copy(Od.getClearColor());
                        }, this.setClearColor = function() {
                            Od.setClearColor.apply(Od, arguments);
                        }, this.getClearAlpha = function() {
                            return Od.getClearAlpha();
                        }, this.setClearAlpha = function() {
                            Od.setClearAlpha.apply(Od, arguments);
                        }, this.clear = function(Qe, rt, Wn) {
                            void 0 === Qe && (Qe = !0), void 0 === rt && (rt = !0), void 0 === Wn && (Wn = !0);
                            let Dl = 0;
                            if (Qe) {
                                let Qe = !1;
                                if (null !== Zu) {
                                    const rt = Zu.texture.format;
                                    Qe = rt === Co.c90 || rt === Co.TkQ || rt === Co.ZQM;
                                }
                                if (Qe) {
                                    const Qe = Zu.texture.type, rt = Qe === Co.OUM || Qe === Co.bkx || Qe === Co.cHt || Qe === Co.V3x || Qe === Co.Wew || Qe === Co.gJ2, Wn = Od.getClearColor(), Dl = Od.getClearAlpha(), Ll = Wn.r, Rl = Wn.g, Ul = Wn.b;
                                    rt ? ($l[0] = Ll, $l[1] = Rl, $l[2] = Ul, $l[3] = Dl, Hd.clearBufferuiv(Hd.COLOR, 0, $l)) : (Tc[0] = Ll, Tc[1] = Rl, Tc[2] = Ul, Tc[3] = Dl, Hd.clearBufferiv(Hd.COLOR, 0, Tc));
                                } else Dl |= Hd.COLOR_BUFFER_BIT;
                            }
                            rt && (Dl |= Hd.DEPTH_BUFFER_BIT), Wn && (Dl |= Hd.STENCIL_BUFFER_BIT, this.state.buffers.stencil.setMask(4294967295)), Hd.clear(Dl);
                        }, this.clearColor = function() {
                            this.clear(!0, !1, !1);
                        }, this.clearDepth = function() {
                            this.clear(!1, !0, !1);
                        }, this.clearStencil = function() {
                            this.clear(!1, !1, !0);
                        }, this.dispose = function() {
                            rt.removeEventListener("webglcontextlost", onContextLost, !1), rt.removeEventListener("webglcontextrestored", onContextRestore, !1), rt.removeEventListener("webglcontextcreationerror", onContextCreationError, !1), Od.dispose(), zd.dispose(), Nd.dispose(), Md.dispose(), Td.dispose(), Cd.dispose(), Dd.dispose(), Gd.dispose(), Zd.dispose(), Ld.dispose(), Wd.dispose(), Wd.removeEventListener("sessionstart", onXRSessionStart), Wd.removeEventListener("sessionend", onXRSessionEnd), Yd.stop();
                        }, this.renderBufferDirect = function(Qe, rt, Wn, Dl, Ll, Rl) {
                            null === rt && (rt = vd);
                            const Ul = Ll.isMesh && Ll.matrixWorld.determinant() < 0, Gl = function(Qe, rt, Wn, Dl, Ll) {
                                !0 !== rt.isScene && (rt = vd);
                                Sd.resetTextureUnits();
                                const Rl = rt.fog, Ul = Dl.isMeshStandardMaterial ? rt.environment : null, Gl = null === Zu ? yu.outputColorSpace : !0 === Zu.isXRRenderTarget ? Zu.texture.colorSpace : Co.Zr2, Zl = (Dl.isMeshStandardMaterial ? Cd : Td).get(Dl.envMap || Ul), Hl = !0 === Dl.vertexColors && !!Wn.attributes.color && 4 === Wn.attributes.color.itemSize, ql = !!Wn.attributes.tangent && (!!Dl.normalMap || Dl.anisotropy > 0), Ql = !!Wn.morphAttributes.position, Kl = !!Wn.morphAttributes.normal, $l = !!Wn.morphAttributes.color;
                                let Tc = Co.y_p;
                                Dl.toneMapped && (null !== Zu && !0 !== Zu.isXRRenderTarget || (Tc = yu.toneMapping));
                                const tu = Wn.morphAttributes.position || Wn.morphAttributes.normal || Wn.morphAttributes.color, du = void 0 !== tu ? tu.length : 0, fu = Md.get(Dl), Eu = lu.state.lights;
                                if (!0 === pd && (!0 === md || Qe !== Ju)) {
                                    const rt = Qe === Ju && Dl.id === Xu;
                                    Rd.setState(Dl, Qe, rt);
                                }
                                let Tu = !1;
                                Dl.version === fu.__version ? fu.needsLights && fu.lightsStateVersion !== Eu.state.version || fu.outputColorSpace !== Gl || Ll.isBatchedMesh && !1 === fu.batching ? Tu = !0 : Ll.isBatchedMesh || !0 !== fu.batching ? Ll.isBatchedMesh && !0 === fu.batchingColor && null === Ll.colorTexture || Ll.isBatchedMesh && !1 === fu.batchingColor && null !== Ll.colorTexture || Ll.isInstancedMesh && !1 === fu.instancing ? Tu = !0 : Ll.isInstancedMesh || !0 !== fu.instancing ? Ll.isSkinnedMesh && !1 === fu.skinning ? Tu = !0 : Ll.isSkinnedMesh || !0 !== fu.skinning ? Ll.isInstancedMesh && !0 === fu.instancingColor && null === Ll.instanceColor || Ll.isInstancedMesh && !1 === fu.instancingColor && null !== Ll.instanceColor || Ll.isInstancedMesh && !0 === fu.instancingMorph && null === Ll.morphTexture || Ll.isInstancedMesh && !1 === fu.instancingMorph && null !== Ll.morphTexture || fu.envMap !== Zl || !0 === Dl.fog && fu.fog !== Rl ? Tu = !0 : void 0 === fu.numClippingPlanes || fu.numClippingPlanes === Rd.numPlanes && fu.numIntersection === Rd.numIntersection ? (fu.vertexAlphas !== Hl || fu.vertexTangents !== ql || fu.morphTargets !== Ql || fu.morphNormals !== Kl || fu.morphColors !== $l || fu.toneMapping !== Tc || fu.morphTargetsCount !== du) && (Tu = !0) : Tu = !0 : Tu = !0 : Tu = !0 : Tu = !0 : (Tu = !0, fu.__version = Dl.version);
                                let Lu = fu.currentProgram;
                                !0 === Tu && (Lu = getProgram(Dl, rt, Ll));
                                let $u = !1, ed = !1, td = !1;
                                const id = Lu.getUniforms(), nd = fu.uniforms;
                                wd.useProgram(Lu.program) && ($u = !0, ed = !0, td = !0);
                                Dl.id !== Xu && (Xu = Dl.id, ed = !0);
                                if ($u || Ju !== Qe) {
                                    wd.buffers.depth.getReversed() ? (fd.copy(Qe.projectionMatrix), (0, Co.xiE)(fd), (0, Co.Mmk)(fd), id.setValue(Hd, "projectionMatrix", fd)) : id.setValue(Hd, "projectionMatrix", Qe.projectionMatrix), id.setValue(Hd, "viewMatrix", Qe.matrixWorldInverse);
                                    const rt = id.map.cameraPosition;
                                    void 0 !== rt && rt.setValue(Hd, Ad.setFromMatrixPosition(Qe.matrixWorld)), bd.logarithmicDepthBuffer && id.setValue(Hd, "logDepthBufFC", 2 / (Math.log(Qe.far + 1) / Math.LN2)), (Dl.isMeshPhongMaterial || Dl.isMeshToonMaterial || Dl.isMeshLambertMaterial || Dl.isMeshBasicMaterial || Dl.isMeshStandardMaterial || Dl.isShaderMaterial) && id.setValue(Hd, "isOrthographic", !0 === Qe.isOrthographicCamera), Ju !== Qe && (Ju = Qe, ed = !0, td = !0);
                                }
                                if (Ll.isSkinnedMesh) {
                                    id.setOptional(Hd, Ll, "bindMatrix"), id.setOptional(Hd, Ll, "bindMatrixInverse");
                                    const Qe = Ll.skeleton;
                                    Qe && (null === Qe.boneTexture && Qe.computeBoneTexture(), id.setValue(Hd, "boneTexture", Qe.boneTexture, Sd));
                                }
                                Ll.isBatchedMesh && (id.setOptional(Hd, Ll, "batchingTexture"), id.setValue(Hd, "batchingTexture", Ll._matricesTexture, Sd), id.setOptional(Hd, Ll, "batchingIdTexture"), id.setValue(Hd, "batchingIdTexture", Ll._indirectTexture, Sd), id.setOptional(Hd, Ll, "batchingColorTexture"), null !== Ll._colorsTexture && id.setValue(Hd, "batchingColorTexture", Ll._colorsTexture, Sd));
                                const rd = Wn.morphAttributes;
                                void 0 === rd.position && void 0 === rd.normal && void 0 === rd.color || Fd.update(Ll, Wn, Lu);
                                (ed || fu.receiveShadow !== Ll.receiveShadow) && (fu.receiveShadow = Ll.receiveShadow, id.setValue(Hd, "receiveShadow", Ll.receiveShadow));
                                Dl.isMeshGouraudMaterial && null !== Dl.envMap && (nd.envMap.value = Zl, nd.flipEnvMap.value = Zl.isCubeTexture && !1 === Zl.isRenderTargetTexture ? -1 : 1);
                                Dl.isMeshStandardMaterial && null === Dl.envMap && null !== rt.environment && (nd.envMapIntensity.value = rt.environmentIntensity);
                                ed && (id.setValue(Hd, "toneMappingExposure", yu.toneMappingExposure), fu.needsLights && (ld = td, (od = nd).ambientLightColor.needsUpdate = ld, od.lightProbe.needsUpdate = ld, od.directionalLights.needsUpdate = ld, od.directionalLightShadows.needsUpdate = ld, od.pointLights.needsUpdate = ld, od.pointLightShadows.needsUpdate = ld, od.spotLights.needsUpdate = ld, od.spotLightShadows.needsUpdate = ld, od.rectAreaLights.needsUpdate = ld, od.hemisphereLights.needsUpdate = ld), Rl && !0 === Dl.fog && Pd.refreshFogUniforms(nd, Rl), Pd.refreshMaterialUniforms(nd, Dl, ad, sd, lu.state.transmissionRenderTarget[Qe.id]), WebGLUniforms.upload(Hd, getUniformList(fu), nd, Sd));
                                var od, ld;
                                Dl.isShaderMaterial && !0 === Dl.uniformsNeedUpdate && (WebGLUniforms.upload(Hd, getUniformList(fu), nd, Sd), Dl.uniformsNeedUpdate = !1);
                                Dl.isSpriteMaterial && id.setValue(Hd, "center", Ll.center);
                                if (id.setValue(Hd, "modelViewMatrix", Ll.modelViewMatrix), id.setValue(Hd, "normalMatrix", Ll.normalMatrix), id.setValue(Hd, "modelMatrix", Ll.matrixWorld), Dl.isShaderMaterial || Dl.isRawShaderMaterial) {
                                    const Qe = Dl.uniformsGroups;
                                    for(let rt = 0, Wn = Qe.length; rt < Wn; rt++){
                                        const Wn = Qe[rt];
                                        Zd.update(Wn, Lu), Zd.bind(Wn, Lu);
                                    }
                                }
                                return Lu;
                            }(Qe, rt, Wn, Dl, Ll);
                            wd.setMaterial(Dl, Ul);
                            let Zl = Wn.index, Hl = 1;
                            if (!0 === Dl.wireframe) {
                                if (Zl = Id.getWireframeAttribute(Wn), void 0 === Zl) return;
                                Hl = 2;
                            }
                            const ql = Wn.drawRange, Ql = Wn.attributes.position;
                            let Kl = ql.start * Hl, $l = (ql.start + ql.count) * Hl;
                            null !== Rl && (Kl = Math.max(Kl, Rl.start * Hl), $l = Math.min($l, (Rl.start + Rl.count) * Hl)), null !== Zl ? (Kl = Math.max(Kl, 0), $l = Math.min($l, Zl.count)) : void 0 !== Ql && null !== Ql && (Kl = Math.max(Kl, 0), $l = Math.min($l, Ql.count));
                            const Tc = $l - Kl;
                            if (Tc < 0 || Tc === 1 / 0) return;
                            let tu;
                            Gd.setup(Ll, Dl, Gl, Wn, Zl);
                            let du = jd;
                            if (null !== Zl && (tu = kd.get(Zl), du = Ud, du.setIndex(tu)), Ll.isMesh) !0 === Dl.wireframe ? (wd.setLineWidth(Dl.wireframeLinewidth * getTargetPixelRatio()), du.setMode(Hd.LINES)) : du.setMode(Hd.TRIANGLES);
                            else if (Ll.isLine) {
                                let Qe = Dl.linewidth;
                                void 0 === Qe && (Qe = 1), wd.setLineWidth(Qe * getTargetPixelRatio()), Ll.isLineSegments ? du.setMode(Hd.LINES) : Ll.isLineLoop ? du.setMode(Hd.LINE_LOOP) : du.setMode(Hd.LINE_STRIP);
                            } else Ll.isPoints ? du.setMode(Hd.POINTS) : Ll.isSprite && du.setMode(Hd.TRIANGLES);
                            if (Ll.isBatchedMesh) {
                                if (null !== Ll._multiDrawInstances) du.renderMultiDrawInstances(Ll._multiDrawStarts, Ll._multiDrawCounts, Ll._multiDrawCount, Ll._multiDrawInstances);
                                else if (xd.get("WEBGL_multi_draw")) du.renderMultiDraw(Ll._multiDrawStarts, Ll._multiDrawCounts, Ll._multiDrawCount);
                                else {
                                    const Qe = Ll._multiDrawStarts, rt = Ll._multiDrawCounts, Wn = Ll._multiDrawCount, Co = Zl ? kd.get(Zl).bytesPerElement : 1, Rl = Md.get(Dl).currentProgram.getUniforms();
                                    for(let Dl = 0; Dl < Wn; Dl++)Rl.setValue(Hd, "_gl_DrawID", Dl), du.render(Qe[Dl] / Co, rt[Dl]);
                                }
                            } else if (Ll.isInstancedMesh) du.renderInstances(Kl, Tc, Ll.count);
                            else if (Wn.isInstancedBufferGeometry) {
                                const Qe = void 0 !== Wn._maxInstanceCount ? Wn._maxInstanceCount : 1 / 0, rt = Math.min(Wn.instanceCount, Qe);
                                du.renderInstances(Kl, Tc, rt);
                            } else du.render(Kl, Tc);
                        }, this.compile = function(Qe, rt, Wn) {
                            void 0 === Wn && (Wn = null), null === Wn && (Wn = Qe), lu = Nd.get(Wn), lu.init(rt), fu.push(lu), Wn.traverseVisible(function(Qe) {
                                Qe.isLight && Qe.layers.test(rt.layers) && (lu.pushLight(Qe), Qe.castShadow && lu.pushShadow(Qe));
                            }), Qe !== Wn && Qe.traverseVisible(function(Qe) {
                                Qe.isLight && Qe.layers.test(rt.layers) && (lu.pushLight(Qe), Qe.castShadow && lu.pushShadow(Qe));
                            }), lu.setupLights();
                            const Co = new Set;
                            return Qe.traverse(function(Qe) {
                                if (!(Qe.isMesh || Qe.isPoints || Qe.isLine || Qe.isSprite)) return;
                                const rt = Qe.material;
                                if (rt) {
                                    if (Array.isArray(rt)) for(let Dl = 0; Dl < rt.length; Dl++){
                                        const Ll = rt[Dl];
                                        prepareMaterial(Ll, Wn, Qe), Co.add(Ll);
                                    }
                                    else prepareMaterial(rt, Wn, Qe), Co.add(rt);
                                }
                            }), fu.pop(), lu = null, Co;
                        }, this.compileAsync = function(Qe, rt, Wn) {
                            void 0 === Wn && (Wn = null);
                            const Co = this.compile(Qe, rt, Wn);
                            return new Promise((rt)=>{
                                function checkMaterialsReady() {
                                    Co.forEach(function(Qe) {
                                        Md.get(Qe).currentProgram.isReady() && Co.delete(Qe);
                                    }), 0 !== Co.size ? setTimeout(checkMaterialsReady, 10) : rt(Qe);
                                }
                                null !== xd.get("KHR_parallel_shader_compile") ? checkMaterialsReady() : setTimeout(checkMaterialsReady, 10);
                            });
                        };
                        let qd = null;
                        function onXRSessionStart() {
                            Yd.stop();
                        }
                        function onXRSessionEnd() {
                            Yd.start();
                        }
                        const Yd = new WebGLAnimation;
                        function projectObject(Qe, rt, Wn, Co) {
                            if (!1 === Qe.visible) return;
                            if (Qe.layers.test(rt.layers)) {
                                if (Qe.isGroup) Wn = Qe.renderOrder;
                                else if (Qe.isLOD) !0 === Qe.autoUpdate && Qe.update(rt);
                                else if (Qe.isLight) lu.pushLight(Qe), Qe.castShadow && lu.pushShadow(Qe);
                                else if (Qe.isSprite) {
                                    if (!Qe.frustumCulled || dd.intersectsSprite(Qe)) {
                                        Co && yd.setFromMatrixPosition(Qe.matrixWorld).applyMatrix4(gd);
                                        const rt = Dd.update(Qe), Dl = Qe.material;
                                        Dl.visible && tu.push(Qe, rt, Dl, Wn, yd.z, null);
                                    }
                                } else if ((Qe.isMesh || Qe.isLine || Qe.isPoints) && (!Qe.frustumCulled || dd.intersectsObject(Qe))) {
                                    const rt = Dd.update(Qe), Dl = Qe.material;
                                    if (Co && (void 0 !== Qe.boundingSphere ? (null === Qe.boundingSphere && Qe.computeBoundingSphere(), yd.copy(Qe.boundingSphere.center)) : (null === rt.boundingSphere && rt.computeBoundingSphere(), yd.copy(rt.boundingSphere.center)), yd.applyMatrix4(Qe.matrixWorld).applyMatrix4(gd)), Array.isArray(Dl)) {
                                        const Co = rt.groups;
                                        for(let Ll = 0, Rl = Co.length; Ll < Rl; Ll++){
                                            const Rl = Co[Ll], Ul = Dl[Rl.materialIndex];
                                            Ul && Ul.visible && tu.push(Qe, rt, Ul, Wn, yd.z, Rl);
                                        }
                                    } else Dl.visible && tu.push(Qe, rt, Dl, Wn, yd.z, null);
                                }
                            }
                            const Dl = Qe.children;
                            for(let Ll = 0, Rl = Dl.length; Ll < Rl; Ll++)projectObject(Dl[Ll], rt, Wn, Co);
                        }
                        function renderScene(Qe, rt, Wn, Co) {
                            const Dl = Qe.opaque, Ll = Qe.transmissive, Rl = Qe.transparent;
                            lu.setupLightsView(Wn), !0 === pd && Rd.setGlobalState(yu.clippingPlanes, Wn), Co && wd.viewport($u.copy(Co)), Dl.length > 0 && renderObjects(Dl, rt, Wn), Ll.length > 0 && renderObjects(Ll, rt, Wn), Rl.length > 0 && renderObjects(Rl, rt, Wn), wd.buffers.depth.setTest(!0), wd.buffers.depth.setMask(!0), wd.buffers.color.setMask(!0), wd.setPolygonOffset(!1);
                        }
                        function renderTransmissionPass(Qe, rt, Wn, Dl) {
                            if (null !== (!0 === Wn.isScene ? Wn.overrideMaterial : null)) return;
                            void 0 === lu.state.transmissionRenderTarget[Dl.id] && (lu.state.transmissionRenderTarget[Dl.id] = new Co.nWS(1, 1, {
                                generateMipmaps: !0,
                                type: xd.has("EXT_color_buffer_half_float") || xd.has("EXT_color_buffer_float") ? Co.ix0 : Co.OUM,
                                minFilter: Co.$_I,
                                samples: 4,
                                stencilBuffer: Ll,
                                resolveDepthBuffer: !1,
                                resolveStencilBuffer: !1,
                                colorSpace: Co.ppV.workingColorSpace
                            }));
                            const Rl = lu.state.transmissionRenderTarget[Dl.id], Ul = Dl.viewport || $u;
                            Rl.setSize(Ul.z * yu.transmissionResolutionScale, Ul.w * yu.transmissionResolutionScale);
                            const Gl = yu.getRenderTarget();
                            yu.setRenderTarget(Rl), yu.getClearColor(id), nd = yu.getClearAlpha(), nd < 1 && yu.setClearColor(16777215, .5), yu.clear(), _d && Od.render(Wn);
                            const Zl = yu.toneMapping;
                            yu.toneMapping = Co.y_p;
                            const Hl = Dl.viewport;
                            if (void 0 !== Dl.viewport && (Dl.viewport = void 0), lu.setupLightsView(Dl), !0 === pd && Rd.setGlobalState(yu.clippingPlanes, Dl), renderObjects(Qe, Wn, Dl), Sd.updateMultisampleRenderTarget(Rl), Sd.updateRenderTargetMipmap(Rl), !1 === xd.has("WEBGL_multisampled_render_to_texture")) {
                                let Qe = !1;
                                for(let Ll = 0, Rl = rt.length; Ll < Rl; Ll++){
                                    const Rl = rt[Ll], Ul = Rl.object, Gl = Rl.geometry, Zl = Rl.material, Hl = Rl.group;
                                    if (Zl.side === Co.$EB && Ul.layers.test(Dl.layers)) {
                                        const rt = Zl.side;
                                        Zl.side = Co.hsX, Zl.needsUpdate = !0, renderObject(Ul, Wn, Dl, Gl, Zl, Hl), Zl.side = rt, Zl.needsUpdate = !0, Qe = !0;
                                    }
                                }
                                !0 === Qe && (Sd.updateMultisampleRenderTarget(Rl), Sd.updateRenderTargetMipmap(Rl));
                            }
                            yu.setRenderTarget(Gl), yu.setClearColor(id, nd), void 0 !== Hl && (Dl.viewport = Hl), yu.toneMapping = Zl;
                        }
                        function renderObjects(Qe, rt, Wn) {
                            const Co = !0 === rt.isScene ? rt.overrideMaterial : null;
                            for(let Dl = 0, Ll = Qe.length; Dl < Ll; Dl++){
                                const Ll = Qe[Dl], Rl = Ll.object, Ul = Ll.geometry, Gl = null === Co ? Ll.material : Co, Zl = Ll.group;
                                Rl.layers.test(Wn.layers) && renderObject(Rl, rt, Wn, Ul, Gl, Zl);
                            }
                        }
                        function renderObject(Qe, rt, Wn, Dl, Ll, Rl) {
                            Qe.onBeforeRender(yu, rt, Wn, Dl, Ll, Rl), Qe.modelViewMatrix.multiplyMatrices(Wn.matrixWorldInverse, Qe.matrixWorld), Qe.normalMatrix.getNormalMatrix(Qe.modelViewMatrix), Ll.onBeforeRender(yu, rt, Wn, Dl, Qe, Rl), !0 === Ll.transparent && Ll.side === Co.$EB && !1 === Ll.forceSinglePass ? (Ll.side = Co.hsX, Ll.needsUpdate = !0, yu.renderBufferDirect(Wn, rt, Dl, Ll, Qe, Rl), Ll.side = Co.hB5, Ll.needsUpdate = !0, yu.renderBufferDirect(Wn, rt, Dl, Ll, Qe, Rl), Ll.side = Co.$EB) : yu.renderBufferDirect(Wn, rt, Dl, Ll, Qe, Rl), Qe.onAfterRender(yu, rt, Wn, Dl, Ll, Rl);
                        }
                        function getProgram(Qe, rt, Wn) {
                            !0 !== rt.isScene && (rt = vd);
                            const Co = Md.get(Qe), Dl = lu.state.lights, Ll = lu.state.shadowsArray, Rl = Dl.state.version, Ul = Ld.getParameters(Qe, Dl.state, Ll, rt, Wn), Gl = Ld.getProgramCacheKey(Ul);
                            let Zl = Co.programs;
                            Co.environment = Qe.isMeshStandardMaterial ? rt.environment : null, Co.fog = rt.fog, Co.envMap = (Qe.isMeshStandardMaterial ? Cd : Td).get(Qe.envMap || Co.environment), Co.envMapRotation = null !== Co.environment && null === Qe.envMap ? rt.environmentRotation : Qe.envMapRotation, void 0 === Zl && (Qe.addEventListener("dispose", onMaterialDispose), Zl = new Map, Co.programs = Zl);
                            let Hl = Zl.get(Gl);
                            if (void 0 !== Hl) {
                                if (Co.currentProgram === Hl && Co.lightsStateVersion === Rl) return updateCommonMaterialProperties(Qe, Ul), Hl;
                            } else Ul.uniforms = Ld.getUniforms(Qe), Qe.onBeforeCompile(Ul, yu), Hl = Ld.acquireProgram(Ul, Gl), Zl.set(Gl, Hl), Co.uniforms = Ul.uniforms;
                            const ql = Co.uniforms;
                            return (Qe.isShaderMaterial || Qe.isRawShaderMaterial) && !0 !== Qe.clipping || (ql.clippingPlanes = Rd.uniform), updateCommonMaterialProperties(Qe, Ul), Co.needsLights = function(Qe) {
                                return Qe.isMeshLambertMaterial || Qe.isMeshToonMaterial || Qe.isMeshPhongMaterial || Qe.isMeshStandardMaterial || Qe.isShadowMaterial || Qe.isShaderMaterial && !0 === Qe.lights;
                            }(Qe), Co.lightsStateVersion = Rl, Co.needsLights && (ql.ambientLightColor.value = Dl.state.ambient, ql.lightProbe.value = Dl.state.probe, ql.directionalLights.value = Dl.state.directional, ql.directionalLightShadows.value = Dl.state.directionalShadow, ql.spotLights.value = Dl.state.spot, ql.spotLightShadows.value = Dl.state.spotShadow, ql.rectAreaLights.value = Dl.state.rectArea, ql.ltc_1.value = Dl.state.rectAreaLTC1, ql.ltc_2.value = Dl.state.rectAreaLTC2, ql.pointLights.value = Dl.state.point, ql.pointLightShadows.value = Dl.state.pointShadow, ql.hemisphereLights.value = Dl.state.hemi, ql.directionalShadowMap.value = Dl.state.directionalShadowMap, ql.directionalShadowMatrix.value = Dl.state.directionalShadowMatrix, ql.spotShadowMap.value = Dl.state.spotShadowMap, ql.spotLightMatrix.value = Dl.state.spotLightMatrix, ql.spotLightMap.value = Dl.state.spotLightMap, ql.pointShadowMap.value = Dl.state.pointShadowMap, ql.pointShadowMatrix.value = Dl.state.pointShadowMatrix), Co.currentProgram = Hl, Co.uniformsList = null, Hl;
                        }
                        function getUniformList(Qe) {
                            if (null === Qe.uniformsList) {
                                const rt = Qe.currentProgram.getUniforms();
                                Qe.uniformsList = WebGLUniforms.seqWithValue(rt.seq, Qe.uniforms);
                            }
                            return Qe.uniformsList;
                        }
                        function updateCommonMaterialProperties(Qe, rt) {
                            const Wn = Md.get(Qe);
                            Wn.outputColorSpace = rt.outputColorSpace, Wn.batching = rt.batching, Wn.batchingColor = rt.batchingColor, Wn.instancing = rt.instancing, Wn.instancingColor = rt.instancingColor, Wn.instancingMorph = rt.instancingMorph, Wn.skinning = rt.skinning, Wn.morphTargets = rt.morphTargets, Wn.morphNormals = rt.morphNormals, Wn.morphColors = rt.morphColors, Wn.morphTargetsCount = rt.morphTargetsCount, Wn.numClippingPlanes = rt.numClippingPlanes, Wn.numIntersection = rt.numClipIntersection, Wn.vertexAlphas = rt.vertexAlphas, Wn.vertexTangents = rt.vertexTangents, Wn.toneMapping = rt.toneMapping;
                        }
                        Yd.setAnimationLoop(function(Qe) {
                            qd && qd(Qe);
                        }), "undefined" !== typeof self && Yd.setContext(self), this.setAnimationLoop = function(Qe) {
                            qd = Qe, Wd.setAnimationLoop(Qe), null === Qe ? Yd.stop() : Yd.start();
                        }, Wd.addEventListener("sessionstart", onXRSessionStart), Wd.addEventListener("sessionend", onXRSessionEnd), this.render = function(Qe, rt) {
                            if (void 0 !== rt && !0 !== rt.isCamera) return void console.error("THREE.WebGLRenderer.render: camera is not an instance of THREE.Camera.");
                            if (!0 === Eu) return;
                            if (!0 === Qe.matrixWorldAutoUpdate && Qe.updateMatrixWorld(), null === rt.parent && !0 === rt.matrixWorldAutoUpdate && rt.updateMatrixWorld(), !0 === Wd.enabled && !0 === Wd.isPresenting && (!0 === Wd.cameraAutoUpdate && Wd.updateCamera(rt), rt = Wd.getCamera()), !0 === Qe.isScene && Qe.onBeforeRender(yu, Qe, rt, Zu), lu = Nd.get(Qe, fu.length), lu.init(rt), fu.push(lu), gd.multiplyMatrices(rt.projectionMatrix, rt.matrixWorldInverse), dd.setFromProjectionMatrix(gd), md = this.localClippingEnabled, pd = Rd.init(this.clippingPlanes, md), tu = zd.get(Qe, du.length), tu.init(), du.push(tu), !0 === Wd.enabled && !0 === Wd.isPresenting) {
                                const Qe = yu.xr.getDepthSensingMesh();
                                null !== Qe && projectObject(Qe, rt, -1 / 0, yu.sortObjects);
                            }
                            projectObject(Qe, rt, 0, yu.sortObjects), tu.finish(), !0 === yu.sortObjects && tu.sort(od, ld), _d = !1 === Wd.enabled || !1 === Wd.isPresenting || !1 === Wd.hasDepthSensing(), _d && Od.addToRenderList(tu, Qe), this.info.render.frame++, !0 === pd && Rd.beginShadows();
                            const Wn = lu.state.shadowsArray;
                            Bd.render(Wn, Qe, rt), !0 === pd && Rd.endShadows(), !0 === this.info.autoReset && this.info.reset();
                            const Co = tu.opaque, Dl = tu.transmissive;
                            if (lu.setupLights(), rt.isArrayCamera) {
                                const Wn = rt.cameras;
                                if (Dl.length > 0) for(let rt = 0, Ll = Wn.length; rt < Ll; rt++)renderTransmissionPass(Co, Dl, Qe, Wn[rt]);
                                _d && Od.render(Qe);
                                for(let rt = 0, Co = Wn.length; rt < Co; rt++){
                                    const Co = Wn[rt];
                                    renderScene(tu, Qe, Co, Co.viewport);
                                }
                            } else Dl.length > 0 && renderTransmissionPass(Co, Dl, Qe, rt), _d && Od.render(Qe), renderScene(tu, Qe, rt);
                            null !== Zu && 0 === Lu && (Sd.updateMultisampleRenderTarget(Zu), Sd.updateRenderTargetMipmap(Zu)), !0 === Qe.isScene && Qe.onAfterRender(yu, Qe, rt), Gd.resetDefaultState(), Xu = -1, Ju = null, fu.pop(), fu.length > 0 ? (lu = fu[fu.length - 1], !0 === pd && Rd.setGlobalState(yu.clippingPlanes, lu.state.camera)) : lu = null, du.pop(), tu = du.length > 0 ? du[du.length - 1] : null;
                        }, this.getActiveCubeFace = function() {
                            return Tu;
                        }, this.getActiveMipmapLevel = function() {
                            return Lu;
                        }, this.getRenderTarget = function() {
                            return Zu;
                        }, this.setRenderTargetTextures = function(Qe, rt, Wn) {
                            Md.get(Qe.texture).__webglTexture = rt, Md.get(Qe.depthTexture).__webglTexture = Wn;
                            const Co = Md.get(Qe);
                            Co.__hasExternalTextures = !0, Co.__autoAllocateDepthBuffer = void 0 === Wn, Co.__autoAllocateDepthBuffer || !0 === xd.has("WEBGL_multisampled_render_to_texture") && (console.warn("THREE.WebGLRenderer: Render-to-texture extension was disabled because an external texture was provided"), Co.__useRenderToTexture = !1);
                        }, this.setRenderTargetFramebuffer = function(Qe, rt) {
                            const Wn = Md.get(Qe);
                            Wn.__webglFramebuffer = rt, Wn.__useDefaultFramebuffer = void 0 === rt;
                        };
                        const Qd = Hd.createFramebuffer();
                        this.setRenderTarget = function(Qe, rt, Wn) {
                            void 0 === rt && (rt = 0), void 0 === Wn && (Wn = 0), Zu = Qe, Tu = rt, Lu = Wn;
                            let Co = !0, Dl = null, Ll = !1, Rl = !1;
                            if (Qe) {
                                const Ul = Md.get(Qe);
                                if (void 0 !== Ul.__useDefaultFramebuffer) wd.bindFramebuffer(Hd.FRAMEBUFFER, null), Co = !1;
                                else if (void 0 === Ul.__webglFramebuffer) Sd.setupRenderTarget(Qe);
                                else if (Ul.__hasExternalTextures) Sd.rebindTextures(Qe, Md.get(Qe.texture).__webglTexture, Md.get(Qe.depthTexture).__webglTexture);
                                else if (Qe.depthBuffer) {
                                    const rt = Qe.depthTexture;
                                    if (Ul.__boundDepthTexture !== rt) {
                                        if (null !== rt && Md.has(rt) && (Qe.width !== rt.image.width || Qe.height !== rt.image.height)) throw new Error("WebGLRenderTarget: Attached DepthTexture is initialized to the incorrect size.");
                                        Sd.setupDepthRenderbuffer(Qe);
                                    }
                                }
                                const Gl = Qe.texture;
                                (Gl.isData3DTexture || Gl.isDataArrayTexture || Gl.isCompressedArrayTexture) && (Rl = !0);
                                const Zl = Md.get(Qe).__webglFramebuffer;
                                Qe.isWebGLCubeRenderTarget ? (Dl = Array.isArray(Zl[rt]) ? Zl[rt][Wn] : Zl[rt], Ll = !0) : Dl = Qe.samples > 0 && !1 === Sd.useMultisampledRTT(Qe) ? Md.get(Qe).__webglMultisampledFramebuffer : Array.isArray(Zl) ? Zl[Wn] : Zl, $u.copy(Qe.viewport), ed.copy(Qe.scissor), td = Qe.scissorTest;
                            } else $u.copy(cd).multiplyScalar(ad).floor(), ed.copy(ud).multiplyScalar(ad).floor(), td = hd;
                            0 !== Wn && (Dl = Qd);
                            if (wd.bindFramebuffer(Hd.FRAMEBUFFER, Dl) && Co && wd.drawBuffers(Qe, Dl), wd.viewport($u), wd.scissor(ed), wd.setScissorTest(td), Ll) {
                                const Co = Md.get(Qe.texture);
                                Hd.framebufferTexture2D(Hd.FRAMEBUFFER, Hd.COLOR_ATTACHMENT0, Hd.TEXTURE_CUBE_MAP_POSITIVE_X + rt, Co.__webglTexture, Wn);
                            } else if (Rl) {
                                const Co = Md.get(Qe.texture), Dl = rt;
                                Hd.framebufferTextureLayer(Hd.FRAMEBUFFER, Hd.COLOR_ATTACHMENT0, Co.__webglTexture, Wn, Dl);
                            } else if (null !== Qe && 0 !== Wn) {
                                const rt = Md.get(Qe.texture);
                                Hd.framebufferTexture2D(Hd.FRAMEBUFFER, Hd.COLOR_ATTACHMENT0, Hd.TEXTURE_2D, rt.__webglTexture, Wn);
                            }
                            Xu = -1;
                        }, this.readRenderTargetPixels = function(Qe, rt, Wn, Co, Dl, Ll, Rl) {
                            if (!Qe || !Qe.isWebGLRenderTarget) return void console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.");
                            let Ul = Md.get(Qe).__webglFramebuffer;
                            if (Qe.isWebGLCubeRenderTarget && void 0 !== Rl && (Ul = Ul[Rl]), Ul) {
                                wd.bindFramebuffer(Hd.FRAMEBUFFER, Ul);
                                try {
                                    const Rl = Qe.texture, Ul = Rl.format, Gl = Rl.type;
                                    if (!bd.textureFormatReadable(Ul)) return void console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.");
                                    if (!bd.textureTypeReadable(Gl)) return void console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.");
                                    rt >= 0 && rt <= Qe.width - Co && Wn >= 0 && Wn <= Qe.height - Dl && Hd.readPixels(rt, Wn, Co, Dl, Vd.convert(Ul), Vd.convert(Gl), Ll);
                                } finally{
                                    const Qe = null !== Zu ? Md.get(Zu).__webglFramebuffer : null;
                                    wd.bindFramebuffer(Hd.FRAMEBUFFER, Qe);
                                }
                            }
                        }, this.readRenderTargetPixelsAsync = async function(Qe, rt, Wn, Dl, Ll, Rl, Ul) {
                            if (!Qe || !Qe.isWebGLRenderTarget) throw new Error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.");
                            let Gl = Md.get(Qe).__webglFramebuffer;
                            if (Qe.isWebGLCubeRenderTarget && void 0 !== Ul && (Gl = Gl[Ul]), Gl) {
                                const Ul = Qe.texture, Zl = Ul.format, Hl = Ul.type;
                                if (!bd.textureFormatReadable(Zl)) throw new Error("THREE.WebGLRenderer.readRenderTargetPixelsAsync: renderTarget is not in RGBA or implementation defined format.");
                                if (!bd.textureTypeReadable(Hl)) throw new Error("THREE.WebGLRenderer.readRenderTargetPixelsAsync: renderTarget is not in UnsignedByteType or implementation defined type.");
                                if (rt >= 0 && rt <= Qe.width - Dl && Wn >= 0 && Wn <= Qe.height - Ll) {
                                    wd.bindFramebuffer(Hd.FRAMEBUFFER, Gl);
                                    const Qe = Hd.createBuffer();
                                    Hd.bindBuffer(Hd.PIXEL_PACK_BUFFER, Qe), Hd.bufferData(Hd.PIXEL_PACK_BUFFER, Rl.byteLength, Hd.STREAM_READ), Hd.readPixels(rt, Wn, Dl, Ll, Vd.convert(Zl), Vd.convert(Hl), 0);
                                    const Ul = null !== Zu ? Md.get(Zu).__webglFramebuffer : null;
                                    wd.bindFramebuffer(Hd.FRAMEBUFFER, Ul);
                                    const ql = Hd.fenceSync(Hd.SYNC_GPU_COMMANDS_COMPLETE, 0);
                                    return Hd.flush(), await (0, Co.jej)(Hd, ql, 4), Hd.bindBuffer(Hd.PIXEL_PACK_BUFFER, Qe), Hd.getBufferSubData(Hd.PIXEL_PACK_BUFFER, 0, Rl), Hd.deleteBuffer(Qe), Hd.deleteSync(ql), Rl;
                                }
                                throw new Error("THREE.WebGLRenderer.readRenderTargetPixelsAsync: requested read bounds are out of range.");
                            }
                        }, this.copyFramebufferToTexture = function(Qe, rt, Wn) {
                            void 0 === rt && (rt = null), void 0 === Wn && (Wn = 0), !0 !== Qe.isTexture && ((0, Co.mcG)("WebGLRenderer: copyFramebufferToTexture function signature has changed."), rt = arguments[0] || null, Qe = arguments[1]);
                            const Dl = Math.pow(2, -Wn), Ll = Math.floor(Qe.image.width * Dl), Rl = Math.floor(Qe.image.height * Dl), Ul = null !== rt ? rt.x : 0, Gl = null !== rt ? rt.y : 0;
                            Sd.setTexture2D(Qe, 0), Hd.copyTexSubImage2D(Hd.TEXTURE_2D, Wn, 0, 0, Ul, Gl, Ll, Rl), wd.unbindTexture();
                        };
                        const Kd = Hd.createFramebuffer(), Xd = Hd.createFramebuffer();
                        this.copyTextureToTexture = function(Qe, rt, Wn, Dl, Ll, Rl) {
                            let Ul, Gl, Zl, Hl, ql, Ql, Kl, $l, Tc;
                            void 0 === Wn && (Wn = null), void 0 === Dl && (Dl = null), void 0 === Ll && (Ll = 0), void 0 === Rl && (Rl = null), !0 !== Qe.isTexture && ((0, Co.mcG)("WebGLRenderer: copyTextureToTexture function signature has changed."), Dl = arguments[0] || null, Qe = arguments[1], rt = arguments[2], Rl = arguments[3] || 0, Wn = null), null === Rl && (0 !== Ll ? ((0, Co.mcG)("WebGLRenderer: copyTextureToTexture function signature has changed to support src and dst mipmap levels."), Rl = Ll, Ll = 0) : Rl = 0);
                            const tu = Qe.isCompressedTexture ? Qe.mipmaps[Rl] : Qe.image;
                            if (null !== Wn) Ul = Wn.max.x - Wn.min.x, Gl = Wn.max.y - Wn.min.y, Zl = Wn.isBox3 ? Wn.max.z - Wn.min.z : 1, Hl = Wn.min.x, ql = Wn.min.y, Ql = Wn.isBox3 ? Wn.min.z : 0;
                            else {
                                const rt = Math.pow(2, -Ll);
                                Ul = Math.floor(tu.width * rt), Gl = Math.floor(tu.height * rt), Zl = Qe.isDataArrayTexture ? tu.depth : Qe.isData3DTexture ? Math.floor(tu.depth * rt) : 1, Hl = 0, ql = 0, Ql = 0;
                            }
                            null !== Dl ? (Kl = Dl.x, $l = Dl.y, Tc = Dl.z) : (Kl = 0, $l = 0, Tc = 0);
                            const lu = Vd.convert(rt.format), du = Vd.convert(rt.type);
                            let fu;
                            rt.isData3DTexture ? (Sd.setTexture3D(rt, 0), fu = Hd.TEXTURE_3D) : rt.isDataArrayTexture || rt.isCompressedArrayTexture ? (Sd.setTexture2DArray(rt, 0), fu = Hd.TEXTURE_2D_ARRAY) : (Sd.setTexture2D(rt, 0), fu = Hd.TEXTURE_2D), Hd.pixelStorei(Hd.UNPACK_FLIP_Y_WEBGL, rt.flipY), Hd.pixelStorei(Hd.UNPACK_PREMULTIPLY_ALPHA_WEBGL, rt.premultiplyAlpha), Hd.pixelStorei(Hd.UNPACK_ALIGNMENT, rt.unpackAlignment);
                            const yu = Hd.getParameter(Hd.UNPACK_ROW_LENGTH), Eu = Hd.getParameter(Hd.UNPACK_IMAGE_HEIGHT), Tu = Hd.getParameter(Hd.UNPACK_SKIP_PIXELS), Lu = Hd.getParameter(Hd.UNPACK_SKIP_ROWS), Zu = Hd.getParameter(Hd.UNPACK_SKIP_IMAGES);
                            Hd.pixelStorei(Hd.UNPACK_ROW_LENGTH, tu.width), Hd.pixelStorei(Hd.UNPACK_IMAGE_HEIGHT, tu.height), Hd.pixelStorei(Hd.UNPACK_SKIP_PIXELS, Hl), Hd.pixelStorei(Hd.UNPACK_SKIP_ROWS, ql), Hd.pixelStorei(Hd.UNPACK_SKIP_IMAGES, Ql);
                            const Xu = Qe.isDataArrayTexture || Qe.isData3DTexture, Ju = rt.isDataArrayTexture || rt.isData3DTexture;
                            if (Qe.isDepthTexture) {
                                const Wn = Md.get(Qe), Co = Md.get(rt), Dl = Md.get(Wn.__renderTarget), tu = Md.get(Co.__renderTarget);
                                wd.bindFramebuffer(Hd.READ_FRAMEBUFFER, Dl.__webglFramebuffer), wd.bindFramebuffer(Hd.DRAW_FRAMEBUFFER, tu.__webglFramebuffer);
                                for(let lu = 0; lu < Zl; lu++)Xu && (Hd.framebufferTextureLayer(Hd.READ_FRAMEBUFFER, Hd.COLOR_ATTACHMENT0, Md.get(Qe).__webglTexture, Ll, Ql + lu), Hd.framebufferTextureLayer(Hd.DRAW_FRAMEBUFFER, Hd.COLOR_ATTACHMENT0, Md.get(rt).__webglTexture, Rl, Tc + lu)), Hd.blitFramebuffer(Hl, ql, Ul, Gl, Kl, $l, Ul, Gl, Hd.DEPTH_BUFFER_BIT, Hd.NEAREST);
                                wd.bindFramebuffer(Hd.READ_FRAMEBUFFER, null), wd.bindFramebuffer(Hd.DRAW_FRAMEBUFFER, null);
                            } else if (0 !== Ll || Qe.isRenderTargetTexture || Md.has(Qe)) {
                                const Wn = Md.get(Qe), Co = Md.get(rt);
                                wd.bindFramebuffer(Hd.READ_FRAMEBUFFER, Kd), wd.bindFramebuffer(Hd.DRAW_FRAMEBUFFER, Xd);
                                for(let Qe = 0; Qe < Zl; Qe++)Xu ? Hd.framebufferTextureLayer(Hd.READ_FRAMEBUFFER, Hd.COLOR_ATTACHMENT0, Wn.__webglTexture, Ll, Ql + Qe) : Hd.framebufferTexture2D(Hd.READ_FRAMEBUFFER, Hd.COLOR_ATTACHMENT0, Hd.TEXTURE_2D, Wn.__webglTexture, Ll), Ju ? Hd.framebufferTextureLayer(Hd.DRAW_FRAMEBUFFER, Hd.COLOR_ATTACHMENT0, Co.__webglTexture, Rl, Tc + Qe) : Hd.framebufferTexture2D(Hd.DRAW_FRAMEBUFFER, Hd.COLOR_ATTACHMENT0, Hd.TEXTURE_2D, Co.__webglTexture, Rl), 0 !== Ll ? Hd.blitFramebuffer(Hl, ql, Ul, Gl, Kl, $l, Ul, Gl, Hd.COLOR_BUFFER_BIT, Hd.NEAREST) : Ju ? Hd.copyTexSubImage3D(fu, Rl, Kl, $l, Tc + Qe, Hl, ql, Ul, Gl) : Hd.copyTexSubImage2D(fu, Rl, Kl, $l, Hl, ql, Ul, Gl);
                                wd.bindFramebuffer(Hd.READ_FRAMEBUFFER, null), wd.bindFramebuffer(Hd.DRAW_FRAMEBUFFER, null);
                            } else Ju ? Qe.isDataTexture || Qe.isData3DTexture ? Hd.texSubImage3D(fu, Rl, Kl, $l, Tc, Ul, Gl, Zl, lu, du, tu.data) : rt.isCompressedArrayTexture ? Hd.compressedTexSubImage3D(fu, Rl, Kl, $l, Tc, Ul, Gl, Zl, lu, tu.data) : Hd.texSubImage3D(fu, Rl, Kl, $l, Tc, Ul, Gl, Zl, lu, du, tu) : Qe.isDataTexture ? Hd.texSubImage2D(Hd.TEXTURE_2D, Rl, Kl, $l, Ul, Gl, lu, du, tu.data) : Qe.isCompressedTexture ? Hd.compressedTexSubImage2D(Hd.TEXTURE_2D, Rl, Kl, $l, tu.width, tu.height, lu, tu.data) : Hd.texSubImage2D(Hd.TEXTURE_2D, Rl, Kl, $l, Ul, Gl, lu, du, tu);
                            Hd.pixelStorei(Hd.UNPACK_ROW_LENGTH, yu), Hd.pixelStorei(Hd.UNPACK_IMAGE_HEIGHT, Eu), Hd.pixelStorei(Hd.UNPACK_SKIP_PIXELS, Tu), Hd.pixelStorei(Hd.UNPACK_SKIP_ROWS, Lu), Hd.pixelStorei(Hd.UNPACK_SKIP_IMAGES, Zu), 0 === Rl && rt.generateMipmaps && Hd.generateMipmap(fu), wd.unbindTexture();
                        }, this.copyTextureToTexture3D = function(Qe, rt, Wn, Dl, Ll) {
                            return void 0 === Wn && (Wn = null), void 0 === Dl && (Dl = null), void 0 === Ll && (Ll = 0), !0 !== Qe.isTexture && ((0, Co.mcG)("WebGLRenderer: copyTextureToTexture3D function signature has changed."), Wn = arguments[0] || null, Dl = arguments[1] || null, Qe = arguments[2], rt = arguments[3], Ll = arguments[4] || 0), (0, Co.mcG)('WebGLRenderer: copyTextureToTexture3D function has been deprecated. Use "copyTextureToTexture" instead.'), this.copyTextureToTexture(Qe, rt, Wn, Dl, Ll);
                        }, this.initRenderTarget = function(Qe) {
                            void 0 === Md.get(Qe).__webglFramebuffer && Sd.setupRenderTarget(Qe);
                        }, this.initTexture = function(Qe) {
                            Qe.isCubeTexture ? Sd.setTextureCube(Qe, 0) : Qe.isData3DTexture ? Sd.setTexture3D(Qe, 0) : Qe.isDataArrayTexture || Qe.isCompressedArrayTexture ? Sd.setTexture2DArray(Qe, 0) : Sd.setTexture2D(Qe, 0), wd.unbindTexture();
                        }, this.resetState = function() {
                            Tu = 0, Lu = 0, Zu = null, wd.reset(), Gd.reset();
                        }, "undefined" !== typeof __THREE_DEVTOOLS__ && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", {
                            detail: this
                        }));
                    }
                    get coordinateSystem() {
                        return Co.TdN;
                    }
                    get outputColorSpace() {
                        return this._outputColorSpace;
                    }
                    set outputColorSpace(Qe) {
                        this._outputColorSpace = Qe;
                        const rt = this.getContext();
                        rt.drawingBufferColorspace = Co.ppV._getDrawingBufferColorSpace(Qe), rt.unpackColorSpace = Co.ppV._getUnpackColorSpace();
                    }
                }
            },
            8330: (Qe)=>{
                "use strict";
                Qe.exports = JSON.parse('{"rE":"4.0.3","Jk":{"O":"https://gitlab.com/panoramax/clients/web-viewer"}}');
            },
            4149: (Qe)=>{
                "use strict";
                Qe.exports = JSON.parse('{"maplibre":{"GeolocateControl.LocationNotAvailable":"Placering ikke tilg\xe6ngelig","GeolocateControl.FindMyLocation":"Find min placering"},"pnx":{"minimize":"Skjul dette modul, du kan vise det igen ved hj\xe6lp af knappen i nederste venstre hj\xf8rne","share_embed_docs":"L\xe6s mere om indlejringskonfiguration","zoom":"Zoom","zoomOut":"Zoom ud","zoomIn":"Zoom ind","moveUp":"Ryk opad","moveDown":"Ryk nedad","moveLeft":"Ryk til venstre","moveRight":"Ryk til h\xf8jre","moveMiddle":"Centreret visning","expand":"Udvid","expand_info":"F\xe5 modulet til at blive vist p\xe5 hele siden","show_psv":"Vis billedfremviseren","show_map":"Vis kortet","options":"Valgmuligheder","filters":"Filtre","layers":"Lag","search":"S\xf8g","search_empty":"Ingen resultater fundet","search_user":"S\xf8g efter et brugernavn\u2026","share":"Del","share_links":"Links","share_page":"Link til dette billede","share_image":"HD-billede","share_rss":"RSS-feed","share_rss_title":"RSS-feed med nye sekvenser i det aktuelt synlige kortomr\xe5de","share_embed":"Indlejr p\xe5 din hjemmeside","share_print":"Udskriv","copy":"Kopi\xe9r","copied":"Kopieret","error_retry":"Pr\xf8v igen senere","sequence_next":"N\xe6ste billede i sekvensen","sequence_play":"Afspil denne sekvens","sequence_more":"Flere afspilningsmuligheder","sequence_speed":"Afspillerens hastighed","legend_license":"Licens: {l}","legend_title":"Vis detaljer om billedet","error_click":"Forts\xe6t","error":"Vi har et problem\u2026","search_address":"S\xf8g efter en adresse, by\u2026","sequence_pause":"S\xe6t sekvensen p\xe5 pause","sequence_prev":"Forrige billede i sekvensen","loading_labels_serious":["\ud83d\uddfa\uFE0F Indl\xe6ser kortdata","\ud83d\udda5\uFE0F Anmoder API","\ud83d\uddbc\uFE0F Indl\xe6ser thumbnails","\ud83d\udd0d Analyserer EXIF-metadata","\ud83c\udfd8\uFE0F 3D-rendering","\ud83d\udcf7 Initialiserer 360\xb0-billeder","\ud83d\udfe0 Farveafstemning","\ud83d\udcaf Beregning af kvalitetsscore \xa9","\ud83d\udce1 Downloader opdateringer","\ud83c\udf0d Henter kortfliser","\ud83d\udcf8 Behandler skygger"],"edit_osm":"Rediger OSM","josm_live":"Aktiv\xe9r automatisk JOSM-synkronisering ved indl\xe6sning af billeder","loading_labels_fun":["\ud83e\udd8c Registrering af skilte om hjortekrydsning","\ud83d\ude98 S\xf8ger Panoramax Car \xa9","\u2615 Injicerer koffein","\ud83d\ude00 Smil, du er blevet kortlagt!","\ud83d\udc08 Deler kattebilleder","\ud83d\ude34 Reducerer overspringshandlinger","\ud83e\uded6 Brygger te","\ud83d\udc27 \xc5bner kildekode","\ud83d\ude87 Indekser undergrundsstationer","\ud83e\uddf9 Metadata-oprydning","\ud83d\ude92 Sender billeder af brandstation","\ud83d\udeb2 Opdatering af Greenways","\ud83d\ude89 Gennemgang af perron p\xe5 station","\ud83d\udef0\uFE0F S\xf8ger efter satellitter","\ud83d\udc65 Skriver personaer","\ud83d\udc1f Finder fish and chip butik","\ud83e\uddd1\u200D\ud83d\udcbb Gr\xe6nseflade til fejlfinding","\ud83d\udcc8 Inkrementelle statistikker","\ud83e\udd16 L\xe6rer semantik","\ud83c\udfa8 Redesign af gr\xe6nseflade","\ud83d\udcc5 Planl\xe6gning af foto-kortl\xe6gningsfester","\ud83e\uddc0 Modning af cheddars","\ud83c\udf04 Beregning af Cornwalls solskin","\ud83c\udf0a M\xe5ling af h\xf8jvande"],"error_psv":"Photo Sphere Viewer indl\xe6ses ikke korrekt","error_nopic":"Intet billede tilg\xe6ngeligt p\xe5 den givne position","error_api":"Billedserveren er ikke tilg\xe6ngelig","error_webgl":"WebGL underst\xf8ttes ikke af din browser","filter_date":"Dato","filter_date_1month":"1 m\xe5ned","filter_date_1year":"1 \xe5r","filter_user":"Bruger","filter_user_mypics":"Mine billeder","filter_picture":"Billedtype","filter_zoom_in":"Zoom ind p\xe5 kortet for at se dette filter","picture_flat":"Klassisk","picture_360":"360\xb0","filter_qualityscore_help":"Klik for at aktivere eller deaktivere","map_background":"Kortbaggrund","map_background_aerial":"Luftfoto","map_background_streets":"Gader","map_theme":"Korttema","error_pic":"Det \xf8nskede billede blev ikke fundet","error_api_compatibility":"Billedserveren er ikke kompatibel med denne version af fremviseren","filter_qualityscore":"Kvalitetsscore","error_josm":"JOSM svarer ikke, k\xf8rer den, og er fjernstyring aktiveret?","metadata_general_seqid_link":"G\xe5 til JSON-beskrivelse af sekvensen","map_theme_default":"Klassisk","map_theme_age_1":"> 2 \xe5r","map_theme_age_2":"< 2 \xe5r","map_theme_age_3":"< 1 \xe5r","map_theme_age_4":"< 1 m\xe5ned","map_theme_type":"Kameratype","map_theme_score":"Kvalitetsscore","contrast":"Aktiv\xe9r h\xf8jere billedkontrast","metadata_general_picid":"Billede","metadata_general_seqid":"Sekvens","metadata_general_picid_link":"G\xe5 til JSON-beskrivelse af billedet","metadata_general_author":"Forfatter","metadata_general_license":"Licens","metadata_general_license_link":"Se den fulde licensbeskrivelse","metadata_general_date":"Optagelsesdato","metadata_camera":"Kamera","metadata_camera_make":"Fabrikat","metadata_camera_model":"Model","metadata_camera_type":"Type","metadata_camera_resolution":"Opl\xf8sning","metadata_camera_focal_length":"Br\xe6ndvidde","metadata_location_latitude":"Breddegrad","metadata_location_orientation":"Retning","metadata_location_precision":"Pr\xe6cision i positionering","metadata_quality":"Kvalitet","metadata_quality_score":"Global score","metadata_quality_gps_score":"Positioneringsscore","metadata_quality_help":"F\xe5 mere at vide om kvalitetsscore","map_theme_age":"Optagelsesdato","metadata_location":"Position","metadata":"Metadata for billede","metadata_location_longitude":"L\xe6ngdegrad","metadata_quality_resolution_score":"Opl\xf8sningsscore","metadata_quality_missing":"ingen v\xe6rdi indstillet i billedet","metadata_exif":"EXIF","metadata_exif_name":"Tag","metadata_exif_value":"V\xe6rdi","report":"Indberet","report_auth":"Denne indberetning vil blive sendt via din konto \\"{a}\\"","report_nature_label":"Problemets karakter","report_nature":{"":"V\xe6lg problemets art\u2026","blur_missing":"En persons ansigt eller bils nummerplade er synlig","blur_excess":"Et objekt, der ikke har brug for sl\xf8ring, sl\xf8res","inappropriate":"Billedet er upassende (ikke relevant, n\xf8genhed\u2026)","privacy":"En privat sti eller ejendom er synlig","picture_low_quality":"Billedet er af meget d\xe5rlig kvalitet","mislocated":"Billedet er d\xe5rligt placeret p\xe5 kortet","copyright":"Billedet kr\xe6nker ophavsretten","other":"Enhver anden form for problem"},"report_whole_sequence":"Det g\xe6lder hele sekvensen","report_details":"Yderligere detaljer","report_details_placeholder":"Hvis du vil, kan du tilf\xf8je detaljer om problemet, og hvad det drejer sig om","report_email":"Din e-mail","report_email_placeholder":"Valgfri","report_submit":"Indsend","report_wait":"Sender indberetning \u2026","report_success":"Indberetningen er blevet sendt. Den vil blive gennemg\xe5et s\xe5 hurtigt som muligt.","report_failure":"Der opstod en fejl under oprettelse af indberetning: {e}. Pr\xf8v venligst igen senere.","qualityscore_title":"Om kvalitetsscoren","qualityscore_doc_2":"Bed\xf8mmelsen vises for brugerne som en A/B/C/D/E-score (A er den bedste, E den d\xe5rligste) og vises grafisk via denne skala:","qualityscore_doc_3":"Den beregnes ud fra GPS-pr\xe6cision og billedopl\xf8sning. Et professionelt system vil have en A-rating, et 360\xb0 actionkamera vil have en B-rating, og en smartphone vil have en C/D/E-rating.","qualityscore_doc_link":"Yderligere oplysninger om kvalitetsscoren","qualityscore_doc_1":"Panoramax tilbyder en kvalitetsscore for hvert billede. Det giver mulighed for nem kortfiltrering og overskuelig visning af tilg\xe6ngelige billeder af h\xf8j kvalitet.","minimize_short":"Skjul","id":"iD","josm":"JOSM","metadata_general_instance":"Oprindelse instans","contribute_id":"Bidrag til OpenStreetMap med iD-editor","geo_uri":"Ekstern app","picture_flat_long":"Klassisk billede","picture_360_long":"Panoramabillede","metadata_summary":"Opsummering","metadata_general_copy_id":"Kopi-ID","metadata_general_copy_picid":"Kopi billed-ID","filter_date_6months":"6 m\xe5neder","picture_all":"Alle"},"psv":{"loadError":"Panoramaet kan ikke indl\xe6ses","twoFingers":"Brug to fingre til at navigere","ctrlZoom":"Brug ctrl + scroll til at zoome ind p\xe5 billedet"},"map":{"loading":"Indl\xe6ser\u2026","thumbnail":"Miniature af billedet, der holdes","not_public":"Ikke offentligt synlig","slow_loading":"Kortet indl\xe6ses langsomt og kan virke defekt","map_data":"Kortdata:","more_panoramax":"F\xe5 mere at vide om Panoramax"}}');
            },
            369: (Qe)=>{
                "use strict";
                Qe.exports = JSON.parse('{"pnx":{"options":"Optionen","filters":"Filter","search":"Suche","layers":"Ebenen","share_links":"Links","share_page":"Link zu dieser Seite","loading_labels_fun":["\ud83e\udd8c Erkennung der \\"Reh kreuzt\\"-Schilder","\ud83d\ude98 Suche Panoramax-Auto \xa9","\u2615 Koffeininjektion","\ud83d\ude00 L\xe4chle, du wirst kartografiert!","\ud83d\udc08 Katzenfotos teilen","\ud83d\ude34 Reduzieren der Prokrastination","\ud83c\udf7a\uFE0F Bier brauen","\ud83d\udc27 Quellcode \xf6ffnen","\ud83d\udee3\uFE0F Indizierung der Autobahnen","\ud83e\uddf9 Metadatenreinigung","\ud83d\ude92 Senden der Fotos der Feuerwehren","\ud83d\udeb2 Gr\xfcne Radwege identifiziert","\ud83d\ude89 Durchgang zum Bahnsteig","\ud83d\udef0\uFE0F Suche Satelliten","\ud83d\udc65 Personas anlegen","\ud83c\udf2d\uFE0F Lokalisierung der Currywurst","\ud83e\uddd1\u200D\ud83d\udcbb Debugging des Interfaces","\ud83d\udcc8 Hochz\xe4hlen der Statistiken"],"search_empty":"Keine Ergebnisse gefunden","share":"Teilen","metadata_general_picid":"Bild-Identifier","zoom":"Zoom","zoomOut":"Herauszoomen","zoomIn":"Hereinzoomen","moveUp":"Nach oben","moveDown":"Nach unten","moveRight":"Nach rechts","moveMiddle":"Sicht zentrieren","map_theme_age":"Aufnahmedatum","expand":"Vergr\xf6\xdfern","expand_info":"Widget im Vollbild anzeigen","show_psv":"Bildbetrachter anzeigen","show_map":"Karte anzeigen","search_user":"Benutzernamen suchen\u2026","filter_zoom_in":"Hereinzoomen um diesen Filter zu sehen","picture_flat":"Klassisch","picture_360":"360\xb0","filter_camera_model":"Nach Kameramodell","map_background":"Kartenhintergrund","map_background_aerial":"Satelliten","map_background_streets":"Stra\xdfen","map_theme":"Karten-Art","metadata_exif_name":"Schlagwort","metadata_exif_value":"Wert","map_theme_age_2":"<2 Jahre","map_theme_age_3":"<1 Jahr","map_theme_type":"Kameratyp","contrast":"H\xf6heren Bildkontrast aktivieren","metadata":"Bildmetadaten","metadata_general_seqid":"Sequenzidentifier","metadata_general_picid_link":"Zur JOSN-Beschreibung des Bildes gehen","loading_labels_serious":["\ud83d\uddfa\uFE0F Laden der Kartendaten","\ud83d\udda5\uFE0F API anfragen","\ud83d\uddbc\uFE0F Vorschaubilder laden","\ud83d\udd0d EXIF Metadaten analysieren","\ud83c\udfd8\uFE0F 3D-Rendering","\ud83d\udcf7 360\xb0 Fotos initialisieren","\ud83d\udfe0 Farben balancieren","\ud83d\udcaf Berechnung der Qualit\xe4tsbewertung \xa9"],"search_address":"Suchen sie eine Adresse, Stadt, \u2026","share_image":"HD Bild","share_rss":"RSS Feed","share_embed":"Auf Webseite einbetten","share_print":"Druck","copy":"Kopieren","copied":"Kopiert","error":"Panoramax ist abgest\xfcrzt\u2026","sequence_next":"N\xe4chstes Foto in der Sequenz","sequence_play":"Sequenz abspielen","sequence_pause":"Sequenz pausieren","sequence_prev":"Vorheriges Foto in der Sequenz","sequence_more":"Mehr Abspieloptionen","sequence_speed":"Abspielgeschwindigkeit","legend_license":"Lizenz: {l}","edit_osm":"OSM editieren","id":"iD","josm":"JOSM","josm_live":"Einschalten der automatischen JOSM-Synchronisierung beim Laden eines Bildes","error_psv":"Betrachter f\xfcr die Photospheres wurde nicht richtig geladen","error_pic":"Gesuchtes Foto wurde nicht gefunden","error_nopic":"Kein Foto verf\xfcgbar an dieser Position","error_api":"Foto-Server ist nicht verf\xfcgbar","error_josm":"JOSM reagiert nicht, ist es ge\xf6ffnet und die Remote eingeschaltet?","error_api_compatibility":"Der Foto-Server ist nicht mit dieser Version des Betrachters kompatibel","filter_date":"Datum","filter_user":"Benutzer","filter_picture":"Foto-Art","map_theme_default":"Klassisch","map_theme_age_1":">2 Jahre","metadata_general_seqid_link":"Zur JSON-Beschreibung der Sequenz gehen","metadata_general_author":"Autor","metadata_general_license":"Lizenz","metadata_general_date":"Aufnahmedatum","metadata_camera":"Kamera","metadata_camera_make":"Hersteller","metadata_camera_model":"Modell","metadata_camera_type":"Typ","metadata_camera_focal_length":"Brennweite","metadata_location":"Ort","metadata_location_longitude":"L\xe4ngengrad","metadata_location_latitude":"Breitengrad","metadata_location_orientation":"Aufnahmerichtung","metadata_location_precision":"Pr\xe4zision der Positionierung","metadata_exif":"EXIF / XMP","minimize":"Widget verbergen, sie k\xf6nnen es \xfcber die Schaltfl\xe4che in der linken unteren Ecke wieder einblenden","map_theme_age_4":"< 1 Monat","error_subtitle":"Bitte versuchen sie es sp\xe4ter erneut, oder schauen sie in die Web-Browser-Konsole f\xfcr mehr Details.","moveLeft":"Nach links","share_rss_title":"RSS Feed neuer Sequenzen auf dem aktuell sichtbaren Kartenbereich","error_webgl":"WebGL wird von ihrem Browser nicht unterst\xfctzt","metadata_general_license_link":"Volle Lizenzbeschreibung ansehen","share_embed_docs":"Mehr \xfcber die Einbettungs-Konfiguration lesen","report_nature":{"":"Art des Problems ausw\xe4hlen\u2026","inappropriate":"Bild ist unangemessen (irrelevant, Nacktheit, ...)","picture_low_quality":"Bild hat eine sehr schlechte Qualit\xe4t","blur_missing":"Das Gesicht einer Person oder ein KFZ-Kennzeichen ist sichtbar","blur_excess":"Ein Objekt das nicht unkenntlich gemacht werden muss wurde unkenntlich gemacht","privacy":"Ein privater Pfad oder ein privates Grundst\xfcck ist sichtbar","mislocated":"Bild ist falsch auf der Karte verortet","copyright":"Bild verletzt das Urheberrecht","other":"Andere Art von Problem"},"report_details_placeholder":"Sie k\xf6nnen optionale Details \xfcber das Problem hinzuf\xfcgen","report_auth":"Dieser Report wird durch ihren Account \\"{a}\\" gesendet","report_nature_label":"Art des Problems","report_whole_sequence":"Dies betrifft die gesamte Sequenz","report_details":"Weitere Details","report_email":"Ihre Email","report_email_placeholder":"Optional","report_submit":"Absenden","report_success":"Ihr Report wurde erfolgreich gesendet. Er wird so schnell wie m\xf6glich \xfcberpr\xfcft.","report_failure":"Ein Fehler ist bei der Erstellung des Reports aufgetreten: {e}. Bitte versuchen sie es erneut.","report":"Foto melden","legend_title":"Zeige Bilderdetails","report_wait":"Bericht senden\u2026","error_click":"Weiter","error_retry":"Bitte sp\xe4ter erneut versuchen","metadata_camera_resolution":"Aufl\xf6sung","filter_user_mypics":"Meine Fotos","metadata_quality_missing":"kein Wert im Foto gesetzt","filter_date_1month":"1 Monat","filter_date_1year":"1 Jahr","filter_qualityscore":"Qualit\xe4tswert","filter_qualityscore_help":"Klicken, um zu aktivieren oder deaktivieren","map_theme_score":"Qualit\xe4tswert","metadata_quality":"Qualit\xe4tswert","metadata_quality_help":"Erfahre mehr \xfcber den Qualit\xe4tswert","metadata_quality_resolution_score":"Aufl\xf6sungswertung","metadata_quality_gps_score":"Positionswertung","metadata_quality_score":"Gesamtwertung","qualityscore_title":"\xdcber den Qualit\xe4tsfaktor","qualityscore_doc_link":"Weitere Informationen zur Berechnung des Qualit\xe4tsfaktors findest du in unserer Dokumentation","qualityscore_doc_1":"Panoramax bietet einen Qualit\xe4tsfaktor f\xfcr jedes Bild. Es erm\xf6glicht eine einfache Kartenfilterung und eine umfassende Anzeige der Verf\xfcgbarkeit hochwertiger Bilder.","qualityscore_doc_2":"Die Note wird den Benutzern als A/B/C/D/E-Bewertung angezeigt (A ist die beste, E die schlechteste) und anhand dieser Skala grafisch dargestellt:","qualityscore_doc_3":"Die Berechnung erfolgt auf der Grundlage der GPS-Genauigkeit und der Bildaufl\xf6sung. Ein professionelles System wird mit A bewertet, eine 360-Grad-Action-Kamera mit B und ein Smartphone mit C/D/E.","minimize_short":"Verbergen"},"psv":{"twoFingers":"Nutzen sie zwei Finger zum navigieren","ctrlZoom":"Nutzen sie Strg+Scrollen um das Bild zu zoomen","loadError":"Das Panorama konnte nicht geladen werden"},"map":{"thumbnail":"Vorschau des marktierten Fotos","not_public":"Nicht \xf6ffentlich sichtbar","loading":"Laden\u2026","slow_loading":"Die Karte wird nur langsam geladen und k\xf6nnte fehlerhaft erscheinen","map_data":"Kartendaten:","more_panoramax":"Mehr Infos \xfcber Panoramax"},"maplibre":{"GeolocateControl.FindMyLocation":"Meinen Standort finden","GeolocateControl.LocationNotAvailable":"Standort nicht verf\xfcgbar"}}');
            },
            389: (Qe)=>{
                "use strict";
                Qe.exports = JSON.parse('{"psv":{"twoFingers":"Use two fingers to navigate","ctrlZoom":"Use ctrl + scroll to zoom the image","loadError":"The panorama can\'t be loaded"},"maplibre":{"GeolocateControl.FindMyLocation":"Find my location","GeolocateControl.LocationNotAvailable":"Location not available"},"pnx":{"zoom":"Zoom","zoomOut":"Zoom out","zoomIn":"Zoom in","moveUp":"Move up","moveDown":"Move down","moveLeft":"Move left","moveRight":"Move right","moveMiddle":"Center view","expand":"Expand","expand_info":"Make the widget appear in full page","show_psv":"Show the picture viewer","show_map":"Show the map","minimize":"Hide this widget, you can show it again using button in bottom left corner","minimize_short":"Hide","options":"Options","filters":"Filters","layers":"Layers","search":"Search","search_empty":"No results found","search_address":"Search an address, city\u2026","search_user":"Search a username\u2026","share":"Share","share_links":"Links","share_page":"Link to this picture","share_image":"HD Image","share_rss":"RSS feed","share_rss_title":"RSS feed of new sequences in the currently visible map area","share_embed":"Embed on your website","share_embed_docs":"Read more about embed configuration","share_print":"Print","whats_panoramax":"Panoramax is the geo-commons for territories\' pictures.","copy":"Copy","copied":"Copied","error":"We have a problem\u2026","error_click":"Continue","error_retry":"Please retry later","sequence_next":"Next picture in sequence","sequence_play":"Play along this sequence","sequence_pause":"Pause sequence","sequence_prev":"Previous picture in sequence","sequence_more":"More play options","sequence_speed":"Player speed","legend_license":"License: {l}","legend_title":"Show details of picture","id":"iD","contribute_id":"Contribute to OpenStreetMap with iD editor","geo_uri":"External app","josm":"JOSM","josm_live":"Enable JOSM automatic sync on picture loading","loading_labels_serious":["\ud83d\uddfa\uFE0F Loading map data","\ud83d\udda5\uFE0F Querying API","\ud83d\uddbc\uFE0F Loading thumbnails","\ud83d\udd0d Analyzing EXIF metadata","\ud83c\udfd8\uFE0F 3D rendering","\ud83d\udcf7 Initializing 360\xb0 pictures","\ud83d\udfe0 Colour balancing","\ud83d\udcaf Computing Quality Score \xa9","\ud83d\udce1 Downloading updates","\ud83c\udf0d Fetching map tiles","\ud83d\udcf8 Processing shadows"],"loading_labels_fun":["\ud83e\udd8c Detecting deer crossing signs","\ud83d\ude98 Searching Panoramax Car \xa9","\u2615 Injecting caffeine","\ud83d\ude00 Smile, you\'re mapped!","\ud83d\udc08 Sharing cat pictures","\ud83d\ude34 Reducing procrastination","\ud83e\uded6 Brewing tea","\ud83d\udc27 Opening source code","\ud83d\ude87 Indexing Underground stations","\ud83e\uddf9 Metadata cleanup","\ud83d\ude92 Sending fire station photos","\ud83d\udeb2 Greenways update","\ud83d\ude89 Station platform walkthrough","\ud83d\udef0\uFE0F Searching satellites","\ud83d\udc65 Writing personas","\ud83d\udc1f Locating chip shops","\ud83e\uddd1\u200D\ud83d\udcbb Debugging interface","\ud83d\udcc8 Incrementing statistics","\ud83e\udd16 Learning semantics","\ud83c\udfa8 Interface redesign","\ud83d\udcc5 Planning photo-mapping-parties","\ud83e\uddc0 Maturing cheddars","\ud83c\udf04 Calculating Cornish sunshine","\ud83c\udf0a Measuring the high tides"],"error_psv":"Photo Sphere Viewer is not loading properly","error_pic":"Requested picture wasn\'t found","error_nopic":"No picture available at given position","error_api":"The pictures server is not available","error_webgl":"WebGL is not supported by your browser","error_josm":"JOSM doesn\'t respond, is it running and is remote enabled?","error_api_compatibility":"The pictures server is not compatible with this viewer version","filter_date":"Date","filter_date_1month":"1 month","filter_date_6months":"6 months","filter_date_1year":"1 year","filter_user":"User","filter_user_mypics":"My pictures","filter_picture":"Picture type","filter_zoom_in":"Zoom-in the map to see this filter","picture_all":"All","picture_flat":"Classic","picture_360":"360\xb0","picture_flat_long":"Classic picture","picture_360_long":"Panoramic picture","filter_qualityscore":"Quality score","filter_qualityscore_help":"Click to enable or disable","qualityscore_title":"About the quality score","qualityscore_doc_1":"Panoramax offers a Quality Score for each picture. It allows easy map filtering and comprehensive display of high-quality pictures availability.","qualityscore_doc_2":"The grade is shown to users as a A/B/C/D/E score (A is the best, E the worst), and shown graphically through this scale:","qualityscore_doc_3":"It is computed based on GPS precision and picture resolution. A professional system will have an A-rating, a 360\xb0 action camera will have a B-rating, and a smartphone will be C/D/E-rated.","qualityscore_doc_link":"Know more about the Quality Score","map_background":"Map background","map_background_aerial":"Aerial","map_background_streets":"Streets","map_theme":"Map theme","map_theme_default":"Classic","map_theme_age":"Capture date","map_theme_age_1":"> 2 years","map_theme_age_2":"< 2 years","map_theme_age_3":"< 1 year","map_theme_age_4":"< 1 month","map_theme_type":"Camera type","map_theme_score":"Quality score","contrast":"Enable higher image contrast","metadata":"Picture metadata","metadata_summary":"Summary","metadata_general_copy_id":"Copy ID","metadata_general_copy_picid":"Copy picture ID","metadata_general_picid":"Picture","metadata_general_seqid":"Sequence","metadata_general_picid_link":"Go to JSON description of the picture","metadata_general_seqid_link":"Go to JSON description of the sequence","metadata_general_author":"Author","metadata_general_license":"License","metadata_general_license_link":"See the full licence description","metadata_general_date":"Capture date","metadata_general_instance":"Origin instance","metadata_camera":"Camera","metadata_camera_make":"Make","metadata_camera_model":"Model","metadata_camera_type":"Type","metadata_camera_resolution":"Resolution","metadata_camera_focal_length":"Focal length","metadata_location":"Position","metadata_location_coordinates":"Coordinates (longitude, latitude)","metadata_location_orientation":"Direction","metadata_location_precision":"Positioning precision","metadata_location_copy":"Copy {v}","metadata_location_copy_more":"More coordinates copy options","metadata_quality":"Quality","metadata_quality_help":"Know more about Quality Score","metadata_quality_score":"Global score","metadata_quality_gps_score":"Positioning score","metadata_quality_resolution_score":"Resolution score","metadata_quality_missing":"no value set in picture","metadata_exif":"EXIF","metadata_exif_name":"Tag","metadata_exif_value":"Value","metadata_exif_doc":"Docs for EXIF tags","metadata_exif_doc_title":"Go to Exiv2 documentation to have full details on EXIF and XMP tags definitions","semantics_title":"Tags","semantics_tags":"{nb} tags","semantics_features":"Detected features","semantics_features_none":"No feature has been detected or annotated in this picture yet.","semantics_features_default_title":"Feature #{nb}","semantics_features_subtitle":"{nb} associated properties","semantics_annotation_tooltip":"Click to see details","semantics_show_all_tags":"Show all tags","semantics_hide_all_tags":"Hide all tags","semantics_key":"Key","semantics_value":"Value","semantics_key_doc":"Know more about this key","semantics_value_doc":"Know more about this tag","semantics_tags_picture":"Picture tags","semantics_tags_picture_none":"No tags has been set for this picture yet.","semantics_qualifiers":"Qualifiers","semantics_show_annotations":"Display picture annotations","semantics_hide_annotations":"Hide picture annotations","semantics_wikidata_properties":{"P31":"instance of","P279":"subclass of","P361":"part of"},"report":"Report","report_auth":"This report will be sent using your account \\"{a}\\"","report_nature_label":"Nature of the issue","report_nature":{"":"Select the nature of issue\u2026","blur_missing":"A person face or car plate is visible","blur_excess":"An object not needing blur is blurred","inappropriate":"Picture is inappropriate (unrelated, nudity\u2026)","privacy":"A private path or property is visible","picture_low_quality":"Picture is of very bad quality","mislocated":"Picture is badly positioned on map","copyright":"Picture infringes copyright","other":"Any other kind of issue"},"report_whole_sequence":"This concerns the entire sequence","report_details":"Additional details","report_details_placeholder":"Optional, you can add details about the issue and how this is concerning","report_email":"Your email","report_email_placeholder":"Optional","report_submit":"Submit","report_wait":"Sending report \u2026","report_success":"Report has been successfully sent. It will be reviewed as soon as possible.","report_failure":"An error occurred when creating report: {e}. Please try again later."},"map":{"loading":"Loading\u2026","thumbnail":"Thumbnail of hovered picture","not_public":"Not publicly visible","slow_loading":"Map is slow to load and could appear broken","map_data":"Map data:","more_panoramax":"Discover more about Panoramax"}}');
            },
            9946: (Qe)=>{
                "use strict";
                Qe.exports = JSON.parse('{"psv":{"twoFingers":"Uzu du fingrojn por navigi","ctrlZoom":"Uzu ctrl + rulumo por zomi la bildon","loadError":"La bildo ne povas esti \u015Dar\u011Dita"},"pnx":{"zoom":"Zomo","zoomOut":"Malzomo","zoomIn":"Zomi","moveUp":"Movi supren","moveDown":"Movi malsupren","moveLeft":"Movi maldekstren","moveRight":"Movi dekstren","moveMiddle":"Centri vido","expand":"Pligrandigi","expand_info":"Aperigu la fenestra\u0135on en plena pa\u011Do","show_psv":"Montri la bildspektilo","show_map":"Montri la mapo","minimize":"Maski la fenestra\u0135o, vu povas montri \u011Din denove kun la butono en malsupra maldekstra angulo","sequence_prev":"Anta\u016Da foto en la sekvenco","sequence_more":"Pli da ludopcioj","sequence_speed":"Rapideco de legado","sequence_next":"Sekva foto en la sekvenco","sequence_play":"Foliumi \u0109i tiun sinsekvon","sequence_pause":"Pa\u016Dzi la sekvenco","copy":"Kopii","copied":"Kopiita","error":"Ni havas problemon\u2026","error_click":"Kontinui","error_retry":"Bonvolu reprovi poste","search_address":"Ser\u0109i adreson, urbon\u2026","filters":"Filtriloj","layers":"Tavoloj","search":"Ser\u0109i","share_embed_docs":"Pli pri enigito sur via retpa\u011Daro","search_empty":"Neniu rezulto trovita","search_user":"Ser\u0109i uzantnomon\u2026","share":"Kunhavigi","share_links":"Ligiloj","share_page":"Ligilo de la foto","share_image":"HD bildo","share_rss":"RSS abonfluo","share_rss_title":"RSS abonfluo de la novaj sekvecoj en la nuntempe videbla mapzono","share_embed":"Enigita en via retpa\u011Daro","share_print":"Presi","edit_osm":"Modifi OSM","legend_license":"Rajtigilo : {l}","josm_live":"Ebligas a\u016Dtomatan JOSM-sinkronigon dum \u015Dar\u011Do de bildo","loading_labels_serious":["\ud83d\uddfa\uFE0F \u015Cargo de la bazmapon","\ud83d\udda5\uFE0F API demandado","\ud83d\uddbc\uFE0F \u015Car\u011Do de miniaturoj","\ud83d\udd0d Analizo de EXIF-metadatumoj","\ud83c\udfd8\uFE0F 3D-rendumo","\ud83d\udcf7 Inico de 360\xb0-bildoj","\ud83d\udfe0 Kolora ekvilibrigo","\ud83d\udcaf Kalkulo de kvalitpoentaro \xa9","\ud83d\udce1 El\u015Dutante \u011Disdatoj","\ud83c\udf0d Reakirante mapkaheloj","\ud83d\udcf8 Traktadante ombroj"],"legend_title":"Montri la detaloj de la bildo","error_api":"La bildservilo ne estas disponebla","error_josm":"JOSM ne respondis. \u0108u \u011Di funkcias kaj la regilo estas \u015Daltita?","error_webgl":"WebGL ne estas subtenata per via retumilo","loading_labels_fun":["\ud83e\udd8c Detekto de cervinaj vojmontriloj","\ud83d\ude98 Ser\u0109o de Panoramax-a\u016Dto \xa9","\u2615 Injekto de kafeino","\ud83d\ude00 Ridetu, vi estas mapita!","\ud83d\udc08 Kunhavigo de katbildoj","\ud83d\ude34 Redukto de prokrastado","\ud83d\udcd6 Lernado de Esperanto","\ud83d\udc27 Malfermo de fontkodo","\ud83d\ude87 Indekso de subteraj stacioj","\ud83e\uddf9 Purigo de metadatumoj","\ud83d\ude92 Sendado de fotoj de fajrostacioj","\ud83d\udeb2 \u011Cisdatigo de verdaj vojoj","\ud83d\ude89 Promenado tra stacioplatformoj","\ud83d\udef0\uFE0F Ser\u0109o de satelitoj","\ud83d\udc65 Verkado de roluloj","\u2747\uFE0F Lokalizo de la Esperanto-flagoj","\ud83e\uddd1\u200D\ud83d\udcbb Sencimigado de la interfaco","\ud83d\udcc8 Alkrementi de la statistikoj","\ud83e\udd16 Lernadante semantiko","\ud83c\udfa8 Interfaca redezajno","\ud83d\udcc5 Planante fota-mapa-festoj","\ud83e\uddc0 Finmaturigo de la froma\u011Doj","\ud83c\udf04 Kalkulante la sunbrilon de la Saharo","\ud83c\udf0a Mezurado de la altaj tajdoj"],"picture_360":"360\xb0","picture_flat":"Klasika","report_nature_label":"Speco de problemo","report_nature":{"":"Elektu la specon de problemo\u2026","blur_missing":"Viza\u011Do a\u016D numerplato estas videbla","copyright":"La bildo malobeas kopirajton","blur_excess":"Objekto kiu ne bezonis malklari\u011Don estas malklarigita","inappropriate":"La bildo estas neta\u016Dga (nevera, nudeco...)","privacy":"Privata vojo a\u016D poseda\u0135o estas videbla","picture_low_quality":"La bildo estas de tre malbona kvalito","mislocated":"La bildo estas malbone poziciigita sur la mapo","other":"\u0108ia alia speco de problemo"},"report":"Raporti","report_auth":"\u0108i tiu raporto estos sendita per via konto \\"{a}\\"","filter_date":"Dato","filter_user_mypics":"Miaj fotoj","options":"Opcioj","error_api_compatibility":"La fotoservilo ne kongruas kun \u0109i tiu spektilo","filter_qualityscore":"Kvalitpoentaro","filter_qualityscore_help":"Alllaku por aktivigi a\u016D mal\u015Dalti","map_theme_age":"Dato de fotado","map_theme_age_1":"> 2 jaroj","map_theme_age_2":"< 2 jaroj","map_theme_age_3":"< 1 jaro","map_theme_age_4":"< 1 monato","map_theme_score":"Kvalitpoentaro","metadata":"Metadatenoj de la bildo","map_theme_type":"Fotiltipo","metadata_general_seqid":"Sekvenco","metadata_camera_resolution":"Difino","metadata_quality_resolution_score":"Rezolucia poentaro","error_psv":"Foto-Sfera Spektilo ne \u015Dar\u011Di\u011Das \u011Duste","error_pic":"La petita bildo ne estis trovita","error_nopic":"Neniu bildo disponeblas \u0109e la donita pozicio","filter_user":"Uzanto","map_theme_default":"Klasika","filter_date_1month":"1 monato","filter_date_1year":"1 jaro","contrast":"Pliigi bildkontraston","metadata_general_picid":"Foto","filter_picture":"Bilda tipo","filter_zoom_in":"Zomu en la mapo por vidi tiun filtrilon","map_background":"Bazmapo","map_background_aerial":"Aera","map_background_streets":"Stratoj","map_theme":"Mapa etoso","metadata_general_picid_link":"Iru al la JSON-priskribo de la foto","metadata_general_seqid_link":"Iru al la JSON-priskribo de la sekvenco","metadata_general_author":"A\u016Dtoro","metadata_general_license":"Rajtigilo","metadata_general_license_link":"Vidi la kompletan rajtigilon en la priskribo","metadata_general_date":"Dato de la fotado","metadata_camera":"Fotilo","metadata_camera_make":"Faristo","metadata_camera_model":"\u015Cablono","metadata_camera_type":"Tipo","metadata_camera_focal_length":"Fokuslongo","metadata_location":"Pozicio","metadata_location_longitude":"Longitudo","metadata_location_latitude":"Latitudo","metadata_location_orientation":"Direkto","metadata_location_precision":"Pozicia precizeco","metadata_quality":"Kvalito","metadata_quality_help":"Pli pri la Kvalitapoentaro","metadata_quality_score":"Malloka poentaro","metadata_quality_gps_score":"Pozicia poentaro","metadata_quality_missing":"neniu valoro en la bildo","metadata_exif":"EXIF","metadata_exif_name":"Etikedo","metadata_exif_value":"Valoro","report_whole_sequence":"\u0108i tio koncernas la tutan sekvencon","report_details":"Aliaj detaloj","report_email":"Via retpo\u015Dto","report_submit":"Sendi","report_wait":"Sendante raporton\u2026","report_success":"La raporto estis sukcese sendita. \u011Ci estos reviziita balda\u016D.","report_details_placeholder":"Opcie, vi povas aldoni detalojn pri la problemo","report_email_placeholder":"Opcie","report_failure":"Eraro okazis dum kreo de la raporto: {e}. Bonvolu provi denove poste.","qualityscore_doc_3":"\u011Ci estas kalkulita surbaze de GPS-precizeco kaj bildrezolucio. Profesiaj sistemoj havos A-poentaron, 360\xb0-akcifotilo havos B-poentaron, kaj po\u015Dtelefono havos C/D/E-poentaron.","qualityscore_title":"Pri la kvalita poentaro","qualityscore_doc_1":"Panoramax ofertas Kvalitan Poentaron por \u0109iu bildo. \u011Ci ebligas facilan mapfiltradon kaj ampleksan vidigon de la havebleco de altkvalitaj bildoj.","qualityscore_doc_link":"Pli da detaloj pri la kalkulo de la Kvalita Poentaro estas disponeblaj en nia dokumentado","minimize_short":"Maski","qualityscore_doc_2":"La poentaro estas montrita al uzantoj kiel litero A/B/C/D/E (A estas la plej bona, E la plej malbona) kaj grafike prezentita per \u0109i tiu skalo:","id":"iD","josm":"JOSM","contribute_id":"Kontribuu al OpenStreetMap kun iD-modifilo","filter_date_6months":"6 monatoj","picture_all":"\u0108iuj","picture_flat_long":"Klasika foto","picture_360_long":"Panorama foto","metadata_summary":"Resumo","metadata_general_copy_id":"Kopii la ID-on","metadata_general_copy_picid":"Kopii la fotan ID-on","metadata_general_instance":"Origina instanco","geo_uri":"Ekseteraj aplika\u0135oj"},"maplibre":{"GeolocateControl.FindMyLocation":"Trovi mian pozicion","GeolocateControl.LocationNotAvailable":"Loko ne disponeblas"},"map":{"slow_loading":"La mapo \u015Dar\u011Das malrapide kaj povus aperi rompi\u011Dinta","loading":"\u015Car\u011Danto\u2026","thumbnail":"Miniaturo de la surflikta bildo","not_public":"Ne publike videbla","more_panoramax":"Malkovri pli pri Panoramax","map_data":"Kartaj datumoj :"}}');
            },
            8302: (Qe)=>{
                "use strict";
                Qe.exports = JSON.parse('{"pnx":{"report_auth":"La denuncia se enviar\xe1 usando tu cuenta \xab{a}\xbb","report":"Denunciar imagen","report_nature_label":"Tipo de problema","report_nature":{"":"Selecciona el tipo de problema\u2026","blur_missing":"Se ve el rostro de una persona, o una matr\xedcula","blur_excess":"Est\xe1 borroso un objeto que no hac\xeda falta ocultar","inappropriate":"La imagen no es apropiada (irrelevante, desnudez, \u2026)","privacy":"Se ve un camino privado, o una propiedad privada","mislocated":"La localizaci\xf3n de la imagen en el mapa no es correcta","picture_low_quality":"La calidad de la imagen es pobre","copyright":"La imagen infringe derechos de autor","other":"Otro tipo de problema"},"sequence_more":"M\xe1s opciones de reproducci\xf3n","sequence_speed":"Velocidad de reproducci\xf3n","legend_license":"Licencia: {l}","edit_osm":"Editar OpenStreetMap","id":"iD","josm":"JOSM","josm_live":"Activar la sincronizaci\xf3n autom\xe1tica de JOSM cuando se carga una imagen","loading_labels_serious":["\ud83d\uddfa\uFE0F Cargando datos del mapa","\ud83d\udda5\uFE0F Consultando la API","\ud83d\uddbc\uFE0F Cargando vistas previas","\ud83d\udd0d Analizando metadatos EXIF","\ud83c\udfd8\uFE0F Renderizado 3D","\ud83d\udcf7 Preparando im\xe1genes 360\xb0","\ud83d\udfe0 Ajustando balance de color","\ud83d\udcaf C\xe1lculo del nivel de calidad \xa9"],"metadata":"Metadatos de la imagen","map_theme_type":"Tipo de c\xe1mara","contrast":"Dar m\xe1s contraste a la imagen","zoom":"Acercar/alejar","zoomOut":"Alejar","map_background_streets":"Calles","loading_labels_fun":["\ud83e\udd8c Detectando paneles de cruce de alces","\ud83d\ude98 Buscando el Coche Panoramax \xa9","\u2615 Inyectando cafe\xedna","\ud83d\ude00 \xa1Sonr\xede, est\xe1s siendo mapeado!","\ud83d\udc08 Compartiendo fotos de gatos","\ud83d\ude34 Reduciendo la procrastinaci\xf3n","\ud83e\uded6 Preparando el t\xe9","\ud83d\udc27 Abriendo el c\xf3digo fuente","\ud83d\ude87 Indexando estaciones del metro","\ud83e\uddf9 Limpieza de metadatos","\ud83d\ude92 Enviando fotos de estaciones de bomberos","\ud83d\udeb2 Actualizando v\xedas verdes","\ud83d\ude89 Paseo por el and\xe9n de la estaci\xf3n","\ud83d\udef0\uFE0F Buscando sat\xe9lites","\ud83d\udc65 Describiendo tipolog\xedas de persona","\ud83d\udc1f Localizando tiendas de fish & chips","\ud83e\uddd1\u200D\ud83d\udcbb Buscando gazapos de la interfaz","\ud83d\udcc8 Incrementando estad\xedsticas"],"metadata_general_license_link":"Ir a la descripci\xf3n completa de la licencia","metadata_general_picid":"Identificador de la imagen","metadata_general_license":"Licencia","report_details_placeholder":"Opcional; puedes a\xf1adir m\xe1s detalles sobre el problema y por qu\xe9 te preocupa","expand":"Expandir","expand_info":"Mostrar el elemento ocupando toda la p\xe1gina","show_psv":"Mostrar el visor de im\xe1genes","show_map":"Mostrar el mapa","zoomIn":"Acercar","moveUp":"Desplazar hacia arriba","moveDown":"Desplazar hacia abajo","moveLeft":"Desplazar hacia la izquierda","moveRight":"Desplazar hacia la derecha","moveMiddle":"Centrar la vista","minimize":"Esconder este elemento. Para mostrarlo de nuevo, pulsa el bot\xf3n en la esquina inferior izquierda","options":"Opciones","filters":"Filtros","layers":"Capas","search":"Buscar","search_empty":"No se encontraron resultados","search_address":"Buscar una direcci\xf3n, una ciudad, \u2026","search_user":"Buscar un usuario\u2026","share":"Compartir","share_links":"Enlaces","share_page":"Enlace a esta p\xe1gina","share_image":"Imagen de alta calidad","share_rss":"Flujo RSS","share_rss_title":"Flujo RSS de las nuevas secuencias en el \xe1rea visible del mapa","share_embed":"Incrustar en tu p\xe1gina web","share_embed_docs":"M\xe1s informaci\xf3n sobre c\xf3mo configurar el incrustado","share_print":"Imprimir","copy":"Copiar","copied":"Copiado","error":"Hay un problema\u2026","sequence_next":"Siguiente imagen de la secuencia","sequence_play":"Reproducir esta secuencia","sequence_pause":"Pausar la secuencia","sequence_prev":"Imagen anterior de la secuencia","error_click":"Continuar","error_retry":"Por favor, int\xe9ntalo m\xe1s tarde","error_psv":"El visor de fotos esf\xe9ricas no se carga correctamente","error_pic":"No se encuentra la imagen que quer\xedamos","error_nopic":"No hay im\xe1genes para la posici\xf3n dada","error_api":"El servidor de im\xe1genes no est\xe1 disponible","error_webgl":"Este navegador no admite WebGL","error_josm":"JOSM no responde. \xbfEst\xe1 abierto, y admite el modo de Control Remoto?","error_api_compatibility":"El servidor de im\xe1genes no es compatible con esta versi\xf3n del visor","filter_date":"Fecha","filter_user":"Usuario","filter_picture":"Tipo de imagen","filter_zoom_in":"Ac\xe9rcate para poder ver filtros","picture_flat":"Cl\xe1sico","picture_360":"360\xb0","filter_camera_model":"Por modelo de c\xe1mara","map_background":"Fondo de mapa","map_background_aerial":"Vista a\xe9rea","map_theme":"Tema de mapa","map_theme_default":"Cl\xe1sico","map_theme_age":"Fecha de toma de imagen","map_theme_age_1":"M\xe1s de dos a\xf1os","map_theme_age_2":"Menos de dos a\xf1os","map_theme_age_3":"Menos de un a\xf1o","map_theme_age_4":"Menos de un mes","metadata_general_seqid":"Identificador de la secuencia","metadata_general_picid_link":"Ir a la descripci\xf3n de la imagen en formato JSON","metadata_general_seqid_link":"Ir a la descripci\xf3n de la secuencia en formato JSON","metadata_general_author":"Autor","metadata_general_date":"Fecha de toma de imagen","metadata_camera":"C\xe1mara","metadata_camera_make":"Marca","metadata_camera_model":"Modelo","metadata_camera_type":"Tipo","metadata_camera_focal_length":"Distancia focal","metadata_location":"Localizaci\xf3n","metadata_location_longitude":"Longitud","metadata_location_latitude":"Latitud","metadata_location_orientation":"Orientaci\xf3n","metadata_location_precision":"Precisi\xf3n de la localizaci\xf3n","metadata_exif":"EXIF / XMP","metadata_exif_name":"Etiqueta","metadata_exif_value":"Valor","report_whole_sequence":"El problema afecta a la secuencia entera","report_details":"M\xe1s detalles","report_email":"Tu direcci\xf3n de correo electr\xf3nico","report_email_placeholder":"Opcional","report_submit":"Enviar","report_success":"La denuncia se ha enviado correctamente. Ser\xe1 revisada lo antes posible.","report_failure":"Ocurri\xf3 un error al crear la denuncia: {e}. Por favor, int\xe9ntalo m\xe1s tarde.","map_theme_score":"Nivel de calidad","filter_qualityscore":"Nivel de calidad","filter_qualityscore_help":"Haga clic para habilitar o deshabilitar","legend_title":"Ver detalles de la imagen","metadata_camera_resolution":"Resoluci\xf3n","metadata_quality":"Puntuaci\xf3n de calidad","metadata_quality_help":"M\xe1s informaci\xf3n sobre el nivel de calidad","metadata_quality_score":"Valoraci\xf3n general","metadata_quality_gps_score":"Puntuaci\xf3n de posicionamiento","metadata_quality_resolution_score":"Puntuaci\xf3n de resoluci\xf3n","metadata_quality_missing":"no hay informaci\xf3n en la imagen","report_wait":"Env\xedo del informe\u2026"},"psv":{"ctrlZoom":"Utiliza Control+rueda de desplazamiento para acercar/alejar","loadError":"Este panorama no se puede cargar","twoFingers":"Desplaza el mapa con dos dedos"},"maplibre":{"GeolocateControl.FindMyLocation":"Local\xedzame","GeolocateControl.LocationNotAvailable":"Localizaci\xf3n no disponible"},"map":{"loading":"Cargando\u2026","thumbnail":"Vista previa de la imagen bajo el cursor","not_public":"No es visible p\xfablicamente","slow_loading":"La mapa tarda mucho en cargarse y puede parecer rota"}}');
            },
            5222: (Qe)=>{
                "use strict";
                Qe.exports = JSON.parse('{"psv":{"twoFingers":"Utilisez deux doigts pour vous d\xe9placer","ctrlZoom":"Utilisez ctrl + scroll pour zoomer dans l\'image","loadError":"L\'image ne peut pas \xeatre charg\xe9e"},"maplibre":{"GeolocateControl.FindMyLocation":"Afficher ma position","GeolocateControl.LocationNotAvailable":"GPS non-disponible"},"pnx":{"zoom":"Zoom","zoomOut":"D\xe9zoomer","zoomIn":"Zoomer","moveUp":"Vers le haut","moveDown":"Vers le bas","moveLeft":"Vers la gauche","moveRight":"Vers la droite","moveMiddle":"Centrer la vue","expand":"Agrandir","expand_info":"Faire appara\xeetre ce widget en pleine page","show_psv":"Afficher la visionneuse de photos","show_map":"Afficher la carte","minimize":"Masquer ce widget, vous pouvez l\'afficher de nouveau gr\xe2ce au bouton dans le coin en bas \xe0 gauche","minimize_short":"Masquer","options":"Options","filters":"Filtres","layers":"Calques","search":"Rechercher","search_empty":"Aucun r\xe9sultat","search_address":"Rechercher une adresse, ville\u2026","search_user":"Rechercher un nom d\'utilisateur\u2026","share":"Partager","share_links":"Liens utiles","share_page":"Lien de la photo","share_image":"Image HD","share_rss":"Flux RSS","share_rss_title":"Flux RSS des nouvelles s\xe9quences dans la zone visible sur la carte","share_embed":"Int\xe9gration sur votre site","share_embed_docs":"D\xe9couvrir plus de possibilit\xe9s pour l\'int\xe9gration sur votre site","share_print":"Imprimer","whats_panoramax":"Panoramax est le g\xe9ocommun des photos des territoires.","copy":"Copier","copied":"Copi\xe9","error":"On a un probl\xe8me\u2026","error_click":"Continuer","error_retry":"Merci de r\xe9essayer plus tard","sequence_next":"Photo suivante dans la s\xe9quence","sequence_play":"Parcourir cette s\xe9quence","sequence_pause":"Mettre en pause la s\xe9quence","sequence_prev":"Photo pr\xe9c\xe9dente dans la s\xe9quence","sequence_more":"Plus d\'options de lecture","sequence_speed":"Vitesse de lecture","legend_license":"Licence : {l}","legend_title":"Afficher les d\xe9tails de l\'image","id":"iD","contribute_id":"Contribuez \xe0 OpenStreetMap avec l\'\xe9diteur iD","geo_uri":"App externe","josm":"JOSM","josm_live":"Active la synchronisation automatique de JOSM lors du chargement d\'une photo","loading_labels_serious":["\ud83d\uddfa\uFE0F Chargement du fond de carte","\ud83d\udda5\uFE0F Interrogation de l\'API","\ud83d\uddbc\uFE0F Chargement des miniatures","\ud83d\udd0d Analyse des m\xe9tadonn\xe9es EXIF","\ud83c\udfd8\uFE0F Cr\xe9ation du rendu 3D","\ud83d\udcf7 Initialisation des vues 360\xb0","\ud83d\udfe0 \xc9quilibrage des couleurs","\ud83d\udcaf Calcul du score qualit\xe9 \xa9","\ud83d\udce1 T\xe9l\xe9chargement des mises \xe0 jour","\ud83c\udf0d R\xe9cup\xe9ration des tuiles","\ud83d\udcf8 Traitement des ombres"],"loading_labels_fun":["\ud83e\udd8c D\xe9tection des panneaux biche","\ud83d\ude98 Recherche de la Panoramax Car \xa9","\u2615 Injection de caf\xe9ine","\ud83d\ude00 Souriez, vous \xeates mapp\xe9s !","\ud83d\udc08 Partage de photos de chats","\ud83d\ude34 R\xe9duction de la procrastination","\ud83c\uddf7\ud83c\uddea Chargement : 974%","\ud83d\udc27 Ouverture du code source","\ud83e\udd81 Indexation des traboules","\ud83e\uddf9 Nettoyage des m\xe9tadonn\xe9es","\ud83d\ude92 Envoi des photos du SDIS","\ud83d\udeb2 Mise \xe0 jour des voies vertes","\ud83d\ude89 Remont\xe9e des quais de gare","\ud83d\udef0\uFE0F Recherche de satellites","\ud83d\udc65 \xc9criture des personas","\ud83e\udd5e Localisation des cr\xeaperies","\ud83e\uddd1\u200D\ud83d\udcbb D\xe9boguage de l\'interface","\ud83d\udcc8 Incr\xe9mentation des statistiques","\ud83e\udd16 Apprentissage de la s\xe9mantique","\ud83c\udfa8 Redesign de l\'interface","\ud83d\udcc5 Planification des photos-carto-parties","\ud83e\uddc0 Affinage des fromages","\ud83c\udf04 Calcul de l\'ensoleillement corse","\ud83c\udf0a Mesure des grandes mar\xe9es"],"error_psv":"Photo Sphere Viewer ne s\'est pas charg\xe9 correctement","error_pic":"La photo demand\xe9e est introuvable","error_nopic":"Aucune photo disponible autour de la localisation recherch\xe9e","error_api":"Le serveur de photos n\'est pas disponible","error_webgl":"WebGL n\'est pas support\xe9 par votre navigateur","error_josm":"JOSM n\'a pas r\xe9pondu, est-il bien lanc\xe9 et la t\xe9l\xe9commande activ\xe9e ?","error_api_compatibility":"Le serveur de photos n\'est pas compatible avec cette visionneuse","filter_date":"Date","filter_date_1month":"1 mois","filter_date_6months":"6 mois","filter_date_1year":"1 an","filter_user":"Utilisateur","filter_user_mypics":"Mes photos","filter_picture":"Type d\'image","picture_all":"Tout","picture_flat":"Classique","picture_360":"360\xb0","picture_flat_long":"Photo classique","picture_360_long":"Photo panoramique","filter_qualityscore":"Score de qualit\xe9","filter_qualityscore_help":"Cliquez pour activer ou d\xe9sactiver","qualityscore_title":"\xc0 propos du score de qualit\xe9","qualityscore_doc_1":"Panoramax propose un Score de Qualit\xe9 pour chacune de ses photos. Cela facilite le filtre et la recherche de photos de bonne qualit\xe9 sur la carte.","qualityscore_doc_2":"Le score est affich\xe9 sous la forme d\'une lettre A/B/C/D/E (A \xe9tant le meilleur, E le moins bon), et visualisable gr\xe2ce \xe0 cette \xe9chelle :","qualityscore_doc_3":"Il est calcul\xe9 en fonction de la pr\xe9cision du GPS ainsi que la r\xe9solution de la photo. Un mat\xe9riel professionnel aura une note de A, une cam\xe9ra sportive 360\xb0 une note de B, et un smartphone une note de C \xe0 E.","qualityscore_doc_link":"En savoir plus sur le Score de Qualit\xe9","filter_zoom_in":"Zoomez la carte pour voir ce filtre","map_background":"Fond de carte","map_background_aerial":"Satellite","map_background_streets":"Plan","map_theme":"Rendu de carte","map_theme_default":"Classique","map_theme_age":"Date de prise de vue","map_theme_age_1":"> 2 ans","map_theme_age_2":"< 2 ans","map_theme_age_3":"< 1 an","map_theme_age_4":"< 1 mois","map_theme_type":"Type de cam\xe9ra","map_theme_score":"Score de qualit\xe9","contrast":"Augmenter le contraste de l\'image","metadata":"M\xe9tadonn\xe9es de la photo","metadata_summary":"R\xe9sum\xe9","metadata_general_copy_id":"Copier l\'ID","metadata_general_copy_picid":"Copier l\'ID de photo","metadata_general_picid":"Photo","metadata_general_seqid":"S\xe9quence","metadata_general_picid_link":"Aller au descriptif JSON de la photo","metadata_general_seqid_link":"Aller au descriptif JSON de la s\xe9quence","metadata_general_author":"Auteur","metadata_general_license":"Licence","metadata_general_license_link":"Voir la description compl\xe8te de la licence","metadata_general_date":"Date de prise de vue","metadata_general_instance":"Instance d\'origine","metadata_camera":"Appareil","metadata_camera_make":"Fabricant","metadata_camera_model":"Mod\xe8le","metadata_camera_type":"Type","metadata_camera_resolution":"R\xe9solution","metadata_camera_focal_length":"Longueur focale","metadata_location":"Position","metadata_location_coordinates":"Coordonn\xe9es (longitude, latitude)","metadata_location_orientation":"Direction","metadata_location_precision":"Pr\xe9cision du positionnement","metadata_location_copy":"Copier {v}","metadata_location_copy_more":"Copier d\'autres formats de coordonn\xe9es","metadata_quality":"Qualit\xe9","metadata_quality_help":"En savoir plus sur le score de qualit\xe9","metadata_quality_score":"Note globale","metadata_quality_gps_score":"Note du positionnement","metadata_quality_resolution_score":"Note de la r\xe9solution","metadata_quality_missing":"pas d\'info dans l\'image","metadata_exif":"EXIF","metadata_exif_name":"Balise","metadata_exif_value":"Valeur","metadata_exif_doc":"Doc des attributs EXIF","metadata_exif_doc_title":"Ac\xe9\xe9der \xe0 la doc Exiv2 pour en savoir plus sur les attributs EXIF et XMP","semantics_title":"Tags","semantics_tags":"{nb} attributs","semantics_features":"Objets d\xe9tect\xe9s","semantics_features_none":"Aucun objet n\'a \xe9t\xe9 d\xe9tect\xe9 ou annot\xe9 dans cette photo pour l\'instant.","semantics_features_default_title":"Objet #{nb}","semantics_features_subtitle":"{nb} attributs associ\xe9s","semantics_annotation_tooltip":"Cliquez pour voir les d\xe9tails","semantics_show_all_tags":"Voir tous les attributs","semantics_hide_all_tags":"Masquer les attributs","semantics_key":"Cl\xe9","semantics_value":"Valeur","semantics_key_doc":"En savoir plus \xe0 propos de cette cl\xe9","semantics_value_doc":"En savoir plus \xe0 propos de cet attribut","semantics_tags_picture":"Attributs de la photo","semantics_tags_picture_none":"Aucun attribut n\'a \xe9t\xe9 d\xe9fini pour cette photo pour l\'instant.","semantics_qualifiers":"Qualificateurs","semantics_wikidata_properties":{"P31":"instance de","P279":"sous-classe de","P361":"partie de"},"report":"Signaler","report_auth":"Ce signalement sera envoy\xe9 en utilisant votre compte \\"{a}\\"","report_nature_label":"Nature du probl\xe8me","report_nature":{"":"S\xe9lectionnez la nature du probl\xe8me\u2026","blur_missing":"Un visage ou une plaque d\'immatriculation est visible","blur_excess":"Un objet qui ne n\xe9cessite pas de floutage est flout\xe9","inappropriate":"L\'image est inappropri\xe9e (non pertinente, nudit\xe9\u2026)","privacy":"Un chemin priv\xe9 ou une propri\xe9t\xe9 priv\xe9e est visible","picture_low_quality":"L\'image est de mauvaise qualit\xe9","mislocated":"L\'image est mal g\xe9olocalis\xe9e","copyright":"L\'image enfreint les droits d\'auteur","other":"Tout autre type de probl\xe8me"},"report_whole_sequence":"Cela concerne toute la s\xe9quence","report_details":"D\xe9tails suppl\xe9mentaires","report_details_placeholder":"Optionnel, vous pouvez ajouter des d\xe9tails sur le probl\xe8me","report_email":"Votre email","report_email_placeholder":"Optionnel","report_submit":"Envoyer","report_wait":"Envoi du signalement en cours\u2026","report_success":"Le signalement a \xe9t\xe9 envoy\xe9 avec succ\xe8s. Il sera examin\xe9 d\xe8s que possible.","report_failure":"Une erreur est survenue lors de la cr\xe9ation du signalement : {e}. Veuillez r\xe9essayer plus tard."},"map":{"loading":"Chargement\u2026","thumbnail":"Miniature de la photo survol\xe9e","not_public":"Masqu\xe9 au public","slow_loading":"La carte est longue \xe0 charger et pourrait appara\xeetre cass\xe9e","map_data":"Donn\xe9es cartographiques :","more_panoramax":"En savoir plus sur Panoramax"}}');
            },
            6909: (Qe)=>{
                "use strict";
                Qe.exports = JSON.parse('{"psv":{"twoFingers":"K\xe9t ujjal navig\xe1lhat","ctrlZoom":"K\xf6zel\xedt\xe9s vagy t\xe1vol\xedt\xe1s: Ctrl + g\xf6rget\xe9s","loadError":"A panor\xe1ma nem t\xf6lthet\u0151 be"},"pnx":{"zoom":"Nagy\xedt\xe1s","zoomOut":"T\xe1vol\xedt\xe1s","zoomIn":"K\xf6zel\xedt\xe9s","moveUp":"Mozg\xe1s fel","moveDown":"Mozg\xe1s le","moveLeft":"Mozg\xe1s balra","moveRight":"Mozg\xe1s jobbra","moveMiddle":"N\xe9zet k\xf6z\xe9pre hoz\xe1sa","expand":"B\u0151v\xedt\xe9s","expand_info":"Widget megjelen\xedt\xe9se teljes oldalon","show_psv":"K\xe9pn\xe9zeget\u0151 megjelen\xedt\xe9se","show_map":"T\xe9rk\xe9p megjelen\xedt\xe9se","minimize":"Widget elrejt\xe9se; a bal als\xf3 sarokban l\xe9v\u0151 gombbal \xfajra megjelen\xedtheti","options":"Be\xe1ll\xedt\xe1sok","filters":"Sz\u0171r\u0151k","layers":"R\xe9tegek","share":"Megoszt\xe1s","search":"Keres\xe9s","search_empty":"Nincs tal\xe1lat","share_links":"Linkek","share_page":"Link erre az oldalra","share_image":"Nagy felbont\xe1s\xfa (HD) k\xe9p","share_rss":"RSS h\xedrcsatorna","share_rss_title":"A t\xe9rk\xe9p l\xe1that\xf3 ter\xfclet\xe9n l\xe9v\u0151 \xfaj sorozatok RSS-h\xedrcsatorn\xe1ja","share_embed":"Be\xe1gyaz\xe1s a weboldaladon","share_print":"Nyomtat\xe1s","copy":"M\xe1sol\xe1s","copied":"M\xe1solva","error":"Ajjaj, baj van\u2026","error_subtitle":"Pr\xf3b\xe1lja \xfajra k\xe9s\u0151bb, vagy n\xe9zze meg a b\xf6ng\xe9sz\u0151konzolt a tov\xe1bbi r\xe9szletek\xe9rt.","sequence_next":"A sorozat k\xf6vetkez\u0151 k\xe9pe","sequence_play":"Sorozat lej\xe1tsz\xe1sa","sequence_pause":"Sorozatlej\xe1tsz\xe1s sz\xfcneteltet\xe9se","sequence_prev":"A sorozat el\u0151z\u0151 k\xe9pe","sequence_more":"Tov\xe1bbi lej\xe1tsz\xe1si lehet\u0151s\xe9gek","sequence_speed":"Lej\xe1tsz\xe1s sebess\xe9ge","legend_license":"Licenc: {l}","edit_osm":"OSM szerkeszt\xe9se","id":"iD","josm":"JOSM","josm_live":"JOSM automatikus szinkroniz\xe1l\xe1s\xe1nak enged\xe9lyez\xe9se k\xe9pbet\xf6lt\xe9skor","loading_labels_serious":["\ud83d\uddfa\uFE0F T\xe9rk\xe9padatok bet\xf6lt\xe9se","\ud83d\udda5\uFE0F API lek\xe9rdez\xe9se","\ud83d\uddbc\uFE0F B\xe9lyegk\xe9pek bet\xf6lt\xe9se","\ud83d\udd0d EXIF metaadatok elemz\xe9se","\ud83c\udfd8\uFE0F 3D megjelen\xedt\xe9s","\ud83d\udcf7 360\xb0-os k\xe9pek inicializ\xe1l\xe1sa","\ud83d\udfe0 Sz\xednek kiegyenl\xedt\xe9se","\ud83d\udcaf Min\u0151s\xe9gi pontsz\xe1m kisz\xe1m\xedt\xe1sa \xa9"],"loading_labels_fun":["\ud83e\udd8c Vadvesz\xe9lyt jelz\u0151 t\xe1bla \xe9szlel\xe9se","\ud83d\ude98 Panoramax aut\xf3 \xa9 keres\xe9se","\u2615 Koffeininjekci\xf3","\ud83d\ude00 Mosolyogj, fel lett\xe9l t\xe9rk\xe9pezve!","\ud83d\udc08 Kiscic\xe1s k\xe9pek megoszt\xe1sa","\ud83d\ude34 Halogat\xe1s cs\xf6kkent\xe9se","\ud83e\uded6 Tea megf\u0151z\xe9se","\ud83d\udc27 Forr\xe1sk\xf3d felnyit\xe1sa","\ud83d\ude87 Metr\xf3\xe1llom\xe1sok indexel\xe9se","\ud83e\uddf9 Metaadatok tisztogat\xe1sa","\ud83d\ude92 T\u0171zolt\xf3s\xe1gr\xf3l sz\xf3l\xf3 fot\xf3k bek\xfcld\xe9se","\ud83d\udeb2 Z\xf6ldutak friss\xedt\xe9se","\ud83d\ude89 Peronok bej\xe1r\xe1sa","\ud83d\udef0\uFE0F M\u0171holdak keres\xe9se","\ud83d\udc65 Person\xe1k meg\xedr\xe1sa","\ud83d\udc1f S\xfcltkrumplikap\xf3k lokaliz\xe1l\xe1sa","\ud83e\uddd1\u200D\ud83d\udcbb Hibakeres\u0151 fel\xfclet","\ud83d\udcc8 Statisztika n\xf6vel\xe9se"],"error_psv":"A Photo Sphere Viewer (g\xf6mbpanor\xe1ma-n\xe9zeget\u0151) nem t\xf6lt\u0151dik be megfelel\u0151en","error_pic":"A k\xe9rt k\xe9p nem tal\xe1lhat\xf3","error_nopic":"Az adott helyen nem \xe9rhet\u0151 el k\xe9p","error_api":"A k\xe9pkiszolg\xe1l\xf3 nem \xe9rhet\u0151 el","error_webgl":"A WebGL nem t\xe1mogatott ebben a b\xf6ng\xe9sz\u0151ben","error_josm":"A JOSM nem v\xe1laszol. Val\xf3ban fut \xe9s el\xe9rhet\u0151 t\xe1volr\xf3l?","error_api_compatibility":"A k\xe9pkiszolg\xe1l\xf3 nem kompatibilis a k\xe9pn\xe9zeget\u0151 ezen verzi\xf3j\xe1val","filter_date":"D\xe1tum szerint","filter_user":"Felhaszn\xe1l\xf3 szerint","filter_picture":"K\xe9pt\xedpus szerint","picture_flat":"Klasszikus","picture_360":"360\xb0","filter_camera_model":"Kameramodell szerint","map_background":"T\xe9rk\xe9ph\xe1tt\xe9r","map_background_aerial":"L\xe9gi felv\xe9tel","map_background_streets":"k\xe9pUtca","map_theme":"T\xe9rk\xe9p t\xe9m\xe1ja","map_theme_default":"Klasszikus","map_theme_age":"K\xe9pk\xe9sz\xedt\xe9s ideje","map_theme_age_1":"> 2 \xe9ve","map_theme_age_2":"< 2 \xe9ve","map_theme_age_3":"< 1 \xe9ve","map_theme_age_4":"< 1 h\xf3napja","map_theme_type":"Kamerat\xedpus","contrast":"Nagyobb k\xe9pkontraszt enged\xe9lyez\xe9se","metadata":"K\xe9p metaadatai","metadata_general_picid":"K\xe9p azonos\xedt\xf3js","metadata_general_seqid":"Sorozat azonos\xedt\xf3ja","metadata_general_picid_link":"Ugr\xe1s a k\xe9p JSON le\xedr\xe1s\xe1hoz","metadata_general_seqid_link":"Ugr\xe1s a sorozat JSON le\xedr\xe1s\xe1hoz","metadata_general_author":"Szerz\u0151","metadata_general_license":"Licenc (enged\xe9ly)","metadata_general_license_link":"Ugr\xe1s a licenc teljes le\xedr\xe1s\xe1hoz","metadata_general_date":"K\xe9sz\xedt\xe9s d\xe1tuma","metadata_camera":"Kamera","metadata_camera_make":"Gy\xe1rt\xf3","metadata_camera_model":"Modell","metadata_camera_type":"T\xedpus","metadata_camera_focal_length":"Gy\xfajt\xf3t\xe1vols\xe1g","metadata_location":"Helysz\xedn","metadata_location_longitude":"Hossz\xfas\xe1g","metadata_location_latitude":"Sz\xe9less\xe9g","metadata_location_orientation":"Felv\xe9tel ir\xe1nya","metadata_location_precision":"Helymeghat\xe1roz\xe1s pontoss\xe1ga","metadata_exif":"EXIF / XMP","metadata_exif_name":"C\xedmke","metadata_exif_value":"\xc9rt\xe9k","report":"K\xe9p bejelent\xe9se","report_auth":"A jelent\xe9s a fi\xf3kod ({a}) felhaszn\xe1l\xe1s\xe1val lesz elk\xfcldve","report_nature":{"":"Probl\xe9ma jelleg\xe9nek kiv\xe1laszt\xe1sa\u2026","blur_missing":"A k\xe9pen l\xe1tszik egy szem\xe9ly arca vagy egy rendsz\xe1mt\xe1bla","blur_excess":"A k\xe9pen el van hom\xe1lyos\xedtva egy olyan objektum, amelynek \xe9lesnek kellene lennie","inappropriate":"A k\xe9p nem megfelel\u0151 (irrelev\xe1ns, meztelens\xe9get jelen\xedt meg stb.)","privacy":"A k\xe9pen mag\xe1n\xfat vagy mag\xe1nter\xfclet l\xe1that\xf3","picture_low_quality":"A k\xe9p nagyon rossz min\u0151s\xe9g\u0171","mislocated":"A k\xe9p rosszul van elhelyezve a t\xe9rk\xe9pen","copyright":"A k\xe9p szerz\u0151i jogot s\xe9rt","other":"B\xe1rmilyen m\xe1s jelleg\u0171 probl\xe9ma"},"report_nature_label":"Probl\xe9ma jellege","report_details":"Tov\xe1bbi r\xe9szletek","filter_zoom_in":"Nagy\xedts a sz\u0171r\u0151k l\xe1that\xf3v\xe1 t\xe9tel\xe9hez","report_email":"E-mail-c\xedm","report_email_placeholder":"Nem k\xf6telez\u0151","report_submit":"Bek\xfcld\xe9s","report_success":"A jelent\xe9s sikeresen be lett k\xfcldve; a lehet\u0151 leghamarabb megvizsg\xe1ljuk.","report_failure":"Hiba t\xf6rt\xe9nt a jelent\xe9s l\xe9trehoz\xe1sakor: {e}. K\xe9rj\xfck, pr\xf3b\xe1ld meg k\xe9s\u0151bb \xfajra.","search_user":"Felhaszn\xe1l\xf3n\xe9v keres\xe9se\u2026","search_address":"C\xedm, v\xe1ros stb. keres\xe9se\u2026","share_embed_docs":"Tov\xe1bbi inform\xe1ci\xf3 a be\xe1gyaz\xe1s konfigur\xe1l\xe1s\xe1r\xf3l","error_click":"Kattints a folytat\xe1shoz","error_retry":"K\xe9rj\xfck, pr\xf3b\xe1ld meg k\xe9s\u0151bb","legend_title":"K\xe9p adatainak megjelen\xedt\xe9se","report_whole_sequence":"A teljes sorozatra vonatkozik","report_wait":"Jelent\xe9s bek\xfcld\xe9se folyamatban\u2026","report_details_placeholder":"Megadhatsz tov\xe1bbi r\xe9szleteket a probl\xe9m\xe1r\xf3l (nem k\xf6telez\u0151)","filter_qualityscore_help":"Kattints az enged\xe9lyez\xe9shez vagy a letilt\xe1shoz","filter_qualityscore":"Min\u0151s\xe9gi pontsz\xe1m","map_theme_score":"Min\u0151s\xe9gi pontsz\xe1m","metadata_camera_resolution":"Felbont\xe1s","metadata_quality":"Min\u0151s\xe9gi pontsz\xe1m","metadata_quality_help":"Tov\xe1bbi tudnival\xf3k a min\u0151s\xe9gi pontsz\xe1mr\xf3l","metadata_quality_score":"\xd6sszes\xedtett pontsz\xe1m","metadata_quality_gps_score":"Pozicion\xe1l\xe1si pontsz\xe1m","metadata_quality_resolution_score":"Felbont\xe1si pontsz\xe1m","metadata_quality_missing":"a k\xe9pben nincs megadva \xe9rt\xe9k"},"map":{"loading":"Bet\xf6lt\xe9s\u2026","thumbnail":"A kurzor alatti k\xe9p b\xe9lyegk\xe9pe","not_public":"Nem l\xe1that\xf3 nyilv\xe1nosan","slow_loading":"A t\xe9rk\xe9p lassan t\xf6lt\u0151dik be, \xe9s lehet, hogy lerobbant"},"maplibre":{"GeolocateControl.FindMyLocation":"Tart\xf3zkod\xe1si hely megtal\xe1l\xe1sa","GeolocateControl.LocationNotAvailable":"Tart\xf3zkod\xe1si hely nem \xe9rhet\u0151 el"}}');
            },
            4895: (Qe)=>{
                "use strict";
                Qe.exports = JSON.parse('{"pnx":{"expand":"Espandi","zoomOut":"Rimpicciolisci","zoomIn":"Ingrandisci","zoom":"Zoom","moveUp":"Muovi in alto","moveDown":"Muovi in basso","moveLeft":"Muovi a sinistra","moveRight":"Muovi a destra","expand_info":"Fai apparire il widget a schermo pieno","options":"Opzioni","filters":"Filtri","layers":"Livelli","search":"Cerca","search_empty":"Nessun risultato trovato","search_address":"Cerca un indirizzo, citt\xe0\u2026","search_user":"Cerca un nome utente\u2026","share":"Condividi","share_links":"Collegamenti","share_page":"Collegamento a questa immagine","share_image":"Immagine HD","share_embed":"Incorpora nel tuo sito web","share_embed_docs":"Scopri di pi\xf9 sulla configurazione della incorporazione","share_print":"Stampa","copy":"Copia","copied":"Copiato","error":"Abbiamo un problema\u2026","error_click":"Continuare","error_retry":"Riprovare pi\xf9 tardi","sequence_play":"Riproduci questa sequenza","sequence_pause":"Pausa la sequenza","sequence_speed":"Velocit\xe0 di riproduzione","legend_license":"Licenza: {l}","legend_title":"Mostra dettagli della foto","edit_osm":"Modifica OSM","loading_labels_serious":["\ud83d\uddfa\uFE0F Caricamento dei dati della mappa","\ud83d\udda5\uFE0F Interrogazione delle API","\ud83d\uddbc\uFE0F Caricamento delle miniature","\ud83d\udd0d Analisi dei metadata EXIF","\ud83c\udfd8\uFE0F Creazione del rendering 3D","\ud83d\udcf7 Inizializzazione delle foto a 360\xb0","\ud83d\udfe0 Bilanciamento del colore","\ud83d\udcaf Calcolo del punteggio della qualit\xe0 \xa9","\ud83d\udce1 Scaricamento degli aggiornamenti","\ud83c\udf0d Recupero dei tasselli della mappa","\ud83d\udcf8 Elaborazione delle ombre"],"loading_labels_fun":["\ud83e\udd8c Rilevazione dei cartelli di attraversamento dei cervi","\ud83d\ude98 Ricerca dell\u2019auto Panoramax \xa9","\u2615 Iniezione di caffeina","\ud83d\ude00 Sorridete, siete stati mappati!","\ud83d\udc08 Condivisione delle foto di gatti","\ud83d\ude34 Riduzione della procrastinazione","\ud83e\uded6 Preparazione del t\xe8","\ud83d\udc27 Apertura del codice sorgente","\ud83d\ude87 Indicizzazione delle stazioni della metro","\ud83e\uddf9 Pulizia dei metadata","\ud83d\ude92 Invio delle foto delle stazioni dei pompieri","\ud83d\udeb2 Aggiornamento delle strade verdi","\ud83d\ude89 Passeggiata sulle banchine della stazione","\ud83d\udef0\uFE0F Ricerca dei satelliti","\ud83d\udc65 Scrittura delle persone","\ud83d\udc1f Ricerca dei negozi di patatine fritte","\ud83e\uddd1\u200D\ud83d\udcbb Debug dell\u2019interfaccia","\ud83d\udcc8 Incremento delle statistiche","\ud83e\udd16 Apprendimento della semantica","\ud83c\udfa8 Riprogettazione dell\u2019interfaccia","\ud83d\udcc5 Pianificazione di eventi di photo-mapping","\ud83e\uddc0 Affinamento dei formaggi","\ud83c\udf04 Calcolo della nebbia in Valpadana","\ud83c\udf0a Misurazione delle grandi maree"],"error_psv":"Il visualizzatore delle foto sferiche non si sta caricando correttamente","error_pic":"La foto richiesta non \xe8 stata trovata","error_nopic":"Nessuna foto disponibile alla posizione richiesta","error_api":"Il server delle foto non \xe8 disponibile","error_webgl":"Il tuo browser non supporta WebGL","error_josm":"JOSM non risponde, \xe8 in esecuzione con il controllo remoto abilitato?","error_api_compatibility":"Il server delle foto non \xe8 compatibile con questa versione del visualizzatore","filter_date":"Data","filter_date_1month":"1 mese","filter_date_1year":"1 anno","filter_user_mypics":"Le mie foto","filter_picture":"Tipo di foto","filter_zoom_in":"Ingrandisci la mappa per vedere questo filtro","picture_flat":"Classica","picture_360":"360\xb0","filter_qualityscore_help":"Clicca per abilitare o disabilitare","map_background":"Sfondo della mappa","map_background_aerial":"Satellite","map_background_streets":"Strade","map_theme":"Tema della mappa","map_theme_default":"Classica","map_theme_age":"Data di acquisizione","map_theme_age_2":"< 2 anni","map_theme_age_3":"< 1 anno","map_theme_age_4":"< 1 mese","map_theme_score":"Punteggio della qualit\xe0","contrast":"Abilita un maggiore contrasto della foto","metadata":"Metadata della foto","metadata_general_picid":"Foto","metadata_general_picid_link":"Vai alla descrizione JSON della foto","metadata_general_seqid_link":"Vai alla descrizione JSON della sequenza","metadata_general_author":"Autore","metadata_general_license":"Licenza","metadata_general_date":"Data di acquisizione","metadata_camera":"Fotocamera","metadata_camera_make":"Costruttore","metadata_camera_model":"Modello","metadata_camera_type":"Tipo","metadata_camera_resolution":"Risoluzione","metadata_location":"Posizione","metadata_location_longitude":"Longitudine","metadata_location_latitude":"Latitudine","metadata_location_precision":"Precisione della posizione","metadata_quality":"Qualit\xe0","metadata_quality_score":"Punteggio globale","metadata_quality_gps_score":"Punteggio della posizione","metadata_quality_resolution_score":"Punteggio della risoluzione","metadata_exif":"EXIF","metadata_exif_name":"Attributo","report_auth":"Questa segnalazione verr\xe0 inviata usando la tua utenza \u201C{a}\u201D","report_nature_label":"Natura del problema","report_nature":{"blur_excess":"Un oggetto che non ha bisogno di essere offuscato lo \xe8","inappropriate":"La foto \xe8 inappropriata (non pertinente, nudo, \u2026)","mislocated":"La foto non \xe8 ben posizionata sulla mappa","copyright":"La foto viola il diritto d\u2019autore","other":"Qualsiasi altro tipo di problema","picture_low_quality":"La foto \xe8 di qualit\xe0 scarsa","":"Selezione la natura del problema\u2026","blur_missing":"Sono visibili la faccia di una persona o la targa di un\u2019auto","privacy":"Sono visibili un sentiero o una propriet\xe0 privati"},"report_whole_sequence":"Riguarda l\u2019intera sequenza","report_details":"Ulteriori dettagli","report_email":"La tua e-mail","report_email_placeholder":"Facoltativo","report_submit":"Invia","report_wait":"Invio della segnalazione\u2026","report_failure":"\xc8 avvenuto un errore durante la creazione della segnalazione: {e}. Riprovare pi\xf9 tardi.","moveMiddle":"Centra la visuale","show_map":"Mostra la mappa","sequence_next":"Prossima foto nella sequenza","map_theme_age_1":"> 2 anni","map_theme_type":"Tipo di fotocamera","minimize":"Nascondi il widget, puoi mostrarlo di nuovo usando il pulsante nell\u2019angolo in basso a sinistra","metadata_general_license_link":"Vedi la descrizione completa della licenza","share_rss":"Feed RSS","show_psv":"Mostra il visualizzatore delle foto","share_rss_title":"Feed RSS delle nuove sequenze nell\u2019attuale area visibile della mappa","sequence_prev":"Foto precedente della sequenza","sequence_more":"Altre opzioni di riproduzione","josm_live":"Abilita la sincronizzazione automatica di JOSM al caricamento delle foto","metadata_general_seqid":"Sequenza","metadata_camera_focal_length":"Lunghezza focale","filter_user":"Utente","metadata_location_orientation":"Direzione","filter_qualityscore":"Punteggio della qualit\xe0","metadata_quality_help":"Per saperne di pi\xf9 sul punteggio della qualit\xe0","metadata_quality_missing":"Nessun valore impostato nella foto","metadata_exif_value":"Valore","report":"Segnala","report_details_placeholder":"Facoltativo, puoi aggiungere dei dettagli sul problema e sul perch\xe9 lo ritieni rilevante","report_success":"La segnalazione \xe8 stata inviata correttamente. Non appena possibile verr\xe0 esaminata.","minimize_short":"Nascondi","qualityscore_title":"Informazioni sul punteggio della qualit\xe0","qualityscore_doc_1":"Panoramax propone un Punteggio della qualit\xe0 per ogni foto. Ci\xf2 permette di filtrare facilmente la mappa e mostrare le foto di alta qualit\xe0 disponibili.","qualityscore_doc_2":"Il voto \xe8 mostrato agli utenti con un valore tipo A/B/C/D/E (A \xe8 il voto migliore, E il peggiore) e graficamente viene mostrato con la seguente scala:","qualityscore_doc_link":"Nella nostra documentazione sono presenti maggiori dettagli sul calcolo del Punteggio della qualit\xe0.","qualityscore_doc_3":"Esso \xe8 calcolato basandosi sulla precisione del GPS e sulla risoluzione della foto. Un sistema professionale avr\xe0 un punteggio A, un action camera a 360\xb0 avr\xe0 un punteggio B e uno smartphone verr\xe0 classificato come C, D o E.","metadata_general_instance":"Istanza di origine","josm":"JOSM","picture_flat_long":"Foto classica","picture_360_long":"Foto panoramica","metadata_summary":"Sintesi","metadata_general_copy_id":"Copia l\u2019ID","metadata_general_copy_picid":"Copia l\u2019ID della foto","id":"iD","contribute_id":"Contribuisci a OpenStreetMap con l\u2019editor iD","geo_uri":"App esterna","filter_date_6months":"6 mesi","picture_all":"Tutte","metadata_exif_doc":"Doc per gli attributi EXIF","metadata_exif_doc_title":"Vai alla documentazione di Exiv2 per i dettagli completi sulle definizioni degli attributi EXIF e XMP"},"psv":{"loadError":"Impossibile caricare l\u2019immagine panoramica","ctrlZoom":"Utilizza Ctrl + rotellina del mouse per ingrandire l\u2019immagine","twoFingers":"Usa due dita per spostarti"},"maplibre":{"GeolocateControl.FindMyLocation":"Trova la mia posizione","GeolocateControl.LocationNotAvailable":"Posizione non disponibile"},"map":{"loading":"Caricamento\u2026","thumbnail":"Miniatura della foto passata con il mouse","not_public":"Non pubblicamente visibile","slow_loading":"La mappa impiega troppo tempo a caricarsi e potrebbe apparire a pezzi","map_data":"Dati cartografici:","more_panoramax":"Per saperne di pi\xf9 su Panoramax"}}');
            },
            3979: (Qe)=>{
                "use strict";
                Qe.exports = JSON.parse('{"pnx":{"metadata_general_picid":"\u753B\u50CF\u8B58\u5225\u5B50","loading_labels_fun":["\ud83e\udd8c \u9E7F\u306E\u6A2A\u65AD\u6A19\u8B58\u306E\u691C\u51FA","\ud83d\ude98 Panoramax Car \xa9\u3092\u691C\u7D22","\u2615 \u30AB\u30D5\u30A7\u30A4\u30F3\u306E\u6CE8\u5165","\ud83d\ude00 \u7B11\u3063\u3066\u304F\u3060\u3055\u3044\u3001\u3042\u306A\u305F\u306F\u5730\u56F3\u306B\u8F09\u3063\u3066\u3044\u307E\u3059\uFF01","\ud83d\udc08 \u732B\u306E\u5199\u771F\u3092\u5171\u6709\u3059\u308B","\ud83d\ude34 \u5148\u5EF6\u3070\u3057\u3092\u6E1B\u3089\u3059","\ud83e\uded6 \u304A\u8336\u3092\u6DF9\u308C\u308B","\ud83d\udc27 \u30BD\u30FC\u30B9\u30B3\u30FC\u30C9\u3092\u516C\u958B","\ud83d\ude87 \u5730\u4E0B\u9244\u99C5\u306E\u7D22\u5F15","\ud83e\uddf9 \u30E1\u30BF\u30C7\u30FC\u30BF\u306E\u30AF\u30EA\u30FC\u30F3\u30A2\u30C3\u30D7","\ud83d\ude92 \u6D88\u9632\u7F72\u306E\u5199\u771F\u3092\u9001\u4FE1","\ud83d\udeb2 \u30B0\u30EA\u30FC\u30F3\u30A6\u30A7\u30A4\u30BA\u306E\u66F4\u65B0","\ud83d\ude89 \u99C5\u306E\u30DB\u30FC\u30E0\u306E\u30A6\u30A9\u30FC\u30AF\u30B9\u30EB\u30FC","\ud83d\udef0\uFE0F \u885B\u661F\u306E\u63A2\u7D22","\ud83d\udc65 \u30DA\u30EB\u30BD\u30CA\u3092\u66F8\u304F","\ud83d\udc1f \u30C1\u30C3\u30D7\u30B7\u30E7\u30C3\u30D7\u306E\u5834\u6240","\ud83e\uddd1\u200D\ud83d\udcbb \u30C7\u30D0\u30C3\u30B0\u30A4\u30F3\u30BF\u30FC\u30D5\u30A7\u30FC\u30B9","\ud83d\udcc8 \u7D71\u8A08\u306E\u5897\u52A0"],"share_embed_docs":"\u57CB\u3081\u8FBC\u307F\u8A2D\u5B9A\u306E\u8A73\u7D30\u3092\u8AAD\u3080","filter_zoom_in":"\u3053\u306E\u30D5\u30A3\u30EB\u30BF\u30FC\u3092\u8868\u793A\u3059\u308B\u306B\u306F\u62E1\u5927\u3057\u3066\u304F\u3060\u3055\u3044","metadata_camera_type":"\u30BF\u30A4\u30D7","minimize":"\u3053\u306E\u30A6\u30A3\u30B8\u30A7\u30C3\u30C8\u3092\u975E\u8868\u793A\u306B\u3059\u308B\u306B\u306F\u3001\u5DE6\u4E0B\u306E\u30DC\u30BF\u30F3\u3092\u4F7F\u7528\u3057\u3066\u518D\u5EA6\u8868\u793A\u3057\u307E\u3059","error_psv":"Photo Sphere Viewer \u304C\u6B63\u3057\u304F\u8AAD\u307F\u8FBC\u307E\u308C\u307E\u305B\u3093\u3067\u3057\u305F","error_josm":"JOSM \u304C\u5FDC\u7B54\u3057\u307E\u305B\u3093\u3002\u5B9F\u884C\u3055\u308C\u3066\u3044\u3066\u3001\u30EA\u30E2\u30FC\u30C8\u304C\u6709\u52B9\u306B\u306A\u3063\u3066\u3044\u307E\u3059\u304B?","filter_user":"\u30E6\u30FC\u30B6\u30FC","qualityscore_doc_3":"\u3053\u308C\u306F GPS \u306E\u7CBE\u5EA6\u3068\u753B\u50CF\u306E\u89E3\u50CF\u5EA6\u306B\u57FA\u3065\u3044\u3066\u8A08\u7B97\u3055\u308C\u307E\u3059\u3002\u30D7\u30ED\u4ED5\u69D8\u306E\u30B7\u30B9\u30C6\u30E0\u306F A \u8A55\u4FA1\u3001360\xb0 \u30A2\u30AF\u30B7\u30E7\u30F3 \u30AB\u30E1\u30E9\u306F B \u8A55\u4FA1\u3001\u30B9\u30DE\u30FC\u30C8\u30D5\u30A9\u30F3\u306F C/D/E \u8A55\u4FA1\u306B\u306A\u308A\u307E\u3059\u3002","report_nature":{"inappropriate":"\u5199\u771F\u304C\u4E0D\u9069\u5207\u3067\u3059\uFF08\u7121\u95A2\u4FC2\u3001\u30CC\u30FC\u30C9\u306A\u3069\uFF09","":"\u554F\u984C\u306E\u6027\u8CEA\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u2026","blur_missing":"\u4EBA\u306E\u9854\u3084\u8ECA\u306E\u30CA\u30F3\u30D0\u30FC\u30D7\u30EC\u30FC\u30C8\u304C\u898B\u3048\u308B","blur_excess":"\u307C\u304B\u3059\u5FC5\u8981\u306E\u306A\u3044\u30AA\u30D6\u30B8\u30A7\u30AF\u30C8\u304C\u307C\u3084\u3051\u3066\u3044\u308B","privacy":"\u30D7\u30E9\u30A4\u30D9\u30FC\u30C8\u30D1\u30B9\u307E\u305F\u306F\u30D7\u30ED\u30D1\u30C6\u30A3\u304C\u8868\u793A\u3055\u308C\u307E\u3059","picture_low_quality":"\u753B\u50CF\u306E\u54C1\u8CEA\u304C\u60AA\u3044","mislocated":"\u5730\u56F3\u4E0A\u306E\u5199\u771F\u306E\u4F4D\u7F6E\u304C\u9069\u5207\u3067\u306F\u3042\u308A\u307E\u305B\u3093","copyright":"\u753B\u50CF\u306F\u8457\u4F5C\u6A29\u3092\u4FB5\u5BB3\u3057\u3066\u3044\u307E\u3059","other":"\u305D\u306E\u4ED6\u306E\u554F\u984C"},"sequence_next":"\u6B21\u306E\u753B\u50CF","sequence_play":"\u3053\u306E\u30B7\u30FC\u30B1\u30F3\u30B9\u306B\u6CBF\u3063\u3066\u30D7\u30EC\u30A4\u3057\u3066\u304F\u3060\u3055\u3044","sequence_pause":"\u4E00\u6642\u505C\u6B62\u30B7\u30FC\u30B1\u30F3\u30B9","sequence_prev":"\u524D\u306E\u753B\u50CF","sequence_more":"\u3088\u308A\u591A\u304F\u306E\u30D7\u30EC\u30A4\u30AA\u30D7\u30B7\u30E7\u30F3","sequence_speed":"\u30D7\u30EC\u30A4\u30E4\u30FC\u306E\u30B9\u30D4\u30FC\u30C9","legend_license":"\u30E9\u30A4\u30BB\u30F3\u30B9: {l}","legend_title":"\u5199\u771F\u306E\u8A73\u7D30\u3092\u8868\u793A","edit_osm":"OSM\u306B\u8CA2\u732E\u3059\u308B","josm_live":"\u753B\u50CF\u8AAD\u307F\u8FBC\u307F\u6642\u306BJOSM\u81EA\u52D5\u540C\u671F\u3092\u6709\u52B9\u306B\u3059\u308B","loading_labels_serious":["\ud83d\uddfa\uFE0F \u30DE\u30C3\u30D7\u30C7\u30FC\u30BF\u306E\u8AAD\u307F\u8FBC\u307F","\ud83d\udda5\uFE0F \u30AF\u30A8\u30EAAPI","\ud83d\uddbc\uFE0F \u30B5\u30E0\u30CD\u30A4\u30EB\u3092\u8AAD\u307F\u8FBC\u3093\u3067\u3044\u307E\u3059","\ud83d\udd0d EXIF\u30E1\u30BF\u30C7\u30FC\u30BF\u306E\u5206\u6790","\ud83c\udfd8\uFE0F 3D\u30EC\u30F3\u30C0\u30EA\u30F3\u30B0","\ud83d\udcf7 360\xb0\u5199\u771F\u3092\u521D\u671F\u5316\u3057\u3066\u3044\u307E\u3059","\ud83d\udfe0 \u8272\u306E\u30D0\u30E9\u30F3\u30B9","\ud83d\udcaf \u30B3\u30F3\u30D4\u30E5\u30FC\u30C6\u30A3\u30F3\u30B0\u54C1\u8CEA\u30B9\u30B3\u30A2 \xa9"],"error_pic":"\u8981\u6C42\u3055\u308C\u305F\u5199\u771F\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3067\u3057\u305F","error_nopic":"\u6307\u5B9A\u3055\u308C\u305F\u4F4D\u7F6E\u306B\u306F\u753B\u50CF\u304C\u3042\u308A\u307E\u305B\u3093","error_api":"\u5199\u771F\u30B5\u30FC\u30D0\u30FC\u304C\u5229\u7528\u3067\u304D\u307E\u305B\u3093","error_webgl":"WebGL\u306F\u30D6\u30E9\u30A6\u30B6\u3067\u30B5\u30DD\u30FC\u30C8\u3055\u308C\u3066\u3044\u307E\u305B\u3093","error_api_compatibility":"\u753B\u50CF\u30B5\u30FC\u30D0\u30FC\u306F\u3053\u306E\u30D3\u30E5\u30FC\u30A2\u306E\u30D0\u30FC\u30B8\u30E7\u30F3\u3068\u4E92\u63DB\u6027\u304C\u3042\u308A\u307E\u305B\u3093","filter_date":"\u65E5\u4ED8","filter_date_1month":"1\u30F6\u6708","filter_date_1year":"1\u5E74","filter_user_mypics":"\u79C1\u306E\u5199\u771F","filter_picture":"\u753B\u50CF\u30BF\u30A4\u30D7","picture_flat":"\u30AF\u30E9\u30B7\u30C3\u30AF","picture_360":"360\xb0","filter_qualityscore":"\u54C1\u8CEA\u30B9\u30B3\u30A2","filter_qualityscore_help":"\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u6709\u52B9\u307E\u305F\u306F\u7121\u52B9\u306B\u3057\u307E\u3059","qualityscore_title":"\u54C1\u8CEA\u30B9\u30B3\u30A2\u306B\u3064\u3044\u3066","qualityscore_doc_1":"Panoramax \u306F\u3001\u5404\u5199\u771F\u306B\u54C1\u8CEA\u30B9\u30B3\u30A2\u3092\u63D0\u4F9B\u3057\u307E\u3059\u3002\u3053\u308C\u306B\u3088\u308A\u3001\u5730\u56F3\u30D5\u30A3\u30EB\u30BF\u30EA\u30F3\u30B0\u304C\u7C21\u5358\u306B\u306A\u308A\u3001\u9AD8\u54C1\u8CEA\u306E\u5199\u771F\u306E\u53EF\u7528\u6027\u3092\u5305\u62EC\u7684\u306B\u8868\u793A\u3067\u304D\u307E\u3059\u3002","qualityscore_doc_2":"\u8A55\u4FA1\u306F A/B/C/D/E \u30B9\u30B3\u30A2 (A \u304C\u6700\u9AD8\u3001E \u304C\u6700\u4F4E) \u3068\u3057\u3066\u30E6\u30FC\u30B6\u30FC\u306B\u8868\u793A\u3055\u308C\u3001\u6B21\u306E\u30B9\u30B1\u30FC\u30EB\u3067\u30B0\u30E9\u30D5\u8868\u793A\u3055\u308C\u307E\u3059\u3002","qualityscore_doc_link":"\u54C1\u8CEA\u30B9\u30B3\u30A2\u306E\u8A08\u7B97\u306E\u8A73\u7D30\u306B\u3064\u3044\u3066\u306F\u3001\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u3092\u3054\u89A7\u304F\u3060\u3055\u3044\u3002","map_background":"\u5730\u56F3\u306E\u80CC\u666F","map_background_aerial":"\u822A\u7A7A\u5199\u771F","map_background_streets":"\u901A\u308A","map_theme":"\u30DE\u30C3\u30D7\u30C6\u30FC\u30DE","map_theme_default":"\u30AF\u30E9\u30B7\u30C3\u30AF","map_theme_age":"\u64AE\u5F71\u65E5","map_theme_age_1":"2\u6B73\u4EE5\u4E0A","map_theme_age_2":"2\u6B73\u672A\u6E80","map_theme_age_3":"1\u6B73\u672A\u6E80","map_theme_age_4":"1\u304B\u6708\u672A\u6E80","map_theme_type":"\u30AB\u30E1\u30E9\u30BF\u30A4\u30D7","map_theme_score":"\u54C1\u8CEA\u30B9\u30B3\u30A2","contrast":"\u3088\u308A\u9AD8\u3044\u753B\u50CF\u30B3\u30F3\u30C8\u30E9\u30B9\u30C8\u3092\u6709\u52B9\u306B\u3059\u308B","metadata":"\u753B\u50CF\u30E1\u30BF\u30C7\u30FC\u30BF","metadata_general_seqid":"\u30B7\u30FC\u30B1\u30F3\u30B9\u8B58\u5225\u5B50","metadata_general_picid_link":"\u753B\u50CF\u306EJSON\u8AAC\u660E\u3078\u79FB\u52D5","metadata_general_seqid_link":"\u30B7\u30FC\u30B1\u30F3\u30B9\u306EJSON\u8A18\u8FF0\u3078\u79FB\u52D5","metadata_general_author":"\u8457\u8005","metadata_general_license":"\u30E9\u30A4\u30BB\u30F3\u30B9","metadata_general_license_link":"\u30E9\u30A4\u30BB\u30F3\u30B9\u306E\u5B8C\u5168\u306A\u8AAC\u660E\u3092\u898B\u308B","metadata_general_date":"\u64AE\u5F71\u65E5","metadata_camera":"\u30AB\u30E1\u30E9","metadata_camera_make":"\u30E1\u30FC\u30AB\u30FC","metadata_camera_model":"\u30E2\u30C7\u30EB","metadata_camera_resolution":"\u89E3\u50CF\u5EA6","metadata_camera_focal_length":"\u7126\u70B9\u8DDD\u96E2","metadata_location":"\u4F4D\u7F6E","metadata_location_longitude":"\u7D4C\u5EA6","metadata_location_latitude":"\u7DEF\u5EA6","metadata_location_orientation":"\u64AE\u5F71\u65B9\u5411","metadata_location_precision":"\u4F4D\u7F6E\u6C7A\u3081\u7CBE\u5EA6","metadata_quality":"\u54C1\u8CEA\u30B9\u30B3\u30A2","metadata_quality_help":"\u54C1\u8CEA\u30B9\u30B3\u30A2\u306B\u3064\u3044\u3066\u8A73\u3057\u304F\u77E5\u308B","metadata_quality_score":"\u30B0\u30ED\u30FC\u30D0\u30EB\u30B9\u30B3\u30A2","metadata_quality_gps_score":"\u30DD\u30B8\u30B7\u30E7\u30CB\u30F3\u30B0\u30B9\u30B3\u30A2","metadata_quality_resolution_score":"\u89E3\u6C7A\u30B9\u30B3\u30A2","metadata_quality_missing":"\u753B\u50CF\u306B\u5024\u304C\u8A2D\u5B9A\u3055\u308C\u3066\u3044\u307E\u305B\u3093","metadata_exif":"EXIF / XMP","metadata_exif_name":"\u30BF\u30B0","metadata_exif_value":"\u4FA1\u5024","report":"\u5199\u771F\u3092\u5831\u544A\u3059\u308B","report_auth":"\u3053\u306E\u30EC\u30DD\u30FC\u30C8\u306F\u3042\u306A\u305F\u306E\u30A2\u30AB\u30A6\u30F3\u30C8\u300C{a}\u300D\u3092\u4F7F\u7528\u3057\u3066\u9001\u4FE1\u3055\u308C\u307E\u3059","report_nature_label":"\u554F\u984C\u306E\u6027\u8CEA","report_whole_sequence":"\u3053\u308C\u306F\u30B7\u30FC\u30B1\u30F3\u30B9\u5168\u4F53\u306B\u95A2\u4FC2\u3059\u308B","report_details":"\u8FFD\u52A0\u306E\u8A73\u7D30","report_details_placeholder":"\u30AA\u30D7\u30B7\u30E7\u30F3\u3068\u3057\u3066\u3001\u554F\u984C\u306E\u8A73\u7D30\u3068\u305D\u308C\u304C\u3069\u306E\u3088\u3046\u306B\u95A2\u4FC2\u3057\u3066\u3044\u308B\u304B\u3092\u8FFD\u52A0\u3067\u304D\u307E\u3059","report_email":"\u3042\u306A\u305F\u306E\u30E1\u30FC\u30EB","report_email_placeholder":"\u30AA\u30D7\u30B7\u30E7\u30F3","report_submit":"\u9001\u4FE1","report_wait":"\u30EC\u30DD\u30FC\u30C8\u3092\u9001\u4FE1\u3057\u3066\u3044\u307E\u3059\u2026","report_success":"\u30EC\u30DD\u30FC\u30C8\u306F\u6B63\u5E38\u306B\u9001\u4FE1\u3055\u308C\u307E\u3057\u305F\u3002\u3067\u304D\u308B\u3060\u3051\u65E9\u304F\u78BA\u8A8D\u3055\u308C\u307E\u3059\u3002","report_failure":"\u30EC\u30DD\u30FC\u30C8\u306E\u4F5C\u6210\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F: {e}\u3002\u3057\u3070\u3089\u304F\u3057\u3066\u304B\u3089\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002","zoom":"\u30BA\u30FC\u30E0","zoomOut":"\u30BA\u30FC\u30E0\u30A2\u30A6\u30C8","zoomIn":"\u30BA\u30FC\u30E0\u30A4\u30F3","moveUp":"\u4E0A\u306B\u79FB\u52D5","moveDown":"\u4E0B\u306B\u79FB\u52D5","moveLeft":"\u5DE6\u306B\u79FB\u52D5","moveRight":"\u53F3\u306B\u79FB\u52D5","moveMiddle":"\u30D3\u30E5\u30FC\u3092\u4E2D\u592E\u306B\u914D\u7F6E\u3059\u308B","expand":"\u62E1\u5927\u3059\u308B","expand_info":"\u30A6\u30A3\u30B8\u30A7\u30C3\u30C8\u3092\u5168\u30DA\u30FC\u30B8\u306B\u8868\u793A\u3059\u308B","show_psv":"\u753B\u50CF\u30D3\u30E5\u30FC\u30A2\u3092\u8868\u793A\u3059\u308B","show_map":"\u5730\u56F3\u3092\u8868\u793A","minimize_short":"\u96A0\u308C\u308B","options":"\u30AA\u30D7\u30B7\u30E7\u30F3","filters":"\u30D5\u30A3\u30EB\u30BF\u30FC","layers":"\u30EC\u30A4\u30E4\u30FC","search":"\u691C\u7D22","search_empty":"\u7D50\u679C\u306A\u3057","search_address":"\u4F4F\u6240\u3001\u5E02\u533A\u753A\u6751\u306A\u3069\u3092\u691C\u7D22","search_user":"\u30E6\u30FC\u30B6\u30FC\u540D\u3092\u691C\u7D22\u2026","share":"\u5171\u6709","share_links":"\u30EA\u30F3\u30AF","share_page":"\u3053\u306E\u30DA\u30FC\u30B8\u3078\u306E\u30EA\u30F3\u30AF","share_image":"HD\u753B\u50CF","share_rss":"RSS\u30D5\u30A3\u30FC\u30C9","share_rss_title":"\u73FE\u5728\u8868\u793A\u3055\u308C\u3066\u3044\u308B\u30DE\u30C3\u30D7\u30A8\u30EA\u30A2\u5185\u306E\u65B0\u3057\u3044\u30B7\u30FC\u30B1\u30F3\u30B9\u306E RSS \u30D5\u30A3\u30FC\u30C9","share_embed":"\u30A6\u30A7\u30D6\u30B5\u30A4\u30C8\u306B\u57CB\u3081\u8FBC\u3080","share_print":"\u5370\u5237","copy":"\u30B3\u30D4\u30FC","copied":"\u30B3\u30D4\u30FC\u3057\u307E\u3057\u305F","error":"\u554F\u984C\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u2026","error_click":"\u7D9A\u304F","error_retry":"\u5F8C\u3067\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044"},"map":{"loading":"\u8AAD\u307F\u8FBC\u307F\u4E2D\u2026","thumbnail":"\u30DB\u30D0\u30FC\u3057\u305F\u753B\u50CF\u306E\u30B5\u30E0\u30CD\u30A4\u30EB","not_public":"\u516C\u958B\u3055\u308C\u306A\u3044","slow_loading":"\u30DE\u30C3\u30D7\u306E\u8AAD\u307F\u8FBC\u307F\u304C\u9045\u304F\u3001\u58CA\u308C\u3066\u3044\u308B\u3088\u3046\u306B\u898B\u3048\u308B\u5834\u5408\u304C\u3042\u308A\u307E\u3059"},"psv":{"twoFingers":"2\u672C\u306E\u6307\u3067\u79FB\u52D5\u3057\u307E\u3059","ctrlZoom":"Ctrl + \u30B9\u30AF\u30ED\u30FC\u30EB\u3067\u753B\u50CF\u3092\u62E1\u5927\u3057\u307E\u3059","loadError":"\u753B\u50CF\u3092\u8AAD\u307F\u8FBC\u3081\u307E\u305B\u3093"},"maplibre":{"GeolocateControl.FindMyLocation":"\u81EA\u5206\u306E\u4F4D\u7F6E\u3092\u8868\u793A","GeolocateControl.LocationNotAvailable":"GPS\u306F\u5229\u7528\u3067\u304D\u307E\u305B\u3093"}}');
            },
            6920: (Qe)=>{
                "use strict";
                Qe.exports = JSON.parse('{"pnx":{"zoomIn":"Zoom in","zoom":"Zoom","zoomOut":"Zoom uit","moveDown":"Naar beneden","search_user":"Zoek een gebruikersnaam\u2026","moveUp":"Ga omhoog","share_rss":"RSS-feed","loading_labels_serious":["\ud83d\uddfa\uFE0F Kaart aan het laden","\ud83d\udda5\uFE0F API opvragen","\ud83d\uddbc\uFE0F Miniatuurweergaven laden","\ud83d\udd0d EXIF metadata analyseren","\ud83c\udfd8\uFE0F 3D-rendering","\ud83d\udcf7 360\xb0 afbeelden initialiseren","\ud83d\udfe0 Kleur balancering","\ud83d\udcaf Bereken kwaliteits-score \xa9","\ud83d\udce1 Updates downloaden","\ud83c\udf0d Kaarttegels ophalen","\ud83d\udcf8 Schaduwen verwerken"],"share_embed_docs":"Lees meer over embedded instellingen","sequence_pause":"Pauzeer sequentie","sequence_prev":"Vorige afbeelding uit de sequentie","id":"iD","josm":"JOSM","sequence_more":"Meer afspeelmogelijkheden","sequence_speed":"Afspeel snelheid","edit_osm":"OSM aanpassen","moveLeft":"Naar links","moveRight":"Naar rechts","moveMiddle":"Middelpunt","expand":"Vergroot","show_psv":"Toon de afbeeldingsviewer","show_map":"Toon de kaart","options":"Opties","filters":"Filters","layers":"Lagen","search":"Zoek","search_empty":"Geen resultaat gevonden","search_address":"Zoek een adres, stad\u2026","share":"Deel","share_links":"Links","share_page":"Link naar deze foto","share_image":"HD afbeelding","share_embed":"Embedden op uw website","share_print":"Afdrukken","copy":"Kopieer","copied":"Gekopieerd","error":"We hebben een probleem\u2026","sequence_next":"Volgende afbeelding van de sequentie","error_click":"Klik om verder te gaan","error_retry":"Probeer later opnieuw","legend_license":"Licentie: {l}","legend_title":"Toon gegevens van de afbeelding","sequence_play":"Speel deze sequentie af","expand_info":"De widget op de volledige pagina weergeven","minimize":"Verberg deze widget, je kan hem terug tonen met de knop linksonder","loading_labels_fun":["\ud83e\udd8c Detectie verkeersborden overstekende herten","\ud83d\ude98 Panoramax auto zoeken \xa9","\u2615 Cafe\xefne-injectie","\ud83d\ude00 Gelukt, je kaart is gekaart!","\ud83d\udc08 Foto\'s delen van katten","\ud83d\ude34 Uitstelgedrag verminderen","\ud83e\uded6 Thee zetten","\ud83d\udc27 Broncode openen","\ud83d\ude87 Indexering metrostations","\ud83e\uddf9 Metadata opschonen","\ud83d\ude92 Foto\'s van brandweerkazernes versturen","\ud83d\udeb2 Fiets- en wandelpaden bijwerken","\ud83d\ude89 Perron doorgang","\ud83d\udef0\uFE0F Satellieten zoeken","\ud83d\udc65 Personas opslaan","\ud83e\udd5e Pannenkoekenhuizen localiseren","\ud83e\uddd1\u200D\ud83d\udcbb Interface debuggen","\ud83d\udcc8 Statistieken verhogen","\ud83e\udd16 Semantiek aanleren","\ud83c\udfa8 Interface herontwerpen","\ud83d\udcc5 Fotomappingparty\'s plannen","\ud83e\uddc0 Kazen laten rijpen"],"share_rss_title":"RSS-feed van nieuwe reeksen in het nu zichtbare kaartgebied","josm_live":"Schakel JOSM automatische synchronisatie in bij het laden van afbeeldingen","minimize_short":"Verbergen","error_psv":"Photo Sphere Viewer werd niet correct geladen","error_nopic":"Geen foto beschikbaar op de aangegeven locatie","error_api":"De fotoserver is niet beschikbaar","error_webgl":"WebGL wordt niet ondersteund door je browser","error_api_compatibility":"De fotoserver is niet compatibel met deze viewer","filter_date_1month":"1 maand","filter_date_1year":"1 jaar","filter_user":"Gebruiker","filter_user_mypics":"Mijn foto\'s","filter_picture":"Afbeeldingstype","picture_flat":"Klassiek","picture_360":"360\xb0","filter_qualityscore":"Kwaliteitsscore","qualityscore_doc_2":"De score wordt getoond als een letter A/B/C/D/E (waarbij A het beste is en E het slechtse), en wordt grafisch weergegeven volgens deze schaal:","qualityscore_doc_link":"Meer weten over de Kwaliteitsscore","map_background":"Kaartachtergrond","map_background_aerial":"Satelliet","map_background_streets":"Straten","map_theme":"Kaartthema","map_theme_default":"Klassiek","map_theme_age":"Opnamedatum","map_theme_age_3":"< 1 jaar","map_theme_age_4":"< 1 maand","filter_qualityscore_help":"Klik om aan- of uit te schakelen","report_failure":"Er is een fout opgetreden bij het aanmaken van het rapport: {e}. Probleem later opnieuw.","map_theme_score":"Kwaliteitsscore","contrast":"Afbeeldingscontrast verhogen","metadata":"Metadata van de foto","metadata_camera_make":"Fabrikant","filter_date":"Datum","filter_zoom_in":"Zoom in om deze filter te zien","metadata_general_license_link":"De volledige beschrijving van de licentie bekijken","metadata_general_seqid":"Identificator van de sequentie","metadata_general_picid_link":"Ga naar de JSON-beschrijving van de foto","metadata_general_seqid_link":"Ga naar de JSON-beschrijving van de sequentie","metadata_general_author":"Auteur","error_josm":"JOSM antwoord niet, is het actief en is afstandsbediening ingeschakeld?","qualityscore_title":"Over de kwaliteitsscore","metadata_general_license":"Licentie","error_pic":"The gevraagde foto werd niet gevonden","map_theme_age_2":"< 2 jaar","metadata_general_picid":"Identificator van de foto","metadata_general_date":"Opnamedatum","map_theme_type":"Cameratype","qualityscore_doc_1":"Panoramax toont een Kwaliteitsscore voor elke foto. Dit vergemakkelijkt filtering en laat toe om foto\'s van hoge kwaliteit te vinden.","qualityscore_doc_3":"Hij wordt berekend op basis van de GPS-nauwkeurigheid en resolutie van de foto. Een professioneel systeem zal een A-score hebben, een 360\xb0 actiecamera een B-score, en een smartphone een C/D/E-score.","map_theme_age_1":"> 2 jaar","report_details_placeholder":"Je kan, optioneel, details over het probleem toevoegen","metadata_camera":"Apparaat","metadata_camera_model":"Model","metadata_camera_type":"Type","metadata_camera_resolution":"Resolutie","metadata_camera_focal_length":"Brandpuntsafstand","metadata_location":"Locatie","metadata_location_longitude":"Longitude","metadata_location_latitude":"Latitude","metadata_location_orientation":"Opnamerichting","metadata_location_precision":"Nauwkeurigheid van de positionering","metadata_quality":"Kwaliteitsscore","metadata_quality_help":"Meer weten over de Kwaliteitsscore","metadata_quality_score":"Globale score","metadata_quality_gps_score":"Positioneringsscore","metadata_quality_resolution_score":"Resolutiescore","metadata_quality_missing":"geen info in de afbeelding","metadata_exif":"EXIF / XMP","metadata_exif_name":"Tag","metadata_exif_value":"Waarde","report":"Foto rapporteren","report_auth":"Dit rapport zal worden verstuurd met je account \\"{a}\\"","report_nature_label":"Aard van het probleem","report_nature":{"":"Selecteer de aard van het probleem \u2026","blur_missing":"Het gezicht van een persoon of een nummerplaat is zichtbaar","blur_excess":"Een object dat niet vervaagd moet worden is vervaagd","inappropriate":"De foto is ongepast (ongerelateerd, naaktheid \u2026)","privacy":"Een private weg of een privaat eigendom is zichtbaar","picture_low_quality":"De foto is van slechte kwaliteit","mislocated":"De foto is slecht gepositioneerd","copyright":"De foto schendt het auteursrecht","other":"Een ander soort probleem"},"report_whole_sequence":"Dit betreft de volledige sequentie","report_details":"Aanvullende details","report_email":"Je e-mail","report_email_placeholder":"Optioneel","report_submit":"Verzenden","report_wait":"Rapport verzenden \u2026","report_success":"Het rapport werd succesvol verzonden. Het zal zo snel mogelijk behandeld worden.","whats_panoramax":"Panoramax is de geo-commons voor foto\'s van gebieden.","contribute_id":"Bijdragen aan OpenStreetMap met de iD-editor","geo_uri":"Externe app"},"psv":{"twoFingers":"Gebruik twee vingers om te navigeren","ctrlZoom":"Gebruik ctrl + scroll om de afbeelding in en uit te zoomen","loadError":"Het panorama kan niet worden geupload"},"maplibre":{"GeolocateControl.FindMyLocation":"Mijn locatie zoeken","GeolocateControl.LocationNotAvailable":"Locatitie niet beschikbaar"},"map":{"loading":"Laden \u2026","slow_loading":"De kaart laadt traag en kan er gebroken uitzien","thumbnail":"Thumbnail van de aangeduide foto","not_public":"Niet openbaar zichtbaar","map_data":"Kaartdata:","more_panoramax":"Meer weten over Panoramax"}}');
            },
            9026: (Qe)=>{
                "use strict";
                Qe.exports = JSON.parse('{"pnx":{"moveRight":"Przesu\u0144 w prawo","sequence_speed":"Pr\u0119dko\u015B\u0107 odtwarzania","metadata_camera_model":"Model","search_address":"Szukaj adres, miasto\u2026","zoom":"Przybli\u017Cenie","zoomIn":"Przybli\u017C","moveUp":"Przesu\u0144 w g\xf3r\u0119","moveDown":"Przesu\u0144 w d\xf3\u0142","moveLeft":"Przesu\u0144 w lewo","moveMiddle":"Wycentruj widok","expand":"Rozszerz","show_psv":"Poka\u017C przegl\u0105dark\u0119 zdj\u0119\u0107","show_map":"Poka\u017C map\u0119","options":"Opcje","filters":"Filtry","layers":"Warstwy","search":"Szukaj","search_empty":"Brak wynik\xf3w","search_user":"Szukaj nazwy u\u017Cytkownika\u2026","share":"Udost\u0119pnij","share_links":"Linki","share_page":"Link do tej strony","share_rss":"Kana\u0142 RSS","share_print":"Drukuj","copy":"Kopiuj","copied":"Skopiowano","error":"Mamy problem\u2026","error_click":"Kliknij, aby kontynuowa\u0107","error_retry":"Prosz\u0119 spr\xf3buj p\xf3\u017Aniej","sequence_next":"Nast\u0119pne zdj\u0119cie w sekwencji","sequence_pause":"Spauzuj sekwencj\u0119","sequence_prev":"Poprzednie zdj\u0119cie w sekwencji","sequence_more":"Wi\u0119cej opcji odtwarzania","legend_license":"Licencja: {l}","legend_title":"Poka\u017C szczeg\xf3\u0142y zdj\u0119cia","edit_osm":"Edytuj OSM","loading_labels_serious":["\ud83d\uddfa\uFE0F Wczytywanie danych mapy","\ud83d\udda5\uFE0F Odpytywanie API","\ud83d\uddbc\uFE0F Wczytywanie miniaturek","\ud83d\udd0d Analizowanie metadanych EXIF","\ud83c\udfd8\uFE0F Renderowanie 3D","\ud83d\udcf7 Inicjowanie zdj\u0119\u0107 360\xb0","\ud83d\udfe0 Balansowanie kolor\xf3w","\ud83d\udcaf Obliczanie oceny jako\u015Bci \xa9"],"map_theme_age_2":"< 2 lata","map_theme_age_1":"> 2 lata","map_theme_age":"Data zrobienia","filter_picture":"Typ zdj\u0119cia","map_theme_age_3":"< rok","map_theme_age_4":"< miesi\u0105c","map_theme_type":"Typ aparatu","metadata":"Metadane zdj\u0119cia","metadata_general_picid":"Identyfikator zdj\u0119cia","metadata_general_seqid":"Identyfikator sekwencji","metadata_general_license":"Licencja","metadata_general_author":"Autor","metadata_camera":"Aparat","metadata_camera_type":"Typ","metadata_camera_resolution":"Rozdzielczo\u015B\u0107","metadata_location":"Lokalizacja","metadata_exif":"EXIF / XMP","metadata_quality_missing":"Brak warto\u015Bci ustawionej w zdj\u0119ciu","metadata_exif_name":"Tag","metadata_exif_value":"Warto\u015B\u0107","report":"Zg\u0142o\u015B zdj\u0119cie","report_nature":{"privacy":"Prywatna droga lub w\u0142asno\u015B\u0107 widoczna","mislocated":"Zdj\u0119cie jest w z\u0142ym miejscu na mapie","copyright":"Zdj\u0119cie narusza prawa autorskie","picture_low_quality":"Zdj\u0119cie jest bardzo niskiej jako\u015Bci","other":"Inny problem","":"Wybierz typ problemu\u2026","blur_missing":"Twarz osoby lub rejestracja samochodu jest widoczna","blur_excess":"Obiekt, kt\xf3ry nie wymaga zamazania jest zamazany","inappropriate":"Zdj\u0119cie jest niestosowne (niezwi\u0105zane, nago\u015B\u0107\u2026)"},"zoomOut":"Oddal","report_whole_sequence":"Dotyczy ca\u0142ej sekwencji","report_details":"Dodatkowe szczeg\xf3\u0142y","report_email":"Tw\xf3j adres email","report_email_placeholder":"Opcjonalne","report_submit":"Wy\u015Blij","report_wait":"Wysy\u0142anie zg\u0142oszenia\u2026","report_success":"Zg\u0142oszenie zosta\u0142o wys\u0142ane. Zostanie przejrzane tak szybko jak to mo\u017Cliwe.","share_rss_title":"Kana\u0142 RSS nowych sekwencji na widocznym obszarze mapy","loading_labels_fun":["\ud83e\udd8c Wykrywanie znak\xf3w przechodzenia jeleni",null,"\u2615 Wstrzykiwanie kofeiny","\ud83d\ude00 U\u015Bmiechnij si\u0119, jeste\u015B mapowany!","\ud83d\udc08 Udost\u0119pnianie zdj\u0119\u0107 kot\xf3w","\ud83d\ude34 Zmniejszania prokrastynacji","\ud83e\uded6 Parzenie herbaty","\ud83d\udc27 Otwieranie kodu \u017Ar\xf3d\u0142owego","\ud83d\ude87 Indeksowanie stacji metra","\ud83e\uddf9 Czyszczenie metadanych","\ud83d\ude92 Przesy\u0142anie zdj\u0119\u0107 remiz",null,"\ud83d\ude89 Przechodzenie peron\xf3w stacji","\ud83d\udef0\uFE0F Wyszukiwanie satelit",null,"\ud83d\udc1f Szukanie sklep\xf3w z frytkami i ryb\u0105","\ud83e\uddd1\u200D\ud83d\udcbb Interfejs debugowania","\ud83d\udcc8 Zwi\u0119kszanie statystyk"],"share_embed_docs":"Przeczytaj wi\u0119cej o konfiguracji osadzenia","sequence_play":"Odtw\xf3rz t\u0119 sekwencj\u0119","josm_live":"W\u0142\u0105cz automatyczn\u0105 synchronizacj\u0119 JOSM przy \u0142adowaniu zdj\u0119\u0107","error_api":"Serwer zdj\u0119\u0107 nie jest dost\u0119pny","error_webgl":"WebGL nie jest obs\u0142ugiwany przez t\u0119 przegl\u0105dark\u0119","error_api_compatibility":"Serwer zdj\u0119\u0107 nie jest kompatybilny z t\u0105 wersj\u0105 przegl\u0105darki","filter_date":"Data","filter_date_1month":"1 miesi\u0105c","filter_date_1year":"1 rok","filter_user":"U\u017Cytkownik","filter_user_mypics":"Moje zdj\u0119cia","filter_zoom_in":"Przybli\u017C, aby filtry by\u0142y widoczne","picture_flat":"Klasyczne","picture_360":"360\xb0","filter_qualityscore":"Ocena jako\u015Bci","map_background":"Podk\u0142ad mapowy","map_background_aerial":"Zdj\u0119cia lotnicze","map_background_streets":"Ulice","map_theme":"Motyw mapy","map_theme_default":"Klasyczny","map_theme_score":"Ocena jako\u015Bci","contrast":"W\u0142\u0105cz wy\u017Cszy kontrast zdj\u0119cia","metadata_general_picid_link":"Id\u017A do opisu zdj\u0119cia w JSON","metadata_general_seqid_link":"Id\u017A do opisu sekwencji w JSON","metadata_general_license_link":"Id\u017A do strony z pelnym opisem licencji","metadata_general_date":"Data zrobienia","metadata_camera_make":"Marka","metadata_camera_focal_length":"Ogniskowa","metadata_location_longitude":"D\u0142ugo\u015B\u0107 geograficzna","metadata_location_latitude":"Szeroko\u015B\u0107 geograficzna","metadata_location_orientation":"Kierunek robienia zdj\u0119cia","metadata_location_precision":"Precyzja lokalizacji","metadata_quality":"Ocena jako\u015Bci","metadata_quality_help":"Dowiedz si\u0119 wi\u0119cej o ocenie jako\u015Bci","metadata_quality_score":"Ocena globalna","metadata_quality_gps_score":"Ocena pozycji","metadata_quality_resolution_score":"Ocena rozdzielczo\u015Bci","report_auth":"To zg\u0142oszenie b\u0119dzie wys\u0142anie przy pomocy Twojego konta \\"{a}\\"","report_nature_label":"Typ problemu","report_details_placeholder":"Opcjonalnie, mo\u017Cesz doda\u0107 szczeg\xf3\u0142y o problemie","report_failure":"B\u0142\u0105d wyst\u0105pi\u0142 podczas tworzenia zg\u0142oszenia: {e}. Prosz\u0119 spr\xf3buj ponownie.","filter_qualityscore_help":"Kliknij, aby w\u0142\u0105czy\u0107 lub wy\u0142\u0105czy\u0107","error_josm":"JOSM nie odpowiada, czy jest uruchomiony i czy dost\u0119p zdalny jest w\u0142\u0105czony?"},"psv":{"twoFingers":"U\u017Cyj dw\xf3ch palc\xf3w do nawigacji","ctrlZoom":"U\u017Cyj ctrl + rolka myszy, aby powi\u0119kszy\u0107 zdj\u0119cie","loadError":"Panorama nie mo\u017Ce by\u0107 za\u0142adowana"},"maplibre":{"GeolocateControl.FindMyLocation":"Znajd\u017A moj\u0105 lokalizacj\u0119","GeolocateControl.LocationNotAvailable":"Lokalizacja niedost\u0119pna"},"map":{"thumbnail":"Miniaturki najechanego zdj\u0119cia","not_public":"Niewidoczne publicznie","slow_loading":"Mapa \u0142aduje si\u0119 wolno i mo\u017Ce si\u0119 wydawaj popsuta","loading":"\u0141adowanie\u2026"}}');
            },
            991: (Qe)=>{
                "use strict";
                Qe.exports = JSON.parse('{"psv":{"twoFingers":"Anv\xe4nd tv\xe5 fingrar f\xf6r att panorera","loadError":"Panoramat kan inte laddas","ctrlZoom":"Anv\xe4nd ctrl + scroll f\xf6r att zooma in p\xe5 bilden"},"pnx":{"moveUp":"Flytta upp","zoom":"Zoom","zoomOut":"Zooma ut","zoomIn":"Zooma in","moveDown":"Flytta ner","moveLeft":"Flytta v\xe4nster","moveRight":"Flytta h\xf6ger","moveMiddle":"Centrera vy","expand":"Expandera","show_psv":"Visa bildvisaren","show_map":"Visa kartan","expand_info":"Visa widgeten p\xe5 hela sidan","minimize":"G\xf6m denna flik, du kan visa den igen genom att anv\xe4nda knappen i nedersta v\xe4nstra h\xf6rnet","minimize_short":"G\xf6m","options":"Alternativ","search":"S\xf6k","search_empty":"Inga resultat hittade","filters":"Filter","layers":"Lager","share":"Dela","share_links":"L\xe4nkar","share_page":"L\xe4nka till denna sida","share_image":"HD bild","share_rss":"RSS feed","share_embed":"B\xe4dda in p\xe5 din hemsida","share_embed_docs":"L\xe4s mer om inb\xe4ddad konfiguration","share_print":"Skriv ut","copy":"Kopiera","copied":"Kopierad","error":"Vi har ett problem\u2026","error_click":"Forts\xe4tt","error_retry":"V\xe4nligen f\xf6rs\xf6k igen senare","sequence_next":"N\xe4sta bild i sekvensen","sequence_play":"Spela upp bilder i sekvensen","sequence_pause":"Pausa sekvens","sequence_more":"Mera uppspelningsalternativ","sequence_speed":"Uppspelningshastighet","legend_license":"Licens: {l}","search_address":"S\xf6k en adress, stad\u2026","edit_osm":"Redigera OSM","loading_labels_serious":["\ud83d\uddfa\uFE0F Laddar kartdata","\ud83d\udda5\uFE0F Anropar API","\ud83d\uddbc\uFE0F Laddar miniatyrer","\ud83d\udd0d Analyserar EXIF metadata","\ud83c\udfd8\uFE0F 3D rendering","\ud83d\udcf7 Initialiserar 360\xb0 bilder","\ud83d\udfe0 F\xe4rg balansering","\ud83d\udcaf Ber\xe4kna Kvalitetspo\xe4ng \xa9"],"loading_labels_fun":["\ud83e\udd8c R\xe4knar \xe4lgar","R\xe4knar gula bilar","\u2615 Bunkrar upp med kaffe","Kaj nu simmar du ur bild!","\ud83d\udc08 Delar kattbilder","\ud83d\ude34 Prokastinerar","\ud83e\uded6 Kokar te","\ud83d\udc27 \xd6ppnar k\xe4llkod","\ud83d\ude87 R\xe4knar t\xe5g","\ud83e\uddf9 St\xe4dar upp bland metadata","\ud83d\udc3f\uFE0F R\xe4knar ekorrar","\ud83d\udeb2 R\xe4knar cykelst\xe4ll","\ud83d\ude89 G\xe5r igenom stationer","\ud83d\udef0\uFE0F S\xf6ker satelliter","\ud83e\uddd1\u200D\ud83c\udf73 Lagar k\xf6ttbullar","\ud83e\uddcdSt\xe5r i k\xf6","\ud83e\uddd1\u200D\ud83d\udcbb Fels\xf6ker gr\xe4nsnitt","\ud83d\udcc8 \xd6kar statistik"],"error_psv":"Foto-sf\xe4r visaren laddar inte ordentligt","error_nopic":"Ingen bild finns p\xe5 angiven position","error_api":"Bildservern \xe4r inte tillg\xe4nlig","error_webgl":"WebGL st\xf6ds inte i din webbl\xe4sare","error_api_compatibility":"Bildservern \xe4r inte kompatibel med den h\xe4r visarens version","filter_date":"Datum","filter_date_1month":"1 m\xe5nad","filter_date_1year":"1 \xe5r","filter_user":"Anv\xe4ndare","filter_user_mypics":"Mina bilder","filter_picture":"Bildtyp","filter_zoom_in":"Zooma in f\xf6r att se detta filter","picture_360":"360\xb0","filter_qualityscore_help":"Klicka f\xf6r att sl\xe5 p\xe5 eller av","qualityscore_title":"Om Kvalitetspo\xe4ng","filter_qualityscore":"Kvalitetspo\xe4ng","qualityscore_doc_2":"Kvalitet visas som en skala p\xe5 A/B/C/D/E (A \xe4r b\xe4st, E \xe4r s\xe4mst) och visas grafisk genom skalan:","map_theme_default":"Klassisk","map_theme_age_1":"> 2 \xe5r","map_theme_age_2":"< 2 \xe5r","map_theme_age_3":"< 1 \xe5r","map_theme_age_4":"< 1 m\xe5nad","map_theme_type":"Kameratyp","contrast":"Aktivera h\xf6gre bildkontrast","metadata":"Bildmetadata","metadata_general_picid":"Bild-identifierare","metadata_general_seqid":"Sekvens-identifierare","qualityscore_doc_link":"Mer information om hur Kvalitetspo\xe4ng ber\xe4knas finns i v\xe5r dokumentation.","map_theme_score":"Kvalitetspo\xe4ng","metadata_general_seqid_link":"G\xe5 till JSON beskrivning av sekvensen","metadata_general_author":"Upphovsman","metadata_general_license":"Licens","metadata_general_license_link":"Se full licensbeskrivning","metadata_general_date":"Bild tagen","metadata_camera":"Kamera","metadata_camera_make":"M\xe4rke","metadata_camera_model":"Modell","metadata_camera_type":"Typ","metadata_camera_resolution":"Uppl\xf6sning","metadata_location":"Plats","metadata_location_longitude":"Longitud","metadata_location_latitude":"Latitud","metadata_location_orientation":"Kamerariktning","metadata_location_precision":"Positionsprecision","metadata_quality":"Kvalitetspo\xe4ng","metadata_quality_score":"Global po\xe4ng","metadata_quality_gps_score":"Positioneringspo\xe4ng","metadata_quality_resolution_score":"Uppl\xf6sningspo\xe4ng","metadata_quality_missing":"Inget v\xe4rde satt i bilden","metadata_exif":"EXIF / XMP","metadata_exif_name":"Tag","metadata_exif_value":"V\xe4rde","report":"Rapportera bild","search_user":"S\xf6k anv\xe4ndarnamn\u2026","legend_title":"Visa detaljer f\xf6r bild","report_auth":"Denna rapport kommer skickas genom ditt konto \\"{a}\\"","share_rss_title":"RSS feed av nya sekvensen f\xf6r karta i bild","error_josm":"JOSM svarar inte, k\xf6rs det och \xe4r remote p\xe5slaget?","sequence_prev":"F\xf6reg\xe5ende bild i sekvensen","josm_live":"Aktivera automatisk JOSM synkronisering vid inladdning av bild","metadata_general_picid_link":"G\xe5 till JSON beskrivning av bilden","metadata_quality_help":"L\xe4s mer om Kvalitetspo\xe4ng","error_pic":"Beg\xe4rd bild hittades inte","qualityscore_doc_3":"Det r\xe4knas ut baserat p\xe5 GPS precision och bildens uppl\xf6sning. Ett profesionellt system kommer ha A-kvalit\xe9, en 360\xb0 actionkamera kommer ha B-kvalit\xe9 och en telefon kommer ha C/D/E-kvalit\xe9.","qualityscore_doc_1":"Panoramax erbjuder en Kvalitetspo\xe4ng f\xf6r varje bild. Det m\xf6jlig\xf6r enkel kartfiltrering och en omfattande uppvisning av tillg\xe4nligheten av bilder av h\xf6g kvalitet.","metadata_camera_focal_length":"Br\xe4nnvidd","picture_flat":"Klassisk","map_background":"Kartbakgrund","map_background_aerial":"Sattelit","map_background_streets":"Gator","map_theme":"Karttema","map_theme_age":"Fotodatum","report_nature_label":"Typ av problem","report_nature":{"":"V\xe4lj typen av problem\u2026","blur_missing":"En persons ansikte eller en registreringspl\xe5t \xe4r synlig","blur_excess":"Ett objekt som inte beh\xf6ver suddas \xe4r suddad","inappropriate":"Bilden \xe4r ol\xe4mplig(orelaterat, nakenhet...)","privacy":"En privat v\xe4g eller fastighet \xe4r synlig","picture_low_quality":"Bilden \xe4r av mycket d\xe5lig kvalitet","mislocated":"Bilden \xe4r placerat d\xe5lig p\xe5 kartan","copyright":"Bilden inkr\xe4nker p\xe5 upphovsr\xe4tt","other":"N\xe5got annat typ av problem"},"report_whole_sequence":"Detta g\xe4ller hela sekvensen","report_details":"Ytterligare detaljer","report_details_placeholder":"Valfritt, kan du l\xe4gga till information om problemet och varf\xf6r det \xe4r ett problem","report_email":"Din e-post","report_email_placeholder":"Valfri","report_submit":"Skicka","report_wait":"Skickar rapport \u2026","report_success":"Rapporten har skickats. Det kommer att ses \xf6ver s\xe5 snart som m\xf6jligt.","report_failure":"Ett fel uppstod n\xe4r rapporten skapades: {e}. F\xf6rs\xf6k igen senare."},"maplibre":{"GeolocateControl.FindMyLocation":"Hitta min postion","GeolocateControl.LocationNotAvailable":"Plats inte tillg\xe4nlig"},"map":{"loading":"Laddar\u2026","thumbnail":"Miniatyrbild av r\xf6rd bild","not_public":"Inte offentligt synligt","slow_loading":"Kartan laddas l\xe5ngsamt och kan verka trasig"}}');
            },
            6984: (Qe)=>{
                "use strict";
                Qe.exports = JSON.parse('{"pnx":{"contrast":"\u589E\u52A0\u76F8\u7247\u5C0D\u6BD4\u5EA6","copied":"\u5DF2\u8907\u88FD","copy":"\u8907\u88FD","edit_osm":"\u7DE8\u8F2F OSM","error":"Panoramax \u7576\u6A5F\u4E86\u2026","error_api":"\u76F8\u7247\u4F3A\u670D\u5668\u7121\u6CD5\u4F7F\u7528","error_api_compatibility":"\u76F8\u7247\u4F3A\u670D\u5668\u548C\u6B64\u6AA2\u8996\u5668\u7684\u7248\u672C\u4E0D\u76F8\u5BB9","error_josm":"JOSM \u6C92\u6709\u56DE\u61C9\uFF0C\u5B83\u5DF2\u7D93\u555F\u52D5\u4E14\u555F\u7528\u9060\u7AEF\u63A7\u5236\u4E86\u55CE?","error_nopic":"\u641C\u5C0B\u7684\u4F4D\u7F6E\u9644\u8FD1\u6C92\u6709\u76F8\u7247","error_pic":"\u627E\u4E0D\u5230\u6307\u5B9A\u7684\u76F8\u7247","error_psv":"\u7121\u6CD5\u6B63\u78BA\u8F09\u5165 Photo Sphere Viewer","error_subtitle":"\u8ACB\u7A0D\u5F8C\u91CD\u8A66\u6216\u6AA2\u67E5\u700F\u89BD\u5668\u7684\u4E3B\u63A7\u53F0\u4EE5\u4E86\u89E3\u8A73\u60C5\u3002","error_webgl":"\u60A8\u7684\u700F\u89BD\u5668\u4E0D\u652F\u63F4 WebGL","expand":"\u5C55\u958B","expand_info":"\u5728\u6574\u500B\u756B\u9762\u986F\u793A\u6B64\u5C0F\u5DE5\u5177","filter_camera_model":"\u6309\u76F8\u6A5F\u578B\u865F","filter_date":"\u65E5\u671F","filter_picture":"\u76F8\u7247\u985E\u578B","filter_user":"\u4F7F\u7528\u8005","filter_zoom_in":"\u62C9\u8FD1\u5730\u5716\u4EE5\u986F\u793A\u7BE9\u9078\u7D50\u679C","filters":"\u7BE9\u9078\u5668","id":"iD","josm":"JOSM","josm_live":"\u555F\u7528\u8F09\u5165\u76F8\u7247\u6642\u81EA\u52D5\u540C\u6B65 JOSM","layers":"\u5716\u5C64","legend_license":"\u6388\u6B0A: {l}","loading_labels_fun":["\ud83e\udd8c \u5075\u6E2C\u5230\u7576\u5FC3\u6885\u82B1\u9E7F\u6A19\u8A8C","\ud83d\ude98 \u6B63\u5728\u641C\u5C0B Panoramax \u6C7D\u8ECA \xa9","\u2615 \u6CE8\u5165\u5496\u5561\u56E0","\ud83d\ude00 \u8ACB\u5FAE\u7B11\uFF0C\u60A8\u5DF2\u88AB\u6A19\u8A18\u5728\u5730\u5716\u4E0A\u4E86\uFF01","\ud83d\udc08 \u6B63\u5728\u5206\u4EAB\u8C93\u54AA\u7684\u76F8\u7247","\ud83d\ude34 \u6B63\u5728\u6E1B\u5C11\u5EF6\u9072","\ud83e\uded6 \u6B63\u5728\u6C8F\u58FA\u597D\u8336","\ud83d\udc27 \u6B63\u5728\u958B\u555F\u539F\u59CB\u78BC","\ud83d\ude87 \u6B63\u5728\u7D22\u5F15\u5730\u9435\u8ECA\u7AD9","\ud83e\uddf9 \u6E05\u7406\u8A6E\u91CB\u8CC7\u6599","\ud83d\ude92 \u6B63\u5728\u50B3\u9001\u6D88\u9632\u968A\u7684\u76F8\u7247","\ud83d\udeb2 \u66F4\u65B0\u7DA0\u9053","\ud83d\ude89 \u6B63\u5728\u901A\u904E\u8ECA\u7AD9\u6708\u53F0","\ud83d\udef0\uFE0F \u6B63\u5728\u641C\u5C0B\u885B\u661F","\ud83d\udc65 \u6B63\u5728\u64B0\u5BEB\u4EBA\u7269\u8A8C","\ud83c\udf57 \u6B63\u5728\u5B9A\u4F4D\u9E79\u9165\u96DE\u5E97","\ud83e\uddd1\u200D\ud83d\udcbb \u6B63\u5728\u5075\u932F\u4ECB\u9762","\ud83d\udcc8 \u7D71\u8A08\u6578\u64DA\u6B63\u5728\u589E\u52A0","\ud83e\udd16 \u6B63\u5728\u5B78\u7FD2\u8A9E\u7FA9","\ud83c\udfa8 \u91CD\u65B0\u8A2D\u8A08\u4ECB\u9762","\ud83d\udcc5 \u6B63\u5728\u898F\u5283\u76F8\u7247\u5730\u5716\u7E6A\u5716\u805A\u6703","\ud83e\uddc0 \u6B63\u5728\u719F\u6210\u5207\u9054\u8D77\u53F8","\ud83c\udf04 \u6B63\u5728\u8A08\u7B97\u6046\u6625\u7684\u65E5\u7167\u6642\u6578","\ud83c\udf0a \u6B63\u5728\u6E2C\u91CF\u6F6E\u6C50"],"loading_labels_serious":["\ud83d\uddfa\uFE0F \u6B63\u5728\u8F09\u5165\u5730\u5716\u8CC7\u6599","\ud83d\udda5\uFE0F \u6B63\u5728\u67E5\u8A62 API","\ud83d\uddbc\uFE0F \u6B63\u5728\u8F09\u5165\u7E2E\u5716","\ud83d\udd0d \u6B63\u5728\u5206\u6790 EXIF \u8A6E\u91CB\u8CC7\u6599","\ud83c\udfd8\uFE0F \u6B63\u5728\u7B97\u7E6A 3D","\ud83d\udcf7 \u6B63\u5728\u521D\u59CB\u5316 360\xb0 \u76F8\u7247","\ud83d\udfe0 \u6B63\u5728\u5E73\u8861\u8272\u5F69","\ud83d\udcaf \u6B63\u5728\u8A08\u7B97\u54C1\u8CEA\u5206\u6578 \xa9","\ud83d\udce1 \u6B63\u5728\u4E0B\u8F09\u66F4\u65B0","\ud83c\udf0d \u6B63\u5728\u53D6\u5F97\u5730\u5716\u5716\u78DA","\ud83d\udcf8 \u6B63\u5728\u8655\u7406\u9670\u5F71"],"map_background":"\u5730\u5716\u80CC\u666F","map_background_aerial":"\u885B\u661F","map_background_streets":"\u9810\u8A2D","map_theme":"\u5730\u5716\u4E3B\u984C","map_theme_age":"\u62CD\u651D\u6642\u9593","map_theme_age_1":"> 2 \u5E74","map_theme_age_2":"< 2 \u5E74","map_theme_age_3":"< 1 \u5E74","map_theme_age_4":"< 1 \u500B\u6708","map_theme_default":"\u7D93\u5178","map_theme_type":"\u76F8\u6A5F\u985E\u578B","metadata":"\u76F8\u7247\u8A6E\u91CB\u8CC7\u6599","metadata_camera":"\u76F8\u6A5F","metadata_camera_focal_length":"\u7126\u8DDD","metadata_camera_make":"\u88FD\u9020\u5546","metadata_camera_model":"\u578B\u865F","metadata_camera_type":"\u985E\u578B","metadata_exif":"EXIF","metadata_exif_name":"\u6A19\u7C64","metadata_exif_value":"\u503C","metadata_general_author":"\u4F5C\u8005","metadata_general_date":"\u62CD\u651D\u6642\u9593","metadata_general_license":"\u6388\u6B0A","metadata_general_license_link":"\u67E5\u770B\u5B8C\u6574\u6388\u6B0A\u689D\u6B3E","metadata_general_picid":"\u76F8\u7247","metadata_general_picid_link":"\u524D\u5F80\u672C\u76F8\u7247\u7684 JSON \u8AAA\u660E","metadata_general_seqid":"\u5E8F\u5217","metadata_general_seqid_link":"\u524D\u5F80\u672C\u5E8F\u5217\u7684 JSON \u8AAA\u660E","metadata_location":"\u4F4D\u7F6E","metadata_location_latitude":"\u7DEF\u5EA6","metadata_location_longitude":"\u7D93\u5EA6","metadata_location_orientation":"\u65B9\u5411","metadata_location_precision":"\u5B9A\u4F4D\u7CBE\u5EA6","minimize":"\u96B1\u85CF\u9019\u500B\u5C0F\u5DE5\u5177\uFF0C\u60A8\u53EF\u4EE5\u6309\u5DE6\u4E0B\u89D2\u7684\u6309\u9215\u518D\u6B21\u986F\u793A\u5B83","moveDown":"\u4E0B\u79FB","moveLeft":"\u5DE6\u79FB","moveMiddle":"\u756B\u9762\u7F6E\u4E2D","moveRight":"\u53F3\u79FB","moveUp":"\u4E0A\u79FB","options":"\u9078\u9805","picture_360":"360\xb0","picture_flat":"\u7D93\u5178","search":"\u641C\u5C0B","search_address":"\u641C\u5C0B\u5730\u5740\u3001\u57CE\u5E02\u2026","search_empty":"\u627E\u4E0D\u5230\u7D50\u679C","search_user":"\u641C\u5C0B\u5E33\u865F\u2026","sequence_more":"\u66F4\u591A\u64AD\u653E\u9078\u9805","sequence_next":"\u5E8F\u5217\u4E2D\u7684\u4E0B\u4E00\u5F35\u76F8\u7247","sequence_pause":"\u66AB\u505C\u5E8F\u5217","sequence_play":"\u64AD\u653E\u5E8F\u5217","sequence_prev":"\u5E8F\u5217\u4E2D\u7684\u4E0A\u4E00\u5F35\u76F8\u7247","sequence_speed":"\u64AD\u653E\u901F\u5EA6","share":"\u5206\u4EAB","share_embed":"\u5D4C\u5165\u5230\u60A8\u7684\u7DB2\u7AD9","share_image":"\u9AD8\u756B\u8CEA\u76F8\u7247","share_links":"\u8D85\u9023\u7D50","share_page":"\u9019\u5F35\u76F8\u7247\u7684\u9023\u7D50","share_print":"\u5217\u5370","share_rss":"RSS \u6458\u8981","share_rss_title":"\u76EE\u524D\u5730\u5716\u53EF\u898B\u5340\u57DF\u4E2D\u65B0\u76F8\u7247\u5E8F\u5217\u7684 RSS \u6458\u8981","show_map":"\u986F\u793A\u5730\u5716","show_psv":"\u986F\u793A\u76F8\u7247\u6AA2\u8996\u5668","zoom":"\u7E2E\u653E","zoomIn":"\u62C9\u8FD1","zoomOut":"\u62C9\u9060","report_submit":"\u9001\u51FA","report_email":"\u60A8\u7684 email","report_nature_label":"\u554F\u984C\u7684\u985E\u578B","report_nature":{"":"\u9078\u64C7\u554F\u984C\u7684\u985E\u578B\u2026","blur_missing":"\u53EF\u4EE5\u770B\u898B\u4EBA\u81C9\u6216\u8ECA\u724C","blur_excess":"\u4E0D\u9700\u8981\u6A21\u7CCA\u7684\u7269\u4EF6\u88AB\u6A21\u7CCA\u8655\u7406\u4E86","inappropriate":"\u4E0D\u7576\u7684\u76F8\u7247 (\u4E0D\u76F8\u95DC\u3001\u88F8\u9AD4\u2026)","privacy":"\u53EF\u4EE5\u770B\u898B\u79C1\u4EBA\u7684\u9053\u8DEF\u6216\u8CC7\u7522","picture_low_quality":"\u76F8\u7247\u7684\u54C1\u8CEA\u5F88\u5DEE","mislocated":"\u76F8\u7247\u5728\u5730\u5716\u4E0A\u7684\u4F4D\u7F6E\u4E0D\u6B63\u78BA","copyright":"\u76F8\u7247\u4FB5\u72AF\u4E86\u7248\u6B0A","other":"\u4EFB\u4F55\u5176\u4ED6\u985E\u578B\u7684\u554F\u984C"},"share_embed_docs":"\u6DF1\u5165\u4E86\u89E3\u5D4C\u5165\u8A2D\u5B9A\u503C","error_retry":"\u8ACB\u7A0D\u5F8C\u518D\u8A66","error_click":"\u7E7C\u7E8C","legend_title":"\u986F\u793A\u76F8\u7247\u7684\u8A73\u7D30\u8CC7\u6599","report_email_placeholder":"\u9078\u586B","report_whole_sequence":"\u9019\u500B\u554F\u984C\u5F71\u97FF\u6574\u500B\u5E8F\u5217","report_details":"\u66F4\u591A\u8CC7\u8A0A","report_details_placeholder":"\u9078\u586B\uFF0C\u60A8\u53EF\u4EE5\u8A73\u8FF0\u6B64\u554F\u984C\u548C\u5B83\u9020\u6210\u7684\u5F71\u97FF","report_wait":"\u6B63\u5728\u50B3\u9001\u5831\u544A\u2026","report_success":"\u5DF2\u6210\u529F\u767C\u9001\u5831\u544A\uFF0C\u6211\u5011\u5C07\u5118\u5FEB\u5C0D\u5B83\u9032\u884C\u5BE9\u6838\u3002","report_failure":"\u5EFA\u7ACB\u5831\u544A\u6642\u767C\u9001\u932F\u8AA4: {e}\uFF0C\u8ACB\u7A0D\u5F8C\u518D\u8A66\u3002","report_auth":"\u6B64\u5831\u544A\u5C07\u4F7F\u7528\u60A8\u7684\u5E33\u6236\u300C{a}\u300D\u767C\u9001","filter_qualityscore":"\u54C1\u8CEA\u5206\u6578","filter_qualityscore_help":"\u9EDE\u64CA\u4EE5\u555F\u7528\u6216\u505C\u7528","map_theme_score":"\u54C1\u8CEA\u5206\u6578","metadata_camera_resolution":"\u89E3\u6790\u5EA6","metadata_quality":"\u54C1\u8CEA","metadata_quality_help":"\u6DF1\u5165\u4E86\u89E3\u54C1\u8CEA\u5206\u6578","metadata_quality_gps_score":"\u5B9A\u4F4D\u5206\u6578","metadata_quality_resolution_score":"\u89E3\u6790\u5EA6\u5206\u6578","metadata_quality_missing":"\u76F8\u7247\u672A\u5305\u542B\u8CC7\u8A0A","report":"\u6AA2\u8209","metadata_quality_score":"\u6574\u9AD4\u5206\u6578","filter_user_mypics":"\u6211\u7684\u76F8\u7247","filter_date_1month":"1 \u500B\u6708","filter_date_1year":"1 \u5E74","qualityscore_doc_2":"\u5206\u6578\u4EE5 A/B/C/D/E \u7B49\u7D1A\u7684\u5F62\u5F0F\u986F\u793A (A \u6700\u4F73\u3001E \u6700\u5DEE) \uFF0C\u4E26\u900F\u904E\u9019\u500B\u91CF\u5C3A\u8996\u89BA\u5316\u986F\u793A:","qualityscore_doc_link":"\u6DF1\u5165\u4E86\u89E3\u54C1\u8CEA\u5206\u6578","qualityscore_title":"\u95DC\u65BC\u54C1\u8CEA\u5206\u6578","qualityscore_doc_1":"Panoramax \u70BA\u6BCF\u5F35\u76F8\u7247\u63D0\u4F9B\u54C1\u8CEA\u5206\u6578\uFF0C\u9019\u80FD\u5E6B\u52A9\u6211\u5011\u8F15\u9B06\u5730\u5728\u5730\u5716\u4E0A\u7BE9\u9078\u548C\u986F\u793A\u9AD8\u54C1\u8CEA\u76F8\u7247\u3002","qualityscore_doc_3":"\u5B83\u6839\u64DA GPS \u7CBE\u78BA\u5EA6\u548C\u76F8\u7247\u89E3\u6790\u5EA6\u8A08\u7B97\u5F97\u51FA\uFF0C\u5C08\u696D\u8A2D\u5099\u7684\u7B49\u7D1A\u70BA A\u3001360\xb0 \u904B\u52D5\u76F8\u6A5F\u7684\u7B49\u7D1A\u70BA B\u3001\u667A\u6167\u578B\u624B\u6A5F\u7684\u7B49\u7D1A\u70BA C/D/E\u3002","minimize_short":"\u96B1\u85CF","metadata_general_instance":"\u4F86\u6E90\u57F7\u884C\u500B\u9AD4","metadata_general_copy_picid":"\u8907\u88FD\u76F8\u7247 ID","metadata_general_copy_id":"\u8907\u88FD ID","picture_360_long":"\u5168\u666F\u76F8\u7247","metadata_summary":"\u6458\u8981","picture_flat_long":"\u7D93\u5178\u76F8\u7247","geo_uri":"\u5916\u90E8\u7A0B\u5F0F","contribute_id":"\u900F\u904E iD \u7DE8\u8F2F\u5668\u4F86\u8CA2\u737B OpenStreetMap","filter_date_6months":"6 \u500B\u6708","picture_all":"\u5168\u90E8","metadata_exif_doc":"EXIF \u6A19\u7C64\u6587\u4EF6","metadata_exif_doc_title":"\u8ACB\u53C3\u95B1 Exiv2 \u6587\u4EF6\u4EE5\u53D6\u5F97 EXIF \u548C XMP \u6A19\u7C64\u5B9A\u7FA9\u7684\u5B8C\u6574\u8AAA\u660E","metadata_location_coordinates":"\u5EA7\u6A19 (\u7D93\u5EA6, \u7DEF\u5EA6)","metadata_location_copy":"\u8907\u88FD {v}","metadata_location_copy_more":"\u66F4\u591A\u5EA7\u6A19\u8907\u88FD\u9078\u9805"},"map":{"loading":"\u6B63\u5728\u8F09\u5165\u2026","not_public":"\u672A\u516C\u958B\u986F\u793A","thumbnail":"\u904A\u6A19\u61F8\u505C\u76F8\u7247\u7684\u7E2E\u5716","slow_loading":"\u5730\u5716\u8F09\u5165\u901F\u5EA6\u7DE9\u6162\u800C\u4E14\u53EF\u80FD\u51FA\u73FE\u640D\u58DE","more_panoramax":"\u6DF1\u5165\u4E86\u89E3 Panoramax","map_data":"\u5730\u5716\u8CC7\u6599:"},"psv":{"ctrlZoom":"\u4F7F\u7528 CTRL + \u6ED1\u9F20\u6EFE\u8F2A\u7E2E\u653E\u5716\u7247","loadError":"\u7121\u6CD5\u8F09\u5165\u5168\u666F\u5716","twoFingers":"\u4F7F\u7528\u96D9\u6307\u79FB\u52D5"},"maplibre":{"GeolocateControl.FindMyLocation":"\u5C0B\u627E\u6211\u7684\u4F4D\u7F6E","GeolocateControl.LocationNotAvailable":"\u7121\u6CD5\u4F7F\u7528\u4F4D\u7F6E\u8CC7\u8A0A"}}');
            }
        }, rt = {};
        function __webpack_require__(Wn) {
            var Co = rt[Wn];
            if (void 0 !== Co) return Co.exports;
            var Dl = rt[Wn] = {
                exports: {}
            };
            return Qe[Wn].call(Dl.exports, Dl, Dl.exports, __webpack_require__), Dl.exports;
        }
        __webpack_require__.n = (Qe)=>{
            var rt = Qe && Qe.__esModule ? ()=>Qe.default : ()=>Qe;
            return __webpack_require__.d(rt, {
                a: rt
            }), rt;
        }, __webpack_require__.d = (Qe, rt)=>{
            for(var Wn in rt)__webpack_require__.o(rt, Wn) && !__webpack_require__.o(Qe, Wn) && Object.defineProperty(Qe, Wn, {
                enumerable: !0,
                get: rt[Wn]
            });
        }, __webpack_require__.o = (Qe, rt)=>Object.prototype.hasOwnProperty.call(Qe, rt), __webpack_require__.r = (Qe)=>{
            "undefined" !== typeof Symbol && Symbol.toStringTag && Object.defineProperty(Qe, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(Qe, "__esModule", {
                value: !0
            });
        };
        var Wn = {};
        return (()=>{
            "use strict";
            __webpack_require__.r(Wn), __webpack_require__.d(Wn, {
                CoverageMap: ()=>Dl.A,
                Editor: ()=>Ll.A,
                PhotoViewer: ()=>Rl.A,
                Viewer: ()=>Co.A,
                components: ()=>Qe,
                utils: ()=>rt
            });
            var Qe = __webpack_require__(9341), rt = __webpack_require__(2030), Co = __webpack_require__(8743), Dl = __webpack_require__(153), Ll = __webpack_require__(1752), Rl = __webpack_require__(3407);
        })(), Wn;
    })());


document.addEventListener("DOMContentLoaded", ()=>{
    const browser = document.querySelector("pnx-viewer");
    const xyzField = document.getElementById("xyz-coords");
    const imageId = document.getElementById("image-id");
    if (browser && xyzField) {
        const updateXYZandImageID = (event)=>{
            const { x: x, y: y, z: z } = event.detail;
            const xyz = `${x}/${y}/${z}`;
            xyzField.value = xyz;
            imageId.value = browser.getAttribute("picture");
        };
        browser.addEventListener("psv:view-rotated", updateXYZandImageID);
        browser.addEventListener("psv:position-changed", updateXYZandImageID);
    }
    const viewer = document.querySelector("pnx-photo-viewer");
    if (viewer) {
        const xyz = viewer.getAttribute("xyz");
        viewer.addEventListener("psv:picture-loaded", ()=>{
            if (xyz) {
                const [x, y, z] = xyz.split("/").map(Number);
                viewer.psv.setXYZ(x, y, z);
            }
        });
    }
});


let $62a17aedb317e76e$var$toEmit = [];
function $62a17aedb317e76e$var$cloneFilter(root) {
    root.addEventListener("click", function(event) {
        $62a17aedb317e76e$var$toEmit.push({
            type: root.getAttribute("data-event-type"),
            target: event.target
        });
    });
}
function $62a17aedb317e76e$export$c5eff21406d7e0f8(root) {
    root.addEventListener("click", ()=>{
        $62a17aedb317e76e$var$toEmit.forEach((event)=>{
            document.dispatchEvent(new CustomEvent(event.type, {
                detail: {
                    source: event.target,
                    skipRefresh: true
                }
            }));
        });
        $62a17aedb317e76e$var$toEmit = [];
        document.getElementById("search-form").submit();
    });
}
var $62a17aedb317e76e$export$2e2bcd8739ae039 = {
    cloneFilter: $62a17aedb317e76e$var$cloneFilter,
    cloneFilterSubmit: $62a17aedb317e76e$export$c5eff21406d7e0f8
};



document.addEventListener("DOMContentLoaded", ()=>{
    const root = document.getElementById("autocomplete-activity");
    if (!root) return;
    const inputElement = root.querySelector('input[name="activite"]');
    const activities = JSON.parse(inputElement.dataset.searchLookup);
    const onSubmit = (slug)=>{
        const activitySlugInput = document.querySelector('input[type="hidden"][name="activity_slug"]');
        if (activitySlugInput) activitySlugInput.value = slug;
    };
    const autocomplete = new (0, $3fd49769fea2b73d$export$2e2bcd8739ae039)(root, {
        getResultValue: (result)=>result.name,
        search: (searchTerm)=>{
            if (searchTerm.length < 3) return [];
            const exactResults = activities.filter((activity)=>activity.keywords.some((keyword)=>keyword.localeCompare(searchTerm, undefined, {
                        sensitivity: "base"
                    }) === 0));
            const otherKeywordResults = activities.filter((activity)=>activity.keywords.some((keyword)=>keyword.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").includes(searchTerm.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "")))).filter((activity)=>!exactResults.includes(activity));
            return exactResults.concat(otherKeywordResults);
        },
        renderResult: (result, props)=>{
            const active = props["aria-selected"] ? "active" : "";
            return `
        <li class="list-group-item a4a-autocomplete-result ${active}" ${props}>
          ${result.name}
        </li>
      `;
        },
        onSubmit: ({ slug: slug })=>onSubmit(slug)
    });
    // Dirty hack to support press Key enter (Lib is broken)
    autocomplete.input.addEventListener("keydown", (event)=>{
        const { key: key } = event;
        const isDropdownExpanded = !!autocomplete?.expanded;
        // We do not want to submit the form if the suggestion list is opened, only when it's closed.
        if (key === "Enter" && isDropdownExpanded) {
            // Prevent form submission
            event.preventDefault();
            const slug = autocomplete?.core?.selectedResult?.slug;
            if (slug) // Populate hidden input
            onSubmit(slug);
        }
    });
    autocomplete.input.addEventListener("input", ()=>{
        const value = autocomplete.input.value.trim();
        if (value === "") {
            const activitySlugInput = document.querySelector('input[type="hidden"][name="activity_slug"]');
            if (activitySlugInput) activitySlugInput.value = "";
        }
    });
});




var $cfd75c534a862da6$var$t = "undefined" != typeof window ? window : void 0, $cfd75c534a862da6$var$i = "undefined" != typeof globalThis ? globalThis : $cfd75c534a862da6$var$t, $cfd75c534a862da6$var$e = Array.prototype, $cfd75c534a862da6$var$r = $cfd75c534a862da6$var$e.forEach, $cfd75c534a862da6$var$s = $cfd75c534a862da6$var$e.indexOf, $cfd75c534a862da6$var$n = null == $cfd75c534a862da6$var$i ? void 0 : $cfd75c534a862da6$var$i.navigator, $cfd75c534a862da6$var$o = null == $cfd75c534a862da6$var$i ? void 0 : $cfd75c534a862da6$var$i.document, $cfd75c534a862da6$var$a = null == $cfd75c534a862da6$var$i ? void 0 : $cfd75c534a862da6$var$i.location, $cfd75c534a862da6$var$l = null == $cfd75c534a862da6$var$i ? void 0 : $cfd75c534a862da6$var$i.fetch, $cfd75c534a862da6$var$u = null != $cfd75c534a862da6$var$i && $cfd75c534a862da6$var$i.XMLHttpRequest && "withCredentials" in new $cfd75c534a862da6$var$i.XMLHttpRequest ? $cfd75c534a862da6$var$i.XMLHttpRequest : void 0, $cfd75c534a862da6$var$h = null == $cfd75c534a862da6$var$i ? void 0 : $cfd75c534a862da6$var$i.AbortController, $cfd75c534a862da6$var$d = null == $cfd75c534a862da6$var$n ? void 0 : $cfd75c534a862da6$var$n.userAgent, $cfd75c534a862da6$var$v = null != $cfd75c534a862da6$var$t ? $cfd75c534a862da6$var$t : {}, $cfd75c534a862da6$var$c = {
    DEBUG: !1,
    LIB_VERSION: "1.254.0"
}, $cfd75c534a862da6$export$7bea938663611d9 = "$copy_autocapture", $cfd75c534a862da6$export$fbd163209a0ff4bf = [
    "$snapshot",
    "$pageview",
    "$pageleave",
    "$set",
    "survey dismissed",
    "survey sent",
    "survey shown",
    "$identify",
    "$groupidentify",
    "$create_alias",
    "$$client_ingestion_warning",
    "$web_experiment_applied",
    "$feature_enrollment_update",
    "$feature_flag_called"
], $cfd75c534a862da6$export$6a00d17b5aff0af = function(t) {
    return t.GZipJS = "gzip-js", t.Base64 = "base64", t;
}({}), $cfd75c534a862da6$export$9dd8f6ec3b5e6004 = [
    "fatal",
    "error",
    "warning",
    "log",
    "info",
    "debug"
];
function $cfd75c534a862da6$var$m(t, i) {
    return -1 !== t.indexOf(i);
}
var $cfd75c534a862da6$var$b = function(t) {
    return t.trim();
}, $cfd75c534a862da6$var$y = function(t) {
    return t.replace(/^\$/, "");
};
var $cfd75c534a862da6$var$w = Array.isArray, $cfd75c534a862da6$var$S = Object.prototype, $cfd75c534a862da6$var$$ = $cfd75c534a862da6$var$S.hasOwnProperty, $cfd75c534a862da6$var$k = $cfd75c534a862da6$var$S.toString, $cfd75c534a862da6$var$x = $cfd75c534a862da6$var$w || function(t) {
    return "[object Array]" === $cfd75c534a862da6$var$k.call(t);
}, $cfd75c534a862da6$var$E = (t)=>"function" == typeof t, $cfd75c534a862da6$var$I = (t)=>t === Object(t) && !$cfd75c534a862da6$var$x(t), $cfd75c534a862da6$var$P = (t)=>{
    if ($cfd75c534a862da6$var$I(t)) {
        for(var i in t)if ($cfd75c534a862da6$var$$.call(t, i)) return !1;
        return !0;
    }
    return !1;
}, $cfd75c534a862da6$var$R = (t)=>void 0 === t, $cfd75c534a862da6$var$T = (t)=>"[object String]" == $cfd75c534a862da6$var$k.call(t), $cfd75c534a862da6$var$M = (t)=>$cfd75c534a862da6$var$T(t) && 0 === t.trim().length, $cfd75c534a862da6$var$C = (t)=>null === t, $cfd75c534a862da6$var$F = (t)=>$cfd75c534a862da6$var$R(t) || $cfd75c534a862da6$var$C(t), $cfd75c534a862da6$var$O = (t)=>"[object Number]" == $cfd75c534a862da6$var$k.call(t), $cfd75c534a862da6$var$A = (t)=>"[object Boolean]" === $cfd75c534a862da6$var$k.call(t), $cfd75c534a862da6$var$D = (t)=>t instanceof FormData, $cfd75c534a862da6$var$L = (t)=>$cfd75c534a862da6$var$m($cfd75c534a862da6$export$fbd163209a0ff4bf, t), $cfd75c534a862da6$var$j = (i)=>{
    var e = {
        t: function(e) {
            if ($cfd75c534a862da6$var$t && ($cfd75c534a862da6$var$c.DEBUG || $cfd75c534a862da6$var$v.POSTHOG_DEBUG) && !$cfd75c534a862da6$var$R($cfd75c534a862da6$var$t.console) && $cfd75c534a862da6$var$t.console) {
                for(var r = ("__rrweb_original__" in $cfd75c534a862da6$var$t.console[e]) ? $cfd75c534a862da6$var$t.console[e].__rrweb_original__ : $cfd75c534a862da6$var$t.console[e], s = arguments.length, n = new Array(s > 1 ? s - 1 : 0), o = 1; o < s; o++)n[o - 1] = arguments[o];
                r(i, ...n);
            }
        },
        info: function() {
            for(var t = arguments.length, i = new Array(t), r = 0; r < t; r++)i[r] = arguments[r];
            e.t("log", ...i);
        },
        warn: function() {
            for(var t = arguments.length, i = new Array(t), r = 0; r < t; r++)i[r] = arguments[r];
            e.t("warn", ...i);
        },
        error: function() {
            for(var t = arguments.length, i = new Array(t), r = 0; r < t; r++)i[r] = arguments[r];
            e.t("error", ...i);
        },
        critical: function() {
            for(var t = arguments.length, e = new Array(t), r = 0; r < t; r++)e[r] = arguments[r];
            console.error(i, ...e);
        },
        uninitializedWarning: (t)=>{
            e.error("You must initialize PostHog before calling " + t);
        },
        createLogger: (t)=>$cfd75c534a862da6$var$j(i + " " + t)
    };
    return e;
}, $cfd75c534a862da6$var$N = $cfd75c534a862da6$var$j("[PostHog.js]"), $cfd75c534a862da6$var$z = $cfd75c534a862da6$var$N.createLogger, $cfd75c534a862da6$var$U = $cfd75c534a862da6$var$z("[ExternalScriptsLoader]"), $cfd75c534a862da6$var$q = (t, i, e)=>{
    if (t.config.disable_external_dependency_loading) return $cfd75c534a862da6$var$U.warn(i + " was requested but loading of external scripts is disabled."), e("Loading of external scripts is disabled");
    var r = null == $cfd75c534a862da6$var$o ? void 0 : $cfd75c534a862da6$var$o.querySelectorAll("script");
    if (r) {
        for(var s = 0; s < r.length; s++)if (r[s].src === i) return e();
    }
    var n = ()=>{
        if (!$cfd75c534a862da6$var$o) return e("document not found");
        var r = $cfd75c534a862da6$var$o.createElement("script");
        if (r.type = "text/javascript", r.crossOrigin = "anonymous", r.src = i, r.onload = (t)=>e(void 0, t), r.onerror = (t)=>e(t), t.config.prepare_external_dependency_script && (r = t.config.prepare_external_dependency_script(r)), !r) return e("prepare_external_dependency_script returned null");
        var s, n = $cfd75c534a862da6$var$o.querySelectorAll("body > script");
        n.length > 0 ? null == (s = n[0].parentNode) || s.insertBefore(r, n[0]) : $cfd75c534a862da6$var$o.body.appendChild(r);
    };
    null != $cfd75c534a862da6$var$o && $cfd75c534a862da6$var$o.body ? n() : null == $cfd75c534a862da6$var$o || $cfd75c534a862da6$var$o.addEventListener("DOMContentLoaded", n);
};
function $cfd75c534a862da6$var$B() {
    return $cfd75c534a862da6$var$B = Object.assign ? Object.assign.bind() : function(t) {
        for(var i = 1; i < arguments.length; i++){
            var e = arguments[i];
            for(var r in e)({}).hasOwnProperty.call(e, r) && (t[r] = e[r]);
        }
        return t;
    }, $cfd75c534a862da6$var$B.apply(null, arguments);
}
function $cfd75c534a862da6$var$H(t, i) {
    if (null == t) return {};
    var e = {};
    for(var r in t)if (({}).hasOwnProperty.call(t, r)) {
        if (-1 !== i.indexOf(r)) continue;
        e[r] = t[r];
    }
    return e;
}
$cfd75c534a862da6$var$v.__PosthogExtensions__ = $cfd75c534a862da6$var$v.__PosthogExtensions__ || {}, $cfd75c534a862da6$var$v.__PosthogExtensions__.loadExternalDependency = (t, i, e)=>{
    var r = "/static/" + i + ".js?v=" + t.version;
    if ("remote-config" === i && (r = "/array/" + t.config.token + "/config.js"), "toolbar" === i) {
        var s = 3e5;
        r = r + "&t=" + Math.floor(Date.now() / s) * s;
    }
    var n = t.requestRouter.endpointFor("assets", r);
    $cfd75c534a862da6$var$q(t, n, e);
}, $cfd75c534a862da6$var$v.__PosthogExtensions__.loadSiteApp = (t, i, e)=>{
    var r = t.requestRouter.endpointFor("api", i);
    $cfd75c534a862da6$var$q(t, r, e);
};
var $cfd75c534a862da6$var$W = {};
function $cfd75c534a862da6$var$G(t, i, e) {
    if ($cfd75c534a862da6$var$x(t)) {
        if ($cfd75c534a862da6$var$r && t.forEach === $cfd75c534a862da6$var$r) t.forEach(i, e);
        else if ("length" in t && t.length === +t.length) {
            for(var s = 0, n = t.length; s < n; s++)if (s in t && i.call(e, t[s], s) === $cfd75c534a862da6$var$W) return;
        }
    }
}
function $cfd75c534a862da6$var$J(t, i, e) {
    if (!$cfd75c534a862da6$var$F(t)) {
        if ($cfd75c534a862da6$var$x(t)) return $cfd75c534a862da6$var$G(t, i, e);
        if ($cfd75c534a862da6$var$D(t)) {
            for (var r of t.entries())if (i.call(e, r[1], r[0]) === $cfd75c534a862da6$var$W) return;
        } else for(var s in t)if ($cfd75c534a862da6$var$$.call(t, s) && i.call(e, t[s], s) === $cfd75c534a862da6$var$W) return;
    }
}
var $cfd75c534a862da6$var$V = function(t) {
    for(var i = arguments.length, e = new Array(i > 1 ? i - 1 : 0), r = 1; r < i; r++)e[r - 1] = arguments[r];
    return $cfd75c534a862da6$var$G(e, function(i) {
        for(var e in i)void 0 !== i[e] && (t[e] = i[e]);
    }), t;
}, $cfd75c534a862da6$var$K = function(t) {
    for(var i = arguments.length, e = new Array(i > 1 ? i - 1 : 0), r = 1; r < i; r++)e[r - 1] = arguments[r];
    return $cfd75c534a862da6$var$G(e, function(i) {
        $cfd75c534a862da6$var$G(i, function(i) {
            t.push(i);
        });
    }), t;
};
function $cfd75c534a862da6$var$Y(t) {
    for(var i = Object.keys(t), e = i.length, r = new Array(e); e--;)r[e] = [
        i[e],
        t[i[e]]
    ];
    return r;
}
var $cfd75c534a862da6$var$X = function(t) {
    try {
        return t();
    } catch (t) {
        return;
    }
}, $cfd75c534a862da6$var$Q = function(t) {
    return function() {
        try {
            for(var i = arguments.length, e = new Array(i), r = 0; r < i; r++)e[r] = arguments[r];
            return t.apply(this, e);
        } catch (t) {
            $cfd75c534a862da6$var$N.critical("Implementation error. Please turn on debug mode and open a ticket on https://app.posthog.com/home#panel=support%3Asupport%3A."), $cfd75c534a862da6$var$N.critical(t);
        }
    };
}, $cfd75c534a862da6$var$Z = function(t) {
    var i = {};
    return $cfd75c534a862da6$var$J(t, function(t, e) {
        ($cfd75c534a862da6$var$T(t) && t.length > 0 || $cfd75c534a862da6$var$O(t)) && (i[e] = t);
    }), i;
};
function $cfd75c534a862da6$var$tt(t, i) {
    var e, r, s;
    return e = t, r = (t)=>$cfd75c534a862da6$var$T(t) && !$cfd75c534a862da6$var$C(i) ? t.slice(0, i) : t, s = new Set, function t(i, e) {
        var n;
        return i !== Object(i) ? r ? r(i, e) : i : s.has(i) ? void 0 : (s.add(i), $cfd75c534a862da6$var$x(i) ? (n = [], $cfd75c534a862da6$var$G(i, (i)=>{
            n.push(t(i));
        })) : (n = {}, $cfd75c534a862da6$var$J(i, (i, e)=>{
            s.has(i) || (n[e] = t(i, e));
        })), n);
    }(e);
}
var $cfd75c534a862da6$var$it = [
    "herokuapp.com",
    "vercel.app",
    "netlify.app"
];
function $cfd75c534a862da6$var$et(t) {
    var i = null == t ? void 0 : t.hostname;
    if (!$cfd75c534a862da6$var$T(i)) return !1;
    var e = i.split(".").slice(-2).join(".");
    for (var r of $cfd75c534a862da6$var$it)if (e === r) return !1;
    return !0;
}
function $cfd75c534a862da6$var$rt(t, i) {
    for(var e = 0; e < t.length; e++)if (i(t[e])) return t[e];
}
function $cfd75c534a862da6$var$st(t, i, e, r) {
    var { capture: s = !1, passive: n = !0 } = null != r ? r : {};
    null == t || t.addEventListener(i, e, {
        capture: s,
        passive: n
    });
}
var $cfd75c534a862da6$var$nt = "$people_distinct_id", $cfd75c534a862da6$var$ot = "__alias", $cfd75c534a862da6$var$at = "__timers", $cfd75c534a862da6$var$lt = "$autocapture_disabled_server_side", $cfd75c534a862da6$var$ut = "$heatmaps_enabled_server_side", $cfd75c534a862da6$var$ht = "$exception_capture_enabled_server_side", $cfd75c534a862da6$var$dt = "$error_tracking_suppression_rules", $cfd75c534a862da6$var$vt = "$web_vitals_enabled_server_side", $cfd75c534a862da6$var$ct = "$dead_clicks_enabled_server_side", $cfd75c534a862da6$var$ft = "$web_vitals_allowed_metrics", $cfd75c534a862da6$var$pt = "$session_recording_enabled_server_side", $cfd75c534a862da6$var$gt = "$console_log_recording_enabled_server_side", $cfd75c534a862da6$var$_t = "$session_recording_network_payload_capture", $cfd75c534a862da6$var$mt = "$session_recording_masking", $cfd75c534a862da6$var$bt = "$session_recording_canvas_recording", $cfd75c534a862da6$var$yt = "$replay_sample_rate", $cfd75c534a862da6$var$wt = "$replay_minimum_duration", $cfd75c534a862da6$var$St = "$replay_script_config", $cfd75c534a862da6$var$$t = "$sesid", $cfd75c534a862da6$var$kt = "$session_is_sampled", $cfd75c534a862da6$var$xt = "$session_recording_url_trigger_activated_session", $cfd75c534a862da6$var$Et = "$session_recording_event_trigger_activated_session", $cfd75c534a862da6$var$It = "$enabled_feature_flags", $cfd75c534a862da6$var$Pt = "$early_access_features", $cfd75c534a862da6$var$Rt = "$feature_flag_details", $cfd75c534a862da6$var$Tt = "$stored_person_properties", $cfd75c534a862da6$var$Mt = "$stored_group_properties", $cfd75c534a862da6$var$Ct = "$surveys", $cfd75c534a862da6$var$Ft = "$surveys_activated", $cfd75c534a862da6$var$Ot = "$flag_call_reported", $cfd75c534a862da6$var$At = "$user_state", $cfd75c534a862da6$var$Dt = "$client_session_props", $cfd75c534a862da6$var$Lt = "$capture_rate_limit", $cfd75c534a862da6$var$jt = "$initial_campaign_params", $cfd75c534a862da6$var$Nt = "$initial_referrer_info", $cfd75c534a862da6$var$zt = "$initial_person_info", $cfd75c534a862da6$var$Ut = "$epp", $cfd75c534a862da6$var$qt = "__POSTHOG_TOOLBAR__", $cfd75c534a862da6$var$Bt = "$posthog_cookieless", $cfd75c534a862da6$var$Ht = [
    $cfd75c534a862da6$var$nt,
    $cfd75c534a862da6$var$ot,
    "__cmpns",
    $cfd75c534a862da6$var$at,
    $cfd75c534a862da6$var$pt,
    $cfd75c534a862da6$var$ut,
    $cfd75c534a862da6$var$$t,
    $cfd75c534a862da6$var$It,
    $cfd75c534a862da6$var$dt,
    $cfd75c534a862da6$var$At,
    $cfd75c534a862da6$var$Pt,
    $cfd75c534a862da6$var$Rt,
    $cfd75c534a862da6$var$Mt,
    $cfd75c534a862da6$var$Tt,
    $cfd75c534a862da6$var$Ct,
    $cfd75c534a862da6$var$Ot,
    $cfd75c534a862da6$var$Dt,
    $cfd75c534a862da6$var$Lt,
    $cfd75c534a862da6$var$jt,
    $cfd75c534a862da6$var$Nt,
    $cfd75c534a862da6$var$Ut,
    $cfd75c534a862da6$var$zt
];
function $cfd75c534a862da6$var$Wt(t) {
    return t instanceof Element && (t.id === $cfd75c534a862da6$var$qt || !(null == t.closest || !t.closest(".toolbar-global-fade-container")));
}
function $cfd75c534a862da6$var$Gt(t) {
    return !!t && 1 === t.nodeType;
}
function $cfd75c534a862da6$var$Jt(t, i) {
    return !!t && !!t.tagName && t.tagName.toLowerCase() === i.toLowerCase();
}
function $cfd75c534a862da6$var$Vt(t) {
    return !!t && 3 === t.nodeType;
}
function $cfd75c534a862da6$var$Kt(t) {
    return !!t && 11 === t.nodeType;
}
function $cfd75c534a862da6$var$Yt(t) {
    return t ? $cfd75c534a862da6$var$b(t).split(/\s+/) : [];
}
function $cfd75c534a862da6$var$Xt(i) {
    var e = null == $cfd75c534a862da6$var$t ? void 0 : $cfd75c534a862da6$var$t.location.href;
    return !!(e && i && i.some((t)=>e.match(t)));
}
function $cfd75c534a862da6$var$Qt(t) {
    var i = "";
    switch(typeof t.className){
        case "string":
            i = t.className;
            break;
        case "object":
            i = (t.className && "baseVal" in t.className ? t.className.baseVal : null) || t.getAttribute("class") || "";
            break;
        default:
            i = "";
    }
    return $cfd75c534a862da6$var$Yt(i);
}
function $cfd75c534a862da6$var$Zt(t) {
    return $cfd75c534a862da6$var$F(t) ? null : $cfd75c534a862da6$var$b(t).split(/(\s+)/).filter((t)=>$cfd75c534a862da6$var$ci(t)).join("").replace(/[\r\n]/g, " ").replace(/[ ]+/g, " ").substring(0, 255);
}
function $cfd75c534a862da6$var$ti(t) {
    var i = "";
    return $cfd75c534a862da6$var$ni(t) && !$cfd75c534a862da6$var$oi(t) && t.childNodes && t.childNodes.length && $cfd75c534a862da6$var$J(t.childNodes, function(t) {
        var e;
        $cfd75c534a862da6$var$Vt(t) && t.textContent && (i += null !== (e = $cfd75c534a862da6$var$Zt(t.textContent)) && void 0 !== e ? e : "");
    }), $cfd75c534a862da6$var$b(i);
}
function $cfd75c534a862da6$var$ii(t) {
    var i;
    return $cfd75c534a862da6$var$R(t.target) ? t.srcElement || null : null != (i = t.target) && i.shadowRoot ? t.composedPath()[0] || null : t.target || null;
}
var $cfd75c534a862da6$var$ei = [
    "a",
    "button",
    "form",
    "input",
    "select",
    "textarea",
    "label"
];
function $cfd75c534a862da6$var$ri(t) {
    var i = t.parentNode;
    return !(!i || !$cfd75c534a862da6$var$Gt(i)) && i;
}
function $cfd75c534a862da6$var$si(i, e, r, s, n) {
    var o, a, l;
    if (void 0 === r && (r = void 0), !$cfd75c534a862da6$var$t || !i || $cfd75c534a862da6$var$Jt(i, "html") || !$cfd75c534a862da6$var$Gt(i)) return !1;
    if (null != (o = r) && o.url_allowlist && !$cfd75c534a862da6$var$Xt(r.url_allowlist)) return !1;
    if (null != (a = r) && a.url_ignorelist && $cfd75c534a862da6$var$Xt(r.url_ignorelist)) return !1;
    if (null != (l = r) && l.dom_event_allowlist) {
        var u = r.dom_event_allowlist;
        if (u && !u.some((t)=>e.type === t)) return !1;
    }
    for(var h = !1, d = [
        i
    ], v = !0, c = i; c.parentNode && !$cfd75c534a862da6$var$Jt(c, "body");)if ($cfd75c534a862da6$var$Kt(c.parentNode)) d.push(c.parentNode.host), c = c.parentNode.host;
    else {
        if (!(v = $cfd75c534a862da6$var$ri(c))) break;
        if (s || $cfd75c534a862da6$var$ei.indexOf(v.tagName.toLowerCase()) > -1) h = !0;
        else {
            var f = $cfd75c534a862da6$var$t.getComputedStyle(v);
            f && "pointer" === f.getPropertyValue("cursor") && (h = !0);
        }
        d.push(v), c = v;
    }
    if (!function(t, i) {
        var e = null == i ? void 0 : i.element_allowlist;
        if ($cfd75c534a862da6$var$R(e)) return !0;
        var r, s = function(t) {
            if (e.some((i)=>t.tagName.toLowerCase() === i)) return {
                v: !0
            };
        };
        for (var n of t)if (r = s(n)) return r.v;
        return !1;
    }(d, r)) return !1;
    if (!function(t, i) {
        var e = null == i ? void 0 : i.css_selector_allowlist;
        if ($cfd75c534a862da6$var$R(e)) return !0;
        var r, s = function(t) {
            if (e.some((i)=>t.matches(i))) return {
                v: !0
            };
        };
        for (var n of t)if (r = s(n)) return r.v;
        return !1;
    }(d, r)) return !1;
    var p = $cfd75c534a862da6$var$t.getComputedStyle(i);
    if (p && "pointer" === p.getPropertyValue("cursor") && "click" === e.type) return !0;
    var g = i.tagName.toLowerCase();
    switch(g){
        case "html":
            return !1;
        case "form":
            return (n || [
                "submit"
            ]).indexOf(e.type) >= 0;
        case "input":
        case "select":
        case "textarea":
            return (n || [
                "change",
                "click"
            ]).indexOf(e.type) >= 0;
        default:
            return h ? (n || [
                "click"
            ]).indexOf(e.type) >= 0 : (n || [
                "click"
            ]).indexOf(e.type) >= 0 && ($cfd75c534a862da6$var$ei.indexOf(g) > -1 || "true" === i.getAttribute("contenteditable"));
    }
}
function $cfd75c534a862da6$var$ni(t) {
    for(var i = t; i.parentNode && !$cfd75c534a862da6$var$Jt(i, "body"); i = i.parentNode){
        var e = $cfd75c534a862da6$var$Qt(i);
        if ($cfd75c534a862da6$var$m(e, "ph-sensitive") || $cfd75c534a862da6$var$m(e, "ph-no-capture")) return !1;
    }
    if ($cfd75c534a862da6$var$m($cfd75c534a862da6$var$Qt(t), "ph-include")) return !0;
    var r = t.type || "";
    if ($cfd75c534a862da6$var$T(r)) switch(r.toLowerCase()){
        case "hidden":
        case "password":
            return !1;
    }
    var s = t.name || t.id || "";
    if ($cfd75c534a862da6$var$T(s)) {
        if (/^cc|cardnum|ccnum|creditcard|csc|cvc|cvv|exp|pass|pwd|routing|seccode|securitycode|securitynum|socialsec|socsec|ssn/i.test(s.replace(/[^a-zA-Z0-9]/g, ""))) return !1;
    }
    return !0;
}
function $cfd75c534a862da6$var$oi(t) {
    return !!($cfd75c534a862da6$var$Jt(t, "input") && ![
        "button",
        "checkbox",
        "submit",
        "reset"
    ].includes(t.type) || $cfd75c534a862da6$var$Jt(t, "select") || $cfd75c534a862da6$var$Jt(t, "textarea") || "true" === t.getAttribute("contenteditable"));
}
var $cfd75c534a862da6$var$ai = "(4[0-9]{12}(?:[0-9]{3})?)|(5[1-5][0-9]{14})|(6(?:011|5[0-9]{2})[0-9]{12})|(3[47][0-9]{13})|(3(?:0[0-5]|[68][0-9])[0-9]{11})|((?:2131|1800|35[0-9]{3})[0-9]{11})", $cfd75c534a862da6$var$li = new RegExp("^(?:" + $cfd75c534a862da6$var$ai + ")$"), $cfd75c534a862da6$var$ui = new RegExp($cfd75c534a862da6$var$ai), $cfd75c534a862da6$var$hi = "\\d{3}-?\\d{2}-?\\d{4}", $cfd75c534a862da6$var$di = new RegExp("^(" + $cfd75c534a862da6$var$hi + ")$"), $cfd75c534a862da6$var$vi = new RegExp("(" + $cfd75c534a862da6$var$hi + ")");
function $cfd75c534a862da6$var$ci(t, i) {
    if (void 0 === i && (i = !0), $cfd75c534a862da6$var$F(t)) return !1;
    if ($cfd75c534a862da6$var$T(t)) {
        if (t = $cfd75c534a862da6$var$b(t), (i ? $cfd75c534a862da6$var$li : $cfd75c534a862da6$var$ui).test((t || "").replace(/[- ]/g, ""))) return !1;
        if ((i ? $cfd75c534a862da6$var$di : $cfd75c534a862da6$var$vi).test(t)) return !1;
    }
    return !0;
}
function $cfd75c534a862da6$var$fi(t) {
    var i = $cfd75c534a862da6$var$ti(t);
    return $cfd75c534a862da6$var$ci(i = (i + " " + $cfd75c534a862da6$var$pi(t)).trim()) ? i : "";
}
function $cfd75c534a862da6$var$pi(t) {
    var i = "";
    return t && t.childNodes && t.childNodes.length && $cfd75c534a862da6$var$J(t.childNodes, function(t) {
        var e;
        if (t && "span" === (null == (e = t.tagName) ? void 0 : e.toLowerCase())) try {
            var r = $cfd75c534a862da6$var$ti(t);
            i = (i + " " + r).trim(), t.childNodes && t.childNodes.length && (i = (i + " " + $cfd75c534a862da6$var$pi(t)).trim());
        } catch (t) {
            $cfd75c534a862da6$var$N.error("[AutoCapture]", t);
        }
    }), i;
}
function $cfd75c534a862da6$var$gi(t) {
    return function(t) {
        var i = t.map((t)=>{
            var i, e, r = "";
            if (t.tag_name && (r += t.tag_name), t.attr_class) for (var s of (t.attr_class.sort(), t.attr_class))r += "." + s.replace(/"/g, "");
            var n = $cfd75c534a862da6$var$B({}, t.text ? {
                text: t.text
            } : {}, {
                "nth-child": null !== (i = t.nth_child) && void 0 !== i ? i : 0,
                "nth-of-type": null !== (e = t.nth_of_type) && void 0 !== e ? e : 0
            }, t.href ? {
                href: t.href
            } : {}, t.attr_id ? {
                attr_id: t.attr_id
            } : {}, t.attributes), o = {};
            return $cfd75c534a862da6$var$Y(n).sort((t, i)=>{
                var [e] = t, [r] = i;
                return e.localeCompare(r);
            }).forEach((t)=>{
                var [i, e] = t;
                return o[$cfd75c534a862da6$var$_i(i.toString())] = $cfd75c534a862da6$var$_i(e.toString());
            }), r += ":", r += $cfd75c534a862da6$var$Y(o).map((t)=>{
                var [i, e] = t;
                return i + '="' + e + '"';
            }).join("");
        });
        return i.join(";");
    }(function(t) {
        return t.map((t)=>{
            var i, e, r = {
                text: null == (i = t.$el_text) ? void 0 : i.slice(0, 400),
                tag_name: t.tag_name,
                href: null == (e = t.attr__href) ? void 0 : e.slice(0, 2048),
                attr_class: $cfd75c534a862da6$var$mi(t),
                attr_id: t.attr__id,
                nth_child: t.nth_child,
                nth_of_type: t.nth_of_type,
                attributes: {}
            };
            return $cfd75c534a862da6$var$Y(t).filter((t)=>{
                var [i] = t;
                return 0 === i.indexOf("attr__");
            }).forEach((t)=>{
                var [i, e] = t;
                return r.attributes[i] = e;
            }), r;
        });
    }(t));
}
function $cfd75c534a862da6$var$_i(t) {
    return t.replace(/"|\\"/g, '\\"');
}
function $cfd75c534a862da6$var$mi(t) {
    var i = t.attr__class;
    return i ? $cfd75c534a862da6$var$x(i) ? i : $cfd75c534a862da6$var$Yt(i) : void 0;
}
class $cfd75c534a862da6$var$bi {
    constructor(){
        this.clicks = [];
    }
    isRageClick(t, i, e) {
        var r = this.clicks[this.clicks.length - 1];
        if (r && Math.abs(t - r.x) + Math.abs(i - r.y) < 30 && e - r.timestamp < 1e3) {
            if (this.clicks.push({
                x: t,
                y: i,
                timestamp: e
            }), 3 === this.clicks.length) return !0;
        } else this.clicks = [
            {
                x: t,
                y: i,
                timestamp: e
            }
        ];
        return !1;
    }
}
var $cfd75c534a862da6$var$yi = [
    "localhost",
    "127.0.0.1"
], $cfd75c534a862da6$var$wi = (t)=>{
    var i = null == $cfd75c534a862da6$var$o ? void 0 : $cfd75c534a862da6$var$o.createElement("a");
    return $cfd75c534a862da6$var$R(i) ? null : (i.href = t, i);
}, $cfd75c534a862da6$var$Si = function(t, i) {
    var e, r;
    void 0 === i && (i = "&");
    var s = [];
    return $cfd75c534a862da6$var$J(t, function(t, i) {
        $cfd75c534a862da6$var$R(t) || $cfd75c534a862da6$var$R(i) || "undefined" === i || (e = encodeURIComponent(((t)=>t instanceof File)(t) ? t.name : t.toString()), r = encodeURIComponent(i), s[s.length] = r + "=" + e);
    }), s.join(i);
}, $cfd75c534a862da6$var$$i = function(t, i) {
    for(var e, r = ((t.split("#")[0] || "").split(/\?(.*)/)[1] || "").replace(/^\?+/g, "").split("&"), s = 0; s < r.length; s++){
        var n = r[s].split("=");
        if (n[0] === i) {
            e = n;
            break;
        }
    }
    if (!$cfd75c534a862da6$var$x(e) || e.length < 2) return "";
    var o = e[1];
    try {
        o = decodeURIComponent(o);
    } catch (t) {
        $cfd75c534a862da6$var$N.error("Skipping decoding for malformed query param: " + o);
    }
    return o.replace(/\+/g, " ");
}, $cfd75c534a862da6$var$ki = function(t, i, e) {
    if (!t || !i || !i.length) return t;
    for(var r = t.split("#"), s = r[0] || "", n = r[1], o = s.split("?"), a = o[1], l = o[0], u = (a || "").split("&"), h = [], d = 0; d < u.length; d++){
        var v = u[d].split("=");
        $cfd75c534a862da6$var$x(v) && (i.includes(v[0]) ? h.push(v[0] + "=" + e) : h.push(u[d]));
    }
    var c = l;
    return null != a && (c += "?" + h.join("&")), null != n && (c += "#" + n), c;
}, $cfd75c534a862da6$var$xi = function(t, i) {
    var e = t.match(new RegExp(i + "=([^&]*)"));
    return e ? e[1] : null;
}, $cfd75c534a862da6$var$Ei = $cfd75c534a862da6$var$z("[AutoCapture]");
function $cfd75c534a862da6$var$Ii(t, i) {
    return i.length > t ? i.slice(0, t) + "..." : i;
}
function $cfd75c534a862da6$var$Pi(t) {
    if (t.previousElementSibling) return t.previousElementSibling;
    var i = t;
    do i = i.previousSibling;
    while (i && !$cfd75c534a862da6$var$Gt(i));
    return i;
}
function $cfd75c534a862da6$var$Ri(t, i, e, r) {
    var s = t.tagName.toLowerCase(), n = {
        tag_name: s
    };
    $cfd75c534a862da6$var$ei.indexOf(s) > -1 && !e && ("a" === s.toLowerCase() || "button" === s.toLowerCase() ? n.$el_text = $cfd75c534a862da6$var$Ii(1024, $cfd75c534a862da6$var$fi(t)) : n.$el_text = $cfd75c534a862da6$var$Ii(1024, $cfd75c534a862da6$var$ti(t)));
    var o = $cfd75c534a862da6$var$Qt(t);
    o.length > 0 && (n.classes = o.filter(function(t) {
        return "" !== t;
    })), $cfd75c534a862da6$var$J(t.attributes, function(e) {
        var s;
        if ((!$cfd75c534a862da6$var$oi(t) || -1 !== [
            "name",
            "id",
            "class",
            "aria-label"
        ].indexOf(e.name)) && (null == r || !r.includes(e.name)) && !i && $cfd75c534a862da6$var$ci(e.value) && (s = e.name, !$cfd75c534a862da6$var$T(s) || "_ngcontent" !== s.substring(0, 10) && "_nghost" !== s.substring(0, 7))) {
            var o = e.value;
            "class" === e.name && (o = $cfd75c534a862da6$var$Yt(o).join(" ")), n["attr__" + e.name] = $cfd75c534a862da6$var$Ii(1024, o);
        }
    });
    for(var a = 1, l = 1, u = t; u = $cfd75c534a862da6$var$Pi(u);)a++, u.tagName === t.tagName && l++;
    return n.nth_child = a, n.nth_of_type = l, n;
}
function $cfd75c534a862da6$var$Ti(i, e) {
    for(var r, s, { e: n, maskAllElementAttributes: o, maskAllText: a, elementAttributeIgnoreList: l, elementsChainAsString: u } = e, h = [
        i
    ], d = i; d.parentNode && !$cfd75c534a862da6$var$Jt(d, "body");)$cfd75c534a862da6$var$Kt(d.parentNode) ? (h.push(d.parentNode.host), d = d.parentNode.host) : (h.push(d.parentNode), d = d.parentNode);
    var v, c = [], f = {}, p = !1, g = !1;
    if ($cfd75c534a862da6$var$J(h, (t)=>{
        var i = $cfd75c534a862da6$var$ni(t);
        "a" === t.tagName.toLowerCase() && (p = t.getAttribute("href"), p = i && p && $cfd75c534a862da6$var$ci(p) && p), $cfd75c534a862da6$var$m($cfd75c534a862da6$var$Qt(t), "ph-no-capture") && (g = !0), c.push($cfd75c534a862da6$var$Ri(t, o, a, l));
        var e = function(t) {
            if (!$cfd75c534a862da6$var$ni(t)) return {};
            var i = {};
            return $cfd75c534a862da6$var$J(t.attributes, function(t) {
                if (t.name && 0 === t.name.indexOf("data-ph-capture-attribute")) {
                    var e = t.name.replace("data-ph-capture-attribute-", ""), r = t.value;
                    e && r && $cfd75c534a862da6$var$ci(r) && (i[e] = r);
                }
            }), i;
        }(t);
        $cfd75c534a862da6$var$V(f, e);
    }), g) return {
        props: {},
        explicitNoCapture: g
    };
    if (a || ("a" === i.tagName.toLowerCase() || "button" === i.tagName.toLowerCase() ? c[0].$el_text = $cfd75c534a862da6$var$fi(i) : c[0].$el_text = $cfd75c534a862da6$var$ti(i)), p) {
        var _, b;
        c[0].attr__href = p;
        var y = null == (_ = $cfd75c534a862da6$var$wi(p)) ? void 0 : _.host, w = null == $cfd75c534a862da6$var$t || null == (b = $cfd75c534a862da6$var$t.location) ? void 0 : b.host;
        y && w && y !== w && (v = p);
    }
    return {
        props: $cfd75c534a862da6$var$V({
            $event_type: n.type,
            $ce_version: 1
        }, u ? {} : {
            $elements: c
        }, {
            $elements_chain: $cfd75c534a862da6$var$gi(c)
        }, null != (r = c[0]) && r.$el_text ? {
            $el_text: null == (s = c[0]) ? void 0 : s.$el_text
        } : {}, v && "click" === n.type ? {
            $external_click_url: v
        } : {}, f)
    };
}
class $cfd75c534a862da6$var$Mi {
    constructor(t){
        this.i = !1, this.o = null, this.rageclicks = new $cfd75c534a862da6$var$bi, this.h = !1, this.instance = t, this.m = null;
    }
    get S() {
        var t, i, e = $cfd75c534a862da6$var$I(this.instance.config.autocapture) ? this.instance.config.autocapture : {};
        return e.url_allowlist = null == (t = e.url_allowlist) ? void 0 : t.map((t)=>new RegExp(t)), e.url_ignorelist = null == (i = e.url_ignorelist) ? void 0 : i.map((t)=>new RegExp(t)), e;
    }
    $() {
        if (this.isBrowserSupported()) {
            if ($cfd75c534a862da6$var$t && $cfd75c534a862da6$var$o) {
                var i = (i)=>{
                    i = i || (null == $cfd75c534a862da6$var$t ? void 0 : $cfd75c534a862da6$var$t.event);
                    try {
                        this.k(i);
                    } catch (t) {
                        $cfd75c534a862da6$var$Ei.error("Failed to capture event", t);
                    }
                };
                if ($cfd75c534a862da6$var$st($cfd75c534a862da6$var$o, "submit", i, {
                    capture: !0
                }), $cfd75c534a862da6$var$st($cfd75c534a862da6$var$o, "change", i, {
                    capture: !0
                }), $cfd75c534a862da6$var$st($cfd75c534a862da6$var$o, "click", i, {
                    capture: !0
                }), this.S.capture_copied_text) {
                    var e = (i)=>{
                        i = i || (null == $cfd75c534a862da6$var$t ? void 0 : $cfd75c534a862da6$var$t.event), this.k(i, $cfd75c534a862da6$export$7bea938663611d9);
                    };
                    $cfd75c534a862da6$var$st($cfd75c534a862da6$var$o, "copy", e, {
                        capture: !0
                    }), $cfd75c534a862da6$var$st($cfd75c534a862da6$var$o, "cut", e, {
                        capture: !0
                    });
                }
            }
        } else $cfd75c534a862da6$var$Ei.info("Disabling Automatic Event Collection because this browser is not supported");
    }
    startIfEnabled() {
        this.isEnabled && !this.i && (this.$(), this.i = !0);
    }
    onRemoteConfig(t) {
        t.elementsChainAsString && (this.h = t.elementsChainAsString), this.instance.persistence && this.instance.persistence.register({
            [$cfd75c534a862da6$var$lt]: !!t.autocapture_opt_out
        }), this.o = !!t.autocapture_opt_out, this.startIfEnabled();
    }
    setElementSelectors(t) {
        this.m = t;
    }
    getElementSelectors(t) {
        var i, e = [];
        return null == (i = this.m) || i.forEach((i)=>{
            var r = null == $cfd75c534a862da6$var$o ? void 0 : $cfd75c534a862da6$var$o.querySelectorAll(i);
            null == r || r.forEach((r)=>{
                t === r && e.push(i);
            });
        }), e;
    }
    get isEnabled() {
        var t, i, e = null == (t = this.instance.persistence) ? void 0 : t.props[$cfd75c534a862da6$var$lt], r = this.o;
        if ($cfd75c534a862da6$var$C(r) && !$cfd75c534a862da6$var$A(e) && !this.instance.I()) return !1;
        var s = null !== (i = this.o) && void 0 !== i ? i : !!e;
        return !!this.instance.config.autocapture && !s;
    }
    k(i, e) {
        if (void 0 === e && (e = "$autocapture"), this.isEnabled) {
            var r, s = $cfd75c534a862da6$var$ii(i);
            if ($cfd75c534a862da6$var$Vt(s) && (s = s.parentNode || null), "$autocapture" === e && "click" === i.type && i instanceof MouseEvent) this.instance.config.rageclick && null != (r = this.rageclicks) && r.isRageClick(i.clientX, i.clientY, (new Date).getTime()) && this.k(i, "$rageclick");
            var n = e === $cfd75c534a862da6$export$7bea938663611d9;
            if (s && $cfd75c534a862da6$var$si(s, i, this.S, n, n ? [
                "copy",
                "cut"
            ] : void 0)) {
                var { props: o, explicitNoCapture: a } = $cfd75c534a862da6$var$Ti(s, {
                    e: i,
                    maskAllElementAttributes: this.instance.config.mask_all_element_attributes,
                    maskAllText: this.instance.config.mask_all_text,
                    elementAttributeIgnoreList: this.S.element_attribute_ignorelist,
                    elementsChainAsString: this.h
                });
                if (a) return !1;
                var l = this.getElementSelectors(s);
                if (l && l.length > 0 && (o.$element_selectors = l), e === $cfd75c534a862da6$export$7bea938663611d9) {
                    var u, h = $cfd75c534a862da6$var$Zt(null == $cfd75c534a862da6$var$t || null == (u = $cfd75c534a862da6$var$t.getSelection()) ? void 0 : u.toString()), d = i.type || "clipboard";
                    if (!h) return !1;
                    o.$selected_content = h, o.$copy_type = d;
                }
                return this.instance.capture(e, o), !0;
            }
        }
    }
    isBrowserSupported() {
        return $cfd75c534a862da6$var$E(null == $cfd75c534a862da6$var$o ? void 0 : $cfd75c534a862da6$var$o.querySelectorAll);
    }
}
Math.trunc || (Math.trunc = function(t) {
    return t < 0 ? Math.ceil(t) : Math.floor(t);
}), Number.isInteger || (Number.isInteger = function(t) {
    return $cfd75c534a862da6$var$O(t) && isFinite(t) && Math.floor(t) === t;
});
var $cfd75c534a862da6$var$Ci = "0123456789abcdef";
class $cfd75c534a862da6$var$Fi {
    constructor(t){
        if (this.bytes = t, 16 !== t.length) throw new TypeError("not 128-bit length");
    }
    static fromFieldsV7(t, i, e, r) {
        if (!Number.isInteger(t) || !Number.isInteger(i) || !Number.isInteger(e) || !Number.isInteger(r) || t < 0 || i < 0 || e < 0 || r < 0 || t > 0xffffffffffff || i > 4095 || e > 1073741823 || r > 4294967295) throw new RangeError("invalid field value");
        var s = new Uint8Array(16);
        return s[0] = t / Math.pow(2, 40), s[1] = t / Math.pow(2, 32), s[2] = t / Math.pow(2, 24), s[3] = t / Math.pow(2, 16), s[4] = t / Math.pow(2, 8), s[5] = t, s[6] = 112 | i >>> 8, s[7] = i, s[8] = 128 | e >>> 24, s[9] = e >>> 16, s[10] = e >>> 8, s[11] = e, s[12] = r >>> 24, s[13] = r >>> 16, s[14] = r >>> 8, s[15] = r, new $cfd75c534a862da6$var$Fi(s);
    }
    toString() {
        for(var t = "", i = 0; i < this.bytes.length; i++)t = t + $cfd75c534a862da6$var$Ci.charAt(this.bytes[i] >>> 4) + $cfd75c534a862da6$var$Ci.charAt(15 & this.bytes[i]), 3 !== i && 5 !== i && 7 !== i && 9 !== i || (t += "-");
        if (36 !== t.length) throw new Error("Invalid UUIDv7 was generated");
        return t;
    }
    clone() {
        return new $cfd75c534a862da6$var$Fi(this.bytes.slice(0));
    }
    equals(t) {
        return 0 === this.compareTo(t);
    }
    compareTo(t) {
        for(var i = 0; i < 16; i++){
            var e = this.bytes[i] - t.bytes[i];
            if (0 !== e) return Math.sign(e);
        }
        return 0;
    }
}
class $cfd75c534a862da6$var$Oi {
    constructor(){
        this.P = 0, this.R = 0, this.T = new $cfd75c534a862da6$var$Li;
    }
    generate() {
        var t = this.generateOrAbort();
        if ($cfd75c534a862da6$var$R(t)) {
            this.P = 0;
            var i = this.generateOrAbort();
            if ($cfd75c534a862da6$var$R(i)) throw new Error("Could not generate UUID after timestamp reset");
            return i;
        }
        return t;
    }
    generateOrAbort() {
        var t = Date.now();
        if (t > this.P) this.P = t, this.M();
        else {
            if (!(t + 1e4 > this.P)) return;
            this.R++, this.R > 4398046511103 && (this.P++, this.M());
        }
        return $cfd75c534a862da6$var$Fi.fromFieldsV7(this.P, Math.trunc(this.R / Math.pow(2, 30)), this.R & Math.pow(2, 30) - 1, this.T.nextUint32());
    }
    M() {
        this.R = 1024 * this.T.nextUint32() + (1023 & this.T.nextUint32());
    }
}
var $cfd75c534a862da6$var$Ai, $cfd75c534a862da6$var$Di = (t)=>{
    if ("undefined" != typeof UUIDV7_DENY_WEAK_RNG && UUIDV7_DENY_WEAK_RNG) throw new Error("no cryptographically strong RNG available");
    for(var i = 0; i < t.length; i++)t[i] = 65536 * Math.trunc(65536 * Math.random()) + Math.trunc(65536 * Math.random());
    return t;
};
$cfd75c534a862da6$var$t && !$cfd75c534a862da6$var$R($cfd75c534a862da6$var$t.crypto) && crypto.getRandomValues && ($cfd75c534a862da6$var$Di = (t)=>crypto.getRandomValues(t));
class $cfd75c534a862da6$var$Li {
    constructor(){
        this.C = new Uint32Array(8), this.F = 1 / 0;
    }
    nextUint32() {
        return this.F >= this.C.length && ($cfd75c534a862da6$var$Di(this.C), this.F = 0), this.C[this.F++];
    }
}
var $cfd75c534a862da6$var$ji = ()=>$cfd75c534a862da6$var$Ni().toString(), $cfd75c534a862da6$var$Ni = ()=>($cfd75c534a862da6$var$Ai || ($cfd75c534a862da6$var$Ai = new $cfd75c534a862da6$var$Oi)).generate(), $cfd75c534a862da6$var$zi = "";
var $cfd75c534a862da6$var$Ui = /[a-z0-9][a-z0-9-]+\.[a-z]{2,}$/i;
function $cfd75c534a862da6$var$qi(t, i) {
    if (i) {
        var e = function(t, i) {
            if (void 0 === i && (i = $cfd75c534a862da6$var$o), $cfd75c534a862da6$var$zi) return $cfd75c534a862da6$var$zi;
            if (!i) return "";
            if ([
                "localhost",
                "127.0.0.1"
            ].includes(t)) return "";
            for(var e = t.split("."), r = Math.min(e.length, 8), s = "dmn_chk_" + $cfd75c534a862da6$var$ji(); !$cfd75c534a862da6$var$zi && r--;){
                var n = e.slice(r).join("."), a = s + "=1;domain=." + n + ";path=/";
                i.cookie = a + ";max-age=3", i.cookie.includes(s) && (i.cookie = a + ";max-age=0", $cfd75c534a862da6$var$zi = n);
            }
            return $cfd75c534a862da6$var$zi;
        }(t);
        if (!e) {
            var r = ((t)=>{
                var i = t.match($cfd75c534a862da6$var$Ui);
                return i ? i[0] : "";
            })(t);
            r !== e && $cfd75c534a862da6$var$N.info("Warning: cookie subdomain discovery mismatch", r, e), e = r;
        }
        return e ? "; domain=." + e : "";
    }
    return "";
}
var $cfd75c534a862da6$var$Bi = {
    O: ()=>!!$cfd75c534a862da6$var$o,
    A: function(t) {
        $cfd75c534a862da6$var$N.error("cookieStore error: " + t);
    },
    D: function(t) {
        if ($cfd75c534a862da6$var$o) {
            try {
                for(var i = t + "=", e = $cfd75c534a862da6$var$o.cookie.split(";").filter((t)=>t.length), r = 0; r < e.length; r++){
                    for(var s = e[r]; " " == s.charAt(0);)s = s.substring(1, s.length);
                    if (0 === s.indexOf(i)) return decodeURIComponent(s.substring(i.length, s.length));
                }
            } catch (t) {}
            return null;
        }
    },
    L: function(t) {
        var i;
        try {
            i = JSON.parse($cfd75c534a862da6$var$Bi.D(t)) || {};
        } catch (t) {}
        return i;
    },
    j: function(t, i, e, r, s) {
        if ($cfd75c534a862da6$var$o) try {
            var n = "", a = "", l = $cfd75c534a862da6$var$qi($cfd75c534a862da6$var$o.location.hostname, r);
            if (e) {
                var u = new Date;
                u.setTime(u.getTime() + 24 * e * 3600000), n = "; expires=" + u.toUTCString();
            }
            s && (a = "; secure");
            var h = t + "=" + encodeURIComponent(JSON.stringify(i)) + n + "; SameSite=Lax; path=/" + l + a;
            return h.length > 3686.4 && $cfd75c534a862da6$var$N.warn("cookieStore warning: large cookie, len=" + h.length), $cfd75c534a862da6$var$o.cookie = h, h;
        } catch (t) {
            return;
        }
    },
    N: function(t, i) {
        try {
            $cfd75c534a862da6$var$Bi.j(t, "", -1, i);
        } catch (t) {
            return;
        }
    }
}, $cfd75c534a862da6$var$Hi = null, $cfd75c534a862da6$var$Wi = {
    O: function() {
        if (!$cfd75c534a862da6$var$C($cfd75c534a862da6$var$Hi)) return $cfd75c534a862da6$var$Hi;
        var i = !0;
        if ($cfd75c534a862da6$var$R($cfd75c534a862da6$var$t)) i = !1;
        else try {
            var e = "__mplssupport__";
            $cfd75c534a862da6$var$Wi.j(e, "xyz"), '"xyz"' !== $cfd75c534a862da6$var$Wi.D(e) && (i = !1), $cfd75c534a862da6$var$Wi.N(e);
        } catch (t) {
            i = !1;
        }
        return i || $cfd75c534a862da6$var$N.error("localStorage unsupported; falling back to cookie store"), $cfd75c534a862da6$var$Hi = i, i;
    },
    A: function(t) {
        $cfd75c534a862da6$var$N.error("localStorage error: " + t);
    },
    D: function(i) {
        try {
            return null == $cfd75c534a862da6$var$t ? void 0 : $cfd75c534a862da6$var$t.localStorage.getItem(i);
        } catch (t) {
            $cfd75c534a862da6$var$Wi.A(t);
        }
        return null;
    },
    L: function(t) {
        try {
            return JSON.parse($cfd75c534a862da6$var$Wi.D(t)) || {};
        } catch (t) {}
        return null;
    },
    j: function(i, e) {
        try {
            null == $cfd75c534a862da6$var$t || $cfd75c534a862da6$var$t.localStorage.setItem(i, JSON.stringify(e));
        } catch (t) {
            $cfd75c534a862da6$var$Wi.A(t);
        }
    },
    N: function(i) {
        try {
            null == $cfd75c534a862da6$var$t || $cfd75c534a862da6$var$t.localStorage.removeItem(i);
        } catch (t) {
            $cfd75c534a862da6$var$Wi.A(t);
        }
    }
}, $cfd75c534a862da6$var$Gi = [
    "distinct_id",
    $cfd75c534a862da6$var$$t,
    $cfd75c534a862da6$var$kt,
    $cfd75c534a862da6$var$Ut,
    $cfd75c534a862da6$var$zt
], $cfd75c534a862da6$var$Ji = $cfd75c534a862da6$var$B({}, $cfd75c534a862da6$var$Wi, {
    L: function(t) {
        try {
            var i = {};
            try {
                i = $cfd75c534a862da6$var$Bi.L(t) || {};
            } catch (t) {}
            var e = $cfd75c534a862da6$var$V(i, JSON.parse($cfd75c534a862da6$var$Wi.D(t) || "{}"));
            return $cfd75c534a862da6$var$Wi.j(t, e), e;
        } catch (t) {}
        return null;
    },
    j: function(t, i, e, r, s, n) {
        try {
            $cfd75c534a862da6$var$Wi.j(t, i, void 0, void 0, n);
            var o = {};
            $cfd75c534a862da6$var$Gi.forEach((t)=>{
                i[t] && (o[t] = i[t]);
            }), Object.keys(o).length && $cfd75c534a862da6$var$Bi.j(t, o, e, r, s, n);
        } catch (t) {
            $cfd75c534a862da6$var$Wi.A(t);
        }
    },
    N: function(i, e) {
        try {
            null == $cfd75c534a862da6$var$t || $cfd75c534a862da6$var$t.localStorage.removeItem(i), $cfd75c534a862da6$var$Bi.N(i, e);
        } catch (t) {
            $cfd75c534a862da6$var$Wi.A(t);
        }
    }
}), $cfd75c534a862da6$var$Vi = {}, $cfd75c534a862da6$var$Ki = {
    O: function() {
        return !0;
    },
    A: function(t) {
        $cfd75c534a862da6$var$N.error("memoryStorage error: " + t);
    },
    D: function(t) {
        return $cfd75c534a862da6$var$Vi[t] || null;
    },
    L: function(t) {
        return $cfd75c534a862da6$var$Vi[t] || null;
    },
    j: function(t, i) {
        $cfd75c534a862da6$var$Vi[t] = i;
    },
    N: function(t) {
        delete $cfd75c534a862da6$var$Vi[t];
    }
}, $cfd75c534a862da6$var$Yi = null, $cfd75c534a862da6$var$Xi = {
    O: function() {
        if (!$cfd75c534a862da6$var$C($cfd75c534a862da6$var$Yi)) return $cfd75c534a862da6$var$Yi;
        if ($cfd75c534a862da6$var$Yi = !0, $cfd75c534a862da6$var$R($cfd75c534a862da6$var$t)) $cfd75c534a862da6$var$Yi = !1;
        else try {
            var i = "__support__";
            $cfd75c534a862da6$var$Xi.j(i, "xyz"), '"xyz"' !== $cfd75c534a862da6$var$Xi.D(i) && ($cfd75c534a862da6$var$Yi = !1), $cfd75c534a862da6$var$Xi.N(i);
        } catch (t) {
            $cfd75c534a862da6$var$Yi = !1;
        }
        return $cfd75c534a862da6$var$Yi;
    },
    A: function(t) {
        $cfd75c534a862da6$var$N.error("sessionStorage error: ", t);
    },
    D: function(i) {
        try {
            return null == $cfd75c534a862da6$var$t ? void 0 : $cfd75c534a862da6$var$t.sessionStorage.getItem(i);
        } catch (t) {
            $cfd75c534a862da6$var$Xi.A(t);
        }
        return null;
    },
    L: function(t) {
        try {
            return JSON.parse($cfd75c534a862da6$var$Xi.D(t)) || null;
        } catch (t) {}
        return null;
    },
    j: function(i, e) {
        try {
            null == $cfd75c534a862da6$var$t || $cfd75c534a862da6$var$t.sessionStorage.setItem(i, JSON.stringify(e));
        } catch (t) {
            $cfd75c534a862da6$var$Xi.A(t);
        }
    },
    N: function(i) {
        try {
            null == $cfd75c534a862da6$var$t || $cfd75c534a862da6$var$t.sessionStorage.removeItem(i);
        } catch (t) {
            $cfd75c534a862da6$var$Xi.A(t);
        }
    }
}, $cfd75c534a862da6$var$Qi = function(t) {
    return t[t.PENDING = -1] = "PENDING", t[t.DENIED = 0] = "DENIED", t[t.GRANTED = 1] = "GRANTED", t;
}({});
class $cfd75c534a862da6$var$Zi {
    constructor(t){
        this._instance = t;
    }
    get S() {
        return this._instance.config;
    }
    get consent() {
        return this.U() ? $cfd75c534a862da6$var$Qi.DENIED : this.q;
    }
    isOptedOut() {
        return this.consent === $cfd75c534a862da6$var$Qi.DENIED || this.consent === $cfd75c534a862da6$var$Qi.PENDING && this.S.opt_out_capturing_by_default;
    }
    isOptedIn() {
        return !this.isOptedOut();
    }
    optInOut(t) {
        this.B.j(this.H, t ? 1 : 0, this.S.cookie_expiration, this.S.cross_subdomain_cookie, this.S.secure_cookie);
    }
    reset() {
        this.B.N(this.H, this.S.cross_subdomain_cookie);
    }
    get H() {
        var { token: t, opt_out_capturing_cookie_prefix: i } = this._instance.config;
        return (i || "__ph_opt_in_out_") + t;
    }
    get q() {
        var t = this.B.D(this.H);
        return "1" === t ? $cfd75c534a862da6$var$Qi.GRANTED : "0" === t ? $cfd75c534a862da6$var$Qi.DENIED : $cfd75c534a862da6$var$Qi.PENDING;
    }
    get B() {
        if (!this.W) {
            var t = this.S.opt_out_capturing_persistence_type;
            this.W = "localStorage" === t ? $cfd75c534a862da6$var$Wi : $cfd75c534a862da6$var$Bi;
            var i = "localStorage" === t ? $cfd75c534a862da6$var$Bi : $cfd75c534a862da6$var$Wi;
            i.D(this.H) && (this.W.D(this.H) || this.optInOut("1" === i.D(this.H)), i.N(this.H, this.S.cross_subdomain_cookie));
        }
        return this.W;
    }
    U() {
        return !!this.S.respect_dnt && !!$cfd75c534a862da6$var$rt([
            null == $cfd75c534a862da6$var$n ? void 0 : $cfd75c534a862da6$var$n.doNotTrack,
            null == $cfd75c534a862da6$var$n ? void 0 : $cfd75c534a862da6$var$n.msDoNotTrack,
            $cfd75c534a862da6$var$v.doNotTrack
        ], (t)=>$cfd75c534a862da6$var$m([
                !0,
                1,
                "1",
                "yes"
            ], t));
    }
}
var $cfd75c534a862da6$var$te = $cfd75c534a862da6$var$z("[Dead Clicks]"), $cfd75c534a862da6$var$ie = ()=>!0, $cfd75c534a862da6$var$ee = (t)=>{
    var i, e = !(null == (i = t.instance.persistence) || !i.get_property($cfd75c534a862da6$var$ct)), r = t.instance.config.capture_dead_clicks;
    return $cfd75c534a862da6$var$A(r) ? r : e;
};
class $cfd75c534a862da6$var$re {
    get lazyLoadedDeadClicksAutocapture() {
        return this.G;
    }
    constructor(t, i, e){
        this.instance = t, this.isEnabled = i, this.onCapture = e, this.startIfEnabled();
    }
    onRemoteConfig(t) {
        this.instance.persistence && this.instance.persistence.register({
            [$cfd75c534a862da6$var$ct]: null == t ? void 0 : t.captureDeadClicks
        }), this.startIfEnabled();
    }
    startIfEnabled() {
        this.isEnabled(this) && this.J(()=>{
            this.V();
        });
    }
    J(t) {
        var i, e;
        null != (i = $cfd75c534a862da6$var$v.__PosthogExtensions__) && i.initDeadClicksAutocapture && t(), null == (e = $cfd75c534a862da6$var$v.__PosthogExtensions__) || null == e.loadExternalDependency || e.loadExternalDependency(this.instance, "dead-clicks-autocapture", (i)=>{
            i ? $cfd75c534a862da6$var$te.error("failed to load script", i) : t();
        });
    }
    V() {
        var t;
        if ($cfd75c534a862da6$var$o) {
            if (!this.G && null != (t = $cfd75c534a862da6$var$v.__PosthogExtensions__) && t.initDeadClicksAutocapture) {
                var i = $cfd75c534a862da6$var$I(this.instance.config.capture_dead_clicks) ? this.instance.config.capture_dead_clicks : {};
                i.__onCapture = this.onCapture, this.G = $cfd75c534a862da6$var$v.__PosthogExtensions__.initDeadClicksAutocapture(this.instance, i), this.G.start($cfd75c534a862da6$var$o), $cfd75c534a862da6$var$te.info("starting...");
            }
        } else $cfd75c534a862da6$var$te.error("`document` not found. Cannot start.");
    }
    stop() {
        this.G && (this.G.stop(), this.G = void 0, $cfd75c534a862da6$var$te.info("stopping..."));
    }
}
function $cfd75c534a862da6$var$se(t, i, e, r, s) {
    return i > e && ($cfd75c534a862da6$var$N.warn("min cannot be greater than max."), i = e), $cfd75c534a862da6$var$O(t) ? t > e ? (r && $cfd75c534a862da6$var$N.warn(r + " cannot be  greater than max: " + e + ". Using max value instead."), e) : t < i ? (r && $cfd75c534a862da6$var$N.warn(r + " cannot be less than min: " + i + ". Using min value instead."), i) : t : (r && $cfd75c534a862da6$var$N.warn(r + " must be a number. using max or fallback. max: " + e + ", fallback: " + s), $cfd75c534a862da6$var$se(s || e, i, e, r));
}
class $cfd75c534a862da6$var$ne {
    constructor(t){
        this.K = {}, this.Y = ()=>{
            Object.keys(this.K).forEach((t)=>{
                var i = this.X(t) + this.Z;
                i >= this.tt ? delete this.K[t] : this.it(t, i);
            });
        }, this.X = (t)=>this.K[String(t)], this.it = (t, i)=>{
            this.K[String(t)] = i;
        }, this.consumeRateLimit = (t)=>{
            var i, e = null !== (i = this.X(t)) && void 0 !== i ? i : this.tt;
            if (0 === (e = Math.max(e - 1, 0))) return !0;
            this.it(t, e);
            var r, s = 0 === e;
            s && (null == (r = this.et) || r.call(this, t));
            return s;
        }, this.rt = t, this.et = this.rt.et, this.tt = $cfd75c534a862da6$var$se(this.rt.bucketSize, 0, 100, "rate limiter bucket size"), this.Z = $cfd75c534a862da6$var$se(this.rt.refillRate, 0, this.tt, "rate limiter refill rate"), this.st = $cfd75c534a862da6$var$se(this.rt.refillInterval, 0, 864e5, "rate limiter refill interval"), setInterval(()=>{
            this.Y();
        }, this.st);
    }
}
var $cfd75c534a862da6$var$oe = $cfd75c534a862da6$var$z("[ExceptionAutocapture]");
class $cfd75c534a862da6$var$ae {
    constructor(i){
        var e, r, s;
        this.nt = ()=>{
            var i;
            if ($cfd75c534a862da6$var$t && this.isEnabled && null != (i = $cfd75c534a862da6$var$v.__PosthogExtensions__) && i.errorWrappingFunctions) {
                var e = $cfd75c534a862da6$var$v.__PosthogExtensions__.errorWrappingFunctions.wrapOnError, r = $cfd75c534a862da6$var$v.__PosthogExtensions__.errorWrappingFunctions.wrapUnhandledRejection, s = $cfd75c534a862da6$var$v.__PosthogExtensions__.errorWrappingFunctions.wrapConsoleError;
                try {
                    !this.ot && this.S.capture_unhandled_errors && (this.ot = e(this.captureException.bind(this))), !this.lt && this.S.capture_unhandled_rejections && (this.lt = r(this.captureException.bind(this))), !this.ut && this.S.capture_console_errors && (this.ut = s(this.captureException.bind(this)));
                } catch (t) {
                    $cfd75c534a862da6$var$oe.error("failed to start", t), this.ht();
                }
            }
        }, this._instance = i, this.dt = !(null == (e = this._instance.persistence) || !e.props[$cfd75c534a862da6$var$ht]), this.S = this.vt(), this.ct = new $cfd75c534a862da6$var$ne({
            refillRate: null !== (r = this._instance.config.error_tracking.__exceptionRateLimiterRefillRate) && void 0 !== r ? r : 1,
            bucketSize: null !== (s = this._instance.config.error_tracking.__exceptionRateLimiterBucketSize) && void 0 !== s ? s : 10,
            refillInterval: 1e4
        }), this.startIfEnabled();
    }
    vt() {
        var t = this._instance.config.capture_exceptions, i = {
            capture_unhandled_errors: !1,
            capture_unhandled_rejections: !1,
            capture_console_errors: !1
        };
        return $cfd75c534a862da6$var$I(t) ? i = $cfd75c534a862da6$var$B({}, i, t) : ($cfd75c534a862da6$var$R(t) ? this.dt : t) && (i = $cfd75c534a862da6$var$B({}, i, {
            capture_unhandled_errors: !0,
            capture_unhandled_rejections: !0
        })), i;
    }
    get isEnabled() {
        return this.S.capture_console_errors || this.S.capture_unhandled_errors || this.S.capture_unhandled_rejections;
    }
    startIfEnabled() {
        this.isEnabled && ($cfd75c534a862da6$var$oe.info("enabled"), this.J(this.nt));
    }
    J(t) {
        var i, e;
        null != (i = $cfd75c534a862da6$var$v.__PosthogExtensions__) && i.errorWrappingFunctions && t(), null == (e = $cfd75c534a862da6$var$v.__PosthogExtensions__) || null == e.loadExternalDependency || e.loadExternalDependency(this._instance, "exception-autocapture", (i)=>{
            if (i) return $cfd75c534a862da6$var$oe.error("failed to load script", i);
            t();
        });
    }
    ht() {
        var t, i, e;
        null == (t = this.ot) || t.call(this), this.ot = void 0, null == (i = this.lt) || i.call(this), this.lt = void 0, null == (e = this.ut) || e.call(this), this.ut = void 0;
    }
    onRemoteConfig(t) {
        var i = t.autocaptureExceptions;
        this.dt = !!i || !1, this.S = this.vt(), this._instance.persistence && this._instance.persistence.register({
            [$cfd75c534a862da6$var$ht]: this.dt
        }), this.startIfEnabled();
    }
    captureException(t) {
        var i, e = this._instance.requestRouter.endpointFor("ui");
        t.$exception_personURL = e + "/project/" + this._instance.config.token + "/person/" + this._instance.get_distinct_id();
        var r = null !== (i = t.$exception_list[0].type) && void 0 !== i ? i : "Exception";
        this.ct.consumeRateLimit(r) ? $cfd75c534a862da6$var$oe.info("Skipping exception capture because of client rate limiting.", {
            exception: t.$exception_list[0].type
        }) : this._instance.exceptions.sendExceptionEvent(t);
    }
}
function $cfd75c534a862da6$var$le(t) {
    return !$cfd75c534a862da6$var$R(Event) && $cfd75c534a862da6$var$ue(t, Event);
}
function $cfd75c534a862da6$var$ue(t, i) {
    try {
        return t instanceof i;
    } catch (t) {
        return !1;
    }
}
function $cfd75c534a862da6$var$he(t) {
    switch(Object.prototype.toString.call(t)){
        case "[object Error]":
        case "[object Exception]":
        case "[object DOMException]":
        case "[object DOMError]":
            return !0;
        default:
            return $cfd75c534a862da6$var$ue(t, Error);
    }
}
function $cfd75c534a862da6$var$de(t, i) {
    return Object.prototype.toString.call(t) === "[object " + i + "]";
}
function $cfd75c534a862da6$var$ve(t) {
    return $cfd75c534a862da6$var$de(t, "DOMError");
}
var $cfd75c534a862da6$var$ce = /\(error: (.*)\)/, $cfd75c534a862da6$var$fe = 50, $cfd75c534a862da6$var$pe = "?";
function $cfd75c534a862da6$var$ge(t, i, e, r) {
    var s = {
        platform: "web:javascript",
        filename: t,
        function: "<anonymous>" === i ? $cfd75c534a862da6$var$pe : i,
        in_app: !0
    };
    return $cfd75c534a862da6$var$R(e) || (s.lineno = e), $cfd75c534a862da6$var$R(r) || (s.colno = r), s;
}
var $cfd75c534a862da6$var$_e = /^\s*at (\S+?)(?::(\d+))(?::(\d+))\s*$/i, $cfd75c534a862da6$var$me = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i, $cfd75c534a862da6$var$be = /\((\S*)(?::(\d+))(?::(\d+))\)/, $cfd75c534a862da6$var$ye = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i, $cfd75c534a862da6$var$we = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i, $cfd75c534a862da6$var$Se = function() {
    for(var t = arguments.length, i = new Array(t), e = 0; e < t; e++)i[e] = arguments[e];
    var r = i.sort((t, i)=>t[0] - i[0]).map((t)=>t[1]);
    return function(t, i) {
        void 0 === i && (i = 0);
        for(var e = [], s = t.split("\n"), n = i; n < s.length; n++){
            var o = s[n];
            if (!(o.length > 1024)) {
                var a = $cfd75c534a862da6$var$ce.test(o) ? o.replace($cfd75c534a862da6$var$ce, "$1") : o;
                if (!a.match(/\S*Error: /)) {
                    for (var l of r){
                        var u = l(a);
                        if (u) {
                            e.push(u);
                            break;
                        }
                    }
                    if (e.length >= $cfd75c534a862da6$var$fe) break;
                }
            }
        }
        return function(t) {
            if (!t.length) return [];
            var i = Array.from(t);
            return i.reverse(), i.slice(0, $cfd75c534a862da6$var$fe).map((t)=>$cfd75c534a862da6$var$B({}, t, {
                    filename: t.filename || $cfd75c534a862da6$var$$e(i).filename,
                    function: t.function || $cfd75c534a862da6$var$pe
                }));
        }(e);
    };
}(...[
    [
        30,
        (t)=>{
            var i = $cfd75c534a862da6$var$_e.exec(t);
            if (i) {
                var [, e, r, s] = i;
                return $cfd75c534a862da6$var$ge(e, $cfd75c534a862da6$var$pe, +r, +s);
            }
            var n = $cfd75c534a862da6$var$me.exec(t);
            if (n) {
                if (n[2] && 0 === n[2].indexOf("eval")) {
                    var o = $cfd75c534a862da6$var$be.exec(n[2]);
                    o && (n[2] = o[1], n[3] = o[2], n[4] = o[3]);
                }
                var [a, l] = $cfd75c534a862da6$var$Ie(n[1] || $cfd75c534a862da6$var$pe, n[2]);
                return $cfd75c534a862da6$var$ge(l, a, n[3] ? +n[3] : void 0, n[4] ? +n[4] : void 0);
            }
        }
    ],
    [
        50,
        (t)=>{
            var i = $cfd75c534a862da6$var$ye.exec(t);
            if (i) {
                if (i[3] && i[3].indexOf(" > eval") > -1) {
                    var e = $cfd75c534a862da6$var$we.exec(i[3]);
                    e && (i[1] = i[1] || "eval", i[3] = e[1], i[4] = e[2], i[5] = "");
                }
                var r = i[3], s = i[1] || $cfd75c534a862da6$var$pe;
                return [s, r] = $cfd75c534a862da6$var$Ie(s, r), $cfd75c534a862da6$var$ge(r, s, i[4] ? +i[4] : void 0, i[5] ? +i[5] : void 0);
            }
        }
    ]
]);
function $cfd75c534a862da6$var$$e(t) {
    return t[t.length - 1] || {};
}
var $cfd75c534a862da6$var$ke, $cfd75c534a862da6$var$xe, $cfd75c534a862da6$var$Ee, $cfd75c534a862da6$var$Ie = (t, i)=>{
    var e = -1 !== t.indexOf("safari-extension"), r = -1 !== t.indexOf("safari-web-extension");
    return e || r ? [
        -1 !== t.indexOf("@") ? t.split("@")[0] : $cfd75c534a862da6$var$pe,
        e ? "safari-extension:" + i : "safari-web-extension:" + i
    ] : [
        t,
        i
    ];
};
var $cfd75c534a862da6$var$Pe = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
function $cfd75c534a862da6$var$Re(t, i) {
    void 0 === i && (i = 0);
    var e = t.stacktrace || t.stack || "", r = function(t) {
        if (t && $cfd75c534a862da6$var$Te.test(t.message)) return 1;
        return 0;
    }(t);
    try {
        var s = $cfd75c534a862da6$var$Se, n = function(t, i) {
            var e = function(t) {
                var i = globalThis._posthogChunkIds;
                if (!i) return {};
                var e = Object.keys(i);
                return $cfd75c534a862da6$var$Ee && e.length === $cfd75c534a862da6$var$xe || ($cfd75c534a862da6$var$xe = e.length, $cfd75c534a862da6$var$Ee = e.reduce((e, r)=>{
                    $cfd75c534a862da6$var$ke || ($cfd75c534a862da6$var$ke = {});
                    var s = $cfd75c534a862da6$var$ke[r];
                    if (s) e[s[0]] = s[1];
                    else for(var n = t(r), o = n.length - 1; o >= 0; o--){
                        var a = n[o], l = null == a ? void 0 : a.filename, u = i[r];
                        if (l && u) {
                            e[l] = u, $cfd75c534a862da6$var$ke[r] = [
                                l,
                                u
                            ];
                            break;
                        }
                    }
                    return e;
                }, {})), $cfd75c534a862da6$var$Ee;
            }(i);
            return t.forEach((t)=>{
                t.filename && (t.chunk_id = e[t.filename]);
            }), t;
        }(s(e, r), s);
        return n.slice(0, n.length - i);
    } catch (t) {}
    return [];
}
var $cfd75c534a862da6$var$Te = /Minified React error #\d+;/i;
function $cfd75c534a862da6$var$Me(t, i) {
    var e, r, s = $cfd75c534a862da6$var$Re(t), n = null === (e = null == i ? void 0 : i.handled) || void 0 === e || e, o = null !== (r = null == i ? void 0 : i.synthetic) && void 0 !== r && r;
    return {
        type: null != i && i.overrideExceptionType ? i.overrideExceptionType : t.name,
        value: function(t) {
            var i = t.message;
            if (i.error && "string" == typeof i.error.message) return String(i.error.message);
            return String(i);
        }(t),
        stacktrace: {
            frames: s,
            type: "raw"
        },
        mechanism: {
            handled: n,
            synthetic: o
        }
    };
}
function $cfd75c534a862da6$var$Ce(t, i) {
    var e = $cfd75c534a862da6$var$Me(t, i);
    return t.cause && $cfd75c534a862da6$var$he(t.cause) && t.cause !== t ? [
        e,
        ...$cfd75c534a862da6$var$Ce(t.cause, {
            handled: null == i ? void 0 : i.handled,
            synthetic: null == i ? void 0 : i.synthetic
        })
    ] : [
        e
    ];
}
function $cfd75c534a862da6$var$Fe(t, i) {
    return {
        $exception_list: $cfd75c534a862da6$var$Ce(t, i),
        $exception_level: "error"
    };
}
function $cfd75c534a862da6$var$Oe(t, i) {
    var e, r, s, n = null === (e = null == i ? void 0 : i.handled) || void 0 === e || e, o = null === (r = null == i ? void 0 : i.synthetic) || void 0 === r || r, a = {
        type: null != i && i.overrideExceptionType ? i.overrideExceptionType : null !== (s = null == i ? void 0 : i.defaultExceptionType) && void 0 !== s ? s : "Error",
        value: t || (null == i ? void 0 : i.defaultExceptionMessage),
        mechanism: {
            handled: n,
            synthetic: o
        }
    };
    if (null != i && i.syntheticException) {
        var l = $cfd75c534a862da6$var$Re(i.syntheticException, 1);
        l.length && (a.stacktrace = {
            frames: l,
            type: "raw"
        });
    }
    return {
        $exception_list: [
            a
        ],
        $exception_level: "error"
    };
}
function $cfd75c534a862da6$var$Ae(t) {
    return $cfd75c534a862da6$var$T(t) && !$cfd75c534a862da6$var$M(t) && $cfd75c534a862da6$export$9dd8f6ec3b5e6004.indexOf(t) >= 0;
}
function $cfd75c534a862da6$var$De(t, i) {
    var e, r, s = null === (e = null == i ? void 0 : i.handled) || void 0 === e || e, n = null === (r = null == i ? void 0 : i.synthetic) || void 0 === r || r, o = null != i && i.overrideExceptionType ? i.overrideExceptionType : $cfd75c534a862da6$var$le(t) ? t.constructor.name : "Error", a = "Non-Error 'exception' captured with keys: " + function(t, i) {
        void 0 === i && (i = 40);
        var e = Object.keys(t);
        if (e.sort(), !e.length) return "[object has no keys]";
        for(var r = e.length; r > 0; r--){
            var s = e.slice(0, r).join(", ");
            if (!(s.length > i)) return r === e.length || s.length <= i ? s : s.slice(0, i) + "...";
        }
        return "";
    }(t), l = {
        type: o,
        value: a,
        mechanism: {
            handled: s,
            synthetic: n
        }
    };
    if (null != i && i.syntheticException) {
        var u = $cfd75c534a862da6$var$Re(null == i ? void 0 : i.syntheticException, 1);
        u.length && (l.stacktrace = {
            frames: u,
            type: "raw"
        });
    }
    return {
        $exception_list: [
            l
        ],
        $exception_level: $cfd75c534a862da6$var$Ae(t.level) ? t.level : "error"
    };
}
function $cfd75c534a862da6$var$Le(t, i) {
    var { error: e, event: r } = t, s = {
        $exception_list: []
    }, n = e || r;
    if ($cfd75c534a862da6$var$ve(n) || function(t) {
        return $cfd75c534a862da6$var$de(t, "DOMException");
    }(n)) {
        var o = n;
        if (function(t) {
            return "stack" in t;
        }(n)) s = $cfd75c534a862da6$var$Fe(n, i);
        else {
            var a = o.name || ($cfd75c534a862da6$var$ve(o) ? "DOMError" : "DOMException"), l = o.message ? a + ": " + o.message : a;
            s = $cfd75c534a862da6$var$Oe(l, $cfd75c534a862da6$var$B({}, i, {
                overrideExceptionType: $cfd75c534a862da6$var$ve(o) ? "DOMError" : "DOMException",
                defaultExceptionMessage: l
            }));
        }
        return "code" in o && (s.$exception_DOMException_code = "" + o.code), s;
    }
    if (function(t) {
        return $cfd75c534a862da6$var$de(t, "ErrorEvent");
    }(n) && n.error) return $cfd75c534a862da6$var$Fe(n.error, i);
    if ($cfd75c534a862da6$var$he(n)) return $cfd75c534a862da6$var$Fe(n, i);
    if (function(t) {
        return $cfd75c534a862da6$var$de(t, "Object");
    }(n) || $cfd75c534a862da6$var$le(n)) return $cfd75c534a862da6$var$De(n, i);
    if ($cfd75c534a862da6$var$R(e) && $cfd75c534a862da6$var$T(r)) {
        var u = "Error", h = r, d = r.match($cfd75c534a862da6$var$Pe);
        return d && (u = d[1], h = d[2]), $cfd75c534a862da6$var$Oe(h, $cfd75c534a862da6$var$B({}, i, {
            overrideExceptionType: u,
            defaultExceptionMessage: h
        }));
    }
    return $cfd75c534a862da6$var$Oe(n, i);
}
function $cfd75c534a862da6$var$je(t, i, e) {
    try {
        if (!(i in t)) return ()=>{};
        var r = t[i], s = e(r);
        return $cfd75c534a862da6$var$E(s) && (s.prototype = s.prototype || {}, Object.defineProperties(s, {
            __posthog_wrapped__: {
                enumerable: !1,
                value: !0
            }
        })), t[i] = s, ()=>{
            t[i] = r;
        };
    } catch (t) {
        return ()=>{};
    }
}
class $cfd75c534a862da6$var$Ne {
    constructor(i){
        var e;
        this._instance = i, this.ft = (null == $cfd75c534a862da6$var$t || null == (e = $cfd75c534a862da6$var$t.location) ? void 0 : e.pathname) || "";
    }
    get isEnabled() {
        return "history_change" === this._instance.config.capture_pageview;
    }
    startIfEnabled() {
        this.isEnabled && ($cfd75c534a862da6$var$N.info("History API monitoring enabled, starting..."), this.monitorHistoryChanges());
    }
    stop() {
        this.gt && this.gt(), this.gt = void 0, $cfd75c534a862da6$var$N.info("History API monitoring stopped");
    }
    monitorHistoryChanges() {
        var i, e;
        if ($cfd75c534a862da6$var$t && $cfd75c534a862da6$var$t.history) {
            var r = this;
            null != (i = $cfd75c534a862da6$var$t.history.pushState) && i.__posthog_wrapped__ || $cfd75c534a862da6$var$je($cfd75c534a862da6$var$t.history, "pushState", (t)=>function(i, e, s) {
                    t.call(this, i, e, s), r._t("pushState");
                }), null != (e = $cfd75c534a862da6$var$t.history.replaceState) && e.__posthog_wrapped__ || $cfd75c534a862da6$var$je($cfd75c534a862da6$var$t.history, "replaceState", (t)=>function(i, e, s) {
                    t.call(this, i, e, s), r._t("replaceState");
                }), this.bt();
        }
    }
    _t(i) {
        try {
            var e, r = null == $cfd75c534a862da6$var$t || null == (e = $cfd75c534a862da6$var$t.location) ? void 0 : e.pathname;
            if (!r) return;
            r !== this.ft && this.isEnabled && this._instance.capture("$pageview", {
                navigation_type: i
            }), this.ft = r;
        } catch (t) {
            $cfd75c534a862da6$var$N.error("Error capturing " + i + " pageview", t);
        }
    }
    bt() {
        if (!this.gt) {
            var i = ()=>{
                this._t("popstate");
            };
            $cfd75c534a862da6$var$st($cfd75c534a862da6$var$t, "popstate", i), this.gt = ()=>{
                $cfd75c534a862da6$var$t && $cfd75c534a862da6$var$t.removeEventListener("popstate", i);
            };
        }
    }
}
function $cfd75c534a862da6$var$ze(t) {
    var i, e;
    return (null == (i = JSON.stringify(t, (e = [], function(t, i) {
        if ($cfd75c534a862da6$var$I(i)) {
            for(; e.length > 0 && e[e.length - 1] !== this;)e.pop();
            return e.includes(i) ? "[Circular]" : (e.push(i), i);
        }
        return i;
    }))) ? void 0 : i.length) || 0;
}
function $cfd75c534a862da6$var$Ue(t, i) {
    if (void 0 === i && (i = 6606028.8), t.size >= i && t.data.length > 1) {
        var e = Math.floor(t.data.length / 2), r = t.data.slice(0, e), s = t.data.slice(e);
        return [
            $cfd75c534a862da6$var$Ue({
                size: $cfd75c534a862da6$var$ze(r),
                data: r,
                sessionId: t.sessionId,
                windowId: t.windowId
            }),
            $cfd75c534a862da6$var$Ue({
                size: $cfd75c534a862da6$var$ze(s),
                data: s,
                sessionId: t.sessionId,
                windowId: t.windowId
            })
        ].flatMap((t)=>t);
    }
    return [
        t
    ];
}
var $cfd75c534a862da6$var$qe = ((t)=>(t[t.DomContentLoaded = 0] = "DomContentLoaded", t[t.Load = 1] = "Load", t[t.FullSnapshot = 2] = "FullSnapshot", t[t.IncrementalSnapshot = 3] = "IncrementalSnapshot", t[t.Meta = 4] = "Meta", t[t.Custom = 5] = "Custom", t[t.Plugin = 6] = "Plugin", t))($cfd75c534a862da6$var$qe || {}), $cfd75c534a862da6$var$Be = ((t)=>(t[t.Mutation = 0] = "Mutation", t[t.MouseMove = 1] = "MouseMove", t[t.MouseInteraction = 2] = "MouseInteraction", t[t.Scroll = 3] = "Scroll", t[t.ViewportResize = 4] = "ViewportResize", t[t.Input = 5] = "Input", t[t.TouchMove = 6] = "TouchMove", t[t.MediaInteraction = 7] = "MediaInteraction", t[t.StyleSheetRule = 8] = "StyleSheetRule", t[t.CanvasMutation = 9] = "CanvasMutation", t[t.Font = 10] = "Font", t[t.Log = 11] = "Log", t[t.Drag = 12] = "Drag", t[t.StyleDeclaration = 13] = "StyleDeclaration", t[t.Selection = 14] = "Selection", t[t.AdoptedStyleSheet = 15] = "AdoptedStyleSheet", t[t.CustomElement = 16] = "CustomElement", t))($cfd75c534a862da6$var$Be || {}), $cfd75c534a862da6$var$He = "[SessionRecording]", $cfd75c534a862da6$var$We = "redacted", $cfd75c534a862da6$var$Ge = {
    initiatorTypes: [
        "audio",
        "beacon",
        "body",
        "css",
        "early-hint",
        "embed",
        "fetch",
        "frame",
        "iframe",
        "icon",
        "image",
        "img",
        "input",
        "link",
        "navigation",
        "object",
        "ping",
        "script",
        "track",
        "video",
        "xmlhttprequest"
    ],
    maskRequestFn: (t)=>t,
    recordHeaders: !1,
    recordBody: !1,
    recordInitialRequests: !1,
    recordPerformance: !1,
    performanceEntryTypeToObserve: [
        "first-input",
        "navigation",
        "paint",
        "resource"
    ],
    payloadSizeLimitBytes: 1e6,
    payloadHostDenyList: [
        ".lr-ingest.io",
        ".ingest.sentry.io",
        ".clarity.ms",
        "analytics.google.com",
        "bam.nr-data.net"
    ]
}, $cfd75c534a862da6$var$Je = [
    "authorization",
    "x-forwarded-for",
    "authorization",
    "cookie",
    "set-cookie",
    "x-api-key",
    "x-real-ip",
    "remote-addr",
    "forwarded",
    "proxy-authorization",
    "x-csrf-token",
    "x-csrftoken",
    "x-xsrf-token"
], $cfd75c534a862da6$var$Ve = [
    "password",
    "secret",
    "passwd",
    "api_key",
    "apikey",
    "auth",
    "credentials",
    "mysql_pwd",
    "privatekey",
    "private_key",
    "token"
], $cfd75c534a862da6$var$Ke = [
    "/s/",
    "/e/",
    "/i/"
];
function $cfd75c534a862da6$var$Ye(t, i, e, r) {
    if ($cfd75c534a862da6$var$F(t)) return t;
    var s = (null == i ? void 0 : i["content-length"]) || function(t) {
        return new Blob([
            t
        ]).size;
    }(t);
    return $cfd75c534a862da6$var$T(s) && (s = parseInt(s)), s > e ? $cfd75c534a862da6$var$He + " " + r + " body too large to record (" + s + " bytes)" : t;
}
function $cfd75c534a862da6$var$Xe(t, i) {
    if ($cfd75c534a862da6$var$F(t)) return t;
    var e = t;
    return $cfd75c534a862da6$var$ci(e, !1) || (e = $cfd75c534a862da6$var$He + " " + i + " body " + $cfd75c534a862da6$var$We), $cfd75c534a862da6$var$J($cfd75c534a862da6$var$Ve, (t)=>{
        var r, s;
        null != (r = e) && r.length && -1 !== (null == (s = e) ? void 0 : s.indexOf(t)) && (e = $cfd75c534a862da6$var$He + " " + i + " body " + $cfd75c534a862da6$var$We + " as might contain: " + t);
    }), e;
}
var $cfd75c534a862da6$var$Qe = (t, i)=>{
    var e, r, s, n = {
        payloadSizeLimitBytes: $cfd75c534a862da6$var$Ge.payloadSizeLimitBytes,
        performanceEntryTypeToObserve: [
            ...$cfd75c534a862da6$var$Ge.performanceEntryTypeToObserve
        ],
        payloadHostDenyList: [
            ...i.payloadHostDenyList || [],
            ...$cfd75c534a862da6$var$Ge.payloadHostDenyList
        ]
    }, o = !1 !== t.session_recording.recordHeaders && i.recordHeaders, a = !1 !== t.session_recording.recordBody && i.recordBody, l = !1 !== t.capture_performance && i.recordPerformance, u = (e = n, s = Math.min(1e6, null !== (r = e.payloadSizeLimitBytes) && void 0 !== r ? r : 1e6), (t)=>(null != t && t.requestBody && (t.requestBody = $cfd75c534a862da6$var$Ye(t.requestBody, t.requestHeaders, s, "Request")), null != t && t.responseBody && (t.responseBody = $cfd75c534a862da6$var$Ye(t.responseBody, t.responseHeaders, s, "Response")), t)), h = (i)=>{
        var e, r;
        return u(((t, i)=>{
            var e, r = $cfd75c534a862da6$var$wi(t.name), s = 0 === i.indexOf("http") ? null == (e = $cfd75c534a862da6$var$wi(i)) ? void 0 : e.pathname : i;
            "/" === s && (s = "");
            var n = null == r ? void 0 : r.pathname.replace(s || "", "");
            if (!(r && n && $cfd75c534a862da6$var$Ke.some((t)=>0 === n.indexOf(t)))) return t;
        })((r = (e = i).requestHeaders, $cfd75c534a862da6$var$F(r) || $cfd75c534a862da6$var$J(Object.keys(null != r ? r : {}), (t)=>{
            $cfd75c534a862da6$var$Je.includes(t.toLowerCase()) && (r[t] = $cfd75c534a862da6$var$We);
        }), e), t.api_host));
    }, d = $cfd75c534a862da6$var$E(t.session_recording.maskNetworkRequestFn);
    return d && $cfd75c534a862da6$var$E(t.session_recording.maskCapturedNetworkRequestFn) && $cfd75c534a862da6$var$N.warn("Both `maskNetworkRequestFn` and `maskCapturedNetworkRequestFn` are defined. `maskNetworkRequestFn` will be ignored."), d && (t.session_recording.maskCapturedNetworkRequestFn = (i)=>{
        var e = t.session_recording.maskNetworkRequestFn({
            url: i.name
        });
        return $cfd75c534a862da6$var$B({}, i, {
            name: null == e ? void 0 : e.url
        });
    }), n.maskRequestFn = $cfd75c534a862da6$var$E(t.session_recording.maskCapturedNetworkRequestFn) ? (i)=>{
        var e, r = h(i);
        return r && null !== (e = null == t.session_recording.maskCapturedNetworkRequestFn ? void 0 : t.session_recording.maskCapturedNetworkRequestFn(r)) && void 0 !== e ? e : void 0;
    } : (t)=>(function(t) {
            if (!$cfd75c534a862da6$var$R(t)) return t.requestBody = $cfd75c534a862da6$var$Xe(t.requestBody, "Request"), t.responseBody = $cfd75c534a862da6$var$Xe(t.responseBody, "Response"), t;
        })(h(t)), $cfd75c534a862da6$var$B({}, $cfd75c534a862da6$var$Ge, n, {
        recordHeaders: o,
        recordBody: a,
        recordPerformance: l,
        recordInitialRequests: l
    });
};
class $cfd75c534a862da6$var$Ze {
    constructor(t, i){
        var e, r;
        void 0 === i && (i = {}), this.yt = {}, this.wt = (t)=>{
            if (!this.yt[t]) {
                var i, e;
                this.yt[t] = !0;
                var r = this.St(t);
                null == (i = (e = this.rt).onBlockedNode) || i.call(e, t, r);
            }
        }, this.$t = (t)=>{
            var i = this.St(t);
            if ("svg" !== (null == i ? void 0 : i.nodeName) && i instanceof Element) {
                var e = i.closest("svg");
                if (e) return [
                    this._rrweb.mirror.getId(e),
                    e
                ];
            }
            return [
                t,
                i
            ];
        }, this.St = (t)=>this._rrweb.mirror.getNode(t), this.kt = (t)=>{
            var i, e, r, s, n, o, a, l;
            return (null !== (i = null == (e = t.removes) ? void 0 : e.length) && void 0 !== i ? i : 0) + (null !== (r = null == (s = t.attributes) ? void 0 : s.length) && void 0 !== r ? r : 0) + (null !== (n = null == (o = t.texts) ? void 0 : o.length) && void 0 !== n ? n : 0) + (null !== (a = null == (l = t.adds) ? void 0 : l.length) && void 0 !== a ? a : 0);
        }, this.throttleMutations = (t)=>{
            if (3 !== t.type || 0 !== t.data.source) return t;
            var i = t.data, e = this.kt(i);
            i.attributes && (i.attributes = i.attributes.filter((t)=>{
                var [i] = this.$t(t.id);
                return !this.ct.consumeRateLimit(i) && t;
            }));
            var r = this.kt(i);
            return 0 !== r || e === r ? t : void 0;
        }, this._rrweb = t, this.rt = i, this.ct = new $cfd75c534a862da6$var$ne({
            bucketSize: null !== (e = this.rt.bucketSize) && void 0 !== e ? e : 100,
            refillRate: null !== (r = this.rt.refillRate) && void 0 !== r ? r : 10,
            refillInterval: 1e3,
            et: this.wt
        });
    }
}
var $cfd75c534a862da6$var$tr = Uint8Array, $cfd75c534a862da6$var$ir = Uint16Array, $cfd75c534a862da6$var$er = Uint32Array, $cfd75c534a862da6$var$rr = new $cfd75c534a862da6$var$tr([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0,
    0,
    0,
    0
]), $cfd75c534a862da6$var$sr = new $cfd75c534a862da6$var$tr([
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13,
    0,
    0
]), $cfd75c534a862da6$var$nr = new $cfd75c534a862da6$var$tr([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]), $cfd75c534a862da6$var$or = function(t, i) {
    for(var e = new $cfd75c534a862da6$var$ir(31), r = 0; r < 31; ++r)e[r] = i += 1 << t[r - 1];
    var s = new $cfd75c534a862da6$var$er(e[30]);
    for(r = 1; r < 30; ++r)for(var n = e[r]; n < e[r + 1]; ++n)s[n] = n - e[r] << 5 | r;
    return [
        e,
        s
    ];
}, $cfd75c534a862da6$var$ar = $cfd75c534a862da6$var$or($cfd75c534a862da6$var$rr, 2), $cfd75c534a862da6$var$lr = $cfd75c534a862da6$var$ar[0], $cfd75c534a862da6$var$ur = $cfd75c534a862da6$var$ar[1];
$cfd75c534a862da6$var$lr[28] = 258, $cfd75c534a862da6$var$ur[258] = 28;
for(var $cfd75c534a862da6$var$hr = $cfd75c534a862da6$var$or($cfd75c534a862da6$var$sr, 0)[1], $cfd75c534a862da6$var$dr = new $cfd75c534a862da6$var$ir(32768), $cfd75c534a862da6$var$vr = 0; $cfd75c534a862da6$var$vr < 32768; ++$cfd75c534a862da6$var$vr){
    var $cfd75c534a862da6$var$cr = (43690 & $cfd75c534a862da6$var$vr) >>> 1 | (21845 & $cfd75c534a862da6$var$vr) << 1;
    $cfd75c534a862da6$var$cr = (61680 & ($cfd75c534a862da6$var$cr = (52428 & $cfd75c534a862da6$var$cr) >>> 2 | (13107 & $cfd75c534a862da6$var$cr) << 2)) >>> 4 | (3855 & $cfd75c534a862da6$var$cr) << 4, $cfd75c534a862da6$var$dr[$cfd75c534a862da6$var$vr] = ((65280 & $cfd75c534a862da6$var$cr) >>> 8 | (255 & $cfd75c534a862da6$var$cr) << 8) >>> 1;
}
var $cfd75c534a862da6$var$fr = function(t, i, e) {
    for(var r = t.length, s = 0, n = new $cfd75c534a862da6$var$ir(i); s < r; ++s)++n[t[s] - 1];
    var o, a = new $cfd75c534a862da6$var$ir(i);
    for(s = 0; s < i; ++s)a[s] = a[s - 1] + n[s - 1] << 1;
    if (e) {
        o = new $cfd75c534a862da6$var$ir(1 << i);
        var l = 15 - i;
        for(s = 0; s < r; ++s)if (t[s]) for(var u = s << 4 | t[s], h = i - t[s], d = a[t[s] - 1]++ << h, v = d | (1 << h) - 1; d <= v; ++d)o[$cfd75c534a862da6$var$dr[d] >>> l] = u;
    } else for(o = new $cfd75c534a862da6$var$ir(r), s = 0; s < r; ++s)o[s] = $cfd75c534a862da6$var$dr[a[t[s] - 1]++] >>> 15 - t[s];
    return o;
}, $cfd75c534a862da6$var$pr = new $cfd75c534a862da6$var$tr(288);
for($cfd75c534a862da6$var$vr = 0; $cfd75c534a862da6$var$vr < 144; ++$cfd75c534a862da6$var$vr)$cfd75c534a862da6$var$pr[$cfd75c534a862da6$var$vr] = 8;
for($cfd75c534a862da6$var$vr = 144; $cfd75c534a862da6$var$vr < 256; ++$cfd75c534a862da6$var$vr)$cfd75c534a862da6$var$pr[$cfd75c534a862da6$var$vr] = 9;
for($cfd75c534a862da6$var$vr = 256; $cfd75c534a862da6$var$vr < 280; ++$cfd75c534a862da6$var$vr)$cfd75c534a862da6$var$pr[$cfd75c534a862da6$var$vr] = 7;
for($cfd75c534a862da6$var$vr = 280; $cfd75c534a862da6$var$vr < 288; ++$cfd75c534a862da6$var$vr)$cfd75c534a862da6$var$pr[$cfd75c534a862da6$var$vr] = 8;
var $cfd75c534a862da6$var$gr = new $cfd75c534a862da6$var$tr(32);
for($cfd75c534a862da6$var$vr = 0; $cfd75c534a862da6$var$vr < 32; ++$cfd75c534a862da6$var$vr)$cfd75c534a862da6$var$gr[$cfd75c534a862da6$var$vr] = 5;
var $cfd75c534a862da6$var$_r = $cfd75c534a862da6$var$fr($cfd75c534a862da6$var$pr, 9, 0), $cfd75c534a862da6$var$mr = $cfd75c534a862da6$var$fr($cfd75c534a862da6$var$gr, 5, 0), $cfd75c534a862da6$var$br = function(t) {
    return (t / 8 >> 0) + (7 & t && 1);
}, $cfd75c534a862da6$var$yr = function(t, i, e) {
    (null == e || e > t.length) && (e = t.length);
    var r = new (t instanceof $cfd75c534a862da6$var$ir ? $cfd75c534a862da6$var$ir : t instanceof $cfd75c534a862da6$var$er ? $cfd75c534a862da6$var$er : $cfd75c534a862da6$var$tr)(e - i);
    return r.set(t.subarray(i, e)), r;
}, $cfd75c534a862da6$var$wr = function(t, i, e) {
    e <<= 7 & i;
    var r = i / 8 >> 0;
    t[r] |= e, t[r + 1] |= e >>> 8;
}, $cfd75c534a862da6$var$Sr = function(t, i, e) {
    e <<= 7 & i;
    var r = i / 8 >> 0;
    t[r] |= e, t[r + 1] |= e >>> 8, t[r + 2] |= e >>> 16;
}, $cfd75c534a862da6$var$$r = function(t, i) {
    for(var e = [], r = 0; r < t.length; ++r)t[r] && e.push({
        s: r,
        f: t[r]
    });
    var s = e.length, n = e.slice();
    if (!s) return [
        new $cfd75c534a862da6$var$tr(0),
        0
    ];
    if (1 == s) {
        var o = new $cfd75c534a862da6$var$tr(e[0].s + 1);
        return o[e[0].s] = 1, [
            o,
            1
        ];
    }
    e.sort(function(t, i) {
        return t.f - i.f;
    }), e.push({
        s: -1,
        f: 25001
    });
    var a = e[0], l = e[1], u = 0, h = 1, d = 2;
    for(e[0] = {
        s: -1,
        f: a.f + l.f,
        l: a,
        r: l
    }; h != s - 1;)a = e[e[u].f < e[d].f ? u++ : d++], l = e[u != h && e[u].f < e[d].f ? u++ : d++], e[h++] = {
        s: -1,
        f: a.f + l.f,
        l: a,
        r: l
    };
    var v = n[0].s;
    for(r = 1; r < s; ++r)n[r].s > v && (v = n[r].s);
    var c = new $cfd75c534a862da6$var$ir(v + 1), f = $cfd75c534a862da6$var$kr(e[h - 1], c, 0);
    if (f > i) {
        r = 0;
        var p = 0, g = f - i, _ = 1 << g;
        for(n.sort(function(t, i) {
            return c[i.s] - c[t.s] || t.f - i.f;
        }); r < s; ++r){
            var m = n[r].s;
            if (!(c[m] > i)) break;
            p += _ - (1 << f - c[m]), c[m] = i;
        }
        for(p >>>= g; p > 0;){
            var b = n[r].s;
            c[b] < i ? p -= 1 << i - c[b]++ - 1 : ++r;
        }
        for(; r >= 0 && p; --r){
            var y = n[r].s;
            c[y] == i && (--c[y], ++p);
        }
        f = i;
    }
    return [
        new $cfd75c534a862da6$var$tr(c),
        f
    ];
}, $cfd75c534a862da6$var$kr = function(t, i, e) {
    return -1 == t.s ? Math.max($cfd75c534a862da6$var$kr(t.l, i, e + 1), $cfd75c534a862da6$var$kr(t.r, i, e + 1)) : i[t.s] = e;
}, $cfd75c534a862da6$var$xr = function(t) {
    for(var i = t.length; i && !t[--i];);
    for(var e = new $cfd75c534a862da6$var$ir(++i), r = 0, s = t[0], n = 1, o = function(t) {
        e[r++] = t;
    }, a = 1; a <= i; ++a)if (t[a] == s && a != i) ++n;
    else {
        if (!s && n > 2) {
            for(; n > 138; n -= 138)o(32754);
            n > 2 && (o(n > 10 ? n - 11 << 5 | 28690 : n - 3 << 5 | 12305), n = 0);
        } else if (n > 3) {
            for(o(s), --n; n > 6; n -= 6)o(8304);
            n > 2 && (o(n - 3 << 5 | 8208), n = 0);
        }
        for(; n--;)o(s);
        n = 1, s = t[a];
    }
    return [
        e.subarray(0, r),
        i
    ];
}, $cfd75c534a862da6$var$Er = function(t, i) {
    for(var e = 0, r = 0; r < i.length; ++r)e += t[r] * i[r];
    return e;
}, $cfd75c534a862da6$var$Ir = function(t, i, e) {
    var r = e.length, s = $cfd75c534a862da6$var$br(i + 2);
    t[s] = 255 & r, t[s + 1] = r >>> 8, t[s + 2] = 255 ^ t[s], t[s + 3] = 255 ^ t[s + 1];
    for(var n = 0; n < r; ++n)t[s + n + 4] = e[n];
    return 8 * (s + 4 + r);
}, $cfd75c534a862da6$var$Pr = function(t, i, e, r, s, n, o, a, l, u, h) {
    $cfd75c534a862da6$var$wr(i, h++, e), ++s[256];
    for(var d = $cfd75c534a862da6$var$$r(s, 15), v = d[0], c = d[1], f = $cfd75c534a862da6$var$$r(n, 15), p = f[0], g = f[1], _ = $cfd75c534a862da6$var$xr(v), m = _[0], b = _[1], y = $cfd75c534a862da6$var$xr(p), w = y[0], S = y[1], $ = new $cfd75c534a862da6$var$ir(19), k = 0; k < m.length; ++k)$[31 & m[k]]++;
    for(k = 0; k < w.length; ++k)$[31 & w[k]]++;
    for(var x = $cfd75c534a862da6$var$$r($, 7), E = x[0], I = x[1], P = 19; P > 4 && !E[$cfd75c534a862da6$var$nr[P - 1]]; --P);
    var R, T, M, C, F = u + 5 << 3, O = $cfd75c534a862da6$var$Er(s, $cfd75c534a862da6$var$pr) + $cfd75c534a862da6$var$Er(n, $cfd75c534a862da6$var$gr) + o, A = $cfd75c534a862da6$var$Er(s, v) + $cfd75c534a862da6$var$Er(n, p) + o + 14 + 3 * P + $cfd75c534a862da6$var$Er($, E) + (2 * $[16] + 3 * $[17] + 7 * $[18]);
    if (F <= O && F <= A) return $cfd75c534a862da6$var$Ir(i, h, t.subarray(l, l + u));
    if ($cfd75c534a862da6$var$wr(i, h, 1 + (A < O)), h += 2, A < O) {
        R = $cfd75c534a862da6$var$fr(v, c, 0), T = v, M = $cfd75c534a862da6$var$fr(p, g, 0), C = p;
        var D = $cfd75c534a862da6$var$fr(E, I, 0);
        $cfd75c534a862da6$var$wr(i, h, b - 257), $cfd75c534a862da6$var$wr(i, h + 5, S - 1), $cfd75c534a862da6$var$wr(i, h + 10, P - 4), h += 14;
        for(k = 0; k < P; ++k)$cfd75c534a862da6$var$wr(i, h + 3 * k, E[$cfd75c534a862da6$var$nr[k]]);
        h += 3 * P;
        for(var L = [
            m,
            w
        ], j = 0; j < 2; ++j){
            var N = L[j];
            for(k = 0; k < N.length; ++k){
                var z = 31 & N[k];
                $cfd75c534a862da6$var$wr(i, h, D[z]), h += E[z], z > 15 && ($cfd75c534a862da6$var$wr(i, h, N[k] >>> 5 & 127), h += N[k] >>> 12);
            }
        }
    } else R = $cfd75c534a862da6$var$_r, T = $cfd75c534a862da6$var$pr, M = $cfd75c534a862da6$var$mr, C = $cfd75c534a862da6$var$gr;
    for(k = 0; k < a; ++k)if (r[k] > 255) {
        z = r[k] >>> 18 & 31;
        $cfd75c534a862da6$var$Sr(i, h, R[z + 257]), h += T[z + 257], z > 7 && ($cfd75c534a862da6$var$wr(i, h, r[k] >>> 23 & 31), h += $cfd75c534a862da6$var$rr[z]);
        var U = 31 & r[k];
        $cfd75c534a862da6$var$Sr(i, h, M[U]), h += C[U], U > 3 && ($cfd75c534a862da6$var$Sr(i, h, r[k] >>> 5 & 8191), h += $cfd75c534a862da6$var$sr[U]);
    } else $cfd75c534a862da6$var$Sr(i, h, R[r[k]]), h += T[r[k]];
    return $cfd75c534a862da6$var$Sr(i, h, R[256]), h + T[256];
}, $cfd75c534a862da6$var$Rr = new $cfd75c534a862da6$var$er([
    65540,
    131080,
    131088,
    131104,
    262176,
    1048704,
    1048832,
    2114560,
    2117632
]), $cfd75c534a862da6$var$Tr = function() {
    for(var t = new $cfd75c534a862da6$var$er(256), i = 0; i < 256; ++i){
        for(var e = i, r = 9; --r;)e = (1 & e && 3988292384) ^ e >>> 1;
        t[i] = e;
    }
    return t;
}(), $cfd75c534a862da6$var$Mr = function() {
    var t = 4294967295;
    return {
        p: function(i) {
            for(var e = t, r = 0; r < i.length; ++r)e = $cfd75c534a862da6$var$Tr[255 & e ^ i[r]] ^ e >>> 8;
            t = e;
        },
        d: function() {
            return 4294967295 ^ t;
        }
    };
}, $cfd75c534a862da6$var$Cr = function(t, i, e, r, s) {
    return function(t, i, e, r, s, n) {
        var o = t.length, a = new $cfd75c534a862da6$var$tr(r + o + 5 * (1 + Math.floor(o / 7e3)) + s), l = a.subarray(r, a.length - s), u = 0;
        if (!i || o < 8) for(var h = 0; h <= o; h += 65535){
            var d = h + 65535;
            d < o ? u = $cfd75c534a862da6$var$Ir(l, u, t.subarray(h, d)) : (l[h] = n, u = $cfd75c534a862da6$var$Ir(l, u, t.subarray(h, o)));
        }
        else {
            for(var v = $cfd75c534a862da6$var$Rr[i - 1], c = v >>> 13, f = 8191 & v, p = (1 << e) - 1, g = new $cfd75c534a862da6$var$ir(32768), _ = new $cfd75c534a862da6$var$ir(p + 1), m = Math.ceil(e / 3), b = 2 * m, y = function(i) {
                return (t[i] ^ t[i + 1] << m ^ t[i + 2] << b) & p;
            }, w = new $cfd75c534a862da6$var$er(25e3), S = new $cfd75c534a862da6$var$ir(288), $ = new $cfd75c534a862da6$var$ir(32), k = 0, x = 0, E = (h = 0, 0), I = 0, P = 0; h < o; ++h){
                var R = y(h), T = 32767 & h, M = _[R];
                if (g[T] = M, _[R] = T, I <= h) {
                    var C = o - h;
                    if ((k > 7e3 || E > 24576) && C > 423) {
                        u = $cfd75c534a862da6$var$Pr(t, l, 0, w, S, $, x, E, P, h - P, u), E = k = x = 0, P = h;
                        for(var F = 0; F < 286; ++F)S[F] = 0;
                        for(F = 0; F < 30; ++F)$[F] = 0;
                    }
                    var O = 2, A = 0, D = f, L = T - M & 32767;
                    if (C > 2 && R == y(h - L)) for(var j = Math.min(c, C) - 1, N = Math.min(32767, h), z = Math.min(258, C); L <= N && --D && T != M;){
                        if (t[h + O] == t[h + O - L]) {
                            for(var U = 0; U < z && t[h + U] == t[h + U - L]; ++U);
                            if (U > O) {
                                if (O = U, A = L, U > j) break;
                                var q = Math.min(L, U - 2), B = 0;
                                for(F = 0; F < q; ++F){
                                    var H = h - L + F + 32768 & 32767, W = H - g[H] + 32768 & 32767;
                                    W > B && (B = W, M = H);
                                }
                            }
                        }
                        L += (T = M) - (M = g[T]) + 32768 & 32767;
                    }
                    if (A) {
                        w[E++] = 268435456 | $cfd75c534a862da6$var$ur[O] << 18 | $cfd75c534a862da6$var$hr[A];
                        var G = 31 & $cfd75c534a862da6$var$ur[O], J = 31 & $cfd75c534a862da6$var$hr[A];
                        x += $cfd75c534a862da6$var$rr[G] + $cfd75c534a862da6$var$sr[J], ++S[257 + G], ++$[J], I = h + O, ++k;
                    } else w[E++] = t[h], ++S[t[h]];
                }
            }
            u = $cfd75c534a862da6$var$Pr(t, l, n, w, S, $, x, E, P, h - P, u);
        }
        return $cfd75c534a862da6$var$yr(a, 0, r + $cfd75c534a862da6$var$br(u) + s);
    }(t, null == i.level ? 6 : i.level, null == i.mem ? Math.ceil(1.5 * Math.max(8, Math.min(13, Math.log(t.length)))) : 12 + i.mem, e, r, !s);
}, $cfd75c534a862da6$var$Fr = function(t, i, e) {
    for(; e; ++i)t[i] = e, e >>>= 8;
}, $cfd75c534a862da6$var$Or = function(t, i) {
    var e = i.filename;
    if (t[0] = 31, t[1] = 139, t[2] = 8, t[8] = i.level < 2 ? 4 : 9 == i.level ? 2 : 0, t[9] = 3, 0 != i.mtime && $cfd75c534a862da6$var$Fr(t, 4, Math.floor(new Date(i.mtime || Date.now()) / 1e3)), e) {
        t[3] = 8;
        for(var r = 0; r <= e.length; ++r)t[r + 10] = e.charCodeAt(r);
    }
}, $cfd75c534a862da6$var$Ar = function(t) {
    return 10 + (t.filename && t.filename.length + 1 || 0);
};
function $cfd75c534a862da6$var$Dr(t, i) {
    void 0 === i && (i = {});
    var e = $cfd75c534a862da6$var$Mr(), r = t.length;
    e.p(t);
    var s = $cfd75c534a862da6$var$Cr(t, i, $cfd75c534a862da6$var$Ar(i), 8), n = s.length;
    return $cfd75c534a862da6$var$Or(s, i), $cfd75c534a862da6$var$Fr(s, n - 8, e.d()), $cfd75c534a862da6$var$Fr(s, n - 4, r), s;
}
function $cfd75c534a862da6$var$Lr(t, i) {
    var e = t.length;
    if ("undefined" != typeof TextEncoder) return (new TextEncoder).encode(t);
    for(var r = new $cfd75c534a862da6$var$tr(t.length + (t.length >>> 1)), s = 0, n = function(t) {
        r[s++] = t;
    }, o = 0; o < e; ++o){
        if (s + 5 > r.length) {
            var a = new $cfd75c534a862da6$var$tr(s + 8 + (e - o << 1));
            a.set(r), r = a;
        }
        var l = t.charCodeAt(o);
        l < 128 || i ? n(l) : l < 2048 ? (n(192 | l >>> 6), n(128 | 63 & l)) : l > 55295 && l < 57344 ? (n(240 | (l = 65536 + (1047552 & l) | 1023 & t.charCodeAt(++o)) >>> 18), n(128 | l >>> 12 & 63), n(128 | l >>> 6 & 63), n(128 | 63 & l)) : (n(224 | l >>> 12), n(128 | l >>> 6 & 63), n(128 | 63 & l));
    }
    return $cfd75c534a862da6$var$yr(r, 0, s);
}
function $cfd75c534a862da6$var$jr(t, i) {
    return function(t) {
        for(var i = 0, e = 0; e < t.length; e++)i = (i << 5) - i + t.charCodeAt(e), i |= 0;
        return Math.abs(i);
    }(t) % 100 < $cfd75c534a862da6$var$se(100 * i, 0, 100);
}
var $cfd75c534a862da6$var$Nr = "disabled", $cfd75c534a862da6$var$zr = "sampled", $cfd75c534a862da6$var$Ur = "active", $cfd75c534a862da6$var$qr = "buffering", $cfd75c534a862da6$var$Br = "paused", $cfd75c534a862da6$var$Hr = "trigger", $cfd75c534a862da6$var$Wr = $cfd75c534a862da6$var$Hr + "_activated", $cfd75c534a862da6$var$Gr = $cfd75c534a862da6$var$Hr + "_pending", $cfd75c534a862da6$var$Jr = $cfd75c534a862da6$var$Hr + "_" + $cfd75c534a862da6$var$Nr;
function $cfd75c534a862da6$var$Vr(t, i) {
    return i.some((i)=>"regex" === i.matching && new RegExp(i.url).test(t));
}
class $cfd75c534a862da6$var$Kr {
    constructor(t){
        this.xt = t;
    }
    triggerStatus(t) {
        var i = this.xt.map((i)=>i.triggerStatus(t));
        return i.includes($cfd75c534a862da6$var$Wr) ? $cfd75c534a862da6$var$Wr : i.includes($cfd75c534a862da6$var$Gr) ? $cfd75c534a862da6$var$Gr : $cfd75c534a862da6$var$Jr;
    }
    stop() {
        this.xt.forEach((t)=>t.stop());
    }
}
class $cfd75c534a862da6$var$Yr {
    constructor(t){
        this.xt = t;
    }
    triggerStatus(t) {
        var i = new Set;
        for (var e of this.xt)i.add(e.triggerStatus(t));
        switch(i.delete($cfd75c534a862da6$var$Jr), i.size){
            case 0:
                return $cfd75c534a862da6$var$Jr;
            case 1:
                return Array.from(i)[0];
            default:
                return $cfd75c534a862da6$var$Gr;
        }
    }
    stop() {
        this.xt.forEach((t)=>t.stop());
    }
}
class $cfd75c534a862da6$var$Xr {
    triggerStatus() {
        return $cfd75c534a862da6$var$Gr;
    }
    stop() {}
}
class $cfd75c534a862da6$var$Qr {
    constructor(t){
        this.Et = [], this.It = [], this.urlBlocked = !1, this._instance = t;
    }
    onRemoteConfig(t) {
        var i, e;
        this.Et = (null == (i = t.sessionRecording) ? void 0 : i.urlTriggers) || [], this.It = (null == (e = t.sessionRecording) ? void 0 : e.urlBlocklist) || [];
    }
    Pt(t) {
        var i;
        return 0 === this.Et.length ? $cfd75c534a862da6$var$Jr : (null == (i = this._instance) ? void 0 : i.get_property($cfd75c534a862da6$var$xt)) === t ? $cfd75c534a862da6$var$Wr : $cfd75c534a862da6$var$Gr;
    }
    triggerStatus(t) {
        var i = this.Pt(t), e = i === $cfd75c534a862da6$var$Wr ? $cfd75c534a862da6$var$Wr : i === $cfd75c534a862da6$var$Gr ? $cfd75c534a862da6$var$Gr : $cfd75c534a862da6$var$Jr;
        return this._instance.register_for_session({
            $sdk_debug_replay_url_trigger_status: e
        }), e;
    }
    checkUrlTriggerConditions(i, e, r) {
        if (void 0 !== $cfd75c534a862da6$var$t && $cfd75c534a862da6$var$t.location.href) {
            var s = $cfd75c534a862da6$var$t.location.href, n = this.urlBlocked, o = $cfd75c534a862da6$var$Vr(s, this.It);
            n && o || (o && !n ? i() : !o && n && e(), $cfd75c534a862da6$var$Vr(s, this.Et) && r("url"));
        }
    }
    stop() {}
}
class $cfd75c534a862da6$var$Zr {
    constructor(t){
        this.linkedFlag = null, this.linkedFlagSeen = !1, this.Rt = ()=>{}, this._instance = t;
    }
    triggerStatus() {
        var t = $cfd75c534a862da6$var$Gr;
        return $cfd75c534a862da6$var$F(this.linkedFlag) && (t = $cfd75c534a862da6$var$Jr), this.linkedFlagSeen && (t = $cfd75c534a862da6$var$Wr), this._instance.register_for_session({
            $sdk_debug_replay_linked_flag_trigger_status: t
        }), t;
    }
    onRemoteConfig(t, i) {
        var e;
        if (this.linkedFlag = (null == (e = t.sessionRecording) ? void 0 : e.linkedFlag) || null, !$cfd75c534a862da6$var$F(this.linkedFlag) && !this.linkedFlagSeen) {
            var r = $cfd75c534a862da6$var$T(this.linkedFlag) ? this.linkedFlag : this.linkedFlag.flag, s = $cfd75c534a862da6$var$T(this.linkedFlag) ? null : this.linkedFlag.variant;
            this.Rt = this._instance.onFeatureFlags((t, e)=>{
                var n = !1;
                if ($cfd75c534a862da6$var$I(e) && r in e) {
                    var o = e[r];
                    n = $cfd75c534a862da6$var$A(o) ? !0 === o : s ? o === s : !!o;
                }
                this.linkedFlagSeen = n, n && i(r, s);
            });
        }
    }
    stop() {
        this.Rt();
    }
}
class $cfd75c534a862da6$var$ts {
    constructor(t){
        this.Tt = [], this._instance = t;
    }
    onRemoteConfig(t) {
        var i;
        this.Tt = (null == (i = t.sessionRecording) ? void 0 : i.eventTriggers) || [];
    }
    Mt(t) {
        var i;
        return 0 === this.Tt.length ? $cfd75c534a862da6$var$Jr : (null == (i = this._instance) ? void 0 : i.get_property($cfd75c534a862da6$var$Et)) === t ? $cfd75c534a862da6$var$Wr : $cfd75c534a862da6$var$Gr;
    }
    triggerStatus(t) {
        var i = this.Mt(t), e = i === $cfd75c534a862da6$var$Wr ? $cfd75c534a862da6$var$Wr : i === $cfd75c534a862da6$var$Gr ? $cfd75c534a862da6$var$Gr : $cfd75c534a862da6$var$Jr;
        return this._instance.register_for_session({
            $sdk_debug_replay_event_trigger_status: e
        }), e;
    }
    stop() {}
}
function $cfd75c534a862da6$var$is(t) {
    return t.isRecordingEnabled ? $cfd75c534a862da6$var$qr : $cfd75c534a862da6$var$Nr;
}
function $cfd75c534a862da6$var$es(t) {
    if (!t.receivedFlags) return $cfd75c534a862da6$var$qr;
    if (!t.isRecordingEnabled) return $cfd75c534a862da6$var$Nr;
    if (t.urlTriggerMatching.urlBlocked) return $cfd75c534a862da6$var$Br;
    var i = !0 === t.isSampled, e = new $cfd75c534a862da6$var$Kr([
        t.eventTriggerMatching,
        t.urlTriggerMatching,
        t.linkedFlagMatching
    ]).triggerStatus(t.sessionId);
    return i ? $cfd75c534a862da6$var$zr : e === $cfd75c534a862da6$var$Wr ? $cfd75c534a862da6$var$Ur : e === $cfd75c534a862da6$var$Gr ? $cfd75c534a862da6$var$qr : !1 === t.isSampled ? $cfd75c534a862da6$var$Nr : $cfd75c534a862da6$var$Ur;
}
function $cfd75c534a862da6$var$rs(t) {
    if (!t.receivedFlags) return $cfd75c534a862da6$var$qr;
    if (!t.isRecordingEnabled) return $cfd75c534a862da6$var$Nr;
    if (t.urlTriggerMatching.urlBlocked) return $cfd75c534a862da6$var$Br;
    var i = new $cfd75c534a862da6$var$Yr([
        t.eventTriggerMatching,
        t.urlTriggerMatching,
        t.linkedFlagMatching
    ]).triggerStatus(t.sessionId), e = i !== $cfd75c534a862da6$var$Jr, r = $cfd75c534a862da6$var$A(t.isSampled);
    return e && i === $cfd75c534a862da6$var$Gr ? $cfd75c534a862da6$var$qr : e && i === $cfd75c534a862da6$var$Jr || r && !t.isSampled ? $cfd75c534a862da6$var$Nr : !0 === t.isSampled ? $cfd75c534a862da6$var$zr : $cfd75c534a862da6$var$Ur;
}
var $cfd75c534a862da6$var$ss = "[SessionRecording]", $cfd75c534a862da6$var$ns = $cfd75c534a862da6$var$z($cfd75c534a862da6$var$ss);
function $cfd75c534a862da6$var$os() {
    var t;
    return null == $cfd75c534a862da6$var$v || null == (t = $cfd75c534a862da6$var$v.__PosthogExtensions__) || null == (t = t.rrweb) ? void 0 : t.record;
}
var $cfd75c534a862da6$var$as = 3e5, $cfd75c534a862da6$var$ls = [
    $cfd75c534a862da6$var$Be.MouseMove,
    $cfd75c534a862da6$var$Be.MouseInteraction,
    $cfd75c534a862da6$var$Be.Scroll,
    $cfd75c534a862da6$var$Be.ViewportResize,
    $cfd75c534a862da6$var$Be.Input,
    $cfd75c534a862da6$var$Be.TouchMove,
    $cfd75c534a862da6$var$Be.MediaInteraction,
    $cfd75c534a862da6$var$Be.Drag
], $cfd75c534a862da6$var$us = (t)=>({
        rrwebMethod: t,
        enqueuedAt: Date.now(),
        attempt: 1
    });
function $cfd75c534a862da6$var$hs(t) {
    return function(t, i) {
        for(var e = "", r = 0; r < t.length;){
            var s = t[r++];
            s < 128 || i ? e += String.fromCharCode(s) : s < 224 ? e += String.fromCharCode((31 & s) << 6 | 63 & t[r++]) : s < 240 ? e += String.fromCharCode((15 & s) << 12 | (63 & t[r++]) << 6 | 63 & t[r++]) : (s = ((15 & s) << 18 | (63 & t[r++]) << 12 | (63 & t[r++]) << 6 | 63 & t[r++]) - 65536, e += String.fromCharCode(55296 | s >> 10, 56320 | 1023 & s));
        }
        return e;
    }($cfd75c534a862da6$var$Dr($cfd75c534a862da6$var$Lr(JSON.stringify(t))), !0);
}
function $cfd75c534a862da6$var$ds(t) {
    return t.type === $cfd75c534a862da6$var$qe.Custom && "sessionIdle" === t.data.tag;
}
class $cfd75c534a862da6$var$vs {
    get sessionId() {
        return this.Ct;
    }
    get Ft() {
        return this._instance.config.session_recording.session_idle_threshold_ms || 3e5;
    }
    get started() {
        return this.Ot;
    }
    get At() {
        if (!this._instance.sessionManager) throw new Error($cfd75c534a862da6$var$ss + " must be started with a valid sessionManager.");
        return this._instance.sessionManager;
    }
    get Dt() {
        var t, i;
        return this.Lt.triggerStatus(this.sessionId) === $cfd75c534a862da6$var$Gr ? 6e4 : null !== (t = null == (i = this._instance.config.session_recording) ? void 0 : i.full_snapshot_interval_millis) && void 0 !== t ? t : $cfd75c534a862da6$var$as;
    }
    get jt() {
        var t = this._instance.get_property($cfd75c534a862da6$var$kt);
        return $cfd75c534a862da6$var$A(t) ? t : null;
    }
    get Nt() {
        var t, i, e = null == (t = this.C) ? void 0 : t.data[(null == (i = this.C) ? void 0 : i.data.length) - 1], { sessionStartTimestamp: r } = this.At.checkAndGetSessionAndWindowId(!0);
        return e ? e.timestamp - r : null;
    }
    get zt() {
        var i = !!this._instance.get_property($cfd75c534a862da6$var$pt), e = !this._instance.config.disable_session_recording;
        return $cfd75c534a862da6$var$t && i && e;
    }
    get Ut() {
        var t = !!this._instance.get_property($cfd75c534a862da6$var$gt), i = this._instance.config.enable_recording_console_log;
        return null != i ? i : t;
    }
    get qt() {
        var t, i, e, r, s, n, o = this._instance.config.session_recording.captureCanvas, a = this._instance.get_property($cfd75c534a862da6$var$bt), l = null !== (t = null !== (i = null == o ? void 0 : o.recordCanvas) && void 0 !== i ? i : null == a ? void 0 : a.enabled) && void 0 !== t && t, u = null !== (e = null !== (r = null == o ? void 0 : o.canvasFps) && void 0 !== r ? r : null == a ? void 0 : a.fps) && void 0 !== e ? e : 4, h = null !== (s = null !== (n = null == o ? void 0 : o.canvasQuality) && void 0 !== n ? n : null == a ? void 0 : a.quality) && void 0 !== s ? s : .4;
        if ("string" == typeof h) {
            var d = parseFloat(h);
            h = isNaN(d) ? .4 : d;
        }
        return {
            enabled: l,
            fps: $cfd75c534a862da6$var$se(u, 0, 12, "canvas recording fps", 4),
            quality: $cfd75c534a862da6$var$se(h, 0, 1, "canvas recording quality", .4)
        };
    }
    get Bt() {
        var t, i, e = this._instance.get_property($cfd75c534a862da6$var$_t), r = {
            recordHeaders: null == (t = this._instance.config.session_recording) ? void 0 : t.recordHeaders,
            recordBody: null == (i = this._instance.config.session_recording) ? void 0 : i.recordBody
        }, s = (null == r ? void 0 : r.recordHeaders) || (null == e ? void 0 : e.recordHeaders), n = (null == r ? void 0 : r.recordBody) || (null == e ? void 0 : e.recordBody), o = $cfd75c534a862da6$var$I(this._instance.config.capture_performance) ? this._instance.config.capture_performance.network_timing : this._instance.config.capture_performance, a = !!($cfd75c534a862da6$var$A(o) ? o : null == e ? void 0 : e.capturePerformance);
        return s || n || a ? {
            recordHeaders: s,
            recordBody: n,
            recordPerformance: a
        } : void 0;
    }
    get Ht() {
        var t, i, e, r, s, n, o = this._instance.get_property($cfd75c534a862da6$var$mt), a = {
            maskAllInputs: null == (t = this._instance.config.session_recording) ? void 0 : t.maskAllInputs,
            maskTextSelector: null == (i = this._instance.config.session_recording) ? void 0 : i.maskTextSelector,
            blockSelector: null == (e = this._instance.config.session_recording) ? void 0 : e.blockSelector
        }, l = null !== (r = null == a ? void 0 : a.maskAllInputs) && void 0 !== r ? r : null == o ? void 0 : o.maskAllInputs, u = null !== (s = null == a ? void 0 : a.maskTextSelector) && void 0 !== s ? s : null == o ? void 0 : o.maskTextSelector, h = null !== (n = null == a ? void 0 : a.blockSelector) && void 0 !== n ? n : null == o ? void 0 : o.blockSelector;
        return $cfd75c534a862da6$var$R(l) && $cfd75c534a862da6$var$R(u) && $cfd75c534a862da6$var$R(h) ? void 0 : {
            maskAllInputs: null == l || l,
            maskTextSelector: u,
            blockSelector: h
        };
    }
    get Wt() {
        var t = this._instance.get_property($cfd75c534a862da6$var$yt);
        return $cfd75c534a862da6$var$O(t) ? t : null;
    }
    get Gt() {
        var t = this._instance.get_property($cfd75c534a862da6$var$wt);
        return $cfd75c534a862da6$var$O(t) ? t : null;
    }
    get status() {
        return this.Jt ? this.Vt({
            receivedFlags: this.Jt,
            isRecordingEnabled: this.zt,
            isSampled: this.jt,
            urlTriggerMatching: this.Kt,
            eventTriggerMatching: this.Yt,
            linkedFlagMatching: this.Xt,
            sessionId: this.sessionId
        }) : $cfd75c534a862da6$var$qr;
    }
    constructor(t){
        if (this.Vt = $cfd75c534a862da6$var$is, this.Jt = !1, this.Qt = [], this.Zt = "unknown", this.ti = Date.now(), this.Lt = new $cfd75c534a862da6$var$Xr, this.ii = void 0, this.ei = void 0, this.ri = void 0, this.si = void 0, this.ni = void 0, this._forceAllowLocalhostNetworkCapture = !1, this.oi = ()=>{
            this.ai();
        }, this.li = ()=>{
            this.ui("browser offline", {});
        }, this.hi = ()=>{
            this.ui("browser online", {});
        }, this.di = ()=>{
            if (null != $cfd75c534a862da6$var$o && $cfd75c534a862da6$var$o.visibilityState) {
                var t = "window " + $cfd75c534a862da6$var$o.visibilityState;
                this.ui(t, {});
            }
        }, this._instance = t, this.Ot = !1, this.vi = "/s/", this.ci = void 0, this.Jt = !1, !this._instance.sessionManager) throw $cfd75c534a862da6$var$ns.error("started without valid sessionManager"), new Error($cfd75c534a862da6$var$ss + " started without valid sessionManager. This is a bug.");
        if (this._instance.config.__preview_experimental_cookieless_mode) throw new Error($cfd75c534a862da6$var$ss + " cannot be used with __preview_experimental_cookieless_mode.");
        this.Xt = new $cfd75c534a862da6$var$Zr(this._instance), this.Kt = new $cfd75c534a862da6$var$Qr(this._instance), this.Yt = new $cfd75c534a862da6$var$ts(this._instance);
        var { sessionId: i, windowId: e } = this.At.checkAndGetSessionAndWindowId();
        this.Ct = i, this.fi = e, this.C = this.pi(), this.Ft >= this.At.sessionTimeoutMs && $cfd75c534a862da6$var$ns.warn("session_idle_threshold_ms (" + this.Ft + ") is greater than the session timeout (" + this.At.sessionTimeoutMs + "). Session will never be detected as idle");
    }
    startIfEnabledOrStop(i) {
        this.zt ? (this.gi(i), $cfd75c534a862da6$var$st($cfd75c534a862da6$var$t, "beforeunload", this.oi), $cfd75c534a862da6$var$st($cfd75c534a862da6$var$t, "offline", this.li), $cfd75c534a862da6$var$st($cfd75c534a862da6$var$t, "online", this.hi), $cfd75c534a862da6$var$st($cfd75c534a862da6$var$t, "visibilitychange", this.di), this.mi(), this.bi(), $cfd75c534a862da6$var$F(this.ii) && (this.ii = this._instance.on("eventCaptured", (t)=>{
            try {
                if ("$pageview" === t.event) {
                    var i = null != t && t.properties.$current_url ? this.yi(null == t ? void 0 : t.properties.$current_url) : "";
                    if (!i) return;
                    this.ui("$pageview", {
                        href: i
                    });
                }
            } catch (t) {
                $cfd75c534a862da6$var$ns.error("Could not add $pageview to rrweb session", t);
            }
        })), this.ei || (this.ei = this.At.onSessionId((t, i, e)=>{
            var r, s;
            e && (this.ui("$session_id_change", {
                sessionId: t,
                windowId: i,
                changeReason: e
            }), null == (r = this._instance) || null == (r = r.persistence) || r.unregister($cfd75c534a862da6$var$Et), null == (s = this._instance) || null == (s = s.persistence) || s.unregister($cfd75c534a862da6$var$xt));
        }))) : this.stopRecording();
    }
    stopRecording() {
        var i, e, r, s;
        this.Ot && this.ci && (this.ci(), this.ci = void 0, this.Ot = !1, null == $cfd75c534a862da6$var$t || $cfd75c534a862da6$var$t.removeEventListener("beforeunload", this.oi), null == $cfd75c534a862da6$var$t || $cfd75c534a862da6$var$t.removeEventListener("offline", this.li), null == $cfd75c534a862da6$var$t || $cfd75c534a862da6$var$t.removeEventListener("online", this.hi), null == $cfd75c534a862da6$var$t || $cfd75c534a862da6$var$t.removeEventListener("visibilitychange", this.di), this.pi(), clearInterval(this.wi), null == (i = this.ii) || i.call(this), this.ii = void 0, null == (e = this.ni) || e.call(this), this.ni = void 0, null == (r = this.ei) || r.call(this), this.ei = void 0, null == (s = this.si) || s.call(this), this.si = void 0, this.Yt.stop(), this.Kt.stop(), this.Xt.stop(), $cfd75c534a862da6$var$ns.info("stopped"));
    }
    Si() {
        var t;
        null == (t = this._instance.persistence) || t.unregister($cfd75c534a862da6$var$kt);
    }
    $i(t) {
        var i, e = this.Ct !== t, r = this.Wt;
        if ($cfd75c534a862da6$var$O(r)) {
            var s = this.jt, n = e || !$cfd75c534a862da6$var$A(s), o = n ? $cfd75c534a862da6$var$jr(t, r) : s;
            n && (o ? this.ki($cfd75c534a862da6$var$zr) : $cfd75c534a862da6$var$ns.warn("Sample rate (" + r + ") has determined that this sessionId (" + t + ") will not be sent to the server."), this.ui("samplingDecisionMade", {
                sampleRate: r,
                isSampled: o
            })), null == (i = this._instance.persistence) || i.register({
                [$cfd75c534a862da6$var$kt]: o
            });
        } else this.Si();
    }
    onRemoteConfig(t) {
        var i, e, r, s;
        (this.ui("$remote_config_received", t), this.xi(t), null != (i = t.sessionRecording) && i.endpoint) && (this.vi = null == (s = t.sessionRecording) ? void 0 : s.endpoint);
        this.mi(), "any" === (null == (e = t.sessionRecording) ? void 0 : e.triggerMatchType) ? (this.Vt = $cfd75c534a862da6$var$es, this.Lt = new $cfd75c534a862da6$var$Kr([
            this.Yt,
            this.Kt
        ])) : (this.Vt = $cfd75c534a862da6$var$rs, this.Lt = new $cfd75c534a862da6$var$Yr([
            this.Yt,
            this.Kt
        ])), this._instance.register_for_session({
            $sdk_debug_replay_remote_trigger_matching_config: null == (r = t.sessionRecording) ? void 0 : r.triggerMatchType
        }), this.Kt.onRemoteConfig(t), this.Yt.onRemoteConfig(t), this.Xt.onRemoteConfig(t, (t, i)=>{
            this.ki("linked_flag_matched", {
                flag: t,
                variant: i
            });
        }), this.Jt = !0, this.startIfEnabledOrStop();
    }
    mi() {
        $cfd75c534a862da6$var$O(this.Wt) && $cfd75c534a862da6$var$F(this.si) && (this.si = this.At.onSessionId((t)=>{
            this.$i(t);
        }));
    }
    xi(t) {
        if (this._instance.persistence) {
            var i, e = this._instance.persistence, r = ()=>{
                var i, r, s, n, o, a, l, u, h, d = null == (i = t.sessionRecording) ? void 0 : i.sampleRate, v = $cfd75c534a862da6$var$F(d) ? null : parseFloat(d);
                $cfd75c534a862da6$var$F(v) && this.Si();
                var c = null == (r = t.sessionRecording) ? void 0 : r.minimumDurationMilliseconds;
                e.register({
                    [$cfd75c534a862da6$var$pt]: !!t.sessionRecording,
                    [$cfd75c534a862da6$var$gt]: null == (s = t.sessionRecording) ? void 0 : s.consoleLogRecordingEnabled,
                    [$cfd75c534a862da6$var$_t]: $cfd75c534a862da6$var$B({
                        capturePerformance: t.capturePerformance
                    }, null == (n = t.sessionRecording) ? void 0 : n.networkPayloadCapture),
                    [$cfd75c534a862da6$var$mt]: null == (o = t.sessionRecording) ? void 0 : o.masking,
                    [$cfd75c534a862da6$var$bt]: {
                        enabled: null == (a = t.sessionRecording) ? void 0 : a.recordCanvas,
                        fps: null == (l = t.sessionRecording) ? void 0 : l.canvasFps,
                        quality: null == (u = t.sessionRecording) ? void 0 : u.canvasQuality
                    },
                    [$cfd75c534a862da6$var$yt]: v,
                    [$cfd75c534a862da6$var$wt]: $cfd75c534a862da6$var$R(c) ? null : c,
                    [$cfd75c534a862da6$var$St]: null == (h = t.sessionRecording) ? void 0 : h.scriptConfig
                });
            };
            r(), null == (i = this.ri) || i.call(this), this.ri = this.At.onSessionId(r);
        }
    }
    log(t, i) {
        var e;
        void 0 === i && (i = "log"), null == (e = this._instance.sessionRecording) || e.onRRwebEmit({
            type: 6,
            data: {
                plugin: "rrweb/console@1",
                payload: {
                    level: i,
                    trace: [],
                    payload: [
                        JSON.stringify(t)
                    ]
                }
            },
            timestamp: Date.now()
        });
    }
    gi(t) {
        if (!$cfd75c534a862da6$var$R(Object.assign) && !$cfd75c534a862da6$var$R(Array.from) && !(this.Ot || this._instance.config.disable_session_recording || this._instance.consent.isOptedOut())) {
            var i;
            if (this.Ot = !0, this.At.checkAndGetSessionAndWindowId(), $cfd75c534a862da6$var$os()) this.Ei();
            else null == (i = $cfd75c534a862da6$var$v.__PosthogExtensions__) || null == i.loadExternalDependency || i.loadExternalDependency(this._instance, this.Ii, (t)=>{
                if (t) return $cfd75c534a862da6$var$ns.error("could not load recorder", t);
                this.Ei();
            });
            $cfd75c534a862da6$var$ns.info("starting"), this.status === $cfd75c534a862da6$var$Ur && this.ki(t || "recording_initialized");
        }
    }
    get Ii() {
        var t;
        return (null == (t = this._instance) || null == (t = t.persistence) || null == (t = t.get_property($cfd75c534a862da6$var$St)) ? void 0 : t.script) || "recorder";
    }
    Pi(t) {
        var i;
        return 3 === t.type && -1 !== $cfd75c534a862da6$var$ls.indexOf(null == (i = t.data) ? void 0 : i.source);
    }
    Ri(t) {
        var i = this.Pi(t);
        i || this.Zt || t.timestamp - this.ti > this.Ft && (this.Zt = !0, clearInterval(this.wi), this.ui("sessionIdle", {
            eventTimestamp: t.timestamp,
            lastActivityTimestamp: this.ti,
            threshold: this.Ft,
            bufferLength: this.C.data.length,
            bufferSize: this.C.size
        }), this.ai());
        var e = !1;
        if (i && (this.ti = t.timestamp, this.Zt)) {
            var r = "unknown" === this.Zt;
            this.Zt = !1, r || (this.ui("sessionNoLongerIdle", {
                reason: "user activity",
                type: t.type
            }), e = !0);
        }
        if (!this.Zt) {
            var { windowId: s, sessionId: n } = this.At.checkAndGetSessionAndWindowId(!i, t.timestamp), o = this.Ct !== n, a = this.fi !== s;
            this.fi = s, this.Ct = n, o || a ? (this.stopRecording(), this.startIfEnabledOrStop("session_id_changed")) : e && this.Ti();
        }
    }
    Mi(t) {
        try {
            return t.rrwebMethod(), !0;
        } catch (i) {
            return this.Qt.length < 10 ? this.Qt.push({
                enqueuedAt: t.enqueuedAt || Date.now(),
                attempt: t.attempt++,
                rrwebMethod: t.rrwebMethod
            }) : $cfd75c534a862da6$var$ns.warn("could not emit queued rrweb event.", i, t), !1;
        }
    }
    ui(t, i) {
        return this.Mi($cfd75c534a862da6$var$us(()=>$cfd75c534a862da6$var$os().addCustomEvent(t, i)));
    }
    Ci() {
        return this.Mi($cfd75c534a862da6$var$us(()=>$cfd75c534a862da6$var$os().takeFullSnapshot()));
    }
    Ei() {
        var t, i, e, r, s = {
            blockClass: "ph-no-capture",
            blockSelector: void 0,
            ignoreClass: "ph-ignore-input",
            maskTextClass: "ph-mask",
            maskTextSelector: void 0,
            maskTextFn: void 0,
            maskAllInputs: !0,
            maskInputOptions: {
                password: !0
            },
            maskInputFn: void 0,
            slimDOMOptions: {},
            collectFonts: !1,
            inlineStylesheet: !0,
            recordCrossOriginIframes: !1
        }, n = this._instance.config.session_recording;
        for (var [o, a] of Object.entries(n || {}))o in s && ("maskInputOptions" === o ? s.maskInputOptions = $cfd75c534a862da6$var$B({
            password: !0
        }, a) : s[o] = a);
        (this.qt && this.qt.enabled && (s.recordCanvas = !0, s.sampling = {
            canvas: this.qt.fps
        }, s.dataURLOptions = {
            type: "image/webp",
            quality: this.qt.quality
        }), this.Ht) && (s.maskAllInputs = null === (i = this.Ht.maskAllInputs) || void 0 === i || i, s.maskTextSelector = null !== (e = this.Ht.maskTextSelector) && void 0 !== e ? e : void 0, s.blockSelector = null !== (r = this.Ht.blockSelector) && void 0 !== r ? r : void 0);
        var l = $cfd75c534a862da6$var$os();
        if (l) {
            this.Fi = null !== (t = this.Fi) && void 0 !== t ? t : new $cfd75c534a862da6$var$Ze(l, {
                refillRate: this._instance.config.session_recording.__mutationThrottlerRefillRate,
                bucketSize: this._instance.config.session_recording.__mutationThrottlerBucketSize,
                onBlockedNode: (t, i)=>{
                    var e = "Too many mutations on node '" + t + "'. Rate limiting. This could be due to SVG animations or something similar";
                    $cfd75c534a862da6$var$ns.info(e, {
                        node: i
                    }), this.log($cfd75c534a862da6$var$ss + " " + e, "warn");
                }
            });
            var u = this.Oi();
            this.ci = l($cfd75c534a862da6$var$B({
                emit: (t)=>{
                    this.onRRwebEmit(t);
                },
                plugins: u
            }, s)), this.ti = Date.now(), this.Zt = $cfd75c534a862da6$var$A(this.Zt) ? this.Zt : "unknown", this.ui("$session_options", {
                sessionRecordingOptions: s,
                activePlugins: u.map((t)=>null == t ? void 0 : t.name)
            }), this.ui("$posthog_config", {
                config: this._instance.config
            });
        } else $cfd75c534a862da6$var$ns.error("onScriptLoaded was called but rrwebRecord is not available. This indicates something has gone wrong.");
    }
    Ti() {
        if (this.wi && clearInterval(this.wi), !0 !== this.Zt) {
            var t = this.Dt;
            t && (this.wi = setInterval(()=>{
                this.Ci();
            }, t));
        }
    }
    Oi() {
        var t, i, e = [], r = null == (t = $cfd75c534a862da6$var$v.__PosthogExtensions__) || null == (t = t.rrwebPlugins) ? void 0 : t.getRecordConsolePlugin;
        r && this.Ut && e.push(r());
        var s = null == (i = $cfd75c534a862da6$var$v.__PosthogExtensions__) || null == (i = i.rrwebPlugins) ? void 0 : i.getRecordNetworkPlugin;
        this.Bt && $cfd75c534a862da6$var$E(s) && (!$cfd75c534a862da6$var$yi.includes(location.hostname) || this._forceAllowLocalhostNetworkCapture ? e.push(s($cfd75c534a862da6$var$Qe(this._instance.config, this.Bt))) : $cfd75c534a862da6$var$ns.info("NetworkCapture not started because we are on localhost."));
        return e;
    }
    onRRwebEmit(t) {
        var i;
        if (this.Ai(), t && $cfd75c534a862da6$var$I(t)) {
            if (t.type === $cfd75c534a862da6$var$qe.Meta) {
                var e = this.yi(t.data.href);
                if (this.Di = e, !e) return;
                t.data.href = e;
            } else this.Li();
            if (this.Kt.checkUrlTriggerConditions(()=>this.ji(), ()=>this.Ni(), (t)=>this.zi(t)), !this.Kt.urlBlocked || (r = t).type === $cfd75c534a862da6$var$qe.Custom && "recording paused" === r.data.tag) {
                var r;
                t.type === $cfd75c534a862da6$var$qe.FullSnapshot && this.Ti(), t.type === $cfd75c534a862da6$var$qe.FullSnapshot && this.Jt && this.Lt.triggerStatus(this.sessionId) === $cfd75c534a862da6$var$Gr && this.pi();
                var s = this.Fi ? this.Fi.throttleMutations(t) : t;
                if (s) {
                    var n = function(t) {
                        var i = t;
                        if (i && $cfd75c534a862da6$var$I(i) && 6 === i.type && $cfd75c534a862da6$var$I(i.data) && "rrweb/console@1" === i.data.plugin) {
                            i.data.payload.payload.length > 10 && (i.data.payload.payload = i.data.payload.payload.slice(0, 10), i.data.payload.payload.push("...[truncated]"));
                            for(var e = [], r = 0; r < i.data.payload.payload.length; r++)i.data.payload.payload[r] && i.data.payload.payload[r].length > 2e3 ? e.push(i.data.payload.payload[r].slice(0, 2e3) + "...[truncated]") : e.push(i.data.payload.payload[r]);
                            return i.data.payload.payload = e, t;
                        }
                        return t;
                    }(s);
                    if (this.Ri(n), !0 !== this.Zt || $cfd75c534a862da6$var$ds(n)) {
                        if ($cfd75c534a862da6$var$ds(n)) {
                            var o = n.data.payload;
                            if (o) {
                                var a = o.lastActivityTimestamp, l = o.threshold;
                                n.timestamp = a + l;
                            }
                        }
                        var u = null === (i = this._instance.config.session_recording.compress_events) || void 0 === i || i ? function(t) {
                            if ($cfd75c534a862da6$var$ze(t) < 1024) return t;
                            try {
                                if (t.type === $cfd75c534a862da6$var$qe.FullSnapshot) return $cfd75c534a862da6$var$B({}, t, {
                                    data: $cfd75c534a862da6$var$hs(t.data),
                                    cv: "2024-10"
                                });
                                if (t.type === $cfd75c534a862da6$var$qe.IncrementalSnapshot && t.data.source === $cfd75c534a862da6$var$Be.Mutation) return $cfd75c534a862da6$var$B({}, t, {
                                    cv: "2024-10",
                                    data: $cfd75c534a862da6$var$B({}, t.data, {
                                        texts: $cfd75c534a862da6$var$hs(t.data.texts),
                                        attributes: $cfd75c534a862da6$var$hs(t.data.attributes),
                                        removes: $cfd75c534a862da6$var$hs(t.data.removes),
                                        adds: $cfd75c534a862da6$var$hs(t.data.adds)
                                    })
                                });
                                if (t.type === $cfd75c534a862da6$var$qe.IncrementalSnapshot && t.data.source === $cfd75c534a862da6$var$Be.StyleSheetRule) return $cfd75c534a862da6$var$B({}, t, {
                                    cv: "2024-10",
                                    data: $cfd75c534a862da6$var$B({}, t.data, {
                                        adds: t.data.adds ? $cfd75c534a862da6$var$hs(t.data.adds) : void 0,
                                        removes: t.data.removes ? $cfd75c534a862da6$var$hs(t.data.removes) : void 0
                                    })
                                });
                            } catch (t) {
                                $cfd75c534a862da6$var$ns.error("could not compress event - will use uncompressed event", t);
                            }
                            return t;
                        }(n) : n, h = {
                            $snapshot_bytes: $cfd75c534a862da6$var$ze(u),
                            $snapshot_data: u,
                            $session_id: this.Ct,
                            $window_id: this.fi
                        };
                        this.status !== $cfd75c534a862da6$var$Nr ? this.Ui(h) : this.pi();
                    }
                }
            }
        }
    }
    Li() {
        if (!this._instance.config.capture_pageview && $cfd75c534a862da6$var$t) {
            var i = this.yi($cfd75c534a862da6$var$t.location.href);
            this.Di !== i && (this.ui("$url_changed", {
                href: i
            }), this.Di = i);
        }
    }
    Ai() {
        if (this.Qt.length) {
            var t = [
                ...this.Qt
            ];
            this.Qt = [], t.forEach((t)=>{
                Date.now() - t.enqueuedAt <= 2e3 && this.Mi(t);
            });
        }
    }
    yi(t) {
        var i = this._instance.config.session_recording;
        if (i.maskNetworkRequestFn) {
            var e, r = {
                url: t
            };
            return null == (e = r = i.maskNetworkRequestFn(r)) ? void 0 : e.url;
        }
        return t;
    }
    pi() {
        return this.C = {
            size: 0,
            data: [],
            sessionId: this.Ct,
            windowId: this.fi
        }, this.C;
    }
    ai() {
        this.qi && (clearTimeout(this.qi), this.qi = void 0);
        var t = this.Gt, i = this.Nt, e = $cfd75c534a862da6$var$O(i) && i >= 0, r = $cfd75c534a862da6$var$O(t) && e && i < t;
        if (this.status === $cfd75c534a862da6$var$qr || this.status === $cfd75c534a862da6$var$Br || this.status === $cfd75c534a862da6$var$Nr || r) return this.qi = setTimeout(()=>{
            this.ai();
        }, 2e3), this.C;
        this.C.data.length > 0 && $cfd75c534a862da6$var$Ue(this.C).forEach((t)=>{
            this.Bi({
                $snapshot_bytes: t.size,
                $snapshot_data: t.data,
                $session_id: t.sessionId,
                $window_id: t.windowId,
                $lib: "web",
                $lib_version: $cfd75c534a862da6$var$c.LIB_VERSION
            });
        });
        return this.pi();
    }
    Ui(t) {
        var i, e = 2 + ((null == (i = this.C) ? void 0 : i.data.length) || 0);
        !this.Zt && (this.C.size + t.$snapshot_bytes + e > 943718.4 || this.C.sessionId !== this.Ct) && (this.C = this.ai()), this.C.size += t.$snapshot_bytes, this.C.data.push(t.$snapshot_data), this.qi || this.Zt || (this.qi = setTimeout(()=>{
            this.ai();
        }, 2e3));
    }
    Bi(t) {
        this._instance.capture("$snapshot", t, {
            _url: this._instance.requestRouter.endpointFor("api", this.vi),
            _noTruncate: !0,
            _batchKey: "recordings",
            skip_client_rate_limiting: !0
        });
    }
    zi(t) {
        var i;
        this.Lt.triggerStatus(this.sessionId) === $cfd75c534a862da6$var$Gr && (null == (i = this._instance) || null == (i = i.persistence) || i.register({
            ["url" === t ? $cfd75c534a862da6$var$xt : $cfd75c534a862da6$var$Et]: this.Ct
        }), this.ai(), this.ki(t + "_trigger_matched"));
    }
    ji() {
        this.Kt.urlBlocked || (this.Kt.urlBlocked = !0, clearInterval(this.wi), $cfd75c534a862da6$var$ns.info("recording paused due to URL blocker"), this.ui("recording paused", {
            reason: "url blocker"
        }));
    }
    Ni() {
        this.Kt.urlBlocked && (this.Kt.urlBlocked = !1, this.Ci(), this.Ti(), this.ui("recording resumed", {
            reason: "left blocked url"
        }), $cfd75c534a862da6$var$ns.info("recording resumed"));
    }
    bi() {
        0 !== this.Yt.Tt.length && $cfd75c534a862da6$var$F(this.ni) && (this.ni = this._instance.on("eventCaptured", (t)=>{
            try {
                this.Yt.Tt.includes(t.event) && this.zi("event");
            } catch (t) {
                $cfd75c534a862da6$var$ns.error("Could not activate event trigger", t);
            }
        }));
    }
    overrideLinkedFlag() {
        this.Xt.linkedFlagSeen = !0, this.Ci(), this.ki("linked_flag_overridden");
    }
    overrideSampling() {
        var t;
        null == (t = this._instance.persistence) || t.register({
            [$cfd75c534a862da6$var$kt]: !0
        }), this.Ci(), this.ki("sampling_overridden");
    }
    overrideTrigger(t) {
        this.zi(t);
    }
    ki(t, i) {
        this._instance.register_for_session({
            $session_recording_start_reason: t
        }), $cfd75c534a862da6$var$ns.info(t.replace("_", " "), i), $cfd75c534a862da6$var$m([
            "recording_initialized",
            "session_id_changed"
        ], t) || this.ui(t, i);
    }
    get sdkDebugProperties() {
        var { sessionStartTimestamp: t } = this.At.checkAndGetSessionAndWindowId(!0);
        return {
            $recording_status: this.status,
            $sdk_debug_replay_internal_buffer_length: this.C.data.length,
            $sdk_debug_replay_internal_buffer_size: this.C.size,
            $sdk_debug_current_session_duration: this.Nt,
            $sdk_debug_session_start: t
        };
    }
}
var $cfd75c534a862da6$var$cs = $cfd75c534a862da6$var$z("[SegmentIntegration]");
function $cfd75c534a862da6$var$fs(t, i) {
    var e = t.config.segment;
    if (!e) return i();
    !function(t, i) {
        var e = t.config.segment;
        if (!e) return i();
        var r = (e)=>{
            var r = ()=>e.anonymousId() || $cfd75c534a862da6$var$ji();
            t.config.get_device_id = r, e.id() && (t.register({
                distinct_id: e.id(),
                $device_id: r()
            }), t.persistence.set_property($cfd75c534a862da6$var$At, "identified")), i();
        }, s = e.user();
        "then" in s && $cfd75c534a862da6$var$E(s.then) ? s.then((t)=>r(t)) : r(s);
    }(t, ()=>{
        e.register(((t)=>{
            Promise && Promise.resolve || $cfd75c534a862da6$var$cs.warn("This browser does not have Promise support, and can not use the segment integration");
            var i = (i, e)=>{
                if (!e) return i;
                i.event.userId || i.event.anonymousId === t.get_distinct_id() || ($cfd75c534a862da6$var$cs.info("No userId set, resetting PostHog"), t.reset()), i.event.userId && i.event.userId !== t.get_distinct_id() && ($cfd75c534a862da6$var$cs.info("UserId set, identifying with PostHog"), t.identify(i.event.userId));
                var r = t.calculateEventProperties(e, i.event.properties);
                return i.event.properties = Object.assign({}, r, i.event.properties), i;
            };
            return {
                name: "PostHog JS",
                type: "enrichment",
                version: "1.0.0",
                isLoaded: ()=>!0,
                load: ()=>Promise.resolve(),
                track: (t)=>i(t, t.event.event),
                page: (t)=>i(t, "$pageview"),
                identify: (t)=>i(t, "$identify"),
                screen: (t)=>i(t, "$screen")
            };
        })(t)).then(()=>{
            i();
        });
    });
}
var $cfd75c534a862da6$var$ps = "posthog-js";
function $cfd75c534a862da6$var$gs(t, i) {
    var { organization: e, projectId: r, prefix: s, severityAllowList: n = [
        "error"
    ] } = void 0 === i ? {} : i;
    return (i)=>{
        var o, a, l, u, h;
        if (!("*" === n || n.includes(i.level)) || !t.__loaded) return i;
        i.tags || (i.tags = {});
        var d = t.requestRouter.endpointFor("ui", "/project/" + t.config.token + "/person/" + t.get_distinct_id());
        i.tags["PostHog Person URL"] = d, t.sessionRecordingStarted() && (i.tags["PostHog Recording URL"] = t.get_session_replay_url({
            withTimestamp: !0
        }));
        var v = (null == (o = i.exception) ? void 0 : o.values) || [], c = v.map((t)=>$cfd75c534a862da6$var$B({}, t, {
                stacktrace: t.stacktrace ? $cfd75c534a862da6$var$B({}, t.stacktrace, {
                    type: "raw",
                    frames: (t.stacktrace.frames || []).map((t)=>$cfd75c534a862da6$var$B({}, t, {
                            platform: "web:javascript"
                        }))
                }) : void 0
            })), f = {
            $exception_message: (null == (a = v[0]) ? void 0 : a.value) || i.message,
            $exception_type: null == (l = v[0]) ? void 0 : l.type,
            $exception_personURL: d,
            $exception_level: i.level,
            $exception_list: c,
            $sentry_event_id: i.event_id,
            $sentry_exception: i.exception,
            $sentry_exception_message: (null == (u = v[0]) ? void 0 : u.value) || i.message,
            $sentry_exception_type: null == (h = v[0]) ? void 0 : h.type,
            $sentry_tags: i.tags
        };
        return e && r && (f.$sentry_url = (s || "https://sentry.io/organizations/") + e + "/issues/?project=" + r + "&query=" + i.event_id), t.exceptions.sendExceptionEvent(f), i;
    };
}
class $cfd75c534a862da6$var$_s {
    constructor(t, i, e, r, s){
        this.name = $cfd75c534a862da6$var$ps, this.setupOnce = function(n) {
            n($cfd75c534a862da6$var$gs(t, {
                organization: i,
                projectId: e,
                prefix: r,
                severityAllowList: s
            }));
        };
    }
}
var $cfd75c534a862da6$var$ms = null != $cfd75c534a862da6$var$t && $cfd75c534a862da6$var$t.location ? $cfd75c534a862da6$var$xi($cfd75c534a862da6$var$t.location.hash, "__posthog") || $cfd75c534a862da6$var$xi(location.hash, "state") : null, $cfd75c534a862da6$var$bs = "_postHogToolbarParams", $cfd75c534a862da6$var$ys = $cfd75c534a862da6$var$z("[Toolbar]"), $cfd75c534a862da6$var$ws = function(t) {
    return t[t.UNINITIALIZED = 0] = "UNINITIALIZED", t[t.LOADING = 1] = "LOADING", t[t.LOADED = 2] = "LOADED", t;
}($cfd75c534a862da6$var$ws || {});
class $cfd75c534a862da6$var$Ss {
    constructor(t){
        this.instance = t;
    }
    Hi(t) {
        $cfd75c534a862da6$var$v.ph_toolbar_state = t;
    }
    Wi() {
        var t;
        return null !== (t = $cfd75c534a862da6$var$v.ph_toolbar_state) && void 0 !== t ? t : $cfd75c534a862da6$var$ws.UNINITIALIZED;
    }
    maybeLoadToolbar(i, e, r) {
        if (void 0 === i && (i = void 0), void 0 === e && (e = void 0), void 0 === r && (r = void 0), !$cfd75c534a862da6$var$t || !$cfd75c534a862da6$var$o) return !1;
        i = null != i ? i : $cfd75c534a862da6$var$t.location, r = null != r ? r : $cfd75c534a862da6$var$t.history;
        try {
            if (!e) {
                try {
                    $cfd75c534a862da6$var$t.localStorage.setItem("test", "test"), $cfd75c534a862da6$var$t.localStorage.removeItem("test");
                } catch (t) {
                    return !1;
                }
                e = null == $cfd75c534a862da6$var$t ? void 0 : $cfd75c534a862da6$var$t.localStorage;
            }
            var s, n = $cfd75c534a862da6$var$ms || $cfd75c534a862da6$var$xi(i.hash, "__posthog") || $cfd75c534a862da6$var$xi(i.hash, "state"), a = n ? $cfd75c534a862da6$var$X(()=>JSON.parse(atob(decodeURIComponent(n)))) || $cfd75c534a862da6$var$X(()=>JSON.parse(decodeURIComponent(n))) : null;
            return a && "ph_authorize" === a.action ? ((s = a).source = "url", s && Object.keys(s).length > 0 && (a.desiredHash ? i.hash = a.desiredHash : r ? r.replaceState(r.state, "", i.pathname + i.search) : i.hash = "")) : ((s = JSON.parse(e.getItem($cfd75c534a862da6$var$bs) || "{}")).source = "localstorage", delete s.userIntent), !(!s.token || this.instance.config.token !== s.token) && (this.loadToolbar(s), !0);
        } catch (t) {
            return !1;
        }
    }
    Gi(t) {
        var i = $cfd75c534a862da6$var$v.ph_load_toolbar || $cfd75c534a862da6$var$v.ph_load_editor;
        !$cfd75c534a862da6$var$F(i) && $cfd75c534a862da6$var$E(i) ? i(t, this.instance) : $cfd75c534a862da6$var$ys.warn("No toolbar load function found");
    }
    loadToolbar(i) {
        var e = !(null == $cfd75c534a862da6$var$o || !$cfd75c534a862da6$var$o.getElementById($cfd75c534a862da6$var$qt));
        if (!$cfd75c534a862da6$var$t || e) return !1;
        var r = "custom" === this.instance.requestRouter.region && this.instance.config.advanced_disable_toolbar_metrics, s = $cfd75c534a862da6$var$B({
            token: this.instance.config.token
        }, i, {
            apiURL: this.instance.requestRouter.endpointFor("ui")
        }, r ? {
            instrument: !1
        } : {});
        if ($cfd75c534a862da6$var$t.localStorage.setItem($cfd75c534a862da6$var$bs, JSON.stringify($cfd75c534a862da6$var$B({}, s, {
            source: void 0
        }))), this.Wi() === $cfd75c534a862da6$var$ws.LOADED) this.Gi(s);
        else if (this.Wi() === $cfd75c534a862da6$var$ws.UNINITIALIZED) {
            var n;
            this.Hi($cfd75c534a862da6$var$ws.LOADING), null == (n = $cfd75c534a862da6$var$v.__PosthogExtensions__) || null == n.loadExternalDependency || n.loadExternalDependency(this.instance, "toolbar", (t)=>{
                if (t) return $cfd75c534a862da6$var$ys.error("[Toolbar] Failed to load", t), void this.Hi($cfd75c534a862da6$var$ws.UNINITIALIZED);
                this.Hi($cfd75c534a862da6$var$ws.LOADED), this.Gi(s);
            }), $cfd75c534a862da6$var$st($cfd75c534a862da6$var$t, "turbolinks:load", ()=>{
                this.Hi($cfd75c534a862da6$var$ws.UNINITIALIZED), this.loadToolbar(s);
            });
        }
        return !0;
    }
    Ji(t) {
        return this.loadToolbar(t);
    }
    maybeLoadEditor(t, i, e) {
        return void 0 === t && (t = void 0), void 0 === i && (i = void 0), void 0 === e && (e = void 0), this.maybeLoadToolbar(t, i, e);
    }
}
var $cfd75c534a862da6$var$$s = $cfd75c534a862da6$var$z("[TracingHeaders]");
class $cfd75c534a862da6$var$ks {
    constructor(t){
        this.Vi = void 0, this.Ki = void 0, this.nt = ()=>{
            var t, i;
            $cfd75c534a862da6$var$R(this.Vi) && (null == (t = $cfd75c534a862da6$var$v.__PosthogExtensions__) || null == (t = t.tracingHeadersPatchFns) || t._patchXHR(this._instance.get_distinct_id(), this._instance.sessionManager));
            $cfd75c534a862da6$var$R(this.Ki) && (null == (i = $cfd75c534a862da6$var$v.__PosthogExtensions__) || null == (i = i.tracingHeadersPatchFns) || i._patchFetch(this._instance.get_distinct_id(), this._instance.sessionManager));
        }, this._instance = t;
    }
    J(t) {
        var i, e;
        null != (i = $cfd75c534a862da6$var$v.__PosthogExtensions__) && i.tracingHeadersPatchFns && t(), null == (e = $cfd75c534a862da6$var$v.__PosthogExtensions__) || null == e.loadExternalDependency || e.loadExternalDependency(this._instance, "tracing-headers", (i)=>{
            if (i) return $cfd75c534a862da6$var$$s.error("failed to load script", i);
            t();
        });
    }
    startIfEnabledOrStop() {
        var t, i;
        this._instance.config.__add_tracing_headers ? this.J(this.nt) : (null == (t = this.Vi) || t.call(this), null == (i = this.Ki) || i.call(this), this.Vi = void 0, this.Ki = void 0);
    }
}
var $cfd75c534a862da6$var$xs = $cfd75c534a862da6$var$z("[Web Vitals]"), $cfd75c534a862da6$var$Es = 9e5;
class $cfd75c534a862da6$var$Is {
    constructor(t){
        var i;
        this.Yi = !1, this.i = !1, this.C = {
            url: void 0,
            metrics: [],
            firstMetricTimestamp: void 0
        }, this.Xi = ()=>{
            clearTimeout(this.Qi), 0 !== this.C.metrics.length && (this._instance.capture("$web_vitals", this.C.metrics.reduce((t, i)=>$cfd75c534a862da6$var$B({}, t, {
                    ["$web_vitals_" + i.name + "_event"]: $cfd75c534a862da6$var$B({}, i),
                    ["$web_vitals_" + i.name + "_value"]: i.value
                }), {})), this.C = {
                url: void 0,
                metrics: [],
                firstMetricTimestamp: void 0
            });
        }, this.Zi = (t)=>{
            var i, e = null == (i = this._instance.sessionManager) ? void 0 : i.checkAndGetSessionAndWindowId(!0);
            if ($cfd75c534a862da6$var$R(e)) $cfd75c534a862da6$var$xs.error("Could not read session ID. Dropping metrics!");
            else {
                this.C = this.C || {
                    url: void 0,
                    metrics: [],
                    firstMetricTimestamp: void 0
                };
                var r = this.te();
                if (!$cfd75c534a862da6$var$R(r)) {
                    if ($cfd75c534a862da6$var$F(null == t ? void 0 : t.name) || $cfd75c534a862da6$var$F(null == t ? void 0 : t.value)) $cfd75c534a862da6$var$xs.error("Invalid metric received", t);
                    else if (this.ie && t.value >= this.ie) $cfd75c534a862da6$var$xs.error("Ignoring metric with value >= " + this.ie, t);
                    else this.C.url !== r && (this.Xi(), this.Qi = setTimeout(this.Xi, this.flushToCaptureTimeoutMs)), $cfd75c534a862da6$var$R(this.C.url) && (this.C.url = r), this.C.firstMetricTimestamp = $cfd75c534a862da6$var$R(this.C.firstMetricTimestamp) ? Date.now() : this.C.firstMetricTimestamp, t.attribution && t.attribution.interactionTargetElement && (t.attribution.interactionTargetElement = void 0), this.C.metrics.push($cfd75c534a862da6$var$B({}, t, {
                        $current_url: r,
                        $session_id: e.sessionId,
                        $window_id: e.windowId,
                        timestamp: Date.now()
                    })), this.C.metrics.length === this.allowedMetrics.length && this.Xi();
                }
            }
        }, this.nt = ()=>{
            var t, i, e, r, s = $cfd75c534a862da6$var$v.__PosthogExtensions__;
            $cfd75c534a862da6$var$R(s) || $cfd75c534a862da6$var$R(s.postHogWebVitalsCallbacks) || ({ onLCP: t, onCLS: i, onFCP: e, onINP: r } = s.postHogWebVitalsCallbacks), t && i && e && r ? (this.allowedMetrics.indexOf("LCP") > -1 && t(this.Zi.bind(this)), this.allowedMetrics.indexOf("CLS") > -1 && i(this.Zi.bind(this)), this.allowedMetrics.indexOf("FCP") > -1 && e(this.Zi.bind(this)), this.allowedMetrics.indexOf("INP") > -1 && r(this.Zi.bind(this)), this.i = !0) : $cfd75c534a862da6$var$xs.error("web vitals callbacks not loaded - not starting");
        }, this._instance = t, this.Yi = !(null == (i = this._instance.persistence) || !i.props[$cfd75c534a862da6$var$vt]), this.startIfEnabled();
    }
    get allowedMetrics() {
        var t, i, e = $cfd75c534a862da6$var$I(this._instance.config.capture_performance) ? null == (t = this._instance.config.capture_performance) ? void 0 : t.web_vitals_allowed_metrics : void 0;
        return $cfd75c534a862da6$var$R(e) ? (null == (i = this._instance.persistence) ? void 0 : i.props[$cfd75c534a862da6$var$ft]) || [
            "CLS",
            "FCP",
            "INP",
            "LCP"
        ] : e;
    }
    get flushToCaptureTimeoutMs() {
        return ($cfd75c534a862da6$var$I(this._instance.config.capture_performance) ? this._instance.config.capture_performance.web_vitals_delayed_flush_ms : void 0) || 5e3;
    }
    get ie() {
        var t = $cfd75c534a862da6$var$I(this._instance.config.capture_performance) && $cfd75c534a862da6$var$O(this._instance.config.capture_performance.__web_vitals_max_value) ? this._instance.config.capture_performance.__web_vitals_max_value : $cfd75c534a862da6$var$Es;
        return 0 < t && t <= 6e4 ? $cfd75c534a862da6$var$Es : t;
    }
    get isEnabled() {
        var t = null == $cfd75c534a862da6$var$a ? void 0 : $cfd75c534a862da6$var$a.protocol;
        if ("http:" !== t && "https:" !== t) return $cfd75c534a862da6$var$xs.info("Web Vitals are disabled on non-http/https protocols"), !1;
        var i = $cfd75c534a862da6$var$I(this._instance.config.capture_performance) ? this._instance.config.capture_performance.web_vitals : $cfd75c534a862da6$var$A(this._instance.config.capture_performance) ? this._instance.config.capture_performance : void 0;
        return $cfd75c534a862da6$var$A(i) ? i : this.Yi;
    }
    startIfEnabled() {
        this.isEnabled && !this.i && ($cfd75c534a862da6$var$xs.info("enabled, starting..."), this.J(this.nt));
    }
    onRemoteConfig(t) {
        var i = $cfd75c534a862da6$var$I(t.capturePerformance) && !!t.capturePerformance.web_vitals, e = $cfd75c534a862da6$var$I(t.capturePerformance) ? t.capturePerformance.web_vitals_allowed_metrics : void 0;
        this._instance.persistence && (this._instance.persistence.register({
            [$cfd75c534a862da6$var$vt]: i
        }), this._instance.persistence.register({
            [$cfd75c534a862da6$var$ft]: e
        })), this.Yi = i, this.startIfEnabled();
    }
    J(t) {
        var i, e;
        null != (i = $cfd75c534a862da6$var$v.__PosthogExtensions__) && i.postHogWebVitalsCallbacks && t(), null == (e = $cfd75c534a862da6$var$v.__PosthogExtensions__) || null == e.loadExternalDependency || e.loadExternalDependency(this._instance, "web-vitals", (i)=>{
            i ? $cfd75c534a862da6$var$xs.error("failed to load script", i) : t();
        });
    }
    te() {
        var i = $cfd75c534a862da6$var$t ? $cfd75c534a862da6$var$t.location.href : void 0;
        return i || $cfd75c534a862da6$var$xs.error("Could not determine current URL"), i;
    }
}
var $cfd75c534a862da6$var$Ps = $cfd75c534a862da6$var$z("[Heatmaps]");
function $cfd75c534a862da6$var$Rs(t) {
    return $cfd75c534a862da6$var$I(t) && "clientX" in t && "clientY" in t && $cfd75c534a862da6$var$O(t.clientX) && $cfd75c534a862da6$var$O(t.clientY);
}
class $cfd75c534a862da6$var$Ts {
    constructor(t){
        var i;
        this.rageclicks = new $cfd75c534a862da6$var$bi, this.Yi = !1, this.i = !1, this.ee = null, this.instance = t, this.Yi = !(null == (i = this.instance.persistence) || !i.props[$cfd75c534a862da6$var$ut]);
    }
    get flushIntervalMilliseconds() {
        var t = 5e3;
        return $cfd75c534a862da6$var$I(this.instance.config.capture_heatmaps) && this.instance.config.capture_heatmaps.flush_interval_milliseconds && (t = this.instance.config.capture_heatmaps.flush_interval_milliseconds), t;
    }
    get isEnabled() {
        return $cfd75c534a862da6$var$R(this.instance.config.capture_heatmaps) ? $cfd75c534a862da6$var$R(this.instance.config.enable_heatmaps) ? this.Yi : this.instance.config.enable_heatmaps : !1 !== this.instance.config.capture_heatmaps;
    }
    startIfEnabled() {
        if (this.isEnabled) {
            if (this.i) return;
            $cfd75c534a862da6$var$Ps.info("starting..."), this.re(), this.ee = setInterval(this.se.bind(this), this.flushIntervalMilliseconds);
        } else {
            var t, i;
            clearInterval(null !== (t = this.ee) && void 0 !== t ? t : void 0), null == (i = this.ne) || i.stop(), this.getAndClearBuffer();
        }
    }
    onRemoteConfig(t) {
        var i = !!t.heatmaps;
        this.instance.persistence && this.instance.persistence.register({
            [$cfd75c534a862da6$var$ut]: i
        }), this.Yi = i, this.startIfEnabled();
    }
    getAndClearBuffer() {
        var t = this.C;
        return this.C = void 0, t;
    }
    oe(t) {
        this.ae(t.originalEvent, "deadclick");
    }
    re() {
        $cfd75c534a862da6$var$t && $cfd75c534a862da6$var$o && ($cfd75c534a862da6$var$st($cfd75c534a862da6$var$t, "beforeunload", this.se.bind(this)), $cfd75c534a862da6$var$st($cfd75c534a862da6$var$o, "click", (i)=>this.ae(i || (null == $cfd75c534a862da6$var$t ? void 0 : $cfd75c534a862da6$var$t.event)), {
            capture: !0
        }), $cfd75c534a862da6$var$st($cfd75c534a862da6$var$o, "mousemove", (i)=>this.le(i || (null == $cfd75c534a862da6$var$t ? void 0 : $cfd75c534a862da6$var$t.event)), {
            capture: !0
        }), this.ne = new $cfd75c534a862da6$var$re(this.instance, $cfd75c534a862da6$var$ie, this.oe.bind(this)), this.ne.startIfEnabled(), this.i = !0);
    }
    ue(i, e) {
        var r = this.instance.scrollManager.scrollY(), s = this.instance.scrollManager.scrollX(), n = this.instance.scrollManager.scrollElement(), o = function(i, e, r) {
            for(var s = i; s && $cfd75c534a862da6$var$Gt(s) && !$cfd75c534a862da6$var$Jt(s, "body");){
                if (s === r) return !1;
                if ($cfd75c534a862da6$var$m(e, null == $cfd75c534a862da6$var$t ? void 0 : $cfd75c534a862da6$var$t.getComputedStyle(s).position)) return !0;
                s = $cfd75c534a862da6$var$ri(s);
            }
            return !1;
        }($cfd75c534a862da6$var$ii(i), [
            "fixed",
            "sticky"
        ], n);
        return {
            x: i.clientX + (o ? 0 : s),
            y: i.clientY + (o ? 0 : r),
            target_fixed: o,
            type: e
        };
    }
    ae(t, i) {
        var e;
        if (void 0 === i && (i = "click"), !$cfd75c534a862da6$var$Wt(t.target) && $cfd75c534a862da6$var$Rs(t)) {
            var r = this.ue(t, i);
            null != (e = this.rageclicks) && e.isRageClick(t.clientX, t.clientY, (new Date).getTime()) && this.he($cfd75c534a862da6$var$B({}, r, {
                type: "rageclick"
            })), this.he(r);
        }
    }
    le(t) {
        !$cfd75c534a862da6$var$Wt(t.target) && $cfd75c534a862da6$var$Rs(t) && (clearTimeout(this.de), this.de = setTimeout(()=>{
            this.he(this.ue(t, "mousemove"));
        }, 500));
    }
    he(i) {
        if ($cfd75c534a862da6$var$t) {
            var e = $cfd75c534a862da6$var$t.location.href;
            this.C = this.C || {}, this.C[e] || (this.C[e] = []), this.C[e].push(i);
        }
    }
    se() {
        this.C && !$cfd75c534a862da6$var$P(this.C) && this.instance.capture("$$heatmap", {
            $heatmap_data: this.getAndClearBuffer()
        });
    }
}
class $cfd75c534a862da6$var$Ms {
    constructor(t){
        this._instance = t;
    }
    doPageView(i, e) {
        var r, s = this.ve(i, e);
        return this.ce = {
            pathname: null !== (r = null == $cfd75c534a862da6$var$t ? void 0 : $cfd75c534a862da6$var$t.location.pathname) && void 0 !== r ? r : "",
            pageViewId: e,
            timestamp: i
        }, this._instance.scrollManager.resetContext(), s;
    }
    doPageLeave(t) {
        var i;
        return this.ve(t, null == (i = this.ce) ? void 0 : i.pageViewId);
    }
    doEvent() {
        var t;
        return {
            $pageview_id: null == (t = this.ce) ? void 0 : t.pageViewId
        };
    }
    ve(t, i) {
        var e = this.ce;
        if (!e) return {
            $pageview_id: i
        };
        var r = {
            $pageview_id: i,
            $prev_pageview_id: e.pageViewId
        }, s = this._instance.scrollManager.getContext();
        if (s && !this._instance.config.disable_scroll_properties) {
            var { maxScrollHeight: n, lastScrollY: o, maxScrollY: a, maxContentHeight: l, lastContentY: u, maxContentY: h } = s;
            if (!($cfd75c534a862da6$var$R(n) || $cfd75c534a862da6$var$R(o) || $cfd75c534a862da6$var$R(a) || $cfd75c534a862da6$var$R(l) || $cfd75c534a862da6$var$R(u) || $cfd75c534a862da6$var$R(h))) {
                n = Math.ceil(n), o = Math.ceil(o), a = Math.ceil(a), l = Math.ceil(l), u = Math.ceil(u), h = Math.ceil(h);
                var d = n <= 1 ? 1 : $cfd75c534a862da6$var$se(o / n, 0, 1), v = n <= 1 ? 1 : $cfd75c534a862da6$var$se(a / n, 0, 1), c = l <= 1 ? 1 : $cfd75c534a862da6$var$se(u / l, 0, 1), f = l <= 1 ? 1 : $cfd75c534a862da6$var$se(h / l, 0, 1);
                r = $cfd75c534a862da6$var$V(r, {
                    $prev_pageview_last_scroll: o,
                    $prev_pageview_last_scroll_percentage: d,
                    $prev_pageview_max_scroll: a,
                    $prev_pageview_max_scroll_percentage: v,
                    $prev_pageview_last_content: u,
                    $prev_pageview_last_content_percentage: c,
                    $prev_pageview_max_content: h,
                    $prev_pageview_max_content_percentage: f
                });
            }
        }
        return e.pathname && (r.$prev_pageview_pathname = e.pathname), e.timestamp && (r.$prev_pageview_duration = (t.getTime() - e.timestamp.getTime()) / 1e3), r;
    }
}
var $cfd75c534a862da6$var$Cs = function(t) {
    var i, e, r, s, n = "";
    for(i = e = 0, r = (t = (t + "").replace(/\r\n/g, "\n").replace(/\r/g, "\n")).length, s = 0; s < r; s++){
        var o = t.charCodeAt(s), a = null;
        o < 128 ? e++ : a = o > 127 && o < 2048 ? String.fromCharCode(o >> 6 | 192, 63 & o | 128) : String.fromCharCode(o >> 12 | 224, o >> 6 & 63 | 128, 63 & o | 128), $cfd75c534a862da6$var$C(a) || (e > i && (n += t.substring(i, e)), n += a, i = e = s + 1);
    }
    return e > i && (n += t.substring(i, t.length)), n;
}, $cfd75c534a862da6$var$Fs = !!$cfd75c534a862da6$var$u || !!$cfd75c534a862da6$var$l, $cfd75c534a862da6$var$Os = "text/plain", $cfd75c534a862da6$var$As = (t, i)=>{
    var [e, r] = t.split("?"), s = $cfd75c534a862da6$var$B({}, i);
    null == r || r.split("&").forEach((t)=>{
        var [i] = t.split("=");
        delete s[i];
    });
    var n = $cfd75c534a862da6$var$Si(s);
    return e + "?" + (n = n ? (r ? r + "&" : "") + n : r);
}, $cfd75c534a862da6$var$Ds = (t, i)=>JSON.stringify(t, (t, i)=>"bigint" == typeof i ? i.toString() : i, i), $cfd75c534a862da6$var$Ls = (t)=>{
    var { data: i, compression: e } = t;
    if (i) {
        if (e === $cfd75c534a862da6$export$6a00d17b5aff0af.GZipJS) {
            var r = $cfd75c534a862da6$var$Dr($cfd75c534a862da6$var$Lr($cfd75c534a862da6$var$Ds(i)), {
                mtime: 0
            }), s = new Blob([
                r
            ], {
                type: $cfd75c534a862da6$var$Os
            });
            return {
                contentType: $cfd75c534a862da6$var$Os,
                body: s,
                estimatedSize: s.size
            };
        }
        if (e === $cfd75c534a862da6$export$6a00d17b5aff0af.Base64) {
            var n = function(t) {
                var i, e, r, s, n, o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", a = 0, l = 0, u = "", h = [];
                if (!t) return t;
                t = $cfd75c534a862da6$var$Cs(t);
                do i = (n = t.charCodeAt(a++) << 16 | t.charCodeAt(a++) << 8 | t.charCodeAt(a++)) >> 18 & 63, e = n >> 12 & 63, r = n >> 6 & 63, s = 63 & n, h[l++] = o.charAt(i) + o.charAt(e) + o.charAt(r) + o.charAt(s);
                while (a < t.length);
                switch(u = h.join(""), t.length % 3){
                    case 1:
                        u = u.slice(0, -2) + "==";
                        break;
                    case 2:
                        u = u.slice(0, -1) + "=";
                }
                return u;
            }($cfd75c534a862da6$var$Ds(i)), o = ((t)=>"data=" + encodeURIComponent("string" == typeof t ? t : $cfd75c534a862da6$var$Ds(t)))(n);
            return {
                contentType: "application/x-www-form-urlencoded",
                body: o,
                estimatedSize: new Blob([
                    o
                ]).size
            };
        }
        var a = $cfd75c534a862da6$var$Ds(i);
        return {
            contentType: "application/json",
            body: a,
            estimatedSize: new Blob([
                a
            ]).size
        };
    }
}, $cfd75c534a862da6$var$js = [];
$cfd75c534a862da6$var$l && $cfd75c534a862da6$var$js.push({
    transport: "fetch",
    method: (t)=>{
        var i, e, { contentType: r, body: s, estimatedSize: n } = null !== (i = $cfd75c534a862da6$var$Ls(t)) && void 0 !== i ? i : {}, o = new Headers;
        $cfd75c534a862da6$var$J(t.headers, function(t, i) {
            o.append(i, t);
        }), r && o.append("Content-Type", r);
        var a = t.url, u = null;
        if ($cfd75c534a862da6$var$h) {
            var d = new $cfd75c534a862da6$var$h;
            u = {
                signal: d.signal,
                timeout: setTimeout(()=>d.abort(), t.timeout)
            };
        }
        $cfd75c534a862da6$var$l(a, $cfd75c534a862da6$var$B({
            method: (null == t ? void 0 : t.method) || "GET",
            headers: o,
            keepalive: "POST" === t.method && (n || 0) < 52428.8,
            body: s,
            signal: null == (e = u) ? void 0 : e.signal
        }, t.fetchOptions)).then((i)=>i.text().then((e)=>{
                var r = {
                    statusCode: i.status,
                    text: e
                };
                if (200 === i.status) try {
                    r.json = JSON.parse(e);
                } catch (t) {
                    $cfd75c534a862da6$var$N.error(t);
                }
                null == t.callback || t.callback(r);
            })).catch((i)=>{
            $cfd75c534a862da6$var$N.error(i), null == t.callback || t.callback({
                statusCode: 0,
                text: i
            });
        }).finally(()=>u ? clearTimeout(u.timeout) : null);
    }
}), $cfd75c534a862da6$var$u && $cfd75c534a862da6$var$js.push({
    transport: "XHR",
    method: (t)=>{
        var i, e = new $cfd75c534a862da6$var$u;
        e.open(t.method || "GET", t.url, !0);
        var { contentType: r, body: s } = null !== (i = $cfd75c534a862da6$var$Ls(t)) && void 0 !== i ? i : {};
        $cfd75c534a862da6$var$J(t.headers, function(t, i) {
            e.setRequestHeader(i, t);
        }), r && e.setRequestHeader("Content-Type", r), t.timeout && (e.timeout = t.timeout), e.withCredentials = !0, e.onreadystatechange = ()=>{
            if (4 === e.readyState) {
                var i = {
                    statusCode: e.status,
                    text: e.responseText
                };
                if (200 === e.status) try {
                    i.json = JSON.parse(e.responseText);
                } catch (t) {}
                null == t.callback || t.callback(i);
            }
        }, e.send(s);
    }
}), null != $cfd75c534a862da6$var$n && $cfd75c534a862da6$var$n.sendBeacon && $cfd75c534a862da6$var$js.push({
    transport: "sendBeacon",
    method: (t)=>{
        var i = $cfd75c534a862da6$var$As(t.url, {
            beacon: "1"
        });
        try {
            var e, { contentType: r, body: s } = null !== (e = $cfd75c534a862da6$var$Ls(t)) && void 0 !== e ? e : {}, o = "string" == typeof s ? new Blob([
                s
            ], {
                type: r
            }) : s;
            $cfd75c534a862da6$var$n.sendBeacon(i, o);
        } catch (t) {}
    }
});
var $cfd75c534a862da6$var$Ns = function(t, i) {
    if (!function(t) {
        try {
            new RegExp(t);
        } catch (t) {
            return !1;
        }
        return !0;
    }(i)) return !1;
    try {
        return new RegExp(i).test(t);
    } catch (t) {
        return !1;
    }
};
function $cfd75c534a862da6$var$zs(t, i, e) {
    return $cfd75c534a862da6$var$Ds({
        distinct_id: t,
        userPropertiesToSet: i,
        userPropertiesToSetOnce: e
    });
}
var $cfd75c534a862da6$var$Us = {
    exact: (t, i)=>i.some((i)=>t.some((t)=>i === t)),
    is_not: (t, i)=>i.every((i)=>t.every((t)=>i !== t)),
    regex: (t, i)=>i.some((i)=>t.some((t)=>$cfd75c534a862da6$var$Ns(i, t))),
    not_regex: (t, i)=>i.every((i)=>t.every((t)=>!$cfd75c534a862da6$var$Ns(i, t))),
    icontains: (t, i)=>i.map($cfd75c534a862da6$var$qs).some((i)=>t.map($cfd75c534a862da6$var$qs).some((t)=>i.includes(t))),
    not_icontains: (t, i)=>i.map($cfd75c534a862da6$var$qs).every((i)=>t.map($cfd75c534a862da6$var$qs).every((t)=>!i.includes(t)))
}, $cfd75c534a862da6$var$qs = (t)=>t.toLowerCase(), $cfd75c534a862da6$var$Bs = $cfd75c534a862da6$var$z("[Error tracking]");
class $cfd75c534a862da6$var$Hs {
    constructor(t){
        var i, e;
        this.fe = [], this._instance = t, this.fe = null !== (i = null == (e = this._instance.persistence) ? void 0 : e.get_property($cfd75c534a862da6$var$dt)) && void 0 !== i ? i : [];
    }
    onRemoteConfig(t) {
        var i, e, r = null !== (i = null == (e = t.errorTracking) ? void 0 : e.suppressionRules) && void 0 !== i ? i : [];
        this.fe = r, this._instance.persistence && this._instance.persistence.register({
            [$cfd75c534a862da6$var$dt]: this.fe
        });
    }
    sendExceptionEvent(t) {
        this.pe(t) ? $cfd75c534a862da6$var$Bs.info("Skipping exception capture because a suppression rule matched") : this._instance.capture("$exception", t, {
            _noTruncate: !0,
            _batchKey: "exceptionEvent"
        });
    }
    pe(t) {
        var i = t.$exception_list;
        if (!i || !$cfd75c534a862da6$var$x(i) || 0 === i.length) return !1;
        var e = i.reduce((t, i)=>{
            var { type: e, value: r } = i;
            return $cfd75c534a862da6$var$T(e) && e.length > 0 && t.$exception_types.push(e), $cfd75c534a862da6$var$T(r) && r.length > 0 && t.$exception_values.push(r), t;
        }, {
            $exception_types: [],
            $exception_values: []
        });
        return this.fe.some((t)=>{
            var i = t.values.map((t)=>{
                var i, r = $cfd75c534a862da6$var$Us[t.operator], s = $cfd75c534a862da6$var$x(t.value) ? t.value : [
                    t.value
                ], n = null !== (i = e[t.key]) && void 0 !== i ? i : [];
                return s.length > 0 && r(s, n);
            });
            return "OR" === t.type ? i.some(Boolean) : i.every(Boolean);
        });
    }
}
var $cfd75c534a862da6$var$Ws = "Mobile", $cfd75c534a862da6$var$Gs = "iOS", $cfd75c534a862da6$var$Js = "Android", $cfd75c534a862da6$var$Vs = "Tablet", $cfd75c534a862da6$var$Ks = $cfd75c534a862da6$var$Js + " " + $cfd75c534a862da6$var$Vs, $cfd75c534a862da6$var$Ys = "iPad", $cfd75c534a862da6$var$Xs = "Apple", $cfd75c534a862da6$var$Qs = $cfd75c534a862da6$var$Xs + " Watch", $cfd75c534a862da6$var$Zs = "Safari", $cfd75c534a862da6$var$tn = "BlackBerry", $cfd75c534a862da6$var$en = "Samsung", $cfd75c534a862da6$var$rn = $cfd75c534a862da6$var$en + "Browser", $cfd75c534a862da6$var$sn = $cfd75c534a862da6$var$en + " Internet", $cfd75c534a862da6$var$nn = "Chrome", $cfd75c534a862da6$var$on = $cfd75c534a862da6$var$nn + " OS", $cfd75c534a862da6$var$an = $cfd75c534a862da6$var$nn + " " + $cfd75c534a862da6$var$Gs, $cfd75c534a862da6$var$ln = "Internet Explorer", $cfd75c534a862da6$var$un = $cfd75c534a862da6$var$ln + " " + $cfd75c534a862da6$var$Ws, $cfd75c534a862da6$var$hn = "Opera", $cfd75c534a862da6$var$dn = $cfd75c534a862da6$var$hn + " Mini", $cfd75c534a862da6$var$vn = "Edge", $cfd75c534a862da6$var$cn = "Microsoft " + $cfd75c534a862da6$var$vn, $cfd75c534a862da6$var$fn = "Firefox", $cfd75c534a862da6$var$pn = $cfd75c534a862da6$var$fn + " " + $cfd75c534a862da6$var$Gs, $cfd75c534a862da6$var$gn = "Nintendo", $cfd75c534a862da6$var$_n = "PlayStation", $cfd75c534a862da6$var$mn = "Xbox", $cfd75c534a862da6$var$bn = $cfd75c534a862da6$var$Js + " " + $cfd75c534a862da6$var$Ws, $cfd75c534a862da6$var$yn = $cfd75c534a862da6$var$Ws + " " + $cfd75c534a862da6$var$Zs, $cfd75c534a862da6$var$wn = "Windows", $cfd75c534a862da6$var$Sn = $cfd75c534a862da6$var$wn + " Phone", $cfd75c534a862da6$var$$n = "Nokia", $cfd75c534a862da6$var$kn = "Ouya", $cfd75c534a862da6$var$xn = "Generic", $cfd75c534a862da6$var$En = $cfd75c534a862da6$var$xn + " " + $cfd75c534a862da6$var$Ws.toLowerCase(), $cfd75c534a862da6$var$In = $cfd75c534a862da6$var$xn + " " + $cfd75c534a862da6$var$Vs.toLowerCase(), $cfd75c534a862da6$var$Pn = "Konqueror", $cfd75c534a862da6$var$Rn = "(\\d+(\\.\\d+)?)", $cfd75c534a862da6$var$Tn = new RegExp("Version/" + $cfd75c534a862da6$var$Rn), $cfd75c534a862da6$var$Mn = new RegExp($cfd75c534a862da6$var$mn, "i"), $cfd75c534a862da6$var$Cn = new RegExp($cfd75c534a862da6$var$_n + " \\w+", "i"), $cfd75c534a862da6$var$Fn = new RegExp($cfd75c534a862da6$var$gn + " \\w+", "i"), $cfd75c534a862da6$var$On = new RegExp($cfd75c534a862da6$var$tn + "|PlayBook|BB10", "i"), $cfd75c534a862da6$var$An = {
    "NT3.51": "NT 3.11",
    "NT4.0": "NT 4.0",
    "5.0": "2000",
    5.1: "XP",
    5.2: "XP",
    "6.0": "Vista",
    6.1: "7",
    6.2: "8",
    6.3: "8.1",
    6.4: "10",
    "10.0": "10"
};
var $cfd75c534a862da6$var$Dn = (t, i)=>i && $cfd75c534a862da6$var$m(i, $cfd75c534a862da6$var$Xs) || function(t) {
        return $cfd75c534a862da6$var$m(t, $cfd75c534a862da6$var$Zs) && !$cfd75c534a862da6$var$m(t, $cfd75c534a862da6$var$nn) && !$cfd75c534a862da6$var$m(t, $cfd75c534a862da6$var$Js);
    }(t), $cfd75c534a862da6$var$Ln = function(t, i) {
    return i = i || "", $cfd75c534a862da6$var$m(t, " OPR/") && $cfd75c534a862da6$var$m(t, "Mini") ? $cfd75c534a862da6$var$dn : $cfd75c534a862da6$var$m(t, " OPR/") ? $cfd75c534a862da6$var$hn : $cfd75c534a862da6$var$On.test(t) ? $cfd75c534a862da6$var$tn : $cfd75c534a862da6$var$m(t, "IE" + $cfd75c534a862da6$var$Ws) || $cfd75c534a862da6$var$m(t, "WPDesktop") ? $cfd75c534a862da6$var$un : $cfd75c534a862da6$var$m(t, $cfd75c534a862da6$var$rn) ? $cfd75c534a862da6$var$sn : $cfd75c534a862da6$var$m(t, $cfd75c534a862da6$var$vn) || $cfd75c534a862da6$var$m(t, "Edg/") ? $cfd75c534a862da6$var$cn : $cfd75c534a862da6$var$m(t, "FBIOS") ? "Facebook " + $cfd75c534a862da6$var$Ws : $cfd75c534a862da6$var$m(t, "UCWEB") || $cfd75c534a862da6$var$m(t, "UCBrowser") ? "UC Browser" : $cfd75c534a862da6$var$m(t, "CriOS") ? $cfd75c534a862da6$var$an : $cfd75c534a862da6$var$m(t, "CrMo") || $cfd75c534a862da6$var$m(t, $cfd75c534a862da6$var$nn) ? $cfd75c534a862da6$var$nn : $cfd75c534a862da6$var$m(t, $cfd75c534a862da6$var$Js) && $cfd75c534a862da6$var$m(t, $cfd75c534a862da6$var$Zs) ? $cfd75c534a862da6$var$bn : $cfd75c534a862da6$var$m(t, "FxiOS") ? $cfd75c534a862da6$var$pn : $cfd75c534a862da6$var$m(t.toLowerCase(), $cfd75c534a862da6$var$Pn.toLowerCase()) ? $cfd75c534a862da6$var$Pn : $cfd75c534a862da6$var$Dn(t, i) ? $cfd75c534a862da6$var$m(t, $cfd75c534a862da6$var$Ws) ? $cfd75c534a862da6$var$yn : $cfd75c534a862da6$var$Zs : $cfd75c534a862da6$var$m(t, $cfd75c534a862da6$var$fn) ? $cfd75c534a862da6$var$fn : $cfd75c534a862da6$var$m(t, "MSIE") || $cfd75c534a862da6$var$m(t, "Trident/") ? $cfd75c534a862da6$var$ln : $cfd75c534a862da6$var$m(t, "Gecko") ? $cfd75c534a862da6$var$fn : "";
}, $cfd75c534a862da6$var$jn = {
    [$cfd75c534a862da6$var$un]: [
        new RegExp("rv:" + $cfd75c534a862da6$var$Rn)
    ],
    [$cfd75c534a862da6$var$cn]: [
        new RegExp($cfd75c534a862da6$var$vn + "?\\/" + $cfd75c534a862da6$var$Rn)
    ],
    [$cfd75c534a862da6$var$nn]: [
        new RegExp("(" + $cfd75c534a862da6$var$nn + "|CrMo)\\/" + $cfd75c534a862da6$var$Rn)
    ],
    [$cfd75c534a862da6$var$an]: [
        new RegExp("CriOS\\/" + $cfd75c534a862da6$var$Rn)
    ],
    "UC Browser": [
        new RegExp("(UCBrowser|UCWEB)\\/" + $cfd75c534a862da6$var$Rn)
    ],
    [$cfd75c534a862da6$var$Zs]: [
        $cfd75c534a862da6$var$Tn
    ],
    [$cfd75c534a862da6$var$yn]: [
        $cfd75c534a862da6$var$Tn
    ],
    [$cfd75c534a862da6$var$hn]: [
        new RegExp("(Opera|OPR)\\/" + $cfd75c534a862da6$var$Rn)
    ],
    [$cfd75c534a862da6$var$fn]: [
        new RegExp($cfd75c534a862da6$var$fn + "\\/" + $cfd75c534a862da6$var$Rn)
    ],
    [$cfd75c534a862da6$var$pn]: [
        new RegExp("FxiOS\\/" + $cfd75c534a862da6$var$Rn)
    ],
    [$cfd75c534a862da6$var$Pn]: [
        new RegExp("Konqueror[:/]?" + $cfd75c534a862da6$var$Rn, "i")
    ],
    [$cfd75c534a862da6$var$tn]: [
        new RegExp($cfd75c534a862da6$var$tn + " " + $cfd75c534a862da6$var$Rn),
        $cfd75c534a862da6$var$Tn
    ],
    [$cfd75c534a862da6$var$bn]: [
        new RegExp("android\\s" + $cfd75c534a862da6$var$Rn, "i")
    ],
    [$cfd75c534a862da6$var$sn]: [
        new RegExp($cfd75c534a862da6$var$rn + "\\/" + $cfd75c534a862da6$var$Rn)
    ],
    [$cfd75c534a862da6$var$ln]: [
        new RegExp("(rv:|MSIE )" + $cfd75c534a862da6$var$Rn)
    ],
    Mozilla: [
        new RegExp("rv:" + $cfd75c534a862da6$var$Rn)
    ]
}, $cfd75c534a862da6$var$Nn = function(t, i) {
    var e = $cfd75c534a862da6$var$Ln(t, i), r = $cfd75c534a862da6$var$jn[e];
    if ($cfd75c534a862da6$var$R(r)) return null;
    for(var s = 0; s < r.length; s++){
        var n = r[s], o = t.match(n);
        if (o) return parseFloat(o[o.length - 2]);
    }
    return null;
}, $cfd75c534a862da6$var$zn = [
    [
        new RegExp($cfd75c534a862da6$var$mn + "; " + $cfd75c534a862da6$var$mn + " (.*?)[);]", "i"),
        (t)=>[
                $cfd75c534a862da6$var$mn,
                t && t[1] || ""
            ]
    ],
    [
        new RegExp($cfd75c534a862da6$var$gn, "i"),
        [
            $cfd75c534a862da6$var$gn,
            ""
        ]
    ],
    [
        new RegExp($cfd75c534a862da6$var$_n, "i"),
        [
            $cfd75c534a862da6$var$_n,
            ""
        ]
    ],
    [
        $cfd75c534a862da6$var$On,
        [
            $cfd75c534a862da6$var$tn,
            ""
        ]
    ],
    [
        new RegExp($cfd75c534a862da6$var$wn, "i"),
        (t, i)=>{
            if (/Phone/.test(i) || /WPDesktop/.test(i)) return [
                $cfd75c534a862da6$var$Sn,
                ""
            ];
            if (new RegExp($cfd75c534a862da6$var$Ws).test(i) && !/IEMobile\b/.test(i)) return [
                $cfd75c534a862da6$var$wn + " " + $cfd75c534a862da6$var$Ws,
                ""
            ];
            var e = /Windows NT ([0-9.]+)/i.exec(i);
            if (e && e[1]) {
                var r = e[1], s = $cfd75c534a862da6$var$An[r] || "";
                return /arm/i.test(i) && (s = "RT"), [
                    $cfd75c534a862da6$var$wn,
                    s
                ];
            }
            return [
                $cfd75c534a862da6$var$wn,
                ""
            ];
        }
    ],
    [
        /((iPhone|iPad|iPod).*?OS (\d+)_(\d+)_?(\d+)?|iPhone)/,
        (t)=>{
            if (t && t[3]) {
                var i = [
                    t[3],
                    t[4],
                    t[5] || "0"
                ];
                return [
                    $cfd75c534a862da6$var$Gs,
                    i.join(".")
                ];
            }
            return [
                $cfd75c534a862da6$var$Gs,
                ""
            ];
        }
    ],
    [
        /(watch.*\/(\d+\.\d+\.\d+)|watch os,(\d+\.\d+),)/i,
        (t)=>{
            var i = "";
            return t && t.length >= 3 && (i = $cfd75c534a862da6$var$R(t[2]) ? t[3] : t[2]), [
                "watchOS",
                i
            ];
        }
    ],
    [
        new RegExp("(" + $cfd75c534a862da6$var$Js + " (\\d+)\\.(\\d+)\\.?(\\d+)?|" + $cfd75c534a862da6$var$Js + ")", "i"),
        (t)=>{
            if (t && t[2]) {
                var i = [
                    t[2],
                    t[3],
                    t[4] || "0"
                ];
                return [
                    $cfd75c534a862da6$var$Js,
                    i.join(".")
                ];
            }
            return [
                $cfd75c534a862da6$var$Js,
                ""
            ];
        }
    ],
    [
        /Mac OS X (\d+)[_.](\d+)[_.]?(\d+)?/i,
        (t)=>{
            var i = [
                "Mac OS X",
                ""
            ];
            if (t && t[1]) {
                var e = [
                    t[1],
                    t[2],
                    t[3] || "0"
                ];
                i[1] = e.join(".");
            }
            return i;
        }
    ],
    [
        /Mac/i,
        [
            "Mac OS X",
            ""
        ]
    ],
    [
        /CrOS/,
        [
            $cfd75c534a862da6$var$on,
            ""
        ]
    ],
    [
        /Linux|debian/i,
        [
            "Linux",
            ""
        ]
    ]
], $cfd75c534a862da6$var$Un = function(t) {
    return $cfd75c534a862da6$var$Fn.test(t) ? $cfd75c534a862da6$var$gn : $cfd75c534a862da6$var$Cn.test(t) ? $cfd75c534a862da6$var$_n : $cfd75c534a862da6$var$Mn.test(t) ? $cfd75c534a862da6$var$mn : new RegExp($cfd75c534a862da6$var$kn, "i").test(t) ? $cfd75c534a862da6$var$kn : new RegExp("(" + $cfd75c534a862da6$var$Sn + "|WPDesktop)", "i").test(t) ? $cfd75c534a862da6$var$Sn : /iPad/.test(t) ? $cfd75c534a862da6$var$Ys : /iPod/.test(t) ? "iPod Touch" : /iPhone/.test(t) ? "iPhone" : /(watch)(?: ?os[,/]|\d,\d\/)[\d.]+/i.test(t) ? $cfd75c534a862da6$var$Qs : $cfd75c534a862da6$var$On.test(t) ? $cfd75c534a862da6$var$tn : /(kobo)\s(ereader|touch)/i.test(t) ? "Kobo" : new RegExp($cfd75c534a862da6$var$$n, "i").test(t) ? $cfd75c534a862da6$var$$n : /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i.test(t) || /(kf[a-z]+)( bui|\)).+silk\//i.test(t) ? "Kindle Fire" : /(Android|ZTE)/i.test(t) ? !new RegExp($cfd75c534a862da6$var$Ws).test(t) || /(9138B|TB782B|Nexus [97]|pixel c|HUAWEISHT|BTV|noble nook|smart ultra 6)/i.test(t) ? /pixel[\daxl ]{1,6}/i.test(t) && !/pixel c/i.test(t) || /(huaweimed-al00|tah-|APA|SM-G92|i980|zte|U304AA)/i.test(t) || /lmy47v/i.test(t) && !/QTAQZ3/i.test(t) ? $cfd75c534a862da6$var$Js : $cfd75c534a862da6$var$Ks : $cfd75c534a862da6$var$Js : new RegExp("(pda|" + $cfd75c534a862da6$var$Ws + ")", "i").test(t) ? $cfd75c534a862da6$var$En : new RegExp($cfd75c534a862da6$var$Vs, "i").test(t) && !new RegExp($cfd75c534a862da6$var$Vs + " pc", "i").test(t) ? $cfd75c534a862da6$var$In : "";
}, $cfd75c534a862da6$var$qn = "https?://(.*)", $cfd75c534a862da6$var$Bn = [
    "gclid",
    "gclsrc",
    "dclid",
    "gbraid",
    "wbraid",
    "fbclid",
    "msclkid",
    "twclid",
    "li_fat_id",
    "igshid",
    "ttclid",
    "rdt_cid",
    "epik",
    "qclid",
    "sccid",
    "irclid",
    "_kx"
], $cfd75c534a862da6$var$Hn = $cfd75c534a862da6$var$K([
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_content",
    "utm_term",
    "gad_source",
    "mc_cid"
], $cfd75c534a862da6$var$Bn), $cfd75c534a862da6$var$Wn = "<masked>";
function $cfd75c534a862da6$var$Gn(t, i, e) {
    if (!$cfd75c534a862da6$var$o) return {};
    var r = i ? $cfd75c534a862da6$var$K([], $cfd75c534a862da6$var$Bn, e || []) : [];
    return $cfd75c534a862da6$var$Jn($cfd75c534a862da6$var$ki($cfd75c534a862da6$var$o.URL, r, $cfd75c534a862da6$var$Wn), t);
}
function $cfd75c534a862da6$var$Jn(t, i) {
    var e = $cfd75c534a862da6$var$Hn.concat(i || []), r = {};
    return $cfd75c534a862da6$var$J(e, function(i) {
        var e = $cfd75c534a862da6$var$$i(t, i);
        r[i] = e || null;
    }), r;
}
function $cfd75c534a862da6$var$Vn(t) {
    var i = function(t) {
        return t ? 0 === t.search($cfd75c534a862da6$var$qn + "google.([^/?]*)") ? "google" : 0 === t.search($cfd75c534a862da6$var$qn + "bing.com") ? "bing" : 0 === t.search($cfd75c534a862da6$var$qn + "yahoo.com") ? "yahoo" : 0 === t.search($cfd75c534a862da6$var$qn + "duckduckgo.com") ? "duckduckgo" : null : null;
    }(t), e = "yahoo" != i ? "q" : "p", r = {};
    if (!$cfd75c534a862da6$var$C(i)) {
        r.$search_engine = i;
        var s = $cfd75c534a862da6$var$o ? $cfd75c534a862da6$var$$i($cfd75c534a862da6$var$o.referrer, e) : "";
        s.length && (r.ph_keyword = s);
    }
    return r;
}
function $cfd75c534a862da6$var$Kn() {
    return navigator.language || navigator.userLanguage;
}
function $cfd75c534a862da6$var$Yn() {
    return (null == $cfd75c534a862da6$var$o ? void 0 : $cfd75c534a862da6$var$o.referrer) || "$direct";
}
function $cfd75c534a862da6$var$Xn(t, i) {
    var e = t ? $cfd75c534a862da6$var$K([], $cfd75c534a862da6$var$Bn, i || []) : [], r = null == $cfd75c534a862da6$var$a ? void 0 : $cfd75c534a862da6$var$a.href.substring(0, 1e3);
    return {
        r: $cfd75c534a862da6$var$Yn().substring(0, 1e3),
        u: r ? $cfd75c534a862da6$var$ki(r, e, $cfd75c534a862da6$var$Wn) : void 0
    };
}
function $cfd75c534a862da6$var$Qn(t) {
    var i, { r: e, u: r } = t, s = {
        $referrer: e,
        $referring_domain: null == e ? void 0 : "$direct" == e ? "$direct" : null == (i = $cfd75c534a862da6$var$wi(e)) ? void 0 : i.host
    };
    if (r) {
        s.$current_url = r;
        var n = $cfd75c534a862da6$var$wi(r);
        s.$host = null == n ? void 0 : n.host, s.$pathname = null == n ? void 0 : n.pathname;
        var o = $cfd75c534a862da6$var$Jn(r);
        $cfd75c534a862da6$var$V(s, o);
    }
    if (e) {
        var a = $cfd75c534a862da6$var$Vn(e);
        $cfd75c534a862da6$var$V(s, a);
    }
    return s;
}
function $cfd75c534a862da6$var$Zn() {
    try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch (t) {
        return;
    }
}
function $cfd75c534a862da6$var$to() {
    try {
        return (new Date).getTimezoneOffset();
    } catch (t) {
        return;
    }
}
function $cfd75c534a862da6$var$io(i, e) {
    if (!$cfd75c534a862da6$var$d) return {};
    var r, s, n, o = i ? $cfd75c534a862da6$var$K([], $cfd75c534a862da6$var$Bn, e || []) : [], [l, u] = function(t) {
        for(var i = 0; i < $cfd75c534a862da6$var$zn.length; i++){
            var [e, r] = $cfd75c534a862da6$var$zn[i], s = e.exec(t), n = s && ($cfd75c534a862da6$var$E(r) ? r(s, t) : r);
            if (n) return n;
        }
        return [
            "",
            ""
        ];
    }($cfd75c534a862da6$var$d);
    return $cfd75c534a862da6$var$V($cfd75c534a862da6$var$Z({
        $os: l,
        $os_version: u,
        $browser: $cfd75c534a862da6$var$Ln($cfd75c534a862da6$var$d, navigator.vendor),
        $device: $cfd75c534a862da6$var$Un($cfd75c534a862da6$var$d),
        $device_type: (s = $cfd75c534a862da6$var$d, n = $cfd75c534a862da6$var$Un(s), n === $cfd75c534a862da6$var$Ys || n === $cfd75c534a862da6$var$Ks || "Kobo" === n || "Kindle Fire" === n || n === $cfd75c534a862da6$var$In ? $cfd75c534a862da6$var$Vs : n === $cfd75c534a862da6$var$gn || n === $cfd75c534a862da6$var$mn || n === $cfd75c534a862da6$var$_n || n === $cfd75c534a862da6$var$kn ? "Console" : n === $cfd75c534a862da6$var$Qs ? "Wearable" : n ? $cfd75c534a862da6$var$Ws : "Desktop"),
        $timezone: $cfd75c534a862da6$var$Zn(),
        $timezone_offset: $cfd75c534a862da6$var$to()
    }), {
        $current_url: $cfd75c534a862da6$var$ki(null == $cfd75c534a862da6$var$a ? void 0 : $cfd75c534a862da6$var$a.href, o, $cfd75c534a862da6$var$Wn),
        $host: null == $cfd75c534a862da6$var$a ? void 0 : $cfd75c534a862da6$var$a.host,
        $pathname: null == $cfd75c534a862da6$var$a ? void 0 : $cfd75c534a862da6$var$a.pathname,
        $raw_user_agent: $cfd75c534a862da6$var$d.length > 1e3 ? $cfd75c534a862da6$var$d.substring(0, 997) + "..." : $cfd75c534a862da6$var$d,
        $browser_version: $cfd75c534a862da6$var$Nn($cfd75c534a862da6$var$d, navigator.vendor),
        $browser_language: $cfd75c534a862da6$var$Kn(),
        $browser_language_prefix: (r = $cfd75c534a862da6$var$Kn(), "string" == typeof r ? r.split("-")[0] : void 0),
        $screen_height: null == $cfd75c534a862da6$var$t ? void 0 : $cfd75c534a862da6$var$t.screen.height,
        $screen_width: null == $cfd75c534a862da6$var$t ? void 0 : $cfd75c534a862da6$var$t.screen.width,
        $viewport_height: null == $cfd75c534a862da6$var$t ? void 0 : $cfd75c534a862da6$var$t.innerHeight,
        $viewport_width: null == $cfd75c534a862da6$var$t ? void 0 : $cfd75c534a862da6$var$t.innerWidth,
        $lib: "web",
        $lib_version: $cfd75c534a862da6$var$c.LIB_VERSION,
        $insert_id: Math.random().toString(36).substring(2, 10) + Math.random().toString(36).substring(2, 10),
        $time: Date.now() / 1e3
    });
}
var $cfd75c534a862da6$var$eo = $cfd75c534a862da6$var$z("[FeatureFlags]"), $cfd75c534a862da6$var$ro = "$active_feature_flags", $cfd75c534a862da6$var$so = "$override_feature_flags", $cfd75c534a862da6$var$no = "$feature_flag_payloads", $cfd75c534a862da6$var$oo = "$override_feature_flag_payloads", $cfd75c534a862da6$var$ao = "$feature_flag_request_id", $cfd75c534a862da6$var$lo = (t)=>{
    var i = {};
    for (var [e, r] of $cfd75c534a862da6$var$Y(t || {}))r && (i[e] = r);
    return i;
}, $cfd75c534a862da6$var$uo = (t)=>{
    var i = t.flags;
    return i ? (t.featureFlags = Object.fromEntries(Object.keys(i).map((t)=>{
        var e;
        return [
            t,
            null !== (e = i[t].variant) && void 0 !== e ? e : i[t].enabled
        ];
    })), t.featureFlagPayloads = Object.fromEntries(Object.keys(i).filter((t)=>i[t].enabled).filter((t)=>{
        var e;
        return null == (e = i[t].metadata) ? void 0 : e.payload;
    }).map((t)=>{
        var e;
        return [
            t,
            null == (e = i[t].metadata) ? void 0 : e.payload
        ];
    }))) : $cfd75c534a862da6$var$eo.warn("Using an older version of the feature flags endpoint. Please upgrade your PostHog server to the latest version"), t;
}, $cfd75c534a862da6$var$ho = function(t) {
    return t.FeatureFlags = "feature_flags", t.Recordings = "recordings", t;
}({});
var $cfd75c534a862da6$var$vo = new Set([
    "7c6f7b45",
    "66c1f69c",
    "2727f65a",
    "f3287528",
    "8cc9a311",
    "eb9f671b",
    "c0e1c6f9",
    "057989ec",
    "723f4019",
    "7b102104",
    "563359d3",
    "bad973ea",
    "f6f2c4f4",
    "59454a61",
    "89ad1076",
    "4edd0da1",
    "26c52e72",
    "a970bd2e",
    "89cf4454",
    "16e2b4e7",
    "fba0e7b6",
    "301c8488",
    "bc65d69e",
    "fe66a3c5",
    "37926ca6",
    "52a196df",
    "d32a7577",
    "42c4c9ef",
    "6883bd5a",
    "04809ff7",
    "e59430a8",
    "61be3dd8",
    "7fa5500b",
    "bf027177",
    "8cfdba9b",
    "96f6df5f",
    "569798e9",
    "0ebc61a5",
    "1b5d7b92",
    "17ebb0a4",
    "f97ea965",
    "85cc817b",
    "3044dfc1",
    "0c3fe5c3",
    "b1f95fa3",
    "8a6342e8",
    "72365c68",
    "12d34ad9",
    "733853ec",
    "3beeb69a",
    "0645bb64",
    "32de7f98",
    "5dcbee21",
    "3fe85053",
    "ad960278",
    "9466e5dd",
    "7ca97b2d",
    "2ee2a65c",
    "28fde5f2",
    "85c52f49",
    "0ad823f4",
    "f11b6cc9",
    "aacf8af9",
    "ab3e62b3",
    "3a85ff15",
    "8a67d3c4",
    "f5e91ef1",
    "4b873698",
    "c5dae949",
    "5b643d76",
    "9599c892",
    "34377448",
    "2189e408",
    "3be9ad53",
    "1a14ce7c",
    "2a164ded",
    "8d53ea86",
    "53bdb37d",
    "bfc3f590",
    "8df38ede",
    "bdb81e49",
    "38fde5c0",
    "8d707e6d",
    "73cbc496",
    "f9d8a5ef",
    "d3a9f8c4",
    "a980d8cd",
    "5bcfe086",
    "e4818f68",
    "4f11fb39",
    "a13c6ae3",
    "150c7fbb",
    "98f3d658",
    "f84f7377",
    "1924dd9c",
    "1f6b63b3",
    "24748755",
    "7c0f717c",
    "8a87f11b",
    "49f57f22",
    "3c9e9234",
    "3772f65b",
    "dff631b6",
    "cd609d40",
    "f853c7f7",
    "952db5ee",
    "c5aa8a79",
    "2d21b6fd",
    "79b7164c",
    "4110e26c",
    "a7d3b43f",
    "84e1b8f6",
    "75cc0998",
    "07f78e33",
    "10ca9b1a",
    "ce441b18",
    "01eb8256",
    "c0ac4b67",
    "8e8e5216",
    "db7943dd",
    "fa133a95",
    "498a4508",
    "21bbda67",
    "7dbfed69",
    "be3ec24c",
    "fc80b8e2"
]);
class $cfd75c534a862da6$var$co {
    constructor(t){
        this.ge = !1, this._e = !1, this.me = !1, this.be = !1, this.ye = !1, this.we = !1, this.Se = !1, this._instance = t, this.featureFlagEventHandlers = [];
    }
    flags() {
        if (this._instance.config.__preview_remote_config) this.we = !0;
        else {
            var t = !this.$e && (this._instance.config.advanced_disable_feature_flags || this._instance.config.advanced_disable_feature_flags_on_first_load);
            this.ke({
                disableFlags: t
            });
        }
    }
    get hasLoadedFlags() {
        return this._e;
    }
    getFlags() {
        return Object.keys(this.getFlagVariants());
    }
    getFlagsWithDetails() {
        var t = this._instance.get_property($cfd75c534a862da6$var$Rt), i = this._instance.get_property($cfd75c534a862da6$var$so), e = this._instance.get_property($cfd75c534a862da6$var$oo);
        if (!e && !i) return t || {};
        var r = $cfd75c534a862da6$var$V({}, t || {}), s = [
            ...new Set([
                ...Object.keys(e || {}),
                ...Object.keys(i || {})
            ])
        ];
        for (var n of s){
            var o, a, l = r[n], u = null == i ? void 0 : i[n], h = $cfd75c534a862da6$var$R(u) ? null !== (o = null == l ? void 0 : l.enabled) && void 0 !== o && o : !!u, d = $cfd75c534a862da6$var$R(u) ? l.variant : "string" == typeof u ? u : void 0, v = null == e ? void 0 : e[n], c = $cfd75c534a862da6$var$B({}, l, {
                enabled: h,
                variant: h ? null != d ? d : null == l ? void 0 : l.variant : void 0
            });
            if (h !== (null == l ? void 0 : l.enabled) && (c.original_enabled = null == l ? void 0 : l.enabled), d !== (null == l ? void 0 : l.variant) && (c.original_variant = null == l ? void 0 : l.variant), v) c.metadata = $cfd75c534a862da6$var$B({}, null == l ? void 0 : l.metadata, {
                payload: v,
                original_payload: null == l || null == (a = l.metadata) ? void 0 : a.payload
            });
            r[n] = c;
        }
        return this.ge || ($cfd75c534a862da6$var$eo.warn(" Overriding feature flag details!", {
            flagDetails: t,
            overriddenPayloads: e,
            finalDetails: r
        }), this.ge = !0), r;
    }
    getFlagVariants() {
        var t = this._instance.get_property($cfd75c534a862da6$var$It), i = this._instance.get_property($cfd75c534a862da6$var$so);
        if (!i) return t || {};
        for(var e = $cfd75c534a862da6$var$V({}, t), r = Object.keys(i), s = 0; s < r.length; s++)e[r[s]] = i[r[s]];
        return this.ge || ($cfd75c534a862da6$var$eo.warn(" Overriding feature flags!", {
            enabledFlags: t,
            overriddenFlags: i,
            finalFlags: e
        }), this.ge = !0), e;
    }
    getFlagPayloads() {
        var t = this._instance.get_property($cfd75c534a862da6$var$no), i = this._instance.get_property($cfd75c534a862da6$var$oo);
        if (!i) return t || {};
        for(var e = $cfd75c534a862da6$var$V({}, t || {}), r = Object.keys(i), s = 0; s < r.length; s++)e[r[s]] = i[r[s]];
        return this.ge || ($cfd75c534a862da6$var$eo.warn(" Overriding feature flag payloads!", {
            flagPayloads: t,
            overriddenPayloads: i,
            finalPayloads: e
        }), this.ge = !0), e;
    }
    reloadFeatureFlags() {
        this.be || this._instance.config.advanced_disable_feature_flags || this.$e || (this.$e = setTimeout(()=>{
            this.ke();
        }, 5));
    }
    xe() {
        clearTimeout(this.$e), this.$e = void 0;
    }
    ensureFlagsLoaded() {
        this._e || this.me || this.$e || this.reloadFeatureFlags();
    }
    setAnonymousDistinctId(t) {
        this.$anon_distinct_id = t;
    }
    setReloadingPaused(t) {
        this.be = t;
    }
    ke(t) {
        var i;
        if (this.xe(), !this._instance.I()) {
            if (this.me) this.ye = !0;
            else {
                var e = {
                    token: this._instance.config.token,
                    distinct_id: this._instance.get_distinct_id(),
                    groups: this._instance.getGroups(),
                    $anon_distinct_id: this.$anon_distinct_id,
                    person_properties: $cfd75c534a862da6$var$B({}, (null == (i = this._instance.persistence) ? void 0 : i.get_initial_props()) || {}, this._instance.get_property($cfd75c534a862da6$var$Tt) || {}),
                    group_properties: this._instance.get_property($cfd75c534a862da6$var$Mt)
                };
                (null != t && t.disableFlags || this._instance.config.advanced_disable_feature_flags) && (e.disable_flags = !0);
                var r = this._instance.config.__preview_flags_v2 && this._instance.config.__preview_remote_config, s = function(t) {
                    var i = function(t) {
                        for(var i = 2166136261, e = 0; e < t.length; e++)i ^= t.charCodeAt(e), i += (i << 1) + (i << 4) + (i << 7) + (i << 8) + (i << 24);
                        return ("00000000" + (i >>> 0).toString(16)).slice(-8);
                    }(t);
                    return null == $cfd75c534a862da6$var$vo ? void 0 : $cfd75c534a862da6$var$vo.has(i);
                }(this._instance.config.token) ? "/decide?v=4" : r ? "/flags/?v=2" : "/flags/?v=2&config=true", n = this._instance.config.advanced_only_evaluate_survey_feature_flags ? "&only_evaluate_survey_feature_flags=true" : "", o = this._instance.requestRouter.endpointFor("api", s + n);
                r && (e.timezone = $cfd75c534a862da6$var$Zn()), this.me = !0, this._instance.Ee({
                    method: "POST",
                    url: o,
                    data: e,
                    compression: this._instance.config.disable_compression ? void 0 : $cfd75c534a862da6$export$6a00d17b5aff0af.Base64,
                    timeout: this._instance.config.feature_flag_request_timeout_ms,
                    callback: (t)=>{
                        var i, r, s = !0;
                        (200 === t.statusCode && (this.ye || (this.$anon_distinct_id = void 0), s = !1), this.me = !1, this.we) || (this.we = !0, this._instance.Ie(null !== (r = t.json) && void 0 !== r ? r : {}));
                        if (!e.disable_flags || this.ye) {
                            if (this.Se = !s, t.json && null != (i = t.json.quotaLimited) && i.includes($cfd75c534a862da6$var$ho.FeatureFlags)) $cfd75c534a862da6$var$eo.warn("You have hit your feature flags quota limit, and will not be able to load feature flags until the quota is reset.  Please visit https://posthog.com/docs/billing/limits-alerts to learn more.");
                            else {
                                var n;
                                if (!e.disable_flags) this.receivedFeatureFlags(null !== (n = t.json) && void 0 !== n ? n : {}, s);
                                this.ye && (this.ye = !1, this.ke());
                            }
                        }
                    }
                });
            }
        }
    }
    getFeatureFlag(t, i) {
        if (void 0 === i && (i = {}), this._e || this.getFlags() && this.getFlags().length > 0) {
            var e = this.getFlagVariants()[t], r = "" + e, s = this._instance.get_property($cfd75c534a862da6$var$ao) || void 0, n = this._instance.get_property($cfd75c534a862da6$var$Ot) || {};
            if ((i.send_event || !("send_event" in i)) && (!(t in n) || !n[t].includes(r))) {
                var o, a, l, u, h, d, v, c, f;
                $cfd75c534a862da6$var$x(n[t]) ? n[t].push(r) : n[t] = [
                    r
                ], null == (o = this._instance.persistence) || o.register({
                    [$cfd75c534a862da6$var$Ot]: n
                });
                var p = this.getFeatureFlagDetails(t), g = {
                    $feature_flag: t,
                    $feature_flag_response: e,
                    $feature_flag_payload: this.getFeatureFlagPayload(t) || null,
                    $feature_flag_request_id: s,
                    $feature_flag_bootstrapped_response: (null == (a = this._instance.config.bootstrap) || null == (a = a.featureFlags) ? void 0 : a[t]) || null,
                    $feature_flag_bootstrapped_payload: (null == (l = this._instance.config.bootstrap) || null == (l = l.featureFlagPayloads) ? void 0 : l[t]) || null,
                    $used_bootstrap_value: !this.Se
                };
                $cfd75c534a862da6$var$R(null == p || null == (u = p.metadata) ? void 0 : u.version) || (g.$feature_flag_version = p.metadata.version);
                var _, m = null !== (h = null == p || null == (d = p.reason) ? void 0 : d.description) && void 0 !== h ? h : null == p || null == (v = p.reason) ? void 0 : v.code;
                if (m && (g.$feature_flag_reason = m), null != p && null != (c = p.metadata) && c.id && (g.$feature_flag_id = p.metadata.id), $cfd75c534a862da6$var$R(null == p ? void 0 : p.original_variant) && $cfd75c534a862da6$var$R(null == p ? void 0 : p.original_enabled) || (g.$feature_flag_original_response = $cfd75c534a862da6$var$R(p.original_variant) ? p.original_enabled : p.original_variant), null != p && null != (f = p.metadata) && f.original_payload) g.$feature_flag_original_payload = null == p || null == (_ = p.metadata) ? void 0 : _.original_payload;
                this._instance.capture("$feature_flag_called", g);
            }
            return e;
        }
        $cfd75c534a862da6$var$eo.warn('getFeatureFlag for key "' + t + "\" failed. Feature flags didn't load in time.");
    }
    getFeatureFlagDetails(t) {
        return this.getFlagsWithDetails()[t];
    }
    getFeatureFlagPayload(t) {
        return this.getFlagPayloads()[t];
    }
    getRemoteConfigPayload(t, i) {
        var e = this._instance.config.token;
        this._instance.Ee({
            method: "POST",
            url: this._instance.requestRouter.endpointFor("api", "/flags/?v=2&config=true"),
            data: {
                distinct_id: this._instance.get_distinct_id(),
                token: e
            },
            compression: this._instance.config.disable_compression ? void 0 : $cfd75c534a862da6$export$6a00d17b5aff0af.Base64,
            timeout: this._instance.config.feature_flag_request_timeout_ms,
            callback: (e)=>{
                var r, s = null == (r = e.json) ? void 0 : r.featureFlagPayloads;
                i((null == s ? void 0 : s[t]) || void 0);
            }
        });
    }
    isFeatureEnabled(t, i) {
        if (void 0 === i && (i = {}), this._e || this.getFlags() && this.getFlags().length > 0) return !!this.getFeatureFlag(t, i);
        $cfd75c534a862da6$var$eo.warn('isFeatureEnabled for key "' + t + "\" failed. Feature flags didn't load in time.");
    }
    addFeatureFlagsHandler(t) {
        this.featureFlagEventHandlers.push(t);
    }
    removeFeatureFlagsHandler(t) {
        this.featureFlagEventHandlers = this.featureFlagEventHandlers.filter((i)=>i !== t);
    }
    receivedFeatureFlags(t, i) {
        if (this._instance.persistence) {
            this._e = !0;
            var e = this.getFlagVariants(), r = this.getFlagPayloads(), s = this.getFlagsWithDetails();
            !function(t, i, e, r, s) {
                void 0 === e && (e = {}), void 0 === r && (r = {}), void 0 === s && (s = {});
                var n = $cfd75c534a862da6$var$uo(t), o = n.flags, a = n.featureFlags, l = n.featureFlagPayloads;
                if (a) {
                    var u = t.requestId;
                    if ($cfd75c534a862da6$var$x(a)) {
                        $cfd75c534a862da6$var$eo.warn("v1 of the feature flags endpoint is deprecated. Please use the latest version.");
                        var h = {};
                        if (a) for(var d = 0; d < a.length; d++)h[a[d]] = !0;
                        i && i.register({
                            [$cfd75c534a862da6$var$ro]: a,
                            [$cfd75c534a862da6$var$It]: h
                        });
                    } else {
                        var v = a, c = l, f = o;
                        t.errorsWhileComputingFlags && (v = $cfd75c534a862da6$var$B({}, e, v), c = $cfd75c534a862da6$var$B({}, r, c), f = $cfd75c534a862da6$var$B({}, s, f)), i && i.register($cfd75c534a862da6$var$B({
                            [$cfd75c534a862da6$var$ro]: Object.keys($cfd75c534a862da6$var$lo(v)),
                            [$cfd75c534a862da6$var$It]: v || {},
                            [$cfd75c534a862da6$var$no]: c || {},
                            [$cfd75c534a862da6$var$Rt]: f || {}
                        }, u ? {
                            [$cfd75c534a862da6$var$ao]: u
                        } : {}));
                    }
                }
            }(t, this._instance.persistence, e, r, s), this.Pe(i);
        }
    }
    override(t, i) {
        void 0 === i && (i = !1), $cfd75c534a862da6$var$eo.warn("override is deprecated. Please use overrideFeatureFlags instead."), this.overrideFeatureFlags({
            flags: t,
            suppressWarning: i
        });
    }
    overrideFeatureFlags(t) {
        if (!this._instance.__loaded || !this._instance.persistence) return $cfd75c534a862da6$var$eo.uninitializedWarning("posthog.featureFlags.overrideFeatureFlags");
        if (!1 === t) return this._instance.persistence.unregister($cfd75c534a862da6$var$so), this._instance.persistence.unregister($cfd75c534a862da6$var$oo), void this.Pe();
        if (t && "object" == typeof t && ("flags" in t || "payloads" in t)) {
            var i, e = t;
            if (this.ge = Boolean(null !== (i = e.suppressWarning) && void 0 !== i && i), "flags" in e) {
                if (!1 === e.flags) this._instance.persistence.unregister($cfd75c534a862da6$var$so);
                else if (e.flags) {
                    if ($cfd75c534a862da6$var$x(e.flags)) {
                        for(var r = {}, s = 0; s < e.flags.length; s++)r[e.flags[s]] = !0;
                        this._instance.persistence.register({
                            [$cfd75c534a862da6$var$so]: r
                        });
                    } else this._instance.persistence.register({
                        [$cfd75c534a862da6$var$so]: e.flags
                    });
                }
            }
            return "payloads" in e && (!1 === e.payloads ? this._instance.persistence.unregister($cfd75c534a862da6$var$oo) : e.payloads && this._instance.persistence.register({
                [$cfd75c534a862da6$var$oo]: e.payloads
            })), void this.Pe();
        }
        this.Pe();
    }
    onFeatureFlags(t) {
        if (this.addFeatureFlagsHandler(t), this._e) {
            var { flags: i, flagVariants: e } = this.Re();
            t(i, e);
        }
        return ()=>this.removeFeatureFlagsHandler(t);
    }
    updateEarlyAccessFeatureEnrollment(t, i) {
        var e, r = (this._instance.get_property($cfd75c534a862da6$var$Pt) || []).find((i)=>i.flagKey === t), s = {
            ["$feature_enrollment/" + t]: i
        }, n = {
            $feature_flag: t,
            $feature_enrollment: i,
            $set: s
        };
        r && (n.$early_access_feature_name = r.name), this._instance.capture("$feature_enrollment_update", n), this.setPersonPropertiesForFlags(s, !1);
        var o = $cfd75c534a862da6$var$B({}, this.getFlagVariants(), {
            [t]: i
        });
        null == (e = this._instance.persistence) || e.register({
            [$cfd75c534a862da6$var$ro]: Object.keys($cfd75c534a862da6$var$lo(o)),
            [$cfd75c534a862da6$var$It]: o
        }), this.Pe();
    }
    getEarlyAccessFeatures(t, i, e) {
        void 0 === i && (i = !1);
        var r = this._instance.get_property($cfd75c534a862da6$var$Pt), s = e ? "&" + e.map((t)=>"stage=" + t).join("&") : "";
        if (r && !i) return t(r);
        this._instance.Ee({
            url: this._instance.requestRouter.endpointFor("api", "/api/early_access_features/?token=" + this._instance.config.token + s),
            method: "GET",
            callback: (i)=>{
                var e;
                if (i.json) {
                    var r = i.json.earlyAccessFeatures;
                    return null == (e = this._instance.persistence) || e.register({
                        [$cfd75c534a862da6$var$Pt]: r
                    }), t(r);
                }
            }
        });
    }
    Re() {
        var t = this.getFlags(), i = this.getFlagVariants();
        return {
            flags: t.filter((t)=>i[t]),
            flagVariants: Object.keys(i).filter((t)=>i[t]).reduce((t, e)=>(t[e] = i[e], t), {})
        };
    }
    Pe(t) {
        var { flags: i, flagVariants: e } = this.Re();
        this.featureFlagEventHandlers.forEach((r)=>r(i, e, {
                errorsLoading: t
            }));
    }
    setPersonPropertiesForFlags(t, i) {
        void 0 === i && (i = !0);
        var e = this._instance.get_property($cfd75c534a862da6$var$Tt) || {};
        this._instance.register({
            [$cfd75c534a862da6$var$Tt]: $cfd75c534a862da6$var$B({}, e, t)
        }), i && this._instance.reloadFeatureFlags();
    }
    resetPersonPropertiesForFlags() {
        this._instance.unregister($cfd75c534a862da6$var$Tt);
    }
    setGroupPropertiesForFlags(t, i) {
        void 0 === i && (i = !0);
        var e = this._instance.get_property($cfd75c534a862da6$var$Mt) || {};
        0 !== Object.keys(e).length && Object.keys(e).forEach((i)=>{
            e[i] = $cfd75c534a862da6$var$B({}, e[i], t[i]), delete t[i];
        }), this._instance.register({
            [$cfd75c534a862da6$var$Mt]: $cfd75c534a862da6$var$B({}, e, t)
        }), i && this._instance.reloadFeatureFlags();
    }
    resetGroupPropertiesForFlags(t) {
        if (t) {
            var i = this._instance.get_property($cfd75c534a862da6$var$Mt) || {};
            this._instance.register({
                [$cfd75c534a862da6$var$Mt]: $cfd75c534a862da6$var$B({}, i, {
                    [t]: {}
                })
            });
        } else this._instance.unregister($cfd75c534a862da6$var$Mt);
    }
}
var $cfd75c534a862da6$var$fo = [
    "cookie",
    "localstorage",
    "localstorage+cookie",
    "sessionstorage",
    "memory"
];
class $cfd75c534a862da6$var$po {
    constructor(t){
        this.S = t, this.props = {}, this.Te = !1, this.Me = ((t)=>{
            var i = "";
            return t.token && (i = t.token.replace(/\+/g, "PL").replace(/\//g, "SL").replace(/=/g, "EQ")), t.persistence_name ? "ph_" + t.persistence_name : "ph_" + i + "_posthog";
        })(t), this.B = this.Ce(t), this.load(), t.debug && $cfd75c534a862da6$var$N.info("Persistence loaded", t.persistence, $cfd75c534a862da6$var$B({}, this.props)), this.update_config(t, t), this.save();
    }
    Ce(t) {
        -1 === $cfd75c534a862da6$var$fo.indexOf(t.persistence.toLowerCase()) && ($cfd75c534a862da6$var$N.critical("Unknown persistence type " + t.persistence + "; falling back to localStorage+cookie"), t.persistence = "localStorage+cookie");
        var i = t.persistence.toLowerCase();
        return "localstorage" === i && $cfd75c534a862da6$var$Wi.O() ? $cfd75c534a862da6$var$Wi : "localstorage+cookie" === i && $cfd75c534a862da6$var$Ji.O() ? $cfd75c534a862da6$var$Ji : "sessionstorage" === i && $cfd75c534a862da6$var$Xi.O() ? $cfd75c534a862da6$var$Xi : "memory" === i ? $cfd75c534a862da6$var$Ki : "cookie" === i ? $cfd75c534a862da6$var$Bi : $cfd75c534a862da6$var$Ji.O() ? $cfd75c534a862da6$var$Ji : $cfd75c534a862da6$var$Bi;
    }
    properties() {
        var t = {};
        return $cfd75c534a862da6$var$J(this.props, function(i, e) {
            if (e === $cfd75c534a862da6$var$It && $cfd75c534a862da6$var$I(i)) for(var r = Object.keys(i), n = 0; n < r.length; n++)t["$feature/" + r[n]] = i[r[n]];
            else a = e, l = !1, ($cfd75c534a862da6$var$C(o = $cfd75c534a862da6$var$Ht) ? l : $cfd75c534a862da6$var$s && o.indexOf === $cfd75c534a862da6$var$s ? -1 != o.indexOf(a) : ($cfd75c534a862da6$var$J(o, function(t) {
                if (l || (l = t === a)) return $cfd75c534a862da6$var$W;
            }), l)) || (t[e] = i);
            var o, a, l;
        }), t;
    }
    load() {
        if (!this.Fe) {
            var t = this.B.L(this.Me);
            t && (this.props = $cfd75c534a862da6$var$V({}, t));
        }
    }
    save() {
        this.Fe || this.B.j(this.Me, this.props, this.Oe, this.Ae, this.De, this.S.debug);
    }
    remove() {
        this.B.N(this.Me, !1), this.B.N(this.Me, !0);
    }
    clear() {
        this.remove(), this.props = {};
    }
    register_once(t, i, e) {
        if ($cfd75c534a862da6$var$I(t)) {
            $cfd75c534a862da6$var$R(i) && (i = "None"), this.Oe = $cfd75c534a862da6$var$R(e) ? this.Le : e;
            var r = !1;
            if ($cfd75c534a862da6$var$J(t, (t, e)=>{
                this.props.hasOwnProperty(e) && this.props[e] !== i || (this.props[e] = t, r = !0);
            }), r) return this.save(), !0;
        }
        return !1;
    }
    register(t, i) {
        if ($cfd75c534a862da6$var$I(t)) {
            this.Oe = $cfd75c534a862da6$var$R(i) ? this.Le : i;
            var e = !1;
            if ($cfd75c534a862da6$var$J(t, (i, r)=>{
                t.hasOwnProperty(r) && this.props[r] !== i && (this.props[r] = i, e = !0);
            }), e) return this.save(), !0;
        }
        return !1;
    }
    unregister(t) {
        t in this.props && (delete this.props[t], this.save());
    }
    update_campaign_params() {
        if (!this.Te) {
            var t = $cfd75c534a862da6$var$Gn(this.S.custom_campaign_params, this.S.mask_personal_data_properties, this.S.custom_personal_data_properties);
            $cfd75c534a862da6$var$P($cfd75c534a862da6$var$Z(t)) || this.register(t), this.Te = !0;
        }
    }
    update_search_keyword() {
        var t;
        this.register((t = null == $cfd75c534a862da6$var$o ? void 0 : $cfd75c534a862da6$var$o.referrer) ? $cfd75c534a862da6$var$Vn(t) : {});
    }
    update_referrer_info() {
        var t;
        this.register_once({
            $referrer: $cfd75c534a862da6$var$Yn(),
            $referring_domain: null != $cfd75c534a862da6$var$o && $cfd75c534a862da6$var$o.referrer && (null == (t = $cfd75c534a862da6$var$wi($cfd75c534a862da6$var$o.referrer)) ? void 0 : t.host) || "$direct"
        }, void 0);
    }
    set_initial_person_info() {
        this.props[$cfd75c534a862da6$var$jt] || this.props[$cfd75c534a862da6$var$Nt] || this.register_once({
            [$cfd75c534a862da6$var$zt]: $cfd75c534a862da6$var$Xn(this.S.mask_personal_data_properties, this.S.custom_personal_data_properties)
        }, void 0);
    }
    get_initial_props() {
        var t = {};
        $cfd75c534a862da6$var$J([
            $cfd75c534a862da6$var$Nt,
            $cfd75c534a862da6$var$jt
        ], (i)=>{
            var e = this.props[i];
            e && $cfd75c534a862da6$var$J(e, function(i, e) {
                t["$initial_" + $cfd75c534a862da6$var$y(e)] = i;
            });
        });
        var i, e, r = this.props[$cfd75c534a862da6$var$zt];
        if (r) {
            var s = (i = $cfd75c534a862da6$var$Qn(r), e = {}, $cfd75c534a862da6$var$J(i, function(t, i) {
                e["$initial_" + $cfd75c534a862da6$var$y(i)] = t;
            }), e);
            $cfd75c534a862da6$var$V(t, s);
        }
        return t;
    }
    safe_merge(t) {
        return $cfd75c534a862da6$var$J(this.props, function(i, e) {
            e in t || (t[e] = i);
        }), t;
    }
    update_config(t, i) {
        if (this.Le = this.Oe = t.cookie_expiration, this.set_disabled(t.disable_persistence), this.set_cross_subdomain(t.cross_subdomain_cookie), this.set_secure(t.secure_cookie), t.persistence !== i.persistence) {
            var e = this.Ce(t), r = this.props;
            this.clear(), this.B = e, this.props = r, this.save();
        }
    }
    set_disabled(t) {
        this.Fe = t, this.Fe ? this.remove() : this.save();
    }
    set_cross_subdomain(t) {
        t !== this.Ae && (this.Ae = t, this.remove(), this.save());
    }
    set_secure(t) {
        t !== this.De && (this.De = t, this.remove(), this.save());
    }
    set_event_timer(t, i) {
        var e = this.props[$cfd75c534a862da6$var$at] || {};
        e[t] = i, this.props[$cfd75c534a862da6$var$at] = e, this.save();
    }
    remove_event_timer(t) {
        var i = (this.props[$cfd75c534a862da6$var$at] || {})[t];
        return $cfd75c534a862da6$var$R(i) || (delete this.props[$cfd75c534a862da6$var$at][t], this.save()), i;
    }
    get_property(t) {
        return this.props[t];
    }
    set_property(t, i) {
        this.props[t] = i, this.save();
    }
}
class $cfd75c534a862da6$var$go {
    constructor(){
        this.je = {}, this.je = {};
    }
    on(t, i) {
        return this.je[t] || (this.je[t] = []), this.je[t].push(i), ()=>{
            this.je[t] = this.je[t].filter((t)=>t !== i);
        };
    }
    emit(t, i) {
        for (var e of this.je[t] || [])e(i);
        for (var r of this.je["*"] || [])r(t, i);
    }
}
class $cfd75c534a862da6$var$_o {
    constructor(t){
        this.Ne = new $cfd75c534a862da6$var$go, this.ze = (t, i)=>this.Ue(t, i) && this.qe(t, i) && this.Be(t, i), this.Ue = (t, i)=>null == i || !i.event || (null == t ? void 0 : t.event) === (null == i ? void 0 : i.event), this._instance = t, this.He = new Set, this.We = new Set;
    }
    init() {
        var t;
        if (!$cfd75c534a862da6$var$R(null == (t = this._instance) ? void 0 : t.Ge)) {
            var i;
            null == (i = this._instance) || i.Ge((t, i)=>{
                this.on(t, i);
            });
        }
    }
    register(t) {
        var i, e;
        if (!$cfd75c534a862da6$var$R(null == (i = this._instance) ? void 0 : i.Ge) && (t.forEach((t)=>{
            var i, e;
            null == (i = this.We) || i.add(t), null == (e = t.steps) || e.forEach((t)=>{
                var i;
                null == (i = this.He) || i.add((null == t ? void 0 : t.event) || "");
            });
        }), null != (e = this._instance) && e.autocapture)) {
            var r, s = new Set;
            t.forEach((t)=>{
                var i;
                null == (i = t.steps) || i.forEach((t)=>{
                    null != t && t.selector && s.add(null == t ? void 0 : t.selector);
                });
            }), null == (r = this._instance) || r.autocapture.setElementSelectors(s);
        }
    }
    on(t, i) {
        var e;
        null != i && 0 != t.length && (this.He.has(t) || this.He.has(null == i ? void 0 : i.event)) && this.We && (null == (e = this.We) ? void 0 : e.size) > 0 && this.We.forEach((t)=>{
            this.Je(i, t) && this.Ne.emit("actionCaptured", t.name);
        });
    }
    Ve(t) {
        this.onAction("actionCaptured", (i)=>t(i));
    }
    Je(t, i) {
        if (null == (null == i ? void 0 : i.steps)) return !1;
        for (var e of i.steps)if (this.ze(t, e)) return !0;
        return !1;
    }
    onAction(t, i) {
        return this.Ne.on(t, i);
    }
    qe(t, i) {
        if (null != i && i.url) {
            var e, r = null == t || null == (e = t.properties) ? void 0 : e.$current_url;
            if (!r || "string" != typeof r) return !1;
            if (!$cfd75c534a862da6$var$_o.Ke(r, null == i ? void 0 : i.url, (null == i ? void 0 : i.url_matching) || "contains")) return !1;
        }
        return !0;
    }
    static Ke(i, e, r) {
        switch(r){
            case "regex":
                return !!$cfd75c534a862da6$var$t && $cfd75c534a862da6$var$Ns(i, e);
            case "exact":
                return e === i;
            case "contains":
                var s = $cfd75c534a862da6$var$_o.Ye(e).replace(/_/g, ".").replace(/%/g, ".*");
                return $cfd75c534a862da6$var$Ns(i, s);
            default:
                return !1;
        }
    }
    static Ye(t) {
        return t.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
    }
    Be(t, i) {
        if ((null != i && i.href || null != i && i.tag_name || null != i && i.text) && !this.Xe(t).some((t)=>!(null != i && i.href && !$cfd75c534a862da6$var$_o.Ke(t.href || "", null == i ? void 0 : i.href, (null == i ? void 0 : i.href_matching) || "exact")) && (null == i || !i.tag_name || t.tag_name === (null == i ? void 0 : i.tag_name)) && !(null != i && i.text && !$cfd75c534a862da6$var$_o.Ke(t.text || "", null == i ? void 0 : i.text, (null == i ? void 0 : i.text_matching) || "exact") && !$cfd75c534a862da6$var$_o.Ke(t.$el_text || "", null == i ? void 0 : i.text, (null == i ? void 0 : i.text_matching) || "exact")))) return !1;
        if (null != i && i.selector) {
            var e, r = null == t || null == (e = t.properties) ? void 0 : e.$element_selectors;
            if (!r) return !1;
            if (!r.includes(null == i ? void 0 : i.selector)) return !1;
        }
        return !0;
    }
    Xe(t) {
        return null == (null == t ? void 0 : t.properties.$elements) ? [] : null == t ? void 0 : t.properties.$elements;
    }
}
var $cfd75c534a862da6$var$mo = $cfd75c534a862da6$var$z("[Surveys]");
var $cfd75c534a862da6$var$bo = "seenSurvey_", $cfd75c534a862da6$var$yo = (t, i)=>{
    var e = "$survey_" + i + "/" + t.id;
    return t.current_iteration && t.current_iteration > 0 && (e = "$survey_" + i + "/" + t.id + "/" + t.current_iteration), e;
};
class $cfd75c534a862da6$var$wo {
    constructor(t){
        this._instance = t, this.Qe = new Map, this.Ze = new Map;
    }
    register(t) {
        var i;
        $cfd75c534a862da6$var$R(null == (i = this._instance) ? void 0 : i.Ge) || (this.tr(t), this.ir(t));
    }
    ir(t) {
        var i = t.filter((t)=>{
            var i, e;
            return (null == (i = t.conditions) ? void 0 : i.actions) && (null == (e = t.conditions) || null == (e = e.actions) || null == (e = e.values) ? void 0 : e.length) > 0;
        });
        if (0 !== i.length) {
            if (null == this.er) {
                this.er = new $cfd75c534a862da6$var$_o(this._instance), this.er.init();
                this.er.Ve((t)=>{
                    this.onAction(t);
                });
            }
            i.forEach((t)=>{
                var i, e, r, s, n;
                t.conditions && null != (i = t.conditions) && i.actions && null != (e = t.conditions) && null != (e = e.actions) && e.values && (null == (r = t.conditions) || null == (r = r.actions) || null == (r = r.values) ? void 0 : r.length) > 0 && (null == (s = this.er) || s.register(t.conditions.actions.values), null == (n = t.conditions) || null == (n = n.actions) || null == (n = n.values) || n.forEach((i)=>{
                    if (i && i.name) {
                        var e = this.Ze.get(i.name);
                        e && e.push(t.id), this.Ze.set(i.name, e || [
                            t.id
                        ]);
                    }
                }));
            });
        }
    }
    tr(t) {
        var i;
        if (0 !== t.filter((t)=>{
            var i, e;
            return (null == (i = t.conditions) ? void 0 : i.events) && (null == (e = t.conditions) || null == (e = e.events) || null == (e = e.values) ? void 0 : e.length) > 0;
        }).length) null == (i = this._instance) || i.Ge((t, i)=>{
            this.onEvent(t, i);
        }), t.forEach((t)=>{
            var i;
            null == (i = t.conditions) || null == (i = i.events) || null == (i = i.values) || i.forEach((i)=>{
                if (i && i.name) {
                    var e = this.Qe.get(i.name);
                    e && e.push(t.id), this.Qe.set(i.name, e || [
                        t.id
                    ]);
                }
            });
        });
    }
    onEvent(t, i) {
        var e, r = (null == (e = this._instance) || null == (e = e.persistence) ? void 0 : e.props[$cfd75c534a862da6$var$Ft]) || [];
        if ("survey shown" === t && i && r.length > 0) {
            var s;
            $cfd75c534a862da6$var$mo.info("survey event matched, removing survey from activated surveys", {
                event: t,
                eventPayload: i,
                existingActivatedSurveys: r
            });
            var n = null == i || null == (s = i.properties) ? void 0 : s.$survey_id;
            if (n) {
                var o = r.indexOf(n);
                o >= 0 && (r.splice(o, 1), this.rr(r));
            }
        } else this.Qe.has(t) && ($cfd75c534a862da6$var$mo.info("survey event matched, updating activated surveys", {
            event: t,
            surveys: this.Qe.get(t)
        }), this.rr(r.concat(this.Qe.get(t) || [])));
    }
    onAction(t) {
        var i, e = (null == (i = this._instance) || null == (i = i.persistence) ? void 0 : i.props[$cfd75c534a862da6$var$Ft]) || [];
        this.Ze.has(t) && this.rr(e.concat(this.Ze.get(t) || []));
    }
    rr(t) {
        var i;
        null == (i = this._instance) || null == (i = i.persistence) || i.register({
            [$cfd75c534a862da6$var$Ft]: [
                ...new Set(t)
            ]
        });
    }
    getSurveys() {
        var t, i = null == (t = this._instance) || null == (t = t.persistence) ? void 0 : t.props[$cfd75c534a862da6$var$Ft];
        return i || [];
    }
    getEventToSurveys() {
        return this.Qe;
    }
    sr() {
        return this.er;
    }
}
class $cfd75c534a862da6$var$So {
    constructor(t){
        this.nr = null, this.ar = !1, this.lr = !1, this.ur = [], this._instance = t, this._surveyEventReceiver = null;
    }
    onRemoteConfig(t) {
        var i = t.surveys;
        if ($cfd75c534a862da6$var$F(i)) return $cfd75c534a862da6$var$mo.warn("Flags not loaded yet. Not loading surveys.");
        var e = $cfd75c534a862da6$var$x(i);
        this.hr = e ? i.length > 0 : i, $cfd75c534a862da6$var$mo.info("flags response received, hasSurveys: " + this.hr), this.hr && this.loadIfEnabled();
    }
    reset() {
        localStorage.removeItem("lastSeenSurveyDate");
        for(var t = [], i = 0; i < localStorage.length; i++){
            var e = localStorage.key(i);
            (null != e && e.startsWith($cfd75c534a862da6$var$bo) || null != e && e.startsWith("inProgressSurvey_")) && t.push(e);
        }
        t.forEach((t)=>localStorage.removeItem(t));
    }
    loadIfEnabled() {
        if (!this.nr) {
            if (this.lr) $cfd75c534a862da6$var$mo.info("Already initializing surveys, skipping...");
            else if (this._instance.config.disable_surveys) $cfd75c534a862da6$var$mo.info("Disabled. Not loading surveys.");
            else if (this.hr) {
                var t = null == $cfd75c534a862da6$var$v ? void 0 : $cfd75c534a862da6$var$v.__PosthogExtensions__;
                if (t) {
                    this.lr = !0;
                    try {
                        var i = t.generateSurveys;
                        if (i) return void this.dr(i);
                        var e = t.loadExternalDependency;
                        if (!e) return void this.vr("PostHog loadExternalDependency extension not found.");
                        e(this._instance, "surveys", (i)=>{
                            i || !t.generateSurveys ? this.vr("Could not load surveys script", i) : this.dr(t.generateSurveys);
                        });
                    } catch (t) {
                        throw this.vr("Error initializing surveys", t), t;
                    } finally{
                        this.lr = !1;
                    }
                } else $cfd75c534a862da6$var$mo.error("PostHog Extensions not found.");
            } else $cfd75c534a862da6$var$mo.info("No surveys to load.");
        }
    }
    dr(t) {
        this.nr = t(this._instance), this._surveyEventReceiver = new $cfd75c534a862da6$var$wo(this._instance), $cfd75c534a862da6$var$mo.info("Surveys loaded successfully"), this.cr({
            isLoaded: !0
        });
    }
    vr(t, i) {
        $cfd75c534a862da6$var$mo.error(t, i), this.cr({
            isLoaded: !1,
            error: t
        });
    }
    onSurveysLoaded(t) {
        return this.ur.push(t), this.nr && this.cr({
            isLoaded: !0
        }), ()=>{
            this.ur = this.ur.filter((i)=>i !== t);
        };
    }
    getSurveys(t, i) {
        if (void 0 === i && (i = !1), this._instance.config.disable_surveys) return $cfd75c534a862da6$var$mo.info("Disabled. Not loading surveys."), t([]);
        var e = this._instance.get_property($cfd75c534a862da6$var$Ct);
        if (e && !i) return t(e, {
            isLoaded: !0
        });
        if (this.ar) return t([], {
            isLoaded: !1,
            error: "Surveys are already being loaded"
        });
        try {
            this.ar = !0, this._instance.Ee({
                url: this._instance.requestRouter.endpointFor("api", "/api/surveys/?token=" + this._instance.config.token),
                method: "GET",
                timeout: this._instance.config.surveys_request_timeout_ms,
                callback: (i)=>{
                    var e;
                    this.ar = !1;
                    var r = i.statusCode;
                    if (200 !== r || !i.json) {
                        var s = "Surveys API could not be loaded, status: " + r;
                        return $cfd75c534a862da6$var$mo.error(s), t([], {
                            isLoaded: !1,
                            error: s
                        });
                    }
                    var n, o = i.json.surveys || [], a = o.filter((t)=>(function(t) {
                            return !(!t.start_date || t.end_date);
                        })(t) && (function(t) {
                            var i;
                            return !(null == (i = t.conditions) || null == (i = i.events) || null == (i = i.values) || !i.length);
                        }(t) || function(t) {
                            var i;
                            return !(null == (i = t.conditions) || null == (i = i.actions) || null == (i = i.values) || !i.length);
                        }(t)));
                    a.length > 0 && (null == (n = this._surveyEventReceiver) || n.register(a));
                    return null == (e = this._instance.persistence) || e.register({
                        [$cfd75c534a862da6$var$Ct]: o
                    }), t(o, {
                        isLoaded: !0
                    });
                }
            });
        } catch (t) {
            throw this.ar = !1, t;
        }
    }
    cr(t) {
        for (var i of this.ur)try {
            t.isLoaded ? this.getSurveys(i) : i([], t);
        } catch (t) {
            $cfd75c534a862da6$var$mo.error("Error in survey callback", t);
        }
    }
    getActiveMatchingSurveys(t, i) {
        if (void 0 === i && (i = !1), !$cfd75c534a862da6$var$F(this.nr)) return this.nr.getActiveMatchingSurveys(t, i);
        $cfd75c534a862da6$var$mo.warn("init was not called");
    }
    pr(t) {
        var i = null;
        return this.getSurveys((e)=>{
            var r;
            i = null !== (r = e.find((i)=>i.id === t)) && void 0 !== r ? r : null;
        }), i;
    }
    gr(t) {
        if ($cfd75c534a862da6$var$F(this.nr)) return {
            eligible: !1,
            reason: "SDK is not enabled or survey functionality is not yet loaded"
        };
        var i = "string" == typeof t ? this.pr(t) : t;
        return i ? this.nr.checkSurveyEligibility(i) : {
            eligible: !1,
            reason: "Survey not found"
        };
    }
    canRenderSurvey(t) {
        if ($cfd75c534a862da6$var$F(this.nr)) return $cfd75c534a862da6$var$mo.warn("init was not called"), {
            visible: !1,
            disabledReason: "SDK is not enabled or survey functionality is not yet loaded"
        };
        var i = this.gr(t);
        return {
            visible: i.eligible,
            disabledReason: i.reason
        };
    }
    canRenderSurveyAsync(t, i) {
        return $cfd75c534a862da6$var$F(this.nr) ? ($cfd75c534a862da6$var$mo.warn("init was not called"), Promise.resolve({
            visible: !1,
            disabledReason: "SDK is not enabled or survey functionality is not yet loaded"
        })) : new Promise((e)=>{
            this.getSurveys((i)=>{
                var r, s = null !== (r = i.find((i)=>i.id === t)) && void 0 !== r ? r : null;
                if (s) {
                    var n = this.gr(s);
                    e({
                        visible: n.eligible,
                        disabledReason: n.reason
                    });
                } else e({
                    visible: !1,
                    disabledReason: "Survey not found"
                });
            }, i);
        });
    }
    renderSurvey(t, i) {
        if ($cfd75c534a862da6$var$F(this.nr)) $cfd75c534a862da6$var$mo.warn("init was not called");
        else {
            var e = this.pr(t), r = null == $cfd75c534a862da6$var$o ? void 0 : $cfd75c534a862da6$var$o.querySelector(i);
            e ? r ? this.nr.renderSurvey(e, r) : $cfd75c534a862da6$var$mo.warn("Survey element not found") : $cfd75c534a862da6$var$mo.warn("Survey not found");
        }
    }
}
var $cfd75c534a862da6$export$87f1e68f1b904cbb = function(t) {
    return t.Button = "button", t.Tab = "tab", t.Selector = "selector", t;
}({}), $cfd75c534a862da6$export$8c0ce98316e43193 = function(t) {
    return t.TopLeft = "top_left", t.TopRight = "top_right", t.TopCenter = "top_center", t.MiddleLeft = "middle_left", t.MiddleRight = "middle_right", t.MiddleCenter = "middle_center", t.Left = "left", t.Center = "center", t.Right = "right", t.NextToTrigger = "next_to_trigger", t;
}({}), $cfd75c534a862da6$export$22779822dd24228f = function(t) {
    return t.Popover = "popover", t.API = "api", t.Widget = "widget", t;
}({}), $cfd75c534a862da6$export$9c2ac61661d417f8 = function(t) {
    return t.Open = "open", t.MultipleChoice = "multiple_choice", t.SingleChoice = "single_choice", t.Rating = "rating", t.Link = "link", t;
}({}), $cfd75c534a862da6$export$bbed2da3bd3bb001 = function(t) {
    return t.NextQuestion = "next_question", t.End = "end", t.ResponseBased = "response_based", t.SpecificQuestion = "specific_question", t;
}({}), $cfd75c534a862da6$export$407ee791fe918359 = function(t) {
    return t.Once = "once", t.Recurring = "recurring", t.Always = "always", t;
}({}), $cfd75c534a862da6$export$9d7ec1793ca1658e = function(t) {
    return t.SHOWN = "survey shown", t.DISMISSED = "survey dismissed", t.SENT = "survey sent", t;
}({}), $cfd75c534a862da6$export$fe4c9af525341543 = function(t) {
    return t.SURVEY_ID = "$survey_id", t.SURVEY_NAME = "$survey_name", t.SURVEY_RESPONSE = "$survey_response", t.SURVEY_ITERATION = "$survey_iteration", t.SURVEY_ITERATION_START_DATE = "$survey_iteration_start_date", t.SURVEY_PARTIALLY_COMPLETED = "$survey_partially_completed", t.SURVEY_SUBMISSION_ID = "$survey_submission_id", t.SURVEY_QUESTIONS = "$survey_questions", t.SURVEY_COMPLETED = "$survey_completed", t;
}({}), $cfd75c534a862da6$var$Mo = $cfd75c534a862da6$var$z("[RateLimiter]");
class $cfd75c534a862da6$var$Co {
    constructor(t){
        var i, e;
        this.serverLimits = {}, this.lastEventRateLimited = !1, this.checkForLimiting = (t)=>{
            var i = t.text;
            if (i && i.length) try {
                (JSON.parse(i).quota_limited || []).forEach((t)=>{
                    $cfd75c534a862da6$var$Mo.info((t || "events") + " is quota limited."), this.serverLimits[t] = (new Date).getTime() + 6e4;
                });
            } catch (t) {
                return void $cfd75c534a862da6$var$Mo.warn('could not rate limit - continuing. Error: "' + (null == t ? void 0 : t.message) + '"', {
                    text: i
                });
            }
        }, this.instance = t, this.captureEventsPerSecond = (null == (i = t.config.rate_limiting) ? void 0 : i.events_per_second) || 10, this.captureEventsBurstLimit = Math.max((null == (e = t.config.rate_limiting) ? void 0 : e.events_burst_limit) || 10 * this.captureEventsPerSecond, this.captureEventsPerSecond), this.lastEventRateLimited = this.clientRateLimitContext(!0).isRateLimited;
    }
    clientRateLimitContext(t) {
        var i, e, r;
        void 0 === t && (t = !1);
        var s = (new Date).getTime(), n = null !== (i = null == (e = this.instance.persistence) ? void 0 : e.get_property($cfd75c534a862da6$var$Lt)) && void 0 !== i ? i : {
            tokens: this.captureEventsBurstLimit,
            last: s
        };
        n.tokens += (s - n.last) / 1e3 * this.captureEventsPerSecond, n.last = s, n.tokens > this.captureEventsBurstLimit && (n.tokens = this.captureEventsBurstLimit);
        var o = n.tokens < 1;
        return o || t || (n.tokens = Math.max(0, n.tokens - 1)), !o || this.lastEventRateLimited || t || this.instance.capture("$$client_ingestion_warning", {
            $$client_ingestion_warning_message: "posthog-js client rate limited. Config is set to " + this.captureEventsPerSecond + " events per second and " + this.captureEventsBurstLimit + " events burst limit."
        }, {
            skip_client_rate_limiting: !0
        }), this.lastEventRateLimited = o, null == (r = this.instance.persistence) || r.set_property($cfd75c534a862da6$var$Lt, n), {
            isRateLimited: o,
            remainingTokens: n.tokens
        };
    }
    isServerRateLimited(t) {
        var i = this.serverLimits[t || "events"] || !1;
        return !1 !== i && (new Date).getTime() < i;
    }
}
var $cfd75c534a862da6$var$Fo = $cfd75c534a862da6$var$z("[RemoteConfig]");
class $cfd75c534a862da6$var$Oo {
    constructor(t){
        this._instance = t;
    }
    get remoteConfig() {
        var t;
        return null == (t = $cfd75c534a862da6$var$v._POSTHOG_REMOTE_CONFIG) || null == (t = t[this._instance.config.token]) ? void 0 : t.config;
    }
    _r(t) {
        var i, e;
        null != (i = $cfd75c534a862da6$var$v.__PosthogExtensions__) && i.loadExternalDependency ? null == (e = $cfd75c534a862da6$var$v.__PosthogExtensions__) || null == e.loadExternalDependency || e.loadExternalDependency(this._instance, "remote-config", ()=>t(this.remoteConfig)) : ($cfd75c534a862da6$var$Fo.error("PostHog Extensions not found. Cannot load remote config."), t());
    }
    mr(t) {
        this._instance.Ee({
            method: "GET",
            url: this._instance.requestRouter.endpointFor("assets", "/array/" + this._instance.config.token + "/config"),
            callback: (i)=>{
                t(i.json);
            }
        });
    }
    load() {
        try {
            if (this.remoteConfig) return $cfd75c534a862da6$var$Fo.info("Using preloaded remote config", this.remoteConfig), void this.Ie(this.remoteConfig);
            if (this._instance.I()) return void $cfd75c534a862da6$var$Fo.warn("Remote config is disabled. Falling back to local config.");
            this._r((t)=>{
                if (!t) return $cfd75c534a862da6$var$Fo.info("No config found after loading remote JS config. Falling back to JSON."), void this.mr((t)=>{
                    this.Ie(t);
                });
                this.Ie(t);
            });
        } catch (t) {
            $cfd75c534a862da6$var$Fo.error("Error loading remote config", t);
        }
    }
    Ie(t) {
        t ? this._instance.config.__preview_remote_config ? (this._instance.Ie(t), !1 !== t.hasFeatureFlags && this._instance.featureFlags.ensureFlagsLoaded()) : $cfd75c534a862da6$var$Fo.info("__preview_remote_config is disabled. Logging config instead", t) : $cfd75c534a862da6$var$Fo.error("Failed to fetch remote config from PostHog.");
    }
}
var $cfd75c534a862da6$var$Ao = 3e3;
class $cfd75c534a862da6$var$Do {
    constructor(t, i){
        this.br = !0, this.yr = [], this.wr = $cfd75c534a862da6$var$se((null == i ? void 0 : i.flush_interval_ms) || $cfd75c534a862da6$var$Ao, 250, 5e3, "flush interval", $cfd75c534a862da6$var$Ao), this.Sr = t;
    }
    enqueue(t) {
        this.yr.push(t), this.$r || this.kr();
    }
    unload() {
        this.Er();
        var t = this.yr.length > 0 ? this.Ir() : {}, i = Object.values(t);
        [
            ...i.filter((t)=>0 === t.url.indexOf("/e")),
            ...i.filter((t)=>0 !== t.url.indexOf("/e"))
        ].map((t)=>{
            this.Sr($cfd75c534a862da6$var$B({}, t, {
                transport: "sendBeacon"
            }));
        });
    }
    enable() {
        this.br = !1, this.kr();
    }
    kr() {
        var t = this;
        this.br || (this.$r = setTimeout(()=>{
            if (this.Er(), this.yr.length > 0) {
                var i = this.Ir(), e = function() {
                    var e = i[r], s = (new Date).getTime();
                    e.data && $cfd75c534a862da6$var$x(e.data) && $cfd75c534a862da6$var$J(e.data, (t)=>{
                        t.offset = Math.abs(t.timestamp - s), delete t.timestamp;
                    }), t.Sr(e);
                };
                for(var r in i)e();
            }
        }, this.wr));
    }
    Er() {
        clearTimeout(this.$r), this.$r = void 0;
    }
    Ir() {
        var t = {};
        return $cfd75c534a862da6$var$J(this.yr, (i)=>{
            var e, r = i, s = (r ? r.batchKey : null) || r.url;
            $cfd75c534a862da6$var$R(t[s]) && (t[s] = $cfd75c534a862da6$var$B({}, r, {
                data: []
            })), null == (e = t[s].data) || e.push(r.data);
        }), this.yr = [], t;
    }
}
var $cfd75c534a862da6$var$Lo = [
    "retriesPerformedSoFar"
];
class $cfd75c534a862da6$var$jo {
    constructor(i){
        this.Pr = !1, this.Rr = 3e3, this.yr = [], this._instance = i, this.yr = [], this.Tr = !0, !$cfd75c534a862da6$var$R($cfd75c534a862da6$var$t) && "onLine" in $cfd75c534a862da6$var$t.navigator && (this.Tr = $cfd75c534a862da6$var$t.navigator.onLine, $cfd75c534a862da6$var$st($cfd75c534a862da6$var$t, "online", ()=>{
            this.Tr = !0, this.se();
        }), $cfd75c534a862da6$var$st($cfd75c534a862da6$var$t, "offline", ()=>{
            this.Tr = !1;
        }));
    }
    get length() {
        return this.yr.length;
    }
    retriableRequest(t) {
        var { retriesPerformedSoFar: i } = t, e = $cfd75c534a862da6$var$H(t, $cfd75c534a862da6$var$Lo);
        $cfd75c534a862da6$var$O(i) && i > 0 && (e.url = $cfd75c534a862da6$var$As(e.url, {
            retry_count: i
        })), this._instance.Ee($cfd75c534a862da6$var$B({}, e, {
            callback: (t)=>{
                200 !== t.statusCode && (t.statusCode < 400 || t.statusCode >= 500) && (null != i ? i : 0) < 10 ? this.Mr($cfd75c534a862da6$var$B({
                    retriesPerformedSoFar: i
                }, e)) : null == e.callback || e.callback(t);
            }
        }));
    }
    Mr(t) {
        var i = t.retriesPerformedSoFar || 0;
        t.retriesPerformedSoFar = i + 1;
        var e = function(t) {
            var i = 3e3 * Math.pow(2, t), e = i / 2, r = Math.min(18e5, i), s = (Math.random() - .5) * (r - e);
            return Math.ceil(r + s);
        }(i), r = Date.now() + e;
        this.yr.push({
            retryAt: r,
            requestOptions: t
        });
        var s = "Enqueued failed request for retry in " + e;
        navigator.onLine || (s += " (Browser is offline)"), $cfd75c534a862da6$var$N.warn(s), this.Pr || (this.Pr = !0, this.Cr());
    }
    Cr() {
        this.Fr && clearTimeout(this.Fr), this.Fr = setTimeout(()=>{
            this.Tr && this.yr.length > 0 && this.se(), this.Cr();
        }, this.Rr);
    }
    se() {
        var t = Date.now(), i = [], e = this.yr.filter((e)=>e.retryAt < t || (i.push(e), !1));
        if (this.yr = i, e.length > 0) for (var { requestOptions: r } of e)this.retriableRequest(r);
    }
    unload() {
        for (var { requestOptions: t } of (this.Fr && (clearTimeout(this.Fr), this.Fr = void 0), this.yr))try {
            this._instance.Ee($cfd75c534a862da6$var$B({}, t, {
                transport: "sendBeacon"
            }));
        } catch (t) {
            $cfd75c534a862da6$var$N.error(t);
        }
        this.yr = [];
    }
}
class $cfd75c534a862da6$var$No {
    constructor(t){
        this.Or = ()=>{
            var t, i, e, r;
            this.Ar || (this.Ar = {});
            var s = this.scrollElement(), n = this.scrollY(), o = s ? Math.max(0, s.scrollHeight - s.clientHeight) : 0, a = n + ((null == s ? void 0 : s.clientHeight) || 0), l = (null == s ? void 0 : s.scrollHeight) || 0;
            this.Ar.lastScrollY = Math.ceil(n), this.Ar.maxScrollY = Math.max(n, null !== (t = this.Ar.maxScrollY) && void 0 !== t ? t : 0), this.Ar.maxScrollHeight = Math.max(o, null !== (i = this.Ar.maxScrollHeight) && void 0 !== i ? i : 0), this.Ar.lastContentY = a, this.Ar.maxContentY = Math.max(a, null !== (e = this.Ar.maxContentY) && void 0 !== e ? e : 0), this.Ar.maxContentHeight = Math.max(l, null !== (r = this.Ar.maxContentHeight) && void 0 !== r ? r : 0);
        }, this._instance = t;
    }
    getContext() {
        return this.Ar;
    }
    resetContext() {
        var t = this.Ar;
        return setTimeout(this.Or, 0), t;
    }
    startMeasuringScrollPosition() {
        $cfd75c534a862da6$var$st($cfd75c534a862da6$var$t, "scroll", this.Or, {
            capture: !0
        }), $cfd75c534a862da6$var$st($cfd75c534a862da6$var$t, "scrollend", this.Or, {
            capture: !0
        }), $cfd75c534a862da6$var$st($cfd75c534a862da6$var$t, "resize", this.Or);
    }
    scrollElement() {
        if (!this._instance.config.scroll_root_selector) return null == $cfd75c534a862da6$var$t ? void 0 : $cfd75c534a862da6$var$t.document.documentElement;
        var i = $cfd75c534a862da6$var$x(this._instance.config.scroll_root_selector) ? this._instance.config.scroll_root_selector : [
            this._instance.config.scroll_root_selector
        ];
        for (var e of i){
            var r = null == $cfd75c534a862da6$var$t ? void 0 : $cfd75c534a862da6$var$t.document.querySelector(e);
            if (r) return r;
        }
    }
    scrollY() {
        if (this._instance.config.scroll_root_selector) {
            var i = this.scrollElement();
            return i && i.scrollTop || 0;
        }
        return $cfd75c534a862da6$var$t && ($cfd75c534a862da6$var$t.scrollY || $cfd75c534a862da6$var$t.pageYOffset || $cfd75c534a862da6$var$t.document.documentElement.scrollTop) || 0;
    }
    scrollX() {
        if (this._instance.config.scroll_root_selector) {
            var i = this.scrollElement();
            return i && i.scrollLeft || 0;
        }
        return $cfd75c534a862da6$var$t && ($cfd75c534a862da6$var$t.scrollX || $cfd75c534a862da6$var$t.pageXOffset || $cfd75c534a862da6$var$t.document.documentElement.scrollLeft) || 0;
    }
}
var $cfd75c534a862da6$var$zo = (t)=>$cfd75c534a862da6$var$Xn(null == t ? void 0 : t.config.mask_personal_data_properties, null == t ? void 0 : t.config.custom_personal_data_properties);
class $cfd75c534a862da6$var$Uo {
    constructor(t, i, e, r){
        this.Dr = (t)=>{
            var i = this.Lr();
            if (!i || i.sessionId !== t) {
                var e = {
                    sessionId: t,
                    props: this.jr(this._instance)
                };
                this.Nr.register({
                    [$cfd75c534a862da6$var$Dt]: e
                });
            }
        }, this._instance = t, this.zr = i, this.Nr = e, this.jr = r || $cfd75c534a862da6$var$zo, this.zr.onSessionId(this.Dr);
    }
    Lr() {
        return this.Nr.props[$cfd75c534a862da6$var$Dt];
    }
    getSetOnceProps() {
        var t, i = null == (t = this.Lr()) ? void 0 : t.props;
        return i ? "r" in i ? $cfd75c534a862da6$var$Qn(i) : {
            $referring_domain: i.referringDomain,
            $pathname: i.initialPathName,
            utm_source: i.utm_source,
            utm_campaign: i.utm_campaign,
            utm_medium: i.utm_medium,
            utm_content: i.utm_content,
            utm_term: i.utm_term
        } : {};
    }
    getSessionProps() {
        var t = {};
        return $cfd75c534a862da6$var$J($cfd75c534a862da6$var$Z(this.getSetOnceProps()), (i, e)=>{
            "$current_url" === e && (e = "url"), t["$session_entry_" + $cfd75c534a862da6$var$y(e)] = i;
        }), t;
    }
}
var $cfd75c534a862da6$var$qo = $cfd75c534a862da6$var$z("[SessionId]");
class $cfd75c534a862da6$var$Bo {
    constructor(t, i, e){
        var r;
        if (this.Ur = [], !t.persistence) throw new Error("SessionIdManager requires a PostHogPersistence instance");
        if (t.config.__preview_experimental_cookieless_mode) throw new Error("SessionIdManager cannot be used with __preview_experimental_cookieless_mode");
        this.S = t.config, this.Nr = t.persistence, this.fi = void 0, this.Ct = void 0, this._sessionStartTimestamp = null, this._sessionActivityTimestamp = null, this.qr = i || $cfd75c534a862da6$var$ji, this.Br = e || $cfd75c534a862da6$var$ji;
        var s = this.S.persistence_name || this.S.token, n = this.S.session_idle_timeout_seconds || 1800;
        if (this._sessionTimeoutMs = 1e3 * $cfd75c534a862da6$var$se(n, 60, 36e3, "session_idle_timeout_seconds", 1800), t.register({
            $configured_session_timeout_ms: this._sessionTimeoutMs
        }), this.Hr(), this.Wr = "ph_" + s + "_window_id", this.Gr = "ph_" + s + "_primary_window_exists", this.Jr()) {
            var o = $cfd75c534a862da6$var$Xi.L(this.Wr), a = $cfd75c534a862da6$var$Xi.L(this.Gr);
            o && !a ? this.fi = o : $cfd75c534a862da6$var$Xi.N(this.Wr), $cfd75c534a862da6$var$Xi.j(this.Gr, !0);
        }
        if (null != (r = this.S.bootstrap) && r.sessionID) try {
            var l = ((t)=>{
                var i = t.replace(/-/g, "");
                if (32 !== i.length) throw new Error("Not a valid UUID");
                if ("7" !== i[12]) throw new Error("Not a UUIDv7");
                return parseInt(i.substring(0, 12), 16);
            })(this.S.bootstrap.sessionID);
            this.Vr(this.S.bootstrap.sessionID, (new Date).getTime(), l);
        } catch (t) {
            $cfd75c534a862da6$var$qo.error("Invalid sessionID in bootstrap", t);
        }
        this.Kr();
    }
    get sessionTimeoutMs() {
        return this._sessionTimeoutMs;
    }
    onSessionId(t) {
        return $cfd75c534a862da6$var$R(this.Ur) && (this.Ur = []), this.Ur.push(t), this.Ct && t(this.Ct, this.fi), ()=>{
            this.Ur = this.Ur.filter((i)=>i !== t);
        };
    }
    Jr() {
        return "memory" !== this.S.persistence && !this.Nr.Fe && $cfd75c534a862da6$var$Xi.O();
    }
    Yr(t) {
        t !== this.fi && (this.fi = t, this.Jr() && $cfd75c534a862da6$var$Xi.j(this.Wr, t));
    }
    Xr() {
        return this.fi ? this.fi : this.Jr() ? $cfd75c534a862da6$var$Xi.L(this.Wr) : null;
    }
    Vr(t, i, e) {
        t === this.Ct && i === this._sessionActivityTimestamp && e === this._sessionStartTimestamp || (this._sessionStartTimestamp = e, this._sessionActivityTimestamp = i, this.Ct = t, this.Nr.register({
            [$cfd75c534a862da6$var$$t]: [
                i,
                t,
                e
            ]
        }));
    }
    Qr() {
        if (this.Ct && this._sessionActivityTimestamp && this._sessionStartTimestamp) return [
            this._sessionActivityTimestamp,
            this.Ct,
            this._sessionStartTimestamp
        ];
        var t = this.Nr.props[$cfd75c534a862da6$var$$t];
        return $cfd75c534a862da6$var$x(t) && 2 === t.length && t.push(t[0]), t || [
            0,
            null,
            0
        ];
    }
    resetSessionId() {
        this.Vr(null, null, null);
    }
    Kr() {
        $cfd75c534a862da6$var$st($cfd75c534a862da6$var$t, "beforeunload", ()=>{
            this.Jr() && $cfd75c534a862da6$var$Xi.N(this.Gr);
        }, {
            capture: !1
        });
    }
    checkAndGetSessionAndWindowId(t, i) {
        if (void 0 === t && (t = !1), void 0 === i && (i = null), this.S.__preview_experimental_cookieless_mode) throw new Error("checkAndGetSessionAndWindowId should not be called in __preview_experimental_cookieless_mode");
        var e = i || (new Date).getTime(), [r, s, n] = this.Qr(), o = this.Xr(), a = $cfd75c534a862da6$var$O(n) && n > 0 && Math.abs(e - n) > 864e5, l = !1, u = !s, h = !t && Math.abs(e - r) > this.sessionTimeoutMs;
        u || h || a ? (s = this.qr(), o = this.Br(), $cfd75c534a862da6$var$qo.info("new session ID generated", {
            sessionId: s,
            windowId: o,
            changeReason: {
                noSessionId: u,
                activityTimeout: h,
                sessionPastMaximumLength: a
            }
        }), n = e, l = !0) : o || (o = this.Br(), l = !0);
        var d = 0 === r || !t || a ? e : r, v = 0 === n ? (new Date).getTime() : n;
        return this.Yr(o), this.Vr(s, d, v), t || this.Hr(), l && this.Ur.forEach((t)=>t(s, o, l ? {
                noSessionId: u,
                activityTimeout: h,
                sessionPastMaximumLength: a
            } : void 0)), {
            sessionId: s,
            windowId: o,
            sessionStartTimestamp: v,
            changeReason: l ? {
                noSessionId: u,
                activityTimeout: h,
                sessionPastMaximumLength: a
            } : void 0,
            lastActivityTimestamp: r
        };
    }
    Hr() {
        clearTimeout(this.Zr), this.Zr = setTimeout(()=>{
            this.resetSessionId();
        }, 1.1 * this.sessionTimeoutMs);
    }
}
var $cfd75c534a862da6$var$Ho = [
    "$set_once",
    "$set"
], $cfd75c534a862da6$var$Wo = $cfd75c534a862da6$var$z("[SiteApps]");
class $cfd75c534a862da6$var$Go {
    constructor(t){
        this._instance = t, this.ts = [], this.apps = {};
    }
    get isEnabled() {
        return !!this._instance.config.opt_in_site_apps;
    }
    es(t, i) {
        if (i) {
            var e = this.globalsForEvent(i);
            this.ts.push(e), this.ts.length > 1e3 && (this.ts = this.ts.slice(10));
        }
    }
    get siteAppLoaders() {
        var t;
        return null == (t = $cfd75c534a862da6$var$v._POSTHOG_REMOTE_CONFIG) || null == (t = t[this._instance.config.token]) ? void 0 : t.siteApps;
    }
    init() {
        if (this.isEnabled) {
            var t = this._instance.Ge(this.es.bind(this));
            this.rs = ()=>{
                t(), this.ts = [], this.rs = void 0;
            };
        }
    }
    globalsForEvent(t) {
        var i, e, r, s, n, o, a;
        if (!t) throw new Error("Event payload is required");
        var l = {}, u = this._instance.get_property("$groups") || [], h = this._instance.get_property("$stored_group_properties") || {};
        for (var [d, v] of Object.entries(h))l[d] = {
            id: u[d],
            type: d,
            properties: v
        };
        var { $set_once: c, $set: f } = t;
        return {
            event: $cfd75c534a862da6$var$B({}, $cfd75c534a862da6$var$H(t, $cfd75c534a862da6$var$Ho), {
                properties: $cfd75c534a862da6$var$B({}, t.properties, f ? {
                    $set: $cfd75c534a862da6$var$B({}, null !== (i = null == (e = t.properties) ? void 0 : e.$set) && void 0 !== i ? i : {}, f)
                } : {}, c ? {
                    $set_once: $cfd75c534a862da6$var$B({}, null !== (r = null == (s = t.properties) ? void 0 : s.$set_once) && void 0 !== r ? r : {}, c)
                } : {}),
                elements_chain: null !== (n = null == (o = t.properties) ? void 0 : o.$elements_chain) && void 0 !== n ? n : "",
                distinct_id: null == (a = t.properties) ? void 0 : a.distinct_id
            }),
            person: {
                properties: this._instance.get_property("$stored_person_properties")
            },
            groups: l
        };
    }
    setupSiteApp(t) {
        var i = this.apps[t.id], e = ()=>{
            var e;
            (!i.errored && this.ts.length && ($cfd75c534a862da6$var$Wo.info("Processing " + this.ts.length + " events for site app with id " + t.id), this.ts.forEach((t)=>null == i.processEvent ? void 0 : i.processEvent(t)), i.processedBuffer = !0), Object.values(this.apps).every((t)=>t.processedBuffer || t.errored)) && (null == (e = this.rs) || e.call(this));
        }, r = !1, s = (s)=>{
            i.errored = !s, i.loaded = !0, $cfd75c534a862da6$var$Wo.info("Site app with id " + t.id + " " + (s ? "loaded" : "errored")), r && e();
        };
        try {
            var { processEvent: n } = t.init({
                posthog: this._instance,
                callback: (t)=>{
                    s(t);
                }
            });
            n && (i.processEvent = n), r = !0;
        } catch (i) {
            $cfd75c534a862da6$var$Wo.error("Error while initializing PostHog app with config id " + t.id, i), s(!1);
        }
        if (r && i.loaded) try {
            e();
        } catch (e) {
            $cfd75c534a862da6$var$Wo.error("Error while processing buffered events PostHog app with config id " + t.id, e), i.errored = !0;
        }
    }
    ss() {
        var t = this.siteAppLoaders || [];
        for (var i of t)this.apps[i.id] = {
            id: i.id,
            loaded: !1,
            errored: !1,
            processedBuffer: !1
        };
        for (var e of t)this.setupSiteApp(e);
    }
    ns(t) {
        if (0 !== Object.keys(this.apps).length) {
            var i = this.globalsForEvent(t);
            for (var e of Object.values(this.apps))try {
                null == e.processEvent || e.processEvent(i);
            } catch (i) {
                $cfd75c534a862da6$var$Wo.error("Error while processing event " + t.event + " for site app " + e.id, i);
            }
        }
    }
    onRemoteConfig(t) {
        var i, e, r, s = this;
        if (null != (i = this.siteAppLoaders) && i.length) return this.isEnabled ? (this.ss(), void this._instance.on("eventCaptured", (t)=>this.ns(t))) : void $cfd75c534a862da6$var$Wo.error('PostHog site apps are disabled. Enable the "opt_in_site_apps" config to proceed.');
        if (null == (e = this.rs) || e.call(this), null != (r = t.siteApps) && r.length) {
            if (this.isEnabled) {
                var n = function(t) {
                    var i;
                    $cfd75c534a862da6$var$v["__$$ph_site_app_" + t] = s._instance, null == (i = $cfd75c534a862da6$var$v.__PosthogExtensions__) || null == i.loadSiteApp || i.loadSiteApp(s._instance, a, (i)=>{
                        if (i) return $cfd75c534a862da6$var$Wo.error("Error while initializing PostHog app with config id " + t, i);
                    });
                };
                for (var { id: o, url: a } of t.siteApps)n(o);
            } else $cfd75c534a862da6$var$Wo.error('PostHog site apps are disabled. Enable the "opt_in_site_apps" config to proceed.');
        }
    }
}
var $cfd75c534a862da6$var$Jo = [
    "amazonbot",
    "amazonproductbot",
    "app.hypefactors.com",
    "applebot",
    "archive.org_bot",
    "awariobot",
    "backlinksextendedbot",
    "baiduspider",
    "bingbot",
    "bingpreview",
    "chrome-lighthouse",
    "dataforseobot",
    "deepscan",
    "duckduckbot",
    "facebookexternal",
    "facebookcatalog",
    "http://yandex.com/bots",
    "hubspot",
    "ia_archiver",
    "leikibot",
    "linkedinbot",
    "meta-externalagent",
    "mj12bot",
    "msnbot",
    "nessus",
    "petalbot",
    "pinterest",
    "prerender",
    "rogerbot",
    "screaming frog",
    "sebot-wa",
    "sitebulb",
    "slackbot",
    "slurp",
    "trendictionbot",
    "turnitin",
    "twitterbot",
    "vercelbot",
    "yahoo! slurp",
    "yandexbot",
    "zoombot",
    "bot.htm",
    "bot.php",
    "(bot;",
    "bot/",
    "crawler",
    "ahrefsbot",
    "ahrefssiteaudit",
    "semrushbot",
    "siteauditbot",
    "splitsignalbot",
    "gptbot",
    "oai-searchbot",
    "chatgpt-user",
    "perplexitybot",
    "better uptime bot",
    "sentryuptimebot",
    "uptimerobot",
    "headlesschrome",
    "cypress",
    "google-hoteladsverifier",
    "adsbot-google",
    "apis-google",
    "duplexweb-google",
    "feedfetcher-google",
    "google favicon",
    "google web preview",
    "google-read-aloud",
    "googlebot",
    "googleother",
    "google-cloudvertexbot",
    "googleweblight",
    "mediapartners-google",
    "storebot-google",
    "google-inspectiontool",
    "bytespider"
], $cfd75c534a862da6$var$Vo = function(t, i) {
    if (!t) return !1;
    var e = t.toLowerCase();
    return $cfd75c534a862da6$var$Jo.concat(i || []).some((t)=>{
        var i = t.toLowerCase();
        return -1 !== e.indexOf(i);
    });
}, $cfd75c534a862da6$var$Ko = function(t, i) {
    if (!t) return !1;
    var e = t.userAgent;
    if (e && $cfd75c534a862da6$var$Vo(e, i)) return !0;
    try {
        var r = null == t ? void 0 : t.userAgentData;
        if (null != r && r.brands && r.brands.some((t)=>$cfd75c534a862da6$var$Vo(null == t ? void 0 : t.brand, i))) return !0;
    } catch (t) {}
    return !!t.webdriver;
}, $cfd75c534a862da6$var$Yo = function(t) {
    return t.US = "us", t.EU = "eu", t.CUSTOM = "custom", t;
}({}), $cfd75c534a862da6$var$Xo = "i.posthog.com";
class $cfd75c534a862da6$var$Qo {
    constructor(t){
        this.os = {}, this.instance = t;
    }
    get apiHost() {
        var t = this.instance.config.api_host.trim().replace(/\/$/, "");
        return "https://app.posthog.com" === t ? "https://us.i.posthog.com" : t;
    }
    get uiHost() {
        var t, i = null == (t = this.instance.config.ui_host) ? void 0 : t.replace(/\/$/, "");
        return i || (i = this.apiHost.replace("." + $cfd75c534a862da6$var$Xo, ".posthog.com")), "https://app.posthog.com" === i ? "https://us.posthog.com" : i;
    }
    get region() {
        return this.os[this.apiHost] || (/https:\/\/(app|us|us-assets)(\.i)?\.posthog\.com/i.test(this.apiHost) ? this.os[this.apiHost] = $cfd75c534a862da6$var$Yo.US : /https:\/\/(eu|eu-assets)(\.i)?\.posthog\.com/i.test(this.apiHost) ? this.os[this.apiHost] = $cfd75c534a862da6$var$Yo.EU : this.os[this.apiHost] = $cfd75c534a862da6$var$Yo.CUSTOM), this.os[this.apiHost];
    }
    endpointFor(t, i) {
        if (void 0 === i && (i = ""), i && (i = "/" === i[0] ? i : "/" + i), "ui" === t) return this.uiHost + i;
        if (this.region === $cfd75c534a862da6$var$Yo.CUSTOM) return this.apiHost + i;
        var e = $cfd75c534a862da6$var$Xo + i;
        switch(t){
            case "assets":
                return "https://" + this.region + "-assets." + e;
            case "api":
                return "https://" + this.region + "." + e;
        }
    }
}
var $cfd75c534a862da6$var$Zo = {
    icontains: (i, e)=>!!$cfd75c534a862da6$var$t && e.href.toLowerCase().indexOf(i.toLowerCase()) > -1,
    not_icontains: (i, e)=>!!$cfd75c534a862da6$var$t && -1 === e.href.toLowerCase().indexOf(i.toLowerCase()),
    regex: (i, e)=>!!$cfd75c534a862da6$var$t && $cfd75c534a862da6$var$Ns(e.href, i),
    not_regex: (i, e)=>!!$cfd75c534a862da6$var$t && !$cfd75c534a862da6$var$Ns(e.href, i),
    exact: (t, i)=>i.href === t,
    is_not: (t, i)=>i.href !== t
};
class $cfd75c534a862da6$var$ta {
    constructor(t){
        var i = this;
        this.getWebExperimentsAndEvaluateDisplayLogic = function(t) {
            void 0 === t && (t = !1), i.getWebExperiments((t)=>{
                $cfd75c534a862da6$var$ta.ls("retrieved web experiments from the server"), i.us = new Map, t.forEach((t)=>{
                    if (t.feature_flag_key) {
                        var e;
                        if (i.us) $cfd75c534a862da6$var$ta.ls("setting flag key ", t.feature_flag_key, " to web experiment ", t), null == (e = i.us) || e.set(t.feature_flag_key, t);
                        var r = i._instance.getFeatureFlag(t.feature_flag_key);
                        $cfd75c534a862da6$var$T(r) && t.variants[r] && i.hs(t.name, r, t.variants[r].transforms);
                    } else if (t.variants) for(var s in t.variants){
                        var n = t.variants[s];
                        $cfd75c534a862da6$var$ta.ds(n) && i.hs(t.name, s, n.transforms);
                    }
                });
            }, t);
        }, this._instance = t, this._instance.onFeatureFlags((t)=>{
            this.onFeatureFlags(t);
        });
    }
    onFeatureFlags(t) {
        if (this._is_bot()) $cfd75c534a862da6$var$ta.ls("Refusing to render web experiment since the viewer is a likely bot");
        else if (!this._instance.config.disable_web_experiments) {
            if ($cfd75c534a862da6$var$F(this.us)) return this.us = new Map, this.loadIfEnabled(), void this.previewWebExperiment();
            $cfd75c534a862da6$var$ta.ls("applying feature flags", t), t.forEach((t)=>{
                var i;
                if (this.us && null != (i = this.us) && i.has(t)) {
                    var e, r = this._instance.getFeatureFlag(t), s = null == (e = this.us) ? void 0 : e.get(t);
                    r && null != s && s.variants[r] && this.hs(s.name, r, s.variants[r].transforms);
                }
            });
        }
    }
    previewWebExperiment() {
        var t = $cfd75c534a862da6$var$ta.getWindowLocation();
        if (null != t && t.search) {
            var i = $cfd75c534a862da6$var$$i(null == t ? void 0 : t.search, "__experiment_id"), e = $cfd75c534a862da6$var$$i(null == t ? void 0 : t.search, "__experiment_variant");
            i && e && ($cfd75c534a862da6$var$ta.ls("previewing web experiments " + i + " && " + e), this.getWebExperiments((t)=>{
                this.vs(parseInt(i), e, t);
            }, !1, !0));
        }
    }
    loadIfEnabled() {
        this._instance.config.disable_web_experiments || this.getWebExperimentsAndEvaluateDisplayLogic();
    }
    getWebExperiments(t, i, e) {
        if (this._instance.config.disable_web_experiments && !e) return t([]);
        var r = this._instance.get_property("$web_experiments");
        if (r && !i) return t(r);
        this._instance.Ee({
            url: this._instance.requestRouter.endpointFor("api", "/api/web_experiments/?token=" + this._instance.config.token),
            method: "GET",
            callback: (i)=>{
                if (200 !== i.statusCode || !i.json) return t([]);
                var e = i.json.experiments || [];
                return t(e);
            }
        });
    }
    vs(t, i, e) {
        var r = e.filter((i)=>i.id === t);
        r && r.length > 0 && ($cfd75c534a862da6$var$ta.ls("Previewing web experiment [" + r[0].name + "] with variant [" + i + "]"), this.hs(r[0].name, i, r[0].variants[i].transforms));
    }
    static ds(t) {
        return !$cfd75c534a862da6$var$F(t.conditions) && $cfd75c534a862da6$var$ta.cs(t) && $cfd75c534a862da6$var$ta.fs(t);
    }
    static cs(t) {
        var i;
        if ($cfd75c534a862da6$var$F(t.conditions) || $cfd75c534a862da6$var$F(null == (i = t.conditions) ? void 0 : i.url)) return !0;
        var e, r, s, n = $cfd75c534a862da6$var$ta.getWindowLocation();
        return !!n && (null == (e = t.conditions) || !e.url || $cfd75c534a862da6$var$Zo[null !== (r = null == (s = t.conditions) ? void 0 : s.urlMatchType) && void 0 !== r ? r : "icontains"](t.conditions.url, n));
    }
    static getWindowLocation() {
        return null == $cfd75c534a862da6$var$t ? void 0 : $cfd75c534a862da6$var$t.location;
    }
    static fs(t) {
        var i;
        if ($cfd75c534a862da6$var$F(t.conditions) || $cfd75c534a862da6$var$F(null == (i = t.conditions) ? void 0 : i.utm)) return !0;
        var e = $cfd75c534a862da6$var$Gn();
        if (e.utm_source) {
            var r, s, n, o, a, l, u, h, d = null == (r = t.conditions) || null == (r = r.utm) || !r.utm_campaign || (null == (s = t.conditions) || null == (s = s.utm) ? void 0 : s.utm_campaign) == e.utm_campaign, v = null == (n = t.conditions) || null == (n = n.utm) || !n.utm_source || (null == (o = t.conditions) || null == (o = o.utm) ? void 0 : o.utm_source) == e.utm_source, c = null == (a = t.conditions) || null == (a = a.utm) || !a.utm_medium || (null == (l = t.conditions) || null == (l = l.utm) ? void 0 : l.utm_medium) == e.utm_medium, f = null == (u = t.conditions) || null == (u = u.utm) || !u.utm_term || (null == (h = t.conditions) || null == (h = h.utm) ? void 0 : h.utm_term) == e.utm_term;
            return d && c && f && v;
        }
        return !1;
    }
    static ls(t) {
        for(var i = arguments.length, e = new Array(i > 1 ? i - 1 : 0), r = 1; r < i; r++)e[r - 1] = arguments[r];
        $cfd75c534a862da6$var$N.info("[WebExperiments] " + t, e);
    }
    hs(t, i, e) {
        this._is_bot() ? $cfd75c534a862da6$var$ta.ls("Refusing to render web experiment since the viewer is a likely bot") : "control" !== i ? e.forEach((e)=>{
            if (e.selector) {
                var r;
                $cfd75c534a862da6$var$ta.ls("applying transform of variant " + i + " for experiment " + t + " ", e);
                var s = null == (r = document) ? void 0 : r.querySelectorAll(e.selector);
                null == s || s.forEach((t)=>{
                    var i = t;
                    e.html && (i.innerHTML = e.html), e.css && i.setAttribute("style", e.css);
                });
            }
        }) : $cfd75c534a862da6$var$ta.ls("Control variants leave the page unmodified.");
    }
    _is_bot() {
        return $cfd75c534a862da6$var$n && this._instance ? $cfd75c534a862da6$var$Ko($cfd75c534a862da6$var$n, this._instance.config.custom_blocked_useragents) : void 0;
    }
}
var $cfd75c534a862da6$var$ia = {}, $cfd75c534a862da6$var$ea = ()=>{}, $cfd75c534a862da6$var$ra = "posthog", $cfd75c534a862da6$var$sa = !$cfd75c534a862da6$var$Fs && -1 === (null == $cfd75c534a862da6$var$d ? void 0 : $cfd75c534a862da6$var$d.indexOf("MSIE")) && -1 === (null == $cfd75c534a862da6$var$d ? void 0 : $cfd75c534a862da6$var$d.indexOf("Mozilla")), $cfd75c534a862da6$var$na = (i)=>{
    var e;
    return {
        api_host: "https://us.i.posthog.com",
        ui_host: null,
        token: "",
        autocapture: !0,
        rageclick: !0,
        cross_subdomain_cookie: $cfd75c534a862da6$var$et(null == $cfd75c534a862da6$var$o ? void 0 : $cfd75c534a862da6$var$o.location),
        persistence: "localStorage+cookie",
        persistence_name: "",
        loaded: $cfd75c534a862da6$var$ea,
        save_campaign_params: !0,
        custom_campaign_params: [],
        custom_blocked_useragents: [],
        save_referrer: !0,
        capture_pageview: "2025-05-24" !== i || "history_change",
        capture_pageleave: "if_capture_pageview",
        defaults: null != i ? i : "unset",
        debug: $cfd75c534a862da6$var$a && $cfd75c534a862da6$var$T(null == $cfd75c534a862da6$var$a ? void 0 : $cfd75c534a862da6$var$a.search) && -1 !== $cfd75c534a862da6$var$a.search.indexOf("__posthog_debug=true") || !1,
        cookie_expiration: 365,
        upgrade: !1,
        disable_session_recording: !1,
        disable_persistence: !1,
        disable_web_experiments: !0,
        disable_surveys: !1,
        disable_external_dependency_loading: !1,
        enable_recording_console_log: void 0,
        secure_cookie: "https:" === (null == $cfd75c534a862da6$var$t || null == (e = $cfd75c534a862da6$var$t.location) ? void 0 : e.protocol),
        ip: !0,
        opt_out_capturing_by_default: !1,
        opt_out_persistence_by_default: !1,
        opt_out_useragent_filter: !1,
        opt_out_capturing_persistence_type: "localStorage",
        opt_out_capturing_cookie_prefix: null,
        opt_in_site_apps: !1,
        property_denylist: [],
        respect_dnt: !1,
        sanitize_properties: null,
        request_headers: {},
        request_batching: !0,
        properties_string_max_length: 65535,
        session_recording: {},
        mask_all_element_attributes: !1,
        mask_all_text: !1,
        mask_personal_data_properties: !1,
        custom_personal_data_properties: [],
        advanced_disable_flags: !1,
        advanced_disable_decide: !1,
        advanced_disable_feature_flags: !1,
        advanced_disable_feature_flags_on_first_load: !1,
        advanced_only_evaluate_survey_feature_flags: !1,
        advanced_disable_toolbar_metrics: !1,
        feature_flag_request_timeout_ms: 3e3,
        surveys_request_timeout_ms: 1e4,
        on_request_error: (t)=>{
            var i = "Bad HTTP status: " + t.statusCode + " " + t.text;
            $cfd75c534a862da6$var$N.error(i);
        },
        get_device_id: (t)=>t,
        capture_performance: void 0,
        name: "posthog",
        bootstrap: {},
        disable_compression: !1,
        session_idle_timeout_seconds: 1800,
        person_profiles: "identified_only",
        before_send: void 0,
        request_queue_config: {
            flush_interval_ms: $cfd75c534a862da6$var$Ao
        },
        error_tracking: {},
        _onCapture: $cfd75c534a862da6$var$ea
    };
}, $cfd75c534a862da6$var$oa = (t)=>{
    var i = {};
    $cfd75c534a862da6$var$R(t.process_person) || (i.person_profiles = t.process_person), $cfd75c534a862da6$var$R(t.xhr_headers) || (i.request_headers = t.xhr_headers), $cfd75c534a862da6$var$R(t.cookie_name) || (i.persistence_name = t.cookie_name), $cfd75c534a862da6$var$R(t.disable_cookie) || (i.disable_persistence = t.disable_cookie), $cfd75c534a862da6$var$R(t.store_google) || (i.save_campaign_params = t.store_google), $cfd75c534a862da6$var$R(t.verbose) || (i.debug = t.verbose);
    var e = $cfd75c534a862da6$var$V({}, i, t);
    return $cfd75c534a862da6$var$x(t.property_blacklist) && ($cfd75c534a862da6$var$R(t.property_denylist) ? e.property_denylist = t.property_blacklist : $cfd75c534a862da6$var$x(t.property_denylist) ? e.property_denylist = [
        ...t.property_blacklist,
        ...t.property_denylist
    ] : $cfd75c534a862da6$var$N.error("Invalid value for property_denylist config: " + t.property_denylist)), e;
};
class $cfd75c534a862da6$var$aa {
    constructor(){
        this.__forceAllowLocalhost = !1;
    }
    get ps() {
        return this.__forceAllowLocalhost;
    }
    set ps(t) {
        $cfd75c534a862da6$var$N.error("WebPerformanceObserver is deprecated and has no impact on network capture. Use `_forceAllowLocalhostNetworkCapture` on `posthog.sessionRecording`"), this.__forceAllowLocalhost = t;
    }
}
class $cfd75c534a862da6$export$a9d6b9cbf49b8241 {
    get decideEndpointWasHit() {
        var t, i;
        return null !== (t = null == (i = this.featureFlags) ? void 0 : i.hasLoadedFlags) && void 0 !== t && t;
    }
    get flagsEndpointWasHit() {
        var t, i;
        return null !== (t = null == (i = this.featureFlags) ? void 0 : i.hasLoadedFlags) && void 0 !== t && t;
    }
    constructor(){
        this.webPerformance = new $cfd75c534a862da6$var$aa, this.gs = !1, this.version = $cfd75c534a862da6$var$c.LIB_VERSION, this._s = new $cfd75c534a862da6$var$go, this._calculate_event_properties = this.calculateEventProperties.bind(this), this.config = $cfd75c534a862da6$var$na(), this.SentryIntegration = $cfd75c534a862da6$var$_s, this.sentryIntegration = (t)=>(function(t, i) {
                var e = $cfd75c534a862da6$var$gs(t, i);
                return {
                    name: $cfd75c534a862da6$var$ps,
                    processEvent: (t)=>e(t)
                };
            })(this, t), this.__request_queue = [], this.__loaded = !1, this.analyticsDefaultEndpoint = "/e/", this.bs = !1, this.ys = null, this.ws = null, this.Ss = null, this.featureFlags = new $cfd75c534a862da6$var$co(this), this.toolbar = new $cfd75c534a862da6$var$Ss(this), this.scrollManager = new $cfd75c534a862da6$var$No(this), this.pageViewManager = new $cfd75c534a862da6$var$Ms(this), this.surveys = new $cfd75c534a862da6$var$So(this), this.experiments = new $cfd75c534a862da6$var$ta(this), this.exceptions = new $cfd75c534a862da6$var$Hs(this), this.rateLimiter = new $cfd75c534a862da6$var$Co(this), this.requestRouter = new $cfd75c534a862da6$var$Qo(this), this.consent = new $cfd75c534a862da6$var$Zi(this), this.people = {
            set: (t, i, e)=>{
                var r = $cfd75c534a862da6$var$T(t) ? {
                    [t]: i
                } : t;
                this.setPersonProperties(r), null == e || e({});
            },
            set_once: (t, i, e)=>{
                var r = $cfd75c534a862da6$var$T(t) ? {
                    [t]: i
                } : t;
                this.setPersonProperties(void 0, r), null == e || e({});
            }
        }, this.on("eventCaptured", (t)=>$cfd75c534a862da6$var$N.info('send "' + (null == t ? void 0 : t.event) + '"', t));
    }
    init(t, i, e) {
        if (e && e !== $cfd75c534a862da6$var$ra) {
            var r, s = null !== (r = $cfd75c534a862da6$var$ia[e]) && void 0 !== r ? r : new $cfd75c534a862da6$export$a9d6b9cbf49b8241;
            return s._init(t, i, e), $cfd75c534a862da6$var$ia[e] = s, $cfd75c534a862da6$var$ia[$cfd75c534a862da6$var$ra][e] = s, s;
        }
        return this._init(t, i, e);
    }
    _init(i, e, r) {
        var s, n;
        if (void 0 === e && (e = {}), $cfd75c534a862da6$var$R(i) || $cfd75c534a862da6$var$M(i)) return $cfd75c534a862da6$var$N.critical("PostHog was initialized without a token. This likely indicates a misconfiguration. Please check the first argument passed to posthog.init()"), this;
        if (this.__loaded) return $cfd75c534a862da6$var$N.warn("You have already initialized PostHog! Re-initializing is a no-op"), this;
        this.__loaded = !0, this.config = {}, this.$s = e, this.ks = [], e.person_profiles && (this.ws = e.person_profiles), this.set_config($cfd75c534a862da6$var$V({}, $cfd75c534a862da6$var$na(e.defaults), $cfd75c534a862da6$var$oa(e), {
            name: r,
            token: i
        })), this.config.on_xhr_error && $cfd75c534a862da6$var$N.error("on_xhr_error is deprecated. Use on_request_error instead"), this.compression = e.disable_compression ? void 0 : $cfd75c534a862da6$export$6a00d17b5aff0af.GZipJS, this.persistence = new $cfd75c534a862da6$var$po(this.config), this.sessionPersistence = "sessionStorage" === this.config.persistence || "memory" === this.config.persistence ? this.persistence : new $cfd75c534a862da6$var$po($cfd75c534a862da6$var$B({}, this.config, {
            persistence: "sessionStorage"
        }));
        var o = $cfd75c534a862da6$var$B({}, this.persistence.props), a = $cfd75c534a862da6$var$B({}, this.sessionPersistence.props);
        if (this.register({
            $initialization_time: (new Date).toISOString()
        }), this.xs = new $cfd75c534a862da6$var$Do((t)=>this.Es(t), this.config.request_queue_config), this.Is = new $cfd75c534a862da6$var$jo(this), this.__request_queue = [], this.config.__preview_experimental_cookieless_mode || (this.sessionManager = new $cfd75c534a862da6$var$Bo(this), this.sessionPropsManager = new $cfd75c534a862da6$var$Uo(this, this.sessionManager, this.persistence)), new $cfd75c534a862da6$var$ks(this).startIfEnabledOrStop(), this.siteApps = new $cfd75c534a862da6$var$Go(this), null == (s = this.siteApps) || s.init(), this.config.__preview_experimental_cookieless_mode || (this.sessionRecording = new $cfd75c534a862da6$var$vs(this), this.sessionRecording.startIfEnabledOrStop()), this.config.disable_scroll_properties || this.scrollManager.startMeasuringScrollPosition(), this.autocapture = new $cfd75c534a862da6$var$Mi(this), this.autocapture.startIfEnabled(), this.surveys.loadIfEnabled(), this.heatmaps = new $cfd75c534a862da6$var$Ts(this), this.heatmaps.startIfEnabled(), this.webVitalsAutocapture = new $cfd75c534a862da6$var$Is(this), this.exceptionObserver = new $cfd75c534a862da6$var$ae(this), this.exceptionObserver.startIfEnabled(), this.deadClicksAutocapture = new $cfd75c534a862da6$var$re(this, $cfd75c534a862da6$var$ee), this.deadClicksAutocapture.startIfEnabled(), this.historyAutocapture = new $cfd75c534a862da6$var$Ne(this), this.historyAutocapture.startIfEnabled(), $cfd75c534a862da6$var$c.DEBUG = $cfd75c534a862da6$var$c.DEBUG || this.config.debug, $cfd75c534a862da6$var$c.DEBUG && $cfd75c534a862da6$var$N.info("Starting in debug mode", {
            this: this,
            config: e,
            thisC: $cfd75c534a862da6$var$B({}, this.config),
            p: o,
            s: a
        }), this.Ps(), void 0 !== (null == (n = e.bootstrap) ? void 0 : n.distinctID)) {
            var l, u, h = this.config.get_device_id($cfd75c534a862da6$var$ji()), d = null != (l = e.bootstrap) && l.isIdentifiedID ? h : e.bootstrap.distinctID;
            this.persistence.set_property($cfd75c534a862da6$var$At, null != (u = e.bootstrap) && u.isIdentifiedID ? "identified" : "anonymous"), this.register({
                distinct_id: e.bootstrap.distinctID,
                $device_id: d
            });
        }
        if (this.Rs()) {
            var v, f, p = Object.keys((null == (v = e.bootstrap) ? void 0 : v.featureFlags) || {}).filter((t)=>{
                var i;
                return !(null == (i = e.bootstrap) || null == (i = i.featureFlags) || !i[t]);
            }).reduce((t, i)=>{
                var r;
                return t[i] = (null == (r = e.bootstrap) || null == (r = r.featureFlags) ? void 0 : r[i]) || !1, t;
            }, {}), _ = Object.keys((null == (f = e.bootstrap) ? void 0 : f.featureFlagPayloads) || {}).filter((t)=>p[t]).reduce((t, i)=>{
                var r, s;
                null != (r = e.bootstrap) && null != (r = r.featureFlagPayloads) && r[i] && (t[i] = null == (s = e.bootstrap) || null == (s = s.featureFlagPayloads) ? void 0 : s[i]);
                return t;
            }, {});
            this.featureFlags.receivedFeatureFlags({
                featureFlags: p,
                featureFlagPayloads: _
            });
        }
        if (this.config.__preview_experimental_cookieless_mode) this.register_once({
            distinct_id: $cfd75c534a862da6$var$Bt,
            $device_id: null
        }, "");
        else if (!this.get_distinct_id()) {
            var m = this.config.get_device_id($cfd75c534a862da6$var$ji());
            this.register_once({
                distinct_id: m,
                $device_id: m
            }, ""), this.persistence.set_property($cfd75c534a862da6$var$At, "anonymous");
        }
        return $cfd75c534a862da6$var$st($cfd75c534a862da6$var$t, "onpagehide" in self ? "pagehide" : "unload", this._handle_unload.bind(this), {
            passive: !1
        }), this.toolbar.maybeLoadToolbar(), e.segment ? $cfd75c534a862da6$var$fs(this, ()=>this.Ts()) : this.Ts(), $cfd75c534a862da6$var$E(this.config._onCapture) && this.config._onCapture !== $cfd75c534a862da6$var$ea && ($cfd75c534a862da6$var$N.warn("onCapture is deprecated. Please use `before_send` instead"), this.on("eventCaptured", (t)=>this.config._onCapture(t.event, t))), this;
    }
    Ie(t) {
        var i, e, r, s, n, a, l, u;
        if (!$cfd75c534a862da6$var$o || !$cfd75c534a862da6$var$o.body) return $cfd75c534a862da6$var$N.info("document not ready yet, trying again in 500 milliseconds..."), void setTimeout(()=>{
            this.Ie(t);
        }, 500);
        this.compression = void 0, t.supportedCompression && !this.config.disable_compression && (this.compression = $cfd75c534a862da6$var$m(t.supportedCompression, $cfd75c534a862da6$export$6a00d17b5aff0af.GZipJS) ? $cfd75c534a862da6$export$6a00d17b5aff0af.GZipJS : $cfd75c534a862da6$var$m(t.supportedCompression, $cfd75c534a862da6$export$6a00d17b5aff0af.Base64) ? $cfd75c534a862da6$export$6a00d17b5aff0af.Base64 : void 0), null != (i = t.analytics) && i.endpoint && (this.analyticsDefaultEndpoint = t.analytics.endpoint), this.set_config({
            person_profiles: this.ws ? this.ws : "identified_only"
        }), null == (e = this.siteApps) || e.onRemoteConfig(t), null == (r = this.sessionRecording) || r.onRemoteConfig(t), null == (s = this.autocapture) || s.onRemoteConfig(t), null == (n = this.heatmaps) || n.onRemoteConfig(t), this.surveys.onRemoteConfig(t), null == (a = this.webVitalsAutocapture) || a.onRemoteConfig(t), null == (l = this.exceptionObserver) || l.onRemoteConfig(t), this.exceptions.onRemoteConfig(t), null == (u = this.deadClicksAutocapture) || u.onRemoteConfig(t);
    }
    Ts() {
        try {
            this.config.loaded(this);
        } catch (t) {
            $cfd75c534a862da6$var$N.critical("`loaded` function failed", t);
        }
        this.Ms(), this.config.capture_pageview && setTimeout(()=>{
            this.consent.isOptedIn() && this.Cs();
        }, 1), new $cfd75c534a862da6$var$Oo(this).load(), this.featureFlags.flags();
    }
    Ms() {
        var t;
        this.has_opted_out_capturing() || this.config.request_batching && (null == (t = this.xs) || t.enable());
    }
    _dom_loaded() {
        this.has_opted_out_capturing() || $cfd75c534a862da6$var$G(this.__request_queue, (t)=>this.Es(t)), this.__request_queue = [], this.Ms();
    }
    _handle_unload() {
        var t, i;
        this.config.request_batching ? (this.Fs() && this.capture("$pageleave"), null == (t = this.xs) || t.unload(), null == (i = this.Is) || i.unload()) : this.Fs() && this.capture("$pageleave", null, {
            transport: "sendBeacon"
        });
    }
    Ee(t) {
        this.__loaded && ($cfd75c534a862da6$var$sa ? this.__request_queue.push(t) : this.rateLimiter.isServerRateLimited(t.batchKey) || (t.transport = t.transport || this.config.api_transport, t.url = $cfd75c534a862da6$var$As(t.url, {
            ip: this.config.ip ? 1 : 0
        }), t.headers = $cfd75c534a862da6$var$B({}, this.config.request_headers), t.compression = "best-available" === t.compression ? this.compression : t.compression, t.fetchOptions = t.fetchOptions || this.config.fetch_options, ((t)=>{
            var i, e, r, s = $cfd75c534a862da6$var$B({}, t);
            s.timeout = s.timeout || 6e4, s.url = $cfd75c534a862da6$var$As(s.url, {
                _: (new Date).getTime().toString(),
                ver: $cfd75c534a862da6$var$c.LIB_VERSION,
                compression: s.compression
            });
            var n = null !== (i = s.transport) && void 0 !== i ? i : "fetch", o = null !== (e = null == (r = $cfd75c534a862da6$var$rt($cfd75c534a862da6$var$js, (t)=>t.transport === n)) ? void 0 : r.method) && void 0 !== e ? e : $cfd75c534a862da6$var$js[0].method;
            if (!o) throw new Error("No available transport method");
            o(s);
        })($cfd75c534a862da6$var$B({}, t, {
            callback: (i)=>{
                var e, r;
                (this.rateLimiter.checkForLimiting(i), i.statusCode >= 400) && (null == (e = (r = this.config).on_request_error) || e.call(r, i));
                null == t.callback || t.callback(i);
            }
        }))));
    }
    Es(t) {
        this.Is ? this.Is.retriableRequest(t) : this.Ee(t);
    }
    _execute_array(t) {
        var i, e = [], r = [], s = [];
        $cfd75c534a862da6$var$G(t, (t)=>{
            t && (i = t[0], $cfd75c534a862da6$var$x(i) ? s.push(t) : $cfd75c534a862da6$var$E(t) ? t.call(this) : $cfd75c534a862da6$var$x(t) && "alias" === i ? e.push(t) : $cfd75c534a862da6$var$x(t) && -1 !== i.indexOf("capture") && $cfd75c534a862da6$var$E(this[i]) ? s.push(t) : r.push(t));
        });
        var n = function(t, i) {
            $cfd75c534a862da6$var$G(t, function(t) {
                if ($cfd75c534a862da6$var$x(t[0])) {
                    var e = i;
                    $cfd75c534a862da6$var$J(t, function(t) {
                        e = e[t[0]].apply(e, t.slice(1));
                    });
                } else this[t[0]].apply(this, t.slice(1));
            }, i);
        };
        n(e, this), n(r, this), n(s, this);
    }
    Rs() {
        var t, i;
        return (null == (t = this.config.bootstrap) ? void 0 : t.featureFlags) && Object.keys(null == (i = this.config.bootstrap) ? void 0 : i.featureFlags).length > 0 || !1;
    }
    push(t) {
        this._execute_array([
            t
        ]);
    }
    capture(t, i, e) {
        var r;
        if (this.__loaded && this.persistence && this.sessionPersistence && this.xs) {
            if (!this.consent.isOptedOut()) {
                if (!$cfd75c534a862da6$var$R(t) && $cfd75c534a862da6$var$T(t)) {
                    if (this.config.opt_out_useragent_filter || !this._is_bot()) {
                        var s = null != e && e.skip_client_rate_limiting ? void 0 : this.rateLimiter.clientRateLimitContext();
                        if (null == s || !s.isRateLimited) {
                            null != i && i.$current_url && !$cfd75c534a862da6$var$T(null == i ? void 0 : i.$current_url) && ($cfd75c534a862da6$var$N.error("Invalid `$current_url` property provided to `posthog.capture`. Input must be a string. Ignoring provided value."), null == i || delete i.$current_url), this.sessionPersistence.update_search_keyword(), this.config.save_campaign_params && this.sessionPersistence.update_campaign_params(), this.config.save_referrer && this.sessionPersistence.update_referrer_info(), (this.config.save_campaign_params || this.config.save_referrer) && this.persistence.set_initial_person_info();
                            var n = new Date, o = (null == e ? void 0 : e.timestamp) || n, a = $cfd75c534a862da6$var$ji(), l = {
                                uuid: a,
                                event: t,
                                properties: this.calculateEventProperties(t, i || {}, o, a)
                            };
                            s && (l.properties.$lib_rate_limit_remaining_tokens = s.remainingTokens), (null == e ? void 0 : e.$set) && (l.$set = null == e ? void 0 : e.$set);
                            var u, h, d = this.Os(null == e ? void 0 : e.$set_once);
                            if (d && (l.$set_once = d), (l = $cfd75c534a862da6$var$tt(l, null != e && e._noTruncate ? null : this.config.properties_string_max_length)).timestamp = o, $cfd75c534a862da6$var$R(null == e ? void 0 : e.timestamp) || (l.properties.$event_time_override_provided = !0, l.properties.$event_time_override_system_time = n), t === $cfd75c534a862da6$export$9d7ec1793ca1658e.DISMISSED || t === $cfd75c534a862da6$export$9d7ec1793ca1658e.SENT) {
                                var v = null == i ? void 0 : i[$cfd75c534a862da6$export$fe4c9af525341543.SURVEY_ID], c = null == i ? void 0 : i[$cfd75c534a862da6$export$fe4c9af525341543.SURVEY_ITERATION];
                                localStorage.setItem((h = "" + $cfd75c534a862da6$var$bo + (u = {
                                    id: v,
                                    current_iteration: c
                                }).id, u.current_iteration && u.current_iteration > 0 && (h = "" + $cfd75c534a862da6$var$bo + u.id + "_" + u.current_iteration), h), "true"), l.$set = $cfd75c534a862da6$var$B({}, l.$set, {
                                    [$cfd75c534a862da6$var$yo({
                                        id: v,
                                        current_iteration: c
                                    }, t === $cfd75c534a862da6$export$9d7ec1793ca1658e.SENT ? "responded" : "dismissed")]: !0
                                });
                            }
                            var f = $cfd75c534a862da6$var$B({}, l.properties.$set, l.$set);
                            if ($cfd75c534a862da6$var$P(f) || this.setPersonPropertiesForFlags(f), !$cfd75c534a862da6$var$F(this.config.before_send)) {
                                var p = this.As(l);
                                if (!p) return;
                                l = p;
                            }
                            this._s.emit("eventCaptured", l);
                            var g = {
                                method: "POST",
                                url: null !== (r = null == e ? void 0 : e._url) && void 0 !== r ? r : this.requestRouter.endpointFor("api", this.analyticsDefaultEndpoint),
                                data: l,
                                compression: "best-available",
                                batchKey: null == e ? void 0 : e._batchKey
                            };
                            return !this.config.request_batching || e && (null == e || !e._batchKey) || null != e && e.send_instantly ? this.Es(g) : this.xs.enqueue(g), l;
                        }
                        $cfd75c534a862da6$var$N.critical("This capture call is ignored due to client rate limiting.");
                    }
                } else $cfd75c534a862da6$var$N.error("No event name provided to posthog.capture");
            }
        } else $cfd75c534a862da6$var$N.uninitializedWarning("posthog.capture");
    }
    Ge(t) {
        return this.on("eventCaptured", (i)=>t(i.event, i));
    }
    calculateEventProperties(t, i, e, r, s) {
        if (e = e || new Date, !this.persistence || !this.sessionPersistence) return i;
        var n = s ? void 0 : this.persistence.remove_event_timer(t), a = $cfd75c534a862da6$var$B({}, i);
        if (a.token = this.config.token, a.$config_defaults = this.config.defaults, this.config.__preview_experimental_cookieless_mode && (a.$cookieless_mode = !0), "$snapshot" === t) {
            var l = $cfd75c534a862da6$var$B({}, this.persistence.properties(), this.sessionPersistence.properties());
            return a.distinct_id = l.distinct_id, (!$cfd75c534a862da6$var$T(a.distinct_id) && !$cfd75c534a862da6$var$O(a.distinct_id) || $cfd75c534a862da6$var$M(a.distinct_id)) && $cfd75c534a862da6$var$N.error("Invalid distinct_id for replay event. This indicates a bug in your implementation"), a;
        }
        var u, h = $cfd75c534a862da6$var$io(this.config.mask_personal_data_properties, this.config.custom_personal_data_properties);
        if (this.sessionManager) {
            var { sessionId: v, windowId: c } = this.sessionManager.checkAndGetSessionAndWindowId(s, e.getTime());
            a.$session_id = v, a.$window_id = c;
        }
        this.sessionPropsManager && $cfd75c534a862da6$var$V(a, this.sessionPropsManager.getSessionProps());
        try {
            var f;
            this.sessionRecording && $cfd75c534a862da6$var$V(a, this.sessionRecording.sdkDebugProperties), a.$sdk_debug_retry_queue_size = null == (f = this.Is) ? void 0 : f.length;
        } catch (t) {
            a.$sdk_debug_error_capturing_properties = String(t);
        }
        if (this.requestRouter.region === $cfd75c534a862da6$var$Yo.CUSTOM && (a.$lib_custom_api_host = this.config.api_host), u = "$pageview" !== t || s ? "$pageleave" !== t || s ? this.pageViewManager.doEvent() : this.pageViewManager.doPageLeave(e) : this.pageViewManager.doPageView(e, r), a = $cfd75c534a862da6$var$V(a, u), "$pageview" === t && $cfd75c534a862da6$var$o && (a.title = $cfd75c534a862da6$var$o.title), !$cfd75c534a862da6$var$R(n)) {
            var p = e.getTime() - n;
            a.$duration = parseFloat((p / 1e3).toFixed(3));
        }
        $cfd75c534a862da6$var$d && this.config.opt_out_useragent_filter && (a.$browser_type = this._is_bot() ? "bot" : "browser"), (a = $cfd75c534a862da6$var$V({}, h, this.persistence.properties(), this.sessionPersistence.properties(), a)).$is_identified = this._isIdentified(), $cfd75c534a862da6$var$x(this.config.property_denylist) ? $cfd75c534a862da6$var$J(this.config.property_denylist, function(t) {
            delete a[t];
        }) : $cfd75c534a862da6$var$N.error("Invalid value for property_denylist config: " + this.config.property_denylist + " or property_blacklist config: " + this.config.property_blacklist);
        var g = this.config.sanitize_properties;
        g && ($cfd75c534a862da6$var$N.error("sanitize_properties is deprecated. Use before_send instead"), a = g(a, t));
        var _ = this.Ds();
        return a.$process_person_profile = _, _ && !s && this.Ls("_calculate_event_properties"), a;
    }
    Os(t) {
        var i;
        if (!this.persistence || !this.Ds()) return t;
        if (this.gs) return t;
        var e = this.persistence.get_initial_props(), r = null == (i = this.sessionPropsManager) ? void 0 : i.getSetOnceProps(), s = $cfd75c534a862da6$var$V({}, e, r || {}, t || {}), n = this.config.sanitize_properties;
        return n && ($cfd75c534a862da6$var$N.error("sanitize_properties is deprecated. Use before_send instead"), s = n(s, "$set_once")), this.gs = !0, $cfd75c534a862da6$var$P(s) ? void 0 : s;
    }
    register(t, i) {
        var e;
        null == (e = this.persistence) || e.register(t, i);
    }
    register_once(t, i, e) {
        var r;
        null == (r = this.persistence) || r.register_once(t, i, e);
    }
    register_for_session(t) {
        var i;
        null == (i = this.sessionPersistence) || i.register(t);
    }
    unregister(t) {
        var i;
        null == (i = this.persistence) || i.unregister(t);
    }
    unregister_for_session(t) {
        var i;
        null == (i = this.sessionPersistence) || i.unregister(t);
    }
    js(t, i) {
        this.register({
            [t]: i
        });
    }
    getFeatureFlag(t, i) {
        return this.featureFlags.getFeatureFlag(t, i);
    }
    getFeatureFlagPayload(t) {
        var i = this.featureFlags.getFeatureFlagPayload(t);
        try {
            return JSON.parse(i);
        } catch (t) {
            return i;
        }
    }
    isFeatureEnabled(t, i) {
        return this.featureFlags.isFeatureEnabled(t, i);
    }
    reloadFeatureFlags() {
        this.featureFlags.reloadFeatureFlags();
    }
    updateEarlyAccessFeatureEnrollment(t, i) {
        this.featureFlags.updateEarlyAccessFeatureEnrollment(t, i);
    }
    getEarlyAccessFeatures(t, i, e) {
        return void 0 === i && (i = !1), this.featureFlags.getEarlyAccessFeatures(t, i, e);
    }
    on(t, i) {
        return this._s.on(t, i);
    }
    onFeatureFlags(t) {
        return this.featureFlags.onFeatureFlags(t);
    }
    onSurveysLoaded(t) {
        return this.surveys.onSurveysLoaded(t);
    }
    onSessionId(t) {
        var i, e;
        return null !== (i = null == (e = this.sessionManager) ? void 0 : e.onSessionId(t)) && void 0 !== i ? i : ()=>{};
    }
    getSurveys(t, i) {
        void 0 === i && (i = !1), this.surveys.getSurveys(t, i);
    }
    getActiveMatchingSurveys(t, i) {
        void 0 === i && (i = !1), this.surveys.getActiveMatchingSurveys(t, i);
    }
    renderSurvey(t, i) {
        this.surveys.renderSurvey(t, i);
    }
    canRenderSurvey(t) {
        return this.surveys.canRenderSurvey(t);
    }
    canRenderSurveyAsync(t, i) {
        return void 0 === i && (i = !1), this.surveys.canRenderSurveyAsync(t, i);
    }
    identify(t, i, e) {
        if (!this.__loaded || !this.persistence) return $cfd75c534a862da6$var$N.uninitializedWarning("posthog.identify");
        if ($cfd75c534a862da6$var$O(t) && (t = t.toString(), $cfd75c534a862da6$var$N.warn("The first argument to posthog.identify was a number, but it should be a string. It has been converted to a string.")), t) {
            if ([
                "distinct_id",
                "distinctid"
            ].includes(t.toLowerCase())) $cfd75c534a862da6$var$N.critical('The string "' + t + '" was set in posthog.identify which indicates an error. This ID should be unique to the user and not a hardcoded string.');
            else if (t !== $cfd75c534a862da6$var$Bt) {
                if (this.Ls("posthog.identify")) {
                    var r = this.get_distinct_id();
                    if (this.register({
                        $user_id: t
                    }), !this.get_property("$device_id")) {
                        var s = r;
                        this.register_once({
                            $had_persisted_distinct_id: !0,
                            $device_id: s
                        }, "");
                    }
                    t !== r && t !== this.get_property($cfd75c534a862da6$var$ot) && (this.unregister($cfd75c534a862da6$var$ot), this.register({
                        distinct_id: t
                    }));
                    var n = "anonymous" === (this.persistence.get_property($cfd75c534a862da6$var$At) || "anonymous");
                    t !== r && n ? (this.persistence.set_property($cfd75c534a862da6$var$At, "identified"), this.setPersonPropertiesForFlags($cfd75c534a862da6$var$B({}, e || {}, i || {}), !1), this.capture("$identify", {
                        distinct_id: t,
                        $anon_distinct_id: r
                    }, {
                        $set: i || {},
                        $set_once: e || {}
                    }), this.Ss = $cfd75c534a862da6$var$zs(t, i, e), this.featureFlags.setAnonymousDistinctId(r)) : (i || e) && this.setPersonProperties(i, e), t !== r && (this.reloadFeatureFlags(), this.unregister($cfd75c534a862da6$var$Ot));
                }
            } else $cfd75c534a862da6$var$N.critical('The string "' + $cfd75c534a862da6$var$Bt + '" was set in posthog.identify which indicates an error. This ID is only used as a sentinel value.');
        } else $cfd75c534a862da6$var$N.error("Unique user id has not been set in posthog.identify");
    }
    setPersonProperties(t, i) {
        if ((t || i) && this.Ls("posthog.setPersonProperties")) {
            var e = $cfd75c534a862da6$var$zs(this.get_distinct_id(), t, i);
            this.Ss !== e ? (this.setPersonPropertiesForFlags($cfd75c534a862da6$var$B({}, i || {}, t || {})), this.capture("$set", {
                $set: t || {},
                $set_once: i || {}
            }), this.Ss = e) : $cfd75c534a862da6$var$N.info("A duplicate setPersonProperties call was made with the same properties. It has been ignored.");
        }
    }
    group(t, i, e) {
        if (t && i) {
            if (this.Ls("posthog.group")) {
                var r = this.getGroups();
                r[t] !== i && this.resetGroupPropertiesForFlags(t), this.register({
                    $groups: $cfd75c534a862da6$var$B({}, r, {
                        [t]: i
                    })
                }), e && (this.capture("$groupidentify", {
                    $group_type: t,
                    $group_key: i,
                    $group_set: e
                }), this.setGroupPropertiesForFlags({
                    [t]: e
                })), r[t] === i || e || this.reloadFeatureFlags();
            }
        } else $cfd75c534a862da6$var$N.error("posthog.group requires a group type and group key");
    }
    resetGroups() {
        this.register({
            $groups: {}
        }), this.resetGroupPropertiesForFlags(), this.reloadFeatureFlags();
    }
    setPersonPropertiesForFlags(t, i) {
        void 0 === i && (i = !0), this.featureFlags.setPersonPropertiesForFlags(t, i);
    }
    resetPersonPropertiesForFlags() {
        this.featureFlags.resetPersonPropertiesForFlags();
    }
    setGroupPropertiesForFlags(t, i) {
        void 0 === i && (i = !0), this.Ls("posthog.setGroupPropertiesForFlags") && this.featureFlags.setGroupPropertiesForFlags(t, i);
    }
    resetGroupPropertiesForFlags(t) {
        this.featureFlags.resetGroupPropertiesForFlags(t);
    }
    reset(t) {
        var i, e, r, s;
        if ($cfd75c534a862da6$var$N.info("reset"), !this.__loaded) return $cfd75c534a862da6$var$N.uninitializedWarning("posthog.reset");
        var n = this.get_property("$device_id");
        if (this.consent.reset(), null == (i = this.persistence) || i.clear(), null == (e = this.sessionPersistence) || e.clear(), this.surveys.reset(), null == (r = this.persistence) || r.set_property($cfd75c534a862da6$var$At, "anonymous"), null == (s = this.sessionManager) || s.resetSessionId(), this.Ss = null, this.config.__preview_experimental_cookieless_mode) this.register_once({
            distinct_id: $cfd75c534a862da6$var$Bt,
            $device_id: null
        }, "");
        else {
            var o = this.config.get_device_id($cfd75c534a862da6$var$ji());
            this.register_once({
                distinct_id: o,
                $device_id: t ? o : n
            }, "");
        }
        this.register({
            $last_posthog_reset: (new Date).toISOString()
        }, 1);
    }
    get_distinct_id() {
        return this.get_property("distinct_id");
    }
    getGroups() {
        return this.get_property("$groups") || {};
    }
    get_session_id() {
        var t, i;
        return null !== (t = null == (i = this.sessionManager) ? void 0 : i.checkAndGetSessionAndWindowId(!0).sessionId) && void 0 !== t ? t : "";
    }
    get_session_replay_url(t) {
        if (!this.sessionManager) return "";
        var { sessionId: i, sessionStartTimestamp: e } = this.sessionManager.checkAndGetSessionAndWindowId(!0), r = this.requestRouter.endpointFor("ui", "/project/" + this.config.token + "/replay/" + i);
        if (null != t && t.withTimestamp && e) {
            var s, n = null !== (s = t.timestampLookBack) && void 0 !== s ? s : 10;
            if (!e) return r;
            r += "?t=" + Math.max(Math.floor(((new Date).getTime() - e) / 1e3) - n, 0);
        }
        return r;
    }
    alias(t, i) {
        return t === this.get_property($cfd75c534a862da6$var$nt) ? ($cfd75c534a862da6$var$N.critical("Attempting to create alias for existing People user - aborting."), -2) : this.Ls("posthog.alias") ? ($cfd75c534a862da6$var$R(i) && (i = this.get_distinct_id()), t !== i ? (this.js($cfd75c534a862da6$var$ot, t), this.capture("$create_alias", {
            alias: t,
            distinct_id: i
        })) : ($cfd75c534a862da6$var$N.warn("alias matches current distinct_id - skipping api call."), this.identify(t), -1)) : void 0;
    }
    set_config(t) {
        var i, e, r, s, n = $cfd75c534a862da6$var$B({}, this.config);
        $cfd75c534a862da6$var$I(t) && ($cfd75c534a862da6$var$V(this.config, $cfd75c534a862da6$var$oa(t)), null == (i = this.persistence) || i.update_config(this.config, n), this.sessionPersistence = "sessionStorage" === this.config.persistence || "memory" === this.config.persistence ? this.persistence : new $cfd75c534a862da6$var$po($cfd75c534a862da6$var$B({}, this.config, {
            persistence: "sessionStorage"
        })), $cfd75c534a862da6$var$Wi.O() && "true" === $cfd75c534a862da6$var$Wi.D("ph_debug") && (this.config.debug = !0), this.config.debug && ($cfd75c534a862da6$var$c.DEBUG = !0, $cfd75c534a862da6$var$N.info("set_config", {
            config: t,
            oldConfig: n,
            newConfig: $cfd75c534a862da6$var$B({}, this.config)
        })), null == (e = this.sessionRecording) || e.startIfEnabledOrStop(), null == (r = this.autocapture) || r.startIfEnabled(), null == (s = this.heatmaps) || s.startIfEnabled(), this.surveys.loadIfEnabled(), this.Ps());
    }
    startSessionRecording(t) {
        var i = !0 === t, e = {
            sampling: i || !(null == t || !t.sampling),
            linked_flag: i || !(null == t || !t.linked_flag),
            url_trigger: i || !(null == t || !t.url_trigger),
            event_trigger: i || !(null == t || !t.event_trigger)
        };
        if (Object.values(e).some(Boolean)) {
            var r, s, n, o, a;
            if (null == (r = this.sessionManager) || r.checkAndGetSessionAndWindowId(), e.sampling) null == (s = this.sessionRecording) || s.overrideSampling();
            if (e.linked_flag) null == (n = this.sessionRecording) || n.overrideLinkedFlag();
            if (e.url_trigger) null == (o = this.sessionRecording) || o.overrideTrigger("url");
            if (e.event_trigger) null == (a = this.sessionRecording) || a.overrideTrigger("event");
        }
        this.set_config({
            disable_session_recording: !1
        });
    }
    stopSessionRecording() {
        this.set_config({
            disable_session_recording: !0
        });
    }
    sessionRecordingStarted() {
        var t;
        return !(null == (t = this.sessionRecording) || !t.started);
    }
    captureException(t, i) {
        var e = new Error("PostHog syntheticException");
        this.exceptions.sendExceptionEvent($cfd75c534a862da6$var$B({}, $cfd75c534a862da6$var$Le(((t)=>t instanceof Error)(t) ? {
            error: t,
            event: t.message
        } : {
            event: t
        }, {
            syntheticException: e
        }), i));
    }
    loadToolbar(t) {
        return this.toolbar.loadToolbar(t);
    }
    get_property(t) {
        var i;
        return null == (i = this.persistence) ? void 0 : i.props[t];
    }
    getSessionProperty(t) {
        var i;
        return null == (i = this.sessionPersistence) ? void 0 : i.props[t];
    }
    toString() {
        var t, i = null !== (t = this.config.name) && void 0 !== t ? t : $cfd75c534a862da6$var$ra;
        return i !== $cfd75c534a862da6$var$ra && (i = $cfd75c534a862da6$var$ra + "." + i), i;
    }
    _isIdentified() {
        var t, i;
        return "identified" === (null == (t = this.persistence) ? void 0 : t.get_property($cfd75c534a862da6$var$At)) || "identified" === (null == (i = this.sessionPersistence) ? void 0 : i.get_property($cfd75c534a862da6$var$At));
    }
    Ds() {
        var t, i;
        return !("never" === this.config.person_profiles || "identified_only" === this.config.person_profiles && !this._isIdentified() && $cfd75c534a862da6$var$P(this.getGroups()) && (null == (t = this.persistence) || null == (t = t.props) || !t[$cfd75c534a862da6$var$ot]) && (null == (i = this.persistence) || null == (i = i.props) || !i[$cfd75c534a862da6$var$Ut]));
    }
    Fs() {
        return !0 === this.config.capture_pageleave || "if_capture_pageview" === this.config.capture_pageleave && (!0 === this.config.capture_pageview || "history_change" === this.config.capture_pageview);
    }
    createPersonProfile() {
        this.Ds() || this.Ls("posthog.createPersonProfile") && this.setPersonProperties({}, {});
    }
    Ls(t) {
        return "never" === this.config.person_profiles ? ($cfd75c534a862da6$var$N.error(t + ' was called, but process_person is set to "never". This call will be ignored.'), !1) : (this.js($cfd75c534a862da6$var$Ut, !0), !0);
    }
    Ps() {
        var t, i, e, r, s = this.consent.isOptedOut(), n = this.config.opt_out_persistence_by_default, o = this.config.disable_persistence || s && !!n;
        (null == (t = this.persistence) ? void 0 : t.Fe) !== o && (null == (e = this.persistence) || e.set_disabled(o));
        (null == (i = this.sessionPersistence) ? void 0 : i.Fe) !== o && (null == (r = this.sessionPersistence) || r.set_disabled(o));
    }
    opt_in_capturing(t) {
        var i;
        (this.consent.optInOut(!0), this.Ps(), $cfd75c534a862da6$var$R(null == t ? void 0 : t.captureEventName) || null != t && t.captureEventName) && this.capture(null !== (i = null == t ? void 0 : t.captureEventName) && void 0 !== i ? i : "$opt_in", null == t ? void 0 : t.captureProperties, {
            send_instantly: !0
        });
        this.config.capture_pageview && this.Cs();
    }
    opt_out_capturing() {
        this.consent.optInOut(!1), this.Ps();
    }
    has_opted_in_capturing() {
        return this.consent.isOptedIn();
    }
    has_opted_out_capturing() {
        return this.consent.isOptedOut();
    }
    clear_opt_in_out_capturing() {
        this.consent.reset(), this.Ps();
    }
    _is_bot() {
        return $cfd75c534a862da6$var$n ? $cfd75c534a862da6$var$Ko($cfd75c534a862da6$var$n, this.config.custom_blocked_useragents) : void 0;
    }
    Cs() {
        $cfd75c534a862da6$var$o && ("visible" === $cfd75c534a862da6$var$o.visibilityState ? this.bs || (this.bs = !0, this.capture("$pageview", {
            title: $cfd75c534a862da6$var$o.title
        }, {
            send_instantly: !0
        }), this.ys && ($cfd75c534a862da6$var$o.removeEventListener("visibilitychange", this.ys), this.ys = null)) : this.ys || (this.ys = this.Cs.bind(this), $cfd75c534a862da6$var$st($cfd75c534a862da6$var$o, "visibilitychange", this.ys)));
    }
    debug(i) {
        !1 === i ? (null == $cfd75c534a862da6$var$t || $cfd75c534a862da6$var$t.console.log("You've disabled debug mode."), localStorage && localStorage.removeItem("ph_debug"), this.set_config({
            debug: !1
        })) : (null == $cfd75c534a862da6$var$t || $cfd75c534a862da6$var$t.console.log("You're now in debug mode. All calls to PostHog will be logged in your console.\nYou can disable this with `posthog.debug(false)`."), localStorage && localStorage.setItem("ph_debug", "true"), this.set_config({
            debug: !0
        }));
    }
    I() {
        var t, i, e, r, s, n, o, a = this.$s || {};
        return "advanced_disable_flags" in a ? !!a.advanced_disable_flags : !1 !== this.config.advanced_disable_flags ? !!this.config.advanced_disable_flags : !0 === this.config.advanced_disable_decide ? ($cfd75c534a862da6$var$N.warn("Config field 'advanced_disable_decide' is deprecated. Please use 'advanced_disable_flags' instead. The old field will be removed in a future major version."), !0) : (e = "advanced_disable_decide", r = !1, s = $cfd75c534a862da6$var$N, n = (i = "advanced_disable_flags") in (t = a) && !$cfd75c534a862da6$var$R(t[i]), o = e in t && !$cfd75c534a862da6$var$R(t[e]), n ? t[i] : o ? (s && s.warn("Config field '" + e + "' is deprecated. Please use '" + i + "' instead. The old field will be removed in a future major version."), t[e]) : r);
    }
    As(t) {
        if ($cfd75c534a862da6$var$F(this.config.before_send)) return t;
        var i = $cfd75c534a862da6$var$x(this.config.before_send) ? this.config.before_send : [
            this.config.before_send
        ], e = t;
        for (var r of i){
            if (e = r(e), $cfd75c534a862da6$var$F(e)) {
                var s = "Event '" + t.event + "' was rejected in beforeSend function";
                return $cfd75c534a862da6$var$L(t.event) ? $cfd75c534a862da6$var$N.warn(s + ". This can cause unexpected behavior.") : $cfd75c534a862da6$var$N.info(s), null;
            }
            e.properties && !$cfd75c534a862da6$var$P(e.properties) || $cfd75c534a862da6$var$N.warn("Event '" + t.event + "' has no properties after beforeSend function, this is likely an error.");
        }
        return e;
    }
    getPageViewId() {
        var t;
        return null == (t = this.pageViewManager.ce) ? void 0 : t.pageViewId;
    }
    captureTraceFeedback(t, i) {
        this.capture("$ai_feedback", {
            $ai_trace_id: String(t),
            $ai_feedback_text: i
        });
    }
    captureTraceMetric(t, i, e) {
        this.capture("$ai_metric", {
            $ai_trace_id: String(t),
            $ai_metric_name: i,
            $ai_metric_value: String(e)
        });
    }
}
!function(t, i) {
    for(var e = 0; e < i.length; e++)t.prototype[i[e]] = $cfd75c534a862da6$var$Q(t.prototype[i[e]]);
}($cfd75c534a862da6$export$a9d6b9cbf49b8241, [
    "identify"
]);
var $cfd75c534a862da6$var$ua, $cfd75c534a862da6$export$2e2bcd8739ae039 = ($cfd75c534a862da6$var$ua = $cfd75c534a862da6$var$ia[$cfd75c534a862da6$var$ra] = new $cfd75c534a862da6$export$a9d6b9cbf49b8241, function() {
    function i() {
        i.done || (i.done = !0, $cfd75c534a862da6$var$sa = !1, $cfd75c534a862da6$var$J($cfd75c534a862da6$var$ia, function(t) {
            t._dom_loaded();
        }));
    }
    null != $cfd75c534a862da6$var$o && $cfd75c534a862da6$var$o.addEventListener ? "complete" === $cfd75c534a862da6$var$o.readyState ? i() : $cfd75c534a862da6$var$st($cfd75c534a862da6$var$o, "DOMContentLoaded", i, {
        capture: !1
    }) : $cfd75c534a862da6$var$t && $cfd75c534a862da6$var$N.error("Browser doesn't support `document.addEventListener` so PostHog couldn't be initialized");
}(), $cfd75c534a862da6$var$ua);


window.Sentry = $5c1cc6e36f06e493$exports;
window.SentryIntegrations = (0, $3ecb36adbd376d3d$export$99d02219d259eb94);
(0, $cfd75c534a862da6$export$2e2bcd8739ae039).init("phc_1EAzdaH4YiBLDU8MMGqPk6BjaJF0gvoE3rZH5UQ4IkZ", {
    api_host: "https://eu.i.posthog.com",
    person_profiles: "always"
});
// Initializations
(0, $4c538bf77dcd4adb$export$2e2bcd8739ae039).ready(()=>{
    (0, $4c538bf77dcd4adb$export$2e2bcd8739ae039).mountOne("#app-map", (0, $0487332c780ecdcd$export$2e2bcd8739ae039).AppMap);
    (0, $4c538bf77dcd4adb$export$2e2bcd8739ae039).mountOne(".contrib-container", (0, $5d0ca6427666b040$export$2e2bcd8739ae039).ContribPagination);
    (0, $4c538bf77dcd4adb$export$2e2bcd8739ae039).mountOne(".contrib-container", (0, $5d0ca6427666b040$export$2e2bcd8739ae039).FormContribEditNotification);
    (0, $4c538bf77dcd4adb$export$2e2bcd8739ae039).mountOne("#contrib-edit-form", (0, $5d0ca6427666b040$export$2e2bcd8739ae039).FormContribDirtyChecker);
    (0, $4c538bf77dcd4adb$export$2e2bcd8739ae039).mountOne("#localisation-map", (0, $5d0ca6427666b040$export$2e2bcd8739ae039).LocalisationMap);
    (0, $4c538bf77dcd4adb$export$2e2bcd8739ae039).mountOne("#map-height-toggle-link", (0, $5d0ca6427666b040$export$2e2bcd8739ae039).MapExpander);
    (0, $4c538bf77dcd4adb$export$2e2bcd8739ae039).mountOne(".a4a-conditional-form", (0, $5d0ca6427666b040$export$2e2bcd8739ae039).ConditionalForm);
    (0, $4c538bf77dcd4adb$export$2e2bcd8739ae039).mountAll(".search-where-field", (0, $5d0ca6427666b040$export$2e2bcd8739ae039).SearchWhere);
    (0, $4c538bf77dcd4adb$export$2e2bcd8739ae039).mountAll(".asteriskField", (0, $5d0ca6427666b040$export$2e2bcd8739ae039).AsteriskField);
    (0, $4c538bf77dcd4adb$export$2e2bcd8739ae039).mountAll(".a4a-geo-link", (0, $5d0ca6427666b040$export$2e2bcd8739ae039).GeoLink);
    (0, $4c538bf77dcd4adb$export$2e2bcd8739ae039).mountAll(".get-geoloc-btn", (0, $5d0ca6427666b040$export$2e2bcd8739ae039).GetGeolocBtn);
    (0, $4c538bf77dcd4adb$export$2e2bcd8739ae039).mountOne("#export-results-btn", (0, $5d0ca6427666b040$export$2e2bcd8739ae039).ExportResultsBtn);
    (0, $4c538bf77dcd4adb$export$2e2bcd8739ae039).mountOne("#erp-address", (0, $5d0ca6427666b040$export$2e2bcd8739ae039).SyncInputsWithElement);
    (0, $4c538bf77dcd4adb$export$2e2bcd8739ae039).mountAll(".half-progress", (0, $5d0ca6427666b040$export$2e2bcd8739ae039).ProgressBar);
    (0, $4c538bf77dcd4adb$export$2e2bcd8739ae039).mountAll(".a4a-label-tag", (0, $5d0ca6427666b040$export$2e2bcd8739ae039).LabelTag);
    (0, $4c538bf77dcd4adb$export$2e2bcd8739ae039).mountAll(".a4a-clone-filter", (0, $62a17aedb317e76e$export$2e2bcd8739ae039).cloneFilter);
    (0, $4c538bf77dcd4adb$export$2e2bcd8739ae039).mountOne("#clone-filter-submit", (0, $62a17aedb317e76e$export$2e2bcd8739ae039).cloneFilterSubmit);
    (0, $4c538bf77dcd4adb$export$2e2bcd8739ae039).mountOne("#no_activity", (0, $5d0ca6427666b040$export$2e2bcd8739ae039).NewActivity);
    (0, $4c538bf77dcd4adb$export$2e2bcd8739ae039).mountOne("#unsure-and-submit", (0, $5d0ca6427666b040$export$2e2bcd8739ae039).PickAnswerAndSubmit);
    (0, $4c538bf77dcd4adb$export$2e2bcd8739ae039).mountOne("#filter-controller", (0, $5d0ca6427666b040$export$2e2bcd8739ae039).filterData);
    (0, $4c538bf77dcd4adb$export$2e2bcd8739ae039).mountAll(".text-expander", (0, $5d0ca6427666b040$export$2e2bcd8739ae039).TextExpander);
    (0, $4c538bf77dcd4adb$export$2e2bcd8739ae039).mountAll(".parent-toggle", (0, $5d0ca6427666b040$export$2e2bcd8739ae039).ContentToggle);
});
(0, $5d0ca6427666b040$export$2e2bcd8739ae039).StoreFilters();
// expose general namespaced lib for usage within pages
window.a4a = {
    dom: $4c538bf77dcd4adb$export$2e2bcd8739ae039,
    geo: $0487332c780ecdcd$export$2e2bcd8739ae039
};
window.onload = function() {
    var src = document.getElementById("id_email"), dst = document.getElementById("id_username");
    if (src && dst) src.addEventListener("input", function() {
        dst.value = src.value.split("@")[0];
    });
    (0, $5d0ca6427666b040$export$2e2bcd8739ae039).listenToLabelEvents();
    (0, $5d0ca6427666b040$export$2e2bcd8739ae039).LoadFilters();
};

})();
//# sourceMappingURL=index.js.map
